var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target2 = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target2[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target2[prop] = source[prop];
    }
  return target2;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve2, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x2) => x2.done ? resolve2(x2.value) : Promise.resolve(x2.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function _mergeNamespaces(n2, m) {
  for (var i2 = 0; i2 < m.length; i2++) {
    const e = m[i2];
    if (typeof e !== "string" && !Array.isArray(e)) {
      for (const k in e) {
        if (k !== "default" && !(k in n2)) {
          const d2 = Object.getOwnPropertyDescriptor(e, k);
          if (d2) {
            Object.defineProperty(n2, k, d2.get ? d2 : {
              enumerable: true,
              get: () => e[k]
            });
          }
        }
      }
    }
  }
  return Object.freeze(Object.defineProperty(n2, Symbol.toStringTag, { value: "Module" }));
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var f = n2.default;
  if (typeof f == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else
    a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k);
    Object.defineProperty(a, k, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k];
      }
    });
  });
  return a;
}
var axios$3 = { exports: {} };
var bind$5 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i2 = 0; i2 < args.length; i2++) {
      args[i2] = arguments[i2];
    }
    return fn.apply(thisArg, args);
  };
};
var bind$4 = bind$5;
var toString$5 = Object.prototype.toString;
function isArray$f(val) {
  return toString$5.call(val) === "[object Array]";
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer$5(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString$5.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return typeof FormData !== "undefined" && val instanceof FormData;
}
function isArrayBufferView(val) {
  var result2;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result2 = ArrayBuffer.isView(val);
  } else {
    result2 = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result2;
}
function isString$1(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject$f(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject$a(val) {
  if (toString$5.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate(val) {
  return toString$5.call(val) === "[object Date]";
}
function isFile(val) {
  return toString$5.call(val) === "[object File]";
}
function isBlob(val) {
  return toString$5.call(val) === "[object Blob]";
}
function isFunction$6(val) {
  return toString$5.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject$f(val) && isFunction$6(val.pipe);
}
function isURLSearchParams(val) {
  return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray$f(obj)) {
    for (var i2 = 0, l = obj.length; i2 < l; i2++) {
      fn.call(null, obj[i2], i2, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge$5() {
  var result2 = {};
  function assignValue2(val, key) {
    if (isPlainObject$a(result2[key]) && isPlainObject$a(val)) {
      result2[key] = merge$5(result2[key], val);
    } else if (isPlainObject$a(val)) {
      result2[key] = merge$5({}, val);
    } else if (isArray$f(val)) {
      result2[key] = val.slice();
    } else {
      result2[key] = val;
    }
  }
  for (var i2 = 0, l = arguments.length; i2 < l; i2++) {
    forEach(arguments[i2], assignValue2);
  }
  return result2;
}
function extend$4(a, b, thisArg) {
  forEach(b, function assignValue2(val, key) {
    if (thisArg && typeof val === "function") {
      a[key] = bind$4(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$9 = {
  isArray: isArray$f,
  isArrayBuffer,
  isBuffer: isBuffer$5,
  isFormData,
  isArrayBufferView,
  isString: isString$1,
  isNumber,
  isObject: isObject$f,
  isPlainObject: isPlainObject$a,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isFunction: isFunction$6,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge: merge$5,
  extend: extend$4,
  trim,
  stripBOM
};
var utils$8 = utils$9;
function encode$1(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$1 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$8.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$8.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$8.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$8.forEach(val, function parseValue2(v) {
        if (utils$8.isDate(v)) {
          v = v.toISOString();
        } else if (utils$8.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode$1(key) + "=" + encode$1(v));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$7 = utils$9;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn) {
  utils$7.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$6 = utils$9;
var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$6.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
var enhanceError$1 = function enhanceError(error2, config2, code, request2, response) {
  error2.config = config2;
  if (code) {
    error2.code = code;
  }
  error2.request = request2;
  error2.response = response;
  error2.isAxiosError = true;
  error2.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error2;
};
var createError;
var hasRequiredCreateError;
function requireCreateError() {
  if (hasRequiredCreateError)
    return createError;
  hasRequiredCreateError = 1;
  var enhanceError3 = enhanceError$1;
  createError = function createError2(message, config2, code, request2, response) {
    var error2 = new Error(message);
    return enhanceError3(error2, config2, code, request2, response);
  };
  return createError;
}
var settle;
var hasRequiredSettle;
function requireSettle() {
  if (hasRequiredSettle)
    return settle;
  hasRequiredSettle = 1;
  var createError2 = requireCreateError();
  settle = function settle2(resolve2, reject, response) {
    var validateStatus2 = response.config.validateStatus;
    if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
      resolve2(response);
    } else {
      reject(createError2(
        "Request failed with status code " + response.status,
        response.config,
        null,
        response.request,
        response
      ));
    }
  };
  return settle;
}
var cookies;
var hasRequiredCookies;
function requireCookies() {
  if (hasRequiredCookies)
    return cookies;
  hasRequiredCookies = 1;
  var utils2 = utils$9;
  cookies = utils2.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain2, secure) {
          var cookie = [];
          cookie.push(name + "=" + encodeURIComponent(value));
          if (utils2.isNumber(expires)) {
            cookie.push("expires=" + new Date(expires).toGMTString());
          }
          if (utils2.isString(path)) {
            cookie.push("path=" + path);
          }
          if (utils2.isString(domain2)) {
            cookie.push("domain=" + domain2);
          }
          if (secure === true) {
            cookie.push("secure");
          }
          document.cookie = cookie.join("; ");
        },
        read: function read(name) {
          var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
          return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove2(name) {
          this.write(name, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function nonStandardBrowserEnv() {
      return {
        write: function write() {
        },
        read: function read() {
          return null;
        },
        remove: function remove2() {
        }
      };
    }()
  );
  return cookies;
}
var isAbsoluteURL;
var hasRequiredIsAbsoluteURL;
function requireIsAbsoluteURL() {
  if (hasRequiredIsAbsoluteURL)
    return isAbsoluteURL;
  hasRequiredIsAbsoluteURL = 1;
  isAbsoluteURL = function isAbsoluteURL2(url) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
  };
  return isAbsoluteURL;
}
var combineURLs;
var hasRequiredCombineURLs;
function requireCombineURLs() {
  if (hasRequiredCombineURLs)
    return combineURLs;
  hasRequiredCombineURLs = 1;
  combineURLs = function combineURLs2(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
  };
  return combineURLs;
}
var buildFullPath;
var hasRequiredBuildFullPath;
function requireBuildFullPath() {
  if (hasRequiredBuildFullPath)
    return buildFullPath;
  hasRequiredBuildFullPath = 1;
  var isAbsoluteURL2 = requireIsAbsoluteURL();
  var combineURLs2 = requireCombineURLs();
  buildFullPath = function buildFullPath2(baseURL, requestedURL) {
    if (baseURL && !isAbsoluteURL2(requestedURL)) {
      return combineURLs2(baseURL, requestedURL);
    }
    return requestedURL;
  };
  return buildFullPath;
}
var parseHeaders;
var hasRequiredParseHeaders;
function requireParseHeaders() {
  if (hasRequiredParseHeaders)
    return parseHeaders;
  hasRequiredParseHeaders = 1;
  var utils2 = utils$9;
  var ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  parseHeaders = function parseHeaders2(headers) {
    var parsed = {};
    var key;
    var val;
    var i2;
    if (!headers) {
      return parsed;
    }
    utils2.forEach(headers.split("\n"), function parser2(line) {
      i2 = line.indexOf(":");
      key = utils2.trim(line.substr(0, i2)).toLowerCase();
      val = utils2.trim(line.substr(i2 + 1));
      if (key) {
        if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
          return;
        }
        if (key === "set-cookie") {
          parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
        } else {
          parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
      }
    });
    return parsed;
  };
  return parseHeaders;
}
var isURLSameOrigin;
var hasRequiredIsURLSameOrigin;
function requireIsURLSameOrigin() {
  if (hasRequiredIsURLSameOrigin)
    return isURLSameOrigin;
  hasRequiredIsURLSameOrigin = 1;
  var utils2 = utils$9;
  isURLSameOrigin = utils2.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement("a");
      var originURL;
      function resolveURL(url) {
        var href = url;
        if (msie) {
          urlParsingNode.setAttribute("href", href);
          href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
      }
      originURL = resolveURL(window.location.href);
      return function isURLSameOrigin2(requestURL) {
        var parsed = utils2.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function nonStandardBrowserEnv() {
      return function isURLSameOrigin2() {
        return true;
      };
    }()
  );
  return isURLSameOrigin;
}
var xhr;
var hasRequiredXhr;
function requireXhr() {
  if (hasRequiredXhr)
    return xhr;
  hasRequiredXhr = 1;
  var utils2 = utils$9;
  var settle2 = requireSettle();
  var cookies2 = requireCookies();
  var buildURL3 = buildURL$1;
  var buildFullPath2 = requireBuildFullPath();
  var parseHeaders2 = requireParseHeaders();
  var isURLSameOrigin2 = requireIsURLSameOrigin();
  var createError2 = requireCreateError();
  xhr = function xhrAdapter(config2) {
    return new Promise(function dispatchXhrRequest(resolve2, reject) {
      var requestData = config2.data;
      var requestHeaders = config2.headers;
      var responseType = config2.responseType;
      if (utils2.isFormData(requestData)) {
        delete requestHeaders["Content-Type"];
      }
      var request2 = new XMLHttpRequest();
      if (config2.auth) {
        var username = config2.auth.username || "";
        var password = config2.auth.password ? unescape(encodeURIComponent(config2.auth.password)) : "";
        requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
      }
      var fullPath = buildFullPath2(config2.baseURL, config2.url);
      request2.open(config2.method.toUpperCase(), buildURL3(fullPath, config2.params, config2.paramsSerializer), true);
      request2.timeout = config2.timeout;
      function onloadend() {
        if (!request2) {
          return;
        }
        var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null;
        var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
        var response = {
          data: responseData,
          status: request2.status,
          statusText: request2.statusText,
          headers: responseHeaders,
          config: config2,
          request: request2
        };
        settle2(resolve2, reject, response);
        request2 = null;
      }
      if ("onloadend" in request2) {
        request2.onloadend = onloadend;
      } else {
        request2.onreadystatechange = function handleLoad() {
          if (!request2 || request2.readyState !== 4) {
            return;
          }
          if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) {
            return;
          }
          setTimeout(onloadend);
        };
      }
      request2.onabort = function handleAbort() {
        if (!request2) {
          return;
        }
        reject(createError2("Request aborted", config2, "ECONNABORTED", request2));
        request2 = null;
      };
      request2.onerror = function handleError2() {
        reject(createError2("Network Error", config2, null, request2));
        request2 = null;
      };
      request2.ontimeout = function handleTimeout() {
        var timeoutErrorMessage = "timeout of " + config2.timeout + "ms exceeded";
        if (config2.timeoutErrorMessage) {
          timeoutErrorMessage = config2.timeoutErrorMessage;
        }
        reject(createError2(
          timeoutErrorMessage,
          config2,
          config2.transitional && config2.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          request2
        ));
        request2 = null;
      };
      if (utils2.isStandardBrowserEnv()) {
        var xsrfValue = (config2.withCredentials || isURLSameOrigin2(fullPath)) && config2.xsrfCookieName ? cookies2.read(config2.xsrfCookieName) : void 0;
        if (xsrfValue) {
          requestHeaders[config2.xsrfHeaderName] = xsrfValue;
        }
      }
      if ("setRequestHeader" in request2) {
        utils2.forEach(requestHeaders, function setRequestHeader(val, key) {
          if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
            delete requestHeaders[key];
          } else {
            request2.setRequestHeader(key, val);
          }
        });
      }
      if (!utils2.isUndefined(config2.withCredentials)) {
        request2.withCredentials = !!config2.withCredentials;
      }
      if (responseType && responseType !== "json") {
        request2.responseType = config2.responseType;
      }
      if (typeof config2.onDownloadProgress === "function") {
        request2.addEventListener("progress", config2.onDownloadProgress);
      }
      if (typeof config2.onUploadProgress === "function" && request2.upload) {
        request2.upload.addEventListener("progress", config2.onUploadProgress);
      }
      if (config2.cancelToken) {
        config2.cancelToken.promise.then(function onCanceled(cancel) {
          if (!request2) {
            return;
          }
          request2.abort();
          reject(cancel);
          request2 = null;
        });
      }
      if (!requestData) {
        requestData = null;
      }
      request2.send(requestData);
    });
  };
  return xhr;
}
var utils$5 = utils$9;
var normalizeHeaderName2 = normalizeHeaderName$1;
var enhanceError2 = enhanceError$1;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = requireXhr();
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = requireXhr();
  }
  return adapter;
}
function stringifySafely(rawValue, parser2, encoder) {
  if (utils$5.isString(rawValue)) {
    try {
      (parser2 || JSON.parse)(rawValue);
      return utils$5.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$a = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName2(headers, "Accept");
    normalizeHeaderName2(headers, "Content-Type");
    if (utils$5.isFormData(data) || utils$5.isArrayBuffer(data) || utils$5.isBuffer(data) || utils$5.isStream(data) || utils$5.isFile(data) || utils$5.isBlob(data)) {
      return data;
    }
    if (utils$5.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$5.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data.toString();
    }
    if (utils$5.isObject(data) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    var transitional2 = this.transitional;
    var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
    var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data) && data.length) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw enhanceError2(e, this, "E_JSON_PARSE");
          }
          throw e;
        }
      }
    }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
defaults$a.headers = {
  common: {
    "Accept": "application/json, text/plain, */*"
  }
};
utils$5.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$a.headers[method] = {};
});
utils$5.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$a.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$a;
var utils$4 = utils$9;
var defaults$9 = defaults_1;
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$9;
  utils$4.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });
  return data;
};
var isCancel$1;
var hasRequiredIsCancel;
function requireIsCancel() {
  if (hasRequiredIsCancel)
    return isCancel$1;
  hasRequiredIsCancel = 1;
  isCancel$1 = function isCancel2(value) {
    return !!(value && value.__CANCEL__);
  };
  return isCancel$1;
}
var utils$3 = utils$9;
var transformData2 = transformData$1;
var isCancel = requireIsCancel();
var defaults$8 = defaults_1;
function throwIfCancellationRequested(config2) {
  if (config2.cancelToken) {
    config2.cancelToken.throwIfRequested();
  }
}
var dispatchRequest$1 = function dispatchRequest(config2) {
  throwIfCancellationRequested(config2);
  config2.headers = config2.headers || {};
  config2.data = transformData2.call(
    config2,
    config2.data,
    config2.headers,
    config2.transformRequest
  );
  config2.headers = utils$3.merge(
    config2.headers.common || {},
    config2.headers[config2.method] || {},
    config2.headers
  );
  utils$3.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function cleanHeaderConfig(method) {
      delete config2.headers[method];
    }
  );
  var adapter = config2.adapter || defaults$8.adapter;
  return adapter(config2).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config2);
    response.data = transformData2.call(
      config2,
      response.data,
      response.headers,
      config2.transformResponse
    );
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config2);
      if (reason && reason.response) {
        reason.response.data = transformData2.call(
          config2,
          reason.response.data,
          reason.response.headers,
          config2.transformResponse
        );
      }
    }
    return Promise.reject(reason);
  });
};
var utils$2 = utils$9;
var mergeConfig$2 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config3 = {};
  var valueFromConfig2Keys = ["url", "method", "data"];
  var mergeDeepPropertiesKeys = ["headers", "auth", "proxy", "params"];
  var defaultToConfig2Keys = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ];
  var directMergeKeys = ["validateStatus"];
  function getMergedValue(target2, source) {
    if (utils$2.isPlainObject(target2) && utils$2.isPlainObject(source)) {
      return utils$2.merge(target2, source);
    } else if (utils$2.isPlainObject(source)) {
      return utils$2.merge({}, source);
    } else if (utils$2.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config3[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config3[prop] = getMergedValue(void 0, config1[prop]);
    }
  }
  utils$2.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config3[prop] = getMergedValue(void 0, config2[prop]);
    }
  });
  utils$2.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
  utils$2.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config3[prop] = getMergedValue(void 0, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config3[prop] = getMergedValue(void 0, config1[prop]);
    }
  });
  utils$2.forEach(directMergeKeys, function merge2(prop) {
    if (prop in config2) {
      config3[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config3[prop] = getMergedValue(void 0, config1[prop]);
    }
  });
  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });
  utils$2.forEach(otherKeys, mergeDeepProperties);
  return config3;
};
const name$1 = "axios";
const version$1 = "0.21.4";
const description = "Promise based HTTP client for the browser and node.js";
const main = "index.js";
const scripts = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
};
const repository = {
  type: "git",
  url: "https://github.com/axios/axios.git"
};
const keywords = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
];
const author = "Matt Zabriskie";
const license = "MIT";
const bugs = {
  url: "https://github.com/axios/axios/issues"
};
const homepage = "https://axios-http.com";
const devDependencies = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
};
const browser = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
const jsdelivr = "dist/axios.min.js";
const unpkg = "dist/axios.min.js";
const typings = "./index.d.ts";
const dependencies = {
  "follow-redirects": "^1.14.0"
};
const bundlesize = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
];
const require$$0$2 = {
  name: name$1,
  version: version$1,
  description,
  main,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  browser,
  jsdelivr,
  unpkg,
  typings,
  dependencies,
  bundlesize
};
var pkg = require$$0$2;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i2) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};
var currentVerArr = pkg.version.split(".");
function isOlderVersion(version2, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split(".") : currentVerArr;
  var destVer = version2.split(".");
  for (var i2 = 0; i2 < 3; i2++) {
    if (pkgVersionArr[i2] > destVer[i2]) {
      return true;
    } else if (pkgVersionArr[i2] < destVer[i2]) {
      return false;
    }
  }
  return false;
}
validators$1.transitional = function transitional(validator2, version2, message) {
  var isDeprecated = version2 && isOlderVersion(version2);
  function formatMessage(opt, desc) {
    return "[Axios v" + pkg.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed in " + version2));
    }
    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version2 + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys2 = Object.keys(options);
  var i2 = keys2.length;
  while (i2-- > 0) {
    var opt = keys2[i2];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result2 = value === void 0 || validator2(value, opt, options);
      if (result2 !== true) {
        throw new TypeError("option " + opt + " must be " + result2);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  isOlderVersion,
  assertOptions,
  validators: validators$1
};
var utils$1 = utils$9;
var buildURL2 = buildURL$1;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest2 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request(config2) {
  if (typeof config2 === "string") {
    config2 = arguments[1] || {};
    config2.url = arguments[0];
  } else {
    config2 = config2 || {};
  }
  config2 = mergeConfig$1(this.defaults, config2);
  if (config2.method) {
    config2.method = config2.method.toLowerCase();
  } else if (this.defaults.method) {
    config2.method = this.defaults.method.toLowerCase();
  } else {
    config2.method = "get";
  }
  var transitional2 = config2.transitional;
  if (transitional2 !== void 0) {
    validator.assertOptions(transitional2, {
      silentJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
      forcedJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
      clarifyTimeoutError: validators.transitional(validators.boolean, "1.0.0")
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config2) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config2);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config2;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error2) {
      onRejected(error2);
      break;
    }
  }
  try {
    promise = dispatchRequest2(newConfig);
  } catch (error2) {
    return Promise.reject(error2);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config2) {
  config2 = mergeConfig$1(this.defaults, config2);
  return buildURL2(config2.url, config2.params, config2.paramsSerializer).replace(/^\?/, "");
};
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function(url, config2) {
    return this.request(mergeConfig$1(config2 || {}, {
      method,
      url,
      data: (config2 || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  Axios$1.prototype[method] = function(url, data, config2) {
    return this.request(mergeConfig$1(config2 || {}, {
      method,
      url,
      data
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel_1;
var hasRequiredCancel;
function requireCancel() {
  if (hasRequiredCancel)
    return Cancel_1;
  hasRequiredCancel = 1;
  function Cancel(message) {
    this.message = message;
  }
  Cancel.prototype.toString = function toString2() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  };
  Cancel.prototype.__CANCEL__ = true;
  Cancel_1 = Cancel;
  return Cancel_1;
}
var CancelToken_1;
var hasRequiredCancelToken;
function requireCancelToken() {
  if (hasRequiredCancelToken)
    return CancelToken_1;
  hasRequiredCancelToken = 1;
  var Cancel = requireCancel();
  function CancelToken(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve2) {
      resolvePromise = resolve2;
    });
    var token = this;
    executor(function cancel(message) {
      if (token.reason) {
        return;
      }
      token.reason = new Cancel(message);
      resolvePromise(token.reason);
    });
  }
  CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  };
  CancelToken.source = function source() {
    var cancel;
    var token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  };
  CancelToken_1 = CancelToken;
  return CancelToken_1;
}
var spread;
var hasRequiredSpread;
function requireSpread() {
  if (hasRequiredSpread)
    return spread;
  hasRequiredSpread = 1;
  spread = function spread2(callback) {
    return function wrap(arr) {
      return callback.apply(null, arr);
    };
  };
  return spread;
}
var isAxiosError;
var hasRequiredIsAxiosError;
function requireIsAxiosError() {
  if (hasRequiredIsAxiosError)
    return isAxiosError;
  hasRequiredIsAxiosError = 1;
  isAxiosError = function isAxiosError2(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
  };
  return isAxiosError;
}
var utils = utils$9;
var bind$3 = bind$5;
var Axios = Axios_1;
var mergeConfig2 = mergeConfig$2;
var defaults$7 = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind$3(Axios.prototype.request, context);
  utils.extend(instance, Axios.prototype, context);
  utils.extend(instance, context);
  return instance;
}
var axios$2 = createInstance(defaults$7);
axios$2.Axios = Axios;
axios$2.create = function create(instanceConfig) {
  return createInstance(mergeConfig2(axios$2.defaults, instanceConfig));
};
axios$2.Cancel = requireCancel();
axios$2.CancelToken = requireCancelToken();
axios$2.isCancel = requireIsCancel();
axios$2.all = function all(promises) {
  return Promise.all(promises);
};
axios$2.spread = requireSpread();
axios$2.isAxiosError = requireIsAxiosError();
axios$3.exports = axios$2;
axios$3.exports.default = axios$2;
var axiosExports = axios$3.exports;
var axios = axiosExports;
const axios$1 = /* @__PURE__ */ getDefaultExportFromCjs(axios);
/*!
 * Vue.js v2.6.14
 * (c) 2014-2021 Evan You
 * Released under the MIT License.
 */
var emptyObject = Object.freeze({});
function isUndef(v) {
  return v === void 0 || v === null;
}
function isDef(v) {
  return v !== void 0 && v !== null;
}
function isTrue(v) {
  return v === true;
}
function isFalse(v) {
  return v === false;
}
function isPrimitive(value) {
  return typeof value === "string" || typeof value === "number" || // $flow-disable-line
  typeof value === "symbol" || typeof value === "boolean";
}
function isObject$e(obj) {
  return obj !== null && typeof obj === "object";
}
var _toString = Object.prototype.toString;
function toRawType(value) {
  return _toString.call(value).slice(8, -1);
}
function isPlainObject$9(obj) {
  return _toString.call(obj) === "[object Object]";
}
function isRegExp(v) {
  return _toString.call(v) === "[object RegExp]";
}
function isValidArrayIndex$1(val) {
  var n2 = parseFloat(String(val));
  return n2 >= 0 && Math.floor(n2) === n2 && isFinite(val);
}
function isPromise$1(val) {
  return isDef(val) && typeof val.then === "function" && typeof val.catch === "function";
}
function toString$4(val) {
  return val == null ? "" : Array.isArray(val) || isPlainObject$9(val) && val.toString === _toString ? JSON.stringify(val, null, 2) : String(val);
}
function toNumber$2(val) {
  var n2 = parseFloat(val);
  return isNaN(n2) ? val : n2;
}
function makeMap(str, expectsLowerCase) {
  var map = /* @__PURE__ */ Object.create(null);
  var list2 = str.split(",");
  for (var i2 = 0; i2 < list2.length; i2++) {
    map[list2[i2]] = true;
  }
  return expectsLowerCase ? function(val) {
    return map[val.toLowerCase()];
  } : function(val) {
    return map[val];
  };
}
makeMap("slot,component", true);
var isReservedAttribute = makeMap("key,ref,slot,slot-scope,is");
function remove$1(arr, item) {
  if (arr.length) {
    var index2 = arr.indexOf(item);
    if (index2 > -1) {
      return arr.splice(index2, 1);
    }
  }
}
var hasOwnProperty$f = Object.prototype.hasOwnProperty;
function hasOwn$2(obj, key) {
  return hasOwnProperty$f.call(obj, key);
}
function cached(fn) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}
var camelizeRE = /-(\w)/g;
var camelize = cached(function(str) {
  return str.replace(camelizeRE, function(_, c) {
    return c ? c.toUpperCase() : "";
  });
});
var capitalize$1 = cached(function(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
});
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function(str) {
  return str.replace(hyphenateRE, "-$1").toLowerCase();
});
function polyfillBind(fn, ctx) {
  function boundFn(a) {
    var l = arguments.length;
    return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
  }
  boundFn._length = fn.length;
  return boundFn;
}
function nativeBind(fn, ctx) {
  return fn.bind(ctx);
}
var bind$2 = Function.prototype.bind ? nativeBind : polyfillBind;
function toArray(list2, start) {
  start = start || 0;
  var i2 = list2.length - start;
  var ret = new Array(i2);
  while (i2--) {
    ret[i2] = list2[i2 + start];
  }
  return ret;
}
function extend$3(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
}
function toObject(arr) {
  var res = {};
  for (var i2 = 0; i2 < arr.length; i2++) {
    if (arr[i2]) {
      extend$3(res, arr[i2]);
    }
  }
  return res;
}
function noop$3(a, b, c) {
}
var no = function(a, b, c) {
  return false;
};
var identity$4 = function(_) {
  return _;
};
function looseEqual$1(a, b) {
  if (a === b) {
    return true;
  }
  var isObjectA = isObject$e(a);
  var isObjectB = isObject$e(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function(e, i2) {
          return looseEqual$1(e, b[i2]);
        });
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function(key) {
          return looseEqual$1(a[key], b[key]);
        });
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
}
function looseIndexOf(arr, val) {
  for (var i2 = 0; i2 < arr.length; i2++) {
    if (looseEqual$1(arr[i2], val)) {
      return i2;
    }
  }
  return -1;
}
function once(fn) {
  var called = false;
  return function() {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  };
}
var SSR_ATTR = "data-server-rendered";
var ASSET_TYPES = [
  "component",
  "directive",
  "filter"
];
var LIFECYCLE_HOOKS = [
  "beforeCreate",
  "created",
  "beforeMount",
  "mounted",
  "beforeUpdate",
  "updated",
  "beforeDestroy",
  "destroyed",
  "activated",
  "deactivated",
  "errorCaptured",
  "serverPrefetch"
];
var config$1 = {
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: /* @__PURE__ */ Object.create(null),
  /**
   * Whether to suppress warnings.
   */
  silent: false,
  /**
   * Show production mode tip message on boot?
   */
  productionTip: false,
  /**
   * Whether to enable devtools
   */
  devtools: false,
  /**
   * Whether to record perf
   */
  performance: false,
  /**
   * Error handler for watcher errors
   */
  errorHandler: null,
  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,
  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],
  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: /* @__PURE__ */ Object.create(null),
  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,
  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,
  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,
  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop$3,
  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity$4,
  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,
  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,
  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
};
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
function isReserved(str) {
  var c = (str + "").charCodeAt(0);
  return c === 36 || c === 95;
}
function def$1(obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}
var bailRE = new RegExp("[^" + unicodeRegExp.source + ".$_\\d]");
function parsePath(path) {
  if (bailRE.test(path)) {
    return;
  }
  var segments = path.split(".");
  return function(obj) {
    for (var i2 = 0; i2 < segments.length; i2++) {
      if (!obj) {
        return;
      }
      obj = obj[segments[i2]];
    }
    return obj;
  };
}
var hasProto = "__proto__" in {};
var inBrowser = typeof window !== "undefined";
var inWeex = typeof WXEnvironment !== "undefined" && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE$1 = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf("msie 9.0") > 0;
var isEdge = UA && UA.indexOf("edge/") > 0;
UA && UA.indexOf("android") > 0 || weexPlatform === "android";
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA) || weexPlatform === "ios";
var isFF = UA && UA.match(/firefox\/(\d+)/);
var nativeWatch = {}.watch;
var supportsPassive$1 = false;
if (inBrowser) {
  try {
    var opts$1 = {};
    Object.defineProperty(opts$1, "passive", {
      get: function get5() {
        supportsPassive$1 = true;
      }
    });
    window.addEventListener("test-passive", null, opts$1);
  } catch (e) {
  }
}
var _isServer;
var isServerRendering = function() {
  if (_isServer === void 0) {
    if (!inBrowser && !inWeex && typeof global !== "undefined") {
      _isServer = global["process"] && global["process"].env.VUE_ENV === "server";
    } else {
      _isServer = false;
    }
  }
  return _isServer;
};
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
function isNative$1(Ctor) {
  return typeof Ctor === "function" && /native code/.test(Ctor.toString());
}
var hasSymbol$1 = typeof Symbol !== "undefined" && isNative$1(Symbol) && typeof Reflect !== "undefined" && isNative$1(Reflect.ownKeys);
var _Set$1;
if (typeof Set !== "undefined" && isNative$1(Set)) {
  _Set$1 = Set;
} else {
  _Set$1 = /* @__PURE__ */ function() {
    function Set2() {
      this.set = /* @__PURE__ */ Object.create(null);
    }
    Set2.prototype.has = function has2(key) {
      return this.set[key] === true;
    };
    Set2.prototype.add = function add2(key) {
      this.set[key] = true;
    };
    Set2.prototype.clear = function clear() {
      this.set = /* @__PURE__ */ Object.create(null);
    };
    return Set2;
  }();
}
var warn$1 = noop$3;
var uid$1 = 0;
var Dep = function Dep2() {
  this.id = uid$1++;
  this.subs = [];
};
Dep.prototype.addSub = function addSub(sub) {
  this.subs.push(sub);
};
Dep.prototype.removeSub = function removeSub(sub) {
  remove$1(this.subs, sub);
};
Dep.prototype.depend = function depend() {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};
Dep.prototype.notify = function notify() {
  var subs = this.subs.slice();
  for (var i2 = 0, l = subs.length; i2 < l; i2++) {
    subs[i2].update();
  }
};
Dep.target = null;
var targetStack = [];
function pushTarget(target2) {
  targetStack.push(target2);
  Dep.target = target2;
}
function popTarget() {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}
var VNode = function VNode2(tag, data, children, text2, elm, context, componentOptions, asyncFactory) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text2;
  this.elm = elm;
  this.ns = void 0;
  this.context = context;
  this.fnContext = void 0;
  this.fnOptions = void 0;
  this.fnScopeId = void 0;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = void 0;
  this.parent = void 0;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = void 0;
  this.isAsyncPlaceholder = false;
};
var prototypeAccessors$1 = { child: { configurable: true } };
prototypeAccessors$1.child.get = function() {
  return this.componentInstance;
};
Object.defineProperties(VNode.prototype, prototypeAccessors$1);
var createEmptyVNode = function(text2) {
  if (text2 === void 0)
    text2 = "";
  var node2 = new VNode();
  node2.text = text2;
  node2.isComment = true;
  return node2;
};
function createTextVNode(val) {
  return new VNode(void 0, void 0, void 0, String(val));
}
function cloneVNode(vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned;
}
var arrayProto$1 = Array.prototype;
var arrayMethods = Object.create(arrayProto$1);
var methodsToPatch = [
  "push",
  "pop",
  "shift",
  "unshift",
  "splice",
  "sort",
  "reverse"
];
methodsToPatch.forEach(function(method) {
  var original = arrayProto$1[method];
  def$1(arrayMethods, method, function mutator() {
    var args = [], len = arguments.length;
    while (len--)
      args[len] = arguments[len];
    var result2 = original.apply(this, args);
    var ob = this.__ob__;
    var inserted2;
    switch (method) {
      case "push":
      case "unshift":
        inserted2 = args;
        break;
      case "splice":
        inserted2 = args.slice(2);
        break;
    }
    if (inserted2) {
      ob.observeArray(inserted2);
    }
    ob.dep.notify();
    return result2;
  });
});
var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
var shouldObserve = true;
function toggleObserving(value) {
  shouldObserve = value;
}
var Observer = function Observer2(value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def$1(value, "__ob__", this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};
Observer.prototype.walk = function walk(obj) {
  var keys2 = Object.keys(obj);
  for (var i2 = 0; i2 < keys2.length; i2++) {
    defineReactive$$1(obj, keys2[i2]);
  }
};
Observer.prototype.observeArray = function observeArray(items) {
  for (var i2 = 0, l = items.length; i2 < l; i2++) {
    observe$1(items[i2]);
  }
};
function protoAugment(target2, src) {
  target2.__proto__ = src;
}
function copyAugment(target2, src, keys2) {
  for (var i2 = 0, l = keys2.length; i2 < l; i2++) {
    var key = keys2[i2];
    def$1(target2, key, src[key]);
  }
}
function observe$1(value, asRootData) {
  if (!isObject$e(value) || value instanceof VNode) {
    return;
  }
  var ob;
  if (hasOwn$2(value, "__ob__") && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (shouldObserve && !isServerRendering() && (Array.isArray(value) || isPlainObject$9(value)) && Object.isExtensible(value) && !value._isVue) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob;
}
function defineReactive$$1(obj, key, val, customSetter, shallow) {
  var dep = new Dep();
  var property2 = Object.getOwnPropertyDescriptor(obj, key);
  if (property2 && property2.configurable === false) {
    return;
  }
  var getter = property2 && property2.get;
  var setter = property2 && property2.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }
  var childOb = !shallow && observe$1(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter() {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value;
    },
    set: function reactiveSetter(newVal) {
      var value = getter ? getter.call(obj) : val;
      if (newVal === value || newVal !== newVal && value !== value) {
        return;
      }
      if (getter && !setter) {
        return;
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe$1(newVal);
      dep.notify();
    }
  });
}
function set$2(target2, key, val) {
  if (Array.isArray(target2) && isValidArrayIndex$1(key)) {
    target2.length = Math.max(target2.length, key);
    target2.splice(key, 1, val);
    return val;
  }
  if (key in target2 && !(key in Object.prototype)) {
    target2[key] = val;
    return val;
  }
  var ob = target2.__ob__;
  if (target2._isVue || ob && ob.vmCount) {
    return val;
  }
  if (!ob) {
    target2[key] = val;
    return val;
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val;
}
function del(target2, key) {
  if (Array.isArray(target2) && isValidArrayIndex$1(key)) {
    target2.splice(key, 1);
    return;
  }
  var ob = target2.__ob__;
  if (target2._isVue || ob && ob.vmCount) {
    return;
  }
  if (!hasOwn$2(target2, key)) {
    return;
  }
  delete target2[key];
  if (!ob) {
    return;
  }
  ob.dep.notify();
}
function dependArray(value) {
  for (var e = void 0, i2 = 0, l = value.length; i2 < l; i2++) {
    e = value[i2];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}
var strats = config$1.optionMergeStrategies;
function mergeData$1(to, from) {
  if (!from) {
    return to;
  }
  var key, toVal, fromVal;
  var keys2 = hasSymbol$1 ? Reflect.ownKeys(from) : Object.keys(from);
  for (var i2 = 0; i2 < keys2.length; i2++) {
    key = keys2[i2];
    if (key === "__ob__") {
      continue;
    }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn$2(to, key)) {
      set$2(to, key, fromVal);
    } else if (toVal !== fromVal && isPlainObject$9(toVal) && isPlainObject$9(fromVal)) {
      mergeData$1(toVal, fromVal);
    }
  }
  return to;
}
function mergeDataOrFn(parentVal, childVal, vm) {
  if (!vm) {
    if (!childVal) {
      return parentVal;
    }
    if (!parentVal) {
      return childVal;
    }
    return function mergedDataFn() {
      return mergeData$1(
        typeof childVal === "function" ? childVal.call(this, this) : childVal,
        typeof parentVal === "function" ? parentVal.call(this, this) : parentVal
      );
    };
  } else {
    return function mergedInstanceDataFn() {
      var instanceData = typeof childVal === "function" ? childVal.call(vm, vm) : childVal;
      var defaultData = typeof parentVal === "function" ? parentVal.call(vm, vm) : parentVal;
      if (instanceData) {
        return mergeData$1(instanceData, defaultData);
      } else {
        return defaultData;
      }
    };
  }
}
strats.data = function(parentVal, childVal, vm) {
  if (!vm) {
    if (childVal && typeof childVal !== "function") {
      return parentVal;
    }
    return mergeDataOrFn(parentVal, childVal);
  }
  return mergeDataOrFn(parentVal, childVal, vm);
};
function mergeHook(parentVal, childVal) {
  var res = childVal ? parentVal ? parentVal.concat(childVal) : Array.isArray(childVal) ? childVal : [childVal] : parentVal;
  return res ? dedupeHooks(res) : res;
}
function dedupeHooks(hooks2) {
  var res = [];
  for (var i2 = 0; i2 < hooks2.length; i2++) {
    if (res.indexOf(hooks2[i2]) === -1) {
      res.push(hooks2[i2]);
    }
  }
  return res;
}
LIFECYCLE_HOOKS.forEach(function(hook) {
  strats[hook] = mergeHook;
});
function mergeAssets(parentVal, childVal, vm, key) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    return extend$3(res, childVal);
  } else {
    return res;
  }
}
ASSET_TYPES.forEach(function(type) {
  strats[type + "s"] = mergeAssets;
});
strats.watch = function(parentVal, childVal, vm, key) {
  if (parentVal === nativeWatch) {
    parentVal = void 0;
  }
  if (childVal === nativeWatch) {
    childVal = void 0;
  }
  if (!childVal) {
    return Object.create(parentVal || null);
  }
  if (!parentVal) {
    return childVal;
  }
  var ret = {};
  extend$3(ret, parentVal);
  for (var key$1 in childVal) {
    var parent2 = ret[key$1];
    var child = childVal[key$1];
    if (parent2 && !Array.isArray(parent2)) {
      parent2 = [parent2];
    }
    ret[key$1] = parent2 ? parent2.concat(child) : Array.isArray(child) ? child : [child];
  }
  return ret;
};
strats.props = strats.methods = strats.inject = strats.computed = function(parentVal, childVal, vm, key) {
  if (childVal && false) {
    assertObjectType(key, childVal);
  }
  if (!parentVal) {
    return childVal;
  }
  var ret = /* @__PURE__ */ Object.create(null);
  extend$3(ret, parentVal);
  if (childVal) {
    extend$3(ret, childVal);
  }
  return ret;
};
strats.provide = mergeDataOrFn;
var defaultStrat = function(parentVal, childVal) {
  return childVal === void 0 ? parentVal : childVal;
};
function normalizeProps(options, vm) {
  var props2 = options.props;
  if (!props2) {
    return;
  }
  var res = {};
  var i2, val, name;
  if (Array.isArray(props2)) {
    i2 = props2.length;
    while (i2--) {
      val = props2[i2];
      if (typeof val === "string") {
        name = camelize(val);
        res[name] = { type: null };
      }
    }
  } else if (isPlainObject$9(props2)) {
    for (var key in props2) {
      val = props2[key];
      name = camelize(key);
      res[name] = isPlainObject$9(val) ? val : { type: val };
    }
  } else
    ;
  options.props = res;
}
function normalizeInject(options, vm) {
  var inject2 = options.inject;
  if (!inject2) {
    return;
  }
  var normalized = options.inject = {};
  if (Array.isArray(inject2)) {
    for (var i2 = 0; i2 < inject2.length; i2++) {
      normalized[inject2[i2]] = { from: inject2[i2] };
    }
  } else if (isPlainObject$9(inject2)) {
    for (var key in inject2) {
      var val = inject2[key];
      normalized[key] = isPlainObject$9(val) ? extend$3({ from: key }, val) : { from: val };
    }
  } else
    ;
}
function normalizeDirectives(options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === "function") {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}
function assertObjectType(name, value, vm) {
  if (!isPlainObject$9(value)) {
    warn$1(
      'Invalid value for option "' + name + '": expected an Object, but got ' + toRawType(value) + "."
    );
  }
}
function mergeOptions(parent2, child, vm) {
  if (typeof child === "function") {
    child = child.options;
  }
  normalizeProps(child);
  normalizeInject(child);
  normalizeDirectives(child);
  if (!child._base) {
    if (child.extends) {
      parent2 = mergeOptions(parent2, child.extends, vm);
    }
    if (child.mixins) {
      for (var i2 = 0, l = child.mixins.length; i2 < l; i2++) {
        parent2 = mergeOptions(parent2, child.mixins[i2], vm);
      }
    }
  }
  var options = {};
  var key;
  for (key in parent2) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn$2(parent2, key)) {
      mergeField(key);
    }
  }
  function mergeField(key2) {
    var strat = strats[key2] || defaultStrat;
    options[key2] = strat(parent2[key2], child[key2], vm, key2);
  }
  return options;
}
function resolveAsset(options, type, id, warnMissing) {
  if (typeof id !== "string") {
    return;
  }
  var assets = options[type];
  if (hasOwn$2(assets, id)) {
    return assets[id];
  }
  var camelizedId = camelize(id);
  if (hasOwn$2(assets, camelizedId)) {
    return assets[camelizedId];
  }
  var PascalCaseId = capitalize$1(camelizedId);
  if (hasOwn$2(assets, PascalCaseId)) {
    return assets[PascalCaseId];
  }
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  return res;
}
function validateProp(key, propOptions, propsData, vm) {
  var prop = propOptions[key];
  var absent = !hasOwn$2(propsData, key);
  var value = propsData[key];
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn$2(prop, "default")) {
      value = false;
    } else if (value === "" || value === hyphenate(key)) {
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  if (value === void 0) {
    value = getPropDefaultValue(vm, prop, key);
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe$1(value);
    toggleObserving(prevShouldObserve);
  }
  return value;
}
function getPropDefaultValue(vm, prop, key) {
  if (!hasOwn$2(prop, "default")) {
    return void 0;
  }
  var def2 = prop.default;
  if (vm && vm.$options.propsData && vm.$options.propsData[key] === void 0 && vm._props[key] !== void 0) {
    return vm._props[key];
  }
  return typeof def2 === "function" && getType(prop.type) !== "Function" ? def2.call(vm) : def2;
}
var functionTypeCheckRE = /^\s*function (\w+)/;
function getType(fn) {
  var match = fn && fn.toString().match(functionTypeCheckRE);
  return match ? match[1] : "";
}
function isSameType(a, b) {
  return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1;
  }
  for (var i2 = 0, len = expectedTypes.length; i2 < len; i2++) {
    if (isSameType(expectedTypes[i2], type)) {
      return i2;
    }
  }
  return -1;
}
function handleError(err2, vm, info) {
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while (cur = cur.$parent) {
        var hooks2 = cur.$options.errorCaptured;
        if (hooks2) {
          for (var i2 = 0; i2 < hooks2.length; i2++) {
            try {
              var capture = hooks2[i2].call(cur, err2, vm, info) === false;
              if (capture) {
                return;
              }
            } catch (e) {
              globalHandleError(e, cur, "errorCaptured hook");
            }
          }
        }
      }
    }
    globalHandleError(err2, vm, info);
  } finally {
    popTarget();
  }
}
function invokeWithErrorHandling(handler, context, args, vm, info) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise$1(res) && !res._handled) {
      res.catch(function(e) {
        return handleError(e, vm, info + " (Promise/async)");
      });
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res;
}
function globalHandleError(err2, vm, info) {
  if (config$1.errorHandler) {
    try {
      return config$1.errorHandler.call(null, err2, vm, info);
    } catch (e) {
      if (e !== err2) {
        logError$1(e);
      }
    }
  }
  logError$1(err2);
}
function logError$1(err2, vm, info) {
  if ((inBrowser || inWeex) && typeof console !== "undefined") {
    console.error(err2);
  } else {
    throw err2;
  }
}
var isUsingMicroTask = false;
var callbacks = [];
var pending = false;
function flushCallbacks() {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i2 = 0; i2 < copies.length; i2++) {
    copies[i2]();
  }
}
var timerFunc;
if (typeof Promise !== "undefined" && isNative$1(Promise)) {
  var p = Promise.resolve();
  timerFunc = function() {
    p.then(flushCallbacks);
    if (isIOS) {
      setTimeout(noop$3);
    }
  };
  isUsingMicroTask = true;
} else if (!isIE$1 && typeof MutationObserver !== "undefined" && (isNative$1(MutationObserver) || // PhantomJS and iOS 7.x
MutationObserver.toString() === "[object MutationObserverConstructor]")) {
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function() {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== "undefined" && isNative$1(setImmediate)) {
  timerFunc = function() {
    setImmediate(flushCallbacks);
  };
} else {
  timerFunc = function() {
    setTimeout(flushCallbacks, 0);
  };
}
function nextTick$1(cb, ctx) {
  var _resolve;
  callbacks.push(function() {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, "nextTick");
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  if (!cb && typeof Promise !== "undefined") {
    return new Promise(function(resolve2) {
      _resolve = resolve2;
    });
  }
}
var seenObjects = new _Set$1();
function traverse$1(val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}
function _traverse(val, seen) {
  var i2, keys2;
  var isA = Array.isArray(val);
  if (!isA && !isObject$e(val) || Object.isFrozen(val) || val instanceof VNode) {
    return;
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return;
    }
    seen.add(depId);
  }
  if (isA) {
    i2 = val.length;
    while (i2--) {
      _traverse(val[i2], seen);
    }
  } else {
    keys2 = Object.keys(val);
    i2 = keys2.length;
    while (i2--) {
      _traverse(val[keys2[i2]], seen);
    }
  }
}
var normalizeEvent = cached(function(name) {
  var passive = name.charAt(0) === "&";
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === "~";
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === "!";
  name = capture ? name.slice(1) : name;
  return {
    name,
    once: once$$1,
    capture,
    passive
  };
});
function createFnInvoker(fns, vm) {
  function invoker() {
    var arguments$1 = arguments;
    var fns2 = invoker.fns;
    if (Array.isArray(fns2)) {
      var cloned = fns2.slice();
      for (var i2 = 0; i2 < cloned.length; i2++) {
        invokeWithErrorHandling(cloned[i2], null, arguments$1, vm, "v-on handler");
      }
    } else {
      return invokeWithErrorHandling(fns2, null, arguments, vm, "v-on handler");
    }
  }
  invoker.fns = fns;
  return invoker;
}
function updateListeners(on2, oldOn, add2, remove$$12, createOnceHandler2, vm) {
  var name, cur, old, event;
  for (name in on2) {
    cur = on2[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur))
      ;
    else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on2[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on2[name] = createOnceHandler2(event.name, cur, event.capture);
      }
      add2(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on2[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on2[name])) {
      event = normalizeEvent(name);
      remove$$12(event.name, oldOn[name], event.capture);
    }
  }
}
function mergeVNodeHook(def2, hookKey, hook) {
  if (def2 instanceof VNode) {
    def2 = def2.data.hook || (def2.data.hook = {});
  }
  var invoker;
  var oldHook = def2[hookKey];
  function wrappedHook() {
    hook.apply(this, arguments);
    remove$1(invoker.fns, wrappedHook);
  }
  if (isUndef(oldHook)) {
    invoker = createFnInvoker([wrappedHook]);
  } else {
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }
  invoker.merged = true;
  def2[hookKey] = invoker;
}
function extractPropsFromVNodeData(data, Ctor, tag) {
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return;
  }
  var res = {};
  var attrs2 = data.attrs;
  var props2 = data.props;
  if (isDef(attrs2) || isDef(props2)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      checkProp(res, props2, key, altKey, true) || checkProp(res, attrs2, key, altKey, false);
    }
  }
  return res;
}
function checkProp(res, hash, key, altKey, preserve) {
  if (isDef(hash)) {
    if (hasOwn$2(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true;
    } else if (hasOwn$2(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true;
    }
  }
  return false;
}
function simpleNormalizeChildren(children) {
  for (var i2 = 0; i2 < children.length; i2++) {
    if (Array.isArray(children[i2])) {
      return Array.prototype.concat.apply([], children);
    }
  }
  return children;
}
function normalizeChildren(children) {
  return isPrimitive(children) ? [createTextVNode(children)] : Array.isArray(children) ? normalizeArrayChildren(children) : void 0;
}
function isTextNode(node2) {
  return isDef(node2) && isDef(node2.text) && isFalse(node2.isComment);
}
function normalizeArrayChildren(children, nestedIndex) {
  var res = [];
  var i2, c, lastIndex, last2;
  for (i2 = 0; i2 < children.length; i2++) {
    c = children[i2];
    if (isUndef(c) || typeof c === "boolean") {
      continue;
    }
    lastIndex = res.length - 1;
    last2 = res[lastIndex];
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, (nestedIndex || "") + "_" + i2);
        if (isTextNode(c[0]) && isTextNode(last2)) {
          res[lastIndex] = createTextVNode(last2.text + c[0].text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last2)) {
        res[lastIndex] = createTextVNode(last2.text + c);
      } else if (c !== "") {
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last2)) {
        res[lastIndex] = createTextVNode(last2.text + c.text);
      } else {
        if (isTrue(children._isVList) && isDef(c.tag) && isUndef(c.key) && isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i2 + "__";
        }
        res.push(c);
      }
    }
  }
  return res;
}
function initProvide(vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === "function" ? provide.call(vm) : provide;
  }
}
function initInjections(vm) {
  var result2 = resolveInject$1(vm.$options.inject, vm);
  if (result2) {
    toggleObserving(false);
    Object.keys(result2).forEach(function(key) {
      {
        defineReactive$$1(vm, key, result2[key]);
      }
    });
    toggleObserving(true);
  }
}
function resolveInject$1(inject2, vm) {
  if (inject2) {
    var result2 = /* @__PURE__ */ Object.create(null);
    var keys2 = hasSymbol$1 ? Reflect.ownKeys(inject2) : Object.keys(inject2);
    for (var i2 = 0; i2 < keys2.length; i2++) {
      var key = keys2[i2];
      if (key === "__ob__") {
        continue;
      }
      var provideKey = inject2[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn$2(source._provided, provideKey)) {
          result2[key] = source._provided[provideKey];
          break;
        }
        source = source.$parent;
      }
      if (!source) {
        if ("default" in inject2[key]) {
          var provideDefault = inject2[key].default;
          result2[key] = typeof provideDefault === "function" ? provideDefault.call(vm) : provideDefault;
        }
      }
    }
    return result2;
  }
}
function resolveSlots$1(children, context) {
  if (!children || !children.length) {
    return {};
  }
  var slots = {};
  for (var i2 = 0, l = children.length; i2 < l; i2++) {
    var child = children[i2];
    var data = child.data;
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    if ((child.context === context || child.fnContext === context) && data && data.slot != null) {
      var name = data.slot;
      var slot = slots[name] || (slots[name] = []);
      if (child.tag === "template") {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  for (var name$12 in slots) {
    if (slots[name$12].every(isWhitespace)) {
      delete slots[name$12];
    }
  }
  return slots;
}
function isWhitespace(node2) {
  return node2.isComment && !node2.asyncFactory || node2.text === " ";
}
function isAsyncPlaceholder(node2) {
  return node2.isComment && node2.asyncFactory;
}
function normalizeScopedSlots(slots, normalSlots, prevSlots) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    return slots._normalized;
  } else if (isStable && prevSlots && prevSlots !== emptyObject && key === prevSlots.$key && !hasNormalSlots && !prevSlots.$hasNormal) {
    return prevSlots;
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== "$") {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  if (slots && Object.isExtensible(slots)) {
    slots._normalized = res;
  }
  def$1(res, "$stable", isStable);
  def$1(res, "$key", key);
  def$1(res, "$hasNormal", hasNormalSlots);
  return res;
}
function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function() {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === "object" && !Array.isArray(res) ? [res] : normalizeChildren(res);
    var vnode = res && res[0];
    return res && (!vnode || res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) ? void 0 : res;
  };
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized;
}
function proxyNormalSlot(slots, key) {
  return function() {
    return slots[key];
  };
}
function renderList(val, render8) {
  var ret, i2, l, keys2, key;
  if (Array.isArray(val) || typeof val === "string") {
    ret = new Array(val.length);
    for (i2 = 0, l = val.length; i2 < l; i2++) {
      ret[i2] = render8(val[i2], i2);
    }
  } else if (typeof val === "number") {
    ret = new Array(val);
    for (i2 = 0; i2 < val; i2++) {
      ret[i2] = render8(i2 + 1, i2);
    }
  } else if (isObject$e(val)) {
    if (hasSymbol$1 && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result2 = iterator.next();
      while (!result2.done) {
        ret.push(render8(result2.value, ret.length));
        result2 = iterator.next();
      }
    } else {
      keys2 = Object.keys(val);
      ret = new Array(keys2.length);
      for (i2 = 0, l = keys2.length; i2 < l; i2++) {
        key = keys2[i2];
        ret[i2] = render8(val[key], key, i2);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  ret._isVList = true;
  return ret;
}
function renderSlot(name, fallbackRender, props2, bindObject) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) {
    props2 = props2 || {};
    if (bindObject) {
      props2 = extend$3(extend$3({}, bindObject), props2);
    }
    nodes = scopedSlotFn(props2) || (typeof fallbackRender === "function" ? fallbackRender() : fallbackRender);
  } else {
    nodes = this.$slots[name] || (typeof fallbackRender === "function" ? fallbackRender() : fallbackRender);
  }
  var target2 = props2 && props2.slot;
  if (target2) {
    return this.$createElement("template", { slot: target2 }, nodes);
  } else {
    return nodes;
  }
}
function resolveFilter(id) {
  return resolveAsset(this.$options, "filters", id) || identity$4;
}
function isKeyNotMatch(expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1;
  } else {
    return expect !== actual;
  }
}
function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
  var mappedKeyCode = config$1.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config$1.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName);
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode);
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key;
  }
  return eventKeyCode === void 0;
}
function bindObjectProps(data, tag, value, asProp, isSync) {
  if (value) {
    if (!isObject$e(value))
      ;
    else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function(key2) {
        if (key2 === "class" || key2 === "style" || isReservedAttribute(key2)) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config$1.mustUseProp(tag, type, key2) ? data.domProps || (data.domProps = {}) : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key2);
        var hyphenatedKey = hyphenate(key2);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key2] = value[key2];
          if (isSync) {
            var on2 = data.on || (data.on = {});
            on2["update:" + key2] = function($event) {
              value[key2] = $event;
            };
          }
        }
      };
      for (var key in value)
        loop(key);
    }
  }
  return data;
}
function renderStatic(index2, isInFor) {
  var cached2 = this._staticTrees || (this._staticTrees = []);
  var tree = cached2[index2];
  if (tree && !isInFor) {
    return tree;
  }
  tree = cached2[index2] = this.$options.staticRenderFns[index2].call(
    this._renderProxy,
    null,
    this
    // for render fns generated for functional component templates
  );
  markStatic(tree, "__static__" + index2, false);
  return tree;
}
function markOnce(tree, index2, key) {
  markStatic(tree, "__once__" + index2 + (key ? "_" + key : ""), true);
  return tree;
}
function markStatic(tree, key, isOnce) {
  if (Array.isArray(tree)) {
    for (var i2 = 0; i2 < tree.length; i2++) {
      if (tree[i2] && typeof tree[i2] !== "string") {
        markStaticNode(tree[i2], key + "_" + i2, isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}
function markStaticNode(node2, key, isOnce) {
  node2.isStatic = true;
  node2.key = key;
  node2.isOnce = isOnce;
}
function bindObjectListeners(data, value) {
  if (value) {
    if (!isPlainObject$9(value))
      ;
    else {
      var on2 = data.on = data.on ? extend$3({}, data.on) : {};
      for (var key in value) {
        var existing = on2[key];
        var ours = value[key];
        on2[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data;
}
function resolveScopedSlots$1(fns, res, hasDynamicKeys, contentHashKey) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i2 = 0; i2 < fns.length; i2++) {
    var slot = fns[i2];
    if (Array.isArray(slot)) {
      resolveScopedSlots$1(slot, res, hasDynamicKeys);
    } else if (slot) {
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    res.$key = contentHashKey;
  }
  return res;
}
function bindDynamicKeys(baseObj, values2) {
  for (var i2 = 0; i2 < values2.length; i2 += 2) {
    var key = values2[i2];
    if (typeof key === "string" && key) {
      baseObj[values2[i2]] = values2[i2 + 1];
    }
  }
  return baseObj;
}
function prependModifier(value, symbol) {
  return typeof value === "string" ? symbol + value : value;
}
function installRenderHelpers(target2) {
  target2._o = markOnce;
  target2._n = toNumber$2;
  target2._s = toString$4;
  target2._l = renderList;
  target2._t = renderSlot;
  target2._q = looseEqual$1;
  target2._i = looseIndexOf;
  target2._m = renderStatic;
  target2._f = resolveFilter;
  target2._k = checkKeyCodes;
  target2._b = bindObjectProps;
  target2._v = createTextVNode;
  target2._e = createEmptyVNode;
  target2._u = resolveScopedSlots$1;
  target2._g = bindObjectListeners;
  target2._d = bindDynamicKeys;
  target2._p = prependModifier;
}
function FunctionalRenderContext(data, props2, children, parent2, Ctor) {
  var this$1$1 = this;
  var options = Ctor.options;
  var contextVm;
  if (hasOwn$2(parent2, "_uid")) {
    contextVm = Object.create(parent2);
    contextVm._original = parent2;
  } else {
    contextVm = parent2;
    parent2 = parent2._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;
  this.data = data;
  this.props = props2;
  this.children = children;
  this.parent = parent2;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject$1(options.inject, parent2);
  this.slots = function() {
    if (!this$1$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1$1.$slots = resolveSlots$1(children, parent2)
      );
    }
    return this$1$1.$slots;
  };
  Object.defineProperty(this, "scopedSlots", {
    enumerable: true,
    get: function get5() {
      return normalizeScopedSlots(data.scopedSlots, this.slots());
    }
  });
  if (isCompiled) {
    this.$options = options;
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }
  if (options._scopeId) {
    this._c = function(a, b, c, d2) {
      var vnode = createElement(contextVm, a, b, c, d2, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent2;
      }
      return vnode;
    };
  } else {
    this._c = function(a, b, c, d2) {
      return createElement(contextVm, a, b, c, d2, needNormalization);
    };
  }
}
installRenderHelpers(FunctionalRenderContext.prototype);
function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
  var options = Ctor.options;
  var props2 = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props2[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) {
      mergeProps(props2, data.attrs);
    }
    if (isDef(data.props)) {
      mergeProps(props2, data.props);
    }
  }
  var renderContext = new FunctionalRenderContext(
    data,
    props2,
    children,
    contextVm,
    Ctor
  );
  var vnode = options.render.call(null, renderContext._c, renderContext);
  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options);
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i2 = 0; i2 < vnodes.length; i2++) {
      res[i2] = cloneAndMarkFunctionalResult(vnodes[i2], data, renderContext.parent, options);
    }
    return res;
  }
}
function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
  var clone2 = cloneVNode(vnode);
  clone2.fnContext = contextVm;
  clone2.fnOptions = options;
  if (data.slot) {
    (clone2.data || (clone2.data = {})).slot = data.slot;
  }
  return clone2;
}
function mergeProps(to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}
var componentVNodeHooks = {
  init: function init(vnode, hydrating) {
    if (vnode.componentInstance && !vnode.componentInstance._isDestroyed && vnode.data.keepAlive) {
      var mountedNode = vnode;
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : void 0, hydrating);
    }
  },
  prepatch: function prepatch(oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData,
      // updated props
      options.listeners,
      // updated listeners
      vnode,
      // new parent vnode
      options.children
      // new children
    );
  },
  insert: function insert(vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, "mounted");
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(
          componentInstance,
          true
          /* direct */
        );
      }
    }
  },
  destroy: function destroy(vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(
          componentInstance,
          true
          /* direct */
        );
      }
    }
  }
};
var hooksToMerge = Object.keys(componentVNodeHooks);
function createComponent(Ctor, data, context, children, tag) {
  if (isUndef(Ctor)) {
    return;
  }
  var baseCtor = context.$options._base;
  if (isObject$e(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }
  if (typeof Ctor !== "function") {
    return;
  }
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === void 0) {
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      );
    }
  }
  data = data || {};
  resolveConstructorOptions(Ctor);
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }
  var propsData = extractPropsFromVNodeData(data, Ctor);
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children);
  }
  var listeners = data.on;
  data.on = data.nativeOn;
  if (isTrue(Ctor.options.abstract)) {
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }
  installComponentHooks(data);
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    "vue-component-" + Ctor.cid + (name ? "-" + name : ""),
    data,
    void 0,
    void 0,
    void 0,
    context,
    { Ctor, propsData, listeners, tag, children },
    asyncFactory
  );
  return vnode;
}
function createComponentInstanceForVnode(vnode, parent2) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent2
  };
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options);
}
function installComponentHooks(data) {
  var hooks2 = data.hook || (data.hook = {});
  for (var i2 = 0; i2 < hooksToMerge.length; i2++) {
    var key = hooksToMerge[i2];
    var existing = hooks2[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks2[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}
function mergeHook$1(f1, f2) {
  var merged = function(a, b) {
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged;
}
function transformModel(options, data) {
  var prop = options.model && options.model.prop || "value";
  var event = options.model && options.model.event || "input";
  (data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on2 = data.on || (data.on = {});
  var existing = on2[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (Array.isArray(existing) ? existing.indexOf(callback) === -1 : existing !== callback) {
      on2[event] = [callback].concat(existing);
    }
  } else {
    on2[event] = callback;
  }
}
var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;
function createElement(context, tag, data, children, normalizationType, alwaysNormalize) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = void 0;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType);
}
function _createElement(context, tag, data, children, normalizationType) {
  if (isDef(data) && isDef(data.__ob__)) {
    return createEmptyVNode();
  }
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    return createEmptyVNode();
  }
  if (Array.isArray(children) && typeof children[0] === "function") {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === "string") {
    var Ctor;
    ns = context.$vnode && context.$vnode.ns || config$1.getTagNamespace(tag);
    if (config$1.isReservedTag(tag)) {
      vnode = new VNode(
        config$1.parsePlatformTagName(tag),
        data,
        children,
        void 0,
        void 0,
        context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, "components", tag))) {
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      vnode = new VNode(
        tag,
        data,
        children,
        void 0,
        void 0,
        context
      );
    }
  } else {
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode;
  } else if (isDef(vnode)) {
    if (isDef(ns)) {
      applyNS(vnode, ns);
    }
    if (isDef(data)) {
      registerDeepBindings(data);
    }
    return vnode;
  } else {
    return createEmptyVNode();
  }
}
function applyNS(vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === "foreignObject") {
    ns = void 0;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i2 = 0, l = vnode.children.length; i2 < l; i2++) {
      var child = vnode.children[i2];
      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force) && child.tag !== "svg")) {
        applyNS(child, ns, force);
      }
    }
  }
}
function registerDeepBindings(data) {
  if (isObject$e(data.style)) {
    traverse$1(data.style);
  }
  if (isObject$e(data.class)) {
    traverse$1(data.class);
  }
}
function initRender(vm) {
  vm._vnode = null;
  vm._staticTrees = null;
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode;
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots$1(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  vm._c = function(a, b, c, d2) {
    return createElement(vm, a, b, c, d2, false);
  };
  vm.$createElement = function(a, b, c, d2) {
    return createElement(vm, a, b, c, d2, true);
  };
  var parentData = parentVnode && parentVnode.data;
  {
    defineReactive$$1(vm, "$attrs", parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, "$listeners", options._parentListeners || emptyObject, null, true);
  }
}
var currentRenderingInstance = null;
function renderMixin(Vue2) {
  installRenderHelpers(Vue2.prototype);
  Vue2.prototype.$nextTick = function(fn) {
    return nextTick$1(fn, this);
  };
  Vue2.prototype._render = function() {
    var vm = this;
    var ref2 = vm.$options;
    var render8 = ref2.render;
    var _parentVnode = ref2._parentVnode;
    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }
    vm.$vnode = _parentVnode;
    var vnode;
    try {
      currentRenderingInstance = vm;
      vnode = render8.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    if (!(vnode instanceof VNode)) {
      vnode = createEmptyVNode();
    }
    vnode.parent = _parentVnode;
    return vnode;
  };
}
function ensureCtor(comp, base) {
  if (comp.__esModule || hasSymbol$1 && comp[Symbol.toStringTag] === "Module") {
    comp = comp.default;
  }
  return isObject$e(comp) ? base.extend(comp) : comp;
}
function createAsyncPlaceholder(factory, data, context, children, tag) {
  var node2 = createEmptyVNode();
  node2.asyncFactory = factory;
  node2.asyncMeta = { data, context, children, tag };
  return node2;
}
function resolveAsyncComponent(factory, baseCtor) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp;
  }
  if (isDef(factory.resolved)) {
    return factory.resolved;
  }
  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    factory.owners.push(owner);
  }
  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp;
  }
  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null;
    owner.$on("hook:destroyed", function() {
      return remove$1(owners, owner);
    });
    var forceRender = function(renderCompleted) {
      for (var i2 = 0, l = owners.length; i2 < l; i2++) {
        owners[i2].$forceUpdate();
      }
      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };
    var resolve2 = once(function(res2) {
      factory.resolved = ensureCtor(res2, baseCtor);
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });
    var reject = once(function(reason) {
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });
    var res = factory(resolve2, reject);
    if (isObject$e(res)) {
      if (isPromise$1(res)) {
        if (isUndef(factory.resolved)) {
          res.then(resolve2, reject);
        }
      } else if (isPromise$1(res.component)) {
        res.component.then(resolve2, reject);
        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }
        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function() {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }
        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function() {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                null
              );
            }
          }, res.timeout);
        }
      }
    }
    sync = false;
    return factory.loading ? factory.loadingComp : factory.resolved;
  }
}
function getFirstComponentChild(children) {
  if (Array.isArray(children)) {
    for (var i2 = 0; i2 < children.length; i2++) {
      var c = children[i2];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c;
      }
    }
  }
}
function initEvents(vm) {
  vm._events = /* @__PURE__ */ Object.create(null);
  vm._hasHookEvent = false;
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}
var target;
function add(event, fn) {
  target.$on(event, fn);
}
function remove$1$1(event, fn) {
  target.$off(event, fn);
}
function createOnceHandler(event, fn) {
  var _target2 = target;
  return function onceHandler() {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target2.$off(event, onceHandler);
    }
  };
}
function updateComponentListeners(vm, listeners, oldListeners) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1$1, createOnceHandler, vm);
  target = void 0;
}
function eventsMixin(Vue2) {
  var hookRE = /^hook:/;
  Vue2.prototype.$on = function(event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i2 = 0, l = event.length; i2 < l; i2++) {
        vm.$on(event[i2], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm;
  };
  Vue2.prototype.$once = function(event, fn) {
    var vm = this;
    function on2() {
      vm.$off(event, on2);
      fn.apply(vm, arguments);
    }
    on2.fn = fn;
    vm.$on(event, on2);
    return vm;
  };
  Vue2.prototype.$off = function(event, fn) {
    var vm = this;
    if (!arguments.length) {
      vm._events = /* @__PURE__ */ Object.create(null);
      return vm;
    }
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm;
    }
    var cbs = vm._events[event];
    if (!cbs) {
      return vm;
    }
    if (!fn) {
      vm._events[event] = null;
      return vm;
    }
    var cb;
    var i2 = cbs.length;
    while (i2--) {
      cb = cbs[i2];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i2, 1);
        break;
      }
    }
    return vm;
  };
  Vue2.prototype.$emit = function(event) {
    var vm = this;
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = 'event handler for "' + event + '"';
      for (var i2 = 0, l = cbs.length; i2 < l; i2++) {
        invokeWithErrorHandling(cbs[i2], vm, args, vm, info);
      }
    }
    return vm;
  };
}
var activeInstance = null;
function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function() {
    activeInstance = prevActiveInstance;
  };
}
function initLifecycle(vm) {
  var options = vm.$options;
  var parent2 = options.parent;
  if (parent2 && !options.abstract) {
    while (parent2.$options.abstract && parent2.$parent) {
      parent2 = parent2.$parent;
    }
    parent2.$children.push(vm);
  }
  vm.$parent = parent2;
  vm.$root = parent2 ? parent2.$root : vm;
  vm.$children = [];
  vm.$refs = {};
  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}
function lifecycleMixin(Vue2) {
  Vue2.prototype._update = function(vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    if (!prevVnode) {
      vm.$el = vm.__patch__(
        vm.$el,
        vnode,
        hydrating,
        false
        /* removeOnly */
      );
    } else {
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
  };
  Vue2.prototype.$forceUpdate = function() {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };
  Vue2.prototype.$destroy = function() {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return;
    }
    callHook(vm, "beforeDestroy");
    vm._isBeingDestroyed = true;
    var parent2 = vm.$parent;
    if (parent2 && !parent2._isBeingDestroyed && !vm.$options.abstract) {
      remove$1(parent2.$children, vm);
    }
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i2 = vm._watchers.length;
    while (i2--) {
      vm._watchers[i2].teardown();
    }
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    vm._isDestroyed = true;
    vm.__patch__(vm._vnode, null);
    callHook(vm, "destroyed");
    vm.$off();
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}
function mountComponent(vm, el, hydrating) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
  }
  callHook(vm, "beforeMount");
  var updateComponent;
  {
    updateComponent = function() {
      vm._update(vm._render(), hydrating);
    };
  }
  new Watcher(
    vm,
    updateComponent,
    noop$3,
    {
      before: function before() {
        if (vm._isMounted && !vm._isDestroyed) {
          callHook(vm, "beforeUpdate");
        }
      }
    },
    true
    /* isRenderWatcher */
  );
  hydrating = false;
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, "mounted");
  }
  return vm;
}
function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(newScopedSlots && !newScopedSlots.$stable || oldScopedSlots !== emptyObject && !oldScopedSlots.$stable || newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key || !newScopedSlots && vm.$scopedSlots.$key);
  var needsForceUpdate = !!(renderChildren || // has new static slots
  vm.$options._renderChildren || // has old static slots
  hasDynamicScopedSlot);
  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode;
  if (vm._vnode) {
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props2 = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i2 = 0; i2 < propKeys.length; i2++) {
      var key = propKeys[i2];
      var propOptions = vm.$options.props;
      props2[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    vm.$options.propsData = propsData;
  }
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);
  if (needsForceUpdate) {
    vm.$slots = resolveSlots$1(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }
}
function isInInactiveTree(vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) {
      return true;
    }
  }
  return false;
}
function activateChildComponent(vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return;
    }
  } else if (vm._directInactive) {
    return;
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i2 = 0; i2 < vm.$children.length; i2++) {
      activateChildComponent(vm.$children[i2]);
    }
    callHook(vm, "activated");
  }
}
function deactivateChildComponent(vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return;
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i2 = 0; i2 < vm.$children.length; i2++) {
      deactivateChildComponent(vm.$children[i2]);
    }
    callHook(vm, "deactivated");
  }
}
function callHook(vm, hook) {
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i2 = 0, j = handlers.length; i2 < j; i2++) {
      invokeWithErrorHandling(handlers[i2], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit("hook:" + hook);
  }
  popTarget();
}
var queue = [];
var activatedChildren = [];
var has$1 = {};
var waiting = false;
var flushing = false;
var index$2 = 0;
function resetSchedulerState() {
  index$2 = queue.length = activatedChildren.length = 0;
  has$1 = {};
  waiting = flushing = false;
}
var currentFlushTimestamp = 0;
var getNow = Date.now;
if (inBrowser && !isIE$1) {
  var performance$1 = window.performance;
  if (performance$1 && typeof performance$1.now === "function" && getNow() > document.createEvent("Event").timeStamp) {
    getNow = function() {
      return performance$1.now();
    };
  }
}
function flushSchedulerQueue() {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;
  queue.sort(function(a, b) {
    return a.id - b.id;
  });
  for (index$2 = 0; index$2 < queue.length; index$2++) {
    watcher = queue[index$2];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has$1[id] = null;
    watcher.run();
  }
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();
  resetSchedulerState();
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);
  if (devtools && config$1.devtools) {
    devtools.emit("flush");
  }
}
function callUpdatedHooks(queue2) {
  var i2 = queue2.length;
  while (i2--) {
    var watcher = queue2[i2];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, "updated");
    }
  }
}
function queueActivatedComponent(vm) {
  vm._inactive = false;
  activatedChildren.push(vm);
}
function callActivatedHooks(queue2) {
  for (var i2 = 0; i2 < queue2.length; i2++) {
    queue2[i2]._inactive = true;
    activateChildComponent(
      queue2[i2],
      true
      /* true */
    );
  }
}
function queueWatcher(watcher) {
  var id = watcher.id;
  if (has$1[id] == null) {
    has$1[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      var i2 = queue.length - 1;
      while (i2 > index$2 && queue[i2].id > watcher.id) {
        i2--;
      }
      queue.splice(i2 + 1, 0, watcher);
    }
    if (!waiting) {
      waiting = true;
      nextTick$1(flushSchedulerQueue);
    }
  }
}
var uid$2 = 0;
var Watcher = function Watcher2(vm, expOrFn, cb, options, isRenderWatcher) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2;
  this.active = true;
  this.dirty = this.lazy;
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set$1();
  this.newDepIds = new _Set$1();
  this.expression = "";
  if (typeof expOrFn === "function") {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop$3;
    }
  }
  this.value = this.lazy ? void 0 : this.get();
};
Watcher.prototype.get = function get() {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, 'getter for watcher "' + this.expression + '"');
    } else {
      throw e;
    }
  } finally {
    if (this.deep) {
      traverse$1(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value;
};
Watcher.prototype.addDep = function addDep(dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};
Watcher.prototype.cleanupDeps = function cleanupDeps() {
  var i2 = this.deps.length;
  while (i2--) {
    var dep = this.deps[i2];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};
Watcher.prototype.update = function update() {
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};
Watcher.prototype.run = function run() {
  if (this.active) {
    var value = this.get();
    if (value !== this.value || // Deep watchers and watchers on Object/Arrays should fire even
    // when the value is the same, because the value may
    // have mutated.
    isObject$e(value) || this.deep) {
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        var info = 'callback for watcher "' + this.expression + '"';
        invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};
Watcher.prototype.evaluate = function evaluate() {
  this.value = this.get();
  this.dirty = false;
};
Watcher.prototype.depend = function depend2() {
  var i2 = this.deps.length;
  while (i2--) {
    this.deps[i2].depend();
  }
};
Watcher.prototype.teardown = function teardown() {
  if (this.active) {
    if (!this.vm._isBeingDestroyed) {
      remove$1(this.vm._watchers, this);
    }
    var i2 = this.deps.length;
    while (i2--) {
      this.deps[i2].removeSub(this);
    }
    this.active = false;
  }
};
var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop$3,
  set: noop$3
};
function proxy$1(target2, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter() {
    return this[sourceKey][key];
  };
  sharedPropertyDefinition.set = function proxySetter(val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target2, key, sharedPropertyDefinition);
}
function initState(vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) {
    initProps(vm, opts.props);
  }
  if (opts.methods) {
    initMethods(vm, opts.methods);
  }
  if (opts.data) {
    initData(vm);
  } else {
    observe$1(
      vm._data = {},
      true
      /* asRootData */
    );
  }
  if (opts.computed) {
    initComputed(vm, opts.computed);
  }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}
function initProps(vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props2 = vm._props = {};
  var keys2 = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function(key2) {
    keys2.push(key2);
    var value = validateProp(key2, propsOptions, propsData, vm);
    {
      defineReactive$$1(props2, key2, value);
    }
    if (!(key2 in vm)) {
      proxy$1(vm, "_props", key2);
    }
  };
  for (var key in propsOptions)
    loop(key);
  toggleObserving(true);
}
function initData(vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === "function" ? getData(data, vm) : data || {};
  if (!isPlainObject$9(data)) {
    data = {};
  }
  var keys2 = Object.keys(data);
  var props2 = vm.$options.props;
  vm.$options.methods;
  var i2 = keys2.length;
  while (i2--) {
    var key = keys2[i2];
    if (props2 && hasOwn$2(props2, key))
      ;
    else if (!isReserved(key)) {
      proxy$1(vm, "_data", key);
    }
  }
  observe$1(
    data,
    true
    /* asRootData */
  );
}
function getData(data, vm) {
  pushTarget();
  try {
    return data.call(vm, vm);
  } catch (e) {
    handleError(e, vm, "data()");
    return {};
  } finally {
    popTarget();
  }
}
var computedWatcherOptions = { lazy: true };
function initComputed(vm, computed2) {
  var watchers = vm._computedWatchers = /* @__PURE__ */ Object.create(null);
  var isSSR = isServerRendering();
  for (var key in computed2) {
    var userDef = computed2[key];
    var getter = typeof userDef === "function" ? userDef : userDef.get;
    if (!isSSR) {
      watchers[key] = new Watcher(
        vm,
        getter || noop$3,
        noop$3,
        computedWatcherOptions
      );
    }
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    }
  }
}
function defineComputed(target2, key, userDef) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === "function") {
    sharedPropertyDefinition.get = shouldCache ? createComputedGetter(key) : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop$3;
  } else {
    sharedPropertyDefinition.get = userDef.get ? shouldCache && userDef.cache !== false ? createComputedGetter(key) : createGetterInvoker(userDef.get) : noop$3;
    sharedPropertyDefinition.set = userDef.set || noop$3;
  }
  Object.defineProperty(target2, key, sharedPropertyDefinition);
}
function createComputedGetter(key) {
  return function computedGetter() {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value;
    }
  };
}
function createGetterInvoker(fn) {
  return function computedGetter() {
    return fn.call(this, this);
  };
}
function initMethods(vm, methods) {
  vm.$options.props;
  for (var key in methods) {
    vm[key] = typeof methods[key] !== "function" ? noop$3 : bind$2(methods[key], vm);
  }
}
function initWatch(vm, watch2) {
  for (var key in watch2) {
    var handler = watch2[key];
    if (Array.isArray(handler)) {
      for (var i2 = 0; i2 < handler.length; i2++) {
        createWatcher$1(vm, key, handler[i2]);
      }
    } else {
      createWatcher$1(vm, key, handler);
    }
  }
}
function createWatcher$1(vm, expOrFn, handler, options) {
  if (isPlainObject$9(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === "string") {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options);
}
function stateMixin(Vue2) {
  var dataDef = {};
  dataDef.get = function() {
    return this._data;
  };
  var propsDef = {};
  propsDef.get = function() {
    return this._props;
  };
  Object.defineProperty(Vue2.prototype, "$data", dataDef);
  Object.defineProperty(Vue2.prototype, "$props", propsDef);
  Vue2.prototype.$set = set$2;
  Vue2.prototype.$delete = del;
  Vue2.prototype.$watch = function(expOrFn, cb, options) {
    var vm = this;
    if (isPlainObject$9(cb)) {
      return createWatcher$1(vm, expOrFn, cb, options);
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      var info = 'callback for immediate watcher "' + watcher.expression + '"';
      pushTarget();
      invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
      popTarget();
    }
    return function unwatchFn() {
      watcher.teardown();
    };
  };
}
var uid$3 = 0;
function initMixin(Vue2) {
  Vue2.prototype._init = function(options) {
    var vm = this;
    vm._uid = uid$3++;
    vm._isVue = true;
    if (options && options._isComponent) {
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    {
      vm._renderProxy = vm;
    }
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, "beforeCreate");
    initInjections(vm);
    initState(vm);
    initProvide(vm);
    callHook(vm, "created");
    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}
function initInternalComponent(vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;
  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}
function resolveConstructorOptions(Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      Ctor.superOptions = superOptions;
      var modifiedOptions = resolveModifiedOptions(Ctor);
      if (modifiedOptions) {
        extend$3(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options;
}
function resolveModifiedOptions(Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) {
        modified = {};
      }
      modified[key] = latest[key];
    }
  }
  return modified;
}
function Vue$1(options) {
  this._init(options);
}
initMixin(Vue$1);
stateMixin(Vue$1);
eventsMixin(Vue$1);
lifecycleMixin(Vue$1);
renderMixin(Vue$1);
function initUse(Vue2) {
  Vue2.use = function(plugin3) {
    var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
    if (installedPlugins.indexOf(plugin3) > -1) {
      return this;
    }
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin3.install === "function") {
      plugin3.install.apply(plugin3, args);
    } else if (typeof plugin3 === "function") {
      plugin3.apply(null, args);
    }
    installedPlugins.push(plugin3);
    return this;
  };
}
function initMixin$1(Vue2) {
  Vue2.mixin = function(mixin2) {
    this.options = mergeOptions(this.options, mixin2);
    return this;
  };
}
function initExtend(Vue2) {
  Vue2.cid = 0;
  var cid = 1;
  Vue2.extend = function(extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId];
    }
    var name = extendOptions.name || Super.options.name;
    var Sub = function VueComponent(options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub["super"] = Super;
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;
    ASSET_TYPES.forEach(function(type) {
      Sub[type] = Super[type];
    });
    if (name) {
      Sub.options.components[name] = Sub;
    }
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend$3({}, Sub.options);
    cachedCtors[SuperId] = Sub;
    return Sub;
  };
}
function initProps$1(Comp) {
  var props2 = Comp.options.props;
  for (var key in props2) {
    proxy$1(Comp.prototype, "_props", key);
  }
}
function initComputed$1(Comp) {
  var computed2 = Comp.options.computed;
  for (var key in computed2) {
    defineComputed(Comp.prototype, key, computed2[key]);
  }
}
function initAssetRegisters(Vue2) {
  ASSET_TYPES.forEach(function(type) {
    Vue2[type] = function(id, definition) {
      if (!definition) {
        return this.options[type + "s"][id];
      } else {
        if (type === "component" && isPlainObject$9(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === "directive" && typeof definition === "function") {
          definition = { bind: definition, update: definition };
        }
        this.options[type + "s"][id] = definition;
        return definition;
      }
    };
  });
}
function getComponentName(opts) {
  return opts && (opts.Ctor.options.name || opts.tag);
}
function matches$1(pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1;
  } else if (typeof pattern === "string") {
    return pattern.split(",").indexOf(name) > -1;
  } else if (isRegExp(pattern)) {
    return pattern.test(name);
  }
  return false;
}
function pruneCache(keepAliveInstance, filter2) {
  var cache = keepAliveInstance.cache;
  var keys2 = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var entry = cache[key];
    if (entry) {
      var name = entry.name;
      if (name && !filter2(name)) {
        pruneCacheEntry(cache, key, keys2, _vnode);
      }
    }
  }
}
function pruneCacheEntry(cache, key, keys2, current) {
  var entry = cache[key];
  if (entry && (!current || entry.tag !== current.tag)) {
    entry.componentInstance.$destroy();
  }
  cache[key] = null;
  remove$1(keys2, key);
}
var patternTypes = [String, RegExp, Array];
var KeepAlive = {
  name: "keep-alive",
  abstract: true,
  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },
  methods: {
    cacheVNode: function cacheVNode() {
      var ref2 = this;
      var cache = ref2.cache;
      var keys2 = ref2.keys;
      var vnodeToCache = ref2.vnodeToCache;
      var keyToCache = ref2.keyToCache;
      if (vnodeToCache) {
        var tag = vnodeToCache.tag;
        var componentInstance = vnodeToCache.componentInstance;
        var componentOptions = vnodeToCache.componentOptions;
        cache[keyToCache] = {
          name: getComponentName(componentOptions),
          tag,
          componentInstance
        };
        keys2.push(keyToCache);
        if (this.max && keys2.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys2[0], keys2, this._vnode);
        }
        this.vnodeToCache = null;
      }
    }
  },
  created: function created() {
    this.cache = /* @__PURE__ */ Object.create(null);
    this.keys = [];
  },
  destroyed: function destroyed() {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },
  mounted: function mounted() {
    var this$1$1 = this;
    this.cacheVNode();
    this.$watch("include", function(val) {
      pruneCache(this$1$1, function(name) {
        return matches$1(val, name);
      });
    });
    this.$watch("exclude", function(val) {
      pruneCache(this$1$1, function(name) {
        return !matches$1(val, name);
      });
    });
  },
  updated: function updated() {
    this.cacheVNode();
  },
  render: function render() {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      var name = getComponentName(componentOptions);
      var ref2 = this;
      var include = ref2.include;
      var exclude = ref2.exclude;
      if (
        // not included
        include && (!name || !matches$1(include, name)) || // excluded
        exclude && name && matches$1(exclude, name)
      ) {
        return vnode;
      }
      var ref$12 = this;
      var cache = ref$12.cache;
      var keys2 = ref$12.keys;
      var key = vnode.key == null ? componentOptions.Ctor.cid + (componentOptions.tag ? "::" + componentOptions.tag : "") : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        remove$1(keys2, key);
        keys2.push(key);
      } else {
        this.vnodeToCache = vnode;
        this.keyToCache = key;
      }
      vnode.data.keepAlive = true;
    }
    return vnode || slot && slot[0];
  }
};
var builtInComponents = {
  KeepAlive
};
function initGlobalAPI(Vue2) {
  var configDef = {};
  configDef.get = function() {
    return config$1;
  };
  Object.defineProperty(Vue2, "config", configDef);
  Vue2.util = {
    warn: warn$1,
    extend: extend$3,
    mergeOptions,
    defineReactive: defineReactive$$1
  };
  Vue2.set = set$2;
  Vue2.delete = del;
  Vue2.nextTick = nextTick$1;
  Vue2.observable = function(obj) {
    observe$1(obj);
    return obj;
  };
  Vue2.options = /* @__PURE__ */ Object.create(null);
  ASSET_TYPES.forEach(function(type) {
    Vue2.options[type + "s"] = /* @__PURE__ */ Object.create(null);
  });
  Vue2.options._base = Vue2;
  extend$3(Vue2.options.components, builtInComponents);
  initUse(Vue2);
  initMixin$1(Vue2);
  initExtend(Vue2);
  initAssetRegisters(Vue2);
}
initGlobalAPI(Vue$1);
Object.defineProperty(Vue$1.prototype, "$isServer", {
  get: isServerRendering
});
Object.defineProperty(Vue$1.prototype, "$ssrContext", {
  get: function get2() {
    return this.$vnode && this.$vnode.ssrContext;
  }
});
Object.defineProperty(Vue$1, "FunctionalRenderContext", {
  value: FunctionalRenderContext
});
Vue$1.version = "2.6.14";
var isReservedAttr = makeMap("style,class");
var acceptValue = makeMap("input,textarea,option,select,progress");
var mustUseProp = function(tag, type, attr) {
  return attr === "value" && acceptValue(tag) && type !== "button" || attr === "selected" && tag === "option" || attr === "checked" && tag === "input" || attr === "muted" && tag === "video";
};
var isEnumeratedAttr = makeMap("contenteditable,draggable,spellcheck");
var isValidContentEditableValue = makeMap("events,caret,typing,plaintext-only");
var convertEnumeratedValue = function(key, value) {
  return isFalsyAttrValue(value) || value === "false" ? "false" : key === "contenteditable" && isValidContentEditableValue(value) ? value : "true";
};
var isBooleanAttr = makeMap(
  "allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible"
);
var xlinkNS = "http://www.w3.org/1999/xlink";
var isXlink = function(name) {
  return name.charAt(5) === ":" && name.slice(0, 5) === "xlink";
};
var getXlinkProp = function(name) {
  return isXlink(name) ? name.slice(6, name.length) : "";
};
var isFalsyAttrValue = function(val) {
  return val == null || val === false;
};
function genClassForVnode(vnode) {
  var data = vnode.data;
  var parentNode2 = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode2 = parentNode2.parent)) {
    if (parentNode2 && parentNode2.data) {
      data = mergeClassData(data, parentNode2.data);
    }
  }
  return renderClass(data.staticClass, data.class);
}
function mergeClassData(child, parent2) {
  return {
    staticClass: concat$1(child.staticClass, parent2.staticClass),
    class: isDef(child.class) ? [child.class, parent2.class] : parent2.class
  };
}
function renderClass(staticClass, dynamicClass) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat$1(staticClass, stringifyClass(dynamicClass));
  }
  return "";
}
function concat$1(a, b) {
  return a ? b ? a + " " + b : a : b || "";
}
function stringifyClass(value) {
  if (Array.isArray(value)) {
    return stringifyArray(value);
  }
  if (isObject$e(value)) {
    return stringifyObject(value);
  }
  if (typeof value === "string") {
    return value;
  }
  return "";
}
function stringifyArray(value) {
  var res = "";
  var stringified;
  for (var i2 = 0, l = value.length; i2 < l; i2++) {
    if (isDef(stringified = stringifyClass(value[i2])) && stringified !== "") {
      if (res) {
        res += " ";
      }
      res += stringified;
    }
  }
  return res;
}
function stringifyObject(value) {
  var res = "";
  for (var key in value) {
    if (value[key]) {
      if (res) {
        res += " ";
      }
      res += key;
    }
  }
  return res;
}
var namespaceMap = {
  svg: "http://www.w3.org/2000/svg",
  math: "http://www.w3.org/1998/Math/MathML"
};
var isHTMLTag = makeMap(
  "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"
);
var isSVG = makeMap(
  "svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",
  true
);
var isReservedTag = function(tag) {
  return isHTMLTag(tag) || isSVG(tag);
};
function getTagNamespace(tag) {
  if (isSVG(tag)) {
    return "svg";
  }
  if (tag === "math") {
    return "math";
  }
}
var unknownElementCache = /* @__PURE__ */ Object.create(null);
function isUnknownElement(tag) {
  if (!inBrowser) {
    return true;
  }
  if (isReservedTag(tag)) {
    return false;
  }
  tag = tag.toLowerCase();
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag];
  }
  var el = document.createElement(tag);
  if (tag.indexOf("-") > -1) {
    return unknownElementCache[tag] = el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
  } else {
    return unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString());
  }
}
var isTextInputType = makeMap("text,number,password,search,email,tel,url");
function query(el) {
  if (typeof el === "string") {
    var selected = document.querySelector(el);
    if (!selected) {
      return document.createElement("div");
    }
    return selected;
  } else {
    return el;
  }
}
function createElement$1(tagName2, vnode) {
  var elm = document.createElement(tagName2);
  if (tagName2 !== "select") {
    return elm;
  }
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== void 0) {
    elm.setAttribute("multiple", "multiple");
  }
  return elm;
}
function createElementNS$1(namespace, tagName2) {
  return document.createElementNS(namespaceMap[namespace], tagName2);
}
function createTextNode(text2) {
  return document.createTextNode(text2);
}
function createComment(text2) {
  return document.createComment(text2);
}
function insertBefore(parentNode2, newNode, referenceNode) {
  parentNode2.insertBefore(newNode, referenceNode);
}
function removeChild(node2, child) {
  node2.removeChild(child);
}
function appendChild$1(node2, child) {
  node2.appendChild(child);
}
function parentNode(node2) {
  return node2.parentNode;
}
function nextSibling(node2) {
  return node2.nextSibling;
}
function tagName(node2) {
  return node2.tagName;
}
function setTextContent(node2, text2) {
  node2.textContent = text2;
}
function setStyleScope(node2, scopeId) {
  node2.setAttribute(scopeId, "");
}
var nodeOps = /* @__PURE__ */ Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS$1,
  createTextNode,
  createComment,
  insertBefore,
  removeChild,
  appendChild: appendChild$1,
  parentNode,
  nextSibling,
  tagName,
  setTextContent,
  setStyleScope
});
var ref$1 = {
  create: function create2(_, vnode) {
    registerRef(vnode);
  },
  update: function update2(oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy2(vnode) {
    registerRef(vnode, true);
  }
};
function registerRef(vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) {
    return;
  }
  var vm = vnode.context;
  var ref2 = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove$1(refs[key], ref2);
    } else if (refs[key] === ref2) {
      refs[key] = void 0;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref2];
      } else if (refs[key].indexOf(ref2) < 0) {
        refs[key].push(ref2);
      }
    } else {
      refs[key] = ref2;
    }
  }
}
var emptyNode = new VNode("", {}, []);
var hooks = ["create", "activate", "update", "remove", "destroy"];
function sameVnode(a, b) {
  return a.key === b.key && a.asyncFactory === b.asyncFactory && (a.tag === b.tag && a.isComment === b.isComment && isDef(a.data) === isDef(b.data) && sameInputType(a, b) || isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error));
}
function sameInputType(a, b) {
  if (a.tag !== "input") {
    return true;
  }
  var i2;
  var typeA = isDef(i2 = a.data) && isDef(i2 = i2.attrs) && i2.type;
  var typeB = isDef(i2 = b.data) && isDef(i2 = i2.attrs) && i2.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB);
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
  var i2, key;
  var map = {};
  for (i2 = beginIdx; i2 <= endIdx; ++i2) {
    key = children[i2].key;
    if (isDef(key)) {
      map[key] = i2;
    }
  }
  return map;
}
function createPatchFunction(backend) {
  var i2, j;
  var cbs = {};
  var modules2 = backend.modules;
  var nodeOps2 = backend.nodeOps;
  for (i2 = 0; i2 < hooks.length; ++i2) {
    cbs[hooks[i2]] = [];
    for (j = 0; j < modules2.length; ++j) {
      if (isDef(modules2[j][hooks[i2]])) {
        cbs[hooks[i2]].push(modules2[j][hooks[i2]]);
      }
    }
  }
  function emptyNodeAt(elm) {
    return new VNode(nodeOps2.tagName(elm).toLowerCase(), {}, [], void 0, elm);
  }
  function createRmCb(childElm, listeners) {
    function remove$$12() {
      if (--remove$$12.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$12.listeners = listeners;
    return remove$$12;
  }
  function removeNode(el) {
    var parent2 = nodeOps2.parentNode(el);
    if (isDef(parent2)) {
      nodeOps2.removeChild(parent2, el);
    }
  }
  function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index2) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      vnode = ownerArray[index2] = cloneVNode(vnode);
    }
    vnode.isRootInsert = !nested;
    if (createComponent2(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return;
    }
    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      vnode.elm = vnode.ns ? nodeOps2.createElementNS(vnode.ns, tag) : nodeOps2.createElement(tag, vnode);
      setScope(vnode);
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert2(parentElm, vnode.elm, refElm);
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps2.createComment(vnode.text);
      insert2(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps2.createTextNode(vnode.text);
      insert2(parentElm, vnode.elm, refElm);
    }
  }
  function createComponent2(vnode, insertedVnodeQueue, parentElm, refElm) {
    var i3 = vnode.data;
    if (isDef(i3)) {
      var isReactivated = isDef(vnode.componentInstance) && i3.keepAlive;
      if (isDef(i3 = i3.hook) && isDef(i3 = i3.init)) {
        i3(
          vnode,
          false
          /* hydrating */
        );
      }
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert2(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true;
      }
    }
  }
  function initComponent(vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      registerRef(vnode);
      insertedVnodeQueue.push(vnode);
    }
  }
  function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
    var i3;
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i3 = innerNode.data) && isDef(i3 = i3.transition)) {
        for (i3 = 0; i3 < cbs.activate.length; ++i3) {
          cbs.activate[i3](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break;
      }
    }
    insert2(parentElm, vnode.elm, refElm);
  }
  function insert2(parent2, elm, ref$$1) {
    if (isDef(parent2)) {
      if (isDef(ref$$1)) {
        if (nodeOps2.parentNode(ref$$1) === parent2) {
          nodeOps2.insertBefore(parent2, elm, ref$$1);
        }
      } else {
        nodeOps2.appendChild(parent2, elm);
      }
    }
  }
  function createChildren(vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      for (var i3 = 0; i3 < children.length; ++i3) {
        createElm(children[i3], insertedVnodeQueue, vnode.elm, null, true, children, i3);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps2.appendChild(vnode.elm, nodeOps2.createTextNode(String(vnode.text)));
    }
  }
  function isPatchable(vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag);
  }
  function invokeCreateHooks(vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i2 = vnode.data.hook;
    if (isDef(i2)) {
      if (isDef(i2.create)) {
        i2.create(emptyNode, vnode);
      }
      if (isDef(i2.insert)) {
        insertedVnodeQueue.push(vnode);
      }
    }
  }
  function setScope(vnode) {
    var i3;
    if (isDef(i3 = vnode.fnScopeId)) {
      nodeOps2.setStyleScope(vnode.elm, i3);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i3 = ancestor.context) && isDef(i3 = i3.$options._scopeId)) {
          nodeOps2.setStyleScope(vnode.elm, i3);
        }
        ancestor = ancestor.parent;
      }
    }
    if (isDef(i3 = activeInstance) && i3 !== vnode.context && i3 !== vnode.fnContext && isDef(i3 = i3.$options._scopeId)) {
      nodeOps2.setStyleScope(vnode.elm, i3);
    }
  }
  function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }
  function invokeDestroyHook(vnode) {
    var i3, j2;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i3 = data.hook) && isDef(i3 = i3.destroy)) {
        i3(vnode);
      }
      for (i3 = 0; i3 < cbs.destroy.length; ++i3) {
        cbs.destroy[i3](vnode);
      }
    }
    if (isDef(i3 = vnode.children)) {
      for (j2 = 0; j2 < vnode.children.length; ++j2) {
        invokeDestroyHook(vnode.children[j2]);
      }
    }
  }
  function removeVnodes(vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else {
          removeNode(ch.elm);
        }
      }
    }
  }
  function removeAndInvokeRemoveHook(vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i3;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        rm.listeners += listeners;
      } else {
        rm = createRmCb(vnode.elm, listeners);
      }
      if (isDef(i3 = vnode.componentInstance) && isDef(i3 = i3._vnode) && isDef(i3.data)) {
        removeAndInvokeRemoveHook(i3, rm);
      }
      for (i3 = 0; i3 < cbs.remove.length; ++i3) {
        cbs.remove[i3](vnode, rm);
      }
      if (isDef(i3 = vnode.data.hook) && isDef(i3 = i3.remove)) {
        i3(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }
  function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
    var canMove = !removeOnly;
    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx];
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) {
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps2.insertBefore(parentElm, oldStartVnode.elm, nodeOps2.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) {
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps2.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) {
          oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
        }
        idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) {
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = void 0;
            canMove && nodeOps2.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }
  function findIdxInOld(node2, oldCh, start, end) {
    for (var i3 = start; i3 < end; i3++) {
      var c = oldCh[i3];
      if (isDef(c) && sameVnode(node2, c)) {
        return i3;
      }
    }
  }
  function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index2, removeOnly) {
    if (oldVnode === vnode) {
      return;
    }
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      vnode = ownerArray[index2] = cloneVNode(vnode);
    }
    var elm = vnode.elm = oldVnode.elm;
    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return;
    }
    if (isTrue(vnode.isStatic) && isTrue(oldVnode.isStatic) && vnode.key === oldVnode.key && (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
      vnode.componentInstance = oldVnode.componentInstance;
      return;
    }
    var i3;
    var data = vnode.data;
    if (isDef(data) && isDef(i3 = data.hook) && isDef(i3 = i3.prepatch)) {
      i3(oldVnode, vnode);
    }
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i3 = 0; i3 < cbs.update.length; ++i3) {
        cbs.update[i3](oldVnode, vnode);
      }
      if (isDef(i3 = data.hook) && isDef(i3 = i3.update)) {
        i3(oldVnode, vnode);
      }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) {
          updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
        }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) {
          nodeOps2.setTextContent(elm, "");
        }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps2.setTextContent(elm, "");
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps2.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i3 = data.hook) && isDef(i3 = i3.postpatch)) {
        i3(oldVnode, vnode);
      }
    }
  }
  function invokeInsertHook(vnode, queue2, initial) {
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue2;
    } else {
      for (var i3 = 0; i3 < queue2.length; ++i3) {
        queue2[i3].data.hook.insert(queue2[i3]);
      }
    }
  }
  var isRenderedModule = makeMap("attrs,class,staticClass,staticStyle,key");
  function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
    var i3;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || data && data.pre;
    vnode.elm = elm;
    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true;
    }
    if (isDef(data)) {
      if (isDef(i3 = data.hook) && isDef(i3 = i3.init)) {
        i3(
          vnode,
          true
          /* hydrating */
        );
      }
      if (isDef(i3 = vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        return true;
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          if (isDef(i3 = data) && isDef(i3 = i3.domProps) && isDef(i3 = i3.innerHTML)) {
            if (i3 !== elm.innerHTML) {
              return false;
            }
          } else {
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break;
              }
              childNode = childNode.nextSibling;
            }
            if (!childrenMatch || childNode) {
              return false;
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break;
          }
        }
        if (!fullInvoke && data["class"]) {
          traverse$1(data["class"]);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true;
  }
  return function patch2(oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) {
        invokeDestroyHook(oldVnode);
      }
      return;
    }
    var isInitialPatch = false;
    var insertedVnodeQueue = [];
    if (isUndef(oldVnode)) {
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode;
            }
          }
          oldVnode = emptyNodeAt(oldVnode);
        }
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps2.parentNode(oldElm);
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps2.nextSibling(oldElm)
        );
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i3 = 0; i3 < cbs.destroy.length; ++i3) {
              cbs.destroy[i3](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              var insert3 = ancestor.data.hook.insert;
              if (insert3.merged) {
                for (var i$2 = 1; i$2 < insert3.fns.length; i$2++) {
                  insert3.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }
    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm;
  };
}
var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives(vnode) {
    updateDirectives(vnode, emptyNode);
  }
};
function updateDirectives(oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}
function _update(oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);
  var dirsWithInsert = [];
  var dirsWithPostpatch = [];
  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      callHook$1(dir, "bind", vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, "update", vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }
  if (dirsWithInsert.length) {
    var callInsert = function() {
      for (var i2 = 0; i2 < dirsWithInsert.length; i2++) {
        callHook$1(dirsWithInsert[i2], "inserted", vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, "insert", callInsert);
    } else {
      callInsert();
    }
  }
  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, "postpatch", function() {
      for (var i2 = 0; i2 < dirsWithPostpatch.length; i2++) {
        callHook$1(dirsWithPostpatch[i2], "componentUpdated", vnode, oldVnode);
      }
    });
  }
  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        callHook$1(oldDirs[key], "unbind", oldVnode, oldVnode, isDestroy);
      }
    }
  }
}
var emptyModifiers = /* @__PURE__ */ Object.create(null);
function normalizeDirectives$1(dirs, vm) {
  var res = /* @__PURE__ */ Object.create(null);
  if (!dirs) {
    return res;
  }
  var i2, dir;
  for (i2 = 0; i2 < dirs.length; i2++) {
    dir = dirs[i2];
    if (!dir.modifiers) {
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, "directives", dir.name);
  }
  return res;
}
function getRawDirName(dir) {
  return dir.rawName || dir.name + "." + Object.keys(dir.modifiers || {}).join(".");
}
function callHook$1(dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, "directive " + dir.name + " " + hook + " hook");
    }
  }
}
var baseModules = [
  ref$1,
  directives
];
function updateAttrs(oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return;
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return;
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs2 = vnode.data.attrs || {};
  if (isDef(attrs2.__ob__)) {
    attrs2 = vnode.data.attrs = extend$3({}, attrs2);
  }
  for (key in attrs2) {
    cur = attrs2[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur, vnode.data.pre);
    }
  }
  if ((isIE$1 || isEdge) && attrs2.value !== oldAttrs.value) {
    setAttr(elm, "value", attrs2.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs2[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}
function setAttr(el, key, value, isInPre) {
  if (isInPre || el.tagName.indexOf("-") > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      value = key === "allowfullscreen" && el.tagName === "EMBED" ? "true" : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}
function baseSetAttr(el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    if (isIE$1 && !isIE9 && el.tagName === "TEXTAREA" && key === "placeholder" && value !== "" && !el.__ieph) {
      var blocker = function(e) {
        e.stopImmediatePropagation();
        el.removeEventListener("input", blocker);
      };
      el.addEventListener("input", blocker);
      el.__ieph = true;
    }
    el.setAttribute(key, value);
  }
}
var attrs = {
  create: updateAttrs,
  update: updateAttrs
};
function updateClass(oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (isUndef(data.staticClass) && isUndef(data.class) && (isUndef(oldData) || isUndef(oldData.staticClass) && isUndef(oldData.class))) {
    return;
  }
  var cls = genClassForVnode(vnode);
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat$1(cls, stringifyClass(transitionClass));
  }
  if (cls !== el._prevClass) {
    el.setAttribute("class", cls);
    el._prevClass = cls;
  }
}
var klass = {
  create: updateClass,
  update: updateClass
};
var RANGE_TOKEN = "__r";
var CHECKBOX_RADIO_TOKEN = "__c";
function normalizeEvents(on2) {
  if (isDef(on2[RANGE_TOKEN])) {
    var event = isIE$1 ? "change" : "input";
    on2[event] = [].concat(on2[RANGE_TOKEN], on2[event] || []);
    delete on2[RANGE_TOKEN];
  }
  if (isDef(on2[CHECKBOX_RADIO_TOKEN])) {
    on2.change = [].concat(on2[CHECKBOX_RADIO_TOKEN], on2.change || []);
    delete on2[CHECKBOX_RADIO_TOKEN];
  }
}
var target$1;
function createOnceHandler$1(event, handler, capture) {
  var _target2 = target$1;
  return function onceHandler() {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target2);
    }
  };
}
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
function add$1(name, handler, capture, passive) {
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function(e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget || // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp || // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 || // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments);
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive$1 ? { capture, passive } : capture
  );
}
function remove$2(name, handler, capture, _target2) {
  (_target2 || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}
function updateDOMListeners(oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return;
  }
  var on2 = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on2);
  updateListeners(on2, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = void 0;
}
var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};
var svgContainer;
function updateDOMProps(oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return;
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props2 = vnode.data.domProps || {};
  if (isDef(props2.__ob__)) {
    props2 = vnode.data.domProps = extend$3({}, props2);
  }
  for (key in oldProps) {
    if (!(key in props2)) {
      elm[key] = "";
    }
  }
  for (key in props2) {
    cur = props2[key];
    if (key === "textContent" || key === "innerHTML") {
      if (vnode.children) {
        vnode.children.length = 0;
      }
      if (cur === oldProps[key]) {
        continue;
      }
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }
    if (key === "value" && elm.tagName !== "PROGRESS") {
      elm._value = cur;
      var strCur = isUndef(cur) ? "" : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === "innerHTML" && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      svgContainer = svgContainer || document.createElement("div");
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      try {
        elm[key] = cur;
      } catch (e) {
      }
    }
  }
}
function shouldUpdateValue(elm, checkVal) {
  return !elm.composing && (elm.tagName === "OPTION" || isNotInFocusAndDirty(elm, checkVal) || isDirtyWithModifiers(elm, checkVal));
}
function isNotInFocusAndDirty(elm, checkVal) {
  var notInFocus = true;
  try {
    notInFocus = document.activeElement !== elm;
  } catch (e) {
  }
  return notInFocus && elm.value !== checkVal;
}
function isDirtyWithModifiers(elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers;
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber$2(value) !== toNumber$2(newVal);
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim();
    }
  }
  return value !== newVal;
}
var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};
var parseStyleText = cached(function(cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function(item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res;
});
function normalizeStyleData(data) {
  var style2 = normalizeStyleBinding(data.style);
  return data.staticStyle ? extend$3(data.staticStyle, style2) : style2;
}
function normalizeStyleBinding(bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle);
  }
  if (typeof bindingStyle === "string") {
    return parseStyleText(bindingStyle);
  }
  return bindingStyle;
}
function getStyle(vnode, checkChild) {
  var res = {};
  var styleData;
  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (childNode && childNode.data && (styleData = normalizeStyleData(childNode.data))) {
        extend$3(res, styleData);
      }
    }
  }
  if (styleData = normalizeStyleData(vnode.data)) {
    extend$3(res, styleData);
  }
  var parentNode2 = vnode;
  while (parentNode2 = parentNode2.parent) {
    if (parentNode2.data && (styleData = normalizeStyleData(parentNode2.data))) {
      extend$3(res, styleData);
    }
  }
  return res;
}
var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function(el, name, val) {
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ""), "important");
  } else {
    var normalizedName = normalize$1(name);
    if (Array.isArray(val)) {
      for (var i2 = 0, len = val.length; i2 < len; i2++) {
        el.style[normalizedName] = val[i2];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};
var vendorNames = ["Webkit", "Moz", "ms"];
var emptyStyle;
var normalize$1 = cached(function(prop) {
  emptyStyle = emptyStyle || document.createElement("div").style;
  prop = camelize(prop);
  if (prop !== "filter" && prop in emptyStyle) {
    return prop;
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i2 = 0; i2 < vendorNames.length; i2++) {
    var name = vendorNames[i2] + capName;
    if (name in emptyStyle) {
      return name;
    }
  }
});
function updateStyle(oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (isUndef(data.staticStyle) && isUndef(data.style) && isUndef(oldData.staticStyle) && isUndef(oldData.style)) {
    return;
  }
  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
  var oldStyle = oldStaticStyle || oldStyleBinding;
  var style2 = normalizeStyleBinding(vnode.data.style) || {};
  vnode.data.normalizedStyle = isDef(style2.__ob__) ? extend$3({}, style2) : style2;
  var newStyle = getStyle(vnode, true);
  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, "");
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      setProp(el, name, cur == null ? "" : cur);
    }
  }
}
var style = {
  create: updateStyle,
  update: updateStyle
};
var whitespaceRE = /\s+/;
function addClass(el, cls) {
  if (!cls || !(cls = cls.trim())) {
    return;
  }
  if (el.classList) {
    if (cls.indexOf(" ") > -1) {
      cls.split(whitespaceRE).forEach(function(c) {
        return el.classList.add(c);
      });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute("class") || "") + " ";
    if (cur.indexOf(" " + cls + " ") < 0) {
      el.setAttribute("class", (cur + cls).trim());
    }
  }
}
function removeClass(el, cls) {
  if (!cls || !(cls = cls.trim())) {
    return;
  }
  if (el.classList) {
    if (cls.indexOf(" ") > -1) {
      cls.split(whitespaceRE).forEach(function(c) {
        return el.classList.remove(c);
      });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute("class");
    }
  } else {
    var cur = " " + (el.getAttribute("class") || "") + " ";
    var tar = " " + cls + " ";
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, " ");
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute("class", cur);
    } else {
      el.removeAttribute("class");
    }
  }
}
function resolveTransition(def$$1) {
  if (!def$$1) {
    return;
  }
  if (typeof def$$1 === "object") {
    var res = {};
    if (def$$1.css !== false) {
      extend$3(res, autoCssTransition(def$$1.name || "v"));
    }
    extend$3(res, def$$1);
    return res;
  } else if (typeof def$$1 === "string") {
    return autoCssTransition(def$$1);
  }
}
var autoCssTransition = cached(function(name) {
  return {
    enterClass: name + "-enter",
    enterToClass: name + "-enter-to",
    enterActiveClass: name + "-enter-active",
    leaveClass: name + "-leave",
    leaveToClass: name + "-leave-to",
    leaveActiveClass: name + "-leave-active"
  };
});
var hasTransition = inBrowser && !isIE9;
var TRANSITION = "transition";
var ANIMATION = "animation";
var transitionProp = "transition";
var transitionEndEvent = "transitionend";
var animationProp = "animation";
var animationEndEvent = "animationend";
if (hasTransition) {
  if (window.ontransitionend === void 0 && window.onwebkittransitionend !== void 0) {
    transitionProp = "WebkitTransition";
    transitionEndEvent = "webkitTransitionEnd";
  }
  if (window.onanimationend === void 0 && window.onwebkitanimationend !== void 0) {
    animationProp = "WebkitAnimation";
    animationEndEvent = "webkitAnimationEnd";
  }
}
var raf = inBrowser ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : (
  /* istanbul ignore next */
  function(fn) {
    return fn();
  }
);
function nextFrame(fn) {
  raf(function() {
    raf(fn);
  });
}
function addTransitionClass(el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}
function removeTransitionClass(el, cls) {
  if (el._transitionClasses) {
    remove$1(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}
function whenTransitionEnds(el, expectedType, cb) {
  var ref2 = getTransitionInfo(el, expectedType);
  var type = ref2.type;
  var timeout = ref2.timeout;
  var propCount = ref2.propCount;
  if (!type) {
    return cb();
  }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function() {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function(e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function() {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}
var transformRE = /\b(transform|all)(,|$)/;
function getTransitionInfo(el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = (styles[transitionProp + "Delay"] || "").split(", ");
  var transitionDurations = (styles[transitionProp + "Duration"] || "").split(", ");
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + "Delay"] || "").split(", ");
  var animationDurations = (styles[animationProp + "Duration"] || "").split(", ");
  var animationTimeout = getTimeout(animationDelays, animationDurations);
  var type;
  var timeout = 0;
  var propCount = 0;
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
    propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
  }
  var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + "Property"]);
  return {
    type,
    timeout,
    propCount,
    hasTransform
  };
}
function getTimeout(delays, durations) {
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }
  return Math.max.apply(null, durations.map(function(d2, i2) {
    return toMs(d2) + toMs(delays[i2]);
  }));
}
function toMs(s2) {
  return Number(s2.slice(0, -1).replace(",", ".")) * 1e3;
}
function enter(vnode, toggleDisplay) {
  var el = vnode.elm;
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }
  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return;
  }
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return;
  }
  var css2 = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter2 = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }
  var isAppear = !context._isMounted || !vnode.isRootInsert;
  if (isAppear && !appear && appear !== "") {
    return;
  }
  var startClass = isAppear && appearClass ? appearClass : enterClass;
  var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
  var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
  var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
  var enterHook = isAppear ? typeof appear === "function" ? appear : enter2 : enter2;
  var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
  var enterCancelledHook = isAppear ? appearCancelled || enterCancelled : enterCancelled;
  var explicitEnterDuration = toNumber$2(
    isObject$e(duration) ? duration.enter : duration
  );
  var expectsCSS = css2 !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);
  var cb = el._enterCb = once(function() {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });
  if (!vnode.data.show) {
    mergeVNodeHook(vnode, "insert", function() {
      var parent2 = el.parentNode;
      var pendingNode = parent2 && parent2._pending && parent2._pending[vnode.key];
      if (pendingNode && pendingNode.tag === vnode.tag && pendingNode.elm._leaveCb) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function() {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }
  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }
  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}
function leave(vnode, rm) {
  var el = vnode.elm;
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }
  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm();
  }
  if (isDef(el._leaveCb)) {
    return;
  }
  var css2 = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave2 = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;
  var expectsCSS = css2 !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave2);
  var explicitLeaveDuration = toNumber$2(
    isObject$e(duration) ? duration.leave : duration
  );
  var cb = el._leaveCb = once(function() {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });
  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }
  function performLeave() {
    if (cb.cancelled) {
      return;
    }
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function() {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave2 && leave2(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}
function isValidDuration(val) {
  return typeof val === "number" && !isNaN(val);
}
function getHookArgumentsLength(fn) {
  if (isUndef(fn)) {
    return false;
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    return getHookArgumentsLength(
      Array.isArray(invokerFns) ? invokerFns[0] : invokerFns
    );
  } else {
    return (fn._length || fn.length) > 1;
  }
}
function _enter(_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}
var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1(vnode, rm) {
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};
var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];
var modules = platformModules.concat(baseModules);
var patch = createPatchFunction({ nodeOps, modules });
if (isIE9) {
  document.addEventListener("selectionchange", function() {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, "input");
    }
  });
}
var directive = {
  inserted: function inserted(el, binding, vnode, oldVnode) {
    if (vnode.tag === "select") {
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, "postpatch", function() {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue$2);
    } else if (vnode.tag === "textarea" || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener("compositionstart", onCompositionStart);
        el.addEventListener("compositionend", onCompositionEnd);
        el.addEventListener("change", onCompositionEnd);
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },
  componentUpdated: function componentUpdated(el, binding, vnode) {
    if (vnode.tag === "select") {
      setSelected(el, binding, vnode.context);
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue$2);
      if (curOptions.some(function(o, i2) {
        return !looseEqual$1(o, prevOptions[i2]);
      })) {
        var needReset = el.multiple ? binding.value.some(function(v) {
          return hasNoMatchingOption(v, curOptions);
        }) : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, "change");
        }
      }
    }
  }
};
function setSelected(el, binding, vm) {
  actuallySetSelected(el, binding);
  if (isIE$1 || isEdge) {
    setTimeout(function() {
      actuallySetSelected(el, binding);
    }, 0);
  }
}
function actuallySetSelected(el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    return;
  }
  var selected, option2;
  for (var i2 = 0, l = el.options.length; i2 < l; i2++) {
    option2 = el.options[i2];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue$2(option2)) > -1;
      if (option2.selected !== selected) {
        option2.selected = selected;
      }
    } else {
      if (looseEqual$1(getValue$2(option2), value)) {
        if (el.selectedIndex !== i2) {
          el.selectedIndex = i2;
        }
        return;
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}
function hasNoMatchingOption(value, options) {
  return options.every(function(o) {
    return !looseEqual$1(o, value);
  });
}
function getValue$2(option2) {
  return "_value" in option2 ? option2._value : option2.value;
}
function onCompositionStart(e) {
  e.target.composing = true;
}
function onCompositionEnd(e) {
  if (!e.target.composing) {
    return;
  }
  e.target.composing = false;
  trigger(e.target, "input");
}
function trigger(el, type) {
  var e = document.createEvent("HTMLEvents");
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}
function locateNode(vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition) ? locateNode(vnode.componentInstance._vnode) : vnode;
}
var show = {
  bind: function bind2(el, ref2, vnode) {
    var value = ref2.value;
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay = el.style.display === "none" ? "" : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function() {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : "none";
    }
  },
  update: function update3(el, ref2, vnode) {
    var value = ref2.value;
    var oldValue = ref2.oldValue;
    if (!value === !oldValue) {
      return;
    }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function() {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function() {
          el.style.display = "none";
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : "none";
    }
  },
  unbind: function unbind(el, binding, vnode, oldVnode, isDestroy) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};
var platformDirectives = {
  model: directive,
  show
};
var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};
function getRealChild(vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children));
  } else {
    return vnode;
  }
}
function extractTransitionData(comp) {
  var data = {};
  var options = comp.$options;
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data;
}
function placeholder(h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h("keep-alive", {
      props: rawChild.componentOptions.propsData
    });
  }
}
function hasParentTransition(vnode) {
  while (vnode = vnode.parent) {
    if (vnode.data.transition) {
      return true;
    }
  }
}
function isSameChild(child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag;
}
var isNotTextNode = function(c) {
  return c.tag || isAsyncPlaceholder(c);
};
var isVShowDirective = function(d2) {
  return d2.name === "show";
};
var Transition = {
  name: "transition",
  props: transitionProps,
  abstract: true,
  render: function render2(h) {
    var this$1$1 = this;
    var children = this.$slots.default;
    if (!children) {
      return;
    }
    children = children.filter(isNotTextNode);
    if (!children.length) {
      return;
    }
    var mode = this.mode;
    var rawChild = children[0];
    if (hasParentTransition(this.$vnode)) {
      return rawChild;
    }
    var child = getRealChild(rawChild);
    if (!child) {
      return rawChild;
    }
    if (this._leaving) {
      return placeholder(h, rawChild);
    }
    var id = "__transition-" + this._uid + "-";
    child.key = child.key == null ? child.isComment ? id + "comment" : id + child.tag : isPrimitive(child.key) ? String(child.key).indexOf(id) === 0 ? child.key : id + child.key : child.key;
    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }
    if (oldChild && oldChild.data && !isSameChild(child, oldChild) && !isAsyncPlaceholder(oldChild) && // #6687 component root is a comment node
    !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)) {
      var oldData = oldChild.data.transition = extend$3({}, data);
      if (mode === "out-in") {
        this._leaving = true;
        mergeVNodeHook(oldData, "afterLeave", function() {
          this$1$1._leaving = false;
          this$1$1.$forceUpdate();
        });
        return placeholder(h, rawChild);
      } else if (mode === "in-out") {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild;
        }
        var delayedLeave;
        var performLeave = function() {
          delayedLeave();
        };
        mergeVNodeHook(data, "afterEnter", performLeave);
        mergeVNodeHook(data, "enterCancelled", performLeave);
        mergeVNodeHook(oldData, "delayLeave", function(leave2) {
          delayedLeave = leave2;
        });
      }
    }
    return rawChild;
  }
};
var props$1 = extend$3({
  tag: String,
  moveClass: String
}, transitionProps);
delete props$1.mode;
var TransitionGroup = {
  props: props$1,
  beforeMount: function beforeMount() {
    var this$1$1 = this;
    var update5 = this._update;
    this._update = function(vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1$1);
      this$1$1.__patch__(
        this$1$1._vnode,
        this$1$1.kept,
        false,
        // hydrating
        true
        // removeOnly (!important, avoids unnecessary moves)
      );
      this$1$1._vnode = this$1$1.kept;
      restoreActiveInstance();
      update5.call(this$1$1, vnode, hydrating);
    };
  },
  render: function render3(h) {
    var tag = this.tag || this.$vnode.data.tag || "span";
    var map = /* @__PURE__ */ Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);
    for (var i2 = 0; i2 < rawChildren.length; i2++) {
      var c = rawChildren[i2];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf("__vlist") !== 0) {
          children.push(c);
          map[c.key] = c;
          (c.data || (c.data = {})).transition = transitionData;
        }
      }
    }
    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }
    return h(tag, null, children);
  },
  updated: function updated2() {
    var children = this.prevChildren;
    var moveClass = this.moveClass || (this.name || "v") + "-move";
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return;
    }
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);
    this._reflow = document.body.offsetHeight;
    children.forEach(function(c) {
      if (c.data.moved) {
        var el = c.elm;
        var s2 = el.style;
        addTransitionClass(el, moveClass);
        s2.transform = s2.WebkitTransform = s2.transitionDuration = "";
        el.addEventListener(transitionEndEvent, el._moveCb = function cb(e) {
          if (e && e.target !== el) {
            return;
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },
  methods: {
    hasMove: function hasMove(el, moveClass) {
      if (!hasTransition) {
        return false;
      }
      if (this._hasMove) {
        return this._hasMove;
      }
      var clone2 = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function(cls) {
          removeClass(clone2, cls);
        });
      }
      addClass(clone2, moveClass);
      clone2.style.display = "none";
      this.$el.appendChild(clone2);
      var info = getTransitionInfo(clone2);
      this.$el.removeChild(clone2);
      return this._hasMove = info.hasTransform;
    }
  }
};
function callPendingCbs(c) {
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}
function recordPosition(c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}
function applyTranslation(c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s2 = c.elm.style;
    s2.transform = s2.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s2.transitionDuration = "0s";
  }
}
var platformComponents = {
  Transition,
  TransitionGroup
};
Vue$1.config.mustUseProp = mustUseProp;
Vue$1.config.isReservedTag = isReservedTag;
Vue$1.config.isReservedAttr = isReservedAttr;
Vue$1.config.getTagNamespace = getTagNamespace;
Vue$1.config.isUnknownElement = isUnknownElement;
extend$3(Vue$1.options.directives, platformDirectives);
extend$3(Vue$1.options.components, platformComponents);
Vue$1.prototype.__patch__ = inBrowser ? patch : noop$3;
Vue$1.prototype.$mount = function(el, hydrating) {
  el = el && inBrowser ? query(el) : void 0;
  return mountComponent(this, el, hydrating);
};
if (inBrowser) {
  setTimeout(function() {
    if (config$1.devtools) {
      if (devtools) {
        devtools.emit("init", Vue$1);
      }
    }
  }, 0);
}
const vue_runtime_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vue$1
}, Symbol.toStringTag, { value: "Module" }));
var extendStatics = function(d2, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b2) {
    d3.__proto__ = b2;
  } || function(d3, b2) {
    for (var p in b2)
      if (Object.prototype.hasOwnProperty.call(b2, p))
        d3[p] = b2[p];
  };
  return extendStatics(d2, b);
};
function __extends$3(d2, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d2, b);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign$2 = function() {
  __assign$2 = Object.assign || function __assign2(t3) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p))
          t3[p] = s2[p];
    }
    return t3;
  };
  return __assign$2.apply(this, arguments);
};
function __values(o) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m = s2 && o[s2], i2 = 0;
  if (m)
    return m.call(o);
  if (o && typeof o.length === "number")
    return {
      next: function() {
        if (o && i2 >= o.length)
          o = void 0;
        return { value: o && o[i2++], done: !o };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n2) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i2 = m.call(o), r, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done)
      ar.push(r.value);
  } catch (error2) {
    e = { error: error2 };
  } finally {
    try {
      if (r && !r.done && (m = i2["return"]))
        m.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var activeEffectScope;
var effectScopeStack = [];
var EffectScopeImpl = (
  /** @class */
  function() {
    function EffectScopeImpl2(vm) {
      this.active = true;
      this.effects = [];
      this.cleanups = [];
      this.vm = vm;
    }
    EffectScopeImpl2.prototype.run = function(fn) {
      if (this.active) {
        try {
          this.on();
          return fn();
        } finally {
          this.off();
        }
      }
      return;
    };
    EffectScopeImpl2.prototype.on = function() {
      if (this.active) {
        effectScopeStack.push(this);
        activeEffectScope = this;
      }
    };
    EffectScopeImpl2.prototype.off = function() {
      if (this.active) {
        effectScopeStack.pop();
        activeEffectScope = effectScopeStack[effectScopeStack.length - 1];
      }
    };
    EffectScopeImpl2.prototype.stop = function() {
      if (this.active) {
        this.vm.$destroy();
        this.effects.forEach(function(e) {
          return e.stop();
        });
        this.cleanups.forEach(function(cleanup) {
          return cleanup();
        });
        this.active = false;
      }
    };
    return EffectScopeImpl2;
  }()
);
var EffectScope = (
  /** @class */
  function(_super) {
    __extends$3(EffectScope2, _super);
    function EffectScope2(detached) {
      if (detached === void 0) {
        detached = false;
      }
      var _this2 = this;
      var vm = void 0;
      withCurrentInstanceTrackingDisabled(function() {
        vm = defineComponentInstance(getVueConstructor());
      });
      _this2 = _super.call(this, vm) || this;
      if (!detached) {
        recordEffectScope(_this2);
      }
      return _this2;
    }
    return EffectScope2;
  }(EffectScopeImpl)
);
function recordEffectScope(effect, scope) {
  var _a2;
  scope = scope || activeEffectScope;
  if (scope && scope.active) {
    scope.effects.push(effect);
    return;
  }
  var vm = (_a2 = getCurrentInstance()) === null || _a2 === void 0 ? void 0 : _a2.proxy;
  vm && vm.$on("hook:destroyed", function() {
    return effect.stop();
  });
}
function effectScope(detached) {
  return new EffectScope(detached);
}
function getCurrentScope() {
  return activeEffectScope;
}
function onScopeDispose(fn) {
  if (activeEffectScope) {
    activeEffectScope.cleanups.push(fn);
  }
}
function getCurrentScopeVM() {
  var _a2, _b2;
  return ((_a2 = getCurrentScope()) === null || _a2 === void 0 ? void 0 : _a2.vm) || ((_b2 = getCurrentInstance()) === null || _b2 === void 0 ? void 0 : _b2.proxy);
}
function bindCurrentScopeToVM(vm) {
  if (!vm.scope) {
    var scope_1 = new EffectScopeImpl(vm.proxy);
    vm.scope = scope_1;
    vm.proxy.$on("hook:destroyed", function() {
      return scope_1.stop();
    });
  }
  return vm.scope;
}
var vueDependency = void 0;
try {
  var requiredVue = require("vue");
  if (requiredVue && isVue(requiredVue)) {
    vueDependency = requiredVue;
  } else if (requiredVue && "default" in requiredVue && isVue(requiredVue.default)) {
    vueDependency = requiredVue.default;
  }
} catch (_a2) {
}
var vueConstructor = null;
var currentInstance = null;
var currentInstanceTracking = true;
var PluginInstalledFlag = "__composition_api_installed__";
function isVue(obj) {
  return obj && isFunction$5(obj) && obj.name === "Vue";
}
function isVueRegistered(Vue2) {
  return vueConstructor && hasOwn$1(Vue2, PluginInstalledFlag);
}
function getVueConstructor() {
  return vueConstructor;
}
function getRegisteredVueOrDefault() {
  var constructor = vueConstructor || vueDependency;
  return constructor;
}
function setVueConstructor(Vue2) {
  vueConstructor = Vue2;
  Object.defineProperty(Vue2, PluginInstalledFlag, {
    configurable: true,
    writable: true,
    value: true
  });
}
function withCurrentInstanceTrackingDisabled(fn) {
  var prev = currentInstanceTracking;
  currentInstanceTracking = false;
  try {
    fn();
  } finally {
    currentInstanceTracking = prev;
  }
}
function setCurrentInstance(instance) {
  if (!currentInstanceTracking)
    return;
  var prev = currentInstance;
  prev === null || prev === void 0 ? void 0 : prev.scope.off();
  currentInstance = instance;
  currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.scope.on();
}
function getCurrentInstance() {
  return currentInstance;
}
var instanceMapCache = /* @__PURE__ */ new WeakMap();
function toVue3ComponentInstance(vm) {
  if (instanceMapCache.has(vm)) {
    return instanceMapCache.get(vm);
  }
  var instance = {
    proxy: vm,
    update: vm.$forceUpdate,
    type: vm.$options,
    uid: vm._uid,
    // $emit is defined on prototype and it expected to be bound
    emit: vm.$emit.bind(vm),
    parent: null,
    root: null
    // to be immediately set
  };
  bindCurrentScopeToVM(instance);
  var instanceProps = [
    "data",
    "props",
    "attrs",
    "refs",
    "vnode",
    "slots"
  ];
  instanceProps.forEach(function(prop) {
    proxy(instance, prop, {
      get: function() {
        return vm["$".concat(prop)];
      }
    });
  });
  proxy(instance, "isMounted", {
    get: function() {
      return vm._isMounted;
    }
  });
  proxy(instance, "isUnmounted", {
    get: function() {
      return vm._isDestroyed;
    }
  });
  proxy(instance, "isDeactivated", {
    get: function() {
      return vm._inactive;
    }
  });
  proxy(instance, "emitted", {
    get: function() {
      return vm._events;
    }
  });
  instanceMapCache.set(vm, instance);
  if (vm.$parent) {
    instance.parent = toVue3ComponentInstance(vm.$parent);
  }
  if (vm.$root) {
    instance.root = toVue3ComponentInstance(vm.$root);
  }
  return instance;
}
var toString$3 = function(x2) {
  return Object.prototype.toString.call(x2);
};
function isNative(Ctor) {
  return typeof Ctor === "function" && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== "undefined" && isNative(Symbol) && typeof Reflect !== "undefined" && isNative(Reflect.ownKeys);
var noopFn = function(_) {
  return _;
};
function proxy(target2, key, _a2) {
  var get5 = _a2.get, set2 = _a2.set;
  Object.defineProperty(target2, key, {
    enumerable: true,
    configurable: true,
    get: get5 || noopFn,
    set: set2 || noopFn
  });
}
function def(obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}
function hasOwn$1(obj, key) {
  return Object.hasOwnProperty.call(obj, key);
}
function assert$1(condition, msg) {
  if (!condition) {
    throw new Error("[vue-composition-api] ".concat(msg));
  }
}
function isArray$e(x2) {
  return Array.isArray(x2);
}
var objectToString$2 = Object.prototype.toString;
var toTypeString = function(value) {
  return objectToString$2.call(value);
};
var isMap$2 = function(val) {
  return toTypeString(val) === "[object Map]";
};
var isSet$2 = function(val) {
  return toTypeString(val) === "[object Set]";
};
var MAX_VALID_ARRAY_LENGTH = 4294967295;
function isValidArrayIndex(val) {
  var n2 = parseFloat(String(val));
  return n2 >= 0 && Math.floor(n2) === n2 && isFinite(val) && n2 <= MAX_VALID_ARRAY_LENGTH;
}
function isObject$d(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject$8(x2) {
  return toString$3(x2) === "[object Object]";
}
function isFunction$5(x2) {
  return typeof x2 === "function";
}
function logError(err2, vm, info) {
  if (typeof window !== "undefined" && typeof console !== "undefined") {
    console.error(err2);
  } else {
    throw err2;
  }
}
function isSame(value1, value2) {
  if (value1 === value2) {
    return value1 !== 0 || 1 / value1 === 1 / value2;
  } else {
    return value1 !== value1 && value2 !== value2;
  }
}
function defineComponentInstance(Ctor, options) {
  if (options === void 0) {
    options = {};
  }
  var silent = Ctor.config.silent;
  Ctor.config.silent = true;
  var vm = new Ctor(options);
  Ctor.config.silent = silent;
  return vm;
}
function isComponentInstance(obj) {
  var Vue2 = getVueConstructor();
  return Vue2 && obj instanceof Vue2;
}
function createSlotProxy(vm, slotName) {
  return function() {
    var args = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      args[_i2] = arguments[_i2];
    }
    if (!vm.$scopedSlots[slotName]) {
      return;
    }
    return vm.$scopedSlots[slotName].apply(vm, args);
  };
}
function resolveSlots(slots, normalSlots) {
  var res;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    return slots._normalized;
  } else {
    res = {};
    for (var key in slots) {
      if (slots[key] && key[0] !== "$") {
        res[key] = true;
      }
    }
  }
  for (var key in normalSlots) {
    if (!(key in res)) {
      res[key] = true;
    }
  }
  return res;
}
var vueInternalClasses;
var getVueInternalClasses = function() {
  if (!vueInternalClasses) {
    var vm = defineComponentInstance(getVueConstructor(), {
      computed: {
        value: function() {
          return 0;
        }
      }
    });
    var Watcher3 = vm._computedWatchers.value.constructor;
    var Dep3 = vm._data.__ob__.dep.constructor;
    vueInternalClasses = {
      Watcher: Watcher3,
      Dep: Dep3
    };
    vm.$destroy();
  }
  return vueInternalClasses;
};
function createSymbol(name) {
  return hasSymbol ? Symbol.for(name) : name;
}
var WatcherPreFlushQueueKey = createSymbol("composition-api.preFlushQueue");
var WatcherPostFlushQueueKey = createSymbol("composition-api.postFlushQueue");
var RefKey = "composition-api.refKey";
var accessModifiedSet = /* @__PURE__ */ new WeakMap();
var rawSet = /* @__PURE__ */ new WeakMap();
var readonlySet = /* @__PURE__ */ new WeakMap();
function set$1(target2, key, val) {
  var Vue2 = getVueConstructor();
  var _a2 = Vue2.util;
  _a2.warn;
  var defineReactive = _a2.defineReactive;
  var ob = target2.__ob__;
  function ssrMockReactivity() {
    if (ob && isObject$d(val) && !hasOwn$1(val, "__ob__")) {
      mockReactivityDeep(val);
    }
  }
  if (isArray$e(target2)) {
    if (isValidArrayIndex(key)) {
      target2.length = Math.max(target2.length, key);
      target2.splice(key, 1, val);
      ssrMockReactivity();
      return val;
    } else if (key === "length" && val !== target2.length) {
      target2.length = val;
      ob === null || ob === void 0 ? void 0 : ob.dep.notify();
      return val;
    }
  }
  if (key in target2 && !(key in Object.prototype)) {
    target2[key] = val;
    ssrMockReactivity();
    return val;
  }
  if (target2._isVue || ob && ob.vmCount) {
    return val;
  }
  if (!ob) {
    target2[key] = val;
    return val;
  }
  defineReactive(ob.value, key, val);
  defineAccessControl(target2, key, val);
  ssrMockReactivity();
  ob.dep.notify();
  return val;
}
var RefImpl = (
  /** @class */
  function() {
    function RefImpl2(_a2) {
      var get5 = _a2.get, set2 = _a2.set;
      proxy(this, "value", {
        get: get5,
        set: set2
      });
    }
    return RefImpl2;
  }()
);
function createRef(options, isReadonly, isComputed2) {
  if (isReadonly === void 0) {
    isReadonly = false;
  }
  if (isComputed2 === void 0) {
    isComputed2 = false;
  }
  var r = new RefImpl(options);
  if (isComputed2)
    r.effect = true;
  var sealed = Object.seal(r);
  if (isReadonly)
    readonlySet.set(sealed, true);
  return sealed;
}
function ref(raw) {
  var _a2;
  if (isRef(raw)) {
    return raw;
  }
  var value = reactive((_a2 = {}, _a2[RefKey] = raw, _a2));
  return createRef({
    get: function() {
      return value[RefKey];
    },
    set: function(v) {
      return value[RefKey] = v;
    }
  });
}
function isRef(value) {
  return value instanceof RefImpl;
}
function unref(ref2) {
  return isRef(ref2) ? ref2.value : ref2;
}
function toRefs(obj) {
  if (!isPlainObject$8(obj))
    return obj;
  var ret = {};
  for (var key in obj) {
    ret[key] = toRef(obj, key);
  }
  return ret;
}
function toRef(object, key) {
  if (!(key in object))
    set$1(object, key, void 0);
  var v = object[key];
  if (isRef(v))
    return v;
  return createRef({
    get: function() {
      return object[key];
    },
    set: function(v2) {
      return object[key] = v2;
    }
  });
}
var SKIPFLAG = "__v_skip";
function isRaw(obj) {
  var _a2;
  return Boolean(obj && hasOwn$1(obj, "__ob__") && typeof obj.__ob__ === "object" && ((_a2 = obj.__ob__) === null || _a2 === void 0 ? void 0 : _a2[SKIPFLAG]));
}
function isReactive(obj) {
  var _a2;
  return Boolean(obj && hasOwn$1(obj, "__ob__") && typeof obj.__ob__ === "object" && !((_a2 = obj.__ob__) === null || _a2 === void 0 ? void 0 : _a2[SKIPFLAG]));
}
function setupAccessControl(target2) {
  if (!isPlainObject$8(target2) || isRaw(target2) || isArray$e(target2) || isRef(target2) || isComponentInstance(target2) || accessModifiedSet.has(target2))
    return;
  accessModifiedSet.set(target2, true);
  var keys2 = Object.keys(target2);
  for (var i2 = 0; i2 < keys2.length; i2++) {
    defineAccessControl(target2, keys2[i2]);
  }
}
function defineAccessControl(target2, key, val) {
  if (key === "__ob__")
    return;
  if (isRaw(target2[key]))
    return;
  var getter;
  var setter;
  var property2 = Object.getOwnPropertyDescriptor(target2, key);
  if (property2) {
    if (property2.configurable === false) {
      return;
    }
    getter = property2.get;
    setter = property2.set;
    if ((!getter || setter) && arguments.length === 2) {
      val = target2[key];
    }
  }
  setupAccessControl(val);
  proxy(target2, key, {
    get: function getterHandler() {
      var value = getter ? getter.call(target2) : val;
      if (key !== RefKey && isRef(value)) {
        return value.value;
      } else {
        return value;
      }
    },
    set: function setterHandler(newVal) {
      if (getter && !setter)
        return;
      if (key !== RefKey && isRef(val) && !isRef(newVal)) {
        val.value = newVal;
      } else if (setter) {
        setter.call(target2, newVal);
        val = newVal;
      } else {
        val = newVal;
      }
      setupAccessControl(newVal);
    }
  });
}
function observe(obj) {
  var Vue2 = getRegisteredVueOrDefault();
  var observed;
  if (Vue2.observable) {
    observed = Vue2.observable(obj);
  } else {
    var vm = defineComponentInstance(Vue2, {
      data: {
        $$state: obj
      }
    });
    observed = vm._data.$$state;
  }
  if (!hasOwn$1(observed, "__ob__")) {
    mockReactivityDeep(observed);
  }
  return observed;
}
function mockReactivityDeep(obj, seen) {
  var e_1, _a2;
  if (seen === void 0) {
    seen = /* @__PURE__ */ new Set();
  }
  if (seen.has(obj) || hasOwn$1(obj, "__ob__") || !Object.isExtensible(obj))
    return;
  def(obj, "__ob__", mockObserver(obj));
  seen.add(obj);
  try {
    for (var _b2 = __values(Object.keys(obj)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var key = _c.value;
      var value = obj[key];
      if (!(isPlainObject$8(value) || isArray$e(value)) || isRaw(value) || !Object.isExtensible(value)) {
        continue;
      }
      mockReactivityDeep(value, seen);
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
}
function mockObserver(value) {
  if (value === void 0) {
    value = {};
  }
  return {
    value,
    dep: {
      notify: noopFn,
      depend: noopFn,
      addSub: noopFn,
      removeSub: noopFn
    }
  };
}
function createObserver() {
  return observe({}).__ob__;
}
function reactive(obj) {
  if (!isObject$d(obj)) {
    return obj;
  }
  if (!(isPlainObject$8(obj) || isArray$e(obj)) || isRaw(obj) || !Object.isExtensible(obj)) {
    return obj;
  }
  var observed = observe(obj);
  setupAccessControl(observed);
  return observed;
}
function markRaw(obj) {
  if (!(isPlainObject$8(obj) || isArray$e(obj)) || !Object.isExtensible(obj)) {
    return obj;
  }
  var ob = createObserver();
  ob[SKIPFLAG] = true;
  def(obj, "__ob__", ob);
  rawSet.set(obj, true);
  return obj;
}
function toRaw(observed) {
  var _a2;
  if (isRaw(observed) || !Object.isExtensible(observed)) {
    return observed;
  }
  return ((_a2 = observed === null || observed === void 0 ? void 0 : observed.__ob__) === null || _a2 === void 0 ? void 0 : _a2.value) || observed;
}
var fallbackVM;
function flushPreQueue() {
  flushQueue(this, WatcherPreFlushQueueKey);
}
function flushPostQueue() {
  flushQueue(this, WatcherPostFlushQueueKey);
}
function hasWatchEnv(vm) {
  return vm[WatcherPreFlushQueueKey] !== void 0;
}
function installWatchEnv(vm) {
  vm[WatcherPreFlushQueueKey] = [];
  vm[WatcherPostFlushQueueKey] = [];
  vm.$on("hook:beforeUpdate", flushPreQueue);
  vm.$on("hook:updated", flushPostQueue);
}
function getWatcherOption(options) {
  return __assign$2({
    immediate: false,
    deep: false,
    flush: "pre"
  }, options);
}
function getWatcherVM() {
  var vm = getCurrentScopeVM();
  if (!vm) {
    if (!fallbackVM) {
      fallbackVM = defineComponentInstance(getVueConstructor());
    }
    vm = fallbackVM;
  } else if (!hasWatchEnv(vm)) {
    installWatchEnv(vm);
  }
  return vm;
}
function flushQueue(vm, key) {
  var queue2 = vm[key];
  for (var index2 = 0; index2 < queue2.length; index2++) {
    queue2[index2]();
  }
  queue2.length = 0;
}
function queueFlushJob(vm, fn, mode) {
  var fallbackFlush = function() {
    vm.$nextTick(function() {
      if (vm[WatcherPreFlushQueueKey].length) {
        flushQueue(vm, WatcherPreFlushQueueKey);
      }
      if (vm[WatcherPostFlushQueueKey].length) {
        flushQueue(vm, WatcherPostFlushQueueKey);
      }
    });
  };
  switch (mode) {
    case "pre":
      fallbackFlush();
      vm[WatcherPreFlushQueueKey].push(fn);
      break;
    case "post":
      fallbackFlush();
      vm[WatcherPostFlushQueueKey].push(fn);
      break;
    default:
      assert$1(false, 'flush must be one of ["post", "pre", "sync"], but got '.concat(mode));
      break;
  }
}
function createVueWatcher(vm, getter, callback, options) {
  var index2 = vm._watchers.length;
  vm.$watch(getter, callback, {
    immediate: options.immediateInvokeCallback,
    deep: options.deep,
    lazy: options.noRun,
    sync: options.sync,
    before: options.before
  });
  return vm._watchers[index2];
}
function patchWatcherTeardown(watcher, runCleanup) {
  var _teardown = watcher.teardown;
  watcher.teardown = function() {
    var args = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      args[_i2] = arguments[_i2];
    }
    _teardown.apply(watcher, args);
    runCleanup();
  };
}
function createWatcher(vm, source, cb, options) {
  var _a2;
  var flushMode = options.flush;
  var isSync = flushMode === "sync";
  var cleanup;
  var registerCleanup = function(fn) {
    cleanup = function() {
      try {
        fn();
      } catch (error2) {
        logError(error2);
      }
    };
  };
  var runCleanup = function() {
    if (cleanup) {
      cleanup();
      cleanup = null;
    }
  };
  var createScheduler = function(fn) {
    if (isSync || /* without a current active instance, ignore pre|post mode */
    vm === fallbackVM) {
      return fn;
    }
    return function() {
      var args = [];
      for (var _i2 = 0; _i2 < arguments.length; _i2++) {
        args[_i2] = arguments[_i2];
      }
      return queueFlushJob(vm, function() {
        fn.apply(void 0, __spreadArray([], __read(args), false));
      }, flushMode);
    };
  };
  if (cb === null) {
    var running_1 = false;
    var getter_1 = function() {
      if (running_1) {
        return;
      }
      try {
        running_1 = true;
        source(registerCleanup);
      } finally {
        running_1 = false;
      }
    };
    var watcher_1 = createVueWatcher(vm, getter_1, noopFn, {
      deep: options.deep || false,
      sync: isSync,
      before: runCleanup
    });
    patchWatcherTeardown(watcher_1, runCleanup);
    watcher_1.lazy = false;
    var originGet = watcher_1.get.bind(watcher_1);
    watcher_1.get = createScheduler(originGet);
    return function() {
      watcher_1.teardown();
    };
  }
  var deep = options.deep;
  var isMultiSource = false;
  var getter;
  if (isRef(source)) {
    getter = function() {
      return source.value;
    };
  } else if (isReactive(source)) {
    getter = function() {
      return source;
    };
    deep = true;
  } else if (isArray$e(source)) {
    isMultiSource = true;
    getter = function() {
      return source.map(function(s2) {
        if (isRef(s2)) {
          return s2.value;
        } else if (isReactive(s2)) {
          return traverse(s2);
        } else if (isFunction$5(s2)) {
          return s2();
        } else {
          return noopFn;
        }
      });
    };
  } else if (isFunction$5(source)) {
    getter = source;
  } else {
    getter = noopFn;
  }
  if (deep) {
    var baseGetter_1 = getter;
    getter = function() {
      return traverse(baseGetter_1());
    };
  }
  var applyCb = function(n2, o) {
    if (!deep && isMultiSource && n2.every(function(v, i2) {
      return isSame(v, o[i2]);
    }))
      return;
    runCleanup();
    return cb(n2, o, registerCleanup);
  };
  var callback = createScheduler(applyCb);
  if (options.immediate) {
    var originalCallback_1 = callback;
    var shiftCallback_1 = function(n2, o) {
      shiftCallback_1 = originalCallback_1;
      return applyCb(n2, isArray$e(n2) ? [] : o);
    };
    callback = function(n2, o) {
      return shiftCallback_1(n2, o);
    };
  }
  var stop = vm.$watch(getter, callback, {
    immediate: options.immediate,
    deep,
    sync: isSync
  });
  var watcher = vm._watchers[vm._watchers.length - 1];
  if (isReactive(watcher.value) && ((_a2 = watcher.value.__ob__) === null || _a2 === void 0 ? void 0 : _a2.dep) && deep) {
    watcher.value.__ob__.dep.addSub({
      update: function() {
        watcher.run();
      }
    });
  }
  patchWatcherTeardown(watcher, runCleanup);
  return function() {
    stop();
  };
}
function watch(source, cb, options) {
  var callback = null;
  if (isFunction$5(cb)) {
    callback = cb;
  } else {
    options = cb;
    callback = null;
  }
  var opts = getWatcherOption(options);
  var vm = getWatcherVM();
  return createWatcher(vm, source, callback, opts);
}
function traverse(value, seen) {
  if (seen === void 0) {
    seen = /* @__PURE__ */ new Set();
  }
  if (!isObject$d(value) || seen.has(value) || rawSet.has(value)) {
    return value;
  }
  seen.add(value);
  if (isRef(value)) {
    traverse(value.value, seen);
  } else if (isArray$e(value)) {
    for (var i2 = 0; i2 < value.length; i2++) {
      traverse(value[i2], seen);
    }
  } else if (isSet$2(value) || isMap$2(value)) {
    value.forEach(function(v) {
      traverse(v, seen);
    });
  } else if (isPlainObject$8(value)) {
    for (var key in value) {
      traverse(value[key], seen);
    }
  }
  return value;
}
function computed(getterOrOptions) {
  var vm = getCurrentScopeVM();
  var getter;
  var setter;
  if (isFunction$5(getterOrOptions)) {
    getter = getterOrOptions;
  } else {
    getter = getterOrOptions.get;
    setter = getterOrOptions.set;
  }
  var computedSetter;
  var computedGetter;
  if (vm && !vm.$isServer) {
    var _a2 = getVueInternalClasses(), Watcher_1 = _a2.Watcher, Dep_1 = _a2.Dep;
    var watcher_1;
    computedGetter = function() {
      if (!watcher_1) {
        watcher_1 = new Watcher_1(vm, getter, noopFn, { lazy: true });
      }
      if (watcher_1.dirty) {
        watcher_1.evaluate();
      }
      if (Dep_1.target) {
        watcher_1.depend();
      }
      return watcher_1.value;
    };
    computedSetter = function(v) {
      if (setter) {
        setter(v);
      }
    };
  } else {
    var computedHost_1 = defineComponentInstance(getVueConstructor(), {
      computed: {
        $$state: {
          get: getter,
          set: setter
        }
      }
    });
    vm && vm.$on("hook:destroyed", function() {
      return computedHost_1.$destroy();
    });
    computedGetter = function() {
      return computedHost_1.$$state;
    };
    computedSetter = function(v) {
      computedHost_1.$$state = v;
    };
  }
  return createRef({
    get: computedGetter,
    set: computedSetter
  }, !setter, true);
}
var NOT_FOUND = {};
function resolveInject(provideKey, vm) {
  var source = vm;
  while (source) {
    if (source._provided && hasOwn$1(source._provided, provideKey)) {
      return source._provided[provideKey];
    }
    source = source.$parent;
  }
  return NOT_FOUND;
}
function inject(key, defaultValue, treatDefaultAsFactory) {
  var _a2;
  if (treatDefaultAsFactory === void 0) {
    treatDefaultAsFactory = false;
  }
  var vm = (_a2 = getCurrentInstance()) === null || _a2 === void 0 ? void 0 : _a2.proxy;
  if (!vm) {
    return;
  }
  if (!key) {
    return defaultValue;
  }
  var val = resolveInject(key, vm);
  if (val !== NOT_FOUND) {
    return val;
  } else if (arguments.length > 1) {
    return treatDefaultAsFactory && isFunction$5(defaultValue) ? defaultValue() : defaultValue;
  } else
    ;
}
var nextTick = function nextTick2() {
  var _a2;
  var args = [];
  for (var _i2 = 0; _i2 < arguments.length; _i2++) {
    args[_i2] = arguments[_i2];
  }
  return (_a2 = getVueConstructor()) === null || _a2 === void 0 ? void 0 : _a2.nextTick.apply(this, args);
};
function set(vm, key, value) {
  var state = vm.__composition_api_state__ = vm.__composition_api_state__ || {};
  state[key] = value;
}
function get$2(vm, key) {
  return (vm.__composition_api_state__ || {})[key];
}
var vmStateManager = {
  set,
  get: get$2
};
function asVmProperty(vm, propName, propValue) {
  var props2 = vm.$options.props;
  if (!(propName in vm) && !(props2 && hasOwn$1(props2, propName))) {
    if (isRef(propValue)) {
      proxy(vm, propName, {
        get: function() {
          return propValue.value;
        },
        set: function(val) {
          propValue.value = val;
        }
      });
    } else {
      proxy(vm, propName, {
        get: function() {
          if (isReactive(propValue)) {
            propValue.__ob__.dep.depend();
          }
          return propValue;
        },
        set: function(val) {
          propValue = val;
        }
      });
    }
  }
}
function updateTemplateRef(vm) {
  var rawBindings = vmStateManager.get(vm, "rawBindings") || {};
  if (!rawBindings || !Object.keys(rawBindings).length)
    return;
  var refs = vm.$refs;
  var oldRefKeys = vmStateManager.get(vm, "refs") || [];
  for (var index2 = 0; index2 < oldRefKeys.length; index2++) {
    var key = oldRefKeys[index2];
    var setupValue = rawBindings[key];
    if (!refs[key] && setupValue && isRef(setupValue)) {
      setupValue.value = null;
    }
  }
  var newKeys = Object.keys(refs);
  var validNewKeys = [];
  for (var index2 = 0; index2 < newKeys.length; index2++) {
    var key = newKeys[index2];
    var setupValue = rawBindings[key];
    if (refs[key] && setupValue && isRef(setupValue)) {
      setupValue.value = refs[key];
      validNewKeys.push(key);
    }
  }
  vmStateManager.set(vm, "refs", validNewKeys);
}
function afterRender(vm) {
  var stack = [vm._vnode];
  while (stack.length) {
    var vnode = stack.pop();
    if (vnode) {
      if (vnode.context)
        updateTemplateRef(vnode.context);
      if (vnode.children) {
        for (var i2 = 0; i2 < vnode.children.length; ++i2) {
          stack.push(vnode.children[i2]);
        }
      }
    }
  }
}
function updateVmAttrs(vm, ctx) {
  var e_1, _a2;
  if (!vm) {
    return;
  }
  var attrBindings = vmStateManager.get(vm, "attrBindings");
  if (!attrBindings && !ctx) {
    return;
  }
  if (!attrBindings) {
    var observedData = reactive({});
    attrBindings = { ctx, data: observedData };
    vmStateManager.set(vm, "attrBindings", attrBindings);
    proxy(ctx, "attrs", {
      get: function() {
        return attrBindings === null || attrBindings === void 0 ? void 0 : attrBindings.data;
      },
      set: function() {
      }
    });
  }
  var source = vm.$attrs;
  var _loop_1 = function(attr2) {
    if (!hasOwn$1(attrBindings.data, attr2)) {
      proxy(attrBindings.data, attr2, {
        get: function() {
          return vm.$attrs[attr2];
        }
      });
    }
  };
  try {
    for (var _b2 = __values(Object.keys(source)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
      var attr = _c.value;
      _loop_1(attr);
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
}
function resolveScopedSlots(vm, slotsProxy) {
  var parentVNode = vm.$options._parentVnode;
  if (!parentVNode)
    return;
  var prevSlots = vmStateManager.get(vm, "slots") || [];
  var curSlots = resolveSlots(parentVNode.data.scopedSlots, vm.$slots);
  for (var index2 = 0; index2 < prevSlots.length; index2++) {
    var key = prevSlots[index2];
    if (!curSlots[key]) {
      delete slotsProxy[key];
    }
  }
  var slotNames = Object.keys(curSlots);
  for (var index2 = 0; index2 < slotNames.length; index2++) {
    var key = slotNames[index2];
    if (!slotsProxy[key]) {
      slotsProxy[key] = createSlotProxy(vm, key);
    }
  }
  vmStateManager.set(vm, "slots", slotNames);
}
function activateCurrentInstance(instance, fn, onError) {
  var preVm = getCurrentInstance();
  setCurrentInstance(instance);
  try {
    return fn(instance);
  } catch (err2) {
    if (onError) {
      onError(err2);
    } else {
      throw err2;
    }
  } finally {
    setCurrentInstance(preVm);
  }
}
function mixin(Vue2) {
  Vue2.mixin({
    beforeCreate: functionApiInit,
    mounted: function() {
      afterRender(this);
    },
    beforeUpdate: function() {
      updateVmAttrs(this);
    },
    updated: function() {
      afterRender(this);
    }
  });
  function functionApiInit() {
    var vm = this;
    var $options = vm.$options;
    var setup = $options.setup, render8 = $options.render;
    if (render8) {
      $options.render = function() {
        var _this2 = this;
        var args = [];
        for (var _i2 = 0; _i2 < arguments.length; _i2++) {
          args[_i2] = arguments[_i2];
        }
        return activateCurrentInstance(toVue3ComponentInstance(vm), function() {
          return render8.apply(_this2, args);
        });
      };
    }
    if (!setup) {
      return;
    }
    if (!isFunction$5(setup)) {
      return;
    }
    var data = $options.data;
    $options.data = function wrappedData() {
      initSetup(vm, vm.$props);
      return isFunction$5(data) ? data.call(vm, vm) : data || {};
    };
  }
  function initSetup(vm, props2) {
    if (props2 === void 0) {
      props2 = {};
    }
    var setup = vm.$options.setup;
    var ctx = createSetupContext(vm);
    var instance = toVue3ComponentInstance(vm);
    instance.setupContext = ctx;
    def(props2, "__ob__", createObserver());
    resolveScopedSlots(vm, ctx.slots);
    var binding;
    activateCurrentInstance(instance, function() {
      binding = setup(props2, ctx);
    });
    if (!binding)
      return;
    if (isFunction$5(binding)) {
      var bindingFunc_1 = binding;
      vm.$options.render = function() {
        resolveScopedSlots(vm, ctx.slots);
        return activateCurrentInstance(instance, function() {
          return bindingFunc_1();
        });
      };
      return;
    } else if (isObject$d(binding)) {
      if (isReactive(binding)) {
        binding = toRefs(binding);
      }
      vmStateManager.set(vm, "rawBindings", binding);
      var bindingObj_1 = binding;
      Object.keys(bindingObj_1).forEach(function(name) {
        var bindingValue = bindingObj_1[name];
        if (!isRef(bindingValue)) {
          if (!isReactive(bindingValue)) {
            if (isFunction$5(bindingValue)) {
              var copy_1 = bindingValue;
              bindingValue = bindingValue.bind(vm);
              Object.keys(copy_1).forEach(function(ele) {
                bindingValue[ele] = copy_1[ele];
              });
            } else if (!isObject$d(bindingValue)) {
              bindingValue = ref(bindingValue);
            } else if (hasReactiveArrayChild(bindingValue)) {
              customReactive(bindingValue);
            }
          } else if (isArray$e(bindingValue)) {
            bindingValue = ref(bindingValue);
          }
        }
        asVmProperty(vm, name, bindingValue);
      });
      return;
    }
  }
  function customReactive(target2, seen) {
    if (seen === void 0) {
      seen = /* @__PURE__ */ new Set();
    }
    if (seen.has(target2))
      return;
    if (!isPlainObject$8(target2) || isRef(target2) || isReactive(target2) || isRaw(target2))
      return;
    var Vue3 = getVueConstructor();
    var defineReactive = Vue3.util.defineReactive;
    Object.keys(target2).forEach(function(k) {
      var val = target2[k];
      defineReactive(target2, k, val);
      if (val) {
        seen.add(val);
        customReactive(val, seen);
      }
      return;
    });
  }
  function hasReactiveArrayChild(target2, visited) {
    if (visited === void 0) {
      visited = /* @__PURE__ */ new Map();
    }
    if (visited.has(target2)) {
      return visited.get(target2);
    }
    visited.set(target2, false);
    if (isArray$e(target2) && isReactive(target2)) {
      visited.set(target2, true);
      return true;
    }
    if (!isPlainObject$8(target2) || isRaw(target2) || isRef(target2)) {
      return false;
    }
    return Object.keys(target2).some(function(x2) {
      return hasReactiveArrayChild(target2[x2], visited);
    });
  }
  function createSetupContext(vm) {
    var ctx = { slots: {} };
    var propsPlain = [
      "root",
      "parent",
      "refs",
      "listeners",
      "isServer",
      "ssrContext"
    ];
    var methodReturnVoid = ["emit"];
    propsPlain.forEach(function(key) {
      var srcKey = "$".concat(key);
      proxy(ctx, key, {
        get: function() {
          return vm[srcKey];
        },
        set: function() {
        }
      });
    });
    updateVmAttrs(vm, ctx);
    methodReturnVoid.forEach(function(key) {
      var srcKey = "$".concat(key);
      proxy(ctx, key, {
        get: function() {
          return function() {
            var args = [];
            for (var _i2 = 0; _i2 < arguments.length; _i2++) {
              args[_i2] = arguments[_i2];
            }
            var fn = vm[srcKey];
            fn.apply(vm, args);
          };
        }
      });
    });
    return ctx;
  }
}
function mergeData(from, to) {
  if (!from)
    return to;
  if (!to)
    return from;
  var key;
  var toVal;
  var fromVal;
  var keys2 = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
  for (var i2 = 0; i2 < keys2.length; i2++) {
    key = keys2[i2];
    if (key === "__ob__")
      continue;
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn$1(to, key)) {
      to[key] = fromVal;
    } else if (toVal !== fromVal && isPlainObject$8(toVal) && !isRef(toVal) && isPlainObject$8(fromVal) && !isRef(fromVal)) {
      mergeData(fromVal, toVal);
    }
  }
  return to;
}
function install$5(Vue2) {
  if (isVueRegistered(Vue2)) {
    return;
  }
  Vue2.config.optionMergeStrategies.setup = function(parent2, child) {
    return function mergedSetupFn(props2, context) {
      return mergeData(isFunction$5(parent2) ? parent2(props2, context) || {} : void 0, isFunction$5(child) ? child(props2, context) || {} : void 0);
    };
  };
  setVueConstructor(Vue2);
  mixin(Vue2);
}
var Plugin = {
  install: function(Vue2) {
    return install$5(Vue2);
  }
};
if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(Plugin);
}
function install$4(_vue) {
  _vue = _vue || Vue$1;
  if (_vue && !_vue["__composition_api_installed__"])
    _vue.use(Plugin);
}
install$4(Vue$1);
var isVue2 = true;
Vue$1.version;
function hasInjectionContext() {
  return !!getCurrentInstance();
}
function getDevtoolsGlobalHook() {
  return getTarget().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function getTarget() {
  return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
}
const isProxyAvailable = typeof Proxy === "function";
const HOOK_SETUP = "devtools-plugin:setup";
const HOOK_PLUGIN_SETTINGS_SET = "plugin:settings:set";
let supported;
let perf;
function isPerformanceSupported() {
  var _a2;
  if (supported !== void 0) {
    return supported;
  }
  if (typeof window !== "undefined" && window.performance) {
    supported = true;
    perf = window.performance;
  } else if (typeof globalThis !== "undefined" && ((_a2 = globalThis.perf_hooks) === null || _a2 === void 0 ? void 0 : _a2.performance)) {
    supported = true;
    perf = globalThis.perf_hooks.performance;
  } else {
    supported = false;
  }
  return supported;
}
function now$1() {
  return isPerformanceSupported() ? perf.now() : Date.now();
}
class ApiProxy {
  constructor(plugin3, hook) {
    this.target = null;
    this.targetQueue = [];
    this.onQueue = [];
    this.plugin = plugin3;
    this.hook = hook;
    const defaultSettings = {};
    if (plugin3.settings) {
      for (const id in plugin3.settings) {
        const item = plugin3.settings[id];
        defaultSettings[id] = item.defaultValue;
      }
    }
    const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin3.id}`;
    let currentSettings = Object.assign({}, defaultSettings);
    try {
      const raw = localStorage.getItem(localSettingsSaveId);
      const data = JSON.parse(raw);
      Object.assign(currentSettings, data);
    } catch (e) {
    }
    this.fallbacks = {
      getSettings() {
        return currentSettings;
      },
      setSettings(value) {
        try {
          localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
        } catch (e) {
        }
        currentSettings = value;
      },
      now() {
        return now$1();
      }
    };
    if (hook) {
      hook.on(HOOK_PLUGIN_SETTINGS_SET, (pluginId, value) => {
        if (pluginId === this.plugin.id) {
          this.fallbacks.setSettings(value);
        }
      });
    }
    this.proxiedOn = new Proxy({}, {
      get: (_target2, prop) => {
        if (this.target) {
          return this.target.on[prop];
        } else {
          return (...args) => {
            this.onQueue.push({
              method: prop,
              args
            });
          };
        }
      }
    });
    this.proxiedTarget = new Proxy({}, {
      get: (_target2, prop) => {
        if (this.target) {
          return this.target[prop];
        } else if (prop === "on") {
          return this.proxiedOn;
        } else if (Object.keys(this.fallbacks).includes(prop)) {
          return (...args) => {
            this.targetQueue.push({
              method: prop,
              args,
              resolve: () => {
              }
            });
            return this.fallbacks[prop](...args);
          };
        } else {
          return (...args) => {
            return new Promise((resolve2) => {
              this.targetQueue.push({
                method: prop,
                args,
                resolve: resolve2
              });
            });
          };
        }
      }
    });
  }
  setRealTarget(target2) {
    return __async(this, null, function* () {
      this.target = target2;
      for (const item of this.onQueue) {
        this.target.on[item.method](...item.args);
      }
      for (const item of this.targetQueue) {
        item.resolve(yield this.target[item.method](...item.args));
      }
    });
  }
}
function setupDevtoolsPlugin(pluginDescriptor, setupFn) {
  const descriptor = pluginDescriptor;
  const target2 = getTarget();
  const hook = getDevtoolsGlobalHook();
  const enableProxy = isProxyAvailable && descriptor.enableEarlyProxy;
  if (hook && (target2.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) {
    hook.emit(HOOK_SETUP, pluginDescriptor, setupFn);
  } else {
    const proxy2 = enableProxy ? new ApiProxy(descriptor, hook) : null;
    const list2 = target2.__VUE_DEVTOOLS_PLUGINS__ = target2.__VUE_DEVTOOLS_PLUGINS__ || [];
    list2.push({
      pluginDescriptor: descriptor,
      setupFn,
      proxy: proxy2
    });
    if (proxy2) {
      setupFn(proxy2.proxiedTarget);
    }
  }
}
/*!
 * pinia v2.3.1
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */
let activePinia;
const setActivePinia = (pinia2) => activePinia = pinia2;
const piniaSymbol = (
  /* istanbul ignore next */
  Symbol()
);
function isPlainObject$7(o) {
  return o && typeof o === "object" && Object.prototype.toString.call(o) === "[object Object]" && typeof o.toJSON !== "function";
}
var MutationType;
(function(MutationType2) {
  MutationType2["direct"] = "direct";
  MutationType2["patchObject"] = "patch object";
  MutationType2["patchFunction"] = "patch function";
})(MutationType || (MutationType = {}));
const IS_CLIENT = typeof window !== "undefined";
const _global = /* @__PURE__ */ (() => typeof window === "object" && window.window === window ? window : typeof self === "object" && self.self === self ? self : typeof global === "object" && global.global === global ? global : typeof globalThis === "object" ? globalThis : { HTMLElement: null })();
function bom(blob, { autoBom = false } = {}) {
  if (autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
    return new Blob([String.fromCharCode(65279), blob], { type: blob.type });
  }
  return blob;
}
function download(url, name, opts) {
  const xhr2 = new XMLHttpRequest();
  xhr2.open("GET", url);
  xhr2.responseType = "blob";
  xhr2.onload = function() {
    saveAs(xhr2.response, name, opts);
  };
  xhr2.onerror = function() {
    console.error("could not download file");
  };
  xhr2.send();
}
function corsEnabled(url) {
  const xhr2 = new XMLHttpRequest();
  xhr2.open("HEAD", url, false);
  try {
    xhr2.send();
  } catch (e) {
  }
  return xhr2.status >= 200 && xhr2.status <= 299;
}
function click(node2) {
  try {
    node2.dispatchEvent(new MouseEvent("click"));
  } catch (e) {
    const evt = document.createEvent("MouseEvents");
    evt.initMouseEvent("click", true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
    node2.dispatchEvent(evt);
  }
}
const _navigator = typeof navigator === "object" ? navigator : { userAgent: "" };
const isMacOSWebView = /* @__PURE__ */ (() => /Macintosh/.test(_navigator.userAgent) && /AppleWebKit/.test(_navigator.userAgent) && !/Safari/.test(_navigator.userAgent))();
const saveAs = !IS_CLIENT ? () => {
} : (
  // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
  typeof HTMLAnchorElement !== "undefined" && "download" in HTMLAnchorElement.prototype && !isMacOSWebView ? downloadSaveAs : (
    // Use msSaveOrOpenBlob as a second approach
    "msSaveOrOpenBlob" in _navigator ? msSaveAs : (
      // Fallback to using FileReader and a popup
      fileSaverSaveAs
    )
  )
);
function downloadSaveAs(blob, name = "download", opts) {
  const a = document.createElement("a");
  a.download = name;
  a.rel = "noopener";
  if (typeof blob === "string") {
    a.href = blob;
    if (a.origin !== location.origin) {
      if (corsEnabled(a.href)) {
        download(blob, name, opts);
      } else {
        a.target = "_blank";
        click(a);
      }
    } else {
      click(a);
    }
  } else {
    a.href = URL.createObjectURL(blob);
    setTimeout(function() {
      URL.revokeObjectURL(a.href);
    }, 4e4);
    setTimeout(function() {
      click(a);
    }, 0);
  }
}
function msSaveAs(blob, name = "download", opts) {
  if (typeof blob === "string") {
    if (corsEnabled(blob)) {
      download(blob, name, opts);
    } else {
      const a = document.createElement("a");
      a.href = blob;
      a.target = "_blank";
      setTimeout(function() {
        click(a);
      });
    }
  } else {
    navigator.msSaveOrOpenBlob(bom(blob, opts), name);
  }
}
function fileSaverSaveAs(blob, name, opts, popup) {
  popup = popup || open("", "_blank");
  if (popup) {
    popup.document.title = popup.document.body.innerText = "downloading...";
  }
  if (typeof blob === "string")
    return download(blob, name, opts);
  const force = blob.type === "application/octet-stream";
  const isSafari = /constructor/i.test(String(_global.HTMLElement)) || "safari" in _global;
  const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((isChromeIOS || force && isSafari || isMacOSWebView) && typeof FileReader !== "undefined") {
    const reader = new FileReader();
    reader.onloadend = function() {
      let url = reader.result;
      if (typeof url !== "string") {
        popup = null;
        throw new Error("Wrong reader.result type");
      }
      url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, "data:attachment/file;");
      if (popup) {
        popup.location.href = url;
      } else {
        location.assign(url);
      }
      popup = null;
    };
    reader.readAsDataURL(blob);
  } else {
    const url = URL.createObjectURL(blob);
    if (popup)
      popup.location.assign(url);
    else
      location.href = url;
    popup = null;
    setTimeout(function() {
      URL.revokeObjectURL(url);
    }, 4e4);
  }
}
function toastMessage(message, type) {
  const piniaMessage = "🍍 " + message;
  if (typeof __VUE_DEVTOOLS_TOAST__ === "function") {
    __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
  } else if (type === "error") {
    console.error(piniaMessage);
  } else if (type === "warn") {
    console.warn(piniaMessage);
  } else {
    console.log(piniaMessage);
  }
}
function isPinia(o) {
  return "_a" in o && "install" in o;
}
function checkClipboardAccess() {
  if (!("clipboard" in navigator)) {
    toastMessage(`Your browser doesn't support the Clipboard API`, "error");
    return true;
  }
}
function checkNotFocusedError(error2) {
  if (error2 instanceof Error && error2.message.toLowerCase().includes("document is not focused")) {
    toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', "warn");
    return true;
  }
  return false;
}
function actionGlobalCopyState(pinia2) {
  return __async(this, null, function* () {
    if (checkClipboardAccess())
      return;
    try {
      yield navigator.clipboard.writeText(JSON.stringify(pinia2.state.value));
      toastMessage("Global state copied to clipboard.");
    } catch (error2) {
      if (checkNotFocusedError(error2))
        return;
      toastMessage(`Failed to serialize the state. Check the console for more details.`, "error");
      console.error(error2);
    }
  });
}
function actionGlobalPasteState(pinia2) {
  return __async(this, null, function* () {
    if (checkClipboardAccess())
      return;
    try {
      loadStoresState(pinia2, JSON.parse(yield navigator.clipboard.readText()));
      toastMessage("Global state pasted from clipboard.");
    } catch (error2) {
      if (checkNotFocusedError(error2))
        return;
      toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, "error");
      console.error(error2);
    }
  });
}
function actionGlobalSaveState(pinia2) {
  return __async(this, null, function* () {
    try {
      saveAs(new Blob([JSON.stringify(pinia2.state.value)], {
        type: "text/plain;charset=utf-8"
      }), "pinia-state.json");
    } catch (error2) {
      toastMessage(`Failed to export the state as JSON. Check the console for more details.`, "error");
      console.error(error2);
    }
  });
}
let fileInput;
function getFileOpener() {
  if (!fileInput) {
    fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".json";
  }
  function openFile() {
    return new Promise((resolve2, reject) => {
      fileInput.onchange = () => __async(this, null, function* () {
        const files = fileInput.files;
        if (!files)
          return resolve2(null);
        const file = files.item(0);
        if (!file)
          return resolve2(null);
        return resolve2({ text: yield file.text(), file });
      });
      fileInput.oncancel = () => resolve2(null);
      fileInput.onerror = reject;
      fileInput.click();
    });
  }
  return openFile;
}
function actionGlobalOpenStateFile(pinia2) {
  return __async(this, null, function* () {
    try {
      const open2 = getFileOpener();
      const result2 = yield open2();
      if (!result2)
        return;
      const { text: text2, file } = result2;
      loadStoresState(pinia2, JSON.parse(text2));
      toastMessage(`Global state imported from "${file.name}".`);
    } catch (error2) {
      toastMessage(`Failed to import the state from JSON. Check the console for more details.`, "error");
      console.error(error2);
    }
  });
}
function loadStoresState(pinia2, state) {
  for (const key in state) {
    const storeState = pinia2.state.value[key];
    if (storeState) {
      Object.assign(storeState, state[key]);
    } else {
      pinia2.state.value[key] = state[key];
    }
  }
}
function formatDisplay(display) {
  return {
    _custom: {
      display
    }
  };
}
const PINIA_ROOT_LABEL = "🍍 Pinia (root)";
const PINIA_ROOT_ID = "_root";
function formatStoreForInspectorTree(store) {
  return isPinia(store) ? {
    id: PINIA_ROOT_ID,
    label: PINIA_ROOT_LABEL
  } : {
    id: store.$id,
    label: store.$id
  };
}
function formatStoreForInspectorState(store) {
  if (isPinia(store)) {
    const storeNames = Array.from(store._s.keys());
    const storeMap = store._s;
    const state2 = {
      state: storeNames.map((storeId) => ({
        editable: true,
        key: storeId,
        value: store.state.value[storeId]
      })),
      getters: storeNames.filter((id) => storeMap.get(id)._getters).map((id) => {
        const store2 = storeMap.get(id);
        return {
          editable: false,
          key: id,
          value: store2._getters.reduce((getters, key) => {
            getters[key] = store2[key];
            return getters;
          }, {})
        };
      })
    };
    return state2;
  }
  const state = {
    state: Object.keys(store.$state).map((key) => ({
      editable: true,
      key,
      value: store.$state[key]
    }))
  };
  if (store._getters && store._getters.length) {
    state.getters = store._getters.map((getterName) => ({
      editable: false,
      key: getterName,
      value: store[getterName]
    }));
  }
  if (store._customProperties.size) {
    state.customProperties = Array.from(store._customProperties).map((key) => ({
      editable: true,
      key,
      value: store[key]
    }));
  }
  return state;
}
function formatEventData(events2) {
  if (!events2)
    return {};
  if (Array.isArray(events2)) {
    return events2.reduce((data, event) => {
      data.keys.push(event.key);
      data.operations.push(event.type);
      data.oldValue[event.key] = event.oldValue;
      data.newValue[event.key] = event.newValue;
      return data;
    }, {
      oldValue: {},
      keys: [],
      operations: [],
      newValue: {}
    });
  } else {
    return {
      operation: formatDisplay(events2.type),
      key: formatDisplay(events2.key),
      oldValue: events2.oldValue,
      newValue: events2.newValue
    };
  }
}
function formatMutationType(type) {
  switch (type) {
    case MutationType.direct:
      return "mutation";
    case MutationType.patchFunction:
      return "$patch";
    case MutationType.patchObject:
      return "$patch";
    default:
      return "unknown";
  }
}
let isTimelineActive = true;
const componentStateTypes = [];
const MUTATIONS_LAYER_ID = "pinia:mutations";
const INSPECTOR_ID = "pinia";
const { assign: assign$1 } = Object;
const getStoreType = (id) => "🍍 " + id;
function registerPiniaDevtools(app, pinia2) {
  setupDevtoolsPlugin({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes,
    app
  }, (api) => {
    if (typeof api.now !== "function") {
      toastMessage("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
    }
    api.addTimelineLayer({
      id: MUTATIONS_LAYER_ID,
      label: `Pinia 🍍`,
      color: 15064968
    });
    api.addInspector({
      id: INSPECTOR_ID,
      label: "Pinia 🍍",
      icon: "storage",
      treeFilterPlaceholder: "Search stores",
      actions: [
        {
          icon: "content_copy",
          action: () => {
            actionGlobalCopyState(pinia2);
          },
          tooltip: "Serialize and copy the state"
        },
        {
          icon: "content_paste",
          action: () => __async(this, null, function* () {
            yield actionGlobalPasteState(pinia2);
            api.sendInspectorTree(INSPECTOR_ID);
            api.sendInspectorState(INSPECTOR_ID);
          }),
          tooltip: "Replace the state with the content of your clipboard"
        },
        {
          icon: "save",
          action: () => {
            actionGlobalSaveState(pinia2);
          },
          tooltip: "Save the state as a JSON file"
        },
        {
          icon: "folder_open",
          action: () => __async(this, null, function* () {
            yield actionGlobalOpenStateFile(pinia2);
            api.sendInspectorTree(INSPECTOR_ID);
            api.sendInspectorState(INSPECTOR_ID);
          }),
          tooltip: "Import the state from a JSON file"
        }
      ],
      nodeActions: [
        {
          icon: "restore",
          tooltip: 'Reset the state (with "$reset")',
          action: (nodeId) => {
            const store = pinia2._s.get(nodeId);
            if (!store) {
              toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, "warn");
            } else if (typeof store.$reset !== "function") {
              toastMessage(`Cannot reset "${nodeId}" store because it doesn't have a "$reset" method implemented.`, "warn");
            } else {
              store.$reset();
              toastMessage(`Store "${nodeId}" reset.`);
            }
          }
        }
      ]
    });
    api.on.inspectComponent((payload, ctx) => {
      const proxy2 = payload.componentInstance && payload.componentInstance.proxy;
      if (proxy2 && proxy2._pStores) {
        const piniaStores = payload.componentInstance.proxy._pStores;
        Object.values(piniaStores).forEach((store) => {
          payload.instanceData.state.push({
            type: getStoreType(store.$id),
            key: "state",
            editable: true,
            value: store._isOptionsAPI ? {
              _custom: {
                value: toRaw(store.$state),
                actions: [
                  {
                    icon: "restore",
                    tooltip: "Reset the state of this store",
                    action: () => store.$reset()
                  }
                ]
              }
            } : (
              // NOTE: workaround to unwrap transferred refs
              Object.keys(store.$state).reduce((state, key) => {
                state[key] = store.$state[key];
                return state;
              }, {})
            )
          });
          if (store._getters && store._getters.length) {
            payload.instanceData.state.push({
              type: getStoreType(store.$id),
              key: "getters",
              editable: false,
              value: store._getters.reduce((getters, key) => {
                try {
                  getters[key] = store[key];
                } catch (error2) {
                  getters[key] = error2;
                }
                return getters;
              }, {})
            });
          }
        });
      }
    });
    api.on.getInspectorTree((payload) => {
      if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
        let stores = [pinia2];
        stores = stores.concat(Array.from(pinia2._s.values()));
        payload.rootNodes = (payload.filter ? stores.filter((store) => "$id" in store ? store.$id.toLowerCase().includes(payload.filter.toLowerCase()) : PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase())) : stores).map(formatStoreForInspectorTree);
      }
    });
    globalThis.$pinia = pinia2;
    api.on.getInspectorState((payload) => {
      if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
        const inspectedStore = payload.nodeId === PINIA_ROOT_ID ? pinia2 : pinia2._s.get(payload.nodeId);
        if (!inspectedStore) {
          return;
        }
        if (inspectedStore) {
          if (payload.nodeId !== PINIA_ROOT_ID)
            globalThis.$store = toRaw(inspectedStore);
          payload.state = formatStoreForInspectorState(inspectedStore);
        }
      }
    });
    api.on.editInspectorState((payload, ctx) => {
      if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
        const inspectedStore = payload.nodeId === PINIA_ROOT_ID ? pinia2 : pinia2._s.get(payload.nodeId);
        if (!inspectedStore) {
          return toastMessage(`store "${payload.nodeId}" not found`, "error");
        }
        const { path } = payload;
        if (!isPinia(inspectedStore)) {
          if (path.length !== 1 || !inspectedStore._customProperties.has(path[0]) || path[0] in inspectedStore.$state) {
            path.unshift("$state");
          }
        } else {
          path.unshift("state");
        }
        isTimelineActive = false;
        payload.set(inspectedStore, path, payload.state.value);
        isTimelineActive = true;
      }
    });
    api.on.editComponentState((payload) => {
      if (payload.type.startsWith("🍍")) {
        const storeId = payload.type.replace(/^🍍\s*/, "");
        const store = pinia2._s.get(storeId);
        if (!store) {
          return toastMessage(`store "${storeId}" not found`, "error");
        }
        const { path } = payload;
        if (path[0] !== "state") {
          return toastMessage(`Invalid path for store "${storeId}":
${path}
Only state can be modified.`);
        }
        path[0] = "$state";
        isTimelineActive = false;
        payload.set(store, path, payload.state.value);
        isTimelineActive = true;
      }
    });
  });
}
function addStoreToDevtools(app, store) {
  if (!componentStateTypes.includes(getStoreType(store.$id))) {
    componentStateTypes.push(getStoreType(store.$id));
  }
  setupDevtoolsPlugin({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes,
    app,
    settings: {
      logStoreChanges: {
        label: "Notify about new/deleted stores",
        type: "boolean",
        defaultValue: true
      }
      // useEmojis: {
      //   label: 'Use emojis in messages ⚡️',
      //   type: 'boolean',
      //   defaultValue: true,
      // },
    }
  }, (api) => {
    const now2 = typeof api.now === "function" ? api.now.bind(api) : Date.now;
    store.$onAction(({ after, onError, name, args }) => {
      const groupId = runningActionId++;
      api.addTimelineEvent({
        layerId: MUTATIONS_LAYER_ID,
        event: {
          time: now2(),
          title: "🛫 " + name,
          subtitle: "start",
          data: {
            store: formatDisplay(store.$id),
            action: formatDisplay(name),
            args
          },
          groupId
        }
      });
      after((result2) => {
        activeAction = void 0;
        api.addTimelineEvent({
          layerId: MUTATIONS_LAYER_ID,
          event: {
            time: now2(),
            title: "🛬 " + name,
            subtitle: "end",
            data: {
              store: formatDisplay(store.$id),
              action: formatDisplay(name),
              args,
              result: result2
            },
            groupId
          }
        });
      });
      onError((error2) => {
        activeAction = void 0;
        api.addTimelineEvent({
          layerId: MUTATIONS_LAYER_ID,
          event: {
            time: now2(),
            logType: "error",
            title: "💥 " + name,
            subtitle: "end",
            data: {
              store: formatDisplay(store.$id),
              action: formatDisplay(name),
              args,
              error: error2
            },
            groupId
          }
        });
      });
    }, true);
    store._customProperties.forEach((name) => {
      watch(() => unref(store[name]), (newValue, oldValue) => {
        api.notifyComponentUpdate();
        api.sendInspectorState(INSPECTOR_ID);
        if (isTimelineActive) {
          api.addTimelineEvent({
            layerId: MUTATIONS_LAYER_ID,
            event: {
              time: now2(),
              title: "Change",
              subtitle: name,
              data: {
                newValue,
                oldValue
              },
              groupId: activeAction
            }
          });
        }
      }, { deep: true });
    });
    store.$subscribe(({ events: events2, type }, state) => {
      api.notifyComponentUpdate();
      api.sendInspectorState(INSPECTOR_ID);
      if (!isTimelineActive)
        return;
      const eventData = {
        time: now2(),
        title: formatMutationType(type),
        data: assign$1({ store: formatDisplay(store.$id) }, formatEventData(events2)),
        groupId: activeAction
      };
      if (type === MutationType.patchFunction) {
        eventData.subtitle = "⤵️";
      } else if (type === MutationType.patchObject) {
        eventData.subtitle = "🧩";
      } else if (events2 && !Array.isArray(events2)) {
        eventData.subtitle = events2.type;
      }
      if (events2) {
        eventData.data["rawEvent(s)"] = {
          _custom: {
            display: "DebuggerEvent",
            type: "object",
            tooltip: "raw DebuggerEvent[]",
            value: events2
          }
        };
      }
      api.addTimelineEvent({
        layerId: MUTATIONS_LAYER_ID,
        event: eventData
      });
    }, { detached: true, flush: "sync" });
    const hotUpdate = store._hotUpdate;
    store._hotUpdate = markRaw((newStore) => {
      hotUpdate(newStore);
      api.addTimelineEvent({
        layerId: MUTATIONS_LAYER_ID,
        event: {
          time: now2(),
          title: "🔥 " + store.$id,
          subtitle: "HMR update",
          data: {
            store: formatDisplay(store.$id),
            info: formatDisplay(`HMR update`)
          }
        }
      });
      api.notifyComponentUpdate();
      api.sendInspectorTree(INSPECTOR_ID);
      api.sendInspectorState(INSPECTOR_ID);
    });
    const { $dispose } = store;
    store.$dispose = () => {
      $dispose();
      api.notifyComponentUpdate();
      api.sendInspectorTree(INSPECTOR_ID);
      api.sendInspectorState(INSPECTOR_ID);
      api.getSettings().logStoreChanges && toastMessage(`Disposed "${store.$id}" store 🗑`);
    };
    api.notifyComponentUpdate();
    api.sendInspectorTree(INSPECTOR_ID);
    api.sendInspectorState(INSPECTOR_ID);
    api.getSettings().logStoreChanges && toastMessage(`"${store.$id}" store installed 🆕`);
  });
}
let runningActionId = 0;
let activeAction;
function patchActionForGrouping(store, actionNames, wrapWithProxy) {
  const actions = actionNames.reduce((storeActions, actionName) => {
    storeActions[actionName] = toRaw(store)[actionName];
    return storeActions;
  }, {});
  for (const actionName in actions) {
    store[actionName] = function() {
      const _actionId = runningActionId;
      const trackedStore = wrapWithProxy ? new Proxy(store, {
        get(...args) {
          activeAction = _actionId;
          return Reflect.get(...args);
        },
        set(...args) {
          activeAction = _actionId;
          return Reflect.set(...args);
        }
      }) : store;
      activeAction = _actionId;
      const retValue = actions[actionName].apply(trackedStore, arguments);
      activeAction = void 0;
      return retValue;
    };
  }
}
function devtoolsPlugin({ app, store, options }) {
  if (store.$id.startsWith("__hot:")) {
    return;
  }
  store._isOptionsAPI = !!options.state;
  if (!store._p._testing) {
    patchActionForGrouping(store, Object.keys(options.actions), store._isOptionsAPI);
    const originalHotUpdate = store._hotUpdate;
    toRaw(store)._hotUpdate = function(newStore) {
      originalHotUpdate.apply(this, arguments);
      patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions), !!store._isOptionsAPI);
    };
  }
  addStoreToDevtools(
    app,
    // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
    store
  );
}
function createPinia() {
  const scope = effectScope(true);
  const state = scope.run(() => ref({}));
  let _p = [];
  const pinia2 = markRaw({
    install(app) {
      setActivePinia(pinia2);
    },
    use(plugin3) {
      if (!this._a && !isVue2)
        ;
      else {
        _p.push(plugin3);
      }
      return this;
    },
    _p,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: scope,
    _s: /* @__PURE__ */ new Map(),
    state
  });
  if (typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && IS_CLIENT && typeof Proxy !== "undefined") {
    pinia2.use(devtoolsPlugin);
  }
  return pinia2;
}
const noop$2 = () => {
};
function addSubscription(subscriptions, callback, detached, onCleanup = noop$2) {
  subscriptions.push(callback);
  const removeSubscription = () => {
    const idx = subscriptions.indexOf(callback);
    if (idx > -1) {
      subscriptions.splice(idx, 1);
      onCleanup();
    }
  };
  if (!detached && getCurrentScope()) {
    onScopeDispose(removeSubscription);
  }
  return removeSubscription;
}
function triggerSubscriptions(subscriptions, ...args) {
  subscriptions.slice().forEach((callback) => {
    callback(...args);
  });
}
const fallbackRunWithContext = (fn) => fn();
const ACTION_MARKER = Symbol();
const ACTION_NAME = Symbol();
function mergeReactiveObjects(target2, patchToApply) {
  if (target2 instanceof Map && patchToApply instanceof Map) {
    patchToApply.forEach((value, key) => target2.set(key, value));
  } else if (target2 instanceof Set && patchToApply instanceof Set) {
    patchToApply.forEach(target2.add, target2);
  }
  for (const key in patchToApply) {
    if (!patchToApply.hasOwnProperty(key))
      continue;
    const subPatch = patchToApply[key];
    const targetValue = target2[key];
    if (isPlainObject$7(targetValue) && isPlainObject$7(subPatch) && target2.hasOwnProperty(key) && !isRef(subPatch) && !isReactive(subPatch)) {
      target2[key] = mergeReactiveObjects(targetValue, subPatch);
    } else {
      target2[key] = subPatch;
    }
  }
  return target2;
}
const skipHydrateSymbol = (
  /* istanbul ignore next */
  Symbol()
);
function shouldHydrate(obj) {
  return !isPlainObject$7(obj) || !obj.hasOwnProperty(skipHydrateSymbol);
}
const { assign } = Object;
function isComputed(o) {
  return !!(isRef(o) && o.effect);
}
function createOptionsStore(id, options, pinia2, hot) {
  const { state, actions, getters } = options;
  const initialState2 = pinia2.state.value[id];
  let store;
  function setup() {
    if (!initialState2 && true) {
      {
        set$1(pinia2.state.value, id, state ? state() : {});
      }
    }
    const localState = toRefs(pinia2.state.value[id]);
    return assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name) => {
      computedGetters[name] = markRaw(computed(() => {
        setActivePinia(pinia2);
        const store2 = pinia2._s.get(id);
        if (!store2._r)
          return;
        return getters[name].call(store2, store2);
      }));
      return computedGetters;
    }, {}));
  }
  store = createSetupStore(id, setup, options, pinia2, hot, true);
  return store;
}
function createSetupStore($id, setup, options = {}, pinia2, hot, isOptionsStore) {
  let scope;
  const optionsForPlugin = assign({ actions: {} }, options);
  const $subscribeOptions = { deep: true };
  let isListening;
  let isSyncListening;
  let subscriptions = [];
  let actionSubscriptions = [];
  let debuggerEvents;
  const initialState2 = pinia2.state.value[$id];
  if (!isOptionsStore && !initialState2 && true) {
    {
      set$1(pinia2.state.value, $id, {});
    }
  }
  const hotState = ref({});
  let activeListener;
  function $patch(partialStateOrMutator) {
    let subscriptionMutation;
    isListening = isSyncListening = false;
    if (typeof partialStateOrMutator === "function") {
      partialStateOrMutator(pinia2.state.value[$id]);
      subscriptionMutation = {
        type: MutationType.patchFunction,
        storeId: $id,
        events: debuggerEvents
      };
    } else {
      mergeReactiveObjects(pinia2.state.value[$id], partialStateOrMutator);
      subscriptionMutation = {
        type: MutationType.patchObject,
        payload: partialStateOrMutator,
        storeId: $id,
        events: debuggerEvents
      };
    }
    const myListenerId = activeListener = Symbol();
    nextTick().then(() => {
      if (activeListener === myListenerId) {
        isListening = true;
      }
    });
    isSyncListening = true;
    triggerSubscriptions(subscriptions, subscriptionMutation, pinia2.state.value[$id]);
  }
  const $reset = isOptionsStore ? function $reset2() {
    const { state } = options;
    const newState = state ? state() : {};
    this.$patch(($state) => {
      assign($state, newState);
    });
  } : (
    /* istanbul ignore next */
    noop$2
  );
  function $dispose() {
    scope.stop();
    subscriptions = [];
    actionSubscriptions = [];
    pinia2._s.delete($id);
  }
  const action = (fn, name = "") => {
    if (ACTION_MARKER in fn) {
      fn[ACTION_NAME] = name;
      return fn;
    }
    const wrappedAction = function() {
      setActivePinia(pinia2);
      const args = Array.from(arguments);
      const afterCallbackList = [];
      const onErrorCallbackList = [];
      function after(callback) {
        afterCallbackList.push(callback);
      }
      function onError(callback) {
        onErrorCallbackList.push(callback);
      }
      triggerSubscriptions(actionSubscriptions, {
        args,
        name: wrappedAction[ACTION_NAME],
        store,
        after,
        onError
      });
      let ret;
      try {
        ret = fn.apply(this && this.$id === $id ? this : store, args);
      } catch (error2) {
        triggerSubscriptions(onErrorCallbackList, error2);
        throw error2;
      }
      if (ret instanceof Promise) {
        return ret.then((value) => {
          triggerSubscriptions(afterCallbackList, value);
          return value;
        }).catch((error2) => {
          triggerSubscriptions(onErrorCallbackList, error2);
          return Promise.reject(error2);
        });
      }
      triggerSubscriptions(afterCallbackList, ret);
      return ret;
    };
    wrappedAction[ACTION_MARKER] = true;
    wrappedAction[ACTION_NAME] = name;
    return wrappedAction;
  };
  const _hmrPayload = /* @__PURE__ */ markRaw({
    actions: {},
    getters: {},
    state: [],
    hotState
  });
  const partialStore = {
    _p: pinia2,
    // _s: scope,
    $id,
    $onAction: addSubscription.bind(null, actionSubscriptions),
    $patch,
    $reset,
    $subscribe(callback, options2 = {}) {
      const removeSubscription = addSubscription(subscriptions, callback, options2.detached, () => stopWatcher());
      const stopWatcher = scope.run(() => watch(() => pinia2.state.value[$id], (state) => {
        if (options2.flush === "sync" ? isSyncListening : isListening) {
          callback({
            storeId: $id,
            type: MutationType.direct,
            events: debuggerEvents
          }, state);
        }
      }, assign({}, $subscribeOptions, options2)));
      return removeSubscription;
    },
    $dispose
  };
  {
    partialStore._r = false;
  }
  const store = reactive(typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && IS_CLIENT ? assign(
    {
      _hmrPayload,
      _customProperties: markRaw(/* @__PURE__ */ new Set())
      // devtools custom properties
    },
    partialStore
    // must be added later
    // setupStore
  ) : partialStore);
  pinia2._s.set($id, store);
  const runWithContext = pinia2._a && pinia2._a.runWithContext || fallbackRunWithContext;
  const setupStore = runWithContext(() => pinia2._e.run(() => (scope = effectScope()).run(() => setup({ action }))));
  for (const key in setupStore) {
    const prop = setupStore[key];
    if (isRef(prop) && !isComputed(prop) || isReactive(prop)) {
      if (!isOptionsStore) {
        if (initialState2 && shouldHydrate(prop)) {
          if (isRef(prop)) {
            prop.value = initialState2[key];
          } else {
            mergeReactiveObjects(prop, initialState2[key]);
          }
        }
        {
          set$1(pinia2.state.value[$id], key, prop);
        }
      }
    } else if (typeof prop === "function") {
      const actionValue = action(prop, key);
      {
        set$1(setupStore, key, actionValue);
      }
      optionsForPlugin.actions[key] = prop;
    } else
      ;
  }
  {
    Object.keys(setupStore).forEach((key) => {
      set$1(store, key, setupStore[key]);
    });
  }
  Object.defineProperty(store, "$state", {
    get: () => pinia2.state.value[$id],
    set: (state) => {
      $patch(($state) => {
        assign($state, state);
      });
    }
  });
  if (typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && IS_CLIENT) {
    const nonEnumerable = {
      writable: true,
      configurable: true,
      // avoid warning on devtools trying to display this property
      enumerable: false
    };
    ["_p", "_hmrPayload", "_getters", "_customProperties"].forEach((p) => {
      Object.defineProperty(store, p, assign({ value: store[p] }, nonEnumerable));
    });
  }
  {
    store._r = true;
  }
  pinia2._p.forEach((extender) => {
    if (typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && IS_CLIENT) {
      const extensions = scope.run(() => extender({
        store,
        app: pinia2._a,
        pinia: pinia2,
        options: optionsForPlugin
      }));
      Object.keys(extensions || {}).forEach((key) => store._customProperties.add(key));
      assign(store, extensions);
    } else {
      assign(store, scope.run(() => extender({
        store,
        app: pinia2._a,
        pinia: pinia2,
        options: optionsForPlugin
      })));
    }
  });
  if (initialState2 && isOptionsStore && options.hydrate) {
    options.hydrate(store.$state, initialState2);
  }
  isListening = true;
  isSyncListening = true;
  return store;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function defineStore(idOrOptions, setup, setupOptions) {
  let id;
  let options;
  const isSetupStore = typeof setup === "function";
  if (typeof idOrOptions === "string") {
    id = idOrOptions;
    options = isSetupStore ? setupOptions : setup;
  } else {
    options = idOrOptions;
    id = idOrOptions.id;
  }
  function useStore(pinia2, hot) {
    const hasContext = hasInjectionContext();
    pinia2 = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    pinia2 || (hasContext ? inject(piniaSymbol, null) : null);
    if (pinia2)
      setActivePinia(pinia2);
    pinia2 = activePinia;
    if (!pinia2._s.has(id)) {
      if (isSetupStore) {
        createSetupStore(id, setup, options, pinia2);
      } else {
        createOptionsStore(id, options, pinia2);
      }
    }
    const store = pinia2._s.get(id);
    return store;
  }
  useStore.$id = id;
  return useStore;
}
let mapStoreSuffix = "Store";
function mapStores(...stores) {
  return stores.reduce((reduced, useStore) => {
    reduced[useStore.$id + mapStoreSuffix] = function() {
      return useStore(this.$pinia);
    };
    return reduced;
  }, {});
}
function mapState(useStore, keysOrMapper) {
  return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key) => {
    reduced[key] = function() {
      return useStore(this.$pinia)[key];
    };
    return reduced;
  }, {}) : Object.keys(keysOrMapper).reduce((reduced, key) => {
    reduced[key] = function() {
      const store = useStore(this.$pinia);
      const storeKey = keysOrMapper[key];
      return typeof storeKey === "function" ? storeKey.call(this, store) : (
        // @ts-expect-error: FIXME: should work?
        store[storeKey]
      );
    };
    return reduced;
  }, {});
}
const PiniaVuePlugin = function(_Vue) {
  _Vue.mixin({
    beforeCreate() {
      const options = this.$options;
      if (options.pinia) {
        const pinia2 = options.pinia;
        if (!this._provided) {
          const provideCache = {};
          Object.defineProperty(this, "_provided", {
            get: () => provideCache,
            set: (v) => Object.assign(provideCache, v)
          });
        }
        this._provided[piniaSymbol] = pinia2;
        if (!this.$pinia) {
          this.$pinia = pinia2;
        }
        pinia2._a = this;
        if (IS_CLIENT) {
          setActivePinia(pinia2);
        }
        if (typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && IS_CLIENT) {
          registerPiniaDevtools(pinia2._a, pinia2);
        }
      } else if (!this.$pinia && options.parent && options.parent.$pinia) {
        this.$pinia = options.parent.$pinia;
      }
    },
    destroyed() {
      delete this._pStores;
    }
  });
};
const useCilbeeStore = /* @__PURE__ */ defineStore("cilbee", {
  state: () => ({
    destinations: [],
    startSweep: null,
    beePosition: null,
    currentBeeSweep: null,
    currentMode: null,
    currentPassableAreaIndex: 0,
    destinationRanges: [],
    fixRootSweep: false,
    minimapRouteLines: [],
    passableAreas: [],
    phase: 0,
    selectedLanguage: 2,
    showSelectedOnly: false,
    ss: null,
    targetMattertagSid: null,
    matterportUiVisibleFlags: {
      tag: true,
      label: true
    }
  }),
  getters: {
    currentPassableArea: (state) => state.passableAreas[state.currentPassableAreaIndex],
    currentPassableAreaFloorSweeps() {
      return (selectedFloorSequence) => {
        var _a2;
        if ((_a2 = this.currentPassableArea) == null ? void 0 : _a2.area) {
          return this.currentPassableArea.area[selectedFloorSequence] ? this.currentPassableArea.area[selectedFloorSequence] : {};
        } else {
          return {};
        }
      };
    },
    destinationSids() {
      return () => {
        return this.destinations.map((dest) => dest.sweep.sid);
      };
    }
  }
});
const __$_require_641d5d9e__ = "data:image/png;base64,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";
const __$_require_6d2c5530__ = "data:image/png;base64,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";
var render$D = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("Transition", [_vm.cilbeeStore.phase === 0 ? _c("div", {
    staticClass: "position-absolute top-0 end-0 pe-none overflow-hidden d-flex flex-column align-items-center justify-content-center w-100 h-100",
    attrs: {
      "id": "dpm-loading-ui"
    }
  }, [_c("img", {
    attrs: {
      "src": __$_require_641d5d9e__
    }
  }), _c("img", {
    staticStyle: {
      "width": "128px"
    },
    attrs: {
      "src": __$_require_6d2c5530__
    }
  })]) : _vm._e()]);
};
var staticRenderFns$C = [];
const loadingUi_vue_vue_type_style_index_0_lang = "";
function normalizeComponent$1(scriptExports, render8, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render8) {
    options.render = render8;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(
        this,
        (options.functional ? this.parent : this).$root.$options.shadowRoot
      );
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __vue2_script$C = {
  data() {
    return {};
  },
  created() {
    return __async(this, null, function* () {
    });
  },
  computed: __spreadValues({}, mapStores(useCilbeeStore))
};
const __cssModules$C = {};
var __component__$C = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$C,
  render$D,
  staticRenderFns$C,
  false,
  __vue2_injectStyles$C,
  null,
  null,
  null
);
function __vue2_injectStyles$C(context) {
  for (let o in __cssModules$C) {
    this[o] = __cssModules$C[o];
  }
}
const LoadingUi = /* @__PURE__ */ function() {
  return __component__$C.exports;
}();
const GetSDK = (elementId) => {
  return new Promise((resolve2, _reject) => {
    const checkIframe = () => __async(void 0, null, function* () {
      let iframe;
      if (elementId instanceof HTMLIFrameElement) {
        iframe = elementId;
      } else {
        iframe = document.getElementById(elementId);
      }
      if (iframe && iframe.contentWindow.MP_SDK) {
        clearInterval(intervalId);
        const sdk = yield iframe.contentWindow.MP_SDK.connect(iframe);
        resolve2(sdk);
      }
    });
    const intervalId = setInterval(checkIframe, 100);
  });
};
var vuetify = { exports: {} };
const require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(vue_runtime_esm);
(function(module, exports) {
  (function webpackUniversalModuleDefinition(root2, factory) {
    module.exports = factory(require$$0$1);
  })(typeof self !== "undefined" ? self : commonjsGlobal, function(__WEBPACK_EXTERNAL_MODULE_vue__) {
    return (
      /******/
      function(modules2) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
          if (installedModules[moduleId]) {
            return installedModules[moduleId].exports;
          }
          var module2 = installedModules[moduleId] = {
            /******/
            i: moduleId,
            /******/
            l: false,
            /******/
            exports: {}
            /******/
          };
          modules2[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
          module2.l = true;
          return module2.exports;
        }
        __webpack_require__.m = modules2;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports2, name, getter) {
          if (!__webpack_require__.o(exports2, name)) {
            Object.defineProperty(exports2, name, { enumerable: true, get: getter });
          }
        };
        __webpack_require__.r = function(exports2) {
          if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
            Object.defineProperty(exports2, Symbol.toStringTag, { value: "Module" });
          }
          Object.defineProperty(exports2, "__esModule", { value: true });
        };
        __webpack_require__.t = function(value, mode) {
          if (mode & 1)
            value = __webpack_require__(value);
          if (mode & 8)
            return value;
          if (mode & 4 && typeof value === "object" && value && value.__esModule)
            return value;
          var ns = /* @__PURE__ */ Object.create(null);
          __webpack_require__.r(ns);
          Object.defineProperty(ns, "default", { enumerable: true, value });
          if (mode & 2 && typeof value != "string")
            for (var key in value)
              __webpack_require__.d(ns, key, function(key2) {
                return value[key2];
              }.bind(null, key));
          return ns;
        };
        __webpack_require__.n = function(module2) {
          var getter = module2 && module2.__esModule ? (
            /******/
            function getDefault() {
              return module2["default"];
            }
          ) : (
            /******/
            function getModuleExports() {
              return module2;
            }
          );
          __webpack_require__.d(getter, "a", getter);
          return getter;
        };
        __webpack_require__.o = function(object, property2) {
          return Object.prototype.hasOwnProperty.call(object, property2);
        };
        __webpack_require__.p = "/dist/";
        return __webpack_require__(__webpack_require__.s = "./src/index.ts");
      }({
        /***/
        "./src/components/VAlert/VAlert.sass": (
          /*!*******************************************!*\
            !*** ./src/components/VAlert/VAlert.sass ***!
            \*******************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VAlert/VAlert.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VAlert/VAlert.ts ***!
            \*****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VAlert.sass */
              "./src/components/VAlert/VAlert.sass"
            );
            var _VSheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSheet */
              "./src/components/VSheet/index.ts"
            );
            var _VBtn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VBtn */
              "./src/components/VBtn/index.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _mixins_transitionable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/transitionable */
              "./src/mixins/transitionable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_7__["default"])(_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_transitionable__WEBPACK_IMPORTED_MODULE_6__["default"]).extend({
              name: "v-alert",
              props: {
                border: {
                  type: String,
                  validator: function validator2(val) {
                    return ["top", "right", "bottom", "left"].includes(val);
                  }
                },
                closeLabel: {
                  type: String,
                  default: "$vuetify.close"
                },
                coloredBorder: Boolean,
                dense: Boolean,
                dismissible: Boolean,
                closeIcon: {
                  type: String,
                  default: "$cancel"
                },
                icon: {
                  default: "",
                  type: [Boolean, String],
                  validator: function validator2(val) {
                    return typeof val === "string" || val === false;
                  }
                },
                outlined: Boolean,
                prominent: Boolean,
                text: Boolean,
                type: {
                  type: String,
                  validator: function validator2(val) {
                    return ["info", "error", "success", "warning"].includes(val);
                  }
                },
                value: {
                  type: Boolean,
                  default: true
                }
              },
              computed: {
                __cachedBorder: function __cachedBorder() {
                  var _a2;
                  if (!this.border)
                    return null;
                  var data = {
                    staticClass: "v-alert__border",
                    class: (_a2 = {}, _a2["v-alert__border--" + this.border] = true, _a2)
                  };
                  if (this.coloredBorder) {
                    data = this.setBackgroundColor(this.computedColor, data);
                    data.class["v-alert__border--has-color"] = true;
                  }
                  return this.$createElement("div", data);
                },
                __cachedDismissible: function __cachedDismissible() {
                  var _this2 = this;
                  if (!this.dismissible)
                    return null;
                  var color2 = this.iconColor;
                  return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    staticClass: "v-alert__dismissible",
                    props: {
                      color: color2,
                      icon: true,
                      small: true
                    },
                    attrs: {
                      "aria-label": this.$vuetify.lang.t(this.closeLabel)
                    },
                    on: {
                      click: function click2() {
                        return _this2.isActive = false;
                      }
                    }
                  }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    props: {
                      color: color2
                    }
                  }, this.closeIcon)]);
                },
                __cachedIcon: function __cachedIcon() {
                  if (!this.computedIcon)
                    return null;
                  return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    staticClass: "v-alert__icon",
                    props: {
                      color: this.iconColor
                    }
                  }, this.computedIcon);
                },
                classes: function classes() {
                  var classes2 = __assign2(__assign2({}, _VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-alert--border": Boolean(this.border),
                    "v-alert--dense": this.dense,
                    "v-alert--outlined": this.outlined,
                    "v-alert--prominent": this.prominent,
                    "v-alert--text": this.text
                  });
                  if (this.border) {
                    classes2["v-alert--border-" + this.border] = true;
                  }
                  return classes2;
                },
                computedColor: function computedColor() {
                  return this.color || this.type;
                },
                computedIcon: function computedIcon() {
                  if (this.icon === false)
                    return false;
                  if (typeof this.icon === "string" && this.icon)
                    return this.icon;
                  if (!["error", "info", "success", "warning"].includes(this.type))
                    return false;
                  return "$" + this.type;
                },
                hasColoredIcon: function hasColoredIcon() {
                  return this.hasText || Boolean(this.border) && this.coloredBorder;
                },
                hasText: function hasText() {
                  return this.text || this.outlined;
                },
                iconColor: function iconColor() {
                  return this.hasColoredIcon ? this.computedColor : void 0;
                },
                isDark: function isDark() {
                  if (this.type && !this.coloredBorder && !this.outlined)
                    return true;
                  return _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__["default"].options.computed.isDark.call(this);
                }
              },
              created: function created2() {
                if (this.$attrs.hasOwnProperty("outline")) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["breaking"])("outline", "outlined", this);
                }
              },
              methods: {
                genWrapper: function genWrapper() {
                  var children = [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["getSlot"])(this, "prepend") || this.__cachedIcon, this.genContent(), this.__cachedBorder, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["getSlot"])(this, "append"), this.$scopedSlots.close ? this.$scopedSlots.close({
                    toggle: this.toggle
                  }) : this.__cachedDismissible];
                  var data = {
                    staticClass: "v-alert__wrapper"
                  };
                  return this.$createElement("div", data, children);
                },
                genContent: function genContent() {
                  return this.$createElement("div", {
                    staticClass: "v-alert__content"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["getSlot"])(this));
                },
                genAlert: function genAlert() {
                  var data = {
                    staticClass: "v-alert",
                    attrs: {
                      role: "alert"
                    },
                    on: this.listeners$,
                    class: this.classes,
                    style: this.styles,
                    directives: [{
                      name: "show",
                      value: this.isActive
                    }]
                  };
                  if (!this.coloredBorder) {
                    var setColor = this.hasText ? this.setTextColor : this.setBackgroundColor;
                    data = setColor(this.computedColor, data);
                  }
                  return this.$createElement("div", data, [this.genWrapper()]);
                },
                /** @public */
                toggle: function toggle() {
                  this.isActive = !this.isActive;
                }
              },
              render: function render8(h) {
                var render9 = this.genAlert();
                if (!this.transition)
                  return render9;
                return h("transition", {
                  props: {
                    name: this.transition,
                    origin: this.origin,
                    mode: this.mode
                  }
                }, [render9]);
              }
            });
          }
        ),
        /***/
        "./src/components/VAlert/index.ts": (
          /*!****************************************!*\
            !*** ./src/components/VAlert/index.ts ***!
            \****************************************/
          /*! exports provided: VAlert, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VAlert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VAlert */
              "./src/components/VAlert/VAlert.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VAlert", function() {
              return _VAlert__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VAlert__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VApp/VApp.sass": (
          /*!***************************************!*\
            !*** ./src/components/VApp/VApp.sass ***!
            \***************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VApp/VApp.ts": (
          /*!*************************************!*\
            !*** ./src/components/VApp/VApp.ts ***!
            \*************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VApp.sass */
              "./src/components/VApp/VApp.sass"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
              name: "v-app",
              props: {
                dark: {
                  type: Boolean,
                  default: void 0
                },
                id: {
                  type: String,
                  default: "app"
                },
                light: {
                  type: Boolean,
                  default: void 0
                }
              },
              computed: {
                isDark: function isDark() {
                  return this.$vuetify.theme.dark;
                }
              },
              beforeCreate: function beforeCreate() {
                if (!this.$vuetify || this.$vuetify === this.$root) {
                  throw new Error("Vuetify is not properly initialized, see https://v2.vuetifyjs.com/getting-started/quick-start#bootstrapping-the-vuetify-object");
                }
              },
              render: function render8(h) {
                var wrapper = h("div", {
                  staticClass: "v-application--wrap"
                }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this));
                return h("div", {
                  staticClass: "v-application",
                  class: __assign2({
                    "v-application--is-rtl": this.$vuetify.rtl,
                    "v-application--is-ltr": !this.$vuetify.rtl
                  }, this.themeClasses),
                  attrs: {
                    "data-app": true
                  },
                  domProps: {
                    id: this.id
                  }
                }, [wrapper]);
              }
            });
          }
        ),
        /***/
        "./src/components/VApp/index.ts": (
          /*!**************************************!*\
            !*** ./src/components/VApp/index.ts ***!
            \**************************************/
          /*! exports provided: VApp, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VApp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VApp */
              "./src/components/VApp/VApp.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VApp", function() {
              return _VApp__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VApp__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VAppBar/VAppBar.sass": (
          /*!*********************************************!*\
            !*** ./src/components/VAppBar/VAppBar.sass ***!
            \*********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VAppBar/VAppBar.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VAppBar/VAppBar.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VAppBar.sass */
              "./src/components/VAppBar/VAppBar.sass"
            );
            var _VToolbar_VToolbar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VToolbar/VToolbar */
              "./src/components/VToolbar/VToolbar.ts"
            );
            var _directives_scroll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../directives/scroll */
              "./src/directives/scroll/index.ts"
            );
            var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/applicationable */
              "./src/mixins/applicationable/index.ts"
            );
            var _mixins_scrollable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/scrollable */
              "./src/mixins/scrollable/index.ts"
            );
            var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/ssr-bootable */
              "./src/mixins/ssr-bootable/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__["default"])(_VToolbar_VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_scrollable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__["default"], Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_3__["default"])("top", ["clippedLeft", "clippedRight", "computedHeight", "invertedScroll", "isExtended", "isProminent", "value"]));
            __webpack_exports__["default"] = baseMixins.extend({
              name: "v-app-bar",
              directives: {
                Scroll: _directives_scroll__WEBPACK_IMPORTED_MODULE_2__["default"]
              },
              provide: function provide() {
                return {
                  VAppBar: this
                };
              },
              props: {
                clippedLeft: Boolean,
                clippedRight: Boolean,
                collapseOnScroll: Boolean,
                elevateOnScroll: Boolean,
                fadeImgOnScroll: Boolean,
                hideOnScroll: Boolean,
                invertedScroll: Boolean,
                scrollOffScreen: Boolean,
                shrinkOnScroll: Boolean,
                value: {
                  type: Boolean,
                  default: true
                }
              },
              data: function data() {
                return {
                  isActive: this.value
                };
              },
              computed: {
                applicationProperty: function applicationProperty() {
                  return !this.bottom ? "top" : "bottom";
                },
                canScroll: function canScroll() {
                  return _mixins_scrollable__WEBPACK_IMPORTED_MODULE_4__["default"].options.computed.canScroll.call(this) && (this.invertedScroll || this.elevateOnScroll || this.hideOnScroll || this.collapseOnScroll || this.isBooted || // If falsy, user has provided an
                  // explicit value which should
                  // overwrite anything we do
                  !this.value);
                },
                classes: function classes() {
                  return __assign2(__assign2({}, _VToolbar_VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-toolbar--collapse": this.collapse || this.collapseOnScroll,
                    "v-app-bar": true,
                    "v-app-bar--clipped": this.clippedLeft || this.clippedRight,
                    "v-app-bar--fade-img-on-scroll": this.fadeImgOnScroll,
                    "v-app-bar--elevate-on-scroll": this.elevateOnScroll,
                    "v-app-bar--fixed": !this.absolute && (this.app || this.fixed),
                    "v-app-bar--hide-shadow": this.hideShadow,
                    "v-app-bar--is-scrolled": this.currentScroll > 0,
                    "v-app-bar--shrink-on-scroll": this.shrinkOnScroll
                  });
                },
                scrollRatio: function scrollRatio() {
                  var threshold = this.computedScrollThreshold;
                  return Math.max((threshold - this.currentScroll) / threshold, 0);
                },
                computedContentHeight: function computedContentHeight() {
                  if (!this.shrinkOnScroll)
                    return _VToolbar_VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.computedContentHeight.call(this);
                  var min2 = this.dense ? 48 : 56;
                  var max2 = this.computedOriginalHeight;
                  return min2 + (max2 - min2) * this.scrollRatio;
                },
                computedFontSize: function computedFontSize() {
                  if (!this.isProminent)
                    return void 0;
                  var min2 = 1.25;
                  var max2 = 1.5;
                  return min2 + (max2 - min2) * this.scrollRatio;
                },
                computedLeft: function computedLeft() {
                  if (!this.app || this.clippedLeft)
                    return 0;
                  return this.$vuetify.application.left;
                },
                computedMarginTop: function computedMarginTop() {
                  if (!this.app)
                    return 0;
                  return this.$vuetify.application.bar;
                },
                computedOpacity: function computedOpacity() {
                  if (!this.fadeImgOnScroll)
                    return void 0;
                  return this.scrollRatio;
                },
                computedOriginalHeight: function computedOriginalHeight() {
                  var height = _VToolbar_VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.computedContentHeight.call(this);
                  if (this.isExtended)
                    height += parseInt(this.extensionHeight);
                  return height;
                },
                computedRight: function computedRight() {
                  if (!this.app || this.clippedRight)
                    return 0;
                  return this.$vuetify.application.right;
                },
                computedScrollThreshold: function computedScrollThreshold() {
                  if (this.scrollThreshold)
                    return Number(this.scrollThreshold);
                  return this.computedOriginalHeight - (this.dense ? 48 : 56);
                },
                computedTransform: function computedTransform() {
                  if (!this.canScroll || this.elevateOnScroll && this.currentScroll === 0 && this.isActive)
                    return 0;
                  if (this.isActive)
                    return 0;
                  var scrollOffScreen = this.scrollOffScreen ? this.computedHeight : this.computedContentHeight;
                  return this.bottom ? scrollOffScreen : -scrollOffScreen;
                },
                hideShadow: function hideShadow() {
                  if (this.elevateOnScroll && this.isExtended) {
                    return this.currentScroll < this.computedScrollThreshold;
                  }
                  if (this.elevateOnScroll) {
                    return this.currentScroll === 0 || this.computedTransform < 0;
                  }
                  return (!this.isExtended || this.scrollOffScreen) && this.computedTransform !== 0;
                },
                isCollapsed: function isCollapsed() {
                  if (!this.collapseOnScroll) {
                    return _VToolbar_VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.isCollapsed.call(this);
                  }
                  return this.currentScroll > 0;
                },
                isProminent: function isProminent() {
                  return _VToolbar_VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.isProminent.call(this) || this.shrinkOnScroll;
                },
                styles: function styles() {
                  return __assign2(__assign2({}, _VToolbar_VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.styles.call(this)), {
                    fontSize: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.computedFontSize, "rem"),
                    marginTop: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.computedMarginTop),
                    transform: "translateY(" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.computedTransform) + ")",
                    left: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.computedLeft),
                    right: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.computedRight)
                  });
                }
              },
              watch: {
                canScroll: "onScroll",
                computedTransform: function computedTransform() {
                  if (!this.canScroll || !this.clippedLeft && !this.clippedRight)
                    return;
                  this.callUpdate();
                },
                invertedScroll: function invertedScroll(val) {
                  this.isActive = !val || this.currentScroll !== 0;
                },
                hideOnScroll: function hideOnScroll(val) {
                  this.isActive = !val || this.currentScroll < this.computedScrollThreshold;
                }
              },
              created: function created2() {
                if (this.invertedScroll)
                  this.isActive = false;
              },
              methods: {
                genBackground: function genBackground() {
                  var render8 = _VToolbar_VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genBackground.call(this);
                  render8.data = this._b(render8.data || {}, render8.tag, {
                    style: {
                      opacity: this.computedOpacity
                    }
                  });
                  return render8;
                },
                updateApplication: function updateApplication() {
                  return this.invertedScroll ? 0 : this.computedHeight + this.computedTransform;
                },
                thresholdMet: function thresholdMet() {
                  if (this.invertedScroll) {
                    this.isActive = this.currentScroll > this.computedScrollThreshold;
                    return;
                  }
                  if (this.hideOnScroll) {
                    this.isActive = this.isScrollingUp || this.currentScroll < this.computedScrollThreshold;
                  }
                  if (this.currentThreshold < this.computedScrollThreshold)
                    return;
                  this.savedScroll = this.currentScroll;
                }
              },
              render: function render8(h) {
                var render9 = _VToolbar_VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"].options.render.call(this, h);
                render9.data = render9.data || {};
                if (this.canScroll) {
                  render9.data.directives = render9.data.directives || [];
                  render9.data.directives.push({
                    arg: this.scrollTarget,
                    name: "scroll",
                    value: this.onScroll
                  });
                }
                return render9;
              }
            });
          }
        ),
        /***/
        "./src/components/VAppBar/VAppBarNavIcon.ts": (
          /*!**************************************************!*\
            !*** ./src/components/VAppBar/VAppBarNavIcon.ts ***!
            \**************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _VBtn_VBtn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VBtn/VBtn */
              "./src/components/VBtn/VBtn.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_2___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend({
              name: "v-app-bar-nav-icon",
              functional: true,
              render: function render8(h, _a2) {
                var slots = _a2.slots, listeners = _a2.listeners, props2 = _a2.props, data = _a2.data;
                var d2 = Object.assign(data, {
                  staticClass: ("v-app-bar__nav-icon " + (data.staticClass || "")).trim(),
                  props: __assign2(__assign2({}, props2), {
                    icon: true
                  }),
                  on: listeners
                });
                var defaultSlot = slots().default;
                return h(_VBtn_VBtn__WEBPACK_IMPORTED_MODULE_1__["default"], d2, defaultSlot || [h(_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"], "$menu")]);
              }
            });
          }
        ),
        /***/
        "./src/components/VAppBar/VAppBarTitle.ts": (
          /*!************************************************!*\
            !*** ./src/components/VAppBar/VAppBarTitle.ts ***!
            \************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_registrable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../mixins/registrable */
              "./src/mixins/registrable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _services_goto_easing_patterns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../services/goto/easing-patterns */
              "./src/services/goto/easing-patterns.ts"
            );
            var base = Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_0__["inject"])("VAppBar", "v-app-bar-title", "v-app-bar");
            __webpack_exports__["default"] = base.extend().extend({
              name: "v-app-bar-title",
              data: function data() {
                return {
                  contentWidth: 0,
                  left: 0,
                  width: 0
                };
              },
              watch: {
                "$vuetify.breakpoint.width": "updateDimensions"
              },
              computed: {
                styles: function styles() {
                  if (!this.contentWidth)
                    return {};
                  var min2 = this.width;
                  var max2 = this.contentWidth;
                  var ratio = Object(_services_goto_easing_patterns__WEBPACK_IMPORTED_MODULE_2__["easeInOutCubic"])(Math.min(1, this.VAppBar.scrollRatio * 1.5));
                  return {
                    width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["convertToUnit"])(min2 + (max2 - min2) * ratio),
                    visibility: this.VAppBar.scrollRatio ? "visible" : "hidden"
                  };
                }
              },
              mounted: function mounted3() {
                this.updateDimensions();
              },
              methods: {
                updateDimensions: function updateDimensions() {
                  var dimensions = this.$refs.placeholder.getBoundingClientRect();
                  this.width = dimensions.width;
                  this.left = dimensions.left;
                  this.contentWidth = this.$refs.content.scrollWidth;
                }
              },
              render: function render8(h) {
                return h("div", {
                  class: "v-toolbar__title v-app-bar-title"
                }, [h("div", {
                  class: "v-app-bar-title__content",
                  style: this.styles,
                  ref: "content"
                }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getSlot"])(this)), h("div", {
                  class: "v-app-bar-title__placeholder",
                  style: {
                    visibility: this.VAppBar.scrollRatio ? "hidden" : "visible"
                  },
                  ref: "placeholder"
                }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getSlot"])(this))]);
              }
            });
          }
        ),
        /***/
        "./src/components/VAppBar/index.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VAppBar/index.ts ***!
            \*****************************************/
          /*! exports provided: VAppBar, VAppBarNavIcon, VAppBarTitle, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VAppBar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VAppBar */
              "./src/components/VAppBar/VAppBar.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VAppBar", function() {
              return _VAppBar__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VAppBarNavIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VAppBarNavIcon */
              "./src/components/VAppBar/VAppBarNavIcon.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VAppBarNavIcon", function() {
              return _VAppBarNavIcon__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _VAppBarTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VAppBarTitle */
              "./src/components/VAppBar/VAppBarTitle.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VAppBarTitle", function() {
              return _VAppBarTitle__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VAppBar: _VAppBar__WEBPACK_IMPORTED_MODULE_0__["default"],
                VAppBarNavIcon: _VAppBarNavIcon__WEBPACK_IMPORTED_MODULE_1__["default"],
                VAppBarTitle: _VAppBarTitle__WEBPACK_IMPORTED_MODULE_2__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VAutocomplete/VAutocomplete.sass": (
          /*!*********************************************************!*\
            !*** ./src/components/VAutocomplete/VAutocomplete.sass ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VAutocomplete/VAutocomplete.ts": (
          /*!*******************************************************!*\
            !*** ./src/components/VAutocomplete/VAutocomplete.ts ***!
            \*******************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VAutocomplete.sass */
              "./src/components/VAutocomplete/VAutocomplete.sass"
            );
            var _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSelect/VSelect */
              "./src/components/VSelect/VSelect.ts"
            );
            var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VTextField/VTextField */
              "./src/components/VTextField/VTextField.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var defaultMenuProps = __assign2(__assign2({}, _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["defaultMenuProps"]), {
              offsetY: true,
              offsetOverflow: true,
              transition: false
            });
            __webpack_exports__["default"] = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
              name: "v-autocomplete",
              props: {
                autoSelectFirst: {
                  type: Boolean,
                  default: false
                },
                filter: {
                  type: Function,
                  default: function _default(item, queryText, itemText) {
                    return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
                  }
                },
                hideNoData: Boolean,
                menuProps: {
                  type: _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.props.menuProps.type,
                  default: function _default() {
                    return defaultMenuProps;
                  }
                },
                noFilter: Boolean,
                searchInput: {
                  type: String
                }
              },
              data: function data() {
                return {
                  lazySearch: this.searchInput
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-autocomplete": true,
                    "v-autocomplete--is-selecting-index": this.selectedIndex > -1
                  });
                },
                computedItems: function computedItems() {
                  return this.filteredItems;
                },
                selectedValues: function selectedValues() {
                  var _this2 = this;
                  return this.selectedItems.map(function(item) {
                    return _this2.getValue(item);
                  });
                },
                hasDisplayedItems: function hasDisplayedItems() {
                  var _this2 = this;
                  return this.hideSelected ? this.filteredItems.some(function(item) {
                    return !_this2.hasItem(item);
                  }) : this.filteredItems.length > 0;
                },
                currentRange: function currentRange() {
                  if (this.selectedItem == null)
                    return 0;
                  return String(this.getText(this.selectedItem)).length;
                },
                filteredItems: function filteredItems() {
                  var _this2 = this;
                  if (!this.isSearching || this.noFilter || this.internalSearch == null)
                    return this.allItems;
                  return this.allItems.filter(function(item) {
                    var value = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getPropertyFromItem"])(item, _this2.itemText);
                    var text2 = value != null ? String(value) : "";
                    return _this2.filter(item, String(_this2.internalSearch), text2);
                  });
                },
                internalSearch: {
                  get: function get5() {
                    return this.lazySearch;
                  },
                  set: function set2(val) {
                    if (this.lazySearch !== val) {
                      this.lazySearch = val;
                      this.$emit("update:search-input", val);
                    }
                  }
                },
                isAnyValueAllowed: function isAnyValueAllowed() {
                  return false;
                },
                isDirty: function isDirty() {
                  return this.searchIsDirty || this.selectedItems.length > 0;
                },
                isSearching: function isSearching() {
                  return this.multiple && this.searchIsDirty || this.searchIsDirty && this.internalSearch !== this.getText(this.selectedItem);
                },
                menuCanShow: function menuCanShow() {
                  if (!this.isFocused)
                    return false;
                  return this.hasDisplayedItems || !this.hideNoData;
                },
                $_menuProps: function $_menuProps() {
                  var props2 = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.$_menuProps.call(this);
                  props2.contentClass = ("v-autocomplete__content " + (props2.contentClass || "")).trim();
                  return __assign2(__assign2({}, defaultMenuProps), props2);
                },
                searchIsDirty: function searchIsDirty() {
                  return this.internalSearch != null && this.internalSearch !== "";
                },
                selectedItem: function selectedItem() {
                  var _this2 = this;
                  if (this.multiple)
                    return null;
                  return this.selectedItems.find(function(i2) {
                    return _this2.valueComparator(_this2.getValue(i2), _this2.getValue(_this2.internalValue));
                  });
                },
                listData: function listData() {
                  var data = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.listData.call(this);
                  data.props = __assign2(__assign2({}, data.props), {
                    items: this.virtualizedItems,
                    noFilter: this.noFilter || !this.isSearching || !this.filteredItems.length,
                    searchInput: this.internalSearch
                  });
                  return data;
                }
              },
              watch: {
                filteredItems: "onFilteredItemsChanged",
                internalValue: "setSearch",
                isFocused: function isFocused(val) {
                  if (val) {
                    document.addEventListener("copy", this.onCopy);
                    this.$refs.input && this.$refs.input.select();
                  } else {
                    document.removeEventListener("copy", this.onCopy);
                    this.blur();
                    this.updateSelf();
                  }
                },
                isMenuActive: function isMenuActive(val) {
                  if (val || !this.hasSlot)
                    return;
                  this.lazySearch = null;
                },
                items: function items(val, oldVal) {
                  if (!(oldVal && oldVal.length) && this.hideNoData && this.isFocused && !this.isMenuActive && val.length)
                    this.activateMenu();
                },
                searchInput: function searchInput(val) {
                  this.lazySearch = val;
                },
                internalSearch: "onInternalSearchChanged",
                itemText: "updateSelf"
              },
              created: function created2() {
                this.setSearch();
              },
              destroyed: function destroyed2() {
                document.removeEventListener("copy", this.onCopy);
              },
              methods: {
                onFilteredItemsChanged: function onFilteredItemsChanged(val, oldVal) {
                  var _this2 = this;
                  if (val === oldVal)
                    return;
                  if (!this.autoSelectFirst) {
                    var preSelectedItem_1 = oldVal[this.$refs.menu.listIndex];
                    if (preSelectedItem_1) {
                      this.setMenuIndex(val.findIndex(function(i2) {
                        return i2 === preSelectedItem_1;
                      }));
                    } else {
                      this.setMenuIndex(-1);
                    }
                    this.$emit("update:list-index", this.$refs.menu.listIndex);
                  }
                  this.$nextTick(function() {
                    if (!_this2.internalSearch || val.length !== 1 && !_this2.autoSelectFirst)
                      return;
                    _this2.$refs.menu.getTiles();
                    if (_this2.autoSelectFirst && val.length) {
                      _this2.setMenuIndex(0);
                      _this2.$emit("update:list-index", _this2.$refs.menu.listIndex);
                    }
                  });
                },
                onInternalSearchChanged: function onInternalSearchChanged() {
                  this.updateMenuDimensions();
                },
                updateMenuDimensions: function updateMenuDimensions() {
                  this.isMenuActive && this.$refs.menu && this.$refs.menu.updateDimensions();
                },
                changeSelectedIndex: function changeSelectedIndex(keyCode) {
                  if (this.searchIsDirty)
                    return;
                  if (this.multiple && keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].left) {
                    if (this.selectedIndex === -1) {
                      this.selectedIndex = this.selectedItems.length - 1;
                    } else {
                      this.selectedIndex--;
                    }
                  } else if (this.multiple && keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].right) {
                    if (this.selectedIndex >= this.selectedItems.length - 1) {
                      this.selectedIndex = -1;
                    } else {
                      this.selectedIndex++;
                    }
                  } else if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].backspace || keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].delete) {
                    this.deleteCurrentItem();
                  }
                },
                deleteCurrentItem: function deleteCurrentItem() {
                  var curIndex = this.selectedIndex;
                  var curItem = this.selectedItems[curIndex];
                  if (!this.isInteractive || this.getDisabled(curItem))
                    return;
                  var lastIndex = this.selectedItems.length - 1;
                  if (this.selectedIndex === -1 && lastIndex !== 0) {
                    this.selectedIndex = lastIndex;
                    return;
                  }
                  var length = this.selectedItems.length;
                  var nextIndex = curIndex !== length - 1 ? curIndex : curIndex - 1;
                  var nextItem = this.selectedItems[nextIndex];
                  if (!nextItem) {
                    this.setValue(this.multiple ? [] : null);
                  } else {
                    this.selectItem(curItem);
                  }
                  this.selectedIndex = nextIndex;
                },
                clearableCallback: function clearableCallback() {
                  this.internalSearch = null;
                  _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.clearableCallback.call(this);
                },
                genInput: function genInput() {
                  var input2 = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genInput.call(this);
                  input2.data = Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_3__["default"])(input2.data, {
                    attrs: {
                      "aria-activedescendant": Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(this.$refs.menu, "activeTile.id"),
                      autocomplete: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(input2.data, "attrs.autocomplete", "off")
                    },
                    domProps: {
                      value: this.internalSearch
                    }
                  });
                  return input2;
                },
                genInputSlot: function genInputSlot() {
                  var slot = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genInputSlot.call(this);
                  slot.data.attrs.role = "combobox";
                  return slot;
                },
                genSelections: function genSelections() {
                  return this.hasSlot || this.multiple ? _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genSelections.call(this) : [];
                },
                onClick: function onClick(e) {
                  if (!this.isInteractive)
                    return;
                  this.selectedIndex > -1 ? this.selectedIndex = -1 : this.onFocus();
                  if (!this.isAppendInner(e.target))
                    this.activateMenu();
                },
                onInput: function onInput(e) {
                  if (this.selectedIndex > -1 || !e.target)
                    return;
                  var target2 = e.target;
                  var value = target2.value;
                  if (target2.value)
                    this.activateMenu();
                  if (!this.multiple && value === "")
                    this.deleteCurrentItem();
                  this.internalSearch = value;
                  this.badInput = target2.validity && target2.validity.badInput;
                },
                onKeyDown: function onKeyDown(e) {
                  var keyCode = e.keyCode;
                  if (e.ctrlKey || ![_util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].home, _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].end].includes(keyCode)) {
                    _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onKeyDown.call(this, e);
                  }
                  this.changeSelectedIndex(keyCode);
                },
                onSpaceDown: function onSpaceDown(e) {
                },
                onTabDown: function onTabDown(e) {
                  _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onTabDown.call(this, e);
                  this.updateSelf();
                },
                onUpDown: function onUpDown(e) {
                  e.preventDefault();
                  this.activateMenu();
                },
                selectItem: function selectItem(item) {
                  _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.selectItem.call(this, item);
                  this.setSearch();
                },
                setSelectedItems: function setSelectedItems() {
                  _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.setSelectedItems.call(this);
                  if (!this.isFocused)
                    this.setSearch();
                },
                setSearch: function setSearch() {
                  var _this2 = this;
                  this.$nextTick(function() {
                    if (!_this2.multiple || !_this2.internalSearch || !_this2.isMenuActive) {
                      _this2.internalSearch = !_this2.selectedItems.length || _this2.multiple || _this2.hasSlot ? null : _this2.getText(_this2.selectedItem);
                    }
                  });
                },
                updateSelf: function updateSelf() {
                  if (!this.searchIsDirty && !this.internalValue)
                    return;
                  if (!this.multiple && !this.valueComparator(this.internalSearch, this.getValue(this.internalValue))) {
                    this.setSearch();
                  }
                },
                hasItem: function hasItem(item) {
                  return this.selectedValues.indexOf(this.getValue(item)) > -1;
                },
                onCopy: function onCopy(event) {
                  var _a2, _b2;
                  if (this.selectedIndex === -1)
                    return;
                  var currentItem = this.selectedItems[this.selectedIndex];
                  var currentItemText = this.getText(currentItem);
                  (_a2 = event.clipboardData) === null || _a2 === void 0 ? void 0 : _a2.setData("text/plain", currentItemText);
                  (_b2 = event.clipboardData) === null || _b2 === void 0 ? void 0 : _b2.setData("text/vnd.vuetify.autocomplete.item+plain", currentItemText);
                  event.preventDefault();
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VAutocomplete/index.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VAutocomplete/index.ts ***!
            \***********************************************/
          /*! exports provided: VAutocomplete, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VAutocomplete__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VAutocomplete */
              "./src/components/VAutocomplete/VAutocomplete.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VAutocomplete", function() {
              return _VAutocomplete__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VAutocomplete__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VAvatar/VAvatar.sass": (
          /*!*********************************************!*\
            !*** ./src/components/VAvatar/VAvatar.sass ***!
            \*********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VAvatar/VAvatar.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VAvatar/VAvatar.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VAvatar.sass */
              "./src/components/VAvatar/VAvatar.sass"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_measurable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/measurable */
              "./src/mixins/measurable/index.ts"
            );
            var _mixins_roundable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/roundable */
              "./src/mixins/roundable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_measurable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_roundable__WEBPACK_IMPORTED_MODULE_3__["default"]).extend({
              name: "v-avatar",
              props: {
                left: Boolean,
                right: Boolean,
                size: {
                  type: [Number, String],
                  default: 48
                }
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-avatar--left": this.left,
                    "v-avatar--right": this.right
                  }, this.roundedClasses);
                },
                styles: function styles() {
                  return __assign2({
                    height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.size),
                    minWidth: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.size),
                    width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.size)
                  }, this.measurableStyles);
                }
              },
              render: function render8(h) {
                var data = {
                  staticClass: "v-avatar",
                  class: this.classes,
                  style: this.styles,
                  on: this.$listeners
                };
                return h("div", this.setBackgroundColor(this.color, data), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getSlot"])(this));
              }
            });
          }
        ),
        /***/
        "./src/components/VAvatar/index.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VAvatar/index.ts ***!
            \*****************************************/
          /*! exports provided: VAvatar, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VAvatar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VAvatar */
              "./src/components/VAvatar/VAvatar.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VAvatar", function() {
              return _VAvatar__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VAvatar__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VBadge/VBadge.sass": (
          /*!*******************************************!*\
            !*** ./src/components/VBadge/VBadge.sass ***!
            \*******************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VBadge/VBadge.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VBadge/VBadge.ts ***!
            \*****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VBadge.sass */
              "./src/components/VBadge/VBadge.sass"
            );
            var _VIcon_VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VIcon/VIcon */
              "./src/components/VIcon/VIcon.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _mixins_transitionable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/transitionable */
              "./src/mixins/transitionable/index.ts"
            );
            var _mixins_positionable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/positionable */
              "./src/mixins/positionable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __rest = function(s2, e) {
              var t3 = {};
              for (var p in s2) {
                if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
                  t3[p] = s2[p];
              }
              if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
                for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
                  if (e.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
                    t3[p[i2]] = s2[p[i2]];
                }
              return t3;
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_7__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], Object(_mixins_positionable__WEBPACK_IMPORTED_MODULE_6__["factory"])(["left", "bottom"]), _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_transitionable__WEBPACK_IMPORTED_MODULE_5__["default"]).extend({
              name: "v-badge",
              props: {
                avatar: Boolean,
                bordered: Boolean,
                color: {
                  type: String,
                  default: "primary"
                },
                content: {
                  required: false
                },
                dot: Boolean,
                label: {
                  type: String,
                  default: "$vuetify.badge"
                },
                icon: String,
                inline: Boolean,
                offsetX: [Number, String],
                offsetY: [Number, String],
                overlap: Boolean,
                tile: Boolean,
                transition: {
                  type: String,
                  default: "scale-rotate-transition"
                },
                value: {
                  default: true
                }
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-badge--avatar": this.avatar,
                    "v-badge--bordered": this.bordered,
                    "v-badge--bottom": this.bottom,
                    "v-badge--dot": this.dot,
                    "v-badge--icon": this.icon != null,
                    "v-badge--inline": this.inline,
                    "v-badge--left": this.left,
                    "v-badge--overlap": this.overlap,
                    "v-badge--tile": this.tile
                  }, this.themeClasses);
                },
                computedBottom: function computedBottom() {
                  return this.bottom ? "auto" : this.computedYOffset;
                },
                computedLeft: function computedLeft() {
                  if (this.isRtl) {
                    return this.left ? this.computedXOffset : "auto";
                  }
                  return this.left ? "auto" : this.computedXOffset;
                },
                computedRight: function computedRight() {
                  if (this.isRtl) {
                    return this.left ? "auto" : this.computedXOffset;
                  }
                  return !this.left ? "auto" : this.computedXOffset;
                },
                computedTop: function computedTop() {
                  return this.bottom ? this.computedYOffset : "auto";
                },
                computedXOffset: function computedXOffset() {
                  return this.calcPosition(this.offsetX);
                },
                computedYOffset: function computedYOffset() {
                  return this.calcPosition(this.offsetY);
                },
                isRtl: function isRtl() {
                  return this.$vuetify.rtl;
                },
                // Default fallback if offsetX
                // or offsetY are undefined.
                offset: function offset2() {
                  if (this.overlap)
                    return this.dot ? 8 : 12;
                  return this.dot ? 2 : 4;
                },
                styles: function styles() {
                  if (this.inline)
                    return {};
                  return {
                    bottom: this.computedBottom,
                    left: this.computedLeft,
                    right: this.computedRight,
                    top: this.computedTop
                  };
                }
              },
              methods: {
                calcPosition: function calcPosition(offset2) {
                  return "calc(100% - " + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["convertToUnit"])(offset2 || this.offset) + ")";
                },
                genBadge: function genBadge() {
                  var lang = this.$vuetify.lang;
                  var label = this.$attrs["aria-label"] || lang.t(this.label);
                  var data = this.setBackgroundColor(this.color, {
                    staticClass: "v-badge__badge",
                    style: this.styles,
                    attrs: {
                      "aria-atomic": this.$attrs["aria-atomic"] || "true",
                      "aria-label": label,
                      "aria-live": this.$attrs["aria-live"] || "polite",
                      title: this.$attrs.title,
                      role: this.$attrs.role || "status"
                    },
                    directives: [{
                      name: "show",
                      value: this.isActive
                    }]
                  });
                  var badge = this.$createElement("span", data, [this.genBadgeContent()]);
                  if (!this.transition)
                    return badge;
                  return this.$createElement("transition", {
                    props: {
                      name: this.transition,
                      origin: this.origin,
                      mode: this.mode
                    }
                  }, [badge]);
                },
                genBadgeContent: function genBadgeContent() {
                  if (this.dot)
                    return void 0;
                  var slot = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getSlot"])(this, "badge");
                  if (slot)
                    return slot;
                  if (this.content)
                    return String(this.content);
                  if (this.icon)
                    return this.$createElement(_VIcon_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.icon);
                  return void 0;
                },
                genBadgeWrapper: function genBadgeWrapper() {
                  return this.$createElement("span", {
                    staticClass: "v-badge__wrapper"
                  }, [this.genBadge()]);
                }
              },
              render: function render8(h) {
                var badge = [this.genBadgeWrapper()];
                var children = [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getSlot"])(this)];
                var _a2 = this.$attrs;
                _a2["aria-atomic"];
                _a2["aria-label"];
                _a2["aria-live"];
                _a2.role;
                _a2.title;
                var attrs2 = __rest(_a2, ["aria-atomic", "aria-label", "aria-live", "role", "title"]);
                if (this.inline && this.left)
                  children.unshift(badge);
                else
                  children.push(badge);
                return h("span", {
                  staticClass: "v-badge",
                  attrs: attrs2,
                  class: this.classes
                }, children);
              }
            });
          }
        ),
        /***/
        "./src/components/VBadge/index.ts": (
          /*!****************************************!*\
            !*** ./src/components/VBadge/index.ts ***!
            \****************************************/
          /*! exports provided: VBadge, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VBadge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VBadge */
              "./src/components/VBadge/VBadge.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBadge", function() {
              return _VBadge__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VBadge__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VBanner/VBanner.sass": (
          /*!*********************************************!*\
            !*** ./src/components/VBanner/VBanner.sass ***!
            \*********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VBanner/VBanner.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VBanner/VBanner.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VBanner.sass */
              "./src/components/VBanner/VBanner.sass"
            );
            var _VSheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSheet */
              "./src/components/VSheet/index.ts"
            );
            var _VAvatar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VAvatar */
              "./src/components/VAvatar/index.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _transitions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../transitions */
              "./src/components/transitions/index.ts"
            );
            var _mixins_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/mobile */
              "./src/mixins/mobile/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_7__["default"])(_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_mobile__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__["default"]).extend({
              name: "v-banner",
              inheritAttrs: false,
              props: {
                app: Boolean,
                icon: String,
                iconColor: String,
                singleLine: Boolean,
                sticky: Boolean,
                value: {
                  type: Boolean,
                  default: true
                }
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-banner--has-icon": this.hasIcon,
                    "v-banner--is-mobile": this.isMobile,
                    "v-banner--single-line": this.singleLine,
                    "v-banner--sticky": this.isSticky
                  });
                },
                hasIcon: function hasIcon() {
                  return Boolean(this.icon || this.$slots.icon || this.$scopedSlots.icon);
                },
                isSticky: function isSticky() {
                  return this.sticky || this.app;
                },
                styles: function styles() {
                  var styles2 = __assign2({}, _VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.styles.call(this));
                  if (this.isSticky) {
                    var top = !this.app ? 0 : this.$vuetify.application.bar + this.$vuetify.application.top;
                    styles2.top = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["convertToUnit"])(top);
                    styles2.position = "sticky";
                    styles2.zIndex = 1;
                  }
                  return styles2;
                }
              },
              methods: {
                /** @public */
                toggle: function toggle() {
                  this.isActive = !this.isActive;
                },
                iconClick: function iconClick(e) {
                  this.$emit("click:icon", e);
                },
                genIcon: function genIcon() {
                  if (!this.hasIcon)
                    return void 0;
                  var content;
                  if (this.icon) {
                    content = this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
                      props: {
                        color: this.iconColor,
                        size: 28
                      }
                    }, [this.icon]);
                  } else {
                    content = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getSlot"])(this, "icon");
                  }
                  return this.$createElement(_VAvatar__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    staticClass: "v-banner__icon",
                    props: {
                      color: this.color,
                      size: 40
                    },
                    on: {
                      click: this.iconClick
                    }
                  }, [content]);
                },
                genText: function genText() {
                  return this.$createElement("div", {
                    staticClass: "v-banner__text"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getSlot"])(this));
                },
                genActions: function genActions() {
                  var _this2 = this;
                  var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getSlot"])(this, "actions", {
                    dismiss: function dismiss() {
                      return _this2.isActive = false;
                    }
                  });
                  if (!children)
                    return void 0;
                  return this.$createElement("div", {
                    staticClass: "v-banner__actions"
                  }, children);
                },
                genContent: function genContent() {
                  return this.$createElement("div", {
                    staticClass: "v-banner__content"
                  }, [this.genIcon(), this.genText()]);
                },
                genWrapper: function genWrapper() {
                  return this.$createElement("div", {
                    staticClass: "v-banner__wrapper"
                  }, [this.genContent(), this.genActions()]);
                }
              },
              render: function render8(h) {
                var data = {
                  staticClass: "v-banner",
                  attrs: this.attrs$,
                  class: this.classes,
                  style: this.styles,
                  directives: [{
                    name: "show",
                    value: this.isActive
                  }]
                };
                return h(_transitions__WEBPACK_IMPORTED_MODULE_4__["VExpandTransition"], [h("div", this.outlined ? data : this.setBackgroundColor(this.color, data), [this.genWrapper()])]);
              }
            });
          }
        ),
        /***/
        "./src/components/VBanner/index.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VBanner/index.ts ***!
            \*****************************************/
          /*! exports provided: VBanner, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VBanner__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VBanner */
              "./src/components/VBanner/VBanner.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBanner", function() {
              return _VBanner__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VBanner__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VBottomNavigation/VBottomNavigation.sass": (
          /*!*****************************************************************!*\
            !*** ./src/components/VBottomNavigation/VBottomNavigation.sass ***!
            \*****************************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VBottomNavigation/VBottomNavigation.ts": (
          /*!***************************************************************!*\
            !*** ./src/components/VBottomNavigation/VBottomNavigation.ts ***!
            \***************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VBottomNavigation.sass */
              "./src/components/VBottomNavigation/VBottomNavigation.sass"
            );
            var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/applicationable */
              "./src/mixins/applicationable/index.ts"
            );
            var _mixins_button_group__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/button-group */
              "./src/mixins/button-group/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_measurable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/measurable */
              "./src/mixins/measurable/index.ts"
            );
            var _mixins_proxyable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/proxyable */
              "./src/mixins/proxyable/index.ts"
            );
            var _mixins_scrollable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/scrollable */
              "./src/mixins/scrollable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_9__["default"])(
              Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__["default"])("bottom", ["height", "inputValue"]),
              _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"],
              _mixins_measurable__WEBPACK_IMPORTED_MODULE_4__["default"],
              Object(_mixins_toggleable__WEBPACK_IMPORTED_MODULE_8__["factory"])("inputValue"),
              _mixins_proxyable__WEBPACK_IMPORTED_MODULE_5__["default"],
              _mixins_scrollable__WEBPACK_IMPORTED_MODULE_6__["default"],
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_7__["default"]
              /* @vue/component */
            ).extend({
              name: "v-bottom-navigation",
              props: {
                activeClass: {
                  type: String,
                  default: "v-btn--active"
                },
                backgroundColor: String,
                grow: Boolean,
                height: {
                  type: [Number, String],
                  default: 56
                },
                hideOnScroll: Boolean,
                horizontal: Boolean,
                inputValue: {
                  type: Boolean,
                  default: true
                },
                mandatory: Boolean,
                shift: Boolean,
                tag: {
                  type: String,
                  default: "div"
                }
              },
              data: function data() {
                return {
                  isActive: this.inputValue
                };
              },
              computed: {
                canScroll: function canScroll() {
                  return _mixins_scrollable__WEBPACK_IMPORTED_MODULE_6__["default"].options.computed.canScroll.call(this) && (this.hideOnScroll || !this.inputValue);
                },
                classes: function classes() {
                  return {
                    "v-bottom-navigation--absolute": this.absolute,
                    "v-bottom-navigation--grow": this.grow,
                    "v-bottom-navigation--fixed": !this.absolute && (this.app || this.fixed),
                    "v-bottom-navigation--horizontal": this.horizontal,
                    "v-bottom-navigation--shift": this.shift
                  };
                },
                styles: function styles() {
                  return __assign2(__assign2({}, this.measurableStyles), {
                    transform: this.isActive ? "none" : "translateY(100%)"
                  });
                }
              },
              watch: {
                canScroll: "onScroll"
              },
              created: function created2() {
                if (this.$attrs.hasOwnProperty("active")) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_10__["breaking"])("active.sync", "value or v-model", this);
                }
              },
              methods: {
                thresholdMet: function thresholdMet() {
                  if (this.hideOnScroll) {
                    this.isActive = !this.isScrollingUp || this.currentScroll > this.computedScrollThreshold;
                    this.$emit("update:input-value", this.isActive);
                  }
                  if (this.currentThreshold < this.computedScrollThreshold)
                    return;
                  this.savedScroll = this.currentScroll;
                },
                updateApplication: function updateApplication() {
                  return this.$el ? this.$el.clientHeight : 0;
                },
                updateValue: function updateValue(val) {
                  this.$emit("change", val);
                }
              },
              render: function render8(h) {
                var data = this.setBackgroundColor(this.backgroundColor, {
                  staticClass: "v-bottom-navigation",
                  class: this.classes,
                  style: this.styles,
                  props: {
                    activeClass: this.activeClass,
                    mandatory: Boolean(this.mandatory || this.value !== void 0),
                    tag: this.tag,
                    value: this.internalValue
                  },
                  on: {
                    change: this.updateValue
                  }
                });
                if (this.canScroll) {
                  data.directives = data.directives || [];
                  data.directives.push({
                    arg: this.scrollTarget,
                    name: "scroll",
                    value: this.onScroll
                  });
                }
                return h(_mixins_button_group__WEBPACK_IMPORTED_MODULE_2__["default"], this.setTextColor(this.color, data), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_11__["getSlot"])(this));
              }
            });
          }
        ),
        /***/
        "./src/components/VBottomNavigation/index.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VBottomNavigation/index.ts ***!
            \***************************************************/
          /*! exports provided: VBottomNavigation, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VBottomNavigation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VBottomNavigation */
              "./src/components/VBottomNavigation/VBottomNavigation.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBottomNavigation", function() {
              return _VBottomNavigation__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VBottomNavigation__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VBottomSheet/VBottomSheet.sass": (
          /*!*******************************************************!*\
            !*** ./src/components/VBottomSheet/VBottomSheet.sass ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VBottomSheet/VBottomSheet.ts": (
          /*!*****************************************************!*\
            !*** ./src/components/VBottomSheet/VBottomSheet.ts ***!
            \*****************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VBottomSheet.sass */
              "./src/components/VBottomSheet/VBottomSheet.sass"
            );
            var _VDialog_VDialog__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VDialog/VDialog */
              "./src/components/VDialog/VDialog.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = _VDialog_VDialog__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
              name: "v-bottom-sheet",
              props: {
                inset: Boolean,
                maxWidth: [String, Number],
                transition: {
                  type: String,
                  default: "bottom-sheet-transition"
                }
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VDialog_VDialog__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-bottom-sheet": true,
                    "v-bottom-sheet--inset": this.inset
                  });
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VBottomSheet/index.ts": (
          /*!**********************************************!*\
            !*** ./src/components/VBottomSheet/index.ts ***!
            \**********************************************/
          /*! exports provided: VBottomSheet, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VBottomSheet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VBottomSheet */
              "./src/components/VBottomSheet/VBottomSheet.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBottomSheet", function() {
              return _VBottomSheet__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VBottomSheet__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VBreadcrumbs/VBreadcrumbs.sass": (
          /*!*******************************************************!*\
            !*** ./src/components/VBreadcrumbs/VBreadcrumbs.sass ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VBreadcrumbs/VBreadcrumbs.ts": (
          /*!*****************************************************!*\
            !*** ./src/components/VBreadcrumbs/VBreadcrumbs.ts ***!
            \*****************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VBreadcrumbs.sass */
              "./src/components/VBreadcrumbs/VBreadcrumbs.sass"
            );
            var _VBreadcrumbsItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VBreadcrumbsItem */
              "./src/components/VBreadcrumbs/VBreadcrumbsItem.ts"
            );
            var _VBreadcrumbsDivider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VBreadcrumbsDivider */
              "./src/components/VBreadcrumbs/VBreadcrumbsDivider.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]
              /* @vue/component */
            ).extend({
              name: "v-breadcrumbs",
              props: {
                divider: {
                  type: String,
                  default: "/"
                },
                items: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                large: Boolean
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-breadcrumbs--large": this.large
                  }, this.themeClasses);
                }
              },
              methods: {
                genDivider: function genDivider() {
                  return this.$createElement(_VBreadcrumbsDivider__WEBPACK_IMPORTED_MODULE_2__["default"], this.$slots.divider ? this.$slots.divider : this.divider);
                },
                genItems: function genItems() {
                  var items = [];
                  var hasSlot = !!this.$scopedSlots.item;
                  var keys2 = [];
                  for (var i2 = 0; i2 < this.items.length; i2++) {
                    var item = this.items[i2];
                    keys2.push(item.text);
                    if (hasSlot)
                      items.push(this.$scopedSlots.item({
                        item
                      }));
                    else
                      items.push(this.$createElement(_VBreadcrumbsItem__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        key: keys2.join("."),
                        props: item
                      }, [item.text]));
                    if (i2 < this.items.length - 1)
                      items.push(this.genDivider());
                  }
                  return items;
                }
              },
              render: function render8(h) {
                var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this) || this.genItems();
                return h("ul", {
                  staticClass: "v-breadcrumbs",
                  class: this.classes
                }, children);
              }
            });
          }
        ),
        /***/
        "./src/components/VBreadcrumbs/VBreadcrumbsDivider.ts": (
          /*!************************************************************!*\
            !*** ./src/components/VBreadcrumbs/VBreadcrumbsDivider.ts ***!
            \************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])("v-breadcrumbs__divider", "li");
          }
        ),
        /***/
        "./src/components/VBreadcrumbs/VBreadcrumbsItem.ts": (
          /*!*********************************************************!*\
            !*** ./src/components/VBreadcrumbs/VBreadcrumbsItem.ts ***!
            \*********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_routable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../mixins/routable */
              "./src/mixins/routable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_routable__WEBPACK_IMPORTED_MODULE_0__["default"]).extend({
              name: "v-breadcrumbs-item",
              props: {
                // In a breadcrumb, the currently
                // active item should be dimmed
                activeClass: {
                  type: String,
                  default: "v-breadcrumbs__item--disabled"
                },
                ripple: {
                  type: [Boolean, Object],
                  default: false
                }
              },
              computed: {
                classes: function classes() {
                  var _a2;
                  return _a2 = {
                    "v-breadcrumbs__item": true
                  }, _a2[this.activeClass] = this.disabled, _a2;
                }
              },
              render: function render8(h) {
                var _a2 = this.generateRouteLink(), tag = _a2.tag, data = _a2.data;
                return h("li", [h(tag, __assign2(__assign2({}, data), {
                  attrs: __assign2(__assign2({}, data.attrs), {
                    "aria-current": this.isActive && this.isLink ? "page" : void 0
                  })
                }), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["getSlot"])(this))]);
              }
            });
          }
        ),
        /***/
        "./src/components/VBreadcrumbs/index.ts": (
          /*!**********************************************!*\
            !*** ./src/components/VBreadcrumbs/index.ts ***!
            \**********************************************/
          /*! exports provided: VBreadcrumbs, VBreadcrumbsItem, VBreadcrumbsDivider, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VBreadcrumbs */
              "./src/components/VBreadcrumbs/VBreadcrumbs.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBreadcrumbs", function() {
              return _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VBreadcrumbsItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VBreadcrumbsItem */
              "./src/components/VBreadcrumbs/VBreadcrumbsItem.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBreadcrumbsItem", function() {
              return _VBreadcrumbsItem__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _VBreadcrumbsDivider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VBreadcrumbsDivider */
              "./src/components/VBreadcrumbs/VBreadcrumbsDivider.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBreadcrumbsDivider", function() {
              return _VBreadcrumbsDivider__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VBreadcrumbs: _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__["default"],
                VBreadcrumbsItem: _VBreadcrumbsItem__WEBPACK_IMPORTED_MODULE_1__["default"],
                VBreadcrumbsDivider: _VBreadcrumbsDivider__WEBPACK_IMPORTED_MODULE_2__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VBtn/VBtn.sass": (
          /*!***************************************!*\
            !*** ./src/components/VBtn/VBtn.sass ***!
            \***************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VBtn/VBtn.ts": (
          /*!*************************************!*\
            !*** ./src/components/VBtn/VBtn.ts ***!
            \*************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VBtn.sass */
              "./src/components/VBtn/VBtn.sass"
            );
            var _VSheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSheet */
              "./src/components/VSheet/index.ts"
            );
            var _VProgressCircular__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VProgressCircular */
              "./src/components/VProgressCircular/index.ts"
            );
            var _mixins_groupable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/groupable */
              "./src/mixins/groupable/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _mixins_elevatable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/elevatable */
              "./src/mixins/elevatable/index.ts"
            );
            var _mixins_positionable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/positionable */
              "./src/mixins/positionable/index.ts"
            );
            var _mixins_routable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../mixins/routable */
              "./src/mixins/routable/index.ts"
            );
            var _mixins_sizeable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../mixins/sizeable */
              "./src/mixins/sizeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_9__["default"])(
              _VSheet__WEBPACK_IMPORTED_MODULE_1__["default"],
              _mixins_routable__WEBPACK_IMPORTED_MODULE_7__["default"],
              _mixins_positionable__WEBPACK_IMPORTED_MODULE_6__["default"],
              _mixins_sizeable__WEBPACK_IMPORTED_MODULE_8__["default"],
              Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_3__["factory"])("btnToggle"),
              Object(_mixins_toggleable__WEBPACK_IMPORTED_MODULE_4__["factory"])("inputValue")
              /* @vue/component */
            );
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-btn",
              props: {
                activeClass: {
                  type: String,
                  default: function _default() {
                    if (!this.btnToggle)
                      return "";
                    return this.btnToggle.activeClass;
                  }
                },
                block: Boolean,
                depressed: Boolean,
                fab: Boolean,
                icon: Boolean,
                loading: Boolean,
                outlined: Boolean,
                plain: Boolean,
                retainFocusOnClick: Boolean,
                rounded: Boolean,
                tag: {
                  type: String,
                  default: "button"
                },
                text: Boolean,
                tile: Boolean,
                type: {
                  type: String,
                  default: "button"
                },
                value: null
              },
              data: function data() {
                return {
                  proxyClass: "v-btn--active"
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2(__assign2(__assign2(__assign2(__assign2({
                    "v-btn": true
                  }, _mixins_routable__WEBPACK_IMPORTED_MODULE_7__["default"].options.computed.classes.call(this)), {
                    "v-btn--absolute": this.absolute,
                    "v-btn--block": this.block,
                    "v-btn--bottom": this.bottom,
                    "v-btn--disabled": this.disabled,
                    "v-btn--is-elevated": this.isElevated,
                    "v-btn--fab": this.fab,
                    "v-btn--fixed": this.fixed,
                    "v-btn--has-bg": this.hasBg,
                    "v-btn--icon": this.icon,
                    "v-btn--left": this.left,
                    "v-btn--loading": this.loading,
                    "v-btn--outlined": this.outlined,
                    "v-btn--plain": this.plain,
                    "v-btn--right": this.right,
                    "v-btn--round": this.isRound,
                    "v-btn--rounded": this.rounded,
                    "v-btn--router": this.to,
                    "v-btn--text": this.text,
                    "v-btn--tile": this.tile,
                    "v-btn--top": this.top
                  }), this.themeClasses), this.groupClasses), this.elevationClasses), this.sizeableClasses);
                },
                computedElevation: function computedElevation() {
                  if (this.disabled)
                    return void 0;
                  return _mixins_elevatable__WEBPACK_IMPORTED_MODULE_5__["default"].options.computed.computedElevation.call(this);
                },
                computedRipple: function computedRipple() {
                  var _a2;
                  var defaultRipple = this.icon || this.fab ? {
                    circle: true
                  } : true;
                  if (this.disabled)
                    return false;
                  else
                    return (_a2 = this.ripple) !== null && _a2 !== void 0 ? _a2 : defaultRipple;
                },
                hasBg: function hasBg() {
                  return !this.text && !this.plain && !this.outlined && !this.icon;
                },
                isElevated: function isElevated() {
                  return Boolean(!this.icon && !this.text && !this.outlined && !this.depressed && !this.disabled && !this.plain && (this.elevation == null || Number(this.elevation) > 0));
                },
                isRound: function isRound() {
                  return Boolean(this.icon || this.fab);
                },
                styles: function styles() {
                  return __assign2({}, this.measurableStyles);
                }
              },
              created: function created2() {
                var _this2 = this;
                var breakingProps = [["flat", "text"], ["outline", "outlined"], ["round", "rounded"]];
                breakingProps.forEach(function(_a2) {
                  var _b2 = __read2(_a2, 2), original = _b2[0], replacement = _b2[1];
                  if (_this2.$attrs.hasOwnProperty(original))
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_10__["breaking"])(original, replacement, _this2);
                });
              },
              methods: {
                click: function click2(e) {
                  !this.retainFocusOnClick && !this.fab && e.detail && this.$el.blur();
                  this.$emit("click", e);
                  this.btnToggle && this.toggle();
                },
                genContent: function genContent() {
                  return this.$createElement("span", {
                    staticClass: "v-btn__content"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_11__["getSlot"])(this));
                },
                genLoader: function genLoader() {
                  return this.$createElement("span", {
                    class: "v-btn__loader"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_11__["getSlot"])(this, "loader") || [this.$createElement(_VProgressCircular__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    props: {
                      indeterminate: true,
                      size: 23,
                      width: 2
                    }
                  })]);
                }
              },
              render: function render8(h) {
                var children = [this.genContent(), this.loading && this.genLoader()];
                var _a2 = this.generateRouteLink(), tag = _a2.tag, data = _a2.data;
                var setColor = this.hasBg ? this.setBackgroundColor : this.setTextColor;
                if (tag === "button") {
                  data.attrs.type = this.type;
                  data.attrs.disabled = this.disabled;
                }
                data.attrs.value = ["string", "number"].includes(_typeof2(this.value)) ? this.value : JSON.stringify(this.value);
                return h(tag, this.disabled ? data : setColor(this.color, data), children);
              }
            });
          }
        ),
        /***/
        "./src/components/VBtn/index.ts": (
          /*!**************************************!*\
            !*** ./src/components/VBtn/index.ts ***!
            \**************************************/
          /*! exports provided: VBtn, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VBtn */
              "./src/components/VBtn/VBtn.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBtn", function() {
              return _VBtn__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VBtn__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VBtnToggle/VBtnToggle.sass": (
          /*!***************************************************!*\
            !*** ./src/components/VBtnToggle/VBtnToggle.sass ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VBtnToggle/VBtnToggle.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VBtnToggle/VBtnToggle.ts ***!
            \*************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VBtnToggle.sass */
              "./src/components/VBtnToggle/VBtnToggle.sass"
            );
            var _mixins_button_group__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/button-group */
              "./src/mixins/button-group/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_button_group__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"]).extend({
              name: "v-btn-toggle",
              props: {
                backgroundColor: String,
                borderless: Boolean,
                dense: Boolean,
                group: Boolean,
                rounded: Boolean,
                shaped: Boolean,
                tile: Boolean
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2(__assign2({}, _mixins_button_group__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-btn-toggle": true,
                    "v-btn-toggle--borderless": this.borderless,
                    "v-btn-toggle--dense": this.dense,
                    "v-btn-toggle--group": this.group,
                    "v-btn-toggle--rounded": this.rounded,
                    "v-btn-toggle--shaped": this.shaped,
                    "v-btn-toggle--tile": this.tile
                  }), this.themeClasses);
                }
              },
              methods: {
                genData: function genData() {
                  var data = this.setTextColor(this.color, __assign2({}, _mixins_button_group__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genData.call(this)));
                  if (this.group)
                    return data;
                  return this.setBackgroundColor(this.backgroundColor, data);
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VBtnToggle/index.ts": (
          /*!********************************************!*\
            !*** ./src/components/VBtnToggle/index.ts ***!
            \********************************************/
          /*! exports provided: VBtnToggle, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VBtnToggle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VBtnToggle */
              "./src/components/VBtnToggle/VBtnToggle.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBtnToggle", function() {
              return _VBtnToggle__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VBtnToggle__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VCalendar/VCalendar.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VCalendar/VCalendar.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_calendar_with_events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./mixins/calendar-with-events */
              "./src/components/VCalendar/mixins/calendar-with-events.ts"
            );
            var _util_props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./util/props */
              "./src/components/VCalendar/util/props.ts"
            );
            var _util_timestamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./util/timestamp */
              "./src/components/VCalendar/util/timestamp.ts"
            );
            var _VCalendarMonthly__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VCalendarMonthly */
              "./src/components/VCalendar/VCalendarMonthly.ts"
            );
            var _VCalendarDaily__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./VCalendarDaily */
              "./src/components/VCalendar/VCalendarDaily.ts"
            );
            var _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./VCalendarWeekly */
              "./src/components/VCalendar/VCalendarWeekly.ts"
            );
            var _VCalendarCategory__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ./VCalendarCategory */
              "./src/components/VCalendar/VCalendarCategory.ts"
            );
            var _util_parser__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ./util/parser */
              "./src/components/VCalendar/util/parser.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = _mixins_calendar_with_events__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
              name: "v-calendar",
              props: __assign2(__assign2(__assign2(__assign2({}, _util_props__WEBPACK_IMPORTED_MODULE_1__["default"].calendar), _util_props__WEBPACK_IMPORTED_MODULE_1__["default"].weeks), _util_props__WEBPACK_IMPORTED_MODULE_1__["default"].intervals), _util_props__WEBPACK_IMPORTED_MODULE_1__["default"].category),
              data: function data() {
                return {
                  lastStart: null,
                  lastEnd: null
                };
              },
              computed: {
                parsedValue: function parsedValue() {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["validateTimestamp"])(this.value) ? Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["parseTimestamp"])(this.value, true) : this.parsedStart || this.times.today;
                },
                parsedCategoryDays: function parsedCategoryDays() {
                  return parseInt(this.categoryDays) || 1;
                },
                renderProps: function renderProps() {
                  var around = this.parsedValue;
                  var component = null;
                  var maxDays = this.maxDays;
                  var weekdays = this.parsedWeekdays;
                  var categories = this.parsedCategories;
                  var start = around;
                  var end = around;
                  switch (this.type) {
                    case "month":
                      component = _VCalendarMonthly__WEBPACK_IMPORTED_MODULE_3__["default"];
                      start = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["getStartOfMonth"])(around);
                      end = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["getEndOfMonth"])(around);
                      break;
                    case "week":
                      component = _VCalendarDaily__WEBPACK_IMPORTED_MODULE_4__["default"];
                      start = this.getStartOfWeek(around);
                      end = this.getEndOfWeek(around);
                      maxDays = 7;
                      break;
                    case "day":
                      component = _VCalendarDaily__WEBPACK_IMPORTED_MODULE_4__["default"];
                      maxDays = 1;
                      weekdays = [start.weekday];
                      break;
                    case "4day":
                      component = _VCalendarDaily__WEBPACK_IMPORTED_MODULE_4__["default"];
                      end = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["relativeDays"])(Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["copyTimestamp"])(end), _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["nextDay"], 3);
                      Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["updateFormatted"])(end);
                      maxDays = 4;
                      weekdays = [start.weekday, (start.weekday + 1) % 7, (start.weekday + 2) % 7, (start.weekday + 3) % 7];
                      break;
                    case "custom-weekly":
                      component = _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_5__["default"];
                      start = this.parsedStart || around;
                      end = this.parsedEnd;
                      break;
                    case "custom-daily":
                      component = _VCalendarDaily__WEBPACK_IMPORTED_MODULE_4__["default"];
                      start = this.parsedStart || around;
                      end = this.parsedEnd;
                      break;
                    case "category":
                      var days = this.parsedCategoryDays;
                      component = _VCalendarCategory__WEBPACK_IMPORTED_MODULE_6__["default"];
                      end = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["relativeDays"])(Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["copyTimestamp"])(end), _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["nextDay"], days);
                      Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["updateFormatted"])(end);
                      maxDays = days;
                      weekdays = [];
                      for (var i2 = 0; i2 < days; i2++) {
                        weekdays.push((start.weekday + i2) % 7);
                      }
                      categories = this.getCategoryList(categories);
                      break;
                    default:
                      throw new Error(this.type + " is not a valid Calendar type");
                  }
                  return {
                    component,
                    start,
                    end,
                    maxDays,
                    weekdays,
                    categories
                  };
                },
                eventWeekdays: function eventWeekdays() {
                  return this.renderProps.weekdays;
                },
                categoryMode: function categoryMode() {
                  return this.type === "category";
                },
                title: function title() {
                  var _a2 = this.renderProps, start = _a2.start, end = _a2.end;
                  var spanYears = start.year !== end.year;
                  var spanMonths = spanYears || start.month !== end.month;
                  if (spanYears) {
                    return this.monthShortFormatter(start, true) + " " + start.year + " - " + this.monthShortFormatter(end, true) + " " + end.year;
                  }
                  if (spanMonths) {
                    return this.monthShortFormatter(start, true) + " - " + this.monthShortFormatter(end, true) + " " + end.year;
                  } else {
                    return this.monthLongFormatter(start, false) + " " + start.year;
                  }
                },
                monthLongFormatter: function monthLongFormatter() {
                  return this.getFormatter({
                    timeZone: "UTC",
                    month: "long"
                  });
                },
                monthShortFormatter: function monthShortFormatter() {
                  return this.getFormatter({
                    timeZone: "UTC",
                    month: "short"
                  });
                },
                parsedCategories: function parsedCategories() {
                  return Object(_util_parser__WEBPACK_IMPORTED_MODULE_7__["getParsedCategories"])(this.categories, this.categoryText);
                }
              },
              watch: {
                renderProps: "checkChange"
              },
              mounted: function mounted3() {
                this.updateEventVisibility();
                this.checkChange();
              },
              updated: function updated3() {
                window.requestAnimationFrame(this.updateEventVisibility);
              },
              methods: {
                checkChange: function checkChange() {
                  var _a2 = this, lastStart = _a2.lastStart, lastEnd = _a2.lastEnd;
                  var _b2 = this.renderProps, start = _b2.start, end = _b2.end;
                  if (!lastStart || !lastEnd || start.date !== lastStart.date || end.date !== lastEnd.date) {
                    this.lastStart = start;
                    this.lastEnd = end;
                    this.$emit("change", {
                      start,
                      end
                    });
                  }
                },
                move: function move(amount) {
                  if (amount === void 0) {
                    amount = 1;
                  }
                  var moved2 = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["copyTimestamp"])(this.parsedValue);
                  var forward = amount > 0;
                  var mover = forward ? _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["nextDay"] : _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["prevDay"];
                  var limit = forward ? _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["DAYS_IN_MONTH_MAX"] : _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["DAY_MIN"];
                  var times = forward ? amount : -amount;
                  while (--times >= 0) {
                    switch (this.type) {
                      case "month":
                        moved2.day = limit;
                        mover(moved2);
                        break;
                      case "week":
                        Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["relativeDays"])(moved2, mover, _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["DAYS_IN_WEEK"]);
                        break;
                      case "day":
                        Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["relativeDays"])(moved2, mover, 1);
                        break;
                      case "4day":
                        Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["relativeDays"])(moved2, mover, 4);
                        break;
                      case "category":
                        Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["relativeDays"])(moved2, mover, this.parsedCategoryDays);
                        break;
                    }
                  }
                  Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["updateWeekday"])(moved2);
                  Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["updateFormatted"])(moved2);
                  Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["updateRelative"])(moved2, this.times.now);
                  if (this.value instanceof Date) {
                    this.$emit("input", Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["timestampToDate"])(moved2));
                  } else if (typeof this.value === "number") {
                    this.$emit("input", Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["timestampToDate"])(moved2).getTime());
                  } else {
                    this.$emit("input", moved2.date);
                  }
                  this.$emit("moved", moved2);
                },
                next: function next(amount) {
                  if (amount === void 0) {
                    amount = 1;
                  }
                  this.move(amount);
                },
                prev: function prev(amount) {
                  if (amount === void 0) {
                    amount = 1;
                  }
                  this.move(-amount);
                },
                timeToY: function timeToY(time, clamp2) {
                  if (clamp2 === void 0) {
                    clamp2 = true;
                  }
                  var c = this.$children[0];
                  if (c && c.timeToY) {
                    return c.timeToY(time, clamp2);
                  } else {
                    return false;
                  }
                },
                timeDelta: function timeDelta(time) {
                  var c = this.$children[0];
                  if (c && c.timeDelta) {
                    return c.timeDelta(time);
                  } else {
                    return false;
                  }
                },
                minutesToPixels: function minutesToPixels(minutes) {
                  var c = this.$children[0];
                  if (c && c.minutesToPixels) {
                    return c.minutesToPixels(minutes);
                  } else {
                    return -1;
                  }
                },
                scrollToTime: function scrollToTime(time) {
                  var c = this.$children[0];
                  if (c && c.scrollToTime) {
                    return c.scrollToTime(time);
                  } else {
                    return false;
                  }
                },
                parseTimestamp: function parseTimestamp(input2, required) {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["parseTimestamp"])(input2, required, this.times.now);
                },
                timestampToDate: function timestampToDate(timestamp) {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["timestampToDate"])(timestamp);
                },
                getCategoryList: function getCategoryList(categories) {
                  var _this2 = this;
                  if (!this.noEvents) {
                    var categoryMap_1 = categories.reduce(function(map, category2, index2) {
                      if (_typeof2(category2) === "object" && category2.categoryName)
                        map[category2.categoryName] = {
                          index: index2,
                          count: 0
                        };
                      else if (typeof category2 === "string")
                        map[category2] = {
                          index: index2,
                          count: 0
                        };
                      return map;
                    }, {});
                    if (!this.categoryHideDynamic || !this.categoryShowAll) {
                      var categoryLength_1 = categories.length;
                      this.parsedEvents.forEach(function(ev) {
                        var category2 = ev.category;
                        if (typeof category2 !== "string") {
                          category2 = _this2.categoryForInvalid;
                        }
                        if (!category2) {
                          return;
                        }
                        if (category2 in categoryMap_1) {
                          categoryMap_1[category2].count++;
                        } else if (!_this2.categoryHideDynamic) {
                          categoryMap_1[category2] = {
                            index: categoryLength_1++,
                            count: 1
                          };
                        }
                      });
                    }
                    if (!this.categoryShowAll) {
                      for (var category in categoryMap_1) {
                        if (categoryMap_1[category].count === 0) {
                          delete categoryMap_1[category];
                        }
                      }
                    }
                    categories = categories.filter(function(category2) {
                      if (_typeof2(category2) === "object" && category2.categoryName) {
                        return categoryMap_1.hasOwnProperty(category2.categoryName);
                      } else if (typeof category2 === "string") {
                        return categoryMap_1.hasOwnProperty(category2);
                      }
                      return false;
                    });
                  }
                  return categories;
                }
              },
              render: function render8(h) {
                var _this2 = this;
                var _a2 = this.renderProps, start = _a2.start, end = _a2.end, maxDays = _a2.maxDays, component = _a2.component, weekdays = _a2.weekdays, categories = _a2.categories;
                return h(component, {
                  staticClass: "v-calendar",
                  class: {
                    "v-calendar-events": !this.noEvents
                  },
                  props: __assign2(__assign2({}, this.$props), {
                    start: start.date,
                    end: end.date,
                    maxDays,
                    weekdays,
                    categories
                  }),
                  attrs: {
                    role: "grid"
                  },
                  directives: [{
                    modifiers: {
                      quiet: true
                    },
                    name: "resize",
                    value: this.updateEventVisibility
                  }],
                  on: __assign2(__assign2({}, this.$listeners), {
                    "click:date": function clickDate(day, e) {
                      if (_this2.$listeners.input) {
                        _this2.$emit("input", day.date);
                      }
                      if (_this2.$listeners["click:date"]) {
                        _this2.$emit("click:date", day, e);
                      }
                    }
                  }),
                  scopedSlots: this.getScopedSlots()
                });
              }
            });
          }
        ),
        /***/
        "./src/components/VCalendar/VCalendarCategory.sass": (
          /*!*********************************************************!*\
            !*** ./src/components/VCalendar/VCalendarCategory.sass ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VCalendar/VCalendarCategory.ts": (
          /*!*******************************************************!*\
            !*** ./src/components/VCalendar/VCalendarCategory.ts ***!
            \*******************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VCalendarCategory.sass */
              "./src/components/VCalendar/VCalendarCategory.sass"
            );
            var _VCalendarDaily__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VCalendarDaily */
              "./src/components/VCalendar/VCalendarDaily.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_props__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./util/props */
              "./src/components/VCalendar/util/props.ts"
            );
            var _util_parser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./util/parser */
              "./src/components/VCalendar/util/parser.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            __webpack_exports__["default"] = _VCalendarDaily__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
              name: "v-calendar-category",
              props: _util_props__WEBPACK_IMPORTED_MODULE_3__["default"].category,
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-calendar-daily": true,
                    "v-calendar-category": true
                  }, this.themeClasses);
                },
                parsedCategories: function parsedCategories() {
                  return Object(_util_parser__WEBPACK_IMPORTED_MODULE_4__["getParsedCategories"])(this.categories, this.categoryText);
                }
              },
              methods: {
                genDayHeader: function genDayHeader(day, index2) {
                  var _this2 = this;
                  var data = {
                    staticClass: "v-calendar-category__columns"
                  };
                  var scope = __assign2(__assign2({
                    week: this.days
                  }, day), {
                    index: index2
                  });
                  var children = this.parsedCategories.map(function(category) {
                    return _this2.genDayHeaderCategory(day, _this2.getCategoryScope(scope, category));
                  });
                  return [this.$createElement("div", data, children)];
                },
                getCategoryScope: function getCategoryScope(scope, category) {
                  var cat = _typeof2(category) === "object" && category && category.categoryName === this.categoryForInvalid ? null : category;
                  return __assign2(__assign2({}, scope), {
                    category: cat
                  });
                },
                genDayHeaderCategory: function genDayHeaderCategory(day, scope) {
                  var _this2 = this;
                  var headerTitle = _typeof2(scope.category) === "object" ? scope.category.categoryName : scope.category;
                  return this.$createElement("div", {
                    staticClass: "v-calendar-category__column-header",
                    on: this.getDefaultMouseEventHandlers(":day-category", function(e) {
                      return _this2.getCategoryScope(_this2.getSlotScope(day), scope.category);
                    })
                  }, [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["getSlot"])(this, "category", scope) || this.genDayHeaderCategoryTitle(headerTitle), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["getSlot"])(this, "day-header", scope)]);
                },
                genDayHeaderCategoryTitle: function genDayHeaderCategoryTitle(categoryName) {
                  return this.$createElement("div", {
                    staticClass: "v-calendar-category__category"
                  }, categoryName === null ? this.categoryForInvalid : categoryName);
                },
                genDays: function genDays() {
                  var _this2 = this;
                  var days = [];
                  this.days.forEach(function(d2, j) {
                    var day = new Array(_this2.parsedCategories.length || 1);
                    day.fill(d2);
                    days.push.apply(days, __spreadArray2([], __read2(day.map(function(v, i2) {
                      return _this2.genDay(v, j, i2);
                    })), false));
                  });
                  return days;
                },
                genDay: function genDay(day, index2, categoryIndex) {
                  var _this2 = this;
                  var category = this.parsedCategories[categoryIndex];
                  return this.$createElement("div", {
                    key: day.date + "-" + categoryIndex,
                    staticClass: "v-calendar-daily__day",
                    class: this.getRelativeClasses(day),
                    on: this.getDefaultMouseEventHandlers(":time", function(e) {
                      return _this2.getSlotScope(_this2.getTimestampAtEvent(e, day));
                    })
                  }, __spreadArray2(__spreadArray2([], __read2(this.genDayIntervals(index2, category)), false), __read2(this.genDayBody(day, category)), false));
                },
                genDayIntervals: function genDayIntervals(index2, category) {
                  var _this2 = this;
                  return this.intervals[index2].map(function(v) {
                    return _this2.genDayInterval(v, category);
                  });
                },
                genDayInterval: function genDayInterval(interval, category) {
                  var _this2 = this;
                  var height = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["convertToUnit"])(this.intervalHeight);
                  var styler = this.intervalStyle || this.intervalStyleDefault;
                  var data = {
                    key: interval.time,
                    staticClass: "v-calendar-daily__day-interval",
                    style: __assign2({
                      height
                    }, styler(__assign2(__assign2({}, interval), {
                      category
                    })))
                  };
                  var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["getSlot"])(this, "interval", function() {
                    return _this2.getCategoryScope(_this2.getSlotScope(interval), category);
                  });
                  return this.$createElement("div", data, children);
                },
                genDayBody: function genDayBody(day, category) {
                  var data = {
                    staticClass: "v-calendar-category__columns"
                  };
                  var children = [this.genDayBodyCategory(day, category)];
                  return [this.$createElement("div", data, children)];
                },
                genDayBodyCategory: function genDayBodyCategory(day, category) {
                  var _this2 = this;
                  var data = {
                    staticClass: "v-calendar-category__column",
                    on: this.getDefaultMouseEventHandlers(":time-category", function(e) {
                      return _this2.getCategoryScope(_this2.getSlotScope(_this2.getTimestampAtEvent(e, day)), category);
                    })
                  };
                  var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["getSlot"])(this, "day-body", function() {
                    return _this2.getCategoryScope(_this2.getSlotScope(day), category);
                  });
                  return this.$createElement("div", data, children);
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VCalendar/VCalendarDaily.sass": (
          /*!******************************************************!*\
            !*** ./src/components/VCalendar/VCalendarDaily.sass ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VCalendar/VCalendarDaily.ts": (
          /*!****************************************************!*\
            !*** ./src/components/VCalendar/VCalendarDaily.ts ***!
            \****************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VCalendarDaily.sass */
              "./src/components/VCalendar/VCalendarDaily.sass"
            );
            var _directives_resize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../directives/resize */
              "./src/directives/resize/index.ts"
            );
            var _VBtn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VBtn */
              "./src/components/VBtn/index.ts"
            );
            var _mixins_calendar_with_intervals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./mixins/calendar-with-intervals */
              "./src/components/VCalendar/mixins/calendar-with-intervals.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            __webpack_exports__["default"] = _mixins_calendar_with_intervals__WEBPACK_IMPORTED_MODULE_3__["default"].extend({
              name: "v-calendar-daily",
              directives: {
                Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_1__["default"]
              },
              data: function data() {
                return {
                  scrollPush: 0
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-calendar-daily": true
                  }, this.themeClasses);
                }
              },
              mounted: function mounted3() {
                this.init();
              },
              methods: {
                init: function init2() {
                  this.$nextTick(this.onResize);
                },
                onResize: function onResize() {
                  this.scrollPush = this.getScrollPush();
                },
                getScrollPush: function getScrollPush() {
                  var area = this.$refs.scrollArea;
                  var pane = this.$refs.pane;
                  return area && pane ? area.offsetWidth - pane.offsetWidth : 0;
                },
                genHead: function genHead() {
                  return this.$createElement("div", {
                    staticClass: "v-calendar-daily__head",
                    style: {
                      marginRight: this.scrollPush + "px"
                    }
                  }, __spreadArray2([this.genHeadIntervals()], __read2(this.genHeadDays()), false));
                },
                genHeadIntervals: function genHeadIntervals() {
                  var width = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.intervalWidth);
                  return this.$createElement("div", {
                    staticClass: "v-calendar-daily__intervals-head",
                    style: {
                      width
                    }
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getSlot"])(this, "interval-header"));
                },
                genHeadDays: function genHeadDays() {
                  return this.days.map(this.genHeadDay);
                },
                genHeadDay: function genHeadDay(day, index2) {
                  var _this2 = this;
                  return this.$createElement("div", {
                    key: day.date,
                    staticClass: "v-calendar-daily_head-day",
                    class: this.getRelativeClasses(day),
                    on: this.getDefaultMouseEventHandlers(":day", function(nativeEvent) {
                      return __assign2({
                        nativeEvent
                      }, _this2.getSlotScope(day));
                    })
                  }, __spreadArray2([this.genHeadWeekday(day), this.genHeadDayLabel(day)], __read2(this.genDayHeader(day, index2)), false));
                },
                genDayHeader: function genDayHeader(day, index2) {
                  var _this2 = this;
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getSlot"])(this, "day-header", function() {
                    return __assign2(__assign2({
                      week: _this2.days
                    }, day), {
                      index: index2
                    });
                  }) || [];
                },
                genHeadWeekday: function genHeadWeekday(day) {
                  var color2 = day.present ? this.color : void 0;
                  return this.$createElement("div", this.setTextColor(color2, {
                    staticClass: "v-calendar-daily_head-weekday"
                  }), this.weekdayFormatter(day, this.shortWeekdays));
                },
                genHeadDayLabel: function genHeadDayLabel(day) {
                  return this.$createElement("div", {
                    staticClass: "v-calendar-daily_head-day-label"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getSlot"])(this, "day-label-header", day) || [this.genHeadDayButton(day)]);
                },
                genHeadDayButton: function genHeadDayButton(day) {
                  var color2 = day.present ? this.color : "transparent";
                  return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    props: {
                      color: color2,
                      fab: true,
                      depressed: true
                    },
                    on: this.getMouseEventHandlers({
                      "click:date": {
                        event: "click",
                        stop: true
                      },
                      "contextmenu:date": {
                        event: "contextmenu",
                        stop: true,
                        prevent: true,
                        result: false
                      }
                    }, function(nativeEvent) {
                      return __assign2({
                        nativeEvent
                      }, day);
                    })
                  }, this.dayFormatter(day, false));
                },
                genBody: function genBody() {
                  return this.$createElement("div", {
                    staticClass: "v-calendar-daily__body"
                  }, [this.genScrollArea()]);
                },
                genScrollArea: function genScrollArea() {
                  return this.$createElement("div", {
                    ref: "scrollArea",
                    staticClass: "v-calendar-daily__scroll-area"
                  }, [this.genPane()]);
                },
                genPane: function genPane() {
                  return this.$createElement("div", {
                    ref: "pane",
                    staticClass: "v-calendar-daily__pane",
                    style: {
                      height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.bodyHeight)
                    }
                  }, [this.genDayContainer()]);
                },
                genDayContainer: function genDayContainer() {
                  return this.$createElement("div", {
                    staticClass: "v-calendar-daily__day-container"
                  }, __spreadArray2([this.genBodyIntervals()], __read2(this.genDays()), false));
                },
                genDays: function genDays() {
                  return this.days.map(this.genDay);
                },
                genDay: function genDay(day, index2) {
                  var _this2 = this;
                  return this.$createElement("div", {
                    key: day.date,
                    staticClass: "v-calendar-daily__day",
                    class: this.getRelativeClasses(day),
                    on: this.getDefaultMouseEventHandlers(":time", function(nativeEvent) {
                      return __assign2({
                        nativeEvent
                      }, _this2.getSlotScope(_this2.getTimestampAtEvent(nativeEvent, day)));
                    })
                  }, __spreadArray2(__spreadArray2([], __read2(this.genDayIntervals(index2)), false), __read2(this.genDayBody(day)), false));
                },
                genDayBody: function genDayBody(day) {
                  var _this2 = this;
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getSlot"])(this, "day-body", function() {
                    return _this2.getSlotScope(day);
                  }) || [];
                },
                genDayIntervals: function genDayIntervals(index2) {
                  return this.intervals[index2].map(this.genDayInterval);
                },
                genDayInterval: function genDayInterval(interval) {
                  var _this2 = this;
                  var height = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.intervalHeight);
                  var styler = this.intervalStyle || this.intervalStyleDefault;
                  var data = {
                    key: interval.time,
                    staticClass: "v-calendar-daily__day-interval",
                    style: __assign2({
                      height
                    }, styler(interval))
                  };
                  var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getSlot"])(this, "interval", function() {
                    return _this2.getSlotScope(interval);
                  });
                  return this.$createElement("div", data, children);
                },
                genBodyIntervals: function genBodyIntervals() {
                  var _this2 = this;
                  var width = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.intervalWidth);
                  var data = {
                    staticClass: "v-calendar-daily__intervals-body",
                    style: {
                      width
                    },
                    on: this.getDefaultMouseEventHandlers(":interval", function(nativeEvent) {
                      return __assign2({
                        nativeEvent
                      }, _this2.getTimestampAtEvent(nativeEvent, _this2.parsedStart));
                    })
                  };
                  return this.$createElement("div", data, this.genIntervalLabels());
                },
                genIntervalLabels: function genIntervalLabels() {
                  if (!this.intervals.length)
                    return null;
                  return this.intervals[0].map(this.genIntervalLabel);
                },
                genIntervalLabel: function genIntervalLabel(interval) {
                  var height = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.intervalHeight);
                  var short = this.shortIntervals;
                  var shower = this.showIntervalLabel || this.showIntervalLabelDefault;
                  var show2 = shower(interval);
                  var label = show2 ? this.intervalFormatter(interval, short) : void 0;
                  return this.$createElement("div", {
                    key: interval.time,
                    staticClass: "v-calendar-daily__interval",
                    style: {
                      height
                    }
                  }, [this.$createElement("div", {
                    staticClass: "v-calendar-daily__interval-text"
                  }, label)]);
                }
              },
              render: function render8(h) {
                return h("div", {
                  class: this.classes,
                  on: {
                    dragstart: function dragstart(e) {
                      e.preventDefault();
                    }
                  },
                  directives: [{
                    modifiers: {
                      quiet: true
                    },
                    name: "resize",
                    value: this.onResize
                  }]
                }, [!this.hideHeader ? this.genHead() : "", this.genBody()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VCalendar/VCalendarMonthly.ts": (
          /*!******************************************************!*\
            !*** ./src/components/VCalendar/VCalendarMonthly.ts ***!
            \******************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VCalendarWeekly.sass */
              "./src/components/VCalendar/VCalendarWeekly.sass"
            );
            var _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VCalendarWeekly */
              "./src/components/VCalendar/VCalendarWeekly.ts"
            );
            var _util_timestamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./util/timestamp */
              "./src/components/VCalendar/util/timestamp.ts"
            );
            __webpack_exports__["default"] = _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
              name: "v-calendar-monthly",
              computed: {
                staticClass: function staticClass() {
                  return "v-calendar-monthly v-calendar-weekly";
                },
                parsedStart: function parsedStart() {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["getStartOfMonth"])(Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["parseTimestamp"])(this.start, true));
                },
                parsedEnd: function parsedEnd() {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["getEndOfMonth"])(Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["parseTimestamp"])(this.end, true));
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VCalendar/VCalendarWeekly.sass": (
          /*!*******************************************************!*\
            !*** ./src/components/VCalendar/VCalendarWeekly.sass ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VCalendar/VCalendarWeekly.ts": (
          /*!*****************************************************!*\
            !*** ./src/components/VCalendar/VCalendarWeekly.ts ***!
            \*****************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VCalendarWeekly.sass */
              "./src/components/VCalendar/VCalendarWeekly.sass"
            );
            var _VBtn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VBtn */
              "./src/components/VBtn/index.ts"
            );
            var _mixins_calendar_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./mixins/calendar-base */
              "./src/components/VCalendar/mixins/calendar-base.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_dateTimeUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/dateTimeUtils */
              "./src/util/dateTimeUtils.ts"
            );
            var _util_props__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./util/props */
              "./src/components/VCalendar/util/props.ts"
            );
            var _util_timestamp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ./util/timestamp */
              "./src/components/VCalendar/util/timestamp.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            __webpack_exports__["default"] = _mixins_calendar_base__WEBPACK_IMPORTED_MODULE_2__["default"].extend({
              name: "v-calendar-weekly",
              props: _util_props__WEBPACK_IMPORTED_MODULE_5__["default"].weeks,
              computed: {
                staticClass: function staticClass() {
                  return "v-calendar-weekly";
                },
                classes: function classes() {
                  return this.themeClasses;
                },
                parsedMinWeeks: function parsedMinWeeks() {
                  return parseInt(this.minWeeks);
                },
                days: function days() {
                  var minDays = this.parsedMinWeeks * this.parsedWeekdays.length;
                  var start = this.getStartOfWeek(this.parsedStart);
                  var end = this.getEndOfWeek(this.parsedEnd);
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["createDayList"])(start, end, this.times.today, this.weekdaySkips, Number.MAX_SAFE_INTEGER, minDays);
                },
                todayWeek: function todayWeek() {
                  var today = this.times.today;
                  var start = this.getStartOfWeek(today);
                  var end = this.getEndOfWeek(today);
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["createDayList"])(start, end, today, this.weekdaySkips, this.parsedWeekdays.length, this.parsedWeekdays.length);
                },
                monthFormatter: function monthFormatter() {
                  if (this.monthFormat) {
                    return this.monthFormat;
                  }
                  var longOptions = {
                    timeZone: "UTC",
                    month: "long"
                  };
                  var shortOptions = {
                    timeZone: "UTC",
                    month: "short"
                  };
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["createNativeLocaleFormatter"])(this.currentLocale, function(_tms, short) {
                    return short ? shortOptions : longOptions;
                  });
                }
              },
              methods: {
                isOutside: function isOutside(day) {
                  var dayIdentifier = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["getDayIdentifier"])(day);
                  return dayIdentifier < Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["getDayIdentifier"])(this.parsedStart) || dayIdentifier > Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_6__["getDayIdentifier"])(this.parsedEnd);
                },
                genHead: function genHead() {
                  return this.$createElement("div", {
                    staticClass: "v-calendar-weekly__head",
                    attrs: {
                      role: "row"
                    }
                  }, this.genHeadDays());
                },
                genHeadDays: function genHeadDays() {
                  var header = this.todayWeek.map(this.genHeadDay);
                  if (this.showWeek) {
                    header.unshift(this.$createElement("div", {
                      staticClass: "v-calendar-weekly__head-weeknumber"
                    }));
                  }
                  return header;
                },
                genHeadDay: function genHeadDay(day, index2) {
                  var outside = this.isOutside(this.days[index2]);
                  var color2 = day.present ? this.color : void 0;
                  return this.$createElement("div", this.setTextColor(color2, {
                    key: day.date,
                    staticClass: "v-calendar-weekly__head-weekday",
                    class: this.getRelativeClasses(day, outside),
                    attrs: {
                      role: "columnheader"
                    }
                  }), this.weekdayFormatter(day, this.shortWeekdays));
                },
                genWeeks: function genWeeks() {
                  var days = this.days;
                  var weekDays = this.parsedWeekdays.length;
                  var weeks = [];
                  for (var i2 = 0; i2 < days.length; i2 += weekDays) {
                    weeks.push(this.genWeek(days.slice(i2, i2 + weekDays), this.getWeekNumber(days[i2])));
                  }
                  return weeks;
                },
                genWeek: function genWeek(week, weekNumber) {
                  var _this2 = this;
                  var weekNodes = week.map(function(day, index2) {
                    return _this2.genDay(day, index2, week);
                  });
                  if (this.showWeek) {
                    weekNodes.unshift(this.genWeekNumber(weekNumber));
                  }
                  return this.$createElement("div", {
                    key: week[0].date,
                    staticClass: "v-calendar-weekly__week",
                    attrs: {
                      role: "row"
                    }
                  }, weekNodes);
                },
                getWeekNumber: function getWeekNumber(determineDay) {
                  return Object(_util_dateTimeUtils__WEBPACK_IMPORTED_MODULE_4__["weekNumber"])(determineDay.year, determineDay.month - 1, determineDay.day, this.parsedWeekdays[0], parseInt(this.localeFirstDayOfYear));
                },
                genWeekNumber: function genWeekNumber(weekNumber) {
                  return this.$createElement("div", {
                    staticClass: "v-calendar-weekly__weeknumber"
                  }, [this.$createElement("small", String(weekNumber))]);
                },
                genDay: function genDay(day, index2, week) {
                  var outside = this.isOutside(day);
                  return this.$createElement("div", {
                    key: day.date,
                    staticClass: "v-calendar-weekly__day",
                    class: this.getRelativeClasses(day, outside),
                    attrs: {
                      role: "cell"
                    },
                    on: this.getDefaultMouseEventHandlers(":day", function(nativeEvent) {
                      return __assign2({
                        nativeEvent
                      }, day);
                    })
                  }, __spreadArray2([this.genDayLabel(day)], __read2(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this, "day", function() {
                    return __assign2({
                      outside,
                      index: index2,
                      week
                    }, day);
                  }) || []), false));
                },
                genDayLabel: function genDayLabel(day) {
                  return this.$createElement("div", {
                    staticClass: "v-calendar-weekly__day-label"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this, "day-label", day) || [this.genDayLabelButton(day)]);
                },
                genDayLabelButton: function genDayLabelButton(day) {
                  var color2 = day.present ? this.color : "transparent";
                  var hasMonth = day.day === 1 && this.showMonthOnFirst;
                  return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: {
                      color: color2,
                      fab: true,
                      depressed: true,
                      small: true
                    },
                    on: this.getMouseEventHandlers({
                      "click:date": {
                        event: "click",
                        stop: true
                      },
                      "contextmenu:date": {
                        event: "contextmenu",
                        stop: true,
                        prevent: true,
                        result: false
                      }
                    }, function(nativeEvent) {
                      return __assign2({
                        nativeEvent
                      }, day);
                    })
                  }, hasMonth ? this.monthFormatter(day, this.shortMonths) + " " + this.dayFormatter(day, false) : this.dayFormatter(day, false));
                },
                genDayMonth: function genDayMonth(day) {
                  var color2 = day.present ? this.color : void 0;
                  return this.$createElement("div", this.setTextColor(color2, {
                    staticClass: "v-calendar-weekly__day-month"
                  }), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this, "day-month", day) || this.monthFormatter(day, this.shortMonths));
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: this.staticClass,
                  class: this.classes,
                  on: {
                    dragstart: function dragstart(e) {
                      e.preventDefault();
                    }
                  }
                }, __spreadArray2([!this.hideHeader ? this.genHead() : ""], __read2(this.genWeeks()), false));
              }
            });
          }
        ),
        /***/
        "./src/components/VCalendar/index.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VCalendar/index.ts ***!
            \*******************************************/
          /*! exports provided: VCalendar, VCalendarCategory, VCalendarDaily, VCalendarWeekly, VCalendarMonthly, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VCalendar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VCalendar */
              "./src/components/VCalendar/VCalendar.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCalendar", function() {
              return _VCalendar__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VCalendarDaily__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VCalendarDaily */
              "./src/components/VCalendar/VCalendarDaily.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCalendarDaily", function() {
              return _VCalendarDaily__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VCalendarWeekly */
              "./src/components/VCalendar/VCalendarWeekly.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCalendarWeekly", function() {
              return _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            var _VCalendarMonthly__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VCalendarMonthly */
              "./src/components/VCalendar/VCalendarMonthly.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCalendarMonthly", function() {
              return _VCalendarMonthly__WEBPACK_IMPORTED_MODULE_3__["default"];
            });
            var _VCalendarCategory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./VCalendarCategory */
              "./src/components/VCalendar/VCalendarCategory.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCalendarCategory", function() {
              return _VCalendarCategory__WEBPACK_IMPORTED_MODULE_4__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VCalendar: _VCalendar__WEBPACK_IMPORTED_MODULE_0__["default"],
                VCalendarCategory: _VCalendarCategory__WEBPACK_IMPORTED_MODULE_4__["default"],
                VCalendarDaily: _VCalendarDaily__WEBPACK_IMPORTED_MODULE_1__["default"],
                VCalendarWeekly: _VCalendarWeekly__WEBPACK_IMPORTED_MODULE_2__["default"],
                VCalendarMonthly: _VCalendarMonthly__WEBPACK_IMPORTED_MODULE_3__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VCalendar/mixins/calendar-base.ts": (
          /*!**********************************************************!*\
            !*** ./src/components/VCalendar/mixins/calendar-base.ts ***!
            \**********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _util_mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_localable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../../mixins/localable */
              "./src/mixins/localable/index.ts"
            );
            var _mixins_mouse__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../../mixins/mouse */
              "./src/mixins/mouse/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _times__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./times */
              "./src/components/VCalendar/mixins/times.ts"
            );
            var _directives_resize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../../directives/resize */
              "./src/directives/resize/index.ts"
            );
            var _util_props__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../util/props */
              "./src/components/VCalendar/util/props.ts"
            );
            var _util_timestamp__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../util/timestamp */
              "./src/components/VCalendar/util/timestamp.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_0__["default"])(
              _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"],
              _mixins_localable__WEBPACK_IMPORTED_MODULE_2__["default"],
              _mixins_mouse__WEBPACK_IMPORTED_MODULE_3__["default"],
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__["default"],
              _times__WEBPACK_IMPORTED_MODULE_5__["default"]
              /* @vue/component */
            ).extend({
              name: "calendar-base",
              directives: {
                Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_6__["default"]
              },
              props: _util_props__WEBPACK_IMPORTED_MODULE_7__["default"].base,
              computed: {
                parsedWeekdays: function parsedWeekdays() {
                  return Array.isArray(this.weekdays) ? this.weekdays : (this.weekdays || "").split(",").map(function(x2) {
                    return parseInt(x2, 10);
                  });
                },
                weekdaySkips: function weekdaySkips() {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_8__["getWeekdaySkips"])(this.parsedWeekdays);
                },
                weekdaySkipsReverse: function weekdaySkipsReverse() {
                  var reversed = this.weekdaySkips.slice();
                  reversed.reverse();
                  return reversed;
                },
                parsedStart: function parsedStart() {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_8__["parseTimestamp"])(this.start, true);
                },
                parsedEnd: function parsedEnd() {
                  var start = this.parsedStart;
                  var end = this.end ? Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_8__["parseTimestamp"])(this.end) || start : start;
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_8__["getTimestampIdentifier"])(end) < Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_8__["getTimestampIdentifier"])(start) ? start : end;
                },
                days: function days() {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_8__["createDayList"])(this.parsedStart, this.parsedEnd, this.times.today, this.weekdaySkips);
                },
                dayFormatter: function dayFormatter() {
                  if (this.dayFormat) {
                    return this.dayFormat;
                  }
                  var options = {
                    timeZone: "UTC",
                    day: "numeric"
                  };
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_8__["createNativeLocaleFormatter"])(this.currentLocale, function(_tms, _short) {
                    return options;
                  });
                },
                weekdayFormatter: function weekdayFormatter() {
                  if (this.weekdayFormat) {
                    return this.weekdayFormat;
                  }
                  var longOptions = {
                    timeZone: "UTC",
                    weekday: "long"
                  };
                  var shortOptions = {
                    timeZone: "UTC",
                    weekday: "short"
                  };
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_8__["createNativeLocaleFormatter"])(this.currentLocale, function(_tms, short) {
                    return short ? shortOptions : longOptions;
                  });
                }
              },
              methods: {
                getRelativeClasses: function getRelativeClasses(timestamp, outside) {
                  if (outside === void 0) {
                    outside = false;
                  }
                  return {
                    "v-present": timestamp.present,
                    "v-past": timestamp.past,
                    "v-future": timestamp.future,
                    "v-outside": outside
                  };
                },
                getStartOfWeek: function getStartOfWeek(timestamp) {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_8__["getStartOfWeek"])(timestamp, this.parsedWeekdays, this.times.today);
                },
                getEndOfWeek: function getEndOfWeek(timestamp) {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_8__["getEndOfWeek"])(timestamp, this.parsedWeekdays, this.times.today);
                },
                getFormatter: function getFormatter(options) {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_8__["createNativeLocaleFormatter"])(this.locale, function(_tms, _short) {
                    return options;
                  });
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VCalendar/mixins/calendar-with-events.sass": (
          /*!*******************************************************************!*\
            !*** ./src/components/VCalendar/mixins/calendar-with-events.sass ***!
            \*******************************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VCalendar/mixins/calendar-with-events.ts": (
          /*!*****************************************************************!*\
            !*** ./src/components/VCalendar/mixins/calendar-with-events.ts ***!
            \*****************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./calendar-with-events.sass */
              "./src/components/VCalendar/mixins/calendar-with-events.sass"
            );
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var _calendar_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./calendar-base */
              "./src/components/VCalendar/mixins/calendar-base.ts"
            );
            var _util_props__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../util/props */
              "./src/components/VCalendar/util/props.ts"
            );
            var _modes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../modes */
              "./src/components/VCalendar/modes/index.ts"
            );
            var _util_timestamp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../util/timestamp */
              "./src/components/VCalendar/util/timestamp.ts"
            );
            var _util_events__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../util/events */
              "./src/components/VCalendar/util/events.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var WIDTH_FULL = 100;
            var WIDTH_START = 95;
            var MINUTES_IN_DAY = 1440;
            __webpack_exports__["default"] = _calendar_base__WEBPACK_IMPORTED_MODULE_2__["default"].extend({
              name: "calendar-with-events",
              directives: {
                ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_1__["default"]
              },
              props: __assign2(__assign2(__assign2({}, _util_props__WEBPACK_IMPORTED_MODULE_3__["default"].events), _util_props__WEBPACK_IMPORTED_MODULE_3__["default"].calendar), _util_props__WEBPACK_IMPORTED_MODULE_3__["default"].category),
              computed: {
                noEvents: function noEvents() {
                  return this.events.length === 0;
                },
                parsedEvents: function parsedEvents() {
                  return this.events.map(this.parseEvent);
                },
                parsedEventOverlapThreshold: function parsedEventOverlapThreshold() {
                  return parseInt(this.eventOverlapThreshold);
                },
                eventTimedFunction: function eventTimedFunction() {
                  var _this2 = this;
                  return typeof this.eventTimed === "function" ? this.eventTimed : function(event) {
                    return !!event[_this2.eventTimed];
                  };
                },
                eventCategoryFunction: function eventCategoryFunction() {
                  var _this2 = this;
                  return typeof this.eventCategory === "function" ? this.eventCategory : function(event) {
                    return event[_this2.eventCategory];
                  };
                },
                eventTextColorFunction: function eventTextColorFunction() {
                  var _this2 = this;
                  return typeof this.eventTextColor === "function" ? this.eventTextColor : function() {
                    return _this2.eventTextColor;
                  };
                },
                eventNameFunction: function eventNameFunction() {
                  var _this2 = this;
                  return typeof this.eventName === "function" ? this.eventName : function(event, timedEvent) {
                    return event.input[_this2.eventName] || "";
                  };
                },
                eventModeFunction: function eventModeFunction() {
                  return typeof this.eventOverlapMode === "function" ? this.eventOverlapMode : _modes__WEBPACK_IMPORTED_MODULE_4__["CalendarEventOverlapModes"][this.eventOverlapMode];
                },
                eventWeekdays: function eventWeekdays() {
                  return this.parsedWeekdays;
                },
                categoryMode: function categoryMode() {
                  return this.type === "category";
                }
              },
              methods: {
                eventColorFunction: function eventColorFunction(e) {
                  return typeof this.eventColor === "function" ? this.eventColor(e) : e.color || this.eventColor;
                },
                parseEvent: function parseEvent(input2, index2) {
                  if (index2 === void 0) {
                    index2 = 0;
                  }
                  return Object(_util_events__WEBPACK_IMPORTED_MODULE_6__["parseEvent"])(input2, index2, this.eventStart, this.eventEnd, this.eventTimedFunction(input2), this.categoryMode ? this.eventCategoryFunction(input2) : false);
                },
                formatTime: function formatTime(withTime, ampm) {
                  var formatter = this.getFormatter({
                    timeZone: "UTC",
                    hour: "numeric",
                    minute: withTime.minute > 0 ? "numeric" : void 0
                  });
                  return formatter(withTime, true);
                },
                updateEventVisibility: function updateEventVisibility() {
                  if (this.noEvents || !this.eventMore) {
                    return;
                  }
                  var eventHeight = this.eventHeight;
                  var eventsMap = this.getEventsMap();
                  for (var date in eventsMap) {
                    var _a2 = eventsMap[date], parent2 = _a2.parent, events2 = _a2.events, more = _a2.more;
                    if (!more) {
                      break;
                    }
                    var parentBounds = parent2.getBoundingClientRect();
                    var last2 = events2.length - 1;
                    var eventsSorted = events2.map(function(event) {
                      return {
                        event,
                        bottom: event.getBoundingClientRect().bottom
                      };
                    }).sort(function(a, b) {
                      return a.bottom - b.bottom;
                    });
                    var hidden = 0;
                    for (var i2 = 0; i2 <= last2; i2++) {
                      var bottom = eventsSorted[i2].bottom;
                      var hide = i2 === last2 ? bottom > parentBounds.bottom : bottom + eventHeight > parentBounds.bottom;
                      if (hide) {
                        eventsSorted[i2].event.style.display = "none";
                        hidden++;
                      }
                    }
                    if (hidden) {
                      more.style.display = "";
                      more.innerHTML = this.$vuetify.lang.t(this.eventMoreText, hidden);
                    } else {
                      more.style.display = "none";
                    }
                  }
                },
                getEventsMap: function getEventsMap() {
                  var eventsMap = {};
                  var elements = this.$refs.events;
                  if (!elements || !elements.forEach) {
                    return eventsMap;
                  }
                  elements.forEach(function(el) {
                    var date = el.getAttribute("data-date");
                    if (el.parentElement && date) {
                      if (!(date in eventsMap)) {
                        eventsMap[date] = {
                          parent: el.parentElement,
                          more: null,
                          events: []
                        };
                      }
                      if (el.getAttribute("data-more")) {
                        eventsMap[date].more = el;
                      } else {
                        eventsMap[date].events.push(el);
                        el.style.display = "";
                      }
                    }
                  });
                  return eventsMap;
                },
                genDayEvent: function genDayEvent(_a2, day) {
                  var event = _a2.event;
                  var eventHeight = this.eventHeight;
                  var eventMarginBottom = this.eventMarginBottom;
                  var dayIdentifier = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_5__["getDayIdentifier"])(day);
                  var week = day.week;
                  var start = dayIdentifier === event.startIdentifier;
                  var end = dayIdentifier === event.endIdentifier;
                  var width = WIDTH_START;
                  if (!this.categoryMode) {
                    for (var i2 = day.index + 1; i2 < week.length; i2++) {
                      var weekdayIdentifier = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_5__["getDayIdentifier"])(week[i2]);
                      if (event.endIdentifier >= weekdayIdentifier) {
                        width += WIDTH_FULL;
                        end = end || weekdayIdentifier === event.endIdentifier;
                      } else {
                        end = true;
                        break;
                      }
                    }
                  }
                  var scope = {
                    eventParsed: event,
                    day,
                    start,
                    end,
                    timed: false
                  };
                  return this.genEvent(event, scope, false, {
                    staticClass: "v-event",
                    class: {
                      "v-event-start": start,
                      "v-event-end": end
                    },
                    style: {
                      height: eventHeight + "px",
                      width: width + "%",
                      "margin-bottom": eventMarginBottom + "px"
                    },
                    attrs: {
                      "data-date": day.date
                    },
                    key: event.index,
                    ref: "events",
                    refInFor: true
                  });
                },
                genTimedEvent: function genTimedEvent(_a2, day) {
                  var event = _a2.event, left = _a2.left, width = _a2.width;
                  if (day.timeDelta(event.end) < 0 || day.timeDelta(event.start) >= 1 || Object(_util_events__WEBPACK_IMPORTED_MODULE_6__["isEventHiddenOn"])(event, day)) {
                    return false;
                  }
                  var dayIdentifier = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_5__["getDayIdentifier"])(day);
                  var start = event.startIdentifier >= dayIdentifier;
                  var end = event.endIdentifier > dayIdentifier;
                  var top = start ? day.timeToY(event.start) : 0;
                  var bottom = end ? day.timeToY(MINUTES_IN_DAY) : day.timeToY(event.end);
                  var height = Math.max(this.eventHeight, bottom - top);
                  var scope = {
                    eventParsed: event,
                    day,
                    start,
                    end,
                    timed: true
                  };
                  return this.genEvent(event, scope, true, {
                    staticClass: "v-event-timed",
                    style: {
                      top: top + "px",
                      height: height + "px",
                      left: left + "%",
                      width: width + "%"
                    }
                  });
                },
                genEvent: function genEvent(event, scopeInput, timedEvent, data) {
                  var _this2 = this;
                  var _a2;
                  var slot = this.$scopedSlots.event;
                  var text2 = this.eventTextColorFunction(event.input);
                  var background = this.eventColorFunction(event.input);
                  var overlapsNoon = event.start.hour < 12 && event.end.hour >= 12;
                  var singline = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_5__["diffMinutes"])(event.start, event.end) <= this.parsedEventOverlapThreshold;
                  var formatTime = this.formatTime;
                  var timeSummary = function timeSummary2() {
                    return formatTime(event.start, overlapsNoon) + " - " + formatTime(event.end, true);
                  };
                  var eventSummary = function eventSummary2() {
                    var name = _this2.eventNameFunction(event, timedEvent);
                    if (event.start.hasTime) {
                      if (timedEvent) {
                        var time = timeSummary();
                        var delimiter = singline ? ", " : _this2.$createElement("br");
                        return _this2.$createElement("span", {
                          staticClass: "v-event-summary"
                        }, [_this2.$createElement("strong", [name]), delimiter, time]);
                      } else {
                        var time = formatTime(event.start, true);
                        return _this2.$createElement("span", {
                          staticClass: "v-event-summary"
                        }, [_this2.$createElement("strong", [time]), " ", name]);
                      }
                    }
                    return _this2.$createElement("span", {
                      staticClass: "v-event-summary"
                    }, [name]);
                  };
                  var scope = __assign2(__assign2({}, scopeInput), {
                    event: event.input,
                    outside: scopeInput.day.outside,
                    singline,
                    overlapsNoon,
                    formatTime,
                    timeSummary,
                    eventSummary
                  });
                  return this.$createElement("div", this.setTextColor(text2, this.setBackgroundColor(background, __assign2({
                    on: this.getDefaultMouseEventHandlers(":event", function(nativeEvent) {
                      return __assign2(__assign2({}, scope), {
                        nativeEvent
                      });
                    }),
                    directives: [{
                      name: "ripple",
                      value: (_a2 = this.eventRipple) !== null && _a2 !== void 0 ? _a2 : true
                    }]
                  }, data))), slot ? slot(scope) : [this.genName(eventSummary)]);
                },
                genName: function genName(eventSummary) {
                  return this.$createElement("div", {
                    staticClass: "pl-1"
                  }, [eventSummary()]);
                },
                genPlaceholder: function genPlaceholder(day) {
                  var height = this.eventHeight + this.eventMarginBottom;
                  return this.$createElement("div", {
                    style: {
                      height: height + "px"
                    },
                    attrs: {
                      "data-date": day.date
                    },
                    ref: "events",
                    refInFor: true
                  });
                },
                genMore: function genMore(day) {
                  var _a2;
                  var eventHeight = this.eventHeight;
                  var eventMarginBottom = this.eventMarginBottom;
                  return this.$createElement("div", {
                    staticClass: "v-event-more pl-1",
                    class: {
                      "v-outside": day.outside
                    },
                    attrs: {
                      "data-date": day.date,
                      "data-more": 1
                    },
                    directives: [{
                      name: "ripple",
                      value: (_a2 = this.eventRipple) !== null && _a2 !== void 0 ? _a2 : true
                    }],
                    on: this.getDefaultMouseEventHandlers(":more", function(nativeEvent) {
                      return __assign2({
                        nativeEvent
                      }, day);
                    }),
                    style: {
                      display: "none",
                      height: eventHeight + "px",
                      "margin-bottom": eventMarginBottom + "px"
                    },
                    ref: "events",
                    refInFor: true
                  });
                },
                getVisibleEvents: function getVisibleEvents() {
                  var start = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_5__["getDayIdentifier"])(this.days[0]);
                  var end = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_5__["getDayIdentifier"])(this.days[this.days.length - 1]);
                  return this.parsedEvents.filter(function(event) {
                    return Object(_util_events__WEBPACK_IMPORTED_MODULE_6__["isEventOverlapping"])(event, start, end);
                  });
                },
                isEventForCategory: function isEventForCategory(event, category) {
                  return !this.categoryMode || _typeof2(category) === "object" && category.categoryName && category.categoryName === event.category || typeof event.category === "string" && category === event.category || typeof event.category !== "string" && category === null;
                },
                getEventsForDay: function getEventsForDay(day) {
                  var identifier = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_5__["getDayIdentifier"])(day);
                  var firstWeekday = this.eventWeekdays[0];
                  return this.parsedEvents.filter(function(event) {
                    return Object(_util_events__WEBPACK_IMPORTED_MODULE_6__["isEventStart"])(event, day, identifier, firstWeekday);
                  });
                },
                getEventsForDayAll: function getEventsForDayAll(day) {
                  var _this2 = this;
                  var identifier = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_5__["getDayIdentifier"])(day);
                  var firstWeekday = this.eventWeekdays[0];
                  return this.parsedEvents.filter(function(event) {
                    return event.allDay && (_this2.categoryMode ? Object(_util_events__WEBPACK_IMPORTED_MODULE_6__["isEventOn"])(event, identifier) : Object(_util_events__WEBPACK_IMPORTED_MODULE_6__["isEventStart"])(event, day, identifier, firstWeekday)) && _this2.isEventForCategory(event, day.category);
                  });
                },
                getEventsForDayTimed: function getEventsForDayTimed(day) {
                  var _this2 = this;
                  var identifier = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_5__["getDayIdentifier"])(day);
                  return this.parsedEvents.filter(function(event) {
                    return !event.allDay && Object(_util_events__WEBPACK_IMPORTED_MODULE_6__["isEventOn"])(event, identifier) && _this2.isEventForCategory(event, day.category);
                  });
                },
                getScopedSlots: function getScopedSlots() {
                  var _this2 = this;
                  if (this.noEvents) {
                    return __assign2({}, this.$scopedSlots);
                  }
                  var mode = this.eventModeFunction(this.parsedEvents, this.eventWeekdays[0], this.parsedEventOverlapThreshold);
                  var isNode2 = function isNode3(input2) {
                    return !!input2;
                  };
                  var getSlotChildren = function getSlotChildren2(day, getter, mapper, timed) {
                    var events2 = getter(day);
                    var visuals = mode(day, events2, timed, _this2.categoryMode);
                    if (timed) {
                      return visuals.map(function(visual) {
                        return mapper(visual, day);
                      }).filter(isNode2);
                    }
                    var children = [];
                    visuals.forEach(function(visual, index2) {
                      while (children.length < visual.column) {
                        children.push(_this2.genPlaceholder(day));
                      }
                      var mapped = mapper(visual, day);
                      if (mapped) {
                        children.push(mapped);
                      }
                    });
                    return children;
                  };
                  var slots = this.$scopedSlots;
                  var slotDay = slots.day;
                  var slotDayHeader = slots["day-header"];
                  var slotDayBody = slots["day-body"];
                  return __assign2(__assign2({}, slots), {
                    day: function day(_day) {
                      var children = getSlotChildren(_day, _this2.getEventsForDay, _this2.genDayEvent, false);
                      if (children && children.length > 0 && _this2.eventMore) {
                        children.push(_this2.genMore(_day));
                      }
                      if (slotDay) {
                        var slot = slotDay(_day);
                        if (slot) {
                          children = children ? children.concat(slot) : slot;
                        }
                      }
                      return children;
                    },
                    "day-header": function dayHeader(day) {
                      var children = getSlotChildren(day, _this2.getEventsForDayAll, _this2.genDayEvent, false);
                      if (slotDayHeader) {
                        var slot = slotDayHeader(day);
                        if (slot) {
                          children = children ? children.concat(slot) : slot;
                        }
                      }
                      return children;
                    },
                    "day-body": function dayBody(day) {
                      var events2 = getSlotChildren(day, _this2.getEventsForDayTimed, _this2.genTimedEvent, true);
                      var children = [_this2.$createElement("div", {
                        staticClass: "v-event-timed-container"
                      }, events2)];
                      if (slotDayBody) {
                        var slot = slotDayBody(day);
                        if (slot) {
                          children = children.concat(slot);
                        }
                      }
                      return children;
                    }
                  });
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VCalendar/mixins/calendar-with-intervals.ts": (
          /*!********************************************************************!*\
            !*** ./src/components/VCalendar/mixins/calendar-with-intervals.ts ***!
            \********************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _calendar_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./calendar-base */
              "./src/components/VCalendar/mixins/calendar-base.ts"
            );
            var _util_props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../util/props */
              "./src/components/VCalendar/util/props.ts"
            );
            var _util_timestamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../util/timestamp */
              "./src/components/VCalendar/util/timestamp.ts"
            );
            __webpack_exports__["default"] = _calendar_base__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
              name: "calendar-with-intervals",
              props: _util_props__WEBPACK_IMPORTED_MODULE_1__["default"].intervals,
              computed: {
                parsedFirstInterval: function parsedFirstInterval() {
                  return parseInt(this.firstInterval);
                },
                parsedIntervalMinutes: function parsedIntervalMinutes() {
                  return parseInt(this.intervalMinutes);
                },
                parsedIntervalCount: function parsedIntervalCount() {
                  return parseInt(this.intervalCount);
                },
                parsedIntervalHeight: function parsedIntervalHeight() {
                  return parseFloat(this.intervalHeight);
                },
                parsedFirstTime: function parsedFirstTime() {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["parseTime"])(this.firstTime);
                },
                firstMinute: function firstMinute() {
                  var time = this.parsedFirstTime;
                  return time !== false && time >= 0 && time <= _util_timestamp__WEBPACK_IMPORTED_MODULE_2__["MINUTES_IN_DAY"] ? time : this.parsedFirstInterval * this.parsedIntervalMinutes;
                },
                bodyHeight: function bodyHeight() {
                  return this.parsedIntervalCount * this.parsedIntervalHeight;
                },
                days: function days() {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["createDayList"])(this.parsedStart, this.parsedEnd, this.times.today, this.weekdaySkips, this.maxDays);
                },
                intervals: function intervals() {
                  var days = this.days;
                  var first = this.firstMinute;
                  var minutes = this.parsedIntervalMinutes;
                  var count = this.parsedIntervalCount;
                  var now2 = this.times.now;
                  return days.map(function(d2) {
                    return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["createIntervalList"])(d2, first, minutes, count, now2);
                  });
                },
                intervalFormatter: function intervalFormatter() {
                  if (this.intervalFormat) {
                    return this.intervalFormat;
                  }
                  var longOptions = {
                    timeZone: "UTC",
                    hour: "2-digit",
                    minute: "2-digit"
                  };
                  var shortOptions = {
                    timeZone: "UTC",
                    hour: "numeric",
                    minute: "2-digit"
                  };
                  var shortHourOptions = {
                    timeZone: "UTC",
                    hour: "numeric"
                  };
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["createNativeLocaleFormatter"])(this.currentLocale, function(tms, short) {
                    return short ? tms.minute === 0 ? shortHourOptions : shortOptions : longOptions;
                  });
                }
              },
              methods: {
                showIntervalLabelDefault: function showIntervalLabelDefault(interval) {
                  var first = this.intervals[0][0];
                  var isFirst = first.hour === interval.hour && first.minute === interval.minute;
                  return !isFirst;
                },
                intervalStyleDefault: function intervalStyleDefault(_interval) {
                  return void 0;
                },
                getTimestampAtEvent: function getTimestampAtEvent(e, day) {
                  var timestamp = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["copyTimestamp"])(day);
                  var bounds = e.currentTarget.getBoundingClientRect();
                  var baseMinutes = this.firstMinute;
                  var touchEvent = e;
                  var mouseEvent = e;
                  var touches = touchEvent.changedTouches || touchEvent.touches;
                  var clientY = touches && touches[0] ? touches[0].clientY : mouseEvent.clientY;
                  var addIntervals = (clientY - bounds.top) / this.parsedIntervalHeight;
                  var addMinutes = Math.floor(addIntervals * this.parsedIntervalMinutes);
                  var minutes = baseMinutes + addMinutes;
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["updateMinutes"])(timestamp, minutes, this.times.now);
                },
                getSlotScope: function getSlotScope(timestamp) {
                  var scope = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["copyTimestamp"])(timestamp);
                  scope.timeToY = this.timeToY;
                  scope.timeDelta = this.timeDelta;
                  scope.minutesToPixels = this.minutesToPixels;
                  scope.week = this.days;
                  return scope;
                },
                scrollToTime: function scrollToTime(time) {
                  var y = this.timeToY(time);
                  var pane = this.$refs.scrollArea;
                  if (y === false || !pane) {
                    return false;
                  }
                  pane.scrollTop = y;
                  return true;
                },
                minutesToPixels: function minutesToPixels(minutes) {
                  return minutes / this.parsedIntervalMinutes * this.parsedIntervalHeight;
                },
                timeToY: function timeToY(time, clamp2) {
                  if (clamp2 === void 0) {
                    clamp2 = true;
                  }
                  var y = this.timeDelta(time);
                  if (y !== false) {
                    y *= this.bodyHeight;
                    if (clamp2) {
                      if (y < 0) {
                        y = 0;
                      }
                      if (y > this.bodyHeight) {
                        y = this.bodyHeight;
                      }
                    }
                  }
                  return y;
                },
                timeDelta: function timeDelta(time) {
                  var minutes = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_2__["parseTime"])(time);
                  if (minutes === false) {
                    return false;
                  }
                  var min2 = this.firstMinute;
                  var gap = this.parsedIntervalCount * this.parsedIntervalMinutes;
                  return (minutes - min2) / gap;
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VCalendar/mixins/times.ts": (
          /*!**************************************************!*\
            !*** ./src/components/VCalendar/mixins/times.ts ***!
            \**************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var _util_timestamp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../util/timestamp */
              "./src/components/VCalendar/util/timestamp.ts"
            );
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "times",
              props: {
                now: {
                  type: String,
                  validator: _util_timestamp__WEBPACK_IMPORTED_MODULE_1__["validateTimestamp"]
                }
              },
              data: function data() {
                return {
                  times: {
                    now: Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_1__["parseTimestamp"])("0000-00-00 00:00", true),
                    today: Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_1__["parseTimestamp"])("0000-00-00", true)
                  }
                };
              },
              computed: {
                parsedNow: function parsedNow() {
                  return this.now ? Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_1__["parseTimestamp"])(this.now, true) : null;
                }
              },
              watch: {
                parsedNow: "updateTimes"
              },
              created: function created2() {
                this.updateTimes();
                this.setPresent();
              },
              methods: {
                setPresent: function setPresent() {
                  this.times.now.present = this.times.today.present = true;
                  this.times.now.past = this.times.today.past = false;
                  this.times.now.future = this.times.today.future = false;
                },
                updateTimes: function updateTimes() {
                  var now2 = this.parsedNow || this.getNow();
                  this.updateDay(now2, this.times.now);
                  this.updateTime(now2, this.times.now);
                  this.updateDay(now2, this.times.today);
                },
                getNow: function getNow2() {
                  return Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_1__["parseDate"])(/* @__PURE__ */ new Date());
                },
                updateDay: function updateDay(now2, target2) {
                  if (now2.date !== target2.date) {
                    target2.year = now2.year;
                    target2.month = now2.month;
                    target2.day = now2.day;
                    target2.weekday = now2.weekday;
                    target2.date = now2.date;
                  }
                },
                updateTime: function updateTime(now2, target2) {
                  if (now2.time !== target2.time) {
                    target2.hour = now2.hour;
                    target2.minute = now2.minute;
                    target2.time = now2.time;
                  }
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VCalendar/modes/column.ts": (
          /*!**************************************************!*\
            !*** ./src/components/VCalendar/modes/column.ts ***!
            \**************************************************/
          /*! exports provided: column */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "column", function() {
              return column;
            });
            var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./common */
              "./src/components/VCalendar/modes/common.ts"
            );
            var FULL_WIDTH = 100;
            var column = function column2(events2, firstWeekday, overlapThreshold) {
              var handler = Object(_common__WEBPACK_IMPORTED_MODULE_0__["getOverlapGroupHandler"])(firstWeekday);
              return function(day, dayEvents, timed, reset) {
                var visuals = handler.getVisuals(day, dayEvents, timed, reset);
                if (timed) {
                  visuals.forEach(function(visual) {
                    visual.left = visual.column * FULL_WIDTH / visual.columnCount;
                    visual.width = FULL_WIDTH / visual.columnCount;
                  });
                }
                return visuals;
              };
            };
          }
        ),
        /***/
        "./src/components/VCalendar/modes/common.ts": (
          /*!**************************************************!*\
            !*** ./src/components/VCalendar/modes/common.ts ***!
            \**************************************************/
          /*! exports provided: getVisuals, hasOverlap, setColumnCount, getRange, getDayRange, getNormalizedRange, getOpenGroup, getOverlapGroupHandler */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "getVisuals", function() {
              return _getVisuals;
            });
            __webpack_require__.d(__webpack_exports__, "hasOverlap", function() {
              return hasOverlap;
            });
            __webpack_require__.d(__webpack_exports__, "setColumnCount", function() {
              return setColumnCount;
            });
            __webpack_require__.d(__webpack_exports__, "getRange", function() {
              return getRange;
            });
            __webpack_require__.d(__webpack_exports__, "getDayRange", function() {
              return getDayRange;
            });
            __webpack_require__.d(__webpack_exports__, "getNormalizedRange", function() {
              return getNormalizedRange;
            });
            __webpack_require__.d(__webpack_exports__, "getOpenGroup", function() {
              return getOpenGroup;
            });
            __webpack_require__.d(__webpack_exports__, "getOverlapGroupHandler", function() {
              return getOverlapGroupHandler;
            });
            var _util_timestamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../util/timestamp */
              "./src/components/VCalendar/util/timestamp.ts"
            );
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var MILLIS_IN_DAY = 864e5;
            function _getVisuals(events2, minStart) {
              if (minStart === void 0) {
                minStart = 0;
              }
              var visuals = events2.map(function(event) {
                return {
                  event,
                  columnCount: 0,
                  column: 0,
                  left: 0,
                  width: 100
                };
              });
              visuals.sort(function(a, b) {
                return Math.max(minStart, a.event.startTimestampIdentifier) - Math.max(minStart, b.event.startTimestampIdentifier) || b.event.endTimestampIdentifier - a.event.endTimestampIdentifier;
              });
              return visuals;
            }
            function hasOverlap(s0, e0, s1, e1, exclude) {
              if (exclude === void 0) {
                exclude = true;
              }
              return exclude ? !(s0 >= e1 || e0 <= s1) : !(s0 > e1 || e0 < s1);
            }
            function setColumnCount(groups) {
              groups.forEach(function(group) {
                group.visuals.forEach(function(groupVisual) {
                  groupVisual.columnCount = groups.length;
                });
              });
            }
            function getRange(event) {
              return [event.startTimestampIdentifier, event.endTimestampIdentifier];
            }
            function getDayRange(event) {
              return [event.startIdentifier, event.endIdentifier];
            }
            function getNormalizedRange(event, dayStart) {
              return [Math.max(dayStart, event.startTimestampIdentifier), Math.min(dayStart + MILLIS_IN_DAY, event.endTimestampIdentifier)];
            }
            function getOpenGroup(groups, start, end, timed) {
              for (var i2 = 0; i2 < groups.length; i2++) {
                var group = groups[i2];
                var intersected = false;
                if (hasOverlap(start, end, group.start, group.end, timed)) {
                  for (var k = 0; k < group.visuals.length; k++) {
                    var groupVisual = group.visuals[k];
                    var _a2 = __read2(timed ? getRange(groupVisual.event) : getDayRange(groupVisual.event), 2), groupStart = _a2[0], groupEnd = _a2[1];
                    if (hasOverlap(start, end, groupStart, groupEnd, timed)) {
                      intersected = true;
                      break;
                    }
                  }
                }
                if (!intersected) {
                  return i2;
                }
              }
              return -1;
            }
            function getOverlapGroupHandler(firstWeekday) {
              var handler = {
                groups: [],
                min: -1,
                max: -1,
                reset: function reset() {
                  handler.groups = [];
                  handler.min = handler.max = -1;
                },
                getVisuals: function getVisuals(day, dayEvents, timed, reset) {
                  if (reset === void 0) {
                    reset = false;
                  }
                  if (day.weekday === firstWeekday || reset) {
                    handler.reset();
                  }
                  var dayStart = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_0__["getTimestampIdentifier"])(day);
                  var visuals = _getVisuals(dayEvents, dayStart);
                  visuals.forEach(function(visual) {
                    var _a2 = __read2(timed ? getRange(visual.event) : getDayRange(visual.event), 2), start = _a2[0], end = _a2[1];
                    if (handler.groups.length > 0 && !hasOverlap(start, end, handler.min, handler.max, timed)) {
                      setColumnCount(handler.groups);
                      handler.reset();
                    }
                    var targetGroup = getOpenGroup(handler.groups, start, end, timed);
                    if (targetGroup === -1) {
                      targetGroup = handler.groups.length;
                      handler.groups.push({
                        start,
                        end,
                        visuals: []
                      });
                    }
                    var target2 = handler.groups[targetGroup];
                    target2.visuals.push(visual);
                    target2.start = Math.min(target2.start, start);
                    target2.end = Math.max(target2.end, end);
                    visual.column = targetGroup;
                    if (handler.min === -1) {
                      handler.min = start;
                      handler.max = end;
                    } else {
                      handler.min = Math.min(handler.min, start);
                      handler.max = Math.max(handler.max, end);
                    }
                  });
                  setColumnCount(handler.groups);
                  if (timed) {
                    handler.reset();
                  }
                  return visuals;
                }
              };
              return handler;
            }
          }
        ),
        /***/
        "./src/components/VCalendar/modes/index.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VCalendar/modes/index.ts ***!
            \*************************************************/
          /*! exports provided: CalendarEventOverlapModes */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "CalendarEventOverlapModes", function() {
              return CalendarEventOverlapModes;
            });
            var _stack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./stack */
              "./src/components/VCalendar/modes/stack.ts"
            );
            var _column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./column */
              "./src/components/VCalendar/modes/column.ts"
            );
            var CalendarEventOverlapModes = {
              stack: _stack__WEBPACK_IMPORTED_MODULE_0__["stack"],
              column: _column__WEBPACK_IMPORTED_MODULE_1__["column"]
            };
          }
        ),
        /***/
        "./src/components/VCalendar/modes/stack.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VCalendar/modes/stack.ts ***!
            \*************************************************/
          /*! exports provided: stack */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "stack", function() {
              return stack;
            });
            var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./common */
              "./src/components/VCalendar/modes/common.ts"
            );
            var _util_timestamp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../util/timestamp */
              "./src/components/VCalendar/util/timestamp.ts"
            );
            var __values2 = function(o) {
              var s2 = typeof Symbol === "function" && Symbol.iterator, m = s2 && o[s2], i2 = 0;
              if (m)
                return m.call(o);
              if (o && typeof o.length === "number")
                return {
                  next: function next() {
                    if (o && i2 >= o.length)
                      o = void 0;
                    return {
                      value: o && o[i2++],
                      done: !o
                    };
                  }
                };
              throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var FULL_WIDTH = 100;
            var DEFAULT_OFFSET = 5;
            var WIDTH_MULTIPLIER = 1.7;
            var stack = function stack2(events2, firstWeekday, overlapThreshold) {
              var handler = Object(_common__WEBPACK_IMPORTED_MODULE_0__["getOverlapGroupHandler"])(firstWeekday);
              return function(day, dayEvents, timed, reset) {
                var e_1, _a2, e_2, _b2, e_3, _c;
                if (!timed) {
                  return handler.getVisuals(day, dayEvents, timed, reset);
                }
                var dayStart = Object(_util_timestamp__WEBPACK_IMPORTED_MODULE_1__["getTimestampIdentifier"])(day);
                var visuals = Object(_common__WEBPACK_IMPORTED_MODULE_0__["getVisuals"])(dayEvents, dayStart);
                var groups = getGroups(visuals, dayStart);
                try {
                  for (var groups_1 = __values2(groups), groups_1_1 = groups_1.next(); !groups_1_1.done; groups_1_1 = groups_1.next()) {
                    var group = groups_1_1.value;
                    var nodes = [];
                    try {
                      for (var _d2 = (e_2 = void 0, __values2(group.visuals)), _e = _d2.next(); !_e.done; _e = _d2.next()) {
                        var visual = _e.value;
                        var child = getNode(visual, dayStart);
                        var index2 = getNextIndex(child, nodes);
                        if (index2 === false) {
                          var parent2 = getParent2(child, nodes);
                          if (parent2) {
                            child.parent = parent2;
                            child.sibling = Object(_common__WEBPACK_IMPORTED_MODULE_0__["hasOverlap"])(child.start, child.end, parent2.start, addTime(parent2.start, overlapThreshold));
                            child.index = parent2.index + 1;
                            parent2.children.push(child);
                          }
                        } else {
                          var _f = __read2(getOverlappingRange(child, nodes, index2 - 1, index2 - 1), 1), parent2 = _f[0];
                          var children = getOverlappingRange(child, nodes, index2 + 1, index2 + nodes.length, true);
                          child.children = children;
                          child.index = index2;
                          if (parent2) {
                            child.parent = parent2;
                            child.sibling = Object(_common__WEBPACK_IMPORTED_MODULE_0__["hasOverlap"])(child.start, child.end, parent2.start, addTime(parent2.start, overlapThreshold));
                            parent2.children.push(child);
                          }
                          try {
                            for (var children_1 = (e_3 = void 0, __values2(children)), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                              var grand = children_1_1.value;
                              if (grand.parent === parent2) {
                                grand.parent = child;
                              }
                              var grandNext = grand.index - child.index <= 1;
                              if (grandNext && child.sibling && Object(_common__WEBPACK_IMPORTED_MODULE_0__["hasOverlap"])(child.start, addTime(child.start, overlapThreshold), grand.start, grand.end)) {
                                grand.sibling = true;
                              }
                            }
                          } catch (e_3_1) {
                            e_3 = {
                              error: e_3_1
                            };
                          } finally {
                            try {
                              if (children_1_1 && !children_1_1.done && (_c = children_1.return))
                                _c.call(children_1);
                            } finally {
                              if (e_3)
                                throw e_3.error;
                            }
                          }
                        }
                        nodes.push(child);
                      }
                    } catch (e_2_1) {
                      e_2 = {
                        error: e_2_1
                      };
                    } finally {
                      try {
                        if (_e && !_e.done && (_b2 = _d2.return))
                          _b2.call(_d2);
                      } finally {
                        if (e_2)
                          throw e_2.error;
                      }
                    }
                    calculateBounds(nodes, overlapThreshold);
                  }
                } catch (e_1_1) {
                  e_1 = {
                    error: e_1_1
                  };
                } finally {
                  try {
                    if (groups_1_1 && !groups_1_1.done && (_a2 = groups_1.return))
                      _a2.call(groups_1);
                  } finally {
                    if (e_1)
                      throw e_1.error;
                  }
                }
                visuals.sort(function(a, b) {
                  return a.left - b.left || a.event.startTimestampIdentifier - b.event.startTimestampIdentifier;
                });
                return visuals;
              };
            };
            function calculateBounds(nodes, overlapThreshold) {
              var e_4, _a2;
              try {
                for (var nodes_1 = __values2(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
                  var node2 = nodes_1_1.value;
                  var visual = node2.visual, parent2 = node2.parent;
                  var columns = getMaxChildIndex(node2) + 1;
                  var spaceLeft = parent2 ? parent2.visual.left : 0;
                  var spaceWidth = FULL_WIDTH - spaceLeft;
                  var offset2 = Math.min(DEFAULT_OFFSET, FULL_WIDTH / columns);
                  var columnWidthMultiplier = getColumnWidthMultiplier(node2, nodes);
                  var columnOffset = spaceWidth / (columns - node2.index + 1);
                  var columnWidth = spaceWidth / (columns - node2.index + (node2.sibling ? 1 : 0)) * columnWidthMultiplier;
                  if (parent2) {
                    visual.left = node2.sibling ? spaceLeft + columnOffset : spaceLeft + offset2;
                  }
                  visual.width = hasFullWidth(node2, nodes, overlapThreshold) ? FULL_WIDTH - visual.left : Math.min(FULL_WIDTH - visual.left, columnWidth * WIDTH_MULTIPLIER);
                }
              } catch (e_4_1) {
                e_4 = {
                  error: e_4_1
                };
              } finally {
                try {
                  if (nodes_1_1 && !nodes_1_1.done && (_a2 = nodes_1.return))
                    _a2.call(nodes_1);
                } finally {
                  if (e_4)
                    throw e_4.error;
                }
              }
            }
            function getColumnWidthMultiplier(node2, nodes) {
              if (!node2.children.length) {
                return 1;
              }
              var maxColumn = node2.index + nodes.length;
              var minColumn = node2.children.reduce(function(min2, c) {
                return Math.min(min2, c.index);
              }, maxColumn);
              return minColumn - node2.index;
            }
            function getOverlappingIndices(node2, nodes) {
              var e_5, _a2;
              var indices = [];
              try {
                for (var nodes_2 = __values2(nodes), nodes_2_1 = nodes_2.next(); !nodes_2_1.done; nodes_2_1 = nodes_2.next()) {
                  var other = nodes_2_1.value;
                  if (Object(_common__WEBPACK_IMPORTED_MODULE_0__["hasOverlap"])(node2.start, node2.end, other.start, other.end)) {
                    indices.push(other.index);
                  }
                }
              } catch (e_5_1) {
                e_5 = {
                  error: e_5_1
                };
              } finally {
                try {
                  if (nodes_2_1 && !nodes_2_1.done && (_a2 = nodes_2.return))
                    _a2.call(nodes_2);
                } finally {
                  if (e_5)
                    throw e_5.error;
                }
              }
              return indices;
            }
            function getNextIndex(node2, nodes) {
              var indices = getOverlappingIndices(node2, nodes);
              indices.sort();
              for (var i2 = 0; i2 < indices.length; i2++) {
                if (i2 < indices[i2]) {
                  return i2;
                }
              }
              return false;
            }
            function getOverlappingRange(node2, nodes, indexMin, indexMax, returnFirstColumn) {
              var e_6, _a2;
              if (returnFirstColumn === void 0) {
                returnFirstColumn = false;
              }
              var overlapping = [];
              try {
                for (var nodes_3 = __values2(nodes), nodes_3_1 = nodes_3.next(); !nodes_3_1.done; nodes_3_1 = nodes_3.next()) {
                  var other = nodes_3_1.value;
                  if (other.index >= indexMin && other.index <= indexMax && Object(_common__WEBPACK_IMPORTED_MODULE_0__["hasOverlap"])(node2.start, node2.end, other.start, other.end)) {
                    overlapping.push(other);
                  }
                }
              } catch (e_6_1) {
                e_6 = {
                  error: e_6_1
                };
              } finally {
                try {
                  if (nodes_3_1 && !nodes_3_1.done && (_a2 = nodes_3.return))
                    _a2.call(nodes_3);
                } finally {
                  if (e_6)
                    throw e_6.error;
                }
              }
              if (returnFirstColumn && overlapping.length > 0) {
                var first_1 = overlapping.reduce(function(min2, n2) {
                  return Math.min(min2, n2.index);
                }, overlapping[0].index);
                return overlapping.filter(function(n2) {
                  return n2.index === first_1;
                });
              }
              return overlapping;
            }
            function getParent2(node2, nodes) {
              var e_7, _a2;
              var parent2 = null;
              try {
                for (var nodes_4 = __values2(nodes), nodes_4_1 = nodes_4.next(); !nodes_4_1.done; nodes_4_1 = nodes_4.next()) {
                  var other = nodes_4_1.value;
                  if (Object(_common__WEBPACK_IMPORTED_MODULE_0__["hasOverlap"])(node2.start, node2.end, other.start, other.end) && (parent2 === null || other.index > parent2.index)) {
                    parent2 = other;
                  }
                }
              } catch (e_7_1) {
                e_7 = {
                  error: e_7_1
                };
              } finally {
                try {
                  if (nodes_4_1 && !nodes_4_1.done && (_a2 = nodes_4.return))
                    _a2.call(nodes_4);
                } finally {
                  if (e_7)
                    throw e_7.error;
                }
              }
              return parent2;
            }
            function hasFullWidth(node2, nodes, overlapThreshold) {
              var e_8, _a2;
              try {
                for (var nodes_5 = __values2(nodes), nodes_5_1 = nodes_5.next(); !nodes_5_1.done; nodes_5_1 = nodes_5.next()) {
                  var other = nodes_5_1.value;
                  if (other !== node2 && other.index > node2.index && Object(_common__WEBPACK_IMPORTED_MODULE_0__["hasOverlap"])(node2.start, addTime(node2.start, overlapThreshold), other.start, other.end)) {
                    return false;
                  }
                }
              } catch (e_8_1) {
                e_8 = {
                  error: e_8_1
                };
              } finally {
                try {
                  if (nodes_5_1 && !nodes_5_1.done && (_a2 = nodes_5.return))
                    _a2.call(nodes_5);
                } finally {
                  if (e_8)
                    throw e_8.error;
                }
              }
              return true;
            }
            function getGroups(visuals, dayStart) {
              var e_9, _a2, e_10, _b2;
              var groups = [];
              try {
                for (var visuals_1 = __values2(visuals), visuals_1_1 = visuals_1.next(); !visuals_1_1.done; visuals_1_1 = visuals_1.next()) {
                  var visual = visuals_1_1.value;
                  var _c = __read2(Object(_common__WEBPACK_IMPORTED_MODULE_0__["getNormalizedRange"])(visual.event, dayStart), 2), start = _c[0], end = _c[1];
                  var added = false;
                  try {
                    for (var groups_2 = (e_10 = void 0, __values2(groups)), groups_2_1 = groups_2.next(); !groups_2_1.done; groups_2_1 = groups_2.next()) {
                      var group = groups_2_1.value;
                      if (Object(_common__WEBPACK_IMPORTED_MODULE_0__["hasOverlap"])(start, end, group.start, group.end)) {
                        group.visuals.push(visual);
                        group.end = Math.max(group.end, end);
                        added = true;
                        break;
                      }
                    }
                  } catch (e_10_1) {
                    e_10 = {
                      error: e_10_1
                    };
                  } finally {
                    try {
                      if (groups_2_1 && !groups_2_1.done && (_b2 = groups_2.return))
                        _b2.call(groups_2);
                    } finally {
                      if (e_10)
                        throw e_10.error;
                    }
                  }
                  if (!added) {
                    groups.push({
                      start,
                      end,
                      visuals: [visual]
                    });
                  }
                }
              } catch (e_9_1) {
                e_9 = {
                  error: e_9_1
                };
              } finally {
                try {
                  if (visuals_1_1 && !visuals_1_1.done && (_a2 = visuals_1.return))
                    _a2.call(visuals_1);
                } finally {
                  if (e_9)
                    throw e_9.error;
                }
              }
              return groups;
            }
            function getNode(visual, dayStart) {
              var _a2 = __read2(Object(_common__WEBPACK_IMPORTED_MODULE_0__["getNormalizedRange"])(visual.event, dayStart), 2), start = _a2[0], end = _a2[1];
              return {
                parent: null,
                sibling: true,
                index: 0,
                visual,
                start,
                end,
                children: []
              };
            }
            function getMaxChildIndex(node2) {
              var e_11, _a2;
              var max2 = node2.index;
              try {
                for (var _b2 = __values2(node2.children), _c = _b2.next(); !_c.done; _c = _b2.next()) {
                  var child = _c.value;
                  var childMax = getMaxChildIndex(child);
                  if (childMax > max2) {
                    max2 = childMax;
                  }
                }
              } catch (e_11_1) {
                e_11 = {
                  error: e_11_1
                };
              } finally {
                try {
                  if (_c && !_c.done && (_a2 = _b2.return))
                    _a2.call(_b2);
                } finally {
                  if (e_11)
                    throw e_11.error;
                }
              }
              return max2;
            }
            function addTime(identifier, minutes) {
              var removeMinutes = identifier % 100;
              var totalMinutes = removeMinutes + minutes;
              var addHours = Math.floor(totalMinutes / 60);
              var addMinutes = totalMinutes % 60;
              return identifier - removeMinutes + addHours * 100 + addMinutes;
            }
          }
        ),
        /***/
        "./src/components/VCalendar/util/events.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VCalendar/util/events.ts ***!
            \*************************************************/
          /*! exports provided: parseEvent, isEventOn, isEventHiddenOn, isEventStart, isEventOverlapping */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "parseEvent", function() {
              return parseEvent;
            });
            __webpack_require__.d(__webpack_exports__, "isEventOn", function() {
              return isEventOn;
            });
            __webpack_require__.d(__webpack_exports__, "isEventHiddenOn", function() {
              return isEventHiddenOn;
            });
            __webpack_require__.d(__webpack_exports__, "isEventStart", function() {
              return isEventStart;
            });
            __webpack_require__.d(__webpack_exports__, "isEventOverlapping", function() {
              return isEventOverlapping;
            });
            var _timestamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./timestamp */
              "./src/components/VCalendar/util/timestamp.ts"
            );
            function parseEvent(input2, index2, startProperty, endProperty, timed, category) {
              if (timed === void 0) {
                timed = false;
              }
              if (category === void 0) {
                category = false;
              }
              var startInput = input2[startProperty];
              var endInput = input2[endProperty];
              var startParsed = Object(_timestamp__WEBPACK_IMPORTED_MODULE_0__["parseTimestamp"])(startInput, true);
              var endParsed = endInput ? Object(_timestamp__WEBPACK_IMPORTED_MODULE_0__["parseTimestamp"])(endInput, true) : startParsed;
              var start = Object(_timestamp__WEBPACK_IMPORTED_MODULE_0__["isTimedless"])(startInput) ? Object(_timestamp__WEBPACK_IMPORTED_MODULE_0__["updateHasTime"])(startParsed, timed) : startParsed;
              var end = Object(_timestamp__WEBPACK_IMPORTED_MODULE_0__["isTimedless"])(endInput) ? Object(_timestamp__WEBPACK_IMPORTED_MODULE_0__["updateHasTime"])(endParsed, timed) : endParsed;
              var startIdentifier = Object(_timestamp__WEBPACK_IMPORTED_MODULE_0__["getDayIdentifier"])(start);
              var startTimestampIdentifier = Object(_timestamp__WEBPACK_IMPORTED_MODULE_0__["getTimestampIdentifier"])(start);
              var endIdentifier = Object(_timestamp__WEBPACK_IMPORTED_MODULE_0__["getDayIdentifier"])(end);
              var endOffset = start.hasTime ? 0 : 2359;
              var endTimestampIdentifier = Object(_timestamp__WEBPACK_IMPORTED_MODULE_0__["getTimestampIdentifier"])(end) + endOffset;
              var allDay = !start.hasTime;
              return {
                input: input2,
                start,
                startIdentifier,
                startTimestampIdentifier,
                end,
                endIdentifier,
                endTimestampIdentifier,
                allDay,
                index: index2,
                category
              };
            }
            function isEventOn(event, dayIdentifier) {
              return dayIdentifier >= event.startIdentifier && dayIdentifier <= event.endIdentifier;
            }
            function isEventHiddenOn(event, day) {
              return event.end.time === "00:00" && event.end.date === day.date && event.start.date !== day.date;
            }
            function isEventStart(event, day, dayIdentifier, firstWeekday) {
              return dayIdentifier === event.startIdentifier || firstWeekday === day.weekday && isEventOn(event, dayIdentifier);
            }
            function isEventOverlapping(event, startIdentifier, endIdentifier) {
              return startIdentifier <= event.endIdentifier && endIdentifier >= event.startIdentifier;
            }
          }
        ),
        /***/
        "./src/components/VCalendar/util/parser.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VCalendar/util/parser.ts ***!
            \*************************************************/
          /*! exports provided: parsedCategoryText, getParsedCategories */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "parsedCategoryText", function() {
              return parsedCategoryText;
            });
            __webpack_require__.d(__webpack_exports__, "getParsedCategories", function() {
              return getParsedCategories;
            });
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            function parsedCategoryText(category, categoryText) {
              return typeof categoryText === "string" && _typeof2(category) === "object" && category ? category[categoryText] : typeof categoryText === "function" ? categoryText(category) : category;
            }
            function getParsedCategories(categories, categoryText) {
              if (typeof categories === "string")
                return categories.split(/\s*,\s/);
              if (Array.isArray(categories)) {
                return categories.map(function(category) {
                  if (typeof category === "string")
                    return category;
                  var categoryName = typeof category.categoryName === "string" ? category.categoryName : parsedCategoryText(category, categoryText);
                  return __assign2(__assign2({}, category), {
                    categoryName
                  });
                });
              }
              return [];
            }
          }
        ),
        /***/
        "./src/components/VCalendar/util/props.ts": (
          /*!************************************************!*\
            !*** ./src/components/VCalendar/util/props.ts ***!
            \************************************************/
          /*! exports provided: default, validateNumber, validateWeekdays */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "validateNumber", function() {
              return validateNumber;
            });
            __webpack_require__.d(__webpack_exports__, "validateWeekdays", function() {
              return validateWeekdays;
            });
            var _timestamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./timestamp */
              "./src/components/VCalendar/util/timestamp.ts"
            );
            var _modes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../modes */
              "./src/components/VCalendar/modes/index.ts"
            );
            __webpack_exports__["default"] = {
              base: {
                start: {
                  type: [String, Number, Date],
                  validate: _timestamp__WEBPACK_IMPORTED_MODULE_0__["validateTimestamp"],
                  default: function _default() {
                    return Object(_timestamp__WEBPACK_IMPORTED_MODULE_0__["parseDate"])(/* @__PURE__ */ new Date()).date;
                  }
                },
                end: {
                  type: [String, Number, Date],
                  validate: _timestamp__WEBPACK_IMPORTED_MODULE_0__["validateTimestamp"]
                },
                weekdays: {
                  type: [Array, String],
                  default: function _default() {
                    return [0, 1, 2, 3, 4, 5, 6];
                  },
                  validate: validateWeekdays
                },
                hideHeader: {
                  type: Boolean
                },
                shortWeekdays: {
                  type: Boolean,
                  default: true
                },
                weekdayFormat: {
                  type: Function,
                  default: null
                },
                dayFormat: {
                  type: Function,
                  default: null
                }
              },
              intervals: {
                maxDays: {
                  type: Number,
                  default: 7
                },
                shortIntervals: {
                  type: Boolean,
                  default: true
                },
                intervalHeight: {
                  type: [Number, String],
                  default: 48,
                  validate: validateNumber
                },
                intervalWidth: {
                  type: [Number, String],
                  default: 60,
                  validate: validateNumber
                },
                intervalMinutes: {
                  type: [Number, String],
                  default: 60,
                  validate: validateNumber
                },
                firstInterval: {
                  type: [Number, String],
                  default: 0,
                  validate: validateNumber
                },
                firstTime: {
                  type: [Number, String, Object],
                  validate: _timestamp__WEBPACK_IMPORTED_MODULE_0__["validateTime"]
                },
                intervalCount: {
                  type: [Number, String],
                  default: 24,
                  validate: validateNumber
                },
                intervalFormat: {
                  type: Function,
                  default: null
                },
                intervalStyle: {
                  type: Function,
                  default: null
                },
                showIntervalLabel: {
                  type: Function,
                  default: null
                }
              },
              weeks: {
                localeFirstDayOfYear: {
                  type: [String, Number],
                  default: 0
                },
                minWeeks: {
                  validate: validateNumber,
                  default: 1
                },
                shortMonths: {
                  type: Boolean,
                  default: true
                },
                showMonthOnFirst: {
                  type: Boolean,
                  default: true
                },
                showWeek: Boolean,
                monthFormat: {
                  type: Function,
                  default: null
                }
              },
              calendar: {
                type: {
                  type: String,
                  default: "month"
                },
                value: {
                  type: [String, Number, Date],
                  validate: _timestamp__WEBPACK_IMPORTED_MODULE_0__["validateTimestamp"]
                }
              },
              category: {
                categories: {
                  type: [Array, String],
                  default: ""
                },
                categoryText: {
                  type: [String, Function]
                },
                categoryHideDynamic: {
                  type: Boolean
                },
                categoryShowAll: {
                  type: Boolean
                },
                categoryForInvalid: {
                  type: String,
                  default: ""
                },
                categoryDays: {
                  type: [Number, String],
                  default: 1,
                  validate: function validate(x2) {
                    return isFinite(parseInt(x2)) && parseInt(x2) > 0;
                  }
                }
              },
              events: {
                events: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                eventStart: {
                  type: String,
                  default: "start"
                },
                eventEnd: {
                  type: String,
                  default: "end"
                },
                eventTimed: {
                  type: [String, Function],
                  default: "timed"
                },
                eventCategory: {
                  type: [String, Function],
                  default: "category"
                },
                eventHeight: {
                  type: Number,
                  default: 20
                },
                eventColor: {
                  type: [String, Function],
                  default: "primary"
                },
                eventTextColor: {
                  type: [String, Function],
                  default: "white"
                },
                eventName: {
                  type: [String, Function],
                  default: "name"
                },
                eventOverlapThreshold: {
                  type: [String, Number],
                  default: 60
                },
                eventOverlapMode: {
                  type: [String, Function],
                  default: "stack",
                  validate: function validate(mode) {
                    return mode in _modes__WEBPACK_IMPORTED_MODULE_1__["CalendarEventOverlapModes"] || typeof mode === "function";
                  }
                },
                eventMore: {
                  type: Boolean,
                  default: true
                },
                eventMoreText: {
                  type: String,
                  default: "$vuetify.calendar.moreEvents"
                },
                eventRipple: {
                  type: [Boolean, Object],
                  default: null
                },
                eventMarginBottom: {
                  type: Number,
                  default: 1
                }
              }
            };
            function validateNumber(input2) {
              return isFinite(parseInt(input2));
            }
            function validateWeekdays(input2) {
              if (typeof input2 === "string") {
                input2 = input2.split(",");
              }
              if (Array.isArray(input2)) {
                var ints = input2.map(function(x3) {
                  return parseInt(x3);
                });
                if (ints.length > _timestamp__WEBPACK_IMPORTED_MODULE_0__["DAYS_IN_WEEK"] || ints.length === 0) {
                  return false;
                }
                var visited = {};
                var wrapped = false;
                for (var i2 = 0; i2 < ints.length; i2++) {
                  var x2 = ints[i2];
                  if (!isFinite(x2) || x2 < 0 || x2 >= _timestamp__WEBPACK_IMPORTED_MODULE_0__["DAYS_IN_WEEK"]) {
                    return false;
                  }
                  if (i2 > 0) {
                    var d2 = x2 - ints[i2 - 1];
                    if (d2 < 0) {
                      if (wrapped) {
                        return false;
                      }
                      wrapped = true;
                    } else if (d2 === 0) {
                      return false;
                    }
                  }
                  if (visited[x2]) {
                    return false;
                  }
                  visited[x2] = true;
                }
                return true;
              }
              return false;
            }
          }
        ),
        /***/
        "./src/components/VCalendar/util/timestamp.ts": (
          /*!****************************************************!*\
            !*** ./src/components/VCalendar/util/timestamp.ts ***!
            \****************************************************/
          /*! exports provided: PARSE_REGEX, PARSE_TIME, DAYS_IN_MONTH, DAYS_IN_MONTH_LEAP, DAYS_IN_MONTH_MIN, DAYS_IN_MONTH_MAX, MONTH_MAX, MONTH_MIN, DAY_MIN, DAYS_IN_WEEK, MINUTES_IN_HOUR, MINUTE_MAX, MINUTES_IN_DAY, HOURS_IN_DAY, HOUR_MAX, FIRST_HOUR, OFFSET_YEAR, OFFSET_MONTH, OFFSET_HOUR, OFFSET_TIME, getStartOfWeek, getEndOfWeek, getStartOfMonth, getEndOfMonth, validateTime, parseTime, validateTimestamp, parseTimestamp, parseDate, getDayIdentifier, getTimeIdentifier, getTimestampIdentifier, updateRelative, isTimedless, updateHasTime, updateMinutes, updateWeekday, updateFormatted, getWeekday, daysInMonth, copyTimestamp, padNumber, getDate, getTime, nextMinutes, nextDay, prevDay, relativeDays, diffMinutes, findWeekday, getWeekdaySkips, timestampToDate, createDayList, createIntervalList, createNativeLocaleFormatter */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "PARSE_REGEX", function() {
              return PARSE_REGEX;
            });
            __webpack_require__.d(__webpack_exports__, "PARSE_TIME", function() {
              return PARSE_TIME;
            });
            __webpack_require__.d(__webpack_exports__, "DAYS_IN_MONTH", function() {
              return DAYS_IN_MONTH;
            });
            __webpack_require__.d(__webpack_exports__, "DAYS_IN_MONTH_LEAP", function() {
              return DAYS_IN_MONTH_LEAP;
            });
            __webpack_require__.d(__webpack_exports__, "DAYS_IN_MONTH_MIN", function() {
              return DAYS_IN_MONTH_MIN;
            });
            __webpack_require__.d(__webpack_exports__, "DAYS_IN_MONTH_MAX", function() {
              return DAYS_IN_MONTH_MAX;
            });
            __webpack_require__.d(__webpack_exports__, "MONTH_MAX", function() {
              return MONTH_MAX;
            });
            __webpack_require__.d(__webpack_exports__, "MONTH_MIN", function() {
              return MONTH_MIN;
            });
            __webpack_require__.d(__webpack_exports__, "DAY_MIN", function() {
              return DAY_MIN;
            });
            __webpack_require__.d(__webpack_exports__, "DAYS_IN_WEEK", function() {
              return DAYS_IN_WEEK;
            });
            __webpack_require__.d(__webpack_exports__, "MINUTES_IN_HOUR", function() {
              return MINUTES_IN_HOUR;
            });
            __webpack_require__.d(__webpack_exports__, "MINUTE_MAX", function() {
              return MINUTE_MAX;
            });
            __webpack_require__.d(__webpack_exports__, "MINUTES_IN_DAY", function() {
              return MINUTES_IN_DAY;
            });
            __webpack_require__.d(__webpack_exports__, "HOURS_IN_DAY", function() {
              return HOURS_IN_DAY;
            });
            __webpack_require__.d(__webpack_exports__, "HOUR_MAX", function() {
              return HOUR_MAX;
            });
            __webpack_require__.d(__webpack_exports__, "FIRST_HOUR", function() {
              return FIRST_HOUR;
            });
            __webpack_require__.d(__webpack_exports__, "OFFSET_YEAR", function() {
              return OFFSET_YEAR;
            });
            __webpack_require__.d(__webpack_exports__, "OFFSET_MONTH", function() {
              return OFFSET_MONTH;
            });
            __webpack_require__.d(__webpack_exports__, "OFFSET_HOUR", function() {
              return OFFSET_HOUR;
            });
            __webpack_require__.d(__webpack_exports__, "OFFSET_TIME", function() {
              return OFFSET_TIME;
            });
            __webpack_require__.d(__webpack_exports__, "getStartOfWeek", function() {
              return getStartOfWeek;
            });
            __webpack_require__.d(__webpack_exports__, "getEndOfWeek", function() {
              return getEndOfWeek;
            });
            __webpack_require__.d(__webpack_exports__, "getStartOfMonth", function() {
              return getStartOfMonth;
            });
            __webpack_require__.d(__webpack_exports__, "getEndOfMonth", function() {
              return getEndOfMonth;
            });
            __webpack_require__.d(__webpack_exports__, "validateTime", function() {
              return validateTime;
            });
            __webpack_require__.d(__webpack_exports__, "parseTime", function() {
              return parseTime;
            });
            __webpack_require__.d(__webpack_exports__, "validateTimestamp", function() {
              return validateTimestamp;
            });
            __webpack_require__.d(__webpack_exports__, "parseTimestamp", function() {
              return parseTimestamp;
            });
            __webpack_require__.d(__webpack_exports__, "parseDate", function() {
              return parseDate;
            });
            __webpack_require__.d(__webpack_exports__, "getDayIdentifier", function() {
              return getDayIdentifier;
            });
            __webpack_require__.d(__webpack_exports__, "getTimeIdentifier", function() {
              return getTimeIdentifier;
            });
            __webpack_require__.d(__webpack_exports__, "getTimestampIdentifier", function() {
              return getTimestampIdentifier;
            });
            __webpack_require__.d(__webpack_exports__, "updateRelative", function() {
              return updateRelative;
            });
            __webpack_require__.d(__webpack_exports__, "isTimedless", function() {
              return isTimedless;
            });
            __webpack_require__.d(__webpack_exports__, "updateHasTime", function() {
              return updateHasTime;
            });
            __webpack_require__.d(__webpack_exports__, "updateMinutes", function() {
              return updateMinutes;
            });
            __webpack_require__.d(__webpack_exports__, "updateWeekday", function() {
              return updateWeekday;
            });
            __webpack_require__.d(__webpack_exports__, "updateFormatted", function() {
              return updateFormatted;
            });
            __webpack_require__.d(__webpack_exports__, "getWeekday", function() {
              return getWeekday;
            });
            __webpack_require__.d(__webpack_exports__, "daysInMonth", function() {
              return daysInMonth;
            });
            __webpack_require__.d(__webpack_exports__, "copyTimestamp", function() {
              return copyTimestamp;
            });
            __webpack_require__.d(__webpack_exports__, "padNumber", function() {
              return padNumber;
            });
            __webpack_require__.d(__webpack_exports__, "getDate", function() {
              return getDate;
            });
            __webpack_require__.d(__webpack_exports__, "getTime", function() {
              return getTime;
            });
            __webpack_require__.d(__webpack_exports__, "nextMinutes", function() {
              return nextMinutes;
            });
            __webpack_require__.d(__webpack_exports__, "nextDay", function() {
              return nextDay;
            });
            __webpack_require__.d(__webpack_exports__, "prevDay", function() {
              return prevDay;
            });
            __webpack_require__.d(__webpack_exports__, "relativeDays", function() {
              return relativeDays;
            });
            __webpack_require__.d(__webpack_exports__, "diffMinutes", function() {
              return diffMinutes;
            });
            __webpack_require__.d(__webpack_exports__, "findWeekday", function() {
              return findWeekday;
            });
            __webpack_require__.d(__webpack_exports__, "getWeekdaySkips", function() {
              return getWeekdaySkips;
            });
            __webpack_require__.d(__webpack_exports__, "timestampToDate", function() {
              return timestampToDate;
            });
            __webpack_require__.d(__webpack_exports__, "createDayList", function() {
              return createDayList;
            });
            __webpack_require__.d(__webpack_exports__, "createIntervalList", function() {
              return createIntervalList;
            });
            __webpack_require__.d(__webpack_exports__, "createNativeLocaleFormatter", function() {
              return createNativeLocaleFormatter;
            });
            var _util_dateTimeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../../util/dateTimeUtils */
              "./src/util/dateTimeUtils.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var PARSE_REGEX = /^(\d{4})-(\d{1,2})(-(\d{1,2}))?([^\d]+(\d{1,2}))?(:(\d{1,2}))?(:(\d{1,2}))?$/;
            var PARSE_TIME = /(\d\d?)(:(\d\d?)|)(:(\d\d?)|)/;
            var DAYS_IN_MONTH = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            var DAYS_IN_MONTH_LEAP = [0, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            var DAYS_IN_MONTH_MIN = 28;
            var DAYS_IN_MONTH_MAX = 31;
            var MONTH_MAX = 12;
            var MONTH_MIN = 1;
            var DAY_MIN = 1;
            var DAYS_IN_WEEK = 7;
            var MINUTES_IN_HOUR = 60;
            var MINUTE_MAX = 59;
            var MINUTES_IN_DAY = 24 * 60;
            var HOURS_IN_DAY = 24;
            var HOUR_MAX = 23;
            var FIRST_HOUR = 0;
            var OFFSET_YEAR = 1e4;
            var OFFSET_MONTH = 100;
            var OFFSET_HOUR = 100;
            var OFFSET_TIME = 1e4;
            function getStartOfWeek(timestamp, weekdays, today) {
              var start = copyTimestamp(timestamp);
              findWeekday(start, weekdays[0], prevDay);
              updateFormatted(start);
              if (today) {
                updateRelative(start, today, start.hasTime);
              }
              return start;
            }
            function getEndOfWeek(timestamp, weekdays, today) {
              var end = copyTimestamp(timestamp);
              findWeekday(end, weekdays[weekdays.length - 1]);
              updateFormatted(end);
              if (today) {
                updateRelative(end, today, end.hasTime);
              }
              return end;
            }
            function getStartOfMonth(timestamp) {
              var start = copyTimestamp(timestamp);
              start.day = DAY_MIN;
              updateWeekday(start);
              updateFormatted(start);
              return start;
            }
            function getEndOfMonth(timestamp) {
              var end = copyTimestamp(timestamp);
              end.day = daysInMonth(end.year, end.month);
              updateWeekday(end);
              updateFormatted(end);
              return end;
            }
            function validateTime(input2) {
              return typeof input2 === "number" && isFinite(input2) || !!PARSE_TIME.exec(input2) || _typeof2(input2) === "object" && isFinite(input2.hour) && isFinite(input2.minute);
            }
            function parseTime(input2) {
              if (typeof input2 === "number") {
                return input2;
              } else if (typeof input2 === "string") {
                var parts = PARSE_TIME.exec(input2);
                if (!parts) {
                  return false;
                }
                return parseInt(parts[1]) * 60 + parseInt(parts[3] || 0);
              } else if (_typeof2(input2) === "object") {
                if (typeof input2.hour !== "number" || typeof input2.minute !== "number") {
                  return false;
                }
                return input2.hour * 60 + input2.minute;
              } else {
                return false;
              }
            }
            function validateTimestamp(input2) {
              return typeof input2 === "number" && isFinite(input2) || typeof input2 === "string" && !!PARSE_REGEX.exec(input2) || input2 instanceof Date;
            }
            function parseTimestamp(input2, required, now2) {
              if (required === void 0) {
                required = false;
              }
              if (typeof input2 === "number" && isFinite(input2)) {
                input2 = new Date(input2);
              }
              if (input2 instanceof Date) {
                var date = parseDate(input2);
                if (now2) {
                  updateRelative(date, now2, date.hasTime);
                }
                return date;
              }
              if (typeof input2 !== "string") {
                if (required) {
                  throw new Error(input2 + " is not a valid timestamp. It must be a Date, number of milliseconds since Epoch, or a string in the format of YYYY-MM-DD or YYYY-MM-DD hh:mm. Zero-padding is optional and seconds are ignored.");
                }
                return null;
              }
              var parts = PARSE_REGEX.exec(input2);
              if (!parts) {
                if (required) {
                  throw new Error(input2 + " is not a valid timestamp. It must be a Date, number of milliseconds since Epoch, or a string in the format of YYYY-MM-DD or YYYY-MM-DD hh:mm. Zero-padding is optional and seconds are ignored.");
                }
                return null;
              }
              var timestamp = {
                date: input2,
                time: "",
                year: parseInt(parts[1]),
                month: parseInt(parts[2]),
                day: parseInt(parts[4]) || 1,
                hour: parseInt(parts[6]) || 0,
                minute: parseInt(parts[8]) || 0,
                weekday: 0,
                hasDay: !!parts[4],
                hasTime: !!(parts[6] && parts[8]),
                past: false,
                present: false,
                future: false
              };
              updateWeekday(timestamp);
              updateFormatted(timestamp);
              if (now2) {
                updateRelative(timestamp, now2, timestamp.hasTime);
              }
              return timestamp;
            }
            function parseDate(date) {
              return updateFormatted({
                date: "",
                time: "",
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: date.getDate(),
                weekday: date.getDay(),
                hour: date.getHours(),
                minute: date.getMinutes(),
                hasDay: true,
                hasTime: true,
                past: false,
                present: true,
                future: false
              });
            }
            function getDayIdentifier(timestamp) {
              return timestamp.year * OFFSET_YEAR + timestamp.month * OFFSET_MONTH + timestamp.day;
            }
            function getTimeIdentifier(timestamp) {
              return timestamp.hour * OFFSET_HOUR + timestamp.minute;
            }
            function getTimestampIdentifier(timestamp) {
              return getDayIdentifier(timestamp) * OFFSET_TIME + getTimeIdentifier(timestamp);
            }
            function updateRelative(timestamp, now2, time) {
              if (time === void 0) {
                time = false;
              }
              var a = getDayIdentifier(now2);
              var b = getDayIdentifier(timestamp);
              var present = a === b;
              if (timestamp.hasTime && time && present) {
                a = getTimeIdentifier(now2);
                b = getTimeIdentifier(timestamp);
                present = a === b;
              }
              timestamp.past = b < a;
              timestamp.present = present;
              timestamp.future = b > a;
              return timestamp;
            }
            function isTimedless(input2) {
              return input2 instanceof Date || typeof input2 === "number" && isFinite(input2);
            }
            function updateHasTime(timestamp, hasTime, now2) {
              if (timestamp.hasTime !== hasTime) {
                timestamp.hasTime = hasTime;
                if (!hasTime) {
                  timestamp.hour = HOUR_MAX;
                  timestamp.minute = MINUTE_MAX;
                  timestamp.time = getTime(timestamp);
                }
                if (now2) {
                  updateRelative(timestamp, now2, timestamp.hasTime);
                }
              }
              return timestamp;
            }
            function updateMinutes(timestamp, minutes, now2) {
              timestamp.hasTime = true;
              timestamp.hour = Math.floor(minutes / MINUTES_IN_HOUR);
              timestamp.minute = minutes % MINUTES_IN_HOUR;
              timestamp.time = getTime(timestamp);
              if (now2) {
                updateRelative(timestamp, now2, true);
              }
              return timestamp;
            }
            function updateWeekday(timestamp) {
              timestamp.weekday = getWeekday(timestamp);
              return timestamp;
            }
            function updateFormatted(timestamp) {
              timestamp.time = getTime(timestamp);
              timestamp.date = getDate(timestamp);
              return timestamp;
            }
            function getWeekday(timestamp) {
              if (timestamp.hasDay) {
                var _ = Math.floor;
                var k = timestamp.day;
                var m = (timestamp.month + 9) % MONTH_MAX + 1;
                var C = _(timestamp.year / 100);
                var Y = timestamp.year % 100 - (timestamp.month <= 2 ? 1 : 0);
                return ((k + _(2.6 * m - 0.2) - 2 * C + Y + _(Y / 4) + _(C / 4)) % 7 + 7) % 7;
              }
              return timestamp.weekday;
            }
            function daysInMonth(year, month) {
              return Object(_util_dateTimeUtils__WEBPACK_IMPORTED_MODULE_0__["isLeapYear"])(year) ? DAYS_IN_MONTH_LEAP[month] : DAYS_IN_MONTH[month];
            }
            function copyTimestamp(timestamp) {
              var date = timestamp.date, time = timestamp.time, year = timestamp.year, month = timestamp.month, day = timestamp.day, weekday = timestamp.weekday, hour = timestamp.hour, minute = timestamp.minute, hasDay = timestamp.hasDay, hasTime = timestamp.hasTime, past = timestamp.past, present = timestamp.present, future = timestamp.future;
              return {
                date,
                time,
                year,
                month,
                day,
                weekday,
                hour,
                minute,
                hasDay,
                hasTime,
                past,
                present,
                future
              };
            }
            function padNumber(x2, length) {
              var padded = String(x2);
              while (padded.length < length) {
                padded = "0" + padded;
              }
              return padded;
            }
            function getDate(timestamp) {
              var str = padNumber(timestamp.year, 4) + "-" + padNumber(timestamp.month, 2);
              if (timestamp.hasDay)
                str += "-" + padNumber(timestamp.day, 2);
              return str;
            }
            function getTime(timestamp) {
              if (!timestamp.hasTime) {
                return "";
              }
              return padNumber(timestamp.hour, 2) + ":" + padNumber(timestamp.minute, 2);
            }
            function nextMinutes(timestamp, minutes) {
              timestamp.minute += minutes;
              while (timestamp.minute > MINUTES_IN_HOUR) {
                timestamp.minute -= MINUTES_IN_HOUR;
                timestamp.hour++;
                if (timestamp.hour >= HOURS_IN_DAY) {
                  nextDay(timestamp);
                  timestamp.hour = FIRST_HOUR;
                }
              }
              return timestamp;
            }
            function nextDay(timestamp) {
              timestamp.day++;
              timestamp.weekday = (timestamp.weekday + 1) % DAYS_IN_WEEK;
              if (timestamp.day > DAYS_IN_MONTH_MIN && timestamp.day > daysInMonth(timestamp.year, timestamp.month)) {
                timestamp.day = DAY_MIN;
                timestamp.month++;
                if (timestamp.month > MONTH_MAX) {
                  timestamp.month = MONTH_MIN;
                  timestamp.year++;
                }
              }
              return timestamp;
            }
            function prevDay(timestamp) {
              timestamp.day--;
              timestamp.weekday = (timestamp.weekday + 6) % DAYS_IN_WEEK;
              if (timestamp.day < DAY_MIN) {
                timestamp.month--;
                if (timestamp.month < MONTH_MIN) {
                  timestamp.year--;
                  timestamp.month = MONTH_MAX;
                }
                timestamp.day = daysInMonth(timestamp.year, timestamp.month);
              }
              return timestamp;
            }
            function relativeDays(timestamp, mover, days) {
              if (mover === void 0) {
                mover = nextDay;
              }
              if (days === void 0) {
                days = 1;
              }
              while (--days >= 0) {
                mover(timestamp);
              }
              return timestamp;
            }
            function diffMinutes(min2, max2) {
              var Y = (max2.year - min2.year) * 525600;
              var M = (max2.month - min2.month) * 43800;
              var D = (max2.day - min2.day) * 1440;
              var h = (max2.hour - min2.hour) * 60;
              var m = max2.minute - min2.minute;
              return Y + M + D + h + m;
            }
            function findWeekday(timestamp, weekday, mover, maxDays) {
              if (mover === void 0) {
                mover = nextDay;
              }
              if (maxDays === void 0) {
                maxDays = 6;
              }
              while (timestamp.weekday !== weekday && --maxDays >= 0) {
                mover(timestamp);
              }
              return timestamp;
            }
            function getWeekdaySkips(weekdays) {
              var skips = [1, 1, 1, 1, 1, 1, 1];
              var filled = [0, 0, 0, 0, 0, 0, 0];
              for (var i2 = 0; i2 < weekdays.length; i2++) {
                filled[weekdays[i2]] = 1;
              }
              for (var k = 0; k < DAYS_IN_WEEK; k++) {
                var skip = 1;
                for (var j = 1; j < DAYS_IN_WEEK; j++) {
                  var next = (k + j) % DAYS_IN_WEEK;
                  if (filled[next]) {
                    break;
                  }
                  skip++;
                }
                skips[k] = filled[k] * skip;
              }
              return skips;
            }
            function timestampToDate(timestamp) {
              var time = padNumber(timestamp.hour, 2) + ":" + padNumber(timestamp.minute, 2);
              var date = timestamp.date;
              return /* @__PURE__ */ new Date(date + "T" + time + ":00+00:00");
            }
            function createDayList(start, end, now2, weekdaySkips, max2, min2) {
              if (max2 === void 0) {
                max2 = 42;
              }
              if (min2 === void 0) {
                min2 = 0;
              }
              var stop = getDayIdentifier(end);
              var days = [];
              var current = copyTimestamp(start);
              var currentIdentifier = 0;
              var stopped = currentIdentifier === stop;
              if (stop < getDayIdentifier(start)) {
                throw new Error("End date is earlier than start date.");
              }
              while ((!stopped || days.length < min2) && days.length < max2) {
                currentIdentifier = getDayIdentifier(current);
                stopped = stopped || currentIdentifier === stop;
                if (weekdaySkips[current.weekday] === 0) {
                  current = nextDay(current);
                  continue;
                }
                var day = copyTimestamp(current);
                updateFormatted(day);
                updateRelative(day, now2);
                days.push(day);
                current = relativeDays(current, nextDay, weekdaySkips[current.weekday]);
              }
              if (!days.length)
                throw new Error("No dates found using specified start date, end date, and weekdays.");
              return days;
            }
            function createIntervalList(timestamp, first, minutes, count, now2) {
              var intervals = [];
              for (var i2 = 0; i2 < count; i2++) {
                var mins = first + i2 * minutes;
                var int = copyTimestamp(timestamp);
                intervals.push(updateMinutes(int, mins, now2));
              }
              return intervals;
            }
            function createNativeLocaleFormatter(locale, getOptions) {
              var emptyFormatter = function emptyFormatter2(_t2, _s) {
                return "";
              };
              if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") {
                return emptyFormatter;
              }
              return function(timestamp, short) {
                try {
                  var intlFormatter = new Intl.DateTimeFormat(locale || void 0, getOptions(timestamp, short));
                  return intlFormatter.format(timestampToDate(timestamp));
                } catch (e) {
                  return "";
                }
              };
            }
          }
        ),
        /***/
        "./src/components/VCard/VCard.sass": (
          /*!*****************************************!*\
            !*** ./src/components/VCard/VCard.sass ***!
            \*****************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VCard/VCard.ts": (
          /*!***************************************!*\
            !*** ./src/components/VCard/VCard.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VCard.sass */
              "./src/components/VCard/VCard.sass"
            );
            var _VSheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSheet */
              "./src/components/VSheet/index.ts"
            );
            var _mixins_loadable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/loadable */
              "./src/mixins/loadable/index.ts"
            );
            var _mixins_routable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/routable */
              "./src/mixins/routable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_loadable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_routable__WEBPACK_IMPORTED_MODULE_3__["default"], _VSheet__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
              name: "v-card",
              props: {
                flat: Boolean,
                hover: Boolean,
                img: String,
                link: Boolean,
                loaderHeight: {
                  type: [Number, String],
                  default: 4
                },
                raised: Boolean
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2(__assign2({
                    "v-card": true
                  }, _mixins_routable__WEBPACK_IMPORTED_MODULE_3__["default"].options.computed.classes.call(this)), {
                    "v-card--flat": this.flat,
                    "v-card--hover": this.hover,
                    "v-card--link": this.isClickable,
                    "v-card--loading": this.loading,
                    "v-card--disabled": this.disabled,
                    "v-card--raised": this.raised
                  }), _VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this));
                },
                styles: function styles() {
                  var style2 = __assign2({}, _VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.styles.call(this));
                  if (this.img) {
                    style2.background = 'url("' + this.img + '") center center / cover no-repeat';
                  }
                  return style2;
                }
              },
              methods: {
                genProgress: function genProgress() {
                  var render8 = _mixins_loadable__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genProgress.call(this);
                  if (!render8)
                    return null;
                  return this.$createElement("div", {
                    staticClass: "v-card__progress",
                    key: "progress"
                  }, [render8]);
                }
              },
              render: function render8(h) {
                var _a2 = this.generateRouteLink(), tag = _a2.tag, data = _a2.data;
                data.style = this.styles;
                if (this.isClickable) {
                  data.attrs = data.attrs || {};
                  data.attrs.tabindex = 0;
                }
                return h(tag, this.setBackgroundColor(this.color, data), [this.genProgress(), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this)]);
              }
            });
          }
        ),
        /***/
        "./src/components/VCard/index.ts": (
          /*!***************************************!*\
            !*** ./src/components/VCard/index.ts ***!
            \***************************************/
          /*! exports provided: VCard, VCardActions, VCardSubtitle, VCardText, VCardTitle, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "VCardActions", function() {
              return VCardActions;
            });
            __webpack_require__.d(__webpack_exports__, "VCardSubtitle", function() {
              return VCardSubtitle;
            });
            __webpack_require__.d(__webpack_exports__, "VCardText", function() {
              return VCardText;
            });
            __webpack_require__.d(__webpack_exports__, "VCardTitle", function() {
              return VCardTitle;
            });
            var _VCard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VCard */
              "./src/components/VCard/VCard.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCard", function() {
              return _VCard__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var VCardActions = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["createSimpleFunctional"])("v-card__actions");
            var VCardSubtitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["createSimpleFunctional"])("v-card__subtitle");
            var VCardText = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["createSimpleFunctional"])("v-card__text");
            var VCardTitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["createSimpleFunctional"])("v-card__title");
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VCard: _VCard__WEBPACK_IMPORTED_MODULE_0__["default"],
                VCardActions,
                VCardSubtitle,
                VCardText,
                VCardTitle
              }
            };
          }
        ),
        /***/
        "./src/components/VCarousel/VCarousel.sass": (
          /*!*************************************************!*\
            !*** ./src/components/VCarousel/VCarousel.sass ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VCarousel/VCarousel.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VCarousel/VCarousel.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VCarousel.sass */
              "./src/components/VCarousel/VCarousel.sass"
            );
            var _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VWindow/VWindow */
              "./src/components/VWindow/VWindow.ts"
            );
            var _VBtn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VBtn */
              "./src/components/VBtn/index.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _VProgressLinear__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../VProgressLinear */
              "./src/components/VProgressLinear/index.ts"
            );
            var _mixins_button_group__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/button-group */
              "./src/mixins/button-group/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
              name: "v-carousel",
              props: {
                continuous: {
                  type: Boolean,
                  default: true
                },
                cycle: Boolean,
                delimiterIcon: {
                  type: String,
                  default: "$delimiter"
                },
                height: {
                  type: [Number, String],
                  default: 500
                },
                hideDelimiters: Boolean,
                hideDelimiterBackground: Boolean,
                interval: {
                  type: [Number, String],
                  default: 6e3,
                  validator: function validator2(value) {
                    return value > 0;
                  }
                },
                mandatory: {
                  type: Boolean,
                  default: true
                },
                progress: Boolean,
                progressColor: String,
                showArrows: {
                  type: Boolean,
                  default: true
                },
                verticalDelimiters: {
                  type: String,
                  default: void 0
                }
              },
              // pass down the parent's theme
              provide: function provide() {
                return {
                  parentTheme: this.theme
                };
              },
              data: function data() {
                return {
                  internalHeight: this.height,
                  slideTimeout: void 0
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-carousel": true,
                    "v-carousel--hide-delimiter-background": this.hideDelimiterBackground,
                    "v-carousel--vertical-delimiters": this.isVertical
                  });
                },
                isDark: function isDark() {
                  return this.dark || !this.light;
                },
                isVertical: function isVertical() {
                  return this.verticalDelimiters != null;
                }
              },
              watch: {
                internalValue: "restartTimeout",
                interval: "restartTimeout",
                height: function height(val, oldVal) {
                  if (val === oldVal || !val)
                    return;
                  this.internalHeight = val;
                },
                cycle: function cycle(val) {
                  if (val) {
                    this.restartTimeout();
                  } else {
                    clearTimeout(this.slideTimeout);
                    this.slideTimeout = void 0;
                  }
                }
              },
              created: function created2() {
                if (this.$attrs.hasOwnProperty("hide-controls")) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_7__["breaking"])("hide-controls", ':show-arrows="false"', this);
                }
              },
              mounted: function mounted3() {
                this.startTimeout();
              },
              methods: {
                genControlIcons: function genControlIcons() {
                  if (this.isVertical)
                    return null;
                  return _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genControlIcons.call(this);
                },
                genDelimiters: function genDelimiters() {
                  return this.$createElement("div", {
                    staticClass: "v-carousel__controls",
                    style: {
                      left: this.verticalDelimiters === "left" && this.isVertical ? 0 : "auto",
                      right: this.verticalDelimiters === "right" ? 0 : "auto"
                    }
                  }, [this.genItems()]);
                },
                genItems: function genItems() {
                  var _this2 = this;
                  var length = this.items.length;
                  var children = [];
                  for (var i2 = 0; i2 < length; i2++) {
                    var child = this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_2__["default"], {
                      staticClass: "v-carousel__controls__item",
                      attrs: {
                        "aria-label": this.$vuetify.lang.t("$vuetify.carousel.ariaLabel.delimiter", i2 + 1, length)
                      },
                      props: {
                        icon: true,
                        small: true,
                        value: this.getValue(this.items[i2], i2)
                      },
                      key: i2
                    }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
                      props: {
                        size: 18
                      }
                    }, this.delimiterIcon)]);
                    children.push(child);
                  }
                  return this.$createElement(_mixins_button_group__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    props: {
                      value: this.internalValue,
                      mandatory: this.mandatory
                    },
                    on: {
                      change: function change(val) {
                        _this2.internalValue = val;
                      }
                    }
                  }, children);
                },
                genProgress: function genProgress() {
                  return this.$createElement(_VProgressLinear__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    staticClass: "v-carousel__progress",
                    props: {
                      color: this.progressColor,
                      value: (this.internalIndex + 1) / this.items.length * 100
                    }
                  });
                },
                restartTimeout: function restartTimeout() {
                  this.slideTimeout && clearTimeout(this.slideTimeout);
                  this.slideTimeout = void 0;
                  window.requestAnimationFrame(this.startTimeout);
                },
                startTimeout: function startTimeout() {
                  if (!this.cycle)
                    return;
                  this.slideTimeout = window.setTimeout(this.next, +this.interval > 0 ? +this.interval : 6e3);
                }
              },
              render: function render8(h) {
                var render9 = _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_1__["default"].options.render.call(this, h);
                render9.data.style = "height: " + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["convertToUnit"])(this.height) + ";";
                if (!this.hideDelimiters) {
                  render9.children.push(this.genDelimiters());
                }
                if (this.progress || this.progressColor) {
                  render9.children.push(this.genProgress());
                }
                return render9;
              }
            });
          }
        ),
        /***/
        "./src/components/VCarousel/VCarouselItem.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VCarousel/VCarouselItem.ts ***!
            \***************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../VWindow/VWindowItem */
              "./src/components/VWindow/VWindowItem.ts"
            );
            var _VImg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VImg */
              "./src/components/VImg/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _mixins_routable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/routable */
              "./src/mixins/routable/index.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__["default"], _mixins_routable__WEBPACK_IMPORTED_MODULE_4__["default"]);
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-carousel-item",
              inject: {
                parentTheme: {
                  default: {
                    isDark: false
                  }
                }
              },
              // pass down the parent's theme
              provide: function provide() {
                return {
                  theme: this.parentTheme
                };
              },
              inheritAttrs: false,
              methods: {
                genDefaultSlot: function genDefaultSlot() {
                  return [this.$createElement(_VImg__WEBPACK_IMPORTED_MODULE_1__["VImg"], {
                    staticClass: "v-carousel__item",
                    props: __assign2(__assign2({}, this.$attrs), {
                      height: this.windowGroup.internalHeight
                    }),
                    on: this.$listeners,
                    scopedSlots: {
                      placeholder: this.$scopedSlots.placeholder
                    }
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this))];
                },
                genWindowItem: function genWindowItem() {
                  var _a2 = this.generateRouteLink(), tag = _a2.tag, data = _a2.data;
                  data.staticClass = "v-window-item";
                  data.directives.push({
                    name: "show",
                    value: this.isActive
                  });
                  return this.$createElement(tag, data, this.genDefaultSlot());
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VCarousel/index.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VCarousel/index.ts ***!
            \*******************************************/
          /*! exports provided: VCarousel, VCarouselItem, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VCarousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VCarousel */
              "./src/components/VCarousel/VCarousel.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCarousel", function() {
              return _VCarousel__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VCarouselItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VCarouselItem */
              "./src/components/VCarousel/VCarouselItem.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCarouselItem", function() {
              return _VCarouselItem__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VCarousel: _VCarousel__WEBPACK_IMPORTED_MODULE_0__["default"],
                VCarouselItem: _VCarouselItem__WEBPACK_IMPORTED_MODULE_1__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VCheckbox/VCheckbox.sass": (
          /*!*************************************************!*\
            !*** ./src/components/VCheckbox/VCheckbox.sass ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VCheckbox/VCheckbox.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VCheckbox/VCheckbox.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VCheckbox.sass */
              "./src/components/VCheckbox/VCheckbox.sass"
            );
            __webpack_require__(
              /*! ../../styles/components/_selection-controls.sass */
              "./src/styles/components/_selection-controls.sass"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _VInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VInput */
              "./src/components/VInput/index.ts"
            );
            var _mixins_selectable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/selectable */
              "./src/mixins/selectable/index.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __rest = function(s2, e) {
              var t3 = {};
              for (var p in s2) {
                if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
                  t3[p] = s2[p];
              }
              if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
                for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
                  if (e.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
                    t3[p[i2]] = s2[p[i2]];
                }
              return t3;
            };
            __webpack_exports__["default"] = _mixins_selectable__WEBPACK_IMPORTED_MODULE_4__["default"].extend({
              name: "v-checkbox",
              props: {
                indeterminate: Boolean,
                indeterminateIcon: {
                  type: String,
                  default: "$checkboxIndeterminate"
                },
                offIcon: {
                  type: String,
                  default: "$checkboxOff"
                },
                onIcon: {
                  type: String,
                  default: "$checkboxOn"
                }
              },
              data: function data() {
                return {
                  inputIndeterminate: this.indeterminate
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VInput__WEBPACK_IMPORTED_MODULE_3__["default"].options.computed.classes.call(this)), {
                    "v-input--selection-controls": true,
                    "v-input--checkbox": true,
                    "v-input--indeterminate": this.inputIndeterminate
                  });
                },
                computedIcon: function computedIcon() {
                  if (this.inputIndeterminate) {
                    return this.indeterminateIcon;
                  } else if (this.isActive) {
                    return this.onIcon;
                  } else {
                    return this.offIcon;
                  }
                },
                // Do not return undefined if disabled,
                // according to spec, should still show
                // a color when disabled and active
                validationState: function validationState() {
                  if (this.isDisabled && !this.inputIndeterminate)
                    return void 0;
                  if (this.hasError && this.shouldValidate)
                    return "error";
                  if (this.hasSuccess)
                    return "success";
                  if (this.hasColor !== null)
                    return this.computedColor;
                  return void 0;
                }
              },
              watch: {
                indeterminate: function indeterminate(val) {
                  var _this2 = this;
                  this.$nextTick(function() {
                    return _this2.inputIndeterminate = val;
                  });
                },
                inputIndeterminate: function inputIndeterminate(val) {
                  this.$emit("update:indeterminate", val);
                },
                isActive: function isActive() {
                  if (!this.indeterminate)
                    return;
                  this.inputIndeterminate = false;
                }
              },
              methods: {
                genCheckbox: function genCheckbox() {
                  var _a2 = this.attrs$;
                  _a2.title;
                  var checkboxAttrs = __rest(_a2, ["title"]);
                  return this.$createElement("div", {
                    staticClass: "v-input--selection-controls__input"
                  }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], this.setTextColor(this.validationState, {
                    props: {
                      dense: this.dense,
                      dark: this.dark,
                      light: this.light
                    }
                  }), this.computedIcon), this.genInput("checkbox", __assign2(__assign2({}, checkboxAttrs), {
                    "aria-checked": this.inputIndeterminate ? "mixed" : this.isActive.toString()
                  })), this.genRipple(this.setTextColor(this.rippleState))]);
                },
                genDefaultSlot: function genDefaultSlot() {
                  return [this.genCheckbox(), this.genLabel()];
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VCheckbox/VSimpleCheckbox.sass": (
          /*!*******************************************************!*\
            !*** ./src/components/VCheckbox/VSimpleCheckbox.sass ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VCheckbox/VSimpleCheckbox.ts": (
          /*!*****************************************************!*\
            !*** ./src/components/VCheckbox/VSimpleCheckbox.ts ***!
            \*****************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VSimpleCheckbox.sass */
              "./src/components/VCheckbox/VSimpleCheckbox.sass"
            );
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_2___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
            var _VIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend({
              name: "v-simple-checkbox",
              functional: true,
              directives: {
                Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_1__["default"]
              },
              props: __assign2(__assign2(__assign2({}, _mixins_colorable__WEBPACK_IMPORTED_MODULE_4__["default"].options.props), _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__["default"].options.props), {
                disabled: Boolean,
                ripple: {
                  type: Boolean,
                  default: true
                },
                value: Boolean,
                indeterminate: Boolean,
                indeterminateIcon: {
                  type: String,
                  default: "$checkboxIndeterminate"
                },
                onIcon: {
                  type: String,
                  default: "$checkboxOn"
                },
                offIcon: {
                  type: String,
                  default: "$checkboxOff"
                }
              }),
              render: function render8(h, _a2) {
                var props2 = _a2.props, data = _a2.data;
                _a2.listeners;
                var children = [];
                var icon = props2.offIcon;
                if (props2.indeterminate)
                  icon = props2.indeterminateIcon;
                else if (props2.value)
                  icon = props2.onIcon;
                children.push(h(_VIcon__WEBPACK_IMPORTED_MODULE_3__["VIcon"], _mixins_colorable__WEBPACK_IMPORTED_MODULE_4__["default"].options.methods.setTextColor(props2.value && props2.color, {
                  props: {
                    disabled: props2.disabled,
                    dark: props2.dark,
                    light: props2.light
                  }
                }), icon));
                if (props2.ripple && !props2.disabled) {
                  var ripple = h("div", _mixins_colorable__WEBPACK_IMPORTED_MODULE_4__["default"].options.methods.setTextColor(props2.color, {
                    staticClass: "v-input--selection-controls__ripple",
                    directives: [{
                      def: _directives_ripple__WEBPACK_IMPORTED_MODULE_1__["default"],
                      name: "ripple",
                      value: {
                        center: true
                      }
                    }]
                  }));
                  children.push(ripple);
                }
                return h("div", Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_6__["default"])(data, {
                  class: {
                    "v-simple-checkbox": true,
                    "v-simple-checkbox--disabled": props2.disabled
                  },
                  on: {
                    click: function click2(e) {
                      e.stopPropagation();
                      if (data.on && data.on.input && !props2.disabled) {
                        Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["wrapInArray"])(data.on.input).forEach(function(f) {
                          return f(!props2.value);
                        });
                      }
                    }
                  }
                }), [h("div", {
                  staticClass: "v-input--selection-controls__input"
                }, children)]);
              }
            });
          }
        ),
        /***/
        "./src/components/VCheckbox/index.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VCheckbox/index.ts ***!
            \*******************************************/
          /*! exports provided: VCheckbox, VSimpleCheckbox, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VCheckbox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VCheckbox */
              "./src/components/VCheckbox/VCheckbox.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCheckbox", function() {
              return _VCheckbox__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VSimpleCheckbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VSimpleCheckbox */
              "./src/components/VCheckbox/VSimpleCheckbox.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSimpleCheckbox", function() {
              return _VSimpleCheckbox__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VCheckbox: _VCheckbox__WEBPACK_IMPORTED_MODULE_0__["default"],
                VSimpleCheckbox: _VSimpleCheckbox__WEBPACK_IMPORTED_MODULE_1__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VChip/VChip.sass": (
          /*!*****************************************!*\
            !*** ./src/components/VChip/VChip.sass ***!
            \*****************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VChip/VChip.ts": (
          /*!***************************************!*\
            !*** ./src/components/VChip/VChip.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VChip.sass */
              "./src/components/VChip/VChip.sass"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _transitions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../transitions */
              "./src/components/transitions/index.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_groupable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/groupable */
              "./src/mixins/groupable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _mixins_routable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../mixins/routable */
              "./src/mixins/routable/index.ts"
            );
            var _mixins_sizeable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../mixins/sizeable */
              "./src/mixins/sizeable/index.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_sizeable__WEBPACK_IMPORTED_MODULE_9__["default"], _mixins_routable__WEBPACK_IMPORTED_MODULE_8__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__["default"], Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_5__["factory"])("chipGroup"), Object(_mixins_toggleable__WEBPACK_IMPORTED_MODULE_7__["factory"])("inputValue")).extend({
              name: "v-chip",
              props: {
                active: {
                  type: Boolean,
                  default: true
                },
                activeClass: {
                  type: String,
                  default: function _default() {
                    if (!this.chipGroup)
                      return "";
                    return this.chipGroup.activeClass;
                  }
                },
                close: Boolean,
                closeIcon: {
                  type: String,
                  default: "$delete"
                },
                closeLabel: {
                  type: String,
                  default: "$vuetify.close"
                },
                disabled: Boolean,
                draggable: Boolean,
                filter: Boolean,
                filterIcon: {
                  type: String,
                  default: "$complete"
                },
                label: Boolean,
                link: Boolean,
                outlined: Boolean,
                pill: Boolean,
                tag: {
                  type: String,
                  default: "span"
                },
                textColor: String,
                value: null
              },
              data: function data() {
                return {
                  proxyClass: "v-chip--active"
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2(__assign2(__assign2(__assign2({
                    "v-chip": true
                  }, _mixins_routable__WEBPACK_IMPORTED_MODULE_8__["default"].options.computed.classes.call(this)), {
                    "v-chip--clickable": this.isClickable,
                    "v-chip--disabled": this.disabled,
                    "v-chip--draggable": this.draggable,
                    "v-chip--label": this.label,
                    "v-chip--link": this.isLink,
                    "v-chip--no-color": !this.color,
                    "v-chip--outlined": this.outlined,
                    "v-chip--pill": this.pill,
                    "v-chip--removable": this.hasClose
                  }), this.themeClasses), this.sizeableClasses), this.groupClasses);
                },
                hasClose: function hasClose() {
                  return Boolean(this.close);
                },
                isClickable: function isClickable() {
                  return Boolean(_mixins_routable__WEBPACK_IMPORTED_MODULE_8__["default"].options.computed.isClickable.call(this) || this.chipGroup);
                }
              },
              created: function created2() {
                var _this2 = this;
                var breakingProps = [["outline", "outlined"], ["selected", "input-value"], ["value", "active"], ["@input", "@active.sync"]];
                breakingProps.forEach(function(_a2) {
                  var _b2 = __read2(_a2, 2), original = _b2[0], replacement = _b2[1];
                  if (_this2.$attrs.hasOwnProperty(original))
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_10__["breaking"])(original, replacement, _this2);
                });
              },
              methods: {
                click: function click2(e) {
                  this.$emit("click", e);
                  this.chipGroup && this.toggle();
                },
                genFilter: function genFilter() {
                  var children = [];
                  if (this.isActive) {
                    children.push(this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
                      staticClass: "v-chip__filter",
                      props: {
                        left: true
                      }
                    }, this.filterIcon));
                  }
                  return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_2__["VExpandXTransition"], children);
                },
                genClose: function genClose() {
                  var _this2 = this;
                  return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    staticClass: "v-chip__close",
                    props: {
                      right: true,
                      size: 18
                    },
                    attrs: {
                      "aria-label": this.$vuetify.lang.t(this.closeLabel)
                    },
                    on: {
                      click: function click2(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        _this2.$emit("click:close");
                        _this2.$emit("update:active", false);
                      }
                    }
                  }, this.closeIcon);
                },
                genContent: function genContent() {
                  return this.$createElement("span", {
                    staticClass: "v-chip__content"
                  }, [this.filter && this.genFilter(), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_11__["getSlot"])(this), this.hasClose && this.genClose()]);
                }
              },
              render: function render8(h) {
                var children = [this.genContent()];
                var _a2 = this.generateRouteLink(), tag = _a2.tag, data = _a2.data;
                data.attrs = __assign2(__assign2({}, data.attrs), {
                  draggable: this.draggable ? "true" : void 0,
                  tabindex: this.chipGroup && !this.disabled ? 0 : data.attrs.tabindex
                });
                data.directives.push({
                  name: "show",
                  value: this.active
                });
                data = this.setBackgroundColor(this.color, data);
                var color2 = this.textColor || this.outlined && this.color;
                return h(tag, this.setTextColor(color2, data), children);
              }
            });
          }
        ),
        /***/
        "./src/components/VChip/index.ts": (
          /*!***************************************!*\
            !*** ./src/components/VChip/index.ts ***!
            \***************************************/
          /*! exports provided: VChip, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VChip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VChip */
              "./src/components/VChip/VChip.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VChip", function() {
              return _VChip__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VChip__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VChipGroup/VChipGroup.sass": (
          /*!***************************************************!*\
            !*** ./src/components/VChipGroup/VChipGroup.sass ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VChipGroup/VChipGroup.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VChipGroup/VChipGroup.ts ***!
            \*************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VChipGroup.sass */
              "./src/components/VChipGroup/VChipGroup.sass"
            );
            var _VSlideGroup_VSlideGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSlideGroup/VSlideGroup */
              "./src/components/VSlideGroup/VSlideGroup.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_VSlideGroup_VSlideGroup__WEBPACK_IMPORTED_MODULE_1__["BaseSlideGroup"], _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"]).extend({
              name: "v-chip-group",
              provide: function provide() {
                return {
                  chipGroup: this
                };
              },
              props: {
                column: Boolean
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VSlideGroup_VSlideGroup__WEBPACK_IMPORTED_MODULE_1__["BaseSlideGroup"].options.computed.classes.call(this)), {
                    "v-chip-group": true,
                    "v-chip-group--column": this.column
                  });
                }
              },
              watch: {
                column: function column(val) {
                  if (val)
                    this.scrollOffset = 0;
                  this.$nextTick(this.onResize);
                }
              },
              methods: {
                genData: function genData() {
                  return this.setTextColor(this.color, __assign2({}, _VSlideGroup_VSlideGroup__WEBPACK_IMPORTED_MODULE_1__["BaseSlideGroup"].options.methods.genData.call(this)));
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VChipGroup/index.ts": (
          /*!********************************************!*\
            !*** ./src/components/VChipGroup/index.ts ***!
            \********************************************/
          /*! exports provided: VChipGroup, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VChipGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VChipGroup */
              "./src/components/VChipGroup/VChipGroup.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VChipGroup", function() {
              return _VChipGroup__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VChipGroup__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VColorPicker/VColorPicker.sass": (
          /*!*******************************************************!*\
            !*** ./src/components/VColorPicker/VColorPicker.sass ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VColorPicker/VColorPicker.ts": (
          /*!*****************************************************!*\
            !*** ./src/components/VColorPicker/VColorPicker.ts ***!
            \*****************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VColorPicker.sass */
              "./src/components/VColorPicker/VColorPicker.sass"
            );
            var _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSheet/VSheet */
              "./src/components/VSheet/VSheet.ts"
            );
            var _VColorPickerPreview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VColorPickerPreview */
              "./src/components/VColorPicker/VColorPickerPreview.ts"
            );
            var _VColorPickerCanvas__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VColorPickerCanvas */
              "./src/components/VColorPicker/VColorPickerCanvas.ts"
            );
            var _VColorPickerEdit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./VColorPickerEdit */
              "./src/components/VColorPicker/VColorPickerEdit.ts"
            );
            var _VColorPickerSwatches__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./VColorPickerSwatches */
              "./src/components/VColorPicker/VColorPickerSwatches.ts"
            );
            var _util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ./util */
              "./src/components/VColorPicker/util/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _mixins_elevatable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../mixins/elevatable */
              "./src/mixins/elevatable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_7__["default"])(_mixins_elevatable__WEBPACK_IMPORTED_MODULE_9__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_10__["default"]).extend({
              name: "v-color-picker",
              props: {
                canvasHeight: {
                  type: [String, Number],
                  default: 150
                },
                disabled: Boolean,
                dotSize: {
                  type: [Number, String],
                  default: 10
                },
                flat: Boolean,
                hideCanvas: Boolean,
                hideSliders: Boolean,
                hideInputs: Boolean,
                hideModeSwitch: Boolean,
                mode: {
                  type: String,
                  default: "rgba",
                  validator: function validator2(v) {
                    return Object.keys(_VColorPickerEdit__WEBPACK_IMPORTED_MODULE_4__["modes"]).includes(v);
                  }
                },
                showSwatches: Boolean,
                swatches: Array,
                swatchesMaxHeight: {
                  type: [Number, String],
                  default: 150
                },
                value: {
                  type: [Object, String]
                },
                width: {
                  type: [Number, String],
                  default: 300
                }
              },
              data: function data() {
                return {
                  internalValue: Object(_util__WEBPACK_IMPORTED_MODULE_6__["fromRGBA"])({
                    r: 255,
                    g: 0,
                    b: 0,
                    a: 1
                  })
                };
              },
              computed: {
                hideAlpha: function hideAlpha() {
                  if (!this.value)
                    return false;
                  return !Object(_util__WEBPACK_IMPORTED_MODULE_6__["hasAlpha"])(this.value);
                }
              },
              watch: {
                value: {
                  handler: function handler(color2) {
                    this.updateColor(Object(_util__WEBPACK_IMPORTED_MODULE_6__["parseColor"])(color2, this.internalValue));
                  },
                  immediate: true
                }
              },
              methods: {
                updateColor: function updateColor(color2) {
                  this.internalValue = color2;
                  var value = Object(_util__WEBPACK_IMPORTED_MODULE_6__["extractColor"])(this.internalValue, this.value);
                  if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["deepEqual"])(value, this.value)) {
                    this.$emit("input", value);
                    this.$emit("update:color", this.internalValue);
                  }
                },
                genCanvas: function genCanvas() {
                  return this.$createElement(_VColorPickerCanvas__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    props: {
                      color: this.internalValue,
                      disabled: this.disabled,
                      dotSize: this.dotSize,
                      width: this.width,
                      height: this.canvasHeight
                    },
                    on: {
                      "update:color": this.updateColor
                    }
                  });
                },
                genControls: function genControls() {
                  return this.$createElement("div", {
                    staticClass: "v-color-picker__controls"
                  }, [!this.hideSliders && this.genPreview(), !this.hideInputs && this.genEdit()]);
                },
                genEdit: function genEdit() {
                  var _this2 = this;
                  return this.$createElement(_VColorPickerEdit__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    props: {
                      color: this.internalValue,
                      disabled: this.disabled,
                      hideAlpha: this.hideAlpha,
                      hideModeSwitch: this.hideModeSwitch,
                      mode: this.mode
                    },
                    on: {
                      "update:color": this.updateColor,
                      "update:mode": function updateMode(v) {
                        return _this2.$emit("update:mode", v);
                      }
                    }
                  });
                },
                genPreview: function genPreview() {
                  return this.$createElement(_VColorPickerPreview__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    props: {
                      color: this.internalValue,
                      disabled: this.disabled,
                      hideAlpha: this.hideAlpha
                    },
                    on: {
                      "update:color": this.updateColor
                    }
                  });
                },
                genSwatches: function genSwatches() {
                  return this.$createElement(_VColorPickerSwatches__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    props: {
                      dark: this.dark,
                      light: this.light,
                      disabled: this.disabled,
                      swatches: this.swatches,
                      color: this.internalValue,
                      maxHeight: this.swatchesMaxHeight
                    },
                    on: {
                      "update:color": this.updateColor
                    }
                  });
                }
              },
              render: function render8(h) {
                return h(_VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"], {
                  staticClass: "v-color-picker",
                  class: __assign2(__assign2({
                    "v-color-picker--flat": this.flat
                  }, this.themeClasses), this.elevationClasses),
                  props: {
                    maxWidth: this.width
                  }
                }, [!this.hideCanvas && this.genCanvas(), (!this.hideSliders || !this.hideInputs) && this.genControls(), this.showSwatches && this.genSwatches()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VColorPicker/VColorPickerCanvas.sass": (
          /*!*************************************************************!*\
            !*** ./src/components/VColorPicker/VColorPickerCanvas.sass ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VColorPicker/VColorPickerCanvas.ts": (
          /*!***********************************************************!*\
            !*** ./src/components/VColorPicker/VColorPickerCanvas.ts ***!
            \***********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VColorPickerCanvas.sass */
              "./src/components/VColorPicker/VColorPickerCanvas.sass"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./util */
              "./src/components/VColorPicker/util/index.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_3___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_3__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_3___default.a.extend({
              name: "v-color-picker-canvas",
              props: {
                color: {
                  type: Object,
                  default: function _default() {
                    return Object(_util__WEBPACK_IMPORTED_MODULE_2__["fromRGBA"])({
                      r: 255,
                      g: 0,
                      b: 0,
                      a: 1
                    });
                  }
                },
                disabled: Boolean,
                dotSize: {
                  type: [Number, String],
                  default: 10
                },
                height: {
                  type: [Number, String],
                  default: 150
                },
                width: {
                  type: [Number, String],
                  default: 300
                }
              },
              data: function data() {
                return {
                  boundingRect: {
                    width: 0,
                    height: 0,
                    left: 0,
                    top: 0
                  }
                };
              },
              computed: {
                dot: function dot() {
                  if (!this.color)
                    return {
                      x: 0,
                      y: 0
                    };
                  return {
                    x: this.color.hsva.s * parseInt(this.width, 10),
                    y: (1 - this.color.hsva.v) * parseInt(this.height, 10)
                  };
                }
              },
              watch: {
                "color.hue": "updateCanvas"
              },
              mounted: function mounted3() {
                this.updateCanvas();
              },
              methods: {
                emitColor: function emitColor(x2, y) {
                  var _a2 = this.boundingRect, left = _a2.left, top = _a2.top, width = _a2.width, height = _a2.height;
                  this.$emit("update:color", Object(_util__WEBPACK_IMPORTED_MODULE_2__["fromHSVA"])({
                    h: this.color.hue,
                    s: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["clamp"])(x2 - left, 0, width) / width,
                    v: 1 - Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["clamp"])(y - top, 0, height) / height,
                    a: this.color.alpha
                  }));
                },
                updateCanvas: function updateCanvas() {
                  if (!this.color)
                    return;
                  var canvas = this.$refs.canvas;
                  var ctx = canvas.getContext("2d");
                  if (!ctx)
                    return;
                  var saturationGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
                  saturationGradient.addColorStop(0, "hsla(0, 0%, 100%, 1)");
                  saturationGradient.addColorStop(1, "hsla(" + this.color.hue + ", 100%, 50%, 1)");
                  ctx.fillStyle = saturationGradient;
                  ctx.fillRect(0, 0, canvas.width, canvas.height);
                  var valueGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
                  valueGradient.addColorStop(0, "hsla(0, 0%, 100%, 0)");
                  valueGradient.addColorStop(1, "hsla(0, 0%, 0%, 1)");
                  ctx.fillStyle = valueGradient;
                  ctx.fillRect(0, 0, canvas.width, canvas.height);
                },
                handleClick: function handleClick(e) {
                  if (this.disabled)
                    return;
                  this.boundingRect = this.$el.getBoundingClientRect();
                  this.emitColor(e.clientX, e.clientY);
                },
                handleMouseDown: function handleMouseDown(e) {
                  e.preventDefault();
                  if (this.disabled)
                    return;
                  this.boundingRect = this.$el.getBoundingClientRect();
                  window.addEventListener("mousemove", this.handleMouseMove);
                  window.addEventListener("mouseup", this.handleMouseUp);
                },
                handleMouseMove: function handleMouseMove(e) {
                  if (this.disabled)
                    return;
                  this.emitColor(e.clientX, e.clientY);
                },
                handleMouseUp: function handleMouseUp() {
                  window.removeEventListener("mousemove", this.handleMouseMove);
                  window.removeEventListener("mouseup", this.handleMouseUp);
                },
                genCanvas: function genCanvas() {
                  return this.$createElement("canvas", {
                    ref: "canvas",
                    attrs: {
                      width: this.width,
                      height: this.height
                    }
                  });
                },
                genDot: function genDot() {
                  var radius = parseInt(this.dotSize, 10) / 2;
                  var x2 = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["convertToUnit"])(this.dot.x - radius);
                  var y = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["convertToUnit"])(this.dot.y - radius);
                  return this.$createElement("div", {
                    staticClass: "v-color-picker__canvas-dot",
                    class: {
                      "v-color-picker__canvas-dot--disabled": this.disabled
                    },
                    style: {
                      width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["convertToUnit"])(this.dotSize),
                      height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["convertToUnit"])(this.dotSize),
                      transform: "translate(" + x2 + ", " + y + ")"
                    }
                  });
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-color-picker__canvas",
                  style: {
                    width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["convertToUnit"])(this.width),
                    height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["convertToUnit"])(this.height)
                  },
                  on: {
                    click: this.handleClick,
                    mousedown: this.handleMouseDown
                  }
                }, [this.genCanvas(), this.genDot()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VColorPicker/VColorPickerEdit.sass": (
          /*!***********************************************************!*\
            !*** ./src/components/VColorPicker/VColorPickerEdit.sass ***!
            \***********************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VColorPicker/VColorPickerEdit.ts": (
          /*!*********************************************************!*\
            !*** ./src/components/VColorPicker/VColorPickerEdit.ts ***!
            \*********************************************************/
          /*! exports provided: modes, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "modes", function() {
              return modes;
            });
            __webpack_require__(
              /*! ./VColorPickerEdit.sass */
              "./src/components/VColorPicker/VColorPickerEdit.sass"
            );
            var _VBtn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VBtn */
              "./src/components/VBtn/index.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _util_colorUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/colorUtils */
              "./src/util/colorUtils.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_4___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_4__);
            var _util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./util */
              "./src/components/VColorPicker/util/index.ts"
            );
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var modes = {
              rgba: {
                inputs: [["r", 255, "int"], ["g", 255, "int"], ["b", 255, "int"], ["a", 1, "float"]],
                from: _util__WEBPACK_IMPORTED_MODULE_5__["fromRGBA"]
              },
              hsla: {
                inputs: [["h", 360, "int"], ["s", 1, "float"], ["l", 1, "float"], ["a", 1, "float"]],
                from: _util__WEBPACK_IMPORTED_MODULE_5__["fromHSLA"]
              },
              hexa: {
                from: _util__WEBPACK_IMPORTED_MODULE_5__["fromHexa"]
              }
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_4___default.a.extend({
              name: "v-color-picker-edit",
              props: {
                color: Object,
                disabled: Boolean,
                hideAlpha: Boolean,
                hideModeSwitch: Boolean,
                mode: {
                  type: String,
                  default: "rgba",
                  validator: function validator2(v) {
                    return Object.keys(modes).includes(v);
                  }
                }
              },
              data: function data() {
                return {
                  modes,
                  internalMode: this.mode
                };
              },
              computed: {
                currentMode: function currentMode() {
                  return this.modes[this.internalMode];
                }
              },
              watch: {
                mode: function mode(_mode) {
                  this.internalMode = _mode;
                }
              },
              created: function created2() {
                this.internalMode = this.mode;
              },
              methods: {
                getValue: function getValue2(v, type) {
                  if (type === "float")
                    return Math.round(v * 100) / 100;
                  else if (type === "int")
                    return Math.round(v);
                  else
                    return 0;
                },
                parseValue: function parseValue2(v, type) {
                  if (type === "float")
                    return parseFloat(v);
                  else if (type === "int")
                    return parseInt(v, 10) || 0;
                  else
                    return 0;
                },
                changeMode: function changeMode() {
                  var modes2 = Object.keys(this.modes);
                  var index2 = modes2.indexOf(this.internalMode);
                  var newMode = modes2[(index2 + 1) % modes2.length];
                  this.internalMode = newMode;
                  this.$emit("update:mode", newMode);
                },
                genInput: function genInput(target2, attrs2, value, on2) {
                  return this.$createElement("div", {
                    staticClass: "v-color-picker__input"
                  }, [this.$createElement("input", {
                    key: target2,
                    attrs: attrs2,
                    domProps: {
                      value
                    },
                    on: on2
                  }), this.$createElement("span", target2.toUpperCase())]);
                },
                genInputs: function genInputs() {
                  var _this2 = this;
                  if (this.internalMode === "hexa") {
                    var hex = this.color.hexa;
                    var value = this.hideAlpha && hex.endsWith("FF") ? hex.substr(0, 7) : hex;
                    return this.genInput("hex", {
                      maxlength: this.hideAlpha ? 7 : 9,
                      disabled: this.disabled
                    }, value, {
                      change: function change(e) {
                        var el = e.target;
                        _this2.$emit("update:color", _this2.currentMode.from(Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_3__["parseHex"])(el.value)));
                      }
                    });
                  } else {
                    var inputs = this.hideAlpha ? this.currentMode.inputs.slice(0, -1) : this.currentMode.inputs;
                    return inputs.map(function(_a2) {
                      var _b2 = __read2(_a2, 3), target2 = _b2[0], max2 = _b2[1], type = _b2[2];
                      var value2 = _this2.color[_this2.internalMode];
                      return _this2.genInput(target2, {
                        type: "number",
                        min: 0,
                        max: max2,
                        step: type === "float" ? "0.01" : type === "int" ? "1" : void 0,
                        disabled: _this2.disabled
                      }, _this2.getValue(value2[target2], type), {
                        input: function input2(e) {
                          var _a3;
                          var el = e.target;
                          var newVal = _this2.parseValue(el.value || "0", type);
                          _this2.$emit("update:color", _this2.currentMode.from(Object.assign({}, value2, (_a3 = {}, _a3[target2] = newVal, _a3)), _this2.color.alpha));
                        }
                      });
                    });
                  }
                },
                genSwitch: function genSwitch() {
                  return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: {
                      small: true,
                      icon: true,
                      disabled: this.disabled
                    },
                    on: {
                      click: this.changeMode
                    }
                  }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], "$unfold")]);
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-color-picker__edit"
                }, [this.genInputs(), !this.hideModeSwitch && this.genSwitch()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VColorPicker/VColorPickerPreview.sass": (
          /*!**************************************************************!*\
            !*** ./src/components/VColorPicker/VColorPickerPreview.sass ***!
            \**************************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VColorPicker/VColorPickerPreview.ts": (
          /*!************************************************************!*\
            !*** ./src/components/VColorPicker/VColorPickerPreview.ts ***!
            \************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VColorPickerPreview.sass */
              "./src/components/VColorPicker/VColorPickerPreview.sass"
            );
            var _VSlider_VSlider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSlider/VSlider */
              "./src/components/VSlider/VSlider.ts"
            );
            var _util_colorUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/colorUtils */
              "./src/util/colorUtils.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_3___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_3__);
            var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./util */
              "./src/components/VColorPicker/util/index.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_3___default.a.extend({
              name: "v-color-picker-preview",
              props: {
                color: Object,
                disabled: Boolean,
                hideAlpha: Boolean
              },
              methods: {
                genAlpha: function genAlpha() {
                  var _this2 = this;
                  return this.genTrack({
                    staticClass: "v-color-picker__alpha",
                    props: {
                      thumbColor: "grey lighten-2",
                      hideDetails: true,
                      value: this.color.alpha,
                      step: 0,
                      min: 0,
                      max: 1
                    },
                    style: {
                      backgroundImage: this.disabled ? void 0 : "linear-gradient(to " + (this.$vuetify.rtl ? "left" : "right") + ", transparent, " + Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_2__["RGBtoCSS"])(this.color.rgba) + ")"
                    },
                    on: {
                      input: function input2(val) {
                        return _this2.color.alpha !== val && _this2.$emit("update:color", Object(_util__WEBPACK_IMPORTED_MODULE_4__["fromHSVA"])(__assign2(__assign2({}, _this2.color.hsva), {
                          a: val
                        })));
                      }
                    }
                  });
                },
                genSliders: function genSliders() {
                  return this.$createElement("div", {
                    staticClass: "v-color-picker__sliders"
                  }, [this.genHue(), !this.hideAlpha && this.genAlpha()]);
                },
                genDot: function genDot() {
                  return this.$createElement("div", {
                    staticClass: "v-color-picker__dot"
                  }, [this.$createElement("div", {
                    style: {
                      background: Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_2__["RGBAtoCSS"])(this.color.rgba)
                    }
                  })]);
                },
                genHue: function genHue() {
                  var _this2 = this;
                  return this.genTrack({
                    staticClass: "v-color-picker__hue",
                    props: {
                      thumbColor: "grey lighten-2",
                      hideDetails: true,
                      value: this.color.hue,
                      step: 0,
                      min: 0,
                      max: 360
                    },
                    on: {
                      input: function input2(val) {
                        return _this2.color.hue !== val && _this2.$emit("update:color", Object(_util__WEBPACK_IMPORTED_MODULE_4__["fromHSVA"])(__assign2(__assign2({}, _this2.color.hsva), {
                          h: val
                        })));
                      }
                    }
                  });
                },
                genTrack: function genTrack(options) {
                  return this.$createElement(_VSlider_VSlider__WEBPACK_IMPORTED_MODULE_1__["default"], __assign2(__assign2({
                    class: "v-color-picker__track"
                  }, options), {
                    props: __assign2({
                      disabled: this.disabled
                    }, options.props)
                  }));
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-color-picker__preview",
                  class: {
                    "v-color-picker__preview--hide-alpha": this.hideAlpha
                  }
                }, [this.genDot(), this.genSliders()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VColorPicker/VColorPickerSwatches.sass": (
          /*!***************************************************************!*\
            !*** ./src/components/VColorPicker/VColorPickerSwatches.sass ***!
            \***************************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VColorPicker/VColorPickerSwatches.ts": (
          /*!*************************************************************!*\
            !*** ./src/components/VColorPicker/VColorPickerSwatches.ts ***!
            \*************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VColorPickerSwatches.sass */
              "./src/components/VColorPicker/VColorPickerSwatches.sass"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _util_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/colors */
              "./src/util/colors.ts"
            );
            var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./util */
              "./src/components/VColorPicker/util/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_colorUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/colorUtils */
              "./src/util/colorUtils.ts"
            );
            function parseDefaultColors(colors) {
              return Object.keys(colors).map(function(key) {
                var color2 = colors[key];
                return color2.base ? [color2.base, color2.darken4, color2.darken3, color2.darken2, color2.darken1, color2.lighten1, color2.lighten2, color2.lighten3, color2.lighten4, color2.lighten5] : [color2.black, color2.white, color2.transparent];
              });
            }
            var white = Object(_util__WEBPACK_IMPORTED_MODULE_3__["fromHex"])("#FFFFFF").rgba;
            var black = Object(_util__WEBPACK_IMPORTED_MODULE_3__["fromHex"])("#000000").rgba;
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_6__["default"]).extend({
              name: "v-color-picker-swatches",
              props: {
                swatches: {
                  type: Array,
                  default: function _default() {
                    return parseDefaultColors(_util_colors__WEBPACK_IMPORTED_MODULE_2__["default"]);
                  }
                },
                disabled: Boolean,
                color: Object,
                maxWidth: [Number, String],
                maxHeight: [Number, String]
              },
              methods: {
                genColor: function genColor(color2) {
                  var _this2 = this;
                  var content = this.$createElement("div", {
                    style: {
                      background: color2
                    }
                  }, [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["deepEqual"])(this.color, Object(_util__WEBPACK_IMPORTED_MODULE_3__["parseColor"])(color2, null)) && this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: {
                      small: true,
                      dark: Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_7__["contrastRatio"])(this.color.rgba, white) > 2 && this.color.alpha > 0.5,
                      light: Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_7__["contrastRatio"])(this.color.rgba, black) > 2 && this.color.alpha > 0.5
                    }
                  }, "$success")]);
                  return this.$createElement("div", {
                    staticClass: "v-color-picker__color",
                    on: {
                      // TODO: Less hacky way of catching transparent
                      click: function click2() {
                        return _this2.disabled || _this2.$emit("update:color", Object(_util__WEBPACK_IMPORTED_MODULE_3__["fromHex"])(color2 === "transparent" ? "#00000000" : color2));
                      }
                    }
                  }, [content]);
                },
                genSwatches: function genSwatches() {
                  var _this2 = this;
                  return this.swatches.map(function(swatch) {
                    var colors = swatch.map(_this2.genColor);
                    return _this2.$createElement("div", {
                      staticClass: "v-color-picker__swatch"
                    }, colors);
                  });
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-color-picker__swatches",
                  style: {
                    maxWidth: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.maxWidth),
                    maxHeight: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.maxHeight)
                  }
                }, [this.$createElement("div", this.genSwatches())]);
              }
            });
          }
        ),
        /***/
        "./src/components/VColorPicker/index.ts": (
          /*!**********************************************!*\
            !*** ./src/components/VColorPicker/index.ts ***!
            \**********************************************/
          /*! exports provided: VColorPicker, VColorPickerSwatches, VColorPickerCanvas, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VColorPicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VColorPicker */
              "./src/components/VColorPicker/VColorPicker.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VColorPicker", function() {
              return _VColorPicker__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VColorPickerSwatches__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VColorPickerSwatches */
              "./src/components/VColorPicker/VColorPickerSwatches.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VColorPickerSwatches", function() {
              return _VColorPickerSwatches__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _VColorPickerCanvas__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VColorPickerCanvas */
              "./src/components/VColorPicker/VColorPickerCanvas.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VColorPickerCanvas", function() {
              return _VColorPickerCanvas__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            __webpack_exports__["default"] = _VColorPicker__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VColorPicker/util/index.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VColorPicker/util/index.ts ***!
            \***************************************************/
          /*! exports provided: fromHSVA, fromHSLA, fromRGBA, fromHexa, fromHex, parseColor, extractColor, hasAlpha */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "fromHSVA", function() {
              return fromHSVA;
            });
            __webpack_require__.d(__webpack_exports__, "fromHSLA", function() {
              return fromHSLA;
            });
            __webpack_require__.d(__webpack_exports__, "fromRGBA", function() {
              return fromRGBA;
            });
            __webpack_require__.d(__webpack_exports__, "fromHexa", function() {
              return fromHexa;
            });
            __webpack_require__.d(__webpack_exports__, "fromHex", function() {
              return fromHex;
            });
            __webpack_require__.d(__webpack_exports__, "parseColor", function() {
              return parseColor;
            });
            __webpack_require__.d(__webpack_exports__, "extractColor", function() {
              return extractColor;
            });
            __webpack_require__.d(__webpack_exports__, "hasAlpha", function() {
              return hasAlpha;
            });
            var _util_colorUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../../util/colorUtils */
              "./src/util/colorUtils.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __rest = function(s2, e) {
              var t3 = {};
              for (var p in s2) {
                if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
                  t3[p] = s2[p];
              }
              if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
                for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
                  if (e.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
                    t3[p[i2]] = s2[p[i2]];
                }
              return t3;
            };
            function fromHSVA(hsva) {
              hsva = __assign2({}, hsva);
              var hexa = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["HSVAtoHex"])(hsva);
              var hsla = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["HSVAtoHSLA"])(hsva);
              var rgba = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["HSVAtoRGBA"])(hsva);
              return {
                alpha: hsva.a,
                hex: hexa.substr(0, 7),
                hexa,
                hsla,
                hsva,
                hue: hsva.h,
                rgba
              };
            }
            function fromHSLA(hsla) {
              var hsva = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["HSLAtoHSVA"])(hsla);
              var hexa = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["HSVAtoHex"])(hsva);
              var rgba = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["HSVAtoRGBA"])(hsva);
              return {
                alpha: hsva.a,
                hex: hexa.substr(0, 7),
                hexa,
                hsla,
                hsva,
                hue: hsva.h,
                rgba
              };
            }
            function fromRGBA(rgba) {
              var hsva = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["RGBAtoHSVA"])(rgba);
              var hexa = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["RGBAtoHex"])(rgba);
              var hsla = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["HSVAtoHSLA"])(hsva);
              return {
                alpha: hsva.a,
                hex: hexa.substr(0, 7),
                hexa,
                hsla,
                hsva,
                hue: hsva.h,
                rgba
              };
            }
            function fromHexa(hexa) {
              var hsva = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["HexToHSVA"])(hexa);
              var hsla = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["HSVAtoHSLA"])(hsva);
              var rgba = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["HSVAtoRGBA"])(hsva);
              return {
                alpha: hsva.a,
                hex: hexa.substr(0, 7),
                hexa,
                hsla,
                hsva,
                hue: hsva.h,
                rgba
              };
            }
            function fromHex(hex) {
              return fromHexa(Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["parseHex"])(hex));
            }
            function has2(obj, key) {
              return key.every(function(k) {
                return obj.hasOwnProperty(k);
              });
            }
            function parseColor(color2, oldColor) {
              if (!color2)
                return fromRGBA({
                  r: 255,
                  g: 0,
                  b: 0,
                  a: 1
                });
              if (typeof color2 === "string") {
                if (color2 === "transparent")
                  return fromHexa("#00000000");
                var hex = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_0__["parseHex"])(color2);
                if (oldColor && hex === oldColor.hexa)
                  return oldColor;
                else
                  return fromHexa(hex);
              }
              if (_typeof2(color2) === "object") {
                if (color2.hasOwnProperty("alpha"))
                  return color2;
                var a = color2.hasOwnProperty("a") ? parseFloat(color2.a) : 1;
                if (has2(color2, ["r", "g", "b"])) {
                  if (oldColor && color2 === oldColor.rgba)
                    return oldColor;
                  else
                    return fromRGBA(__assign2(__assign2({}, color2), {
                      a
                    }));
                } else if (has2(color2, ["h", "s", "l"])) {
                  if (oldColor && color2 === oldColor.hsla)
                    return oldColor;
                  else
                    return fromHSLA(__assign2(__assign2({}, color2), {
                      a
                    }));
                } else if (has2(color2, ["h", "s", "v"])) {
                  if (oldColor && color2 === oldColor.hsva)
                    return oldColor;
                  else
                    return fromHSVA(__assign2(__assign2({}, color2), {
                      a
                    }));
                }
              }
              return fromRGBA({
                r: 255,
                g: 0,
                b: 0,
                a: 1
              });
            }
            function stripAlpha(color2, stripAlpha2) {
              if (stripAlpha2) {
                color2.a;
                var rest = __rest(color2, ["a"]);
                return rest;
              }
              return color2;
            }
            function extractColor(color2, input2) {
              if (input2 == null)
                return color2;
              if (typeof input2 === "string") {
                return input2.length === 7 ? color2.hex : color2.hexa;
              }
              if (_typeof2(input2) === "object") {
                var shouldStrip = typeof input2.a === "number" && input2.a === 0 ? !!input2.a : !input2.a;
                if (has2(input2, ["r", "g", "b"]))
                  return stripAlpha(color2.rgba, shouldStrip);
                else if (has2(input2, ["h", "s", "l"]))
                  return stripAlpha(color2.hsla, shouldStrip);
                else if (has2(input2, ["h", "s", "v"]))
                  return stripAlpha(color2.hsva, shouldStrip);
              }
              return color2;
            }
            function hasAlpha(color2) {
              if (!color2)
                return false;
              if (typeof color2 === "string") {
                return color2.length > 7;
              }
              if (_typeof2(color2) === "object") {
                return has2(color2, ["a"]) || has2(color2, ["alpha"]);
              }
              return false;
            }
          }
        ),
        /***/
        "./src/components/VCombobox/VCombobox.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VCombobox/VCombobox.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ../VAutocomplete/VAutocomplete.sass */
              "./src/components/VAutocomplete/VAutocomplete.sass"
            );
            var _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSelect/VSelect */
              "./src/components/VSelect/VSelect.ts"
            );
            var _VAutocomplete_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VAutocomplete/VAutocomplete */
              "./src/components/VAutocomplete/VAutocomplete.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = _VAutocomplete_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].extend({
              name: "v-combobox",
              props: {
                delimiters: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                returnObject: {
                  type: Boolean,
                  default: true
                }
              },
              data: function data() {
                return {
                  editingIndex: -1
                };
              },
              computed: {
                computedCounterValue: function computedCounterValue() {
                  return this.multiple ? this.selectedItems.length : (this.internalSearch || "").toString().length;
                },
                hasSlot: function hasSlot() {
                  return _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.hasSlot.call(this) || this.multiple;
                },
                isAnyValueAllowed: function isAnyValueAllowed() {
                  return true;
                },
                menuCanShow: function menuCanShow() {
                  if (!this.isFocused)
                    return false;
                  return this.hasDisplayedItems || !!this.$slots["no-data"] && !this.hideNoData;
                },
                searchIsDirty: function searchIsDirty() {
                  return this.internalSearch != null;
                }
              },
              methods: {
                onInternalSearchChanged: function onInternalSearchChanged(val) {
                  if (val && this.multiple && this.delimiters.length) {
                    var delimiter = this.delimiters.find(function(d2) {
                      return val.endsWith(d2);
                    });
                    if (delimiter != null) {
                      this.internalSearch = val.slice(0, val.length - delimiter.length);
                      this.updateTags();
                    }
                  }
                  this.updateMenuDimensions();
                },
                genInput: function genInput() {
                  var input2 = _VAutocomplete_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genInput.call(this);
                  delete input2.data.attrs.name;
                  input2.data.on.paste = this.onPaste;
                  return input2;
                },
                genChipSelection: function genChipSelection(item, index2) {
                  var _this2 = this;
                  var chip = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genChipSelection.call(this, item, index2);
                  if (this.multiple) {
                    chip.componentOptions.listeners = __assign2(__assign2({}, chip.componentOptions.listeners), {
                      dblclick: function dblclick() {
                        _this2.editingIndex = index2;
                        _this2.internalSearch = _this2.getText(item);
                        _this2.selectedIndex = -1;
                      }
                    });
                  }
                  return chip;
                },
                onChipInput: function onChipInput(item) {
                  _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onChipInput.call(this, item);
                  this.editingIndex = -1;
                },
                // Requires a manual definition
                // to overwrite removal in v-autocomplete
                onEnterDown: function onEnterDown(e) {
                  e.preventDefault();
                  if (this.getMenuIndex() > -1)
                    return;
                  this.$nextTick(this.updateSelf);
                },
                onKeyDown: function onKeyDown(e) {
                  var keyCode = e.keyCode;
                  if (e.ctrlKey || ![_util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].home, _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].end].includes(keyCode)) {
                    _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onKeyDown.call(this, e);
                  }
                  if (this.multiple && keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].left && this.$refs.input.selectionStart === 0) {
                    this.updateSelf();
                  } else if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].enter) {
                    this.onEnterDown(e);
                  }
                  this.changeSelectedIndex(keyCode);
                },
                onTabDown: function onTabDown(e) {
                  if (this.multiple && this.internalSearch && this.getMenuIndex() === -1) {
                    e.preventDefault();
                    e.stopPropagation();
                    return this.updateTags();
                  }
                  _VAutocomplete_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.onTabDown.call(this, e);
                },
                selectItem: function selectItem(item) {
                  if (this.editingIndex > -1) {
                    this.updateEditing();
                  } else {
                    _VAutocomplete_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.selectItem.call(this, item);
                    if (this.internalSearch && this.multiple && this.getText(item).toLocaleLowerCase().includes(this.internalSearch.toLocaleLowerCase())) {
                      this.internalSearch = null;
                    }
                  }
                },
                setSelectedItems: function setSelectedItems() {
                  if (this.internalValue == null || this.internalValue === "") {
                    this.selectedItems = [];
                  } else {
                    this.selectedItems = this.multiple ? this.internalValue : [this.internalValue];
                  }
                },
                setValue: function setValue(value) {
                  _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.setValue.call(this, value === void 0 ? this.internalSearch : value);
                },
                updateEditing: function updateEditing() {
                  var _this2 = this;
                  var value = this.internalValue.slice();
                  var index2 = this.selectedItems.findIndex(function(item2) {
                    return _this2.getText(item2) === _this2.internalSearch;
                  });
                  if (index2 > -1) {
                    var item = _typeof2(value[index2]) === "object" ? Object.assign({}, value[index2]) : value[index2];
                    value.splice(index2, 1);
                    value.push(item);
                  } else {
                    value[this.editingIndex] = this.internalSearch;
                  }
                  this.setValue(value);
                  this.editingIndex = -1;
                  this.internalSearch = null;
                },
                updateCombobox: function updateCombobox() {
                  if (!this.searchIsDirty)
                    return;
                  if (this.internalSearch !== this.getText(this.internalValue))
                    this.setValue();
                  var isUsingSlot = Boolean(this.$scopedSlots.selection) || this.hasChips;
                  if (isUsingSlot)
                    this.internalSearch = null;
                },
                updateSelf: function updateSelf() {
                  this.multiple ? this.updateTags() : this.updateCombobox();
                },
                updateTags: function updateTags() {
                  var _this2 = this;
                  var menuIndex = this.getMenuIndex();
                  if (menuIndex < 0 && !this.searchIsDirty || !this.internalSearch)
                    return;
                  if (this.editingIndex > -1) {
                    return this.updateEditing();
                  }
                  var index2 = this.selectedItems.findIndex(function(item) {
                    return _this2.internalSearch === _this2.getText(item);
                  });
                  var itemToSelect = index2 > -1 && _typeof2(this.selectedItems[index2]) === "object" ? Object.assign({}, this.selectedItems[index2]) : this.internalSearch;
                  if (index2 > -1) {
                    var internalValue = this.internalValue.slice();
                    internalValue.splice(index2, 1);
                    this.setValue(internalValue);
                  }
                  if (menuIndex > -1)
                    return this.internalSearch = null;
                  this.selectItem(itemToSelect);
                  this.internalSearch = null;
                },
                onPaste: function onPaste(event) {
                  var _a2;
                  this.$emit("paste", event);
                  if (!this.multiple || this.searchIsDirty)
                    return;
                  var pastedItemText = (_a2 = event.clipboardData) === null || _a2 === void 0 ? void 0 : _a2.getData("text/vnd.vuetify.autocomplete.item+plain");
                  if (pastedItemText && this.findExistingIndex(pastedItemText) === -1) {
                    event.preventDefault();
                    _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.selectItem.call(this, pastedItemText);
                  }
                },
                clearableCallback: function clearableCallback() {
                  this.editingIndex = -1;
                  _VAutocomplete_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.clearableCallback.call(this);
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VCombobox/index.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VCombobox/index.ts ***!
            \*******************************************/
          /*! exports provided: VCombobox, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VCombobox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VCombobox */
              "./src/components/VCombobox/VCombobox.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCombobox", function() {
              return _VCombobox__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VCombobox__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VContent/VContent.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VContent/VContent.ts ***!
            \*********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VMain_VMain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../VMain/VMain */
              "./src/components/VMain/VMain.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            __webpack_exports__["default"] = _VMain_VMain__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
              name: "v-main",
              created: function created2() {
                Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["deprecate"])("v-content", "v-main", this);
              },
              render: function render8(h) {
                var node2 = _VMain_VMain__WEBPACK_IMPORTED_MODULE_0__["default"].options.render.call(this, h);
                node2.data.staticClass += " v-content";
                node2.children[0].data.staticClass += " v-content__wrap";
                return h(node2.tag, node2.data, node2.children);
              }
            });
          }
        ),
        /***/
        "./src/components/VContent/index.ts": (
          /*!******************************************!*\
            !*** ./src/components/VContent/index.ts ***!
            \******************************************/
          /*! exports provided: VContent, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VContent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VContent */
              "./src/components/VContent/VContent.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VContent", function() {
              return _VContent__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VContent__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VCounter/VCounter.sass": (
          /*!***********************************************!*\
            !*** ./src/components/VCounter/VCounter.sass ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VCounter/VCounter.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VCounter/VCounter.ts ***!
            \*********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VCounter.sass */
              "./src/components/VCounter/VCounter.sass"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
              name: "v-counter",
              functional: true,
              props: {
                value: {
                  type: [Number, String],
                  default: ""
                },
                max: [Number, String]
              },
              render: function render8(h, ctx) {
                var props2 = ctx.props;
                var max2 = parseInt(props2.max, 10);
                var value = parseInt(props2.value, 10);
                var content = max2 ? value + " / " + max2 : String(props2.value);
                var isGreater = max2 && value > max2;
                return h("div", {
                  staticClass: "v-counter",
                  class: __assign2({
                    "error--text": isGreater
                  }, Object(_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["functionalThemeClasses"])(ctx))
                }, content);
              }
            });
          }
        ),
        /***/
        "./src/components/VCounter/index.ts": (
          /*!******************************************!*\
            !*** ./src/components/VCounter/index.ts ***!
            \******************************************/
          /*! exports provided: VCounter, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VCounter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VCounter */
              "./src/components/VCounter/VCounter.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCounter", function() {
              return _VCounter__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VCounter__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VData/VData.ts": (
          /*!***************************************!*\
            !*** ./src/components/VData/VData.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
              name: "v-data",
              inheritAttrs: false,
              props: {
                items: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                options: {
                  type: Object,
                  default: function _default() {
                    return {};
                  }
                },
                sortBy: {
                  type: [String, Array]
                },
                sortDesc: {
                  type: [Boolean, Array]
                },
                customSort: {
                  type: Function,
                  default: _util_helpers__WEBPACK_IMPORTED_MODULE_0__["sortItems"]
                },
                mustSort: Boolean,
                multiSort: Boolean,
                page: {
                  type: Number,
                  default: 1
                },
                itemsPerPage: {
                  type: Number,
                  default: 10
                },
                groupBy: {
                  type: [String, Array],
                  default: function _default() {
                    return [];
                  }
                },
                groupDesc: {
                  type: [Boolean, Array],
                  default: function _default() {
                    return [];
                  }
                },
                customGroup: {
                  type: Function,
                  default: _util_helpers__WEBPACK_IMPORTED_MODULE_0__["groupItems"]
                },
                locale: {
                  type: String,
                  default: "en-US"
                },
                disableSort: Boolean,
                disablePagination: Boolean,
                disableFiltering: Boolean,
                search: String,
                customFilter: {
                  type: Function,
                  default: _util_helpers__WEBPACK_IMPORTED_MODULE_0__["searchItems"]
                },
                serverItemsLength: {
                  type: Number,
                  default: -1
                }
              },
              data: function data() {
                var _a2, _b2;
                var internalOptions = {
                  page: this.page,
                  itemsPerPage: this.itemsPerPage,
                  sortBy: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["wrapInArray"])(this.sortBy),
                  sortDesc: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["wrapInArray"])(this.sortDesc),
                  groupBy: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["wrapInArray"])(this.groupBy),
                  groupDesc: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["wrapInArray"])(this.groupDesc),
                  mustSort: this.mustSort,
                  multiSort: this.multiSort
                };
                if (this.options) {
                  internalOptions = Object.assign(internalOptions, this.options);
                }
                var sortBy = internalOptions.sortBy, sortDesc = internalOptions.sortDesc, groupBy = internalOptions.groupBy, groupDesc = internalOptions.groupDesc;
                var sortDiff = sortBy.length - sortDesc.length;
                var groupDiff = groupBy.length - groupDesc.length;
                if (sortDiff > 0) {
                  (_a2 = internalOptions.sortDesc).push.apply(_a2, __spreadArray2([], __read2(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["fillArray"])(sortDiff, false)), false));
                }
                if (groupDiff > 0) {
                  (_b2 = internalOptions.groupDesc).push.apply(_b2, __spreadArray2([], __read2(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["fillArray"])(groupDiff, false)), false));
                }
                return {
                  internalOptions
                };
              },
              computed: {
                itemsLength: function itemsLength() {
                  return this.serverItemsLength >= 0 ? this.serverItemsLength : this.filteredItems.length;
                },
                pageCount: function pageCount() {
                  return this.internalOptions.itemsPerPage <= 0 ? 1 : Math.ceil(this.itemsLength / this.internalOptions.itemsPerPage);
                },
                pageStart: function pageStart() {
                  if (this.internalOptions.itemsPerPage === -1 || !this.items.length)
                    return 0;
                  return (this.internalOptions.page - 1) * this.internalOptions.itemsPerPage;
                },
                pageStop: function pageStop() {
                  if (this.internalOptions.itemsPerPage === -1)
                    return this.itemsLength;
                  if (!this.items.length)
                    return 0;
                  return Math.min(this.itemsLength, this.internalOptions.page * this.internalOptions.itemsPerPage);
                },
                isGrouped: function isGrouped() {
                  return !!this.internalOptions.groupBy.length;
                },
                pagination: function pagination() {
                  return {
                    page: this.internalOptions.page,
                    itemsPerPage: this.internalOptions.itemsPerPage,
                    pageStart: this.pageStart,
                    pageStop: this.pageStop,
                    pageCount: this.pageCount,
                    itemsLength: this.itemsLength
                  };
                },
                filteredItems: function filteredItems() {
                  var items = this.items.slice();
                  if (!this.disableFiltering && this.serverItemsLength <= 0) {
                    items = this.customFilter(items, this.search);
                  }
                  return items;
                },
                computedItems: function computedItems() {
                  var items = this.filteredItems.slice();
                  if ((!this.disableSort || this.internalOptions.groupBy.length) && this.serverItemsLength <= 0) {
                    items = this.sortItems(items);
                  }
                  if (!this.disablePagination && this.serverItemsLength <= 0) {
                    items = this.paginateItems(items);
                  }
                  return items;
                },
                groupedItems: function groupedItems() {
                  return this.isGrouped ? this.groupItems(this.computedItems) : null;
                },
                scopedProps: function scopedProps() {
                  return {
                    sort: this.sort,
                    sortArray: this.sortArray,
                    group: this.group,
                    items: this.computedItems,
                    options: this.internalOptions,
                    updateOptions: this.updateOptions,
                    pagination: this.pagination,
                    groupedItems: this.groupedItems,
                    originalItemsLength: this.items.length
                  };
                },
                computedOptions: function computedOptions() {
                  return __assign2({}, this.options);
                }
              },
              watch: {
                computedOptions: {
                  handler: function handler(options, old) {
                    if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["deepEqual"])(options, old))
                      return;
                    this.updateOptions(options);
                  },
                  deep: true,
                  immediate: true
                },
                internalOptions: {
                  handler: function handler(options, old) {
                    if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["deepEqual"])(options, old))
                      return;
                    this.$emit("update:options", options);
                  },
                  deep: true,
                  immediate: true
                },
                page: function page(_page) {
                  this.updateOptions({
                    page: _page
                  });
                },
                "internalOptions.page": function internalOptionsPage(page) {
                  this.$emit("update:page", page);
                },
                itemsPerPage: function itemsPerPage(_itemsPerPage) {
                  this.updateOptions({
                    itemsPerPage: _itemsPerPage
                  });
                },
                "internalOptions.itemsPerPage": function internalOptionsItemsPerPage(itemsPerPage) {
                  this.$emit("update:items-per-page", itemsPerPage);
                },
                sortBy: function sortBy(_sortBy) {
                  this.updateOptions({
                    sortBy: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["wrapInArray"])(_sortBy)
                  });
                },
                "internalOptions.sortBy": function internalOptionsSortBy(sortBy, old) {
                  !Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["deepEqual"])(sortBy, old) && this.$emit("update:sort-by", Array.isArray(this.sortBy) ? sortBy : sortBy[0]);
                },
                sortDesc: function sortDesc(_sortDesc) {
                  this.updateOptions({
                    sortDesc: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["wrapInArray"])(_sortDesc)
                  });
                },
                "internalOptions.sortDesc": function internalOptionsSortDesc(sortDesc, old) {
                  !Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["deepEqual"])(sortDesc, old) && this.$emit("update:sort-desc", Array.isArray(this.sortDesc) ? sortDesc : sortDesc[0]);
                },
                groupBy: function groupBy(_groupBy) {
                  this.updateOptions({
                    groupBy: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["wrapInArray"])(_groupBy)
                  });
                },
                "internalOptions.groupBy": function internalOptionsGroupBy(groupBy, old) {
                  !Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["deepEqual"])(groupBy, old) && this.$emit("update:group-by", Array.isArray(this.groupBy) ? groupBy : groupBy[0]);
                },
                groupDesc: function groupDesc(_groupDesc) {
                  this.updateOptions({
                    groupDesc: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["wrapInArray"])(_groupDesc)
                  });
                },
                "internalOptions.groupDesc": function internalOptionsGroupDesc(groupDesc, old) {
                  !Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["deepEqual"])(groupDesc, old) && this.$emit("update:group-desc", Array.isArray(this.groupDesc) ? groupDesc : groupDesc[0]);
                },
                multiSort: function multiSort(_multiSort) {
                  this.updateOptions({
                    multiSort: _multiSort
                  });
                },
                "internalOptions.multiSort": function internalOptionsMultiSort(multiSort) {
                  this.$emit("update:multi-sort", multiSort);
                },
                mustSort: function mustSort(_mustSort) {
                  this.updateOptions({
                    mustSort: _mustSort
                  });
                },
                "internalOptions.mustSort": function internalOptionsMustSort(mustSort) {
                  this.$emit("update:must-sort", mustSort);
                },
                pageCount: {
                  handler: function handler(pageCount) {
                    this.$emit("page-count", pageCount);
                  },
                  immediate: true
                },
                computedItems: {
                  handler: function handler(computedItems) {
                    this.$emit("current-items", computedItems);
                  },
                  immediate: true
                },
                pagination: {
                  handler: function handler(pagination, old) {
                    if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["deepEqual"])(pagination, old))
                      return;
                    this.$emit("pagination", this.pagination);
                  },
                  immediate: true
                }
              },
              methods: {
                toggle: function toggle(key, oldBy, oldDesc, page, mustSort, multiSort) {
                  var by = oldBy.slice();
                  var desc = oldDesc.slice();
                  var byIndex = by.findIndex(function(k) {
                    return k === key;
                  });
                  if (byIndex < 0) {
                    if (!multiSort) {
                      by = [];
                      desc = [];
                    }
                    by.push(key);
                    desc.push(false);
                  } else if (byIndex >= 0 && !desc[byIndex]) {
                    desc[byIndex] = true;
                  } else if (!mustSort) {
                    by.splice(byIndex, 1);
                    desc.splice(byIndex, 1);
                  } else {
                    desc[byIndex] = false;
                  }
                  if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["deepEqual"])(by, oldBy) || !Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["deepEqual"])(desc, oldDesc)) {
                    page = 1;
                  }
                  return {
                    by,
                    desc,
                    page
                  };
                },
                group: function group(key) {
                  var _a2 = this.toggle(key, this.internalOptions.groupBy, this.internalOptions.groupDesc, this.internalOptions.page, true, false), groupBy = _a2.by, groupDesc = _a2.desc, page = _a2.page;
                  this.updateOptions({
                    groupBy,
                    groupDesc,
                    page
                  });
                },
                sort: function sort2(key) {
                  if (Array.isArray(key))
                    return this.sortArray(key);
                  var _a2 = this.toggle(key, this.internalOptions.sortBy, this.internalOptions.sortDesc, this.internalOptions.page, this.internalOptions.mustSort, this.internalOptions.multiSort), sortBy = _a2.by, sortDesc = _a2.desc, page = _a2.page;
                  this.updateOptions({
                    sortBy,
                    sortDesc,
                    page
                  });
                },
                sortArray: function sortArray(sortBy) {
                  var _this2 = this;
                  var sortDesc = sortBy.map(function(s2) {
                    var i2 = _this2.internalOptions.sortBy.findIndex(function(k) {
                      return k === s2;
                    });
                    return i2 > -1 ? _this2.internalOptions.sortDesc[i2] : false;
                  });
                  this.updateOptions({
                    sortBy,
                    sortDesc
                  });
                },
                updateOptions: function updateOptions(options) {
                  this.internalOptions = __assign2(__assign2(__assign2({}, this.internalOptions), options), {
                    page: this.serverItemsLength < 0 ? Math.max(1, Math.min(options.page || this.internalOptions.page, this.pageCount)) : options.page || this.internalOptions.page
                  });
                },
                sortItems: function sortItems(items) {
                  var sortBy = [];
                  var sortDesc = [];
                  if (!this.disableSort) {
                    sortBy = this.internalOptions.sortBy;
                    sortDesc = this.internalOptions.sortDesc;
                  }
                  if (this.internalOptions.groupBy.length) {
                    sortBy = __spreadArray2(__spreadArray2([], __read2(this.internalOptions.groupBy), false), __read2(sortBy), false);
                    sortDesc = __spreadArray2(__spreadArray2([], __read2(this.internalOptions.groupDesc), false), __read2(sortDesc), false);
                  }
                  return this.customSort(items, sortBy, sortDesc, this.locale);
                },
                groupItems: function groupItems(items) {
                  return this.customGroup(items, this.internalOptions.groupBy, this.internalOptions.groupDesc);
                },
                paginateItems: function paginateItems(items) {
                  if (this.serverItemsLength === -1 && items.length <= this.pageStart) {
                    this.internalOptions.page = Math.max(1, Math.ceil(items.length / this.internalOptions.itemsPerPage)) || 1;
                  }
                  return items.slice(this.pageStart, this.pageStop);
                }
              },
              render: function render8() {
                return this.$scopedSlots.default && this.$scopedSlots.default(this.scopedProps);
              }
            });
          }
        ),
        /***/
        "./src/components/VData/index.ts": (
          /*!***************************************!*\
            !*** ./src/components/VData/index.ts ***!
            \***************************************/
          /*! exports provided: VData, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VData */
              "./src/components/VData/VData.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VData", function() {
              return _VData__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VData__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VDataIterator/VDataFooter.sass": (
          /*!*******************************************************!*\
            !*** ./src/components/VDataIterator/VDataFooter.sass ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VDataIterator/VDataFooter.ts": (
          /*!*****************************************************!*\
            !*** ./src/components/VDataIterator/VDataFooter.ts ***!
            \*****************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VDataFooter.sass */
              "./src/components/VDataIterator/VDataFooter.sass"
            );
            var _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSelect/VSelect */
              "./src/components/VSelect/VSelect.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _VBtn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VBtn */
              "./src/components/VBtn/index.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_4___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_4__);
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_4___default.a.extend({
              name: "v-data-footer",
              props: {
                options: {
                  type: Object,
                  required: true
                },
                pagination: {
                  type: Object,
                  required: true
                },
                itemsPerPageOptions: {
                  type: Array,
                  default: function _default() {
                    return [5, 10, 15, -1];
                  }
                },
                prevIcon: {
                  type: String,
                  default: "$prev"
                },
                nextIcon: {
                  type: String,
                  default: "$next"
                },
                firstIcon: {
                  type: String,
                  default: "$first"
                },
                lastIcon: {
                  type: String,
                  default: "$last"
                },
                itemsPerPageText: {
                  type: String,
                  default: "$vuetify.dataFooter.itemsPerPageText"
                },
                itemsPerPageAllText: {
                  type: String,
                  default: "$vuetify.dataFooter.itemsPerPageAll"
                },
                showFirstLastPage: Boolean,
                showCurrentPage: Boolean,
                disablePagination: Boolean,
                disableItemsPerPage: Boolean,
                pageText: {
                  type: String,
                  default: "$vuetify.dataFooter.pageText"
                }
              },
              computed: {
                disableNextPageIcon: function disableNextPageIcon() {
                  return this.options.itemsPerPage <= 0 || this.options.page * this.options.itemsPerPage >= this.pagination.itemsLength || this.pagination.pageStop < 0;
                },
                computedDataItemsPerPageOptions: function computedDataItemsPerPageOptions() {
                  var _this2 = this;
                  return this.itemsPerPageOptions.map(function(option2) {
                    if (_typeof2(option2) === "object")
                      return option2;
                    else
                      return _this2.genDataItemsPerPageOption(option2);
                  });
                }
              },
              methods: {
                updateOptions: function updateOptions(obj) {
                  this.$emit("update:options", Object.assign({}, this.options, obj));
                },
                onFirstPage: function onFirstPage() {
                  this.updateOptions({
                    page: 1
                  });
                },
                onPreviousPage: function onPreviousPage() {
                  this.updateOptions({
                    page: this.options.page - 1
                  });
                },
                onNextPage: function onNextPage() {
                  this.updateOptions({
                    page: this.options.page + 1
                  });
                },
                onLastPage: function onLastPage() {
                  this.updateOptions({
                    page: this.pagination.pageCount
                  });
                },
                onChangeItemsPerPage: function onChangeItemsPerPage(itemsPerPage) {
                  this.updateOptions({
                    itemsPerPage,
                    page: 1
                  });
                },
                genDataItemsPerPageOption: function genDataItemsPerPageOption(option2) {
                  return {
                    text: option2 === -1 ? this.$vuetify.lang.t(this.itemsPerPageAllText) : String(option2),
                    value: option2
                  };
                },
                genItemsPerPageSelect: function genItemsPerPageSelect() {
                  var value = this.options.itemsPerPage;
                  var computedIPPO = this.computedDataItemsPerPageOptions;
                  if (computedIPPO.length <= 1)
                    return null;
                  if (!computedIPPO.find(function(ippo) {
                    return ippo.value === value;
                  }))
                    value = computedIPPO[0];
                  return this.$createElement("div", {
                    staticClass: "v-data-footer__select"
                  }, [this.$vuetify.lang.t(this.itemsPerPageText), this.$createElement(_VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    attrs: {
                      "aria-label": this.$vuetify.lang.t(this.itemsPerPageText)
                    },
                    props: {
                      disabled: this.disableItemsPerPage,
                      items: computedIPPO,
                      value,
                      hideDetails: true,
                      auto: true,
                      minWidth: "75px"
                    },
                    on: {
                      input: this.onChangeItemsPerPage
                    }
                  })]);
                },
                genPaginationInfo: function genPaginationInfo() {
                  var children = ["–"];
                  var itemsLength = this.pagination.itemsLength;
                  var pageStart = this.pagination.pageStart;
                  var pageStop = this.pagination.pageStop;
                  if (this.pagination.itemsLength && this.pagination.itemsPerPage) {
                    pageStart = this.pagination.pageStart + 1;
                    pageStop = itemsLength < this.pagination.pageStop || this.pagination.pageStop < 0 ? itemsLength : this.pagination.pageStop;
                    children = this.$scopedSlots["page-text"] ? [this.$scopedSlots["page-text"]({
                      pageStart,
                      pageStop,
                      itemsLength
                    })] : [this.$vuetify.lang.t(this.pageText, pageStart, pageStop, itemsLength)];
                  } else if (this.$scopedSlots["page-text"]) {
                    children = [this.$scopedSlots["page-text"]({
                      pageStart,
                      pageStop,
                      itemsLength
                    })];
                  }
                  return this.$createElement("div", {
                    class: "v-data-footer__pagination"
                  }, children);
                },
                genIcon: function genIcon(click2, disabled, label, icon) {
                  return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    props: {
                      disabled: disabled || this.disablePagination,
                      icon: true,
                      text: true
                      // dark: this.dark, // TODO: add mixin
                      // light: this.light // TODO: add mixin
                    },
                    on: {
                      click: click2
                    },
                    attrs: {
                      "aria-label": label
                      // TODO: Localization
                    }
                  }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], icon)]);
                },
                genIcons: function genIcons() {
                  var before = [];
                  var after = [];
                  before.push(this.genIcon(this.onPreviousPage, this.options.page === 1, this.$vuetify.lang.t("$vuetify.dataFooter.prevPage"), this.$vuetify.rtl ? this.nextIcon : this.prevIcon));
                  after.push(this.genIcon(this.onNextPage, this.disableNextPageIcon, this.$vuetify.lang.t("$vuetify.dataFooter.nextPage"), this.$vuetify.rtl ? this.prevIcon : this.nextIcon));
                  if (this.showFirstLastPage) {
                    before.unshift(this.genIcon(this.onFirstPage, this.options.page === 1, this.$vuetify.lang.t("$vuetify.dataFooter.firstPage"), this.$vuetify.rtl ? this.lastIcon : this.firstIcon));
                    after.push(this.genIcon(this.onLastPage, this.options.page >= this.pagination.pageCount || this.options.itemsPerPage === -1, this.$vuetify.lang.t("$vuetify.dataFooter.lastPage"), this.$vuetify.rtl ? this.firstIcon : this.lastIcon));
                  }
                  return [this.$createElement("div", {
                    staticClass: "v-data-footer__icons-before"
                  }, before), this.showCurrentPage && this.$createElement("span", [this.options.page.toString()]), this.$createElement("div", {
                    staticClass: "v-data-footer__icons-after"
                  }, after)];
                }
              },
              render: function render8() {
                return this.$createElement("div", {
                  staticClass: "v-data-footer"
                }, [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this, "prepend"), this.genItemsPerPageSelect(), this.genPaginationInfo(), this.genIcons()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VDataIterator/VDataIterator.ts": (
          /*!*******************************************************!*\
            !*** ./src/components/VDataIterator/VDataIterator.ts ***!
            \*******************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../VData */
              "./src/components/VData/index.ts"
            );
            var _VDataFooter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VDataFooter */
              "./src/components/VDataIterator/VDataFooter.ts"
            );
            var _mixins_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/mobile */
              "./src/mixins/mobile/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_mobile__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]).extend({
              name: "v-data-iterator",
              props: __assign2(__assign2({}, _VData__WEBPACK_IMPORTED_MODULE_0__["VData"].options.props), {
                itemKey: {
                  type: String,
                  default: "id"
                },
                value: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                singleSelect: Boolean,
                expanded: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                mobileBreakpoint: __assign2(__assign2({}, _mixins_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].options.props.mobileBreakpoint), {
                  default: 600
                }),
                singleExpand: Boolean,
                loading: [Boolean, String],
                noResultsText: {
                  type: String,
                  default: "$vuetify.dataIterator.noResultsText"
                },
                noDataText: {
                  type: String,
                  default: "$vuetify.noDataText"
                },
                loadingText: {
                  type: String,
                  default: "$vuetify.dataIterator.loadingText"
                },
                hideDefaultFooter: Boolean,
                footerProps: Object,
                selectableKey: {
                  type: String,
                  default: "isSelectable"
                }
              }),
              data: function data() {
                return {
                  selection: {},
                  expansion: {},
                  internalCurrentItems: [],
                  shiftKeyDown: false,
                  lastEntry: -1
                };
              },
              computed: {
                everyItem: function everyItem() {
                  var _this2 = this;
                  return !!this.selectableItems.length && this.selectableItems.every(function(i2) {
                    return _this2.isSelected(i2);
                  });
                },
                someItems: function someItems() {
                  var _this2 = this;
                  return this.selectableItems.some(function(i2) {
                    return _this2.isSelected(i2);
                  });
                },
                sanitizedFooterProps: function sanitizedFooterProps() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["camelizeObjectKeys"])(this.footerProps);
                },
                selectableItems: function selectableItems() {
                  var _this2 = this;
                  return this.internalCurrentItems.filter(function(item) {
                    return _this2.isSelectable(item);
                  });
                }
              },
              watch: {
                value: {
                  handler: function handler(value) {
                    var _this2 = this;
                    this.selection = value.reduce(function(selection, item) {
                      selection[Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(item, _this2.itemKey)] = item;
                      return selection;
                    }, {});
                  },
                  immediate: true
                },
                selection: function selection(value, old) {
                  if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["deepEqual"])(Object.keys(value), Object.keys(old)))
                    return;
                  this.$emit("input", Object.values(value));
                },
                expanded: {
                  handler: function handler(value) {
                    var _this2 = this;
                    this.expansion = value.reduce(function(expansion, item) {
                      expansion[Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(item, _this2.itemKey)] = true;
                      return expansion;
                    }, {});
                  },
                  immediate: true
                },
                expansion: function expansion(value, old) {
                  var _this2 = this;
                  if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["deepEqual"])(value, old))
                    return;
                  var keys2 = Object.keys(value).filter(function(k) {
                    return value[k];
                  });
                  var expanded = !keys2.length ? [] : this.items.filter(function(i2) {
                    return keys2.includes(String(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(i2, _this2.itemKey)));
                  });
                  this.$emit("update:expanded", expanded);
                }
              },
              created: function created2() {
                var _this2 = this;
                var breakingProps = [["disable-initial-sort", "sort-by"], ["filter", "custom-filter"], ["pagination", "options"], ["total-items", "server-items-length"], ["hide-actions", "hide-default-footer"], ["rows-per-page-items", "footer-props.items-per-page-options"], ["rows-per-page-text", "footer-props.items-per-page-text"], ["prev-icon", "footer-props.prev-icon"], ["next-icon", "footer-props.next-icon"]];
                breakingProps.forEach(function(_a2) {
                  var _b2 = __read2(_a2, 2), original = _b2[0], replacement = _b2[1];
                  if (_this2.$attrs.hasOwnProperty(original))
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["breaking"])(original, replacement, _this2);
                });
                var removedProps = ["expand", "content-class", "content-props", "content-tag"];
                removedProps.forEach(function(prop) {
                  if (_this2.$attrs.hasOwnProperty(prop))
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["removed"])(prop);
                });
              },
              mounted: function mounted3() {
                window.addEventListener("keydown", this.onKeyDown);
                window.addEventListener("keyup", this.onKeyUp);
              },
              beforeDestroy: function beforeDestroy2() {
                window.removeEventListener("keydown", this.onKeyDown);
                window.removeEventListener("keyup", this.onKeyUp);
              },
              methods: {
                onKeyDown: function onKeyDown(e) {
                  this.shiftKeyDown = e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_5__["keyCodes"].shift || e.shiftKey;
                },
                onKeyUp: function onKeyUp(e) {
                  if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_5__["keyCodes"].shift || !e.shiftKey) {
                    this.shiftKeyDown = false;
                  }
                },
                toggleSelectAll: function toggleSelectAll(value) {
                  var selection = Object.assign({}, this.selection);
                  for (var i2 = 0; i2 < this.selectableItems.length; i2++) {
                    var item = this.selectableItems[i2];
                    if (!this.isSelectable(item))
                      continue;
                    var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(item, this.itemKey);
                    if (value)
                      selection[key] = item;
                    else
                      delete selection[key];
                  }
                  this.selection = selection;
                  this.$emit("toggle-select-all", {
                    items: this.internalCurrentItems,
                    value
                  });
                },
                isSelectable: function isSelectable(item) {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(item, this.selectableKey) !== false;
                },
                isSelected: function isSelected(item) {
                  return !!this.selection[Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(item, this.itemKey)] || false;
                },
                select: function select(item, value, emit) {
                  var _this2 = this;
                  if (value === void 0) {
                    value = true;
                  }
                  if (emit === void 0) {
                    emit = true;
                  }
                  if (!this.isSelectable(item))
                    return;
                  var selection = this.singleSelect ? {} : Object.assign({}, this.selection);
                  var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(item, this.itemKey);
                  if (value)
                    selection[key] = item;
                  else
                    delete selection[key];
                  var index2 = this.selectableItems.findIndex(function(x2) {
                    return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(x2, _this2.itemKey) === key;
                  });
                  if (this.lastEntry === -1)
                    this.lastEntry = index2;
                  else if (this.shiftKeyDown && !this.singleSelect && emit) {
                    var lastEntryKey = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(this.selectableItems[this.lastEntry], this.itemKey);
                    var lastEntryKeySelected = Object.keys(this.selection).includes(String(lastEntryKey));
                    this.multipleSelect(lastEntryKeySelected, emit, selection, index2);
                  }
                  this.lastEntry = index2;
                  if (this.singleSelect && emit) {
                    var keys2 = Object.keys(this.selection);
                    var old = keys2.length && Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(this.selection[keys2[0]], this.itemKey);
                    old && old !== key && this.$emit("item-selected", {
                      item: this.selection[old],
                      value: false
                    });
                  }
                  this.selection = selection;
                  emit && this.$emit("item-selected", {
                    item,
                    value
                  });
                },
                multipleSelect: function multipleSelect(value, emit, selection, index2) {
                  if (value === void 0) {
                    value = true;
                  }
                  if (emit === void 0) {
                    emit = true;
                  }
                  var start = index2 < this.lastEntry ? index2 : this.lastEntry;
                  var end = index2 < this.lastEntry ? this.lastEntry : index2;
                  for (var i2 = start; i2 <= end; i2++) {
                    var currentItem = this.selectableItems[i2];
                    var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(currentItem, this.itemKey);
                    if (value)
                      selection[key] = currentItem;
                    else
                      delete selection[key];
                    emit && this.$emit("item-selected", {
                      currentItem,
                      value
                    });
                  }
                },
                isExpanded: function isExpanded(item) {
                  return this.expansion[Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(item, this.itemKey)] || false;
                },
                expand: function expand(item, value) {
                  if (value === void 0) {
                    value = true;
                  }
                  var expansion = this.singleExpand ? {} : Object.assign({}, this.expansion);
                  var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(item, this.itemKey);
                  if (value)
                    expansion[key] = true;
                  else
                    delete expansion[key];
                  this.expansion = expansion;
                  this.$emit("item-expanded", {
                    item,
                    value
                  });
                },
                createItemProps: function createItemProps(item, index2) {
                  var _this2 = this;
                  return {
                    item,
                    index: index2,
                    select: function select(v) {
                      return _this2.select(item, v);
                    },
                    isSelected: this.isSelected(item),
                    expand: function expand(v) {
                      return _this2.expand(item, v);
                    },
                    isExpanded: this.isExpanded(item),
                    isMobile: this.isMobile
                  };
                },
                genEmptyWrapper: function genEmptyWrapper(content) {
                  return this.$createElement("div", content);
                },
                genEmpty: function genEmpty(originalItemsLength, filteredItemsLength) {
                  if (originalItemsLength === 0 && this.loading) {
                    var loading = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this, "loading") || this.$vuetify.lang.t(this.loadingText);
                    return this.genEmptyWrapper(loading);
                  } else if (originalItemsLength === 0) {
                    var noData = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this, "noData") || this.$vuetify.lang.t(this.noDataText);
                    return this.genEmptyWrapper(noData);
                  } else if (filteredItemsLength === 0) {
                    var noResults = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this, "noResults") || this.$vuetify.lang.t(this.noResultsText);
                    return this.genEmptyWrapper(noResults);
                  }
                  return null;
                },
                genItems: function genItems(props2) {
                  var _this2 = this;
                  var empty = this.genEmpty(props2.originalItemsLength, props2.pagination.itemsLength);
                  if (empty)
                    return [empty];
                  if (this.$scopedSlots.default) {
                    return this.$scopedSlots.default(__assign2(__assign2({}, props2), {
                      isSelected: this.isSelected,
                      select: this.select,
                      isExpanded: this.isExpanded,
                      isMobile: this.isMobile,
                      expand: this.expand
                    }));
                  }
                  if (this.$scopedSlots.item) {
                    return props2.items.map(function(item, index2) {
                      return _this2.$scopedSlots.item(_this2.createItemProps(item, index2));
                    });
                  }
                  return [];
                },
                genFooter: function genFooter(props2) {
                  if (this.hideDefaultFooter)
                    return null;
                  var data = {
                    props: __assign2(__assign2({}, this.sanitizedFooterProps), {
                      options: props2.options,
                      pagination: props2.pagination
                    }),
                    on: {
                      "update:options": function updateOptions(value) {
                        return props2.updateOptions(value);
                      }
                    }
                  };
                  var scopedSlots = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getPrefixedScopedSlots"])("footer.", this.$scopedSlots);
                  return this.$createElement(_VDataFooter__WEBPACK_IMPORTED_MODULE_1__["default"], __assign2({
                    scopedSlots
                  }, data));
                },
                genDefaultScopedSlot: function genDefaultScopedSlot(props2) {
                  var outerProps = __assign2(__assign2({}, props2), {
                    someItems: this.someItems,
                    everyItem: this.everyItem,
                    toggleSelectAll: this.toggleSelectAll
                  });
                  return this.$createElement("div", {
                    staticClass: "v-data-iterator"
                  }, [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this, "header", outerProps, true), this.genItems(props2), this.genFooter(props2), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this, "footer", outerProps, true)]);
                }
              },
              render: function render8() {
                var _this2 = this;
                return this.$createElement(_VData__WEBPACK_IMPORTED_MODULE_0__["VData"], {
                  props: this.$props,
                  on: {
                    "update:options": function updateOptions(v, old) {
                      return !Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["deepEqual"])(v, old) && _this2.$emit("update:options", v);
                    },
                    "update:page": function updatePage(v) {
                      return _this2.$emit("update:page", v);
                    },
                    "update:items-per-page": function updateItemsPerPage(v) {
                      return _this2.$emit("update:items-per-page", v);
                    },
                    "update:sort-by": function updateSortBy(v) {
                      return _this2.$emit("update:sort-by", v);
                    },
                    "update:sort-desc": function updateSortDesc(v) {
                      return _this2.$emit("update:sort-desc", v);
                    },
                    "update:group-by": function updateGroupBy(v) {
                      return _this2.$emit("update:group-by", v);
                    },
                    "update:group-desc": function updateGroupDesc(v) {
                      return _this2.$emit("update:group-desc", v);
                    },
                    pagination: function pagination(v, old) {
                      return !Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["deepEqual"])(v, old) && _this2.$emit("pagination", v);
                    },
                    "current-items": function currentItems(v) {
                      _this2.internalCurrentItems = v;
                      _this2.$emit("current-items", v);
                    },
                    "page-count": function pageCount(v) {
                      return _this2.$emit("page-count", v);
                    }
                  },
                  scopedSlots: {
                    default: this.genDefaultScopedSlot
                  }
                });
              }
            });
          }
        ),
        /***/
        "./src/components/VDataIterator/index.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VDataIterator/index.ts ***!
            \***********************************************/
          /*! exports provided: VDataIterator, VDataFooter, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VDataIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VDataIterator */
              "./src/components/VDataIterator/VDataIterator.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDataIterator", function() {
              return _VDataIterator__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VDataFooter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VDataFooter */
              "./src/components/VDataIterator/VDataFooter.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDataFooter", function() {
              return _VDataFooter__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VDataIterator: _VDataIterator__WEBPACK_IMPORTED_MODULE_0__["default"],
                VDataFooter: _VDataFooter__WEBPACK_IMPORTED_MODULE_1__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VDataTable/MobileRow.ts": (
          /*!************************************************!*\
            !*** ./src/components/VDataTable/MobileRow.ts ***!
            \************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "row",
              functional: true,
              props: {
                headers: Array,
                hideDefaultHeader: Boolean,
                index: Number,
                item: Object,
                rtl: Boolean
              },
              render: function render8(h, _a2) {
                var props2 = _a2.props, slots = _a2.slots, data = _a2.data;
                var computedSlots = slots();
                var columns = props2.headers.map(function(header) {
                  var classes = {
                    "v-data-table__mobile-row": true
                  };
                  var children = [];
                  var value = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getObjectValueByPath"])(props2.item, header.value);
                  var slotName = header.value;
                  var scopedSlot = data.scopedSlots && data.scopedSlots.hasOwnProperty(slotName) && data.scopedSlots[slotName];
                  var regularSlot = computedSlots.hasOwnProperty(slotName) && computedSlots[slotName];
                  if (scopedSlot) {
                    children.push(scopedSlot({
                      item: props2.item,
                      isMobile: true,
                      header,
                      index: props2.index,
                      value
                    }));
                  } else if (regularSlot) {
                    children.push(regularSlot);
                  } else {
                    children.push(value == null ? value : String(value));
                  }
                  var mobileRowChildren = [h("div", {
                    staticClass: "v-data-table__mobile-row__cell"
                  }, children)];
                  if (header.value !== "dataTableSelect" && !props2.hideDefaultHeader) {
                    mobileRowChildren.unshift(h("div", {
                      staticClass: "v-data-table__mobile-row__header"
                    }, [header.text]));
                  }
                  return h("td", {
                    class: classes
                  }, mobileRowChildren);
                });
                return h("tr", __assign2(__assign2({}, data), {
                  staticClass: "v-data-table__mobile-table-row"
                }), columns);
              }
            });
          }
        ),
        /***/
        "./src/components/VDataTable/Row.ts": (
          /*!******************************************!*\
            !*** ./src/components/VDataTable/Row.ts ***!
            \******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            function needsTd(slot) {
              var _a2;
              return slot.length !== 1 || !["td", "th"].includes((_a2 = slot[0]) === null || _a2 === void 0 ? void 0 : _a2.tag);
            }
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "row",
              functional: true,
              props: {
                headers: Array,
                index: Number,
                item: Object,
                rtl: Boolean
              },
              render: function render8(h, _a2) {
                var props2 = _a2.props, slots = _a2.slots, data = _a2.data;
                var computedSlots = slots();
                var columns = props2.headers.map(function(header) {
                  var children = [];
                  var value = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getObjectValueByPath"])(props2.item, header.value);
                  var slotName = header.value;
                  var scopedSlot = data.scopedSlots && data.scopedSlots.hasOwnProperty(slotName) && data.scopedSlots[slotName];
                  var regularSlot = computedSlots.hasOwnProperty(slotName) && computedSlots[slotName];
                  if (scopedSlot) {
                    children.push.apply(children, __spreadArray2([], __read2(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["wrapInArray"])(scopedSlot({
                      item: props2.item,
                      isMobile: false,
                      header,
                      index: props2.index,
                      value
                    }))), false));
                  } else if (regularSlot) {
                    children.push.apply(children, __spreadArray2([], __read2(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["wrapInArray"])(regularSlot)), false));
                  } else {
                    children.push(value == null ? value : String(value));
                  }
                  var textAlign = "text-" + (header.align || "start");
                  return needsTd(children) ? h("td", {
                    class: [textAlign, header.cellClass, {
                      "v-data-table__divider": header.divider
                    }]
                  }, children) : children;
                });
                return h("tr", data, columns);
              }
            });
          }
        ),
        /***/
        "./src/components/VDataTable/RowGroup.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VDataTable/RowGroup.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "row-group",
              functional: true,
              props: {
                value: {
                  type: Boolean,
                  default: true
                },
                headerClass: {
                  type: String,
                  default: "v-row-group__header"
                },
                contentClass: String,
                summaryClass: {
                  type: String,
                  default: "v-row-group__summary"
                }
              },
              render: function render8(h, _a2) {
                var slots = _a2.slots, props2 = _a2.props;
                var computedSlots = slots();
                var children = [];
                if (computedSlots["column.header"]) {
                  children.push(h("tr", {
                    staticClass: props2.headerClass
                  }, computedSlots["column.header"]));
                } else if (computedSlots["row.header"]) {
                  children.push.apply(children, __spreadArray2([], __read2(computedSlots["row.header"]), false));
                }
                if (computedSlots["row.content"] && props2.value)
                  children.push.apply(children, __spreadArray2([], __read2(computedSlots["row.content"]), false));
                if (computedSlots["column.summary"]) {
                  children.push(h("tr", {
                    staticClass: props2.summaryClass
                  }, computedSlots["column.summary"]));
                } else if (computedSlots["row.summary"]) {
                  children.push.apply(children, __spreadArray2([], __read2(computedSlots["row.summary"]), false));
                }
                return children;
              }
            });
          }
        ),
        /***/
        "./src/components/VDataTable/VDataTable.sass": (
          /*!***************************************************!*\
            !*** ./src/components/VDataTable/VDataTable.sass ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VDataTable/VDataTable.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VDataTable/VDataTable.ts ***!
            \*************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VDataTable.sass */
              "./src/components/VDataTable/VDataTable.sass"
            );
            var _VData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VData */
              "./src/components/VData/index.ts"
            );
            var _VDataIterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VDataIterator */
              "./src/components/VDataIterator/index.ts"
            );
            var _VBtn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VBtn */
              "./src/components/VBtn/index.ts"
            );
            var _VDataTableHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./VDataTableHeader */
              "./src/components/VDataTable/VDataTableHeader.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _Row__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ./Row */
              "./src/components/VDataTable/Row.ts"
            );
            var _RowGroup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ./RowGroup */
              "./src/components/VDataTable/RowGroup.ts"
            );
            var _VCheckbox_VSimpleCheckbox__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../VCheckbox/VSimpleCheckbox */
              "./src/components/VCheckbox/VSimpleCheckbox.ts"
            );
            var _VSimpleTable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ./VSimpleTable */
              "./src/components/VDataTable/VSimpleTable.ts"
            );
            var _MobileRow__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ./MobileRow */
              "./src/components/VDataTable/MobileRow.ts"
            );
            var _mixins_loadable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ../../mixins/loadable */
              "./src/mixins/loadable/index.ts"
            );
            var _mixins_mouse__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
              /*! ../../mixins/mouse */
              "./src/mixins/mouse/index.ts"
            );
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
              /*! ../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            function filterFn(item, search, filter2) {
              return function(header) {
                var value = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getObjectValueByPath"])(item, header.value);
                return header.filter ? header.filter(value, search, item) : filter2(value, search, item);
              };
            }
            function searchTableItems(items, search, headersWithCustomFilters, headersWithoutCustomFilters, customFilter, filterMode) {
              search = typeof search === "string" ? search.trim() : null;
              if (filterMode === "union") {
                if (!(search && headersWithoutCustomFilters.length) && !headersWithCustomFilters.length)
                  return items;
                return items.filter(function(item) {
                  if (headersWithCustomFilters.length && headersWithCustomFilters.every(filterFn(item, search, _util_helpers__WEBPACK_IMPORTED_MODULE_15__["defaultFilter"]))) {
                    return true;
                  }
                  return search && headersWithoutCustomFilters.some(filterFn(item, search, customFilter));
                });
              } else if (filterMode === "intersection") {
                return items.filter(function(item) {
                  var matchesColumnFilters = headersWithCustomFilters.every(filterFn(item, search, _util_helpers__WEBPACK_IMPORTED_MODULE_15__["defaultFilter"]));
                  var matchesSearchTerm = !search || headersWithoutCustomFilters.some(filterFn(item, search, customFilter));
                  return matchesColumnFilters && matchesSearchTerm;
                });
              } else {
                return items;
              }
            }
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_14__["default"])(_VDataIterator__WEBPACK_IMPORTED_MODULE_2__["VDataIterator"], _mixins_loadable__WEBPACK_IMPORTED_MODULE_11__["default"], _mixins_mouse__WEBPACK_IMPORTED_MODULE_12__["default"]).extend({
              name: "v-data-table",
              // https://github.com/vuejs/vue/issues/6872
              directives: {
                ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_13__["default"]
              },
              props: {
                headers: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                showSelect: Boolean,
                checkboxColor: String,
                showExpand: Boolean,
                showGroupBy: Boolean,
                // TODO: Fix
                // virtualRows: Boolean,
                height: [Number, String],
                hideDefaultHeader: Boolean,
                caption: String,
                dense: Boolean,
                headerProps: Object,
                calculateWidths: Boolean,
                fixedHeader: Boolean,
                headersLength: Number,
                expandIcon: {
                  type: String,
                  default: "$expand"
                },
                customFilter: {
                  type: Function,
                  default: _util_helpers__WEBPACK_IMPORTED_MODULE_15__["defaultFilter"]
                },
                filterMode: {
                  type: String,
                  default: "intersection"
                },
                itemClass: {
                  type: [String, Function],
                  default: function _default() {
                    return "";
                  }
                },
                itemStyle: {
                  type: [String, Function],
                  default: function _default() {
                    return "";
                  }
                },
                loaderHeight: {
                  type: [Number, String],
                  default: 4
                }
              },
              data: function data() {
                return {
                  internalGroupBy: [],
                  openCache: {},
                  widths: []
                };
              },
              computed: {
                computedHeaders: function computedHeaders() {
                  var _this2 = this;
                  if (!this.headers)
                    return [];
                  var headers = this.headers.filter(function(h) {
                    return h.value === void 0 || !_this2.internalGroupBy.find(function(v) {
                      return v === h.value;
                    });
                  });
                  var defaultHeader = {
                    text: "",
                    sortable: false,
                    width: "1px"
                  };
                  if (this.showSelect) {
                    var index2 = headers.findIndex(function(h) {
                      return h.value === "data-table-select";
                    });
                    if (index2 < 0)
                      headers.unshift(__assign2(__assign2({}, defaultHeader), {
                        value: "data-table-select"
                      }));
                    else
                      headers.splice(index2, 1, __assign2(__assign2({}, defaultHeader), headers[index2]));
                  }
                  if (this.showExpand) {
                    var index2 = headers.findIndex(function(h) {
                      return h.value === "data-table-expand";
                    });
                    if (index2 < 0)
                      headers.unshift(__assign2(__assign2({}, defaultHeader), {
                        value: "data-table-expand"
                      }));
                    else
                      headers.splice(index2, 1, __assign2(__assign2({}, defaultHeader), headers[index2]));
                  }
                  return headers;
                },
                colspanAttrs: function colspanAttrs() {
                  return this.isMobile ? void 0 : {
                    colspan: this.headersLength || this.computedHeaders.length
                  };
                },
                columnSorters: function columnSorters() {
                  return this.computedHeaders.reduce(function(acc, header) {
                    if (header.sort)
                      acc[header.value] = header.sort;
                    return acc;
                  }, {});
                },
                headersWithCustomFilters: function headersWithCustomFilters() {
                  return this.headers.filter(function(header) {
                    return header.filter && (!header.hasOwnProperty("filterable") || header.filterable === true);
                  });
                },
                headersWithoutCustomFilters: function headersWithoutCustomFilters() {
                  return this.headers.filter(function(header) {
                    return !header.filter && (!header.hasOwnProperty("filterable") || header.filterable === true);
                  });
                },
                sanitizedHeaderProps: function sanitizedHeaderProps() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["camelizeObjectKeys"])(this.headerProps);
                },
                computedItemsPerPage: function computedItemsPerPage() {
                  var itemsPerPage = this.options && this.options.itemsPerPage ? this.options.itemsPerPage : this.itemsPerPage;
                  var itemsPerPageOptions = this.sanitizedFooterProps.itemsPerPageOptions;
                  if (itemsPerPageOptions && !itemsPerPageOptions.find(function(item) {
                    return typeof item === "number" ? item === itemsPerPage : item.value === itemsPerPage;
                  })) {
                    var firstOption = itemsPerPageOptions[0];
                    return _typeof2(firstOption) === "object" ? firstOption.value : firstOption;
                  }
                  return itemsPerPage;
                },
                groupByText: function groupByText() {
                  var _this2 = this;
                  var _a2, _b2, _c;
                  return (_c = (_b2 = (_a2 = this.headers) === null || _a2 === void 0 ? void 0 : _a2.find(function(header) {
                    var _a3;
                    return header.value === ((_a3 = _this2.internalGroupBy) === null || _a3 === void 0 ? void 0 : _a3[0]);
                  })) === null || _b2 === void 0 ? void 0 : _b2.text) !== null && _c !== void 0 ? _c : "";
                }
              },
              created: function created2() {
                var _this2 = this;
                var breakingProps = [["sort-icon", "header-props.sort-icon"], ["hide-headers", "hide-default-header"], ["select-all", "show-select"]];
                breakingProps.forEach(function(_a2) {
                  var _b2 = __read2(_a2, 2), original = _b2[0], replacement = _b2[1];
                  if (_this2.$attrs.hasOwnProperty(original))
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_16__["breaking"])(original, replacement, _this2);
                });
              },
              mounted: function mounted3() {
                if (this.calculateWidths) {
                  window.addEventListener("resize", this.calcWidths);
                  this.calcWidths();
                }
              },
              beforeDestroy: function beforeDestroy2() {
                if (this.calculateWidths) {
                  window.removeEventListener("resize", this.calcWidths);
                }
              },
              methods: {
                calcWidths: function calcWidths() {
                  this.widths = Array.from(this.$el.querySelectorAll("th")).map(function(e) {
                    return e.clientWidth;
                  });
                },
                customFilterWithColumns: function customFilterWithColumns(items, search) {
                  return searchTableItems(items, search, this.headersWithCustomFilters, this.headersWithoutCustomFilters, this.customFilter, this.filterMode);
                },
                customSortWithHeaders: function customSortWithHeaders(items, sortBy, sortDesc, locale) {
                  return this.customSort(items, sortBy, sortDesc, locale, this.columnSorters);
                },
                createItemProps: function createItemProps(item, index2) {
                  var _this2 = this;
                  var data = __assign2(__assign2({}, _VDataIterator__WEBPACK_IMPORTED_MODULE_2__["VDataIterator"].options.methods.createItemProps.call(this, item, index2)), {
                    headers: this.computedHeaders
                  });
                  return __assign2(__assign2({}, data), {
                    attrs: {
                      class: {
                        "v-data-table__selected": data.isSelected
                      }
                    },
                    on: __assign2(__assign2({}, this.getDefaultMouseEventHandlers(":row", function() {
                      return data;
                    }, true)), {
                      // TODO: the first argument should be the event, and the second argument should be data,
                      // but this is a breaking change so it's for v3
                      click: function click2(event) {
                        return _this2.$emit("click:row", item, data, event);
                      }
                    })
                  });
                },
                genCaption: function genCaption(props2) {
                  if (this.caption)
                    return [this.$createElement("caption", [this.caption])];
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getSlot"])(this, "caption", props2, true);
                },
                genColgroup: function genColgroup(props2) {
                  var _this2 = this;
                  return this.$createElement("colgroup", this.computedHeaders.map(function(header) {
                    return _this2.$createElement("col", {
                      class: {
                        divider: header.divider
                      }
                    });
                  }));
                },
                genLoading: function genLoading() {
                  var th = this.$createElement("th", {
                    staticClass: "column",
                    attrs: this.colspanAttrs
                  }, [this.genProgress()]);
                  var tr = this.$createElement("tr", {
                    staticClass: "v-data-table__progress"
                  }, [th]);
                  return this.$createElement("thead", [tr]);
                },
                genHeaders: function genHeaders(props2) {
                  var data = {
                    props: __assign2(__assign2({}, this.sanitizedHeaderProps), {
                      headers: this.computedHeaders,
                      options: props2.options,
                      mobile: this.isMobile,
                      showGroupBy: this.showGroupBy,
                      checkboxColor: this.checkboxColor,
                      someItems: this.someItems,
                      everyItem: this.everyItem,
                      singleSelect: this.singleSelect,
                      disableSort: this.disableSort
                    }),
                    on: {
                      sort: props2.sort,
                      group: props2.group,
                      "toggle-select-all": this.toggleSelectAll
                    }
                  };
                  var children = [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getSlot"])(this, "header", __assign2(__assign2({}, data), {
                    isMobile: this.isMobile
                  }))];
                  if (!this.hideDefaultHeader) {
                    var scopedSlots = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getPrefixedScopedSlots"])("header.", this.$scopedSlots);
                    children.push(this.$createElement(_VDataTableHeader__WEBPACK_IMPORTED_MODULE_4__["default"], __assign2(__assign2({}, data), {
                      scopedSlots
                    })));
                  }
                  if (this.loading)
                    children.push(this.genLoading());
                  return children;
                },
                genEmptyWrapper: function genEmptyWrapper(content) {
                  return this.$createElement("tr", {
                    staticClass: "v-data-table__empty-wrapper"
                  }, [this.$createElement("td", {
                    attrs: this.colspanAttrs
                  }, content)]);
                },
                genItems: function genItems(items, props2) {
                  var empty = this.genEmpty(props2.originalItemsLength, props2.pagination.itemsLength);
                  if (empty)
                    return [empty];
                  return props2.groupedItems ? this.genGroupedRows(props2.groupedItems, props2) : this.genRows(items, props2);
                },
                genGroupedRows: function genGroupedRows(groupedItems, props2) {
                  var _this2 = this;
                  return groupedItems.map(function(group) {
                    if (!_this2.openCache.hasOwnProperty(group.name))
                      _this2.$set(_this2.openCache, group.name, true);
                    if (_this2.$scopedSlots.group) {
                      return _this2.$scopedSlots.group({
                        group: group.name,
                        options: props2.options,
                        isMobile: _this2.isMobile,
                        items: group.items,
                        headers: _this2.computedHeaders
                      });
                    } else {
                      return _this2.genDefaultGroupedRow(group.name, group.items, props2);
                    }
                  });
                },
                genDefaultGroupedRow: function genDefaultGroupedRow(group, items, props2) {
                  var _this2 = this;
                  var isOpen = !!this.openCache[group];
                  var children = [this.$createElement("template", {
                    slot: "row.content"
                  }, this.genRows(items, props2))];
                  var toggleFn = function toggleFn2() {
                    return _this2.$set(_this2.openCache, group, !_this2.openCache[group]);
                  };
                  var removeFn = function removeFn2() {
                    return props2.updateOptions({
                      groupBy: [],
                      groupDesc: []
                    });
                  };
                  if (this.$scopedSlots["group.header"]) {
                    children.unshift(this.$createElement("template", {
                      slot: "column.header"
                    }, [this.$scopedSlots["group.header"]({
                      group,
                      groupBy: props2.options.groupBy,
                      isMobile: this.isMobile,
                      items,
                      headers: this.computedHeaders,
                      isOpen,
                      toggle: toggleFn,
                      remove: removeFn
                    })]));
                  } else {
                    var toggle = this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_3__["default"], {
                      staticClass: "ma-0",
                      props: {
                        icon: true,
                        small: true
                      },
                      on: {
                        click: toggleFn
                      }
                    }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_5__["default"], [isOpen ? "$minus" : "$plus"])]);
                    var remove2 = this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_3__["default"], {
                      staticClass: "ma-0",
                      props: {
                        icon: true,
                        small: true
                      },
                      on: {
                        click: removeFn
                      }
                    }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_5__["default"], ["$close"])]);
                    var column = this.$createElement("td", {
                      staticClass: "text-start",
                      attrs: this.colspanAttrs
                    }, [toggle, this.groupByText + ": " + group, remove2]);
                    children.unshift(this.$createElement("template", {
                      slot: "column.header"
                    }, [column]));
                  }
                  if (this.$scopedSlots["group.summary"]) {
                    children.push(this.$createElement("template", {
                      slot: "column.summary"
                    }, [this.$scopedSlots["group.summary"]({
                      group,
                      groupBy: props2.options.groupBy,
                      isMobile: this.isMobile,
                      items,
                      headers: this.computedHeaders,
                      isOpen,
                      toggle: toggleFn
                    })]));
                  }
                  return this.$createElement(_RowGroup__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    key: group,
                    props: {
                      value: isOpen
                    }
                  }, children);
                },
                genRows: function genRows(items, props2) {
                  return this.$scopedSlots.item ? this.genScopedRows(items, props2) : this.genDefaultRows(items, props2);
                },
                genScopedRows: function genScopedRows(items, props2) {
                  var rows = [];
                  for (var i2 = 0; i2 < items.length; i2++) {
                    var item = items[i2];
                    rows.push(this.$scopedSlots.item(__assign2(__assign2({}, this.createItemProps(item, i2)), {
                      isMobile: this.isMobile
                    })));
                    if (this.isExpanded(item)) {
                      rows.push(this.$scopedSlots["expanded-item"]({
                        headers: this.computedHeaders,
                        isMobile: this.isMobile,
                        index: i2,
                        item
                      }));
                    }
                  }
                  return rows;
                },
                genDefaultRows: function genDefaultRows(items, props2) {
                  var _this2 = this;
                  return this.$scopedSlots["expanded-item"] ? items.map(function(item, index2) {
                    return _this2.genDefaultExpandedRow(item, index2);
                  }) : items.map(function(item, index2) {
                    return _this2.genDefaultSimpleRow(item, index2);
                  });
                },
                genDefaultExpandedRow: function genDefaultExpandedRow(item, index2) {
                  var isExpanded = this.isExpanded(item);
                  var classes = {
                    "v-data-table__expanded v-data-table__expanded__row": isExpanded
                  };
                  var headerRow = this.genDefaultSimpleRow(item, index2, classes);
                  var expandedRow = this.$createElement("tr", {
                    staticClass: "v-data-table__expanded v-data-table__expanded__content"
                  }, [this.$scopedSlots["expanded-item"]({
                    headers: this.computedHeaders,
                    isMobile: this.isMobile,
                    item
                  })]);
                  return this.$createElement(_RowGroup__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    props: {
                      value: isExpanded
                    }
                  }, [this.$createElement("template", {
                    slot: "row.header"
                  }, [headerRow]), this.$createElement("template", {
                    slot: "row.content"
                  }, [expandedRow])]);
                },
                genDefaultSimpleRow: function genDefaultSimpleRow(item, index2, classes) {
                  var _this2 = this;
                  if (classes === void 0) {
                    classes = {};
                  }
                  var scopedSlots = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getPrefixedScopedSlots"])("item.", this.$scopedSlots);
                  var data = this.createItemProps(item, index2);
                  if (this.showSelect) {
                    var slot_1 = scopedSlots["data-table-select"];
                    scopedSlots["data-table-select"] = slot_1 ? function() {
                      return slot_1(__assign2(__assign2({}, data), {
                        isMobile: _this2.isMobile
                      }));
                    } : function() {
                      var _a2;
                      return _this2.$createElement(_VCheckbox_VSimpleCheckbox__WEBPACK_IMPORTED_MODULE_8__["default"], {
                        staticClass: "v-data-table__checkbox",
                        props: {
                          value: data.isSelected,
                          disabled: !_this2.isSelectable(item),
                          color: (_a2 = _this2.checkboxColor) !== null && _a2 !== void 0 ? _a2 : ""
                        },
                        on: {
                          input: function input2(val) {
                            return data.select(val);
                          }
                        }
                      });
                    };
                  }
                  if (this.showExpand) {
                    var slot_2 = scopedSlots["data-table-expand"];
                    scopedSlots["data-table-expand"] = slot_2 ? function() {
                      return slot_2(data);
                    } : function() {
                      return _this2.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_5__["default"], {
                        staticClass: "v-data-table__expand-icon",
                        class: {
                          "v-data-table__expand-icon--active": data.isExpanded
                        },
                        on: {
                          click: function click2(e) {
                            e.stopPropagation();
                            data.expand(!data.isExpanded);
                          }
                        }
                      }, [_this2.expandIcon]);
                    };
                  }
                  return this.$createElement(this.isMobile ? _MobileRow__WEBPACK_IMPORTED_MODULE_10__["default"] : _Row__WEBPACK_IMPORTED_MODULE_6__["default"], {
                    key: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getObjectValueByPath"])(item, this.itemKey),
                    class: Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_17__["mergeClasses"])(__assign2(__assign2({}, classes), {
                      "v-data-table__selected": data.isSelected
                    }), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getPropertyFromItem"])(item, this.itemClass)),
                    style: Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_17__["mergeStyles"])({}, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getPropertyFromItem"])(item, this.itemStyle)),
                    props: {
                      headers: this.computedHeaders,
                      hideDefaultHeader: this.hideDefaultHeader,
                      index: index2,
                      item,
                      rtl: this.$vuetify.rtl
                    },
                    scopedSlots,
                    on: data.on
                  });
                },
                genBody: function genBody(props2) {
                  var data = __assign2(__assign2({}, props2), {
                    expand: this.expand,
                    headers: this.computedHeaders,
                    isExpanded: this.isExpanded,
                    isMobile: this.isMobile,
                    isSelected: this.isSelected,
                    select: this.select
                  });
                  if (this.$scopedSlots.body) {
                    return this.$scopedSlots.body(data);
                  }
                  return this.$createElement("tbody", [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getSlot"])(this, "body.prepend", data, true), this.genItems(props2.items, props2), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getSlot"])(this, "body.append", data, true)]);
                },
                genFoot: function genFoot(props2) {
                  var _a2, _b2;
                  return (_b2 = (_a2 = this.$scopedSlots).foot) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, props2);
                },
                genFooters: function genFooters(props2) {
                  var data = {
                    props: __assign2({
                      options: props2.options,
                      pagination: props2.pagination,
                      itemsPerPageText: "$vuetify.dataTable.itemsPerPageText"
                    }, this.sanitizedFooterProps),
                    on: {
                      "update:options": function updateOptions(value) {
                        return props2.updateOptions(value);
                      }
                    },
                    widths: this.widths,
                    headers: this.computedHeaders
                  };
                  var children = [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getSlot"])(this, "footer", data, true)];
                  if (!this.hideDefaultFooter) {
                    children.push(this.$createElement(_VDataIterator__WEBPACK_IMPORTED_MODULE_2__["VDataFooter"], __assign2(__assign2({}, data), {
                      scopedSlots: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getPrefixedScopedSlots"])("footer.", this.$scopedSlots)
                    })));
                  }
                  return children;
                },
                genDefaultScopedSlot: function genDefaultScopedSlot(props2) {
                  var simpleProps = {
                    height: this.height,
                    fixedHeader: this.fixedHeader,
                    dense: this.dense
                  };
                  return this.$createElement(_VSimpleTable__WEBPACK_IMPORTED_MODULE_9__["default"], {
                    props: simpleProps,
                    class: {
                      "v-data-table--mobile": this.isMobile,
                      "v-data-table--selectable": this.showSelect
                    }
                  }, [this.proxySlot("top", Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["getSlot"])(this, "top", __assign2(__assign2({}, props2), {
                    isMobile: this.isMobile
                  }), true)), this.genCaption(props2), this.genColgroup(props2), this.genHeaders(props2), this.genBody(props2), this.genFoot(props2), this.proxySlot("bottom", this.genFooters(props2))]);
                },
                proxySlot: function proxySlot(slot, content) {
                  return this.$createElement("template", {
                    slot
                  }, content);
                }
              },
              render: function render8() {
                var _this2 = this;
                return this.$createElement(_VData__WEBPACK_IMPORTED_MODULE_1__["VData"], {
                  props: __assign2(__assign2({}, this.$props), {
                    customFilter: this.customFilterWithColumns,
                    customSort: this.customSortWithHeaders,
                    itemsPerPage: this.computedItemsPerPage
                  }),
                  on: {
                    "update:options": function updateOptions(v, old) {
                      _this2.internalGroupBy = v.groupBy || [];
                      !Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["deepEqual"])(v, old) && _this2.$emit("update:options", v);
                    },
                    "update:page": function updatePage(v) {
                      return _this2.$emit("update:page", v);
                    },
                    "update:items-per-page": function updateItemsPerPage(v) {
                      return _this2.$emit("update:items-per-page", v);
                    },
                    "update:sort-by": function updateSortBy(v) {
                      return _this2.$emit("update:sort-by", v);
                    },
                    "update:sort-desc": function updateSortDesc(v) {
                      return _this2.$emit("update:sort-desc", v);
                    },
                    "update:group-by": function updateGroupBy(v) {
                      return _this2.$emit("update:group-by", v);
                    },
                    "update:group-desc": function updateGroupDesc(v) {
                      return _this2.$emit("update:group-desc", v);
                    },
                    pagination: function pagination(v, old) {
                      return !Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["deepEqual"])(v, old) && _this2.$emit("pagination", v);
                    },
                    "current-items": function currentItems(v) {
                      _this2.internalCurrentItems = v;
                      _this2.$emit("current-items", v);
                    },
                    "page-count": function pageCount(v) {
                      return _this2.$emit("page-count", v);
                    }
                  },
                  scopedSlots: {
                    default: this.genDefaultScopedSlot
                  }
                });
              }
            });
          }
        ),
        /***/
        "./src/components/VDataTable/VDataTableHeader.sass": (
          /*!*********************************************************!*\
            !*** ./src/components/VDataTable/VDataTableHeader.sass ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VDataTable/VDataTableHeader.ts": (
          /*!*******************************************************!*\
            !*** ./src/components/VDataTable/VDataTableHeader.ts ***!
            \*******************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VDataTableHeader.sass */
              "./src/components/VDataTable/VDataTableHeader.sass"
            );
            var _VDataTableHeaderMobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VDataTableHeaderMobile */
              "./src/components/VDataTable/VDataTableHeaderMobile.ts"
            );
            var _VDataTableHeaderDesktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VDataTableHeaderDesktop */
              "./src/components/VDataTable/VDataTableHeaderDesktop.ts"
            );
            var _mixins_header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./mixins/header */
              "./src/components/VDataTable/mixins/header.ts"
            );
            var _util_dedupeModelListeners__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/dedupeModelListeners */
              "./src/util/dedupeModelListeners.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var _util_rebuildFunctionalSlots__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/rebuildFunctionalSlots */
              "./src/util/rebuildFunctionalSlots.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_7___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_7__);
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_7___default.a.extend({
              name: "v-data-table-header",
              functional: true,
              props: __assign2(__assign2({}, _mixins_header__WEBPACK_IMPORTED_MODULE_3__["default"].options.props), {
                mobile: Boolean
              }),
              render: function render8(h, _a2) {
                var props2 = _a2.props, data = _a2.data, slots = _a2.slots;
                Object(_util_dedupeModelListeners__WEBPACK_IMPORTED_MODULE_4__["default"])(data);
                var children = Object(_util_rebuildFunctionalSlots__WEBPACK_IMPORTED_MODULE_6__["default"])(slots(), h);
                data = Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_5__["default"])(data, {
                  props: props2
                });
                if (props2.mobile) {
                  return h(_VDataTableHeaderMobile__WEBPACK_IMPORTED_MODULE_1__["default"], data, children);
                } else {
                  return h(_VDataTableHeaderDesktop__WEBPACK_IMPORTED_MODULE_2__["default"], data, children);
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VDataTable/VDataTableHeaderDesktop.ts": (
          /*!**************************************************************!*\
            !*** ./src/components/VDataTable/VDataTableHeaderDesktop.ts ***!
            \**************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _util_mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _mixins_header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./mixins/header */
              "./src/components/VDataTable/mixins/header.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_0__["default"])(_mixins_header__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
              name: "v-data-table-header-desktop",
              methods: {
                genGroupByToggle: function genGroupByToggle(header) {
                  var _this2 = this;
                  return this.$createElement("span", {
                    on: {
                      click: function click2(e) {
                        e.stopPropagation();
                        _this2.$emit("group", header.value);
                      }
                    }
                  }, ["group"]);
                },
                getAria: function getAria(beingSorted, isDesc) {
                  var _this2 = this;
                  var $t = function $t2(key) {
                    return _this2.$vuetify.lang.t("$vuetify.dataTable.ariaLabel." + key);
                  };
                  var ariaSort = "none";
                  var ariaLabel = [$t("sortNone"), $t("activateAscending")];
                  if (!beingSorted) {
                    return {
                      ariaSort,
                      ariaLabel: ariaLabel.join(" ")
                    };
                  }
                  if (isDesc) {
                    ariaSort = "descending";
                    ariaLabel = [$t("sortDescending"), $t(this.options.mustSort ? "activateAscending" : "activateNone")];
                  } else {
                    ariaSort = "ascending";
                    ariaLabel = [$t("sortAscending"), $t("activateDescending")];
                  }
                  return {
                    ariaSort,
                    ariaLabel: ariaLabel.join(" ")
                  };
                },
                genHeader: function genHeader(header) {
                  var _this2 = this;
                  var data = {
                    attrs: {
                      role: "columnheader",
                      scope: "col",
                      "aria-label": header.text || ""
                    },
                    style: {
                      width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["convertToUnit"])(header.width),
                      minWidth: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["convertToUnit"])(header.width)
                    },
                    class: __spreadArray2(__spreadArray2(["text-" + (header.align || "start")], __read2(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["wrapInArray"])(header.class)), false), [header.divider && "v-data-table__divider"], false),
                    on: {}
                  };
                  var children = [];
                  if (header.value === "data-table-select" && !this.singleSelect) {
                    return this.$createElement("th", data, [this.genSelectAll()]);
                  }
                  children.push(this.$scopedSlots.hasOwnProperty(header.value) ? this.$scopedSlots[header.value]({
                    header
                  }) : this.$createElement("span", [header.text]));
                  if (!this.disableSort && (header.sortable || !header.hasOwnProperty("sortable"))) {
                    data.on.click = function() {
                      return _this2.$emit("sort", header.value);
                    };
                    var sortIndex = this.options.sortBy.findIndex(function(k) {
                      return k === header.value;
                    });
                    var beingSorted = sortIndex >= 0;
                    var isDesc = this.options.sortDesc[sortIndex];
                    data.class.push("sortable");
                    var _a2 = this.getAria(beingSorted, isDesc), ariaLabel = _a2.ariaLabel, ariaSort = _a2.ariaSort;
                    data.attrs["aria-label"] += (header.text ? ": " : "") + ariaLabel;
                    data.attrs["aria-sort"] = ariaSort;
                    if (beingSorted) {
                      data.class.push("active");
                      data.class.push(isDesc ? "desc" : "asc");
                    }
                    if (header.align === "end")
                      children.unshift(this.genSortIcon());
                    else
                      children.push(this.genSortIcon());
                    if (this.options.multiSort && beingSorted) {
                      children.push(this.$createElement("span", {
                        class: "v-data-table-header__sort-badge"
                      }, [String(sortIndex + 1)]));
                    }
                  }
                  if (this.showGroupBy && header.groupable !== false)
                    children.push(this.genGroupByToggle(header));
                  return this.$createElement("th", data, children);
                }
              },
              render: function render8() {
                var _this2 = this;
                return this.$createElement("thead", {
                  staticClass: "v-data-table-header"
                }, [this.$createElement("tr", this.headers.map(function(header) {
                  return _this2.genHeader(header);
                }))]);
              }
            });
          }
        ),
        /***/
        "./src/components/VDataTable/VDataTableHeaderMobile.ts": (
          /*!*************************************************************!*\
            !*** ./src/components/VDataTable/VDataTableHeaderMobile.ts ***!
            \*************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _util_mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSelect/VSelect */
              "./src/components/VSelect/VSelect.ts"
            );
            var _VChip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VChip */
              "./src/components/VChip/index.ts"
            );
            var _mixins_header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./mixins/header */
              "./src/components/VDataTable/mixins/header.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_0__["default"])(_mixins_header__WEBPACK_IMPORTED_MODULE_3__["default"]).extend({
              name: "v-data-table-header-mobile",
              props: {
                sortByText: {
                  type: String,
                  default: "$vuetify.dataTable.sortBy"
                }
              },
              methods: {
                genSortChip: function genSortChip(props2) {
                  var _this2 = this;
                  var children = [props2.item.text];
                  var sortIndex = this.options.sortBy.findIndex(function(k) {
                    return k === props2.item.value;
                  });
                  var beingSorted = sortIndex >= 0;
                  var isDesc = this.options.sortDesc[sortIndex];
                  children.push(this.$createElement("div", {
                    staticClass: "v-chip__close",
                    class: {
                      sortable: true,
                      active: beingSorted,
                      asc: beingSorted && !isDesc,
                      desc: beingSorted && isDesc
                    }
                  }, [this.genSortIcon()]));
                  return this.$createElement(_VChip__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    staticClass: "sortable",
                    on: {
                      click: function click2(e) {
                        e.stopPropagation();
                        _this2.$emit("sort", props2.item.value);
                      }
                    }
                  }, children);
                },
                genSortSelect: function genSortSelect(items) {
                  var _this2 = this;
                  return this.$createElement(_VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: {
                      label: this.$vuetify.lang.t(this.sortByText),
                      items,
                      hideDetails: true,
                      multiple: this.options.multiSort,
                      value: this.options.multiSort ? this.options.sortBy : this.options.sortBy[0],
                      menuProps: {
                        closeOnContentClick: true
                      }
                    },
                    on: {
                      change: function change(v) {
                        return _this2.$emit("sort", v);
                      }
                    },
                    scopedSlots: {
                      selection: function selection(props2) {
                        return _this2.genSortChip(props2);
                      }
                    }
                  });
                }
              },
              render: function render8(h) {
                var children = [];
                var header = this.headers.find(function(h2) {
                  return h2.value === "data-table-select";
                });
                if (header && !this.singleSelect) {
                  children.push(this.$createElement("div", {
                    class: __spreadArray2(["v-data-table-header-mobile__select"], __read2(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["wrapInArray"])(header.class)), false),
                    attrs: {
                      width: header.width
                    }
                  }, [this.genSelectAll()]));
                }
                var sortHeaders = this.headers.filter(function(h2) {
                  return h2.sortable !== false && h2.value !== "data-table-select";
                }).map(function(h2) {
                  return {
                    text: h2.text,
                    value: h2.value
                  };
                });
                if (!this.disableSort && sortHeaders.length) {
                  children.push(this.genSortSelect(sortHeaders));
                }
                var th = children.length ? h("th", [h("div", {
                  staticClass: "v-data-table-header-mobile__wrapper"
                }, children)]) : void 0;
                var tr = h("tr", [th]);
                return h("thead", {
                  staticClass: "v-data-table-header v-data-table-header-mobile"
                }, [tr]);
              }
            });
          }
        ),
        /***/
        "./src/components/VDataTable/VEditDialog.sass": (
          /*!****************************************************!*\
            !*** ./src/components/VDataTable/VEditDialog.sass ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VDataTable/VEditDialog.ts": (
          /*!**************************************************!*\
            !*** ./src/components/VDataTable/VEditDialog.ts ***!
            \**************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VEditDialog.sass */
              "./src/components/VDataTable/VEditDialog.sass"
            );
            var _mixins_returnable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/returnable */
              "./src/mixins/returnable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _VBtn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../VBtn */
              "./src/components/VBtn/index.ts"
            );
            var _VMenu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../VMenu */
              "./src/components/VMenu/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__["default"])(_mixins_returnable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]).extend({
              name: "v-edit-dialog",
              props: {
                cancelText: {
                  default: "Cancel"
                },
                large: Boolean,
                eager: Boolean,
                persistent: Boolean,
                saveText: {
                  default: "Save"
                },
                transition: {
                  type: String,
                  default: "slide-x-reverse-transition"
                }
              },
              data: function data() {
                return {
                  isActive: false
                };
              },
              watch: {
                isActive: function isActive(val) {
                  if (val) {
                    this.$emit("open");
                    setTimeout(this.focus, 50);
                  } else {
                    this.$emit("close");
                  }
                }
              },
              methods: {
                cancel: function cancel() {
                  this.isActive = false;
                  this.$emit("cancel");
                },
                focus: function focus() {
                  var input2 = this.$refs.content.querySelector("input");
                  input2 && input2.focus();
                },
                genButton: function genButton(fn, text2) {
                  return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    props: {
                      text: true,
                      color: "primary",
                      light: true
                    },
                    on: {
                      click: fn
                    }
                  }, text2);
                },
                genActions: function genActions() {
                  var _this2 = this;
                  return this.$createElement("div", {
                    class: "v-small-dialog__actions"
                  }, [this.genButton(this.cancel, this.cancelText), this.genButton(function() {
                    _this2.save(_this2.returnValue);
                    _this2.$emit("save");
                  }, this.saveText)]);
                },
                genContent: function genContent() {
                  var _this2 = this;
                  return this.$createElement("div", {
                    staticClass: "v-small-dialog__content",
                    on: {
                      keydown: function keydown(e) {
                        e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].esc && _this2.cancel();
                        if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].enter) {
                          _this2.save(_this2.returnValue);
                          _this2.$emit("save");
                        }
                      }
                    },
                    ref: "content"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this, "input"));
                }
              },
              render: function render8(h) {
                var _this2 = this;
                return h(_VMenu__WEBPACK_IMPORTED_MODULE_5__["default"], {
                  staticClass: "v-small-dialog",
                  class: this.themeClasses,
                  props: {
                    contentClass: "v-small-dialog__menu-content",
                    transition: this.transition,
                    origin: "top right",
                    right: true,
                    value: this.isActive,
                    closeOnClick: !this.persistent,
                    closeOnContentClick: false,
                    eager: this.eager,
                    light: this.light,
                    dark: this.dark
                  },
                  on: {
                    input: function input2(val) {
                      return _this2.isActive = val;
                    }
                  },
                  scopedSlots: {
                    activator: function activator(_a2) {
                      var on2 = _a2.on;
                      return h("div", {
                        staticClass: "v-small-dialog__activator",
                        on: on2
                      }, [h("span", {
                        staticClass: "v-small-dialog__activator__content"
                      }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(_this2))]);
                    }
                  }
                }, [this.genContent(), this.large ? this.genActions() : null]);
              }
            });
          }
        ),
        /***/
        "./src/components/VDataTable/VSimpleTable.sass": (
          /*!*****************************************************!*\
            !*** ./src/components/VDataTable/VSimpleTable.sass ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VDataTable/VSimpleTable.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VDataTable/VSimpleTable.ts ***!
            \***************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VSimpleTable.sass */
              "./src/components/VDataTable/VSimpleTable.sass"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]).extend({
              name: "v-simple-table",
              props: {
                dense: Boolean,
                fixedHeader: Boolean,
                height: [Number, String]
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-data-table--dense": this.dense,
                    "v-data-table--fixed-height": !!this.height && !this.fixedHeader,
                    "v-data-table--fixed-header": this.fixedHeader,
                    "v-data-table--has-top": !!this.$slots.top,
                    "v-data-table--has-bottom": !!this.$slots.bottom
                  }, this.themeClasses);
                }
              },
              methods: {
                genWrapper: function genWrapper() {
                  return this.$slots.wrapper || this.$createElement("div", {
                    staticClass: "v-data-table__wrapper",
                    style: {
                      height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["convertToUnit"])(this.height)
                    }
                  }, [this.$createElement("table", Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getSlot"])(this))]);
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-data-table",
                  class: this.classes
                }, [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getSlot"])(this, "top"), this.genWrapper(), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getSlot"])(this, "bottom")]);
              }
            });
          }
        ),
        /***/
        "./src/components/VDataTable/VVirtualTable.sass": (
          /*!******************************************************!*\
            !*** ./src/components/VDataTable/VVirtualTable.sass ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VDataTable/VVirtualTable.ts": (
          /*!****************************************************!*\
            !*** ./src/components/VDataTable/VVirtualTable.ts ***!
            \****************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VVirtualTable.sass */
              "./src/components/VDataTable/VVirtualTable.sass"
            );
            var _VSimpleTable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VSimpleTable */
              "./src/components/VDataTable/VSimpleTable.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_VSimpleTable__WEBPACK_IMPORTED_MODULE_1__["default"]);
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-virtual-table",
              props: {
                chunkSize: {
                  type: Number,
                  default: 25
                },
                headerHeight: {
                  type: Number,
                  default: 48
                },
                items: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                rowHeight: {
                  type: Number,
                  default: 48
                }
              },
              data: function data() {
                return {
                  scrollTop: 0,
                  oldChunk: 0,
                  scrollDebounce: null,
                  invalidateCache: false
                };
              },
              computed: {
                itemsLength: function itemsLength() {
                  return this.items.length;
                },
                totalHeight: function totalHeight() {
                  return this.itemsLength * this.rowHeight + this.headerHeight;
                },
                topIndex: function topIndex() {
                  return Math.floor(this.scrollTop / this.rowHeight);
                },
                chunkIndex: function chunkIndex() {
                  return Math.floor(this.topIndex / this.chunkSize);
                },
                startIndex: function startIndex() {
                  return Math.max(0, this.chunkIndex * this.chunkSize - this.chunkSize);
                },
                offsetTop: function offsetTop() {
                  return Math.max(0, this.startIndex * this.rowHeight);
                },
                stopIndex: function stopIndex() {
                  return Math.min(this.startIndex + this.chunkSize * 3, this.itemsLength);
                },
                offsetBottom: function offsetBottom() {
                  return Math.max(0, (this.itemsLength - this.stopIndex - this.startIndex) * this.rowHeight);
                }
              },
              watch: {
                chunkIndex: function chunkIndex(newValue, oldValue) {
                  this.oldChunk = oldValue;
                },
                items: function items() {
                  this.cachedItems = null;
                  this.$refs.table.scrollTop = 0;
                }
              },
              created: function created2() {
                this.cachedItems = null;
              },
              mounted: function mounted3() {
                this.scrollDebounce = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["debounce"])(this.onScroll, 50);
                this.$refs.table.addEventListener("scroll", this.scrollDebounce, {
                  passive: true
                });
              },
              beforeDestroy: function beforeDestroy2() {
                this.$refs.table.removeEventListener("scroll", this.scrollDebounce);
              },
              methods: {
                createStyleHeight: function createStyleHeight(height) {
                  return {
                    height: height + "px"
                  };
                },
                genBody: function genBody() {
                  if (this.cachedItems === null || this.chunkIndex !== this.oldChunk) {
                    this.cachedItems = this.genItems();
                    this.oldChunk = this.chunkIndex;
                  }
                  return this.$createElement("tbody", [this.$createElement("tr", {
                    style: this.createStyleHeight(this.offsetTop)
                  }), this.cachedItems, this.$createElement("tr", {
                    style: this.createStyleHeight(this.offsetBottom)
                  })]);
                },
                genItems: function genItems() {
                  return this.$scopedSlots.items({
                    items: this.items.slice(this.startIndex, this.stopIndex)
                  });
                },
                onScroll: function onScroll(e) {
                  var target2 = e.target;
                  this.scrollTop = target2.scrollTop;
                },
                genTable: function genTable() {
                  return this.$createElement("div", {
                    ref: "table",
                    staticClass: "v-virtual-table__table"
                  }, [this.$createElement("table", [this.$slots["body.before"], this.genBody(), this.$slots["body.after"]])]);
                },
                genWrapper: function genWrapper() {
                  return this.$createElement("div", {
                    staticClass: "v-virtual-table__wrapper",
                    style: {
                      height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.height)
                    }
                  }, [this.genTable()]);
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-data-table v-virtual-table",
                  class: this.classes
                }, [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this, "top"), this.genWrapper(), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this, "bottom")]);
              }
            });
          }
        ),
        /***/
        "./src/components/VDataTable/index.ts": (
          /*!********************************************!*\
            !*** ./src/components/VDataTable/index.ts ***!
            \********************************************/
          /*! exports provided: VDataTable, VEditDialog, VTableOverflow, VDataTableHeader, VSimpleTable, VVirtualTable, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "VTableOverflow", function() {
              return VTableOverflow;
            });
            var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _VDataTable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VDataTable */
              "./src/components/VDataTable/VDataTable.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDataTable", function() {
              return _VDataTable__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _VDataTableHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VDataTableHeader */
              "./src/components/VDataTable/VDataTableHeader.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDataTableHeader", function() {
              return _VDataTableHeader__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            var _VEditDialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VEditDialog */
              "./src/components/VDataTable/VEditDialog.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VEditDialog", function() {
              return _VEditDialog__WEBPACK_IMPORTED_MODULE_3__["default"];
            });
            var _VSimpleTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./VSimpleTable */
              "./src/components/VDataTable/VSimpleTable.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSimpleTable", function() {
              return _VSimpleTable__WEBPACK_IMPORTED_MODULE_4__["default"];
            });
            var _VVirtualTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./VVirtualTable */
              "./src/components/VDataTable/VVirtualTable.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VVirtualTable", function() {
              return _VVirtualTable__WEBPACK_IMPORTED_MODULE_5__["default"];
            });
            var VTableOverflow = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])("v-table__overflow");
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VDataTable: _VDataTable__WEBPACK_IMPORTED_MODULE_1__["default"],
                VDataTableHeader: _VDataTableHeader__WEBPACK_IMPORTED_MODULE_2__["default"],
                VEditDialog: _VEditDialog__WEBPACK_IMPORTED_MODULE_3__["default"],
                VTableOverflow,
                VSimpleTable: _VSimpleTable__WEBPACK_IMPORTED_MODULE_4__["default"],
                VVirtualTable: _VVirtualTable__WEBPACK_IMPORTED_MODULE_5__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VDataTable/mixins/header.ts": (
          /*!****************************************************!*\
            !*** ./src/components/VDataTable/mixins/header.ts ***!
            \****************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _VCheckbox_VSimpleCheckbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../VCheckbox/VSimpleCheckbox */
              "./src/components/VCheckbox/VSimpleCheckbox.ts"
            );
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])().extend({
              // https://github.com/vuejs/vue/issues/6872
              directives: {
                ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_2__["default"]
              },
              props: {
                headers: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                options: {
                  type: Object,
                  default: function _default() {
                    return {
                      page: 1,
                      itemsPerPage: 10,
                      sortBy: [],
                      sortDesc: [],
                      groupBy: [],
                      groupDesc: [],
                      multiSort: false,
                      mustSort: false
                    };
                  }
                },
                checkboxColor: String,
                sortIcon: {
                  type: String,
                  default: "$sort"
                },
                everyItem: Boolean,
                someItems: Boolean,
                showGroupBy: Boolean,
                singleSelect: Boolean,
                disableSort: Boolean
              },
              methods: {
                genSelectAll: function genSelectAll() {
                  var _this2 = this;
                  var _a2;
                  var data = {
                    props: {
                      value: this.everyItem,
                      indeterminate: !this.everyItem && this.someItems,
                      color: (_a2 = this.checkboxColor) !== null && _a2 !== void 0 ? _a2 : ""
                    },
                    on: {
                      input: function input2(v) {
                        return _this2.$emit("toggle-select-all", v);
                      }
                    }
                  };
                  if (this.$scopedSlots["data-table-select"]) {
                    return this.$scopedSlots["data-table-select"](data);
                  }
                  return this.$createElement(_VCheckbox_VSimpleCheckbox__WEBPACK_IMPORTED_MODULE_1__["default"], __assign2({
                    staticClass: "v-data-table__checkbox"
                  }, data));
                },
                genSortIcon: function genSortIcon() {
                  return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"], {
                    staticClass: "v-data-table-header__icon",
                    props: {
                      size: 18
                    }
                  }, [this.sortIcon]);
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VDatePicker/VDatePicker.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VDatePicker/VDatePicker.ts ***!
            \***************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VDatePickerTitle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VDatePickerTitle */
              "./src/components/VDatePicker/VDatePickerTitle.ts"
            );
            var _VDatePickerHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VDatePickerHeader */
              "./src/components/VDatePicker/VDatePickerHeader.ts"
            );
            var _VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VDatePickerDateTable */
              "./src/components/VDatePicker/VDatePickerDateTable.ts"
            );
            var _VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VDatePickerMonthTable */
              "./src/components/VDatePicker/VDatePickerMonthTable.ts"
            );
            var _VDatePickerYears__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./VDatePickerYears */
              "./src/components/VDatePicker/VDatePickerYears.ts"
            );
            var _mixins_localable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/localable */
              "./src/mixins/localable/index.ts"
            );
            var _mixins_picker__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/picker */
              "./src/mixins/picker/index.ts"
            );
            var _util_isDateAllowed__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ./util/isDateAllowed */
              "./src/components/VDatePicker/util/isDateAllowed.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _VCalendar_util_timestamp__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ../VCalendar/util/timestamp */
              "./src/components/VCalendar/util/timestamp.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
              /*! ./util */
              "./src/components/VDatePicker/util/index.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__["default"])(_mixins_localable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_picker__WEBPACK_IMPORTED_MODULE_6__["default"]).extend({
              name: "v-date-picker",
              props: {
                activePicker: String,
                allowedDates: Function,
                // Function formatting the day in date picker table
                dayFormat: Function,
                disabled: Boolean,
                events: {
                  type: [Array, Function, Object],
                  default: function _default() {
                    return null;
                  }
                },
                eventColor: {
                  type: [Array, Function, Object, String],
                  default: function _default() {
                    return "warning";
                  }
                },
                firstDayOfWeek: {
                  type: [String, Number],
                  default: 0
                },
                // Function formatting the tableDate in the day/month table header
                headerDateFormat: Function,
                localeFirstDayOfYear: {
                  type: [String, Number],
                  default: 0
                },
                max: String,
                min: String,
                // Function formatting month in the months table
                monthFormat: Function,
                multiple: Boolean,
                nextIcon: {
                  type: String,
                  default: "$next"
                },
                nextMonthAriaLabel: {
                  type: String,
                  default: "$vuetify.datePicker.nextMonthAriaLabel"
                },
                nextYearAriaLabel: {
                  type: String,
                  default: "$vuetify.datePicker.nextYearAriaLabel"
                },
                pickerDate: String,
                prevIcon: {
                  type: String,
                  default: "$prev"
                },
                prevMonthAriaLabel: {
                  type: String,
                  default: "$vuetify.datePicker.prevMonthAriaLabel"
                },
                prevYearAriaLabel: {
                  type: String,
                  default: "$vuetify.datePicker.prevYearAriaLabel"
                },
                range: Boolean,
                reactive: Boolean,
                readonly: Boolean,
                scrollable: Boolean,
                showCurrent: {
                  type: [Boolean, String],
                  default: true
                },
                selectedItemsText: {
                  type: String,
                  default: "$vuetify.datePicker.itemsSelected"
                },
                showAdjacentMonths: Boolean,
                showWeek: Boolean,
                // Function formatting currently selected date in the picker title
                titleDateFormat: Function,
                type: {
                  type: String,
                  default: "date",
                  validator: function validator2(type) {
                    return ["date", "month"].includes(type);
                  }
                  // TODO: year
                },
                value: [Array, String],
                weekdayFormat: Function,
                // Function formatting the year in table header and pickup title
                yearFormat: Function,
                yearIcon: String
              },
              data: function data() {
                var _this2 = this;
                var now2 = /* @__PURE__ */ new Date();
                return {
                  internalActivePicker: this.type.toUpperCase(),
                  inputDay: null,
                  inputMonth: null,
                  inputYear: null,
                  isReversing: false,
                  now: now2,
                  // tableDate is a string in 'YYYY' / 'YYYY-M' format (leading zero for month is not required)
                  tableDate: function() {
                    if (_this2.pickerDate) {
                      return _this2.pickerDate;
                    }
                    var multipleValue = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["wrapInArray"])(_this2.value);
                    var date = multipleValue[multipleValue.length - 1] || (typeof _this2.showCurrent === "string" ? _this2.showCurrent : now2.getFullYear() + "-" + (now2.getMonth() + 1));
                    return Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(date, _this2.type === "date" ? "month" : "year");
                  }()
                };
              },
              computed: {
                multipleValue: function multipleValue() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["wrapInArray"])(this.value);
                },
                isMultiple: function isMultiple() {
                  return this.multiple || this.range;
                },
                lastValue: function lastValue() {
                  return this.isMultiple ? this.multipleValue[this.multipleValue.length - 1] : this.value;
                },
                selectedMonths: function selectedMonths() {
                  if (!this.value || this.type === "month") {
                    return this.value;
                  } else if (this.isMultiple) {
                    return this.multipleValue.map(function(val) {
                      return val.substr(0, 7);
                    });
                  } else {
                    return this.value.substr(0, 7);
                  }
                },
                current: function current() {
                  if (this.showCurrent === true) {
                    return Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(this.now.getFullYear() + "-" + (this.now.getMonth() + 1) + "-" + this.now.getDate(), this.type);
                  }
                  return this.showCurrent || null;
                },
                inputDate: function inputDate() {
                  return this.type === "date" ? this.inputYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_12__["pad"])(this.inputMonth + 1) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_12__["pad"])(this.inputDay) : this.inputYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_12__["pad"])(this.inputMonth + 1);
                },
                tableMonth: function tableMonth() {
                  return Number((this.pickerDate || this.tableDate).split("-")[1]) - 1;
                },
                tableYear: function tableYear() {
                  return Number((this.pickerDate || this.tableDate).split("-")[0]);
                },
                minMonth: function minMonth() {
                  return this.min ? Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(this.min, "month") : null;
                },
                maxMonth: function maxMonth() {
                  return this.max ? Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(this.max, "month") : null;
                },
                minYear: function minYear() {
                  return this.min ? Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(this.min, "year") : null;
                },
                maxYear: function maxYear() {
                  return this.max ? Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(this.max, "year") : null;
                },
                formatters: function formatters() {
                  return {
                    year: this.yearFormat || Object(_util__WEBPACK_IMPORTED_MODULE_12__["createNativeLocaleFormatter"])(this.currentLocale, {
                      year: "numeric",
                      timeZone: "UTC"
                    }, {
                      length: 4
                    }),
                    titleDate: this.titleDateFormat || (this.isMultiple ? this.defaultTitleMultipleDateFormatter : this.defaultTitleDateFormatter)
                  };
                },
                defaultTitleMultipleDateFormatter: function defaultTitleMultipleDateFormatter() {
                  var _this2 = this;
                  return function(dates) {
                    if (!dates.length) {
                      return "-";
                    }
                    if (dates.length === 1) {
                      return _this2.defaultTitleDateFormatter(dates[0]);
                    }
                    return _this2.$vuetify.lang.t(_this2.selectedItemsText, dates.length);
                  };
                },
                defaultTitleDateFormatter: function defaultTitleDateFormatter() {
                  var titleFormats = {
                    year: {
                      year: "numeric",
                      timeZone: "UTC"
                    },
                    month: {
                      month: "long",
                      timeZone: "UTC"
                    },
                    date: {
                      weekday: "short",
                      month: "short",
                      day: "numeric",
                      timeZone: "UTC"
                    }
                  };
                  var titleDateFormatter = Object(_util__WEBPACK_IMPORTED_MODULE_12__["createNativeLocaleFormatter"])(this.currentLocale, titleFormats[this.type], {
                    start: 0,
                    length: {
                      date: 10,
                      month: 7,
                      year: 4
                    }[this.type]
                  });
                  var landscapeFormatter = function landscapeFormatter2(date) {
                    return titleDateFormatter(date).replace(/([^\d\s])([\d])/g, function(match, nonDigit, digit) {
                      return nonDigit + " " + digit;
                    }).replace(", ", ",<br>");
                  };
                  return this.landscape ? landscapeFormatter : titleDateFormatter;
                }
              },
              watch: {
                internalActivePicker: {
                  immediate: true,
                  handler: function handler(val) {
                    this.$emit("update:active-picker", val);
                  }
                },
                activePicker: function activePicker(val) {
                  this.internalActivePicker = val;
                },
                tableDate: function tableDate(val, prev) {
                  var sanitizeType = this.type === "month" ? "year" : "month";
                  this.isReversing = Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(val, sanitizeType) < Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(prev, sanitizeType);
                  this.$emit("update:picker-date", val);
                },
                pickerDate: function pickerDate(val) {
                  if (val) {
                    this.tableDate = val;
                  } else if (this.lastValue && this.type === "date") {
                    this.tableDate = Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(this.lastValue, "month");
                  } else if (this.lastValue && this.type === "month") {
                    this.tableDate = Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(this.lastValue, "year");
                  }
                },
                value: function value(newValue, oldValue) {
                  this.checkMultipleProp();
                  this.setInputDate();
                  if (!this.isMultiple && this.value && !this.pickerDate || this.isMultiple && this.multipleValue.length && (!oldValue || !oldValue.length) && !this.pickerDate) {
                    this.tableDate = Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(this.inputDate, this.type === "month" ? "year" : "month");
                  }
                },
                type: function type(_type) {
                  this.internalActivePicker = _type.toUpperCase();
                  if (this.value && this.value.length) {
                    var output = this.multipleValue.map(function(val) {
                      return Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(val, _type);
                    }).filter(this.isDateAllowed);
                    this.$emit("input", this.isMultiple ? output : output[0]);
                  }
                }
              },
              created: function created2() {
                this.checkMultipleProp();
                if (this.pickerDate !== this.tableDate) {
                  this.$emit("update:picker-date", this.tableDate);
                }
                this.setInputDate();
              },
              methods: {
                emitInput: function emitInput(newInput) {
                  if (this.range) {
                    if (this.multipleValue.length !== 1) {
                      this.$emit("input", [newInput]);
                    } else {
                      var output_1 = [this.multipleValue[0], newInput];
                      this.$emit("input", output_1);
                      this.$emit("change", output_1);
                    }
                    return;
                  }
                  var output = this.multiple ? this.multipleValue.indexOf(newInput) === -1 ? this.multipleValue.concat([newInput]) : this.multipleValue.filter(function(x2) {
                    return x2 !== newInput;
                  }) : newInput;
                  this.$emit("input", output);
                  this.multiple || this.$emit("change", newInput);
                },
                checkMultipleProp: function checkMultipleProp() {
                  if (this.value == null)
                    return;
                  var valueType = this.value.constructor.name;
                  var expected = this.isMultiple ? "Array" : "String";
                  if (valueType !== expected) {
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_11__["consoleWarn"])("Value must be " + (this.isMultiple ? "an" : "a") + " " + expected + ", got " + valueType, this);
                  }
                },
                isDateAllowed: function isDateAllowed(value) {
                  return Object(_util_isDateAllowed__WEBPACK_IMPORTED_MODULE_7__["default"])(value, this.min, this.max, this.allowedDates);
                },
                yearClick: function yearClick(value) {
                  this.inputYear = value;
                  if (this.type === "month") {
                    this.tableDate = "" + value;
                  } else {
                    this.tableDate = value + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_12__["pad"])((this.tableMonth || 0) + 1);
                  }
                  this.internalActivePicker = "MONTH";
                  if (this.reactive && !this.readonly && !this.isMultiple && this.isDateAllowed(this.inputDate)) {
                    this.$emit("input", this.inputDate);
                  }
                },
                monthClick: function monthClick(value) {
                  var _a2 = __read2(value.split("-"), 2), year = _a2[0], month = _a2[1];
                  this.inputYear = parseInt(year, 10);
                  this.inputMonth = parseInt(month, 10) - 1;
                  if (this.type === "date") {
                    if (this.inputDay) {
                      this.inputDay = Math.min(this.inputDay, Object(_VCalendar_util_timestamp__WEBPACK_IMPORTED_MODULE_10__["daysInMonth"])(this.inputYear, this.inputMonth + 1));
                    }
                    this.tableDate = value;
                    this.internalActivePicker = "DATE";
                    if (this.reactive && !this.readonly && !this.isMultiple && this.isDateAllowed(this.inputDate)) {
                      this.$emit("input", this.inputDate);
                    }
                  } else {
                    this.emitInput(this.inputDate);
                  }
                },
                dateClick: function dateClick(value) {
                  var _a2 = __read2(value.split("-"), 3), year = _a2[0], month = _a2[1], day = _a2[2];
                  this.inputYear = parseInt(year, 10);
                  this.inputMonth = parseInt(month, 10) - 1;
                  this.inputDay = parseInt(day, 10);
                  this.emitInput(this.inputDate);
                },
                genPickerTitle: function genPickerTitle() {
                  var _this2 = this;
                  return this.$createElement(_VDatePickerTitle__WEBPACK_IMPORTED_MODULE_0__["default"], {
                    props: {
                      date: this.value ? this.formatters.titleDate(this.isMultiple ? this.multipleValue : this.value) : "",
                      disabled: this.disabled,
                      readonly: this.readonly,
                      selectingYear: this.internalActivePicker === "YEAR",
                      year: this.formatters.year(this.multipleValue.length ? "" + this.inputYear : this.tableDate),
                      yearIcon: this.yearIcon,
                      value: this.multipleValue[0]
                    },
                    slot: "title",
                    on: {
                      "update:selecting-year": function updateSelectingYear(value) {
                        return _this2.internalActivePicker = value ? "YEAR" : _this2.type.toUpperCase();
                      }
                    }
                  });
                },
                genTableHeader: function genTableHeader() {
                  var _this2 = this;
                  return this.$createElement(_VDatePickerHeader__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: {
                      nextIcon: this.nextIcon,
                      color: this.color,
                      dark: this.dark,
                      disabled: this.disabled,
                      format: this.headerDateFormat,
                      light: this.light,
                      locale: this.locale,
                      min: this.internalActivePicker === "DATE" ? this.minMonth : this.minYear,
                      max: this.internalActivePicker === "DATE" ? this.maxMonth : this.maxYear,
                      nextAriaLabel: this.internalActivePicker === "DATE" ? this.nextMonthAriaLabel : this.nextYearAriaLabel,
                      prevAriaLabel: this.internalActivePicker === "DATE" ? this.prevMonthAriaLabel : this.prevYearAriaLabel,
                      prevIcon: this.prevIcon,
                      readonly: this.readonly,
                      value: this.internalActivePicker === "DATE" ? Object(_util__WEBPACK_IMPORTED_MODULE_12__["pad"])(this.tableYear, 4) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_12__["pad"])(this.tableMonth + 1) : "" + Object(_util__WEBPACK_IMPORTED_MODULE_12__["pad"])(this.tableYear, 4)
                    },
                    on: {
                      toggle: function toggle() {
                        return _this2.internalActivePicker = _this2.internalActivePicker === "DATE" ? "MONTH" : "YEAR";
                      },
                      input: function input2(value) {
                        return _this2.tableDate = value;
                      }
                    }
                  });
                },
                genDateTable: function genDateTable() {
                  var _this2 = this;
                  return this.$createElement(_VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    props: {
                      allowedDates: this.allowedDates,
                      color: this.color,
                      current: this.current,
                      dark: this.dark,
                      disabled: this.disabled,
                      events: this.events,
                      eventColor: this.eventColor,
                      firstDayOfWeek: this.firstDayOfWeek,
                      format: this.dayFormat,
                      light: this.light,
                      locale: this.locale,
                      localeFirstDayOfYear: this.localeFirstDayOfYear,
                      min: this.min,
                      max: this.max,
                      range: this.range,
                      readonly: this.readonly,
                      scrollable: this.scrollable,
                      showAdjacentMonths: this.showAdjacentMonths,
                      showWeek: this.showWeek,
                      tableDate: Object(_util__WEBPACK_IMPORTED_MODULE_12__["pad"])(this.tableYear, 4) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_12__["pad"])(this.tableMonth + 1),
                      value: this.value,
                      weekdayFormat: this.weekdayFormat
                    },
                    ref: "table",
                    on: __assign2({
                      input: this.dateClick,
                      "update:table-date": function updateTableDate(value) {
                        return _this2.tableDate = value;
                      }
                    }, Object(_util__WEBPACK_IMPORTED_MODULE_12__["createItemTypeListeners"])(this, ":date"))
                  });
                },
                genMonthTable: function genMonthTable() {
                  var _this2 = this;
                  return this.$createElement(_VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    props: {
                      allowedDates: this.type === "month" ? this.allowedDates : null,
                      color: this.color,
                      current: this.current ? Object(_util__WEBPACK_IMPORTED_MODULE_12__["sanitizeDateString"])(this.current, "month") : null,
                      dark: this.dark,
                      disabled: this.disabled,
                      events: this.type === "month" ? this.events : null,
                      eventColor: this.type === "month" ? this.eventColor : null,
                      format: this.monthFormat,
                      light: this.light,
                      locale: this.locale,
                      min: this.minMonth,
                      max: this.maxMonth,
                      range: this.range,
                      readonly: this.readonly && this.type === "month",
                      scrollable: this.scrollable,
                      value: this.selectedMonths,
                      tableDate: "" + Object(_util__WEBPACK_IMPORTED_MODULE_12__["pad"])(this.tableYear, 4)
                    },
                    ref: "table",
                    on: __assign2({
                      input: this.monthClick,
                      "update:table-date": function updateTableDate(value) {
                        return _this2.tableDate = value;
                      }
                    }, Object(_util__WEBPACK_IMPORTED_MODULE_12__["createItemTypeListeners"])(this, ":month"))
                  });
                },
                genYears: function genYears() {
                  return this.$createElement(_VDatePickerYears__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    props: {
                      color: this.color,
                      format: this.yearFormat,
                      locale: this.locale,
                      min: this.minYear,
                      max: this.maxYear,
                      value: this.tableYear
                    },
                    on: __assign2({
                      input: this.yearClick
                    }, Object(_util__WEBPACK_IMPORTED_MODULE_12__["createItemTypeListeners"])(this, ":year"))
                  });
                },
                genPickerBody: function genPickerBody() {
                  var children = this.internalActivePicker === "YEAR" ? [this.genYears()] : [this.genTableHeader(), this.internalActivePicker === "DATE" ? this.genDateTable() : this.genMonthTable()];
                  return this.$createElement("div", {
                    key: this.internalActivePicker
                  }, children);
                },
                setInputDate: function setInputDate() {
                  if (this.lastValue) {
                    var array = this.lastValue.split("-");
                    this.inputYear = parseInt(array[0], 10);
                    this.inputMonth = parseInt(array[1], 10) - 1;
                    if (this.type === "date") {
                      this.inputDay = parseInt(array[2], 10);
                    }
                  } else {
                    this.inputYear = this.inputYear || this.now.getFullYear();
                    this.inputMonth = this.inputMonth == null ? this.inputMonth : this.now.getMonth();
                    this.inputDay = this.inputDay || this.now.getDate();
                  }
                }
              },
              render: function render8() {
                return this.genPicker("v-picker--date");
              }
            });
          }
        ),
        /***/
        "./src/components/VDatePicker/VDatePickerDateTable.ts": (
          /*!************************************************************!*\
            !*** ./src/components/VDatePicker/VDatePickerDateTable.ts ***!
            \************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_date_picker_table__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./mixins/date-picker-table */
              "./src/components/VDatePicker/mixins/date-picker-table.ts"
            );
            var _util_dateTimeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/dateTimeUtils */
              "./src/util/dateTimeUtils.ts"
            );
            var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./util */
              "./src/components/VDatePicker/util/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(
              _mixins_date_picker_table__WEBPACK_IMPORTED_MODULE_0__["default"]
              /* @vue/component */
            ).extend({
              name: "v-date-picker-date-table",
              props: {
                firstDayOfWeek: {
                  type: [String, Number],
                  default: 0
                },
                localeFirstDayOfYear: {
                  type: [String, Number],
                  default: 0
                },
                showAdjacentMonths: Boolean,
                showWeek: Boolean,
                weekdayFormat: Function
              },
              computed: {
                formatter: function formatter() {
                  return this.format || Object(_util__WEBPACK_IMPORTED_MODULE_2__["createNativeLocaleFormatter"])(this.currentLocale, {
                    day: "numeric",
                    timeZone: "UTC"
                  }, {
                    start: 8,
                    length: 2
                  });
                },
                weekdayFormatter: function weekdayFormatter() {
                  return this.weekdayFormat || Object(_util__WEBPACK_IMPORTED_MODULE_2__["createNativeLocaleFormatter"])(this.currentLocale, {
                    weekday: "narrow",
                    timeZone: "UTC"
                  });
                },
                weekDays: function weekDays() {
                  var _this2 = this;
                  var first = parseInt(this.firstDayOfWeek, 10);
                  return this.weekdayFormatter ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["createRange"])(7).map(function(i2) {
                    return _this2.weekdayFormatter("2017-01-" + (first + i2 + 15));
                  }) : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["createRange"])(7).map(function(i2) {
                    return ["S", "M", "T", "W", "T", "F", "S"][(i2 + first) % 7];
                  });
                }
              },
              methods: {
                calculateTableDate: function calculateTableDate(delta) {
                  return Object(_util__WEBPACK_IMPORTED_MODULE_2__["monthChange"])(this.tableDate, Math.sign(delta || 1));
                },
                genTHead: function genTHead() {
                  var _this2 = this;
                  var days = this.weekDays.map(function(day) {
                    return _this2.$createElement("th", day);
                  });
                  if (this.showWeek) {
                    days.unshift(this.$createElement("th"));
                  }
                  return this.$createElement("thead", this.genTR(days));
                },
                // Returns number of the days from the firstDayOfWeek to the first day of the current month
                weekDaysBeforeFirstDayOfTheMonth: function weekDaysBeforeFirstDayOfTheMonth() {
                  var firstDayOfTheMonth = /* @__PURE__ */ new Date(this.displayedYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(this.displayedMonth + 1) + "-01T00:00:00+00:00");
                  var weekDay = firstDayOfTheMonth.getUTCDay();
                  return (weekDay - parseInt(this.firstDayOfWeek) + 7) % 7;
                },
                getWeekNumber: function getWeekNumber(dayInMonth) {
                  return Object(_util_dateTimeUtils__WEBPACK_IMPORTED_MODULE_1__["weekNumber"])(this.displayedYear, this.displayedMonth, dayInMonth, parseInt(this.firstDayOfWeek), parseInt(this.localeFirstDayOfYear));
                },
                genWeekNumber: function genWeekNumber(weekNumber) {
                  return this.$createElement("td", [this.$createElement("small", {
                    staticClass: "v-date-picker-table--date__week"
                  }, String(weekNumber).padStart(2, "0"))]);
                },
                // eslint-disable-next-line max-statements
                genTBody: function genTBody() {
                  var children = [];
                  var daysInMonth = new Date(this.displayedYear, this.displayedMonth + 1, 0).getDate();
                  var rows = [];
                  var day = this.weekDaysBeforeFirstDayOfTheMonth();
                  if (this.showWeek) {
                    rows.push(this.genWeekNumber(this.getWeekNumber(1)));
                  }
                  var prevMonthYear = this.displayedMonth ? this.displayedYear : this.displayedYear - 1;
                  var prevMonth = (this.displayedMonth + 11) % 12;
                  var firstDayFromPreviousMonth = new Date(this.displayedYear, this.displayedMonth, 0).getDate();
                  var cellsInRow = this.showWeek ? 8 : 7;
                  while (day--) {
                    var date = prevMonthYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(prevMonth + 1) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(firstDayFromPreviousMonth - day);
                    rows.push(this.$createElement("td", this.showAdjacentMonths ? [this.genButton(date, true, "date", this.formatter, true)] : []));
                  }
                  for (day = 1; day <= daysInMonth; day++) {
                    var date = this.displayedYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(this.displayedMonth + 1) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(day);
                    rows.push(this.$createElement("td", [this.genButton(date, true, "date", this.formatter)]));
                    if (rows.length % cellsInRow === 0) {
                      children.push(this.genTR(rows));
                      rows = [];
                      if (this.showWeek && (day < daysInMonth || this.showAdjacentMonths)) {
                        rows.push(this.genWeekNumber(this.getWeekNumber(day + 7)));
                      }
                    }
                  }
                  var nextMonthYear = this.displayedMonth === 11 ? this.displayedYear + 1 : this.displayedYear;
                  var nextMonth = (this.displayedMonth + 1) % 12;
                  var nextMonthDay = 1;
                  while (rows.length < cellsInRow) {
                    var date = nextMonthYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(nextMonth + 1) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(nextMonthDay++);
                    rows.push(this.$createElement("td", this.showAdjacentMonths ? [this.genButton(date, true, "date", this.formatter, true)] : []));
                  }
                  if (rows.length) {
                    children.push(this.genTR(rows));
                  }
                  return this.$createElement("tbody", children);
                },
                genTR: function genTR(children) {
                  return [this.$createElement("tr", children)];
                }
              },
              render: function render8() {
                return this.genTable("v-date-picker-table v-date-picker-table--date", [this.genTHead(), this.genTBody()], this.calculateTableDate);
              }
            });
          }
        ),
        /***/
        "./src/components/VDatePicker/VDatePickerHeader.sass": (
          /*!***********************************************************!*\
            !*** ./src/components/VDatePicker/VDatePickerHeader.sass ***!
            \***********************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VDatePicker/VDatePickerHeader.ts": (
          /*!*********************************************************!*\
            !*** ./src/components/VDatePicker/VDatePickerHeader.ts ***!
            \*********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VDatePickerHeader.sass */
              "./src/components/VDatePicker/VDatePickerHeader.sass"
            );
            var _VBtn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VBtn */
              "./src/components/VBtn/index.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_localable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/localable */
              "./src/mixins/localable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ./util */
              "./src/components/VDatePicker/util/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_7__["default"])(
              _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"],
              _mixins_localable__WEBPACK_IMPORTED_MODULE_4__["default"],
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__["default"]
              /* @vue/component */
            ).extend({
              name: "v-date-picker-header",
              props: {
                disabled: Boolean,
                format: Function,
                min: String,
                max: String,
                nextAriaLabel: String,
                nextIcon: {
                  type: String,
                  default: "$next"
                },
                prevAriaLabel: String,
                prevIcon: {
                  type: String,
                  default: "$prev"
                },
                readonly: Boolean,
                value: {
                  type: [Number, String],
                  required: true
                }
              },
              data: function data() {
                return {
                  isReversing: false
                };
              },
              computed: {
                formatter: function formatter() {
                  if (this.format) {
                    return this.format;
                  } else if (String(this.value).split("-")[1]) {
                    return Object(_util__WEBPACK_IMPORTED_MODULE_6__["createNativeLocaleFormatter"])(this.currentLocale, {
                      month: "long",
                      year: "numeric",
                      timeZone: "UTC"
                    }, {
                      length: 7
                    });
                  } else {
                    return Object(_util__WEBPACK_IMPORTED_MODULE_6__["createNativeLocaleFormatter"])(this.currentLocale, {
                      year: "numeric",
                      timeZone: "UTC"
                    }, {
                      length: 4
                    });
                  }
                }
              },
              watch: {
                value: function value(newVal, oldVal) {
                  this.isReversing = newVal < oldVal;
                }
              },
              methods: {
                genBtn: function genBtn(change) {
                  var _this2 = this;
                  var ariaLabelId = change > 0 ? this.nextAriaLabel : this.prevAriaLabel;
                  var ariaLabel = ariaLabelId ? this.$vuetify.lang.t(ariaLabelId) : void 0;
                  var disabled = this.disabled || change < 0 && this.min && this.calculateChange(change) < this.min || change > 0 && this.max && this.calculateChange(change) > this.max;
                  return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    attrs: {
                      "aria-label": ariaLabel
                    },
                    props: {
                      dark: this.dark,
                      disabled,
                      icon: true,
                      light: this.light
                    },
                    on: {
                      click: function click2(e) {
                        e.stopPropagation();
                        _this2.$emit("input", _this2.calculateChange(change));
                      }
                    }
                  }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], change < 0 === !this.$vuetify.rtl ? this.prevIcon : this.nextIcon)]);
                },
                calculateChange: function calculateChange(sign) {
                  var _a2 = __read2(String(this.value).split("-").map(Number), 2), year = _a2[0], month = _a2[1];
                  if (month == null) {
                    return "" + (year + sign);
                  } else {
                    return Object(_util__WEBPACK_IMPORTED_MODULE_6__["monthChange"])(String(this.value), sign);
                  }
                },
                genHeader: function genHeader() {
                  var _this2 = this;
                  var color2 = !this.disabled && (this.color || "accent");
                  var header = this.$createElement("div", this.setTextColor(color2, {
                    key: String(this.value)
                  }), [this.$createElement("button", {
                    attrs: {
                      type: "button"
                    },
                    on: {
                      click: function click2() {
                        return _this2.$emit("toggle");
                      }
                    }
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getSlot"])(this) || [this.formatter(String(this.value))])]);
                  var transition2 = this.$createElement("transition", {
                    props: {
                      name: this.isReversing === !this.$vuetify.rtl ? "tab-reverse-transition" : "tab-transition"
                    }
                  }, [header]);
                  return this.$createElement("div", {
                    staticClass: "v-date-picker-header__value",
                    class: {
                      "v-date-picker-header__value--disabled": this.disabled
                    }
                  }, [transition2]);
                }
              },
              render: function render8() {
                return this.$createElement("div", {
                  staticClass: "v-date-picker-header",
                  class: __assign2({
                    "v-date-picker-header--disabled": this.disabled
                  }, this.themeClasses)
                }, [this.genBtn(-1), this.genHeader(), this.genBtn(1)]);
              }
            });
          }
        ),
        /***/
        "./src/components/VDatePicker/VDatePickerMonthTable.ts": (
          /*!*************************************************************!*\
            !*** ./src/components/VDatePicker/VDatePickerMonthTable.ts ***!
            \*************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_date_picker_table__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./mixins/date-picker-table */
              "./src/components/VDatePicker/mixins/date-picker-table.ts"
            );
            var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./util */
              "./src/components/VDatePicker/util/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(
              _mixins_date_picker_table__WEBPACK_IMPORTED_MODULE_0__["default"]
              /* @vue/component */
            ).extend({
              name: "v-date-picker-month-table",
              computed: {
                formatter: function formatter() {
                  return this.format || Object(_util__WEBPACK_IMPORTED_MODULE_1__["createNativeLocaleFormatter"])(this.currentLocale, {
                    month: "short",
                    timeZone: "UTC"
                  }, {
                    start: 5,
                    length: 2
                  });
                }
              },
              methods: {
                calculateTableDate: function calculateTableDate(delta) {
                  return "" + (parseInt(this.tableDate, 10) + Math.sign(delta || 1));
                },
                genTBody: function genTBody() {
                  var _this2 = this;
                  var children = [];
                  var cols = Array(3).fill(null);
                  var rows = 12 / cols.length;
                  var _loop_1 = function _loop_12(row2) {
                    var tds = cols.map(function(_, col) {
                      var month = row2 * cols.length + col;
                      var date = _this2.displayedYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_1__["pad"])(month + 1);
                      return _this2.$createElement("td", {
                        key: month
                      }, [_this2.genButton(date, false, "month", _this2.formatter)]);
                    });
                    children.push(this_1.$createElement("tr", {
                      key: row2
                    }, tds));
                  };
                  var this_1 = this;
                  for (var row = 0; row < rows; row++) {
                    _loop_1(row);
                  }
                  return this.$createElement("tbody", children);
                }
              },
              render: function render8() {
                return this.genTable("v-date-picker-table v-date-picker-table--month", [this.genTBody()], this.calculateTableDate);
              }
            });
          }
        ),
        /***/
        "./src/components/VDatePicker/VDatePickerTable.sass": (
          /*!**********************************************************!*\
            !*** ./src/components/VDatePicker/VDatePickerTable.sass ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VDatePicker/VDatePickerTitle.sass": (
          /*!**********************************************************!*\
            !*** ./src/components/VDatePicker/VDatePickerTitle.sass ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VDatePicker/VDatePickerTitle.ts": (
          /*!********************************************************!*\
            !*** ./src/components/VDatePicker/VDatePickerTitle.ts ***!
            \********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VDatePickerTitle.sass */
              "./src/components/VDatePicker/VDatePickerTitle.sass"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _mixins_picker_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/picker-button */
              "./src/mixins/picker-button/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(
              _mixins_picker_button__WEBPACK_IMPORTED_MODULE_2__["default"]
              /* @vue/component */
            ).extend({
              name: "v-date-picker-title",
              props: {
                date: {
                  type: String,
                  default: ""
                },
                disabled: Boolean,
                readonly: Boolean,
                selectingYear: Boolean,
                value: {
                  type: String
                },
                year: {
                  type: [Number, String],
                  default: ""
                },
                yearIcon: {
                  type: String
                }
              },
              data: function data() {
                return {
                  isReversing: false
                };
              },
              computed: {
                computedTransition: function computedTransition() {
                  return this.isReversing ? "picker-reverse-transition" : "picker-transition";
                }
              },
              watch: {
                value: function value(val, prev) {
                  this.isReversing = val < prev;
                }
              },
              methods: {
                genYearIcon: function genYearIcon() {
                  return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: {
                      dark: true
                    }
                  }, this.yearIcon);
                },
                getYearBtn: function getYearBtn() {
                  return this.genPickerButton("selectingYear", true, [String(this.year), this.yearIcon ? this.genYearIcon() : null], false, "v-date-picker-title__year");
                },
                genTitleText: function genTitleText() {
                  return this.$createElement("transition", {
                    props: {
                      name: this.computedTransition
                    }
                  }, [this.$createElement("div", {
                    domProps: {
                      innerHTML: this.date || "&nbsp;"
                    },
                    key: this.value
                  })]);
                },
                genTitleDate: function genTitleDate() {
                  return this.genPickerButton("selectingYear", false, [this.genTitleText()], false, "v-date-picker-title__date");
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-date-picker-title",
                  class: {
                    "v-date-picker-title--disabled": this.disabled
                  }
                }, [this.getYearBtn(), this.genTitleDate()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VDatePicker/VDatePickerYears.sass": (
          /*!**********************************************************!*\
            !*** ./src/components/VDatePicker/VDatePickerYears.sass ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VDatePicker/VDatePickerYears.ts": (
          /*!********************************************************!*\
            !*** ./src/components/VDatePicker/VDatePickerYears.ts ***!
            \********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VDatePickerYears.sass */
              "./src/components/VDatePicker/VDatePickerYears.sass"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_localable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/localable */
              "./src/mixins/localable/index.ts"
            );
            var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./util */
              "./src/components/VDatePicker/util/index.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(
              _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"],
              _mixins_localable__WEBPACK_IMPORTED_MODULE_2__["default"]
              /* @vue/component */
            ).extend({
              name: "v-date-picker-years",
              props: {
                format: Function,
                min: [Number, String],
                max: [Number, String],
                readonly: Boolean,
                value: [Number, String]
              },
              data: function data() {
                return {
                  defaultColor: "primary"
                };
              },
              computed: {
                formatter: function formatter() {
                  return this.format || Object(_util__WEBPACK_IMPORTED_MODULE_3__["createNativeLocaleFormatter"])(this.currentLocale, {
                    year: "numeric",
                    timeZone: "UTC"
                  }, {
                    length: 4
                  });
                }
              },
              mounted: function mounted3() {
                var _this2 = this;
                setTimeout(function() {
                  var activeItem = _this2.$el.getElementsByClassName("active")[0];
                  if (activeItem) {
                    _this2.$el.scrollTop = activeItem.offsetTop - _this2.$el.offsetHeight / 2 + activeItem.offsetHeight / 2;
                  } else if (_this2.min && !_this2.max) {
                    _this2.$el.scrollTop = _this2.$el.scrollHeight;
                  } else if (!_this2.min && _this2.max) {
                    _this2.$el.scrollTop = 0;
                  } else {
                    _this2.$el.scrollTop = _this2.$el.scrollHeight / 2 - _this2.$el.offsetHeight / 2;
                  }
                });
              },
              methods: {
                genYearItem: function genYearItem(year) {
                  var _this2 = this;
                  var formatted = this.formatter("" + year);
                  var active = parseInt(this.value, 10) === year;
                  var color2 = active && (this.color || "primary");
                  return this.$createElement("li", this.setTextColor(color2, {
                    key: year,
                    class: {
                      active
                    },
                    on: Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_4__["mergeListeners"])({
                      click: function click2() {
                        return _this2.$emit("input", year);
                      }
                    }, Object(_util__WEBPACK_IMPORTED_MODULE_3__["createItemTypeNativeListeners"])(this, ":year", year))
                  }), formatted);
                },
                genYearItems: function genYearItems() {
                  var children = [];
                  var selectedYear = this.value ? parseInt(this.value, 10) : (/* @__PURE__ */ new Date()).getFullYear();
                  var maxYear = this.max ? parseInt(this.max, 10) : selectedYear + 100;
                  var minYear = Math.min(maxYear, this.min ? parseInt(this.min, 10) : selectedYear - 100);
                  for (var year = maxYear; year >= minYear; year--) {
                    children.push(this.genYearItem(year));
                  }
                  return children;
                }
              },
              render: function render8() {
                return this.$createElement("ul", {
                  staticClass: "v-date-picker-years",
                  ref: "years"
                }, this.genYearItems());
              }
            });
          }
        ),
        /***/
        "./src/components/VDatePicker/index.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VDatePicker/index.ts ***!
            \*********************************************/
          /*! exports provided: VDatePicker, VDatePickerTitle, VDatePickerHeader, VDatePickerDateTable, VDatePickerMonthTable, VDatePickerYears, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VDatePicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VDatePicker */
              "./src/components/VDatePicker/VDatePicker.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDatePicker", function() {
              return _VDatePicker__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VDatePickerTitle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VDatePickerTitle */
              "./src/components/VDatePicker/VDatePickerTitle.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDatePickerTitle", function() {
              return _VDatePickerTitle__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _VDatePickerHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VDatePickerHeader */
              "./src/components/VDatePicker/VDatePickerHeader.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDatePickerHeader", function() {
              return _VDatePickerHeader__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            var _VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VDatePickerDateTable */
              "./src/components/VDatePicker/VDatePickerDateTable.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDatePickerDateTable", function() {
              return _VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_3__["default"];
            });
            var _VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./VDatePickerMonthTable */
              "./src/components/VDatePicker/VDatePickerMonthTable.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDatePickerMonthTable", function() {
              return _VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_4__["default"];
            });
            var _VDatePickerYears__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./VDatePickerYears */
              "./src/components/VDatePicker/VDatePickerYears.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDatePickerYears", function() {
              return _VDatePickerYears__WEBPACK_IMPORTED_MODULE_5__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VDatePicker: _VDatePicker__WEBPACK_IMPORTED_MODULE_0__["default"],
                VDatePickerTitle: _VDatePickerTitle__WEBPACK_IMPORTED_MODULE_1__["default"],
                VDatePickerHeader: _VDatePickerHeader__WEBPACK_IMPORTED_MODULE_2__["default"],
                VDatePickerDateTable: _VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_3__["default"],
                VDatePickerMonthTable: _VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_4__["default"],
                VDatePickerYears: _VDatePickerYears__WEBPACK_IMPORTED_MODULE_5__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VDatePicker/mixins/date-picker-table.ts": (
          /*!****************************************************************!*\
            !*** ./src/components/VDatePicker/mixins/date-picker-table.ts ***!
            \****************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ../VDatePickerTable.sass */
              "./src/components/VDatePicker/VDatePickerTable.sass"
            );
            var _directives_touch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../../directives/touch */
              "./src/directives/touch/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_localable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../../mixins/localable */
              "./src/mixins/localable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../util */
              "./src/components/VDatePicker/util/index.ts"
            );
            var _util_isDateAllowed__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../util/isDateAllowed */
              "./src/components/VDatePicker/util/isDateAllowed.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__["default"])(
              _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"],
              _mixins_localable__WEBPACK_IMPORTED_MODULE_3__["default"],
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__["default"]
              /* @vue/component */
            ).extend({
              directives: {
                Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_1__["default"]
              },
              props: {
                allowedDates: Function,
                current: String,
                disabled: Boolean,
                format: Function,
                events: {
                  type: [Array, Function, Object],
                  default: function _default() {
                    return null;
                  }
                },
                eventColor: {
                  type: [Array, Function, Object, String],
                  default: function _default() {
                    return "warning";
                  }
                },
                min: String,
                max: String,
                range: Boolean,
                readonly: Boolean,
                scrollable: Boolean,
                tableDate: {
                  type: String,
                  required: true
                },
                value: [String, Array]
              },
              data: function data() {
                return {
                  isReversing: false,
                  wheelThrottle: null
                };
              },
              computed: {
                computedTransition: function computedTransition() {
                  return this.isReversing === !this.$vuetify.rtl ? "tab-reverse-transition" : "tab-transition";
                },
                displayedMonth: function displayedMonth() {
                  return Number(this.tableDate.split("-")[1]) - 1;
                },
                displayedYear: function displayedYear() {
                  return Number(this.tableDate.split("-")[0]);
                }
              },
              watch: {
                tableDate: function tableDate(newVal, oldVal) {
                  this.isReversing = newVal < oldVal;
                }
              },
              mounted: function mounted3() {
                this.wheelThrottle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["throttle"])(this.wheel, 250);
              },
              methods: {
                genButtonClasses: function genButtonClasses(isAllowed, isFloating, isSelected, isCurrent, isFirst, isLast) {
                  return __assign2({
                    "v-size--default": !isFloating,
                    "v-date-picker-table__current": isCurrent,
                    "v-btn--active": isSelected,
                    "v-btn--flat": !isAllowed || this.disabled,
                    "v-btn--text": isSelected === isCurrent,
                    "v-btn--rounded": isFloating,
                    "v-btn--disabled": !isAllowed || this.disabled,
                    "v-btn--outlined": isCurrent && !isSelected,
                    "v-date-picker--first-in-range": isFirst,
                    "v-date-picker--last-in-range": isLast
                  }, this.themeClasses);
                },
                genButtonEvents: function genButtonEvents(value, isAllowed, mouseEventType) {
                  var _this2 = this;
                  if (this.disabled)
                    return void 0;
                  return Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_7__["mergeListeners"])({
                    click: function click2() {
                      if (isAllowed && !_this2.readonly)
                        _this2.$emit("input", value);
                    }
                  }, Object(_util__WEBPACK_IMPORTED_MODULE_5__["createItemTypeNativeListeners"])(this, ":" + mouseEventType, value));
                },
                genButton: function genButton(value, isFloating, mouseEventType, formatter, isOtherMonth) {
                  if (isOtherMonth === void 0) {
                    isOtherMonth = false;
                  }
                  var isAllowed = Object(_util_isDateAllowed__WEBPACK_IMPORTED_MODULE_6__["default"])(value, this.min, this.max, this.allowedDates);
                  var isSelected = this.isSelected(value) && isAllowed;
                  var isCurrent = value === this.current;
                  var setColor = isSelected ? this.setBackgroundColor : this.setTextColor;
                  var color2 = (isSelected || isCurrent) && (this.color || "accent");
                  var isFirst = false;
                  var isLast = false;
                  if (this.range && !!this.value && Array.isArray(this.value)) {
                    isFirst = value === this.value[0];
                    isLast = value === this.value[this.value.length - 1];
                  }
                  return this.$createElement("button", setColor(color2, {
                    staticClass: "v-btn",
                    class: this.genButtonClasses(isAllowed && !isOtherMonth, isFloating, isSelected, isCurrent, isFirst, isLast),
                    attrs: {
                      type: "button"
                    },
                    domProps: {
                      disabled: this.disabled || !isAllowed || isOtherMonth
                    },
                    on: this.genButtonEvents(value, isAllowed, mouseEventType)
                  }), [this.$createElement("div", {
                    staticClass: "v-btn__content"
                  }, [formatter(value)]), this.genEvents(value)]);
                },
                getEventColors: function getEventColors(date) {
                  var arrayize = function arrayize2(v) {
                    return Array.isArray(v) ? v : [v];
                  };
                  var eventData;
                  var eventColors = [];
                  if (Array.isArray(this.events)) {
                    eventData = this.events.includes(date);
                  } else if (this.events instanceof Function) {
                    eventData = this.events(date) || false;
                  } else if (this.events) {
                    eventData = this.events[date] || false;
                  } else {
                    eventData = false;
                  }
                  if (!eventData) {
                    return [];
                  } else if (eventData !== true) {
                    eventColors = arrayize(eventData);
                  } else if (typeof this.eventColor === "string") {
                    eventColors = [this.eventColor];
                  } else if (typeof this.eventColor === "function") {
                    eventColors = arrayize(this.eventColor(date));
                  } else if (Array.isArray(this.eventColor)) {
                    eventColors = this.eventColor;
                  } else {
                    eventColors = arrayize(this.eventColor[date]);
                  }
                  return eventColors.filter(function(v) {
                    return v;
                  });
                },
                genEvents: function genEvents(date) {
                  var _this2 = this;
                  var eventColors = this.getEventColors(date);
                  return eventColors.length ? this.$createElement("div", {
                    staticClass: "v-date-picker-table__events"
                  }, eventColors.map(function(color2) {
                    return _this2.$createElement("div", _this2.setBackgroundColor(color2));
                  })) : null;
                },
                isValidScroll: function isValidScroll(value, calculateTableDate) {
                  var tableDate = calculateTableDate(value);
                  var sanitizeType = tableDate.split("-").length === 1 ? "year" : "month";
                  return value < 0 && (this.min ? tableDate >= Object(_util__WEBPACK_IMPORTED_MODULE_5__["sanitizeDateString"])(this.min, sanitizeType) : true) || value > 0 && (this.max ? tableDate <= Object(_util__WEBPACK_IMPORTED_MODULE_5__["sanitizeDateString"])(this.max, sanitizeType) : true);
                },
                wheel: function wheel(e, calculateTableDate) {
                  this.$emit("update:table-date", calculateTableDate(e.deltaY));
                },
                touch: function touch(value, calculateTableDate) {
                  this.$emit("update:table-date", calculateTableDate(value));
                },
                genTable: function genTable(staticClass, children, calculateTableDate) {
                  var _this2 = this;
                  var transition2 = this.$createElement("transition", {
                    props: {
                      name: this.computedTransition
                    }
                  }, [this.$createElement("table", {
                    key: this.tableDate
                  }, children)]);
                  var touchDirective = {
                    name: "touch",
                    value: {
                      left: function left(e) {
                        return e.offsetX < -15 && _this2.isValidScroll(1, calculateTableDate) && _this2.touch(1, calculateTableDate);
                      },
                      right: function right(e) {
                        return e.offsetX > 15 && _this2.isValidScroll(-1, calculateTableDate) && _this2.touch(-1, calculateTableDate);
                      }
                    }
                  };
                  return this.$createElement("div", {
                    staticClass,
                    class: __assign2({
                      "v-date-picker-table--disabled": this.disabled
                    }, this.themeClasses),
                    on: !this.disabled && this.scrollable ? {
                      wheel: function wheel(e) {
                        e.preventDefault();
                        if (_this2.isValidScroll(e.deltaY, calculateTableDate)) {
                          _this2.wheelThrottle(e, calculateTableDate);
                        }
                      }
                    } : void 0,
                    directives: [touchDirective]
                  }, [transition2]);
                },
                isSelected: function isSelected(value) {
                  if (Array.isArray(this.value)) {
                    if (this.range && this.value.length === 2) {
                      var _a2 = __read2(__spreadArray2([], __read2(this.value), false).sort(), 2), from = _a2[0], to = _a2[1];
                      return from <= value && value <= to;
                    } else {
                      return this.value.indexOf(value) !== -1;
                    }
                  }
                  return value === this.value;
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VDatePicker/util/createNativeLocaleFormatter.ts": (
          /*!************************************************************************!*\
            !*** ./src/components/VDatePicker/util/createNativeLocaleFormatter.ts ***!
            \************************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _pad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./pad */
              "./src/components/VDatePicker/util/pad.ts"
            );
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            function createNativeLocaleFormatter(locale, options, substrOptions) {
              if (substrOptions === void 0) {
                substrOptions = {
                  start: 0,
                  length: 0
                };
              }
              var makeIsoString = function makeIsoString2(dateString) {
                var _a2 = __read2(dateString.trim().split(" ")[0].split("-"), 3), year = _a2[0], month = _a2[1], date = _a2[2];
                return [Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(year, 4), Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(month || 1), Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(date || 1)].join("-");
              };
              try {
                var intlFormatter_1 = new Intl.DateTimeFormat(locale || void 0, options);
                return function(dateString) {
                  return intlFormatter_1.format(/* @__PURE__ */ new Date(makeIsoString(dateString) + "T00:00:00+00:00"));
                };
              } catch (e) {
                return substrOptions.start || substrOptions.length ? function(dateString) {
                  return makeIsoString(dateString).substr(substrOptions.start || 0, substrOptions.length);
                } : void 0;
              }
            }
            __webpack_exports__["default"] = createNativeLocaleFormatter;
          }
        ),
        /***/
        "./src/components/VDatePicker/util/eventHelpers.ts": (
          /*!*********************************************************!*\
            !*** ./src/components/VDatePicker/util/eventHelpers.ts ***!
            \*********************************************************/
          /*! exports provided: createItemTypeNativeListeners, createItemTypeListeners */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "createItemTypeNativeListeners", function() {
              return createItemTypeNativeListeners;
            });
            __webpack_require__.d(__webpack_exports__, "createItemTypeListeners", function() {
              return createItemTypeListeners;
            });
            function createItemTypeNativeListeners(instance, itemTypeSuffix, value) {
              return Object.keys(instance.$listeners).reduce(function(on2, eventName) {
                if (eventName.endsWith(itemTypeSuffix)) {
                  on2[eventName.slice(0, -itemTypeSuffix.length)] = function(event) {
                    return instance.$emit(eventName, value, event);
                  };
                }
                return on2;
              }, {});
            }
            function createItemTypeListeners(instance, itemTypeSuffix) {
              return Object.keys(instance.$listeners).reduce(function(on2, eventName) {
                if (eventName.endsWith(itemTypeSuffix)) {
                  on2[eventName] = instance.$listeners[eventName];
                }
                return on2;
              }, {});
            }
          }
        ),
        /***/
        "./src/components/VDatePicker/util/index.ts": (
          /*!**************************************************!*\
            !*** ./src/components/VDatePicker/util/index.ts ***!
            \**************************************************/
          /*! exports provided: createItemTypeListeners, createItemTypeNativeListeners, createNativeLocaleFormatter, monthChange, sanitizeDateString, pad */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _eventHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./eventHelpers */
              "./src/components/VDatePicker/util/eventHelpers.ts"
            );
            __webpack_require__.d(__webpack_exports__, "createItemTypeListeners", function() {
              return _eventHelpers__WEBPACK_IMPORTED_MODULE_0__["createItemTypeListeners"];
            });
            __webpack_require__.d(__webpack_exports__, "createItemTypeNativeListeners", function() {
              return _eventHelpers__WEBPACK_IMPORTED_MODULE_0__["createItemTypeNativeListeners"];
            });
            var _createNativeLocaleFormatter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./createNativeLocaleFormatter */
              "./src/components/VDatePicker/util/createNativeLocaleFormatter.ts"
            );
            __webpack_require__.d(__webpack_exports__, "createNativeLocaleFormatter", function() {
              return _createNativeLocaleFormatter__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _monthChange__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./monthChange */
              "./src/components/VDatePicker/util/monthChange.ts"
            );
            __webpack_require__.d(__webpack_exports__, "monthChange", function() {
              return _monthChange__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            var _sanitizeDateString__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./sanitizeDateString */
              "./src/components/VDatePicker/util/sanitizeDateString.ts"
            );
            __webpack_require__.d(__webpack_exports__, "sanitizeDateString", function() {
              return _sanitizeDateString__WEBPACK_IMPORTED_MODULE_3__["default"];
            });
            var _pad__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./pad */
              "./src/components/VDatePicker/util/pad.ts"
            );
            __webpack_require__.d(__webpack_exports__, "pad", function() {
              return _pad__WEBPACK_IMPORTED_MODULE_4__["default"];
            });
          }
        ),
        /***/
        "./src/components/VDatePicker/util/isDateAllowed.ts": (
          /*!**********************************************************!*\
            !*** ./src/components/VDatePicker/util/isDateAllowed.ts ***!
            \**********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", function() {
              return isDateAllowed;
            });
            function isDateAllowed(date, min2, max2, allowedFn) {
              return (!allowedFn || allowedFn(date)) && (!min2 || date >= min2.substr(0, 10)) && (!max2 || date <= max2);
            }
          }
        ),
        /***/
        "./src/components/VDatePicker/util/monthChange.ts": (
          /*!********************************************************!*\
            !*** ./src/components/VDatePicker/util/monthChange.ts ***!
            \********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _pad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./pad */
              "./src/components/VDatePicker/util/pad.ts"
            );
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            __webpack_exports__["default"] = function(value, sign) {
              var _a2 = __read2(value.split("-").map(Number), 2), year = _a2[0], month = _a2[1];
              if (month + sign === 0) {
                return year - 1 + "-12";
              } else if (month + sign === 13) {
                return year + 1 + "-01";
              } else {
                return year + "-" + Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(month + sign);
              }
            };
          }
        ),
        /***/
        "./src/components/VDatePicker/util/pad.ts": (
          /*!************************************************!*\
            !*** ./src/components/VDatePicker/util/pad.ts ***!
            \************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var padStart = function padStart2(string, targetLength, padString) {
              targetLength = targetLength >> 0;
              string = String(string);
              padString = String(padString);
              if (string.length > targetLength) {
                return String(string);
              }
              targetLength = targetLength - string.length;
              if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length);
              }
              return padString.slice(0, targetLength) + String(string);
            };
            __webpack_exports__["default"] = function(n2, length) {
              if (length === void 0) {
                length = 2;
              }
              return padStart(n2, length, "0");
            };
          }
        ),
        /***/
        "./src/components/VDatePicker/util/sanitizeDateString.ts": (
          /*!***************************************************************!*\
            !*** ./src/components/VDatePicker/util/sanitizeDateString.ts ***!
            \***************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _pad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./pad */
              "./src/components/VDatePicker/util/pad.ts"
            );
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            __webpack_exports__["default"] = function(dateString, type) {
              var _a2 = __read2(dateString.split("-"), 3), year = _a2[0], _b2 = _a2[1], month = _b2 === void 0 ? 1 : _b2, _c = _a2[2], date = _c === void 0 ? 1 : _c;
              return (year + "-" + Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(month) + "-" + Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(date)).substr(0, {
                date: 10,
                month: 7,
                year: 4
              }[type]);
            };
          }
        ),
        /***/
        "./src/components/VDialog/VDialog.sass": (
          /*!*********************************************!*\
            !*** ./src/components/VDialog/VDialog.sass ***!
            \*********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VDialog/VDialog.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VDialog/VDialog.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VDialog.sass */
              "./src/components/VDialog/VDialog.sass"
            );
            var _VThemeProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VThemeProvider */
              "./src/components/VThemeProvider/index.ts"
            );
            var _mixins_activatable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/activatable */
              "./src/mixins/activatable/index.ts"
            );
            var _mixins_dependent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/dependent */
              "./src/mixins/dependent/index.ts"
            );
            var _mixins_detachable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/detachable */
              "./src/mixins/detachable/index.ts"
            );
            var _mixins_overlayable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/overlayable */
              "./src/mixins/overlayable/index.ts"
            );
            var _mixins_returnable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/returnable */
              "./src/mixins/returnable/index.ts"
            );
            var _mixins_stackable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../mixins/stackable */
              "./src/mixins/stackable/index.ts"
            );
            var _directives_click_outside__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../directives/click-outside */
              "./src/directives/click-outside/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_9__["default"])(_mixins_dependent__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_detachable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_overlayable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_returnable__WEBPACK_IMPORTED_MODULE_6__["default"], _mixins_stackable__WEBPACK_IMPORTED_MODULE_7__["default"], _mixins_activatable__WEBPACK_IMPORTED_MODULE_2__["default"]);
            __webpack_exports__["default"] = baseMixins.extend({
              name: "v-dialog",
              directives: {
                ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_8__["default"]
              },
              props: {
                dark: Boolean,
                disabled: Boolean,
                fullscreen: Boolean,
                light: Boolean,
                maxWidth: [String, Number],
                noClickAnimation: Boolean,
                origin: {
                  type: String,
                  default: "center center"
                },
                persistent: Boolean,
                retainFocus: {
                  type: Boolean,
                  default: true
                },
                scrollable: Boolean,
                transition: {
                  type: [String, Boolean],
                  default: "dialog-transition"
                },
                width: [String, Number]
              },
              data: function data() {
                return {
                  activatedBy: null,
                  animate: false,
                  animateTimeout: -1,
                  stackMinZIndex: 200,
                  previousActiveElement: null
                };
              },
              computed: {
                classes: function classes() {
                  var _a2;
                  return _a2 = {}, _a2[("v-dialog " + this.contentClass).trim()] = true, _a2["v-dialog--active"] = this.isActive, _a2["v-dialog--persistent"] = this.persistent, _a2["v-dialog--fullscreen"] = this.fullscreen, _a2["v-dialog--scrollable"] = this.scrollable, _a2["v-dialog--animated"] = this.animate, _a2;
                },
                contentClasses: function contentClasses() {
                  return {
                    "v-dialog__content": true,
                    "v-dialog__content--active": this.isActive
                  };
                },
                hasActivator: function hasActivator() {
                  return Boolean(!!this.$slots.activator || !!this.$scopedSlots.activator);
                }
              },
              watch: {
                isActive: function isActive(val) {
                  var _a2;
                  if (val) {
                    this.show();
                    this.hideScroll();
                  } else {
                    this.removeOverlay();
                    this.unbind();
                    (_a2 = this.previousActiveElement) === null || _a2 === void 0 ? void 0 : _a2.focus();
                  }
                },
                fullscreen: function fullscreen(val) {
                  if (!this.isActive)
                    return;
                  if (val) {
                    this.hideScroll();
                    this.removeOverlay(false);
                  } else {
                    this.showScroll();
                    this.genOverlay();
                  }
                }
              },
              created: function created2() {
                if (this.$attrs.hasOwnProperty("full-width")) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_10__["removed"])("full-width", this);
                }
              },
              beforeMount: function beforeMount2() {
                var _this2 = this;
                this.$nextTick(function() {
                  _this2.isBooted = _this2.isActive;
                  _this2.isActive && _this2.show();
                });
              },
              beforeDestroy: function beforeDestroy2() {
                if (typeof window !== "undefined")
                  this.unbind();
              },
              methods: {
                animateClick: function animateClick() {
                  var _this2 = this;
                  this.animate = false;
                  this.$nextTick(function() {
                    _this2.animate = true;
                    window.clearTimeout(_this2.animateTimeout);
                    _this2.animateTimeout = window.setTimeout(function() {
                      return _this2.animate = false;
                    }, 150);
                  });
                },
                closeConditional: function closeConditional(e) {
                  var target2 = e.target;
                  return !(this._isDestroyed || !this.isActive || this.$refs.content.contains(target2) || this.overlay && target2 && !this.overlay.$el.contains(target2)) && this.activeZIndex >= this.getMaxZIndex();
                },
                hideScroll: function hideScroll() {
                  if (this.fullscreen) {
                    document.documentElement.classList.add("overflow-y-hidden");
                  } else {
                    _mixins_overlayable__WEBPACK_IMPORTED_MODULE_5__["default"].options.methods.hideScroll.call(this);
                  }
                },
                show: function show2() {
                  var _this2 = this;
                  !this.fullscreen && !this.hideOverlay && this.genOverlay();
                  this.$nextTick(function() {
                    _this2.$nextTick(function() {
                      var _a2, _b2;
                      if (!((_a2 = _this2.$refs.dialog) === null || _a2 === void 0 ? void 0 : _a2.contains(document.activeElement))) {
                        _this2.previousActiveElement = document.activeElement;
                        (_b2 = _this2.$refs.dialog) === null || _b2 === void 0 ? void 0 : _b2.focus();
                      }
                      _this2.bind();
                    });
                  });
                },
                bind: function bind4() {
                  window.addEventListener("focusin", this.onFocusin);
                },
                unbind: function unbind3() {
                  window.removeEventListener("focusin", this.onFocusin);
                },
                onClickOutside: function onClickOutside(e) {
                  this.$emit("click:outside", e);
                  if (this.persistent) {
                    this.noClickAnimation || this.animateClick();
                  } else {
                    this.isActive = false;
                  }
                },
                onKeydown: function onKeydown(e) {
                  if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_11__["keyCodes"].esc && !this.getOpenDependents().length) {
                    if (!this.persistent) {
                      this.isActive = false;
                      var activator_1 = this.getActivator();
                      this.$nextTick(function() {
                        return activator_1 && activator_1.focus();
                      });
                    } else if (!this.noClickAnimation) {
                      this.animateClick();
                    }
                  }
                  this.$emit("keydown", e);
                },
                // On focus change, wrap focus to stay inside the dialog
                // https://github.com/vuetifyjs/vuetify/issues/6892
                onFocusin: function onFocusin(e) {
                  if (!e || !this.retainFocus)
                    return;
                  var target2 = e.target;
                  if (!!target2 && this.$refs.dialog && // It isn't the document or the dialog body
                  ![document, this.$refs.dialog].includes(target2) && // It isn't inside the dialog body
                  !this.$refs.dialog.contains(target2) && // We're the topmost dialog
                  this.activeZIndex >= this.getMaxZIndex() && // It isn't inside a dependent element (like a menu)
                  !this.getOpenDependentElements().some(function(el2) {
                    return el2.contains(target2);
                  })) {
                    var focusable = this.$refs.dialog.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
                    var el = __spreadArray2([], __read2(focusable), false).find(function(el2) {
                      return !el2.hasAttribute("disabled") && !el2.matches('[tabindex="-1"]');
                    });
                    el && el.focus();
                  }
                },
                genContent: function genContent() {
                  var _this2 = this;
                  return this.showLazyContent(function() {
                    return [_this2.$createElement(_VThemeProvider__WEBPACK_IMPORTED_MODULE_1__["VThemeProvider"], {
                      props: {
                        root: true,
                        light: _this2.light,
                        dark: _this2.dark
                      }
                    }, [_this2.$createElement("div", {
                      class: _this2.contentClasses,
                      attrs: __assign2({
                        role: "dialog",
                        "aria-modal": _this2.hideOverlay ? void 0 : "true"
                      }, _this2.getScopeIdAttrs()),
                      on: {
                        keydown: _this2.onKeydown
                      },
                      style: {
                        zIndex: _this2.activeZIndex
                      },
                      ref: "content"
                    }, [_this2.genTransition()])])];
                  });
                },
                genTransition: function genTransition() {
                  var content = this.genInnerContent();
                  if (!this.transition)
                    return content;
                  return this.$createElement("transition", {
                    props: {
                      name: this.transition,
                      origin: this.origin,
                      appear: true
                    }
                  }, [content]);
                },
                genInnerContent: function genInnerContent() {
                  var data = {
                    class: this.classes,
                    attrs: {
                      tabindex: this.isActive ? 0 : void 0
                    },
                    ref: "dialog",
                    directives: [{
                      name: "click-outside",
                      value: {
                        handler: this.onClickOutside,
                        closeConditional: this.closeConditional,
                        include: this.getOpenDependentElements
                      }
                    }, {
                      name: "show",
                      value: this.isActive
                    }],
                    style: {
                      transformOrigin: this.origin
                    }
                  };
                  if (!this.fullscreen) {
                    data.style = __assign2(__assign2({}, data.style), {
                      maxWidth: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_11__["convertToUnit"])(this.maxWidth),
                      width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_11__["convertToUnit"])(this.width)
                    });
                  }
                  return this.$createElement("div", data, this.getContentSlot());
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-dialog__container",
                  class: {
                    "v-dialog__container--attached": this.attach === "" || this.attach === true || this.attach === "attach"
                  }
                }, [this.genActivator(), this.genContent()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VDialog/index.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VDialog/index.ts ***!
            \*****************************************/
          /*! exports provided: VDialog, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VDialog__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VDialog */
              "./src/components/VDialog/VDialog.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDialog", function() {
              return _VDialog__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VDialog__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VDivider/VDivider.sass": (
          /*!***********************************************!*\
            !*** ./src/components/VDivider/VDivider.sass ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VDivider/VDivider.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VDivider/VDivider.ts ***!
            \*********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VDivider.sass */
              "./src/components/VDivider/VDivider.sass"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
              name: "v-divider",
              props: {
                inset: Boolean,
                vertical: Boolean
              },
              render: function render8(h) {
                var orientation;
                if (!this.$attrs.role || this.$attrs.role === "separator") {
                  orientation = this.vertical ? "vertical" : "horizontal";
                }
                return h("hr", {
                  class: __assign2({
                    "v-divider": true,
                    "v-divider--inset": this.inset,
                    "v-divider--vertical": this.vertical
                  }, this.themeClasses),
                  attrs: __assign2({
                    role: "separator",
                    "aria-orientation": orientation
                  }, this.$attrs),
                  on: this.$listeners
                });
              }
            });
          }
        ),
        /***/
        "./src/components/VDivider/index.ts": (
          /*!******************************************!*\
            !*** ./src/components/VDivider/index.ts ***!
            \******************************************/
          /*! exports provided: VDivider, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VDivider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VDivider */
              "./src/components/VDivider/VDivider.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDivider", function() {
              return _VDivider__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VDivider__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VExpansionPanel/VExpansionPanel.sass": (
          /*!*************************************************************!*\
            !*** ./src/components/VExpansionPanel/VExpansionPanel.sass ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VExpansionPanel/VExpansionPanel.ts": (
          /*!***********************************************************!*\
            !*** ./src/components/VExpansionPanel/VExpansionPanel.ts ***!
            \***********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_groupable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../mixins/groupable */
              "./src/mixins/groupable/index.ts"
            );
            var _mixins_registrable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/registrable */
              "./src/mixins/registrable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(
              Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_0__["factory"])("expansionPanels", "v-expansion-panel", "v-expansion-panels"),
              Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_1__["provide"])("expansionPanel", true)
              /* @vue/component */
            ).extend({
              name: "v-expansion-panel",
              props: {
                disabled: Boolean,
                readonly: Boolean
              },
              data: function data() {
                return {
                  content: null,
                  header: null,
                  nextIsActive: false
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-expansion-panel--active": this.isActive,
                    "v-expansion-panel--next-active": this.nextIsActive,
                    "v-expansion-panel--disabled": this.isDisabled
                  }, this.groupClasses);
                },
                isDisabled: function isDisabled() {
                  return this.expansionPanels.disabled || this.disabled;
                },
                isReadonly: function isReadonly() {
                  return this.expansionPanels.readonly || this.readonly;
                }
              },
              methods: {
                registerContent: function registerContent(vm) {
                  this.content = vm;
                },
                unregisterContent: function unregisterContent() {
                  this.content = null;
                },
                registerHeader: function registerHeader(vm) {
                  this.header = vm;
                  vm.$on("click", this.onClick);
                },
                unregisterHeader: function unregisterHeader() {
                  this.header = null;
                },
                onClick: function onClick(e) {
                  if (e.detail)
                    this.header.$el.blur();
                  this.$emit("click", e);
                  this.isReadonly || this.isDisabled || this.toggle();
                },
                toggle: function toggle() {
                  var _this2 = this;
                  this.$nextTick(function() {
                    return _this2.$emit("change");
                  });
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-expansion-panel",
                  class: this.classes,
                  attrs: {
                    "aria-expanded": String(this.isActive)
                  }
                }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["getSlot"])(this));
              }
            });
          }
        ),
        /***/
        "./src/components/VExpansionPanel/VExpansionPanelContent.ts": (
          /*!******************************************************************!*\
            !*** ./src/components/VExpansionPanel/VExpansionPanelContent.ts ***!
            \******************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _transitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../transitions */
              "./src/components/transitions/index.ts"
            );
            var _mixins_bootable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/bootable */
              "./src/mixins/bootable/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_registrable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/registrable */
              "./src/mixins/registrable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_bootable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_3__["inject"])("expansionPanel", "v-expansion-panel-content", "v-expansion-panel"));
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-expansion-panel-content",
              data: function data() {
                return {
                  isActive: false
                };
              },
              computed: {
                parentIsActive: function parentIsActive() {
                  return this.expansionPanel.isActive;
                }
              },
              watch: {
                parentIsActive: {
                  immediate: true,
                  handler: function handler(val, oldVal) {
                    var _this2 = this;
                    if (val)
                      this.isBooted = true;
                    if (oldVal == null)
                      this.isActive = val;
                    else
                      this.$nextTick(function() {
                        return _this2.isActive = val;
                      });
                  }
                }
              },
              created: function created2() {
                this.expansionPanel.registerContent(this);
              },
              beforeDestroy: function beforeDestroy2() {
                this.expansionPanel.unregisterContent();
              },
              render: function render8(h) {
                var _this2 = this;
                return h(_transitions__WEBPACK_IMPORTED_MODULE_0__["VExpandTransition"], this.showLazyContent(function() {
                  return [h("div", _this2.setBackgroundColor(_this2.color, {
                    staticClass: "v-expansion-panel-content",
                    directives: [{
                      name: "show",
                      value: _this2.isActive
                    }]
                  }), [h("div", {
                    class: "v-expansion-panel-content__wrap"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getSlot"])(_this2, "default", {
                    open: _this2.isActive
                  }))])];
                }));
              }
            });
          }
        ),
        /***/
        "./src/components/VExpansionPanel/VExpansionPanelHeader.ts": (
          /*!*****************************************************************!*\
            !*** ./src/components/VExpansionPanel/VExpansionPanelHeader.ts ***!
            \*****************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _transitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../transitions */
              "./src/components/transitions/index.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_registrable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/registrable */
              "./src/mixins/registrable/index.ts"
            );
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_3__["inject"])("expansionPanel", "v-expansion-panel-header", "v-expansion-panel"));
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-expansion-panel-header",
              directives: {
                ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_4__["default"]
              },
              props: {
                disableIconRotate: Boolean,
                expandIcon: {
                  type: String,
                  default: "$expand"
                },
                hideActions: Boolean,
                ripple: {
                  type: [Boolean, Object],
                  default: false
                }
              },
              data: function data() {
                return {
                  hasMousedown: false
                };
              },
              computed: {
                classes: function classes() {
                  return {
                    "v-expansion-panel-header--active": this.isActive,
                    "v-expansion-panel-header--mousedown": this.hasMousedown
                  };
                },
                isActive: function isActive() {
                  return this.expansionPanel.isActive;
                },
                isDisabled: function isDisabled() {
                  return this.expansionPanel.isDisabled;
                },
                isReadonly: function isReadonly() {
                  return this.expansionPanel.isReadonly;
                }
              },
              created: function created2() {
                this.expansionPanel.registerHeader(this);
              },
              beforeDestroy: function beforeDestroy2() {
                this.expansionPanel.unregisterHeader();
              },
              methods: {
                onClick: function onClick(e) {
                  this.$emit("click", e);
                },
                genIcon: function genIcon() {
                  var icon = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this, "actions", {
                    open: this.isActive
                  }) || [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.expandIcon)];
                  return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_0__["VFadeTransition"], [this.$createElement("div", {
                    staticClass: "v-expansion-panel-header__icon",
                    class: {
                      "v-expansion-panel-header__icon--disable-rotate": this.disableIconRotate
                    },
                    directives: [{
                      name: "show",
                      value: !this.isDisabled
                    }]
                  }, icon)]);
                }
              },
              render: function render8(h) {
                var _this2 = this;
                return h("button", this.setBackgroundColor(this.color, {
                  staticClass: "v-expansion-panel-header",
                  class: this.classes,
                  attrs: {
                    tabindex: this.isDisabled ? -1 : null,
                    type: "button",
                    "aria-expanded": this.isActive
                  },
                  directives: [{
                    name: "ripple",
                    value: this.ripple
                  }],
                  on: __assign2(__assign2({}, this.$listeners), {
                    click: this.onClick,
                    mousedown: function mousedown() {
                      return _this2.hasMousedown = true;
                    },
                    mouseup: function mouseup() {
                      return _this2.hasMousedown = false;
                    }
                  })
                }), [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this, "default", {
                  open: this.isActive
                }, true), this.hideActions || this.genIcon()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VExpansionPanel/VExpansionPanels.ts": (
          /*!************************************************************!*\
            !*** ./src/components/VExpansionPanel/VExpansionPanels.ts ***!
            \************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VExpansionPanel.sass */
              "./src/components/VExpansionPanel/VExpansionPanel.sass"
            );
            var _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VItemGroup/VItemGroup */
              "./src/components/VItemGroup/VItemGroup.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__["BaseItemGroup"].extend({
              name: "v-expansion-panels",
              provide: function provide() {
                return {
                  expansionPanels: this
                };
              },
              props: {
                accordion: Boolean,
                disabled: Boolean,
                flat: Boolean,
                hover: Boolean,
                focusable: Boolean,
                inset: Boolean,
                popout: Boolean,
                readonly: Boolean,
                tile: Boolean
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__["BaseItemGroup"].options.computed.classes.call(this)), {
                    "v-expansion-panels": true,
                    "v-expansion-panels--accordion": this.accordion,
                    "v-expansion-panels--flat": this.flat,
                    "v-expansion-panels--hover": this.hover,
                    "v-expansion-panels--focusable": this.focusable,
                    "v-expansion-panels--inset": this.inset,
                    "v-expansion-panels--popout": this.popout,
                    "v-expansion-panels--tile": this.tile
                  });
                }
              },
              created: function created2() {
                if (this.$attrs.hasOwnProperty("expand")) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["breaking"])("expand", "multiple", this);
                }
                if (Array.isArray(this.value) && this.value.length > 0 && typeof this.value[0] === "boolean") {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["breaking"])(':value="[true, false, true]"', ':value="[0, 2]"', this);
                }
              },
              methods: {
                updateItem: function updateItem(item, index2) {
                  var value = this.getValue(item, index2);
                  var nextValue = this.getValue(item, index2 + 1);
                  item.isActive = this.toggleMethod(value);
                  item.nextIsActive = this.toggleMethod(nextValue);
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VExpansionPanel/index.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VExpansionPanel/index.ts ***!
            \*************************************************/
          /*! exports provided: VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VExpansionPanels__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VExpansionPanels */
              "./src/components/VExpansionPanel/VExpansionPanels.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VExpansionPanels", function() {
              return _VExpansionPanels__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VExpansionPanel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VExpansionPanel */
              "./src/components/VExpansionPanel/VExpansionPanel.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VExpansionPanel", function() {
              return _VExpansionPanel__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _VExpansionPanelContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VExpansionPanelContent */
              "./src/components/VExpansionPanel/VExpansionPanelContent.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VExpansionPanelContent", function() {
              return _VExpansionPanelContent__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            var _VExpansionPanelHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VExpansionPanelHeader */
              "./src/components/VExpansionPanel/VExpansionPanelHeader.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VExpansionPanelHeader", function() {
              return _VExpansionPanelHeader__WEBPACK_IMPORTED_MODULE_3__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VExpansionPanels: _VExpansionPanels__WEBPACK_IMPORTED_MODULE_0__["default"],
                VExpansionPanel: _VExpansionPanel__WEBPACK_IMPORTED_MODULE_1__["default"],
                VExpansionPanelHeader: _VExpansionPanelHeader__WEBPACK_IMPORTED_MODULE_3__["default"],
                VExpansionPanelContent: _VExpansionPanelContent__WEBPACK_IMPORTED_MODULE_2__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VFileInput/VFileInput.sass": (
          /*!***************************************************!*\
            !*** ./src/components/VFileInput/VFileInput.sass ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VFileInput/VFileInput.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VFileInput/VFileInput.ts ***!
            \*************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VFileInput.sass */
              "./src/components/VFileInput/VFileInput.sass"
            );
            var _VTextField__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VTextField */
              "./src/components/VTextField/index.ts"
            );
            var _VChip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VChip */
              "./src/components/VChip/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            __webpack_exports__["default"] = _VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
              name: "v-file-input",
              model: {
                prop: "value",
                event: "change"
              },
              props: {
                chips: Boolean,
                clearable: {
                  type: Boolean,
                  default: true
                },
                counterSizeString: {
                  type: String,
                  default: "$vuetify.fileInput.counterSize"
                },
                counterString: {
                  type: String,
                  default: "$vuetify.fileInput.counter"
                },
                hideInput: Boolean,
                multiple: Boolean,
                placeholder: String,
                prependIcon: {
                  type: String,
                  default: "$file"
                },
                readonly: {
                  type: Boolean,
                  default: false
                },
                showSize: {
                  type: [Boolean, Number],
                  default: false,
                  validator: function validator2(v) {
                    return typeof v === "boolean" || [1e3, 1024].includes(v);
                  }
                },
                smallChips: Boolean,
                truncateLength: {
                  type: [Number, String],
                  default: 22
                },
                type: {
                  type: String,
                  default: "file"
                },
                value: {
                  default: void 0,
                  validator: function validator2(val) {
                    return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["wrapInArray"])(val).every(function(v) {
                      return v != null && _typeof2(v) === "object";
                    });
                  }
                }
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-file-input": true
                  });
                },
                computedCounterValue: function computedCounterValue() {
                  var fileCount = this.multiple && this.lazyValue ? this.lazyValue.length : this.lazyValue instanceof File ? 1 : 0;
                  if (!this.showSize)
                    return this.$vuetify.lang.t(this.counterString, fileCount);
                  var bytes = this.internalArrayValue.reduce(function(bytes2, _a2) {
                    var _b2 = _a2.size, size = _b2 === void 0 ? 0 : _b2;
                    return bytes2 + size;
                  }, 0);
                  return this.$vuetify.lang.t(this.counterSizeString, fileCount, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["humanReadableFileSize"])(bytes, this.base === 1024));
                },
                internalArrayValue: function internalArrayValue() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["wrapInArray"])(this.internalValue);
                },
                internalValue: {
                  get: function get5() {
                    return this.lazyValue;
                  },
                  set: function set2(val) {
                    this.lazyValue = val;
                    this.$emit("change", this.lazyValue);
                  }
                },
                isDirty: function isDirty() {
                  return this.internalArrayValue.length > 0;
                },
                isLabelActive: function isLabelActive() {
                  return this.isDirty;
                },
                text: function text2() {
                  var _this2 = this;
                  if (!this.isDirty && (this.persistentPlaceholder || this.isFocused || !this.hasLabel))
                    return [this.placeholder];
                  return this.internalArrayValue.map(function(file) {
                    var _a2 = file.name, name = _a2 === void 0 ? "" : _a2, _b2 = file.size, size = _b2 === void 0 ? 0 : _b2;
                    var truncatedText = _this2.truncateText(name);
                    return !_this2.showSize ? truncatedText : truncatedText + " (" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["humanReadableFileSize"])(size, _this2.base === 1024) + ")";
                  });
                },
                base: function base() {
                  return typeof this.showSize !== "boolean" ? this.showSize : void 0;
                },
                hasChips: function hasChips() {
                  return this.chips || this.smallChips;
                }
              },
              watch: {
                readonly: {
                  handler: function handler(v) {
                    if (v === true)
                      Object(_util_console__WEBPACK_IMPORTED_MODULE_4__["consoleError"])("readonly is not supported on <v-file-input>", this);
                  },
                  immediate: true
                },
                value: function value(v) {
                  var value2 = this.multiple ? v : v ? [v] : [];
                  if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["deepEqual"])(value2, this.$refs.input.files)) {
                    this.$refs.input.value = "";
                  }
                }
              },
              methods: {
                clearableCallback: function clearableCallback() {
                  this.internalValue = this.multiple ? [] : null;
                  this.$refs.input.value = "";
                },
                genChips: function genChips() {
                  var _this2 = this;
                  if (!this.isDirty)
                    return [];
                  return this.text.map(function(text2, index2) {
                    return _this2.$createElement(_VChip__WEBPACK_IMPORTED_MODULE_2__["VChip"], {
                      props: {
                        small: _this2.smallChips
                      },
                      on: {
                        "click:close": function clickClose() {
                          var internalValue = _this2.internalValue;
                          internalValue.splice(index2, 1);
                          _this2.internalValue = internalValue;
                        }
                      }
                    }, [text2]);
                  });
                },
                genControl: function genControl() {
                  var render8 = _VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genControl.call(this);
                  if (this.hideInput) {
                    render8.data.style = Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_5__["mergeStyles"])(render8.data.style, {
                      display: "none"
                    });
                  }
                  return render8;
                },
                genInput: function genInput() {
                  var input2 = _VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genInput.call(this);
                  input2.data.attrs.multiple = this.multiple;
                  delete input2.data.domProps.value;
                  delete input2.data.on.input;
                  input2.data.on.change = this.onInput;
                  return [this.genSelections(), input2];
                },
                genPrependSlot: function genPrependSlot() {
                  var _this2 = this;
                  if (!this.prependIcon)
                    return null;
                  var icon = this.genIcon("prepend", function() {
                    _this2.$refs.input.click();
                  });
                  return this.genSlot("prepend", "outer", [icon]);
                },
                genSelectionText: function genSelectionText() {
                  var length = this.text.length;
                  if (length < 2)
                    return this.text;
                  if (this.showSize && !this.counter)
                    return [this.computedCounterValue];
                  return [this.$vuetify.lang.t(this.counterString, length)];
                },
                genSelections: function genSelections() {
                  var _this2 = this;
                  var children = [];
                  if (this.isDirty && this.$scopedSlots.selection) {
                    this.internalArrayValue.forEach(function(file, index2) {
                      if (!_this2.$scopedSlots.selection)
                        return;
                      children.push(_this2.$scopedSlots.selection({
                        text: _this2.text[index2],
                        file,
                        index: index2
                      }));
                    });
                  } else {
                    children.push(this.hasChips && this.isDirty ? this.genChips() : this.genSelectionText());
                  }
                  return this.$createElement("div", {
                    staticClass: "v-file-input__text",
                    class: {
                      "v-file-input__text--placeholder": this.placeholder && !this.isDirty,
                      "v-file-input__text--chips": this.hasChips && !this.$scopedSlots.selection
                    }
                  }, children);
                },
                genTextFieldSlot: function genTextFieldSlot() {
                  var _this2 = this;
                  var node2 = _VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genTextFieldSlot.call(this);
                  node2.data.on = __assign2(__assign2({}, node2.data.on || {}), {
                    click: function click2(e) {
                      if (e.target && e.target.nodeName === "LABEL")
                        return;
                      _this2.$refs.input.click();
                    }
                  });
                  return node2;
                },
                onInput: function onInput(e) {
                  var files = __spreadArray2([], __read2(e.target.files || []), false);
                  this.internalValue = this.multiple ? files : files[0];
                  this.initialValue = this.internalValue;
                },
                onKeyDown: function onKeyDown(e) {
                  this.$emit("keydown", e);
                },
                truncateText: function truncateText(str) {
                  if (str.length < Number(this.truncateLength))
                    return str;
                  var charsKeepOneSide = Math.floor((Number(this.truncateLength) - 1) / 2);
                  return str.slice(0, charsKeepOneSide) + "…" + str.slice(str.length - charsKeepOneSide);
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VFileInput/index.ts": (
          /*!********************************************!*\
            !*** ./src/components/VFileInput/index.ts ***!
            \********************************************/
          /*! exports provided: VFileInput, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VFileInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VFileInput */
              "./src/components/VFileInput/VFileInput.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VFileInput", function() {
              return _VFileInput__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VFileInput__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VFooter/VFooter.sass": (
          /*!*********************************************!*\
            !*** ./src/components/VFooter/VFooter.sass ***!
            \*********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VFooter/VFooter.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VFooter/VFooter.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VFooter.sass */
              "./src/components/VFooter/VFooter.sass"
            );
            var _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSheet/VSheet */
              "./src/components/VSheet/VSheet.ts"
            );
            var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/applicationable */
              "./src/mixins/applicationable/index.ts"
            );
            var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/ssr-bootable */
              "./src/mixins/ssr-bootable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"], Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_2__["default"])("footer", ["height", "inset"]), _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_3__["default"]).extend({
              name: "v-footer",
              props: {
                height: {
                  default: "auto",
                  type: [Number, String]
                },
                inset: Boolean,
                padless: Boolean,
                tag: {
                  type: String,
                  default: "footer"
                }
              },
              computed: {
                applicationProperty: function applicationProperty() {
                  return this.inset ? "insetFooter" : "footer";
                },
                classes: function classes() {
                  return __assign2(__assign2({}, _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-footer--absolute": this.absolute,
                    "v-footer--fixed": !this.absolute && (this.app || this.fixed),
                    "v-footer--padless": this.padless,
                    "v-footer--inset": this.inset
                  });
                },
                computedBottom: function computedBottom() {
                  if (!this.isPositioned)
                    return void 0;
                  return this.app ? this.$vuetify.application.bottom : 0;
                },
                computedLeft: function computedLeft() {
                  if (!this.isPositioned)
                    return void 0;
                  return this.app && this.inset ? this.$vuetify.application.left : 0;
                },
                computedRight: function computedRight() {
                  if (!this.isPositioned)
                    return void 0;
                  return this.app && this.inset ? this.$vuetify.application.right : 0;
                },
                isPositioned: function isPositioned() {
                  return Boolean(this.absolute || this.fixed || this.app);
                },
                styles: function styles() {
                  var height = parseInt(this.height);
                  return __assign2(__assign2({}, _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.styles.call(this)), {
                    height: isNaN(height) ? height : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(height),
                    left: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.computedLeft),
                    right: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.computedRight),
                    bottom: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.computedBottom)
                  });
                }
              },
              methods: {
                updateApplication: function updateApplication() {
                  var height = parseInt(this.height);
                  return isNaN(height) ? this.$el ? this.$el.clientHeight : 0 : height;
                }
              },
              render: function render8(h) {
                var data = this.setBackgroundColor(this.color, {
                  staticClass: "v-footer",
                  class: this.classes,
                  style: this.styles
                });
                return h(this.tag, data, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this));
              }
            });
          }
        ),
        /***/
        "./src/components/VFooter/index.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VFooter/index.ts ***!
            \*****************************************/
          /*! exports provided: VFooter, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VFooter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VFooter */
              "./src/components/VFooter/VFooter.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VFooter", function() {
              return _VFooter__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VFooter__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VForm/VForm.ts": (
          /*!***************************************!*\
            !*** ./src/components/VForm/VForm.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _util_mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/binds-attrs */
              "./src/mixins/binds-attrs/index.ts"
            );
            var _mixins_registrable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/registrable */
              "./src/mixins/registrable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_0__["default"])(
              _mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_1__["default"],
              Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_2__["provide"])("form")
              /* @vue/component */
            ).extend({
              name: "v-form",
              provide: function provide() {
                return {
                  form: this
                };
              },
              inheritAttrs: false,
              props: {
                disabled: Boolean,
                lazyValidation: Boolean,
                readonly: Boolean,
                value: Boolean
              },
              data: function data() {
                return {
                  inputs: [],
                  watchers: [],
                  errorBag: {}
                };
              },
              watch: {
                errorBag: {
                  handler: function handler(val) {
                    var errors = Object.values(val).includes(true);
                    this.$emit("input", !errors);
                  },
                  deep: true,
                  immediate: true
                }
              },
              methods: {
                watchInput: function watchInput(input2) {
                  var _this2 = this;
                  var watcher = function watcher2(input3) {
                    return input3.$watch("hasError", function(val) {
                      _this2.$set(_this2.errorBag, input3._uid, val);
                    }, {
                      immediate: true
                    });
                  };
                  var watchers = {
                    _uid: input2._uid,
                    valid: function valid() {
                    },
                    shouldValidate: function shouldValidate() {
                    }
                  };
                  if (this.lazyValidation) {
                    watchers.shouldValidate = input2.$watch("shouldValidate", function(val) {
                      if (!val)
                        return;
                      if (_this2.errorBag.hasOwnProperty(input2._uid))
                        return;
                      watchers.valid = watcher(input2);
                    });
                  } else {
                    watchers.valid = watcher(input2);
                  }
                  return watchers;
                },
                /** @public */
                validate: function validate() {
                  return this.inputs.filter(function(input2) {
                    return !input2.validate(true);
                  }).length === 0;
                },
                /** @public */
                reset: function reset() {
                  this.inputs.forEach(function(input2) {
                    return input2.reset();
                  });
                  this.resetErrorBag();
                },
                resetErrorBag: function resetErrorBag() {
                  var _this2 = this;
                  if (this.lazyValidation) {
                    setTimeout(function() {
                      _this2.errorBag = {};
                    }, 0);
                  }
                },
                /** @public */
                resetValidation: function resetValidation() {
                  this.inputs.forEach(function(input2) {
                    return input2.resetValidation();
                  });
                  this.resetErrorBag();
                },
                register: function register(input2) {
                  this.inputs.push(input2);
                  this.watchers.push(this.watchInput(input2));
                },
                unregister: function unregister(input2) {
                  var found = this.inputs.find(function(i2) {
                    return i2._uid === input2._uid;
                  });
                  if (!found)
                    return;
                  var unwatch = this.watchers.find(function(i2) {
                    return i2._uid === found._uid;
                  });
                  if (unwatch) {
                    unwatch.valid();
                    unwatch.shouldValidate();
                  }
                  this.watchers = this.watchers.filter(function(i2) {
                    return i2._uid !== found._uid;
                  });
                  this.inputs = this.inputs.filter(function(i2) {
                    return i2._uid !== found._uid;
                  });
                  this.$delete(this.errorBag, found._uid);
                }
              },
              render: function render8(h) {
                var _this2 = this;
                return h("form", {
                  staticClass: "v-form",
                  attrs: __assign2({
                    novalidate: true
                  }, this.attrs$),
                  on: {
                    submit: function submit(e) {
                      return _this2.$emit("submit", e);
                    }
                  }
                }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this));
              }
            });
          }
        ),
        /***/
        "./src/components/VForm/index.ts": (
          /*!***************************************!*\
            !*** ./src/components/VForm/index.ts ***!
            \***************************************/
          /*! exports provided: VForm, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VForm__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VForm */
              "./src/components/VForm/VForm.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VForm", function() {
              return _VForm__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VForm__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VGrid/VCol.ts": (
          /*!**************************************!*\
            !*** ./src/components/VGrid/VCol.ts ***!
            \**************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VGrid.sass */
              "./src/components/VGrid/VGrid.sass"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var breakpoints = ["sm", "md", "lg", "xl"];
            var breakpointProps = function() {
              return breakpoints.reduce(function(props2, val) {
                props2[val] = {
                  type: [Boolean, String, Number],
                  default: false
                };
                return props2;
              }, {});
            }();
            var offsetProps = function() {
              return breakpoints.reduce(function(props2, val) {
                props2["offset" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["upperFirst"])(val)] = {
                  type: [String, Number],
                  default: null
                };
                return props2;
              }, {});
            }();
            var orderProps = function() {
              return breakpoints.reduce(function(props2, val) {
                props2["order" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["upperFirst"])(val)] = {
                  type: [String, Number],
                  default: null
                };
                return props2;
              }, {});
            }();
            var propMap = {
              col: Object.keys(breakpointProps),
              offset: Object.keys(offsetProps),
              order: Object.keys(orderProps)
            };
            function breakpointClass(type, prop, val) {
              var className = type;
              if (val == null || val === false) {
                return void 0;
              }
              if (prop) {
                var breakpoint = prop.replace(type, "");
                className += "-" + breakpoint;
              }
              if (type === "col" && (val === "" || val === true)) {
                return className.toLowerCase();
              }
              className += "-" + val;
              return className.toLowerCase();
            }
            var cache = /* @__PURE__ */ new Map();
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
              name: "v-col",
              functional: true,
              props: __assign2(__assign2(__assign2(__assign2(__assign2(__assign2({
                cols: {
                  type: [Boolean, String, Number],
                  default: false
                }
              }, breakpointProps), {
                offset: {
                  type: [String, Number],
                  default: null
                }
              }), offsetProps), {
                order: {
                  type: [String, Number],
                  default: null
                }
              }), orderProps), {
                alignSelf: {
                  type: String,
                  default: null,
                  validator: function validator2(str) {
                    return ["auto", "start", "end", "center", "baseline", "stretch"].includes(str);
                  }
                },
                tag: {
                  type: String,
                  default: "div"
                }
              }),
              render: function render8(h, _a2) {
                var _b2;
                var props2 = _a2.props, data = _a2.data, children = _a2.children;
                _a2.parent;
                var cacheKey = "";
                for (var prop in props2) {
                  cacheKey += String(props2[prop]);
                }
                var classList = cache.get(cacheKey);
                if (!classList) {
                  classList = [];
                  var type_1;
                  for (type_1 in propMap) {
                    propMap[type_1].forEach(function(prop2) {
                      var value = props2[prop2];
                      var className = breakpointClass(type_1, prop2, value);
                      if (className)
                        classList.push(className);
                    });
                  }
                  var hasColClasses = classList.some(function(className) {
                    return className.startsWith("col-");
                  });
                  classList.push((_b2 = {
                    // Default to .col if no other col-{bp}-* classes generated nor `cols` specified.
                    col: !hasColClasses || !props2.cols
                  }, _b2["col-" + props2.cols] = props2.cols, _b2["offset-" + props2.offset] = props2.offset, _b2["order-" + props2.order] = props2.order, _b2["align-self-" + props2.alignSelf] = props2.alignSelf, _b2));
                  cache.set(cacheKey, classList);
                }
                return h(props2.tag, Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_2__["default"])(data, {
                  class: classList
                }), children);
              }
            });
          }
        ),
        /***/
        "./src/components/VGrid/VContainer.ts": (
          /*!********************************************!*\
            !*** ./src/components/VGrid/VContainer.ts ***!
            \********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./_grid.sass */
              "./src/components/VGrid/_grid.sass"
            );
            __webpack_require__(
              /*! ./VGrid.sass */
              "./src/components/VGrid/VGrid.sass"
            );
            var _grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./grid */
              "./src/components/VGrid/grid.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            __webpack_exports__["default"] = Object(_grid__WEBPACK_IMPORTED_MODULE_2__["default"])("container").extend({
              name: "v-container",
              functional: true,
              props: {
                id: String,
                tag: {
                  type: String,
                  default: "div"
                },
                fluid: {
                  type: Boolean,
                  default: false
                }
              },
              render: function render8(h, _a2) {
                var props2 = _a2.props, data = _a2.data, children = _a2.children;
                var classes;
                var attrs2 = data.attrs;
                if (attrs2) {
                  data.attrs = {};
                  classes = Object.keys(attrs2).filter(function(key) {
                    if (key === "slot")
                      return false;
                    var value = attrs2[key];
                    if (key.startsWith("data-")) {
                      data.attrs[key] = value;
                      return false;
                    }
                    return value || typeof value === "string";
                  });
                }
                if (props2.id) {
                  data.domProps = data.domProps || {};
                  data.domProps.id = props2.id;
                }
                return h(props2.tag, Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_3__["default"])(data, {
                  staticClass: "container",
                  class: Array({
                    "container--fluid": props2.fluid
                  }).concat(classes || [])
                }), children);
              }
            });
          }
        ),
        /***/
        "./src/components/VGrid/VFlex.ts": (
          /*!***************************************!*\
            !*** ./src/components/VGrid/VFlex.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./_grid.sass */
              "./src/components/VGrid/_grid.sass"
            );
            var _grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./grid */
              "./src/components/VGrid/grid.ts"
            );
            __webpack_exports__["default"] = Object(_grid__WEBPACK_IMPORTED_MODULE_1__["default"])("flex");
          }
        ),
        /***/
        "./src/components/VGrid/VGrid.sass": (
          /*!*****************************************!*\
            !*** ./src/components/VGrid/VGrid.sass ***!
            \*****************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VGrid/VLayout.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VGrid/VLayout.ts ***!
            \*****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./_grid.sass */
              "./src/components/VGrid/_grid.sass"
            );
            var _grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./grid */
              "./src/components/VGrid/grid.ts"
            );
            __webpack_exports__["default"] = Object(_grid__WEBPACK_IMPORTED_MODULE_1__["default"])("layout");
          }
        ),
        /***/
        "./src/components/VGrid/VRow.ts": (
          /*!**************************************!*\
            !*** ./src/components/VGrid/VRow.ts ***!
            \**************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VGrid.sass */
              "./src/components/VGrid/VGrid.sass"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            var breakpoints = ["sm", "md", "lg", "xl"];
            var ALIGNMENT = ["start", "end", "center"];
            function makeProps(prefix, def2) {
              return breakpoints.reduce(function(props2, val) {
                props2[prefix + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["upperFirst"])(val)] = def2();
                return props2;
              }, {});
            }
            var alignValidator = function alignValidator2(str) {
              return __spreadArray2(__spreadArray2([], __read2(ALIGNMENT), false), ["baseline", "stretch"], false).includes(str);
            };
            var alignProps = makeProps("align", function() {
              return {
                type: String,
                default: null,
                validator: alignValidator
              };
            });
            var justifyValidator = function justifyValidator2(str) {
              return __spreadArray2(__spreadArray2([], __read2(ALIGNMENT), false), ["space-between", "space-around"], false).includes(str);
            };
            var justifyProps = makeProps("justify", function() {
              return {
                type: String,
                default: null,
                validator: justifyValidator
              };
            });
            var alignContentValidator = function alignContentValidator2(str) {
              return __spreadArray2(__spreadArray2([], __read2(ALIGNMENT), false), ["space-between", "space-around", "stretch"], false).includes(str);
            };
            var alignContentProps = makeProps("alignContent", function() {
              return {
                type: String,
                default: null,
                validator: alignContentValidator
              };
            });
            var propMap = {
              align: Object.keys(alignProps),
              justify: Object.keys(justifyProps),
              alignContent: Object.keys(alignContentProps)
            };
            var classMap = {
              align: "align",
              justify: "justify",
              alignContent: "align-content"
            };
            function breakpointClass(type, prop, val) {
              var className = classMap[type];
              if (val == null) {
                return void 0;
              }
              if (prop) {
                var breakpoint = prop.replace(type, "");
                className += "-" + breakpoint;
              }
              className += "-" + val;
              return className.toLowerCase();
            }
            var cache = /* @__PURE__ */ new Map();
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
              name: "v-row",
              functional: true,
              props: __assign2(__assign2(__assign2(__assign2(__assign2({
                tag: {
                  type: String,
                  default: "div"
                },
                dense: Boolean,
                noGutters: Boolean,
                align: {
                  type: String,
                  default: null,
                  validator: alignValidator
                }
              }, alignProps), {
                justify: {
                  type: String,
                  default: null,
                  validator: justifyValidator
                }
              }), justifyProps), {
                alignContent: {
                  type: String,
                  default: null,
                  validator: alignContentValidator
                }
              }), alignContentProps),
              render: function render8(h, _a2) {
                var _b2;
                var props2 = _a2.props, data = _a2.data, children = _a2.children;
                var cacheKey = "";
                for (var prop in props2) {
                  cacheKey += String(props2[prop]);
                }
                var classList = cache.get(cacheKey);
                if (!classList) {
                  classList = [];
                  var type_1;
                  for (type_1 in propMap) {
                    propMap[type_1].forEach(function(prop2) {
                      var value = props2[prop2];
                      var className = breakpointClass(type_1, prop2, value);
                      if (className)
                        classList.push(className);
                    });
                  }
                  classList.push((_b2 = {
                    "no-gutters": props2.noGutters,
                    "row--dense": props2.dense
                  }, _b2["align-" + props2.align] = props2.align, _b2["justify-" + props2.justify] = props2.justify, _b2["align-content-" + props2.alignContent] = props2.alignContent, _b2));
                  cache.set(cacheKey, classList);
                }
                return h(props2.tag, Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_2__["default"])(data, {
                  staticClass: "row",
                  class: classList
                }), children);
              }
            });
          }
        ),
        /***/
        "./src/components/VGrid/VSpacer.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VGrid/VSpacer.ts ***!
            \*****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./_grid.sass */
              "./src/components/VGrid/_grid.sass"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["createSimpleFunctional"])("spacer", "div", "v-spacer");
          }
        ),
        /***/
        "./src/components/VGrid/_grid.sass": (
          /*!*****************************************!*\
            !*** ./src/components/VGrid/_grid.sass ***!
            \*****************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VGrid/grid.ts": (
          /*!**************************************!*\
            !*** ./src/components/VGrid/grid.ts ***!
            \**************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", function() {
              return VGrid;
            });
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            function VGrid(name) {
              return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
                name: "v-" + name,
                functional: true,
                props: {
                  id: String,
                  tag: {
                    type: String,
                    default: "div"
                  }
                },
                render: function render8(h, _a2) {
                  var props2 = _a2.props, data = _a2.data, children = _a2.children;
                  data.staticClass = (name + " " + (data.staticClass || "")).trim();
                  var attrs2 = data.attrs;
                  if (attrs2) {
                    data.attrs = {};
                    var classes = Object.keys(attrs2).filter(function(key) {
                      if (key === "slot")
                        return false;
                      var value = attrs2[key];
                      if (key.startsWith("data-")) {
                        data.attrs[key] = value;
                        return false;
                      }
                      return value || typeof value === "string";
                    });
                    if (classes.length)
                      data.staticClass += " " + classes.join(" ");
                  }
                  if (props2.id) {
                    data.domProps = data.domProps || {};
                    data.domProps.id = props2.id;
                  }
                  return h(props2.tag, data, children);
                }
              });
            }
          }
        ),
        /***/
        "./src/components/VGrid/index.ts": (
          /*!***************************************!*\
            !*** ./src/components/VGrid/index.ts ***!
            \***************************************/
          /*! exports provided: VContainer, VCol, VRow, VSpacer, VLayout, VFlex, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VContainer */
              "./src/components/VGrid/VContainer.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VContainer", function() {
              return _VContainer__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VCol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VCol */
              "./src/components/VGrid/VCol.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCol", function() {
              return _VCol__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _VRow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VRow */
              "./src/components/VGrid/VRow.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VRow", function() {
              return _VRow__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            var _VSpacer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VSpacer */
              "./src/components/VGrid/VSpacer.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSpacer", function() {
              return _VSpacer__WEBPACK_IMPORTED_MODULE_3__["default"];
            });
            var _VLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./VLayout */
              "./src/components/VGrid/VLayout.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VLayout", function() {
              return _VLayout__WEBPACK_IMPORTED_MODULE_4__["default"];
            });
            var _VFlex__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./VFlex */
              "./src/components/VGrid/VFlex.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VFlex", function() {
              return _VFlex__WEBPACK_IMPORTED_MODULE_5__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VContainer: _VContainer__WEBPACK_IMPORTED_MODULE_0__["default"],
                VCol: _VCol__WEBPACK_IMPORTED_MODULE_1__["default"],
                VRow: _VRow__WEBPACK_IMPORTED_MODULE_2__["default"],
                VSpacer: _VSpacer__WEBPACK_IMPORTED_MODULE_3__["default"],
                VLayout: _VLayout__WEBPACK_IMPORTED_MODULE_4__["default"],
                VFlex: _VFlex__WEBPACK_IMPORTED_MODULE_5__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VHover/VHover.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VHover/VHover.ts ***!
            \*****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_delayable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../mixins/delayable */
              "./src/mixins/delayable/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(
              _mixins_delayable__WEBPACK_IMPORTED_MODULE_0__["default"],
              _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__["default"]
              /* @vue/component */
            ).extend({
              name: "v-hover",
              props: {
                disabled: {
                  type: Boolean,
                  default: false
                },
                value: {
                  type: Boolean,
                  default: void 0
                }
              },
              methods: {
                onMouseEnter: function onMouseEnter() {
                  this.runDelay("open");
                },
                onMouseLeave: function onMouseLeave() {
                  this.runDelay("close");
                }
              },
              render: function render8() {
                if (!this.$scopedSlots.default && this.value === void 0) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["consoleWarn"])("v-hover is missing a default scopedSlot or bound value", this);
                  return null;
                }
                var element;
                if (this.$scopedSlots.default) {
                  element = this.$scopedSlots.default({
                    hover: this.isActive
                  });
                }
                if (Array.isArray(element) && element.length === 1) {
                  element = element[0];
                }
                if (!element || Array.isArray(element) || !element.tag) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["consoleWarn"])("v-hover should only contain a single element", this);
                  return element;
                }
                if (!this.disabled) {
                  element.data = element.data || {};
                  this._g(element.data, {
                    mouseenter: this.onMouseEnter,
                    mouseleave: this.onMouseLeave
                  });
                }
                return element;
              }
            });
          }
        ),
        /***/
        "./src/components/VHover/index.ts": (
          /*!****************************************!*\
            !*** ./src/components/VHover/index.ts ***!
            \****************************************/
          /*! exports provided: VHover, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VHover__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VHover */
              "./src/components/VHover/VHover.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VHover", function() {
              return _VHover__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VHover__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VIcon/VIcon.sass": (
          /*!*****************************************!*\
            !*** ./src/components/VIcon/VIcon.sass ***!
            \*****************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VIcon/VIcon.ts": (
          /*!***************************************!*\
            !*** ./src/components/VIcon/VIcon.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VIcon.sass */
              "./src/components/VIcon/VIcon.sass"
            );
            var _mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/binds-attrs */
              "./src/mixins/binds-attrs/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_sizeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/sizeable */
              "./src/mixins/sizeable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_6___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_6__);
            var _util_mixins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var SIZE_MAP;
            (function(SIZE_MAP2) {
              SIZE_MAP2["xSmall"] = "12px";
              SIZE_MAP2["small"] = "16px";
              SIZE_MAP2["default"] = "24px";
              SIZE_MAP2["medium"] = "28px";
              SIZE_MAP2["large"] = "36px";
              SIZE_MAP2["xLarge"] = "40px";
            })(SIZE_MAP || (SIZE_MAP = {}));
            function isFontAwesome5(iconType) {
              return ["fas", "far", "fal", "fab", "fad", "fak"].some(function(val) {
                return iconType.includes(val);
              });
            }
            function isSvgPath(icon) {
              return /^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(icon) && /[\dz]$/i.test(icon) && icon.length > 4;
            }
            var VIcon = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_7__["default"])(
              _mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_1__["default"],
              _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"],
              _mixins_sizeable__WEBPACK_IMPORTED_MODULE_3__["default"],
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__["default"]
              /* @vue/component */
            ).extend({
              name: "v-icon",
              props: {
                dense: Boolean,
                disabled: Boolean,
                left: Boolean,
                right: Boolean,
                size: [Number, String],
                tag: {
                  type: String,
                  required: false,
                  default: "i"
                }
              },
              computed: {
                medium: function medium() {
                  return false;
                },
                hasClickListener: function hasClickListener() {
                  return Boolean(this.listeners$.click || this.listeners$["!click"]);
                }
              },
              methods: {
                getIcon: function getIcon() {
                  var iconName = "";
                  if (this.$slots.default)
                    iconName = this.$slots.default[0].text.trim();
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["remapInternalIcon"])(this, iconName);
                },
                getSize: function getSize() {
                  var sizes = {
                    xSmall: this.xSmall,
                    small: this.small,
                    medium: this.medium,
                    large: this.large,
                    xLarge: this.xLarge
                  };
                  var explicitSize = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["keys"])(sizes).find(function(key) {
                    return sizes[key];
                  });
                  return explicitSize && SIZE_MAP[explicitSize] || Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.size);
                },
                // Component data for both font icon and SVG wrapper span
                getDefaultData: function getDefaultData() {
                  return {
                    staticClass: "v-icon notranslate",
                    class: {
                      "v-icon--disabled": this.disabled,
                      "v-icon--left": this.left,
                      "v-icon--link": this.hasClickListener,
                      "v-icon--right": this.right,
                      "v-icon--dense": this.dense
                    },
                    attrs: __assign2({
                      "aria-hidden": !this.hasClickListener,
                      disabled: this.hasClickListener && this.disabled,
                      type: this.hasClickListener ? "button" : void 0
                    }, this.attrs$),
                    on: this.listeners$
                  };
                },
                getSvgWrapperData: function getSvgWrapperData() {
                  var fontSize = this.getSize();
                  var wrapperData = __assign2(__assign2({}, this.getDefaultData()), {
                    style: fontSize ? {
                      fontSize,
                      height: fontSize,
                      width: fontSize
                    } : void 0
                  });
                  this.applyColors(wrapperData);
                  return wrapperData;
                },
                applyColors: function applyColors(data) {
                  data.class = __assign2(__assign2({}, data.class), this.themeClasses);
                  this.setTextColor(this.color, data);
                },
                renderFontIcon: function renderFontIcon(icon, h) {
                  var newChildren = [];
                  var data = this.getDefaultData();
                  var iconType = "material-icons";
                  var delimiterIndex = icon.indexOf("-");
                  var isMaterialIcon = delimiterIndex <= -1;
                  if (isMaterialIcon) {
                    newChildren.push(icon);
                  } else {
                    iconType = icon.slice(0, delimiterIndex);
                    if (isFontAwesome5(iconType))
                      iconType = "";
                  }
                  data.class[iconType] = true;
                  data.class[icon] = !isMaterialIcon;
                  var fontSize = this.getSize();
                  if (fontSize)
                    data.style = {
                      fontSize
                    };
                  this.applyColors(data);
                  return h(this.hasClickListener ? "button" : this.tag, data, newChildren);
                },
                renderSvgIcon: function renderSvgIcon(icon, h) {
                  var svgData = {
                    class: "v-icon__svg",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24",
                      role: "img",
                      "aria-hidden": true
                    }
                  };
                  var size = this.getSize();
                  if (size) {
                    svgData.style = {
                      fontSize: size,
                      height: size,
                      width: size
                    };
                  }
                  return h(this.hasClickListener ? "button" : "span", this.getSvgWrapperData(), [h("svg", svgData, [h("path", {
                    attrs: {
                      d: icon
                    }
                  })])]);
                },
                renderSvgIconComponent: function renderSvgIconComponent(icon, h) {
                  var data = {
                    class: {
                      "v-icon__component": true
                    }
                  };
                  var size = this.getSize();
                  if (size) {
                    data.style = {
                      fontSize: size,
                      height: size,
                      width: size
                    };
                  }
                  this.applyColors(data);
                  var component = icon.component;
                  data.props = icon.props;
                  data.nativeOn = data.on;
                  return h(this.hasClickListener ? "button" : "span", this.getSvgWrapperData(), [h(component, data)]);
                }
              },
              render: function render8(h) {
                var icon = this.getIcon();
                if (typeof icon === "string") {
                  if (isSvgPath(icon)) {
                    return this.renderSvgIcon(icon, h);
                  }
                  return this.renderFontIcon(icon, h);
                }
                return this.renderSvgIconComponent(icon, h);
              }
            });
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_6___default.a.extend({
              name: "v-icon",
              $_wrapperFor: VIcon,
              functional: true,
              render: function render8(h, _a2) {
                var data = _a2.data, children = _a2.children;
                var iconName = "";
                if (data.domProps) {
                  iconName = data.domProps.textContent || data.domProps.innerHTML || iconName;
                  delete data.domProps.textContent;
                  delete data.domProps.innerHTML;
                }
                return h(VIcon, data, iconName ? [iconName] : children);
              }
            });
          }
        ),
        /***/
        "./src/components/VIcon/index.ts": (
          /*!***************************************!*\
            !*** ./src/components/VIcon/index.ts ***!
            \***************************************/
          /*! exports provided: VIcon, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VIcon */
              "./src/components/VIcon/VIcon.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VIcon", function() {
              return _VIcon__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VIcon__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VImg/VImg.sass": (
          /*!***************************************!*\
            !*** ./src/components/VImg/VImg.sass ***!
            \***************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VImg/VImg.ts": (
          /*!*************************************!*\
            !*** ./src/components/VImg/VImg.ts ***!
            \*************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VImg.sass */
              "./src/components/VImg/VImg.sass"
            );
            var _directives_intersect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../directives/intersect */
              "./src/directives/intersect/index.ts"
            );
            var _VResponsive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VResponsive */
              "./src/components/VResponsive/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var hasIntersect = typeof window !== "undefined" && "IntersectionObserver" in window;
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_VResponsive__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]).extend({
              name: "v-img",
              directives: {
                intersect: _directives_intersect__WEBPACK_IMPORTED_MODULE_1__["default"]
              },
              props: {
                alt: String,
                contain: Boolean,
                eager: Boolean,
                gradient: String,
                lazySrc: String,
                options: {
                  type: Object,
                  // For more information on types, navigate to:
                  // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
                  default: function _default() {
                    return {
                      root: void 0,
                      rootMargin: void 0,
                      threshold: void 0
                    };
                  }
                },
                position: {
                  type: String,
                  default: "center center"
                },
                sizes: String,
                src: {
                  type: [String, Object],
                  default: ""
                },
                srcset: String,
                transition: {
                  type: [Boolean, String],
                  default: "fade-transition"
                }
              },
              data: function data() {
                return {
                  currentSrc: "",
                  image: null,
                  isLoading: true,
                  calculatedAspectRatio: void 0,
                  naturalWidth: void 0,
                  hasError: false
                };
              },
              computed: {
                computedAspectRatio: function computedAspectRatio() {
                  return Number(this.normalisedSrc.aspect || this.calculatedAspectRatio);
                },
                normalisedSrc: function normalisedSrc() {
                  return this.src && _typeof2(this.src) === "object" ? {
                    src: this.src.src,
                    srcset: this.srcset || this.src.srcset,
                    lazySrc: this.lazySrc || this.src.lazySrc,
                    aspect: Number(this.aspectRatio || this.src.aspect)
                  } : {
                    src: this.src,
                    srcset: this.srcset,
                    lazySrc: this.lazySrc,
                    aspect: Number(this.aspectRatio || 0)
                  };
                },
                __cachedImage: function __cachedImage() {
                  if (!(this.normalisedSrc.src || this.normalisedSrc.lazySrc || this.gradient))
                    return [];
                  var backgroundImage = [];
                  var src = this.isLoading ? this.normalisedSrc.lazySrc : this.currentSrc;
                  if (this.gradient)
                    backgroundImage.push("linear-gradient(" + this.gradient + ")");
                  if (src)
                    backgroundImage.push('url("' + src + '")');
                  var image = this.$createElement("div", {
                    staticClass: "v-image__image",
                    class: {
                      "v-image__image--preload": this.isLoading,
                      "v-image__image--contain": this.contain,
                      "v-image__image--cover": !this.contain
                    },
                    style: {
                      backgroundImage: backgroundImage.join(", "),
                      backgroundPosition: this.position
                    },
                    key: +this.isLoading
                  });
                  if (!this.transition)
                    return image;
                  return this.$createElement("transition", {
                    attrs: {
                      name: this.transition,
                      mode: "in-out"
                    }
                  }, [image]);
                }
              },
              watch: {
                src: function src() {
                  if (!this.isLoading)
                    this.init(void 0, void 0, true);
                  else
                    this.loadImage();
                },
                "$vuetify.breakpoint.width": "getSrc"
              },
              mounted: function mounted3() {
                this.init();
              },
              methods: {
                init: function init2(entries, observer, isIntersecting) {
                  if (hasIntersect && !isIntersecting && !this.eager)
                    return;
                  if (this.normalisedSrc.lazySrc) {
                    var lazyImg = new Image();
                    lazyImg.src = this.normalisedSrc.lazySrc;
                    this.pollForSize(lazyImg, null);
                  }
                  if (this.normalisedSrc.src)
                    this.loadImage();
                },
                onLoad: function onLoad() {
                  this.getSrc();
                  this.isLoading = false;
                  this.$emit("load", this.src);
                  if (this.image && (this.normalisedSrc.src.endsWith(".svg") || this.normalisedSrc.src.startsWith("data:image/svg+xml"))) {
                    if (this.image.naturalHeight && this.image.naturalWidth) {
                      this.naturalWidth = this.image.naturalWidth;
                      this.calculatedAspectRatio = this.image.naturalWidth / this.image.naturalHeight;
                    } else {
                      this.calculatedAspectRatio = 1;
                    }
                  }
                },
                onError: function onError() {
                  this.hasError = true;
                  this.$emit("error", this.src);
                },
                getSrc: function getSrc() {
                  if (this.image)
                    this.currentSrc = this.image.currentSrc || this.image.src;
                },
                loadImage: function loadImage2() {
                  var _this2 = this;
                  var image = new Image();
                  this.image = image;
                  image.onload = function() {
                    if (image.decode) {
                      image.decode().catch(function(err2) {
                        Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["consoleWarn"])("Failed to decode image, trying to render anyway\n\n" + ("src: " + _this2.normalisedSrc.src) + (err2.message ? "\nOriginal error: " + err2.message : ""), _this2);
                      }).then(_this2.onLoad);
                    } else {
                      _this2.onLoad();
                    }
                  };
                  image.onerror = this.onError;
                  this.hasError = false;
                  this.sizes && (image.sizes = this.sizes);
                  this.normalisedSrc.srcset && (image.srcset = this.normalisedSrc.srcset);
                  image.src = this.normalisedSrc.src;
                  this.$emit("loadstart", this.normalisedSrc.src);
                  this.aspectRatio || this.pollForSize(image);
                  this.getSrc();
                },
                pollForSize: function pollForSize(img, timeout) {
                  var _this2 = this;
                  if (timeout === void 0) {
                    timeout = 100;
                  }
                  var poll = function poll2() {
                    var naturalHeight = img.naturalHeight, naturalWidth = img.naturalWidth;
                    if (naturalHeight || naturalWidth) {
                      _this2.naturalWidth = naturalWidth;
                      _this2.calculatedAspectRatio = naturalWidth / naturalHeight;
                    } else if (!img.complete && _this2.isLoading && !_this2.hasError && timeout != null) {
                      setTimeout(poll2, timeout);
                    }
                  };
                  poll();
                },
                genContent: function genContent() {
                  var content = _VResponsive__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genContent.call(this);
                  if (this.naturalWidth) {
                    this._b(content.data, "div", {
                      style: {
                        width: this.naturalWidth + "px"
                      }
                    });
                  }
                  return content;
                },
                __genPlaceholder: function __genPlaceholder() {
                  var slot = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getSlot"])(this, "placeholder");
                  if (slot) {
                    var placeholder2 = this.isLoading ? [this.$createElement("div", {
                      staticClass: "v-image__placeholder"
                    }, slot)] : [];
                    if (!this.transition)
                      return placeholder2[0];
                    return this.$createElement("transition", {
                      props: {
                        appear: true,
                        name: this.transition
                      }
                    }, placeholder2);
                  }
                }
              },
              render: function render8(h) {
                var node2 = _VResponsive__WEBPACK_IMPORTED_MODULE_2__["default"].options.render.call(this, h);
                var data = Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_5__["default"])(node2.data, {
                  staticClass: "v-image",
                  attrs: {
                    "aria-label": this.alt,
                    role: this.alt ? "img" : void 0
                  },
                  class: this.themeClasses,
                  // Only load intersect directive if it
                  // will work in the current browser.
                  directives: hasIntersect ? [{
                    name: "intersect",
                    modifiers: {
                      once: true
                    },
                    value: {
                      handler: this.init,
                      options: this.options
                    }
                  }] : void 0
                });
                node2.children = [this.__cachedSizer, this.__cachedImage, this.__genPlaceholder(), this.genContent()];
                return h(node2.tag, data, node2.children);
              }
            });
          }
        ),
        /***/
        "./src/components/VImg/index.ts": (
          /*!**************************************!*\
            !*** ./src/components/VImg/index.ts ***!
            \**************************************/
          /*! exports provided: VImg, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VImg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VImg */
              "./src/components/VImg/VImg.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VImg", function() {
              return _VImg__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VImg__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VInput/VInput.sass": (
          /*!*******************************************!*\
            !*** ./src/components/VInput/VInput.sass ***!
            \*******************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VInput/VInput.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VInput/VInput.ts ***!
            \*****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VInput.sass */
              "./src/components/VInput/VInput.sass"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _VLabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VLabel */
              "./src/components/VLabel/index.ts"
            );
            var _VMessages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VMessages */
              "./src/components/VMessages/index.ts"
            );
            var _mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/binds-attrs */
              "./src/mixins/binds-attrs/index.ts"
            );
            var _mixins_validatable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/validatable */
              "./src/mixins/validatable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__["default"])(_mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_validatable__WEBPACK_IMPORTED_MODULE_5__["default"]);
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-input",
              inheritAttrs: false,
              props: {
                appendIcon: String,
                backgroundColor: {
                  type: String,
                  default: ""
                },
                dense: Boolean,
                height: [Number, String],
                hideDetails: [Boolean, String],
                hideSpinButtons: Boolean,
                hint: String,
                id: String,
                label: String,
                loading: Boolean,
                persistentHint: Boolean,
                prependIcon: String,
                value: null
              },
              data: function data() {
                return {
                  lazyValue: this.value,
                  hasMouseDown: false
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-input--has-state": this.hasState,
                    "v-input--hide-details": !this.showDetails,
                    "v-input--is-label-active": this.isLabelActive,
                    "v-input--is-dirty": this.isDirty,
                    "v-input--is-disabled": this.isDisabled,
                    "v-input--is-focused": this.isFocused,
                    // <v-switch loading>.loading === '' so we can't just cast to boolean
                    "v-input--is-loading": this.loading !== false && this.loading != null,
                    "v-input--is-readonly": this.isReadonly,
                    "v-input--dense": this.dense,
                    "v-input--hide-spin-buttons": this.hideSpinButtons
                  }, this.themeClasses);
                },
                computedId: function computedId() {
                  return this.id || "input-" + this._uid;
                },
                hasDetails: function hasDetails() {
                  return this.messagesToDisplay.length > 0;
                },
                hasHint: function hasHint() {
                  return !this.hasMessages && !!this.hint && (this.persistentHint || this.isFocused);
                },
                hasLabel: function hasLabel() {
                  return !!(this.$slots.label || this.label);
                },
                // Proxy for `lazyValue`
                // This allows an input
                // to function without
                // a provided model
                internalValue: {
                  get: function get5() {
                    return this.lazyValue;
                  },
                  set: function set2(val) {
                    this.lazyValue = val;
                    this.$emit(this.$_modelEvent, val);
                  }
                },
                isDirty: function isDirty() {
                  return !!this.lazyValue;
                },
                isLabelActive: function isLabelActive() {
                  return this.isDirty;
                },
                messagesToDisplay: function messagesToDisplay() {
                  var _this2 = this;
                  if (this.hasHint)
                    return [this.hint];
                  if (!this.hasMessages)
                    return [];
                  return this.validations.map(function(validation) {
                    if (typeof validation === "string")
                      return validation;
                    var validationResult = validation(_this2.internalValue);
                    return typeof validationResult === "string" ? validationResult : "";
                  }).filter(function(message) {
                    return message !== "";
                  });
                },
                showDetails: function showDetails() {
                  return this.hideDetails === false || this.hideDetails === "auto" && this.hasDetails;
                }
              },
              watch: {
                value: function value(val) {
                  this.lazyValue = val;
                }
              },
              beforeCreate: function beforeCreate() {
                this.$_modelEvent = this.$options.model && this.$options.model.event || "input";
              },
              methods: {
                genContent: function genContent() {
                  return [this.genPrependSlot(), this.genControl(), this.genAppendSlot()];
                },
                genControl: function genControl() {
                  return this.$createElement("div", {
                    staticClass: "v-input__control",
                    attrs: {
                      title: this.attrs$.title
                    }
                  }, [this.genInputSlot(), this.genMessages()]);
                },
                genDefaultSlot: function genDefaultSlot() {
                  return [this.genLabel(), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getSlot"])(this)];
                },
                genIcon: function genIcon(type, cb, extraData) {
                  var _this2 = this;
                  var _a2;
                  if (extraData === void 0) {
                    extraData = {};
                  }
                  var icon = this[type + "Icon"];
                  var eventName = "click:" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["kebabCase"])(type);
                  var hasListener = !!(this.listeners$[eventName] || cb);
                  var localeKey = {
                    prepend: "prependAction",
                    prependInner: "prependAction",
                    append: "appendAction",
                    appendOuter: "appendAction",
                    clear: "clear"
                  }[type];
                  var label = hasListener && localeKey ? this.$vuetify.lang.t("$vuetify.input." + localeKey, (_a2 = this.label) !== null && _a2 !== void 0 ? _a2 : "") : void 0;
                  var data = Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_7__["default"])({
                    attrs: {
                      "aria-label": label,
                      color: this.validationState,
                      dark: this.dark,
                      disabled: this.isDisabled,
                      light: this.light,
                      tabindex: type === "clear" ? -1 : void 0
                    },
                    on: !hasListener ? void 0 : {
                      click: function click2(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        _this2.$emit(eventName, e);
                        cb && cb(e);
                      },
                      // Container has g event that will
                      // trigger menu open if enclosed
                      mouseup: function mouseup(e) {
                        e.preventDefault();
                        e.stopPropagation();
                      }
                    }
                  }, extraData);
                  return this.$createElement("div", {
                    staticClass: "v-input__icon",
                    class: type ? "v-input__icon--" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["kebabCase"])(type) : void 0
                  }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], data, icon)]);
                },
                genInputSlot: function genInputSlot() {
                  return this.$createElement("div", this.setBackgroundColor(this.backgroundColor, {
                    staticClass: "v-input__slot",
                    style: {
                      height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["convertToUnit"])(this.height)
                    },
                    on: {
                      click: this.onClick,
                      mousedown: this.onMouseDown,
                      mouseup: this.onMouseUp
                    },
                    ref: "input-slot"
                  }), [this.genDefaultSlot()]);
                },
                genLabel: function genLabel() {
                  if (!this.hasLabel)
                    return null;
                  return this.$createElement(_VLabel__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    props: {
                      color: this.validationState,
                      dark: this.dark,
                      disabled: this.isDisabled,
                      focused: this.hasState,
                      for: this.computedId,
                      light: this.light
                    }
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getSlot"])(this, "label") || this.label);
                },
                genMessages: function genMessages() {
                  var _this2 = this;
                  if (!this.showDetails)
                    return null;
                  return this.$createElement(_VMessages__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    props: {
                      color: this.hasHint ? "" : this.validationState,
                      dark: this.dark,
                      light: this.light,
                      value: this.messagesToDisplay
                    },
                    attrs: {
                      role: this.hasMessages ? "alert" : null
                    },
                    scopedSlots: {
                      default: function _default(props2) {
                        return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getSlot"])(_this2, "message", props2);
                      }
                    }
                  });
                },
                genSlot: function genSlot(type, location2, slot) {
                  if (!slot.length)
                    return null;
                  var ref2 = type + "-" + location2;
                  return this.$createElement("div", {
                    staticClass: "v-input__" + ref2,
                    ref: ref2
                  }, slot);
                },
                genPrependSlot: function genPrependSlot() {
                  var slot = [];
                  if (this.$slots.prepend) {
                    slot.push(this.$slots.prepend);
                  } else if (this.prependIcon) {
                    slot.push(this.genIcon("prepend"));
                  }
                  return this.genSlot("prepend", "outer", slot);
                },
                genAppendSlot: function genAppendSlot() {
                  var slot = [];
                  if (this.$slots.append) {
                    slot.push(this.$slots.append);
                  } else if (this.appendIcon) {
                    slot.push(this.genIcon("append"));
                  }
                  return this.genSlot("append", "outer", slot);
                },
                onClick: function onClick(e) {
                  this.$emit("click", e);
                },
                onMouseDown: function onMouseDown(e) {
                  this.hasMouseDown = true;
                  this.$emit("mousedown", e);
                },
                onMouseUp: function onMouseUp(e) {
                  this.hasMouseDown = false;
                  this.$emit("mouseup", e);
                }
              },
              render: function render8(h) {
                return h("div", this.setTextColor(this.validationState, {
                  staticClass: "v-input",
                  class: this.classes
                }), this.genContent());
              }
            });
          }
        ),
        /***/
        "./src/components/VInput/index.ts": (
          /*!****************************************!*\
            !*** ./src/components/VInput/index.ts ***!
            \****************************************/
          /*! exports provided: VInput, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VInput */
              "./src/components/VInput/VInput.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VInput", function() {
              return _VInput__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VInput__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VItemGroup/VItem.sass": (
          /*!**********************************************!*\
            !*** ./src/components/VItemGroup/VItem.sass ***!
            \**********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VItemGroup/VItem.ts": (
          /*!********************************************!*\
            !*** ./src/components/VItemGroup/VItem.ts ***!
            \********************************************/
          /*! exports provided: BaseItem, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "BaseItem", function() {
              return BaseItem;
            });
            __webpack_require__(
              /*! ./VItem.sass */
              "./src/components/VItemGroup/VItem.sass"
            );
            var _mixins_groupable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/groupable */
              "./src/mixins/groupable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_4___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_4__);
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var BaseItem = vue__WEBPACK_IMPORTED_MODULE_4___default.a.extend({
              props: {
                activeClass: String,
                value: {
                  required: false
                },
                disabled: Boolean
              },
              data: function data() {
                return {
                  isActive: false
                };
              },
              methods: {
                toggle: function toggle() {
                  this.isActive = !this.isActive;
                }
              },
              render: function render8() {
                var _a2;
                if (!this.$scopedSlots.default) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["consoleWarn"])("v-item is missing a default scopedSlot", this);
                  return null;
                }
                var element;
                if (this.$scopedSlots.default) {
                  element = this.$scopedSlots.default({
                    active: this.isActive,
                    toggle: this.toggle
                  });
                }
                if (Array.isArray(element) && element.length === 1) {
                  element = element[0];
                }
                if (!element || Array.isArray(element) || !element.tag) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["consoleWarn"])("v-item should only contain a single element", this);
                  return element;
                }
                element.data = this._b(element.data || {}, element.tag, {
                  class: (_a2 = {}, _a2[this.activeClass] = this.isActive, _a2["v-item--disabled"] = this.disabled, _a2)
                });
                if (this.disabled) {
                  element.data.attrs = __assign2(__assign2({}, element.data.attrs), {
                    tabindex: -1
                  });
                }
                return element;
              }
            });
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(BaseItem, Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_1__["factory"])("itemGroup", "v-item", "v-item-group")).extend({
              name: "v-item"
            });
          }
        ),
        /***/
        "./src/components/VItemGroup/VItemGroup.sass": (
          /*!***************************************************!*\
            !*** ./src/components/VItemGroup/VItemGroup.sass ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VItemGroup/VItemGroup.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VItemGroup/VItemGroup.ts ***!
            \*************************************************/
          /*! exports provided: BaseItemGroup, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "BaseItemGroup", function() {
              return BaseItemGroup;
            });
            __webpack_require__(
              /*! ./VItemGroup.sass */
              "./src/components/VItemGroup/VItemGroup.sass"
            );
            var _mixins_comparable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/comparable */
              "./src/mixins/comparable/index.ts"
            );
            var _mixins_proxyable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/proxyable */
              "./src/mixins/proxyable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var BaseItemGroup = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_comparable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_proxyable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]).extend({
              name: "base-item-group",
              props: {
                activeClass: {
                  type: String,
                  default: "v-item--active"
                },
                mandatory: Boolean,
                max: {
                  type: [Number, String],
                  default: null
                },
                multiple: Boolean,
                tag: {
                  type: String,
                  default: "div"
                }
              },
              data: function data() {
                return {
                  // As long as a value is defined, show it
                  // Otherwise, check if multiple
                  // to determine which default to provide
                  internalLazyValue: this.value !== void 0 ? this.value : this.multiple ? [] : void 0,
                  items: []
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-item-group": true
                  }, this.themeClasses);
                },
                selectedIndex: function selectedIndex() {
                  return this.selectedItem && this.items.indexOf(this.selectedItem) || -1;
                },
                selectedItem: function selectedItem() {
                  if (this.multiple)
                    return void 0;
                  return this.selectedItems[0];
                },
                selectedItems: function selectedItems() {
                  var _this2 = this;
                  return this.items.filter(function(item, index2) {
                    return _this2.toggleMethod(_this2.getValue(item, index2));
                  });
                },
                selectedValues: function selectedValues() {
                  if (this.internalValue == null)
                    return [];
                  return Array.isArray(this.internalValue) ? this.internalValue : [this.internalValue];
                },
                toggleMethod: function toggleMethod() {
                  var _this2 = this;
                  if (!this.multiple) {
                    return function(v) {
                      return _this2.valueComparator(_this2.internalValue, v);
                    };
                  }
                  var internalValue = this.internalValue;
                  if (Array.isArray(internalValue)) {
                    return function(v) {
                      return internalValue.some(function(intern) {
                        return _this2.valueComparator(intern, v);
                      });
                    };
                  }
                  return function() {
                    return false;
                  };
                }
              },
              watch: {
                internalValue: "updateItemsState",
                items: "updateItemsState"
              },
              created: function created2() {
                if (this.multiple && !Array.isArray(this.internalValue)) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_5__["consoleWarn"])("Model must be bound to an array if the multiple property is true.", this);
                }
              },
              methods: {
                genData: function genData() {
                  return {
                    class: this.classes
                  };
                },
                getValue: function getValue2(item, i2) {
                  return item.value === void 0 ? i2 : item.value;
                },
                onClick: function onClick(item) {
                  this.updateInternalValue(this.getValue(item, this.items.indexOf(item)));
                },
                register: function register(item) {
                  var _this2 = this;
                  var index2 = this.items.push(item) - 1;
                  item.$on("change", function() {
                    return _this2.onClick(item);
                  });
                  if (this.mandatory && !this.selectedValues.length) {
                    this.updateMandatory();
                  }
                  this.updateItem(item, index2);
                },
                unregister: function unregister(item) {
                  if (this._isDestroyed)
                    return;
                  var index2 = this.items.indexOf(item);
                  var value = this.getValue(item, index2);
                  this.items.splice(index2, 1);
                  var valueIndex = this.selectedValues.indexOf(value);
                  if (valueIndex < 0)
                    return;
                  if (!this.mandatory) {
                    return this.updateInternalValue(value);
                  }
                  if (this.multiple && Array.isArray(this.internalValue)) {
                    this.internalValue = this.internalValue.filter(function(v) {
                      return v !== value;
                    });
                  } else {
                    this.internalValue = void 0;
                  }
                  if (!this.selectedItems.length) {
                    this.updateMandatory(true);
                  }
                },
                updateItem: function updateItem(item, index2) {
                  var value = this.getValue(item, index2);
                  item.isActive = this.toggleMethod(value);
                },
                // https://github.com/vuetifyjs/vuetify/issues/5352
                updateItemsState: function updateItemsState() {
                  var _this2 = this;
                  this.$nextTick(function() {
                    if (_this2.mandatory && !_this2.selectedItems.length) {
                      return _this2.updateMandatory();
                    }
                    _this2.items.forEach(_this2.updateItem);
                  });
                },
                updateInternalValue: function updateInternalValue(value) {
                  this.multiple ? this.updateMultiple(value) : this.updateSingle(value);
                },
                updateMandatory: function updateMandatory(last2) {
                  if (!this.items.length)
                    return;
                  var items = this.items.slice();
                  if (last2)
                    items.reverse();
                  var item = items.find(function(item2) {
                    return !item2.disabled;
                  });
                  if (!item)
                    return;
                  var index2 = this.items.indexOf(item);
                  this.updateInternalValue(this.getValue(item, index2));
                },
                updateMultiple: function updateMultiple(value) {
                  var _this2 = this;
                  var defaultValue = Array.isArray(this.internalValue) ? this.internalValue : [];
                  var internalValue = defaultValue.slice();
                  var index2 = internalValue.findIndex(function(val) {
                    return _this2.valueComparator(val, value);
                  });
                  if (this.mandatory && // Item already exists
                  index2 > -1 && // value would be reduced below min
                  internalValue.length - 1 < 1)
                    return;
                  if (
                    // Max is set
                    this.max != null && // Item doesn't exist
                    index2 < 0 && // value would be increased above max
                    internalValue.length + 1 > this.max
                  )
                    return;
                  index2 > -1 ? internalValue.splice(index2, 1) : internalValue.push(value);
                  this.internalValue = internalValue;
                },
                updateSingle: function updateSingle(value) {
                  var isSame2 = this.valueComparator(this.internalValue, value);
                  if (this.mandatory && isSame2)
                    return;
                  this.internalValue = isSame2 ? void 0 : value;
                }
              },
              render: function render8(h) {
                return h(this.tag, this.genData(), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getSlot"])(this));
              }
            });
            __webpack_exports__["default"] = BaseItemGroup.extend({
              name: "v-item-group",
              provide: function provide() {
                return {
                  itemGroup: this
                };
              }
            });
          }
        ),
        /***/
        "./src/components/VItemGroup/index.ts": (
          /*!********************************************!*\
            !*** ./src/components/VItemGroup/index.ts ***!
            \********************************************/
          /*! exports provided: VItem, VItemGroup, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VItem */
              "./src/components/VItemGroup/VItem.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VItem", function() {
              return _VItem__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VItemGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VItemGroup */
              "./src/components/VItemGroup/VItemGroup.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VItemGroup", function() {
              return _VItemGroup__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VItem: _VItem__WEBPACK_IMPORTED_MODULE_0__["default"],
                VItemGroup: _VItemGroup__WEBPACK_IMPORTED_MODULE_1__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VLabel/VLabel.sass": (
          /*!*******************************************!*\
            !*** ./src/components/VLabel/VLabel.sass ***!
            \*******************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VLabel/VLabel.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VLabel/VLabel.ts ***!
            \*****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VLabel.sass */
              "./src/components/VLabel/VLabel.sass"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]).extend({
              name: "v-label",
              functional: true,
              props: {
                absolute: Boolean,
                color: {
                  type: String,
                  default: "primary"
                },
                disabled: Boolean,
                focused: Boolean,
                for: String,
                left: {
                  type: [Number, String],
                  default: 0
                },
                right: {
                  type: [Number, String],
                  default: "auto"
                },
                value: Boolean
              },
              render: function render8(h, ctx) {
                var children = ctx.children, listeners = ctx.listeners, props2 = ctx.props, data = ctx.data;
                var newData = Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_5__["default"])({
                  staticClass: "v-label",
                  class: __assign2({
                    "v-label--active": props2.value,
                    "v-label--is-disabled": props2.disabled
                  }, Object(_mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["functionalThemeClasses"])(ctx)),
                  attrs: {
                    for: props2.for,
                    "aria-hidden": !props2.for
                  },
                  on: listeners,
                  style: {
                    left: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(props2.left),
                    right: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(props2.right),
                    position: props2.absolute ? "absolute" : "relative"
                  },
                  ref: "label"
                }, data);
                return h("label", _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.setTextColor(props2.focused && props2.color, newData), children);
              }
            });
          }
        ),
        /***/
        "./src/components/VLabel/index.ts": (
          /*!****************************************!*\
            !*** ./src/components/VLabel/index.ts ***!
            \****************************************/
          /*! exports provided: VLabel, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VLabel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VLabel */
              "./src/components/VLabel/VLabel.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VLabel", function() {
              return _VLabel__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VLabel__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VLazy/VLazy.ts": (
          /*!***************************************!*\
            !*** ./src/components/VLazy/VLazy.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_measurable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../mixins/measurable */
              "./src/mixins/measurable/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _directives_intersect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../directives/intersect */
              "./src/directives/intersect/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_measurable__WEBPACK_IMPORTED_MODULE_0__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
              name: "VLazy",
              directives: {
                intersect: _directives_intersect__WEBPACK_IMPORTED_MODULE_2__["default"]
              },
              props: {
                options: {
                  type: Object,
                  // For more information on types, navigate to:
                  // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
                  default: function _default() {
                    return {
                      root: void 0,
                      rootMargin: void 0,
                      threshold: void 0
                    };
                  }
                },
                tag: {
                  type: String,
                  default: "div"
                },
                transition: {
                  type: String,
                  default: "fade-transition"
                }
              },
              computed: {
                styles: function styles() {
                  return __assign2({}, this.measurableStyles);
                }
              },
              methods: {
                genContent: function genContent() {
                  var children = this.isActive && Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getSlot"])(this);
                  return this.transition ? this.$createElement("transition", {
                    props: {
                      name: this.transition
                    }
                  }, children) : children;
                },
                onObserve: function onObserve(entries, observer, isIntersecting) {
                  if (this.isActive)
                    return;
                  this.isActive = isIntersecting;
                }
              },
              render: function render8(h) {
                return h(this.tag, {
                  staticClass: "v-lazy",
                  attrs: this.$attrs,
                  directives: [{
                    name: "intersect",
                    value: {
                      handler: this.onObserve,
                      options: this.options
                    }
                  }],
                  on: this.$listeners,
                  style: this.styles
                }, [this.genContent()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VLazy/index.ts": (
          /*!***************************************!*\
            !*** ./src/components/VLazy/index.ts ***!
            \***************************************/
          /*! exports provided: VLazy, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VLazy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VLazy */
              "./src/components/VLazy/VLazy.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VLazy", function() {
              return _VLazy__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VLazy__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VList/VList.sass": (
          /*!*****************************************!*\
            !*** ./src/components/VList/VList.sass ***!
            \*****************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VList/VList.ts": (
          /*!***************************************!*\
            !*** ./src/components/VList/VList.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VList.sass */
              "./src/components/VList/VList.sass"
            );
            var _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSheet/VSheet */
              "./src/components/VSheet/VSheet.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __values2 = function(o) {
              var s2 = typeof Symbol === "function" && Symbol.iterator, m = s2 && o[s2], i2 = 0;
              if (m)
                return m.call(o);
              if (o && typeof o.length === "number")
                return {
                  next: function next() {
                    if (o && i2 >= o.length)
                      o = void 0;
                    return {
                      value: o && o[i2++],
                      done: !o
                    };
                  }
                };
              throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            __webpack_exports__["default"] = _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].extend().extend({
              name: "v-list",
              provide: function provide() {
                return {
                  isInList: true,
                  list: this
                };
              },
              inject: {
                isInMenu: {
                  default: false
                },
                isInNav: {
                  default: false
                }
              },
              props: {
                dense: Boolean,
                disabled: Boolean,
                expand: Boolean,
                flat: Boolean,
                nav: Boolean,
                rounded: Boolean,
                subheader: Boolean,
                threeLine: Boolean,
                twoLine: Boolean
              },
              data: function data() {
                return {
                  groups: []
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-list--dense": this.dense,
                    "v-list--disabled": this.disabled,
                    "v-list--flat": this.flat,
                    "v-list--nav": this.nav,
                    "v-list--rounded": this.rounded,
                    "v-list--subheader": this.subheader,
                    "v-list--two-line": this.twoLine,
                    "v-list--three-line": this.threeLine
                  });
                }
              },
              methods: {
                register: function register(content) {
                  this.groups.push(content);
                },
                unregister: function unregister(content) {
                  var index2 = this.groups.findIndex(function(g) {
                    return g._uid === content._uid;
                  });
                  if (index2 > -1)
                    this.groups.splice(index2, 1);
                },
                listClick: function listClick(uid2) {
                  var e_1, _a2;
                  if (this.expand)
                    return;
                  try {
                    for (var _b2 = __values2(this.groups), _c = _b2.next(); !_c.done; _c = _b2.next()) {
                      var group = _c.value;
                      group.toggle(uid2);
                    }
                  } catch (e_1_1) {
                    e_1 = {
                      error: e_1_1
                    };
                  } finally {
                    try {
                      if (_c && !_c.done && (_a2 = _b2.return))
                        _a2.call(_b2);
                    } finally {
                      if (e_1)
                        throw e_1.error;
                    }
                  }
                }
              },
              render: function render8(h) {
                var data = {
                  staticClass: "v-list",
                  class: this.classes,
                  style: this.styles,
                  attrs: __assign2({
                    role: this.isInNav || this.isInMenu ? void 0 : "list"
                  }, this.attrs$),
                  on: this.listeners$
                };
                return h(this.tag, this.setBackgroundColor(this.color, data), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["getSlot"])(this));
              }
            });
          }
        ),
        /***/
        "./src/components/VList/VListGroup.sass": (
          /*!**********************************************!*\
            !*** ./src/components/VList/VListGroup.sass ***!
            \**********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VList/VListGroup.ts": (
          /*!********************************************!*\
            !*** ./src/components/VList/VListGroup.ts ***!
            \********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VListGroup.sass */
              "./src/components/VList/VListGroup.sass"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _VListItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VListItem */
              "./src/components/VList/VListItem.ts"
            );
            var _VListItemIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VListItemIcon */
              "./src/components/VList/VListItemIcon.ts"
            );
            var _mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/binds-attrs */
              "./src/mixins/binds-attrs/index.ts"
            );
            var _mixins_bootable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/bootable */
              "./src/mixins/bootable/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _mixins_registrable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../mixins/registrable */
              "./src/mixins/registrable/index.ts"
            );
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var _transitions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ../transitions */
              "./src/components/transitions/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_11__["default"])(_mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_bootable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_colorable__WEBPACK_IMPORTED_MODULE_6__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_8__["inject"])("list"), _mixins_toggleable__WEBPACK_IMPORTED_MODULE_7__["default"]);
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-list-group",
              directives: {
                ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_9__["default"]
              },
              props: {
                activeClass: {
                  type: String,
                  default: ""
                },
                appendIcon: {
                  type: String,
                  default: "$expand"
                },
                color: {
                  type: String,
                  default: "primary"
                },
                disabled: Boolean,
                group: [String, RegExp],
                noAction: Boolean,
                prependIcon: String,
                ripple: {
                  type: [Boolean, Object],
                  default: true
                },
                subGroup: Boolean
              },
              computed: {
                classes: function classes() {
                  return {
                    "v-list-group--active": this.isActive,
                    "v-list-group--disabled": this.disabled,
                    "v-list-group--no-action": this.noAction,
                    "v-list-group--sub-group": this.subGroup
                  };
                }
              },
              watch: {
                isActive: function isActive(val) {
                  if (!this.subGroup && val) {
                    this.list && this.list.listClick(this._uid);
                  }
                },
                $route: "onRouteChange"
              },
              created: function created2() {
                this.list && this.list.register(this);
                if (this.group && this.$route && this.value == null) {
                  this.isActive = this.matchRoute(this.$route.path);
                }
              },
              beforeDestroy: function beforeDestroy2() {
                this.list && this.list.unregister(this);
              },
              methods: {
                click: function click2(e) {
                  var _this2 = this;
                  if (this.disabled)
                    return;
                  this.isBooted = true;
                  this.$emit("click", e);
                  this.$nextTick(function() {
                    return _this2.isActive = !_this2.isActive;
                  });
                },
                genIcon: function genIcon(icon) {
                  return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], icon);
                },
                genAppendIcon: function genAppendIcon() {
                  var icon = !this.subGroup ? this.appendIcon : false;
                  var slot = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["getSlot"])(this, "appendIcon");
                  if (!icon && !slot)
                    return null;
                  return this.$createElement(_VListItemIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    staticClass: "v-list-group__header__append-icon"
                  }, [slot || this.genIcon(icon)]);
                },
                genHeader: function genHeader() {
                  var _a2;
                  return this.$createElement(_VListItem__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    staticClass: "v-list-group__header",
                    attrs: {
                      "aria-expanded": String(this.isActive),
                      role: "button"
                    },
                    class: (_a2 = {}, _a2[this.activeClass] = this.isActive, _a2),
                    props: {
                      inputValue: this.isActive
                    },
                    directives: [{
                      name: "ripple",
                      value: this.ripple
                    }],
                    on: __assign2(__assign2({}, this.listeners$), {
                      click: this.click
                    })
                  }, [this.genPrependIcon(), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["getSlot"])(this, "activator"), this.genAppendIcon()]);
                },
                genItems: function genItems() {
                  var _this2 = this;
                  return this.showLazyContent(function() {
                    return [_this2.$createElement("div", {
                      staticClass: "v-list-group__items",
                      directives: [{
                        name: "show",
                        value: _this2.isActive
                      }]
                    }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["getSlot"])(_this2))];
                  });
                },
                genPrependIcon: function genPrependIcon() {
                  var icon = this.subGroup && this.prependIcon == null ? "$subgroup" : this.prependIcon;
                  var slot = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["getSlot"])(this, "prependIcon");
                  if (!icon && !slot)
                    return null;
                  return this.$createElement(_VListItemIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    staticClass: "v-list-group__header__prepend-icon"
                  }, [slot || this.genIcon(icon)]);
                },
                onRouteChange: function onRouteChange(to) {
                  if (!this.group)
                    return;
                  var isActive = this.matchRoute(to.path);
                  if (isActive && this.isActive !== isActive) {
                    this.list && this.list.listClick(this._uid);
                  }
                  this.isActive = isActive;
                },
                toggle: function toggle(uid2) {
                  var _this2 = this;
                  var isActive = this._uid === uid2;
                  if (isActive)
                    this.isBooted = true;
                  this.$nextTick(function() {
                    return _this2.isActive = isActive;
                  });
                },
                matchRoute: function matchRoute(to) {
                  return to.match(this.group) !== null;
                }
              },
              render: function render8(h) {
                return h("div", this.setTextColor(this.isActive && this.color, {
                  staticClass: "v-list-group",
                  class: this.classes
                }), [this.genHeader(), h(_transitions__WEBPACK_IMPORTED_MODULE_10__["VExpandTransition"], this.genItems())]);
              }
            });
          }
        ),
        /***/
        "./src/components/VList/VListItem.sass": (
          /*!*********************************************!*\
            !*** ./src/components/VList/VListItem.sass ***!
            \*********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VList/VListItem.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VList/VListItem.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VListItem.sass */
              "./src/components/VList/VListItem.sass"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_routable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/routable */
              "./src/mixins/routable/index.ts"
            );
            var _mixins_groupable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/groupable */
              "./src/mixins/groupable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ./../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_9__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_routable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__["default"], Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_3__["factory"])("listItemGroup"), Object(_mixins_toggleable__WEBPACK_IMPORTED_MODULE_5__["factory"])("inputValue"));
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-list-item",
              directives: {
                Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_6__["default"]
              },
              inject: {
                isInGroup: {
                  default: false
                },
                isInList: {
                  default: false
                },
                isInMenu: {
                  default: false
                },
                isInNav: {
                  default: false
                }
              },
              inheritAttrs: false,
              props: {
                activeClass: {
                  type: String,
                  default: function _default() {
                    if (!this.listItemGroup)
                      return "";
                    return this.listItemGroup.activeClass;
                  }
                },
                dense: Boolean,
                inactive: Boolean,
                link: Boolean,
                selectable: {
                  type: Boolean
                },
                tag: {
                  type: String,
                  default: "div"
                },
                threeLine: Boolean,
                twoLine: Boolean,
                value: null
              },
              data: function data() {
                return {
                  proxyClass: "v-list-item--active"
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2(__assign2({
                    "v-list-item": true
                  }, _mixins_routable__WEBPACK_IMPORTED_MODULE_2__["default"].options.computed.classes.call(this)), {
                    "v-list-item--dense": this.dense,
                    "v-list-item--disabled": this.disabled,
                    "v-list-item--link": this.isClickable && !this.inactive,
                    "v-list-item--selectable": this.selectable,
                    "v-list-item--three-line": this.threeLine,
                    "v-list-item--two-line": this.twoLine
                  }), this.themeClasses);
                },
                isClickable: function isClickable() {
                  return Boolean(_mixins_routable__WEBPACK_IMPORTED_MODULE_2__["default"].options.computed.isClickable.call(this) || this.listItemGroup);
                }
              },
              created: function created2() {
                if (this.$attrs.hasOwnProperty("avatar")) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["removed"])("avatar", this);
                }
              },
              methods: {
                click: function click2(e) {
                  if (e.detail)
                    this.$el.blur();
                  this.$emit("click", e);
                  this.to || this.toggle();
                },
                genAttrs: function genAttrs() {
                  var attrs2 = __assign2({
                    "aria-disabled": this.disabled ? true : void 0,
                    tabindex: this.isClickable && !this.disabled ? 0 : -1
                  }, this.$attrs);
                  if (this.$attrs.hasOwnProperty("role"))
                    ;
                  else if (this.isInNav)
                    ;
                  else if (this.isInGroup) {
                    attrs2.role = "option";
                    attrs2["aria-selected"] = String(this.isActive);
                  } else if (this.isInMenu) {
                    attrs2.role = this.isClickable ? "menuitem" : void 0;
                    attrs2.id = attrs2.id || "list-item-" + this._uid;
                  } else if (this.isInList) {
                    attrs2.role = "listitem";
                  }
                  return attrs2;
                },
                toggle: function toggle() {
                  if (this.to && this.inputValue === void 0) {
                    this.isActive = !this.isActive;
                  }
                  this.$emit("change");
                }
              },
              render: function render8(h) {
                var _this2 = this;
                var _a2 = this.generateRouteLink(), tag = _a2.tag, data = _a2.data;
                data.attrs = __assign2(__assign2({}, data.attrs), this.genAttrs());
                data[this.to ? "nativeOn" : "on"] = __assign2(__assign2({}, data[this.to ? "nativeOn" : "on"]), {
                  keydown: function keydown(e) {
                    if (!_this2.disabled) {
                      if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_7__["keyCodes"].enter)
                        _this2.click(e);
                      _this2.$emit("keydown", e);
                    }
                  }
                });
                if (this.inactive)
                  tag = "div";
                if (this.inactive && this.to) {
                  data.on = data.nativeOn;
                  delete data.nativeOn;
                }
                var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getSlot"])(this, "default", {
                  active: this.isActive,
                  toggle: this.toggle
                });
                return h(tag, this.isActive ? this.setTextColor(this.color, data) : data, children);
              }
            });
          }
        ),
        /***/
        "./src/components/VList/VListItemAction.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VList/VListItemAction.ts ***!
            \*************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "v-list-item-action",
              functional: true,
              render: function render8(h, _a2) {
                var data = _a2.data, _b2 = _a2.children, children = _b2 === void 0 ? [] : _b2;
                data.staticClass = data.staticClass ? "v-list-item__action " + data.staticClass : "v-list-item__action";
                var filteredChild = children.filter(function(VNode3) {
                  return VNode3.isComment === false && VNode3.text !== " ";
                });
                if (filteredChild.length > 1)
                  data.staticClass += " v-list-item__action--stack";
                return h("div", data, children);
              }
            });
          }
        ),
        /***/
        "./src/components/VList/VListItemAvatar.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VList/VListItemAvatar.ts ***!
            \*************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VAvatar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../VAvatar */
              "./src/components/VAvatar/index.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = _VAvatar__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
              name: "v-list-item-avatar",
              props: {
                horizontal: Boolean,
                size: {
                  type: [Number, String],
                  default: 40
                }
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({
                    "v-list-item__avatar--horizontal": this.horizontal
                  }, _VAvatar__WEBPACK_IMPORTED_MODULE_0__["default"].options.computed.classes.call(this)), {
                    "v-avatar--tile": this.tile || this.horizontal
                  });
                }
              },
              render: function render8(h) {
                var render9 = _VAvatar__WEBPACK_IMPORTED_MODULE_0__["default"].options.render.call(this, h);
                render9.data = render9.data || {};
                render9.data.staticClass += " v-list-item__avatar";
                return render9;
              }
            });
          }
        ),
        /***/
        "./src/components/VList/VListItemGroup.sass": (
          /*!**************************************************!*\
            !*** ./src/components/VList/VListItemGroup.sass ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VList/VListItemGroup.ts": (
          /*!************************************************!*\
            !*** ./src/components/VList/VListItemGroup.ts ***!
            \************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VListItemGroup.sass */
              "./src/components/VList/VListItemGroup.sass"
            );
            var _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VItemGroup/VItemGroup */
              "./src/components/VItemGroup/VItemGroup.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__["BaseItemGroup"], _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"]).extend({
              name: "v-list-item-group",
              provide: function provide() {
                return {
                  isInGroup: true,
                  listItemGroup: this
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__["BaseItemGroup"].options.computed.classes.call(this)), {
                    "v-list-item-group": true
                  });
                }
              },
              methods: {
                genData: function genData() {
                  return this.setTextColor(this.color, __assign2(__assign2({}, _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__["BaseItemGroup"].options.methods.genData.call(this)), {
                    attrs: {
                      role: "listbox"
                    }
                  }));
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VList/VListItemIcon.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VList/VListItemIcon.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "v-list-item-icon",
              functional: true,
              render: function render8(h, _a2) {
                var data = _a2.data, children = _a2.children;
                data.staticClass = ("v-list-item__icon " + (data.staticClass || "")).trim();
                return h("div", data, children);
              }
            });
          }
        ),
        /***/
        "./src/components/VList/index.ts": (
          /*!***************************************!*\
            !*** ./src/components/VList/index.ts ***!
            \***************************************/
          /*! exports provided: VListItemActionText, VListItemContent, VListItemTitle, VListItemSubtitle, VList, VListGroup, VListItem, VListItemAction, VListItemAvatar, VListItemIcon, VListItemGroup, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "VListItemActionText", function() {
              return VListItemActionText;
            });
            __webpack_require__.d(__webpack_exports__, "VListItemContent", function() {
              return VListItemContent;
            });
            __webpack_require__.d(__webpack_exports__, "VListItemTitle", function() {
              return VListItemTitle;
            });
            __webpack_require__.d(__webpack_exports__, "VListItemSubtitle", function() {
              return VListItemSubtitle;
            });
            var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _VList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VList */
              "./src/components/VList/VList.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VList", function() {
              return _VList__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _VListGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VListGroup */
              "./src/components/VList/VListGroup.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VListGroup", function() {
              return _VListGroup__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            var _VListItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VListItem */
              "./src/components/VList/VListItem.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VListItem", function() {
              return _VListItem__WEBPACK_IMPORTED_MODULE_3__["default"];
            });
            var _VListItemGroup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./VListItemGroup */
              "./src/components/VList/VListItemGroup.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VListItemGroup", function() {
              return _VListItemGroup__WEBPACK_IMPORTED_MODULE_4__["default"];
            });
            var _VListItemAction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./VListItemAction */
              "./src/components/VList/VListItemAction.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VListItemAction", function() {
              return _VListItemAction__WEBPACK_IMPORTED_MODULE_5__["default"];
            });
            var _VListItemAvatar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ./VListItemAvatar */
              "./src/components/VList/VListItemAvatar.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VListItemAvatar", function() {
              return _VListItemAvatar__WEBPACK_IMPORTED_MODULE_6__["default"];
            });
            var _VListItemIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ./VListItemIcon */
              "./src/components/VList/VListItemIcon.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VListItemIcon", function() {
              return _VListItemIcon__WEBPACK_IMPORTED_MODULE_7__["default"];
            });
            var VListItemActionText = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])("v-list-item__action-text", "span");
            var VListItemContent = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])("v-list-item__content", "div");
            var VListItemTitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])("v-list-item__title", "div");
            var VListItemSubtitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])("v-list-item__subtitle", "div");
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VList: _VList__WEBPACK_IMPORTED_MODULE_1__["default"],
                VListGroup: _VListGroup__WEBPACK_IMPORTED_MODULE_2__["default"],
                VListItem: _VListItem__WEBPACK_IMPORTED_MODULE_3__["default"],
                VListItemAction: _VListItemAction__WEBPACK_IMPORTED_MODULE_5__["default"],
                VListItemActionText,
                VListItemAvatar: _VListItemAvatar__WEBPACK_IMPORTED_MODULE_6__["default"],
                VListItemContent,
                VListItemGroup: _VListItemGroup__WEBPACK_IMPORTED_MODULE_4__["default"],
                VListItemIcon: _VListItemIcon__WEBPACK_IMPORTED_MODULE_7__["default"],
                VListItemSubtitle,
                VListItemTitle
              }
            };
          }
        ),
        /***/
        "./src/components/VMain/VMain.sass": (
          /*!*****************************************!*\
            !*** ./src/components/VMain/VMain.sass ***!
            \*****************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VMain/VMain.ts": (
          /*!***************************************!*\
            !*** ./src/components/VMain/VMain.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VMain.sass */
              "./src/components/VMain/VMain.sass"
            );
            var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/ssr-bootable */
              "./src/mixins/ssr-bootable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
              name: "v-main",
              props: {
                tag: {
                  type: String,
                  default: "main"
                }
              },
              computed: {
                styles: function styles() {
                  var _a2 = this.$vuetify.application, bar = _a2.bar, top = _a2.top, right = _a2.right, footer = _a2.footer, insetFooter = _a2.insetFooter, bottom = _a2.bottom, left = _a2.left;
                  return {
                    paddingTop: top + bar + "px",
                    paddingRight: right + "px",
                    paddingBottom: footer + insetFooter + bottom + "px",
                    paddingLeft: left + "px"
                  };
                }
              },
              render: function render8(h) {
                var data = {
                  staticClass: "v-main",
                  style: this.styles,
                  ref: "main"
                };
                return h(this.tag, data, [h("div", {
                  staticClass: "v-main__wrap"
                }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["getSlot"])(this))]);
              }
            });
          }
        ),
        /***/
        "./src/components/VMain/index.ts": (
          /*!***************************************!*\
            !*** ./src/components/VMain/index.ts ***!
            \***************************************/
          /*! exports provided: VMain, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VMain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VMain */
              "./src/components/VMain/VMain.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VMain", function() {
              return _VMain__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VMain__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VMenu/VMenu.sass": (
          /*!*****************************************!*\
            !*** ./src/components/VMenu/VMenu.sass ***!
            \*****************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VMenu/VMenu.ts": (
          /*!***************************************!*\
            !*** ./src/components/VMenu/VMenu.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VMenu.sass */
              "./src/components/VMenu/VMenu.sass"
            );
            var _VThemeProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VThemeProvider */
              "./src/components/VThemeProvider/index.ts"
            );
            var _mixins_activatable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/activatable */
              "./src/mixins/activatable/index.ts"
            );
            var _mixins_delayable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/delayable */
              "./src/mixins/delayable/index.ts"
            );
            var _mixins_dependent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/dependent */
              "./src/mixins/dependent/index.ts"
            );
            var _mixins_menuable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/menuable */
              "./src/mixins/menuable/index.ts"
            );
            var _mixins_returnable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/returnable */
              "./src/mixins/returnable/index.ts"
            );
            var _mixins_roundable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../mixins/roundable */
              "./src/mixins/roundable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _directives_click_outside__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../directives/click-outside */
              "./src/directives/click-outside/index.ts"
            );
            var _directives_resize__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ../../directives/resize */
              "./src/directives/resize/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _services_goto__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
              /*! ../../services/goto */
              "./src/services/goto/index.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_11__["default"])(_mixins_dependent__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_delayable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_returnable__WEBPACK_IMPORTED_MODULE_6__["default"], _mixins_roundable__WEBPACK_IMPORTED_MODULE_7__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_8__["default"], _mixins_menuable__WEBPACK_IMPORTED_MODULE_5__["default"]);
            __webpack_exports__["default"] = baseMixins.extend({
              name: "v-menu",
              directives: {
                ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_9__["default"],
                Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_10__["default"]
              },
              provide: function provide() {
                return {
                  isInMenu: true,
                  // Pass theme through to default slot
                  theme: this.theme
                };
              },
              props: {
                auto: Boolean,
                closeOnClick: {
                  type: Boolean,
                  default: true
                },
                closeOnContentClick: {
                  type: Boolean,
                  default: true
                },
                disabled: Boolean,
                disableKeys: Boolean,
                maxHeight: {
                  type: [Number, String],
                  default: "auto"
                },
                offsetX: Boolean,
                offsetY: Boolean,
                openOnHover: Boolean,
                origin: {
                  type: String,
                  default: "top left"
                },
                transition: {
                  type: [Boolean, String],
                  default: "v-menu-transition"
                },
                contentProps: {
                  type: Object,
                  default: function _default() {
                    return {};
                  }
                }
              },
              data: function data() {
                return {
                  calculatedTopAuto: 0,
                  defaultOffset: 8,
                  hasJustFocused: false,
                  listIndex: -1,
                  resizeTimeout: 0,
                  selectedIndex: null,
                  tiles: []
                };
              },
              computed: {
                activeTile: function activeTile() {
                  return this.tiles[this.listIndex];
                },
                calculatedLeft: function calculatedLeft() {
                  var menuWidth = Math.max(this.dimensions.content.width, parseFloat(this.calculatedMinWidth));
                  if (!this.auto)
                    return this.calcLeft(menuWidth) || "0";
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_13__["convertToUnit"])(this.calcXOverflow(this.calcLeftAuto(), menuWidth)) || "0";
                },
                calculatedMaxHeight: function calculatedMaxHeight() {
                  var height = this.auto ? "200px" : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_13__["convertToUnit"])(this.maxHeight);
                  return height || "0";
                },
                calculatedMaxWidth: function calculatedMaxWidth() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_13__["convertToUnit"])(this.maxWidth) || "0";
                },
                calculatedMinWidth: function calculatedMinWidth() {
                  if (this.minWidth) {
                    return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_13__["convertToUnit"])(this.minWidth) || "0";
                  }
                  var minWidth = Math.min(this.dimensions.activator.width + Number(this.nudgeWidth) + (this.auto ? 16 : 0), Math.max(this.pageWidth - 24, 0));
                  var calculatedMaxWidth = isNaN(parseInt(this.calculatedMaxWidth)) ? minWidth : parseInt(this.calculatedMaxWidth);
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_13__["convertToUnit"])(Math.min(calculatedMaxWidth, minWidth)) || "0";
                },
                calculatedTop: function calculatedTop() {
                  var top = !this.auto ? this.calcTop() : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_13__["convertToUnit"])(this.calcYOverflow(this.calculatedTopAuto));
                  return top || "0";
                },
                hasClickableTiles: function hasClickableTiles() {
                  return Boolean(this.tiles.find(function(tile) {
                    return tile.tabIndex > -1;
                  }));
                },
                styles: function styles() {
                  return {
                    maxHeight: this.calculatedMaxHeight,
                    minWidth: this.calculatedMinWidth,
                    maxWidth: this.calculatedMaxWidth,
                    top: this.calculatedTop,
                    left: this.calculatedLeft,
                    transformOrigin: this.origin,
                    zIndex: this.zIndex || this.activeZIndex
                  };
                }
              },
              watch: {
                isActive: function isActive(val) {
                  if (!val)
                    this.listIndex = -1;
                },
                isContentActive: function isContentActive(val) {
                  this.hasJustFocused = val;
                },
                listIndex: function listIndex(next, prev) {
                  if (next in this.tiles) {
                    var tile = this.tiles[next];
                    tile.classList.add("v-list-item--highlighted");
                    var scrollTop = this.$refs.content.scrollTop;
                    var contentHeight = this.$refs.content.clientHeight;
                    if (scrollTop > tile.offsetTop - 8) {
                      Object(_services_goto__WEBPACK_IMPORTED_MODULE_14__["default"])(tile.offsetTop - tile.clientHeight, {
                        appOffset: false,
                        duration: 300,
                        container: this.$refs.content
                      });
                    } else if (scrollTop + contentHeight < tile.offsetTop + tile.clientHeight + 8) {
                      Object(_services_goto__WEBPACK_IMPORTED_MODULE_14__["default"])(tile.offsetTop - contentHeight + tile.clientHeight * 2, {
                        appOffset: false,
                        duration: 300,
                        container: this.$refs.content
                      });
                    }
                  }
                  prev in this.tiles && this.tiles[prev].classList.remove("v-list-item--highlighted");
                }
              },
              created: function created2() {
                if (this.$attrs.hasOwnProperty("full-width")) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_12__["removed"])("full-width", this);
                }
              },
              mounted: function mounted3() {
                this.isActive && this.callActivate();
              },
              methods: {
                activate: function activate() {
                  var _this2 = this;
                  this.updateDimensions();
                  requestAnimationFrame(function() {
                    _this2.startTransition().then(function() {
                      if (_this2.$refs.content) {
                        _this2.calculatedTopAuto = _this2.calcTopAuto();
                        _this2.auto && (_this2.$refs.content.scrollTop = _this2.calcScrollPosition());
                      }
                    });
                  });
                },
                calcScrollPosition: function calcScrollPosition() {
                  var $el = this.$refs.content;
                  var activeTile = $el.querySelector(".v-list-item--active");
                  var maxScrollTop = $el.scrollHeight - $el.offsetHeight;
                  return activeTile ? Math.min(maxScrollTop, Math.max(0, activeTile.offsetTop - $el.offsetHeight / 2 + activeTile.offsetHeight / 2)) : $el.scrollTop;
                },
                calcLeftAuto: function calcLeftAuto() {
                  return parseInt(this.dimensions.activator.left - this.defaultOffset * 2);
                },
                calcTopAuto: function calcTopAuto() {
                  var $el = this.$refs.content;
                  var activeTile = $el.querySelector(".v-list-item--active");
                  if (!activeTile) {
                    this.selectedIndex = null;
                  }
                  if (this.offsetY || !activeTile) {
                    return this.computedTop;
                  }
                  this.selectedIndex = Array.from(this.tiles).indexOf(activeTile);
                  var tileDistanceFromMenuTop = activeTile.offsetTop - this.calcScrollPosition();
                  var firstTileOffsetTop = $el.querySelector(".v-list-item").offsetTop;
                  return this.computedTop - tileDistanceFromMenuTop - firstTileOffsetTop - 1;
                },
                changeListIndex: function changeListIndex(e) {
                  this.getTiles();
                  if (!this.isActive || !this.hasClickableTiles) {
                    return;
                  } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_13__["keyCodes"].tab) {
                    this.isActive = false;
                    return;
                  } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_13__["keyCodes"].down) {
                    this.nextTile();
                  } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_13__["keyCodes"].up) {
                    this.prevTile();
                  } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_13__["keyCodes"].end) {
                    this.lastTile();
                  } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_13__["keyCodes"].home) {
                    this.firstTile();
                  } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_13__["keyCodes"].enter && this.listIndex !== -1) {
                    this.tiles[this.listIndex].click();
                  } else {
                    return;
                  }
                  e.preventDefault();
                },
                closeConditional: function closeConditional(e) {
                  var target2 = e.target;
                  return this.isActive && !this._isDestroyed && this.closeOnClick && !this.$refs.content.contains(target2);
                },
                genActivatorAttributes: function genActivatorAttributes() {
                  var attributes2 = _mixins_activatable__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genActivatorAttributes.call(this);
                  if (this.activeTile && this.activeTile.id) {
                    return __assign2(__assign2({}, attributes2), {
                      "aria-activedescendant": this.activeTile.id
                    });
                  }
                  return attributes2;
                },
                genActivatorListeners: function genActivatorListeners() {
                  var listeners = _mixins_menuable__WEBPACK_IMPORTED_MODULE_5__["default"].options.methods.genActivatorListeners.call(this);
                  if (!this.disableKeys) {
                    listeners.keydown = this.onKeyDown;
                  }
                  return listeners;
                },
                genTransition: function genTransition() {
                  var content = this.genContent();
                  if (!this.transition)
                    return content;
                  return this.$createElement("transition", {
                    props: {
                      name: this.transition
                    }
                  }, [content]);
                },
                genDirectives: function genDirectives() {
                  var _this2 = this;
                  var directives2 = [{
                    name: "show",
                    value: this.isContentActive
                  }];
                  if (!this.openOnHover && this.closeOnClick) {
                    directives2.push({
                      name: "click-outside",
                      value: {
                        handler: function handler() {
                          _this2.isActive = false;
                        },
                        closeConditional: this.closeConditional,
                        include: function include() {
                          return __spreadArray2([_this2.$el], __read2(_this2.getOpenDependentElements()), false);
                        }
                      }
                    });
                  }
                  return directives2;
                },
                genContent: function genContent() {
                  var _a2;
                  var _this2 = this;
                  var options = {
                    attrs: __assign2(__assign2(__assign2({}, this.getScopeIdAttrs()), this.contentProps), {
                      role: "role" in this.$attrs ? this.$attrs.role : "menu"
                    }),
                    staticClass: "v-menu__content",
                    class: __assign2(__assign2(__assign2({}, this.rootThemeClasses), this.roundedClasses), (_a2 = {
                      "v-menu__content--auto": this.auto,
                      "v-menu__content--fixed": this.activatorFixed,
                      menuable__content__active: this.isActive
                    }, _a2[this.contentClass.trim()] = true, _a2)),
                    style: this.styles,
                    directives: this.genDirectives(),
                    ref: "content",
                    on: {
                      click: function click2(e) {
                        var target2 = e.target;
                        if (target2.getAttribute("disabled"))
                          return;
                        if (_this2.closeOnContentClick)
                          _this2.isActive = false;
                      },
                      keydown: this.onKeyDown
                    }
                  };
                  if (this.$listeners.scroll) {
                    options.on = options.on || {};
                    options.on.scroll = this.$listeners.scroll;
                  }
                  if (!this.disabled && this.openOnHover) {
                    options.on = options.on || {};
                    options.on.mouseenter = this.mouseEnterHandler;
                  }
                  if (this.openOnHover) {
                    options.on = options.on || {};
                    options.on.mouseleave = this.mouseLeaveHandler;
                  }
                  return this.$createElement("div", options, this.getContentSlot());
                },
                getTiles: function getTiles() {
                  if (!this.$refs.content)
                    return;
                  this.tiles = Array.from(this.$refs.content.querySelectorAll(".v-list-item, .v-divider, .v-subheader"));
                },
                mouseEnterHandler: function mouseEnterHandler() {
                  var _this2 = this;
                  this.runDelay("open", function() {
                    if (_this2.hasJustFocused)
                      return;
                    _this2.hasJustFocused = true;
                  });
                },
                mouseLeaveHandler: function mouseLeaveHandler(e) {
                  var _this2 = this;
                  this.runDelay("close", function() {
                    var _a2;
                    if ((_a2 = _this2.$refs.content) === null || _a2 === void 0 ? void 0 : _a2.contains(e.relatedTarget))
                      return;
                    requestAnimationFrame(function() {
                      _this2.isActive = false;
                      _this2.callDeactivate();
                    });
                  });
                },
                nextTile: function nextTile() {
                  var tile = this.tiles[this.listIndex + 1];
                  if (!tile) {
                    if (!this.tiles.length)
                      return;
                    this.listIndex = -1;
                    this.nextTile();
                    return;
                  }
                  this.listIndex++;
                  if (tile.tabIndex === -1)
                    this.nextTile();
                },
                prevTile: function prevTile() {
                  var tile = this.tiles[this.listIndex - 1];
                  if (!tile) {
                    if (!this.tiles.length)
                      return;
                    this.listIndex = this.tiles.length;
                    this.prevTile();
                    return;
                  }
                  this.listIndex--;
                  if (tile.tabIndex === -1)
                    this.prevTile();
                },
                lastTile: function lastTile() {
                  var tile = this.tiles[this.tiles.length - 1];
                  if (!tile)
                    return;
                  this.listIndex = this.tiles.length - 1;
                  if (tile.tabIndex === -1)
                    this.prevTile();
                },
                firstTile: function firstTile() {
                  var tile = this.tiles[0];
                  if (!tile)
                    return;
                  this.listIndex = 0;
                  if (tile.tabIndex === -1)
                    this.nextTile();
                },
                onKeyDown: function onKeyDown(e) {
                  var _this2 = this;
                  if (this.disableKeys)
                    return;
                  if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_13__["keyCodes"].esc) {
                    setTimeout(function() {
                      _this2.isActive = false;
                    });
                    var activator_1 = this.getActivator();
                    this.$nextTick(function() {
                      return activator_1 && activator_1.focus();
                    });
                  } else if (!this.isActive && [_util_helpers__WEBPACK_IMPORTED_MODULE_13__["keyCodes"].up, _util_helpers__WEBPACK_IMPORTED_MODULE_13__["keyCodes"].down].includes(e.keyCode)) {
                    this.isActive = true;
                  }
                  this.$nextTick(function() {
                    return _this2.changeListIndex(e);
                  });
                },
                onResize: function onResize() {
                  if (!this.isActive)
                    return;
                  this.$refs.content.offsetWidth;
                  this.updateDimensions();
                  clearTimeout(this.resizeTimeout);
                  this.resizeTimeout = window.setTimeout(this.updateDimensions, 100);
                }
              },
              render: function render8(h) {
                var _this2 = this;
                var data = {
                  staticClass: "v-menu",
                  class: {
                    "v-menu--attached": this.attach === "" || this.attach === true || this.attach === "attach"
                  },
                  directives: [{
                    arg: "500",
                    name: "resize",
                    value: this.onResize
                  }]
                };
                return h("div", data, [!this.activator && this.genActivator(), this.showLazyContent(function() {
                  return [_this2.$createElement(_VThemeProvider__WEBPACK_IMPORTED_MODULE_1__["VThemeProvider"], {
                    props: {
                      root: true,
                      light: _this2.light,
                      dark: _this2.dark
                    }
                  }, [_this2.genTransition()])];
                })]);
              }
            });
          }
        ),
        /***/
        "./src/components/VMenu/index.ts": (
          /*!***************************************!*\
            !*** ./src/components/VMenu/index.ts ***!
            \***************************************/
          /*! exports provided: VMenu, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VMenu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VMenu */
              "./src/components/VMenu/VMenu.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VMenu", function() {
              return _VMenu__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VMenu__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VMessages/VMessages.sass": (
          /*!*************************************************!*\
            !*** ./src/components/VMessages/VMessages.sass ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VMessages/VMessages.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VMessages/VMessages.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VMessages.sass */
              "./src/components/VMessages/VMessages.sass"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]).extend({
              name: "v-messages",
              props: {
                value: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                }
              },
              methods: {
                genChildren: function genChildren() {
                  return this.$createElement("transition-group", {
                    staticClass: "v-messages__wrapper",
                    attrs: {
                      name: "message-transition",
                      tag: "div"
                    }
                  }, this.value.map(this.genMessage));
                },
                genMessage: function genMessage(message, key) {
                  return this.$createElement("div", {
                    staticClass: "v-messages__message",
                    key
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getSlot"])(this, "default", {
                    message,
                    key
                  }) || [message]);
                }
              },
              render: function render8(h) {
                return h("div", this.setTextColor(this.color, {
                  staticClass: "v-messages",
                  class: this.themeClasses
                }), [this.genChildren()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VMessages/index.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VMessages/index.ts ***!
            \*******************************************/
          /*! exports provided: VMessages, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VMessages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VMessages */
              "./src/components/VMessages/VMessages.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VMessages", function() {
              return _VMessages__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VMessages__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VNavigationDrawer/VNavigationDrawer.sass": (
          /*!*****************************************************************!*\
            !*** ./src/components/VNavigationDrawer/VNavigationDrawer.sass ***!
            \*****************************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VNavigationDrawer/VNavigationDrawer.ts": (
          /*!***************************************************************!*\
            !*** ./src/components/VNavigationDrawer/VNavigationDrawer.ts ***!
            \***************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VNavigationDrawer.sass */
              "./src/components/VNavigationDrawer/VNavigationDrawer.sass"
            );
            var _VImg_VImg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VImg/VImg */
              "./src/components/VImg/VImg.ts"
            );
            var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/applicationable */
              "./src/mixins/applicationable/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_dependent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/dependent */
              "./src/mixins/dependent/index.ts"
            );
            var _mixins_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/mobile */
              "./src/mixins/mobile/index.ts"
            );
            var _mixins_overlayable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/overlayable */
              "./src/mixins/overlayable/index.ts"
            );
            var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../mixins/ssr-bootable */
              "./src/mixins/ssr-bootable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _directives_click_outside__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../directives/click-outside */
              "./src/directives/click-outside/index.ts"
            );
            var _directives_resize__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ../../directives/resize */
              "./src/directives/resize/index.ts"
            );
            var _directives_touch__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ../../directives/touch */
              "./src/directives/touch/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_13__["default"])(Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_2__["default"])("left", ["isActive", "isMobile", "miniVariant", "expandOnHover", "permanent", "right", "temporary", "width"]), _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_dependent__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_mobile__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_overlayable__WEBPACK_IMPORTED_MODULE_6__["default"], _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_7__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_8__["default"]);
            __webpack_exports__["default"] = baseMixins.extend({
              name: "v-navigation-drawer",
              directives: {
                ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_9__["default"],
                Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_10__["default"],
                Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_11__["default"]
              },
              provide: function provide() {
                return {
                  isInNav: this.tag === "nav"
                };
              },
              props: {
                bottom: Boolean,
                clipped: Boolean,
                disableResizeWatcher: Boolean,
                disableRouteWatcher: Boolean,
                expandOnHover: Boolean,
                floating: Boolean,
                height: {
                  type: [Number, String],
                  default: function _default() {
                    return this.app ? "100vh" : "100%";
                  }
                },
                miniVariant: Boolean,
                miniVariantWidth: {
                  type: [Number, String],
                  default: 56
                },
                permanent: Boolean,
                right: Boolean,
                src: {
                  type: [String, Object],
                  default: ""
                },
                stateless: Boolean,
                tag: {
                  type: String,
                  default: function _default() {
                    return this.app ? "nav" : "aside";
                  }
                },
                temporary: Boolean,
                touchless: Boolean,
                width: {
                  type: [Number, String],
                  default: 256
                },
                value: null
              },
              data: function data() {
                return {
                  isMouseover: false,
                  touchArea: {
                    left: 0,
                    right: 0
                  },
                  stackMinZIndex: 6
                };
              },
              computed: {
                /**
                 * Used for setting an app value from a dynamic
                 * property. Called from applicationable.js
                 */
                applicationProperty: function applicationProperty() {
                  return this.right ? "right" : "left";
                },
                classes: function classes() {
                  return __assign2({
                    "v-navigation-drawer": true,
                    "v-navigation-drawer--absolute": this.absolute,
                    "v-navigation-drawer--bottom": this.bottom,
                    "v-navigation-drawer--clipped": this.clipped,
                    "v-navigation-drawer--close": !this.isActive,
                    "v-navigation-drawer--fixed": !this.absolute && (this.app || this.fixed),
                    "v-navigation-drawer--floating": this.floating,
                    "v-navigation-drawer--is-mobile": this.isMobile,
                    "v-navigation-drawer--is-mouseover": this.isMouseover,
                    "v-navigation-drawer--mini-variant": this.isMiniVariant,
                    "v-navigation-drawer--custom-mini-variant": Number(this.miniVariantWidth) !== 56,
                    "v-navigation-drawer--open": this.isActive,
                    "v-navigation-drawer--open-on-hover": this.expandOnHover,
                    "v-navigation-drawer--right": this.right,
                    "v-navigation-drawer--temporary": this.temporary
                  }, this.themeClasses);
                },
                computedMaxHeight: function computedMaxHeight() {
                  if (!this.hasApp)
                    return null;
                  var computedMaxHeight2 = this.$vuetify.application.bottom + this.$vuetify.application.footer + this.$vuetify.application.bar;
                  if (!this.clipped)
                    return computedMaxHeight2;
                  return computedMaxHeight2 + this.$vuetify.application.top;
                },
                computedTop: function computedTop() {
                  if (!this.hasApp)
                    return 0;
                  var computedTop2 = this.$vuetify.application.bar;
                  computedTop2 += this.clipped ? this.$vuetify.application.top : 0;
                  return computedTop2;
                },
                computedTransform: function computedTransform() {
                  if (this.isActive)
                    return 0;
                  if (this.isBottom)
                    return 100;
                  return this.right ? 100 : -100;
                },
                computedWidth: function computedWidth() {
                  return this.isMiniVariant ? this.miniVariantWidth : this.width;
                },
                hasApp: function hasApp() {
                  return this.app && !this.isMobile && !this.temporary;
                },
                isBottom: function isBottom() {
                  return this.bottom && this.isMobile;
                },
                isMiniVariant: function isMiniVariant() {
                  return !this.expandOnHover && this.miniVariant || this.expandOnHover && !this.isMouseover;
                },
                isMobile: function isMobile() {
                  return !this.stateless && !this.permanent && _mixins_mobile__WEBPACK_IMPORTED_MODULE_5__["default"].options.computed.isMobile.call(this);
                },
                reactsToClick: function reactsToClick() {
                  return !this.stateless && !this.permanent && (this.isMobile || this.temporary);
                },
                reactsToMobile: function reactsToMobile() {
                  return this.app && !this.disableResizeWatcher && !this.permanent && !this.stateless && !this.temporary;
                },
                reactsToResize: function reactsToResize() {
                  return !this.disableResizeWatcher && !this.stateless;
                },
                reactsToRoute: function reactsToRoute() {
                  return !this.disableRouteWatcher && !this.stateless && (this.temporary || this.isMobile);
                },
                showOverlay: function showOverlay() {
                  return !this.hideOverlay && this.isActive && (this.isMobile || this.temporary);
                },
                styles: function styles() {
                  var translate = this.isBottom ? "translateY" : "translateX";
                  return {
                    height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["convertToUnit"])(this.height),
                    top: !this.isBottom ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["convertToUnit"])(this.computedTop) : "auto",
                    maxHeight: this.computedMaxHeight != null ? "calc(100% - " + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["convertToUnit"])(this.computedMaxHeight) + ")" : void 0,
                    transform: translate + "(" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["convertToUnit"])(this.computedTransform, "%") + ")",
                    width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["convertToUnit"])(this.computedWidth)
                  };
                }
              },
              watch: {
                $route: "onRouteChange",
                isActive: function isActive(val) {
                  this.$emit("input", val);
                },
                /**
                 * When mobile changes, adjust the active state
                 * only when there has been a previous value
                 */
                isMobile: function isMobile(val, prev) {
                  !val && this.isActive && !this.temporary && this.removeOverlay();
                  if (prev == null || !this.reactsToResize || !this.reactsToMobile)
                    return;
                  this.isActive = !val;
                },
                permanent: function permanent(val) {
                  if (val)
                    this.isActive = true;
                },
                showOverlay: function showOverlay(val) {
                  if (val)
                    this.genOverlay();
                  else
                    this.removeOverlay();
                },
                value: function value(val) {
                  if (this.permanent)
                    return;
                  if (val == null) {
                    this.init();
                    return;
                  }
                  if (val !== this.isActive)
                    this.isActive = val;
                },
                expandOnHover: "updateMiniVariant",
                isMouseover: function isMouseover(val) {
                  this.updateMiniVariant(!val);
                }
              },
              beforeMount: function beforeMount2() {
                this.init();
              },
              methods: {
                calculateTouchArea: function calculateTouchArea() {
                  var parent2 = this.$el.parentNode;
                  if (!parent2)
                    return;
                  var parentRect = parent2.getBoundingClientRect();
                  this.touchArea = {
                    left: parentRect.left + 50,
                    right: parentRect.right - 50
                  };
                },
                closeConditional: function closeConditional() {
                  return this.isActive && !this._isDestroyed && this.reactsToClick;
                },
                genAppend: function genAppend() {
                  return this.genPosition("append");
                },
                genBackground: function genBackground() {
                  var props2 = {
                    height: "100%",
                    width: "100%",
                    src: this.src
                  };
                  var image = this.$scopedSlots.img ? this.$scopedSlots.img(props2) : this.$createElement(_VImg_VImg__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: props2
                  });
                  return this.$createElement("div", {
                    staticClass: "v-navigation-drawer__image"
                  }, [image]);
                },
                genDirectives: function genDirectives() {
                  var _this2 = this;
                  var directives2 = [{
                    name: "click-outside",
                    value: {
                      handler: function handler() {
                        _this2.isActive = false;
                      },
                      closeConditional: this.closeConditional,
                      include: this.getOpenDependentElements
                    }
                  }];
                  if (!this.touchless && !this.stateless) {
                    directives2.push({
                      name: "touch",
                      value: {
                        parent: true,
                        left: this.swipeLeft,
                        right: this.swipeRight
                      }
                    });
                  }
                  return directives2;
                },
                genListeners: function genListeners() {
                  var _this2 = this;
                  var on2 = {
                    mouseenter: function mouseenter() {
                      return _this2.isMouseover = true;
                    },
                    mouseleave: function mouseleave() {
                      return _this2.isMouseover = false;
                    },
                    transitionend: function transitionend(e) {
                      if (e.target !== e.currentTarget)
                        return;
                      _this2.$emit("transitionend", e);
                      var resizeEvent = document.createEvent("UIEvents");
                      resizeEvent.initUIEvent("resize", true, false, window, 0);
                      window.dispatchEvent(resizeEvent);
                    }
                  };
                  if (this.miniVariant) {
                    on2.click = function() {
                      return _this2.$emit("update:mini-variant", false);
                    };
                  }
                  return on2;
                },
                genPosition: function genPosition(name) {
                  var slot = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["getSlot"])(this, name);
                  if (!slot)
                    return slot;
                  return this.$createElement("div", {
                    staticClass: "v-navigation-drawer__" + name
                  }, slot);
                },
                genPrepend: function genPrepend() {
                  return this.genPosition("prepend");
                },
                genContent: function genContent() {
                  return this.$createElement("div", {
                    staticClass: "v-navigation-drawer__content"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["getSlot"])(this));
                },
                genBorder: function genBorder() {
                  return this.$createElement("div", {
                    staticClass: "v-navigation-drawer__border"
                  });
                },
                init: function init2() {
                  if (this.permanent) {
                    this.isActive = true;
                  } else if (this.stateless || this.value != null) {
                    this.isActive = this.value;
                  } else if (!this.temporary) {
                    this.isActive = !this.isMobile;
                  }
                },
                onRouteChange: function onRouteChange() {
                  if (this.reactsToRoute && this.closeConditional()) {
                    this.isActive = false;
                  }
                },
                swipeLeft: function swipeLeft(e) {
                  if (this.isActive && this.right)
                    return;
                  this.calculateTouchArea();
                  if (Math.abs(e.touchendX - e.touchstartX) < 100)
                    return;
                  if (this.right && e.touchstartX >= this.touchArea.right)
                    this.isActive = true;
                  else if (!this.right && this.isActive)
                    this.isActive = false;
                },
                swipeRight: function swipeRight(e) {
                  if (this.isActive && !this.right)
                    return;
                  this.calculateTouchArea();
                  if (Math.abs(e.touchendX - e.touchstartX) < 100)
                    return;
                  if (!this.right && e.touchstartX <= this.touchArea.left)
                    this.isActive = true;
                  else if (this.right && this.isActive)
                    this.isActive = false;
                },
                /**
                 * Update the application layout
                 */
                updateApplication: function updateApplication() {
                  if (!this.isActive || this.isMobile || this.temporary || !this.$el)
                    return 0;
                  var width = Number(this.miniVariant ? this.miniVariantWidth : this.width);
                  return isNaN(width) ? this.$el.clientWidth : width;
                },
                updateMiniVariant: function updateMiniVariant(val) {
                  if (this.expandOnHover && this.miniVariant !== val)
                    this.$emit("update:mini-variant", val);
                }
              },
              render: function render8(h) {
                var children = [this.genPrepend(), this.genContent(), this.genAppend(), this.genBorder()];
                if (this.src || Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["getSlot"])(this, "img"))
                  children.unshift(this.genBackground());
                return h(this.tag, this.setBackgroundColor(this.color, {
                  class: this.classes,
                  style: this.styles,
                  directives: this.genDirectives(),
                  on: this.genListeners()
                }), children);
              }
            });
          }
        ),
        /***/
        "./src/components/VNavigationDrawer/index.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VNavigationDrawer/index.ts ***!
            \***************************************************/
          /*! exports provided: VNavigationDrawer, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VNavigationDrawer */
              "./src/components/VNavigationDrawer/VNavigationDrawer.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VNavigationDrawer", function() {
              return _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VOtpInput/VOtpInput.sass": (
          /*!*************************************************!*\
            !*** ./src/components/VOtpInput/VOtpInput.sass ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VOtpInput/VOtpInput.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VOtpInput/VOtpInput.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ../VTextField/VTextField.sass */
              "./src/components/VTextField/VTextField.sass"
            );
            __webpack_require__(
              /*! ./VOtpInput.sass */
              "./src/components/VOtpInput/VOtpInput.sass"
            );
            var _VInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VInput */
              "./src/components/VInput/index.ts"
            );
            var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VTextField/VTextField */
              "./src/components/VTextField/VTextField.ts"
            );
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_7__["default"])(_VInput__WEBPACK_IMPORTED_MODULE_2__["default"]);
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-otp-input",
              directives: {
                ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_4__["default"]
              },
              inheritAttrs: false,
              props: {
                length: {
                  type: [Number, String],
                  default: 6
                },
                type: {
                  type: String,
                  default: "text"
                },
                plain: Boolean
              },
              data: function data() {
                return {
                  initialValue: null,
                  isBooted: false,
                  otp: []
                };
              },
              computed: {
                outlined: function outlined() {
                  return !this.plain;
                },
                classes: function classes() {
                  return __assign2(__assign2(__assign2({}, _VInput__WEBPACK_IMPORTED_MODULE_2__["default"].options.computed.classes.call(this)), _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_3__["default"].options.computed.classes.call(this)), {
                    "v-otp-input--plain": this.plain
                  });
                }
              },
              watch: {
                isFocused: "updateValue",
                value: function value(val) {
                  this.lazyValue = val;
                  this.otp = (val === null || val === void 0 ? void 0 : val.split("")) || [];
                }
              },
              created: function created2() {
                var _a2;
                if (this.$attrs.hasOwnProperty("browser-autocomplete")) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["breaking"])("browser-autocomplete", "autocomplete", this);
                }
                this.otp = ((_a2 = this.internalValue) === null || _a2 === void 0 ? void 0 : _a2.split("")) || [];
              },
              mounted: function mounted3() {
                var _this2 = this;
                requestAnimationFrame(function() {
                  return _this2.isBooted = true;
                });
              },
              methods: {
                /** @public */
                focus: function focus(e, otpIdx) {
                  this.onFocus(e, otpIdx || 0);
                },
                genInputSlot: function genInputSlot(otpIdx) {
                  var _this2 = this;
                  return this.$createElement("div", this.setBackgroundColor(this.backgroundColor, {
                    staticClass: "v-input__slot",
                    style: {
                      height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.height)
                    },
                    on: {
                      click: function click2() {
                        return _this2.onClick(otpIdx);
                      },
                      mousedown: function mousedown(e) {
                        return _this2.onMouseDown(e, otpIdx);
                      },
                      mouseup: function mouseup(e) {
                        return _this2.onMouseUp(e, otpIdx);
                      }
                    }
                  }), [this.genDefaultSlot(otpIdx)]);
                },
                genControl: function genControl(otpIdx) {
                  return this.$createElement("div", {
                    staticClass: "v-input__control"
                  }, [this.genInputSlot(otpIdx)]);
                },
                genDefaultSlot: function genDefaultSlot(otpIdx) {
                  return [this.genFieldset(), this.genTextFieldSlot(otpIdx)];
                },
                genContent: function genContent() {
                  var _this2 = this;
                  return Array.from({
                    length: +this.length
                  }, function(_, i2) {
                    return _this2.$createElement("div", _this2.setTextColor(_this2.validationState, {
                      staticClass: "v-input",
                      class: _this2.classes
                    }), [_this2.genControl(i2)]);
                  });
                },
                genFieldset: function genFieldset() {
                  return this.$createElement("fieldset", {
                    attrs: {
                      "aria-hidden": true
                    }
                  }, [this.genLegend()]);
                },
                genLegend: function genLegend() {
                  var span = this.$createElement("span", {
                    domProps: {
                      innerHTML: "&#8203;"
                    }
                  });
                  return this.$createElement("legend", {
                    style: {
                      width: "0px"
                    }
                  }, [span]);
                },
                genInput: function genInput(otpIdx) {
                  var _this2 = this;
                  var listeners = Object.assign({}, this.listeners$);
                  delete listeners.change;
                  return this.$createElement("input", {
                    style: {},
                    domProps: {
                      value: this.otp[otpIdx],
                      min: this.type === "number" ? 0 : null
                    },
                    attrs: __assign2(__assign2({}, this.attrs$), {
                      autocomplete: "one-time-code",
                      disabled: this.isDisabled,
                      readonly: this.isReadonly,
                      type: this.type,
                      id: this.computedId + "--" + otpIdx,
                      class: "otp-field-box--" + otpIdx
                    }),
                    on: Object.assign(listeners, {
                      blur: this.onBlur,
                      input: function input2(e) {
                        return _this2.onInput(e, otpIdx);
                      },
                      focus: function focus(e) {
                        return _this2.onFocus(e, otpIdx);
                      },
                      keydown: this.onKeyDown,
                      keyup: function keyup(e) {
                        return _this2.onKeyUp(e, otpIdx);
                      }
                    }),
                    ref: "input",
                    refInFor: true
                  });
                },
                genTextFieldSlot: function genTextFieldSlot(otpIdx) {
                  return this.$createElement("div", {
                    staticClass: "v-text-field__slot"
                  }, [this.genInput(otpIdx)]);
                },
                onBlur: function onBlur(e) {
                  var _this2 = this;
                  this.isFocused = false;
                  e && this.$nextTick(function() {
                    return _this2.$emit("blur", e);
                  });
                },
                onClick: function onClick(otpIdx) {
                  if (this.isFocused || this.isDisabled || !this.$refs.input[otpIdx])
                    return;
                  this.onFocus(void 0, otpIdx);
                },
                onFocus: function onFocus(e, otpIdx) {
                  e === null || e === void 0 ? void 0 : e.preventDefault();
                  e === null || e === void 0 ? void 0 : e.stopPropagation();
                  var elements = this.$refs.input;
                  var ref2 = this.$refs.input && elements[otpIdx || 0];
                  if (!ref2)
                    return;
                  if (document.activeElement !== ref2) {
                    ref2.focus();
                    return ref2.select();
                  }
                  if (!this.isFocused) {
                    this.isFocused = true;
                    ref2.select();
                    e && this.$emit("focus", e);
                  }
                },
                onInput: function onInput(e, index2) {
                  var maxCursor = +this.length - 1;
                  var target2 = e.target;
                  var value = target2.value;
                  var inputDataArray = (value === null || value === void 0 ? void 0 : value.split("")) || [];
                  var newOtp = __spreadArray2([], __read2(this.otp), false);
                  for (var i2 = 0; i2 < inputDataArray.length; i2++) {
                    var appIdx = index2 + i2;
                    if (appIdx > maxCursor)
                      break;
                    newOtp[appIdx] = inputDataArray[i2].toString();
                  }
                  if (!inputDataArray.length) {
                    newOtp.splice(index2, 1);
                  }
                  this.otp = newOtp;
                  this.internalValue = this.otp.join("");
                  if (index2 + inputDataArray.length >= +this.length) {
                    this.onCompleted();
                    this.clearFocus(index2);
                  } else if (inputDataArray.length) {
                    this.changeFocus(index2 + inputDataArray.length);
                  }
                },
                clearFocus: function clearFocus(index2) {
                  var input2 = this.$refs.input[index2];
                  input2.blur();
                },
                onKeyDown: function onKeyDown(e) {
                  if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_5__["keyCodes"].enter) {
                    this.$emit("change", this.internalValue);
                  }
                  this.$emit("keydown", e);
                },
                onMouseDown: function onMouseDown(e, otpIdx) {
                  if (e.target !== this.$refs.input[otpIdx]) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                  _VInput__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.onMouseDown.call(this, e);
                },
                onMouseUp: function onMouseUp(e, otpIdx) {
                  if (this.hasMouseDown)
                    this.focus(e, otpIdx);
                  _VInput__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.onMouseUp.call(this, e);
                },
                changeFocus: function changeFocus(index2) {
                  this.onFocus(void 0, index2 || 0);
                },
                updateValue: function updateValue(val) {
                  this.hasColor = val;
                  if (val) {
                    this.initialValue = this.lazyValue;
                  } else if (this.initialValue !== this.lazyValue) {
                    this.$emit("change", this.lazyValue);
                  }
                },
                onKeyUp: function onKeyUp(event, index2) {
                  event.preventDefault();
                  var eventKey = event.key;
                  if (["Tab", "Shift", "Meta", "Control", "Alt"].includes(eventKey)) {
                    return;
                  }
                  if (["Delete"].includes(eventKey)) {
                    return;
                  }
                  if (eventKey === "ArrowLeft" || eventKey === "Backspace" && !this.otp[index2]) {
                    return index2 > 0 && this.changeFocus(index2 - 1);
                  }
                  if (eventKey === "ArrowRight") {
                    return index2 + 1 < +this.length && this.changeFocus(index2 + 1);
                  }
                },
                onCompleted: function onCompleted() {
                  var rsp = this.otp.join("");
                  if (rsp.length === +this.length) {
                    this.$emit("finish", rsp);
                  }
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-otp-input",
                  class: this.themeClasses
                }, this.genContent());
              }
            });
          }
        ),
        /***/
        "./src/components/VOtpInput/index.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VOtpInput/index.ts ***!
            \*******************************************/
          /*! exports provided: VOtpInput, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VOtpInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VOtpInput */
              "./src/components/VOtpInput/VOtpInput.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VOtpInput", function() {
              return _VOtpInput__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VOtpInput__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VOverflowBtn/VOverflowBtn.sass": (
          /*!*******************************************************!*\
            !*** ./src/components/VOverflowBtn/VOverflowBtn.sass ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VOverflowBtn/VOverflowBtn.ts": (
          /*!*****************************************************!*\
            !*** ./src/components/VOverflowBtn/VOverflowBtn.ts ***!
            \*****************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VOverflowBtn.sass */
              "./src/components/VOverflowBtn/VOverflowBtn.sass"
            );
            var _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSelect/VSelect */
              "./src/components/VSelect/VSelect.ts"
            );
            var _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VAutocomplete */
              "./src/components/VAutocomplete/index.ts"
            );
            var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VTextField/VTextField */
              "./src/components/VTextField/VTextField.ts"
            );
            var _VBtn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../VBtn */
              "./src/components/VBtn/index.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].extend({
              name: "v-overflow-btn",
              props: {
                editable: Boolean,
                segmented: Boolean
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].options.computed.classes.call(this)), {
                    "v-overflow-btn": true,
                    "v-overflow-btn--segmented": this.segmented,
                    "v-overflow-btn--editable": this.editable
                  });
                },
                isAnyValueAllowed: function isAnyValueAllowed() {
                  return this.editable || _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].options.computed.isAnyValueAllowed.call(this);
                },
                isSingle: function isSingle() {
                  return true;
                },
                computedItems: function computedItems() {
                  return this.segmented ? this.allItems : this.filteredItems;
                },
                labelValue: function labelValue() {
                  return this.isFocused && !this.persistentPlaceholder || this.isLabelActive;
                }
              },
              methods: {
                genSelections: function genSelections() {
                  return this.editable ? _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genSelections.call(this) : _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genSelections.call(this);
                },
                genCommaSelection: function genCommaSelection(item, index2, last2) {
                  return this.segmented ? this.genSegmentedBtn(item) : _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genCommaSelection.call(this, item, index2, last2);
                },
                genInput: function genInput() {
                  var input2 = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_3__["default"].options.methods.genInput.call(this);
                  input2.data = input2.data || {};
                  input2.data.domProps.value = this.editable ? this.internalSearch : "";
                  input2.data.attrs.readonly = !this.isAnyValueAllowed;
                  return input2;
                },
                genLabel: function genLabel() {
                  if (this.editable && this.isFocused)
                    return null;
                  var label = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_3__["default"].options.methods.genLabel.call(this);
                  if (!label)
                    return label;
                  label.data = label.data || {};
                  label.data.style = {};
                  return label;
                },
                genSegmentedBtn: function genSegmentedBtn(item) {
                  var _this2 = this;
                  var itemValue = this.getValue(item);
                  var itemObj = this.computedItems.find(function(i2) {
                    return _this2.getValue(i2) === itemValue;
                  }) || item;
                  if (!itemObj.text || !itemObj.callback) {
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_5__["consoleWarn"])('When using "segmented" prop without a selection slot, items must contain both a text and callback property', this);
                    return null;
                  }
                  return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    props: {
                      text: true
                    },
                    on: {
                      click: function click2(e) {
                        e.stopPropagation();
                        itemObj.callback(e);
                      }
                    }
                  }, [itemObj.text]);
                },
                updateValue: function updateValue(val) {
                  if (val) {
                    this.initialValue = this.lazyValue;
                  } else if (this.initialValue !== this.lazyValue) {
                    this.$emit("change", this.lazyValue);
                  }
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VOverflowBtn/index.ts": (
          /*!**********************************************!*\
            !*** ./src/components/VOverflowBtn/index.ts ***!
            \**********************************************/
          /*! exports provided: VOverflowBtn, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VOverflowBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VOverflowBtn */
              "./src/components/VOverflowBtn/VOverflowBtn.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VOverflowBtn", function() {
              return _VOverflowBtn__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VOverflowBtn__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VOverlay/VOverlay.sass": (
          /*!***********************************************!*\
            !*** ./src/components/VOverlay/VOverlay.sass ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VOverlay/VOverlay.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VOverlay/VOverlay.ts ***!
            \*********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VOverlay.sass */
              "./src/components/VOverlay/VOverlay.sass"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_3__["default"]).extend({
              name: "v-overlay",
              props: {
                absolute: Boolean,
                color: {
                  type: String,
                  default: "#212121"
                },
                dark: {
                  type: Boolean,
                  default: true
                },
                opacity: {
                  type: [Number, String],
                  default: 0.46
                },
                value: {
                  default: true
                },
                zIndex: {
                  type: [Number, String],
                  default: 5
                }
              },
              computed: {
                __scrim: function __scrim() {
                  var data = this.setBackgroundColor(this.color, {
                    staticClass: "v-overlay__scrim",
                    style: {
                      opacity: this.computedOpacity
                    }
                  });
                  return this.$createElement("div", data);
                },
                classes: function classes() {
                  return __assign2({
                    "v-overlay--absolute": this.absolute,
                    "v-overlay--active": this.isActive
                  }, this.themeClasses);
                },
                computedOpacity: function computedOpacity() {
                  return Number(this.isActive ? this.opacity : 0);
                },
                styles: function styles() {
                  return {
                    zIndex: this.zIndex
                  };
                }
              },
              methods: {
                genContent: function genContent() {
                  return this.$createElement("div", {
                    staticClass: "v-overlay__content"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this));
                }
              },
              render: function render8(h) {
                var children = [this.__scrim];
                if (this.isActive)
                  children.push(this.genContent());
                return h("div", {
                  staticClass: "v-overlay",
                  on: this.$listeners,
                  class: this.classes,
                  style: this.styles
                }, children);
              }
            });
          }
        ),
        /***/
        "./src/components/VOverlay/index.ts": (
          /*!******************************************!*\
            !*** ./src/components/VOverlay/index.ts ***!
            \******************************************/
          /*! exports provided: VOverlay, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VOverlay__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VOverlay */
              "./src/components/VOverlay/VOverlay.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VOverlay", function() {
              return _VOverlay__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VOverlay__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VPagination/VPagination.sass": (
          /*!*****************************************************!*\
            !*** ./src/components/VPagination/VPagination.sass ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VPagination/VPagination.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VPagination/VPagination.ts ***!
            \***************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VPagination.sass */
              "./src/components/VPagination/VPagination.sass"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _directives_resize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../directives/resize */
              "./src/directives/resize/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_intersectable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/intersectable */
              "./src/mixins/intersectable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], Object(_mixins_intersectable__WEBPACK_IMPORTED_MODULE_4__["default"])({
              onVisible: ["init"]
            }), _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__["default"]).extend({
              name: "v-pagination",
              directives: {
                Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_2__["default"]
              },
              props: {
                circle: Boolean,
                disabled: Boolean,
                navigationColor: String,
                navigationTextColor: String,
                length: {
                  type: Number,
                  default: 0,
                  validator: function validator2(val) {
                    return val % 1 === 0;
                  }
                },
                nextIcon: {
                  type: String,
                  default: "$next"
                },
                prevIcon: {
                  type: String,
                  default: "$prev"
                },
                totalVisible: [Number, String],
                value: {
                  type: Number,
                  default: 0
                },
                pageAriaLabel: {
                  type: String,
                  default: "$vuetify.pagination.ariaLabel.page"
                },
                currentPageAriaLabel: {
                  type: String,
                  default: "$vuetify.pagination.ariaLabel.currentPage"
                },
                previousAriaLabel: {
                  type: String,
                  default: "$vuetify.pagination.ariaLabel.previous"
                },
                nextAriaLabel: {
                  type: String,
                  default: "$vuetify.pagination.ariaLabel.next"
                },
                wrapperAriaLabel: {
                  type: String,
                  default: "$vuetify.pagination.ariaLabel.wrapper"
                }
              },
              data: function data() {
                return {
                  maxButtons: 0,
                  selected: null
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-pagination": true,
                    "v-pagination--circle": this.circle,
                    "v-pagination--disabled": this.disabled
                  }, this.themeClasses);
                },
                items: function items() {
                  var totalVisible = parseInt(this.totalVisible, 10);
                  if (totalVisible === 0 || isNaN(this.length) || this.length > Number.MAX_SAFE_INTEGER) {
                    return [];
                  }
                  var maxLength = Math.min(Math.max(0, totalVisible) || this.length, Math.max(0, this.maxButtons) || this.length, this.length);
                  if (this.length <= maxLength) {
                    return this.range(1, this.length);
                  }
                  var even = maxLength % 2 === 0 ? 1 : 0;
                  var left = Math.floor(maxLength / 2);
                  var right = this.length - left + 1 + even;
                  if (this.value > left && this.value < right) {
                    var firstItem = 1;
                    var lastItem = this.length;
                    var start = this.value - left + 2;
                    var end = this.value + left - 2 - even;
                    var secondItem = start - 1 === firstItem + 1 ? 2 : "...";
                    var beforeLastItem = end + 1 === lastItem - 1 ? end + 1 : "...";
                    return __spreadArray2(__spreadArray2([1, secondItem], __read2(this.range(start, end)), false), [beforeLastItem, this.length], false);
                  } else if (this.value === left) {
                    var end = this.value + left - 1 - even;
                    return __spreadArray2(__spreadArray2([], __read2(this.range(1, end)), false), ["...", this.length], false);
                  } else if (this.value === right) {
                    var start = this.value - left + 1;
                    return __spreadArray2([1, "..."], __read2(this.range(start, this.length)), false);
                  } else {
                    return __spreadArray2(__spreadArray2(__spreadArray2([], __read2(this.range(1, left)), false), ["..."], false), __read2(this.range(right, this.length)), false);
                  }
                }
              },
              watch: {
                value: function value() {
                  this.init();
                }
              },
              beforeMount: function beforeMount2() {
                this.init();
              },
              methods: {
                init: function init2() {
                  var _this2 = this;
                  this.selected = null;
                  this.onResize();
                  this.$nextTick(this.onResize);
                  setTimeout(function() {
                    return _this2.selected = _this2.value;
                  }, 100);
                },
                onResize: function onResize() {
                  var width = this.$el && this.$el.parentElement ? this.$el.parentElement.clientWidth : window.innerWidth;
                  this.maxButtons = Math.floor((width - 96) / 42);
                },
                next: function next(e) {
                  e.preventDefault();
                  this.$emit("input", this.value + 1);
                  this.$emit("next");
                },
                previous: function previous(e) {
                  e.preventDefault();
                  this.$emit("input", this.value - 1);
                  this.$emit("previous");
                },
                range: function range(from, to) {
                  var range2 = [];
                  from = from > 0 ? from : 1;
                  for (var i2 = from; i2 <= to; i2++) {
                    range2.push(i2);
                  }
                  return range2;
                },
                genIcon: function genIcon(h, icon, disabled, fn, label) {
                  return h("li", [h("button", this.setBackgroundColor(this.navigationColor, {
                    staticClass: "v-pagination__navigation",
                    class: {
                      "v-pagination__navigation--disabled": disabled
                    },
                    attrs: {
                      disabled,
                      type: "button",
                      "aria-label": label
                    },
                    on: disabled ? {} : {
                      click: fn
                    }
                  }), [h(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: {
                      color: this.navigationTextColor
                    }
                  }, [icon])])]);
                },
                genItem: function genItem(h, i2) {
                  var _this2 = this;
                  var color2 = i2 === this.value && (this.color || "primary");
                  var isCurrentPage = i2 === this.value;
                  var ariaLabel = isCurrentPage ? this.currentPageAriaLabel : this.pageAriaLabel;
                  return h("button", this.setBackgroundColor(color2, {
                    staticClass: "v-pagination__item",
                    class: {
                      "v-pagination__item--active": i2 === this.value
                    },
                    attrs: {
                      type: "button",
                      "aria-current": isCurrentPage,
                      "aria-label": this.$vuetify.lang.t(ariaLabel, i2)
                    },
                    on: {
                      click: function click2() {
                        return _this2.$emit("input", i2);
                      }
                    }
                  }), [i2.toString()]);
                },
                genItems: function genItems(h) {
                  var _this2 = this;
                  return this.items.map(function(i2, index2) {
                    return h("li", {
                      key: index2
                    }, [isNaN(Number(i2)) ? h("span", {
                      class: "v-pagination__more"
                    }, [i2.toString()]) : _this2.genItem(h, i2)]);
                  });
                },
                genList: function genList(h, children) {
                  return h("ul", {
                    directives: [{
                      modifiers: {
                        quiet: true
                      },
                      name: "resize",
                      value: this.onResize
                    }],
                    class: this.classes
                  }, children);
                }
              },
              render: function render8(h) {
                var children = [this.genIcon(h, this.$vuetify.rtl ? this.nextIcon : this.prevIcon, this.value <= 1, this.previous, this.$vuetify.lang.t(this.previousAriaLabel)), this.genItems(h), this.genIcon(h, this.$vuetify.rtl ? this.prevIcon : this.nextIcon, this.value >= this.length, this.next, this.$vuetify.lang.t(this.nextAriaLabel))];
                return h("nav", {
                  attrs: {
                    role: "navigation",
                    "aria-label": this.$vuetify.lang.t(this.wrapperAriaLabel)
                  }
                }, [this.genList(h, children)]);
              }
            });
          }
        ),
        /***/
        "./src/components/VPagination/index.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VPagination/index.ts ***!
            \*********************************************/
          /*! exports provided: VPagination, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VPagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VPagination */
              "./src/components/VPagination/VPagination.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VPagination", function() {
              return _VPagination__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VPagination__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VParallax/VParallax.sass": (
          /*!*************************************************!*\
            !*** ./src/components/VParallax/VParallax.sass ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VParallax/VParallax.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VParallax/VParallax.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VParallax.sass */
              "./src/components/VParallax/VParallax.sass"
            );
            var _mixins_translatable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/translatable */
              "./src/mixins/translatable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_translatable__WEBPACK_IMPORTED_MODULE_1__["default"]);
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-parallax",
              props: {
                alt: {
                  type: String,
                  default: ""
                },
                height: {
                  type: [String, Number],
                  default: 500
                },
                src: String,
                srcset: String
              },
              data: function data() {
                return {
                  isBooted: false
                };
              },
              computed: {
                styles: function styles() {
                  return {
                    display: "block",
                    opacity: this.isBooted ? 1 : 0,
                    transform: "translate(-50%, " + this.parallax + "px)"
                  };
                }
              },
              mounted: function mounted3() {
                this.init();
              },
              methods: {
                init: function init2() {
                  var _this2 = this;
                  var img = this.$refs.img;
                  if (!img)
                    return;
                  if (img.complete) {
                    this.translate();
                    this.listeners();
                  } else {
                    img.addEventListener("load", function() {
                      _this2.translate();
                      _this2.listeners();
                    }, false);
                  }
                  this.isBooted = true;
                },
                objHeight: function objHeight() {
                  return this.$refs.img.naturalHeight;
                }
              },
              render: function render8(h) {
                var imgData = {
                  staticClass: "v-parallax__image",
                  style: this.styles,
                  attrs: {
                    src: this.src,
                    srcset: this.srcset,
                    alt: this.alt
                  },
                  ref: "img"
                };
                var container2 = h("div", {
                  staticClass: "v-parallax__image-container"
                }, [h("img", imgData)]);
                var content = h("div", {
                  staticClass: "v-parallax__content"
                }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this));
                return h("div", {
                  staticClass: "v-parallax",
                  style: {
                    height: this.height + "px"
                  },
                  on: this.$listeners
                }, [container2, content]);
              }
            });
          }
        ),
        /***/
        "./src/components/VParallax/index.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VParallax/index.ts ***!
            \*******************************************/
          /*! exports provided: VParallax, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VParallax__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VParallax */
              "./src/components/VParallax/VParallax.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VParallax", function() {
              return _VParallax__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VParallax__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VPicker/VPicker.sass": (
          /*!*********************************************!*\
            !*** ./src/components/VPicker/VPicker.sass ***!
            \*********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VPicker/VPicker.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VPicker/VPicker.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VPicker.sass */
              "./src/components/VPicker/VPicker.sass"
            );
            __webpack_require__(
              /*! ../VCard/VCard.sass */
              "./src/components/VCard/VCard.sass"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_elevatable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/elevatable */
              "./src/mixins/elevatable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_elevatable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__["default"]).extend({
              name: "v-picker",
              props: {
                flat: Boolean,
                fullWidth: Boolean,
                landscape: Boolean,
                noTitle: Boolean,
                transition: {
                  type: String,
                  default: "fade-transition"
                },
                width: {
                  type: [Number, String],
                  default: 290
                }
              },
              computed: {
                computedTitleColor: function computedTitleColor() {
                  var defaultTitleColor = this.isDark ? false : this.color || "primary";
                  return this.color || defaultTitleColor;
                }
              },
              methods: {
                genTitle: function genTitle() {
                  return this.$createElement("div", this.setBackgroundColor(this.computedTitleColor, {
                    staticClass: "v-picker__title",
                    class: {
                      "v-picker__title--landscape": this.landscape
                    }
                  }), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this, "title"));
                },
                genBodyTransition: function genBodyTransition() {
                  return this.$createElement("transition", {
                    props: {
                      name: this.transition
                    }
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this));
                },
                genBody: function genBody() {
                  return this.$createElement("div", {
                    staticClass: "v-picker__body",
                    class: __assign2({
                      "v-picker__body--no-title": this.noTitle
                    }, this.themeClasses),
                    style: this.fullWidth ? void 0 : {
                      width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.width)
                    }
                  }, [this.genBodyTransition()]);
                },
                genActions: function genActions() {
                  return this.$createElement("div", {
                    staticClass: "v-picker__actions v-card__actions",
                    class: {
                      "v-picker__actions--no-title": this.noTitle
                    }
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this, "actions"));
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-picker v-card",
                  class: __assign2(__assign2({
                    "v-picker--flat": this.flat,
                    "v-picker--landscape": this.landscape,
                    "v-picker--full-width": this.fullWidth
                  }, this.themeClasses), this.elevationClasses)
                }, [this.$slots.title ? this.genTitle() : null, this.genBody(), this.$slots.actions ? this.genActions() : null]);
              }
            });
          }
        ),
        /***/
        "./src/components/VPicker/index.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VPicker/index.ts ***!
            \*****************************************/
          /*! exports provided: VPicker, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VPicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VPicker */
              "./src/components/VPicker/VPicker.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VPicker", function() {
              return _VPicker__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VPicker__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VProgressCircular/VProgressCircular.sass": (
          /*!*****************************************************************!*\
            !*** ./src/components/VProgressCircular/VProgressCircular.sass ***!
            \*****************************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VProgressCircular/VProgressCircular.ts": (
          /*!***************************************************************!*\
            !*** ./src/components/VProgressCircular/VProgressCircular.ts ***!
            \***************************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VProgressCircular.sass */
              "./src/components/VProgressCircular/VProgressCircular.sass"
            );
            var _directives_intersect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../directives/intersect */
              "./src/directives/intersect/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"].extend({
              name: "v-progress-circular",
              directives: {
                intersect: _directives_intersect__WEBPACK_IMPORTED_MODULE_1__["default"]
              },
              props: {
                button: Boolean,
                indeterminate: Boolean,
                rotate: {
                  type: [Number, String],
                  default: 0
                },
                size: {
                  type: [Number, String],
                  default: 32
                },
                width: {
                  type: [Number, String],
                  default: 4
                },
                value: {
                  type: [Number, String],
                  default: 0
                }
              },
              data: function data() {
                return {
                  radius: 20,
                  isVisible: true
                };
              },
              computed: {
                calculatedSize: function calculatedSize() {
                  return Number(this.size) + (this.button ? 8 : 0);
                },
                circumference: function circumference() {
                  return 2 * Math.PI * this.radius;
                },
                classes: function classes() {
                  return {
                    "v-progress-circular--visible": this.isVisible,
                    "v-progress-circular--indeterminate": this.indeterminate,
                    "v-progress-circular--button": this.button
                  };
                },
                normalizedValue: function normalizedValue() {
                  if (this.value < 0) {
                    return 0;
                  }
                  if (this.value > 100) {
                    return 100;
                  }
                  return parseFloat(this.value);
                },
                strokeDashArray: function strokeDashArray() {
                  return Math.round(this.circumference * 1e3) / 1e3;
                },
                strokeDashOffset: function strokeDashOffset() {
                  return (100 - this.normalizedValue) / 100 * this.circumference + "px";
                },
                strokeWidth: function strokeWidth() {
                  return Number(this.width) / +this.size * this.viewBoxSize * 2;
                },
                styles: function styles() {
                  return {
                    height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.calculatedSize),
                    width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.calculatedSize)
                  };
                },
                svgStyles: function svgStyles() {
                  return {
                    transform: "rotate(" + Number(this.rotate) + "deg)"
                  };
                },
                viewBoxSize: function viewBoxSize() {
                  return this.radius / (1 - Number(this.width) / +this.size);
                }
              },
              methods: {
                genCircle: function genCircle(name, offset2) {
                  return this.$createElement("circle", {
                    class: "v-progress-circular__" + name,
                    attrs: {
                      fill: "transparent",
                      cx: 2 * this.viewBoxSize,
                      cy: 2 * this.viewBoxSize,
                      r: this.radius,
                      "stroke-width": this.strokeWidth,
                      "stroke-dasharray": this.strokeDashArray,
                      "stroke-dashoffset": offset2
                    }
                  });
                },
                genSvg: function genSvg() {
                  var children = [this.indeterminate || this.genCircle("underlay", 0), this.genCircle("overlay", this.strokeDashOffset)];
                  return this.$createElement("svg", {
                    style: this.svgStyles,
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: this.viewBoxSize + " " + this.viewBoxSize + " " + 2 * this.viewBoxSize + " " + 2 * this.viewBoxSize
                    }
                  }, children);
                },
                genInfo: function genInfo() {
                  return this.$createElement("div", {
                    staticClass: "v-progress-circular__info"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this));
                },
                onObserve: function onObserve(entries, observer, isIntersecting) {
                  this.isVisible = isIntersecting;
                }
              },
              render: function render8(h) {
                return h("div", this.setTextColor(this.color, {
                  staticClass: "v-progress-circular",
                  attrs: {
                    role: "progressbar",
                    "aria-valuemin": 0,
                    "aria-valuemax": 100,
                    "aria-valuenow": this.indeterminate ? void 0 : this.normalizedValue
                  },
                  class: this.classes,
                  directives: [{
                    name: "intersect",
                    value: this.onObserve
                  }],
                  style: this.styles,
                  on: this.$listeners
                }), [this.genSvg(), this.genInfo()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VProgressCircular/index.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VProgressCircular/index.ts ***!
            \***************************************************/
          /*! exports provided: VProgressCircular, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VProgressCircular__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VProgressCircular */
              "./src/components/VProgressCircular/VProgressCircular.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VProgressCircular", function() {
              return _VProgressCircular__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VProgressCircular__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VProgressLinear/VProgressLinear.sass": (
          /*!*************************************************************!*\
            !*** ./src/components/VProgressLinear/VProgressLinear.sass ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VProgressLinear/VProgressLinear.ts": (
          /*!***********************************************************!*\
            !*** ./src/components/VProgressLinear/VProgressLinear.ts ***!
            \***********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VProgressLinear.sass */
              "./src/components/VProgressLinear/VProgressLinear.sass"
            );
            var _transitions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../transitions */
              "./src/components/transitions/index.ts"
            );
            var _directives_intersect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../directives/intersect */
              "./src/directives/intersect/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_positionable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/positionable */
              "./src/mixins/positionable/index.ts"
            );
            var _mixins_proxyable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/proxyable */
              "./src/mixins/proxyable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], Object(_mixins_positionable__WEBPACK_IMPORTED_MODULE_4__["factory"])(["absolute", "fixed", "top", "bottom"]), _mixins_proxyable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__["default"]);
            __webpack_exports__["default"] = baseMixins.extend({
              name: "v-progress-linear",
              directives: {
                intersect: _directives_intersect__WEBPACK_IMPORTED_MODULE_2__["default"]
              },
              props: {
                active: {
                  type: Boolean,
                  default: true
                },
                backgroundColor: {
                  type: String,
                  default: null
                },
                backgroundOpacity: {
                  type: [Number, String],
                  default: null
                },
                bufferValue: {
                  type: [Number, String],
                  default: 100
                },
                color: {
                  type: String,
                  default: "primary"
                },
                height: {
                  type: [Number, String],
                  default: 4
                },
                indeterminate: Boolean,
                query: Boolean,
                reverse: Boolean,
                rounded: Boolean,
                stream: Boolean,
                striped: Boolean,
                value: {
                  type: [Number, String],
                  default: 0
                }
              },
              data: function data() {
                return {
                  internalLazyValue: this.value || 0,
                  isVisible: true
                };
              },
              computed: {
                __cachedBackground: function __cachedBackground() {
                  return this.$createElement("div", this.setBackgroundColor(this.backgroundColor || this.color, {
                    staticClass: "v-progress-linear__background",
                    style: this.backgroundStyle
                  }));
                },
                __cachedBar: function __cachedBar() {
                  return this.$createElement(this.computedTransition, [this.__cachedBarType]);
                },
                __cachedBarType: function __cachedBarType() {
                  return this.indeterminate ? this.__cachedIndeterminate : this.__cachedDeterminate;
                },
                __cachedBuffer: function __cachedBuffer() {
                  return this.$createElement("div", {
                    staticClass: "v-progress-linear__buffer",
                    style: this.styles
                  });
                },
                __cachedDeterminate: function __cachedDeterminate() {
                  return this.$createElement("div", this.setBackgroundColor(this.color, {
                    staticClass: "v-progress-linear__determinate",
                    style: {
                      width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.normalizedValue, "%")
                    }
                  }));
                },
                __cachedIndeterminate: function __cachedIndeterminate() {
                  return this.$createElement("div", {
                    staticClass: "v-progress-linear__indeterminate",
                    class: {
                      "v-progress-linear__indeterminate--active": this.active
                    }
                  }, [this.genProgressBar("long"), this.genProgressBar("short")]);
                },
                __cachedStream: function __cachedStream() {
                  if (!this.stream)
                    return null;
                  return this.$createElement("div", this.setTextColor(this.color, {
                    staticClass: "v-progress-linear__stream",
                    style: {
                      width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(100 - this.normalizedBuffer, "%")
                    }
                  }));
                },
                backgroundStyle: function backgroundStyle() {
                  var _a2;
                  var backgroundOpacity = this.backgroundOpacity == null ? this.backgroundColor ? 1 : 0.3 : parseFloat(this.backgroundOpacity);
                  return _a2 = {
                    opacity: backgroundOpacity
                  }, _a2[this.isReversed ? "right" : "left"] = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.normalizedValue, "%"), _a2.width = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(Math.max(0, this.normalizedBuffer - this.normalizedValue), "%"), _a2;
                },
                classes: function classes() {
                  return __assign2({
                    "v-progress-linear--absolute": this.absolute,
                    "v-progress-linear--fixed": this.fixed,
                    "v-progress-linear--query": this.query,
                    "v-progress-linear--reactive": this.reactive,
                    "v-progress-linear--reverse": this.isReversed,
                    "v-progress-linear--rounded": this.rounded,
                    "v-progress-linear--striped": this.striped,
                    "v-progress-linear--visible": this.isVisible
                  }, this.themeClasses);
                },
                computedTransition: function computedTransition() {
                  return this.indeterminate ? _transitions__WEBPACK_IMPORTED_MODULE_1__["VFadeTransition"] : _transitions__WEBPACK_IMPORTED_MODULE_1__["VSlideXTransition"];
                },
                isReversed: function isReversed() {
                  return this.$vuetify.rtl !== this.reverse;
                },
                normalizedBuffer: function normalizedBuffer() {
                  return this.normalize(this.bufferValue);
                },
                normalizedValue: function normalizedValue() {
                  return this.normalize(this.internalLazyValue);
                },
                reactive: function reactive2() {
                  return Boolean(this.$listeners.change);
                },
                styles: function styles() {
                  var styles2 = {};
                  if (!this.active) {
                    styles2.height = 0;
                  }
                  if (!this.indeterminate && parseFloat(this.normalizedBuffer) !== 100) {
                    styles2.width = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.normalizedBuffer, "%");
                  }
                  return styles2;
                }
              },
              methods: {
                genContent: function genContent() {
                  var slot = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getSlot"])(this, "default", {
                    value: this.internalLazyValue
                  });
                  if (!slot)
                    return null;
                  return this.$createElement("div", {
                    staticClass: "v-progress-linear__content"
                  }, slot);
                },
                genListeners: function genListeners() {
                  var listeners = this.$listeners;
                  if (this.reactive) {
                    listeners.click = this.onClick;
                  }
                  return listeners;
                },
                genProgressBar: function genProgressBar(name) {
                  var _a2;
                  return this.$createElement("div", this.setBackgroundColor(this.color, {
                    staticClass: "v-progress-linear__indeterminate",
                    class: (_a2 = {}, _a2[name] = true, _a2)
                  }));
                },
                onClick: function onClick(e) {
                  if (!this.reactive)
                    return;
                  var width = this.$el.getBoundingClientRect().width;
                  this.internalValue = e.offsetX / width * 100;
                },
                onObserve: function onObserve(entries, observer, isIntersecting) {
                  this.isVisible = isIntersecting;
                },
                normalize: function normalize2(value) {
                  if (value < 0)
                    return 0;
                  if (value > 100)
                    return 100;
                  return parseFloat(value);
                }
              },
              render: function render8(h) {
                var data = {
                  staticClass: "v-progress-linear",
                  attrs: {
                    role: "progressbar",
                    "aria-valuemin": 0,
                    "aria-valuemax": this.normalizedBuffer,
                    "aria-valuenow": this.indeterminate ? void 0 : this.normalizedValue
                  },
                  class: this.classes,
                  directives: [{
                    name: "intersect",
                    value: this.onObserve
                  }],
                  style: {
                    bottom: this.bottom ? 0 : void 0,
                    height: this.active ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.height) : 0,
                    top: this.top ? 0 : void 0
                  },
                  on: this.genListeners()
                };
                return h("div", data, [this.__cachedStream, this.__cachedBackground, this.__cachedBuffer, this.__cachedBar, this.genContent()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VProgressLinear/index.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VProgressLinear/index.ts ***!
            \*************************************************/
          /*! exports provided: VProgressLinear, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VProgressLinear__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VProgressLinear */
              "./src/components/VProgressLinear/VProgressLinear.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VProgressLinear", function() {
              return _VProgressLinear__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VProgressLinear__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VRadioGroup/VRadio.sass": (
          /*!************************************************!*\
            !*** ./src/components/VRadioGroup/VRadio.sass ***!
            \************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VRadioGroup/VRadio.ts": (
          /*!**********************************************!*\
            !*** ./src/components/VRadioGroup/VRadio.ts ***!
            \**********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VRadio.sass */
              "./src/components/VRadioGroup/VRadio.sass"
            );
            var _VLabel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VLabel */
              "./src/components/VLabel/index.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _VInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VInput */
              "./src/components/VInput/index.ts"
            );
            var _mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/binds-attrs */
              "./src/mixins/binds-attrs/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_groupable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/groupable */
              "./src/mixins/groupable/index.ts"
            );
            var _mixins_rippleable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../mixins/rippleable */
              "./src/mixins/rippleable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _mixins_selectable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../mixins/selectable */
              "./src/mixins/selectable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __rest = function(s2, e) {
              var t3 = {};
              for (var p in s2) {
                if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
                  t3[p] = s2[p];
              }
              if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
                for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
                  if (e.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
                    t3[p[i2]] = s2[p[i2]];
                }
              return t3;
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_11__["default"])(_mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_colorable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_rippleable__WEBPACK_IMPORTED_MODULE_7__["default"], Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_6__["factory"])("radioGroup"), _mixins_themeable__WEBPACK_IMPORTED_MODULE_8__["default"]);
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-radio",
              inheritAttrs: false,
              props: {
                disabled: {
                  type: Boolean,
                  default: null
                },
                id: String,
                label: String,
                name: String,
                offIcon: {
                  type: String,
                  default: "$radioOff"
                },
                onIcon: {
                  type: String,
                  default: "$radioOn"
                },
                readonly: {
                  type: Boolean,
                  default: null
                },
                value: {
                  default: null
                }
              },
              data: function data() {
                return {
                  isFocused: false
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({
                    "v-radio--is-disabled": this.isDisabled,
                    "v-radio--is-focused": this.isFocused
                  }, this.themeClasses), this.groupClasses);
                },
                computedColor: function computedColor() {
                  if (this.isDisabled)
                    return void 0;
                  return _mixins_selectable__WEBPACK_IMPORTED_MODULE_9__["default"].options.computed.computedColor.call(this);
                },
                computedIcon: function computedIcon() {
                  return this.isActive ? this.onIcon : this.offIcon;
                },
                computedId: function computedId() {
                  return _VInput__WEBPACK_IMPORTED_MODULE_3__["default"].options.computed.computedId.call(this);
                },
                hasLabel: _VInput__WEBPACK_IMPORTED_MODULE_3__["default"].options.computed.hasLabel,
                hasState: function hasState() {
                  return (this.radioGroup || {}).hasState;
                },
                isDisabled: function isDisabled() {
                  var _a2;
                  return (_a2 = this.disabled) !== null && _a2 !== void 0 ? _a2 : !!this.radioGroup && this.radioGroup.isDisabled;
                },
                isReadonly: function isReadonly() {
                  var _a2;
                  return (_a2 = this.readonly) !== null && _a2 !== void 0 ? _a2 : !!this.radioGroup && this.radioGroup.isReadonly;
                },
                computedName: function computedName() {
                  if (this.name || !this.radioGroup) {
                    return this.name;
                  }
                  return this.radioGroup.name || "radio-" + this.radioGroup._uid;
                },
                rippleState: function rippleState() {
                  return _mixins_selectable__WEBPACK_IMPORTED_MODULE_9__["default"].options.computed.rippleState.call(this);
                },
                validationState: function validationState() {
                  return (this.radioGroup || {}).validationState || this.computedColor;
                }
              },
              methods: {
                genInput: function genInput(args) {
                  return _mixins_selectable__WEBPACK_IMPORTED_MODULE_9__["default"].options.methods.genInput.call(this, "radio", args);
                },
                genLabel: function genLabel() {
                  if (!this.hasLabel)
                    return null;
                  return this.$createElement(_VLabel__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    on: {
                      // Label shouldn't cause the input to focus
                      click: _mixins_selectable__WEBPACK_IMPORTED_MODULE_9__["prevent"]
                    },
                    attrs: {
                      for: this.computedId
                    },
                    props: {
                      color: this.validationState,
                      focused: this.hasState
                    }
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_10__["getSlot"])(this, "label") || this.label);
                },
                genRadio: function genRadio() {
                  var _a2 = this.attrs$;
                  _a2.title;
                  var radioAttrs = __rest(_a2, ["title"]);
                  return this.$createElement("div", {
                    staticClass: "v-input--selection-controls__input"
                  }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], this.setTextColor(this.validationState, {
                    props: {
                      dense: this.radioGroup && this.radioGroup.dense
                    }
                  }), this.computedIcon), this.genInput(__assign2({
                    name: this.computedName,
                    value: this.value
                  }, radioAttrs)), this.genRipple(this.setTextColor(this.rippleState))]);
                },
                onFocus: function onFocus(e) {
                  this.isFocused = true;
                  this.$emit("focus", e);
                },
                onBlur: function onBlur(e) {
                  this.isFocused = false;
                  this.$emit("blur", e);
                },
                onChange: function onChange() {
                  if (this.isDisabled || this.isReadonly || this.isActive)
                    return;
                  this.toggle();
                },
                onKeydown: function onKeydown() {
                }
                // Override default with noop
              },
              render: function render8(h) {
                var data = {
                  staticClass: "v-radio",
                  class: this.classes,
                  on: Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_12__["mergeListeners"])({
                    click: this.onChange
                  }, this.listeners$),
                  attrs: {
                    title: this.attrs$.title
                  }
                };
                return h("div", data, [this.genRadio(), this.genLabel()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VRadioGroup/VRadioGroup.sass": (
          /*!*****************************************************!*\
            !*** ./src/components/VRadioGroup/VRadioGroup.sass ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VRadioGroup/VRadioGroup.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VRadioGroup/VRadioGroup.ts ***!
            \***************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ../../styles/components/_selection-controls.sass */
              "./src/styles/components/_selection-controls.sass"
            );
            __webpack_require__(
              /*! ./VRadioGroup.sass */
              "./src/components/VRadioGroup/VRadioGroup.sass"
            );
            var _VInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VInput */
              "./src/components/VInput/index.ts"
            );
            var _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VItemGroup/VItemGroup */
              "./src/components/VItemGroup/VItemGroup.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_3__["BaseItemGroup"], _VInput__WEBPACK_IMPORTED_MODULE_2__["default"]);
            __webpack_exports__["default"] = baseMixins.extend({
              name: "v-radio-group",
              provide: function provide() {
                return {
                  radioGroup: this
                };
              },
              props: {
                column: {
                  type: Boolean,
                  default: true
                },
                height: {
                  type: [Number, String],
                  default: "auto"
                },
                name: String,
                row: Boolean,
                // If no value set on VRadio
                // will match valueComparator
                // force default to null
                value: null
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VInput__WEBPACK_IMPORTED_MODULE_2__["default"].options.computed.classes.call(this)), {
                    "v-input--selection-controls v-input--radio-group": true,
                    "v-input--radio-group--column": this.column && !this.row,
                    "v-input--radio-group--row": this.row
                  });
                }
              },
              methods: {
                genDefaultSlot: function genDefaultSlot() {
                  return this.$createElement("div", {
                    staticClass: "v-input--radio-group__input",
                    attrs: {
                      id: this.id,
                      role: "radiogroup",
                      "aria-labelledby": this.computedId
                    }
                  }, _VInput__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genDefaultSlot.call(this));
                },
                genInputSlot: function genInputSlot() {
                  var render8 = _VInput__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genInputSlot.call(this);
                  delete render8.data.on.click;
                  return render8;
                },
                genLabel: function genLabel() {
                  var label = _VInput__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genLabel.call(this);
                  if (!label)
                    return null;
                  label.data.attrs.id = this.computedId;
                  delete label.data.attrs.for;
                  label.tag = "legend";
                  return label;
                },
                onClick: _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_3__["BaseItemGroup"].options.methods.onClick
              },
              render: function render8(h) {
                var vnode = _VInput__WEBPACK_IMPORTED_MODULE_2__["default"].options.render.call(this, h);
                this._b(vnode.data, "div", this.attrs$);
                return vnode;
              }
            });
          }
        ),
        /***/
        "./src/components/VRadioGroup/index.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VRadioGroup/index.ts ***!
            \*********************************************/
          /*! exports provided: VRadioGroup, VRadio, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VRadioGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VRadioGroup */
              "./src/components/VRadioGroup/VRadioGroup.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VRadioGroup", function() {
              return _VRadioGroup__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VRadio__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VRadio */
              "./src/components/VRadioGroup/VRadio.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VRadio", function() {
              return _VRadio__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VRadioGroup: _VRadioGroup__WEBPACK_IMPORTED_MODULE_0__["default"],
                VRadio: _VRadio__WEBPACK_IMPORTED_MODULE_1__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VRangeSlider/VRangeSlider.sass": (
          /*!*******************************************************!*\
            !*** ./src/components/VRangeSlider/VRangeSlider.sass ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VRangeSlider/VRangeSlider.ts": (
          /*!*****************************************************!*\
            !*** ./src/components/VRangeSlider/VRangeSlider.ts ***!
            \*****************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VRangeSlider.sass */
              "./src/components/VRangeSlider/VRangeSlider.sass"
            );
            var _VSlider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSlider */
              "./src/components/VSlider/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            __webpack_exports__["default"] = _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
              name: "v-range-slider",
              props: {
                value: {
                  type: Array,
                  default: function _default() {
                    return [0, 0];
                  }
                }
              },
              data: function data() {
                return {
                  activeThumb: null,
                  lazyValue: this.value
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-input--range-slider": true
                  });
                },
                internalValue: {
                  get: function get5() {
                    return this.lazyValue;
                  },
                  set: function set2(val) {
                    var _this2 = this;
                    var value = val.map(function(v) {
                      if (v === void 0) {
                        v = 0;
                      }
                      return _this2.roundValue(Math.min(Math.max(v, _this2.minValue), _this2.maxValue));
                    });
                    if (value[0] > value[1] || value[1] < value[0]) {
                      if (this.activeThumb !== null) {
                        var toFocus = this.activeThumb === 1 ? 0 : 1;
                        var el = this.$refs["thumb_" + toFocus];
                        el.focus();
                      }
                      value = [value[1], value[0]];
                    }
                    this.lazyValue = value;
                    if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["deepEqual"])(value, this.value))
                      this.$emit("input", value);
                    this.validate();
                  }
                },
                inputWidth: function inputWidth() {
                  var _this2 = this;
                  return this.internalValue.map(function(v) {
                    return (_this2.roundValue(v) - _this2.minValue) / (_this2.maxValue - _this2.minValue) * 100;
                  });
                }
              },
              methods: {
                getTrackStyle: function getTrackStyle(startLength, endLength, startPadding, endPadding) {
                  var _a2;
                  if (startPadding === void 0) {
                    startPadding = 0;
                  }
                  if (endPadding === void 0) {
                    endPadding = 0;
                  }
                  var startDir = this.vertical ? this.$vuetify.rtl ? "top" : "bottom" : this.$vuetify.rtl ? "right" : "left";
                  var endDir = this.vertical ? "height" : "width";
                  var start = "calc(" + startLength + "% + " + startPadding + "px)";
                  var end = "calc(" + endLength + "% + " + endPadding + "px)";
                  return _a2 = {
                    transition: this.trackTransition
                  }, _a2[startDir] = start, _a2[endDir] = end, _a2;
                },
                getIndexOfClosestValue: function getIndexOfClosestValue(arr, v) {
                  if (Math.abs(arr[0] - v) < Math.abs(arr[1] - v))
                    return 0;
                  else
                    return 1;
                },
                genInput: function genInput() {
                  var _this2 = this;
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["createRange"])(2).map(function(i2) {
                    var input2 = _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genInput.call(_this2);
                    input2.data = input2.data || {};
                    input2.data.attrs = input2.data.attrs || {};
                    input2.data.attrs.value = _this2.internalValue[i2];
                    input2.data.attrs.id = "input-" + (i2 ? "max" : "min") + "-" + _this2._uid;
                    return input2;
                  });
                },
                genTrackContainer: function genTrackContainer() {
                  var _this2 = this;
                  var children = [];
                  var padding = this.isDisabled ? 10 : 0;
                  var sections = [{
                    class: "v-slider__track-background",
                    color: this.computedTrackColor,
                    styles: [0, this.inputWidth[0], 0, -padding]
                  }, {
                    class: this.isDisabled ? "v-slider__track-background" : "v-slider__track-fill",
                    color: this.isDisabled ? this.computedTrackColor : this.computedTrackFillColor,
                    styles: [this.inputWidth[0], Math.abs(this.inputWidth[1] - this.inputWidth[0]), padding, padding * -2]
                  }, {
                    class: "v-slider__track-background",
                    color: this.computedTrackColor,
                    styles: [this.inputWidth[1], Math.abs(100 - this.inputWidth[1]), padding, -padding]
                  }];
                  if (this.$vuetify.rtl)
                    sections.reverse();
                  children.push.apply(children, __spreadArray2([], __read2(sections.map(function(section) {
                    return _this2.$createElement("div", _this2.setBackgroundColor(section.color, {
                      staticClass: section.class,
                      style: _this2.getTrackStyle.apply(_this2, __spreadArray2([], __read2(section.styles), false))
                    }));
                  })), false));
                  return this.$createElement("div", {
                    staticClass: "v-slider__track-container",
                    ref: "track"
                  }, children);
                },
                genChildren: function genChildren() {
                  var _this2 = this;
                  return [this.genInput(), this.genTrackContainer(), this.genSteps(), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["createRange"])(2).map(function(index2) {
                    var value = _this2.internalValue[index2];
                    var onFocus = function onFocus2(e) {
                      _this2.isFocused = true;
                      _this2.activeThumb = index2;
                      _this2.$emit("focus", e);
                    };
                    var onBlur = function onBlur2(e) {
                      _this2.isFocused = false;
                      _this2.activeThumb = null;
                      _this2.$emit("blur", e);
                    };
                    var valueWidth = _this2.inputWidth[index2];
                    var isActive = _this2.isActive && _this2.activeThumb === index2;
                    var isFocused = _this2.isFocused && _this2.activeThumb === index2;
                    return _this2.genThumbContainer(value, valueWidth, isActive, isFocused, onFocus, onBlur, "thumb_" + index2);
                  })];
                },
                reevaluateSelected: function reevaluateSelected(value) {
                  this.activeThumb = this.getIndexOfClosestValue(this.internalValue, value);
                  var refName = "thumb_" + this.activeThumb;
                  var thumbRef = this.$refs[refName];
                  thumbRef.focus();
                },
                onSliderMouseDown: function onSliderMouseDown(e) {
                  var _this2 = this;
                  var _a2;
                  var value = this.parseMouseMove(e);
                  this.reevaluateSelected(value);
                  this.oldValue = this.internalValue;
                  this.isActive = true;
                  if ((_a2 = e.target) === null || _a2 === void 0 ? void 0 : _a2.matches(".v-slider__thumb-container, .v-slider__thumb-container *")) {
                    this.thumbPressed = true;
                    var domRect = e.target.getBoundingClientRect();
                    var touch = "touches" in e ? e.touches[0] : e;
                    this.startOffset = this.vertical ? touch.clientY - (domRect.top + domRect.height / 2) : touch.clientX - (domRect.left + domRect.width / 2);
                  } else {
                    this.startOffset = 0;
                    window.clearTimeout(this.mouseTimeout);
                    this.mouseTimeout = window.setTimeout(function() {
                      _this2.thumbPressed = true;
                    }, 300);
                  }
                  var mouseUpOptions = _util_helpers__WEBPACK_IMPORTED_MODULE_2__["passiveSupported"] ? {
                    passive: true,
                    capture: true
                  } : true;
                  var mouseMoveOptions = _util_helpers__WEBPACK_IMPORTED_MODULE_2__["passiveSupported"] ? {
                    passive: true
                  } : false;
                  var isTouchEvent = "touches" in e;
                  this.onMouseMove(e);
                  this.app.addEventListener(isTouchEvent ? "touchmove" : "mousemove", this.onMouseMove, mouseMoveOptions);
                  Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["addOnceEventListener"])(this.app, isTouchEvent ? "touchend" : "mouseup", this.onSliderMouseUp, mouseUpOptions);
                  this.$emit("start", this.internalValue);
                },
                onSliderClick: function onSliderClick(e) {
                  if (!this.isActive) {
                    if (this.noClick) {
                      this.noClick = false;
                      return;
                    }
                    var value = this.parseMouseMove(e);
                    this.reevaluateSelected(value);
                    this.setInternalValue(value);
                    this.$emit("change", this.internalValue);
                  }
                },
                onMouseMove: function onMouseMove(e) {
                  var value = this.parseMouseMove(e);
                  if (e.type === "mousemove") {
                    this.thumbPressed = true;
                  }
                  if (this.activeThumb === null) {
                    this.activeThumb = this.getIndexOfClosestValue(this.internalValue, value);
                  }
                  this.setInternalValue(value);
                },
                onKeyDown: function onKeyDown(e) {
                  if (this.activeThumb === null)
                    return;
                  var value = this.parseKeyDown(e, this.internalValue[this.activeThumb]);
                  if (value == null)
                    return;
                  this.setInternalValue(value);
                  this.$emit("change", this.internalValue);
                },
                setInternalValue: function setInternalValue(value) {
                  var _this2 = this;
                  this.internalValue = this.internalValue.map(function(v, i2) {
                    if (i2 === _this2.activeThumb)
                      return value;
                    else
                      return Number(v);
                  });
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VRangeSlider/index.ts": (
          /*!**********************************************!*\
            !*** ./src/components/VRangeSlider/index.ts ***!
            \**********************************************/
          /*! exports provided: VRangeSlider, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VRangeSlider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VRangeSlider */
              "./src/components/VRangeSlider/VRangeSlider.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VRangeSlider", function() {
              return _VRangeSlider__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VRangeSlider__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VRating/VRating.sass": (
          /*!*********************************************!*\
            !*** ./src/components/VRating/VRating.sass ***!
            \*********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VRating/VRating.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VRating/VRating.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VRating.sass */
              "./src/components/VRating/VRating.sass"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_delayable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/delayable */
              "./src/mixins/delayable/index.ts"
            );
            var _mixins_sizeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/sizeable */
              "./src/mixins/sizeable/index.ts"
            );
            var _mixins_rippleable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/rippleable */
              "./src/mixins/rippleable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_delayable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_rippleable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_sizeable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__["default"]).extend({
              name: "v-rating",
              props: {
                backgroundColor: {
                  type: String,
                  default: "accent"
                },
                color: {
                  type: String,
                  default: "primary"
                },
                clearable: Boolean,
                dense: Boolean,
                emptyIcon: {
                  type: String,
                  default: "$ratingEmpty"
                },
                fullIcon: {
                  type: String,
                  default: "$ratingFull"
                },
                halfIcon: {
                  type: String,
                  default: "$ratingHalf"
                },
                halfIncrements: Boolean,
                hover: Boolean,
                length: {
                  type: [Number, String],
                  default: 5
                },
                readonly: Boolean,
                size: [Number, String],
                value: {
                  type: Number,
                  default: 0
                },
                iconLabel: {
                  type: String,
                  default: "$vuetify.rating.ariaLabel.icon"
                }
              },
              data: function data() {
                return {
                  hoverIndex: -1,
                  internalValue: this.value
                };
              },
              computed: {
                directives: function directives2() {
                  if (this.readonly || !this.ripple)
                    return [];
                  return [{
                    name: "ripple",
                    value: {
                      circle: true
                    }
                  }];
                },
                iconProps: function iconProps() {
                  var _a2 = this.$props, dark = _a2.dark, large = _a2.large, light = _a2.light, medium = _a2.medium, small = _a2.small, size = _a2.size, xLarge = _a2.xLarge, xSmall = _a2.xSmall;
                  return {
                    dark,
                    large,
                    light,
                    medium,
                    size,
                    small,
                    xLarge,
                    xSmall
                  };
                },
                isHovering: function isHovering() {
                  return this.hover && this.hoverIndex >= 0;
                }
              },
              watch: {
                internalValue: function internalValue(val) {
                  val !== this.value && this.$emit("input", val);
                },
                value: function value(val) {
                  this.internalValue = val;
                }
              },
              methods: {
                createClickFn: function createClickFn(i2) {
                  var _this2 = this;
                  return function(e) {
                    if (_this2.readonly)
                      return;
                    var newValue = _this2.genHoverIndex(e, i2);
                    if (_this2.clearable && _this2.internalValue === newValue) {
                      _this2.internalValue = 0;
                    } else {
                      _this2.internalValue = newValue;
                    }
                  };
                },
                createProps: function createProps(i2) {
                  var props2 = {
                    index: i2,
                    value: this.internalValue,
                    click: this.createClickFn(i2),
                    isFilled: Math.floor(this.internalValue) > i2,
                    isHovered: Math.floor(this.hoverIndex) > i2
                  };
                  if (this.halfIncrements) {
                    props2.isHalfHovered = !props2.isHovered && (this.hoverIndex - i2) % 1 > 0;
                    props2.isHalfFilled = !props2.isFilled && (this.internalValue - i2) % 1 > 0;
                  }
                  return props2;
                },
                genHoverIndex: function genHoverIndex(e, i2) {
                  var isHalf = this.isHalfEvent(e);
                  if (this.halfIncrements && this.$vuetify.rtl) {
                    isHalf = !isHalf;
                  }
                  return i2 + (isHalf ? 0.5 : 1);
                },
                getIconName: function getIconName(props2) {
                  var isFull = this.isHovering ? props2.isHovered : props2.isFilled;
                  var isHalf = this.isHovering ? props2.isHalfHovered : props2.isHalfFilled;
                  return isFull ? this.fullIcon : isHalf ? this.halfIcon : this.emptyIcon;
                },
                getColor: function getColor(props2) {
                  if (this.isHovering) {
                    if (props2.isHovered || props2.isHalfHovered)
                      return this.color;
                  } else {
                    if (props2.isFilled || props2.isHalfFilled)
                      return this.color;
                  }
                  return this.backgroundColor;
                },
                isHalfEvent: function isHalfEvent(e) {
                  if (this.halfIncrements) {
                    var rect = e.target && e.target.getBoundingClientRect();
                    if (rect && e.pageX - rect.left < rect.width / 2)
                      return true;
                  }
                  return false;
                },
                onMouseEnter: function onMouseEnter(e, i2) {
                  var _this2 = this;
                  this.runDelay("open", function() {
                    _this2.hoverIndex = _this2.genHoverIndex(e, i2);
                  });
                },
                onMouseLeave: function onMouseLeave() {
                  var _this2 = this;
                  this.runDelay("close", function() {
                    return _this2.hoverIndex = -1;
                  });
                },
                genItem: function genItem(i2) {
                  var _this2 = this;
                  var props2 = this.createProps(i2);
                  if (this.$scopedSlots.item)
                    return this.$scopedSlots.item(props2);
                  var listeners = {
                    click: props2.click
                  };
                  if (this.hover) {
                    listeners.mouseenter = function(e) {
                      return _this2.onMouseEnter(e, i2);
                    };
                    listeners.mouseleave = this.onMouseLeave;
                    if (this.halfIncrements) {
                      listeners.mousemove = function(e) {
                        return _this2.onMouseEnter(e, i2);
                      };
                    }
                  }
                  return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.setTextColor(this.getColor(props2), {
                    attrs: {
                      "aria-label": this.$vuetify.lang.t(this.iconLabel, i2 + 1, Number(this.length))
                    },
                    directives: this.directives,
                    props: this.iconProps,
                    on: listeners
                  }), [this.getIconName(props2)]);
                }
              },
              render: function render8(h) {
                var _this2 = this;
                var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["createRange"])(Number(this.length)).map(function(i2) {
                  return _this2.genItem(i2);
                });
                return h("div", {
                  staticClass: "v-rating",
                  class: {
                    "v-rating--readonly": this.readonly,
                    "v-rating--dense": this.dense
                  }
                }, children);
              }
            });
          }
        ),
        /***/
        "./src/components/VRating/index.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VRating/index.ts ***!
            \*****************************************/
          /*! exports provided: VRating, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VRating__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VRating */
              "./src/components/VRating/VRating.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VRating", function() {
              return _VRating__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VRating__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VResponsive/VResponsive.sass": (
          /*!*****************************************************!*\
            !*** ./src/components/VResponsive/VResponsive.sass ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VResponsive/VResponsive.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VResponsive/VResponsive.ts ***!
            \***************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VResponsive.sass */
              "./src/components/VResponsive/VResponsive.sass"
            );
            var _mixins_measurable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/measurable */
              "./src/mixins/measurable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_measurable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
              name: "v-responsive",
              props: {
                aspectRatio: [String, Number],
                contentClass: String
              },
              computed: {
                computedAspectRatio: function computedAspectRatio() {
                  return Number(this.aspectRatio);
                },
                aspectStyle: function aspectStyle() {
                  return this.computedAspectRatio ? {
                    paddingBottom: 1 / this.computedAspectRatio * 100 + "%"
                  } : void 0;
                },
                __cachedSizer: function __cachedSizer() {
                  if (!this.aspectStyle)
                    return [];
                  return this.$createElement("div", {
                    style: this.aspectStyle,
                    staticClass: "v-responsive__sizer"
                  });
                }
              },
              methods: {
                genContent: function genContent() {
                  return this.$createElement("div", {
                    staticClass: "v-responsive__content",
                    class: this.contentClass
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this));
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-responsive",
                  style: this.measurableStyles,
                  on: this.$listeners
                }, [this.__cachedSizer, this.genContent()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VResponsive/index.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VResponsive/index.ts ***!
            \*********************************************/
          /*! exports provided: VResponsive, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VResponsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VResponsive */
              "./src/components/VResponsive/VResponsive.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VResponsive", function() {
              return _VResponsive__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VResponsive__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VSelect/VSelect.sass": (
          /*!*********************************************!*\
            !*** ./src/components/VSelect/VSelect.sass ***!
            \*********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VSelect/VSelect.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VSelect/VSelect.ts ***!
            \*******************************************/
          /*! exports provided: defaultMenuProps, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "defaultMenuProps", function() {
              return defaultMenuProps;
            });
            __webpack_require__(
              /*! ../VTextField/VTextField.sass */
              "./src/components/VTextField/VTextField.sass"
            );
            __webpack_require__(
              /*! ./VSelect.sass */
              "./src/components/VSelect/VSelect.sass"
            );
            var _VChip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VChip */
              "./src/components/VChip/index.ts"
            );
            var _VMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VMenu */
              "./src/components/VMenu/index.ts"
            );
            var _VSelectList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./VSelectList */
              "./src/components/VSelect/VSelectList.ts"
            );
            var _VInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../VInput */
              "./src/components/VInput/index.ts"
            );
            var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../VTextField/VTextField */
              "./src/components/VTextField/VTextField.ts"
            );
            var _mixins_comparable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../mixins/comparable */
              "./src/mixins/comparable/index.ts"
            );
            var _mixins_dependent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../mixins/dependent */
              "./src/mixins/dependent/index.ts"
            );
            var _mixins_filterable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../mixins/filterable */
              "./src/mixins/filterable/index.ts"
            );
            var _directives_click_outside__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ../../directives/click-outside */
              "./src/directives/click-outside/index.ts"
            );
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __values2 = function(o) {
              var s2 = typeof Symbol === "function" && Symbol.iterator, m = s2 && o[s2], i2 = 0;
              if (m)
                return m.call(o);
              if (o && typeof o.length === "number")
                return {
                  next: function next() {
                    if (o && i2 >= o.length)
                      o = void 0;
                    return {
                      value: o && o[i2++],
                      done: !o
                    };
                  }
                };
              throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            var defaultMenuProps = {
              closeOnClick: false,
              closeOnContentClick: false,
              disableKeys: true,
              openOnClick: false,
              maxHeight: 304
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_14__["default"])(_VTextField_VTextField__WEBPACK_IMPORTED_MODULE_6__["default"], _mixins_comparable__WEBPACK_IMPORTED_MODULE_7__["default"], _mixins_dependent__WEBPACK_IMPORTED_MODULE_8__["default"], _mixins_filterable__WEBPACK_IMPORTED_MODULE_9__["default"]);
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-select",
              directives: {
                ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_10__["default"]
              },
              props: {
                appendIcon: {
                  type: String,
                  default: "$dropdown"
                },
                attach: {
                  type: null,
                  default: false
                },
                cacheItems: Boolean,
                chips: Boolean,
                clearable: Boolean,
                deletableChips: Boolean,
                disableLookup: Boolean,
                eager: Boolean,
                hideSelected: Boolean,
                items: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                itemColor: {
                  type: String,
                  default: "primary"
                },
                itemDisabled: {
                  type: [String, Array, Function],
                  default: "disabled"
                },
                itemText: {
                  type: [String, Array, Function],
                  default: "text"
                },
                itemValue: {
                  type: [String, Array, Function],
                  default: "value"
                },
                menuProps: {
                  type: [String, Array, Object],
                  default: function _default() {
                    return defaultMenuProps;
                  }
                },
                multiple: Boolean,
                openOnClear: Boolean,
                returnObject: Boolean,
                smallChips: Boolean
              },
              data: function data() {
                return {
                  cachedItems: this.cacheItems ? this.items : [],
                  menuIsBooted: false,
                  isMenuActive: false,
                  lastItem: 20,
                  // As long as a value is defined, show it
                  // Otherwise, check if multiple
                  // to determine which default to provide
                  lazyValue: this.value !== void 0 ? this.value : this.multiple ? [] : void 0,
                  selectedIndex: -1,
                  selectedItems: [],
                  keyboardLookupPrefix: "",
                  keyboardLookupLastTime: 0
                };
              },
              computed: {
                /* All items that the select has */
                allItems: function allItems() {
                  return this.filterDuplicates(this.cachedItems.concat(this.items));
                },
                classes: function classes() {
                  return __assign2(__assign2({}, _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_6__["default"].options.computed.classes.call(this)), {
                    "v-select": true,
                    "v-select--chips": this.hasChips,
                    "v-select--chips--small": this.smallChips,
                    "v-select--is-menu-active": this.isMenuActive,
                    "v-select--is-multi": this.multiple
                  });
                },
                /* Used by other components to overwrite */
                computedItems: function computedItems() {
                  return this.allItems;
                },
                computedOwns: function computedOwns() {
                  return "list-" + this._uid;
                },
                computedCounterValue: function computedCounterValue() {
                  var _a2;
                  var value = this.multiple ? this.selectedItems : ((_a2 = this.getText(this.selectedItems[0])) !== null && _a2 !== void 0 ? _a2 : "").toString();
                  if (typeof this.counterValue === "function") {
                    return this.counterValue(value);
                  }
                  return value.length;
                },
                directives: function directives2() {
                  var _this2 = this;
                  return this.isFocused ? [{
                    name: "click-outside",
                    value: {
                      handler: this.blur,
                      closeConditional: this.closeConditional,
                      include: function include() {
                        return _this2.getOpenDependentElements();
                      }
                    }
                  }] : void 0;
                },
                dynamicHeight: function dynamicHeight() {
                  return "auto";
                },
                hasChips: function hasChips() {
                  return this.chips || this.smallChips;
                },
                hasSlot: function hasSlot() {
                  return Boolean(this.hasChips || this.$scopedSlots.selection);
                },
                isDirty: function isDirty() {
                  return this.selectedItems.length > 0;
                },
                listData: function listData() {
                  var _a2;
                  var scopeId = this.$vnode && this.$vnode.context.$options._scopeId;
                  var attrs2 = scopeId ? (_a2 = {}, _a2[scopeId] = true, _a2) : {};
                  return {
                    attrs: __assign2(__assign2({}, attrs2), {
                      id: this.computedOwns
                    }),
                    props: {
                      action: this.multiple,
                      color: this.itemColor,
                      dense: this.dense,
                      hideSelected: this.hideSelected,
                      items: this.virtualizedItems,
                      itemDisabled: this.itemDisabled,
                      itemText: this.itemText,
                      itemValue: this.itemValue,
                      noDataText: this.$vuetify.lang.t(this.noDataText),
                      selectedItems: this.selectedItems
                    },
                    on: {
                      select: this.selectItem
                    },
                    scopedSlots: {
                      item: this.$scopedSlots.item
                    }
                  };
                },
                staticList: function staticList() {
                  if (this.$slots["no-data"] || this.$slots["prepend-item"] || this.$slots["append-item"]) {
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_13__["consoleError"])("assert: staticList should not be called if slots are used");
                  }
                  return this.$createElement(_VSelectList__WEBPACK_IMPORTED_MODULE_4__["default"], this.listData);
                },
                virtualizedItems: function virtualizedItems() {
                  return this.$_menuProps.auto ? this.computedItems : this.computedItems.slice(0, this.lastItem);
                },
                menuCanShow: function menuCanShow() {
                  return true;
                },
                $_menuProps: function $_menuProps() {
                  var normalisedProps = typeof this.menuProps === "string" ? this.menuProps.split(",") : this.menuProps;
                  if (Array.isArray(normalisedProps)) {
                    normalisedProps = normalisedProps.reduce(function(acc, p) {
                      acc[p.trim()] = true;
                      return acc;
                    }, {});
                  }
                  return __assign2(__assign2(__assign2({}, defaultMenuProps), {
                    eager: this.eager,
                    value: this.menuCanShow && this.isMenuActive,
                    nudgeBottom: normalisedProps.offsetY ? 1 : 0
                  }), normalisedProps);
                }
              },
              watch: {
                internalValue: function internalValue(val) {
                  var _this2 = this;
                  this.initialValue = val;
                  this.setSelectedItems();
                  if (this.multiple) {
                    this.$nextTick(function() {
                      var _a2;
                      (_a2 = _this2.$refs.menu) === null || _a2 === void 0 ? void 0 : _a2.updateDimensions();
                    });
                  }
                  if (this.hideSelected) {
                    this.$nextTick(function() {
                      _this2.onScroll();
                    });
                  }
                },
                isMenuActive: function isMenuActive(val) {
                  var _this2 = this;
                  window.setTimeout(function() {
                    return _this2.onMenuActiveChange(val);
                  });
                },
                items: {
                  immediate: true,
                  handler: function handler(val) {
                    var _this2 = this;
                    if (this.cacheItems) {
                      this.$nextTick(function() {
                        _this2.cachedItems = _this2.filterDuplicates(_this2.cachedItems.concat(val));
                      });
                    }
                    this.setSelectedItems();
                  }
                }
              },
              methods: {
                /** @public */
                blur: function blur(e) {
                  _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_6__["default"].options.methods.blur.call(this, e);
                  this.isMenuActive = false;
                  this.isFocused = false;
                  this.selectedIndex = -1;
                  this.setMenuIndex(-1);
                },
                /** @public */
                activateMenu: function activateMenu() {
                  if (!this.isInteractive || this.isMenuActive)
                    return;
                  this.isMenuActive = true;
                },
                clearableCallback: function clearableCallback() {
                  var _this2 = this;
                  this.setValue(this.multiple ? [] : null);
                  this.setMenuIndex(-1);
                  this.$nextTick(function() {
                    return _this2.$refs.input && _this2.$refs.input.focus();
                  });
                  if (this.openOnClear)
                    this.isMenuActive = true;
                },
                closeConditional: function closeConditional(e) {
                  if (!this.isMenuActive)
                    return true;
                  return !this._isDestroyed && // Click originates from outside the menu content
                  // Multiple selects don't close when an item is clicked
                  (!this.getContent() || !this.getContent().contains(e.target)) && // Click originates from outside the element
                  this.$el && !this.$el.contains(e.target) && e.target !== this.$el;
                },
                filterDuplicates: function filterDuplicates(arr) {
                  var uniqueValues = /* @__PURE__ */ new Map();
                  for (var index2 = 0; index2 < arr.length; ++index2) {
                    var item = arr[index2];
                    if (item == null) {
                      continue;
                    }
                    if (item.header || item.divider) {
                      uniqueValues.set(item, item);
                      continue;
                    }
                    var val = this.getValue(item);
                    !uniqueValues.has(val) && uniqueValues.set(val, item);
                  }
                  return Array.from(uniqueValues.values());
                },
                findExistingIndex: function findExistingIndex(item) {
                  var _this2 = this;
                  var itemValue = this.getValue(item);
                  return (this.internalValue || []).findIndex(function(i2) {
                    return _this2.valueComparator(_this2.getValue(i2), itemValue);
                  });
                },
                getContent: function getContent() {
                  return this.$refs.menu && this.$refs.menu.$refs.content;
                },
                genChipSelection: function genChipSelection(item, index2) {
                  var _this2 = this;
                  var isDisabled = this.isDisabled || this.getDisabled(item);
                  var isInteractive = !isDisabled && this.isInteractive;
                  return this.$createElement(_VChip__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    staticClass: "v-chip--select",
                    attrs: {
                      tabindex: -1
                    },
                    props: {
                      close: this.deletableChips && isInteractive,
                      disabled: isDisabled,
                      inputValue: index2 === this.selectedIndex,
                      small: this.smallChips
                    },
                    on: {
                      click: function click2(e) {
                        if (!isInteractive)
                          return;
                        e.stopPropagation();
                        _this2.selectedIndex = index2;
                      },
                      "click:close": function clickClose() {
                        return _this2.onChipInput(item);
                      }
                    },
                    key: JSON.stringify(this.getValue(item))
                  }, this.getText(item));
                },
                genCommaSelection: function genCommaSelection(item, index2, last2) {
                  var color2 = index2 === this.selectedIndex && this.computedColor;
                  var isDisabled = this.isDisabled || this.getDisabled(item);
                  return this.$createElement("div", this.setTextColor(color2, {
                    staticClass: "v-select__selection v-select__selection--comma",
                    class: {
                      "v-select__selection--disabled": isDisabled
                    },
                    key: JSON.stringify(this.getValue(item))
                  }), "" + this.getText(item) + (last2 ? "" : ", "));
                },
                genDefaultSlot: function genDefaultSlot() {
                  var selections = this.genSelections();
                  var input2 = this.genInput();
                  if (Array.isArray(selections)) {
                    selections.push(input2);
                  } else {
                    selections.children = selections.children || [];
                    selections.children.push(input2);
                  }
                  return [this.genFieldset(), this.$createElement("div", {
                    staticClass: "v-select__slot",
                    directives: this.directives
                  }, [this.genLabel(), this.prefix ? this.genAffix("prefix") : null, selections, this.suffix ? this.genAffix("suffix") : null, this.genClearIcon(), this.genIconSlot(), this.genHiddenInput()]), this.genMenu(), this.genProgress()];
                },
                genIcon: function genIcon(type, cb, extraData) {
                  var icon = _VInput__WEBPACK_IMPORTED_MODULE_5__["default"].options.methods.genIcon.call(this, type, cb, extraData);
                  if (type === "append") {
                    icon.children[0].data = Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_11__["default"])(icon.children[0].data, {
                      attrs: {
                        tabindex: icon.children[0].componentOptions.listeners && "-1",
                        "aria-hidden": "true",
                        "aria-label": void 0
                      }
                    });
                  }
                  return icon;
                },
                genInput: function genInput() {
                  var input2 = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_6__["default"].options.methods.genInput.call(this);
                  delete input2.data.attrs.name;
                  input2.data = Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_11__["default"])(input2.data, {
                    domProps: {
                      value: null
                    },
                    attrs: {
                      readonly: true,
                      type: "text",
                      "aria-readonly": String(this.isReadonly),
                      "aria-activedescendant": Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["getObjectValueByPath"])(this.$refs.menu, "activeTile.id"),
                      autocomplete: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["getObjectValueByPath"])(input2.data, "attrs.autocomplete", "off"),
                      placeholder: !this.isDirty && (this.persistentPlaceholder || this.isFocused || !this.hasLabel) ? this.placeholder : void 0
                    },
                    on: {
                      keypress: this.onKeyPress
                    }
                  });
                  return input2;
                },
                genHiddenInput: function genHiddenInput() {
                  return this.$createElement("input", {
                    domProps: {
                      value: this.lazyValue
                    },
                    attrs: {
                      type: "hidden",
                      name: this.attrs$.name
                    }
                  });
                },
                genInputSlot: function genInputSlot() {
                  var render8 = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_6__["default"].options.methods.genInputSlot.call(this);
                  render8.data.attrs = __assign2(__assign2({}, render8.data.attrs), {
                    role: "button",
                    "aria-haspopup": "listbox",
                    "aria-expanded": String(this.isMenuActive),
                    "aria-owns": this.computedOwns
                  });
                  return render8;
                },
                genList: function genList() {
                  if (this.$slots["no-data"] || this.$slots["prepend-item"] || this.$slots["append-item"]) {
                    return this.genListWithSlot();
                  } else {
                    return this.staticList;
                  }
                },
                genListWithSlot: function genListWithSlot() {
                  var _this2 = this;
                  var slots = ["prepend-item", "no-data", "append-item"].filter(function(slotName) {
                    return _this2.$slots[slotName];
                  }).map(function(slotName) {
                    return _this2.$createElement("template", {
                      slot: slotName
                    }, _this2.$slots[slotName]);
                  });
                  return this.$createElement(_VSelectList__WEBPACK_IMPORTED_MODULE_4__["default"], __assign2({}, this.listData), slots);
                },
                genMenu: function genMenu() {
                  var _this2 = this;
                  var props2 = this.$_menuProps;
                  props2.activator = this.$refs["input-slot"];
                  if ("attach" in props2)
                    ;
                  else if (
                    // TODO: make this a computed property or helper or something
                    this.attach === "" || // If used as a boolean prop (<v-menu attach>)
                    this.attach === true || // If bound to a boolean (<v-menu :attach="true">)
                    this.attach === "attach"
                  ) {
                    props2.attach = this.$el;
                  } else {
                    props2.attach = this.attach;
                  }
                  return this.$createElement(_VMenu__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    attrs: {
                      role: void 0
                    },
                    props: props2,
                    on: {
                      input: function input2(val) {
                        _this2.isMenuActive = val;
                        _this2.isFocused = val;
                      },
                      scroll: this.onScroll
                    },
                    ref: "menu"
                  }, [this.genList()]);
                },
                genSelections: function genSelections() {
                  var length = this.selectedItems.length;
                  var children = new Array(length);
                  var genSelection;
                  if (this.$scopedSlots.selection) {
                    genSelection = this.genSlotSelection;
                  } else if (this.hasChips) {
                    genSelection = this.genChipSelection;
                  } else {
                    genSelection = this.genCommaSelection;
                  }
                  while (length--) {
                    children[length] = genSelection(this.selectedItems[length], length, length === children.length - 1);
                  }
                  return this.$createElement("div", {
                    staticClass: "v-select__selections"
                  }, children);
                },
                genSlotSelection: function genSlotSelection(item, index2) {
                  var _this2 = this;
                  return this.$scopedSlots.selection({
                    attrs: {
                      class: "v-chip--select"
                    },
                    parent: this,
                    item,
                    index: index2,
                    select: function select(e) {
                      e.stopPropagation();
                      _this2.selectedIndex = index2;
                    },
                    selected: index2 === this.selectedIndex,
                    disabled: !this.isInteractive
                  });
                },
                getMenuIndex: function getMenuIndex() {
                  return this.$refs.menu ? this.$refs.menu.listIndex : -1;
                },
                getDisabled: function getDisabled(item) {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["getPropertyFromItem"])(item, this.itemDisabled, false);
                },
                getText: function getText2(item) {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["getPropertyFromItem"])(item, this.itemText, item);
                },
                getValue: function getValue2(item) {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_12__["getPropertyFromItem"])(item, this.itemValue, this.getText(item));
                },
                onBlur: function onBlur(e) {
                  e && this.$emit("blur", e);
                },
                onChipInput: function onChipInput(item) {
                  if (this.multiple)
                    this.selectItem(item);
                  else
                    this.setValue(null);
                  if (this.selectedItems.length === 0) {
                    this.isMenuActive = true;
                  } else {
                    this.isMenuActive = false;
                  }
                  this.selectedIndex = -1;
                },
                onClick: function onClick(e) {
                  if (!this.isInteractive)
                    return;
                  if (!this.isAppendInner(e.target)) {
                    this.isMenuActive = true;
                  }
                  if (!this.isFocused) {
                    this.isFocused = true;
                    this.$emit("focus");
                  }
                  this.$emit("click", e);
                },
                onEscDown: function onEscDown(e) {
                  e.preventDefault();
                  if (this.isMenuActive) {
                    e.stopPropagation();
                    this.isMenuActive = false;
                  }
                },
                onKeyPress: function onKeyPress(e) {
                  var _this2 = this;
                  if (this.multiple || !this.isInteractive || this.disableLookup || e.key.length > 1 || e.ctrlKey || e.metaKey || e.altKey)
                    return;
                  var KEYBOARD_LOOKUP_THRESHOLD = 1e3;
                  var now2 = performance.now();
                  if (now2 - this.keyboardLookupLastTime > KEYBOARD_LOOKUP_THRESHOLD) {
                    this.keyboardLookupPrefix = "";
                  }
                  this.keyboardLookupPrefix += e.key.toLowerCase();
                  this.keyboardLookupLastTime = now2;
                  var index2 = this.allItems.findIndex(function(item2) {
                    var _a2;
                    var text2 = ((_a2 = _this2.getText(item2)) !== null && _a2 !== void 0 ? _a2 : "").toString();
                    return text2.toLowerCase().startsWith(_this2.keyboardLookupPrefix);
                  });
                  var item = this.allItems[index2];
                  if (index2 !== -1) {
                    this.lastItem = Math.max(this.lastItem, index2 + 5);
                    this.setValue(this.returnObject ? item : this.getValue(item));
                    this.$nextTick(function() {
                      return _this2.$refs.menu.getTiles();
                    });
                    setTimeout(function() {
                      return _this2.setMenuIndex(index2);
                    });
                  }
                },
                onKeyDown: function onKeyDown(e) {
                  var _this2 = this;
                  if (this.isReadonly && e.keyCode !== _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].tab)
                    return;
                  var keyCode = e.keyCode;
                  var menu = this.$refs.menu;
                  this.$emit("keydown", e);
                  if (!menu)
                    return;
                  if (this.isMenuActive && [_util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].up, _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].down, _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].home, _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].end, _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].enter].includes(keyCode)) {
                    this.$nextTick(function() {
                      menu.changeListIndex(e);
                      _this2.$emit("update:list-index", menu.listIndex);
                    });
                  }
                  if ([_util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].enter, _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].space].includes(keyCode))
                    this.activateMenu();
                  if (!this.isMenuActive && [_util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].up, _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].down, _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].home, _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].end].includes(keyCode))
                    return this.onUpDown(e);
                  if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].esc)
                    return this.onEscDown(e);
                  if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].tab)
                    return this.onTabDown(e);
                  if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].space)
                    return this.onSpaceDown(e);
                },
                onMenuActiveChange: function onMenuActiveChange(val) {
                  if (this.multiple && !val || this.getMenuIndex() > -1)
                    return;
                  var menu = this.$refs.menu;
                  if (!menu || !this.isDirty)
                    return;
                  this.$refs.menu.getTiles();
                  for (var i2 = 0; i2 < menu.tiles.length; i2++) {
                    if (menu.tiles[i2].getAttribute("aria-selected") === "true") {
                      this.setMenuIndex(i2);
                      break;
                    }
                  }
                },
                onMouseUp: function onMouseUp(e) {
                  var _this2 = this;
                  if (this.hasMouseDown && e.which !== 3 && this.isInteractive) {
                    if (this.isAppendInner(e.target)) {
                      this.$nextTick(function() {
                        return _this2.isMenuActive = !_this2.isMenuActive;
                      });
                    }
                  }
                  _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_6__["default"].options.methods.onMouseUp.call(this, e);
                },
                onScroll: function onScroll() {
                  var _this2 = this;
                  if (!this.isMenuActive) {
                    requestAnimationFrame(function() {
                      var content = _this2.getContent();
                      if (content)
                        content.scrollTop = 0;
                    });
                  } else {
                    if (this.lastItem > this.computedItems.length)
                      return;
                    var showMoreItems = this.getContent().scrollHeight - (this.getContent().scrollTop + this.getContent().clientHeight) < 200;
                    if (showMoreItems) {
                      this.lastItem += 20;
                    }
                  }
                },
                onSpaceDown: function onSpaceDown(e) {
                  e.preventDefault();
                },
                onTabDown: function onTabDown(e) {
                  var menu = this.$refs.menu;
                  if (!menu)
                    return;
                  var activeTile = menu.activeTile;
                  if (!this.multiple && activeTile && this.isMenuActive) {
                    e.preventDefault();
                    e.stopPropagation();
                    activeTile.click();
                  } else {
                    this.blur(e);
                  }
                },
                onUpDown: function onUpDown(e) {
                  var _this2 = this;
                  var menu = this.$refs.menu;
                  if (!menu)
                    return;
                  e.preventDefault();
                  if (this.multiple)
                    return this.activateMenu();
                  var keyCode = e.keyCode;
                  menu.isBooted = true;
                  window.requestAnimationFrame(function() {
                    menu.getTiles();
                    if (!menu.hasClickableTiles)
                      return _this2.activateMenu();
                    switch (keyCode) {
                      case _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].up:
                        menu.prevTile();
                        break;
                      case _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].down:
                        menu.nextTile();
                        break;
                      case _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].home:
                        menu.firstTile();
                        break;
                      case _util_helpers__WEBPACK_IMPORTED_MODULE_12__["keyCodes"].end:
                        menu.lastTile();
                        break;
                    }
                    _this2.selectItem(_this2.allItems[_this2.getMenuIndex()]);
                  });
                },
                selectItem: function selectItem(item) {
                  var _this2 = this;
                  if (!this.multiple) {
                    this.setValue(this.returnObject ? item : this.getValue(item));
                    this.isMenuActive = false;
                  } else {
                    var internalValue = (this.internalValue || []).slice();
                    var i2 = this.findExistingIndex(item);
                    i2 !== -1 ? internalValue.splice(i2, 1) : internalValue.push(item);
                    this.setValue(internalValue.map(function(i3) {
                      return _this2.returnObject ? i3 : _this2.getValue(i3);
                    }));
                    if (this.hideSelected) {
                      this.setMenuIndex(-1);
                    } else {
                      var index_1 = this.computedItems.indexOf(item);
                      if (~index_1) {
                        this.$nextTick(function() {
                          return _this2.$refs.menu.getTiles();
                        });
                        setTimeout(function() {
                          return _this2.setMenuIndex(index_1);
                        });
                      }
                    }
                  }
                },
                setMenuIndex: function setMenuIndex(index2) {
                  this.$refs.menu && (this.$refs.menu.listIndex = index2);
                },
                setSelectedItems: function setSelectedItems() {
                  var e_1, _a2;
                  var _this2 = this;
                  var selectedItems = [];
                  var values2 = !this.multiple || !Array.isArray(this.internalValue) ? [this.internalValue] : this.internalValue;
                  var _loop_1 = function _loop_12(value2) {
                    var index2 = this_1.allItems.findIndex(function(v) {
                      return _this2.valueComparator(_this2.getValue(v), _this2.getValue(value2));
                    });
                    if (index2 > -1) {
                      selectedItems.push(this_1.allItems[index2]);
                    }
                  };
                  var this_1 = this;
                  try {
                    for (var values_12 = __values2(values2), values_1_1 = values_12.next(); !values_1_1.done; values_1_1 = values_12.next()) {
                      var value = values_1_1.value;
                      _loop_1(value);
                    }
                  } catch (e_1_1) {
                    e_1 = {
                      error: e_1_1
                    };
                  } finally {
                    try {
                      if (values_1_1 && !values_1_1.done && (_a2 = values_12.return))
                        _a2.call(values_12);
                    } finally {
                      if (e_1)
                        throw e_1.error;
                    }
                  }
                  this.selectedItems = selectedItems;
                },
                setValue: function setValue(value) {
                  if (!this.valueComparator(value, this.internalValue)) {
                    this.internalValue = value;
                    this.$emit("change", value);
                  }
                },
                isAppendInner: function isAppendInner(target2) {
                  var appendInner = this.$refs["append-inner"];
                  return appendInner && (appendInner === target2 || appendInner.contains(target2));
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VSelect/VSelectList.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VSelect/VSelectList.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VCheckbox_VSimpleCheckbox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../VCheckbox/VSimpleCheckbox */
              "./src/components/VCheckbox/VSimpleCheckbox.ts"
            );
            var _VDivider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VDivider */
              "./src/components/VDivider/index.ts"
            );
            var _VSubheader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VSubheader */
              "./src/components/VSubheader/index.ts"
            );
            var _VList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VList */
              "./src/components/VList/index.ts"
            );
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__["default"]).extend({
              name: "v-select-list",
              // https://github.com/vuejs/vue/issues/6872
              directives: {
                ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_4__["default"]
              },
              props: {
                action: Boolean,
                dense: Boolean,
                hideSelected: Boolean,
                items: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                itemDisabled: {
                  type: [String, Array, Function],
                  default: "disabled"
                },
                itemText: {
                  type: [String, Array, Function],
                  default: "text"
                },
                itemValue: {
                  type: [String, Array, Function],
                  default: "value"
                },
                noDataText: String,
                noFilter: Boolean,
                searchInput: null,
                selectedItems: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                }
              },
              computed: {
                parsedItems: function parsedItems() {
                  var _this2 = this;
                  return this.selectedItems.map(function(item) {
                    return _this2.getValue(item);
                  });
                },
                tileActiveClass: function tileActiveClass() {
                  return Object.keys(this.setTextColor(this.color).class || {}).join(" ");
                },
                staticNoDataTile: function staticNoDataTile() {
                  var tile = {
                    attrs: {
                      role: void 0
                    },
                    on: {
                      mousedown: function mousedown(e) {
                        return e.preventDefault();
                      }
                      // Prevent onBlur from being called
                    }
                  };
                  return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_3__["VListItem"], tile, [this.genTileContent(this.noDataText)]);
                }
              },
              methods: {
                genAction: function genAction(item, inputValue) {
                  var _this2 = this;
                  return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_3__["VListItemAction"], [this.$createElement(_VCheckbox_VSimpleCheckbox__WEBPACK_IMPORTED_MODULE_0__["default"], {
                    props: {
                      color: this.color,
                      value: inputValue,
                      ripple: false
                    },
                    on: {
                      input: function input2() {
                        return _this2.$emit("select", item);
                      }
                    }
                  })]);
                },
                genDivider: function genDivider(props2) {
                  return this.$createElement(_VDivider__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: props2
                  });
                },
                genFilteredText: function genFilteredText(text2) {
                  text2 = text2 || "";
                  if (!this.searchInput || this.noFilter)
                    return text2;
                  var _a2 = this.getMaskedCharacters(text2), start = _a2.start, middle = _a2.middle, end = _a2.end;
                  return [start, this.genHighlight(middle), end];
                },
                genHeader: function genHeader(props2) {
                  return this.$createElement(_VSubheader__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    props: props2
                  }, props2.header);
                },
                genHighlight: function genHighlight(text2) {
                  return this.$createElement("span", {
                    staticClass: "v-list-item__mask"
                  }, text2);
                },
                getMaskedCharacters: function getMaskedCharacters(text2) {
                  var searchInput = (this.searchInput || "").toString().toLocaleLowerCase();
                  var index2 = text2.toLocaleLowerCase().indexOf(searchInput);
                  if (index2 < 0)
                    return {
                      start: text2,
                      middle: "",
                      end: ""
                    };
                  var start = text2.slice(0, index2);
                  var middle = text2.slice(index2, index2 + searchInput.length);
                  var end = text2.slice(index2 + searchInput.length);
                  return {
                    start,
                    middle,
                    end
                  };
                },
                genTile: function genTile(_a2) {
                  var _this2 = this;
                  var item = _a2.item, index2 = _a2.index, _b2 = _a2.disabled, disabled = _b2 === void 0 ? null : _b2, _c = _a2.value, value = _c === void 0 ? false : _c;
                  if (!value)
                    value = this.hasItem(item);
                  if (item === Object(item)) {
                    disabled = disabled !== null ? disabled : this.getDisabled(item);
                  }
                  var tile = {
                    attrs: {
                      // Default behavior in list does not
                      // contain aria-selected by default
                      "aria-selected": String(value),
                      id: "list-item-" + this._uid + "-" + index2,
                      role: "option"
                    },
                    on: {
                      mousedown: function mousedown(e) {
                        e.preventDefault();
                      },
                      click: function click2() {
                        return disabled || _this2.$emit("select", item);
                      }
                    },
                    props: {
                      activeClass: this.tileActiveClass,
                      disabled,
                      ripple: true,
                      inputValue: value
                    }
                  };
                  if (!this.$scopedSlots.item) {
                    return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_3__["VListItem"], tile, [this.action && !this.hideSelected && this.items.length > 0 ? this.genAction(item, value) : null, this.genTileContent(item, index2)]);
                  }
                  var parent2 = this;
                  var scopedSlot = this.$scopedSlots.item({
                    parent: parent2,
                    item,
                    attrs: __assign2(__assign2({}, tile.attrs), tile.props),
                    on: tile.on
                  });
                  return this.needsTile(scopedSlot) ? this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_3__["VListItem"], tile, scopedSlot) : scopedSlot;
                },
                genTileContent: function genTileContent(item, index2) {
                  return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_3__["VListItemContent"], [this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_3__["VListItemTitle"], [this.genFilteredText(this.getText(item))])]);
                },
                hasItem: function hasItem(item) {
                  return this.parsedItems.indexOf(this.getValue(item)) > -1;
                },
                needsTile: function needsTile(slot) {
                  return slot.length !== 1 || slot[0].componentOptions == null || slot[0].componentOptions.Ctor.options.name !== "v-list-item";
                },
                getDisabled: function getDisabled(item) {
                  return Boolean(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getPropertyFromItem"])(item, this.itemDisabled, false));
                },
                getText: function getText2(item) {
                  return String(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getPropertyFromItem"])(item, this.itemText, item));
                },
                getValue: function getValue2(item) {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getPropertyFromItem"])(item, this.itemValue, this.getText(item));
                }
              },
              render: function render8() {
                var children = [];
                var itemsLength = this.items.length;
                for (var index2 = 0; index2 < itemsLength; index2++) {
                  var item = this.items[index2];
                  if (this.hideSelected && this.hasItem(item))
                    continue;
                  if (item == null)
                    children.push(this.genTile({
                      item,
                      index: index2
                    }));
                  else if (item.header)
                    children.push(this.genHeader(item));
                  else if (item.divider)
                    children.push(this.genDivider(item));
                  else
                    children.push(this.genTile({
                      item,
                      index: index2
                    }));
                }
                children.length || children.push(this.$slots["no-data"] || this.staticNoDataTile);
                this.$slots["prepend-item"] && children.unshift(this.$slots["prepend-item"]);
                this.$slots["append-item"] && children.push(this.$slots["append-item"]);
                return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_3__["VList"], {
                  staticClass: "v-select-list",
                  class: this.themeClasses,
                  attrs: {
                    role: "listbox",
                    tabindex: -1
                  },
                  on: {
                    mousedown: function mousedown(e) {
                      e.preventDefault();
                    }
                  },
                  props: {
                    dense: this.dense
                  }
                }, children);
              }
            });
          }
        ),
        /***/
        "./src/components/VSelect/index.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VSelect/index.ts ***!
            \*****************************************/
          /*! exports provided: VSelect, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VSelect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VSelect */
              "./src/components/VSelect/VSelect.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSelect", function() {
              return _VSelect__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VSelect__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VSheet/VSheet.sass": (
          /*!*******************************************!*\
            !*** ./src/components/VSheet/VSheet.sass ***!
            \*******************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VSheet/VSheet.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VSheet/VSheet.ts ***!
            \*****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VSheet.sass */
              "./src/components/VSheet/VSheet.sass"
            );
            var _mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/binds-attrs */
              "./src/mixins/binds-attrs/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_elevatable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/elevatable */
              "./src/mixins/elevatable/index.ts"
            );
            var _mixins_measurable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/measurable */
              "./src/mixins/measurable/index.ts"
            );
            var _mixins_roundable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/roundable */
              "./src/mixins/roundable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_7__["default"])(_mixins_binds_attrs__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_elevatable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_measurable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_roundable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__["default"]).extend({
              name: "v-sheet",
              props: {
                outlined: Boolean,
                shaped: Boolean,
                tag: {
                  type: String,
                  default: "div"
                }
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2(__assign2({
                    "v-sheet": true,
                    "v-sheet--outlined": this.outlined,
                    "v-sheet--shaped": this.shaped
                  }, this.themeClasses), this.elevationClasses), this.roundedClasses);
                },
                styles: function styles() {
                  return this.measurableStyles;
                }
              },
              render: function render8(h) {
                var data = {
                  class: this.classes,
                  style: this.styles,
                  on: this.listeners$
                };
                return h(this.tag, this.setBackgroundColor(this.color, data), this.$slots.default);
              }
            });
          }
        ),
        /***/
        "./src/components/VSheet/index.ts": (
          /*!****************************************!*\
            !*** ./src/components/VSheet/index.ts ***!
            \****************************************/
          /*! exports provided: VSheet, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VSheet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VSheet */
              "./src/components/VSheet/VSheet.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSheet", function() {
              return _VSheet__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VSheet__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VSkeletonLoader/VSkeletonLoader.sass": (
          /*!*************************************************************!*\
            !*** ./src/components/VSkeletonLoader/VSkeletonLoader.sass ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VSkeletonLoader/VSkeletonLoader.ts": (
          /*!***********************************************************!*\
            !*** ./src/components/VSkeletonLoader/VSkeletonLoader.ts ***!
            \***********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VSkeletonLoader.sass */
              "./src/components/VSkeletonLoader/VSkeletonLoader.sass"
            );
            var _mixins_elevatable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/elevatable */
              "./src/mixins/elevatable/index.ts"
            );
            var _mixins_measurable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/measurable */
              "./src/mixins/measurable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_elevatable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_measurable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]).extend({
              name: "VSkeletonLoader",
              props: {
                boilerplate: Boolean,
                loading: Boolean,
                loadingText: {
                  type: String,
                  default: "$vuetify.loading"
                },
                tile: Boolean,
                transition: String,
                type: String,
                types: {
                  type: Object,
                  default: function _default() {
                    return {};
                  }
                }
              },
              computed: {
                attrs: function attrs2() {
                  if (!this.isLoading)
                    return this.$attrs;
                  return __assign2({
                    "aria-busy": !this.boilerplate ? true : void 0,
                    "aria-live": !this.boilerplate ? "polite" : void 0,
                    "aria-label": !this.boilerplate ? this.$vuetify.lang.t(this.loadingText) : void 0,
                    role: !this.boilerplate ? "alert" : void 0
                  }, this.$attrs);
                },
                classes: function classes() {
                  return __assign2(__assign2({
                    "v-skeleton-loader--boilerplate": this.boilerplate,
                    "v-skeleton-loader--is-loading": this.isLoading,
                    "v-skeleton-loader--tile": this.tile
                  }, this.themeClasses), this.elevationClasses);
                },
                isLoading: function isLoading() {
                  return !("default" in this.$scopedSlots) || this.loading;
                },
                rootTypes: function rootTypes() {
                  return __assign2({
                    actions: "button@2",
                    article: "heading, paragraph",
                    avatar: "avatar",
                    button: "button",
                    card: "image, card-heading",
                    "card-avatar": "image, list-item-avatar",
                    "card-heading": "heading",
                    chip: "chip",
                    "date-picker": "list-item, card-heading, divider, date-picker-options, date-picker-days, actions",
                    "date-picker-options": "text, avatar@2",
                    "date-picker-days": "avatar@28",
                    heading: "heading",
                    image: "image",
                    "list-item": "text",
                    "list-item-avatar": "avatar, text",
                    "list-item-two-line": "sentences",
                    "list-item-avatar-two-line": "avatar, sentences",
                    "list-item-three-line": "paragraph",
                    "list-item-avatar-three-line": "avatar, paragraph",
                    paragraph: "text@3",
                    sentences: "text@2",
                    table: "table-heading, table-thead, table-tbody, table-tfoot",
                    "table-heading": "heading, text",
                    "table-thead": "heading@6",
                    "table-tbody": "table-row-divider@6",
                    "table-row-divider": "table-row, divider",
                    "table-row": "table-cell@6",
                    "table-cell": "text",
                    "table-tfoot": "text@2, avatar@2",
                    text: "text"
                  }, this.types);
                }
              },
              methods: {
                genBone: function genBone(text2, children) {
                  return this.$createElement("div", {
                    staticClass: "v-skeleton-loader__" + text2 + " v-skeleton-loader__bone"
                  }, children);
                },
                genBones: function genBones(bone) {
                  var _this2 = this;
                  var _a2 = __read2(bone.split("@"), 2), type = _a2[0], length = _a2[1];
                  var generator = function generator2() {
                    return _this2.genStructure(type);
                  };
                  return Array.from({
                    length
                  }).map(generator);
                },
                // Fix type when this is merged
                // https://github.com/microsoft/TypeScript/pull/33050
                genStructure: function genStructure(type) {
                  var children = [];
                  type = type || this.type || "";
                  var bone = this.rootTypes[type] || "";
                  if (type === bone)
                    ;
                  else if (type.indexOf(",") > -1)
                    return this.mapBones(type);
                  else if (type.indexOf("@") > -1)
                    return this.genBones(type);
                  else if (bone.indexOf(",") > -1)
                    children = this.mapBones(bone);
                  else if (bone.indexOf("@") > -1)
                    children = this.genBones(bone);
                  else if (bone)
                    children.push(this.genStructure(bone));
                  return [this.genBone(type, children)];
                },
                genSkeleton: function genSkeleton() {
                  var children = [];
                  if (!this.isLoading)
                    children.push(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this));
                  else
                    children.push(this.genStructure());
                  if (!this.transition)
                    return children;
                  return this.$createElement("transition", {
                    props: {
                      name: this.transition
                    },
                    // Only show transition when
                    // content has been loaded
                    on: {
                      afterEnter: this.resetStyles,
                      beforeEnter: this.onBeforeEnter,
                      beforeLeave: this.onBeforeLeave,
                      leaveCancelled: this.resetStyles
                    }
                  }, children);
                },
                mapBones: function mapBones(bones) {
                  return bones.replace(/\s/g, "").split(",").map(this.genStructure);
                },
                onBeforeEnter: function onBeforeEnter(el) {
                  this.resetStyles(el);
                  if (!this.isLoading)
                    return;
                  el._initialStyle = {
                    display: el.style.display,
                    transition: el.style.transition
                  };
                  el.style.setProperty("transition", "none", "important");
                },
                onBeforeLeave: function onBeforeLeave(el) {
                  el.style.setProperty("display", "none", "important");
                },
                resetStyles: function resetStyles(el) {
                  if (!el._initialStyle)
                    return;
                  el.style.display = el._initialStyle.display || "";
                  el.style.transition = el._initialStyle.transition;
                  delete el._initialStyle;
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-skeleton-loader",
                  attrs: this.attrs,
                  on: this.$listeners,
                  class: this.classes,
                  style: this.isLoading ? this.measurableStyles : void 0
                }, [this.genSkeleton()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VSkeletonLoader/index.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VSkeletonLoader/index.ts ***!
            \*************************************************/
          /*! exports provided: VSkeletonLoader, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VSkeletonLoader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VSkeletonLoader */
              "./src/components/VSkeletonLoader/VSkeletonLoader.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSkeletonLoader", function() {
              return _VSkeletonLoader__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VSkeletonLoader__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VSlideGroup/VSlideGroup.sass": (
          /*!*****************************************************!*\
            !*** ./src/components/VSlideGroup/VSlideGroup.sass ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VSlideGroup/VSlideGroup.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VSlideGroup/VSlideGroup.ts ***!
            \***************************************************/
          /*! exports provided: calculateUpdatedOffset, calculateCenteredOffset, BaseSlideGroup, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "calculateUpdatedOffset", function() {
              return calculateUpdatedOffset;
            });
            __webpack_require__.d(__webpack_exports__, "calculateCenteredOffset", function() {
              return calculateCenteredOffset;
            });
            __webpack_require__.d(__webpack_exports__, "BaseSlideGroup", function() {
              return BaseSlideGroup;
            });
            __webpack_require__(
              /*! ./VSlideGroup.sass */
              "./src/components/VSlideGroup/VSlideGroup.sass"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _transitions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../transitions */
              "./src/components/transitions/index.ts"
            );
            var _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VItemGroup/VItemGroup */
              "./src/components/VItemGroup/VItemGroup.ts"
            );
            var _mixins_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/mobile */
              "./src/mixins/mobile/index.ts"
            );
            var _directives_resize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../directives/resize */
              "./src/directives/resize/index.ts"
            );
            var _directives_touch__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../directives/touch */
              "./src/directives/touch/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __values2 = function(o) {
              var s2 = typeof Symbol === "function" && Symbol.iterator, m = s2 && o[s2], i2 = 0;
              if (m)
                return m.call(o);
              if (o && typeof o.length === "number")
                return {
                  next: function next() {
                    if (o && i2 >= o.length)
                      o = void 0;
                    return {
                      value: o && o[i2++],
                      done: !o
                    };
                  }
                };
              throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            function bias(val) {
              var c = 0.501;
              var x2 = Math.abs(val);
              return Math.sign(val) * (x2 / ((1 / c - 2) * (1 - x2) + 1));
            }
            function calculateUpdatedOffset(selectedElement, widths, rtl, currentScrollOffset) {
              var clientWidth = selectedElement.clientWidth;
              var offsetLeft = rtl ? widths.content - selectedElement.offsetLeft - clientWidth : selectedElement.offsetLeft;
              if (rtl) {
                currentScrollOffset = -currentScrollOffset;
              }
              var totalWidth = widths.wrapper + currentScrollOffset;
              var itemOffset = clientWidth + offsetLeft;
              var additionalOffset = clientWidth * 0.4;
              if (offsetLeft <= currentScrollOffset) {
                currentScrollOffset = Math.max(offsetLeft - additionalOffset, 0);
              } else if (totalWidth <= itemOffset) {
                currentScrollOffset = Math.min(currentScrollOffset - (totalWidth - itemOffset - additionalOffset), widths.content - widths.wrapper);
              }
              return rtl ? -currentScrollOffset : currentScrollOffset;
            }
            function calculateCenteredOffset(selectedElement, widths, rtl) {
              var offsetLeft = selectedElement.offsetLeft, clientWidth = selectedElement.clientWidth;
              if (rtl) {
                var offsetCentered = widths.content - offsetLeft - clientWidth / 2 - widths.wrapper / 2;
                return -Math.min(widths.content - widths.wrapper, Math.max(0, offsetCentered));
              } else {
                var offsetCentered = offsetLeft + clientWidth / 2 - widths.wrapper / 2;
                return Math.min(widths.content - widths.wrapper, Math.max(0, offsetCentered));
              }
            }
            var BaseSlideGroup = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_7__["default"])(_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_3__["BaseItemGroup"], _mixins_mobile__WEBPACK_IMPORTED_MODULE_4__["default"]).extend({
              name: "base-slide-group",
              directives: {
                Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_5__["default"],
                Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_6__["default"]
              },
              props: {
                activeClass: {
                  type: String,
                  default: "v-slide-item--active"
                },
                centerActive: Boolean,
                nextIcon: {
                  type: String,
                  default: "$next"
                },
                prevIcon: {
                  type: String,
                  default: "$prev"
                },
                showArrows: {
                  type: [Boolean, String],
                  validator: function validator2(v) {
                    return typeof v === "boolean" || ["always", "never", "desktop", "mobile"].includes(v);
                  }
                }
              },
              data: function data() {
                return {
                  isOverflowing: false,
                  resizeTimeout: 0,
                  startX: 0,
                  isSwipingHorizontal: false,
                  isSwiping: false,
                  scrollOffset: 0,
                  widths: {
                    content: 0,
                    wrapper: 0
                  }
                };
              },
              computed: {
                canTouch: function canTouch() {
                  return typeof window !== "undefined";
                },
                __cachedNext: function __cachedNext() {
                  return this.genTransition("next");
                },
                __cachedPrev: function __cachedPrev() {
                  return this.genTransition("prev");
                },
                classes: function classes() {
                  return __assign2(__assign2({}, _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_3__["BaseItemGroup"].options.computed.classes.call(this)), {
                    "v-slide-group": true,
                    "v-slide-group--has-affixes": this.hasAffixes,
                    "v-slide-group--is-overflowing": this.isOverflowing
                  });
                },
                hasAffixes: function hasAffixes() {
                  switch (this.showArrows) {
                    case "always":
                      return true;
                    case "desktop":
                      return !this.isMobile;
                    case true:
                      return this.isOverflowing || Math.abs(this.scrollOffset) > 0;
                    case "mobile":
                      return this.isMobile || this.isOverflowing || Math.abs(this.scrollOffset) > 0;
                    case "never":
                      return false;
                    default:
                      return !this.isMobile && (this.isOverflowing || Math.abs(this.scrollOffset) > 0);
                  }
                },
                hasNext: function hasNext() {
                  if (!this.hasAffixes)
                    return false;
                  var _a2 = this.widths, content = _a2.content, wrapper = _a2.wrapper;
                  return content > Math.abs(this.scrollOffset) + wrapper;
                },
                hasPrev: function hasPrev() {
                  return this.hasAffixes && this.scrollOffset !== 0;
                }
              },
              watch: {
                internalValue: "setWidths",
                // When overflow changes, the arrows alter
                // the widths of the content and wrapper
                // and need to be recalculated
                isOverflowing: "setWidths",
                scrollOffset: function scrollOffset(val) {
                  if (this.$vuetify.rtl)
                    val = -val;
                  var scroll = val <= 0 ? bias(-val) : val > this.widths.content - this.widths.wrapper ? -(this.widths.content - this.widths.wrapper) + bias(this.widths.content - this.widths.wrapper - val) : -val;
                  if (this.$vuetify.rtl)
                    scroll = -scroll;
                  this.$refs.content.style.transform = "translateX(" + scroll + "px)";
                }
              },
              mounted: function mounted3() {
                var _this2 = this;
                if (typeof ResizeObserver !== "undefined") {
                  var obs_1 = new ResizeObserver(function() {
                    _this2.onResize();
                  });
                  obs_1.observe(this.$el);
                  obs_1.observe(this.$refs.content);
                  this.$on("hook:destroyed", function() {
                    obs_1.disconnect();
                  });
                } else {
                  var itemsLength_1 = 0;
                  this.$on("hook:beforeUpdate", function() {
                    var _a2;
                    itemsLength_1 = (((_a2 = _this2.$refs.content) === null || _a2 === void 0 ? void 0 : _a2.children) || []).length;
                  });
                  this.$on("hook:updated", function() {
                    var _a2;
                    if (itemsLength_1 === (((_a2 = _this2.$refs.content) === null || _a2 === void 0 ? void 0 : _a2.children) || []).length)
                      return;
                    _this2.setWidths();
                  });
                }
              },
              methods: {
                onScroll: function onScroll() {
                  this.$refs.wrapper.scrollLeft = 0;
                },
                onFocusin: function onFocusin(e) {
                  var e_1, _a2, e_2, _b2;
                  if (!this.isOverflowing)
                    return;
                  try {
                    for (var _c = __values2(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["composedPath"])(e)), _d2 = _c.next(); !_d2.done; _d2 = _c.next()) {
                      var el = _d2.value;
                      try {
                        for (var _e = (e_2 = void 0, __values2(this.items)), _f = _e.next(); !_f.done; _f = _e.next()) {
                          var vm = _f.value;
                          if (vm.$el === el) {
                            this.scrollOffset = calculateUpdatedOffset(vm.$el, this.widths, this.$vuetify.rtl, this.scrollOffset);
                            return;
                          }
                        }
                      } catch (e_2_1) {
                        e_2 = {
                          error: e_2_1
                        };
                      } finally {
                        try {
                          if (_f && !_f.done && (_b2 = _e.return))
                            _b2.call(_e);
                        } finally {
                          if (e_2)
                            throw e_2.error;
                        }
                      }
                    }
                  } catch (e_1_1) {
                    e_1 = {
                      error: e_1_1
                    };
                  } finally {
                    try {
                      if (_d2 && !_d2.done && (_a2 = _c.return))
                        _a2.call(_c);
                    } finally {
                      if (e_1)
                        throw e_1.error;
                    }
                  }
                },
                // Always generate next for scrollable hint
                genNext: function genNext() {
                  var _this2 = this;
                  var slot = this.$scopedSlots.next ? this.$scopedSlots.next({}) : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getSlot"])(this, "next") || this.__cachedNext;
                  return this.$createElement("div", {
                    staticClass: "v-slide-group__next",
                    class: {
                      "v-slide-group__next--disabled": !this.hasNext
                    },
                    on: {
                      click: function click2() {
                        return _this2.onAffixClick("next");
                      }
                    },
                    key: "next"
                  }, [slot]);
                },
                genContent: function genContent() {
                  return this.$createElement("div", {
                    staticClass: "v-slide-group__content",
                    ref: "content",
                    on: {
                      focusin: this.onFocusin
                    }
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getSlot"])(this));
                },
                genData: function genData() {
                  return {
                    class: this.classes,
                    directives: [{
                      name: "resize",
                      value: this.onResize
                    }]
                  };
                },
                genIcon: function genIcon(location2) {
                  var icon = location2;
                  if (this.$vuetify.rtl && location2 === "prev") {
                    icon = "next";
                  } else if (this.$vuetify.rtl && location2 === "next") {
                    icon = "prev";
                  }
                  var upperLocation = "" + location2[0].toUpperCase() + location2.slice(1);
                  var hasAffix = this["has" + upperLocation];
                  if (!this.showArrows && !hasAffix)
                    return null;
                  return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: {
                      disabled: !hasAffix
                    }
                  }, this[icon + "Icon"]);
                },
                // Always generate prev for scrollable hint
                genPrev: function genPrev() {
                  var _this2 = this;
                  var slot = this.$scopedSlots.prev ? this.$scopedSlots.prev({}) : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getSlot"])(this, "prev") || this.__cachedPrev;
                  return this.$createElement("div", {
                    staticClass: "v-slide-group__prev",
                    class: {
                      "v-slide-group__prev--disabled": !this.hasPrev
                    },
                    on: {
                      click: function click2() {
                        return _this2.onAffixClick("prev");
                      }
                    },
                    key: "prev"
                  }, [slot]);
                },
                genTransition: function genTransition(location2) {
                  return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_2__["VFadeTransition"], [this.genIcon(location2)]);
                },
                genWrapper: function genWrapper() {
                  var _this2 = this;
                  return this.$createElement("div", {
                    staticClass: "v-slide-group__wrapper",
                    directives: [{
                      name: "touch",
                      value: {
                        start: function start(e) {
                          return _this2.overflowCheck(e, _this2.onTouchStart);
                        },
                        move: function move(e) {
                          return _this2.overflowCheck(e, _this2.onTouchMove);
                        },
                        end: function end(e) {
                          return _this2.overflowCheck(e, _this2.onTouchEnd);
                        }
                      }
                    }],
                    ref: "wrapper",
                    on: {
                      scroll: this.onScroll
                    }
                  }, [this.genContent()]);
                },
                calculateNewOffset: function calculateNewOffset(direction, widths, rtl, currentScrollOffset) {
                  var sign = rtl ? -1 : 1;
                  var newAbosluteOffset = sign * currentScrollOffset + (direction === "prev" ? -1 : 1) * widths.wrapper;
                  return sign * Math.max(Math.min(newAbosluteOffset, widths.content - widths.wrapper), 0);
                },
                onAffixClick: function onAffixClick(location2) {
                  this.$emit("click:" + location2);
                  this.scrollTo(location2);
                },
                onResize: function onResize() {
                  if (this._isDestroyed)
                    return;
                  this.setWidths();
                },
                onTouchStart: function onTouchStart(e) {
                  var content = this.$refs.content;
                  this.startX = this.scrollOffset + e.touchstartX;
                  content.style.setProperty("transition", "none");
                  content.style.setProperty("willChange", "transform");
                },
                onTouchMove: function onTouchMove(e) {
                  if (!this.canTouch)
                    return;
                  if (!this.isSwiping) {
                    var diffX = e.touchmoveX - e.touchstartX;
                    var diffY = e.touchmoveY - e.touchstartY;
                    this.isSwipingHorizontal = Math.abs(diffX) > Math.abs(diffY);
                    this.isSwiping = true;
                  }
                  if (this.isSwipingHorizontal) {
                    this.scrollOffset = this.startX - e.touchmoveX;
                    document.documentElement.style.overflowY = "hidden";
                  }
                },
                onTouchEnd: function onTouchEnd() {
                  if (!this.canTouch)
                    return;
                  var _a2 = this.$refs, content = _a2.content, wrapper = _a2.wrapper;
                  var maxScrollOffset = content.clientWidth - wrapper.clientWidth;
                  content.style.setProperty("transition", null);
                  content.style.setProperty("willChange", null);
                  if (this.$vuetify.rtl) {
                    if (this.scrollOffset > 0 || !this.isOverflowing) {
                      this.scrollOffset = 0;
                    } else if (this.scrollOffset <= -maxScrollOffset) {
                      this.scrollOffset = -maxScrollOffset;
                    }
                  } else {
                    if (this.scrollOffset < 0 || !this.isOverflowing) {
                      this.scrollOffset = 0;
                    } else if (this.scrollOffset >= maxScrollOffset) {
                      this.scrollOffset = maxScrollOffset;
                    }
                  }
                  this.isSwiping = false;
                  document.documentElement.style.removeProperty("overflow-y");
                },
                overflowCheck: function overflowCheck(e, fn) {
                  e.stopPropagation();
                  this.isOverflowing && fn(e);
                },
                scrollIntoView: function scrollIntoView() {
                  if (!this.selectedItem && this.items.length) {
                    var lastItemPosition = this.items[this.items.length - 1].$el.getBoundingClientRect();
                    var wrapperPosition = this.$refs.wrapper.getBoundingClientRect();
                    if (this.$vuetify.rtl && wrapperPosition.right < lastItemPosition.right || !this.$vuetify.rtl && wrapperPosition.left > lastItemPosition.left) {
                      this.scrollTo("prev");
                    }
                  }
                  if (!this.selectedItem) {
                    return;
                  }
                  if (this.selectedIndex === 0 || !this.centerActive && !this.isOverflowing) {
                    this.scrollOffset = 0;
                  } else if (this.centerActive) {
                    this.scrollOffset = calculateCenteredOffset(this.selectedItem.$el, this.widths, this.$vuetify.rtl);
                  } else if (this.isOverflowing) {
                    this.scrollOffset = calculateUpdatedOffset(this.selectedItem.$el, this.widths, this.$vuetify.rtl, this.scrollOffset);
                  }
                },
                scrollTo: function scrollTo(location2) {
                  this.scrollOffset = this.calculateNewOffset(location2, {
                    // Force reflow
                    content: this.$refs.content ? this.$refs.content.clientWidth : 0,
                    wrapper: this.$refs.wrapper ? this.$refs.wrapper.clientWidth : 0
                  }, this.$vuetify.rtl, this.scrollOffset);
                },
                setWidths: function setWidths() {
                  var _this2 = this;
                  window.requestAnimationFrame(function() {
                    if (_this2._isDestroyed)
                      return;
                    var _a2 = _this2.$refs, content = _a2.content, wrapper = _a2.wrapper;
                    _this2.widths = {
                      content: content ? content.clientWidth : 0,
                      wrapper: wrapper ? wrapper.clientWidth : 0
                    };
                    _this2.isOverflowing = _this2.widths.wrapper + 1 < _this2.widths.content;
                    _this2.scrollIntoView();
                  });
                }
              },
              render: function render8(h) {
                return h("div", this.genData(), [this.genPrev(), this.genWrapper(), this.genNext()]);
              }
            });
            __webpack_exports__["default"] = BaseSlideGroup.extend({
              name: "v-slide-group",
              provide: function provide() {
                return {
                  slideGroup: this
                };
              }
            });
          }
        ),
        /***/
        "./src/components/VSlideGroup/VSlideItem.ts": (
          /*!**************************************************!*\
            !*** ./src/components/VSlideGroup/VSlideItem.ts ***!
            \**************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VItemGroup_VItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../VItemGroup/VItem */
              "./src/components/VItemGroup/VItem.ts"
            );
            var _mixins_groupable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/groupable */
              "./src/mixins/groupable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(
              _VItemGroup_VItem__WEBPACK_IMPORTED_MODULE_0__["BaseItem"],
              Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_1__["factory"])("slideGroup")
              /* @vue/component */
            ).extend({
              name: "v-slide-item"
            });
          }
        ),
        /***/
        "./src/components/VSlideGroup/index.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VSlideGroup/index.ts ***!
            \*********************************************/
          /*! exports provided: VSlideGroup, VSlideItem, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VSlideGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VSlideGroup */
              "./src/components/VSlideGroup/VSlideGroup.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSlideGroup", function() {
              return _VSlideGroup__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VSlideItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VSlideItem */
              "./src/components/VSlideGroup/VSlideItem.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSlideItem", function() {
              return _VSlideItem__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VSlideGroup: _VSlideGroup__WEBPACK_IMPORTED_MODULE_0__["default"],
                VSlideItem: _VSlideItem__WEBPACK_IMPORTED_MODULE_1__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VSlider/VSlider.sass": (
          /*!*********************************************!*\
            !*** ./src/components/VSlider/VSlider.sass ***!
            \*********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VSlider/VSlider.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VSlider/VSlider.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VSlider.sass */
              "./src/components/VSlider/VSlider.sass"
            );
            var _VInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VInput */
              "./src/components/VInput/index.ts"
            );
            var _transitions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../transitions */
              "./src/components/transitions/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _mixins_loadable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/loadable */
              "./src/mixins/loadable/index.ts"
            );
            var _directives_click_outside__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../directives/click-outside */
              "./src/directives/click-outside/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(
              _VInput__WEBPACK_IMPORTED_MODULE_1__["default"],
              _mixins_loadable__WEBPACK_IMPORTED_MODULE_4__["default"]
              /* @vue/component */
            ).extend({
              name: "v-slider",
              directives: {
                ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_5__["default"]
              },
              mixins: [_mixins_loadable__WEBPACK_IMPORTED_MODULE_4__["default"]],
              props: {
                disabled: Boolean,
                inverseLabel: Boolean,
                max: {
                  type: [Number, String],
                  default: 100
                },
                min: {
                  type: [Number, String],
                  default: 0
                },
                step: {
                  type: [Number, String],
                  default: 1
                },
                thumbColor: String,
                thumbLabel: {
                  type: [Boolean, String],
                  default: void 0,
                  validator: function validator2(v) {
                    return typeof v === "boolean" || v === "always";
                  }
                },
                thumbSize: {
                  type: [Number, String],
                  default: 32
                },
                tickLabels: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                ticks: {
                  type: [Boolean, String],
                  default: false,
                  validator: function validator2(v) {
                    return typeof v === "boolean" || v === "always";
                  }
                },
                tickSize: {
                  type: [Number, String],
                  default: 2
                },
                trackColor: String,
                trackFillColor: String,
                value: [Number, String],
                vertical: Boolean
              },
              data: function data() {
                return {
                  app: null,
                  oldValue: null,
                  thumbPressed: false,
                  mouseTimeout: -1,
                  isFocused: false,
                  isActive: false,
                  noClick: false,
                  startOffset: 0
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-input__slider": true,
                    "v-input__slider--vertical": this.vertical,
                    "v-input__slider--inverse-label": this.inverseLabel
                  });
                },
                internalValue: {
                  get: function get5() {
                    return this.lazyValue;
                  },
                  set: function set2(val) {
                    val = isNaN(val) ? this.minValue : val;
                    var value = this.roundValue(Math.min(Math.max(val, this.minValue), this.maxValue));
                    if (value === this.lazyValue)
                      return;
                    this.lazyValue = value;
                    this.$emit("input", value);
                  }
                },
                trackTransition: function trackTransition() {
                  return this.thumbPressed ? this.showTicks || this.stepNumeric ? "0.1s cubic-bezier(0.25, 0.8, 0.5, 1)" : "none" : "";
                },
                minValue: function minValue() {
                  return parseFloat(this.min);
                },
                maxValue: function maxValue() {
                  return parseFloat(this.max);
                },
                stepNumeric: function stepNumeric() {
                  return this.step > 0 ? parseFloat(this.step) : 0;
                },
                inputWidth: function inputWidth() {
                  var inputWidth2 = (this.roundValue(this.internalValue) - this.minValue) / (this.maxValue - this.minValue) * 100;
                  return isNaN(inputWidth2) ? 0 : inputWidth2;
                },
                trackFillStyles: function trackFillStyles() {
                  var _a2;
                  var startDir = this.vertical ? "bottom" : "left";
                  var endDir = this.vertical ? "top" : "right";
                  var valueDir = this.vertical ? "height" : "width";
                  var start = this.$vuetify.rtl ? "auto" : "0";
                  var end = this.$vuetify.rtl ? "0" : "auto";
                  var value = this.isDisabled ? "calc(" + this.inputWidth + "% - 10px)" : this.inputWidth + "%";
                  return _a2 = {
                    transition: this.trackTransition
                  }, _a2[startDir] = start, _a2[endDir] = end, _a2[valueDir] = value, _a2;
                },
                trackStyles: function trackStyles() {
                  var _a2;
                  var startDir = this.vertical ? this.$vuetify.rtl ? "bottom" : "top" : this.$vuetify.rtl ? "left" : "right";
                  var endDir = this.vertical ? "height" : "width";
                  var start = "0px";
                  var end = this.isDisabled ? "calc(" + (100 - this.inputWidth) + "% - 10px)" : "calc(" + (100 - this.inputWidth) + "%)";
                  return _a2 = {
                    transition: this.trackTransition
                  }, _a2[startDir] = start, _a2[endDir] = end, _a2;
                },
                showTicks: function showTicks() {
                  return this.tickLabels.length > 0 || !!(!this.isDisabled && this.stepNumeric && this.ticks);
                },
                numTicks: function numTicks() {
                  return Math.ceil((this.maxValue - this.minValue) / this.stepNumeric);
                },
                showThumbLabel: function showThumbLabel() {
                  return !this.isDisabled && !!(this.thumbLabel || this.$scopedSlots["thumb-label"]);
                },
                computedTrackColor: function computedTrackColor() {
                  if (this.isDisabled)
                    return void 0;
                  if (this.trackColor)
                    return this.trackColor;
                  if (this.isDark)
                    return this.validationState;
                  return this.validationState || "primary lighten-3";
                },
                computedTrackFillColor: function computedTrackFillColor() {
                  if (this.isDisabled)
                    return void 0;
                  if (this.trackFillColor)
                    return this.trackFillColor;
                  return this.validationState || this.computedColor;
                },
                computedThumbColor: function computedThumbColor() {
                  if (this.thumbColor)
                    return this.thumbColor;
                  return this.validationState || this.computedColor;
                }
              },
              watch: {
                min: function min2(val) {
                  var parsed = parseFloat(val);
                  parsed > this.internalValue && this.$emit("input", parsed);
                },
                max: function max2(val) {
                  var parsed = parseFloat(val);
                  parsed < this.internalValue && this.$emit("input", parsed);
                },
                value: {
                  handler: function handler(v) {
                    this.internalValue = v;
                  },
                  immediate: true
                }
              },
              mounted: function mounted3() {
                this.app = document.querySelector("[data-app]") || Object(_util_console__WEBPACK_IMPORTED_MODULE_7__["consoleWarn"])("Missing v-app or a non-body wrapping element with the [data-app] attribute", this);
              },
              methods: {
                genDefaultSlot: function genDefaultSlot() {
                  var children = [this.genLabel()];
                  var slider = this.genSlider();
                  this.inverseLabel ? children.unshift(slider) : children.push(slider);
                  children.push(this.genProgress());
                  return children;
                },
                genSlider: function genSlider() {
                  return this.$createElement("div", {
                    class: __assign2({
                      "v-slider": true,
                      "v-slider--horizontal": !this.vertical,
                      "v-slider--vertical": this.vertical,
                      "v-slider--focused": this.isFocused,
                      "v-slider--active": this.isActive,
                      "v-slider--disabled": this.isDisabled,
                      "v-slider--readonly": this.isReadonly
                    }, this.themeClasses),
                    directives: [{
                      name: "click-outside",
                      value: this.onBlur
                    }],
                    on: {
                      click: this.onSliderClick,
                      mousedown: this.onSliderMouseDown,
                      touchstart: this.onSliderMouseDown
                    }
                  }, this.genChildren());
                },
                genChildren: function genChildren() {
                  return [this.genInput(), this.genTrackContainer(), this.genSteps(), this.genThumbContainer(this.internalValue, this.inputWidth, this.isActive, this.isFocused, this.onFocus, this.onBlur)];
                },
                genInput: function genInput() {
                  return this.$createElement("input", {
                    attrs: __assign2({
                      value: this.internalValue,
                      id: this.computedId,
                      disabled: true,
                      readonly: true,
                      tabindex: -1
                    }, this.$attrs)
                    // on: this.genListeners(), // TODO: do we need to attach the listeners to input?
                  });
                },
                genTrackContainer: function genTrackContainer() {
                  var children = [this.$createElement("div", this.setBackgroundColor(this.computedTrackColor, {
                    staticClass: "v-slider__track-background",
                    style: this.trackStyles
                  })), this.$createElement("div", this.setBackgroundColor(this.computedTrackFillColor, {
                    staticClass: "v-slider__track-fill",
                    style: this.trackFillStyles
                  }))];
                  return this.$createElement("div", {
                    staticClass: "v-slider__track-container",
                    ref: "track"
                  }, children);
                },
                genSteps: function genSteps() {
                  var _this2 = this;
                  if (!this.step || !this.showTicks)
                    return null;
                  var tickSize = parseFloat(this.tickSize);
                  var range = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["createRange"])(this.numTicks + 1);
                  var direction = this.vertical ? "bottom" : this.$vuetify.rtl ? "right" : "left";
                  var offsetDirection = this.vertical ? this.$vuetify.rtl ? "left" : "right" : "top";
                  if (this.vertical)
                    range.reverse();
                  var ticks = range.map(function(index2) {
                    var _a2;
                    var children = [];
                    if (_this2.tickLabels[index2]) {
                      children.push(_this2.$createElement("div", {
                        staticClass: "v-slider__tick-label"
                      }, _this2.tickLabels[index2]));
                    }
                    var width = index2 * (100 / _this2.numTicks);
                    var filled = _this2.$vuetify.rtl ? 100 - _this2.inputWidth < width : width < _this2.inputWidth;
                    return _this2.$createElement("span", {
                      key: index2,
                      staticClass: "v-slider__tick",
                      class: {
                        "v-slider__tick--filled": filled
                      },
                      style: (_a2 = {
                        width: tickSize + "px",
                        height: tickSize + "px"
                      }, _a2[direction] = "calc(" + width + "% - " + tickSize / 2 + "px)", _a2[offsetDirection] = "calc(50% - " + tickSize / 2 + "px)", _a2)
                    }, children);
                  });
                  return this.$createElement("div", {
                    staticClass: "v-slider__ticks-container",
                    class: {
                      "v-slider__ticks-container--always-show": this.ticks === "always" || this.tickLabels.length > 0
                    }
                  }, ticks);
                },
                genThumbContainer: function genThumbContainer(value, valueWidth, isActive, isFocused, onFocus, onBlur, ref2) {
                  if (ref2 === void 0) {
                    ref2 = "thumb";
                  }
                  var children = [this.genThumb()];
                  var thumbLabelContent = this.genThumbLabelContent(value);
                  this.showThumbLabel && children.push(this.genThumbLabel(thumbLabelContent));
                  return this.$createElement("div", this.setTextColor(this.computedThumbColor, {
                    ref: ref2,
                    key: ref2,
                    staticClass: "v-slider__thumb-container",
                    class: {
                      "v-slider__thumb-container--active": isActive,
                      "v-slider__thumb-container--focused": isFocused,
                      "v-slider__thumb-container--show-label": this.showThumbLabel
                    },
                    style: this.getThumbContainerStyles(valueWidth),
                    attrs: {
                      role: "slider",
                      tabindex: this.isDisabled ? -1 : this.$attrs.tabindex ? this.$attrs.tabindex : 0,
                      "aria-label": this.$attrs["aria-label"] || this.label,
                      "aria-valuemin": this.min,
                      "aria-valuemax": this.max,
                      "aria-valuenow": this.internalValue,
                      "aria-readonly": String(this.isReadonly),
                      "aria-orientation": this.vertical ? "vertical" : "horizontal"
                    },
                    on: {
                      focus: onFocus,
                      blur: onBlur,
                      keydown: this.onKeyDown
                    }
                  }), children);
                },
                genThumbLabelContent: function genThumbLabelContent(value) {
                  return this.$scopedSlots["thumb-label"] ? this.$scopedSlots["thumb-label"]({
                    value
                  }) : [this.$createElement("span", [String(value)])];
                },
                genThumbLabel: function genThumbLabel(content) {
                  var size = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["convertToUnit"])(this.thumbSize);
                  var transform = this.vertical ? "translateY(20%) translateY(" + (Number(this.thumbSize) / 3 - 1) + "px) translateX(55%) rotate(135deg)" : "translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg)";
                  return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_2__["VScaleTransition"], {
                    props: {
                      origin: "bottom center"
                    }
                  }, [this.$createElement("div", {
                    staticClass: "v-slider__thumb-label-container",
                    directives: [{
                      name: "show",
                      value: this.isFocused || this.isActive || this.thumbLabel === "always"
                    }]
                  }, [this.$createElement("div", this.setBackgroundColor(this.computedThumbColor, {
                    staticClass: "v-slider__thumb-label",
                    style: {
                      height: size,
                      width: size,
                      transform
                    }
                  }), [this.$createElement("div", content)])])]);
                },
                genThumb: function genThumb() {
                  return this.$createElement("div", this.setBackgroundColor(this.computedThumbColor, {
                    staticClass: "v-slider__thumb"
                  }));
                },
                getThumbContainerStyles: function getThumbContainerStyles(width) {
                  var _a2;
                  var direction = this.vertical ? "top" : "left";
                  var value = this.$vuetify.rtl ? 100 - width : width;
                  value = this.vertical ? 100 - value : value;
                  return _a2 = {
                    transition: this.trackTransition
                  }, _a2[direction] = value + "%", _a2;
                },
                onSliderMouseDown: function onSliderMouseDown(e) {
                  var _this2 = this;
                  var _a2;
                  e.preventDefault();
                  this.oldValue = this.internalValue;
                  this.isActive = true;
                  if ((_a2 = e.target) === null || _a2 === void 0 ? void 0 : _a2.matches(".v-slider__thumb-container, .v-slider__thumb-container *")) {
                    this.thumbPressed = true;
                    var domRect = e.target.getBoundingClientRect();
                    var touch = "touches" in e ? e.touches[0] : e;
                    this.startOffset = this.vertical ? touch.clientY - (domRect.top + domRect.height / 2) : touch.clientX - (domRect.left + domRect.width / 2);
                  } else {
                    this.startOffset = 0;
                    window.clearTimeout(this.mouseTimeout);
                    this.mouseTimeout = window.setTimeout(function() {
                      _this2.thumbPressed = true;
                    }, 300);
                  }
                  var mouseUpOptions = _util_helpers__WEBPACK_IMPORTED_MODULE_6__["passiveSupported"] ? {
                    passive: true,
                    capture: true
                  } : true;
                  var mouseMoveOptions = _util_helpers__WEBPACK_IMPORTED_MODULE_6__["passiveSupported"] ? {
                    passive: true
                  } : false;
                  var isTouchEvent = "touches" in e;
                  this.onMouseMove(e);
                  this.app.addEventListener(isTouchEvent ? "touchmove" : "mousemove", this.onMouseMove, mouseMoveOptions);
                  Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["addOnceEventListener"])(this.app, isTouchEvent ? "touchend" : "mouseup", this.onSliderMouseUp, mouseUpOptions);
                  this.$emit("start", this.internalValue);
                },
                onSliderMouseUp: function onSliderMouseUp(e) {
                  e.stopPropagation();
                  window.clearTimeout(this.mouseTimeout);
                  this.thumbPressed = false;
                  var mouseMoveOptions = _util_helpers__WEBPACK_IMPORTED_MODULE_6__["passiveSupported"] ? {
                    passive: true
                  } : false;
                  this.app.removeEventListener("touchmove", this.onMouseMove, mouseMoveOptions);
                  this.app.removeEventListener("mousemove", this.onMouseMove, mouseMoveOptions);
                  this.$emit("mouseup", e);
                  this.$emit("end", this.internalValue);
                  if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["deepEqual"])(this.oldValue, this.internalValue)) {
                    this.$emit("change", this.internalValue);
                    this.noClick = true;
                  }
                  this.isActive = false;
                },
                onMouseMove: function onMouseMove(e) {
                  if (e.type === "mousemove") {
                    this.thumbPressed = true;
                  }
                  this.internalValue = this.parseMouseMove(e);
                },
                onKeyDown: function onKeyDown(e) {
                  if (!this.isInteractive)
                    return;
                  var value = this.parseKeyDown(e, this.internalValue);
                  if (value == null || value < this.minValue || value > this.maxValue)
                    return;
                  this.internalValue = value;
                  this.$emit("change", value);
                },
                onSliderClick: function onSliderClick(e) {
                  if (this.noClick) {
                    this.noClick = false;
                    return;
                  }
                  var thumb = this.$refs.thumb;
                  thumb.focus();
                  this.onMouseMove(e);
                  this.$emit("change", this.internalValue);
                },
                onBlur: function onBlur(e) {
                  this.isFocused = false;
                  this.$emit("blur", e);
                },
                onFocus: function onFocus(e) {
                  this.isFocused = true;
                  this.$emit("focus", e);
                },
                parseMouseMove: function parseMouseMove(e) {
                  var start = this.vertical ? "top" : "left";
                  var length = this.vertical ? "height" : "width";
                  var click2 = this.vertical ? "clientY" : "clientX";
                  var _a2 = this.$refs.track.getBoundingClientRect(), _b2 = start, trackStart = _a2[_b2], _c = length, trackLength = _a2[_c];
                  var clickOffset = "touches" in e ? e.touches[0][click2] : e[click2];
                  var clickPos = Math.min(Math.max((clickOffset - trackStart - this.startOffset) / trackLength, 0), 1) || 0;
                  if (this.vertical)
                    clickPos = 1 - clickPos;
                  if (this.$vuetify.rtl)
                    clickPos = 1 - clickPos;
                  return parseFloat(this.min) + clickPos * (this.maxValue - this.minValue);
                },
                parseKeyDown: function parseKeyDown(e, value) {
                  if (!this.isInteractive)
                    return;
                  var pageup = _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].pageup, pagedown = _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].pagedown, end = _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].end, home = _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].home, left = _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].left, right = _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].right, down = _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].down, up = _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].up;
                  if (![pageup, pagedown, end, home, left, right, down, up].includes(e.keyCode))
                    return;
                  e.preventDefault();
                  var step = this.stepNumeric || 1;
                  var steps = (this.maxValue - this.minValue) / step;
                  if ([left, right, down, up].includes(e.keyCode)) {
                    var increase = this.$vuetify.rtl ? [left, up] : [right, up];
                    var direction = increase.includes(e.keyCode) ? 1 : -1;
                    var multiplier = e.shiftKey ? 3 : e.ctrlKey ? 2 : 1;
                    value = value + direction * step * multiplier;
                  } else if (e.keyCode === home) {
                    value = this.minValue;
                  } else if (e.keyCode === end) {
                    value = this.maxValue;
                  } else {
                    var direction = e.keyCode === pagedown ? 1 : -1;
                    value = value - direction * step * (steps > 100 ? steps / 10 : 10);
                  }
                  return value;
                },
                roundValue: function roundValue(value) {
                  if (!this.stepNumeric)
                    return value;
                  var trimmedStep = this.step.toString().trim();
                  var decimals = trimmedStep.indexOf(".") > -1 ? trimmedStep.length - trimmedStep.indexOf(".") - 1 : 0;
                  var offset2 = this.minValue % this.stepNumeric;
                  var newValue = Math.round((value - offset2) / this.stepNumeric) * this.stepNumeric + offset2;
                  return parseFloat(Math.min(newValue, this.maxValue).toFixed(decimals));
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VSlider/index.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VSlider/index.ts ***!
            \*****************************************/
          /*! exports provided: VSlider, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VSlider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VSlider */
              "./src/components/VSlider/VSlider.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSlider", function() {
              return _VSlider__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VSlider__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VSnackbar/VSnackbar.sass": (
          /*!*************************************************!*\
            !*** ./src/components/VSnackbar/VSnackbar.sass ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VSnackbar/VSnackbar.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VSnackbar/VSnackbar.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VSnackbar.sass */
              "./src/components/VSnackbar/VSnackbar.sass"
            );
            var _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSheet/VSheet */
              "./src/components/VSheet/VSheet.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _mixins_positionable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/positionable */
              "./src/mixins/positionable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__["default"])(
              _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"],
              _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"],
              _mixins_toggleable__WEBPACK_IMPORTED_MODULE_4__["default"],
              Object(_mixins_positionable__WEBPACK_IMPORTED_MODULE_5__["factory"])(["absolute", "bottom", "left", "right", "top"])
              /* @vue/component */
            ).extend({
              name: "v-snackbar",
              props: {
                app: Boolean,
                centered: Boolean,
                contentClass: {
                  type: String,
                  default: ""
                },
                multiLine: Boolean,
                text: Boolean,
                timeout: {
                  type: [Number, String],
                  default: 5e3
                },
                transition: {
                  type: [Boolean, String],
                  default: "v-snack-transition",
                  validator: function validator2(v) {
                    return typeof v === "string" || v === false;
                  }
                },
                vertical: Boolean
              },
              data: function data() {
                return {
                  activeTimeout: -1
                };
              },
              computed: {
                classes: function classes() {
                  return {
                    "v-snack--absolute": this.absolute,
                    "v-snack--active": this.isActive,
                    "v-snack--bottom": this.bottom || !this.top,
                    "v-snack--centered": this.centered,
                    "v-snack--has-background": this.hasBackground,
                    "v-snack--left": this.left,
                    "v-snack--multi-line": this.multiLine && !this.vertical,
                    "v-snack--right": this.right,
                    "v-snack--text": this.text,
                    "v-snack--top": this.top,
                    "v-snack--vertical": this.vertical
                  };
                },
                // Text and outlined styles both
                // use transparent backgrounds
                hasBackground: function hasBackground() {
                  return !this.text && !this.outlined;
                },
                // Snackbar is dark by default
                // override themeable logic.
                isDark: function isDark() {
                  return this.hasBackground ? !this.light : _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"].options.computed.isDark.call(this);
                },
                styles: function styles() {
                  if (this.absolute || !this.app)
                    return {};
                  var _a2 = this.$vuetify.application, bar = _a2.bar, bottom = _a2.bottom, footer = _a2.footer, insetFooter = _a2.insetFooter, left = _a2.left, right = _a2.right, top = _a2.top;
                  return {
                    paddingBottom: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(bottom + footer + insetFooter),
                    paddingLeft: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(left),
                    paddingRight: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(right),
                    paddingTop: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(bar + top)
                  };
                }
              },
              watch: {
                isActive: "setTimeout",
                timeout: "setTimeout"
              },
              mounted: function mounted3() {
                if (this.isActive)
                  this.setTimeout();
              },
              created: function created2() {
                if (this.$attrs.hasOwnProperty("auto-height")) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["removed"])("auto-height", this);
                }
                if (this.timeout == 0) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["deprecate"])('timeout="0"', "-1", this);
                }
              },
              methods: {
                genActions: function genActions() {
                  return this.$createElement("div", {
                    staticClass: "v-snack__action "
                  }, [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getSlot"])(this, "action", {
                    attrs: {
                      class: "v-snack__btn"
                    }
                  })]);
                },
                genContent: function genContent() {
                  var _a2;
                  return this.$createElement("div", {
                    staticClass: "v-snack__content",
                    class: (_a2 = {}, _a2[this.contentClass] = true, _a2),
                    attrs: {
                      role: "status",
                      "aria-live": "polite"
                    }
                  }, [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getSlot"])(this)]);
                },
                genWrapper: function genWrapper() {
                  var _this2 = this;
                  var setColor = this.hasBackground ? this.setBackgroundColor : this.setTextColor;
                  var data = setColor(this.color, {
                    staticClass: "v-snack__wrapper",
                    class: _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this),
                    style: _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.styles.call(this),
                    directives: [{
                      name: "show",
                      value: this.isActive
                    }],
                    on: {
                      pointerenter: function pointerenter() {
                        return window.clearTimeout(_this2.activeTimeout);
                      },
                      pointerleave: this.setTimeout
                    }
                  });
                  return this.$createElement("div", data, [this.genContent(), this.genActions()]);
                },
                genTransition: function genTransition() {
                  return this.$createElement("transition", {
                    props: {
                      name: this.transition
                    }
                  }, [this.genWrapper()]);
                },
                setTimeout: function setTimeout2() {
                  var _this2 = this;
                  window.clearTimeout(this.activeTimeout);
                  var timeout = Number(this.timeout);
                  if (!this.isActive || // TODO: remove 0 in v3
                  [0, -1].includes(timeout)) {
                    return;
                  }
                  this.activeTimeout = window.setTimeout(function() {
                    _this2.isActive = false;
                  }, timeout);
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-snack",
                  class: this.classes,
                  style: this.styles
                }, [this.transition !== false ? this.genTransition() : this.genWrapper()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VSnackbar/index.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VSnackbar/index.ts ***!
            \*******************************************/
          /*! exports provided: VSnackbar, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VSnackbar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VSnackbar */
              "./src/components/VSnackbar/VSnackbar.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSnackbar", function() {
              return _VSnackbar__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VSnackbar__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VSparkline/VSparkline.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VSparkline/VSparkline.ts ***!
            \*************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _helpers_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./helpers/core */
              "./src/components/VSparkline/helpers/core.ts"
            );
            var _helpers_path__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./helpers/path */
              "./src/components/VSparkline/helpers/path.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_0__["default"]).extend({
              name: "VSparkline",
              inheritAttrs: false,
              props: {
                autoDraw: Boolean,
                autoDrawDuration: {
                  type: Number,
                  default: 2e3
                },
                autoDrawEasing: {
                  type: String,
                  default: "ease"
                },
                autoLineWidth: {
                  type: Boolean,
                  default: false
                },
                color: {
                  type: String,
                  default: "primary"
                },
                fill: {
                  type: Boolean,
                  default: false
                },
                gradient: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                gradientDirection: {
                  type: String,
                  validator: function validator2(val) {
                    return ["top", "bottom", "left", "right"].includes(val);
                  },
                  default: "top"
                },
                height: {
                  type: [String, Number],
                  default: 75
                },
                labels: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                labelSize: {
                  type: [Number, String],
                  default: 7
                },
                lineWidth: {
                  type: [String, Number],
                  default: 4
                },
                padding: {
                  type: [String, Number],
                  default: 8
                },
                showLabels: Boolean,
                smooth: {
                  type: [Boolean, Number, String],
                  default: false
                },
                type: {
                  type: String,
                  default: "trend",
                  validator: function validator2(val) {
                    return ["trend", "bar"].includes(val);
                  }
                },
                value: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                width: {
                  type: [Number, String],
                  default: 300
                }
              },
              data: function data() {
                return {
                  lastLength: 0
                };
              },
              computed: {
                parsedPadding: function parsedPadding() {
                  return Number(this.padding);
                },
                parsedWidth: function parsedWidth() {
                  return Number(this.width);
                },
                parsedHeight: function parsedHeight() {
                  return parseInt(this.height, 10);
                },
                parsedLabelSize: function parsedLabelSize() {
                  return parseInt(this.labelSize, 10) || 7;
                },
                totalHeight: function totalHeight() {
                  var height = this.parsedHeight;
                  if (this.hasLabels)
                    height += parseInt(this.labelSize, 10) * 1.5;
                  return height;
                },
                totalWidth: function totalWidth() {
                  var width = this.parsedWidth;
                  if (this.type === "bar")
                    width = Math.max(this.value.length * this._lineWidth, width);
                  return width;
                },
                totalValues: function totalValues() {
                  return this.value.length;
                },
                _lineWidth: function _lineWidth() {
                  if (this.autoLineWidth && this.type !== "trend") {
                    var totalPadding = this.parsedPadding * (this.totalValues + 1);
                    return (this.parsedWidth - totalPadding) / this.totalValues;
                  } else {
                    return parseFloat(this.lineWidth) || 4;
                  }
                },
                boundary: function boundary() {
                  if (this.type === "bar")
                    return {
                      minX: 0,
                      maxX: this.totalWidth,
                      minY: 0,
                      maxY: this.parsedHeight
                    };
                  var padding = this.parsedPadding;
                  return {
                    minX: padding,
                    maxX: this.totalWidth - padding,
                    minY: padding,
                    maxY: this.parsedHeight - padding
                  };
                },
                hasLabels: function hasLabels() {
                  return Boolean(this.showLabels || this.labels.length > 0 || this.$scopedSlots.label);
                },
                parsedLabels: function parsedLabels() {
                  var labels = [];
                  var points = this._values;
                  var len = points.length;
                  for (var i2 = 0; labels.length < len; i2++) {
                    var item = points[i2];
                    var value = this.labels[i2];
                    if (!value) {
                      value = _typeof2(item) === "object" ? item.value : item;
                    }
                    labels.push({
                      x: item.x,
                      value: String(value)
                    });
                  }
                  return labels;
                },
                normalizedValues: function normalizedValues() {
                  return this.value.map(function(item) {
                    return typeof item === "number" ? item : item.value;
                  });
                },
                _values: function _values2() {
                  return this.type === "trend" ? Object(_helpers_core__WEBPACK_IMPORTED_MODULE_2__["genPoints"])(this.normalizedValues, this.boundary) : Object(_helpers_core__WEBPACK_IMPORTED_MODULE_2__["genBars"])(this.normalizedValues, this.boundary);
                },
                textY: function textY() {
                  var y = this.parsedHeight;
                  if (this.type === "trend")
                    y -= 4;
                  return y;
                },
                _radius: function _radius() {
                  return this.smooth === true ? 8 : Number(this.smooth);
                }
              },
              watch: {
                value: {
                  immediate: true,
                  handler: function handler() {
                    var _this2 = this;
                    this.$nextTick(function() {
                      if (!_this2.autoDraw || _this2.type === "bar" || !_this2.$refs.path)
                        return;
                      var path = _this2.$refs.path;
                      var length = path.getTotalLength();
                      if (!_this2.fill) {
                        path.style.transition = "none";
                        path.style.strokeDasharray = length + " " + length;
                        path.style.strokeDashoffset = Math.abs(length - (_this2.lastLength || 0)).toString();
                        path.getBoundingClientRect();
                        path.style.transition = "stroke-dashoffset " + _this2.autoDrawDuration + "ms " + _this2.autoDrawEasing;
                        path.style.strokeDashoffset = "0";
                      } else {
                        path.style.transformOrigin = "bottom center";
                        path.style.transition = "none";
                        path.style.transform = "scaleY(0)";
                        path.getBoundingClientRect();
                        path.style.transition = "transform " + _this2.autoDrawDuration + "ms " + _this2.autoDrawEasing;
                        path.style.transform = "scaleY(1)";
                      }
                      _this2.lastLength = length;
                    });
                  }
                }
              },
              methods: {
                genGradient: function genGradient() {
                  var _this2 = this;
                  var gradientDirection = this.gradientDirection;
                  var gradient = this.gradient.slice();
                  if (!gradient.length)
                    gradient.push("");
                  var len = Math.max(gradient.length - 1, 1);
                  var stops = gradient.reverse().map(function(color2, index2) {
                    return _this2.$createElement("stop", {
                      attrs: {
                        offset: index2 / len,
                        "stop-color": color2 || "currentColor"
                      }
                    });
                  });
                  return this.$createElement("defs", [this.$createElement("linearGradient", {
                    attrs: {
                      id: this._uid,
                      gradientUnits: "userSpaceOnUse",
                      x1: gradientDirection === "left" ? "100%" : "0",
                      y1: gradientDirection === "top" ? "100%" : "0",
                      x2: gradientDirection === "right" ? "100%" : "0",
                      y2: gradientDirection === "bottom" ? "100%" : "0"
                    }
                  }, stops)]);
                },
                genG: function genG(children) {
                  return this.$createElement("g", {
                    style: {
                      fontSize: "8",
                      textAnchor: "middle",
                      dominantBaseline: "mathematical",
                      fill: "currentColor"
                    }
                    // TODO: TS 3.5 is too eager with the array type here
                  }, children);
                },
                genPath: function genPath() {
                  var points = Object(_helpers_core__WEBPACK_IMPORTED_MODULE_2__["genPoints"])(this.normalizedValues, this.boundary);
                  return this.$createElement("path", {
                    attrs: {
                      d: Object(_helpers_path__WEBPACK_IMPORTED_MODULE_3__["genPath"])(points, this._radius, this.fill, this.parsedHeight),
                      fill: this.fill ? "url(#" + this._uid + ")" : "none",
                      stroke: this.fill ? "none" : "url(#" + this._uid + ")"
                    },
                    ref: "path"
                  });
                },
                genLabels: function genLabels(offsetX) {
                  var _this2 = this;
                  var children = this.parsedLabels.map(function(item, i2) {
                    return _this2.$createElement("text", {
                      attrs: {
                        x: item.x + offsetX + _this2._lineWidth / 2,
                        y: _this2.textY + _this2.parsedLabelSize * 0.75,
                        "font-size": Number(_this2.labelSize) || 7
                      }
                    }, [_this2.genLabel(item, i2)]);
                  });
                  return this.genG(children);
                },
                genLabel: function genLabel(item, index2) {
                  return this.$scopedSlots.label ? this.$scopedSlots.label({
                    index: index2,
                    value: item.value
                  }) : item.value;
                },
                genBars: function genBars() {
                  if (!this.value || this.totalValues < 2)
                    return void 0;
                  var bars = Object(_helpers_core__WEBPACK_IMPORTED_MODULE_2__["genBars"])(this.normalizedValues, this.boundary);
                  var offsetX = (Math.abs(bars[0].x - bars[1].x) - this._lineWidth) / 2;
                  return this.$createElement("svg", {
                    attrs: {
                      display: "block",
                      viewBox: "0 0 " + this.totalWidth + " " + this.totalHeight
                    }
                  }, [this.genGradient(), this.genClipPath(bars, offsetX, this._lineWidth, "sparkline-bar-" + this._uid), this.hasLabels ? this.genLabels(offsetX) : void 0, this.$createElement("g", {
                    attrs: {
                      "clip-path": "url(#sparkline-bar-" + this._uid + "-clip)",
                      fill: "url(#" + this._uid + ")"
                    }
                  }, [this.$createElement("rect", {
                    attrs: {
                      x: 0,
                      y: 0,
                      width: this.totalWidth,
                      height: this.height
                    }
                  })])]);
                },
                genClipPath: function genClipPath(bars, offsetX, lineWidth, id) {
                  var _this2 = this;
                  var rounding = typeof this.smooth === "number" ? this.smooth : this.smooth ? 2 : 0;
                  return this.$createElement("clipPath", {
                    attrs: {
                      id: id + "-clip"
                    }
                  }, bars.map(function(item) {
                    return _this2.$createElement("rect", {
                      attrs: {
                        x: item.x + offsetX,
                        y: item.y,
                        width: lineWidth,
                        height: item.height,
                        rx: rounding,
                        ry: rounding
                      }
                    }, [_this2.autoDraw ? _this2.$createElement("animate", {
                      attrs: {
                        attributeName: "height",
                        from: 0,
                        to: item.height,
                        dur: _this2.autoDrawDuration + "ms",
                        fill: "freeze"
                      }
                    }) : void 0]);
                  }));
                },
                genTrend: function genTrend() {
                  return this.$createElement("svg", this.setTextColor(this.color, {
                    attrs: __assign2(__assign2({}, this.$attrs), {
                      display: "block",
                      "stroke-width": this._lineWidth || 1,
                      viewBox: "0 0 " + this.width + " " + this.totalHeight
                    })
                  }), [this.genGradient(), this.hasLabels && this.genLabels(-(this._lineWidth / 2)), this.genPath()]);
                }
              },
              render: function render8(h) {
                if (this.totalValues < 2)
                  return void 0;
                return this.type === "trend" ? this.genTrend() : this.genBars();
              }
            });
          }
        ),
        /***/
        "./src/components/VSparkline/helpers/core.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VSparkline/helpers/core.ts ***!
            \***************************************************/
          /*! exports provided: genPoints, genBars */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "genPoints", function() {
              return genPoints;
            });
            __webpack_require__.d(__webpack_exports__, "genBars", function() {
              return genBars;
            });
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            function genPoints(values2, boundary) {
              var minX = boundary.minX, maxX = boundary.maxX, minY = boundary.minY, maxY = boundary.maxY;
              var totalValues = values2.length;
              var maxValue = Math.max.apply(Math, __spreadArray2([], __read2(values2), false));
              var minValue = Math.min.apply(Math, __spreadArray2([], __read2(values2), false));
              var gridX = (maxX - minX) / (totalValues - 1);
              var gridY = (maxY - minY) / (maxValue - minValue || 1);
              return values2.map(function(value, index2) {
                return {
                  x: minX + index2 * gridX,
                  y: maxY - (value - minValue) * gridY,
                  value
                };
              });
            }
            function genBars(values2, boundary) {
              var minX = boundary.minX, maxX = boundary.maxX, minY = boundary.minY, maxY = boundary.maxY;
              var totalValues = values2.length;
              var maxValue = Math.max.apply(Math, __spreadArray2([], __read2(values2), false));
              var minValue = Math.min.apply(Math, __spreadArray2([], __read2(values2), false));
              if (minValue > 0)
                minValue = 0;
              if (maxValue < 0)
                maxValue = 0;
              var gridX = maxX / totalValues;
              var gridY = (maxY - minY) / (maxValue - minValue || 1);
              var horizonY = maxY - Math.abs(minValue * gridY);
              return values2.map(function(value, index2) {
                var height = Math.abs(gridY * value);
                return {
                  x: minX + index2 * gridX,
                  y: horizonY - height + +(value < 0) * height,
                  height,
                  value
                };
              });
            }
          }
        ),
        /***/
        "./src/components/VSparkline/helpers/math.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VSparkline/helpers/math.ts ***!
            \***************************************************/
          /*! exports provided: checkCollinear, getDistance, moveTo */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "checkCollinear", function() {
              return checkCollinear;
            });
            __webpack_require__.d(__webpack_exports__, "getDistance", function() {
              return getDistance;
            });
            __webpack_require__.d(__webpack_exports__, "moveTo", function() {
              return moveTo;
            });
            function int(value) {
              return parseInt(value, 10);
            }
            function checkCollinear(p0, p1, p2) {
              return int(p0.x + p2.x) === int(2 * p1.x) && int(p0.y + p2.y) === int(2 * p1.y);
            }
            function getDistance(p1, p2) {
              return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
            }
            function moveTo(to, from, radius) {
              var vector = {
                x: to.x - from.x,
                y: to.y - from.y
              };
              var length = Math.sqrt(vector.x * vector.x + vector.y * vector.y);
              var unitVector = {
                x: vector.x / length,
                y: vector.y / length
              };
              return {
                x: from.x + unitVector.x * radius,
                y: from.y + unitVector.y * radius
              };
            }
          }
        ),
        /***/
        "./src/components/VSparkline/helpers/path.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VSparkline/helpers/path.ts ***!
            \***************************************************/
          /*! exports provided: genPath */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "genPath", function() {
              return genPath;
            });
            var _math__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./math */
              "./src/components/VSparkline/helpers/math.ts"
            );
            function genPath(points, radius, fill, height) {
              if (fill === void 0) {
                fill = false;
              }
              if (height === void 0) {
                height = 75;
              }
              var start = points.shift();
              var end = points[points.length - 1];
              return (fill ? "M" + start.x + " " + (height - start.x + 2) + " L" + start.x + " " + start.y : "M" + start.x + " " + start.y) + points.map(function(point, index2) {
                var next = points[index2 + 1];
                var prev = points[index2 - 1] || start;
                var isCollinear = next && Object(_math__WEBPACK_IMPORTED_MODULE_0__["checkCollinear"])(next, point, prev);
                if (!next || isCollinear) {
                  return "L" + point.x + " " + point.y;
                }
                var threshold = Math.min(Object(_math__WEBPACK_IMPORTED_MODULE_0__["getDistance"])(prev, point), Object(_math__WEBPACK_IMPORTED_MODULE_0__["getDistance"])(next, point));
                var isTooCloseForRadius = threshold / 2 < radius;
                var radiusForPoint = isTooCloseForRadius ? threshold / 2 : radius;
                var before = Object(_math__WEBPACK_IMPORTED_MODULE_0__["moveTo"])(prev, point, radiusForPoint);
                var after = Object(_math__WEBPACK_IMPORTED_MODULE_0__["moveTo"])(next, point, radiusForPoint);
                return "L" + before.x + " " + before.y + "S" + point.x + " " + point.y + " " + after.x + " " + after.y;
              }).join("") + (fill ? "L" + end.x + " " + (height - start.x + 2) + " Z" : "");
            }
          }
        ),
        /***/
        "./src/components/VSparkline/index.ts": (
          /*!********************************************!*\
            !*** ./src/components/VSparkline/index.ts ***!
            \********************************************/
          /*! exports provided: VSparkline, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VSparkline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VSparkline */
              "./src/components/VSparkline/VSparkline.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSparkline", function() {
              return _VSparkline__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VSparkline__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VSpeedDial/VSpeedDial.sass": (
          /*!***************************************************!*\
            !*** ./src/components/VSpeedDial/VSpeedDial.sass ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VSpeedDial/VSpeedDial.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VSpeedDial/VSpeedDial.ts ***!
            \*************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VSpeedDial.sass */
              "./src/components/VSpeedDial/VSpeedDial.sass"
            );
            var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _mixins_positionable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/positionable */
              "./src/mixins/positionable/index.ts"
            );
            var _mixins_transitionable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/transitionable */
              "./src/mixins/transitionable/index.ts"
            );
            var _directives_click_outside__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../directives/click-outside */
              "./src/directives/click-outside/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_positionable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_transitionable__WEBPACK_IMPORTED_MODULE_3__["default"]).extend({
              name: "v-speed-dial",
              directives: {
                ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_4__["default"]
              },
              props: {
                direction: {
                  type: String,
                  default: "top",
                  validator: function validator2(val) {
                    return ["top", "right", "bottom", "left"].includes(val);
                  }
                },
                openOnHover: Boolean,
                transition: {
                  type: String,
                  default: "scale-transition"
                }
              },
              computed: {
                classes: function classes() {
                  var _a2;
                  return _a2 = {
                    "v-speed-dial": true,
                    "v-speed-dial--top": this.top,
                    "v-speed-dial--right": this.right,
                    "v-speed-dial--bottom": this.bottom,
                    "v-speed-dial--left": this.left,
                    "v-speed-dial--absolute": this.absolute,
                    "v-speed-dial--fixed": this.fixed
                  }, _a2["v-speed-dial--direction-" + this.direction] = true, _a2["v-speed-dial--is-active"] = this.isActive, _a2;
                }
              },
              render: function render8(h) {
                var _this2 = this;
                var children = [];
                var data = {
                  class: this.classes,
                  directives: [{
                    name: "click-outside",
                    value: function value() {
                      return _this2.isActive = false;
                    }
                  }],
                  on: {
                    click: function click2() {
                      return _this2.isActive = !_this2.isActive;
                    }
                  }
                };
                if (this.openOnHover) {
                  data.on.mouseenter = function() {
                    return _this2.isActive = true;
                  };
                  data.on.mouseleave = function() {
                    return _this2.isActive = false;
                  };
                }
                if (this.isActive) {
                  var btnCount_1 = 0;
                  children = (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getSlot"])(this) || []).map(function(b, i2) {
                    if (b.tag && typeof b.componentOptions !== "undefined" && (b.componentOptions.Ctor.options.name === "v-btn" || b.componentOptions.Ctor.options.name === "v-tooltip")) {
                      btnCount_1++;
                      return h("div", {
                        style: {
                          transitionDelay: btnCount_1 * 0.05 + "s"
                        },
                        key: i2
                      }, [b]);
                    } else {
                      b.key = i2;
                      return b;
                    }
                  });
                }
                var list2 = h("transition-group", {
                  class: "v-speed-dial__list",
                  props: {
                    name: this.transition,
                    mode: this.mode,
                    origin: this.origin,
                    tag: "div"
                  }
                }, children);
                return h("div", data, [Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getSlot"])(this, "activator"), list2]);
              }
            });
          }
        ),
        /***/
        "./src/components/VSpeedDial/index.ts": (
          /*!********************************************!*\
            !*** ./src/components/VSpeedDial/index.ts ***!
            \********************************************/
          /*! exports provided: VSpeedDial, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VSpeedDial__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VSpeedDial */
              "./src/components/VSpeedDial/VSpeedDial.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSpeedDial", function() {
              return _VSpeedDial__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VSpeedDial__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VStepper/VStepper.sass": (
          /*!***********************************************!*\
            !*** ./src/components/VStepper/VStepper.sass ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VStepper/VStepper.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VStepper/VStepper.ts ***!
            \*********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VStepper.sass */
              "./src/components/VStepper/VStepper.sass"
            );
            var _VSheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSheet */
              "./src/components/VSheet/index.ts"
            );
            var _mixins_registrable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/registrable */
              "./src/mixins/registrable/index.ts"
            );
            var _mixins_proxyable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/proxyable */
              "./src/mixins/proxyable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_2__["provide"])("stepper"), _mixins_proxyable__WEBPACK_IMPORTED_MODULE_3__["default"]);
            __webpack_exports__["default"] = baseMixins.extend({
              name: "v-stepper",
              provide: function provide() {
                return {
                  stepClick: this.stepClick,
                  isVertical: this.vertical
                };
              },
              props: {
                altLabels: Boolean,
                nonLinear: Boolean,
                flat: Boolean,
                vertical: Boolean
              },
              data: function data() {
                var data2 = {
                  isBooted: false,
                  steps: [],
                  content: [],
                  isReverse: false
                };
                data2.internalLazyValue = this.value != null ? this.value : (data2[0] || {}).step || 1;
                return data2;
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-stepper--flat": this.flat,
                    "v-stepper--is-booted": this.isBooted,
                    "v-stepper--vertical": this.vertical,
                    "v-stepper--alt-labels": this.altLabels,
                    "v-stepper--non-linear": this.nonLinear
                  }, _VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this));
                },
                styles: function styles() {
                  return __assign2({}, _VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.styles.call(this));
                }
              },
              watch: {
                internalValue: function internalValue(val, oldVal) {
                  this.isReverse = Number(val) < Number(oldVal);
                  oldVal && (this.isBooted = true);
                  this.updateView();
                }
              },
              created: function created2() {
                if (this.$listeners.input) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_5__["breaking"])("@input", "@change", this);
                }
              },
              mounted: function mounted3() {
                this.updateView();
              },
              methods: {
                register: function register(item) {
                  if (item.$options.name === "v-stepper-step") {
                    this.steps.push(item);
                  } else if (item.$options.name === "v-stepper-content") {
                    item.isVertical = this.vertical;
                    this.content.push(item);
                  }
                },
                unregister: function unregister(item) {
                  if (item.$options.name === "v-stepper-step") {
                    this.steps = this.steps.filter(function(i2) {
                      return i2 !== item;
                    });
                  } else if (item.$options.name === "v-stepper-content") {
                    item.isVertical = this.vertical;
                    this.content = this.content.filter(function(i2) {
                      return i2 !== item;
                    });
                  }
                },
                stepClick: function stepClick(step) {
                  var _this2 = this;
                  this.$nextTick(function() {
                    return _this2.internalValue = step;
                  });
                },
                updateView: function updateView() {
                  for (var index2 = this.steps.length; --index2 >= 0; ) {
                    this.steps[index2].toggle(this.internalValue);
                  }
                  for (var index2 = this.content.length; --index2 >= 0; ) {
                    this.content[index2].toggle(this.internalValue, this.isReverse);
                  }
                }
              },
              render: function render8(h) {
                return h(this.tag, {
                  staticClass: "v-stepper",
                  class: this.classes,
                  style: this.styles
                }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getSlot"])(this));
              }
            });
          }
        ),
        /***/
        "./src/components/VStepper/VStepperContent.ts": (
          /*!****************************************************!*\
            !*** ./src/components/VStepper/VStepperContent.ts ***!
            \****************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _transitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../transitions */
              "./src/components/transitions/index.ts"
            );
            var _mixins_registrable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/registrable */
              "./src/mixins/registrable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_1__["inject"])("stepper", "v-stepper-content", "v-stepper"));
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-stepper-content",
              inject: {
                isVerticalProvided: {
                  from: "isVertical"
                }
              },
              props: {
                step: {
                  type: [Number, String],
                  required: true
                }
              },
              data: function data() {
                return {
                  height: 0,
                  // Must be null to allow
                  // previous comparison
                  isActive: null,
                  isReverse: false,
                  isVertical: this.isVerticalProvided
                };
              },
              computed: {
                computedTransition: function computedTransition() {
                  var reverse = this.$vuetify.rtl ? !this.isReverse : this.isReverse;
                  return reverse ? _transitions__WEBPACK_IMPORTED_MODULE_0__["VTabReverseTransition"] : _transitions__WEBPACK_IMPORTED_MODULE_0__["VTabTransition"];
                },
                styles: function styles() {
                  if (!this.isVertical)
                    return {};
                  return {
                    height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["convertToUnit"])(this.height)
                  };
                }
              },
              watch: {
                isActive: function isActive(current, previous) {
                  if (current && previous == null) {
                    this.height = "auto";
                    return;
                  }
                  if (!this.isVertical)
                    return;
                  if (this.isActive)
                    this.enter();
                  else
                    this.leave();
                }
              },
              mounted: function mounted3() {
                this.$refs.wrapper.addEventListener("transitionend", this.onTransition, false);
                this.stepper && this.stepper.register(this);
              },
              beforeDestroy: function beforeDestroy2() {
                this.$refs.wrapper.removeEventListener("transitionend", this.onTransition, false);
                this.stepper && this.stepper.unregister(this);
              },
              methods: {
                onTransition: function onTransition(e) {
                  if (!this.isActive || e.propertyName !== "height")
                    return;
                  this.height = "auto";
                },
                enter: function enter2() {
                  var _this2 = this;
                  var scrollHeight = 0;
                  requestAnimationFrame(function() {
                    scrollHeight = _this2.$refs.wrapper.scrollHeight;
                  });
                  this.height = 0;
                  setTimeout(function() {
                    return _this2.isActive && (_this2.height = scrollHeight || "auto");
                  }, 450);
                },
                leave: function leave2() {
                  var _this2 = this;
                  this.height = this.$refs.wrapper.clientHeight;
                  setTimeout(function() {
                    return _this2.height = 0;
                  }, 10);
                },
                toggle: function toggle(step, reverse) {
                  this.isActive = step.toString() === this.step.toString();
                  this.isReverse = reverse;
                }
              },
              render: function render8(h) {
                var contentData = {
                  staticClass: "v-stepper__content"
                };
                var wrapperData = {
                  staticClass: "v-stepper__wrapper",
                  style: this.styles,
                  ref: "wrapper"
                };
                if (!this.isVertical) {
                  contentData.directives = [{
                    name: "show",
                    value: this.isActive
                  }];
                }
                var wrapper = h("div", wrapperData, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["getSlot"])(this));
                var content = h("div", contentData, [wrapper]);
                return h(this.computedTransition, {
                  on: this.$listeners
                }, [content]);
              }
            });
          }
        ),
        /***/
        "./src/components/VStepper/VStepperStep.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VStepper/VStepperStep.ts ***!
            \*************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_registrable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/registrable */
              "./src/mixins/registrable/index.ts"
            );
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_2__["inject"])("stepper", "v-stepper-step", "v-stepper"));
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-stepper-step",
              directives: {
                ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_3__["default"]
              },
              inject: ["stepClick"],
              props: {
                color: {
                  type: String,
                  default: "primary"
                },
                complete: Boolean,
                completeIcon: {
                  type: String,
                  default: "$complete"
                },
                editable: Boolean,
                editIcon: {
                  type: String,
                  default: "$edit"
                },
                errorIcon: {
                  type: String,
                  default: "$error"
                },
                rules: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                step: [Number, String]
              },
              data: function data() {
                return {
                  isActive: false,
                  isInactive: true
                };
              },
              computed: {
                classes: function classes() {
                  return {
                    "v-stepper__step--active": this.isActive,
                    "v-stepper__step--editable": this.editable,
                    "v-stepper__step--inactive": this.isInactive,
                    "v-stepper__step--error error--text": this.hasError,
                    "v-stepper__step--complete": this.complete
                  };
                },
                hasError: function hasError() {
                  return this.rules.some(function(validate) {
                    return validate() !== true;
                  });
                }
              },
              mounted: function mounted3() {
                this.stepper && this.stepper.register(this);
              },
              beforeDestroy: function beforeDestroy2() {
                this.stepper && this.stepper.unregister(this);
              },
              methods: {
                click: function click2(e) {
                  e.stopPropagation();
                  this.$emit("click", e);
                  if (this.editable) {
                    this.stepClick(this.step);
                  }
                },
                genIcon: function genIcon(icon) {
                  return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"], icon);
                },
                genLabel: function genLabel() {
                  return this.$createElement("div", {
                    staticClass: "v-stepper__label"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this));
                },
                genStep: function genStep() {
                  var color2 = !this.hasError && (this.complete || this.isActive) ? this.color : false;
                  return this.$createElement("span", this.setBackgroundColor(color2, {
                    staticClass: "v-stepper__step__step"
                  }), this.genStepContent());
                },
                genStepContent: function genStepContent() {
                  var children = [];
                  if (this.hasError) {
                    children.push(this.genIcon(this.errorIcon));
                  } else if (this.complete) {
                    if (this.editable) {
                      children.push(this.genIcon(this.editIcon));
                    } else {
                      children.push(this.genIcon(this.completeIcon));
                    }
                  } else {
                    children.push(String(this.step));
                  }
                  return children;
                },
                keyboardClick: function keyboardClick(e) {
                  if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_5__["keyCodes"].space) {
                    this.click(e);
                  }
                },
                toggle: function toggle(step) {
                  this.isActive = step.toString() === this.step.toString();
                  this.isInactive = Number(step) < Number(this.step);
                }
              },
              render: function render8(h) {
                return h("div", {
                  attrs: {
                    tabindex: this.editable ? 0 : -1
                  },
                  staticClass: "v-stepper__step",
                  class: this.classes,
                  directives: [{
                    name: "ripple",
                    value: this.editable
                  }],
                  on: {
                    click: this.click,
                    keydown: this.keyboardClick
                  }
                }, [this.genStep(), this.genLabel()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VStepper/index.ts": (
          /*!******************************************!*\
            !*** ./src/components/VStepper/index.ts ***!
            \******************************************/
          /*! exports provided: VStepper, VStepperContent, VStepperStep, VStepperHeader, VStepperItems, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "VStepperHeader", function() {
              return VStepperHeader;
            });
            __webpack_require__.d(__webpack_exports__, "VStepperItems", function() {
              return VStepperItems;
            });
            var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _VStepper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VStepper */
              "./src/components/VStepper/VStepper.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VStepper", function() {
              return _VStepper__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _VStepperStep__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VStepperStep */
              "./src/components/VStepper/VStepperStep.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VStepperStep", function() {
              return _VStepperStep__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            var _VStepperContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VStepperContent */
              "./src/components/VStepper/VStepperContent.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VStepperContent", function() {
              return _VStepperContent__WEBPACK_IMPORTED_MODULE_3__["default"];
            });
            var VStepperHeader = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])("v-stepper__header");
            var VStepperItems = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])("v-stepper__items");
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VStepper: _VStepper__WEBPACK_IMPORTED_MODULE_1__["default"],
                VStepperContent: _VStepperContent__WEBPACK_IMPORTED_MODULE_3__["default"],
                VStepperStep: _VStepperStep__WEBPACK_IMPORTED_MODULE_2__["default"],
                VStepperHeader,
                VStepperItems
              }
            };
          }
        ),
        /***/
        "./src/components/VSubheader/VSubheader.sass": (
          /*!***************************************************!*\
            !*** ./src/components/VSubheader/VSubheader.sass ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VSubheader/VSubheader.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VSubheader/VSubheader.ts ***!
            \*************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VSubheader.sass */
              "./src/components/VSubheader/VSubheader.sass"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"]
              /* @vue/component */
            ).extend({
              name: "v-subheader",
              props: {
                inset: Boolean
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-subheader",
                  class: __assign2({
                    "v-subheader--inset": this.inset
                  }, this.themeClasses),
                  attrs: this.$attrs,
                  on: this.$listeners
                }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this));
              }
            });
          }
        ),
        /***/
        "./src/components/VSubheader/index.ts": (
          /*!********************************************!*\
            !*** ./src/components/VSubheader/index.ts ***!
            \********************************************/
          /*! exports provided: VSubheader, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VSubheader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VSubheader */
              "./src/components/VSubheader/VSubheader.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSubheader", function() {
              return _VSubheader__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VSubheader__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VSwitch/VSwitch.sass": (
          /*!*********************************************!*\
            !*** ./src/components/VSwitch/VSwitch.sass ***!
            \*********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VSwitch/VSwitch.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VSwitch/VSwitch.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ../../styles/components/_selection-controls.sass */
              "./src/styles/components/_selection-controls.sass"
            );
            __webpack_require__(
              /*! ./VSwitch.sass */
              "./src/components/VSwitch/VSwitch.sass"
            );
            var _mixins_selectable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/selectable */
              "./src/mixins/selectable/index.ts"
            );
            var _VInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VInput */
              "./src/components/VInput/index.ts"
            );
            var _directives_touch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../directives/touch */
              "./src/directives/touch/index.ts"
            );
            var _transitions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../transitions */
              "./src/components/transitions/index.ts"
            );
            var _VProgressCircular_VProgressCircular__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../VProgressCircular/VProgressCircular */
              "./src/components/VProgressCircular/VProgressCircular.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __rest = function(s2, e) {
              var t3 = {};
              for (var p in s2) {
                if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
                  t3[p] = s2[p];
              }
              if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
                for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
                  if (e.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
                    t3[p[i2]] = s2[p[i2]];
                }
              return t3;
            };
            __webpack_exports__["default"] = _mixins_selectable__WEBPACK_IMPORTED_MODULE_2__["default"].extend({
              name: "v-switch",
              directives: {
                Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_4__["default"]
              },
              props: {
                inset: Boolean,
                loading: {
                  type: [Boolean, String],
                  default: false
                },
                flat: {
                  type: Boolean,
                  default: false
                }
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VInput__WEBPACK_IMPORTED_MODULE_3__["default"].options.computed.classes.call(this)), {
                    "v-input--selection-controls v-input--switch": true,
                    "v-input--switch--flat": this.flat,
                    "v-input--switch--inset": this.inset
                  });
                },
                attrs: function attrs2() {
                  return {
                    "aria-checked": String(this.isActive),
                    "aria-disabled": String(this.isDisabled),
                    role: "switch"
                  };
                },
                // Do not return undefined if disabled,
                // according to spec, should still show
                // a color when disabled and active
                validationState: function validationState() {
                  if (this.hasError && this.shouldValidate)
                    return "error";
                  if (this.hasSuccess)
                    return "success";
                  if (this.hasColor !== null)
                    return this.computedColor;
                  return void 0;
                },
                switchData: function switchData() {
                  return this.setTextColor(this.loading ? void 0 : this.validationState, {
                    class: this.themeClasses
                  });
                }
              },
              methods: {
                genDefaultSlot: function genDefaultSlot() {
                  return [this.genSwitch(), this.genLabel()];
                },
                genSwitch: function genSwitch() {
                  var _a2 = this.attrs$;
                  _a2.title;
                  var switchAttrs = __rest(_a2, ["title"]);
                  return this.$createElement("div", {
                    staticClass: "v-input--selection-controls__input"
                  }, [this.genInput("checkbox", __assign2(__assign2({}, this.attrs), switchAttrs)), this.genRipple(this.setTextColor(this.validationState, {
                    directives: [{
                      name: "touch",
                      value: {
                        left: this.onSwipeLeft,
                        right: this.onSwipeRight
                      }
                    }]
                  })), this.$createElement("div", __assign2({
                    staticClass: "v-input--switch__track"
                  }, this.switchData)), this.$createElement("div", __assign2({
                    staticClass: "v-input--switch__thumb"
                  }, this.switchData), [this.genProgress()])]);
                },
                genProgress: function genProgress() {
                  return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_5__["VFabTransition"], {}, [this.loading === false ? null : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getSlot"])(this, "progress") || this.$createElement(_VProgressCircular_VProgressCircular__WEBPACK_IMPORTED_MODULE_6__["default"], {
                    props: {
                      color: this.loading === true || this.loading === "" ? this.color || "primary" : this.loading,
                      size: 16,
                      width: 2,
                      indeterminate: true
                    }
                  })]);
                },
                onSwipeLeft: function onSwipeLeft() {
                  if (this.isActive)
                    this.onChange();
                },
                onSwipeRight: function onSwipeRight() {
                  if (!this.isActive)
                    this.onChange();
                },
                onKeydown: function onKeydown(e) {
                  if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_7__["keyCodes"].left && this.isActive || e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_7__["keyCodes"].right && !this.isActive)
                    this.onChange();
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VSwitch/index.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VSwitch/index.ts ***!
            \*****************************************/
          /*! exports provided: VSwitch, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VSwitch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VSwitch */
              "./src/components/VSwitch/VSwitch.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSwitch", function() {
              return _VSwitch__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VSwitch__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VSystemBar/VSystemBar.sass": (
          /*!***************************************************!*\
            !*** ./src/components/VSystemBar/VSystemBar.sass ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VSystemBar/VSystemBar.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VSystemBar/VSystemBar.ts ***!
            \*************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VSystemBar.sass */
              "./src/components/VSystemBar/VSystemBar.sass"
            );
            var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/applicationable */
              "./src/mixins/applicationable/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(
              Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__["default"])("bar", ["height", "window"]),
              _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"],
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]
              /* @vue/component */
            ).extend({
              name: "v-system-bar",
              props: {
                height: [Number, String],
                lightsOut: Boolean,
                window: Boolean
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-system-bar--lights-out": this.lightsOut,
                    "v-system-bar--absolute": this.absolute,
                    "v-system-bar--fixed": !this.absolute && (this.app || this.fixed),
                    "v-system-bar--window": this.window
                  }, this.themeClasses);
                },
                computedHeight: function computedHeight() {
                  if (this.height) {
                    return isNaN(parseInt(this.height)) ? this.height : parseInt(this.height);
                  }
                  return this.window ? 32 : 24;
                },
                styles: function styles() {
                  return {
                    height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.computedHeight)
                  };
                }
              },
              methods: {
                updateApplication: function updateApplication() {
                  return this.$el ? this.$el.clientHeight : this.computedHeight;
                }
              },
              render: function render8(h) {
                var data = {
                  staticClass: "v-system-bar",
                  class: this.classes,
                  style: this.styles,
                  on: this.$listeners
                };
                return h("div", this.setBackgroundColor(this.color, data), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this));
              }
            });
          }
        ),
        /***/
        "./src/components/VSystemBar/index.ts": (
          /*!********************************************!*\
            !*** ./src/components/VSystemBar/index.ts ***!
            \********************************************/
          /*! exports provided: VSystemBar, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VSystemBar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VSystemBar */
              "./src/components/VSystemBar/VSystemBar.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSystemBar", function() {
              return _VSystemBar__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VSystemBar__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VTabs/VTab.ts": (
          /*!**************************************!*\
            !*** ./src/components/VTabs/VTab.ts ***!
            \**************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_groupable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../mixins/groupable */
              "./src/mixins/groupable/index.ts"
            );
            var _mixins_routable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/routable */
              "./src/mixins/routable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(
              _mixins_routable__WEBPACK_IMPORTED_MODULE_1__["default"],
              // Must be after routable
              // to overwrite activeClass
              Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_0__["factory"])("tabsBar"),
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
            );
            __webpack_exports__["default"] = baseMixins.extend().extend().extend({
              name: "v-tab",
              props: {
                ripple: {
                  type: [Boolean, Object],
                  default: true
                },
                tabValue: {
                  required: false
                }
              },
              data: function data() {
                return {
                  proxyClass: "v-tab--active"
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2(__assign2({
                    "v-tab": true
                  }, _mixins_routable__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-tab--disabled": this.disabled
                  }), this.groupClasses);
                },
                value: function value() {
                  if (this.tabValue != null)
                    return this.tabValue;
                  var to = this.to || this.href;
                  if (to == null)
                    return to;
                  if (this.$router && this.to === Object(this.to)) {
                    var resolve2 = this.$router.resolve(this.to, this.$route, this.append);
                    to = resolve2.href;
                  }
                  return to.replace("#", "");
                }
              },
              methods: {
                click: function click2(e) {
                  if (this.disabled) {
                    e.preventDefault();
                    return;
                  }
                  if (this.href && this.href.indexOf("#") > -1)
                    e.preventDefault();
                  if (e.detail)
                    this.$el.blur();
                  this.$emit("click", e);
                  this.to || this.toggle();
                },
                toggle: function toggle() {
                  if (!this.isActive || !this.tabsBar.mandatory && !this.to) {
                    this.$emit("change");
                  }
                }
              },
              render: function render8(h) {
                var _this2 = this;
                var _a2 = this.generateRouteLink(), tag = _a2.tag, data = _a2.data;
                data.attrs = __assign2(__assign2({}, data.attrs), {
                  "aria-selected": String(this.isActive),
                  role: "tab",
                  tabindex: this.disabled ? -1 : 0
                });
                data.on = __assign2(__assign2({}, data.on), {
                  keydown: function keydown(e) {
                    if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].enter)
                      _this2.click(e);
                    _this2.$emit("keydown", e);
                  }
                });
                return h(tag, data, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this));
              }
            });
          }
        ),
        /***/
        "./src/components/VTabs/VTabItem.ts": (
          /*!******************************************!*\
            !*** ./src/components/VTabs/VTabItem.ts ***!
            \******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../VWindow/VWindowItem */
              "./src/components/VWindow/VWindowItem.ts"
            );
            __webpack_exports__["default"] = _VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
              name: "v-tab-item",
              props: {
                id: String
              },
              methods: {
                genWindowItem: function genWindowItem() {
                  var item = _VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__["default"].options.methods.genWindowItem.call(this);
                  item.data.domProps = item.data.domProps || {};
                  item.data.domProps.id = this.id || this.value;
                  return item;
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VTabs/VTabs.sass": (
          /*!*****************************************!*\
            !*** ./src/components/VTabs/VTabs.sass ***!
            \*****************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VTabs/VTabs.ts": (
          /*!***************************************!*\
            !*** ./src/components/VTabs/VTabs.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VTabs.sass */
              "./src/components/VTabs/VTabs.sass"
            );
            var _VTabsBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VTabsBar */
              "./src/components/VTabs/VTabsBar.ts"
            );
            var _VTabsItems__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VTabsItems */
              "./src/components/VTabs/VTabsItems.ts"
            );
            var _VTabsSlider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VTabsSlider */
              "./src/components/VTabs/VTabsSlider.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_proxyable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/proxyable */
              "./src/mixins/proxyable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _directives_resize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../directives/resize */
              "./src/directives/resize/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_9__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_proxyable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__["default"]);
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-tabs",
              directives: {
                Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_7__["default"]
              },
              props: {
                activeClass: {
                  type: String,
                  default: ""
                },
                alignWithTitle: Boolean,
                backgroundColor: String,
                centerActive: Boolean,
                centered: Boolean,
                fixedTabs: Boolean,
                grow: Boolean,
                height: {
                  type: [Number, String],
                  default: void 0
                },
                hideSlider: Boolean,
                iconsAndText: Boolean,
                mobileBreakpoint: [String, Number],
                nextIcon: {
                  type: String,
                  default: "$next"
                },
                optional: Boolean,
                prevIcon: {
                  type: String,
                  default: "$prev"
                },
                right: Boolean,
                showArrows: [Boolean, String],
                sliderColor: String,
                sliderSize: {
                  type: [Number, String],
                  default: 2
                },
                vertical: Boolean
              },
              data: function data() {
                return {
                  resizeTimeout: 0,
                  slider: {
                    height: null,
                    left: null,
                    right: null,
                    top: null,
                    width: null
                  },
                  transitionTime: 300
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-tabs--align-with-title": this.alignWithTitle,
                    "v-tabs--centered": this.centered,
                    "v-tabs--fixed-tabs": this.fixedTabs,
                    "v-tabs--grow": this.grow,
                    "v-tabs--icons-and-text": this.iconsAndText,
                    "v-tabs--right": this.right,
                    "v-tabs--vertical": this.vertical
                  }, this.themeClasses);
                },
                isReversed: function isReversed() {
                  return this.$vuetify.rtl && this.vertical;
                },
                sliderStyles: function sliderStyles() {
                  return {
                    height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["convertToUnit"])(this.slider.height),
                    left: this.isReversed ? void 0 : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["convertToUnit"])(this.slider.left),
                    right: this.isReversed ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["convertToUnit"])(this.slider.right) : void 0,
                    top: this.vertical ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["convertToUnit"])(this.slider.top) : void 0,
                    transition: this.slider.left != null ? null : "none",
                    width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["convertToUnit"])(this.slider.width)
                  };
                },
                computedColor: function computedColor() {
                  if (this.color)
                    return this.color;
                  else if (this.isDark && !this.appIsDark)
                    return "white";
                  else
                    return "primary";
                }
              },
              watch: {
                alignWithTitle: "callSlider",
                centered: "callSlider",
                centerActive: "callSlider",
                fixedTabs: "callSlider",
                grow: "callSlider",
                iconsAndText: "callSlider",
                right: "callSlider",
                showArrows: "callSlider",
                vertical: "callSlider",
                "$vuetify.application.left": "onResize",
                "$vuetify.application.right": "onResize",
                "$vuetify.rtl": "onResize"
              },
              mounted: function mounted3() {
                var _this2 = this;
                if (typeof ResizeObserver !== "undefined") {
                  var obs_1 = new ResizeObserver(function() {
                    _this2.onResize();
                  });
                  obs_1.observe(this.$el);
                  this.$on("hook:destroyed", function() {
                    obs_1.disconnect();
                  });
                }
                this.$nextTick(function() {
                  window.setTimeout(_this2.callSlider, 30);
                });
              },
              methods: {
                callSlider: function callSlider() {
                  var _this2 = this;
                  if (this.hideSlider || !this.$refs.items || !this.$refs.items.selectedItems.length) {
                    this.slider.width = 0;
                    return false;
                  }
                  this.$nextTick(function() {
                    var activeTab = _this2.$refs.items.selectedItems[0];
                    if (!activeTab || !activeTab.$el) {
                      _this2.slider.width = 0;
                      _this2.slider.left = 0;
                      return;
                    }
                    var el = activeTab.$el;
                    _this2.slider = {
                      height: !_this2.vertical ? Number(_this2.sliderSize) : el.scrollHeight,
                      left: _this2.vertical ? 0 : el.offsetLeft,
                      right: _this2.vertical ? 0 : el.offsetLeft + el.offsetWidth,
                      top: el.offsetTop,
                      width: _this2.vertical ? Number(_this2.sliderSize) : el.scrollWidth
                    };
                  });
                  return true;
                },
                genBar: function genBar(items, slider) {
                  var _this2 = this;
                  var data = {
                    style: {
                      height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["convertToUnit"])(this.height)
                    },
                    props: {
                      activeClass: this.activeClass,
                      centerActive: this.centerActive,
                      dark: this.dark,
                      light: this.light,
                      mandatory: !this.optional,
                      mobileBreakpoint: this.mobileBreakpoint,
                      nextIcon: this.nextIcon,
                      prevIcon: this.prevIcon,
                      showArrows: this.showArrows,
                      value: this.internalValue
                    },
                    on: {
                      "call:slider": this.callSlider,
                      change: function change(val) {
                        _this2.internalValue = val;
                      }
                    },
                    ref: "items"
                  };
                  this.setTextColor(this.computedColor, data);
                  this.setBackgroundColor(this.backgroundColor, data);
                  return this.$createElement(_VTabsBar__WEBPACK_IMPORTED_MODULE_1__["default"], data, [this.genSlider(slider), items]);
                },
                genItems: function genItems(items, item) {
                  var _this2 = this;
                  if (items)
                    return items;
                  if (!item.length)
                    return null;
                  return this.$createElement(_VTabsItems__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    props: {
                      value: this.internalValue
                    },
                    on: {
                      change: function change(val) {
                        _this2.internalValue = val;
                      }
                    }
                  }, item);
                },
                genSlider: function genSlider(slider) {
                  if (this.hideSlider)
                    return null;
                  if (!slider) {
                    slider = this.$createElement(_VTabsSlider__WEBPACK_IMPORTED_MODULE_3__["default"], {
                      props: {
                        color: this.sliderColor
                      }
                    });
                  }
                  return this.$createElement("div", {
                    staticClass: "v-tabs-slider-wrapper",
                    style: this.sliderStyles
                  }, [slider]);
                },
                onResize: function onResize() {
                  if (this._isDestroyed)
                    return;
                  clearTimeout(this.resizeTimeout);
                  this.resizeTimeout = window.setTimeout(this.callSlider, 0);
                },
                parseNodes: function parseNodes() {
                  var items = null;
                  var slider = null;
                  var item = [];
                  var tab = [];
                  var slot = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getSlot"])(this) || [];
                  var length = slot.length;
                  for (var i2 = 0; i2 < length; i2++) {
                    var vnode = slot[i2];
                    if (vnode.componentOptions) {
                      switch (vnode.componentOptions.Ctor.options.name) {
                        case "v-tabs-slider":
                          slider = vnode;
                          break;
                        case "v-tabs-items":
                          items = vnode;
                          break;
                        case "v-tab-item":
                          item.push(vnode);
                          break;
                        default:
                          tab.push(vnode);
                      }
                    } else {
                      tab.push(vnode);
                    }
                  }
                  return {
                    tab,
                    slider,
                    items,
                    item
                  };
                }
              },
              render: function render8(h) {
                var _a2 = this.parseNodes(), tab = _a2.tab, slider = _a2.slider, items = _a2.items, item = _a2.item;
                return h("div", {
                  staticClass: "v-tabs",
                  class: this.classes,
                  directives: [{
                    name: "resize",
                    modifiers: {
                      quiet: true
                    },
                    value: this.onResize
                  }]
                }, [this.genBar(tab, slider), this.genItems(items, item)]);
              }
            });
          }
        ),
        /***/
        "./src/components/VTabs/VTabsBar.ts": (
          /*!******************************************!*\
            !*** ./src/components/VTabs/VTabsBar.ts ***!
            \******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VSlideGroup_VSlideGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../VSlideGroup/VSlideGroup */
              "./src/components/VSlideGroup/VSlideGroup.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/ssr-bootable */
              "./src/mixins/ssr-bootable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __values2 = function(o) {
              var s2 = typeof Symbol === "function" && Symbol.iterator, m = s2 && o[s2], i2 = 0;
              if (m)
                return m.call(o);
              if (o && typeof o.length === "number")
                return {
                  next: function next() {
                    if (o && i2 >= o.length)
                      o = void 0;
                    return {
                      value: o && o[i2++],
                      done: !o
                    };
                  }
                };
              throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(
              _VSlideGroup_VSlideGroup__WEBPACK_IMPORTED_MODULE_0__["BaseSlideGroup"],
              _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_2__["default"],
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"]
              /* @vue/component */
            ).extend({
              name: "v-tabs-bar",
              provide: function provide() {
                return {
                  tabsBar: this
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2(__assign2({}, _VSlideGroup_VSlideGroup__WEBPACK_IMPORTED_MODULE_0__["BaseSlideGroup"].options.computed.classes.call(this)), {
                    "v-tabs-bar": true,
                    "v-tabs-bar--is-mobile": this.isMobile,
                    // TODO: Remove this and move to v-slide-group
                    "v-tabs-bar--show-arrows": this.showArrows
                  }), this.themeClasses);
                }
              },
              watch: {
                items: "callSlider",
                internalValue: "callSlider",
                $route: "onRouteChange"
              },
              methods: {
                callSlider: function callSlider() {
                  if (!this.isBooted)
                    return;
                  this.$emit("call:slider");
                },
                genContent: function genContent() {
                  var render8 = _VSlideGroup_VSlideGroup__WEBPACK_IMPORTED_MODULE_0__["BaseSlideGroup"].options.methods.genContent.call(this);
                  render8.data = render8.data || {};
                  render8.data.staticClass += " v-tabs-bar__content";
                  return render8;
                },
                onRouteChange: function onRouteChange(val, oldVal) {
                  var e_1, _a2;
                  if (this.mandatory)
                    return;
                  var items = this.items;
                  var newPath = val.path;
                  var oldPath = oldVal.path;
                  var hasNew = false;
                  var hasOld = false;
                  try {
                    for (var items_1 = __values2(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                      var item = items_1_1.value;
                      if (item.to === oldPath)
                        hasOld = true;
                      else if (item.to === newPath)
                        hasNew = true;
                      if (hasNew && hasOld)
                        break;
                    }
                  } catch (e_1_1) {
                    e_1 = {
                      error: e_1_1
                    };
                  } finally {
                    try {
                      if (items_1_1 && !items_1_1.done && (_a2 = items_1.return))
                        _a2.call(items_1);
                    } finally {
                      if (e_1)
                        throw e_1.error;
                    }
                  }
                  if (!hasNew && hasOld)
                    this.internalValue = void 0;
                }
              },
              render: function render8(h) {
                var render9 = _VSlideGroup_VSlideGroup__WEBPACK_IMPORTED_MODULE_0__["BaseSlideGroup"].options.render.call(this, h);
                render9.data.attrs = {
                  role: "tablist"
                };
                return render9;
              }
            });
          }
        ),
        /***/
        "./src/components/VTabs/VTabsItems.ts": (
          /*!********************************************!*\
            !*** ./src/components/VTabs/VTabsItems.ts ***!
            \********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../VWindow/VWindow */
              "./src/components/VWindow/VWindow.ts"
            );
            var _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./../VItemGroup/VItemGroup */
              "./src/components/VItemGroup/VItemGroup.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
              name: "v-tabs-items",
              props: {
                mandatory: {
                  type: Boolean,
                  default: false
                }
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__["default"].options.computed.classes.call(this)), {
                    "v-tabs-items": true
                  });
                },
                isDark: function isDark() {
                  return this.rootIsDark;
                }
              },
              methods: {
                getValue: function getValue2(item, i2) {
                  return item.id || _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__["BaseItemGroup"].options.methods.getValue.call(this, item, i2);
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VTabs/VTabsSlider.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VTabs/VTabsSlider.ts ***!
            \*********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_0__["default"]).extend({
              name: "v-tabs-slider",
              render: function render8(h) {
                return h("div", this.setBackgroundColor(this.color, {
                  staticClass: "v-tabs-slider"
                }));
              }
            });
          }
        ),
        /***/
        "./src/components/VTabs/index.ts": (
          /*!***************************************!*\
            !*** ./src/components/VTabs/index.ts ***!
            \***************************************/
          /*! exports provided: VTabs, VTab, VTabItem, VTabsItems, VTabsSlider, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VTabs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VTabs */
              "./src/components/VTabs/VTabs.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTabs", function() {
              return _VTabs__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VTab__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VTab */
              "./src/components/VTabs/VTab.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTab", function() {
              return _VTab__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _VTabsItems__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VTabsItems */
              "./src/components/VTabs/VTabsItems.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTabsItems", function() {
              return _VTabsItems__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            var _VTabItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VTabItem */
              "./src/components/VTabs/VTabItem.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTabItem", function() {
              return _VTabItem__WEBPACK_IMPORTED_MODULE_3__["default"];
            });
            var _VTabsSlider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./VTabsSlider */
              "./src/components/VTabs/VTabsSlider.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTabsSlider", function() {
              return _VTabsSlider__WEBPACK_IMPORTED_MODULE_4__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VTabs: _VTabs__WEBPACK_IMPORTED_MODULE_0__["default"],
                VTab: _VTab__WEBPACK_IMPORTED_MODULE_1__["default"],
                VTabsItems: _VTabsItems__WEBPACK_IMPORTED_MODULE_2__["default"],
                VTabItem: _VTabItem__WEBPACK_IMPORTED_MODULE_3__["default"],
                VTabsSlider: _VTabsSlider__WEBPACK_IMPORTED_MODULE_4__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VTextField/VTextField.sass": (
          /*!***************************************************!*\
            !*** ./src/components/VTextField/VTextField.sass ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VTextField/VTextField.ts": (
          /*!*************************************************!*\
            !*** ./src/components/VTextField/VTextField.ts ***!
            \*************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VTextField.sass */
              "./src/components/VTextField/VTextField.sass"
            );
            var _VInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VInput */
              "./src/components/VInput/index.ts"
            );
            var _VCounter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VCounter */
              "./src/components/VCounter/index.ts"
            );
            var _VLabel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VLabel */
              "./src/components/VLabel/index.ts"
            );
            var _mixins_intersectable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/intersectable */
              "./src/mixins/intersectable/index.ts"
            );
            var _mixins_loadable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/loadable */
              "./src/mixins/loadable/index.ts"
            );
            var _mixins_validatable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../mixins/validatable */
              "./src/mixins/validatable/index.ts"
            );
            var _directives_resize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../directives/resize */
              "./src/directives/resize/index.ts"
            );
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var _util_dom__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ../../util/dom */
              "./src/util/dom.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __rest = function(s2, e) {
              var t3 = {};
              for (var p in s2) {
                if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
                  t3[p] = s2[p];
              }
              if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
                for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
                  if (e.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
                    t3[p[i2]] = s2[p[i2]];
                }
              return t3;
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_12__["default"])(_VInput__WEBPACK_IMPORTED_MODULE_1__["default"], Object(_mixins_intersectable__WEBPACK_IMPORTED_MODULE_4__["default"])({
              onVisible: ["onResize", "tryAutofocus"]
            }), _mixins_loadable__WEBPACK_IMPORTED_MODULE_5__["default"]);
            var dirtyTypes = ["color", "file", "time", "date", "datetime-local", "week", "month"];
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-text-field",
              directives: {
                resize: _directives_resize__WEBPACK_IMPORTED_MODULE_7__["default"],
                ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_8__["default"]
              },
              inheritAttrs: false,
              props: {
                appendOuterIcon: String,
                autofocus: Boolean,
                clearable: Boolean,
                clearIcon: {
                  type: String,
                  default: "$clear"
                },
                counter: [Boolean, Number, String],
                counterValue: Function,
                filled: Boolean,
                flat: Boolean,
                fullWidth: Boolean,
                label: String,
                outlined: Boolean,
                placeholder: String,
                prefix: String,
                prependInnerIcon: String,
                persistentPlaceholder: Boolean,
                reverse: Boolean,
                rounded: Boolean,
                shaped: Boolean,
                singleLine: Boolean,
                solo: Boolean,
                soloInverted: Boolean,
                suffix: String,
                type: {
                  type: String,
                  default: "text"
                }
              },
              data: function data() {
                return {
                  badInput: false,
                  labelWidth: 0,
                  prefixWidth: 0,
                  prependWidth: 0,
                  initialValue: null,
                  isBooted: false,
                  isClearing: false
                };
              },
              computed: {
                classes: function classes() {
                  return __assign2(__assign2({}, _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-text-field": true,
                    "v-text-field--full-width": this.fullWidth,
                    "v-text-field--prefix": this.prefix,
                    "v-text-field--single-line": this.isSingle,
                    "v-text-field--solo": this.isSolo,
                    "v-text-field--solo-inverted": this.soloInverted,
                    "v-text-field--solo-flat": this.flat,
                    "v-text-field--filled": this.filled,
                    "v-text-field--is-booted": this.isBooted,
                    "v-text-field--enclosed": this.isEnclosed,
                    "v-text-field--reverse": this.reverse,
                    "v-text-field--outlined": this.outlined,
                    "v-text-field--placeholder": this.placeholder,
                    "v-text-field--rounded": this.rounded,
                    "v-text-field--shaped": this.shaped
                  });
                },
                computedColor: function computedColor() {
                  var computedColor2 = _mixins_validatable__WEBPACK_IMPORTED_MODULE_6__["default"].options.computed.computedColor.call(this);
                  if (!this.soloInverted || !this.isFocused)
                    return computedColor2;
                  return this.color || "primary";
                },
                computedCounterValue: function computedCounterValue() {
                  if (typeof this.counterValue === "function") {
                    return this.counterValue(this.internalValue);
                  }
                  return __spreadArray2([], __read2((this.internalValue || "").toString()), false).length;
                },
                hasCounter: function hasCounter() {
                  return this.counter !== false && this.counter != null;
                },
                hasDetails: function hasDetails() {
                  return _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.hasDetails.call(this) || this.hasCounter;
                },
                internalValue: {
                  get: function get5() {
                    return this.lazyValue;
                  },
                  set: function set2(val) {
                    this.lazyValue = val;
                    this.$emit("input", this.lazyValue);
                  }
                },
                isDirty: function isDirty() {
                  var _a2;
                  return ((_a2 = this.lazyValue) === null || _a2 === void 0 ? void 0 : _a2.toString().length) > 0 || this.badInput;
                },
                isEnclosed: function isEnclosed() {
                  return this.filled || this.isSolo || this.outlined;
                },
                isLabelActive: function isLabelActive() {
                  return this.isDirty || dirtyTypes.includes(this.type);
                },
                isSingle: function isSingle() {
                  return this.isSolo || this.singleLine || this.fullWidth || // https://material.io/components/text-fields/#filled-text-field
                  this.filled && !this.hasLabel;
                },
                isSolo: function isSolo() {
                  return this.solo || this.soloInverted;
                },
                labelPosition: function labelPosition() {
                  var offset2 = this.prefix && !this.labelValue ? this.prefixWidth : 0;
                  if (this.labelValue && this.prependWidth)
                    offset2 -= this.prependWidth;
                  return this.$vuetify.rtl === this.reverse ? {
                    left: offset2,
                    right: "auto"
                  } : {
                    left: "auto",
                    right: offset2
                  };
                },
                showLabel: function showLabel() {
                  return this.hasLabel && !(this.isSingle && this.labelValue);
                },
                labelValue: function labelValue() {
                  return this.isFocused || this.isLabelActive || this.persistentPlaceholder;
                }
              },
              watch: {
                // labelValue: 'setLabelWidth', // moved to mounted, see #11533
                outlined: "setLabelWidth",
                label: function label() {
                  this.$nextTick(this.setLabelWidth);
                },
                prefix: function prefix() {
                  this.$nextTick(this.setPrefixWidth);
                },
                isFocused: "updateValue",
                value: function value(val) {
                  this.lazyValue = val;
                }
              },
              created: function created2() {
                if (this.$attrs.hasOwnProperty("box")) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_11__["breaking"])("box", "filled", this);
                }
                if (this.$attrs.hasOwnProperty("browser-autocomplete")) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_11__["breaking"])("browser-autocomplete", "autocomplete", this);
                }
                if (this.shaped && !(this.filled || this.outlined || this.isSolo)) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_11__["consoleWarn"])("shaped should be used with either filled or outlined", this);
                }
              },
              mounted: function mounted3() {
                var _this2 = this;
                this.$watch(function() {
                  return _this2.labelValue;
                }, this.setLabelWidth);
                this.autofocus && this.tryAutofocus();
                requestAnimationFrame(function() {
                  _this2.isBooted = true;
                  requestAnimationFrame(function() {
                    if (!_this2.isIntersecting) {
                      _this2.onResize();
                    }
                  });
                });
              },
              methods: {
                /** @public */
                focus: function focus() {
                  this.onFocus();
                },
                /** @public */
                blur: function blur(e) {
                  var _this2 = this;
                  window.requestAnimationFrame(function() {
                    _this2.$refs.input && _this2.$refs.input.blur();
                  });
                },
                clearableCallback: function clearableCallback() {
                  var _this2 = this;
                  this.$refs.input && this.$refs.input.focus();
                  this.$nextTick(function() {
                    return _this2.internalValue = null;
                  });
                },
                genAppendSlot: function genAppendSlot() {
                  var slot = [];
                  if (this.$slots["append-outer"]) {
                    slot.push(this.$slots["append-outer"]);
                  } else if (this.appendOuterIcon) {
                    slot.push(this.genIcon("appendOuter"));
                  }
                  return this.genSlot("append", "outer", slot);
                },
                genPrependInnerSlot: function genPrependInnerSlot() {
                  var slot = [];
                  if (this.$slots["prepend-inner"]) {
                    slot.push(this.$slots["prepend-inner"]);
                  } else if (this.prependInnerIcon) {
                    slot.push(this.genIcon("prependInner"));
                  }
                  return this.genSlot("prepend", "inner", slot);
                },
                genIconSlot: function genIconSlot() {
                  var slot = [];
                  if (this.$slots.append) {
                    slot.push(this.$slots.append);
                  } else if (this.appendIcon) {
                    slot.push(this.genIcon("append"));
                  }
                  return this.genSlot("append", "inner", slot);
                },
                genInputSlot: function genInputSlot() {
                  var input2 = _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genInputSlot.call(this);
                  var prepend2 = this.genPrependInnerSlot();
                  if (prepend2) {
                    input2.children = input2.children || [];
                    input2.children.unshift(prepend2);
                  }
                  return input2;
                },
                genClearIcon: function genClearIcon() {
                  if (!this.clearable)
                    return null;
                  if (!this.isDirty) {
                    return this.genSlot("append", "inner", [this.$createElement("div")]);
                  }
                  return this.genSlot("append", "inner", [this.genIcon("clear", this.clearableCallback)]);
                },
                genCounter: function genCounter() {
                  var _a2, _b2, _c;
                  if (!this.hasCounter)
                    return null;
                  var max2 = this.counter === true ? this.attrs$.maxlength : this.counter;
                  var props2 = {
                    dark: this.dark,
                    light: this.light,
                    max: max2,
                    value: this.computedCounterValue
                  };
                  return (_c = (_b2 = (_a2 = this.$scopedSlots).counter) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, {
                    props: props2
                  })) !== null && _c !== void 0 ? _c : this.$createElement(_VCounter__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    props: props2
                  });
                },
                genControl: function genControl() {
                  return _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genControl.call(this);
                },
                genDefaultSlot: function genDefaultSlot() {
                  return [this.genFieldset(), this.genTextFieldSlot(), this.genClearIcon(), this.genIconSlot(), this.genProgress()];
                },
                genFieldset: function genFieldset() {
                  if (!this.outlined)
                    return null;
                  return this.$createElement("fieldset", {
                    attrs: {
                      "aria-hidden": true
                    }
                  }, [this.genLegend()]);
                },
                genLabel: function genLabel() {
                  if (!this.showLabel)
                    return null;
                  var data = {
                    props: {
                      absolute: true,
                      color: this.validationState,
                      dark: this.dark,
                      disabled: this.isDisabled,
                      focused: !this.isSingle && (this.isFocused || !!this.validationState),
                      for: this.computedId,
                      left: this.labelPosition.left,
                      light: this.light,
                      right: this.labelPosition.right,
                      value: this.labelValue
                    }
                  };
                  return this.$createElement(_VLabel__WEBPACK_IMPORTED_MODULE_3__["default"], data, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_10__["getSlot"])(this, "label") || this.label);
                },
                genLegend: function genLegend() {
                  var width = !this.singleLine && (this.labelValue || this.isDirty) ? this.labelWidth : 0;
                  var span = this.$createElement("span", {
                    domProps: {
                      innerHTML: "&#8203;"
                    },
                    staticClass: "notranslate"
                  });
                  return this.$createElement("legend", {
                    style: {
                      width: !this.isSingle ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_10__["convertToUnit"])(width) : void 0
                    }
                  }, [span]);
                },
                genInput: function genInput() {
                  var listeners = Object.assign({}, this.listeners$);
                  delete listeners.change;
                  var _a2 = this.attrs$;
                  _a2.title;
                  var inputAttrs = __rest(_a2, ["title"]);
                  return this.$createElement("input", {
                    style: {},
                    domProps: {
                      value: this.type === "number" && Object.is(this.lazyValue, -0) ? "-0" : this.lazyValue
                    },
                    attrs: __assign2(__assign2({}, inputAttrs), {
                      autofocus: this.autofocus,
                      disabled: this.isDisabled,
                      id: this.computedId,
                      placeholder: this.persistentPlaceholder || this.isFocused || !this.hasLabel ? this.placeholder : void 0,
                      readonly: this.isReadonly,
                      type: this.type
                    }),
                    on: Object.assign(listeners, {
                      blur: this.onBlur,
                      input: this.onInput,
                      focus: this.onFocus,
                      keydown: this.onKeyDown
                    }),
                    ref: "input",
                    directives: [{
                      name: "resize",
                      modifiers: {
                        quiet: true
                      },
                      value: this.onResize
                    }]
                  });
                },
                genMessages: function genMessages() {
                  if (!this.showDetails)
                    return null;
                  var messagesNode = _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genMessages.call(this);
                  var counterNode = this.genCounter();
                  return this.$createElement("div", {
                    staticClass: "v-text-field__details"
                  }, [messagesNode, counterNode]);
                },
                genTextFieldSlot: function genTextFieldSlot() {
                  return this.$createElement("div", {
                    staticClass: "v-text-field__slot"
                  }, [this.genLabel(), this.prefix ? this.genAffix("prefix") : null, this.genInput(), this.suffix ? this.genAffix("suffix") : null]);
                },
                genAffix: function genAffix(type) {
                  return this.$createElement("div", {
                    class: "v-text-field__" + type,
                    ref: type
                  }, this[type]);
                },
                onBlur: function onBlur(e) {
                  var _this2 = this;
                  this.isFocused = false;
                  e && this.$nextTick(function() {
                    return _this2.$emit("blur", e);
                  });
                },
                onClick: function onClick() {
                  if (this.isFocused || this.isDisabled || !this.$refs.input)
                    return;
                  this.$refs.input.focus();
                },
                onFocus: function onFocus(e) {
                  if (!this.$refs.input)
                    return;
                  var root2 = Object(_util_dom__WEBPACK_IMPORTED_MODULE_9__["attachedRoot"])(this.$el);
                  if (!root2)
                    return;
                  if (root2.activeElement !== this.$refs.input) {
                    return this.$refs.input.focus();
                  }
                  if (!this.isFocused) {
                    this.isFocused = true;
                    e && this.$emit("focus", e);
                  }
                },
                onInput: function onInput(e) {
                  var target2 = e.target;
                  this.internalValue = target2.value;
                  this.badInput = target2.validity && target2.validity.badInput;
                },
                onKeyDown: function onKeyDown(e) {
                  if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_10__["keyCodes"].enter && this.lazyValue !== this.initialValue) {
                    this.initialValue = this.lazyValue;
                    this.$emit("change", this.initialValue);
                  }
                  this.$emit("keydown", e);
                },
                onMouseDown: function onMouseDown(e) {
                  if (e.target !== this.$refs.input) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                  _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onMouseDown.call(this, e);
                },
                onMouseUp: function onMouseUp(e) {
                  if (this.hasMouseDown)
                    this.focus();
                  _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onMouseUp.call(this, e);
                },
                setLabelWidth: function setLabelWidth() {
                  if (!this.outlined)
                    return;
                  this.labelWidth = this.$refs.label ? Math.min(this.$refs.label.scrollWidth * 0.75 + 6, this.$el.offsetWidth - 24) : 0;
                },
                setPrefixWidth: function setPrefixWidth() {
                  if (!this.$refs.prefix)
                    return;
                  this.prefixWidth = this.$refs.prefix.offsetWidth;
                },
                setPrependWidth: function setPrependWidth() {
                  if (!this.outlined || !this.$refs["prepend-inner"])
                    return;
                  this.prependWidth = this.$refs["prepend-inner"].offsetWidth;
                },
                tryAutofocus: function tryAutofocus() {
                  if (!this.autofocus || typeof document === "undefined" || !this.$refs.input)
                    return false;
                  var root2 = Object(_util_dom__WEBPACK_IMPORTED_MODULE_9__["attachedRoot"])(this.$el);
                  if (!root2 || root2.activeElement === this.$refs.input)
                    return false;
                  this.$refs.input.focus();
                  return true;
                },
                updateValue: function updateValue(val) {
                  this.hasColor = val;
                  if (val) {
                    this.initialValue = this.lazyValue;
                  } else if (this.initialValue !== this.lazyValue) {
                    this.$emit("change", this.lazyValue);
                  }
                },
                onResize: function onResize() {
                  this.setLabelWidth();
                  this.setPrefixWidth();
                  this.setPrependWidth();
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VTextField/index.ts": (
          /*!********************************************!*\
            !*** ./src/components/VTextField/index.ts ***!
            \********************************************/
          /*! exports provided: VTextField, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VTextField__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VTextField */
              "./src/components/VTextField/VTextField.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTextField", function() {
              return _VTextField__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VTextField__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VTextarea/VTextarea.sass": (
          /*!*************************************************!*\
            !*** ./src/components/VTextarea/VTextarea.sass ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VTextarea/VTextarea.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VTextarea/VTextarea.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VTextarea.sass */
              "./src/components/VTextarea/VTextarea.sass"
            );
            var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VTextField/VTextField */
              "./src/components/VTextField/VTextField.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"]);
            __webpack_exports__["default"] = baseMixins.extend({
              name: "v-textarea",
              props: {
                autoGrow: Boolean,
                noResize: Boolean,
                rowHeight: {
                  type: [Number, String],
                  default: 24,
                  validator: function validator2(v) {
                    return !isNaN(parseFloat(v));
                  }
                },
                rows: {
                  type: [Number, String],
                  default: 5,
                  validator: function validator2(v) {
                    return !isNaN(parseInt(v, 10));
                  }
                }
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-textarea": true,
                    "v-textarea--auto-grow": this.autoGrow,
                    "v-textarea--no-resize": this.noResizeHandle
                  }, _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this));
                },
                noResizeHandle: function noResizeHandle() {
                  return this.noResize || this.autoGrow;
                }
              },
              watch: {
                autoGrow: function autoGrow(val) {
                  var _this2 = this;
                  this.$nextTick(function() {
                    var _a2;
                    val ? _this2.calculateInputHeight() : (_a2 = _this2.$refs.input) === null || _a2 === void 0 ? void 0 : _a2.style.removeProperty("height");
                  });
                },
                lazyValue: function lazyValue() {
                  this.autoGrow && this.$nextTick(this.calculateInputHeight);
                },
                rowHeight: function rowHeight() {
                  this.autoGrow && this.$nextTick(this.calculateInputHeight);
                }
              },
              mounted: function mounted3() {
                var _this2 = this;
                setTimeout(function() {
                  _this2.autoGrow && _this2.calculateInputHeight();
                }, 0);
              },
              methods: {
                calculateInputHeight: function calculateInputHeight() {
                  var input2 = this.$refs.input;
                  if (!input2)
                    return;
                  input2.style.height = "0";
                  var height = input2.scrollHeight;
                  var minHeight = parseInt(this.rows, 10) * parseFloat(this.rowHeight);
                  input2.style.height = Math.max(minHeight, height) + "px";
                },
                genInput: function genInput() {
                  var input2 = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genInput.call(this);
                  input2.tag = "textarea";
                  delete input2.data.attrs.type;
                  input2.data.attrs.rows = this.rows;
                  return input2;
                },
                onInput: function onInput(e) {
                  _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.onInput.call(this, e);
                  this.autoGrow && this.calculateInputHeight();
                },
                onKeyDown: function onKeyDown(e) {
                  if (this.isFocused && e.keyCode === 13) {
                    e.stopPropagation();
                  }
                  this.$emit("keydown", e);
                }
              }
            });
          }
        ),
        /***/
        "./src/components/VTextarea/index.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VTextarea/index.ts ***!
            \*******************************************/
          /*! exports provided: VTextarea, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VTextarea__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VTextarea */
              "./src/components/VTextarea/VTextarea.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTextarea", function() {
              return _VTextarea__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VTextarea__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VThemeProvider/VThemeProvider.ts": (
          /*!*********************************************************!*\
            !*** ./src/components/VThemeProvider/VThemeProvider.ts ***!
            \*********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            __webpack_exports__["default"] = _mixins_themeable__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
              name: "v-theme-provider",
              props: {
                root: Boolean
              },
              computed: {
                isDark: function isDark() {
                  return this.root ? this.rootIsDark : _mixins_themeable__WEBPACK_IMPORTED_MODULE_0__["default"].options.computed.isDark.call(this);
                }
              },
              render: function render8() {
                return this.$slots.default && this.$slots.default.find(function(node2) {
                  return !node2.isComment && node2.text !== " ";
                });
              }
            });
          }
        ),
        /***/
        "./src/components/VThemeProvider/index.ts": (
          /*!************************************************!*\
            !*** ./src/components/VThemeProvider/index.ts ***!
            \************************************************/
          /*! exports provided: VThemeProvider, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VThemeProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VThemeProvider */
              "./src/components/VThemeProvider/VThemeProvider.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VThemeProvider", function() {
              return _VThemeProvider__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VThemeProvider__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VTimePicker/SelectingTimes.ts": (
          /*!******************************************************!*\
            !*** ./src/components/VTimePicker/SelectingTimes.ts ***!
            \******************************************************/
          /*! exports provided: SelectingTimes */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "SelectingTimes", function() {
              return SelectingTimes;
            });
            var SelectingTimes;
            (function(SelectingTimes2) {
              SelectingTimes2[SelectingTimes2["Hour"] = 1] = "Hour";
              SelectingTimes2[SelectingTimes2["Minute"] = 2] = "Minute";
              SelectingTimes2[SelectingTimes2["Second"] = 3] = "Second";
            })(SelectingTimes || (SelectingTimes = {}));
          }
        ),
        /***/
        "./src/components/VTimePicker/VTimePicker.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VTimePicker/VTimePicker.ts ***!
            \***************************************************/
          /*! exports provided: SelectingTimes, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VTimePickerTitle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VTimePickerTitle */
              "./src/components/VTimePicker/VTimePickerTitle.ts"
            );
            var _VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VTimePickerClock */
              "./src/components/VTimePicker/VTimePickerClock.ts"
            );
            var _mixins_picker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/picker */
              "./src/mixins/picker/index.ts"
            );
            var _mixins_picker_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/picker-button */
              "./src/mixins/picker-button/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../VDatePicker/util/pad */
              "./src/components/VDatePicker/util/pad.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ./SelectingTimes */
              "./src/components/VTimePicker/SelectingTimes.ts"
            );
            __webpack_require__.d(__webpack_exports__, "SelectingTimes", function() {
              return _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"];
            });
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var rangeHours24 = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["createRange"])(24);
            var rangeHours12am = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["createRange"])(12);
            var rangeHours12pm = rangeHours12am.map(function(v) {
              return v + 12;
            });
            var range60 = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["createRange"])(60);
            var selectingNames = {
              1: "hour",
              2: "minute",
              3: "second"
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__["default"])(
              _mixins_picker__WEBPACK_IMPORTED_MODULE_2__["default"],
              _mixins_picker_button__WEBPACK_IMPORTED_MODULE_3__["default"]
              /* @vue/component */
            ).extend({
              name: "v-time-picker",
              props: {
                activePicker: String,
                allowedHours: [Function, Array],
                allowedMinutes: [Function, Array],
                allowedSeconds: [Function, Array],
                disabled: Boolean,
                format: {
                  type: String,
                  default: "ampm",
                  validator: function validator2(val) {
                    return ["ampm", "24hr"].includes(val);
                  }
                },
                min: String,
                max: String,
                readonly: Boolean,
                scrollable: Boolean,
                useSeconds: Boolean,
                value: null,
                ampmInTitle: Boolean
              },
              data: function data() {
                return {
                  inputHour: null,
                  inputMinute: null,
                  inputSecond: null,
                  lazyInputHour: null,
                  lazyInputMinute: null,
                  lazyInputSecond: null,
                  period: "am",
                  selecting: _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour
                };
              },
              computed: {
                selectingHour: {
                  get: function get5() {
                    return this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour;
                  },
                  set: function set2(v) {
                    this.selecting = _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour;
                  }
                },
                selectingMinute: {
                  get: function get5() {
                    return this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Minute;
                  },
                  set: function set2(v) {
                    this.selecting = _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Minute;
                  }
                },
                selectingSecond: {
                  get: function get5() {
                    return this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Second;
                  },
                  set: function set2(v) {
                    this.selecting = _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Second;
                  }
                },
                isAllowedHourCb: function isAllowedHourCb() {
                  var _this2 = this;
                  var cb;
                  if (this.allowedHours instanceof Array) {
                    cb = function cb2(val) {
                      return _this2.allowedHours.includes(val);
                    };
                  } else {
                    cb = this.allowedHours;
                  }
                  if (!this.min && !this.max)
                    return cb;
                  var minHour = this.min ? Number(this.min.split(":")[0]) : 0;
                  var maxHour = this.max ? Number(this.max.split(":")[0]) : 23;
                  return function(val) {
                    return val >= minHour * 1 && val <= maxHour * 1 && (!cb || cb(val));
                  };
                },
                isAllowedMinuteCb: function isAllowedMinuteCb() {
                  var _this2 = this;
                  var cb;
                  var isHourAllowed = !this.isAllowedHourCb || this.inputHour === null || this.isAllowedHourCb(this.inputHour);
                  if (this.allowedMinutes instanceof Array) {
                    cb = function cb2(val) {
                      return _this2.allowedMinutes.includes(val);
                    };
                  } else {
                    cb = this.allowedMinutes;
                  }
                  if (!this.min && !this.max) {
                    return isHourAllowed ? cb : function() {
                      return false;
                    };
                  }
                  var _a2 = __read2(this.min ? this.min.split(":").map(Number) : [0, 0], 2), minHour = _a2[0], minMinute = _a2[1];
                  var _b2 = __read2(this.max ? this.max.split(":").map(Number) : [23, 59], 2), maxHour = _b2[0], maxMinute = _b2[1];
                  var minTime = minHour * 60 + minMinute * 1;
                  var maxTime = maxHour * 60 + maxMinute * 1;
                  return function(val) {
                    var time = 60 * _this2.inputHour + val;
                    return time >= minTime && time <= maxTime && isHourAllowed && (!cb || cb(val));
                  };
                },
                isAllowedSecondCb: function isAllowedSecondCb() {
                  var _this2 = this;
                  var cb;
                  var isHourAllowed = !this.isAllowedHourCb || this.inputHour === null || this.isAllowedHourCb(this.inputHour);
                  var isMinuteAllowed = isHourAllowed && (!this.isAllowedMinuteCb || this.inputMinute === null || this.isAllowedMinuteCb(this.inputMinute));
                  if (this.allowedSeconds instanceof Array) {
                    cb = function cb2(val) {
                      return _this2.allowedSeconds.includes(val);
                    };
                  } else {
                    cb = this.allowedSeconds;
                  }
                  if (!this.min && !this.max) {
                    return isMinuteAllowed ? cb : function() {
                      return false;
                    };
                  }
                  var _a2 = __read2(this.min ? this.min.split(":").map(Number) : [0, 0, 0], 3), minHour = _a2[0], minMinute = _a2[1], minSecond = _a2[2];
                  var _b2 = __read2(this.max ? this.max.split(":").map(Number) : [23, 59, 59], 3), maxHour = _b2[0], maxMinute = _b2[1], maxSecond = _b2[2];
                  var minTime = minHour * 3600 + minMinute * 60 + (minSecond || 0) * 1;
                  var maxTime = maxHour * 3600 + maxMinute * 60 + (maxSecond || 0) * 1;
                  return function(val) {
                    var time = 3600 * _this2.inputHour + 60 * _this2.inputMinute + val;
                    return time >= minTime && time <= maxTime && isMinuteAllowed && (!cb || cb(val));
                  };
                },
                isAmPm: function isAmPm() {
                  return this.format === "ampm";
                }
              },
              watch: {
                activePicker: "setPicker",
                selecting: "emitPicker",
                value: "setInputData"
              },
              mounted: function mounted3() {
                this.setInputData(this.value);
                this.$on("update:period", this.setPeriod);
              },
              methods: {
                genValue: function genValue() {
                  if (this.inputHour != null && this.inputMinute != null && (!this.useSeconds || this.inputSecond != null)) {
                    return Object(_VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_5__["default"])(this.inputHour) + ":" + Object(_VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_5__["default"])(this.inputMinute) + (this.useSeconds ? ":" + Object(_VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_5__["default"])(this.inputSecond) : "");
                  }
                  return null;
                },
                emitValue: function emitValue() {
                  var value = this.genValue();
                  if (value !== null)
                    this.$emit("input", value);
                },
                emitPicker: function emitPicker(value) {
                  var activePicker = "HOUR";
                  if (value === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Minute) {
                    activePicker = "MINUTE";
                  } else if (value === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Second) {
                    activePicker = "SECOND";
                  }
                  this.$emit("update:active-picker", activePicker);
                },
                setPicker: function setPicker(picker) {
                  if (picker === "HOUR")
                    this.selecting = _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour;
                  else if (picker === "MINUTE")
                    this.selecting = _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Minute;
                  else if (picker === "SECOND" && this.useSeconds)
                    this.selecting = _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Second;
                },
                setPeriod: function setPeriod(period) {
                  this.period = period;
                  if (this.inputHour != null) {
                    var newHour = this.inputHour + (period === "am" ? -12 : 12);
                    this.inputHour = this.firstAllowed("hour", newHour);
                    this.emitValue();
                  }
                },
                setInputData: function setInputData(value) {
                  if (value == null || value === "") {
                    this.inputHour = null;
                    this.inputMinute = null;
                    this.inputSecond = null;
                  } else if (value instanceof Date) {
                    this.inputHour = value.getHours();
                    this.inputMinute = value.getMinutes();
                    this.inputSecond = value.getSeconds();
                  } else {
                    var _a2 = __read2(value.trim().toLowerCase().match(/^(\d+):(\d+)(:(\d+))?([ap]m)?$/) || new Array(6), 6), hour = _a2[1], minute = _a2[2], second = _a2[4], period = _a2[5];
                    this.inputHour = period ? this.convert12to24(parseInt(hour, 10), period) : parseInt(hour, 10);
                    this.inputMinute = parseInt(minute, 10);
                    this.inputSecond = parseInt(second || 0, 10);
                  }
                  this.period = this.inputHour == null || this.inputHour < 12 ? "am" : "pm";
                },
                convert24to12: function convert24to12(hour) {
                  return hour ? (hour - 1) % 12 + 1 : 12;
                },
                convert12to24: function convert12to24(hour, period) {
                  return hour % 12 + (period === "pm" ? 12 : 0);
                },
                onInput: function onInput(value) {
                  if (this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour) {
                    this.inputHour = this.isAmPm ? this.convert12to24(value, this.period) : value;
                  } else if (this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Minute) {
                    this.inputMinute = value;
                  } else {
                    this.inputSecond = value;
                  }
                  this.emitValue();
                },
                onChange: function onChange(value) {
                  this.$emit("click:" + selectingNames[this.selecting], value);
                  var emitChange = this.selecting === (this.useSeconds ? _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Second : _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Minute);
                  if (this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour) {
                    this.selecting = _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Minute;
                  } else if (this.useSeconds && this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Minute) {
                    this.selecting = _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Second;
                  }
                  if (this.inputHour === this.lazyInputHour && this.inputMinute === this.lazyInputMinute && (!this.useSeconds || this.inputSecond === this.lazyInputSecond))
                    return;
                  var time = this.genValue();
                  if (time === null)
                    return;
                  this.lazyInputHour = this.inputHour;
                  this.lazyInputMinute = this.inputMinute;
                  this.useSeconds && (this.lazyInputSecond = this.inputSecond);
                  emitChange && this.$emit("change", time);
                },
                firstAllowed: function firstAllowed(type, value) {
                  var allowedFn = type === "hour" ? this.isAllowedHourCb : type === "minute" ? this.isAllowedMinuteCb : this.isAllowedSecondCb;
                  if (!allowedFn)
                    return value;
                  var range = type === "minute" ? range60 : type === "second" ? range60 : this.isAmPm ? value < 12 ? rangeHours12am : rangeHours12pm : rangeHours24;
                  var first = range.find(function(v) {
                    return allowedFn((v + value) % range.length + range[0]);
                  });
                  return ((first || 0) + value) % range.length + range[0];
                },
                genClock: function genClock() {
                  return this.$createElement(_VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: {
                      allowedValues: this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour ? this.isAllowedHourCb : this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Minute ? this.isAllowedMinuteCb : this.isAllowedSecondCb,
                      color: this.color,
                      dark: this.dark,
                      disabled: this.disabled,
                      double: this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour && !this.isAmPm,
                      format: this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour ? this.isAmPm ? this.convert24to12 : function(val) {
                        return val;
                      } : function(val) {
                        return Object(_VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_5__["default"])(val, 2);
                      },
                      light: this.light,
                      max: this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour ? this.isAmPm && this.period === "am" ? 11 : 23 : 59,
                      min: this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour && this.isAmPm && this.period === "pm" ? 12 : 0,
                      readonly: this.readonly,
                      scrollable: this.scrollable,
                      size: Number(this.width) - (!this.fullWidth && this.landscape ? 80 : 20),
                      step: this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour ? 1 : 5,
                      value: this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Hour ? this.inputHour : this.selecting === _SelectingTimes__WEBPACK_IMPORTED_MODULE_7__["SelectingTimes"].Minute ? this.inputMinute : this.inputSecond
                    },
                    on: {
                      input: this.onInput,
                      change: this.onChange
                    },
                    ref: "clock"
                  });
                },
                genClockAmPm: function genClockAmPm() {
                  return this.$createElement("div", this.setTextColor(this.color || "primary", {
                    staticClass: "v-time-picker-clock__ampm"
                  }), [this.genPickerButton("period", "am", this.$vuetify.lang.t("$vuetify.timePicker.am"), this.disabled || this.readonly), this.genPickerButton("period", "pm", this.$vuetify.lang.t("$vuetify.timePicker.pm"), this.disabled || this.readonly)]);
                },
                genPickerBody: function genPickerBody() {
                  return this.$createElement("div", {
                    staticClass: "v-time-picker-clock__container",
                    key: this.selecting
                  }, [!this.ampmInTitle && this.isAmPm && this.genClockAmPm(), this.genClock()]);
                },
                genPickerTitle: function genPickerTitle() {
                  var _this2 = this;
                  return this.$createElement(_VTimePickerTitle__WEBPACK_IMPORTED_MODULE_0__["default"], {
                    props: {
                      ampm: this.isAmPm,
                      ampmReadonly: this.isAmPm && !this.ampmInTitle,
                      disabled: this.disabled,
                      hour: this.inputHour,
                      minute: this.inputMinute,
                      second: this.inputSecond,
                      period: this.period,
                      readonly: this.readonly,
                      useSeconds: this.useSeconds,
                      selecting: this.selecting
                    },
                    on: {
                      "update:selecting": function updateSelecting(value) {
                        return _this2.selecting = value;
                      },
                      "update:period": function updatePeriod(period) {
                        return _this2.$emit("update:period", period);
                      }
                    },
                    ref: "title",
                    slot: "title"
                  });
                }
              },
              render: function render8() {
                return this.genPicker("v-picker--time");
              }
            });
          }
        ),
        /***/
        "./src/components/VTimePicker/VTimePickerClock.sass": (
          /*!**********************************************************!*\
            !*** ./src/components/VTimePicker/VTimePickerClock.sass ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VTimePicker/VTimePickerClock.ts": (
          /*!********************************************************!*\
            !*** ./src/components/VTimePicker/VTimePickerClock.ts ***!
            \********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VTimePickerClock.sass */
              "./src/components/VTimePicker/VTimePickerClock.sass"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(
              _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"],
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
              /* @vue/component */
            ).extend({
              name: "v-time-picker-clock",
              props: {
                allowedValues: Function,
                ampm: Boolean,
                disabled: Boolean,
                double: Boolean,
                format: {
                  type: Function,
                  default: function _default(val) {
                    return val;
                  }
                },
                max: {
                  type: Number,
                  required: true
                },
                min: {
                  type: Number,
                  required: true
                },
                scrollable: Boolean,
                readonly: Boolean,
                rotate: {
                  type: Number,
                  default: 0
                },
                step: {
                  type: Number,
                  default: 1
                },
                value: Number
              },
              data: function data() {
                return {
                  inputValue: this.value,
                  isDragging: false,
                  valueOnMouseDown: null,
                  valueOnMouseUp: null
                };
              },
              computed: {
                count: function count() {
                  return this.max - this.min + 1;
                },
                degreesPerUnit: function degreesPerUnit() {
                  return 360 / this.roundCount;
                },
                degrees: function degrees() {
                  return this.degreesPerUnit * Math.PI / 180;
                },
                displayedValue: function displayedValue() {
                  return this.value == null ? this.min : this.value;
                },
                innerRadiusScale: function innerRadiusScale() {
                  return 0.62;
                },
                roundCount: function roundCount() {
                  return this.double ? this.count / 2 : this.count;
                }
              },
              watch: {
                value: function value(_value) {
                  this.inputValue = _value;
                }
              },
              methods: {
                wheel: function wheel(e) {
                  e.preventDefault();
                  var delta = Math.sign(-e.deltaY || 1);
                  var value = this.displayedValue;
                  do {
                    value = value + delta;
                    value = (value - this.min + this.count) % this.count + this.min;
                  } while (!this.isAllowed(value) && value !== this.displayedValue);
                  if (value !== this.displayedValue) {
                    this.update(value);
                  }
                },
                isInner: function isInner(value) {
                  return this.double && value - this.min >= this.roundCount;
                },
                handScale: function handScale(value) {
                  return this.isInner(value) ? this.innerRadiusScale : 1;
                },
                isAllowed: function isAllowed(value) {
                  return !this.allowedValues || this.allowedValues(value);
                },
                genValues: function genValues() {
                  var children = [];
                  for (var value = this.min; value <= this.max; value = value + this.step) {
                    var color2 = value === this.value && (this.color || "accent");
                    children.push(this.$createElement("span", this.setBackgroundColor(color2, {
                      staticClass: "v-time-picker-clock__item",
                      class: {
                        "v-time-picker-clock__item--active": value === this.displayedValue,
                        "v-time-picker-clock__item--disabled": this.disabled || !this.isAllowed(value)
                      },
                      style: this.getTransform(value),
                      domProps: {
                        innerHTML: "<span>" + this.format(value) + "</span>"
                      }
                    })));
                  }
                  return children;
                },
                genHand: function genHand() {
                  var scale = "scaleY(" + this.handScale(this.displayedValue) + ")";
                  var angle = this.rotate + this.degreesPerUnit * (this.displayedValue - this.min);
                  var color2 = this.value != null && (this.color || "accent");
                  return this.$createElement("div", this.setBackgroundColor(color2, {
                    staticClass: "v-time-picker-clock__hand",
                    class: {
                      "v-time-picker-clock__hand--inner": this.isInner(this.value)
                    },
                    style: {
                      transform: "rotate(" + angle + "deg) " + scale
                    }
                  }));
                },
                getTransform: function getTransform(i2) {
                  var _a2 = this.getPosition(i2), x2 = _a2.x, y = _a2.y;
                  return {
                    left: 50 + x2 * 50 + "%",
                    top: 50 + y * 50 + "%"
                  };
                },
                getPosition: function getPosition(value) {
                  var rotateRadians = this.rotate * Math.PI / 180;
                  return {
                    x: Math.sin((value - this.min) * this.degrees + rotateRadians) * this.handScale(value),
                    y: -Math.cos((value - this.min) * this.degrees + rotateRadians) * this.handScale(value)
                  };
                },
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  this.valueOnMouseDown = null;
                  this.valueOnMouseUp = null;
                  this.isDragging = true;
                  this.onDragMove(e);
                },
                onMouseUp: function onMouseUp(e) {
                  e.stopPropagation();
                  this.isDragging = false;
                  if (this.valueOnMouseUp !== null && this.isAllowed(this.valueOnMouseUp)) {
                    this.$emit("change", this.valueOnMouseUp);
                  }
                },
                onDragMove: function onDragMove(e) {
                  e.preventDefault();
                  if (!this.isDragging && e.type !== "click" || !this.$refs.clock)
                    return;
                  var _a2 = this.$refs.clock.getBoundingClientRect(), width = _a2.width, top = _a2.top, left = _a2.left;
                  var innerWidth = this.$refs.innerClock.getBoundingClientRect().width;
                  var _b2 = "touches" in e ? e.touches[0] : e, clientX = _b2.clientX, clientY = _b2.clientY;
                  var center = {
                    x: width / 2,
                    y: -width / 2
                  };
                  var coords = {
                    x: clientX - left,
                    y: top - clientY
                  };
                  var handAngle = Math.round(this.angle(center, coords) - this.rotate + 360) % 360;
                  var insideClick = this.double && this.euclidean(center, coords) < (innerWidth + innerWidth * this.innerRadiusScale) / 4;
                  var checksCount = Math.ceil(15 / this.degreesPerUnit);
                  var value;
                  for (var i2 = 0; i2 < checksCount; i2++) {
                    value = this.angleToValue(handAngle + i2 * this.degreesPerUnit, insideClick);
                    if (this.isAllowed(value))
                      return this.setMouseDownValue(value);
                    value = this.angleToValue(handAngle - i2 * this.degreesPerUnit, insideClick);
                    if (this.isAllowed(value))
                      return this.setMouseDownValue(value);
                  }
                },
                angleToValue: function angleToValue(angle, insideClick) {
                  var value = (Math.round(angle / this.degreesPerUnit) + (insideClick ? this.roundCount : 0)) % this.count + this.min;
                  if (angle < 360 - this.degreesPerUnit / 2)
                    return value;
                  return insideClick ? this.max - this.roundCount + 1 : this.min;
                },
                setMouseDownValue: function setMouseDownValue(value) {
                  if (this.valueOnMouseDown === null) {
                    this.valueOnMouseDown = value;
                  }
                  this.valueOnMouseUp = value;
                  this.update(value);
                },
                update: function update5(value) {
                  if (this.inputValue !== value) {
                    this.inputValue = value;
                    this.$emit("input", value);
                  }
                },
                euclidean: function euclidean(p0, p1) {
                  var dx = p1.x - p0.x;
                  var dy = p1.y - p0.y;
                  return Math.sqrt(dx * dx + dy * dy);
                },
                angle: function angle(center, p1) {
                  var value = 2 * Math.atan2(p1.y - center.y - this.euclidean(center, p1), p1.x - center.x);
                  return Math.abs(value * 180 / Math.PI);
                }
              },
              render: function render8(h) {
                var _this2 = this;
                var data = {
                  staticClass: "v-time-picker-clock",
                  class: __assign2({
                    "v-time-picker-clock--indeterminate": this.value == null
                  }, this.themeClasses),
                  on: this.readonly || this.disabled ? void 0 : {
                    mousedown: this.onMouseDown,
                    mouseup: this.onMouseUp,
                    mouseleave: function mouseleave(e) {
                      return _this2.isDragging && _this2.onMouseUp(e);
                    },
                    touchstart: this.onMouseDown,
                    touchend: this.onMouseUp,
                    mousemove: this.onDragMove,
                    touchmove: this.onDragMove
                  },
                  ref: "clock"
                };
                if (this.scrollable && data.on) {
                  data.on.wheel = this.wheel;
                }
                return h("div", data, [h("div", {
                  staticClass: "v-time-picker-clock__inner",
                  ref: "innerClock"
                }, [this.genHand(), this.genValues()])]);
              }
            });
          }
        ),
        /***/
        "./src/components/VTimePicker/VTimePickerTitle.sass": (
          /*!**********************************************************!*\
            !*** ./src/components/VTimePicker/VTimePickerTitle.sass ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VTimePicker/VTimePickerTitle.ts": (
          /*!********************************************************!*\
            !*** ./src/components/VTimePicker/VTimePickerTitle.ts ***!
            \********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VTimePickerTitle.sass */
              "./src/components/VTimePicker/VTimePickerTitle.sass"
            );
            var _mixins_picker_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/picker-button */
              "./src/mixins/picker-button/index.ts"
            );
            var _VDatePicker_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VDatePicker/util */
              "./src/components/VDatePicker/util/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _SelectingTimes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./SelectingTimes */
              "./src/components/VTimePicker/SelectingTimes.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(
              _mixins_picker_button__WEBPACK_IMPORTED_MODULE_1__["default"]
              /* @vue/component */
            ).extend({
              name: "v-time-picker-title",
              props: {
                ampm: Boolean,
                ampmReadonly: Boolean,
                disabled: Boolean,
                hour: Number,
                minute: Number,
                second: Number,
                period: {
                  type: String,
                  validator: function validator2(period) {
                    return period === "am" || period === "pm";
                  }
                },
                readonly: Boolean,
                useSeconds: Boolean,
                selecting: Number
              },
              methods: {
                genTime: function genTime() {
                  var hour = this.hour;
                  if (this.ampm) {
                    hour = hour ? (hour - 1) % 12 + 1 : 12;
                  }
                  var displayedHour = this.hour == null ? "--" : this.ampm ? String(hour) : Object(_VDatePicker_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(hour);
                  var displayedMinute = this.minute == null ? "--" : Object(_VDatePicker_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(this.minute);
                  var titleContent = [this.genPickerButton("selecting", _SelectingTimes__WEBPACK_IMPORTED_MODULE_4__["SelectingTimes"].Hour, displayedHour, this.disabled), this.$createElement("span", ":"), this.genPickerButton("selecting", _SelectingTimes__WEBPACK_IMPORTED_MODULE_4__["SelectingTimes"].Minute, displayedMinute, this.disabled)];
                  if (this.useSeconds) {
                    var displayedSecond = this.second == null ? "--" : Object(_VDatePicker_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(this.second);
                    titleContent.push(this.$createElement("span", ":"));
                    titleContent.push(this.genPickerButton("selecting", _SelectingTimes__WEBPACK_IMPORTED_MODULE_4__["SelectingTimes"].Second, displayedSecond, this.disabled));
                  }
                  return this.$createElement("div", {
                    class: "v-time-picker-title__time"
                  }, titleContent);
                },
                genAmPm: function genAmPm() {
                  return this.$createElement("div", {
                    staticClass: "v-time-picker-title__ampm",
                    class: {
                      "v-time-picker-title__ampm--readonly": this.ampmReadonly
                    }
                  }, [!this.ampmReadonly || this.period === "am" ? this.genPickerButton("period", "am", this.$vuetify.lang.t("$vuetify.timePicker.am"), this.disabled || this.readonly) : null, !this.ampmReadonly || this.period === "pm" ? this.genPickerButton("period", "pm", this.$vuetify.lang.t("$vuetify.timePicker.pm"), this.disabled || this.readonly) : null]);
                }
              },
              render: function render8(h) {
                var children = [this.genTime()];
                this.ampm && children.push(this.genAmPm());
                return h("div", {
                  staticClass: "v-time-picker-title"
                }, children);
              }
            });
          }
        ),
        /***/
        "./src/components/VTimePicker/index.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VTimePicker/index.ts ***!
            \*********************************************/
          /*! exports provided: VTimePicker, VTimePickerClock, VTimePickerTitle, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VTimePicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VTimePicker */
              "./src/components/VTimePicker/VTimePicker.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTimePicker", function() {
              return _VTimePicker__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VTimePickerClock */
              "./src/components/VTimePicker/VTimePickerClock.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTimePickerClock", function() {
              return _VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _VTimePickerTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VTimePickerTitle */
              "./src/components/VTimePicker/VTimePickerTitle.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTimePickerTitle", function() {
              return _VTimePickerTitle__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VTimePicker: _VTimePicker__WEBPACK_IMPORTED_MODULE_0__["default"],
                VTimePickerClock: _VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__["default"],
                VTimePickerTitle: _VTimePickerTitle__WEBPACK_IMPORTED_MODULE_2__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VTimeline/VTimeline.sass": (
          /*!*************************************************!*\
            !*** ./src/components/VTimeline/VTimeline.sass ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VTimeline/VTimeline.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VTimeline/VTimeline.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VTimeline.sass */
              "./src/components/VTimeline/VTimeline.sass"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
              /* @vue/component */
            ).extend({
              name: "v-timeline",
              provide: function provide() {
                return {
                  timeline: this
                };
              },
              props: {
                alignTop: Boolean,
                dense: Boolean,
                reverse: Boolean
              },
              computed: {
                classes: function classes() {
                  return __assign2({
                    "v-timeline--align-top": this.alignTop,
                    "v-timeline--dense": this.dense,
                    "v-timeline--reverse": this.reverse
                  }, this.themeClasses);
                }
              },
              render: function render8(h) {
                return h("div", {
                  staticClass: "v-timeline",
                  class: this.classes
                }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this));
              }
            });
          }
        ),
        /***/
        "./src/components/VTimeline/VTimelineItem.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VTimeline/VTimelineItem.ts ***!
            \***************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _util_mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_0__["default"])(
              _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"],
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
              /* @vue/component */
            );
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "v-timeline-item",
              inject: ["timeline"],
              props: {
                color: {
                  type: String,
                  default: "primary"
                },
                fillDot: Boolean,
                hideDot: Boolean,
                icon: String,
                iconColor: String,
                large: Boolean,
                left: Boolean,
                right: Boolean,
                small: Boolean
              },
              computed: {
                hasIcon: function hasIcon() {
                  return !!this.icon || !!this.$slots.icon;
                }
              },
              methods: {
                genBody: function genBody() {
                  return this.$createElement("div", {
                    staticClass: "v-timeline-item__body"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getSlot"])(this));
                },
                genIcon: function genIcon() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getSlot"])(this, "icon") || this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: {
                      color: this.iconColor,
                      dark: !this.theme.isDark,
                      small: this.small
                    }
                  }, this.icon);
                },
                genInnerDot: function genInnerDot() {
                  var data = this.setBackgroundColor(this.color);
                  return this.$createElement("div", __assign2({
                    staticClass: "v-timeline-item__inner-dot"
                  }, data), [this.hasIcon && this.genIcon()]);
                },
                genDot: function genDot() {
                  return this.$createElement("div", {
                    staticClass: "v-timeline-item__dot",
                    class: {
                      "v-timeline-item__dot--small": this.small,
                      "v-timeline-item__dot--large": this.large
                    }
                  }, [this.genInnerDot()]);
                },
                genDivider: function genDivider() {
                  var children = [];
                  if (!this.hideDot)
                    children.push(this.genDot());
                  return this.$createElement("div", {
                    staticClass: "v-timeline-item__divider"
                  }, children);
                },
                genOpposite: function genOpposite() {
                  return this.$createElement("div", {
                    staticClass: "v-timeline-item__opposite"
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getSlot"])(this, "opposite"));
                }
              },
              render: function render8(h) {
                var children = [this.genBody(), this.genDivider()];
                if (this.$slots.opposite)
                  children.push(this.genOpposite());
                return h("div", {
                  staticClass: "v-timeline-item",
                  class: __assign2({
                    "v-timeline-item--fill-dot": this.fillDot,
                    "v-timeline-item--before": this.timeline.reverse ? this.right : this.left,
                    "v-timeline-item--after": this.timeline.reverse ? this.left : this.right
                  }, this.themeClasses)
                }, children);
              }
            });
          }
        ),
        /***/
        "./src/components/VTimeline/index.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VTimeline/index.ts ***!
            \*******************************************/
          /*! exports provided: VTimeline, VTimelineItem, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VTimeline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VTimeline */
              "./src/components/VTimeline/VTimeline.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTimeline", function() {
              return _VTimeline__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VTimelineItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VTimelineItem */
              "./src/components/VTimeline/VTimelineItem.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTimelineItem", function() {
              return _VTimelineItem__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VTimeline: _VTimeline__WEBPACK_IMPORTED_MODULE_0__["default"],
                VTimelineItem: _VTimelineItem__WEBPACK_IMPORTED_MODULE_1__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VToolbar/VToolbar.sass": (
          /*!***********************************************!*\
            !*** ./src/components/VToolbar/VToolbar.sass ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VToolbar/VToolbar.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VToolbar/VToolbar.ts ***!
            \*********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VToolbar.sass */
              "./src/components/VToolbar/VToolbar.sass"
            );
            var _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VSheet/VSheet */
              "./src/components/VSheet/VSheet.ts"
            );
            var _VImg_VImg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VImg/VImg */
              "./src/components/VImg/VImg.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            __webpack_exports__["default"] = _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
              name: "v-toolbar",
              props: {
                absolute: Boolean,
                bottom: Boolean,
                collapse: Boolean,
                dense: Boolean,
                extended: Boolean,
                extensionHeight: {
                  default: 48,
                  type: [Number, String]
                },
                flat: Boolean,
                floating: Boolean,
                prominent: Boolean,
                short: Boolean,
                src: {
                  type: [String, Object],
                  default: ""
                },
                tag: {
                  type: String,
                  default: "header"
                }
              },
              data: function data() {
                return {
                  isExtended: false
                };
              },
              computed: {
                computedHeight: function computedHeight() {
                  var height = this.computedContentHeight;
                  if (!this.isExtended)
                    return height;
                  var extensionHeight = parseInt(this.extensionHeight);
                  return this.isCollapsed ? height : height + (!isNaN(extensionHeight) ? extensionHeight : 0);
                },
                computedContentHeight: function computedContentHeight() {
                  if (this.height)
                    return parseInt(this.height);
                  if (this.isProminent && this.dense)
                    return 96;
                  if (this.isProminent && this.short)
                    return 112;
                  if (this.isProminent)
                    return 128;
                  if (this.dense)
                    return 48;
                  if (this.short || this.$vuetify.breakpoint.smAndDown)
                    return 56;
                  return 64;
                },
                classes: function classes() {
                  return __assign2(__assign2({}, _VSheet_VSheet__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this)), {
                    "v-toolbar": true,
                    "v-toolbar--absolute": this.absolute,
                    "v-toolbar--bottom": this.bottom,
                    "v-toolbar--collapse": this.collapse,
                    "v-toolbar--collapsed": this.isCollapsed,
                    "v-toolbar--dense": this.dense,
                    "v-toolbar--extended": this.isExtended,
                    "v-toolbar--flat": this.flat,
                    "v-toolbar--floating": this.floating,
                    "v-toolbar--prominent": this.isProminent
                  });
                },
                isCollapsed: function isCollapsed() {
                  return this.collapse;
                },
                isProminent: function isProminent() {
                  return this.prominent;
                },
                styles: function styles() {
                  return __assign2(__assign2({}, this.measurableStyles), {
                    height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.computedHeight)
                  });
                }
              },
              created: function created2() {
                var _this2 = this;
                var breakingProps = [["app", "<v-app-bar app>"], ["manual-scroll", '<v-app-bar :value="false">'], ["clipped-left", "<v-app-bar clipped-left>"], ["clipped-right", "<v-app-bar clipped-right>"], ["inverted-scroll", "<v-app-bar inverted-scroll>"], ["scroll-off-screen", "<v-app-bar scroll-off-screen>"], ["scroll-target", "<v-app-bar scroll-target>"], ["scroll-threshold", "<v-app-bar scroll-threshold>"], ["card", "<v-app-bar flat>"]];
                breakingProps.forEach(function(_a2) {
                  var _b2 = __read2(_a2, 2), original = _b2[0], replacement = _b2[1];
                  if (_this2.$attrs.hasOwnProperty(original))
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_4__["breaking"])(original, replacement, _this2);
                });
              },
              methods: {
                genBackground: function genBackground() {
                  var props2 = {
                    height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.computedHeight),
                    src: this.src
                  };
                  var image = this.$scopedSlots.img ? this.$scopedSlots.img({
                    props: props2
                  }) : this.$createElement(_VImg_VImg__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    props: props2
                  });
                  return this.$createElement("div", {
                    staticClass: "v-toolbar__image"
                  }, [image]);
                },
                genContent: function genContent() {
                  return this.$createElement("div", {
                    staticClass: "v-toolbar__content",
                    style: {
                      height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.computedContentHeight)
                    }
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this));
                },
                genExtension: function genExtension() {
                  return this.$createElement("div", {
                    staticClass: "v-toolbar__extension",
                    style: {
                      height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.extensionHeight)
                    }
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this, "extension"));
                }
              },
              render: function render8(h) {
                this.isExtended = this.extended || !!this.$scopedSlots.extension;
                var children = [this.genContent()];
                var data = this.setBackgroundColor(this.color, {
                  class: this.classes,
                  style: this.styles,
                  on: this.$listeners
                });
                if (this.isExtended)
                  children.push(this.genExtension());
                if (this.src || this.$scopedSlots.img)
                  children.unshift(this.genBackground());
                return h(this.tag, data, children);
              }
            });
          }
        ),
        /***/
        "./src/components/VToolbar/index.ts": (
          /*!******************************************!*\
            !*** ./src/components/VToolbar/index.ts ***!
            \******************************************/
          /*! exports provided: VToolbar, VToolbarItems, VToolbarTitle, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "VToolbarItems", function() {
              return VToolbarItems;
            });
            __webpack_require__.d(__webpack_exports__, "VToolbarTitle", function() {
              return VToolbarTitle;
            });
            var _VToolbar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VToolbar */
              "./src/components/VToolbar/VToolbar.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VToolbar", function() {
              return _VToolbar__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var VToolbarTitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["createSimpleFunctional"])("v-toolbar__title");
            var VToolbarItems = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["createSimpleFunctional"])("v-toolbar__items");
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VToolbar: _VToolbar__WEBPACK_IMPORTED_MODULE_0__["default"],
                VToolbarItems,
                VToolbarTitle
              }
            };
          }
        ),
        /***/
        "./src/components/VTooltip/VTooltip.sass": (
          /*!***********************************************!*\
            !*** ./src/components/VTooltip/VTooltip.sass ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VTooltip/VTooltip.ts": (
          /*!*********************************************!*\
            !*** ./src/components/VTooltip/VTooltip.ts ***!
            \*********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VTooltip.sass */
              "./src/components/VTooltip/VTooltip.sass"
            );
            var _mixins_activatable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/activatable */
              "./src/mixins/activatable/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_delayable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/delayable */
              "./src/mixins/delayable/index.ts"
            );
            var _mixins_dependent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../mixins/dependent */
              "./src/mixins/dependent/index.ts"
            );
            var _mixins_menuable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../mixins/menuable */
              "./src/mixins/menuable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_delayable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_dependent__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_menuable__WEBPACK_IMPORTED_MODULE_5__["default"]).extend({
              name: "v-tooltip",
              props: {
                closeDelay: {
                  type: [Number, String],
                  default: 0
                },
                disabled: Boolean,
                openDelay: {
                  type: [Number, String],
                  default: 0
                },
                openOnHover: {
                  type: Boolean,
                  default: true
                },
                openOnFocus: {
                  type: Boolean,
                  default: true
                },
                tag: {
                  type: String,
                  default: "span"
                },
                transition: String
              },
              data: function data() {
                return {
                  calculatedMinWidth: 0,
                  closeDependents: false
                };
              },
              computed: {
                calculatedLeft: function calculatedLeft() {
                  var _a2 = this.dimensions, activator = _a2.activator, content = _a2.content;
                  var unknown = !this.bottom && !this.left && !this.top && !this.right;
                  var activatorLeft = this.attach !== false ? activator.offsetLeft : activator.left;
                  var left = 0;
                  if (this.top || this.bottom || unknown) {
                    left = activatorLeft + activator.width / 2 - content.width / 2;
                  } else if (this.left || this.right) {
                    left = activatorLeft + (this.right ? activator.width : -content.width) + (this.right ? 10 : -10);
                  }
                  if (this.nudgeLeft)
                    left -= parseInt(this.nudgeLeft);
                  if (this.nudgeRight)
                    left += parseInt(this.nudgeRight);
                  return this.calcXOverflow(left, this.dimensions.content.width) + "px";
                },
                calculatedTop: function calculatedTop() {
                  var _a2 = this.dimensions, activator = _a2.activator, content = _a2.content;
                  var activatorTop = this.attach !== false ? activator.offsetTop : activator.top;
                  var top = 0;
                  if (this.top || this.bottom) {
                    top = activatorTop + (this.bottom ? activator.height : -content.height) + (this.bottom ? 10 : -10);
                  } else if (this.left || this.right) {
                    top = activatorTop + activator.height / 2 - content.height / 2;
                  }
                  if (this.nudgeTop)
                    top -= parseInt(this.nudgeTop);
                  if (this.nudgeBottom)
                    top += parseInt(this.nudgeBottom);
                  if (this.attach === false)
                    top += this.pageYOffset;
                  return this.calcYOverflow(top) + "px";
                },
                classes: function classes() {
                  return {
                    "v-tooltip--top": this.top,
                    "v-tooltip--right": this.right,
                    "v-tooltip--bottom": this.bottom,
                    "v-tooltip--left": this.left,
                    "v-tooltip--attached": this.attach === "" || this.attach === true || this.attach === "attach"
                  };
                },
                computedTransition: function computedTransition() {
                  if (this.transition)
                    return this.transition;
                  return this.isActive ? "scale-transition" : "fade-transition";
                },
                offsetY: function offsetY() {
                  return this.top || this.bottom;
                },
                offsetX: function offsetX() {
                  return this.left || this.right;
                },
                styles: function styles() {
                  return {
                    left: this.calculatedLeft,
                    maxWidth: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["convertToUnit"])(this.maxWidth),
                    minWidth: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["convertToUnit"])(this.minWidth),
                    top: this.calculatedTop,
                    zIndex: this.zIndex || this.activeZIndex
                  };
                }
              },
              beforeMount: function beforeMount2() {
                var _this2 = this;
                this.$nextTick(function() {
                  _this2.value && _this2.callActivate();
                });
              },
              mounted: function mounted3() {
                if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getSlotType"])(this, "activator", true) === "v-slot") {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_7__["consoleError"])(`v-tooltip's activator slot must be bound, try '<template #activator="data"><v-btn v-on="data.on>'`, this);
                }
              },
              methods: {
                activate: function activate() {
                  this.updateDimensions();
                  requestAnimationFrame(this.startTransition);
                },
                deactivate: function deactivate() {
                  this.runDelay("close");
                },
                genActivatorListeners: function genActivatorListeners() {
                  var _this2 = this;
                  var listeners = _mixins_activatable__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genActivatorListeners.call(this);
                  if (this.openOnFocus) {
                    listeners.focus = function(e) {
                      _this2.getActivator(e);
                      _this2.runDelay("open");
                    };
                    listeners.blur = function(e) {
                      _this2.getActivator(e);
                      _this2.runDelay("close");
                    };
                  }
                  listeners.keydown = function(e) {
                    if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].esc) {
                      _this2.getActivator(e);
                      _this2.runDelay("close");
                    }
                  };
                  return listeners;
                },
                genActivatorAttributes: function genActivatorAttributes() {
                  return {
                    "aria-haspopup": true,
                    "aria-expanded": String(this.isActive)
                  };
                },
                genTransition: function genTransition() {
                  var content = this.genContent();
                  if (!this.computedTransition)
                    return content;
                  return this.$createElement("transition", {
                    props: {
                      name: this.computedTransition
                    }
                  }, [content]);
                },
                genContent: function genContent() {
                  var _a2;
                  return this.$createElement("div", this.setBackgroundColor(this.color, {
                    staticClass: "v-tooltip__content",
                    class: (_a2 = {}, _a2[this.contentClass] = true, _a2.menuable__content__active = this.isActive, _a2["v-tooltip__content--fixed"] = this.activatorFixed, _a2),
                    style: this.styles,
                    attrs: this.getScopeIdAttrs(),
                    directives: [{
                      name: "show",
                      value: this.isContentActive
                    }],
                    ref: "content"
                  }), this.getContentSlot());
                }
              },
              render: function render8(h) {
                var _this2 = this;
                return h(this.tag, {
                  staticClass: "v-tooltip",
                  class: this.classes
                }, [this.showLazyContent(function() {
                  return [_this2.genTransition()];
                }), this.genActivator()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VTooltip/index.ts": (
          /*!******************************************!*\
            !*** ./src/components/VTooltip/index.ts ***!
            \******************************************/
          /*! exports provided: VTooltip, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VTooltip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VTooltip */
              "./src/components/VTooltip/VTooltip.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTooltip", function() {
              return _VTooltip__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VTooltip__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VTreeview/VTreeview.sass": (
          /*!*************************************************!*\
            !*** ./src/components/VTreeview/VTreeview.sass ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VTreeview/VTreeview.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VTreeview/VTreeview.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VTreeview.sass */
              "./src/components/VTreeview/VTreeview.sass"
            );
            var _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VTreeviewNode */
              "./src/components/VTreeview/VTreeviewNode.ts"
            );
            var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _mixins_registrable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/registrable */
              "./src/mixins/registrable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_filterTreeItems__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ./util/filterTreeItems */
              "./src/components/VTreeview/util/filterTreeItems.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            var __values2 = function(o) {
              var s2 = typeof Symbol === "function" && Symbol.iterator, m = s2 && o[s2], i2 = 0;
              if (m)
                return m.call(o);
              if (o && typeof o.length === "number")
                return {
                  next: function next() {
                    if (o && i2 >= o.length)
                      o = void 0;
                    return {
                      value: o && o[i2++],
                      done: !o
                    };
                  }
                };
              throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(
              Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_3__["provide"])("treeview"),
              _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
              /* @vue/component */
            ).extend({
              name: "v-treeview",
              provide: function provide() {
                return {
                  treeview: this
                };
              },
              props: __assign2({
                active: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                dense: Boolean,
                disabled: Boolean,
                filter: Function,
                hoverable: Boolean,
                items: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                multipleActive: Boolean,
                open: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                openAll: Boolean,
                returnObject: {
                  type: Boolean,
                  default: false
                  // TODO: Should be true in next major
                },
                search: String,
                value: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                }
              }, _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__["VTreeviewNodeProps"]),
              data: function data() {
                return {
                  level: -1,
                  activeCache: /* @__PURE__ */ new Set(),
                  nodes: {},
                  openCache: /* @__PURE__ */ new Set(),
                  selectedCache: /* @__PURE__ */ new Set()
                };
              },
              computed: {
                excludedItems: function excludedItems() {
                  var excluded = /* @__PURE__ */ new Set();
                  if (!this.search)
                    return excluded;
                  for (var i2 = 0; i2 < this.items.length; i2++) {
                    Object(_util_filterTreeItems__WEBPACK_IMPORTED_MODULE_7__["filterTreeItems"])(this.filter || _util_filterTreeItems__WEBPACK_IMPORTED_MODULE_7__["filterTreeItem"], this.items[i2], this.search, this.itemKey, this.itemText, this.itemChildren, excluded);
                  }
                  return excluded;
                }
              },
              watch: {
                items: {
                  handler: function handler() {
                    var _this2 = this;
                    var oldKeys = Object.keys(this.nodes).map(function(k) {
                      return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(_this2.nodes[k].item, _this2.itemKey);
                    });
                    var newKeys = this.getKeys(this.items);
                    var diff = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["arrayDiff"])(newKeys, oldKeys);
                    if (!diff.length && newKeys.length < oldKeys.length)
                      return;
                    diff.forEach(function(k) {
                      return delete _this2.nodes[k];
                    });
                    var oldSelectedCache = __spreadArray2([], __read2(this.selectedCache), false);
                    this.selectedCache = /* @__PURE__ */ new Set();
                    this.activeCache = /* @__PURE__ */ new Set();
                    this.openCache = /* @__PURE__ */ new Set();
                    this.buildTree(this.items);
                    if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["deepEqual"])(oldSelectedCache, __spreadArray2([], __read2(this.selectedCache), false)))
                      this.emitSelected();
                  },
                  deep: true
                },
                active: function active(value) {
                  this.handleNodeCacheWatcher(value, this.activeCache, this.updateActive, this.emitActive);
                },
                value: function value(_value) {
                  this.handleNodeCacheWatcher(_value, this.selectedCache, this.updateSelected, this.emitSelected);
                },
                open: function open2(value) {
                  this.handleNodeCacheWatcher(value, this.openCache, this.updateOpen, this.emitOpen);
                }
              },
              created: function created2() {
                var e_1, _a2, e_2, _b2;
                var _this2 = this;
                var getValue2 = function getValue3(key) {
                  return _this2.returnObject ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(key, _this2.itemKey) : key;
                };
                this.buildTree(this.items);
                try {
                  for (var _c = __values2(this.value.map(getValue2)), _d2 = _c.next(); !_d2.done; _d2 = _c.next()) {
                    var value = _d2.value;
                    this.updateSelected(value, true, true);
                  }
                } catch (e_1_1) {
                  e_1 = {
                    error: e_1_1
                  };
                } finally {
                  try {
                    if (_d2 && !_d2.done && (_a2 = _c.return))
                      _a2.call(_c);
                  } finally {
                    if (e_1)
                      throw e_1.error;
                  }
                }
                try {
                  for (var _e = __values2(this.active.map(getValue2)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var active = _f.value;
                    this.updateActive(active, true);
                  }
                } catch (e_2_1) {
                  e_2 = {
                    error: e_2_1
                  };
                } finally {
                  try {
                    if (_f && !_f.done && (_b2 = _e.return))
                      _b2.call(_e);
                  } finally {
                    if (e_2)
                      throw e_2.error;
                  }
                }
              },
              mounted: function mounted3() {
                var _this2 = this;
                if (this.$slots.prepend || this.$slots.append) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["consoleWarn"])("The prepend and append slots require a slot-scope attribute", this);
                }
                if (this.openAll) {
                  this.updateAll(true);
                } else {
                  this.open.forEach(function(key) {
                    return _this2.updateOpen(_this2.returnObject ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(key, _this2.itemKey) : key, true);
                  });
                  this.emitOpen();
                }
              },
              methods: {
                /** @public */
                updateAll: function updateAll(value) {
                  var _this2 = this;
                  Object.keys(this.nodes).forEach(function(key) {
                    return _this2.updateOpen(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(_this2.nodes[key].item, _this2.itemKey), value);
                  });
                  this.emitOpen();
                },
                getKeys: function getKeys2(items, keys2) {
                  if (keys2 === void 0) {
                    keys2 = [];
                  }
                  for (var i2 = 0; i2 < items.length; i2++) {
                    var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(items[i2], this.itemKey);
                    keys2.push(key);
                    var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(items[i2], this.itemChildren);
                    if (children) {
                      keys2.push.apply(keys2, __spreadArray2([], __read2(this.getKeys(children)), false));
                    }
                  }
                  return keys2;
                },
                buildTree: function buildTree(items, parent2) {
                  var _this2 = this;
                  var _a2;
                  if (parent2 === void 0) {
                    parent2 = null;
                  }
                  for (var i2 = 0; i2 < items.length; i2++) {
                    var item = items[i2];
                    var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(item, this.itemKey);
                    var children = (_a2 = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(item, this.itemChildren)) !== null && _a2 !== void 0 ? _a2 : [];
                    var oldNode = this.nodes.hasOwnProperty(key) ? this.nodes[key] : {
                      isSelected: false,
                      isIndeterminate: false,
                      isActive: false,
                      isOpen: false,
                      vnode: null
                    };
                    var node2 = {
                      vnode: oldNode.vnode,
                      parent: parent2,
                      children: children.map(function(c) {
                        return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(c, _this2.itemKey);
                      }),
                      item
                    };
                    this.buildTree(children, key);
                    if (this.selectionType !== "independent" && parent2 !== null && !this.nodes.hasOwnProperty(key) && this.nodes.hasOwnProperty(parent2)) {
                      node2.isSelected = this.nodes[parent2].isSelected;
                    } else {
                      node2.isSelected = oldNode.isSelected;
                      node2.isIndeterminate = oldNode.isIndeterminate;
                    }
                    node2.isActive = oldNode.isActive;
                    node2.isOpen = oldNode.isOpen;
                    this.nodes[key] = node2;
                    if (children.length && this.selectionType !== "independent") {
                      var _b2 = this.calculateState(key, this.nodes), isSelected = _b2.isSelected, isIndeterminate = _b2.isIndeterminate;
                      node2.isSelected = isSelected;
                      node2.isIndeterminate = isIndeterminate;
                    }
                    if (this.nodes[key].isSelected && (this.selectionType === "independent" || node2.children.length === 0))
                      this.selectedCache.add(key);
                    if (this.nodes[key].isActive)
                      this.activeCache.add(key);
                    if (this.nodes[key].isOpen)
                      this.openCache.add(key);
                    this.updateVnodeState(key);
                  }
                },
                calculateState: function calculateState(node2, state) {
                  var children = state[node2].children;
                  var counts = children.reduce(function(counts2, child) {
                    counts2[0] += +Boolean(state[child].isSelected);
                    counts2[1] += +Boolean(state[child].isIndeterminate);
                    return counts2;
                  }, [0, 0]);
                  var isSelected = !!children.length && counts[0] === children.length;
                  var isIndeterminate = !isSelected && (counts[0] > 0 || counts[1] > 0);
                  return {
                    isSelected,
                    isIndeterminate
                  };
                },
                emitOpen: function emitOpen() {
                  this.emitNodeCache("update:open", this.openCache);
                },
                emitSelected: function emitSelected() {
                  this.emitNodeCache("input", this.selectedCache);
                },
                emitActive: function emitActive() {
                  this.emitNodeCache("update:active", this.activeCache);
                },
                emitNodeCache: function emitNodeCache(event, cache) {
                  var _this2 = this;
                  this.$emit(event, this.returnObject ? __spreadArray2([], __read2(cache), false).map(function(key) {
                    return _this2.nodes[key].item;
                  }) : __spreadArray2([], __read2(cache), false));
                },
                handleNodeCacheWatcher: function handleNodeCacheWatcher(value, cache, updateFn, emitFn) {
                  var _this2 = this;
                  value = this.returnObject ? value.map(function(v) {
                    return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(v, _this2.itemKey);
                  }) : value;
                  var old = __spreadArray2([], __read2(cache), false);
                  if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["deepEqual"])(old, value))
                    return;
                  old.forEach(function(key) {
                    return updateFn(key, false);
                  });
                  value.forEach(function(key) {
                    return updateFn(key, true);
                  });
                  emitFn();
                },
                getDescendants: function getDescendants(key, descendants) {
                  if (descendants === void 0) {
                    descendants = [];
                  }
                  var children = this.nodes[key].children;
                  descendants.push.apply(descendants, __spreadArray2([], __read2(children), false));
                  for (var i2 = 0; i2 < children.length; i2++) {
                    descendants = this.getDescendants(children[i2], descendants);
                  }
                  return descendants;
                },
                getParents: function getParents(key) {
                  var parent2 = this.nodes[key].parent;
                  var parents = [];
                  while (parent2 !== null) {
                    parents.push(parent2);
                    parent2 = this.nodes[parent2].parent;
                  }
                  return parents;
                },
                register: function register(node2) {
                  var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(node2.item, this.itemKey);
                  this.nodes[key].vnode = node2;
                  this.updateVnodeState(key);
                },
                unregister: function unregister(node2) {
                  var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(node2.item, this.itemKey);
                  if (this.nodes[key])
                    this.nodes[key].vnode = null;
                },
                isParent: function isParent(key) {
                  return this.nodes[key].children && this.nodes[key].children.length;
                },
                updateActive: function updateActive(key, isActive) {
                  var _this2 = this;
                  if (!this.nodes.hasOwnProperty(key))
                    return;
                  if (!this.multipleActive) {
                    this.activeCache.forEach(function(active) {
                      _this2.nodes[active].isActive = false;
                      _this2.updateVnodeState(active);
                      _this2.activeCache.delete(active);
                    });
                  }
                  var node2 = this.nodes[key];
                  if (!node2)
                    return;
                  if (isActive)
                    this.activeCache.add(key);
                  else
                    this.activeCache.delete(key);
                  node2.isActive = isActive;
                  this.updateVnodeState(key);
                },
                updateSelected: function updateSelected(key, isSelected, isForced) {
                  var e_3, _a2, e_4, _b2, e_5, _c;
                  if (isForced === void 0) {
                    isForced = false;
                  }
                  if (!this.nodes.hasOwnProperty(key))
                    return;
                  var changed = /* @__PURE__ */ new Map();
                  if (this.selectionType !== "independent") {
                    try {
                      for (var _d2 = __values2(this.getDescendants(key)), _e = _d2.next(); !_e.done; _e = _d2.next()) {
                        var descendant = _e.value;
                        if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(this.nodes[descendant].item, this.itemDisabled) || isForced) {
                          this.nodes[descendant].isSelected = isSelected;
                          this.nodes[descendant].isIndeterminate = false;
                          changed.set(descendant, isSelected);
                        }
                      }
                    } catch (e_3_1) {
                      e_3 = {
                        error: e_3_1
                      };
                    } finally {
                      try {
                        if (_e && !_e.done && (_a2 = _d2.return))
                          _a2.call(_d2);
                      } finally {
                        if (e_3)
                          throw e_3.error;
                      }
                    }
                    var calculated = this.calculateState(key, this.nodes);
                    this.nodes[key].isSelected = isSelected;
                    this.nodes[key].isIndeterminate = calculated.isIndeterminate;
                    changed.set(key, isSelected);
                    try {
                      for (var _f = __values2(this.getParents(key)), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var parent2 = _g.value;
                        var calculated_1 = this.calculateState(parent2, this.nodes);
                        this.nodes[parent2].isSelected = calculated_1.isSelected;
                        this.nodes[parent2].isIndeterminate = calculated_1.isIndeterminate;
                        changed.set(parent2, calculated_1.isSelected);
                      }
                    } catch (e_4_1) {
                      e_4 = {
                        error: e_4_1
                      };
                    } finally {
                      try {
                        if (_g && !_g.done && (_b2 = _f.return))
                          _b2.call(_f);
                      } finally {
                        if (e_4)
                          throw e_4.error;
                      }
                    }
                  } else {
                    this.nodes[key].isSelected = isSelected;
                    this.nodes[key].isIndeterminate = false;
                    changed.set(key, isSelected);
                  }
                  try {
                    for (var _h = __values2(changed.entries()), _j = _h.next(); !_j.done; _j = _h.next()) {
                      var _k = __read2(_j.value, 2), key_1 = _k[0], value = _k[1];
                      this.updateVnodeState(key_1);
                      if (this.selectionType === "leaf" && this.isParent(key_1))
                        continue;
                      value === true ? this.selectedCache.add(key_1) : this.selectedCache.delete(key_1);
                    }
                  } catch (e_5_1) {
                    e_5 = {
                      error: e_5_1
                    };
                  } finally {
                    try {
                      if (_j && !_j.done && (_c = _h.return))
                        _c.call(_h);
                    } finally {
                      if (e_5)
                        throw e_5.error;
                    }
                  }
                },
                updateOpen: function updateOpen(key, isOpen) {
                  var _this2 = this;
                  if (!this.nodes.hasOwnProperty(key))
                    return;
                  var node2 = this.nodes[key];
                  var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(node2.item, this.itemChildren);
                  if (children && !children.length && node2.vnode && !node2.vnode.hasLoaded) {
                    node2.vnode.checkChildren().then(function() {
                      return _this2.updateOpen(key, isOpen);
                    });
                  } else if (children && children.length) {
                    node2.isOpen = isOpen;
                    node2.isOpen ? this.openCache.add(key) : this.openCache.delete(key);
                    this.updateVnodeState(key);
                  }
                },
                updateVnodeState: function updateVnodeState(key) {
                  var node2 = this.nodes[key];
                  if (node2 && node2.vnode) {
                    node2.vnode.isSelected = node2.isSelected;
                    node2.vnode.isIndeterminate = node2.isIndeterminate;
                    node2.vnode.isActive = node2.isActive;
                    node2.vnode.isOpen = node2.isOpen;
                  }
                },
                isExcluded: function isExcluded(key) {
                  return !!this.search && this.excludedItems.has(key);
                }
              },
              render: function render8(h) {
                var _this2 = this;
                var children = this.items.length ? this.items.filter(function(item) {
                  return !_this2.isExcluded(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(item, _this2.itemKey));
                }).map(function(item) {
                  var genChild = _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genChild.bind(_this2);
                  return genChild(item, _this2.disabled || Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(item, _this2.itemDisabled));
                }) : this.$slots.default;
                return h("div", {
                  staticClass: "v-treeview",
                  class: __assign2({
                    "v-treeview--hoverable": this.hoverable,
                    "v-treeview--dense": this.dense
                  }, this.themeClasses)
                }, children);
              }
            });
          }
        ),
        /***/
        "./src/components/VTreeview/VTreeviewNode.ts": (
          /*!***************************************************!*\
            !*** ./src/components/VTreeview/VTreeviewNode.ts ***!
            \***************************************************/
          /*! exports provided: VTreeviewNodeProps, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "VTreeviewNodeProps", function() {
              return VTreeviewNodeProps;
            });
            var _transitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../transitions */
              "./src/components/transitions/index.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _mixins_registrable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/registrable */
              "./src/mixins/registrable/index.ts"
            );
            var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../mixins/colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_2__["inject"])("treeview"));
            var VTreeviewNodeProps = {
              activatable: Boolean,
              activeClass: {
                type: String,
                default: "v-treeview-node--active"
              },
              color: {
                type: String,
                default: "primary"
              },
              disablePerNode: Boolean,
              expandIcon: {
                type: String,
                default: "$subgroup"
              },
              indeterminateIcon: {
                type: String,
                default: "$checkboxIndeterminate"
              },
              itemChildren: {
                type: String,
                default: "children"
              },
              itemDisabled: {
                type: String,
                default: "disabled"
              },
              itemKey: {
                type: String,
                default: "id"
              },
              itemText: {
                type: String,
                default: "name"
              },
              loadChildren: Function,
              loadingIcon: {
                type: String,
                default: "$loading"
              },
              offIcon: {
                type: String,
                default: "$checkboxOff"
              },
              onIcon: {
                type: String,
                default: "$checkboxOn"
              },
              openOnClick: Boolean,
              rounded: Boolean,
              selectable: Boolean,
              selectedColor: {
                type: String,
                default: "accent"
              },
              shaped: Boolean,
              transition: Boolean,
              selectionType: {
                type: String,
                default: "leaf",
                validator: function validator2(v) {
                  return ["leaf", "independent"].includes(v);
                }
              }
            };
            var VTreeviewNode = baseMixins.extend().extend({
              name: "v-treeview-node",
              inject: {
                treeview: {
                  default: null
                }
              },
              props: __assign2({
                level: Number,
                item: {
                  type: Object,
                  default: function _default() {
                    return null;
                  }
                },
                parentIsDisabled: Boolean
              }, VTreeviewNodeProps),
              data: function data() {
                return {
                  hasLoaded: false,
                  isActive: false,
                  isIndeterminate: false,
                  isLoading: false,
                  isOpen: false,
                  isSelected: false
                  // Node is selected (checkbox)
                };
              },
              computed: {
                disabled: function disabled() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(this.item, this.itemDisabled) || !this.disablePerNode && this.parentIsDisabled && this.selectionType === "leaf";
                },
                key: function key() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(this.item, this.itemKey);
                },
                children: function children() {
                  var _this2 = this;
                  var children2 = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(this.item, this.itemChildren);
                  return children2 && children2.filter(function(child) {
                    return !_this2.treeview.isExcluded(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(child, _this2.itemKey));
                  });
                },
                text: function text2() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(this.item, this.itemText);
                },
                scopedProps: function scopedProps() {
                  return {
                    item: this.item,
                    leaf: !this.children,
                    selected: this.isSelected,
                    indeterminate: this.isIndeterminate,
                    active: this.isActive,
                    open: this.isOpen
                  };
                },
                computedIcon: function computedIcon() {
                  if (this.isIndeterminate)
                    return this.indeterminateIcon;
                  else if (this.isSelected)
                    return this.onIcon;
                  else
                    return this.offIcon;
                },
                hasChildren: function hasChildren2() {
                  return !!this.children && (!!this.children.length || !!this.loadChildren);
                }
              },
              created: function created2() {
                this.treeview.register(this);
              },
              beforeDestroy: function beforeDestroy2() {
                this.treeview.unregister(this);
              },
              methods: {
                checkChildren: function checkChildren() {
                  var _this2 = this;
                  return new Promise(function(resolve2) {
                    if (!_this2.children || _this2.children.length || !_this2.loadChildren || _this2.hasLoaded)
                      return resolve2();
                    _this2.isLoading = true;
                    resolve2(_this2.loadChildren(_this2.item));
                  }).then(function() {
                    _this2.isLoading = false;
                    _this2.hasLoaded = true;
                  });
                },
                open: function open2() {
                  this.isOpen = !this.isOpen;
                  this.treeview.updateOpen(this.key, this.isOpen);
                  this.treeview.emitOpen();
                },
                genLabel: function genLabel() {
                  var children = [];
                  if (this.$scopedSlots.label)
                    children.push(this.$scopedSlots.label(this.scopedProps));
                  else
                    children.push(this.text);
                  return this.$createElement("div", {
                    slot: "label",
                    staticClass: "v-treeview-node__label"
                  }, children);
                },
                genPrependSlot: function genPrependSlot() {
                  if (!this.$scopedSlots.prepend)
                    return null;
                  return this.$createElement("div", {
                    staticClass: "v-treeview-node__prepend"
                  }, this.$scopedSlots.prepend(this.scopedProps));
                },
                genAppendSlot: function genAppendSlot() {
                  if (!this.$scopedSlots.append)
                    return null;
                  return this.$createElement("div", {
                    staticClass: "v-treeview-node__append"
                  }, this.$scopedSlots.append(this.scopedProps));
                },
                genContent: function genContent() {
                  var children = [this.genPrependSlot(), this.genLabel(), this.genAppendSlot()];
                  return this.$createElement("div", {
                    staticClass: "v-treeview-node__content"
                  }, children);
                },
                genToggle: function genToggle() {
                  var _this2 = this;
                  return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["VIcon"], {
                    staticClass: "v-treeview-node__toggle",
                    class: {
                      "v-treeview-node__toggle--open": this.isOpen,
                      "v-treeview-node__toggle--loading": this.isLoading
                    },
                    slot: "prepend",
                    on: {
                      click: function click2(e) {
                        e.stopPropagation();
                        if (_this2.isLoading)
                          return;
                        _this2.checkChildren().then(function() {
                          return _this2.open();
                        });
                      }
                    }
                  }, [this.isLoading ? this.loadingIcon : this.expandIcon]);
                },
                genCheckbox: function genCheckbox() {
                  var _this2 = this;
                  return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["VIcon"], {
                    staticClass: "v-treeview-node__checkbox",
                    props: {
                      color: this.isSelected || this.isIndeterminate ? this.selectedColor : void 0,
                      disabled: this.disabled
                    },
                    on: {
                      click: function click2(e) {
                        e.stopPropagation();
                        if (_this2.isLoading)
                          return;
                        _this2.checkChildren().then(function() {
                          _this2.$nextTick(function() {
                            _this2.isSelected = !_this2.isSelected;
                            _this2.isIndeterminate = false;
                            _this2.treeview.updateSelected(_this2.key, _this2.isSelected);
                            _this2.treeview.emitSelected();
                          });
                        });
                      }
                    }
                  }, [this.computedIcon]);
                },
                genLevel: function genLevel(level) {
                  var _this2 = this;
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["createRange"])(level).map(function() {
                    return _this2.$createElement("div", {
                      staticClass: "v-treeview-node__level"
                    });
                  });
                },
                genNode: function genNode() {
                  var _a2;
                  var _this2 = this;
                  var children = [this.genContent()];
                  if (this.selectable)
                    children.unshift(this.genCheckbox());
                  if (this.hasChildren) {
                    children.unshift(this.genToggle());
                  } else {
                    children.unshift.apply(children, __spreadArray2([], __read2(this.genLevel(1)), false));
                  }
                  children.unshift.apply(children, __spreadArray2([], __read2(this.genLevel(this.level)), false));
                  return this.$createElement("div", this.setTextColor(this.isActive && this.color, {
                    staticClass: "v-treeview-node__root",
                    class: (_a2 = {}, _a2[this.activeClass] = this.isActive, _a2),
                    on: {
                      click: function click2() {
                        if (_this2.openOnClick && _this2.hasChildren) {
                          _this2.checkChildren().then(_this2.open);
                        } else if (_this2.activatable && !_this2.disabled) {
                          _this2.isActive = !_this2.isActive;
                          _this2.treeview.updateActive(_this2.key, _this2.isActive);
                          _this2.treeview.emitActive();
                        }
                      }
                    }
                  }), children);
                },
                genChild: function genChild(item, parentIsDisabled) {
                  return this.$createElement(VTreeviewNode, {
                    key: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(item, this.itemKey),
                    props: {
                      activatable: this.activatable,
                      activeClass: this.activeClass,
                      item,
                      selectable: this.selectable,
                      selectedColor: this.selectedColor,
                      color: this.color,
                      disablePerNode: this.disablePerNode,
                      expandIcon: this.expandIcon,
                      indeterminateIcon: this.indeterminateIcon,
                      offIcon: this.offIcon,
                      onIcon: this.onIcon,
                      loadingIcon: this.loadingIcon,
                      itemKey: this.itemKey,
                      itemText: this.itemText,
                      itemDisabled: this.itemDisabled,
                      itemChildren: this.itemChildren,
                      loadChildren: this.loadChildren,
                      transition: this.transition,
                      openOnClick: this.openOnClick,
                      rounded: this.rounded,
                      shaped: this.shaped,
                      level: this.level + 1,
                      selectionType: this.selectionType,
                      parentIsDisabled
                    },
                    scopedSlots: this.$scopedSlots
                  });
                },
                genChildrenWrapper: function genChildrenWrapper() {
                  var _this2 = this;
                  if (!this.isOpen || !this.children)
                    return null;
                  var children = [this.children.map(function(c) {
                    return _this2.genChild(c, _this2.disabled);
                  })];
                  return this.$createElement("div", {
                    staticClass: "v-treeview-node__children"
                  }, children);
                },
                genTransition: function genTransition() {
                  return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_0__["VExpandTransition"], [this.genChildrenWrapper()]);
                }
              },
              render: function render8(h) {
                var children = [this.genNode()];
                if (this.transition)
                  children.push(this.genTransition());
                else
                  children.push(this.genChildrenWrapper());
                return h("div", {
                  staticClass: "v-treeview-node",
                  class: {
                    "v-treeview-node--leaf": !this.hasChildren,
                    "v-treeview-node--click": this.openOnClick,
                    "v-treeview-node--disabled": this.disabled,
                    "v-treeview-node--rounded": this.rounded,
                    "v-treeview-node--shaped": this.shaped,
                    "v-treeview-node--selected": this.isSelected
                  },
                  attrs: {
                    "aria-expanded": String(this.isOpen)
                  }
                }, children);
              }
            });
            __webpack_exports__["default"] = VTreeviewNode;
          }
        ),
        /***/
        "./src/components/VTreeview/index.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VTreeview/index.ts ***!
            \*******************************************/
          /*! exports provided: VTreeview, VTreeviewNode, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VTreeview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VTreeview */
              "./src/components/VTreeview/VTreeview.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTreeview", function() {
              return _VTreeview__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VTreeviewNode */
              "./src/components/VTreeview/VTreeviewNode.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTreeviewNode", function() {
              return _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VTreeview: _VTreeview__WEBPACK_IMPORTED_MODULE_0__["default"],
                VTreeviewNode: _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/VTreeview/util/filterTreeItems.ts": (
          /*!**********************************************************!*\
            !*** ./src/components/VTreeview/util/filterTreeItems.ts ***!
            \**********************************************************/
          /*! exports provided: filterTreeItem, filterTreeItems */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "filterTreeItem", function() {
              return filterTreeItem;
            });
            __webpack_require__.d(__webpack_exports__, "filterTreeItems", function() {
              return filterTreeItems;
            });
            var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../../util/helpers */
              "./src/util/helpers.ts"
            );
            function filterTreeItem(item, search, textKey) {
              var text2 = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["getObjectValueByPath"])(item, textKey);
              return text2.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1;
            }
            function filterTreeItems(filter2, item, search, idKey, textKey, childrenKey, excluded) {
              if (filter2(item, search, textKey)) {
                return true;
              }
              var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["getObjectValueByPath"])(item, childrenKey);
              if (children) {
                var match = false;
                for (var i2 = 0; i2 < children.length; i2++) {
                  if (filterTreeItems(filter2, children[i2], search, idKey, textKey, childrenKey, excluded)) {
                    match = true;
                  }
                }
                if (match)
                  return true;
              }
              excluded.add(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["getObjectValueByPath"])(item, idKey));
              return false;
            }
          }
        ),
        /***/
        "./src/components/VVirtualScroll/VVirtualScroll.sass": (
          /*!***********************************************************!*\
            !*** ./src/components/VVirtualScroll/VVirtualScroll.sass ***!
            \***********************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VVirtualScroll/VVirtualScroll.ts": (
          /*!*********************************************************!*\
            !*** ./src/components/VVirtualScroll/VVirtualScroll.ts ***!
            \*********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VVirtualScroll.sass */
              "./src/components/VVirtualScroll/VVirtualScroll.sass"
            );
            var _mixins_measurable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/measurable */
              "./src/mixins/measurable/index.ts"
            );
            var _directives_scroll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../directives/scroll */
              "./src/directives/scroll/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = _mixins_measurable__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
              name: "v-virtual-scroll",
              directives: {
                Scroll: _directives_scroll__WEBPACK_IMPORTED_MODULE_2__["default"]
              },
              props: {
                bench: {
                  type: [Number, String],
                  default: 0
                },
                itemHeight: {
                  type: [Number, String],
                  required: true
                },
                items: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                }
              },
              data: function data() {
                return {
                  first: 0,
                  last: 0,
                  scrollTop: 0
                };
              },
              computed: {
                __bench: function __bench() {
                  return parseInt(this.bench, 10);
                },
                __itemHeight: function __itemHeight() {
                  return parseInt(this.itemHeight, 10);
                },
                firstToRender: function firstToRender() {
                  return Math.max(0, this.first - this.__bench);
                },
                lastToRender: function lastToRender() {
                  return Math.min(this.items.length, this.last + this.__bench);
                }
              },
              watch: {
                height: "onScroll",
                itemHeight: "onScroll"
              },
              mounted: function mounted3() {
                this.last = this.getLast(0);
              },
              methods: {
                getChildren: function getChildren2() {
                  return this.items.slice(this.firstToRender, this.lastToRender).map(this.genChild);
                },
                genChild: function genChild(item, index2) {
                  index2 += this.firstToRender;
                  var top = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(index2 * this.__itemHeight);
                  return this.$createElement("div", {
                    staticClass: "v-virtual-scroll__item",
                    style: {
                      top
                    },
                    key: index2
                  }, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this, "default", {
                    index: index2,
                    item
                  }));
                },
                getFirst: function getFirst() {
                  return Math.floor(this.scrollTop / this.__itemHeight);
                },
                getLast: function getLast(first) {
                  var height = parseInt(this.height || 0, 10) || this.$el.clientHeight;
                  return first + Math.ceil(height / this.__itemHeight);
                },
                onScroll: function onScroll() {
                  this.scrollTop = this.$el.scrollTop;
                  this.first = this.getFirst();
                  this.last = this.getLast(this.first);
                }
              },
              render: function render8(h) {
                var content = h("div", {
                  staticClass: "v-virtual-scroll__container",
                  style: {
                    height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.items.length * this.__itemHeight)
                  }
                }, this.getChildren());
                return h("div", {
                  staticClass: "v-virtual-scroll",
                  style: this.measurableStyles,
                  directives: [{
                    name: "scroll",
                    modifiers: {
                      self: true
                    },
                    value: this.onScroll
                  }],
                  on: this.$listeners
                }, [content]);
              }
            });
          }
        ),
        /***/
        "./src/components/VVirtualScroll/index.ts": (
          /*!************************************************!*\
            !*** ./src/components/VVirtualScroll/index.ts ***!
            \************************************************/
          /*! exports provided: VVirtualScroll, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VVirtualScroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VVirtualScroll */
              "./src/components/VVirtualScroll/VVirtualScroll.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VVirtualScroll", function() {
              return _VVirtualScroll__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            __webpack_exports__["default"] = _VVirtualScroll__WEBPACK_IMPORTED_MODULE_0__["default"];
          }
        ),
        /***/
        "./src/components/VWindow/VWindow.sass": (
          /*!*********************************************!*\
            !*** ./src/components/VWindow/VWindow.sass ***!
            \*********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/components/VWindow/VWindow.ts": (
          /*!*******************************************!*\
            !*** ./src/components/VWindow/VWindow.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__(
              /*! ./VWindow.sass */
              "./src/components/VWindow/VWindow.sass"
            );
            var _directives_touch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../directives/touch */
              "./src/directives/touch/index.ts"
            );
            var _VBtn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../VBtn */
              "./src/components/VBtn/index.ts"
            );
            var _VIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../VIcon */
              "./src/components/VIcon/index.ts"
            );
            var _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../VItemGroup/VItemGroup */
              "./src/components/VItemGroup/VItemGroup.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_4__["BaseItemGroup"].extend({
              name: "v-window",
              directives: {
                Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_1__["default"]
              },
              provide: function provide() {
                return {
                  windowGroup: this
                };
              },
              props: {
                activeClass: {
                  type: String,
                  default: "v-window-item--active"
                },
                continuous: Boolean,
                mandatory: {
                  type: Boolean,
                  default: true
                },
                nextIcon: {
                  type: [Boolean, String],
                  default: "$next"
                },
                prevIcon: {
                  type: [Boolean, String],
                  default: "$prev"
                },
                reverse: Boolean,
                showArrows: Boolean,
                showArrowsOnHover: Boolean,
                touch: Object,
                touchless: Boolean,
                value: {
                  required: false
                },
                vertical: Boolean
              },
              data: function data() {
                return {
                  changedByDelimiters: false,
                  internalHeight: void 0,
                  transitionHeight: void 0,
                  transitionCount: 0,
                  isBooted: false,
                  isReverse: false
                };
              },
              computed: {
                isActive: function isActive() {
                  return this.transitionCount > 0;
                },
                classes: function classes() {
                  return __assign2(__assign2({}, _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_4__["BaseItemGroup"].options.computed.classes.call(this)), {
                    "v-window--show-arrows-on-hover": this.showArrowsOnHover
                  });
                },
                computedTransition: function computedTransition() {
                  if (!this.isBooted)
                    return "";
                  var axis = this.vertical ? "y" : "x";
                  var reverse = this.internalReverse ? !this.isReverse : this.isReverse;
                  var direction = reverse ? "-reverse" : "";
                  return "v-window-" + axis + direction + "-transition";
                },
                hasActiveItems: function hasActiveItems() {
                  return Boolean(this.items.find(function(item) {
                    return !item.disabled;
                  }));
                },
                hasNext: function hasNext() {
                  return this.continuous || this.internalIndex < this.items.length - 1;
                },
                hasPrev: function hasPrev() {
                  return this.continuous || this.internalIndex > 0;
                },
                internalIndex: function internalIndex() {
                  var _this2 = this;
                  return this.items.findIndex(function(item, i2) {
                    return _this2.internalValue === _this2.getValue(item, i2);
                  });
                },
                internalReverse: function internalReverse() {
                  return this.$vuetify.rtl ? !this.reverse : this.reverse;
                }
              },
              watch: {
                internalIndex: function internalIndex(val, oldVal) {
                  this.isReverse = this.updateReverse(val, oldVal);
                }
              },
              mounted: function mounted3() {
                var _this2 = this;
                window.requestAnimationFrame(function() {
                  return _this2.isBooted = true;
                });
              },
              methods: {
                genDefaultSlot: function genDefaultSlot() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this);
                },
                genContainer: function genContainer() {
                  var children = [this.genDefaultSlot()];
                  if (this.showArrows) {
                    children.push(this.genControlIcons());
                  }
                  return this.$createElement("div", {
                    staticClass: "v-window__container",
                    class: {
                      "v-window__container--is-active": this.isActive
                    },
                    style: {
                      height: this.internalHeight || this.transitionHeight
                    }
                  }, children);
                },
                genIcon: function genIcon(direction, icon, _click) {
                  var _this2 = this;
                  var _a2, _b2, _c;
                  var on2 = {
                    click: function click2(e) {
                      e.stopPropagation();
                      _this2.changedByDelimiters = true;
                      _click();
                    }
                  };
                  var attrs2 = {
                    "aria-label": this.$vuetify.lang.t("$vuetify.carousel." + direction)
                  };
                  var children = (_c = (_b2 = (_a2 = this.$scopedSlots)[direction]) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, {
                    on: on2,
                    attrs: attrs2
                  })) !== null && _c !== void 0 ? _c : [this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    props: {
                      icon: true
                    },
                    attrs: attrs2,
                    on: on2
                  }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    props: {
                      large: true
                    }
                  }, icon)])];
                  return this.$createElement("div", {
                    staticClass: "v-window__" + direction
                  }, children);
                },
                genControlIcons: function genControlIcons() {
                  var icons2 = [];
                  var prevIcon = this.$vuetify.rtl ? this.nextIcon : this.prevIcon;
                  if (this.hasPrev && prevIcon && typeof prevIcon === "string") {
                    var icon = this.genIcon("prev", prevIcon, this.prev);
                    icon && icons2.push(icon);
                  }
                  var nextIcon = this.$vuetify.rtl ? this.prevIcon : this.nextIcon;
                  if (this.hasNext && nextIcon && typeof nextIcon === "string") {
                    var icon = this.genIcon("next", nextIcon, this.next);
                    icon && icons2.push(icon);
                  }
                  return icons2;
                },
                getNextIndex: function getNextIndex(index2) {
                  var nextIndex = (index2 + 1) % this.items.length;
                  var item = this.items[nextIndex];
                  if (item.disabled)
                    return this.getNextIndex(nextIndex);
                  return nextIndex;
                },
                getPrevIndex: function getPrevIndex(index2) {
                  var prevIndex = (index2 + this.items.length - 1) % this.items.length;
                  var item = this.items[prevIndex];
                  if (item.disabled)
                    return this.getPrevIndex(prevIndex);
                  return prevIndex;
                },
                next: function next() {
                  if (!this.hasActiveItems || !this.hasNext)
                    return;
                  var nextIndex = this.getNextIndex(this.internalIndex);
                  var item = this.items[nextIndex];
                  this.internalValue = this.getValue(item, nextIndex);
                },
                prev: function prev() {
                  if (!this.hasActiveItems || !this.hasPrev)
                    return;
                  var lastIndex = this.getPrevIndex(this.internalIndex);
                  var item = this.items[lastIndex];
                  this.internalValue = this.getValue(item, lastIndex);
                },
                updateReverse: function updateReverse(val, oldVal) {
                  var itemsLength = this.items.length;
                  var lastIndex = itemsLength - 1;
                  if (itemsLength <= 2)
                    return val < oldVal;
                  if (val === lastIndex && oldVal === 0) {
                    return true;
                  } else if (val === 0 && oldVal === lastIndex) {
                    return false;
                  } else {
                    return val < oldVal;
                  }
                }
              },
              render: function render8(h) {
                var _this2 = this;
                var data = {
                  staticClass: "v-window",
                  class: this.classes,
                  directives: []
                };
                if (!this.touchless) {
                  var value = this.touch || {
                    left: function left() {
                      _this2.$vuetify.rtl ? _this2.prev() : _this2.next();
                    },
                    right: function right() {
                      _this2.$vuetify.rtl ? _this2.next() : _this2.prev();
                    },
                    end: function end(e) {
                      e.stopPropagation();
                    },
                    start: function start(e) {
                      e.stopPropagation();
                    }
                  };
                  data.directives.push({
                    name: "touch",
                    value
                  });
                }
                return h("div", data, [this.genContainer()]);
              }
            });
          }
        ),
        /***/
        "./src/components/VWindow/VWindowItem.ts": (
          /*!***********************************************!*\
            !*** ./src/components/VWindow/VWindowItem.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mixins_bootable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../mixins/bootable */
              "./src/mixins/bootable/index.ts"
            );
            var _mixins_groupable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../mixins/groupable */
              "./src/mixins/groupable/index.ts"
            );
            var _directives_touch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../directives/touch */
              "./src/directives/touch/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_bootable__WEBPACK_IMPORTED_MODULE_0__["default"], Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_1__["factory"])("windowGroup", "v-window-item", "v-window"));
            __webpack_exports__["default"] = baseMixins.extend().extend().extend({
              name: "v-window-item",
              directives: {
                Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_2__["default"]
              },
              props: {
                disabled: Boolean,
                reverseTransition: {
                  type: [Boolean, String],
                  default: void 0
                },
                transition: {
                  type: [Boolean, String],
                  default: void 0
                },
                value: {
                  required: false
                }
              },
              data: function data() {
                return {
                  isActive: false,
                  inTransition: false
                };
              },
              computed: {
                classes: function classes() {
                  return this.groupClasses;
                },
                computedTransition: function computedTransition() {
                  if (!this.windowGroup.internalReverse) {
                    return typeof this.transition !== "undefined" ? this.transition || "" : this.windowGroup.computedTransition;
                  }
                  return typeof this.reverseTransition !== "undefined" ? this.reverseTransition || "" : this.windowGroup.computedTransition;
                }
              },
              methods: {
                genDefaultSlot: function genDefaultSlot() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this);
                },
                genWindowItem: function genWindowItem() {
                  return this.$createElement("div", {
                    staticClass: "v-window-item",
                    class: this.classes,
                    directives: [{
                      name: "show",
                      value: this.isActive
                    }],
                    on: this.$listeners
                  }, this.genDefaultSlot());
                },
                onAfterTransition: function onAfterTransition() {
                  if (!this.inTransition) {
                    return;
                  }
                  this.inTransition = false;
                  if (this.windowGroup.transitionCount > 0) {
                    this.windowGroup.transitionCount--;
                    if (this.windowGroup.transitionCount === 0) {
                      this.windowGroup.transitionHeight = void 0;
                    }
                  }
                },
                onBeforeTransition: function onBeforeTransition() {
                  if (this.inTransition) {
                    return;
                  }
                  this.inTransition = true;
                  if (this.windowGroup.transitionCount === 0) {
                    this.windowGroup.transitionHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.windowGroup.$el.clientHeight);
                  }
                  this.windowGroup.transitionCount++;
                },
                onTransitionCancelled: function onTransitionCancelled() {
                  this.onAfterTransition();
                },
                onEnter: function onEnter(el) {
                  var _this2 = this;
                  if (!this.inTransition) {
                    return;
                  }
                  this.$nextTick(function() {
                    if (!_this2.computedTransition || !_this2.inTransition) {
                      return;
                    }
                    _this2.windowGroup.transitionHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(el.clientHeight);
                  });
                }
              },
              render: function render8(h) {
                var _this2 = this;
                return h("transition", {
                  props: {
                    name: this.computedTransition
                  },
                  on: {
                    // Handlers for enter windows.
                    beforeEnter: this.onBeforeTransition,
                    afterEnter: this.onAfterTransition,
                    enterCancelled: this.onTransitionCancelled,
                    // Handlers for leave windows.
                    beforeLeave: this.onBeforeTransition,
                    afterLeave: this.onAfterTransition,
                    leaveCancelled: this.onTransitionCancelled,
                    // Enter handler for height transition.
                    enter: this.onEnter
                  }
                }, this.showLazyContent(function() {
                  return [_this2.genWindowItem()];
                }));
              }
            });
          }
        ),
        /***/
        "./src/components/VWindow/index.ts": (
          /*!*****************************************!*\
            !*** ./src/components/VWindow/index.ts ***!
            \*****************************************/
          /*! exports provided: VWindow, VWindowItem, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VWindow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VWindow */
              "./src/components/VWindow/VWindow.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VWindow", function() {
              return _VWindow__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _VWindowItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VWindowItem */
              "./src/components/VWindow/VWindowItem.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VWindowItem", function() {
              return _VWindowItem__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VWindow: _VWindow__WEBPACK_IMPORTED_MODULE_0__["default"],
                VWindowItem: _VWindowItem__WEBPACK_IMPORTED_MODULE_1__["default"]
              }
            };
          }
        ),
        /***/
        "./src/components/index.ts": (
          /*!*********************************!*\
            !*** ./src/components/index.ts ***!
            \*********************************/
          /*! exports provided: VApp, VAppBar, VAppBarNavIcon, VAppBarTitle, VAlert, VAutocomplete, VAvatar, VBadge, VBanner, VBottomNavigation, VBottomSheet, VBreadcrumbs, VBreadcrumbsItem, VBreadcrumbsDivider, VBtn, VBtnToggle, VCalendar, VCalendarCategory, VCalendarDaily, VCalendarWeekly, VCalendarMonthly, VCard, VCardActions, VCardSubtitle, VCardText, VCardTitle, VCarousel, VCarouselItem, VCheckbox, VSimpleCheckbox, VChip, VChipGroup, VColorPicker, VColorPickerSwatches, VColorPickerCanvas, VContent, VCombobox, VCounter, VData, VDataIterator, VDataFooter, VDataTable, VEditDialog, VTableOverflow, VDataTableHeader, VSimpleTable, VVirtualTable, VDatePicker, VDatePickerTitle, VDatePickerHeader, VDatePickerDateTable, VDatePickerMonthTable, VDatePickerYears, VDialog, VDivider, VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent, VFileInput, VFooter, VForm, VContainer, VCol, VRow, VSpacer, VLayout, VFlex, VHover, VIcon, VImg, VInput, VItem, VItemGroup, VLabel, VLazy, VListItemActionText, VListItemContent, VListItemTitle, VListItemSubtitle, VList, VListGroup, VListItem, VListItemAction, VListItemAvatar, VListItemIcon, VListItemGroup, VMain, VMenu, VMessages, VNavigationDrawer, VOtpInput, VOverflowBtn, VOverlay, VPagination, VSheet, VParallax, VPicker, VProgressCircular, VProgressLinear, VRadioGroup, VRadio, VRangeSlider, VRating, VResponsive, VSelect, VSkeletonLoader, VSlider, VSlideGroup, VSlideItem, VSnackbar, VSparkline, VSpeedDial, VStepper, VStepperContent, VStepperStep, VStepperHeader, VStepperItems, VSubheader, VSwitch, VSystemBar, VTabs, VTab, VTabItem, VTabsItems, VTabsSlider, VTextarea, VTextField, VThemeProvider, VTimeline, VTimelineItem, VTimePicker, VTimePickerClock, VTimePickerTitle, VToolbar, VToolbarItems, VToolbarTitle, VTooltip, VTreeview, VTreeviewNode, VVirtualScroll, VWindow, VWindowItem, VCarouselTransition, VCarouselReverseTransition, VTabTransition, VTabReverseTransition, VMenuTransition, VFabTransition, VDialogTransition, VDialogBottomTransition, VDialogTopTransition, VFadeTransition, VScaleTransition, VScrollXTransition, VScrollXReverseTransition, VScrollYTransition, VScrollYReverseTransition, VSlideXTransition, VSlideXReverseTransition, VSlideYTransition, VSlideYReverseTransition, VExpandTransition, VExpandXTransition */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _VApp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./VApp */
              "./src/components/VApp/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VApp", function() {
              return _VApp__WEBPACK_IMPORTED_MODULE_0__["VApp"];
            });
            var _VAppBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./VAppBar */
              "./src/components/VAppBar/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VAppBar", function() {
              return _VAppBar__WEBPACK_IMPORTED_MODULE_1__["VAppBar"];
            });
            __webpack_require__.d(__webpack_exports__, "VAppBarNavIcon", function() {
              return _VAppBar__WEBPACK_IMPORTED_MODULE_1__["VAppBarNavIcon"];
            });
            __webpack_require__.d(__webpack_exports__, "VAppBarTitle", function() {
              return _VAppBar__WEBPACK_IMPORTED_MODULE_1__["VAppBarTitle"];
            });
            var _VAlert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./VAlert */
              "./src/components/VAlert/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VAlert", function() {
              return _VAlert__WEBPACK_IMPORTED_MODULE_2__["VAlert"];
            });
            var _VAutocomplete__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./VAutocomplete */
              "./src/components/VAutocomplete/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VAutocomplete", function() {
              return _VAutocomplete__WEBPACK_IMPORTED_MODULE_3__["VAutocomplete"];
            });
            var _VAvatar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./VAvatar */
              "./src/components/VAvatar/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VAvatar", function() {
              return _VAvatar__WEBPACK_IMPORTED_MODULE_4__["VAvatar"];
            });
            var _VBadge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./VBadge */
              "./src/components/VBadge/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBadge", function() {
              return _VBadge__WEBPACK_IMPORTED_MODULE_5__["VBadge"];
            });
            var _VBanner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ./VBanner */
              "./src/components/VBanner/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBanner", function() {
              return _VBanner__WEBPACK_IMPORTED_MODULE_6__["VBanner"];
            });
            var _VBottomNavigation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ./VBottomNavigation */
              "./src/components/VBottomNavigation/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBottomNavigation", function() {
              return _VBottomNavigation__WEBPACK_IMPORTED_MODULE_7__["VBottomNavigation"];
            });
            var _VBottomSheet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ./VBottomSheet */
              "./src/components/VBottomSheet/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBottomSheet", function() {
              return _VBottomSheet__WEBPACK_IMPORTED_MODULE_8__["VBottomSheet"];
            });
            var _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ./VBreadcrumbs */
              "./src/components/VBreadcrumbs/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBreadcrumbs", function() {
              return _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_9__["VBreadcrumbs"];
            });
            __webpack_require__.d(__webpack_exports__, "VBreadcrumbsItem", function() {
              return _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_9__["VBreadcrumbsItem"];
            });
            __webpack_require__.d(__webpack_exports__, "VBreadcrumbsDivider", function() {
              return _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_9__["VBreadcrumbsDivider"];
            });
            var _VBtn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ./VBtn */
              "./src/components/VBtn/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBtn", function() {
              return _VBtn__WEBPACK_IMPORTED_MODULE_10__["VBtn"];
            });
            var _VBtnToggle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ./VBtnToggle */
              "./src/components/VBtnToggle/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VBtnToggle", function() {
              return _VBtnToggle__WEBPACK_IMPORTED_MODULE_11__["VBtnToggle"];
            });
            var _VCalendar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
              /*! ./VCalendar */
              "./src/components/VCalendar/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCalendar", function() {
              return _VCalendar__WEBPACK_IMPORTED_MODULE_12__["VCalendar"];
            });
            __webpack_require__.d(__webpack_exports__, "VCalendarCategory", function() {
              return _VCalendar__WEBPACK_IMPORTED_MODULE_12__["VCalendarCategory"];
            });
            __webpack_require__.d(__webpack_exports__, "VCalendarDaily", function() {
              return _VCalendar__WEBPACK_IMPORTED_MODULE_12__["VCalendarDaily"];
            });
            __webpack_require__.d(__webpack_exports__, "VCalendarWeekly", function() {
              return _VCalendar__WEBPACK_IMPORTED_MODULE_12__["VCalendarWeekly"];
            });
            __webpack_require__.d(__webpack_exports__, "VCalendarMonthly", function() {
              return _VCalendar__WEBPACK_IMPORTED_MODULE_12__["VCalendarMonthly"];
            });
            var _VCard__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
              /*! ./VCard */
              "./src/components/VCard/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCard", function() {
              return _VCard__WEBPACK_IMPORTED_MODULE_13__["VCard"];
            });
            __webpack_require__.d(__webpack_exports__, "VCardActions", function() {
              return _VCard__WEBPACK_IMPORTED_MODULE_13__["VCardActions"];
            });
            __webpack_require__.d(__webpack_exports__, "VCardSubtitle", function() {
              return _VCard__WEBPACK_IMPORTED_MODULE_13__["VCardSubtitle"];
            });
            __webpack_require__.d(__webpack_exports__, "VCardText", function() {
              return _VCard__WEBPACK_IMPORTED_MODULE_13__["VCardText"];
            });
            __webpack_require__.d(__webpack_exports__, "VCardTitle", function() {
              return _VCard__WEBPACK_IMPORTED_MODULE_13__["VCardTitle"];
            });
            var _VCarousel__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
              /*! ./VCarousel */
              "./src/components/VCarousel/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCarousel", function() {
              return _VCarousel__WEBPACK_IMPORTED_MODULE_14__["VCarousel"];
            });
            __webpack_require__.d(__webpack_exports__, "VCarouselItem", function() {
              return _VCarousel__WEBPACK_IMPORTED_MODULE_14__["VCarouselItem"];
            });
            var _VCheckbox__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
              /*! ./VCheckbox */
              "./src/components/VCheckbox/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCheckbox", function() {
              return _VCheckbox__WEBPACK_IMPORTED_MODULE_15__["VCheckbox"];
            });
            __webpack_require__.d(__webpack_exports__, "VSimpleCheckbox", function() {
              return _VCheckbox__WEBPACK_IMPORTED_MODULE_15__["VSimpleCheckbox"];
            });
            var _VChip__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
              /*! ./VChip */
              "./src/components/VChip/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VChip", function() {
              return _VChip__WEBPACK_IMPORTED_MODULE_16__["VChip"];
            });
            var _VChipGroup__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
              /*! ./VChipGroup */
              "./src/components/VChipGroup/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VChipGroup", function() {
              return _VChipGroup__WEBPACK_IMPORTED_MODULE_17__["VChipGroup"];
            });
            var _VColorPicker__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
              /*! ./VColorPicker */
              "./src/components/VColorPicker/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VColorPicker", function() {
              return _VColorPicker__WEBPACK_IMPORTED_MODULE_18__["VColorPicker"];
            });
            __webpack_require__.d(__webpack_exports__, "VColorPickerSwatches", function() {
              return _VColorPicker__WEBPACK_IMPORTED_MODULE_18__["VColorPickerSwatches"];
            });
            __webpack_require__.d(__webpack_exports__, "VColorPickerCanvas", function() {
              return _VColorPicker__WEBPACK_IMPORTED_MODULE_18__["VColorPickerCanvas"];
            });
            var _VContent__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
              /*! ./VContent */
              "./src/components/VContent/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VContent", function() {
              return _VContent__WEBPACK_IMPORTED_MODULE_19__["VContent"];
            });
            var _VCombobox__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
              /*! ./VCombobox */
              "./src/components/VCombobox/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCombobox", function() {
              return _VCombobox__WEBPACK_IMPORTED_MODULE_20__["VCombobox"];
            });
            var _VCounter__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
              /*! ./VCounter */
              "./src/components/VCounter/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCounter", function() {
              return _VCounter__WEBPACK_IMPORTED_MODULE_21__["VCounter"];
            });
            var _VData__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
              /*! ./VData */
              "./src/components/VData/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VData", function() {
              return _VData__WEBPACK_IMPORTED_MODULE_22__["VData"];
            });
            var _VDataIterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
              /*! ./VDataIterator */
              "./src/components/VDataIterator/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDataIterator", function() {
              return _VDataIterator__WEBPACK_IMPORTED_MODULE_23__["VDataIterator"];
            });
            __webpack_require__.d(__webpack_exports__, "VDataFooter", function() {
              return _VDataIterator__WEBPACK_IMPORTED_MODULE_23__["VDataFooter"];
            });
            var _VDataTable__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
              /*! ./VDataTable */
              "./src/components/VDataTable/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDataTable", function() {
              return _VDataTable__WEBPACK_IMPORTED_MODULE_24__["VDataTable"];
            });
            __webpack_require__.d(__webpack_exports__, "VEditDialog", function() {
              return _VDataTable__WEBPACK_IMPORTED_MODULE_24__["VEditDialog"];
            });
            __webpack_require__.d(__webpack_exports__, "VTableOverflow", function() {
              return _VDataTable__WEBPACK_IMPORTED_MODULE_24__["VTableOverflow"];
            });
            __webpack_require__.d(__webpack_exports__, "VDataTableHeader", function() {
              return _VDataTable__WEBPACK_IMPORTED_MODULE_24__["VDataTableHeader"];
            });
            __webpack_require__.d(__webpack_exports__, "VSimpleTable", function() {
              return _VDataTable__WEBPACK_IMPORTED_MODULE_24__["VSimpleTable"];
            });
            __webpack_require__.d(__webpack_exports__, "VVirtualTable", function() {
              return _VDataTable__WEBPACK_IMPORTED_MODULE_24__["VVirtualTable"];
            });
            var _VDatePicker__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
              /*! ./VDatePicker */
              "./src/components/VDatePicker/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDatePicker", function() {
              return _VDatePicker__WEBPACK_IMPORTED_MODULE_25__["VDatePicker"];
            });
            __webpack_require__.d(__webpack_exports__, "VDatePickerTitle", function() {
              return _VDatePicker__WEBPACK_IMPORTED_MODULE_25__["VDatePickerTitle"];
            });
            __webpack_require__.d(__webpack_exports__, "VDatePickerHeader", function() {
              return _VDatePicker__WEBPACK_IMPORTED_MODULE_25__["VDatePickerHeader"];
            });
            __webpack_require__.d(__webpack_exports__, "VDatePickerDateTable", function() {
              return _VDatePicker__WEBPACK_IMPORTED_MODULE_25__["VDatePickerDateTable"];
            });
            __webpack_require__.d(__webpack_exports__, "VDatePickerMonthTable", function() {
              return _VDatePicker__WEBPACK_IMPORTED_MODULE_25__["VDatePickerMonthTable"];
            });
            __webpack_require__.d(__webpack_exports__, "VDatePickerYears", function() {
              return _VDatePicker__WEBPACK_IMPORTED_MODULE_25__["VDatePickerYears"];
            });
            var _VDialog__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
              /*! ./VDialog */
              "./src/components/VDialog/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDialog", function() {
              return _VDialog__WEBPACK_IMPORTED_MODULE_26__["VDialog"];
            });
            var _VDivider__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
              /*! ./VDivider */
              "./src/components/VDivider/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VDivider", function() {
              return _VDivider__WEBPACK_IMPORTED_MODULE_27__["VDivider"];
            });
            var _VExpansionPanel__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(
              /*! ./VExpansionPanel */
              "./src/components/VExpansionPanel/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VExpansionPanels", function() {
              return _VExpansionPanel__WEBPACK_IMPORTED_MODULE_28__["VExpansionPanels"];
            });
            __webpack_require__.d(__webpack_exports__, "VExpansionPanel", function() {
              return _VExpansionPanel__WEBPACK_IMPORTED_MODULE_28__["VExpansionPanel"];
            });
            __webpack_require__.d(__webpack_exports__, "VExpansionPanelHeader", function() {
              return _VExpansionPanel__WEBPACK_IMPORTED_MODULE_28__["VExpansionPanelHeader"];
            });
            __webpack_require__.d(__webpack_exports__, "VExpansionPanelContent", function() {
              return _VExpansionPanel__WEBPACK_IMPORTED_MODULE_28__["VExpansionPanelContent"];
            });
            var _VFileInput__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(
              /*! ./VFileInput */
              "./src/components/VFileInput/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VFileInput", function() {
              return _VFileInput__WEBPACK_IMPORTED_MODULE_29__["VFileInput"];
            });
            var _VFooter__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(
              /*! ./VFooter */
              "./src/components/VFooter/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VFooter", function() {
              return _VFooter__WEBPACK_IMPORTED_MODULE_30__["VFooter"];
            });
            var _VForm__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(
              /*! ./VForm */
              "./src/components/VForm/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VForm", function() {
              return _VForm__WEBPACK_IMPORTED_MODULE_31__["VForm"];
            });
            var _VGrid__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(
              /*! ./VGrid */
              "./src/components/VGrid/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VContainer", function() {
              return _VGrid__WEBPACK_IMPORTED_MODULE_32__["VContainer"];
            });
            __webpack_require__.d(__webpack_exports__, "VCol", function() {
              return _VGrid__WEBPACK_IMPORTED_MODULE_32__["VCol"];
            });
            __webpack_require__.d(__webpack_exports__, "VRow", function() {
              return _VGrid__WEBPACK_IMPORTED_MODULE_32__["VRow"];
            });
            __webpack_require__.d(__webpack_exports__, "VSpacer", function() {
              return _VGrid__WEBPACK_IMPORTED_MODULE_32__["VSpacer"];
            });
            __webpack_require__.d(__webpack_exports__, "VLayout", function() {
              return _VGrid__WEBPACK_IMPORTED_MODULE_32__["VLayout"];
            });
            __webpack_require__.d(__webpack_exports__, "VFlex", function() {
              return _VGrid__WEBPACK_IMPORTED_MODULE_32__["VFlex"];
            });
            var _VHover__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(
              /*! ./VHover */
              "./src/components/VHover/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VHover", function() {
              return _VHover__WEBPACK_IMPORTED_MODULE_33__["VHover"];
            });
            var _VIcon__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(
              /*! ./VIcon */
              "./src/components/VIcon/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VIcon", function() {
              return _VIcon__WEBPACK_IMPORTED_MODULE_34__["VIcon"];
            });
            var _VImg__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(
              /*! ./VImg */
              "./src/components/VImg/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VImg", function() {
              return _VImg__WEBPACK_IMPORTED_MODULE_35__["VImg"];
            });
            var _VInput__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(
              /*! ./VInput */
              "./src/components/VInput/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VInput", function() {
              return _VInput__WEBPACK_IMPORTED_MODULE_36__["VInput"];
            });
            var _VItemGroup__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(
              /*! ./VItemGroup */
              "./src/components/VItemGroup/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VItem", function() {
              return _VItemGroup__WEBPACK_IMPORTED_MODULE_37__["VItem"];
            });
            __webpack_require__.d(__webpack_exports__, "VItemGroup", function() {
              return _VItemGroup__WEBPACK_IMPORTED_MODULE_37__["VItemGroup"];
            });
            var _VLabel__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(
              /*! ./VLabel */
              "./src/components/VLabel/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VLabel", function() {
              return _VLabel__WEBPACK_IMPORTED_MODULE_38__["VLabel"];
            });
            var _VLazy__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(
              /*! ./VLazy */
              "./src/components/VLazy/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VLazy", function() {
              return _VLazy__WEBPACK_IMPORTED_MODULE_39__["VLazy"];
            });
            var _VList__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(
              /*! ./VList */
              "./src/components/VList/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VListItemActionText", function() {
              return _VList__WEBPACK_IMPORTED_MODULE_40__["VListItemActionText"];
            });
            __webpack_require__.d(__webpack_exports__, "VListItemContent", function() {
              return _VList__WEBPACK_IMPORTED_MODULE_40__["VListItemContent"];
            });
            __webpack_require__.d(__webpack_exports__, "VListItemTitle", function() {
              return _VList__WEBPACK_IMPORTED_MODULE_40__["VListItemTitle"];
            });
            __webpack_require__.d(__webpack_exports__, "VListItemSubtitle", function() {
              return _VList__WEBPACK_IMPORTED_MODULE_40__["VListItemSubtitle"];
            });
            __webpack_require__.d(__webpack_exports__, "VList", function() {
              return _VList__WEBPACK_IMPORTED_MODULE_40__["VList"];
            });
            __webpack_require__.d(__webpack_exports__, "VListGroup", function() {
              return _VList__WEBPACK_IMPORTED_MODULE_40__["VListGroup"];
            });
            __webpack_require__.d(__webpack_exports__, "VListItem", function() {
              return _VList__WEBPACK_IMPORTED_MODULE_40__["VListItem"];
            });
            __webpack_require__.d(__webpack_exports__, "VListItemAction", function() {
              return _VList__WEBPACK_IMPORTED_MODULE_40__["VListItemAction"];
            });
            __webpack_require__.d(__webpack_exports__, "VListItemAvatar", function() {
              return _VList__WEBPACK_IMPORTED_MODULE_40__["VListItemAvatar"];
            });
            __webpack_require__.d(__webpack_exports__, "VListItemIcon", function() {
              return _VList__WEBPACK_IMPORTED_MODULE_40__["VListItemIcon"];
            });
            __webpack_require__.d(__webpack_exports__, "VListItemGroup", function() {
              return _VList__WEBPACK_IMPORTED_MODULE_40__["VListItemGroup"];
            });
            var _VMain__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(
              /*! ./VMain */
              "./src/components/VMain/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VMain", function() {
              return _VMain__WEBPACK_IMPORTED_MODULE_41__["VMain"];
            });
            var _VMenu__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(
              /*! ./VMenu */
              "./src/components/VMenu/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VMenu", function() {
              return _VMenu__WEBPACK_IMPORTED_MODULE_42__["VMenu"];
            });
            var _VMessages__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(
              /*! ./VMessages */
              "./src/components/VMessages/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VMessages", function() {
              return _VMessages__WEBPACK_IMPORTED_MODULE_43__["VMessages"];
            });
            var _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(
              /*! ./VNavigationDrawer */
              "./src/components/VNavigationDrawer/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VNavigationDrawer", function() {
              return _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_44__["VNavigationDrawer"];
            });
            var _VOtpInput__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(
              /*! ./VOtpInput */
              "./src/components/VOtpInput/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VOtpInput", function() {
              return _VOtpInput__WEBPACK_IMPORTED_MODULE_45__["VOtpInput"];
            });
            var _VOverflowBtn__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(
              /*! ./VOverflowBtn */
              "./src/components/VOverflowBtn/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VOverflowBtn", function() {
              return _VOverflowBtn__WEBPACK_IMPORTED_MODULE_46__["VOverflowBtn"];
            });
            var _VOverlay__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(
              /*! ./VOverlay */
              "./src/components/VOverlay/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VOverlay", function() {
              return _VOverlay__WEBPACK_IMPORTED_MODULE_47__["VOverlay"];
            });
            var _VPagination__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(
              /*! ./VPagination */
              "./src/components/VPagination/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VPagination", function() {
              return _VPagination__WEBPACK_IMPORTED_MODULE_48__["VPagination"];
            });
            var _VSheet__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(
              /*! ./VSheet */
              "./src/components/VSheet/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSheet", function() {
              return _VSheet__WEBPACK_IMPORTED_MODULE_49__["VSheet"];
            });
            var _VParallax__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(
              /*! ./VParallax */
              "./src/components/VParallax/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VParallax", function() {
              return _VParallax__WEBPACK_IMPORTED_MODULE_50__["VParallax"];
            });
            var _VPicker__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(
              /*! ./VPicker */
              "./src/components/VPicker/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VPicker", function() {
              return _VPicker__WEBPACK_IMPORTED_MODULE_51__["VPicker"];
            });
            var _VProgressCircular__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(
              /*! ./VProgressCircular */
              "./src/components/VProgressCircular/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VProgressCircular", function() {
              return _VProgressCircular__WEBPACK_IMPORTED_MODULE_52__["VProgressCircular"];
            });
            var _VProgressLinear__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(
              /*! ./VProgressLinear */
              "./src/components/VProgressLinear/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VProgressLinear", function() {
              return _VProgressLinear__WEBPACK_IMPORTED_MODULE_53__["VProgressLinear"];
            });
            var _VRadioGroup__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(
              /*! ./VRadioGroup */
              "./src/components/VRadioGroup/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VRadioGroup", function() {
              return _VRadioGroup__WEBPACK_IMPORTED_MODULE_54__["VRadioGroup"];
            });
            __webpack_require__.d(__webpack_exports__, "VRadio", function() {
              return _VRadioGroup__WEBPACK_IMPORTED_MODULE_54__["VRadio"];
            });
            var _VRangeSlider__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(
              /*! ./VRangeSlider */
              "./src/components/VRangeSlider/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VRangeSlider", function() {
              return _VRangeSlider__WEBPACK_IMPORTED_MODULE_55__["VRangeSlider"];
            });
            var _VRating__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(
              /*! ./VRating */
              "./src/components/VRating/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VRating", function() {
              return _VRating__WEBPACK_IMPORTED_MODULE_56__["VRating"];
            });
            var _VResponsive__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(
              /*! ./VResponsive */
              "./src/components/VResponsive/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VResponsive", function() {
              return _VResponsive__WEBPACK_IMPORTED_MODULE_57__["VResponsive"];
            });
            var _VSelect__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(
              /*! ./VSelect */
              "./src/components/VSelect/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSelect", function() {
              return _VSelect__WEBPACK_IMPORTED_MODULE_58__["VSelect"];
            });
            var _VSkeletonLoader__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(
              /*! ./VSkeletonLoader */
              "./src/components/VSkeletonLoader/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSkeletonLoader", function() {
              return _VSkeletonLoader__WEBPACK_IMPORTED_MODULE_59__["VSkeletonLoader"];
            });
            var _VSlider__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(
              /*! ./VSlider */
              "./src/components/VSlider/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSlider", function() {
              return _VSlider__WEBPACK_IMPORTED_MODULE_60__["VSlider"];
            });
            var _VSlideGroup__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(
              /*! ./VSlideGroup */
              "./src/components/VSlideGroup/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSlideGroup", function() {
              return _VSlideGroup__WEBPACK_IMPORTED_MODULE_61__["VSlideGroup"];
            });
            __webpack_require__.d(__webpack_exports__, "VSlideItem", function() {
              return _VSlideGroup__WEBPACK_IMPORTED_MODULE_61__["VSlideItem"];
            });
            var _VSnackbar__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(
              /*! ./VSnackbar */
              "./src/components/VSnackbar/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSnackbar", function() {
              return _VSnackbar__WEBPACK_IMPORTED_MODULE_62__["VSnackbar"];
            });
            var _VSparkline__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(
              /*! ./VSparkline */
              "./src/components/VSparkline/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSparkline", function() {
              return _VSparkline__WEBPACK_IMPORTED_MODULE_63__["VSparkline"];
            });
            var _VSpeedDial__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(
              /*! ./VSpeedDial */
              "./src/components/VSpeedDial/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSpeedDial", function() {
              return _VSpeedDial__WEBPACK_IMPORTED_MODULE_64__["VSpeedDial"];
            });
            var _VStepper__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(
              /*! ./VStepper */
              "./src/components/VStepper/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VStepper", function() {
              return _VStepper__WEBPACK_IMPORTED_MODULE_65__["VStepper"];
            });
            __webpack_require__.d(__webpack_exports__, "VStepperContent", function() {
              return _VStepper__WEBPACK_IMPORTED_MODULE_65__["VStepperContent"];
            });
            __webpack_require__.d(__webpack_exports__, "VStepperStep", function() {
              return _VStepper__WEBPACK_IMPORTED_MODULE_65__["VStepperStep"];
            });
            __webpack_require__.d(__webpack_exports__, "VStepperHeader", function() {
              return _VStepper__WEBPACK_IMPORTED_MODULE_65__["VStepperHeader"];
            });
            __webpack_require__.d(__webpack_exports__, "VStepperItems", function() {
              return _VStepper__WEBPACK_IMPORTED_MODULE_65__["VStepperItems"];
            });
            var _VSubheader__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(
              /*! ./VSubheader */
              "./src/components/VSubheader/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSubheader", function() {
              return _VSubheader__WEBPACK_IMPORTED_MODULE_66__["VSubheader"];
            });
            var _VSwitch__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(
              /*! ./VSwitch */
              "./src/components/VSwitch/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSwitch", function() {
              return _VSwitch__WEBPACK_IMPORTED_MODULE_67__["VSwitch"];
            });
            var _VSystemBar__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(
              /*! ./VSystemBar */
              "./src/components/VSystemBar/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VSystemBar", function() {
              return _VSystemBar__WEBPACK_IMPORTED_MODULE_68__["VSystemBar"];
            });
            var _VTabs__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(
              /*! ./VTabs */
              "./src/components/VTabs/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTabs", function() {
              return _VTabs__WEBPACK_IMPORTED_MODULE_69__["VTabs"];
            });
            __webpack_require__.d(__webpack_exports__, "VTab", function() {
              return _VTabs__WEBPACK_IMPORTED_MODULE_69__["VTab"];
            });
            __webpack_require__.d(__webpack_exports__, "VTabItem", function() {
              return _VTabs__WEBPACK_IMPORTED_MODULE_69__["VTabItem"];
            });
            __webpack_require__.d(__webpack_exports__, "VTabsItems", function() {
              return _VTabs__WEBPACK_IMPORTED_MODULE_69__["VTabsItems"];
            });
            __webpack_require__.d(__webpack_exports__, "VTabsSlider", function() {
              return _VTabs__WEBPACK_IMPORTED_MODULE_69__["VTabsSlider"];
            });
            var _VTextarea__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(
              /*! ./VTextarea */
              "./src/components/VTextarea/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTextarea", function() {
              return _VTextarea__WEBPACK_IMPORTED_MODULE_70__["VTextarea"];
            });
            var _VTextField__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(
              /*! ./VTextField */
              "./src/components/VTextField/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTextField", function() {
              return _VTextField__WEBPACK_IMPORTED_MODULE_71__["VTextField"];
            });
            var _VThemeProvider__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(
              /*! ./VThemeProvider */
              "./src/components/VThemeProvider/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VThemeProvider", function() {
              return _VThemeProvider__WEBPACK_IMPORTED_MODULE_72__["VThemeProvider"];
            });
            var _VTimeline__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(
              /*! ./VTimeline */
              "./src/components/VTimeline/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTimeline", function() {
              return _VTimeline__WEBPACK_IMPORTED_MODULE_73__["VTimeline"];
            });
            __webpack_require__.d(__webpack_exports__, "VTimelineItem", function() {
              return _VTimeline__WEBPACK_IMPORTED_MODULE_73__["VTimelineItem"];
            });
            var _VTimePicker__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(
              /*! ./VTimePicker */
              "./src/components/VTimePicker/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTimePicker", function() {
              return _VTimePicker__WEBPACK_IMPORTED_MODULE_74__["VTimePicker"];
            });
            __webpack_require__.d(__webpack_exports__, "VTimePickerClock", function() {
              return _VTimePicker__WEBPACK_IMPORTED_MODULE_74__["VTimePickerClock"];
            });
            __webpack_require__.d(__webpack_exports__, "VTimePickerTitle", function() {
              return _VTimePicker__WEBPACK_IMPORTED_MODULE_74__["VTimePickerTitle"];
            });
            var _VToolbar__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(
              /*! ./VToolbar */
              "./src/components/VToolbar/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VToolbar", function() {
              return _VToolbar__WEBPACK_IMPORTED_MODULE_75__["VToolbar"];
            });
            __webpack_require__.d(__webpack_exports__, "VToolbarItems", function() {
              return _VToolbar__WEBPACK_IMPORTED_MODULE_75__["VToolbarItems"];
            });
            __webpack_require__.d(__webpack_exports__, "VToolbarTitle", function() {
              return _VToolbar__WEBPACK_IMPORTED_MODULE_75__["VToolbarTitle"];
            });
            var _VTooltip__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(
              /*! ./VTooltip */
              "./src/components/VTooltip/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTooltip", function() {
              return _VTooltip__WEBPACK_IMPORTED_MODULE_76__["VTooltip"];
            });
            var _VTreeview__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(
              /*! ./VTreeview */
              "./src/components/VTreeview/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VTreeview", function() {
              return _VTreeview__WEBPACK_IMPORTED_MODULE_77__["VTreeview"];
            });
            __webpack_require__.d(__webpack_exports__, "VTreeviewNode", function() {
              return _VTreeview__WEBPACK_IMPORTED_MODULE_77__["VTreeviewNode"];
            });
            var _VVirtualScroll__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(
              /*! ./VVirtualScroll */
              "./src/components/VVirtualScroll/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VVirtualScroll", function() {
              return _VVirtualScroll__WEBPACK_IMPORTED_MODULE_78__["VVirtualScroll"];
            });
            var _VWindow__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(
              /*! ./VWindow */
              "./src/components/VWindow/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VWindow", function() {
              return _VWindow__WEBPACK_IMPORTED_MODULE_79__["VWindow"];
            });
            __webpack_require__.d(__webpack_exports__, "VWindowItem", function() {
              return _VWindow__WEBPACK_IMPORTED_MODULE_79__["VWindowItem"];
            });
            var _transitions__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(
              /*! ./transitions */
              "./src/components/transitions/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "VCarouselTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VCarouselTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VCarouselReverseTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VCarouselReverseTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VTabTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VTabTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VTabReverseTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VTabReverseTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VMenuTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VMenuTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VFabTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VFabTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VDialogTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VDialogTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VDialogBottomTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VDialogBottomTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VDialogTopTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VDialogTopTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VFadeTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VFadeTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VScaleTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VScaleTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VScrollXTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VScrollXTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VScrollXReverseTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VScrollXReverseTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VScrollYTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VScrollYTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VScrollYReverseTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VScrollYReverseTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VSlideXTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VSlideXTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VSlideXReverseTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VSlideXReverseTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VSlideYTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VSlideYTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VSlideYReverseTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VSlideYReverseTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VExpandTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VExpandTransition"];
            });
            __webpack_require__.d(__webpack_exports__, "VExpandXTransition", function() {
              return _transitions__WEBPACK_IMPORTED_MODULE_80__["VExpandXTransition"];
            });
          }
        ),
        /***/
        "./src/components/transitions/createTransition.ts": (
          /*!********************************************************!*\
            !*** ./src/components/transitions/createTransition.ts ***!
            \********************************************************/
          /*! exports provided: createSimpleTransition, createJavascriptTransition */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "createSimpleTransition", function() {
              return createSimpleTransition;
            });
            __webpack_require__.d(__webpack_exports__, "createJavascriptTransition", function() {
              return createJavascriptTransition;
            });
            var _util_mergeData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/mergeData */
              "./src/util/mergeData.ts"
            );
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            function mergeTransitions(dest) {
              var _a2;
              if (dest === void 0) {
                dest = [];
              }
              var transitions = [];
              for (var _i2 = 1; _i2 < arguments.length; _i2++) {
                transitions[_i2 - 1] = arguments[_i2];
              }
              return (_a2 = Array()).concat.apply(_a2, __spreadArray2([dest], __read2(transitions), false));
            }
            function createSimpleTransition(name, origin, mode) {
              if (origin === void 0) {
                origin = "top center 0";
              }
              return {
                name,
                functional: true,
                props: {
                  group: {
                    type: Boolean,
                    default: false
                  },
                  hideOnLeave: {
                    type: Boolean,
                    default: false
                  },
                  leaveAbsolute: {
                    type: Boolean,
                    default: false
                  },
                  mode: {
                    type: String,
                    default: mode
                  },
                  origin: {
                    type: String,
                    default: origin
                  }
                },
                render: function render8(h, context) {
                  var tag = "transition" + (context.props.group ? "-group" : "");
                  var data = {
                    props: {
                      name,
                      mode: context.props.mode
                    },
                    on: {
                      beforeEnter: function beforeEnter(el) {
                        el.style.transformOrigin = context.props.origin;
                        el.style.webkitTransformOrigin = context.props.origin;
                      }
                    }
                  };
                  if (context.props.leaveAbsolute) {
                    data.on.leave = mergeTransitions(data.on.leave, function(el) {
                      var offsetTop = el.offsetTop, offsetLeft = el.offsetLeft, offsetWidth = el.offsetWidth, offsetHeight = el.offsetHeight;
                      el._transitionInitialStyles = {
                        position: el.style.position,
                        top: el.style.top,
                        left: el.style.left,
                        width: el.style.width,
                        height: el.style.height
                      };
                      el.style.position = "absolute";
                      el.style.top = offsetTop + "px";
                      el.style.left = offsetLeft + "px";
                      el.style.width = offsetWidth + "px";
                      el.style.height = offsetHeight + "px";
                    });
                    data.on.afterLeave = mergeTransitions(data.on.afterLeave, function(el) {
                      if (el && el._transitionInitialStyles) {
                        var _a2 = el._transitionInitialStyles, position = _a2.position, top = _a2.top, left = _a2.left, width = _a2.width, height = _a2.height;
                        delete el._transitionInitialStyles;
                        el.style.position = position || "";
                        el.style.top = top || "";
                        el.style.left = left || "";
                        el.style.width = width || "";
                        el.style.height = height || "";
                      }
                    });
                  }
                  if (context.props.hideOnLeave) {
                    data.on.leave = mergeTransitions(data.on.leave, function(el) {
                      el.style.setProperty("display", "none", "important");
                    });
                  }
                  return h(tag, Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_0__["default"])(context.data, data), context.children);
                }
              };
            }
            function createJavascriptTransition(name, functions, mode) {
              if (mode === void 0) {
                mode = "in-out";
              }
              return {
                name,
                functional: true,
                props: {
                  mode: {
                    type: String,
                    default: mode
                  }
                },
                render: function render8(h, context) {
                  return h("transition", Object(_util_mergeData__WEBPACK_IMPORTED_MODULE_0__["default"])(context.data, {
                    props: {
                      name
                    },
                    on: functions
                  }), context.children);
                }
              };
            }
          }
        ),
        /***/
        "./src/components/transitions/expand-transition.ts": (
          /*!*********************************************************!*\
            !*** ./src/components/transitions/expand-transition.ts ***!
            \*********************************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = function(expandedParentClass, x2) {
              if (expandedParentClass === void 0) {
                expandedParentClass = "";
              }
              if (x2 === void 0) {
                x2 = false;
              }
              var sizeProperty = x2 ? "width" : "height";
              var offsetProperty = "offset" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["upperFirst"])(sizeProperty);
              return {
                beforeEnter: function beforeEnter(el) {
                  var _a2;
                  el._parent = el.parentNode;
                  el._initialStyle = (_a2 = {
                    transition: el.style.transition,
                    overflow: el.style.overflow
                  }, _a2[sizeProperty] = el.style[sizeProperty], _a2);
                },
                enter: function enter2(el) {
                  var initialStyle = el._initialStyle;
                  el.style.setProperty("transition", "none", "important");
                  el.style.overflow = "hidden";
                  var offset2 = el[offsetProperty] + "px";
                  el.style[sizeProperty] = "0";
                  void el.offsetHeight;
                  el.style.transition = initialStyle.transition;
                  if (expandedParentClass && el._parent) {
                    el._parent.classList.add(expandedParentClass);
                  }
                  requestAnimationFrame(function() {
                    el.style[sizeProperty] = offset2;
                  });
                },
                afterEnter: resetStyles,
                enterCancelled: resetStyles,
                leave: function leave2(el) {
                  var _a2;
                  el._initialStyle = (_a2 = {
                    transition: "",
                    overflow: el.style.overflow
                  }, _a2[sizeProperty] = el.style[sizeProperty], _a2);
                  el.style.overflow = "hidden";
                  el.style[sizeProperty] = el[offsetProperty] + "px";
                  void el.offsetHeight;
                  requestAnimationFrame(function() {
                    return el.style[sizeProperty] = "0";
                  });
                },
                afterLeave,
                leaveCancelled: afterLeave
              };
              function afterLeave(el) {
                if (expandedParentClass && el._parent) {
                  el._parent.classList.remove(expandedParentClass);
                }
                resetStyles(el);
              }
              function resetStyles(el) {
                var size = el._initialStyle[sizeProperty];
                el.style.overflow = el._initialStyle.overflow;
                if (size != null)
                  el.style[sizeProperty] = size;
                delete el._initialStyle;
              }
            };
          }
        ),
        /***/
        "./src/components/transitions/index.ts": (
          /*!*********************************************!*\
            !*** ./src/components/transitions/index.ts ***!
            \*********************************************/
          /*! exports provided: VCarouselTransition, VCarouselReverseTransition, VTabTransition, VTabReverseTransition, VMenuTransition, VFabTransition, VDialogTransition, VDialogBottomTransition, VDialogTopTransition, VFadeTransition, VScaleTransition, VScrollXTransition, VScrollXReverseTransition, VScrollYTransition, VScrollYReverseTransition, VSlideXTransition, VSlideXReverseTransition, VSlideYTransition, VSlideYReverseTransition, VExpandTransition, VExpandXTransition, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "VCarouselTransition", function() {
              return VCarouselTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VCarouselReverseTransition", function() {
              return VCarouselReverseTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VTabTransition", function() {
              return VTabTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VTabReverseTransition", function() {
              return VTabReverseTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VMenuTransition", function() {
              return VMenuTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VFabTransition", function() {
              return VFabTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VDialogTransition", function() {
              return VDialogTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VDialogBottomTransition", function() {
              return VDialogBottomTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VDialogTopTransition", function() {
              return VDialogTopTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VFadeTransition", function() {
              return VFadeTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VScaleTransition", function() {
              return VScaleTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VScrollXTransition", function() {
              return VScrollXTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VScrollXReverseTransition", function() {
              return VScrollXReverseTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VScrollYTransition", function() {
              return VScrollYTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VScrollYReverseTransition", function() {
              return VScrollYReverseTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VSlideXTransition", function() {
              return VSlideXTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VSlideXReverseTransition", function() {
              return VSlideXReverseTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VSlideYTransition", function() {
              return VSlideYTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VSlideYReverseTransition", function() {
              return VSlideYReverseTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VExpandTransition", function() {
              return VExpandTransition;
            });
            __webpack_require__.d(__webpack_exports__, "VExpandXTransition", function() {
              return VExpandXTransition;
            });
            var _createTransition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./createTransition */
              "./src/components/transitions/createTransition.ts"
            );
            var _expand_transition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./expand-transition */
              "./src/components/transitions/expand-transition.ts"
            );
            var VCarouselTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("carousel-transition");
            var VCarouselReverseTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("carousel-reverse-transition");
            var VTabTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("tab-transition");
            var VTabReverseTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("tab-reverse-transition");
            var VMenuTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("menu-transition");
            var VFabTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("fab-transition", "center center", "out-in");
            var VDialogTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("dialog-transition");
            var VDialogBottomTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("dialog-bottom-transition");
            var VDialogTopTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("dialog-top-transition");
            var VFadeTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("fade-transition");
            var VScaleTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("scale-transition");
            var VScrollXTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("scroll-x-transition");
            var VScrollXReverseTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("scroll-x-reverse-transition");
            var VScrollYTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("scroll-y-transition");
            var VScrollYReverseTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("scroll-y-reverse-transition");
            var VSlideXTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("slide-x-transition");
            var VSlideXReverseTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("slide-x-reverse-transition");
            var VSlideYTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("slide-y-transition");
            var VSlideYReverseTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])("slide-y-reverse-transition");
            var VExpandTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createJavascriptTransition"])("expand-transition", Object(_expand_transition__WEBPACK_IMPORTED_MODULE_1__["default"])());
            var VExpandXTransition = Object(_createTransition__WEBPACK_IMPORTED_MODULE_0__["createJavascriptTransition"])("expand-x-transition", Object(_expand_transition__WEBPACK_IMPORTED_MODULE_1__["default"])("", true));
            __webpack_exports__["default"] = {
              $_vuetify_subcomponents: {
                VCarouselTransition,
                VCarouselReverseTransition,
                VDialogTransition,
                VDialogBottomTransition,
                VDialogTopTransition,
                VFabTransition,
                VFadeTransition,
                VMenuTransition,
                VScaleTransition,
                VScrollXTransition,
                VScrollXReverseTransition,
                VScrollYTransition,
                VScrollYReverseTransition,
                VSlideXTransition,
                VSlideXReverseTransition,
                VSlideYTransition,
                VSlideYReverseTransition,
                VTabReverseTransition,
                VTabTransition,
                VExpandTransition,
                VExpandXTransition
              }
            };
          }
        ),
        /***/
        "./src/directives/click-outside/index.ts": (
          /*!***********************************************!*\
            !*** ./src/directives/click-outside/index.ts ***!
            \***********************************************/
          /*! exports provided: ClickOutside, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "ClickOutside", function() {
              return ClickOutside;
            });
            var _util_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/dom */
              "./src/util/dom.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            function defaultConditional() {
              return true;
            }
            function checkEvent(e, el, binding) {
              if (!e || checkIsActive(e, binding) === false)
                return false;
              var root2 = Object(_util_dom__WEBPACK_IMPORTED_MODULE_0__["attachedRoot"])(el);
              if (typeof ShadowRoot !== "undefined" && root2 instanceof ShadowRoot && root2.host === e.target)
                return false;
              var elements = (_typeof2(binding.value) === "object" && binding.value.include || function() {
                return [];
              })();
              elements.push(el);
              return !elements.some(function(el2) {
                return el2.contains(e.target);
              });
            }
            function checkIsActive(e, binding) {
              var isActive = _typeof2(binding.value) === "object" && binding.value.closeConditional || defaultConditional;
              return isActive(e);
            }
            function directive2(e, el, binding) {
              var handler = typeof binding.value === "function" ? binding.value : binding.value.handler;
              el._clickOutside.lastMousedownWasOutside && checkEvent(e, el, binding) && setTimeout(function() {
                checkIsActive(e, binding) && handler && handler(e);
              }, 0);
            }
            function handleShadow(el, callback) {
              var root2 = Object(_util_dom__WEBPACK_IMPORTED_MODULE_0__["attachedRoot"])(el);
              callback(document);
              if (typeof ShadowRoot !== "undefined" && root2 instanceof ShadowRoot) {
                callback(root2);
              }
            }
            var ClickOutside = {
              // [data-app] may not be found
              // if using bind, inserted makes
              // sure that the root element is
              // available, iOS does not support
              // clicks on body
              inserted: function inserted2(el, binding, vnode) {
                var onClick = function onClick2(e) {
                  return directive2(e, el, binding);
                };
                var onMousedown = function onMousedown2(e) {
                  el._clickOutside.lastMousedownWasOutside = checkEvent(e, el, binding);
                };
                handleShadow(el, function(app) {
                  app.addEventListener("click", onClick, true);
                  app.addEventListener("mousedown", onMousedown, true);
                });
                if (!el._clickOutside) {
                  el._clickOutside = {
                    lastMousedownWasOutside: true
                  };
                }
                el._clickOutside[vnode.context._uid] = {
                  onClick,
                  onMousedown
                };
              },
              unbind: function unbind3(el, binding, vnode) {
                if (!el._clickOutside)
                  return;
                handleShadow(el, function(app) {
                  var _a2;
                  if (!app || !((_a2 = el._clickOutside) === null || _a2 === void 0 ? void 0 : _a2[vnode.context._uid]))
                    return;
                  var _b2 = el._clickOutside[vnode.context._uid], onClick = _b2.onClick, onMousedown = _b2.onMousedown;
                  app.removeEventListener("click", onClick, true);
                  app.removeEventListener("mousedown", onMousedown, true);
                });
                delete el._clickOutside[vnode.context._uid];
              }
            };
            __webpack_exports__["default"] = ClickOutside;
          }
        ),
        /***/
        "./src/directives/index.ts": (
          /*!*********************************!*\
            !*** ./src/directives/index.ts ***!
            \*********************************/
          /*! exports provided: ClickOutside, Intersect, Mutate, Resize, Ripple, Scroll, Touch */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _click_outside__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./click-outside */
              "./src/directives/click-outside/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "ClickOutside", function() {
              return _click_outside__WEBPACK_IMPORTED_MODULE_0__["ClickOutside"];
            });
            var _intersect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./intersect */
              "./src/directives/intersect/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Intersect", function() {
              return _intersect__WEBPACK_IMPORTED_MODULE_1__["Intersect"];
            });
            var _mutate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./mutate */
              "./src/directives/mutate/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Mutate", function() {
              return _mutate__WEBPACK_IMPORTED_MODULE_2__["Mutate"];
            });
            var _resize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./resize */
              "./src/directives/resize/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Resize", function() {
              return _resize__WEBPACK_IMPORTED_MODULE_3__["Resize"];
            });
            var _ripple__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./ripple */
              "./src/directives/ripple/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Ripple", function() {
              return _ripple__WEBPACK_IMPORTED_MODULE_4__["Ripple"];
            });
            var _scroll__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./scroll */
              "./src/directives/scroll/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Scroll", function() {
              return _scroll__WEBPACK_IMPORTED_MODULE_5__["Scroll"];
            });
            var _touch__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ./touch */
              "./src/directives/touch/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Touch", function() {
              return _touch__WEBPACK_IMPORTED_MODULE_6__["Touch"];
            });
          }
        ),
        /***/
        "./src/directives/intersect/index.ts": (
          /*!*******************************************!*\
            !*** ./src/directives/intersect/index.ts ***!
            \*******************************************/
          /*! exports provided: Intersect, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Intersect", function() {
              return Intersect;
            });
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            function inserted2(el, binding, vnode) {
              if (typeof window === "undefined" || !("IntersectionObserver" in window))
                return;
              var modifiers = binding.modifiers || {};
              var value = binding.value;
              var _a2 = _typeof2(value) === "object" ? value : {
                handler: value,
                options: {}
              }, handler = _a2.handler, options = _a2.options;
              var observer = new IntersectionObserver(function(entries, observer2) {
                var _a3;
                if (entries === void 0) {
                  entries = [];
                }
                var _observe = (_a3 = el._observe) === null || _a3 === void 0 ? void 0 : _a3[vnode.context._uid];
                if (!_observe)
                  return;
                var isIntersecting = entries.some(function(entry) {
                  return entry.isIntersecting;
                });
                if (handler && (!modifiers.quiet || _observe.init) && (!modifiers.once || isIntersecting || _observe.init)) {
                  handler(entries, observer2, isIntersecting);
                }
                if (isIntersecting && modifiers.once)
                  unbind3(el, binding, vnode);
                else
                  _observe.init = true;
              }, options);
              el._observe = Object(el._observe);
              el._observe[vnode.context._uid] = {
                init: false,
                observer
              };
              observer.observe(el);
            }
            function unbind3(el, binding, vnode) {
              var _a2;
              var observe2 = (_a2 = el._observe) === null || _a2 === void 0 ? void 0 : _a2[vnode.context._uid];
              if (!observe2)
                return;
              observe2.observer.unobserve(el);
              delete el._observe[vnode.context._uid];
            }
            var Intersect = {
              inserted: inserted2,
              unbind: unbind3
            };
            __webpack_exports__["default"] = Intersect;
          }
        ),
        /***/
        "./src/directives/mutate/index.ts": (
          /*!****************************************!*\
            !*** ./src/directives/mutate/index.ts ***!
            \****************************************/
          /*! exports provided: Mutate, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Mutate", function() {
              return Mutate;
            });
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __rest = function(s2, e) {
              var t3 = {};
              for (var p in s2) {
                if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
                  t3[p] = s2[p];
              }
              if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
                for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
                  if (e.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
                    t3[p[i2]] = s2[p[i2]];
                }
              return t3;
            };
            function inserted2(el, binding, vnode) {
              var modifiers = binding.modifiers || {};
              var value = binding.value;
              var callback = _typeof2(value) === "object" ? value.handler : value;
              var once2 = modifiers.once, modifierKeys = __rest(modifiers, ["once"]);
              var hasModifiers = Object.keys(modifierKeys).length > 0;
              var options = _typeof2(value) === "object" && value.options ? value.options : hasModifiers ? {
                attributes: modifierKeys.attr,
                childList: modifierKeys.child,
                subtree: modifierKeys.sub,
                characterData: modifierKeys.char
              } : {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
              };
              var observer = new MutationObserver(function(mutationsList, observer2) {
                if (!el._mutate)
                  return;
                callback(mutationsList, observer2);
                once2 && unbind3(el, binding, vnode);
              });
              observer.observe(el, options);
              el._mutate = Object(el._mutate);
              el._mutate[vnode.context._uid] = {
                observer
              };
            }
            function unbind3(el, binding, vnode) {
              var _a2;
              if (!((_a2 = el._mutate) === null || _a2 === void 0 ? void 0 : _a2[vnode.context._uid]))
                return;
              el._mutate[vnode.context._uid].observer.disconnect();
              delete el._mutate[vnode.context._uid];
            }
            var Mutate = {
              inserted: inserted2,
              unbind: unbind3
            };
            __webpack_exports__["default"] = Mutate;
          }
        ),
        /***/
        "./src/directives/resize/index.ts": (
          /*!****************************************!*\
            !*** ./src/directives/resize/index.ts ***!
            \****************************************/
          /*! exports provided: Resize, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Resize", function() {
              return Resize;
            });
            function inserted2(el, binding, vnode) {
              var callback = binding.value;
              var options = binding.options || {
                passive: true
              };
              window.addEventListener("resize", callback, options);
              el._onResize = Object(el._onResize);
              el._onResize[vnode.context._uid] = {
                callback,
                options
              };
              if (!binding.modifiers || !binding.modifiers.quiet) {
                callback();
              }
            }
            function unbind3(el, binding, vnode) {
              var _a2;
              if (!((_a2 = el._onResize) === null || _a2 === void 0 ? void 0 : _a2[vnode.context._uid]))
                return;
              var _b2 = el._onResize[vnode.context._uid], callback = _b2.callback, options = _b2.options;
              window.removeEventListener("resize", callback, options);
              delete el._onResize[vnode.context._uid];
            }
            var Resize = {
              inserted: inserted2,
              unbind: unbind3
            };
            __webpack_exports__["default"] = Resize;
          }
        ),
        /***/
        "./src/directives/ripple/VRipple.sass": (
          /*!********************************************!*\
            !*** ./src/directives/ripple/VRipple.sass ***!
            \********************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/directives/ripple/index.ts": (
          /*!****************************************!*\
            !*** ./src/directives/ripple/index.ts ***!
            \****************************************/
          /*! exports provided: Ripple, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Ripple", function() {
              return Ripple;
            });
            __webpack_require__(
              /*! ./VRipple.sass */
              "./src/directives/ripple/VRipple.sass"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            var DELAY_RIPPLE = 80;
            function transform(el, value) {
              el.style.transform = value;
              el.style.webkitTransform = value;
            }
            function isTouchEvent(e) {
              return e.constructor.name === "TouchEvent";
            }
            function isKeyboardEvent(e) {
              return e.constructor.name === "KeyboardEvent";
            }
            var calculate = function calculate2(e, el, value) {
              if (value === void 0) {
                value = {};
              }
              var localX = 0;
              var localY = 0;
              if (!isKeyboardEvent(e)) {
                var offset2 = el.getBoundingClientRect();
                var target2 = isTouchEvent(e) ? e.touches[e.touches.length - 1] : e;
                localX = target2.clientX - offset2.left;
                localY = target2.clientY - offset2.top;
              }
              var radius = 0;
              var scale = 0.3;
              if (el._ripple && el._ripple.circle) {
                scale = 0.15;
                radius = el.clientWidth / 2;
                radius = value.center ? radius : radius + Math.sqrt(Math.pow(localX - radius, 2) + Math.pow(localY - radius, 2)) / 4;
              } else {
                radius = Math.sqrt(Math.pow(el.clientWidth, 2) + Math.pow(el.clientHeight, 2)) / 2;
              }
              var centerX = (el.clientWidth - radius * 2) / 2 + "px";
              var centerY = (el.clientHeight - radius * 2) / 2 + "px";
              var x2 = value.center ? centerX : localX - radius + "px";
              var y = value.center ? centerY : localY - radius + "px";
              return {
                radius,
                scale,
                x: x2,
                y,
                centerX,
                centerY
              };
            };
            var ripples = {
              /* eslint-disable max-statements */
              show: function show2(e, el, value) {
                if (value === void 0) {
                  value = {};
                }
                if (!el._ripple || !el._ripple.enabled) {
                  return;
                }
                var container2 = document.createElement("span");
                var animation = document.createElement("span");
                container2.appendChild(animation);
                container2.className = "v-ripple__container";
                if (value.class) {
                  container2.className += " " + value.class;
                }
                var _a2 = calculate(e, el, value), radius = _a2.radius, scale = _a2.scale, x2 = _a2.x, y = _a2.y, centerX = _a2.centerX, centerY = _a2.centerY;
                var size = radius * 2 + "px";
                animation.className = "v-ripple__animation";
                animation.style.width = size;
                animation.style.height = size;
                el.appendChild(container2);
                var computed2 = window.getComputedStyle(el);
                if (computed2 && computed2.position === "static") {
                  el.style.position = "relative";
                  el.dataset.previousPosition = "static";
                }
                animation.classList.add("v-ripple__animation--enter");
                animation.classList.add("v-ripple__animation--visible");
                transform(animation, "translate(" + x2 + ", " + y + ") scale3d(" + scale + "," + scale + "," + scale + ")");
                animation.dataset.activated = String(performance.now());
                setTimeout(function() {
                  animation.classList.remove("v-ripple__animation--enter");
                  animation.classList.add("v-ripple__animation--in");
                  transform(animation, "translate(" + centerX + ", " + centerY + ") scale3d(1,1,1)");
                }, 0);
              },
              hide: function hide(el) {
                if (!el || !el._ripple || !el._ripple.enabled)
                  return;
                var ripples2 = el.getElementsByClassName("v-ripple__animation");
                if (ripples2.length === 0)
                  return;
                var animation = ripples2[ripples2.length - 1];
                if (animation.dataset.isHiding)
                  return;
                else
                  animation.dataset.isHiding = "true";
                var diff = performance.now() - Number(animation.dataset.activated);
                var delay = Math.max(250 - diff, 0);
                setTimeout(function() {
                  animation.classList.remove("v-ripple__animation--in");
                  animation.classList.add("v-ripple__animation--out");
                  setTimeout(function() {
                    var _a2;
                    var ripples3 = el.getElementsByClassName("v-ripple__animation");
                    if (ripples3.length === 1 && el.dataset.previousPosition) {
                      el.style.position = el.dataset.previousPosition;
                      delete el.dataset.previousPosition;
                    }
                    if (((_a2 = animation.parentNode) === null || _a2 === void 0 ? void 0 : _a2.parentNode) === el)
                      el.removeChild(animation.parentNode);
                  }, 300);
                }, delay);
              }
            };
            function isRippleEnabled(value) {
              return typeof value === "undefined" || !!value;
            }
            function rippleShow(e) {
              var value = {};
              var element = e.currentTarget;
              if (!element || !element._ripple || element._ripple.touched || e.rippleStop)
                return;
              e.rippleStop = true;
              if (isTouchEvent(e)) {
                element._ripple.touched = true;
                element._ripple.isTouch = true;
              } else {
                if (element._ripple.isTouch)
                  return;
              }
              value.center = element._ripple.centered || isKeyboardEvent(e);
              if (element._ripple.class) {
                value.class = element._ripple.class;
              }
              if (isTouchEvent(e)) {
                if (element._ripple.showTimerCommit)
                  return;
                element._ripple.showTimerCommit = function() {
                  ripples.show(e, element, value);
                };
                element._ripple.showTimer = window.setTimeout(function() {
                  if (element && element._ripple && element._ripple.showTimerCommit) {
                    element._ripple.showTimerCommit();
                    element._ripple.showTimerCommit = null;
                  }
                }, DELAY_RIPPLE);
              } else {
                ripples.show(e, element, value);
              }
            }
            function rippleHide(e) {
              var element = e.currentTarget;
              if (!element || !element._ripple)
                return;
              window.clearTimeout(element._ripple.showTimer);
              if (e.type === "touchend" && element._ripple.showTimerCommit) {
                element._ripple.showTimerCommit();
                element._ripple.showTimerCommit = null;
                element._ripple.showTimer = setTimeout(function() {
                  rippleHide(e);
                });
                return;
              }
              window.setTimeout(function() {
                if (element._ripple) {
                  element._ripple.touched = false;
                }
              });
              ripples.hide(element);
            }
            function rippleCancelShow(e) {
              var element = e.currentTarget;
              if (!element || !element._ripple)
                return;
              if (element._ripple.showTimerCommit) {
                element._ripple.showTimerCommit = null;
              }
              window.clearTimeout(element._ripple.showTimer);
            }
            var keyboardRipple = false;
            function keyboardRippleShow(e) {
              if (!keyboardRipple && (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_2__["keyCodes"].enter || e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_2__["keyCodes"].space)) {
                keyboardRipple = true;
                rippleShow(e);
              }
            }
            function keyboardRippleHide(e) {
              keyboardRipple = false;
              rippleHide(e);
            }
            function focusRippleHide(e) {
              if (keyboardRipple === true) {
                keyboardRipple = false;
                rippleHide(e);
              }
            }
            function updateRipple(el, binding, wasEnabled) {
              var enabled = isRippleEnabled(binding.value);
              if (!enabled) {
                ripples.hide(el);
              }
              el._ripple = el._ripple || {};
              el._ripple.enabled = enabled;
              var value = binding.value || {};
              if (value.center) {
                el._ripple.centered = true;
              }
              if (value.class) {
                el._ripple.class = binding.value.class;
              }
              if (value.circle) {
                el._ripple.circle = value.circle;
              }
              if (enabled && !wasEnabled) {
                el.addEventListener("touchstart", rippleShow, {
                  passive: true
                });
                el.addEventListener("touchend", rippleHide, {
                  passive: true
                });
                el.addEventListener("touchmove", rippleCancelShow, {
                  passive: true
                });
                el.addEventListener("touchcancel", rippleHide);
                el.addEventListener("mousedown", rippleShow);
                el.addEventListener("mouseup", rippleHide);
                el.addEventListener("mouseleave", rippleHide);
                el.addEventListener("keydown", keyboardRippleShow);
                el.addEventListener("keyup", keyboardRippleHide);
                el.addEventListener("blur", focusRippleHide);
                el.addEventListener("dragstart", rippleHide, {
                  passive: true
                });
              } else if (!enabled && wasEnabled) {
                removeListeners(el);
              }
            }
            function removeListeners(el) {
              el.removeEventListener("mousedown", rippleShow);
              el.removeEventListener("touchstart", rippleShow);
              el.removeEventListener("touchend", rippleHide);
              el.removeEventListener("touchmove", rippleCancelShow);
              el.removeEventListener("touchcancel", rippleHide);
              el.removeEventListener("mouseup", rippleHide);
              el.removeEventListener("mouseleave", rippleHide);
              el.removeEventListener("keydown", keyboardRippleShow);
              el.removeEventListener("keyup", keyboardRippleHide);
              el.removeEventListener("dragstart", rippleHide);
              el.removeEventListener("blur", focusRippleHide);
            }
            function directive2(el, binding, node2) {
              updateRipple(el, binding, false);
              {
                node2.context && node2.context.$nextTick(function() {
                  var computed2 = window.getComputedStyle(el);
                  if (computed2 && computed2.display === "inline") {
                    var context = node2.fnOptions ? [node2.fnOptions, node2.context] : [node2.componentInstance];
                    _util_console__WEBPACK_IMPORTED_MODULE_1__["consoleWarn"].apply(void 0, __spreadArray2(["v-ripple can only be used on block-level elements"], __read2(context), false));
                  }
                });
              }
            }
            function unbind3(el) {
              delete el._ripple;
              removeListeners(el);
            }
            function update5(el, binding) {
              if (binding.value === binding.oldValue) {
                return;
              }
              var wasEnabled = isRippleEnabled(binding.oldValue);
              updateRipple(el, binding, wasEnabled);
            }
            var Ripple = {
              bind: directive2,
              unbind: unbind3,
              update: update5
            };
            __webpack_exports__["default"] = Ripple;
          }
        ),
        /***/
        "./src/directives/scroll/index.ts": (
          /*!****************************************!*\
            !*** ./src/directives/scroll/index.ts ***!
            \****************************************/
          /*! exports provided: Scroll, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Scroll", function() {
              return Scroll;
            });
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            function inserted2(el, binding, vnode) {
              var _a2 = (binding.modifiers || {}).self, self2 = _a2 === void 0 ? false : _a2;
              var value = binding.value;
              var options = _typeof2(value) === "object" && value.options || {
                passive: true
              };
              var handler = typeof value === "function" || "handleEvent" in value ? value : value.handler;
              var target2 = self2 ? el : binding.arg ? document.querySelector(binding.arg) : window;
              if (!target2)
                return;
              target2.addEventListener("scroll", handler, options);
              el._onScroll = Object(el._onScroll);
              el._onScroll[vnode.context._uid] = {
                handler,
                options,
                // Don't reference self
                target: self2 ? void 0 : target2
              };
            }
            function unbind3(el, binding, vnode) {
              var _a2;
              if (!((_a2 = el._onScroll) === null || _a2 === void 0 ? void 0 : _a2[vnode.context._uid]))
                return;
              var _b2 = el._onScroll[vnode.context._uid], handler = _b2.handler, options = _b2.options, _c = _b2.target, target2 = _c === void 0 ? el : _c;
              target2.removeEventListener("scroll", handler, options);
              delete el._onScroll[vnode.context._uid];
            }
            var Scroll = {
              inserted: inserted2,
              unbind: unbind3
            };
            __webpack_exports__["default"] = Scroll;
          }
        ),
        /***/
        "./src/directives/touch/index.ts": (
          /*!***************************************!*\
            !*** ./src/directives/touch/index.ts ***!
            \***************************************/
          /*! exports provided: Touch, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Touch", function() {
              return Touch;
            });
            var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var handleGesture = function handleGesture2(wrapper) {
              var touchstartX = wrapper.touchstartX, touchendX = wrapper.touchendX, touchstartY = wrapper.touchstartY, touchendY = wrapper.touchendY;
              var dirRatio = 0.5;
              var minDistance = 16;
              wrapper.offsetX = touchendX - touchstartX;
              wrapper.offsetY = touchendY - touchstartY;
              if (Math.abs(wrapper.offsetY) < dirRatio * Math.abs(wrapper.offsetX)) {
                wrapper.left && touchendX < touchstartX - minDistance && wrapper.left(wrapper);
                wrapper.right && touchendX > touchstartX + minDistance && wrapper.right(wrapper);
              }
              if (Math.abs(wrapper.offsetX) < dirRatio * Math.abs(wrapper.offsetY)) {
                wrapper.up && touchendY < touchstartY - minDistance && wrapper.up(wrapper);
                wrapper.down && touchendY > touchstartY + minDistance && wrapper.down(wrapper);
              }
            };
            function _touchstart(event, wrapper) {
              var touch = event.changedTouches[0];
              wrapper.touchstartX = touch.clientX;
              wrapper.touchstartY = touch.clientY;
              wrapper.start && wrapper.start(Object.assign(event, wrapper));
            }
            function _touchend(event, wrapper) {
              var touch = event.changedTouches[0];
              wrapper.touchendX = touch.clientX;
              wrapper.touchendY = touch.clientY;
              wrapper.end && wrapper.end(Object.assign(event, wrapper));
              handleGesture(wrapper);
            }
            function _touchmove(event, wrapper) {
              var touch = event.changedTouches[0];
              wrapper.touchmoveX = touch.clientX;
              wrapper.touchmoveY = touch.clientY;
              wrapper.move && wrapper.move(Object.assign(event, wrapper));
            }
            function createHandlers(value) {
              var wrapper = {
                touchstartX: 0,
                touchstartY: 0,
                touchendX: 0,
                touchendY: 0,
                touchmoveX: 0,
                touchmoveY: 0,
                offsetX: 0,
                offsetY: 0,
                left: value.left,
                right: value.right,
                up: value.up,
                down: value.down,
                start: value.start,
                move: value.move,
                end: value.end
              };
              return {
                touchstart: function touchstart(e) {
                  return _touchstart(e, wrapper);
                },
                touchend: function touchend(e) {
                  return _touchend(e, wrapper);
                },
                touchmove: function touchmove(e) {
                  return _touchmove(e, wrapper);
                }
              };
            }
            function inserted2(el, binding, vnode) {
              var value = binding.value;
              var target2 = value.parent ? el.parentElement : el;
              var options = value.options || {
                passive: true
              };
              if (!target2)
                return;
              var handlers = createHandlers(binding.value);
              target2._touchHandlers = Object(target2._touchHandlers);
              target2._touchHandlers[vnode.context._uid] = handlers;
              Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["keys"])(handlers).forEach(function(eventName) {
                target2.addEventListener(eventName, handlers[eventName], options);
              });
            }
            function unbind3(el, binding, vnode) {
              var target2 = binding.value.parent ? el.parentElement : el;
              if (!target2 || !target2._touchHandlers)
                return;
              var handlers = target2._touchHandlers[vnode.context._uid];
              Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["keys"])(handlers).forEach(function(eventName) {
                target2.removeEventListener(eventName, handlers[eventName]);
              });
              delete target2._touchHandlers[vnode.context._uid];
            }
            var Touch = {
              inserted: inserted2,
              unbind: unbind3
            };
            __webpack_exports__["default"] = Touch;
          }
        ),
        /***/
        "./src/framework.ts": (
          /*!**************************!*\
            !*** ./src/framework.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _install__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./install */
              "./src/install.ts"
            );
            var _services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./services */
              "./src/services/index.ts"
            );
            var Vuetify2 = (
              /** @class */
              function() {
                function Vuetify3(userPreset) {
                  if (userPreset === void 0) {
                    userPreset = {};
                  }
                  this.framework = {
                    isHydrating: false
                  };
                  this.installed = [];
                  this.preset = {};
                  this.userPreset = {};
                  this.userPreset = userPreset;
                  this.use(_services__WEBPACK_IMPORTED_MODULE_1__["Presets"]);
                  this.use(_services__WEBPACK_IMPORTED_MODULE_1__["Application"]);
                  this.use(_services__WEBPACK_IMPORTED_MODULE_1__["Breakpoint"]);
                  this.use(_services__WEBPACK_IMPORTED_MODULE_1__["Goto"]);
                  this.use(_services__WEBPACK_IMPORTED_MODULE_1__["Icons"]);
                  this.use(_services__WEBPACK_IMPORTED_MODULE_1__["Lang"]);
                  this.use(_services__WEBPACK_IMPORTED_MODULE_1__["Theme"]);
                }
                Vuetify3.prototype.init = function(root2, ssrContext) {
                  var _this2 = this;
                  this.installed.forEach(function(property2) {
                    var service = _this2.framework[property2];
                    service.framework = _this2.framework;
                    service.init(root2, ssrContext);
                  });
                  this.framework.rtl = Boolean(this.preset.rtl);
                };
                Vuetify3.prototype.use = function(Service) {
                  var property2 = Service.property;
                  if (this.installed.includes(property2))
                    return;
                  this.framework[property2] = new Service(this.preset, this);
                  this.installed.push(property2);
                };
                Vuetify3.install = _install__WEBPACK_IMPORTED_MODULE_0__["install"];
                Vuetify3.installed = false;
                Vuetify3.version = "2.7.2";
                Vuetify3.config = {
                  silent: false
                };
                return Vuetify3;
              }()
            );
            __webpack_exports__["default"] = Vuetify2;
          }
        ),
        /***/
        "./src/index.ts": (
          /*!**********************!*\
            !*** ./src/index.ts ***!
            \**********************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./components */
              "./src/components/index.ts"
            );
            var _directives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./directives */
              "./src/directives/index.ts"
            );
            var _framework__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./framework */
              "./src/framework.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = _framework__WEBPACK_IMPORTED_MODULE_2__["default"];
            var install2 = _framework__WEBPACK_IMPORTED_MODULE_2__["default"].install;
            _framework__WEBPACK_IMPORTED_MODULE_2__["default"].install = function(Vue2, args) {
              install2.call(_framework__WEBPACK_IMPORTED_MODULE_2__["default"], Vue2, __assign2({
                components: _components__WEBPACK_IMPORTED_MODULE_0__,
                directives: _directives__WEBPACK_IMPORTED_MODULE_1__
              }, args));
            };
            if (typeof window !== "undefined" && window.Vue) {
              window.Vue.use(_framework__WEBPACK_IMPORTED_MODULE_2__["default"]);
            }
          }
        ),
        /***/
        "./src/install.ts": (
          /*!************************!*\
            !*** ./src/install.ts ***!
            \************************/
          /*! exports provided: install */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "install", function() {
              return install2;
            });
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./util/console */
              "./src/util/console.ts"
            );
            function install2(Vue2, args) {
              if (args === void 0) {
                args = {};
              }
              if (install2.installed)
                return;
              install2.installed = true;
              if (vue__WEBPACK_IMPORTED_MODULE_0___default.a !== Vue2) {
                Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleError"])(`Multiple instances of Vue detected
See https://github.com/vuetifyjs/vuetify/issues/4068

If you're seeing "$attrs is readonly", it's caused by this`);
              }
              var components = args.components || {};
              var directives2 = args.directives || {};
              for (var name in directives2) {
                var directive2 = directives2[name];
                Vue2.directive(name, directive2);
              }
              (function registerComponents2(components2) {
                if (components2) {
                  for (var key in components2) {
                    var component = components2[key];
                    if (component && !registerComponents2(component.$_vuetify_subcomponents)) {
                      Vue2.component(key, component);
                    }
                  }
                  return true;
                }
                return false;
              })(components);
              if (Vue2.$_vuetify_installed)
                return;
              Vue2.$_vuetify_installed = true;
              Vue2.mixin({
                beforeCreate: function beforeCreate() {
                  var options = this.$options;
                  if (options.vuetify) {
                    options.vuetify.init(this, this.$ssrContext);
                    this.$vuetify = Vue2.observable(options.vuetify.framework);
                  } else {
                    this.$vuetify = options.parent && options.parent.$vuetify || this;
                  }
                },
                beforeMount: function beforeMount2() {
                  if (this.$options.vuetify && this.$el && this.$el.hasAttribute("data-server-rendered")) {
                    this.$vuetify.isHydrating = true;
                    this.$vuetify.breakpoint.update(true);
                  }
                },
                mounted: function mounted3() {
                  if (this.$options.vuetify && this.$vuetify.isHydrating) {
                    this.$vuetify.isHydrating = false;
                    this.$vuetify.breakpoint.update();
                  }
                }
              });
            }
          }
        ),
        /***/
        "./src/locale/af.ts": (
          /*!**************************!*\
            !*** ./src/locale/af.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "badge",
              close: "Close",
              dataIterator: {
                noResultsText: "Geen ooreenstemmende resultate is gevind nie",
                loadingText: "Loading item..."
              },
              dataTable: {
                itemsPerPageText: "Rye per bladsy:",
                ariaLabel: {
                  sortDescending: "Sorted descending.",
                  sortAscending: "Sorted ascending..",
                  sortNone: "Not sorted.",
                  activateNone: "Activate to remove sorting.",
                  activateDescending: "Activate to sort descending.",
                  activateAscending: "Activate to sort ascending."
                },
                sortBy: "Sort by"
              },
              dataFooter: {
                itemsPerPageText: "Aantal per bladsy:",
                itemsPerPageAll: "Alles",
                nextPage: "Volgende bladsy",
                prevPage: "Vorige bladsy",
                firstPage: "Eerste bladsy",
                lastPage: "Laaste bladsy",
                pageText: "{0}-{1} van {2}"
              },
              datePicker: {
                itemsSelected: "{0} gekies",
                nextMonthAriaLabel: "Volgende maand",
                nextYearAriaLabel: "Volgende jaar",
                prevMonthAriaLabel: "Vorige maand",
                prevYearAriaLabel: "Vorige jaar"
              },
              noDataText: "Geen data is beskikbaar nie",
              carousel: {
                prev: "Vorige visuele",
                next: "Volgende visuele",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "{0} meer"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} files",
                counterSize: "{0} files ({1} in total)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Paginasie-navigasie",
                  next: "Volgende bladsy",
                  previous: "Vorige bladsy",
                  page: "Gaan na bladsy {0}",
                  currentPage: "Huidige bladsy, Bladsy {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/ar.ts": (
          /*!**************************!*\
            !*** ./src/locale/ar.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "شارة",
              close: "إغلاق",
              dataIterator: {
                noResultsText: "لم يتم إيجاد نتائج",
                loadingText: "يتم جلب العناصر..."
              },
              dataTable: {
                itemsPerPageText: "عدد الصفوف لكل صفحة:",
                ariaLabel: {
                  sortDescending: "مرتب تنازلياً.",
                  sortAscending: "مرتب تصاعدياً.",
                  sortNone: "غير مرتب.",
                  activateNone: "نشط لإزالة الترتيب.",
                  activateDescending: "نشط للترتيب تنازلياً.",
                  activateAscending: "نشط للترتيب تصاعدياً."
                },
                sortBy: "رتب حسب"
              },
              dataFooter: {
                itemsPerPageText: "عدد العناصر لكل صفحة:",
                itemsPerPageAll: "الكل",
                nextPage: "الصفحة التالية",
                prevPage: "الصفحة السابقة",
                firstPage: "الصفحة الأولى",
                lastPage: "الصفحة الأخيرة",
                pageText: "{0}-{1} من {2}"
              },
              datePicker: {
                itemsSelected: "تم تحديد {0}",
                nextMonthAriaLabel: "الشهر القادم",
                nextYearAriaLabel: "العام القادم",
                prevMonthAriaLabel: "الشهر الماضى",
                prevYearAriaLabel: "السنة الماضية"
              },
              noDataText: "لا توجد بيانات",
              carousel: {
                prev: "المعروض السابق",
                next: "المعروض التالي",
                ariaLabel: {
                  delimiter: "المعروض رقم {0} من {1}"
                }
              },
              calendar: {
                moreEvents: "{0} أكثر"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} ملفات",
                counterSize: "{0} ملفات ({1} في المجموع)"
              },
              timePicker: {
                am: "صباحاً",
                pm: "مساءً"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "الإنتقال بين الصفحات",
                  next: "الصفحة التالية",
                  previous: "الصفحة السابقة",
                  page: "{0} انتقل إلى الصفحة",
                  currentPage: "{0} الصفحة الحالية رقمها"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "القييم {0} من {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/az.ts": (
          /*!**************************!*\
            !*** ./src/locale/az.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "nişan",
              close: "Bağla",
              dataIterator: {
                noResultsText: "Uyğun məlumat tapılmadı",
                loadingText: "Yüklənir... Zəhmət olmasa, gözləyin."
              },
              dataTable: {
                itemsPerPageText: "Səhifə başı sətir sayı:",
                ariaLabel: {
                  sortDescending: "Azalan sıra ilə düzülmüş.",
                  sortAscending: "Artan sıra ilə düzülmüş.",
                  sortNone: "Sıralanmamışdır. ",
                  activateNone: "Sıralamanı yığışdır.",
                  activateDescending: "Azalan sıra ilə düz.",
                  activateAscending: "Artan sıra ilə düz."
                },
                sortBy: "Sırala"
              },
              dataFooter: {
                itemsPerPageText: "Səhifə başı sətir sayı:",
                itemsPerPageAll: "Hamısı",
                nextPage: "Növbəti səhifə",
                prevPage: "Əvvəlki səhifə",
                firstPage: "İlk səhifə",
                lastPage: "Son səhifə",
                pageText: "{0} - {1} arası, Cəmi: {2} qeydiyyat"
              },
              datePicker: {
                itemsSelected: "{0} element seçildi",
                nextMonthAriaLabel: "Növbəti ay",
                nextYearAriaLabel: "Növbəti yıl",
                prevMonthAriaLabel: "Keçən ay",
                prevYearAriaLabel: "Keçən yıl"
              },
              noDataText: "Bu görüntüdə məlumat yoxdur.",
              carousel: {
                prev: "Əvvəlki görüntü",
                next: "Növbəti görüntü",
                ariaLabel: {
                  delimiter: "Galereya səhifə {0} / {1}"
                }
              },
              calendar: {
                moreEvents: "{0} ədad daha"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} fayl",
                counterSize: "{0} fayl (cəmi {1})"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Səhifələmə Naviqasiyası",
                  next: "Növbəti səhifə",
                  previous: "Əvəvlki səhifə",
                  page: "Səhifəyə get {0}",
                  currentPage: "Cari səhifə, Səhifə {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/bg.ts": (
          /*!**************************!*\
            !*** ./src/locale/bg.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Значка",
              close: "Затвори",
              dataIterator: {
                noResultsText: "Не са намерени записи",
                loadingText: "Зареждане на елементи..."
              },
              dataTable: {
                itemsPerPageText: "Редове на страница:",
                ariaLabel: {
                  sortDescending: "Подреди в намаляващ ред.",
                  sortAscending: "Подреди в нарастващ ред.",
                  sortNone: "Без подредба.",
                  activateNone: "Активирай за премахване на подредбата.",
                  activateDescending: "Активирай за подредба в намаляващ ред.",
                  activateAscending: "Активирай за подредба в нарастващ ред."
                },
                sortBy: "Сортирай по"
              },
              dataFooter: {
                itemsPerPageText: "Елементи на страница:",
                itemsPerPageAll: "Всички",
                nextPage: "Следваща страница",
                prevPage: "Предишна страница",
                firstPage: "Първа страница",
                lastPage: "Последна страница",
                pageText: "{0}-{1} от {2}"
              },
              datePicker: {
                itemsSelected: "{0} избрани",
                nextMonthAriaLabel: "Следващ месец",
                nextYearAriaLabel: "Следващата година",
                prevMonthAriaLabel: "Предишен месец",
                prevYearAriaLabel: "Предишна година"
              },
              noDataText: "Няма налични данни",
              carousel: {
                prev: "Предишна визуализация",
                next: "Следваща визуализация",
                ariaLabel: {
                  delimiter: "Кадър {0} от {1} на въртележката"
                }
              },
              calendar: {
                moreEvents: "Още {0}"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} файла",
                counterSize: "{0} файла ({1} общо)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Странициране",
                  next: "Следваща страница",
                  previous: "Предишна страница",
                  page: "Отиди на страница {0}",
                  currentPage: "Текуща страница, Страница {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/ca.ts": (
          /*!**************************!*\
            !*** ./src/locale/ca.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Insígnia",
              close: "Tancar",
              dataIterator: {
                noResultsText: "Sense dades per mostrar",
                loadingText: "Carregant..."
              },
              dataTable: {
                itemsPerPageText: "Files per pàgina:",
                ariaLabel: {
                  sortDescending: "Ordre descendent.",
                  sortAscending: "Ordre ascendent.",
                  sortNone: "Sense ordenar.",
                  activateNone: "Premi per treure la ordenació.",
                  activateDescending: "Premi per ordenar descendent.",
                  activateAscending: "Premi per ordenar ascendent."
                },
                sortBy: "Ordenat per"
              },
              dataFooter: {
                itemsPerPageText: "Elements per pàgina:",
                itemsPerPageAll: "Tot",
                nextPage: "Pàgina següent",
                prevPage: "Pàgina anterior",
                firstPage: "Primera pàgina",
                lastPage: "Última pàgina",
                pageText: "{0}-{1} de {2}"
              },
              datePicker: {
                itemsSelected: "{0} seleccionats",
                nextMonthAriaLabel: "El mes que ve",
                nextYearAriaLabel: "L'any que ve",
                prevMonthAriaLabel: "Mes anterior",
                prevYearAriaLabel: "Any anterior"
              },
              noDataText: "Sense dades",
              carousel: {
                prev: "Visualització prèvia",
                next: "Visualització següent",
                ariaLabel: {
                  delimiter: "Diapositiva {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "{0} més"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} fitxers",
                counterSize: "{0} fitxers ({1} en total)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navegació de la pàgina",
                  next: "Pàgina següent",
                  previous: "Pàgina anterior",
                  page: "Ves a la pàgina {0}",
                  currentPage: "Pàgina actual, pàgina {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Puntuació {0} de {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/ckb.ts": (
          /*!***************************!*\
            !*** ./src/locale/ckb.ts ***!
            \***************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "باج",
              close: "داخستن",
              dataIterator: {
                noResultsText: "هیچ تۆمارێکی هاوتا نەدۆزرایەوە",
                loadingText: "بارکردنی ئایتمەکان..."
              },
              dataTable: {
                itemsPerPageText: "ڕیزەکان بۆ هەر پەڕەیەک:",
                ariaLabel: {
                  sortDescending: ".سەر بەرەو خوار ڕیزکراوە",
                  sortAscending: ".سەر بەرەو ژوور ڕیزکراوە",
                  sortNone: "ڕیزنەکراوە.",
                  activateNone: "چالاککردن بۆ لابردنی ڕیزکردن.",
                  activateDescending: "چالاککردن بۆ ڕیزکردنی سەربەرەوخوار.",
                  activateAscending: "چالاککردن بۆ ڕیزکردنی سەر بەرەو ژوور."
                },
                sortBy: "ڕیزکردن بەپێی"
              },
              dataFooter: {
                itemsPerPageText: "ئایتمەکان بۆ هەر پەڕەیەک:",
                itemsPerPageAll: "هەمووی",
                nextPage: "پەڕەی دواتر",
                prevPage: "پەڕەی پێشوو",
                firstPage: "پەڕەی یەکەم",
                lastPage: "پەڕەی کۆتایی",
                pageText: "{0}-{1} لە {2}"
              },
              datePicker: {
                itemsSelected: "{0} دەسنیشانکراوە",
                nextMonthAriaLabel: "مانگی داهاتوو",
                nextYearAriaLabel: "ساڵی داهاتوو",
                prevMonthAriaLabel: "مانگی پێشوو",
                prevYearAriaLabel: "ساڵی پێشوو"
              },
              noDataText: "هیچ داتایەک بەردەست نیە",
              carousel: {
                prev: "بینراوی پێشوو",
                next: "بینراوی داهاتوو",
                ariaLabel: {
                  delimiter: "سلایدی کارۆسێل {0} لە {1}"
                }
              },
              calendar: {
                moreEvents: "{0} زیاتر"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} فایل",
                counterSize: "{0} فایل ({1} لە کۆی گشتی)"
              },
              timePicker: {
                am: "پێش نیوەڕۆژ",
                pm: "دوای نیوەڕۆژ"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "ڕێنیشاندەری پەڕەگۆڕکێ",
                  next: "پەڕەی دواتر",
                  previous: "پەڕەی پێشوو",
                  page: "بڕۆ بۆ پەڕەی {0}",
                  currentPage: "پەڕەی ئێستا، پەڕە{0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/cs.ts": (
          /*!**************************!*\
            !*** ./src/locale/cs.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Odznak",
              close: "Zavřít",
              dataIterator: {
                noResultsText: "Nenalezeny žádné záznamy",
                loadingText: "Načítám položky..."
              },
              dataTable: {
                itemsPerPageText: "Řádků na stránku:",
                ariaLabel: {
                  sortDescending: "Řazeno sestupně.",
                  sortAscending: "Řazeno vzestupně.",
                  sortNone: "Neseřazeno.",
                  activateNone: "Aktivováním vypnete řazení.",
                  activateDescending: "Aktivováním se bude řadit sestupně.",
                  activateAscending: "Aktivováním se bude řadit vzestupně."
                },
                sortBy: "Řadit dle"
              },
              dataFooter: {
                itemsPerPageText: "Položek na stránku:",
                itemsPerPageAll: "Vše",
                nextPage: "Další strana",
                prevPage: "Předchozí strana",
                firstPage: "První strana",
                lastPage: "Poslední strana",
                pageText: "{0}-{1} z {2}"
              },
              datePicker: {
                itemsSelected: "{0} vybráno",
                nextMonthAriaLabel: "Příští měsíc",
                nextYearAriaLabel: "Příští rok",
                prevMonthAriaLabel: "Předchozí měsíc",
                prevYearAriaLabel: "Předchozí rok"
              },
              noDataText: "Nejsou dostupná žádná data",
              carousel: {
                prev: "Předchozí obrázek",
                next: "Další obrázek",
                ariaLabel: {
                  delimiter: "Slide {0} z {1}"
                }
              },
              calendar: {
                moreEvents: "{0} dalších"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} souborů",
                counterSize: "{0} souborů ({1} celkem)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navigace po stránkách",
                  next: "Další strana",
                  previous: "Předchozí strana",
                  page: "Přejít na stránku {0}",
                  currentPage: "Aktuální stránka, stránka {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Hodnocení {0} z {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/da.ts": (
          /*!**************************!*\
            !*** ./src/locale/da.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Emblem",
              close: "Luk",
              dataIterator: {
                noResultsText: "Ingen matchende data fundet",
                loadingText: "Indhenter data..."
              },
              dataTable: {
                itemsPerPageText: "Rækker pr. side:",
                ariaLabel: {
                  sortDescending: "Sorteret faldende.",
                  sortAscending: "Sorteret stigende.",
                  sortNone: "Ikke sorteret.",
                  activateNone: "Aktiver for at fjerne sortering.",
                  activateDescending: "Aktiver for at sortere faldende.",
                  activateAscending: "Aktiver for at sortere stigende."
                },
                sortBy: "Sorter efter"
              },
              dataFooter: {
                itemsPerPageText: "Rækker pr. side:",
                itemsPerPageAll: "Alle",
                nextPage: "Næste side",
                prevPage: "Forrige side",
                firstPage: "Første side",
                lastPage: "Sidste side",
                pageText: "{0}-{1} af {2}"
              },
              datePicker: {
                itemsSelected: "{0} valgt",
                nextMonthAriaLabel: "Næste måned",
                nextYearAriaLabel: "Næste år",
                prevMonthAriaLabel: "Forrige måned",
                prevYearAriaLabel: "Forrige år"
              },
              noDataText: "Ingen data tilgængelig",
              carousel: {
                prev: "Forrige visuelle",
                next: "Næste visuelle",
                ariaLabel: {
                  delimiter: "Karrusel dias {0} af {1}"
                }
              },
              calendar: {
                moreEvents: "{0} mere"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} filer",
                counterSize: "{0} filer ({1} total)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Pagineringsnavigation",
                  next: "Næste side",
                  previous: "Forrige side",
                  page: "Gå til side {0}",
                  currentPage: "Nuværende side, Side {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Bedømmelse {0} af {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/de.ts": (
          /*!**************************!*\
            !*** ./src/locale/de.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Abzeichen",
              close: "Schließen",
              dataIterator: {
                noResultsText: "Keine Elemente gefunden",
                loadingText: "Lade Elemente..."
              },
              dataTable: {
                itemsPerPageText: "Zeilen pro Seite:",
                ariaLabel: {
                  sortDescending: "Absteigend sortiert.",
                  sortAscending: "Aufsteigend sortiert.",
                  sortNone: "Nicht sortiert.",
                  activateNone: "Aktivieren um Sortierung zu entfernen.",
                  activateDescending: "Aktivieren um absteigend zu sortieren.",
                  activateAscending: "Aktivieren um aufsteigend zu sortieren."
                },
                sortBy: "Sortiere nach"
              },
              dataFooter: {
                itemsPerPageText: "Elemente pro Seite:",
                itemsPerPageAll: "Alle",
                nextPage: "Nächste Seite",
                prevPage: "Vorherige Seite",
                firstPage: "Erste Seite",
                lastPage: "Letzte Seite",
                pageText: "{0}-{1} von {2}"
              },
              datePicker: {
                itemsSelected: "{0} ausgewählt",
                nextMonthAriaLabel: "Nächsten Monat",
                nextYearAriaLabel: "Nächstes Jahr",
                prevMonthAriaLabel: "Vorheriger Monat",
                prevYearAriaLabel: "Vorheriges Jahr"
              },
              noDataText: "Keine Daten vorhanden",
              carousel: {
                prev: "Vorheriges Bild",
                next: "Nächstes Bild",
                ariaLabel: {
                  delimiter: "Element {0} von {1}"
                }
              },
              calendar: {
                moreEvents: "{0} mehr"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} Dateien",
                counterSize: "{0} Dateien ({1} gesamt)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Seitennavigation",
                  next: "Nächste Seite",
                  previous: "Vorherige Seite",
                  page: "Gehe zu Seite {0}",
                  currentPage: "Aktuelle Seite, Seite {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/el.ts": (
          /*!**************************!*\
            !*** ./src/locale/el.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Σήμα",
              close: "Close",
              dataIterator: {
                noResultsText: "Δε βρέθηκαν αποτελέσματα",
                loadingText: "Loading item..."
              },
              dataTable: {
                itemsPerPageText: "Γραμμές ανά σελίδα:",
                ariaLabel: {
                  sortDescending: "Sorted descending.",
                  sortAscending: "Sorted ascending.",
                  sortNone: "Not sorted.",
                  activateNone: "Activate to remove sorting.",
                  activateDescending: "Activate to sort descending.",
                  activateAscending: "Activate to sort ascending."
                },
                sortBy: "Sort by"
              },
              dataFooter: {
                itemsPerPageText: "Αντικείμενα ανά σελίδα:",
                itemsPerPageAll: "Όλα",
                nextPage: "Επόμενη σελίδα",
                prevPage: "Προηγούμενη σελίδα",
                firstPage: "Πρώτη σελίδα",
                lastPage: "Τελευταία σελίδα",
                pageText: "{0}-{1} από {2}"
              },
              datePicker: {
                itemsSelected: "{0} επιλεγμένα",
                nextMonthAriaLabel: "Τον επόμενο μήνα",
                nextYearAriaLabel: "Του χρόνου",
                prevMonthAriaLabel: "Προηγούμενος μήνας",
                prevYearAriaLabel: "Προηγούμενο έτος"
              },
              noDataText: "Χωρίς δεδομένα",
              carousel: {
                prev: "הקודם חזותי",
                next: "הבא חזותי",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "{0} ακόμη"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} files",
                counterSize: "{0} files ({1} in total)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Πλοήγηση με προορισμούς",
                  next: "Επόμενη σελίδα",
                  previous: "Προηγούμενη σελίδα",
                  page: "Πήγαινε στην σελίδα {0}",
                  currentPage: "Τρέχουσα σελίδα, σελίδα {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/en.ts": (
          /*!**************************!*\
            !*** ./src/locale/en.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Badge",
              close: "Close",
              dataIterator: {
                noResultsText: "No matching records found",
                loadingText: "Loading items..."
              },
              dataTable: {
                itemsPerPageText: "Rows per page:",
                ariaLabel: {
                  sortDescending: "Sorted descending.",
                  sortAscending: "Sorted ascending.",
                  sortNone: "Not sorted.",
                  activateNone: "Activate to remove sorting.",
                  activateDescending: "Activate to sort descending.",
                  activateAscending: "Activate to sort ascending."
                },
                sortBy: "Sort by"
              },
              dataFooter: {
                itemsPerPageText: "Items per page:",
                itemsPerPageAll: "All",
                nextPage: "Next page",
                prevPage: "Previous page",
                firstPage: "First page",
                lastPage: "Last page",
                pageText: "{0}-{1} of {2}"
              },
              datePicker: {
                itemsSelected: "{0} selected",
                nextMonthAriaLabel: "Next month",
                nextYearAriaLabel: "Next year",
                prevMonthAriaLabel: "Previous month",
                prevYearAriaLabel: "Previous year"
              },
              noDataText: "No data available",
              carousel: {
                prev: "Previous visual",
                next: "Next visual",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "{0} more"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} files",
                counterSize: "{0} files ({1} in total)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Pagination Navigation",
                  next: "Next page",
                  previous: "Previous page",
                  page: "Goto Page {0}",
                  currentPage: "Current Page, Page {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/es.ts": (
          /*!**************************!*\
            !*** ./src/locale/es.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Placa",
              close: "Cerrar",
              dataIterator: {
                noResultsText: "Ningún elemento coincide con la búsqueda",
                loadingText: "Cargando..."
              },
              dataTable: {
                itemsPerPageText: "Filas por página:",
                ariaLabel: {
                  sortDescending: "Orden descendente.",
                  sortAscending: "Orden ascendente.",
                  sortNone: "Sin ordenar.",
                  activateNone: "Pulse para quitar orden.",
                  activateDescending: "Pulse para ordenar de forma descendente.",
                  activateAscending: "Pulse para ordenar de forma ascendente."
                },
                sortBy: "Ordenado por"
              },
              dataFooter: {
                itemsPerPageText: "Elementos por página:",
                itemsPerPageAll: "Todos",
                nextPage: "Página siguiente",
                prevPage: "Página anterior",
                firstPage: "Primera página",
                lastPage: "Última página",
                pageText: "{0}-{1} de {2}"
              },
              datePicker: {
                itemsSelected: "{0} seleccionados",
                nextMonthAriaLabel: "Próximo mes",
                nextYearAriaLabel: "Próximo año",
                prevMonthAriaLabel: "Mes anterior",
                prevYearAriaLabel: "Año anterior"
              },
              noDataText: "No hay datos disponibles",
              carousel: {
                prev: "Visual anterior",
                next: "Visual siguiente",
                ariaLabel: {
                  delimiter: "Visual {0} de {1}"
                }
              },
              calendar: {
                moreEvents: "{0} más"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} archivos",
                counterSize: "{0} archivos ({1} en total)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navegación de paginación",
                  next: "Página siguiente",
                  previous: "Página anterior",
                  page: "Ir a la página {0}",
                  currentPage: "Página actual, página {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Puntuación {0} de {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/et.ts": (
          /*!**************************!*\
            !*** ./src/locale/et.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Märk",
              close: "Sulge",
              dataIterator: {
                noResultsText: "Vastavaid kirjeid ei leitud",
                loadingText: "Andmeid laaditakse..."
              },
              dataTable: {
                itemsPerPageText: "Ridu leheküljel:",
                ariaLabel: {
                  sortDescending: "Kahanevalt sorteeritud.",
                  sortAscending: "Kasvavalt sorteeritud.",
                  sortNone: "Ei ole sorteeritud.",
                  activateNone: "Vajuta uuesti sorteerimise eemaldamiseks.",
                  activateDescending: "Vajuta uuesti, et sorteerida kahanevalt.",
                  activateAscending: "Vajuta kasvavalt sorteerimiseks."
                },
                sortBy: "Sorteerimise alus"
              },
              dataFooter: {
                itemsPerPageText: "Kirjeid leheküljel:",
                itemsPerPageAll: "Kõik",
                nextPage: "Järgmine lehekülg",
                prevPage: "Eelmine lehekülg",
                firstPage: "Esimene lehekülg",
                lastPage: "Viimane lehekülg",
                pageText: "{0}-{1} {2}st"
              },
              datePicker: {
                itemsSelected: "{0} valitud",
                nextMonthAriaLabel: "Järgmine kuu",
                nextYearAriaLabel: "Järgmine aasta",
                prevMonthAriaLabel: "Eelmine kuu",
                prevYearAriaLabel: "Eelmine aasta"
              },
              noDataText: "Andmed puuduvad",
              carousel: {
                prev: "Eelmine visuaalne",
                next: "Järgmine visuaalne",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "{0} veel"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} faili",
                counterSize: "{0} faili (kokku {1})"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Pagination Navigation",
                  next: "Järgmine lehekülg",
                  previous: "Eelmine lehekülg",
                  page: "Mine lehele {0}",
                  currentPage: "Praegune leht, leht {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/fa.ts": (
          /*!**************************!*\
            !*** ./src/locale/fa.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "نشان",
              close: "بستن",
              dataIterator: {
                noResultsText: "نتیجه‌ای یافت نشد",
                loadingText: "در حال بارگذاری..."
              },
              dataTable: {
                itemsPerPageText: "ردیف در صفحه:",
                ariaLabel: {
                  sortDescending: "مرتب‌سازی نزولی",
                  sortAscending: "مرتب‌سازی صعودی",
                  sortNone: "بدون مرتب‌سازی",
                  activateNone: "غیرفعال‌سازی مرتب‌سازی",
                  activateDescending: "غیرفعال‌سازی مرتب‌سازی نزولی",
                  activateAscending: "غیرفعال‌سازی مرتب‌سازی صعودی"
                },
                sortBy: "مرتب‌سازی براساس"
              },
              dataFooter: {
                itemsPerPageText: "ردیف در صفحه:",
                itemsPerPageAll: "همه",
                nextPage: "صفحه‌ی بعد",
                prevPage: "صفحه‌ی قبل",
                firstPage: "صفحه‌ی یکم",
                lastPage: "صفحه‌ی آخر",
                pageText: "{0} تا {1} از {2}"
              },
              datePicker: {
                itemsSelected: "{0} انتخاب شده",
                nextMonthAriaLabel: "ماه بعد",
                nextYearAriaLabel: "سال بعد",
                prevMonthAriaLabel: "ماه قبل",
                prevYearAriaLabel: "سال قبل"
              },
              noDataText: "داده‌ای موجود نیست",
              carousel: {
                prev: "اسلاید قبلی",
                next: "اسلاید بعدی",
                ariaLabel: {
                  delimiter: "اسلاید {0} از {1}"
                }
              },
              calendar: {
                moreEvents: "{بیشتر {0"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} پرونده",
                counterSize: "{0} پرونده ({1} در کل)"
              },
              timePicker: {
                am: "قبل از ظهر",
                pm: "بعد از ظهر"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "جهت یابی صفحه",
                  next: "صفحه بعد",
                  previous: "صفحه قبلی",
                  page: "برو صفحه {0}",
                  currentPage: "{0} صفحه فعلی ، صفحه"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/fi.ts": (
          /*!**************************!*\
            !*** ./src/locale/fi.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Infopiste",
              close: "Sulje",
              dataIterator: {
                noResultsText: "Ei osumia",
                loadingText: "Ladataan kohteita..."
              },
              dataTable: {
                itemsPerPageText: "Rivejä sivulla:",
                ariaLabel: {
                  sortDescending: ": Järjestetty laskevasti. Poista järjestäminen aktivoimalla.",
                  sortAscending: ": Järjestetty nousevasti. Järjestä laskevasti aktivoimalla.",
                  sortNone: ": Ei järjestetty. Järjestä nousevasti aktivoimalla.",
                  activateNone: "Aktivoi lajittelun poistamiseksi.",
                  activateDescending: "Aktivoi laskevien laskevien lajittelemiseksi.",
                  activateAscending: "Aktivoi lajitella nouseva."
                },
                sortBy: "Järjestä"
              },
              dataFooter: {
                itemsPerPageText: "Kohteita sivulla:",
                itemsPerPageAll: "Kaikki",
                nextPage: "Seuraava sivu",
                prevPage: "Edellinen sivu",
                firstPage: "Ensimmäinen sivu",
                lastPage: "Viimeinen sivu",
                pageText: "{0}-{1} ({2})"
              },
              datePicker: {
                itemsSelected: "{0} valittu",
                nextMonthAriaLabel: "Seuraava kuukausi",
                nextYearAriaLabel: "Ensi vuosi",
                prevMonthAriaLabel: "Edellinen kuukausi",
                prevYearAriaLabel: "Edellinen vuosi"
              },
              noDataText: "Ei dataa",
              carousel: {
                prev: "Edellinen kuva",
                next: "Seuraava kuva",
                ariaLabel: {
                  delimiter: "Karusellin kuva {0}/{1}"
                }
              },
              calendar: {
                moreEvents: "{0} lisää"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} tiedostoa",
                counterSize: "{0} tiedostoa ({1} yhteensä)"
              },
              timePicker: {
                am: "ap.",
                pm: "ip."
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Pagination Navigation",
                  next: "Seuraava sivu",
                  previous: "Edellinen sivu",
                  page: "Mene sivulle {0}",
                  currentPage: "Nykyinen sivu, Sivu {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Luokitus {0}/{1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/fr.ts": (
          /*!**************************!*\
            !*** ./src/locale/fr.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Badge",
              close: "Fermer",
              dataIterator: {
                noResultsText: "Aucun enregistrement correspondant trouvé",
                loadingText: "Chargement de l'élément…"
              },
              dataTable: {
                itemsPerPageText: "Lignes par page :",
                ariaLabel: {
                  sortDescending: "Tri décroissant.",
                  sortAscending: "Tri croissant.",
                  sortNone: "Non trié.",
                  activateNone: "Activer pour supprimer le tri.",
                  activateDescending: "Activer pour trier par ordre décroissant.",
                  activateAscending: "Activer pour trier par ordre croissant."
                },
                sortBy: "Trier par"
              },
              dataFooter: {
                itemsPerPageText: "Élements par page :",
                itemsPerPageAll: "Tous",
                nextPage: "Page suivante",
                prevPage: "Page précédente",
                firstPage: "Première page",
                lastPage: "Dernière page",
                pageText: "{0}-{1} de {2}"
              },
              datePicker: {
                itemsSelected: "{0} sélectionné(s)",
                nextMonthAriaLabel: "Le mois prochain",
                nextYearAriaLabel: "L'année prochaine",
                prevMonthAriaLabel: "Le mois précédent",
                prevYearAriaLabel: "Année précédente"
              },
              noDataText: "Aucune donnée disponible",
              carousel: {
                prev: "Visuel précédent",
                next: "Visuel suivant",
                ariaLabel: {
                  delimiter: "Diapositive {0} de {1}"
                }
              },
              calendar: {
                moreEvents: "{0} de plus"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} fichier(s)",
                counterSize: "{0} fichier(s) ({1} au total)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navigation de pagination",
                  next: "Page suivante",
                  previous: "Page précédente",
                  page: "Aller à la page {0}",
                  currentPage: "Page actuelle, Page {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Note de {0} sur {1}"
                }
              },
              loading: "Chargement…"
            };
          }
        ),
        /***/
        "./src/locale/he.ts": (
          /*!**************************!*\
            !*** ./src/locale/he.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "תג",
              close: "סגור",
              dataIterator: {
                noResultsText: "לא נמצאו תוצאות מתאימות",
                loadingText: "טוען פריט..."
              },
              dataTable: {
                itemsPerPageText: "שורות לעמוד:",
                ariaLabel: {
                  sortDescending: "ממוין לפי סדר עולה. לחץ להספקת המיון.",
                  sortAscending: "ממוין לפי סדר יורד. לחץ למיון לפי סדר עולה.",
                  sortNone: "לא ממוין. לחץ למיון לפי סדר עולה.",
                  activateNone: "הפעל להסרת המיון.",
                  activateDescending: "הפעל למיון יורד.",
                  activateAscending: "הפעל למיון עולה."
                },
                sortBy: "סדר לפי"
              },
              dataFooter: {
                itemsPerPageText: "פריטים לדף:",
                itemsPerPageAll: "הכל",
                nextPage: "עמוד הבא",
                prevPage: "עמוד הקודם",
                firstPage: "עמוד ראשון",
                lastPage: "עמוד אחרון",
                pageText: "{0}-{1} מתוך {2}"
              },
              datePicker: {
                itemsSelected: "{0} נבחרו",
                nextMonthAriaLabel: "חודש הבא",
                nextYearAriaLabel: "שנה הבאה",
                prevMonthAriaLabel: "חודש שעבר",
                prevYearAriaLabel: "שנה שעברה"
              },
              noDataText: "אין נתונים זמינים",
              carousel: {
                prev: "מצג קודם",
                next: "מצג הבא",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "{0} נוספים"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} קבצים",
                counterSize: "{0} קבצים ({1} בסך הכל)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "ניווט עימוד",
                  next: "עמוד הבא",
                  previous: "עמוד הקודם",
                  page: "{0} לך לעמוד",
                  currentPage: "{0} עמוד נוכחי, עמוד"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/hr.ts": (
          /*!**************************!*\
            !*** ./src/locale/hr.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Bedž",
              close: "Zatvori",
              dataIterator: {
                noResultsText: "Nisu pronađene odgovarajuće stavke",
                loadingText: "Učitavanje..."
              },
              dataTable: {
                itemsPerPageText: "Redaka po stranici:",
                ariaLabel: {
                  sortDescending: "Sortirano silazno.",
                  sortAscending: "Sortirano uzlazno.",
                  sortNone: "Nije sortirano.",
                  activateNone: "Odaberite za uklanjanje sortiranja.",
                  activateDescending: "Odaberite za silazno sortiranje.",
                  activateAscending: "Odaberite za uzlazno sortiranje."
                },
                sortBy: "Sortirajte po"
              },
              dataFooter: {
                itemsPerPageText: "Stavki po stranici:",
                itemsPerPageAll: "Sve",
                nextPage: "Sljedeća stranica",
                prevPage: "Prethodna stranica",
                firstPage: "Prva stranica",
                lastPage: "Posljednja stranica",
                pageText: "{0}-{1} od {2}"
              },
              datePicker: {
                itemsSelected: "{0} odabrano",
                nextMonthAriaLabel: "Sljedeći mjesec",
                nextYearAriaLabel: "Slijedeće godine",
                prevMonthAriaLabel: "Prethodni mjesec",
                prevYearAriaLabel: "Prošla godina"
              },
              noDataText: "Nema dostupnih podataka",
              carousel: {
                prev: "Prethodno",
                next: "Sljedeće",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "Još {0}"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "Odabranih datoteka: {0}",
                counterSize: "Odabranih datoteka: {0} ({1} ukupno)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navigacija stranicama",
                  next: "Sljedeća stranica",
                  previous: "Prethodna stranica",
                  page: "Idi na stranicu {0}",
                  currentPage: "Trenutna stranica, stranica {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/hu.ts": (
          /*!**************************!*\
            !*** ./src/locale/hu.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Jelvény",
              close: "Bezárás",
              dataIterator: {
                noResultsText: "Nincs egyező találat",
                loadingText: "Betöltés..."
              },
              dataTable: {
                itemsPerPageText: "Elem oldalanként:",
                ariaLabel: {
                  sortDescending: "Csökkenő sorrendbe rendezve.",
                  sortAscending: "Növekvő sorrendbe rendezve.",
                  sortNone: "Rendezetlen.",
                  activateNone: "Rendezés törlése.",
                  activateDescending: "Aktiváld a csökkenő rendezésért.",
                  activateAscending: "Aktiváld a növekvő rendezésért."
                },
                sortBy: "Rendezés"
              },
              dataFooter: {
                itemsPerPageText: "Elem oldalanként:",
                itemsPerPageAll: "Mind",
                nextPage: "Következő oldal",
                prevPage: "Előző oldal",
                firstPage: "Első oldal",
                lastPage: "Utolsó oldal",
                pageText: "{0}-{1} / {2}"
              },
              datePicker: {
                itemsSelected: "{0} kiválasztva",
                nextMonthAriaLabel: "Következő hónap",
                nextYearAriaLabel: "Következő év",
                prevMonthAriaLabel: "Előző hónap",
                prevYearAriaLabel: "Előző év"
              },
              noDataText: "Nincs elérhető adat",
              carousel: {
                prev: "Előző",
                next: "Következő",
                ariaLabel: {
                  delimiter: "Dia {0}/{1}"
                }
              },
              calendar: {
                moreEvents: "{0} további"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} fájl",
                counterSize: "{0} fájl ({1} összesen)"
              },
              timePicker: {
                am: "de",
                pm: "du"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Oldal navigáció",
                  next: "Következő oldal",
                  previous: "Előző oldal",
                  page: "Menj a(z) {0}. oldalra",
                  currentPage: "Aktuális oldal: {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/id.ts": (
          /*!**************************!*\
            !*** ./src/locale/id.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Lencana",
              close: "Tutup",
              dataIterator: {
                noResultsText: "Tidak ditemukan catatan yang cocok",
                loadingText: "Memuat data..."
              },
              dataTable: {
                itemsPerPageText: "Baris per halaman:",
                ariaLabel: {
                  sortDescending: "Diurutkan kebawah.",
                  sortAscending: "Diurutkan keatas.",
                  sortNone: "Tidak diurutkan.",
                  activateNone: "Aktifkan untuk menghapus penyortiran.",
                  activateDescending: "Aktifkan untuk mengurutkan kebawah.",
                  activateAscending: "Aktifkan untuk mengurutkan keatas."
                },
                sortBy: "Urutkan berdasar"
              },
              dataFooter: {
                itemsPerPageText: "Item per halaman:",
                itemsPerPageAll: "Semua",
                nextPage: "Halaman selanjutnya",
                prevPage: "Halaman sebelumnya",
                firstPage: "Halaman pertama",
                lastPage: "Halaman terakhir",
                pageText: "{0}-{1} dari {2}"
              },
              datePicker: {
                itemsSelected: "{0} dipilih",
                nextMonthAriaLabel: "Bulan depan",
                nextYearAriaLabel: "Tahun depan",
                prevMonthAriaLabel: "Bulan sebelumnya",
                prevYearAriaLabel: "Tahun sebelumnya"
              },
              noDataText: "Tidak ada data tersedia",
              carousel: {
                prev: "Visual sebelumnya",
                next: "Visual selanjutnya",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "{0} lagi"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} berkas",
                counterSize: "{0} berkas (dari total {1})"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navigasi Pagination",
                  next: "Halaman selanjutnya",
                  previous: "Halaman sebelumnya",
                  page: "Buka halaman {0}",
                  currentPage: "Halaman Saat Ini, Halaman {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/index.ts": (
          /*!*****************************!*\
            !*** ./src/locale/index.ts ***!
            \*****************************/
          /*! exports provided: af, ar, bg, ca, ckb, cs, da, de, el, en, es, et, fa, fi, fr, hr, hu, he, id, it, ja, ko, lv, lt, nl, no, pl, pt, ro, ru, sk, sl, srCyrl, srLatn, sv, th, tr, az, uk, vi, zhHans, zhHant */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _af__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./af */
              "./src/locale/af.ts"
            );
            __webpack_require__.d(__webpack_exports__, "af", function() {
              return _af__WEBPACK_IMPORTED_MODULE_0__["default"];
            });
            var _ar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./ar */
              "./src/locale/ar.ts"
            );
            __webpack_require__.d(__webpack_exports__, "ar", function() {
              return _ar__WEBPACK_IMPORTED_MODULE_1__["default"];
            });
            var _bg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./bg */
              "./src/locale/bg.ts"
            );
            __webpack_require__.d(__webpack_exports__, "bg", function() {
              return _bg__WEBPACK_IMPORTED_MODULE_2__["default"];
            });
            var _ca__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./ca */
              "./src/locale/ca.ts"
            );
            __webpack_require__.d(__webpack_exports__, "ca", function() {
              return _ca__WEBPACK_IMPORTED_MODULE_3__["default"];
            });
            var _ckb__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./ckb */
              "./src/locale/ckb.ts"
            );
            __webpack_require__.d(__webpack_exports__, "ckb", function() {
              return _ckb__WEBPACK_IMPORTED_MODULE_4__["default"];
            });
            var _cs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./cs */
              "./src/locale/cs.ts"
            );
            __webpack_require__.d(__webpack_exports__, "cs", function() {
              return _cs__WEBPACK_IMPORTED_MODULE_5__["default"];
            });
            var _da__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ./da */
              "./src/locale/da.ts"
            );
            __webpack_require__.d(__webpack_exports__, "da", function() {
              return _da__WEBPACK_IMPORTED_MODULE_6__["default"];
            });
            var _de__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
              /*! ./de */
              "./src/locale/de.ts"
            );
            __webpack_require__.d(__webpack_exports__, "de", function() {
              return _de__WEBPACK_IMPORTED_MODULE_7__["default"];
            });
            var _el__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
              /*! ./el */
              "./src/locale/el.ts"
            );
            __webpack_require__.d(__webpack_exports__, "el", function() {
              return _el__WEBPACK_IMPORTED_MODULE_8__["default"];
            });
            var _en__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
              /*! ./en */
              "./src/locale/en.ts"
            );
            __webpack_require__.d(__webpack_exports__, "en", function() {
              return _en__WEBPACK_IMPORTED_MODULE_9__["default"];
            });
            var _es__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
              /*! ./es */
              "./src/locale/es.ts"
            );
            __webpack_require__.d(__webpack_exports__, "es", function() {
              return _es__WEBPACK_IMPORTED_MODULE_10__["default"];
            });
            var _et__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
              /*! ./et */
              "./src/locale/et.ts"
            );
            __webpack_require__.d(__webpack_exports__, "et", function() {
              return _et__WEBPACK_IMPORTED_MODULE_11__["default"];
            });
            var _fa__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
              /*! ./fa */
              "./src/locale/fa.ts"
            );
            __webpack_require__.d(__webpack_exports__, "fa", function() {
              return _fa__WEBPACK_IMPORTED_MODULE_12__["default"];
            });
            var _fi__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
              /*! ./fi */
              "./src/locale/fi.ts"
            );
            __webpack_require__.d(__webpack_exports__, "fi", function() {
              return _fi__WEBPACK_IMPORTED_MODULE_13__["default"];
            });
            var _fr__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
              /*! ./fr */
              "./src/locale/fr.ts"
            );
            __webpack_require__.d(__webpack_exports__, "fr", function() {
              return _fr__WEBPACK_IMPORTED_MODULE_14__["default"];
            });
            var _hr__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
              /*! ./hr */
              "./src/locale/hr.ts"
            );
            __webpack_require__.d(__webpack_exports__, "hr", function() {
              return _hr__WEBPACK_IMPORTED_MODULE_15__["default"];
            });
            var _hu__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
              /*! ./hu */
              "./src/locale/hu.ts"
            );
            __webpack_require__.d(__webpack_exports__, "hu", function() {
              return _hu__WEBPACK_IMPORTED_MODULE_16__["default"];
            });
            var _he__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
              /*! ./he */
              "./src/locale/he.ts"
            );
            __webpack_require__.d(__webpack_exports__, "he", function() {
              return _he__WEBPACK_IMPORTED_MODULE_17__["default"];
            });
            var _id__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
              /*! ./id */
              "./src/locale/id.ts"
            );
            __webpack_require__.d(__webpack_exports__, "id", function() {
              return _id__WEBPACK_IMPORTED_MODULE_18__["default"];
            });
            var _it__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
              /*! ./it */
              "./src/locale/it.ts"
            );
            __webpack_require__.d(__webpack_exports__, "it", function() {
              return _it__WEBPACK_IMPORTED_MODULE_19__["default"];
            });
            var _ja__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
              /*! ./ja */
              "./src/locale/ja.ts"
            );
            __webpack_require__.d(__webpack_exports__, "ja", function() {
              return _ja__WEBPACK_IMPORTED_MODULE_20__["default"];
            });
            var _ko__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
              /*! ./ko */
              "./src/locale/ko.ts"
            );
            __webpack_require__.d(__webpack_exports__, "ko", function() {
              return _ko__WEBPACK_IMPORTED_MODULE_21__["default"];
            });
            var _lv__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
              /*! ./lv */
              "./src/locale/lv.ts"
            );
            __webpack_require__.d(__webpack_exports__, "lv", function() {
              return _lv__WEBPACK_IMPORTED_MODULE_22__["default"];
            });
            var _lt__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
              /*! ./lt */
              "./src/locale/lt.ts"
            );
            __webpack_require__.d(__webpack_exports__, "lt", function() {
              return _lt__WEBPACK_IMPORTED_MODULE_23__["default"];
            });
            var _nl__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
              /*! ./nl */
              "./src/locale/nl.ts"
            );
            __webpack_require__.d(__webpack_exports__, "nl", function() {
              return _nl__WEBPACK_IMPORTED_MODULE_24__["default"];
            });
            var _no__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
              /*! ./no */
              "./src/locale/no.ts"
            );
            __webpack_require__.d(__webpack_exports__, "no", function() {
              return _no__WEBPACK_IMPORTED_MODULE_25__["default"];
            });
            var _pl__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
              /*! ./pl */
              "./src/locale/pl.ts"
            );
            __webpack_require__.d(__webpack_exports__, "pl", function() {
              return _pl__WEBPACK_IMPORTED_MODULE_26__["default"];
            });
            var _pt__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
              /*! ./pt */
              "./src/locale/pt.ts"
            );
            __webpack_require__.d(__webpack_exports__, "pt", function() {
              return _pt__WEBPACK_IMPORTED_MODULE_27__["default"];
            });
            var _ro__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(
              /*! ./ro */
              "./src/locale/ro.ts"
            );
            __webpack_require__.d(__webpack_exports__, "ro", function() {
              return _ro__WEBPACK_IMPORTED_MODULE_28__["default"];
            });
            var _ru__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(
              /*! ./ru */
              "./src/locale/ru.ts"
            );
            __webpack_require__.d(__webpack_exports__, "ru", function() {
              return _ru__WEBPACK_IMPORTED_MODULE_29__["default"];
            });
            var _sk__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(
              /*! ./sk */
              "./src/locale/sk.ts"
            );
            __webpack_require__.d(__webpack_exports__, "sk", function() {
              return _sk__WEBPACK_IMPORTED_MODULE_30__["default"];
            });
            var _sl__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(
              /*! ./sl */
              "./src/locale/sl.ts"
            );
            __webpack_require__.d(__webpack_exports__, "sl", function() {
              return _sl__WEBPACK_IMPORTED_MODULE_31__["default"];
            });
            var _sr_Cyrl__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(
              /*! ./sr-Cyrl */
              "./src/locale/sr-Cyrl.ts"
            );
            __webpack_require__.d(__webpack_exports__, "srCyrl", function() {
              return _sr_Cyrl__WEBPACK_IMPORTED_MODULE_32__["default"];
            });
            var _sr_Latn__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(
              /*! ./sr-Latn */
              "./src/locale/sr-Latn.ts"
            );
            __webpack_require__.d(__webpack_exports__, "srLatn", function() {
              return _sr_Latn__WEBPACK_IMPORTED_MODULE_33__["default"];
            });
            var _sv__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(
              /*! ./sv */
              "./src/locale/sv.ts"
            );
            __webpack_require__.d(__webpack_exports__, "sv", function() {
              return _sv__WEBPACK_IMPORTED_MODULE_34__["default"];
            });
            var _th__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(
              /*! ./th */
              "./src/locale/th.ts"
            );
            __webpack_require__.d(__webpack_exports__, "th", function() {
              return _th__WEBPACK_IMPORTED_MODULE_35__["default"];
            });
            var _tr__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(
              /*! ./tr */
              "./src/locale/tr.ts"
            );
            __webpack_require__.d(__webpack_exports__, "tr", function() {
              return _tr__WEBPACK_IMPORTED_MODULE_36__["default"];
            });
            var _az__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(
              /*! ./az */
              "./src/locale/az.ts"
            );
            __webpack_require__.d(__webpack_exports__, "az", function() {
              return _az__WEBPACK_IMPORTED_MODULE_37__["default"];
            });
            var _uk__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(
              /*! ./uk */
              "./src/locale/uk.ts"
            );
            __webpack_require__.d(__webpack_exports__, "uk", function() {
              return _uk__WEBPACK_IMPORTED_MODULE_38__["default"];
            });
            var _vi__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(
              /*! ./vi */
              "./src/locale/vi.ts"
            );
            __webpack_require__.d(__webpack_exports__, "vi", function() {
              return _vi__WEBPACK_IMPORTED_MODULE_39__["default"];
            });
            var _zh_Hans__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(
              /*! ./zh-Hans */
              "./src/locale/zh-Hans.ts"
            );
            __webpack_require__.d(__webpack_exports__, "zhHans", function() {
              return _zh_Hans__WEBPACK_IMPORTED_MODULE_40__["default"];
            });
            var _zh_Hant__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(
              /*! ./zh-Hant */
              "./src/locale/zh-Hant.ts"
            );
            __webpack_require__.d(__webpack_exports__, "zhHant", function() {
              return _zh_Hant__WEBPACK_IMPORTED_MODULE_41__["default"];
            });
          }
        ),
        /***/
        "./src/locale/it.ts": (
          /*!**************************!*\
            !*** ./src/locale/it.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Distintivo",
              close: "Chiudi",
              dataIterator: {
                noResultsText: "Nessun risultato trovato",
                loadingText: "Caricamento in corso..."
              },
              dataTable: {
                itemsPerPageText: "Righe per pagina:",
                ariaLabel: {
                  sortDescending: "Ordinati in ordine decrescente.",
                  sortAscending: "Ordinati in ordine crescente.",
                  sortNone: "Non ordinato.",
                  activateNone: "Attiva per rimuovere l'ordinamento.",
                  activateDescending: "Attiva per ordinare in ordine decrescente.",
                  activateAscending: "Attiva per ordinare in ordine crescente."
                },
                sortBy: "Ordina per"
              },
              dataFooter: {
                itemsPerPageText: "Elementi per pagina:",
                itemsPerPageAll: "Tutti",
                nextPage: "Pagina seguente",
                prevPage: "Pagina precedente",
                firstPage: "Prima pagina",
                lastPage: "Ultima pagina",
                pageText: "{0}-{1} di {2}"
              },
              datePicker: {
                itemsSelected: "{0} selezionati",
                nextMonthAriaLabel: "Il prossimo mese",
                nextYearAriaLabel: "L'anno prossimo",
                prevMonthAriaLabel: "Il mese scorso",
                prevYearAriaLabel: "L'anno scorso"
              },
              noDataText: "Nessun elemento disponibile",
              carousel: {
                prev: "Vista precedente",
                next: "Prossima vista",
                ariaLabel: {
                  delimiter: "Carousel slide {0} di {1}"
                }
              },
              calendar: {
                moreEvents: "{0} di più"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} file",
                counterSize: "{0} file ({1} in totale)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navigazione impaginazione",
                  next: "Pagina seguente",
                  previous: "Pagina precedente",
                  page: "Vai alla pagina {0}",
                  currentPage: "Pagina corrente, pagina {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Valutazione {0} di {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/ja.ts": (
          /*!**************************!*\
            !*** ./src/locale/ja.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "バッジ",
              close: "閉じる",
              dataIterator: {
                noResultsText: "検索結果が見つかりません。",
                loadingText: "項目をロード中です..."
              },
              dataTable: {
                itemsPerPageText: "1ページあたりの行数：",
                ariaLabel: {
                  sortDescending: "降順の並び替え。",
                  sortAscending: "昇順の並び替え。",
                  sortNone: "ソートされていません。",
                  activateNone: "ソートを削除するには有効にしてください。",
                  activateDescending: "降順の並び替えのためには有効にしてください。",
                  activateAscending: "昇順のソートのためには有効にしてください。"
                },
                sortBy: "ソート方式"
              },
              dataFooter: {
                itemsPerPageText: "1ページあたりの件数：",
                itemsPerPageAll: "すべて",
                nextPage: "次のページ",
                prevPage: "前のページ",
                firstPage: "最初のページ",
                lastPage: "最後のページ",
                pageText: "{0}-{1} 件目 / {2}件"
              },
              datePicker: {
                itemsSelected: "{0}日付選択",
                nextMonthAriaLabel: "来月",
                nextYearAriaLabel: "来年",
                prevMonthAriaLabel: "前月",
                prevYearAriaLabel: "前年"
              },
              noDataText: "データはありません。",
              carousel: {
                prev: "前のビジュアル",
                next: "次のビジュアル",
                ariaLabel: {
                  delimiter: "カルーセルのスライド {0}件目 / {1}件"
                }
              },
              calendar: {
                moreEvents: "さらに{0}"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} ファイル",
                counterSize: "{0} ファイル (合計 {1})"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "ページネーションナビゲーション",
                  next: "次のページ",
                  previous: "前のページ",
                  page: "{0}ページ目に移動",
                  currentPage: "現在のページ、ページ {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "評価 {1} のうち {0}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/ko.ts": (
          /*!**************************!*\
            !*** ./src/locale/ko.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "배지",
              close: "닫기",
              dataIterator: {
                noResultsText: "일치하는 항목이 없습니다.",
                loadingText: "불러오는 중..."
              },
              dataTable: {
                itemsPerPageText: "페이지 당 행 수:",
                ariaLabel: {
                  sortDescending: "내림차순 정렬.",
                  sortAscending: "오름차순 정렬.",
                  sortNone: "정렬하지 않음.",
                  activateNone: "정렬을 취소하려면 활성화하세요.",
                  activateDescending: "내림차순 정렬을 위해 활성화하세요.",
                  activateAscending: "오름차순 정렬을 위해 활성화하세요."
                },
                sortBy: "Sort by"
              },
              dataFooter: {
                itemsPerPageText: "페이지 당 항목 수:",
                itemsPerPageAll: "전체",
                nextPage: "다음 페이지",
                prevPage: "이전 페이지",
                firstPage: "첫 페이지",
                lastPage: "마지막 페이지",
                pageText: "{2} 중 {0}-{1}"
              },
              datePicker: {
                itemsSelected: "{0} 선택됨",
                nextMonthAriaLabel: "다음 달",
                nextYearAriaLabel: "내년",
                prevMonthAriaLabel: "지난달",
                prevYearAriaLabel: "전년도"
              },
              noDataText: "데이터가 없습니다.",
              carousel: {
                prev: "이전 화면",
                next: "다음 화면",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "{0} 더보기"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} files",
                counterSize: "{0} files ({1} in total)"
              },
              timePicker: {
                am: "오전",
                pm: "오후"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Pagination Navigation",
                  next: "다음 페이지",
                  previous: "이전 페이지",
                  page: "고토 페이지 {0}",
                  currentPage: "현재 페이지, 페이지 {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/lt.ts": (
          /*!**************************!*\
            !*** ./src/locale/lt.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Ženklelis",
              close: "Uždaryti",
              dataIterator: {
                noResultsText: "Nerasta atitinkančių įrašų",
                loadingText: "Kraunama..."
              },
              dataTable: {
                itemsPerPageText: "Eilutės per puslapį:",
                ariaLabel: {
                  sortDescending: "Išrikiuota mažėjimo tvarka.",
                  sortAscending: "Išrikiuota didėjimo tvarka.",
                  sortNone: "Nerikiuota.",
                  activateNone: "Suaktyvinkite, jei norite rikiavimą pašalinti.",
                  activateDescending: "Suaktyvinkite, jei norite rikiuoti mažėjimo tvarka.",
                  activateAscending: "Suaktyvinkite, jei norite rikiuoti didėjimo tvarka."
                },
                sortBy: "Sort by"
              },
              dataFooter: {
                itemsPerPageText: "Įrašai per puslapį:",
                itemsPerPageAll: "Visi",
                nextPage: "Kitas puslapis",
                prevPage: "Ankstesnis puslapis",
                firstPage: "Pirmas puslapis",
                lastPage: "Paskutinis puslapis",
                pageText: "{0}-{1} iš {2}"
              },
              datePicker: {
                itemsSelected: "{0} pasirinkta",
                nextMonthAriaLabel: "Kitą mėnesį",
                nextYearAriaLabel: "Kitais metais",
                prevMonthAriaLabel: "Praeita mėnesį",
                prevYearAriaLabel: "Praeiti metai"
              },
              noDataText: "Nėra duomenų",
              carousel: {
                prev: "Ankstesnioji skaidrė",
                next: "Kita skaidrė",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "Daugiau {0}"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} failų",
                counterSize: "{0} failų ({1} iš viso)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Puslapio naršymas",
                  next: "Kitas puslapis",
                  previous: "Ankstesnis puslapis",
                  page: "Eiti į puslapį {0}",
                  currentPage: "Dabartinis puslapis, puslapis {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/lv.ts": (
          /*!**************************!*\
            !*** ./src/locale/lv.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Žetons",
              close: "Aizvērt",
              dataIterator: {
                noResultsText: "Nekas netika atrasts",
                loadingText: "Ielādē..."
              },
              dataTable: {
                itemsPerPageText: "Rādīt lapā:",
                ariaLabel: {
                  sortDescending: "Sakārtots dilstošā secībā.",
                  sortAscending: "Sakārtots augošā secībā.",
                  sortNone: "Nav sakārtots.",
                  activateNone: "Aktivizēt, lai noņemtu kārtošanu.",
                  activateDescending: "Aktivizēt, lai sakārtotu dilstošā secībā.",
                  activateAscending: "Aktivizēt, lai sakārtotu augošā secībā."
                },
                sortBy: "Sort by"
              },
              dataFooter: {
                itemsPerPageText: "Rādīt lapā:",
                itemsPerPageAll: "Visu",
                nextPage: "Nākamā lapa",
                prevPage: "Iepriekšējā lapa",
                firstPage: "Pirmā lapa",
                lastPage: "Pēdējā lapa",
                pageText: "{0}-{1} no {2}"
              },
              datePicker: {
                itemsSelected: "{0} izvēlēts",
                nextMonthAriaLabel: "Nākammēnes",
                nextYearAriaLabel: "Nākamgad",
                prevMonthAriaLabel: "Iepriekšējais mēnesis",
                prevYearAriaLabel: "Iepriekšējais gads"
              },
              noDataText: "Nav pieejamu datu",
              carousel: {
                prev: "Iepriekšējais slaids",
                next: "Nākamais slaids",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "Vēl {0}"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} files",
                counterSize: "{0} files ({1} in total)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navigācija paginationā",
                  next: "Nākamā lapa",
                  previous: "Iepriekšējā lapa",
                  page: "Iet uz lapu {0}",
                  currentPage: "Pašreizējā lapa, lapa {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/nl.ts": (
          /*!**************************!*\
            !*** ./src/locale/nl.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "insigne",
              close: "Sluiten",
              dataIterator: {
                noResultsText: "Geen overeenkomende resultaten gevonden",
                loadingText: "Items aan het laden..."
              },
              dataTable: {
                itemsPerPageText: "Rijen per pagina:",
                ariaLabel: {
                  sortDescending: "Aflopend gesorteerd.",
                  sortAscending: "Oplopend gesorteerd.",
                  sortNone: "Niet gesorteerd.",
                  activateNone: "Activeer om de sortering te verwijderen.",
                  activateDescending: "Activeer om aflopend te sorteren.",
                  activateAscending: "Activeer om oplopend te sorteren."
                },
                sortBy: "Sorteer volgens"
              },
              dataFooter: {
                itemsPerPageText: "Aantal per pagina:",
                itemsPerPageAll: "Alles",
                nextPage: "Volgende pagina",
                prevPage: "Vorige pagina",
                firstPage: "Eerste pagina",
                lastPage: "Laatste pagina",
                pageText: "{0}-{1} van {2}"
              },
              datePicker: {
                itemsSelected: "{0} geselecteerd",
                nextMonthAriaLabel: "Volgende maand",
                nextYearAriaLabel: "Volgend jaar",
                prevMonthAriaLabel: "Vorige maand",
                prevYearAriaLabel: "Vorig jaar"
              },
              noDataText: "Geen gegevens beschikbaar",
              carousel: {
                prev: "Vorig beeld",
                next: "Volgend beeld",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "{0} meer"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} bestanden",
                counterSize: "{0} bestanden ({1} in totaal)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Paginanavigatie",
                  next: "Volgende pagina",
                  previous: "Vorige pagina",
                  page: "Ga naar pagina {0}",
                  currentPage: "Huidige pagina, pagina {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/no.ts": (
          /*!**************************!*\
            !*** ./src/locale/no.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Skilt",
              close: "Lukk",
              dataIterator: {
                noResultsText: "Fant ingen matchende elementer.",
                loadingText: "Laster elementer..."
              },
              dataTable: {
                itemsPerPageText: "Rader per side:",
                ariaLabel: {
                  sortDescending: "Sortert synkende.",
                  sortAscending: "Sortert stigende.",
                  sortNone: "Ikke sortert.",
                  activateNone: "Aktiver for å fjerne sortering.",
                  activateDescending: "Aktiver for å sortere synkende.",
                  activateAscending: "Aktiver for å sortere stigende."
                },
                sortBy: "Sorter etter"
              },
              dataFooter: {
                itemsPerPageText: "Elementer per side:",
                itemsPerPageAll: "Alle",
                nextPage: "Neste side",
                prevPage: "Forrige side",
                firstPage: "Første side",
                lastPage: "Siste side",
                pageText: "{0}-{1} av {2}"
              },
              datePicker: {
                itemsSelected: "{0} valgt",
                nextMonthAriaLabel: "Neste måned",
                nextYearAriaLabel: "Neste år",
                prevMonthAriaLabel: "Forrige måned",
                prevYearAriaLabel: "Forrige år"
              },
              noDataText: "Ingen data er tilgjengelig",
              carousel: {
                prev: "Forrige bilde",
                next: "Neste bilde",
                ariaLabel: {
                  delimiter: "Karusellbilde {0} av {1}"
                }
              },
              calendar: {
                moreEvents: "{0} flere"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} filer",
                counterSize: "{0} filer ({1} totalt)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Paginasjonsnavigasjon",
                  next: "Neste side",
                  previous: "Forrige side",
                  page: "Gå til side {0}",
                  currentPage: "Gjeldende side, side {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/pl.ts": (
          /*!**************************!*\
            !*** ./src/locale/pl.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Odznaka",
              close: "Zamknij",
              dataIterator: {
                noResultsText: "Nie znaleziono danych odpowiadających wyszukiwaniu",
                loadingText: "Wczytywanie danych..."
              },
              dataTable: {
                itemsPerPageText: "Wierszy na stronie:",
                ariaLabel: {
                  sortDescending: "Sortowanie malejąco. Kliknij aby zmienić.",
                  sortAscending: "Sortowanie rosnąco. Kliknij aby zmienić.",
                  sortNone: "Bez sortowania. Kliknij aby posortować rosnąco.",
                  activateNone: "Kliknij aby usunąć sortowanie.",
                  activateDescending: "Kliknij aby posortować malejąco.",
                  activateAscending: "Kliknij aby posortować rosnąco."
                },
                sortBy: "Sortuj według"
              },
              dataFooter: {
                itemsPerPageText: "Pozycji na stronie:",
                itemsPerPageAll: "Wszystkie",
                nextPage: "Następna strona",
                prevPage: "Poprzednia strona",
                firstPage: "Pierwsza strona",
                lastPage: "Ostatnia strona",
                pageText: "{0}-{1} z {2}"
              },
              datePicker: {
                itemsSelected: "{0} dat(y)",
                nextMonthAriaLabel: "Następny miesiąc",
                nextYearAriaLabel: "Następny rok",
                prevMonthAriaLabel: "Poprzedni miesiąc",
                prevYearAriaLabel: "Poprzedni rok"
              },
              noDataText: "Brak danych",
              carousel: {
                prev: "Poprzedni obraz",
                next: "Następny obraz",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "{0} więcej"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "Liczba plików: {0}",
                counterSize: "Liczba plików: {0} (łącznie {1})"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Nawigacja paginacyjna",
                  next: "Następna strona",
                  previous: "Poprzednia strona",
                  page: "Idź do strony {0}",
                  currentPage: "Bieżąca strona, strona {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/pt.ts": (
          /*!**************************!*\
            !*** ./src/locale/pt.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Distintivo",
              close: "Fechar",
              dataIterator: {
                noResultsText: "Nenhum dado encontrado",
                loadingText: "Carregando itens..."
              },
              dataTable: {
                itemsPerPageText: "Linhas por página:",
                ariaLabel: {
                  sortDescending: "Ordenado decrescente.",
                  sortAscending: "Ordenado crescente.",
                  sortNone: "Não ordenado.",
                  activateNone: "Ative para remover a ordenação.",
                  activateDescending: "Ative para ordenar decrescente.",
                  activateAscending: "Ative para ordenar crescente."
                },
                sortBy: "Ordenar por"
              },
              dataFooter: {
                itemsPerPageText: "Itens por página:",
                itemsPerPageAll: "Todos",
                nextPage: "Próxima página",
                prevPage: "Página anterior",
                firstPage: "Primeira página",
                lastPage: "Última página",
                pageText: "{0}-{1} de {2}"
              },
              datePicker: {
                itemsSelected: "{0} selecionado(s)",
                nextMonthAriaLabel: "Próximo mês",
                nextYearAriaLabel: "Próximo ano",
                prevMonthAriaLabel: "Mês anterior",
                prevYearAriaLabel: "Ano anterior"
              },
              noDataText: "Não há dados disponíveis",
              carousel: {
                prev: "Visão anterior",
                next: "Próxima visão",
                ariaLabel: {
                  delimiter: "Slide {0} de {1} do carrossel"
                }
              },
              calendar: {
                moreEvents: "Mais {0}"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} arquivo(s)",
                counterSize: "{0} arquivo(s) ({1} no total)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navegação de paginação",
                  next: "Próxima página",
                  previous: "Página anterior",
                  page: "Ir à página {0}",
                  currentPage: "Página atual, página {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/ro.ts": (
          /*!**************************!*\
            !*** ./src/locale/ro.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Insignă",
              close: "Închideți",
              dataIterator: {
                noResultsText: "Nu s-au găsit înregistrări corespunzătoare",
                loadingText: "Se încarcă articolele..."
              },
              dataTable: {
                itemsPerPageText: "Rânduri pe pagină:",
                ariaLabel: {
                  sortDescending: "Sortate descendent.",
                  sortAscending: "Sortate ascendent.",
                  sortNone: "Nesortate.",
                  activateNone: "Activați pentru a elimina sortarea.",
                  activateDescending: "Activați pentru a sorta descendent.",
                  activateAscending: "Activați pentru a sorta ascendent."
                },
                sortBy: "Sortați după"
              },
              dataFooter: {
                itemsPerPageText: "Articole pe pagină:",
                itemsPerPageAll: "Toate",
                nextPage: "Pagina următoare",
                prevPage: "Pagina anterioară",
                firstPage: "Prima pagină",
                lastPage: "Ultima pagină",
                pageText: "{0}-{1} din {2}"
              },
              datePicker: {
                itemsSelected: "{0} selectate",
                nextMonthAriaLabel: "Luna următoare",
                nextYearAriaLabel: "Anul următor",
                prevMonthAriaLabel: "Luna anterioară",
                prevYearAriaLabel: "Anul anterior"
              },
              noDataText: "Nu există date disponibile",
              carousel: {
                prev: "Grafica anterioară",
                next: "Grafica următoare",
                ariaLabel: {
                  delimiter: "Slide carusel {0} din {1}"
                }
              },
              calendar: {
                moreEvents: "încă {0}"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} fișiere",
                counterSize: "{0} fișiere ({1} în total)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navigare prin paginare",
                  next: "Pagina următoare",
                  previous: "Pagina anterioară",
                  page: "Mergeți la pagina {0}",
                  currentPage: "Pagina curentă, pagina {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating de {0} din {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/ru.ts": (
          /*!**************************!*\
            !*** ./src/locale/ru.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "знак",
              close: "Закрыть",
              dataIterator: {
                noResultsText: "Не найдено подходящих записей",
                loadingText: "Запись загружается..."
              },
              dataTable: {
                itemsPerPageText: "Строк на странице:",
                ariaLabel: {
                  sortDescending: "Упорядочено по убыванию.",
                  sortAscending: "Упорядочено по возрастанию.",
                  sortNone: "Не упорядочено.",
                  activateNone: "Активируйте, чтобы убрать сортировку.",
                  activateDescending: "Активируйте для упорядочивания убыванию.",
                  activateAscending: "Активируйте для упорядочивания по возрастанию."
                },
                sortBy: "Сортировать по"
              },
              dataFooter: {
                itemsPerPageText: "Записей на странице:",
                itemsPerPageAll: "Все",
                nextPage: "Следующая страница",
                prevPage: "Предыдущая страница",
                firstPage: "Первая страница",
                lastPage: "Последняя страница",
                pageText: "{0}-{1} из {2}"
              },
              datePicker: {
                itemsSelected: "{0} выбран",
                nextMonthAriaLabel: "Следующий месяц",
                nextYearAriaLabel: "Следующий год",
                prevMonthAriaLabel: "Прошлый месяц",
                prevYearAriaLabel: "Предыдущий год"
              },
              noDataText: "Отсутствуют данные",
              carousel: {
                prev: "Предыдущий слайд",
                next: "Следующий слайд",
                ariaLabel: {
                  delimiter: "Слайд {0} из {1}"
                }
              },
              calendar: {
                moreEvents: "Еще {0}"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "Файлов: {0}",
                counterSize: "Файлов: {0} (всего {1})"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Навигация по страницам",
                  next: "Следующая страница",
                  previous: "Предыдущая страница",
                  page: "Перейти на страницу {0}",
                  currentPage: "Текущая страница, Страница {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/sk.ts": (
          /*!**************************!*\
            !*** ./src/locale/sk.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Odznak",
              close: "Zavrieť",
              dataIterator: {
                noResultsText: "Neboli nájdené žiadne záznamy",
                loadingText: "Načítavam položky..."
              },
              dataTable: {
                itemsPerPageText: "Počet riadkov na stránku:",
                ariaLabel: {
                  sortDescending: "Zoradené zostupne.",
                  sortAscending: "Zoradené vzostupne.",
                  sortNone: "Nezoradené.",
                  activateNone: "Aktivujte na zrušenie triedenia.",
                  activateDescending: "Aktivujte na zoradenie zostupne.",
                  activateAscending: "Aktivujte na zoradenie vzostupne."
                },
                sortBy: "Zoradiť podľa"
              },
              dataFooter: {
                itemsPerPageText: "Počet položiek na stránku:",
                itemsPerPageAll: "Všetko",
                nextPage: "Ďalšia stránka",
                prevPage: "Predchádzajúca stránka",
                firstPage: "Prvá stránka",
                lastPage: "Posledná stránka",
                pageText: "{0}–{1} z {2}"
              },
              datePicker: {
                itemsSelected: "{0} vybrané",
                nextMonthAriaLabel: "Ďalší mesiac",
                nextYearAriaLabel: "Ďalší rok",
                prevMonthAriaLabel: "Predchádzajúci mesiac",
                prevYearAriaLabel: "Predchádzajúci rok"
              },
              noDataText: "Nie sú dostupné žiadne dáta",
              carousel: {
                prev: "Predchádzajúci obrázok",
                next: "Další obrázok",
                ariaLabel: {
                  delimiter: "Snímka {0} z {1}"
                }
              },
              calendar: {
                moreEvents: "{0} ďalších"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} súborov",
                counterSize: "{0} súborov ({1} celkom)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navigácia stránkovania",
                  next: "Ďalšia stránka",
                  previous: "Predchádzajúca stránka",
                  page: "Ísť na stránku {0}",
                  currentPage: "Aktuálna stránka, stránka {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Hodnotenie {0} z {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/sl.ts": (
          /*!**************************!*\
            !*** ./src/locale/sl.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Značka",
              close: "Zapri",
              dataIterator: {
                noResultsText: "Ni iskanega zapisa",
                loadingText: "Nalaganje..."
              },
              dataTable: {
                itemsPerPageText: "Vrstic na stran:",
                ariaLabel: {
                  sortDescending: "Razvrščeno padajoče.",
                  sortAscending: "Razvrščeno naraščajoče.",
                  sortNone: "Ni razvrščeno.",
                  activateNone: "Aktivirajte za odstranitev razvrščanja.",
                  activateDescending: "Aktivirajte za padajoče razvrščanje.",
                  activateAscending: "Aktivirajte za naraščajoče razvrščanje."
                },
                sortBy: "Razvrsti po"
              },
              dataFooter: {
                itemsPerPageText: "Predmetov na stran:",
                itemsPerPageAll: "Vse",
                nextPage: "Naslednja stran",
                prevPage: "Prejšnja stran",
                firstPage: "Prva stran",
                lastPage: "Zadnja stran",
                pageText: "{0}-{1} od {2}"
              },
              datePicker: {
                itemsSelected: "{0} izbrano/-ih",
                nextMonthAriaLabel: "Naslednji mesec",
                nextYearAriaLabel: "Naslednje leto",
                prevMonthAriaLabel: "Prejšnji mesec",
                prevYearAriaLabel: "Prejšnje leto"
              },
              noDataText: "Ni podatkov",
              carousel: {
                prev: "Prejšnji prikaz",
                next: "Naslednji prikaz",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "Še {0}"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} datotek",
                counterSize: "{0} datotek ({1} skupno)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navigacija po strani po strani",
                  next: "Naslednja stran",
                  previous: "Prejšnja stran",
                  page: "Pojdi na stran {0}",
                  currentPage: "Trenutna stran, stran {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/sr-Cyrl.ts": (
          /*!*******************************!*\
            !*** ./src/locale/sr-Cyrl.ts ***!
            \*******************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Значка",
              close: "Затвори",
              dataIterator: {
                noResultsText: "Ни један запис није пронађен",
                loadingText: "Учитавање ставке..."
              },
              dataTable: {
                itemsPerPageText: "Редова по страници:",
                ariaLabel: {
                  sortDescending: "Сортирано опадајуће.",
                  sortAscending: "Сортирано растуће.",
                  sortNone: "Није сортирано.",
                  activateNone: "Кликни да уклониш сортирање.",
                  activateDescending: "Кликни да сортираш опадајуће.",
                  activateAscending: "Кликни да сортираш растуће."
                },
                sortBy: "Сортирај по"
              },
              dataFooter: {
                itemsPerPageText: "Ставки по страници:",
                itemsPerPageAll: "Све",
                nextPage: "Следећа страница",
                prevPage: "Претходна страница",
                firstPage: "Прва страница",
                lastPage: "Последња страница",
                pageText: "{0}-{1} од {2}"
              },
              datePicker: {
                itemsSelected: "{0} одабрано",
                nextMonthAriaLabel: "Следећег месеца",
                nextYearAriaLabel: "Следеће године",
                prevMonthAriaLabel: "Претходни месец",
                prevYearAriaLabel: "Претходна година"
              },
              noDataText: "Нема доступних података",
              carousel: {
                prev: "Претходна слика",
                next: "Следећа слика",
                ariaLabel: {
                  delimiter: "Слика {0} од {1}"
                }
              },
              calendar: {
                moreEvents: "{0} више"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} фајлова",
                counterSize: "{0} фајлова ({1} укупно)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Навигација страницама",
                  next: "Следећа страница",
                  previous: "Претходна страница",
                  page: "Иди на страну {0}",
                  currentPage: "Тренутна страница, страница {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Оцена {0} од {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/sr-Latn.ts": (
          /*!*******************************!*\
            !*** ./src/locale/sr-Latn.ts ***!
            \*******************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Značka",
              close: "Zatvori",
              dataIterator: {
                noResultsText: "Nijedan zapis nije pronađen",
                loadingText: "Učitavanje stavke..."
              },
              dataTable: {
                itemsPerPageText: "Redova po stranici:",
                ariaLabel: {
                  sortDescending: "Sortirano opadajuće.",
                  sortAscending: "Sortirano rastuće.",
                  sortNone: "Nije sortirano.",
                  activateNone: "Klikni da ukloniš sortiranje.",
                  activateDescending: "Klikni da sortiraš opadajuće.",
                  activateAscending: "Klikni da sortiraš rastuće."
                },
                sortBy: "Sortiraj po"
              },
              dataFooter: {
                itemsPerPageText: "Stavki po stranici:",
                itemsPerPageAll: "Sve",
                nextPage: "Sledeća stranica",
                prevPage: "Prethodna stranica",
                firstPage: "Prva stranica",
                lastPage: "Poslednja stranica",
                pageText: "{0}-{1} od {2}"
              },
              datePicker: {
                itemsSelected: "{0} odabrano",
                nextMonthAriaLabel: "Sledećeg meseca",
                nextYearAriaLabel: "Sledeće godine",
                prevMonthAriaLabel: "Prethodni mesec",
                prevYearAriaLabel: "Prethodna godina"
              },
              noDataText: "Nema dostupnih podataka",
              carousel: {
                prev: "Prethodna slika",
                next: "Sledeća slika",
                ariaLabel: {
                  delimiter: "Slika {0} od {1}"
                }
              },
              calendar: {
                moreEvents: "{0} više"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} fajlova",
                counterSize: "{0} fajlova ({1} ukupno)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Navigacija stranicama",
                  next: "Sledeća stranica",
                  previous: "Prethodna stranica",
                  page: "Idi na stranu {0}",
                  currentPage: "Trenutna stranica, stranica {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Ocena {0} od {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/sv.ts": (
          /*!**************************!*\
            !*** ./src/locale/sv.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Bricka",
              close: "Stäng",
              dataIterator: {
                noResultsText: "Inga poster funna",
                loadingText: "Laddar data..."
              },
              dataTable: {
                itemsPerPageText: "Rader per sida:",
                ariaLabel: {
                  sortDescending: "Sorterat fallande.",
                  sortAscending: "Sorterat stigande.",
                  sortNone: "Osorterat.",
                  activateNone: "Aktivera för att ta bort sortering.",
                  activateDescending: "Aktivera för sortering fallande.",
                  activateAscending: "Aktivera för sortering stigande."
                },
                sortBy: "Sortera efter"
              },
              dataFooter: {
                itemsPerPageText: "Objekt per sida:",
                itemsPerPageAll: "Alla",
                nextPage: "Nästa sida",
                prevPage: "Föregående sida",
                firstPage: "Första sidan",
                lastPage: "Sista sidan",
                pageText: "{0}-{1} av {2}"
              },
              datePicker: {
                itemsSelected: "{0} markerade",
                nextMonthAriaLabel: "Nästa månad",
                nextYearAriaLabel: "Nästa år",
                prevMonthAriaLabel: "Förra månaden",
                prevYearAriaLabel: "Förra året"
              },
              noDataText: "Ingen data tillgänglig",
              carousel: {
                prev: "Föregående vy",
                next: "Nästa vy",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "{0} fler"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} filer",
                counterSize: "{0} filer (av {1} totalt)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Pagination Navigation",
                  next: "Nästa sida",
                  previous: "Föregående sida",
                  page: "Gå till sidan {0}",
                  currentPage: "Aktuell sida, sida {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/th.ts": (
          /*!**************************!*\
            !*** ./src/locale/th.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "สัญลักษณ์",
              close: "ปิด",
              dataIterator: {
                noResultsText: "ไม่พบข้อมูลที่ค้นหา",
                loadingText: "กำลังโหลดข้อมูล..."
              },
              dataTable: {
                itemsPerPageText: "แถวต่อหน้า:",
                ariaLabel: {
                  sortDescending: "เรียงจากมากไปน้อยอยู่",
                  sortAscending: "เรียงจากน้อยไปมากอยู่",
                  sortNone: "ไม่ได้เรียงลำดับ",
                  activateNone: "กดเพื่อปิดการเรียงลำดับ",
                  activateDescending: "กดเพื่อเรียงจากมากไปน้อย",
                  activateAscending: "กดเพื่อเรียงจากน้อยไปมาก"
                },
                sortBy: "เรียงตาม"
              },
              dataFooter: {
                itemsPerPageText: "รายการต่อหน้า:",
                itemsPerPageAll: "ทั้งหมด",
                nextPage: "หน้าต่อไป",
                prevPage: "หน้าที่แล้ว",
                firstPage: "หน้าแรก",
                lastPage: "หน้าสุดท้าย",
                pageText: "{0}-{1} จาก {2}"
              },
              datePicker: {
                itemsSelected: "เลือก {0} วัน",
                nextMonthAriaLabel: "เดือนถัดไป",
                nextYearAriaLabel: "ปีถัดไป",
                prevMonthAriaLabel: "เดือนก่อนหน้า",
                prevYearAriaLabel: "ปีก่อนหน้า"
              },
              noDataText: "ไม่มีข้อมูล",
              carousel: {
                prev: "ภาพก่อนหน้า",
                next: "ภาพถัดไป",
                ariaLabel: {
                  delimiter: "ภาพสไลด์ที่ {0} จาก {1}"
                }
              },
              calendar: {
                moreEvents: "มีอีก {0}"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} ไฟล์",
                counterSize: "{0} ไฟล์ (รวม {1})"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "การนำทางไปยังหน้า",
                  next: "หน้าต่อไป",
                  previous: "หน้าที่แล้ว",
                  page: "ไปที่หน้า {0}",
                  currentPage: "หน้าปัจจุบัน (หน้า {0})"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/tr.ts": (
          /*!**************************!*\
            !*** ./src/locale/tr.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "rozet",
              close: "Kapat",
              dataIterator: {
                noResultsText: "Eşleşen veri bulunamadı",
                loadingText: "Yükleniyor... Lütfen bekleyin."
              },
              dataTable: {
                itemsPerPageText: "Sayfa başına satır:",
                ariaLabel: {
                  sortDescending: "Z den A ya sıralı.",
                  sortAscending: "A dan Z ye sıralı.",
                  sortNone: "Sıralı değil. ",
                  activateNone: "Sıralamayı kaldırmak için etkinleştir.",
                  activateDescending: "Z den A ya sıralamak için etkinleştir.",
                  activateAscending: "A dan Z ye sıralamak için etkinleştir."
                },
                sortBy: "Sırala"
              },
              dataFooter: {
                itemsPerPageText: "Sayfa başına satır:",
                itemsPerPageAll: "Hepsi",
                nextPage: "Sonraki sayfa",
                prevPage: "Önceki sayfa",
                firstPage: "İlk sayfa",
                lastPage: "Son sayfa",
                pageText: "{0} - {1} arası, Toplam: {2} kayıt"
              },
              datePicker: {
                itemsSelected: "{0} öge seçildi",
                nextMonthAriaLabel: "Gelecek ay",
                nextYearAriaLabel: "Gelecek yıl",
                prevMonthAriaLabel: "Geçtiğimiz ay",
                prevYearAriaLabel: "Geçen yıl"
              },
              noDataText: "Bu görünümde veri yok.",
              carousel: {
                prev: "Önceki görsel",
                next: "Sonraki görsel",
                ariaLabel: {
                  delimiter: "Galeri sayfa {0} / {1}"
                }
              },
              calendar: {
                moreEvents: "{0} tane daha"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} dosya",
                counterSize: "{0} dosya (toplamda {1})"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Sayfalandırma Navigasyonu",
                  next: "Sonraki sayfa",
                  previous: "Önceki sayfa",
                  page: "Sayfaya git {0}",
                  currentPage: "Geçerli Sayfa, Sayfa {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/uk.ts": (
          /*!**************************!*\
            !*** ./src/locale/uk.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Знак",
              close: "Закрити",
              dataIterator: {
                noResultsText: "В результаті пошуку нічого не знайдено",
                loadingText: "Завантаження..."
              },
              dataTable: {
                itemsPerPageText: "Рядків на сторінці:",
                ariaLabel: {
                  sortDescending: "Відсортовано за спаданням.",
                  sortAscending: "Відсортовано за зростанням.",
                  sortNone: "Не відсортовано.",
                  activateNone: "Активувати, щоб видалити сортування.",
                  activateDescending: "Активувати, щоб відсортувати за спаданням.",
                  activateAscending: "Активувати, щоб відсортувати за зростанням."
                },
                sortBy: "Відсортувати за"
              },
              dataFooter: {
                itemsPerPageText: "Елементів на сторінці:",
                itemsPerPageAll: "Всі",
                nextPage: "Наступна сторінка",
                prevPage: "Попередня сторінка",
                firstPage: "Перша сторінка",
                lastPage: "Остання сторінка",
                pageText: "{0}-{1} з {2}"
              },
              datePicker: {
                itemsSelected: "{0} вибрано",
                nextMonthAriaLabel: "Наступного місяця",
                nextYearAriaLabel: "Наступного року",
                prevMonthAriaLabel: "Попередній місяць",
                prevYearAriaLabel: "Попередній рік"
              },
              noDataText: "Немає даних для відображення",
              carousel: {
                prev: "Попередній слайд",
                next: "Наступий слайд",
                ariaLabel: {
                  delimiter: "Слайд {0} з {1}"
                }
              },
              calendar: {
                moreEvents: "Ще {0}"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} файлів",
                counterSize: "{0} файлів ({1} загалом)"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Навігація по сторінках",
                  next: "Наступна сторінка",
                  previous: "Попередня сторінка",
                  page: "Перейти на сторінку {0}",
                  currentPage: "Поточна сторінка, Сторінка {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/vi.ts": (
          /*!**************************!*\
            !*** ./src/locale/vi.ts ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "Huy hiệu",
              close: "Đóng",
              dataIterator: {
                noResultsText: "Không tìm thấy kết quả nào",
                loadingText: "Đang tải..."
              },
              dataTable: {
                itemsPerPageText: "Số hàng mỗi trang:",
                ariaLabel: {
                  sortDescending: "Sắp xếp giảm dần.",
                  sortAscending: "Sắp xếp tăng dần.",
                  sortNone: "Không sắp xếp.",
                  activateNone: "Kích hoạt để bỏ sắp xếp.",
                  activateDescending: "Kích hoạt để sắp xếp giảm dần.",
                  activateAscending: "Kích hoạt để sắp xếp tăng dần."
                },
                sortBy: "Sắp xếp"
              },
              dataFooter: {
                itemsPerPageText: "Số mục mỗi trang:",
                itemsPerPageAll: "Toàn bộ",
                nextPage: "Trang tiếp theo",
                prevPage: "Trang trước",
                firstPage: "Trang đầu",
                lastPage: "Trang cuối",
                pageText: "{0}-{1} trên {2}"
              },
              datePicker: {
                itemsSelected: "{0} được chọn",
                nextMonthAriaLabel: "Tháng sau",
                nextYearAriaLabel: "Năm sau",
                prevMonthAriaLabel: "Tháng trước",
                prevYearAriaLabel: "Năm trước"
              },
              noDataText: "Không có dữ liệu",
              carousel: {
                prev: "Ảnh tiếp theo",
                next: "Ảnh trước",
                ariaLabel: {
                  delimiter: "Carousel slide {0} trên {1}"
                }
              },
              calendar: {
                moreEvents: "{0} nữa"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} tệp",
                counterSize: "{0} tệp (tổng cộng {1})"
              },
              timePicker: {
                am: "SA",
                pm: "CH"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "Điều hướng phân trang",
                  next: "Trang tiếp theo",
                  previous: "Trang trước",
                  page: "Đến trang {0}",
                  currentPage: "Trang hiện tại, Trang {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Đánh giá {0} trên {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/zh-Hans.ts": (
          /*!*******************************!*\
            !*** ./src/locale/zh-Hans.ts ***!
            \*******************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "徽章",
              close: "关闭",
              dataIterator: {
                noResultsText: "没有符合条件的结果",
                loadingText: "加载中……"
              },
              dataTable: {
                itemsPerPageText: "每页数目：",
                ariaLabel: {
                  sortDescending: "：降序排列。",
                  sortAscending: "：升序排列。",
                  sortNone: "：未排序。",
                  activateNone: "点击以移除排序。",
                  activateDescending: "点击以降序排列。",
                  activateAscending: "点击以升序排列。"
                },
                sortBy: "排序方式"
              },
              dataFooter: {
                itemsPerPageText: "每页数目：",
                itemsPerPageAll: "全部",
                nextPage: "下一页",
                prevPage: "上一页",
                firstPage: "首页",
                lastPage: "尾页",
                pageText: "{0}-{1} 共 {2}"
              },
              datePicker: {
                itemsSelected: "已选择 {0}",
                nextMonthAriaLabel: "下个月",
                nextYearAriaLabel: "明年",
                prevMonthAriaLabel: "前一个月",
                prevYearAriaLabel: "前一年"
              },
              noDataText: "没有数据",
              carousel: {
                prev: "上一张",
                next: "下一张",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "还有 {0} 项"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} 个文件",
                counterSize: "{0} 个文件（共 {1}）"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "分页导航",
                  next: "下一页",
                  previous: "上一页",
                  page: "转到页面 {0}",
                  currentPage: "当前页 {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/locale/zh-Hant.ts": (
          /*!*******************************!*\
            !*** ./src/locale/zh-Hant.ts ***!
            \*******************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_exports__["default"] = {
              badge: "徽章",
              close: "關閉",
              dataIterator: {
                noResultsText: "沒有符合條件的結果",
                loadingText: "讀取中..."
              },
              dataTable: {
                itemsPerPageText: "每頁列數：",
                ariaLabel: {
                  sortDescending: "：降序排列。",
                  sortAscending: "：升序排列。",
                  sortNone: "無排序方式。點擊以升序排列。",
                  activateNone: "點擊以移除排序方式。",
                  activateDescending: "點擊以降序排列。",
                  activateAscending: "點擊以移除排序方式。"
                },
                sortBy: "排序方式"
              },
              dataFooter: {
                itemsPerPageText: "每頁項目：",
                itemsPerPageAll: "全部",
                nextPage: "下一頁",
                prevPage: "上一頁",
                firstPage: "第一頁",
                lastPage: "最後頁",
                pageText: "{2} 條中的 {0}~{1} 條"
              },
              datePicker: {
                itemsSelected: "已選擇 {0}",
                nextMonthAriaLabel: "下個月",
                nextYearAriaLabel: "明年",
                prevMonthAriaLabel: "前一個月",
                prevYearAriaLabel: "前一年"
              },
              noDataText: "沒有資料",
              carousel: {
                prev: "上一張",
                next: "下一張",
                ariaLabel: {
                  delimiter: "Carousel slide {0} of {1}"
                }
              },
              calendar: {
                moreEvents: "還有其他 {0} 項"
              },
              input: {
                clear: "Clear {0}",
                prependAction: "{0} prepended action",
                appendAction: "{0} appended action"
              },
              fileInput: {
                counter: "{0} 個檔案",
                counterSize: "{0} 個檔案（共 {1}）"
              },
              timePicker: {
                am: "AM",
                pm: "PM"
              },
              pagination: {
                ariaLabel: {
                  wrapper: "分頁導航",
                  next: "下一頁",
                  previous: "上一頁",
                  page: "轉到頁面 {0}",
                  currentPage: "當前頁 {0}"
                }
              },
              rating: {
                ariaLabel: {
                  icon: "Rating {0} of {1}"
                }
              },
              loading: "Loading..."
            };
          }
        ),
        /***/
        "./src/mixins/activatable/index.ts": (
          /*!*****************************************!*\
            !*** ./src/mixins/activatable/index.ts ***!
            \*****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _delayable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../delayable */
              "./src/mixins/delayable/index.ts"
            );
            var _toggleable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../toggleable */
              "./src/mixins/toggleable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __values2 = function(o) {
              var s2 = typeof Symbol === "function" && Symbol.iterator, m = s2 && o[s2], i2 = 0;
              if (m)
                return m.call(o);
              if (o && typeof o.length === "number")
                return {
                  next: function next() {
                    if (o && i2 >= o.length)
                      o = void 0;
                    return {
                      value: o && o[i2++],
                      done: !o
                    };
                  }
                };
              throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_delayable__WEBPACK_IMPORTED_MODULE_0__["default"], _toggleable__WEBPACK_IMPORTED_MODULE_1__["default"]);
            __webpack_exports__["default"] = baseMixins.extend({
              name: "activatable",
              props: {
                activator: {
                  default: null,
                  validator: function validator2(val) {
                    return ["string", "object"].includes(_typeof2(val));
                  }
                },
                disabled: Boolean,
                internalActivator: Boolean,
                openOnClick: {
                  type: Boolean,
                  default: true
                },
                openOnHover: Boolean,
                openOnFocus: Boolean
              },
              data: function data() {
                return {
                  // Do not use this directly, call getActivator() instead
                  activatorElement: null,
                  activatorNode: [],
                  events: ["click", "mouseenter", "mouseleave", "focus"],
                  listeners: {}
                };
              },
              watch: {
                activator: "resetActivator",
                openOnFocus: "resetActivator",
                openOnHover: "resetActivator"
              },
              mounted: function mounted3() {
                var slotType = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlotType"])(this, "activator", true);
                if (slotType && ["v-slot", "normal"].includes(slotType)) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_4__["consoleError"])(`The activator slot must be bound, try '<template v-slot:activator="{ on }"><v-btn v-on="on">'`, this);
                }
                this.addActivatorEvents();
              },
              beforeDestroy: function beforeDestroy2() {
                this.removeActivatorEvents();
              },
              methods: {
                addActivatorEvents: function addActivatorEvents() {
                  var e_1, _a2;
                  if (!this.activator || this.disabled || !this.getActivator())
                    return;
                  this.listeners = this.genActivatorListeners();
                  var keys2 = Object.keys(this.listeners);
                  try {
                    for (var keys_12 = __values2(keys2), keys_1_1 = keys_12.next(); !keys_1_1.done; keys_1_1 = keys_12.next()) {
                      var key = keys_1_1.value;
                      this.getActivator().addEventListener(key, this.listeners[key]);
                    }
                  } catch (e_1_1) {
                    e_1 = {
                      error: e_1_1
                    };
                  } finally {
                    try {
                      if (keys_1_1 && !keys_1_1.done && (_a2 = keys_12.return))
                        _a2.call(keys_12);
                    } finally {
                      if (e_1)
                        throw e_1.error;
                    }
                  }
                },
                genActivator: function genActivator() {
                  var node2 = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this, "activator", Object.assign(this.getValueProxy(), {
                    on: this.genActivatorListeners(),
                    attrs: this.genActivatorAttributes()
                  })) || [];
                  this.activatorNode = node2;
                  return node2;
                },
                genActivatorAttributes: function genActivatorAttributes() {
                  return {
                    role: this.openOnClick && !this.openOnHover ? "button" : void 0,
                    "aria-haspopup": true,
                    "aria-expanded": String(this.isActive)
                  };
                },
                genActivatorListeners: function genActivatorListeners() {
                  var _this2 = this;
                  if (this.disabled)
                    return {};
                  var listeners = {};
                  if (this.openOnHover) {
                    listeners.mouseenter = function(e) {
                      _this2.getActivator(e);
                      _this2.runDelay("open");
                    };
                    listeners.mouseleave = function(e) {
                      _this2.getActivator(e);
                      _this2.runDelay("close");
                    };
                  } else if (this.openOnClick) {
                    listeners.click = function(e) {
                      var activator = _this2.getActivator(e);
                      if (activator)
                        activator.focus();
                      e.stopPropagation();
                      _this2.isActive = !_this2.isActive;
                    };
                  }
                  if (this.openOnFocus) {
                    listeners.focus = function(e) {
                      _this2.getActivator(e);
                      e.stopPropagation();
                      _this2.isActive = !_this2.isActive;
                    };
                  }
                  return listeners;
                },
                getActivator: function getActivator(e) {
                  if (this.activatorElement)
                    return this.activatorElement;
                  var activator = null;
                  if (this.activator) {
                    var target2 = this.internalActivator ? this.$el : document;
                    if (typeof this.activator === "string") {
                      activator = target2.querySelector(this.activator);
                    } else if (this.activator.$el) {
                      activator = this.activator.$el;
                    } else {
                      activator = this.activator;
                    }
                  } else if (this.activatorNode.length === 1 || this.activatorNode.length && !e) {
                    var vm = this.activatorNode[0].componentInstance;
                    if (vm && vm.$options.mixins && //                         Activatable is indirectly used via Menuable
                    vm.$options.mixins.some(function(m) {
                      return m.options && ["activatable", "menuable"].includes(m.options.name);
                    })) {
                      activator = vm.getActivator();
                    } else {
                      activator = this.activatorNode[0].elm;
                    }
                  } else if (e) {
                    activator = e.currentTarget || e.target;
                  }
                  this.activatorElement = (activator === null || activator === void 0 ? void 0 : activator.nodeType) === Node.ELEMENT_NODE ? activator : null;
                  return this.activatorElement;
                },
                getContentSlot: function getContentSlot() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getSlot"])(this, "default", this.getValueProxy(), true);
                },
                getValueProxy: function getValueProxy() {
                  var self2 = this;
                  return {
                    get value() {
                      return self2.isActive;
                    },
                    set value(isActive) {
                      self2.isActive = isActive;
                    }
                  };
                },
                removeActivatorEvents: function removeActivatorEvents() {
                  var e_2, _a2;
                  if (!this.activator || !this.activatorElement)
                    return;
                  var keys2 = Object.keys(this.listeners);
                  try {
                    for (var keys_2 = __values2(keys2), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
                      var key = keys_2_1.value;
                      this.activatorElement.removeEventListener(key, this.listeners[key]);
                    }
                  } catch (e_2_1) {
                    e_2 = {
                      error: e_2_1
                    };
                  } finally {
                    try {
                      if (keys_2_1 && !keys_2_1.done && (_a2 = keys_2.return))
                        _a2.call(keys_2);
                    } finally {
                      if (e_2)
                        throw e_2.error;
                    }
                  }
                  this.listeners = {};
                },
                resetActivator: function resetActivator() {
                  this.removeActivatorEvents();
                  this.activatorElement = null;
                  this.getActivator();
                  this.addActivatorEvents();
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/applicationable/index.ts": (
          /*!*********************************************!*\
            !*** ./src/mixins/applicationable/index.ts ***!
            \*********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", function() {
              return applicationable;
            });
            var _positionable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../positionable */
              "./src/mixins/positionable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            function applicationable(value, events2) {
              if (events2 === void 0) {
                events2 = [];
              }
              return Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(Object(_positionable__WEBPACK_IMPORTED_MODULE_0__["factory"])(["absolute", "fixed"])).extend({
                name: "applicationable",
                props: {
                  app: Boolean
                },
                computed: {
                  applicationProperty: function applicationProperty() {
                    return value;
                  }
                },
                watch: {
                  // If previous value was app
                  // reset the provided prop
                  app: function app(x2, prev) {
                    prev ? this.removeApplication(true) : this.callUpdate();
                  },
                  applicationProperty: function applicationProperty(newVal, oldVal) {
                    this.$vuetify.application.unregister(this._uid, oldVal);
                  }
                },
                activated: function activated() {
                  this.callUpdate();
                },
                created: function created2() {
                  for (var i2 = 0, length = events2.length; i2 < length; i2++) {
                    this.$watch(events2[i2], this.callUpdate);
                  }
                  this.callUpdate();
                },
                mounted: function mounted3() {
                  this.callUpdate();
                },
                deactivated: function deactivated() {
                  this.removeApplication();
                },
                destroyed: function destroyed2() {
                  this.removeApplication();
                },
                methods: {
                  callUpdate: function callUpdate() {
                    if (!this.app)
                      return;
                    this.$vuetify.application.register(this._uid, this.applicationProperty, this.updateApplication());
                  },
                  removeApplication: function removeApplication(force) {
                    if (force === void 0) {
                      force = false;
                    }
                    if (!force && !this.app)
                      return;
                    this.$vuetify.application.unregister(this._uid, this.applicationProperty);
                  },
                  updateApplication: function updateApplication() {
                    return 0;
                  }
                }
              });
            }
          }
        ),
        /***/
        "./src/mixins/binds-attrs/index.ts": (
          /*!*****************************************!*\
            !*** ./src/mixins/binds-attrs/index.ts ***!
            \*****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            function makeWatcher(property2) {
              return function(val, oldVal) {
                for (var attr in oldVal) {
                  if (!Object.prototype.hasOwnProperty.call(val, attr)) {
                    this.$delete(this.$data[property2], attr);
                  }
                }
                for (var attr in val) {
                  this.$set(this.$data[property2], attr, val[attr]);
                }
              };
            }
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              data: function data() {
                return {
                  attrs$: {},
                  listeners$: {}
                };
              },
              created: function created2() {
                this.$watch("$attrs", makeWatcher("attrs$"), {
                  immediate: true
                });
                this.$watch("$listeners", makeWatcher("listeners$"), {
                  immediate: true
                });
              }
            });
          }
        ),
        /***/
        "./src/mixins/bootable/index.ts": (
          /*!**************************************!*\
            !*** ./src/mixins/bootable/index.ts ***!
            \**************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _util_console__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend().extend({
              name: "bootable",
              props: {
                eager: Boolean
              },
              data: function data() {
                return {
                  isBooted: false
                };
              },
              computed: {
                hasContent: function hasContent() {
                  return this.isBooted || this.eager || this.isActive;
                }
              },
              watch: {
                isActive: function isActive() {
                  this.isBooted = true;
                }
              },
              created: function created2() {
                if ("lazy" in this.$attrs) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_0__["removed"])("lazy", this);
                }
              },
              methods: {
                showLazyContent: function showLazyContent(content) {
                  return this.hasContent && content ? content() : [this.$createElement()];
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/button-group/index.ts": (
          /*!******************************************!*\
            !*** ./src/mixins/button-group/index.ts ***!
            \******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _components_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../components/VItemGroup/VItemGroup */
              "./src/components/VItemGroup/VItemGroup.ts"
            );
            __webpack_exports__["default"] = _components_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_0__["BaseItemGroup"].extend({
              name: "button-group",
              provide: function provide() {
                return {
                  btnToggle: this
                };
              },
              computed: {
                classes: function classes() {
                  return _components_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_0__["BaseItemGroup"].options.computed.classes.call(this);
                }
              },
              methods: {
                // Isn't being passed down through types
                genData: _components_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_0__["BaseItemGroup"].options.methods.genData
              }
            });
          }
        ),
        /***/
        "./src/mixins/colorable/index.ts": (
          /*!***************************************!*\
            !*** ./src/mixins/colorable/index.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_colorUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/colorUtils */
              "./src/util/colorUtils.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "colorable",
              props: {
                color: String
              },
              methods: {
                setBackgroundColor: function setBackgroundColor(color2, data) {
                  var _a2;
                  if (data === void 0) {
                    data = {};
                  }
                  if (typeof data.style === "string") {
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleError"])("style must be an object", this);
                    return data;
                  }
                  if (typeof data.class === "string") {
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleError"])("class must be an object", this);
                    return data;
                  }
                  if (Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_2__["isCssColor"])(color2)) {
                    data.style = __assign2(__assign2({}, data.style), {
                      "background-color": "" + color2,
                      "border-color": "" + color2
                    });
                  } else if (color2) {
                    data.class = __assign2(__assign2({}, data.class), (_a2 = {}, _a2[color2] = true, _a2));
                  }
                  return data;
                },
                setTextColor: function setTextColor(color2, data) {
                  var _a2;
                  if (data === void 0) {
                    data = {};
                  }
                  if (typeof data.style === "string") {
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleError"])("style must be an object", this);
                    return data;
                  }
                  if (typeof data.class === "string") {
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleError"])("class must be an object", this);
                    return data;
                  }
                  if (Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_2__["isCssColor"])(color2)) {
                    data.style = __assign2(__assign2({}, data.style), {
                      color: "" + color2,
                      "caret-color": "" + color2
                    });
                  } else if (color2) {
                    var _b2 = __read2(color2.toString().trim().split(" ", 2), 2), colorName2 = _b2[0], colorModifier = _b2[1];
                    data.class = __assign2(__assign2({}, data.class), (_a2 = {}, _a2[colorName2 + "--text"] = true, _a2));
                    if (colorModifier) {
                      data.class["text--" + colorModifier] = true;
                    }
                  }
                  return data;
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/comparable/index.ts": (
          /*!****************************************!*\
            !*** ./src/mixins/comparable/index.ts ***!
            \****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "comparable",
              props: {
                valueComparator: {
                  type: Function,
                  default: _util_helpers__WEBPACK_IMPORTED_MODULE_1__["deepEqual"]
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/delayable/index.ts": (
          /*!***************************************!*\
            !*** ./src/mixins/delayable/index.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
              name: "delayable",
              props: {
                openDelay: {
                  type: [Number, String],
                  default: 0
                },
                closeDelay: {
                  type: [Number, String],
                  default: 0
                }
              },
              data: function data() {
                return {
                  openTimeout: void 0,
                  closeTimeout: void 0
                };
              },
              methods: {
                /**
                 * Clear any pending delay timers from executing
                 */
                clearDelay: function clearDelay() {
                  clearTimeout(this.openTimeout);
                  clearTimeout(this.closeTimeout);
                },
                /**
                 * Runs callback after a specified delay
                 */
                runDelay: function runDelay(type, cb) {
                  var _this2 = this;
                  this.clearDelay();
                  var delay = parseInt(this[type + "Delay"], 10);
                  this[type + "Timeout"] = setTimeout(cb || function() {
                    _this2.isActive = {
                      open: true,
                      close: false
                    }[type];
                  }, delay);
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/dependent/index.ts": (
          /*!***************************************!*\
            !*** ./src/mixins/dependent/index.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _util_mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            function searchChildren(children) {
              var results = [];
              for (var index2 = 0; index2 < children.length; index2++) {
                var child = children[index2];
                if (child.isActive && child.isDependent) {
                  results.push(child);
                } else {
                  results.push.apply(results, __spreadArray2([], __read2(searchChildren(child.$children)), false));
                }
              }
              return results;
            }
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_0__["default"])().extend({
              name: "dependent",
              data: function data() {
                return {
                  closeDependents: true,
                  isActive: false,
                  isDependent: true
                };
              },
              watch: {
                isActive: function isActive(val) {
                  if (val)
                    return;
                  var openDependents = this.getOpenDependents();
                  for (var index2 = 0; index2 < openDependents.length; index2++) {
                    openDependents[index2].isActive = false;
                  }
                }
              },
              methods: {
                getOpenDependents: function getOpenDependents() {
                  if (this.closeDependents)
                    return searchChildren(this.$children);
                  return [];
                },
                getOpenDependentElements: function getOpenDependentElements() {
                  var result2 = [];
                  var openDependents = this.getOpenDependents();
                  for (var index2 = 0; index2 < openDependents.length; index2++) {
                    result2.push.apply(result2, __spreadArray2([], __read2(openDependents[index2].getClickableDependentElements()), false));
                  }
                  return result2;
                },
                getClickableDependentElements: function getClickableDependentElements() {
                  var result2 = [this.$el];
                  if (this.$refs.content)
                    result2.push(this.$refs.content);
                  if (this.overlay)
                    result2.push(this.overlay.$el);
                  result2.push.apply(result2, __spreadArray2([], __read2(this.getOpenDependentElements()), false));
                  return result2;
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/detachable/index.ts": (
          /*!****************************************!*\
            !*** ./src/mixins/detachable/index.ts ***!
            \****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _bootable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../bootable */
              "./src/mixins/bootable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            function validateAttachTarget(val) {
              var type = _typeof2(val);
              if (type === "boolean" || type === "string")
                return true;
              return val.nodeType === Node.ELEMENT_NODE;
            }
            function removeActivator(activator) {
              activator.forEach(function(node2) {
                node2.elm && node2.elm.parentNode && node2.elm.parentNode.removeChild(node2.elm);
              });
            }
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_bootable__WEBPACK_IMPORTED_MODULE_0__["default"]).extend({
              name: "detachable",
              props: {
                attach: {
                  default: false,
                  validator: validateAttachTarget
                },
                contentClass: {
                  type: String,
                  default: ""
                }
              },
              data: function data() {
                return {
                  activatorNode: null,
                  hasDetached: false
                };
              },
              watch: {
                attach: function attach() {
                  this.hasDetached = false;
                  this.initDetach();
                },
                hasContent: function hasContent() {
                  this.$nextTick(this.initDetach);
                }
              },
              beforeMount: function beforeMount2() {
                var _this2 = this;
                this.$nextTick(function() {
                  if (_this2.activatorNode) {
                    var activator = Array.isArray(_this2.activatorNode) ? _this2.activatorNode : [_this2.activatorNode];
                    activator.forEach(function(node2) {
                      if (!node2.elm)
                        return;
                      if (!_this2.$el.parentNode)
                        return;
                      var target2 = _this2.$el === _this2.$el.parentNode.firstChild ? _this2.$el : _this2.$el.nextSibling;
                      _this2.$el.parentNode.insertBefore(node2.elm, target2);
                    });
                  }
                });
              },
              mounted: function mounted3() {
                this.hasContent && this.initDetach();
              },
              deactivated: function deactivated() {
                this.isActive = false;
              },
              beforeDestroy: function beforeDestroy2() {
                if (this.$refs.content && this.$refs.content.parentNode) {
                  this.$refs.content.parentNode.removeChild(this.$refs.content);
                }
              },
              destroyed: function destroyed2() {
                var _this2 = this;
                if (this.activatorNode) {
                  var activator_1 = Array.isArray(this.activatorNode) ? this.activatorNode : [this.activatorNode];
                  if (this.$el.isConnected) {
                    var observer_1 = new MutationObserver(function(list2) {
                      if (list2.some(function(record) {
                        return Array.from(record.removedNodes).includes(_this2.$el);
                      })) {
                        observer_1.disconnect();
                        removeActivator(activator_1);
                      }
                    });
                    observer_1.observe(this.$el.parentNode, {
                      subtree: false,
                      childList: true
                    });
                  } else {
                    removeActivator(activator_1);
                  }
                }
              },
              methods: {
                getScopeIdAttrs: function getScopeIdAttrs() {
                  var _a2;
                  var scopeId = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getObjectValueByPath"])(this.$vnode, "context.$options._scopeId");
                  return scopeId && (_a2 = {}, _a2[scopeId] = "", _a2);
                },
                initDetach: function initDetach() {
                  if (this._isDestroyed || !this.$refs.content || this.hasDetached || // Leave menu in place if attached
                  // and dev has not changed target
                  this.attach === "" || // If used as a boolean prop (<v-menu attach>)
                  this.attach === true || // If bound to a boolean (<v-menu :attach="true">)
                  this.attach === "attach")
                    return;
                  var target2;
                  if (this.attach === false) {
                    target2 = document.querySelector("[data-app]");
                  } else if (typeof this.attach === "string") {
                    target2 = document.querySelector(this.attach);
                  } else {
                    target2 = this.attach;
                  }
                  if (!target2) {
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["consoleWarn"])("Unable to locate target " + (this.attach || "[data-app]"), this);
                    return;
                  }
                  target2.appendChild(this.$refs.content);
                  this.hasDetached = true;
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/elevatable/index.ts": (
          /*!****************************************!*\
            !*** ./src/mixins/elevatable/index.ts ***!
            \****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "elevatable",
              props: {
                elevation: [Number, String]
              },
              computed: {
                computedElevation: function computedElevation() {
                  return this.elevation;
                },
                elevationClasses: function elevationClasses() {
                  var _a2;
                  var elevation = this.computedElevation;
                  if (elevation == null)
                    return {};
                  if (isNaN(parseInt(elevation)))
                    return {};
                  return _a2 = {}, _a2["elevation-" + this.elevation] = true, _a2;
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/filterable/index.ts": (
          /*!****************************************!*\
            !*** ./src/mixins/filterable/index.ts ***!
            \****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "filterable",
              props: {
                noDataText: {
                  type: String,
                  default: "$vuetify.noDataText"
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/groupable/index.ts": (
          /*!***************************************!*\
            !*** ./src/mixins/groupable/index.ts ***!
            \***************************************/
          /*! exports provided: factory, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "factory", function() {
              return factory;
            });
            var _registrable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../registrable */
              "./src/mixins/registrable/index.ts"
            );
            function factory(namespace, child, parent2) {
              return Object(_registrable__WEBPACK_IMPORTED_MODULE_0__["inject"])(namespace, child, parent2).extend({
                name: "groupable",
                props: {
                  activeClass: {
                    type: String,
                    default: function _default() {
                      if (!this[namespace])
                        return void 0;
                      return this[namespace].activeClass;
                    }
                  },
                  disabled: Boolean
                },
                data: function data() {
                  return {
                    isActive: false
                  };
                },
                computed: {
                  groupClasses: function groupClasses() {
                    var _a2;
                    if (!this.activeClass)
                      return {};
                    return _a2 = {}, _a2[this.activeClass] = this.isActive, _a2;
                  }
                },
                created: function created2() {
                  this[namespace] && this[namespace].register(this);
                },
                beforeDestroy: function beforeDestroy2() {
                  this[namespace] && this[namespace].unregister(this);
                },
                methods: {
                  toggle: function toggle(e) {
                    if (this.disabled && e) {
                      e.preventDefault();
                      return;
                    }
                    this.$emit("change");
                  }
                }
              });
            }
            var Groupable = factory("itemGroup");
            __webpack_exports__["default"] = Groupable;
          }
        ),
        /***/
        "./src/mixins/intersectable/index.ts": (
          /*!*******************************************!*\
            !*** ./src/mixins/intersectable/index.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", function() {
              return intersectable;
            });
            var _directives_intersect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../directives/intersect */
              "./src/directives/intersect/index.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_2___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
            function intersectable(options) {
              return vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend({
                name: "intersectable",
                data: function data() {
                  return {
                    isIntersecting: false
                  };
                },
                mounted: function mounted3() {
                  _directives_intersect__WEBPACK_IMPORTED_MODULE_0__["default"].inserted(this.$el, {
                    name: "intersect",
                    value: this.onObserve
                  }, this.$vnode);
                },
                destroyed: function destroyed2() {
                  _directives_intersect__WEBPACK_IMPORTED_MODULE_0__["default"].unbind(this.$el, {
                    name: "intersect",
                    value: this.onObserve
                  }, this.$vnode);
                },
                methods: {
                  onObserve: function onObserve(entries, observer, isIntersecting) {
                    this.isIntersecting = isIntersecting;
                    if (!isIntersecting)
                      return;
                    for (var i2 = 0, length = options.onVisible.length; i2 < length; i2++) {
                      var callback = this[options.onVisible[i2]];
                      if (typeof callback === "function") {
                        callback();
                        continue;
                      }
                      Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleWarn"])(options.onVisible[i2] + " method is not available on the instance but referenced in intersectable mixin options");
                    }
                  }
                }
              });
            }
          }
        ),
        /***/
        "./src/mixins/loadable/index.ts": (
          /*!**************************************!*\
            !*** ./src/mixins/loadable/index.ts ***!
            \**************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var _components_VProgressLinear__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../components/VProgressLinear */
              "./src/components/VProgressLinear/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
              name: "loadable",
              props: {
                loading: {
                  type: [Boolean, String],
                  default: false
                },
                loaderHeight: {
                  type: [Number, String],
                  default: 2
                }
              },
              methods: {
                genProgress: function genProgress() {
                  if (this.loading === false)
                    return null;
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["getSlot"])(this, "progress") || this.$createElement(_components_VProgressLinear__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: {
                      absolute: true,
                      color: this.loading === true || this.loading === "" ? this.color || "primary" : this.loading,
                      height: this.loaderHeight,
                      indeterminate: true
                    }
                  });
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/localable/index.ts": (
          /*!***************************************!*\
            !*** ./src/mixins/localable/index.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "localable",
              props: {
                locale: String
              },
              computed: {
                currentLocale: function currentLocale() {
                  return this.locale || this.$vuetify.lang.current;
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/measurable/index.ts": (
          /*!****************************************!*\
            !*** ./src/mixins/measurable/index.ts ***!
            \****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
              name: "measurable",
              props: {
                height: [Number, String],
                maxHeight: [Number, String],
                maxWidth: [Number, String],
                minHeight: [Number, String],
                minWidth: [Number, String],
                width: [Number, String]
              },
              computed: {
                measurableStyles: function measurableStyles() {
                  var styles = {};
                  var height = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["convertToUnit"])(this.height);
                  var minHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["convertToUnit"])(this.minHeight);
                  var minWidth = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["convertToUnit"])(this.minWidth);
                  var maxHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["convertToUnit"])(this.maxHeight);
                  var maxWidth = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["convertToUnit"])(this.maxWidth);
                  var width = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["convertToUnit"])(this.width);
                  if (height)
                    styles.height = height;
                  if (minHeight)
                    styles.minHeight = minHeight;
                  if (minWidth)
                    styles.minWidth = minWidth;
                  if (maxHeight)
                    styles.maxHeight = maxHeight;
                  if (maxWidth)
                    styles.maxWidth = maxWidth;
                  if (width)
                    styles.width = width;
                  return styles;
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/menuable/index.ts": (
          /*!**************************************!*\
            !*** ./src/mixins/menuable/index.ts ***!
            \**************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _stackable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../stackable */
              "./src/mixins/stackable/index.ts"
            );
            var _positionable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../positionable */
              "./src/mixins/positionable/index.ts"
            );
            var _activatable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../activatable */
              "./src/mixins/activatable/index.ts"
            );
            var _detachable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../detachable */
              "./src/mixins/detachable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_stackable__WEBPACK_IMPORTED_MODULE_0__["default"], Object(_positionable__WEBPACK_IMPORTED_MODULE_1__["factory"])(["top", "right", "bottom", "left", "absolute"]), _activatable__WEBPACK_IMPORTED_MODULE_2__["default"], _detachable__WEBPACK_IMPORTED_MODULE_3__["default"]);
            __webpack_exports__["default"] = baseMixins.extend().extend({
              name: "menuable",
              props: {
                allowOverflow: Boolean,
                light: Boolean,
                dark: Boolean,
                maxWidth: {
                  type: [Number, String],
                  default: "auto"
                },
                minWidth: [Number, String],
                nudgeBottom: {
                  type: [Number, String],
                  default: 0
                },
                nudgeLeft: {
                  type: [Number, String],
                  default: 0
                },
                nudgeRight: {
                  type: [Number, String],
                  default: 0
                },
                nudgeTop: {
                  type: [Number, String],
                  default: 0
                },
                nudgeWidth: {
                  type: [Number, String],
                  default: 0
                },
                offsetOverflow: Boolean,
                positionX: {
                  type: Number,
                  default: null
                },
                positionY: {
                  type: Number,
                  default: null
                },
                zIndex: {
                  type: [Number, String],
                  default: null
                }
              },
              data: function data() {
                return {
                  activatorNode: [],
                  absoluteX: 0,
                  absoluteY: 0,
                  activatedBy: null,
                  activatorFixed: false,
                  dimensions: {
                    activator: {
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      width: 0,
                      height: 0,
                      offsetTop: 0,
                      scrollHeight: 0,
                      offsetLeft: 0
                    },
                    content: {
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      width: 0,
                      height: 0,
                      offsetTop: 0,
                      scrollHeight: 0
                    }
                  },
                  relativeYOffset: 0,
                  hasJustFocused: false,
                  hasWindow: false,
                  inputActivator: false,
                  isContentActive: false,
                  pageWidth: 0,
                  pageYOffset: 0,
                  stackClass: "v-menu__content--active",
                  stackMinZIndex: 6
                };
              },
              computed: {
                computedLeft: function computedLeft() {
                  var a = this.dimensions.activator;
                  var c = this.dimensions.content;
                  var activatorLeft = (this.attach !== false ? a.offsetLeft : a.left) || 0;
                  var minWidth = Math.max(a.width, c.width);
                  var left = 0;
                  left += activatorLeft;
                  if (this.left || this.$vuetify.rtl && !this.right)
                    left -= minWidth - a.width;
                  if (this.offsetX) {
                    var maxWidth = isNaN(Number(this.maxWidth)) ? a.width : Math.min(a.width, Number(this.maxWidth));
                    left += this.left ? -maxWidth : a.width;
                  }
                  if (this.nudgeLeft)
                    left -= parseInt(this.nudgeLeft);
                  if (this.nudgeRight)
                    left += parseInt(this.nudgeRight);
                  return left;
                },
                computedTop: function computedTop() {
                  var a = this.dimensions.activator;
                  var c = this.dimensions.content;
                  var top = 0;
                  if (this.top)
                    top += a.height - c.height;
                  if (this.attach !== false)
                    top += a.offsetTop;
                  else
                    top += a.top + this.pageYOffset;
                  if (this.offsetY)
                    top += this.top ? -a.height : a.height;
                  if (this.nudgeTop)
                    top -= parseInt(this.nudgeTop);
                  if (this.nudgeBottom)
                    top += parseInt(this.nudgeBottom);
                  return top;
                },
                hasActivator: function hasActivator() {
                  return !!this.$slots.activator || !!this.$scopedSlots.activator || !!this.activator || !!this.inputActivator;
                },
                absoluteYOffset: function absoluteYOffset() {
                  return this.pageYOffset - this.relativeYOffset;
                }
              },
              watch: {
                disabled: function disabled(val) {
                  val && this.callDeactivate();
                },
                isActive: function isActive(val) {
                  if (this.disabled)
                    return;
                  val ? this.callActivate() : this.callDeactivate();
                },
                positionX: "updateDimensions",
                positionY: "updateDimensions"
              },
              beforeMount: function beforeMount2() {
                this.hasWindow = typeof window !== "undefined";
                if (this.hasWindow) {
                  window.addEventListener("resize", this.updateDimensions, false);
                }
              },
              beforeDestroy: function beforeDestroy2() {
                if (this.hasWindow) {
                  window.removeEventListener("resize", this.updateDimensions, false);
                }
              },
              methods: {
                absolutePosition: function absolutePosition() {
                  return {
                    offsetTop: this.positionY || this.absoluteY,
                    offsetLeft: this.positionX || this.absoluteX,
                    scrollHeight: 0,
                    top: this.positionY || this.absoluteY,
                    bottom: this.positionY || this.absoluteY,
                    left: this.positionX || this.absoluteX,
                    right: this.positionX || this.absoluteX,
                    height: 0,
                    width: 0
                  };
                },
                activate: function activate() {
                },
                calcLeft: function calcLeft(menuWidth) {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.attach !== false ? this.computedLeft : this.calcXOverflow(this.computedLeft, menuWidth));
                },
                calcTop: function calcTop() {
                  return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.attach !== false ? this.computedTop : this.calcYOverflow(this.computedTop));
                },
                calcXOverflow: function calcXOverflow(left, menuWidth) {
                  var xOverflow = left + menuWidth - this.pageWidth + 12;
                  if ((!this.left || this.right) && xOverflow > 0) {
                    left = Math.max(left - xOverflow, 0);
                  } else {
                    left = Math.max(left, 12);
                  }
                  return left + this.getOffsetLeft();
                },
                calcYOverflow: function calcYOverflow(top) {
                  var documentHeight = this.getInnerHeight();
                  var toTop = this.absoluteYOffset + documentHeight;
                  var activator = this.dimensions.activator;
                  var contentHeight = this.dimensions.content.height;
                  var totalHeight = top + contentHeight;
                  var isOverflowing = toTop < totalHeight;
                  if (isOverflowing && this.offsetOverflow && // If we don't have enough room to offset
                  // the overflow, don't offset
                  activator.top > contentHeight) {
                    top = this.pageYOffset + (activator.top - contentHeight);
                  } else if (isOverflowing && !this.allowOverflow) {
                    top = toTop - contentHeight - 12;
                  } else if (top < this.absoluteYOffset && !this.allowOverflow) {
                    top = this.absoluteYOffset + 12;
                  }
                  return top < 12 ? 12 : top;
                },
                callActivate: function callActivate() {
                  if (!this.hasWindow)
                    return;
                  this.activate();
                },
                callDeactivate: function callDeactivate() {
                  this.isContentActive = false;
                  this.deactivate();
                },
                checkForPageYOffset: function checkForPageYOffset() {
                  if (this.hasWindow) {
                    this.pageYOffset = this.activatorFixed ? 0 : this.getOffsetTop();
                  }
                },
                checkActivatorFixed: function checkActivatorFixed() {
                  if (this.attach !== false) {
                    this.activatorFixed = false;
                    return;
                  }
                  var el = this.getActivator();
                  while (el) {
                    if (window.getComputedStyle(el).position === "fixed") {
                      this.activatorFixed = true;
                      return;
                    }
                    el = el.offsetParent;
                  }
                  this.activatorFixed = false;
                },
                deactivate: function deactivate() {
                },
                genActivatorListeners: function genActivatorListeners() {
                  var _this2 = this;
                  var listeners = _activatable__WEBPACK_IMPORTED_MODULE_2__["default"].options.methods.genActivatorListeners.call(this);
                  var onClick = listeners.click;
                  if (onClick) {
                    listeners.click = function(e) {
                      if (_this2.openOnClick) {
                        onClick && onClick(e);
                      }
                      _this2.absoluteX = e.clientX;
                      _this2.absoluteY = e.clientY;
                    };
                  }
                  return listeners;
                },
                getInnerHeight: function getInnerHeight() {
                  if (!this.hasWindow)
                    return 0;
                  return window.innerHeight || document.documentElement.clientHeight;
                },
                getOffsetLeft: function getOffsetLeft() {
                  if (!this.hasWindow)
                    return 0;
                  return window.pageXOffset || document.documentElement.scrollLeft;
                },
                getOffsetTop: function getOffsetTop() {
                  if (!this.hasWindow)
                    return 0;
                  return window.pageYOffset || document.documentElement.scrollTop;
                },
                getRoundedBoundedClientRect: function getRoundedBoundedClientRect(el) {
                  var rect = el.getBoundingClientRect();
                  return {
                    top: Math.round(rect.top),
                    left: Math.round(rect.left),
                    bottom: Math.round(rect.bottom),
                    right: Math.round(rect.right),
                    width: Math.round(rect.width),
                    height: Math.round(rect.height)
                  };
                },
                measure: function measure(el) {
                  if (!el || !this.hasWindow)
                    return null;
                  var rect = this.getRoundedBoundedClientRect(el);
                  if (this.attach !== false) {
                    var style2 = window.getComputedStyle(el);
                    rect.left = parseInt(style2.marginLeft);
                    rect.top = parseInt(style2.marginTop);
                  }
                  return rect;
                },
                sneakPeek: function sneakPeek(cb) {
                  var _this2 = this;
                  requestAnimationFrame(function() {
                    var el = _this2.$refs.content;
                    if (!el || el.style.display !== "none") {
                      cb();
                      return;
                    }
                    el.style.display = "inline-block";
                    cb();
                    el.style.display = "none";
                  });
                },
                startTransition: function startTransition() {
                  var _this2 = this;
                  return new Promise(function(resolve2) {
                    return requestAnimationFrame(function() {
                      _this2.isContentActive = _this2.hasJustFocused = _this2.isActive;
                      resolve2();
                    });
                  });
                },
                updateDimensions: function updateDimensions() {
                  var _this2 = this;
                  this.hasWindow = typeof window !== "undefined";
                  this.checkActivatorFixed();
                  this.checkForPageYOffset();
                  this.pageWidth = document.documentElement.clientWidth;
                  var dimensions = {
                    activator: __assign2({}, this.dimensions.activator),
                    content: __assign2({}, this.dimensions.content)
                  };
                  if (!this.hasActivator || this.absolute) {
                    dimensions.activator = this.absolutePosition();
                  } else {
                    var activator = this.getActivator();
                    if (!activator)
                      return;
                    dimensions.activator = this.measure(activator);
                    dimensions.activator.offsetLeft = activator.offsetLeft;
                    if (this.attach !== false) {
                      dimensions.activator.offsetTop = activator.offsetTop;
                    } else {
                      dimensions.activator.offsetTop = 0;
                    }
                  }
                  this.sneakPeek(function() {
                    if (_this2.$refs.content) {
                      if (_this2.$refs.content.offsetParent) {
                        var offsetRect = _this2.getRoundedBoundedClientRect(_this2.$refs.content.offsetParent);
                        _this2.relativeYOffset = window.pageYOffset + offsetRect.top;
                        dimensions.activator.top -= _this2.relativeYOffset;
                        dimensions.activator.left -= window.pageXOffset + offsetRect.left;
                      }
                      dimensions.content = _this2.measure(_this2.$refs.content);
                    }
                    _this2.dimensions = dimensions;
                  });
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/mobile/index.ts": (
          /*!************************************!*\
            !*** ./src/mixins/mobile/index.ts ***!
            \************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _util_console__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
              name: "mobile",
              props: {
                mobileBreakpoint: {
                  type: [Number, String],
                  default: function _default() {
                    return this.$vuetify ? this.$vuetify.breakpoint.mobileBreakpoint : void 0;
                  },
                  validator: function validator2(v) {
                    return !isNaN(Number(v)) || ["xs", "sm", "md", "lg", "xl"].includes(String(v));
                  }
                }
              },
              computed: {
                isMobile: function isMobile() {
                  var _a2 = this.$vuetify.breakpoint, mobile = _a2.mobile, width = _a2.width, name = _a2.name, mobileBreakpoint = _a2.mobileBreakpoint;
                  if (mobileBreakpoint === this.mobileBreakpoint)
                    return mobile;
                  var mobileWidth = parseInt(this.mobileBreakpoint, 10);
                  var isNumber2 = !isNaN(mobileWidth);
                  return isNumber2 ? width < mobileWidth : name === this.mobileBreakpoint;
                }
              },
              created: function created2() {
                if (this.$attrs.hasOwnProperty("mobile-break-point")) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_0__["deprecate"])("mobile-break-point", "mobile-breakpoint", this);
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/mouse/index.ts": (
          /*!***********************************!*\
            !*** ./src/mixins/mouse/index.ts ***!
            \***********************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "mouse",
              methods: {
                getDefaultMouseEventHandlers: function getDefaultMouseEventHandlers(suffix, getData2, eventFirst) {
                  var _a2;
                  if (eventFirst === void 0) {
                    eventFirst = false;
                  }
                  var listeners = Object.keys(this.$listeners).filter(function(key) {
                    return key.endsWith(suffix);
                  }).reduce(function(acc, key) {
                    acc[key] = {
                      event: key.slice(0, -suffix.length)
                    };
                    return acc;
                  }, {});
                  return this.getMouseEventHandlers(__assign2(__assign2({}, listeners), (_a2 = {}, _a2["contextmenu" + suffix] = {
                    event: "contextmenu",
                    prevent: true,
                    result: false
                  }, _a2)), getData2, eventFirst);
                },
                getMouseEventHandlers: function getMouseEventHandlers(events2, getData2, eventFirst) {
                  var _this2 = this;
                  if (eventFirst === void 0) {
                    eventFirst = false;
                  }
                  var on2 = {};
                  var _loop_1 = function _loop_12(event2) {
                    var eventOptions = events2[event2];
                    if (!this_1.$listeners[event2])
                      return "continue";
                    var prefix = eventOptions.passive ? "&" : (eventOptions.once ? "~" : "") + (eventOptions.capture ? "!" : "");
                    var key = prefix + eventOptions.event;
                    var handler = function handler2(e) {
                      var _a2, _b2;
                      var mouseEvent = e;
                      if (eventOptions.button === void 0 || mouseEvent.buttons > 0 && mouseEvent.button === eventOptions.button) {
                        if (eventOptions.prevent) {
                          e.preventDefault();
                        }
                        if (eventOptions.stop) {
                          e.stopPropagation();
                        }
                        if (e && "touches" in e) {
                          var classSeparator_1 = " ";
                          var eventTargetClasses_1 = (_a2 = e.currentTarget) === null || _a2 === void 0 ? void 0 : _a2.className.split(classSeparator_1);
                          var currentTargets = document.elementsFromPoint(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
                          var currentTarget = currentTargets.find(function(t3) {
                            return t3.className.split(classSeparator_1).some(function(c) {
                              return eventTargetClasses_1.includes(c);
                            });
                          });
                          if (currentTarget && !((_b2 = e.target) === null || _b2 === void 0 ? void 0 : _b2.isSameNode(currentTarget))) {
                            currentTarget.dispatchEvent(new TouchEvent(e.type, {
                              changedTouches: e.changedTouches,
                              targetTouches: e.targetTouches,
                              touches: e.touches
                            }));
                            return;
                          }
                        }
                        if (eventFirst) {
                          _this2.$emit(event2, e, getData2(e));
                        } else {
                          _this2.$emit(event2, getData2(e), e);
                        }
                      }
                      return eventOptions.result;
                    };
                    if (key in on2) {
                      if (Array.isArray(on2[key])) {
                        on2[key].push(handler);
                      } else {
                        on2[key] = [on2[key], handler];
                      }
                    } else {
                      on2[key] = handler;
                    }
                  };
                  var this_1 = this;
                  for (var event in events2) {
                    _loop_1(event);
                  }
                  return on2;
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/overlayable/index.ts": (
          /*!*****************************************!*\
            !*** ./src/mixins/overlayable/index.ts ***!
            \*****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _components_VOverlay__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../components/VOverlay */
              "./src/components/VOverlay/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_2___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend().extend({
              name: "overlayable",
              props: {
                hideOverlay: Boolean,
                overlayColor: String,
                overlayOpacity: [Number, String]
              },
              data: function data() {
                return {
                  animationFrame: 0,
                  overlay: null
                };
              },
              watch: {
                hideOverlay: function hideOverlay(value) {
                  if (!this.isActive)
                    return;
                  if (value)
                    this.removeOverlay();
                  else
                    this.genOverlay();
                }
              },
              beforeDestroy: function beforeDestroy2() {
                this.removeOverlay();
              },
              methods: {
                createOverlay: function createOverlay() {
                  var overlay = new _components_VOverlay__WEBPACK_IMPORTED_MODULE_0__["default"]({
                    propsData: {
                      absolute: this.absolute,
                      value: false,
                      color: this.overlayColor,
                      opacity: this.overlayOpacity
                    }
                  });
                  overlay.$mount();
                  var parent2 = this.absolute ? this.$el.parentNode : document.querySelector("[data-app]");
                  parent2 && parent2.insertBefore(overlay.$el, parent2.firstChild);
                  this.overlay = overlay;
                },
                genOverlay: function genOverlay() {
                  var _this2 = this;
                  this.hideScroll();
                  if (this.hideOverlay)
                    return;
                  if (!this.overlay)
                    this.createOverlay();
                  this.animationFrame = requestAnimationFrame(function() {
                    if (!_this2.overlay)
                      return;
                    if (_this2.activeZIndex !== void 0) {
                      _this2.overlay.zIndex = String(_this2.activeZIndex - 1);
                    } else if (_this2.$el) {
                      _this2.overlay.zIndex = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getZIndex"])(_this2.$el);
                    }
                    _this2.overlay.value = true;
                  });
                  return true;
                },
                /** removeOverlay(false) will not restore the scollbar afterwards */
                removeOverlay: function removeOverlay(showScroll) {
                  var _this2 = this;
                  if (showScroll === void 0) {
                    showScroll = true;
                  }
                  if (this.overlay) {
                    Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["addOnceEventListener"])(this.overlay.$el, "transitionend", function() {
                      if (!_this2.overlay || !_this2.overlay.$el || !_this2.overlay.$el.parentNode || _this2.overlay.value || _this2.isActive)
                        return;
                      _this2.overlay.$el.parentNode.removeChild(_this2.overlay.$el);
                      _this2.overlay.$destroy();
                      _this2.overlay = null;
                    });
                    cancelAnimationFrame(this.animationFrame);
                    this.overlay.value = false;
                  }
                  showScroll && this.showScroll();
                },
                scrollListener: function scrollListener(e) {
                  if ("key" in e) {
                    if (["INPUT", "TEXTAREA", "SELECT"].includes(e.target.tagName) || // https://github.com/vuetifyjs/vuetify/issues/4715
                    e.target.isContentEditable)
                      return;
                    var up = [_util_helpers__WEBPACK_IMPORTED_MODULE_1__["keyCodes"].up, _util_helpers__WEBPACK_IMPORTED_MODULE_1__["keyCodes"].pageup];
                    var down = [_util_helpers__WEBPACK_IMPORTED_MODULE_1__["keyCodes"].down, _util_helpers__WEBPACK_IMPORTED_MODULE_1__["keyCodes"].pagedown];
                    if (up.includes(e.keyCode)) {
                      e.deltaY = -1;
                    } else if (down.includes(e.keyCode)) {
                      e.deltaY = 1;
                    } else {
                      return;
                    }
                  }
                  if (e.target === this.overlay || e.type !== "keydown" && e.target === document.body || this.checkPath(e))
                    e.preventDefault();
                },
                hasScrollbar: function hasScrollbar(el) {
                  if (!el || el.nodeType !== Node.ELEMENT_NODE)
                    return false;
                  var style2 = window.getComputedStyle(el);
                  return (["auto", "scroll"].includes(style2.overflowY) || el.tagName === "SELECT") && el.scrollHeight > el.clientHeight || ["auto", "scroll"].includes(style2.overflowX) && el.scrollWidth > el.clientWidth;
                },
                shouldScroll: function shouldScroll(el, e) {
                  if (el.hasAttribute("data-app"))
                    return false;
                  var dir = e.shiftKey || e.deltaX ? "x" : "y";
                  var delta = dir === "y" ? e.deltaY : e.deltaX || e.deltaY;
                  var alreadyAtStart;
                  var alreadyAtEnd;
                  if (dir === "y") {
                    alreadyAtStart = el.scrollTop === 0;
                    alreadyAtEnd = el.scrollTop + el.clientHeight === el.scrollHeight;
                  } else {
                    alreadyAtStart = el.scrollLeft === 0;
                    alreadyAtEnd = el.scrollLeft + el.clientWidth === el.scrollWidth;
                  }
                  var scrollingUp = delta < 0;
                  var scrollingDown = delta > 0;
                  if (!alreadyAtStart && scrollingUp)
                    return true;
                  if (!alreadyAtEnd && scrollingDown)
                    return true;
                  if ((alreadyAtStart || alreadyAtEnd) && el.parentNode) {
                    return this.shouldScroll(el.parentNode, e);
                  }
                  return false;
                },
                isInside: function isInside(el, parent2) {
                  if (el === parent2) {
                    return true;
                  } else if (el === null || el === document.body) {
                    return false;
                  } else {
                    return this.isInside(el.parentNode, parent2);
                  }
                },
                checkPath: function checkPath(e) {
                  var path = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["composedPath"])(e);
                  if (e.type === "keydown" && path[0] === document.body) {
                    var dialog = this.$refs.dialog;
                    var selected = window.getSelection().anchorNode;
                    if (dialog && this.hasScrollbar(dialog) && this.isInside(selected, dialog)) {
                      return !this.shouldScroll(dialog, e);
                    }
                    return true;
                  }
                  for (var index2 = 0; index2 < path.length; index2++) {
                    var el = path[index2];
                    if (el === document)
                      return true;
                    if (el === document.documentElement)
                      return true;
                    if (el === this.$refs.content)
                      return true;
                    if (this.hasScrollbar(el))
                      return !this.shouldScroll(el, e);
                  }
                  return true;
                },
                hideScroll: function hideScroll() {
                  if (this.$vuetify.breakpoint.smAndDown) {
                    document.documentElement.classList.add("overflow-y-hidden");
                  } else {
                    Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["addPassiveEventListener"])(window, "wheel", this.scrollListener, {
                      passive: false
                    });
                    window.addEventListener("keydown", this.scrollListener);
                  }
                },
                showScroll: function showScroll() {
                  document.documentElement.classList.remove("overflow-y-hidden");
                  window.removeEventListener("wheel", this.scrollListener);
                  window.removeEventListener("keydown", this.scrollListener);
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/picker-button/index.ts": (
          /*!*******************************************!*\
            !*** ./src/mixins/picker-button/index.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_colorable__WEBPACK_IMPORTED_MODULE_0__["default"]).extend({
              methods: {
                genPickerButton: function genPickerButton(prop, value, content, readonly, staticClass) {
                  var _this2 = this;
                  if (readonly === void 0) {
                    readonly = false;
                  }
                  if (staticClass === void 0) {
                    staticClass = "";
                  }
                  var active = this[prop] === value;
                  var click2 = function click3(event) {
                    event.stopPropagation();
                    _this2.$emit("update:" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["kebabCase"])(prop), value);
                  };
                  return this.$createElement("div", {
                    staticClass: ("v-picker__title__btn " + staticClass).trim(),
                    class: {
                      "v-picker__title__btn--active": active,
                      "v-picker__title__btn--readonly": readonly
                    },
                    on: active || readonly ? void 0 : {
                      click: click2
                    }
                  }, Array.isArray(content) ? content : [content]);
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/picker/index.ts": (
          /*!************************************!*\
            !*** ./src/mixins/picker/index.ts ***!
            \************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _components_VPicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../components/VPicker */
              "./src/components/VPicker/index.ts"
            );
            var _colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _mixins_elevatable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../mixins/elevatable */
              "./src/mixins/elevatable/index.ts"
            );
            var _themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(
              _colorable__WEBPACK_IMPORTED_MODULE_1__["default"],
              _mixins_elevatable__WEBPACK_IMPORTED_MODULE_2__["default"],
              _themeable__WEBPACK_IMPORTED_MODULE_3__["default"]
              /* @vue/component */
            ).extend({
              name: "picker",
              props: {
                flat: Boolean,
                fullWidth: Boolean,
                headerColor: String,
                landscape: Boolean,
                noTitle: Boolean,
                width: {
                  type: [Number, String],
                  default: 290
                }
              },
              methods: {
                genPickerTitle: function genPickerTitle() {
                  return null;
                },
                genPickerBody: function genPickerBody() {
                  return null;
                },
                genPickerActionsSlot: function genPickerActionsSlot() {
                  return this.$scopedSlots.default ? this.$scopedSlots.default({
                    save: this.save,
                    cancel: this.cancel
                  }) : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getSlot"])(this);
                },
                genPicker: function genPicker(staticClass) {
                  var children = [];
                  if (!this.noTitle) {
                    var title = this.genPickerTitle();
                    title && children.push(title);
                  }
                  var body = this.genPickerBody();
                  body && children.push(body);
                  children.push(this.$createElement("template", {
                    slot: "actions"
                  }, [this.genPickerActionsSlot()]));
                  return this.$createElement(_components_VPicker__WEBPACK_IMPORTED_MODULE_0__["default"], {
                    staticClass,
                    props: {
                      color: this.headerColor || this.color,
                      dark: this.dark,
                      elevation: this.elevation,
                      flat: this.flat,
                      fullWidth: this.fullWidth,
                      landscape: this.landscape,
                      light: this.light,
                      width: this.width,
                      noTitle: this.noTitle
                    }
                  }, children);
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/positionable/index.ts": (
          /*!******************************************!*\
            !*** ./src/mixins/positionable/index.ts ***!
            \******************************************/
          /*! exports provided: factory, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "factory", function() {
              return factory;
            });
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var availableProps = {
              absolute: Boolean,
              bottom: Boolean,
              fixed: Boolean,
              left: Boolean,
              right: Boolean,
              top: Boolean
            };
            function factory(selected) {
              if (selected === void 0) {
                selected = [];
              }
              return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
                name: "positionable",
                props: selected.length ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["filterObjectOnKeys"])(availableProps, selected) : availableProps
              });
            }
            __webpack_exports__["default"] = factory();
          }
        ),
        /***/
        "./src/mixins/proxyable/index.ts": (
          /*!***************************************!*\
            !*** ./src/mixins/proxyable/index.ts ***!
            \***************************************/
          /*! exports provided: factory, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "factory", function() {
              return factory;
            });
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            function factory(prop, event) {
              var _a2, _b2;
              if (prop === void 0) {
                prop = "value";
              }
              if (event === void 0) {
                event = "change";
              }
              return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
                name: "proxyable",
                model: {
                  prop,
                  event
                },
                props: (_a2 = {}, _a2[prop] = {
                  required: false
                }, _a2),
                data: function data() {
                  return {
                    internalLazyValue: this[prop]
                  };
                },
                computed: {
                  internalValue: {
                    get: function get5() {
                      return this.internalLazyValue;
                    },
                    set: function set2(val) {
                      if (val === this.internalLazyValue)
                        return;
                      this.internalLazyValue = val;
                      this.$emit(event, val);
                    }
                  }
                },
                watch: (_b2 = {}, _b2[prop] = function(val) {
                  this.internalLazyValue = val;
                }, _b2)
              });
            }
            var Proxyable = factory();
            __webpack_exports__["default"] = Proxyable;
          }
        ),
        /***/
        "./src/mixins/registrable/index.ts": (
          /*!*****************************************!*\
            !*** ./src/mixins/registrable/index.ts ***!
            \*****************************************/
          /*! exports provided: inject, provide */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "inject", function() {
              return inject2;
            });
            __webpack_require__.d(__webpack_exports__, "provide", function() {
              return provide;
            });
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            function generateWarning(child, parent2) {
              return function() {
                return Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleWarn"])("The " + child + " component must be used inside a " + parent2);
              };
            }
            function inject2(namespace, child, parent2) {
              var _a2;
              var defaultImpl = child && parent2 ? {
                register: generateWarning(child, parent2),
                unregister: generateWarning(child, parent2)
              } : null;
              return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
                name: "registrable-inject",
                inject: (_a2 = {}, _a2[namespace] = {
                  default: defaultImpl
                }, _a2)
              });
            }
            function provide(namespace, self2) {
              if (self2 === void 0) {
                self2 = false;
              }
              return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
                name: "registrable-provide",
                provide: function provide2() {
                  var _a2;
                  return _a2 = {}, _a2[namespace] = self2 ? this : {
                    register: this.register,
                    unregister: this.unregister
                  }, _a2;
                }
              });
            }
          }
        ),
        /***/
        "./src/mixins/returnable/index.ts": (
          /*!****************************************!*\
            !*** ./src/mixins/returnable/index.ts ***!
            \****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "returnable",
              props: {
                returnValue: null
              },
              data: function data() {
                return {
                  isActive: false,
                  originalValue: null
                };
              },
              watch: {
                isActive: function isActive(val) {
                  if (val) {
                    this.originalValue = this.returnValue;
                  } else {
                    this.$emit("update:return-value", this.originalValue);
                  }
                }
              },
              methods: {
                save: function save2(value) {
                  var _this2 = this;
                  this.originalValue = value;
                  setTimeout(function() {
                    _this2.isActive = false;
                  });
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/rippleable/index.ts": (
          /*!****************************************!*\
            !*** ./src/mixins/rippleable/index.ts ***!
            \****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_1___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
              name: "rippleable",
              directives: {
                ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_0__["default"]
              },
              props: {
                ripple: {
                  type: [Boolean, Object],
                  default: true
                }
              },
              methods: {
                genRipple: function genRipple(data) {
                  if (data === void 0) {
                    data = {};
                  }
                  if (!this.ripple)
                    return null;
                  data.staticClass = "v-input--selection-controls__ripple";
                  data.directives = data.directives || [];
                  data.directives.push({
                    name: "ripple",
                    value: {
                      center: true
                    }
                  });
                  return this.$createElement("div", data);
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/roundable/index.ts": (
          /*!***************************************!*\
            !*** ./src/mixins/roundable/index.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var __values2 = function(o) {
              var s2 = typeof Symbol === "function" && Symbol.iterator, m = s2 && o[s2], i2 = 0;
              if (m)
                return m.call(o);
              if (o && typeof o.length === "number")
                return {
                  next: function next() {
                    if (o && i2 >= o.length)
                      o = void 0;
                    return {
                      value: o && o[i2++],
                      done: !o
                    };
                  }
                };
              throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "roundable",
              props: {
                rounded: [Boolean, String],
                tile: Boolean
              },
              computed: {
                roundedClasses: function roundedClasses() {
                  var e_1, _a2, _b2;
                  var composite = [];
                  var rounded = typeof this.rounded === "string" ? String(this.rounded) : this.rounded === true;
                  if (this.tile) {
                    composite.push("rounded-0");
                  } else if (typeof rounded === "string") {
                    var values2 = rounded.split(" ");
                    try {
                      for (var values_12 = __values2(values2), values_1_1 = values_12.next(); !values_1_1.done; values_1_1 = values_12.next()) {
                        var value = values_1_1.value;
                        composite.push("rounded-" + value);
                      }
                    } catch (e_1_1) {
                      e_1 = {
                        error: e_1_1
                      };
                    } finally {
                      try {
                        if (values_1_1 && !values_1_1.done && (_a2 = values_12.return))
                          _a2.call(values_12);
                      } finally {
                        if (e_1)
                          throw e_1.error;
                      }
                    }
                  } else if (rounded) {
                    composite.push("rounded");
                  }
                  return composite.length > 0 ? (_b2 = {}, _b2[composite.join(" ")] = true, _b2) : {};
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/routable/index.ts": (
          /*!**************************************!*\
            !*** ./src/mixins/routable/index.ts ***!
            \**************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var _directives_ripple__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../directives/ripple */
              "./src/directives/ripple/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "routable",
              directives: {
                Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_1__["default"]
              },
              props: {
                activeClass: String,
                append: Boolean,
                disabled: Boolean,
                exact: {
                  type: Boolean,
                  default: void 0
                },
                exactPath: Boolean,
                exactActiveClass: String,
                link: Boolean,
                href: [String, Object],
                to: [String, Object],
                nuxt: Boolean,
                replace: Boolean,
                ripple: {
                  type: [Boolean, Object],
                  default: null
                },
                tag: String,
                target: String
              },
              data: function data() {
                return {
                  isActive: false,
                  proxyClass: ""
                };
              },
              computed: {
                classes: function classes() {
                  var classes2 = {};
                  if (this.to)
                    return classes2;
                  if (this.activeClass)
                    classes2[this.activeClass] = this.isActive;
                  if (this.proxyClass)
                    classes2[this.proxyClass] = this.isActive;
                  return classes2;
                },
                computedRipple: function computedRipple() {
                  var _a2;
                  return (_a2 = this.ripple) !== null && _a2 !== void 0 ? _a2 : !this.disabled && this.isClickable;
                },
                isClickable: function isClickable() {
                  if (this.disabled)
                    return false;
                  return Boolean(this.isLink || this.$listeners.click || this.$listeners["!click"] || this.$attrs.tabindex);
                },
                isLink: function isLink() {
                  return this.to || this.href || this.link;
                },
                styles: function styles() {
                  return {};
                }
              },
              watch: {
                $route: "onRouteChange"
              },
              mounted: function mounted3() {
                this.onRouteChange();
              },
              methods: {
                generateRouteLink: function generateRouteLink() {
                  var _a2;
                  var exact = this.exact;
                  var tag;
                  var data = (_a2 = {
                    attrs: {
                      tabindex: "tabindex" in this.$attrs ? this.$attrs.tabindex : void 0
                    },
                    class: this.classes,
                    style: this.styles,
                    props: {},
                    directives: [{
                      name: "ripple",
                      value: this.computedRipple
                    }]
                  }, _a2[this.to ? "nativeOn" : "on"] = __assign2(__assign2({}, this.$listeners), "click" in this ? {
                    click: this.click
                  } : void 0), _a2.ref = "link", _a2);
                  if (typeof this.exact === "undefined") {
                    exact = this.to === "/" || this.to === Object(this.to) && this.to.path === "/";
                  }
                  if (this.to) {
                    var activeClass = this.activeClass;
                    var exactActiveClass = this.exactActiveClass || activeClass;
                    if (this.proxyClass) {
                      activeClass = (activeClass + " " + this.proxyClass).trim();
                      exactActiveClass = (exactActiveClass + " " + this.proxyClass).trim();
                    }
                    tag = this.nuxt ? "nuxt-link" : "router-link";
                    Object.assign(data.props, {
                      to: this.to,
                      exact,
                      exactPath: this.exactPath,
                      activeClass,
                      exactActiveClass,
                      append: this.append,
                      replace: this.replace
                    });
                  } else {
                    tag = this.href && "a" || this.tag || "div";
                    if (tag === "a" && this.href)
                      data.attrs.href = this.href;
                  }
                  if (this.target)
                    data.attrs.target = this.target;
                  return {
                    tag,
                    data
                  };
                },
                onRouteChange: function onRouteChange() {
                  var _this2 = this;
                  if (!this.to || !this.$refs.link || !this.$route)
                    return;
                  var activeClass = ((this.activeClass || "") + " " + (this.proxyClass || "")).trim();
                  var exactActiveClass = ((this.exactActiveClass || "") + " " + (this.proxyClass || "")).trim() || activeClass;
                  var path = "_vnode.data.class." + (this.exact ? exactActiveClass : activeClass);
                  this.$nextTick(function() {
                    if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["getObjectValueByPath"])(_this2.$refs.link, path) === _this2.isActive) {
                      _this2.toggle();
                    }
                  });
                },
                toggle: function toggle() {
                  this.isActive = !this.isActive;
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/scrollable/index.ts": (
          /*!****************************************!*\
            !*** ./src/mixins/scrollable/index.ts ***!
            \****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _directives__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../directives */
              "./src/directives/index.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_2___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_2___default.a.extend({
              name: "scrollable",
              directives: {
                Scroll: _directives__WEBPACK_IMPORTED_MODULE_0__["Scroll"]
              },
              props: {
                scrollTarget: String,
                scrollThreshold: [String, Number]
              },
              data: function data() {
                return {
                  currentScroll: 0,
                  currentThreshold: 0,
                  isActive: false,
                  isScrollingUp: false,
                  previousScroll: 0,
                  savedScroll: 0,
                  target: null
                };
              },
              computed: {
                /**
                 * A computed property that returns
                 * whether scrolling features are
                 * enabled or disabled
                 */
                canScroll: function canScroll() {
                  return typeof window !== "undefined";
                },
                /**
                 * The threshold that must be met before
                 * thresholdMet function is invoked
                 */
                computedScrollThreshold: function computedScrollThreshold() {
                  return this.scrollThreshold ? Number(this.scrollThreshold) : 300;
                }
              },
              watch: {
                isScrollingUp: function isScrollingUp() {
                  this.savedScroll = this.savedScroll || this.currentScroll;
                },
                isActive: function isActive() {
                  this.savedScroll = 0;
                }
              },
              mounted: function mounted3() {
                if (this.scrollTarget) {
                  this.target = document.querySelector(this.scrollTarget);
                  if (!this.target) {
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleWarn"])("Unable to locate element with identifier " + this.scrollTarget, this);
                  }
                }
              },
              methods: {
                onScroll: function onScroll() {
                  var _this2 = this;
                  if (!this.canScroll)
                    return;
                  this.previousScroll = this.currentScroll;
                  this.currentScroll = this.target ? this.target.scrollTop : window.pageYOffset;
                  this.isScrollingUp = this.currentScroll < this.previousScroll;
                  this.currentThreshold = Math.abs(this.currentScroll - this.computedScrollThreshold);
                  this.$nextTick(function() {
                    if (Math.abs(_this2.currentScroll - _this2.savedScroll) > _this2.computedScrollThreshold)
                      _this2.thresholdMet();
                  });
                },
                /**
                 * The method invoked when
                 * scrolling in any direction
                 * has exceeded the threshold
                 */
                thresholdMet: function thresholdMet() {
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/selectable/index.ts": (
          /*!****************************************!*\
            !*** ./src/mixins/selectable/index.ts ***!
            \****************************************/
          /*! exports provided: prevent, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "prevent", function() {
              return prevent;
            });
            var _components_VInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../components/VInput */
              "./src/components/VInput/index.ts"
            );
            var _rippleable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../rippleable */
              "./src/mixins/rippleable/index.ts"
            );
            var _comparable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../comparable */
              "./src/mixins/comparable/index.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            function prevent(e) {
              e.preventDefault();
            }
            __webpack_exports__["default"] = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_components_VInput__WEBPACK_IMPORTED_MODULE_0__["default"], _rippleable__WEBPACK_IMPORTED_MODULE_1__["default"], _comparable__WEBPACK_IMPORTED_MODULE_2__["default"]).extend({
              name: "selectable",
              model: {
                prop: "inputValue",
                event: "change"
              },
              props: {
                id: String,
                inputValue: null,
                falseValue: null,
                trueValue: null,
                multiple: {
                  type: Boolean,
                  default: null
                },
                label: String
              },
              data: function data() {
                return {
                  hasColor: this.inputValue,
                  lazyValue: this.inputValue
                };
              },
              computed: {
                computedColor: function computedColor() {
                  if (!this.isActive)
                    return void 0;
                  if (this.color)
                    return this.color;
                  if (this.isDark && !this.appIsDark)
                    return "white";
                  return "primary";
                },
                isMultiple: function isMultiple() {
                  return this.multiple === true || this.multiple === null && Array.isArray(this.internalValue);
                },
                isActive: function isActive() {
                  var _this2 = this;
                  var value = this.value;
                  var input2 = this.internalValue;
                  if (this.isMultiple) {
                    if (!Array.isArray(input2))
                      return false;
                    return input2.some(function(item) {
                      return _this2.valueComparator(item, value);
                    });
                  }
                  if (this.trueValue === void 0 || this.falseValue === void 0) {
                    return value ? this.valueComparator(value, input2) : Boolean(input2);
                  }
                  return this.valueComparator(input2, this.trueValue);
                },
                isDirty: function isDirty() {
                  return this.isActive;
                },
                rippleState: function rippleState() {
                  return !this.isDisabled && !this.validationState ? void 0 : this.validationState;
                }
              },
              watch: {
                inputValue: function inputValue(val) {
                  this.lazyValue = val;
                  this.hasColor = val;
                }
              },
              methods: {
                genLabel: function genLabel() {
                  var label = _components_VInput__WEBPACK_IMPORTED_MODULE_0__["default"].options.methods.genLabel.call(this);
                  if (!label)
                    return label;
                  label.data.on = {
                    // Label shouldn't cause the input to focus
                    click: prevent
                  };
                  return label;
                },
                genInput: function genInput(type, attrs2) {
                  return this.$createElement("input", {
                    attrs: Object.assign({
                      "aria-checked": this.isActive.toString(),
                      disabled: this.isDisabled,
                      id: this.computedId,
                      role: type,
                      type
                    }, attrs2),
                    domProps: {
                      value: this.value,
                      checked: this.isActive
                    },
                    on: {
                      blur: this.onBlur,
                      change: this.onChange,
                      focus: this.onFocus,
                      keydown: this.onKeydown,
                      click: prevent
                    },
                    ref: "input"
                  });
                },
                onClick: function onClick(e) {
                  this.onChange();
                  this.$emit("click", e);
                },
                onChange: function onChange() {
                  var _this2 = this;
                  if (!this.isInteractive)
                    return;
                  var value = this.value;
                  var input2 = this.internalValue;
                  if (this.isMultiple) {
                    if (!Array.isArray(input2)) {
                      input2 = [];
                    }
                    var length = input2.length;
                    input2 = input2.filter(function(item) {
                      return !_this2.valueComparator(item, value);
                    });
                    if (input2.length === length) {
                      input2.push(value);
                    }
                  } else if (this.trueValue !== void 0 && this.falseValue !== void 0) {
                    input2 = this.valueComparator(input2, this.trueValue) ? this.falseValue : this.trueValue;
                  } else if (value) {
                    input2 = this.valueComparator(input2, value) ? null : value;
                  } else {
                    input2 = !input2;
                  }
                  this.validate(true, input2);
                  this.internalValue = input2;
                  this.hasColor = input2;
                },
                onFocus: function onFocus(e) {
                  this.isFocused = true;
                  this.$emit("focus", e);
                },
                onBlur: function onBlur(e) {
                  this.isFocused = false;
                  this.$emit("blur", e);
                },
                /** @abstract */
                onKeydown: function onKeydown(e) {
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/sizeable/index.ts": (
          /*!**************************************!*\
            !*** ./src/mixins/sizeable/index.ts ***!
            \**************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "sizeable",
              props: {
                large: Boolean,
                small: Boolean,
                xLarge: Boolean,
                xSmall: Boolean
              },
              computed: {
                medium: function medium() {
                  return Boolean(!this.xSmall && !this.small && !this.large && !this.xLarge);
                },
                sizeableClasses: function sizeableClasses() {
                  return {
                    "v-size--x-small": this.xSmall,
                    "v-size--small": this.small,
                    "v-size--default": this.medium,
                    "v-size--large": this.large,
                    "v-size--x-large": this.xLarge
                  };
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/ssr-bootable/index.ts": (
          /*!******************************************!*\
            !*** ./src/mixins/ssr-bootable/index.ts ***!
            \******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "ssr-bootable",
              data: function data() {
                return {
                  isBooted: false
                };
              },
              mounted: function mounted3() {
                var _this2 = this;
                window.requestAnimationFrame(function() {
                  _this2.$el.setAttribute("data-booted", "true");
                  _this2.isBooted = true;
                });
              }
            });
          }
        ),
        /***/
        "./src/mixins/stackable/index.ts": (
          /*!***************************************!*\
            !*** ./src/mixins/stackable/index.ts ***!
            \***************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
              name: "stackable",
              data: function data() {
                return {
                  stackElement: null,
                  stackExclude: null,
                  stackMinZIndex: 0,
                  isActive: false
                };
              },
              computed: {
                activeZIndex: function activeZIndex() {
                  if (typeof window === "undefined")
                    return 0;
                  var content = this.stackElement || this.$refs.content;
                  var index2 = !this.isActive ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getZIndex"])(content) : this.getMaxZIndex(this.stackExclude || [content]) + 2;
                  if (index2 == null)
                    return index2;
                  return parseInt(index2);
                }
              },
              methods: {
                getMaxZIndex: function getMaxZIndex(exclude) {
                  if (exclude === void 0) {
                    exclude = [];
                  }
                  var base = this.$el;
                  var zis = [this.stackMinZIndex, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getZIndex"])(base)];
                  var activeElements = __spreadArray2(__spreadArray2([], __read2(document.getElementsByClassName("v-menu__content--active")), false), __read2(document.getElementsByClassName("v-dialog__content--active")), false);
                  for (var index2 = 0; index2 < activeElements.length; index2++) {
                    if (!exclude.includes(activeElements[index2])) {
                      zis.push(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getZIndex"])(activeElements[index2]));
                    }
                  }
                  return Math.max.apply(Math, __spreadArray2([], __read2(zis), false));
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/themeable/index.ts": (
          /*!***************************************!*\
            !*** ./src/mixins/themeable/index.ts ***!
            \***************************************/
          /*! exports provided: default, functionalThemeClasses */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "functionalThemeClasses", function() {
              return functionalThemeClasses;
            });
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var Themeable = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
              name: "themeable",
              provide: function provide() {
                return {
                  theme: this.themeableProvide
                };
              },
              inject: {
                theme: {
                  default: {
                    isDark: false
                  }
                }
              },
              props: {
                dark: {
                  type: Boolean,
                  default: null
                },
                light: {
                  type: Boolean,
                  default: null
                }
              },
              data: function data() {
                return {
                  themeableProvide: {
                    isDark: false
                  }
                };
              },
              computed: {
                appIsDark: function appIsDark() {
                  return this.$vuetify.theme.dark || false;
                },
                isDark: function isDark() {
                  if (this.dark === true) {
                    return true;
                  } else if (this.light === true) {
                    return false;
                  } else {
                    return this.theme.isDark;
                  }
                },
                themeClasses: function themeClasses() {
                  return {
                    "theme--dark": this.isDark,
                    "theme--light": !this.isDark
                  };
                },
                /** Used by menus and dialogs, inherits from v-app instead of the parent */
                rootIsDark: function rootIsDark() {
                  if (this.dark === true) {
                    return true;
                  } else if (this.light === true) {
                    return false;
                  } else {
                    return this.appIsDark;
                  }
                },
                rootThemeClasses: function rootThemeClasses() {
                  return {
                    "theme--dark": this.rootIsDark,
                    "theme--light": !this.rootIsDark
                  };
                }
              },
              watch: {
                isDark: {
                  handler: function handler(newVal, oldVal) {
                    if (newVal !== oldVal) {
                      this.themeableProvide.isDark = this.isDark;
                    }
                  },
                  immediate: true
                }
              }
            });
            __webpack_exports__["default"] = Themeable;
            function functionalThemeClasses(context) {
              var vm = __assign2(__assign2({}, context.props), context.injections);
              var isDark = Themeable.options.computed.isDark.call(vm);
              return Themeable.options.computed.themeClasses.call({
                isDark
              });
            }
          }
        ),
        /***/
        "./src/mixins/toggleable/index.ts": (
          /*!****************************************!*\
            !*** ./src/mixins/toggleable/index.ts ***!
            \****************************************/
          /*! exports provided: factory, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "factory", function() {
              return factory;
            });
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            function factory(prop, event) {
              var _a2, _b2;
              if (prop === void 0) {
                prop = "value";
              }
              if (event === void 0) {
                event = "input";
              }
              return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
                name: "toggleable",
                model: {
                  prop,
                  event
                },
                props: (_a2 = {}, _a2[prop] = {
                  required: false
                }, _a2),
                data: function data() {
                  return {
                    isActive: !!this[prop]
                  };
                },
                watch: (_b2 = {}, _b2[prop] = function(val) {
                  this.isActive = !!val;
                }, _b2.isActive = function(val) {
                  !!val !== this[prop] && this.$emit(event, val);
                }, _b2)
              });
            }
            var Toggleable = factory();
            __webpack_exports__["default"] = Toggleable;
          }
        ),
        /***/
        "./src/mixins/transitionable/index.ts": (
          /*!********************************************!*\
            !*** ./src/mixins/transitionable/index.ts ***!
            \********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "transitionable",
              props: {
                mode: String,
                origin: String,
                transition: String
              }
            });
          }
        ),
        /***/
        "./src/mixins/translatable/index.ts": (
          /*!******************************************!*\
            !*** ./src/mixins/translatable/index.ts ***!
            \******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            __webpack_exports__["default"] = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
              name: "translatable",
              props: {
                height: Number
              },
              data: function data() {
                return {
                  elOffsetTop: 0,
                  parallax: 0,
                  parallaxDist: 0,
                  percentScrolled: 0,
                  scrollTop: 0,
                  windowHeight: 0,
                  windowBottom: 0
                };
              },
              computed: {
                imgHeight: function imgHeight() {
                  return this.objHeight();
                }
              },
              beforeDestroy: function beforeDestroy2() {
                window.removeEventListener("scroll", this.translate, false);
                window.removeEventListener("resize", this.translate, false);
              },
              methods: {
                calcDimensions: function calcDimensions() {
                  var offset2 = this.$el.getBoundingClientRect();
                  this.scrollTop = window.pageYOffset;
                  this.parallaxDist = this.imgHeight - this.height;
                  this.elOffsetTop = offset2.top + this.scrollTop;
                  this.windowHeight = window.innerHeight;
                  this.windowBottom = this.scrollTop + this.windowHeight;
                },
                listeners: function listeners() {
                  window.addEventListener("scroll", this.translate, false);
                  window.addEventListener("resize", this.translate, false);
                },
                /** @abstract **/
                objHeight: function objHeight() {
                  throw new Error("Not implemented !");
                },
                translate: function translate() {
                  this.calcDimensions();
                  this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (parseInt(this.height) + this.windowHeight);
                  this.parallax = Math.round(this.parallaxDist * this.percentScrolled);
                }
              }
            });
          }
        ),
        /***/
        "./src/mixins/validatable/index.ts": (
          /*!*****************************************!*\
            !*** ./src/mixins/validatable/index.ts ***!
            \*****************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../colorable */
              "./src/mixins/colorable/index.ts"
            );
            var _themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../themeable */
              "./src/mixins/themeable/index.ts"
            );
            var _registrable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../registrable */
              "./src/mixins/registrable/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ../../util/mixins */
              "./src/util/mixins.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_colorable__WEBPACK_IMPORTED_MODULE_0__["default"], Object(_registrable__WEBPACK_IMPORTED_MODULE_2__["inject"])("form"), _themeable__WEBPACK_IMPORTED_MODULE_1__["default"]);
            __webpack_exports__["default"] = baseMixins.extend({
              name: "validatable",
              props: {
                disabled: {
                  type: Boolean,
                  default: null
                },
                error: Boolean,
                errorCount: {
                  type: [Number, String],
                  default: 1
                },
                errorMessages: {
                  type: [String, Array],
                  default: function _default() {
                    return [];
                  }
                },
                messages: {
                  type: [String, Array],
                  default: function _default() {
                    return [];
                  }
                },
                readonly: {
                  type: Boolean,
                  default: null
                },
                rules: {
                  type: Array,
                  default: function _default() {
                    return [];
                  }
                },
                success: Boolean,
                successMessages: {
                  type: [String, Array],
                  default: function _default() {
                    return [];
                  }
                },
                validateOnBlur: Boolean,
                value: {
                  required: false
                }
              },
              data: function data() {
                return {
                  errorBucket: [],
                  hasColor: false,
                  hasFocused: false,
                  hasInput: false,
                  isFocused: false,
                  isResetting: false,
                  lazyValue: this.value,
                  valid: false
                };
              },
              computed: {
                computedColor: function computedColor() {
                  if (this.isDisabled)
                    return void 0;
                  if (this.color)
                    return this.color;
                  if (this.isDark && !this.appIsDark)
                    return "white";
                  else
                    return "primary";
                },
                hasError: function hasError() {
                  return this.internalErrorMessages.length > 0 || this.errorBucket.length > 0 || this.error;
                },
                // TODO: Add logic that allows the user to enable based
                // upon a good validation
                hasSuccess: function hasSuccess() {
                  return this.internalSuccessMessages.length > 0 || this.success;
                },
                externalError: function externalError() {
                  return this.internalErrorMessages.length > 0 || this.error;
                },
                hasMessages: function hasMessages() {
                  return this.validationTarget.length > 0;
                },
                hasState: function hasState() {
                  if (this.isDisabled)
                    return false;
                  return this.hasSuccess || this.shouldValidate && this.hasError;
                },
                internalErrorMessages: function internalErrorMessages() {
                  return this.genInternalMessages(this.errorMessages);
                },
                internalMessages: function internalMessages() {
                  return this.genInternalMessages(this.messages);
                },
                internalSuccessMessages: function internalSuccessMessages() {
                  return this.genInternalMessages(this.successMessages);
                },
                internalValue: {
                  get: function get5() {
                    return this.lazyValue;
                  },
                  set: function set2(val) {
                    this.lazyValue = val;
                    this.$emit("input", val);
                  }
                },
                isDisabled: function isDisabled() {
                  var _a2;
                  return (_a2 = this.disabled) !== null && _a2 !== void 0 ? _a2 : !!this.form && this.form.disabled;
                },
                isInteractive: function isInteractive() {
                  return !this.isDisabled && !this.isReadonly;
                },
                isReadonly: function isReadonly() {
                  var _a2;
                  return (_a2 = this.readonly) !== null && _a2 !== void 0 ? _a2 : !!this.form && this.form.readonly;
                },
                shouldValidate: function shouldValidate() {
                  if (this.externalError)
                    return true;
                  if (this.isResetting)
                    return false;
                  return this.validateOnBlur ? this.hasFocused && !this.isFocused : this.hasInput || this.hasFocused;
                },
                validations: function validations() {
                  return this.validationTarget.slice(0, Number(this.errorCount));
                },
                validationState: function validationState() {
                  if (this.isDisabled)
                    return void 0;
                  if (this.hasError && this.shouldValidate)
                    return "error";
                  if (this.hasSuccess)
                    return "success";
                  if (this.hasColor)
                    return this.computedColor;
                  return void 0;
                },
                validationTarget: function validationTarget() {
                  if (this.internalErrorMessages.length > 0) {
                    return this.internalErrorMessages;
                  } else if (this.successMessages && this.successMessages.length > 0) {
                    return this.internalSuccessMessages;
                  } else if (this.messages && this.messages.length > 0) {
                    return this.internalMessages;
                  } else if (this.shouldValidate) {
                    return this.errorBucket;
                  } else
                    return [];
                }
              },
              watch: {
                rules: {
                  handler: function handler(newVal, oldVal) {
                    if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["deepEqual"])(newVal, oldVal))
                      return;
                    this.validate();
                  },
                  deep: true
                },
                internalValue: function internalValue() {
                  this.hasInput = true;
                  this.validateOnBlur || this.$nextTick(this.validate);
                },
                isFocused: function isFocused(val) {
                  if (!val && !this.isDisabled) {
                    this.hasFocused = true;
                    this.validateOnBlur && this.$nextTick(this.validate);
                  }
                },
                isResetting: function isResetting() {
                  var _this2 = this;
                  setTimeout(function() {
                    _this2.hasInput = false;
                    _this2.hasFocused = false;
                    _this2.isResetting = false;
                    _this2.validate();
                  }, 0);
                },
                hasError: function hasError(val) {
                  if (this.shouldValidate) {
                    this.$emit("update:error", val);
                  }
                },
                value: function value(val) {
                  this.lazyValue = val;
                }
              },
              beforeMount: function beforeMount2() {
                this.validate();
              },
              created: function created2() {
                this.form && this.form.register(this);
              },
              beforeDestroy: function beforeDestroy2() {
                this.form && this.form.unregister(this);
              },
              methods: {
                genInternalMessages: function genInternalMessages(messages2) {
                  if (!messages2)
                    return [];
                  else if (Array.isArray(messages2))
                    return messages2;
                  else
                    return [messages2];
                },
                /** @public */
                reset: function reset() {
                  this.isResetting = true;
                  this.internalValue = Array.isArray(this.internalValue) ? [] : null;
                },
                /** @public */
                resetValidation: function resetValidation() {
                  this.isResetting = true;
                },
                /** @public */
                validate: function validate(force, value) {
                  if (force === void 0) {
                    force = false;
                  }
                  var errorBucket = [];
                  value = value || this.internalValue;
                  if (force)
                    this.hasInput = this.hasFocused = true;
                  for (var index2 = 0; index2 < this.rules.length; index2++) {
                    var rule2 = this.rules[index2];
                    var valid = typeof rule2 === "function" ? rule2(value) : rule2;
                    if (valid === false || typeof valid === "string") {
                      errorBucket.push(valid || "");
                    } else if (typeof valid !== "boolean") {
                      Object(_util_console__WEBPACK_IMPORTED_MODULE_4__["consoleError"])("Rules should return a string or boolean, received '" + _typeof2(valid) + "' instead", this);
                    }
                  }
                  this.errorBucket = errorBucket;
                  this.valid = errorBucket.length === 0;
                  return this.valid;
                }
              }
            });
          }
        ),
        /***/
        "./src/presets/default/index.ts": (
          /*!**************************************!*\
            !*** ./src/presets/default/index.ts ***!
            \**************************************/
          /*! exports provided: preset */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "preset", function() {
              return preset;
            });
            __webpack_require__(
              /*! ../../styles/main.sass */
              "./src/styles/main.sass"
            );
            var _locale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../locale */
              "./src/locale/index.ts"
            );
            var preset = {
              breakpoint: {
                // TODO: update to MD2 spec in v3 - 1280
                mobileBreakpoint: 1264,
                scrollBarWidth: 16,
                thresholds: {
                  xs: 600,
                  sm: 960,
                  md: 1280,
                  lg: 1920
                }
              },
              icons: {
                // TODO: remove v3
                iconfont: "mdi",
                values: {}
              },
              lang: {
                current: "en",
                locales: {
                  en: _locale__WEBPACK_IMPORTED_MODULE_1__["en"]
                },
                // Default translator exists in lang service
                t: void 0
              },
              rtl: false,
              theme: {
                dark: false,
                default: "light",
                disable: false,
                options: {
                  cspNonce: void 0,
                  customProperties: void 0,
                  minifyTheme: void 0,
                  themeCache: void 0,
                  variations: true
                },
                themes: {
                  light: {
                    primary: "#1976D2",
                    secondary: "#424242",
                    accent: "#82B1FF",
                    error: "#FF5252",
                    info: "#2196F3",
                    success: "#4CAF50",
                    warning: "#FB8C00"
                  },
                  dark: {
                    primary: "#2196F3",
                    secondary: "#424242",
                    accent: "#FF4081",
                    error: "#FF5252",
                    info: "#2196F3",
                    success: "#4CAF50",
                    warning: "#FB8C00"
                  }
                }
              }
            };
          }
        ),
        /***/
        "./src/services/application/index.ts": (
          /*!*******************************************!*\
            !*** ./src/services/application/index.ts ***!
            \*******************************************/
          /*! exports provided: Application */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Application", function() {
              return Application;
            });
            var _service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../service */
              "./src/services/service/index.ts"
            );
            var __extends2 = function() {
              var _extendStatics = function extendStatics2(d2, b) {
                _extendStatics = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function(d3, b2) {
                  d3.__proto__ = b2;
                } || function(d3, b2) {
                  for (var p in b2) {
                    if (Object.prototype.hasOwnProperty.call(b2, p))
                      d3[p] = b2[p];
                  }
                };
                return _extendStatics(d2, b);
              };
              return function(d2, b) {
                if (typeof b !== "function" && b !== null)
                  throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                _extendStatics(d2, b);
                function __() {
                  this.constructor = d2;
                }
                d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
              };
            }();
            var Application = (
              /** @class */
              function(_super) {
                __extends2(Application2, _super);
                function Application2() {
                  var _this2 = _super !== null && _super.apply(this, arguments) || this;
                  _this2.bar = 0;
                  _this2.top = 0;
                  _this2.left = 0;
                  _this2.insetFooter = 0;
                  _this2.right = 0;
                  _this2.bottom = 0;
                  _this2.footer = 0;
                  _this2.application = {
                    bar: {},
                    top: {},
                    left: {},
                    insetFooter: {},
                    right: {},
                    bottom: {},
                    footer: {}
                  };
                  return _this2;
                }
                Application2.prototype.register = function(uid2, location2, size) {
                  this.application[location2][uid2] = size;
                  this.update(location2);
                };
                Application2.prototype.unregister = function(uid2, location2) {
                  if (this.application[location2][uid2] == null)
                    return;
                  delete this.application[location2][uid2];
                  this.update(location2);
                };
                Application2.prototype.update = function(location2) {
                  this[location2] = Object.values(this.application[location2]).reduce(function(acc, cur) {
                    return acc + cur;
                  }, 0);
                };
                Application2.property = "application";
                return Application2;
              }(_service__WEBPACK_IMPORTED_MODULE_0__["Service"])
            );
          }
        ),
        /***/
        "./src/services/breakpoint/index.ts": (
          /*!******************************************!*\
            !*** ./src/services/breakpoint/index.ts ***!
            \******************************************/
          /*! exports provided: Breakpoint */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Breakpoint", function() {
              return Breakpoint;
            });
            var _service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../service */
              "./src/services/service/index.ts"
            );
            var __extends2 = function() {
              var _extendStatics = function extendStatics2(d2, b) {
                _extendStatics = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function(d3, b2) {
                  d3.__proto__ = b2;
                } || function(d3, b2) {
                  for (var p in b2) {
                    if (Object.prototype.hasOwnProperty.call(b2, p))
                      d3[p] = b2[p];
                  }
                };
                return _extendStatics(d2, b);
              };
              return function(d2, b) {
                if (typeof b !== "function" && b !== null)
                  throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                _extendStatics(d2, b);
                function __() {
                  this.constructor = d2;
                }
                d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
              };
            }();
            var Breakpoint = (
              /** @class */
              function(_super) {
                __extends2(Breakpoint2, _super);
                function Breakpoint2(preset) {
                  var _this2 = _super.call(this) || this;
                  _this2.xs = false;
                  _this2.sm = false;
                  _this2.md = false;
                  _this2.lg = false;
                  _this2.xl = false;
                  _this2.xsOnly = false;
                  _this2.smOnly = false;
                  _this2.smAndDown = false;
                  _this2.smAndUp = false;
                  _this2.mdOnly = false;
                  _this2.mdAndDown = false;
                  _this2.mdAndUp = false;
                  _this2.lgOnly = false;
                  _this2.lgAndDown = false;
                  _this2.lgAndUp = false;
                  _this2.xlOnly = false;
                  _this2.name = "xs";
                  _this2.height = 0;
                  _this2.width = 0;
                  _this2.mobile = true;
                  _this2.resizeTimeout = 0;
                  var _a2 = preset[Breakpoint2.property], mobileBreakpoint = _a2.mobileBreakpoint, scrollBarWidth = _a2.scrollBarWidth, thresholds = _a2.thresholds;
                  _this2.mobileBreakpoint = mobileBreakpoint;
                  _this2.scrollBarWidth = scrollBarWidth;
                  _this2.thresholds = thresholds;
                  return _this2;
                }
                Breakpoint2.prototype.init = function() {
                  this.update();
                  if (typeof window === "undefined")
                    return;
                  window.addEventListener("resize", this.onResize.bind(this), {
                    passive: true
                  });
                };
                Breakpoint2.prototype.update = function(ssr) {
                  if (ssr === void 0) {
                    ssr = false;
                  }
                  var height = ssr ? 0 : this.getClientHeight();
                  var width = ssr ? 0 : this.getClientWidth();
                  var xs = width < this.thresholds.xs;
                  var sm = width < this.thresholds.sm && !xs;
                  var md = width < this.thresholds.md - this.scrollBarWidth && !(sm || xs);
                  var lg = width < this.thresholds.lg - this.scrollBarWidth && !(md || sm || xs);
                  var xl = width >= this.thresholds.lg - this.scrollBarWidth;
                  this.height = height;
                  this.width = width;
                  this.xs = xs;
                  this.sm = sm;
                  this.md = md;
                  this.lg = lg;
                  this.xl = xl;
                  this.xsOnly = xs;
                  this.smOnly = sm;
                  this.smAndDown = (xs || sm) && !(md || lg || xl);
                  this.smAndUp = !xs && (sm || md || lg || xl);
                  this.mdOnly = md;
                  this.mdAndDown = (xs || sm || md) && !(lg || xl);
                  this.mdAndUp = !(xs || sm) && (md || lg || xl);
                  this.lgOnly = lg;
                  this.lgAndDown = (xs || sm || md || lg) && !xl;
                  this.lgAndUp = !(xs || sm || md) && (lg || xl);
                  this.xlOnly = xl;
                  switch (true) {
                    case xs:
                      this.name = "xs";
                      break;
                    case sm:
                      this.name = "sm";
                      break;
                    case md:
                      this.name = "md";
                      break;
                    case lg:
                      this.name = "lg";
                      break;
                    default:
                      this.name = "xl";
                      break;
                  }
                  if (typeof this.mobileBreakpoint === "number") {
                    this.mobile = width < parseInt(this.mobileBreakpoint, 10);
                    return;
                  }
                  var breakpoints = {
                    xs: 0,
                    sm: 1,
                    md: 2,
                    lg: 3,
                    xl: 4
                  };
                  var current = breakpoints[this.name];
                  var max2 = breakpoints[this.mobileBreakpoint];
                  this.mobile = current <= max2;
                };
                Breakpoint2.prototype.onResize = function() {
                  clearTimeout(this.resizeTimeout);
                  this.resizeTimeout = window.setTimeout(this.update.bind(this), 200);
                };
                Breakpoint2.prototype.getClientWidth = function() {
                  if (typeof document === "undefined")
                    return 0;
                  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                };
                Breakpoint2.prototype.getClientHeight = function() {
                  if (typeof document === "undefined")
                    return 0;
                  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                };
                Breakpoint2.property = "breakpoint";
                return Breakpoint2;
              }(_service__WEBPACK_IMPORTED_MODULE_0__["Service"])
            );
          }
        ),
        /***/
        "./src/services/goto/easing-patterns.ts": (
          /*!**********************************************!*\
            !*** ./src/services/goto/easing-patterns.ts ***!
            \**********************************************/
          /*! exports provided: linear, easeInQuad, easeOutQuad, easeInOutQuad, easeInCubic, easeOutCubic, easeInOutCubic, easeInQuart, easeOutQuart, easeInOutQuart, easeInQuint, easeOutQuint, easeInOutQuint */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "linear", function() {
              return linear;
            });
            __webpack_require__.d(__webpack_exports__, "easeInQuad", function() {
              return easeInQuad;
            });
            __webpack_require__.d(__webpack_exports__, "easeOutQuad", function() {
              return easeOutQuad;
            });
            __webpack_require__.d(__webpack_exports__, "easeInOutQuad", function() {
              return easeInOutQuad;
            });
            __webpack_require__.d(__webpack_exports__, "easeInCubic", function() {
              return easeInCubic;
            });
            __webpack_require__.d(__webpack_exports__, "easeOutCubic", function() {
              return easeOutCubic;
            });
            __webpack_require__.d(__webpack_exports__, "easeInOutCubic", function() {
              return easeInOutCubic;
            });
            __webpack_require__.d(__webpack_exports__, "easeInQuart", function() {
              return easeInQuart;
            });
            __webpack_require__.d(__webpack_exports__, "easeOutQuart", function() {
              return easeOutQuart;
            });
            __webpack_require__.d(__webpack_exports__, "easeInOutQuart", function() {
              return easeInOutQuart;
            });
            __webpack_require__.d(__webpack_exports__, "easeInQuint", function() {
              return easeInQuint;
            });
            __webpack_require__.d(__webpack_exports__, "easeOutQuint", function() {
              return easeOutQuint;
            });
            __webpack_require__.d(__webpack_exports__, "easeInOutQuint", function() {
              return easeInOutQuint;
            });
            var linear = function linear2(t3) {
              return t3;
            };
            var easeInQuad = function easeInQuad2(t3) {
              return Math.pow(t3, 2);
            };
            var easeOutQuad = function easeOutQuad2(t3) {
              return t3 * (2 - t3);
            };
            var easeInOutQuad = function easeInOutQuad2(t3) {
              return t3 < 0.5 ? 2 * Math.pow(t3, 2) : -1 + (4 - 2 * t3) * t3;
            };
            var easeInCubic = function easeInCubic2(t3) {
              return Math.pow(t3, 3);
            };
            var easeOutCubic = function easeOutCubic2(t3) {
              return Math.pow(--t3, 3) + 1;
            };
            var easeInOutCubic = function easeInOutCubic2(t3) {
              return t3 < 0.5 ? 4 * Math.pow(t3, 3) : (t3 - 1) * (2 * t3 - 2) * (2 * t3 - 2) + 1;
            };
            var easeInQuart = function easeInQuart2(t3) {
              return Math.pow(t3, 4);
            };
            var easeOutQuart = function easeOutQuart2(t3) {
              return 1 - Math.pow(--t3, 4);
            };
            var easeInOutQuart = function easeInOutQuart2(t3) {
              return t3 < 0.5 ? 8 * t3 * t3 * t3 * t3 : 1 - 8 * --t3 * t3 * t3 * t3;
            };
            var easeInQuint = function easeInQuint2(t3) {
              return Math.pow(t3, 5);
            };
            var easeOutQuint = function easeOutQuint2(t3) {
              return 1 + Math.pow(--t3, 5);
            };
            var easeInOutQuint = function easeInOutQuint2(t3) {
              return t3 < 0.5 ? 16 * Math.pow(t3, 5) : 1 + 16 * Math.pow(--t3, 5);
            };
          }
        ),
        /***/
        "./src/services/goto/index.ts": (
          /*!************************************!*\
            !*** ./src/services/goto/index.ts ***!
            \************************************/
          /*! exports provided: default, Goto */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", function() {
              return goTo;
            });
            __webpack_require__.d(__webpack_exports__, "Goto", function() {
              return Goto;
            });
            var _service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../service */
              "./src/services/service/index.ts"
            );
            var _easing_patterns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./easing-patterns */
              "./src/services/goto/easing-patterns.ts"
            );
            var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./util */
              "./src/services/goto/util.ts"
            );
            var __extends2 = function() {
              var _extendStatics = function extendStatics2(d2, b) {
                _extendStatics = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function(d3, b2) {
                  d3.__proto__ = b2;
                } || function(d3, b2) {
                  for (var p in b2) {
                    if (Object.prototype.hasOwnProperty.call(b2, p))
                      d3[p] = b2[p];
                  }
                };
                return _extendStatics(d2, b);
              };
              return function(d2, b) {
                if (typeof b !== "function" && b !== null)
                  throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                _extendStatics(d2, b);
                function __() {
                  this.constructor = d2;
                }
                d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
              };
            }();
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            function goTo(_target2, _settings) {
              if (_settings === void 0) {
                _settings = {};
              }
              var settings = __assign2({
                container: document.scrollingElement || document.body || document.documentElement,
                duration: 500,
                offset: 0,
                easing: "easeInOutCubic",
                appOffset: true
              }, _settings);
              var container2 = Object(_util__WEBPACK_IMPORTED_MODULE_2__["getContainer"])(settings.container);
              if (settings.appOffset && goTo.framework.application) {
                var isDrawer = container2.classList.contains("v-navigation-drawer");
                var isClipped = container2.classList.contains("v-navigation-drawer--clipped");
                var _a2 = goTo.framework.application, bar = _a2.bar, top = _a2.top;
                settings.offset += bar;
                if (!isDrawer || isClipped)
                  settings.offset += top;
              }
              var startTime = performance.now();
              var targetLocation;
              if (typeof _target2 === "number") {
                targetLocation = Object(_util__WEBPACK_IMPORTED_MODULE_2__["getOffset"])(_target2) - settings.offset;
              } else {
                targetLocation = Object(_util__WEBPACK_IMPORTED_MODULE_2__["getOffset"])(_target2) - Object(_util__WEBPACK_IMPORTED_MODULE_2__["getOffset"])(container2) - settings.offset;
              }
              var startLocation = container2.scrollTop;
              if (targetLocation === startLocation)
                return Promise.resolve(targetLocation);
              var ease = typeof settings.easing === "function" ? settings.easing : _easing_patterns__WEBPACK_IMPORTED_MODULE_1__[settings.easing];
              if (!ease)
                throw new TypeError('Easing function "' + settings.easing + '" not found.');
              return new Promise(function(resolve2) {
                return requestAnimationFrame(function step(currentTime) {
                  var timeElapsed = currentTime - startTime;
                  var progress = Math.abs(settings.duration ? Math.min(timeElapsed / settings.duration, 1) : 1);
                  container2.scrollTop = Math.floor(startLocation + (targetLocation - startLocation) * ease(progress));
                  var clientHeight = container2 === document.body ? document.documentElement.clientHeight : container2.clientHeight;
                  var reachBottom = clientHeight + container2.scrollTop >= container2.scrollHeight;
                  if (progress === 1 || // Need to go lower but reach bottom
                  targetLocation > container2.scrollTop && reachBottom) {
                    return resolve2(targetLocation);
                  }
                  requestAnimationFrame(step);
                });
              });
            }
            goTo.framework = {};
            goTo.init = function() {
            };
            var Goto = (
              /** @class */
              function(_super) {
                __extends2(Goto2, _super);
                function Goto2() {
                  _super.call(this) || this;
                  return goTo;
                }
                Goto2.property = "goTo";
                return Goto2;
              }(_service__WEBPACK_IMPORTED_MODULE_0__["Service"])
            );
          }
        ),
        /***/
        "./src/services/goto/util.ts": (
          /*!***********************************!*\
            !*** ./src/services/goto/util.ts ***!
            \***********************************/
          /*! exports provided: getOffset, getContainer */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "getOffset", function() {
              return getOffset;
            });
            __webpack_require__.d(__webpack_exports__, "getContainer", function() {
              return getContainer;
            });
            function getOffset(target2) {
              if (typeof target2 === "number") {
                return target2;
              }
              var el = $(target2);
              if (!el) {
                throw typeof target2 === "string" ? new Error('Target element "' + target2 + '" not found.') : new TypeError("Target must be a Number/Selector/HTMLElement/VueComponent, received " + type(target2) + " instead.");
              }
              var totalOffset = 0;
              while (el) {
                totalOffset += el.offsetTop;
                el = el.offsetParent;
              }
              return totalOffset;
            }
            function getContainer(container2) {
              var el = $(container2);
              if (el)
                return el;
              throw typeof container2 === "string" ? new Error('Container element "' + container2 + '" not found.') : new TypeError("Container must be a Selector/HTMLElement/VueComponent, received " + type(container2) + " instead.");
            }
            function type(el) {
              return el == null ? el : el.constructor.name;
            }
            function $(el) {
              if (typeof el === "string") {
                return document.querySelector(el);
              } else if (el && el._isVue) {
                return el.$el;
              } else if (el instanceof HTMLElement) {
                return el;
              } else {
                return null;
              }
            }
          }
        ),
        /***/
        "./src/services/icons/index.ts": (
          /*!*************************************!*\
            !*** ./src/services/icons/index.ts ***!
            \*************************************/
          /*! exports provided: Icons */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Icons", function() {
              return Icons;
            });
            var _service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../service */
              "./src/services/service/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _presets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./presets */
              "./src/services/icons/presets/index.ts"
            );
            var __extends2 = function() {
              var _extendStatics = function extendStatics2(d2, b) {
                _extendStatics = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function(d3, b2) {
                  d3.__proto__ = b2;
                } || function(d3, b2) {
                  for (var p in b2) {
                    if (Object.prototype.hasOwnProperty.call(b2, p))
                      d3[p] = b2[p];
                  }
                };
                return _extendStatics(d2, b);
              };
              return function(d2, b) {
                if (typeof b !== "function" && b !== null)
                  throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                _extendStatics(d2, b);
                function __() {
                  this.constructor = d2;
                }
                d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
              };
            }();
            var Icons = (
              /** @class */
              function(_super) {
                __extends2(Icons2, _super);
                function Icons2(preset) {
                  var _this2 = _super.call(this) || this;
                  var _a2 = preset[Icons2.property], iconfont = _a2.iconfont, values2 = _a2.values, component = _a2.component;
                  _this2.component = component;
                  _this2.iconfont = iconfont;
                  _this2.values = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["mergeDeep"])(_presets__WEBPACK_IMPORTED_MODULE_2__["default"][iconfont], values2);
                  return _this2;
                }
                Icons2.property = "icons";
                return Icons2;
              }(_service__WEBPACK_IMPORTED_MODULE_0__["Service"])
            );
          }
        ),
        /***/
        "./src/services/icons/presets/fa-svg.ts": (
          /*!**********************************************!*\
            !*** ./src/services/icons/presets/fa-svg.ts ***!
            \**********************************************/
          /*! exports provided: convertToComponentDeclarations, default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "convertToComponentDeclarations", function() {
              return convertToComponentDeclarations;
            });
            var _fa__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./fa */
              "./src/services/icons/presets/fa.ts"
            );
            function convertToComponentDeclarations(component, iconSet) {
              var result2 = {};
              for (var key in iconSet) {
                result2[key] = {
                  component,
                  props: {
                    icon: iconSet[key].split(" fa-")
                  }
                };
              }
              return result2;
            }
            __webpack_exports__["default"] = convertToComponentDeclarations("font-awesome-icon", _fa__WEBPACK_IMPORTED_MODULE_0__["default"]);
          }
        ),
        /***/
        "./src/services/icons/presets/fa.ts": (
          /*!******************************************!*\
            !*** ./src/services/icons/presets/fa.ts ***!
            \******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var icons2 = {
              complete: "fas fa-check",
              cancel: "fas fa-times-circle",
              close: "fas fa-times",
              delete: "fas fa-times-circle",
              clear: "fas fa-times-circle",
              success: "fas fa-check-circle",
              info: "fas fa-info-circle",
              warning: "fas fa-exclamation-circle",
              error: "fas fa-exclamation-triangle",
              prev: "fas fa-chevron-left",
              next: "fas fa-chevron-right",
              checkboxOn: "fas fa-check-square",
              checkboxOff: "far fa-square",
              checkboxIndeterminate: "fas fa-minus-square",
              delimiter: "fas fa-circle",
              sort: "fas fa-sort-up",
              expand: "fas fa-chevron-down",
              menu: "fas fa-bars",
              subgroup: "fas fa-caret-down",
              dropdown: "fas fa-caret-down",
              radioOn: "far fa-dot-circle",
              radioOff: "far fa-circle",
              edit: "fas fa-edit",
              ratingEmpty: "far fa-star",
              ratingFull: "fas fa-star",
              ratingHalf: "fas fa-star-half",
              loading: "fas fa-sync",
              first: "fas fa-step-backward",
              last: "fas fa-step-forward",
              unfold: "fas fa-arrows-alt-v",
              file: "fas fa-paperclip",
              plus: "fas fa-plus",
              minus: "fas fa-minus"
            };
            __webpack_exports__["default"] = icons2;
          }
        ),
        /***/
        "./src/services/icons/presets/fa4.ts": (
          /*!*******************************************!*\
            !*** ./src/services/icons/presets/fa4.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var icons2 = {
              complete: "fa fa-check",
              cancel: "fa fa-times-circle",
              close: "fa fa-times",
              delete: "fa fa-times-circle",
              clear: "fa fa-times-circle",
              success: "fa fa-check-circle",
              info: "fa fa-info-circle",
              warning: "fa fa-exclamation",
              error: "fa fa-exclamation-triangle",
              prev: "fa fa-chevron-left",
              next: "fa fa-chevron-right",
              checkboxOn: "fa fa-check-square",
              checkboxOff: "fa fa-square-o",
              checkboxIndeterminate: "fa fa-minus-square",
              delimiter: "fa fa-circle",
              sort: "fa fa-sort-up",
              expand: "fa fa-chevron-down",
              menu: "fa fa-bars",
              subgroup: "fa fa-caret-down",
              dropdown: "fa fa-caret-down",
              radioOn: "fa fa-dot-circle-o",
              radioOff: "fa fa-circle-o",
              edit: "fa fa-pencil",
              ratingEmpty: "fa fa-star-o",
              ratingFull: "fa fa-star",
              ratingHalf: "fa fa-star-half-o",
              loading: "fa fa-refresh",
              first: "fa fa-step-backward",
              last: "fa fa-step-forward",
              unfold: "fa fa-angle-double-down",
              file: "fa fa-paperclip",
              plus: "fa fa-plus",
              minus: "fa fa-minus"
            };
            __webpack_exports__["default"] = icons2;
          }
        ),
        /***/
        "./src/services/icons/presets/index.ts": (
          /*!*********************************************!*\
            !*** ./src/services/icons/presets/index.ts ***!
            \*********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _mdi_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./mdi-svg */
              "./src/services/icons/presets/mdi-svg.ts"
            );
            var _md__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./md */
              "./src/services/icons/presets/md.ts"
            );
            var _mdi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./mdi */
              "./src/services/icons/presets/mdi.ts"
            );
            var _fa__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./fa */
              "./src/services/icons/presets/fa.ts"
            );
            var _fa4__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./fa4 */
              "./src/services/icons/presets/fa4.ts"
            );
            var _fa_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./fa-svg */
              "./src/services/icons/presets/fa-svg.ts"
            );
            __webpack_exports__["default"] = Object.freeze({
              mdiSvg: _mdi_svg__WEBPACK_IMPORTED_MODULE_0__["default"],
              md: _md__WEBPACK_IMPORTED_MODULE_1__["default"],
              mdi: _mdi__WEBPACK_IMPORTED_MODULE_2__["default"],
              fa: _fa__WEBPACK_IMPORTED_MODULE_3__["default"],
              fa4: _fa4__WEBPACK_IMPORTED_MODULE_4__["default"],
              faSvg: _fa_svg__WEBPACK_IMPORTED_MODULE_5__["default"]
            });
          }
        ),
        /***/
        "./src/services/icons/presets/md.ts": (
          /*!******************************************!*\
            !*** ./src/services/icons/presets/md.ts ***!
            \******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var icons2 = {
              complete: "check",
              cancel: "cancel",
              close: "close",
              delete: "cancel",
              clear: "clear",
              success: "check_circle",
              info: "info",
              warning: "priority_high",
              error: "warning",
              prev: "chevron_left",
              next: "chevron_right",
              checkboxOn: "check_box",
              checkboxOff: "check_box_outline_blank",
              checkboxIndeterminate: "indeterminate_check_box",
              delimiter: "fiber_manual_record",
              sort: "arrow_upward",
              expand: "keyboard_arrow_down",
              menu: "menu",
              subgroup: "arrow_drop_down",
              dropdown: "arrow_drop_down",
              radioOn: "radio_button_checked",
              radioOff: "radio_button_unchecked",
              edit: "edit",
              ratingEmpty: "star_border",
              ratingFull: "star",
              ratingHalf: "star_half",
              loading: "cached",
              first: "first_page",
              last: "last_page",
              unfold: "unfold_more",
              file: "attach_file",
              plus: "add",
              minus: "remove"
            };
            __webpack_exports__["default"] = icons2;
          }
        ),
        /***/
        "./src/services/icons/presets/mdi-svg.ts": (
          /*!***********************************************!*\
            !*** ./src/services/icons/presets/mdi-svg.ts ***!
            \***********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var icons2 = {
              complete: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
              cancel: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
              close: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
              delete: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
              clear: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
              success: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
              info: "M13,9H11V7H13M13,17H11V11H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2ZM13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z",
              warning: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z",
              error: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
              prev: "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z",
              next: "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z",
              checkboxOn: "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
              checkboxOff: "M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z",
              checkboxIndeterminate: "M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
              delimiter: "M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
              sort: "M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z",
              expand: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z",
              menu: "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z",
              subgroup: "M7,10L12,15L17,10H7Z",
              dropdown: "M7,10L12,15L17,10H7Z",
              radioOn: "M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z",
              radioOff: "M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
              edit: "M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z",
              ratingEmpty: "M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z",
              ratingFull: "M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z",
              ratingHalf: "M12,15.4V6.1L13.71,10.13L18.09,10.5L14.77,13.39L15.76,17.67M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z",
              loading: "M19,8L15,12H18C18,15.31 15.31,18 12,18C11,18 10.03,17.75 9.2,17.3L7.74,18.76C8.97,19.54 10.43,20 12,20C16.42,20 20,16.42 20,12H23M6,12C6,8.69 8.69,6 12,6C13,6 13.97,6.25 14.8,6.7L16.26,5.24C15.03,4.46 13.57,4 12,4C7.58,4 4,7.58 4,12H1L5,16L9,12",
              first: "M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z",
              last: "M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z",
              unfold: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z",
              file: "M16.5,6V17.5C16.5,19.71 14.71,21.5 12.5,21.5C10.29,21.5 8.5,19.71 8.5,17.5V5C8.5,3.62 9.62,2.5 11,2.5C12.38,2.5 13.5,3.62 13.5,5V15.5C13.5,16.05 13.05,16.5 12.5,16.5C11.95,16.5 11.5,16.05 11.5,15.5V6H10V15.5C10,16.88 11.12,18 12.5,18C13.88,18 15,16.88 15,15.5V5C15,2.79 13.21,1 11,1C8.79,1 7,2.79 7,5V17.5C7,20.54 9.46,23 12.5,23C15.54,23 18,20.54 18,17.5V6H16.5Z",
              plus: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
              minus: "M19,13H5V11H19V13Z"
            };
            __webpack_exports__["default"] = icons2;
          }
        ),
        /***/
        "./src/services/icons/presets/mdi.ts": (
          /*!*******************************************!*\
            !*** ./src/services/icons/presets/mdi.ts ***!
            \*******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var icons2 = {
              complete: "mdi-check",
              cancel: "mdi-close-circle",
              close: "mdi-close",
              delete: "mdi-close-circle",
              clear: "mdi-close",
              success: "mdi-check-circle",
              info: "mdi-information",
              warning: "mdi-exclamation",
              error: "mdi-alert",
              prev: "mdi-chevron-left",
              next: "mdi-chevron-right",
              checkboxOn: "mdi-checkbox-marked",
              checkboxOff: "mdi-checkbox-blank-outline",
              checkboxIndeterminate: "mdi-minus-box",
              delimiter: "mdi-circle",
              sort: "mdi-arrow-up",
              expand: "mdi-chevron-down",
              menu: "mdi-menu",
              subgroup: "mdi-menu-down",
              dropdown: "mdi-menu-down",
              radioOn: "mdi-radiobox-marked",
              radioOff: "mdi-radiobox-blank",
              edit: "mdi-pencil",
              ratingEmpty: "mdi-star-outline",
              ratingFull: "mdi-star",
              ratingHalf: "mdi-star-half-full",
              loading: "mdi-cached",
              first: "mdi-page-first",
              last: "mdi-page-last",
              unfold: "mdi-unfold-more-horizontal",
              file: "mdi-paperclip",
              plus: "mdi-plus",
              minus: "mdi-minus"
            };
            __webpack_exports__["default"] = icons2;
          }
        ),
        /***/
        "./src/services/index.ts": (
          /*!*******************************!*\
            !*** ./src/services/index.ts ***!
            \*******************************/
          /*! exports provided: Application, Breakpoint, Goto, Icons, Lang, Presets, Theme */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var _application__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./application */
              "./src/services/application/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Application", function() {
              return _application__WEBPACK_IMPORTED_MODULE_0__["Application"];
            });
            var _breakpoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./breakpoint */
              "./src/services/breakpoint/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Breakpoint", function() {
              return _breakpoint__WEBPACK_IMPORTED_MODULE_1__["Breakpoint"];
            });
            var _goto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./goto */
              "./src/services/goto/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Goto", function() {
              return _goto__WEBPACK_IMPORTED_MODULE_2__["Goto"];
            });
            var _icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ./icons */
              "./src/services/icons/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Icons", function() {
              return _icons__WEBPACK_IMPORTED_MODULE_3__["Icons"];
            });
            var _lang__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
              /*! ./lang */
              "./src/services/lang/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Lang", function() {
              return _lang__WEBPACK_IMPORTED_MODULE_4__["Lang"];
            });
            var _presets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
              /*! ./presets */
              "./src/services/presets/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Presets", function() {
              return _presets__WEBPACK_IMPORTED_MODULE_5__["Presets"];
            });
            var _theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
              /*! ./theme */
              "./src/services/theme/index.ts"
            );
            __webpack_require__.d(__webpack_exports__, "Theme", function() {
              return _theme__WEBPACK_IMPORTED_MODULE_6__["Theme"];
            });
          }
        ),
        /***/
        "./src/services/lang/index.ts": (
          /*!************************************!*\
            !*** ./src/services/lang/index.ts ***!
            \************************************/
          /*! exports provided: Lang */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Lang", function() {
              return Lang;
            });
            var _service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../service */
              "./src/services/service/index.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var __extends2 = function() {
              var _extendStatics = function extendStatics2(d2, b) {
                _extendStatics = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function(d3, b2) {
                  d3.__proto__ = b2;
                } || function(d3, b2) {
                  for (var p in b2) {
                    if (Object.prototype.hasOwnProperty.call(b2, p))
                      d3[p] = b2[p];
                  }
                };
                return _extendStatics(d2, b);
              };
              return function(d2, b) {
                if (typeof b !== "function" && b !== null)
                  throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                _extendStatics(d2, b);
                function __() {
                  this.constructor = d2;
                }
                d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
              };
            }();
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            var LANG_PREFIX = "$vuetify.";
            var fallback = Symbol("Lang fallback");
            function getTranslation(locale, key, usingDefault, defaultLocale) {
              if (usingDefault === void 0) {
                usingDefault = false;
              }
              var shortKey = key.replace(LANG_PREFIX, "");
              var translation = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getObjectValueByPath"])(locale, shortKey, fallback);
              if (translation === fallback) {
                if (usingDefault) {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleError"])('Translation key "' + shortKey + '" not found in fallback');
                  translation = key;
                } else {
                  Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleWarn"])('Translation key "' + shortKey + '" not found, falling back to default');
                  translation = getTranslation(defaultLocale, key, true, defaultLocale);
                }
              }
              return translation;
            }
            var Lang = (
              /** @class */
              function(_super) {
                __extends2(Lang2, _super);
                function Lang2(preset) {
                  var _this2 = _super.call(this) || this;
                  _this2.defaultLocale = "en";
                  var _a2 = preset[Lang2.property], current = _a2.current, locales = _a2.locales, t3 = _a2.t;
                  _this2.current = current;
                  _this2.locales = locales;
                  _this2.translator = t3 || _this2.defaultTranslator;
                  return _this2;
                }
                Lang2.prototype.currentLocale = function(key) {
                  var translation = this.locales[this.current];
                  var defaultLocale = this.locales[this.defaultLocale];
                  return getTranslation(translation, key, false, defaultLocale);
                };
                Lang2.prototype.t = function(key) {
                  var params = [];
                  for (var _i2 = 1; _i2 < arguments.length; _i2++) {
                    params[_i2 - 1] = arguments[_i2];
                  }
                  if (!key.startsWith(LANG_PREFIX))
                    return this.replace(key, params);
                  return this.translator.apply(this, __spreadArray2([key], __read2(params), false));
                };
                Lang2.prototype.defaultTranslator = function(key) {
                  var params = [];
                  for (var _i2 = 1; _i2 < arguments.length; _i2++) {
                    params[_i2 - 1] = arguments[_i2];
                  }
                  return this.replace(this.currentLocale(key), params);
                };
                Lang2.prototype.replace = function(str, params) {
                  return str.replace(/\{(\d+)\}/g, function(match, index2) {
                    return String(params[+index2]);
                  });
                };
                Lang2.property = "lang";
                return Lang2;
              }(_service__WEBPACK_IMPORTED_MODULE_0__["Service"])
            );
          }
        ),
        /***/
        "./src/services/presets/index.ts": (
          /*!***************************************!*\
            !*** ./src/services/presets/index.ts ***!
            \***************************************/
          /*! exports provided: Presets */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Presets", function() {
              return Presets;
            });
            var _presets_default__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../presets/default */
              "./src/presets/default/index.ts"
            );
            var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/console */
              "./src/util/console.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../service */
              "./src/services/service/index.ts"
            );
            var __extends2 = function() {
              var _extendStatics = function extendStatics2(d2, b) {
                _extendStatics = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function(d3, b2) {
                  d3.__proto__ = b2;
                } || function(d3, b2) {
                  for (var p in b2) {
                    if (Object.prototype.hasOwnProperty.call(b2, p))
                      d3[p] = b2[p];
                  }
                };
                return _extendStatics(d2, b);
              };
              return function(d2, b) {
                if (typeof b !== "function" && b !== null)
                  throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                _extendStatics(d2, b);
                function __() {
                  this.constructor = d2;
                }
                d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
              };
            }();
            var __rest = function(s2, e) {
              var t3 = {};
              for (var p in s2) {
                if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
                  t3[p] = s2[p];
              }
              if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
                for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
                  if (e.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
                    t3[p[i2]] = s2[p[i2]];
                }
              return t3;
            };
            var Presets = (
              /** @class */
              function(_super) {
                __extends2(Presets2, _super);
                function Presets2(parentPreset, parent2) {
                  var _this2 = _super.call(this) || this;
                  var defaultPreset = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["mergeDeep"])({}, _presets_default__WEBPACK_IMPORTED_MODULE_0__["preset"]);
                  var userPreset = parent2.userPreset;
                  var _a2 = userPreset.preset, globalPreset = _a2 === void 0 ? {} : _a2, preset = __rest(userPreset, ["preset"]);
                  if (globalPreset.preset != null) {
                    Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleWarn"])("Global presets do not support the **preset** option, it can be safely omitted");
                  }
                  parent2.preset = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["mergeDeep"])(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["mergeDeep"])(defaultPreset, globalPreset), preset);
                  return _this2;
                }
                Presets2.property = "presets";
                return Presets2;
              }(_service__WEBPACK_IMPORTED_MODULE_3__["Service"])
            );
          }
        ),
        /***/
        "./src/services/service/index.ts": (
          /*!***************************************!*\
            !*** ./src/services/service/index.ts ***!
            \***************************************/
          /*! exports provided: Service */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Service", function() {
              return Service;
            });
            var Service = (
              /** @class */
              function() {
                function Service2() {
                  this.framework = {};
                }
                Service2.prototype.init = function(root2, ssrContext) {
                };
                return Service2;
              }()
            );
          }
        ),
        /***/
        "./src/services/theme/index.ts": (
          /*!*************************************!*\
            !*** ./src/services/theme/index.ts ***!
            \*************************************/
          /*! exports provided: Theme */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Theme", function() {
              return Theme;
            });
            var _service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../service */
              "./src/services/service/index.ts"
            );
            var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./utils */
              "./src/services/theme/utils.ts"
            );
            var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_3___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_3__);
            var __extends2 = function() {
              var _extendStatics = function extendStatics2(d2, b) {
                _extendStatics = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function(d3, b2) {
                  d3.__proto__ = b2;
                } || function(d3, b2) {
                  for (var p in b2) {
                    if (Object.prototype.hasOwnProperty.call(b2, p))
                      d3[p] = b2[p];
                  }
                };
                return _extendStatics(d2, b);
              };
              return function(d2, b) {
                if (typeof b !== "function" && b !== null)
                  throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                _extendStatics(d2, b);
                function __() {
                  this.constructor = d2;
                }
                d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
              };
            }();
            var Theme = (
              /** @class */
              function(_super) {
                __extends2(Theme2, _super);
                function Theme2(preset) {
                  var _this2 = _super.call(this) || this;
                  _this2.disabled = false;
                  _this2.isDark = null;
                  _this2.unwatch = null;
                  _this2.vueMeta = null;
                  var _a2 = preset[Theme2.property], dark = _a2.dark, disable = _a2.disable, options = _a2.options, themes = _a2.themes;
                  _this2.dark = Boolean(dark);
                  _this2.defaults = _this2.themes = themes;
                  _this2.options = options;
                  if (disable) {
                    _this2.disabled = true;
                    return _this2;
                  }
                  _this2.themes = {
                    dark: _this2.fillVariant(themes.dark, true),
                    light: _this2.fillVariant(themes.light, false)
                  };
                  return _this2;
                }
                Object.defineProperty(Theme2.prototype, "css", {
                  // When setting css, check for element and apply new values
                  /* eslint-disable-next-line accessor-pairs */
                  set: function set2(val) {
                    if (this.vueMeta) {
                      if (this.isVueMeta23) {
                        this.applyVueMeta23();
                      }
                      return;
                    }
                    this.checkOrCreateStyleElement() && (this.styleEl.innerHTML = val);
                  },
                  enumerable: false,
                  configurable: true
                });
                Object.defineProperty(Theme2.prototype, "dark", {
                  get: function get5() {
                    return Boolean(this.isDark);
                  },
                  set: function set2(val) {
                    var oldDark = this.isDark;
                    this.isDark = val;
                    oldDark != null && this.applyTheme();
                  },
                  enumerable: false,
                  configurable: true
                });
                Theme2.prototype.applyTheme = function() {
                  if (this.disabled)
                    return this.clearCss();
                  this.css = this.generatedStyles;
                };
                Theme2.prototype.clearCss = function() {
                  this.css = "";
                };
                Theme2.prototype.init = function(root2, ssrContext) {
                  if (this.disabled)
                    return;
                  if (root2.$meta) {
                    this.initVueMeta(root2);
                  } else if (ssrContext) {
                    this.initSSR(ssrContext);
                  }
                  this.initTheme(root2);
                };
                Theme2.prototype.setTheme = function(theme, value) {
                  this.themes[theme] = Object.assign(this.themes[theme], value);
                  this.applyTheme();
                };
                Theme2.prototype.resetThemes = function() {
                  this.themes.light = Object.assign({}, this.defaults.light);
                  this.themes.dark = Object.assign({}, this.defaults.dark);
                  this.applyTheme();
                };
                Theme2.prototype.checkOrCreateStyleElement = function() {
                  this.styleEl = document.getElementById("vuetify-theme-stylesheet");
                  if (this.styleEl)
                    return true;
                  this.genStyleElement();
                  return Boolean(this.styleEl);
                };
                Theme2.prototype.fillVariant = function(theme, dark) {
                  if (theme === void 0) {
                    theme = {};
                  }
                  var defaultTheme = this.themes[dark ? "dark" : "light"];
                  return Object.assign({}, defaultTheme, theme);
                };
                Theme2.prototype.genStyleElement = function() {
                  if (typeof document === "undefined")
                    return;
                  this.styleEl = document.createElement("style");
                  this.styleEl.type = "text/css";
                  this.styleEl.id = "vuetify-theme-stylesheet";
                  if (this.options.cspNonce) {
                    this.styleEl.setAttribute("nonce", this.options.cspNonce);
                  }
                  document.head.appendChild(this.styleEl);
                };
                Theme2.prototype.initVueMeta = function(root2) {
                  var _this2 = this;
                  this.vueMeta = root2.$meta();
                  if (this.isVueMeta23) {
                    root2.$nextTick(function() {
                      _this2.applyVueMeta23();
                    });
                    return;
                  }
                  var metaKeyName = typeof this.vueMeta.getOptions === "function" ? this.vueMeta.getOptions().keyName : "metaInfo";
                  var metaInfo = root2.$options[metaKeyName] || {};
                  root2.$options[metaKeyName] = function() {
                    metaInfo.style = metaInfo.style || [];
                    var vuetifyStylesheet = metaInfo.style.find(function(s2) {
                      return s2.id === "vuetify-theme-stylesheet";
                    });
                    if (!vuetifyStylesheet) {
                      metaInfo.style.push({
                        cssText: _this2.generatedStyles,
                        type: "text/css",
                        id: "vuetify-theme-stylesheet",
                        nonce: (_this2.options || {}).cspNonce
                      });
                    } else {
                      vuetifyStylesheet.cssText = _this2.generatedStyles;
                    }
                    return metaInfo;
                  };
                };
                Theme2.prototype.applyVueMeta23 = function() {
                  var set2 = this.vueMeta.addApp("vuetify").set;
                  set2({
                    style: [{
                      cssText: this.generatedStyles,
                      type: "text/css",
                      id: "vuetify-theme-stylesheet",
                      nonce: this.options.cspNonce
                    }]
                  });
                };
                Theme2.prototype.initSSR = function(ssrContext) {
                  var nonce = this.options.cspNonce ? ' nonce="' + this.options.cspNonce + '"' : "";
                  ssrContext.head = ssrContext.head || "";
                  ssrContext.head += '<style type="text/css" id="vuetify-theme-stylesheet"' + nonce + ">" + this.generatedStyles + "</style>";
                };
                Theme2.prototype.initTheme = function(root2) {
                  var _this2 = this;
                  if (typeof document === "undefined")
                    return;
                  if (this.unwatch) {
                    this.unwatch();
                    this.unwatch = null;
                  }
                  root2.$once("hook:created", function() {
                    var obs = vue__WEBPACK_IMPORTED_MODULE_3___default.a.observable({
                      themes: _this2.themes
                    });
                    _this2.unwatch = root2.$watch(function() {
                      return obs.themes;
                    }, function() {
                      return _this2.applyTheme();
                    }, {
                      deep: true
                    });
                  });
                  this.applyTheme();
                };
                Object.defineProperty(Theme2.prototype, "currentTheme", {
                  get: function get5() {
                    var target2 = this.dark ? "dark" : "light";
                    return this.themes[target2];
                  },
                  enumerable: false,
                  configurable: true
                });
                Object.defineProperty(Theme2.prototype, "generatedStyles", {
                  get: function get5() {
                    var theme = this.parsedTheme;
                    var options = this.options || {};
                    var css2;
                    if (options.themeCache != null) {
                      css2 = options.themeCache.get(theme);
                      if (css2 != null)
                        return css2;
                    }
                    css2 = _utils__WEBPACK_IMPORTED_MODULE_1__["genStyles"](theme, options.customProperties);
                    if (options.minifyTheme != null) {
                      css2 = options.minifyTheme(css2);
                    }
                    if (options.themeCache != null) {
                      options.themeCache.set(theme, css2);
                    }
                    return css2;
                  },
                  enumerable: false,
                  configurable: true
                });
                Object.defineProperty(Theme2.prototype, "parsedTheme", {
                  get: function get5() {
                    return _utils__WEBPACK_IMPORTED_MODULE_1__["parse"](this.currentTheme || {}, void 0, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["getNestedValue"])(this.options, ["variations"], true));
                  },
                  enumerable: false,
                  configurable: true
                });
                Object.defineProperty(Theme2.prototype, "isVueMeta23", {
                  // Is using v2.3 of vue-meta
                  // https://github.com/nuxt/vue-meta/releases/tag/v2.3.0
                  get: function get5() {
                    return typeof this.vueMeta.addApp === "function";
                  },
                  enumerable: false,
                  configurable: true
                });
                Theme2.property = "theme";
                return Theme2;
              }(_service__WEBPACK_IMPORTED_MODULE_0__["Service"])
            );
          }
        ),
        /***/
        "./src/services/theme/utils.ts": (
          /*!*************************************!*\
            !*** ./src/services/theme/utils.ts ***!
            \*************************************/
          /*! exports provided: parse, genStyles, genVariations, lighten, darken */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "parse", function() {
              return parse2;
            });
            __webpack_require__.d(__webpack_exports__, "genStyles", function() {
              return genStyles;
            });
            __webpack_require__.d(__webpack_exports__, "genVariations", function() {
              return genVariations;
            });
            __webpack_require__.d(__webpack_exports__, "lighten", function() {
              return lighten;
            });
            __webpack_require__.d(__webpack_exports__, "darken", function() {
              return darken;
            });
            var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var _util_colorUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ../../util/colorUtils */
              "./src/util/colorUtils.ts"
            );
            var _util_color_transformSRGB__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ../../util/color/transformSRGB */
              "./src/util/color/transformSRGB.ts"
            );
            var _util_color_transformCIELAB__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
              /*! ../../util/color/transformCIELAB */
              "./src/util/color/transformCIELAB.ts"
            );
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __rest = function(s2, e) {
              var t3 = {};
              for (var p in s2) {
                if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
                  t3[p] = s2[p];
              }
              if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
                for (var i2 = 0, p = Object.getOwnPropertySymbols(s2); i2 < p.length; i2++) {
                  if (e.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i2]))
                    t3[p[i2]] = s2[p[i2]];
                }
              return t3;
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            function parse2(theme, isItem, variations) {
              if (isItem === void 0) {
                isItem = false;
              }
              if (variations === void 0) {
                variations = true;
              }
              var anchor = theme.anchor, variant = __rest(theme, ["anchor"]);
              var colors = Object.keys(variant);
              var parsedTheme = {};
              for (var i2 = 0; i2 < colors.length; ++i2) {
                var name = colors[i2];
                var value = theme[name];
                if (value == null)
                  continue;
                if (!variations) {
                  parsedTheme[name] = {
                    base: Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_1__["intToHex"])(Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_1__["colorToInt"])(value))
                  };
                } else if (isItem) {
                  if (name === "base" || name.startsWith("lighten") || name.startsWith("darken")) {
                    parsedTheme[name] = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_1__["colorToHex"])(value);
                  }
                } else if (_typeof2(value) === "object") {
                  parsedTheme[name] = parse2(value, true, variations);
                } else {
                  parsedTheme[name] = genVariations(name, Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_1__["colorToInt"])(value));
                }
              }
              if (!isItem) {
                parsedTheme.anchor = anchor || parsedTheme.base || parsedTheme.primary.base;
              }
              return parsedTheme;
            }
            var genBaseColor = function genBaseColor2(name, value) {
              return "\n.v-application ." + name + " {\n  background-color: " + value + " !important;\n  border-color: " + value + " !important;\n}\n.v-application ." + name + "--text {\n  color: " + value + " !important;\n  caret-color: " + value + " !important;\n}";
            };
            var genVariantColor = function genVariantColor2(name, variant, value) {
              var _a2 = __read2(variant.split(/(\d)/, 2), 2), type = _a2[0], n2 = _a2[1];
              return "\n.v-application ." + name + "." + type + "-" + n2 + " {\n  background-color: " + value + " !important;\n  border-color: " + value + " !important;\n}\n.v-application ." + name + "--text.text--" + type + "-" + n2 + " {\n  color: " + value + " !important;\n  caret-color: " + value + " !important;\n}";
            };
            var genColorVariableName = function genColorVariableName2(name, variant) {
              if (variant === void 0) {
                variant = "base";
              }
              return "--v-" + name + "-" + variant;
            };
            var genColorVariable = function genColorVariable2(name, variant) {
              if (variant === void 0) {
                variant = "base";
              }
              return "var(" + genColorVariableName(name, variant) + ")";
            };
            function genStyles(theme, cssVar) {
              if (cssVar === void 0) {
                cssVar = false;
              }
              var anchor = theme.anchor, variant = __rest(theme, ["anchor"]);
              var colors = Object.keys(variant);
              if (!colors.length)
                return "";
              var variablesCss = "";
              var css2 = "";
              var aColor = cssVar ? genColorVariable("anchor") : anchor;
              css2 += ".v-application a { color: " + aColor + "; }";
              cssVar && (variablesCss += "  " + genColorVariableName("anchor") + ": " + anchor + ";\n");
              for (var i2 = 0; i2 < colors.length; ++i2) {
                var name = colors[i2];
                var value = theme[name];
                css2 += genBaseColor(name, cssVar ? genColorVariable(name) : value.base);
                cssVar && (variablesCss += "  " + genColorVariableName(name) + ": " + value.base + ";\n");
                var variants = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["keys"])(value);
                for (var i_1 = 0; i_1 < variants.length; ++i_1) {
                  var variant_1 = variants[i_1];
                  var variantValue = value[variant_1];
                  if (variant_1 === "base")
                    continue;
                  css2 += genVariantColor(name, variant_1, cssVar ? genColorVariable(name, variant_1) : variantValue);
                  cssVar && (variablesCss += "  " + genColorVariableName(name, variant_1) + ": " + variantValue + ";\n");
                }
              }
              if (cssVar) {
                variablesCss = ":root {\n" + variablesCss + "}\n\n";
              }
              return variablesCss + css2;
            }
            function genVariations(name, value) {
              var values2 = {
                base: Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_1__["intToHex"])(value)
              };
              for (var i2 = 5; i2 > 0; --i2) {
                values2["lighten" + i2] = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_1__["intToHex"])(lighten(value, i2));
              }
              for (var i2 = 1; i2 <= 4; ++i2) {
                values2["darken" + i2] = Object(_util_colorUtils__WEBPACK_IMPORTED_MODULE_1__["intToHex"])(darken(value, i2));
              }
              return values2;
            }
            function lighten(value, amount) {
              var lab = _util_color_transformCIELAB__WEBPACK_IMPORTED_MODULE_3__["fromXYZ"](_util_color_transformSRGB__WEBPACK_IMPORTED_MODULE_2__["toXYZ"](value));
              lab[0] = lab[0] + amount * 10;
              return _util_color_transformSRGB__WEBPACK_IMPORTED_MODULE_2__["fromXYZ"](_util_color_transformCIELAB__WEBPACK_IMPORTED_MODULE_3__["toXYZ"](lab));
            }
            function darken(value, amount) {
              var lab = _util_color_transformCIELAB__WEBPACK_IMPORTED_MODULE_3__["fromXYZ"](_util_color_transformSRGB__WEBPACK_IMPORTED_MODULE_2__["toXYZ"](value));
              lab[0] = lab[0] - amount * 10;
              return _util_color_transformSRGB__WEBPACK_IMPORTED_MODULE_2__["fromXYZ"](_util_color_transformCIELAB__WEBPACK_IMPORTED_MODULE_3__["toXYZ"](lab));
            }
          }
        ),
        /***/
        "./src/styles/components/_selection-controls.sass": (
          /*!********************************************************!*\
            !*** ./src/styles/components/_selection-controls.sass ***!
            \********************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/styles/main.sass": (
          /*!******************************!*\
            !*** ./src/styles/main.sass ***!
            \******************************/
          /*! no static exports found */
          /***/
          function(module2, exports2, __webpack_require__) {
          }
        ),
        /***/
        "./src/util/color/transformCIELAB.ts": (
          /*!*******************************************!*\
            !*** ./src/util/color/transformCIELAB.ts ***!
            \*******************************************/
          /*! exports provided: fromXYZ, toXYZ */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "fromXYZ", function() {
              return fromXYZ;
            });
            __webpack_require__.d(__webpack_exports__, "toXYZ", function() {
              return toXYZ;
            });
            var delta = 0.20689655172413793;
            var cielabForwardTransform = function cielabForwardTransform2(t3) {
              return t3 > Math.pow(delta, 3) ? Math.cbrt(t3) : t3 / (3 * Math.pow(delta, 2)) + 4 / 29;
            };
            var cielabReverseTransform = function cielabReverseTransform2(t3) {
              return t3 > delta ? Math.pow(t3, 3) : 3 * Math.pow(delta, 2) * (t3 - 4 / 29);
            };
            function fromXYZ(xyz) {
              var transform = cielabForwardTransform;
              var transformedY = transform(xyz[1]);
              return [116 * transformedY - 16, 500 * (transform(xyz[0] / 0.95047) - transformedY), 200 * (transformedY - transform(xyz[2] / 1.08883))];
            }
            function toXYZ(lab) {
              var transform = cielabReverseTransform;
              var Ln = (lab[0] + 16) / 116;
              return [transform(Ln + lab[1] / 500) * 0.95047, transform(Ln), transform(Ln - lab[2] / 200) * 1.08883];
            }
          }
        ),
        /***/
        "./src/util/color/transformSRGB.ts": (
          /*!*****************************************!*\
            !*** ./src/util/color/transformSRGB.ts ***!
            \*****************************************/
          /*! exports provided: fromXYZ, toXYZ */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "fromXYZ", function() {
              return fromXYZ;
            });
            __webpack_require__.d(__webpack_exports__, "toXYZ", function() {
              return toXYZ;
            });
            var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../../util/helpers */
              "./src/util/helpers.ts"
            );
            var srgbForwardMatrix = [[3.2406, -1.5372, -0.4986], [-0.9689, 1.8758, 0.0415], [0.0557, -0.204, 1.057]];
            var srgbForwardTransform = function srgbForwardTransform2(C) {
              return C <= 31308e-7 ? C * 12.92 : 1.055 * Math.pow(C, 1 / 2.4) - 0.055;
            };
            var srgbReverseMatrix = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]];
            var srgbReverseTransform = function srgbReverseTransform2(C) {
              return C <= 0.04045 ? C / 12.92 : Math.pow((C + 0.055) / 1.055, 2.4);
            };
            function fromXYZ(xyz) {
              var rgb = Array(3);
              var transform = srgbForwardTransform;
              var matrix2 = srgbForwardMatrix;
              for (var i2 = 0; i2 < 3; ++i2) {
                rgb[i2] = Math.round(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["clamp"])(transform(matrix2[i2][0] * xyz[0] + matrix2[i2][1] * xyz[1] + matrix2[i2][2] * xyz[2])) * 255);
              }
              return (rgb[0] << 16) + (rgb[1] << 8) + (rgb[2] << 0);
            }
            function toXYZ(rgb) {
              var xyz = [0, 0, 0];
              var transform = srgbReverseTransform;
              var matrix2 = srgbReverseMatrix;
              var r = transform((rgb >> 16 & 255) / 255);
              var g = transform((rgb >> 8 & 255) / 255);
              var b = transform((rgb >> 0 & 255) / 255);
              for (var i2 = 0; i2 < 3; ++i2) {
                xyz[i2] = matrix2[i2][0] * r + matrix2[i2][1] * g + matrix2[i2][2] * b;
              }
              return xyz;
            }
          }
        ),
        /***/
        "./src/util/colorUtils.ts": (
          /*!********************************!*\
            !*** ./src/util/colorUtils.ts ***!
            \********************************/
          /*! exports provided: isCssColor, colorToInt, classToHex, intToHex, colorToHex, HSVAtoRGBA, RGBAtoHSVA, HSVAtoHSLA, HSLAtoHSVA, RGBAtoCSS, RGBtoCSS, RGBAtoHex, HexToRGBA, HexToHSVA, HSVAtoHex, parseHex, parseGradient, RGBtoInt, contrastRatio */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "isCssColor", function() {
              return isCssColor;
            });
            __webpack_require__.d(__webpack_exports__, "colorToInt", function() {
              return colorToInt;
            });
            __webpack_require__.d(__webpack_exports__, "classToHex", function() {
              return classToHex;
            });
            __webpack_require__.d(__webpack_exports__, "intToHex", function() {
              return intToHex;
            });
            __webpack_require__.d(__webpack_exports__, "colorToHex", function() {
              return colorToHex;
            });
            __webpack_require__.d(__webpack_exports__, "HSVAtoRGBA", function() {
              return HSVAtoRGBA;
            });
            __webpack_require__.d(__webpack_exports__, "RGBAtoHSVA", function() {
              return RGBAtoHSVA;
            });
            __webpack_require__.d(__webpack_exports__, "HSVAtoHSLA", function() {
              return HSVAtoHSLA;
            });
            __webpack_require__.d(__webpack_exports__, "HSLAtoHSVA", function() {
              return HSLAtoHSVA;
            });
            __webpack_require__.d(__webpack_exports__, "RGBAtoCSS", function() {
              return RGBAtoCSS;
            });
            __webpack_require__.d(__webpack_exports__, "RGBtoCSS", function() {
              return RGBtoCSS;
            });
            __webpack_require__.d(__webpack_exports__, "RGBAtoHex", function() {
              return RGBAtoHex;
            });
            __webpack_require__.d(__webpack_exports__, "HexToRGBA", function() {
              return HexToRGBA;
            });
            __webpack_require__.d(__webpack_exports__, "HexToHSVA", function() {
              return HexToHSVA;
            });
            __webpack_require__.d(__webpack_exports__, "HSVAtoHex", function() {
              return HSVAtoHex;
            });
            __webpack_require__.d(__webpack_exports__, "parseHex", function() {
              return parseHex;
            });
            __webpack_require__.d(__webpack_exports__, "parseGradient", function() {
              return parseGradient;
            });
            __webpack_require__.d(__webpack_exports__, "RGBtoInt", function() {
              return RGBtoInt;
            });
            __webpack_require__.d(__webpack_exports__, "contrastRatio", function() {
              return contrastRatio;
            });
            var _console__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./console */
              "./src/util/console.ts"
            );
            var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
              /*! ./helpers */
              "./src/util/helpers.ts"
            );
            var _color_transformSRGB__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
              /*! ./color/transformSRGB */
              "./src/util/color/transformSRGB.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            function isCssColor(color2) {
              return !!color2 && !!color2.match(/^(#|var\(--|(rgb|hsl)a?\()/);
            }
            function colorToInt(color2) {
              var rgb;
              if (typeof color2 === "number") {
                rgb = color2;
              } else if (typeof color2 === "string") {
                var c = color2[0] === "#" ? color2.substring(1) : color2;
                if (c.length === 3) {
                  c = c.split("").map(function(char) {
                    return char + char;
                  }).join("");
                }
                if (c.length !== 6) {
                  Object(_console__WEBPACK_IMPORTED_MODULE_0__["consoleWarn"])("'" + color2 + "' is not a valid rgb color");
                }
                rgb = parseInt(c, 16);
              } else {
                throw new TypeError("Colors can only be numbers or strings, recieved " + (color2 == null ? color2 : color2.constructor.name) + " instead");
              }
              if (rgb < 0) {
                Object(_console__WEBPACK_IMPORTED_MODULE_0__["consoleWarn"])("Colors cannot be negative: '" + color2 + "'");
                rgb = 0;
              } else if (rgb > 16777215 || isNaN(rgb)) {
                Object(_console__WEBPACK_IMPORTED_MODULE_0__["consoleWarn"])("'" + color2 + "' is not a valid rgb color");
                rgb = 16777215;
              }
              return rgb;
            }
            function classToHex(color2, colors, currentTheme) {
              var _a2 = __read2(color2.toString().trim().replace("-", "").split(" ", 2), 2), colorName2 = _a2[0], colorModifier = _a2[1];
              var hexColor = "";
              if (colorName2 && colorName2 in colors) {
                if (colorModifier && colorModifier in colors[colorName2]) {
                  hexColor = colors[colorName2][colorModifier];
                } else if ("base" in colors[colorName2]) {
                  hexColor = colors[colorName2].base;
                }
              } else if (colorName2 && colorName2 in currentTheme) {
                hexColor = currentTheme[colorName2];
              }
              return hexColor;
            }
            function intToHex(color2) {
              var hexColor = color2.toString(16);
              if (hexColor.length < 6)
                hexColor = "0".repeat(6 - hexColor.length) + hexColor;
              return "#" + hexColor;
            }
            function colorToHex(color2) {
              return intToHex(colorToInt(color2));
            }
            function HSVAtoRGBA(hsva) {
              var h = hsva.h, s2 = hsva.s, v = hsva.v, a = hsva.a;
              var f = function f2(n2) {
                var k = (n2 + h / 60) % 6;
                return v - v * s2 * Math.max(Math.min(k, 4 - k, 1), 0);
              };
              var rgb = [f(5), f(3), f(1)].map(function(v2) {
                return Math.round(v2 * 255);
              });
              return {
                r: rgb[0],
                g: rgb[1],
                b: rgb[2],
                a
              };
            }
            function RGBAtoHSVA(rgba) {
              if (!rgba)
                return {
                  h: 0,
                  s: 1,
                  v: 1,
                  a: 1
                };
              var r = rgba.r / 255;
              var g = rgba.g / 255;
              var b = rgba.b / 255;
              var max2 = Math.max(r, g, b);
              var min2 = Math.min(r, g, b);
              var h = 0;
              if (max2 !== min2) {
                if (max2 === r) {
                  h = 60 * (0 + (g - b) / (max2 - min2));
                } else if (max2 === g) {
                  h = 60 * (2 + (b - r) / (max2 - min2));
                } else if (max2 === b) {
                  h = 60 * (4 + (r - g) / (max2 - min2));
                }
              }
              if (h < 0)
                h = h + 360;
              var s2 = max2 === 0 ? 0 : (max2 - min2) / max2;
              var hsv = [h, s2, max2];
              return {
                h: hsv[0],
                s: hsv[1],
                v: hsv[2],
                a: rgba.a
              };
            }
            function HSVAtoHSLA(hsva) {
              var h = hsva.h, s2 = hsva.s, v = hsva.v, a = hsva.a;
              var l = v - v * s2 / 2;
              var sprime = l === 1 || l === 0 ? 0 : (v - l) / Math.min(l, 1 - l);
              return {
                h,
                s: sprime,
                l,
                a
              };
            }
            function HSLAtoHSVA(hsl) {
              var h = hsl.h, s2 = hsl.s, l = hsl.l, a = hsl.a;
              var v = l + s2 * Math.min(l, 1 - l);
              var sprime = v === 0 ? 0 : 2 - 2 * l / v;
              return {
                h,
                s: sprime,
                v,
                a
              };
            }
            function RGBAtoCSS(rgba) {
              return "rgba(" + rgba.r + ", " + rgba.g + ", " + rgba.b + ", " + rgba.a + ")";
            }
            function RGBtoCSS(rgba) {
              return RGBAtoCSS(__assign2(__assign2({}, rgba), {
                a: 1
              }));
            }
            function RGBAtoHex(rgba) {
              var toHex2 = function toHex3(v) {
                var h = Math.round(v).toString(16);
                return ("00".substr(0, 2 - h.length) + h).toUpperCase();
              };
              return "#" + [toHex2(rgba.r), toHex2(rgba.g), toHex2(rgba.b), toHex2(Math.round(rgba.a * 255))].join("");
            }
            function HexToRGBA(hex) {
              var rgba = Object(_helpers__WEBPACK_IMPORTED_MODULE_1__["chunk"])(hex.slice(1), 2).map(function(c) {
                return parseInt(c, 16);
              });
              return {
                r: rgba[0],
                g: rgba[1],
                b: rgba[2],
                a: Math.round(rgba[3] / 255 * 100) / 100
              };
            }
            function HexToHSVA(hex) {
              var rgb = HexToRGBA(hex);
              return RGBAtoHSVA(rgb);
            }
            function HSVAtoHex(hsva) {
              return RGBAtoHex(HSVAtoRGBA(hsva));
            }
            function parseHex(hex) {
              if (hex.startsWith("#")) {
                hex = hex.slice(1);
              }
              hex = hex.replace(/([^0-9a-f])/gi, "F");
              if (hex.length === 3 || hex.length === 4) {
                hex = hex.split("").map(function(x2) {
                  return x2 + x2;
                }).join("");
              }
              if (hex.length === 6) {
                hex = Object(_helpers__WEBPACK_IMPORTED_MODULE_1__["padEnd"])(hex, 8, "F");
              } else {
                hex = Object(_helpers__WEBPACK_IMPORTED_MODULE_1__["padEnd"])(Object(_helpers__WEBPACK_IMPORTED_MODULE_1__["padEnd"])(hex, 6), 8, "F");
              }
              return ("#" + hex).toUpperCase().substr(0, 9);
            }
            function parseGradient(gradient, colors, currentTheme) {
              return gradient.replace(/([a-z]+(\s[a-z]+-[1-5])?)(?=$|,)/gi, function(x2) {
                return classToHex(x2, colors, currentTheme) || x2;
              }).replace(/(rgba\()#[0-9a-f]+(?=,)/gi, function(x2) {
                return "rgba(" + Object.values(HexToRGBA(parseHex(x2.replace(/rgba\(/, "")))).slice(0, 3).join(",");
              });
            }
            function RGBtoInt(rgba) {
              return (rgba.r << 16) + (rgba.g << 8) + rgba.b;
            }
            function contrastRatio(c1, c2) {
              var _a2 = __read2(Object(_color_transformSRGB__WEBPACK_IMPORTED_MODULE_2__["toXYZ"])(RGBtoInt(c1)), 2), y1 = _a2[1];
              var _b2 = __read2(Object(_color_transformSRGB__WEBPACK_IMPORTED_MODULE_2__["toXYZ"])(RGBtoInt(c2)), 2), y2 = _b2[1];
              return (Math.max(y1, y2) + 0.05) / (Math.min(y1, y2) + 0.05);
            }
          }
        ),
        /***/
        "./src/util/colors.ts": (
          /*!****************************!*\
            !*** ./src/util/colors.ts ***!
            \****************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            var red = Object.freeze({
              base: "#f44336",
              lighten5: "#ffebee",
              lighten4: "#ffcdd2",
              lighten3: "#ef9a9a",
              lighten2: "#e57373",
              lighten1: "#ef5350",
              darken1: "#e53935",
              darken2: "#d32f2f",
              darken3: "#c62828",
              darken4: "#b71c1c",
              accent1: "#ff8a80",
              accent2: "#ff5252",
              accent3: "#ff1744",
              accent4: "#d50000"
            });
            var pink = Object.freeze({
              base: "#e91e63",
              lighten5: "#fce4ec",
              lighten4: "#f8bbd0",
              lighten3: "#f48fb1",
              lighten2: "#f06292",
              lighten1: "#ec407a",
              darken1: "#d81b60",
              darken2: "#c2185b",
              darken3: "#ad1457",
              darken4: "#880e4f",
              accent1: "#ff80ab",
              accent2: "#ff4081",
              accent3: "#f50057",
              accent4: "#c51162"
            });
            var purple = Object.freeze({
              base: "#9c27b0",
              lighten5: "#f3e5f5",
              lighten4: "#e1bee7",
              lighten3: "#ce93d8",
              lighten2: "#ba68c8",
              lighten1: "#ab47bc",
              darken1: "#8e24aa",
              darken2: "#7b1fa2",
              darken3: "#6a1b9a",
              darken4: "#4a148c",
              accent1: "#ea80fc",
              accent2: "#e040fb",
              accent3: "#d500f9",
              accent4: "#aa00ff"
            });
            var deepPurple = Object.freeze({
              base: "#673ab7",
              lighten5: "#ede7f6",
              lighten4: "#d1c4e9",
              lighten3: "#b39ddb",
              lighten2: "#9575cd",
              lighten1: "#7e57c2",
              darken1: "#5e35b1",
              darken2: "#512da8",
              darken3: "#4527a0",
              darken4: "#311b92",
              accent1: "#b388ff",
              accent2: "#7c4dff",
              accent3: "#651fff",
              accent4: "#6200ea"
            });
            var indigo = Object.freeze({
              base: "#3f51b5",
              lighten5: "#e8eaf6",
              lighten4: "#c5cae9",
              lighten3: "#9fa8da",
              lighten2: "#7986cb",
              lighten1: "#5c6bc0",
              darken1: "#3949ab",
              darken2: "#303f9f",
              darken3: "#283593",
              darken4: "#1a237e",
              accent1: "#8c9eff",
              accent2: "#536dfe",
              accent3: "#3d5afe",
              accent4: "#304ffe"
            });
            var blue = Object.freeze({
              base: "#2196f3",
              lighten5: "#e3f2fd",
              lighten4: "#bbdefb",
              lighten3: "#90caf9",
              lighten2: "#64b5f6",
              lighten1: "#42a5f5",
              darken1: "#1e88e5",
              darken2: "#1976d2",
              darken3: "#1565c0",
              darken4: "#0d47a1",
              accent1: "#82b1ff",
              accent2: "#448aff",
              accent3: "#2979ff",
              accent4: "#2962ff"
            });
            var lightBlue = Object.freeze({
              base: "#03a9f4",
              lighten5: "#e1f5fe",
              lighten4: "#b3e5fc",
              lighten3: "#81d4fa",
              lighten2: "#4fc3f7",
              lighten1: "#29b6f6",
              darken1: "#039be5",
              darken2: "#0288d1",
              darken3: "#0277bd",
              darken4: "#01579b",
              accent1: "#80d8ff",
              accent2: "#40c4ff",
              accent3: "#00b0ff",
              accent4: "#0091ea"
            });
            var cyan = Object.freeze({
              base: "#00bcd4",
              lighten5: "#e0f7fa",
              lighten4: "#b2ebf2",
              lighten3: "#80deea",
              lighten2: "#4dd0e1",
              lighten1: "#26c6da",
              darken1: "#00acc1",
              darken2: "#0097a7",
              darken3: "#00838f",
              darken4: "#006064",
              accent1: "#84ffff",
              accent2: "#18ffff",
              accent3: "#00e5ff",
              accent4: "#00b8d4"
            });
            var teal = Object.freeze({
              base: "#009688",
              lighten5: "#e0f2f1",
              lighten4: "#b2dfdb",
              lighten3: "#80cbc4",
              lighten2: "#4db6ac",
              lighten1: "#26a69a",
              darken1: "#00897b",
              darken2: "#00796b",
              darken3: "#00695c",
              darken4: "#004d40",
              accent1: "#a7ffeb",
              accent2: "#64ffda",
              accent3: "#1de9b6",
              accent4: "#00bfa5"
            });
            var green = Object.freeze({
              base: "#4caf50",
              lighten5: "#e8f5e9",
              lighten4: "#c8e6c9",
              lighten3: "#a5d6a7",
              lighten2: "#81c784",
              lighten1: "#66bb6a",
              darken1: "#43a047",
              darken2: "#388e3c",
              darken3: "#2e7d32",
              darken4: "#1b5e20",
              accent1: "#b9f6ca",
              accent2: "#69f0ae",
              accent3: "#00e676",
              accent4: "#00c853"
            });
            var lightGreen = Object.freeze({
              base: "#8bc34a",
              lighten5: "#f1f8e9",
              lighten4: "#dcedc8",
              lighten3: "#c5e1a5",
              lighten2: "#aed581",
              lighten1: "#9ccc65",
              darken1: "#7cb342",
              darken2: "#689f38",
              darken3: "#558b2f",
              darken4: "#33691e",
              accent1: "#ccff90",
              accent2: "#b2ff59",
              accent3: "#76ff03",
              accent4: "#64dd17"
            });
            var lime = Object.freeze({
              base: "#cddc39",
              lighten5: "#f9fbe7",
              lighten4: "#f0f4c3",
              lighten3: "#e6ee9c",
              lighten2: "#dce775",
              lighten1: "#d4e157",
              darken1: "#c0ca33",
              darken2: "#afb42b",
              darken3: "#9e9d24",
              darken4: "#827717",
              accent1: "#f4ff81",
              accent2: "#eeff41",
              accent3: "#c6ff00",
              accent4: "#aeea00"
            });
            var yellow = Object.freeze({
              base: "#ffeb3b",
              lighten5: "#fffde7",
              lighten4: "#fff9c4",
              lighten3: "#fff59d",
              lighten2: "#fff176",
              lighten1: "#ffee58",
              darken1: "#fdd835",
              darken2: "#fbc02d",
              darken3: "#f9a825",
              darken4: "#f57f17",
              accent1: "#ffff8d",
              accent2: "#ffff00",
              accent3: "#ffea00",
              accent4: "#ffd600"
            });
            var amber = Object.freeze({
              base: "#ffc107",
              lighten5: "#fff8e1",
              lighten4: "#ffecb3",
              lighten3: "#ffe082",
              lighten2: "#ffd54f",
              lighten1: "#ffca28",
              darken1: "#ffb300",
              darken2: "#ffa000",
              darken3: "#ff8f00",
              darken4: "#ff6f00",
              accent1: "#ffe57f",
              accent2: "#ffd740",
              accent3: "#ffc400",
              accent4: "#ffab00"
            });
            var orange = Object.freeze({
              base: "#ff9800",
              lighten5: "#fff3e0",
              lighten4: "#ffe0b2",
              lighten3: "#ffcc80",
              lighten2: "#ffb74d",
              lighten1: "#ffa726",
              darken1: "#fb8c00",
              darken2: "#f57c00",
              darken3: "#ef6c00",
              darken4: "#e65100",
              accent1: "#ffd180",
              accent2: "#ffab40",
              accent3: "#ff9100",
              accent4: "#ff6d00"
            });
            var deepOrange = Object.freeze({
              base: "#ff5722",
              lighten5: "#fbe9e7",
              lighten4: "#ffccbc",
              lighten3: "#ffab91",
              lighten2: "#ff8a65",
              lighten1: "#ff7043",
              darken1: "#f4511e",
              darken2: "#e64a19",
              darken3: "#d84315",
              darken4: "#bf360c",
              accent1: "#ff9e80",
              accent2: "#ff6e40",
              accent3: "#ff3d00",
              accent4: "#dd2c00"
            });
            var brown = Object.freeze({
              base: "#795548",
              lighten5: "#efebe9",
              lighten4: "#d7ccc8",
              lighten3: "#bcaaa4",
              lighten2: "#a1887f",
              lighten1: "#8d6e63",
              darken1: "#6d4c41",
              darken2: "#5d4037",
              darken3: "#4e342e",
              darken4: "#3e2723"
            });
            var blueGrey = Object.freeze({
              base: "#607d8b",
              lighten5: "#eceff1",
              lighten4: "#cfd8dc",
              lighten3: "#b0bec5",
              lighten2: "#90a4ae",
              lighten1: "#78909c",
              darken1: "#546e7a",
              darken2: "#455a64",
              darken3: "#37474f",
              darken4: "#263238"
            });
            var grey = Object.freeze({
              base: "#9e9e9e",
              lighten5: "#fafafa",
              lighten4: "#f5f5f5",
              lighten3: "#eeeeee",
              lighten2: "#e0e0e0",
              lighten1: "#bdbdbd",
              darken1: "#757575",
              darken2: "#616161",
              darken3: "#424242",
              darken4: "#212121"
            });
            var shades = Object.freeze({
              black: "#000000",
              white: "#ffffff",
              transparent: "transparent"
            });
            __webpack_exports__["default"] = Object.freeze({
              red,
              pink,
              purple,
              deepPurple,
              indigo,
              blue,
              lightBlue,
              cyan,
              teal,
              green,
              lightGreen,
              lime,
              yellow,
              amber,
              orange,
              deepOrange,
              brown,
              blueGrey,
              grey,
              shades
            });
          }
        ),
        /***/
        "./src/util/console.ts": (
          /*!*****************************!*\
            !*** ./src/util/console.ts ***!
            \*****************************/
          /*! exports provided: consoleInfo, consoleWarn, consoleError, deprecate, breaking, removed */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "consoleInfo", function() {
              return consoleInfo;
            });
            __webpack_require__.d(__webpack_exports__, "consoleWarn", function() {
              return consoleWarn;
            });
            __webpack_require__.d(__webpack_exports__, "consoleError", function() {
              return consoleError;
            });
            __webpack_require__.d(__webpack_exports__, "deprecate", function() {
              return deprecate;
            });
            __webpack_require__.d(__webpack_exports__, "breaking", function() {
              return breaking;
            });
            __webpack_require__.d(__webpack_exports__, "removed", function() {
              return removed;
            });
            var _framework__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ../framework */
              "./src/framework.ts"
            );
            function createMessage(message, vm, parent2) {
              if (_framework__WEBPACK_IMPORTED_MODULE_0__["default"].config.silent)
                return;
              if (parent2) {
                vm = {
                  _isVue: true,
                  $parent: parent2,
                  $options: vm
                };
              }
              if (vm) {
                vm.$_alreadyWarned = vm.$_alreadyWarned || [];
                if (vm.$_alreadyWarned.includes(message))
                  return;
                vm.$_alreadyWarned.push(message);
              }
              return "[Vuetify] " + message + (vm ? generateComponentTrace(vm) : "");
            }
            function consoleInfo(message, vm, parent2) {
              var newMessage = createMessage(message, vm, parent2);
              newMessage != null && console.info(newMessage);
            }
            function consoleWarn(message, vm, parent2) {
              var newMessage = createMessage(message, vm, parent2);
              newMessage != null && console.warn(newMessage);
            }
            function consoleError(message, vm, parent2) {
              var newMessage = createMessage(message, vm, parent2);
              newMessage != null && console.error(newMessage);
            }
            function deprecate(original, replacement, vm, parent2) {
              consoleWarn("[UPGRADE] '" + original + "' is deprecated, use '" + replacement + "' instead.", vm, parent2);
            }
            function breaking(original, replacement, vm, parent2) {
              consoleError("[BREAKING] '" + original + "' has been removed, use '" + replacement + "' instead. For more information, see the upgrade guide https://github.com/vuetifyjs/vuetify/releases/tag/v2.0.0#user-content-upgrade-guide", vm, parent2);
            }
            function removed(original, vm, parent2) {
              consoleWarn("[REMOVED] '" + original + "' has been removed. You can safely omit it.", vm, parent2);
            }
            var classifyRE = /(?:^|[-_])(\w)/g;
            var classify = function classify2(str) {
              return str.replace(classifyRE, function(c) {
                return c.toUpperCase();
              }).replace(/[-_]/g, "");
            };
            function formatComponentName(vm, includeFile) {
              if (vm.$root === vm) {
                return "<Root>";
              }
              var options = typeof vm === "function" && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm || {};
              var name = options.name || options._componentTag;
              var file = options.__file;
              if (!name && file) {
                var match = file.match(/([^/\\]+)\.vue$/);
                name = match && match[1];
              }
              return (name ? "<" + classify(name) + ">" : "<Anonymous>") + (file && includeFile !== false ? " at " + file : "");
            }
            function generateComponentTrace(vm) {
              if (vm._isVue && vm.$parent) {
                var tree = [];
                var currentRecursiveSequence = 0;
                while (vm) {
                  if (tree.length > 0) {
                    var last2 = tree[tree.length - 1];
                    if (last2.constructor === vm.constructor) {
                      currentRecursiveSequence++;
                      vm = vm.$parent;
                      continue;
                    } else if (currentRecursiveSequence > 0) {
                      tree[tree.length - 1] = [last2, currentRecursiveSequence];
                      currentRecursiveSequence = 0;
                    }
                  }
                  tree.push(vm);
                  vm = vm.$parent;
                }
                return "\n\nfound in\n\n" + tree.map(function(vm2, i2) {
                  return "" + (i2 === 0 ? "---> " : " ".repeat(5 + i2 * 2)) + (Array.isArray(vm2) ? formatComponentName(vm2[0]) + "... (" + vm2[1] + " recursive calls)" : formatComponentName(vm2));
                }).join("\n");
              } else {
                return "\n\n(found in " + formatComponentName(vm) + ")";
              }
            }
          }
        ),
        /***/
        "./src/util/dateTimeUtils.ts": (
          /*!***********************************!*\
            !*** ./src/util/dateTimeUtils.ts ***!
            \***********************************/
          /*! exports provided: weekNumber, isLeapYear */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "weekNumber", function() {
              return weekNumber;
            });
            __webpack_require__.d(__webpack_exports__, "isLeapYear", function() {
              return isLeapYear;
            });
            function createUTCDate(year, month, day) {
              if (month === void 0) {
                month = 0;
              }
              if (day === void 0) {
                day = 1;
              }
              var date;
              if (year < 100 && year >= 0) {
                date = new Date(Date.UTC(year, month, day));
                if (isFinite(date.getUTCFullYear())) {
                  date.setUTCFullYear(year);
                }
              } else {
                date = new Date(Date.UTC(year, month, day));
              }
              return date;
            }
            function firstWeekOffset(year, firstDayOfWeek, firstDayOfYear) {
              var firstWeekDayInFirstWeek = 7 + firstDayOfWeek - firstDayOfYear;
              var firstWeekDayOfYear = (7 + createUTCDate(year, 0, firstWeekDayInFirstWeek).getUTCDay() - firstDayOfWeek) % 7;
              return -firstWeekDayOfYear + firstWeekDayInFirstWeek - 1;
            }
            function dayOfYear(year, month, day, firstDayOfWeek) {
              var dayOfYear2 = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334][month];
              if (month > 1 && isLeapYear(year)) {
                dayOfYear2++;
              }
              return dayOfYear2 + day;
            }
            function weeksInYear(year, firstDayOfWeek, firstDayOfYear) {
              var weekOffset = firstWeekOffset(year, firstDayOfWeek, firstDayOfYear);
              var weekOffsetNext = firstWeekOffset(year + 1, firstDayOfWeek, firstDayOfYear);
              var daysInYear = isLeapYear(year) ? 366 : 365;
              return (daysInYear - weekOffset + weekOffsetNext) / 7;
            }
            function weekNumber(year, month, day, firstDayOfWeek, localeFirstDayOfYear) {
              var weekOffset = firstWeekOffset(year, firstDayOfWeek, localeFirstDayOfYear);
              var week = Math.ceil((dayOfYear(year, month, day) - weekOffset) / 7);
              if (week < 1) {
                return week + weeksInYear(year - 1, firstDayOfWeek, localeFirstDayOfYear);
              } else if (week > weeksInYear(year, firstDayOfWeek, localeFirstDayOfYear)) {
                return week - weeksInYear(year, firstDayOfWeek, localeFirstDayOfYear);
              } else {
                return week;
              }
            }
            function isLeapYear(year) {
              return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
            }
          }
        ),
        /***/
        "./src/util/dedupeModelListeners.ts": (
          /*!******************************************!*\
            !*** ./src/util/dedupeModelListeners.ts ***!
            \******************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", function() {
              return dedupeModelListeners;
            });
            function dedupeModelListeners(data) {
              if (data.model && data.on && data.on.input) {
                if (Array.isArray(data.on.input)) {
                  var i2 = data.on.input.indexOf(data.model.callback);
                  if (i2 > -1)
                    data.on.input.splice(i2, 1);
                } else {
                  delete data.on.input;
                }
              }
            }
          }
        ),
        /***/
        "./src/util/dom.ts": (
          /*!*************************!*\
            !*** ./src/util/dom.ts ***!
            \*************************/
          /*! exports provided: attachedRoot */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "attachedRoot", function() {
              return attachedRoot;
            });
            function attachedRoot(node2) {
              if (typeof node2.getRootNode !== "function") {
                while (node2.parentNode) {
                  node2 = node2.parentNode;
                }
                if (node2 !== document)
                  return null;
                return document;
              }
              var root2 = node2.getRootNode();
              if (root2 !== document && root2.getRootNode({
                composed: true
              }) !== document)
                return null;
              return root2;
            }
          }
        ),
        /***/
        "./src/util/helpers.ts": (
          /*!*****************************!*\
            !*** ./src/util/helpers.ts ***!
            \*****************************/
          /*! exports provided: createSimpleFunctional, directiveConfig, addOnceEventListener, passiveSupported, addPassiveEventListener, getNestedValue, deepEqual, getObjectValueByPath, getPropertyFromItem, createRange, getZIndex, filterObjectOnKeys, convertToUnit, kebabCase, isObject, keyCodes, remapInternalIcon, keys, camelize, arrayDiff, upperFirst, groupItems, wrapInArray, sortItems, defaultFilter, searchItems, getSlotType, debounce, throttle, getPrefixedScopedSlots, getSlot, clamp, padEnd, chunk, humanReadableFileSize, camelizeObjectKeys, mergeDeep, fillArray, composedPath */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "createSimpleFunctional", function() {
              return createSimpleFunctional;
            });
            __webpack_require__.d(__webpack_exports__, "directiveConfig", function() {
              return directiveConfig;
            });
            __webpack_require__.d(__webpack_exports__, "addOnceEventListener", function() {
              return addOnceEventListener;
            });
            __webpack_require__.d(__webpack_exports__, "passiveSupported", function() {
              return passiveSupported;
            });
            __webpack_require__.d(__webpack_exports__, "addPassiveEventListener", function() {
              return addPassiveEventListener;
            });
            __webpack_require__.d(__webpack_exports__, "getNestedValue", function() {
              return getNestedValue;
            });
            __webpack_require__.d(__webpack_exports__, "deepEqual", function() {
              return deepEqual2;
            });
            __webpack_require__.d(__webpack_exports__, "getObjectValueByPath", function() {
              return getObjectValueByPath;
            });
            __webpack_require__.d(__webpack_exports__, "getPropertyFromItem", function() {
              return getPropertyFromItem;
            });
            __webpack_require__.d(__webpack_exports__, "createRange", function() {
              return createRange;
            });
            __webpack_require__.d(__webpack_exports__, "getZIndex", function() {
              return getZIndex;
            });
            __webpack_require__.d(__webpack_exports__, "filterObjectOnKeys", function() {
              return filterObjectOnKeys;
            });
            __webpack_require__.d(__webpack_exports__, "convertToUnit", function() {
              return convertToUnit;
            });
            __webpack_require__.d(__webpack_exports__, "kebabCase", function() {
              return kebabCase;
            });
            __webpack_require__.d(__webpack_exports__, "isObject", function() {
              return isObject2;
            });
            __webpack_require__.d(__webpack_exports__, "keyCodes", function() {
              return keyCodes;
            });
            __webpack_require__.d(__webpack_exports__, "remapInternalIcon", function() {
              return remapInternalIcon;
            });
            __webpack_require__.d(__webpack_exports__, "keys", function() {
              return keys2;
            });
            __webpack_require__.d(__webpack_exports__, "camelize", function() {
              return camelize2;
            });
            __webpack_require__.d(__webpack_exports__, "arrayDiff", function() {
              return arrayDiff;
            });
            __webpack_require__.d(__webpack_exports__, "upperFirst", function() {
              return upperFirst;
            });
            __webpack_require__.d(__webpack_exports__, "groupItems", function() {
              return groupItems;
            });
            __webpack_require__.d(__webpack_exports__, "wrapInArray", function() {
              return wrapInArray;
            });
            __webpack_require__.d(__webpack_exports__, "sortItems", function() {
              return sortItems;
            });
            __webpack_require__.d(__webpack_exports__, "defaultFilter", function() {
              return defaultFilter;
            });
            __webpack_require__.d(__webpack_exports__, "searchItems", function() {
              return searchItems;
            });
            __webpack_require__.d(__webpack_exports__, "getSlotType", function() {
              return getSlotType;
            });
            __webpack_require__.d(__webpack_exports__, "debounce", function() {
              return debounce;
            });
            __webpack_require__.d(__webpack_exports__, "throttle", function() {
              return throttle2;
            });
            __webpack_require__.d(__webpack_exports__, "getPrefixedScopedSlots", function() {
              return getPrefixedScopedSlots;
            });
            __webpack_require__.d(__webpack_exports__, "getSlot", function() {
              return getSlot;
            });
            __webpack_require__.d(__webpack_exports__, "clamp", function() {
              return clamp2;
            });
            __webpack_require__.d(__webpack_exports__, "padEnd", function() {
              return padEnd;
            });
            __webpack_require__.d(__webpack_exports__, "chunk", function() {
              return chunk2;
            });
            __webpack_require__.d(__webpack_exports__, "humanReadableFileSize", function() {
              return humanReadableFileSize;
            });
            __webpack_require__.d(__webpack_exports__, "camelizeObjectKeys", function() {
              return camelizeObjectKeys;
            });
            __webpack_require__.d(__webpack_exports__, "mergeDeep", function() {
              return mergeDeep;
            });
            __webpack_require__.d(__webpack_exports__, "fillArray", function() {
              return fillArray;
            });
            __webpack_require__.d(__webpack_exports__, "composedPath", function() {
              return composedPath;
            });
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            function _typeof2(obj) {
              "@babel/helpers - typeof";
              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof2 = function _typeof3(obj2) {
                  return typeof obj2;
                };
              } else {
                _typeof2 = function _typeof3(obj2) {
                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
                };
              }
              return _typeof2(obj);
            }
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var __spreadArray2 = function(to, from, pack) {
              if (pack || arguments.length === 2)
                for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
                  if (ar || !(i2 in from)) {
                    if (!ar)
                      ar = Array.prototype.slice.call(from, 0, i2);
                    ar[i2] = from[i2];
                  }
                }
              return to.concat(ar || Array.prototype.slice.call(from));
            };
            function createSimpleFunctional(c, el, name) {
              if (el === void 0) {
                el = "div";
              }
              return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
                name: name || c.replace(/__/g, "-"),
                functional: true,
                props: {
                  tag: {
                    type: String,
                    default: el
                  }
                },
                render: function render8(h, _a2) {
                  var data = _a2.data, props2 = _a2.props, children = _a2.children;
                  data.staticClass = (c + " " + (data.staticClass || "")).trim();
                  return h(props2.tag, data, children);
                }
              });
            }
            function directiveConfig(binding, defaults2) {
              if (defaults2 === void 0) {
                defaults2 = {};
              }
              return __assign2(__assign2(__assign2(__assign2({}, defaults2), binding.modifiers), {
                value: binding.arg
              }), binding.value || {});
            }
            function addOnceEventListener(el, eventName, cb, options) {
              if (options === void 0) {
                options = false;
              }
              var once2 = function once3(event) {
                cb(event);
                el.removeEventListener(eventName, once3, options);
              };
              el.addEventListener(eventName, once2, options);
            }
            var passiveSupported = false;
            try {
              if (typeof window !== "undefined") {
                var testListenerOpts = Object.defineProperty({}, "passive", {
                  get: function get5() {
                    passiveSupported = true;
                  }
                });
                window.addEventListener("testListener", testListenerOpts, testListenerOpts);
                window.removeEventListener("testListener", testListenerOpts, testListenerOpts);
              }
            } catch (e) {
              console.warn(e);
            }
            function addPassiveEventListener(el, event, cb, options) {
              el.addEventListener(event, cb, passiveSupported ? options : false);
            }
            function getNestedValue(obj, path, fallback) {
              var last2 = path.length - 1;
              if (last2 < 0)
                return obj === void 0 ? fallback : obj;
              for (var i2 = 0; i2 < last2; i2++) {
                if (obj == null) {
                  return fallback;
                }
                obj = obj[path[i2]];
              }
              if (obj == null)
                return fallback;
              return obj[path[last2]] === void 0 ? fallback : obj[path[last2]];
            }
            function deepEqual2(a, b) {
              if (a === b)
                return true;
              if (a instanceof Date && b instanceof Date && a.getTime() !== b.getTime()) {
                return false;
              }
              if (a !== Object(a) || b !== Object(b)) {
                return false;
              }
              var props2 = Object.keys(a);
              if (props2.length !== Object.keys(b).length) {
                return false;
              }
              return props2.every(function(p) {
                return deepEqual2(a[p], b[p]);
              });
            }
            function getObjectValueByPath(obj, path, fallback) {
              if (obj == null || !path || typeof path !== "string")
                return fallback;
              if (obj[path] !== void 0)
                return obj[path];
              path = path.replace(/\[(\w+)\]/g, ".$1");
              path = path.replace(/^\./, "");
              return getNestedValue(obj, path.split("."), fallback);
            }
            function getPropertyFromItem(item, property2, fallback) {
              if (property2 == null)
                return item === void 0 ? fallback : item;
              if (item !== Object(item))
                return fallback === void 0 ? item : fallback;
              if (typeof property2 === "string")
                return getObjectValueByPath(item, property2, fallback);
              if (Array.isArray(property2))
                return getNestedValue(item, property2, fallback);
              if (typeof property2 !== "function")
                return fallback;
              var value = property2(item, fallback);
              return typeof value === "undefined" ? fallback : value;
            }
            function createRange(length) {
              return Array.from({
                length
              }, function(v, k) {
                return k;
              });
            }
            function getZIndex(el) {
              if (!el || el.nodeType !== Node.ELEMENT_NODE)
                return 0;
              var index2 = +window.getComputedStyle(el).getPropertyValue("z-index");
              if (!index2)
                return getZIndex(el.parentNode);
              return index2;
            }
            function filterObjectOnKeys(obj, keys3) {
              var filtered = {};
              for (var i2 = 0; i2 < keys3.length; i2++) {
                var key = keys3[i2];
                if (typeof obj[key] !== "undefined") {
                  filtered[key] = obj[key];
                }
              }
              return filtered;
            }
            function convertToUnit(str, unit) {
              if (unit === void 0) {
                unit = "px";
              }
              if (str == null || str === "") {
                return void 0;
              } else if (isNaN(+str)) {
                return String(str);
              } else {
                return "" + Number(str) + unit;
              }
            }
            function kebabCase(str) {
              return (str || "").replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
            }
            function isObject2(obj) {
              return obj !== null && _typeof2(obj) === "object";
            }
            var keyCodes = Object.freeze({
              enter: 13,
              tab: 9,
              delete: 46,
              esc: 27,
              space: 32,
              up: 38,
              down: 40,
              left: 37,
              right: 39,
              end: 35,
              home: 36,
              del: 46,
              backspace: 8,
              insert: 45,
              pageup: 33,
              pagedown: 34,
              shift: 16
            });
            function remapInternalIcon(vm, iconName) {
              var component = vm.$vuetify.icons.component;
              if (iconName.startsWith("$")) {
                var iconPath = "$vuetify.icons.values." + iconName.split("$").pop().split(".").pop();
                var override = getObjectValueByPath(vm, iconPath, iconName);
                if (typeof override === "string")
                  iconName = override;
                else
                  return override;
              }
              if (component == null) {
                return iconName;
              }
              return {
                component,
                props: {
                  icon: iconName
                }
              };
            }
            function keys2(o) {
              return Object.keys(o);
            }
            var camelizeRE2 = /-(\w)/g;
            var camelize2 = function camelize3(str) {
              return str.replace(camelizeRE2, function(_, c) {
                return c ? c.toUpperCase() : "";
              });
            };
            function arrayDiff(a, b) {
              var diff = [];
              for (var i2 = 0; i2 < b.length; i2++) {
                if (a.indexOf(b[i2]) < 0)
                  diff.push(b[i2]);
              }
              return diff;
            }
            function upperFirst(str) {
              return str.charAt(0).toUpperCase() + str.slice(1);
            }
            function groupItems(items, groupBy, groupDesc) {
              var key = groupBy[0];
              var groups = [];
              var current;
              for (var i2 = 0; i2 < items.length; i2++) {
                var item = items[i2];
                var val = getObjectValueByPath(item, key, null);
                if (current !== val) {
                  current = val;
                  groups.push({
                    name: val !== null && val !== void 0 ? val : "",
                    items: []
                  });
                }
                groups[groups.length - 1].items.push(item);
              }
              return groups;
            }
            function wrapInArray(v) {
              return v != null ? Array.isArray(v) ? v : [v] : [];
            }
            function sortItems(items, sortBy, sortDesc, locale, customSorters) {
              if (sortBy === null || !sortBy.length)
                return items;
              var stringCollator = new Intl.Collator(locale, {
                sensitivity: "accent",
                usage: "sort"
              });
              return items.sort(function(a, b) {
                var _a2, _b2;
                for (var i2 = 0; i2 < sortBy.length; i2++) {
                  var sortKey = sortBy[i2];
                  var sortA = getObjectValueByPath(a, sortKey);
                  var sortB = getObjectValueByPath(b, sortKey);
                  if (sortDesc[i2]) {
                    _a2 = __read2([sortB, sortA], 2), sortA = _a2[0], sortB = _a2[1];
                  }
                  if (customSorters && customSorters[sortKey]) {
                    var customResult = customSorters[sortKey](sortA, sortB);
                    if (!customResult)
                      continue;
                    return customResult;
                  }
                  if (sortA === null && sortB === null) {
                    continue;
                  }
                  if (sortA instanceof Date && sortB instanceof Date) {
                    return sortA.getTime() - sortB.getTime();
                  }
                  _b2 = __read2([sortA, sortB].map(function(s2) {
                    return (s2 || "").toString().toLocaleLowerCase();
                  }), 2), sortA = _b2[0], sortB = _b2[1];
                  if (sortA !== sortB) {
                    if (!isNaN(sortA) && !isNaN(sortB))
                      return Number(sortA) - Number(sortB);
                    return stringCollator.compare(sortA, sortB);
                  }
                }
                return 0;
              });
            }
            function defaultFilter(value, search, item) {
              return value != null && search != null && typeof value !== "boolean" && value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
            }
            function searchItems(items, search) {
              if (!search)
                return items;
              search = search.toString().toLowerCase();
              if (search.trim() === "")
                return items;
              return items.filter(function(item) {
                return Object.keys(item).some(function(key) {
                  return defaultFilter(getObjectValueByPath(item, key), search);
                });
              });
            }
            function getSlotType(vm, name, split) {
              if (vm.$slots.hasOwnProperty(name) && vm.$scopedSlots.hasOwnProperty(name) && vm.$scopedSlots[name].name) {
                return split ? "v-slot" : "scoped";
              }
              if (vm.$slots.hasOwnProperty(name))
                return "normal";
              if (vm.$scopedSlots.hasOwnProperty(name))
                return "scoped";
            }
            function debounce(fn, delay) {
              var timeoutId = 0;
              return function() {
                var args = [];
                for (var _i2 = 0; _i2 < arguments.length; _i2++) {
                  args[_i2] = arguments[_i2];
                }
                clearTimeout(timeoutId);
                timeoutId = setTimeout(function() {
                  return fn.apply(void 0, __spreadArray2([], __read2(args), false));
                }, delay);
              };
            }
            function throttle2(fn, limit) {
              var throttling = false;
              return function() {
                var args = [];
                for (var _i2 = 0; _i2 < arguments.length; _i2++) {
                  args[_i2] = arguments[_i2];
                }
                if (!throttling) {
                  throttling = true;
                  setTimeout(function() {
                    return throttling = false;
                  }, limit);
                  return fn.apply(void 0, __spreadArray2([], __read2(args), false));
                }
              };
            }
            function getPrefixedScopedSlots(prefix, scopedSlots) {
              return Object.keys(scopedSlots).filter(function(k) {
                return k.startsWith(prefix);
              }).reduce(function(obj, k) {
                obj[k.replace(prefix, "")] = scopedSlots[k];
                return obj;
              }, {});
            }
            function getSlot(vm, name, data, optional) {
              if (name === void 0) {
                name = "default";
              }
              if (optional === void 0) {
                optional = false;
              }
              var kebabName = kebabCase(name);
              if (vm.$scopedSlots.hasOwnProperty(name)) {
                return vm.$scopedSlots[name](data instanceof Function ? data() : data);
              } else if (vm.$scopedSlots.hasOwnProperty(kebabName)) {
                return vm.$scopedSlots[kebabName](data instanceof Function ? data() : data);
              } else if (vm.$slots.hasOwnProperty(name) && (!data || optional)) {
                return vm.$slots[name];
              } else if (vm.$slots.hasOwnProperty(kebabName) && (!data || optional)) {
                return vm.$slots[kebabName];
              }
              return void 0;
            }
            function clamp2(value, min2, max2) {
              if (min2 === void 0) {
                min2 = 0;
              }
              if (max2 === void 0) {
                max2 = 1;
              }
              return Math.max(min2, Math.min(max2, value));
            }
            function padEnd(str, length, char) {
              if (char === void 0) {
                char = "0";
              }
              return str + char.repeat(Math.max(0, length - str.length));
            }
            function chunk2(str, size) {
              if (size === void 0) {
                size = 1;
              }
              var chunked = [];
              var index2 = 0;
              while (index2 < str.length) {
                chunked.push(str.substr(index2, size));
                index2 += size;
              }
              return chunked;
            }
            function humanReadableFileSize(bytes, binary) {
              if (binary === void 0) {
                binary = false;
              }
              var base = binary ? 1024 : 1e3;
              if (bytes < base) {
                return bytes + " B";
              }
              var prefix = binary ? ["Ki", "Mi", "Gi"] : ["k", "M", "G"];
              var unit = -1;
              while (Math.abs(bytes) >= base && unit < prefix.length - 1) {
                bytes /= base;
                ++unit;
              }
              return bytes.toFixed(1) + " " + prefix[unit] + "B";
            }
            function camelizeObjectKeys(obj) {
              if (!obj)
                return {};
              return Object.keys(obj).reduce(function(o, key) {
                o[camelize2(key)] = obj[key];
                return o;
              }, {});
            }
            function mergeDeep(source, target2) {
              if (source === void 0) {
                source = {};
              }
              if (target2 === void 0) {
                target2 = {};
              }
              for (var key in target2) {
                var sourceProperty = source[key];
                var targetProperty = target2[key];
                if (isObject2(sourceProperty) && isObject2(targetProperty)) {
                  source[key] = mergeDeep(sourceProperty, targetProperty);
                  continue;
                }
                source[key] = targetProperty;
              }
              return source;
            }
            function fillArray(length, obj) {
              return Array(length).fill(obj);
            }
            function composedPath(e) {
              if (e.composedPath)
                return e.composedPath();
              var path = [];
              var el = e.target;
              while (el) {
                path.push(el);
                if (el.tagName === "HTML") {
                  path.push(document);
                  path.push(window);
                  return path;
                }
                el = el.parentElement;
              }
              return path;
            }
          }
        ),
        /***/
        "./src/util/mergeData.ts": (
          /*!*******************************!*\
            !*** ./src/util/mergeData.ts ***!
            \*******************************/
          /*! exports provided: default, mergeStyles, mergeClasses, mergeListeners */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", function() {
              return mergeData2;
            });
            __webpack_require__.d(__webpack_exports__, "mergeStyles", function() {
              return mergeStyles;
            });
            __webpack_require__.d(__webpack_exports__, "mergeClasses", function() {
              return mergeClasses;
            });
            __webpack_require__.d(__webpack_exports__, "mergeListeners", function() {
              return mergeListeners;
            });
            var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! ./helpers */
              "./src/util/helpers.ts"
            );
            var __assign2 = function() {
              __assign2 = Object.assign || function(t3) {
                for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
                  s2 = arguments[i2];
                  for (var p in s2) {
                    if (Object.prototype.hasOwnProperty.call(s2, p))
                      t3[p] = s2[p];
                  }
                }
                return t3;
              };
              return __assign2.apply(this, arguments);
            };
            var __values2 = function(o) {
              var s2 = typeof Symbol === "function" && Symbol.iterator, m = s2 && o[s2], i2 = 0;
              if (m)
                return m.call(o);
              if (o && typeof o.length === "number")
                return {
                  next: function next() {
                    if (o && i2 >= o.length)
                      o = void 0;
                    return {
                      value: o && o[i2++],
                      done: !o
                    };
                  }
                };
              throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            var __read2 = function(o, n2) {
              var m = typeof Symbol === "function" && o[Symbol.iterator];
              if (!m)
                return o;
              var i2 = m.call(o), r, ar = [], e;
              try {
                while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done) {
                  ar.push(r.value);
                }
              } catch (error2) {
                e = {
                  error: error2
                };
              } finally {
                try {
                  if (r && !r.done && (m = i2["return"]))
                    m.call(i2);
                } finally {
                  if (e)
                    throw e.error;
                }
              }
              return ar;
            };
            var pattern = {
              styleList: /;(?![^(]*\))/g,
              styleProp: /:(.*)/
            };
            function parseStyle(style2) {
              var e_1, _a2;
              var styleMap = {};
              try {
                for (var _b2 = __values2(style2.split(pattern.styleList)), _c = _b2.next(); !_c.done; _c = _b2.next()) {
                  var s2 = _c.value;
                  var _d2 = __read2(s2.split(pattern.styleProp), 2), key = _d2[0], val = _d2[1];
                  key = key.trim();
                  if (!key) {
                    continue;
                  }
                  if (typeof val === "string") {
                    val = val.trim();
                  }
                  styleMap[Object(_helpers__WEBPACK_IMPORTED_MODULE_0__["camelize"])(key)] = val;
                }
              } catch (e_1_1) {
                e_1 = {
                  error: e_1_1
                };
              } finally {
                try {
                  if (_c && !_c.done && (_a2 = _b2.return))
                    _a2.call(_b2);
                } finally {
                  if (e_1)
                    throw e_1.error;
                }
              }
              return styleMap;
            }
            function mergeData2() {
              var e_2, _a2;
              var mergeTarget = {};
              var i2 = arguments.length;
              var prop;
              while (i2--) {
                try {
                  for (var _b2 = (e_2 = void 0, __values2(Object.keys(arguments[i2]))), _c = _b2.next(); !_c.done; _c = _b2.next()) {
                    prop = _c.value;
                    switch (prop) {
                      case "class":
                      case "directives":
                        if (arguments[i2][prop]) {
                          mergeTarget[prop] = mergeClasses(mergeTarget[prop], arguments[i2][prop]);
                        }
                        break;
                      case "style":
                        if (arguments[i2][prop]) {
                          mergeTarget[prop] = mergeStyles(mergeTarget[prop], arguments[i2][prop]);
                        }
                        break;
                      case "staticClass":
                        if (!arguments[i2][prop]) {
                          break;
                        }
                        if (mergeTarget[prop] === void 0) {
                          mergeTarget[prop] = "";
                        }
                        if (mergeTarget[prop]) {
                          mergeTarget[prop] += " ";
                        }
                        mergeTarget[prop] += arguments[i2][prop].trim();
                        break;
                      case "on":
                      case "nativeOn":
                        if (arguments[i2][prop]) {
                          mergeTarget[prop] = mergeListeners(mergeTarget[prop], arguments[i2][prop]);
                        }
                        break;
                      case "attrs":
                      case "props":
                      case "domProps":
                      case "scopedSlots":
                      case "staticStyle":
                      case "hook":
                      case "transition":
                        if (!arguments[i2][prop]) {
                          break;
                        }
                        if (!mergeTarget[prop]) {
                          mergeTarget[prop] = {};
                        }
                        mergeTarget[prop] = __assign2(__assign2({}, arguments[i2][prop]), mergeTarget[prop]);
                        break;
                      default:
                        if (!mergeTarget[prop]) {
                          mergeTarget[prop] = arguments[i2][prop];
                        }
                    }
                  }
                } catch (e_2_1) {
                  e_2 = {
                    error: e_2_1
                  };
                } finally {
                  try {
                    if (_c && !_c.done && (_a2 = _b2.return))
                      _a2.call(_b2);
                  } finally {
                    if (e_2)
                      throw e_2.error;
                  }
                }
              }
              return mergeTarget;
            }
            function mergeStyles(target2, source) {
              if (!target2)
                return source;
              if (!source)
                return target2;
              target2 = Object(_helpers__WEBPACK_IMPORTED_MODULE_0__["wrapInArray"])(typeof target2 === "string" ? parseStyle(target2) : target2);
              return target2.concat(typeof source === "string" ? parseStyle(source) : source);
            }
            function mergeClasses(target2, source) {
              if (!source)
                return target2;
              if (!target2)
                return source;
              return target2 ? Object(_helpers__WEBPACK_IMPORTED_MODULE_0__["wrapInArray"])(target2).concat(source) : source;
            }
            function mergeListeners() {
              var args = [];
              for (var _i2 = 0; _i2 < arguments.length; _i2++) {
                args[_i2] = arguments[_i2];
              }
              if (!args[0])
                return args[1];
              if (!args[1])
                return args[0];
              var dest = {};
              for (var i2 = 2; i2--; ) {
                var arg = args[i2];
                for (var event in arg) {
                  if (!arg[event])
                    continue;
                  if (dest[event]) {
                    dest[event] = [].concat(arg[event], dest[event]);
                  } else {
                    dest[event] = arg[event];
                  }
                }
              }
              return dest;
            }
          }
        ),
        /***/
        "./src/util/mixins.ts": (
          /*!****************************!*\
            !*** ./src/util/mixins.ts ***!
            \****************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", function() {
              return mixins;
            });
            var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
              /*! vue */
              "vue"
            );
            var vue__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
            function mixins() {
              var args = [];
              for (var _i2 = 0; _i2 < arguments.length; _i2++) {
                args[_i2] = arguments[_i2];
              }
              return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
                mixins: args
              });
            }
          }
        ),
        /***/
        "./src/util/rebuildFunctionalSlots.ts": (
          /*!********************************************!*\
            !*** ./src/util/rebuildFunctionalSlots.ts ***!
            \********************************************/
          /*! exports provided: default */
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "default", function() {
              return rebuildFunctionalSlots;
            });
            function rebuildFunctionalSlots(slots, h) {
              var children = [];
              for (var slot in slots) {
                if (slots.hasOwnProperty(slot)) {
                  children.push(h("template", {
                    slot
                  }, slots[slot]));
                }
              }
              return children;
            }
          }
        ),
        /***/
        "vue": (
          /*!******************************************************************************!*\
            !*** external {"commonjs":"vue","commonjs2":"vue","amd":"vue","root":"Vue"} ***!
            \******************************************************************************/
          /*! no static exports found */
          /***/
          function(module2, exports2) {
            module2.exports = __WEBPACK_EXTERNAL_MODULE_vue__;
          }
        )
        /******/
      })["default"]
    );
  });
})(vuetify);
var vuetifyExports = vuetify.exports;
const Vuetify = /* @__PURE__ */ getDefaultExportFromCjs(vuetifyExports);
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$5(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$5;
var eq$4 = eq_1;
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$4(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data = this.__data__, index2 = assocIndexOf$3(data, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data = this.__data__, index2 = assocIndexOf$2(data, key);
  return index2 < 0 ? void 0 : data[index2][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var ListCache$3 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$3();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data = this.__data__, result2 = data["delete"](key);
  this.size = data.size;
  return result2;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$9 = freeGlobal || freeSelf || Function("return this")();
var _root = root$9;
var root$8 = _root;
var Symbol$7 = root$8.Symbol;
var _Symbol = Symbol$7;
var Symbol$6 = _Symbol;
var objectProto$f = Object.prototype;
var hasOwnProperty$e = objectProto$f.hasOwnProperty;
var nativeObjectToString$1 = objectProto$f.toString;
var symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$e.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result2 = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result2;
}
var _getRawTag = getRawTag$1;
var objectProto$e = Object.prototype;
var nativeObjectToString = objectProto$e.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$5 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$5 ? Symbol$5.toStringTag : void 0;
function baseGetTag$6(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$6;
function isObject$c(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$c;
var baseGetTag$5 = _baseGetTag, isObject$b = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$4(value) {
  if (!isObject$b(value)) {
    return false;
  }
  var tag = baseGetTag$5(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$4;
var root$7 = _root;
var coreJsData$1 = root$7["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid2 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid2 ? "Symbol(src)_1." + uid2 : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$3 = isFunction_1, isMasked = _isMasked, isObject$a = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$d = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$d = objectProto$d.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$d).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject$a(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$3(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$7;
var getNative$6 = _getNative, root$6 = _root;
var Map$4 = getNative$6(root$6, "Map");
var _Map = Map$4;
var getNative$5 = _getNative;
var nativeCreate$4 = getNative$5(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result2 = this.has(key) && delete this.__data__[key];
  this.size -= result2 ? 1 : 0;
  return result2;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$c = Object.prototype;
var hasOwnProperty$c = objectProto$c.hasOwnProperty;
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result2 = data[key];
    return result2 === HASH_UNDEFINED$2 ? void 0 : result2;
  }
  return hasOwnProperty$c.call(data, key) ? data[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$b = Object.prototype;
var hasOwnProperty$b = objectProto$b.hasOwnProperty;
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$b.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
var Hash = _Hash, ListCache$2 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$2)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result2 = getMapData$3(this, key)["delete"](key);
  this.size -= result2 ? 1 : 0;
  return result2;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype["delete"] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;
var ListCache$1 = _ListCache, Map$2 = _Map, MapCache$2 = _MapCache;
var LARGE_ARRAY_SIZE$1 = 200;
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$4(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack$4.prototype.clear = stackClear;
Stack$4.prototype["delete"] = stackDelete;
Stack$4.prototype.get = stackGet;
Stack$4.prototype.has = stackHas;
Stack$4.prototype.set = stackSet;
var _Stack = Stack$4;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache$1 = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$2(values2) {
  var index2 = -1, length = values2 == null ? 0 : values2.length;
  this.__data__ = new MapCache$1();
  while (++index2 < length) {
    this.add(values2[index2]);
  }
}
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;
var _SetCache = SetCache$2;
function arraySome$1(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (predicate(array[index2], index2, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
function cacheHas$2(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$2;
var SetCache$1 = _SetCache, arraySome = _arraySome, cacheHas$1 = _cacheHas;
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache$1() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index2 < arrLength) {
    var arrValue = array[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result2 = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas$1(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result2 = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result2 = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result2;
}
var _equalArrays = equalArrays$2;
var root$5 = _root;
var Uint8Array$3 = root$5.Uint8Array;
var _Uint8Array = Uint8Array$3;
function mapToArray$1(map) {
  var index2 = -1, result2 = Array(map.size);
  map.forEach(function(value, key) {
    result2[++index2] = [key, value];
  });
  return result2;
}
var _mapToArray = mapToArray$1;
function setToArray$3(set2) {
  var index2 = -1, result2 = Array(set2.size);
  set2.forEach(function(value) {
    result2[++index2] = value;
  });
  return result2;
}
var _setToArray = setToArray$3;
var Symbol$4 = _Symbol, Uint8Array$2 = _Uint8Array, eq$3 = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray$2 = _setToArray;
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", symbolTag$3 = "[object Symbol]";
var arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]";
var symbolProto$2 = Symbol$4 ? Symbol$4.prototype : void 0, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$4:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag$3:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;
    case boolTag$3:
    case dateTag$3:
    case numberTag$3:
      return eq$3(+object, +other);
    case errorTag$2:
      return object.name == other.name && object.message == other.message;
    case regexpTag$3:
    case stringTag$3:
      return object == other + "";
    case mapTag$5:
      var convert2 = mapToArray;
    case setTag$5:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert2 || (convert2 = setToArray$2);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object, other);
      var result2 = equalArrays$1(convert2(object), convert2(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result2;
    case symbolTag$3:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
function arrayPush$3(array, values2) {
  var index2 = -1, length = values2.length, offset2 = array.length;
  while (++index2 < length) {
    array[offset2 + index2] = values2[index2];
  }
  return array;
}
var _arrayPush = arrayPush$3;
var isArray$d = Array.isArray;
var isArray_1 = isArray$d;
var arrayPush$2 = _arrayPush, isArray$c = isArray_1;
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result2 = keysFunc(object);
  return isArray$c(object) ? result2 : arrayPush$2(result2, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$2;
function arrayFilter$1(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
  while (++index2 < length) {
    var value = array[index2];
    if (predicate(value, index2, array)) {
      result2[resIndex++] = value;
    }
  }
  return result2;
}
var _arrayFilter = arrayFilter$1;
function stubArray$2() {
  return [];
}
var stubArray_1 = stubArray$2;
var arrayFilter = _arrayFilter, stubArray$1 = stubArray_1;
var objectProto$a = Object.prototype;
var propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};
var _getSymbols = getSymbols$3;
function baseTimes$1(n2, iteratee) {
  var index2 = -1, result2 = Array(n2);
  while (++index2 < n2) {
    result2[index2] = iteratee(index2);
  }
  return result2;
}
var _baseTimes = baseTimes$1;
function isObjectLike$9(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$9;
var baseGetTag$4 = _baseGetTag, isObjectLike$8 = isObjectLike_1;
var argsTag$3 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$8(value) && baseGetTag$4(value) == argsTag$3;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$7 = isObjectLike_1;
var objectProto$9 = Object.prototype;
var hasOwnProperty$a = objectProto$9.hasOwnProperty;
var propertyIsEnumerable = objectProto$9.propertyIsEnumerable;
var isArguments$4 = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$7(value) && hasOwnProperty$a.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
var isArguments_1 = isArguments$4;
var isBuffer$4 = { exports: {} };
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
isBuffer$4.exports;
(function(module, exports) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer2 = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer2;
})(isBuffer$4, isBuffer$4.exports);
var isBufferExports = isBuffer$4.exports;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var _isIndex = isIndex$3;
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength$3(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3;
var baseGetTag$3 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$6 = isObjectLike_1;
var argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", errorTag$1 = "[object Error]", funcTag$1 = "[object Function]", mapTag$4 = "[object Map]", numberTag$2 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$2 = "[object RegExp]", setTag$4 = "[object Set]", stringTag$2 = "[object String]", weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$3 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$2] = typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] = typedArrayTags[weakMapTag$2] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$6(value) && isLength$2(value.length) && !!typedArrayTags[baseGetTag$3(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$3(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$3;
var _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(module, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports;
var baseIsTypedArray = _baseIsTypedArray, baseUnary$2 = _baseUnary, nodeUtil$2 = _nodeUtilExports;
var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;
var isTypedArray$4 = nodeIsTypedArray ? baseUnary$2(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$4;
var baseTimes = _baseTimes, isArguments$3 = isArguments_1, isArray$b = isArray_1, isBuffer$3 = isBufferExports, isIndex$2 = _isIndex, isTypedArray$3 = isTypedArray_1;
var objectProto$8 = Object.prototype;
var hasOwnProperty$9 = objectProto$8.hasOwnProperty;
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$b(value), isArg = !isArr && isArguments$3(value), isBuff = !isArr && !isArg && isBuffer$3(value), isType = !isArr && !isArg && !isBuff && isTypedArray$3(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String) : [], length = result2.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$9.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex$2(key, length)))) {
      result2.push(key);
    }
  }
  return result2;
}
var _arrayLikeKeys = arrayLikeKeys$2;
var objectProto$7 = Object.prototype;
function isPrototype$3(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$7;
  return value === proto;
}
var _isPrototype = isPrototype$3;
function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$2;
var overArg$1 = _overArg;
var nativeKeys$1 = overArg$1(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype$2 = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$6 = Object.prototype;
var hasOwnProperty$8 = objectProto$6.hasOwnProperty;
function baseKeys$1(object) {
  if (!isPrototype$2(object)) {
    return nativeKeys(object);
  }
  var result2 = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$8.call(object, key) && key != "constructor") {
      result2.push(key);
    }
  }
  return result2;
}
var _baseKeys = baseKeys$1;
var isFunction$2 = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$5(value) {
  return value != null && isLength$1(value.length) && !isFunction$2(value);
}
var isArrayLike_1 = isArrayLike$5;
var arrayLikeKeys$1 = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike$4 = isArrayLike_1;
function keys$6(object) {
  return isArrayLike$4(object) ? arrayLikeKeys$1(object) : baseKeys(object);
}
var keys_1 = keys$6;
var baseGetAllKeys$1 = _baseGetAllKeys, getSymbols$2 = _getSymbols, keys$5 = keys_1;
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$5, getSymbols$2);
}
var _getAllKeys = getAllKeys$2;
var getAllKeys$1 = _getAllKeys;
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$5 = Object.prototype;
var hasOwnProperty$7 = objectProto$5.hasOwnProperty;
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys$1(object), objLength = objProps.length, othProps = getAllKeys$1(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$7.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result2 = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result2 = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result2 && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result2 = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result2;
}
var _equalObjects = equalObjects$1;
var getNative$4 = _getNative, root$4 = _root;
var DataView$2 = getNative$4(root$4, "DataView");
var _DataView = DataView$2;
var getNative$3 = _getNative, root$3 = _root;
var Promise$2 = getNative$3(root$3, "Promise");
var _Promise = Promise$2;
var getNative$2 = _getNative, root$2 = _root;
var Set$3 = getNative$2(root$2, "Set");
var _Set = Set$3;
var getNative$1 = _getNative, root$1 = _root;
var WeakMap$2 = getNative$1(root$1, "WeakMap");
var _WeakMap = WeakMap$2;
var DataView$1 = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$2 = _Set, WeakMap$1 = _WeakMap, baseGetTag$2 = _baseGetTag, toSource = _toSource;
var mapTag$3 = "[object Map]", objectTag$3 = "[object Object]", promiseTag = "[object Promise]", setTag$3 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$2 = "[object DataView]";
var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$1);
var getTag$4 = baseGetTag$2;
if (DataView$1 && getTag$4(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2 || Map$1 && getTag$4(new Map$1()) != mapTag$3 || Promise$1 && getTag$4(Promise$1.resolve()) != promiseTag || Set$2 && getTag$4(new Set$2()) != setTag$3 || WeakMap$1 && getTag$4(new WeakMap$1()) != weakMapTag$1) {
  getTag$4 = function(value) {
    var result2 = baseGetTag$2(value), Ctor = result2 == objectTag$3 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$3;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$3;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result2;
  };
}
var _getTag = getTag$4;
var Stack$3 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag$3 = _getTag, isArray$a = isArray_1, isBuffer$2 = isBufferExports, isTypedArray$2 = isTypedArray_1;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", objectTag$2 = "[object Object]";
var objectProto$4 = Object.prototype;
var hasOwnProperty$6 = objectProto$4.hasOwnProperty;
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$a(object), othIsArr = isArray$a(other), objTag = objIsArr ? arrayTag$1 : getTag$3(object), othTag = othIsArr ? arrayTag$1 : getTag$3(other);
  objTag = objTag == argsTag$1 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$2 : othTag;
  var objIsObj = objTag == objectTag$2, othIsObj = othTag == objectTag$2, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$2(object)) {
    if (!isBuffer$2(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$3());
    return objIsArr || isTypedArray$2(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$6.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$6.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$3());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$3());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike$5 = isObjectLike_1;
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike$5(value) && !isObjectLike$5(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}
var _baseIsEqual = baseIsEqual$3;
var baseIsEqual$2 = _baseIsEqual;
function isEqual(value, other) {
  return baseIsEqual$2(value, other);
}
var isEqual_1 = isEqual;
const _isEqual = /* @__PURE__ */ getDefaultExportFromCjs(isEqual_1);
function arrayMap$3(array, iteratee) {
  var index2 = -1, length = array == null ? 0 : array.length, result2 = Array(length);
  while (++index2 < length) {
    result2[index2] = iteratee(array[index2], index2, array);
  }
  return result2;
}
var _arrayMap = arrayMap$3;
function arrayEach$1(array, iteratee) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (iteratee(array[index2], index2, array) === false) {
      break;
    }
  }
  return array;
}
var _arrayEach = arrayEach$1;
var getNative = _getNative;
var defineProperty$2 = function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e) {
  }
}();
var _defineProperty$1 = defineProperty$2;
var defineProperty$1 = _defineProperty$1;
function baseAssignValue$4(object, key, value) {
  if (key == "__proto__" && defineProperty$1) {
    defineProperty$1(object, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object[key] = value;
  }
}
var _baseAssignValue = baseAssignValue$4;
var baseAssignValue$3 = _baseAssignValue, eq$2 = eq_1;
var objectProto$3 = Object.prototype;
var hasOwnProperty$5 = objectProto$3.hasOwnProperty;
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq$2(objValue, value)) || value === void 0 && !(key in object)) {
    baseAssignValue$3(object, key, value);
  }
}
var _assignValue = assignValue$2;
var assignValue$1 = _assignValue, baseAssignValue$2 = _baseAssignValue;
function copyObject$6(source, props2, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index2 = -1, length = props2.length;
  while (++index2 < length) {
    var key = props2[index2];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue$2(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}
var _copyObject = copyObject$6;
var copyObject$5 = _copyObject, keys$4 = keys_1;
function baseAssign$1(object, source) {
  return object && copyObject$5(source, keys$4(source), object);
}
var _baseAssign = baseAssign$1;
function nativeKeysIn$1(object) {
  var result2 = [];
  if (object != null) {
    for (var key in Object(object)) {
      result2.push(key);
    }
  }
  return result2;
}
var _nativeKeysIn = nativeKeysIn$1;
var isObject$9 = isObject_1, isPrototype$1 = _isPrototype, nativeKeysIn = _nativeKeysIn;
var objectProto$2 = Object.prototype;
var hasOwnProperty$4 = objectProto$2.hasOwnProperty;
function baseKeysIn$1(object) {
  if (!isObject$9(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object), result2 = [];
  for (var key in object) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$4.call(object, key)))) {
      result2.push(key);
    }
  }
  return result2;
}
var _baseKeysIn = baseKeysIn$1;
var arrayLikeKeys = _arrayLikeKeys, baseKeysIn = _baseKeysIn, isArrayLike$3 = isArrayLike_1;
function keysIn$5(object) {
  return isArrayLike$3(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
var keysIn_1 = keysIn$5;
var copyObject$4 = _copyObject, keysIn$4 = keysIn_1;
function baseAssignIn$1(object, source) {
  return object && copyObject$4(source, keysIn$4(source), object);
}
var _baseAssignIn = baseAssignIn$1;
var _cloneBuffer = { exports: {} };
_cloneBuffer.exports;
(function(module, exports) {
  var root2 = _root;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer2 = moduleExports ? root2.Buffer : void 0, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : void 0;
  function cloneBuffer2(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result2);
    return result2;
  }
  module.exports = cloneBuffer2;
})(_cloneBuffer, _cloneBuffer.exports);
var _cloneBufferExports = _cloneBuffer.exports;
function copyArray$2(source, array) {
  var index2 = -1, length = source.length;
  array || (array = Array(length));
  while (++index2 < length) {
    array[index2] = source[index2];
  }
  return array;
}
var _copyArray = copyArray$2;
var copyObject$3 = _copyObject, getSymbols$1 = _getSymbols;
function copySymbols$1(source, object) {
  return copyObject$3(source, getSymbols$1(source), object);
}
var _copySymbols = copySymbols$1;
var overArg = _overArg;
var getPrototype$3 = overArg(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$3;
var arrayPush$1 = _arrayPush, getPrototype$2 = _getPrototype, getSymbols = _getSymbols, stubArray = stubArray_1;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result2 = [];
  while (object) {
    arrayPush$1(result2, getSymbols(object));
    object = getPrototype$2(object);
  }
  return result2;
};
var _getSymbolsIn = getSymbolsIn$2;
var copyObject$2 = _copyObject, getSymbolsIn$1 = _getSymbolsIn;
function copySymbolsIn$1(source, object) {
  return copyObject$2(source, getSymbolsIn$1(source), object);
}
var _copySymbolsIn = copySymbolsIn$1;
var baseGetAllKeys = _baseGetAllKeys, getSymbolsIn = _getSymbolsIn, keysIn$3 = keysIn_1;
function getAllKeysIn$2(object) {
  return baseGetAllKeys(object, keysIn$3, getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn$2;
var objectProto$1 = Object.prototype;
var hasOwnProperty$3 = objectProto$1.hasOwnProperty;
function initCloneArray$1(array) {
  var length = array.length, result2 = new array.constructor(length);
  if (length && typeof array[0] == "string" && hasOwnProperty$3.call(array, "index")) {
    result2.index = array.index;
    result2.input = array.input;
  }
  return result2;
}
var _initCloneArray = initCloneArray$1;
var Uint8Array$1 = _Uint8Array;
function cloneArrayBuffer$3(arrayBuffer) {
  var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result2).set(new Uint8Array$1(arrayBuffer));
  return result2;
}
var _cloneArrayBuffer = cloneArrayBuffer$3;
var cloneArrayBuffer$2 = _cloneArrayBuffer;
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var _cloneDataView = cloneDataView$1;
var reFlags = /\w*$/;
function cloneRegExp$1(regexp) {
  var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result2.lastIndex = regexp.lastIndex;
  return result2;
}
var _cloneRegExp = cloneRegExp$1;
var Symbol$3 = _Symbol;
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : void 0, symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function cloneSymbol$1(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
var _cloneSymbol = cloneSymbol$1;
var cloneArrayBuffer$1 = _cloneArrayBuffer;
function cloneTypedArray$2(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var _cloneTypedArray = cloneTypedArray$2;
var cloneArrayBuffer = _cloneArrayBuffer, cloneDataView = _cloneDataView, cloneRegExp = _cloneRegExp, cloneSymbol = _cloneSymbol, cloneTypedArray$1 = _cloneTypedArray;
var boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag$2 = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);
    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);
    case dataViewTag$1:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray$1(object, isDeep);
    case mapTag$2:
      return new Ctor();
    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);
    case regexpTag$1:
      return cloneRegExp(object);
    case setTag$2:
      return new Ctor();
    case symbolTag$2:
      return cloneSymbol(object);
  }
}
var _initCloneByTag = initCloneByTag$1;
var isObject$8 = isObject_1;
var objectCreate = Object.create;
var baseCreate$1 = function() {
  function object() {
  }
  return function(proto) {
    if (!isObject$8(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result2 = new object();
    object.prototype = void 0;
    return result2;
  };
}();
var _baseCreate = baseCreate$1;
var baseCreate = _baseCreate, getPrototype$1 = _getPrototype, isPrototype = _isPrototype;
function initCloneObject$2(object) {
  return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype$1(object)) : {};
}
var _initCloneObject = initCloneObject$2;
var getTag$2 = _getTag, isObjectLike$4 = isObjectLike_1;
var mapTag$1 = "[object Map]";
function baseIsMap$1(value) {
  return isObjectLike$4(value) && getTag$2(value) == mapTag$1;
}
var _baseIsMap = baseIsMap$1;
var baseIsMap = _baseIsMap, baseUnary$1 = _baseUnary, nodeUtil$1 = _nodeUtilExports;
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
var isMap$1 = nodeIsMap ? baseUnary$1(nodeIsMap) : baseIsMap;
var isMap_1 = isMap$1;
var getTag$1 = _getTag, isObjectLike$3 = isObjectLike_1;
var setTag$1 = "[object Set]";
function baseIsSet$1(value) {
  return isObjectLike$3(value) && getTag$1(value) == setTag$1;
}
var _baseIsSet = baseIsSet$1;
var baseIsSet = _baseIsSet, baseUnary = _baseUnary, nodeUtil = _nodeUtilExports;
var nodeIsSet = nodeUtil && nodeUtil.isSet;
var isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var isSet_1 = isSet$1;
var Stack$2 = _Stack, arrayEach = _arrayEach, assignValue = _assignValue, baseAssign = _baseAssign, baseAssignIn = _baseAssignIn, cloneBuffer$1 = _cloneBufferExports, copyArray$1 = _copyArray, copySymbols = _copySymbols, copySymbolsIn = _copySymbolsIn, getAllKeys = _getAllKeys, getAllKeysIn$1 = _getAllKeysIn, getTag = _getTag, initCloneArray = _initCloneArray, initCloneByTag = _initCloneByTag, initCloneObject$1 = _initCloneObject, isArray$9 = isArray_1, isBuffer$1 = isBufferExports, isMap = isMap_1, isObject$7 = isObject_1, isSet = isSet_1, keys$3 = keys_1, keysIn$2 = keysIn_1;
var CLONE_DEEP_FLAG$2 = 1, CLONE_FLAT_FLAG$1 = 2, CLONE_SYMBOLS_FLAG$3 = 4;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag$1 = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag$1 = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag$1] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
function baseClone$3(value, bitmask, customizer, key, object, stack) {
  var result2, isDeep = bitmask & CLONE_DEEP_FLAG$2, isFlat = bitmask & CLONE_FLAT_FLAG$1, isFull = bitmask & CLONE_SYMBOLS_FLAG$3;
  if (customizer) {
    result2 = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result2 !== void 0) {
    return result2;
  }
  if (!isObject$7(value)) {
    return value;
  }
  var isArr = isArray$9(value);
  if (isArr) {
    result2 = initCloneArray(value);
    if (!isDeep) {
      return copyArray$1(value, result2);
    }
  } else {
    var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
    if (isBuffer$1(value)) {
      return cloneBuffer$1(value, isDeep);
    }
    if (tag == objectTag$1 || tag == argsTag || isFunc && !object) {
      result2 = isFlat || isFunc ? {} : initCloneObject$1(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result2 = initCloneByTag(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack$2());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result2);
  if (isSet(value)) {
    value.forEach(function(subValue) {
      result2.add(baseClone$3(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key2) {
      result2.set(key2, baseClone$3(subValue, bitmask, customizer, key2, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn$1 : getAllKeys : isFlat ? keysIn$2 : keys$3;
  var props2 = isArr ? void 0 : keysFunc(value);
  arrayEach(props2 || value, function(subValue, key2) {
    if (props2) {
      key2 = subValue;
      subValue = value[key2];
    }
    assignValue(result2, key2, baseClone$3(subValue, bitmask, customizer, key2, value, stack));
  });
  return result2;
}
var _baseClone = baseClone$3;
var baseGetTag$1 = _baseGetTag, isObjectLike$2 = isObjectLike_1;
var symbolTag = "[object Symbol]";
function isSymbol$4(value) {
  return typeof value == "symbol" || isObjectLike$2(value) && baseGetTag$1(value) == symbolTag;
}
var isSymbol_1 = isSymbol$4;
var isArray$8 = isArray_1, isSymbol$3 = isSymbol_1;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(value, object) {
  if (isArray$8(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey$3;
var MapCache = _MapCache;
var FUNC_ERROR_TEXT = "Expected a function";
function memoize$1(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result2 = func.apply(this, args);
    memoized.cache = cache.set(key, result2) || cache;
    return result2;
  };
  memoized.cache = new (memoize$1.Cache || MapCache)();
  return memoized;
}
memoize$1.Cache = MapCache;
var memoize_1 = memoize$1;
var memoize = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result2 = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result2.cache;
  return result2;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath$1 = memoizeCapped(function(string) {
  var result2 = [];
  if (string.charCodeAt(0) === 46) {
    result2.push("");
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
  });
  return result2;
});
var _stringToPath = stringToPath$1;
var Symbol$2 = _Symbol, arrayMap$2 = _arrayMap, isArray$7 = isArray_1, isSymbol$2 = isSymbol_1;
var INFINITY$3 = 1 / 0;
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString$1(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$7(value)) {
    return arrayMap$2(value, baseToString$1) + "";
  }
  if (isSymbol$2(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result2 = value + "";
  return result2 == "0" && 1 / value == -INFINITY$3 ? "-0" : result2;
}
var _baseToString = baseToString$1;
var baseToString = _baseToString;
function toString$2(value) {
  return value == null ? "" : baseToString(value);
}
var toString_1 = toString$2;
var isArray$6 = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString$1 = toString_1;
function castPath$4(value, object) {
  if (isArray$6(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString$1(value));
}
var _castPath = castPath$4;
function last$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
var last_1 = last$1;
var isSymbol$1 = isSymbol_1;
var INFINITY$2 = 1 / 0;
function toKey$5(value) {
  if (typeof value == "string" || isSymbol$1(value)) {
    return value;
  }
  var result2 = value + "";
  return result2 == "0" && 1 / value == -INFINITY$2 ? "-0" : result2;
}
var _toKey = toKey$5;
var castPath$3 = _castPath, toKey$4 = _toKey;
function baseGet$3(object, path) {
  path = castPath$3(path, object);
  var index2 = 0, length = path.length;
  while (object != null && index2 < length) {
    object = object[toKey$4(path[index2++])];
  }
  return index2 && index2 == length ? object : void 0;
}
var _baseGet = baseGet$3;
function baseSlice$2(array, start, end) {
  var index2 = -1, length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result2 = Array(length);
  while (++index2 < length) {
    result2[index2] = array[index2 + start];
  }
  return result2;
}
var _baseSlice = baseSlice$2;
var baseGet$2 = _baseGet, baseSlice$1 = _baseSlice;
function parent$1(object, path) {
  return path.length < 2 ? object : baseGet$2(object, baseSlice$1(path, 0, -1));
}
var _parent = parent$1;
var castPath$2 = _castPath, last = last_1, parent = _parent, toKey$3 = _toKey;
function baseUnset$1(object, path) {
  path = castPath$2(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey$3(last(path))];
}
var _baseUnset = baseUnset$1;
var baseGetTag = _baseGetTag, getPrototype = _getPrototype, isObjectLike$1 = isObjectLike_1;
var objectTag = "[object Object]";
var funcProto = Function.prototype, objectProto = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$2 = objectProto.hasOwnProperty;
var objectCtorString = funcToString.call(Object);
function isPlainObject$6(value) {
  if (!isObjectLike$1(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$2.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
var isPlainObject_1 = isPlainObject$6;
var isPlainObject$5 = isPlainObject_1;
function customOmitClone$1(value) {
  return isPlainObject$5(value) ? void 0 : value;
}
var _customOmitClone = customOmitClone$1;
var Symbol$1 = _Symbol, isArguments$2 = isArguments_1, isArray$5 = isArray_1;
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable$1(value) {
  return isArray$5(value) || isArguments$2(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
var _isFlattenable = isFlattenable$1;
var arrayPush = _arrayPush, isFlattenable = _isFlattenable;
function baseFlatten$1(array, depth, predicate, isStrict, result2) {
  var index2 = -1, length = array.length;
  predicate || (predicate = isFlattenable);
  result2 || (result2 = []);
  while (++index2 < length) {
    var value = array[index2];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten$1(value, depth - 1, predicate, isStrict, result2);
      } else {
        arrayPush(result2, value);
      }
    } else if (!isStrict) {
      result2[result2.length] = value;
    }
  }
  return result2;
}
var _baseFlatten = baseFlatten$1;
var baseFlatten = _baseFlatten;
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}
var flatten_1 = flatten$1;
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var _apply = apply$1;
var apply = _apply;
var nativeMax$1 = Math.max;
function overRest$2(func, start, transform) {
  start = nativeMax$1(start === void 0 ? func.length - 1 : start, 0);
  return function() {
    var args = arguments, index2 = -1, length = nativeMax$1(args.length - start, 0), array = Array(length);
    while (++index2 < length) {
      array[index2] = args[start + index2];
    }
    index2 = -1;
    var otherArgs = Array(start + 1);
    while (++index2 < start) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}
var _overRest = overRest$2;
function constant$1(value) {
  return function() {
    return value;
  };
}
var constant_1 = constant$1;
function identity$3(value) {
  return value;
}
var identity_1 = identity$3;
var constant = constant_1, defineProperty = _defineProperty$1, identity$2 = identity_1;
var baseSetToString$1 = !defineProperty ? identity$2 : function(func, string) {
  return defineProperty(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string),
    "writable": true
  });
};
var _baseSetToString = baseSetToString$1;
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut$1(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
var _shortOut = shortOut$1;
var baseSetToString = _baseSetToString, shortOut = _shortOut;
var setToString$2 = shortOut(baseSetToString);
var _setToString = setToString$2;
var flatten = flatten_1, overRest$1 = _overRest, setToString$1 = _setToString;
function flatRest$1(func) {
  return setToString$1(overRest$1(func, void 0, flatten), func + "");
}
var _flatRest = flatRest$1;
var arrayMap$1 = _arrayMap, baseClone$2 = _baseClone, baseUnset = _baseUnset, castPath$1 = _castPath, copyObject$1 = _copyObject, customOmitClone = _customOmitClone, flatRest = _flatRest, getAllKeysIn = _getAllKeysIn;
var CLONE_DEEP_FLAG$1 = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$2 = 4;
var omit = flatRest(function(object, paths) {
  var result2 = {};
  if (object == null) {
    return result2;
  }
  var isDeep = false;
  paths = arrayMap$1(paths, function(path) {
    path = castPath$1(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject$1(object, getAllKeysIn(object), result2);
  if (isDeep) {
    result2 = baseClone$2(result2, CLONE_DEEP_FLAG$1 | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG$2, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result2, paths[length]);
  }
  return result2;
});
var omit_1 = omit;
const _omit = /* @__PURE__ */ getDefaultExportFromCjs(omit_1);
function arrayAggregator$1(array, setter, iteratee, accumulator) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    var value = array[index2];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}
var _arrayAggregator = arrayAggregator$1;
function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object), props2 = keysFunc(object), length = props2.length;
    while (length--) {
      var key = props2[fromRight ? length : ++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var _createBaseFor = createBaseFor$1;
var createBaseFor = _createBaseFor;
var baseFor$2 = createBaseFor();
var _baseFor = baseFor$2;
var baseFor$1 = _baseFor, keys$2 = keys_1;
function baseForOwn$1(object, iteratee) {
  return object && baseFor$1(object, iteratee, keys$2);
}
var _baseForOwn = baseForOwn$1;
var isArrayLike$2 = isArrayLike_1;
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$2(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length, index2 = fromRight ? length : -1, iterable = Object(collection);
    while (fromRight ? index2-- : ++index2 < length) {
      if (iteratee(iterable[index2], index2, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var _createBaseEach = createBaseEach$1;
var baseForOwn = _baseForOwn, createBaseEach = _createBaseEach;
var baseEach$1 = createBaseEach(baseForOwn);
var _baseEach = baseEach$1;
var baseEach = _baseEach;
function baseAggregator$1(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection2) {
    setter(accumulator, value, iteratee(value), collection2);
  });
  return accumulator;
}
var _baseAggregator = baseAggregator$1;
var Stack$1 = _Stack, baseIsEqual$1 = _baseIsEqual;
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(object, source, matchData, customizer) {
  var index2 = matchData.length, length = index2, noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index2--) {
    var data = matchData[index2];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index2 < length) {
    data = matchData[index2];
    var key = data[0], objValue = object[key], srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === void 0 && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$1();
      if (customizer) {
        var result2 = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result2 === void 0 ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result2)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;
var isObject$6 = isObject_1;
function isStrictComparable$2(value) {
  return value === value && !isObject$6(value);
}
var _isStrictComparable = isStrictComparable$2;
var isStrictComparable$1 = _isStrictComparable, keys$1 = keys_1;
function getMatchData$1(object) {
  var result2 = keys$1(object), length = result2.length;
  while (length--) {
    var key = result2[length], value = object[key];
    result2[length] = [key, value, isStrictComparable$1(value)];
  }
  return result2;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;
var baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
var _baseMatches = baseMatches$1;
var baseGet$1 = _baseGet;
function get$1(object, path, defaultValue) {
  var result2 = object == null ? void 0 : baseGet$1(object, path);
  return result2 === void 0 ? defaultValue : result2;
}
var get_1 = get$1;
function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}
var _baseHasIn = baseHasIn$1;
var castPath = _castPath, isArguments$1 = isArguments_1, isArray$4 = isArray_1, isIndex$1 = _isIndex, isLength = isLength_1, toKey$2 = _toKey;
function hasPath$1(object, path, hasFunc) {
  path = castPath(path, object);
  var index2 = -1, length = path.length, result2 = false;
  while (++index2 < length) {
    var key = toKey$2(path[index2]);
    if (!(result2 = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result2 || ++index2 != length) {
    return result2;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex$1(key, length) && (isArray$4(object) || isArguments$1(object));
}
var _hasPath = hasPath$1;
var baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}
var hasIn_1 = hasIn$1;
var baseIsEqual = _baseIsEqual, get3 = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey;
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object) {
    var objValue = get3(object, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function baseProperty$1(key) {
  return function(object) {
    return object == null ? void 0 : object[key];
  };
}
var _baseProperty = baseProperty$1;
var baseGet = _baseGet;
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet(object, path);
  };
}
var _basePropertyDeep = basePropertyDeep$1;
var baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
var property_1 = property$1;
var baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity$1 = identity_1, isArray$3 = isArray_1, property = property_1;
function baseIteratee$1(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$1;
  }
  if (typeof value == "object") {
    return isArray$3(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$1;
var arrayAggregator = _arrayAggregator, baseAggregator = _baseAggregator, baseIteratee = _baseIteratee, isArray$2 = isArray_1;
function createAggregator$1(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray$2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
    return func(collection, setter, baseIteratee(iteratee), accumulator);
  };
}
var _createAggregator = createAggregator$1;
var baseAssignValue$1 = _baseAssignValue, createAggregator = _createAggregator;
var keyBy = createAggregator(function(result2, value, key) {
  baseAssignValue$1(result2, key, value);
});
var keyBy_1 = keyBy;
const _keyBy = /* @__PURE__ */ getDefaultExportFromCjs(keyBy_1);
var arrayMap = _arrayMap;
function baseValues$1(object, props2) {
  return arrayMap(props2, function(key) {
    return object[key];
  });
}
var _baseValues = baseValues$1;
var baseValues = _baseValues, keys = keys_1;
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}
var values_1 = values;
const _values = /* @__PURE__ */ getDefaultExportFromCjs(values_1);
var baseAssignValue = _baseAssignValue, eq$1 = eq_1;
function assignMergeValue$2(object, key, value) {
  if (value !== void 0 && !eq$1(object[key], value) || value === void 0 && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}
var _assignMergeValue = assignMergeValue$2;
var isArrayLike$1 = isArrayLike_1, isObjectLike = isObjectLike_1;
function isArrayLikeObject$1(value) {
  return isObjectLike(value) && isArrayLike$1(value);
}
var isArrayLikeObject_1 = isArrayLikeObject$1;
function safeGet$2(object, key) {
  if (key === "constructor" && typeof object[key] === "function") {
    return;
  }
  if (key == "__proto__") {
    return;
  }
  return object[key];
}
var _safeGet = safeGet$2;
var copyObject = _copyObject, keysIn$1 = keysIn_1;
function toPlainObject$1(value) {
  return copyObject(value, keysIn$1(value));
}
var toPlainObject_1 = toPlainObject$1;
var assignMergeValue$1 = _assignMergeValue, cloneBuffer = _cloneBufferExports, cloneTypedArray = _cloneTypedArray, copyArray = _copyArray, initCloneObject = _initCloneObject, isArguments = isArguments_1, isArray$1 = isArray_1, isArrayLikeObject = isArrayLikeObject_1, isBuffer = isBufferExports, isFunction$1 = isFunction_1, isObject$5 = isObject_1, isPlainObject$4 = isPlainObject_1, isTypedArray$1 = isTypedArray_1, safeGet$1 = _safeGet, toPlainObject = toPlainObject_1;
function baseMergeDeep$1(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet$1(object, key), srcValue = safeGet$1(source, key), stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue$1(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray$1(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray$1(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$1(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject$4(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject$5(objValue) || isFunction$1(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack["delete"](srcValue);
  }
  assignMergeValue$1(object, key, newValue);
}
var _baseMergeDeep = baseMergeDeep$1;
var Stack = _Stack, assignMergeValue = _assignMergeValue, baseFor = _baseFor, baseMergeDeep = _baseMergeDeep, isObject$4 = isObject_1, keysIn = keysIn_1, safeGet = _safeGet;
function baseMerge$1(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack());
    if (isObject$4(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge$1, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}
var _baseMerge = baseMerge$1;
var identity = identity_1, overRest = _overRest, setToString = _setToString;
function baseRest$1(func, start) {
  return setToString(overRest(func, start, identity), func + "");
}
var _baseRest = baseRest$1;
var eq = eq_1, isArrayLike = isArrayLike_1, isIndex = _isIndex, isObject$3 = isObject_1;
function isIterateeCall$2(value, index2, object) {
  if (!isObject$3(object)) {
    return false;
  }
  var type = typeof index2;
  if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
    return eq(object[index2], value);
  }
  return false;
}
var _isIterateeCall = isIterateeCall$2;
var baseRest = _baseRest, isIterateeCall$1 = _isIterateeCall;
function createAssigner$1(assigner) {
  return baseRest(function(object, sources) {
    var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
    customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
    if (guard && isIterateeCall$1(sources[0], sources[1], guard)) {
      customizer = length < 3 ? void 0 : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index2 < length) {
      var source = sources[index2];
      if (source) {
        assigner(object, source, index2, customizer);
      }
    }
    return object;
  });
}
var _createAssigner = createAssigner$1;
var baseMerge = _baseMerge, createAssigner = _createAssigner;
var merge$4 = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});
var merge_1 = merge$4;
const _merge = /* @__PURE__ */ getDefaultExportFromCjs(merge_1);
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const REVISION = "176";
const UVMapping = 300;
const RepeatWrapping = 1e3;
const ClampToEdgeWrapping = 1001;
const MirroredRepeatWrapping = 1002;
const LinearFilter = 1006;
const LinearMipmapLinearFilter = 1008;
const UnsignedByteType = 1009;
const RGBAFormat = 1023;
const LoopOnce = 2200;
const LoopRepeat = 2201;
const LoopPingPong = 2202;
const InterpolateDiscrete = 2300;
const InterpolateLinear = 2301;
const InterpolateSmooth = 2302;
const ZeroCurvatureEnding = 2400;
const ZeroSlopeEnding = 2401;
const WrapAroundEnding = 2402;
const NormalAnimationBlendMode = 2500;
const AdditiveAnimationBlendMode = 2501;
const NoColorSpace = "";
const SRGBColorSpace = "srgb";
const LinearSRGBColorSpace = "srgb-linear";
const LinearTransfer = "linear";
const SRGBTransfer = "srgb";
const WebGLCoordinateSystem = 2e3;
const WebGPUCoordinateSystem = 2001;
class EventDispatcher {
  /**
   * Adds the given event listener to the given event type.
   *
   * @param {string} type - The type of event to listen to.
   * @param {Function} listener - The function that gets called when the event is fired.
   */
  addEventListener(type, listener) {
    if (this._listeners === void 0)
      this._listeners = {};
    const listeners = this._listeners;
    if (listeners[type] === void 0) {
      listeners[type] = [];
    }
    if (listeners[type].indexOf(listener) === -1) {
      listeners[type].push(listener);
    }
  }
  /**
   * Returns `true` if the given event listener has been added to the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to check.
   * @return {boolean} Whether the given event listener has been added to the given event type.
   */
  hasEventListener(type, listener) {
    const listeners = this._listeners;
    if (listeners === void 0)
      return false;
    return listeners[type] !== void 0 && listeners[type].indexOf(listener) !== -1;
  }
  /**
   * Removes the given event listener from the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to remove.
   */
  removeEventListener(type, listener) {
    const listeners = this._listeners;
    if (listeners === void 0)
      return;
    const listenerArray = listeners[type];
    if (listenerArray !== void 0) {
      const index2 = listenerArray.indexOf(listener);
      if (index2 !== -1) {
        listenerArray.splice(index2, 1);
      }
    }
  }
  /**
   * Dispatches an event object.
   *
   * @param {Object} event - The event that gets fired.
   */
  dispatchEvent(event) {
    const listeners = this._listeners;
    if (listeners === void 0)
      return;
    const listenerArray = listeners[event.type];
    if (listenerArray !== void 0) {
      event.target = this;
      const array = listenerArray.slice(0);
      for (let i2 = 0, l = array.length; i2 < l; i2++) {
        array[i2].call(this, event);
      }
      event.target = null;
    }
  }
}
const _lut = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let _seed = 1234567;
const DEG2RAD = Math.PI / 180;
const RAD2DEG = 180 / Math.PI;
function generateUUID() {
  const d0 = Math.random() * 4294967295 | 0;
  const d1 = Math.random() * 4294967295 | 0;
  const d2 = Math.random() * 4294967295 | 0;
  const d3 = Math.random() * 4294967295 | 0;
  const uuid = _lut[d0 & 255] + _lut[d0 >> 8 & 255] + _lut[d0 >> 16 & 255] + _lut[d0 >> 24 & 255] + "-" + _lut[d1 & 255] + _lut[d1 >> 8 & 255] + "-" + _lut[d1 >> 16 & 15 | 64] + _lut[d1 >> 24 & 255] + "-" + _lut[d2 & 63 | 128] + _lut[d2 >> 8 & 255] + "-" + _lut[d2 >> 16 & 255] + _lut[d2 >> 24 & 255] + _lut[d3 & 255] + _lut[d3 >> 8 & 255] + _lut[d3 >> 16 & 255] + _lut[d3 >> 24 & 255];
  return uuid.toLowerCase();
}
function clamp$2(value, min2, max2) {
  return Math.max(min2, Math.min(max2, value));
}
function euclideanModulo(n2, m) {
  return (n2 % m + m) % m;
}
function mapLinear(x2, a1, a2, b1, b2) {
  return b1 + (x2 - a1) * (b2 - b1) / (a2 - a1);
}
function inverseLerp(x2, y, value) {
  if (x2 !== y) {
    return (value - x2) / (y - x2);
  } else {
    return 0;
  }
}
function lerp(x2, y, t3) {
  return (1 - t3) * x2 + t3 * y;
}
function damp(x2, y, lambda, dt) {
  return lerp(x2, y, 1 - Math.exp(-lambda * dt));
}
function pingpong(x2, length = 1) {
  return length - Math.abs(euclideanModulo(x2, length * 2) - length);
}
function smoothstep(x2, min2, max2) {
  if (x2 <= min2)
    return 0;
  if (x2 >= max2)
    return 1;
  x2 = (x2 - min2) / (max2 - min2);
  return x2 * x2 * (3 - 2 * x2);
}
function smootherstep(x2, min2, max2) {
  if (x2 <= min2)
    return 0;
  if (x2 >= max2)
    return 1;
  x2 = (x2 - min2) / (max2 - min2);
  return x2 * x2 * x2 * (x2 * (x2 * 6 - 15) + 10);
}
function randInt(low, high) {
  return low + Math.floor(Math.random() * (high - low + 1));
}
function randFloat(low, high) {
  return low + Math.random() * (high - low);
}
function randFloatSpread(range) {
  return range * (0.5 - Math.random());
}
function seededRandom(s2) {
  if (s2 !== void 0)
    _seed = s2;
  let t3 = _seed += 1831565813;
  t3 = Math.imul(t3 ^ t3 >>> 15, t3 | 1);
  t3 ^= t3 + Math.imul(t3 ^ t3 >>> 7, t3 | 61);
  return ((t3 ^ t3 >>> 14) >>> 0) / 4294967296;
}
function degToRad(degrees) {
  return degrees * DEG2RAD;
}
function radToDeg(radians) {
  return radians * RAD2DEG;
}
function isPowerOfTwo(value) {
  return (value & value - 1) === 0 && value !== 0;
}
function ceilPowerOfTwo(value) {
  return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function floorPowerOfTwo(value) {
  return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function setQuaternionFromProperEuler(q, a, b, c, order) {
  const cos = Math.cos;
  const sin = Math.sin;
  const c2 = cos(b / 2);
  const s2 = sin(b / 2);
  const c13 = cos((a + c) / 2);
  const s13 = sin((a + c) / 2);
  const c1_3 = cos((a - c) / 2);
  const s1_3 = sin((a - c) / 2);
  const c3_1 = cos((c - a) / 2);
  const s3_1 = sin((c - a) / 2);
  switch (order) {
    case "XYX":
      q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
      break;
    case "YZY":
      q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
      break;
    case "ZXZ":
      q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
      break;
    case "XZX":
      q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
      break;
    case "YXY":
      q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
      break;
    case "ZYZ":
      q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
  }
}
function denormalize(value, array) {
  switch (array.constructor) {
    case Float32Array:
      return value;
    case Uint32Array:
      return value / 4294967295;
    case Uint16Array:
      return value / 65535;
    case Uint8Array:
      return value / 255;
    case Int32Array:
      return Math.max(value / 2147483647, -1);
    case Int16Array:
      return Math.max(value / 32767, -1);
    case Int8Array:
      return Math.max(value / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function normalize(value, array) {
  switch (array.constructor) {
    case Float32Array:
      return value;
    case Uint32Array:
      return Math.round(value * 4294967295);
    case Uint16Array:
      return Math.round(value * 65535);
    case Uint8Array:
      return Math.round(value * 255);
    case Int32Array:
      return Math.round(value * 2147483647);
    case Int16Array:
      return Math.round(value * 32767);
    case Int8Array:
      return Math.round(value * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
const MathUtils = {
  DEG2RAD,
  RAD2DEG,
  /**
   * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
   * (universally unique identifier).
   *
   * @static
   * @method
   * @return {string} The UUID.
   */
  generateUUID,
  /**
   * Clamps the given value between min and max.
   *
   * @static
   * @method
   * @param {number} value - The value to clamp.
   * @param {number} min - The min value.
   * @param {number} max - The max value.
   * @return {number} The clamped value.
   */
  clamp: clamp$2,
  /**
   * Computes the Euclidean modulo of the given parameters that
   * is `( ( n % m ) + m ) % m`.
   *
   * @static
   * @method
   * @param {number} n - The first parameter.
   * @param {number} m - The second parameter.
   * @return {number} The Euclidean modulo.
   */
  euclideanModulo,
  /**
   * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
   * for the given value.
   *
   * @static
   * @method
   * @param {number} x - The value to be mapped.
   * @param {number} a1 - Minimum value for range A.
   * @param {number} a2 - Maximum value for range A.
   * @param {number} b1 - Minimum value for range B.
   * @param {number} b2 - Maximum value for range B.
   * @return {number} The mapped value.
   */
  mapLinear,
  /**
   * Returns the percentage in the closed interval `[0, 1]` of the given value
   * between the start and end point.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} value - A value between start and end.
   * @return {number} The interpolation factor.
   */
  inverseLerp,
  /**
   * Returns a value linearly interpolated from two known points based on the given interval -
   * `t = 0` will return `x` and `t = 1` will return `y`.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {number} The interpolated value.
   */
  lerp,
  /**
   * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
   * time to maintain frame rate independent movement. For details, see
   * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
   *
   * @static
   * @method
   * @param {number} x - The current point.
   * @param {number} y - The target point.
   * @param {number} lambda - A higher lambda value will make the movement more sudden,
   * and a lower value will make the movement more gradual.
   * @param {number} dt - Delta time in seconds.
   * @return {number} The interpolated value.
   */
  damp,
  /**
   * Returns a value that alternates between `0` and the given `length` parameter.
   *
   * @static
   * @method
   * @param {number} x - The value to pingpong.
   * @param {number} [length=1] - The positive value the function will pingpong to.
   * @return {number} The alternated value.
   */
  pingpong,
  /**
   * Returns a value in the range `[0,1]` that represents the percentage that `x` has
   * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
   * the `min` and `max`.
   *
   * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smoothstep,
  /**
   * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
   * that has zero 1st and 2nd order derivatives at x=0 and x=1.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smootherstep,
  /**
   * Returns a random integer from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random integer.
   */
  randInt,
  /**
   * Returns a random float from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random float.
   */
  randFloat,
  /**
   * Returns a random integer from `<-range/2, range/2>` interval.
   *
   * @static
   * @method
   * @param {number} range - Defines the value range.
   * @return {number} A random float.
   */
  randFloatSpread,
  /**
   * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
   *
   * @static
   * @method
   * @param {number} [s] - The integer seed.
   * @return {number} A random float.
   */
  seededRandom,
  /**
   * Converts degrees to radians.
   *
   * @static
   * @method
   * @param {number} degrees - A value in degrees.
   * @return {number} The converted value in radians.
   */
  degToRad,
  /**
   * Converts radians to degrees.
   *
   * @static
   * @method
   * @param {number} radians - A value in radians.
   * @return {number} The converted value in degrees.
   */
  radToDeg,
  /**
   * Returns `true` if the given number is a power of two.
   *
   * @static
   * @method
   * @param {number} value - The value to check.
   * @return {boolean} Whether the given number is a power of two or not.
   */
  isPowerOfTwo,
  /**
   * Returns the smallest power of two that is greater than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The smallest power of two that is greater than or equal to the given number.
   */
  ceilPowerOfTwo,
  /**
   * Returns the largest power of two that is less than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The largest power of two that is less than or equal to the given number.
   */
  floorPowerOfTwo,
  /**
   * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
   * defined by the given angles and order.
   *
   * Rotations are applied to the axes in the order specified by order:
   * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
   *
   * @static
   * @method
   * @param {Quaternion} q - The quaternion to set.
   * @param {number} a - The rotation applied to the first axis, in radians.
   * @param {number} b - The rotation applied to the second axis, in radians.
   * @param {number} c - The rotation applied to the third axis, in radians.
   * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
   */
  setQuaternionFromProperEuler,
  /**
   * Normalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The float value in the range `[0,1]` to normalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The normalize value.
   */
  normalize,
  /**
   * Denormalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The value to denormalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The denormalize (float) value in the range `[0,1]`.
   */
  denormalize
};
class Vector2 {
  /**
   * Constructs a new 2D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   */
  constructor(x2 = 0, y = 0) {
    Vector2.prototype.isVector2 = true;
    this.x = x2;
    this.y = y;
  }
  /**
   * Alias for {@link Vector2#x}.
   *
   * @type {number}
   */
  get width() {
    return this.x;
  }
  set width(value) {
    this.x = value;
  }
  /**
   * Alias for {@link Vector2#y}.
   *
   * @type {number}
   */
  get height() {
    return this.y;
  }
  set height(value) {
    this.y = value;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @return {Vector2} A reference to this vector.
   */
  set(x2, y) {
    this.x = x2;
    this.y = y;
    return this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector2} A reference to this vector.
   */
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    return this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setX(x2) {
    this.x = x2;
    return this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setY(y) {
    this.y = y;
    return this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @param {number} value - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setComponent(index2, value) {
    switch (index2) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      default:
        throw new Error("index is out of range: " + index2);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @return {number} A vector component value.
   */
  getComponent(index2) {
    switch (index2) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + index2);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector2} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector2} v - The vector to copy.
   * @return {Vector2} A reference to this vector.
   */
  copy(v) {
    this.x = v.x;
    this.y = v.y;
    return this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector2} v - The vector to add.
   * @return {Vector2} A reference to this vector.
   */
  add(v) {
    this.x += v.x;
    this.y += v.y;
    return this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector2} A reference to this vector.
   */
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    return this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  addVectors(a, b) {
    this.x = a.x + b.x;
    this.y = a.y + b.y;
    return this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector2} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector2} A reference to this vector.
   */
  addScaledVector(v, s2) {
    this.x += v.x * s2;
    this.y += v.y * s2;
    return this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector2} v - The vector to subtract.
   * @return {Vector2} A reference to this vector.
   */
  sub(v) {
    this.x -= v.x;
    this.y -= v.y;
    return this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector2} A reference to this vector.
   */
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    return this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  subVectors(a, b) {
    this.x = a.x - b.x;
    this.y = a.y - b.y;
    return this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector2} v - The vector to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiply(v) {
    this.x *= v.x;
    this.y *= v.y;
    return this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    return this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector2} v - The vector to divide.
   * @return {Vector2} A reference to this vector.
   */
  divide(v) {
    this.x /= v.x;
    this.y /= v.y;
    return this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector2} A reference to this vector.
   */
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  /**
   * Multiplies this vector (with an implicit 1 as the 3rd component) by
   * the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {Vector2} A reference to this vector.
   */
  applyMatrix3(m) {
    const x2 = this.x, y = this.y;
    const e = m.elements;
    this.x = e[0] * x2 + e[3] * y + e[6];
    this.y = e[1] * x2 + e[4] * y + e[7];
    return this;
  }
  /**
   * If this vector's x or y value is greater than the given vector's x or y
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  min(v) {
    this.x = Math.min(this.x, v.x);
    this.y = Math.min(this.y, v.y);
    return this;
  }
  /**
   * If this vector's x or y value is less than the given vector's x or y
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  max(v) {
    this.x = Math.max(this.x, v.x);
    this.y = Math.max(this.y, v.y);
    return this;
  }
  /**
   * If this vector's x or y value is greater than the max vector's x or y
   * value, it is replaced by the corresponding value.
   * If this vector's x or y value is less than the min vector's x or y value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector2} min - The minimum x and y values.
   * @param {Vector2} max - The maximum x and y values in the desired range.
   * @return {Vector2} A reference to this vector.
   */
  clamp(min2, max2) {
    this.x = clamp$2(this.x, min2.x, max2.x);
    this.y = clamp$2(this.y, min2.y, max2.y);
    return this;
  }
  /**
   * If this vector's x or y values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x or y values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampScalar(minVal, maxVal) {
    this.x = clamp$2(this.x, minVal, maxVal);
    this.y = clamp$2(this.y, minVal, maxVal);
    return this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampLength(min2, max2) {
    const length = this.length();
    return this.divideScalar(length || 1).multiplyScalar(clamp$2(length, min2, max2));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    return this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    return this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector2} A reference to this vector.
   */
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  roundToZero() {
    this.x = Math.trunc(this.x);
    this.y = Math.trunc(this.y);
    return this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x and y = -y.
   *
   * @return {Vector2} A reference to this vector.
   */
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    return this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(v) {
    return this.x * v.x + this.y * v.y;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the cross product with.
   * @return {number} The result of the cross product.
   */
  cross(v) {
    return this.x * v.y - this.y * v.x;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Computes the angle in radians of this vector with respect to the positive x-axis.
   *
   * @return {number} The angle in radians.
   */
  angle() {
    const angle = Math.atan2(-this.y, -this.x) + Math.PI;
    return angle;
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector2} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(v) {
    const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
    if (denominator === 0)
      return Math.PI / 2;
    const theta = this.dot(v) / denominator;
    return Math.acos(clamp$2(theta, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(v) {
    return Math.sqrt(this.distanceToSquared(v));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector2} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(v) {
    const dx = this.x - v.x, dy = this.y - v.y;
    return dx * dx + dy * dy;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(v) {
    return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector2} A reference to this vector.
   */
  setLength(length) {
    return this.normalize().multiplyScalar(length);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector2} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerp(v, alpha) {
    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    return this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector2} v1 - The first vector.
   * @param {Vector2} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerpVectors(v1, v2, alpha) {
    this.x = v1.x + (v2.x - v1.x) * alpha;
    this.y = v1.y + (v2.y - v1.y) * alpha;
    return this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector2} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(v) {
    return v.x === this.x && v.y === this.y;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]` and y
   * value to be `array[ offset + 1 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector2} A reference to this vector.
   */
  fromArray(array, offset2 = 0) {
    this.x = array[offset2];
    this.y = array[offset2 + 1];
    return this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(array = [], offset2 = 0) {
    array[offset2] = this.x;
    array[offset2 + 1] = this.y;
    return array;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector2} A reference to this vector.
   */
  fromBufferAttribute(attribute, index2) {
    this.x = attribute.getX(index2);
    this.y = attribute.getY(index2);
    return this;
  }
  /**
   * Rotates this vector around the given center by the given angle.
   *
   * @param {Vector2} center - The point around which to rotate.
   * @param {number} angle - The angle to rotate, in radians.
   * @return {Vector2} A reference to this vector.
   */
  rotateAround(center, angle) {
    const c = Math.cos(angle), s2 = Math.sin(angle);
    const x2 = this.x - center.x;
    const y = this.y - center.y;
    this.x = x2 * c - y * s2 + center.x;
    this.y = x2 * s2 + y * c + center.y;
    return this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  random() {
    this.x = Math.random();
    this.y = Math.random();
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
  }
}
class Matrix3 {
  /**
   * Constructs a new 3x3 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   */
  constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
    Matrix3.prototype.isMatrix3 = true;
    this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ];
    if (n11 !== void 0) {
      this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @return {Matrix3} A reference to this matrix.
   */
  set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
    const te2 = this.elements;
    te2[0] = n11;
    te2[1] = n21;
    te2[2] = n31;
    te2[3] = n12;
    te2[4] = n22;
    te2[5] = n32;
    te2[6] = n13;
    te2[7] = n23;
    te2[8] = n33;
    return this;
  }
  /**
   * Sets this matrix to the 3x3 identity matrix.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix3} m - The matrix to copy.
   * @return {Matrix3} A reference to this matrix.
   */
  copy(m) {
    const te2 = this.elements;
    const me = m.elements;
    te2[0] = me[0];
    te2[1] = me[1];
    te2[2] = me[2];
    te2[3] = me[3];
    te2[4] = me[4];
    te2[5] = me[5];
    te2[6] = me[6];
    te2[7] = me[7];
    te2[8] = me[8];
    return this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix3} A reference to this matrix.
   */
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrix3Column(this, 0);
    yAxis.setFromMatrix3Column(this, 1);
    zAxis.setFromMatrix3Column(this, 2);
    return this;
  }
  /**
   * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  setFromMatrix4(m) {
    const me = m.elements;
    this.set(
      me[0],
      me[4],
      me[8],
      me[1],
      me[5],
      me[9],
      me[2],
      me[6],
      me[10]
    );
    return this;
  }
  /**
   * Post-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  multiply(m) {
    return this.multiplyMatrices(this, m);
  }
  /**
   * Pre-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  premultiply(m) {
    return this.multiplyMatrices(m, this);
  }
  /**
   * Multiples the given 3x3 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix3} a - The first matrix.
   * @param {Matrix3} b - The second matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyMatrices(a, b) {
    const ae = a.elements;
    const be = b.elements;
    const te2 = this.elements;
    const a11 = ae[0], a12 = ae[3], a13 = ae[6];
    const a21 = ae[1], a22 = ae[4], a23 = ae[7];
    const a31 = ae[2], a32 = ae[5], a33 = ae[8];
    const b11 = be[0], b12 = be[3], b13 = be[6];
    const b21 = be[1], b22 = be[4], b23 = be[7];
    const b31 = be[2], b32 = be[5], b33 = be[8];
    te2[0] = a11 * b11 + a12 * b21 + a13 * b31;
    te2[3] = a11 * b12 + a12 * b22 + a13 * b32;
    te2[6] = a11 * b13 + a12 * b23 + a13 * b33;
    te2[1] = a21 * b11 + a22 * b21 + a23 * b31;
    te2[4] = a21 * b12 + a22 * b22 + a23 * b32;
    te2[7] = a21 * b13 + a22 * b23 + a23 * b33;
    te2[2] = a31 * b11 + a32 * b21 + a33 * b31;
    te2[5] = a31 * b12 + a32 * b22 + a33 * b32;
    te2[8] = a31 * b13 + a32 * b23 + a33 * b33;
    return this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyScalar(s2) {
    const te2 = this.elements;
    te2[0] *= s2;
    te2[3] *= s2;
    te2[6] *= s2;
    te2[1] *= s2;
    te2[4] *= s2;
    te2[7] *= s2;
    te2[2] *= s2;
    te2[5] *= s2;
    te2[8] *= s2;
    return this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * @return {number} The determinant.
   */
  determinant() {
    const te2 = this.elements;
    const a = te2[0], b = te2[1], c = te2[2], d2 = te2[3], e = te2[4], f = te2[5], g = te2[6], h = te2[7], i2 = te2[8];
    return a * e * i2 - a * f * h - b * d2 * i2 + b * f * g + c * d2 * h - c * e * g;
  }
  /**
   * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  invert() {
    const te2 = this.elements, n11 = te2[0], n21 = te2[1], n31 = te2[2], n12 = te2[3], n22 = te2[4], n32 = te2[5], n13 = te2[6], n23 = te2[7], n33 = te2[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
    if (det === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det;
    te2[0] = t11 * detInv;
    te2[1] = (n31 * n23 - n33 * n21) * detInv;
    te2[2] = (n32 * n21 - n31 * n22) * detInv;
    te2[3] = t12 * detInv;
    te2[4] = (n33 * n11 - n31 * n13) * detInv;
    te2[5] = (n31 * n12 - n32 * n11) * detInv;
    te2[6] = t13 * detInv;
    te2[7] = (n21 * n13 - n23 * n11) * detInv;
    te2[8] = (n22 * n11 - n21 * n12) * detInv;
    return this;
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  transpose() {
    let tmp;
    const m = this.elements;
    tmp = m[1];
    m[1] = m[3];
    m[3] = tmp;
    tmp = m[2];
    m[2] = m[6];
    m[6] = tmp;
    tmp = m[5];
    m[5] = m[7];
    m[7] = tmp;
    return this;
  }
  /**
   * Computes the normal matrix which is the inverse transpose of the upper
   * left 3x3 portion of the given 4x4 matrix.
   *
   * @param {Matrix4} matrix4 - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  getNormalMatrix(matrix4) {
    return this.setFromMatrix4(matrix4).invert().transpose();
  }
  /**
   * Transposes this matrix into the supplied array, and returns itself unchanged.
   *
   * @param {Array<number>} r - An array to store the transposed matrix elements.
   * @return {Matrix3} A reference to this matrix.
   */
  transposeIntoArray(r) {
    const m = this.elements;
    r[0] = m[0];
    r[1] = m[3];
    r[2] = m[6];
    r[3] = m[1];
    r[4] = m[4];
    r[5] = m[7];
    r[6] = m[2];
    r[7] = m[5];
    r[8] = m[8];
    return this;
  }
  /**
   * Sets the UV transform matrix from offset, repeat, rotation, and center.
   *
   * @param {number} tx - Offset x.
   * @param {number} ty - Offset y.
   * @param {number} sx - Repeat x.
   * @param {number} sy - Repeat y.
   * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
   * @param {number} cx - Center x of rotation.
   * @param {number} cy - Center y of rotation
   * @return {Matrix3} A reference to this matrix.
   */
  setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
    const c = Math.cos(rotation);
    const s2 = Math.sin(rotation);
    this.set(
      sx * c,
      sx * s2,
      -sx * (c * cx + s2 * cy) + cx + tx,
      -sy * s2,
      sy * c,
      -sy * (-s2 * cx + c * cy) + cy + ty,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Scales this matrix with the given scalar values.
   *
   * @param {number} sx - The amount to scale in the X axis.
   * @param {number} sy - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  scale(sx, sy) {
    this.premultiply(_m3.makeScale(sx, sy));
    return this;
  }
  /**
   * Rotates this matrix by the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  rotate(theta) {
    this.premultiply(_m3.makeRotation(-theta));
    return this;
  }
  /**
   * Translates this matrix by the given scalar values.
   *
   * @param {number} tx - The amount to translate in the X axis.
   * @param {number} ty - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  translate(tx, ty) {
    this.premultiply(_m3.makeTranslation(tx, ty));
    return this;
  }
  // for 2D Transforms
  /**
   * Sets this matrix as a 2D translation transform.
   *
   * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeTranslation(x2, y) {
    if (x2.isVector2) {
      this.set(
        1,
        0,
        x2.x,
        0,
        1,
        x2.y,
        0,
        0,
        1
      );
    } else {
      this.set(
        1,
        0,
        x2,
        0,
        1,
        y,
        0,
        0,
        1
      );
    }
    return this;
  }
  /**
   * Sets this matrix as a 2D rotational transformation.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  makeRotation(theta) {
    const c = Math.cos(theta);
    const s2 = Math.sin(theta);
    this.set(
      c,
      -s2,
      0,
      s2,
      c,
      0,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Sets this matrix as a 2D scale transform.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeScale(x2, y) {
    this.set(
      x2,
      0,
      0,
      0,
      y,
      0,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix3} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(matrix2) {
    const te2 = this.elements;
    const me = matrix2.elements;
    for (let i2 = 0; i2 < 9; i2++) {
      if (te2[i2] !== me[i2])
        return false;
    }
    return true;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix3} A reference to this matrix.
   */
  fromArray(array, offset2 = 0) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.elements[i2] = array[i2 + offset2];
    }
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(array = [], offset2 = 0) {
    const te2 = this.elements;
    array[offset2] = te2[0];
    array[offset2 + 1] = te2[1];
    array[offset2 + 2] = te2[2];
    array[offset2 + 3] = te2[3];
    array[offset2 + 4] = te2[4];
    array[offset2 + 5] = te2[5];
    array[offset2 + 6] = te2[6];
    array[offset2 + 7] = te2[7];
    array[offset2 + 8] = te2[8];
    return array;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix3} A clone of this instance.
   */
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const _m3 = /* @__PURE__ */ new Matrix3();
function createElementNS(name) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
const LINEAR_REC709_TO_XYZ = /* @__PURE__ */ new Matrix3().set(
  0.4123908,
  0.3575843,
  0.1804808,
  0.212639,
  0.7151687,
  0.0721923,
  0.0193308,
  0.1191948,
  0.9505322
);
const XYZ_TO_LINEAR_REC709 = /* @__PURE__ */ new Matrix3().set(
  3.2409699,
  -1.5373832,
  -0.4986108,
  -0.9692436,
  1.8759675,
  0.0415551,
  0.0556301,
  -0.203977,
  1.0569715
);
function createColorManagement() {
  const ColorManagement2 = {
    enabled: true,
    workingColorSpace: LinearSRGBColorSpace,
    /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */
    spaces: {},
    convert: function(color2, sourceColorSpace, targetColorSpace) {
      if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) {
        return color2;
      }
      if (this.spaces[sourceColorSpace].transfer === SRGBTransfer) {
        color2.r = SRGBToLinear(color2.r);
        color2.g = SRGBToLinear(color2.g);
        color2.b = SRGBToLinear(color2.b);
      }
      if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
        color2.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
        color2.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
      }
      if (this.spaces[targetColorSpace].transfer === SRGBTransfer) {
        color2.r = LinearToSRGB(color2.r);
        color2.g = LinearToSRGB(color2.g);
        color2.b = LinearToSRGB(color2.b);
      }
      return color2;
    },
    fromWorkingColorSpace: function(color2, targetColorSpace) {
      return this.convert(color2, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color2, sourceColorSpace) {
      return this.convert(color2, sourceColorSpace, this.workingColorSpace);
    },
    getPrimaries: function(colorSpace) {
      return this.spaces[colorSpace].primaries;
    },
    getTransfer: function(colorSpace) {
      if (colorSpace === NoColorSpace)
        return LinearTransfer;
      return this.spaces[colorSpace].transfer;
    },
    getLuminanceCoefficients: function(target2, colorSpace = this.workingColorSpace) {
      return target2.fromArray(this.spaces[colorSpace].luminanceCoefficients);
    },
    define: function(colorSpaces) {
      Object.assign(this.spaces, colorSpaces);
    },
    // Internal APIs
    _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
      return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(colorSpace) {
      return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
      return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
    }
  };
  const REC709_PRIMARIES = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06];
  const REC709_LUMINANCE_COEFFICIENTS = [0.2126, 0.7152, 0.0722];
  const D65 = [0.3127, 0.329];
  ColorManagement2.define({
    [LinearSRGBColorSpace]: {
      primaries: REC709_PRIMARIES,
      whitePoint: D65,
      transfer: LinearTransfer,
      toXYZ: LINEAR_REC709_TO_XYZ,
      fromXYZ: XYZ_TO_LINEAR_REC709,
      luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
      workingColorSpaceConfig: { unpackColorSpace: SRGBColorSpace },
      outputColorSpaceConfig: { drawingBufferColorSpace: SRGBColorSpace }
    },
    [SRGBColorSpace]: {
      primaries: REC709_PRIMARIES,
      whitePoint: D65,
      transfer: SRGBTransfer,
      toXYZ: LINEAR_REC709_TO_XYZ,
      fromXYZ: XYZ_TO_LINEAR_REC709,
      luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
      outputColorSpaceConfig: { drawingBufferColorSpace: SRGBColorSpace }
    }
  });
  return ColorManagement2;
}
const ColorManagement = /* @__PURE__ */ createColorManagement();
function SRGBToLinear(c) {
  return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function LinearToSRGB(c) {
  return c < 31308e-7 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let _canvas;
class ImageUtils {
  /**
   * Returns a data URI containing a representation of the given image.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
   * @param {string} [type='image/png'] - Indicates the image format.
   * @return {string} The data URI.
   */
  static getDataURL(image, type = "image/png") {
    if (/^data:/i.test(image.src)) {
      return image.src;
    }
    if (typeof HTMLCanvasElement === "undefined") {
      return image.src;
    }
    let canvas;
    if (image instanceof HTMLCanvasElement) {
      canvas = image;
    } else {
      if (_canvas === void 0)
        _canvas = createElementNS("canvas");
      _canvas.width = image.width;
      _canvas.height = image.height;
      const context = _canvas.getContext("2d");
      if (image instanceof ImageData) {
        context.putImageData(image, 0, 0);
      } else {
        context.drawImage(image, 0, 0, image.width, image.height);
      }
      canvas = _canvas;
    }
    return canvas.toDataURL(type);
  }
  /**
   * Converts the given sRGB image data to linear color space.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
   * @return {HTMLCanvasElement|Object} The converted image.
   */
  static sRGBToLinear(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
      const canvas = createElementNS("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext("2d");
      context.drawImage(image, 0, 0, image.width, image.height);
      const imageData = context.getImageData(0, 0, image.width, image.height);
      const data = imageData.data;
      for (let i2 = 0; i2 < data.length; i2++) {
        data[i2] = SRGBToLinear(data[i2] / 255) * 255;
      }
      context.putImageData(imageData, 0, 0);
      return canvas;
    } else if (image.data) {
      const data = image.data.slice(0);
      for (let i2 = 0; i2 < data.length; i2++) {
        if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) {
          data[i2] = Math.floor(SRGBToLinear(data[i2] / 255) * 255);
        } else {
          data[i2] = SRGBToLinear(data[i2]);
        }
      }
      return {
        data,
        width: image.width,
        height: image.height
      };
    } else {
      console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
      return image;
    }
  }
}
let _sourceId = 0;
class Source {
  /**
   * Constructs a new video texture.
   *
   * @param {any} [data=null] - The data definition of a texture.
   */
  constructor(data = null) {
    this.isSource = true;
    Object.defineProperty(this, "id", { value: _sourceId++ });
    this.uuid = generateUUID();
    this.data = data;
    this.dataReady = true;
    this.version = 0;
  }
  /**
   * When the property is set to `true`, the engine allocates the memory
   * for the texture (if necessary) and triggers the actual texture upload
   * to the GPU next time the source is used.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(value) {
    if (value === true)
      this.version++;
  }
  /**
   * Serializes the source into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized source.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    if (!isRootObject && meta.images[this.uuid] !== void 0) {
      return meta.images[this.uuid];
    }
    const output = {
      uuid: this.uuid,
      url: ""
    };
    const data = this.data;
    if (data !== null) {
      let url;
      if (Array.isArray(data)) {
        url = [];
        for (let i2 = 0, l = data.length; i2 < l; i2++) {
          if (data[i2].isDataTexture) {
            url.push(serializeImage(data[i2].image));
          } else {
            url.push(serializeImage(data[i2]));
          }
        }
      } else {
        url = serializeImage(data);
      }
      output.url = url;
    }
    if (!isRootObject) {
      meta.images[this.uuid] = output;
    }
    return output;
  }
}
function serializeImage(image) {
  if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
    return ImageUtils.getDataURL(image);
  } else {
    if (image.data) {
      return {
        data: Array.from(image.data),
        width: image.width,
        height: image.height,
        type: image.data.constructor.name
      };
    } else {
      console.warn("THREE.Texture: Unable to serialize Texture.");
      return {};
    }
  }
}
let _textureId = 0;
class Texture extends EventDispatcher {
  /**
   * Constructs a new texture.
   *
   * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */
  constructor(image = Texture.DEFAULT_IMAGE, mapping = Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = Texture.DEFAULT_ANISOTROPY, colorSpace = NoColorSpace) {
    super();
    this.isTexture = true;
    Object.defineProperty(this, "id", { value: _textureId++ });
    this.uuid = generateUUID();
    this.name = "";
    this.source = new Source(image);
    this.mipmaps = [];
    this.mapping = mapping;
    this.channel = 0;
    this.wrapS = wrapS;
    this.wrapT = wrapT;
    this.magFilter = magFilter;
    this.minFilter = minFilter;
    this.anisotropy = anisotropy;
    this.format = format;
    this.internalFormat = null;
    this.type = type;
    this.offset = new Vector2(0, 0);
    this.repeat = new Vector2(1, 1);
    this.center = new Vector2(0, 0);
    this.rotation = 0;
    this.matrixAutoUpdate = true;
    this.matrix = new Matrix3();
    this.generateMipmaps = true;
    this.premultiplyAlpha = false;
    this.flipY = true;
    this.unpackAlignment = 4;
    this.colorSpace = colorSpace;
    this.userData = {};
    this.version = 0;
    this.onUpdate = null;
    this.renderTarget = null;
    this.isRenderTargetTexture = false;
    this.isTextureArray = false;
    this.pmremVersion = 0;
  }
  /**
   * The image object holding the texture data.
   *
   * @type {?Object}
   */
  get image() {
    return this.source.data;
  }
  set image(value = null) {
    this.source.data = value;
  }
  /**
   * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
   * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
   */
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  /**
   * Returns a new texture with copied values from this instance.
   *
   * @return {Texture} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given texture to this instance.
   *
   * @param {Texture} source - The texture to copy.
   * @return {Texture} A reference to this instance.
   */
  copy(source) {
    this.name = source.name;
    this.source = source.source;
    this.mipmaps = source.mipmaps.slice(0);
    this.mapping = source.mapping;
    this.channel = source.channel;
    this.wrapS = source.wrapS;
    this.wrapT = source.wrapT;
    this.magFilter = source.magFilter;
    this.minFilter = source.minFilter;
    this.anisotropy = source.anisotropy;
    this.format = source.format;
    this.internalFormat = source.internalFormat;
    this.type = source.type;
    this.offset.copy(source.offset);
    this.repeat.copy(source.repeat);
    this.center.copy(source.center);
    this.rotation = source.rotation;
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrix.copy(source.matrix);
    this.generateMipmaps = source.generateMipmaps;
    this.premultiplyAlpha = source.premultiplyAlpha;
    this.flipY = source.flipY;
    this.unpackAlignment = source.unpackAlignment;
    this.colorSpace = source.colorSpace;
    this.renderTarget = source.renderTarget;
    this.isRenderTargetTexture = source.isRenderTargetTexture;
    this.isTextureArray = source.isTextureArray;
    this.userData = JSON.parse(JSON.stringify(source.userData));
    this.needsUpdate = true;
    return this;
  }
  /**
   * Serializes the texture into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized texture.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    if (!isRootObject && meta.textures[this.uuid] !== void 0) {
      return meta.textures[this.uuid];
    }
    const output = {
      metadata: {
        version: 4.6,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(meta).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    if (Object.keys(this.userData).length > 0)
      output.userData = this.userData;
    if (!isRootObject) {
      meta.textures[this.uuid] = output;
    }
    return output;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Texture#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Transforms the given uv vector with the textures uv transformation matrix.
   *
   * @param {Vector2} uv - The uv vector.
   * @return {Vector2} The transformed uv vector.
   */
  transformUv(uv) {
    if (this.mapping !== UVMapping)
      return uv;
    uv.applyMatrix3(this.matrix);
    if (uv.x < 0 || uv.x > 1) {
      switch (this.wrapS) {
        case RepeatWrapping:
          uv.x = uv.x - Math.floor(uv.x);
          break;
        case ClampToEdgeWrapping:
          uv.x = uv.x < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          if (Math.abs(Math.floor(uv.x) % 2) === 1) {
            uv.x = Math.ceil(uv.x) - uv.x;
          } else {
            uv.x = uv.x - Math.floor(uv.x);
          }
          break;
      }
    }
    if (uv.y < 0 || uv.y > 1) {
      switch (this.wrapT) {
        case RepeatWrapping:
          uv.y = uv.y - Math.floor(uv.y);
          break;
        case ClampToEdgeWrapping:
          uv.y = uv.y < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          if (Math.abs(Math.floor(uv.y) % 2) === 1) {
            uv.y = Math.ceil(uv.y) - uv.y;
          } else {
            uv.y = uv.y - Math.floor(uv.y);
          }
          break;
      }
    }
    if (this.flipY) {
      uv.y = 1 - uv.y;
    }
    return uv;
  }
  /**
   * Setting this property to `true` indicates the engine the texture
   * must be updated in the next render. This triggers a texture upload
   * to the GPU and ensures correct texture parameter configuration.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(value) {
    if (value === true) {
      this.version++;
      this.source.needsUpdate = true;
    }
  }
  /**
   * Setting this property to `true` indicates the engine the PMREM
   * must be regenerated.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsPMREMUpdate(value) {
    if (value === true) {
      this.pmremVersion++;
    }
  }
}
Texture.DEFAULT_IMAGE = null;
Texture.DEFAULT_MAPPING = UVMapping;
Texture.DEFAULT_ANISOTROPY = 1;
class Quaternion {
  /**
   * Constructs a new quaternion.
   *
   * @param {number} [x=0] - The x value of this quaternion.
   * @param {number} [y=0] - The y value of this quaternion.
   * @param {number} [z=0] - The z value of this quaternion.
   * @param {number} [w=1] - The w value of this quaternion.
   */
  constructor(x2 = 0, y = 0, z = 0, w = 1) {
    this.isQuaternion = true;
    this._x = x2;
    this._y = y;
    this._z = z;
    this._w = w;
  }
  /**
   * Interpolates between two quaternions via SLERP. This implementation assumes the
   * quaternion data are managed  in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @param {number} t - The interpolation factor in the range `[0,1]`.
   * @see {@link Quaternion#slerp}
   */
  static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t3) {
    let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
    const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
    if (t3 === 0) {
      dst[dstOffset + 0] = x0;
      dst[dstOffset + 1] = y0;
      dst[dstOffset + 2] = z0;
      dst[dstOffset + 3] = w0;
      return;
    }
    if (t3 === 1) {
      dst[dstOffset + 0] = x1;
      dst[dstOffset + 1] = y1;
      dst[dstOffset + 2] = z1;
      dst[dstOffset + 3] = w1;
      return;
    }
    if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
      let s2 = 1 - t3;
      const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
      if (sqrSin > Number.EPSILON) {
        const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
        s2 = Math.sin(s2 * len) / sin;
        t3 = Math.sin(t3 * len) / sin;
      }
      const tDir = t3 * dir;
      x0 = x0 * s2 + x1 * tDir;
      y0 = y0 * s2 + y1 * tDir;
      z0 = z0 * s2 + z1 * tDir;
      w0 = w0 * s2 + w1 * tDir;
      if (s2 === 1 - t3) {
        const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
        x0 *= f;
        y0 *= f;
        z0 *= f;
        w0 *= f;
      }
    }
    dst[dstOffset] = x0;
    dst[dstOffset + 1] = y0;
    dst[dstOffset + 2] = z0;
    dst[dstOffset + 3] = w0;
  }
  /**
   * Multiplies two quaternions. This implementation assumes the quaternion data are managed
   * in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @return {Array<number>} The destination array.
   * @see {@link Quaternion#multiplyQuaternions}.
   */
  static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
    const x0 = src0[srcOffset0];
    const y0 = src0[srcOffset0 + 1];
    const z0 = src0[srcOffset0 + 2];
    const w0 = src0[srcOffset0 + 3];
    const x1 = src1[srcOffset1];
    const y1 = src1[srcOffset1 + 1];
    const z1 = src1[srcOffset1 + 2];
    const w1 = src1[srcOffset1 + 3];
    dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
    dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
    dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
    dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
    return dst;
  }
  /**
   * The x value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
    this._onChangeCallback();
  }
  /**
   * The y value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
    this._onChangeCallback();
  }
  /**
   * The z value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(value) {
    this._z = value;
    this._onChangeCallback();
  }
  /**
   * The w value of this quaternion.
   *
   * @type {number}
   * @default 1
   */
  get w() {
    return this._w;
  }
  set w(value) {
    this._w = value;
    this._onChangeCallback();
  }
  /**
   * Sets the quaternion components.
   *
   * @param {number} x - The x value of this quaternion.
   * @param {number} y - The y value of this quaternion.
   * @param {number} z - The z value of this quaternion.
   * @param {number} w - The w value of this quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  set(x2, y, z, w) {
    this._x = x2;
    this._y = y;
    this._z = z;
    this._w = w;
    this._onChangeCallback();
    return this;
  }
  /**
   * Returns a new quaternion with copied values from this instance.
   *
   * @return {Quaternion} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  /**
   * Copies the values of the given quaternion to this instance.
   *
   * @param {Quaternion} quaternion - The quaternion to copy.
   * @return {Quaternion} A reference to this quaternion.
   */
  copy(quaternion) {
    this._x = quaternion.x;
    this._y = quaternion.y;
    this._z = quaternion.z;
    this._w = quaternion.w;
    this._onChangeCallback();
    return this;
  }
  /**
   * Sets this quaternion from the rotation specified by the given
   * Euler angles.
   *
   * @param {Euler} euler - The Euler angles.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromEuler(euler, update5 = true) {
    const x2 = euler._x, y = euler._y, z = euler._z, order = euler._order;
    const cos = Math.cos;
    const sin = Math.sin;
    const c1 = cos(x2 / 2);
    const c2 = cos(y / 2);
    const c3 = cos(z / 2);
    const s1 = sin(x2 / 2);
    const s2 = sin(y / 2);
    const s3 = sin(z / 2);
    switch (order) {
      case "XYZ":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "YXZ":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      case "ZXY":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "ZYX":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      case "YZX":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "XZY":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
    }
    if (update5 === true)
      this._onChangeCallback();
    return this;
  }
  /**
   * Sets this quaternion from the given axis and angle.
   *
   * @param {Vector3} axis - The normalized axis.
   * @param {number} angle - The angle in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromAxisAngle(axis, angle) {
    const halfAngle = angle / 2, s2 = Math.sin(halfAngle);
    this._x = axis.x * s2;
    this._y = axis.y * s2;
    this._z = axis.z * s2;
    this._w = Math.cos(halfAngle);
    this._onChangeCallback();
    return this;
  }
  /**
   * Sets this quaternion from the given rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromRotationMatrix(m) {
    const te2 = m.elements, m11 = te2[0], m12 = te2[4], m13 = te2[8], m21 = te2[1], m22 = te2[5], m23 = te2[9], m31 = te2[2], m32 = te2[6], m33 = te2[10], trace = m11 + m22 + m33;
    if (trace > 0) {
      const s2 = 0.5 / Math.sqrt(trace + 1);
      this._w = 0.25 / s2;
      this._x = (m32 - m23) * s2;
      this._y = (m13 - m31) * s2;
      this._z = (m21 - m12) * s2;
    } else if (m11 > m22 && m11 > m33) {
      const s2 = 2 * Math.sqrt(1 + m11 - m22 - m33);
      this._w = (m32 - m23) / s2;
      this._x = 0.25 * s2;
      this._y = (m12 + m21) / s2;
      this._z = (m13 + m31) / s2;
    } else if (m22 > m33) {
      const s2 = 2 * Math.sqrt(1 + m22 - m11 - m33);
      this._w = (m13 - m31) / s2;
      this._x = (m12 + m21) / s2;
      this._y = 0.25 * s2;
      this._z = (m23 + m32) / s2;
    } else {
      const s2 = 2 * Math.sqrt(1 + m33 - m11 - m22);
      this._w = (m21 - m12) / s2;
      this._x = (m13 + m31) / s2;
      this._y = (m23 + m32) / s2;
      this._z = 0.25 * s2;
    }
    this._onChangeCallback();
    return this;
  }
  /**
   * Sets this quaternion to the rotation required to rotate the direction vector
   * `vFrom` to the direction vector `vTo`.
   *
   * @param {Vector3} vFrom - The first (normalized) direction vector.
   * @param {Vector3} vTo - The second (normalized) direction vector.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromUnitVectors(vFrom, vTo) {
    let r = vFrom.dot(vTo) + 1;
    if (r < Number.EPSILON) {
      r = 0;
      if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
        this._x = -vFrom.y;
        this._y = vFrom.x;
        this._z = 0;
        this._w = r;
      } else {
        this._x = 0;
        this._y = -vFrom.z;
        this._z = vFrom.y;
        this._w = r;
      }
    } else {
      this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
      this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
      this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
      this._w = r;
    }
    return this.normalize();
  }
  /**
   * Returns the angle between this quaternion and the given one in radians.
   *
   * @param {Quaternion} q - The quaternion to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(q) {
    return 2 * Math.acos(Math.abs(clamp$2(this.dot(q), -1, 1)));
  }
  /**
   * Rotates this quaternion by a given angular step to the given quaternion.
   * The method ensures that the final quaternion will not overshoot `q`.
   *
   * @param {Quaternion} q - The target quaternion.
   * @param {number} step - The angular step in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  rotateTowards(q, step) {
    const angle = this.angleTo(q);
    if (angle === 0)
      return this;
    const t3 = Math.min(1, step / angle);
    this.slerp(q, t3);
    return this;
  }
  /**
   * Sets this quaternion to the identity quaternion; that is, to the
   * quaternion that represents "no rotation".
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  identity() {
    return this.set(0, 0, 0, 1);
  }
  /**
   * Inverts this quaternion via {@link Quaternion#conjugate}. The
   * quaternion is assumed to have unit length.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  invert() {
    return this.conjugate();
  }
  /**
   * Returns the rotational conjugate of this quaternion. The conjugate of a
   * quaternion represents the same rotation in the opposite direction about
   * the rotational axis.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  conjugate() {
    this._x *= -1;
    this._y *= -1;
    this._z *= -1;
    this._onChangeCallback();
    return this;
  }
  /**
   * Calculates the dot product of this quaternion and the given one.
   *
   * @param {Quaternion} v - The quaternion to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(v) {
    return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
  }
  /**
   * Computes the squared Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector. This can be useful if you are comparing the
   * lengths of two quaternions, as this is a slightly more efficient calculation than
   * {@link Quaternion#length}.
   *
   * @return {number} The squared Euclidean length.
   */
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  /**
   * Computes the Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector.
   *
   * @return {number} The Euclidean length.
   */
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  /**
   * Normalizes this quaternion - that is, calculated the quaternion that performs
   * the same rotation as this one, but has a length equal to `1`.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  normalize() {
    let l = this.length();
    if (l === 0) {
      this._x = 0;
      this._y = 0;
      this._z = 0;
      this._w = 1;
    } else {
      l = 1 / l;
      this._x = this._x * l;
      this._y = this._y * l;
      this._z = this._z * l;
      this._w = this._w * l;
    }
    this._onChangeCallback();
    return this;
  }
  /**
   * Multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiply(q) {
    return this.multiplyQuaternions(this, q);
  }
  /**
   * Pre-multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  premultiply(q) {
    return this.multiplyQuaternions(q, this);
  }
  /**
   * Multiplies the given quaternions and stores the result in this instance.
   *
   * @param {Quaternion} a - The first quaternion.
   * @param {Quaternion} b - The second quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiplyQuaternions(a, b) {
    const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
    const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
    this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
    this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
    this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
    this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
    this._onChangeCallback();
    return this;
  }
  /**
   * Performs a spherical linear interpolation between quaternions.
   *
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerp(qb, t3) {
    if (t3 === 0)
      return this;
    if (t3 === 1)
      return this.copy(qb);
    const x2 = this._x, y = this._y, z = this._z, w = this._w;
    let cosHalfTheta = w * qb._w + x2 * qb._x + y * qb._y + z * qb._z;
    if (cosHalfTheta < 0) {
      this._w = -qb._w;
      this._x = -qb._x;
      this._y = -qb._y;
      this._z = -qb._z;
      cosHalfTheta = -cosHalfTheta;
    } else {
      this.copy(qb);
    }
    if (cosHalfTheta >= 1) {
      this._w = w;
      this._x = x2;
      this._y = y;
      this._z = z;
      return this;
    }
    const sqrSinHalfTheta = 1 - cosHalfTheta * cosHalfTheta;
    if (sqrSinHalfTheta <= Number.EPSILON) {
      const s2 = 1 - t3;
      this._w = s2 * w + t3 * this._w;
      this._x = s2 * x2 + t3 * this._x;
      this._y = s2 * y + t3 * this._y;
      this._z = s2 * z + t3 * this._z;
      this.normalize();
      return this;
    }
    const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
    const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
    const ratioA = Math.sin((1 - t3) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t3 * halfTheta) / sinHalfTheta;
    this._w = w * ratioA + this._w * ratioB;
    this._x = x2 * ratioA + this._x * ratioB;
    this._y = y * ratioA + this._y * ratioB;
    this._z = z * ratioA + this._z * ratioB;
    this._onChangeCallback();
    return this;
  }
  /**
   * Performs a spherical linear interpolation between the given quaternions
   * and stores the result in this quaternion.
   *
   * @param {Quaternion} qa - The source quaternion.
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerpQuaternions(qa, qb, t3) {
    return this.copy(qa).slerp(qb, t3);
  }
  /**
   * Sets this quaternion to a uniformly random, normalized quaternion.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  random() {
    const theta1 = 2 * Math.PI * Math.random();
    const theta2 = 2 * Math.PI * Math.random();
    const x0 = Math.random();
    const r1 = Math.sqrt(1 - x0);
    const r2 = Math.sqrt(x0);
    return this.set(
      r1 * Math.sin(theta1),
      r1 * Math.cos(theta1),
      r2 * Math.sin(theta2),
      r2 * Math.cos(theta2)
    );
  }
  /**
   * Returns `true` if this quaternion is equal with the given one.
   *
   * @param {Quaternion} quaternion - The quaternion to test for equality.
   * @return {boolean} Whether this quaternion is equal with the given one.
   */
  equals(quaternion) {
    return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
  }
  /**
   * Sets this quaternion's components from the given array.
   *
   * @param {Array<number>} array - An array holding the quaternion component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromArray(array, offset2 = 0) {
    this._x = array[offset2];
    this._y = array[offset2 + 1];
    this._z = array[offset2 + 2];
    this._w = array[offset2 + 3];
    this._onChangeCallback();
    return this;
  }
  /**
   * Writes the components of this quaternion to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The quaternion components.
   */
  toArray(array = [], offset2 = 0) {
    array[offset2] = this._x;
    array[offset2 + 1] = this._y;
    array[offset2 + 2] = this._z;
    array[offset2 + 3] = this._w;
    return array;
  }
  /**
   * Sets the components of this quaternion from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
   * @param {number} index - The index into the attribute.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromBufferAttribute(attribute, index2) {
    this._x = attribute.getX(index2);
    this._y = attribute.getY(index2);
    this._z = attribute.getZ(index2);
    this._w = attribute.getW(index2);
    this._onChangeCallback();
    return this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the
   * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
   *
   * @return {Array<number>} The serialized quaternion.
   */
  toJSON() {
    return this.toArray();
  }
  _onChange(callback) {
    this._onChangeCallback = callback;
    return this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x;
    yield this._y;
    yield this._z;
    yield this._w;
  }
}
class Vector3 {
  /**
   * Constructs a new 3D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   */
  constructor(x2 = 0, y = 0, z = 0) {
    Vector3.prototype.isVector3 = true;
    this.x = x2;
    this.y = y;
    this.z = z;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @return {Vector3} A reference to this vector.
   */
  set(x2, y, z) {
    if (z === void 0)
      z = this.z;
    this.x = x2;
    this.y = y;
    this.z = z;
    return this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector3} A reference to this vector.
   */
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    this.z = scalar;
    return this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setX(x2) {
    this.x = x2;
    return this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setY(y) {
    this.y = y;
    return this;
  }
  /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setZ(z) {
    this.z = z;
    return this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @param {number} value - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setComponent(index2, value) {
    switch (index2) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      case 2:
        this.z = value;
        break;
      default:
        throw new Error("index is out of range: " + index2);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @return {number} A vector component value.
   */
  getComponent(index2) {
    switch (index2) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + index2);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector3} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3} v - The vector to copy.
   * @return {Vector3} A reference to this vector.
   */
  copy(v) {
    this.x = v.x;
    this.y = v.y;
    this.z = v.z;
    return this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector3} v - The vector to add.
   * @return {Vector3} A reference to this vector.
   */
  add(v) {
    this.x += v.x;
    this.y += v.y;
    this.z += v.z;
    return this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector3} A reference to this vector.
   */
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    this.z += s2;
    return this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  addVectors(a, b) {
    this.x = a.x + b.x;
    this.y = a.y + b.y;
    this.z = a.z + b.z;
    return this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector3|Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector3} A reference to this vector.
   */
  addScaledVector(v, s2) {
    this.x += v.x * s2;
    this.y += v.y * s2;
    this.z += v.z * s2;
    return this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector3} v - The vector to subtract.
   * @return {Vector3} A reference to this vector.
   */
  sub(v) {
    this.x -= v.x;
    this.y -= v.y;
    this.z -= v.z;
    return this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector3} A reference to this vector.
   */
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    this.z -= s2;
    return this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  subVectors(a, b) {
    this.x = a.x - b.x;
    this.y = a.y - b.y;
    this.z = a.z - b.z;
    return this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector3} v - The vector to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiply(v) {
    this.x *= v.x;
    this.y *= v.y;
    this.z *= v.z;
    return this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
    return this;
  }
  /**
   * Multiplies the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  multiplyVectors(a, b) {
    this.x = a.x * b.x;
    this.y = a.y * b.y;
    this.z = a.z * b.z;
    return this;
  }
  /**
   * Applies the given Euler rotation to this vector.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Vector3} A reference to this vector.
   */
  applyEuler(euler) {
    return this.applyQuaternion(_quaternion$4.setFromEuler(euler));
  }
  /**
   * Applies a rotation specified by an axis and an angle to this vector.
   *
   * @param {Vector3} axis - A normalized vector representing the rotation axis.
   * @param {number} angle - The angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  applyAxisAngle(axis, angle) {
    return this.applyQuaternion(_quaternion$4.setFromAxisAngle(axis, angle));
  }
  /**
   * Multiplies this vector with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix3(m) {
    const x2 = this.x, y = this.y, z = this.z;
    const e = m.elements;
    this.x = e[0] * x2 + e[3] * y + e[6] * z;
    this.y = e[1] * x2 + e[4] * y + e[7] * z;
    this.z = e[2] * x2 + e[5] * y + e[8] * z;
    return this;
  }
  /**
   * Multiplies this vector by the given normal matrix and normalizes
   * the result.
   *
   * @param {Matrix3} m - The normal matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyNormalMatrix(m) {
    return this.applyMatrix3(m).normalize();
  }
  /**
   * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
   * divides by perspective.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix4(m) {
    const x2 = this.x, y = this.y, z = this.z;
    const e = m.elements;
    const w = 1 / (e[3] * x2 + e[7] * y + e[11] * z + e[15]);
    this.x = (e[0] * x2 + e[4] * y + e[8] * z + e[12]) * w;
    this.y = (e[1] * x2 + e[5] * y + e[9] * z + e[13]) * w;
    this.z = (e[2] * x2 + e[6] * y + e[10] * z + e[14]) * w;
    return this;
  }
  /**
   * Applies the given Quaternion to this vector.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Vector3} A reference to this vector.
   */
  applyQuaternion(q) {
    const vx = this.x, vy = this.y, vz = this.z;
    const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
    const tx = 2 * (qy * vz - qz * vy);
    const ty = 2 * (qz * vx - qx * vz);
    const tz = 2 * (qx * vy - qy * vx);
    this.x = vx + qw * tx + qy * tz - qz * ty;
    this.y = vy + qw * ty + qz * tx - qx * tz;
    this.z = vz + qw * tz + qx * ty - qy * tx;
    return this;
  }
  /**
   * Projects this vector from world space into the camera's normalized
   * device coordinate (NDC) space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  project(camera2) {
    return this.applyMatrix4(camera2.matrixWorldInverse).applyMatrix4(camera2.projectionMatrix);
  }
  /**
   * Unprojects this vector from the camera's normalized device coordinate (NDC)
   * space into world space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  unproject(camera2) {
    return this.applyMatrix4(camera2.projectionMatrixInverse).applyMatrix4(camera2.matrixWorld);
  }
  /**
   * Transforms the direction of this vector by a matrix (the upper left 3 x 3
   * subset of the given 4x4 matrix and then normalizes the result.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Vector3} A reference to this vector.
   */
  transformDirection(m) {
    const x2 = this.x, y = this.y, z = this.z;
    const e = m.elements;
    this.x = e[0] * x2 + e[4] * y + e[8] * z;
    this.y = e[1] * x2 + e[5] * y + e[9] * z;
    this.z = e[2] * x2 + e[6] * y + e[10] * z;
    return this.normalize();
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector3} v - The vector to divide.
   * @return {Vector3} A reference to this vector.
   */
  divide(v) {
    this.x /= v.x;
    this.y /= v.y;
    this.z /= v.z;
    return this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector3} A reference to this vector.
   */
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  /**
   * If this vector's x, y or z value is greater than the given vector's x, y or z
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  min(v) {
    this.x = Math.min(this.x, v.x);
    this.y = Math.min(this.y, v.y);
    this.z = Math.min(this.z, v.z);
    return this;
  }
  /**
   * If this vector's x, y or z value is less than the given vector's x, y or z
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  max(v) {
    this.x = Math.max(this.x, v.x);
    this.y = Math.max(this.y, v.y);
    this.z = Math.max(this.z, v.z);
    return this;
  }
  /**
   * If this vector's x, y or z value is greater than the max vector's x, y or z
   * value, it is replaced by the corresponding value.
   * If this vector's x, y or z value is less than the min vector's x, y or z value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector3} min - The minimum x, y and z values.
   * @param {Vector3} max - The maximum x, y and z values in the desired range.
   * @return {Vector3} A reference to this vector.
   */
  clamp(min2, max2) {
    this.x = clamp$2(this.x, min2.x, max2.x);
    this.y = clamp$2(this.y, min2.y, max2.y);
    this.z = clamp$2(this.z, min2.z, max2.z);
    return this;
  }
  /**
   * If this vector's x, y or z values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y or z values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampScalar(minVal, maxVal) {
    this.x = clamp$2(this.x, minVal, maxVal);
    this.y = clamp$2(this.y, minVal, maxVal);
    this.z = clamp$2(this.z, minVal, maxVal);
    return this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampLength(min2, max2) {
    const length = this.length();
    return this.divideScalar(length || 1).multiplyScalar(clamp$2(length, min2, max2));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    return this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    return this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector3} A reference to this vector.
   */
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    return this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  roundToZero() {
    this.x = Math.trunc(this.x);
    this.y = Math.trunc(this.y);
    this.z = Math.trunc(this.z);
    return this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
   *
   * @return {Vector3} A reference to this vector.
   */
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    return this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(v) {
    return this.x * v.x + this.y * v.y + this.z * v.z;
  }
  // TODO lengthSquared?
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector3} A reference to this vector.
   */
  setLength(length) {
    return this.normalize().multiplyScalar(length);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector3} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerp(v, alpha) {
    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    this.z += (v.z - this.z) * alpha;
    return this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector3} v1 - The first vector.
   * @param {Vector3} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerpVectors(v1, v2, alpha) {
    this.x = v1.x + (v2.x - v1.x) * alpha;
    this.y = v1.y + (v2.y - v1.y) * alpha;
    this.z = v1.z + (v2.z - v1.z) * alpha;
    return this;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the cross product with.
   * @return {Vector3} The result of the cross product.
   */
  cross(v) {
    return this.crossVectors(this, v);
  }
  /**
   * Calculates the cross product of the given vectors and stores the result
   * in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  crossVectors(a, b) {
    const ax = a.x, ay = a.y, az = a.z;
    const bx = b.x, by = b.y, bz = b.z;
    this.x = ay * bz - az * by;
    this.y = az * bx - ax * bz;
    this.z = ax * by - ay * bx;
    return this;
  }
  /**
   * Projects this vector onto the given one.
   *
   * @param {Vector3} v - The vector to project to.
   * @return {Vector3} A reference to this vector.
   */
  projectOnVector(v) {
    const denominator = v.lengthSq();
    if (denominator === 0)
      return this.set(0, 0, 0);
    const scalar = v.dot(this) / denominator;
    return this.copy(v).multiplyScalar(scalar);
  }
  /**
   * Projects this vector onto a plane by subtracting this
   * vector projected onto the plane's normal from this vector.
   *
   * @param {Vector3} planeNormal - The plane normal.
   * @return {Vector3} A reference to this vector.
   */
  projectOnPlane(planeNormal) {
    _vector$c.copy(this).projectOnVector(planeNormal);
    return this.sub(_vector$c);
  }
  /**
   * Reflects this vector off a plane orthogonal to the given normal vector.
   *
   * @param {Vector3} normal - The (normalized) normal vector.
   * @return {Vector3} A reference to this vector.
   */
  reflect(normal) {
    return this.sub(_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector3} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(v) {
    const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
    if (denominator === 0)
      return Math.PI / 2;
    const theta = this.dot(v) / denominator;
    return Math.acos(clamp$2(theta, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(v) {
    return Math.sqrt(this.distanceToSquared(v));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector3} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(v) {
    const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
    return dx * dx + dy * dy + dz * dz;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(v) {
    return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {Spherical} s - The spherical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromSpherical(s2) {
    return this.setFromSphericalCoords(s2.radius, s2.phi, s2.theta);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} phi - The phi angle in radians.
   * @param {number} theta - The theta angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  setFromSphericalCoords(radius, phi, theta) {
    const sinPhiRadius = Math.sin(phi) * radius;
    this.x = sinPhiRadius * Math.sin(theta);
    this.y = Math.cos(phi) * radius;
    this.z = sinPhiRadius * Math.cos(theta);
    return this;
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {Cylindrical} c - The cylindrical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindrical(c) {
    return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} theta - The theta angle in radians.
   * @param {number} y - The y value.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindricalCoords(radius, theta, y) {
    this.x = radius * Math.sin(theta);
    this.y = y;
    this.z = radius * Math.cos(theta);
    return this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixPosition(m) {
    const e = m.elements;
    this.x = e[12];
    this.y = e[13];
    this.z = e[14];
    return this;
  }
  /**
   * Sets the vector components to the scale elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixScale(m) {
    const sx = this.setFromMatrixColumn(m, 0).length();
    const sy = this.setFromMatrixColumn(m, 1).length();
    const sz = this.setFromMatrixColumn(m, 2).length();
    this.x = sx;
    this.y = sy;
    this.z = sz;
    return this;
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixColumn(m, index2) {
    return this.fromArray(m.elements, index2 * 4);
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrix3Column(m, index2) {
    return this.fromArray(m.elements, index2 * 3);
  }
  /**
   * Sets the vector components from the given Euler angles.
   *
   * @param {Euler} e - The Euler angles to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromEuler(e) {
    this.x = e._x;
    this.y = e._y;
    this.z = e._z;
    return this;
  }
  /**
   * Sets the vector components from the RGB components of the
   * given color.
   *
   * @param {Color} c - The color to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromColor(c) {
    this.x = c.r;
    this.y = c.g;
    this.z = c.b;
    return this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector3} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(v) {
    return v.x === this.x && v.y === this.y && v.z === this.z;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
   * and z value to be `array[ offset + 2 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector3} A reference to this vector.
   */
  fromArray(array, offset2 = 0) {
    this.x = array[offset2];
    this.y = array[offset2 + 1];
    this.z = array[offset2 + 2];
    return this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(array = [], offset2 = 0) {
    array[offset2] = this.x;
    array[offset2 + 1] = this.y;
    array[offset2 + 2] = this.z;
    return array;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector3} A reference to this vector.
   */
  fromBufferAttribute(attribute, index2) {
    this.x = attribute.getX(index2);
    this.y = attribute.getY(index2);
    this.z = attribute.getZ(index2);
    return this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    return this;
  }
  /**
   * Sets this vector to a uniformly random point on a unit sphere.
   *
   * @return {Vector3} A reference to this vector.
   */
  randomDirection() {
    const theta = Math.random() * Math.PI * 2;
    const u = Math.random() * 2 - 1;
    const c = Math.sqrt(1 - u * u);
    this.x = c * Math.cos(theta);
    this.y = u;
    this.z = c * Math.sin(theta);
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
    yield this.z;
  }
}
const _vector$c = /* @__PURE__ */ new Vector3();
const _quaternion$4 = /* @__PURE__ */ new Quaternion();
class Box3 {
  /**
   * Constructs a new bounding box.
   *
   * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
   * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
   */
  constructor(min2 = new Vector3(Infinity, Infinity, Infinity), max2 = new Vector3(-Infinity, -Infinity, -Infinity)) {
    this.isBox3 = true;
    this.min = min2;
    this.max = max2;
  }
  /**
   * Sets the lower and upper boundaries of this box.
   * Please note that this method only copies the values from the given objects.
   *
   * @param {Vector3} min - The lower boundary of the box.
   * @param {Vector3} max - The upper boundary of the box.
   * @return {Box3} A reference to this bounding box.
   */
  set(min2, max2) {
    this.min.copy(min2);
    this.max.copy(max2);
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<number>} array - An array holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromArray(array) {
    this.makeEmpty();
    for (let i2 = 0, il = array.length; i2 < il; i2 += 3) {
      this.expandByPoint(_vector$b.fromArray(array, i2));
    }
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromBufferAttribute(attribute) {
    this.makeEmpty();
    for (let i2 = 0, il = attribute.count; i2 < il; i2++) {
      this.expandByPoint(_vector$b.fromBufferAttribute(attribute, i2));
    }
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
   * @return {Box3} A reference to this bounding box.
   */
  setFromPoints(points) {
    this.makeEmpty();
    for (let i2 = 0, il = points.length; i2 < il; i2++) {
      this.expandByPoint(points[i2]);
    }
    return this;
  }
  /**
   * Centers this box on the given center vector and sets this box's width, height and
   * depth to the given size values.
   *
   * @param {Vector3} center - The center of the box.
   * @param {Vector3} size - The x, y and z dimensions of the box.
   * @return {Box3} A reference to this bounding box.
   */
  setFromCenterAndSize(center, size) {
    const halfSize = _vector$b.copy(size).multiplyScalar(0.5);
    this.min.copy(center).sub(halfSize);
    this.max.copy(center).add(halfSize);
    return this;
  }
  /**
   * Computes the world-axis-aligned bounding box for the given 3D object
   * (including its children), accounting for the object's, and children's,
   * world transforms. The function may result in a larger box than strictly necessary.
   *
   * @param {Object3D} object - The 3D object to compute the bounding box for.
   * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
   * world-axis-aligned bounding box at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  setFromObject(object, precise = false) {
    this.makeEmpty();
    return this.expandByObject(object, precise);
  }
  /**
   * Returns a new box with copied values from this instance.
   *
   * @return {Box3} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given box to this instance.
   *
   * @param {Box3} box - The box to copy.
   * @return {Box3} A reference to this bounding box.
   */
  copy(box) {
    this.min.copy(box.min);
    this.max.copy(box.max);
    return this;
  }
  /**
   * Makes this box empty which means in encloses a zero space in 3D.
   *
   * @return {Box3} A reference to this bounding box.
   */
  makeEmpty() {
    this.min.x = this.min.y = this.min.z = Infinity;
    this.max.x = this.max.y = this.max.z = -Infinity;
    return this;
  }
  /**
   * Returns true if this box includes zero points within its bounds.
   * Note that a box with equal lower and upper bounds still includes one
   * point, the one both bounds share.
   *
   * @return {boolean} Whether this box is empty or not.
   */
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  /**
   * Returns the center point of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The center point.
   */
  getCenter(target2) {
    return this.isEmpty() ? target2.set(0, 0, 0) : target2.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  /**
   * Returns the dimensions of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The size.
   */
  getSize(target2) {
    return this.isEmpty() ? target2.set(0, 0, 0) : target2.subVectors(this.max, this.min);
  }
  /**
   * Expands the boundaries of this box to include the given point.
   *
   * @param {Vector3} point - The point that should be included by the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByPoint(point) {
    this.min.min(point);
    this.max.max(point);
    return this;
  }
  /**
   * Expands this box equilaterally by the given vector. The width of this
   * box will be expanded by the x component of the vector in both
   * directions. The height of this box will be expanded by the y component of
   * the vector in both directions. The depth of this box will be
   * expanded by the z component of the vector in both directions.
   *
   * @param {Vector3} vector - The vector that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByVector(vector) {
    this.min.sub(vector);
    this.max.add(vector);
    return this;
  }
  /**
   * Expands each dimension of the box by the given scalar. If negative, the
   * dimensions of the box will be contracted.
   *
   * @param {number} scalar - The scalar value that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByScalar(scalar) {
    this.min.addScalar(-scalar);
    this.max.addScalar(scalar);
    return this;
  }
  /**
   * Expands the boundaries of this box to include the given 3D object and
   * its children, accounting for the object's, and children's, world
   * transforms. The function may result in a larger box than strictly
   * necessary (unless the precise parameter is set to true).
   *
   * @param {Object3D} object - The 3D object that should expand the bounding box.
   * @param {boolean} precise - If set to `true`, the method expands the bounding box
   * as little as necessary at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  expandByObject(object, precise = false) {
    object.updateWorldMatrix(false, false);
    const geometry = object.geometry;
    if (geometry !== void 0) {
      const positionAttribute = geometry.getAttribute("position");
      if (precise === true && positionAttribute !== void 0 && object.isInstancedMesh !== true) {
        for (let i2 = 0, l = positionAttribute.count; i2 < l; i2++) {
          if (object.isMesh === true) {
            object.getVertexPosition(i2, _vector$b);
          } else {
            _vector$b.fromBufferAttribute(positionAttribute, i2);
          }
          _vector$b.applyMatrix4(object.matrixWorld);
          this.expandByPoint(_vector$b);
        }
      } else {
        if (object.boundingBox !== void 0) {
          if (object.boundingBox === null) {
            object.computeBoundingBox();
          }
          _box$4.copy(object.boundingBox);
        } else {
          if (geometry.boundingBox === null) {
            geometry.computeBoundingBox();
          }
          _box$4.copy(geometry.boundingBox);
        }
        _box$4.applyMatrix4(object.matrixWorld);
        this.union(_box$4);
      }
    }
    const children = object.children;
    for (let i2 = 0, l = children.length; i2 < l; i2++) {
      this.expandByObject(children[i2], precise);
    }
    return this;
  }
  /**
   * Returns `true` if the given point lies within or on the boundaries of this box.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the bounding box contains the given point or not.
   */
  containsPoint(point) {
    return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
  }
  /**
   * Returns `true` if this bounding box includes the entirety of the given bounding box.
   * If this box and the given one are identical, this function also returns `true`.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box contains the given bounding box or not.
   */
  containsBox(box) {
    return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
  }
  /**
   * Returns a point as a proportion of this box's width, height and depth.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A point as a proportion of this box's width, height and depth.
   */
  getParameter(point, target2) {
    return target2.set(
      (point.x - this.min.x) / (this.max.x - this.min.x),
      (point.y - this.min.y) / (this.max.y - this.min.y),
      (point.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  /**
   * Returns `true` if the given bounding box intersects with this bounding box.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with this bounding box.
   */
  intersectsBox(box) {
    return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
  }
  /**
   * Returns `true` if the given bounding sphere intersects with this bounding box.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
   */
  intersectsSphere(sphere) {
    this.clampPoint(sphere.center, _vector$b);
    return _vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
  }
  /**
   * Returns `true` if the given plane intersects with this bounding box.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether the given plane intersects with this bounding box.
   */
  intersectsPlane(plane) {
    let min2, max2;
    if (plane.normal.x > 0) {
      min2 = plane.normal.x * this.min.x;
      max2 = plane.normal.x * this.max.x;
    } else {
      min2 = plane.normal.x * this.max.x;
      max2 = plane.normal.x * this.min.x;
    }
    if (plane.normal.y > 0) {
      min2 += plane.normal.y * this.min.y;
      max2 += plane.normal.y * this.max.y;
    } else {
      min2 += plane.normal.y * this.max.y;
      max2 += plane.normal.y * this.min.y;
    }
    if (plane.normal.z > 0) {
      min2 += plane.normal.z * this.min.z;
      max2 += plane.normal.z * this.max.z;
    } else {
      min2 += plane.normal.z * this.max.z;
      max2 += plane.normal.z * this.min.z;
    }
    return min2 <= -plane.constant && max2 >= -plane.constant;
  }
  /**
   * Returns `true` if the given triangle intersects with this bounding box.
   *
   * @param {Triangle} triangle - The triangle to test.
   * @return {boolean} Whether the given triangle intersects with this bounding box.
   */
  intersectsTriangle(triangle) {
    if (this.isEmpty()) {
      return false;
    }
    this.getCenter(_center);
    _extents.subVectors(this.max, _center);
    _v0$2.subVectors(triangle.a, _center);
    _v1$7.subVectors(triangle.b, _center);
    _v2$4.subVectors(triangle.c, _center);
    _f0.subVectors(_v1$7, _v0$2);
    _f1.subVectors(_v2$4, _v1$7);
    _f2.subVectors(_v0$2, _v2$4);
    let axes = [
      0,
      -_f0.z,
      _f0.y,
      0,
      -_f1.z,
      _f1.y,
      0,
      -_f2.z,
      _f2.y,
      _f0.z,
      0,
      -_f0.x,
      _f1.z,
      0,
      -_f1.x,
      _f2.z,
      0,
      -_f2.x,
      -_f0.y,
      _f0.x,
      0,
      -_f1.y,
      _f1.x,
      0,
      -_f2.y,
      _f2.x,
      0
    ];
    if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) {
      return false;
    }
    axes = [1, 0, 0, 0, 1, 0, 0, 0, 1];
    if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) {
      return false;
    }
    _triangleNormal.crossVectors(_f0, _f1);
    axes = [_triangleNormal.x, _triangleNormal.y, _triangleNormal.z];
    return satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents);
  }
  /**
   * Clamps the given point within the bounds of this box.
   *
   * @param {Vector3} point - The point to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(point, target2) {
    return target2.copy(point).clamp(this.min, this.max);
  }
  /**
   * Returns the euclidean distance from any edge of this box to the specified point. If
   * the given point lies inside of this box, the distance will be `0`.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The euclidean distance.
   */
  distanceToPoint(point) {
    return this.clampPoint(point, _vector$b).distanceTo(point);
  }
  /**
   * Returns a bounding sphere that encloses this bounding box.
   *
   * @param {Sphere} target - The target sphere that is used to store the method's result.
   * @return {Sphere} The bounding sphere that encloses this bounding box.
   */
  getBoundingSphere(target2) {
    if (this.isEmpty()) {
      target2.makeEmpty();
    } else {
      this.getCenter(target2.center);
      target2.radius = this.getSize(_vector$b).length() * 0.5;
    }
    return target2;
  }
  /**
   * Computes the intersection of this bounding box and the given one, setting the upper
   * bound of this box to the lesser of the two boxes' upper bounds and the
   * lower bound of this box to the greater of the two boxes' lower bounds. If
   * there's no overlap, makes this box empty.
   *
   * @param {Box3} box - The bounding box to intersect with.
   * @return {Box3} A reference to this bounding box.
   */
  intersect(box) {
    this.min.max(box.min);
    this.max.min(box.max);
    if (this.isEmpty())
      this.makeEmpty();
    return this;
  }
  /**
   * Computes the union of this box and another and the given one, setting the upper
   * bound of this box to the greater of the two boxes' upper bounds and the
   * lower bound of this box to the lesser of the two boxes' lower bounds.
   *
   * @param {Box3} box - The bounding box that will be unioned with this instance.
   * @return {Box3} A reference to this bounding box.
   */
  union(box) {
    this.min.min(box.min);
    this.max.max(box.max);
    return this;
  }
  /**
   * Transforms this bounding box by the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Box3} A reference to this bounding box.
   */
  applyMatrix4(matrix2) {
    if (this.isEmpty())
      return this;
    _points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix2);
    _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix2);
    _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix2);
    _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix2);
    _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix2);
    _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix2);
    _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix2);
    _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix2);
    this.setFromPoints(_points);
    return this;
  }
  /**
   * Adds the given offset to both the upper and lower bounds of this bounding box,
   * effectively moving it in 3D space.
   *
   * @param {Vector3} offset - The offset that should be used to translate the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  translate(offset2) {
    this.min.add(offset2);
    this.max.add(offset2);
    return this;
  }
  /**
   * Returns `true` if this bounding box is equal with the given one.
   *
   * @param {Box3} box - The box to test for equality.
   * @return {boolean} Whether this bounding box is equal with the given one.
   */
  equals(box) {
    return box.min.equals(this.min) && box.max.equals(this.max);
  }
}
const _points = [
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3()
];
const _vector$b = /* @__PURE__ */ new Vector3();
const _box$4 = /* @__PURE__ */ new Box3();
const _v0$2 = /* @__PURE__ */ new Vector3();
const _v1$7 = /* @__PURE__ */ new Vector3();
const _v2$4 = /* @__PURE__ */ new Vector3();
const _f0 = /* @__PURE__ */ new Vector3();
const _f1 = /* @__PURE__ */ new Vector3();
const _f2 = /* @__PURE__ */ new Vector3();
const _center = /* @__PURE__ */ new Vector3();
const _extents = /* @__PURE__ */ new Vector3();
const _triangleNormal = /* @__PURE__ */ new Vector3();
const _testAxis = /* @__PURE__ */ new Vector3();
function satForAxes(axes, v0, v1, v2, extents) {
  for (let i2 = 0, j = axes.length - 3; i2 <= j; i2 += 3) {
    _testAxis.fromArray(axes, i2);
    const r = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z);
    const p0 = v0.dot(_testAxis);
    const p1 = v1.dot(_testAxis);
    const p2 = v2.dot(_testAxis);
    if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) {
      return false;
    }
  }
  return true;
}
const _vector$a = /* @__PURE__ */ new Vector3();
const _segCenter = /* @__PURE__ */ new Vector3();
const _segDir = /* @__PURE__ */ new Vector3();
const _diff = /* @__PURE__ */ new Vector3();
const _edge1 = /* @__PURE__ */ new Vector3();
const _edge2 = /* @__PURE__ */ new Vector3();
const _normal$1 = /* @__PURE__ */ new Vector3();
class Ray {
  /**
   * Constructs a new ray.
   *
   * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
   * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
   */
  constructor(origin = new Vector3(), direction = new Vector3(0, 0, -1)) {
    this.origin = origin;
    this.direction = direction;
  }
  /**
   * Sets the ray's components by copying the given values.
   *
   * @param {Vector3} origin - The origin.
   * @param {Vector3} direction - The direction.
   * @return {Ray} A reference to this ray.
   */
  set(origin, direction) {
    this.origin.copy(origin);
    this.direction.copy(direction);
    return this;
  }
  /**
   * Copies the values of the given ray to this instance.
   *
   * @param {Ray} ray - The ray to copy.
   * @return {Ray} A reference to this ray.
   */
  copy(ray) {
    this.origin.copy(ray.origin);
    this.direction.copy(ray.direction);
    return this;
  }
  /**
   * Returns a vector that is located at a given distance along this ray.
   *
   * @param {number} t - The distance along the ray to retrieve a position for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A position on the ray.
   */
  at(t3, target2) {
    return target2.copy(this.origin).addScaledVector(this.direction, t3);
  }
  /**
   * Adjusts the direction of the ray to point at the given vector in world space.
   *
   * @param {Vector3} v - The target position.
   * @return {Ray} A reference to this ray.
   */
  lookAt(v) {
    this.direction.copy(v).sub(this.origin).normalize();
    return this;
  }
  /**
   * Shift the origin of this ray along its direction by the given distance.
   *
   * @param {number} t - The distance along the ray to interpolate.
   * @return {Ray} A reference to this ray.
   */
  recast(t3) {
    this.origin.copy(this.at(t3, _vector$a));
    return this;
  }
  /**
   * Returns the point along this ray that is closest to the given point.
   *
   * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on this ray.
   */
  closestPointToPoint(point, target2) {
    target2.subVectors(point, this.origin);
    const directionDistance = target2.dot(this.direction);
    if (directionDistance < 0) {
      return target2.copy(this.origin);
    }
    return target2.copy(this.origin).addScaledVector(this.direction, directionDistance);
  }
  /**
   * Returns the distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The distance.
   */
  distanceToPoint(point) {
    return Math.sqrt(this.distanceSqToPoint(point));
  }
  /**
   * Returns the squared distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The squared distance.
   */
  distanceSqToPoint(point) {
    const directionDistance = _vector$a.subVectors(point, this.origin).dot(this.direction);
    if (directionDistance < 0) {
      return this.origin.distanceToSquared(point);
    }
    _vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
    return _vector$a.distanceToSquared(point);
  }
  /**
   * Returns the squared distance between this ray and the given line segment.
   *
   * @param {Vector3} v0 - The start point of the line segment.
   * @param {Vector3} v1 - The end point of the line segment.
   * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
   * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
   * @return {number} The squared distance.
   */
  distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
    _segCenter.copy(v0).add(v1).multiplyScalar(0.5);
    _segDir.copy(v1).sub(v0).normalize();
    _diff.copy(this.origin).sub(_segCenter);
    const segExtent = v0.distanceTo(v1) * 0.5;
    const a01 = -this.direction.dot(_segDir);
    const b0 = _diff.dot(this.direction);
    const b1 = -_diff.dot(_segDir);
    const c = _diff.lengthSq();
    const det = Math.abs(1 - a01 * a01);
    let s0, s1, sqrDist, extDet;
    if (det > 0) {
      s0 = a01 * b1 - b0;
      s1 = a01 * b0 - b1;
      extDet = segExtent * det;
      if (s0 >= 0) {
        if (s1 >= -extDet) {
          if (s1 <= extDet) {
            const invDet = 1 / det;
            s0 *= invDet;
            s1 *= invDet;
            sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
          } else {
            s1 = segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
          }
        } else {
          s1 = -segExtent;
          s0 = Math.max(0, -(a01 * s1 + b0));
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
      } else {
        if (s1 <= -extDet) {
          s0 = Math.max(0, -(-a01 * segExtent + b0));
          s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        } else if (s1 <= extDet) {
          s0 = 0;
          s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = s1 * (s1 + 2 * b1) + c;
        } else {
          s0 = Math.max(0, -(a01 * segExtent + b0));
          s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
      }
    } else {
      s1 = a01 > 0 ? -segExtent : segExtent;
      s0 = Math.max(0, -(a01 * s1 + b0));
      sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
    }
    if (optionalPointOnRay) {
      optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
    }
    if (optionalPointOnSegment) {
      optionalPointOnSegment.copy(_segCenter).addScaledVector(_segDir, s1);
    }
    return sqrDist;
  }
  /**
   * Intersects this ray with the given sphere, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectSphere(sphere, target2) {
    _vector$a.subVectors(sphere.center, this.origin);
    const tca = _vector$a.dot(this.direction);
    const d2 = _vector$a.dot(_vector$a) - tca * tca;
    const radius2 = sphere.radius * sphere.radius;
    if (d2 > radius2)
      return null;
    const thc = Math.sqrt(radius2 - d2);
    const t0 = tca - thc;
    const t1 = tca + thc;
    if (t1 < 0)
      return null;
    if (t0 < 0)
      return this.at(t1, target2);
    return this.at(t0, target2);
  }
  /**
   * Returns `true` if this ray intersects with the given sphere.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @return {boolean} Whether this ray intersects with the given sphere or not.
   */
  intersectsSphere(sphere) {
    return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
  }
  /**
   * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
   * does not intersect with the plane.
   *
   * @param {Plane} plane - The plane to compute the distance to.
   * @return {?number} Whether this ray intersects with the given sphere or not.
   */
  distanceToPlane(plane) {
    const denominator = plane.normal.dot(this.direction);
    if (denominator === 0) {
      if (plane.distanceToPoint(this.origin) === 0) {
        return 0;
      }
      return null;
    }
    const t3 = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
    return t3 >= 0 ? t3 : null;
  }
  /**
   * Intersects this ray with the given plane, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Plane} plane - The plane to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectPlane(plane, target2) {
    const t3 = this.distanceToPlane(plane);
    if (t3 === null) {
      return null;
    }
    return this.at(t3, target2);
  }
  /**
   * Returns `true` if this ray intersects with the given plane.
   *
   * @param {Plane} plane - The plane to intersect.
   * @return {boolean} Whether this ray intersects with the given plane or not.
   */
  intersectsPlane(plane) {
    const distToPoint = plane.distanceToPoint(this.origin);
    if (distToPoint === 0) {
      return true;
    }
    const denominator = plane.normal.dot(this.direction);
    if (denominator * distToPoint < 0) {
      return true;
    }
    return false;
  }
  /**
   * Intersects this ray with the given bounding box, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Box3} box - The box to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectBox(box, target2) {
    let tmin, tmax, tymin, tymax, tzmin, tzmax;
    const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
    const origin = this.origin;
    if (invdirx >= 0) {
      tmin = (box.min.x - origin.x) * invdirx;
      tmax = (box.max.x - origin.x) * invdirx;
    } else {
      tmin = (box.max.x - origin.x) * invdirx;
      tmax = (box.min.x - origin.x) * invdirx;
    }
    if (invdiry >= 0) {
      tymin = (box.min.y - origin.y) * invdiry;
      tymax = (box.max.y - origin.y) * invdiry;
    } else {
      tymin = (box.max.y - origin.y) * invdiry;
      tymax = (box.min.y - origin.y) * invdiry;
    }
    if (tmin > tymax || tymin > tmax)
      return null;
    if (tymin > tmin || isNaN(tmin))
      tmin = tymin;
    if (tymax < tmax || isNaN(tmax))
      tmax = tymax;
    if (invdirz >= 0) {
      tzmin = (box.min.z - origin.z) * invdirz;
      tzmax = (box.max.z - origin.z) * invdirz;
    } else {
      tzmin = (box.max.z - origin.z) * invdirz;
      tzmax = (box.min.z - origin.z) * invdirz;
    }
    if (tmin > tzmax || tzmin > tmax)
      return null;
    if (tzmin > tmin || tmin !== tmin)
      tmin = tzmin;
    if (tzmax < tmax || tmax !== tmax)
      tmax = tzmax;
    if (tmax < 0)
      return null;
    return this.at(tmin >= 0 ? tmin : tmax, target2);
  }
  /**
   * Returns `true` if this ray intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this ray intersects with the given box or not.
   */
  intersectsBox(box) {
    return this.intersectBox(box, _vector$a) !== null;
  }
  /**
   * Intersects this ray with the given triangle, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Vector3} a - The first vertex of the triangle.
   * @param {Vector3} b - The second vertex of the triangle.
   * @param {Vector3} c - The third vertex of the triangle.
   * @param {boolean} backfaceCulling - Whether to use backface culling or not.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectTriangle(a, b, c, backfaceCulling, target2) {
    _edge1.subVectors(b, a);
    _edge2.subVectors(c, a);
    _normal$1.crossVectors(_edge1, _edge2);
    let DdN = this.direction.dot(_normal$1);
    let sign;
    if (DdN > 0) {
      if (backfaceCulling)
        return null;
      sign = 1;
    } else if (DdN < 0) {
      sign = -1;
      DdN = -DdN;
    } else {
      return null;
    }
    _diff.subVectors(this.origin, a);
    const DdQxE2 = sign * this.direction.dot(_edge2.crossVectors(_diff, _edge2));
    if (DdQxE2 < 0) {
      return null;
    }
    const DdE1xQ = sign * this.direction.dot(_edge1.cross(_diff));
    if (DdE1xQ < 0) {
      return null;
    }
    if (DdQxE2 + DdE1xQ > DdN) {
      return null;
    }
    const QdN = -sign * _diff.dot(_normal$1);
    if (QdN < 0) {
      return null;
    }
    return this.at(QdN / DdN, target2);
  }
  /**
   * Transforms this ray with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix4 - The transformation matrix.
   * @return {Ray} A reference to this ray.
   */
  applyMatrix4(matrix4) {
    this.origin.applyMatrix4(matrix4);
    this.direction.transformDirection(matrix4);
    return this;
  }
  /**
   * Returns `true` if this ray is equal with the given one.
   *
   * @param {Ray} ray - The ray to test for equality.
   * @return {boolean} Whether this ray is equal with the given one.
   */
  equals(ray) {
    return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
  }
  /**
   * Returns a new ray with copied values from this instance.
   *
   * @return {Ray} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class Matrix4 {
  /**
   * Constructs a new 4x4 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   */
  constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
    Matrix4.prototype.isMatrix4 = true;
    this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ];
    if (n11 !== void 0) {
      this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   * @return {Matrix4} A reference to this matrix.
   */
  set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
    const te2 = this.elements;
    te2[0] = n11;
    te2[4] = n12;
    te2[8] = n13;
    te2[12] = n14;
    te2[1] = n21;
    te2[5] = n22;
    te2[9] = n23;
    te2[13] = n24;
    te2[2] = n31;
    te2[6] = n32;
    te2[10] = n33;
    te2[14] = n34;
    te2[3] = n41;
    te2[7] = n42;
    te2[11] = n43;
    te2[15] = n44;
    return this;
  }
  /**
   * Sets this matrix to the 4x4 identity matrix.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix4} A clone of this instance.
   */
  clone() {
    return new Matrix4().fromArray(this.elements);
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix4} m - The matrix to copy.
   * @return {Matrix4} A reference to this matrix.
   */
  copy(m) {
    const te2 = this.elements;
    const me = m.elements;
    te2[0] = me[0];
    te2[1] = me[1];
    te2[2] = me[2];
    te2[3] = me[3];
    te2[4] = me[4];
    te2[5] = me[5];
    te2[6] = me[6];
    te2[7] = me[7];
    te2[8] = me[8];
    te2[9] = me[9];
    te2[10] = me[10];
    te2[11] = me[11];
    te2[12] = me[12];
    te2[13] = me[13];
    te2[14] = me[14];
    te2[15] = me[15];
    return this;
  }
  /**
   * Copies the translation component of the given matrix
   * into this matrix's translation component.
   *
   * @param {Matrix4} m - The matrix to copy the translation component.
   * @return {Matrix4} A reference to this matrix.
   */
  copyPosition(m) {
    const te2 = this.elements, me = m.elements;
    te2[12] = me[12];
    te2[13] = me[13];
    te2[14] = me[14];
    return this;
  }
  /**
   * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  setFromMatrix3(m) {
    const me = m.elements;
    this.set(
      me[0],
      me[3],
      me[6],
      0,
      me[1],
      me[4],
      me[7],
      0,
      me[2],
      me[5],
      me[8],
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrixColumn(this, 0);
    yAxis.setFromMatrixColumn(this, 1);
    zAxis.setFromMatrixColumn(this, 2);
    return this;
  }
  /**
   * Sets the given basis vectors to this matrix.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeBasis(xAxis, yAxis, zAxis) {
    this.set(
      xAxis.x,
      yAxis.x,
      zAxis.x,
      0,
      xAxis.y,
      yAxis.y,
      zAxis.y,
      0,
      xAxis.z,
      yAxis.z,
      zAxis.z,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Extracts the rotation component of the given matrix
   * into this matrix's rotation component.
   *
   * Note: This method does not support reflection matrices.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  extractRotation(m) {
    const te2 = this.elements;
    const me = m.elements;
    const scaleX = 1 / _v1$5.setFromMatrixColumn(m, 0).length();
    const scaleY = 1 / _v1$5.setFromMatrixColumn(m, 1).length();
    const scaleZ = 1 / _v1$5.setFromMatrixColumn(m, 2).length();
    te2[0] = me[0] * scaleX;
    te2[1] = me[1] * scaleX;
    te2[2] = me[2] * scaleX;
    te2[3] = 0;
    te2[4] = me[4] * scaleY;
    te2[5] = me[5] * scaleY;
    te2[6] = me[6] * scaleY;
    te2[7] = 0;
    te2[8] = me[8] * scaleZ;
    te2[9] = me[9] * scaleZ;
    te2[10] = me[10] * scaleZ;
    te2[11] = 0;
    te2[12] = 0;
    te2[13] = 0;
    te2[14] = 0;
    te2[15] = 1;
    return this;
  }
  /**
   * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
   * the rotation specified by the given Euler angles. The rest of
   * the matrix is set to the identity. Depending on the {@link Euler#order},
   * there are six possible outcomes. See [this page]{@link https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix}
   * for a complete list.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromEuler(euler) {
    const te2 = this.elements;
    const x2 = euler.x, y = euler.y, z = euler.z;
    const a = Math.cos(x2), b = Math.sin(x2);
    const c = Math.cos(y), d2 = Math.sin(y);
    const e = Math.cos(z), f = Math.sin(z);
    if (euler.order === "XYZ") {
      const ae = a * e, af = a * f, be = b * e, bf = b * f;
      te2[0] = c * e;
      te2[4] = -c * f;
      te2[8] = d2;
      te2[1] = af + be * d2;
      te2[5] = ae - bf * d2;
      te2[9] = -b * c;
      te2[2] = bf - ae * d2;
      te2[6] = be + af * d2;
      te2[10] = a * c;
    } else if (euler.order === "YXZ") {
      const ce = c * e, cf = c * f, de = d2 * e, df = d2 * f;
      te2[0] = ce + df * b;
      te2[4] = de * b - cf;
      te2[8] = a * d2;
      te2[1] = a * f;
      te2[5] = a * e;
      te2[9] = -b;
      te2[2] = cf * b - de;
      te2[6] = df + ce * b;
      te2[10] = a * c;
    } else if (euler.order === "ZXY") {
      const ce = c * e, cf = c * f, de = d2 * e, df = d2 * f;
      te2[0] = ce - df * b;
      te2[4] = -a * f;
      te2[8] = de + cf * b;
      te2[1] = cf + de * b;
      te2[5] = a * e;
      te2[9] = df - ce * b;
      te2[2] = -a * d2;
      te2[6] = b;
      te2[10] = a * c;
    } else if (euler.order === "ZYX") {
      const ae = a * e, af = a * f, be = b * e, bf = b * f;
      te2[0] = c * e;
      te2[4] = be * d2 - af;
      te2[8] = ae * d2 + bf;
      te2[1] = c * f;
      te2[5] = bf * d2 + ae;
      te2[9] = af * d2 - be;
      te2[2] = -d2;
      te2[6] = b * c;
      te2[10] = a * c;
    } else if (euler.order === "YZX") {
      const ac = a * c, ad = a * d2, bc = b * c, bd = b * d2;
      te2[0] = c * e;
      te2[4] = bd - ac * f;
      te2[8] = bc * f + ad;
      te2[1] = f;
      te2[5] = a * e;
      te2[9] = -b * e;
      te2[2] = -d2 * e;
      te2[6] = ad * f + bc;
      te2[10] = ac - bd * f;
    } else if (euler.order === "XZY") {
      const ac = a * c, ad = a * d2, bc = b * c, bd = b * d2;
      te2[0] = c * e;
      te2[4] = -f;
      te2[8] = d2 * e;
      te2[1] = ac * f + bd;
      te2[5] = a * e;
      te2[9] = ad * f - bc;
      te2[2] = bc * f - ad;
      te2[6] = b * e;
      te2[10] = bd * f + ac;
    }
    te2[3] = 0;
    te2[7] = 0;
    te2[11] = 0;
    te2[12] = 0;
    te2[13] = 0;
    te2[14] = 0;
    te2[15] = 1;
    return this;
  }
  /**
   * Sets the rotation component of this matrix to the rotation specified by
   * the given Quaternion as outlined [here]{@link https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion}
   * The rest of the matrix is set to the identity.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromQuaternion(q) {
    return this.compose(_zero, q, _one);
  }
  /**
   * Sets the rotation component of the transformation matrix, looking from `eye` towards
   * `target`, and oriented by the up-direction.
   *
   * @param {Vector3} eye - The eye vector.
   * @param {Vector3} target - The target vector.
   * @param {Vector3} up - The up vector.
   * @return {Matrix4} A reference to this matrix.
   */
  lookAt(eye, target2, up) {
    const te2 = this.elements;
    _z.subVectors(eye, target2);
    if (_z.lengthSq() === 0) {
      _z.z = 1;
    }
    _z.normalize();
    _x.crossVectors(up, _z);
    if (_x.lengthSq() === 0) {
      if (Math.abs(up.z) === 1) {
        _z.x += 1e-4;
      } else {
        _z.z += 1e-4;
      }
      _z.normalize();
      _x.crossVectors(up, _z);
    }
    _x.normalize();
    _y.crossVectors(_z, _x);
    te2[0] = _x.x;
    te2[4] = _y.x;
    te2[8] = _z.x;
    te2[1] = _x.y;
    te2[5] = _y.y;
    te2[9] = _z.y;
    te2[2] = _x.z;
    te2[6] = _y.z;
    te2[10] = _z.z;
    return this;
  }
  /**
   * Post-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  multiply(m) {
    return this.multiplyMatrices(this, m);
  }
  /**
   * Pre-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  premultiply(m) {
    return this.multiplyMatrices(m, this);
  }
  /**
   * Multiples the given 4x4 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix4} a - The first matrix.
   * @param {Matrix4} b - The second matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyMatrices(a, b) {
    const ae = a.elements;
    const be = b.elements;
    const te2 = this.elements;
    const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
    const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
    const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
    const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
    const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
    const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
    const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
    const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
    te2[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
    te2[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
    te2[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
    te2[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
    te2[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
    te2[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
    te2[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
    te2[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
    te2[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
    te2[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
    te2[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
    te2[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
    te2[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
    te2[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
    te2[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
    te2[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
    return this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyScalar(s2) {
    const te2 = this.elements;
    te2[0] *= s2;
    te2[4] *= s2;
    te2[8] *= s2;
    te2[12] *= s2;
    te2[1] *= s2;
    te2[5] *= s2;
    te2[9] *= s2;
    te2[13] *= s2;
    te2[2] *= s2;
    te2[6] *= s2;
    te2[10] *= s2;
    te2[14] *= s2;
    te2[3] *= s2;
    te2[7] *= s2;
    te2[11] *= s2;
    te2[15] *= s2;
    return this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * Based on the method outlined [here]{@link http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html}.
   *
   * @return {number} The determinant.
   */
  determinant() {
    const te2 = this.elements;
    const n11 = te2[0], n12 = te2[4], n13 = te2[8], n14 = te2[12];
    const n21 = te2[1], n22 = te2[5], n23 = te2[9], n24 = te2[13];
    const n31 = te2[2], n32 = te2[6], n33 = te2[10], n34 = te2[14];
    const n41 = te2[3], n42 = te2[7], n43 = te2[11], n44 = te2[15];
    return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  transpose() {
    const te2 = this.elements;
    let tmp;
    tmp = te2[1];
    te2[1] = te2[4];
    te2[4] = tmp;
    tmp = te2[2];
    te2[2] = te2[8];
    te2[8] = tmp;
    tmp = te2[6];
    te2[6] = te2[9];
    te2[9] = tmp;
    tmp = te2[3];
    te2[3] = te2[12];
    te2[12] = tmp;
    tmp = te2[7];
    te2[7] = te2[13];
    te2[13] = tmp;
    tmp = te2[11];
    te2[11] = te2[14];
    te2[14] = tmp;
    return this;
  }
  /**
   * Sets the position component for this matrix from the given vector,
   * without affecting the rest of the matrix.
   *
   * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
   * @param {number} y - The y component of the vector.
   * @param {number} z - The z component of the vector.
   * @return {Matrix4} A reference to this matrix.
   */
  setPosition(x2, y, z) {
    const te2 = this.elements;
    if (x2.isVector3) {
      te2[12] = x2.x;
      te2[13] = x2.y;
      te2[14] = x2.z;
    } else {
      te2[12] = x2;
      te2[13] = y;
      te2[14] = z;
    }
    return this;
  }
  /**
   * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  invert() {
    const te2 = this.elements, n11 = te2[0], n21 = te2[1], n31 = te2[2], n41 = te2[3], n12 = te2[4], n22 = te2[5], n32 = te2[6], n42 = te2[7], n13 = te2[8], n23 = te2[9], n33 = te2[10], n43 = te2[11], n14 = te2[12], n24 = te2[13], n34 = te2[14], n44 = te2[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
    const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
    if (det === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det;
    te2[0] = t11 * detInv;
    te2[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
    te2[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
    te2[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
    te2[4] = t12 * detInv;
    te2[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
    te2[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
    te2[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
    te2[8] = t13 * detInv;
    te2[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
    te2[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
    te2[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
    te2[12] = t14 * detInv;
    te2[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
    te2[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
    te2[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
    return this;
  }
  /**
   * Multiplies the columns of this matrix by the given vector.
   *
   * @param {Vector3} v - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  scale(v) {
    const te2 = this.elements;
    const x2 = v.x, y = v.y, z = v.z;
    te2[0] *= x2;
    te2[4] *= y;
    te2[8] *= z;
    te2[1] *= x2;
    te2[5] *= y;
    te2[9] *= z;
    te2[2] *= x2;
    te2[6] *= y;
    te2[10] *= z;
    te2[3] *= x2;
    te2[7] *= y;
    te2[11] *= z;
    return this;
  }
  /**
   * Gets the maximum scale value of the three axes.
   *
   * @return {number} The maximum scale.
   */
  getMaxScaleOnAxis() {
    const te2 = this.elements;
    const scaleXSq = te2[0] * te2[0] + te2[1] * te2[1] + te2[2] * te2[2];
    const scaleYSq = te2[4] * te2[4] + te2[5] * te2[5] + te2[6] * te2[6];
    const scaleZSq = te2[8] * te2[8] + te2[9] * te2[9] + te2[10] * te2[10];
    return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
  }
  /**
   * Sets this matrix as a translation transform from the given vector.
   *
   * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @param {number} z - The amount to translate in the z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeTranslation(x2, y, z) {
    if (x2.isVector3) {
      this.set(
        1,
        0,
        0,
        x2.x,
        0,
        1,
        0,
        x2.y,
        0,
        0,
        1,
        x2.z,
        0,
        0,
        0,
        1
      );
    } else {
      this.set(
        1,
        0,
        0,
        x2,
        0,
        1,
        0,
        y,
        0,
        0,
        1,
        z,
        0,
        0,
        0,
        1
      );
    }
    return this;
  }
  /**
   * Sets this matrix as a rotational transformation around the X axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationX(theta) {
    const c = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      1,
      0,
      0,
      0,
      0,
      c,
      -s2,
      0,
      0,
      s2,
      c,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Y axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationY(theta) {
    const c = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      c,
      0,
      s2,
      0,
      0,
      1,
      0,
      0,
      -s2,
      0,
      c,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Z axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationZ(theta) {
    const c = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      c,
      -s2,
      0,
      0,
      s2,
      c,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Sets this matrix as a rotational transformation around the given axis by
   * the given angle.
   *
   * This is a somewhat controversial but mathematically sound alternative to
   * rotating via Quaternions. See the discussion [here]{@link https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199}.
   *
   * @param {Vector3} axis - The normalized rotation axis.
   * @param {number} angle - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationAxis(axis, angle) {
    const c = Math.cos(angle);
    const s2 = Math.sin(angle);
    const t3 = 1 - c;
    const x2 = axis.x, y = axis.y, z = axis.z;
    const tx = t3 * x2, ty = t3 * y;
    this.set(
      tx * x2 + c,
      tx * y - s2 * z,
      tx * z + s2 * y,
      0,
      tx * y + s2 * z,
      ty * y + c,
      ty * z - s2 * x2,
      0,
      tx * z - s2 * y,
      ty * z + s2 * x2,
      t3 * z * z + c,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Sets this matrix as a scale transformation.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @param {number} z - The amount to scale in the Z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeScale(x2, y, z) {
    this.set(
      x2,
      0,
      0,
      0,
      0,
      y,
      0,
      0,
      0,
      0,
      z,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Sets this matrix as a shear transformation.
   *
   * @param {number} xy - The amount to shear X by Y.
   * @param {number} xz - The amount to shear X by Z.
   * @param {number} yx - The amount to shear Y by X.
   * @param {number} yz - The amount to shear Y by Z.
   * @param {number} zx - The amount to shear Z by X.
   * @param {number} zy - The amount to shear Z by Y.
   * @return {Matrix4} A reference to this matrix.
   */
  makeShear(xy, xz, yx, yz, zx, zy) {
    this.set(
      1,
      yx,
      zx,
      0,
      xy,
      1,
      zy,
      0,
      xz,
      yz,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  /**
   * Sets this matrix to the transformation composed of the given position,
   * rotation (Quaternion) and scale.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  compose(position, quaternion, scale) {
    const te2 = this.elements;
    const x2 = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
    const x22 = x2 + x2, y2 = y + y, z2 = z + z;
    const xx = x2 * x22, xy = x2 * y2, xz = x2 * z2;
    const yy = y * y2, yz = y * z2, zz = z * z2;
    const wx = w * x22, wy = w * y2, wz = w * z2;
    const sx = scale.x, sy = scale.y, sz = scale.z;
    te2[0] = (1 - (yy + zz)) * sx;
    te2[1] = (xy + wz) * sx;
    te2[2] = (xz - wy) * sx;
    te2[3] = 0;
    te2[4] = (xy - wz) * sy;
    te2[5] = (1 - (xx + zz)) * sy;
    te2[6] = (yz + wx) * sy;
    te2[7] = 0;
    te2[8] = (xz + wy) * sz;
    te2[9] = (yz - wx) * sz;
    te2[10] = (1 - (xx + yy)) * sz;
    te2[11] = 0;
    te2[12] = position.x;
    te2[13] = position.y;
    te2[14] = position.z;
    te2[15] = 1;
    return this;
  }
  /**
   * Decomposes this matrix into its position, rotation and scale components
   * and provides the result in the given objects.
   *
   * Note: Not all matrices are decomposable in this way. For example, if an
   * object has a non-uniformly scaled parent, then the object's world matrix
   * may not be decomposable, and this method may not be appropriate.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  decompose(position, quaternion, scale) {
    const te2 = this.elements;
    let sx = _v1$5.set(te2[0], te2[1], te2[2]).length();
    const sy = _v1$5.set(te2[4], te2[5], te2[6]).length();
    const sz = _v1$5.set(te2[8], te2[9], te2[10]).length();
    const det = this.determinant();
    if (det < 0)
      sx = -sx;
    position.x = te2[12];
    position.y = te2[13];
    position.z = te2[14];
    _m1$2.copy(this);
    const invSX = 1 / sx;
    const invSY = 1 / sy;
    const invSZ = 1 / sz;
    _m1$2.elements[0] *= invSX;
    _m1$2.elements[1] *= invSX;
    _m1$2.elements[2] *= invSX;
    _m1$2.elements[4] *= invSY;
    _m1$2.elements[5] *= invSY;
    _m1$2.elements[6] *= invSY;
    _m1$2.elements[8] *= invSZ;
    _m1$2.elements[9] *= invSZ;
    _m1$2.elements[10] *= invSZ;
    quaternion.setFromRotationMatrix(_m1$2);
    scale.x = sx;
    scale.y = sy;
    scale.z = sz;
    return this;
  }
  /**
  	 * Creates a perspective projection matrix. This is used internally by
  	 * {@link PerspectiveCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makePerspective(left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem) {
    const te2 = this.elements;
    const x2 = 2 * near / (right - left);
    const y = 2 * near / (top - bottom);
    const a = (right + left) / (right - left);
    const b = (top + bottom) / (top - bottom);
    let c, d2;
    if (coordinateSystem === WebGLCoordinateSystem) {
      c = -(far + near) / (far - near);
      d2 = -2 * far * near / (far - near);
    } else if (coordinateSystem === WebGPUCoordinateSystem) {
      c = -far / (far - near);
      d2 = -far * near / (far - near);
    } else {
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + coordinateSystem);
    }
    te2[0] = x2;
    te2[4] = 0;
    te2[8] = a;
    te2[12] = 0;
    te2[1] = 0;
    te2[5] = y;
    te2[9] = b;
    te2[13] = 0;
    te2[2] = 0;
    te2[6] = 0;
    te2[10] = c;
    te2[14] = d2;
    te2[3] = 0;
    te2[7] = 0;
    te2[11] = -1;
    te2[15] = 0;
    return this;
  }
  /**
  	 * Creates a orthographic projection matrix. This is used internally by
  	 * {@link OrthographicCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem) {
    const te2 = this.elements;
    const w = 1 / (right - left);
    const h = 1 / (top - bottom);
    const p = 1 / (far - near);
    const x2 = (right + left) * w;
    const y = (top + bottom) * h;
    let z, zInv;
    if (coordinateSystem === WebGLCoordinateSystem) {
      z = (far + near) * p;
      zInv = -2 * p;
    } else if (coordinateSystem === WebGPUCoordinateSystem) {
      z = near * p;
      zInv = -1 * p;
    } else {
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + coordinateSystem);
    }
    te2[0] = 2 * w;
    te2[4] = 0;
    te2[8] = 0;
    te2[12] = -x2;
    te2[1] = 0;
    te2[5] = 2 * h;
    te2[9] = 0;
    te2[13] = -y;
    te2[2] = 0;
    te2[6] = 0;
    te2[10] = zInv;
    te2[14] = -z;
    te2[3] = 0;
    te2[7] = 0;
    te2[11] = 0;
    te2[15] = 1;
    return this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix4} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(matrix2) {
    const te2 = this.elements;
    const me = matrix2.elements;
    for (let i2 = 0; i2 < 16; i2++) {
      if (te2[i2] !== me[i2])
        return false;
    }
    return true;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix4} A reference to this matrix.
   */
  fromArray(array, offset2 = 0) {
    for (let i2 = 0; i2 < 16; i2++) {
      this.elements[i2] = array[i2 + offset2];
    }
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(array = [], offset2 = 0) {
    const te2 = this.elements;
    array[offset2] = te2[0];
    array[offset2 + 1] = te2[1];
    array[offset2 + 2] = te2[2];
    array[offset2 + 3] = te2[3];
    array[offset2 + 4] = te2[4];
    array[offset2 + 5] = te2[5];
    array[offset2 + 6] = te2[6];
    array[offset2 + 7] = te2[7];
    array[offset2 + 8] = te2[8];
    array[offset2 + 9] = te2[9];
    array[offset2 + 10] = te2[10];
    array[offset2 + 11] = te2[11];
    array[offset2 + 12] = te2[12];
    array[offset2 + 13] = te2[13];
    array[offset2 + 14] = te2[14];
    array[offset2 + 15] = te2[15];
    return array;
  }
}
const _v1$5 = /* @__PURE__ */ new Vector3();
const _m1$2 = /* @__PURE__ */ new Matrix4();
const _zero = /* @__PURE__ */ new Vector3(0, 0, 0);
const _one = /* @__PURE__ */ new Vector3(1, 1, 1);
const _x = /* @__PURE__ */ new Vector3();
const _y = /* @__PURE__ */ new Vector3();
const _z = /* @__PURE__ */ new Vector3();
const _matrix$2 = /* @__PURE__ */ new Matrix4();
const _quaternion$3 = /* @__PURE__ */ new Quaternion();
class Euler {
  /**
   * Constructs a new euler instance.
   *
   * @param {number} [x=0] - The angle of the x axis in radians.
   * @param {number} [y=0] - The angle of the y axis in radians.
   * @param {number} [z=0] - The angle of the z axis in radians.
   * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
   */
  constructor(x2 = 0, y = 0, z = 0, order = Euler.DEFAULT_ORDER) {
    this.isEuler = true;
    this._x = x2;
    this._y = y;
    this._z = z;
    this._order = order;
  }
  /**
   * The angle of the x axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
    this._onChangeCallback();
  }
  /**
   * The angle of the y axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
    this._onChangeCallback();
  }
  /**
   * The angle of the z axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(value) {
    this._z = value;
    this._onChangeCallback();
  }
  /**
   * A string representing the order that the rotations are applied.
   *
   * @type {string}
   * @default 'XYZ'
   */
  get order() {
    return this._order;
  }
  set order(value) {
    this._order = value;
    this._onChangeCallback();
  }
  /**
   * Sets the Euler components.
   *
   * @param {number} x - The angle of the x axis in radians.
   * @param {number} y - The angle of the y axis in radians.
   * @param {number} z - The angle of the z axis in radians.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  set(x2, y, z, order = this._order) {
    this._x = x2;
    this._y = y;
    this._z = z;
    this._order = order;
    this._onChangeCallback();
    return this;
  }
  /**
   * Returns a new Euler instance with copied values from this instance.
   *
   * @return {Euler} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  /**
   * Copies the values of the given Euler instance to this instance.
   *
   * @param {Euler} euler - The Euler instance to copy.
   * @return {Euler} A reference to this Euler instance.
   */
  copy(euler) {
    this._x = euler._x;
    this._y = euler._y;
    this._z = euler._z;
    this._order = euler._order;
    this._onChangeCallback();
    return this;
  }
  /**
   * Sets the angles of this Euler instance from a pure rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromRotationMatrix(m, order = this._order, update5 = true) {
    const te2 = m.elements;
    const m11 = te2[0], m12 = te2[4], m13 = te2[8];
    const m21 = te2[1], m22 = te2[5], m23 = te2[9];
    const m31 = te2[2], m32 = te2[6], m33 = te2[10];
    switch (order) {
      case "XYZ":
        this._y = Math.asin(clamp$2(m13, -1, 1));
        if (Math.abs(m13) < 0.9999999) {
          this._x = Math.atan2(-m23, m33);
          this._z = Math.atan2(-m12, m11);
        } else {
          this._x = Math.atan2(m32, m22);
          this._z = 0;
        }
        break;
      case "YXZ":
        this._x = Math.asin(-clamp$2(m23, -1, 1));
        if (Math.abs(m23) < 0.9999999) {
          this._y = Math.atan2(m13, m33);
          this._z = Math.atan2(m21, m22);
        } else {
          this._y = Math.atan2(-m31, m11);
          this._z = 0;
        }
        break;
      case "ZXY":
        this._x = Math.asin(clamp$2(m32, -1, 1));
        if (Math.abs(m32) < 0.9999999) {
          this._y = Math.atan2(-m31, m33);
          this._z = Math.atan2(-m12, m22);
        } else {
          this._y = 0;
          this._z = Math.atan2(m21, m11);
        }
        break;
      case "ZYX":
        this._y = Math.asin(-clamp$2(m31, -1, 1));
        if (Math.abs(m31) < 0.9999999) {
          this._x = Math.atan2(m32, m33);
          this._z = Math.atan2(m21, m11);
        } else {
          this._x = 0;
          this._z = Math.atan2(-m12, m22);
        }
        break;
      case "YZX":
        this._z = Math.asin(clamp$2(m21, -1, 1));
        if (Math.abs(m21) < 0.9999999) {
          this._x = Math.atan2(-m23, m22);
          this._y = Math.atan2(-m31, m11);
        } else {
          this._x = 0;
          this._y = Math.atan2(m13, m33);
        }
        break;
      case "XZY":
        this._z = Math.asin(-clamp$2(m12, -1, 1));
        if (Math.abs(m12) < 0.9999999) {
          this._x = Math.atan2(m32, m22);
          this._y = Math.atan2(m13, m11);
        } else {
          this._x = Math.atan2(-m23, m33);
          this._y = 0;
        }
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
    }
    this._order = order;
    if (update5 === true)
      this._onChangeCallback();
    return this;
  }
  /**
   * Sets the angles of this Euler instance from a normalized quaternion.
   *
   * @param {Quaternion} q - A normalized Quaternion.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromQuaternion(q, order, update5) {
    _matrix$2.makeRotationFromQuaternion(q);
    return this.setFromRotationMatrix(_matrix$2, order, update5);
  }
  /**
   * Sets the angles of this Euler instance from the given vector.
   *
   * @param {Vector3} v - The vector.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromVector3(v, order = this._order) {
    return this.set(v.x, v.y, v.z, order);
  }
  /**
   * Resets the euler angle with a new order by creating a quaternion from this
   * euler angle and then setting this euler angle with the quaternion and the
   * new order.
   *
   * Warning: This discards revolution information.
   *
   * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  reorder(newOrder) {
    _quaternion$3.setFromEuler(this);
    return this.setFromQuaternion(_quaternion$3, newOrder);
  }
  /**
   * Returns `true` if this Euler instance is equal with the given one.
   *
   * @param {Euler} euler - The Euler instance to test for equality.
   * @return {boolean} Whether this Euler instance is equal with the given one.
   */
  equals(euler) {
    return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
  }
  /**
   * Sets this Euler instance's components to values from the given array. The first three
   * entries of the array are assign to the x,y and z components. An optional fourth entry
   * defines the Euler order.
   *
   * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
   * @return {Euler} A reference to this Euler instance.
   */
  fromArray(array) {
    this._x = array[0];
    this._y = array[1];
    this._z = array[2];
    if (array[3] !== void 0)
      this._order = array[3];
    this._onChangeCallback();
    return this;
  }
  /**
   * Writes the components of this Euler instance to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number,number,number,string>} The Euler components.
   */
  toArray(array = [], offset2 = 0) {
    array[offset2] = this._x;
    array[offset2 + 1] = this._y;
    array[offset2 + 2] = this._z;
    array[offset2 + 3] = this._order;
    return array;
  }
  _onChange(callback) {
    this._onChangeCallback = callback;
    return this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x;
    yield this._y;
    yield this._z;
    yield this._order;
  }
}
Euler.DEFAULT_ORDER = "XYZ";
class Layers {
  /**
   * Constructs a new layers instance, with membership
   * initially set to layer `0`.
   */
  constructor() {
    this.mask = 1 | 0;
  }
  /**
   * Sets membership to the given layer, and remove membership all other layers.
   *
   * @param {number} layer - The layer to set.
   */
  set(layer) {
    this.mask = (1 << layer | 0) >>> 0;
  }
  /**
   * Adds membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  enable(layer) {
    this.mask |= 1 << layer | 0;
  }
  /**
   * Adds membership to all layers.
   */
  enableAll() {
    this.mask = 4294967295 | 0;
  }
  /**
   * Toggles the membership of the given layer.
   *
   * @param {number} layer - The layer to toggle.
   */
  toggle(layer) {
    this.mask ^= 1 << layer | 0;
  }
  /**
   * Removes membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  disable(layer) {
    this.mask &= ~(1 << layer | 0);
  }
  /**
   * Removes the membership from all layers.
   */
  disableAll() {
    this.mask = 0;
  }
  /**
   * Returns `true` if this and the given layers object have at least one
   * layer in common.
   *
   * @param {Layers} layers - The layers to test.
   * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
   */
  test(layers) {
    return (this.mask & layers.mask) !== 0;
  }
  /**
   * Returns `true` if the given layer is enabled.
   *
   * @param {number} layer - The layer to test.
   * @return {boolean } Whether the given layer is enabled or not.
   */
  isEnabled(layer) {
    return (this.mask & (1 << layer | 0)) !== 0;
  }
}
let _object3DId = 0;
const _v1$4 = /* @__PURE__ */ new Vector3();
const _q1 = /* @__PURE__ */ new Quaternion();
const _m1$1 = /* @__PURE__ */ new Matrix4();
const _target = /* @__PURE__ */ new Vector3();
const _position$3 = /* @__PURE__ */ new Vector3();
const _scale$2 = /* @__PURE__ */ new Vector3();
const _quaternion$2 = /* @__PURE__ */ new Quaternion();
const _xAxis = /* @__PURE__ */ new Vector3(1, 0, 0);
const _yAxis = /* @__PURE__ */ new Vector3(0, 1, 0);
const _zAxis = /* @__PURE__ */ new Vector3(0, 0, 1);
const _addedEvent = { type: "added" };
const _removedEvent = { type: "removed" };
const _childaddedEvent = { type: "childadded", child: null };
const _childremovedEvent = { type: "childremoved", child: null };
class Object3D extends EventDispatcher {
  /**
   * Constructs a new 3D object.
   */
  constructor() {
    super();
    this.isObject3D = true;
    Object.defineProperty(this, "id", { value: _object3DId++ });
    this.uuid = generateUUID();
    this.name = "";
    this.type = "Object3D";
    this.parent = null;
    this.children = [];
    this.up = Object3D.DEFAULT_UP.clone();
    const position = new Vector3();
    const rotation = new Euler();
    const quaternion = new Quaternion();
    const scale = new Vector3(1, 1, 1);
    function onRotationChange() {
      quaternion.setFromEuler(rotation, false);
    }
    function onQuaternionChange() {
      rotation.setFromQuaternion(quaternion, void 0, false);
    }
    rotation._onChange(onRotationChange);
    quaternion._onChange(onQuaternionChange);
    Object.defineProperties(this, {
      /**
       * Represents the object's local position.
       *
       * @name Object3D#position
       * @type {Vector3}
       * @default (0,0,0)
       */
      position: {
        configurable: true,
        enumerable: true,
        value: position
      },
      /**
       * Represents the object's local rotation as Euler angles, in radians.
       *
       * @name Object3D#rotation
       * @type {Euler}
       * @default (0,0,0)
       */
      rotation: {
        configurable: true,
        enumerable: true,
        value: rotation
      },
      /**
       * Represents the object's local rotation as Quaternions.
       *
       * @name Object3D#quaternion
       * @type {Quaternion}
       */
      quaternion: {
        configurable: true,
        enumerable: true,
        value: quaternion
      },
      /**
       * Represents the object's local scale.
       *
       * @name Object3D#scale
       * @type {Vector3}
       * @default (1,1,1)
       */
      scale: {
        configurable: true,
        enumerable: true,
        value: scale
      },
      /**
       * Represents the object's model-view matrix.
       *
       * @name Object3D#modelViewMatrix
       * @type {Matrix4}
       */
      modelViewMatrix: {
        value: new Matrix4()
      },
      /**
       * Represents the object's normal matrix.
       *
       * @name Object3D#normalMatrix
       * @type {Matrix3}
       */
      normalMatrix: {
        value: new Matrix3()
      }
    });
    this.matrix = new Matrix4();
    this.matrixWorld = new Matrix4();
    this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE;
    this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE;
    this.matrixWorldNeedsUpdate = false;
    this.layers = new Layers();
    this.visible = true;
    this.castShadow = false;
    this.receiveShadow = false;
    this.frustumCulled = true;
    this.renderOrder = 0;
    this.animations = [];
    this.customDepthMaterial = void 0;
    this.customDistanceMaterial = void 0;
    this.userData = {};
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeShadow() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onAfterShadow() {
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onAfterRender() {
  }
  /**
   * Applies the given transformation matrix to the object and updates the object's position,
   * rotation and scale.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   */
  applyMatrix4(matrix2) {
    if (this.matrixAutoUpdate)
      this.updateMatrix();
    this.matrix.premultiply(matrix2);
    this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  /**
   * Applies a rotation represented by given the quaternion to the 3D object.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Object3D} A reference to this instance.
   */
  applyQuaternion(q) {
    this.quaternion.premultiply(q);
    return this;
  }
  /**
   * Sets the given rotation represented as an axis/angle couple to the 3D object.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   */
  setRotationFromAxisAngle(axis, angle) {
    this.quaternion.setFromAxisAngle(axis, angle);
  }
  /**
   * Sets the given rotation represented as Euler angles to the 3D object.
   *
   * @param {Euler} euler - The Euler angles.
   */
  setRotationFromEuler(euler) {
    this.quaternion.setFromEuler(euler, true);
  }
  /**
   * Sets the given rotation represented as rotation matrix to the 3D object.
   *
   * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
   * a pure rotation matrix (i.e, unscaled).
   */
  setRotationFromMatrix(m) {
    this.quaternion.setFromRotationMatrix(m);
  }
  /**
   * Sets the given rotation represented as a Quaternion to the 3D object.
   *
   * @param {Quaternion} q - The Quaternion
   */
  setRotationFromQuaternion(q) {
    this.quaternion.copy(q);
  }
  /**
   * Rotates the 3D object along an axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnAxis(axis, angle) {
    _q1.setFromAxisAngle(axis, angle);
    this.quaternion.multiply(_q1);
    return this;
  }
  /**
   * Rotates the 3D object along an axis in world space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnWorldAxis(axis, angle) {
    _q1.setFromAxisAngle(axis, angle);
    this.quaternion.premultiply(_q1);
    return this;
  }
  /**
   * Rotates the 3D object around its X axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateX(angle) {
    return this.rotateOnAxis(_xAxis, angle);
  }
  /**
   * Rotates the 3D object around its Y axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateY(angle) {
    return this.rotateOnAxis(_yAxis, angle);
  }
  /**
   * Rotates the 3D object around its Z axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateZ(angle) {
    return this.rotateOnAxis(_zAxis, angle);
  }
  /**
   * Translate the 3D object by a distance along the given axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateOnAxis(axis, distance) {
    _v1$4.copy(axis).applyQuaternion(this.quaternion);
    this.position.add(_v1$4.multiplyScalar(distance));
    return this;
  }
  /**
   * Translate the 3D object by a distance along its X-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateX(distance) {
    return this.translateOnAxis(_xAxis, distance);
  }
  /**
   * Translate the 3D object by a distance along its Y-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateY(distance) {
    return this.translateOnAxis(_yAxis, distance);
  }
  /**
   * Translate the 3D object by a distance along its Z-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateZ(distance) {
    return this.translateOnAxis(_zAxis, distance);
  }
  /**
   * Converts the given vector from this 3D object's local space to world space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  localToWorld(vector) {
    this.updateWorldMatrix(true, false);
    return vector.applyMatrix4(this.matrixWorld);
  }
  /**
   * Converts the given vector from this 3D object's word space to local space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  worldToLocal(vector) {
    this.updateWorldMatrix(true, false);
    return vector.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
  }
  /**
   * Rotates the object to face a point in world space.
   *
   * This method does not support objects having non-uniformly-scaled parent(s).
   *
   * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
   * @param {number} [y] - The y coordinate in world space.
   * @param {number} [z] - The z coordinate in world space.
   */
  lookAt(x2, y, z) {
    if (x2.isVector3) {
      _target.copy(x2);
    } else {
      _target.set(x2, y, z);
    }
    const parent2 = this.parent;
    this.updateWorldMatrix(true, false);
    _position$3.setFromMatrixPosition(this.matrixWorld);
    if (this.isCamera || this.isLight) {
      _m1$1.lookAt(_position$3, _target, this.up);
    } else {
      _m1$1.lookAt(_target, _position$3, this.up);
    }
    this.quaternion.setFromRotationMatrix(_m1$1);
    if (parent2) {
      _m1$1.extractRotation(parent2.matrixWorld);
      _q1.setFromRotationMatrix(_m1$1);
      this.quaternion.premultiply(_q1.invert());
    }
  }
  /**
   * Adds the given 3D object as a child to this 3D object. An arbitrary number of
   * objects may be added. Any current parent on an object passed in here will be
   * removed, since an object can have at most one parent.
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to add.
   * @return {Object3D} A reference to this instance.
   */
  add(object) {
    if (arguments.length > 1) {
      for (let i2 = 0; i2 < arguments.length; i2++) {
        this.add(arguments[i2]);
      }
      return this;
    }
    if (object === this) {
      console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
      return this;
    }
    if (object && object.isObject3D) {
      object.removeFromParent();
      object.parent = this;
      this.children.push(object);
      object.dispatchEvent(_addedEvent);
      _childaddedEvent.child = object;
      this.dispatchEvent(_childaddedEvent);
      _childaddedEvent.child = null;
    } else {
      console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
    }
    return this;
  }
  /**
   * Removes the given 3D object as child from this 3D object.
   * An arbitrary number of objects may be removed.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @param {Object3D} object - The 3D object to remove.
   * @return {Object3D} A reference to this instance.
   */
  remove(object) {
    if (arguments.length > 1) {
      for (let i2 = 0; i2 < arguments.length; i2++) {
        this.remove(arguments[i2]);
      }
      return this;
    }
    const index2 = this.children.indexOf(object);
    if (index2 !== -1) {
      object.parent = null;
      this.children.splice(index2, 1);
      object.dispatchEvent(_removedEvent);
      _childremovedEvent.child = object;
      this.dispatchEvent(_childremovedEvent);
      _childremovedEvent.child = null;
    }
    return this;
  }
  /**
   * Removes this 3D object from its current parent.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  removeFromParent() {
    const parent2 = this.parent;
    if (parent2 !== null) {
      parent2.remove(this);
    }
    return this;
  }
  /**
   * Removes all child objects.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  clear() {
    return this.remove(...this.children);
  }
  /**
   * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
   * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to attach.
   * @return {Object3D} A reference to this instance.
   */
  attach(object) {
    this.updateWorldMatrix(true, false);
    _m1$1.copy(this.matrixWorld).invert();
    if (object.parent !== null) {
      object.parent.updateWorldMatrix(true, false);
      _m1$1.multiply(object.parent.matrixWorld);
    }
    object.applyMatrix4(_m1$1);
    object.removeFromParent();
    object.parent = this;
    this.children.push(object);
    object.updateWorldMatrix(false, true);
    object.dispatchEvent(_addedEvent);
    _childaddedEvent.child = object;
    this.dispatchEvent(_childaddedEvent);
    _childaddedEvent.child = null;
    return this;
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching ID.
   *
   * @param {number} id - The id.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectById(id) {
    return this.getObjectByProperty("id", id);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching name.
   *
   * @param {string} name - The name.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByName(name) {
    return this.getObjectByProperty("name", name);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByProperty(name, value) {
    if (this[name] === value)
      return this;
    for (let i2 = 0, l = this.children.length; i2 < l; i2++) {
      const child = this.children[i2];
      const object = child.getObjectByProperty(name, value);
      if (object !== void 0) {
        return object;
      }
    }
    return void 0;
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns all 3D objects with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @param {Array<Object3D>} result - The method stores the result in this array.
   * @return {Array<Object3D>} The found 3D objects.
   */
  getObjectsByProperty(name, value, result2 = []) {
    if (this[name] === value)
      result2.push(this);
    const children = this.children;
    for (let i2 = 0, l = children.length; i2 < l; i2++) {
      children[i2].getObjectsByProperty(name, value, result2);
    }
    return result2;
  }
  /**
   * Returns a vector representing the position of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's position in world space.
   */
  getWorldPosition(target2) {
    this.updateWorldMatrix(true, false);
    return target2.setFromMatrixPosition(this.matrixWorld);
  }
  /**
   * Returns a Quaternion representing the position of the 3D object in world space.
   *
   * @param {Quaternion} target - The target Quaternion the result is stored to.
   * @return {Quaternion} The 3D object's rotation in world space.
   */
  getWorldQuaternion(target2) {
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(_position$3, target2, _scale$2);
    return target2;
  }
  /**
   * Returns a vector representing the scale of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's scale in world space.
   */
  getWorldScale(target2) {
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(_position$3, _quaternion$2, target2);
    return target2;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(target2) {
    this.updateWorldMatrix(true, false);
    const e = this.matrixWorld.elements;
    return target2.set(e[8], e[9], e[10]).normalize();
  }
  /**
   * Abstract method to get intersections between a casted ray and this
   * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
   * implement this method in order to use raycasting.
   *
   * @abstract
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - An array holding the result of the method.
   */
  raycast() {
  }
  /**
   * Executes the callback on this 3D object and all descendants.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverse(callback) {
    callback(this);
    const children = this.children;
    for (let i2 = 0, l = children.length; i2 < l; i2++) {
      children[i2].traverse(callback);
    }
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
   * Descendants of invisible 3D objects are not traversed.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseVisible(callback) {
    if (this.visible === false)
      return;
    callback(this);
    const children = this.children;
    for (let i2 = 0, l = children.length; i2 < l; i2++) {
      children[i2].traverseVisible(callback);
    }
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseAncestors(callback) {
    const parent2 = this.parent;
    if (parent2 !== null) {
      callback(parent2);
      parent2.traverseAncestors(callback);
    }
  }
  /**
   * Updates the transformation matrix in local space by computing it from the current
   * position, rotation and scale values.
   */
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale);
    this.matrixWorldNeedsUpdate = true;
  }
  /**
   * Updates the transformation matrix in world space of this 3D objects and its descendants.
   *
   * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
   * local space. The computation of the local and world matrix can be controlled with the
   * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
   * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
   *
   * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
   * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
   */
  updateMatrixWorld(force) {
    if (this.matrixAutoUpdate)
      this.updateMatrix();
    if (this.matrixWorldNeedsUpdate || force) {
      if (this.matrixWorldAutoUpdate === true) {
        if (this.parent === null) {
          this.matrixWorld.copy(this.matrix);
        } else {
          this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
      }
      this.matrixWorldNeedsUpdate = false;
      force = true;
    }
    const children = this.children;
    for (let i2 = 0, l = children.length; i2 < l; i2++) {
      const child = children[i2];
      child.updateMatrixWorld(force);
    }
  }
  /**
   * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
   * update of ancestor and descendant nodes.
   *
   * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
   * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
   */
  updateWorldMatrix(updateParents, updateChildren) {
    const parent2 = this.parent;
    if (updateParents === true && parent2 !== null) {
      parent2.updateWorldMatrix(true, false);
    }
    if (this.matrixAutoUpdate)
      this.updateMatrix();
    if (this.matrixWorldAutoUpdate === true) {
      if (this.parent === null) {
        this.matrixWorld.copy(this.matrix);
      } else {
        this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
      }
    }
    if (updateChildren === true) {
      const children = this.children;
      for (let i2 = 0, l = children.length; i2 < l; i2++) {
        const child = children[i2];
        child.updateWorldMatrix(false, true);
      }
    }
  }
  /**
   * Serializes the 3D object into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized 3D object.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    const output = {};
    if (isRootObject) {
      meta = {
        geometries: {},
        materials: {},
        textures: {},
        images: {},
        shapes: {},
        skeletons: {},
        animations: {},
        nodes: {}
      };
      output.metadata = {
        version: 4.6,
        type: "Object",
        generator: "Object3D.toJSON"
      };
    }
    const object = {};
    object.uuid = this.uuid;
    object.type = this.type;
    if (this.name !== "")
      object.name = this.name;
    if (this.castShadow === true)
      object.castShadow = true;
    if (this.receiveShadow === true)
      object.receiveShadow = true;
    if (this.visible === false)
      object.visible = false;
    if (this.frustumCulled === false)
      object.frustumCulled = false;
    if (this.renderOrder !== 0)
      object.renderOrder = this.renderOrder;
    if (Object.keys(this.userData).length > 0)
      object.userData = this.userData;
    object.layers = this.layers.mask;
    object.matrix = this.matrix.toArray();
    object.up = this.up.toArray();
    if (this.matrixAutoUpdate === false)
      object.matrixAutoUpdate = false;
    if (this.isInstancedMesh) {
      object.type = "InstancedMesh";
      object.count = this.count;
      object.instanceMatrix = this.instanceMatrix.toJSON();
      if (this.instanceColor !== null)
        object.instanceColor = this.instanceColor.toJSON();
    }
    if (this.isBatchedMesh) {
      object.type = "BatchedMesh";
      object.perObjectFrustumCulled = this.perObjectFrustumCulled;
      object.sortObjects = this.sortObjects;
      object.drawRanges = this._drawRanges;
      object.reservedRanges = this._reservedRanges;
      object.geometryInfo = this._geometryInfo.map((info) => __spreadProps(__spreadValues({}, info), {
        boundingBox: info.boundingBox ? {
          min: info.boundingBox.min.toArray(),
          max: info.boundingBox.max.toArray()
        } : void 0,
        boundingSphere: info.boundingSphere ? {
          radius: info.boundingSphere.radius,
          center: info.boundingSphere.center.toArray()
        } : void 0
      }));
      object.instanceInfo = this._instanceInfo.map((info) => __spreadValues({}, info));
      object.availableInstanceIds = this._availableInstanceIds.slice();
      object.availableGeometryIds = this._availableGeometryIds.slice();
      object.nextIndexStart = this._nextIndexStart;
      object.nextVertexStart = this._nextVertexStart;
      object.geometryCount = this._geometryCount;
      object.maxInstanceCount = this._maxInstanceCount;
      object.maxVertexCount = this._maxVertexCount;
      object.maxIndexCount = this._maxIndexCount;
      object.geometryInitialized = this._geometryInitialized;
      object.matricesTexture = this._matricesTexture.toJSON(meta);
      object.indirectTexture = this._indirectTexture.toJSON(meta);
      if (this._colorsTexture !== null) {
        object.colorsTexture = this._colorsTexture.toJSON(meta);
      }
      if (this.boundingSphere !== null) {
        object.boundingSphere = {
          center: this.boundingSphere.center.toArray(),
          radius: this.boundingSphere.radius
        };
      }
      if (this.boundingBox !== null) {
        object.boundingBox = {
          min: this.boundingBox.min.toArray(),
          max: this.boundingBox.max.toArray()
        };
      }
    }
    function serialize(library, element) {
      if (library[element.uuid] === void 0) {
        library[element.uuid] = element.toJSON(meta);
      }
      return element.uuid;
    }
    if (this.isScene) {
      if (this.background) {
        if (this.background.isColor) {
          object.background = this.background.toJSON();
        } else if (this.background.isTexture) {
          object.background = this.background.toJSON(meta).uuid;
        }
      }
      if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) {
        object.environment = this.environment.toJSON(meta).uuid;
      }
    } else if (this.isMesh || this.isLine || this.isPoints) {
      object.geometry = serialize(meta.geometries, this.geometry);
      const parameters = this.geometry.parameters;
      if (parameters !== void 0 && parameters.shapes !== void 0) {
        const shapes = parameters.shapes;
        if (Array.isArray(shapes)) {
          for (let i2 = 0, l = shapes.length; i2 < l; i2++) {
            const shape = shapes[i2];
            serialize(meta.shapes, shape);
          }
        } else {
          serialize(meta.shapes, shapes);
        }
      }
    }
    if (this.isSkinnedMesh) {
      object.bindMode = this.bindMode;
      object.bindMatrix = this.bindMatrix.toArray();
      if (this.skeleton !== void 0) {
        serialize(meta.skeletons, this.skeleton);
        object.skeleton = this.skeleton.uuid;
      }
    }
    if (this.material !== void 0) {
      if (Array.isArray(this.material)) {
        const uuids = [];
        for (let i2 = 0, l = this.material.length; i2 < l; i2++) {
          uuids.push(serialize(meta.materials, this.material[i2]));
        }
        object.material = uuids;
      } else {
        object.material = serialize(meta.materials, this.material);
      }
    }
    if (this.children.length > 0) {
      object.children = [];
      for (let i2 = 0; i2 < this.children.length; i2++) {
        object.children.push(this.children[i2].toJSON(meta).object);
      }
    }
    if (this.animations.length > 0) {
      object.animations = [];
      for (let i2 = 0; i2 < this.animations.length; i2++) {
        const animation = this.animations[i2];
        object.animations.push(serialize(meta.animations, animation));
      }
    }
    if (isRootObject) {
      const geometries = extractFromCache(meta.geometries);
      const materials = extractFromCache(meta.materials);
      const textures = extractFromCache(meta.textures);
      const images = extractFromCache(meta.images);
      const shapes = extractFromCache(meta.shapes);
      const skeletons = extractFromCache(meta.skeletons);
      const animations = extractFromCache(meta.animations);
      const nodes = extractFromCache(meta.nodes);
      if (geometries.length > 0)
        output.geometries = geometries;
      if (materials.length > 0)
        output.materials = materials;
      if (textures.length > 0)
        output.textures = textures;
      if (images.length > 0)
        output.images = images;
      if (shapes.length > 0)
        output.shapes = shapes;
      if (skeletons.length > 0)
        output.skeletons = skeletons;
      if (animations.length > 0)
        output.animations = animations;
      if (nodes.length > 0)
        output.nodes = nodes;
    }
    output.object = object;
    return output;
    function extractFromCache(cache) {
      const values2 = [];
      for (const key in cache) {
        const data = cache[key];
        delete data.metadata;
        values2.push(data);
      }
      return values2;
    }
  }
  /**
   * Returns a new 3D object with copied values from this instance.
   *
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
   * @return {Object3D} A clone of this instance.
   */
  clone(recursive) {
    return new this.constructor().copy(this, recursive);
  }
  /**
   * Copies the values of the given 3D object to this instance.
   *
   * @param {Object3D} source - The 3D object to copy.
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
   * @return {Object3D} A reference to this instance.
   */
  copy(source, recursive = true) {
    this.name = source.name;
    this.up.copy(source.up);
    this.position.copy(source.position);
    this.rotation.order = source.rotation.order;
    this.quaternion.copy(source.quaternion);
    this.scale.copy(source.scale);
    this.matrix.copy(source.matrix);
    this.matrixWorld.copy(source.matrixWorld);
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
    this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
    this.layers.mask = source.layers.mask;
    this.visible = source.visible;
    this.castShadow = source.castShadow;
    this.receiveShadow = source.receiveShadow;
    this.frustumCulled = source.frustumCulled;
    this.renderOrder = source.renderOrder;
    this.animations = source.animations.slice();
    this.userData = JSON.parse(JSON.stringify(source.userData));
    if (recursive === true) {
      for (let i2 = 0; i2 < source.children.length; i2++) {
        const child = source.children[i2];
        this.add(child.clone());
      }
    }
    return this;
  }
}
Object3D.DEFAULT_UP = /* @__PURE__ */ new Vector3(0, 1, 0);
Object3D.DEFAULT_MATRIX_AUTO_UPDATE = true;
Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const _colorKeywords = {
  "aliceblue": 15792383,
  "antiquewhite": 16444375,
  "aqua": 65535,
  "aquamarine": 8388564,
  "azure": 15794175,
  "beige": 16119260,
  "bisque": 16770244,
  "black": 0,
  "blanchedalmond": 16772045,
  "blue": 255,
  "blueviolet": 9055202,
  "brown": 10824234,
  "burlywood": 14596231,
  "cadetblue": 6266528,
  "chartreuse": 8388352,
  "chocolate": 13789470,
  "coral": 16744272,
  "cornflowerblue": 6591981,
  "cornsilk": 16775388,
  "crimson": 14423100,
  "cyan": 65535,
  "darkblue": 139,
  "darkcyan": 35723,
  "darkgoldenrod": 12092939,
  "darkgray": 11119017,
  "darkgreen": 25600,
  "darkgrey": 11119017,
  "darkkhaki": 12433259,
  "darkmagenta": 9109643,
  "darkolivegreen": 5597999,
  "darkorange": 16747520,
  "darkorchid": 10040012,
  "darkred": 9109504,
  "darksalmon": 15308410,
  "darkseagreen": 9419919,
  "darkslateblue": 4734347,
  "darkslategray": 3100495,
  "darkslategrey": 3100495,
  "darkturquoise": 52945,
  "darkviolet": 9699539,
  "deeppink": 16716947,
  "deepskyblue": 49151,
  "dimgray": 6908265,
  "dimgrey": 6908265,
  "dodgerblue": 2003199,
  "firebrick": 11674146,
  "floralwhite": 16775920,
  "forestgreen": 2263842,
  "fuchsia": 16711935,
  "gainsboro": 14474460,
  "ghostwhite": 16316671,
  "gold": 16766720,
  "goldenrod": 14329120,
  "gray": 8421504,
  "green": 32768,
  "greenyellow": 11403055,
  "grey": 8421504,
  "honeydew": 15794160,
  "hotpink": 16738740,
  "indianred": 13458524,
  "indigo": 4915330,
  "ivory": 16777200,
  "khaki": 15787660,
  "lavender": 15132410,
  "lavenderblush": 16773365,
  "lawngreen": 8190976,
  "lemonchiffon": 16775885,
  "lightblue": 11393254,
  "lightcoral": 15761536,
  "lightcyan": 14745599,
  "lightgoldenrodyellow": 16448210,
  "lightgray": 13882323,
  "lightgreen": 9498256,
  "lightgrey": 13882323,
  "lightpink": 16758465,
  "lightsalmon": 16752762,
  "lightseagreen": 2142890,
  "lightskyblue": 8900346,
  "lightslategray": 7833753,
  "lightslategrey": 7833753,
  "lightsteelblue": 11584734,
  "lightyellow": 16777184,
  "lime": 65280,
  "limegreen": 3329330,
  "linen": 16445670,
  "magenta": 16711935,
  "maroon": 8388608,
  "mediumaquamarine": 6737322,
  "mediumblue": 205,
  "mediumorchid": 12211667,
  "mediumpurple": 9662683,
  "mediumseagreen": 3978097,
  "mediumslateblue": 8087790,
  "mediumspringgreen": 64154,
  "mediumturquoise": 4772300,
  "mediumvioletred": 13047173,
  "midnightblue": 1644912,
  "mintcream": 16121850,
  "mistyrose": 16770273,
  "moccasin": 16770229,
  "navajowhite": 16768685,
  "navy": 128,
  "oldlace": 16643558,
  "olive": 8421376,
  "olivedrab": 7048739,
  "orange": 16753920,
  "orangered": 16729344,
  "orchid": 14315734,
  "palegoldenrod": 15657130,
  "palegreen": 10025880,
  "paleturquoise": 11529966,
  "palevioletred": 14381203,
  "papayawhip": 16773077,
  "peachpuff": 16767673,
  "peru": 13468991,
  "pink": 16761035,
  "plum": 14524637,
  "powderblue": 11591910,
  "purple": 8388736,
  "rebeccapurple": 6697881,
  "red": 16711680,
  "rosybrown": 12357519,
  "royalblue": 4286945,
  "saddlebrown": 9127187,
  "salmon": 16416882,
  "sandybrown": 16032864,
  "seagreen": 3050327,
  "seashell": 16774638,
  "sienna": 10506797,
  "silver": 12632256,
  "skyblue": 8900331,
  "slateblue": 6970061,
  "slategray": 7372944,
  "slategrey": 7372944,
  "snow": 16775930,
  "springgreen": 65407,
  "steelblue": 4620980,
  "tan": 13808780,
  "teal": 32896,
  "thistle": 14204888,
  "tomato": 16737095,
  "turquoise": 4251856,
  "violet": 15631086,
  "wheat": 16113331,
  "white": 16777215,
  "whitesmoke": 16119285,
  "yellow": 16776960,
  "yellowgreen": 10145074
};
const _hslA = { h: 0, s: 0, l: 0 };
const _hslB = { h: 0, s: 0, l: 0 };
function hue2rgb(p, q, t3) {
  if (t3 < 0)
    t3 += 1;
  if (t3 > 1)
    t3 -= 1;
  if (t3 < 1 / 6)
    return p + (q - p) * 6 * t3;
  if (t3 < 1 / 2)
    return q;
  if (t3 < 2 / 3)
    return p + (q - p) * 6 * (2 / 3 - t3);
  return p;
}
let Color$2 = class Color {
  /**
   * Constructs a new color.
   *
   * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
   * and that method is used throughout the rest of the documentation.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   */
  constructor(r, g, b) {
    this.isColor = true;
    this.r = 1;
    this.g = 1;
    this.b = 1;
    return this.set(r, g, b);
  }
  /**
   * Sets the colors's components from the given values.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   * @return {Color} A reference to this color.
   */
  set(r, g, b) {
    if (g === void 0 && b === void 0) {
      const value = r;
      if (value && value.isColor) {
        this.copy(value);
      } else if (typeof value === "number") {
        this.setHex(value);
      } else if (typeof value === "string") {
        this.setStyle(value);
      }
    } else {
      this.setRGB(r, g, b);
    }
    return this;
  }
  /**
   * Sets the colors's components to the given scalar value.
   *
   * @param {number} scalar - The scalar value.
   * @return {Color} A reference to this color.
   */
  setScalar(scalar) {
    this.r = scalar;
    this.g = scalar;
    this.b = scalar;
    return this;
  }
  /**
   * Sets this color from a hexadecimal value.
   *
   * @param {number} hex - The hexadecimal value.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHex(hex, colorSpace = SRGBColorSpace) {
    hex = Math.floor(hex);
    this.r = (hex >> 16 & 255) / 255;
    this.g = (hex >> 8 & 255) / 255;
    this.b = (hex & 255) / 255;
    ColorManagement.toWorkingColorSpace(this, colorSpace);
    return this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} r - Red channel value between `0.0` and `1.0`.
   * @param {number} g - Green channel value between `0.0` and `1.0`.
   * @param {number} b - Blue channel value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setRGB(r, g, b, colorSpace = ColorManagement.workingColorSpace) {
    this.r = r;
    this.g = g;
    this.b = b;
    ColorManagement.toWorkingColorSpace(this, colorSpace);
    return this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHSL(h, s2, l, colorSpace = ColorManagement.workingColorSpace) {
    h = euclideanModulo(h, 1);
    s2 = clamp$2(s2, 0, 1);
    l = clamp$2(l, 0, 1);
    if (s2 === 0) {
      this.r = this.g = this.b = l;
    } else {
      const p = l <= 0.5 ? l * (1 + s2) : l + s2 - l * s2;
      const q = 2 * l - p;
      this.r = hue2rgb(q, p, h + 1 / 3);
      this.g = hue2rgb(q, p, h);
      this.b = hue2rgb(q, p, h - 1 / 3);
    }
    ColorManagement.toWorkingColorSpace(this, colorSpace);
    return this;
  }
  /**
   * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
   * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
   * any [X11 color name]{@link https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart} -
   * all 140 color names are supported).
   *
   * @param {string} style - Color as a CSS-style string.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setStyle(style2, colorSpace = SRGBColorSpace) {
    function handleAlpha(string) {
      if (string === void 0)
        return;
      if (parseFloat(string) < 1) {
        console.warn("THREE.Color: Alpha component of " + style2 + " will be ignored.");
      }
    }
    let m;
    if (m = /^(\w+)\(([^\)]*)\)/.exec(style2)) {
      let color2;
      const name = m[1];
      const components = m[2];
      switch (name) {
        case "rgb":
        case "rgba":
          if (color2 = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            handleAlpha(color2[4]);
            return this.setRGB(
              Math.min(255, parseInt(color2[1], 10)) / 255,
              Math.min(255, parseInt(color2[2], 10)) / 255,
              Math.min(255, parseInt(color2[3], 10)) / 255,
              colorSpace
            );
          }
          if (color2 = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            handleAlpha(color2[4]);
            return this.setRGB(
              Math.min(100, parseInt(color2[1], 10)) / 100,
              Math.min(100, parseInt(color2[2], 10)) / 100,
              Math.min(100, parseInt(color2[3], 10)) / 100,
              colorSpace
            );
          }
          break;
        case "hsl":
        case "hsla":
          if (color2 = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            handleAlpha(color2[4]);
            return this.setHSL(
              parseFloat(color2[1]) / 360,
              parseFloat(color2[2]) / 100,
              parseFloat(color2[3]) / 100,
              colorSpace
            );
          }
          break;
        default:
          console.warn("THREE.Color: Unknown color model " + style2);
      }
    } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style2)) {
      const hex = m[1];
      const size = hex.length;
      if (size === 3) {
        return this.setRGB(
          parseInt(hex.charAt(0), 16) / 15,
          parseInt(hex.charAt(1), 16) / 15,
          parseInt(hex.charAt(2), 16) / 15,
          colorSpace
        );
      } else if (size === 6) {
        return this.setHex(parseInt(hex, 16), colorSpace);
      } else {
        console.warn("THREE.Color: Invalid hex color " + style2);
      }
    } else if (style2 && style2.length > 0) {
      return this.setColorName(style2, colorSpace);
    }
    return this;
  }
  /**
   * Sets this color from a color name. Faster than {@link Color#setStyle} if
   * you don't need the other CSS-style formats.
   *
   * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
   * ```js
   * Color.NAMES.aliceblue // returns 0xF0F8FF
   * ```
   *
   * @param {string} style - The color name.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setColorName(style2, colorSpace = SRGBColorSpace) {
    const hex = _colorKeywords[style2.toLowerCase()];
    if (hex !== void 0) {
      this.setHex(hex, colorSpace);
    } else {
      console.warn("THREE.Color: Unknown color " + style2);
    }
    return this;
  }
  /**
   * Returns a new color with copied values from this instance.
   *
   * @return {Color} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  /**
   * Copies the values of the given color to this instance.
   *
   * @param {Color} color - The color to copy.
   * @return {Color} A reference to this color.
   */
  copy(color2) {
    this.r = color2.r;
    this.g = color2.g;
    this.b = color2.b;
    return this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copySRGBToLinear(color2) {
    this.r = SRGBToLinear(color2.r);
    this.g = SRGBToLinear(color2.g);
    this.b = SRGBToLinear(color2.b);
    return this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copyLinearToSRGB(color2) {
    this.r = LinearToSRGB(color2.r);
    this.g = LinearToSRGB(color2.g);
    this.b = LinearToSRGB(color2.b);
    return this;
  }
  /**
   * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertSRGBToLinear() {
    this.copySRGBToLinear(this);
    return this;
  }
  /**
   * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertLinearToSRGB() {
    this.copyLinearToSRGB(this);
    return this;
  }
  /**
   * Returns the hexadecimal value of this color.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {number} The hexadecimal value.
   */
  getHex(colorSpace = SRGBColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color.copy(this), colorSpace);
    return Math.round(clamp$2(_color.r * 255, 0, 255)) * 65536 + Math.round(clamp$2(_color.g * 255, 0, 255)) * 256 + Math.round(clamp$2(_color.b * 255, 0, 255));
  }
  /**
   * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The hexadecimal value as a string.
   */
  getHexString(colorSpace = SRGBColorSpace) {
    return ("000000" + this.getHex(colorSpace).toString(16)).slice(-6);
  }
  /**
   * Converts the colors RGB values into the HSL format and stores them into the
   * given target object.
   *
   * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {{h:number,s:number,l:number}} The HSL representation of this color.
   */
  getHSL(target2, colorSpace = ColorManagement.workingColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color.copy(this), colorSpace);
    const r = _color.r, g = _color.g, b = _color.b;
    const max2 = Math.max(r, g, b);
    const min2 = Math.min(r, g, b);
    let hue, saturation;
    const lightness = (min2 + max2) / 2;
    if (min2 === max2) {
      hue = 0;
      saturation = 0;
    } else {
      const delta = max2 - min2;
      saturation = lightness <= 0.5 ? delta / (max2 + min2) : delta / (2 - max2 - min2);
      switch (max2) {
        case r:
          hue = (g - b) / delta + (g < b ? 6 : 0);
          break;
        case g:
          hue = (b - r) / delta + 2;
          break;
        case b:
          hue = (r - g) / delta + 4;
          break;
      }
      hue /= 6;
    }
    target2.h = hue;
    target2.s = saturation;
    target2.l = lightness;
    return target2;
  }
  /**
   * Returns the RGB values of this color and stores them into the given target object.
   *
   * @param {Color} target - The target color that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} The RGB representation of this color.
   */
  getRGB(target2, colorSpace = ColorManagement.workingColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color.copy(this), colorSpace);
    target2.r = _color.r;
    target2.g = _color.g;
    target2.b = _color.b;
    return target2;
  }
  /**
   * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The CSS representation of this color.
   */
  getStyle(colorSpace = SRGBColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color.copy(this), colorSpace);
    const r = _color.r, g = _color.g, b = _color.b;
    if (colorSpace !== SRGBColorSpace) {
      return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
    }
    return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
  }
  /**
   * Adds the given HSL values to this color's values.
   * Internally, this converts the color's RGB values to HSL, adds HSL
   * and then converts the color back to RGB.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @return {Color} A reference to this color.
   */
  offsetHSL(h, s2, l) {
    this.getHSL(_hslA);
    return this.setHSL(_hslA.h + h, _hslA.s + s2, _hslA.l + l);
  }
  /**
   * Adds the RGB values of the given color to the RGB values of this color.
   *
   * @param {Color} color - The color to add.
   * @return {Color} A reference to this color.
   */
  add(color2) {
    this.r += color2.r;
    this.g += color2.g;
    this.b += color2.b;
    return this;
  }
  /**
   * Adds the RGB values of the given colors and stores the result in this instance.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @return {Color} A reference to this color.
   */
  addColors(color1, color2) {
    this.r = color1.r + color2.r;
    this.g = color1.g + color2.g;
    this.b = color1.b + color2.b;
    return this;
  }
  /**
   * Adds the given scalar value to the RGB values of this color.
   *
   * @param {number} s - The scalar to add.
   * @return {Color} A reference to this color.
   */
  addScalar(s2) {
    this.r += s2;
    this.g += s2;
    this.b += s2;
    return this;
  }
  /**
   * Subtracts the RGB values of the given color from the RGB values of this color.
   *
   * @param {Color} color - The color to subtract.
   * @return {Color} A reference to this color.
   */
  sub(color2) {
    this.r = Math.max(0, this.r - color2.r);
    this.g = Math.max(0, this.g - color2.g);
    this.b = Math.max(0, this.b - color2.b);
    return this;
  }
  /**
   * Multiplies the RGB values of the given color with the RGB values of this color.
   *
   * @param {Color} color - The color to multiply.
   * @return {Color} A reference to this color.
   */
  multiply(color2) {
    this.r *= color2.r;
    this.g *= color2.g;
    this.b *= color2.b;
    return this;
  }
  /**
   * Multiplies the given scalar value with the RGB values of this color.
   *
   * @param {number} s - The scalar to multiply.
   * @return {Color} A reference to this color.
   */
  multiplyScalar(s2) {
    this.r *= s2;
    this.g *= s2;
    this.b *= s2;
    return this;
  }
  /**
   * Linearly interpolates this color's RGB values toward the RGB values of the
   * given color. The alpha argument can be thought of as the ratio between
   * the two colors, where `0.0` is this color and `1.0` is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerp(color2, alpha) {
    this.r += (color2.r - this.r) * alpha;
    this.g += (color2.g - this.g) * alpha;
    this.b += (color2.b - this.b) * alpha;
    return this;
  }
  /**
   * Linearly interpolates between the given colors and stores the result in this instance.
   * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
   * is the first and `1.0` is the second color.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpColors(color1, color2, alpha) {
    this.r = color1.r + (color2.r - color1.r) * alpha;
    this.g = color1.g + (color2.g - color1.g) * alpha;
    this.b = color1.b + (color2.b - color1.b) * alpha;
    return this;
  }
  /**
   * Linearly interpolates this color's HSL values toward the HSL values of the
   * given color. It differs from {@link Color#lerp} by not interpolating straight
   * from one color to the other, but instead going through all the hues in between
   * those two colors. The alpha argument can be thought of as the ratio between
   * the two colors, where 0.0 is this color and 1.0 is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpHSL(color2, alpha) {
    this.getHSL(_hslA);
    color2.getHSL(_hslB);
    const h = lerp(_hslA.h, _hslB.h, alpha);
    const s2 = lerp(_hslA.s, _hslB.s, alpha);
    const l = lerp(_hslA.l, _hslB.l, alpha);
    this.setHSL(h, s2, l);
    return this;
  }
  /**
   * Sets the color's RGB components from the given 3D vector.
   *
   * @param {Vector3} v - The vector to set.
   * @return {Color} A reference to this color.
   */
  setFromVector3(v) {
    this.r = v.x;
    this.g = v.y;
    this.b = v.z;
    return this;
  }
  /**
   * Transforms this color with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix.
   * @return {Color} A reference to this color.
   */
  applyMatrix3(m) {
    const r = this.r, g = this.g, b = this.b;
    const e = m.elements;
    this.r = e[0] * r + e[3] * g + e[6] * b;
    this.g = e[1] * r + e[4] * g + e[7] * b;
    this.b = e[2] * r + e[5] * g + e[8] * b;
    return this;
  }
  /**
   * Returns `true` if this color is equal with the given one.
   *
   * @param {Color} c - The color to test for equality.
   * @return {boolean} Whether this bounding color is equal with the given one.
   */
  equals(c) {
    return c.r === this.r && c.g === this.g && c.b === this.b;
  }
  /**
   * Sets this color's RGB components from the given array.
   *
   * @param {Array<number>} array - An array holding the RGB values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Color} A reference to this color.
   */
  fromArray(array, offset2 = 0) {
    this.r = array[offset2];
    this.g = array[offset2 + 1];
    this.b = array[offset2 + 2];
    return this;
  }
  /**
   * Writes the RGB components of this color to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the color components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The color components.
   */
  toArray(array = [], offset2 = 0) {
    array[offset2] = this.r;
    array[offset2 + 1] = this.g;
    array[offset2 + 2] = this.b;
    return array;
  }
  /**
   * Sets the components of this color from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding color data.
   * @param {number} index - The index into the attribute.
   * @return {Color} A reference to this color.
   */
  fromBufferAttribute(attribute, index2) {
    this.r = attribute.getX(index2);
    this.g = attribute.getY(index2);
    this.b = attribute.getZ(index2);
    return this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the color
   * as a hexadecimal value.
   *
   * @return {number} The hexadecimal value.
   */
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r;
    yield this.g;
    yield this.b;
  }
};
const _color = /* @__PURE__ */ new Color$2();
Color$2.NAMES = _colorKeywords;
let Scene$1 = class Scene extends Object3D {
  /**
   * Constructs a new scene.
   */
  constructor() {
    super();
    this.isScene = true;
    this.type = "Scene";
    this.background = null;
    this.environment = null;
    this.fog = null;
    this.backgroundBlurriness = 0;
    this.backgroundIntensity = 1;
    this.backgroundRotation = new Euler();
    this.environmentIntensity = 1;
    this.environmentRotation = new Euler();
    this.overrideMaterial = null;
    if (typeof __THREE_DEVTOOLS__ !== "undefined") {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
    }
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    if (source.background !== null)
      this.background = source.background.clone();
    if (source.environment !== null)
      this.environment = source.environment.clone();
    if (source.fog !== null)
      this.fog = source.fog.clone();
    this.backgroundBlurriness = source.backgroundBlurriness;
    this.backgroundIntensity = source.backgroundIntensity;
    this.backgroundRotation.copy(source.backgroundRotation);
    this.environmentIntensity = source.environmentIntensity;
    this.environmentRotation.copy(source.environmentRotation);
    if (source.overrideMaterial !== null)
      this.overrideMaterial = source.overrideMaterial.clone();
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    if (this.fog !== null)
      data.object.fog = this.fog.toJSON();
    if (this.backgroundBlurriness > 0)
      data.object.backgroundBlurriness = this.backgroundBlurriness;
    if (this.backgroundIntensity !== 1)
      data.object.backgroundIntensity = this.backgroundIntensity;
    data.object.backgroundRotation = this.backgroundRotation.toArray();
    if (this.environmentIntensity !== 1)
      data.object.environmentIntensity = this.environmentIntensity;
    data.object.environmentRotation = this.environmentRotation.toArray();
    return data;
  }
};
function convertArray(array, type) {
  if (!array || array.constructor === type)
    return array;
  if (typeof type.BYTES_PER_ELEMENT === "number") {
    return new type(array);
  }
  return Array.prototype.slice.call(array);
}
function isTypedArray(object) {
  return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
function getKeyframeOrder(times) {
  function compareTime(i2, j) {
    return times[i2] - times[j];
  }
  const n2 = times.length;
  const result2 = new Array(n2);
  for (let i2 = 0; i2 !== n2; ++i2)
    result2[i2] = i2;
  result2.sort(compareTime);
  return result2;
}
function sortedArray(values2, stride, order) {
  const nValues = values2.length;
  const result2 = new values2.constructor(nValues);
  for (let i2 = 0, dstOffset = 0; dstOffset !== nValues; ++i2) {
    const srcOffset = order[i2] * stride;
    for (let j = 0; j !== stride; ++j) {
      result2[dstOffset++] = values2[srcOffset + j];
    }
  }
  return result2;
}
function flattenJSON(jsonKeys, times, values2, valuePropertyName) {
  let i2 = 1, key = jsonKeys[0];
  while (key !== void 0 && key[valuePropertyName] === void 0) {
    key = jsonKeys[i2++];
  }
  if (key === void 0)
    return;
  let value = key[valuePropertyName];
  if (value === void 0)
    return;
  if (Array.isArray(value)) {
    do {
      value = key[valuePropertyName];
      if (value !== void 0) {
        times.push(key.time);
        values2.push(...value);
      }
      key = jsonKeys[i2++];
    } while (key !== void 0);
  } else if (value.toArray !== void 0) {
    do {
      value = key[valuePropertyName];
      if (value !== void 0) {
        times.push(key.time);
        value.toArray(values2, values2.length);
      }
      key = jsonKeys[i2++];
    } while (key !== void 0);
  } else {
    do {
      value = key[valuePropertyName];
      if (value !== void 0) {
        times.push(key.time);
        values2.push(value);
      }
      key = jsonKeys[i2++];
    } while (key !== void 0);
  }
}
class Interpolant {
  /**
   * Constructs a new interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    this.parameterPositions = parameterPositions;
    this._cachedIndex = 0;
    this.resultBuffer = resultBuffer !== void 0 ? resultBuffer : new sampleValues.constructor(sampleSize);
    this.sampleValues = sampleValues;
    this.valueSize = sampleSize;
    this.settings = null;
    this.DefaultSettings_ = {};
  }
  /**
   * Evaluate the interpolant at position `t`.
   *
   * @param {number} t - The interpolation factor.
   * @return {TypedArray} The result buffer.
   */
  evaluate(t3) {
    const pp = this.parameterPositions;
    let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
    validate_interval: {
      seek: {
        let right;
        linear_scan: {
          forward_scan:
            if (!(t3 < t1)) {
              for (let giveUpAt = i1 + 2; ; ) {
                if (t1 === void 0) {
                  if (t3 < t0)
                    break forward_scan;
                  i1 = pp.length;
                  this._cachedIndex = i1;
                  return this.copySampleValue_(i1 - 1);
                }
                if (i1 === giveUpAt)
                  break;
                t0 = t1;
                t1 = pp[++i1];
                if (t3 < t1) {
                  break seek;
                }
              }
              right = pp.length;
              break linear_scan;
            }
          if (!(t3 >= t0)) {
            const t1global = pp[1];
            if (t3 < t1global) {
              i1 = 2;
              t0 = t1global;
            }
            for (let giveUpAt = i1 - 2; ; ) {
              if (t0 === void 0) {
                this._cachedIndex = 0;
                return this.copySampleValue_(0);
              }
              if (i1 === giveUpAt)
                break;
              t1 = t0;
              t0 = pp[--i1 - 1];
              if (t3 >= t0) {
                break seek;
              }
            }
            right = i1;
            i1 = 0;
            break linear_scan;
          }
          break validate_interval;
        }
        while (i1 < right) {
          const mid = i1 + right >>> 1;
          if (t3 < pp[mid]) {
            right = mid;
          } else {
            i1 = mid + 1;
          }
        }
        t1 = pp[i1];
        t0 = pp[i1 - 1];
        if (t0 === void 0) {
          this._cachedIndex = 0;
          return this.copySampleValue_(0);
        }
        if (t1 === void 0) {
          i1 = pp.length;
          this._cachedIndex = i1;
          return this.copySampleValue_(i1 - 1);
        }
      }
      this._cachedIndex = i1;
      this.intervalChanged_(i1, t0, t1);
    }
    return this.interpolate_(i1, t0, t3, t1);
  }
  /**
   * Returns the interpolation settings.
   *
   * @return {Object} The interpolation settings.
   */
  getSettings_() {
    return this.settings || this.DefaultSettings_;
  }
  /**
   * Copies a sample value to the result buffer.
   *
   * @param {number} index - An index into the sample value buffer.
   * @return {TypedArray} The result buffer.
   */
  copySampleValue_(index2) {
    const result2 = this.resultBuffer, values2 = this.sampleValues, stride = this.valueSize, offset2 = index2 * stride;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result2[i2] = values2[offset2 + i2];
    }
    return result2;
  }
  /**
   * Copies a sample value to the result buffer.
   *
   * @abstract
   * @param {number} i1 - An index into the sample value buffer.
   * @param {number} t0 - The previous interpolation factor.
   * @param {number} t - The current interpolation factor.
   * @param {number} t1 - The next interpolation factor.
   * @return {TypedArray} The result buffer.
   */
  interpolate_() {
    throw new Error("call to abstract method");
  }
  /**
   * Optional method that is executed when the interval has changed.
   *
   * @param {number} i1 - An index into the sample value buffer.
   * @param {number} t0 - The previous interpolation factor.
   * @param {number} t - The current interpolation factor.
   */
  intervalChanged_() {
  }
}
class CubicInterpolant extends Interpolant {
  /**
   * Constructs a new cubic interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    this._weightPrev = -0;
    this._offsetPrev = -0;
    this._weightNext = -0;
    this._offsetNext = -0;
    this.DefaultSettings_ = {
      endingStart: ZeroCurvatureEnding,
      endingEnd: ZeroCurvatureEnding
    };
  }
  intervalChanged_(i1, t0, t1) {
    const pp = this.parameterPositions;
    let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
    if (tPrev === void 0) {
      switch (this.getSettings_().endingStart) {
        case ZeroSlopeEnding:
          iPrev = i1;
          tPrev = 2 * t0 - t1;
          break;
        case WrapAroundEnding:
          iPrev = pp.length - 2;
          tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
          break;
        default:
          iPrev = i1;
          tPrev = t1;
      }
    }
    if (tNext === void 0) {
      switch (this.getSettings_().endingEnd) {
        case ZeroSlopeEnding:
          iNext = i1;
          tNext = 2 * t1 - t0;
          break;
        case WrapAroundEnding:
          iNext = 1;
          tNext = t1 + pp[1] - pp[0];
          break;
        default:
          iNext = i1 - 1;
          tNext = t0;
      }
    }
    const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
    this._weightPrev = halfDt / (t0 - tPrev);
    this._weightNext = halfDt / (tNext - t1);
    this._offsetPrev = iPrev * stride;
    this._offsetNext = iNext * stride;
  }
  interpolate_(i1, t0, t3, t1) {
    const result2 = this.resultBuffer, values2 = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t3 - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
    const sP = -wP * ppp + 2 * wP * pp - wP * p;
    const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
    const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
    const sN = wN * ppp - wN * pp;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result2[i2] = sP * values2[oP + i2] + s0 * values2[o0 + i2] + s1 * values2[o1 + i2] + sN * values2[oN + i2];
    }
    return result2;
  }
}
class LinearInterpolant extends Interpolant {
  /**
   * Constructs a new linear interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1, t0, t3, t1) {
    const result2 = this.resultBuffer, values2 = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t3 - t0) / (t1 - t0), weight0 = 1 - weight1;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result2[i2] = values2[offset0 + i2] * weight0 + values2[offset1 + i2] * weight1;
    }
    return result2;
  }
}
class DiscreteInterpolant extends Interpolant {
  /**
   * Constructs a new discrete interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1) {
    return this.copySampleValue_(i1 - 1);
  }
}
class KeyframeTrack {
  /**
   * Constructs a new keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(name, times, values2, interpolation) {
    if (name === void 0)
      throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (times === void 0 || times.length === 0)
      throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
    this.name = name;
    this.times = convertArray(times, this.TimeBufferType);
    this.values = convertArray(values2, this.ValueBufferType);
    this.setInterpolation(interpolation || this.DefaultInterpolation);
  }
  /**
   * Converts the keyframe track to JSON.
   *
   * @static
   * @param {KeyframeTrack} track - The keyframe track to serialize.
   * @return {Object} The serialized keyframe track as JSON.
   */
  static toJSON(track) {
    const trackType = track.constructor;
    let json;
    if (trackType.toJSON !== this.toJSON) {
      json = trackType.toJSON(track);
    } else {
      json = {
        "name": track.name,
        "times": convertArray(track.times, Array),
        "values": convertArray(track.values, Array)
      };
      const interpolation = track.getInterpolation();
      if (interpolation !== track.DefaultInterpolation) {
        json.interpolation = interpolation;
      }
    }
    json.type = track.ValueTypeName;
    return json;
  }
  /**
   * Factory method for creating a new discrete interpolant.
   *
   * @static
   * @param {TypedArray} [result] - The result buffer.
   * @return {DiscreteInterpolant} The new interpolant.
   */
  InterpolantFactoryMethodDiscrete(result2) {
    return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), result2);
  }
  /**
   * Factory method for creating a new linear interpolant.
   *
   * @static
   * @param {TypedArray} [result] - The result buffer.
   * @return {LinearInterpolant} The new interpolant.
   */
  InterpolantFactoryMethodLinear(result2) {
    return new LinearInterpolant(this.times, this.values, this.getValueSize(), result2);
  }
  /**
   * Factory method for creating a new smooth interpolant.
   *
   * @static
   * @param {TypedArray} [result] - The result buffer.
   * @return {CubicInterpolant} The new interpolant.
   */
  InterpolantFactoryMethodSmooth(result2) {
    return new CubicInterpolant(this.times, this.values, this.getValueSize(), result2);
  }
  /**
   * Defines the interpolation factor method for this keyframe track.
   *
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} interpolation - The interpolation type.
   * @return {KeyframeTrack} A reference to this keyframe track.
   */
  setInterpolation(interpolation) {
    let factoryMethod;
    switch (interpolation) {
      case InterpolateDiscrete:
        factoryMethod = this.InterpolantFactoryMethodDiscrete;
        break;
      case InterpolateLinear:
        factoryMethod = this.InterpolantFactoryMethodLinear;
        break;
      case InterpolateSmooth:
        factoryMethod = this.InterpolantFactoryMethodSmooth;
        break;
    }
    if (factoryMethod === void 0) {
      const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
      if (this.createInterpolant === void 0) {
        if (interpolation !== this.DefaultInterpolation) {
          this.setInterpolation(this.DefaultInterpolation);
        } else {
          throw new Error(message);
        }
      }
      console.warn("THREE.KeyframeTrack:", message);
      return this;
    }
    this.createInterpolant = factoryMethod;
    return this;
  }
  /**
   * Returns the current interpolation type.
   *
   * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} The interpolation type.
   */
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return InterpolateDiscrete;
      case this.InterpolantFactoryMethodLinear:
        return InterpolateLinear;
      case this.InterpolantFactoryMethodSmooth:
        return InterpolateSmooth;
    }
  }
  /**
   * Returns the value size.
   *
   * @return {number} The value size.
   */
  getValueSize() {
    return this.values.length / this.times.length;
  }
  /**
   * Moves all keyframes either forward or backward in time.
   *
   * @param {number} timeOffset - The offset to move the time values.
   * @return {KeyframeTrack} A reference to this keyframe track.
   */
  shift(timeOffset) {
    if (timeOffset !== 0) {
      const times = this.times;
      for (let i2 = 0, n2 = times.length; i2 !== n2; ++i2) {
        times[i2] += timeOffset;
      }
    }
    return this;
  }
  /**
   * Scale all keyframe times by a factor (useful for frame - seconds conversions).
   *
   * @param {number} timeScale - The time scale.
   * @return {KeyframeTrack} A reference to this keyframe track.
   */
  scale(timeScale) {
    if (timeScale !== 1) {
      const times = this.times;
      for (let i2 = 0, n2 = times.length; i2 !== n2; ++i2) {
        times[i2] *= timeScale;
      }
    }
    return this;
  }
  /**
   * Removes keyframes before and after animation without changing any values within the defined time range.
   *
   * Note: The method does not shift around keys to the start of the track time, because for interpolated
   * keys this will change their values
   *
   * @param {number} startTime - The start time.
   * @param {number} endTime - The end time.
   * @return {KeyframeTrack} A reference to this keyframe track.
   */
  trim(startTime, endTime) {
    const times = this.times, nKeys = times.length;
    let from = 0, to = nKeys - 1;
    while (from !== nKeys && times[from] < startTime) {
      ++from;
    }
    while (to !== -1 && times[to] > endTime) {
      --to;
    }
    ++to;
    if (from !== 0 || to !== nKeys) {
      if (from >= to) {
        to = Math.max(to, 1);
        from = to - 1;
      }
      const stride = this.getValueSize();
      this.times = times.slice(from, to);
      this.values = this.values.slice(from * stride, to * stride);
    }
    return this;
  }
  /**
   * Performs minimal validation on the keyframe track. Returns `true` if the values
   * are valid.
   *
   * @return {boolean} Whether the keyframes are valid or not.
   */
  validate() {
    let valid = true;
    const valueSize = this.getValueSize();
    if (valueSize - Math.floor(valueSize) !== 0) {
      console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
      valid = false;
    }
    const times = this.times, values2 = this.values, nKeys = times.length;
    if (nKeys === 0) {
      console.error("THREE.KeyframeTrack: Track is empty.", this);
      valid = false;
    }
    let prevTime = null;
    for (let i2 = 0; i2 !== nKeys; i2++) {
      const currTime = times[i2];
      if (typeof currTime === "number" && isNaN(currTime)) {
        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i2, currTime);
        valid = false;
        break;
      }
      if (prevTime !== null && prevTime > currTime) {
        console.error("THREE.KeyframeTrack: Out of order keys.", this, i2, currTime, prevTime);
        valid = false;
        break;
      }
      prevTime = currTime;
    }
    if (values2 !== void 0) {
      if (isTypedArray(values2)) {
        for (let i2 = 0, n2 = values2.length; i2 !== n2; ++i2) {
          const value = values2[i2];
          if (isNaN(value)) {
            console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i2, value);
            valid = false;
            break;
          }
        }
      }
    }
    return valid;
  }
  /**
   * Optimizes this keyframe track by removing equivalent sequential keys (which are
   * common in morph target sequences).
   *
   * @return {AnimationClip} A reference to this animation clip.
   */
  optimize() {
    const times = this.times.slice(), values2 = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === InterpolateSmooth, lastIndex = times.length - 1;
    let writeIndex = 1;
    for (let i2 = 1; i2 < lastIndex; ++i2) {
      let keep = false;
      const time = times[i2];
      const timeNext = times[i2 + 1];
      if (time !== timeNext && (i2 !== 1 || time !== times[0])) {
        if (!smoothInterpolation) {
          const offset2 = i2 * stride, offsetP = offset2 - stride, offsetN = offset2 + stride;
          for (let j = 0; j !== stride; ++j) {
            const value = values2[offset2 + j];
            if (value !== values2[offsetP + j] || value !== values2[offsetN + j]) {
              keep = true;
              break;
            }
          }
        } else {
          keep = true;
        }
      }
      if (keep) {
        if (i2 !== writeIndex) {
          times[writeIndex] = times[i2];
          const readOffset = i2 * stride, writeOffset = writeIndex * stride;
          for (let j = 0; j !== stride; ++j) {
            values2[writeOffset + j] = values2[readOffset + j];
          }
        }
        ++writeIndex;
      }
    }
    if (lastIndex > 0) {
      times[writeIndex] = times[lastIndex];
      for (let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j) {
        values2[writeOffset + j] = values2[readOffset + j];
      }
      ++writeIndex;
    }
    if (writeIndex !== times.length) {
      this.times = times.slice(0, writeIndex);
      this.values = values2.slice(0, writeIndex * stride);
    } else {
      this.times = times;
      this.values = values2;
    }
    return this;
  }
  /**
   * Returns a new keyframe track with copied values from this instance.
   *
   * @return {KeyframeTrack} A clone of this instance.
   */
  clone() {
    const times = this.times.slice();
    const values2 = this.values.slice();
    const TypedKeyframeTrack = this.constructor;
    const track = new TypedKeyframeTrack(this.name, times, values2);
    track.createInterpolant = this.createInterpolant;
    return track;
  }
}
KeyframeTrack.prototype.ValueTypeName = "";
KeyframeTrack.prototype.TimeBufferType = Float32Array;
KeyframeTrack.prototype.ValueBufferType = Float32Array;
KeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
class BooleanKeyframeTrack extends KeyframeTrack {
  /**
   * Constructs a new boolean keyframe track.
   *
   * This keyframe track type has no `interpolation` parameter because the
   * interpolation is always discrete.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   */
  constructor(name, times, values2) {
    super(name, times, values2);
  }
}
BooleanKeyframeTrack.prototype.ValueTypeName = "bool";
BooleanKeyframeTrack.prototype.ValueBufferType = Array;
BooleanKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class ColorKeyframeTrack extends KeyframeTrack {
  /**
   * Constructs a new color keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(name, times, values2, interpolation) {
    super(name, times, values2, interpolation);
  }
}
ColorKeyframeTrack.prototype.ValueTypeName = "color";
class NumberKeyframeTrack extends KeyframeTrack {
  /**
   * Constructs a new number keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(name, times, values2, interpolation) {
    super(name, times, values2, interpolation);
  }
}
NumberKeyframeTrack.prototype.ValueTypeName = "number";
class QuaternionLinearInterpolant extends Interpolant {
  /**
   * Constructs a new SLERP interpolant.
   *
   * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
   * @param {TypedArray} sampleValues - The sample values.
   * @param {number} sampleSize - The sample size
   * @param {TypedArray} [resultBuffer] - The result buffer.
   */
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1, t0, t3, t1) {
    const result2 = this.resultBuffer, values2 = this.sampleValues, stride = this.valueSize, alpha = (t3 - t0) / (t1 - t0);
    let offset2 = i1 * stride;
    for (let end = offset2 + stride; offset2 !== end; offset2 += 4) {
      Quaternion.slerpFlat(result2, 0, values2, offset2 - stride, values2, offset2, alpha);
    }
    return result2;
  }
}
class QuaternionKeyframeTrack extends KeyframeTrack {
  /**
   * Constructs a new Quaternion keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(name, times, values2, interpolation) {
    super(name, times, values2, interpolation);
  }
  /**
   * Overwritten so the method returns Quaternion based interpolant.
   *
   * @static
   * @param {TypedArray} [result] - The result buffer.
   * @return {QuaternionLinearInterpolant} The new interpolant.
   */
  InterpolantFactoryMethodLinear(result2) {
    return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), result2);
  }
}
QuaternionKeyframeTrack.prototype.ValueTypeName = "quaternion";
QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class StringKeyframeTrack extends KeyframeTrack {
  /**
   * Constructs a new string keyframe track.
   *
   * This keyframe track type has no `interpolation` parameter because the
   * interpolation is always discrete.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   */
  constructor(name, times, values2) {
    super(name, times, values2);
  }
}
StringKeyframeTrack.prototype.ValueTypeName = "string";
StringKeyframeTrack.prototype.ValueBufferType = Array;
StringKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class VectorKeyframeTrack extends KeyframeTrack {
  /**
   * Constructs a new vector keyframe track.
   *
   * @param {string} name - The keyframe track's name.
   * @param {Array<number>} times - A list of keyframe times.
   * @param {Array<number>} values - A list of keyframe values.
   * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
   */
  constructor(name, times, values2, interpolation) {
    super(name, times, values2, interpolation);
  }
}
VectorKeyframeTrack.prototype.ValueTypeName = "vector";
class AnimationClip {
  /**
   * Constructs a new animation clip.
   *
   * Note: Instead of instantiating an AnimationClip directly with the constructor, you can
   * use the static interface of this class for creating clips. In most cases though, animation clips
   * will automatically be created by loaders when importing animated 3D assets.
   *
   * @param {string} [name=''] - The clip's name.
   * @param {number} [duration=-1] - The clip's duration in seconds. If a negative value is passed,
   * the duration will be calculated from the passed keyframes.
   * @param {Array<KeyframeTrack>} tracks - An array of keyframe tracks.
   * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode=NormalAnimationBlendMode] - Defines how the animation
   * is blended/combined when two or more animations are simultaneously played.
   */
  constructor(name = "", duration = -1, tracks = [], blendMode = NormalAnimationBlendMode) {
    this.name = name;
    this.tracks = tracks;
    this.duration = duration;
    this.blendMode = blendMode;
    this.uuid = generateUUID();
    if (this.duration < 0) {
      this.resetDuration();
    }
  }
  /**
   * Factory method for creating an animation clip from the given JSON.
   *
   * @static
   * @param {Object} json - The serialized animation clip.
   * @return {AnimationClip} The new animation clip.
   */
  static parse(json) {
    const tracks = [], jsonTracks = json.tracks, frameTime = 1 / (json.fps || 1);
    for (let i2 = 0, n2 = jsonTracks.length; i2 !== n2; ++i2) {
      tracks.push(parseKeyframeTrack(jsonTracks[i2]).scale(frameTime));
    }
    const clip2 = new this(json.name, json.duration, tracks, json.blendMode);
    clip2.uuid = json.uuid;
    return clip2;
  }
  /**
   * Serializes the given animation clip into JSON.
   *
   * @static
   * @param {AnimationClip} clip - The animation clip to serialize.
   * @return {Object} The JSON object.
   */
  static toJSON(clip2) {
    const tracks = [], clipTracks = clip2.tracks;
    const json = {
      "name": clip2.name,
      "duration": clip2.duration,
      "tracks": tracks,
      "uuid": clip2.uuid,
      "blendMode": clip2.blendMode
    };
    for (let i2 = 0, n2 = clipTracks.length; i2 !== n2; ++i2) {
      tracks.push(KeyframeTrack.toJSON(clipTracks[i2]));
    }
    return json;
  }
  /**
   * Returns a new animation clip from the passed morph targets array of a
   * geometry, taking a name and the number of frames per second.
   *
   * Note: The fps parameter is required, but the animation speed can be
   * overridden via {@link AnimationAction#setDuration}.
   *
   * @static
   * @param {string} name - The name of the animation clip.
   * @param {Array<Object>} morphTargetSequence - A sequence of morph targets.
   * @param {number} fps - The Frames-Per-Second value.
   * @param {boolean} noLoop - Whether the clip should be no loop or not.
   * @return {AnimationClip} The new animation clip.
   */
  static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
    const numMorphTargets = morphTargetSequence.length;
    const tracks = [];
    for (let i2 = 0; i2 < numMorphTargets; i2++) {
      let times = [];
      let values2 = [];
      times.push(
        (i2 + numMorphTargets - 1) % numMorphTargets,
        i2,
        (i2 + 1) % numMorphTargets
      );
      values2.push(0, 1, 0);
      const order = getKeyframeOrder(times);
      times = sortedArray(times, 1, order);
      values2 = sortedArray(values2, 1, order);
      if (!noLoop && times[0] === 0) {
        times.push(numMorphTargets);
        values2.push(values2[0]);
      }
      tracks.push(
        new NumberKeyframeTrack(
          ".morphTargetInfluences[" + morphTargetSequence[i2].name + "]",
          times,
          values2
        ).scale(1 / fps)
      );
    }
    return new this(name, -1, tracks);
  }
  /**
   * Searches for an animation clip by name, taking as its first parameter
   * either an array of clips, or a mesh or geometry that contains an
   * array named "animations" property.
   *
   * @static
   * @param {(Array<AnimationClip>|Object3D)} objectOrClipArray - The array or object to search through.
   * @param {string} name - The name to search for.
   * @return {?AnimationClip} The found animation clip. Returns `null` if no clip has been found.
   */
  static findByName(objectOrClipArray, name) {
    let clipArray = objectOrClipArray;
    if (!Array.isArray(objectOrClipArray)) {
      const o = objectOrClipArray;
      clipArray = o.geometry && o.geometry.animations || o.animations;
    }
    for (let i2 = 0; i2 < clipArray.length; i2++) {
      if (clipArray[i2].name === name) {
        return clipArray[i2];
      }
    }
    return null;
  }
  /**
   * Returns an array of new AnimationClips created from the morph target
   * sequences of a geometry, trying to sort morph target names into
   * animation-group-based patterns like "Walk_001, Walk_002, Run_001, Run_002...".
   *
   * See {@link MD2Loader#parse} as an example for how the method should be used.
   *
   * @static
   * @param {Array<Object>} morphTargets - A sequence of morph targets.
   * @param {number} fps - The Frames-Per-Second value.
   * @param {boolean} noLoop - Whether the clip should be no loop or not.
   * @return {Array<AnimationClip>} An array of new animation clips.
   */
  static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
    const animationToMorphTargets = {};
    const pattern = /^([\w-]*?)([\d]+)$/;
    for (let i2 = 0, il = morphTargets.length; i2 < il; i2++) {
      const morphTarget = morphTargets[i2];
      const parts = morphTarget.name.match(pattern);
      if (parts && parts.length > 1) {
        const name = parts[1];
        let animationMorphTargets = animationToMorphTargets[name];
        if (!animationMorphTargets) {
          animationToMorphTargets[name] = animationMorphTargets = [];
        }
        animationMorphTargets.push(morphTarget);
      }
    }
    const clips = [];
    for (const name in animationToMorphTargets) {
      clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
    }
    return clips;
  }
  /**
   * Parses the `animation.hierarchy` format and returns a new animation clip.
   *
   * @static
   * @deprecated since r175.
   * @param {Object} animation - A serialized animation clip as JSON.
   * @param {Array<Bones>} bones - An array of bones.
   * @return {?AnimationClip} The new animation clip.
   */
  static parseAnimation(animation, bones) {
    console.warn("THREE.AnimationClip: parseAnimation() is deprecated and will be removed with r185");
    if (!animation) {
      console.error("THREE.AnimationClip: No animation in JSONLoader data.");
      return null;
    }
    const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
      if (animationKeys.length !== 0) {
        const times = [];
        const values2 = [];
        flattenJSON(animationKeys, times, values2, propertyName);
        if (times.length !== 0) {
          destTracks.push(new trackType(trackName, times, values2));
        }
      }
    };
    const tracks = [];
    const clipName = animation.name || "default";
    const fps = animation.fps || 30;
    const blendMode = animation.blendMode;
    let duration = animation.length || -1;
    const hierarchyTracks = animation.hierarchy || [];
    for (let h = 0; h < hierarchyTracks.length; h++) {
      const animationKeys = hierarchyTracks[h].keys;
      if (!animationKeys || animationKeys.length === 0)
        continue;
      if (animationKeys[0].morphTargets) {
        const morphTargetNames = {};
        let k;
        for (k = 0; k < animationKeys.length; k++) {
          if (animationKeys[k].morphTargets) {
            for (let m = 0; m < animationKeys[k].morphTargets.length; m++) {
              morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
            }
          }
        }
        for (const morphTargetName in morphTargetNames) {
          const times = [];
          const values2 = [];
          for (let m = 0; m !== animationKeys[k].morphTargets.length; ++m) {
            const animationKey = animationKeys[k];
            times.push(animationKey.time);
            values2.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
          }
          tracks.push(new NumberKeyframeTrack(".morphTargetInfluence[" + morphTargetName + "]", times, values2));
        }
        duration = morphTargetNames.length * fps;
      } else {
        const boneName = ".bones[" + bones[h].name + "]";
        addNonemptyTrack(
          VectorKeyframeTrack,
          boneName + ".position",
          animationKeys,
          "pos",
          tracks
        );
        addNonemptyTrack(
          QuaternionKeyframeTrack,
          boneName + ".quaternion",
          animationKeys,
          "rot",
          tracks
        );
        addNonemptyTrack(
          VectorKeyframeTrack,
          boneName + ".scale",
          animationKeys,
          "scl",
          tracks
        );
      }
    }
    if (tracks.length === 0) {
      return null;
    }
    const clip2 = new this(clipName, duration, tracks, blendMode);
    return clip2;
  }
  /**
   * Sets the duration of this clip to the duration of its longest keyframe track.
   *
   * @return {AnimationClip} A reference to this animation clip.
   */
  resetDuration() {
    const tracks = this.tracks;
    let duration = 0;
    for (let i2 = 0, n2 = tracks.length; i2 !== n2; ++i2) {
      const track = this.tracks[i2];
      duration = Math.max(duration, track.times[track.times.length - 1]);
    }
    this.duration = duration;
    return this;
  }
  /**
   * Trims all tracks to the clip's duration.
   *
   * @return {AnimationClip} A reference to this animation clip.
   */
  trim() {
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      this.tracks[i2].trim(0, this.duration);
    }
    return this;
  }
  /**
   * Performs minimal validation on each track in the clip. Returns `true` if all
   * tracks are valid.
   *
   * @return {boolean} Whether the clip's keyframes are valid or not.
   */
  validate() {
    let valid = true;
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      valid = valid && this.tracks[i2].validate();
    }
    return valid;
  }
  /**
   * Optimizes each track by removing equivalent sequential keys (which are
   * common in morph target sequences).
   *
   * @return {AnimationClip} A reference to this animation clip.
   */
  optimize() {
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      this.tracks[i2].optimize();
    }
    return this;
  }
  /**
   * Returns a new animation clip with copied values from this instance.
   *
   * @return {AnimationClip} A clone of this instance.
   */
  clone() {
    const tracks = [];
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      tracks.push(this.tracks[i2].clone());
    }
    return new this.constructor(this.name, this.duration, tracks, this.blendMode);
  }
  /**
   * Serializes this animation clip into JSON.
   *
   * @return {Object} The JSON object.
   */
  toJSON() {
    return this.constructor.toJSON(this);
  }
}
function getTrackTypeForValueTypeName(typeName) {
  switch (typeName.toLowerCase()) {
    case "scalar":
    case "double":
    case "float":
    case "number":
    case "integer":
      return NumberKeyframeTrack;
    case "vector":
    case "vector2":
    case "vector3":
    case "vector4":
      return VectorKeyframeTrack;
    case "color":
      return ColorKeyframeTrack;
    case "quaternion":
      return QuaternionKeyframeTrack;
    case "bool":
    case "boolean":
      return BooleanKeyframeTrack;
    case "string":
      return StringKeyframeTrack;
  }
  throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function parseKeyframeTrack(json) {
  if (json.type === void 0) {
    throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
  }
  const trackType = getTrackTypeForValueTypeName(json.type);
  if (json.times === void 0) {
    const times = [], values2 = [];
    flattenJSON(json.keys, times, values2, "value");
    json.times = times;
    json.values = values2;
  }
  if (trackType.parse !== void 0) {
    return trackType.parse(json);
  } else {
    return new trackType(json.name, json.times, json.values, json.interpolation);
  }
}
class PropertyMixer {
  /**
   * Constructs a new property mixer.
   *
   * @param {PropertyBinding} binding - The property binding.
   * @param {string} typeName - The keyframe track type name.
   * @param {number} valueSize - The keyframe track value size.
   */
  constructor(binding, typeName, valueSize) {
    this.binding = binding;
    this.valueSize = valueSize;
    let mixFunction, mixFunctionAdditive, setIdentity;
    switch (typeName) {
      case "quaternion":
        mixFunction = this._slerp;
        mixFunctionAdditive = this._slerpAdditive;
        setIdentity = this._setAdditiveIdentityQuaternion;
        this.buffer = new Float64Array(valueSize * 6);
        this._workIndex = 5;
        break;
      case "string":
      case "bool":
        mixFunction = this._select;
        mixFunctionAdditive = this._select;
        setIdentity = this._setAdditiveIdentityOther;
        this.buffer = new Array(valueSize * 5);
        break;
      default:
        mixFunction = this._lerp;
        mixFunctionAdditive = this._lerpAdditive;
        setIdentity = this._setAdditiveIdentityNumeric;
        this.buffer = new Float64Array(valueSize * 5);
    }
    this._mixBufferRegion = mixFunction;
    this._mixBufferRegionAdditive = mixFunctionAdditive;
    this._setIdentity = setIdentity;
    this._origIndex = 3;
    this._addIndex = 4;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    this.useCount = 0;
    this.referenceCount = 0;
  }
  /**
   * Accumulates data in the `incoming` region into `accu<i>`.
   *
   * @param {number} accuIndex - The accumulation index.
   * @param {number} weight - The weight.
   */
  accumulate(accuIndex, weight) {
    const buffer = this.buffer, stride = this.valueSize, offset2 = accuIndex * stride + stride;
    let currentWeight = this.cumulativeWeight;
    if (currentWeight === 0) {
      for (let i2 = 0; i2 !== stride; ++i2) {
        buffer[offset2 + i2] = buffer[i2];
      }
      currentWeight = weight;
    } else {
      currentWeight += weight;
      const mix = weight / currentWeight;
      this._mixBufferRegion(buffer, offset2, 0, mix, stride);
    }
    this.cumulativeWeight = currentWeight;
  }
  /**
   * Accumulates data in the `incoming` region into `add`.
   *
   * @param {number} weight - The weight.
   */
  accumulateAdditive(weight) {
    const buffer = this.buffer, stride = this.valueSize, offset2 = stride * this._addIndex;
    if (this.cumulativeWeightAdditive === 0) {
      this._setIdentity();
    }
    this._mixBufferRegionAdditive(buffer, offset2, 0, weight, stride);
    this.cumulativeWeightAdditive += weight;
  }
  /**
   * Applies the state of `accu<i>` to the binding when accus differ.
   *
   * @param {number} accuIndex - The accumulation index.
   */
  apply(accuIndex) {
    const stride = this.valueSize, buffer = this.buffer, offset2 = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    if (weight < 1) {
      const originalValueOffset = stride * this._origIndex;
      this._mixBufferRegion(
        buffer,
        offset2,
        originalValueOffset,
        1 - weight,
        stride
      );
    }
    if (weightAdditive > 0) {
      this._mixBufferRegionAdditive(buffer, offset2, this._addIndex * stride, 1, stride);
    }
    for (let i2 = stride, e = stride + stride; i2 !== e; ++i2) {
      if (buffer[i2] !== buffer[i2 + stride]) {
        binding.setValue(buffer, offset2);
        break;
      }
    }
  }
  /**
   * Remembers the state of the bound property and copy it to both accus.
   */
  saveOriginalState() {
    const binding = this.binding;
    const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
    binding.getValue(buffer, originalValueOffset);
    for (let i2 = stride, e = originalValueOffset; i2 !== e; ++i2) {
      buffer[i2] = buffer[originalValueOffset + i2 % stride];
    }
    this._setIdentity();
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
  }
  /**
   * Applies the state previously taken via {@link PropertyMixer#saveOriginalState} to the binding.
   */
  restoreOriginalState() {
    const originalValueOffset = this.valueSize * 3;
    this.binding.setValue(this.buffer, originalValueOffset);
  }
  // internals
  _setAdditiveIdentityNumeric() {
    const startIndex = this._addIndex * this.valueSize;
    const endIndex = startIndex + this.valueSize;
    for (let i2 = startIndex; i2 < endIndex; i2++) {
      this.buffer[i2] = 0;
    }
  }
  _setAdditiveIdentityQuaternion() {
    this._setAdditiveIdentityNumeric();
    this.buffer[this._addIndex * this.valueSize + 3] = 1;
  }
  _setAdditiveIdentityOther() {
    const startIndex = this._origIndex * this.valueSize;
    const targetIndex = this._addIndex * this.valueSize;
    for (let i2 = 0; i2 < this.valueSize; i2++) {
      this.buffer[targetIndex + i2] = this.buffer[startIndex + i2];
    }
  }
  // mix functions
  _select(buffer, dstOffset, srcOffset, t3, stride) {
    if (t3 >= 0.5) {
      for (let i2 = 0; i2 !== stride; ++i2) {
        buffer[dstOffset + i2] = buffer[srcOffset + i2];
      }
    }
  }
  _slerp(buffer, dstOffset, srcOffset, t3) {
    Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t3);
  }
  _slerpAdditive(buffer, dstOffset, srcOffset, t3, stride) {
    const workOffset = this._workIndex * stride;
    Quaternion.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
    Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t3);
  }
  _lerp(buffer, dstOffset, srcOffset, t3, stride) {
    const s2 = 1 - t3;
    for (let i2 = 0; i2 !== stride; ++i2) {
      const j = dstOffset + i2;
      buffer[j] = buffer[j] * s2 + buffer[srcOffset + i2] * t3;
    }
  }
  _lerpAdditive(buffer, dstOffset, srcOffset, t3, stride) {
    for (let i2 = 0; i2 !== stride; ++i2) {
      const j = dstOffset + i2;
      buffer[j] = buffer[j] + buffer[srcOffset + i2] * t3;
    }
  }
}
const _RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const _reservedRe = new RegExp("[" + _RESERVED_CHARS_RE + "]", "g");
const _wordChar = "[^" + _RESERVED_CHARS_RE + "]";
const _wordCharOrDot = "[^" + _RESERVED_CHARS_RE.replace("\\.", "") + "]";
const _directoryRe = /* @__PURE__ */ /((?:WC+[\/:])*)/.source.replace("WC", _wordChar);
const _nodeRe = /* @__PURE__ */ /(WCOD+)?/.source.replace("WCOD", _wordCharOrDot);
const _objectRe = /* @__PURE__ */ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", _wordChar);
const _propertyRe = /* @__PURE__ */ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", _wordChar);
const _trackRe = new RegExp(
  "^" + _directoryRe + _nodeRe + _objectRe + _propertyRe + "$"
);
const _supportedObjectNames = ["material", "materials", "bones", "map"];
class Composite {
  constructor(targetGroup, path, optionalParsedPath) {
    const parsedPath = optionalParsedPath || PropertyBinding.parseTrackName(path);
    this._targetGroup = targetGroup;
    this._bindings = targetGroup.subscribe_(path, parsedPath);
  }
  getValue(array, offset2) {
    this.bind();
    const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
    if (binding !== void 0)
      binding.getValue(array, offset2);
  }
  setValue(array, offset2) {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].setValue(array, offset2);
    }
  }
  bind() {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].bind();
    }
  }
  unbind() {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].unbind();
    }
  }
}
class PropertyBinding {
  /**
   * Constructs a new property binding.
   *
   * @param {Object} rootNode - The root node.
   * @param {string} path - The path.
   * @param {?Object} [parsedPath] - The parsed path.
   */
  constructor(rootNode, path, parsedPath) {
    this.path = path;
    this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path);
    this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName);
    this.rootNode = rootNode;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
  /**
   * Factory method for creating a property binding from the given parameters.
   *
   * @static
   * @param {Object} root - The root node.
   * @param {string} path - The path.
   * @param {?Object} [parsedPath] - The parsed path.
   * @return {PropertyBinding|Composite} The created property binding or composite.
   */
  static create(root2, path, parsedPath) {
    if (!(root2 && root2.isAnimationObjectGroup)) {
      return new PropertyBinding(root2, path, parsedPath);
    } else {
      return new PropertyBinding.Composite(root2, path, parsedPath);
    }
  }
  /**
   * Replaces spaces with underscores and removes unsupported characters from
   * node names, to ensure compatibility with parseTrackName().
   *
   * @param {string} name - Node name to be sanitized.
   * @return {string} The sanitized node name.
   */
  static sanitizeNodeName(name) {
    return name.replace(/\s/g, "_").replace(_reservedRe, "");
  }
  /**
   * Parses the given track name (an object path to an animated property) and
   * returns an object with information about the path. Matches strings in the following forms:
   *
   * - nodeName.property
   * - nodeName.property[accessor]
   * - nodeName.material.property[accessor]
   * - uuid.property[accessor]
   * - uuid.objectName[objectIndex].propertyName[propertyIndex]
   * - parentName/nodeName.property
   * - parentName/parentName/nodeName.property[index]
   * - .bone[Armature.DEF_cog].position
   * - scene:helium_balloon_model:helium_balloon_model.position
   *
   * @static
   * @param {string} trackName - The track name to parse.
   * @return {Object} The parsed track name as an object.
   */
  static parseTrackName(trackName) {
    const matches2 = _trackRe.exec(trackName);
    if (matches2 === null) {
      throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
    }
    const results = {
      // directoryName: matches[ 1 ], // (tschw) currently unused
      nodeName: matches2[2],
      objectName: matches2[3],
      objectIndex: matches2[4],
      propertyName: matches2[5],
      // required
      propertyIndex: matches2[6]
    };
    const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
    if (lastDot !== void 0 && lastDot !== -1) {
      const objectName = results.nodeName.substring(lastDot + 1);
      if (_supportedObjectNames.indexOf(objectName) !== -1) {
        results.nodeName = results.nodeName.substring(0, lastDot);
        results.objectName = objectName;
      }
    }
    if (results.propertyName === null || results.propertyName.length === 0) {
      throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
    }
    return results;
  }
  /**
   * Searches for a node in the hierarchy of the given root object by the given
   * node name.
   *
   * @static
   * @param {Object} root - The root object.
   * @param {string|number} nodeName - The name of the node.
   * @return {?Object} The found node. Returns `null` if no object was found.
   */
  static findNode(root2, nodeName) {
    if (nodeName === void 0 || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root2.name || nodeName === root2.uuid) {
      return root2;
    }
    if (root2.skeleton) {
      const bone = root2.skeleton.getBoneByName(nodeName);
      if (bone !== void 0) {
        return bone;
      }
    }
    if (root2.children) {
      const searchNodeSubtree = function(children) {
        for (let i2 = 0; i2 < children.length; i2++) {
          const childNode = children[i2];
          if (childNode.name === nodeName || childNode.uuid === nodeName) {
            return childNode;
          }
          const result2 = searchNodeSubtree(childNode.children);
          if (result2)
            return result2;
        }
        return null;
      };
      const subTreeNode = searchNodeSubtree(root2.children);
      if (subTreeNode) {
        return subTreeNode;
      }
    }
    return null;
  }
  // these are used to "bind" a nonexistent property
  _getValue_unavailable() {
  }
  _setValue_unavailable() {
  }
  // Getters
  _getValue_direct(buffer, offset2) {
    buffer[offset2] = this.targetObject[this.propertyName];
  }
  _getValue_array(buffer, offset2) {
    const source = this.resolvedProperty;
    for (let i2 = 0, n2 = source.length; i2 !== n2; ++i2) {
      buffer[offset2++] = source[i2];
    }
  }
  _getValue_arrayElement(buffer, offset2) {
    buffer[offset2] = this.resolvedProperty[this.propertyIndex];
  }
  _getValue_toArray(buffer, offset2) {
    this.resolvedProperty.toArray(buffer, offset2);
  }
  // Direct
  _setValue_direct(buffer, offset2) {
    this.targetObject[this.propertyName] = buffer[offset2];
  }
  _setValue_direct_setNeedsUpdate(buffer, offset2) {
    this.targetObject[this.propertyName] = buffer[offset2];
    this.targetObject.needsUpdate = true;
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset2) {
    this.targetObject[this.propertyName] = buffer[offset2];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // EntireArray
  _setValue_array(buffer, offset2) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer[offset2++];
    }
  }
  _setValue_array_setNeedsUpdate(buffer, offset2) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer[offset2++];
    }
    this.targetObject.needsUpdate = true;
  }
  _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset2) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer[offset2++];
    }
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // ArrayElement
  _setValue_arrayElement(buffer, offset2) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset2];
  }
  _setValue_arrayElement_setNeedsUpdate(buffer, offset2) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset2];
    this.targetObject.needsUpdate = true;
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset2) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset2];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // HasToFromArray
  _setValue_fromArray(buffer, offset2) {
    this.resolvedProperty.fromArray(buffer, offset2);
  }
  _setValue_fromArray_setNeedsUpdate(buffer, offset2) {
    this.resolvedProperty.fromArray(buffer, offset2);
    this.targetObject.needsUpdate = true;
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset2) {
    this.resolvedProperty.fromArray(buffer, offset2);
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _getValue_unbound(targetArray, offset2) {
    this.bind();
    this.getValue(targetArray, offset2);
  }
  _setValue_unbound(sourceArray, offset2) {
    this.bind();
    this.setValue(sourceArray, offset2);
  }
  /**
   * Creates a getter / setter pair for the property tracked by this binding.
   */
  bind() {
    let targetObject = this.node;
    const parsedPath = this.parsedPath;
    const objectName = parsedPath.objectName;
    const propertyName = parsedPath.propertyName;
    let propertyIndex = parsedPath.propertyIndex;
    if (!targetObject) {
      targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName);
      this.node = targetObject;
    }
    this.getValue = this._getValue_unavailable;
    this.setValue = this._setValue_unavailable;
    if (!targetObject) {
      console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
      return;
    }
    if (objectName) {
      let objectIndex = parsedPath.objectIndex;
      switch (objectName) {
        case "materials":
          if (!targetObject.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!targetObject.material.materials) {
            console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
            return;
          }
          targetObject = targetObject.material.materials;
          break;
        case "bones":
          if (!targetObject.skeleton) {
            console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
            return;
          }
          targetObject = targetObject.skeleton.bones;
          for (let i2 = 0; i2 < targetObject.length; i2++) {
            if (targetObject[i2].name === objectIndex) {
              objectIndex = i2;
              break;
            }
          }
          break;
        case "map":
          if ("map" in targetObject) {
            targetObject = targetObject.map;
            break;
          }
          if (!targetObject.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!targetObject.material.map) {
            console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
            return;
          }
          targetObject = targetObject.material.map;
          break;
        default:
          if (targetObject[objectName] === void 0) {
            console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
            return;
          }
          targetObject = targetObject[objectName];
      }
      if (objectIndex !== void 0) {
        if (targetObject[objectIndex] === void 0) {
          console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
          return;
        }
        targetObject = targetObject[objectIndex];
      }
    }
    const nodeProperty = targetObject[propertyName];
    if (nodeProperty === void 0) {
      const nodeName = parsedPath.nodeName;
      console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
      return;
    }
    let versioning = this.Versioning.None;
    this.targetObject = targetObject;
    if (targetObject.isMaterial === true) {
      versioning = this.Versioning.NeedsUpdate;
    } else if (targetObject.isObject3D === true) {
      versioning = this.Versioning.MatrixWorldNeedsUpdate;
    }
    let bindingType = this.BindingType.Direct;
    if (propertyIndex !== void 0) {
      if (propertyName === "morphTargetInfluences") {
        if (!targetObject.geometry) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
          return;
        }
        if (!targetObject.geometry.morphAttributes) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
          return;
        }
        if (targetObject.morphTargetDictionary[propertyIndex] !== void 0) {
          propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
        }
      }
      bindingType = this.BindingType.ArrayElement;
      this.resolvedProperty = nodeProperty;
      this.propertyIndex = propertyIndex;
    } else if (nodeProperty.fromArray !== void 0 && nodeProperty.toArray !== void 0) {
      bindingType = this.BindingType.HasFromToArray;
      this.resolvedProperty = nodeProperty;
    } else if (Array.isArray(nodeProperty)) {
      bindingType = this.BindingType.EntireArray;
      this.resolvedProperty = nodeProperty;
    } else {
      this.propertyName = propertyName;
    }
    this.getValue = this.GetterByBindingType[bindingType];
    this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
  }
  /**
   * Unbinds the property.
   */
  unbind() {
    this.node = null;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
}
PropertyBinding.Composite = Composite;
PropertyBinding.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
};
PropertyBinding.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
};
PropertyBinding.prototype.GetterByBindingType = [
  PropertyBinding.prototype._getValue_direct,
  PropertyBinding.prototype._getValue_array,
  PropertyBinding.prototype._getValue_arrayElement,
  PropertyBinding.prototype._getValue_toArray
];
PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [
  [
    // Direct
    PropertyBinding.prototype._setValue_direct,
    PropertyBinding.prototype._setValue_direct_setNeedsUpdate,
    PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate
  ],
  [
    // EntireArray
    PropertyBinding.prototype._setValue_array,
    PropertyBinding.prototype._setValue_array_setNeedsUpdate,
    PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate
  ],
  [
    // ArrayElement
    PropertyBinding.prototype._setValue_arrayElement,
    PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate,
    PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
  ],
  [
    // HasToFromArray
    PropertyBinding.prototype._setValue_fromArray,
    PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate,
    PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
  ]
];
class AnimationAction {
  /**
   * Constructs a new animation action.
   *
   * @param {AnimationMixer} mixer - The mixer that is controlled by this action.
   * @param {AnimationClip} clip - The animation clip that holds the actual keyframes.
   * @param {?Object3D} [localRoot=null] - The root object on which this action is performed.
   * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
   */
  constructor(mixer, clip2, localRoot = null, blendMode = clip2.blendMode) {
    this._mixer = mixer;
    this._clip = clip2;
    this._localRoot = localRoot;
    this.blendMode = blendMode;
    const tracks = clip2.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
    const interpolantSettings = {
      endingStart: ZeroCurvatureEnding,
      endingEnd: ZeroCurvatureEnding
    };
    for (let i2 = 0; i2 !== nTracks; ++i2) {
      const interpolant = tracks[i2].createInterpolant(null);
      interpolants[i2] = interpolant;
      interpolant.settings = interpolantSettings;
    }
    this._interpolantSettings = interpolantSettings;
    this._interpolants = interpolants;
    this._propertyBindings = new Array(nTracks);
    this._cacheIndex = null;
    this._byClipCacheIndex = null;
    this._timeScaleInterpolant = null;
    this._weightInterpolant = null;
    this.loop = LoopRepeat;
    this._loopCount = -1;
    this._startTime = null;
    this.time = 0;
    this.timeScale = 1;
    this._effectiveTimeScale = 1;
    this.weight = 1;
    this._effectiveWeight = 1;
    this.repetitions = Infinity;
    this.paused = false;
    this.enabled = true;
    this.clampWhenFinished = false;
    this.zeroSlopeAtStart = true;
    this.zeroSlopeAtEnd = true;
  }
  /**
   * Starts the playback of the animation.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  play() {
    this._mixer._activateAction(this);
    return this;
  }
  /**
   * Stops the playback of the animation.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  stop() {
    this._mixer._deactivateAction(this);
    return this.reset();
  }
  /**
   * Resets the playback of the animation.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  reset() {
    this.paused = false;
    this.enabled = true;
    this.time = 0;
    this._loopCount = -1;
    this._startTime = null;
    return this.stopFading().stopWarping();
  }
  /**
   * Returns `true` if the animation is running.
   *
   * @return {boolean} Whether the animation is running or not.
   */
  isRunning() {
    return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
  }
  /**
   * Returns `true` when {@link AnimationAction#play} has been called.
   *
   * @return {boolean} Whether the animation is scheduled or not.
   */
  isScheduled() {
    return this._mixer._isActiveAction(this);
  }
  /**
   * Defines the time when the animation should start.
   *
   * @param {number} time - The start time in seconds.
   * @return {AnimationAction} A reference to this animation action.
   */
  startAt(time) {
    this._startTime = time;
    return this;
  }
  /**
   * Configures the loop settings for this action.
   *
   * @param {(LoopRepeat|LoopOnce|LoopPingPong)} mode - The loop mode.
   * @param {number} repetitions - The number of repetitions.
   * @return {AnimationAction} A reference to this animation action.
   */
  setLoop(mode, repetitions) {
    this.loop = mode;
    this.repetitions = repetitions;
    return this;
  }
  /**
   * Sets the effective weight of this action.
   *
   * An action has no effect and thus an effective weight of zero when the
   * action is disabled.
   *
   * @param {number} weight - The weight to set.
   * @return {AnimationAction} A reference to this animation action.
   */
  setEffectiveWeight(weight) {
    this.weight = weight;
    this._effectiveWeight = this.enabled ? weight : 0;
    return this.stopFading();
  }
  /**
   * Returns the effective weight of this action.
   *
   * @return {number} The effective weight.
   */
  getEffectiveWeight() {
    return this._effectiveWeight;
  }
  /**
   * Fades the animation in by increasing its weight gradually from `0` to `1`,
   * within the passed time interval.
   *
   * @param {number} duration - The duration of the fade.
   * @return {AnimationAction} A reference to this animation action.
   */
  fadeIn(duration) {
    return this._scheduleFading(duration, 0, 1);
  }
  /**
   * Fades the animation out by decreasing its weight gradually from `1` to `0`,
   * within the passed time interval.
   *
   * @param {number} duration - The duration of the fade.
   * @return {AnimationAction} A reference to this animation action.
   */
  fadeOut(duration) {
    return this._scheduleFading(duration, 1, 0);
  }
  /**
   * Causes this action to fade in and the given action to fade out,
   * within the passed time interval.
   *
   * @param {AnimationAction} fadeOutAction - The animation action to fade out.
   * @param {number} duration - The duration of the fade.
   * @param {boolean} [warp=false] - Whether warping should be used or not.
   * @return {AnimationAction} A reference to this animation action.
   */
  crossFadeFrom(fadeOutAction, duration, warp = false) {
    fadeOutAction.fadeOut(duration);
    this.fadeIn(duration);
    if (warp === true) {
      const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
      fadeOutAction.warp(1, startEndRatio, duration);
      this.warp(endStartRatio, 1, duration);
    }
    return this;
  }
  /**
   * Causes this action to fade out and the given action to fade in,
   * within the passed time interval.
   *
   * @param {AnimationAction} fadeInAction - The animation action to fade in.
   * @param {number} duration - The duration of the fade.
   * @param {boolean} [warp=false] - Whether warping should be used or not.
   * @return {AnimationAction} A reference to this animation action.
   */
  crossFadeTo(fadeInAction, duration, warp = false) {
    return fadeInAction.crossFadeFrom(this, duration, warp);
  }
  /**
   * Stops any fading which is applied to this action.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  stopFading() {
    const weightInterpolant = this._weightInterpolant;
    if (weightInterpolant !== null) {
      this._weightInterpolant = null;
      this._mixer._takeBackControlInterpolant(weightInterpolant);
    }
    return this;
  }
  /**
   * Sets the effective time scale of this action.
   *
   * An action has no effect and thus an effective time scale of zero when the
   * action is paused.
   *
   * @param {number} timeScale - The time scale to set.
   * @return {AnimationAction} A reference to this animation action.
   */
  setEffectiveTimeScale(timeScale) {
    this.timeScale = timeScale;
    this._effectiveTimeScale = this.paused ? 0 : timeScale;
    return this.stopWarping();
  }
  /**
   * Returns the effective time scale of this action.
   *
   * @return {number} The effective time scale.
   */
  getEffectiveTimeScale() {
    return this._effectiveTimeScale;
  }
  /**
   * Sets the duration for a single loop of this action.
   *
   * @param {number} duration - The duration to set.
   * @return {AnimationAction} A reference to this animation action.
   */
  setDuration(duration) {
    this.timeScale = this._clip.duration / duration;
    return this.stopWarping();
  }
  /**
   * Synchronizes this action with the passed other action.
   *
   * @param {AnimationAction} action - The action to sync with.
   * @return {AnimationAction} A reference to this animation action.
   */
  syncWith(action) {
    this.time = action.time;
    this.timeScale = action.timeScale;
    return this.stopWarping();
  }
  /**
   * Decelerates this animation's speed to `0` within the passed time interval.
   *
   * @param {number} duration - The duration.
   * @return {AnimationAction} A reference to this animation action.
   */
  halt(duration) {
    return this.warp(this._effectiveTimeScale, 0, duration);
  }
  /**
   * Changes the playback speed, within the passed time interval, by modifying
   * {@link AnimationAction#timeScale} gradually from `startTimeScale` to
   * `endTimeScale`.
   *
   * @param {number} startTimeScale - The start time scale.
   * @param {number} endTimeScale - The end time scale.
   * @param {number} duration - The duration.
   * @return {AnimationAction} A reference to this animation action.
   */
  warp(startTimeScale, endTimeScale, duration) {
    const mixer = this._mixer, now2 = mixer.time, timeScale = this.timeScale;
    let interpolant = this._timeScaleInterpolant;
    if (interpolant === null) {
      interpolant = mixer._lendControlInterpolant();
      this._timeScaleInterpolant = interpolant;
    }
    const times = interpolant.parameterPositions, values2 = interpolant.sampleValues;
    times[0] = now2;
    times[1] = now2 + duration;
    values2[0] = startTimeScale / timeScale;
    values2[1] = endTimeScale / timeScale;
    return this;
  }
  /**
   * Stops any scheduled warping which is applied to this action.
   *
   * @return {AnimationAction} A reference to this animation action.
   */
  stopWarping() {
    const timeScaleInterpolant = this._timeScaleInterpolant;
    if (timeScaleInterpolant !== null) {
      this._timeScaleInterpolant = null;
      this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
    }
    return this;
  }
  /**
   * Returns the animation mixer of this animation action.
   *
   * @return {AnimationMixer} The animation mixer.
   */
  getMixer() {
    return this._mixer;
  }
  /**
   * Returns the animation clip of this animation action.
   *
   * @return {AnimationClip} The animation clip.
   */
  getClip() {
    return this._clip;
  }
  /**
   * Returns the root object of this animation action.
   *
   * @return {Object3D} The root object.
   */
  getRoot() {
    return this._localRoot || this._mixer._root;
  }
  // Interna
  _update(time, deltaTime, timeDirection, accuIndex) {
    if (!this.enabled) {
      this._updateWeight(time);
      return;
    }
    const startTime = this._startTime;
    if (startTime !== null) {
      const timeRunning = (time - startTime) * timeDirection;
      if (timeRunning < 0 || timeDirection === 0) {
        deltaTime = 0;
      } else {
        this._startTime = null;
        deltaTime = timeDirection * timeRunning;
      }
    }
    deltaTime *= this._updateTimeScale(time);
    const clipTime = this._updateTime(deltaTime);
    const weight = this._updateWeight(time);
    if (weight > 0) {
      const interpolants = this._interpolants;
      const propertyMixers = this._propertyBindings;
      switch (this.blendMode) {
        case AdditiveAnimationBlendMode:
          for (let j = 0, m = interpolants.length; j !== m; ++j) {
            interpolants[j].evaluate(clipTime);
            propertyMixers[j].accumulateAdditive(weight);
          }
          break;
        case NormalAnimationBlendMode:
        default:
          for (let j = 0, m = interpolants.length; j !== m; ++j) {
            interpolants[j].evaluate(clipTime);
            propertyMixers[j].accumulate(accuIndex, weight);
          }
      }
    }
  }
  _updateWeight(time) {
    let weight = 0;
    if (this.enabled) {
      weight = this.weight;
      const interpolant = this._weightInterpolant;
      if (interpolant !== null) {
        const interpolantValue = interpolant.evaluate(time)[0];
        weight *= interpolantValue;
        if (time > interpolant.parameterPositions[1]) {
          this.stopFading();
          if (interpolantValue === 0) {
            this.enabled = false;
          }
        }
      }
    }
    this._effectiveWeight = weight;
    return weight;
  }
  _updateTimeScale(time) {
    let timeScale = 0;
    if (!this.paused) {
      timeScale = this.timeScale;
      const interpolant = this._timeScaleInterpolant;
      if (interpolant !== null) {
        const interpolantValue = interpolant.evaluate(time)[0];
        timeScale *= interpolantValue;
        if (time > interpolant.parameterPositions[1]) {
          this.stopWarping();
          if (timeScale === 0) {
            this.paused = true;
          } else {
            this.timeScale = timeScale;
          }
        }
      }
    }
    this._effectiveTimeScale = timeScale;
    return timeScale;
  }
  _updateTime(deltaTime) {
    const duration = this._clip.duration;
    const loop = this.loop;
    let time = this.time + deltaTime;
    let loopCount = this._loopCount;
    const pingPong = loop === LoopPingPong;
    if (deltaTime === 0) {
      if (loopCount === -1)
        return time;
      return pingPong && (loopCount & 1) === 1 ? duration - time : time;
    }
    if (loop === LoopOnce) {
      if (loopCount === -1) {
        this._loopCount = 0;
        this._setEndings(true, true, false);
      }
      handle_stop: {
        if (time >= duration) {
          time = duration;
        } else if (time < 0) {
          time = 0;
        } else {
          this.time = time;
          break handle_stop;
        }
        if (this.clampWhenFinished)
          this.paused = true;
        else
          this.enabled = false;
        this.time = time;
        this._mixer.dispatchEvent({
          type: "finished",
          action: this,
          direction: deltaTime < 0 ? -1 : 1
        });
      }
    } else {
      if (loopCount === -1) {
        if (deltaTime >= 0) {
          loopCount = 0;
          this._setEndings(true, this.repetitions === 0, pingPong);
        } else {
          this._setEndings(this.repetitions === 0, true, pingPong);
        }
      }
      if (time >= duration || time < 0) {
        const loopDelta = Math.floor(time / duration);
        time -= duration * loopDelta;
        loopCount += Math.abs(loopDelta);
        const pending2 = this.repetitions - loopCount;
        if (pending2 <= 0) {
          if (this.clampWhenFinished)
            this.paused = true;
          else
            this.enabled = false;
          time = deltaTime > 0 ? duration : 0;
          this.time = time;
          this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: deltaTime > 0 ? 1 : -1
          });
        } else {
          if (pending2 === 1) {
            const atStart = deltaTime < 0;
            this._setEndings(atStart, !atStart, pingPong);
          } else {
            this._setEndings(false, false, pingPong);
          }
          this._loopCount = loopCount;
          this.time = time;
          this._mixer.dispatchEvent({
            type: "loop",
            action: this,
            loopDelta
          });
        }
      } else {
        this.time = time;
      }
      if (pingPong && (loopCount & 1) === 1) {
        return duration - time;
      }
    }
    return time;
  }
  _setEndings(atStart, atEnd, pingPong) {
    const settings = this._interpolantSettings;
    if (pingPong) {
      settings.endingStart = ZeroSlopeEnding;
      settings.endingEnd = ZeroSlopeEnding;
    } else {
      if (atStart) {
        settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;
      } else {
        settings.endingStart = WrapAroundEnding;
      }
      if (atEnd) {
        settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;
      } else {
        settings.endingEnd = WrapAroundEnding;
      }
    }
  }
  _scheduleFading(duration, weightNow, weightThen) {
    const mixer = this._mixer, now2 = mixer.time;
    let interpolant = this._weightInterpolant;
    if (interpolant === null) {
      interpolant = mixer._lendControlInterpolant();
      this._weightInterpolant = interpolant;
    }
    const times = interpolant.parameterPositions, values2 = interpolant.sampleValues;
    times[0] = now2;
    values2[0] = weightNow;
    times[1] = now2 + duration;
    values2[1] = weightThen;
    return this;
  }
}
const _controlInterpolantsResultBuffer = new Float32Array(1);
class AnimationMixer extends EventDispatcher {
  /**
   * Constructs a new animation mixer.
   *
   * @param {Object3D} root - The object whose animations shall be played by this mixer.
   */
  constructor(root2) {
    super();
    this._root = root2;
    this._initMemoryManager();
    this._accuIndex = 0;
    this.time = 0;
    this.timeScale = 1;
  }
  _bindAction(action, prototypeAction) {
    const root2 = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root2.uuid, bindingsByRoot = this._bindingsByRootAndName;
    let bindingsByName = bindingsByRoot[rootUuid];
    if (bindingsByName === void 0) {
      bindingsByName = {};
      bindingsByRoot[rootUuid] = bindingsByName;
    }
    for (let i2 = 0; i2 !== nTracks; ++i2) {
      const track = tracks[i2], trackName = track.name;
      let binding = bindingsByName[trackName];
      if (binding !== void 0) {
        ++binding.referenceCount;
        bindings[i2] = binding;
      } else {
        binding = bindings[i2];
        if (binding !== void 0) {
          if (binding._cacheIndex === null) {
            ++binding.referenceCount;
            this._addInactiveBinding(binding, rootUuid, trackName);
          }
          continue;
        }
        const path = prototypeAction && prototypeAction._propertyBindings[i2].binding.parsedPath;
        binding = new PropertyMixer(
          PropertyBinding.create(root2, trackName, path),
          track.ValueTypeName,
          track.getValueSize()
        );
        ++binding.referenceCount;
        this._addInactiveBinding(binding, rootUuid, trackName);
        bindings[i2] = binding;
      }
      interpolants[i2].resultBuffer = binding.buffer;
    }
  }
  _activateAction(action) {
    if (!this._isActiveAction(action)) {
      if (action._cacheIndex === null) {
        const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
        this._bindAction(
          action,
          actionsForClip && actionsForClip.knownActions[0]
        );
        this._addInactiveAction(action, clipUuid, rootUuid);
      }
      const bindings = action._propertyBindings;
      for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
        const binding = bindings[i2];
        if (binding.useCount++ === 0) {
          this._lendBinding(binding);
          binding.saveOriginalState();
        }
      }
      this._lendAction(action);
    }
  }
  _deactivateAction(action) {
    if (this._isActiveAction(action)) {
      const bindings = action._propertyBindings;
      for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
        const binding = bindings[i2];
        if (--binding.useCount === 0) {
          binding.restoreOriginalState();
          this._takeBackBinding(binding);
        }
      }
      this._takeBackAction(action);
    }
  }
  // Memory manager
  _initMemoryManager() {
    this._actions = [];
    this._nActiveActions = 0;
    this._actionsByClip = {};
    this._bindings = [];
    this._nActiveBindings = 0;
    this._bindingsByRootAndName = {};
    this._controlInterpolants = [];
    this._nActiveControlInterpolants = 0;
    const scope = this;
    this.stats = {
      actions: {
        get total() {
          return scope._actions.length;
        },
        get inUse() {
          return scope._nActiveActions;
        }
      },
      bindings: {
        get total() {
          return scope._bindings.length;
        },
        get inUse() {
          return scope._nActiveBindings;
        }
      },
      controlInterpolants: {
        get total() {
          return scope._controlInterpolants.length;
        },
        get inUse() {
          return scope._nActiveControlInterpolants;
        }
      }
    };
  }
  // Memory management for AnimationAction objects
  _isActiveAction(action) {
    const index2 = action._cacheIndex;
    return index2 !== null && index2 < this._nActiveActions;
  }
  _addInactiveAction(action, clipUuid, rootUuid) {
    const actions = this._actions, actionsByClip = this._actionsByClip;
    let actionsForClip = actionsByClip[clipUuid];
    if (actionsForClip === void 0) {
      actionsForClip = {
        knownActions: [action],
        actionByRoot: {}
      };
      action._byClipCacheIndex = 0;
      actionsByClip[clipUuid] = actionsForClip;
    } else {
      const knownActions = actionsForClip.knownActions;
      action._byClipCacheIndex = knownActions.length;
      knownActions.push(action);
    }
    action._cacheIndex = actions.length;
    actions.push(action);
    actionsForClip.actionByRoot[rootUuid] = action;
  }
  _removeInactiveAction(action) {
    const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
    lastInactiveAction._cacheIndex = cacheIndex;
    actions[cacheIndex] = lastInactiveAction;
    actions.pop();
    action._cacheIndex = null;
    const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
    lastKnownAction._byClipCacheIndex = byClipCacheIndex;
    knownActionsForClip[byClipCacheIndex] = lastKnownAction;
    knownActionsForClip.pop();
    action._byClipCacheIndex = null;
    const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
    delete actionByRoot[rootUuid];
    if (knownActionsForClip.length === 0) {
      delete actionsByClip[clipUuid];
    }
    this._removeInactiveBindingsForAction(action);
  }
  _removeInactiveBindingsForAction(action) {
    const bindings = action._propertyBindings;
    for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
      const binding = bindings[i2];
      if (--binding.referenceCount === 0) {
        this._removeInactiveBinding(binding);
      }
    }
  }
  _lendAction(action) {
    const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
    action._cacheIndex = lastActiveIndex;
    actions[lastActiveIndex] = action;
    firstInactiveAction._cacheIndex = prevIndex;
    actions[prevIndex] = firstInactiveAction;
  }
  _takeBackAction(action) {
    const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
    action._cacheIndex = firstInactiveIndex;
    actions[firstInactiveIndex] = action;
    lastActiveAction._cacheIndex = prevIndex;
    actions[prevIndex] = lastActiveAction;
  }
  // Memory management for PropertyMixer objects
  _addInactiveBinding(binding, rootUuid, trackName) {
    const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
    let bindingByName = bindingsByRoot[rootUuid];
    if (bindingByName === void 0) {
      bindingByName = {};
      bindingsByRoot[rootUuid] = bindingByName;
    }
    bindingByName[trackName] = binding;
    binding._cacheIndex = bindings.length;
    bindings.push(binding);
  }
  _removeInactiveBinding(binding) {
    const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
    lastInactiveBinding._cacheIndex = cacheIndex;
    bindings[cacheIndex] = lastInactiveBinding;
    bindings.pop();
    delete bindingByName[trackName];
    if (Object.keys(bindingByName).length === 0) {
      delete bindingsByRoot[rootUuid];
    }
  }
  _lendBinding(binding) {
    const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
    binding._cacheIndex = lastActiveIndex;
    bindings[lastActiveIndex] = binding;
    firstInactiveBinding._cacheIndex = prevIndex;
    bindings[prevIndex] = firstInactiveBinding;
  }
  _takeBackBinding(binding) {
    const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
    binding._cacheIndex = firstInactiveIndex;
    bindings[firstInactiveIndex] = binding;
    lastActiveBinding._cacheIndex = prevIndex;
    bindings[prevIndex] = lastActiveBinding;
  }
  // Memory management of Interpolants for weight and time scale
  _lendControlInterpolant() {
    const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
    let interpolant = interpolants[lastActiveIndex];
    if (interpolant === void 0) {
      interpolant = new LinearInterpolant(
        new Float32Array(2),
        new Float32Array(2),
        1,
        _controlInterpolantsResultBuffer
      );
      interpolant.__cacheIndex = lastActiveIndex;
      interpolants[lastActiveIndex] = interpolant;
    }
    return interpolant;
  }
  _takeBackControlInterpolant(interpolant) {
    const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
    interpolant.__cacheIndex = firstInactiveIndex;
    interpolants[firstInactiveIndex] = interpolant;
    lastActiveInterpolant.__cacheIndex = prevIndex;
    interpolants[prevIndex] = lastActiveInterpolant;
  }
  /**
   * Returns an instance of {@link AnimationAction} for the passed clip.
   *
   * If an action fitting the clip and root parameters doesn't yet exist, it
   * will be created by this method. Calling this method several times with the
   * same clip and root parameters always returns the same action.
   *
   * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
   * @param {Object3D} [optionalRoot] - An alternative root object.
   * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
   * @return {?AnimationAction} The animation action.
   */
  clipAction(clip2, optionalRoot, blendMode) {
    const root2 = optionalRoot || this._root, rootUuid = root2.uuid;
    let clipObject = typeof clip2 === "string" ? AnimationClip.findByName(root2, clip2) : clip2;
    const clipUuid = clipObject !== null ? clipObject.uuid : clip2;
    const actionsForClip = this._actionsByClip[clipUuid];
    let prototypeAction = null;
    if (blendMode === void 0) {
      if (clipObject !== null) {
        blendMode = clipObject.blendMode;
      } else {
        blendMode = NormalAnimationBlendMode;
      }
    }
    if (actionsForClip !== void 0) {
      const existingAction = actionsForClip.actionByRoot[rootUuid];
      if (existingAction !== void 0 && existingAction.blendMode === blendMode) {
        return existingAction;
      }
      prototypeAction = actionsForClip.knownActions[0];
      if (clipObject === null)
        clipObject = prototypeAction._clip;
    }
    if (clipObject === null)
      return null;
    const newAction = new AnimationAction(this, clipObject, optionalRoot, blendMode);
    this._bindAction(newAction, prototypeAction);
    this._addInactiveAction(newAction, clipUuid, rootUuid);
    return newAction;
  }
  /**
   * Returns an existing animation action for the passed clip.
   *
   * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
   * @param {Object3D} [optionalRoot] - An alternative root object.
   * @return {?AnimationAction} The animation action. Returns `null` if no action was found.
   */
  existingAction(clip2, optionalRoot) {
    const root2 = optionalRoot || this._root, rootUuid = root2.uuid, clipObject = typeof clip2 === "string" ? AnimationClip.findByName(root2, clip2) : clip2, clipUuid = clipObject ? clipObject.uuid : clip2, actionsForClip = this._actionsByClip[clipUuid];
    if (actionsForClip !== void 0) {
      return actionsForClip.actionByRoot[rootUuid] || null;
    }
    return null;
  }
  /**
   * Deactivates all previously scheduled actions on this mixer.
   *
   * @return {AnimationMixer} A reference to thi animation mixer.
   */
  stopAllAction() {
    const actions = this._actions, nActions = this._nActiveActions;
    for (let i2 = nActions - 1; i2 >= 0; --i2) {
      actions[i2].stop();
    }
    return this;
  }
  /**
   * Advances the global mixer time and updates the animation.
   *
   * This is usually done in the render loop by passing the delta
   * time from {@link Clock} or {@link Timer}.
   *
   * @param {number} deltaTime - The delta time in seconds.
   * @return {AnimationMixer} A reference to thi animation mixer.
   */
  update(deltaTime) {
    deltaTime *= this.timeScale;
    const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
    for (let i2 = 0; i2 !== nActions; ++i2) {
      const action = actions[i2];
      action._update(time, deltaTime, timeDirection, accuIndex);
    }
    const bindings = this._bindings, nBindings = this._nActiveBindings;
    for (let i2 = 0; i2 !== nBindings; ++i2) {
      bindings[i2].apply(accuIndex);
    }
    return this;
  }
  /**
   * Sets the global mixer to a specific time and updates the animation accordingly.
   *
   * This is useful when you need to jump to an exact time in an animation. The
   * input parameter will be scaled by {@link AnimationMixer#timeScale}
   *
   * @param {number} time - The time to set in seconds.
   * @return {AnimationMixer} A reference to thi animation mixer.
   */
  setTime(time) {
    this.time = 0;
    for (let i2 = 0; i2 < this._actions.length; i2++) {
      this._actions[i2].time = 0;
    }
    return this.update(time);
  }
  /**
   * Returns this mixer's root object.
   *
   * @return {Object3D} The mixer's root object.
   */
  getRoot() {
    return this._root;
  }
  /**
   * Deallocates all memory resources for a clip. Before using this method make
   * sure to call {@link AnimationAction#stop} for all related actions.
   *
   * @param {AnimationClip} clip - The clip to uncache.
   */
  uncacheClip(clip2) {
    const actions = this._actions, clipUuid = clip2.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
    if (actionsForClip !== void 0) {
      const actionsToRemove = actionsForClip.knownActions;
      for (let i2 = 0, n2 = actionsToRemove.length; i2 !== n2; ++i2) {
        const action = actionsToRemove[i2];
        this._deactivateAction(action);
        const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
        action._cacheIndex = null;
        action._byClipCacheIndex = null;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        this._removeInactiveBindingsForAction(action);
      }
      delete actionsByClip[clipUuid];
    }
  }
  /**
   * Deallocates all memory resources for a root object. Before using this
   * method make sure to call {@link AnimationAction#stop} for all related
   * actions or alternatively {@link AnimationMixer#stopAllAction} when the
   * mixer operates on a single root.
   *
   * @param {Object3D} root - The root object to uncache.
   */
  uncacheRoot(root2) {
    const rootUuid = root2.uuid, actionsByClip = this._actionsByClip;
    for (const clipUuid in actionsByClip) {
      const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
      if (action !== void 0) {
        this._deactivateAction(action);
        this._removeInactiveAction(action);
      }
    }
    const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
    if (bindingByName !== void 0) {
      for (const trackName in bindingByName) {
        const binding = bindingByName[trackName];
        binding.restoreOriginalState();
        this._removeInactiveBinding(binding);
      }
    }
  }
  /**
   * Deallocates all memory resources for an action. The action is identified by the
   * given clip and an optional root object. Before using this method make
   * sure to call {@link AnimationAction#stop} to deactivate the action.
   *
   * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
   * @param {Object3D} [optionalRoot] - An alternative root object.
   */
  uncacheAction(clip2, optionalRoot) {
    const action = this.existingAction(clip2, optionalRoot);
    if (action !== null) {
      this._deactivateAction(action);
      this._removeInactiveAction(action);
    }
  }
}
const _matrix$1 = /* @__PURE__ */ new Matrix4();
class Raycaster {
  /**
   * Constructs a new raycaster.
   *
   * @param {Vector3} origin - The origin vector where the ray casts from.
   * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
   * @param {number} [near=0] - All results returned are further away than near. Near can't be negative.
   * @param {number} [far=Infinity] - All results returned are closer than far. Far can't be lower than near.
   */
  constructor(origin, direction, near = 0, far = Infinity) {
    this.ray = new Ray(origin, direction);
    this.near = near;
    this.far = far;
    this.camera = null;
    this.layers = new Layers();
    this.params = {
      Mesh: {},
      Line: { threshold: 1 },
      LOD: {},
      Points: { threshold: 1 },
      Sprite: {}
    };
  }
  /**
   * Updates the ray with a new origin and direction by copying the values from the arguments.
   *
   * @param {Vector3} origin - The origin vector where the ray casts from.
   * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
   */
  set(origin, direction) {
    this.ray.set(origin, direction);
  }
  /**
   * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
   *
   * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
   * X and Y components should be between `-1` and `1`.
   * @param {Camera} camera - The camera from which the ray should originate.
   */
  setFromCamera(coords, camera2) {
    if (camera2.isPerspectiveCamera) {
      this.ray.origin.setFromMatrixPosition(camera2.matrixWorld);
      this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera2).sub(this.ray.origin).normalize();
      this.camera = camera2;
    } else if (camera2.isOrthographicCamera) {
      this.ray.origin.set(coords.x, coords.y, (camera2.near + camera2.far) / (camera2.near - camera2.far)).unproject(camera2);
      this.ray.direction.set(0, 0, -1).transformDirection(camera2.matrixWorld);
      this.camera = camera2;
    } else {
      console.error("THREE.Raycaster: Unsupported camera type: " + camera2.type);
    }
  }
  /**
   * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
   *
   * @param {WebXRController} controller - The controller to copy the position and direction from.
   * @return {Raycaster} A reference to this raycaster.
   */
  setFromXRController(controller) {
    _matrix$1.identity().extractRotation(controller.matrixWorld);
    this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
    this.ray.direction.set(0, 0, -1).applyMatrix4(_matrix$1);
    return this;
  }
  /**
   * The intersection point of a raycaster intersection test.
   * @typedef {Object} Raycaster~Intersection
   * @property {number} distance - The distance from the ray's origin to the intersection point.
   * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
   * intersection to the nearest point on the ray. For other objects it will be `undefined`.
   * @property {Vector3} point - The intersection point, in world coordinates.
   * @property {Object} face - The face that has been intersected.
   * @property {number} faceIndex - The face index.
   * @property {Object3D} object - The 3D object that has been intersected.
   * @property {Vector2} uv - U,V coordinates at point of intersection.
   * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
   * @property {Vector3} uv1 - Interpolated normal vector at point of intersection.
   * @property {number} instanceId - The index number of the instance where the ray
   * intersects the {@link InstancedMesh}.
   */
  /**
   * Checks all intersection between the ray and the object with or without the
   * descendants. Intersections are returned sorted by distance, closest first.
   *
   * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
   * evaluating whether the ray intersects the object or not. This allows meshes to respond
   * differently to ray casting than lines or points.
   *
   * Note that for meshes, faces must be pointed towards the origin of the ray in order
   * to be detected; intersections of the ray passing through the back of a face will not
   * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
   * to `THREE.DoubleSide`.
   *
   * @param {Object3D} object - The 3D object to check for intersection with the ray.
   * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
   * Otherwise it only checks intersection with the object.
   * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
   * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
   */
  intersectObject(object, recursive = true, intersects = []) {
    intersect(object, this, intersects, recursive);
    intersects.sort(ascSort);
    return intersects;
  }
  /**
   * Checks all intersection between the ray and the objects with or without
   * the descendants. Intersections are returned sorted by distance, closest first.
   *
   * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
   * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
   * Otherwise it only checks intersection with the object.
   * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
   * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
   */
  intersectObjects(objects, recursive = true, intersects = []) {
    for (let i2 = 0, l = objects.length; i2 < l; i2++) {
      intersect(objects[i2], this, intersects, recursive);
    }
    intersects.sort(ascSort);
    return intersects;
  }
}
function ascSort(a, b) {
  return a.distance - b.distance;
}
function intersect(object, raycaster, intersects, recursive) {
  let propagate = true;
  if (object.layers.test(raycaster.layers)) {
    const result2 = object.raycast(raycaster, intersects);
    if (result2 === false)
      propagate = false;
  }
  if (propagate === true && recursive === true) {
    const children = object.children;
    for (let i2 = 0, l = children.length; i2 < l; i2++) {
      intersect(children[i2], raycaster, intersects, true);
    }
  }
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") {
  __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
    revision: REVISION
  } }));
}
if (typeof window !== "undefined") {
  if (window.__THREE__) {
    console.warn("WARNING: Multiple instances of Three.js being imported.");
  } else {
    window.__THREE__ = REVISION;
  }
}
const toHex = (color2) => {
  const rateToHex = (rate) => {
    return ("00" + Math.round(255 * rate).toString(16)).slice(-2);
  };
  return `#${rateToHex(color2.r)}${rateToHex(color2.g)}${rateToHex(color2.b)}`;
};
var mdiAbTesting = "M4 2A2 2 0 0 0 2 4V12H4V8H6V12H8V4A2 2 0 0 0 6 2H4M4 4H6V6H4M22 15.5V14A2 2 0 0 0 20 12H16V22H20A2 2 0 0 0 22 20V18.5A1.54 1.54 0 0 0 20.5 17A1.54 1.54 0 0 0 22 15.5M20 20H18V18H20V20M20 16H18V14H20M5.79 21.61L4.21 20.39L18.21 2.39L19.79 3.61Z";
var mdiAbacus = "M5 5H7V11H5V5M10 5H8V11H10V5M5 19H7V13H5V19M10 13H8V19H10V17H15V15H10V13M2 21H4V3H2V21M20 3V7H13V5H11V11H13V9H20V15H18V13H16V19H18V17H20V21H22V3H20Z";
var mdiAbjadArabic = "M12 4C10.08 4 8.5 5.58 8.5 7.5C8.5 8.43 8.88 9.28 9.5 9.91C7.97 10.91 7 12.62 7 14.5C7 17.53 9.47 20 12.5 20C14.26 20 16 19.54 17.5 18.66L16.5 16.93C15.28 17.63 13.9 18 12.5 18C10.56 18 9 16.45 9 14.5C9 12.91 10.06 11.53 11.59 11.12L16.8 9.72L16.28 7.79L11.83 9C11.08 8.9 10.5 8.28 10.5 7.5C10.5 6.66 11.16 6 12 6C12.26 6 12.5 6.07 12.75 6.2L13.75 4.47C13.22 4.16 12.61 4 12 4Z";
var mdiAbjadHebrew = "M3.9 4L9 10.03C7.58 10.17 6.36 11.18 6 12.59L4 20H6.07L7.92 13.11C8.09 12.46 8.69 12 9.36 12H10.69L17.47 20H20.1L15 13.97C16.42 13.83 17.64 12.82 18 11.41L20 4H17.93L16.08 10.89C15.91 11.54 15.31 12 14.64 12H13.31L6.53 4Z";
var mdiAbugidaDevanagari = "M8 3V5H11C12.32 5 13.41 5.83 13.82 7H6V9H14V10H12C9.25 10 7 12.25 7 15C7 17.75 9.25 20 12 20C12.77 20 13.45 19.73 14 19.3V21H16V17H14C13.55 17.62 12.83 18 12 18C10.33 18 9 16.67 9 15C9 13.33 10.33 12 12 12H16V9H18V7H15.9C15.43 4.72 13.41 3 11 3H8Z";
var mdiAbugidaThai = "M9 20C9 17.44 10.87 12.42 13.86 7.25C14.29 6.5 15.08 6 16 6C17.12 6 18 6.88 18 8V20H20V8C20 5.8 18.2 4 16 4C14.34 4 12.9 4.92 12.13 6.25C10.56 8.96 9.61 11.15 9 13.03V6.5C9 5.13 7.87 4 6.5 4C5.13 4 4 5.13 4 6.5C4 7.87 5.13 9 6.5 9C6.67 9 6.84 9 7 8.95V20M6.5 6C6.79 6 7 6.21 7 6.5C7 6.79 6.79 7 6.5 7C6.21 7 6 6.79 6 6.5C6 6.21 6.21 6 6.5 6Z";
var mdiAccessPoint = "M4.93,4.93C3.12,6.74 2,9.24 2,12C2,14.76 3.12,17.26 4.93,19.07L6.34,17.66C4.89,16.22 4,14.22 4,12C4,9.79 4.89,7.78 6.34,6.34L4.93,4.93M19.07,4.93L17.66,6.34C19.11,7.78 20,9.79 20,12C20,14.22 19.11,16.22 17.66,17.66L19.07,19.07C20.88,17.26 22,14.76 22,12C22,9.24 20.88,6.74 19.07,4.93M7.76,7.76C6.67,8.85 6,10.35 6,12C6,13.65 6.67,15.15 7.76,16.24L9.17,14.83C8.45,14.11 8,13.11 8,12C8,10.89 8.45,9.89 9.17,9.17L7.76,7.76M16.24,7.76L14.83,9.17C15.55,9.89 16,10.89 16,12C16,13.11 15.55,14.11 14.83,14.83L16.24,16.24C17.33,15.15 18,13.65 18,12C18,10.35 17.33,8.85 16.24,7.76M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z";
var mdiAccessPointCheck = "M20.59 14.84L21.75 16.25L17 21L14.25 18L15.41 16.84L17 18.43L20.59 14.84M19.07 4.93L17.66 6.34C19.11 7.78 20 9.79 20 12V12.34C20.68 12.59 21.33 12.96 21.88 13.43C21.95 12.96 22 12.5 22 12C22 9.24 20.88 6.74 19.07 4.93M15.96 12.36C16.6 12.13 17.28 12 18 12C18 10.35 17.33 8.85 16.24 7.76L14.83 9.17C15.55 9.89 16 10.89 16 12C16 12.12 15.97 12.24 15.96 12.36M12 10C10.9 10 10 10.9 10 12S10.9 14 12 14 14 13.1 14 12 13.1 10 12 10M6.34 6.34L4.93 4.93C3.12 6.74 2 9.24 2 12S3.12 17.26 4.93 19.07L6.34 17.66C4.89 16.22 4 14.22 4 12C4 9.79 4.89 7.78 6.34 6.34M7.76 7.76C6.67 8.85 6 10.35 6 12S6.67 15.15 7.76 16.24L9.17 14.83C8.45 14.11 8 13.11 8 12S8.45 9.89 9.17 9.17L7.76 7.76Z";
var mdiAccessPointMinus = "M16 12C16 10.89 15.55 9.89 14.83 9.17L16.24 7.76C17.33 8.85 18 10.35 18 12C17.28 12 16.6 12.13 15.96 12.36C15.97 12.24 16 12.12 16 12M20 12.34C20.68 12.59 21.33 12.96 21.88 13.43C21.95 12.96 22 12.5 22 12C22 9.24 20.88 6.74 19.07 4.93L17.66 6.34C19.11 7.78 20 9.79 20 12C20 12.12 20 12.23 20 12.34M12 10C10.9 10 10 10.9 10 12S10.9 14 12 14 14 13.1 14 12 13.1 10 12 10M7.76 7.76C6.67 8.85 6 10.35 6 12S6.67 15.15 7.76 16.24L9.17 14.83C8.45 14.11 8 13.11 8 12S8.45 9.89 9.17 9.17L7.76 7.76M6.34 6.34L4.93 4.93C3.12 6.74 2 9.24 2 12S3.12 17.26 4.93 19.07L6.34 17.66C4.89 16.22 4 14.22 4 12C4 9.79 4.89 7.78 6.34 6.34M14 19H22V17H14V19Z";
var mdiAccessPointNetwork = "M4.93,3.93C3.12,5.74 2,8.24 2,11C2,13.76 3.12,16.26 4.93,18.07L6.34,16.66C4.89,15.22 4,13.22 4,11C4,8.79 4.89,6.78 6.34,5.34L4.93,3.93M19.07,3.93L17.66,5.34C19.11,6.78 20,8.79 20,11C20,13.22 19.11,15.22 17.66,16.66L19.07,18.07C20.88,16.26 22,13.76 22,11C22,8.24 20.88,5.74 19.07,3.93M7.76,6.76C6.67,7.85 6,9.35 6,11C6,12.65 6.67,14.15 7.76,15.24L9.17,13.83C8.45,13.11 8,12.11 8,11C8,9.89 8.45,8.89 9.17,8.17L7.76,6.76M16.24,6.76L14.83,8.17C15.55,8.89 16,9.89 16,11C16,12.11 15.55,13.11 14.83,13.83L16.24,15.24C17.33,14.15 18,12.65 18,11C18,9.35 17.33,7.85 16.24,6.76M12,9A2,2 0 0,0 10,11A2,2 0 0,0 12,13A2,2 0 0,0 14,11A2,2 0 0,0 12,9M11,15V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15A1,1 0 0,0 14,19H13V15H11Z";
var mdiAccessPointNetworkOff = "M14.83,13.83C15.55,13.11 16,12.11 16,11C16,9.89 15.55,8.89 14.83,8.17L16.24,6.76C17.33,7.85 18,9.35 18,11C18,12.65 17.33,14.15 16.24,15.24L14.83,13.83M14,11A2,2 0 0,0 12,9C11.4,9 10.87,9.27 10.5,9.68L13.32,12.5C13.73,12.13 14,11.6 14,11M17.66,16.66L19.07,18.07C20.88,16.26 22,13.76 22,11C22,8.24 20.88,5.74 19.07,3.93L17.66,5.34C19.11,6.78 20,8.79 20,11C20,13.22 19.11,15.22 17.66,16.66M22,21.18V20H20.82L22,21.18M20.27,22L21,22.73L19.73,24L17.73,22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V15.27L8.34,12.61C8.54,13.07 8.82,13.5 9.17,13.83L7.76,15.24C6.67,14.15 6,12.65 6,11C6,10.77 6,10.54 6.04,10.31L4.37,8.64C4.14,9.39 4,10.18 4,11C4,13.22 4.89,15.22 6.34,16.66L4.93,18.07C3.12,16.26 2,13.76 2,11C2,9.61 2.29,8.28 2.81,7.08L1,5.27L2.28,4L3.7,5.42L5.15,6.87L6.63,8.35V8.35L8.17,9.9L10.28,12L11,12.71L18.27,20H18.28L20.28,22H20.27M15.73,20L13,17.27V19H14A1,1 0 0,1 15,20H15.73Z";
var mdiAccessPointOff = "M20.84 22.73L12.1 14C12.06 14 12.03 14 12 14C10.9 14 10 13.11 10 12C10 11.97 10 11.94 10 11.9L8.4 10.29C8.15 10.81 8 11.38 8 12C8 13.11 8.45 14.11 9.17 14.83L7.76 16.24C6.67 15.15 6 13.65 6 12C6 10.83 6.34 9.74 6.93 8.82L5.5 7.37C4.55 8.67 4 10.27 4 12C4 14.22 4.89 16.22 6.34 17.66L4.93 19.07C3.12 17.26 2 14.76 2 12C2 9.72 2.77 7.63 4.06 5.95L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M15.93 12.73L17.53 14.33C17.83 13.61 18 12.83 18 12C18 10.35 17.33 8.85 16.24 7.76L14.83 9.17C15.55 9.89 16 10.89 16 12C16 12.25 15.97 12.5 15.93 12.73M19.03 15.83L20.5 17.28C21.44 15.75 22 13.94 22 12C22 9.24 20.88 6.74 19.07 4.93L17.66 6.34C19.11 7.78 20 9.79 20 12C20 13.39 19.65 14.7 19.03 15.83Z";
var mdiAccessPointPlus = "M16 12C16 10.89 15.55 9.89 14.83 9.17L16.24 7.76C17.33 8.85 18 10.35 18 12C17.28 12 16.6 12.13 15.96 12.36C15.97 12.24 16 12.12 16 12M20 12.34C20.68 12.59 21.33 12.96 21.88 13.43C21.95 12.96 22 12.5 22 12C22 9.24 20.88 6.74 19.07 4.93L17.66 6.34C19.11 7.78 20 9.79 20 12C20 12.12 20 12.23 20 12.34M12 10C10.9 10 10 10.9 10 12S10.9 14 12 14 14 13.1 14 12 13.1 10 12 10M6.34 6.34L4.93 4.93C3.12 6.74 2 9.24 2 12S3.12 17.26 4.93 19.07L6.34 17.66C4.89 16.22 4 14.22 4 12C4 9.79 4.89 7.78 6.34 6.34M7.76 7.76C6.67 8.85 6 10.35 6 12S6.67 15.15 7.76 16.24L9.17 14.83C8.45 14.11 8 13.11 8 12S8.45 9.89 9.17 9.17L7.76 7.76M19 14H17V17H14V19H17V22H19V19H22V17H19V14Z";
var mdiAccessPointRemove = "M16 12C16 10.89 15.55 9.89 14.83 9.17L16.24 7.76C17.33 8.85 18 10.35 18 12C17.28 12 16.6 12.13 15.96 12.36C15.97 12.24 16 12.12 16 12M6.34 6.34L4.93 4.93C3.12 6.74 2 9.24 2 12S3.12 17.26 4.93 19.07L6.34 17.66C4.89 16.22 4 14.22 4 12C4 9.79 4.89 7.78 6.34 6.34M19.07 4.93L17.66 6.34C19.11 7.78 20 9.79 20 12C20 12.12 20 12.23 20 12.34C20.68 12.59 21.33 12.96 21.88 13.43C21.95 12.96 22 12.5 22 12C22 9.24 20.88 6.74 19.07 4.93M12 10C10.9 10 10 10.9 10 12S10.9 14 12 14 14 13.1 14 12 13.1 10 12 10M7.76 7.76C6.67 8.85 6 10.35 6 12S6.67 15.15 7.76 16.24L9.17 14.83C8.45 14.11 8 13.11 8 12S8.45 9.89 9.17 9.17L7.76 7.76M20.12 14.46L18 16.59L15.88 14.47L14.47 15.88L16.59 18L14.47 20.12L15.88 21.53L18 19.41L20.12 21.53L21.53 20.12L19.41 18L21.53 15.88L20.12 14.46Z";
var mdiAccount = "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z";
var mdiAccountAlert = "M10 4A4 4 0 0 1 14 8A4 4 0 0 1 10 12A4 4 0 0 1 6 8A4 4 0 0 1 10 4M10 14C14.42 14 18 15.79 18 18V20H2V18C2 15.79 5.58 14 10 14M20 12V7H22V13H20M20 17V15H22V17H20Z";
var mdiAccountAlertOutline = "M20 12V7H22V13H20M20 17H22V15H20M10 13C12.67 13 18 14.34 18 17V20H2V17C2 14.34 7.33 13 10 13M10 4A4 4 0 0 1 14 8A4 4 0 0 1 10 12A4 4 0 0 1 6 8A4 4 0 0 1 10 4M10 14.9C7.03 14.9 3.9 16.36 3.9 17V18.1H16.1V17C16.1 16.36 12.97 14.9 10 14.9M10 5.9A2.1 2.1 0 0 0 7.9 8A2.1 2.1 0 0 0 10 10.1A2.1 2.1 0 0 0 12.1 8A2.1 2.1 0 0 0 10 5.9Z";
var mdiAccountArrowDown = "M19 18V14H17V18H15L18 21L21 18H19M11 4C8.8 4 7 5.8 7 8S8.8 12 11 12 15 10.2 15 8 13.2 4 11 4M11 14C6.6 14 3 15.8 3 18V20H12.5C12.2 19.2 12 18.4 12 17.5C12 16.3 12.3 15.2 12.9 14.1C12.3 14.1 11.7 14 11 14";
var mdiAccountArrowDownOutline = "M19 18V14H17V18H15L18 21L21 18H19M11 4C8.8 4 7 5.8 7 8S8.8 12 11 12 15 10.2 15 8 13.2 4 11 4M11 6C12.1 6 13 6.9 13 8S12.1 10 11 10 9 9.1 9 8 9.9 6 11 6M11 13C8.3 13 3 14.3 3 17V20H12.5C12.2 19.4 12.1 18.8 12 18.1H4.9V17C4.9 16.4 8 14.9 11 14.9C11.5 14.9 12 15 12.5 15C12.8 14.4 13.1 13.8 13.6 13.3C12.6 13.1 11.7 13 11 13";
var mdiAccountArrowLeft = "M17 18H21V16H17V14L14 17L17 20V18M11 4C8.8 4 7 5.8 7 8S8.8 12 11 12 15 10.2 15 8 13.2 4 11 4M11 14C6.6 14 3 15.8 3 18V20H12.5C12.2 19.2 12 18.4 12 17.5C12 16.3 12.3 15.2 12.9 14.1C12.3 14.1 11.7 14 11 14";
var mdiAccountArrowLeftOutline = "M17 18H21V16H17V14L14 17L17 20V18M11 4C8.8 4 7 5.8 7 8S8.8 12 11 12 15 10.2 15 8 13.2 4 11 4M11 6C12.1 6 13 6.9 13 8S12.1 10 11 10 9 9.1 9 8 9.9 6 11 6M11 13C8.3 13 3 14.3 3 17V20H12.5C12.2 19.4 12.1 18.8 12 18.1H4.9V17C4.9 16.4 8 14.9 11 14.9C11.5 14.9 12 15 12.5 15C12.8 14.4 13.1 13.8 13.6 13.3C12.6 13.1 11.7 13 11 13";
var mdiAccountArrowRight = "M18 16H14V18H18V20L21 17L18 14V16M11 4C8.8 4 7 5.8 7 8S8.8 12 11 12 15 10.2 15 8 13.2 4 11 4M11 14C6.6 14 3 15.8 3 18V20H12.5C12.2 19.2 12 18.4 12 17.5C12 16.3 12.3 15.2 12.9 14.1C12.3 14.1 11.7 14 11 14";
var mdiAccountArrowRightOutline = "M18 16H14V18H18V20L21 17L18 14V16M11 4C8.8 4 7 5.8 7 8S8.8 12 11 12 15 10.2 15 8 13.2 4 11 4M11 6C12.1 6 13 6.9 13 8S12.1 10 11 10 9 9.1 9 8 9.9 6 11 6M11 13C8.3 13 3 14.3 3 17V20H12.5C12.2 19.4 12.1 18.8 12 18.1H4.9V17C4.9 16.4 8 14.9 11 14.9C11.5 14.9 12 15 12.5 15C12.8 14.4 13.1 13.8 13.6 13.3C12.6 13.1 11.7 13 11 13";
var mdiAccountArrowUp = "M17 17V21H19V17H21L18 14L15 17H17M11 4C8.8 4 7 5.8 7 8S8.8 12 11 12 15 10.2 15 8 13.2 4 11 4M11 14C6.6 14 3 15.8 3 18V20H12.5C12.2 19.2 12 18.4 12 17.5C12 16.3 12.3 15.2 12.9 14.1C12.3 14.1 11.7 14 11 14";
var mdiAccountArrowUpOutline = "M17 17V21H19V17H21L18 14L15 17H17M11 4C8.8 4 7 5.8 7 8S8.8 12 11 12 15 10.2 15 8 13.2 4 11 4M11 6C12.1 6 13 6.9 13 8S12.1 10 11 10 9 9.1 9 8 9.9 6 11 6M11 13C8.3 13 3 14.3 3 17V20H12.5C12.2 19.4 12.1 18.8 12 18.1H4.9V17C4.9 16.4 8 14.9 11 14.9C11.5 14.9 12 15 12.5 15C12.8 14.4 13.1 13.8 13.6 13.3C12.6 13.1 11.7 13 11 13";
var mdiAccountBadge = "M14 19.5C14 17.5 15.1 15.7 16.7 14.8C15.4 14.3 13.8 14 12 14C7.6 14 4 15.8 4 18V20H14V19.5M19.5 16C17.6 16 16 17.6 16 19.5S17.6 23 19.5 23 23 21.4 23 19.5 21.4 16 19.5 16M16 8C16 10.2 14.2 12 12 12S8 10.2 8 8 9.8 4 12 4 16 5.8 16 8Z";
var mdiAccountBadgeOutline = "M14 20H4V17C4 14.3 9.3 13 12 13C13.5 13 15.9 13.4 17.7 14.3C16.9 14.6 16.3 15 15.7 15.5C14.6 15.1 13.3 14.9 12 14.9C9 14.9 5.9 16.4 5.9 17V18.1H14.2C14.1 18.5 14 19 14 19.5V20M23 19.5C23 21.4 21.4 23 19.5 23S16 21.4 16 19.5 17.6 16 19.5 16 23 17.6 23 19.5M12 6C13.1 6 14 6.9 14 8S13.1 10 12 10 10 9.1 10 8 10.9 6 12 6M12 4C9.8 4 8 5.8 8 8S9.8 12 12 12 16 10.2 16 8 14.2 4 12 4Z";
var mdiAccountBox = "M6,17C6,15 10,13.9 12,13.9C14,13.9 18,15 18,17V18H6M15,9A3,3 0 0,1 12,12A3,3 0 0,1 9,9A3,3 0 0,1 12,6A3,3 0 0,1 15,9M3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5C3.89,3 3,3.9 3,5Z";
var mdiAccountBoxEditOutline = "M21.7 13.58L20.42 12.3C20.21 12.09 19.86 12.09 19.65 12.3L18.65 13.3L20.7 15.35L21.7 14.35C21.91 14.14 21.91 13.79 21.7 13.58M12 22H14.06L20.11 15.93L18.06 13.88L12 19.94V22M10 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 4.47 3.21 3.96 3.59 3.59C3.96 3.21 4.47 3 5 3H19C20.1 3 21 3.89 21 5V10.33C20.36 10.07 19.63 10.08 19 10.36V5H5V19H10.11L10 19.11V21M14.62 14.5L12.11 17H7.5V16.25C7.5 14.75 10.5 14 12 14C12.7 14 13.73 14.16 14.62 14.5M13.59 11.59C13.17 12 12.6 12.25 12 12.25C11.4 12.25 10.83 12 10.41 11.59C10 11.17 9.75 10.6 9.75 10C9.75 9.4 10 8.83 10.41 8.41C10.83 8 11.4 7.75 12 7.75C12.6 7.75 13.17 8 13.59 8.41C14 8.83 14.25 9.4 14.25 10C14.25 10.6 14 11.17 13.59 11.59Z";
var mdiAccountBoxMinusOutline = "M13.4 14.15C12.73 14.95 12.26 15.93 12.08 17H7.5V16.25C7.5 14.75 10.5 14 12 14C12.39 14 12.88 14.05 13.4 14.15M19 5V12.08C19.72 12.2 20.39 12.45 21 12.8V5C21 3.89 20.1 3 19 3H5C4.47 3 3.96 3.21 3.59 3.59C3.21 3.96 3 4.47 3 5V19C3 19.53 3.21 20.04 3.59 20.41C3.96 20.79 4.47 21 5 21H12.8C12.45 20.39 12.2 19.72 12.08 19H5V5H19M12 12.25C12.6 12.25 13.17 12 13.59 11.59C14 11.17 14.25 10.6 14.25 10C14.25 9.4 14 8.83 13.59 8.41C13.17 8 12.6 7.75 12 7.75C11.4 7.75 10.83 8 10.41 8.41C10 8.83 9.75 9.4 9.75 10C9.75 10.6 10 11.17 10.41 11.59C10.83 12 11.4 12.25 12 12.25M22 17V19H14V17H22Z";
var mdiAccountBoxMultiple = "M4,6H2V20A2,2 0 0,0 4,22H18V20H4V6M20,2A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H8A2,2 0 0,1 6,16V4A2,2 0 0,1 8,2H20M17,7A3,3 0 0,0 14,4A3,3 0 0,0 11,7A3,3 0 0,0 14,10A3,3 0 0,0 17,7M8,15V16H20V15C20,13 16,11.9 14,11.9C12,11.9 8,13 8,15Z";
var mdiAccountBoxMultipleOutline = "M4 6H2V20C2 21.11 2.9 22 4 22H18V20H4V6M18.5 14.25C18.5 12.75 15.5 12 14 12S9.5 12.75 9.5 14.25V15H18.5M14 10.25C15.24 10.25 16.25 9.24 16.25 8S15.24 5.75 14 5.75 11.75 6.76 11.75 8 12.76 10.25 14 10.25M20 2H8C6.9 2 6 2.9 6 4V16C6 17.11 6.9 18 8 18H20C21.11 18 22 17.11 22 16V4C22 2.89 21.1 2 20 2M20 16H8V4H20V16Z";
var mdiAccountBoxOutline = "M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M16.5,16.25C16.5,14.75 13.5,14 12,14C10.5,14 7.5,14.75 7.5,16.25V17H16.5M12,12.25A2.25,2.25 0 0,0 14.25,10A2.25,2.25 0 0,0 12,7.75A2.25,2.25 0 0,0 9.75,10A2.25,2.25 0 0,0 12,12.25Z";
var mdiAccountBoxPlusOutline = "M13.4 14.15C12.73 14.95 12.26 15.93 12.08 17H7.5V16.25C7.5 14.75 10.5 14 12 14C12.39 14 12.88 14.05 13.4 14.15M19 5V12.08C19.72 12.2 20.39 12.45 21 12.8V5C21 3.89 20.1 3 19 3H5C4.47 3 3.96 3.21 3.59 3.59C3.21 3.96 3 4.47 3 5V19C3 19.53 3.21 20.04 3.59 20.41C3.96 20.79 4.47 21 5 21H12.8C12.45 20.39 12.2 19.72 12.08 19H5V5H19M12 12.25C12.6 12.25 13.17 12 13.59 11.59C14 11.17 14.25 10.6 14.25 10C14.25 9.4 14 8.83 13.59 8.41C13.17 8 12.6 7.75 12 7.75C11.4 7.75 10.83 8 10.41 8.41C10 8.83 9.75 9.4 9.75 10C9.75 10.6 10 11.17 10.41 11.59C10.83 12 11.4 12.25 12 12.25M17 14H19V17H22V19H19V22H17V19H14V17H17V14Z";
var mdiAccountCancel = "M10 4A4 4 0 0 0 6 8A4 4 0 0 0 10 12A4 4 0 0 0 14 8A4 4 0 0 0 10 4M17.5 13C15 13 13 15 13 17.5C13 20 15 22 17.5 22C20 22 22 20 22 17.5C22 15 20 13 17.5 13M10 14C5.58 14 2 15.79 2 18V20H11.5A6.5 6.5 0 0 1 11 17.5A6.5 6.5 0 0 1 11.95 14.14C11.32 14.06 10.68 14 10 14M17.5 14.5C19.16 14.5 20.5 15.84 20.5 17.5C20.5 18.06 20.35 18.58 20.08 19L16 14.92C16.42 14.65 16.94 14.5 17.5 14.5M14.92 16L19 20.08C18.58 20.35 18.06 20.5 17.5 20.5C15.84 20.5 14.5 19.16 14.5 17.5C14.5 16.94 14.65 16.42 14.92 16Z";
var mdiAccountCancelOutline = "M10 4A4 4 0 0 0 6 8A4 4 0 0 0 10 12A4 4 0 0 0 14 8A4 4 0 0 0 10 4M10 6A2 2 0 0 1 12 8A2 2 0 0 1 10 10A2 2 0 0 1 8 8A2 2 0 0 1 10 6M10 13C7.33 13 2 14.33 2 17V20H11.5A6.5 6.5 0 0 1 11.03 18.1H3.9V17C3.9 16.36 7.03 14.9 10 14.9C10.5 14.9 11 14.95 11.5 15.03A6.5 6.5 0 0 1 12.55 13.29C11.61 13.1 10.71 13 10 13M17.5 13C15 13 13 15 13 17.5C13 20 15 22 17.5 22C20 22 22 20 22 17.5C22 15 20 13 17.5 13M17.5 14.5C19.16 14.5 20.5 15.84 20.5 17.5C20.5 18.06 20.35 18.58 20.08 19L16 14.92C16.42 14.65 16.94 14.5 17.5 14.5M14.92 16L19 20.08C18.58 20.35 18.06 20.5 17.5 20.5C15.84 20.5 14.5 19.16 14.5 17.5C14.5 16.94 14.65 16.42 14.92 16Z";
var mdiAccountCard = "M7 12C9.2 12 11 10.2 11 8S9.2 4 7 4 3 5.8 3 8 4.8 12 7 12M11 20V14.7C9.9 14.3 8.5 14 7 14C3.1 14 0 15.8 0 18V20H11M15 4C13.9 4 13 4.9 13 6V18C13 19.1 13.9 20 15 20H22C23.1 20 24 19.1 24 18V6C24 4.9 23.1 4 22 4H15Z";
var mdiAccountCardOutline = "M7 4C4.8 4 3 5.8 3 8S4.8 12 7 12 11 10.2 11 8 9.2 4 7 4M7 10C5.9 10 5 9.1 5 8S5.9 6 7 6 9 6.9 9 8 8.1 10 7 10M0 18C0 15.8 3.1 14 7 14C8.5 14 9.9 14.3 11 14.7V17C10.2 16.5 8.8 16 7 16C3.8 16 2 17.4 2 18H11V20H0V18M22 4H15C13.9 4 13 4.9 13 6V18C13 19.1 13.9 20 15 20H22C23.1 20 24 19.1 24 18V6C24 4.9 23.1 4 22 4M22 18H15V6H22V18Z";
var mdiAccountCash = "M11 8C11 10.21 9.21 12 7 12C4.79 12 3 10.21 3 8C3 5.79 4.79 4 7 4C9.21 4 11 5.79 11 8M11 14.72V20H0V18C0 15.79 3.13 14 7 14C8.5 14 9.87 14.27 11 14.72M24 20H13V3H24V20M16 11.5C16 10.12 17.12 9 18.5 9C19.88 9 21 10.12 21 11.5C21 12.88 19.88 14 18.5 14C17.12 14 16 12.88 16 11.5M22 7C20.9 7 20 6.11 20 5H17C17 6.11 16.11 7 15 7V16C16.11 16 17 16.9 17 18H20C20 16.9 20.9 16 22 16V7Z";
var mdiAccountCashOutline = "M16 11.5C16 10.12 17.12 9 18.5 9S21 10.12 21 11.5 19.88 14 18.5 14 16 12.88 16 11.5M13 3V20H24V3H13M22 16C20.9 16 20 16.9 20 18H17C17 16.9 16.11 16 15 16V7C16.11 7 17 6.11 17 5H20C20 6.11 20.9 7 22 7V16M7 6C8.1 6 9 6.9 9 8S8.1 10 7 10 5 9.1 5 8 5.9 6 7 6M7 4C4.79 4 3 5.79 3 8S4.79 12 7 12 11 10.21 11 8 9.21 4 7 4M7 14C3.13 14 0 15.79 0 18V20H11V18H2C2 17.42 3.75 16 7 16C8.83 16 10.17 16.45 11 16.95V14.72C9.87 14.27 8.5 14 7 14Z";
var mdiAccountCheck = "M21.1,12.5L22.5,13.91L15.97,20.5L12.5,17L13.9,15.59L15.97,17.67L21.1,12.5M10,17L13,20H3V18C3,15.79 6.58,14 11,14L12.89,14.11L10,17M11,4A4,4 0 0,1 15,8A4,4 0 0,1 11,12A4,4 0 0,1 7,8A4,4 0 0,1 11,4Z";
var mdiAccountCheckOutline = "M21.1,12.5L22.5,13.91L15.97,20.5L12.5,17L13.9,15.59L15.97,17.67L21.1,12.5M11,4A4,4 0 0,1 15,8A4,4 0 0,1 11,12A4,4 0 0,1 7,8A4,4 0 0,1 11,4M11,6A2,2 0 0,0 9,8A2,2 0 0,0 11,10A2,2 0 0,0 13,8A2,2 0 0,0 11,6M11,13C11.68,13 12.5,13.09 13.41,13.26L11.74,14.93L11,14.9C8.03,14.9 4.9,16.36 4.9,17V18.1H11.1L13,20H3V17C3,14.34 8.33,13 11,13Z";
var mdiAccountChild = "M12,2A3,3 0 0,1 15,5A3,3 0 0,1 12,8A3,3 0 0,1 9,5A3,3 0 0,1 12,2M12,9C13.63,9 15.12,9.35 16.5,10.05C17.84,10.76 18.5,11.61 18.5,12.61V18.38C18.5,19.5 17.64,20.44 15.89,21.19V19C15.89,18.05 15.03,17.38 13.31,16.97C12.75,16.84 12.31,16.78 12,16.78C11.13,16.78 10.3,16.95 9.54,17.3C8.77,17.64 8.31,18.08 8.16,18.61C9.5,19.14 10.78,19.41 12,19.41L13,19.31V21.94L12,22C10.63,22 9.33,21.72 8.11,21.19C6.36,20.44 5.5,19.5 5.5,18.38V12.61C5.5,11.61 6.16,10.76 7.5,10.05C8.88,9.35 10.38,9 12,9M12,11A2,2 0 0,0 10,13A2,2 0 0,0 12,15A2,2 0 0,0 14,13A2,2 0 0,0 12,11Z";
var mdiAccountChildCircle = "M12,12A1.5,1.5 0 0,1 13.5,13.5A1.5,1.5 0 0,1 12,15A1.5,1.5 0 0,1 10.5,13.5A1.5,1.5 0 0,1 12,12M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,16C12.72,16 13.4,16.15 14.04,16.5C14.68,16.8 15,17.2 15,17.67V19.41C16.34,18.81 17,18.08 17,17.2V12.8C17,12 16.5,11.35 15.45,10.8C14.4,10.26 13.25,10 12,10C10.75,10 9.6,10.26 8.55,10.8C7.5,11.35 7,12 7,12.8V17.2C7,18 7.53,18.69 8.63,19.22C9.72,19.75 10.84,20 12,20L13,19.92V17.91L12,18C11,18 10,17.8 9.05,17.39C9.17,17 9.53,16.69 10.13,16.41C10.72,16.13 11.34,16 12,16M12,4A2.5,2.5 0 0,0 9.5,6.5A2.5,2.5 0 0,0 12,9A2.5,2.5 0 0,0 14.5,6.5A2.5,2.5 0 0,0 12,4Z";
var mdiAccountChildOutline = "M12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17M12 10C14.34 10 19 11.16 19 13.5V18.63C19 19.5 18.31 20.24 17.34 20.79V13.38C17.34 12.82 14.6 11.54 12 11.54C9.4 11.54 6.66 12.82 6.66 13.38V18.75C6.66 19 7.31 19.46 8.28 19.85C9 19 10.93 18.56 12 18.56C13.33 18.56 16 19.22 16 20.56V21.39C14.63 21.88 13.07 22.13 12 22.13C10.93 22.13 9.38 21.88 8 21.39H8C6.37 20.81 5 19.89 5 18.63V13.5C5 11.16 9.66 10 12 10M12 3.75C11.03 3.75 10.25 4.53 10.25 5.5C10.25 6.47 11.03 7.25 12 7.25C12.97 7.25 13.75 6.47 13.75 5.5C13.75 4.53 12.97 3.75 12 3.75M12 9C10.07 9 8.5 7.43 8.5 5.5C8.5 3.57 10.07 2 12 2C13.93 2 15.5 3.57 15.5 5.5C15.5 7.43 13.93 9 12 9Z";
var mdiAccountCircle = "M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z";
var mdiAccountCircleOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7.07,18.28C7.5,17.38 10.12,16.5 12,16.5C13.88,16.5 16.5,17.38 16.93,18.28C15.57,19.36 13.86,20 12,20C10.14,20 8.43,19.36 7.07,18.28M18.36,16.83C16.93,15.09 13.46,14.5 12,14.5C10.54,14.5 7.07,15.09 5.64,16.83C4.62,15.5 4,13.82 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,13.82 19.38,15.5 18.36,16.83M12,6C10.06,6 8.5,7.56 8.5,9.5C8.5,11.44 10.06,13 12,13C13.94,13 15.5,11.44 15.5,9.5C15.5,7.56 13.94,6 12,6M12,11A1.5,1.5 0 0,1 10.5,9.5A1.5,1.5 0 0,1 12,8A1.5,1.5 0 0,1 13.5,9.5A1.5,1.5 0 0,1 12,11Z";
var mdiAccountClock = "M10.63,14.1C12.23,10.58 16.38,9.03 19.9,10.63C23.42,12.23 24.97,16.38 23.37,19.9C22.24,22.4 19.75,24 17,24C14.3,24 11.83,22.44 10.67,20H1V18C1.06,16.86 1.84,15.93 3.34,15.18C4.84,14.43 6.72,14.04 9,14C9.57,14 10.11,14.05 10.63,14.1V14.1M9,4C10.12,4.03 11.06,4.42 11.81,5.17C12.56,5.92 12.93,6.86 12.93,8C12.93,9.14 12.56,10.08 11.81,10.83C11.06,11.58 10.12,11.95 9,11.95C7.88,11.95 6.94,11.58 6.19,10.83C5.44,10.08 5.07,9.14 5.07,8C5.07,6.86 5.44,5.92 6.19,5.17C6.94,4.42 7.88,4.03 9,4M17,22A5,5 0 0,0 22,17A5,5 0 0,0 17,12A5,5 0 0,0 12,17A5,5 0 0,0 17,22M16,14H17.5V16.82L19.94,18.23L19.19,19.53L16,17.69V14Z";
var mdiAccountClockOutline = "M16,14H17.5V16.82L19.94,18.23L19.19,19.53L16,17.69V14M17,12A5,5 0 0,0 12,17A5,5 0 0,0 17,22A5,5 0 0,0 22,17A5,5 0 0,0 17,12M17,10A7,7 0 0,1 24,17A7,7 0 0,1 17,24C14.21,24 11.8,22.36 10.67,20H1V17C1,14.34 6.33,13 9,13C9.6,13 10.34,13.07 11.12,13.2C12.36,11.28 14.53,10 17,10M10,17C10,16.3 10.1,15.62 10.29,15C9.87,14.93 9.43,14.9 9,14.9C6.03,14.9 2.9,16.36 2.9,17V18.1H10.09C10.03,17.74 10,17.37 10,17M9,4A4,4 0 0,1 13,8A4,4 0 0,1 9,12A4,4 0 0,1 5,8A4,4 0 0,1 9,4M9,5.9A2.1,2.1 0 0,0 6.9,8A2.1,2.1 0 0,0 9,10.1A2.1,2.1 0 0,0 11.1,8A2.1,2.1 0 0,0 9,5.9Z";
var mdiAccountCog = "M10 4A4 4 0 0 0 6 8A4 4 0 0 0 10 12A4 4 0 0 0 14 8A4 4 0 0 0 10 4M17 12C16.87 12 16.76 12.09 16.74 12.21L16.55 13.53C16.25 13.66 15.96 13.82 15.7 14L14.46 13.5C14.35 13.5 14.22 13.5 14.15 13.63L13.15 15.36C13.09 15.47 13.11 15.6 13.21 15.68L14.27 16.5C14.25 16.67 14.24 16.83 14.24 17C14.24 17.17 14.25 17.33 14.27 17.5L13.21 18.32C13.12 18.4 13.09 18.53 13.15 18.64L14.15 20.37C14.21 20.5 14.34 20.5 14.46 20.5L15.7 20C15.96 20.18 16.24 20.35 16.55 20.47L16.74 21.79C16.76 21.91 16.86 22 17 22H19C19.11 22 19.22 21.91 19.24 21.79L19.43 20.47C19.73 20.34 20 20.18 20.27 20L21.5 20.5C21.63 20.5 21.76 20.5 21.83 20.37L22.83 18.64C22.89 18.53 22.86 18.4 22.77 18.32L21.7 17.5C21.72 17.33 21.74 17.17 21.74 17C21.74 16.83 21.73 16.67 21.7 16.5L22.76 15.68C22.85 15.6 22.88 15.47 22.82 15.36L21.82 13.63C21.76 13.5 21.63 13.5 21.5 13.5L20.27 14C20 13.82 19.73 13.65 19.42 13.53L19.23 12.21C19.22 12.09 19.11 12 19 12H17M10 14C5.58 14 2 15.79 2 18V20H11.68A7 7 0 0 1 11 17A7 7 0 0 1 11.64 14.09C11.11 14.03 10.56 14 10 14M18 15.5C18.83 15.5 19.5 16.17 19.5 17C19.5 17.83 18.83 18.5 18 18.5C17.16 18.5 16.5 17.83 16.5 17C16.5 16.17 17.17 15.5 18 15.5Z";
var mdiAccountCogOutline = "M10 4A4 4 0 0 0 6 8A4 4 0 0 0 10 12A4 4 0 0 0 14 8A4 4 0 0 0 10 4M10 6A2 2 0 0 1 12 8A2 2 0 0 1 10 10A2 2 0 0 1 8 8A2 2 0 0 1 10 6M17 12C16.84 12 16.76 12.08 16.76 12.24L16.5 13.5C16.28 13.68 15.96 13.84 15.72 14L14.44 13.5C14.36 13.5 14.2 13.5 14.12 13.6L13.16 15.36C13.08 15.44 13.08 15.6 13.24 15.68L14.28 16.5V17.5L13.24 18.32C13.16 18.4 13.08 18.56 13.16 18.64L14.12 20.4C14.2 20.5 14.36 20.5 14.44 20.5L15.72 20C15.96 20.16 16.28 20.32 16.5 20.5L16.76 21.76C16.76 21.92 16.84 22 17 22H19C19.08 22 19.24 21.92 19.24 21.76L19.4 20.5C19.72 20.32 20.04 20.16 20.28 20L21.5 20.5C21.64 20.5 21.8 20.5 21.8 20.4L22.84 18.64C22.92 18.56 22.84 18.4 22.76 18.32L21.72 17.5V16.5L22.76 15.68C22.84 15.6 22.92 15.44 22.84 15.36L21.8 13.6C21.8 13.5 21.64 13.5 21.5 13.5L20.28 14C20.04 13.84 19.72 13.68 19.4 13.5L19.24 12.24C19.24 12.08 19.08 12 19 12H17M10 13C7.33 13 2 14.33 2 17V20H11.67C11.39 19.41 11.19 18.77 11.09 18.1H3.9V17C3.9 16.36 7.03 14.9 10 14.9C10.43 14.9 10.87 14.94 11.3 15C11.5 14.36 11.77 13.76 12.12 13.21C11.34 13.08 10.6 13 10 13M18.04 15.5C18.84 15.5 19.5 16.16 19.5 17.04C19.5 17.84 18.84 18.5 18.04 18.5C17.16 18.5 16.5 17.84 16.5 17.04C16.5 16.16 17.16 15.5 18.04 15.5Z";
var mdiAccountConvert = "M12 0L11.34 .03L15.15 3.84L16.5 2.5C19.75 4.07 22.09 7.24 22.45 11H23.95C23.44 4.84 18.29 0 12 0M12 4C10.07 4 8.5 5.57 8.5 7.5C8.5 9.43 10.07 11 12 11C13.93 11 15.5 9.43 15.5 7.5C15.5 5.57 13.93 4 12 4M.05 13C.56 19.16 5.71 24 12 24L12.66 23.97L8.85 20.16L7.5 21.5C4.25 19.94 1.91 16.76 1.55 13H.05M12 13C8.13 13 5 14.57 5 16.5V18H19V16.5C19 14.57 15.87 13 12 13Z";
var mdiAccountConvertOutline = "M12 0L11.34 .03L15.15 3.84L16.5 2.5C19.75 4.07 22.09 7.24 22.45 11H23.95C23.44 4.84 18.29 0 12 0M12 4C10.07 4 8.5 5.57 8.5 7.5C8.5 9.43 10.07 11 12 11C13.93 11 15.5 9.43 15.5 7.5C15.5 5.57 13.93 4 12 4M12 6C12.83 6 13.5 6.67 13.5 7.5C13.5 8.33 12.83 9 12 9C11.17 9 10.5 8.33 10.5 7.5C10.5 6.67 11.17 6 12 6M.05 13C.56 19.16 5.71 24 12 24L12.66 23.97L8.85 20.16L7.5 21.5C4.25 19.94 1.91 16.76 1.55 13H.05M12 13C8.13 13 5 14.57 5 16.5V18H19V16.5C19 14.57 15.87 13 12 13M12 15C14.11 15 15.61 15.53 16.39 16H7.61C8.39 15.53 9.89 15 12 15Z";
var mdiAccountCowboyHat = "M20 22H4V20C4 17.8 7.6 16 12 16S20 17.8 20 20M8 9H16V10C16 12.2 14.2 14 12 14S8 12.2 8 10M19 4C18.4 4 18 4.4 18 5V6H16.5L15.1 3C15 2.8 14.9 2.6 14.7 2.5C14.2 2 13.4 1.9 12.7 2.2L12 2.4L11.3 2.1C10.6 1.8 9.8 1.9 9.3 2.4C9.1 2.6 9 2.8 8.9 3L7.5 6H6V5C6 4.4 5.6 4 5 4S4 4.4 4 5V6C4 7.1 4.9 8 6 8H18C19.1 8 20 7.1 20 6V5C20 4.5 19.6 4 19 4Z";
var mdiAccountCowboyHatOutline = "M19 4C18.4 4 18 4.4 18 5V6H16.5L15.1 3C15 2.8 14.9 2.6 14.7 2.5C14.2 2 13.4 1.9 12.7 2.2L12 2.4L11.3 2.1C10.6 1.8 9.8 1.9 9.3 2.4C9.1 2.6 9 2.8 8.9 3L7.5 6H6V5C6 4.4 5.6 4 5 4S4 4.4 4 5V6C4 7.1 4.9 8 6 8H18C19.1 8 20 7.1 20 6V5C20 4.5 19.6 4 19 4M4 22V19C4 16.33 9.33 15 12 15S20 16.33 20 19V22H4M18.1 20.1V19C18.1 18.36 14.97 16.9 12 16.9S5.9 18.36 5.9 19V20.1H18.1M16 9V10C16 12.21 14.21 14 12 14S8 12.21 8 10V9H10V10C10 11.11 10.9 12 12 12S14 11.11 14 10V9H16Z";
var mdiAccountCreditCard = "M7 12C9.2 12 11 10.2 11 8S9.2 4 7 4 3 5.8 3 8 4.8 12 7 12M11 20V14.7C9.9 14.3 8.5 14 7 14C3.1 14 0 15.8 0 18V20H11M22 4H15C13.9 4 13 4.9 13 6V18C13 19.1 13.9 20 15 20H22C23.1 20 24 19.1 24 18V6C24 4.9 23.1 4 22 4M18 18H16V6H18V18Z";
var mdiAccountCreditCardOutline = "M7 4C4.8 4 3 5.8 3 8S4.8 12 7 12 11 10.2 11 8 9.2 4 7 4M7 10C5.9 10 5 9.1 5 8S5.9 6 7 6 9 6.9 9 8 8.1 10 7 10M7 14C3.1 14 0 15.8 0 18V20H11V18H2C2 17.4 3.8 16 7 16C8.8 16 10.2 16.5 11 17V14.8C9.9 14.3 8.5 14 7 14M22 4H15C13.9 4 13 4.9 13 6V18C13 19.1 13.9 20 15 20H22C23.1 20 24 19.1 24 18V6C24 4.9 23.1 4 22 4M16 18H15V6H16V18M22 18H18V6H22V18Z";
var mdiAccountDetails = "M11 9C11 10.66 9.66 12 8 12C6.34 12 5 10.66 5 9C5 7.34 6.34 6 8 6C9.66 6 11 7.34 11 9M14 20H2V18C2 15.79 4.69 14 8 14C11.31 14 14 15.79 14 18M22 12V14H13V12M22 8V10H13V8M22 4V6H13V4Z";
var mdiAccountDetailsOutline = "M11 9C11 10.66 9.66 12 8 12C6.34 12 5 10.66 5 9C5 7.34 6.34 6 8 6C9.66 6 11 7.34 11 9M14 20H2V18C2 15.79 4.69 14 8 14C11.31 14 14 15.79 14 18M7 9C7 9.55 7.45 10 8 10C8.55 10 9 9.55 9 9C9 8.45 8.55 8 8 8C7.45 8 7 8.45 7 9M4 18H12C12 16.9 10.21 16 8 16C5.79 16 4 16.9 4 18M22 12V14H13V12M22 8V10H13V8M22 4V6H13V4Z";
var mdiAccountEdit = "M21.7,13.35L20.7,14.35L18.65,12.3L19.65,11.3C19.86,11.09 20.21,11.09 20.42,11.3L21.7,12.58C21.91,12.79 21.91,13.14 21.7,13.35M12,18.94L18.06,12.88L20.11,14.93L14.06,21H12V18.94M12,14C7.58,14 4,15.79 4,18V20H10V18.11L14,14.11C13.34,14.03 12.67,14 12,14M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4Z";
var mdiAccountEditOutline = "M2 17V20H10V18.11H3.9V17C3.9 16.36 7.03 14.9 10 14.9C10.96 14.91 11.91 15.04 12.83 15.28L14.35 13.76C12.95 13.29 11.5 13.03 10 13C7.33 13 2 14.33 2 17M10 4C7.79 4 6 5.79 6 8S7.79 12 10 12 14 10.21 14 8 12.21 4 10 4M10 10C8.9 10 8 9.11 8 8S8.9 6 10 6 12 6.9 12 8 11.11 10 10 10M21.7 13.35L20.7 14.35L18.65 12.35L19.65 11.35C19.86 11.14 20.21 11.14 20.42 11.35L21.7 12.63C21.91 12.84 21.91 13.19 21.7 13.4M12 18.94L18.06 12.88L20.11 14.88L14.11 20.95H12V18.94";
var mdiAccountEye = "M6 8C6 5.79 7.79 4 10 4S14 5.79 14 8 12.21 12 10 12 6 10.21 6 8M9.14 19.75L8.85 19L9.14 18.25C9.84 16.5 11.08 15.14 12.61 14.22C11.79 14.08 10.92 14 10 14C5.58 14 2 15.79 2 18V20H9.27C9.23 19.91 9.18 19.83 9.14 19.75M17 18C16.44 18 16 18.44 16 19S16.44 20 17 20 18 19.56 18 19 17.56 18 17 18M23 19C22.06 21.34 19.73 23 17 23S11.94 21.34 11 19C11.94 16.66 14.27 15 17 15S22.06 16.66 23 19M19.5 19C19.5 17.62 18.38 16.5 17 16.5S14.5 17.62 14.5 19 15.62 21.5 17 21.5 19.5 20.38 19.5 19Z";
var mdiAccountEyeOutline = "M10 12C12.21 12 14 10.21 14 8S12.21 4 10 4 6 5.79 6 8 7.79 12 10 12M10 6C11.11 6 12 6.9 12 8S11.11 10 10 10 8 9.11 8 8 8.9 6 10 6M9.27 20H2V17C2 14.33 7.33 13 10 13C11.04 13 12.5 13.21 13.86 13.61C13 13.95 12.2 14.42 11.5 15C11 14.94 10.5 14.9 10 14.9C7.03 14.9 3.9 16.36 3.9 17V18.1H9.22C9.2 18.15 9.17 18.2 9.14 18.25L8.85 19L9.14 19.75C9.18 19.83 9.23 19.91 9.27 20M17 18C17.56 18 18 18.44 18 19S17.56 20 17 20 16 19.56 16 19 16.44 18 17 18M17 15C14.27 15 11.94 16.66 11 19C11.94 21.34 14.27 23 17 23S22.06 21.34 23 19C22.06 16.66 19.73 15 17 15M17 21.5C15.62 21.5 14.5 20.38 14.5 19S15.62 16.5 17 16.5 19.5 17.62 19.5 19 18.38 21.5 17 21.5Z";
var mdiAccountFile = "M7.5 5C9.43 5 11 6.57 11 8.5C11 10.43 9.43 12 7.5 12C5.57 12 4 10.43 4 8.5C4 6.57 5.57 5 7.5 5M1 19V16.5C1 14.57 4.46 13 7.5 13C8.68 13 9.92 13.24 11 13.64V19H1M22 19H14C13.45 19 13 18.55 13 18V6C13 5.45 13.45 5 14 5H19L23 9V18C23 18.55 22.55 19 22 19M18 10H21V9.83L18.17 7H18V10Z";
var mdiAccountFileOutline = "M7.5 5C9.43 5 11 6.57 11 8.5C11 10.43 9.43 12 7.5 12C5.57 12 4 10.43 4 8.5C4 6.57 5.57 5 7.5 5M1 19V16.5C1 14.57 4.46 13 7.5 13C8.68 13 9.92 13.24 11 13.64V15.56C10.18 15.22 8.91 15 7.5 15C5 15 3 15.67 3 16.5V17H11V19H1M22 19H14C13.45 19 13 18.55 13 18V6C13 5.45 13.45 5 14 5H19L23 9V18C23 18.55 22.55 19 22 19M15 7V17H21V10H18V7H15M7.5 7C6.67 7 6 7.67 6 8.5C6 9.33 6.67 10 7.5 10C8.33 10 9 9.33 9 8.5C9 7.67 8.33 7 7.5 7Z";
var mdiAccountFileText = "M7.5 5C9.43 5 11 6.57 11 8.5C11 10.43 9.43 12 7.5 12C5.57 12 4 10.43 4 8.5C4 6.57 5.57 5 7.5 5M1 19V16.5C1 14.57 4.46 13 7.5 13C8.68 13 9.92 13.24 11 13.64V19H1M22 19H14C13.45 19 13 18.55 13 18V6C13 5.45 13.45 5 14 5H19L23 9V18C23 18.55 22.55 19 22 19M18 10H21V9.83L18.17 7H18V10M15 12V13.5H21V12H15M15 15V16.5H21V15H15Z";
var mdiAccountFileTextOutline = "M7.5 5C9.43 5 11 6.57 11 8.5C11 10.43 9.43 12 7.5 12C5.57 12 4 10.43 4 8.5C4 6.57 5.57 5 7.5 5M1 19V16.5C1 14.57 4.46 13 7.5 13C8.68 13 9.92 13.24 11 13.64V15.56C10.18 15.22 8.91 15 7.5 15C5 15 3 15.67 3 16.5V17H11V19H1M22 19H14C13.45 19 13 18.55 13 18V6C13 5.45 13.45 5 14 5H19L23 9V18C23 18.55 22.55 19 22 19M15 7V17H21V10H18V7H15M7.5 7C6.67 7 6 7.67 6 8.5C6 9.33 6.67 10 7.5 10C8.33 10 9 9.33 9 8.5C9 7.67 8.33 7 7.5 7M16 13H20V15H16V13Z";
var mdiAccountFilter = "M10 4C12.2 4 14 5.8 14 8S12.2 12 10 12 6 10.2 6 8 7.8 4 10 4M17 21L18.8 22.77C19.3 23.27 20 22.87 20 22.28V18L22.8 14.6C23.3 13.9 22.8 13 22 13H15C14.2 13 13.7 14 14.2 14.6L17 18V21M15 18.7L12.7 15.9C12.3 15.4 12.1 14.8 12.1 14.2C11.4 14 10.7 14 10 14C5.6 14 2 15.8 2 18V20H15V18.7Z";
var mdiAccountFilterOutline = "M17 21L18.8 22.77C19.3 23.27 20 22.87 20 22.28V18L22.8 14.6C23.3 13.9 22.8 13 22 13H15C14.2 13 13.7 14 14.2 14.6L17 18V21M15 20H2V17C2 14.3 7.3 13 10 13C10.6 13 11.3 13.1 12.1 13.2C11.9 13.8 12 14.5 12.2 15.1C11.5 15 10.7 14.9 10 14.9C7 14.9 3.9 16.4 3.9 17V18.1H14.5L15 18.7V20M10 4C7.8 4 6 5.8 6 8S7.8 12 10 12 14 10.2 14 8 12.2 4 10 4M10 10C8.9 10 8 9.1 8 8S8.9 6 10 6 12 6.9 12 8 11.1 10 10 10Z";
var mdiAccountGroup = "M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z";
var mdiAccountGroupOutline = "M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z";
var mdiAccountHardHat = "M12,15C7.58,15 4,16.79 4,19V21H20V19C20,16.79 16.42,15 12,15M8,9A4,4 0 0,0 12,13A4,4 0 0,0 16,9M11.5,2C11.2,2 11,2.21 11,2.5V5.5H10V3C10,3 7.75,3.86 7.75,6.75C7.75,6.75 7,6.89 7,8H17C16.95,6.89 16.25,6.75 16.25,6.75C16.25,3.86 14,3 14,3V5.5H13V2.5C13,2.21 12.81,2 12.5,2H11.5Z";
var mdiAccountHardHatOutline = "M16 9C16 14.33 8 14.33 8 9H10C10 11.67 14 11.67 14 9M20 18V21H4V18C4 15.33 9.33 14 12 14C14.67 14 20 15.33 20 18M18.1 18C18.1 17.36 14.97 15.9 12 15.9C9.03 15.9 5.9 17.36 5.9 18V19.1H18.1M12.5 2C12.78 2 13 2.22 13 2.5V5.5H14V3C15.45 3.67 16.34 5.16 16.25 6.75C16.25 6.75 16.95 6.89 17 8H7C7 6.89 7.75 6.75 7.75 6.75C7.66 5.16 8.55 3.67 10 3V5.5H11V2.5C11 2.22 11.22 2 11.5 2";
var mdiAccountHeart = "M15,14C12.3,14 7,15.3 7,18V20H23V18C23,15.3 17.7,14 15,14M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12M5,15L4.4,14.5C2.4,12.6 1,11.4 1,9.9C1,8.7 2,7.7 3.2,7.7C3.9,7.7 4.6,8 5,8.5C5.4,8 6.1,7.7 6.8,7.7C8,7.7 9,8.6 9,9.9C9,11.4 7.6,12.6 5.6,14.5L5,15Z";
var mdiAccountHeartOutline = "M5,15L4.4,14.5C2.4,12.6 1,11.4 1,9.9C1,8.7 2,7.7 3.2,7.7C3.9,7.7 4.6,8 5,8.5C5.4,8 6.1,7.7 6.8,7.7C8,7.7 9,8.6 9,9.9C9,11.4 7.6,12.6 5.6,14.5L5,15M15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4M15,10.1A2.1,2.1 0 0,1 12.9,8A2.1,2.1 0 0,1 15,5.9C16.16,5.9 17.1,6.84 17.1,8C17.1,9.16 16.16,10.1 15,10.1M15,13C12.33,13 7,14.33 7,17V20H23V17C23,14.33 17.67,13 15,13M21.1,18.1H8.9V17C8.9,16.36 12,14.9 15,14.9C17.97,14.9 21.1,16.36 21.1,17V18.1Z";
var mdiAccountInjury = "M8 6C8 3.79 9.79 2 12 2S16 3.79 16 6 14.21 10 12 10 8 8.21 8 6M17 22H18C19.1 22 20 21.1 20 20V15.22C20 14.1 19.39 13.07 18.39 12.56C17.96 12.34 17.5 12.13 17 11.94V22M12.34 17L15 11.33C14.07 11.12 13.07 11 12 11C9.47 11 7.29 11.7 5.61 12.56C4.61 13.07 4 14.1 4 15.22V22H6.34C6.12 21.55 6 21.04 6 20.5C6 18.57 7.57 17 9.5 17H12.34M10 22L11.41 19H9.5C8.67 19 8 19.67 8 20.5S8.67 22 9.5 22H10Z";
var mdiAccountInjuryOutline = "M12 10C14.21 10 16 8.21 16 6S14.21 2 12 2 8 3.79 8 6 9.79 10 12 10M12 4C13.1 4 14 4.9 14 6S13.1 8 12 8 10 7.1 10 6 10.9 4 12 4M18.39 12.56C16.71 11.7 14.53 11 12 11S7.29 11.7 5.61 12.56C4.61 13.07 4 14.1 4 15.22V22H6V15.22C6 14.84 6.2 14.5 6.5 14.34C7.71 13.73 9.63 13 12 13C12.76 13 13.47 13.07 14.13 13.2L12.58 16.5H9.75C8.23 16.5 7 17.73 7 19.25S8.23 22 9.75 22H18C19.1 22 20 21.1 20 20V15.22C20 14.1 19.39 13.07 18.39 12.56M10.94 20H9.75C9.34 20 9 19.66 9 19.25S9.34 18.5 9.75 18.5H11.64L10.94 20M18 20H13.15L16.09 13.73C16.63 13.93 17.1 14.14 17.5 14.34C17.8 14.5 18 14.84 18 15.22V20Z";
var mdiAccountKey = "M11 10V12H9V14H7V12H5.8C5.4 13.2 4.3 14 3 14C1.3 14 0 12.7 0 11S1.3 8 3 8C4.3 8 5.4 8.8 5.8 10H11M3 10C2.4 10 2 10.4 2 11S2.4 12 3 12 4 11.6 4 11 3.6 10 3 10M16 14C18.7 14 24 15.3 24 18V20H8V18C8 15.3 13.3 14 16 14M16 12C13.8 12 12 10.2 12 8S13.8 4 16 4 20 5.8 20 8 18.2 12 16 12Z";
var mdiAccountKeyOutline = "M5.8 10C5.4 8.8 4.3 8 3 8C1.3 8 0 9.3 0 11S1.3 14 3 14C4.3 14 5.4 13.2 5.8 12H7V14H9V12H11V10H5.8M3 12C2.4 12 2 11.6 2 11S2.4 10 3 10 4 10.4 4 11 3.6 12 3 12M16 4C13.8 4 12 5.8 12 8S13.8 12 16 12 20 10.2 20 8 18.2 4 16 4M16 10.1C14.8 10.1 13.9 9.2 13.9 8C13.9 6.8 14.8 5.9 16 5.9C17.2 5.9 18.1 6.8 18.1 8S17.2 10.1 16 10.1M16 13C13.3 13 8 14.3 8 17V20H24V17C24 14.3 18.7 13 16 13M22.1 18.1H9.9V17C9.9 16.4 13 14.9 16 14.9C19 14.9 22.1 16.4 22.1 17V18.1Z";
var mdiAccountLock = "M6 8C6 5.79 7.79 4 10 4S14 5.79 14 8 12.21 12 10 12 6 10.21 6 8M12 18.2C12 17.24 12.5 16.34 13.2 15.74V15.5C13.2 15.11 13.27 14.74 13.38 14.38C12.35 14.14 11.21 14 10 14C5.58 14 2 15.79 2 18V20H12V18.2M22 18.3V21.8C22 22.4 21.4 23 20.7 23H15.2C14.6 23 14 22.4 14 21.7V18.2C14 17.6 14.6 17 15.2 17V15.5C15.2 14.1 16.6 13 18 13C19.4 13 20.8 14.1 20.8 15.5V17C21.4 17 22 17.6 22 18.3M19.5 15.5C19.5 14.7 18.8 14.2 18 14.2C17.2 14.2 16.5 14.7 16.5 15.5V17H19.5V15.5Z";
var mdiAccountLockOpen = "M6 8C6 5.79 7.79 4 10 4S14 5.79 14 8 12.21 12 10 12 6 10.21 6 8M12 18.2C12 17.24 12.5 16.34 13.2 15.74V14.5C13.2 14.45 13.22 14.39 13.22 14.34C12.23 14.12 11.15 14 10 14C5.58 14 2 15.79 2 18V20H12V18.2M22 18.3V21.8C22 22.4 21.4 23 20.7 23H15.2C14.6 23 14 22.4 14 21.7V18.2C14 17.6 14.6 17 15.2 17V14.5C15.2 13.1 16.6 12 18 12S20.8 13.1 20.8 14.5V15H19.5V14.5C19.5 13.7 18.8 13.2 18 13.2S16.5 13.7 16.5 14.5V17H20.8C21.4 17 22 17.6 22 18.3Z";
var mdiAccountLockOpenOutline = "M10 12C12.21 12 14 10.21 14 8S12.21 4 10 4 6 5.79 6 8 7.79 12 10 12M10 6C11.11 6 12 6.9 12 8S11.11 10 10 10 8 9.11 8 8 8.9 6 10 6M12 20H2V17C2 14.33 7.33 13 10 13C10.91 13 12.13 13.16 13.35 13.47C13.26 13.8 13.2 14.15 13.2 14.5V15.39C12.22 15.1 11.1 14.9 10 14.9C7.03 14.9 3.9 16.36 3.9 17V18.1H12C12 18.13 12 18.17 12 18.2V20M20.8 17H16.5V14.5C16.5 13.7 17.2 13.2 18 13.2S19.5 13.7 19.5 14.5V15H20.8V14.5C20.8 13.1 19.4 12 18 12S15.2 13.1 15.2 14.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17Z";
var mdiAccountLockOutline = "M10 12C12.21 12 14 10.21 14 8S12.21 4 10 4 6 5.79 6 8 7.79 12 10 12M10 6C11.11 6 12 6.9 12 8S11.11 10 10 10 8 9.11 8 8 8.9 6 10 6M12 20H2V17C2 14.33 7.33 13 10 13C11 13 12.38 13.19 13.71 13.56C13.41 14.12 13.23 14.74 13.21 15.39C12.23 15.1 11.11 14.9 10 14.9C7.03 14.9 3.9 16.36 3.9 17V18.1H12C12 18.13 12 18.17 12 18.2V20M20.8 17V15.5C20.8 14.1 19.4 13 18 13C16.6 13 15.2 14.1 15.2 15.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17M19.5 17H16.5V15.5C16.5 14.7 17.2 14.2 18 14.2C18.8 14.2 19.5 14.7 19.5 15.5V17Z";
var mdiAccountMinus = "M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M1,10V12H9V10M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12Z";
var mdiAccountMinusOutline = "M15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4M15,5.9C16.16,5.9 17.1,6.84 17.1,8C17.1,9.16 16.16,10.1 15,10.1A2.1,2.1 0 0,1 12.9,8A2.1,2.1 0 0,1 15,5.9M1,10V12H9V10H1M15,13C12.33,13 7,14.33 7,17V20H23V17C23,14.33 17.67,13 15,13M15,14.9C17.97,14.9 21.1,16.36 21.1,17V18.1H8.9V17C8.9,16.36 12,14.9 15,14.9Z";
var mdiAccountMultiple = "M16 17V19H2V17S2 13 9 13 16 17 16 17M12.5 7.5A3.5 3.5 0 1 0 9 11A3.5 3.5 0 0 0 12.5 7.5M15.94 13A5.32 5.32 0 0 1 18 17V19H22V17S22 13.37 15.94 13M15 4A3.39 3.39 0 0 0 13.07 4.59A5 5 0 0 1 13.07 10.41A3.39 3.39 0 0 0 15 11A3.5 3.5 0 0 0 15 4Z";
var mdiAccountMultipleCheck = "M19 17V19H7V17S7 13 13 13 19 17 19 17M16 8A3 3 0 1 0 13 11A3 3 0 0 0 16 8M19.2 13.06A5.6 5.6 0 0 1 21 17V19H24V17S24 13.55 19.2 13.06M18 5A2.91 2.91 0 0 0 17.11 5.14A5 5 0 0 1 17.11 10.86A2.91 2.91 0 0 0 18 11A3 3 0 0 0 18 5M7.34 8.92L8.5 10.33L3.75 15.08L1 12.08L2.16 10.92L3.75 12.5L7.34 8.92";
var mdiAccountMultipleCheckOutline = "M13 11A3 3 0 1 0 10 8A3 3 0 0 0 13 11M13 7A1 1 0 1 1 12 8A1 1 0 0 1 13 7M17.11 10.86A5 5 0 0 0 17.11 5.14A2.91 2.91 0 0 1 18 5A3 3 0 0 1 18 11A2.91 2.91 0 0 1 17.11 10.86M13 13C7 13 7 17 7 17V19H19V17S19 13 13 13M9 17C9 16.71 9.32 15 13 15C16.5 15 16.94 16.56 17 17M24 17V19H21V17A5.6 5.6 0 0 0 19.2 13.06C24 13.55 24 17 24 17M7.34 8.92L8.5 10.33L3.75 15.08L1 12.08L2.16 10.92L3.75 12.5L7.34 8.92";
var mdiAccountMultipleMinus = "M19 17V19H7V17S7 13 13 13 19 17 19 17M16 8A3 3 0 1 0 13 11A3 3 0 0 0 16 8M19.2 13.06A5.6 5.6 0 0 1 21 17V19H24V17S24 13.55 19.2 13.06M18 5A2.91 2.91 0 0 0 17.11 5.14A5 5 0 0 1 17.11 10.86A2.91 2.91 0 0 0 18 11A3 3 0 0 0 18 5M8 10H0V12H8Z";
var mdiAccountMultipleMinusOutline = "M13 11A3 3 0 1 0 10 8A3 3 0 0 0 13 11M13 7A1 1 0 1 1 12 8A1 1 0 0 1 13 7M17.11 10.86A5 5 0 0 0 17.11 5.14A2.91 2.91 0 0 1 18 5A3 3 0 0 1 18 11A2.91 2.91 0 0 1 17.11 10.86M13 13C7 13 7 17 7 17V19H19V17S19 13 13 13M9 17C9 16.71 9.32 15 13 15C16.5 15 16.94 16.56 17 17M24 17V19H21V17A5.6 5.6 0 0 0 19.2 13.06C24 13.55 24 17 24 17M8 12H0V10H8Z";
var mdiAccountMultipleOutline = "M13.07 10.41A5 5 0 0 0 13.07 4.59A3.39 3.39 0 0 1 15 4A3.5 3.5 0 0 1 15 11A3.39 3.39 0 0 1 13.07 10.41M5.5 7.5A3.5 3.5 0 1 1 9 11A3.5 3.5 0 0 1 5.5 7.5M7.5 7.5A1.5 1.5 0 1 0 9 6A1.5 1.5 0 0 0 7.5 7.5M16 17V19H2V17S2 13 9 13 16 17 16 17M14 17C13.86 16.22 12.67 15 9 15S4.07 16.31 4 17M15.95 13A5.32 5.32 0 0 1 18 17V19H22V17S22 13.37 15.94 13Z";
var mdiAccountMultiplePlus = "M19 17V19H7V17S7 13 13 13 19 17 19 17M16 8A3 3 0 1 0 13 11A3 3 0 0 0 16 8M19.2 13.06A5.6 5.6 0 0 1 21 17V19H24V17S24 13.55 19.2 13.06M18 5A2.91 2.91 0 0 0 17.11 5.14A5 5 0 0 1 17.11 10.86A2.91 2.91 0 0 0 18 11A3 3 0 0 0 18 5M8 10H5V7H3V10H0V12H3V15H5V12H8Z";
var mdiAccountMultiplePlusOutline = "M13 11A3 3 0 1 0 10 8A3 3 0 0 0 13 11M13 7A1 1 0 1 1 12 8A1 1 0 0 1 13 7M17.11 10.86A5 5 0 0 0 17.11 5.14A2.91 2.91 0 0 1 18 5A3 3 0 0 1 18 11A2.91 2.91 0 0 1 17.11 10.86M13 13C7 13 7 17 7 17V19H19V17S19 13 13 13M9 17C9 16.71 9.32 15 13 15C16.5 15 16.94 16.56 17 17M24 17V19H21V17A5.6 5.6 0 0 0 19.2 13.06C24 13.55 24 17 24 17M8 12H5V15H3V12H0V10H3V7H5V10H8Z";
var mdiAccountMultipleRemove = "M24 17V19H21V17C21 15.45 20.3 14.06 19.18 13.06C24 13.55 24 17 24 17M18 5C19.66 5 21 6.34 21 8C21 9.66 19.66 11 18 11C17.69 11 17.38 10.95 17.1 10.86C17.67 10.05 18 9.07 18 8C18 6.94 17.67 5.95 17.1 5.14C17.38 5.05 17.69 5 18 5M13 5C14.66 5 16 6.34 16 8C16 9.66 14.66 11 13 11C11.34 11 10 9.66 10 8C10 6.34 11.34 5 13 5M19 17V19H7V17C7 14.79 9.69 13 13 13C16.31 13 19 14.79 19 17M.464 13.12L2.59 11L.464 8.88L1.88 7.46L4 9.59L6.12 7.46L7.54 8.88L5.41 11L7.54 13.12L6.12 14.54L4 12.41L1.88 14.54Z";
var mdiAccountMultipleRemoveOutline = "M24 17V19H21V17C21 15.45 20.3 14.06 19.18 13.06C24 13.55 24 17 24 17M18 5C19.66 5 21 6.34 21 8C21 9.66 19.66 11 18 11C17.69 11 17.38 10.95 17.1 10.86C17.67 10.05 18 9.07 18 8C18 6.94 17.67 5.95 17.1 5.14C17.38 5.05 17.69 5 18 5M13 5C14.66 5 16 6.34 16 8C16 9.66 14.66 11 13 11C11.34 11 10 9.66 10 8C10 6.34 11.34 5 13 5M19 17V19H7V17C7 14.79 9.69 13 13 13C16.31 13 19 14.79 19 17M13 7C12.45 7 12 7.45 12 8C12 8.55 12.45 9 13 9C13.55 9 14 8.55 14 8C14 7.45 13.55 7 13 7M13 15C10.79 15 9 15.9 9 17H17C17 15.9 15.21 15 13 15M.464 13.12L2.59 11L.464 8.88L1.88 7.46L4 9.59L6.12 7.46L7.54 8.88L5.41 11L7.54 13.12L6.12 14.54L4 12.41L1.88 14.54Z";
var mdiAccountMusic = "M11,14C12,14 13.05,14.16 14.2,14.44C13.39,15.31 13,16.33 13,17.5C13,18.39 13.25,19.23 13.78,20H3V18C3,16.81 3.91,15.85 5.74,15.12C7.57,14.38 9.33,14 11,14M11,12C9.92,12 9,11.61 8.18,10.83C7.38,10.05 7,9.11 7,8C7,6.92 7.38,6 8.18,5.18C9,4.38 9.92,4 11,4C12.11,4 13.05,4.38 13.83,5.18C14.61,6 15,6.92 15,8C15,9.11 14.61,10.05 13.83,10.83C13.05,11.61 12.11,12 11,12M18.5,10H20L22,10V12H20V17.5A2.5,2.5 0 0,1 17.5,20A2.5,2.5 0 0,1 15,17.5A2.5,2.5 0 0,1 17.5,15C17.86,15 18.19,15.07 18.5,15.21V10Z";
var mdiAccountMusicOutline = "M11,4A4,4 0 0,1 15,8A4,4 0 0,1 11,12A4,4 0 0,1 7,8A4,4 0 0,1 11,4M11,6A2,2 0 0,0 9,8A2,2 0 0,0 11,10A2,2 0 0,0 13,8A2,2 0 0,0 11,6M11,13C12.1,13 13.66,13.23 15.11,13.69C14.5,14.07 14,14.6 13.61,15.23C12.79,15.03 11.89,14.9 11,14.9C8.03,14.9 4.9,16.36 4.9,17V18.1H13.04C13.13,18.8 13.38,19.44 13.76,20H3V17C3,14.34 8.33,13 11,13M18.5,10H20L22,10V12H20V17.5A2.5,2.5 0 0,1 17.5,20A2.5,2.5 0 0,1 15,17.5A2.5,2.5 0 0,1 17.5,15C17.86,15 18.19,15.07 18.5,15.21V10Z";
var mdiAccountNetwork = "M13,17V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H5V15.5C5,13.57 8.13,12 12,12C15.87,12 19,13.57 19,15.5V17H13M12,3A3.5,3.5 0 0,1 15.5,6.5A3.5,3.5 0 0,1 12,10A3.5,3.5 0 0,1 8.5,6.5A3.5,3.5 0 0,1 12,3Z";
var mdiAccountNetworkOff = "M13.03 9.83L8.67 5.47C9.11 4.04 10.43 3 12 3C13.93 3 15.5 4.57 15.5 6.5C15.5 8.07 14.46 9.39 13.03 9.83M19 15.5C19 14.26 17.7 13.17 15.75 12.55L19 15.8V15.5M22 22H21.57L20.84 22.73L20.11 22H15C15 22.55 14.55 23 14 23H10C9.45 23 9 22.55 9 22H2V20H9C9 19.45 9.45 19 10 19H11V17H5V15.5C5 13.88 7.22 12.5 10.23 12.12L1.11 3L2.39 1.73L22 21.34V21.35L22.11 21.46L22 21.57V22M18.11 20L15.11 17H13V19H14C14.55 19 15 19.45 15 20H18.11Z";
var mdiAccountNetworkOffOutline = "M19 15.8L15.75 12.55C17.7 13.17 19 14.26 19 15.5V15.8M13.03 9.83L8.67 5.47C9.11 4.04 10.43 3 12 3C13.93 3 15.5 4.57 15.5 6.5C15.5 8.07 14.46 9.39 13.03 9.83M12 8C12.83 8 13.5 7.33 13.5 6.5S12.83 5 12 5 10.5 5.67 10.5 6.5 11.17 8 12 8M22 22H21.57L20.84 22.73L20.11 22H15C15 22.55 14.55 23 14 23H10C9.45 23 9 22.55 9 22H2V20H9C9 19.45 9.45 19 10 19H11V17H5V15.5C5 13.88 7.22 12.5 10.23 12.12L1.11 3L2.39 1.73L22 21.34V21.35L22.11 21.46L22 21.57V22M13.11 15L12.11 14C12.08 14 12.04 14 12 14C9.89 14 8.39 14.53 7.61 15H13.11M18.11 20L15.11 17H13V19H14C14.55 19 15 19.45 15 20H18.11Z";
var mdiAccountNetworkOutline = "M12,10A3.5,3.5 0 0,0 15.5,6.5A3.5,3.5 0 0,0 12,3A3.5,3.5 0 0,0 8.5,6.5A3.5,3.5 0 0,0 12,10M12,5A1.5,1.5 0 0,1 13.5,6.5A1.5,1.5 0 0,1 12,8A1.5,1.5 0 0,1 10.5,6.5A1.5,1.5 0 0,1 12,5M15,20A1,1 0 0,0 14,19H13V17H19V15.5C19,13.57 15.87,12 12,12C8.13,12 5,13.57 5,15.5V17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M7.61,15C8.39,14.53 9.89,14 12,14C14.11,14 15.61,14.53 16.39,15H7.61Z";
var mdiAccountOff = "M12,4A4,4 0 0,1 16,8C16,9.95 14.6,11.58 12.75,11.93L8.07,7.25C8.42,5.4 10.05,4 12,4M12.28,14L18.28,20L20,21.72L18.73,23L15.73,20H4V18C4,16.16 6.5,14.61 9.87,14.14L2.78,7.05L4.05,5.78L12.28,14M20,18V19.18L15.14,14.32C18,14.93 20,16.35 20,18Z";
var mdiAccountOffOutline = "M2.75,7L4.03,5.75L13.26,15L20,21.72L18.73,23L15.73,20H4V17C4,15.14 6.61,13.92 9.09,13.36L2.75,7M20,17V19.18L18.1,17.28V17C18.1,16.74 17.6,16.35 16.8,16L14,13.18C16.71,13.63 20,14.91 20,17M5.9,17V18.1H13.83L10.72,15C8.19,15.3 5.9,16.45 5.9,17M12,4A4,4 0 0,1 16,8C16,9.95 14.6,11.58 12.75,11.93L8.07,7.25C8.42,5.4 10.05,4 12,4M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6Z";
var mdiAccountOutline = "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M12,13C14.67,13 20,14.33 20,17V20H4V17C4,14.33 9.33,13 12,13M12,14.9C9.03,14.9 5.9,16.36 5.9,17V18.1H18.1V17C18.1,16.36 14.97,14.9 12,14.9Z";
var mdiAccountPlus = "M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M6,10V7H4V10H1V12H4V15H6V12H9V10M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12Z";
var mdiAccountPlusOutline = "M15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4M15,5.9C16.16,5.9 17.1,6.84 17.1,8C17.1,9.16 16.16,10.1 15,10.1A2.1,2.1 0 0,1 12.9,8A2.1,2.1 0 0,1 15,5.9M4,7V10H1V12H4V15H6V12H9V10H6V7H4M15,13C12.33,13 7,14.33 7,17V20H23V17C23,14.33 17.67,13 15,13M15,14.9C17.97,14.9 21.1,16.36 21.1,17V18.1H8.9V17C8.9,16.36 12,14.9 15,14.9Z";
var mdiAccountQuestion = "M13,8A4,4 0 0,1 9,12A4,4 0 0,1 5,8A4,4 0 0,1 9,4A4,4 0 0,1 13,8M17,18V20H1V18C1,15.79 4.58,14 9,14C13.42,14 17,15.79 17,18M20.5,14.5V16H19V14.5H20.5M18.5,9.5H17V9A3,3 0 0,1 20,6A3,3 0 0,1 23,9C23,9.97 22.5,10.88 21.71,11.41L21.41,11.6C20.84,12 20.5,12.61 20.5,13.3V13.5H19V13.3C19,12.11 19.6,11 20.59,10.35L20.88,10.16C21.27,9.9 21.5,9.47 21.5,9A1.5,1.5 0 0,0 20,7.5A1.5,1.5 0 0,0 18.5,9V9.5Z";
var mdiAccountQuestionOutline = "M20.5,14.5V16H19V14.5H20.5M18.5,9.5H17V9A3,3 0 0,1 20,6A3,3 0 0,1 23,9C23,9.97 22.5,10.88 21.71,11.41L21.41,11.6C20.84,12 20.5,12.61 20.5,13.3V13.5H19V13.3C19,12.11 19.6,11 20.59,10.35L20.88,10.16C21.27,9.9 21.5,9.47 21.5,9A1.5,1.5 0 0,0 20,7.5A1.5,1.5 0 0,0 18.5,9V9.5M9,13C11.67,13 17,14.34 17,17V20H1V17C1,14.34 6.33,13 9,13M9,4A4,4 0 0,1 13,8A4,4 0 0,1 9,12A4,4 0 0,1 5,8A4,4 0 0,1 9,4M9,14.9C6.03,14.9 2.9,16.36 2.9,17V18.1H15.1V17C15.1,16.36 11.97,14.9 9,14.9M9,5.9A2.1,2.1 0 0,0 6.9,8A2.1,2.1 0 0,0 9,10.1A2.1,2.1 0 0,0 11.1,8A2.1,2.1 0 0,0 9,5.9Z";
var mdiAccountReactivate = "M21.5 9H16.5L18.36 7.14C16.9 5.23 14.59 4 12 4C7.58 4 4 7.58 4 12C4 13.83 4.61 15.5 5.64 16.85C6.86 15.45 9.15 14.5 12 14.5C14.85 14.5 17.15 15.45 18.36 16.85C19.39 15.5 20 13.83 20 12H22C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C15.14 2 17.95 3.45 19.78 5.72L21.5 4V9M12 7C13.66 7 15 8.34 15 10C15 11.66 13.66 13 12 13C10.34 13 9 11.66 9 10C9 8.34 10.34 7 12 7Z";
var mdiAccountReactivateOutline = "M21.5 9H16.5L18.36 7.14C16.9 5.23 14.59 4 12 4C7.58 4 4 7.58 4 12C4 13.83 4.61 15.5 5.64 16.85C6.86 15.45 9.15 14.5 12 14.5C14.85 14.5 17.15 15.45 18.36 16.85C19.39 15.5 20 13.83 20 12H22C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C15.14 2 17.95 3.45 19.78 5.72L21.5 4V9M12 20C13.9 20 15.64 19.34 17 18.24C16.36 17.23 14.45 16.5 12 16.5C9.55 16.5 7.64 17.23 7 18.24C8.36 19.34 10.1 20 12 20M12 6C13.93 6 15.5 7.57 15.5 9.5C15.5 11.43 13.93 13 12 13C10.07 13 8.5 11.43 8.5 9.5C8.5 7.57 10.07 6 12 6M12 8C11.17 8 10.5 8.67 10.5 9.5C10.5 10.33 11.17 11 12 11C12.83 11 13.5 10.33 13.5 9.5C13.5 8.67 12.83 8 12 8Z";
var mdiAccountRemove = "M15,14C17.67,14 23,15.33 23,18V20H7V18C7,15.33 12.33,14 15,14M15,12A4,4 0 0,1 11,8A4,4 0 0,1 15,4A4,4 0 0,1 19,8A4,4 0 0,1 15,12M5,9.59L7.12,7.46L8.54,8.88L6.41,11L8.54,13.12L7.12,14.54L5,12.41L2.88,14.54L1.46,13.12L3.59,11L1.46,8.88L2.88,7.46L5,9.59Z";
var mdiAccountRemoveOutline = "M1.46,8.88L2.88,7.46L5,9.59L7.12,7.46L8.54,8.88L6.41,11L8.54,13.12L7.12,14.54L5,12.41L2.88,14.54L1.46,13.12L3.59,11L1.46,8.88M15,4A4,4 0 0,1 19,8A4,4 0 0,1 15,12A4,4 0 0,1 11,8A4,4 0 0,1 15,4M15,5.9A2.1,2.1 0 0,0 12.9,8A2.1,2.1 0 0,0 15,10.1C16.16,10.1 17.1,9.16 17.1,8C17.1,6.84 16.16,5.9 15,5.9M15,13C17.67,13 23,14.33 23,17V20H7V17C7,14.33 12.33,13 15,13M15,14.9C12,14.9 8.9,16.36 8.9,17V18.1H21.1V17C21.1,16.36 17.97,14.9 15,14.9Z";
var mdiAccountSchool = "M16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8L8.11 7.06L5 5.5L12 2L19 5.5V10.5H18V6L15.89 7.06L16 8M12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z";
var mdiAccountSchoolOutline = "M18 10.5V6L15.89 7.06C15.96 7.36 16 7.67 16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8C8 7.67 8.04 7.36 8.11 7.06L5 5.5L12 2L19 5.5V10.5H18M12 9L10 8C10 9.1 10.9 10 12 10C13.1 10 14 9.1 14 8L12 9M14.75 5.42L12.16 4.1L9.47 5.47L12.07 6.79L14.75 5.42M12 13C14.67 13 20 14.33 20 17V20H4V17C4 14.33 9.33 13 12 13M12 14.9C9 14.9 5.9 16.36 5.9 17V18.1H18.1V17C18.1 16.36 14.97 14.9 12 14.9Z";
var mdiAccountSearch = "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14M10,4A4,4 0 0,1 14,8C14,8.91 13.69,9.75 13.18,10.43C12.32,10.75 11.55,11.26 10.91,11.9L10,12A4,4 0 0,1 6,8A4,4 0 0,1 10,4M2,20V18C2,15.88 5.31,14.14 9.5,14C9.18,14.78 9,15.62 9,16.5C9,17.79 9.38,19 10,20H2Z";
var mdiAccountSearchOutline = "M10,13C9.65,13.59 9.36,14.24 9.19,14.93C6.5,15.16 3.9,16.42 3.9,17V18.1H9.2C9.37,18.78 9.65,19.42 10,20H2V17C2,14.34 7.33,13 10,13M10,4A4,4 0 0,1 14,8C14,8.91 13.69,9.75 13.18,10.43C12.32,10.75 11.55,11.26 10.91,11.9L10,12A4,4 0 0,1 6,8A4,4 0 0,1 10,4M10,5.9A2.1,2.1 0 0,0 7.9,8A2.1,2.1 0 0,0 10,10.1A2.1,2.1 0 0,0 12.1,8A2.1,2.1 0 0,0 10,5.9M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14Z";
var mdiAccountSettings = "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z";
var mdiAccountSettingsOutline = "M12 4C14.21 4 16 5.79 16 8S14.21 12 12 12 8 10.21 8 8 9.79 4 12 4M12 6C10.9 6 10 6.9 10 8S10.9 10 12 10 14 9.11 14 8 13.11 6 12 6M12 13C14.67 13 20 14.33 20 17V20H4V17C4 14.33 9.33 13 12 13M12 14.9C9.03 14.9 5.9 16.36 5.9 17V18.1H18.1V17C18.1 16.36 14.97 14.9 12 14.9M13 22H11V24H13V22M17 22H15V24H17V22M9 22H7V24H9V22Z";
var mdiAccountStar = "M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12M5,13.28L7.45,14.77L6.8,11.96L9,10.08L6.11,9.83L5,7.19L3.87,9.83L1,10.08L3.18,11.96L2.5,14.77L5,13.28Z";
var mdiAccountStarOutline = "M15,4A4,4 0 0,1 19,8A4,4 0 0,1 15,12A4,4 0 0,1 11,8A4,4 0 0,1 15,4M15,5.9A2.1,2.1 0 0,0 12.9,8A2.1,2.1 0 0,0 15,10.1C16.16,10.1 17.1,9.16 17.1,8C17.1,6.84 16.16,5.9 15,5.9M15,13C17.67,13 23,14.33 23,17V20H7V17C7,14.33 12.33,13 15,13M15,14.9C12,14.9 8.9,16.36 8.9,17V18.1H21.1V17C21.1,16.36 17.97,14.9 15,14.9M5,13.28L2.5,14.77L3.18,11.96L1,10.08L3.87,9.83L5,7.19L6.11,9.83L9,10.08L6.8,11.96L7.45,14.77L5,13.28Z";
var mdiAccountSupervisor = "M16.5,12A2.5,2.5 0 0,0 19,9.5A2.5,2.5 0 0,0 16.5,7A2.5,2.5 0 0,0 14,9.5A2.5,2.5 0 0,0 16.5,12M9,11A3,3 0 0,0 12,8A3,3 0 0,0 9,5A3,3 0 0,0 6,8A3,3 0 0,0 9,11M16.5,14C14.67,14 11,14.92 11,16.75V19H22V16.75C22,14.92 18.33,14 16.5,14M9,13C6.67,13 2,14.17 2,16.5V19H9V16.75C9,15.9 9.33,14.41 11.37,13.28C10.5,13.1 9.66,13 9,13Z";
var mdiAccountSupervisorCircle = "M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M15.6,8.34C16.67,8.34 17.53,9.2 17.53,10.27C17.53,11.34 16.67,12.2 15.6,12.2A1.93,1.93 0 0,1 13.67,10.27C13.66,9.2 14.53,8.34 15.6,8.34M9.6,6.76C10.9,6.76 11.96,7.82 11.96,9.12C11.96,10.42 10.9,11.5 9.6,11.5C8.3,11.5 7.24,10.42 7.24,9.12C7.24,7.81 8.29,6.76 9.6,6.76M9.6,15.89V19.64C7.2,18.89 5.3,17.04 4.46,14.68C5.5,13.56 8.13,13 9.6,13C10.13,13 10.8,13.07 11.5,13.21C9.86,14.08 9.6,15.23 9.6,15.89M12,20C11.72,20 11.46,20 11.2,19.96V15.89C11.2,14.47 14.14,13.76 15.6,13.76C16.67,13.76 18.5,14.15 19.44,14.91C18.27,17.88 15.38,20 12,20Z";
var mdiAccountSupervisorCircleOutline = "M12.5 10C12.5 8.34 11.16 7 9.5 7C7.86 7 6.5 8.34 6.5 10C6.5 11.64 7.86 13 9.5 13C11.16 13 12.5 11.64 12.5 10M9.5 11C8.96 11 8.5 10.54 8.5 10C8.5 9.44 8.96 9 9.5 9C10.06 9 10.5 9.44 10.5 10C10.5 10.54 10.06 11 9.5 11M16 13C17.12 13 18 12.1 18 11C18 9.88 17.12 9 16 9C14.9 9 14 9.88 14 11C14 12.1 14.9 13 16 13M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2M5.85 17.11C6.53 16.57 8.12 16 9.5 16C9.58 16 9.66 16 9.74 16C10 15.37 10.41 14.72 11.04 14.15C10.5 14.05 9.95 14 9.5 14C8.21 14 6.12 14.44 4.78 15.42C4.28 14.38 4 13.22 4 12C4 7.58 7.59 4 12 4C16.41 4 20 7.58 20 12C20 13.19 19.73 14.33 19.25 15.36C18.25 14.77 16.89 14.5 16 14.5C14.5 14.5 11.5 15.3 11.5 17.19V19.97C9.24 19.84 7.22 18.76 5.85 17.11Z";
var mdiAccountSupervisorOutline = "M16.5 15.5C18.22 15.5 20.25 16.3 20.5 16.78V17.5H12.5V16.78C12.75 16.3 14.78 15.5 16.5 15.5M16.5 14C14.67 14 11 14.92 11 16.75V19H22V16.75C22 14.92 18.33 14 16.5 14M9 13C6.67 13 2 14.17 2 16.5V19H9V17.5H3.5V16.5C3.5 15.87 6.29 14.34 9.82 14.5A5.12 5.12 0 0 1 11.37 13.25A12.28 12.28 0 0 0 9 13M9 6.5A1.5 1.5 0 1 1 7.5 8A1.5 1.5 0 0 1 9 6.5M9 5A3 3 0 1 0 12 8A3 3 0 0 0 9 5M16.5 8.5A1 1 0 1 1 15.5 9.5A1 1 0 0 1 16.5 8.5M16.5 7A2.5 2.5 0 1 0 19 9.5A2.5 2.5 0 0 0 16.5 7Z";
var mdiAccountSwitch = "M16 9C22 9 22 13 22 13V15H16V13C16 13 16 11.31 14.85 9.8C14.68 9.57 14.47 9.35 14.25 9.14C14.77 9.06 15.34 9 16 9M2 13C2 13 2 9 8 9S14 13 14 13V15H2V13M9 17V19H15V17L18 20L15 23V21H9V23L6 20L9 17M8 1C6.34 1 5 2.34 5 4S6.34 7 8 7 11 5.66 11 4 9.66 1 8 1M16 1C14.34 1 13 2.34 13 4S14.34 7 16 7 19 5.66 19 4 17.66 1 16 1Z";
var mdiAccountSwitchOutline = "M16 9C22 9 22 13 22 13V15H16V13C16 13 16 11.31 14.85 9.8C14.68 9.57 14.47 9.35 14.25 9.14C14.77 9.06 15.34 9 16 9M8 11C11.5 11 11.94 12.56 12 13H4C4.06 12.56 4.5 11 8 11M8 9C2 9 2 13 2 13V15H14V13C14 13 14 9 8 9M9 17V19H15V17L18 20L15 23V21H9V23L6 20L9 17M8 3C8.55 3 9 3.45 9 4S8.55 5 8 5 7 4.55 7 4 7.45 3 8 3M8 1C6.34 1 5 2.34 5 4S6.34 7 8 7 11 5.66 11 4 9.66 1 8 1M16 1C14.34 1 13 2.34 13 4S14.34 7 16 7 19 5.66 19 4 17.66 1 16 1Z";
var mdiAccountSync = "M11 4C8.8 4 7 5.8 7 8S8.8 12 11 12 15 10.2 15 8 13.2 4 11 4M11 14C6.6 14 3 15.8 3 18V20H12.5C12.2 19.2 12 18.4 12 17.5C12 16.3 12.3 15.2 12.9 14.1C12.3 14.1 11.7 14 11 14M18 20C16.6 20 15.5 18.9 15.5 17.5C15.5 17.1 15.6 16.7 15.8 16.4L14.7 15.3C14.3 15.9 14 16.7 14 17.5C14 19.7 15.8 21.5 18 21.5V23L20.2 20.8L18 18.5V20M18 13.5V12L15.8 14.2L18 16.4V15C19.4 15 20.5 16.1 20.5 17.5C20.5 17.9 20.4 18.3 20.2 18.6L21.3 19.7C21.7 19.1 22 18.3 22 17.5C22 15.3 20.2 13.5 18 13.5Z";
var mdiAccountSyncOutline = "M11 4C8.8 4 7 5.8 7 8S8.8 12 11 12 15 10.2 15 8 13.2 4 11 4M11 6C12.1 6 13 6.9 13 8S12.1 10 11 10 9 9.1 9 8 9.9 6 11 6M11 13C8.3 13 3 14.3 3 17V20H12.5C12.2 19.4 12.1 18.8 12 18.1H4.9V17C4.9 16.4 8 14.9 11 14.9C11.5 14.9 12 15 12.5 15C12.8 14.4 13.1 13.8 13.6 13.3C12.6 13.1 11.7 13 11 13M18 20C16.6 20 15.5 18.9 15.5 17.5C15.5 17.1 15.6 16.7 15.8 16.4L14.7 15.3C14.3 15.9 14 16.7 14 17.5C14 19.7 15.8 21.5 18 21.5V23L20.2 20.8L18 18.5V20M18 13.5V12L15.8 14.2L18 16.4V15C19.4 15 20.5 16.1 20.5 17.5C20.5 17.9 20.4 18.3 20.2 18.6L21.3 19.7C21.7 19.1 22 18.3 22 17.5C22 15.3 20.2 13.5 18 13.5Z";
var mdiAccountTag = "M21.8 17.8L18.2 14.2C18 14.1 17.8 14 17.6 14H14.8C14.4 14 14 14.4 14 14.8V17.6C14 17.8 14.1 18 14.2 18.2L17.8 21.8C17.9 21.9 18.1 22 18.4 22C18.6 22 18.8 21.9 19 21.8L21.8 19C21.9 18.9 22 18.7 22 18.4C22 18.2 21.9 18 21.8 17.8M15.4 16C15.1 16 14.8 15.7 14.8 15.4C14.8 15.1 15.1 14.8 15.4 14.8C15.7 14.8 16 15.1 16 15.4C16 15.7 15.7 16 15.4 16M10 4C7.8 4 6 5.8 6 8S7.8 12 10 12 14 10.2 14 8 12.2 4 10 4M10 14C5.6 14 2 15.8 2 18V20H13.2L12.8 19.6C12.3 19.1 12 18.4 12 17.6V14.8C12 14.6 12 14.4 12.1 14.1C11.4 14 10.7 14 10 14Z";
var mdiAccountTagOutline = "M15.4 16C15.1 16 14.8 15.7 14.8 15.4C14.8 15.1 15.1 14.8 15.4 14.8C15.7 14.8 16 15.1 16 15.4C16 15.7 15.7 16 15.4 16M21.8 17.8L18.2 14.2C18 14.1 17.8 14 17.6 14H14.8C14.4 14 14 14.4 14 14.8V17.6C14 17.8 14.1 18 14.2 18.2L17.8 21.8C17.9 21.9 18.1 22 18.4 22S18.8 21.9 19 21.8L21.8 19C21.9 18.9 22 18.7 22 18.4C22 18.2 21.9 18 21.8 17.8M10 4C7.8 4 6 5.8 6 8S7.8 12 10 12 14 10.2 14 8 12.2 4 10 4M10 6C11.1 6 12 6.9 12 8S11.1 10 10 10 8 9.1 8 8 8.9 6 10 6M10 13C7.3 13 2 14.3 2 17V20H13.2L12.8 19.6C12.4 19.2 12.1 18.7 12 18.1H3.9V17C3.9 16.4 7 14.9 10 14.9C10.7 14.9 11.4 15 12 15.1V14.8C12 14.2 12.2 13.7 12.5 13.3C11.6 13.1 10.7 13 10 13Z";
var mdiAccountTie = "M12 3C14.21 3 16 4.79 16 7S14.21 11 12 11 8 9.21 8 7 9.79 3 12 3M16 13.54C16 14.6 15.72 17.07 13.81 19.83L13 15L13.94 13.12C13.32 13.05 12.67 13 12 13S10.68 13.05 10.06 13.12L11 15L10.19 19.83C8.28 17.07 8 14.6 8 13.54C5.61 14.24 4 15.5 4 17V21H20V17C20 15.5 18.4 14.24 16 13.54Z";
var mdiAccountTieHat = "M16 14.5C16 15.6 15.7 18 13.8 20.8L13 16L13.9 14.1C13.3 14.1 12.7 14 12 14S10.7 14.1 10.1 14.1L11 16L10.2 20.8C8.3 18.1 8 15.6 8 14.5C5.6 15.2 4 16.5 4 18V22H20V18C20 16.5 18.4 15.2 16 14.5M6 4.5C6 3.1 8.7 2 12 2S18 3.1 18 4.5C18 4.9 17.8 5.2 17.5 5.5C16.6 4.6 14.5 4 12 4S7.4 4.6 6.5 5.5C6.2 5.2 6 4.9 6 4.5M15.9 7.4C16 7.6 16 7.8 16 8C16 10.2 14.2 12 12 12S8 10.2 8 8C8 7.8 8 7.6 8.1 7.4C9.1 7.8 10.5 8 12 8S14.9 7.8 15.9 7.4M16.6 6.1C15.5 6.6 13.9 7 12 7S8.5 6.6 7.4 6.1C8.1 5.5 9.8 5 12 5S15.9 5.5 16.6 6.1Z";
var mdiAccountTieHatOutline = "M6 4.5C6 3.1 8.7 2 12 2S18 3.1 18 4.5C18 4.9 17.8 5.2 17.5 5.5C16.6 4.6 14.5 4 12 4S7.4 4.6 6.5 5.5C6.2 5.2 6 4.9 6 4.5M12 5C9.8 5 8.1 5.5 7.4 6.1C8.5 6.6 10.1 7 12 7S15.5 6.6 16.6 6.1C15.9 5.5 14.2 5 12 5M14 8C14 9.1 13.1 10 12 10S10 9.1 10 8V7.9C9.3 7.8 8.6 7.7 8 7.5V8C8 10.2 9.8 12 12 12S16 10.2 16 8C16 7.8 16 7.6 15.9 7.4C15.3 7.6 14.6 7.7 13.9 7.8C14 7.9 14 7.9 14 8M16.4 13.8L15.7 15L15.5 15.5C17 16 18.1 16.6 18.1 17V20.1H13.9L13 15L13.9 13.1C13.3 13.1 12.7 13 12 13S10.7 13 10.1 13.1L11 15L10.1 20.1H5.9V17C5.9 16.6 7 16 8.5 15.5L8.3 15L7.7 13.8C5.7 14.4 4 15.5 4 17V22H20V17C20 15.5 18.3 14.4 16.4 13.8Z";
var mdiAccountTieOutline = "M16.36 12.76C18.31 13.42 20 14.5 20 16V21H4V16C4 14.5 5.69 13.42 7.65 12.76L8.27 14L8.5 14.5C7 14.96 5.9 15.62 5.9 16V19.1H10.12L11 14.03L10.06 12.15C10.68 12.08 11.33 12.03 12 12.03C12.67 12.03 13.32 12.08 13.94 12.15L13 14.03L13.88 19.1H18.1V16C18.1 15.62 17 14.96 15.5 14.5L15.73 14L16.36 12.76M12 5C10.9 5 10 5.9 10 7C10 8.1 10.9 9 12 9C13.1 9 14 8.1 14 7C14 5.9 13.1 5 12 5M12 11C9.79 11 8 9.21 8 7C8 4.79 9.79 3 12 3C14.21 3 16 4.79 16 7C16 9.21 14.21 11 12 11Z";
var mdiAccountTieVoice = "M16.75 4.36C18.77 6.56 18.77 9.61 16.75 11.63L15.07 9.94C15.91 8.76 15.91 7.23 15.07 6.05L16.75 4.36M20.06 1C24 5.05 23.96 11.11 20.06 15L18.43 13.37C21.2 10.19 21.2 5.65 18.43 2.63L20.06 1M9 4C11.2 4 13 5.79 13 8S11.2 12 9 12 5 10.21 5 8 6.79 4 9 4M13 14.54C13 15.6 12.71 18.07 10.8 20.83L10 16L10.93 14.12C10.31 14.05 9.66 14 9 14S7.67 14.05 7.05 14.12L8 16L7.18 20.83C5.27 18.07 5 15.6 5 14.54C2.6 15.24 .994 16.5 .994 18V22H17V18C17 16.5 15.39 15.24 13 14.54Z";
var mdiAccountTieVoiceOff = "M12.7 9.5L7.5 4.3C7.96 4.11 8.46 4 9 4C11.2 4 13 5.79 13 8C13 8.53 12.89 9.04 12.7 9.5M16.75 11.63C18.77 9.61 18.77 6.56 16.75 4.36L15.07 6.05C15.91 7.23 15.91 8.76 15.07 9.94L16.75 11.63M20.06 15C23.96 11.11 24 5.05 20.06 1L18.43 2.63C21.2 5.65 21.2 10.19 18.43 13.37L20.06 15M2.39 1.73L1.11 3L5.13 7C5.05 7.34 5 7.66 5 8C5 10.21 6.79 12 9 12C9.33 12 9.66 11.94 9.97 11.86L13 14.87C12.93 16.06 12.54 18.32 10.8 20.83L10 16L10.93 14.12C10.31 14.05 9.66 14 9 14C8.32 14 7.67 14.05 7.05 14.12L8 16L7.18 20.83C5.27 18.07 5 15.6 5 14.54C2.6 15.24 .994 16.5 .994 18V22H17V18.88L20.84 22.73L22.11 21.46L2.39 1.73Z";
var mdiAccountTieVoiceOffOutline = "M9.22 6L7.5 4.3C7.96 4.11 8.47 4 9 4C11.21 4 13 5.79 13 8C13 8.53 12.89 9.04 12.7 9.5L11 7.78C10.87 6.86 10.14 6.13 9.22 6M20.06 15C23.96 11.11 24 5.05 20.06 1L18.43 2.63C21.2 5.65 21.2 10.19 18.43 13.37L20.06 15M16.75 11.63C18.77 9.61 18.77 6.56 16.75 4.36L15.07 6.05C15.91 7.23 15.91 8.76 15.07 9.94L16.75 11.63M2.39 1.73L1.11 3L5.14 7.03C5.06 7.34 5 7.66 5 8C5 10.21 6.79 12 9 12C9.34 12 9.66 11.94 9.97 11.86L12.86 14.75L12.73 15L12.5 15.5C13.3 15.74 13.97 16.05 14.44 16.33L15.1 17V20.1H10.88L10 15.03L10.94 13.15C10.32 13.08 9.67 13.03 9 13.03S7.68 13.08 7.06 13.15L8 15.03L7.12 20.1H2.9V17C2.9 16.62 4 15.96 5.5 15.5L5.27 15L4.65 13.76C2.69 14.42 1 15.5 1 17V22H17V18.89L20.84 22.73L22.11 21.46L2.39 1.73Z";
var mdiAccountTieVoiceOutline = "M16.75 4.36C18.77 6.56 18.77 9.61 16.75 11.63L15.07 9.94C15.91 8.76 15.91 7.23 15.07 6.05L16.75 4.36M20.06 1C24 5.05 23.96 11.11 20.06 15L18.43 13.37C21.2 10.19 21.2 5.65 18.43 2.63L20.06 1M13.36 13.76C15.31 14.42 17 15.5 17 17V22H1V17C1 15.5 2.69 14.42 4.65 13.76L5.27 15L5.5 15.5C4 15.96 2.9 16.62 2.9 17V20.1H7.12L8 15.03L7.06 13.15C7.68 13.08 8.33 13.03 9 13.03S10.32 13.08 10.94 13.15L10 15.03L10.88 20.1H15.1V17C15.1 16.62 14 15.96 12.5 15.5L12.73 15L13.36 13.76M9 6C7.9 6 7 6.9 7 8S7.9 10 9 10 11 9.1 11 8 10.1 6 9 6M9 12C6.79 12 5 10.21 5 8S6.79 4 9 4 13 5.79 13 8 11.21 12 9 12Z";
var mdiAccountTieWoman = "M11.94 3C9.75 3.03 8 4.81 8 7C7.94 8.64 7.81 10.47 7.03 11.59C9.71 13.22 12 13 12 13C12 13 14.29 13.22 16.97 11.59C16.12 10.22 15.94 8.54 16 7C16 4.79 14.21 3 12 3H11.94M8.86 13.32C6 13.93 4 15.35 4 17V21H12L9 17H6.5M12 21L13.78 13.81C13.78 13.81 13 14 12 14C11 14 10.22 13.81 10.22 13.81M12 21H20V17C20 15.35 18 13.93 15.14 13.32L17.5 17H15Z";
var mdiAccountVoice = "M9,5A4,4 0 0,1 13,9A4,4 0 0,1 9,13A4,4 0 0,1 5,9A4,4 0 0,1 9,5M9,15C11.67,15 17,16.34 17,19V21H1V19C1,16.34 6.33,15 9,15M16.76,5.36C18.78,7.56 18.78,10.61 16.76,12.63L15.08,10.94C15.92,9.76 15.92,8.23 15.08,7.05L16.76,5.36M20.07,2C24,6.05 23.97,12.11 20.07,16L18.44,14.37C21.21,11.19 21.21,6.65 18.44,3.63L20.07,2Z";
var mdiAccountVoiceOff = "M2,3.27L3.28,2L22,20.72L20.73,22L16.73,18C16.9,18.31 17,18.64 17,19V21H1V19C1,16.34 6.33,15 9,15C10.77,15 13.72,15.59 15.5,16.77L11.12,12.39C10.5,12.78 9.78,13 9,13A4,4 0 0,1 5,9C5,8.22 5.22,7.5 5.61,6.88L2,3.27M9,5A4,4 0 0,1 13,9V9.17L8.83,5H9M16.76,5.36C18.78,7.56 18.78,10.61 16.76,12.63L15.08,10.94C15.92,9.76 15.92,8.23 15.08,7.05L16.76,5.36M20.07,2C24,6.05 23.97,12.11 20.07,16L18.44,14.37C21.21,11.19 21.21,6.65 18.44,3.63L20.07,2Z";
var mdiAccountWrench = "M22.9 21.2L18.8 17.1C19.2 16.1 19 14.8 18.1 14C17.2 13.1 15.9 12.9 14.8 13.4L16.7 15.3L15.3 16.7L13.3 14.7C12.8 15.8 13 17.1 13.9 18.1C14.8 19 16 19.2 17 18.8L21.1 22.9C21.3 23.1 21.6 23.1 21.7 22.9L22.7 21.9C23 21.6 23 21.3 22.9 21.2M13 20H2V18C2 15.8 5.6 14 10 14C10.5 14 11 14 11.4 14.1C11.1 14.7 11 15.3 11 16C11 17.6 11.8 19.1 13 20M10 4C7.8 4 6 5.8 6 8S7.8 12 10 12 14 10.2 14 8 12.2 4 10 4";
var mdiAccountWrenchOutline = "M22.9 21.2L18.8 17.1C19.2 16.1 19 14.8 18.1 14C17.2 13.1 15.9 12.9 14.8 13.4L16.7 15.3L15.3 16.7L13.3 14.7C12.8 15.8 13 17.1 13.9 18.1C14.8 19 16 19.2 17 18.8L21.1 22.9C21.3 23.1 21.6 23.1 21.7 22.9L22.7 21.9C23 21.6 23 21.3 22.9 21.2M10 12C12.2 12 14 10.2 14 8S12.2 4 10 4 6 5.8 6 8 7.8 12 10 12M10 6C11.1 6 12 6.9 12 8S11.1 10 10 10 8 9.1 8 8 8.9 6 10 6M13 20H2V17C2 14.3 7.3 13 10 13C10.5 13 11.2 13.1 11.9 13.2C11.5 13.7 11.3 14.3 11.1 15C10.7 15 10.4 14.9 10 14.9C7 14.9 3.9 16.4 3.9 17V18.1H11.5C11.8 18.9 12.4 19.5 13 20Z";
var mdiAdjust = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9A3,3 0 0,1 15,12Z";
var mdiAdvertisements = "M19 7C17.9 7 17 7.9 17 9V11C17 12.1 17.9 13 19 13H21V15H17V17H21C22.1 17 23 16.1 23 15V13C23 11.9 22.1 11 21 11H19V9H23V7H19M9 7V17H13C14.1 17 15 16.1 15 15V9C15 7.9 14.1 7 13 7H9M11 9H13V15H11V9M3 7C1.9 7 1 7.9 1 9V17H3V13H5V17H7V9C7 7.9 6.1 7 5 7H3M3 9H5V11H3V9Z";
var mdiAdvertisementsOff = "M12.2 9L10.2 7H13C14.1 7 15 7.9 15 9V11.8L13 9.8V9H12.2M23 9V7H19C17.9 7 17 7.9 17 9V11C17 12.1 17.9 13 19 13H21V15H18.2L20.2 17H21C22.1 17 23 16.1 23 15V13C23 11.9 22.1 11 21 11H19V9H23M22.1 21.5L20.8 22.8L14.4 16.4C14.1 16.7 13.6 17 13 17H9V10.9L7 8.9V17H5V13H3V17H1V9C1 7.9 1.9 7 3 7H5.1L1.1 3L2.4 1.7L22.1 21.5M5 9H3V11H5V9M13 14.9L11 12.9V15H13V14.9Z";
var mdiAirConditioner = "M6.59,0.66C8.93,-1.15 11.47,1.06 12.04,4.5C12.47,4.5 12.89,4.62 13.27,4.84C13.79,4.24 14.25,3.42 14.07,2.5C13.65,0.35 16.06,-1.39 18.35,1.58C20.16,3.92 17.95,6.46 14.5,7.03C14.5,7.46 14.39,7.89 14.16,8.27C14.76,8.78 15.58,9.24 16.5,9.06C18.63,8.64 20.38,11.04 17.41,13.34C15.07,15.15 12.53,12.94 11.96,9.5C11.53,9.5 11.11,9.37 10.74,9.15C10.22,9.75 9.75,10.58 9.93,11.5C10.35,13.64 7.94,15.39 5.65,12.42C3.83,10.07 6.05,7.53 9.5,6.97C9.5,6.54 9.63,6.12 9.85,5.74C9.25,5.23 8.43,4.76 7.5,4.94C5.37,5.36 3.62,2.96 6.59,0.66M5,16H7A2,2 0 0,1 9,18V24H7V22H5V24H3V18A2,2 0 0,1 5,16M5,18V20H7V18H5M12.93,16H15L12.07,24H10L12.93,16M18,16H21V18H18V22H21V24H18A2,2 0 0,1 16,22V18A2,2 0 0,1 18,16Z";
var mdiAirFilter = "M19,18.31V20A2,2 0 0,1 17,22H7A2,2 0 0,1 5,20V16.3C4.54,16.12 3.95,16 3,16A1,1 0 0,1 2,15A1,1 0 0,1 3,14C3.82,14 4.47,14.08 5,14.21V12.3C4.54,12.12 3.95,12 3,12A1,1 0 0,1 2,11A1,1 0 0,1 3,10C3.82,10 4.47,10.08 5,10.21V8.3C4.54,8.12 3.95,8 3,8A1,1 0 0,1 2,7A1,1 0 0,1 3,6C3.82,6 4.47,6.08 5,6.21V4A2,2 0 0,1 7,2H17A2,2 0 0,1 19,4V6.16C20.78,6.47 21.54,7.13 21.71,7.29C22.1,7.68 22.1,8.32 21.71,8.71C21.32,9.1 20.8,9.09 20.29,8.71V8.71C20.29,8.71 19.25,8 17,8C15.74,8 14.91,8.41 13.95,8.9C12.91,9.41 11.74,10 10,10C9.64,10 9.31,10 9,9.96V7.95C9.3,8 9.63,8 10,8C11.26,8 12.09,7.59 13.05,7.11C14.09,6.59 15.27,6 17,6V4H7V20H17V18C18.5,18 18.97,18.29 19,18.31M17,10C15.27,10 14.09,10.59 13.05,11.11C12.09,11.59 11.26,12 10,12C9.63,12 9.3,12 9,11.95V13.96C9.31,14 9.64,14 10,14C11.74,14 12.91,13.41 13.95,12.9C14.91,12.42 15.74,12 17,12C19.25,12 20.29,12.71 20.29,12.71V12.71C20.8,13.1 21.32,13.1 21.71,12.71C22.1,12.32 22.1,11.69 21.71,11.29C21.5,11.08 20.25,10 17,10M17,14C15.27,14 14.09,14.59 13.05,15.11C12.09,15.59 11.26,16 10,16C9.63,16 9.3,16 9,15.95V17.96C9.31,18 9.64,18 10,18C11.74,18 12.91,17.41 13.95,16.9C14.91,16.42 15.74,16 17,16C19.25,16 20.29,16.71 20.29,16.71V16.71C20.8,17.1 21.32,17.1 21.71,16.71C22.1,16.32 22.1,15.69 21.71,15.29C21.5,15.08 20.25,14 17,14Z";
var mdiAirHorn = "M19,2.8V6L19,9.2C19,9.5 18.7,9.8 18.4,9.7C18.4,9.7 14.5,7.1 10,7.1V9.5H10.2C10.7,9.5 11.2,9.7 11.4,10.1L12.7,11.9C12.9,12.1 13,12.4 13,12.6V20.6C13,21.3 12.3,22 11.5,22H6.5C5.7,22 5,21.4 5,20.6V12.6C5,12.3 5.1,12.1 5.3,11.9L6.6,10.1C6.9,9.7 7.3,9.5 7.8,9.5H8V8C7.6,8.5 7,8.8 6.4,8.8C5.1,8.8 4,7.5 4,6C4,4.5 5.1,3.2 6.4,3.2C7,3.3 7.6,3.6 8,4V2.6H10V5C14.5,5 18.4,2.4 18.4,2.4C18.7,2.3 19,2.5 19,2.8Z";
var mdiAirHumidifier = "M11 9C8.79 9 7 10.79 7 13S8.79 17 11 17 15 15.21 15 13 13.21 9 11 9M11 15C9.9 15 9 14.11 9 13S9.9 11 11 11 13 11.9 13 13 12.11 15 11 15M7 4H14C16.21 4 18 5.79 18 8V9H16V8C16 6.9 15.11 6 14 6H7C5.9 6 5 6.9 5 8V20H16V18H18V22H3V8C3 5.79 4.79 4 7 4M19 10.5C19 10.5 21 12.67 21 14C21 15.1 20.1 16 19 16S17 15.1 17 14C17 12.67 19 10.5 19 10.5";
var mdiAirHumidifierOff = "M22.1 21.5L2.4 1.7L1.1 3L3.8 5.7C3.3 6.3 3 7.1 3 8V22H18V19.9L20.8 22.7L22.1 21.5M9.6 11.5L12.4 14.3C12.1 14.7 11.6 15 11 15C9.9 15 9 14.1 9 13C9 12.4 9.3 11.9 9.6 11.5M16 17.9V20H5V8C5 7.7 5.1 7.4 5.2 7.1L8.2 10.1C7.5 10.8 7 11.9 7 13C7 15.2 8.8 17 11 17C12.1 17 13.2 16.5 13.9 15.8L16 17.9M17 13.8C17.1 12.5 19 10.5 19 10.5S21 12.7 21 14C21 15 20.2 15.9 19.2 16L17 13.8M9.2 6L7.2 4H14C16.2 4 18 5.8 18 8V9H16V8C16 6.9 15.1 6 14 6H9.2Z";
var mdiAirPurifier = "M11,9A4,4 0 0,1 15,13A4,4 0 0,1 11,17A4,4 0 0,1 7,13A4,4 0 0,1 11,9M11,11A2,2 0 0,0 9,13A2,2 0 0,0 11,15A2,2 0 0,0 13,13A2,2 0 0,0 11,11M7,4H14A4,4 0 0,1 18,8V9H16V8A2,2 0 0,0 14,6H7A2,2 0 0,0 5,8V20H16V18H18V22H3V8A4,4 0 0,1 7,4M16,11C18.5,11 18.5,9 21,9V11C18.5,11 18.5,13 16,13V11M16,15C18.5,15 18.5,13 21,13V15C18.5,15 18.5,17 16,17V15Z";
var mdiAirPurifierOff = "M21 11C18.6 11 18.5 12.9 16.2 13L16 12.8V11C18.5 11 18.5 9 21 9V11M22.1 21.5L20.8 22.8L18 19.9V22H3V8C3 7.1 3.3 6.3 3.8 5.7L1.1 3L2.4 1.7L22.1 21.5M9 13C9 14.1 9.9 15 11 15C11.6 15 12.1 14.7 12.5 14.4L9.7 11.6C9.3 11.9 9 12.4 9 13M16 17.9L13.9 15.8C13.2 16.5 12.1 17 11 17C8.8 17 7 15.2 7 13C7 11.9 7.5 10.8 8.2 10.1L5.2 7.1C5.1 7.4 5 7.7 5 8V20H16V17.9M21 15V13C19.3 13 18.7 14 17.7 14.5L18.8 15.6C19.4 15.3 20 15 21 15M14 6C15.1 6 16 6.9 16 8V9H18V8C18 5.8 16.2 4 14 4H7.2L9.2 6H14Z";
var mdiAirbag = "M14,8A5,5 0 0,1 9,13A5,5 0 0,1 4,8A5,5 0 0,1 9,3A5,5 0 0,1 14,8M10.46,15.55L13,18.03L11,18.05L7.5,21.58L6,20.09L10.46,15.55M17,2C18.08,2 19,2.88 19,4C19,5.08 18.12,6 17,6C15.92,6 15,5.12 15,4C15,2.92 15.89,2 17,2M14.41,15H11.59L17.29,20.71L18.71,19.29L14.41,15M15.12,14.29L19.41,18.59L19.63,18.8C19.86,18.42 20,18 20,17.5V9.5A2.5,2.5 0 0,0 17.5,7A2.5,2.5 0 0,0 15,9.5V14.17L15.12,14.29Z";
var mdiAirballoon = "M11,23A2,2 0 0,1 9,21V19H15V21A2,2 0 0,1 13,23H11M12,1C12.71,1 13.39,1.09 14.05,1.26C15.22,2.83 16,5.71 16,9C16,11.28 15.62,13.37 15,16A2,2 0 0,1 13,18H11A2,2 0 0,1 9,16C8.38,13.37 8,11.28 8,9C8,5.71 8.78,2.83 9.95,1.26C10.61,1.09 11.29,1 12,1M20,8C20,11.18 18.15,15.92 15.46,17.21C16.41,15.39 17,11.83 17,9C17,6.17 16.41,3.61 15.46,1.79C18.15,3.08 20,4.82 20,8M4,8C4,4.82 5.85,3.08 8.54,1.79C7.59,3.61 7,6.17 7,9C7,11.83 7.59,15.39 8.54,17.21C5.85,15.92 4,11.18 4,8Z";
var mdiAirballoonOutline = "M11 23C9.9 23 9 22.1 9 21V19H15V21C15 22.1 14.1 23 13 23H11M12 3C12.28 3 12.55 3 12.81 3.05C13.42 4.22 14 6.26 14 9C14 11.1 13 16 13 16H11C11 16 10 11.1 10 9C10 6.26 10.58 4.22 11.19 3.05C11.45 3 11.72 3 12 3M12 1C11.29 1 10.61 1.09 9.95 1.26C8.78 2.83 8 5.71 8 9C8 11.28 8.38 13.37 9 16C9 17.1 9.9 18 11 18H13C14.1 18 15 17.1 15 16C15.62 13.37 16 11.28 16 9C16 5.71 15.22 2.83 14.05 1.26C13.39 1.09 12.71 1 12 1M4 8C4 11.18 5.85 15.92 8.54 17.21C8 16.21 7.61 14.67 7.34 13C6.55 11.53 6 9.62 6 8C6 6.66 6.44 5.67 7.47 4.8C7.73 3.67 8.09 2.65 8.54 1.79C5.85 3.08 4 4.82 4 8M15.46 1.79C15.91 2.65 16.27 3.67 16.53 4.8C17.56 5.67 18 6.66 18 8C18 9.62 17.45 11.53 16.66 13C16.39 14.67 16 16.21 15.46 17.21C18.15 15.92 20 11.18 20 8S18.15 3.08 15.46 1.79Z";
var mdiAirplane = "M20.56 3.91C21.15 4.5 21.15 5.45 20.56 6.03L16.67 9.92L18.79 19.11L17.38 20.53L13.5 13.1L9.6 17L9.96 19.47L8.89 20.53L7.13 17.35L3.94 15.58L5 14.5L7.5 14.87L11.37 11L3.94 7.09L5.36 5.68L14.55 7.8L18.44 3.91C19 3.33 20 3.33 20.56 3.91Z";
var mdiAirplaneAlert = "M17.56 3.91C18.15 4.5 18.15 5.45 17.56 6.03L13.67 9.92L15.79 19.11L14.38 20.53L10.5 13.1L6.6 17L6.96 19.47L5.89 20.53L4.13 17.35L.944 15.58L2 14.5L4.5 14.87L8.37 11L.944 7.09L2.36 5.68L11.55 7.8L15.44 3.91C16 3.33 17 3.33 17.56 3.91M20 7V13H22V7H20M20 17H22V15H20V17Z";
var mdiAirplaneCheck = "M15.97 13.83C15.08 14.35 14.34 15.09 13.82 16L11.55 11.63L7.66 15.5L8 18L6.95 19.06L5.18 15.87L2 14.11L3.06 13.05L5.54 13.4L9.43 9.5L2 5.62L3.41 4.21L12.61 6.33L16.5 2.44C17.08 1.85 18.03 1.85 18.62 2.44C19.2 3.03 19.2 4 18.62 4.56L14.73 8.45L15.97 13.83M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiAirplaneClock = "M16 9C15.09 9 14.23 9.18 13.43 9.5L12.73 6.45L16.62 2.56C17.2 2 17.2 1.03 16.62 .44S15.08-.146 14.5 .44L10.61 4.33L1.41 2.21L0 3.62L7.43 7.5L3.54 11.4L1.06 11.05L0 12.11L3.18 13.87L4.95 17.06L6 16L5.66 13.5L9.55 9.63L10.57 11.59C9.59 12.79 9 14.33 9 16C9 19.87 12.13 23 16 23S23 19.87 23 16 19.87 9 16 9M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21M16.5 16.25V12H15V17L18.61 19.16L19.36 17.94L16.5 16.25Z";
var mdiAirplaneCog = "M15.73 12.81C14.76 13.33 13.92 14.07 13.29 14.96L11.55 11.63L7.66 15.5L8 18L6.95 19.06L5.18 15.87L2 14.11L3.06 13.05L5.54 13.4L9.43 9.5L2 5.62L3.41 4.21L12.61 6.33L16.5 2.44C17.08 1.85 18.03 1.85 18.62 2.44C19.2 3.03 19.2 4 18.62 4.56L14.73 8.45L15.73 12.81M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiAirplaneEdit = "M11.55 11.63L7.66 15.5L8 18L6.95 19.06L5.18 15.87L2 14.11L3.06 13.05L5.54 13.4L9.43 9.5L2 5.62L3.41 4.21L12.61 6.33L16.5 2.44C17.08 1.85 18.03 1.85 18.62 2.44C19.2 3.03 19.2 4 18.62 4.56L14.73 8.45L16.03 14.1L13.94 16.19L11.55 11.63M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47Z";
var mdiAirplaneLanding = "M2.5,19H21.5V21H2.5V19M9.68,13.27L14.03,14.43L19.34,15.85C20.14,16.06 20.96,15.59 21.18,14.79C21.39,14 20.92,13.17 20.12,12.95L14.81,11.53L12.05,2.5L10.12,2V10.28L5.15,8.95L4.22,6.63L2.77,6.24V11.41L4.37,11.84L9.68,13.27Z";
var mdiAirplaneMarker = "M15.33 11.05C14.17 11.88 13.34 13.14 13.09 14.58L11.55 11.63L7.66 15.5L8 18L6.95 19.06L5.18 15.87L2 14.11L3.06 13.05L5.54 13.4L9.43 9.5L2 5.62L3.41 4.21L12.61 6.33L16.5 2.44C17.08 1.85 18.03 1.85 18.62 2.44C19.2 3.03 19.2 4 18.62 4.56L14.73 8.45L15.33 11.05M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6";
var mdiAirplaneMinus = "M15.97 13.83C15.08 14.35 14.34 15.09 13.82 16L11.55 11.63L7.66 15.5L8 18L6.95 19.06L5.18 15.87L2 14.11L3.06 13.05L5.54 13.4L9.43 9.5L2 5.62L3.41 4.21L12.61 6.33L16.5 2.44C17.08 1.85 18.03 1.85 18.62 2.44C19.2 3.03 19.2 4 18.62 4.56L14.73 8.45L15.97 13.83M15 18V20H23V18H15Z";
var mdiAirplaneOff = "M20.84 22.73L18 19.9L17.38 20.53L16 17.89L12.35 14.24L9.6 17L9.96 19.47L8.89 20.53L7.13 17.35L3.94 15.58L5 14.5L7.5 14.87L10.23 12.12L6.59 8.5L3.94 7.09L4.57 6.46L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M16.67 9.92L20.56 6.03C21.15 5.45 21.15 4.5 20.56 3.91S19 3.33 18.44 3.91L14.55 7.8L9.94 6.74L17.74 14.54L16.67 9.92Z";
var mdiAirplanePlus = "M15.97 13.83C15.08 14.35 14.34 15.09 13.82 16L11.55 11.63L7.66 15.5L8 18L6.95 19.06L5.18 15.87L2 14.11L3.06 13.05L5.54 13.4L9.43 9.5L2 5.62L3.41 4.21L12.61 6.33L16.5 2.44C17.08 1.85 18.03 1.85 18.62 2.44C19.2 3.03 19.2 4 18.62 4.56L14.73 8.45L15.97 13.83M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiAirplaneRemove = "M15.97 13.83C15.08 14.35 14.34 15.09 13.82 16L11.55 11.63L7.66 15.5L8 18L6.95 19.06L5.18 15.87L2 14.11L3.06 13.05L5.54 13.4L9.43 9.5L2 5.62L3.41 4.21L12.61 6.33L16.5 2.44C17.08 1.85 18.03 1.85 18.62 2.44C19.2 3.03 19.2 4 18.62 4.56L14.73 8.45L15.97 13.83M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiAirplaneSearch = "M9.55 9.63L10.9 12.22C11.5 11.17 12.41 10.31 13.5 9.74L12.73 6.45L16.62 2.56C17.2 1.97 17.2 1 16.62 .438S15.08-.148 14.5 .438L10.61 4.33L1.41 2.21L0 3.62L7.43 7.5L3.54 11.4L1.06 11.05L0 12.11L3.18 13.87L4.95 17.06L6 16L5.66 13.5L9.55 9.63M16.5 11C19 11 21 13 21 15.5C21 16.38 20.75 17.21 20.31 17.9L23.39 21L22 22.39L18.88 19.32C18.19 19.75 17.37 20 16.5 20C14 20 12 18 12 15.5S14 11 16.5 11M16.5 13C15.12 13 14 14.12 14 15.5S15.12 18 16.5 18 19 16.88 19 15.5 17.88 13 16.5 13";
var mdiAirplaneSettings = "M20.09 4.56L16.2 8.45L18.32 17.64L16.91 19.06L13 11.63L9.13 15.5L9.5 18L8.42 19.06L6.65 15.87L3.47 14.11L4.53 13.04L7 13.4L10.9 9.5L3.47 5.62L4.89 4.21L14.08 6.33L17.97 2.44C18.55 1.85 19.5 1.85 20.09 2.44C20.68 3 20.68 3.97 20.09 4.56M7 24H9V22H7V24M11 24H13V22H11V24M15 24H17V22H15V24Z";
var mdiAirplaneTakeoff = "M2.5,19H21.5V21H2.5V19M22.07,9.64C21.86,8.84 21.03,8.36 20.23,8.58L14.92,10L8,3.57L6.09,4.08L10.23,11.25L5.26,12.58L3.29,11.04L1.84,11.43L3.66,14.59L4.43,15.92L6.03,15.5L11.34,14.07L15.69,12.91L21,11.5C21.81,11.26 22.28,10.44 22.07,9.64Z";
var mdiAirport = "M14.97,5.92C14.83,5.41 14.3,5.1 13.79,5.24L10.39,6.15L5.95,2.03L4.72,2.36L7.38,6.95L4.19,7.8L2.93,6.82L2,7.07L3.66,9.95L14.28,7.11C14.8,6.96 15.1,6.43 14.97,5.92M21,10L20,12H15L14,10L15,9H17V7H18V9H20L21,10M22,20V22H2V20H15V13H20V20H22Z";
var mdiAlarm = "M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22A9,9 0 0,0 21,13A9,9 0 0,0 12,4M12.5,8H11V14L15.75,16.85L16.5,15.62L12.5,13.25V8M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72Z";
var mdiAlarmBell = "M15,18.66V22H5V18.66C8.09,20.45 11.91,20.45 15,18.66M22,4A2,2 0 0,0 20,2C19.69,2 19.39,2.07 19.12,2.21C18.82,2.36 18.56,2.58 18.36,2.85C17.72,3.75 17.94,5 18.85,5.64C19.18,5.87 19.59,6 20,6C20.08,6 20.16,6 20.24,6C21.97,10.43 20.66,15.46 17,18.5C16.68,18.75 16.35,19 16,19.22V21H17V19.74C20.14,17.5 22,13.86 22,10C22,8.5 21.72,7 21.17,5.62C21.69,5.24 22,4.64 22,4M18,10A8,8 0 0,1 10,18A8,8 0 0,1 2,10A8,8 0 0,1 10,2A8,8 0 0,1 18,10Z";
var mdiAlarmCheck = "M10.54,14.53L8.41,12.4L7.35,13.46L10.53,16.64L16.53,10.64L15.47,9.58L10.54,14.53M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22A9,9 0 0,0 21,13A9,9 0 0,0 12,4M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72Z";
var mdiAlarmLight = "M6,6.9L3.87,4.78L5.28,3.37L7.4,5.5L6,6.9M13,1V4H11V1H13M20.13,4.78L18,6.9L16.6,5.5L18.72,3.37L20.13,4.78M4.5,10.5V12.5H1.5V10.5H4.5M19.5,10.5H22.5V12.5H19.5V10.5M6,20H18A2,2 0 0,1 20,22H4A2,2 0 0,1 6,20M12,5A6,6 0 0,1 18,11V19H6V11A6,6 0 0,1 12,5Z";
var mdiAlarmLightOff = "M18 14.8L9 5.8C9.9 5.3 10.9 5 12 5C15.3 5 18 7.7 18 11V14.8M20.1 4.8L18.7 3.4L16.6 5.5L18 6.9L20.1 4.8M19.5 10.5V12.5H22.5V10.5H19.5M4.5 10.5H1.5V12.5H4.5V10.5M1.1 3L6.6 8.5C6.2 9.2 6 10.1 6 11V19H17.1L18.1 20H6C4.9 20 4 20.9 4 22H20.1L20.8 22.7L22.1 21.4L2.4 1.7L1.1 3M13 1H11V4H13V1Z";
var mdiAlarmLightOffOutline = "M10.5 7.3L9 5.8C9.9 5.3 10.9 5 12 5C15.3 5 18 7.7 18 11V14.8L16 12.8V11C16 8.8 14.2 7 12 7C11.5 7 11 7.1 10.5 7.3M20.1 4.8L18.7 3.4L16.6 5.5L18 6.9L20.1 4.8M19.5 10.5V12.5H22.5V10.5H19.5M4.5 10.5H1.5V12.5H4.5V10.5M2.4 1.7L22.1 21.4L20.8 22.7L20.1 22H4C4 20.9 4.9 20 6 20H18.1L17.1 19H6V11C6 10.1 6.2 9.2 6.6 8.5L1.1 3L2.4 1.7M8 17H15.1L8.1 10C8.1 10.3 8 10.7 8 11V17M13 1H11V4H13V1Z";
var mdiAlarmLightOutline = "M6,6.9L3.87,4.78L5.28,3.37L7.4,5.5L6,6.9M13,1V4H11V1H13M20.13,4.78L18,6.9L16.6,5.5L18.72,3.37L20.13,4.78M4.5,10.5V12.5H1.5V10.5H4.5M19.5,10.5H22.5V12.5H19.5V10.5M6,20H18A2,2 0 0,1 20,22H4A2,2 0 0,1 6,20M12,5A6,6 0 0,1 18,11V19H6V11A6,6 0 0,1 12,5M12,7A4,4 0 0,0 8,11V17H16V11A4,4 0 0,0 12,7Z";
var mdiAlarmMultiple = "M9.29,3.25L5.16,6.72L4,5.34L8.14,1.87L9.29,3.25M22,5.35L20.84,6.73L16.7,3.25L17.86,1.87L22,5.35M13,4A8,8 0 0,1 21,12A8,8 0 0,1 13,20A8,8 0 0,1 5,12A8,8 0 0,1 13,4M13,6A6,6 0 0,0 7,12A6,6 0 0,0 13,18A6,6 0 0,0 19,12A6,6 0 0,0 13,6M12,7.5H13.5V12.03L16.72,13.5L16.1,14.86L12,13V7.5M1,14C1,11.5 2.13,9.3 3.91,7.83C3.33,9.1 3,10.5 3,12L3.06,13.13L3,14C3,16.28 4.27,18.26 6.14,19.28C7.44,20.5 9.07,21.39 10.89,21.78C10.28,21.92 9.65,22 9,22A8,8 0 0,1 1,14Z";
var mdiAlarmNote = "M17.4,1.86L16.11,3.39L20.71,7.25L22,5.72L17.4,1.86M6.6,1.86L2,5.71L3.29,7.24L7.88,3.39L6.6,1.86M12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22C12.33,22 12.67,22 13,21.94V19.94C12.67,20 12.33,20 12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6C15.1,6 17.83,8.03 18.71,11H20.78C19.85,6.9 16.2,4 12,4M23,15H20V20.5A2.5,2.5 0 0,1 17.5,23A2.5,2.5 0 0,1 15,20.5A2.5,2.5 0 0,1 17.5,18C18.04,18 18.57,18.18 19,18.5V13H23V15M11.5,8V13.25L7.5,15.62L8.25,16.85L13,14V8H11.5Z";
var mdiAlarmNoteOff = "M19,13V15.8L20,16.8V15H23V13H19M2.38,1.73L1.11,3L3,4.88L2,5.71L3.29,7.24L4.41,6.3L5.21,7.1C1.95,10.85 2.35,16.54 6.11,19.8C7.74,21.22 9.83,22 12,22C12.33,22 12.67,22 13,21.94V19.94C12.67,20 12.33,20 12,20A7,7 0 0,1 5,13C5,11.36 5.57,9.77 6.63,8.5L11.41,13.3L7.5,15.62L8.25,16.85L12.44,14.33L16.38,18.27C15.14,18.88 14.64,20.38 15.25,21.62C15.86,22.86 17.36,23.36 18.6,22.75C19.09,22.5 19.5,22.11 19.73,21.62L20.84,22.73L22.11,21.46L2.38,1.73M12,6C15.1,6 17.83,8.03 18.71,11H20.78C19.85,6.9 16.2,4 12,4C10.65,4 9.31,4.3 8.1,4.9L9.62,6.42C10.38,6.14 11.19,6 12,6M11.5,8.3L13,9.8V8H11.5V8.3M7.88,3.39L6.6,1.86L5.76,2.56L7.18,4L7.88,3.39M17.4,1.86L16.11,3.39L20.71,7.25L22,5.72L17.4,1.86Z";
var mdiAlarmOff = "M8,3.28L6.6,1.86L5.74,2.57L7.16,4M16.47,18.39C15.26,19.39 13.7,20 12,20A7,7 0 0,1 5,13C5,11.3 5.61,9.74 6.61,8.53M2.92,2.29L1.65,3.57L3,4.9L1.87,5.83L3.29,7.25L4.4,6.31L5.2,7.11C3.83,8.69 3,10.75 3,13A9,9 0 0,0 12,22C14.25,22 16.31,21.17 17.89,19.8L20.09,22L21.36,20.73L3.89,3.27L2.92,2.29M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72M12,6A7,7 0 0,1 19,13C19,13.84 18.84,14.65 18.57,15.4L20.09,16.92C20.67,15.73 21,14.41 21,13A9,9 0 0,0 12,4C10.59,4 9.27,4.33 8.08,4.91L9.6,6.43C10.35,6.16 11.16,6 12,6Z";
var mdiAlarmPanel = "M20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3M8 19H5V17H8V19M8 16H5V14H8V16M8 13H5V11H8V13M13.5 19H10.5V17H13.5V19M13.5 16H10.5V14H13.5V16M13.5 13H10.5V11H13.5V13M19 19H16V17H19V19M19 16H16V14H19V16M19 13H16V11H19V13M19 9H5V5H19V9Z";
var mdiAlarmPanelOutline = "M9 12H6V10H9V12M13.5 10H10.5V12H13.5V10M18 10H15V12H18V10M18 6H6V9H18V6M20 5H4L4 19L20 19L20 5L20 5M20 3C21.1 3 22 3.9 22 5V19C22 20.1 21.1 21 20 21H4C2.9 21 2 20.1 2 19V5C2 3.9 2.9 3 4 3H20M9 13H6V15H9V13M13.5 13H10.5V15H13.5V13M18 13H15V15H18V13M9 16H6V18H9V16M13.5 16H10.5V18H13.5V16M18 16H15V18H18V16Z";
var mdiAlarmPlus = "M13,9H11V12H8V14H11V17H13V14H16V12H13M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22A9,9 0 0,0 21,13A9,9 0 0,0 12,4M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39Z";
var mdiAlarmSnooze = "M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72M12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22A9,9 0 0,0 21,13A9,9 0 0,0 12,4M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M9,11H12.63L9,15.2V17H15V15H11.37L15,10.8V9H9V11Z";
var mdiAlbum = "M12,11A1,1 0 0,0 11,12A1,1 0 0,0 12,13A1,1 0 0,0 13,12A1,1 0 0,0 12,11M12,16.5C9.5,16.5 7.5,14.5 7.5,12C7.5,9.5 9.5,7.5 12,7.5C14.5,7.5 16.5,9.5 16.5,12C16.5,14.5 14.5,16.5 12,16.5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiAlert = "M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z";
var mdiAlertBox = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M13,13V7H11V13H13M13,17V15H11V17H13Z";
var mdiAlertBoxOutline = "M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M11,15H13V17H11V15M11,7H13V13H11V7";
var mdiAlertCircle = "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiAlertCircleCheck = "M18.75 22.16L16 19.16L17.16 18L18.75 19.59L22.34 16L23.5 17.41L18.75 22.16M13 13V7H11V13H13M13 17V15H11V17H13M12 2C17.5 2 22 6.5 22 12L21.91 13.31C21.31 13.11 20.67 13 20 13C16.69 13 14 15.69 14 19C14 19.95 14.22 20.85 14.62 21.65C13.78 21.88 12.91 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2Z";
var mdiAlertCircleCheckOutline = "M18.75 22.16L16 19.16L17.16 18L18.75 19.59L22.34 16L23.5 17.41L18.75 22.16M11 15H13V17H11V15M11 7H13V13H11V7M12 2C17.5 2 22 6.5 22 12L21.92 13.31C21.31 13.11 20.67 13 19.94 13L20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C12.71 20 13.39 19.91 14.05 19.74C14.13 20.42 14.33 21.06 14.62 21.65C13.78 21.88 12.9 22 12 22C6.47 22 2 17.5 2 12C2 6.5 6.47 2 12 2Z";
var mdiAlertCircleOutline = "M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z";
var mdiAlertDecagram = "M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M13,17H11V15H13V17M13,13H11V7H13V13Z";
var mdiAlertDecagramOutline = "M23,12L20.56,14.78L20.9,18.46L17.29,19.28L15.4,22.46L12,21L8.6,22.47L6.71,19.29L3.1,18.47L3.44,14.78L1,12L3.44,9.21L3.1,5.53L6.71,4.72L8.6,1.54L12,3L15.4,1.54L17.29,4.72L20.9,5.54L20.56,9.22L23,12M20.33,12L18.5,9.89L18.74,7.1L16,6.5L14.58,4.07L12,5.18L9.42,4.07L8,6.5L5.26,7.09L5.5,9.88L3.67,12L5.5,14.1L5.26,16.9L8,17.5L9.42,19.93L12,18.81L14.58,19.92L16,17.5L18.74,16.89L18.5,14.1L20.33,12M11,15H13V17H11V15M11,7H13V13H11V7";
var mdiAlertMinus = "M14 19C14 16.21 15.91 13.87 18.5 13.2L12 2L1 21H14.35C14.13 20.37 14 19.7 14 19M13 18H11V16H13V18M13 14H11V10H13V14M24 18V20H16V18H24Z";
var mdiAlertMinusOutline = "M11 15.5H13V17.5H11V15.5M14 19C14 18.86 14 18.73 14 18.6H5.4L12 7.3L16.11 14.44C16.62 14 17.2 13.65 17.84 13.41L12 3.3L2 20.6H14.22C14.08 20.09 14 19.56 14 19M13 10.5H11V14.5H13V10.5M16 18V20H24V18H16Z";
var mdiAlertOctagon = "M13 13H11V7H13M11 15H13V17H11M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3Z";
var mdiAlertOctagonOutline = "M8.27,3L3,8.27V15.73L8.27,21H15.73C17.5,19.24 21,15.73 21,15.73V8.27L15.73,3M9.1,5H14.9L19,9.1V14.9L14.9,19H9.1L5,14.9V9.1M11,15H13V17H11V15M11,7H13V13H11V7";
var mdiAlertOctagram = "M2.2,16.06L3.88,12L2.2,7.94L6.26,6.26L7.94,2.2L12,3.88L16.06,2.2L17.74,6.26L21.8,7.94L20.12,12L21.8,16.06L17.74,17.74L16.06,21.8L12,20.12L7.94,21.8L6.26,17.74L2.2,16.06M13,17V15H11V17H13M13,13V7H11V13H13Z";
var mdiAlertOctagramOutline = "M2.2,16.06L3.88,12L2.2,7.94L6.26,6.26L7.94,2.2L12,3.88L16.06,2.2L17.74,6.26L21.8,7.94L20.12,12L21.8,16.06L17.74,17.74L16.06,21.8L12,20.12L7.94,21.8L6.26,17.74L2.2,16.06M4.81,9L6.05,12L4.81,15L7.79,16.21L9,19.19L12,17.95L15,19.19L16.21,16.21L19.19,15L17.95,12L19.19,9L16.21,7.79L15,4.81L12,6.05L9,4.81L7.79,7.79L4.81,9M11,15H13V17H11V15M11,7H13V13H11V7";
var mdiAlertOutline = "M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16";
var mdiAlertPlus = "M14 19C14 16.21 15.91 13.87 18.5 13.2L12 2L1 21H14.35C14.13 20.37 14 19.7 14 19M13 18H11V16H13V18M13 14H11V10H13V14M21 15V18H24V20H21V23H19V20H16V18H19V15H21Z";
var mdiAlertPlusOutline = "M11 15.5H13V17.5H11V15.5M14 19C14 18.86 14 18.73 14 18.6H5.4L12 7.3L16.11 14.44C16.62 14 17.2 13.65 17.84 13.41L12 3.3L2 20.6H14.22C14.08 20.09 14 19.56 14 19M13 10.5H11V14.5H13V10.5M19 15V18H16V20H19V23H21V20H24V18H21V15H19Z";
var mdiAlertRemove = "M14 19C14 16.21 15.91 13.87 18.5 13.2L12 2L1 21H14.35C14.13 20.37 14 19.7 14 19M13 18H11V16H13V18M13 14H11V10H13V14M23.54 16.88L21.41 19L23.54 21.12L22.12 22.54L20 20.41L17.88 22.54L16.47 21.12L18.59 19L16.47 16.88L17.88 15.47L20 17.59L22.12 15.46L23.54 16.88Z";
var mdiAlertRemoveOutline = "M11 15.5H13V17.5H11V15.5M14 19C14 18.86 14 18.73 14 18.6H5.4L12 7.3L16.11 14.44C16.62 14 17.2 13.65 17.84 13.41L12 3.3L2 20.6H14.22C14.08 20.09 14 19.56 14 19M13 10.5H11V14.5H13V10.5M22.12 15.46L20 17.59L17.88 15.46L16.47 16.88L18.59 19L16.47 21.12L17.88 22.54L20 20.41L22.12 22.54L23.54 21.12L21.41 19L23.54 16.88L22.12 15.46Z";
var mdiAlertRhombus = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M11 7H13V13H11V7M11 15H13V17H11V15Z";
var mdiAlertRhombusOutline = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M12 4L20 12L12 20L4 12M11 7V13H13V7M11 15V17H13V15Z";
var mdiAlien = "M12,3C16.97,3 21,6.58 21,11C21,15.42 15,21 12,21C9,21 3,15.42 3,11C3,6.58 7.03,3 12,3M10.31,10.93C9.29,9.29 7.47,8.58 6.25,9.34C5.03,10.1 4.87,12.05 5.89,13.69C6.92,15.33 8.74,16.04 9.96,15.28C11.18,14.5 11.33,12.57 10.31,10.93M13.69,10.93C12.67,12.57 12.82,14.5 14.04,15.28C15.26,16.04 17.08,15.33 18.11,13.69C19.13,12.05 18.97,10.1 17.75,9.34C16.53,8.58 14.71,9.29 13.69,10.93M12,17.75C10,17.75 9.5,17 9.5,17C9.5,17.03 10,19 12,19C14,19 14.5,17 14.5,17C14.5,17 14,17.75 12,17.75Z";
var mdiAlienOutline = "M10.31 10.93C11.33 12.57 11.18 14.5 9.96 15.28C8.74 16.04 6.92 15.33 5.89 13.69C4.87 12.05 5.03 10.1 6.25 9.34C7.47 8.58 9.29 9.29 10.31 10.93M12 17.75C14 17.75 14.5 17 14.5 17C14.5 17 14 19 12 19C10 19 9.5 17.03 9.5 17C9.5 17 10 17.75 12 17.75M17.75 9.34C18.97 10.1 19.13 12.05 18.11 13.69C17.08 15.33 15.26 16.04 14.04 15.28C12.82 14.5 12.67 12.57 13.69 10.93C14.71 9.29 16.53 8.58 17.75 9.34M12 20C14.5 20 20 14.86 20 11C20 7.14 16.41 4 12 4C7.59 4 4 7.14 4 11C4 14.86 9.5 20 12 20M12 2C17.5 2 22 6.04 22 11C22 15.08 16.32 22 12 22C7.68 22 2 15.08 2 11C2 6.04 6.5 2 12 2Z";
var mdiAlignHorizontalCenter = "M11 2H13V7H21V10H13V14H18V17H13V22H11V17H6V14H11V10H3V7H11V2Z";
var mdiAlignHorizontalDistribute = "M4 22H2V2H4V22M22 2H20V22H22V2M13.5 7H10.5V17H13.5V7Z";
var mdiAlignHorizontalLeft = "M4 22H2V2H4V22M22 7H6V10H22V7M16 14H6V17H16V14Z";
var mdiAlignHorizontalRight = "M20 2H22V22H20V2M2 10H18V7H2V10M8 17H18V14H8V17Z";
var mdiAlignVerticalBottom = "M22 22H2V20H22V22M10 2H7V18H10V2M17 8H14V18H17V8Z";
var mdiAlignVerticalCenter = "M22 11H17V6H14V11H10V3H7V11H1.8V13H7V21H10V13H14V18H17V13H22V11Z";
var mdiAlignVerticalDistribute = "M22 2V4H2V2H22M7 10.5V13.5H17V10.5H7M2 20V22H22V20H2Z";
var mdiAlignVerticalTop = "M22 2V4H2V2H22M7 22H10V6H7V22M14 16H17V6H14V16Z";
var mdiAllInclusive = "M18.6,6.62C17.16,6.62 15.8,7.18 14.83,8.15L7.8,14.39C7.16,15.03 6.31,15.38 5.4,15.38C3.53,15.38 2,13.87 2,12C2,10.13 3.53,8.62 5.4,8.62C6.31,8.62 7.16,8.97 7.84,9.65L8.97,10.65L10.5,9.31L9.22,8.2C8.2,7.18 6.84,6.62 5.4,6.62C2.42,6.62 0,9.04 0,12C0,14.96 2.42,17.38 5.4,17.38C6.84,17.38 8.2,16.82 9.17,15.85L16.2,9.61C16.84,8.97 17.69,8.62 18.6,8.62C20.47,8.62 22,10.13 22,12C22,13.87 20.47,15.38 18.6,15.38C17.7,15.38 16.84,15.03 16.16,14.35L15,13.34L13.5,14.68L14.78,15.8C15.8,16.81 17.15,17.37 18.6,17.37C21.58,17.37 24,14.96 24,12C24,9 21.58,6.62 18.6,6.62Z";
var mdiAllInclusiveBox = "M19 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.1 3 19 3M16.1 15.9C15.07 15.9 14.09 15.5 13.35 14.76L12.71 14.12L14.13 12.71L14.76 13.34C15.12 13.7 15.6 13.9 16.11 13.9C17.15 13.9 18 13.05 18 12S17.15 10.1 16.1 10.1C15.6 10.1 15.12 10.3 14.76 10.66L10.65 14.76C9.91 15.5 8.94 15.9 7.9 15.9C5.75 15.9 4 14.15 4 12S5.75 8.1 7.9 8.1C8.94 8.1 9.91 8.5 10.65 9.24L11.29 9.88L9.87 11.3L9.24 10.66C8.88 10.3 8.4 10.1 7.9 10.1C6.85 10.1 6 10.95 6 12S6.85 13.9 7.9 13.9C8.4 13.9 8.88 13.7 9.24 13.34L13.35 9.24C14.09 8.5 15.06 8.1 16.1 8.1C18.25 8.1 20 9.85 20 12S18.25 15.9 16.1 15.9Z";
var mdiAllInclusiveBoxOutline = "M19 12C19 13.84 17.5 15.34 15.66 15.34C14.77 15.34 13.94 15 13.31 14.36L12.71 13.76L13.77 12.71C14.04 13 14.37 13.3 14.37 13.3C14.71 13.65 15.18 13.84 15.67 13.84C16.68 13.84 17.5 13 17.5 12S16.68 10.16 15.67 10.16C15.18 10.16 14.71 10.36 14.37 10.7L10.7 14.36C10.07 15 9.23 15.34 8.34 15.34C6.5 15.34 5 13.84 5 12S6.5 8.66 8.34 8.66C9.23 8.66 10.07 9 10.7 9.64L11.29 10.24L10.23 11.3L9.64 10.7C9.29 10.36 8.83 10.16 8.34 10.16C7.32 10.16 6.5 11 6.5 12S7.32 13.84 8.34 13.84C8.83 13.84 9.29 13.65 9.64 13.3L13.31 9.64C13.94 9 14.77 8.66 15.66 8.66C17.5 8.66 19 10.16 19 12M21 5V19C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.89 3.89 3 5 3H19C20.1 3 21 3.89 21 5M19 5H5V19H19V5Z";
var mdiAllergy = "M19.75 5.33A1.25 1.25 0 0 0 18.5 6.58V11.17H17.67V4.08A1.25 1.25 0 0 0 15.17 4.08V11.17H14.33V3.25A1.25 1.25 0 1 0 11.83 3.25V11.17H11V5.33A1.25 1.25 0 0 0 8.5 5.33V15.26L4.91 13.26A1 1 0 0 0 4.41 13.12A1 1 0 0 0 3.75 13.37L2.67 14.37L9.21 21A3.29 3.29 0 0 0 11.58 22H17.67A3.33 3.33 0 0 0 21 18.67V6.58A1.25 1.25 0 0 0 19.75 5.33M11 15A1 1 0 1 1 12 14A1 1 0 0 1 11 15M13 18A1 1 0 1 1 14 17A1 1 0 0 1 13 18M18 16A1 1 0 1 1 19 15A1 1 0 0 1 18 16M17 19A1 1 0 1 1 18 18A1 1 0 0 1 17 19M15 15A1 1 0 1 1 16 14A1 1 0 0 1 15 15Z";
var mdiAlpha = "M18.08,17.8C17.62,17.93 17.21,18 16.85,18C15.65,18 14.84,17.12 14.43,15.35H14.38C13.39,17.26 12,18.21 10.25,18.21C8.94,18.21 7.89,17.72 7.1,16.73C6.31,15.74 5.92,14.5 5.92,13C5.92,11.25 6.37,9.85 7.26,8.76C8.15,7.67 9.36,7.12 10.89,7.12C11.71,7.12 12.45,7.35 13.09,7.8C13.73,8.26 14.22,8.9 14.56,9.73H14.6L15.31,7.33H17.87L15.73,12.65C15.97,13.89 16.22,14.74 16.5,15.19C16.74,15.64 17.08,15.87 17.5,15.87C17.74,15.87 17.93,15.83 18.1,15.76L18.08,17.8M13.82,12.56C13.61,11.43 13.27,10.55 12.81,9.95C12.36,9.34 11.81,9.04 11.18,9.04C10.36,9.04 9.7,9.41 9.21,10.14C8.72,10.88 8.5,11.79 8.5,12.86C8.5,13.84 8.69,14.65 9.12,15.31C9.54,15.97 10.11,16.29 10.82,16.29C11.42,16.29 11.97,16 12.46,15.45C12.96,14.88 13.37,14.05 13.7,12.96L13.82,12.56Z";
var mdiAlphaA = "M11,7A2,2 0 0,0 9,9V17H11V13H13V17H15V9A2,2 0 0,0 13,7H11M11,9H13V11H11V9Z";
var mdiAlphaABox = "M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M11,7A2,2 0 0,0 9,9V17H11V13H13V17H15V9A2,2 0 0,0 13,7H11M11,9H13V11H11V9Z";
var mdiAlphaABoxOutline = "M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M5,5V19H19V5H5M11,7H13A2,2 0 0,1 15,9V17H13V13H11V17H9V9A2,2 0 0,1 11,7M11,9V11H13V9H11Z";
var mdiAlphaACircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,7A2,2 0 0,0 9,9V17H11V13H13V17H15V9A2,2 0 0,0 13,7H11M11,9H13V11H11V9Z";
var mdiAlphaACircleOutline = "M11,7H13A2,2 0 0,1 15,9V17H13V13H11V17H9V9A2,2 0 0,1 11,7M11,9V11H13V9H11M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaB = "M15,10.5V9A2,2 0 0,0 13,7H9V17H13A2,2 0 0,0 15,15V13.5C15,12.7 14.3,12 13.5,12C14.3,12 15,11.3 15,10.5M13,15H11V13H13V15M13,11H11V9H13V11Z";
var mdiAlphaBBox = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M15,10.5V9A2,2 0 0,0 13,7H9V17H13A2,2 0 0,0 15,15V13.5C15,12.7 14.3,12 13.5,12C14.3,12 15,11.3 15,10.5M13,15H11V13H13V15M13,11H11V9H13V11Z";
var mdiAlphaBBoxOutline = "M15,10.5C15,11.3 14.3,12 13.5,12C14.3,12 15,12.7 15,13.5V15A2,2 0 0,1 13,17H9V7H13A2,2 0 0,1 15,9V10.5M13,15V13H11V15H13M13,11V9H11V11H13M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M5,5V19H19V5H5Z";
var mdiAlphaBCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M15,10.5V9A2,2 0 0,0 13,7H9V17H13A2,2 0 0,0 15,15V13.5C15,12.7 14.3,12 13.5,12C14.3,12 15,11.3 15,10.5M13,15H11V13H13V15M13,11H11V9H13V11Z";
var mdiAlphaBCircleOutline = "M15,10.5C15,11.3 14.3,12 13.5,12C14.3,12 15,12.7 15,13.5V15A2,2 0 0,1 13,17H9V7H13A2,2 0 0,1 15,9V10.5M13,15V13H11V15H13M13,11V9H11V11H13M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaC = "M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V14H13V15H11V9H13V10H15V9A2,2 0 0,0 13,7H11Z";
var mdiAlphaCBox = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V14H13V15H11V9H13V10H15V9A2,2 0 0,0 13,7H11Z";
var mdiAlphaCBoxOutline = "M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M5,5V19H19V5H5M11,7H13A2,2 0 0,1 15,9V10H13V9H11V15H13V14H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7Z";
var mdiAlphaCCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V14H13V15H11V9H13V10H15V9A2,2 0 0,0 13,7H11Z";
var mdiAlphaCCircleOutline = "M11,7H13A2,2 0 0,1 15,9V10H13V9H11V15H13V14H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaD = "M9,7V17H13A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H9M11,9H13V15H11V9Z";
var mdiAlphaDBox = "M9,7V17H13A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H9M11,9H13V15H11V9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaDBoxOutline = "M9,7H13A2,2 0 0,1 15,9V15A2,2 0 0,1 13,17H9V7M11,9V15H13V9H11M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M5,5V19H19V5H5Z";
var mdiAlphaDCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M9,7V17H13A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H9M11,9H13V15H11V9Z";
var mdiAlphaDCircleOutline = "M9,7H13A2,2 0 0,1 15,9V15A2,2 0 0,1 13,17H9V7M11,9V15H13V9H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaE = "M9,7V17H15V15H11V13H15V11H11V9H15V7H9Z";
var mdiAlphaEBox = "M9,7V17H15V15H11V13H15V11H11V9H15V7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaEBoxOutline = "M9,7H15V9H11V11H15V13H11V15H15V17H9V7M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M5,5V19H19V5H5Z";
var mdiAlphaECircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M9,7V17H15V15H11V13H15V11H11V9H15V7H9Z";
var mdiAlphaECircleOutline = "M9,7H15V9H11V11H15V13H11V15H15V17H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaF = "M9,7V17H11V13H14V11H11V9H15V7H9Z";
var mdiAlphaFBox = "M9,7V17H11V13H14V11H11V9H15V7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaFBoxOutline = "M9,7H15V9H11V11H14V13H11V17H9V7M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M5,5V19H19V5H5Z";
var mdiAlphaFCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M9,7V17H11V13H14V11H11V9H15V7H9Z";
var mdiAlphaFCircleOutline = "M9,7H15V9H11V11H14V13H11V17H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaG = "M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V11H13V15H11V9H15V7H11Z";
var mdiAlphaGBox = "M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V11H13V15H11V9H15V7H11M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaGBoxOutline = "M11,7H15V9H11V15H13V11H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M5,5V19H19V5H5Z";
var mdiAlphaGCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V11H13V15H11V9H15V7H11Z";
var mdiAlphaGCircleOutline = "M11,7H15V9H11V15H13V11H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaH = "M9,7V17H11V13H13V17H15V7H13V11H11V7H9Z";
var mdiAlphaHBox = "M9,7V17H11V13H13V17H15V7H13V11H11V7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaHBoxOutline = "M9,7H11V11H13V7H15V17H13V13H11V17H9V7M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M5,5V19H19V5H5Z";
var mdiAlphaHCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M9,7V17H11V13H13V17H15V7H13V11H11V7H9Z";
var mdiAlphaHCircleOutline = "M9,7H11V11H13V7H15V17H13V13H11V17H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaI = "M14,7V9H13V15H14V17H10V15H11V9H10V7H14Z";
var mdiAlphaIBox = "M14,7H10V9H11V15H10V17H14V15H13V9H14V7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaIBoxOutline = "M14,7V9H13V15H14V17H10V15H11V9H10V7H14M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaICircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M14,7H10V9H11V15H10V17H14V15H13V9H14V7Z";
var mdiAlphaICircleOutline = "M14,7V9H13V15H14V17H10V15H11V9H10V7H14M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaJ = "M13,7V15H11V14H9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V7H13Z";
var mdiAlphaJBox = "M13,7V15H11V14H9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V7H13M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaJBoxOutline = "M13,7H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V14H11V15H13V7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaJCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M13,7V15H11V14H9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V7H13Z";
var mdiAlphaJCircleOutline = "M13,7H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V14H11V15H13V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaK = "M9,7V17H11V13.67L13,17H15L12,12L15,7H13L11,10.33V7H9Z";
var mdiAlphaKBox = "M9,7V17H11V13.67L13,17H15L12,12L15,7H13L11,10.33V7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaKBoxOutline = "M9,7H11V10.33L13,7H15L12,12L15,17H13L11,13.67V17H9V7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaKCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M9,7V17H11V13.67L13,17H15L12,12L15,7H13L11,10.33V7H9Z";
var mdiAlphaKCircleOutline = "M9,7H11V10.33L13,7H15L12,12L15,17H13L11,13.67V17H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaL = "M9,7V17H15V15H11V7H9Z";
var mdiAlphaLBox = "M9,7V17H15V15H11V7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaLBoxOutline = "M9,7H11V15H15V17H9V7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaLCircle = "M9,7V17H15V15H11V7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaLCircleOutline = "M9,7H11V15H15V17H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaM = "M9,7A2,2 0 0,0 7,9V17H9V9H11V16H13V9H15V17H17V9A2,2 0 0,0 15,7H9Z";
var mdiAlphaMBox = "M9,7A2,2 0 0,0 7,9V17H9V9H11V16H13V9H15V17H17V9A2,2 0 0,0 15,7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaMBoxOutline = "M9,7H15A2,2 0 0,1 17,9V17H15V9H13V16H11V9H9V17H7V9A2,2 0 0,1 9,7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaMCircle = "M9,7A2,2 0 0,0 7,9V17H9V9H11V16H13V9H15V17H17V9A2,2 0 0,0 15,7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaMCircleOutline = "M9,7H15A2,2 0 0,1 17,9V17H15V9H13V16H11V9H9V17H7V9A2,2 0 0,1 9,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaN = "M9,7V17H11V12L13,17H15V7H13V12L11,7H9Z";
var mdiAlphaNBox = "M9,7V17H11V12L13,17H15V7H13V12L11,7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaNBoxOutline = "M9,7H11L13,12V7H15V17H13L11,12V17H9V7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaNCircle = "M9,7V17H11V12L13,17H15V7H13V12L11,7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaNCircleOutline = "M9,7H11L13,12V7H15V17H13L11,12V17H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaO = "M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11M11,9H13V15H11V9Z";
var mdiAlphaOBox = "M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11M11,9H13V15H11V9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaOBoxOutline = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5M11,7H13A2,2 0 0,1 15,9V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M11,9V15H13V9H11Z";
var mdiAlphaOCircle = "M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11M11,9H13V15H11V9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaOCircleOutline = "M11,7H13A2,2 0 0,1 15,9V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M11,9V15H13V9H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaP = "M9,7V17H11V13H13A2,2 0 0,0 15,11V9A2,2 0 0,0 13,7H9M11,9H13V11H11V9Z";
var mdiAlphaPBox = "M9,7V17H11V13H13A2,2 0 0,0 15,11V9A2,2 0 0,0 13,7H9M11,9H13V11H11V9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaPBoxOutline = "M9,7H13A2,2 0 0,1 15,9V11A2,2 0 0,1 13,13H11V17H9V7M11,9V11H13V9H11M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaPCircle = "M9,7V17H11V13H13A2,2 0 0,0 15,11V9A2,2 0 0,0 13,7H9M11,9H13V11H11V9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaPCircleOutline = "M9,7H13A2,2 0 0,1 15,9V11A2,2 0 0,1 13,13H11V17H9V7M11,9V11H13V9H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaQ = "M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17V19H13V17A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11M11,9H13V15H11V9Z";
var mdiAlphaQBox = "M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17V19H13V17A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11M11,9H13V15H11V9M5,4H19A2,2 0 0,1 21,6V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V6A2,2 0 0,1 5,4Z";
var mdiAlphaQBoxOutline = "M5,4H19A2,2 0 0,1 21,6V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V6A2,2 0 0,1 5,4M5,6V20H19V6H5M11,7H13A2,2 0 0,1 15,9V15A2,2 0 0,1 13,17V19H11V17A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M11,9V15H13V9H11Z";
var mdiAlphaQCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17V19H13V17A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11M11,9H13V15H11V9Z";
var mdiAlphaQCircleOutline = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M11,7H13A2,2 0 0,1 15,9V15A2,2 0 0,1 13,17V19H11V17A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M11,9V15H13V9H11Z";
var mdiAlphaR = "M9,7V17H11V13H11.8L13,17H15L13.76,12.85C14.5,12.55 15,11.84 15,11V9A2,2 0 0,0 13,7H9M11,9H13V11H11V9Z";
var mdiAlphaRBox = "M9,7V17H11V13H11.8L13,17H15L13.76,12.85C14.5,12.55 15,11.84 15,11V9A2,2 0 0,0 13,7H9M11,9H13V11H11V9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaRBoxOutline = "M9,7H13A2,2 0 0,1 15,9V11C15,11.84 14.5,12.55 13.76,12.85L15,17H13L11.8,13H11V17H9V7M11,9V11H13V9H11M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaRCircle = "M9,7V17H11V13H11.8L13,17H15L13.76,12.85C14.5,12.55 15,11.84 15,11V9A2,2 0 0,0 13,7H9M11,9H13V11H11V9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaRCircleOutline = "M9,7H13A2,2 0 0,1 15,9V11C15,11.84 14.5,12.55 13.76,12.85L15,17H13L11.8,13H11V17H9V7M11,9V11H13V9H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,16.41 7.58,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaS = "M11,7A2,2 0 0,0 9,9V11A2,2 0 0,0 11,13H13V15H9V17H13A2,2 0 0,0 15,15V13A2,2 0 0,0 13,11H11V9H15V7H11Z";
var mdiAlphaSBox = "M11,7A2,2 0 0,0 9,9V11A2,2 0 0,0 11,13H13V15H9V17H13A2,2 0 0,0 15,15V13A2,2 0 0,0 13,11H11V9H15V7H11M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaSBoxOutline = "M11,7H15V9H11V11H13A2,2 0 0,1 15,13V15A2,2 0 0,1 13,17H9V15H13V13H11A2,2 0 0,1 9,11V9A2,2 0 0,1 11,7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaSCircle = "M11,7A2,2 0 0,0 9,9V11A2,2 0 0,0 11,13H13V15H9V17H13A2,2 0 0,0 15,15V13A2,2 0 0,0 13,11H11V9H15V7H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaSCircleOutline = "M11,7H15V9H11V11H13A2,2 0 0,1 15,13V15A2,2 0 0,1 13,17H9V15H13V13H11A2,2 0 0,1 9,11V9A2,2 0 0,1 11,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaT = "M9,7V9H11V17H13V9H15V7H9Z";
var mdiAlphaTBox = "M9,7V9H11V17H13V9H15V7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaTBoxOutline = "M9,7H15V9H13V17H11V9H9V7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaTCircle = "M9,7V9H11V17H13V9H15V7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaTCircleOutline = "M9,7H15V9H13V17H11V9H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaU = "M9,7V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V7H13V15H11V7H9Z";
var mdiAlphaUBox = "M9,7V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V7H13V15H11V7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaUBoxOutline = "M9,7H11V15H13V7H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaUCircle = "M9,7V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V7H13V15H11V7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaUCircleOutline = "M9,7H11V15H13V7H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaV = "M9,7L11,17H13L15,7H13L12,12L11,7H9Z";
var mdiAlphaVBox = "M9,7L11,17H13L15,7H13L12,12L11,7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaVBoxOutline = "M9,7H11L12,12L13,7H15L13,17H11L9,7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaVCircle = "M9,7L11,17H13L15,7H13L12,12L11,7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaVCircleOutline = "M9,7H11L12,12L13,7H15L13,17H11L9,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaW = "M9,17A2,2 0 0,1 7,15V7H9V15H11V8H13V15H15V7H17V15A2,2 0 0,1 15,17H9Z";
var mdiAlphaWBox = "M9,17H15A2,2 0 0,0 17,15V7H15V15H13V8H11V15H9V7H7V15A2,2 0 0,0 9,17M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaWBoxOutline = "M9,17A2,2 0 0,1 7,15V7H9V15H11V8H13V15H15V7H17V15A2,2 0 0,1 15,17H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaWCircle = "M9,17H15A2,2 0 0,0 17,15V7H15V15H13V8H11V15H9V7H7V15A2,2 0 0,0 9,17M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaWCircleOutline = "M9,17A2,2 0 0,1 7,15V7H9V15H11V8H13V15H15V7H17V15A2,2 0 0,1 15,17H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaX = "M9,7L11,12L9,17H11L12,14.5L13,17H15L13,12L15,7H13L12,9.5L11,7H9Z";
var mdiAlphaXBox = "M9,7L11,12L9,17H11L12,14.5L13,17H15L13,12L15,7H13L12,9.5L11,7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaXBoxOutline = "M9,7H11L12,9.5L13,7H15L13,12L15,17H13L12,14.5L11,17H9L11,12L9,7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaXCircle = "M9,7L11,12L9,17H11L12,14.5L13,17H15L13,12L15,7H13L12,9.5L11,7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaXCircleOutline = "M9,7H11L12,9.5L13,7H15L13,12L15,17H13L12,14.5L11,17H9L11,12L9,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaY = "M9,7L11,13V17H13V13L15,7H13L12,10L11,7H9Z";
var mdiAlphaYBox = "M9,7L11,13V17H13V13L15,7H13L12,10L11,7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaYBoxOutline = "M9,7H11L12,10L13,7H15L13,13V17H11V13L9,7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaYCircle = "M9,7L11,13V17H13V13L15,7H13L12,10L11,7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaYCircleOutline = "M9,7H11L12,10L13,7H15L13,13V17H11V13L9,7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphaZ = "M9,7V9H13L9,15V17H15V15H11L15,9V7H9Z";
var mdiAlphaZBox = "M9,7V9H13L9,15V17H15V15H11L15,9V7H9M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiAlphaZBoxOutline = "M9,7H15V9L11,15H15V17H9V15L13,9H9V7M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiAlphaZCircle = "M9,7V9H13L9,15V17H15V15H11L15,9V7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiAlphaZCircleOutline = "M9,7H15V9L11,15H15V17H9V15L13,9H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiAlphabetAurebesh = "M3 4V11H14.23L22 4H19L13.46 9H5V4H3M3 13V20H5V15H13.46L19 20H22L14.23 13H3Z";
var mdiAlphabetCyrillic = "M16 6C14.36 6 13 7.36 13 9V15C13 16.65 14.36 18 16 18H17C18.65 18 20 16.65 20 15V12C20 10.36 18.65 9 17 9H15C15 8.44 15.44 8 16 8H18C19.09 8 20 7.09 20 6M5 9V11H8C8.57 11 9 11.43 9 12H7C5.36 12 4 13.36 4 15C4 16.65 5.36 18 7 18H11V12C11 10.36 9.65 9 8 9M15 11H17C17.57 11 18 11.43 18 12V15C18 15.57 17.57 16 17 16H16C15.43 16 15 15.57 15 15M7 14H9V16H7C6.43 16 6 15.57 6 15C6 14.43 6.43 14 7 14Z";
var mdiAlphabetGreek = "M16 6C14.36 6 13 7.36 13 9V21H15V9C15 8.43 15.43 8 16 8H17C17.57 8 18 8.43 18 9V10C18 10.57 17.57 11 17 11H16V13H17C17.57 13 18 13.43 18 14V15C18 15.57 17.57 16 17 16H16V18H17C18.65 18 20 16.65 20 15V14C20 13.18 19.59 12.46 19 12C19.59 11.54 20 10.82 20 10V9C20 7.36 18.65 6 17 6M7 9C5.36 9 4 10.36 4 12V15C4 16.65 5.36 18 7 18H7.7C8.2 18 8.65 17.81 9 17.5V18H11V9H9V9.5C8.65 9.19 8.2 9 7.7 9M7 11H8C8.57 11 9 11.43 9 12V15C9 15.57 8.57 16 8 16H7C6.43 16 6 15.57 6 15V12C6 11.43 6.43 11 7 11Z";
var mdiAlphabetLatin = "M13 6V18H15V17.31C15.37 17.73 15.9 18 16.5 18H17C18.65 18 20 16.65 20 15V12C20 10.36 18.65 9 17 9H16.5C15.9 9 15.37 9.27 15 9.7V6M5 9V11H8C8.57 11 9 11.43 9 12H7C5.36 12 4 13.36 4 15C4 16.65 5.36 18 7 18H11V12C11 10.36 9.65 9 8 9M16 11H17C17.57 11 18 11.43 18 12V15C18 15.57 17.57 16 17 16H16C15.43 16 15 15.57 15 15V12C15 11.43 15.43 11 16 11M7 14H9V16H7C6.43 16 6 15.57 6 15C6 14.43 6.43 14 7 14Z";
var mdiAlphabetPiqad = "M13.04 4L6.54 17.85C6.21 18.55 5.5 19 4.73 19H4V20H16C17.2 20 18.27 20.54 19 21.39H20C19.05 19.32 17 18 14.7 18H12C11.29 18 10.62 17.63 10.24 17.03C9.85 16.43 9.8 15.68 10.1 15.03L10.58 14H19V13H17.5C15.29 13 13.5 11.21 13.5 9C13.5 6.79 15.29 5 17.5 5H20V4Z";
var mdiAlphabetTengwar = "M10 7L12.5 3H15L11 7H10M12.5 9C11.96 9 11.46 9.13 11 9.35V9H8V11H9V21H11V12.5C11 11.67 11.67 11 12.5 11C13.33 11 14 11.67 14 12.5V14.5C14 15.33 13.33 16 12.5 16H12V18H12.5C14.43 18 16 16.43 16 14.5V12.5C16 10.57 14.43 9 12.5 9Z";
var mdiAlphabetical = "M6,11A2,2 0 0,1 8,13V17H4A2,2 0 0,1 2,15V13A2,2 0 0,1 4,11H6M4,13V15H6V13H4M20,13V15H22V17H20A2,2 0 0,1 18,15V13A2,2 0 0,1 20,11H22V13H20M12,7V11H14A2,2 0 0,1 16,13V15A2,2 0 0,1 14,17H12A2,2 0 0,1 10,15V7H12M12,15H14V13H12V15Z";
var mdiAlphabeticalOff = "M22.11 21.46L16 15.31L14 13.31L13.65 13L10 9.34L2.39 1.73L1.11 3L10 11.89V15A2 2 0 0 0 12 17H14A1.92 1.92 0 0 0 14.89 16.78L20.84 22.73M12 15V13.89L13.11 15M16 12.78L14.22 11A2 2 0 0 1 16 12.78M20.2 17L18 14.8V13A2 2 0 0 1 20 11H22V13H20V15H22V17M6 11H4A2 2 0 0 0 2 13V15A2 2 0 0 0 4 17H8V13A2 2 0 0 0 6 11M6 15H4V13H6M12 8.8L10.2 7H12Z";
var mdiAlphabeticalVariant = "M3 7A2 2 0 0 0 1 9V17H3V13H5V17H7V9A2 2 0 0 0 5 7H3M3 9H5V11H3M15 10.5V9A2 2 0 0 0 13 7H9V17H13A2 2 0 0 0 15 15V13.5A1.54 1.54 0 0 0 13.5 12A1.54 1.54 0 0 0 15 10.5M13 15H11V13H13V15M13 11H11V9H13M19 7A2 2 0 0 0 17 9V15A2 2 0 0 0 19 17H21A2 2 0 0 0 23 15V14H21V15H19V9H21V10H23V9A2 2 0 0 0 21 7Z";
var mdiAlphabeticalVariantOff = "M12.2 9L10.2 7H13A2 2 0 0 1 15 9V10.5A1.47 1.47 0 0 1 14.64 11.44L13 9.8V9M23 10V9A2 2 0 0 0 21 7H19A2 2 0 0 0 17 9V13.8L20.2 17H21A2 2 0 0 0 23 15V14H21V15H19V9H21V10M15 14.35L22.11 21.46L20.84 22.73L14.46 16.35A2 2 0 0 1 13 17H9V10.89L7 8.89V17H5V13H3V17H1V9A2 2 0 0 1 3 7H5.12L1.12 3L2.39 1.73L9 8.34L11 10.34L11.66 11L15 14.34M5 9H3V11H5M13 14.89L11.11 13H11V15H13Z";
var mdiAltimeter = "M7,3V5H17V3H7M9,7V9H15V7H9M2,7.96V16.04L6.03,12L2,7.96M22.03,7.96L18,12L22.03,16.04V7.96M7,11V13H17V11H7M9,15V17H15V15H9M7,19V21H17V19H7Z";
var mdiAmbulance = "M18,18.5A1.5,1.5 0 0,0 19.5,17A1.5,1.5 0 0,0 18,15.5A1.5,1.5 0 0,0 16.5,17A1.5,1.5 0 0,0 18,18.5M19.5,9.5H17V12H21.46L19.5,9.5M6,18.5A1.5,1.5 0 0,0 7.5,17A1.5,1.5 0 0,0 6,15.5A1.5,1.5 0 0,0 4.5,17A1.5,1.5 0 0,0 6,18.5M20,8L23,12V17H21A3,3 0 0,1 18,20A3,3 0 0,1 15,17H9A3,3 0 0,1 6,20A3,3 0 0,1 3,17H1V6C1,4.89 1.89,4 3,4H17V8H20M8,6V9H5V11H8V14H10V11H13V9H10V6H8Z";
var mdiAmmunition = "M14,22H10V21H14V22M13,10V7H11V10L10,11.5V20H14V11.5L13,10M12,2C12,2 11,3 11,5V6H13V5C13,5 13,3 12,2M8,22H4V21H8V22M7,10V7H5V10L4,11.5V20H8V11.5L7,10M6,2C6,2 5,3 5,5V6H7V5C7,5 7,3 6,2M20,22H16V21H20V22M19,10V7H17V10L16,11.5V20H20V11.5L19,10M18,2C18,2 17,3 17,5V6H19V5C19,5 19,3 18,2Z";
var mdiAmpersand = "M4.4,16.5C4.4,15.6 4.7,14.7 5.2,13.9C5.7,13.1 6.7,12.2 8.2,11.2C7.3,10.1 6.8,9.3 6.5,8.7C6.1,8 6,7.4 6,6.7C6,5.2 6.4,4.1 7.3,3.2C8.2,2.3 9.4,2 10.9,2C12.2,2 13.3,2.4 14.2,3.2C15.1,4 15.5,5 15.5,6.1C15.5,6.9 15.3,7.6 14.9,8.3C14.5,9 13.8,9.7 12.8,10.4L11.4,11.5L15.7,16.7C16.3,15.5 16.6,14.3 16.6,12.8H18.8C18.8,15.1 18.3,17 17.2,18.5L20,21.8H17L15.7,20.3C15,20.9 14.3,21.3 13.4,21.6C12.5,21.9 11.6,22.1 10.7,22.1C8.8,22.1 7.3,21.6 6.1,20.6C5,19.5 4.4,18.2 4.4,16.5M10.7,20C12,20 13.2,19.5 14.3,18.5L9.6,12.8L9.2,13.1C7.7,14.2 7,15.3 7,16.5C7,17.6 7.3,18.4 8,19C8.7,19.6 9.5,20 10.7,20M8.5,6.7C8.5,7.6 9,8.6 10.1,9.9L11.7,8.8C12.3,8.4 12.7,8 12.9,7.6C13.1,7.2 13.2,6.7 13.2,6.2C13.2,5.6 13,5.1 12.5,4.7C12.1,4.3 11.5,4.1 10.8,4.1C10.1,4.1 9.5,4.3 9.1,4.8C8.7,5.3 8.5,5.9 8.5,6.7Z";
var mdiAmplifier = "M10,2H14A1,1 0 0,1 15,3H21V21H19A1,1 0 0,1 18,22A1,1 0 0,1 17,21H7A1,1 0 0,1 6,22A1,1 0 0,1 5,21H3V3H9A1,1 0 0,1 10,2M5,5V9H19V5H5M7,6A1,1 0 0,1 8,7A1,1 0 0,1 7,8A1,1 0 0,1 6,7A1,1 0 0,1 7,6M12,6H14V7H12V6M15,6H16V8H15V6M17,6H18V8H17V6M12,11A4,4 0 0,0 8,15A4,4 0 0,0 12,19A4,4 0 0,0 16,15A4,4 0 0,0 12,11M10,6A1,1 0 0,1 11,7A1,1 0 0,1 10,8A1,1 0 0,1 9,7A1,1 0 0,1 10,6Z";
var mdiAmplifierOff = "M22.1 21.5L2.4 1.7L1.1 3L3 4.9V21H5C5 21.6 5.4 22 6 22S7 21.6 7 21H17C17 21.6 17.4 22 18 22S19 21.6 19 21H19.1L20.8 22.7L22.1 21.5M5 9V6.9L7.1 9H5M12 19C9.8 19 8 17.2 8 15C8 13.6 8.7 12.4 9.8 11.7L15.3 17.2C14.6 18.3 13.4 19 12 19M14 6V7H12V6H14M10 6C10.6 6 11 6.4 11 7C11 7.2 10.9 7.4 10.8 7.6L9.4 6.2C9.6 6.1 9.8 6 10 6M8.2 5L6.2 3H9C9 2.4 9.4 2 10 2H14C14.6 2 15 2.4 15 3H21V17.8L12.2 9H19V5H8.2M16 6V8H15V6H16M18 6V8H17V6H18Z";
var mdiAnchor = "M12 2A3 3 0 0 0 9 5A3 3 0 0 0 11 7.83V9H8V11H11V19.92C10.26 19.79 9.5 19.58 8.79 19.27C8.05 18.95 7.4 18.56 6.82 18.09C6.24 17.62 5.78 17.11 5.44 16.55L7 15L3 12V15C3 15.97 3.27 16.88 3.82 17.72C4.37 18.56 5.09 19.31 6 19.95C6.87 20.59 7.84 21.09 8.88 21.45C9.93 21.81 10.97 22 12 22C13.03 22 14.07 21.8 15.12 21.44C16.16 21.08 17.13 20.58 18 19.95C18.92 19.31 19.63 18.57 20.18 17.72C20.73 16.88 21 15.97 21 15V12L17 15L18.56 16.55C18.22 17.11 17.76 17.62 17.18 18.09C16.6 18.56 15.95 18.95 15.21 19.27C14.5 19.58 13.74 19.79 13 19.92V11H16V9H13V7.82A3 3 0 0 0 15 5A3 3 0 0 0 12 2M12 4A1 1 0 0 1 13 5A1 1 0 0 1 12 6A1 1 0 0 1 11 5A1 1 0 0 1 12 4Z";
var mdiAndroid = "M16.61 15.15C16.15 15.15 15.77 14.78 15.77 14.32S16.15 13.5 16.61 13.5H16.61C17.07 13.5 17.45 13.86 17.45 14.32C17.45 14.78 17.07 15.15 16.61 15.15M7.41 15.15C6.95 15.15 6.57 14.78 6.57 14.32C6.57 13.86 6.95 13.5 7.41 13.5H7.41C7.87 13.5 8.24 13.86 8.24 14.32C8.24 14.78 7.87 15.15 7.41 15.15M16.91 10.14L18.58 7.26C18.67 7.09 18.61 6.88 18.45 6.79C18.28 6.69 18.07 6.75 18 6.92L16.29 9.83C14.95 9.22 13.5 8.9 12 8.91C10.47 8.91 9 9.24 7.73 9.82L6.04 6.91C5.95 6.74 5.74 6.68 5.57 6.78C5.4 6.87 5.35 7.08 5.44 7.25L7.1 10.13C4.25 11.69 2.29 14.58 2 18H22C21.72 14.59 19.77 11.7 16.91 10.14H16.91Z";
var mdiAndroidStudio = "M11,2H13V4H13.5A1.5,1.5 0 0,1 15,5.5V9L14.56,9.44L16.2,12.28C17.31,11.19 18,9.68 18,8H20C20,10.42 18.93,12.59 17.23,14.06L20.37,19.5L20.5,21.72L18.63,20.5L15.56,15.17C14.5,15.7 13.28,16 12,16C10.72,16 9.5,15.7 8.44,15.17L5.37,20.5L3.5,21.72L3.63,19.5L9.44,9.44L9,9V5.5A1.5,1.5 0 0,1 10.5,4H11V2M9.44,13.43C10.22,13.8 11.09,14 12,14C12.91,14 13.78,13.8 14.56,13.43L13.1,10.9H13.09C12.47,11.5 11.53,11.5 10.91,10.9H10.9L9.44,13.43M12,6A1,1 0 0,0 11,7A1,1 0 0,0 12,8A1,1 0 0,0 13,7A1,1 0 0,0 12,6Z";
var mdiAngleAcute = "M20,19H4.09L14.18,4.43L15.82,5.57L11.28,12.13C12.89,12.96 14,14.62 14,16.54C14,16.7 14,16.85 13.97,17H20V19M7.91,17H11.96C12,16.85 12,16.7 12,16.54C12,15.28 11.24,14.22 10.14,13.78L7.91,17Z";
var mdiAngleObtuse = "M21,19H9.31L4.07,5.36L5.93,4.64L8.96,12.5C9.5,12.29 10.09,12.17 10.71,12.17V12.17C13.38,12.17 15.56,14.34 15.58,17H21V19M10.69,17H13.58C13.56,15.42 12.3,14.17 10.71,14.17C10.34,14.17 10,14.24 9.67,14.36L10.69,17Z";
var mdiAngleRight = "M5,4H7V11H13V17H20V19H5V4M7,17H11V13H7V17Z";
var mdiAngular = "M12,2.5L20.84,5.65L19.5,17.35L12,21.5L4.5,17.35L3.16,5.65L12,2.5M12,4.6L6.47,17H8.53L9.64,14.22H14.34L15.45,17H17.5L12,4.6M13.62,12.5H10.39L12,8.63L13.62,12.5Z";
var mdiAngularjs = "M12,2.5L20.84,5.65L19.5,17.35L12,21.5L4.5,17.35L3.16,5.65L12,2.5M12,4.5L5,7L6.08,16.22L12,19.5L17.92,16.22L19,7L12,4.5M12,5.72L16.58,16H14.87L13.94,13.72H10.04L9.12,16H7.41L12,5.72M13.34,12.3L12,9.07L10.66,12.3H13.34Z";
var mdiAnimation = "M4,2C2.89,2 2,2.89 2,4V14H4V4H14V2H4M8,6C6.89,6 6,6.89 6,8V18H8V8H18V6H8M12,10C10.89,10 10,10.89 10,12V20C10,21.11 10.89,22 12,22H20C21.11,22 22,21.11 22,20V12C22,10.89 21.11,10 20,10H12Z";
var mdiAnimationOutline = "M4,2A2,2 0 0,0 2,4V14H4V4H14V2H4M8,6A2,2 0 0,0 6,8V18H8V8H18V6H8M20,12V20H12V12H20M20,10H12A2,2 0 0,0 10,12V20A2,2 0 0,0 12,22H20A2,2 0 0,0 22,20V12A2,2 0 0,0 20,10Z";
var mdiAnimationPlay = "M4,2H14V4H4V14H2V4C2,2.89 2.89,2 4,2M8,6H18V8H8V18H6V8C6,6.89 6.89,6 8,6M12,10H20C21.11,10 22,10.89 22,12V20C22,21.11 21.11,22 20,22H12C10.89,22 10,21.11 10,20V12C10,10.89 10.89,10 12,10M14,12V20L20,16L14,12Z";
var mdiAnimationPlayOutline = "M4,2A2,2 0 0,0 2,4V14H4V4H14V2H4M8,6A2,2 0 0,0 6,8V18H8V8H18V6H8M20,12V20H12V12H20M20,10H12A2,2 0 0,0 10,12V20A2,2 0 0,0 12,22H20A2,2 0 0,0 22,20V12A2,2 0 0,0 20,10M14,13V19L18,16L14,13Z";
var mdiAnsible = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2M16.1 17C15.91 17 15.76 16.9 15.55 16.73L10.39 12.56L8.66 16.9H7.17L11.54 6.39C11.65 6.11 11.89 5.97 12.17 5.97C12.45 5.97 12.67 6.11 12.79 6.39L16.77 15.97C16.81 16.08 16.84 16.19 16.84 16.26C16.83 16.68 16.5 17 16.1 17M12.17 8.11L14.76 14.5L10.85 11.42L12.17 8.11Z";
var mdiAntenna = "M12 7.5C12.69 7.5 13.27 7.73 13.76 8.2S14.5 9.27 14.5 10C14.5 11.05 14 11.81 13 12.28V21H11V12.28C10 11.81 9.5 11.05 9.5 10C9.5 9.27 9.76 8.67 10.24 8.2S11.31 7.5 12 7.5M16.69 5.3C17.94 6.55 18.61 8.11 18.7 10C18.7 11.8 18.03 13.38 16.69 14.72L15.5 13.5C16.5 12.59 17 11.42 17 10C17 8.67 16.5 7.5 15.5 6.5L16.69 5.3M6.09 4.08C4.5 5.67 3.7 7.64 3.7 10S4.5 14.3 6.09 15.89L4.92 17.11C3 15.08 2 12.7 2 10C2 7.3 3 4.94 4.92 2.91L6.09 4.08M19.08 2.91C21 4.94 22 7.3 22 10C22 12.8 21 15.17 19.08 17.11L17.91 15.89C19.5 14.3 20.3 12.33 20.3 10S19.5 5.67 17.91 4.08L19.08 2.91M7.31 5.3L8.5 6.5C7.5 7.42 7 8.58 7 10C7 11.33 7.5 12.5 8.5 13.5L7.31 14.72C5.97 13.38 5.3 11.8 5.3 10C5.3 8.2 5.97 6.64 7.31 5.3Z";
var mdiAnvil = "M9,5V10C13.03,12.47 8.44,14.97 6,16V19H21V16C14.59,13.27 17.47,9 22,8V5H9M2,6C2.81,8.13 4.42,9.5 7,10V6H2Z";
var mdiApacheKafka = "M15.54 12.97C14.86 12.97 14.24 13.22 13.76 13.64L12.47 12.89C12.56 12.6 12.6 12.29 12.6 11.97C12.6 11.65 12.56 11.34 12.5 11.05L13.73 10.32C14.21 10.76 14.85 11 15.54 11C17.03 11 18.24 9.81 18.24 8.32S17.03 5.63 15.54 5.63 12.84 6.84 12.84 8.33C12.84 8.5 12.86 8.7 12.89 8.88L11.64 9.6C11.21 9.15 10.64 8.82 10 8.65V7.26C11.09 6.91 11.88 5.89 11.88 4.69C11.88 3.2 10.67 2 9.18 2C7.69 2 6.5 3.2 6.5 4.69C6.5 5.89 7.26 6.9 8.34 7.26V8.66C6.86 9.04 5.76 10.37 5.76 11.97C5.76 13.57 6.86 14.91 8.34 15.28V16.73C7.26 17.09 6.5 18.1 6.5 19.3C6.5 20.79 7.69 22 9.18 22C10.67 22 11.88 20.79 11.88 19.3C11.88 18.1 11.09 17.08 10 16.73V15.29C10.64 15.13 11.2 14.8 11.64 14.35L12.9 15.08C12.86 15.27 12.84 15.46 12.84 15.66C12.84 17.15 14.05 18.36 15.54 18.36S18.24 17.15 18.24 15.66 17.03 12.97 15.54 12.97M15.54 7C16.28 7 16.87 7.59 16.87 8.32S16.28 9.66 15.54 9.66 14.21 9.06 14.21 8.32 14.8 7 15.54 7M7.85 4.69C7.85 3.95 8.44 3.35 9.18 3.35C9.92 3.35 10.5 3.95 10.5 4.69S9.92 6.03 9.18 6.03C8.44 6.03 7.85 5.43 7.85 4.69M10.5 19.3C10.5 20.04 9.92 20.64 9.18 20.64C8.44 20.64 7.85 20.04 7.85 19.3C7.85 18.56 8.44 17.96 9.18 17.96C9.92 17.96 10.5 18.56 10.5 19.3M9.18 13.89C8.12 13.89 7.26 13.03 7.26 11.97C7.26 10.91 8.12 10.05 9.18 10.05S11.1 10.91 11.1 11.97C11.1 13.03 10.24 13.89 9.18 13.89M15.54 17C14.8 17 14.21 16.4 14.21 15.66S14.8 14.33 15.54 14.33 16.87 14.93 16.87 15.66 16.28 17 15.54 17Z";
var mdiApi = "M7 7H5A2 2 0 0 0 3 9V17H5V13H7V17H9V9A2 2 0 0 0 7 7M7 11H5V9H7M14 7H10V17H12V13H14A2 2 0 0 0 16 11V9A2 2 0 0 0 14 7M14 11H12V9H14M20 9V15H21V17H17V15H18V9H17V7H21V9Z";
var mdiApiOff = "M7 11H5V9H7M14 7H11.38L13.29 9H14V9.75L15.87 11.71C15.95 11.5 16 11.25 16 11V9C16 7.9 15.11 7 14 7M4.45 2.62L3 4L5.86 7H5C3.9 7 3 7.9 3 9V17H5V13H7V17H9V10.3L10 11.34V17H12V13.45L19.55 21.38L21 20M20.9 17H21V15H20V9H21V7H17V9H18V13.95Z";
var mdiApple = "M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z";
var mdiAppleFinder = "M8 11C7.45 11 7 10.55 7 10V8C7 7.45 7.45 7 8 7C8.55 7 9 7.45 9 8V10C9 10.55 8.55 11 8 11M17 10V8C17 7.45 16.55 7 16 7C15.45 7 15 7.45 15 8V10C15 10.55 15.45 11 16 11C16.55 11 17 10.55 17 10M22 5V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V5C2 3.9 2.9 3 4 3H20C21.1 3 22 3.9 22 5M4 20L13.06 20C12.96 19.35 12.89 18.64 12.83 17.94C12.56 17.96 12.3 18 12 18C8.24 18 6.31 15.73 6.23 15.63C5.88 15.21 5.94 14.58 6.36 14.22C6.78 13.87 7.41 13.93 7.77 14.35C7.83 14.43 9.23 16 12 16C12.27 16 12.5 15.97 12.74 15.95C12.71 14.75 12.73 13.74 12.74 13.26H10.93C10.28 13.26 9.75 12.7 9.75 12C9.77 11.75 10.07 7.82 11 5H4L4 20M20 20L20 5H12.6C11.74 7.19 11.37 10.73 11.27 11.76H13.08C13.72 11.76 14.25 12.32 14.25 13C14.25 13.04 14.21 14.15 14.24 15.6C15.54 15.11 16.22 14.35 16.23 14.34C16.58 13.92 17.21 13.85 17.63 14.2C18.06 14.55 18.12 15.18 17.77 15.61C17.71 15.68 16.55 17.05 14.32 17.68C14.38 18.5 14.46 19.29 14.58 20H20Z";
var mdiAppleIcloud = "M22,15.04C22,17.23 20.24,19 18.07,19H5.93C3.76,19 2,17.23 2,15.04C2,13.07 3.43,11.44 5.31,11.14C5.28,11 5.27,10.86 5.27,10.71C5.27,9.33 6.38,8.2 7.76,8.2C8.37,8.2 8.94,8.43 9.37,8.8C10.14,7.05 11.13,5.44 13.91,5.44C17.28,5.44 18.87,8.06 18.87,10.83C18.87,10.94 18.87,11.06 18.86,11.17C20.65,11.54 22,13.13 22,15.04Z";
var mdiAppleIos = "M2.09 16.8H3.75V9.76H2.09M2.92 8.84C3.44 8.84 3.84 8.44 3.84 7.94C3.84 7.44 3.44 7.04 2.92 7.04C2.4 7.04 2 7.44 2 7.94C2 8.44 2.4 8.84 2.92 8.84M9.25 7.06C6.46 7.06 4.7 8.96 4.7 12C4.7 15.06 6.46 16.96 9.25 16.96C12.04 16.96 13.8 15.06 13.8 12C13.8 8.96 12.04 7.06 9.25 7.06M9.25 8.5C10.96 8.5 12.05 9.87 12.05 12C12.05 14.15 10.96 15.5 9.25 15.5C7.54 15.5 6.46 14.15 6.46 12C6.46 9.87 7.54 8.5 9.25 8.5M14.5 14.11C14.57 15.87 16 16.96 18.22 16.96C20.54 16.96 22 15.82 22 14C22 12.57 21.18 11.77 19.23 11.32L18.13 11.07C16.95 10.79 16.47 10.42 16.47 9.78C16.47 9 17.2 8.45 18.28 8.45C19.38 8.45 20.13 9 20.21 9.89H21.84C21.8 8.2 20.41 7.06 18.29 7.06C16.21 7.06 14.73 8.21 14.73 9.91C14.73 11.28 15.56 12.13 17.33 12.53L18.57 12.82C19.78 13.11 20.27 13.5 20.27 14.2C20.27 15 19.47 15.57 18.31 15.57C17.15 15.57 16.26 15 16.16 14.11H14.5Z";
var mdiAppleKeyboardCaps = "M15,14V8H17.17L12,2.83L6.83,8H9V14H15M12,0L22,10H17V16H7V10H2L12,0M7,18H17V24H7V18M15,20H9V22H15V20Z";
var mdiAppleKeyboardCommand = "M6,2A4,4 0 0,1 10,6V8H14V6A4,4 0 0,1 18,2A4,4 0 0,1 22,6A4,4 0 0,1 18,10H16V14H18A4,4 0 0,1 22,18A4,4 0 0,1 18,22A4,4 0 0,1 14,18V16H10V18A4,4 0 0,1 6,22A4,4 0 0,1 2,18A4,4 0 0,1 6,14H8V10H6A4,4 0 0,1 2,6A4,4 0 0,1 6,2M16,18A2,2 0 0,0 18,20A2,2 0 0,0 20,18A2,2 0 0,0 18,16H16V18M14,10H10V14H14V10M6,16A2,2 0 0,0 4,18A2,2 0 0,0 6,20A2,2 0 0,0 8,18V16H6M8,6A2,2 0 0,0 6,4A2,2 0 0,0 4,6A2,2 0 0,0 6,8H8V6M18,8A2,2 0 0,0 20,6A2,2 0 0,0 18,4A2,2 0 0,0 16,6V8H18Z";
var mdiAppleKeyboardControl = "M19.78,11.78L18.36,13.19L12,6.83L5.64,13.19L4.22,11.78L12,4L19.78,11.78Z";
var mdiAppleKeyboardOption = "M3,4H9.11L16.15,18H21V20H14.88L7.84,6H3V4M14,4H21V6H14V4Z";
var mdiAppleKeyboardShift = "M15,18V12H17.17L12,6.83L6.83,12H9V18H15M12,4L22,14H17V20H7V14H2L12,4Z";
var mdiAppleSafari = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,14.09 4.8,16 6.11,17.41L9.88,9.88L17.41,6.11C16,4.8 14.09,4 12,4M12,20A8,8 0 0,0 20,12C20,9.91 19.2,8 17.89,6.59L14.12,14.12L6.59,17.89C8,19.2 9.91,20 12,20M12,12L11.23,11.23L9.7,14.3L12.77,12.77L12,12M12,17.5H13V19H12V17.5M15.88,15.89L16.59,15.18L17.65,16.24L16.94,16.95L15.88,15.89M17.5,12V11H19V12H17.5M12,6.5H11V5H12V6.5M8.12,8.11L7.41,8.82L6.35,7.76L7.06,7.05L8.12,8.11M6.5,12V13H5V12H6.5Z";
var mdiApplication = "M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M21 7H3V4H21V7Z";
var mdiApplicationArray = "M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M10 11H8V18H10V20H6V9H10V11M18 20H14V18H16V11H14V9H18V20M21 7H3V4H21V7Z";
var mdiApplicationArrayOutline = "M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M21 20H3V6H21V20M6 8V18H10V16H8V10H10V8H6M16 16H14V18H18V8H14V10H16V16";
var mdiApplicationBraces = "M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M11 11H9V12.5C9 13.6 8.1 14.5 7 14.5C8.1 14.5 9 15.4 9 16.5V18H11V20H9C7.9 20 7 19.1 7 18V17.5C7 16.4 6.1 15.5 5 15.5V13.5C6.1 13.5 7 12.6 7 11.5V11C7 9.9 7.9 9 9 9H11V11M19 15.5C17.9 15.5 17 16.4 17 17.5V18C17 19.1 16.1 20 15 20H13V18H15V16.5C15 15.4 15.9 14.5 17 14.5C15.9 14.5 15 13.6 15 12.5V11H13V9H15C16.1 9 17 9.9 17 11V11.5C17 12.6 17.9 13.5 19 13.5V15.5M21 7H3V4H21V7Z";
var mdiApplicationBracesOutline = "M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M21 20H3V6H21V20M9 8C7.9 8 7 8.9 7 10C7 11.1 6.1 12 5 12V14C6.1 14 7 14.9 7 16C7 17.1 7.9 18 9 18H11V16H9V15C9 13.9 8.1 13 7 13C8.1 13 9 12.1 9 11V10H11V8M15 8C16.1 8 17 8.9 17 10C17 11.1 17.9 12 19 12V14C17.9 14 17 14.9 17 16C17 17.1 16.1 18 15 18H13V16H15V15C15 13.9 15.9 13 17 13C15.9 13 15 12.1 15 11V10H13V8H15Z";
var mdiApplicationBrackets = "M21,2H3A2,2 0 0,0 1,4V20A2,2 0 0,0 3,22H21A2,2 0 0,0 23,20V4A2,2 0 0,0 21,2M11,17.5L9.5,19L5,14.5L9.5,10L11,11.5L8,14.5L11,17.5M14.5,19L13,17.5L16,14.5L13,11.5L14.5,10L19,14.5L14.5,19M21,7H3V4H21V7Z";
var mdiApplicationBracketsOutline = "M9.5,8.5L11,10L8,13L11,16L9.5,17.5L5,13L9.5,8.5M14.5,17.5L13,16L16,13L13,10L14.5,8.5L19,13L14.5,17.5M21,2H3A2,2 0 0,0 1,4V20A2,2 0 0,0 3,22H21A2,2 0 0,0 23,20V4A2,2 0 0,0 21,2M21,20H3V6H21V20Z";
var mdiApplicationCog = "M21.7 18.6V17.6L22.8 16.8C22.9 16.7 23 16.6 22.9 16.5L21.9 14.8C21.9 14.7 21.7 14.7 21.6 14.7L20.4 15.2C20.1 15 19.8 14.8 19.5 14.7L19.3 13.4C19.3 13.3 19.2 13.2 19.1 13.2H17.1C16.9 13.2 16.8 13.3 16.8 13.4L16.6 14.7C16.3 14.9 16.1 15 15.8 15.2L14.6 14.7C14.5 14.7 14.4 14.7 14.3 14.8L13.3 16.5C13.3 16.6 13.3 16.7 13.4 16.8L14.5 17.6V18.6L13.4 19.4C13.3 19.5 13.2 19.6 13.3 19.7L14.3 21.4C14.4 21.5 14.5 21.5 14.6 21.5L15.8 21C16 21.2 16.3 21.4 16.6 21.5L16.8 22.8C16.9 22.9 17 23 17.1 23H19.1C19.2 23 19.3 22.9 19.3 22.8L19.5 21.5C19.8 21.3 20 21.2 20.3 21L21.5 21.4C21.6 21.4 21.7 21.4 21.8 21.3L22.8 19.6C22.9 19.5 22.9 19.4 22.8 19.4L21.7 18.6M18 19.5C17.2 19.5 16.5 18.8 16.5 18S17.2 16.5 18 16.5 19.5 17.2 19.5 18 18.8 19.5 18 19.5M11 18C11 14.1 14.1 11 18 11C20 11 21.7 11.8 23 13.1V4C23 2.9 22.1 2 21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H12.3C11.5 20.9 11 19.5 11 18M3 4H21V7H3V4Z";
var mdiApplicationCogOutline = "M21.7 18.6V17.6L22.8 16.8C22.9 16.7 23 16.6 22.9 16.5L21.9 14.8C21.9 14.7 21.7 14.7 21.6 14.7L20.4 15.2C20.1 15 19.8 14.8 19.5 14.7L19.3 13.4C19.3 13.3 19.2 13.2 19.1 13.2H17.1C16.9 13.2 16.8 13.3 16.8 13.4L16.6 14.7C16.3 14.9 16.1 15 15.8 15.2L14.6 14.7C14.5 14.7 14.4 14.7 14.3 14.8L13.3 16.5C13.3 16.6 13.3 16.7 13.4 16.8L14.5 17.6V18.6L13.4 19.4C13.3 19.5 13.2 19.6 13.3 19.7L14.3 21.4C14.4 21.5 14.5 21.5 14.6 21.5L15.8 21C16 21.2 16.3 21.4 16.6 21.5L16.8 22.8C16.9 22.9 17 23 17.1 23H19.1C19.2 23 19.3 22.9 19.3 22.8L19.5 21.5C19.8 21.3 20 21.2 20.3 21L21.5 21.4C21.6 21.4 21.7 21.4 21.8 21.3L22.8 19.6C22.9 19.5 22.9 19.4 22.8 19.4L21.7 18.6M18 19.5C17.2 19.5 16.5 18.8 16.5 18S17.2 16.5 18 16.5 19.5 17.2 19.5 18 18.8 19.5 18 19.5M12.3 22H3C1.9 22 1 21.1 1 20V4C1 2.9 1.9 2 3 2H21C22.1 2 23 2.9 23 4V13.1C22.4 12.5 21.7 12 21 11.7V6H3V20H11.3C11.5 20.7 11.8 21.4 12.3 22Z";
var mdiApplicationEdit = "M11 20.1L19.2 11.9C19.7 11.4 20.3 11.1 21 11.1C21.7 11.1 22.3 11.4 22.8 11.9L23 12.1V4C23 2.9 22.1 2 21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H11V20.1M3 4H21V7H3V4M21 13.1C20.9 13.1 20.7 13.2 20.6 13.3L19.6 14.3L21.7 16.4L22.7 15.4C22.9 15.2 22.9 14.8 22.7 14.6L21.4 13.3C21.3 13.2 21.2 13.1 21 13.1M19.1 14.9L13 20.9V23H15.1L21.2 16.9L19.1 14.9Z";
var mdiApplicationEditOutline = "M11 20V22H3C1.9 22 1 21.1 1 20V4C1 2.9 1.9 2 3 2H21C22.1 2 23 2.9 23 4V12.1L22.8 11.9C22.3 11.4 21.7 11.1 21 11.1V6H3V20H11M21.4 13.3L22.7 14.6C22.9 14.8 22.9 15.2 22.7 15.4L21.7 16.4L19.6 14.3L20.6 13.3C20.7 13.2 20.8 13.1 21 13.1C21.2 13.1 21.3 13.2 21.4 13.3M21.1 16.9L15.1 23H13V20.9L19.1 14.8L21.1 16.9Z";
var mdiApplicationExport = "M9 12H18.8L16.3 9.5L17.7 8.1L22.6 13L17.7 17.9L16.3 16.5L18.8 14H9V12M21 17.4V20H3V6H21V8.6L23 10.6V4C23 2.9 22.1 2 21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V15.4L21 17.4Z";
var mdiApplicationImport = "M1 12H10.8L8.3 9.5L9.7 8.1L14.6 13L9.7 17.9L8.3 16.5L10.8 14H1V12M21 2H3C1.9 2 1 2.9 1 4V10.1H3V6H21V20H3V16H1V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2";
var mdiApplicationOutline = "M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M21 20H3V6H21V20Z";
var mdiApplicationParentheses = "M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M10 19.4L8.4 20C6.9 18.6 6 16.6 6 14.5S6.9 10.4 8.4 9L10 9.6C8.7 10.7 8 12.6 8 14.5S8.7 18.2 10 19.4M15.6 20L14 19.4C15.3 18.2 16 16.4 16 14.5S15.3 10.8 14 9.6L15.6 9C17.1 10.4 18 12.4 18 14.5C18 16.6 17.1 18.6 15.6 20M21 7H3V4H21V7Z";
var mdiApplicationParenthesesOutline = "M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M21 20H3V6H21V20M15.6 8C17.1 9.3 18 11.1 18 13C18 14.9 17.1 16.7 15.6 18L14 17.4C15.3 16.4 16 14.7 16 13S15.3 9.6 14 8.6L15.6 8M8.4 8L10 8.6C8.7 9.6 8 11.3 8 13S8.7 16.4 10 17.4L8.4 18C6.9 16.7 6 14.9 6 13S6.9 9.3 8.4 8Z";
var mdiApplicationSettings = "M21 0H3C1.9 0 1 .9 1 2V18C1 19.1 1.9 20 3 20H21C22.1 20 23 19.1 23 18V2C23 .9 22.1 0 21 0M21 5H3V2H21V5M7 22H9V24H7V22M11 22H13V24H11V22M15 22H17V24H15V22";
var mdiApplicationSettingsOutline = "M21 0H3C1.9 0 1 .9 1 2V18C1 19.1 1.9 20 3 20H21C22.1 20 23 19.1 23 18V2C23 .9 22.1 0 21 0M21 18H3V4H21V18M7 22H9V24H7V22M11 22H13V24H11V22M15 22H17V24H15V22";
var mdiApplicationVariable = "M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M7.4 20C5.9 18.6 5 16.6 5 14.5S5.9 10.4 7.4 9L9 9.6C7.7 10.7 7 12.6 7 14.5S7.7 18.2 9 19.4L7.4 20M12.7 18L11.9 16L10.5 18H9L11.3 14.9L10 12H11.3L12.1 14L13.5 12H15L12.8 15L14.1 18H12.7M16.6 20L15 19.4C16.3 18.2 17 16.4 17 14.5S16.3 10.8 15 9.6L16.6 9C18.1 10.4 19 12.4 19 14.5C19 16.6 18.1 18.6 16.6 20M21 7H3V4H21V7Z";
var mdiApplicationVariableOutline = "M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M21 20H3V6H21V20M16.6 8C18.1 9.3 19 11.1 19 13C19 14.9 18.1 16.7 16.6 18L15 17.4C16.3 16.4 17 14.7 17 13S16.3 9.6 15 8.6L16.6 8M7.4 8L9 8.6C7.7 9.6 7 11.3 7 13S7.7 16.4 9 17.4L7.4 18C5.9 16.7 5 14.9 5 13S5.9 9.3 7.4 8M12.1 12L13.5 10H15L12.8 13L14.1 16H12.8L12 14L10.6 16H9L11.3 12.9L10 10H11.3L12.1 12Z";
var mdiApproximatelyEqual = "M18.9 9.2C18.1 10.1 16.6 11 15 11C13.5 11 12.6 10.5 11.8 10.1C11 9.8 10.2 9.3 8.9 9.3C7.7 9.3 6.6 10 6 10.6L5 9.1C5.9 8.2 7.3 7.2 8.9 7.2C10.4 7.2 11.3 7.8 12.1 8.1C12.9 8.4 13.7 9 15 9C16.2 9 17.3 8.2 17.9 7.6L18.9 9.2M19 14.1C18.1 15 16.7 16 15.1 16C13.6 16 12.7 15.5 11.9 15.1C11.1 14.8 10.3 14.2 9 14.2C7.8 14.2 6.7 15 6.1 15.6L5.1 14C6 13.1 7.4 12.1 9 12.1C10.5 12.1 11.4 12.6 12.2 13C13 13.3 13.8 13.8 15.1 13.8C16.3 13.8 17.4 13 18 12.4L19 14.1Z";
var mdiApproximatelyEqualBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.3 8.2C10.6 8.2 11.4 8.7 12.1 9C12.7 9.3 13.4 9.7 14.5 9.7C15.5 9.7 16.5 9 17 8.5L17.8 9.8C17.1 10.6 15.8 11.4 14.4 11.4C13.1 11.4 12.3 10.9 11.7 10.6C11.1 10.3 10.3 9.9 9.2 9.9C8.2 9.9 7.2 10.6 6.7 11.1L6 9.8C6.7 9 8 8.2 9.3 8.2M14.6 15.8C13.3 15.8 12.5 15.3 11.8 15C11.2 14.7 10.4 14.3 9.3 14.3C8.3 14.3 7.3 15 6.8 15.5L6 14.1C6.7 13.3 8 12.5 9.3 12.5C10.6 12.5 11.4 13 12.1 13.3C12.7 13.6 13.4 14 14.6 14C15.6 14 16.6 13.3 17.1 12.8L17.9 14.1C17.3 15 16 15.8 14.6 15.8Z";
var mdiApps = "M16,20H20V16H16M16,14H20V10H16M10,8H14V4H10M16,8H20V4H16M10,14H14V10H10M4,14H8V10H4M4,20H8V16H4M10,20H14V16H10M4,8H8V4H4V8Z";
var mdiAppsBox = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M7,7V9H9V7H7M11,7V9H13V7H11M15,7V9H17V7H15M7,11V13H9V11H7M11,11V13H13V11H11M15,11V13H17V11H15M7,15V17H9V15H7M11,15V17H13V15H11M15,15V17H17V15H15Z";
var mdiArch = "M12,2C11.11,4.18 10.57,5.61 9.58,7.73C10.19,8.37 10.93,9.12 12.14,9.97C10.84,9.43 9.95,8.9 9.29,8.34C8,11 6.03,14.75 2,22C5.17,20.17 7.63,19.04 9.92,18.61C9.82,18.19 9.76,17.73 9.77,17.25V17.15C9.82,15.12 10.88,13.56 12.13,13.67C13.38,13.77 14.35,15.5 14.3,17.54C14.29,17.92 14.25,18.29 14.18,18.63C16.44,19.07 18.87,20.19 22,22C21.38,20.86 20.83,19.84 20.31,18.87C19.5,18.23 18.61,17.39 16.85,16.5C18.06,16.8 18.93,17.16 19.61,17.57C14.26,7.62 13.83,6.3 12,2Z";
var mdiArchive = "M3,3H21V7H3V3M4,8H20V21H4V8M9.5,11A0.5,0.5 0 0,0 9,11.5V13H15V11.5A0.5,0.5 0 0,0 14.5,11H9.5Z";
var mdiArchiveAlert = "M2 4H18V7H2V4M3 8H17V20H3V8M7.5 11C7.22 11 7 11.22 7 11.5V13H13V11.5C13 11.22 12.78 11 12.5 11H7.5M20 13V7H22V13H20M20 17V15H22V17H20Z";
var mdiArchiveAlertOutline = "M2 4H18V7H2V4M7.5 11H12.5C12.78 11 13 11.22 13 11.5V13H7V11.5C7 11.22 7.22 11 7.5 11M20 13V7H22V13H20M20 17V15H22V17H20M3 8H5V18H15V8H17V20H3V8Z";
var mdiArchiveArrowDown = "M3 3H21V7H3V3M4 21V8H20V21H4M14 14V11H10V14H7L12 19L17 14H14Z";
var mdiArchiveArrowDownOutline = "M20 21H4V10H6V19H18V10H20V21M3 3H21V9H3V3M5 5V7H19V5M10.5 11V14H8L12 18L16 14H13.5V11";
var mdiArchiveArrowUp = "M4 21H20V8H4M14 15V18H10V15H7L12 10L17 15M3 3H21V7H3";
var mdiArchiveArrowUpOutline = "M20 21H4V10H6V19H18V10H20V21M3 3H21V9H3V3M5 5V7H19V5M10.5 17V14H8L12 10L16 14H13.5V17";
var mdiArchiveCancel = "M18.5 12C19 12 19.5 12.07 20 12.18V8H4V21H12.5C12.18 20.23 12 19.39 12 18.5C12 14.91 14.91 12 18.5 12M9 13V11.5C9 11.22 9.22 11 9.5 11H14.5C14.78 11 15 11.22 15 11.5V13H9M21 7H3V3H21V7M18.5 14C16 14 14 16 14 18.5S16 23 18.5 23 23 21 23 18.5 21 14 18.5 14M18.5 21.5C16.84 21.5 15.5 20.16 15.5 18.5C15.5 17.94 15.65 17.42 15.92 17L20 21.08C19.58 21.35 19.06 21.5 18.5 21.5M21.08 20L17 15.92C17.42 15.65 17.94 15.5 18.5 15.5C20.16 15.5 21.5 16.84 21.5 18.5C21.5 19.06 21.35 19.58 21.08 20Z";
var mdiArchiveCancelOutline = "M14.5 11C14.78 11 15 11.22 15 11.5V13H9V11.5C9 11.22 9.22 11 9.5 11H14.5M18.5 12C19 12 19.5 12.07 20 12.18V10H18V12.03C18.17 12 18.33 12 18.5 12M6 19V10H4V21H12.5C12.24 20.38 12.09 19.7 12.03 19H6M21 9H3V3H21V9M19 5H5V7H19V5M23 18.5C23 21 21 23 18.5 23S14 21 14 18.5 16 14 18.5 14 23 16 23 18.5M20 21.08L15.92 17C15.65 17.42 15.5 17.94 15.5 18.5C15.5 20.16 16.84 21.5 18.5 21.5C19.06 21.5 19.58 21.35 20 21.08M21.5 18.5C21.5 16.84 20.16 15.5 18.5 15.5C17.94 15.5 17.42 15.65 17 15.92L21.08 20C21.35 19.58 21.5 19.06 21.5 18.5Z";
var mdiArchiveCheck = "M19 13C19.34 13 19.67 13.04 20 13.09V8H4V21H13.35C13.13 20.37 13 19.7 13 19C13 15.69 15.69 13 19 13M9 13V11.5C9 11.22 9.22 11 9.5 11H14.5C14.78 11 15 11.22 15 11.5V13H9M21 7H3V3H21V7M22.5 17.25L17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25Z";
var mdiArchiveCheckOutline = "M21 3H3V9H21V3M19 7H5V5H19V7M14.5 11C14.78 11 15 11.22 15 11.5V13H9V11.5C9 11.22 9.22 11 9.5 11H14.5M18 13.09V10H20V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09M13 19C13 19.7 13.13 20.37 13.35 21H4V10H6V19H13M22.5 17.25L17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25Z";
var mdiArchiveClock = "M20 6H2V2H20V6M16.5 12H15V17L18.61 19.16L19.36 17.94L16.5 16.25V12M23 16C23 19.87 19.87 23 16 23C13.62 23 11.53 21.81 10.26 20H3V7H19V9.68C21.36 10.81 23 13.21 23 16M8 12H10.26C10.83 11.19 11.56 10.5 12.41 10H8.5C8.22 10 8 10.22 8 10.5V12M21 16C21 13.24 18.76 11 16 11S11 13.24 11 16 13.24 21 16 21 21 18.76 21 16Z";
var mdiArchiveClockOutline = "M20 2H2V8H20V2M18 6H4V4H18V6M16 9C14.69 9 13.46 9.37 12.41 10H8.5C8.22 10 8 10.22 8 10.5V12H10.26C9.47 13.13 9 14.5 9 16C9 16.7 9.11 17.37 9.29 18H5V9H3V20H10.26C11.53 21.81 13.62 23 16 23C19.87 23 23 19.87 23 16C23 12.13 19.87 9 16 9M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25Z";
var mdiArchiveCog = "M21 7H3V3H21V7M12 19C12 19.7 12.11 20.37 12.3 21H4V8H20V12.08C19.67 12.03 19.34 12 19 12C15.13 12 12 15.13 12 19M15 13V11.5C15 11.22 14.78 11 14.5 11H9.5C9.22 11 9 11.22 9 11.5V13H15M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiArchiveCogOutline = "M18 12.08V10H20V12.08C19.67 12.03 19.34 12 19 12C18.66 12 18.33 12.03 18 12.08M9.5 11C9.22 11 9 11.22 9 11.5V13H15V11.5C15 11.22 14.78 11 14.5 11H9.5M6 19V10H4V21H12.3C12.11 20.37 12 19.7 12 19H6M21 9H3V3H21V9M19 5H5V7H19V5M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiArchiveEdit = "M20 10.3V8H4V21H11V19.13L19.39 10.74C19.57 10.56 19.78 10.42 20 10.3M15 13H9V11.5C9 11.22 9.22 11 9.5 11H14.5C14.78 11 15 11.22 15 11.5V13M21 7H3V3H21V7M22.85 14.19L21.87 15.17L19.83 13.13L20.81 12.15C21 11.95 21.33 11.95 21.53 12.15L22.85 13.47C23.05 13.67 23.05 14 22.85 14.19M19.13 13.83L21.17 15.87L15.04 22H13V19.96L19.13 13.83Z";
var mdiArchiveEditOutline = "M18 12.13V10H20V10.3C19.78 10.42 19.57 10.56 19.39 10.74L18 12.13M9.5 11C9.22 11 9 11.22 9 11.5V13H15V11.5C15 11.22 14.78 11 14.5 11H9.5M6 10H4V21H11V19.13L11.13 19H6V10M21 9H3V3H21V9M19 5H5V7H19V5M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47Z";
var mdiArchiveEye = "M21 7H3V3H21V7M9.14 19.75C9.32 20.19 9.54 20.61 9.78 21H4V8H20V13.55C19.06 13.19 18.05 13 17 13C13.5 13 10.43 15.06 9.14 18.25L8.85 19L9.14 19.75M9 13H15V11.5C15 11.22 14.78 11 14.5 11H9.5C9.22 11 9 11.22 9 11.5V13M17 18C16.44 18 16 18.44 16 19S16.44 20 17 20 18 19.56 18 19 17.56 18 17 18M23 19C22.06 21.34 19.73 23 17 23S11.94 21.34 11 19C11.94 16.66 14.27 15 17 15S22.06 16.66 23 19M19.5 19C19.5 17.62 18.38 16.5 17 16.5S14.5 17.62 14.5 19 15.62 21.5 17 21.5 19.5 20.38 19.5 19Z";
var mdiArchiveEyeOutline = "M14.5 11C14.78 11 15 11.22 15 11.5V13H9V11.5C9 11.22 9.22 11 9.5 11H14.5M20 13.55V10H18V13.06C18.69 13.14 19.36 13.31 20 13.55M21 9H3V3H21V9M19 5H5V7H19V5M8.85 19H6V10H4V21H9.78C9.54 20.61 9.32 20.19 9.14 19.75L8.85 19M17 18C16.44 18 16 18.44 16 19S16.44 20 17 20 18 19.56 18 19 17.56 18 17 18M23 19C22.06 21.34 19.73 23 17 23S11.94 21.34 11 19C11.94 16.66 14.27 15 17 15S22.06 16.66 23 19M19.5 19C19.5 17.62 18.38 16.5 17 16.5S14.5 17.62 14.5 19 15.62 21.5 17 21.5 19.5 20.38 19.5 19Z";
var mdiArchiveLock = "M21 7H3V3H21V7M9.5 11H14.5C14.78 11 15 11.22 15 11.5V12.06C15.87 10.83 17.35 10 19 10C19.34 10 19.68 10.04 20 10.11V8H4V21H13.03C13 20.9 13 20.8 13 20.7V17.2C13 16.24 13.5 15.34 14.2 14.74V14.5C14.2 14 14.32 13.47 14.5 13H9V11.5C9 11.22 9.22 11 9.5 11M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiArchiveLockOpen = "M21 7H3V3H21V7M19 9C19.34 9 19.68 9.04 20 9.11V8H4V21H13.03C13 20.9 13 20.8 13 20.7V17.2C13 16.24 13.5 15.34 14.2 14.74V13.5C14.2 13.33 14.24 13.17 14.26 13H9V11.5C9 11.22 9.22 11 9.5 11H14.5C14.67 11 14.82 11.09 14.91 11.22C15.75 9.91 17.28 9 19 9M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiArchiveLockOpenOutline = "M14.5 11C14.67 11 14.82 11.09 14.91 11.22C14.56 11.76 14.34 12.36 14.26 13H9V11.5C9 11.22 9.22 11 9.5 11H14.5M13 19H6V10H4V21H13.03C13 20.9 13 20.8 13 20.7V19M21 9H3V3H21V9M19 5H5V7H19V5M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiArchiveLockOutline = "M15 12.06C14.79 12.35 14.64 12.67 14.5 13H9V11.5C9 11.22 9.22 11 9.5 11H14.5C14.78 11 15 11.22 15 11.5V12.06M21 9H3V3H21V9M19 5H5V7H19V5M13 19H6V10H4V21H13.03C13 20.9 13 20.8 13 20.7V19M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiArchiveMarker = "M21 7H3V3H21V7M13.63 13H9V11.5C9 11.22 9.22 11 9.5 11H14.5C14.72 11 14.9 11.14 14.97 11.33C15.93 10.5 17.17 10 18.5 10C19 10 19.5 10.08 20 10.22V8H4V21H15.19C14.12 19.43 13 17.35 13 15.5C13 14.61 13.23 13.76 13.63 13M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiArchiveMarkerOutline = "M14.5 11C14.72 11 14.9 11.14 14.97 11.33C14.42 11.79 13.96 12.36 13.63 13H9V11.5C9 11.22 9.22 11 9.5 11H14.5M21 9H3V3H21V9M19 5H5V7H19V5M6 19V10H4V21H15.19C14.78 20.4 14.36 19.72 14 19H6M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiArchiveMinus = "M19 13C19.34 13 19.67 13.04 20 13.09V8H4V21H13.35C13.13 20.37 13 19.7 13 19C13 15.69 15.69 13 19 13M9 13V11.5C9 11.22 9.22 11 9.5 11H14.5C14.78 11 15 11.22 15 11.5V13H9M21 7H3V3H21V7M23 18V20H15V18H23Z";
var mdiArchiveMinusOutline = "M13 19C13 19.7 13.13 20.37 13.35 21H4V10H6V19H13M19 13C19.34 13 19.67 13.04 20 13.09V10H18V13.09C18.33 13.04 18.66 13 19 13M9.5 11C9.22 11 9 11.22 9 11.5V13H15V11.5C15 11.22 14.78 11 14.5 11H9.5M21 9H3V3H21V9M19 5H5V7H19V5M15 18V20H23V18H15Z";
var mdiArchiveMusic = "M16.5 16.11V11H20V8H4V21H13.03C13 20.84 13 20.67 13 20.5C13 18.36 14.5 16.57 16.5 16.11M9 13V11.5C9 11.22 9.22 11 9.5 11H14.5C14.78 11 15 11.22 15 11.5V13H9M21 7H3V3H21V7M22 13V15H20V20.5C20 21.88 18.88 23 17.5 23S15 21.88 15 20.5 16.12 18 17.5 18C17.86 18 18.19 18.07 18.5 18.21V13H22Z";
var mdiArchiveMusicOutline = "M21 3H3V9H21V3M19 7H5V5H19V7M18 11V10H20V11H18M14.5 11C14.78 11 15 11.22 15 11.5V13H9V11.5C9 11.22 9.22 11 9.5 11H14.5M13.26 19C13.09 19.47 13 19.97 13 20.5C13 20.67 13 20.84 13.03 21H4V10H6V19H13.26M22 13V15H20V20.5C20 21.88 18.88 23 17.5 23S15 21.88 15 20.5 16.12 18 17.5 18C17.86 18 18.19 18.07 18.5 18.21V13H22Z";
var mdiArchiveOff = "M10.2 7L6.2 3H21V7H10.2M20 8H11.2L20 16.8V8M20 19.35V19.34L8.66 8H8.66L7.66 7H7.66L2.39 1.73L1.11 3L3 4.89V7H5.11L6.11 8H4V21H19.11L20.84 22.73L22.11 21.46L20 19.35Z";
var mdiArchiveOffOutline = "M8.2 5L6.2 3H21V9H12.2L10.2 7H19V5H8.2M20 16.8V10H18V14.8L20 16.8M20 19.35V19.34L18 17.34V17.35L9.66 9H9.66L7.66 7H7.66L6.13 5.47L2.39 1.73L1.11 3L3 4.89V9H7.11L17.11 19H6V10H4V21H19.11L20.84 22.73L22.11 21.46L20 19.35Z";
var mdiArchiveOutline = "M20 21H4V10H6V19H18V10H20V21M3 3H21V9H3V3M9.5 11H14.5C14.78 11 15 11.22 15 11.5V13H9V11.5C9 11.22 9.22 11 9.5 11M5 5V7H19V5H5Z";
var mdiArchivePlus = "M21 7H3V3H21V7M13 19C13 19.7 13.13 20.37 13.35 21H4V8H20V13.09C19.67 13.04 19.34 13 19 13C15.69 13 13 15.69 13 19M15 13V11.5C15 11.22 14.78 11 14.5 11H9.5C9.22 11 9 11.22 9 11.5V13H15M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiArchivePlusOutline = "M18 13.09V10H20V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09M9.5 11C9.22 11 9 11.22 9 11.5V13H15V11.5C15 11.22 14.78 11 14.5 11H9.5M21 9H3V3H21V9M19 5H5V7H19V5M6 19V10H4V21H13.35C13.13 20.37 13 19.7 13 19H6M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiArchiveRefresh = "M18.5 12C19 12 19.5 12.07 20 12.18V8H4V21H12.5C12.18 20.23 12 19.39 12 18.5C12 14.91 14.91 12 18.5 12M9 13V11.5C9 11.22 9.22 11 9.5 11H14.5C14.78 11 15 11.22 15 11.5V13H9M21 7H3V3H21V7M18 18.5L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5S16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5S15.79 14.5 18 14.5C19.11 14.5 20.11 14.95 20.83 15.67L22 14.5V18.5H18Z";
var mdiArchiveRefreshOutline = "M18 12.03V10H20V12.18C19.5 12.07 19 12 18.5 12C18.33 12 18.17 12 18 12.03M9.5 11C9.22 11 9 11.22 9 11.5V13H15V11.5C15 11.22 14.78 11 14.5 11H9.5M6 19V10H4V21H12.5C12.24 20.38 12.09 19.7 12.03 19H6M21 9H3V3H21V9M19 5H5V7H19V5M22 18.5V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22Z";
var mdiArchiveRemove = "M21 7H3V3H21V7M13 19C13 19.7 13.13 20.37 13.35 21H4V8H20V13.09C19.67 13.04 19.34 13 19 13C15.69 13 13 15.69 13 19M15 13V11.5C15 11.22 14.78 11 14.5 11H9.5C9.22 11 9 11.22 9 11.5V13H15M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiArchiveRemoveOutline = "M18 13.09V10H20V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09M14.5 11H9.5C9.22 11 9 11.22 9 11.5V13H15V11.5C15 11.22 14.78 11 14.5 11M6 19V10H4V21H13.35C13.13 20.37 13 19.7 13 19H6M21 9H3V3H21V9M19 5H5V7H19V5M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiArchiveSearch = "M20 6H2V2H20V6M11.03 12H8V10.5C8 10.22 8.22 10 8.5 10H13.04C14.84 8.87 17.07 8.7 19 9.5V7H3V20H11.82C9.7 17.8 9.44 14.5 11.03 12M23.39 21L22 22.39L18.88 19.32C18.19 19.75 17.37 20 16.5 20C14 20 12 18 12 15.5S14 11 16.5 11 21 13 21 15.5C21 16.38 20.75 17.21 20.31 17.9L23.39 21M19 15.5C19 14.12 17.88 13 16.5 13S14 14.12 14 15.5 15.12 18 16.5 18 19 16.88 19 15.5Z";
var mdiArchiveSearchOutline = "M13.04 10C12.64 10.25 12.26 10.55 11.9 10.9C11.57 11.24 11.27 11.61 11.03 12H8V10.5C8 10.22 8.22 10 8.5 10H13.04M20 8H2V2H20V8M18 4H4V6H18V4M5 18V9H3V20H11.82C11.24 19.4 10.8 18.72 10.5 18H5M23.39 21L22 22.39L18.88 19.32C18.19 19.75 17.37 20 16.5 20C14 20 12 18 12 15.5S14 11 16.5 11 21 13 21 15.5C21 16.38 20.75 17.21 20.31 17.9L23.39 21M19 15.5C19 14.12 17.88 13 16.5 13S14 14.12 14 15.5 15.12 18 16.5 18 19 16.88 19 15.5Z";
var mdiArchiveSettings = "M21 2V6H3V2H21M4 7H20V20H4V7M9 12H15V10.5C15 10.22 14.78 10 14.5 10H9.5C9.22 10 9 10.22 9 10.5V12M7 24H9V22H7V24M11 24H13V22H11V24M15 24H17V22H15V24Z";
var mdiArchiveSettingsOutline = "M3 2V8H21V2H3M19 6H5V4H19V6M18 9H20V20H4V9H6V18H18V9M15 10.5V12H9V10.5C9 10.22 9.22 10 9.5 10H14.5C14.78 10 15 10.22 15 10.5M7 22H9V24H7V22M11 22H13V24H11V22M15 22H17V24H15V22Z";
var mdiArchiveStar = "M21 7H3V3H21V7M13 19C13 19.7 13.13 20.37 13.35 21H4V8H20V13.09C19.67 13.04 19.34 13 19 13C15.69 13 13 15.69 13 19M15 13V11.5C15 11.22 14.78 11 14.5 11H9.5C9.22 11 9 11.22 9 11.5V13H15M23 17.89L20.11 17.64L19 15L17.87 17.64L15 17.89L17.18 19.77L16.5 22.58L19 21.09L21.45 22.58L20.8 19.77L23 17.89Z";
var mdiArchiveStarOutline = "M18 13.09V10H20V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09M9.5 11C9.22 11 9 11.22 9 11.5V13H15V11.5C15 11.22 14.78 11 14.5 11H9.5M6 19V10H4V21H13.35C13.13 20.37 13 19.7 13 19H6M21 9H3V3H21V9M19 5H5V7H19V5M23 17.89L20.11 17.64L19 15L17.87 17.64L15 17.89L17.18 19.77L16.5 22.58L19 21.09L21.45 22.58L20.8 19.77L23 17.89Z";
var mdiArchiveSync = "M21 7H3V3H21V7M9.5 11H14.5C14.78 11 15 11.22 15 11.5V12.82C16.17 11.69 17.75 11 19.5 11C19.67 11 19.84 11 20 11.03V8H4V21H14.03C13.38 20 13 18.79 13 17.5C13 15.75 13.69 14.17 14.82 13H9V11.5C9 11.22 9.22 11 9.5 11M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20Z";
var mdiArchiveSyncOutline = "M18 11.18V10H20V11.03C19.84 11 19.67 11 19.5 11C19 11 18.5 11.07 18 11.18M15 11.5C15 11.22 14.78 11 14.5 11H9.5C9.22 11 9 11.22 9 11.5V13H14.82C14.88 12.94 14.94 12.88 15 12.82V11.5M6 19V10H4V21H14.03C13.64 20.39 13.35 19.72 13.18 19H6M21 9H3V3H21V9M19 5H5V7H19V5M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20Z";
var mdiArmFlex = "M3 18.34C3 18.34 4 7.09 7 3L12 4L11 7.09H9V14.25H10C12 11.18 16.14 10.06 18.64 11.18C21.94 12.71 21.64 17.32 18.64 19.36C16.24 21 9 22.43 3 18.34Z";
var mdiArmFlexOutline = "M7 7.76V16.25H11.08L11.68 15.34C12.84 13.55 14.93 12.75 16.47 12.75C17 12.75 17.45 12.84 17.79 13C18.7 13.41 18.95 14.18 19 14.74C19.08 15.87 18.5 17.03 17.5 17.71C16.6 18.33 14.44 19 11.87 19C10.12 19 7.61 18.69 5.12 17.3C5.41 14.85 6 10.88 7 7.76M7 3C4 7.09 3 18.34 3 18.34C5.9 20.31 9.08 21 11.87 21C14.86 21 17.39 20.21 18.64 19.36C21.64 17.32 21.94 12.71 18.64 11.18C18 10.89 17.26 10.75 16.47 10.75C14.17 10.75 11.5 11.96 10 14.25H9V7.09H11L12 4L7 3Z";
var mdiArrangeBringForward = "M2,2H16V16H2V2M22,8V22H8V18H10V20H20V10H18V8H22Z";
var mdiArrangeBringToFront = "M2,2H11V6H9V4H4V9H6V11H2V2M22,13V22H13V18H15V20H20V15H18V13H22M8,8H16V16H8V8Z";
var mdiArrangeSendBackward = "M2,2H16V16H2V2M22,8V22H8V18H18V8H22M4,4V14H14V4H4Z";
var mdiArrangeSendToBack = "M2,2H11V11H2V2M9,4H4V9H9V4M22,13V22H13V13H22M15,20H20V15H15V20M16,8V11H13V8H16M11,16H8V13H11V16Z";
var mdiArrowAll = "M13,11H18L16.5,9.5L17.92,8.08L21.84,12L17.92,15.92L16.5,14.5L18,13H13V18L14.5,16.5L15.92,17.92L12,21.84L8.08,17.92L9.5,16.5L11,18V13H6L7.5,14.5L6.08,15.92L2.16,12L6.08,8.08L7.5,9.5L6,11H11V6L9.5,7.5L8.08,6.08L12,2.16L15.92,6.08L14.5,7.5L13,6V11Z";
var mdiArrowBottomLeft = "M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z";
var mdiArrowBottomLeftBoldBox = "M5 21C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5M15.3 16L13.2 13.9L17 10L14.2 7.2L10.4 11.1L8.2 8.9V16H15.3Z";
var mdiArrowBottomLeftBoldBoxOutline = "M8 16V8.9L10.1 11L14.2 7.1L17 10L12.9 13.9L15 16H8M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19M19 19H5V5H19V19Z";
var mdiArrowBottomLeftBoldOutline = "M18.36,19.78H4.22V5.64L8.47,9.88L14.12,4.22L19.78,9.88L14.12,15.54L18.36,19.78M6.34,17.66H13.41L11.29,15.54L16.95,9.88L14.12,7.05L8.46,12.71L6.34,10.59V17.66Z";
var mdiArrowBottomLeftThick = "M15.5,5.69L18.31,8.5L11.94,14.89H16.89V18.31H5.69V7.11H9.12V12.06L15.5,5.69Z";
var mdiArrowBottomLeftThin = "M12.07 19L9.24 16.18L19 6.42L17.58 5L7.82 14.76L5 11.94V19Z";
var mdiArrowBottomLeftThinCircleOutline = "M12 20.03C16.41 20.03 20.03 16.41 20.03 12C20.03 7.59 16.41 3.97 12 3.97C7.59 3.97 3.97 7.59 3.97 12C3.97 16.41 7.59 20.03 12 20.03M12 22C6.46 22 2 17.54 2 12C2 6.46 6.46 2 12 2C17.54 2 22 6.46 22 12C22 17.54 17.54 22 12 22M10.12 12.47L8 10.36V16H13.64L11.53 13.88L16.5 8.9L15.1 7.5";
var mdiArrowBottomRight = "M5,6.41L6.41,5L17,15.59V9H19V19H9V17H15.59L5,6.41Z";
var mdiArrowBottomRightBoldBox = "M19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21M15.8 16V8.9L13.7 11L9.8 7.2L7 10L10.8 13.9L8.7 16H15.8Z";
var mdiArrowBottomRightBoldBoxOutline = "M16 16H8.9L11 13.9L7 10L9.8 7.2L13.9 11.1L16 8.9V16M5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21M5 5H19V19H5V5Z";
var mdiArrowBottomRightBoldOutline = "M9.88,15.54L4.22,9.88L9.88,4.22L15.54,9.88L19.78,5.64V19.78H5.64L9.88,15.54M17.66,10.59L15.54,12.71L9.88,7.05L7.05,9.88L12.71,15.54L10.59,17.66H17.66V10.59Z";
var mdiArrowBottomRightThick = "M14.89,12.06V7.11H18.31V18.31H7.11V14.89H12.06L5.69,8.5L8.5,5.69L14.89,12.06Z";
var mdiArrowBottomRightThin = "M11.93 19L14.76 16.18L5 6.42L6.42 5L16.18 14.76L19 11.94V19Z";
var mdiArrowBottomRightThinCircleOutline = "M12 20.03C7.59 20.03 3.97 16.41 3.97 12C3.97 7.59 7.59 3.97 12 3.97C16.41 3.97 20.03 7.59 20.03 12C20.03 16.41 16.41 20.03 12 20.03M12 22C17.54 22 22 17.54 22 12C22 6.46 17.54 2 12 2C6.46 2 2 6.46 2 12C2 17.54 6.46 22 12 22M13.88 12.47L16 10.36V16H10.36L12.47 13.88L7.5 8.9L8.9 7.5";
var mdiArrowCollapse = "M19.5,3.09L15,7.59V4H13V11H20V9H16.41L20.91,4.5L19.5,3.09M4,13V15H7.59L3.09,19.5L4.5,20.91L9,16.41V20H11V13H4Z";
var mdiArrowCollapseAll = "M19.5,3.09L20.91,4.5L16.41,9H20V11H13V4H15V7.59L19.5,3.09M20.91,19.5L19.5,20.91L15,16.41V20H13V13H20V15H16.41L20.91,19.5M4.5,3.09L9,7.59V4H11V11H4V9H7.59L3.09,4.5L4.5,3.09M3.09,19.5L7.59,15H4V13H11V20H9V16.41L4.5,20.91L3.09,19.5Z";
var mdiArrowCollapseDown = "M19.92,12.08L12,20L4.08,12.08L5.5,10.67L11,16.17V2H13V16.17L18.5,10.66L19.92,12.08M12,20H2V22H22V20H12Z";
var mdiArrowCollapseHorizontal = "M13,20V4H15.03V20H13M10,20V4H12.03V20H10M5,8L9.03,12L5,16V13H2V11H5V8M20,16L16,12L20,8V11H23V13H20V16Z";
var mdiArrowCollapseLeft = "M11.92,19.92L4,12L11.92,4.08L13.33,5.5L7.83,11H22V13H7.83L13.34,18.5L11.92,19.92M4,12V2H2V22H4V12Z";
var mdiArrowCollapseRight = "M12.08,4.08L20,12L12.08,19.92L10.67,18.5L16.17,13H2V11H16.17L10.67,5.5L12.08,4.08M20,12V22H22V2H20V12Z";
var mdiArrowCollapseUp = "M4.08,11.92L12,4L19.92,11.92L18.5,13.33L13,7.83V22H11V7.83L5.5,13.33L4.08,11.92M12,4H22V2H2V4H12Z";
var mdiArrowCollapseVertical = "M4,12H20V14H4V12M4,9H20V11H4V9M16,4L12,8L8,4H11V1H13V4H16M8,19L12,15L16,19H13V22H11V19H8Z";
var mdiArrowDecision = "M11,5H8L12,1L16,5H13V9.43C12.25,9.89 11.58,10.46 11,11.12V5M22,11L18,7V10C14.39,9.85 11.31,12.57 11,16.17C9.44,16.72 8.62,18.44 9.17,20C9.72,21.56 11.44,22.38 13,21.83C14.56,21.27 15.38,19.56 14.83,18C14.53,17.14 13.85,16.47 13,16.17C13.47,12.17 17.47,11.97 17.95,11.97V14.97L22,11M10.63,11.59C9.3,10.57 7.67,10 6,10V7L2,11L6,15V12C7.34,12.03 8.63,12.5 9.64,13.4C9.89,12.76 10.22,12.15 10.63,11.59Z";
var mdiArrowDecisionAuto = "M12,5H9L13,1L17,5H14V9.43C13.25,9.89 12.58,10.46 12,11.12V5M10.4,15H8.5L7.8,13H4.6L3.9,15H2L5.2,6H7.2L10.4,15M7.35,11.65L6.2,8L5.05,11.65H7.35M23,11L19,7V10C15.39,9.85 12.31,12.57 12,16.17C10.44,16.72 9.62,18.44 10.17,20C10.72,21.56 12.44,22.38 14,21.83C15.56,21.27 16.38,19.56 15.83,18C15.53,17.14 14.85,16.47 14,16.17C14.47,12.17 18.47,11.97 18.95,11.97V14.97L23,11Z";
var mdiArrowDecisionAutoOutline = "M19,15V12C18.5,12 14.5,12.16 14.05,16.2C15.61,16.75 16.43,18.47 15.88,20.03C15.33,21.59 13.61,22.41 12.05,21.86C10.5,21.3 9.67,19.59 10.22,18.03C10.5,17.17 11.2,16.5 12.05,16.2C12.34,12.61 15.4,9.88 19,10V7L23,11L19,15M14,19A1,1 0 0,0 13,18A1,1 0 0,0 12,19A1,1 0 0,0 13,20A1,1 0 0,0 14,19M12,11.12C12.58,10.46 13.25,9.89 14,9.43V5H17L13,1L9,5H12V11.12M7.2,6H5.2L2,15H3.9L4.6,13H7.8L8.5,15H10.4L7.2,6M5.05,11.65L6.2,8L7.35,11.65H5.05Z";
var mdiArrowDecisionOutline = "M9.64,13.4C8.63,12.5 7.34,12.03 6,12V15L2,11L6,7V10C7.67,10 9.3,10.57 10.63,11.59C10.22,12.15 9.89,12.76 9.64,13.4M18,15V12C17.5,12 13.5,12.16 13.05,16.2C14.61,16.75 15.43,18.47 14.88,20.03C14.33,21.59 12.61,22.41 11.05,21.86C9.5,21.3 8.67,19.59 9.22,18.03C9.5,17.17 10.2,16.5 11.05,16.2C11.34,12.61 14.4,9.88 18,10V7L22,11L18,15M13,19A1,1 0 0,0 12,18A1,1 0 0,0 11,19A1,1 0 0,0 12,20A1,1 0 0,0 13,19M11,11.12C11.58,10.46 12.25,9.89 13,9.43V5H16L12,1L8,5H11V11.12Z";
var mdiArrowDown = "M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z";
var mdiArrowDownBold = "M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z";
var mdiArrowDownBoldBox = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M12,17L17,12H14V8H10V12H7L12,17Z";
var mdiArrowDownBoldBoxOutline = "M12,17L7,12H10V8H14V12H17L12,17M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiArrowDownBoldCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,17L17,12H14V8H10V12H7L12,17Z";
var mdiArrowDownBoldCircleOutline = "M12,17L7,12H10V8H14V12H17L12,17M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiArrowDownBoldHexagonOutline = "M12,17L7,12H10V8H14V12H17L12,17M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z";
var mdiArrowDownBoldOutline = "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z";
var mdiArrowDownBox = "M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M11,6V14.5L7.5,11L6.08,12.42L12,18.34L17.92,12.42L16.5,11L13,14.5V6H11Z";
var mdiArrowDownCircle = "M11,6V14L7.5,10.5L6.08,11.92L12,17.84L17.92,11.92L16.5,10.5L13,14V6H11M12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22Z";
var mdiArrowDownCircleOutline = "M11,6H13V14L16.5,10.5L17.92,11.92L12,17.84L6.08,11.92L7.5,10.5L11,14V6M12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20Z";
var mdiArrowDownDropCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M7,10L12,15L17,10H7Z";
var mdiArrowDownDropCircleOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M7,10L12,15L17,10H7Z";
var mdiArrowDownLeft = "M20 4V6H13.5C11 6 9 8 9 10.5V16.17L12.09 13.09L13.5 14.5L8 20L2.5 14.5L3.91 13.08L7 16.17V10.5C7 6.91 9.91 4 13.5 4H20Z";
var mdiArrowDownLeftBold = "M21 3V7H13.5C11.57 7 10 8.57 10 10.5V13H14L8 20L2 13H6V10.5C6 6.36 9.36 3 13.5 3H21Z";
var mdiArrowDownRight = "M21.5 14.5L16 20L10.5 14.5L11.91 13.09L15 16.17V10.5C15 8 13 6 10.5 6H4V4H10.5C14.09 4 17 6.91 17 10.5V16.17L20.09 13.08L21.5 14.5Z";
var mdiArrowDownRightBold = "M10.5 3C14.64 3 18 6.36 18 10.5V13H22L16 20L10 13H14V10.5C14 8.57 12.43 7 10.5 7H3V3H10.5Z";
var mdiArrowDownThick = "M10,4H14V13L17.5,9.5L19.92,11.92L12,19.84L4.08,11.92L6.5,9.5L10,13V4Z";
var mdiArrowDownThin = "M7.03 13.92H11.03V5L13.04 4.97V13.92H17.03L12.03 18.92Z";
var mdiArrowDownThinCircleOutline = "M12 20.03C16.41 20.03 20.03 16.41 20.03 12C20.03 7.59 16.41 3.97 12 3.97C7.59 3.97 3.97 7.59 3.97 12C3.97 16.41 7.59 20.03 12 20.03M12 22C6.46 22 2 17.54 2 12C2 6.46 6.46 2 12 2C17.54 2 22 6.46 22 12C22 17.54 17.54 22 12 22M11 13.54H8L12 17.5L16 13.54H13V6.5H11";
var mdiArrowExpand = "M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z";
var mdiArrowExpandAll = "M9.5,13.09L10.91,14.5L6.41,19H10V21H3V14H5V17.59L9.5,13.09M10.91,9.5L9.5,10.91L5,6.41V10H3V3H10V5H6.41L10.91,9.5M14.5,13.09L19,17.59V14H21V21H14V19H17.59L13.09,14.5L14.5,13.09M13.09,9.5L17.59,5H14V3H21V10H19V6.41L14.5,10.91L13.09,9.5Z";
var mdiArrowExpandDown = "M22,4V2H2V4H11V18.17L5.5,12.67L4.08,14.08L12,22L19.92,14.08L18.5,12.67L13,18.17V4H22Z";
var mdiArrowExpandHorizontal = "M9,11H15V8L19,12L15,16V13H9V16L5,12L9,8V11M2,20V4H4V20H2M20,20V4H22V20H20Z";
var mdiArrowExpandLeft = "M20,22H22V2H20V11H5.83L11.33,5.5L9.92,4.08L2,12L9.92,19.92L11.33,18.5L5.83,13H20V22Z";
var mdiArrowExpandRight = "M4,2H2V22H4V13H18.17L12.67,18.5L14.08,19.92L22,12L14.08,4.08L12.67,5.5L18.17,11H4V2Z";
var mdiArrowExpandUp = "M2,20V22H22V20H13V5.83L18.5,11.33L19.92,9.92L12,2L4.08,9.92L5.5,11.33L11,5.83V20H2Z";
var mdiArrowExpandVertical = "M13,9V15H16L12,19L8,15H11V9H8L12,5L16,9H13M4,2H20V4H4V2M4,20H20V22H4V20Z";
var mdiArrowHorizontalLock = "M14.8 7V5.5C14.8 4.1 13.4 3 12 3S9.2 4.1 9.2 5.5V7C8.6 7 8 7.6 8 8.2V11.7C8 12.4 8.6 13 9.2 13H14.7C15.4 13 16 12.4 16 11.8V8.3C16 7.6 15.4 7 14.8 7M13.5 7H10.5V5.5C10.5 4.7 11.2 4.2 12 4.2S13.5 4.7 13.5 5.5V7M6 17V20L2 16L6 12V15H18V12L22 16L18 20V17H6Z";
var mdiArrowLeft = "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z";
var mdiArrowLeftBold = "M20,9V15H12V19.84L4.16,12L12,4.16V9H20Z";
var mdiArrowLeftBoldBox = "M21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5M7,12L12,17V14H16V10H12V7L7,12Z";
var mdiArrowLeftBoldBoxOutline = "M7,12L12,7V10H16V14H12V17L7,12M21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5M19,5H5V19H19V5Z";
var mdiArrowLeftBoldCircle = "M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M7,12L12,17V14H16V10H12V7L7,12Z";
var mdiArrowLeftBoldCircleOutline = "M7,12L12,7V10H16V14H12V17L7,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12Z";
var mdiArrowLeftBoldHexagonOutline = "M7,12L12,7V10H16V14H12V17L7,12M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z";
var mdiArrowLeftBoldOutline = "M13,22L3,12L13,2V8H21V16H13V22M6,12L11,17V14H19V10H11V7L6,12Z";
var mdiArrowLeftBottom = "M20 4V10.5C20 14.09 17.09 17 13.5 17H7.83L10.92 20.09L9.5 21.5L4 16L9.5 10.5L10.91 11.91L7.83 15H13.5C16 15 18 13 18 10.5V4H20Z";
var mdiArrowLeftBottomBold = "M21 10.5C21 14.64 17.64 18 13.5 18H11V22L4 16L11 10V14H13.5C15.43 14 17 12.43 17 10.5V3H21V10.5Z";
var mdiArrowLeftBox = "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5C3,3.89 3.9,3 5,3H19M18,11H9.5L13,7.5L11.58,6.08L5.66,12L11.58,17.92L13,16.5L9.5,13H18V11Z";
var mdiArrowLeftCircle = "M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M18,11H10L13.5,7.5L12.08,6.08L6.16,12L12.08,17.92L13.5,16.5L10,13H18V11Z";
var mdiArrowLeftCircleOutline = "M18,11V13H10L13.5,16.5L12.08,17.92L6.16,12L12.08,6.08L13.5,7.5L10,11H18M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12Z";
var mdiArrowLeftDropCircle = "M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M14,7L9,12L14,17V7Z";
var mdiArrowLeftDropCircleOutline = "M22,12A10,10 0 0,0 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12M14,7L9,12L14,17V7Z";
var mdiArrowLeftRight = "M6.45,17.45L1,12L6.45,6.55L7.86,7.96L4.83,11H19.17L16.14,7.96L17.55,6.55L23,12L17.55,17.45L16.14,16.04L19.17,13H4.83L7.86,16.04L6.45,17.45Z";
var mdiArrowLeftRightBold = "M8,14V18L2,12L8,6V10H16V6L22,12L16,18V14H8Z";
var mdiArrowLeftRightBoldOutline = "M14,16V22L24,12L14,2V8H10V2L0,12L10,22V16H14M8,14V17L3,12L8,7V10H16V7L21,12L16,17V14H8Z";
var mdiArrowLeftThick = "M20,10V14H11L14.5,17.5L12.08,19.92L4.16,12L12.08,4.08L14.5,6.5L11,10H20Z";
var mdiArrowLeftThin = "M10.05 16.94V12.94H18.97L19 10.93H10.05V6.94L5.05 11.94Z";
var mdiArrowLeftThinCircleOutline = "M3.97 12C3.97 16.41 7.59 20.03 12 20.03C16.41 20.03 20.03 16.41 20.03 12C20.03 7.59 16.41 3.97 12 3.97C7.59 3.97 3.97 7.59 3.97 12M2 12C2 6.46 6.46 2 12 2C17.54 2 22 6.46 22 12C22 17.54 17.54 22 12 22C6.46 22 2 17.54 2 12M10.46 11V8L6.5 12L10.46 16V13H17.5V11";
var mdiArrowLeftTop = "M20 13.5V20H18V13.5C18 11 16 9 13.5 9H7.83L10.91 12.09L9.5 13.5L4 8L9.5 2.5L10.92 3.91L7.83 7H13.5C17.09 7 20 9.91 20 13.5Z";
var mdiArrowLeftTopBold = "M21 21H17V13.5C17 11.57 15.43 10 13.5 10H11V14L4 8L11 2V6H13.5C17.64 6 21 9.36 21 13.5V21Z";
var mdiArrowOscillating = "M6 14H9L5 18L1 14H4C4 11.3 5.7 6.6 11 6.1V8.1C7.6 8.6 6 11.9 6 14M20 14C20 11.3 18.3 6.6 13 6.1V8.1C16.4 8.7 18 11.9 18 14H15L19 18L23 14H20Z";
var mdiArrowOscillatingOff = "M13 8.1V6.1C18.3 6.6 20 11.4 20 14H23L20.1 16.9L17.2 14H18C18 11.9 16.4 8.6 13 8.1M7.8 7.1L2.4 1.7L1.1 3L6.3 8.2C4.7 10 4 12.4 4 14H1L5 18L9 14H6C6 12.7 6.6 11 7.9 9.7L20.9 22.7L22.2 21.4L9.3 8.7L7.8 7.1M11 6.1L9.5 6.4L11 7.8V6.1Z";
var mdiArrowProjectile = "M22 2L20 7L19.03 6.03L8 17.06V19L5 22L4 20L2 19L5 16H6.94L17.97 4.97L17 4L22 2Z";
var mdiArrowProjectileMultiple = "M19 16L22 19L20 20L19 22L16 19V17.06L12 13.06L8 17.06V19L5 22L4 20L2 19L5 16H6.94L10.94 12L4.97 6.03L4 7L2 2L7 4L6.03 4.97L12 10.94L17.97 4.97L17 4L22 2L20 7L19.03 6.03L13.06 12L17.06 16H19Z";
var mdiArrowRight = "M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z";
var mdiArrowRightBold = "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z";
var mdiArrowRightBoldBox = "M3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19M17,12L12,7V10H8V14H12V17L17,12Z";
var mdiArrowRightBoldBoxOutline = "M17,12L12,17V14H8V10H12V7L17,12M3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19M5,19H19V5H5V19Z";
var mdiArrowRightBoldCircle = "M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M17,12L12,7V10H8V14H12V17L17,12Z";
var mdiArrowRightBoldCircleOutline = "M17,12L12,17V14H8V10H12V7L17,12M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12Z";
var mdiArrowRightBoldHexagonOutline = "M17,12L12,17V14H8V10H12V7L17,12M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z";
var mdiArrowRightBoldOutline = "M11,16H3V8H11V2L21,12L11,22V16M13,7V10H5V14H13V17L18,12L13,7Z";
var mdiArrowRightBottom = "M20 16L14.5 21.5L13.08 20.09L16.17 17H10.5C6.91 17 4 14.09 4 10.5V4H6V10.5C6 13 8 15 10.5 15H16.17L13.09 11.91L14.5 10.5L20 16Z";
var mdiArrowRightBottomBold = "M3 3H7V10.5C7 12.43 8.57 14 10.5 14H13V10L20 16L13 22V18H10.5C6.36 18 3 14.64 3 10.5V3Z";
var mdiArrowRightBox = "M5,21A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19C21,20.11 20.1,21 19,21H5M6,13H14.5L11,16.5L12.42,17.92L18.34,12L12.42,6.08L11,7.5L14.5,11H6V13Z";
var mdiArrowRightCircle = "M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M6,13H14L10.5,16.5L11.92,17.92L17.84,12L11.92,6.08L10.5,7.5L14,11H6V13Z";
var mdiArrowRightCircleOutline = "M6,13V11H14L10.5,7.5L11.92,6.08L17.84,12L11.92,17.92L10.5,16.5L14,13H6M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12Z";
var mdiArrowRightDropCircle = "M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M10,17L15,12L10,7V17Z";
var mdiArrowRightDropCircleOutline = "M2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2A10,10 0 0,0 2,12M4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12M10,17L15,12L10,7V17Z";
var mdiArrowRightThick = "M4,10V14H13L9.5,17.5L11.92,19.92L19.84,12L11.92,4.08L9.5,6.5L13,10H4Z";
var mdiArrowRightThin = "M14 16.94V12.94H5.08L5.05 10.93H14V6.94L19 11.94Z";
var mdiArrowRightThinCircleOutline = "M20.03 12C20.03 7.59 16.41 3.97 12 3.97C7.59 3.97 3.97 7.59 3.97 12C3.97 16.41 7.59 20.03 12 20.03C16.41 20.03 20.03 16.41 20.03 12M22 12C22 17.54 17.54 22 12 22C6.46 22 2 17.54 2 12C2 6.46 6.46 2 12 2C17.54 2 22 6.46 22 12M13.54 13V16L17.5 12L13.54 8V11H6.5V13";
var mdiArrowRightTop = "M20 8L14.5 13.5L13.09 12.09L16.17 9H10.5C8 9 6 11 6 13.5V20H4V13.5C4 9.91 6.91 7 10.5 7H16.17L13.08 3.91L14.5 2.5L20 8Z";
var mdiArrowRightTopBold = "M3 13.5C3 9.36 6.36 6 10.5 6H13V2L20 8L13 14V10H10.5C8.57 10 7 11.57 7 13.5V21H3V13.5Z";
var mdiArrowSplitHorizontal = "M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z";
var mdiArrowSplitVertical = "M18,16V13H15V22H13V2H15V11H18V8L22,12L18,16M2,12L6,16V13H9V22H11V2H9V11H6V8L2,12Z";
var mdiArrowTopLeft = "M19,17.59L17.59,19L7,8.41V15H5V5H15V7H8.41L19,17.59Z";
var mdiArrowTopLeftBoldBox = "M5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3M8.2 8V15.1L10.3 13L14.1 16.9L17 14L13.2 10.1L15.3 8H8.2Z";
var mdiArrowTopLeftBoldBoxOutline = "M8 8H15.1L13 10.1L17 14L14.2 16.8L10.1 12.9L8 15.1V8M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V5H19V19Z";
var mdiArrowTopLeftBoldOutline = "M14.12,8.46L19.78,14.12L14.12,19.78L8.46,14.12L4.22,18.36V4.22H18.36L14.12,8.46M6.34,13.41L8.46,11.29L14.12,16.95L16.95,14.12L11.29,8.47L13.41,6.34H6.34V13.41Z";
var mdiArrowTopLeftBottomRight = "M13,21H21V13H19V17.59L6.41,5H11V3H3V11H5V6.41L17.59,19H13V21Z";
var mdiArrowTopLeftBottomRightBold = "M5.83,8.66L3,11.5V3H11.5L8.66,5.83L18.17,15.34L21,12.5V21H12.5L15.34,18.17L5.83,8.66Z";
var mdiArrowTopLeftThick = "M9.12,11.94V16.89H5.69V5.69H16.89V9.12H11.94L18.31,15.5L15.5,18.31L9.12,11.94Z";
var mdiArrowTopLeftThin = "M12.07 5L9.24 7.83L19 17.59L17.58 19L7.82 9.25L5 12.07V5Z";
var mdiArrowTopLeftThinCircleOutline = "M12 3.97C16.41 3.97 20.03 7.59 20.03 12C20.03 16.41 16.41 20.03 12 20.03C7.59 20.03 3.97 16.41 3.97 12C3.97 7.59 7.59 3.97 12 3.97M12 2C6.46 2 2 6.46 2 12C2 17.54 6.46 22 12 22C17.54 22 22 17.54 22 12C22 6.46 17.54 2 12 2M10.12 11.53L8 13.64V8H13.64L11.53 10.12L16.5 15.1L15.1 16.5";
var mdiArrowTopRight = "M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z";
var mdiArrowTopRightBoldBox = "M19 3C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19M8.7 8L10.8 10.1L7 14L9.8 16.8L13.6 12.9L15.7 15V8H8.7Z";
var mdiArrowTopRightBoldBoxOutline = "M16 8V15.1L13.9 13L9.8 16.9L7 14L11.1 10.1L8.9 8H16M3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5M5 5H19V19H5V5Z";
var mdiArrowTopRightBoldOutline = "M5.64,4.22H19.78V18.36L15.54,14.12L9.88,19.78L4.22,14.12L9.88,8.46L5.64,4.22M17.66,6.34H10.59L12.71,8.46L7.05,14.12L9.88,16.95L15.54,11.29L17.66,13.41V6.34H17.66Z";
var mdiArrowTopRightBottomLeft = "M11,21H3V13H5V17.59L17.59,5H13V3H21V11H19V6.41L6.41,19H11V21Z";
var mdiArrowTopRightBottomLeftBold = "M18.17,8.66L21,11.5V3H12.5L15.34,5.83L5.83,15.34L3,12.5V21H11.5L8.66,18.17L18.17,8.66Z";
var mdiArrowTopRightThick = "M8.5,18.31L5.69,15.5L12.06,9.12H7.11V5.69H18.31V16.89H14.89V11.94L8.5,18.31Z";
var mdiArrowTopRightThin = "M11.93 5L14.76 7.83L5 17.59L6.42 19L16.18 9.25L19 12.07V5H11.93Z";
var mdiArrowTopRightThinCircleOutline = "M12 3.97C7.59 3.97 3.97 7.59 3.97 12C3.97 16.41 7.59 20.03 12 20.03C16.41 20.03 20.03 16.41 20.03 12C20.03 7.59 16.41 3.97 12 3.97M12 2C17.54 2 22 6.46 22 12C22 17.54 17.54 22 12 22C6.46 22 2 17.54 2 12C2 6.46 6.46 2 12 2M13.88 11.53L16 13.64V8H10.36L12.47 10.12L7.5 15.1L8.9 16.5";
var mdiArrowUDownLeft = "M20 10.5V18H18V10.5C18 8 16 6 13.5 6S9 8 9 10.5V16.17L12.09 13.09L13.5 14.5L8 20L2.5 14.5L3.91 13.08L7 16.17V10.5C7 6.91 9.91 4 13.5 4S20 6.91 20 10.5Z";
var mdiArrowUDownLeftBold = "M21 10.5V18H17V10.5C17 8.57 15.43 7 13.5 7S10 8.57 10 10.5V13H14L8 20L2 13H6V10.5C6 6.36 9.36 3 13.5 3S21 6.36 21 10.5Z";
var mdiArrowUDownRight = "M21.5 14.5L16 20L10.5 14.5L11.91 13.09L15 16.17V10.5C15 8 13 6 10.5 6S6 8 6 10.5V18H4V10.5C4 6.91 6.91 4 10.5 4S17 6.91 17 10.5V16.17L20.09 13.08L21.5 14.5Z";
var mdiArrowUDownRightBold = "M10.5 3C14.64 3 18 6.36 18 10.5V13H22L16 20L10 13H14V10.5C14 8.57 12.43 7 10.5 7S7 8.57 7 10.5V18H3V10.5C3 6.36 6.36 3 10.5 3Z";
var mdiArrowULeftBottom = "M20 10.5C20 14.09 17.09 17 13.5 17H7.83L10.92 20.09L9.5 21.5L4 16L9.5 10.5L10.91 11.91L7.83 15H13.5C16 15 18 13 18 10.5S16 6 13.5 6H6V4H13.5C17.09 4 20 6.91 20 10.5Z";
var mdiArrowULeftBottomBold = "M21 10.5C21 14.64 17.64 18 13.5 18H11V22L4 16L11 10V14H13.5C15.43 14 17 12.43 17 10.5S15.43 7 13.5 7H6V3H13.5C17.64 3 21 6.36 21 10.5Z";
var mdiArrowULeftTop = "M20 13.5C20 17.09 17.09 20 13.5 20H6V18H13.5C16 18 18 16 18 13.5S16 9 13.5 9H7.83L10.91 12.09L9.5 13.5L4 8L9.5 2.5L10.92 3.91L7.83 7H13.5C17.09 7 20 9.91 20 13.5Z";
var mdiArrowULeftTopBold = "M13.5 21H6V17H13.5C15.43 17 17 15.43 17 13.5S15.43 10 13.5 10H11V14L4 8L11 2V6H13.5C17.64 6 21 9.36 21 13.5S17.64 21 13.5 21Z";
var mdiArrowURightBottom = "M20 16L14.5 21.5L13.08 20.09L16.17 17H10.5C6.91 17 4 14.09 4 10.5S6.91 4 10.5 4H18V6H10.5C8 6 6 8 6 10.5S8 15 10.5 15H16.17L13.09 11.91L14.5 10.5L20 16Z";
var mdiArrowURightBottomBold = "M10.5 3H18V7H10.5C8.57 7 7 8.57 7 10.5S8.57 14 10.5 14H13V10L20 16L13 22V18H10.5C6.36 18 3 14.64 3 10.5S6.36 3 10.5 3Z";
var mdiArrowURightTop = "M10.5 18H18V20H10.5C6.91 20 4 17.09 4 13.5S6.91 7 10.5 7H16.17L13.08 3.91L14.5 2.5L20 8L14.5 13.5L13.09 12.09L16.17 9H10.5C8 9 6 11 6 13.5S8 18 10.5 18Z";
var mdiArrowURightTopBold = "M3 13.5C3 9.36 6.36 6 10.5 6H13V2L20 8L13 14V10H10.5C8.57 10 7 11.57 7 13.5S8.57 17 10.5 17H18V21H10.5C6.36 21 3 17.64 3 13.5Z";
var mdiArrowUUpLeft = "M20 6V13.5C20 17.09 17.09 20 13.5 20S7 17.09 7 13.5V7.83L3.91 10.92L2.5 9.5L8 4L13.5 9.5L12.09 10.91L9 7.83V13.5C9 16 11 18 13.5 18S18 16 18 13.5V6H20Z";
var mdiArrowUUpLeftBold = "M13.5 21C9.36 21 6 17.64 6 13.5V11H2L8 4L14 11H10V13.5C10 15.43 11.57 17 13.5 17S17 15.43 17 13.5V6H21V13.5C21 17.64 17.64 21 13.5 21Z";
var mdiArrowUUpRight = "M21.5 9.5L20.09 10.92L17 7.83V13.5C17 17.09 14.09 20 10.5 20S4 17.09 4 13.5V6H6V13.5C6 16 8 18 10.5 18S15 16 15 13.5V7.83L11.91 10.91L10.5 9.5L16 4L21.5 9.5Z";
var mdiArrowUUpRightBold = "M3 13.5V6H7V13.5C7 15.43 8.57 17 10.5 17S14 15.43 14 13.5V11H10L16 4L22 11H18V13.5C18 17.64 14.64 21 10.5 21S3 17.64 3 13.5Z";
var mdiArrowUp = "M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z";
var mdiArrowUpBold = "M15,20H9V12H4.16L12,4.16L19.84,12H15V20Z";
var mdiArrowUpBoldBox = "M19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21M12,7L7,12H10V16H14V12H17L12,7Z";
var mdiArrowUpBoldBoxOutline = "M12,7L17,12H14V16H10V12H7L12,7M19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21M19,19V5H5V19H19Z";
var mdiArrowUpBoldCircle = "M12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22M12,7L7,12H10V16H14V12H17L12,7Z";
var mdiArrowUpBoldCircleOutline = "M12,7L17,12H14V16H10V12H7L12,7M12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20Z";
var mdiArrowUpBoldHexagonOutline = "M12,7L17,12H14V16H10V12H7L12,7M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z";
var mdiArrowUpBoldOutline = "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z";
var mdiArrowUpBox = "M21,19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19C20.11,3 21,3.9 21,5V19M13,18V9.5L16.5,13L17.92,11.58L12,5.66L6.08,11.58L7.5,13L11,9.5V18H13Z";
var mdiArrowUpCircle = "M13,18V10L16.5,13.5L17.92,12.08L12,6.16L6.08,12.08L7.5,13.5L11,10V18H13M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiArrowUpCircleOutline = "M13,18H11V10L7.5,13.5L6.08,12.08L12,6.16L17.92,12.08L16.5,13.5L13,10V18M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiArrowUpDown = "M17.45,17.55L12,23L6.55,17.55L7.96,16.14L11,19.17V4.83L7.96,7.86L6.55,6.45L12,1L17.45,6.45L16.04,7.86L13,4.83V19.17L16.04,16.14L17.45,17.55Z";
var mdiArrowUpDownBold = "M10,8H6L12,2L18,8H14V16H18L12,22L6,16H10V8Z";
var mdiArrowUpDownBoldOutline = "M16,10H22L12,0L2,10H8V14H2L12,24L22,14H16V10M14,16H17L12,21L7,16H10V8H7L12,3L17,8H14V16Z";
var mdiArrowUpDropCircle = "M12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22M17,14L12,9L7,14H17Z";
var mdiArrowUpDropCircleOutline = "M12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M17,14L12,9L7,14H17Z";
var mdiArrowUpLeft = "M20 18V20H13.5C9.91 20 7 17.09 7 13.5V7.83L3.91 10.92L2.5 9.5L8 4L13.5 9.5L12.09 10.91L9 7.83V13.5C9 16 11 18 13.5 18H20Z";
var mdiArrowUpLeftBold = "M13.5 21C9.36 21 6 17.64 6 13.5V11H2L8 4L14 11H10V13.5C10 15.43 11.57 17 13.5 17H21V21H13.5Z";
var mdiArrowUpRight = "M21.5 9.5L20.09 10.92L17 7.83V13.5C17 17.09 14.09 20 10.5 20H4V18H10.5C13 18 15 16 15 13.5V7.83L11.91 10.91L10.5 9.5L16 4L21.5 9.5Z";
var mdiArrowUpRightBold = "M3 21V17H10.5C12.43 17 14 15.43 14 13.5V11H10L16 4L22 11H18V13.5C18 17.64 14.64 21 10.5 21H3Z";
var mdiArrowUpThick = "M14,20H10V11L6.5,14.5L4.08,12.08L12,4.16L19.92,12.08L17.5,14.5L14,11V20Z";
var mdiArrowUpThin = "M7.03 9.97H11.03V18.89L13.04 18.92V9.97H17.03L12.03 4.97Z";
var mdiArrowUpThinCircleOutline = "M12 3.97C7.59 3.97 3.97 7.59 3.97 12C3.97 16.41 7.59 20.03 12 20.03C16.41 20.03 20.03 16.41 20.03 12C20.03 7.59 16.41 3.97 12 3.97M12 2C17.54 2 22 6.46 22 12C22 17.54 17.54 22 12 22C6.46 22 2 17.54 2 12C2 6.46 6.46 2 12 2M13 10.46H16L12 6.5L8 10.46H11V17.5H13";
var mdiArrowVerticalLock = "M18.8 11V9.5C18.8 8.1 17.4 7 16 7S13.2 8.1 13.2 9.5V11C12.6 11 12 11.6 12 12.2V15.7C12 16.4 12.6 17 13.2 17H18.7C19.4 17 20 16.4 20 15.8V12.3C20 11.6 19.4 11 18.8 11M17.5 11H14.5V9.5C14.5 8.7 15.2 8.2 16 8.2C16.8 8.2 17.5 8.7 17.5 9.5V11M9 6H12L8 2L4 6H7V18H4L8 22L12 18H9V6Z";
var mdiArtboard = "M17 9V15H7V9H17M19 3H17V6H19V3M7 3H5V6H7V3M23 7H20V9H23V7M19 7H5V17H19V7M4 7H1V9H4V7M23 15H20V17H23V15M4 15H1V17H4V15M19 18H17V21H19V18M7 18H5V21H7V18Z";
var mdiArtstation = "M1.77,16.88L3.5,19.86C3.84,20.54 4.54,21 5.33,21H16.79L14.43,16.88H1.77M22.23,16.9C22.23,16.5 22.11,16.11 21.9,15.78L15.17,4.1C14.82,3.44 14.15,3 13.35,3H9.8L20.18,21L21.82,18.14C22.13,17.6 22.23,17.36 22.23,16.9M12.73,13.94L8.1,5.92L3.45,13.94H12.73Z";
var mdiAspectRatio = "M19,12H17V15H14V17H19V12M7,9H10V7H5V12H7V9M21,3H3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V5A2,2 0 0,0 21,3M21,19H3V5H21V19Z";
var mdiAssistant = "M19,2H5A2,2 0 0,0 3,4V18A2,2 0 0,0 5,20H9L12,23L15,20H19A2,2 0 0,0 21,18V4A2,2 0 0,0 19,2M13.88,12.88L12,17L10.12,12.88L6,11L10.12,9.12L12,5L13.88,9.12L18,11";
var mdiAsterisk = "M21 13H14.4L19.1 17.7L17.7 19.1L13 14.4V21H11V14.3L6.3 19L4.9 17.6L9.4 13H3V11H9.6L4.9 6.3L6.3 4.9L11 9.6V3H13V9.4L17.6 4.8L19 6.3L14.3 11H21V13Z";
var mdiAsteriskCircleOutline = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2M12 20C7.61 20 4 16.39 4 12C4 7.61 7.61 4 12 4C16.39 4 20 7.61 20 12C20 16.39 16.39 20 12 20M13 10.27L15.83 8.63L16.83 10.37L14 12L16.83 13.63L15.83 15.37L13 13.73V17H11V13.73L8.17 15.37L7.17 13.63L10 12L7.17 10.37L8.17 8.63L11 10.27V7H13V10.27Z";
var mdiAt = "M12,15C12.81,15 13.5,14.7 14.11,14.11C14.7,13.5 15,12.81 15,12C15,11.19 14.7,10.5 14.11,9.89C13.5,9.3 12.81,9 12,9C11.19,9 10.5,9.3 9.89,9.89C9.3,10.5 9,11.19 9,12C9,12.81 9.3,13.5 9.89,14.11C10.5,14.7 11.19,15 12,15M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12V13.45C22,14.45 21.65,15.3 21,16C20.3,16.67 19.5,17 18.5,17C17.3,17 16.31,16.5 15.56,15.5C14.56,16.5 13.38,17 12,17C10.63,17 9.45,16.5 8.46,15.54C7.5,14.55 7,13.38 7,12C7,10.63 7.5,9.45 8.46,8.46C9.45,7.5 10.63,7 12,7C13.38,7 14.55,7.5 15.54,8.46C16.5,9.45 17,10.63 17,12V13.45C17,13.86 17.16,14.22 17.46,14.53C17.76,14.84 18.11,15 18.5,15C18.92,15 19.27,14.84 19.57,14.53C19.87,14.22 20,13.86 20,13.45V12C20,9.81 19.23,7.93 17.65,6.35C16.07,4.77 14.19,4 12,4C9.81,4 7.93,4.77 6.35,6.35C4.77,7.93 4,9.81 4,12C4,14.19 4.77,16.07 6.35,17.65C7.93,19.23 9.81,20 12,20H17V22H12C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z";
var mdiAtlassian = "M7.93,11.24C7.74,11 7.38,10.94 7.13,11.13C7.06,11.19 7,11.26 6.96,11.34L2.06,21.15C1.91,21.44 2.03,21.79 2.32,21.94C2.4,22 2.5,22 2.59,22H9.41C9.63,22 9.84,21.88 9.94,21.68C11.41,18.63 10.5,14 7.93,11.24M11.53,2.31C9.05,6.14 8.76,11 10.77,15.09L14.06,21.68C14.17,21.88 14.37,22 14.59,22H21.41A0.59,0.59 0 0,0 22,21.41C22,21.32 22,21.23 21.94,21.15C21.94,21.15 12.76,2.77 12.5,2.31C12.39,2.04 12.06,1.92 11.78,2.06C11.67,2.11 11.58,2.2 11.53,2.31Z";
var mdiAtm = "M8,9V10.5H10.25V15H11.75V10.5H14V9H8M6,9H3A1,1 0 0,0 2,10V15H3.5V13.5H5.5V15H7V10A1,1 0 0,0 6,9M5.5,12H3.5V10.5H5.5V12M21,9H16.5A1,1 0 0,0 15.5,10V15H17V10.5H18V14H19.5V10.5H20.5V15H22V10A1,1 0 0,0 21,9Z";
var mdiAtom = "M12,11A1,1 0 0,1 13,12A1,1 0 0,1 12,13A1,1 0 0,1 11,12A1,1 0 0,1 12,11M4.22,4.22C5.65,2.79 8.75,3.43 12,5.56C15.25,3.43 18.35,2.79 19.78,4.22C21.21,5.65 20.57,8.75 18.44,12C20.57,15.25 21.21,18.35 19.78,19.78C18.35,21.21 15.25,20.57 12,18.44C8.75,20.57 5.65,21.21 4.22,19.78C2.79,18.35 3.43,15.25 5.56,12C3.43,8.75 2.79,5.65 4.22,4.22M15.54,8.46C16.15,9.08 16.71,9.71 17.23,10.34C18.61,8.21 19.11,6.38 18.36,5.64C17.62,4.89 15.79,5.39 13.66,6.77C14.29,7.29 14.92,7.85 15.54,8.46M8.46,15.54C7.85,14.92 7.29,14.29 6.77,13.66C5.39,15.79 4.89,17.62 5.64,18.36C6.38,19.11 8.21,18.61 10.34,17.23C9.71,16.71 9.08,16.15 8.46,15.54M5.64,5.64C4.89,6.38 5.39,8.21 6.77,10.34C7.29,9.71 7.85,9.08 8.46,8.46C9.08,7.85 9.71,7.29 10.34,6.77C8.21,5.39 6.38,4.89 5.64,5.64M9.88,14.12C10.58,14.82 11.3,15.46 12,16.03C12.7,15.46 13.42,14.82 14.12,14.12C14.82,13.42 15.46,12.7 16.03,12C15.46,11.3 14.82,10.58 14.12,9.88C13.42,9.18 12.7,8.54 12,7.97C11.3,8.54 10.58,9.18 9.88,9.88C9.18,10.58 8.54,11.3 7.97,12C8.54,12.7 9.18,13.42 9.88,14.12M18.36,18.36C19.11,17.62 18.61,15.79 17.23,13.66C16.71,14.29 16.15,14.92 15.54,15.54C14.92,16.15 14.29,16.71 13.66,17.23C15.79,18.61 17.62,19.11 18.36,18.36Z";
var mdiAtomVariant = "M18.36,2.64C20,2.64 21.36,4 21.36,5.64C21.36,7.29 20,8.64 18.36,8.64C16.71,8.64 15.36,7.29 15.36,5.64C15.36,5.34 15.41,5.06 15.5,4.8C14.43,4.29 13.25,4 12,4A8,8 0 0,0 4,12L4.04,12.84L2.05,13.05L2,12A10,10 0 0,1 12,2C13.69,2 15.28,2.42 16.67,3.16C17.16,2.83 17.74,2.64 18.36,2.64M18.36,4.64A1,1 0 0,0 17.36,5.64A1,1 0 0,0 18.36,6.64C18.92,6.64 19.36,6.19 19.36,5.64C19.36,5.08 18.92,4.64 18.36,4.64M5.64,15.36C7.29,15.36 8.64,16.71 8.64,18.36C8.64,18.66 8.59,18.94 8.5,19.2C9.57,19.71 10.75,20 12,20A8,8 0 0,0 20,12L19.96,11.16L21.95,10.95L22,12A10,10 0 0,1 12,22C10.31,22 8.72,21.58 7.33,20.84C6.84,21.17 6.26,21.36 5.64,21.36C4,21.36 2.64,20 2.64,18.36C2.64,16.71 4,15.36 5.64,15.36M5.64,17.36C5.08,17.36 4.64,17.81 4.64,18.36C4.64,18.92 5.08,19.36 5.64,19.36A1,1 0 0,0 6.64,18.36A1,1 0 0,0 5.64,17.36M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8Z";
var mdiAttachment = "M7.5,18A5.5,5.5 0 0,1 2,12.5A5.5,5.5 0 0,1 7.5,7H18A4,4 0 0,1 22,11A4,4 0 0,1 18,15H9.5A2.5,2.5 0 0,1 7,12.5A2.5,2.5 0 0,1 9.5,10H17V11.5H9.5A1,1 0 0,0 8.5,12.5A1,1 0 0,0 9.5,13.5H18A2.5,2.5 0 0,0 20.5,11A2.5,2.5 0 0,0 18,8.5H7.5A4,4 0 0,0 3.5,12.5A4,4 0 0,0 7.5,16.5H17V18H7.5Z";
var mdiAttachmentCheck = "M16.61 13.5C15.81 13.85 15.11 14.36 14.54 15H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17V11.5H9.5C8.95 11.5 8.5 11.95 8.5 12.5S8.95 13.5 9.5 13.5H16.61M3.5 12.5C3.5 10.29 5.29 8.5 7.5 8.5H18C19.38 8.5 20.5 9.62 20.5 11C20.5 11.84 20.08 12.58 19.45 13.03C20.05 13.07 20.63 13.2 21.17 13.41C21.69 12.74 22 11.91 22 11C22 8.79 20.21 7 18 7H7.5C4.46 7 2 9.46 2 12.5S4.46 18 7.5 18H13.09C13.18 17.47 13.34 16.97 13.55 16.5H7.5C5.29 16.5 3.5 14.71 3.5 12.5M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiAttachmentLock = "M18 13C16.6 13 15.2 14.1 15.2 15.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17V15.5C20.8 14.1 19.4 13 18 13M18 14.2C18.8 14.2 19.5 14.7 19.5 15.5V17H16.5V15.5C16.5 14.7 17.2 14.2 18 14.2M7.5 5C4.5 5 2 7.5 2 10.5S4.5 16 7.5 16H13.2V15.5C13.2 15.2 13.2 14.8 13.3 14.5H7.5C5.3 14.5 3.5 12.7 3.5 10.5S5.3 6.5 7.5 6.5H18C19.4 6.5 20.5 7.6 20.5 9C20.5 9.9 20 10.7 19.2 11.2C19.8 11.3 20.3 11.6 20.8 11.9C21.6 11.1 22 10.1 22 9C22 6.8 20.2 5 18 5H7.5M9.5 8C8.1 8 7 9.1 7 10.5S8.1 13 9.5 13H14C14.5 12.3 15.1 11.8 15.8 11.5H9.5C8.9 11.5 8.5 11.1 8.5 10.5S8.9 9.5 9.5 9.5H17V8H9.5Z";
var mdiAttachmentMinus = "M16.61 13.5C15.81 13.85 15.11 14.36 14.54 15H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17V11.5H9.5C8.95 11.5 8.5 11.95 8.5 12.5S8.95 13.5 9.5 13.5H16.61M3.5 12.5C3.5 10.29 5.29 8.5 7.5 8.5H18C19.38 8.5 20.5 9.62 20.5 11C20.5 11.84 20.08 12.58 19.45 13.03C20.05 13.07 20.63 13.2 21.17 13.41C21.69 12.74 22 11.91 22 11C22 8.79 20.21 7 18 7H7.5C4.46 7 2 9.46 2 12.5S4.46 18 7.5 18H13.09C13.18 17.47 13.34 16.97 13.55 16.5H7.5C5.29 16.5 3.5 14.71 3.5 12.5M15 18V20H23V18H15Z";
var mdiAttachmentOff = "M17 10V11.5H14.7L13.2 10H17M18 8.5C19.38 8.5 20.5 9.62 20.5 11S19.38 13.5 18 13.5H16.7L18.18 15C20.31 14.89 22 13.15 22 11C22 8.79 20.21 7 18 7H10.2L11.7 8.5H18M22.11 21.46L20.84 22.73L16.11 18H7.5C4.46 18 2 15.54 2 12.5C2 10.17 3.45 8.19 5.5 7.38L1.11 3L2.39 1.73L22.11 21.46M8.5 12.5C8.5 13.05 8.95 13.5 9.5 13.5H11.61L9.61 11.5H9.5C8.95 11.5 8.5 11.95 8.5 12.5M14.61 16.5L13.11 15H9.5C8.12 15 7 13.88 7 12.5C7 11.5 7.57 10.69 8.38 10.27L6.69 8.58C4.87 8.96 3.5 10.57 3.5 12.5C3.5 14.71 5.29 16.5 7.5 16.5H14.61Z";
var mdiAttachmentPlus = "M7.5 16.5H13.55C13.34 16.97 13.18 17.47 13.09 18H7.5C4.46 18 2 15.54 2 12.5S4.46 7 7.5 7H18C20.21 7 22 8.79 22 11C22 11.91 21.69 12.74 21.17 13.41C20.63 13.2 20.05 13.07 19.45 13.03C20.08 12.58 20.5 11.84 20.5 11C20.5 9.62 19.38 8.5 18 8.5H7.5C5.29 8.5 3.5 10.29 3.5 12.5S5.29 16.5 7.5 16.5M9.5 13.5C8.95 13.5 8.5 13.05 8.5 12.5S8.95 11.5 9.5 11.5H17V10H9.5C8.12 10 7 11.12 7 12.5S8.12 15 9.5 15H14.54C15.11 14.36 15.81 13.85 16.61 13.5H9.5M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiAttachmentRemove = "M16.61 13.5C15.81 13.85 15.11 14.36 14.54 15H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17V11.5H9.5C8.95 11.5 8.5 11.95 8.5 12.5S8.95 13.5 9.5 13.5H16.61M3.5 12.5C3.5 10.29 5.29 8.5 7.5 8.5H18C19.38 8.5 20.5 9.62 20.5 11C20.5 11.84 20.08 12.58 19.45 13.03C20.05 13.07 20.63 13.2 21.17 13.41C21.69 12.74 22 11.91 22 11C22 8.79 20.21 7 18 7H7.5C4.46 7 2 9.46 2 12.5S4.46 18 7.5 18H13.09C13.18 17.47 13.34 16.97 13.55 16.5H7.5C5.29 16.5 3.5 14.71 3.5 12.5M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiAtv = "M20 11C19.8 11 19.6 11 19.5 11.1L17.4 9H20V6L16.3 7.9L13.4 5H9V7H12.6L14.6 9H11L7 11L5 9H0V11H4C1.8 11 0 12.8 0 15S1.8 19 4 19 8 17.2 8 15L10 17H13L16.5 10.9L17.5 11.9C16.6 12.6 16 13.8 16 15C16 17.2 17.8 19 20 19S24 17.2 24 15 22.2 11 20 11M4 17C2.9 17 2 16.1 2 15S2.9 13 4 13 6 13.9 6 15 5.1 17 4 17M20 17C18.9 17 18 16.1 18 15S18.9 13 20 13 22 13.9 22 15 21.1 17 20 17Z";
var mdiAudioInputRca = "M11 6V12H5V6H7V2C7 1.45 7.45 1 8 1S9 1.45 9 2V6H11M5 14V16C5 17.3 5.84 18.4 7 18.82V23H9V18.82C10.16 18.4 11 17.3 11 16V14H5M17 6V2C17 1.45 16.55 1 16 1S15 1.45 15 2V6H13V12H19V6H17M13 14V16C13 17.3 13.84 18.4 15 18.82V23H17V18.82C18.16 18.4 19 17.3 19 16V14H13Z";
var mdiAudioInputStereoMinijack = "M11 4V3C11 2.45 11.45 2 12 2S13 2.45 13 3V4H11M13 9V5H11V9H9V15C9 16.3 9.84 17.4 11 17.82V22H13V17.82C14.16 17.4 15 16.3 15 15V9H13Z";
var mdiAudioInputXlr = "M12 4C16.41 4 20 7.59 20 12S16.41 20 12 20 4 16.41 4 12 7.59 4 12 4M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M13.5 16.5C13.5 15.67 12.83 15 12 15S10.5 15.67 10.5 16.5C10.5 17.33 11.17 18 12 18S13.5 17.33 13.5 16.5M9 12C9 11.17 8.33 10.5 7.5 10.5S6 11.17 6 12 6.67 13.5 7.5 13.5 9 12.83 9 12M18 12C18 11.17 17.33 10.5 16.5 10.5C15.67 10.5 15 11.17 15 12S15.67 13.5 16.5 13.5C17.33 13.5 18 12.83 18 12Z";
var mdiAudioVideo = "M20,7H4A2,2 0 0,0 2,9V15A2,2 0 0,0 4,17H5V18C5,18.6 5.4,19 6,19H8C8.6,19 9,18.6 9,18V17H15V18C15,18.6 15.4,19 16,19H18C18.6,19 19,18.6 19,18V17H20A2,2 0 0,0 22,15V9A2,2 0 0,0 20,7M14,12H4V10H14V12M18,13A2,2 0 0,1 16,11A2,2 0 0,1 18,9A2,2 0 0,1 20,11A2,2 0 0,1 18,13M6,15H4V14H6V15M10,15H8V14H10V15M14,15H12V14H14V15Z";
var mdiAudioVideoOff = "M22.1 21.5L2.4 1.7L1.1 3L5.1 7H4C2.9 7 2 7.9 2 9V15C2 16.1 2.9 17 4 17H5V18C5 18.6 5.4 19 6 19H8C8.6 19 9 18.6 9 18V17H15V18C15 18.6 15.4 19 16 19H17.1L20.8 22.7L22.1 21.5M6 15H4V14H6V15M4 12V10H8.1L10.1 12H4M10 15H8V14H10V15M12 15V14H12.1L13.1 15H12M14 10V10.8L20.2 17C21.2 16.9 22 16.1 22 15V9C22 7.9 21.1 7 20 7H10.2L13.2 10H14M18 9C19.1 9 20 9.9 20 11S19.1 13 18 13 16 12.1 16 11 16.9 9 18 9Z";
var mdiAugmentedReality = "M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5M7,9H10C10.6,9 11,9.5 11,10V15H9.5V13.5H7.5V15H6V10C6,9.5 6.4,9 7,9M13,9H16.5C17.35,9 18,9.65 18,10.5V11.5C18,12.1 17.6,12.65 17.1,12.9L18,15H16.5L15.65,13H14.5V15H13V9M7.5,10.5V12H9.5V10.5H7.5M14.5,10.5V11.5H16.5V10.5H14.5";
var mdiAurora = "M2 3C2.55 3 3 3.45 3 4V13H5V5C5 4.45 5.45 4 6 4C6.55 4 7 4.45 7 5V13H9V6C9 5.45 9.45 5 10 5C10.55 5 11 5.45 11 6V13H12.5C12.67 13 12.84 13 13 13.05V7C13 6.45 13.45 6 14 6C14.55 6 15 6.45 15 7V15.5C15 16.88 13.88 18 12.5 18H11.5C11.22 18 11 18.22 11 18.5C11 18.78 11.22 19 11.5 19H17V8C17 7.45 17.45 7 18 7C18.55 7 19 7.45 19 8V19H21V9C21 8.45 21.45 8 22 8C22.55 8 23 8.45 23 9V20C23 20.55 22.55 21 22 21H11.5C10.12 21 9 19.88 9 18.5C9 17.12 10.12 16 11.5 16H12.5C12.78 16 13 15.78 13 15.5C13 15.22 12.78 15 12.5 15H2C1.45 15 1 14.55 1 14V4C1 3.45 1.45 3 2 3Z";
var mdiAutoDownload = "M22 17V19H11V17H22M19 4.5V9.5H22L16.5 15L11 9.5H14V4.5H19M10.7 15H8.8L8.1 13H4.9L4.2 15H2.3L5.5 6H7.5L10.7 15M7.65 11.65L6.5 8L5.35 11.65H7.65Z";
var mdiAutoFix = "M7.5,5.6L5,7L6.4,4.5L5,2L7.5,3.4L10,2L8.6,4.5L10,7L7.5,5.6M19.5,15.4L22,14L20.6,16.5L22,19L19.5,17.6L17,19L18.4,16.5L17,14L19.5,15.4M22,2L20.6,4.5L22,7L19.5,5.6L17,7L18.4,4.5L17,2L19.5,3.4L22,2M13.34,12.78L15.78,10.34L13.66,8.22L11.22,10.66L13.34,12.78M14.37,7.29L16.71,9.63C17.1,10 17.1,10.65 16.71,11.04L5.04,22.71C4.65,23.1 4,23.1 3.63,22.71L1.29,20.37C0.9,20 0.9,19.35 1.29,18.96L12.96,7.29C13.35,6.9 14,6.9 14.37,7.29Z";
var mdiAutoMode = "M19.8 5.67C21.05 7.19 21.82 9.04 22 11H19.94C19.74 9.57 19.16 8.22 18.26 7.1L19.8 5.67M13 2.05C14.96 2.24 16.81 3 18.33 4.26L16.9 5.69C15.77 4.8 14.42 4.24 13 4.05V2.05M11 2.06C9.04 2.26 7.19 3.03 5.67 4.27L7.1 5.69C8.23 4.81 9.58 4.24 11 4.06V2.06M4.26 5.67L5.63 7.06V7.1C4.75 8.23 4.18 9.58 4 11H2C2.21 9.04 3 7.18 4.26 5.67M2 14V19L3.6 17.4C5.38 20.17 8.47 22 12 22C16.82 22 20.87 18.55 21.8 14H19.75C18.86 17.45 15.72 20 12 20C9.05 20 6.39 18.39 5 16L7 14H2M12 17L13.56 13.58L17 12L13.56 10.44L12 7L10.43 10.44L7 12L10.43 13.58L12 17Z";
var mdiAutoUpload = "M5.35,12.65L6.5,9L7.65,12.65M5.5,7L2.3,16H4.2L4.9,14H8.1L8.8,16H10.7L7.5,7M11,20H22V18H11M14,16H19V11H22L16.5,5.5L11,11H14V16Z";
var mdiAutorenew = "M12,6V9L16,5L12,1V4A8,8 0 0,0 4,12C4,13.57 4.46,15.03 5.24,16.26L6.7,14.8C6.25,13.97 6,13 6,12A6,6 0 0,1 12,6M18.76,7.74L17.3,9.2C17.74,10.04 18,11 18,12A6,6 0 0,1 12,18V15L8,19L12,23V20A8,8 0 0,0 20,12C20,10.43 19.54,8.97 18.76,7.74Z";
var mdiAutorenewOff = "M18 12C18 11 17.74 10.04 17.3 9.2L18.76 7.74C19.54 8.97 20 10.43 20 12C20 13.39 19.64 14.68 19 15.82L17.5 14.32C17.82 13.6 18 12.83 18 12M2.39 1.73L1.11 3L5.5 7.37C4.55 8.68 4 10.27 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13 6 12C6 10.83 6.34 9.74 6.92 8.81L15.19 17.08C14.26 17.66 13.17 18 12 18V15L8 19L12 23V20C13.73 20 15.32 19.45 16.63 18.5L20.84 22.73L22.11 21.46L2.39 1.73M12 6V8.8L12.1 8.9L16 5L12 1V4C10.62 4 9.32 4.36 8.18 5L9.68 6.5C10.4 6.18 11.18 6 12 6Z";
var mdiAvTimer = "M11,17A1,1 0 0,0 12,18A1,1 0 0,0 13,17A1,1 0 0,0 12,16A1,1 0 0,0 11,17M11,3V7H13V5.08C16.39,5.57 19,8.47 19,12A7,7 0 0,1 12,19A7,7 0 0,1 5,12C5,10.32 5.59,8.78 6.58,7.58L12,13L13.41,11.59L6.61,4.79V4.81C4.42,6.45 3,9.05 3,12A9,9 0 0,0 12,21A9,9 0 0,0 21,12A9,9 0 0,0 12,3M18,12A1,1 0 0,0 17,11A1,1 0 0,0 16,12A1,1 0 0,0 17,13A1,1 0 0,0 18,12M6,12A1,1 0 0,0 7,13A1,1 0 0,0 8,12A1,1 0 0,0 7,11A1,1 0 0,0 6,12Z";
var mdiAwning = "M5.06 7C4.63 7 4.22 7.14 3.84 7.42C3.46 7.7 3.24 8.06 3.14 8.5L2.11 12.91C1.86 14 2.06 14.92 2.69 15.73C2.81 15.85 2.93 15.97 3.04 16.07C3.63 16.64 4.28 17 5.22 17C6.16 17 6.91 16.59 7.47 16.05C8.1 16.67 8.86 17 9.8 17C10.64 17 11.44 16.63 12 16.07C12.68 16.7 13.45 17 14.3 17C15.17 17 15.91 16.67 16.54 16.05C17.11 16.62 17.86 17 18.81 17C19.76 17 20.43 16.65 21 16.06C21.09 15.97 21.18 15.87 21.28 15.77C21.94 14.95 22.14 14 21.89 12.91L20.86 8.5C20.73 8.06 20.5 7.7 20.13 7.42C19.77 7.14 19.38 7 18.94 7H5.06Z";
var mdiAwningOutline = "M5.06 7C4.63 7 4.22 7.14 3.84 7.42C3.46 7.7 3.24 8.06 3.14 8.5L2.11 12.91C1.86 14 2.06 14.92 2.69 15.73C2.81 15.85 2.93 15.97 3.04 16.07C3.63 16.64 4.28 17 5.22 17C6.16 17 6.91 16.59 7.47 16.05C8.1 16.67 8.86 17 9.8 17C10.64 17 11.44 16.63 12 16.07C12.68 16.7 13.45 17 14.3 17C15.17 17 15.91 16.67 16.54 16.05C17.11 16.62 17.86 17 18.81 17C19.76 17 20.43 16.65 21 16.06C21.09 15.97 21.18 15.87 21.28 15.77C21.94 14.95 22.14 14 21.89 12.91L20.86 8.5C20.73 8.06 20.5 7.7 20.13 7.42C19.77 7.14 19.38 7 18.94 7H5.06M18.89 8.97L19.97 13.38C20.06 13.81 19.97 14.2 19.69 14.55C19.44 14.86 19.13 15 18.75 15C18.44 15 18.17 14.9 17.95 14.66C17.73 14.43 17.61 14.16 17.58 13.84L16.97 9L18.89 8.97M5.06 9H7.03L6.42 13.84C6.3 14.63 5.91 15 5.25 15C4.84 15 4.53 14.86 4.31 14.55C4.03 14.2 3.94 13.81 4.03 13.38L5.06 9M9.05 9H11V13.7C11 14.05 10.89 14.35 10.64 14.62C10.39 14.88 10.08 15 9.7 15C9.36 15 9.07 14.88 8.84 14.59C8.61 14.3 8.5 14 8.5 13.66V13.5L9.05 9M13 9H14.95L15.5 13.5C15.58 13.92 15.5 14.27 15.21 14.57C14.95 14.87 14.61 15 14.2 15C13.89 15 13.61 14.88 13.36 14.62C13.11 14.35 13 14.05 13 13.7V9Z";
var mdiAws = "M7.64,10.38C7.64,10.63 7.66,10.83 7.71,11C7.76,11.12 7.83,11.28 7.92,11.46C7.96,11.5 7.97,11.56 7.97,11.61C7.97,11.68 7.93,11.74 7.84,11.81L7.42,12.09C7.36,12.13 7.3,12.15 7.25,12.15C7.18,12.15 7.12,12.11 7.05,12.05C6.96,11.95 6.88,11.85 6.81,11.74C6.75,11.63 6.68,11.5 6.61,11.35C6.09,11.96 5.44,12.27 4.65,12.27C4.09,12.27 3.65,12.11 3.32,11.79C3,11.47 2.83,11.04 2.83,10.5C2.83,9.95 3.03,9.5 3.43,9.14C3.84,8.8 4.38,8.62 5.06,8.62C5.29,8.62 5.5,8.64 5.77,8.68C6,8.71 6.27,8.76 6.53,8.82V8.34C6.53,7.83 6.43,7.5 6.22,7.27C6,7.06 5.65,6.97 5.14,6.97C4.9,6.97 4.66,7 4.42,7.05C4.17,7.11 3.93,7.18 3.7,7.28C3.59,7.32 3.5,7.35 3.47,7.36C3.42,7.38 3.39,7.38 3.36,7.38C3.27,7.38 3.22,7.32 3.22,7.18V6.85C3.22,6.75 3.23,6.67 3.27,6.62C3.3,6.57 3.36,6.53 3.45,6.5C3.69,6.36 3.96,6.26 4.29,6.18C4.62,6.09 4.96,6.05 5.33,6.05C6.12,6.05 6.7,6.23 7.07,6.59C7.44,6.95 7.62,7.5 7.62,8.23V10.38H7.64M4.94,11.4C5.16,11.4 5.38,11.36 5.62,11.28C5.86,11.2 6.07,11.05 6.25,10.85C6.36,10.72 6.44,10.58 6.5,10.42C6.5,10.26 6.55,10.07 6.55,9.84V9.57C6.35,9.5 6.15,9.5 5.93,9.45C5.72,9.43 5.5,9.41 5.31,9.41C4.86,9.41 4.54,9.5 4.32,9.68C4.1,9.86 4,10.11 4,10.44C4,10.76 4.07,11 4.24,11.15C4.4,11.32 4.63,11.4 4.94,11.4M10.28,12.11C10.16,12.11 10.08,12.09 10,12.05C9.97,12 9.92,11.91 9.88,11.79L8.32,6.65C8.28,6.5 8.26,6.43 8.26,6.38C8.26,6.27 8.31,6.21 8.42,6.21H9.07C9.2,6.21 9.29,6.23 9.33,6.28C9.39,6.32 9.43,6.41 9.47,6.54L10.58,10.94L11.62,6.54C11.65,6.41 11.69,6.32 11.75,6.28C11.8,6.24 11.89,6.21 12,6.21H12.55C12.67,6.21 12.76,6.23 12.81,6.28C12.86,6.32 12.91,6.41 12.94,6.54L14,11L15.14,6.54C15.18,6.41 15.23,6.32 15.27,6.28C15.33,6.24 15.41,6.21 15.53,6.21H16.15C16.26,6.21 16.32,6.27 16.32,6.38C16.32,6.41 16.31,6.45 16.3,6.5C16.3,6.5 16.28,6.58 16.26,6.65L14.65,11.79C14.61,11.93 14.57,12 14.5,12.05C14.46,12.09 14.37,12.12 14.26,12.12H13.69C13.56,12.12 13.5,12.1 13.42,12.05C13.37,12 13.32,11.92 13.3,11.79L12.27,7.5L11.24,11.78C11.21,11.91 11.17,12 11.12,12.05C11.06,12.09 10.97,12.11 10.85,12.11H10.28M18.83,12.29C18.5,12.29 18.13,12.25 17.8,12.17C17.47,12.09 17.21,12 17.04,11.91C16.93,11.85 16.86,11.78 16.83,11.72C16.8,11.66 16.79,11.6 16.79,11.54V11.2C16.79,11.06 16.84,11 16.94,11C17,11 17,11 17.06,11C17.1,11 17.16,11.05 17.23,11.08C17.45,11.18 17.7,11.26 17.96,11.31C18.23,11.36 18.5,11.39 18.75,11.39C19.17,11.39 19.5,11.32 19.72,11.17C19.95,11 20.07,10.81 20.07,10.54C20.07,10.35 20,10.2 19.89,10.07C19.77,9.95 19.54,9.83 19.22,9.73L18.25,9.43C17.77,9.27 17.41,9.05 17.19,8.75C16.97,8.46 16.86,8.13 16.86,7.78C16.86,7.5 16.92,7.26 17.04,7.05C17.16,6.83 17.32,6.65 17.5,6.5C17.72,6.35 17.94,6.24 18.21,6.16C18.47,6.08 18.75,6.04 19.05,6.04C19.19,6.04 19.34,6.05 19.5,6.07C19.64,6.09 19.78,6.12 19.92,6.14C20.06,6.18 20.18,6.21 20.3,6.25C20.42,6.29 20.5,6.33 20.58,6.37C20.67,6.42 20.74,6.47 20.78,6.53C20.82,6.59 20.84,6.66 20.84,6.75V7.07C20.84,7.21 20.79,7.28 20.69,7.28C20.64,7.28 20.55,7.25 20.43,7.2C20.06,7.03 19.63,6.94 19.16,6.94C18.78,6.94 18.5,7 18.27,7.13C18.07,7.25 17.96,7.45 17.96,7.72C17.96,7.91 18.03,8.07 18.16,8.19C18.29,8.32 18.54,8.44 18.89,8.56L19.84,8.86C20.32,9 20.66,9.22 20.87,9.5C21.07,9.77 21.17,10.08 21.17,10.43C21.17,10.71 21.11,10.97 21,11.2C20.88,11.42 20.72,11.62 20.5,11.78C20.31,11.95 20.06,12.07 19.78,12.16C19.5,12.25 19.16,12.29 18.83,12.29M20.08,15.53C17.89,17.14 14.71,18 12,18C8.15,18 4.7,16.58 2.09,14.23C1.88,14.04 2.07,13.79 2.32,13.94C5.14,15.57 8.61,16.56 12.21,16.56C14.64,16.56 17.31,16.06 19.76,15C20.13,14.85 20.44,15.26 20.08,15.53M21,14.5C20.71,14.13 19.14,14.32 18.43,14.4C18.22,14.43 18.19,14.24 18.38,14.1C19.63,13.23 21.69,13.5 21.92,13.77C22.16,14.07 21.86,16.13 20.69,17.11C20.5,17.26 20.33,17.18 20.41,17C20.68,16.32 21.27,14.84 21,14.5Z";
var mdiAxe = "M12,2L22,8C22,12 20,14 16,15L13,10L9,6L12,2M4.11,19.84L2.12,18.33L9.19,9L11,10.81L4.11,19.84Z";
var mdiAxeBattle = "M21.47 12.43C19.35 14.55 15.82 13.84 15.82 13.84V9.6L3.41 22L2 20.59L14.4 8.18H10.16C10.16 8.18 9.45 4.65 11.57 2.53C13.69 .406 17.23 1.11 17.23 1.11V5.36L17.94 4.65L19.35 6.06L18.64 6.77H22.89C22.89 6.77 23.59 10.31 21.47 12.43Z";
var mdiAxis = "M2.61,21L1.61,19.27L11,13.85V3H13V13.85L22.39,19.27L21.39,21L12,15.58L2.61,21Z";
var mdiAxisArrow = "M12,2L16,6H13V13.85L19.53,17.61L21,15.03L22.5,20.5L17,21.96L18.53,19.35L12,15.58L5.47,19.35L7,21.96L1.5,20.5L3,15.03L4.47,17.61L11,13.85V6H8L12,2Z";
var mdiAxisArrowInfo = "M12 2L16 6H13V13.85L19.53 17.61L21 15.03L22.5 20.5L17 21.96L18.53 19.35L12 15.58L5.47 19.35L7 21.96L1.5 20.5L3 15.03L4.47 17.61L11 13.85V6H8L12 2M21 5H19V3H21V5M22 10V12H18V10H19V8H18V6H21V10H22Z";
var mdiAxisArrowLock = "M21.8,5C22.4,5 23,5.6 23,6.3V9.8C23,10.4 22.4,11 21.7,11H16.2C15.6,11 15,10.4 15,9.7V6.2C15,5.6 15.6,5 16.2,5V3.5C16.2,2.1 17.6,1 19,1C20.4,1 21.8,2.1 21.8,3.5V5M20.5,5V3.5C20.5,2.7 19.8,2.2 19,2.2C18.2,2.2 17.5,2.7 17.5,3.5V5H20.5M1.74,19.25L3.21,13.79L4.68,16.34L9,13.85V6H6L10,2L14,6H11V13.85L18.03,17.86L19.5,15.28L21,20.74L15.5,22.21L17.03,19.6L10,15.58L5.68,18.07L7.21,20.71L1.74,19.25Z";
var mdiAxisLock = "M21.8,5C22.4,5 23,5.6 23,6.3V9.8C23,10.4 22.4,11 21.7,11H16.2C15.6,11 15,10.4 15,9.7V6.2C15,5.6 15.6,5 16.2,5V3.5C16.2,2.1 17.6,1 19,1C20.4,1 21.8,2.1 21.8,3.5V5M20.5,5V3.5C20.5,2.7 19.8,2.2 19,2.2C18.2,2.2 17.5,2.7 17.5,3.5V5H20.5M11,13.82L20.39,19.25L19.39,21L10,15.56L3.17,19.5L2.17,17.77L9,13.82V3H11V13.82Z";
var mdiAxisXArrow = "M1.5,20.5L3,15.03L4.46,17.6L11,13.82V3H13V13.82L22.39,19.25L21.39,21L12,15.56L5.46,19.33L7,21.96L1.5,20.5Z";
var mdiAxisXArrowLock = "M21.8,5C22.4,5 23,5.6 23,6.3V9.8C23,10.4 22.4,11 21.7,11H16.2C15.6,11 15,10.4 15,9.7V6.2C15,5.6 15.6,5 16.2,5V3.5C16.2,2.1 17.6,1 19,1C20.4,1 21.8,2.1 21.8,3.5V5M20.5,5V3.5C20.5,2.7 19.8,2.2 19,2.2C18.31,2.2 17.69,2.58 17.54,3.2C17.5,3.29 17.5,3.39 17.5,3.5V5H20.5M1.74,19.25L3.21,13.79L4.67,16.32L9,13.82V3H11V13.82L20.39,19.25L19.39,21L10,15.56L5.67,18.06L7.21,20.71L1.74,19.25Z";
var mdiAxisXRotateClockwise = "M12,10H14.91C14.57,6.55 13.4,4 12,4C10.42,4 9.12,7.27 9,11.42L7,12.57V12C7,6.5 9.24,2 12,2C14.42,2 16.44,5.44 16.9,10H20L16,14L12,10M12,22C10.12,22 8.47,19.92 7.62,16.84L9.37,15.83C9.87,18.31 10.86,20 12,20C13.27,20 14.36,17.89 14.79,14.92L16,16.12L16.7,15.42C16,19.26 14.16,22 12,22M2.11,18.87L1.11,17.13L1.06,17.06L11.12,11.25L12.72,12.84L2.15,18.94L2.11,18.87M21.89,5.13L22.89,6.87L19.2,9H17.77L17.5,7.66L21.89,5.13Z";
var mdiAxisXRotateCounterclockwise = "M12,14L16,10L20,14H16.9C16.44,18.56 14.42,22 12,22C10.12,22 8.47,19.92 7.62,16.84L9.37,15.83C9.87,18.31 10.86,20 12,20C13.4,20 14.57,17.45 14.91,14H12M1.11,17.13L13.89,9.75L13.96,10.54L10.5,14H10.54L2.11,18.87L1.11,17.13M21.89,5.13L22.89,6.87L17.88,9.76C17.79,9.03 17.67,8.33 17.5,7.66L21.89,5.13M12,2C14.3,2 16.23,5.1 16.82,9.32L16,8.5L14.87,9.63C14.5,6.37 13.35,4 12,4C10.42,4 9.12,7.27 9,11.42L7,12.57V12C7,6.5 9.24,2 12,2Z";
var mdiAxisXYArrowLock = "M21.8,5C22.4,5 23,5.6 23,6.3V9.8C23,10.4 22.4,11 21.7,11H16.2C15.6,11 15,10.4 15,9.7V6.2C15,5.6 15.6,5 16.2,5V3.5C16.2,2.1 17.6,1 19,1C20.4,1 21.8,2.1 21.8,3.5V5M20.5,5V3.5C20.5,2.7 19.8,2.2 19,2.2C18.2,2.2 17.5,2.7 17.5,3.5V5H20.5M1.74,19.25L3.21,13.79L4.68,16.34L9,13.85V3H11V13.85L17.53,17.61L19,15.03L20.5,20.5L15,21.96L16.53,19.35L10,15.58L5.68,18.07L7.21,20.71L1.74,19.25Z";
var mdiAxisYArrow = "M22.5,20.5L17,21.96L18.53,19.35L12,15.58L2.61,21L1.61,19.27L11,13.85V3H13V13.85L19.53,17.61L21,15.03L22.5,20.5Z";
var mdiAxisYArrowLock = "M11,13.82L18,17.88L19.5,15.28L21,20.74L15.5,22.21L17,19.61L10,15.56L3.17,19.5L2.17,17.77L9,13.82V3H11V13.82M21.8,5C22.4,5 23,5.6 23,6.3V9.8C23,10.4 22.4,11 21.7,11H16.2C15.6,11 15,10.4 15,9.7V6.2C15,5.6 15.6,5 16.2,5V3.5C16.2,2.1 17.6,1 19,1C20.4,1 21.8,2.1 21.8,3.5V5M20.5,5V3.5C20.5,2.7 19.8,2.2 19,2.2C18.2,2.2 17.5,2.7 17.5,3.5V5H20.5Z";
var mdiAxisYRotateClockwise = "M12,10L16,14L20,10H16.9C16.44,5.44 14.42,2 12,2C10.12,2 8.47,4.08 7.62,7.16L9.37,8.17C9.87,5.69 10.86,4 12,4C13.4,4 14.57,6.55 14.91,10H12M1.11,6.87L13.89,14.25L13.96,13.46L10.5,10H10.54L2.11,5.13L1.11,6.87M21.89,18.87L22.89,17.13L17.88,14.24C17.79,14.97 17.67,15.67 17.5,16.34L21.89,18.87M12,22C14.3,22 16.23,18.9 16.82,14.68L16,15.5L14.87,14.37C14.5,17.63 13.35,20 12,20C10.42,20 9.12,16.73 9,12.58L7,11.43V12C7,17.5 9.24,22 12,22Z";
var mdiAxisYRotateCounterclockwise = "M12,14H14.91C14.57,17.45 13.4,20 12,20C10.42,20 9.12,16.73 9,12.58L7,11.43V12C7,17.5 9.24,22 12,22C14.42,22 16.44,18.56 16.9,14H20L16,10L12,14M12,2C10.12,2 8.47,4.08 7.62,7.16L9.37,8.17C9.87,5.69 10.86,4 12,4C13.27,4 14.36,6.11 14.79,9.08L16,7.88L16.7,8.58C16,4.74 14.16,2 12,2M2.11,5.13L1.11,6.87L1.06,6.94L11.12,12.75L12.72,11.16L2.15,5.06L2.11,5.13M21.89,18.87L22.89,17.13L19.2,15H17.77L17.5,16.34L21.89,18.87Z";
var mdiAxisZArrow = "M12,2L16,6H13V13.82L22.39,19.25L21.39,21L12,15.56L2.61,21L1.61,19.25L11,13.82V6H8L12,2Z";
var mdiAxisZArrowLock = "M21.8,5C22.4,5 23,5.6 23,6.3V9.8C23,10.4 22.4,11 21.7,11H16.2C15.6,11 15,10.4 15,9.7V6.2C15,5.6 15.6,5 16.2,5V3.5C16.2,2.1 17.6,1 19,1C20.4,1 21.8,2.1 21.8,3.5V5M20.5,5V3.5C20.5,2.7 19.8,2.2 19,2.2C18.2,2.2 17.5,2.7 17.5,3.5V5H20.5M10,2L14,6H11V13.82L20.39,19.25L19.39,21L10,15.56L3.17,19.5L2.17,17.77L9,13.82V6H6L10,2Z";
var mdiAxisZRotateClockwise = "M14,12L10,16L14,20V16.9C18.56,16.44 22,14.42 22,12C22,9.58 18.56,7.56 14,7.1V9.09C17.45,9.43 20,10.6 20,12C20,13.4 17.45,14.57 14,14.91V12M4,12C4,10.6 6.55,9.43 10,9.09V7.1C5.44,7.56 2,9.58 2,12C2,14.16 4.74,16 8.58,16.7L7.88,16L9.08,14.79C6.11,14.36 4,13.27 4,12M13,2H11V13L13,11V2M13,22V21L11,19V22H13Z";
var mdiAxisZRotateCounterclockwise = "M10,12L14,16L10,20V16.9C5.44,16.44 2,14.42 2,12C2,9.58 5.44,7.56 10,7.1V9.09C6.55,9.43 4,10.6 4,12C4,13.4 6.55,14.57 10,14.91V12M20,12C20,10.6 17.45,9.43 14,9.09V7.1C18.56,7.56 22,9.58 22,12C22,14.16 19.26,16 15.42,16.7L16.12,16L14.92,14.79C17.89,14.36 20,13.27 20,12M11,2H13V13L11,11V2M11,22V21L13,19V22H11Z";
var mdiBabel = "M15.14 2C13.8 2.12 12.04 2.59 9.87 3.43C9.28 3.87 8.6 4.3 7.84 4.72V4.85C7.9 4.85 7.96 4.81 8.04 4.77C8.13 4.76 8.19 4.79 8.19 4.88L8.32 4.8L8.39 4.79L8.4 4.86C8.41 4.92 7.93 5.29 7 5.96L7.06 6.09H7L6.84 6.04C6.84 6.09 6.78 6.11 6.64 6.12L6.65 6.19L6.81 6.37C6.75 6.37 6.68 6.36 6.6 6.32C6.29 6.35 6 6.58 5.69 7L5.77 7.12C6.03 6.88 6.18 6.76 6.22 6.76L6.24 6.95C6.2 6.95 6.12 7 6.04 7.03L6.2 7.27C6.5 6.93 6.86 6.64 7.24 6.41C7.43 6.46 7.53 6.5 7.53 6.58L7.67 6.57C8.69 5.81 9.71 5.27 10.71 4.93L10.72 5.06C10.53 5.34 10.4 5.5 10.33 5.5C10.34 5.59 10.38 5.67 10.43 5.74C10.45 5.92 10 7.06 9.07 9.19C6.95 14.13 5.19 17.78 3.77 20.16C3.77 20.2 3.8 20.27 3.85 20.35C4.2 20.26 4.42 20.18 4.5 20.1L4.6 20.09L4.61 20.22L4.74 20.21L4.88 20.13C4.88 20.18 4.93 20.19 5 20.18L5.03 20.31C5.03 20.45 4.96 20.65 4.8 20.92C4.65 21.08 4.5 21.42 4.34 21.94V22H4.47C5.04 21.35 5.5 20.72 5.78 20.11C7.44 19.62 8.71 19.15 9.59 18.67C10.47 18.6 11.15 18.37 11.61 18L11.6 17.91L11.27 18H11.19L11.18 17.95C11.83 17.85 12.28 17.7 12.5 17.5C13.79 16.54 14.74 15.85 15.39 15.44C17.39 13.97 18.33 12.55 18.22 11.21C18.21 11.07 17.76 10.5 16.9 9.56C16.88 9.38 17.19 9.12 17.8 8.77L19.53 7.24C19.92 6.74 20.15 5.94 20.23 4.83L20.2 4.57C20.14 3.79 19.58 3.16 18.5 2.68C17.88 2.25 16.76 2.03 15.14 2M17.24 2.87C18.53 2.92 19.19 3.14 19.23 3.55L19.18 3.68L17.24 2.87M16 3.96C16.89 3.95 17.35 4.18 17.4 4.68L17.5 4.67V4.34L17.64 4.33C18 4.5 18.16 4.74 18.18 5C18.2 5.2 18.1 5.42 17.89 5.69C17.8 5.7 17.75 5.64 17.74 5.5H17.6L17.56 5.91C17 6.78 16.56 7.23 16.3 7.26C16.06 7.58 15.91 7.75 15.85 7.75C15.67 7.97 15.17 8.35 14.35 8.87C14.08 8.9 13.07 9.28 11.34 10.04C11.25 10 11.16 10 11.06 10L11.05 9.88C11.03 9.62 11.14 9.31 11.39 8.92C11.5 8.21 11.67 7.8 11.83 7.7L13.28 4.44C13.27 4.24 13.57 4.09 14.21 4L14.42 3.96L14.44 4.15C15.06 4.05 15.45 4 15.6 4C15.74 3.97 15.88 3.96 16 3.96M19 4.29H19.04C19.16 4.3 19.28 4.5 19.41 4.91L19.42 5.03C19.35 5.04 19.22 4.83 19.03 4.41L19 4.29M10.82 6.36H10.88L10.9 6.55C10.84 6.56 10.75 6.65 10.65 6.83L10.64 6.7C10.76 6.55 10.82 6.43 10.82 6.36M6.67 6.46L6.68 6.5C6.63 6.5 6.56 6.56 6.5 6.6L6.41 6.61L6.39 6.5L6.67 6.46M10.24 7.72L10.26 8H10.19L10.16 7.73L10.24 7.72M10.07 8.19C10.05 8.41 10 8.5 9.89 8.53L9.82 8.54C9.9 8.39 9.94 8.29 9.93 8.21L10.07 8.19M9.78 8.87L9.79 8.93L9.67 9.14L9.54 9.15L9.53 9.09C9.66 9.08 9.72 9 9.71 8.88L9.78 8.87M9.5 9.5L9.45 9.81H9.38L9.36 9.5H9.5M16.57 9.72L16.85 9.89C16.86 10 16.82 10.03 16.73 10.04C16.61 9.96 16.5 9.93 16.44 9.93L16.43 9.73L16.57 9.72M11 10.46L11.03 10.58L10.76 10.61L10.75 10.5L11 10.46M15.5 10.91C15.68 11 15.78 11.09 15.79 11.16L15.8 11.22C15.61 11.24 15.45 11.14 15.29 10.93L15.5 10.91M17.66 11.12C17.81 11.18 17.88 11.25 17.89 11.31L17.93 11.82C17.87 11.96 17.81 12.03 17.74 12.03L17.66 11.12M14.16 11.18C14.86 11.17 15.4 11.33 15.76 11.68L15.79 11.94C15.5 12.85 15.13 13.38 14.75 13.54L13 14.93C11.7 15.79 11 16.21 10.9 16.22C8.83 17.36 7.54 17.95 7.04 18H6.96C7.03 17.76 7.95 15.87 9.73 12.33C10.5 12.26 11.76 11.89 13.44 11.23L13.85 11.19C13.96 11.19 14.06 11.18 14.16 11.18M11.62 11.59L11.63 11.65L11.35 11.67L11.34 11.61L11.62 11.59M7.26 15.81C7.17 16.26 7.08 16.5 7 16.5L6.97 16.43C6.95 16.2 7.05 16 7.26 15.81M13.18 16.09L13.19 16.21C13.2 16.27 13 16.43 12.6 16.72C11.44 17.29 10.76 17.68 10.56 17.88C9.3 18.32 8.68 18.59 8.69 18.69C7.57 19.14 6.84 19.46 6.5 19.66C6.41 19.67 6.29 19.63 6.13 19.56C6.12 19.34 6.21 19.15 6.44 19C6.63 19 6.82 19 7 19.09C7.21 19 7.57 18.87 8.08 18.74L8.07 18.61L7.66 18.65C7.71 18.58 8.11 18.4 8.86 18.09L9.07 18.07L9.08 18.13C8.73 18.16 8.53 18.27 8.5 18.46C8.5 18.53 8.53 18.58 8.62 18.57C8.87 18.39 9 18.3 9 18.27C9.5 18.18 10.9 17.44 13.18 16.09M6.86 16.69L6.87 16.75C6.88 16.84 6.83 16.89 6.74 16.9V16.84C6.73 16.76 6.77 16.71 6.86 16.69M10 17.5C10.07 17.47 10.12 17.5 10.12 17.58C9.96 17.6 9.65 17.73 9.19 18H9.12L9.11 17.87C9.44 17.84 9.73 17.71 9.97 17.5H10M6.95 18.5L6.96 18.58C6.9 18.58 6.84 18.61 6.75 18.66L6.62 18.67C6.61 18.61 6.65 18.55 6.74 18.53L6.95 18.5M5.35 19.3L5.5 19.36C5.44 19.76 5.33 19.96 5.13 20C4.97 19.91 4.83 19.88 4.7 19.89L4.68 19.7C4.67 19.62 4.72 19.57 4.82 19.55C4.9 19.54 4.95 19.6 4.96 19.73C5.2 19.44 5.33 19.3 5.35 19.3Z";
var mdiBaby = "M18.5,4A2.5,2.5 0 0,1 21,6.5A2.5,2.5 0 0,1 18.5,9A2.5,2.5 0 0,1 16,6.5A2.5,2.5 0 0,1 18.5,4M4.5,20A1.5,1.5 0 0,1 3,18.5A1.5,1.5 0 0,1 4.5,17H11.5A1.5,1.5 0 0,1 13,18.5A1.5,1.5 0 0,1 11.5,20H4.5M16.09,19L14.69,15H11L6.75,10.75C6.75,10.75 9,8.25 12.5,8.25C15.5,8.25 15.85,9.25 16.06,9.87L18.92,18C19.2,18.78 18.78,19.64 18,19.92C17.22,20.19 16.36,19.78 16.09,19Z";
var mdiBabyBottle = "M11.28 2.8L10.78 3.3A5.5 5.5 0 0 0 6.41 2.87L6.33 2.8A2.5 2.5 0 0 0 2.8 6.33L2.87 6.41A5.5 5.5 0 0 0 3.3 10.78L2.8 11.28A1.5 1.5 0 0 0 2.8 13.4L4.21 14.82A1.5 1.5 0 0 0 6.33 14.82L6.68 14.46L13.76 21.53A1.5 1.5 0 0 0 15.88 21.53L21.53 15.88A1.5 1.5 0 0 0 21.53 13.76L14.46 6.68L14.82 6.33A1.5 1.5 0 0 0 14.82 4.21L13.4 2.8A1.5 1.5 0 0 0 11.28 2.8M13.76 5.27L5.27 13.76L3.86 12.34L12.34 3.86M14.82 11.63L11.63 14.82L10.57 13.76L13.76 10.57M16.94 13.76L13.76 16.94L12.69 15.88L15.88 12.69Z";
var mdiBabyBottleOutline = "M11.28 2.8L10.78 3.3C9.44 2.55 7.84 2.4 6.41 2.87L6.33 2.8C5.36 1.82 3.77 1.82 2.8 2.8S1.82 5.36 2.8 6.33L2.87 6.41C2.4 7.84 2.55 9.44 3.3 10.78L2.8 11.28C2.21 11.87 2.21 12.81 2.8 13.4L4.21 14.82C4.8 15.4 5.74 15.4 6.33 14.82L6.68 14.46L13.76 21.53C14.34 22.12 15.29 22.12 15.88 21.53L21.53 15.88C22.12 15.29 22.12 14.34 21.53 13.75L14.46 6.68L14.82 6.33C15.4 5.74 15.4 4.8 14.82 4.21L13.4 2.79C12.82 2.21 11.87 2.21 11.28 2.8M4.25 7.05C4.33 6.71 4.47 6.38 4.66 6.07L3.86 5.27C3.75 5.16 3.67 5.04 3.63 4.9C3.5 4.56 3.57 4.14 3.86 3.86S4.56 3.5 4.9 3.63C5.04 3.67 5.16 3.75 5.27 3.86L6.07 4.66C6.38 4.47 6.71 4.33 7.05 4.25C7.91 4 8.83 4.06 9.65 4.42L4.42 9.65C4.06 8.83 4 7.91 4.25 7.05M20.47 14.82L14.82 20.47L7.75 13.4L13.4 7.75L20.47 14.82M13.76 5.27L5.27 13.76L3.86 12.34L12.34 3.86L13.76 5.27M14.82 11.63L11.63 14.82L10.57 13.76L13.76 10.57L14.82 11.63M16.94 13.76L13.76 16.94L12.69 15.88L15.88 12.69L16.94 13.76Z";
var mdiBabyBuggy = "M17 20A2 2 0 0 1 15 22A2 2 0 0 1 13 20A2 2 0 0 1 15 18A2 2 0 0 1 17 20M7 20A2 2 0 0 1 5 22A2 2 0 0 1 3 20A2 2 0 0 1 5 18A2 2 0 0 1 7 20M17.61 3C16.95 3 16.44 3.2 16 3.5C15.32 3.91 14.88 4.59 14.47 5.07L5.71 15.35C5.16 16 5.62 17 6.47 17H14C15.11 17 16 16.1 16 15V6.38C16.58 5.7 16.93 5 17.61 5C18.38 5 19 5.66 19 6.5V7H21V6.5C21 4.56 19.5 3 17.61 3M8.86 3.09C7.04 3.16 5.23 3.76 3.68 4.9L8.44 9.66L12.32 5.1C12.59 4.78 12.91 4.38 13.3 4C12.14 3.45 10.9 3.15 9.65 3.09C9.39 3.08 9.12 3.08 8.86 3.09Z";
var mdiBabyBuggyOff = "M17 20C17 21.11 16.11 22 15 22S13 21.11 13 20 13.9 18 15 18 17 18.9 17 20M5 18C3.9 18 3 18.9 3 20S3.9 22 5 22 7 21.11 7 20 6.11 18 5 18M22.11 21.46L2.39 1.73L1.11 3L9.28 11.17L5.71 15.35C5.16 16 5.62 17 6.47 17H14C14.32 17 14.62 16.92 14.89 16.78L20.84 22.73L22.11 21.46M16 12.8V6.38C16.58 5.7 16.93 5 17.61 5C18.38 5 19 5.66 19 6.5V7H21V6.5C21 4.56 19.5 3 17.61 3C16.95 3 16.44 3.2 16 3.5C15.32 3.91 14.88 4.59 14.47 5.07L11.62 8.42L16 12.8M12.32 5.1C12.59 4.78 12.91 4.38 13.3 4C12.14 3.45 10.9 3.15 9.65 3.09C9.39 3.08 9.12 3.08 8.86 3.09C8.12 3.12 7.38 3.26 6.66 3.46L10.47 7.27L12.32 5.1Z";
var mdiBabyCarriage = "M13,2V10H21A8,8 0 0,0 13,2M19.32,15.89C20.37,14.54 21,12.84 21,11H6.44L5.5,9H2V11H4.22C4.22,11 6.11,15.07 6.34,15.42C5.24,16 4.5,17.17 4.5,18.5A3.5,3.5 0 0,0 8,22C9.76,22 11.22,20.7 11.46,19H13.54C13.78,20.7 15.24,22 17,22A3.5,3.5 0 0,0 20.5,18.5C20.5,17.46 20.04,16.53 19.32,15.89M8,20A1.5,1.5 0 0,1 6.5,18.5A1.5,1.5 0 0,1 8,17A1.5,1.5 0 0,1 9.5,18.5A1.5,1.5 0 0,1 8,20M17,20A1.5,1.5 0 0,1 15.5,18.5A1.5,1.5 0 0,1 17,17A1.5,1.5 0 0,1 18.5,18.5A1.5,1.5 0 0,1 17,20Z";
var mdiBabyCarriageOff = "M22 10C22 5.6 18.4 2 14 2V10H22M14.2 11H22C22 12.8 21.4 14.5 20.3 15.9C21 16.5 21.4 17.4 21.5 18.3L14.2 11M20.8 22.7L22.1 21.4L2.4 1.7L1.1 3L9.1 11H7.4L6.5 9H3V11H5.2C5.2 11 7.1 15.1 7.3 15.4C6.3 15.9 5.6 16.9 5.5 18C5.2 19.9 6.6 21.7 8.5 22C10.4 22.3 12.2 20.9 12.5 19H14.6C14.7 19.4 14.8 19.8 15 20.2C15.9 21.9 18.1 22.5 19.7 21.6L20.8 22.7M10.5 18.5C10.5 19.3 9.8 20 9 20S7.5 19.3 7.5 18.5 8.2 17 9 17 10.5 17.7 10.5 18.5M18.1 20C17.2 20 16.5 19.3 16.5 18.5V18.4L18.1 20Z";
var mdiBabyFace = "M1,12C1,10.19 2.2,8.66 3.86,8.17C5.29,5.11 8.4,3 12,3C15.6,3 18.71,5.11 20.15,8.17C21.8,8.66 23,10.19 23,12C23,13.81 21.8,15.34 20.15,15.83C18.71,18.89 15.6,21 12,21C8.4,21 5.29,18.89 3.86,15.83C2.2,15.34 1,13.81 1,12M14.5,9.25A1.25,1.25 0 0,0 13.25,10.5A1.25,1.25 0 0,0 14.5,11.75A1.25,1.25 0 0,0 15.75,10.5A1.25,1.25 0 0,0 14.5,9.25M9.5,9.25A1.25,1.25 0 0,0 8.25,10.5A1.25,1.25 0 0,0 9.5,11.75A1.25,1.25 0 0,0 10.75,10.5A1.25,1.25 0 0,0 9.5,9.25M7.5,14C8.26,15.77 10,17 12,17C14,17 15.74,15.77 16.5,14H7.5M3,12C3,12.82 3.5,13.53 4.21,13.84C4.07,13.25 4,12.63 4,12C4,11.37 4.07,10.75 4.21,10.16C3.5,10.47 3,11.18 3,12M21,12C21,11.18 20.5,10.47 19.79,10.16C19.93,10.75 20,11.37 20,12C20,12.63 19.93,13.25 19.79,13.84C20.5,13.53 21,12.82 21,12Z";
var mdiBabyFaceOutline = "M14.5,9.25A1.25,1.25 0 0,1 15.75,10.5A1.25,1.25 0 0,1 14.5,11.75A1.25,1.25 0 0,1 13.25,10.5A1.25,1.25 0 0,1 14.5,9.25M9.5,9.25A1.25,1.25 0 0,1 10.75,10.5A1.25,1.25 0 0,1 9.5,11.75A1.25,1.25 0 0,1 8.25,10.5A1.25,1.25 0 0,1 9.5,9.25M7.5,14H16.5C15.74,15.77 14,17 12,17C10,17 8.26,15.77 7.5,14M1,12C1,10.19 2.2,8.66 3.86,8.17C5.29,5.11 8.4,3 12,3C15.6,3 18.71,5.11 20.15,8.17C21.8,8.66 23,10.19 23,12C23,13.81 21.8,15.34 20.15,15.83C18.71,18.89 15.6,21 12,21C8.4,21 5.29,18.89 3.86,15.83C2.2,15.34 1,13.81 1,12M12,5C8.82,5 6.14,7.12 5.28,10H5A2,2 0 0,0 3,12A2,2 0 0,0 5,14H5.28C6.14,16.88 8.82,19 12,19C15.18,19 17.86,16.88 18.72,14H19A2,2 0 0,0 21,12A2,2 0 0,0 19,10H18.72C17.86,7.12 15.18,5 12,5Z";
var mdiBackburger = "M5,13L9,17L7.6,18.42L1.18,12L7.6,5.58L9,7L5,11H21V13H5M21,6V8H11V6H21M21,16V18H11V16H21Z";
var mdiBackspace = "M22,3H7C6.31,3 5.77,3.35 5.41,3.88L0,12L5.41,20.11C5.77,20.64 6.31,21 7,21H22A2,2 0 0,0 24,19V5A2,2 0 0,0 22,3M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12";
var mdiBackspaceOutline = "M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12L19,15.59M22,3A2,2 0 0,1 24,5V19A2,2 0 0,1 22,21H7C6.31,21 5.77,20.64 5.41,20.11L0,12L5.41,3.88C5.77,3.35 6.31,3 7,3H22M22,5H7L2.28,12L7,19H22V5Z";
var mdiBackspaceReverse = "M2,21H17C17.7,21 18.2,20.6 18.6,20.1L24,12L18.6,3.9C18.2,3.4 17.7,3 17,3H2A2,2 0 0,0 0,5V19A2,2 0 0,0 2,21M5,8.4L6.4,7L10,10.6L13.6,7L15,8.4L11.4,12L15,15.6L13.6,17L10,13.4L6.4,17L5,15.6L8.6,12";
var mdiBackspaceReverseOutline = "M5,15.59L6.41,17L10,13.41L13.59,17L15,15.59L11.41,12L15,8.41L13.59,7L10,10.59L6.41,7L5,8.41L8.59,12L5,15.59M2,3A2,2 0 0,0 0,5V19A2,2 0 0,0 2,21H17C17.69,21 18.23,20.64 18.59,20.11L24,12L18.59,3.88C18.23,3.35 17.69,3 17,3H2M2,5H17L21.72,12L17,19H2V5Z";
var mdiBackupRestore = "M12,3A9,9 0 0,0 3,12H0L4,16L8,12H5A7,7 0 0,1 12,5A7,7 0 0,1 19,12A7,7 0 0,1 12,19C10.5,19 9.09,18.5 7.94,17.7L6.5,19.14C8.04,20.3 9.94,21 12,21A9,9 0 0,0 21,12A9,9 0 0,0 12,3M14,12A2,2 0 0,0 12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12Z";
var mdiBacteria = "M21,16C21,15.5 20.95,15.08 20.88,14.68L22.45,13.9L21.55,12.1L20.18,12.79C19.63,11.96 18.91,11.5 18.29,11.28L18.95,9.32L17.05,8.68L16.29,10.96C14.96,10.83 14.17,10.32 13.7,9.77L15.45,8.9L14.55,7.1L13,7.89C12.97,7.59 12.86,6.72 12.28,5.87L13.83,3.55L12.17,2.44L10.76,4.56C10.28,4.33 9.7,4.15 9,4.06V2H7V4.1C6.29,4.25 5.73,4.54 5.32,4.91L2.7,2.29L1.29,3.71L4.24,6.65C4,7.39 4,8 4,8H2V10H4.04C4.1,10.63 4.21,11.36 4.4,12.15L1.68,13.05L2.31,14.95L5,14.05C5.24,14.56 5.5,15.08 5.82,15.58L3.44,17.17L4.55,18.83L7.07,17.15C7.63,17.71 8.29,18.21 9.06,18.64L8.1,20.55L9.89,21.45L10.89,19.45L10.73,19.36C11.68,19.68 12.76,19.9 14,19.97V22H16V19.93C16.76,19.84 17.81,19.64 18.77,19.19L20.29,20.71L21.7,19.29L20.37,17.95C20.75,17.44 21,16.8 21,16M8.5,11A1.5,1.5 0 0,1 7,9.5A1.5,1.5 0 0,1 8.5,8A1.5,1.5 0 0,1 10,9.5A1.5,1.5 0 0,1 8.5,11M11,14A1,1 0 0,1 10,13A1,1 0 0,1 11,12A1,1 0 0,1 12,13A1,1 0 0,1 11,14M15.5,17A1.5,1.5 0 0,1 14,15.5A1.5,1.5 0 0,1 15.5,14A1.5,1.5 0 0,1 17,15.5A1.5,1.5 0 0,1 15.5,17Z";
var mdiBacteriaOutline = "M9,2H7V4.1C6.29,4.25 5.73,4.54 5.32,4.91L2.7,2.29L1.29,3.71L4.24,6.65C4,7.39 4,8 4,8H2V10H4.04C4.1,10.63 4.21,11.36 4.4,12.15L1.68,13.05L2.31,14.95L5,14.05C5.24,14.56 5.5,15.08 5.82,15.58L3.44,17.17L4.55,18.83L7.07,17.15C7.63,17.71 8.29,18.21 9.06,18.64L8.1,20.55L9.89,21.45L10.89,19.45L10.73,19.36C11.68,19.68 12.76,19.9 14,19.97V22H16V19.93C16.76,19.84 17.81,19.64 18.77,19.19L20.29,20.71L21.7,19.29L20.37,17.95C20.75,17.44 21,16.8 21,16C21,15.5 20.95,15.08 20.88,14.68L22.45,13.9L21.55,12.1L20.18,12.79C19.63,11.96 18.91,11.5 18.29,11.28L18.95,9.32L17.05,8.68L16.29,10.96C14.96,10.83 14.17,10.32 13.7,9.77L15.45,8.9L14.55,7.1L13,7.89C12.97,7.59 12.86,6.72 12.28,5.87L13.83,3.55L12.17,2.44L10.76,4.56C10.28,4.33 9.7,4.15 9,4.06M15,18C12.06,18 9.81,17.18 8.31,15.56C5.68,12.72 6,8.2 6,8.17V8.11L6,8.03C6,7.1 6.39,6 8,6C10.63,6 10.97,7.43 11,8C11,10 12.6,13 17,13C17.33,13 19,13.15 19,16C19,17.89 15.03,18 15,18M8.5,8A1.5,1.5 0 0,0 7,9.5A1.5,1.5 0 0,0 8.5,11A1.5,1.5 0 0,0 10,9.5A1.5,1.5 0 0,0 8.5,8M11,12A1,1 0 0,0 10,13A1,1 0 0,0 11,14A1,1 0 0,0 12,13A1,1 0 0,0 11,12M15.5,14A1.5,1.5 0 0,0 14,15.5A1.5,1.5 0 0,0 15.5,17A1.5,1.5 0 0,0 17,15.5A1.5,1.5 0 0,0 15.5,14Z";
var mdiBadgeAccount = "M17,3H14V6H10V3H7A2,2 0 0,0 5,5V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V5A2,2 0 0,0 17,3M12,8A2,2 0 0,1 14,10A2,2 0 0,1 12,12A2,2 0 0,1 10,10A2,2 0 0,1 12,8M16,16H8V15C8,13.67 10.67,13 12,13C13.33,13 16,13.67 16,15V16M13,5H11V1H13V5M16,19H8V18H16V19M12,21H8V20H12V21Z";
var mdiBadgeAccountAlert = "M15,3H12V6H8V3H5A2,2 0 0,0 3,5V21A2,2 0 0,0 5,23H15A2,2 0 0,0 17,21V5A2,2 0 0,0 15,3M10,8A2,2 0 0,1 12,10A2,2 0 0,1 10,12A2,2 0 0,1 8,10A2,2 0 0,1 10,8M14,16H6V15C6,13.67 8.67,13 10,13C11.33,13 14,13.67 14,15V16M11,5H9V1H11V5M14,19H6V18H14V19M10,21H6V20H10V21M19,13V7H21V13H19M19,17V15H21V17H19Z";
var mdiBadgeAccountAlertOutline = "M15,3H12V5H15V21H5V5H8V3H5A2,2 0 0,0 3,5V21A2,2 0 0,0 5,23H15A2,2 0 0,0 17,21V5A2,2 0 0,0 15,3M10,7A2,2 0 0,1 12,9A2,2 0 0,1 10,11A2,2 0 0,1 8,9A2,2 0 0,1 10,7M14,15H6V14C6,12.67 8.67,12 10,12C11.33,12 14,12.67 14,14V15M14,18H6V17H14V18M10,20H6V19H10V20M11,5H9V1H11V5M19,13V7H21V13H19M19,17V15H21V17H19Z";
var mdiBadgeAccountHorizontal = "M22,4H14V7H10V4H2A2,2 0 0,0 0,6V20A2,2 0 0,0 2,22H22A2,2 0 0,0 24,20V6A2,2 0 0,0 22,4M8,9A2,2 0 0,1 10,11A2,2 0 0,1 8,13A2,2 0 0,1 6,11A2,2 0 0,1 8,9M12,17H4V16C4,14.67 6.67,14 8,14C9.33,14 12,14.67 12,16V17M20,18H14V16H20V18M20,14H14V12H20V14M20,10H14V8H20V10M13,6H11V2H13V6Z";
var mdiBadgeAccountHorizontalOutline = "M8,9A2,2 0 0,1 10,11A2,2 0 0,1 8,13A2,2 0 0,1 6,11A2,2 0 0,1 8,9M12,17H4V16C4,14.67 6.67,14 8,14C9.33,14 12,14.67 12,16V17M20,8H14V10H20V8M20,12H14V14H20V12M20,16H14V18H20V16M22,4H14V6H22V20H2V6H10V4H2A2,2 0 0,0 0,6V20A2,2 0 0,0 2,22H22A2,2 0 0,0 24,20V6A2,2 0 0,0 22,4M13,6H11V2H13V6Z";
var mdiBadgeAccountOutline = "M17,3H14V5H17V21H7V5H10V3H7A2,2 0 0,0 5,5V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V5A2,2 0 0,0 17,3M12,7A2,2 0 0,1 14,9A2,2 0 0,1 12,11A2,2 0 0,1 10,9A2,2 0 0,1 12,7M16,15H8V14C8,12.67 10.67,12 12,12C13.33,12 16,12.67 16,14V15M16,18H8V17H16V18M12,20H8V19H12V20M13,5H11V1H13V5Z";
var mdiBadminton = "M12.3,2C11.33,2.03 10.58,2.84 10.61,3.8C10.62,4.04 10.67,4.27 10.77,4.5L11.06,5.14V5.14C11.1,5.27 11.03,5.41 10.89,5.45C10.8,5.5 10.7,5.45 10.63,5.37L10.21,4.82C9.88,4.4 9.38,4.14 8.85,4.13C7.88,4.11 7.08,4.88 7.06,5.84C7.05,6.26 7.19,6.66 7.45,7L7.87,7.5H7.88C7.96,7.63 7.93,7.79 7.82,7.87C7.73,7.94 7.61,7.94 7.53,7.87L7,7.45C6.66,7.19 6.25,7.05 5.84,7.06C4.88,7.08 4.11,7.88 4.13,8.85C4.14,9.38 4.4,9.88 4.82,10.21L5.39,10.65C5.5,10.75 5.5,10.91 5.38,11C5.31,11.07 5.21,11.09 5.12,11.05H5.11L4.5,10.77C4.27,10.68 4.04,10.62 3.8,10.61C2.84,10.58 2.03,11.34 2,12.31C2,13.03 2.4,13.69 3.06,13.97L14.45,19.04L19.04,14.45L13.97,3.06C13.69,2.39 13,1.97 12.3,2M13.13,6.1C13.55,6.09 13.93,6.33 14.09,6.71L17.14,13.55L13.19,9.61L12.26,7.5C11.96,6.87 12.42,6.12 13.13,6.1M9.85,8.85C10.12,8.85 10.37,8.95 10.56,9.15L15.37,13.96C15.77,14.34 15.78,14.97 15.4,15.37C15,15.77 14.38,15.78 13.96,15.37L9.15,10.56C8.75,10.18 8.74,9.54 9.13,9.15C9.32,8.95 9.58,8.85 9.85,8.85M7.13,12.17C7.26,12.17 7.4,12.21 7.5,12.26L9.63,13.2L13.57,17.14L6.71,14.09C5.69,13.65 6.03,12.14 7.13,12.17M20.28,16.04L16.04,20.28L16.89,21.13C17.65,21.88 18.75,22.17 19.78,21.9C20.81,21.62 21.62,20.81 21.9,19.78C22.17,18.75 21.88,17.65 21.13,16.89L20.28,16.04Z";
var mdiBagCarryOn = "M14.6 21.4C15 21.8 15.4 22 16 22S17 21.8 17.4 21.4 18 20.6 18 20 17.8 19 17.4 18.6 16.5 18 16 18 15 18.2 14.6 18.6 14 19.4 14 20 14.2 21 14.6 21.4M6 19C6 19.5 6.2 20 6.6 20.4C7 20.8 7.5 21 8 21V7C7.5 7 7 7.2 6.6 7.6C6.2 8 6 8.5 6 9V19M16 2H12C12 2.5 12.2 3 12.6 3.4C13 3.8 13.5 4 14 4V7H9V21H13.2C13 20.5 13 20.2 13 20C13 19.2 13.3 18.5 13.9 17.9C14.5 17.3 15.2 17 16 17V2Z";
var mdiBagCarryOnCheck = "M15.28,16.69L18.14,13.88L18.84,14.58L15.28,18.14L13.17,16L13.88,15.28L15.28,16.69M8,21A2,2 0 0,1 6,19V9A2,2 0 0,1 8,7V21M9,7H14V4A2,2 0 0,1 12,2H16V10A6,6 0 0,1 22,16A6,6 0 0,1 16,22C14.77,22 13.63,21.63 12.68,21H9V7M16,12A4,4 0 0,0 12,16A4,4 0 0,0 16,20A4,4 0 0,0 20,16A4,4 0 0,0 16,12Z";
var mdiBagCarryOnOff = "M2.1 4.9L6 8.9V19C6 19.5 6.2 20 6.6 20.4C7 20.8 7.5 21 8 21V10.8L9 11.8V21H13.2C13.1 20.6 13 20.2 13 20C13 18.8 13.5 18 14.6 17.4L15.4 18.2C14.5 18.5 14.1 19.2 14.1 20.1C14.1 20.6 14.3 21.1 14.7 21.5C15 21.8 15.5 22 16 22C16.9 22 17.6 21.6 17.9 20.7L19.1 21.9L20.5 20.5L3.5 3.5L2.1 4.9M12 2C12 2.5 12.2 3 12.6 3.4S13.5 4 14 4V7H9.8L16 13.2V2H12Z";
var mdiBagChecked = "M22 19H2V21H22V19M4 15C4 15.5 4.2 16 4.6 16.4C5 16.8 5.5 17 6 17V6C5.5 6 5 6.2 4.6 6.6C4.2 7 4 7.5 4 8V15M13.5 6H10.5C10.5 5.6 10.6 5.2 10.9 4.9C11.2 4.6 11.5 4.5 12 4.5C12.4 4.5 12.8 4.6 13.1 4.9C13.3 5.2 13.5 5.6 13.5 6M7 6V17H17V6H15C15 5.2 14.7 4.5 14.1 3.9S12.8 3 12 3C11.2 3 10.5 3.3 9.9 3.9C9.3 4.5 9 5.2 9 6H7M18 17C18.5 17 19 16.8 19.4 16.4C19.8 16 20 15.5 20 15V8C20 7.5 19.8 7 19.4 6.6C19 6.2 18.5 6 18 6V17Z";
var mdiBagPersonal = "M16,5V4A2,2 0 0,0 14,2H10A2,2 0 0,0 8,4V5A4,4 0 0,0 4,9V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V9A4,4 0 0,0 16,5M10,4H14V5H10V4M12,9L14,11L12,13L10,11L12,9M18,16H9V18H8V16H6V15H18V16Z";
var mdiBagPersonalOff = "M20,19.35L2.38,1.73L1.11,3L4.77,6.66C4.27,7.34 4,8.16 4,9V20A2,2 0 0,0 6,22H18C18.56,22 19.08,21.76 19.46,21.35L20.84,22.73L22.11,21.46L20,19.35M9,16V18H8V16H6V15H13.11L14.11,16H9M20,9A4,4 0 0,0 16,5V4A2,2 0 0,0 14,2H10A2,2 0 0,0 8,4V4.8L20,16.8V9M14,5H10V4H14V5Z";
var mdiBagPersonalOffOutline = "M20,19.35L2.38,1.73L1.11,3L4.77,6.66C4.27,7.34 4,8.16 4,9V20A2,2 0 0,0 6,22H18C18.56,22 19.08,21.76 19.46,21.35L20.84,22.73L22.11,21.46L20,19.35M6,9C6,8.69 6.08,8.38 6.22,8.11L13.11,15H6V9M18,20H6V16H8V18H9V16H14.11L18,19.89V20M16,7A2,2 0 0,1 18,9V14.8L20,16.8V9A4,4 0 0,0 16,5V4A2,2 0 0,0 14,2H10A2,2 0 0,0 8,4V4.8L10.2,7H16M10,4H14V5H10V4Z";
var mdiBagPersonalOutline = "M16,5V4A2,2 0 0,0 14,2H10A2,2 0 0,0 8,4V5A4,4 0 0,0 4,9V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V9A4,4 0 0,0 16,5M10,4H14V5H10V4M12,9L14,11L12,13L10,11L12,9M18,20H6V16H8V18H9V16H18V20M18,15H6V9A2,2 0 0,1 8,7H16A2,2 0 0,1 18,9V15Z";
var mdiBagPersonalPlus = "M22 19H19V22H17V19H14V17H17V14H19V17H22V19M8 2C6.9 2 6 2.9 6 4V5C3.8 5 2 6.8 2 9V20C2 21.1 2.9 22 4 22H13.5C12.5 20.9 12 19.5 12 18C12 17.3 12.1 16.6 12.3 16H7V18H6V16H4V15H12.8C13.8 13.2 15.8 12 18 12V9C18 6.8 16.2 5 14 5V4C14 2.9 13.1 2 12 2H8M8 4H12V5H8V4M10 9L12 11L10 13L8 11L10 9Z";
var mdiBagPersonalPlusOutline = "M22 19H19V22H17V19H14V17H17V14H19V17H22V19M8 2C6.9 2 6 2.9 6 4V5C3.8 5 2 6.8 2 9V20C2 21.1 2.9 22 4 22H13.5C13 21.4 12.6 20.7 12.3 20H4V16H6V18H7V16H12.3C12.4 15.7 12.6 15.3 12.8 15H4V9C4 7.9 4.9 7 6 7H14C15.1 7 16 7.9 16 9V12.3C16.6 12.1 17.3 12 18 12V9C18 6.8 16.2 5 14 5V4C14 2.9 13.1 2 12 2H8M8 4H12V5H8V4M10 9L8 11L10 13L12 11L10 9Z";
var mdiBagPersonalTag = "M14 5V4C14 2.9 13.1 2 12 2H8C6.9 2 6 2.9 6 4V5C3.8 5 2 6.8 2 9V20C2 21.1 2.9 22 4 22H15.2L12.8 19.6C12.2 19.1 11.9 18.3 11.9 17.6V16H7V18H6V16H4V15H12V14.8C12 13.3 13.2 12 14.8 12H18V9C18 6.8 16.2 5 14 5M10 13L8 11L10 9L12 11L10 13M12 5H8V4H12V5M21.8 17.8L18.2 14.2C18 14.1 17.8 14 17.6 14H14.8C14.4 14 14 14.4 14 14.8V17.6C14 17.8 14.1 18 14.2 18.2L17.8 21.8C17.9 21.9 18.1 22 18.4 22C18.6 22 18.8 21.9 19 21.8L21.8 19C21.9 18.9 22 18.7 22 18.4C22 18.2 21.9 18 21.8 17.8M15.4 16C15.1 16 14.8 15.7 14.8 15.4C14.8 15.1 15.1 14.8 15.4 14.8C15.7 14.8 16 15.1 16 15.4C16 15.7 15.7 16 15.4 16Z";
var mdiBagPersonalTagOutline = "M14 5V4C14 2.9 13.1 2 12 2H8C6.9 2 6 2.9 6 4V5C3.8 5 2 6.8 2 9V20C2 21.1 2.9 22 4 22H15.2L13.2 20H4V16H6V18H7V16H12V15H4V9C4 7.9 4.9 7 6 7H14C15.1 7 16 7.9 16 9V12H18V9C18 6.8 16.2 5 14 5M12 5H8V4H12V5M10 9L8 11L10 13L12 11L10 9M21.8 17.8L18.2 14.2C18 14.1 17.8 14 17.6 14H14.8C14.4 14 14 14.4 14 14.8V17.6C14 17.8 14.1 18 14.2 18.2L17.8 21.8C17.9 21.9 18.1 22 18.4 22C18.6 22 18.8 21.9 19 21.8L21.8 19C21.9 18.9 22 18.7 22 18.4C22 18.2 21.9 18 21.8 17.8M15.4 16C15.1 16 14.8 15.7 14.8 15.4C14.8 15.1 15.1 14.8 15.4 14.8C15.7 14.8 16 15.1 16 15.4C16 15.7 15.7 16 15.4 16Z";
var mdiBagSuitcase = "M17.03 6C18.11 6 19 6.88 19 8V19C19 20.13 18.11 21 17.03 21C17.03 21.58 16.56 22 16 22C15.5 22 15 21.58 15 21H9C9 21.58 8.5 22 8 22C7.44 22 6.97 21.58 6.97 21C5.89 21 5 20.13 5 19V8C5 6.88 5.89 6 6.97 6H9V3C9 2.42 9.46 2 10 2H14C14.54 2 15 2.42 15 3V6H17.03M13.5 6V3.5H10.5V6H13.5M8 9V18H9.5V9H8M14.5 9V18H16V9H14.5M11.25 9V18H12.75V9H11.25Z";
var mdiBagSuitcaseOff = "M2 4.77L3.28 3.5L21 21.22L19.73 22.5L18 20.76C17.71 20.93 17.38 21 17.03 21C17.03 21.58 16.56 22 16 22C15.5 22 15 21.58 15 21H9C9 21.58 8.5 22 8 22C7.44 22 6.97 21.58 6.97 21C5.89 21 5 20.13 5 19V7.77L2 4.77M17.03 6C18.11 6 19 6.88 19 8V16.68L16 13.68V9H14.5V12.18L12.75 10.43V9H11.32L8.31 6H9V3C9 2.42 9.46 2 10 2H14C14.54 2 15 2.42 15 3V6H17.03M8 18H9.5V12.27L8 10.77V18M11.25 18H12.75V15.5L11.25 14V18M14.5 18H15.23L14.5 17.27V18M13.5 6V3.5H10.5V6H13.5Z";
var mdiBagSuitcaseOffOutline = "M2 4.77L3.28 3.5L21 21.22L19.73 22.5L18 20.76C17.71 20.93 17.38 21 17.03 21C17.03 21.58 16.56 22 16 22C15.5 22 15 21.58 15 21H9C9 21.58 8.5 22 8 22C7.44 22 6.97 21.58 6.97 21C5.89 21 5 20.13 5 19L5 7.78L2 4.77M9.5 18H8V10.78L6.97 9.74V19H16.23L15.25 18H14.5V17.26L12.75 15.5V18H11.25V14L9.5 12.28V18M12.75 9V10.43L11.32 9H12.75M14.5 9H16V13.67L14.5 12.17V9M17.03 6C18.11 6 19 6.88 19 8V16.68L17.03 14.7V8H10.33L8.31 6H9V3C9 2.42 9.46 2 10 2H14C14.54 2 15 2.42 15 3V6H17.03M10.5 3.5V6H13.5V3.5H10.5Z";
var mdiBagSuitcaseOutline = "M9.5 18V9H8V18M12.75 18V9H11.25V18M16 18V9H14.5V18M17.03 6C18.11 6 19 6.88 19 8V19C19 20.13 18.11 21 17.03 21C17.03 21.58 16.56 22 16 22C15.5 22 15 21.58 15 21H9C9 21.58 8.5 22 8 22C7.44 22 6.97 21.58 6.97 21C5.89 21 5 20.13 5 19V8C5 6.88 5.89 6 6.97 6H9V3C9 2.42 9.46 2 10 2H14C14.54 2 15 2.42 15 3V6M10.5 3.5V6H13.5V3.5M17.03 19V8H6.97V19";
var mdiBaguette = "M5 22C3.68 22 3.15 19.64 3.04 18.7A5.56 5.56 0 0 1 3.36 16A2.5 2.5 0 0 1 5.23 14.38C6.4 14.18 7.23 14.88 8.29 15.12A1.21 1.21 0 0 0 9.85 13.75C9.41 12.03 6.28 12 5 12C5 10.14 7.04 9.9 8.5 10.04A10.8 10.8 0 0 1 11.04 10.6C11.54 10.77 12.12 11.2 12.67 11.16C13.5 11.09 13.67 10.23 13.31 9.6C12.44 8.12 9.97 8 8.5 8C8.5 6 10.23 5.62 11.89 5.92A11.58 11.58 0 0 1 14.38 6.71C14.89 6.93 15.5 7.35 16.06 7.16C17.5 6.72 16 5.18 15.36 4.81A6.6 6.6 0 0 0 13.94 4.23C13.4 4.07 12.74 4.13 13.23 3.5A5.13 5.13 0 0 1 15.96 2.26C17.85 1.82 20.46 1.74 20.92 4.12A5.3 5.3 0 0 1 20.07 7.7A38.96 38.96 0 0 1 13.22 16.33A36.6 36.6 0 0 1 8.62 20.32C7.62 21.04 6.3 22 5 22Z";
var mdiBalcony = "M10 10V12H8V10H10M16 12V10H14V12H16M21 14V22H3V14H4V10C4 5.58 7.58 2 12 2S20 5.58 20 10V14H21M7 16H5V20H7V16M11 16H9V20H11V16M11 4.08C8.16 4.56 6 7.03 6 10V14H11V4.08M13 14H18V10C18 7.03 15.84 4.56 13 4.08V14M15 16H13V20H15V16M19 16H17V20H19V16Z";
var mdiBalloon = "M13.16,12.74L14,14H12.5C12.35,16.71 12,19.41 11.5,22.08L10.5,21.92C11,19.3 11.34,16.66 11.5,14H10L10.84,12.74C8.64,11.79 7,8.36 7,6A5,5 0 0,1 12,1A5,5 0 0,1 17,6C17,8.36 15.36,11.79 13.16,12.74Z";
var mdiBallot = "M13,9.5H18V7.5H13V9.5M13,16.5H18V14.5H13V16.5M19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21M6,11H11V6H6V11M7,7H10V10H7V7M6,18H11V13H6V18M7,14H10V17H7V14Z";
var mdiBallotOutline = "M13,7.5H18V9.5H13V7.5M13,14.5H18V16.5H13V14.5M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M19,19V5H5V19H19M11,6V11H6V6H11M10,10V7H7V10H10M11,13V18H6V13H11M10,17V14H7V17H10Z";
var mdiBallotRecount = "M19,12V13.5A4,4 0 0,1 23,17.5C23,18.32 22.75,19.08 22.33,19.71L21.24,18.62C21.41,18.28 21.5,17.9 21.5,17.5A2.5,2.5 0 0,0 19,15V16.5L16.75,14.25L19,12M19,23V21.5A4,4 0 0,1 15,17.5C15,16.68 15.25,15.92 15.67,15.29L16.76,16.38C16.59,16.72 16.5,17.1 16.5,17.5A2.5,2.5 0 0,0 19,20V18.5L21.25,20.75L19,23M10,17H7V14H10V17M10,7V10H7V7H10M5,21A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V11.17C20.5,11.06 20,11 19.5,11A6.5,6.5 0 0,0 13,17.5C13,18.79 13.38,20 14,21H5M13,9.5H18V7.5H13V9.5M11,13H6V18H11V13M11,6H6V11H11V6Z";
var mdiBallotRecountOutline = "M6,18V13H11V18H6M7,14V17H10V14H7M13,7.5H18V9.5H13V7.5M5,21A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V11.17C20.5,11.06 20,11 19.5,11H19V5H5V19H13.17C13.34,19.72 13.63,20.39 14,21H5M11,6V11H6V6H11M10,10V7H7V10H10M19,12V13.5A4,4 0 0,1 23,17.5C23,18.32 22.75,19.08 22.33,19.71L21.24,18.62C21.41,18.28 21.5,17.9 21.5,17.5A2.5,2.5 0 0,0 19,15V16.5L16.75,14.25L19,12M19,23V21.5A4,4 0 0,1 15,17.5C15,16.68 15.25,15.92 15.67,15.29L16.76,16.38C16.59,16.72 16.5,17.1 16.5,17.5A2.5,2.5 0 0,0 19,20V18.5L21.25,20.75L19,23Z";
var mdiBandage = "M17.73,12L21.71,8.04C22.1,7.65 22.1,7 21.71,6.63L17.37,2.29C17,1.9 16.35,1.9 15.96,2.29L12,6.27L8,2.29C7.8,2.1 7.55,2 7.29,2C7.04,2 6.78,2.1 6.59,2.29L2.25,6.63C1.86,7 1.86,7.65 2.25,8.04L6.23,12L2.25,16C1.86,16.39 1.86,17 2.25,17.41L6.59,21.75C7,22.14 7.61,22.14 8,21.75L12,17.77L15.96,21.75C16.16,21.95 16.41,22.04 16.67,22.04C16.93,22.04 17.18,21.94 17.38,21.75L21.72,17.41C22.11,17 22.11,16.39 21.72,16L17.73,12M12,9A1,1 0 0,1 13,10A1,1 0 0,1 12,11A1,1 0 0,1 11,10A1,1 0 0,1 12,9M7.29,10.96L3.66,7.34L7.29,3.71L10.91,7.33L7.29,10.96M10,13A1,1 0 0,1 9,12A1,1 0 0,1 10,11A1,1 0 0,1 11,12A1,1 0 0,1 10,13M12,15A1,1 0 0,1 11,14A1,1 0 0,1 12,13A1,1 0 0,1 13,14A1,1 0 0,1 12,15M14,11A1,1 0 0,1 15,12A1,1 0 0,1 14,13A1,1 0 0,1 13,12A1,1 0 0,1 14,11M16.66,20.34L13.03,16.72L16.66,13.09L20.28,16.71L16.66,20.34Z";
var mdiBank = "M11.5,1L2,6V8H21V6M16,10V17H19V10M2,22H21V19H2M10,10V17H13V10M4,10V17H7V10H4Z";
var mdiBankCheck = "M17.8 21.2L15 18.2L16.2 17L17.8 18.6L21.4 15L22.6 16.4L17.8 21.2M13 10H10V17H12.1C12.2 16.2 12.6 15.4 13 14.7V10M16 10V12.3C16.6 12.1 17.3 12 18 12C18.3 12 18.7 12 19 12.1V10H16M12.1 19H2V22H13.5C12.8 21.2 12.3 20.1 12.1 19M21 6L11.5 1L2 6V8H21V6M7 17V10H4V17H7Z";
var mdiBankCircle = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M17 17H7V15H17V17M8 14V11H10V14H8M11 14V11H13V14H11M14 14V11H16V14H14M17 10H7V8.5L12 6L17 8.5V10Z";
var mdiBankCircleOutline = "M12 4C16.4 4 20 7.6 20 12S16.4 20 12 20 4 16.4 4 12 7.6 4 12 4M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M17 17H7V15H17V17M8 14V11H10V14H8M11 14V11H13V14H11M14 14V11H16V14H14M17 10H7V8.5L12 6L17 8.5V10Z";
var mdiBankMinus = "M14,17H22V19H14V17M11.5,1L21,6V8H2V6L11.5,1M16,10H19V12.08L18,12C17.3,12 16.63,12.12 16,12.34V10M2,22V19H12.08C12.27,20.14 12.79,21.17 13.53,22H2M10,10H13V14.68C12.54,15.37 12.22,16.15 12.08,17H10V10M4,10H7V17H4V10Z";
var mdiBankOff = "M20.8 22.7L20.1 22H2V19H17.1L13 14.9V17H10V11.9L6.1 8H2V6L3.4 5.3L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M4 10V17H7V10H4M21 8V6L11.5 1L6.7 3.5L11.2 8H21M19 15.8V10H16V12.8L19 15.8Z";
var mdiBankOffOutline = "M20.8 22.7L19.1 21H2V19H17.1L12.5 14.4V17H10.5V12.4L6.1 8H2V6L3.4 5.3L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M4.5 10V17H6.5V10H4.5M11.5 3.3L16.7 6H9.2L11.2 8H21V6L11.5 1L6.7 3.5L8.2 5L11.5 3.3M18.5 15.3V10H16.5V13.3L18.5 15.3Z";
var mdiBankOutline = "M6.5,10H4.5V17H6.5V10M12.5,10H10.5V17H12.5V10M21,19H2V21H21V19M18.5,10H16.5V17H18.5V10M11.5,3.26L16.71,6H6.29L11.5,3.26M11.5,1L2,6V8H21V6L11.5,1Z";
var mdiBankPlus = "M17,14H19V17H22V19H19V22H17V19H14V17H17V14M11.5,1L21,6V8H2V6L11.5,1M16,10H19V12.08L18,12C17.3,12 16.63,12.12 16,12.34V10M2,22V19H12.08C12.27,20.14 12.79,21.17 13.53,22H2M10,10H13V14.68C12.54,15.37 12.22,16.15 12.08,17H10V10M4,10H7V17H4V10Z";
var mdiBankRemove = "M14.46,15.88L15.88,14.46L18,16.59L20.12,14.46L21.54,15.88L19.41,18L21.54,20.12L20.12,21.54L18,19.41L15.88,21.54L14.46,20.12L16.59,18L14.46,15.88M11.5,1L21,6V8H2V6L11.5,1M16,10H19V12.08L18,12C17.3,12 16.63,12.12 16,12.34V10M2,22V19H12.08C12.27,20.14 12.79,21.17 13.53,22H2M10,10H13V14.68C12.54,15.37 12.22,16.15 12.08,17H10V10M4,10H7V17H4V10Z";
var mdiBankTransfer = "M15,14V11H18V9L22,12.5L18,16V14H15M14,7.7V9H2V7.7L8,4L14,7.7M7,10H9V15H7V10M3,10H5V15H3V10M13,10V12.5L11,14.3V10H13M9.1,16L8.5,16.5L10.2,18H2V16H9.1M17,15V18H14V20L10,16.5L14,13V15H17Z";
var mdiBankTransferIn = "M2,15V12H5V10L9,13.5L5,17V15H2M22,8.7V10H10V8.7L16,5L22,8.7M10,17H22V19H10V17M15,11H17V16H15V11M11,11H13V16H11V11M19,11H21V16H19V11Z";
var mdiBankTransferOut = "M15,15V12H18V10L22,13.5L18,17V15H15M14,8.7V10H2V8.7L8,5L14,8.7M2,17H14V19H2V17M7,11H9V16H7V11M3,11H5V16H3V11M11,11H13V16H11V11Z";
var mdiBarcode = "M2,6H4V18H2V6M5,6H6V18H5V6M7,6H10V18H7V6M11,6H12V18H11V6M14,6H16V18H14V6M17,6H20V18H17V6M21,6H22V18H21V6Z";
var mdiBarcodeOff = "M20.84 22.73L16 17.89V18H14V15.89L12 13.89V18H11V12.89L10 11.89V18H7V8.89L6 7.89V18H5V6.89L1.11 3L2.39 1.73L7 6.34L10 9.34L11 10.34L12 11.34L14 13.35V13.34L16 15.34V15.35L17 16.35V16.34L18.66 18H18.65L22.11 21.46L20.84 22.73M16 6H14V10.8L16 12.8V6M12 6H11V7.8L12 8.8V6M20 6H17V13.8L20 16.8V6M22 18V6H21V17.8L21.2 18H22M10 6H9.2L10 6.8V6M2 18H4V6H2V18Z";
var mdiBarcodeScan = "M4,6H6V18H4V6M7,6H8V18H7V6M9,6H12V18H9V6M13,6H14V18H13V6M16,6H18V18H16V6M19,6H20V18H19V6M2,4V8H0V4A2,2 0 0,1 2,2H6V4H2M22,2A2,2 0 0,1 24,4V8H22V4H18V2H22M2,16V20H6V22H2A2,2 0 0,1 0,20V16H2M22,20V16H24V20A2,2 0 0,1 22,22H18V20H22Z";
var mdiBarley = "M7.33,18.33C6.5,17.17 6.5,15.83 6.5,14.5C8.17,15.5 9.83,16.5 10.67,17.67L11,18.23V15.95C9.5,15.05 8.08,14.13 7.33,13.08C6.5,11.92 6.5,10.58 6.5,9.25C8.17,10.25 9.83,11.25 10.67,12.42L11,13V10.7C9.5,9.8 8.08,8.88 7.33,7.83C6.5,6.67 6.5,5.33 6.5,4C8.17,5 9.83,6 10.67,7.17C10.77,7.31 10.86,7.46 10.94,7.62C10.77,7 10.66,6.42 10.65,5.82C10.64,4.31 11.3,2.76 11.96,1.21C12.65,2.69 13.34,4.18 13.35,5.69C13.36,6.32 13.25,6.96 13.07,7.59C13.15,7.45 13.23,7.31 13.33,7.17C14.17,6 15.83,5 17.5,4C17.5,5.33 17.5,6.67 16.67,7.83C15.92,8.88 14.5,9.8 13,10.7V13L13.33,12.42C14.17,11.25 15.83,10.25 17.5,9.25C17.5,10.58 17.5,11.92 16.67,13.08C15.92,14.13 14.5,15.05 13,15.95V18.23L13.33,17.67C14.17,16.5 15.83,15.5 17.5,14.5C17.5,15.83 17.5,17.17 16.67,18.33C15.92,19.38 14.5,20.3 13,21.2V23H11V21.2C9.5,20.3 8.08,19.38 7.33,18.33Z";
var mdiBarleyOff = "M11.96,1.21C11.3,2.76 10.64,4.31 10.65,5.82C10.66,6.42 10.77,7 10.94,7.62C10.86,7.46 10.77,7.31 10.67,7.17C9.83,6 8.17,5 6.5,4C6.5,4.8 6.5,5.59 6.68,6.36L13,12.68V10.7C14.5,9.8 15.92,8.88 16.67,7.83C17.5,6.67 17.5,5.33 17.5,4C15.83,5 14.17,6 13.33,7.17C13.23,7.31 13.15,7.45 13.07,7.59C13.25,6.96 13.36,6.32 13.35,5.69C13.34,4.18 12.65,2.69 11.96,1.21M3.28,5.5L2,6.77L6.64,11.41C6.75,12 6.95,12.55 7.33,13.08C8.08,14.13 9.5,15.05 11,15.95V18.23L10.67,17.67C9.83,16.5 8.17,15.5 6.5,14.5C6.5,15.83 6.5,17.17 7.33,18.33C8.08,19.38 9.5,20.3 11,21.2V23H13V21.2C13.74,20.76 14.45,20.31 15.07,19.84L18.73,23.5L20,22.22C14,16.23 9.1,11.32 3.28,5.5M17.5,9.25C15.83,10.25 14.17,11.25 13.33,12.42L13.12,12.79L15,14.66C15.67,14.16 16.27,13.64 16.67,13.08C17.5,11.92 17.5,10.58 17.5,9.25M17.5,14.5C16.93,14.84 16.38,15.18 15.85,15.53L17.29,16.97C17.5,16.17 17.5,15.33 17.5,14.5Z";
var mdiBarn = "M12,3L3,8.2V21H9L11.9,18L15,21H21V8.2L12,3M7.9,20V14L10.9,17L7.9,20M8.9,13H14.9L11.9,16L8.9,13M15.9,20L12.9,17L15.9,14V20M15,11H8.8V9H15V11Z";
var mdiBarrel = "M20 13C20.55 13 21 12.55 21 12S20.55 11 20 11H19V5H20C20.55 5 21 4.55 21 4S20.55 3 20 3H4C3.45 3 3 3.45 3 4S3.45 5 4 5H5V11H4C3.45 11 3 11.45 3 12S3.45 13 4 13H5V19H4C3.45 19 3 19.45 3 20S3.45 21 4 21H20C20.55 21 21 20.55 21 20S20.55 19 20 19H19V13H20M12 16C10.34 16 9 14.68 9 13.05C9 11.75 9.5 11.38 12 8.5C14.47 11.36 15 11.74 15 13.05C15 14.68 13.66 16 12 16Z";
var mdiBarrelOutline = "M9 13.05C9 14.68 10.34 16 12 16S15 14.68 15 13.05C15 11.74 14.47 11.36 12 8.5C9.5 11.38 9 11.75 9 13.05M20 13C20.55 13 21 12.55 21 12S20.55 11 20 11H19V5H20C20.55 5 21 4.55 21 4S20.55 3 20 3H4C3.45 3 3 3.45 3 4S3.45 5 4 5H5V11H4C3.45 11 3 11.45 3 12S3.45 13 4 13H5V19H4C3.45 19 3 19.45 3 20S3.45 21 4 21H20C20.55 21 21 20.55 21 20S20.55 19 20 19H19V13H20M17 19H7V13C7.55 13 8 12.55 8 12S7.55 11 7 11V5H17V11C16.45 11 16 11.45 16 12S16.45 13 17 13V19Z";
var mdiBaseball = "M12,2C9.5,2 7.25,2.9 5.5,4.4C6,4.81 6.41,5.27 6.8,5.76L7.89,5.13L8.89,6.87L7.89,7.44C8.45,8.53 8.82,9.73 8.95,11H10V12L10,13H8.95C8.82,14.27 8.45,15.47 7.89,16.56L8.89,17.13L7.89,18.87L6.8,18.24C6.41,18.73 6,19.19 5.5,19.6C7.25,21.1 9.5,22 12,22C14.5,22 16.75,21.1 18.5,19.6C18,19.19 17.59,18.73 17.19,18.24L16.11,18.87L15.11,17.13L16.11,16.55C15.55,15.47 15.18,14.27 15.05,13H14V11H15.05C15.18,9.73 15.55,8.53 16.11,7.45L15.11,6.87L16.11,5.13L17.19,5.76C17.59,5.27 18,4.81 18.5,4.4C16.75,2.9 14.5,2 12,2M4.12,5.85C2.79,7.55 2,9.68 2,12C2,14.32 2.79,16.45 4.12,18.15C4.46,17.87 4.76,17.55 5.05,17.22L4.43,16.87L5.43,15.13L6.16,15.56C6.55,14.77 6.82,13.91 6.93,13H6V12L6,11H6.93C6.82,10.09 6.55,9.23 6.16,8.44L5.43,8.87L4.43,7.13L5.05,6.78C4.76,6.45 4.46,6.13 4.12,5.85M19.88,5.85C19.54,6.13 19.24,6.45 18.95,6.78L19.57,7.13L18.57,8.87L17.84,8.44C17.45,9.23 17.18,10.09 17.07,11H18V13H17.07C17.18,13.91 17.45,14.77 17.84,15.56L18.57,15.13L19.57,16.87L18.95,17.22C19.24,17.55 19.54,17.87 19.88,18.15C21.21,16.45 22,14.32 22,12C22,9.68 21.21,7.55 19.88,5.85Z";
var mdiBaseballBat = "M20,2C19.72,2 19.5,2.11 19.29,2.29L9.79,11.79C9.75,11.83 9.72,11.87 7.23,15.35L4,18.59L3.71,18.29C3.5,18.1 3.26,18 3,18C2.44,18 2,18.44 2,19C2,19.26 2.1,19.5 2.29,19.71L4.29,21.71C4.68,22.11 5.31,22.12 5.71,21.74C6.11,21.35 6.12,20.72 5.71,20.29L5.41,20L8.64,16.77L12.21,14.21L21.71,4.71C22.1,4.32 22.1,3.68 21.71,3.29L20.71,2.29C20.5,2.1 20.26,2 20,2M18.5,13A2.5,2.5 0 0,0 16,15.5A2.5,2.5 0 0,0 18.5,18A2.5,2.5 0 0,0 21,15.5A2.5,2.5 0 0,0 18.5,13Z";
var mdiBaseballDiamond = "M5.79 12.79L2 9C2 9 6 3 12 3S22 9 22 9L18.21 12.79L12 6.59L5.79 12.79M13.5 18H10.5V20L12 21L13.5 20V18M16.79 14.21L14.2 16.8C13.6 16.31 12.84 16 12 16S10.4 16.31 9.8 16.8L7.21 14.21L12 9.41L16.79 14.21M13 14C13 13.45 12.55 13 12 13S11 13.45 11 14 11.45 15 12 15 13 14.55 13 14Z";
var mdiBaseballDiamondOutline = "M12 2C5 2 1 9 1 9L9.3 17.3C9.74 16.77 10.32 16.37 11 16.17L7.83 13L12 8.83L16.17 13L13 16.17C13.68 16.37 14.27 16.77 14.7 17.3L23 9C23 9 19 2 12 2M17.59 11.59L12 6L6.41 11.59L3.59 8.76C4.95 7 7.89 4 12 4C16.08 4 19.03 7 20.4 8.77L17.59 11.59M13 13C13 13.55 12.55 14 12 14S11 13.55 11 13 11.45 12 12 12 13 12.45 13 13M13.5 20L12 21L10.5 20V18H13.5V20Z";
var mdiBaseballOutline = "M8.17 2.76C9.39 2.26 10.69 2 12 2C13.31 2 14.61 2.26 15.83 2.76C17.04 3.26 18.14 4 19.07 4.93C20 5.86 20.74 6.96 21.24 8.17C21.74 9.39 22 10.69 22 12C22 14.65 20.95 17.2 19.07 19.07C17.2 20.95 14.65 22 12 22C10.69 22 9.39 21.74 8.17 21.24C6.96 20.74 5.86 20 4.93 19.07C3.05 17.2 2 14.65 2 12C2 9.35 3.05 6.8 4.93 4.93C5.86 4 6.96 3.26 8.17 2.76M7.89 18.86C9.12 19.6 10.54 20 12 20C13.46 20 14.88 19.6 16.11 18.86L15.11 17.13L16.11 16.55C15.55 15.47 15.18 14.27 15.05 13H14V11H15.05C15.18 9.73 15.55 8.53 16.11 7.45L15.11 6.87L16.11 5.14C14.88 4.4 13.46 4 12 4C10.54 4 9.12 4.4 7.89 5.14L8.89 6.87L7.89 7.44C8.45 8.53 8.82 9.73 8.95 11H10V13H8.95C8.82 14.27 8.45 15.47 7.89 16.56L8.89 17.13L7.89 18.86M5 15.88L5.43 15.13L6.16 15.56C6.55 14.77 6.82 13.91 6.93 13H6V11H6.93C6.82 10.09 6.55 9.23 6.16 8.44L5.43 8.87L5 8.12C4.35 9.3 4 10.63 4 12C4 13.37 4.35 14.7 5 15.88M19 8.13L18.57 8.87L17.84 8.44C17.45 9.23 17.18 10.09 17.07 11H18V13H17.07C17.18 13.91 17.45 14.77 17.84 15.56L18.57 15.13L19 15.88C19.65 14.7 20 13.37 20 12C20 10.63 19.65 9.3 19 8.12Z";
var mdiBash = "M5 9H7.31L7.63 6H9.63L9.31 9H11.31L11.63 6H13.63L13.31 9H15V11H13.1L12.9 13H15V15H12.69L12.37 18H10.37L10.69 15H8.69L8.37 18H6.37L6.69 15H5V13H6.9L7.1 11H5V9M9.1 11L8.9 13H10.9L11.1 11M19 6H17V14H19M19 16H17V18H19Z";
var mdiBasket = "M5.5,21C4.72,21 4.04,20.55 3.71,19.9V19.9L1.1,10.44L1,10A1,1 0 0,1 2,9H6.58L11.18,2.43C11.36,2.17 11.66,2 12,2C12.34,2 12.65,2.17 12.83,2.44L17.42,9H22A1,1 0 0,1 23,10L22.96,10.29L20.29,19.9C19.96,20.55 19.28,21 18.5,21H5.5M12,4.74L9,9H15L12,4.74M12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17A2,2 0 0,0 14,15A2,2 0 0,0 12,13Z";
var mdiBasketCheck = "M21.63 16.27L17.76 20.17L16.41 18.8L15 20.22L17.75 23L23.03 17.68L21.63 16.27M13 20C13 16.69 15.69 14 19 14C20 14 20.92 14.24 21.74 14.67L22.96 10.29L23 10C23 9.45 22.55 9 22 9H17.42L12.83 2.44C12.65 2.17 12.34 2 12 2S11.36 2.17 11.18 2.43L6.58 9H2C1.45 9 1 9.45 1 10L1.1 10.44L3.71 19.9C4.04 20.55 4.72 21 5.5 21H13.09C13.04 20.67 13 20.34 13 20M12 4.74L15 9H9L12 4.74M10 15C10 13.9 10.9 13 12 13S14 13.9 14 15 13.11 17 12 17 10 16.11 10 15Z";
var mdiBasketCheckOutline = "M21.63 16.27L17.76 20.17L16.41 18.8L15 20.22L17.75 23L23.03 17.68L21.63 16.27M14 15C14 16.1 13.1 17 12 17S10 16.1 10 15 10.9 13 12 13 14 13.9 14 15M13 20C13 19.66 13.04 19.33 13.09 19H5.5L3.31 11H20.7L19.86 14.07C20.54 14.17 21.18 14.37 21.76 14.68L22.97 10.27L23 10C23 9.45 22.55 9 22 9H17.21L12.83 2.44C12.64 2.16 12.32 2 12 2S11.36 2.16 11.17 2.45L6.79 9H2C1.45 9 1 9.45 1 10C1 10.09 1 10.18 1.04 10.27L3.58 19.54C3.81 20.38 4.58 21 5.5 21H13.09C13.04 20.67 13 20.34 13 20M12 4.8L14.8 9H9.2L12 4.8Z";
var mdiBasketFill = "M3,2H6V5H3V2M6,7H9V10H6V7M8,2H11V5H8V2M17,11L12,6H15V2H19V6H22L17,11M7.5,22C6.72,22 6.04,21.55 5.71,20.9V20.9L3.1,13.44L3,13A1,1 0 0,1 4,12H20A1,1 0 0,1 21,13L20.96,13.29L18.29,20.9C17.96,21.55 17.28,22 16.5,22H7.5M7.61,20H16.39L18.57,14H5.42L7.61,20Z";
var mdiBasketMinus = "M23 18V20H15V18H23M23 10L22.96 10.29L22 13.8C21.11 13.29 20.09 13 19 13C15.69 13 13 15.69 13 19C13 19.7 13.13 20.37 13.35 21H5.5C4.72 21 4.04 20.55 3.71 19.9L1.1 10.44L1 10C1 9.45 1.45 9 2 9H6.58L11.18 2.43C11.36 2.17 11.66 2 12 2S12.65 2.17 12.83 2.44L17.42 9H22C22.55 9 23 9.45 23 10M14 15C14 13.9 13.11 13 12 13S10 13.9 10 15 10.9 17 12 17 14 16.11 14 15M15 9L12 4.74L9 9H15Z";
var mdiBasketMinusOutline = "M23 18V20H15V18H23M12 13C10.9 13 10 13.9 10 15S10.9 17 12 17 14 16.1 14 15 13.1 13 12 13M13.35 21H5.5C4.58 21 3.81 20.38 3.58 19.54L1.04 10.27C1 10.18 1 10.09 1 10C1 9.45 1.45 9 2 9H6.79L11.17 2.45C11.36 2.16 11.68 2 12 2S12.64 2.16 12.83 2.44L17.21 9H22C22.55 9 23 9.45 23 10L22.97 10.27L22 13.81C21.43 13.5 20.79 13.24 20.12 13.11L20.7 11H3.31L5.5 19H13C13 19.7 13.13 20.37 13.35 21M9.2 9H14.8L12 4.8L9.2 9Z";
var mdiBasketOff = "M23 10L22.96 10.29L20.9 17.7L12.2 9H15L12 4.74L10.32 7.12L8.89 5.69L11.18 2.43C11.36 2.17 11.66 2 12 2S12.65 2.17 12.83 2.44L17.42 9H22C22.55 9 23 9.45 23 10M22.11 21.46L20.84 22.73L19.03 20.92C18.86 20.97 18.68 21 18.5 21H5.5C4.72 21 4.04 20.55 3.71 19.9L1.1 10.44L1 10C1 9.45 1.45 9 2 9H6.58L6.8 8.69L1.11 3L2.39 1.73L22.11 21.46M13.85 15.74L11.26 13.15C10.5 13.44 10 14.16 10 15C10 16.11 10.9 17 12 17C12.84 17 13.56 16.5 13.85 15.74Z";
var mdiBasketOffOutline = "M2.39 1.73L1.11 3L6.92 8.81L6.79 9H2C1.45 9 1 9.45 1 10C1 10.09 1 10.18 1.04 10.27L3.58 19.54C3.81 20.38 4.58 21 5.5 21H18.5C18.68 21 18.86 20.96 19.03 20.92L20.84 22.73L22.11 21.46L2.39 1.73M5.5 19L3.31 11H9.11L11.26 13.15C10.5 13.44 10 14.16 10 15C10 16.1 10.9 17 12 17C12.84 17 13.56 16.5 13.85 15.74L17.11 19H5.5M23 10L22.97 10.27L20.93 17.73L19.3 16.1L20.7 11H14.2L12.2 9H14.8L12 4.8L10.4 7.2L8.96 5.76L11.17 2.45C11.36 2.16 11.68 2 12 2S12.64 2.16 12.83 2.44L17.21 9H22C22.55 9 23 9.45 23 10Z";
var mdiBasketOutline = "M22 9H17.21L12.83 2.44C12.64 2.16 12.32 2 12 2S11.36 2.16 11.17 2.45L6.79 9H2C1.45 9 1 9.45 1 10C1 10.09 1 10.18 1.04 10.27L3.58 19.54C3.81 20.38 4.58 21 5.5 21H18.5C19.42 21 20.19 20.38 20.43 19.54L22.97 10.27L23 10C23 9.45 22.55 9 22 9M12 4.8L14.8 9H9.2L12 4.8M18.5 19L5.5 19L3.31 11H20.7L18.5 19M12 13C10.9 13 10 13.9 10 15S10.9 17 12 17 14 16.1 14 15 13.1 13 12 13Z";
var mdiBasketPlus = "M20 15V18H23V20H20V23H18V20H15V18H18V15H20M23 10L22.96 10.29L22 13.8C21.11 13.29 20.09 13 19 13C15.69 13 13 15.69 13 19C13 19.7 13.13 20.37 13.35 21H5.5C4.72 21 4.04 20.55 3.71 19.9L1.1 10.44L1 10C1 9.45 1.45 9 2 9H6.58L11.18 2.43C11.36 2.17 11.66 2 12 2S12.65 2.17 12.83 2.44L17.42 9H22C22.55 9 23 9.45 23 10M14 15C14 13.9 13.11 13 12 13S10 13.9 10 15 10.9 17 12 17 14 16.11 14 15M15 9L12 4.74L9 9H15Z";
var mdiBasketPlusOutline = "M20 15V18H23V20H20V23H18V20H15V18H18V15H20M12 13C10.9 13 10 13.9 10 15S10.9 17 12 17 14 16.1 14 15 13.1 13 12 13M13.35 21H5.5C4.58 21 3.81 20.38 3.58 19.54L1.04 10.27C1 10.18 1 10.09 1 10C1 9.45 1.45 9 2 9H6.79L11.17 2.45C11.36 2.16 11.68 2 12 2S12.64 2.16 12.83 2.44L17.21 9H22C22.55 9 23 9.45 23 10L22.97 10.27L22 13.81C21.43 13.5 20.79 13.24 20.12 13.11L20.7 11H3.31L5.5 19H13C13 19.7 13.13 20.37 13.35 21M9.2 9H14.8L12 4.8L9.2 9Z";
var mdiBasketRemove = "M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.46L22.54 16.88M23 10L22.96 10.29L22 13.8C21.11 13.29 20.09 13 19 13C15.69 13 13 15.69 13 19C13 19.7 13.13 20.37 13.35 21H5.5C4.72 21 4.04 20.55 3.71 19.9L1.1 10.44L1 10C1 9.45 1.45 9 2 9H6.58L11.18 2.43C11.36 2.17 11.66 2 12 2S12.65 2.17 12.83 2.44L17.42 9H22C22.55 9 23 9.45 23 10M14 15C14 13.9 13.11 13 12 13S10 13.9 10 15 10.9 17 12 17 14 16.11 14 15M15 9L12 4.74L9 9H15Z";
var mdiBasketRemoveOutline = "M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.46L22.54 16.88M12 13C10.9 13 10 13.9 10 15S10.9 17 12 17 14 16.1 14 15 13.1 13 12 13M13.35 21H5.5C4.58 21 3.81 20.38 3.58 19.54L1.04 10.27C1 10.18 1 10.09 1 10C1 9.45 1.45 9 2 9H6.79L11.17 2.45C11.36 2.16 11.68 2 12 2S12.64 2.16 12.83 2.44L17.21 9H22C22.55 9 23 9.45 23 10L22.97 10.27L22 13.81C21.43 13.5 20.79 13.24 20.12 13.11L20.7 11H3.31L5.5 19H13C13 19.7 13.13 20.37 13.35 21M9.2 9H14.8L12 4.8L9.2 9Z";
var mdiBasketUnfill = "M3,10H6V7H3V10M5,5H8V2H5V5M8,10H11V7H8V10M17,1L12,6H15V10H19V6H22L17,1M7.5,22C6.72,22 6.04,21.55 5.71,20.9V20.9L3.1,13.44L3,13A1,1 0 0,1 4,12H20A1,1 0 0,1 21,13L20.96,13.29L18.29,20.9C17.96,21.55 17.28,22 16.5,22H7.5M7.61,20H16.39L18.57,14H5.42L7.61,20Z";
var mdiBasketball = "M2.34,14.63C2.94,14.41 3.56,14.3 4.22,14.3C5.56,14.3 6.73,14.72 7.73,15.56L4.59,18.7C3.53,17.5 2.78,16.13 2.34,14.63M15.56,9.8C17.53,11.27 19.66,11.63 21.94,10.88C21.97,11.09 22,11.47 22,12C22,13.03 21.75,14.18 21.28,15.45C20.81,16.71 20.23,17.73 19.55,18.5L13.22,12.19L15.56,9.8M8.77,16.64C9.83,18.17 10.05,19.84 9.42,21.66C8,21.25 6.73,20.61 5.67,19.73L8.77,16.64M12.19,13.22L18.5,19.55C16.33,21.45 13.78,22.25 10.88,21.94C11.09,21.28 11.2,20.56 11.2,19.78C11.2,19.16 11.06,18.43 10.78,17.6C10.5,16.77 10.17,16.09 9.8,15.56L12.19,13.22M8.81,14.5C7.88,13.67 6.8,13.15 5.58,12.91C4.36,12.68 3.19,12.75 2.06,13.13C2.03,12.91 2,12.53 2,12C2,10.97 2.25,9.82 2.72,8.55C3.19,7.29 3.77,6.27 4.45,5.5L11.11,12.19L8.81,14.5M15.56,7.73C14.22,6.08 13.91,4.28 14.63,2.34C15.25,2.5 15.96,2.8 16.76,3.26C17.55,3.71 18.2,4.16 18.7,4.59L15.56,7.73M21.66,9.38C21.06,9.59 20.44,9.7 19.78,9.7C18.69,9.7 17.64,9.38 16.64,8.72L19.73,5.67C20.61,6.77 21.25,8 21.66,9.38M12.19,11.11L5.5,4.45C7.67,2.55 10.22,1.75 13.13,2.06C12.91,2.72 12.8,3.44 12.8,4.22C12.8,4.94 12.96,5.75 13.29,6.66C13.62,7.56 14,8.28 14.5,8.81L12.19,11.11Z";
var mdiBasketballHoop = "M21,2H3A2,2 0 0,0 1,4V16A2,2 0 0,0 3,18H5V14H19V18H21A2,2 0 0,0 23,16V4A2,2 0 0,0 21,2M17,12H15V9H9V12H7V9A2,2 0 0,1 9,7H15A2,2 0 0,1 17,9V12M7,16V19.5L8,23L10,21L12,23L14,21L16,23L17,19.5V16H7Z";
var mdiBasketballHoopOutline = "M21,2H3A2,2 0 0,0 1,4V16A2,2 0 0,0 3,18H6.57L8,23L10,21L12,23L14,21L16,23L17.43,18H21A2,2 0 0,0 23,16V4A2,2 0 0,0 21,2M21,16H18V14H17V9A2,2 0 0,0 15,7H9A2,2 0 0,0 7,9V14H6V16H3V4H21V16M9,14V9H15V14H9Z";
var mdiBat = "M0.75,8C0.75,8 5,7 8,9C8,9 8.5,12.75 10.5,12.75V11C10.5,11 11,12 12,12C13,12 13.5,11 13.5,11V12.75C15.5,12.75 16,9 16,9C19,7 23.25,8 23.25,8C21.25,9 21,12.5 21,12.5C17,12.5 17,15.75 17,15.75C12,14.75 12,18.5 12,18.5C12,18.5 12,14.75 7,15.75C7,15.75 7,12.5 3,12.5C3,12.5 2.75,9 0.75,8Z";
var mdiBathtub = "M7 5C8.11 5 9 5.9 9 7S8.11 9 7 9 5 8.11 5 7 5.9 5 7 5M20 13V4.83C20 3.27 18.73 2 17.17 2C16.42 2 15.7 2.3 15.17 2.83L13.92 4.08C13.76 4.03 13.59 4 13.41 4C13 4 12.64 4.12 12.33 4.32L15.09 7.08C15.29 6.77 15.41 6.4 15.41 6C15.41 5.82 15.38 5.66 15.34 5.5L16.59 4.24C16.74 4.09 16.95 4 17.17 4C17.63 4 18 4.37 18 4.83V13H11.15C10.85 12.79 10.58 12.55 10.33 12.28L8.93 10.73C8.74 10.5 8.5 10.35 8.24 10.23C7.93 10.08 7.59 10 7.24 10C6 10 5 11 5 12.25V13H2V19C2 20.1 2.9 21 4 21C4 21.55 4.45 22 5 22H19C19.55 22 20 21.55 20 21C21.1 21 22 20.1 22 19V13H20Z";
var mdiBathtubOutline = "M7 5C8.11 5 9 5.9 9 7S8.11 9 7 9 5 8.11 5 7 5.9 5 7 5M20 13V4.83C20 3.27 18.73 2 17.17 2C16.42 2 15.7 2.3 15.17 2.83L13.92 4.08C13.76 4.03 13.59 4 13.41 4C13 4 12.64 4.12 12.33 4.32L15.09 7.08C15.29 6.77 15.41 6.4 15.41 6C15.41 5.82 15.38 5.66 15.34 5.5L16.59 4.24C16.74 4.09 16.95 4 17.17 4C17.63 4 18 4.37 18 4.83V13H11.15C10.85 12.79 10.58 12.55 10.33 12.28L8.93 10.73C8.74 10.5 8.5 10.35 8.24 10.23C7.93 10.08 7.59 10 7.24 10C6 10 5 11 5 12.25V13H2V19C2 20.1 2.9 21 4 21C4 21.55 4.45 22 5 22H19C19.55 22 20 21.55 20 21C21.1 21 22 20.1 22 19V13H20M20 19H4V15H20V19Z";
var mdiBattery = "M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z";
var mdiBattery10 = "M16,18H8V6H16M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z";
var mdiBattery10Bluetooth = "M5,2V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4H11V2H5M4,6H12V18H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z";
var mdiBattery20 = "M16,17H8V6H16M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z";
var mdiBattery20Bluetooth = "M5,2V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4H11V2H5M4,6H12V17H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z";
var mdiBattery30 = "M16,15H8V6H16M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z";
var mdiBattery30Bluetooth = "M5,2V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4H11V2H5M4,6H12V15H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z";
var mdiBattery40 = "M16,14H8V6H16M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z";
var mdiBattery40Bluetooth = "M5,2V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4H11V2H5M4,6H12V14H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z";
var mdiBattery50 = "M16,13H8V6H16M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z";
var mdiBattery50Bluetooth = "M5,2V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4H11V2H5M4,6H12V13H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z";
var mdiBattery60 = "M16,12H8V6H16M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z";
var mdiBattery60Bluetooth = "M5,2V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4H11V2H5M4,6H12V12H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z";
var mdiBattery70 = "M16,10H8V6H16M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z";
var mdiBattery70Bluetooth = "M5,2V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4H11V2H5M4,6H12V10H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z";
var mdiBattery80 = "M16,9H8V6H16M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z";
var mdiBattery80Bluetooth = "M5,2V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4H11V2H5M4,6H12V9H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z";
var mdiBattery90 = "M16,8H8V6H16M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z";
var mdiBattery90Bluetooth = "M5,2V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4H11V2H5M4,6H12V8H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z";
var mdiBatteryAlert = "M13 14H11V8H13M13 18H11V16H13M16.7 4H15V2H9V4H7.3C6.6 4 6 4.6 6 5.3V20.6C6 21.4 6.6 22 7.3 22H16.6C17.3 22 17.9 21.4 17.9 20.7V5.3C18 4.6 17.4 4 16.7 4Z";
var mdiBatteryAlertBluetooth = "M5 2V4H3.3C2.6 4 2 4.6 2 5.3V20.6C2 21.4 2.6 22 3.3 22H12.6C13.3 22 13.9 21.4 13.9 20.7V5.3C14 4.6 13.4 4 12.7 4H11V2H5M19 8V11.8L16.7 9.5L16 10.2L18.8 13L16 15.8L16.7 16.5L19 14.2V18H19.5L22.4 15.1L20.2 13L22.3 10.9L19.5 8H19M7 8H9V14H7M20 9.9L20.9 10.8L20 11.8V9.9M20 14.2L20.9 15.1L20 16.1V14.2M7 16H9V18H7V16Z";
var mdiBatteryAlertVariant = "M14.67 4H13V2H7V4H5.33C4.6 4 4 4.6 4 5.33V20.67C4 21.4 4.6 22 5.33 22H14.67C15.4 22 16 21.4 16 20.67V5.33C16 4.6 15.4 4 14.67 4M21 13H19V7H21V13M21 17H19V15H21V17Z";
var mdiBatteryAlertVariantOutline = "M14 20H6V6H14M14.67 4H13V2H7V4H5.33C4.6 4 4 4.6 4 5.33V20.67C4 21.4 4.6 22 5.33 22H14.67C15.4 22 16 21.4 16 20.67V5.33C16 4.6 15.4 4 14.67 4M21 7H19V13H21V8M21 15H19V17H21V15Z";
var mdiBatteryArrowDown = "M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C14.69 12 12 14.69 12 18C12 19.54 12.58 20.94 13.54 22M14.94 18.5L17.94 21.5L20.94 18.5H18.94V14.5H16.94V18.5H14.94";
var mdiBatteryArrowDownOutline = "M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C17.3 12 16.63 12.13 16 12.35V6H8V20H12.35C12.61 20.75 13 21.42 13.54 22M14.94 18.5L17.94 21.5L20.94 18.5H18.94V14.5H16.94V18.5H14.94";
var mdiBatteryArrowUp = "M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C14.69 12 12 14.69 12 18C12 19.54 12.58 20.94 13.54 22M20.94 17.5L17.94 14.5L14.94 17.5H16.94V21.5H18.94V17.5H20.94";
var mdiBatteryArrowUpOutline = "M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C17.3 12 16.63 12.13 16 12.35V6H8V20H12.35C12.61 20.75 13 21.42 13.54 22M20.94 17.5L17.94 14.5L14.94 17.5H16.94V21.5H18.94V17.5H20.94";
var mdiBatteryBluetooth = "M5,2V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4H11V2H5M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z";
var mdiBatteryBluetoothVariant = "M9,2V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4H15V2H9M11.83,8H12.33L15.18,10.85L13.04,13L15.17,15.14L12.33,18H11.83V14.21L9.54,16.5L8.83,15.79L11.62,13L8.83,10.21L9.54,9.5L11.83,11.79V8M12.83,9.91V11.79L13.77,10.85L12.83,9.91M12.83,14.21V16.08L13.77,15.14L12.83,14.21Z";
var mdiBatteryCharging = "M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.66C6,21.4 6.6,22 7.33,22H16.66C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4M11,20V14.5H9L13,7V12.5H15";
var mdiBatteryCharging10 = "M23.05,11H20.05V4L15.05,14H18.05V22M12,18H4L4.05,6H12.05M12.72,4H11.05V2H5.05V4H3.38A1.33,1.33 0 0,0 2.05,5.33V20.67C2.05,21.4 2.65,22 3.38,22H12.72C13.45,22 14.05,21.4 14.05,20.67V5.33A1.33,1.33 0 0,0 12.72,4Z";
var mdiBatteryCharging100 = "M23,11H20V4L15,14H18V22M12.67,4H11V2H5V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4Z";
var mdiBatteryCharging20 = "M23.05,11H20.05V4L15.05,14H18.05V22M12.05,17H4.05V6H12.05M12.72,4H11.05V2H5.05V4H3.38A1.33,1.33 0 0,0 2.05,5.33V20.67C2.05,21.4 2.65,22 3.38,22H12.72C13.45,22 14.05,21.4 14.05,20.67V5.33A1.33,1.33 0 0,0 12.72,4Z";
var mdiBatteryCharging30 = "M12,15H4V6H12M12.67,4H11V2H5V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4M23,11H20V4L15,14H18V22L23,11Z";
var mdiBatteryCharging40 = "M13 4H11V2H5V4H3C2.4 4 2 4.4 2 5V21C2 21.6 2.4 22 3 22H13C13.6 22 14 21.6 14 21V5C14 4.4 13.6 4 13 4M12 14.5H4V6H12V14.5M23 11H20V4L15 14H18V22";
var mdiBatteryCharging50 = "M23,11H20V4L15,14H18V22M12,13H4V6H12M12.67,4H11V2H5V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4Z";
var mdiBatteryCharging60 = "M12,11H4V6H12M12.67,4H11V2H5V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4M23,11H20V4L15,14H18V22L23,11Z";
var mdiBatteryCharging70 = "M12,10H4V6H12M12.67,4H11V2H5V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4M23,11H20V4L15,14H18V22L23,11Z";
var mdiBatteryCharging80 = "M23,11H20V4L15,14H18V22M12,9H4V6H12M12.67,4H11V2H5V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4Z";
var mdiBatteryCharging90 = "M23,11H20V4L15,14H18V22M12,8H4V6H12M12.67,4H11V2H5V4H3.33A1.33,1.33 0 0,0 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33A1.33,1.33 0 0,0 12.67,4Z";
var mdiBatteryChargingHigh = "M12 20H4V6H12M12.67 4H11V2H5V4H3.33C2.6 4 2 4.6 2 5.33V20.67C2 21.4 2.6 22 3.33 22H12.67C13.41 22 14 21.41 14 20.67V5.33C14 4.6 13.4 4 12.67 4M11 16H5V19H11V16M11 7H5V10H11V7M11 11.5H5V14.5H11V11.5M23 10H20V3L15 13H18V21";
var mdiBatteryChargingLow = "M12 20H4V6H12M12.67 4H11V2H5V4H3.33C2.6 4 2 4.6 2 5.33V20.67C2 21.4 2.6 22 3.33 22H12.67C13.41 22 14 21.41 14 20.67V5.33C14 4.6 13.4 4 12.67 4M11 16H5V19H11V16M23 10H20V3L15 13H18V21";
var mdiBatteryChargingMedium = "M12 20H4V6H12M12.67 4H11V2H5V4H3.33C2.6 4 2 4.6 2 5.33V20.67C2 21.4 2.6 22 3.33 22H12.67C13.41 22 14 21.41 14 20.67V5.33C14 4.6 13.4 4 12.67 4M11 16H5V19H11V16M11 11.5H5V14.5H11V11.5M23 10H20V3L15 13H18V21";
var mdiBatteryChargingOutline = "M23.05,11H20.05V4L15.05,14H18.05V22M12,20H4L4.05,6H12.05M12.72,4H11.05V2H5.05V4H3.38A1.33,1.33 0 0,0 2.05,5.33V20.67C2.05,21.4 2.65,22 3.38,22H12.72C13.45,22 14.05,21.4 14.05,20.67V5.33A1.33,1.33 0 0,0 12.72,4Z";
var mdiBatteryChargingWireless = "M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76Z";
var mdiBatteryChargingWireless10 = "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M12,18.5H4V6H12V18.5Z";
var mdiBatteryChargingWireless20 = "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M12,17H4V6H12V17Z";
var mdiBatteryChargingWireless30 = "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M12,16H4V6H12V16Z";
var mdiBatteryChargingWireless40 = "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M12,14.5H4V6H12V14.5Z";
var mdiBatteryChargingWireless50 = "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M12,13H4V6H12V13Z";
var mdiBatteryChargingWireless60 = "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M12,11.6H4V6H12V11.6Z";
var mdiBatteryChargingWireless70 = "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M12,10H4V6H12V10Z";
var mdiBatteryChargingWireless80 = "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M12,9H4V6H12V9Z";
var mdiBatteryChargingWireless90 = "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M12,7.5H4V6H12V7.5Z";
var mdiBatteryChargingWirelessAlert = "M13 4H11V2H5V4H3C2.4 4 2 4.4 2 5V21C2 21.6 2.4 22 3 22H13C13.6 22 14 21.6 14 21V5C14 4.4 13.6 4 13 4M9 18H7V16H9V18M9 14H7V8H9V14M20.1 4.9L18.7 6.3C21.8 9.4 21.8 14.5 18.7 17.6L20.1 19C24 15.2 24 8.8 20.1 4.9M17.2 7.8L15.8 9.2C17.4 10.8 17.4 13.3 15.8 14.9L17.2 16.3C19.6 13.9 19.6 10.1 17.2 7.8Z";
var mdiBatteryChargingWirelessOutline = "M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3A1,1 0 0,0 2,5V21A1,1 0 0,0 3,22H13A1,1 0 0,0 14,21V5A1,1 0 0,0 13,4M12,20H4V6H12V20Z";
var mdiBatteryCheck = "M16.75 21.16L14 18.16L15.16 17L16.75 18.59L20.34 15L21.5 16.41L16.75 21.16M12 18C12 14.69 14.69 12 18 12V5.33C18 4.6 17.4 4 16.67 4H15V2H9V4H7.33C6.6 4 6 4.6 6 5.33V20.67C6 21.4 6.6 22 7.33 22H13.54C12.58 20.94 12 19.54 12 18Z";
var mdiBatteryCheckOutline = "M16.75 21.16L14 18.16L15.16 17L16.75 18.59L20.34 15L21.5 16.41L16.75 21.16M12.35 20H8V6H16V12.35C16.63 12.13 17.3 12 18 12V5.33C18 4.6 17.4 4 16.67 4H15V2H9V4H7.33C6.6 4 6 4.6 6 5.33V20.67C6 21.4 6.6 22 7.33 22H13.54C13 21.42 12.61 20.75 12.35 20Z";
var mdiBatteryClock = "M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25M23 16C23 19.87 19.87 23 16 23C14.69 23 13.46 22.63 12.41 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V9.29C20.89 10.15 23 12.83 23 16M21 16C21 13.24 18.76 11 16 11S11 13.24 11 16 13.24 21 16 21 21 18.76 21 16Z";
var mdiBatteryClockOutline = "M18 9.29V5.33C18 4.6 17.4 4 16.67 4H15V2H9V4H7.33C6.6 4 6 4.6 6 5.33V20.67C6 21.4 6.6 22 7.33 22H12.41C13.46 22.63 14.69 23 16 23C19.87 23 23 19.87 23 16C23 12.83 20.89 10.15 18 9.29M8 6H16V9C12.13 9 9 12.13 9 16C9 17.5 9.47 18.87 10.26 20H8V6M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25Z";
var mdiBatteryHeart = "M12.67 4H11V2H5V4H3.33A1.34 1.34 0 0 0 2 5.33V20.67A1.34 1.34 0 0 0 3.33 22H12.67A1.34 1.34 0 0 0 14 20.67V5.33A1.34 1.34 0 0 0 12.67 4M19 16.17L18.42 15.64C16.36 13.77 15 12.54 15 11A2.18 2.18 0 0 1 17.2 8.8A2.4 2.4 0 0 1 19 9.63A2.4 2.4 0 0 1 20.8 8.8A2.18 2.18 0 0 1 23 11C23 12.5 21.64 13.74 19.58 15.61Z";
var mdiBatteryHeartOutline = "M19 16.2L18.4 15.7C16.4 13.8 15 12.5 15 11C15 9.8 16 8.8 17.2 8.8C17.9 8.8 18.5 9.1 19 9.6C19.5 9.1 20.1 8.8 20.8 8.8C22 8.8 23 9.8 23 11C23 12.5 21.6 13.7 19.6 15.6L19 16.2M12.7 4H11V2H5V4H3.3C2.6 4 2 4.6 2 5.3V20.6C2 21.4 2.6 22 3.3 22H12.6C13.3 22 13.9 21.4 13.9 20.7V5.3C14 4.6 13.4 4 12.7 4M12 20H4V6H12V20Z";
var mdiBatteryHeartVariant = "M16.67 4H15V2H9V4H7.33A1.34 1.34 0 0 0 6 5.33V20.67A1.34 1.34 0 0 0 7.33 22H16.67A1.34 1.34 0 0 0 18 20.67V5.33A1.34 1.34 0 0 0 16.67 4M12.58 15.64L12 16.17L11.42 15.64C9.36 13.77 8 12.54 8 11A2.18 2.18 0 0 1 10.2 8.8A2.4 2.4 0 0 1 12 9.63A2.4 2.4 0 0 1 13.8 8.8A2.18 2.18 0 0 1 16 11C16 12.54 14.64 13.77 12.58 15.64Z";
var mdiBatteryHigh = "M16 20H8V6H16M16.67 4H15V2H9V4H7.33C6.6 4 6 4.6 6 5.33V20.67C6 21.4 6.6 22 7.33 22H16.67C17.41 22 18 21.41 18 20.67V5.33C18 4.6 17.4 4 16.67 4M15 16H9V19H15V16M15 7H9V10H15V7M15 11.5H9V14.5H15V11.5Z";
var mdiBatteryLock = "M19.8 16V14.5C19.8 13.1 18.4 12 17 12S14.2 13.1 14.2 14.5V16C13.6 16 13 16.6 13 17.2V20.7C13 21.4 13.6 22 14.2 22H19.7C20.4 22 21 21.4 21 20.8V17.3C21 16.6 20.4 16 19.8 16M18.5 16H15.5V14.5C15.5 13.7 16.2 13.2 17 13.2S18.5 13.7 18.5 14.5V16M11.27 22H5.33C4.6 22 4 21.4 4 20.67V5.33C4 4.6 4.6 4 5.33 4H7V2H13V4H14.67C15.4 4 16 4.6 16 5.33V10.11C13.86 10.55 12.2 12.38 12.2 14.5V14.74C11.5 15.34 11 16.24 11 17.2V20.7C11 21.16 11.1 21.6 11.27 22Z";
var mdiBatteryLockOpen = "M19.8 16H15.5V13.5C15.5 12.7 16.2 12.2 17 12.2S18.5 12.7 18.5 13.5V14H19.8V13.5C19.8 12.1 18.4 11 17 11S14.2 12.1 14.2 13.5V16C13.6 16 13 16.6 13 17.2V20.7C13 21.4 13.6 22 14.2 22H19.7C20.4 22 21 21.4 21 20.8V17.3C21 16.6 20.4 16 19.8 16M11.27 22H5.33C4.6 22 4 21.4 4 20.67V5.33C4 4.6 4.6 4 5.33 4H7V2H13V4H14.67C15.4 4 16 4.6 16 5.33V9.11C13.86 9.55 12.2 11.38 12.2 13.5V14.74C11.5 15.34 11 16.24 11 17.2V20.7C11 20.93 11.03 21.15 11.07 21.37L11.08 21.39C11.12 21.6 11.19 21.8 11.27 22Z";
var mdiBatteryLow = "M16 20H8V6H16M16.67 4H15V2H9V4H7.33C6.6 4 6 4.6 6 5.33V20.67C6 21.4 6.6 22 7.33 22H16.67C17.41 22 18 21.41 18 20.67V5.33C18 4.6 17.4 4 16.67 4M15 16H9V19H15V16";
var mdiBatteryMedium = "M16 20H8V6H16M16.67 4H15V2H9V4H7.33C6.6 4 6 4.6 6 5.33V20.67C6 21.4 6.6 22 7.33 22H16.67C17.41 22 18 21.41 18 20.67V5.33C18 4.6 17.4 4 16.67 4M15 16H9V19H15V16M15 11.5H9V14.5H15V11.5Z";
var mdiBatteryMinus = "M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C14.69 12 12 14.69 12 18C12 19.54 12.58 20.94 13.54 22M22 17V19H14V17H22Z";
var mdiBatteryMinusOutline = "M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C17.3 12 16.63 12.13 16 12.35V6H8V20H12.35C12.61 20.75 13 21.42 13.54 22M22 17V19H14V17H22Z";
var mdiBatteryMinusVariant = "M16.67,4C17.4,4 18,4.6 18,5.33V20.67A1.33,1.33 0 0,1 16.67,22H7.33C6.6,22 6,21.4 6,20.67V5.33A1.33,1.33 0 0,1 7.33,4H9V2H15V4H16.67M8,12V14H16V12";
var mdiBatteryNegative = "M11.67,4A1.33,1.33 0 0,1 13,5.33V20.67C13,21.4 12.4,22 11.67,22H2.33C1.6,22 1,21.4 1,20.67V5.33A1.33,1.33 0 0,1 2.33,4H4V2H10V4H11.67M15,12H23V14H15V12M3,13H11V6H3V13Z";
var mdiBatteryOff = "M18 14.8L7.21 4H9V2H15V4H16.67A1.34 1.34 0 0 1 18 5.33M18 17.35L3.38 2.73L2.11 4L6 7.89V20.67A1.34 1.34 0 0 0 7.33 22H16.67A1.34 1.34 0 0 0 18 20.67V19.89L20.84 22.73L22.11 21.46Z";
var mdiBatteryOffOutline = "M18 17.35L3.38 2.73L2.11 4L6 7.89V20.67A1.34 1.34 0 0 0 7.33 22H16.67A1.34 1.34 0 0 0 18 20.67V19.89L20.84 22.73L22.11 21.46M16 20H8V9.89L16 17.89M16 6V12.8L18 14.8V5.33A1.34 1.34 0 0 0 16.67 4H15V2H9V4H7.21L9.21 6Z";
var mdiBatteryOutline = "M16,20H8V6H16M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67A1.33,1.33 0 0,0 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z";
var mdiBatteryPlus = "M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C14.69 12 12 14.69 12 18C12 19.54 12.58 20.94 13.54 22M22 17V19H19V22H17V19H14V17H17V14H19V17H22Z";
var mdiBatteryPlusOutline = "M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C17.3 12 16.63 12.13 16 12.35V6H8V20H12.35C12.61 20.75 13 21.42 13.54 22M22 17V19H19V22H17V19H14V17H17V14H19V17H22Z";
var mdiBatteryPlusVariant = "M16.67,4C17.4,4 18,4.6 18,5.33V20.67A1.33,1.33 0 0,1 16.67,22H7.33C6.6,22 6,21.4 6,20.67V5.33A1.33,1.33 0 0,1 7.33,4H9V2H15V4H16.67M16,14V12H13V9H11V12H8V14H11V17H13V14H16Z";
var mdiBatteryPositive = "M11.67,4A1.33,1.33 0 0,1 13,5.33V20.67C13,21.4 12.4,22 11.67,22H2.33C1.6,22 1,21.4 1,20.67V5.33A1.33,1.33 0 0,1 2.33,4H4V2H10V4H11.67M23,14H20V17H18V14H15V12H18V9H20V12H23V14M3,13H11V6H3V13Z";
var mdiBatteryRemove = "M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C14.69 12 12 14.69 12 18C12 19.54 12.58 20.94 13.54 22M21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.47 20.12L16.59 18L14.47 15.88L15.88 14.47L18 16.59L20.12 14.47L21.54 15.88L19.41 18L21.54 20.12Z";
var mdiBatteryRemoveOutline = "M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C17.3 12 16.63 12.13 16 12.35V6H8V20H12.35C12.61 20.75 13 21.42 13.54 22M21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.47 20.12L16.59 18L14.47 15.88L15.88 14.47L18 16.59L20.12 14.47L21.54 15.88L19.41 18L21.54 20.12Z";
var mdiBatterySync = "M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C14.69 12 12 14.69 12 18C12 19.54 12.58 20.94 13.54 22M18 13L20.25 15.25L18 17.5V16C16.15 16 14.94 17.96 15.76 19.62L14.67 20.71C12.91 18.05 14.81 14.5 18 14.5V13M18 24L15.75 21.75L18 19.5V21C19.85 21 21.06 19.04 20.24 17.38L21.33 16.29C23.09 18.95 21.19 22.5 18 22.5V24";
var mdiBatterySyncOutline = "M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C17.3 12 16.63 12.13 16 12.35V6H8V20H12.35C12.61 20.75 13 21.42 13.54 22M18 13L20.25 15.25L18 17.5V16C16.15 16 14.94 17.96 15.76 19.62L14.67 20.71C12.91 18.05 14.81 14.5 18 14.5V13M18 24L15.75 21.75L18 19.5V21C19.85 21 21.06 19.04 20.24 17.38L21.33 16.29C23.09 18.95 21.19 22.5 18 22.5V24";
var mdiBatteryUnknown = "M15.07,12.25L14.17,13.17C13.63,13.71 13.25,14.18 13.09,15H11.05C11.16,14.1 11.56,13.28 12.17,12.67L13.41,11.41C13.78,11.05 14,10.55 14,10C14,8.89 13.1,8 12,8A2,2 0 0,0 10,10H8A4,4 0 0,1 12,6A4,4 0 0,1 16,10C16,10.88 15.64,11.68 15.07,12.25M13,19H11V17H13M16.67,4H15V2H9V4H7.33A1.33,1.33 0 0,0 6,5.33V20.66C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.66V5.33C18,4.59 17.4,4 16.67,4Z";
var mdiBatteryUnknownBluetooth = "M5,2V4H3.33A1.33,1.33 0 0,0 2,5.33V20.66C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.66V5.33C14,4.59 13.4,4 12.67,4H11V2H5M8,6A4,4 0 0,1 12,10C12,10.88 11.64,11.68 11.07,12.25L10.17,13.17C9.63,13.71 9.25,14.18 9.09,15H7.05C7.16,14.1 7.56,13.28 8.17,12.67L9.41,11.41C9.78,11.05 10,10.55 10,10C10,8.89 9.1,8 8,8A2,2 0 0,0 6,10H4A4,4 0 0,1 8,6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21M7,17H9V19H7V17Z";
var mdiBeach = "M15,18.54C17.13,18.21 19.5,18 22,18V22H5C5,21.35 8.2,19.86 13,18.9V12.4C12.16,12.65 11.45,13.21 11,13.95C10.39,12.93 9.27,12.25 8,12.25C6.73,12.25 5.61,12.93 5,13.95C5.03,10.37 8.5,7.43 13,7.04V7A1,1 0 0,1 14,6A1,1 0 0,1 15,7V7.04C19.5,7.43 22.96,10.37 23,13.95C22.39,12.93 21.27,12.25 20,12.25C18.73,12.25 17.61,12.93 17,13.95C16.55,13.21 15.84,12.65 15,12.39V18.54M7,2A5,5 0 0,1 2,7V2H7Z";
var mdiBeaker = "M3,3V5A2,2 0 0,1 5,7V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V7A2,2 0 0,1 21,5V3H3M7,9H10V10H7V9M7,11H10V12H7V11M10,16H7V15H10V16M12,14H7V13H12V14M12,8H7V7H12V8Z";
var mdiBeakerAlert = "M3 3H21V5C19.9 5 19 5.9 19 7V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V7C5 5.9 4.1 5 3 5V3M7 9V10H10V9H7M7 11V12H10V11H7M10 16V15H7V16H10M12 14V13H7V14H12M12 8V7H7V8H12M21 13V7H23V13H21M21 17V15H23V17H21Z";
var mdiBeakerAlertOutline = "M3 3H21V5C19.9 5 19 5.9 19 7V19C19 20.11 18.11 21 17 21H7C5.9 21 5 20.11 5 19V7C5 5.9 4.11 5 3 5V3M7 5V7H12V8H7V9H10V10H7V11H10V12H7V13H12V14H7V15H10V16H7V19H17V5H7M21 13V7H23V13H21M21 17V15H23V17H21Z";
var mdiBeakerCheck = "M17.75 21.16L15 18.16L16.16 17L17.75 18.59L21.34 15L22.5 16.41L17.75 21.16M3 3H21V5C19.9 5 19 5.9 19 7V12C15.69 12 13 14.69 13 18C13 19.09 13.29 20.12 13.8 21H7C5.9 21 5 20.1 5 19V7C5 5.9 4.1 5 3 5V3M7 9V10H10V9H7M7 11V12H10V11H7M10 16V15H7V16H10M12 14V13H7V14H12M12 8V7H7V8H12Z";
var mdiBeakerCheckOutline = "M17.75 21.16L15 18.16L16.16 17L17.75 18.59L21.34 15L22.5 16.41L17.75 21.16M3 3H21V5C19.9 5 19 5.9 19 7V12C18.3 12 17.63 12.12 17 12.34V5H7V7H12V8H7V9H10V10H7V11H10V12H7V13H12V14H7V15H10V16H7V19H13.08C13.2 19.72 13.45 20.39 13.8 21H7C5.9 21 5 20.11 5 19V7C5 5.9 4.11 5 3 5V3Z";
var mdiBeakerMinus = "M23 17V19H15V17H23M3 3H21V5C19.9 5 19 5.9 19 7V12C15.69 12 13 14.69 13 18C13 19.09 13.29 20.12 13.8 21H7C5.9 21 5 20.1 5 19V7C5 5.9 4.1 5 3 5V3M7 9V10H10V9H7M7 11V12H10V11H7M10 16V15H7V16H10M12 14V13H7V14H12M12 8V7H7V8H12Z";
var mdiBeakerMinusOutline = "M23 17V19H15V17M3 3H21V5C19.9 5 19 5.9 19 7V12C18.3 12 17.63 12.12 17 12.34V5H7V7H12V8H7V9H10V10H7V11H10V12H7V13H12V14H7V15H10V16H7V19H13.08C13.2 19.72 13.45 20.39 13.8 21H7C5.9 21 5 20.11 5 19V7C5 5.9 4.11 5 3 5V3Z";
var mdiBeakerOutline = "M3,3H21V5A2,2 0 0,0 19,7V19A2,2 0 0,1 17,21H7A2,2 0 0,1 5,19V7A2,2 0 0,0 3,5V3M7,5V7H12V8H7V9H10V10H7V11H10V12H7V13H12V14H7V15H10V16H7V19H17V5H7Z";
var mdiBeakerPlus = "M18 14H20V17H23V19H20V22H18V19H15V17H18V14M3 3H21V5C19.9 5 19 5.9 19 7V12C15.69 12 13 14.69 13 18C13 19.09 13.29 20.12 13.8 21H7C5.9 21 5 20.1 5 19V7C5 5.9 4.1 5 3 5V3M7 9V10H10V9H7M7 11V12H10V11H7M10 16V15H7V16H10M12 14V13H7V14H12M12 8V7H7V8H12Z";
var mdiBeakerPlusOutline = "M18 14H20V17H23V19H20V22H18V19H15V17H18V14M3 3H21V5C19.9 5 19 5.9 19 7V12C18.3 12 17.63 12.12 17 12.34V5H7V7H12V8H7V9H10V10H7V11H10V12H7V13H12V14H7V15H10V16H7V19H13.08C13.2 19.72 13.45 20.39 13.8 21H7C5.9 21 5 20.11 5 19V7C5 5.9 4.11 5 3 5V3Z";
var mdiBeakerQuestion = "M0 3H18V5C16.9 5 16 5.9 16 7V19C16 20.1 15.1 21 14 21H4C2.9 21 2 20.1 2 19V7C2 5.9 1.1 5 0 5V3M4 9V10H7V9H4M4 11V12H7V11H4M7 16V15H4V16H7M9 14V13H4V14H9M9 8V7H4V8H9M21.5 15.5V17H20V15.5H21.5M19.5 10.5H18V10C18 8.34 19.34 7 21 7C22.66 7 24 8.34 24 10C24 10.97 23.5 11.88 22.71 12.41L22.41 12.6C21.84 13 21.5 13.62 21.5 14.3V14.5H20V14.3C20 13.11 20.6 12 21.59 11.35L21.88 11.16C22.27 10.9 22.5 10.47 22.5 10C22.5 9.18 21.83 8.5 21 8.5C20.17 8.5 19.5 9.17 19.5 10V10.5Z";
var mdiBeakerQuestionOutline = "M0 3H18V5C16.9 5 16 5.9 16 7V19C16 20.11 15.11 21 14 21H4C2.9 21 2 20.11 2 19V7C2 5.9 1.11 5 0 5V3M4 5V7H9V8H4V9H7V10H4V11H7V12H4V13H9V14H4V15H7V16H4V19H14V5H4M21.5 15.5V17H20V15.5H21.5M19.5 10.5H18V10C18 8.34 19.34 7 21 7C22.66 7 24 8.34 24 10C24 10.97 23.5 11.88 22.71 12.41L22.41 12.6C21.84 13 21.5 13.62 21.5 14.3V14.5H20V14.3C20 13.11 20.6 12 21.59 11.35L21.88 11.16C22.27 10.9 22.5 10.47 22.5 10C22.5 9.18 21.83 8.5 21 8.5C20.17 8.5 19.5 9.17 19.5 10V10.5Z";
var mdiBeakerRemove = "M15.46 15.88L16.88 14.46L19 16.59L21.12 14.47L22.53 15.88L20.41 18L22.54 20.12L21.12 21.54L19 19.41L16.88 21.53L15.47 20.12L17.59 18L15.46 15.88M3 3H21V5C19.9 5 19 5.9 19 7V12C15.69 12 13 14.69 13 18C13 19.09 13.29 20.12 13.8 21H7C5.9 21 5 20.1 5 19V7C5 5.9 4.1 5 3 5V3M7 9V10H10V9H7M7 11V12H10V11H7M10 16V15H7V16H10M12 14V13H7V14H12M12 8V7H7V8H12Z";
var mdiBeakerRemoveOutline = "M15.46 15.88L16.88 14.46L19 16.59L21.12 14.47L22.53 15.88L20.41 18L22.54 20.12L21.12 21.54L19 19.41L16.88 21.53L15.47 20.12L17.59 18L15.46 15.88M3 3H21V5C19.9 5 19 5.9 19 7V12C18.3 12 17.63 12.12 17 12.34V5H7V7H12V8H7V9H10V10H7V11H10V12H7V13H12V14H7V15H10V16H7V19H13.08C13.2 19.72 13.45 20.39 13.8 21H7C5.9 21 5 20.11 5 19V7C5 5.9 4.11 5 3 5V3Z";
var mdiBed = "M19,7H11V14H3V5H1V20H3V17H21V20H23V11A4,4 0 0,0 19,7M7,13A3,3 0 0,0 10,10A3,3 0 0,0 7,7A3,3 0 0,0 4,10A3,3 0 0,0 7,13Z";
var mdiBedClock = "M19.2 9.5L16 7.7V4H17.5V6.8L19.9 8.2L19.2 9.5M22.2 11.7C22.7 12.4 23 13.2 23 14V23H21V20H3V23H1V8H3V17H11V10.6C10.4 9.5 10 8.3 10 7C10 3.1 13.1 0 17 0S24 3.1 24 7C24 8.8 23.3 10.4 22.2 11.7M12 7C12 9.8 14.2 12 17 12S22 9.8 22 7 19.8 2 17 2 12 4.2 12 7M7 16C8.7 16 10 14.7 10 13S8.7 10 7 10 4 11.3 4 13 5.3 16 7 16Z";
var mdiBedDouble = "M18 10V7A2 2 0 0 0 16 5H8A2 2 0 0 0 6 7V10A2 2 0 0 0 4 12V17H5.33L6 19H7L7.67 17H16.33L17 19H18L18.67 17H20V12A2 2 0 0 0 18 10M11 10H8V7H11M16 10H13V7H16Z";
var mdiBedDoubleOutline = "M8 5C7.5 5 7 5.21 6.61 5.6S6 6.45 6 7V10C5.47 10 5 10.19 4.59 10.59S4 11.47 4 12V17H5.34L6 19H7L7.69 17H16.36L17 19H18L18.66 17H20V12C20 11.47 19.81 11 19.41 10.59S18.53 10 18 10V7C18 6.45 17.8 6 17.39 5.6S16.5 5 16 5M8 7H11V10H8M13 7H16V10H13M6 12H18V15H6Z";
var mdiBedEmpty = "M19,7H5V14H3V5H1V20H3V17H21V20H23V11A4,4 0 0,0 19,7";
var mdiBedKing = "M6 5C5.47 5 5 5.21 4.59 5.6S4 6.45 4 7V10C3.45 10 3 10.19 2.6 10.59S2 11.47 2 12V17H3.33L4 19H5L5.67 17H18.33L19 19H20L20.67 17H22V12C22 11.47 21.79 11 21.4 10.59C21 10.19 20.55 10 20 10V7C20 6.45 19.81 6 19.41 5.6S18.53 5 18 5M6 7H11V10H6M13 7H18V10H13Z";
var mdiBedKingOutline = "M20 10V7A2 2 0 0 0 18 5H6A2 2 0 0 0 4 7V10A2 2 0 0 0 2 12V17H3.33L4 19H5L5.67 17H18.33L19 19H20L20.67 17H22V12A2 2 0 0 0 20 10M13 7H18V10H13M6 7H11V10H6M20 15H4V12H20Z";
var mdiBedOutline = "M7 14C8.66 14 10 12.66 10 11C10 9.34 8.66 8 7 8C5.34 8 4 9.34 4 11C4 12.66 5.34 14 7 14M7 10C7.55 10 8 10.45 8 11C8 11.55 7.55 12 7 12C6.45 12 6 11.55 6 11C6 10.45 6.45 10 7 10M19 7H11V15H3V5H1V20H3V17H21V20H23V11C23 8.79 21.21 7 19 7M21 15H13V9H19C20.1 9 21 9.9 21 11Z";
var mdiBedQueen = "M19 10V7A2 2 0 0 0 17 5H7A2 2 0 0 0 5 7V10A2 2 0 0 0 3 12V17H4.33L5 19H6L6.67 17H17.33L18 19H19L19.67 17H21V12A2 2 0 0 0 19 10M17 10H7V7H17Z";
var mdiBedQueenOutline = "M19 10V7A2 2 0 0 0 17 5H7A2 2 0 0 0 5 7V10A2 2 0 0 0 3 12V17H4.33L5 19H6L6.67 17H17.33L18 19H19L19.67 17H21V12A2 2 0 0 0 19 10M7 7H17V10H7M19 15H5V12H19Z";
var mdiBedSingle = "M17 10V7C17 5.9 16.11 5 15 5H9C7.9 5 7 5.9 7 7V10C5.9 10 4.89 10.9 5 12V17H6.33L7 19H8L8.67 17H15.33L16 19H17L17.67 17H19V12C19 10.9 18.11 10 17 10M15 10H9V7H15Z";
var mdiBedSingleOutline = "M17 10V7C17 5.9 16.11 5 15 5H9C7.9 5 7 5.9 7 7V10C5.9 10 5 10.9 5 12V17H6.33L7 19H8L8.67 17H15.33L16 19H17L17.67 17H19V12C19 10.9 18.11 10 17 10M9 7H15V10H9M17 15H7V12H17Z";
var mdiBee = "M17.4 9C17 7.8 16.2 7 15 6.5V5H14V6.4H13.6C12.5 6.4 11.6 6.8 10.8 7.6L10.4 8L9 7.5C8.7 7.4 8.4 7.3 8 7.3C7.4 7.3 6.8 7.5 6.3 7.9C5.7 8.3 5.4 8.8 5.2 9.3C5 10 5 10.6 5.2 11.3C5.5 12 5.8 12.5 6.3 12.8C5.9 14.3 6.2 15.6 7.3 16.7C8.1 17.5 9 17.9 10.1 17.9C10.6 17.9 10.9 17.9 11.2 17.8C11.8 18.6 12.6 19.1 13.6 19.1C13.9 19.1 14.3 19.1 14.6 19C15.2 18.8 15.6 18.4 16 17.9C16.4 17.3 16.6 16.8 16.6 16.2C16.6 15.8 16.6 15.5 16.5 15.2L16 13.6L16.6 13.2C17.4 12.4 17.8 11.3 17.7 10.1H19V9H17.4M7.7 11.3C7.1 11 6.9 10.6 7.1 10C7.3 9.4 7.7 9.2 8.3 9.4L11.5 10.6C9.9 11.4 8.7 11.6 7.7 11.3M14 16.9C13.4 17.1 13 16.9 12.7 16.3C12.4 15.3 12.6 14.1 13.4 12.5L14.6 15.6C14.8 16.3 14.6 16.7 14 16.9M15.2 11.6L14.6 10V9.9L14.3 9.6H14.2L12.6 9C13 8.7 13.4 8.5 13.9 8.5C14.4 8.5 14.9 8.7 15.3 9.1C15.7 9.5 15.9 9.9 15.9 10.4C15.7 10.7 15.5 11.2 15.2 11.6Z";
var mdiBeeFlower = "M11.6 13V12.9L11.3 12.6H11.2L9.6 12C10 11.7 10.4 11.5 10.9 11.5C11.4 11.5 11.9 11.7 12.3 12.1C12.7 12.5 12.9 12.9 12.9 13.4C12.9 13.9 12.8 14.3 12.4 14.7L11.6 13M9.7 19.3C9.4 18.3 9.6 17.1 10.4 15.5L11.6 18.6C11.8 19.2 11.6 19.6 11 19.9C10.4 20.2 10 20 9.7 19.3M4.1 13.1C4.3 12.5 4.7 12.3 5.3 12.5L8.5 13.7C6.9 14.5 5.7 14.7 4.7 14.4C4.1 14.1 3.9 13.7 4.1 13.1M12 8.1H11V9.5H10.6C9.5 9.5 8.6 9.9 7.8 10.7L7.4 11.3L6 10.5C5.7 10.4 5.4 10.4 5 10.4C4.4 10.4 3.8 10.6 3.3 11S2.4 11.8 2.2 12.4C2 13.1 2 13.7 2.2 14.4C2.5 15.1 2.8 15.6 3.3 15.9C2.9 17.4 3.2 18.7 4.3 19.8C5.1 20.6 6 21 7.1 21C7.6 21 7.9 21 8.2 20.9C8.8 21.7 9.6 22.2 10.6 22.2C10.9 22.2 11.3 22.2 11.6 22.1C12.2 21.9 12.6 21.5 13 21C13.4 20.4 13.6 19.9 13.6 19.3C13.6 18.9 13.6 18.6 13.5 18.3L12.9 16.9L13.5 16.5C14.3 15.7 14.7 14.6 14.6 13.4H16V12.4H14.4C14 11.2 13.2 10.4 12 10V8.1M17.3 6.8C17.1 6.6 17 6.3 17 6.1C17 5.8 17.1 5.6 17.3 5.4C17.5 5.2 17.7 5.1 18 5.1S18.5 5.2 18.7 5.4C18.9 5.5 19 5.8 19 6.1C19 6.4 18.9 6.6 18.7 6.8C18.5 7 18.3 7 18 7S17.5 7 17.3 6.8M20.7 4.1H19.6L19.3 3.2C19.1 2.5 18.7 2.2 18 2.2C17.3 2.2 16.8 2.5 16.7 3.2L16.4 4.1H15.3C14.7 4.1 14.3 4.4 14 5C13.8 5.6 14 6.1 14.6 6.5L15.5 7L15.1 8.2C14.9 8.6 15 9 15.2 9.4C15.5 9.8 15.8 10 16.3 10C16.7 10 17 9.9 17.2 9.7L18 9.1L18.8 9.8C19 9.9 19.3 10 19.7 10C20.2 10 20.5 9.8 20.8 9.4C21 9 21.1 8.6 20.9 8.2L20.5 7L21.3 6.5C21.9 6.1 22.1 5.6 21.9 5C21.7 4.3 21.3 4.1 20.7 4.1Z";
var mdiBeehiveOffOutline = "M1.1 3L4.7 6.5C3.7 7.2 3 8.2 3 9.5C3 10.1 3.2 10.7 3.5 11.2C2 11.6 1 12.9 1 14.5C1 15.8 1.7 16.8 2.7 17.5C2.2 18 2 18.7 2 19.5C2 21.4 3.6 23 5.5 23H18.5C19.3 23 20 22.7 20.6 22.3L21.3 23L22.6 21.7L2.4 1.7L1.1 3M9.2 11H6.5C5.7 11 5 10.3 5 9.5C5 8.8 5.5 8.2 6.2 8L9.2 11M9 21H5.5C4.7 21 4 20.3 4 19.5S4.7 18 5.5 18H9V21M9.2 16H4.5C3.7 16 3 15.3 3 14.5S3.7 13 4.5 13H11.2L12.2 14H12C10.7 14 9.6 14.8 9.2 16M18.5 21H15V18H16.2L19.1 20.9C18.9 21 18.7 21 18.5 21M7.1 3.9L5.7 2.5C6.3 1.6 7.3 1 8.5 1H15.5C17.4 1 19 2.6 19 4.5C19 5.1 18.8 5.7 18.5 6.2C20 6.6 21 7.9 21 9.5C21 10.1 20.8 10.7 20.5 11.2C21.9 11.7 23 13 23 14.5C23 15.8 22.3 16.8 21.3 17.5C21.6 17.9 21.8 18.3 21.9 18.7L19.2 16H19.5C20.3 16 21 15.3 21 14.5S20.3 13 19.5 13H16.2L14.2 11H17.5C18.3 11 19 10.3 19 9.5S18.3 8 17.5 8H11.2L9.2 6H15.5C16.3 6 17 5.3 17 4.5S16.3 3 15.5 3H8.5C7.9 3 7.3 3.4 7.1 3.9Z";
var mdiBeehiveOutline = "M23 14.5C23 12.94 21.97 11.63 20.55 11.18C20.83 10.68 21 10.11 21 9.5C21 7.94 19.97 6.63 18.55 6.18C18.83 5.68 19 5.11 19 4.5C19 2.57 17.43 1 15.5 1H8.5C6.57 1 5 2.57 5 4.5C5 5.11 5.17 5.68 5.45 6.18C4.04 6.63 3 7.94 3 9.5C3 10.11 3.17 10.68 3.45 11.18C2.04 11.63 1 12.94 1 14.5C1 15.76 1.67 16.84 2.67 17.46C2.25 18.03 2 18.74 2 19.5C2 21.43 3.57 23 5.5 23H18.5C20.43 23 22 21.43 22 19.5C22 18.74 21.75 18.03 21.33 17.46C22.33 16.84 23 15.76 23 14.5M8.5 3H15.5C16.33 3 17 3.67 17 4.5S16.33 6 15.5 6H8.5C7.67 6 7 5.33 7 4.5S7.67 3 8.5 3M6.5 8H17.5C18.33 8 19 8.67 19 9.5S18.33 11 17.5 11H6.5C5.67 11 5 10.33 5 9.5S5.67 8 6.5 8M4 19.5C4 18.67 4.67 18 5.5 18H9V21H5.5C4.67 21 4 20.33 4 19.5M18.5 21H15V18H18.5C19.33 18 20 18.67 20 19.5S19.33 21 18.5 21M19.5 16H14.82C14.4 14.84 13.3 14 12 14S9.6 14.84 9.18 16H4.5C3.67 16 3 15.33 3 14.5S3.67 13 4.5 13H19.5C20.33 13 21 13.67 21 14.5S20.33 16 19.5 16Z";
var mdiBeekeeper = "M19 5H16C16 3.34 14.21 2 12 2C9.79 2 8 3.34 8 5H5C4.45 5 4 5.45 4 6S4.45 7 5 7V14C5 15.11 5.9 16 7 16H17C18.11 16 19 15.11 19 14V7C19.55 7 20 6.55 20 6S19.55 5 19 5M17 14H7V7H17V14M15.86 8C15.94 8.32 16 8.65 16 9C16 11.21 14.21 13 12 13S8 11.21 8 9C8 8.65 8.06 8.32 8.14 8H10.28C10.11 8.3 10 8.63 10 9C10 10.1 10.9 11 12 11S14 10.1 14 9C14 8.63 13.89 8.3 13.72 8H15.86M20 19V22H4V19C4 18.22 4.47 17.55 5.18 17H12C9.28 17 6.19 18.29 6 19V20H18V19C17.81 18.29 14.72 17 12 17H18.82C19.53 17.55 20 18.22 20 19Z";
var mdiBeer = "M4,2H19L17,22H6L4,2M6.2,4L7.8,20H8.8L7.43,6.34C8.5,6 9.89,5.89 11,7C12.56,8.56 15.33,7.69 16.5,7.23L16.8,4H6.2Z";
var mdiBeerOutline = "M4 2L6 22H17L19 2H4M6.2 4H16.8L16.5 7.23C13.18 8.5 11.85 7.67 11.38 7.31C11.13 7.12 10.77 6.69 10.11 6.39C9.45 6.08 8.55 6 7.5 6.32C7.09 6.43 6.77 6.61 6.5 6.79L6.2 4M8.86 8.11C9.05 8.11 9.16 8.15 9.27 8.2C9.5 8.3 9.71 8.55 10.17 8.9C11.03 9.56 13.03 10.36 16.26 9.41L15.2 20H7.8L6.71 9.06C6.76 9 6.91 8.89 7.17 8.71C7.5 8.5 7.91 8.28 8 8.25L8 8.25H8.03C8.41 8.14 8.67 8.1 8.86 8.11Z";
var mdiBell = "M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M14,21A2,2 0 0,1 12,23A2,2 0 0,1 10,21";
var mdiBellAlert = "M23 7V13H21V7M21 15H23V17H21M12 2A2 2 0 0 0 10 4A2 2 0 0 0 10 4.29C7.12 5.14 5 7.82 5 11V17L3 19V20H21V19L19 17V11C19 7.82 16.88 5.14 14 4.29A2 2 0 0 0 14 4A2 2 0 0 0 12 2M10 21A2 2 0 0 0 12 23A2 2 0 0 0 14 21Z";
var mdiBellAlertOutline = "M12 2A2 2 0 0 0 10 4A2 2 0 0 0 10 4.29C7.12 5.14 5 7.82 5 11V17L3 19V20H21V19L19 17V11C19 7.82 16.88 5.14 14 4.29A2 2 0 0 0 14 4A2 2 0 0 0 12 2M12 6A5 5 0 0 1 17 11V18H7V11A5 5 0 0 1 12 6M21 7V13H23V7H21M21 15V17H23V15H21M10 21A2 2 0 0 0 12 23A2 2 0 0 0 14 21H10Z";
var mdiBellBadge = "M21 6.5C21 8.43 19.43 10 17.5 10S14 8.43 14 6.5 15.57 3 17.5 3 21 4.57 21 6.5M19 11.79C18.5 11.92 18 12 17.5 12C14.47 12 12 9.53 12 6.5C12 5.03 12.58 3.7 13.5 2.71C13.15 2.28 12.61 2 12 2C10.9 2 10 2.9 10 4V4.29C7.03 5.17 5 7.9 5 11V17L3 19V20H21V19L19 17V11.79M12 23C13.11 23 14 22.11 14 21H10C10 22.11 10.9 23 12 23Z";
var mdiBellBadgeOutline = "M19 17V11.8C18.5 11.9 18 12 17.5 12H17V18H7V11C7 8.2 9.2 6 12 6C12.1 4.7 12.7 3.6 13.5 2.7C13.2 2.3 12.6 2 12 2C10.9 2 10 2.9 10 4V4.3C7 5.2 5 7.9 5 11V17L3 19V20H21V19L19 17M10 21C10 22.1 10.9 23 12 23S14 22.1 14 21H10M21 6.5C21 8.4 19.4 10 17.5 10S14 8.4 14 6.5 15.6 3 17.5 3 21 4.6 21 6.5";
var mdiBellCancel = "M17.5 13A4.5 4.5 0 0 0 13 17.5A4.5 4.5 0 0 0 17.5 22A4.5 4.5 0 0 0 22 17.5A4.5 4.5 0 0 0 17.5 13M17.5 14.5A3 3 0 0 1 20.5 17.5A3 3 0 0 1 20.08 19L16 14.92A3 3 0 0 1 17.5 14.5M14.92 16L19 20.08A3 3 0 0 1 17.5 20.5A3 3 0 0 1 14.5 17.5A3 3 0 0 1 14.92 16M12 2C10.9 2 10 2.9 10 4C10 4.1 10 4.19 10 4.29C7.12 5.14 5 7.82 5 11V17L3 19V20H11.5A6.5 6.5 0 0 1 11 17.5A6.5 6.5 0 0 1 17.5 11A6.5 6.5 0 0 1 19 11.18V11C19 7.82 16.88 5.14 14 4.29C14 4.19 14 4.1 14 4C14 2.9 13.11 2 12 2M10 21C10 22.11 10.9 23 12 23C12.5 23 12.97 22.81 13.33 22.5A6.5 6.5 0 0 1 12.03 21Z";
var mdiBellCancelOutline = "M17.5 13A4.5 4.5 0 0 0 13 17.5A4.5 4.5 0 0 0 17.5 22A4.5 4.5 0 0 0 22 17.5A4.5 4.5 0 0 0 17.5 13M17.5 14.5A3 3 0 0 1 20.5 17.5A3 3 0 0 1 20.08 19L16 14.92A3 3 0 0 1 17.5 14.5M14.92 16L19 20.08A3 3 0 0 1 17.5 20.5A3 3 0 0 1 14.5 17.5A3 3 0 0 1 14.92 16M12 2C10.9 2 10 2.9 10 4C10 4.1 10 4.19 10 4.29C7.12 5.14 5 7.82 5 11V17L3 19V20H11.5A6.5 6.5 0 0 1 11.03 18H7V11A5 5 0 0 1 12 6A5 5 0 0 1 17 11V11A6.5 6.5 0 0 1 17.5 11A6.5 6.5 0 0 1 19 11.18V11C19 7.82 16.88 5.14 14 4.29C14 4.19 14 4.1 14 4C14 2.9 13.11 2 12 2M10 21C10 22.11 10.9 23 12 23C12.5 23 12.97 22.81 13.33 22.5A6.5 6.5 0 0 1 12.03 21Z";
var mdiBellCheck = "M17.75 21.16L15 18.16L16.16 17L17.75 18.59L21.34 15L22.5 16.41L17.75 21.16M3 20V19L5 17V11C5 7.9 7.03 5.18 10 4.29V4C10 2.9 10.9 2 12 2C13.11 2 14 2.9 14 4V4.29C16.97 5.18 19 7.9 19 11V12.08L18 12C14.69 12 12 14.69 12 18C12 18.7 12.12 19.37 12.34 20H3M12 23C10.9 23 10 22.11 10 21H12.8C13.04 21.41 13.33 21.79 13.65 22.13C13.29 22.66 12.69 23 12 23Z";
var mdiBellCheckOutline = "M17.75 21.16L15 18.16L16.16 17L17.75 18.59L21.34 15L22.5 16.41L17.75 21.16M10 21H12.8C13.04 21.41 13.33 21.79 13.65 22.13C13.29 22.66 12.69 23 12 23C10.9 23 10 22.11 10 21M3 20V19L5 17V11C5 7.9 7.03 5.18 10 4.29V4C10 2.9 10.9 2 12 2C13.11 2 14 2.9 14 4V4.29C16.97 5.18 19 7.9 19 11V12.08L18 12L17 12.08V11C17 8.24 14.76 6 12 6C9.24 6 7 8.24 7 11V18H12C12 18.7 12.12 19.37 12.34 20H3Z";
var mdiBellCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M17,16V15L16,14V11.39C16,10.3 15.73,9.34 15.21,8.53C14.7,7.72 13.96,7.21 13,7V6.5A1,1 0 0,0 12,5.5A1,1 0 0,0 11,6.5V7C10.04,7.21 9.3,7.72 8.79,8.53C8.27,9.34 8,10.3 8,11.39V14L7,15V16H17M13.5,17H10.5A1.5,1.5 0 0,0 12,18.5A1.5,1.5 0 0,0 13.5,17Z";
var mdiBellCircleOutline = "M17,16H7V15L8,14V11.39C8,10.3 8.27,9.34 8.79,8.53C9.3,7.72 10.04,7.21 11,7V6.5A1,1 0 0,1 12,5.5A1,1 0 0,1 13,6.5V7C13.96,7.21 14.7,7.72 15.21,8.53C15.73,9.34 16,10.3 16,11.39V14L17,15V16M13.5,17A1.5,1.5 0 0,1 12,18.5A1.5,1.5 0 0,1 10.5,17H13.5M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiBellCog = "M19 12C15.13 12 12 15.13 12 19C12 19.34 12.03 19.67 12.08 20H3V19L5 17V11C5 7.9 7.03 5.17 10 4.29V4C10 2.9 10.9 2 12 2S14 2.9 14 4V4.29C16.97 5.17 19 7.9 19 11V12M10 21C10 22.11 10.9 23 12 23C12.39 23 12.75 22.88 13.06 22.69C12.74 22.17 12.5 21.6 12.3 21H10M23.77 20.32C23.87 20.39 23.89 20.53 23.83 20.64L22.83 22.37C22.77 22.5 22.64 22.5 22.53 22.5L21.28 21.97C21 22.17 20.75 22.34 20.44 22.47L20.25 23.79C20.23 23.91 20.13 24 20 24H18C17.88 24 17.77 23.91 17.75 23.79L17.57 22.47C17.25 22.34 17 22.17 16.72 21.97L15.5 22.5C15.37 22.5 15.23 22.5 15.17 22.37L14.17 20.64C14.11 20.53 14.14 20.39 14.23 20.32L15.29 19.5C15.27 19.33 15.25 19.17 15.25 19S15.27 18.67 15.29 18.5L14.23 17.68C14.14 17.61 14.11 17.5 14.17 17.36L15.17 15.64C15.23 15.53 15.37 15.5 15.5 15.53L16.72 16C17 15.83 17.25 15.66 17.57 15.54L17.75 14.21C17.77 14.09 17.88 14 18 14H20C20.13 14 20.23 14.09 20.25 14.21L20.44 15.54C20.75 15.66 21 15.83 21.28 16L22.53 15.53C22.64 15.5 22.77 15.53 22.83 15.64L23.83 17.36C23.89 17.5 23.87 17.61 23.77 17.68L22.72 18.5C22.74 18.67 22.75 18.84 22.75 19S22.74 19.33 22.72 19.5L23.77 20.32M20.75 19C20.75 18.03 19.97 17.25 19 17.25S17.25 18.03 17.25 19 18.04 20.75 19 20.75 20.75 19.97 20.75 19Z";
var mdiBellCogOutline = "M22.72 19.5C22.74 19.33 22.75 19.17 22.75 19S22.74 18.67 22.72 18.5L23.77 17.68C23.87 17.61 23.89 17.5 23.83 17.36L22.83 15.64C22.77 15.53 22.64 15.5 22.53 15.53L21.28 16C21 15.83 20.75 15.66 20.44 15.54L20.25 14.21C20.23 14.09 20.13 14 20 14H18C17.88 14 17.77 14.09 17.75 14.21L17.57 15.54C17.25 15.66 17 15.83 16.72 16L15.5 15.53C15.37 15.5 15.23 15.53 15.17 15.64L14.17 17.36C14.11 17.5 14.14 17.61 14.23 17.68L15.29 18.5C15.27 18.67 15.25 18.84 15.25 19S15.27 19.33 15.29 19.5L14.23 20.32C14.14 20.39 14.11 20.53 14.17 20.64L15.17 22.37C15.23 22.5 15.37 22.5 15.5 22.5L16.72 21.97C17 22.17 17.25 22.34 17.57 22.47L17.75 23.79C17.77 23.91 17.88 24 18 24H20C20.13 24 20.23 23.91 20.25 23.79L20.44 22.47C20.75 22.34 21 22.17 21.28 21.97L22.53 22.5C22.64 22.5 22.77 22.5 22.83 22.37L23.83 20.64C23.89 20.53 23.87 20.39 23.77 20.32L22.72 19.5M19 20.75C18.04 20.75 17.25 19.97 17.25 19S18.04 17.25 19 17.25 20.75 18.03 20.75 19 19.97 20.75 19 20.75M12.08 20H3V19L5 17V11C5 7.9 7 5.2 10 4.3V4C10 2.9 10.9 2 12 2S14 2.9 14 4V4.3C17 5.2 19 7.9 19 11V12C18.31 12 17.63 12.11 17 12.29V11C17 8.2 14.8 6 12 6S7 8.2 7 11V18H12.08C12.03 18.33 12 18.66 12 19C12 19.34 12.03 19.67 12.08 20M12.3 21C12.5 21.6 12.74 22.17 13.06 22.69C12.75 22.88 12.39 23 12 23C10.9 23 10 22.1 10 21H12.3Z";
var mdiBellMinus = "M22 19V17H14V19H22M12 2C10.9 2 10 2.9 10 4C10 4.1 10 4.19 10 4.29C7.12 5.14 5 7.82 5 11V17L3 19V20H12.35C12.12 19.36 12 18.68 12 18C12 14.69 14.69 12 18 12C18.34 12 18.67 12.03 19 12.09V11C19 7.82 16.88 5.14 14 4.29C14 4.19 14 4.1 14 4C14 2.9 13.11 2 12 2M10 21C10 22.11 10.9 23 12 23C12.66 23 13.28 22.67 13.65 22.13C13.33 21.79 13.05 21.41 12.81 21H10Z";
var mdiBellMinusOutline = "M12 2C10.9 2 10 2.9 10 4V4.29C7.12 5.14 5 7.82 5 11V17L3 19V20H12.35C12.12 19.36 12 18.68 12 18H7V11C7 8.24 9.24 6 12 6S17 8.24 17 11V12.09C17.33 12.03 17.67 12 18 12C18.34 12 18.67 12.03 19 12.09V11C19 7.82 16.88 5.14 14 4.29V4C14 2.9 13.11 2 12 2M14 17V19H22V17M10 21C10 22.11 10.9 23 12 23C12.66 23 13.28 22.67 13.65 22.13C13.33 21.79 13.05 21.41 12.81 21H10Z";
var mdiBellOff = "M20.84,22.73L18.11,20H3V19L5,17V11C5,9.86 5.29,8.73 5.83,7.72L1.11,3L2.39,1.73L22.11,21.46L20.84,22.73M19,15.8V11C19,7.9 16.97,5.17 14,4.29C14,4.19 14,4.1 14,4A2,2 0 0,0 12,2A2,2 0 0,0 10,4C10,4.1 10,4.19 10,4.29C9.39,4.47 8.8,4.74 8.26,5.09L19,15.8M12,23A2,2 0 0,0 14,21H10A2,2 0 0,0 12,23Z";
var mdiBellOffOutline = "M22.11,21.46L2.39,1.73L1.11,3L5.83,7.72C5.29,8.73 5,9.86 5,11V17L3,19V20H18.11L20.84,22.73L22.11,21.46M7,18V11C7,10.39 7.11,9.79 7.34,9.23L16.11,18H7M10,21H14A2,2 0 0,1 12,23A2,2 0 0,1 10,21M8.29,5.09C8.82,4.75 9.4,4.5 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V15.8L17,13.8V11A5,5 0 0,0 12,6C11.22,6 10.45,6.2 9.76,6.56L8.29,5.09Z";
var mdiBellOutline = "M10 21H14C14 22.1 13.1 23 12 23S10 22.1 10 21M21 19V20H3V19L5 17V11C5 7.9 7 5.2 10 4.3V4C10 2.9 10.9 2 12 2S14 2.9 14 4V4.3C17 5.2 19 7.9 19 11V17L21 19M17 11C17 8.2 14.8 6 12 6S7 8.2 7 11V18H17V11Z";
var mdiBellPlus = "M17 14V17H14V19H17V22H19V19H22V17H19V14M12 2A2 2 0 0 0 10 4A2 2 0 0 0 10 4.29C7.12 5.14 5 7.82 5 11V17L3 19V20H12.35A6 6 0 0 1 12 18A6 6 0 0 1 18 12A6 6 0 0 1 19 12.09V11C19 7.82 16.88 5.14 14 4.29A2 2 0 0 0 14 4A2 2 0 0 0 12 2M10 21A2 2 0 0 0 12 23A2 2 0 0 0 13.65 22.13A6 6 0 0 1 12.81 21Z";
var mdiBellPlusOutline = "M12 2C10.9 2 10 2.9 10 4C10 4.1 10 4.19 10 4.29C7.12 5.14 5 7.82 5 11V17L3 19V20H12.35C12.12 19.36 12 18.68 12 18H7V11C7 8.24 9.24 6 12 6C14.76 6 17 8.24 17 11V12.09C17.33 12.03 17.67 12 18 12C18.34 12 18.67 12.03 19 12.09V11C19 7.82 16.88 5.14 14 4.29C14 4.19 14 4.1 14 4C14 2.9 13.11 2 12 2M17 14V17H14V19H17V22H19V19H22V17H19V14M10 21C10 22.11 10.9 23 12 23C12.66 23 13.28 22.67 13.65 22.13C13.33 21.79 13.05 21.41 12.81 21Z";
var mdiBellRemove = "M20.12 14.46L18 16.59L15.88 14.46L14.46 15.88L16.59 18L14.46 20.12L15.88 21.54L18 19.41L20.12 21.54L21.54 20.12L19.41 18L21.54 15.88M12 2C10.9 2 10 2.9 10 4C10 4.1 10 4.19 10 4.29C7.12 5.14 5 7.82 5 11V17L3 19V20H12.35C12.12 19.36 12 18.68 12 18C12 14.69 14.69 12 18 12C18.34 12 18.67 12.03 19 12.09V11C19 7.82 16.88 5.14 14 4.29C14 4.19 14 4.1 14 4C14 2.9 13.11 2 12 2M10 21C10 22.11 10.9 23 12 23C12.66 23 13.28 22.67 13.65 22.13C13.33 21.79 13.05 21.41 12.81 21Z";
var mdiBellRemoveOutline = "M20.12 14.46L18 16.59L15.88 14.46L14.46 15.88L16.59 18L14.46 20.12L15.88 21.54L18 19.41L20.12 21.54L21.54 20.12L19.41 18L21.54 15.88M12 2C10.9 2 10 2.9 10 4C10 4.1 10 4.19 10 4.29C7.12 5.14 5 7.82 5 11V17L3 19V20H12.35C12.12 19.36 12 18.68 12 18H7V11A5 5 0 0 1 12 6A5 5 0 0 1 17 11V12.09C17.33 12.04 17.66 12 18 12C18.34 12 18.67 12.03 19 12.09V11C19 7.82 16.88 5.14 14 4.29C14 4.19 14 4.1 14 4C14 2.9 13.11 2 12 2M10 21C10 22.11 10.9 23 12 23C12.66 23 13.28 22.67 13.65 22.13C13.33 21.79 13.05 21.41 12.81 21Z";
var mdiBellRing = "M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M14,21A2,2 0 0,1 12,23A2,2 0 0,1 10,21M19.75,3.19L18.33,4.61C20.04,6.3 21,8.6 21,11H23C23,8.07 21.84,5.25 19.75,3.19M1,11H3C3,8.6 3.96,6.3 5.67,4.61L4.25,3.19C2.16,5.25 1,8.07 1,11Z";
var mdiBellRingOutline = "M10,21H14A2,2 0 0,1 12,23A2,2 0 0,1 10,21M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M17,11A5,5 0 0,0 12,6A5,5 0 0,0 7,11V18H17V11M19.75,3.19L18.33,4.61C20.04,6.3 21,8.6 21,11H23C23,8.07 21.84,5.25 19.75,3.19M1,11H3C3,8.6 3.96,6.3 5.67,4.61L4.25,3.19C2.16,5.25 1,8.07 1,11Z";
var mdiBellSleep = "M10,21H14A2,2 0 0,1 12,23A2,2 0 0,1 10,21M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M15,9H9V11H12.24L9,13.7V16H15V14H11.76L15,11.3V9Z";
var mdiBellSleepOutline = "M10,21H14A2,2 0 0,1 12,23A2,2 0 0,1 10,21M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M17,11A5,5 0 0,0 12,6A5,5 0 0,0 7,11V18H17V11M9,9V11H12.24L9,13.7V16H15V14H11.76L15,11.3V9H9Z";
var mdiBench = "M23 13H1V15H3V19H5V15H19V19H21V15H23V13Z";
var mdiBenchBack = "M4 5C3.45 5 3 5.45 3 6V10C3 10.55 3.45 11 4 11H5V13H1V15H3V19H5V15H19V19H21V15H23V13H19V11H20C20.55 11 21 10.55 21 10V6C21 5.45 20.55 5 20 5H4M17 11V13H7V11H17Z";
var mdiBeta = "M9.23,17.59V23.12H6.88V6.72C6.88,5.27 7.31,4.13 8.16,3.28C9,2.43 10.17,2 11.61,2C13,2 14.07,2.34 14.87,3C15.66,3.68 16.05,4.62 16.05,5.81C16.05,6.63 15.79,7.4 15.27,8.11C14.75,8.82 14.08,9.31 13.25,9.58V9.62C14.5,9.82 15.47,10.27 16.13,11C16.79,11.71 17.12,12.62 17.12,13.74C17.12,15.06 16.66,16.14 15.75,16.97C14.83,17.8 13.63,18.21 12.13,18.21C11.07,18.21 10.1,18 9.23,17.59M10.72,10.75V8.83C11.59,8.72 12.3,8.4 12.87,7.86C13.43,7.31 13.71,6.7 13.71,6C13.71,4.62 13,3.92 11.6,3.92C10.84,3.92 10.25,4.16 9.84,4.65C9.43,5.14 9.23,5.82 9.23,6.71V15.5C10.14,16.03 11.03,16.29 11.89,16.29C12.73,16.29 13.39,16.07 13.86,15.64C14.33,15.2 14.56,14.58 14.56,13.79C14.56,12 13.28,11 10.72,10.75Z";
var mdiBetamax = "M4,5A2,2 0 0,0 2,7V17A2,2 0 0,0 4,19H20A2,2 0 0,0 22,17V7A2,2 0 0,0 20,5H4M8,9A4,4 0 0,1 12,13A4,4 0 0,1 8,17A4,4 0 0,1 4,13A4,4 0 0,1 8,9M13,9H20V17H13V9M8,11A2,2 0 0,0 6,13A2,2 0 0,0 8,15A2,2 0 0,0 10,13A2,2 0 0,0 8,11Z";
var mdiBiathlon = "M12.88,3.64C13.65,3.64 14.28,4.27 14.28,5.04C14.28,5.81 13.65,6.44 12.88,6.44C12.11,6.44 11.5,5.81 11.5,5.04C11.5,4.27 12.11,3.64 12.88,3.64M15,13H16.5V19H15V13M15,8.5H16.5V10H15V8.5M10.04,2.6L8,2.04L6.06,8.58L3.9,11.42L7.17,12.37L10.04,2.6M19.67,18.55C19.31,18.93 18.88,19.5 18.4,19.7C17.91,19.92 17.54,20 17,20H13.5L13.43,17C13.42,16.83 13.37,16.67 13.28,16.5L10.88,12.24L11.76,9.5C12.34,10.55 13,11.73 13.06,11.83C13.21,12 13.45,12.13 13.69,12.13H15.9A0.81,0.81 0 0,0 16.71,11.32C16.71,10.9 16.38,10.56 15.96,10.53L14.29,10.4L12.4,7C12.4,7 12,6.42 11.14,6.42C10.27,6.42 10,6.84 9.83,7.42L6,20H3V22H17C18.37,22 19.53,21.34 20.5,20.37L19.67,18.55M9.75,14.39L11.62,17.39L11.75,20H7.75L9.75,14.39Z";
var mdiBicycle = "M19 10C18.44 10 17.91 10.11 17.41 10.28L14.46 4.5H11V6H13.54L14.42 7.72L12 13.13L10.23 8.95C10.5 8.85 10.74 8.58 10.74 8.25C10.74 7.84 10.41 7.5 10 7.5H8C7.58 7.5 7.24 7.84 7.24 8.25S7.58 9 8 9H8.61L10.86 14.25H9.92C9.56 11.85 7.5 10 5 10C2.24 10 0 12.24 0 15S2.24 20 5 20C7.5 20 9.56 18.15 9.92 15.75H12.5L15.29 9.43L16.08 10.96C14.82 11.87 14 13.34 14 15C14 17.76 16.24 20 19 20S24 17.76 24 15 21.76 10 19 10M5 18.5C3.07 18.5 1.5 16.93 1.5 15S3.07 11.5 5 11.5C6.67 11.5 8.07 12.68 8.41 14.25H4V15.75H8.41C8.07 17.32 6.67 18.5 5 18.5M19 18.5C17.07 18.5 15.5 16.93 15.5 15C15.5 13.92 16 12.97 16.77 12.33L18.57 15.85L19.89 15.13L18.1 11.63C18.39 11.56 18.69 11.5 19 11.5C20.93 11.5 22.5 13.07 22.5 15S20.93 18.5 19 18.5Z";
var mdiBicycleBasket = "M11.74 13.36L14.14 7.71L13.06 5.5H10.5V4H14L14.73 5.5H21.75L20.75 9H16.44L17.11 10.37C17.69 10.13 18.33 10 19 10C21.76 10 24 12.24 24 15C24 17.76 21.76 20 19 20C16.24 20 14 17.76 14 15C14 13.45 14.71 12.06 15.82 11.15L15 9.5L12.25 16H9.9C9.44 18.28 7.42 20 5 20C2.24 20 0 17.76 0 15C0 12.24 2.24 10 5 10C7.59 10 9.72 11.97 10 14.5H10.58L8.3 9H7.5C7.09 9 6.75 8.66 6.75 8.25C6.75 7.84 7.09 7.5 7.5 7.5H10.25C10.66 7.5 11 7.84 11 8.25C11 8.66 10.66 9 10.25 9H9.97L11.74 13.36M5 11.5C3.07 11.5 1.5 13.07 1.5 15C1.5 16.93 3.07 18.5 5 18.5C6.59 18.5 7.93 17.45 8.36 16H4V14.5H8.47C8.22 12.8 6.76 11.5 5 11.5M19 11.5C18.57 11.5 18.15 11.58 17.77 11.72L19.7 15.68L18.35 16.34L16.5 12.55C15.88 13.18 15.5 14.05 15.5 15C15.5 16.93 17.07 18.5 19 18.5C20.93 18.5 22.5 16.93 22.5 15C22.5 13.07 20.93 11.5 19 11.5Z";
var mdiBicycleCargo = "M21 11.5V10L13.5 9V5H9V6.5H12V14.3H11L9 10C9.3 9.9 9.5 9.6 9.5 9.3C9.5 8.9 9.2 8.5 8.8 8.5H6.8C6.3 8.5 6 8.8 6 9.2S6.3 10 6.8 10H7.4L9.4 14.2H7.9C7.6 12.4 6 11 4 11C1.8 11 0 12.8 0 15S1.8 19 4 19C6 19 7.6 17.6 7.9 15.8H16.5C16.7 13.4 18.6 11.5 21 11.5M6.4 15.8C6.1 16.8 5.1 17.6 4 17.6C2.6 17.6 1.5 16.5 1.5 15.1S2.6 12.6 4 12.6C5.1 12.6 6.1 13.3 6.4 14.4H4V15.9H6.4M21 13C19.3 13 18 14.3 18 16S19.3 19 21 19 24 17.7 24 16 22.7 13 21 13M21 17.5C20.2 17.5 19.5 16.8 19.5 16S20.2 14.5 21 14.5 22.5 15.2 22.5 16 21.8 17.5 21 17.5Z";
var mdiBicycleElectric = "M19 7C18.44 7 17.91 7.11 17.41 7.28L14.46 1.5H11V3H13.54L14.42 4.72L12 10.13L10.23 5.95C10.5 5.85 10.74 5.58 10.74 5.25C10.74 4.84 10.41 4.5 10 4.5H8C7.58 4.5 7.24 4.84 7.24 5.25S7.58 6 8 6H8.61L10.86 11.25H9.92C9.56 8.85 7.5 7 5 7C2.24 7 0 9.24 0 12S2.24 17 5 17C7.5 17 9.56 15.15 9.92 12.75H12.5L15.29 6.43L16.08 7.96C14.82 8.87 14 10.34 14 12C14 14.76 16.24 17 19 17S24 14.76 24 12 21.76 7 19 7M5 15.5C3.07 15.5 1.5 13.93 1.5 12S3.07 8.5 5 8.5C6.67 8.5 8.07 9.68 8.41 11.25H4V12.75H8.41C8.07 14.32 6.67 15.5 5 15.5M19 15.5C17.07 15.5 15.5 13.93 15.5 12C15.5 10.92 16 9.97 16.77 9.33L18.57 12.85L19.89 12.13L18.1 8.63C18.39 8.56 18.69 8.5 19 8.5C20.93 8.5 22.5 10.07 22.5 12S20.93 15.5 19 15.5M11 20H7L13 23V21H17L11 18V20Z";
var mdiBicyclePennyFarthing = "M15.5 5.06V2H12V4H13.5V5.04C12.71 5.11 11.94 5.27 11.2 5.5C11.03 5.2 10.72 5 10.36 5H7C6.45 5 6 5.45 6 6S6.45 7 7 7H8.05C5.09 9 3.12 12.36 3 16.18C1.85 16.59 1 17.69 1 19C1 20.66 2.34 22 4 22S7 20.66 7 19C7 17.7 6.17 16.61 5 16.19C5.07 14.67 5.46 13.25 6.14 12C6.05 12.5 6 13 6 13.5C6 18.19 9.81 22 14.5 22C19.19 22 23 18.19 23 13.5C23 9.14 19.72 5.56 15.5 5.06M4 20C3.45 20 3 19.55 3 19S3.45 18 4 18 5 18.45 5 19 4.55 20 4 20M14.5 20C10.92 20 8 17.08 8 13.5C8 10.26 10.39 7.57 13.5 7.09V15H15.5V7.09C18.61 7.57 21 10.26 21 13.5C21 17.08 18.08 20 14.5 20Z";
var mdiBike = "M5,20.5A3.5,3.5 0 0,1 1.5,17A3.5,3.5 0 0,1 5,13.5A3.5,3.5 0 0,1 8.5,17A3.5,3.5 0 0,1 5,20.5M5,12A5,5 0 0,0 0,17A5,5 0 0,0 5,22A5,5 0 0,0 10,17A5,5 0 0,0 5,12M14.8,10H19V8.2H15.8L13.86,4.93C13.57,4.43 13,4.1 12.4,4.1C11.93,4.1 11.5,4.29 11.2,4.6L7.5,8.29C7.19,8.6 7,9 7,9.5C7,10.13 7.33,10.66 7.85,10.97L11.2,13V18H13V11.5L10.75,9.85L13.07,7.5M19,20.5A3.5,3.5 0 0,1 15.5,17A3.5,3.5 0 0,1 19,13.5A3.5,3.5 0 0,1 22.5,17A3.5,3.5 0 0,1 19,20.5M19,12A5,5 0 0,0 14,17A5,5 0 0,0 19,22A5,5 0 0,0 24,17A5,5 0 0,0 19,12M16,4.8C17,4.8 17.8,4 17.8,3C17.8,2 17,1.2 16,1.2C15,1.2 14.2,2 14.2,3C14.2,4 15,4.8 16,4.8Z";
var mdiBikeFast = "M16 1.2C15 1.2 14.2 2 14.2 3S15 4.8 16 4.8 17.8 4 17.8 3 17 1.2 16 1.2M12.4 4.1C11.93 4.1 11.5 4.29 11.2 4.6L7.5 8.29C7.19 8.6 7 9 7 9.5C7 10.13 7.33 10.66 7.85 10.97L11.2 13V18H13V11.5L10.75 9.85L13.07 7.5L14.8 10H19V8.2H15.8L13.86 4.93C13.57 4.43 13 4.1 12.4 4.1M10 3H3C2.45 3 2 2.55 2 2S2.45 1 3 1H12.79C12.58 1.34 12.41 1.71 12.32 2.11C11.46 2.13 10.65 2.45 10 3M5 12C2.24 12 0 14.24 0 17S2.24 22 5 22 10 19.76 10 17 7.76 12 5 12M5 20.5C3.07 20.5 1.5 18.93 1.5 17S3.07 13.5 5 13.5 8.5 15.07 8.5 17 6.93 20.5 5 20.5M19 12C16.24 12 14 14.24 14 17S16.24 22 19 22 24 19.76 24 17 21.76 12 19 12M19 20.5C17.07 20.5 15.5 18.93 15.5 17S17.07 13.5 19 13.5 22.5 15.07 22.5 17 20.93 20.5 19 20.5M5.32 11H1C.448 11 0 10.55 0 10S.448 9 1 9H5.05C5.03 9.16 5 9.33 5 9.5C5 10.03 5.12 10.54 5.32 11M6 7H2C1.45 7 1 6.55 1 6S1.45 5 2 5H7.97L6.09 6.87C6.05 6.91 6 6.96 6 7Z";
var mdiBikePedal = "M6.85 5C5.87 5 5.04 5.71 4.87 6.67L4 12L4.87 17.33C5.04 18.29 5.87 19 6.85 19H14.15C15.13 19 15.97 18.29 16.13 17.33L16.68 14H18V13H20V11H18V10H16.68L16.13 6.67C15.97 5.71 15.13 5 14.15 5H6.85M6.85 7H14.15L14.82 11H6.18L6.85 7M6.18 13H14.82L14.15 17H6.85L6.18 13Z";
var mdiBikePedalClipless = "M14.43 16.11L15.28 14H16V13H20V11H16V10H15.28L14.43 7.89C14 6.75 12.87 6 11.65 6H9.35C8.13 6 7 6.75 6.57 7.89L5.37 10.89C5.08 11.6 5.08 12.4 5.37 13.11L6.57 16.11C7 17.25 8.13 18 9.35 18H11.65C12.87 18 14 17.25 14.43 16.11M9.35 8H11.65C12.06 8 12.42 8.25 12.57 8.63L13.12 10H7.88L8.43 8.63C8.58 8.25 8.95 8 9.35 8M8.43 15.37L7.88 14H13.12L12.57 15.37C12.42 15.75 12.05 16 11.65 16H9.35C8.95 16 8.58 15.75 8.43 15.37Z";
var mdiBikePedalMountain = "M6.82 5C5.87 5 5.05 5.67 4.86 6.61L4.04 10.71C4 10.84 4 10.97 4 11.1V12.9C4 13.03 4 13.16 4.04 13.29L4.86 17.39C5.05 18.33 5.87 19 6.82 19H13.38C14.14 19 14.83 18.57 15.17 17.89L16.79 14.66C16.89 14.45 16.96 14.23 17 14H18V13H20V11H18V10H17C16.96 9.77 16.89 9.55 16.79 9.34L15.17 6.11C14.83 5.43 14.14 5 13.38 5H6.82M6.82 7H7.38L9.88 12L7.38 17H6.82L6 12.9V11.1L6.82 7M11.62 11L9.62 7H13.38L15 10.24V11H11.62M11.62 13H15V13.76L13.38 17H9.62L11.62 13Z";
var mdiBillboard = "M20 22H18V17H20M6 22H4V17H6M23 4V13A2 2 0 0 1 21 15H3A2 2 0 0 1 1 13V4A2 2 0 0 1 3 2H21A2 2 0 0 1 23 4M21 4H3V13H21M20 6H15V8H20M18 9H15V11H18M14 11H4L6.73 7.36L8.73 10.09L9.46 9.55L8.2 7.82L9.91 5.55Z";
var mdiBilliards = "M11,13H13V15H11M11,9H13V11H11M11,17H13A2,2 0 0,0 15,15V13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 15,10.5V9A2,2 0 0,0 13,7H11A2,2 0 0,0 9,9V10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 9,13.5V15A2,2 0 0,0 11,17M12,1C5.92,1 1,5.92 1,12C1,18.08 5.92,23 12,23C18.08,23 23,18.08 23,12C23,5.92 18.08,1 12,1M12,19A7,7 0 0,1 5,12A7,7 0 0,1 12,5A7,7 0 0,1 19,12A7,7 0 0,1 12,19Z";
var mdiBilliardsRack = "M20.31,16.44L14.54,6.47C13.72,5.04 11.89,4.55 10.46,5.38C10,5.64 9.63,6 9.36,6.47L3.6,16.44C2.77,17.87 3.26,19.69 4.69,20.5C5.14,20.78 5.65,20.92 6.18,20.92H17.73C19.38,20.91 20.72,19.57 20.71,17.92C20.71,17.4 20.57,16.89 20.31,16.44M5.37,17.43L11.11,7.47C11.38,7 12,6.82 12.46,7.1C12.62,7.18 12.75,7.31 12.84,7.47L18.58,17.43C18.85,17.91 18.69,18.5 18.21,18.79C18.06,18.88 17.89,18.93 17.72,18.93H6.21C5.66,18.92 5.21,18.47 5.22,17.92C5.22,17.75 5.26,17.58 5.35,17.43H5.37M11.97,13.45C10.87,13.45 10,12.56 10,11.46C10,10.35 10.87,9.46 11.97,9.46A2,2 0 0,1 13.97,11.46C13.97,12.56 13.07,13.45 11.95,13.45H11.97M9.46,17.93C8.36,17.93 7.47,17.04 7.47,15.94C7.47,14.84 8.36,13.95 9.46,13.95C10.56,13.95 11.46,14.84 11.46,15.94C11.46,17.04 10.56,17.93 9.46,17.93M14.44,17.93A2,2 0 0,1 12.45,15.94A2,2 0 0,1 14.44,13.95C15.54,13.95 16.44,14.84 16.44,15.94C16.44,17.04 15.54,17.93 14.44,17.93Z";
var mdiBinoculars = "M11,6H13V13H11V6M9,20A1,1 0 0,1 8,21H5A1,1 0 0,1 4,20V15L6,6H10V13A1,1 0 0,1 9,14V20M10,5H7V3H10V5M15,20V14A1,1 0 0,1 14,13V6H18L20,15V20A1,1 0 0,1 19,21H16A1,1 0 0,1 15,20M14,5V3H17V5H14Z";
var mdiBio = "M17,12H20A2,2 0 0,1 22,14V17A2,2 0 0,1 20,19H17A2,2 0 0,1 15,17V14A2,2 0 0,1 17,12M17,14V17H20V14H17M2,7H7A2,2 0 0,1 9,9V11A2,2 0 0,1 7,13A2,2 0 0,1 9,15V17A2,2 0 0,1 7,19H2V13L2,7M4,9V12H7V9H4M4,17H7V14H4V17M11,13H13V19H11V13M11,9H13V11H11V9Z";
var mdiBiohazard = "M23,16.06C23,16.29 23,16.5 22.96,16.7C22.78,14.14 20.64,12.11 18,12.11C17.63,12.11 17.27,12.16 16.92,12.23C16.96,12.5 17,12.73 17,13C17,15.35 15.31,17.32 13.07,17.81C13.42,20.05 15.31,21.79 17.65,21.96C17.43,22 17.22,22 17,22C14.92,22 13.07,20.94 12,19.34C10.93,20.94 9.09,22 7,22C6.78,22 6.57,22 6.35,21.96C8.69,21.79 10.57,20.06 10.93,17.81C8.68,17.32 7,15.35 7,13C7,12.73 7.04,12.5 7.07,12.23C6.73,12.16 6.37,12.11 6,12.11C3.36,12.11 1.22,14.14 1.03,16.7C1,16.5 1,16.29 1,16.06C1,12.85 3.59,10.24 6.81,10.14C6.3,9.27 6,8.25 6,7.17C6,4.94 7.23,3 9.06,2C7.81,2.9 7,4.34 7,6C7,7.35 7.56,8.59 8.47,9.5C9.38,8.59 10.62,8.04 12,8.04C13.37,8.04 14.62,8.59 15.5,9.5C16.43,8.59 17,7.35 17,6C17,4.34 16.18,2.9 14.94,2C16.77,3 18,4.94 18,7.17C18,8.25 17.7,9.27 17.19,10.14C20.42,10.24 23,12.85 23,16.06M9.27,10.11C10.05,10.62 11,10.92 12,10.92C13,10.92 13.95,10.62 14.73,10.11C14,9.45 13.06,9.03 12,9.03C10.94,9.03 10,9.45 9.27,10.11M12,14.47C12.82,14.47 13.5,13.8 13.5,13A1.5,1.5 0 0,0 12,11.5A1.5,1.5 0 0,0 10.5,13C10.5,13.8 11.17,14.47 12,14.47M10.97,16.79C10.87,14.9 9.71,13.29 8.05,12.55C8.03,12.7 8,12.84 8,13C8,14.82 9.27,16.34 10.97,16.79M15.96,12.55C14.29,13.29 13.12,14.9 13,16.79C14.73,16.34 16,14.82 16,13C16,12.84 15.97,12.7 15.96,12.55Z";
var mdiBird = "M23 11.5L19.95 10.37C19.69 9.22 19.04 8.56 19.04 8.56C17.4 6.92 14.75 6.92 13.11 8.56L11.63 10.04L5 3C4 7 5 11 7.45 14.22L2 19.5C2 19.5 10.89 21.5 16.07 17.45C18.83 15.29 19.45 14.03 19.84 12.7L23 11.5M17.71 11.72C17.32 12.11 16.68 12.11 16.29 11.72C15.9 11.33 15.9 10.7 16.29 10.31C16.68 9.92 17.32 9.92 17.71 10.31C18.1 10.7 18.1 11.33 17.71 11.72Z";
var mdiBitbucket = "M2.65 3C2.3 3 2 3.3 2 3.65C2 3.69 2 3.73 2 3.77L4.73 20.27C4.8 20.69 5.16 21 5.58 21H18.63C18.94 21 19.22 20.78 19.27 20.46L22 3.77C22.05 3.42 21.81 3.09 21.46 3.04C21.43 3.03 21.39 3.03 21.35 3.03L2.65 3M14.1 14.95H9.94L8.81 9.07H15.11L14.1 14.95Z";
var mdiBitcoin = "M14.24 10.56C13.93 11.8 12 11.17 11.4 11L11.95 8.82C12.57 9 14.56 9.26 14.24 10.56M11.13 12.12L10.53 14.53C11.27 14.72 13.56 15.45 13.9 14.09C14.26 12.67 11.87 12.3 11.13 12.12M21.7 14.42C20.36 19.78 14.94 23.04 9.58 21.7C4.22 20.36 .963 14.94 2.3 9.58C3.64 4.22 9.06 .964 14.42 2.3C19.77 3.64 23.03 9.06 21.7 14.42M14.21 8.05L14.66 6.25L13.56 6L13.12 7.73C12.83 7.66 12.54 7.59 12.24 7.53L12.68 5.76L11.59 5.5L11.14 7.29C10.9 7.23 10.66 7.18 10.44 7.12L10.44 7.12L8.93 6.74L8.63 7.91C8.63 7.91 9.45 8.1 9.43 8.11C9.88 8.22 9.96 8.5 9.94 8.75L8.71 13.68C8.66 13.82 8.5 14 8.21 13.95C8.22 13.96 7.41 13.75 7.41 13.75L6.87 15L8.29 15.36C8.56 15.43 8.82 15.5 9.08 15.56L8.62 17.38L9.72 17.66L10.17 15.85C10.47 15.93 10.76 16 11.04 16.08L10.59 17.87L11.69 18.15L12.15 16.33C14 16.68 15.42 16.54 16 14.85C16.5 13.5 16 12.7 15 12.19C15.72 12 16.26 11.55 16.41 10.57C16.61 9.24 15.59 8.53 14.21 8.05Z";
var mdiBlackMesa = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,14.39 5.05,16.53 6.71,18H9V12H17L19.15,15.59C19.69,14.5 20,13.29 20,12A8,8 0 0,0 12,4Z";
var mdiBlender = "M16.13 15.13L18 3H14V2H10V3H5C3.9 3 3 3.9 3 5V9C3 10.1 3.9 11 5 11H7.23L7.87 15.13C6.74 16.05 6 17.43 6 19V20C6 21.1 6.9 22 8 22H16C17.1 22 18 21.1 18 20V19C18 17.43 17.26 16.05 16.13 15.13M5 9V5H6.31L6.93 9H5M12 19C11.45 19 11 18.55 11 18S11.45 17 12 17 13 17.45 13 18 12.55 19 12 19M14.29 14H9.72L8.33 5H15.67L14.29 14Z";
var mdiBlenderOutline = "M16.13 15.13L18 3H14V2H10V3H5C3.9 3 3 3.9 3 5V9C3 10.1 3.9 11 5 11H7.23L7.87 15.13C6.74 16.05 6 17.43 6 19V20C6 21.1 6.9 22 8 22H16C17.1 22 18 21.1 18 20V19C18 17.43 17.26 16.05 16.13 15.13M5 9V5H6.31L6.93 9H5M15.67 5L14.29 14H9.72L8.33 5H15.67M16 20H8V19C8 17.35 9.35 16 11 16H13C14.65 16 16 17.35 16 19V20M12 17C12.55 17 13 17.45 13 18S12.55 19 12 19 11 18.55 11 18 11.45 17 12 17Z";
var mdiBlenderSoftware = "M12.58,3.12V3.13C12.27,3.13 11.96,3.22 11.71,3.39C11.21,3.74 11.15,4.32 11.6,4.69L14.46,7L5.73,7.03H5.72C5,7.03 4.3,7.5 4.16,8.1C4,8.71 4.5,9.22 5.26,9.22L9.69,9.21L1.76,15.3C1,15.87 0.77,16.82 1.24,17.42C1.72,18.03 2.73,18.03 3.5,17.42L7.8,13.89C7.8,13.89 7.73,14.37 7.74,14.65C7.74,14.94 7.84,15.5 7.97,15.93C8.26,16.86 8.75,17.71 9.43,18.46C10.13,19.23 11,19.85 12,20.29C13.03,20.76 14.17,21 15.34,21C16.5,21 17.65,20.75 18.69,20.28C19.69,19.84 20.55,19.21 21.25,18.44C21.93,17.69 22.42,16.83 22.71,15.91C22.85,15.44 22.94,14.97 23,14.5C23,14.03 23,13.56 22.94,13.09C22.81,12.18 22.5,11.32 22,10.54C21.56,9.83 21,9.2 20.31,8.67V8.67L13.42,3.38C13.19,3.21 12.89,3.12 12.58,3.12M15.34,9.21C16.5,9.21 17.59,9.59 18.46,10.29C18.9,10.65 19.25,11.07 19.5,11.54C19.77,12 19.94,12.55 20,13.11C20.04,13.67 19.96,14.23 19.77,14.77C19.57,15.31 19.25,15.81 18.82,16.26C17.93,17.16 16.69,17.68 15.34,17.68C14,17.68 12.75,17.17 11.86,16.27C11.43,15.83 11.11,15.32 10.91,14.78C10.72,14.25 10.64,13.69 10.69,13.12C10.74,12.56 10.91,12.03 11.17,11.55C11.43,11.08 11.79,10.66 12.23,10.3C13.09,9.59 14.19,9.21 15.34,9.21M15.44,10.61C14.66,10.61 13.94,10.89 13.41,11.34C12.87,11.8 12.5,12.44 12.47,13.18C12.43,13.93 12.73,14.63 13.26,15.15C13.8,15.68 14.58,16 15.44,16C16.3,16 17.07,15.68 17.62,15.15C18.15,14.63 18.45,13.93 18.41,13.18C18.37,12.44 18,11.8 17.47,11.34C16.94,10.89 16.22,10.61 15.44,10.61Z";
var mdiBlinds = "M3,2H21A1,1 0 0,1 22,3V5A1,1 0 0,1 21,6H20V13A1,1 0 0,1 19,14H13V16.17C14.17,16.58 15,17.69 15,19A3,3 0 0,1 12,22A3,3 0 0,1 9,19C9,17.69 9.83,16.58 11,16.17V14H5A1,1 0 0,1 4,13V6H3A1,1 0 0,1 2,5V3A1,1 0 0,1 3,2M12,18A1,1 0 0,0 11,19A1,1 0 0,0 12,20A1,1 0 0,0 13,19A1,1 0 0,0 12,18Z";
var mdiBlindsHorizontal = "M20 19V3H4V19H2V21H22V19H20M16 9H18V11H16V9M14 11H6V9H14V11M18 7H16V5H18V7M14 5V7H6V5H14M6 19V13H14V14.82C13.55 15.14 13.25 15.66 13.25 16.25C13.25 17.22 14.03 18 15 18S16.75 17.22 16.75 16.25C16.75 15.66 16.45 15.13 16 14.82V13H18V19H6Z";
var mdiBlindsHorizontalClosed = "M20 19V3H4V19H2V21H13.25C13.25 21.97 14.03 22.75 15 22.75S16.75 21.97 16.75 21H22V19H20M18 11H16V9H18V11M14 11H6V9H14V11M14 13V15H6V13H14M16 13H18V15H16V13M18 7H16V5H18V7M14 5V7H6V5H14M6 19V17H14V19H6M16 19V17H18V19H16Z";
var mdiBlindsOpen = "M3 2H21C21.55 2 22 2.45 22 3V5C22 5.55 21.55 6 21 6H20V7C20 7.55 19.55 8 19 8H13V10.17C14.17 10.58 15 11.7 15 13C15 14.66 13.66 16 12 16C10.34 16 9 14.66 9 13C9 11.69 9.84 10.58 11 10.17V8H5C4.45 8 4 7.55 4 7V6H3C2.45 6 2 5.55 2 5V3C2 2.45 2.45 2 3 2M12 12C11.45 12 11 12.45 11 13C11 13.55 11.45 14 12 14C12.55 14 13 13.55 13 13C13 12.45 12.55 12 12 12Z";
var mdiBlindsVertical = "M20 19V3H4V19H2V21H22V19H20M10 19V5H14V19H10Z";
var mdiBlindsVerticalClosed = "M20 19V3H4V19H2V21H22V19H20M13 5H14.5V19H13V5M11 19H9.5V5H11V19M6 5H7.5V19H6V5M16.5 19V5H18V19H16.5Z";
var mdiBlockHelper = "M12,0A12,12 0 0,1 24,12A12,12 0 0,1 12,24A12,12 0 0,1 0,12A12,12 0 0,1 12,0M12,2A10,10 0 0,0 2,12C2,14.4 2.85,16.6 4.26,18.33L18.33,4.26C16.6,2.85 14.4,2 12,2M12,22A10,10 0 0,0 22,12C22,9.6 21.15,7.4 19.74,5.67L5.67,19.74C7.4,21.15 9.6,22 12,22Z";
var mdiBloodBag = "M21,7C20,7 20,6 20,6V5H18V7H16V6C16,4.27 14.75,1 10,1C5.25,1 4,4.27 4,6V19C4,19.33 3.9,21 2,21V23C4.93,23 6,20.61 6,19V6C6,5.88 6.05,3 10,3C13.83,3 14,5.7 14,6V7H12V5H10V6C10,6 10,7 9,7C8,7 8,8 8,8V20C8,20 8,22 13,22C13.24,22 14.13,22 17,22C22,22 22,20 22,20V8C22,8 22,7 21,7M15,19.4A3,3 0 0,1 12,16.4C12,14.4 15,11 15,11C15,11 18,14.4 18,16.4A3,3 0 0,1 15,19.4Z";
var mdiBluetooth = "M14.88,16.29L13,18.17V14.41M13,5.83L14.88,7.71L13,9.58M17.71,7.71L12,2H11V9.58L6.41,5L5,6.41L10.59,12L5,17.58L6.41,19L11,14.41V22H12L17.71,16.29L13.41,12L17.71,7.71Z";
var mdiBluetoothAudio = "M12.88,16.29L11,18.17V14.41M11,5.83L12.88,7.71L11,9.58M15.71,7.71L10,2H9V9.58L4.41,5L3,6.41L8.59,12L3,17.58L4.41,19L9,14.41V22H10L15.71,16.29L11.41,12M19.53,6.71L18.26,8C18.89,9.18 19.25,10.55 19.25,12C19.25,13.45 18.89,14.82 18.26,16L19.46,17.22C20.43,15.68 21,13.87 21,11.91C21,10 20.46,8.23 19.53,6.71M14.24,12L16.56,14.33C16.84,13.6 17,12.82 17,12C17,11.18 16.84,10.4 16.57,9.68L14.24,12Z";
var mdiBluetoothConnect = "M19,10L17,12L19,14L21,12M14.88,16.29L13,18.17V14.41M13,5.83L14.88,7.71L13,9.58M17.71,7.71L12,2H11V9.58L6.41,5L5,6.41L10.59,12L5,17.58L6.41,19L11,14.41V22H12L17.71,16.29L13.41,12M7,12L5,10L3,12L5,14L7,12Z";
var mdiBluetoothOff = "M13,5.83L14.88,7.71L13.28,9.31L14.69,10.72L17.71,7.7L12,2H11V7.03L13,9.03M5.41,4L4,5.41L10.59,12L5,17.59L6.41,19L11,14.41V22H12L16.29,17.71L18.59,20L20,18.59M13,18.17V14.41L14.88,16.29";
var mdiBluetoothSettings = "M14.88,14.29L13,16.17V12.41L14.88,14.29M13,3.83L14.88,5.71L13,7.59M17.71,5.71L12,0H11V7.59L6.41,3L5,4.41L10.59,10L5,15.59L6.41,17L11,12.41V20H12L17.71,14.29L13.41,10L17.71,5.71M15,24H17V22H15M7,24H9V22H7M11,24H13V22H11V24Z";
var mdiBluetoothTransfer = "M14.71,7.71L10.41,12L14.71,16.29L9,22H8V14.41L3.41,19L2,17.59L7.59,12L2,6.41L3.41,5L8,9.59V2H9L14.71,7.71M10,5.83V9.59L11.88,7.71L10,5.83M11.88,16.29L10,14.41V18.17L11.88,16.29M22,8H20V11H18V8H16L19,4L22,8M22,16L19,20L16,16H18V13H20V16H22Z";
var mdiBlur = "M14,8.5A1.5,1.5 0 0,0 12.5,10A1.5,1.5 0 0,0 14,11.5A1.5,1.5 0 0,0 15.5,10A1.5,1.5 0 0,0 14,8.5M14,12.5A1.5,1.5 0 0,0 12.5,14A1.5,1.5 0 0,0 14,15.5A1.5,1.5 0 0,0 15.5,14A1.5,1.5 0 0,0 14,12.5M10,17A1,1 0 0,0 9,18A1,1 0 0,0 10,19A1,1 0 0,0 11,18A1,1 0 0,0 10,17M10,8.5A1.5,1.5 0 0,0 8.5,10A1.5,1.5 0 0,0 10,11.5A1.5,1.5 0 0,0 11.5,10A1.5,1.5 0 0,0 10,8.5M14,20.5A0.5,0.5 0 0,0 13.5,21A0.5,0.5 0 0,0 14,21.5A0.5,0.5 0 0,0 14.5,21A0.5,0.5 0 0,0 14,20.5M14,17A1,1 0 0,0 13,18A1,1 0 0,0 14,19A1,1 0 0,0 15,18A1,1 0 0,0 14,17M21,13.5A0.5,0.5 0 0,0 20.5,14A0.5,0.5 0 0,0 21,14.5A0.5,0.5 0 0,0 21.5,14A0.5,0.5 0 0,0 21,13.5M18,5A1,1 0 0,0 17,6A1,1 0 0,0 18,7A1,1 0 0,0 19,6A1,1 0 0,0 18,5M18,9A1,1 0 0,0 17,10A1,1 0 0,0 18,11A1,1 0 0,0 19,10A1,1 0 0,0 18,9M18,17A1,1 0 0,0 17,18A1,1 0 0,0 18,19A1,1 0 0,0 19,18A1,1 0 0,0 18,17M18,13A1,1 0 0,0 17,14A1,1 0 0,0 18,15A1,1 0 0,0 19,14A1,1 0 0,0 18,13M10,12.5A1.5,1.5 0 0,0 8.5,14A1.5,1.5 0 0,0 10,15.5A1.5,1.5 0 0,0 11.5,14A1.5,1.5 0 0,0 10,12.5M10,7A1,1 0 0,0 11,6A1,1 0 0,0 10,5A1,1 0 0,0 9,6A1,1 0 0,0 10,7M10,3.5A0.5,0.5 0 0,0 10.5,3A0.5,0.5 0 0,0 10,2.5A0.5,0.5 0 0,0 9.5,3A0.5,0.5 0 0,0 10,3.5M10,20.5A0.5,0.5 0 0,0 9.5,21A0.5,0.5 0 0,0 10,21.5A0.5,0.5 0 0,0 10.5,21A0.5,0.5 0 0,0 10,20.5M3,13.5A0.5,0.5 0 0,0 2.5,14A0.5,0.5 0 0,0 3,14.5A0.5,0.5 0 0,0 3.5,14A0.5,0.5 0 0,0 3,13.5M14,3.5A0.5,0.5 0 0,0 14.5,3A0.5,0.5 0 0,0 14,2.5A0.5,0.5 0 0,0 13.5,3A0.5,0.5 0 0,0 14,3.5M14,7A1,1 0 0,0 15,6A1,1 0 0,0 14,5A1,1 0 0,0 13,6A1,1 0 0,0 14,7M21,10.5A0.5,0.5 0 0,0 21.5,10A0.5,0.5 0 0,0 21,9.5A0.5,0.5 0 0,0 20.5,10A0.5,0.5 0 0,0 21,10.5M6,5A1,1 0 0,0 5,6A1,1 0 0,0 6,7A1,1 0 0,0 7,6A1,1 0 0,0 6,5M3,9.5A0.5,0.5 0 0,0 2.5,10A0.5,0.5 0 0,0 3,10.5A0.5,0.5 0 0,0 3.5,10A0.5,0.5 0 0,0 3,9.5M6,9A1,1 0 0,0 5,10A1,1 0 0,0 6,11A1,1 0 0,0 7,10A1,1 0 0,0 6,9M6,17A1,1 0 0,0 5,18A1,1 0 0,0 6,19A1,1 0 0,0 7,18A1,1 0 0,0 6,17M6,13A1,1 0 0,0 5,14A1,1 0 0,0 6,15A1,1 0 0,0 7,14A1,1 0 0,0 6,13Z";
var mdiBlurLinear = "M13,17A1,1 0 0,0 14,16A1,1 0 0,0 13,15A1,1 0 0,0 12,16A1,1 0 0,0 13,17M13,13A1,1 0 0,0 14,12A1,1 0 0,0 13,11A1,1 0 0,0 12,12A1,1 0 0,0 13,13M13,9A1,1 0 0,0 14,8A1,1 0 0,0 13,7A1,1 0 0,0 12,8A1,1 0 0,0 13,9M17,12.5A0.5,0.5 0 0,0 17.5,12A0.5,0.5 0 0,0 17,11.5A0.5,0.5 0 0,0 16.5,12A0.5,0.5 0 0,0 17,12.5M17,8.5A0.5,0.5 0 0,0 17.5,8A0.5,0.5 0 0,0 17,7.5A0.5,0.5 0 0,0 16.5,8A0.5,0.5 0 0,0 17,8.5M3,3V5H21V3M17,16.5A0.5,0.5 0 0,0 17.5,16A0.5,0.5 0 0,0 17,15.5A0.5,0.5 0 0,0 16.5,16A0.5,0.5 0 0,0 17,16.5M9,17A1,1 0 0,0 10,16A1,1 0 0,0 9,15A1,1 0 0,0 8,16A1,1 0 0,0 9,17M5,13.5A1.5,1.5 0 0,0 6.5,12A1.5,1.5 0 0,0 5,10.5A1.5,1.5 0 0,0 3.5,12A1.5,1.5 0 0,0 5,13.5M5,9.5A1.5,1.5 0 0,0 6.5,8A1.5,1.5 0 0,0 5,6.5A1.5,1.5 0 0,0 3.5,8A1.5,1.5 0 0,0 5,9.5M3,21H21V19H3M9,9A1,1 0 0,0 10,8A1,1 0 0,0 9,7A1,1 0 0,0 8,8A1,1 0 0,0 9,9M9,13A1,1 0 0,0 10,12A1,1 0 0,0 9,11A1,1 0 0,0 8,12A1,1 0 0,0 9,13M5,17.5A1.5,1.5 0 0,0 6.5,16A1.5,1.5 0 0,0 5,14.5A1.5,1.5 0 0,0 3.5,16A1.5,1.5 0 0,0 5,17.5Z";
var mdiBlurOff = "M3,13.5A0.5,0.5 0 0,0 2.5,14A0.5,0.5 0 0,0 3,14.5A0.5,0.5 0 0,0 3.5,14A0.5,0.5 0 0,0 3,13.5M6,17A1,1 0 0,0 5,18A1,1 0 0,0 6,19A1,1 0 0,0 7,18A1,1 0 0,0 6,17M10,20.5A0.5,0.5 0 0,0 9.5,21A0.5,0.5 0 0,0 10,21.5A0.5,0.5 0 0,0 10.5,21A0.5,0.5 0 0,0 10,20.5M3,9.5A0.5,0.5 0 0,0 2.5,10A0.5,0.5 0 0,0 3,10.5A0.5,0.5 0 0,0 3.5,10A0.5,0.5 0 0,0 3,9.5M6,13A1,1 0 0,0 5,14A1,1 0 0,0 6,15A1,1 0 0,0 7,14A1,1 0 0,0 6,13M21,13.5A0.5,0.5 0 0,0 20.5,14A0.5,0.5 0 0,0 21,14.5A0.5,0.5 0 0,0 21.5,14A0.5,0.5 0 0,0 21,13.5M10,17A1,1 0 0,0 9,18A1,1 0 0,0 10,19A1,1 0 0,0 11,18A1,1 0 0,0 10,17M2.5,5.27L6.28,9.05L6,9A1,1 0 0,0 5,10A1,1 0 0,0 6,11A1,1 0 0,0 7,10C7,9.9 6.97,9.81 6.94,9.72L9.75,12.53C9.04,12.64 8.5,13.26 8.5,14A1.5,1.5 0 0,0 10,15.5C10.74,15.5 11.36,14.96 11.47,14.25L14.28,17.06C14.19,17.03 14.1,17 14,17A1,1 0 0,0 13,18A1,1 0 0,0 14,19A1,1 0 0,0 15,18C15,17.9 14.97,17.81 14.94,17.72L18.72,21.5L20,20.23L3.77,4L2.5,5.27M14,20.5A0.5,0.5 0 0,0 13.5,21A0.5,0.5 0 0,0 14,21.5A0.5,0.5 0 0,0 14.5,21A0.5,0.5 0 0,0 14,20.5M18,7A1,1 0 0,0 19,6A1,1 0 0,0 18,5A1,1 0 0,0 17,6A1,1 0 0,0 18,7M18,11A1,1 0 0,0 19,10A1,1 0 0,0 18,9A1,1 0 0,0 17,10A1,1 0 0,0 18,11M18,15A1,1 0 0,0 19,14A1,1 0 0,0 18,13A1,1 0 0,0 17,14A1,1 0 0,0 18,15M10,7A1,1 0 0,0 11,6A1,1 0 0,0 10,5A1,1 0 0,0 9,6A1,1 0 0,0 10,7M21,10.5A0.5,0.5 0 0,0 21.5,10A0.5,0.5 0 0,0 21,9.5A0.5,0.5 0 0,0 20.5,10A0.5,0.5 0 0,0 21,10.5M10,3.5A0.5,0.5 0 0,0 10.5,3A0.5,0.5 0 0,0 10,2.5A0.5,0.5 0 0,0 9.5,3A0.5,0.5 0 0,0 10,3.5M14,3.5A0.5,0.5 0 0,0 14.5,3A0.5,0.5 0 0,0 14,2.5A0.5,0.5 0 0,0 13.5,3A0.5,0.5 0 0,0 14,3.5M13.8,11.5H14A1.5,1.5 0 0,0 15.5,10A1.5,1.5 0 0,0 14,8.5A1.5,1.5 0 0,0 12.5,10V10.2C12.61,10.87 13.13,11.39 13.8,11.5M14,7A1,1 0 0,0 15,6A1,1 0 0,0 14,5A1,1 0 0,0 13,6A1,1 0 0,0 14,7Z";
var mdiBlurRadial = "M14,13A1,1 0 0,0 13,14A1,1 0 0,0 14,15A1,1 0 0,0 15,14A1,1 0 0,0 14,13M14,16.5A0.5,0.5 0 0,0 13.5,17A0.5,0.5 0 0,0 14,17.5A0.5,0.5 0 0,0 14.5,17A0.5,0.5 0 0,0 14,16.5M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M17,9.5A0.5,0.5 0 0,0 16.5,10A0.5,0.5 0 0,0 17,10.5A0.5,0.5 0 0,0 17.5,10A0.5,0.5 0 0,0 17,9.5M17,13.5A0.5,0.5 0 0,0 16.5,14A0.5,0.5 0 0,0 17,14.5A0.5,0.5 0 0,0 17.5,14A0.5,0.5 0 0,0 17,13.5M14,7.5A0.5,0.5 0 0,0 14.5,7A0.5,0.5 0 0,0 14,6.5A0.5,0.5 0 0,0 13.5,7A0.5,0.5 0 0,0 14,7.5M14,9A1,1 0 0,0 13,10A1,1 0 0,0 14,11A1,1 0 0,0 15,10A1,1 0 0,0 14,9M10,7.5A0.5,0.5 0 0,0 10.5,7A0.5,0.5 0 0,0 10,6.5A0.5,0.5 0 0,0 9.5,7A0.5,0.5 0 0,0 10,7.5M7,13.5A0.5,0.5 0 0,0 6.5,14A0.5,0.5 0 0,0 7,14.5A0.5,0.5 0 0,0 7.5,14A0.5,0.5 0 0,0 7,13.5M10,16.5A0.5,0.5 0 0,0 9.5,17A0.5,0.5 0 0,0 10,17.5A0.5,0.5 0 0,0 10.5,17A0.5,0.5 0 0,0 10,16.5M7,9.5A0.5,0.5 0 0,0 6.5,10A0.5,0.5 0 0,0 7,10.5A0.5,0.5 0 0,0 7.5,10A0.5,0.5 0 0,0 7,9.5M10,13A1,1 0 0,0 9,14A1,1 0 0,0 10,15A1,1 0 0,0 11,14A1,1 0 0,0 10,13M10,9A1,1 0 0,0 9,10A1,1 0 0,0 10,11A1,1 0 0,0 11,10A1,1 0 0,0 10,9Z";
var mdiBolt = "M14,17.7V21H10V20.3L14,17.7M17,3H7V6H17V3M15,7L14,7.7V7H10V10.3L9,11V12L15,8.1V7M15,11L14,11.7V9.7L10,12.4V14.4L9,15V16L15,12.1V11M15,15L14,15.7V13.7L10,16.4V18.4L9,19V20L15,16.1V15Z";
var mdiBomb = "M11.25,6A3.25,3.25 0 0,1 14.5,2.75A3.25,3.25 0 0,1 17.75,6C17.75,6.42 18.08,6.75 18.5,6.75C18.92,6.75 19.25,6.42 19.25,6V5.25H20.75V6A2.25,2.25 0 0,1 18.5,8.25A2.25,2.25 0 0,1 16.25,6A1.75,1.75 0 0,0 14.5,4.25A1.75,1.75 0 0,0 12.75,6H14V7.29C16.89,8.15 19,10.83 19,14A7,7 0 0,1 12,21A7,7 0 0,1 5,14C5,10.83 7.11,8.15 10,7.29V6H11.25M22,6H24V7H22V6M19,4V2H20V4H19M20.91,4.38L22.33,2.96L23.04,3.67L21.62,5.09L20.91,4.38Z";
var mdiBombOff = "M14.5,2.75C12.7,2.75 11.25,4.2 11.25,6H10V7.29C9.31,7.5 8.67,7.81 8.08,8.2L17.79,17.91C18.58,16.76 19,15.39 19,14C19,10.83 16.89,8.15 14,7.29V6H12.75A1.75,1.75 0 0,1 14.5,4.25A1.75,1.75 0 0,1 16.25,6A2.25,2.25 0 0,0 18.5,8.25C19.74,8.25 20.74,7.24 20.74,6V5.25H19.25V6C19.25,6.42 18.91,6.75 18.5,6.75C18.08,6.75 17.75,6.42 17.75,6C17.75,4.2 16.29,2.75 14.5,2.75M3.41,6.36L2,7.77L5.55,11.32C5.2,12.14 5,13.04 5,14C5,17.86 8.13,21 12,21C12.92,21 13.83,20.81 14.68,20.45L18.23,24L19.64,22.59L3.41,6.36Z";
var mdiBone = "M8,14A3,3 0 0,1 5,17A3,3 0 0,1 2,14C2,13.23 2.29,12.53 2.76,12C2.29,11.47 2,10.77 2,10A3,3 0 0,1 5,7A3,3 0 0,1 8,10C9.33,10.08 10.67,10.17 12,10.17C13.33,10.17 14.67,10.08 16,10A3,3 0 0,1 19,7A3,3 0 0,1 22,10C22,10.77 21.71,11.47 21.24,12C21.71,12.53 22,13.23 22,14A3,3 0 0,1 19,17A3,3 0 0,1 16,14C14.67,13.92 13.33,13.83 12,13.83C10.67,13.83 9.33,13.92 8,14Z";
var mdiBoneOff = "M22.1 21.5L2.4 1.7L1.1 3L5.1 7H5C3.3 7 2 8.3 2 10C2 10.8 2.3 11.5 2.8 12C2.3 12.5 2 13.2 2 14C2 15.7 3.3 17 5 17S8 15.7 8 14C9.3 13.9 10.6 13.8 11.9 13.8L20.8 22.7L22.1 21.5M20 16.8L13.3 10.1C14.2 10.1 15.1 10 16 10C16 8.3 17.3 7 19 7S22 8.3 22 10C22 10.8 21.7 11.5 21.2 12C21.7 12.5 22 13.2 22 14C22 15.3 21.2 16.4 20 16.8Z";
var mdiBook = "M18,22A2,2 0 0,0 20,20V4C20,2.89 19.1,2 18,2H12V9L9.5,7.5L7,9V2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18Z";
var mdiBookAccount = "M18 2H12V9L9.5 7.5L7 9V2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V4A2 2 0 0 0 18 2M14 12A2 2 0 1 1 12 14A2 2 0 0 1 14 12M18 20H10V19C10 17.67 12.67 17 14 17S18 17.67 18 19Z";
var mdiBookAccountOutline = "M18 2A2 2 0 0 1 20 4V20A2 2 0 0 1 18 22H6A2 2 0 0 1 4 20V4A2 2 0 0 1 6 2H18M18 4H13V9L10.5 6.7L8 9V4H6V20H18M13 11A2 2 0 1 1 11 13A2 2 0 0 1 13 11M17 19H9V18C9 16.67 11.67 16 13 16S17 16.67 17 18V19";
var mdiBookAlert = "M18 4V20C18 21.11 17.11 22 16 22H4C2.9 22 2 21.11 2 20V4C2 2.9 2.9 2 4 2H5V9L7.5 7.5L10 9V2H16C17.1 2 18 2.89 18 4M20 17H22V15H20V17M20 7V13H22V7H20Z";
var mdiBookAlertOutline = "M16 2H4C2.9 2 2 2.9 2 4V20C2 21.11 2.9 22 4 22H16C17.11 22 18 21.11 18 20V4C18 2.9 17.11 2 16 2M16 20H4V4H6V12L8.5 9.75L11 12V4H16V20M20 15H22V17H20V15M22 7V13H20V7H22Z";
var mdiBookAlphabet = "M5.81,2C4.83,2.09 4,3 4,4V20C4,21.05 4.95,22 6,22H18C19.05,22 20,21.05 20,20V4C20,2.89 19.1,2 18,2H12V9L9.5,7.5L7,9V2H6C5.94,2 5.87,2 5.81,2M12,13H13A1,1 0 0,1 14,14V18H13V16H12V18H11V14A1,1 0 0,1 12,13M12,14V15H13V14H12M15,15H18V16L16,19H18V20H15V19L17,16H15V15Z";
var mdiBookArrowDown = "M13 19C13 20.1 13.3 21.12 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V13.09C19.67 13.04 19.34 13 19 13C15.69 13 13 15.69 13 19M20 20V16H18V20H16L19 23L22 20H20Z";
var mdiBookArrowDownOutline = "M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V4H13V12L10.5 9.75L8 12V4H6V20H13.09M20 20V16H18V20H16L19 23L22 20H20Z";
var mdiBookArrowLeft = "M13 19C13 20.1 13.3 21.12 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V13.09C19.67 13.04 19.34 13 19 13C15.69 13 13 15.69 13 19M18 18V16L15 19L18 22V20H22V18H18Z";
var mdiBookArrowLeftOutline = "M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V4H13V12L10.5 9.75L8 12V4H6V20H13.09M18 18V16L15 19L18 22V20H22V18H18Z";
var mdiBookArrowRight = "M13 19C13 20.1 13.3 21.12 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V13.09C19.67 13.04 19.34 13 19 13C15.69 13 13 15.69 13 19M23 19L20 16V18H16V20H20V22L23 19Z";
var mdiBookArrowRightOutline = "M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V4H13V12L10.5 9.75L8 12V4H6V20H13.09M23 19L20 16V18H16V20H20V22L23 19Z";
var mdiBookArrowUp = "M13 19C13 20.1 13.3 21.12 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V13.09C19.67 13.04 19.34 13 19 13C15.69 13 13 15.69 13 19M19 15L16 18H18V22H20V18H22L19 15Z";
var mdiBookArrowUpOutline = "M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V4H13V12L10.5 9.75L8 12V4H6V20H13.09M19 15L16 18H18V22H20V18H22L19 15Z";
var mdiBookCancel = "M12 18.5C12 19.79 12.39 21 13.04 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V12.18C19.5 12.07 19 12 18.5 12C14.91 12 12 14.91 12 18.5M23 18.5C23 21 21 23 18.5 23S14 21 14 18.5 16 14 18.5 14 23 16 23 18.5M20 21.08L15.92 17C15.65 17.42 15.5 17.94 15.5 18.5C15.5 20.16 16.84 21.5 18.5 21.5C19.06 21.5 19.58 21.35 20 21.08M21.5 18.5C21.5 16.84 20.16 15.5 18.5 15.5C17.94 15.5 17.42 15.65 17 15.92L21.08 20C21.35 19.58 21.5 19.06 21.5 18.5Z";
var mdiBookCancelOutline = "M12.18 20C12.36 20.72 12.65 21.39 13.04 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V12.18C19.5 12.07 19 12 18.5 12C18.33 12 18.17 12 18 12.03V4H13V12L10.5 9.75L8 12V4H6V20H12.18M23 18.5C23 21 21 23 18.5 23S14 21 14 18.5 16 14 18.5 14 23 16 23 18.5M20 21.08L15.92 17C15.65 17.42 15.5 17.94 15.5 18.5C15.5 20.16 16.84 21.5 18.5 21.5C19.06 21.5 19.58 21.35 20 21.08M21.5 18.5C21.5 16.84 20.16 15.5 18.5 15.5C17.94 15.5 17.42 15.65 17 15.92L21.08 20C21.35 19.58 21.5 19.06 21.5 18.5Z";
var mdiBookCheck = "M16.75 22.16L14 19.16L15.16 18L16.75 19.59L20.34 16L21.5 17.41L16.75 22.16M6 22C4.89 22 4 21.1 4 20V4C4 2.89 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V13.34C19.37 13.12 18.7 13 18 13C14.69 13 12 15.69 12 19C12 20.09 12.29 21.12 12.8 22H6Z";
var mdiBookCheckOutline = "M16.75 22.16L14 19.16L15.16 18L16.75 19.59L20.34 16L21.5 17.41L16.75 22.16M18 2C19.1 2 20 2.9 20 4V13.34C19.37 13.12 18.7 13 18 13V4H13V12L10.5 9.75L8 12V4H6V20H12.08C12.2 20.72 12.45 21.39 12.8 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2H18Z";
var mdiBookClock = "M16.5 17.25L19.36 18.94L18.61 20.16L15 18V13H16.5V17.25M23 17C23 20.87 19.87 24 16 24C14.09 24 12.37 23.24 11.11 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V11.26C21.81 12.53 23 14.62 23 17M21 17C21 14.24 18.76 12 16 12S11 14.24 11 17 13.24 22 16 22 21 19.76 21 17Z";
var mdiBookClockOutline = "M20 11.26V4C20 2.9 19.11 2 18 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H11.11C12.37 23.24 14.09 24 16 24C19.87 24 23 20.87 23 17C23 14.62 21.81 12.53 20 11.26M18 4V10.29C17.37 10.11 16.7 10 16 10C14.93 10 13.91 10.25 13 10.68V4H18M6 4H8V12L10.5 9.75L12.1 11.19C10.23 12.45 9 14.58 9 17C9 18.08 9.25 19.09 9.68 20H6V4M16 22C13.24 22 11 19.76 11 17S13.24 12 16 12 21 14.24 21 17 18.76 22 16 22M16.5 17.25L19.36 18.94L18.61 20.16L15 18V13H16.5V17.25Z";
var mdiBookCog = "M12 19C12 20.08 12.25 21.09 12.68 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V12.08C19.67 12.03 19.34 12 19 12C15.13 12 12 15.13 12 19M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiBookCogOutline = "M18 4H13V12L10.5 9.75L8 12V4H6V20H12.08C12.18 20.71 12.39 21.38 12.69 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V12.08C19.67 12.03 19.34 12 19 12C18.66 12 18.33 12.03 18 12.08V4M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiBookCross = "M5.81,2H7V9L9.5,7.5L12,9V2H18A2,2 0 0,1 20,4V20C20,21.05 19.05,22 18,22H6C4.95,22 4,21.05 4,20V4C4,3 4.83,2.09 5.81,2M13,10V13H10V15H13V20H15V15H18V13H15V10H13Z";
var mdiBookEdit = "M19.39 10.74L11 19.13V22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V10.3C19.78 10.42 19.57 10.56 19.39 10.74M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47Z";
var mdiBookEditOutline = "M6 20H11V22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V10.3C19.78 10.42 19.57 10.56 19.39 10.74L18 12.13V4H13V12L10.5 9.75L8 12V4H6V20M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96Z";
var mdiBookEducation = "M8.82 17L13 19.28V22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V12.54L18.5 11.72L8.82 17M24 17L18.5 14L13 17L18.5 20L24 17M15 19.09V21.09L18.5 23L22 21.09V19.09L18.5 21L15 19.09Z";
var mdiBookEducationOutline = "M6 20H13V22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V12.54L18.5 11.72L18 12V4H13V12L10.5 9.75L8 12V4H6V20M24 17L18.5 14L13 17L18.5 20L24 17M15 19.09V21.09L18.5 23L22 21.09V19.09L18.5 21L15 19.09Z";
var mdiBookHeart = "M19 23.3L18.4 22.8C16.4 20.9 15 19.7 15 18.2C15 17 16 16 17.2 16C17.9 16 18.6 16.3 19 16.8C19.4 16.3 20.1 16 20.8 16C22 16 23 16.9 23 18.2C23 19.7 21.6 20.9 19.6 22.8L19 23.3M6 22C4.89 22 4 21.1 4 20V4C4 2.89 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V13.08L19 13C15.69 13 13 15.69 13 19C13 20.09 13.29 21.12 13.8 22H6Z";
var mdiBookHeartOutline = "M19 23.3L18.4 22.8C16.4 20.9 15 19.7 15 18.2C15 17 16 16 17.2 16C17.9 16 18.6 16.3 19 16.8C19.4 16.3 20.1 16 20.8 16C22 16 23 16.9 23 18.2C23 19.7 21.6 20.9 19.6 22.8L19 23.3M18 2C19.1 2 20 2.9 20 4V13.08L19 13L18 13.08V4H13V12L10.5 9.75L8 12V4H6V20H13.08C13.2 20.72 13.45 21.39 13.8 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2H18Z";
var mdiBookInformationVariant = "M18 2H12V9L9.5 7.5L7 9V2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.89 19.1 2 18 2M17.68 18.41C17.57 18.5 16.47 19.25 16.05 19.5C15.63 19.79 14 20.72 14.26 18.92C14.89 15.28 16.11 13.12 14.65 14.06C14.27 14.29 14.05 14.43 13.91 14.5C13.78 14.61 13.79 14.6 13.68 14.41S13.53 14.23 13.67 14.13C13.67 14.13 15.9 12.34 16.72 12.28C17.5 12.21 17.31 13.17 17.24 13.61C16.78 15.46 15.94 18.15 16.07 18.54C16.18 18.93 17 18.31 17.44 18C17.44 18 17.5 17.93 17.61 18.05C17.72 18.22 17.83 18.3 17.68 18.41M16.97 11.06C16.4 11.06 15.94 10.6 15.94 10.03C15.94 9.46 16.4 9 16.97 9C17.54 9 18 9.46 18 10.03C18 10.6 17.54 11.06 16.97 11.06Z";
var mdiBookLock = "M14.2 14.5V14.74C13.5 15.34 13 16.24 13 17.2V20.7C13 21.16 13.1 21.6 13.27 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V10.11C19.68 10.04 19.34 10 19 10C16.4 10 14.2 12.06 14.2 14.5M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiBookLockOpen = "M14.2 13.5V14.74C13.5 15.34 13 16.24 13 17.2V20.7C13 21.16 13.1 21.6 13.27 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V9.11C19.68 9.04 19.34 9 19 9C16.4 9 14.2 11.06 14.2 13.5M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiBookLockOpenOutline = "M13 20.7C13 21.16 13.1 21.6 13.27 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V9.11C19.68 9.04 19.34 9 19 9S18.32 9.04 18 9.11V4H13V12L10.5 9.75L8 12V4H6V20H13V20.7M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiBookLockOutline = "M13 20.7C13 21.16 13.1 21.6 13.27 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V10.11C19.68 10.04 19.34 10 19 10S18.32 10.04 18 10.11V4H13V12L10.5 9.75L8 12V4H6V20H13V20.7M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiBookMarker = "M13 15.5C13 17.78 14.7 20.41 15.91 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V10.22C19.5 10.08 19 10 18.5 10C15.5 10 13 12.5 13 15.5M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiBookMarkerOutline = "M14.55 20C15 20.76 15.5 21.44 15.91 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V10.22C19.5 10.08 19 10 18.5 10C18.33 10 18.17 10 18 10.03V4H13V12L10.5 9.75L8 12V4H6V20H14.55M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiBookMinus = "M13 19C13 20.1 13.3 21.12 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V13.09C19.67 13.04 19.34 13 19 13C15.69 13 13 15.69 13 19M15 18V20H23V18H15Z";
var mdiBookMinusMultiple = "M13.09 20H5V6H3V20C3 21.11 3.9 22 5 22H13.81C13.44 21.39 13.2 20.71 13.09 20M19 2H14V7L12 5.5L10 7V2H9C7.9 2 7 2.9 7 4V16C7 17.11 7.9 18 9 18H13.09C13.64 14.73 16.74 12.53 20 13.08C20.34 13.14 20.68 13.23 21 13.34V4C21 2.9 20.11 2 19 2M23 18V20H15V18H23Z";
var mdiBookMinusMultipleOutline = "M13.09 20H5V6H3V20C3 21.11 3.9 22 5 22H13.81C13.44 21.39 13.2 20.71 13.09 20M19 2H9C7.9 2 7 2.9 7 4V16C7 17.11 7.9 18 9 18H13.09C13.2 17.29 13.44 16.61 13.81 16H9V4H11V10L13.5 7.75L16 10V4H19V13C19.68 13 20.36 13.11 21 13.34V4C21 2.9 20.11 2 19 2M23 18V20H15V18H23Z";
var mdiBookMinusOutline = "M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V4H13V12L10.5 9.75L8 12V4H6V20H13.09M15 18V20H23V18H15Z";
var mdiBookMultiple = "M19,18H9A2,2 0 0,1 7,16V4A2,2 0 0,1 9,2H10V7L12,5.5L14,7V2H19A2,2 0 0,1 21,4V16A2,2 0 0,1 19,18M17,20V22H5A2,2 0 0,1 3,20V6H5V20H17Z";
var mdiBookMultipleOutline = "M19 2A2 2 0 0 1 21 4V16A2 2 0 0 1 19 18H9A2 2 0 0 1 7 16V4A2 2 0 0 1 9 2H19M19 4H16V10L13.5 7.75L11 10V4H9V16H19M3 20A2 2 0 0 0 5 22H17V20H5V6H3Z";
var mdiBookMusic = "M13 20.5C13 21.03 13.09 21.53 13.26 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V11H16.5V16.11C14.5 16.57 13 18.36 13 20.5M20 13H18.5V18.21C18.19 18.07 17.86 18 17.5 18C16.12 18 15 19.12 15 20.5S16.12 23 17.5 23 20 21.88 20 20.5V15H22V13H20Z";
var mdiBookMusicOutline = "M13 20.5C13 21.03 13.09 21.53 13.26 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V11H18V4H13V12L10.5 9.75L8 12V4H6V20H13.04C13.03 20.17 13 20.33 13 20.5M20 13H18.5V18.21C18.19 18.07 17.86 18 17.5 18C16.12 18 15 19.12 15 20.5S16.12 23 17.5 23 20 21.88 20 20.5V15H22V13H20Z";
var mdiBookOff = "M18.68 2.12L12 8.8V2H18C18.24 2 18.46 2.05 18.68 2.12M9.5 7.5L7 9V2H6C4.89 2 4 2.9 4 4V16.8L11.88 8.93L9.5 7.5M21.61 1.73L1.89 21.46L3.16 22.73L4.54 21.35C4.9 21.75 5.42 22 6 22H18C19.11 22 20 21.11 20 20V5.89L22.89 3L21.61 1.73Z";
var mdiBookOffOutline = "M6 14.8L4 16.8V4C4 2.9 4.89 2 6 2H18C18.24 2 18.47 2.04 18.68 2.12L16.8 4H13V7.8L10.79 10L10.5 9.75L8 12V4H6V14.8M22.89 3L20 5.89V20C20 21.11 19.11 22 18 22H6C5.42 22 4.9 21.75 4.54 21.35L3.16 22.73L1.89 21.46L21.61 1.73L22.89 3M18 7.89L6 19.89V20H18V7.89Z";
var mdiBookOpen = "M13,12H20V13.5H13M13,9.5H20V11H13M13,14.5H20V16H13M21,4H3A2,2 0 0,0 1,6V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V6A2,2 0 0,0 21,4M21,19H12V6H21";
var mdiBookOpenBlankVariant = "M6.5 20C8.2 20 10.65 20.65 12 21.5C13.35 20.65 15.8 20 17.5 20C19.15 20 20.85 20.3 22.25 21.05C22.35 21.1 22.4 21.1 22.5 21.1C22.75 21.1 23 20.85 23 20.6V6C22.4 5.55 21.75 5.25 21 5C19.89 4.65 18.67 4.5 17.5 4.5C15.55 4.5 13.45 4.9 12 6C10.55 4.9 8.45 4.5 6.5 4.5C5.33 4.5 4.11 4.65 3 5C2.25 5.25 1.6 5.55 1 6V20.6C1 20.85 1.25 21.1 1.5 21.1C1.6 21.1 1.65 21.1 1.75 21.05C3.15 20.3 4.85 20 6.5 20M12 19.5V8C13.35 7.15 15.8 6.5 17.5 6.5C18.7 6.5 19.9 6.65 21 7V18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5Z";
var mdiBookOpenBlankVariantOutline = "M12 21.5C10.65 20.65 8.2 20 6.5 20C4.85 20 3.15 20.3 1.75 21.05C1.65 21.1 1.6 21.1 1.5 21.1C1.25 21.1 1 20.85 1 20.6V6C1.6 5.55 2.25 5.25 3 5C4.11 4.65 5.33 4.5 6.5 4.5C8.45 4.5 10.55 4.9 12 6C13.45 4.9 15.55 4.5 17.5 4.5C18.67 4.5 19.89 4.65 21 5C21.75 5.25 22.4 5.55 23 6V20.6C23 20.85 22.75 21.1 22.5 21.1C22.4 21.1 22.35 21.1 22.25 21.05C20.85 20.3 19.15 20 17.5 20C15.8 20 13.35 20.65 12 21.5M11 7.5C9.64 6.9 7.84 6.5 6.5 6.5C5.3 6.5 4.1 6.65 3 7V18.5C4.1 18.15 5.3 18 6.5 18C7.84 18 9.64 18.4 11 19V7.5M13 19C14.36 18.4 16.16 18 17.5 18C18.7 18 19.9 18.15 21 18.5V7C19.9 6.65 18.7 6.5 17.5 6.5C16.16 6.5 14.36 6.9 13 7.5V19Z";
var mdiBookOpenOutline = "M21,4H3A2,2 0 0,0 1,6V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V6A2,2 0 0,0 21,4M3,19V6H11V19H3M21,19H13V6H21V19M14,9.5H20V11H14V9.5M14,12H20V13.5H14V12M14,14.5H20V16H14V14.5Z";
var mdiBookOpenPageVariant = "M19 2L14 6.5V17.5L19 13V2M6.5 5C4.55 5 2.45 5.4 1 6.5V21.16C1 21.41 1.25 21.66 1.5 21.66C1.6 21.66 1.65 21.59 1.75 21.59C3.1 20.94 5.05 20.5 6.5 20.5C8.45 20.5 10.55 20.9 12 22C13.35 21.15 15.8 20.5 17.5 20.5C19.15 20.5 20.85 20.81 22.25 21.56C22.35 21.61 22.4 21.59 22.5 21.59C22.75 21.59 23 21.34 23 21.09V6.5C22.4 6.05 21.75 5.75 21 5.5V19C19.9 18.65 18.7 18.5 17.5 18.5C15.8 18.5 13.35 19.15 12 20V6.5C10.55 5.4 8.45 5 6.5 5Z";
var mdiBookOpenPageVariantOutline = "M19 1L14 6V17L19 12.5V1M21 5V18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5V6C10.55 4.9 8.45 4.5 6.5 4.5C4.55 4.5 2.45 4.9 1 6V20.65C1 20.9 1.25 21.15 1.5 21.15C1.6 21.15 1.65 21.1 1.75 21.1C3.1 20.45 5.05 20 6.5 20C8.45 20 10.55 20.4 12 21.5C13.35 20.65 15.8 20 17.5 20C19.15 20 20.85 20.3 22.25 21.05C22.35 21.1 22.4 21.1 22.5 21.1C22.75 21.1 23 20.85 23 20.6V6C22.4 5.55 21.75 5.25 21 5M10 18.41C8.75 18.09 7.5 18 6.5 18C5.44 18 4.18 18.19 3 18.5V7.13C3.91 6.73 5.14 6.5 6.5 6.5C7.86 6.5 9.09 6.73 10 7.13V18.41Z";
var mdiBookOpenVariant = "M12 21.5C10.65 20.65 8.2 20 6.5 20C4.85 20 3.15 20.3 1.75 21.05C1.65 21.1 1.6 21.1 1.5 21.1C1.25 21.1 1 20.85 1 20.6V6C1.6 5.55 2.25 5.25 3 5C4.11 4.65 5.33 4.5 6.5 4.5C8.45 4.5 10.55 4.9 12 6C13.45 4.9 15.55 4.5 17.5 4.5C18.67 4.5 19.89 4.65 21 5C21.75 5.25 22.4 5.55 23 6V20.6C23 20.85 22.75 21.1 22.5 21.1C22.4 21.1 22.35 21.1 22.25 21.05C20.85 20.3 19.15 20 17.5 20C15.8 20 13.35 20.65 12 21.5M12 8V19.5C13.35 18.65 15.8 18 17.5 18C18.7 18 19.9 18.15 21 18.5V7C19.9 6.65 18.7 6.5 17.5 6.5C15.8 6.5 13.35 7.15 12 8M13 11.5C14.11 10.82 15.6 10.5 17.5 10.5C18.41 10.5 19.26 10.59 20 10.78V9.23C19.13 9.08 18.29 9 17.5 9C15.73 9 14.23 9.28 13 9.84V11.5M17.5 11.67C15.79 11.67 14.29 11.93 13 12.46V14.15C14.11 13.5 15.6 13.16 17.5 13.16C18.54 13.16 19.38 13.24 20 13.4V11.9C19.13 11.74 18.29 11.67 17.5 11.67M20 14.57C19.13 14.41 18.29 14.33 17.5 14.33C15.67 14.33 14.17 14.6 13 15.13V16.82C14.11 16.16 15.6 15.83 17.5 15.83C18.54 15.83 19.38 15.91 20 16.07V14.57Z";
var mdiBookOpenVariantOutline = "M12 21.5C10.65 20.65 8.2 20 6.5 20C4.85 20 3.15 20.3 1.75 21.05C1.65 21.1 1.6 21.1 1.5 21.1C1.25 21.1 1 20.85 1 20.6V6C1.6 5.55 2.25 5.25 3 5C4.11 4.65 5.33 4.5 6.5 4.5C8.45 4.5 10.55 4.9 12 6C13.45 4.9 15.55 4.5 17.5 4.5C18.67 4.5 19.89 4.65 21 5C21.75 5.25 22.4 5.55 23 6V20.6C23 20.85 22.75 21.1 22.5 21.1C22.4 21.1 22.35 21.1 22.25 21.05C20.85 20.3 19.15 20 17.5 20C15.8 20 13.35 20.65 12 21.5M11 7.5C9.64 6.9 7.84 6.5 6.5 6.5C5.3 6.5 4.1 6.65 3 7V18.5C4.1 18.15 5.3 18 6.5 18C7.84 18 9.64 18.4 11 19V7.5M13 19C14.36 18.4 16.16 18 17.5 18C18.7 18 19.9 18.15 21 18.5V7C19.9 6.65 18.7 6.5 17.5 6.5C16.16 6.5 14.36 6.9 13 7.5V19M14 16.35C14.96 16 16.12 15.83 17.5 15.83C18.54 15.83 19.38 15.91 20 16.07V14.57C19.13 14.41 18.29 14.33 17.5 14.33C16.16 14.33 15 14.5 14 14.76V16.35M14 13.69C14.96 13.34 16.12 13.16 17.5 13.16C18.54 13.16 19.38 13.24 20 13.4V11.9C19.13 11.74 18.29 11.67 17.5 11.67C16.22 11.67 15.05 11.82 14 12.12V13.69M14 11C14.96 10.67 16.12 10.5 17.5 10.5C18.41 10.5 19.26 10.59 20 10.78V9.23C19.13 9.08 18.29 9 17.5 9C16.18 9 15 9.15 14 9.46V11Z";
var mdiBookOutline = "M18,2A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H18M18,4H13V12L10.5,9.75L8,12V4H6V20H18V4Z";
var mdiBookPlay = "M13 19C13 20.1 13.3 21.12 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V13.09C19.67 13.04 19.34 13 19 13C15.69 13 13 15.69 13 19M17 16V22L22 19L17 16Z";
var mdiBookPlayOutline = "M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V4H13V12L10.5 9.75L8 12V4H6V20H13.09M17 16V22L22 19L17 16Z";
var mdiBookPlus = "M13 19C13 20.1 13.3 21.12 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V13.09C19.67 13.04 19.34 13 19 13C15.69 13 13 15.69 13 19M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiBookPlusMultiple = "M13.09 20H5V6H3V20A2 2 0 0 0 5 22H13.81A5.5 5.5 0 0 1 13.09 20M19 2H14V7L12 5.5L10 7V2H9A2 2 0 0 0 7 4V16A2 2 0 0 0 9 18H13.09A6 6 0 0 1 21 13.34V4A2 2 0 0 0 19 2M20 15V18H23V20H20V23H18V20H15V18H18V15Z";
var mdiBookPlusMultipleOutline = "M13.09 20H5V6H3V20A2 2 0 0 0 5 22H13.81A5.5 5.5 0 0 1 13.09 20M19 2H9A2 2 0 0 0 7 4V16A2 2 0 0 0 9 18H13.09A5.5 5.5 0 0 1 13.81 16H9V4H11V10L13.5 7.75L16 10V4H19V13A6 6 0 0 1 21 13.34V4A2 2 0 0 0 19 2M20 15V18H23V20H20V23H18V20H15V18H18V15Z";
var mdiBookPlusOutline = "M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V4H13V12L10.5 9.75L8 12V4H6V20H13.09M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiBookRefresh = "M12 18.5C12 19.79 12.39 21 13.04 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V12.18C19.5 12.07 19 12 18.5 12C14.91 12 12 14.91 12 18.5M22 18.5V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22Z";
var mdiBookRefreshOutline = "M12.18 20C12.36 20.72 12.65 21.39 13.04 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V12.18C19.5 12.07 19 12 18.5 12C18.33 12 18.17 12 18 12.03V4H13V12L10.5 9.75L8 12V4H6V20H12.18M22 18.5V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22Z";
var mdiBookRemove = "M13 19C13 20.1 13.3 21.12 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V13.09C19.67 13.04 19.34 13 19 13C15.69 13 13 15.69 13 19M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiBookRemoveMultiple = "M13.09 20H5V6H3V20A2 2 0 0 0 5 22H13.81A5.5 5.5 0 0 1 13.09 20M19 2H14V7L12 5.5L10 7V2H9A2 2 0 0 0 7 4V16A2 2 0 0 0 9 18H13.09A6 6 0 0 1 21 13.34V4A2 2 0 0 0 19 2M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.46 21.12L17.59 19L15.46 16.88L16.88 15.46L19 17.59L21.12 15.46Z";
var mdiBookRemoveMultipleOutline = "M13.09 20H5V6H3V20A2 2 0 0 0 5 22H13.81A5.5 5.5 0 0 1 13.09 20M19 2H9A2 2 0 0 0 7 4V16A2 2 0 0 0 9 18H13.09A5.5 5.5 0 0 1 13.81 16H9V4H11V10L13.5 7.75L16 10V4H19V13A6 6 0 0 1 21 13.34V4A2 2 0 0 0 19 2M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.46 21.12L17.59 19L15.46 16.88L16.88 15.46L19 17.59L21.12 15.46Z";
var mdiBookRemoveOutline = "M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V4H13V12L10.5 9.75L8 12V4H6V20H13.09M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiBookSearch = "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14M6,22A2,2 0 0,1 4,20V4C4,2.89 4.9,2 6,2H7V9L9.5,7.5L12,9V2H18A2,2 0 0,1 20,4V11.81C18.83,10.69 17.25,10 15.5,10A6.5,6.5 0 0,0 9,16.5C9,18.81 10.21,20.85 12.03,22H6Z";
var mdiBookSearchOutline = "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14M13,4V12L10.5,9.75L8,12V4H6V20H10C10.54,20.81 11.23,21.5 12.03,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H18A2,2 0 0,1 20,4V11.81C19.42,11.26 18.75,10.81 18,10.5V4H13Z";
var mdiBookSettings = "M20 2V18C20 19.11 19.11 20 18 20H6C4.89 20 4 19.11 4 18V2C4 .895 4.89 0 6 0H7V7L9.5 5.5L12 7V0H18C19.1 0 20 .89 20 2M7 24H9V22H7V24M15 24H17V22H15V24M11 24H13V22H11V24Z";
var mdiBookSettingsOutline = "M18 0H6C4.89 0 4 .895 4 2V18C4 19.11 4.89 20 6 20H18C19.11 20 20 19.11 20 18V2C20 .895 19.11 0 18 0M18 18H6V2H8V10L10.5 7.75L13 10V2H18V18M7 22H9V24H7V22M11 22H13V24H11V22M15 22H17V24H15V22Z";
var mdiBookSync = "M13 17.5C13 19.25 13.69 20.83 14.82 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H7V9L9.5 7.5L12 9V2H18C19.1 2 20 2.89 20 4V11.03C19.84 11 19.67 11 19.5 11C15.91 11 13 13.91 13 17.5M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5Z";
var mdiBookSyncOutline = "M13.5 20C13.81 20.75 14.26 21.42 14.82 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H18C19.11 2 20 2.9 20 4V11.03C19.84 11 19.67 11 19.5 11C19 11 18.5 11.07 18 11.18V4H13V12L10.5 9.75L8 12V4H6V20H13.5M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5Z";
var mdiBookVariant = "M6,4H11V12L8.5,10.5L6,12M18,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V4A2,2 0 0,0 18,2Z";
var mdiBookmark = "M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z";
var mdiBookmarkBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M18 14L15.5 12.5L13 14V6H18V14Z";
var mdiBookmarkBoxMultiple = "M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 12L17.5 10.5L15 12V4H20V12Z";
var mdiBookmarkBoxMultipleOutline = "M4 20H18V22H4C2.9 22 2 21.1 2 20V6H4V20M22 4V16C22 17.1 21.1 18 20 18H8C6.9 18 6 17.1 6 16V4C6 2.9 6.9 2 8 2H20C21.1 2 22 2.9 22 4M20 4H8V16H20V4M18 6H13V13L15.5 11.5L18 13V6Z";
var mdiBookmarkBoxOutline = "M5 3H19C20.1 3 21 3.89 21 5V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 3.89 3.89 3 5 3M19 19V5H5V19H19M17 7H12V15L14.5 13.5L17 15V7Z";
var mdiBookmarkCheck = "M17,3A2,2 0 0,1 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,14L17.25,7.76L15.84,6.34L11,11.18L8.41,8.59L7,10L11,14Z";
var mdiBookmarkCheckOutline = "M9.47 9.65L8.06 11.07L11 14L16.19 8.82L14.78 7.4L11 11.18M17 3H7C5.9 3 5 3.9 5 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3M17 18L12 15.82L7 18V5H17Z";
var mdiBookmarkMinus = "M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5A2,2 0 0,0 17,3M15,11H9V9H15V11Z";
var mdiBookmarkMinusOutline = "M9,11V9H15V11H9M19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17C18.11,3 19,3.9 19,5M17,5H7V18L12,15.82L17,18V5Z";
var mdiBookmarkMultiple = "M15,5A2,2 0 0,1 17,7V23L10,20L3,23V7C3,5.89 3.9,5 5,5H15M9,1H19A2,2 0 0,1 21,3V19L19,18.13V3H7A2,2 0 0,1 9,1Z";
var mdiBookmarkMultipleOutline = "M9,1H19A2,2 0 0,1 21,3V19L19,18.13V3H7A2,2 0 0,1 9,1M15,20V7H5V20L10,17.82L15,20M15,5C16.11,5 17,5.9 17,7V23L10,20L3,23V7A2,2 0 0,1 5,5H15Z";
var mdiBookmarkMusic = "M17,3A2,2 0 0,1 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,11A2,2 0 0,0 9,13A2,2 0 0,0 11,15A2,2 0 0,0 13,13V8H16V6H12V11.27C11.71,11.1 11.36,11 11,11Z";
var mdiBookmarkMusicOutline = "M7 3C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.89 18.1 3 17 3H7M7 5H17V18L12 15.82L7 18V5M12 6V11.3C11.7 11.1 11.4 11 11 11C9.9 11 9 11.9 9 13C9 14.11 9.9 15 11 15C12.11 15 13 14.11 13 13V8H15V6H12Z";
var mdiBookmarkOff = "M20,20.72L18.73,22L16.78,20.05L12,18L5,21V8.27L2,5.27L3.28,4L20,20.72M19,17.16V5C19,3.89 18.1,3 17,3H7C6.41,3 5.89,3.27 5.5,3.68L19,17.16Z";
var mdiBookmarkOffOutline = "M3.28,4L2,5.27L5,8.27V21L12,18L16.78,20.05L18.73,22L20,20.72L3.28,4M7,18V10.27L13,16.25L12,15.82L7,18M7,5.16L5.5,3.67C5.88,3.26 6.41,3 7,3H17A2,2 0 0,1 19,5V17.16L17,15.16V5H7V5.16Z";
var mdiBookmarkOutline = "M17,18L12,15.82L7,18V5H17M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z";
var mdiBookmarkPlus = "M17,3A2,2 0 0,1 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,7V9H9V11H11V13H13V11H15V9H13V7H11Z";
var mdiBookmarkPlusOutline = "M17,18V5H7V18L12,15.82L17,18M17,3A2,2 0 0,1 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,7H13V9H15V11H13V13H11V11H9V9H11V7Z";
var mdiBookmarkRemove = "M17,3A2,2 0 0,1 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M8.17,8.58L10.59,11L8.17,13.41L9.59,14.83L12,12.41L14.41,14.83L15.83,13.41L13.41,11L15.83,8.58L14.41,7.17L12,9.58L9.59,7.17L8.17,8.58Z";
var mdiBookmarkRemoveOutline = "M7 3C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.89 18.1 3 17 3H7M7 5H17V18L12 15.82L7 18V5M9.88 7.47L8.47 8.88L10.59 11L8.47 13.12L9.88 14.54L12 12.42L14.12 14.53L15.54 13.12L13.42 11L15.53 8.88L14.12 7.47L12 9.59L9.88 7.47Z";
var mdiBookshelf = "M9 3V18H12V3H9M12 5L16 18L19 17L15 4L12 5M5 5V18H8V5H5M3 19V21H21V19H3Z";
var mdiBoomGate = "M20,9H8.22C7.11,7.77 5.21,7.68 4,8.8C3.36,9.36 3,10.16 3,11V20A1,1 0 0,0 2,21V22H10V21A1,1 0 0,0 9,20V13H20A2,2 0 0,0 22,11A2,2 0 0,0 20,9M6,12.5A1.5,1.5 0 0,1 4.5,11A1.5,1.5 0 0,1 6,9.5A1.5,1.5 0 0,1 7.5,11A1.5,1.5 0 0,1 6,12.5M10.5,12L9,10H10.5L12,12H10.5M14.5,12L13,10H14.5L16,12H14.5M18.5,12L17,10H18.5L20,12H18.5Z";
var mdiBoomGateAlert = "M19.9 3C19.3 2 18.1 1.7 17.2 2.3L6.9 8.2C6.6 8.1 6.3 8 6 8C4.3 8 3 9.3 3 11V20C2.4 20 2 20.4 2 21V22H10V21C10 20.4 9.6 20 9 20V11.6L19.1 5.8C20.1 5.2 20.4 4 19.9 3M6 12.5C5.2 12.5 4.5 11.8 4.5 11S5.2 9.5 6 9.5 7.5 10.2 7.5 11 6.8 12.5 6 12.5M10.4 9.6L8.1 8.6L9.4 7.8L11.7 8.8L10.4 9.6M13.9 7.6L11.6 6.6L12.9 5.8L15.2 6.8L13.9 7.6M17.3 5.6L15 4.6L16.3 3.8L18.6 4.8L17.3 5.6M20 18H18V20H20V18M20 10H18V16H20V10Z";
var mdiBoomGateAlertOutline = "M19.9 3C19.3 2 18.1 1.7 17.2 2.3L6.9 8.2C6.6 8.1 6.3 8 6 8C4.3 8 3 9.3 3 11V20C2.4 20 2 20.4 2 21V22H10V21C10 20.4 9.6 20 9 20V11.6L19.1 5.8C20.1 5.2 20.4 4 19.9 3M7.5 20H4.5V13.6C5.4 14.1 6.6 14.1 7.5 13.6V20M6 12.5C5.2 12.5 4.5 11.8 4.5 11S5.2 9.5 6 9.5 7.5 10.2 7.5 11 6.8 12.5 6 12.5M10.4 9.6L8.1 8.6L9.4 7.8L11.7 8.8L10.4 9.6M13.9 7.6L11.6 6.6L12.9 5.8L15.2 6.8L13.9 7.6M17.3 5.6L15 4.6L16.3 3.8L18.6 4.8L17.3 5.6M20 16H18V10H20V16M20 20H18V18H20V20Z";
var mdiBoomGateArrowDown = "M19.86,3C19.31,2.04 18.09,1.71 17.12,2.27L6.92,8.16C6.62,8.06 6.31,8 6,8A3,3 0 0,0 3,11V20A1,1 0 0,0 2,21V22H10V21A1,1 0 0,0 9,20V11.58L19.12,5.73C20.08,5.18 20.41,3.96 19.86,3M6,12.5A1.5,1.5 0 0,1 4.5,11A1.5,1.5 0 0,1 6,9.5A1.5,1.5 0 0,1 7.5,11A1.5,1.5 0 0,1 6,12.5M10.4,9.62L8.1,8.62L9.4,7.87L11.7,8.87L10.4,9.62M13.86,7.62L11.56,6.62L12.86,5.87L15.16,6.87L13.86,7.62M17.33,5.62L15.03,4.62L16.33,3.87L18.62,4.87L17.33,5.62M17,20L12,15H15V11H19V15H22L17,20";
var mdiBoomGateArrowDownOutline = "M19.86,3C20.41,3.96 20.08,5.18 19.12,5.73L9,11.58V20A1,1 0 0,1 10,21V22H2V21A1,1 0 0,1 3,20V11A3,3 0 0,1 6,8C6.31,8 6.62,8.06 6.92,8.16L17.12,2.27C18.09,1.71 19.31,2.04 19.86,3M7.5,20V13.6C6.57,14.14 5.43,14.14 4.5,13.6V20H7.5M6,12.5A1.5,1.5 0 0,0 7.5,11A1.5,1.5 0 0,0 6,9.5A1.5,1.5 0 0,0 4.5,11A1.5,1.5 0 0,0 6,12.5M10.4,9.62L11.7,8.87L9.4,7.87L8.1,8.62L10.4,9.62M13.86,7.62L15.16,6.87L12.86,5.87L11.56,6.62L13.86,7.62M17.33,5.62L18.62,4.87L16.33,3.87L15.03,4.62L17.33,5.62M16,11.16H18V16.17L21,16.16L17,20L13,16.16L16,16.17V11.16Z";
var mdiBoomGateArrowUp = "M19.86,3C19.31,2.04 18.09,1.71 17.12,2.27L6.92,8.16C6.62,8.06 6.31,8 6,8A3,3 0 0,0 3,11V20A1,1 0 0,0 2,21V22H10V21A1,1 0 0,0 9,20V11.58L19.12,5.73C20.08,5.18 20.41,3.96 19.86,3M6,12.5A1.5,1.5 0 0,1 4.5,11A1.5,1.5 0 0,1 6,9.5A1.5,1.5 0 0,1 7.5,11A1.5,1.5 0 0,1 6,12.5M10.4,9.62L8.1,8.62L9.4,7.87L11.7,8.87L10.4,9.62M13.86,7.62L11.56,6.62L12.86,5.87L15.16,6.87L13.86,7.62M17.33,5.62L15.03,4.62L16.33,3.87L18.62,4.87L17.33,5.62M17,11L22,16H19V20H15V16H12L17,11";
var mdiBoomGateArrowUpOutline = "M19.86,3C20.41,3.96 20.08,5.18 19.12,5.73L9,11.58V20A1,1 0 0,1 10,21V22H2V21A1,1 0 0,1 3,20V11A3,3 0 0,1 6,8C6.31,8 6.62,8.06 6.92,8.16L17.12,2.27C18.09,1.71 19.31,2.04 19.86,3M7.5,20V13.6C6.57,14.14 5.43,14.14 4.5,13.6V20H7.5M6,12.5A1.5,1.5 0 0,0 7.5,11A1.5,1.5 0 0,0 6,9.5A1.5,1.5 0 0,0 4.5,11A1.5,1.5 0 0,0 6,12.5M10.4,9.62L11.7,8.87L9.4,7.87L8.1,8.62L10.4,9.62M13.86,7.62L15.16,6.87L12.86,5.87L11.56,6.62L13.86,7.62M17.33,5.62L18.62,4.87L16.33,3.87L15.03,4.62L17.33,5.62M16,20V15H13L17,11.16L21,15H18V20H16Z";
var mdiBoomGateOutline = "M20,9H8.22C7.11,7.77 5.21,7.68 4,8.8C3.36,9.36 3,10.16 3,11V20A1,1 0 0,0 2,21V22H10V21A1,1 0 0,0 9,20V13H20A2,2 0 0,0 22,11A2,2 0 0,0 20,9M7.5,20H4.5V13.6C5.43,14.14 6.57,14.14 7.5,13.6V20M6,12.5A1.5,1.5 0 0,1 4.5,11A1.5,1.5 0 0,1 6,9.5A1.5,1.5 0 0,1 7.5,11A1.5,1.5 0 0,1 6,12.5M10.5,12L9,10H10.5L12,12H10.5M14.5,12L13,10H14.5L16,12H14.5M18.5,12L17,10H18.5L20,12H18.5Z";
var mdiBoomGateUp = "M19.9 3C19.3 2 18.1 1.7 17.2 2.3L6.9 8.2C6.6 8.1 6.3 8 6 8C4.3 8 3 9.3 3 11V20C2.4 20 2 20.4 2 21V22H10V21C10 20.4 9.6 20 9 20V11.6L19.1 5.8C20.1 5.2 20.4 4 19.9 3M6 12.5C5.2 12.5 4.5 11.8 4.5 11S5.2 9.5 6 9.5 7.5 10.2 7.5 11 6.8 12.5 6 12.5M10.4 9.6L8.1 8.6L9.4 7.8L11.7 8.8L10.4 9.6M13.9 7.6L11.6 6.6L12.9 5.8L15.2 6.8L13.9 7.6M17.3 5.6L15 4.6L16.3 3.8L18.6 4.8L17.3 5.6";
var mdiBoomGateUpOutline = "M19.9 3C19.3 2 18.1 1.7 17.2 2.3L6.9 8.2C6.6 8.1 6.3 8 6 8C4.3 8 3 9.3 3 11V20C2.4 20 2 20.4 2 21V22H10V21C10 20.4 9.6 20 9 20V11.6L19.1 5.8C20.1 5.2 20.4 4 19.9 3M7.5 20H4.5V13.6C5.4 14.1 6.6 14.1 7.5 13.6V20M6 12.5C5.2 12.5 4.5 11.8 4.5 11S5.2 9.5 6 9.5 7.5 10.2 7.5 11 6.8 12.5 6 12.5M10.4 9.6L8.1 8.6L9.4 7.8L11.7 8.8L10.4 9.6M13.9 7.6L11.6 6.6L12.9 5.8L15.2 6.8L13.9 7.6M17.3 5.6L15 4.6L16.3 3.8L18.6 4.8L17.3 5.6";
var mdiBoombox = "M7,5L5,7V8H3A1,1 0 0,0 2,9V17A1,1 0 0,0 3,18H21A1,1 0 0,0 22,17V9A1,1 0 0,0 21,8H19V7L17,5H7M7,7H17V8H7V7M11,9H13A0.5,0.5 0 0,1 13.5,9.5A0.5,0.5 0 0,1 13,10H11A0.5,0.5 0 0,1 10.5,9.5A0.5,0.5 0 0,1 11,9M7.5,10.5A3,3 0 0,1 10.5,13.5A3,3 0 0,1 7.5,16.5A3,3 0 0,1 4.5,13.5A3,3 0 0,1 7.5,10.5M16.5,10.5A3,3 0 0,1 19.5,13.5A3,3 0 0,1 16.5,16.5A3,3 0 0,1 13.5,13.5A3,3 0 0,1 16.5,10.5M7.5,12A1.5,1.5 0 0,0 6,13.5A1.5,1.5 0 0,0 7.5,15A1.5,1.5 0 0,0 9,13.5A1.5,1.5 0 0,0 7.5,12M16.5,12A1.5,1.5 0 0,0 15,13.5A1.5,1.5 0 0,0 16.5,15A1.5,1.5 0 0,0 18,13.5A1.5,1.5 0 0,0 16.5,12Z";
var mdiBoomerang = "M10 2H4C2.9 2 2 2.9 2 4S2.9 6 4 6H8L10 2M18 2C20.2 2 22 3.8 22 6V12L18 14C18 9.6 14.4 6 10 6L12 2H18M18 20V16L22 14V20C22 21.1 21.1 22 20 22S18 21.1 18 20Z";
var mdiBootstrap = "M11.79 11.5H9.72V8.19H12.19C13.45 8.19 14.15 8.75 14.15 9.78C14.15 10.9 13.32 11.5 11.79 11.5M12.16 12.63H9.72V16.27L12.28 16.27C13.84 16.27 14.66 15.64 14.66 14.44S13.81 12.63 12.16 12.63M22 5.31V18.69C22 20.5 20.5 22 18.69 22H5.31C3.5 22 2 20.5 2 18.69V5.31C2 3.5 3.5 2 5.31 2H18.69C20.5 2 22 3.5 22 5.31M16 14.5C16 13.12 15.08 12.13 13.67 11.95V11.89C14.67 11.71 15.46 10.71 15.46 9.63C15.46 8.08 14.26 7.05 12.5 7.05H8.43V17.41H12.47C14.68 17.41 16 16.32 16 14.5Z";
var mdiBorderAll = "M19,11H13V5H19M19,19H13V13H19M11,11H5V5H11M11,19H5V13H11M3,21H21V3H3V21Z";
var mdiBorderAllVariant = "M3,21V3H21V21H3M5,5V19H19V5H5Z";
var mdiBorderBottom = "M5,15H3V17H5M3,21H21V19H3M5,11H3V13H5M19,9H21V7H19M19,5H21V3H19M5,7H3V9H5M19,17H21V15H19M19,13H21V11H19M17,3H15V5H17M13,3H11V5H13M17,11H15V13H17M13,7H11V9H13M5,3H3V5H5M13,11H11V13H13M9,3H7V5H9M13,15H11V17H13M9,11H7V13H9V11Z";
var mdiBorderBottomVariant = "M5,15H3V17H5M3,21H21V19H3M5,11H3V13H5M19,9H21V7H19M19,5H21V3H19M5,7H3V9H5M19,17H21V15H19M19,13H21V11H19M17,3H15V5H17M13,3H11V5H13M5,3H3V5H5M9,3H7V5H9";
var mdiBorderColor = "M20.71,4.04C21.1,3.65 21.1,3 20.71,2.63L18.37,0.29C18,-0.1 17.35,-0.1 16.96,0.29L15,2.25L18.75,6M17.75,7L14,3.25L4,13.25V17H7.75L17.75,7Z";
var mdiBorderHorizontal = "M19,21H21V19H19M15,21H17V19H15M11,17H13V15H11M19,9H21V7H19M19,5H21V3H19M3,13H21V11H3M11,21H13V19H11M19,17H21V15H19M13,3H11V5H13M13,7H11V9H13M17,3H15V5H17M9,3H7V5H9M5,3H3V5H5M7,21H9V19H7M3,17H5V15H3M5,7H3V9H5M3,21H5V19H3V21Z";
var mdiBorderInside = "M19,17H21V15H19M19,21H21V19H19M13,3H11V11H3V13H11V21H13V13H21V11H13M15,21H17V19H15M19,5H21V3H19M19,9H21V7H19M17,3H15V5H17M5,3H3V5H5M9,3H7V5H9M3,17H5V15H3M5,7H3V9H5M7,21H9V19H7M3,21H5V19H3V21Z";
var mdiBorderLeft = "M15,5H17V3H15M15,13H17V11H15M19,21H21V19H19M19,13H21V11H19M19,5H21V3H19M19,17H21V15H19M15,21H17V19H15M19,9H21V7H19M3,21H5V3H3M7,13H9V11H7M7,5H9V3H7M7,21H9V19H7M11,13H13V11H11M11,9H13V7H11M11,5H13V3H11M11,17H13V15H11M11,21H13V19H11V21Z";
var mdiBorderLeftVariant = "M15,5H17V3H15M19,21H21V19H19M19,13H21V11H19M19,5H21V3H19M19,17H21V15H19M15,21H17V19H15M19,9H21V7H19M3,21H5V3H3M7,5H9V3H7M7,21H9V19H7M11,5H13V3H11M11,21H13V19H11V21Z";
var mdiBorderNone = "M15,5H17V3H15M15,13H17V11H15M15,21H17V19H15M11,5H13V3H11M19,5H21V3H19M11,9H13V7H11M19,9H21V7H19M19,21H21V19H19M19,13H21V11H19M19,17H21V15H19M11,13H13V11H11M3,5H5V3H3M3,9H5V7H3M3,13H5V11H3M3,17H5V15H3M3,21H5V19H3M11,21H13V19H11M11,17H13V15H11M7,21H9V19H7M7,13H9V11H7M7,5H9V3H7V5Z";
var mdiBorderNoneVariant = "M15,5H17V3H15M15,21H17V19H15M11,5H13V3H11M19,5H21V3H19M19,9H21V7H19M19,21H21V19H19M19,13H21V11H19M19,17H21V15H19M3,5H5V3H3M3,9H5V7H3M3,13H5V11H3M3,17H5V15H3M3,21H5V19H3M11,21H13V19H11M7,21H9V19H7M7,5H9V3H7V5Z";
var mdiBorderOutside = "M9,11H7V13H9M13,15H11V17H13M19,19H5V5H19M3,21H21V3H3M17,11H15V13H17M13,11H11V13H13M13,7H11V9H13V7Z";
var mdiBorderRadius = "M3 16C3 18.8 5.2 21 8 21H10V19H8C6.3 19 5 17.7 5 16V14H3V16M21 8C21 5.2 18.8 3 16 3H14V5H16C17.7 5 19 6.3 19 8V10H21V8M16 21C18.8 21 21 18.8 21 16V14H19V16C19 17.7 17.7 19 16 19H14V21H16M8 3C5.2 3 3 5.2 3 8V10H5V8C5 6.3 6.3 5 8 5H10V3H8Z";
var mdiBorderRight = "M11,9H13V7H11M11,5H13V3H11M11,13H13V11H11M15,5H17V3H15M15,21H17V19H15M19,21H21V3H19M15,13H17V11H15M11,17H13V15H11M3,9H5V7H3M3,17H5V15H3M3,13H5V11H3M11,21H13V19H11M3,21H5V19H3M7,13H9V11H7M7,5H9V3H7M3,5H5V3H3M7,21H9V19H7V21Z";
var mdiBorderRightVariant = "M11,5H13V3H11M15,5H17V3H15M15,21H17V19H15M19,21H21V3H19M3,9H5V7H3M3,17H5V15H3M3,13H5V11H3M11,21H13V19H11M3,21H5V19H3M7,5H9V3H7M3,5H5V3H3M7,21H9V19H7V21Z";
var mdiBorderStyle = "M15,21H17V19H15M19,21H21V19H19M7,21H9V19H7M11,21H13V19H11M19,17H21V15H19M19,13H21V11H19M3,3V21H5V5H21V3M19,9H21V7H19";
var mdiBorderTop = "M15,13H17V11H15M19,21H21V19H19M11,9H13V7H11M15,21H17V19H15M19,17H21V15H19M3,5H21V3H3M19,13H21V11H19M19,9H21V7H19M11,17H13V15H11M3,9H5V7H3M3,13H5V11H3M3,21H5V19H3M3,17H5V15H3M11,21H13V19H11M11,13H13V11H11M7,13H9V11H7M7,21H9V19H7V21Z";
var mdiBorderTopVariant = "M19,21H21V19H19M15,21H17V19H15M19,17H21V15H19M3,5H21V3H3M19,13H21V11H19M19,9H21V7H19M3,9H5V7H3M3,13H5V11H3M3,21H5V19H3M3,17H5V15H3M11,21H13V19H11M7,21H9V19H7V21Z";
var mdiBorderVertical = "M15,13H17V11H15M15,21H17V19H15M15,5H17V3H15M19,9H21V7H19M19,5H21V3H19M19,13H21V11H19M19,21H21V19H19M11,21H13V3H11M19,17H21V15H19M7,5H9V3H7M3,17H5V15H3M3,21H5V19H3M3,13H5V11H3M7,13H9V11H7M7,21H9V19H7M3,5H5V3H3M3,9H5V7H3V9Z";
var mdiBottleSoda = "M15 11V20A2 2 0 0 1 13 22H11A2 2 0 0 1 9 20V11A2 2 0 0 1 9.6 9.58C11.1 7.89 11 4 11 4H10V2H14V4H13S12.9 7.89 14.4 9.58A2 2 0 0 1 15 11Z";
var mdiBottleSodaClassic = "M15 13.77A3 3 0 0 0 15 18.23V20A2 2 0 0 1 13 22H11A2 2 0 0 1 9 20V18.23A3 3 0 0 0 9 13.77V9A12.28 12.28 0 0 0 10.91 4H10V2H14V4H13.09A12.28 12.28 0 0 0 15 9Z";
var mdiBottleSodaClassicOutline = "M10 2V4H10.91C10.65 5.79 9 7.5 8 9V13.77C9.32 14.96 9.32 17.04 8 18.23V20C8 21.11 8.9 22 10 22H14C15.11 22 16 21.11 16 20V18.23C14.68 17.04 14.68 14.96 16 13.77V9C15 7.5 13.35 5.79 13.09 4H14V2M12 6.5C12.24 7 13.54 8.5 13.9 8.91L14 9V13C13.35 13.87 13 14.92 13 16C13 17.08 13.35 18.13 14 19V20H10V19C10.65 18.13 11 17.08 11 16C11 14.92 10.65 13.87 10 13V9L10.1 8.91C10.46 8.5 11.76 7 12 6.5Z";
var mdiBottleSodaOutline = "M14.4 9.58C12.9 7.89 13 4 13 4H14V2H10V4H11S11.1 7.89 9.6 9.58A2 2 0 0 0 9 11V20A2 2 0 0 0 11 22H13A2 2 0 0 0 15 20V11A2 2 0 0 0 14.4 9.58M13 20H11V11L11.1 10.91A6.26 6.26 0 0 0 12 9.5A6.26 6.26 0 0 0 12.9 10.91L13 11Z";
var mdiBottleTonic = "M13 4H11L10 2H14L13 4M19 13V22H5V13C5 10.24 7.24 8 10 8V6H9V5H15V6H14V8C16.76 8 19 10.24 19 13Z";
var mdiBottleTonicOutline = "M13 4H11L10 2H14L13 4M19 13V22H5V13C5 10.24 7.24 8 10 8V6H9V5H15V6H14V8C16.76 8 19 10.24 19 13M17 13C17 11.35 15.65 10 14 10H10C8.35 10 7 11.35 7 13V20H17V13Z";
var mdiBottleTonicPlus = "M13 4H11L10 2H14L13 4M14 8V6H15V5H9V6H10V8C7.24 8 5 10.24 5 13V22H19V13C19 10.24 16.76 8 14 8M16 17H13V20H11V17H8V15H11V12H13V15H16V17Z";
var mdiBottleTonicPlusOutline = "M13 4H11L10 2H14L13 4M19 13V22H5V13C5 10.24 7.24 8 10 8V6H9V5H15V6H14V8C16.76 8 19 10.24 19 13M17 13C17 11.35 15.65 10 14 10H10C8.35 10 7 11.35 7 13V20H17V13M15 16H13V18H11V16H9V14H11V12H13V14H15V16Z";
var mdiBottleTonicSkull = "M19 13V22H5V13C5 10.24 7.24 8 10 8V6H9V5H15V6H14V8C16.76 8 19 10.24 19 13M13 4L14 2H10L11 4H13M12 11C9.79 11 8 12.79 8 15C8 16 8.39 16.9 9 17.59V19H10.25V17.5H11.38V19H12.63V17.5H13.75V19H15V17.59C15.61 16.9 16 16 16 15C16 12.79 14.21 11 12 11M10.5 15C9.95 15 9.5 14.55 9.5 14S9.95 13 10.5 13 11.5 13.45 11.5 14 11.05 15 10.5 15M11.25 16.25L12 15L12.75 16.25H11.25M13.5 15C12.95 15 12.5 14.55 12.5 14S12.95 13 13.5 13 14.5 13.45 14.5 14 14.05 15 13.5 15Z";
var mdiBottleTonicSkullOutline = "M13 4H11L10 2H14L13 4M14 8V6H15V5H9V6H10V8C7.24 8 5 10.24 5 13V22H19V13C19 10.24 16.76 8 14 8M17 20H7V13C7 11.35 8.35 10 10 10H14C15.65 10 17 11.35 17 13V20M12 11C9.79 11 8 12.79 8 15C8 16 8.39 16.9 9 17.59V19H10.25V17.5H11.38V19H12.63V17.5H13.75V19H15V17.59C15.61 16.9 16 16 16 15C16 12.79 14.21 11 12 11M10.5 15C9.95 15 9.5 14.55 9.5 14S9.95 13 10.5 13 11.5 13.45 11.5 14 11.05 15 10.5 15M11.25 16.25L12 15L12.75 16.25H11.25M13.5 15C12.95 15 12.5 14.55 12.5 14S12.95 13 13.5 13 14.5 13.45 14.5 14 14.05 15 13.5 15Z";
var mdiBottleWine = "M10,22A1,1 0 0,1 9,21V11C9,9 10,7.25 11,7V2.5A0.5,0.5 0 0,1 11.5,2H12.5A0.5,0.5 0 0,1 13,2.5V7C14,7.25 15,9 15,11V21A1,1 0 0,1 14,22H10Z";
var mdiBottleWineOutline = "M11.5 2C11.22 2 11 2.22 11 2.5V7C10.93 7 10.85 7 10.78 7.03C9.82 7.27 9.21 8 8.76 8.89C8.3 9.76 8 10.84 8 12C8.05 15 8 18.03 8 21C8 21.55 8.45 22 9 22C11 22 13 22 15 22C15.55 22 16 21.55 16 21C16.04 18 16 15 16 12C16 10.84 15.74 9.76 15.28 8.88C14.83 8 14.22 7.27 13.26 7.04C13.18 7 13.05 7 13 7V2.5C13 2.22 12.78 2 12.5 2M12 8.85C12.32 8.85 12.63 8.9 12.78 9C12.85 9.03 13.2 9.26 13.5 9.81C13.78 10.37 14 11.17 14 12V20H10V12C10 11.17 10.22 10.37 10.5 9.81C10.8 9.26 11.15 9.03 11.22 9C11.36 8.9 11.68 8.85 12 8.85Z";
var mdiBowArrow = "M19.03 6.03L20 7L22 2L17 4L17.97 4.97L16.15 6.79C10.87 2.16 3.3 3.94 2.97 4L2 4.26L2.5 6.2L3.29 6L10.12 12.82L6.94 16H5L2 19L4 20L5 22L8 19V17.06L11.18 13.88L18 20.71L17.81 21.5L19.74 22L20 21.03C20.06 20.7 21.84 13.13 17.21 7.85L19.03 6.03M4.5 5.78C6.55 5.5 11.28 5.28 14.73 8.21L10.82 12.12L4.5 5.78M18.22 19.5L11.88 13.18L15.79 9.27C18.72 12.72 18.5 17.45 18.22 19.5Z";
var mdiBowTie = "M15,14L21,17V7L15,10V14M9,14L3,17V7L9,10V14M10,10H14V14H10V10Z";
var mdiBowl = "M22 15C22 18.9 18.9 22 15 22H9C5.1 22 2 18.9 2 15V12H22V15Z";
var mdiBowlMix = "M16.2 11L20.3 4.5L22 5.5L18.6 11H16.2M15.6 12H2V15C2 18.9 5.1 22 9 22H15C18.9 22 22 18.9 22 15V12H15.6Z";
var mdiBowlMixOutline = "M15.6 12H2V15C2 18.9 5.1 22 9 22H15C18.9 22 22 18.9 22 15V12H15.6M20 15C20 17.8 17.8 20 15 20H9C6.2 20 4 17.8 4 15V14H20V15M16.2 11L20.3 4.4L22 5.5L18.6 11H16.2Z";
var mdiBowlOutline = "M2 12V15C2 18.9 5.1 22 9 22H15C18.9 22 22 18.9 22 15V12H2M4 14H20V15C20 17.8 17.8 20 15 20H9C6.2 20 4 17.8 4 15V14Z";
var mdiBowling = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12.5,11A1.5,1.5 0 0,0 11,12.5A1.5,1.5 0 0,0 12.5,14A1.5,1.5 0 0,0 14,12.5A1.5,1.5 0 0,0 12.5,11M12,5A2,2 0 0,0 10,7A2,2 0 0,0 12,9A2,2 0 0,0 14,7A2,2 0 0,0 12,5M5.93,8.5C5.38,9.45 5.71,10.67 6.66,11.22C7.62,11.78 8.84,11.45 9.4,10.5C9.95,9.53 9.62,8.31 8.66,7.76C7.71,7.21 6.5,7.53 5.93,8.5Z";
var mdiBox = "M15.39,14.04V14.04C15.39,12.62 14.24,11.47 12.82,11.47C11.41,11.47 10.26,12.62 10.26,14.04V14.04C10.26,15.45 11.41,16.6 12.82,16.6C14.24,16.6 15.39,15.45 15.39,14.04M17.1,14.04C17.1,16.4 15.18,18.31 12.82,18.31C11.19,18.31 9.77,17.39 9.05,16.04C8.33,17.39 6.91,18.31 5.28,18.31C2.94,18.31 1.04,16.43 1,14.11V14.11H1V7H1V7C1,6.56 1.39,6.18 1.86,6.18C2.33,6.18 2.7,6.56 2.71,7V7H2.71V10.62C3.43,10.08 4.32,9.76 5.28,9.76C6.91,9.76 8.33,10.68 9.05,12.03C9.77,10.68 11.19,9.76 12.82,9.76C15.18,9.76 17.1,11.68 17.1,14.04V14.04M7.84,14.04V14.04C7.84,12.62 6.69,11.47 5.28,11.47C3.86,11.47 2.71,12.62 2.71,14.04V14.04C2.71,15.45 3.86,16.6 5.28,16.6C6.69,16.6 7.84,15.45 7.84,14.04M22.84,16.96V16.96C22.95,17.12 23,17.3 23,17.47C23,17.73 22.88,18 22.66,18.15C22.5,18.26 22.33,18.32 22.15,18.32C21.9,18.32 21.65,18.21 21.5,18L19.59,15.47L17.7,18V18C17.53,18.21 17.28,18.32 17.03,18.32C16.85,18.32 16.67,18.26 16.5,18.15C16.29,18 16.17,17.72 16.17,17.46C16.17,17.29 16.23,17.11 16.33,16.96V16.96H16.33V16.96L18.5,14.04L16.33,11.11V11.11H16.33V11.11C16.22,10.96 16.17,10.79 16.17,10.61C16.17,10.35 16.29,10.1 16.5,9.93C16.89,9.65 17.41,9.72 17.7,10.09V10.09L19.59,12.61L21.5,10.09C21.76,9.72 22.29,9.65 22.66,9.93C22.89,10.1 23,10.36 23,10.63C23,10.8 22.95,10.97 22.84,11.11V11.11H22.84V11.11L20.66,14.04L22.84,16.96V16.96H22.84Z";
var mdiBoxCutter = "M7.22,11.91C6.89,12.24 6.71,12.65 6.66,13.08L12.17,15.44L20.66,6.96C21.44,6.17 21.44,4.91 20.66,4.13L19.24,2.71C18.46,1.93 17.2,1.93 16.41,2.71L7.22,11.91M5,16V21.75L10.81,16.53L5.81,14.53L5,16M17.12,4.83C17.5,4.44 18.15,4.44 18.54,4.83C18.93,5.23 18.93,5.86 18.54,6.25C18.15,6.64 17.5,6.64 17.12,6.25C16.73,5.86 16.73,5.23 17.12,4.83Z";
var mdiBoxCutterOff = "M20.84 22.73L12.86 14.75L12.17 15.44L6.66 13.08C6.71 12.65 6.89 12.24 7.22 11.91L8.62 10.5L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M15.41 12.21L11.16 7.96L16.41 2.71C17.2 1.93 18.46 1.93 19.24 2.71L20.66 4.13C21.44 4.91 21.44 6.17 20.66 6.96L15.41 12.21M17.12 6.25C17.5 6.64 18.15 6.64 18.54 6.25C18.93 5.86 18.93 5.23 18.54 4.83C18.15 4.44 17.5 4.44 17.12 4.83C16.73 5.23 16.73 5.86 17.12 6.25M5 16V21.75L10.81 16.53L5.81 14.53L5 16Z";
var mdiBoxShadow = "M3,3H18V18H3V3M19,19H21V21H19V19M19,16H21V18H19V16M19,13H21V15H19V13M19,10H21V12H19V10M19,7H21V9H19V7M16,19H18V21H16V19M13,19H15V21H13V19M10,19H12V21H10V19M7,19H9V21H7V19Z";
var mdiBoxingGlove = "M19,16V6H22V16H19M12,4C8,4 7,4 7,4C7,4 2,4 2,8V14C2,15.77 3,16.76 4.07,17.31C4.4,15.43 6.03,14 8,14H11V16H8A2,2 0 0,0 6,18C6,19.11 6.9,20 8,20H13C17,20 17,16 17,16V6C17,6 16,4 12,4Z";
var mdiBraille = "M7,8A1,1 0 0,1 8,7A1,1 0 0,1 9,8V12.47L10.21,12.6L15.15,14.79C15.67,15.03 16,15.56 16,16.14V20.5C15.97,21.32 15.32,21.97 14.5,22H8C7.62,22 7.26,21.85 7,21.57L2.1,17.37L2.84,16.6C3.03,16.39 3.3,16.28 3.58,16.28H3.8L7,18V8M19.5,2A1.5,1.5 0 0,0 18,3.5A1.5,1.5 0 0,0 19.5,5A1.5,1.5 0 0,0 21,3.5A1.5,1.5 0 0,0 19.5,2M19.5,7A1.5,1.5 0 0,0 18,8.5A1.5,1.5 0 0,0 19.5,10A1.5,1.5 0 0,0 21,8.5A1.5,1.5 0 0,0 19.5,7M14.5,7A1.5,1.5 0 0,0 13,8.5A1.5,1.5 0 0,0 14.5,10A1.5,1.5 0 0,0 16,8.5A1.5,1.5 0 0,0 14.5,7M19.5,12A1.5,1.5 0 0,0 18,13.5A1.5,1.5 0 0,0 19.5,15A1.5,1.5 0 0,0 21,13.5A1.5,1.5 0 0,0 19.5,12Z";
var mdiBrain = "M21.33,12.91C21.42,14.46 20.71,15.95 19.44,16.86L20.21,18.35C20.44,18.8 20.47,19.33 20.27,19.8C20.08,20.27 19.69,20.64 19.21,20.8L18.42,21.05C18.25,21.11 18.06,21.14 17.88,21.14C17.37,21.14 16.89,20.91 16.56,20.5L14.44,18C13.55,17.85 12.71,17.47 12,16.9C11.5,17.05 11,17.13 10.5,17.13C9.62,17.13 8.74,16.86 8,16.34C7.47,16.5 6.93,16.57 6.38,16.56C5.59,16.57 4.81,16.41 4.08,16.11C2.65,15.47 1.7,14.07 1.65,12.5C1.57,11.78 1.69,11.05 2,10.39C1.71,9.64 1.68,8.82 1.93,8.06C2.3,7.11 3,6.32 3.87,5.82C4.45,4.13 6.08,3 7.87,3.12C9.47,1.62 11.92,1.46 13.7,2.75C14.12,2.64 14.56,2.58 15,2.58C16.36,2.55 17.65,3.15 18.5,4.22C20.54,4.75 22,6.57 22.08,8.69C22.13,9.8 21.83,10.89 21.22,11.82C21.29,12.18 21.33,12.54 21.33,12.91M16.33,11.5C16.9,11.57 17.35,12 17.35,12.57A1,1 0 0,1 16.35,13.57H15.72C15.4,14.47 14.84,15.26 14.1,15.86C14.35,15.95 14.61,16 14.87,16.07C20,16 19.4,12.87 19.4,12.82C19.34,11.39 18.14,10.27 16.71,10.33A1,1 0 0,1 15.71,9.33A1,1 0 0,1 16.71,8.33C17.94,8.36 19.12,8.82 20.04,9.63C20.09,9.34 20.12,9.04 20.12,8.74C20.06,7.5 19.5,6.42 17.25,6.21C16,3.25 12.85,4.89 12.85,5.81V5.81C12.82,6.04 13.06,6.53 13.1,6.56A1,1 0 0,1 14.1,7.56C14.1,8.11 13.65,8.56 13.1,8.56V8.56C12.57,8.54 12.07,8.34 11.67,8C11.19,8.31 10.64,8.5 10.07,8.56V8.56C9.5,8.61 9.03,8.21 9,7.66C8.92,7.1 9.33,6.61 9.88,6.56C10.04,6.54 10.82,6.42 10.82,5.79V5.79C10.82,5.13 11.07,4.5 11.5,4C10.58,3.75 9.59,4.08 8.59,5.29C6.75,5 6,5.25 5.45,7.2C4.5,7.67 4,8 3.78,9C4.86,8.78 5.97,8.87 7,9.25C7.5,9.44 7.78,10 7.59,10.54C7.4,11.06 6.82,11.32 6.3,11.13C5.57,10.81 4.75,10.79 4,11.07C3.68,11.34 3.68,11.9 3.68,12.34C3.68,13.08 4.05,13.77 4.68,14.17C5.21,14.44 5.8,14.58 6.39,14.57C6.24,14.31 6.11,14.04 6,13.76C5.81,13.22 6.1,12.63 6.64,12.44C7.18,12.25 7.77,12.54 7.96,13.08C8.36,14.22 9.38,15 10.58,15.13C11.95,15.06 13.17,14.25 13.77,13C14,11.62 15.11,11.5 16.33,11.5M18.33,18.97L17.71,17.67L17,17.83L18,19.08L18.33,18.97M13.68,10.36C13.7,9.83 13.3,9.38 12.77,9.33C12.06,9.29 11.37,9.53 10.84,10C10.27,10.58 9.97,11.38 10,12.19A1,1 0 0,0 11,13.19C11.57,13.19 12,12.74 12,12.19C12,11.92 12.07,11.65 12.23,11.43C12.35,11.33 12.5,11.28 12.66,11.28C13.21,11.31 13.68,10.9 13.68,10.36Z";
var mdiBreadSlice = "M12,2C17.5,2 22,5.36 22,9.5C22,11.19 21.26,12.75 20,14V22H4V14C2.74,12.75 2,11.19 2,9.5C2,5.36 6.5,2 12,2M8,18H12V14H8V18Z";
var mdiBreadSliceOutline = "M12,2C17.5,2 22,5.36 22,9.5C22,11.19 21.26,12.75 20,14V22H4V14C2.74,12.75 2,11.19 2,9.5C2,5.36 6.5,2 12,2M18,13.14C19.24,12.17 20,10.89 20,9.5C20,6.46 16.42,4 12,4C7.58,4 4,6.46 4,9.5C4,10.89 4.76,12.17 6,13.14V20H18V13.14M8,18V14H12V18H8Z";
var mdiBridge = "M7,14V10.91C6.28,10.58 5.61,10.18 5,9.71V14H7M5,18H3V16H1V14H3V7H5V8.43C6.8,10 9.27,11 12,11C14.73,11 17.2,10 19,8.43V7H21V14H23V16H21V18H19V16H5V18M17,10.91V14H19V9.71C18.39,10.18 17.72,10.58 17,10.91M16,14V11.32C15.36,11.55 14.69,11.72 14,11.84V14H16M13,14V11.96L12,12L11,11.96V14H13M10,14V11.84C9.31,11.72 8.64,11.55 8,11.32V14H10Z";
var mdiBriefcase = "M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V19A2,2 0 0,1 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14Z";
var mdiBriefcaseAccount = "M20,6H16V4A2,2 0 0,0 14,2H10C8.89,2 8,2.89 8,4V6H4C2.89,6 2,6.89 2,8V19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19V8A2,2 0 0,0 20,6M10,4H14V6H10V4M12,9A2.5,2.5 0 0,1 14.5,11.5A2.5,2.5 0 0,1 12,14A2.5,2.5 0 0,1 9.5,11.5A2.5,2.5 0 0,1 12,9M17,19H7V17.75C7,16.37 9.24,15.25 12,15.25C14.76,15.25 17,16.37 17,17.75V19Z";
var mdiBriefcaseAccountOutline = "M20,6C20.58,6 21.05,6.2 21.42,6.59C21.8,7 22,7.45 22,8V19C22,19.55 21.8,20 21.42,20.41C21.05,20.8 20.58,21 20,21H4C3.42,21 2.95,20.8 2.58,20.41C2.2,20 2,19.55 2,19V8C2,7.45 2.2,7 2.58,6.59C2.95,6.2 3.42,6 4,6H8V4C8,3.42 8.2,2.95 8.58,2.58C8.95,2.2 9.42,2 10,2H14C14.58,2 15.05,2.2 15.42,2.58C15.8,2.95 16,3.42 16,4V6H20M4,8V19H20V8H4M14,6V4H10V6H14M12,9A2.25,2.25 0 0,1 14.25,11.25C14.25,12.5 13.24,13.5 12,13.5A2.25,2.25 0 0,1 9.75,11.25C9.75,10 10.76,9 12,9M16.5,18H7.5V16.88C7.5,15.63 9.5,14.63 12,14.63C14.5,14.63 16.5,15.63 16.5,16.88V18Z";
var mdiBriefcaseArrowLeftRight = "M10 2H14C15.11 2 16 2.9 16 4V6H20C21.11 6 22 6.9 22 8V13.53C20.94 12.58 19.54 12 18 12C14.69 12 12 14.69 12 18C12 19.09 12.29 20.12 12.8 21H4C2.89 21 2 20.1 2 19V8C2 6.89 2.89 6 4 6H8V4C8 2.89 8.89 2 10 2M14 6V4H10V6H14M19 18.5V17H15V15H19V13.5L22 16L19 18.5M17 19H21V21H17V22.5L14 20L17 17.5V19Z";
var mdiBriefcaseArrowLeftRightOutline = "M10 2H14C15.11 2 16 2.9 16 4V6H20C21.11 6 22 6.9 22 8V13.53C21.42 13 20.75 12.6 20 12.34V8H4V19H12.08C12.2 19.72 12.45 20.39 12.8 21H4C2.9 21 2 20.11 2 19V8C2 6.9 2.9 6 4 6H8V4C8 2.9 8.9 2 10 2M14 6V4H10V6H14M19 18.5V17H15V15H19V13.5L22 16L19 18.5M17 19H21V21H17V22.5L14 20L17 17.5V19Z";
var mdiBriefcaseArrowUpDown = "M10 2H14C15.11 2 16 2.9 16 4V6H20C21.11 6 22 6.9 22 8V13.53C20.94 12.58 19.54 12 18 12C14.69 12 12 14.69 12 18C12 19.09 12.29 20.12 12.8 21H4C2.89 21 2 20.1 2 19V8C2 6.89 2.89 6 4 6H8V4C8 2.89 8.89 2 10 2M14 6V4H10V6H14M17.5 19H19V15H21V19H22.5L20 22L17.5 19M17 17V21H15V17H13.5L16 14L18.5 17H17Z";
var mdiBriefcaseArrowUpDownOutline = "M10 2H14C15.11 2 16 2.9 16 4V6H20C21.11 6 22 6.9 22 8V13.53C21.42 13 20.75 12.6 20 12.34V8H4V19H12.08C12.2 19.72 12.45 20.39 12.8 21H4C2.9 21 2 20.11 2 19V8C2 6.9 2.9 6 4 6H8V4C8 2.9 8.9 2 10 2M14 6V4H10V6H14M17.5 19H19V15H21V19H22.5L20 22L17.5 19M17 17V21H15V17H13.5L16 14L18.5 17H17Z";
var mdiBriefcaseCheck = "M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V8A2,2 0 0,1 4,6H8V4A2,2 0 0,1 10,2M14,6V4H10V6H14M10.5,17.5L17.09,10.91L15.68,9.5L10.5,14.67L8.41,12.59L7,14L10.5,17.5Z";
var mdiBriefcaseCheckOutline = "M20 6C20.58 6 21.05 6.2 21.42 6.59C21.8 7 22 7.45 22 8V19C22 19.55 21.8 20 21.42 20.41C21.05 20.8 20.58 21 20 21H4C3.42 21 2.95 20.8 2.58 20.41C2.2 20 2 19.55 2 19V8C2 7.45 2.2 7 2.58 6.59C2.95 6.2 3.42 6 4 6H8V4C8 3.42 8.2 2.95 8.58 2.58C8.95 2.2 9.42 2 10 2H14C14.58 2 15.05 2.2 15.42 2.58C15.8 2.95 16 3.42 16 4V6H20M4 8V19H20V8H4M14 6V4H10V6H14M10.46 17.5L17.05 10.91L15.64 9.5L10.46 14.67L8.37 12.59L6.96 14L10.46 17.5Z";
var mdiBriefcaseClock = "M21 11.11V7A2 2 0 0 0 19 5H15V3A2 2 0 0 0 13 1H9A2 2 0 0 0 7 3V5H3A2 2 0 0 0 1 7V18A2 2 0 0 0 3 20H10.26A7 7 0 1 0 21 11.11M9 3H13V5H9M19 20A5 5 0 0 1 13 20A5 5 0 1 1 19 20M15 13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69V13";
var mdiBriefcaseClockOutline = "M21 11.11V7A2 2 0 0 0 20.42 5.59A1.87 1.87 0 0 0 19 5H15V3A1.9 1.9 0 0 0 14.42 1.58A1.9 1.9 0 0 0 13 1H9A1.9 1.9 0 0 0 7.58 1.58A1.9 1.9 0 0 0 7 3V5H3A1.87 1.87 0 0 0 1.58 5.59A2 2 0 0 0 1 7V18A2 2 0 0 0 1.58 19.41A1.87 1.87 0 0 0 3 20H10.26A7 7 0 1 0 21 11.11M9 3H13V5H9M3 18V7H19V9.68A6.84 6.84 0 0 0 16 9A7 7 0 0 0 9 16A6.91 6.91 0 0 0 9.29 18M19 20A5 5 0 0 1 13 20A4.94 4.94 0 0 1 11 16A5 5 0 0 1 16 11A4.94 4.94 0 0 1 19 12A5 5 0 0 1 19 20M15 13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69V13";
var mdiBriefcaseDownload = "M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V19A2,2 0 0,1 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14M12,19L17,14H14V10H10V14H7L12,19Z";
var mdiBriefcaseDownloadOutline = "M12,18L7,13H10V9H14V13H17L12,18M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V19A2,2 0 0,1 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14M4,8V19H20V8H4Z";
var mdiBriefcaseEdit = "M14,2A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8L10.85,19C10.85,20.1 10.85,19.5 10.85,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2H14M14,6V4H10V6H14M21.04,12.13C20.9,12.13 20.76,12.19 20.65,12.3L19.65,13.3L21.7,15.35L22.7,14.35C22.92,14.14 22.92,13.79 22.7,13.58L21.42,12.3C21.31,12.19 21.18,12.13 21.04,12.13M19.07,13.88L13,19.94V22H15.06L21.12,15.93L19.07,13.88Z";
var mdiBriefcaseEditOutline = "M21.04,12.13C21.18,12.13 21.31,12.19 21.42,12.3L22.7,13.58C22.92,13.79 22.92,14.14 22.7,14.35L21.7,15.35L19.65,13.3L20.65,12.3C20.76,12.19 20.9,12.13 21.04,12.13M19.07,13.88L21.12,15.93L15.06,22H13V19.94L19.07,13.88M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8L20,10V8H4V19H11V21H4A2,2 0 0,1 2,19V8A2,2 0 0,1 4,6H8V4A2,2 0 0,1 10,2M14,6V4H10V6H14Z";
var mdiBriefcaseEye = "M17 18C17.6 18 18 18.4 18 19S17.6 20 17 20 16 19.6 16 19 16.4 18 17 18M9.1 19.7L8.8 19L9.1 18.3C10.4 15.1 13.5 13 17 13C18.9 13 20.6 13.6 22 14.6V8C22 6.9 21.1 6 20 6H16V4C16 2.9 15.1 2 14 2H10C8.9 2 8 2.9 8 4V6H4C2.9 6 2 6.9 2 8V19C2 20.1 2.9 21 4 21H9.8C9.5 20.6 9.3 20.2 9.1 19.7M10 4H14V6H10V4M17 15C14.3 15 11.9 16.7 11 19C11.9 21.3 14.3 23 17 23S22.1 21.3 23 19C22.1 16.7 19.7 15 17 15M17 21.5C15.6 21.5 14.5 20.4 14.5 19S15.6 16.5 17 16.5 19.5 17.6 19.5 19 18.4 21.5 17 21.5Z";
var mdiBriefcaseEyeOutline = "M17 18C17.6 18 18 18.4 18 19S17.6 20 17 20 16 19.6 16 19 16.4 18 17 18M17 15C14.3 15 11.9 16.7 11 19C11.9 21.3 14.3 23 17 23S22.1 21.3 23 19C22.1 16.7 19.7 15 17 15M17 21.5C15.6 21.5 14.5 20.4 14.5 19S15.6 16.5 17 16.5 19.5 17.6 19.5 19 18.4 21.5 17 21.5M9.1 19.7L8.8 19H4V8H20V13.6C20.7 13.9 21.4 14.2 22 14.7V8C22 7.5 21.8 7 21.4 6.6C21 6.2 20.6 6 20 6H16V4C16 3.4 15.8 3 15.4 2.6C15 2.2 14.6 2 14 2H10C9.4 2 9 2.2 8.6 2.6C8.2 3 8 3.4 8 4V6H4C3.4 6 3 6.2 2.6 6.6C2.2 7 2 7.5 2 8V19C2 19.5 2.2 20 2.6 20.4C3 20.8 3.4 21 4 21H9.8C9.5 20.6 9.3 20.2 9.1 19.7M10 4H14V6H10V4Z";
var mdiBriefcaseMinus = "M22,17V19H14V17H22M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V13.53C20.94,12.58 19.54,12 18,12A6,6 0 0,0 12,18C12,19.09 12.29,20.12 12.8,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14Z";
var mdiBriefcaseMinusOutline = "M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V13.53C21.42,13 20.75,12.6 20,12.34V8H4V19H12.08C12.2,19.72 12.45,20.39 12.8,21H4A2,2 0 0,1 2,19V8A2,2 0 0,1 4,6H8V4A2,2 0 0,1 10,2M14,6V4H10V6H14M14,17H22V19H14V17Z";
var mdiBriefcaseOff = "M22.11 21.46L20.84 22.73L19.11 21H4C2.89 21 2 20.1 2 19V8C2 6.89 2.89 6 4 6H4.11L1.11 3L2.39 1.73L22.11 21.46M22 18.8L8 4.8V4C8 2.89 8.89 2 10 2H14C15.11 2 16 2.9 16 4V6H20C21.11 6 22 6.9 22 8V18.8M14 4H10V6H14V4Z";
var mdiBriefcaseOffOutline = "M20 8V16.8L22 18.8V8C22 7.45 21.8 7 21.42 6.59C21.05 6.2 20.58 6 20 6H16V4C16 3.42 15.8 2.95 15.42 2.58C15.05 2.2 14.58 2 14 2H10C9.42 2 8.95 2.2 8.58 2.58C8.2 2.95 8 3.42 8 4V4.8L11.2 8H20M10 4H14V6H10V4M2.39 1.73L1.11 3L4.11 6H4C3.42 6 2.95 6.2 2.58 6.59C2.2 7 2 7.45 2 8V19C2 19.55 2.2 20 2.58 20.41C2.95 20.8 3.42 21 4 21H19.11L20.84 22.73L22.11 21.46L2.39 1.73M4 19V8H6.11L17.11 19H4Z";
var mdiBriefcaseOutline = "M20,6C20.58,6 21.05,6.2 21.42,6.59C21.8,7 22,7.45 22,8V19C22,19.55 21.8,20 21.42,20.41C21.05,20.8 20.58,21 20,21H4C3.42,21 2.95,20.8 2.58,20.41C2.2,20 2,19.55 2,19V8C2,7.45 2.2,7 2.58,6.59C2.95,6.2 3.42,6 4,6H8V4C8,3.42 8.2,2.95 8.58,2.58C8.95,2.2 9.42,2 10,2H14C14.58,2 15.05,2.2 15.42,2.58C15.8,2.95 16,3.42 16,4V6H20M4,8V19H20V8H4M14,6V4H10V6H14Z";
var mdiBriefcasePlus = "M17,14H19V17H22V19H19V22H17V19H14V17H17V14M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V13.53C20.94,12.58 19.54,12 18,12A6,6 0 0,0 12,18C12,19.09 12.29,20.12 12.8,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14Z";
var mdiBriefcasePlusOutline = "M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V13.53C21.42,13 20.75,12.6 20,12.34V8H4V19H12.08C12.2,19.72 12.45,20.39 12.8,21H4A2,2 0 0,1 2,19V8A2,2 0 0,1 4,6H8V4A2,2 0 0,1 10,2M14,6V4H10V6H14M14,17H17V14H19V17H22V19H19V22H17V19H14V17Z";
var mdiBriefcaseRemove = "M14.46,15.88L15.88,14.46L18,16.59L20.12,14.46L21.54,15.88L19.41,18L21.54,20.12L20.12,21.54L18,19.41L15.88,21.54L14.46,20.12L16.59,18L14.46,15.88M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V13.53C20.94,12.58 19.54,12 18,12A6,6 0 0,0 12,18C12,19.09 12.29,20.12 12.8,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14Z";
var mdiBriefcaseRemoveOutline = "M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V13.53C21.42,13 20.75,12.6 20,12.34V8H4V19H12.08C12.2,19.72 12.45,20.39 12.8,21H4A2,2 0 0,1 2,19V8A2,2 0 0,1 4,6H8V4A2,2 0 0,1 10,2M14,6V4H10V6H14M14.46,15.88L15.88,14.46L18,16.59L20.12,14.46L21.54,15.88L19.41,18L21.54,20.12L20.12,21.54L18,19.41L15.88,21.54L14.46,20.12L16.59,18L14.46,15.88Z";
var mdiBriefcaseSearch = "M16.5,12C19,12 21,14 21,16.5C21,17.38 20.75,18.21 20.31,18.9L23.39,22L22,23.39L18.88,20.32C18.19,20.75 17.37,21 16.5,21C14,21 12,19 12,16.5C12,14 14,12 16.5,12M16.5,14A2.5,2.5 0 0,0 14,16.5A2.5,2.5 0 0,0 16.5,19A2.5,2.5 0 0,0 19,16.5A2.5,2.5 0 0,0 16.5,14M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V13.03C20.85,11.21 18.82,10 16.5,10A6.5,6.5 0 0,0 10,16.5C10,18.25 10.69,19.83 11.81,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14Z";
var mdiBriefcaseSearchOutline = "M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V13.03C21.5,12.23 20.8,11.54 20,11V8H4V19H10.5C10.81,19.75 11.26,20.42 11.81,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14M20.31,18.9L23.39,22L22,23.39L18.88,20.32C18.19,20.75 17.37,21 16.5,21C14,21 12,19 12,16.5C12,14 14,12 16.5,12C19,12 21,14 21,16.5C21,17.38 20.75,18.21 20.31,18.9M16.5,19A2.5,2.5 0 0,0 19,16.5A2.5,2.5 0 0,0 16.5,14A2.5,2.5 0 0,0 14,16.5A2.5,2.5 0 0,0 16.5,19Z";
var mdiBriefcaseUpload = "M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V19A2,2 0 0,1 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14M12,9L7,14H10V18H14V14H17L12,9Z";
var mdiBriefcaseUploadOutline = "M12,9L17,14H14V18H10V14H7L12,9M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V19A2,2 0 0,1 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14M4,8V19H20V8H4Z";
var mdiBriefcaseVariant = "M10 16V15H3L3 19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V15H14V16H10M20 7H16V5L14 3H10L8 5V7H4C2.9 7 2 7.9 2 9V12C2 13.11 2.89 14 4 14H10V12H14V14H20C21.1 14 22 13.1 22 12V9C22 7.9 21.1 7 20 7M14 7H10V5H14V7Z";
var mdiBriefcaseVariantOff = "M10 6.8L8.1 4.9L10 3H14L16 5V7H20C21.1 7 22 7.9 22 9V12C22 13.1 21.1 14 20 14H17.2L10.2 7H14V5H10V6.8M2.39 1.73L1.11 3L5.11 7H4C2.9 7 2 7.9 2 9V12C2 13.11 2.89 14 4 14H10V12H10.11L14 15.89V16H10V15H3V19C3 20.11 3.89 21 5 21H19C19.03 21 19.07 21 19.1 21L20.84 22.73L22.11 21.46L2.39 1.73M21 17.8V15H18.2L21 17.8Z";
var mdiBriefcaseVariantOffOutline = "M10 6.8L8.1 4.9L10 3H14L16 5V7H20C21.1 7 22 7.9 22 9V14C22 14.73 21.59 15.37 21 15.72V17.8L17.2 14H20V9H12.2L10.2 7H14V5H10V6.8M22.11 21.46L20.84 22.73L19.1 21C19.07 21 19.03 21 19 21H5C3.89 21 3 20.11 3 19V15.73C2.4 15.38 2 14.75 2 14V9C2 7.9 2.9 7 4 7H5.11L1.11 3L2.39 1.73L22.11 21.46M11 15H13V14.89L11.11 13H11V15M9 14V11H9.11L7.11 9H4V14H9M17.11 19L15 16.89V17H9V16H5V19H17.11Z";
var mdiBriefcaseVariantOutline = "M20 7H16V5L14 3H10L8 5V7H4C2.9 7 2 7.9 2 9V14C2 14.75 2.4 15.38 3 15.73V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V15.72C21.59 15.37 22 14.73 22 14V9C22 7.9 21.1 7 20 7M10 5H14V7H10V5M4 9H20V14H15V11H9V14H4V9M13 15H11V13H13V15M19 19H5V16H9V17H15V16H19V19Z";
var mdiBrightness1 = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiBrightness2 = "M10,2C8.18,2 6.47,2.5 5,3.35C8,5.08 10,8.3 10,12C10,15.7 8,18.92 5,20.65C6.47,21.5 8.18,22 10,22A10,10 0 0,0 20,12A10,10 0 0,0 10,2Z";
var mdiBrightness3 = "M9,2C7.95,2 6.95,2.16 6,2.46C10.06,3.73 13,7.5 13,12C13,16.5 10.06,20.27 6,21.54C6.95,21.84 7.95,22 9,22A10,10 0 0,0 19,12A10,10 0 0,0 9,2Z";
var mdiBrightness4 = "M12,18C11.11,18 10.26,17.8 9.5,17.45C11.56,16.5 13,14.42 13,12C13,9.58 11.56,7.5 9.5,6.55C10.26,6.2 11.11,6 12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18M20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31L23.31,12L20,8.69Z";
var mdiBrightness5 = "M12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18M20,15.31L23.31,12L20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31Z";
var mdiBrightness6 = "M12,18V6A6,6 0 0,1 18,12A6,6 0 0,1 12,18M20,15.31L23.31,12L20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31Z";
var mdiBrightness7 = "M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8M12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18M20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31L23.31,12L20,8.69Z";
var mdiBrightnessAuto = "M14.3,16L13.6,14H10.4L9.7,16H7.8L11,7H13L16.2,16H14.3M20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31L23.31,12L20,8.69M10.85,12.65H13.15L12,9L10.85,12.65Z";
var mdiBrightnessPercent = "M20.04,8.71V4H15.34L12,0.69L8.71,4H4V8.71L0.69,12L4,15.34V20.04H8.71L12,23.35L15.34,20.04H20.04V15.34L23.35,12L20.04,8.71M8.83,7.05C9.81,7.05 10.6,7.84 10.6,8.83A1.77,1.77 0 0,1 8.83,10.6C7.84,10.6 7.05,9.81 7.05,8.83C7.05,7.84 7.84,7.05 8.83,7.05M15.22,17C14.24,17 13.45,16.2 13.45,15.22A1.77,1.77 0 0,1 15.22,13.45C16.2,13.45 17,14.24 17,15.22A1.78,1.78 0 0,1 15.22,17M8.5,17.03L7,15.53L15.53,7L17.03,8.5L8.5,17.03Z";
var mdiBroadcast = "M12 10C10.9 10 10 10.9 10 12S10.9 14 12 14 14 13.1 14 12 13.1 10 12 10M18 12C18 8.7 15.3 6 12 6S6 8.7 6 12C6 14.2 7.2 16.1 9 17.2L10 15.5C8.8 14.8 8 13.5 8 12.1C8 9.9 9.8 8.1 12 8.1S16 9.9 16 12.1C16 13.6 15.2 14.9 14 15.5L15 17.2C16.8 16.2 18 14.2 18 12M12 2C6.5 2 2 6.5 2 12C2 15.7 4 18.9 7 20.6L8 18.9C5.6 17.5 4 14.9 4 12C4 7.6 7.6 4 12 4S20 7.6 20 12C20 15 18.4 17.5 16 18.9L17 20.6C20 18.9 22 15.7 22 12C22 6.5 17.5 2 12 2Z";
var mdiBroadcastOff = "M17.6 14.2C17.9 13.5 18 12.8 18 12C18 8.7 15.3 6 12 6C11.2 6 10.4 6.2 9.8 6.4L11.4 8H12C14.2 8 16 9.8 16 12C16 12.2 16 12.4 15.9 12.6L17.6 14.2M12 4C16.4 4 20 7.6 20 12C20 13.4 19.6 14.6 19 15.7L20.5 17.2C21.4 15.7 22 13.9 22 12C22 6.5 17.5 2 12 2C10.1 2 8.3 2.5 6.8 3.5L8.3 5C9.4 4.3 10.6 4 12 4M3.3 2.5L2 3.8L4.1 5.9C2.8 7.6 2 9.7 2 12C2 15.7 4 18.9 7 20.6L8 18.9C5.6 17.5 4 14.9 4 12C4 10.2 4.6 8.6 5.5 7.3L7 8.8C6.4 9.7 6 10.8 6 12C6 14.2 7.2 16.1 9 17.2L10 15.5C8.8 14.8 8 13.5 8 12.1C8 11.5 8.2 10.9 8.4 10.3L10 11.9V12.1C10 13.2 10.9 14.1 12 14.1H12.2L19.7 21.6L21 20.3L4.3 3.5L3.3 2.5Z";
var mdiBroom = "M19.36,2.72L20.78,4.14L15.06,9.85C16.13,11.39 16.28,13.24 15.38,14.44L9.06,8.12C10.26,7.22 12.11,7.37 13.65,8.44L19.36,2.72M5.93,17.57C3.92,15.56 2.69,13.16 2.35,10.92L7.23,8.83L14.67,16.27L12.58,21.15C10.34,20.81 7.94,19.58 5.93,17.57Z";
var mdiBrush = "M20.71,4.63L19.37,3.29C19,2.9 18.35,2.9 17.96,3.29L9,12.25L11.75,15L20.71,6.04C21.1,5.65 21.1,5 20.71,4.63M7,14A3,3 0 0,0 4,17C4,18.31 2.84,19 2,19C2.92,20.22 4.5,21 6,21A4,4 0 0,0 10,17A3,3 0 0,0 7,14Z";
var mdiBrushOff = "M20.8 22.7L12.4 14.3L11.8 15L9 12.2L9.7 11.5L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M7 14C5.3 14 4 15.3 4 17C4 18.3 2.8 19 2 19C2.9 20.2 4.5 21 6 21C8.2 21 10 19.2 10 17C10 15.3 8.7 14 7 14M20.7 6C21.1 5.6 21.1 5 20.7 4.6L19.4 3.3C19 2.9 18.4 2.9 18 3.3L12.2 9L15 11.8L20.7 6Z";
var mdiBrushOutline = "M7 16C7.55 16 8 16.45 8 17C8 18.1 7.1 19 6 19C5.83 19 5.67 19 5.5 18.95C5.81 18.4 6 17.74 6 17C6 16.45 6.45 16 7 16M18.67 3C18.41 3 18.16 3.1 17.96 3.29L9 12.25L11.75 15L20.71 6.04C21.1 5.65 21.1 5 20.71 4.63L19.37 3.29C19.17 3.09 18.92 3 18.67 3M7 14C5.34 14 4 15.34 4 17C4 18.31 2.84 19 2 19C2.92 20.22 4.5 21 6 21C8.21 21 10 19.21 10 17C10 15.34 8.66 14 7 14Z";
var mdiBrushVariant = "M8 3C5.79 3 4 4.79 4 7V14C4 15.1 4.9 16 6 16H9V20C9 21.1 9.9 22 11 22H13C14.1 22 15 21.1 15 20V16H18C19.1 16 20 15.1 20 14V3H8M8 5H12V7H14V5H15V9H17V5H18V10H6V7C6 5.9 6.9 5 8 5M6 14V12H18V14H6Z";
var mdiBucket = "M3 4H21V7H20L17.5 21H6.5L4 7H3V4Z";
var mdiBucketOutline = "M3 4H21V7H20L17.5 21H6.5L4 7H3V4M17.97 7H6.03L8.15 19H15.85L17.97 7Z";
var mdiBuffet = "M9 14C9.55 14 10 14.45 10 15C10 15.55 9.55 16 9 16C8.45 16 8 15.55 8 15C8 14.45 8.45 14 9 14M15 14C15.55 14 16 14.45 16 15C16 15.55 15.55 16 15 16C14.45 16 14 15.55 14 15C14 14.45 14.45 14 15 14M3 22L4 19H3C2.45 19 2 18.55 2 18V12C2 11.45 2.45 11 3 11H21C21.55 11 22 11.45 22 12V18C22 18.55 21.55 19 21 19H20L21 22H19L18 19H6L5 22H3M13 13V17H20V13H13M4 13V17H11V13H4Z";
var mdiBug = "M14,12H10V10H14M14,16H10V14H14M20,8H17.19C16.74,7.22 16.12,6.55 15.37,6.04L17,4.41L15.59,3L13.42,5.17C12.96,5.06 12.5,5 12,5C11.5,5 11.04,5.06 10.59,5.17L8.41,3L7,4.41L8.62,6.04C7.88,6.55 7.26,7.22 6.81,8H4V10H6.09C6.04,10.33 6,10.66 6,11V12H4V14H6V15C6,15.34 6.04,15.67 6.09,16H4V18H6.81C7.85,19.79 9.78,21 12,21C14.22,21 16.15,19.79 17.19,18H20V16H17.91C17.96,15.67 18,15.34 18,15V14H20V12H18V11C18,10.66 17.96,10.33 17.91,10H20V8Z";
var mdiBugCheck = "M19 7H16.19C15.74 6.2 15.12 5.5 14.37 5L16 3.41L14.59 2L12.42 4.17C11.96 4.06 11.5 4 11 4S10.05 4.06 9.59 4.17L7.41 2L6 3.41L7.62 5C6.87 5.5 6.26 6.21 5.81 7H3V9H5.09C5.03 9.33 5 9.66 5 10V11H3V13H5V14C5 14.34 5.03 14.67 5.09 15H3V17H5.81C7.26 19.5 10.28 20.61 13 19.65V19C13 16.46 14.61 14.2 17 13.35V13H19V11H17V10C17 9.66 16.97 9.33 16.91 9H19V7M13 15H9V13H13V15M13 11H9V9H13V11M17.75 22.16L15 19.16L16.16 18L17.75 19.59L21.34 16L22.5 17.41L17.75 22.16Z";
var mdiBugCheckOutline = "M19 7H16.19C15.74 6.2 15.12 5.5 14.37 5L16 3.41L14.59 2L12.42 4.17C11.96 4.06 11.5 4 11 4S10.05 4.06 9.59 4.17L7.41 2L6 3.41L7.62 5C6.87 5.5 6.26 6.21 5.81 7H3V9H5.09C5.03 9.33 5 9.66 5 10V11H3V13H5V14C5 14.34 5.03 14.67 5.09 15H3V17H5.81C7.26 19.5 10.28 20.61 13 19.65V19C13 18.43 13.09 17.86 13.25 17.31C12.59 17.76 11.8 18 11 18C8.79 18 7 16.21 7 14V10C7 7.79 8.79 6 11 6S15 7.79 15 10V14C15 14.19 15 14.39 14.95 14.58C15.54 14.04 16.24 13.62 17 13.35V13H19V11H17V10C17 9.66 16.97 9.33 16.91 9H19V7M21.34 16L17.75 19.59L16.16 18L15 19.16L17.75 22.16L22.5 17.41L21.34 16M13 9V11H9V9H13M13 13V15H9V13H13Z";
var mdiBugOutline = "M20,8H17.19C16.74,7.2 16.12,6.5 15.37,6L17,4.41L15.59,3L13.42,5.17C12.96,5.06 12.5,5 12,5C11.5,5 11.05,5.06 10.59,5.17L8.41,3L7,4.41L8.62,6C7.87,6.5 7.26,7.21 6.81,8H4V10H6.09C6.03,10.33 6,10.66 6,11V12H4V14H6V15C6,15.34 6.03,15.67 6.09,16H4V18H6.81C8.47,20.87 12.14,21.84 15,20.18C15.91,19.66 16.67,18.9 17.19,18H20V16H17.91C17.97,15.67 18,15.34 18,15V14H20V12H18V11C18,10.66 17.97,10.33 17.91,10H20V8M16,15A4,4 0 0,1 12,19A4,4 0 0,1 8,15V11A4,4 0 0,1 12,7A4,4 0 0,1 16,11V15M14,10V12H10V10H14M10,14H14V16H10V14Z";
var mdiBugPause = "M19 7H16.19C15.74 6.2 15.12 5.5 14.37 5L16 3.41L14.59 2L12.42 4.17C11.96 4.06 11.5 4 11 4S10.05 4.06 9.59 4.17L7.41 2L6 3.41L7.62 5C6.87 5.5 6.26 6.21 5.81 7H3V9H5.09C5.03 9.33 5 9.66 5 10V11H3V13H5V14C5 14.34 5.03 14.67 5.09 15H3V17H5.81C7.26 19.5 10.28 20.61 13 19.65V19C13 16.46 14.61 14.2 17 13.35V13H19V11H17V10C17 9.66 16.97 9.33 16.91 9H19V7M13 15H9V13H13V15M13 11H9V9H13V11M20 16H22V22H20M16 16H18V22H16V16Z";
var mdiBugPauseOutline = "M19 7H16.19C15.74 6.2 15.12 5.5 14.37 5L16 3.41L14.59 2L12.42 4.17C11.96 4.06 11.5 4 11 4S10.05 4.06 9.59 4.17L7.41 2L6 3.41L7.62 5C6.87 5.5 6.26 6.21 5.81 7H3V9H5.09C5.03 9.33 5 9.66 5 10V11H3V13H5V14C5 14.34 5.03 14.67 5.09 15H3V17H5.81C7.26 19.5 10.28 20.61 13 19.65V19C13 18.43 13.09 17.86 13.25 17.31C12.59 17.76 11.8 18 11 18C8.79 18 7 16.21 7 14V10C7 7.79 8.79 6 11 6S15 7.79 15 10V14C15 14.19 15 14.39 14.95 14.58C15.54 14.04 16.24 13.62 17 13.35V13H19V11H17V10C17 9.66 16.97 9.33 16.91 9H19V7M13 9V11H9V9H13M13 13V15H9V13H13M20 16H22V22H20M16 16H18V22H16V16Z";
var mdiBugPlay = "M19 7H16.19C15.74 6.2 15.12 5.5 14.37 5L16 3.41L14.59 2L12.42 4.17C11.96 4.06 11.5 4 11 4S10.05 4.06 9.59 4.17L7.41 2L6 3.41L7.62 5C6.87 5.5 6.26 6.21 5.81 7H3V9H5.09C5.03 9.33 5 9.66 5 10V11H3V13H5V14C5 14.34 5.03 14.67 5.09 15H3V17H5.81C7.26 19.5 10.28 20.61 13 19.65V19C13 16.46 14.61 14.2 17 13.35V13H19V11H17V10C17 9.66 16.97 9.33 16.91 9H19V7M13 15H9V13H13V15M13 11H9V9H13V11M17 16V22L22 19L17 16Z";
var mdiBugPlayOutline = "M19 7H16.19C15.74 6.2 15.12 5.5 14.37 5L16 3.41L14.59 2L12.42 4.17C11.96 4.06 11.5 4 11 4S10.05 4.06 9.59 4.17L7.41 2L6 3.41L7.62 5C6.87 5.5 6.26 6.21 5.81 7H3V9H5.09C5.03 9.33 5 9.66 5 10V11H3V13H5V14C5 14.34 5.03 14.67 5.09 15H3V17H5.81C7.26 19.5 10.28 20.61 13 19.65V19C13 18.43 13.09 17.86 13.25 17.31C12.59 17.76 11.8 18 11 18C8.79 18 7 16.21 7 14V10C7 7.79 8.79 6 11 6S15 7.79 15 10V14C15 14.19 15 14.39 14.95 14.58C15.54 14.04 16.24 13.62 17 13.35V13H19V11H17V10C17 9.66 16.97 9.33 16.91 9H19V7M13 9V11H9V9H13M13 13V15H9V13H13M17 16V22L22 19L17 16Z";
var mdiBugStop = "M19 7H16.19C15.74 6.2 15.12 5.5 14.37 5L16 3.41L14.59 2L12.42 4.17C11.96 4.06 11.5 4 11 4S10.05 4.06 9.59 4.17L7.41 2L6 3.41L7.62 5C6.87 5.5 6.26 6.21 5.81 7H3V9H5.09C5.03 9.33 5 9.66 5 10V11H3V13H5V14C5 14.34 5.03 14.67 5.09 15H3V17H5.81C7.26 19.5 10.28 20.61 13 19.65V19C13 16.46 14.61 14.2 17 13.35V13H19V11H17V10C17 9.66 16.97 9.33 16.91 9H19V7M13 15H9V13H13V15M13 11H9V9H13V11M16 16H22V22H16V16Z";
var mdiBugStopOutline = "M19 7H16.19C15.74 6.2 15.12 5.5 14.37 5L16 3.41L14.59 2L12.42 4.17C11.96 4.06 11.5 4 11 4S10.05 4.06 9.59 4.17L7.41 2L6 3.41L7.62 5C6.87 5.5 6.26 6.21 5.81 7H3V9H5.09C5.03 9.33 5 9.66 5 10V11H3V13H5V14C5 14.34 5.03 14.67 5.09 15H3V17H5.81C7.26 19.5 10.28 20.61 13 19.65V19C13 18.43 13.09 17.86 13.25 17.31C12.59 17.76 11.8 18 11 18C8.79 18 7 16.21 7 14V10C7 7.79 8.79 6 11 6S15 7.79 15 10V14C15 14.19 15 14.39 14.95 14.58C15.54 14.04 16.24 13.62 17 13.35V13H19V11H17V10C17 9.66 16.97 9.33 16.91 9H19V7M13 9V11H9V9H13M13 13V15H9V13H13M16 16H22V22H16V16Z";
var mdiBugle = "M21,6C21,11 12,11 12,11C12,11 6,11 5,11C4,11 3,10 3,10H2V14H3C3,14 4,13 5,13C5.2,13 5.7,13 6.3,13C5.5,13.5 5,14.2 5,15C5,16.8 7.3,18 10.5,18C13.7,18 16,16.8 16,15C16,14.4 15.7,13.8 15.2,13.3C17.8,13.8 21,15 21,18H22V6H21M10.5,16.7C8.2,16.7 6.4,15.9 6.4,15C6.4,14.1 8.2,13.3 10.5,13.3C12.8,13.3 14.6,14.1 14.6,15C14.6,15.9 12.8,16.7 10.5,16.7Z";
var mdiBulkheadLight = "M13 2.09C13 2.06 13 2.03 13 2C13 1.45 12.55 1 12 1S11 1.45 11 2C11 2.03 11 2.06 11 2.09C8.19 2.56 6.03 5 6.03 7.97V16C6.03 19 8.19 21.44 11 21.91C11 21.94 11 21.97 11 22C11 22.55 11.45 23 12 23S13 22.55 13 22C13 21.97 13 21.94 13 21.91C15.81 21.44 17.97 19 17.97 16V7.97C18 5 15.81 2.56 13 2.09M16 8H15V5.4C15.6 6.09 16 7 16 8V8M14 19.44C13.41 19.79 12.73 20 12 20C11.27 20 10.59 19.79 10 19.44V16H14V19.44M10 15V9H14V15H10M9 15H8.03V9H9V15M10 4.56C10.59 4.21 11.27 4 12 4C12.73 4 13.41 4.21 14 4.56V8H10V4.56M15 9H16V15H15V9M9 5.4V8H8.03V7.97C8.03 7 8.4 6.09 9 5.4M8.03 16H9V18.6C8.4 17.91 8.03 17 8.03 16.03V16M15 18.6V16H16V16C16 17 15.6 17.91 15 18.6Z";
var mdiBulldozer = "M4,4A1,1 0 0,0 3,5V10C2.54,10 2.14,10.31 2.03,10.76V13.97H2.29C2.65,13.37 3.3,13 4,13H13C13.7,13 14.35,13.37 14.71,13.97H16.03L16,11V11A1,1 0 0,0 15,10H13V8A1,1 0 0,0 12,7A1,1 0 0,0 11,8V10H9V5A1,1 0 0,0 8,4H4M5,6H7V10L7,11H5V6M17,11V19H22V18L19,17L18,11H17M4,15A2,2 0 0,0 2,17A2,2 0 0,0 4,19H13A2,2 0 0,0 15,17A2,2 0 0,0 13,15H4Z";
var mdiBullet = "M14,22H10V21H14V22M13,10V7H11V10L10,11.5V20H14V11.5L13,10M12,2C12,2 11,3 11,5V6H13V5C13,5 13,3 12,2Z";
var mdiBulletinBoard = "M12.04,2.5L9.53,5H14.53L12.04,2.5M4,7V20H20V7H4M12,0L17,5V5H20A2,2 0 0,1 22,7V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V7A2,2 0 0,1 4,5H7V5L12,0M7,18V14H12V18H7M14,17V10H18V17H14M6,12V9H11V12H6Z";
var mdiBullhorn = "M12,8H4A2,2 0 0,0 2,10V14A2,2 0 0,0 4,16H5V20A1,1 0 0,0 6,21H8A1,1 0 0,0 9,20V16H12L17,20V4L12,8M21.5,12C21.5,13.71 20.54,15.26 19,16V8C20.53,8.75 21.5,10.3 21.5,12Z";
var mdiBullhornOutline = "M12,8H4A2,2 0 0,0 2,10V14A2,2 0 0,0 4,16H5V20A1,1 0 0,0 6,21H8A1,1 0 0,0 9,20V16H12L17,20V4L12,8M15,15.6L13,14H4V10H13L15,8.4V15.6M21.5,12C21.5,13.71 20.54,15.26 19,16V8C20.53,8.75 21.5,10.3 21.5,12Z";
var mdiBullhornVariant = "M20 2V4L4 8V6H2V18H4V16L6 16.5V18.5C6 20.4 7.6 22 9.5 22S13 20.4 13 18.5V18.3L20 20V22H22V2H20M11 18.5C11 19.3 10.3 20 9.5 20S8 19.3 8 18.5V17L11 17.8V18.5Z";
var mdiBullhornVariantOutline = "M20 2V4L4 8V6H2V18H4V16L6 16.5V18.5C6 20.4 7.6 22 9.5 22S13 20.4 13 18.5V18.3L20 20V22H22V2H20M11 18.5C11 19.3 10.3 20 9.5 20S8 19.3 8 18.5V17L11 17.8V18.5M20 18L4 14V10L20 6V18Z";
var mdiBullseye = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z";
var mdiBullseyeArrow = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,10.84 21.79,9.69 21.39,8.61L19.79,10.21C19.93,10.8 20,11.4 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.6,4 13.2,4.07 13.79,4.21L15.4,2.6C14.31,2.21 13.16,2 12,2M19,2L15,6V7.5L12.45,10.05C12.3,10 12.15,10 12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12C14,11.85 14,11.7 13.95,11.55L16.5,9H18L22,5H19V2M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12H16A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8V6Z";
var mdiBulma = "M11.38 2L6.38 7L5.13 15.75L11.38 22L18.88 17L13.88 12L17.63 8.25L11.38 2Z";
var mdiBunkBed = "M1 2V23H3V21H21V23H23V7C23 4.79 21.21 3 19 3H10V8H3V2M6.5 2A2.5 2.5 0 0 0 4 4.5A2.5 2.5 0 0 0 6.5 7A2.5 2.5 0 0 0 9 4.5A2.5 2.5 0 0 0 6.5 2M3 11H21V13.56C20.41 13.21 19.73 13 19 13H10V18H3M6.5 12A2.5 2.5 0 0 0 4 14.5A2.5 2.5 0 0 0 6.5 17A2.5 2.5 0 0 0 9 14.5A2.5 2.5 0 0 0 6.5 12Z";
var mdiBunkBedOutline = "M1 2H3V9H10V3H19C21.2 3 23 4.8 23 7V23H21V21H3V23H1V2M12 5V9H21V7C21 5.9 20.1 5 19 5H12M3 11V19H10V13H19C19.7 13 20.4 13.2 21 13.6V11H3M6.5 13C7.9 13 9 14.1 9 15.5S7.9 18 6.5 18 4 16.9 4 15.5 5.1 13 6.5 13M6.5 14.6C6 14.6 5.6 15 5.6 15.5S6 16.4 6.5 16.4 7.4 16 7.4 15.5 7 14.6 6.5 14.6M12 15V19H21V17C21 15.9 20.1 15 19 15H12M6.5 3C7.9 3 9 4.1 9 5.5S7.9 8 6.5 8 4 6.9 4 5.5 5.1 3 6.5 3M6.5 4.6C6 4.6 5.6 5 5.6 5.5S6 6.4 6.5 6.4 7.4 6 7.4 5.5 7 4.6 6.5 4.6Z";
var mdiBus = "M18,11H6V6H18M16.5,17A1.5,1.5 0 0,1 15,15.5A1.5,1.5 0 0,1 16.5,14A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 16.5,17M7.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,14A1.5,1.5 0 0,1 9,15.5A1.5,1.5 0 0,1 7.5,17M4,16C4,16.88 4.39,17.67 5,18.22V20A1,1 0 0,0 6,21H7A1,1 0 0,0 8,20V19H16V20A1,1 0 0,0 17,21H18A1,1 0 0,0 19,20V18.22C19.61,17.67 20,16.88 20,16V6C20,2.5 16.42,2 12,2C7.58,2 4,2.5 4,6V16Z";
var mdiBusAlert = "M16,1A7,7 0 0,1 23,8C23,11.53 20.39,14.45 17,14.93V18C17,18.84 16.65,19.58 15.96,20.2V22C15.96,22.27 15.87,22.5 15.68,22.71C15.5,22.91 15.26,23 15,23H14C13.71,23 13.47,22.91 13.27,22.71C13.06,22.5 12.96,22.27 12.96,22V21H5.04V22C5.04,22.27 4.94,22.5 4.73,22.71C4.53,22.91 4.29,23 4,23H3C2.74,23 2.5,22.91 2.32,22.71C2.13,22.5 2.04,22.27 2.04,22V20.2C1.35,19.58 1,18.84 1,18V8C1,6.42 1.7,5.35 3.07,4.8C4.44,4.26 6.42,4 9,4L10.23,4.03C11.5,2.2 13.61,1 16,1M16,3A5,5 0 0,0 11,8A5,5 0 0,0 16,13A5,5 0 0,0 21,8A5,5 0 0,0 16,3M15,10H17V12H15V10M15,4H17V9H15V4M3,13H11.09C9.8,11.72 9,9.96 9,8H3V13M4.5,16C3.69,16 3,16.67 3,17.5A1.5,1.5 0 0,0 4.5,19C5.35,19 6,18.33 6,17.5A1.5,1.5 0 0,0 4.5,16M13.5,16C12.65,16 12,16.67 12,17.5A1.5,1.5 0 0,0 13.5,19C14.31,19 15,18.33 15,17.5A1.5,1.5 0 0,0 13.5,16Z";
var mdiBusArticulatedEnd = "M21.5,6L20,7.5L21.5,9L20,10.5L21.5,12L20,13.5L21.5,15H12.5A3,3 0 0,1 9.5,18A3,3 0 0,1 6.5,15H2.5V8C2.5,6.89 3.39,6 4.5,6H21.5M18.5,7.5H15V10H18.5V7.5M13.5,7.5H9.5V10H13.5V7.5M8,7.5H4V10H8V7.5M9.5,13.5A1.5,1.5 0 0,0 8,15A1.5,1.5 0 0,0 9.5,16.5A1.5,1.5 0 0,0 11,15A1.5,1.5 0 0,0 9.5,13.5Z";
var mdiBusArticulatedFront = "M1,6L2.5,7.5L1,9L2.5,10.5L1,12L2.5,13.5L1,15H3A3,3 0 0,0 6,18A3,3 0 0,0 9,15H15A3,3 0 0,0 18,18A3,3 0 0,0 21,15H23V8C23,6.89 22.11,6 21,6H1M4,7.5H6.5V10H4V7.5M8,7.5H12V10H8V7.5M13.5,7.5H17.5V10H13.5V7.5M19,7.5H21.5V13L19,11V7.5M6,13.5A1.5,1.5 0 0,1 7.5,15A1.5,1.5 0 0,1 6,16.5A1.5,1.5 0 0,1 4.5,15A1.5,1.5 0 0,1 6,13.5M18,13.5A1.5,1.5 0 0,1 19.5,15A1.5,1.5 0 0,1 18,16.5A1.5,1.5 0 0,1 16.5,15A1.5,1.5 0 0,1 18,13.5Z";
var mdiBusClock = "M16.5,4V8.25L19.36,9.94L18.61,11.16L15,9V4H16.5M16,13C17.36,13 18.54,12.5 19.5,11.53C20.5,10.56 21,9.39 21,8C21,6.64 20.5,5.46 19.5,4.5C18.54,3.5 17.36,3 16,3C14.61,3 13.44,3.5 12.47,4.5C11.5,5.46 11,6.64 11,8C11,9.39 11.5,10.56 12.47,11.53C13.44,12.5 14.61,13 16,13M13.5,19C13.94,19 14.3,18.84 14.58,18.54C14.86,18.24 15,17.89 15,17.5C15,17.08 14.86,16.73 14.58,16.43C14.3,16.13 13.94,16 13.5,16C13.06,16 12.7,16.13 12.42,16.43C12.14,16.73 12,17.08 12,17.5C12,17.89 12.14,18.24 12.42,18.54C12.7,18.84 13.06,19 13.5,19M3,13H11.11C9.7,11.64 9,10 9,8H3V13M4.5,19C4.94,19 5.3,18.84 5.58,18.54C5.86,18.24 6,17.89 6,17.5C6,17.08 5.86,16.73 5.58,16.43C5.3,16.13 4.94,16 4.5,16C4.06,16 3.7,16.13 3.42,16.43C3.14,16.73 3,17.08 3,17.5C3,17.89 3.14,18.24 3.42,18.54C3.7,18.84 4.06,19 4.5,19M16,1C17.92,1 19.58,1.67 20.95,3.05C22.33,4.42 23,6.08 23,8C23,9.77 22.44,11.29 21.28,12.59C20.13,13.88 18.7,14.66 17,14.91V18C17,18.84 16.67,19.58 16,20.2V22C16,22.27 15.89,22.5 15.7,22.71C15.5,22.91 15.28,23 15,23H14C13.73,23 13.5,22.91 13.29,22.71C13.09,22.5 13,22.27 13,22V21H5V22C5,22.27 4.91,22.5 4.71,22.71C4.5,22.91 4.27,23 4,23H3C2.72,23 2.5,22.91 2.3,22.71C2.11,22.5 2,22.27 2,22V20.2C1.33,19.58 1,18.84 1,18V8C1,6.42 1.67,5.35 3.05,4.8C4.42,4.26 6.41,4 9,4C9.13,4 9.33,4 9.61,4C9.89,4 10.09,4.03 10.22,4.03C11.63,2 13.55,1 16,1Z";
var mdiBusDoubleDecker = "M3,4C1.89,4 1,4.89 1,6V17H3A3,3 0 0,0 6,20A3,3 0 0,0 9,17H15A3,3 0 0,0 18,20A3,3 0 0,0 21,17H23V14C23,12.89 22.11,12 21,12H19V9.5H23V6C23,4.89 22.11,4 21,4H3M2.5,5.5H6.5V8H2.5V5.5M8,5.5H12V8H8V5.5M13.5,5.5H17.5V8H13.5V5.5M19,5.5H21.5V8H19V5.5M13.5,9.5H17.5V12H13.5V9.5M2.5,9.5H6.5V12H2.5V9.5M8,9.5H12V12H8V9.5M6,15.5A1.5,1.5 0 0,1 7.5,17A1.5,1.5 0 0,1 6,18.5A1.5,1.5 0 0,1 4.5,17A1.5,1.5 0 0,1 6,15.5M18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5Z";
var mdiBusElectric = "M18 8H6V4H18M16.5 14C15.7 14 15 13.3 15 12.5C15 11.7 15.7 11 16.5 11C17.3 11 18 11.7 18 12.5C18 13.3 17.3 14 16.5 14M7.5 14C6.7 14 6 13.3 6 12.5C6 11.7 6.7 11 7.5 11S9 11.7 9 12.5C9 13.3 8.3 14 7.5 14M4 13C4 13.9 4.4 14.7 5 15.2V17C5 17.6 5.4 18 6 18H7C7.6 18 8 17.6 8 17V16H16V17C16 17.6 16.4 18 17 18H18C18.6 18 19 17.6 19 17V15.2C19.6 14.7 20 13.9 20 13V4C20 .5 16.4 0 12 0S4 .5 4 4V13M7 21H11V19L17 22H13V24L7 21Z";
var mdiBusMarker = "M12 2C7.58 2 4 2.5 4 6V16A3 3 0 0 0 5 18.22V20A1 1 0 0 0 6 21H7A1 1 0 0 0 8 20V19H14A8 8 0 0 1 13 15.5A5.55 5.55 0 0 1 15.38 11H6V6H18V10A4.07 4.07 0 0 1 18.5 10A5.34 5.34 0 0 1 20 10.22V6C20 2.5 16.42 2 12 2M7.5 14A1.5 1.5 0 1 1 6 15.5A1.5 1.5 0 0 1 7.5 14M18.5 12A3.54 3.54 0 0 0 15 15.5C15 18.1 18.5 22 18.5 22S22 18.1 22 15.5A3.54 3.54 0 0 0 18.5 12M18.5 16.8A1.2 1.2 0 1 1 18.5 14.4A1.29 1.29 0 0 1 19.7 15.6A1.15 1.15 0 0 1 18.5 16.8Z";
var mdiBusMultiple = "M10 5C5.58 5 2 5.5 2 9V19C2 19.85 2.37 20.66 3 21.22V23C3 23.55 3.45 24 4 24H5C5.55 24 6 23.55 6 23V22H14V23C14 23.55 14.45 24 15 24H16C16.55 24 17 23.55 17 23V21.22C17.63 20.66 18 19.85 18 19V9C18 5.5 14.42 5 10 5M5.5 20C4.67 20 4 19.33 4 18.5S4.67 17 5.5 17 7 17.67 7 18.5 6.33 20 5.5 20M14.5 20C13.67 20 13 19.33 13 18.5S13.67 17 14.5 17 16 17.67 16 18.5 15.33 20 14.5 20M16 14H4V9H16V14M22 5V15C22 15.85 21.63 16.66 21 17.22V19C21 19.55 20.55 20 20 20H19.88C19.95 19.68 20 19.35 20 19V9C20 3 13 3 10 3C9.09 3 7.8 3 6.46 3.17C7.55 1.32 10.5 1 14 1C18.42 1 22 1.5 22 5Z";
var mdiBusSchool = "M3,6C1.89,6 1,6.89 1,8V15H3A3,3 0 0,0 6,18A3,3 0 0,0 9,15H15A3,3 0 0,0 18,18A3,3 0 0,0 21,15H23V12C23,10.89 22.11,10 21,10H19V8C19,6.89 18.11,6 17,6H3M13.5,7.5H17.5V10H13.5V7.5M2.5,7.5H6.5V10H2.5V7.5M8,7.5H12V10H8V7.5M6,13.5A1.5,1.5 0 0,1 7.5,15A1.5,1.5 0 0,1 6,16.5A1.5,1.5 0 0,1 4.5,15A1.5,1.5 0 0,1 6,13.5M18,13.5A1.5,1.5 0 0,1 19.5,15A1.5,1.5 0 0,1 18,16.5A1.5,1.5 0 0,1 16.5,15A1.5,1.5 0 0,1 18,13.5Z";
var mdiBusSide = "M3,6C1.89,6 1,6.89 1,8V15H3A3,3 0 0,0 6,18A3,3 0 0,0 9,15H15A3,3 0 0,0 18,18A3,3 0 0,0 21,15H23V8C23,6.89 22.11,6 21,6H3M2.5,7.5H6.5V10H2.5V7.5M8,7.5H12V10H8V7.5M13.5,7.5H17.5V10H13.5V7.5M19,7.5H21.5V13L19,11V7.5M6,13.5A1.5,1.5 0 0,1 7.5,15A1.5,1.5 0 0,1 6,16.5A1.5,1.5 0 0,1 4.5,15A1.5,1.5 0 0,1 6,13.5M18,13.5A1.5,1.5 0 0,1 19.5,15A1.5,1.5 0 0,1 18,16.5A1.5,1.5 0 0,1 16.5,15A1.5,1.5 0 0,1 18,13.5Z";
var mdiBusSign = "M4 11H11.07C10.39 12.18 10 13.54 10 15C10 16.46 10.39 17.82 11.07 19H6V20C6 20.27 5.9 20.5 5.71 20.71C5.5 20.9 5.27 21 5 21H4C3.74 21 3.5 20.9 3.29 20.71C3.11 20.5 3 20.27 3 20V18.22C2.39 17.67 2 16.88 2 16V6C2 2.5 5.58 2 10 2C14.42 2 18 2.5 18 6V7C17.31 7 16.64 7.09 16 7.25V6H4V11M5.5 17C5.9 17 6.28 16.84 6.56 16.56C6.84 16.28 7 15.9 7 15.5C7 15.1 6.84 14.72 6.56 14.44C6.28 14.16 5.9 14 5.5 14C5.1 14 4.72 14.16 4.44 14.44C4.16 14.72 4 15.1 4 15.5C4 15.9 4.16 16.28 4.44 16.56C4.72 16.84 5.1 17 5.5 17M15 20V21H21V20C21 19.45 20.55 19 20 19H19V14H21L23 12L21 10H13L15 12L13 14H17V19H16C15.45 19 15 19.45 15 20Z";
var mdiBusStop = "M22 7V16C22 16.71 21.62 17.36 21 17.72V19.25C21 19.66 20.66 20 20.25 20H19.75C19.34 20 19 19.66 19 19.25V18H12V19.25C12 19.66 11.66 20 11.25 20H10.75C10.34 20 10 19.66 10 19.25V17.72C9.39 17.36 9 16.71 9 16V7C9 4 12 4 15.5 4S22 4 22 7M13 15C13 14.45 12.55 14 12 14S11 14.45 11 15 11.45 16 12 16 13 15.55 13 15M20 15C20 14.45 19.55 14 19 14S18 14.45 18 15 18.45 16 19 16 20 15.55 20 15M20 7H11V11H20V7M7 9.5C6.97 8.12 5.83 7 4.45 7.05C3.07 7.08 1.97 8.22 2 9.6C2.03 10.77 2.86 11.77 4 12V20H5V12C6.18 11.76 7 10.71 7 9.5Z";
var mdiBusStopCovered = "M20 3H7V2H6A1.78 1.78 0 0 0 4.59 3H2V5H3.73C2 10.58 2 22 2 22H7V5H20M22 8.5A2.5 2.5 0 1 0 19 11V22H20V11A2.5 2.5 0 0 0 22 8.5M15 11.5V16H14V22H12.5V17H11.5V22H10V16H9V11.5A1.5 1.5 0 0 1 10.5 10H13.5A1.5 1.5 0 0 1 15 11.5M12 6.5A1.5 1.5 0 1 0 13.5 8A1.5 1.5 0 0 0 12 6.5Z";
var mdiBusStopUncovered = "M6 22V19H4V22H2V14A1 1 0 0 1 3 13A1 1 0 0 1 4 14V17H7A1 1 0 0 1 8 18V22M20 11V22H19V11A2.5 2.5 0 1 1 20 11M15 11.55V16H14V22H12.5V17H11.5V22H10V16H9V11.5A1.5 1.5 0 0 1 10.5 10H13.5A1.5 1.5 0 0 1 15 11.5M12 6.55A1.5 1.5 0 1 0 13.5 8A1.5 1.5 0 0 0 12 6.5Z";
var mdiBusWrench = "M20 13V6C20 2.5 16.42 2 12 2C7.58 2 4 2.5 4 6V16C4 16.88 4.39 17.67 5 18.22V20C5 20.27 5.11 20.5 5.29 20.71C5.5 20.9 5.74 21 6 21H7C7.27 21 7.5 20.9 7.71 20.71C7.9 20.5 8 20.27 8 20V19H12C11.37 18.16 11 17.13 11 16C11 13.24 13.24 11 16 11C17.64 11 19.09 11.79 20 13M16 11H6V6H18V11H16M6.44 16.56C6.16 16.28 6 15.9 6 15.5C6 15.1 6.16 14.72 6.44 14.44C6.72 14.16 7.1 14 7.5 14C7.9 14 8.28 14.16 8.56 14.44C8.84 14.72 9 15.1 9 15.5C9 15.9 8.84 16.28 8.56 16.56C8.28 16.84 7.9 17 7.5 17C7.1 17 6.72 16.84 6.44 16.56M15.5 16.92L13.29 14.71C13.11 15.1 13 15.54 13 16C13 17.66 14.34 19 16 19C16.46 19 16.9 18.9 17.29 18.71L21.29 22.71L22.71 21.29L18.71 17.29C18.9 16.9 19 16.46 19 16C19 14.34 17.66 13 16 13C15.54 13 15.1 13.11 14.71 13.29L16.91 15.5L15.5 16.91Z";
var mdiButterfly = "M13 21H11V6L9.03 3.97L10 3L12 5L14 3L15 4L13 6V21M7 6C4.24 6 2 8.24 2 11C2 12.64 2.79 14.09 4 15H4V17C4 19.21 5.79 21 8 21C8.72 21 9.39 20.81 9.97 20.5L10 20.46V7C9.16 6.37 8.13 6 7 6M6.5 12.5L5 11L6.5 9.5L8 11L6.5 12.5M22 11C22 8.24 19.76 6 17 6C15.88 6 14.85 6.37 14 7L14 7V20.46C14.59 20.81 15.27 21 16 21C18.21 21 20 19.21 20 17V15H20C21.21 14.09 22 12.64 22 11M17.5 12.5L16 11L17.5 9.5L19 11L17.5 12.5Z";
var mdiButterflyOutline = "M13 21H11V6L9.03 3.97L10 3L12 5L14 3L15 4L13 6V21M14 9H14V7C14.84 6.37 15.88 6 17 6C19.76 6 22 8.24 22 11C22 12.64 21.21 14.09 20 15H20V17C20 19.21 18.21 21 16 21C15.27 21 14.59 20.81 14 20.46V18.46C14.59 18.81 15.27 19 16 19C17.1 19 18 18.1 18 17V13.83C19.17 13.42 20 12.31 20 11C20 9.35 18.67 8 17 8H17C15.88 8 14.84 8.37 14 9M10 9H10C9.16 8.37 8.13 8 7 8H7C5.33 8 4 9.35 4 11C4 12.31 4.84 13.42 6 13.83V17C6 18.1 6.9 19 8 19C8.73 19 9.41 18.81 10 18.46V20.46C9.41 20.81 8.73 21 8 21C5.79 21 4 19.21 4 17V15H4C2.79 14.09 2 12.64 2 11C2 8.24 4.24 6 7 6C8.13 6 9.16 6.37 10 7V9M9 11L7.5 9.5L6 11L7.5 12.5L9 11M18 11L16.5 9.5L15 11L16.5 12.5L18 11Z";
var mdiButtonCursor = "M18.1 15.3C18 15.4 17.8 15.5 17.7 15.6L15.3 16L17 19.6C17.2 20 17 20.4 16.6 20.6L13.8 21.9C13.7 22 13.6 22 13.5 22C13.2 22 12.9 21.8 12.8 21.6L11.2 18L9.3 19.5C9.2 19.6 9 19.7 8.8 19.7C8.4 19.7 8 19.4 8 18.9V7.5C8 7 8.3 6.7 8.8 6.7C9 6.7 9.2 6.8 9.3 6.9L18 14.3C18.3 14.5 18.4 15 18.1 15.3M6 12H4V4H20V12H18.4L20.6 13.9C21.4 13.6 21.9 12.9 21.9 12V4C21.9 2.9 21 2 19.9 2H4C2.9 2 2 2.9 2 4V12C2 13.1 2.9 14 4 14H6V12Z";
var mdiButtonPointer = "M20 20.5C20 21.3 19.3 22 18.5 22H13C12.6 22 12.3 21.9 12 21.6L8 17.4L8.7 16.6C8.9 16.4 9.2 16.3 9.5 16.3H9.7L12 18V9C12 8.4 12.4 8 13 8S14 8.4 14 9V13.5L15.2 13.6L19.1 15.8C19.6 16 20 16.6 20 17.1V20.5M20 2H4C2.9 2 2 2.9 2 4V12C2 13.1 2.9 14 4 14H8V12H4V4H20V12H18V14H20C21.1 14 22 13.1 22 12V4C22 2.9 21.1 2 20 2Z";
var mdiCabinAFrame = "M12 3L4 21H20L12 3M9 19H7.08L9 14.67V19M13 19H11V14H13V19M10.19 12L12 7.92L13.81 12H10.19M15 14.67L16.92 19H15V14.67Z";
var mdiCableData = "M7.05 3.5C5.68 4.88 5.68 7.1 7.05 8.47L15.54 16.95C16.12 17.54 16.12 18.5 15.54 19.07C14.95 19.66 14 19.66 13.41 19.07L9.17 14.83L10.23 13.77L6.7 10.23L6.34 10.59L4.93 9.17C4.54 8.78 3.91 8.78 3.5 9.17L2.1 10.59C1.71 11 1.71 11.61 2.1 12L3.5 13.41L3.16 13.77L6.7 17.3L7.76 16.24L12 20.5C13.37 21.85 15.58 21.85 16.95 20.5C18.32 19.12 18.32 16.9 16.95 15.54L8.46 7.05C7.88 6.46 7.88 5.5 8.46 4.93C9.05 4.34 10 4.34 10.59 4.93L14.83 9.17L13.77 10.23L17.3 13.77L17.66 13.41L19.07 14.83C19.46 15.22 20.1 15.22 20.5 14.83L21.9 13.41C22.29 13 22.29 12.39 21.9 12L20.5 10.59L20.84 10.23L17.3 6.7L16.24 7.76L12 3.5C10.63 2.15 8.42 2.15 7.05 3.5M2.81 11.29L4.22 9.88L5.64 11.29L4.22 12.71M18.36 12.71L19.78 11.29L21.19 12.71L19.78 14.12Z";
var mdiCached = "M19,8L15,12H18A6,6 0 0,1 12,18C11,18 10.03,17.75 9.2,17.3L7.74,18.76C8.97,19.54 10.43,20 12,20A8,8 0 0,0 20,12H23M6,12A6,6 0 0,1 12,6C13,6 13.97,6.25 14.8,6.7L16.26,5.24C15.03,4.46 13.57,4 12,4A8,8 0 0,0 4,12H1L5,16L9,12";
var mdiCactus = "M14,16V21H10V18H9A3,3 0 0,1 6,15V12A1,1 0 0,1 7,11A1,1 0 0,1 8,12V15C8,15.56 8.45,16 9,16H10V6A2,2 0 0,1 12,4A2,2 0 0,1 14,6V14H15A1,1 0 0,0 16,13V11A1,1 0 0,1 17,10A1,1 0 0,1 18,11V13A3,3 0 0,1 15,16H14Z";
var mdiCake = "M11.5,0.5C12,0.75 13,2.4 13,3.5C13,4.6 12.33,5 11.5,5C10.67,5 10,4.85 10,3.75C10,2.65 11,2 11.5,0.5M18.5,9C21,9 23,11 23,13.5C23,15.06 22.21,16.43 21,17.24V23H12L3,23V17.24C1.79,16.43 1,15.06 1,13.5C1,11 3,9 5.5,9H10V6H13V9H18.5M12,16A2.5,2.5 0 0,0 14.5,13.5H16A2.5,2.5 0 0,0 18.5,16A2.5,2.5 0 0,0 21,13.5A2.5,2.5 0 0,0 18.5,11H5.5A2.5,2.5 0 0,0 3,13.5A2.5,2.5 0 0,0 5.5,16A2.5,2.5 0 0,0 8,13.5H9.5A2.5,2.5 0 0,0 12,16Z";
var mdiCakeLayered = "M21,21V17C21,15.89 20.1,15 19,15H18V12C18,10.89 17.1,10 16,10H13V8H11V10H8C6.89,10 6,10.89 6,12V15H5C3.89,15 3,15.89 3,17V21H1V23H23V21M12,7A2,2 0 0,0 14,5C14,4.62 13.9,4.27 13.71,3.97L12,1L10.28,3.97C10.1,4.27 10,4.62 10,5A2,2 0 0,0 12,7Z";
var mdiCakeVariant = "M12,6C13.11,6 14,5.1 14,4C14,3.62 13.9,3.27 13.71,2.97L12,0L10.29,2.97C10.1,3.27 10,3.62 10,4A2,2 0 0,0 12,6M16.6,16L15.53,14.92L14.45,16C13.15,17.29 10.87,17.3 9.56,16L8.5,14.92L7.4,16C6.75,16.64 5.88,17 4.96,17C4.23,17 3.56,16.77 3,16.39V21A1,1 0 0,0 4,22H20A1,1 0 0,0 21,21V16.39C20.44,16.77 19.77,17 19.04,17C18.12,17 17.25,16.64 16.6,16M18,9H13V7H11V9H6A3,3 0 0,0 3,12V13.54C3,14.62 3.88,15.5 4.96,15.5C5.5,15.5 6,15.3 6.34,14.93L8.5,12.8L10.61,14.93C11.35,15.67 12.64,15.67 13.38,14.93L15.5,12.8L17.65,14.93C18,15.3 18.5,15.5 19.03,15.5C20.11,15.5 21,14.62 21,13.54V12A3,3 0 0,0 18,9Z";
var mdiCakeVariantOutline = "M12 6C13.11 6 14 5.1 14 4C14 3.62 13.9 3.27 13.71 2.97L12 0L10.29 2.97C10.1 3.27 10 3.62 10 4C10 5.1 10.9 6 12 6M18 9H13V7H11V9H6C4.34 9 3 10.34 3 12V21C3 21.55 3.45 22 4 22H20C20.55 22 21 21.55 21 21V12C21 10.34 19.66 9 18 9M19 20H5V17C5.9 17 6.76 16.63 7.4 16L8.5 14.92L9.56 16C10.87 17.3 13.15 17.29 14.45 16L15.53 14.92L16.6 16C17.24 16.63 18.1 17 19 17V20M19 15.5C18.5 15.5 18 15.3 17.65 14.93L15.5 12.8L13.38 14.93C12.64 15.67 11.35 15.67 10.61 14.93L8.5 12.8L6.34 14.93C6 15.29 5.5 15.5 5 15.5V12C5 11.45 5.45 11 6 11H18C18.55 11 19 11.45 19 12V15.5Z";
var mdiCalculator = "M7,2H17A2,2 0 0,1 19,4V20A2,2 0 0,1 17,22H7A2,2 0 0,1 5,20V4A2,2 0 0,1 7,2M7,4V8H17V4H7M7,10V12H9V10H7M11,10V12H13V10H11M15,10V12H17V10H15M7,14V16H9V14H7M11,14V16H13V14H11M15,14V16H17V14H15M7,18V20H9V18H7M11,18V20H13V18H11M15,18V20H17V18H15Z";
var mdiCalculatorVariant = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M13 7.1L14.1 6L15.5 7.4L16.9 6L18 7.1L16.6 8.5L18 9.9L16.9 11L15.5 9.6L14.1 11L13 9.9L14.4 8.5L13 7.1M6.2 7.7H11.2V9.2H6.2V7.7M11.5 16H9.5V18H8V16H6V14.5H8V12.5H9.5V14.5H11.5V16M18 17.2H13V15.7H18V17.2M18 14.8H13V13.3H18V14.8Z";
var mdiCalculatorVariantOutline = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V5H19V19M6.2 7.7H11.2V9.2H6.2V7.7M13 15.8H18V17.3H13V15.8M13 13.2H18V14.7H13V13.2M8 18H9.5V16H11.5V14.5H9.5V12.5H8V14.5H6V16H8V18M14.1 10.9L15.5 9.5L16.9 10.9L18 9.9L16.6 8.5L18 7.1L16.9 6L15.5 7.4L14.1 6L13 7.1L14.4 8.5L13 9.9L14.1 10.9Z";
var mdiCalendar = "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z";
var mdiCalendarAccount = "M12 9C14 9 15 11.42 13.59 12.84C12.17 14.26 9.75 13.25 9.75 11.25C9.75 10 10.75 9 12 9M16.5 18H7.5V16.88C7.5 15.63 9.5 14.63 12 14.63S16.5 15.63 16.5 16.88M19 19H5V8H19M16 1V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3H18V1H16Z";
var mdiCalendarAccountOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M19 19H5V9H19V19M19 7H5V5H19M12 10C14 10 15 12.42 13.59 13.84C12.17 15.26 9.75 14.25 9.75 12.25C9.75 11 10.75 10 12 10M16.5 17.88V18H7.5V17.88C7.5 16.63 9.5 15.63 12 15.63S16.5 16.63 16.5 17.88Z";
var mdiCalendarAlert = "M6 1V3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3H18V1H16V3H8V1H6M5 8H19V19H5V8M11 9V14H13V9H11M11 16V18H13V16H11Z";
var mdiCalendarAlertOutline = "M11 16H13V18H11V16M11 10H13V14H11V10M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 5V7H5V5H19M5 19V9H19V19H5Z";
var mdiCalendarArrowLeft = "M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.89 20.1 3 19 3M19 19H5V8H19V19M12 10V12H16V15H12V17L8 13.5L12 10Z";
var mdiCalendarArrowRight = "M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.89 20.1 3 19 3M19 19H5V8H19V19M12 17V15H8V12H12V10L16 13.5L12 17Z";
var mdiCalendarBadge = "M19.5 16C17.6 16 16 17.6 16 19.5S17.6 23 19.5 23 23 21.4 23 19.5 21.4 16 19.5 16M14.21 21H5C3.9 21 3 20.11 3 19V5C3 3.89 3.89 3 5 3H6V1H8V3H16V1H18V3H19C20.1 3 21 3.89 21 5V14.21C20.5 14.08 20 14 19.5 14C19.33 14 19.17 14 19 14.03V8H5V19H14.03C14 19.17 14 19.33 14 19.5C14 20 14.08 20.5 14.21 21Z";
var mdiCalendarBadgeOutline = "M19.5 16C17.6 16 16 17.6 16 19.5S17.6 23 19.5 23 23 21.4 23 19.5 21.4 16 19.5 16M14 19.5C14 19.33 14 19.17 14.03 19H5V9H19V14.03C19.17 14 19.33 14 19.5 14C20 14 20.5 14.08 21 14.21V5C21 3.9 20.11 3 19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H14.21C14.08 20.5 14 20 14 19.5M5 5H19V7H5V5Z";
var mdiCalendarBlank = "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1";
var mdiCalendarBlankMultiple = "M21 17V8H7V17H21M21 3C22.1 3 23 3.9 23 5V17C23 18.1 22.1 19 21 19H7C5.89 19 5 18.1 5 17V5C5 3.9 5.9 3 7 3H8V1H10V3H18V1H20V3H21M3 21H17V23H3C1.89 23 1 22.1 1 21V9H3V21Z";
var mdiCalendarBlankOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M19 19H5V9H19V19M19 7H5V5H19V7Z";
var mdiCalendarCheck = "M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M16.53,11.06L15.47,10L10.59,14.88L8.47,12.76L7.41,13.82L10.59,17L16.53,11.06Z";
var mdiCalendarCheckOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M19 19H5V9H19V19M5 7V5H19V7H5M10.56 17.46L16.5 11.53L15.43 10.47L10.56 15.34L8.45 13.23L7.39 14.29L10.56 17.46Z";
var mdiCalendarClock = "M15,13H16.5V15.82L18.94,17.23L18.19,18.53L15,16.69V13M19,8H5V19H9.67C9.24,18.09 9,17.07 9,16A7,7 0 0,1 16,9C17.07,9 18.09,9.24 19,9.67V8M5,21C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19A2,2 0 0,1 21,5V11.1C22.24,12.36 23,14.09 23,16A7,7 0 0,1 16,23C14.09,23 12.36,22.24 11.1,21H5M16,11.15A4.85,4.85 0 0,0 11.15,16C11.15,18.68 13.32,20.85 16,20.85A4.85,4.85 0 0,0 20.85,16C20.85,13.32 18.68,11.15 16,11.15Z";
var mdiCalendarClockOutline = "M6 1V3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.89 21 5 21H11.1C12.36 22.24 14.09 23 16 23C19.87 23 23 19.87 23 16C23 14.09 22.24 12.36 21 11.1V5C21 3.9 20.11 3 19 3H18V1H16V3H8V1M5 5H19V7H5M5 9H19V9.67C18.09 9.24 17.07 9 16 9C12.13 9 9 12.13 9 16C9 17.07 9.24 18.09 9.67 19H5M16 11.15C18.68 11.15 20.85 13.32 20.85 16C20.85 18.68 18.68 20.85 16 20.85C13.32 20.85 11.15 18.68 11.15 16C11.15 13.32 13.32 11.15 16 11.15M15 13V16.69L18.19 18.53L18.94 17.23L16.5 15.82V13Z";
var mdiCalendarCollapseHorizontal = "M19 19H5V8H19M16 1V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H18V1M11 14L8 11V13H6V15H8V17L11 14M18 13H16V11L13 14L16 17V15H18V13Z";
var mdiCalendarCollapseHorizontalOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 5V7H5V5H19M5 19V9H19V19H5M16 11L13 14L16 17V15H18V13H16V11M8 13H6V15H8V17L11 14L8 11V13Z";
var mdiCalendarCursor = "M22.86 17.74C22.77 17.85 22.65 17.91 22.53 17.94L20.66 18.3L21.95 21.14C22.11 21.43 21.97 21.79 21.67 21.93L19.53 22.94C19.44 23 19.36 23 19.27 23C19.05 23 18.84 22.88 18.74 22.66L17.45 19.83L15.96 21.04C15.86 21.12 15.74 21.17 15.59 21.17C15.26 21.17 15 20.9 15 20.57V11.6C15 11.27 15.26 11 15.59 11C15.74 11 15.88 11.05 16 11.13L22.77 16.89C23.04 17.12 23.07 17.5 22.86 17.74M12 15V10H7V15H12M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H13V19H5V8H19V11.06L21 12.76V5C21 3.9 20.1 3 19 3Z";
var mdiCalendarCursorOutline = "M5 9H19V11.1L21 12.8V5C21 3.9 20.1 3 19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H13V19H5V9M19 5V7H5V5H19M7 16V11H12V16H7M22.9 17.7C22.8 17.8 22.7 17.9 22.6 17.9L20.7 18.3L22 21.1C22.2 21.4 22 21.7 21.7 21.9L19.6 22.9C19.4 23 19.4 23 19.3 23C19.1 23 18.9 22.9 18.8 22.7L17.5 19.9L16 21C15.9 21.1 15.8 21.1 15.6 21.1C15.3 21.1 15 20.8 15 20.5V11.5C15 11.2 15.3 10.9 15.6 10.9C15.7 10.9 15.9 11 16 11L22.8 16.8C23 17.1 23.1 17.5 22.9 17.7Z";
var mdiCalendarEdit = "M19,3H18V1H16V3H8V1H6V3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H10V19H5V8H19V9H21V5A2,2 0 0,0 19,3M21.7,13.35L20.7,14.35L18.65,12.35L19.65,11.35C19.85,11.14 20.19,11.13 20.42,11.35L21.7,12.63C21.89,12.83 21.89,13.15 21.7,13.35M12,18.94L18.07,12.88L20.12,14.88L14.06,21H12V18.94Z";
var mdiCalendarEditOutline = "M21.7 13.35L20.7 14.35L18.65 12.35L19.65 11.35C19.85 11.14 20.19 11.13 20.42 11.35L21.7 12.63C21.89 12.83 21.89 13.15 21.7 13.35M12 18.94V21H14.06L20.12 14.88L18.07 12.88L12 18.94M5 19H10V21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H6V1H8V3H16V1H18V3H19C20.11 3 21 3.9 21 5V9H5V19M5 5V7H19V5H5Z";
var mdiCalendarEnd = "M22 14V22H20V18L16 22V19H11V17H16V14L20 18V14H22M5 19L9 19V21L5 21C3.9 21 3 20.1 3 19V5C3 3.89 3.9 3 5 3H6V.998H8V3H16V.998H18V3H19C20.11 3 21 3.89 21 5L21 12H19V8H5V19Z";
var mdiCalendarEndOutline = "M5 9H19V12H21V5C21 3.9 20.1 3 19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H9V19H5V9M19 5V7H5V5H19M16 17H11V19H16V22L20 18L16 14V17M20 14V22H22V14H20Z";
var mdiCalendarExpandHorizontal = "M19 19H5V8H19M16 1V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H18V1M18 14L15 11V13H9V11L6 14L9 17V15H15V17L18 14Z";
var mdiCalendarExpandHorizontalOutline = "M15 13H9V11L6 14L9 17V15H15V17L18 14L15 11V13M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 5V7H5V5H19M5 19V9H19V19H5Z";
var mdiCalendarExport = "M12 22L16 18H13V12H11V18H8L12 22M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H8L6 19H5V8H19V19H18L16 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3Z";
var mdiCalendarExportOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H8L6 19H5V9H19V19H18L16 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M5 7V5H19V7H5M13 18V12H11V18H8L12 22L16 18H13Z";
var mdiCalendarFilter = "M6 1H8V3H16V1H18V3H19C20.11 3 21 3.9 21 5V11H19V8H5V19H15V21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H6V1M17 21L18.8 22.77C19.3 23.27 20 22.87 20 22.28V18L22.8 14.6C23.3 13.9 22.8 13 22 13H15C14.2 13 13.7 14 14.2 14.6L17 18V21";
var mdiCalendarFilterOutline = "M19 3H18V1H16V3H8V1H6V3H4.75C4.31 3.07 3.9 3.27 3.58 3.58C3.27 3.9 3.07 4.31 3 4.75V19.25C3.07 19.69 3.27 20.1 3.58 20.42C3.9 20.73 4.31 20.93 4.75 21H15V19H5V9H19V11H21V5C21 3.89 20.11 3 19 3M19 7H5V5H19V7M17 21L18.8 22.77C19.3 23.27 20 22.87 20 22.28V18L22.8 14.6C23.3 13.9 22.8 13 22 13H15C14.2 13 13.7 14 14.2 14.6L17 18V21";
var mdiCalendarHeart = "M19 19V8H5V19H19M16 1H18V3H19C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H6V1H8V3H16V1M12 17.17L11.42 16.64C9.36 14.77 8 13.54 8 12.03C8 10.8 8.97 9.83 10.2 9.83C10.9 9.83 11.56 10.15 12 10.66C12.44 10.15 13.1 9.83 13.8 9.83C15.03 9.83 16 10.8 16 12.03C16 13.54 14.64 14.77 12.58 16.64L12 17.17Z";
var mdiCalendarHeartOutline = "M16 12.2C16 13.71 14.64 14.94 12.58 16.81L12 17.34L11.42 16.81C9.36 14.94 8 13.71 8 12.2C8 10.97 8.97 10 10.2 10C10.9 10 11.56 10.32 12 10.83C12.44 10.32 13.1 10 13.8 10C15.03 10 16 10.97 16 12.2M21 5V19C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H6V1H8V3H16V1H18V3H19C20.11 3 21 3.9 21 5M5 5V7H19V5H5M19 19V9H5V19H19Z";
var mdiCalendarImport = "M12 12L8 16H11V22H13V16H16M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H9V19H5V8H19V19H15V21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3Z";
var mdiCalendarImportOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H9V19H5V9H19V19H15V21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M5 7V5H19V7H5M12 12L8 16H11V22H13V16H16L12 12Z";
var mdiCalendarLock = "M12 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H6V1H8V3H16V1H18V3H19C20.1 3 21 3.9 21 5V12C20.4 11.6 19.7 11.2 19 11.1V8H5V19H12V21M22 18.3V21.8C22 22.4 21.4 23 20.7 23H15.2C14.6 23 14 22.4 14 21.7V18.2C14 17.6 14.6 17 15.2 17V15.5C15.2 14.1 16.6 13 18 13S20.8 14.1 20.8 15.5V17C21.4 17 22 17.6 22 18.3M19.5 15.5C19.5 14.7 18.8 14.2 18 14.2S16.5 14.7 16.5 15.5V17H19.5V15.5Z";
var mdiCalendarLockOpen = "M12 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H6V1H8V3H16V1H18V3H19C20.1 3 21 3.9 21 5V11C20.4 10.6 19.7 10.2 19 10.1V8H5V19H12V21M22 18.3C22 17.6 21.4 17 20.8 17H16.5V14.5C16.5 13.7 17.2 13.2 18 13.2S19.5 13.7 19.5 14.5V15H20.8V14.5C20.8 13.1 19.4 12 18 12S15.2 13.1 15.2 14.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3Z";
var mdiCalendarLockOpenOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H12V19H5V9H19V10.1C19.7 10.3 20.4 10.6 21 11V5C21 3.9 20.1 3 19 3M19 7H5V5H19V7M22 21.8C22 22.4 21.4 23 20.7 23H15.2C14.6 23 14 22.4 14 21.7V18.2C14 17.6 14.6 17 15.2 17V14.5C15.2 13.1 16.6 12 18 12S20.8 13.1 20.8 14.5V15H19.5V14.5C19.5 13.7 18.8 13.2 18 13.2S16.5 13.7 16.5 14.5V17H20.8C21.4 17 22 17.6 22 18.3V21.8Z";
var mdiCalendarLockOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H12V19H5V9H19V11C19.7 11.2 20.4 11.5 21 11.9V5C21 3.9 20.1 3 19 3M19 7H5V5H19V7M20.8 17V15.5C20.8 14.1 19.4 13 18 13S15.2 14.1 15.2 15.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17M19.5 17H16.5V15.5C16.5 14.7 17.2 14.2 18 14.2S19.5 14.7 19.5 15.5V17Z";
var mdiCalendarMinus = "M19 19V8H5V19H19M16 1H18V3H19C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.89 3.89 3 5 3H6V1H8V3H16V1M16 12.5V14.5H8V12.5H16Z";
var mdiCalendarMinusOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M19 5V7H5V5H19M5 19V9H19V19H5M8 13H16V15H8V13Z";
var mdiCalendarMonth = "M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z";
var mdiCalendarMonthOutline = "M7 11H9V13H7V11M21 5V19C21 20.11 20.11 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H6V1H8V3H16V1H18V3H19C20.11 3 21 3.9 21 5M5 7H19V5H5V7M19 19V9H5V19H19M15 13V11H17V13H15M11 13V11H13V13H11M7 15H9V17H7V15M15 17V15H17V17H15M11 17V15H13V17H11Z";
var mdiCalendarMultiple = "M21,17V8H7V17H21M21,3A2,2 0 0,1 23,5V17A2,2 0 0,1 21,19H7C5.89,19 5,18.1 5,17V5A2,2 0 0,1 7,3H8V1H10V3H18V1H20V3H21M3,21H17V23H3C1.89,23 1,22.1 1,21V9H3V21M19,15H15V11H19V15Z";
var mdiCalendarMultipleCheck = "M21,17V8H7V17H21M21,3A2,2 0 0,1 23,5V17A2,2 0 0,1 21,19H7C5.89,19 5,18.1 5,17V5A2,2 0 0,1 7,3H8V1H10V3H18V1H20V3H21M17.53,11.06L13.09,15.5L10.41,12.82L11.47,11.76L13.09,13.38L16.47,10L17.53,11.06M3,21H17V23H3C1.89,23 1,22.1 1,21V9H3V21Z";
var mdiCalendarMultiselect = "M19,19V8H5V19H19M16,1H18V3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1M7,10H9V12H7V10M15,10H17V12H15V10M11,14H13V16H11V14M15,14H17V16H15V14Z";
var mdiCalendarMultiselectOutline = "M7 11H9V13H7V11M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 5V7H5V5H19M5 19V9H19V19H5M11 15H13V17H11V15M15 15H17V17H15V15M15 11H17V13H15V11Z";
var mdiCalendarOutline = "M12 12H17V17H12V12M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 5V7H5V5H19M5 19V9H19V19H5Z";
var mdiCalendarPlus = "M19 19V8H5V19H19M16 1H18V3H19C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.89 3.89 3 5 3H6V1H8V3H16V1M11 9.5H13V12.5H16V14.5H13V17.5H11V14.5H8V12.5H11V9.5Z";
var mdiCalendarPlusOutline = "M13 13H16V15H13V18H11V15H8V13H11V10H13V13M21 5V19C21 20.11 20.11 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.89 3.89 3 5 3H6V1H8V3H16V1H18V3H19C20.11 3 21 3.9 21 5M5 5V7H19V5H5M19 19V9H5V19H19Z";
var mdiCalendarQuestion = "M6,1V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H18V1H16V3H8V1H6M5,8H19V19H5V8M12.19,9C11.32,9 10.62,9.2 10.08,9.59C9.56,10 9.3,10.57 9.31,11.36L9.32,11.39H11.25C11.26,11.09 11.35,10.86 11.53,10.7C11.71,10.55 11.93,10.47 12.19,10.47C12.5,10.47 12.76,10.57 12.94,10.75C13.12,10.94 13.2,11.2 13.2,11.5C13.2,11.82 13.13,12.09 12.97,12.32C12.83,12.55 12.62,12.75 12.36,12.91C11.85,13.25 11.5,13.55 11.31,13.82C11.11,14.08 11,14.5 11,15H13C13,14.69 13.04,14.44 13.13,14.26C13.22,14.08 13.39,13.9 13.64,13.74C14.09,13.5 14.46,13.21 14.75,12.81C15.04,12.41 15.19,12 15.19,11.5C15.19,10.74 14.92,10.13 14.38,9.68C13.85,9.23 13.12,9 12.19,9M11,16V18H13V16H11Z";
var mdiCalendarQuestionOutline = "M11.95 10C11.21 10 10.61 10.18 10.15 10.5C9.71 10.89 9.5 11.4 9.5 12.1L9.5 12.12H11.15C11.16 11.86 11.24 11.65 11.39 11.5C11.54 11.38 11.73 11.31 11.95 11.31C12.21 11.31 12.43 11.4 12.59 11.56C12.74 11.73 12.81 11.96 12.81 12.22C12.81 12.5 12.75 12.75 12.61 12.95C12.5 13.16 12.31 13.33 12.09 13.5C11.66 13.78 11.36 14.05 11.2 14.29C11.03 14.5 10.94 14.89 10.94 15.33H12.64C12.64 15.06 12.67 14.84 12.75 14.68C12.83 14.5 12.97 14.36 13.18 14.21C13.57 14 13.88 13.74 14.13 13.39C14.37 13.03 14.5 12.67 14.5 12.22C14.5 11.55 14.27 11 13.81 10.61C13.36 10.2 12.74 10 11.95 10M10.94 16.22V18H12.64V16.22H10.94M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M19 5V7H5V5H19M5 19V9H19V19H5Z";
var mdiCalendarRange = "M9,10H7V12H9V10M13,10H11V12H13V10M17,10H15V12H17V10M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V8H19V19Z";
var mdiCalendarRangeOutline = "M7 11H9V13H7V11M21 5V19C21 20.11 20.11 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H6V1H8V3H16V1H18V3H19C20.11 3 21 3.9 21 5M5 7H19V5H5V7M19 19V9H5V19H19M15 13H17V11H15V13M11 13H13V11H11V13Z";
var mdiCalendarRefresh = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H14C13.4 20.5 12.9 19.8 12.5 19H5V8H19V10.6C19.7 10.7 20.4 10.9 21 11.3V5C21 3.9 20.1 3 19 3M18 12.5C19.1 12.5 20.1 12.9 20.8 13.7L22 12.5V16.5H18L19.8 14.7C19.3 14.3 18.7 14 18 14C16.6 14 15.5 15.1 15.5 16.5S16.6 19 18 19C18.8 19 19.5 18.6 20 18H21.7C21.1 19.5 19.7 20.5 18 20.5C15.8 20.5 14 18.7 14 16.5S15.8 12.5 18 12.5Z";
var mdiCalendarRefreshOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H14C13.4 20.5 12.9 19.8 12.5 19H5V9H19V10.6C19.7 10.7 20.4 10.9 21 11.3V5C21 3.9 20.1 3 19 3M19 7H5V5H19M18 12.5C19.1 12.5 20.1 12.9 20.8 13.7L22 12.5V16.5H18L19.8 14.7C19.3 14.3 18.7 14 18 14C16.6 14 15.5 15.1 15.5 16.5S16.6 19 18 19C18.8 19 19.5 18.6 20 18H21.7C21.1 19.5 19.7 20.5 18 20.5C15.8 20.5 14 18.7 14 16.5S15.8 12.5 18 12.5Z";
var mdiCalendarRemove = "M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M9.31,17L11.75,14.56L14.19,17L15.25,15.94L12.81,13.5L15.25,11.06L14.19,10L11.75,12.44L9.31,10L8.25,11.06L10.69,13.5L8.25,15.94L9.31,17Z";
var mdiCalendarRemoveOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M19 19H5V9H19V19M5 7V5H19V7H5M8.23 16.41L9.29 17.47L11.73 15.03L14.17 17.47L15.23 16.41L12.79 13.97L15.23 11.53L14.17 10.47L11.73 12.91L9.29 10.47L8.23 11.53L10.67 13.97L8.23 16.41Z";
var mdiCalendarSearch = "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14M19,8H5V19H9.5C9.81,19.75 10.26,20.42 10.81,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19A2,2 0 0,1 21,5V13.03C20.5,12.22 19.8,11.54 19,11V8Z";
var mdiCalendarSearchOutline = "M19.3 18.9C19.7 18.2 20 17.4 20 16.5C20 14 18 12 15.5 12S11 14 11 16.5 13 21 15.5 21C16.4 21 17.2 20.8 17.9 20.3L21 23.4L22.4 22L19.3 18.9M15.5 19C14.1 19 13 17.9 13 16.5S14.1 14 15.5 14 18 15.1 18 16.5 16.9 19 15.5 19M5 19V9H19V11C19.8 11.5 20.5 12.2 21 13V5C21 3.9 20.1 3 19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H10.8C10.2 20.4 9.8 19.8 9.5 19H5M19 5V7H5V5H19Z";
var mdiCalendarStar = "M19 19H5V8H19M16 1V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3H18V1M10.88 12H7.27L10.19 14.11L9.08 17.56L12 15.43L14.92 17.56L13.8 14.12L16.72 12H13.12L12 8.56L10.88 12Z";
var mdiCalendarStarFourPoints = "M10.74 12.25L12 9.5L13.25 12.25L16 13.5L13.25 14.76L12 17.5L10.74 14.76L8 13.5L10.74 12.25M16 3V1H18V3H19C19.53 3 20.04 3.21 20.41 3.59C20.79 3.96 21 4.47 21 5V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 4.47 3.21 3.96 3.59 3.59C3.96 3.21 4.47 3 5 3H6V1H8V3H16M5 8V19H19V8H5Z";
var mdiCalendarStarOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V9H19V19M19 7H5V5H19V7M11 13H7.8L10.4 15L9.4 18L12 16.2L14.6 18L13.6 15L16.2 13H13L12 10L11 13Z";
var mdiCalendarStart = "M2 14H4V17H9V14L13 18L9 22V19H4V22H2V14M19 19V8H5V12H3L3 5C3 3.89 3.89 3 5 3H6V.998H8V3H16V.998H18V3H19C20.1 3 21 3.89 21 5V19C21 20.1 20.1 21 19 21L12.83 21L14.83 19L19 19Z";
var mdiCalendarStartOutline = "M13 18L9 14V17H4V14H2V22H4V19H9V22L13 18M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V12H5V9H19V19H14.8L12.8 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M5 7V5H19V7H5Z";
var mdiCalendarSync = "M18,11V12.5C21.19,12.5 23.09,16.05 21.33,18.71L20.24,17.62C21.06,15.96 19.85,14 18,14V15.5L15.75,13.25L18,11M18,22V20.5C14.81,20.5 12.91,16.95 14.67,14.29L15.76,15.38C14.94,17.04 16.15,19 18,19V17.5L20.25,19.75L18,22M19,3H18V1H16V3H8V1H6V3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H14C13.36,20.45 12.86,19.77 12.5,19H5V8H19V10.59C19.71,10.7 20.39,10.94 21,11.31V5A2,2 0 0,0 19,3Z";
var mdiCalendarSyncOutline = "M18,11V12.5C21.19,12.5 23.09,16.05 21.33,18.71L20.24,17.62C21.06,15.96 19.85,14 18,14V15.5L15.75,13.25L18,11M18,22V20.5C14.81,20.5 12.91,16.95 14.67,14.29L15.76,15.38C14.94,17.04 16.15,19 18,19V17.5L20.25,19.75L18,22M19,3H18V1H16V3H8V1H6V3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H14C13.36,20.45 12.86,19.77 12.5,19H5V9H19V10.59C19.71,10.7 20.39,10.94 21,11.31V5A2,2 0 0,0 19,3M19,7H5V5H19";
var mdiCalendarText = "M14,14H7V16H14M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M17,10H7V12H17V10Z";
var mdiCalendarTextOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M19 19H5V9H19V19M5 7V5H19V7H5M7 11H17V13H7V11M7 15H14V17H7V15Z";
var mdiCalendarToday = "M7,10H12V15H7M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiCalendarTodayOutline = "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3M19 19H5V9H19V19M19 7H5V5H19M7 11H12V16H7";
var mdiCalendarWeek = "M6 1H8V3H16V1H18V3H19C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.89 3.89 3 5 3H6V1M5 8V19H19V8H5M7 10H17V12H7V10Z";
var mdiCalendarWeekBegin = "M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M9,10H7V17H9V10Z";
var mdiCalendarWeekBeginOutline = "M19 3C20.11 3 21 3.89 21 5V19C21 20.11 20.11 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.89 3.9 3 5 3H6V1H8V3H16V1H18V3H19M19 19V9H5V19H19M19 7V5H5V7H19M7 11H9V17H7V11";
var mdiCalendarWeekOutline = "M5 3H6V1H8V3H16V1H18V3H19C20.11 3 21 3.89 21 5V19C21 20.1 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.89 3.9 3 5 3M5 19H19V9H5V19M5 7H19V5H5V7M17 11V13H7V11H17";
var mdiCalendarWeekend = "M19 19V8H5V19H19M16 1H18V3H19C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H6V1H8V3H16V1M7 17V10H9V17H7M15 10H17V17H15V10Z";
var mdiCalendarWeekendOutline = "M19 3C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H6V1H8V3H16V1H18V3H19M19 19V9H5V19H19M19 7V5H5V7H19M7 11H9V17H7V11M15 11H17V17H15V11Z";
var mdiCallMade = "M9,5V7H15.59L4,18.59L5.41,20L17,8.41V15H19V5";
var mdiCallMerge = "M17,20.41L18.41,19L15,15.59L13.59,17M7.5,8H11V13.59L5.59,19L7,20.41L13,14.41V8H16.5L12,3.5";
var mdiCallMissed = "M19.59,7L12,14.59L6.41,9H11V7H3V15H5V10.41L12,17.41L21,8.41";
var mdiCallReceived = "M20,5.41L18.59,4L7,15.59V9H5V19H15V17H8.41";
var mdiCallSplit = "M14,4L16.29,6.29L13.41,9.17L14.83,10.59L17.71,7.71L20,10V4M10,4H4V10L6.29,7.71L11,12.41V20H13V11.59L7.71,6.29";
var mdiCamcorder = "M7 2C4.24 2 2 4.24 2 7V20C2 21.1 2.9 22 4 22H10C11.1 22 12 21.1 12 20V7C12 4.24 9.76 2 7 2M5 20C4.45 20 4 19.55 4 19S4.45 18 5 18 6 18.45 6 19 5.55 20 5 20M7 10C5.34 10 4 8.66 4 7S5.34 4 7 4 10 5.34 10 7 8.66 10 7 10M22 9V14C22 15.1 21.1 16 20 16H13V14H20V9H13V7H20C21.1 7 22 7.9 22 9Z";
var mdiCamcorderOff = "M22.1 21.5L9.4 8.8L2.4 1.8L1.1 3L2.7 4.6C2.2 5.3 2 6.1 2 7V20C2 21.1 2.9 22 4 22H10C11.1 22 12 21.1 12 20V13.9L13 14.9V16H14.1L20.8 22.7L22.1 21.5M5 20C4.5 20 4 19.5 4 19S4.5 18 5 18 6 18.5 6 19 5.5 20 5 20M7 10C5.3 10 4 8.7 4 7C4 6.7 4.1 6.4 4.2 6.1L8 9.9C7.6 9.9 7.3 10 7 10M7.2 4L5.5 2.3C6 2.1 6.5 2 7 2C9.8 2 12 4.2 12 7V8.8L10 6.8C9.9 5.3 8.7 4.1 7.2 4M20 9H13V7H20C21.1 7 22 7.9 22 9V14C22 15.1 21.1 16 20 16H19.2L17.2 14H20V9Z";
var mdiCamera = "M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z";
var mdiCameraAccount = "M4,5H7L9,3H15L17,5H20A2,2 0 0,1 22,7V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V7A2,2 0 0,1 4,5M16,17V16C16,14.67 13.33,14 12,14C10.67,14 8,14.67 8,16V17H16M12,9A2,2 0 0,0 10,11A2,2 0 0,0 12,13A2,2 0 0,0 14,11A2,2 0 0,0 12,9Z";
var mdiCameraBurst = "M1,5H3V19H1V5M5,5H7V19H5V5M22,5H10A1,1 0 0,0 9,6V18A1,1 0 0,0 10,19H22A1,1 0 0,0 23,18V6A1,1 0 0,0 22,5M11,17L13.5,13.85L15.29,16L17.79,12.78L21,17H11Z";
var mdiCameraControl = "M9,12C9,11.19 9.3,10.5 9.89,9.89C10.5,9.3 11.19,9 12,9C12.81,9 13.5,9.3 14.11,9.89C14.7,10.5 15,11.19 15,12C15,12.81 14.7,13.5 14.11,14.11C13.5,14.7 12.81,15 12,15C11.19,15 10.5,14.7 9.89,14.11C9.3,13.5 9,12.81 9,12M5.53,8.44L7.31,10.22L5.53,12L7.31,13.78L5.53,15.56L2,12L5.53,8.44M8.44,18.47L10.22,16.69L12,18.47L13.78,16.69L15.56,18.47L12,22L8.44,18.47M18.47,15.56L16.69,13.78L18.47,12L16.69,10.22L18.47,8.44L22,12L18.47,15.56M15.56,5.53L13.78,7.31L12,5.53L10.22,7.31L8.44,5.53L12,2L15.56,5.53Z";
var mdiCameraDocument = "M21 7V22H3V20H19V7H14.72C14.38 7.6 13.74 8 13 8C13 9.11 12.1 10 11 10H8C6.9 10 6 9.1 6 8V4C6 2.9 6.9 2 8 2H11C12.1 2 13 2.9 13 4C13.74 4 14.38 4.41 14.72 5H19C20.11 5 21 5.89 21 7M6 15H13L11 11H8L6 15Z";
var mdiCameraDocumentOff = "M20.84 22.73L20.11 22H3V20H18.11L12.89 14.78L13 15H6L8 11H9.11L8.11 10H8C6.9 10 6 9.1 6 8V7.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M13 8C13.74 8 14.38 7.6 14.72 7H19V15.8L21 17.8V7C21 5.89 20.11 5 19 5H14.72C14.38 4.41 13.74 4 13 4C13 2.9 12.1 2 11 2H8C7.24 2 6.59 2.43 6.25 3.05L12.5 9.3C12.81 8.95 13 8.5 13 8Z";
var mdiCameraEnhance = "M9,3L7.17,5H4A2,2 0 0,0 2,7V19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19V7A2,2 0 0,0 20,5H16.83L15,3M12,18A5,5 0 0,1 7,13A5,5 0 0,1 12,8A5,5 0 0,1 17,13A5,5 0 0,1 12,18M12,17L13.25,14.25L16,13L13.25,11.75L12,9L10.75,11.75L8,13L10.75,14.25";
var mdiCameraEnhanceOutline = "M12,10L11.06,12.06L9,13L11.06,13.94L12,16L12.94,13.94L15,13L12.94,12.06L12,10M20,5H16.83L15,3H9L7.17,5H4A2,2 0 0,0 2,7V19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19V7A2,2 0 0,0 20,5M20,19H4V7H8.05L8.64,6.35L9.88,5H14.12L15.36,6.35L15.95,7H20V19M12,8A5,5 0 0,0 7,13A5,5 0 0,0 12,18A5,5 0 0,0 17,13A5,5 0 0,0 12,8M12,16A3,3 0 0,1 9,13A3,3 0 0,1 12,10A3,3 0 0,1 15,13A3,3 0 0,1 12,16Z";
var mdiCameraFlip = "M20 5H17L15 3H9L7 5H4C2.9 5 2 5.9 2 7V19C2 20.11 2.9 21 4 21H20C21.11 21 22 20.11 22 19V7C22 5.9 21.11 5 20 5M5 12H7.1C7.65 9.29 10.29 7.55 13 8.1C13.76 8.25 14.43 8.59 15 9L13.56 10.45C13.11 10.17 12.58 10 12 10C10.74 10 9.6 10.8 9.18 12H11L8 15L5 12M16.91 14C16.36 16.71 13.72 18.45 11 17.9C10.25 17.74 9.58 17.41 9 17L10.44 15.55C10.9 15.83 11.43 16 12 16C13.27 16 14.41 15.2 14.83 14H13L16 11L19 14H16.91Z";
var mdiCameraFlipOutline = "M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.11 2.9 21 4 21H20C21.11 21 22 20.11 22 19V7C22 5.9 21.11 5 20 5M20 19H4V7H8.05L9.88 5H14.12L16 7H20V19M5 12H7.1C7.65 9.29 10.29 7.55 13 8.1C13.76 8.25 14.43 8.59 15 9L13.56 10.45C13.11 10.17 12.58 10 12 10C10.74 10 9.6 10.8 9.18 12H11L8 15L5 12M16.91 14C16.36 16.71 13.72 18.45 11 17.9C10.25 17.74 9.58 17.41 9 17L10.44 15.55C10.9 15.83 11.43 16 12 16C13.27 16 14.41 15.2 14.83 14H13L16 11L19 14H16.91Z";
var mdiCameraFront = "M7,2H17V12.5C17,10.83 13.67,10 12,10C10.33,10 7,10.83 7,12.5M17,0H7A2,2 0 0,0 5,2V16A2,2 0 0,0 7,18H17A2,2 0 0,0 19,16V2A2,2 0 0,0 17,0M12,8A2,2 0 0,0 14,6A2,2 0 0,0 12,4A2,2 0 0,0 10,6A2,2 0 0,0 12,8M14,20V22H19V20M10,20H5V22H10V24L13,21L10,18V20Z";
var mdiCameraFrontVariant = "M6,0H18A2,2 0 0,1 20,2V22A2,2 0 0,1 18,24H6A2,2 0 0,1 4,22V2A2,2 0 0,1 6,0M12,6A3,3 0 0,1 15,9A3,3 0 0,1 12,12A3,3 0 0,1 9,9A3,3 0 0,1 12,6M11,1V3H13V1H11M6,4V16.5C6,15.12 8.69,14 12,14C15.31,14 18,15.12 18,16.5V4H6M13,18H9V20H13V22L16,19L13,16V18Z";
var mdiCameraGopro = "M20,5H15A2,2 0 0,0 13,7V12A2,2 0 0,0 15,14H20A2,2 0 0,0 22,12V7A2,2 0 0,0 20,5M17.5,12.5A3,3 0 0,1 14.5,9.5A3,3 0 0,1 17.5,6.5A3,3 0 0,1 20.5,9.5A3,3 0 0,1 17.5,12.5M17.5,11A1.5,1.5 0 0,1 16,9.5A1.5,1.5 0 0,1 17.5,8A1.5,1.5 0 0,1 19,9.5A1.5,1.5 0 0,1 17.5,11M12,15V5H4A2,2 0 0,0 2,7V17A2,2 0 0,0 4,19H20A2,2 0 0,0 22,17V15H12M10,12H4V7H10V12Z";
var mdiCameraImage = "M4,5H7L9,3H15L17,5H20A2,2 0 0,1 22,7V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V7A2,2 0 0,1 4,5M13.09,9.45L11.05,12.18L12.6,14.25L11.73,14.91L9.27,11.64L6,16H18L13.09,9.45Z";
var mdiCameraIris = "M13.73,15L9.83,21.76C10.53,21.91 11.25,22 12,22C14.4,22 16.6,21.15 18.32,19.75L14.66,13.4M2.46,15C3.38,17.92 5.61,20.26 8.45,21.34L12.12,15M8.54,12L4.64,5.25C3,7 2,9.39 2,12C2,12.68 2.07,13.35 2.2,14H9.69M21.8,10H14.31L14.6,10.5L19.36,18.75C21,16.97 22,14.6 22,12C22,11.31 21.93,10.64 21.8,10M21.54,9C20.62,6.07 18.39,3.74 15.55,2.66L11.88,9M9.4,10.5L14.17,2.24C13.47,2.09 12.75,2 12,2C9.6,2 7.4,2.84 5.68,4.25L9.34,10.6L9.4,10.5Z";
var mdiCameraLock = "M4 4H7L9 2H15L17 4H20C21.11 4 22 4.89 22 6V12C21.16 11.37 20.13 11 19 11C18.21 11 17.46 11.18 16.79 11.5C16.18 9.22 14.27 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C12.42 17 12.84 16.95 13.23 16.85C13.08 17.2 13 17.59 13 18V20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4M12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9M23 18.3V21.8C23 22.4 22.4 23 21.7 23H16.2C15.6 23 15 22.4 15 21.7V18.2C15 17.6 15.6 17 16.2 17V15.5C16.2 14.1 17.6 13 19 13C20.4 13 21.8 14.1 21.8 15.5V17C22.4 17 23 17.6 23 18.3M20.5 15.5C20.5 14.7 19.8 14.2 19 14.2C18.2 14.2 17.5 14.7 17.5 15.5V17H20.5V15.5Z";
var mdiCameraLockOpen = "M15 12C14.6 12.6 14.4 13.3 14.3 14C13.7 14.6 12.9 15 12 15C10.3 15 9 13.7 9 12S10.3 9 12 9 15 10.3 15 12M13 18.2C13 17.7 13.1 17.2 13.4 16.8C12.9 16.9 12.5 17 12 17C9.2 17 7 14.8 7 12S9.2 7 12 7C14.3 7 16.1 8.5 16.8 10.6C17.5 10.3 18.2 10 19 10C20.1 10 21.2 10.4 22 11V6C22 4.9 21.1 4 20 4H17L15 2H9L7 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H13V18.2M21.8 17H17.5V14.5C17.5 13.7 18.2 13.2 19 13.2S20.5 13.7 20.5 14.5V15H21.8V14.5C21.8 13.1 20.4 12 19 12S16.2 13.1 16.2 14.5V17C15.6 17 15 17.6 15 18.2V21.7C15 22.4 15.6 23 16.2 23H21.7C22.4 23 23 22.4 23 21.8V18.3C23 17.6 22.4 17 21.8 17Z";
var mdiCameraLockOpenOutline = "M13 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H7.2L9 2H15L16.8 4H20C21.1 4 22 4.9 22 6V11C21.4 10.6 20.7 10.2 20 10.1V6H16L14.2 4H9.9L8 6H4V18H13V20M12 7C9.2 7 7 9.2 7 12S9.2 17 12 17C12.5 17 12.9 16.9 13.4 16.8C13.6 16.4 13.9 16 14.2 15.8V14.6C14.2 14.4 14.2 14.2 14.3 14.1C13.7 14.7 12.9 15.1 12 15.1C10.3 15.1 9 13.8 9 12.1S10.3 9.1 12 9.1 15 10.4 15 12.1V12.2C15.4 11.6 16.1 11.1 16.8 10.7C16.1 8.5 14.3 7 12 7M21.8 17H17.5V14.5C17.5 13.7 18.2 13.2 19 13.2S20.5 13.7 20.5 14.5V15H21.8V14.5C21.8 13.1 20.4 12 19 12S16.2 13.1 16.2 14.5V17C15.6 17 15 17.6 15 18.2V21.7C15 22.4 15.6 23 16.2 23H21.7C22.4 23 23 22.4 23 21.8V18.3C23 17.6 22.4 17 21.8 17Z";
var mdiCameraLockOutline = "M23 18.3V21.8C23 22.4 22.4 23 21.7 23H16.2C15.6 23 15 22.4 15 21.7V18.2C15 17.6 15.6 17 16.2 17V15.5C16.2 14.1 17.6 13 19 13C20.4 13 21.8 14.1 21.8 15.5V17C22.4 17 23 17.6 23 18.3M20.5 15.5C20.5 14.7 19.8 14.2 19 14.2C18.2 14.2 17.5 14.7 17.5 15.5V17H20.5V15.5M20 4C21.1 4 22 4.9 22 6V12C21.42 11.56 20.74 11.25 20 11.1V6H15.95L14.12 4H9.88L8.05 6H4V18H13V20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H7.17L9 2H15L16.83 4H20M12 7C14.57 7 16.68 8.94 16.97 11.43C15.29 12.18 14.1 13.83 14 15.76C13.67 16.06 13.4 16.43 13.23 16.85C12.84 16.95 12.42 17 12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7M12 15C13.65 15 15 13.65 15 12C15 10.35 13.65 9 12 9C10.35 9 9 10.35 9 12C9 13.65 10.35 15 12 15Z";
var mdiCameraMarker = "M18.5 16.8C17.8 16.8 17.3 16.2 17.3 15.6C17.3 14.9 17.9 14.4 18.5 14.4S19.7 15 19.7 15.6C19.8 16.2 19.2 16.8 18.5 16.8M18.5 12C16.6 12 15 13.6 15 15.5C15 18.1 18.5 22 18.5 22S22 18.1 22 15.5C22 13.6 20.4 12 18.5 12M9 2L7 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H14.5C13.9 19.1 13.4 18.1 13.1 16.9C12.8 17 12.4 17 12 17C9.2 17 7 14.8 7 12S9.2 7 12 7C14.1 7 16 8.3 16.7 10.3C17.3 10.1 17.9 10 18.5 10C19.8 10 21 10.5 22 11.3V6C22 4.9 21.1 4 20 4H17L15 2H9M11.9 9C10.3 9 9 10.4 9 12C9 13.7 10.3 15 12 15C12.4 15 12.7 14.9 13 14.8C13.2 13.4 13.9 12.2 14.9 11.3C14.6 10 13.4 9 11.9 9C12 9 12 9 11.9 9Z";
var mdiCameraMarkerOutline = "M18.5 16.8C17.8 16.8 17.3 16.2 17.3 15.6C17.3 14.9 17.9 14.4 18.5 14.4S19.7 15 19.7 15.6C19.8 16.2 19.2 16.8 18.5 16.8M18.5 12C16.6 12 15 13.6 15 15.5C15 18.1 18.5 22 18.5 22S22 18.1 22 15.5C22 13.6 20.4 12 18.5 12M9 2L7.2 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H14.5C14.1 19.4 13.7 18.7 13.5 18H4V6H8.1L9.9 4H14.1L15.9 6H20V10.2C20.7 10.4 21.4 10.8 22 11.3V6C22 4.9 21.1 4 20 4H16.8L15 2H9M12 7C9.2 7 7 9.2 7 12S9.2 17 12 17C12.4 17 12.8 17 13.2 16.9C13.1 16.4 13 16 13 15.5V14.8C12.7 14.9 12.3 15 12 15C10.3 15 9 13.7 9 12S10.3 9 12 9C13.4 9 14.6 10 14.9 11.3C15.4 10.9 16 10.5 16.7 10.3C16 8.3 14.1 7 12 7Z";
var mdiCameraMeteringCenter = "M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M4,6V18H20V6H4M12,10.5A1.5,1.5 0 0,1 13.5,12A1.5,1.5 0 0,1 12,13.5A1.5,1.5 0 0,1 10.5,12A1.5,1.5 0 0,1 12,10.5M12,7.5C14.14,7.5 15.93,9 16.39,11H14.83C14.42,9.83 13.31,9 12,9C10.69,9 9.58,9.83 9.17,11H7.61C8.07,9 9.86,7.5 12,7.5M12,16.5C9.86,16.5 8.07,15 7.61,13H9.17C9.58,14.17 10.69,15 12,15C13.31,15 14.42,14.17 14.83,13H16.39C15.93,15 14.14,16.5 12,16.5Z";
var mdiCameraMeteringMatrix = "M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M4,6V18H20V6H4M5.5,7.5H11V9.17C10.15,9.47 9.47,10.15 9.17,11H5.5V7.5M18.5,7.5V11H14.83C14.53,10.15 13.85,9.47 13,9.17V7.5H18.5M18.5,16.5H13V14.83C13.85,14.53 14.53,13.85 14.83,13H18.5V16.5M5.5,16.5V13H9.17C9.47,13.85 10.15,14.53 11,14.83V16.5H5.5M12,10.5A1.5,1.5 0 0,1 13.5,12A1.5,1.5 0 0,1 12,13.5A1.5,1.5 0 0,1 10.5,12A1.5,1.5 0 0,1 12,10.5Z";
var mdiCameraMeteringPartial = "M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M4,6V18H20V6H4M12,7.5C14.14,7.5 15.93,9 16.39,11H14.83C14.42,9.83 13.31,9 12,9C10.69,9 9.58,9.83 9.17,11H7.61C8.07,9 9.86,7.5 12,7.5M12,16.5C9.86,16.5 8.07,15 7.61,13H9.17C9.58,14.17 10.69,15 12,15C13.31,15 14.42,14.17 14.83,13H16.39C15.93,15 14.14,16.5 12,16.5Z";
var mdiCameraMeteringSpot = "M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M4,6V18H20V6H4M12,10.5A1.5,1.5 0 0,1 13.5,12A1.5,1.5 0 0,1 12,13.5A1.5,1.5 0 0,1 10.5,12A1.5,1.5 0 0,1 12,10.5Z";
var mdiCameraOff = "M1.2,4.47L2.5,3.2L20,20.72L18.73,22L16.73,20H4A2,2 0 0,1 2,18V6C2,5.78 2.04,5.57 2.1,5.37L1.2,4.47M7,4L9,2H15L17,4H20A2,2 0 0,1 22,6V18C22,18.6 21.74,19.13 21.32,19.5L16.33,14.5C16.76,13.77 17,12.91 17,12A5,5 0 0,0 12,7C11.09,7 10.23,7.24 9.5,7.67L5.82,4H7M7,12A5,5 0 0,0 12,17C12.5,17 13.03,16.92 13.5,16.77L11.72,15C10.29,14.85 9.15,13.71 9,12.28L7.23,10.5C7.08,10.97 7,11.5 7,12M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9Z";
var mdiCameraOffOutline = "M17 12C17 12.54 16.9 13.05 16.74 13.54L15 11.78C14.87 10.3 13.7 9.13 12.22 9L10.46 7.26C10.95 7.1 11.46 7 12 7C14.76 7 17 9.24 17 12M9.88 4H14.12L15.95 6H20V16.8L21.88 18.68C21.96 18.47 22 18.24 22 18V6C22 4.89 21.11 4 20 4H16.83L15 2H9L7.18 4L8.6 5.4L9.88 4M22.11 21.46L20.84 22.73L18.11 20H4C2.9 20 2 19.11 2 18V6C2 5.42 2.25 4.9 2.65 4.54L1.11 3L2.39 1.73L22.11 21.46M9 12C9 13.66 10.34 15 12 15C12.33 15 12.65 14.93 12.94 14.83L9.17 11.06C9.07 11.36 9 11.67 9 12M16.11 18L14.45 16.34C13.72 16.75 12.89 17 12 17C9.24 17 7 14.76 7 12C7 11.11 7.25 10.28 7.66 9.55L4.11 6H4V18H16.11Z";
var mdiCameraOutline = "M20,4H16.83L15,2H9L7.17,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6A2,2 0 0,0 20,4M20,18H4V6H8.05L9.88,4H14.12L15.95,6H20V18M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15Z";
var mdiCameraPartyMode = "M12,17C10.37,17 8.94,16.21 8,15H12A3,3 0 0,0 15,12C15,11.65 14.93,11.31 14.82,11H16.9C16.96,11.32 17,11.66 17,12A5,5 0 0,1 12,17M12,7C13.63,7 15.06,7.79 16,9H12A3,3 0 0,0 9,12C9,12.35 9.07,12.68 9.18,13H7.1C7.03,12.68 7,12.34 7,12A5,5 0 0,1 12,7M20,4H16.83L15,2H9L7.17,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z";
var mdiCameraPlus = "M3 4V1H5V4H8V6H5V9H3V6H0V4M6 10V7H9V4H16L17.8 6H21C22.1 6 23 6.9 23 8V20C23 21.1 22.1 22 21 22H5C3.9 22 3 21.1 3 20V10M13 19C17.45 19 19.69 13.62 16.54 10.46C13.39 7.31 8 9.55 8 14C8 16.76 10.24 19 13 19M9.8 14C9.8 16.85 13.25 18.28 15.26 16.26C17.28 14.25 15.85 10.8 13 10.8C11.24 10.8 9.8 12.24 9.8 14Z";
var mdiCameraPlusOutline = "M21 6H17.8L16 4H10V6H15.1L17 8H21V20H5V11H3V20C3 21.1 3.9 22 5 22H21C22.1 22 23 21.1 23 20V8C23 6.9 22.1 6 21 6M8 14C8 18.45 13.39 20.69 16.54 17.54C19.69 14.39 17.45 9 13 9C10.24 9 8 11.24 8 14M13 11C14.64 11.05 15.95 12.36 16 14C15.95 15.64 14.64 16.95 13 17C11.36 16.95 10.05 15.64 10 14C10.05 12.36 11.36 11.05 13 11M5 6H8V4H5V1H3V4H0V6H3V9H5";
var mdiCameraRear = "M12,6C10.89,6 10,5.1 10,4A2,2 0 0,1 12,2C13.09,2 14,2.9 14,4A2,2 0 0,1 12,6M17,0H7A2,2 0 0,0 5,2V16A2,2 0 0,0 7,18H17A2,2 0 0,0 19,16V2A2,2 0 0,0 17,0M14,20V22H19V20M10,20H5V22H10V24L13,21L10,18V20Z";
var mdiCameraRearVariant = "M6,0H18A2,2 0 0,1 20,2V22A2,2 0 0,1 18,24H6A2,2 0 0,1 4,22V2A2,2 0 0,1 6,0M12,2A2,2 0 0,0 10,4A2,2 0 0,0 12,6A2,2 0 0,0 14,4A2,2 0 0,0 12,2M13,18H9V20H13V22L16,19L13,16V18Z";
var mdiCameraRetake = "M20,5H17L15,3H9L7,5H4A2,2 0 0,0 2,7V19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19V7A2,2 0 0,0 20,5M12,18C10.92,18 9.86,17.65 9,17L10.44,15.56C10.91,15.85 11.45,16 12,16A3,3 0 0,0 15,13A3,3 0 0,0 12,10C10.74,10 9.6,10.8 9.18,12H11L8,15L5,12H7.1C7.65,9.29 10.29,7.55 13,8.1C15.7,8.65 17.45,11.29 16.9,14C16.42,16.33 14.38,18 12,18Z";
var mdiCameraRetakeOutline = "M20,5H16.83L15,3H9L7.17,5H4A2,2 0 0,0 2,7V19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19V7A2,2 0 0,0 20,5M20,19H4V7H8.05L9.88,5H14.12L16,7H20V19M12,18C10.92,18 9.86,17.65 9,17L10.44,15.56C10.91,15.85 11.45,16 12,16A3,3 0 0,0 15,13A3,3 0 0,0 12,10C10.74,10 9.6,10.8 9.18,12H11L8,15L5,12H7.1C7.65,9.29 10.29,7.55 13,8.1C15.7,8.65 17.45,11.29 16.9,14C16.42,16.33 14.38,18 12,18Z";
var mdiCameraSwitch = "M15,15.5V13H9V15.5L5.5,12L9,8.5V11H15V8.5L18.5,12M20,4H16.83L15,2H9L7.17,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z";
var mdiCameraSwitchOutline = "M20 4H16.8L15 2H9L7.2 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4M9.9 4H14.1L15.9 6H20V18H4V6H8.1M15 11H9V8.5L5.5 12L9 15.5V13H15V15.5L18.5 12L15 8.5V11Z";
var mdiCameraTimer = "M4.94,6.35C4.55,5.96 4.55,5.32 4.94,4.93C5.33,4.54 5.96,4.54 6.35,4.93L13.07,10.31L13.42,10.59C14.2,11.37 14.2,12.64 13.42,13.42C12.64,14.2 11.37,14.2 10.59,13.42L10.31,13.07L4.94,6.35M12,20A8,8 0 0,0 20,12C20,9.79 19.1,7.79 17.66,6.34L19.07,4.93C20.88,6.74 22,9.24 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12H4A8,8 0 0,0 12,20M12,1A2,2 0 0,1 14,3A2,2 0 0,1 12,5A2,2 0 0,1 10,3A2,2 0 0,1 12,1Z";
var mdiCameraWireless = "M12,10.8A3.2,3.2 0 0,1 15.2,14A3.2,3.2 0 0,1 12,17.2A3.2,3.2 0 0,1 8.8,14A3.2,3.2 0 0,1 12,10.8M16,3.33V2A6,6 0 0,1 22,8H20.67C20.67,5.42 18.58,3.33 16,3.33M16,6V4.67C17.84,4.67 19.33,6.16 19.33,8H18C18,6.89 17.11,6 16,6M17,9H22V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V8A2,2 0 0,1 4,6H7.17L9,4H15V7C16.11,7 17,7.89 17,9M12,19A5,5 0 0,0 17,14A5,5 0 0,0 12,9A5,5 0 0,0 7,14A5,5 0 0,0 12,19Z";
var mdiCameraWirelessOutline = "M20,9V20H4V8H8.05L9.88,6H15V4H9L7.17,6H4A2,2 0 0,0 2,8V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V9H20M20.67,8H22C22,4.68 19.31,2 16,2V3.33C18.58,3.33 20.66,5.41 20.67,8M18,8H19.33C19.32,6.15 17.84,4.67 16,4.67V6C17.11,6 18,6.89 18,8M7,14A5,5 0 0,0 12,19A5,5 0 0,0 17,14A5,5 0 0,0 12,9A5,5 0 0,0 7,14M15,14A3,3 0 0,1 12,17A3,3 0 0,1 9,14A3,3 0 0,1 12,11A3,3 0 0,1 15,14Z";
var mdiCampfire = "M15.9,18.5L21.9,20.1L21.5,22L12.1,19.5L2.7,22L2.2,20.1L8.2,18.5L2.1,16.9L2.6,15L12,17.5L21.4,15L21.9,16.9L15.9,18.5M16.07,7.92C15.91,7.7 15.71,7.5 15.5,7.33C15.05,6.9 14.5,6.59 14.06,6.13C13,5.08 12.79,3.34 13.44,2C12.79,2.17 12.18,2.54 11.67,2.95C9.84,4.46 9.11,7.1 10,9.38C10,9.45 10.04,9.53 10.04,9.62C10.04,9.78 9.93,9.92 9.79,10C9.63,10.05 9.46,10 9.33,9.9C9.28,9.86 9.25,9.82 9.22,9.77C8.42,8.74 8.29,7.26 8.84,6.07C7.65,7.06 7,8.72 7.11,10.29C7.13,10.65 7.18,11 7.3,11.36C7.41,11.8 7.59,12.23 7.82,12.61C8.57,13.86 9.9,14.76 11.32,14.94C12.84,15.14 14.46,14.85 15.63,13.79C16.93,12.59 17.4,10.67 16.71,9L16.61,8.83C16.47,8.5 16.28,8.2 16.04,7.93L16.07,7.92M13.83,12.47C13.63,12.65 13.31,12.83 13.05,12.91C12.26,13.19 11.46,12.79 11,12.31C11.84,12.11 12.34,11.47 12.5,10.83C12.61,10.25 12.39,9.78 12.29,9.22C12.21,8.69 12.22,8.23 12.42,7.73C12.55,8 12.69,8.28 12.86,8.5C13.41,9.22 14.27,9.54 14.45,10.5C14.47,10.63 14.5,10.72 14.5,10.83C14.5,11.43 14.26,12.07 13.82,12.47";
var mdiCancel = "M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22 2 17.5 2 12 6.5 2 12 2M12 4C10.1 4 8.4 4.6 7.1 5.7L18.3 16.9C19.3 15.5 20 13.8 20 12C20 7.6 16.4 4 12 4M16.9 18.3L5.7 7.1C4.6 8.4 4 10.1 4 12C4 16.4 7.6 20 12 20C13.9 20 15.6 19.4 16.9 18.3Z";
var mdiCandelabra = "M20.5 11C20.5 11.55 20.05 12 19.5 12H19V14C19 15.11 18.11 16 17 16H13V20H14C15.11 20 16 20.9 16 22H8C8 20.9 8.9 20 10 20H11V16H7C5.9 16 5 15.11 5 14V12H4.5C3.95 12 3.5 11.55 3.5 11S3.95 10 4.5 10H5V4L7 5V10H7.5C8.05 10 8.5 10.45 8.5 11S8.05 12 7.5 12H7V14H11V12H10.5C9.95 12 9.5 11.55 9.5 11S9.95 10 10.5 10H11V2L13 3V10H13.5C14.05 10 14.5 10.45 14.5 11S14.05 12 13.5 12H13V14H17V12H16.5C15.95 12 15.5 11.55 15.5 11S15.95 10 16.5 10H17V4L19 5V10H19.5C20.05 10 20.5 10.45 20.5 11Z";
var mdiCandelabraFire = "M18 7C18.83 7 19.5 6.33 19.5 5.5C19.5 4.67 18.83 3 18 3S16.5 4.67 16.5 5.5C16.5 6.33 17.17 7 18 7M18 5.25C18.28 5.25 18.5 5.47 18.5 5.75S18.28 6.25 18 6.25 17.5 6.03 17.5 5.75 17.72 5.25 18 5.25M12 6C12.83 6 13.5 5.33 13.5 4.5C13.5 3.67 12.83 2 12 2S10.5 3.67 10.5 4.5C10.5 5.33 11.17 6 12 6M12 4.25C12.28 4.25 12.5 4.47 12.5 4.75S12.28 5.25 12 5.25 11.5 5.03 11.5 4.75 11.72 4.25 12 4.25M6 7C6.83 7 7.5 6.33 7.5 5.5C7.5 4.67 6.83 3 6 3S4.5 4.67 4.5 5.5C4.5 6.33 5.17 7 6 7M6 5.25C6.28 5.25 6.5 5.47 6.5 5.75S6.28 6.25 6 6.25 5.5 6.03 5.5 5.75 5.72 5.25 6 5.25M20.5 11C20.5 11.55 20.05 12 19.5 12H19V14C19 15.11 18.11 16 17 16H13V20H14C15.11 20 16 20.9 16 22H8C8 20.9 8.9 20 10 20H11V16H7C5.9 16 5 15.11 5 14V12H4.5C3.95 12 3.5 11.55 3.5 11S3.95 10 4.5 10V9C4.5 8.45 4.95 8 5.5 8H6.5C7.05 8 7.5 8.45 7.5 9V10C8.05 10 8.5 10.45 8.5 11S8.05 12 7.5 12H7V14H11V12H10.5C9.95 12 9.5 11.55 9.5 11S9.95 10 10.5 10V8C10.5 7.45 10.95 7 11.5 7H12.5C13.05 7 13.5 7.45 13.5 8V10C14.05 10 14.5 10.45 14.5 11S14.05 12 13.5 12H13V14H17V12H16.5C15.95 12 15.5 11.55 15.5 11S15.95 10 16.5 10V9C16.5 8.45 16.95 8 17.5 8H18.5C19.05 8 19.5 8.45 19.5 9V10C20.05 10 20.5 10.45 20.5 11Z";
var mdiCandle = "M12.5,2C10.84,2 9.5,5.34 9.5,7A3,3 0 0,0 12.5,10A3,3 0 0,0 15.5,7C15.5,5.34 14.16,2 12.5,2M12.5,6.5A1,1 0 0,1 13.5,7.5A1,1 0 0,1 12.5,8.5A1,1 0 0,1 11.5,7.5A1,1 0 0,1 12.5,6.5M10,11A1,1 0 0,0 9,12V20H7A1,1 0 0,1 6,19V18A1,1 0 0,0 5,17A1,1 0 0,0 4,18V19A3,3 0 0,0 7,22H19A1,1 0 0,0 20,21A1,1 0 0,0 19,20H16V12A1,1 0 0,0 15,11H10Z";
var mdiCandy = "M15.54 8.46C17.5 10.42 17.5 13.58 15.54 15.54S10.42 17.5 8.47 15.54 6.5 10.42 8.47 8.46 13.58 6.5 15.54 8.46M19.47 4.55C19.47 4.55 18.5 4.67 17.43 5.36C17.28 4.32 16.78 3.27 15.93 2.42C14.68 3.66 14.53 5.22 14.83 6.34C16.22 6.7 17.3 7.78 17.66 9.17C18.78 9.47 20.34 9.32 21.58 8.07C20.74 7.23 19.71 6.74 18.68 6.58C19.07 6 19.38 5.33 19.47 4.55M4.53 19.45C4.53 19.45 5.5 19.33 6.57 18.64C6.72 19.68 7.22 20.73 8.07 21.58C9.32 20.34 9.47 18.78 9.17 17.66C7.78 17.3 6.7 16.22 6.34 14.83C5.22 14.53 3.66 14.68 2.42 15.93C3.26 16.77 4.29 17.27 5.32 17.42C4.93 18 4.62 18.68 4.53 19.45Z";
var mdiCandyOff = "M20.8 22.7L14.4 16.3C12.5 17.4 10 17.1 8.4 15.5C6.8 13.9 6.5 11.4 7.6 9.5L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M15.5 8.5C14.1 7.1 12.2 6.7 10.4 7.3L16.7 13.6C17.3 11.8 16.9 9.8 15.5 8.5M17.7 9.2C18.8 9.5 20.4 9.3 21.6 8.1C20.8 7.3 19.7 6.8 18.7 6.6C19.1 6 19.4 5.3 19.5 4.6C19.5 4.6 18.5 4.7 17.5 5.4C17.4 4.4 16.9 3.3 16 2.5C14.8 3.7 14.6 5.3 14.9 6.4C16.2 6.7 17.3 7.8 17.7 9.2M6.3 14.8C5.2 14.5 3.6 14.7 2.4 15.9C3.2 16.7 4.3 17.2 5.3 17.4C4.9 18 4.6 18.7 4.5 19.4C4.5 19.4 5.5 19.3 6.5 18.6C6.6 19.6 7.1 20.7 8 21.5C9.2 20.3 9.4 18.7 9.1 17.6C7.8 17.3 6.7 16.2 6.3 14.8Z";
var mdiCandyOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L7.7 9.6C6.6 11.5 6.9 14 8.5 15.6S12.6 17.5 14.5 16.4L20.9 22.8L22.1 21.5M9.9 14.1C9.1 13.3 8.8 12.1 9.2 11L13 14.8C11.9 15.2 10.7 15 9.9 14.1M14.8 6.3C14.5 5.2 14.6 3.6 15.9 2.4C16.8 3.3 17.3 4.3 17.4 5.3C18.5 4.6 19.4 4.5 19.4 4.5C19.3 5.3 19 6 18.6 6.5C19.6 6.7 20.7 7.2 21.5 8C20.3 9.2 18.7 9.4 17.6 9.1C17.3 7.8 16.2 6.7 14.8 6.3M12.2 9L10.4 7.2C12.1 6.6 14.1 7 15.5 8.4C16.9 9.8 17.3 11.7 16.7 13.5L15 11.8C14.9 11.1 14.7 10.4 14.1 9.9S12.9 9.1 12.2 9M9.2 17.7C9.5 18.8 9.4 20.4 8.1 21.6C7.2 20.7 6.7 19.7 6.6 18.7C5.5 19.4 4.6 19.5 4.6 19.5C4.7 18.7 5 18 5.4 17.5C4.4 17.3 3.3 16.8 2.5 16C3.7 14.8 5.3 14.6 6.4 14.9C6.7 16.2 7.8 17.3 9.2 17.7Z";
var mdiCandyOutline = "M9.88 9.88C11.05 8.71 12.95 8.71 14.12 9.88S15.29 12.95 14.12 14.12 11.05 15.29 9.88 14.12 8.71 11.05 9.88 9.88M8.46 8.46C6.5 10.42 6.5 13.58 8.46 15.54S13.58 17.5 15.54 15.54 17.5 10.42 15.54 8.46 10.42 6.5 8.46 8.46M19.47 4.55C19.47 4.55 18.5 4.67 17.43 5.37C17.28 4.32 16.78 3.27 15.93 2.42C14.68 3.67 14.53 5.22 14.83 6.34C16.22 6.7 17.3 7.78 17.66 9.17C18.78 9.47 20.34 9.32 21.58 8.07C20.74 7.23 19.71 6.74 18.68 6.58C19.07 6 19.38 5.33 19.47 4.55M4.53 19.45C4.53 19.45 5.5 19.33 6.57 18.64C6.72 19.68 7.22 20.73 8.07 21.58C9.32 20.34 9.47 18.78 9.17 17.66C7.79 17.3 6.7 16.22 6.34 14.83C5.22 14.53 3.67 14.68 2.42 15.93C3.26 16.77 4.29 17.27 5.32 17.42C4.93 18 4.62 18.68 4.53 19.45Z";
var mdiCandycane = "M10,10A2,2 0 0,1 8,12A2,2 0 0,1 6,10V8C6,7.37 6.1,6.77 6.27,6.2L10,9.93V10M12,2C12.74,2 13.44,2.13 14.09,2.38L11.97,6C11.14,6 10.44,6.5 10.15,7.25L7.24,4.34C8.34,2.92 10.06,2 12,2M17.76,6.31L14,10.07V8C14,7.62 13.9,7.27 13.72,6.97L15.83,3.38C16.74,4.13 17.42,5.15 17.76,6.31M18,13.09L14,17.09V12.9L18,8.9V13.09M18,20A2,2 0 0,1 16,22A2,2 0 0,1 14,20V19.91L18,15.91V20Z";
var mdiCannabis = "M11.5,22V17.35C11,18.13 10,19.09 8.03,19.81C8.03,19.81 8.53,18.1 9.94,16.95C8.64,17.23 6.68,17.19 4,16C4,16 6.47,14.59 9.28,14.97C7.69,14 5.7,12.08 4.17,8.11C4.17,8.11 8.67,9.34 10.91,13.14C8.88,8.24 12,2 12,2C14.43,7.47 13.91,11.1 13.12,13.1C15.37,9.33 19.83,8.11 19.83,8.11C18.3,12.08 16.31,14 14.72,14.97C17.53,14.59 20,16 20,16C17.32,17.19 15.36,17.23 14.06,16.95C15.47,18.1 15.97,19.81 15.97,19.81C14,19.09 13,18.13 12.5,17.35V22H11.5Z";
var mdiCannabisOff = "M16.62 13.42L14.5 11.32C16.84 8.94 19.83 8.11 19.83 8.11C18.87 10.6 17.73 12.27 16.62 13.42M12 2C12 2 10.86 4.3 10.41 7.21L13.72 10.5C13.92 8.45 13.61 5.63 12 2M20.84 22.73L22.11 21.46L2.39 1.73L1.11 3L8.62 10.5C6.5 8.75 4.17 8.11 4.17 8.11C5.7 12.08 7.69 14 9.28 14.97C6.47 14.59 4 16 4 16C6.68 17.19 8.64 17.23 9.94 16.95C8.53 18.1 8.03 19.81 8.03 19.81C10 19.09 11 18.13 11.5 17.35V22H12.5V17.35C13 18.13 14 19.09 15.97 19.81C15.97 19.81 15.47 18.1 14.06 16.95C14.39 17 14.77 17.07 15.2 17.09L20.84 22.73Z";
var mdiCapsLock = "M9.96,13.71L12,8.29L14.03,13.72M11.14,6L6.43,18H8.36L9.32,15.43H14.68L15.64,18H17.57L12.86,6H11.14M20,2H4C2.89,2 2,2.89 2,4V20C2,21.11 2.9,22 4,22H20C21.11,22 22,21.11 22,20V4C22,2.89 21.1,2 20,2M20,20H4V4H20V20Z";
var mdiCar = "M5,11L6.5,6.5H17.5L19,11M17.5,16A1.5,1.5 0 0,1 16,14.5A1.5,1.5 0 0,1 17.5,13A1.5,1.5 0 0,1 19,14.5A1.5,1.5 0 0,1 17.5,16M6.5,16A1.5,1.5 0 0,1 5,14.5A1.5,1.5 0 0,1 6.5,13A1.5,1.5 0 0,1 8,14.5A1.5,1.5 0 0,1 6.5,16M18.92,6C18.72,5.42 18.16,5 17.5,5H6.5C5.84,5 5.28,5.42 5.08,6L3,12V20A1,1 0 0,0 4,21H5A1,1 0 0,0 6,20V19H18V20A1,1 0 0,0 19,21H20A1,1 0 0,0 21,20V12L18.92,6Z";
var mdiCar2Plus = "M8 16C8 13.6 9.1 11.5 10.7 10H3L4.5 5.5H15.5L16.3 8C16.9 8 17.5 8.1 18 8.3L16.9 5C16.7 4.4 16.1 4 15.5 4H4.5C3.8 4 3.3 4.4 3.1 5L1 11V19C1 19.5 1.5 20 2 20H3C3.5 20 4 19.5 4 19V18H8.3C8.1 17.4 8 16.7 8 16M4.5 15C3.7 15 3 14.3 3 13.5S3.7 12 4.5 12 6 12.7 6 13.5 5.3 15 4.5 15M16 20V18H13V17H14C15.1 17 16 16.1 16 15V14C16 12.9 15.1 12 14 12H11V14H14V15H13C11.9 15 11 15.9 11 17V20M23 17H21V19H19V17H17V15H19V13H21V15H23V17Z";
var mdiCar3Plus = "M16.9 5C16.7 4.4 16.1 4 15.5 4H4.5C3.8 4 3.3 4.4 3.1 5L1 11V19C1 19.5 1.5 20 2 20H3C3.5 20 4 19.5 4 19V18H8.3C8.1 17.4 8 16.7 8 16C8 13.6 9.1 11.5 10.7 10H3L4.5 5.5H15.5L16.3 8C16.9 8 17.5 8.1 18 8.3L16.9 5M4.5 12C5.3 12 6 12.7 6 13.5S5.3 15 4.5 15 3 14.3 3 13.5 3.7 12 4.5 12M23 17H21V19H19V17H17V15H19V13H21V15H23V17M14.5 16C15.3 16 16 14.8 16 14C16 12.9 15.1 12 14 12H11V14H14V15H12V17H14V18H11V20H14C15.1 20 16 19.1 16 18C16 17.2 15.3 16 14.5 16Z";
var mdiCarArrowLeft = "M12 18C12 14.69 14.69 12 18 12C19.09 12 20.12 12.3 21 12.81V12L18.92 6C18.72 5.42 18.16 5 17.5 5H6.5C5.84 5 5.28 5.42 5.08 6L3 12V20C3 20.55 3.45 21 4 21H5C5.55 21 6 20.55 6 20V19H12.09C12.04 18.67 12 18.34 12 18M6.5 6.5H17.5L19 11H5L6.5 6.5M6.5 16C5.67 16 5 15.33 5 14.5S5.67 13 6.5 13 8 13.67 8 14.5 7.33 16 6.5 16M18 15V17H22V19H18V21L15 18L18 15";
var mdiCarArrowRight = "M12 18C12 14.69 14.69 12 18 12C19.09 12 20.12 12.3 21 12.81V12L18.92 6C18.72 5.42 18.16 5 17.5 5H6.5C5.84 5 5.28 5.42 5.08 6L3 12V20C3 20.55 3.45 21 4 21H5C5.55 21 6 20.55 6 20V19H12.09C12.04 18.67 12 18.34 12 18M6.5 6.5H17.5L19 11H5L6.5 6.5M6.5 16C5.67 16 5 15.33 5 14.5S5.67 13 6.5 13 8 13.67 8 14.5 7.33 16 6.5 16M19 21V19H15V17H19V15L22 18L19 21";
var mdiCarBack = "M6,11L7,7H17L18,11M18.92,6C18.71,5.4 18.14,5 17.5,5H6.5C5.86,5 5.29,5.4 5.08,6L3,12V20A1,1 0 0,0 4,21H5A1,1 0 0,0 6,20V18H18V20A1,1 0 0,0 19,21H20A1,1 0 0,0 21,20V12L18.92,6M7,16H5V14H7V16M19,16H17V14H19V16M14,16H10V14H14V16Z";
var mdiCarBattery = "M4,3V6H1V20H23V6H20V3H14V6H10V3H4M3,8H21V18H3V8M15,10V12H13V14H15V16H17V14H19V12H17V10H15M5,12V14H11V12H5Z";
var mdiCarBrakeAbs = "M24,12C24,15.31 22.66,18.31 20.5,20.5L19.42,19.42C21.32,17.5 22.5,14.9 22.5,12C22.5,9.11 21.32,6.5 19.42,4.58L20.5,3.5C22.66,5.69 24,8.69 24,12M20,9.6V8H16.8C15.92,8 15.2,8.72 15.2,9.6V11.2A1.6,1.6 0 0,0 16.8,12.8H18.4V14.4H15.2V16H18.4C19.28,16 20,15.28 20,14.4V12.8A1.6,1.6 0 0,0 18.4,11.2H16.8V9.6H20M8.42,6C9.47,5.37 10.69,5 12,5C13.31,5 14.53,5.37 15.58,6H18.69C17.05,4.16 14.66,3 12,3C9.34,3 6.95,4.16 5.31,6H8.42M13.2,12C13.84,12 14.4,12.56 14.4,13.2V14.4A1.6,1.6 0 0,1 12.8,16H9.6V8H12.8A1.6,1.6 0 0,1 14.4,9.6V10.8C14.4,11.44 13.84,12 13.2,12M12.8,12.8H11.2V14.4H12.8V12.8M12.8,9.6H11.2V11.2H12.8V9.6M4.58,4.58L3.5,3.5C1.34,5.69 0,8.69 0,12C0,15.31 1.34,18.31 3.5,20.5L4.58,19.42C2.68,17.5 1.5,14.9 1.5,12C1.5,9.11 2.68,6.5 4.58,4.58M7.2,16V12.8H5.6V16H4V9.6A1.6,1.6 0 0,1 5.6,8H7.2C8.08,8 8.8,8.72 8.8,9.6V16H7.2M7.2,11.2V9.6H5.6V11.2H7.2M15.58,18C14.53,18.63 13.31,19 12,19C10.69,19 9.47,18.63 8.42,18H5.31C6.95,19.84 9.34,21 12,21C14.66,21 17.05,19.84 18.69,18H15.58Z";
var mdiCarBrakeAlert = "M11,15H13V17H11V15M11,7H13V13H11V7M12,3A9,9 0 0,0 3,12A9,9 0 0,0 12,21A9,9 0 0,0 21,12A9,9 0 0,0 12,3M12,19C8.14,19 5,15.86 5,12C5,8.14 8.14,5 12,5C15.86,5 19,8.14 19,12C19,15.86 15.86,19 12,19M20.5,20.5C22.66,18.31 24,15.31 24,12C24,8.69 22.66,5.69 20.5,3.5L19.42,4.58C21.32,6.5 22.5,9.11 22.5,12C22.5,14.9 21.32,17.5 19.42,19.42L20.5,20.5M4.58,19.42C2.68,17.5 1.5,14.9 1.5,12C1.5,9.11 2.68,6.5 4.58,4.58L3.5,3.5C1.34,5.69 0,8.69 0,12C0,15.31 1.34,18.31 3.5,20.5L4.58,19.42Z";
var mdiCarBrakeFluidLevel = "M1.5 12C1.5 14.9 2.68 17.5 4.58 19.42L3.5 20.5C1.34 18.31 0 15.31 0 12S1.34 5.69 3.5 3.5L4.58 4.58C2.68 6.5 1.5 9.11 1.5 12M21 12C21 16.97 16.97 21 12 21S3 16.97 3 12 7.03 3 12 3 21 7.03 21 12M5 12C5 12.44 5.05 12.86 5.12 13.28C5.3 13.09 5.46 13 5.78 13C6.3 13 6.39 13.21 6.78 13.71C7.17 14.21 7.85 15 8.89 15C9.92 15 10.61 14.21 11 13.71C11.26 13.37 11.39 13.18 11.61 13.08C11.71 13.03 11.83 13 12 13C12.5 13 12.61 13.21 13 13.71C13.39 14.21 14.08 15 15.11 15C16.15 15 16.83 14.21 17.22 13.71C17.61 13.21 17.7 13 18.22 13C18.54 13 18.7 13.09 18.88 13.28C18.95 12.86 19 12.44 19 12C19 8.14 15.86 5 12 5S5 8.14 5 12M20.5 3.5L19.42 4.58C21.32 6.5 22.5 9.11 22.5 12C22.5 14.9 21.32 17.5 19.42 19.42L20.5 20.5C22.66 18.31 24 15.31 24 12S22.66 5.69 20.5 3.5Z";
var mdiCarBrakeHold = "M12,3C7,3 3,7 3,12C3,17 7,21 12,21C17,21 21,17 21,12C21,7 17,3 12,3M12,19C8.1,19 5,15.9 5,12C5,8.1 8.1,5 12,5C15.9,5 19,8.1 19,12C19,15.9 15.9,19 12,19M20.5,20.5C22.7,18.3 24,15.3 24,12C24,8.7 22.7,5.7 20.5,3.5L19.4,4.6C21.3,6.5 22.5,9.1 22.5,12C22.5,14.9 21.3,17.5 19.4,19.4L20.5,20.5M4.6,19.4C2.7,17.5 1.5,14.9 1.5,12C1.5,9.1 2.7,6.5 4.6,4.6L3.5,3.5C1.3,5.7 0,8.7 0,12C0,15.3 1.3,18.3 3.5,20.5L4.6,19.4M9,7V17H11V13H13V17H15V7H13V11H11V7H9Z";
var mdiCarBrakeLowPressure = "M13 12C13 12.55 12.55 13 12 13S11 12.55 11 12 11.45 11 12 11 13 11.45 13 12M10 12L7 9V11H3V13H7V15L10 12M14 12L17 15V13H21V11H17V9L14 12M20.5 3.5L19.42 4.58C21.32 6.5 22.5 9.11 22.5 12C22.5 14.9 21.32 17.5 19.42 19.42L20.5 20.5C22.66 18.31 24 15.31 24 12S22.66 5.69 20.5 3.5M5.69 9C6.81 6.64 9.22 5 12 5S17.19 6.64 18.32 9H20.5C19.24 5.5 15.92 3 12 3S4.76 5.5 3.5 9H5.69M4.58 4.58L3.5 3.5C1.34 5.69 0 8.69 0 12S1.34 18.31 3.5 20.5L4.58 19.42C2.68 17.5 1.5 14.9 1.5 12C1.5 9.11 2.68 6.5 4.58 4.58M18.32 15C17.19 17.36 14.79 19 12 19S6.81 17.36 5.69 15H3.5C4.76 18.5 8.08 21 12 21S19.24 18.5 20.5 15H18.32Z";
var mdiCarBrakeParking = "M12,3C7,3 3,7 3,12C3,17 7,21 12,21C17,21 21,17 21,12C21,7 17,3 12,3M12,19C8.1,19 5,15.9 5,12C5,8.1 8.1,5 12,5C15.9,5 19,8.1 19,12C19,15.9 15.9,19 12,19M20.5,20.5C22.7,18.3 24,15.3 24,12C24,8.7 22.7,5.7 20.5,3.5L19.4,4.6C21.3,6.5 22.5,9.1 22.5,12C22.5,14.9 21.3,17.5 19.4,19.4L20.5,20.5M4.6,19.4C2.7,17.5 1.5,14.9 1.5,12C1.5,9.1 2.7,6.5 4.6,4.6L3.5,3.5C1.3,5.7 0,8.7 0,12C0,15.3 1.3,18.3 3.5,20.5L4.6,19.4M9.5,7V17H11.5V13H13.5A2,2 0 0,0 15.5,11V9A2,2 0 0,0 13.5,7H9.5M11.5,9H13.5V11H11.5V9Z";
var mdiCarBrakeRetarder = "M12 3C7 3 3 7 3 12S7 21 12 21 21 17 21 12 17 3 12 3M12 19C8.1 19 5 15.9 5 12S8.1 5 12 5 19 8.1 19 12 15.9 19 12 19M20.5 20.5C22.7 18.3 24 15.3 24 12S22.7 5.7 20.5 3.5L19.4 4.6C21.3 6.5 22.5 9.1 22.5 12S21.3 17.5 19.4 19.4L20.5 20.5M4.6 19.4C2.7 17.5 1.5 14.9 1.5 12S2.7 6.5 4.6 4.6L3.5 3.5C1.3 5.7 0 8.7 0 12S1.3 18.3 3.5 20.5L4.6 19.4M15.3 10.5C15.96 10.5 16.5 11.17 16.5 12C16.5 12.81 15.95 13.5 15.3 13.5C14.93 13.5 14.66 13.29 14.5 13.11L14.47 13.08L14.44 13.05L13.38 12L14.47 10.92L14.5 10.89L14.53 10.86C14.74 10.63 15 10.5 15.3 10.5M8.7 10.5C9.07 10.5 9.34 10.71 9.5 10.88L9.5 10.92L9.56 10.95L10.62 12L9.53 13.08L9.5 13.11L9.47 13.15C9.26 13.37 9 13.5 8.7 13.5C8.05 13.5 7.5 12.81 7.5 12S8.05 10.5 8.7 10.5M15.3 9C14.58 9 13.9 9.31 13.42 9.85L12 11.25L10.61 9.88C10.1 9.31 9.42 9 8.7 9C7.21 9 6 10.35 6 12S7.21 15 8.7 15C9.42 15 10.1 14.69 10.59 14.15L12 12.75L13.39 14.12C13.9 14.68 14.58 15 15.3 15C16.79 15 18 13.65 18 12C18 10.33 16.79 9 15.3 9Z";
var mdiCarBrakeTemperature = "M12 10H15V8H12V7C12 6.4 11.6 6 11 6S10 6.4 10 7V17.3C9.4 17.6 9 18.3 9 19C9 20.1 9.9 21 11 21S13 20.1 13 19C13 18.3 12.6 17.6 12 17.3V14H15V12H12V10M24 12C24 15.31 22.66 18.31 20.5 20.5L19.42 19.42C21.32 17.5 22.5 14.9 22.5 12C22.5 9.11 21.32 6.5 19.42 4.58L20.5 3.5C22.66 5.69 24 8.69 24 12M1.5 12C1.5 14.9 2.68 17.5 4.58 19.42L3.5 20.5C1.34 18.31 0 15.31 0 12S1.34 5.69 3.5 3.5L4.58 4.58C2.68 6.5 1.5 9.11 1.5 12M21 12C21 15.53 18.96 18.58 16 20.05V17.74C17.81 16.47 19 14.37 19 12C19 8.14 15.86 5 12 5S5 8.14 5 12C5 14.37 6.19 16.47 8 17.74V20.05C5.04 18.58 3 15.53 3 12C3 7.03 7.03 3 12 3S21 7.03 21 12Z";
var mdiCarBrakeWornLinings = "M12 5C15.86 5 19 8.14 19 12S15.86 19 12 19 5 15.86 5 12 8.14 5 12 5M12 3C7.03 3 3 7.03 3 12S7.03 21 12 21 21 16.97 21 12 16.97 3 12 3M4.58 4.58L3.5 3.5C2.37 4.65 1.47 6.03 .861 7.55L2.3 8C2.84 6.71 3.61 5.56 4.58 4.58M1.71 14.1C1.57 13.42 1.5 12.72 1.5 12C1.5 11.28 1.57 10.58 1.71 9.9L.275 9.46C.098 10.28 0 11.13 0 12S.098 13.72 .275 14.54L1.71 14.1M23.14 7.55C22.53 6.03 21.63 4.65 20.5 3.5L19.42 4.58C20.39 5.56 21.16 6.71 21.7 8L23.14 7.55M.861 16.45C1.47 18 2.37 19.35 3.5 20.5L4.58 19.42C3.61 18.44 2.84 17.29 2.3 16L.861 16.45M19.42 19.42L20.5 20.5C21.63 19.35 22.53 18 23.14 16.45L21.7 16C21.16 17.29 20.39 18.44 19.42 19.42M22.29 9.9C22.43 10.58 22.5 11.28 22.5 12C22.5 12.72 22.43 13.42 22.29 14.1L23.73 14.54C23.9 13.72 24 12.87 24 12S23.9 10.28 23.73 9.46L22.29 9.9Z";
var mdiCarChildSeat = "M17 4.5C17 5.9 15.9 7 14.5 7S12 5.9 12 4.5 13.1 2 14.5 2 17 3.1 17 4.5M15 8H14.2C12.1 8 10.1 6.8 9.1 4.9C9 4.8 8.9 4.7 8.9 4.6L7.1 5.4C7.6 6.8 9.2 8.6 11.5 9.5L9.7 14.5L5.8 13.4L3 18.9L5 19.4L6.8 15.8L11.3 17C12.3 17.2 13.3 16.7 13.7 15.8L16 9.4C16.2 8.7 15.7 8 15 8M18.9 7L15.5 16.4C14.9 18 13.4 19 11.8 19C11.5 19 11.1 19 10.8 18.9L7.9 18.1L7 19.9L9 20.4L10.4 20.8C10.9 20.9 11.4 21 11.9 21C14.4 21 16.6 19.5 17.5 17.1L21 7H18.9Z";
var mdiCarClock = "M23 8C23 4.13 19.87 1 16 1C12.47 1 9.57 3.61 9.08 7H4.5C3.84 7 3.28 7.42 3.08 8L1 14V22C1 22.55 1.45 23 2 23H3C3.55 23 4 22.55 4 22V21H16V22C16 22.55 16.45 23 17 23H18C18.55 23 19 22.55 19 22V14.32C21.36 13.19 23 10.79 23 8M4.5 8.5H9.03C9.15 10.26 9.92 11.84 11.11 13H3L4.5 8.5M4.5 18C3.67 18 3 17.33 3 16.5S3.67 15 4.5 15 6 15.67 6 16.5 5.33 18 4.5 18M15.5 18C14.67 18 14 17.33 14 16.5S14.67 15 15.5 15 17 15.67 17 16.5 16.33 18 15.5 18M16 13C14.61 13 13.44 12.5 12.47 11.53C11.5 10.56 11 9.39 11 8C11 6.64 11.5 5.46 12.47 4.5C13.44 3.5 14.61 3 16 3C17.36 3 18.54 3.5 19.5 4.5C20.5 5.46 21 6.64 21 8C21 9.39 20.5 10.56 19.5 11.53C18.54 12.5 17.36 13 16 13M16.5 8.25L19.36 9.94L18.61 11.16L15 9V4H16.5V8.25Z";
var mdiCarClutch = "M10 18.84L14 20.7V23L8 20V14H5V10H8V4L14 1V3.3L10 5.16V18.84M19 10H15V5.41L12 6.8V17.2L15 18.6V14H19V10Z";
var mdiCarCog = "M6.5 5C5.84 5 5.28 5.42 5.08 6L3 12V20A1 1 0 0 0 4 21H5A1 1 0 0 0 6 20V19H11.3A7 7 0 0 1 11 17A7 7 0 0 1 14.41 11H5L6.5 6.5H17.5L18.68 10.03A7 7 0 0 1 20.47 10.46L18.92 6C18.72 5.42 18.16 5 17.5 5H6.5M17 12C16.87 12 16.76 12.09 16.74 12.21L16.55 13.53C16.25 13.66 15.96 13.82 15.7 14L14.46 13.5C14.35 13.5 14.22 13.5 14.15 13.63L13.15 15.36C13.09 15.47 13.11 15.6 13.21 15.68L14.27 16.5C14.25 16.67 14.24 16.83 14.24 17C14.24 17.17 14.25 17.33 14.27 17.5L13.21 18.32C13.12 18.4 13.09 18.53 13.15 18.64L14.15 20.37C14.21 20.5 14.34 20.5 14.46 20.5L15.7 20C15.96 20.18 16.24 20.35 16.55 20.47L16.74 21.79C16.76 21.91 16.86 22 17 22H19C19.11 22 19.22 21.91 19.24 21.79L19.43 20.47C19.73 20.34 20 20.18 20.27 20L21.5 20.5C21.63 20.5 21.76 20.5 21.83 20.37L22.83 18.64C22.89 18.53 22.86 18.4 22.77 18.32L21.7 17.5C21.72 17.33 21.74 17.17 21.74 17C21.74 16.83 21.73 16.67 21.7 16.5L22.76 15.68C22.85 15.6 22.88 15.47 22.82 15.36L21.82 13.63C21.76 13.5 21.63 13.5 21.5 13.5L20.27 14C20 13.82 19.73 13.65 19.42 13.53L19.23 12.21C19.22 12.09 19.11 12 19 12H17M6.5 13A1.5 1.5 0 0 1 8 14.5A1.5 1.5 0 0 1 6.5 16A1.5 1.5 0 0 1 5 14.5A1.5 1.5 0 0 1 6.5 13M18 15.5C18.83 15.5 19.5 16.17 19.5 17C19.5 17.83 18.83 18.5 18 18.5C17.16 18.5 16.5 17.83 16.5 17C16.5 16.17 17.17 15.5 18 15.5Z";
var mdiCarConnected = "M5,14H19L17.5,9.5H6.5L5,14M17.5,19A1.5,1.5 0 0,0 19,17.5A1.5,1.5 0 0,0 17.5,16A1.5,1.5 0 0,0 16,17.5A1.5,1.5 0 0,0 17.5,19M6.5,19A1.5,1.5 0 0,0 8,17.5A1.5,1.5 0 0,0 6.5,16A1.5,1.5 0 0,0 5,17.5A1.5,1.5 0 0,0 6.5,19M18.92,9L21,15V23A1,1 0 0,1 20,24H19A1,1 0 0,1 18,23V22H6V23A1,1 0 0,1 5,24H4A1,1 0 0,1 3,23V15L5.08,9C5.28,8.42 5.85,8 6.5,8H17.5C18.15,8 18.72,8.42 18.92,9M12,0C14.12,0 16.15,0.86 17.65,2.35L16.23,3.77C15.11,2.65 13.58,2 12,2C10.42,2 8.89,2.65 7.77,3.77L6.36,2.35C7.85,0.86 9.88,0 12,0M12,4C13.06,4 14.07,4.44 14.82,5.18L13.4,6.6C13.03,6.23 12.53,6 12,6C11.5,6 10.97,6.23 10.6,6.6L9.18,5.18C9.93,4.44 10.94,4 12,4Z";
var mdiCarConvertible = "M16,6L15,6.75L17.5,10H13.5V8.5H12V10H3C1.89,10 1,10.89 1,12V15H3A3,3 0 0,0 6,18A3,3 0 0,0 9,15H15A3,3 0 0,0 18,18A3,3 0 0,0 21,15H23V12C23,10.89 22.11,10 21,10H19L16,6M6,13.5A1.5,1.5 0 0,1 7.5,15A1.5,1.5 0 0,1 6,16.5A1.5,1.5 0 0,1 4.5,15A1.5,1.5 0 0,1 6,13.5M18,13.5A1.5,1.5 0 0,1 19.5,15A1.5,1.5 0 0,1 18,16.5A1.5,1.5 0 0,1 16.5,15A1.5,1.5 0 0,1 18,13.5Z";
var mdiCarCoolantLevel = "M19 7V5H21V3H13V5H15V7H1V21H23V7H19M21 14.42C20.71 14.13 20.5 14 20 14C19.33 14 19.21 14.21 18.71 14.71S17.33 16 16 16 13.79 15.21 13.29 14.71 12.67 14 12 14C11.78 14 11.63 14.03 11.5 14.08C11.22 14.18 11.05 14.37 10.71 14.71C10.21 15.21 9.33 16 8 16S5.79 15.21 5.29 14.71 4.67 14 4 14C3.5 14 3.29 14.13 3 14.42V9H21V14.42Z";
var mdiCarCruiseControl = "M22,15C22,17.6 20.8,19.9 18.9,21.3L18.4,20.8L16.3,18.7L17.7,17.3L18.9,18.5C19.4,17.8 19.8,16.9 19.9,16H18V14H19.9C19.7,13.1 19.4,12.3 18.9,11.5L17.7,12.7L16.3,11.3L17.5,10.1C16.8,9.6 15.9,9.2 15,9.1V11H13V9.1C12.1,9.3 11.3,9.6 10.5,10.1L13.5,13.1C13.7,13.1 13.8,13 14,13A2,2 0 0,1 16,15A2,2 0 0,1 14,17A2,2 0 0,1 12,15C12,14.8 12,14.7 12.1,14.5L9.1,11.5C8.6,12.2 8.2,13.1 8.1,14H10V16H8.1C8.3,16.9 8.6,17.7 9.1,18.5L10.3,17.3L11.7,18.7L9.1,21.3C7.2,19.9 6,17.6 6,15A8,8 0 0,1 14,7A8,8 0 0,1 22,15M6.7,5.3L3.4,2L2,3.4L5.3,6.7L4,8H8V4L6.7,5.3Z";
var mdiCarDefrostFront = "M15,23C14.7,23 14.5,22.9 14.3,22.7C13.9,22.3 14,21.7 14.4,21.3V21.3C14.9,20.9 16.1,19.5 16.1,18.4C16.1,17.8 15.7,17.2 15.3,16.5C14.8,15.7 14.1,14.7 14.1,13.5C14.1,11.2 15.4,10.3 15.6,10.2C16.1,9.9 16.7,10.1 17,10.5C17.3,11 17.1,11.6 16.7,11.9V11.9C16.7,11.9 16.2,12.3 16.2,13.5C16.2,14.1 16.6,14.7 17,15.4C17.5,16.2 18.2,17.2 18.2,18.4C18.2,20.6 16.1,22.6 15.9,22.8C15.5,22.9 15.2,23 15,23M11.7,22.7C11.9,22.5 14,20.5 14,18.3C14,17.1 13.4,16.1 12.8,15.3C12.4,14.6 12,14 12,13.4C12,12.2 12.5,11.8 12.5,11.8V11.8C13,11.5 13.1,10.9 12.8,10.4C12.5,9.9 11.9,9.8 11.4,10.1C11.2,10.2 9.9,11.1 9.9,13.4C9.9,14.6 10.5,15.6 11.1,16.4C11.5,17.1 11.9,17.7 11.9,18.3C11.9,19.4 10.7,20.8 10.2,21.2V21.2C9.8,21.6 9.8,22.2 10.1,22.6C10.3,22.8 10.6,22.9 10.8,22.9C11.2,23 11.5,22.9 11.7,22.7M7.7,22.7C7.9,22.5 10,20.5 10,18.3C10,17.1 9.4,16.1 8.8,15.3C8.4,14.7 8,14.1 8,13.4C8,12.2 8.5,11.8 8.5,11.8V11.8C9,11.5 9.1,10.9 8.8,10.4C8.6,10 7.9,9.9 7.5,10.1C7.3,10.2 6,11.1 6,13.4C6,14.6 6.6,15.6 7.2,16.4C7.6,17.1 8,17.7 8,18.3C8,19.4 6.8,20.8 6.3,21.2V21.2C5.9,21.6 5.9,22.2 6.2,22.6C6.5,22.9 6.7,23 7,23C7.2,23 7.5,22.9 7.7,22.7M12,3C9.4,3 1,3.3 1,7C1,9.4 2.2,15.4 2.8,18H4L4.8,18H5V16H4.4C3.8,13.1 3,8.8 3,7C3,6 7.4,5 12,5C16.6,5 21,6 21,7C21,8.8 20.2,13.1 19.6,16H19V18H19.2L20,18H21.2C21.8,15.4 23,9.4 23,7C23,3.3 14.6,3 12,3Z";
var mdiCarDefrostRear = "M10,18.3C10,20.5 7.9,22.5 7.7,22.7C7.5,22.9 7.2,23 7,23C6.7,23 6.5,22.9 6.2,22.6C5.9,22.2 5.9,21.6 6.3,21.2C6.8,20.8 8,19.4 8,18.3C8,17.7 7.6,17.1 7.2,16.4C6.6,15.6 6,14.6 6,13.4C6,11.1 7.3,10.2 7.5,10.1C7.9,9.9 8.6,10 8.8,10.4C9.1,10.9 9,11.5 8.5,11.8C8.5,11.8 8,12.2 8,13.4C8,14.1 8.4,14.7 8.8,15.3C9.4,16.1 10,17.1 10,18.3M12,13.4C12,12.2 12.5,11.8 12.5,11.8C13,11.5 13.1,10.9 12.8,10.4C12.5,9.9 11.9,9.8 11.4,10.1C11.2,10.2 9.9,11.1 9.9,13.4C9.9,14.6 10.5,15.6 11.1,16.4C11.5,17.1 11.9,17.7 11.9,18.3C11.9,19.4 10.7,20.8 10.2,21.2C9.8,21.6 9.8,22.2 10.1,22.6C10.3,22.8 10.6,22.9 10.8,22.9C11.2,23 11.5,22.9 11.7,22.7C11.9,22.5 14,20.5 14,18.3C14,17.1 13.4,16.1 12.8,15.3C12.4,14.6 12,14 12,13.4M20,3H4A2,2 0 0,0 2,5V16A2,2 0 0,0 4,18H5V16H4V5H20V16H19V18H20A2,2 0 0,0 22,16V5A2,2 0 0,0 20,3M16.2,13.5C16.2,12.3 16.7,11.9 16.7,11.9C17.1,11.6 17.3,11 17,10.5C16.7,10.1 16.1,9.9 15.6,10.2C15.4,10.3 14.1,11.2 14.1,13.5C14.1,14.7 14.8,15.7 15.3,16.5C15.7,17.2 16.1,17.8 16.1,18.4C16.1,19.5 14.9,20.9 14.4,21.3C14,21.7 13.9,22.3 14.3,22.7C14.5,22.9 14.7,23 15,23C15.2,23 15.5,22.9 15.9,22.8C16.1,22.6 18.2,20.6 18.2,18.4C18.2,17.2 17.5,16.2 17,15.4C16.6,14.7 16.2,14.1 16.2,13.5Z";
var mdiCarDoor = "M19,14H16V16H19V14M22,21H3V11L11,3H21A1,1 0 0,1 22,4V21M11.83,5L5.83,11H20V5H11.83Z";
var mdiCarDoorLock = "M7.8 17V15.5C7.8 14.1 6.4 13 5 13S2.2 14.1 2.2 15.5V17C1.6 17 1 17.6 1 18.2V21.7C1 22.4 1.6 23 2.2 23H7.7C8.4 23 9 22.4 9 21.8V18.3C9 17.6 8.4 17 7.8 17M6.5 17H3.5V15.5C3.5 14.7 4.2 14.2 5 14.2S6.5 14.7 6.5 15.5V17M21 3H11L3 11V11.44C3.61 11.17 4.29 11 5 11C7.6 11 9.8 13.06 9.8 15.5V15.75C10.53 16.36 11 17.28 11 18.3V21H22V4C22 3.45 21.55 3 21 3M19 16H16V14H19V16M20 11H5.83L11.83 5H20V11Z";
var mdiCarDoorLockOpen = "M22 21H11V16C11 15.26 10.6 14.61 10 14.26C10 14.18 10 14.09 10 14C10 12.87 9.63 11.84 9 11H20V5H11.83L7.28 9.55C6.6 9.2 5.82 9 5 9L11 3H21C21.27 3 21.5 3.11 21.71 3.29C21.9 3.5 22 3.74 22 4V21M19 14H16V16H19V14M7.8 16H3.5V13.5C3.5 12.7 4.2 12.2 5 12.2C5.8 12.2 6.5 12.7 6.5 13.5V14H7.8V13.5C7.8 12.1 6.4 11 5 11C3.6 11 2.2 12.1 2.2 13.5V16C1.6 16 1 16.6 1 17.2V20.7C1 21.4 1.6 22 2.2 22H7.7C8.4 22 9 21.4 9 20.8V17.3C9 16.6 8.4 16 7.8 16Z";
var mdiCarElectric = "M18.92 2C18.72 1.42 18.16 1 17.5 1H6.5C5.84 1 5.29 1.42 5.08 2L3 8V16C3 16.55 3.45 17 4 17H5C5.55 17 6 16.55 6 16V15H18V16C18 16.55 18.45 17 19 17H20C20.55 17 21 16.55 21 16V8L18.92 2M6.5 12C5.67 12 5 11.33 5 10.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12M17.5 12C16.67 12 16 11.33 16 10.5S16.67 9 17.5 9 19 9.67 19 10.5 18.33 12 17.5 12M5 7L6.5 2.5H17.5L19 7H5M7 20H11V18L17 21H13V23L7 20Z";
var mdiCarElectricOutline = "M18.92 2C18.72 1.42 18.16 1 17.5 1H6.5C5.84 1 5.29 1.42 5.08 2L3 8V16C3 16.55 3.45 17 4 17H5C5.55 17 6 16.55 6 16V15H18V16C18 16.55 18.45 17 19 17H20C20.55 17 21 16.55 21 16V8L18.92 2M6.85 3H17.14L18.22 6.11H5.77L6.85 3M19 13H5V8H19V13M7.5 9C8.33 9 9 9.67 9 10.5S8.33 12 7.5 12 6 11.33 6 10.5 6.67 9 7.5 9M16.5 9C17.33 9 18 9.67 18 10.5S17.33 12 16.5 12C15.67 12 15 11.33 15 10.5S15.67 9 16.5 9M7 20H11V18L17 21H13V23L7 20Z";
var mdiCarEmergency = "M11 0V3H13V0H11M7.88 1.46L6.46 2.87L8.59 5L10 3.58L7.88 1.46M16.12 1.46L14 3.58L15.41 5L17.54 2.88L16.12 1.46M12 5A2 2 0 0 0 10 7V8H6.5C5.84 8 5.28 8.42 5.08 9L3 15V23A1 1 0 0 0 4 24H5A1 1 0 0 0 6 23V22H18V23A1 1 0 0 0 19 24H20A1 1 0 0 0 21 23V15L18.92 9C18.72 8.42 18.16 8 17.5 8H14V7A2 2 0 0 0 12 5M6.5 9.5H17.5L19 14H5L6.5 9.5M6.5 16A1.5 1.5 0 0 1 8 17.5A1.5 1.5 0 0 1 6.5 19A1.5 1.5 0 0 1 5 17.5A1.5 1.5 0 0 1 6.5 16M17.5 16A1.5 1.5 0 0 1 19 17.5A1.5 1.5 0 0 1 17.5 19A1.5 1.5 0 0 1 16 17.5A1.5 1.5 0 0 1 17.5 16Z";
var mdiCarEsp = "M5.31,6C6.95,4.16 9.34,3 12,3C14.66,3 17.05,4.16 18.69,6H15.58C14.53,5.37 13.31,5 12,5C10.69,5 9.47,5.37 8.42,6H5.31M14.4,9.6V8H11.2A1.6,1.6 0 0,0 9.6,9.6V11.2C9.6,12.08 10.32,12.8 11.2,12.8H12.8V14.4H9.6V16H12.8A1.6,1.6 0 0,0 14.4,14.4V12.8C14.4,11.92 13.68,11.2 12.8,11.2H11.2V9.6H14.4M18.4,8H15.2V16H16.8V12.8H18.4A1.6,1.6 0 0,0 20,11.2V9.6C20,8.72 19.28,8 18.4,8M18.4,11.2H16.8V9.6H18.4V11.2M8.8,9.6V8H4V16H8.8V14.4H5.6V12.8H8.8V11.2H5.6V9.6H8.8M15.58,18C14.53,18.63 13.31,19 12,19C10.69,19 9.47,18.63 8.42,18H5.31C6.95,19.84 9.34,21 12,21C14.66,21 17.05,19.84 18.69,18H15.58M20.5,3.5L19.42,4.58C21.32,6.5 22.5,9.11 22.5,12C22.5,14.9 21.32,17.5 19.42,19.42L20.5,20.5C22.66,18.31 24,15.31 24,12C24,8.69 22.66,5.69 20.5,3.5M4.58,4.58L3.5,3.5C1.34,5.69 0,8.69 0,12C0,15.31 1.34,18.31 3.5,20.5L4.58,19.42C2.68,17.5 1.5,14.9 1.5,12C1.5,9.11 2.68,6.5 4.58,4.58Z";
var mdiCarEstate = "M3,6H16L19,10H21C22.11,10 23,10.89 23,12V15H21A3,3 0 0,1 18,18A3,3 0 0,1 15,15H9A3,3 0 0,1 6,18A3,3 0 0,1 3,15H1V8C1,6.89 1.89,6 3,6M2.5,7.5V10H10.5V7.5H2.5M12,7.5V10H17.14L15.25,7.5H12M6,13.5A1.5,1.5 0 0,0 4.5,15A1.5,1.5 0 0,0 6,16.5A1.5,1.5 0 0,0 7.5,15A1.5,1.5 0 0,0 6,13.5M18,13.5A1.5,1.5 0 0,0 16.5,15A1.5,1.5 0 0,0 18,16.5A1.5,1.5 0 0,0 19.5,15A1.5,1.5 0 0,0 18,13.5Z";
var mdiCarHatchback = "M16,6H6L1,12V15H3A3,3 0 0,0 6,18A3,3 0 0,0 9,15H15A3,3 0 0,0 18,18A3,3 0 0,0 21,15H23V12C23,10.89 22.11,10 21,10H19L16,6M6.5,7.5H10.5V10H4.5L6.5,7.5M12,7.5H15.5L17.46,10H12V7.5M6,13.5A1.5,1.5 0 0,1 7.5,15A1.5,1.5 0 0,1 6,16.5A1.5,1.5 0 0,1 4.5,15A1.5,1.5 0 0,1 6,13.5M18,13.5A1.5,1.5 0 0,1 19.5,15A1.5,1.5 0 0,1 18,16.5A1.5,1.5 0 0,1 16.5,15A1.5,1.5 0 0,1 18,13.5Z";
var mdiCarInfo = "M19 15H17V13H19M20 20V22H16V20H17V18H16V16H19V20M18.92 5A1.5 1.5 0 0 0 17.5 4H6.5A1.5 1.5 0 0 0 5.08 5L3 11V19A1 1 0 0 0 4 20H5A1 1 0 0 0 6 19V18H11A7 7 0 0 1 18 11A6.84 6.84 0 0 1 21 11.68V11M6.5 15A1.5 1.5 0 1 1 8 13.5A1.5 1.5 0 0 1 6.5 15M5 10L6.5 5.5H17.5L19 10Z";
var mdiCarKey = "M9 0C7.3 0 6 1.3 6 3S7.3 6 9 6C10.3 6 11.4 5.2 11.8 4H14V6H16V4H18V2H11.8C11.4 .8 10.3 0 9 0M9 2C9.6 2 10 2.4 10 3S9.6 4 9 4 8 3.6 8 3 8.4 2 9 2M6.5 8C5.8 8 5.3 8.4 5.1 9L3 15V23C3 23.6 3.4 24 4 24H5C5.6 24 6 23.6 6 23V22H18V23C18 23.6 18.4 24 19 24H20C20.6 24 21 23.6 21 23V15L18.9 9C18.7 8.4 18.1 8 17.5 8H6.5M6.5 9.5H17.5L19 14H5L6.5 9.5M6.5 16C7.3 16 8 16.7 8 17.5S7.3 19 6.5 19 5 18.3 5 17.5 5.7 16 6.5 16M17.5 16C18.3 16 19 16.7 19 17.5S18.3 19 17.5 19 16 18.3 16 17.5 16.7 16 17.5 16Z";
var mdiCarLiftedPickup = "M18 14L18.79 14.1L18.77 14.33L19.24 14.5L19.39 14.34C19.89 14.6 20.32 15 20.6 15.5L20.43 15.67L20.63 16.12L20.86 16.1C20.95 16.39 21 16.69 21 17L20.9 17.78L20.66 17.77L20.47 18.24L20.66 18.39C20.39 18.9 20 19.32 19.5 19.6L19.33 19.42L18.87 19.62L18.89 19.86C18.61 19.95 18.31 20 18 20L17.21 19.9L17.22 19.65L16.76 19.47L16.6 19.66C16.1 19.39 15.67 19 15.39 18.5L15.57 18.32L15.37 17.86L15.13 17.88C15.05 17.6 15 17.31 15 17L15.11 16.2L15.34 16.21L15.53 15.75L15.35 15.6C15.62 15.09 16 14.68 16.5 14.39L16.67 14.56L17.13 14.36L17.11 14.14C17.39 14.05 17.69 14 18 14M18 15.5C17.17 15.5 16.5 16.17 16.5 17C16.5 17.83 17.17 18.5 18 18.5C18.83 18.5 19.5 17.83 19.5 17C19.5 16.17 18.83 15.5 18 15.5M6 14L6.79 14.1L6.77 14.33L7.24 14.5L7.39 14.34C7.89 14.6 8.32 15 8.6 15.5L8.43 15.67L8.63 16.12L8.86 16.1C8.95 16.39 9 16.69 9 17L8.9 17.78L8.65 17.77L8.47 18.24L8.66 18.39C8.39 18.9 8 19.32 7.5 19.6L7.33 19.42L6.87 19.62L6.89 19.86C6.61 19.95 6.31 20 6 20L5.21 19.9L5.22 19.65L4.76 19.47L4.6 19.66C4.1 19.39 3.67 19 3.39 18.5L3.57 18.32L3.37 17.86L3.13 17.88C3.05 17.6 3 17.31 3 17L3.11 16.2L3.34 16.21L3.53 15.75L3.35 15.6C3.62 15.09 4 14.68 4.5 14.39L4.67 14.56L5.13 14.36L5.11 14.14C5.39 14.05 5.69 14 6 14M6 15.5C5.17 15.5 4.5 16.17 4.5 17C4.5 17.83 5.17 18.5 6 18.5C6.83 18.5 7.5 17.83 7.5 17C7.5 16.17 6.83 15.5 6 15.5M16 6L19 10H21C22.11 10 23 10.89 23 12V15H21C21 13.34 19.66 12 18 12C16.34 12 15 13.34 15 15H9C9 13.34 7.66 12 6 12C4.34 12 3 13.34 3 15H1V10H10.5V6L16 6M12 7.5V10H17.46L15.5 7.5H12Z";
var mdiCarLightAlert = "M23 7V13H21V7H23M21 17H23V15H21V17M1 9V11H5C5.1 10.3 5.1 9.6 5.2 9H1M5 13H1V15H5.2C5.1 14.4 5.1 13.7 5 13M5.9 6.4C6 5.8 6.3 5.4 6.5 5H1V7H5.7C5.8 6.8 5.8 6.6 5.9 6.4M1 17V19H6.6C6.2 18.4 5.9 17.8 5.7 17H1M10 4.8C6 4.8 6 19.2 10 19.2S19 16.5 19 12 14 4.8 10 4.8M10.1 17.2C9.7 16.8 9 15 9 12S9.7 7.2 10.1 6.8C13 6.9 17 8.7 17 12S13 17.1 10.1 17.2";
var mdiCarLightDimmed = "M13,4.8C9,4.8 9,19.2 13,19.2C17,19.2 22,16.5 22,12C22,7.5 17,4.8 13,4.8M13.1,17.2C12.7,16.8 12,15 12,12C12,9 12.7,7.2 13.1,6.8C16,6.9 20,8.7 20,12C20,15.3 15.9,17.1 13.1,17.2M8,10.5C8,11 7.9,11.5 7.9,12C7.9,12.2 7.9,12.4 7.9,12.6L2.4,14L1.9,12.1L8,10.5M2,7L9.4,5.1C9.2,5.4 9,5.8 8.9,6.3C8.8,6.6 8.7,7 8.6,7.4L2.5,8.9L2,7M8.2,15.5C8.3,16.2 8.5,16.9 8.7,17.4L2.4,19L1.9,17.1L8.2,15.5Z";
var mdiCarLightFog = "M13,4.8C9,4.8 9,19.2 13,19.2C17,19.2 22,16.5 22,12C22,7.5 17,4.8 13,4.8M13.1,17.2C12.7,16.8 12,15 12,12C12,9 12.7,7.2 13.1,6.8C16,6.9 20,8.7 20,12C20,15.3 16,17.1 13.1,17.2M6,8V11H8C8,11.3 8,11.7 8,12C8,12.3 8,12.7 8,13H6V16H8.4C8.6,16.7 8.8,17.4 9,18H6V21H4V18H2V16H4V13H2V11H4V8H2V6H4V3H6V6H9C9,6.1 8.9,6.2 8.9,6.4C8.7,6.9 8.5,7.4 8.4,8H6Z";
var mdiCarLightHigh = "M13,4.8C9,4.8 9,19.2 13,19.2C17,19.2 22,16.5 22,12C22,7.5 17,4.8 13,4.8M13.1,17.2C12.7,16.8 12,15 12,12C12,9 12.7,7.2 13.1,6.8C16,6.9 20,8.7 20,12C20,15.3 16,17.1 13.1,17.2M2,5H9.5C9.3,5.4 9,5.8 8.9,6.4C8.8,6.6 8.8,6.8 8.7,7H2V5M8,11H2V9H8.2C8.1,9.6 8.1,10.3 8,11M8.7,17C8.9,17.8 9.2,18.4 9.6,19H2.1V17H8.7M8.2,15H2V13H8C8.1,13.7 8.1,14.4 8.2,15Z";
var mdiCarLimousine = "M1,6L2.5,7.5L1,9L2.5,10.5L1,12L2.5,13.5L1,15H15A3,3 0 0,0 18,18A3,3 0 0,0 21,15H23V12C23,10.89 22.11,10 21,10H19L16,6H1M4.62,7.5H10.5V10H4.12L3.12,9L4.62,7.5M12,7.5H15.5L17.46,10H12V7.5M18,13.5A1.5,1.5 0 0,1 19.5,15A1.5,1.5 0 0,1 18,16.5A1.5,1.5 0 0,1 16.5,15A1.5,1.5 0 0,1 18,13.5Z";
var mdiCarMultiple = "M8,11L9.5,6.5H18.5L20,11M18.5,16A1.5,1.5 0 0,1 17,14.5A1.5,1.5 0 0,1 18.5,13A1.5,1.5 0 0,1 20,14.5A1.5,1.5 0 0,1 18.5,16M9.5,16A1.5,1.5 0 0,1 8,14.5A1.5,1.5 0 0,1 9.5,13A1.5,1.5 0 0,1 11,14.5A1.5,1.5 0 0,1 9.5,16M19.92,6C19.71,5.4 19.14,5 18.5,5H9.5C8.86,5 8.29,5.4 8.08,6L6,12V20A1,1 0 0,0 7,21H8A1,1 0 0,0 9,20V19H19V20A1,1 0 0,0 20,21H21A1,1 0 0,0 22,20V12L19.92,6M14.92,3C14.71,2.4 14.14,2 13.5,2H4.5C3.86,2 3.29,2.4 3.08,3L1,9V17A1,1 0 0,0 2,18H3A1,1 0 0,0 4,17V12.91C3.22,12.63 2.82,11.77 3.1,11C3.32,10.4 3.87,10 4.5,10H4.57L5.27,8H3L4.5,3.5H15.09L14.92,3Z";
var mdiCarOff = "M20.5,19.85L6.41,5.76L2.41,1.76L1.11,3L4.57,6.46L3,11V19A1,1 0 0,0 4,20H5A1,1 0 0,0 6,19V18H16.11L20.84,22.73L22.11,21.46L20.5,19.85M6.5,15A1.5,1.5 0 0,1 5,13.5A1.5,1.5 0 0,1 6.5,12A1.5,1.5 0 0,1 8,13.5A1.5,1.5 0 0,1 6.5,15M5,10L5.78,7.67L8.11,10H5M17.5,5.5L19,10H13.2L16.12,12.92C16.5,12.17 17.37,11.86 18.12,12.21C18.87,12.57 19.18,13.47 18.83,14.21C18.68,14.5 18.43,14.77 18.12,14.92L21,17.8V11L18.92,5C18.71,4.4 18.14,4 17.5,4H7.2L8.7,5.5H17.5Z";
var mdiCarOutline = "M18.9 6C18.7 5.4 18.1 5 17.5 5H6.5C5.8 5 5.3 5.4 5.1 6L3 12V20C3 20.5 3.5 21 4 21H5C5.6 21 6 20.5 6 20V19H18V20C18 20.5 18.5 21 19 21H20C20.5 21 21 20.5 21 20V12L18.9 6M6.8 7H17.1L18.2 10H5.8L6.8 7M19 17H5V12H19V17M7.5 13C8.3 13 9 13.7 9 14.5S8.3 16 7.5 16 6 15.3 6 14.5 6.7 13 7.5 13M16.5 13C17.3 13 18 13.7 18 14.5S17.3 16 16.5 16C15.7 16 15 15.3 15 14.5S15.7 13 16.5 13Z";
var mdiCarParkingLights = "M7.3,9.2C8.1,9.6 9,10.5 9,12C9,13.5 8.1,14.4 7.3,14.8C6.9,13.4 6.9,10.6 7.3,9.2M6.5,7C4.5,7 4.5,17 6.5,17C8.5,17 11,15.1 11,12C11,8.9 8.5,7 6.5,7M16.7,9.2C17,10.6 17,13.4 16.7,14.8C15.9,14.4 15,13.5 15,12C15,10.5 15.9,9.6 16.7,9.2M17.5,7C15.5,7 13,8.9 13,12C13,15.1 15.5,17 17.5,17C19.5,17 19.5,7 17.5,7M4.9,6.2L2.5,4.6L1.4,6.3L4,8C4.2,7.3 4.5,6.6 4.9,6.2M20,8L22.6,6.3L21.5,4.6L19.1,6.2C19.4,6.6 19.8,7.2 20,8M4,16L1.4,17.7L2.5,19.4L4.9,17.8C4.6,17.4 4.2,16.8 4,16M20.5,11C20.5,11.3 20.5,11.7 20.5,12C20.5,12.3 20.5,12.6 20.5,13H24V11H20.5M19.1,17.8L21.5,19.4L22.6,17.7L20,16C19.8,16.7 19.5,17.4 19.1,17.8M3.5,12C3.5,11.7 3.5,11.4 3.5,11H0V13H3.5C3.5,12.7 3.5,12.3 3.5,12Z";
var mdiCarPickup = "M16,6H10.5V10H1V15H3A3,3 0 0,0 6,18A3,3 0 0,0 9,15H15A3,3 0 0,0 18,18A3,3 0 0,0 21,15H23V12C23,10.89 22.11,10 21,10H19L16,6M12,7.5H15.5L17.46,10H12V7.5M6,13.5A1.5,1.5 0 0,1 7.5,15A1.5,1.5 0 0,1 6,16.5A1.5,1.5 0 0,1 4.5,15A1.5,1.5 0 0,1 6,13.5M18,13.5A1.5,1.5 0 0,1 19.5,15A1.5,1.5 0 0,1 18,16.5A1.5,1.5 0 0,1 16.5,15A1.5,1.5 0 0,1 18,13.5Z";
var mdiCarSearch = "M9.61 16.11C9.61 14.03 10.59 12.19 12.1 11H5L6.5 6.5H17.5L18.72 10.16C19.56 10.53 20.3 11.07 20.91 11.74L18.92 6C18.72 5.42 18.16 5 17.5 5H6.5C5.84 5 5.28 5.42 5.08 6L3 12V20C3 20.55 3.45 21 4 21H5C5.55 21 6 20.55 6 20V19H10.29C9.86 18.13 9.61 17.15 9.61 16.11M6.5 16C5.67 16 5 15.33 5 14.5S5.67 13 6.5 13 8 13.67 8 14.5 7.33 16 6.5 16M20.71 20.7L20.7 20.71L20.71 20.7M16.11 11.61C18.61 11.61 20.61 13.61 20.61 16.11C20.61 17 20.36 17.82 19.92 18.5L23 21.61L21.61 23L18.5 19.93C17.8 20.36 17 20.61 16.11 20.61C13.61 20.61 11.61 18.61 11.61 16.11S13.61 11.61 16.11 11.61M16.11 13.61C14.73 13.61 13.61 14.73 13.61 16.11S14.73 18.61 16.11 18.61 18.61 17.5 18.61 16.11 17.5 13.61 16.11 13.61";
var mdiCarSearchOutline = "M10.29 19H6V20C6 20.5 5.6 21 5 21H4C3.5 21 3 20.5 3 20V12L5.1 6C5.3 5.4 5.8 5 6.5 5H17.5C18.1 5 18.7 5.4 18.9 6L20.91 11.74C20.17 10.93 19.24 10.31 18.18 9.95L17.1 7H6.8L5.8 10H13.91C12.79 10.4 11.81 11.1 11.08 12H5V17H9.68C9.78 17.71 10 18.38 10.29 19M6 14.5C6 15.3 6.7 16 7.5 16S9 15.3 9 14.5 8.3 13 7.5 13 6 13.7 6 14.5M16.11 11.61C13.61 11.61 11.61 13.61 11.61 16.11S13.61 20.61 16.11 20.61C17 20.61 17.8 20.36 18.5 19.93L21.61 23L23 21.61L19.92 18.5C20.36 17.82 20.61 17 20.61 16.11C20.61 13.61 18.61 11.61 16.11 11.61M16.11 13.61C17.5 13.61 18.61 14.73 18.61 16.11S17.5 18.61 16.11 18.61 13.61 17.5 13.61 16.11 14.73 13.61 16.11 13.61";
var mdiCarSeat = "M7 18C7 18 4 10 4 6S6 2 6 2H7C7 2 8 2 8 3S7 4 7 6 10 10 10 13 7 18 7 18M12 17C11 17 8 19.5 8 19.5C7.7 19.7 7.8 20 8 20.3C8 20.3 9 22.1 11 22.1H17C18.1 22.1 19 21.2 19 20.1V19.1C19 18 18.1 17.1 17 17.1H12Z";
var mdiCarSeatCooler = "M20.8 10.2L19.4 10.6L18.2 9.9V8.2L19.4 7.5L20.8 7.9L21.1 6.8L20 6.5L20.3 5.4L19.2 5.1L18.8 6.5L17.6 7.2L16.1 6.3V5L17.1 4L16.3 3.2L15.5 4L14.7 3.2L13.9 4L14.9 5V6.3L13.4 7.2L12.2 6.5L11.9 5.1L10.8 5.4L11.1 6.5L10 6.7L10.3 7.8L11.7 7.4L12.9 8.1V9.8L11.7 10.5L10.3 10.1L10 11.4L11.1 11.7L10.8 12.7L11.9 13L12.3 11.6L13.5 10.9L15 11.8V13.1L14 14.1L14.8 14.9L15.6 14.1L16.4 14.9L17.2 14.1L16.2 13.1V11.8L17.7 10.9L18.9 11.6L19.3 13L20.4 12.7L20 11.6L21.1 11.3L20.8 10.2M14 8.2L15.5 7.3L17 8.2V9.9L15.5 10.8L14 9.9V8.2M5 18C5 18 2 10 2 6S4 2 4 2H5C5 2 6 2 6 3S5 4 5 6 8 10 8 13 5 18 5 18M15 17C16.1 17 17 17.9 17 19V20C17 21.1 16.1 22 15 22H9C7 22 6 20.2 6 20.2C5.8 20 5.7 19.6 6 19.4C6 19.4 9 16.9 10 16.9H15Z";
var mdiCarSeatHeater = "M5 18C5 18 2 10 2 6S4 2 4 2H5C5 2 6 2 6 3S5 4 5 6 8 10 8 13 5 18 5 18M15 17C16.1 17 17 17.9 17 19V20C17 21.1 16.1 22 15 22H9C7 22 6 20.2 6 20.2C5.8 20 5.7 19.6 6 19.4C6 19.4 9 16.9 10 16.9H15M13.7 3.4L12.3 6.8L13.7 10.2L11.7 15L10 13.6L11.4 10.2L10 6.8L12 2L13.7 3.4M17.9 3.4L16.5 6.8L17.9 10.2L15.9 15L14.2 13.6L15.6 10.2L14.2 6.8L16.2 2L17.9 3.4M22 3.4L20.6 6.8L22 10.2L20 15L18.3 13.6L19.7 10.2L18.3 6.8L20.3 2L22 3.4";
var mdiCarSelect = "M5 13L6.5 8.5H17.5L19 13M17.5 18C16.7 18 16 17.3 16 16.5S16.7 15 17.5 15 19 15.7 19 16.5 18.3 18 17.5 18M6.5 18C5.7 18 5 17.3 5 16.5S5.7 15 6.5 15 8 15.7 8 16.5 7.3 18 6.5 18M18.9 8C18.7 7.4 18.1 7 17.5 7H6.5C5.8 7 5.3 7.4 5.1 8L3 14V22C3 22.6 3.4 23 4 23H5C5.6 23 6 22.6 6 22V21H18V22C18 22.6 18.4 23 19 23H20C20.6 23 21 22.6 21 22V14M8 1L12 5.5L16 1Z";
var mdiCarSettings = "M15 22H17V24H15M11 22H13V24H11M7 22H9V24H7M5 11L6.5 6.5H17.5L19 11M17.5 16A1.5 1.5 0 0 1 16 14.5A1.5 1.5 0 0 1 17.5 13A1.5 1.5 0 0 1 19 14.5A1.5 1.5 0 0 1 17.5 16M6.5 16A1.5 1.5 0 0 1 5 14.5A1.5 1.5 0 0 1 6.5 13A1.5 1.5 0 0 1 8 14.5A1.5 1.5 0 0 1 6.5 16M18.92 6C18.72 5.42 18.16 5 17.5 5H6.5C5.84 5 5.28 5.42 5.08 6L3 12V20A1 1 0 0 0 4 21H5A1 1 0 0 0 6 20V19H18V20A1 1 0 0 0 19 21H20A1 1 0 0 0 21 20V12Z";
var mdiCarShiftPattern = "M8 5H4V2H8V5M4 22H8V19H4V22M14 2H10V5H14V2M10 22H14V19H10V22M16 2V5H20V2H16M17 11H13V7H11V11H7V7H5V17H7V13H11V17H13V13H19V7H17V11Z";
var mdiCarSide = "M16,6L19,10H21C22.11,10 23,10.89 23,12V15H21A3,3 0 0,1 18,18A3,3 0 0,1 15,15H9A3,3 0 0,1 6,18A3,3 0 0,1 3,15H1V12C1,10.89 1.89,10 3,10L6,6H16M10.5,7.5H6.75L4.86,10H10.5V7.5M12,7.5V10H17.14L15.25,7.5H12M6,13.5A1.5,1.5 0 0,0 4.5,15A1.5,1.5 0 0,0 6,16.5A1.5,1.5 0 0,0 7.5,15A1.5,1.5 0 0,0 6,13.5M18,13.5A1.5,1.5 0 0,0 16.5,15A1.5,1.5 0 0,0 18,16.5A1.5,1.5 0 0,0 19.5,15A1.5,1.5 0 0,0 18,13.5Z";
var mdiCarSpeedLimiter = "M18 15C18 17.6 16.8 19.9 14.9 21.3L14.4 20.8L12.3 18.7L13.7 17.3L14.9 18.5C15.4 17.8 15.8 16.9 15.9 16H14V14H15.9C15.7 13.1 15.4 12.3 14.9 11.5L13.7 12.7L12.3 11.3L13.5 10.1C12.8 9.6 11.9 9.2 11 9.1V11H9V9.1C8.1 9.3 7.3 9.6 6.5 10.1L9.5 13.1C9.7 13.1 9.8 13 10 13C11.11 13 12 13.9 12 15S11.11 17 10 17 8 16.11 8 15C8 14.8 8 14.7 8.1 14.5L5.1 11.5C4.6 12.2 4.2 13.1 4.1 14H6V16H4.1C4.3 16.9 4.6 17.7 5.1 18.5L6.3 17.3L7.7 18.7L5.1 21.3C3.2 19.9 2 17.6 2 15C2 10.58 5.58 7 10 7S18 10.58 18 15M23 5C23 3.34 21.66 2 20 2S17 3.34 17 5C17 6.3 17.84 7.4 19 7.82V11H21V7.82C22.16 7.4 23 6.3 23 5M20 6C19.45 6 19 5.55 19 5S19.45 4 20 4 21 4.45 21 5 20.55 6 20 6Z";
var mdiCarSports = "M12,8.5H7L4,11H3C1.89,11 1,11.89 1,13V16H3.17C3.6,17.2 4.73,18 6,18C7.27,18 8.4,17.2 8.82,16H15.17C15.6,17.2 16.73,18 18,18C19.27,18 20.4,17.2 20.82,16H23V15C23,13.89 21.97,13.53 21,13L12,8.5M5.25,12L7.5,10H11.5L15.5,12H5.25M6,13.5A1.5,1.5 0 0,1 7.5,15A1.5,1.5 0 0,1 6,16.5A1.5,1.5 0 0,1 4.5,15A1.5,1.5 0 0,1 6,13.5M18,13.5A1.5,1.5 0 0,1 19.5,15A1.5,1.5 0 0,1 18,16.5A1.5,1.5 0 0,1 16.5,15A1.5,1.5 0 0,1 18,13.5Z";
var mdiCarTireAlert = "M11,13H13V15H11V13M11,5H13V11H11V5M17,4.76C18.86,6.19 20,8.61 20,11C20,14 18.33,16.64 15.86,18H8.14C5.67,16.64 4,14 4,11C4,8.61 5.09,6.17 7,4.76V2H5V3.86C3.15,5.68 2,8.2 2,11C2,13.8 3.15,16.32 5,18.14V22H7V20H9V22H11V20H13V22H15V20H17V22H19V18.14C20.85,16.32 22,13.8 22,11C22,8.2 20.85,5.68 19,3.86V2H17V4.76Z";
var mdiCarTractionControl = "M9.5,11H10.5C10.8,11 11,10.8 11,10.5V9H19V10.5C19,10.8 19.2,11 19.5,11H20.5C20.8,11 21,10.8 21,10.5V9L21,8.5V6L19.6,1.7C19.5,1.3 19.1,1 18.7,1H11.4C11,1 10.6,1.3 10.5,1.7L9,6V8.5L9,9V10.5C9,10.8 9.2,11 9.5,11M11.3,2H18.6L19.5,5H10.4L11.3,2M12,23H10C10,22.2 8.1,21.5 6.6,20.9C4.5,20.1 2,19.2 2,17C2,14.7 4.3,14.1 6.2,13.5C7.9,13.1 9,12.7 9,12H11C11,14.3 8.7,14.9 6.8,15.5C5.1,15.9 4,16.3 4,17C4,17.8 5.9,18.5 7.4,19.1C9.5,19.9 12,20.8 12,23M22,23H20C20,22.2 18.1,21.5 16.6,20.9C14.5,20.1 12,19.2 12,17C12,14.7 14.3,14.1 16.2,13.5C17.8,13 19,12.7 19,12H21C21,14.3 18.7,14.9 16.8,15.5C15.2,15.9 14,16.3 14,17C14,17.8 15.9,18.5 17.4,19.1C19.5,19.9 22,20.8 22,23Z";
var mdiCarTurbocharger = "M22 13V15H18.32C18.75 14.09 19 13.08 19 12C19 8.14 15.86 5 12 5H2V3H12C16.97 3 21 7.03 21 12C21 12.34 20.97 12.67 20.94 13H22M12 19C8.14 19 5 15.86 5 12C5 10.93 5.25 9.91 5.69 9H2V11H3.06C3.03 11.33 3 11.66 3 12C3 16.97 7.03 21 12 21H22V19H12M16.86 12.2C15.93 12.94 14.72 12.47 14 12.05V12C16.79 10.31 15.39 7.89 15.39 7.89S14.33 6.04 14.61 7.89C14.78 9.07 13.76 9.88 13.04 10.3L13 10.28C12.93 7 10.13 7 10.13 7S8 7 9.74 7.69C10.85 8.13 11.04 9.42 11.05 10.25L11 10.28C8.14 8.7 6.74 11.12 6.74 11.12S5.67 12.97 7.14 11.8C8.07 11.07 9.28 11.54 10 11.95V12C7.21 13.7 8.61 16.12 8.61 16.12S9.67 17.97 9.4 16.11C9.22 14.94 10.25 14.13 10.97 13.7L11 13.73C11.07 17 13.87 17 13.87 17S16 17 14.26 16.31C13.15 15.87 12.96 14.58 12.95 13.75L13 13.73C15.86 15.31 17.26 12.88 17.26 12.88S18.33 11.04 16.86 12.2Z";
var mdiCarWash = "M5,13L6.5,8.5H17.5L19,13M17.5,18A1.5,1.5 0 0,1 16,16.5A1.5,1.5 0 0,1 17.5,15A1.5,1.5 0 0,1 19,16.5A1.5,1.5 0 0,1 17.5,18M6.5,18A1.5,1.5 0 0,1 5,16.5A1.5,1.5 0 0,1 6.5,15A1.5,1.5 0 0,1 8,16.5A1.5,1.5 0 0,1 6.5,18M18.92,8C18.72,7.42 18.16,7 17.5,7H6.5C5.84,7 5.28,7.42 5.08,8L3,14V22A1,1 0 0,0 4,23H5A1,1 0 0,0 6,22V21H18V22A1,1 0 0,0 19,23H20A1,1 0 0,0 21,22V14M7,5A1.5,1.5 0 0,0 8.5,3.5C8.5,2.5 7,0.8 7,0.8C7,0.8 5.5,2.5 5.5,3.5A1.5,1.5 0 0,0 7,5M12,5A1.5,1.5 0 0,0 13.5,3.5C13.5,2.5 12,0.8 12,0.8C12,0.8 10.5,2.5 10.5,3.5A1.5,1.5 0 0,0 12,5M17,5A1.5,1.5 0 0,0 18.5,3.5C18.5,2.5 17,0.8 17,0.8C17,0.8 15.5,2.5 15.5,3.5A1.5,1.5 0 0,0 17,5Z";
var mdiCarWindshield = "M22.63 15.5L20.21 5.85A1 1 0 0 0 19.14 5.1C17.8 5.24 14.14 5.5 12 5.5S6.2 5.24 4.86 5.1A1 1 0 0 0 3.79 5.85L1.37 15.5A1.5 1.5 0 0 0 2.55 17.36A61.5 61.5 0 0 0 12 18A61.5 61.5 0 0 0 21.45 17.36A1.5 1.5 0 0 0 22.63 15.5Z";
var mdiCarWindshieldOutline = "M22.63 15.5L20.21 5.85A1 1 0 0 0 19.14 5.1C17.8 5.24 14.14 5.5 12 5.5S6.2 5.24 4.86 5.1A1 1 0 0 0 3.79 5.85L1.37 15.5A1.5 1.5 0 0 0 2.55 17.36A61.5 61.5 0 0 0 12 18A61.5 61.5 0 0 0 21.45 17.36A1.5 1.5 0 0 0 22.63 15.5M12 16A63.33 63.33 0 0 1 3.44 15.5L5.5 7.18C7 7.32 10.16 7.5 12 7.5S17 7.32 18.5 7.18L20.56 15.5A63.33 63.33 0 0 1 12 16Z";
var mdiCarWireless = "M12 5C10.9 5 10 5.9 10 7V8H6.5C5.84 8 5.28 8.42 5.08 9L3 15V23C3 23.55 3.45 24 4 24H5C5.55 24 6 23.55 6 23V22H18V23C18 23.55 18.45 24 19 24H20C20.55 24 21 23.55 21 23V15L18.92 9C18.72 8.42 18.16 8 17.5 8H14V7C14 5.9 13.11 5 12 5M6.5 9.5H17.5L19 14H5L6.5 9.5M6.5 16C7.33 16 8 16.67 8 17.5S7.33 19 6.5 19 5 18.33 5 17.5 5.67 16 6.5 16M17.5 16C18.33 16 19 16.67 19 17.5S18.33 19 17.5 19 16 18.33 16 17.5 16.67 16 17.5 16M16.2 3.4C15 2.3 13.5 1.7 12 1.7S9 2.3 7.8 3.4L7 2.6C8.4 1.2 10.2 .5 12 .5S15.6 1.2 17 2.6L16.2 3.4M15.3 4.2L14.5 5C13.8 4.3 12.9 4 12 4S10.2 4.3 9.5 5L8.7 4.2C9.6 3.3 10.8 2.8 12 2.8S14.4 3.3 15.3 4.2";
var mdiCarWrench = "M20.96 16.45C20.97 16.3 21 16.15 21 16V16.5L20.96 16.45M11 16C11 16.71 11.15 17.39 11.42 18H6V19C6 19.55 5.55 20 5 20H4C3.45 20 3 19.55 3 19V11L5.08 5C5.28 4.42 5.84 4 6.5 4H17.5C18.16 4 18.72 4.42 18.92 5L21 11V16C21 13.24 18.76 11 16 11S11 13.24 11 16M8 13.5C8 12.67 7.33 12 6.5 12S5 12.67 5 13.5 5.67 15 6.5 15 8 14.33 8 13.5M19 10L17.5 5.5H6.5L5 10H19M22.87 21.19L18.76 17.08C19.17 16.04 18.94 14.82 18.08 13.97C17.18 13.06 15.83 12.88 14.74 13.38L16.68 15.32L15.33 16.68L13.34 14.73C12.8 15.82 13.05 17.17 13.93 18.08C14.79 18.94 16 19.16 17.05 18.76L21.16 22.86C21.34 23.05 21.61 23.05 21.79 22.86L22.83 21.83C23.05 21.65 23.05 21.33 22.87 21.19Z";
var mdiCarabiner = "M8 17.5C8 18.33 7.33 19 6.5 19S5 18.33 5 17.5 5.67 16 6.5 16 8 16.67 8 17.5M18 5.59C17.79 3.54 16.18 2 14.24 2H8.88C6.95 2 5.36 3.5 5.15 5.53L5 6.59C4.92 7.34 5.5 8 6.24 8C6.87 8 7.39 7.53 7.47 6.91L7.61 5.82C7.68 5.07 8.23 4.5 8.88 4.5H14.24C14.89 4.5 15.44 5.07 15.5 5.82L16.5 16.88C16.59 17.74 16 18.5 15.25 18.5L10.04 17.82C9.95 18.77 9.5 19.6 8.8 20.18L14.93 21L15.09 21H15.25C16.27 21 17.26 20.56 17.96 19.78C18.71 18.94 19.09 17.8 19 16.65L18 5.59M11.66 7.94C11.08 7.57 10.31 7.75 9.94 8.34L6.39 14C6.43 14 6.46 14 6.5 14C7.38 14 8.18 14.34 8.8 14.88L12.06 9.66C12.43 9.08 12.25 8.31 11.66 7.94Z";
var mdiCaravan = "M5,7A2,2 0 0,0 3,9V15A2,2 0 0,0 5,17H7A3,3 0 0,0 10,20A3,3 0 0,0 13,17H21V15H19V9A2,2 0 0,0 17,7H5M5,9H10V12H5V9M13,9H17V12H13V9M10,16A1,1 0 0,1 11,17A1,1 0 0,1 10,18A1,1 0 0,1 9,17A1,1 0 0,1 10,16Z";
var mdiCard = "M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20Z";
var mdiCardAccountDetails = "M2,3H22C23.05,3 24,3.95 24,5V19C24,20.05 23.05,21 22,21H2C0.95,21 0,20.05 0,19V5C0,3.95 0.95,3 2,3M14,6V7H22V6H14M14,8V9H21.5L22,9V8H14M14,10V11H21V10H14M8,13.91C6,13.91 2,15 2,17V18H14V17C14,15 10,13.91 8,13.91M8,6A3,3 0 0,0 5,9A3,3 0 0,0 8,12A3,3 0 0,0 11,9A3,3 0 0,0 8,6Z";
var mdiCardAccountDetailsOutline = "M22,3H2C0.91,3.04 0.04,3.91 0,5V19C0.04,20.09 0.91,20.96 2,21H22C23.09,20.96 23.96,20.09 24,19V5C23.96,3.91 23.09,3.04 22,3M22,19H2V5H22V19M14,17V15.75C14,14.09 10.66,13.25 9,13.25C7.34,13.25 4,14.09 4,15.75V17H14M9,7A2.5,2.5 0 0,0 6.5,9.5A2.5,2.5 0 0,0 9,12A2.5,2.5 0 0,0 11.5,9.5A2.5,2.5 0 0,0 9,7M14,7V8H20V7H14M14,9V10H20V9H14M14,11V12H18V11H14";
var mdiCardAccountDetailsStar = "M20 22.09L22.45 23.58L21.8 20.77L24 18.89L21.11 18.64L20 16L18.87 18.64L16 18.89L18.18 20.77L17.5 23.58L20 22.09M14.08 21H2C.95 21 0 20.05 0 19V5C0 3.95 .95 3 2 3H22C23.05 3 24 3.95 24 5V15.53C22.94 14.58 21.54 14 20 14C16.69 14 14 16.69 14 20C14 20.34 14.03 20.68 14.08 21M8 13.91C6 13.91 2 15 2 17V18H14V17C14 15 10 13.91 8 13.91M8 6C6.35 6 5 7.35 5 9C5 10.65 6.35 12 8 12C9.65 12 11 10.65 11 9C11 7.35 9.65 6 8 6M21 10H14V11H21V10M22 8H14V9H22V8M22 6H14V7H22V6Z";
var mdiCardAccountDetailsStarOutline = "M20 22.09L22.45 23.58L21.8 20.77L24 18.89L21.11 18.64L20 16L18.87 18.64L16 18.89L18.18 20.77L17.5 23.58L20 22.09M14.08 21H2C.91 20.96 .04 20.09 0 19V5C.04 3.91 .91 3.04 2 3H22C23.09 3.04 23.96 3.91 24 5V15.53C23.42 15 22.75 14.61 22 14.34V5H2V19H14.08C14.03 19.33 14 19.66 14 20C14 20.34 14.03 20.68 14.08 21M14 17H4V15.75C4 14.09 7.34 13.25 9 13.25C10.66 13.25 14 14.09 14 15.75V17M14 11H18V12H14V11M9 7C7.63 7 6.5 8.13 6.5 9.5C6.5 10.87 7.63 12 9 12C10.37 12 11.5 10.87 11.5 9.5C11.5 8.13 10.37 7 9 7M14 9H20V10H14V9M14 7H20V8H14V7Z";
var mdiCardAccountMail = "M21,8V7L18,9L15,7V8L18,10M22,3H2A2,2 0 0,0 0,5V19A2,2 0 0,0 2,21H22A2,2 0 0,0 24,19V5A2,2 0 0,0 22,3M8,6A3,3 0 0,1 11,9A3,3 0 0,1 8,12A3,3 0 0,1 5,9A3,3 0 0,1 8,6M14,18H2V17C2,15 6,13.9 8,13.9C10,13.9 14,15 14,17M22,12H14V6H22";
var mdiCardAccountMailOutline = "M22,3H2A2,2 0 0,0 0,5V19A2,2 0 0,0 2,21H22A2,2 0 0,0 24,19V5A2,2 0 0,0 22,3M22,19H2V5H22V19M21,6H14V11H21V6M20,8L17.5,9.75L15,8V7L17.5,8.75L20,7V8M9,12A3,3 0 0,0 12,9A3,3 0 0,0 9,6A3,3 0 0,0 6,9A3,3 0 0,0 9,12M9,8A1,1 0 0,1 10,9A1,1 0 0,1 9,10A1,1 0 0,1 8,9A1,1 0 0,1 9,8M15,16.59C15,14.09 11.03,13 9,13C6.97,13 3,14.09 3,16.59V18H15V16.59M5.5,16C6.22,15.5 7.7,15 9,15C10.3,15 11.77,15.5 12.5,16H5.5Z";
var mdiCardAccountPhone = "M22,3H2A2,2 0 0,0 0,5V19A2,2 0 0,0 2,21H22A2,2 0 0,0 24,19V5A2,2 0 0,0 22,3M8,6A3,3 0 0,1 11,9A3,3 0 0,1 8,12A3,3 0 0,1 5,9A3,3 0 0,1 8,6M14,18H2V17C2,15 6,13.9 8,13.9C10,13.9 14,15 14,17V18M17.85,14H19.5L21,16L19,18C17.7,17 16.73,15.61 16.28,14C16.1,13.36 16,12.69 16,12C16,11.31 16.1,10.64 16.28,10C16.73,8.38 17.7,7 19,6L21,8L19.5,10H17.85C17.63,10.63 17.5,11.3 17.5,12C17.5,12.7 17.63,13.37 17.85,14Z";
var mdiCardAccountPhoneOutline = "M22,3H2A2,2 0 0,0 0,5V19A2,2 0 0,0 2,21H22A2,2 0 0,0 24,19V5A2,2 0 0,0 22,3M22,19H2V5H22V19M19,18L21,16L19.5,14H17.85C17.63,13.37 17.5,12.7 17.5,12C17.5,11.3 17.63,10.63 17.85,10H19.5L21,8L19,6C17.7,7 16.73,8.38 16.28,10C16.1,10.64 16,11.31 16,12C16,12.69 16.1,13.36 16.28,14C16.73,15.61 17.7,17 19,18M9,12A3,3 0 0,0 12,9A3,3 0 0,0 9,6A3,3 0 0,0 6,9A3,3 0 0,0 9,12M9,8A1,1 0 0,1 10,9A1,1 0 0,1 9,10A1,1 0 0,1 8,9A1,1 0 0,1 9,8M15,16.59C15,14.09 11.03,13 9,13C6.97,13 3,14.09 3,16.59V18H15V16.59M5.5,16C6.22,15.5 7.7,15 9,15C10.3,15 11.77,15.5 12.5,16H5.5Z";
var mdiCardBulleted = "M20,4A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20M11,13H9V15H11V13M19,13H13V15H19V13M7,9H5V11H7V9M19,9H9V11H19V9Z";
var mdiCardBulletedOff = "M3.35,3.58L20.65,20.87L19.23,22.29L16.94,20H4A2,2 0 0,1 2,18V6C2,5.72 2.06,5.46 2.16,5.22L1.23,4.29L2.65,2.87L3.35,3.58M6.6,4H20A2,2 0 0,1 22,6V18C22,18.4 21.88,18.77 21.68,19.08L17.6,15H20V13H15.6L13.6,11H20V9H11.6L6.6,4M9.94,13H9V15H11V14.06L9.94,13M5.94,9H5V11H7V10.06L5.94,9Z";
var mdiCardBulletedOffOutline = "M20.59,20.87L19.17,22.29L16.88,20H4A2,2 0 0,1 2,18V6C2,5.74 2.05,5.5 2.14,5.26L1.17,4.29L2.59,2.87L3.73,4L20.59,20.87V20.87M6.54,4H20A2,2 0 0,1 22,6V18C22,18.41 21.87,18.8 21.66,19.12L20,17.46V6H8.54L6.54,4M4,18H14.88L11.88,15H10V13.12L7.88,11H6V9.12L4,7.12V18M18,15H17.54L15.54,13H18V15M18,11H13.54L11.54,9H18V11Z";
var mdiCardBulletedOutline = "M12,15H10V13H12V15M18,15H14V13H18V15M8,11H6V9H8V11M18,11H10V9H18V11M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4Z";
var mdiCardBulletedSettings = "M9,22V24H7V22H9M13,22V24H11V22H13M17,22V24H15V22H17M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M11,13H9V15H11V13M19,13H13V15H19V13M7,9H5V11H7V9M19,9H9V11H19V9Z";
var mdiCardBulletedSettingsOutline = "M9,22V24H7V22H9M13,22V24H11V22H13M17,22V24H15V22H17M12,15H10V13H12V15M18,15H14V13H18V15M8,11H6V9H8V11M18,11H10V9H18V11M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4Z";
var mdiCardMinus = "M23 18V20H15V18H23M19 13C20.09 13 21.12 13.3 22 13.81V6C22 4.89 21.11 4 20 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19C13 15.69 15.69 13 19 13Z";
var mdiCardMinusOutline = "M23 18V20H15V18H23M13.09 18H4V6H20V13.09C20.72 13.21 21.39 13.46 22 13.81V6C22 4.89 21.11 4 20 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19C13 18.66 13.04 18.33 13.09 18Z";
var mdiCardMultiple = "M21 3C21.53 3 22.04 3.21 22.41 3.59C22.79 3.96 23 4.47 23 5V15C23 15.53 22.79 16.04 22.41 16.41C22.04 16.79 21.53 17 21 17H7C6.47 17 5.96 16.79 5.59 16.41C5.21 16.04 5 15.53 5 15V5C5 4.47 5.21 3.96 5.59 3.59C5.96 3.21 6.47 3 7 3H21M3 19H18V21H3C2.47 21 1.96 20.79 1.59 20.41C1.21 20.04 1 19.53 1 19V8H3V19Z";
var mdiCardMultipleOutline = "M21 16V6H7V16H21M21 4C21.53 4 22.04 4.21 22.41 4.59C22.79 4.96 23 5.47 23 6V16C23 16.53 22.79 17.04 22.41 17.41C22.04 17.79 21.53 18 21 18H7C5.89 18 5 17.1 5 16V6C5 4.89 5.89 4 7 4H21M3 20H18V22H3C2.47 22 1.96 21.79 1.59 21.41C1.21 21.04 1 20.53 1 20V9H3V20Z";
var mdiCardOff = "M21.88 18.68L7.2 4H20C21.11 4 22 4.89 22 6V18C22 18.24 21.96 18.47 21.88 18.68M20.56 19.91L20.57 19.91L2.39 1.73L1.11 3L2.65 4.54C2.25 4.9 2 5.42 2 6V18C2 19.11 2.9 20 4 20H18.11L20.84 22.73L22.11 21.46L20.56 19.91Z";
var mdiCardOffOutline = "M9.2 6L7.2 4H20C21.11 4 22 4.89 22 6V18C22 18.24 21.96 18.47 21.88 18.68L20 16.8V6H9.2M22.11 21.46L20.84 22.73L18.11 20H4C2.9 20 2 19.11 2 18V6C2 5.42 2.25 4.9 2.65 4.54L1.11 3L2.39 1.73L6.66 6L18.65 18H18.66L20.57 19.91L20.56 19.91L22.11 21.46M16.11 18L4.11 6H4V18H16.11Z";
var mdiCardOutline = "M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4Z";
var mdiCardPlus = "M13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H20C21.11 4 22 4.89 22 6V13.81C21.12 13.3 20.09 13 19 13C15.69 13 13 15.69 13 19C13 19.34 13.04 19.67 13.09 20M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiCardPlusOutline = "M21 15V18H24V20H21V23H19V20H16V18H19V15H21M14 18H3V6H19V13H21V6C21 4.89 20.11 4 19 4H3C1.9 4 1 4.89 1 6V18C1 19.11 1.9 20 3 20H14V18Z";
var mdiCardRemove = "M20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19M19 13C20.09 13 21.12 13.3 22 13.81V6C22 4.89 21.11 4 20 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19C13 15.69 15.69 13 19 13Z";
var mdiCardRemoveOutline = "M20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19M13.09 18H4V6H20V13.09C20.72 13.21 21.39 13.46 22 13.81V6C22 4.89 21.11 4 20 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19C13 18.66 13.04 18.33 13.09 18Z";
var mdiCardSearch = "M11.5 9C10.12 9 9 10.12 9 11.5S10.12 14 11.5 14 14 12.88 14 11.5 12.88 9 11.5 9M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4M16.79 18.21L13.88 15.3C13.19 15.74 12.37 16 11.5 16C9 16 7 14 7 11.5S9 7 11.5 7 16 9 16 11.5C16 12.38 15.74 13.19 15.3 13.89L18.21 16.79L16.79 18.21Z";
var mdiCardSearchOutline = "M11.5 16C12.37 16 13.19 15.74 13.88 15.3L16.32 17.74L17.74 16.32L15.3 13.89C15.74 13.19 16 12.38 16 11.5C16 9 14 7 11.5 7S7 9 7 11.5 9 16 11.5 16M11.5 9C12.88 9 14 10.12 14 11.5S12.88 14 11.5 14 9 12.88 9 11.5 10.12 9 11.5 9M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4M20 18H4V6H20V18Z";
var mdiCardText = "M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M5,13V15H16V13H5M5,9V11H19V9H5Z";
var mdiCardTextOutline = "M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4M6,9H18V11H6V9M6,13H16V15H6V13Z";
var mdiCards = "M21.47,4.35L20.13,3.79V12.82L22.56,6.96C22.97,5.94 22.5,4.77 21.47,4.35M1.97,8.05L6.93,20C7.24,20.77 7.97,21.24 8.74,21.26C9,21.26 9.27,21.21 9.53,21.1L16.9,18.05C17.65,17.74 18.11,17 18.13,16.26C18.14,16 18.09,15.71 18,15.45L13,3.5C12.71,2.73 11.97,2.26 11.19,2.25C10.93,2.25 10.67,2.31 10.42,2.4L3.06,5.45C2.04,5.87 1.55,7.04 1.97,8.05M18.12,4.25A2,2 0 0,0 16.12,2.25H14.67L18.12,10.59";
var mdiCardsClub = "M12,2C14.3,2 16.3,4 16.3,6.2C16.21,8.77 14.34,9.83 14.04,10C15.04,9.5 16.5,9.5 16.5,9.5C19,9.5 21,11.3 21,13.8C21,16.3 19,18 16.5,18C16.5,18 15,18 13,17C13,17 12.7,19 15,22H9C11.3,19 11,17 11,17C9,18 7.5,18 7.5,18C5,18 3,16.3 3,13.8C3,11.3 5,9.5 7.5,9.5C7.5,9.5 8.96,9.5 9.96,10C9.66,9.83 7.79,8.77 7.7,6.2C7.7,4 9.7,2 12,2Z";
var mdiCardsClubOutline = "M16.6 9.5C16.8 8.9 17 8.2 17 7.5C17 4.5 14.8 2 12 2S7 4.5 7 7.5C7 8.2 7.1 8.9 7.4 9.5C4.9 9.6 3 11.4 3 13.8C3 16.3 5 18 7.5 18C7.5 18 10 18 11 17C11 17 11.3 19 9 22H15C12.7 19 13 17 13 17C14 18 16.5 18 16.5 18C19 18 21 16.3 21 13.8C21 11.4 19.1 9.6 16.6 9.5M16.5 16C16.5 16 14 16 13 15H11C10 16 7.5 16 7.5 16C6.3 16 5 15.3 5 13.8C5 12.5 6.1 11.5 7.5 11.5C7.8 11.5 8.3 11.6 8.8 11.7C8.9 11.7 9 11.8 9.1 11.8L10 10.1C9.8 9.9 9.7 9.7 9.6 9.5C9.2 8.9 9 8.3 9 7.5C9 5.6 10.3 4 12 4S15 5.6 15 7.5C15 8.3 14.8 9 14.4 9.6C14.3 9.8 14.2 9.9 14.1 10.1L15 11.8C15.1 11.8 15.2 11.7 15.3 11.7C15.7 11.6 16.2 11.5 16.6 11.5C18 11.5 19.1 12.5 19.1 13.8C19 15.3 17.7 16 16.5 16Z";
var mdiCardsDiamond = "M19,12L12,22L5,12L12,2";
var mdiCardsDiamondOutline = "M12 2L5 12L12 22L19 12M7.44 12L12 5.5L16.56 12L12 18.5";
var mdiCardsHeart = "M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z";
var mdiCardsHeartOutline = "M12.1 18.55L12 18.65L11.89 18.55C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5C9.04 5 10.54 6 11.07 7.36H12.93C13.46 6 14.96 5 16.5 5C18.5 5 20 6.5 20 8.5C20 11.39 16.86 14.24 12.1 18.55M16.5 3C14.76 3 13.09 3.81 12 5.08C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.41 2 8.5C2 12.27 5.4 15.36 10.55 20.03L12 21.35L13.45 20.03C18.6 15.36 22 12.27 22 8.5C22 5.41 19.58 3 16.5 3Z";
var mdiCardsOutline = "M11.19,2.25C10.93,2.25 10.67,2.31 10.42,2.4L3.06,5.45C2.04,5.87 1.55,7.04 1.97,8.05L6.93,20C7.24,20.77 7.97,21.23 8.74,21.25C9,21.25 9.27,21.22 9.53,21.1L16.9,18.05C17.65,17.74 18.11,17 18.13,16.25C18.14,16 18.09,15.71 18,15.45L13,3.5C12.71,2.73 11.97,2.26 11.19,2.25M14.67,2.25L18.12,10.6V4.25A2,2 0 0,0 16.12,2.25M20.13,3.79V12.82L22.56,6.96C22.97,5.94 22.5,4.78 21.47,4.36M11.19,4.22L16.17,16.24L8.78,19.3L3.8,7.29";
var mdiCardsPlaying = "M14.7 2.2H16.2C17.3 2.2 18.2 3.1 18.2 4.2V10.6L14.7 2.2M20.1 3.8L21.4 4.4C22.4 4.8 22.9 6 22.5 7L20.1 12.9V3.8M18 15.5L13 3.5C12.7 2.7 12 2.3 11.2 2.3C10.9 2.3 10.7 2.4 10.4 2.5L3 5.5C2 5.9 1.5 7 2 8L7 20C7.3 20.8 8 21.2 8.8 21.2C9.1 21.2 9.3 21.2 9.6 21L17 18C17.8 17.7 18.2 17 18.2 16.2C18.1 16 18.1 15.7 18 15.5M11.4 15L8.2 12.6L8.6 8.6L11.8 11L11.4 15";
var mdiCardsPlayingClub = "M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2M14 15C13.4 15 12.9 14.7 12.5 14.3L13.5 17H10.5L11.5 14.3C11.1 14.7 10.6 15 10 15C8.9 15 8 14.1 8 13S8.9 11 10 11H10.3C10.1 10.7 10 10.3 10 10C10 8.9 10.9 8 12 8S14 8.9 14 10C14 10.4 13.9 10.7 13.7 11H14C15.1 11 16 11.9 16 13S15.1 15 14 15Z";
var mdiCardsPlayingClubMultiple = "M3 4V22C3 23.1 3.9 24 5 24H17V22H5V4H3M19 0H9C7.9 0 7 .9 7 2V18C7 19.1 7.9 20 9 20H19C20.1 20 21 19.1 21 18V2C21 .9 20.1 0 19 0M16 13C15.4 13 14.9 12.7 14.5 12.3L15.5 15H12.5L13.5 12.3C13.1 12.7 12.6 13 12 13C10.9 13 10 12.1 10 11S10.9 9 12 9H12.3C12.1 8.7 12 8.4 12 8C12 6.9 12.9 6 14 6S16 6.9 16 8C16 8.4 15.9 8.7 15.7 9H16C17.1 9 18 9.9 18 11S17.1 13 16 13Z";
var mdiCardsPlayingClubMultipleOutline = "M19 0H9C7.9 0 7 .9 7 2V18C7 19.1 7.9 20 9 20H19C20.1 20 21 19.1 21 18V2C21 .9 20.1 0 19 0M19 18H9V2H19V18M3 4V22C3 23.1 3.9 24 5 24H17V22H5V4H3M14 6C12.9 6 12 6.9 12 8C12 8.4 12.1 8.7 12.3 9H12C10.9 9 10 9.9 10 11S10.9 13 12 13C12.6 13 13.1 12.7 13.5 12.3L12.5 15H15.5L14.5 12.3C14.9 12.7 15.4 13 16 13C17.1 13 18 12.1 18 11S17.1 9 16 9H15.7C15.9 8.7 16 8.4 16 8C16 6.9 15.1 6 14 6Z";
var mdiCardsPlayingClubOutline = "M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2M17 20H7V4H17V20M12 8C10.9 8 10 8.9 10 10C10 10.4 10.1 10.7 10.3 11H10C8.9 11 8 11.9 8 13S8.9 15 10 15C10.6 15 11.1 14.7 11.5 14.3L10.5 17H13.5L12.5 14.3C12.9 14.7 13.4 15 14 15C15.1 15 16 14.1 16 13S15.1 11 14 11H13.7C13.9 10.7 14 10.3 14 10C14 8.9 13.1 8 12 8Z";
var mdiCardsPlayingDiamond = "M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2M12 17L9 12L12 7L15 12L12 17Z";
var mdiCardsPlayingDiamondMultiple = "M3 4V22C3 23.1 3.9 24 5 24H17V22H5V4H3M19 0H9C7.9 0 7 .9 7 2V18C7 19.1 7.9 20 9 20H19C20.1 20 21 19.1 21 18V2C21 .9 20.1 0 19 0M14 15L11 10L14 5L17 10L14 15Z";
var mdiCardsPlayingDiamondMultipleOutline = "M19 0H9C7.9 0 7 .9 7 2V18C7 19.1 7.9 20 9 20H19C20.1 20 21 19.1 21 18V2C21 .9 20.1 0 19 0M19 18H9V2H19V18M3 4V22C3 23.1 3.9 24 5 24H17V22H5V4H3M14 5L11 10L14 15L17 10L14 5Z";
var mdiCardsPlayingDiamondOutline = "M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2M17 20H7V4H17V20M12 7L9 12L12 17L15 12L12 7Z";
var mdiCardsPlayingHeart = "M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2M12.6 15.8L12 16.3L11.4 15.8C9.4 13.9 8 12.7 8 11.2C8 10 9 9 10.2 9C10.9 9 11.6 9.3 12 9.8C12.4 9.3 13.1 9 13.8 9C15 9 16 9.9 16 11.2C16 12.7 14.6 13.9 12.6 15.8Z";
var mdiCardsPlayingHeartMultiple = "M3 4V22C3 23.1 3.9 24 5 24H17V22H5V4H3M19 0H9C7.9 0 7 .9 7 2V18C7 19.1 7.9 20 9 20H19C20.1 20 21 19.1 21 18V2C21 .9 20.1 0 19 0M14.6 13.8L14 14.3L13.4 13.8C11.4 11.9 10 10.7 10 9.2C10 8 11 7 12.2 7C12.9 7 13.6 7.3 14 7.8C14.4 7.3 15.1 7 15.8 7C17 7 18 7.9 18 9.2C18 10.7 16.6 11.9 14.6 13.8Z";
var mdiCardsPlayingHeartMultipleOutline = "M19 0H9C7.9 0 7 .9 7 2V18C7 19.1 7.9 20 9 20H19C20.1 20 21 19.1 21 18V2C21 .9 20.1 0 19 0M19 18H9V2H19V18M3 4V22C3 23.1 3.9 24 5 24H17V22H5V4H3M12.2 7C11 7 10 8 10 9.2C10 10.7 11.4 11.9 13.4 13.8L14 14.3L14.6 13.8C16.6 11.9 18 10.7 18 9.2C18 7.9 17 7 15.8 7C15.1 7 14.4 7.3 14 7.8C13.6 7.3 12.9 7 12.2 7Z";
var mdiCardsPlayingHeartOutline = "M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2M17 20H7V4H17V20M10.2 9C9 9 8 10 8 11.2C8 12.7 9.4 13.9 11.4 15.8L12 16.3L12.6 15.8C14.6 13.9 16 12.7 16 11.2C16 9.9 15 9 13.8 9C13.1 9 12.4 9.3 12 9.8C11.6 9.3 10.9 9 10.2 9Z";
var mdiCardsPlayingOutline = "M11.19,2.25C11.97,2.26 12.71,2.73 13,3.5L18,15.45C18.09,15.71 18.14,16 18.13,16.25C18.11,17 17.65,17.74 16.9,18.05L9.53,21.1C9.27,21.22 9,21.25 8.74,21.25C7.97,21.23 7.24,20.77 6.93,20L1.97,8.05C1.55,7.04 2.04,5.87 3.06,5.45L10.42,2.4C10.67,2.31 10.93,2.25 11.19,2.25M14.67,2.25H16.12A2,2 0 0,1 18.12,4.25V10.6L14.67,2.25M20.13,3.79L21.47,4.36C22.5,4.78 22.97,5.94 22.56,6.96L20.13,12.82V3.79M11.19,4.22L3.8,7.29L8.77,19.3L16.17,16.24L11.19,4.22M8.65,8.54L11.88,10.95L11.44,14.96L8.21,12.54L8.65,8.54Z";
var mdiCardsPlayingSpade = "M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2M13.8 15C13.4 15 13 14.9 12.6 14.7L13.5 17H10.5L11.4 14.7C11 14.9 10.6 15 10.2 15C9 15 8 14 8 12.8C8 11.3 9.4 10.1 11.4 8.2L12 7.7L12.6 8.2C14.6 10.1 16 11.3 16 12.8C16 14.1 15 15 13.8 15Z";
var mdiCardsPlayingSpadeMultiple = "M3 4V22C3 23.1 3.9 24 5 24H17V22H5V4H3M19 0H9C7.9 0 7 .9 7 2V18C7 19.1 7.9 20 9 20H19C20.1 20 21 19.1 21 18V2C21 .9 20.1 0 19 0M15.8 13C15.4 13 15 12.9 14.6 12.7L15.5 15H12.5L13.4 12.7C13 12.9 12.6 13 12.2 13C11 13 10 12 10 10.8C10 9.3 11.4 8.1 13.4 6.2L14 5.7L14.6 6.2C16.6 8.1 18 9.3 18 10.8C18 12.1 17 13 15.8 13Z";
var mdiCardsPlayingSpadeMultipleOutline = "M19 0H9C7.9 0 7 .9 7 2V18C7 19.1 7.9 20 9 20H19C20.1 20 21 19.1 21 18V2C21 .9 20.1 0 19 0M19 18H9V2H19V18M3 4V22C3 23.1 3.9 24 5 24H17V22H5V4H3M14 5.7L13.4 6.2C11.4 8.1 10 9.3 10 10.8C10 12 11 13 12.2 13C12.6 13 13 12.9 13.4 12.7L12.5 15H15.5L14.6 12.7C14.9 12.9 15.4 13 15.8 13C17 13 18 12.1 18 10.8C18 9.3 16.6 8.1 14.6 6.2L14 5.7Z";
var mdiCardsPlayingSpadeOutline = "M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2M17 20H7V4H17V20M12 7.7L11.4 8.2C9.4 10.1 8 11.3 8 12.8C8 14 9 15 10.2 15C10.6 15 11 14.9 11.4 14.7L10.5 17H13.5L12.6 14.7C12.9 14.9 13.4 15 13.8 15C15 15 16 14.1 16 12.8C16 11.3 14.6 10.1 12.6 8.2L12 7.7Z";
var mdiCardsSpade = "M12,2C9,7 4,9 4,14C4,16 6,18 8,18C9,18 10,18 11,17C11,17 11.32,19 9,22H15C13,19 13,17 13,17C14,18 15,18 16,18C18,18 20,16 20,14C20,9 15,7 12,2Z";
var mdiCardsSpadeOutline = "M11 17C11 17 11.3 19 9 22H15C12.7 19 13 17 13 17S14 18 16 18 20 16 20 14C20 9 15 7 12 2C9 7 4 9 4 14C4 16 6 18 8 18S11 17 11 17M13 14H11C11 14 10 16 8 16C7.1 16 6 14.9 6 14C5.8 11 9.9 8.2 12 5.4C14.1 8.1 18.2 10.9 18 14C18 14.9 16.9 16 16 16C14 16 13 14 13 14Z";
var mdiCardsVariant = "M5,2H19A1,1 0 0,1 20,3V13A1,1 0 0,1 19,14H5A1,1 0 0,1 4,13V3A1,1 0 0,1 5,2M6,4V12H18V4H6M20,17A1,1 0 0,1 19,18H5A1,1 0 0,1 4,17V16H20V17M20,21A1,1 0 0,1 19,22H5A1,1 0 0,1 4,21V20H20V21Z";
var mdiCarrot = "M16,10L15.8,11H13.5A0.5,0.5 0 0,0 13,11.5A0.5,0.5 0 0,0 13.5,12H15.6L14.6,17H12.5A0.5,0.5 0 0,0 12,17.5A0.5,0.5 0 0,0 12.5,18H14.4L14,20A2,2 0 0,1 12,22A2,2 0 0,1 10,20L9,15H10.5A0.5,0.5 0 0,0 11,14.5A0.5,0.5 0 0,0 10.5,14H8.8L8,10C8,8.8 8.93,7.77 10.29,7.29L8.9,5.28C8.59,4.82 8.7,4.2 9.16,3.89C9.61,3.57 10.23,3.69 10.55,4.14L11,4.8V3A1,1 0 0,1 12,2A1,1 0 0,1 13,3V5.28L14.5,3.54C14.83,3.12 15.47,3.07 15.89,3.43C16.31,3.78 16.36,4.41 16,4.84L13.87,7.35C15.14,7.85 16,8.85 16,10Z";
var mdiCart = "M17,18C15.89,18 15,18.89 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5.5C20.95,5.34 21,5.17 21,5A1,1 0 0,0 20,4H5.21L4.27,2M7,18C5.89,18 5,18.89 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20C9,18.89 8.1,18 7,18Z";
var mdiCartArrowDown = "M10 0V4H8L12 8L16 4H14V0M1 2V4H3L6.6 11.6L5.2 14C5.1 14.3 5 14.6 5 15C5 16.1 5.9 17 7 17H19V15H7.4C7.3 15 7.2 14.9 7.2 14.8V14.7L8.1 13H15.5C16.2 13 16.9 12.6 17.2 12L21.1 5L19.4 4L15.5 11H8.5L4.3 2M7 18C5.9 18 5 18.9 5 20S5.9 22 7 22 9 21.1 9 20 8.1 18 7 18M17 18C15.9 18 15 18.9 15 20S15.9 22 17 22 19 21.1 19 20 18.1 18 17 18Z";
var mdiCartArrowRight = "M9,20A2,2 0 0,1 7,22A2,2 0 0,1 5,20A2,2 0 0,1 7,18A2,2 0 0,1 9,20M17,18A2,2 0 0,0 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20A2,2 0 0,0 17,18M7.2,14.63C7.19,14.67 7.19,14.71 7.2,14.75A0.25,0.25 0 0,0 7.45,15H19V17H7A2,2 0 0,1 5,15C5,14.65 5.07,14.31 5.24,14L6.6,11.59L3,4H1V2H4.27L5.21,4H20A1,1 0 0,1 21,5C21,5.17 20.95,5.34 20.88,5.5L17.3,12C16.94,12.62 16.27,13 15.55,13H8.1L7.2,14.63M9,9.5H13V11.5L16,8.5L13,5.5V7.5H9V9.5Z";
var mdiCartArrowUp = "M12 0L8 4H10V8H14V4H16M1 2V4H3L6.6 11.6L5.2 14C5.1 14.3 5 14.6 5 15C5 16.1 5.9 17 7 17H19V15H7.4C7.3 15 7.2 14.9 7.2 14.8V14.7L8.1 13H15.5C16.2 13 16.9 12.6 17.2 12L21.1 5L19.4 4L15.5 11H8.5L4.3 2M7 18C5.9 18 5 18.9 5 20S5.9 22 7 22 9 21.1 9 20 8.1 18 7 18M17 18C15.9 18 15 18.9 15 20S15.9 22 17 22 19 21.1 19 20 18.1 18 17 18Z";
var mdiCartCheck = "M9 20C9 21.1 8.1 22 7 22S5 21.1 5 20 5.9 18 7 18 9 18.9 9 20M17 18C15.9 18 15 18.9 15 20S15.9 22 17 22 19 21.1 19 20 18.1 18 17 18M7.2 14.8V14.7L8.1 13H15.5C16.2 13 16.9 12.6 17.2 12L21.1 5L19.4 4L15.5 11H8.5L4.3 2H1V4H3L6.6 11.6L5.2 14C5.1 14.3 5 14.6 5 15C5 16.1 5.9 17 7 17H19V15H7.4C7.3 15 7.2 14.9 7.2 14.8M18 2.8L16.6 1.4L11.8 6.2L9.2 3.6L7.8 5L11.8 9L18 2.8Z";
var mdiCartHeart = "M9 20C9 21.1 8.1 22 7 22S5 21.1 5 20 5.9 18 7 18 9 18.9 9 20M17 18C15.9 18 15 18.9 15 20S15.9 22 17 22 19 21.1 19 20 18.1 18 17 18M7.2 14.8V14.7L8.1 13H15.5C16.2 13 16.9 12.6 17.2 12L21.1 5L19.4 4L15.5 11H8.5L4.3 2H1V4H3L6.6 11.6L5.2 14C5.1 14.3 5 14.6 5 15C5 16.1 5.9 17 7 17H19V15H7.4C7.3 15 7.2 14.9 7.2 14.8M12 9.3L11.4 8.8C9.4 6.9 8 5.7 8 4.2C8 3 9 2 10.2 2C10.9 2 11.6 2.3 12 2.8C12.4 2.3 13.1 2 13.8 2C15 2 16 2.9 16 4.2C16 5.7 14.6 6.9 12.6 8.8L12 9.3Z";
var mdiCartMinus = "M16 6V4H8V6M7 18C5.9 18 5 18.9 5 20S5.9 22 7 22 9 21.1 9 20 8.1 18 7 18M17 18C15.9 18 15 18.9 15 20S15.9 22 17 22 19 21.1 19 20 18.1 18 17 18M7.2 14.8V14.7L8.1 13H15.5C16.2 13 16.9 12.6 17.2 12L21.1 5L19.4 4L15.5 11H8.5L4.3 2H1V4H3L6.6 11.6L5.2 14C5.1 14.3 5 14.6 5 15C5 16.1 5.9 17 7 17H19V15H7.4C7.3 15 7.2 14.9 7.2 14.8Z";
var mdiCartOff = "M22.73,22.73L1.27,1.27L0,2.54L4.39,6.93L6.6,11.59L5.25,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H14.46L15.84,18.38C15.34,18.74 15,19.33 15,20A2,2 0 0,0 17,22C17.67,22 18.26,21.67 18.62,21.16L21.46,24L22.73,22.73M7.42,15A0.25,0.25 0 0,1 7.17,14.75L7.2,14.63L8.1,13H10.46L12.46,15H7.42M15.55,13C16.3,13 16.96,12.59 17.3,11.97L20.88,5.5C20.96,5.34 21,5.17 21,5A1,1 0 0,0 20,4H6.54L15.55,13M7,18A2,2 0 0,0 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20A2,2 0 0,0 7,18Z";
var mdiCartOutline = "M17,18A2,2 0 0,1 19,20A2,2 0 0,1 17,22C15.89,22 15,21.1 15,20C15,18.89 15.89,18 17,18M1,2H4.27L5.21,4H20A1,1 0 0,1 21,5C21,5.17 20.95,5.34 20.88,5.5L17.3,11.97C16.96,12.58 16.3,13 15.55,13H8.1L7.2,14.63L7.17,14.75A0.25,0.25 0 0,0 7.42,15H19V17H7C5.89,17 5,16.1 5,15C5,14.65 5.09,14.32 5.24,14.04L6.6,11.59L3,4H1V2M7,18A2,2 0 0,1 9,20A2,2 0 0,1 7,22C5.89,22 5,21.1 5,20C5,18.89 5.89,18 7,18M16,11L18.78,6H6.14L8.5,11H16Z";
var mdiCartPercent = "M7 18C8.1 18 9 18.9 9 20S8.1 22 7 22 5 21.1 5 20 5.9 18 7 18M17 18C18.1 18 19 18.9 19 20S18.1 22 17 22 15 21.1 15 20 15.9 18 17 18M7.2 14.8C7.2 14.9 7.3 15 7.4 15H19V17H7C5.9 17 5 16.1 5 15C5 14.6 5.1 14.3 5.2 14L6.5 11.6L3 4H1V2H4.3L8.6 11H15.6L19.5 4L21.2 5L17.3 12C17 12.6 16.3 13 15.6 13H8.1L7.2 14.6V14.8M9.4 1C10.2 1 10.8 1.6 10.8 2.4S10.2 3.8 9.4 3.8 8 3.2 8 2.4 8.7 1 9.4 1M14.6 9C13.8 9 13.2 8.4 13.2 7.6S13.8 6.2 14.6 6.2 16 6.8 16 7.6 15.3 9 14.6 9M9.2 9L8 7.8L14.8 1L16 2.2L9.2 9";
var mdiCartPlus = "M11 9H13V6H16V4H13V1H11V4H8V6H11M7 18C5.9 18 5 18.9 5 20S5.9 22 7 22 9 21.1 9 20 8.1 18 7 18M17 18C15.9 18 15 18.9 15 20S15.9 22 17 22 19 21.1 19 20 18.1 18 17 18M7.2 14.8V14.7L8.1 13H15.5C16.2 13 16.9 12.6 17.2 12L21.1 5L19.4 4L15.5 11H8.5L4.3 2H1V4H3L6.6 11.6L5.2 14C5.1 14.3 5 14.6 5 15C5 16.1 5.9 17 7 17H19V15H7.4C7.3 15 7.2 14.9 7.2 14.8Z";
var mdiCartRemove = "M14.1 8.5L12 6.4L9.9 8.5L8.5 7.1L10.6 5L8.5 2.9L9.9 1.5L12 3.6L14.1 1.5L15.5 2.9L13.4 5L15.5 7.1L14.1 8.5M7 18C8.1 18 9 18.9 9 20S8.1 22 7 22 5 21.1 5 20 5.9 18 7 18M17 18C18.1 18 19 18.9 19 20S18.1 22 17 22 15 21.1 15 20 15.9 18 17 18M7.2 14.8C7.2 14.9 7.3 15 7.4 15H19V17H7C5.9 17 5 16.1 5 15C5 14.6 5.1 14.3 5.2 14L6.5 11.6L3 4H1V2H4.3L8.6 11H15.6L19.5 4L21.2 5L17.3 12C17 12.6 16.3 13 15.6 13H8.1L7.2 14.6V14.8Z";
var mdiCartVariant = "M19 20C19 21.11 18.11 22 17 22C15.89 22 15 21.1 15 20C15 18.89 15.89 18 17 18C18.11 18 19 18.9 19 20M7 18C5.89 18 5 18.89 5 20C5 21.1 5.89 22 7 22C8.11 22 9 21.11 9 20S8.11 18 7 18M7.2 14.63L7.17 14.75C7.17 14.89 7.28 15 7.42 15H19V17H7C5.89 17 5 16.1 5 15C5 14.65 5.09 14.32 5.24 14.04L6.6 11.59L3 4H1V2H4.27L5.21 4H20C20.55 4 21 4.45 21 5C21 5.17 20.95 5.34 20.88 5.5L17.3 11.97C16.96 12.58 16.3 13 15.55 13H8.1L7.2 14.63M8.5 11H10V9H7.56L8.5 11M11 9V11H14V9H11M14 8V6H11V8H14M17.11 9H15V11H16L17.11 9M18.78 6H15V8H17.67L18.78 6M6.14 6L7.08 8H10V6H6.14Z";
var mdiCaseSensitiveAlt = "M20,14C20,12.5 19.5,12 18,12H16V11C16,10 16,10 14,10V15.4L14,19H16L18,19C19.5,19 20,18.47 20,17V14M12,12C12,10.5 11.47,10 10,10H6C4.5,10 4,10.5 4,12V19H6V16H10V19H12V12M10,7H14V5H10V7M22,9V20C22,21.11 21.11,22 20,22H4A2,2 0 0,1 2,20V9C2,7.89 2.89,7 4,7H8V5L10,3H14L16,5V7H20A2,2 0 0,1 22,9H22M16,17H18V14H16V17M6,12H10V14H6V12Z";
var mdiCash = "M3,6H21V18H3V6M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M7,8A2,2 0 0,1 5,10V14A2,2 0 0,1 7,16H17A2,2 0 0,1 19,14V10A2,2 0 0,1 17,8H7Z";
var mdiCash100 = "M2,5H22V20H2V5M20,18V7H4V18H20M17,8A2,2 0 0,0 19,10V15A2,2 0 0,0 17,17H7A2,2 0 0,0 5,15V10A2,2 0 0,0 7,8H17M17,13V12C17,10.9 16.33,10 15.5,10C14.67,10 14,10.9 14,12V13C14,14.1 14.67,15 15.5,15C16.33,15 17,14.1 17,13M15.5,11A0.5,0.5 0 0,1 16,11.5V13.5A0.5,0.5 0 0,1 15.5,14A0.5,0.5 0 0,1 15,13.5V11.5A0.5,0.5 0 0,1 15.5,11M13,13V12C13,10.9 12.33,10 11.5,10C10.67,10 10,10.9 10,12V13C10,14.1 10.67,15 11.5,15C12.33,15 13,14.1 13,13M11.5,11A0.5,0.5 0 0,1 12,11.5V13.5A0.5,0.5 0 0,1 11.5,14A0.5,0.5 0 0,1 11,13.5V11.5A0.5,0.5 0 0,1 11.5,11M8,15H9V10H8L7,10.5V11.5L8,11V15Z";
var mdiCashCheck = "M3 6V18H13.32C13.1 17.33 13 16.66 13 16H7C7 14.9 6.11 14 5 14V10C6.11 10 7 9.11 7 8H17C17 9.11 17.9 10 19 10V10.06C19.67 10.06 20.34 10.18 21 10.4V6H3M12 9C10.3 9.03 9 10.3 9 12C9 13.7 10.3 14.94 12 15C12.38 15 12.77 14.92 13.14 14.77C13.41 13.67 13.86 12.63 14.97 11.61C14.85 10.28 13.59 8.97 12 9M21.63 12.27L17.76 16.17L16.41 14.8L15 16.22L17.75 19L23.03 13.68L21.63 12.27Z";
var mdiCashClock = "M17.5 16.82L19.94 18.23L19.19 19.53L16 17.69V14H17.5V16.82M24 17C24 20.87 20.87 24 17 24S10 20.87 10 17C10 16.66 10.03 16.33 10.08 16H2V4H20V10.68C22.36 11.81 24 14.21 24 17M10.68 14C10.86 13.64 11.05 13.3 11.28 12.97C11.19 13 11.1 13 11 13C9.34 13 8 11.66 8 10S9.34 7 11 7 14 8.34 14 10C14 10.25 13.96 10.5 13.9 10.73C14.84 10.27 15.89 10 17 10C17.34 10 17.67 10.03 18 10.08V8C16.9 8 16 7.11 16 6H6C6 7.11 5.11 8 4 8V12C5.11 12 6 12.9 6 14H10.68M22 17C22 14.24 19.76 12 17 12S12 14.24 12 17 14.24 22 17 22 22 19.76 22 17Z";
var mdiCashEdit = "M3 6H21V9.1C19.96 9.1 19.35 9.72 19.2 9.87L19.19 9.89L19 10.07V10C18.47 10 17.96 9.79 17.59 9.41C17.21 9.04 17 8.53 17 8H7C7 8.53 6.79 9.04 6.41 9.41C6.04 9.79 5.53 10 5 10V14C5.53 14 6.04 14.21 6.41 14.59C6.79 14.96 7 15.47 7 16H13.07L11.07 18H3V6M12 9C12.8 9 13.56 9.32 14.12 9.88C14.68 10.44 15 11.2 15 12C15 12.8 14.68 13.56 14.12 14.12C13.56 14.68 12.8 15 12 15C11.2 15 10.44 14.68 9.88 14.12C9.32 13.56 9 12.8 9 12C9 11.2 9.32 10.44 9.88 9.88C10.44 9.32 11.2 9 12 9M22.7 12.6L21.4 11.3C21.3 11.2 21.2 11.1 21 11.1C20.8 11.1 20.7 11.2 20.6 11.3L19.6 12.3L21.7 14.4L22.7 13.4C22.9 13.2 22.9 12.8 22.7 12.6M15.1 21L21.1 14.9L19.1 12.8L13 18.9V21H15.1Z";
var mdiCashFast = "M17.12 9.88C16.56 9.32 15.8 9 15 9S13.44 9.32 12.88 9.88C12.32 10.44 12 11.2 12 12S12.32 13.56 12.88 14.12 14.2 15 15 15 16.56 14.68 17.12 14.12 18 12.8 18 12 17.68 10.44 17.12 9.88M7 6V18H23V6H7M21 14C20.47 14 19.96 14.21 19.59 14.59C19.21 14.96 19 15.47 19 16H11C11 15.47 10.79 14.96 10.41 14.59C10.04 14.21 9.53 14 9 14V10C9.53 10 10.04 9.79 10.41 9.41C10.79 9.04 11 8.53 11 8H19C19 8.53 19.21 9.04 19.59 9.41C19.96 9.79 20.47 10 21 10V14M5 8H3C2.45 8 2 7.55 2 7C2 6.45 2.45 6 3 6H5V8M5 13H2C1.45 13 1 12.55 1 12C1 11.45 1.45 11 2 11H5V13M5 18H1C.448 18 0 17.55 0 17C0 16.45 .448 16 1 16H5V18Z";
var mdiCashLock = "M21.8 15C22.4 15 23 15.6 23 16.3V19.8C23 20.4 22.4 21 21.7 21H16.2C15.6 21 15 20.4 15 19.7V16.2C15 15.6 15.6 15 16.2 15V13.5C16.2 12.1 17.6 11 19 11C20.4 11 21.8 12.1 21.8 13.5V15M20.5 15V13.5C20.5 12.7 19.8 12.2 19 12.2C18.2 12.2 17.5 12.7 17.5 13.5V15H20.5M2 6H20V9.1L19 9C18.18 9 17.41 9.2 16.73 9.54C16.28 9.18 16 8.62 16 8H6C6 9.11 5.11 10 4 10V14C5.11 14 6 14.9 6 16H13.04L13 16.5V18H2V6M11 9C12.66 9 14 10.34 14 12C14 13.66 12.66 15 11 15C9.34 15 8 13.66 8 12C8 10.34 9.34 9 11 9Z";
var mdiCashLockOpen = "M21.8 16C22.4 16 23 16.6 23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V13.5C16.2 12.1 17.6 11 19 11C20.4 11 21.8 12.1 21.8 13.5V14H20.5V13.5C20.5 12.7 19.8 12.2 19 12.2C18.2 12.2 17.5 12.7 17.5 13.5V16H21.8M2 6H20V9.1L19 9C18.18 9 17.41 9.2 16.73 9.54C16.28 9.18 16 8.62 16 8H6C6 9.11 5.11 10 4 10V14C5.11 14 6 14.9 6 16H13.04L13 16.5V18H2V6M11 9C12.66 9 14 10.34 14 12C14 13.66 12.66 15 11 15C9.34 15 8 13.66 8 12C8 10.34 9.34 9 11 9Z";
var mdiCashMarker = "M18.5,16.8C17.8,16.8 17.3,16.2 17.3,15.6C17.3,14.9 17.9,14.4 18.5,14.4C19.1,14.4 19.7,15 19.7,15.6C19.8,16.2 19.2,16.8 18.5,16.8M18.5,12C16.6,12 15,13.6 15,15.5C15,18.1 18.5,22 18.5,22C18.5,22 22,18.1 22,15.5C22,13.6 20.4,12 18.5,12M14.9,11.3C14.6,10 13.4,9 12,9C10.3,9 9,10.3 9,12C9,13.7 10.3,15 12,15C12.4,15 12.7,14.9 13,14.8C13.2,13.4 13.9,12.2 14.9,11.3M13,16H7A2,2 0 0,0 5,14V10A2,2 0 0,0 7,8H17A2,2 0 0,0 19,10C19,10 20,10 21,10.6V6H3V18H13.5C13.3,17.3 13.1,16.7 13,16Z";
var mdiCashMinus = "M15 15V17H23V15M14.97 11.61C14.85 10.28 13.59 8.97 12 9C10.3 9.03 9 10.3 9 12C9 13.7 10.3 14.94 12 15C12.38 15 12.77 14.92 13.14 14.77C13.41 13.67 13.86 12.63 14.97 11.61M13 16H7C7 14.9 6.11 14 5 14V10C6.11 10 7 9.11 7 8H17C17 9.11 17.9 10 19 10V10.06C19.67 10.06 20.34 10.18 21 10.4V6H3V18H13.32C13.1 17.33 13 16.66 13 16Z";
var mdiCashMultiple = "M5,6H23V18H5V6M14,9A3,3 0 0,1 17,12A3,3 0 0,1 14,15A3,3 0 0,1 11,12A3,3 0 0,1 14,9M9,8A2,2 0 0,1 7,10V14A2,2 0 0,1 9,16H19A2,2 0 0,1 21,14V10A2,2 0 0,1 19,8H9M1,10H3V20H19V22H1V10Z";
var mdiCashOff = "M3 4.9V4.95L3.05 4.94L4.11 6H3V18H16.11L20.84 22.73L22.11 21.46L4.57 3.91L2.39 1.73L1.11 3L3 4.9M6.41 9.41C6.61 9.22 6.76 9 6.86 8.75L9.16 11.05C9.05 11.35 9 11.67 9 12C9 12.8 9.32 13.56 9.88 14.12C10.44 14.68 11.2 15 12 15C12.33 15 12.65 14.95 12.95 14.84L14.11 16H7C7 15.47 6.79 14.96 6.41 14.59C6.04 14.21 5.53 14 5 14V10C5.53 10 6.04 9.79 6.41 9.41M17.69 14.5L21 17.8V6H9.2L11.2 8H17C17 8.53 17.21 9.04 17.59 9.41C17.96 9.79 18.47 10 19 10V14C18.5 14 18.05 14.18 17.69 14.5Z";
var mdiCashPlus = "M15 15V17H18V20H20V17H23V15H20V12H18V15M14.97 11.61C14.85 10.28 13.59 8.97 12 9C10.3 9.03 9 10.3 9 12C9 13.7 10.3 14.94 12 15C12.38 15 12.77 14.92 13.14 14.77C13.41 13.67 13.86 12.63 14.97 11.61M13 16H7C7 14.9 6.11 14 5 14V10C6.11 10 7 9.11 7 8H17C17 9.11 17.9 10 19 10V10.06C19.67 10.06 20.34 10.18 21 10.4V6H3V18H13.32C13.1 17.33 13 16.66 13 16Z";
var mdiCashRefund = "M12.3 8.93L9.88 6.5H15.5V10H17V5H9.88L12.3 2.57L11.24 1.5L7 5.75L11.24 10L12.3 8.93M12 14A3 3 0 1 0 15 17A3 3 0 0 0 12 14M3 11V23H21V11M19 19A2 2 0 0 0 17 21H7A2 2 0 0 0 5 19V15A2 2 0 0 0 7 13H17A2 2 0 0 0 19 15Z";
var mdiCashRegister = "M2,17H22V21H2V17M6.25,7H9V6H6V3H14V6H11V7H17.8C18.8,7 19.8,8 20,9L20.5,16H3.5L4.05,9C4.05,8 5.05,7 6.25,7M13,9V11H18V9H13M6,9V10H8V9H6M9,9V10H11V9H9M6,11V12H8V11H6M9,11V12H11V11H9M6,13V14H8V13H6M9,13V14H11V13H9M7,4V5H13V4H7Z";
var mdiCashRemove = "M15.46 18.12L16.88 19.54L19 17.41L21.12 19.54L22.54 18.12L20.41 16L22.54 13.88L21.12 12.46L19 14.59L16.88 12.46L15.46 13.88L17.59 16M14.97 11.62C14.86 10.28 13.58 8.97 12 9C10.3 9.04 9 10.3 9 12C9 13.7 10.3 14.94 12 15C12.39 15 12.77 14.92 13.14 14.77C13.41 13.67 13.86 12.63 14.97 11.62M13 16H7C7 14.9 6.1 14 5 14V10C6.1 10 7 9.1 7 8H17C17 9.1 17.9 10 19 10V10.05C19.67 10.06 20.34 10.18 21 10.4V6H3V18H13.32C13.1 17.33 13 16.66 13 16Z";
var mdiCashSync = "M3 6V18H13.32C13.1 17.33 13 16.66 13 16H7C7 14.9 6.11 14 5 14V10C6.11 10 7 9.11 7 8H17C17 9.11 17.9 10 19 10V10.06C19.67 10.06 20.34 10.18 21 10.4V6H3M12 9C10.3 9.03 9 10.3 9 12S10.3 14.94 12 15C12.38 15 12.77 14.92 13.14 14.77C13.41 13.67 13.86 12.63 14.97 11.61C14.85 10.28 13.59 8.97 12 9M19 11L21.25 13.25L19 15.5V14C17.15 14 15.94 15.96 16.76 17.62L15.67 18.71C13.91 16.05 15.81 12.5 19 12.5V11M19 22L16.75 19.75L19 17.5V19C20.85 19 22.06 17.04 21.24 15.38L22.33 14.29C24.09 16.95 22.19 20.5 19 20.5V22";
var mdiCassette = "M4,5A2,2 0 0,0 2,7V17A2,2 0 0,0 4,19H6L7,17H17L18,19H20A2,2 0 0,0 22,17V7A2,2 0 0,0 20,5H4M6.5,10A1.5,1.5 0 0,1 8,11.5A1.5,1.5 0 0,1 6.5,13A1.5,1.5 0 0,1 5,11.5A1.5,1.5 0 0,1 6.5,10M9,10H15V13H9V10M17.5,10A1.5,1.5 0 0,1 19,11.5A1.5,1.5 0 0,1 17.5,13A1.5,1.5 0 0,1 16,11.5A1.5,1.5 0 0,1 17.5,10Z";
var mdiCast = "M1,10V12A9,9 0 0,1 10,21H12C12,14.92 7.07,10 1,10M1,14V16A5,5 0 0,1 6,21H8A7,7 0 0,0 1,14M1,18V21H4A3,3 0 0,0 1,18M21,3H3C1.89,3 1,3.89 1,5V8H3V5H21V19H14V21H21A2,2 0 0,0 23,19V5C23,3.89 22.1,3 21,3Z";
var mdiCastAudio = "M2 11V13C7 13 11 17 11 22H13C13 15.9 8.1 11 2 11M20 2H10C8.9 2 8 2.9 8 4V10.5C9 11 9.9 11.7 10.7 12.4C11.6 11 13.2 10 15 10C17.8 10 20 12.2 20 15S17.8 20 15 20H14.8C14.9 20.7 15 21.3 15 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M15 8C13.9 8 13 7.1 13 6C13 4.9 13.9 4 15 4C16.1 4 17 4.9 17 6S16.1 8 15 8M15 18C14.8 18 14.5 18 14.3 17.9C13.8 16.4 13.1 15.1 12.2 13.9C12.6 12.8 13.7 11.9 15 11.9C16.7 11.9 18 13.2 18 14.9S16.7 18 15 18M2 15V17C4.8 17 7 19.2 7 22H9C9 18.1 5.9 15 2 15M2 19V22H5C5 20.3 3.7 19 2 19";
var mdiCastAudioVariant = "M14.5 12C14.5 10.62 13.38 9.5 12 9.5C10.62 9.5 9.5 10.62 9.5 12C9.5 13 10.09 13.84 10.93 14.25L9.82 15.35C8.73 14.64 8 13.41 8 12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12C16 13.41 15.27 14.64 14.18 15.35L13.08 14.25C13.92 13.84 14.5 13 14.5 12M12 2C6.5 2 2 6.5 2 12C2 15.06 3.38 17.8 5.54 19.63L6.61 18.57C4.71 17 3.5 14.64 3.5 12C3.5 7.31 7.31 3.5 12 3.5C16.69 3.5 20.5 7.31 20.5 12C20.5 14.64 19.29 17 17.39 18.57L18.46 19.63C20.62 17.79 22 15.06 22 12C22 6.5 17.5 2 12 2M19 12C19 8.13 15.87 5 12 5C8.13 5 5 8.13 5 12C5 14.23 6.05 16.22 7.68 17.5L8.75 16.43C7.39 15.42 6.5 13.82 6.5 12C6.5 8.97 8.97 6.5 12 6.5C15.03 6.5 17.5 8.97 17.5 12C17.5 13.82 16.61 15.42 15.25 16.43L16.33 17.5C17.95 16.22 19 14.23 19 12M6 22H18L12 16L6 22Z";
var mdiCastConnected = "M21,3H3C1.89,3 1,3.89 1,5V8H3V5H21V19H14V21H21A2,2 0 0,0 23,19V5C23,3.89 22.1,3 21,3M1,10V12A9,9 0 0,1 10,21H12C12,14.92 7.07,10 1,10M19,7H5V8.63C8.96,9.91 12.09,13.04 13.37,17H19M1,14V16A5,5 0 0,1 6,21H8A7,7 0 0,0 1,14M1,18V21H4A3,3 0 0,0 1,18Z";
var mdiCastEducation = "M21,3H3A2,2 0 0,0 1,5V8H3V5H21V19H14V21H21A2,2 0 0,0 23,19V5A2,2 0 0,0 21,3M1,18V21H4A3,3 0 0,0 1,18M1,14V16A5,5 0 0,1 6,21H8A7,7 0 0,0 1,14M1,10V12A9,9 0 0,1 10,21H12C12,14.92 7.07,10 1,10M11,11.09V13.09L14.5,15L18,13.09V11.09L14.5,13L11,11.09M14.5,6L9,9L14.5,12L20,9L14.5,6Z";
var mdiCastOff = "M1.6,1.27L0.25,2.75L1.41,3.8C1.16,4.13 1,4.55 1,5V8H3V5.23L18.2,19H14V21H20.41L22.31,22.72L23.65,21.24M6.5,3L8.7,5H21V16.14L23,17.95V5C23,3.89 22.1,3 21,3M1,10V12A9,9 0 0,1 10,21H12C12,14.92 7.08,10 1,10M1,14V16A5,5 0 0,1 6,21H8A7,7 0 0,0 1,14M1,18V21H4A3,3 0 0,0 1,18Z";
var mdiCastVariant = "M6,22H18L12,16M21,3H3A2,2 0 0,0 1,5V17A2,2 0 0,0 3,19H7V17H3V5H21V17H17V19H21A2,2 0 0,0 23,17V5A2,2 0 0,0 21,3Z";
var mdiCastle = "M2,13H4V15H6V13H8V15H10V13H12V15H14V10L17,7V1H19L23,3L19,5V7L22,10V22H11V19A2,2 0 0,0 9,17A2,2 0 0,0 7,19V22H2V13M18,10C17.45,10 17,10.54 17,11.2V13H19V11.2C19,10.54 18.55,10 18,10Z";
var mdiCat = "M12,8L10.67,8.09C9.81,7.07 7.4,4.5 5,4.5C5,4.5 3.03,7.46 4.96,11.41C4.41,12.24 4.07,12.67 4,13.66L2.07,13.95L2.28,14.93L4.04,14.67L4.18,15.38L2.61,16.32L3.08,17.21L4.53,16.32C5.68,18.76 8.59,20 12,20C15.41,20 18.32,18.76 19.47,16.32L20.92,17.21L21.39,16.32L19.82,15.38L19.96,14.67L21.72,14.93L21.93,13.95L20,13.66C19.93,12.67 19.59,12.24 19.04,11.41C20.97,7.46 19,4.5 19,4.5C16.6,4.5 14.19,7.07 13.33,8.09L12,8M9,11A1,1 0 0,1 10,12A1,1 0 0,1 9,13A1,1 0 0,1 8,12A1,1 0 0,1 9,11M15,11A1,1 0 0,1 16,12A1,1 0 0,1 15,13A1,1 0 0,1 14,12A1,1 0 0,1 15,11M11,14H13L12.3,15.39C12.5,16.03 13.06,16.5 13.75,16.5A1.5,1.5 0 0,0 15.25,15H15.75A2,2 0 0,1 13.75,17C13,17 12.35,16.59 12,16V16H12C11.65,16.59 11,17 10.25,17A2,2 0 0,1 8.25,15H8.75A1.5,1.5 0 0,0 10.25,16.5C10.94,16.5 11.5,16.03 11.7,15.39L11,14Z";
var mdiCctv = "M6.03 12.03L8.03 15.5L5.5 18.68L2 12.62L6.03 12.03M17 18V15.29C17.88 14.9 18.5 14.03 18.5 13C18.5 12.43 18.3 11.9 17.97 11.5L19.94 10.35C20.95 9.76 21.3 8.47 20.71 7.46L19.33 5.06C18.74 4.05 17.45 3.7 16.44 4.28L8.31 9C7.36 9.53 7.03 10.75 7.58 11.71L9.08 14.31C9.63 15.26 10.86 15.59 11.81 15.04L13.69 13.96C13.94 14.55 14.41 15.03 15 15.29V18C15 19.1 15.9 20 17 20H22V18H17Z";
var mdiCctvOff = "M20.84 22.73L18.11 20H17C15.9 20 15 19.1 15 18V16.89L12.66 14.55L11.81 15.04C10.86 15.59 9.63 15.26 9.08 14.31L7.58 11.71C7.18 11 7.25 10.18 7.68 9.57L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M18.5 13C18.5 12.43 18.3 11.9 17.97 11.5L19.94 10.35C20.95 9.76 21.3 8.47 20.71 7.46L19.33 5.06C18.74 4.05 17.45 3.7 16.44 4.28L10.77 7.57L17.86 14.66C18.26 14.22 18.5 13.64 18.5 13M2 12.62L5.5 18.68L8.03 15.5L6.03 12.03L2 12.62Z";
var mdiCeilingFan = "M8 3V5H11V10.27C10.38 10.63 10 11.29 10 12V13H14V12C14 11.29 13.62 10.63 13 10.27V5H16V3H8M6 12C3.79 12 2 12.67 2 13.5S3.79 15 6 15 10 14.33 10 13.5 8.21 12 6 12M18 12C15.79 12 14 12.67 14 13.5S15.79 15 18 15 22 14.33 22 13.5 20.21 12 18 12M10 14V15C10 15.72 10.38 16.38 11 16.73C11.62 17.09 12.38 17.09 13 16.73C13.62 16.38 14 15.71 14 15V14H10Z";
var mdiCeilingFanLight = "M8 3V5H11V10.27C10.38 10.63 10 11.29 10 12V13H14V12C14 11.29 13.62 10.63 13 10.27V5H16V3H8M6 12C3.79 12 2 12.67 2 13.5C2 14.33 3.79 15 6 15S10 14.33 10 13.5C10 12.67 8.21 12 6 12M18 12C15.79 12 14 12.67 14 13.5C14 14.33 15.79 15 18 15S22 14.33 22 13.5C22 12.67 20.21 12 18 12M10 14V15C10 15.72 10.38 16.38 11 16.73C11.62 17.09 12.38 17.09 13 16.73C13.62 16.38 14 15.71 14 15V14H10M13 19V22H11V19H13M15.88 16.46L18 18.59L16.59 20L14.47 17.88L15.88 16.46M9.54 17.88L7.41 20L6 18.59L8.12 16.47L9.54 17.88";
var mdiCeilingLight = "M8,9H11V4H13V9H16L20,17H4L8,9M14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18H14Z";
var mdiCeilingLightMultiple = "M10 11H13V6H15V11H18L22 19H6L10 11M16 20C16 21.11 15.11 22 14 22S12 21.11 12 20H16M8.21 10.11L8.76 9H11V2H9V7H6L2 15H5.76L8.21 10.11Z";
var mdiCeilingLightMultipleOutline = "M16.76 13L18.76 17H9.24L11.24 13H16.76M15 6H13V11H10L6 19H22L18 11H15V6M16 20C16 21.11 15.11 22 14 22S12 21.11 12 20H16M8.21 10.11L8.76 9H11V2H9V7H6L2 15H5.76L8.21 10.11Z";
var mdiCeilingLightOutline = "M14.76 11L16.76 15H7.24L9.24 11H14.76M13 4H11V9H8L4 17H20L16 9H13V4M14 18H10C10 19.11 10.9 20 12 20S14 19.11 14 18Z";
var mdiCellphone = "M17,19H7V5H17M17,1H7C5.89,1 5,1.89 5,3V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V3C19,1.89 18.1,1 17,1Z";
var mdiCellphoneArrowDown = "M17,1H7A2,2 0 0,0 5,3V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V3A2,2 0 0,0 17,1M17,19H7V5H17V19M16,13H13V8H11V13H8L12,17L16,13Z";
var mdiCellphoneArrowDownVariant = "M18 14L23 9L21.6 7.6L19 10.2V3H17V10.2L14.4 7.6L13 9L18 14M19 16V21C19 22.1 18.1 23 17 23H7C5.9 23 5 22.1 5 21V3C5 1.9 5.9 1 7 1H14V5H7V19H17V16H19Z";
var mdiCellphoneBasic = "M15,2A1,1 0 0,0 14,3V6H10C8.89,6 8,6.89 8,8V20C8,21.11 8.89,22 10,22H15C16.11,22 17,21.11 17,20V8C17,7.26 16.6,6.62 16,6.28V3A1,1 0 0,0 15,2M10,8H15V13H10V8M10,15H11V16H10V15M12,15H13V16H12V15M14,15H15V16H14V15M10,17H11V18H10V17M12,17H13V18H12V17M14,17H15V18H14V17M10,19H11V20H10V19M12,19H13V20H12V19M14,19H15V20H14V19Z";
var mdiCellphoneCharging = "M11 18.5V13H9L13 5.5V11H15M17 19H7V5H17M17 1H7C5.89 1 5 1.89 5 3V21A2 2 0 0 0 7 23H17A2 2 0 0 0 19 21V3C19 1.89 18.1 1 17 1Z";
var mdiCellphoneCheck = "M14.54 23H7C5.9 23 5 22.11 5 21V3C5 1.89 5.89 1 7 1H17C18.1 1 19 1.89 19 3V13C18.3 13 17.63 13.13 17 13.35V5H7V19H13C13 20.54 13.58 21.94 14.54 23M17.75 22.16L15 19.16L16.16 18L17.75 19.59L21.34 16L22.5 17.41L17.75 22.16";
var mdiCellphoneCog = "M9.82,12.5C9.84,12.33 9.86,12.17 9.86,12C9.86,11.83 9.84,11.67 9.82,11.5L10.9,10.69C11,10.62 11,10.5 10.96,10.37L9.93,8.64C9.87,8.53 9.73,8.5 9.62,8.53L8.34,9.03C8.07,8.83 7.78,8.67 7.47,8.54L7.27,7.21C7.27,7.09 7.16,7 7.03,7H5C4.85,7 4.74,7.09 4.72,7.21L4.5,8.53C4.21,8.65 3.92,8.83 3.65,9L2.37,8.5C2.25,8.47 2.12,8.5 2.06,8.63L1.03,10.36C0.97,10.5 1,10.61 1.1,10.69L2.18,11.5C2.16,11.67 2.15,11.84 2.15,12C2.15,12.17 2.17,12.33 2.19,12.5L1.1,13.32C1,13.39 1,13.53 1.04,13.64L2.07,15.37C2.13,15.5 2.27,15.5 2.38,15.5L3.66,15C3.93,15.18 4.22,15.34 4.53,15.47L4.73,16.79C4.74,16.91 4.85,17 5,17H7.04C7.17,17 7.28,16.91 7.29,16.79L7.5,15.47C7.8,15.35 8.09,15.17 8.36,15L9.64,15.5C9.76,15.53 9.89,15.5 9.95,15.37L11,13.64C11.04,13.53 11,13.4 10.92,13.32L9.82,12.5M6,13.75C5,13.75 4.2,12.97 4.2,12C4.2,11.03 5,10.25 6,10.25C7,10.25 7.8,11.03 7.8,12C7.8,12.97 7,13.75 6,13.75M17,1H7A2,2 0 0,0 5,3V6H7V4H17V20H7V18H5V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V3A2,2 0 0,0 17,1Z";
var mdiCellphoneDock = "M16,15H8V5H16M16,1H8C6.89,1 6,1.89 6,3V17A2,2 0 0,0 8,19H16A2,2 0 0,0 18,17V3C18,1.89 17.1,1 16,1M8,23H16V21H8V23Z";
var mdiCellphoneInformation = "M13 7H11V9H13V7M13 11H11V17H13V11M17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1M17 19H7V5H17V19Z";
var mdiCellphoneKey = "M7 1C5.9 1 5 1.9 5 3V7H7V4H17V20H7V17H5V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1H7M6 9C4.3 9 3 10.3 3 12S4.3 15 6 15C7.3 15 8.4 14.2 8.8 13H11V15H13V13H15V11H8.8C8.4 9.8 7.3 9 6 9M6 11C6.6 11 7 11.4 7 12S6.6 13 6 13 5 12.6 5 12 5.4 11 6 11Z";
var mdiCellphoneLink = "M22,17H18V10H22M23,8H17A1,1 0 0,0 16,9V19A1,1 0 0,0 17,20H23A1,1 0 0,0 24,19V9A1,1 0 0,0 23,8M4,6H22V4H4A2,2 0 0,0 2,6V17H0V20H14V17H4V6Z";
var mdiCellphoneLinkOff = "M23,8H17A1,1 0 0,0 16,9V13.18L18,15.18V10H22V17H19.82L22.82,20H23A1,1 0 0,0 24,19V9A1,1 0 0,0 23,8M4,6.27L14.73,17H4V6.27M1.92,1.65L0.65,2.92L2.47,4.74C2.18,5.08 2,5.5 2,6V17H0V20H17.73L20.08,22.35L21.35,21.08L3.89,3.62L1.92,1.65M22,6V4H6.82L8.82,6H22Z";
var mdiCellphoneLock = "M17,1H7A2,2 0 0,0 5,3V6H7V4H17V20H7V18H5V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V3A2,2 0 0,0 17,1M8.8,11V9.5C8.8,8.1 7.4,7 6,7C4.6,7 3.2,8.1 3.2,9.5V11C2.6,11 2,11.6 2,12.2V15.7C2,16.4 2.6,17 3.2,17H8.7C9.4,17 10,16.4 10,15.8V12.3C10,11.6 9.4,11 8.8,11M7.5,11H4.5V9.5C4.5,8.7 5.2,8.2 6,8.2C6.8,8.2 7.5,8.7 7.5,9.5V11Z";
var mdiCellphoneMarker = "M18.5 13C16.6 13 15 14.61 15 16.5C15 19.11 18.5 23 18.5 23S22 19.11 22 16.5C22 14.61 20.4 13 18.5 13M18.5 17.81C17.8 17.81 17.3 17.21 17.3 16.61C17.3 15.91 17.9 15.41 18.5 15.41S19.7 16 19.7 16.61C19.8 17.21 19.2 17.81 18.5 17.81M15.91 23H7C5.9 23 5 22.11 5 21V3C5 1.89 5.89 1 7 1H17C18.1 1 19 1.89 19 3V11.03C18.84 11 18.67 11 18.5 11C18 11 17.5 11.08 17 11.22V5H7V19H13.54C14.14 20.5 15.12 21.97 15.91 23Z";
var mdiCellphoneMessage = "M11,17V7H4V17H11M11,3A2,2 0 0,1 13,5V19A2,2 0 0,1 11,21H4C2.89,21 2,20.1 2,19V5A2,2 0 0,1 4,3H11M16.5,3H21.5A1.5,1.5 0 0,1 23,4.5V7.5A1.5,1.5 0 0,1 21.5,9H18L15,12V9L15,4.5A1.5,1.5 0 0,1 16.5,3Z";
var mdiCellphoneMessageOff = "M2.39 1.73L1.11 3L2.22 4.11C2.08 4.38 2 4.68 2 5V19C2 20.1 2.89 21 4 21H11C12.1 21 13 20.1 13 19V14.89L20.84 22.73L22.11 21.46L2.39 1.73M11 17H4V7H5.11L11 12.89V17M23 4.5V7.5C23 8.33 22.33 9 21.5 9H18L15.1 11.9L15 11.8V4.5C15 3.67 15.67 3 16.5 3H21.5C22.33 3 23 3.67 23 4.5M10.2 7L6.2 3H11C12.1 3 13 3.9 13 5V9.8L11 7.8V7H10.2";
var mdiCellphoneNfc = "M2,16V18A5,5 0 0,1 7,23H9A7,7 0 0,0 2,16M2,20V23H5A3,3 0 0,0 2,20M2,12V14A9,9 0 0,1 11,23H13C13,16.92 8.08,12 2,12M17,1H7A2,2 0 0,0 5,3V10.37C5.69,10.53 6.36,10.74 7,11V5H17V18H13.97C14.5,19.25 14.81,20.59 14.92,22H17A2,2 0 0,0 19,20V3A2,2 0 0,0 17,1Z";
var mdiCellphoneNfcOff = "M20.84 22.73L18.85 20.74C18.56 21.5 17.84 22 17 22H14.92C14.81 20.59 14.5 19.25 13.97 18H16.11L7 8.89V11C6.36 10.74 5.69 10.53 5 10.37V6.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M17 5V13.8L19 15.8V3C19 1.9 18.11 1 17 1H7C6.24 1 5.59 1.43 5.25 2.05L8.2 5H17M2 20V23H5C5 21.34 3.66 20 2 20M2 16V18C4.76 18 7 20.24 7 23H9C9 19.13 5.87 16 2 16M2 12V14C6.97 14 11 18.03 11 23H13C13 16.92 8.08 12 2 12Z";
var mdiCellphoneOff = "M2.38,1.73L1.11,3L5,6.89V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V20.89L20.84,22.73L22.11,21.46M17,19H7V8.89L17,18.89V19M17,5V13.8L19,15.8V3A2,2 0 0,0 17,1H7C6.28,1 5.6,1.37 5.24,2L8.24,5H17Z";
var mdiCellphonePlay = "M17 19H7V5H17M17 1H7C5.89 1 5 1.89 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.89 18.1 1 17 1M10 9V15L14 12L10 9Z";
var mdiCellphoneRemove = "M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88M14.54 23H7C5.9 23 5 22.11 5 21V3C5 1.89 5.89 1 7 1H17C18.1 1 19 1.89 19 3V13C18.3 13 17.63 13.13 17 13.35V5H7V19H13C13 20.54 13.58 21.94 14.54 23Z";
var mdiCellphoneScreenshot = "M7,1A2,2 0 0,0 5,3V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V3A2,2 0 0,0 17,1H7M7,4H17V20H7V4M9,6V10H10.5V7.5H13V6H9M13.5,14V16.5H11V18H15V14H13.5Z";
var mdiCellphoneSettings = "M16,16H8V4H16M16,0H8A2,2 0 0,0 6,2V18A2,2 0 0,0 8,20H16A2,2 0 0,0 18,18V2A2,2 0 0,0 16,0M15,24H17V22H15M11,24H13V22H11M7,24H9V22H7V24Z";
var mdiCellphoneSound = "M19.1,8.7C20.9,10.5 20.9,13.3 19.1,15.2L20.1,16.2C22.6,13.9 22.6,10.1 20.1,7.7L19.1,8.7M18,9.8L17,10.8C17.5,11.5 17.5,12.4 17,13.1L18,14.1C19.2,12.9 19.2,11.1 18,9.8M14,1H4A2,2 0 0,0 2,3V21A2,2 0 0,0 4,23H14A2,2 0 0,0 16,21V3A2,2 0 0,0 14,1M14,20H4V4H14V20Z";
var mdiCellphoneText = "M17,19V5H7V19H17M17,1A2,2 0 0,1 19,3V21A2,2 0 0,1 17,23H7C5.89,23 5,22.1 5,21V3C5,1.89 5.89,1 7,1H17M9,7H15V9H9V7M9,11H13V13H9V11Z";
var mdiCellphoneWireless = "M20.07,4.93C21.88,6.74 23,9.24 23,12C23,14.76 21.88,17.26 20.07,19.07L18.66,17.66C20.11,16.22 21,14.22 21,12C21,9.79 20.11,7.78 18.66,6.34L20.07,4.93M17.24,7.76C18.33,8.85 19,10.35 19,12C19,13.65 18.33,15.15 17.24,16.24L15.83,14.83C16.55,14.11 17,13.11 17,12C17,10.89 16.55,9.89 15.83,9.17L17.24,7.76M13,10A2,2 0 0,1 15,12A2,2 0 0,1 13,14A2,2 0 0,1 11,12A2,2 0 0,1 13,10M11.5,1A2.5,2.5 0 0,1 14,3.5V8H12V4H3V19H12V16H14V20.5A2.5,2.5 0 0,1 11.5,23H3.5A2.5,2.5 0 0,1 1,20.5V3.5A2.5,2.5 0 0,1 3.5,1H11.5Z";
var mdiCentos = "M19.07 14.93L22 12L19.07 9.07V4.93H14.93L12 2L9.07 4.93H4.93V9.07L2 12L4.93 14.93V19.07H9.07L12 22L14.93 19.07H19.07V14.93M21.41 12L19.07 14.34V12.46H13.69L13.23 12L13.69 11.54H19.07V9.66L21.41 12M18.66 14.76L17.32 16.09L14.11 12.87H18.66V14.76M12.46 13.1L12 12.65L11.54 13.1V12.46H10.9L11.36 12L10.9 11.54H11.54V10.9L12 11.36L12.46 10.9V11.54H13.1L12.65 12L13.1 12.46H12.46V13.1M14.11 11.13L17.32 7.91L18.66 9.24V11.13H14.11M18.66 5.35V8.65L17.32 7.32L13.5 11.13H12.87V10.5L16.68 6.68L15.35 5.35H18.66M12.87 9.89V5.35H14.76L16.09 6.68L12.87 9.89M12 2.59L14.34 4.93H12.46V10.31L12 10.77L11.54 10.31V4.93H9.66L12 2.59M11.13 9.89L7.91 6.68L9.24 5.35H11.13V9.89M5.35 5.35H8.65L7.32 6.68L11.13 10.5V11.13H10.5L6.68 7.32L5.35 8.65V5.35M5.35 9.24L6.68 7.91L9.89 11.13H5.35V9.24M2.59 12L4.93 9.66V11.54H10.31L10.77 12L10.31 12.46H4.93V14.34L2.59 12M9.89 12.87L6.68 16.09L5.35 14.76V12.87H9.89M5.35 18.66V15.35L6.68 16.68L10.5 12.87H11.13V13.5L7.32 17.32L8.65 18.65H5.35M11.13 14.11V18.66H9.24L7.91 17.32L11.13 14.11M12 21.41L9.66 19.07H11.54V13.69L12 13.23L12.46 13.69V19.07H14.34L12 21.41M12.87 14.11L16.09 17.32L14.76 18.66H12.87V14.11M15.35 18.66L16.68 17.32L12.87 13.5V12.87H13.5L17.32 16.68L18.65 15.35V18.66H15.35Z";
var mdiCertificate = "M4,3C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H12V22L15,19L18,22V17H20A2,2 0 0,0 22,15V8L22,6V5A2,2 0 0,0 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z";
var mdiCertificateOutline = "M13 21L15 20L17 21V14H13M17 9V7L15 8L13 7V9L11 10L13 11V13L15 12L17 13V11L19 10M20 3H4A2 2 0 0 0 2 5V15A2 2 0 0 0 4 17H11V15H4V5H20V15H19V17H20A2 2 0 0 0 22 15V5A2 2 0 0 0 20 3M11 8H5V6H11M9 11H5V9H9M11 14H5V12H11Z";
var mdiChairRolling = "M22 10V13H19V10H22M2 13H5V10H2V13M17 5C17 3.9 16.1 3 15 3H9C7.9 3 7 3.9 7 5V13H17V5M7 15H6V17H11V18L7 22H9.8L12 19.8L14.2 22H17L13 18V17H18V15H7Z";
var mdiChairSchool = "M22,5V7H17L13.53,12H16V14H14.46L18.17,22H15.97L15.04,20H6.38L5.35,22H3.1L7.23,14H7C6.55,14 6.17,13.7 6.04,13.3L2.87,3.84L3.82,3.5C4.34,3.34 4.91,3.63 5.08,4.15L7.72,12H12.1L15.57,7H12V5H22M9.5,14L7.42,18H14.11L12.26,14H9.5Z";
var mdiChandelier = "M15 13.1C15 14.76 13.66 16.1 12 16.1S9 14.76 9 13.1 10.34 10.1 12 10.1 15 11.44 15 13.1M9 2V3C9 4.11 9.9 5 11 5V9.1C11.32 9.04 11.66 9 12 9S12.68 9.04 13 9.1V5C14.11 5 15 4.11 15 3V2H9M4 11.1C2.34 11.1 1 12.44 1 14.1S2.34 17.1 4 17.1 7 15.76 7 14.1 5.66 11.1 4 11.1M20 11.1C18.34 11.1 17 12.44 17 14.1S18.34 17.1 20 17.1 23 15.76 23 14.1 21.66 11.1 20 11.1M20 18.1C19.32 18.1 18.67 17.96 18.08 17.71C17.6 17.95 17.07 18.1 16.5 18.1C15.39 18.1 14.41 17.57 13.77 16.77C13.22 17 12.63 17.1 12 17.1S10.78 17 10.23 16.77C9.59 17.57 8.61 18.1 7.5 18.1C6.93 18.1 6.4 17.95 5.92 17.71C5.33 17.96 4.68 18.1 4 18.1C3.73 18.1 3.46 18.06 3.2 18C4.21 19.29 5.76 20.1 7.5 20.1C8.83 20.1 10.05 19.63 11 18.84V21.1C11 21.65 11.45 22.1 12 22.1C12.55 22.1 13 21.65 13 21.1V18.84C13.95 19.63 15.17 20.1 16.5 20.1C18.24 20.1 19.79 19.29 20.8 18C20.54 18.06 20.27 18.1 20 18.1Z";
var mdiCharity = "M12.75,3.94C13.75,3.22 14.91,2.86 16.22,2.86C16.94,2.86 17.73,3.05 18.59,3.45C19.45,3.84 20.13,4.3 20.63,4.83C21.66,6.11 22.09,7.6 21.94,9.3C21.78,11 21.22,12.33 20.25,13.27L12.66,20.86C12.47,21.05 12.23,21.14 11.95,21.14C11.67,21.14 11.44,21.05 11.25,20.86C11.06,20.67 10.97,20.44 10.97,20.16C10.97,19.88 11.06,19.64 11.25,19.45L15.84,14.86C16.09,14.64 16.09,14.41 15.84,14.16C15.59,13.91 15.36,13.91 15.14,14.16L10.55,18.75C10.36,18.94 10.13,19.03 9.84,19.03C9.56,19.03 9.33,18.94 9.14,18.75C8.95,18.56 8.86,18.33 8.86,18.05C8.86,17.77 8.95,17.53 9.14,17.34L13.73,12.75C14,12.5 14,12.25 13.73,12C13.5,11.75 13.28,11.75 13.03,12L8.44,16.64C8.25,16.83 8,16.92 7.73,16.92C7.45,16.92 7.21,16.83 7,16.64C6.8,16.45 6.7,16.22 6.7,15.94C6.7,15.66 6.81,15.41 7.03,15.19L11.63,10.59C11.88,10.34 11.88,10.11 11.63,9.89C11.38,9.67 11.14,9.67 10.92,9.89L6.28,14.5C6.06,14.7 5.83,14.81 5.58,14.81C5.3,14.81 5.06,14.71 4.88,14.5C4.69,14.3 4.59,14.06 4.59,13.78C4.59,13.5 4.69,13.27 4.88,13.08C7.94,10 9.83,8.14 10.55,7.45L14.11,10.97C14.5,11.34 14.95,11.53 15.5,11.53C16.2,11.53 16.75,11.25 17.16,10.69C17.44,10.28 17.54,9.83 17.46,9.33C17.38,8.83 17.17,8.41 16.83,8.06L12.75,3.94M14.81,10.27L10.55,6L3.47,13.08C2.63,12.23 2.15,10.93 2.04,9.16C1.93,7.4 2.41,5.87 3.47,4.59C4.66,3.41 6.08,2.81 7.73,2.81C9.39,2.81 10.8,3.41 11.95,4.59L16.22,8.86C16.41,9.05 16.5,9.28 16.5,9.56C16.5,9.84 16.41,10.08 16.22,10.27C16.03,10.45 15.8,10.55 15.5,10.55C15.23,10.55 15,10.45 14.81,10.27V10.27Z";
var mdiCharitySearch = "M10.5 6L3.4 13.1C2.6 12.2 2.2 10.9 2 9.2C1.9 7.4 2.4 5.9 3.5 4.6C4.7 3.4 6.1 2.8 7.8 2.8C9.5 2.8 10.9 3.4 12 4.6L13.7 6.3C13 6.5 12.4 6.8 11.8 7.2L10.5 6M15.5 6C18.4 6 20.9 7.9 21.7 10.6C21.8 10.2 21.9 9.8 21.9 9.3C22.1 7.6 21.6 6.1 20.6 4.8C20.1 4.3 19.4 3.8 18.6 3.4C17.7 3 16.9 2.8 16.2 2.8C14.9 2.8 13.7 3.2 12.7 3.9L14.8 6H15.5M11 7.9L10.6 7.5C9.8 8.1 7.9 10 4.9 13.1C4.7 13.3 4.6 13.5 4.6 13.8C4.6 14.1 4.7 14.3 4.9 14.5C5.1 14.7 5.3 14.8 5.6 14.8C5.8 14.8 6.1 14.7 6.3 14.5L9 11.8C9.2 10.2 9.9 8.9 11 7.9M10.2 16.3L9.1 17.4C9 17.5 8.9 17.8 8.9 18C8.9 18.3 9 18.5 9.2 18.7S9.6 19 9.8 19C10.1 19 10.3 18.9 10.5 18.7L11.6 17.6C11.1 17.3 10.6 16.8 10.2 16.3M9 13.2L7 15.2C6.8 15.4 6.7 15.7 6.7 16C6.7 16.3 6.8 16.5 7 16.7C7.2 16.9 7.5 17 7.7 17C8 17 8.2 16.9 8.4 16.7L9.6 15.4C9.3 14.7 9.1 14 9 13.2M12.5 18.2L11.3 19.4C11.1 19.6 11 19.8 11 20.1C11 20.4 11.1 20.6 11.3 20.8S11.7 21.1 12 21.1C12.3 21.1 12.5 21 12.7 20.8L14.6 18.9C13.8 18.8 13.1 18.6 12.5 18.2M22.2 17.8L20.8 19.2L17.9 16.3C17.2 16.7 16.4 17 15.5 17C13 17 11 15 11 12.5S13 8 15.5 8 20 10 20 12.5C20 13.4 19.7 14.2 19.3 14.9L22.2 17.8M18 12.5C18 11.1 16.9 10 15.5 10S13 11.1 13 12.5 14.1 15 15.5 15 18 13.9 18 12.5Z";
var mdiChartArc = "M16.18,19.6L14.17,16.12C15.15,15.4 15.83,14.28 15.97,13H20C19.83,15.76 18.35,18.16 16.18,19.6M13,7.03V3C17.3,3.26 20.74,6.7 21,11H16.97C16.74,8.91 15.09,7.26 13,7.03M7,12.5C7,13.14 7.13,13.75 7.38,14.3L3.9,16.31C3.32,15.16 3,13.87 3,12.5C3,7.97 6.54,4.27 11,4V8.03C8.75,8.28 7,10.18 7,12.5M11.5,21C8.53,21 5.92,19.5 4.4,17.18L7.88,15.17C8.7,16.28 10,17 11.5,17C12.14,17 12.75,16.87 13.3,16.62L15.31,20.1C14.16,20.68 12.87,21 11.5,21Z";
var mdiChartAreaspline = "M17.45,15.18L22,7.31V19L22,21H2V3H4V15.54L9.5,6L16,9.78L20.24,2.45L21.97,3.45L16.74,12.5L10.23,8.75L4.31,19H6.57L10.96,11.44L17.45,15.18Z";
var mdiChartAreasplineVariant = "M22,21H2V3H4V15.54L9.5,6L16,9.78L20.24,2.45L21.97,3.45L22,21Z";
var mdiChartBar = "M22,21H2V3H4V19H6V10H10V19H12V6H16V19H18V14H22V21Z";
var mdiChartBarStacked = "M22,21H2V3H4V19H6V17H10V19H12V16H16V19H18V17H22V21M18,14H22V16H18V14M12,6H16V9H12V6M16,15H12V10H16V15M6,10H10V12H6V10M10,16H6V13H10V16Z";
var mdiChartBellCurve = "M9.96,11.31C10.82,8.1 11.5,6 13,6C14.5,6 15.18,8.1 16.04,11.31C17,14.92 18.1,19 22,19V17C19.8,17 19,14.54 17.97,10.8C17.08,7.46 16.15,4 13,4C9.85,4 8.92,7.46 8.03,10.8C7.03,14.54 6.2,17 4,17V2H2V22H22V20H4V19C7.9,19 9,14.92 9.96,11.31Z";
var mdiChartBellCurveCumulative = "M4 19V20H22V22H2V2H4V17C7 17 10 15 12.1 11.4C15.1 6.4 18.4 4 22 4V6C19.2 6 16.5 8.1 13.9 12.5C11.3 16.6 7.7 19 4 19Z";
var mdiChartBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9 17H7V10H9V17M13 17H11V7H13V17M17 17H15V13H17V17Z";
var mdiChartBoxMultiple = "M4 20H16V22H4C2.9 22 2 21.1 2 20V7H4M22 4V16C22 17.1 21.1 18 20 18H8C6.9 18 6 17.1 6 16V4C6 2.9 6.9 2 8 2H20C21.1 2 22 2.9 22 4M12 8H10V14H12M15 6H13V14H15M18 11H16V14H18Z";
var mdiChartBoxMultipleOutline = "M20 16V4H8V16M22 16C22 17.1 21.1 18 20 18H8C6.9 18 6 17.1 6 16V4C6 2.9 6.9 2 8 2H20C21.1 2 22 2.9 22 4M16 20V22H4C2.9 22 2 21.1 2 20V7H4V20M16 11H18V14H16M13 6H15V14H13M10 8H12V14H10Z";
var mdiChartBoxOutline = "M9 17H7V10H9V17M13 17H11V7H13V17M17 17H15V13H17V17M19 19H5V5H19V19.1M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z";
var mdiChartBoxPlusOutline = "M22 5V7H19V10H17V7H14V5H17V2H19V5H22M19 19H5V5H11V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V13H19V19M15 13V17H17V13H15M11 17H13V9H11V17M9 17V11H7V17H9Z";
var mdiChartBubble = "M7.2,11.2C8.97,11.2 10.4,12.63 10.4,14.4C10.4,16.17 8.97,17.6 7.2,17.6C5.43,17.6 4,16.17 4,14.4C4,12.63 5.43,11.2 7.2,11.2M14.8,16A2,2 0 0,1 16.8,18A2,2 0 0,1 14.8,20A2,2 0 0,1 12.8,18A2,2 0 0,1 14.8,16M15.2,4A4.8,4.8 0 0,1 20,8.8C20,11.45 17.85,13.6 15.2,13.6A4.8,4.8 0 0,1 10.4,8.8C10.4,6.15 12.55,4 15.2,4Z";
var mdiChartDonut = "M13,2.05V5.08C16.39,5.57 19,8.47 19,12C19,12.9 18.82,13.75 18.5,14.54L21.12,16.07C21.68,14.83 22,13.45 22,12C22,6.82 18.05,2.55 13,2.05M12,19A7,7 0 0,1 5,12C5,8.47 7.61,5.57 11,5.08V2.05C5.94,2.55 2,6.81 2,12A10,10 0 0,0 12,22C15.3,22 18.23,20.39 20.05,17.91L17.45,16.38C16.17,18 14.21,19 12,19Z";
var mdiChartDonutVariant = "M13,2.05C18.05,2.55 22,6.82 22,12C22,13.45 21.68,14.83 21.12,16.07L18.5,14.54C18.82,13.75 19,12.9 19,12C19,8.47 16.39,5.57 13,5.08V2.05M12,19C14.21,19 16.17,18 17.45,16.38L20.05,17.91C18.23,20.39 15.3,22 12,22C6.47,22 2,17.5 2,12C2,6.81 5.94,2.55 11,2.05V5.08C7.61,5.57 5,8.47 5,12A7,7 0 0,0 12,19M12,6A6,6 0 0,1 18,12C18,14.97 15.84,17.44 13,17.92V14.83C14.17,14.42 15,13.31 15,12A3,3 0 0,0 12,9L11.45,9.05L9.91,6.38C10.56,6.13 11.26,6 12,6M6,12C6,10.14 6.85,8.5 8.18,7.38L9.72,10.05C9.27,10.57 9,11.26 9,12C9,13.31 9.83,14.42 11,14.83V17.92C8.16,17.44 6,14.97 6,12Z";
var mdiChartGantt = "M2,5H10V2H12V22H10V18H6V15H10V13H4V10H10V8H2V5M14,5H17V8H14V5M14,10H19V13H14V10M14,15H22V18H14V15Z";
var mdiChartHistogram = "M3,3H5V13H9V7H13V11H17V15H21V21H3V3Z";
var mdiChartLine = "M16,11.78L20.24,4.45L21.97,5.45L16.74,14.5L10.23,10.75L5.46,19H22V21H2V3H4V17.54L9.5,8L16,11.78Z";
var mdiChartLineStacked = "M17.45,15.18L22,6.81V19L22,21H2V3H4V15.54L4,19H4.31L6,19H6.57L10.96,11.44L17.45,15.18M22,3L21.97,3.45L17,11L10,6L6,12V3H22Z";
var mdiChartLineVariant = "M3.5,18.5L9.5,12.5L13.5,16.5L22,6.92L20.59,5.5L13.5,13.5L9.5,9.5L2,17L3.5,18.5Z";
var mdiChartMultiline = "M22,6.92L20.59,5.5L17.74,8.72C15.68,6.4 12.83,5 9.61,5C6.72,5 4.07,6.16 2,8L3.42,9.42C5.12,7.93 7.27,7 9.61,7C12.35,7 14.7,8.26 16.38,10.24L13.5,13.5L9.5,9.5L2,17L3.5,18.5L9.5,12.5L13.5,16.5L17.55,11.93C18.3,13.28 18.8,14.83 19,16.5H21C20.78,14.18 20.05,12.09 18.96,10.34L22,6.92Z";
var mdiChartMultiple = "M22 16V18H6V2H8V13.57L13.71 4.57L16.87 6.68L19.29 4.26L20.71 5.68L17.13 9.29L14.29 7.4L8.82 16M4 20V4H2V22H22V20Z";
var mdiChartPie = "M11,2V22C5.9,21.5 2,17.2 2,12C2,6.8 5.9,2.5 11,2M13,2V11H22C21.5,6.2 17.8,2.5 13,2M13,13V22C17.7,21.5 21.5,17.8 22,13H13Z";
var mdiChartPieOutline = "M13 11H19.95Q19.58 8.25 17.66 6.34 15.75 4.43 13 4.05M11 19.95V4.05Q8 4.43 6 6.69 4 8.95 4 12T6 17.31Q8 19.58 11 19.95M13 19.95Q15.75 19.6 17.68 17.68 19.6 15.75 19.95 13H13M12 12M12 22Q9.93 22 8.1 21.21 6.28 20.43 4.93 19.08 3.58 17.73 2.79 15.9 2 14.08 2 12T2.79 8.1Q3.58 6.28 4.93 4.93 6.28 3.58 8.1 2.79 9.93 2 12 2T15.89 2.79Q17.7 3.58 19.06 4.94 20.43 6.3 21.21 8.11 22 9.93 22 12 22 14.05 21.21 15.88 20.43 17.7 19.08 19.06 17.73 20.43 15.9 21.21 14.08 22 12 22Z";
var mdiChartPpf = "M5 6V8C8.2 8 11.36 9.18 13.57 11.15C15.64 13 16.83 15.5 17 18H18.97A14 12.5 0 0 0 5 6M22 21H2V3H4V19H22Z";
var mdiChartSankey = "M22 5H4V2H2V22H22V20H4V9C8.09 9 10.13 11 12.29 13.21S17.09 18 22 18V16C17.91 16 15.87 14 13.71 11.79S8.91 7 4 7H22Z";
var mdiChartSankeyVariant = "M20 4V6H4V4H2V12H4V10C8.16 10 9.92 12.11 11.77 14.34S15.65 19 20 19V21H22V15H20V17C16.59 17 15.07 15.17 13.31 13.06C11.34 10.69 9.1 8 4 8H20V10H22V4Z";
var mdiChartScatterPlot = "M2,2H4V20H22V22H2V2M9,10A3,3 0 0,1 12,13A3,3 0 0,1 9,16A3,3 0 0,1 6,13A3,3 0 0,1 9,10M13,2A3,3 0 0,1 16,5A3,3 0 0,1 13,8A3,3 0 0,1 10,5A3,3 0 0,1 13,2M18,12A3,3 0 0,1 21,15A3,3 0 0,1 18,18A3,3 0 0,1 15,15A3,3 0 0,1 18,12Z";
var mdiChartScatterPlotHexbin = "M2,2H4V20H22V22H2V2M14,14.5L12,18H7.94L5.92,14.5L7.94,11H12L14,14.5M14.08,6.5L12.06,10H8L6,6.5L8,3H12.06L14.08,6.5M21.25,10.5L19.23,14H15.19L13.17,10.5L15.19,7H19.23L21.25,10.5Z";
var mdiChartTimeline = "M2,2H4V20H22V22H2V2M7,10H17V13H7V10M11,15H21V18H11V15M6,4H22V8H20V6H8V8H6V4Z";
var mdiChartTimelineVariant = "M3,14L3.5,14.07L8.07,9.5C7.89,8.85 8.06,8.11 8.59,7.59C9.37,6.8 10.63,6.8 11.41,7.59C11.94,8.11 12.11,8.85 11.93,9.5L14.5,12.07L15,12C15.18,12 15.35,12 15.5,12.07L19.07,8.5C19,8.35 19,8.18 19,8A2,2 0 0,1 21,6A2,2 0 0,1 23,8A2,2 0 0,1 21,10C20.82,10 20.65,10 20.5,9.93L16.93,13.5C17,13.65 17,13.82 17,14A2,2 0 0,1 15,16A2,2 0 0,1 13,14L13.07,13.5L10.5,10.93C10.18,11 9.82,11 9.5,10.93L4.93,15.5L5,16A2,2 0 0,1 3,18A2,2 0 0,1 1,16A2,2 0 0,1 3,14Z";
var mdiChartTimelineVariantShimmer = "M21 8C19.5 8 18.7 9.4 19.1 10.5L15.5 14.1C15.2 14 14.8 14 14.5 14.1L11.9 11.5C12.3 10.4 11.5 9 10 9C8.6 9 7.7 10.4 8.1 11.5L3.5 16C2.4 15.7 1 16.5 1 18C1 19.1 1.9 20 3 20C4.4 20 5.3 18.6 4.9 17.5L9.4 12.9C9.7 13 10.1 13 10.4 12.9L13 15.5C12.7 16.5 13.5 18 15 18C16.5 18 17.3 16.6 16.9 15.5L20.5 11.9C21.6 12.2 23 11.4 23 10C23 8.9 22.1 8 21 8M15 9L15.9 6.9L18 6L15.9 5.1L15 3L14.1 5.1L12 6L14.1 6.9L15 9M3.5 11L4 9L6 8.5L4 8L3.5 6L3 8L1 8.5L3 9L3.5 11Z";
var mdiChartTree = "M14,6H22V22H14V6M2,4H22V2H2V4M2,8H12V6H2V8M9,22H12V10H9V22M2,22H7V10H2V22Z";
var mdiChartWaterfall = "M2 2H4V20H22V22H2V2M17 2H20V18H17V2M6 11H9V18H6V11M13 3H16V7H13V3M10 8H13V12H10V8Z";
var mdiChat = "M12,3C17.5,3 22,6.58 22,11C22,15.42 17.5,19 12,19C10.76,19 9.57,18.82 8.47,18.5C5.55,21 2,21 2,21C4.33,18.67 4.7,17.1 4.75,16.5C3.05,15.07 2,13.13 2,11C2,6.58 6.5,3 12,3Z";
var mdiChatAlert = "M12,3C17.5,3 22,6.58 22,11C22,15.42 17.5,19 12,19C10.76,19 9.57,18.82 8.47,18.5C5.55,21 2,21 2,21C4.33,18.67 4.7,17.1 4.75,16.5C3.05,15.07 2,13.13 2,11C2,6.58 6.5,3 12,3M11,14V16H13V14H11M11,12H13V6H11V12Z";
var mdiChatAlertOutline = "M12 3C6.5 3 2 6.58 2 11C2.05 13.15 3.06 15.17 4.75 16.5C4.75 17.1 4.33 18.67 2 21C4.37 20.89 6.64 20 8.47 18.5C9.61 18.83 10.81 19 12 19C17.5 19 22 15.42 22 11S17.5 3 12 3M12 17C7.58 17 4 14.31 4 11S7.58 5 12 5 20 7.69 20 11 16.42 17 12 17M11 13V15H13V13H11M11 11H13V7H11V11Z";
var mdiChatMinus = "M23 17V19H15V17H23M12 3C17.5 3 22 6.58 22 11C22 11.58 21.92 12.14 21.78 12.68C20.95 12.25 20 12 19 12C15.69 12 13 14.69 13 18L13.08 18.95L12 19C10.76 19 9.57 18.82 8.47 18.5C5.55 21 2 21 2 21C4.33 18.67 4.7 17.1 4.75 16.5C3.05 15.07 2 13.14 2 11C2 6.58 6.5 3 12 3Z";
var mdiChatMinusOutline = "M12 3C17.5 3 22 6.58 22 11C22 11.58 21.92 12.14 21.78 12.68C21.19 12.38 20.55 12.16 19.88 12.06C19.96 11.72 20 11.36 20 11C20 7.69 16.42 5 12 5S4 7.69 4 11 7.58 17 12 17L13.09 16.95L13 18L13.08 18.95L12 19C10.81 19 9.62 18.83 8.47 18.5C6.64 20 4.37 20.89 2 21C4.33 18.67 4.75 17.1 4.75 16.5C3.06 15.17 2.05 13.15 2 11C2 6.58 6.5 3 12 3M23 17V19H15V17H23Z";
var mdiChatOutline = "M12,3C6.5,3 2,6.58 2,11C2.05,13.15 3.06,15.17 4.75,16.5C4.75,17.1 4.33,18.67 2,21C4.37,20.89 6.64,20 8.47,18.5C9.61,18.83 10.81,19 12,19C17.5,19 22,15.42 22,11C22,6.58 17.5,3 12,3M12,17C7.58,17 4,14.31 4,11C4,7.69 7.58,5 12,5C16.42,5 20,7.69 20,11C20,14.31 16.42,17 12,17Z";
var mdiChatPlus = "M18 14H20V17H23V19H20V22H18V19H15V17H18V14M12 3C17.5 3 22 6.58 22 11C22 11.58 21.92 12.14 21.78 12.68C20.95 12.25 20 12 19 12C15.69 12 13 14.69 13 18L13.08 18.95L12 19C10.76 19 9.57 18.82 8.47 18.5C5.55 21 2 21 2 21C4.33 18.67 4.7 17.1 4.75 16.5C3.05 15.07 2 13.14 2 11C2 6.58 6.5 3 12 3Z";
var mdiChatPlusOutline = "M12 3C17.5 3 22 6.58 22 11C22 11.58 21.92 12.14 21.78 12.68C21.19 12.38 20.55 12.16 19.88 12.06C19.96 11.72 20 11.36 20 11C20 7.69 16.42 5 12 5C7.58 5 4 7.69 4 11C4 14.31 7.58 17 12 17L13.09 16.95L13 18L13.08 18.95L12 19C10.81 19 9.62 18.83 8.47 18.5C6.64 20 4.37 20.89 2 21C4.33 18.67 4.75 17.1 4.75 16.5C3.06 15.17 2.05 13.15 2 11C2 6.58 6.5 3 12 3M18 14H20V17H23V19H20V22H18V19H15V17H18V14Z";
var mdiChatProcessing = "M12,3C17.5,3 22,6.58 22,11C22,15.42 17.5,19 12,19C10.76,19 9.57,18.82 8.47,18.5C5.55,21 2,21 2,21C4.33,18.67 4.7,17.1 4.75,16.5C3.05,15.07 2,13.13 2,11C2,6.58 6.5,3 12,3M17,12V10H15V12H17M13,12V10H11V12H13M9,12V10H7V12H9Z";
var mdiChatProcessingOutline = "M12 3C6.5 3 2 6.58 2 11C2.05 13.15 3.06 15.17 4.75 16.5C4.75 17.1 4.33 18.67 2 21C4.37 20.89 6.64 20 8.47 18.5C9.61 18.83 10.81 19 12 19C17.5 19 22 15.42 22 11S17.5 3 12 3M12 17C7.58 17 4 14.31 4 11S7.58 5 12 5 20 7.69 20 11 16.42 17 12 17M17 12V10H15V12H17M13 12V10H11V12H13M9 12V10H7V12H9Z";
var mdiChatQuestion = "M12 3C6.5 3 2 6.6 2 11C2 13.1 3 15.1 4.8 16.5C4.8 17.1 4.4 18.7 2 21C2 21 5.5 21 8.5 18.5C9.6 18.8 10.8 19 12 19C17.5 19 22 15.4 22 11S17.5 3 12 3M13 15H11V13H13V15M14.8 10C14.5 10.4 14.1 10.6 13.7 10.8C13.4 11 13.3 11.1 13.2 11.3C13 11.5 13 11.7 13 12H11C11 11.5 11.1 11.2 11.3 10.9C11.5 10.7 11.9 10.4 12.4 10.1C12.7 10 12.9 9.8 13 9.6C13.1 9.4 13.2 9.1 13.2 8.9C13.2 8.6 13.1 8.4 12.9 8.2C12.7 8 12.4 7.9 12.1 7.9C11.8 7.9 11.6 8 11.4 8.1C11.2 8.2 11.1 8.4 11.1 8.7H9.1C9.2 8 9.5 7.4 10 7C10.5 6.6 11.2 6.5 12.1 6.5C13 6.5 13.8 6.7 14.3 7.1C14.8 7.5 15.1 8.1 15.1 8.8C15.2 9.2 15.1 9.6 14.8 10Z";
var mdiChatQuestionOutline = "M12 3C6.5 3 2 6.6 2 11C2 13.2 3.1 15.2 4.8 16.5C4.8 17.1 4.4 18.7 2 21C4.4 20.9 6.6 20 8.5 18.5C9.6 18.8 10.8 19 12 19C17.5 19 22 15.4 22 11S17.5 3 12 3M12 17C7.6 17 4 14.3 4 11S7.6 5 12 5 20 7.7 20 11 16.4 17 12 17M12.2 6.5C11.3 6.5 10.6 6.7 10.1 7C9.5 7.4 9.2 8 9.3 8.7H11.3C11.3 8.4 11.4 8.2 11.6 8.1C11.8 8 12 7.9 12.3 7.9C12.6 7.9 12.9 8 13.1 8.2C13.3 8.4 13.4 8.6 13.4 8.9C13.4 9.2 13.3 9.4 13.2 9.6C13 9.8 12.8 10 12.6 10.1C12.1 10.4 11.7 10.7 11.5 10.9C11.1 11.2 11 11.5 11 12H13C13 11.7 13.1 11.5 13.1 11.3C13.2 11.1 13.4 11 13.6 10.8C14.1 10.6 14.4 10.3 14.7 9.9C15 9.5 15.1 9.1 15.1 8.7C15.1 8 14.8 7.4 14.3 7C13.9 6.7 13.1 6.5 12.2 6.5M11 13V15H13V13H11Z";
var mdiChatRemove = "M15.46 15.88L16.88 14.46L19 16.59L21.12 14.47L22.54 15.88L20.41 18L22.54 20.12L21.12 21.54L19 19.41L16.88 21.54L15.46 20.12L17.59 18L15.47 15.88M12 3C17.5 3 22 6.58 22 11C22 11.58 21.92 12.14 21.78 12.68C20.95 12.25 20 12 19 12C15.69 12 13 14.69 13 18L13.08 18.95L12 19C10.76 19 9.57 18.82 8.47 18.5C5.55 21 2 21 2 21C4.33 18.67 4.7 17.1 4.75 16.5C3.05 15.07 2 13.14 2 11C2 6.58 6.5 3 12 3Z";
var mdiChatRemoveOutline = "M15.46 15.88L16.88 14.46L19 16.59L21.12 14.47L22.54 15.88L20.41 18L22.54 20.12L21.12 21.54L19 19.41L16.88 21.54L15.46 20.12L17.59 18L15.47 15.88M12 3C17.5 3 22 6.58 22 11C22 11.58 21.92 12.14 21.78 12.68C21.19 12.38 20.55 12.16 19.88 12.06C19.96 11.72 20 11.36 20 11C20 7.69 16.42 5 12 5C7.58 5 4 7.69 4 11C4 14.31 7.58 17 12 17L13.09 16.95L13 18L13.08 18.95L12 19C10.81 19 9.62 18.83 8.47 18.5C6.64 20 4.37 20.89 2 21C4.33 18.67 4.75 17.1 4.75 16.5C3.06 15.17 2.05 13.15 2 11C2 6.58 6.5 3 12 3Z";
var mdiChatSleep = "M12 3C6.5 3 2 6.58 2 11C2 13.13 3.05 15.07 4.75 16.5C4.7 17.1 4.33 18.67 2 21C2 21 5.55 21 8.47 18.5C9.57 18.82 10.76 19 12 19C17.5 19 22 15.42 22 11S17.5 3 12 3M15 9.3L11.76 13H15V15H9V12.7L12.24 9H9V7H15V9.3Z";
var mdiChatSleepOutline = "M12 3C6.5 3 2 6.58 2 11C2.05 13.15 3.06 15.17 4.75 16.5C4.75 17.1 4.33 18.67 2 21C4.37 20.89 6.64 20 8.47 18.5C9.61 18.83 10.81 19 12 19C17.5 19 22 15.42 22 11S17.5 3 12 3M12 17C7.58 17 4 14.31 4 11S7.58 5 12 5 20 7.69 20 11 16.42 17 12 17M15 7H9V9H12.24L9 12.7V15H15V13H11.76L15 9.3V7Z";
var mdiCheck = "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z";
var mdiCheckAll = "M0.41,13.41L6,19L7.41,17.58L1.83,12M22.24,5.58L11.66,16.17L7.5,12L6.07,13.41L11.66,19L23.66,7M18,7L16.59,5.58L10.24,11.93L11.66,13.34L18,7Z";
var mdiCheckBold = "M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z";
var mdiCheckCircle = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z";
var mdiCheckCircleOutline = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z";
var mdiCheckDecagram = "M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z";
var mdiCheckDecagramOutline = "M23 12L20.6 9.2L20.9 5.5L17.3 4.7L15.4 1.5L12 3L8.6 1.5L6.7 4.7L3.1 5.5L3.4 9.2L1 12L3.4 14.8L3.1 18.5L6.7 19.3L8.6 22.5L12 21L15.4 22.5L17.3 19.3L20.9 18.5L20.6 14.8L23 12M18.7 16.9L16 17.5L14.6 19.9L12 18.8L9.4 19.9L8 17.5L5.3 16.9L5.5 14.1L3.7 12L5.5 9.9L5.3 7.1L8 6.5L9.4 4.1L12 5.2L14.6 4.1L16 6.5L18.7 7.1L18.5 9.9L20.3 12L18.5 14.1L18.7 16.9M16.6 7.6L18 9L10 17L6 13L7.4 11.6L10 14.2L16.6 7.6Z";
var mdiCheckNetwork = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M8.25,10.08L9.41,8.92L11,10.5L14.59,6.92L15.75,8.33L11,13.08L8.25,10.08Z";
var mdiCheckNetworkOutline = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M7,15V5H17V15H7M8,10.37L9.24,9.13L10.93,10.83L14.76,7L16,8.5L10.93,13.57L8,10.37Z";
var mdiCheckOutline = "M19.78,2.2L24,6.42L8.44,22L0,13.55L4.22,9.33L8.44,13.55L19.78,2.2M19.78,5L8.44,16.36L4.22,12.19L2.81,13.55L8.44,19.17L21.19,6.42L19.78,5Z";
var mdiCheckUnderline = "M21,5L9,17L3.5,11.5L4.91,10.09L9,14.17L19.59,3.59L21,5M3,21V19H21V21H3Z";
var mdiCheckUnderlineCircle = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M17,18H7V16H17V18M10.3,14L7,10.7L8.4,9.3L10.3,11.2L15.6,5.9L17,7.3L10.3,14Z";
var mdiCheckUnderlineCircleOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M7,15H17V17H7V15M10.3,11.2L8.4,9.3L7,10.7L10.3,14L17,7.3L15.6,5.9L10.3,11.2Z";
var mdiCheckbook = "M5,14H19V15H5V14M21,17V8H3V17H21M1,5H23V19H1V5M5,10H12V12H5V10Z";
var mdiCheckbookArrowLeft = "M5 14H15.53C15.25 14.31 15 14.64 14.8 15H5V14M21 8V12.08C21.72 12.2 22.39 12.45 23 12.8V5H1V19H14.08C14.03 18.68 14 18.34 14 18C14 17.66 14.03 17.33 14.08 17H3V8H21M5 10H12V12H5V10M16 18L19 15V17H23V19H19V21L16 18Z";
var mdiCheckbookArrowRight = "M5 14H15.53C15.25 14.31 15 14.64 14.8 15H5V14M21 8V12.08C21.72 12.2 22.39 12.45 23 12.8V5H1V19H14.08C14.03 18.68 14 18.34 14 18C14 17.66 14.03 17.33 14.08 17H3V8H21M5 10H12V12H5V10M24 18L21 15V17H17V19H21V21L24 18Z";
var mdiCheckboxBlank = "M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiCheckboxBlankBadge = "M23 4.5C23 6.43 21.43 8 19.5 8S16 6.43 16 4.5 17.57 1 19.5 1 23 2.57 23 4.5M19.5 10C16.47 10 14 7.53 14 4.5C14 4 14.08 3.5 14.21 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V9.79C20.5 9.92 20 10 19.5 10Z";
var mdiCheckboxBlankBadgeOutline = "M23 4.5C23 6.43 21.43 8 19.5 8S16 6.43 16 4.5 17.57 1 19.5 1 23 2.57 23 4.5M19.5 10C19.33 10 19.17 10 19 10V19H5V5H14.03C14 4.84 14 4.67 14 4.5C14 4 14.08 3.5 14.21 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V9.79C20.5 9.92 20 10 19.5 10Z";
var mdiCheckboxBlankCircle = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiCheckboxBlankCircleOutline = "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiCheckboxBlankOff = "M20.84 22.73L19.1 21C19.06 21 19.03 21 19 21H5C3.9 21 3 20.11 3 19V5C3 4.97 3 4.94 3 4.9L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M21 5C21 3.89 20.1 3 19 3H6.2L21 17.8V5Z";
var mdiCheckboxBlankOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L3 4.9V19C3 20.11 3.9 21 5 21H19.1L20.84 22.73L22.11 21.46M5 19V6.89L17.11 19H5M8.2 5L6.2 3H19C20.1 3 21 3.89 21 5V17.8L19 15.8V5H8.2Z";
var mdiCheckboxBlankOutline = "M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z";
var mdiCheckboxIntermediate = "M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,17H7V7H17V17Z";
var mdiCheckboxIntermediateVariant = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V5H19V19M7 17V7H17";
var mdiCheckboxMarked = "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiCheckboxMarkedCircle = "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiCheckboxMarkedCircleAutoOutline = "M12 22C12.8 22 13.6 21.9 14.3 21.7C13.9 21.2 13.5 20.6 13.3 19.9C12.9 20 12.4 20 12 20C7.6 20 4 16.4 4 12C4 7.6 7.6 4 12 4C12.8 4 13.5 4.1 14.2 4.3L15.8 2.7C14.6 2.3 13.3 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22M6.5 11.5L7.9 10.1L11 13.2L19.6 4.6L21 6L11 16L6.5 11.5M19 14L17.74 16.75L15 18L17.74 19.26L19 22L20.25 19.26L23 18L20.25 16.75L19 14Z";
var mdiCheckboxMarkedCircleMinusOutline = "M14.3 21.7C13.6 21.9 12.8 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C13.3 2 14.6 2.3 15.8 2.7L14.2 4.3C13.5 4.1 12.8 4 12 4C7.6 4 4 7.6 4 12C4 16.4 7.6 20 12 20C12.4 20 12.9 20 13.3 19.9C13.5 20.6 13.9 21.2 14.3 21.7M7.9 10.1L6.5 11.5L11 16L21 6L19.6 4.6L11 13.2L7.9 10.1M15 17V19H23V17H15Z";
var mdiCheckboxMarkedCircleOutline = "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z";
var mdiCheckboxMarkedCirclePlusOutline = "M14.3 21.7C13.6 21.9 12.8 22 12 22C6.5 22 2 17.5 2 12S6.5 2 12 2C13.3 2 14.6 2.3 15.8 2.7L14.2 4.3C13.5 4.1 12.8 4 12 4C7.6 4 4 7.6 4 12S7.6 20 12 20C12.4 20 12.9 20 13.3 19.9C13.5 20.6 13.9 21.2 14.3 21.7M7.9 10.1L6.5 11.5L11 16L21 6L19.6 4.6L11 13.2L7.9 10.1M18 14V17H15V19H18V22H20V19H23V17H20V14H18Z";
var mdiCheckboxMarkedOutline = "M19,19H5V5H15V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V11H19M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z";
var mdiCheckboxMultipleBlank = "M22,16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H20A2,2 0 0,1 22,4V16M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16Z";
var mdiCheckboxMultipleBlankCircle = "M14,2A8,8 0 0,0 6,10A8,8 0 0,0 14,18A8,8 0 0,0 22,10A8,8 0 0,0 14,2M4.93,5.82C3.08,7.34 2,9.61 2,12A8,8 0 0,0 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z";
var mdiCheckboxMultipleBlankCircleOutline = "M14,2A8,8 0 0,0 6,10A8,8 0 0,0 14,18A8,8 0 0,0 22,10A8,8 0 0,0 14,2M14,4C17.32,4 20,6.69 20,10C20,13.32 17.32,16 14,16A6,6 0 0,1 8,10A6,6 0 0,1 14,4M4.93,5.82C3.08,7.34 2,9.61 2,12A8,8 0 0,0 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z";
var mdiCheckboxMultipleBlankOutline = "M20,16V4H8V16H20M22,16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H20A2,2 0 0,1 22,4V16M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16Z";
var mdiCheckboxMultipleMarked = "M22,16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H20A2,2 0 0,1 22,4V16M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16M13,14L20,7L18.59,5.59L13,11.17L9.91,8.09L8.5,9.5L13,14Z";
var mdiCheckboxMultipleMarkedCircle = "M14,2A8,8 0 0,0 6,10A8,8 0 0,0 14,18A8,8 0 0,0 22,10A8,8 0 0,0 14,2M4.93,5.82C3.08,7.34 2,9.61 2,12A8,8 0 0,0 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82M18.09,6.08L19.5,7.5L13,14L9.21,10.21L10.63,8.79L13,11.17";
var mdiCheckboxMultipleMarkedCircleOutline = "M14,2A8,8 0 0,0 6,10A8,8 0 0,0 14,18A8,8 0 0,0 22,10H20C20,13.32 17.32,16 14,16A6,6 0 0,1 8,10A6,6 0 0,1 14,4C14.43,4 14.86,4.05 15.27,4.14L16.88,2.54C15.96,2.18 15,2 14,2M20.59,3.58L14,10.17L11.62,7.79L10.21,9.21L14,13L22,5M4.93,5.82C3.08,7.34 2,9.61 2,12A8,8 0 0,0 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z";
var mdiCheckboxMultipleMarkedOutline = "M20,16V10H22V16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H16V4H8V16H20M10.91,7.08L14,10.17L20.59,3.58L22,5L14,13L9.5,8.5L10.91,7.08M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16Z";
var mdiCheckboxMultipleOutline = "M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M20,16H8V4H20V16M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16M18.53,8.06L17.47,7L12.59,11.88L10.47,9.76L9.41,10.82L12.59,14L18.53,8.06Z";
var mdiCheckboxOutline = "M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9";
var mdiCheckerboard = "M2 2V22H22V2H2M20 12H16V16H20V20H16V16H12V20H8V16H4V12H8V8H4V4H8V8H12V4H16V8H20V12M16 8V12H12V8H16M12 12V16H8V12H12Z";
var mdiCheckerboardMinus = "M14 17V19H22V17M8 16H12V12H8V16M12 12H16V8H12V12M2 2V22H13.5C13 21.4 12.6 20.7 12.3 20H8V16H4V12H8V8H4V4H8V8H12V4H16V8H20V12.4C20.7 12.7 21.4 13.1 22 13.6V2H2Z";
var mdiCheckerboardPlus = "M19 17H22V19H19V22H17V19H14V17H17V14H19V17M8 16H12V12H8V16M12 12H16V8H12V12M2 2V22H13.54C13 21.42 12.63 20.74 12.36 20H8V16H4V12H8V8H4V4H8V8H12V4H16V8H20V12.36C20.74 12.63 21.42 13 22 13.54V2H2Z";
var mdiCheckerboardRemove = "M8 16H12V12H8V16M12 12H16V8H12V12M2 2V22H13.5C13 21.4 12.6 20.7 12.3 20H8V16H4V12H8V8H4V4H8V8H12V4H16V8H20V12.4C20.7 12.7 21.4 13.1 22 13.6V2H2M20.1 14.5L18 16.6L15.9 14.5L14.5 15.9L16.6 18L14.5 20.1L15.9 21.5L18 19.4L20.1 21.5L21.5 20.1L19.4 18L21.5 15.9L20.1 14.5Z";
var mdiCheese = "M11 17.5C11 16.67 11.67 16 12.5 16C12.79 16 13.06 16.09 13.29 16.23L20.75 11.93C20.35 11.22 19.9 10.55 19.41 9.9C19.29 9.96 19.15 10 19 10C18.45 10 18 9.55 18 9C18 8.8 18.08 8.62 18.18 8.46C16.45 6.64 14.34 5.2 12 4.25C11.85 5.24 11 6 10 6C8.9 6 8 5.11 8 4C8 3.72 8.06 3.45 8.16 3.21C7.3 3.08 6.41 3 5.5 3C5.33 3 5.17 3 5 3.03V9.05C6.14 9.28 7 10.29 7 11.5S6.14 13.72 5 13.95V21L11 17.54C11 17.53 11 17.5 11 17.5M14 9C15.11 9 16 9.9 16 11S15.11 13 14 13 12 12.11 12 11 12.9 9 14 9M9 16C8.45 16 8 15.55 8 15S8.45 14 9 14 10 14.45 10 15 9.55 16 9 16M9 10C8.45 10 8 9.55 8 9S8.45 8 9 8 10 8.45 10 9 9.55 10 9 10Z";
var mdiCheeseOff = "M3.5 1.7L2.2 3L6.1 6.9V9C7.2 9.2 8.1 10.2 8.1 11.5S7.2 13.7 6.1 14V21L12.1 17.5C12.1 16.7 12.8 16 13.6 16C13.9 16 14.2 16.1 14.4 16.2L15.1 15.8L20.3 21L21.6 19.7L3.5 1.7M10.1 16C9.6 16 9.1 15.5 9.1 15S9.6 14 10.1 14 11.1 14.5 11.1 15 10.6 16 10.1 16M13.8 9.5L9.9 5.6C10.2 5.9 10.6 6 11.1 6C12.1 6 12.9 5.2 13.1 4.2C15.4 5.2 17.6 6.6 19.3 8.4C19.2 8.6 19.1 8.7 19.1 8.9C19.1 9.4 19.6 9.9 20.1 9.9C20.3 9.9 20.4 9.9 20.5 9.8C21 10.4 21.4 11.1 21.8 11.8L18.3 13.8L16.6 12.1C16.9 11.8 17.1 11.3 17.1 10.8C17.1 9.7 16.2 8.8 15.1 8.8C14.6 9 14.1 9.2 13.8 9.5M9.5 5.2L7.3 3C8 3 8.6 3.1 9.2 3.2C9.1 3.5 9.1 3.7 9.1 4C9.1 4.4 9.2 4.9 9.5 5.2Z";
var mdiChefHat = "M12.5,1.5C10.73,1.5 9.17,2.67 8.67,4.37C8.14,4.13 7.58,4 7,4A4,4 0 0,0 3,8C3,9.82 4.24,11.41 6,11.87V19H19V11.87C20.76,11.41 22,9.82 22,8A4,4 0 0,0 18,4C17.42,4 16.86,4.13 16.33,4.37C15.83,2.67 14.27,1.5 12.5,1.5M12,10.5H13V17.5H12V10.5M9,12.5H10V17.5H9V12.5M15,12.5H16V17.5H15V12.5M6,20V21A1,1 0 0,0 7,22H18A1,1 0 0,0 19,21V20H6Z";
var mdiChemicalWeapon = "M11,7.83C9.83,7.42 9,6.3 9,5A3,3 0 0,1 12,2A3,3 0 0,1 15,5C15,6.31 14.16,7.42 13,7.83V10.64C12.68,10.55 12.35,10.5 12,10.5C11.65,10.5 11.32,10.55 11,10.64V7.83M18.3,21.1C17.16,20.45 16.62,19.18 16.84,17.96L14.4,16.55C14.88,16.09 15.24,15.5 15.4,14.82L17.84,16.23C18.78,15.42 20.16,15.26 21.29,15.91C22.73,16.74 23.22,18.57 22.39,20C21.56,21.44 19.73,21.93 18.3,21.1M2.7,15.9C3.83,15.25 5.21,15.42 6.15,16.22L8.6,14.81C8.76,15.5 9.11,16.08 9.6,16.54L7.15,17.95C7.38,19.17 6.83,20.45 5.7,21.1C4.26,21.93 2.43,21.44 1.6,20C0.77,18.57 1.26,16.73 2.7,15.9M14,14A2,2 0 0,1 12,16C10.89,16 10,15.1 10,14A2,2 0 0,1 12,12C13.11,12 14,12.9 14,14M17,14L16.97,14.57L15.5,13.71C15.4,12.64 14.83,11.71 14,11.12V9.41C15.77,10.19 17,11.95 17,14M14.97,18.03C14.14,18.64 13.11,19 12,19C10.89,19 9.86,18.64 9.03,18L10.5,17.17C10.96,17.38 11.47,17.5 12,17.5C12.53,17.5 13.03,17.38 13.5,17.17L14.97,18.03M7.03,14.56L7,14C7,11.95 8.23,10.19 10,9.42V11.13C9.17,11.71 8.6,12.64 8.5,13.7L7.03,14.56Z";
var mdiChessBishop = "M19,22H5V20H19V22M17.16,8.26C18.22,9.63 18.86,11.28 19,13C19,15.76 15.87,18 12,18C8.13,18 5,15.76 5,13C5,10.62 7.33,6.39 10.46,5.27C10.16,4.91 10,4.46 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.46 13.84,4.91 13.54,5.27C14.4,5.6 15.18,6.1 15.84,6.74L11.29,11.29L12.71,12.71L17.16,8.26Z";
var mdiChessKing = "M19,22H5V20H19V22M17,10C15.58,10 14.26,10.77 13.55,12H13V7H16V5H13V2H11V5H8V7H11V12H10.45C9.35,10.09 6.9,9.43 5,10.54C3.07,11.64 2.42,14.09 3.5,16C4.24,17.24 5.57,18 7,18H17A4,4 0 0,0 21,14A4,4 0 0,0 17,10Z";
var mdiChessKnight = "M19,22H5V20H19V22M13,2V2C11.75,2 10.58,2.62 9.89,3.66L7,8L9,10L11.06,8.63C11.5,8.32 12.14,8.44 12.45,8.9C12.47,8.93 12.5,8.96 12.5,9V9C12.8,9.59 12.69,10.3 12.22,10.77L7.42,15.57C6.87,16.13 6.87,17.03 7.43,17.58C7.69,17.84 8.05,18 8.42,18H17V6A4,4 0 0,0 13,2Z";
var mdiChessPawn = "M19 22H5V20H19V22M16 18H8L10.18 10H8V8H10.72L10.79 7.74C10.1 7.44 9.55 6.89 9.25 6.2C8.58 4.68 9.27 2.91 10.79 2.25C12.31 1.58 14.08 2.27 14.74 3.79C15.41 5.31 14.72 7.07 13.2 7.74L13.27 8H16V10H13.82L16 18Z";
var mdiChessQueen = "M18,3A2,2 0 0,1 20,5C20,5.81 19.5,6.5 18.83,6.82L17,13.15V18H7V13.15L5.17,6.82C4.5,6.5 4,5.81 4,5A2,2 0 0,1 6,3A2,2 0 0,1 8,5C8,5.5 7.82,5.95 7.5,6.3L10.3,9.35L10.83,5.62C10.33,5.26 10,4.67 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.67 13.67,5.26 13.17,5.62L13.7,9.35L16.47,6.29C16.18,5.94 16,5.5 16,5A2,2 0 0,1 18,3M5,20H19V22H5V20Z";
var mdiChessRook = "M5,20H19V22H5V20M17,2V5H15V2H13V5H11V2H9V5H7V2H5V8H7V18H17V8H19V2H17Z";
var mdiChevronDoubleDown = "M16.59,5.59L18,7L12,13L6,7L7.41,5.59L12,10.17L16.59,5.59M16.59,11.59L18,13L12,19L6,13L7.41,11.59L12,16.17L16.59,11.59Z";
var mdiChevronDoubleLeft = "M18.41,7.41L17,6L11,12L17,18L18.41,16.59L13.83,12L18.41,7.41M12.41,7.41L11,6L5,12L11,18L12.41,16.59L7.83,12L12.41,7.41Z";
var mdiChevronDoubleRight = "M5.59,7.41L7,6L13,12L7,18L5.59,16.59L10.17,12L5.59,7.41M11.59,7.41L13,6L19,12L13,18L11.59,16.59L16.17,12L11.59,7.41Z";
var mdiChevronDoubleUp = "M7.41,18.41L6,17L12,11L18,17L16.59,18.41L12,13.83L7.41,18.41M7.41,12.41L6,11L12,5L18,11L16.59,12.41L12,7.83L7.41,12.41Z";
var mdiChevronDown = "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z";
var mdiChevronDownBox = "M19,3H5A2,2 0 0,0 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5A2,2 0 0,0 19,3M12,15.71L6,9.71L7.41,8.29L12,12.88L16.59,8.29L18,9.71L12,15.71Z";
var mdiChevronDownBoxOutline = "M19,3H5A2,2 0 0,0 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M7.41,8.29L12,12.88L16.59,8.29L18,9.71L12,15.71L6,9.71L7.41,8.29Z";
var mdiChevronDownCircle = "M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M6,10L12,16L18,10L16.6,8.6L12,13.2L7.4,8.6L6,10Z";
var mdiChevronDownCircleOutline = "M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M6,10L12,16L18,10L16.6,8.6L12,13.2L7.4,8.6L6,10Z";
var mdiChevronLeft = "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z";
var mdiChevronLeftBox = "M19,3H5A2,2 0 0,0 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5A2,2 0 0,0 19,3M15.71,16.59L14.29,18L8.29,12L14.29,6L15.71,7.41L11.12,12L15.71,16.59Z";
var mdiChevronLeftBoxOutline = "M19,3H5A2,2 0 0,0 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M15.71,7.41L11.12,12L15.71,16.59L14.29,18L8.29,12L14.29,6L15.71,7.41Z";
var mdiChevronLeftCircle = "M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M15.4,16.6L10.8,12L15.4,7.4L14,6L8,12L14,18L15.4,16.6Z";
var mdiChevronLeftCircleOutline = "M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M15.4,16.6L10.8,12L15.4,7.4L14,6L8,12L14,18L15.4,16.6Z";
var mdiChevronRight = "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z";
var mdiChevronRightBox = "M19,3H5A2,2 0 0,0 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5A2,2 0 0,0 19,3M9.71,18L8.29,16.59L12.88,12L8.29,7.41L9.71,6L15.71,12L9.71,18Z";
var mdiChevronRightBoxOutline = "M19,3H5A2,2 0 0,0 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M8.29,16.59L12.88,12L8.29,7.41L9.71,6L15.71,12L9.71,18L8.29,16.59Z";
var mdiChevronRightCircle = "M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,18L16,12L10,6L8.6,7.4L13.2,12L8.6,16.6L10,18Z";
var mdiChevronRightCircleOutline = "M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M8.6,16.6L13.2,12L8.6,7.4L10,6L16,12L10,18L8.6,16.6Z";
var mdiChevronTripleDown = "M7.41,14.58L12,19.17L16.59,14.58L18,16L12,22L6,16L7.41,14.58M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58M7.41,2.58L12,7.17L16.59,2.58L18,4L12,10L6,4L7.41,2.58Z";
var mdiChevronTripleLeft = "M9.42,7.41L4.83,12L9.42,16.59L8,18L2,12L8,6L9.42,7.41M15.42,7.41L10.83,12L15.42,16.59L14,18L8,12L14,6L15.42,7.41M21.42,7.41L16.83,12L21.42,16.59L20,18L14,12L20,6L21.42,7.41Z";
var mdiChevronTripleRight = "M14.58,16.59L19.17,12L14.58,7.41L16,6L22,12L16,18L14.58,16.59M8.58,16.59L13.17,12L8.58,7.41L10,6L16,12L10,18L8.58,16.59M2.58,16.59L7.17,12L2.58,7.41L4,6L10,12L4,18L2.58,16.59Z";
var mdiChevronTripleUp = "M16.59,9.42L12,4.83L7.41,9.42L6,8L12,2L18,8L16.59,9.42M16.59,15.42L12,10.83L7.41,15.42L6,14L12,8L18,14L16.59,15.42M16.59,21.42L12,16.83L7.41,21.42L6,20L12,14L18,20L16.59,21.42Z";
var mdiChevronUp = "M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z";
var mdiChevronUpBox = "M19,3H5A2,2 0 0,0 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5A2,2 0 0,0 19,3M16.59,15.71L12,11.12L7.41,15.71L6,14.29L12,8.29L18,14.29L16.59,15.71Z";
var mdiChevronUpBoxOutline = "M19,3H5A2,2 0 0,0 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M16.59,15.71L12,11.12L7.41,15.71L6,14.29L12,8.29L18,14.29L16.59,15.71Z";
var mdiChevronUpCircle = "M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M7.4,15.4L12,10.8L16.6,15.4L18,14L12,8L6,14L7.4,15.4Z";
var mdiChevronUpCircleOutline = "M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M7.4,15.4L12,10.8L16.6,15.4L18,14L12,8L6,14L7.4,15.4Z";
var mdiChiliAlert = "M9.25 7.5L7.73 6.63C8.26 5.7 9.03 5 9.94 4.69C9.8 4.29 9.44 4 9 4V2C10.54 2 11.79 3.16 11.97 4.65C12.91 4.94 13.72 5.66 14.27 6.63L12.75 7.5L11 6.5L9.25 7.5M14 8.28L12.75 9L11 8L9.25 9L8 8.28C7.4 8.63 7 9.27 7 10V11C7 20 15 22 15 22V10C15 9.27 14.6 8.63 14 8.28M17 7V13H19V7H17M17 17H19V15H17V17Z";
var mdiChiliAlertOutline = "M14 8.28L12.75 9L11 8L9.25 9L8 8.28C7.4 8.63 7 9.27 7 10V11C7 20 15 22 15 22V10C15 9.27 14.6 8.63 14 8.28M13 18.87C11.23 17.69 9.17 15.44 9 11.43L11 10.3L13 11.45V18.87M9.25 7.5L7.73 6.63C8.26 5.7 9.03 5 9.94 4.69C9.8 4.29 9.44 4 9 4V2C10.54 2 11.79 3.16 11.97 4.65C12.91 4.94 13.72 5.66 14.27 6.63L12.75 7.5L11 6.5L9.25 7.5M19 7V13H17V7H19M17 15H19V17H17V15Z";
var mdiChiliHot = "M10.43 7.32L8.86 6.42C9.38 5.6 10.11 5 10.94 4.7C10.81 4.3 10.45 4 10 4V2C10.77 2 11.47 2.29 12 2.77V4C12.45 4 12.81 4.3 12.94 4.7C11.83 5.08 10.93 6.05 10.43 7.32M10 11C10 10.23 10.23 9.5 10.6 8.91L9.26 8.15C8.5 8.44 8 9.16 8 10V11C8 18.05 12.9 20.8 15.03 21.66C12.41 19.62 10 16.2 10 11M6.43 7.32L4.86 6.42C5.38 5.6 6.11 5 6.94 4.7C6.81 4.3 6.45 4 6 4V2C6.77 2 7.47 2.29 8 2.77V4C8.45 4 8.81 4.3 8.94 4.7C7.83 5.08 6.93 6.05 6.43 7.32M6 11C6 10.23 6.23 9.5 6.6 8.91L5.26 8.15C4.5 8.44 4 9.16 4 10V11C4 18.05 8.9 20.8 11.03 21.66C8.41 19.62 6 16.2 6 11M19 8.28L17.75 9L16 8L14.25 9L13 8.28C12.4 8.63 12 9.27 12 10V11C12 20 20 22 20 22V10C20 9.27 19.6 8.63 19 8.28M12.73 6.63L14.25 7.5L16 6.5L17.75 7.5L19.27 6.63C18.72 5.66 17.91 4.94 16.97 4.65C16.79 3.16 15.54 2 14 2V4C14.44 4 14.8 4.29 14.94 4.69C14.03 5 13.26 5.7 12.73 6.63Z";
var mdiChiliHotOutline = "M10.94 4.7C10.81 4.3 10.45 4 10 4V2C10.77 2 11.47 2.29 12 2.77V4C12.45 4 12.81 4.3 12.94 4.7C11.83 5.08 10.93 6.05 10.43 7.32L8.86 6.42C9.38 5.6 10.11 5 10.94 4.7M10 11C10 10.23 10.23 9.5 10.6 8.91L9.26 8.15C8.5 8.44 8 9.16 8 10V11C8 18.05 12.9 20.8 15.03 21.66C12.41 19.62 10 16.2 10 11M8.94 4.7C8.81 4.3 8.45 4 8 4V2.77C7.47 2.29 6.77 2 6 2V4C6.45 4 6.81 4.3 6.94 4.7C6.11 5 5.38 5.6 4.86 6.42L6.43 7.32C6.93 6.05 7.83 5.08 8.94 4.7M6 11C6 10.23 6.23 9.5 6.6 8.91L5.26 8.15C4.5 8.44 4 9.16 4 10V11C4 18.05 8.9 20.8 11.03 21.66C8.41 19.62 6 16.2 6 11M20 10V22C20 22 12 20 12 11V10C12 9.27 12.4 8.63 13 8.28L14.25 9L16 8L17.75 9L19 8.28C19.6 8.63 20 9.27 20 10M18 18.87V11.45L16 10.3L14 11.43C14.17 15.44 16.23 17.69 18 18.87M12.73 6.63L14.25 7.5L16 6.5L17.75 7.5L19.27 6.63C18.72 5.66 17.91 4.94 16.97 4.65C16.79 3.16 15.54 2 14 2V4C14.44 4 14.8 4.29 14.94 4.69C14.03 5 13.26 5.7 12.73 6.63Z";
var mdiChiliMedium = "M8.43 7.32L6.86 6.42C7.38 5.6 8.11 5 8.94 4.7C8.81 4.3 8.45 4 8 4V2C8.77 2 9.47 2.29 10 2.77V4C10.45 4 10.81 4.3 10.94 4.7C9.83 5.08 8.93 6.05 8.43 7.32M8 11C8 10.23 8.23 9.5 8.6 8.91L7.26 8.15C6.5 8.44 6 9.16 6 10V11C6 18.05 10.9 20.8 13.03 21.66C10.41 19.62 8 16.2 8 11M17 8.28L15.75 9L14 8L12.25 9L11 8.28C10.4 8.63 10 9.27 10 10V11C10 20 18 22 18 22V10C18 9.27 17.6 8.63 17 8.28M10.73 6.63L12.25 7.5L14 6.5L15.75 7.5L17.27 6.63C16.72 5.66 15.91 4.94 14.97 4.65C14.79 3.16 13.54 2 12 2V4C12.44 4 12.8 4.29 12.94 4.69C12.03 5 11.26 5.7 10.73 6.63Z";
var mdiChiliMediumOutline = "M8.43 7.32L6.86 6.42C7.38 5.6 8.11 5 8.94 4.7C8.81 4.3 8.45 4 8 4V2C8.77 2 9.47 2.29 10 2.77V4C10.45 4 10.81 4.3 10.94 4.7C9.83 5.08 8.93 6.05 8.43 7.32M8 11C8 10.23 8.23 9.5 8.6 8.91L7.26 8.15C6.5 8.44 6 9.16 6 10V11C6 18.05 10.9 20.8 13.03 21.66C10.41 19.62 8 16.2 8 11M18 10V22C18 22 10 20 10 11V10C10 9.27 10.4 8.63 11 8.28L12.25 9L14 8L15.75 9L17 8.28C17.6 8.63 18 9.27 18 10M16 18.87V11.45L14 10.3L12 11.43C12.17 15.44 14.23 17.69 16 18.87M10.73 6.63L12.25 7.5L14 6.5L15.75 7.5L17.27 6.63C16.72 5.66 15.91 4.94 14.97 4.65C14.79 3.16 13.54 2 12 2V4C12.44 4 12.8 4.29 12.94 4.69C12.03 5 11.26 5.7 10.73 6.63Z";
var mdiChiliMild = "M16 10V22C16 22 8 20 8 11V10C8 9.27 8.4 8.63 9 8.28L10.25 9L12 8L13.75 9L15 8.28C15.6 8.63 16 9.27 16 10M12 6.5L13.75 7.5L15.27 6.63C14.72 5.66 13.91 4.94 12.97 4.65C12.79 3.16 11.54 2 10 2V4C10.44 4 10.8 4.29 10.94 4.69C10.03 5 9.26 5.7 8.73 6.63L10.25 7.5L12 6.5Z";
var mdiChiliMildOutline = "M10.25 7.5L8.73 6.63C9.26 5.7 10.03 5 10.94 4.69C10.8 4.29 10.44 4 10 4V2C11.54 2 12.79 3.16 12.97 4.65C13.91 4.94 14.72 5.66 15.27 6.63L13.75 7.5L12 6.5L10.25 7.5M16 10V22C16 22 8 20 8 11V10C8 9.27 8.4 8.63 9 8.28L10.25 9L12 8L13.75 9L15 8.28C15.6 8.63 16 9.27 16 10M14 11.45L12 10.3L10 11.43C10.17 15.44 12.23 17.69 14 18.87V11.45Z";
var mdiChiliOff = "M15 8.28C15.6 8.63 16 9.27 16 10V12.8L11.5 8.29L12 8L13.75 9L15 8.28M12 6.5L13.75 7.5L15.27 6.63C14.72 5.66 13.91 4.94 12.97 4.65C12.79 3.16 11.54 2 10 2V4C10.44 4 10.8 4.29 10.94 4.69C10.26 4.92 9.66 5.37 9.17 5.97L10.54 7.34L12 6.5M2.39 1.73L1.11 3L8 9.9C8 9.94 8 9.97 8 10V11C8 20 16 22 16 22V17.89L20.84 22.73L22.11 21.46L2.39 1.73Z";
var mdiChiliOffOutline = "M15 8.28C15.6 8.63 16 9.27 16 10V12.8L11.5 8.29L12 8L13.75 9L15 8.28M12 6.5L13.75 7.5L15.27 6.63C14.72 5.66 13.91 4.94 12.97 4.65C12.79 3.16 11.54 2 10 2V4C10.44 4 10.8 4.29 10.94 4.69C10.26 4.92 9.66 5.37 9.17 5.97L10.54 7.34L12 6.5M22.11 21.46L20.84 22.73L16 17.89V22C16 22 8 20 8 11V10C8 9.97 8 9.94 8 9.9L1.11 3L2.39 1.73L22.11 21.46M14 15.89L10.07 11.96C10.38 15.63 12.31 17.74 14 18.87V15.89Z";
var mdiChip = "M6,4H18V5H21V7H18V9H21V11H18V13H21V15H18V17H21V19H18V20H6V19H3V17H6V15H3V13H6V11H3V9H6V7H3V5H6V4M11,15V18H12V15H11M13,15V18H14V15H13M15,15V18H16V15H15Z";
var mdiChurch = "M18 12.22V9L13 6.5V5H15V3H13V1H11V3H9V5H11V6.5L6 9V12.22L2 14V22H10V19C10 17.9 10.9 17 12 17S14 17.9 14 19V22H22V14L18 12.22M12 13.5C11.17 13.5 10.5 12.83 10.5 12S11.17 10.5 12 10.5 13.5 11.17 13.5 12 12.83 13.5 12 13.5Z";
var mdiChurchOutline = "M18 12.22V9L13 6.5V5H15V3H13V1H11V3H9V5H11V6.5L6 9V12.22L2 14V22H11V18C11 17.45 11.45 17 12 17C12.55 17 13 17.45 13 18V22H22V14L18 12.22M20 20H15V17.96C15 16.27 13.65 14.9 12 14.9C10.35 14.9 9 16.27 9 17.96V20H4V15.21L8 13.4V10.05L12 8L16 10.04V13.39L20 15.2V20M12 10.5C12.83 10.5 13.5 11.17 13.5 12C13.5 12.83 12.83 13.5 12 13.5C11.17 13.5 10.5 12.83 10.5 12C10.5 11.17 11.17 10.5 12 10.5Z";
var mdiCigar = "M16 10.2H14.5A2 2 0 0 1 12.65 8.2A1.78 1.78 0 0 1 14.5 6.45V5A3.35 3.35 0 1 0 14.5 11.7H16A1.93 1.93 0 0 1 18 13.7V15H19.5V13.36A3.31 3.31 0 0 0 16 10.2M18.82 7.73A3.34 3.34 0 0 0 16.5 2V3.5A1.85 1.85 0 1 1 16.5 7.2V8.7A4 4 0 0 1 20.5 12.77V15H22V12.76A5.55 5.55 0 0 0 18.85 7.73M18 16V22H19.5V16M20.5 16V22H22V16M12 16V17.27A2 2 0 0 1 12 20.73V22H17V16M2.88 16.88A3 3 0 0 0 5 22H10V20.73A2 2 0 0 1 10 17.27V16H5A3 3 0 0 0 2.88 16.88M12 19A1 1 0 1 1 11 18A1 1 0 0 1 12 19Z";
var mdiCigarOff = "M20.84 22.73L18.11 20H18V19.89L17 18.89V20H12V18.73C12.3 18.56 12.55 18.31 12.73 18C13.28 17.05 12.96 15.83 12 15.27V14H12.11L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M14.5 9.7H16C17.07 9.66 17.96 10.5 18 11.56C18 11.61 18 11.65 18 11.7V13H19.5V11.36C19.42 9.53 17.88 8.12 16.05 8.2L16 8.2H14.5C13.45 8.12 12.65 7.25 12.65 6.2C12.67 5.22 13.5 4.43 14.46 4.45L14.5 4.45V3C12.65 3 11.15 4.5 11.15 6.35S12.65 9.7 14.5 9.7M20.5 10.7L20.5 10.77V13H22V10.76C22 8.62 20.78 6.66 18.85 5.73H18.82C19.58 5 19.9 4 19.8 3H18.32C18.34 3.11 18.35 3.23 18.35 3.35C18.35 4.37 17.5 5.2 16.5 5.2H16.5V6.7C18.71 6.7 20.5 8.5 20.5 10.7M9.27 16C9.45 15.7 9.7 15.45 10 15.27V14H5C4.21 14 3.44 14.32 2.88 14.88C1.71 16.05 1.71 17.95 2.88 19.12C3.45 19.68 4.21 20 5 20H10V18.73C9.05 18.18 8.72 16.95 9.27 16M18 14.8L19.5 16.3V14H18V14.8M20.5 17.3L22 18.8V14H20.5V17.3M11 16C10.45 16 10 16.45 10 17S10.45 18 11 18 12 17.55 12 17 11.55 16 11 16Z";
var mdiCircle = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiCircleBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M12 16C9.79 16 8 14.21 8 12S9.79 8 12 8 16 9.79 16 12 14.21 16 12 16Z";
var mdiCircleBoxOutline = "M19 5V19H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M12 8C9.79 8 8 9.79 8 12S9.79 16 12 16 16 14.21 16 12 14.21 8 12 8Z";
var mdiCircleDouble = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8Z";
var mdiCircleEditOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12H20A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4V2M18.78,3C18.61,3 18.43,3.07 18.3,3.2L17.08,4.41L19.58,6.91L20.8,5.7C21.06,5.44 21.06,5 20.8,4.75L19.25,3.2C19.12,3.07 18.95,3 18.78,3M16.37,5.12L9,12.5V15H11.5L18.87,7.62L16.37,5.12Z";
var mdiCircleExpand = "M16,4L20,8V4M20,16L16,20H20M8,20L4,16V20M4,8L8,4H4M16.95,7.05C14.22,4.32 9.78,4.32 7.05,7.05C4.32,9.78 4.32,14.22 7.05,16.95C9.78,19.68 14.22,19.68 16.95,16.95C19.68,14.22 19.68,9.79 16.95,7.05M15.85,15.85C13.72,18 10.28,18 8.15,15.85C6,13.72 6,10.28 8.15,8.15C10.28,6 13.72,6 15.85,8.15C18,10.28 18,13.72 15.85,15.85Z";
var mdiCircleHalf = "M12 2A10 10 0 0 0 2 12A10 10 0 0 0 12 22V2Z";
var mdiCircleHalfFull = "M12 2A10 10 0 0 0 2 12A10 10 0 0 0 12 22A10 10 0 0 0 22 12A10 10 0 0 0 12 2M12 4A8 8 0 0 1 20 12A8 8 0 0 1 12 20V4Z";
var mdiCircleMedium = "M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z";
var mdiCircleMultiple = "M15 4A8 8 0 1 1 7 12A8 8 0 0 1 15 4M3 12A6 6 0 0 0 7 17.65V19.74A8 8 0 0 1 7 4.26V6.35A6 6 0 0 0 3 12Z";
var mdiCircleMultipleOutline = "M15,4A8,8 0 0,1 23,12A8,8 0 0,1 15,20A8,8 0 0,1 7,12A8,8 0 0,1 15,4M15,18A6,6 0 0,0 21,12A6,6 0 0,0 15,6A6,6 0 0,0 9,12A6,6 0 0,0 15,18M3,12C3,14.61 4.67,16.83 7,17.65V19.74C3.55,18.85 1,15.73 1,12C1,8.27 3.55,5.15 7,4.26V6.35C4.67,7.17 3,9.39 3,12Z";
var mdiCircleOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L4.06 5.95C2.78 7.63 2 9.72 2 12C2 17.5 6.5 22 12 22C14.28 22 16.37 21.23 18.05 19.94L20.84 22.73L22.11 21.46M12 20C7.58 20 4 16.42 4 12C4 10.27 4.56 8.68 5.5 7.38L16.62 18.5C15.32 19.45 13.73 20 12 20M8.17 4.97L6.72 3.5C8.25 2.56 10.06 2 12 2C17.5 2 22 6.5 22 12C22 13.94 21.44 15.75 20.5 17.28L19.03 15.83C19.65 14.69 20 13.39 20 12C20 7.58 16.42 4 12 4C10.61 4 9.31 4.35 8.17 4.97Z";
var mdiCircleOpacity = "M18 10V8H20V10H18M18 12V10H16V12H18M18 8V6H16V8H18M16 2.84V4H18C17.37 3.54 16.71 3.15 16 2.84M18 4V6H20C19.42 5.25 18.75 4.58 18 4M20 6V8H21.16C20.85 7.29 20.46 6.63 20 6M22 12C22 11.32 21.93 10.65 21.8 10H20V12H22M16 6V4H14V6H16M16 16H18V14H16V16M18 18H20L20 18V16H18V18M16 20H18L18 20V18H16V20M14 21.8C14.7 21.66 15.36 21.44 16 21.16V20H14V21.8M18 14H20V12H18V14M16 8H14V10H16V8M20 16H21.16C21.44 15.36 21.66 14.7 21.8 14H20V16M16 12H14V14H16V12M12 18V16H14V14H12V12H14V10H12V8H14V6H12V4H14V2.2C13.35 2.07 12.69 2 12 2C6.5 2 2 6.5 2 12S6.5 22 12 22V20H14V18H12M14 18H16V16H14V18Z";
var mdiCircleOutline = "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiCircleSlice1 = "M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4M12 5C13.93 5 15.68 5.78 16.95 7.05L12 12V5Z";
var mdiCircleSlice2 = "M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4M12 5C15.87 5 19 8.13 19 12H12V5Z";
var mdiCircleSlice3 = "M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4M12 5C15.87 5 19 8.13 19 12C19 13.93 18.22 15.68 16.95 16.95L12 12V5Z";
var mdiCircleSlice4 = "M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4M12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19V5Z";
var mdiCircleSlice5 = "M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4M12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19C10.07 19 8.32 18.22 7.05 16.95L12 12V5Z";
var mdiCircleSlice6 = "M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4M12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19C8.13 19 5 15.87 5 12H12V5Z";
var mdiCircleSlice7 = "M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4M12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19C8.13 19 5 15.87 5 12C5 10.07 5.78 8.32 7.05 7.05L12 12V5Z";
var mdiCircleSlice8 = "M12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4Z";
var mdiCircleSmall = "M12,10A2,2 0 0,0 10,12C10,13.11 10.9,14 12,14C13.11,14 14,13.11 14,12A2,2 0 0,0 12,10Z";
var mdiCircularSaw = "M13,11A1,1 0 0,1 14,12A1,1 0 0,1 13,13A1,1 0 0,1 12,12A1,1 0 0,1 13,11M7.86,6.25C9.14,4.87 10.97,4 13,4C16.5,4 19.44,6.61 19.93,10H22V12H16A3,3 0 0,0 13,9A3,3 0 0,0 10,12H2V10H2.05C2.25,7.73 3.14,5.66 4.5,4L7.86,6.25M6.73,7.89L5.06,6.77C4.53,7.75 4.18,8.84 4.06,10H6.07C6.18,9.25 6.4,8.54 6.73,7.89M7.4,15.4L6,14H11.79C12.03,14.42 12.5,14.7 13,14.7C13.5,14.7 13.97,14.42 14.21,14H20V15.4C18.39,14.42 18.46,15.75 18.46,15.75V17.71L16.5,19.67C16,17.92 15.1,18.9 15.1,18.9L13.7,20.3H10.9C11.88,18.69 10.55,18.76 10.55,18.76H8.59L6.63,16.8C8.38,16.31 7.4,15.4 7.4,15.4Z";
var mdiCity = "M19,15H17V13H19M19,19H17V17H19M13,7H11V5H13M13,11H11V9H13M13,15H11V13H13M13,19H11V17H13M7,11H5V9H7M7,15H5V13H7M7,19H5V17H7M15,11V5L12,2L9,5V7H3V21H21V11H15Z";
var mdiCitySwitch = "M21 15V9H15V3L12 0L9 3V5H3V15H21M19 13H17V11H19V13M11 5V3H13V5H11M11 9V7H13V9H11M11 13V11H13V13H11M7 9H5V7H7V9M7 13H5V11H7V13M9 17V19H15V17L18 20L15 23V21H9V23L6 20L9 17Z";
var mdiCityVariant = "M19,9V7A2,2 0 0,0 17,5H16V2H14V5H13A2,2 0 0,0 11,7V9A2,2 0 0,0 9,11V12H5A2,2 0 0,0 3,14V22H6V20H8V22H12V20H14V22H16V20H18V22H21V11A2,2 0 0,0 19,9M8,18H6V16H8V18M14,18H12V16H14V18M14,14H12V12H14V14M13,9V7H17V9H13M18,18H16V16H18V18M18,14H16V12H18V14Z";
var mdiCityVariantOutline = "M15,23H13V21H15V23M19,21H17V23H19V21M15,17H13V19H15V17M7,21H5V23H7V21M7,17H5V19H7V17M19,17H17V19H19V17M15,13H13V15H15V13M19,13H17V15H19V13M21,9A2,2 0 0,1 23,11V23H21V11H11V23H9V15H3V23H1V15A2,2 0 0,1 3,13H9V11A2,2 0 0,1 11,9V7A2,2 0 0,1 13,5H15V1H17V5H19A2,2 0 0,1 21,7V9M19,9V7H13V9H19Z";
var mdiClipboard = "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3";
var mdiClipboardAccount = "M18,19H6V17.6C6,15.6 10,14.5 12,14.5C14,14.5 18,15.6 18,17.6M12,7A3,3 0 0,1 15,10A3,3 0 0,1 12,13A3,3 0 0,1 9,10A3,3 0 0,1 12,7M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiClipboardAccountOutline = "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H9.18C9.6,1.84 10.7,1 12,1C13.3,1 14.4,1.84 14.82,3H19M12,3A1,1 0 0,0 11,4A1,1 0 0,0 12,5A1,1 0 0,0 13,4A1,1 0 0,0 12,3M7,7V5H5V19H19V5H17V7H7M12,9A2,2 0 0,1 14,11A2,2 0 0,1 12,13A2,2 0 0,1 10,11A2,2 0 0,1 12,9M8,17V16C8,14.9 9.79,14 12,14C14.21,14 16,14.9 16,16V17H8Z";
var mdiClipboardAlert = "M12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5M13,14H11V8H13M13,18H11V16H13M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiClipboardAlertOutline = "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H9.18C9.6,1.84 10.7,1 12,1C13.3,1 14.4,1.84 14.82,3H19M12,3A1,1 0 0,0 11,4A1,1 0 0,0 12,5A1,1 0 0,0 13,4A1,1 0 0,0 12,3M7,7V5H5V19H19V5H17V7H7M11,9H13V13.5H11V9M11,15H13V17H11V15Z";
var mdiClipboardArrowDown = "M12,18L7,13H10V9H14V13H17M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiClipboardArrowDownOutline = "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H9.18C9.6,1.84 10.7,1 12,1C13.3,1 14.4,1.84 14.82,3H19M12,3A1,1 0 0,0 11,4A1,1 0 0,0 12,5A1,1 0 0,0 13,4A1,1 0 0,0 12,3M7,7V5H5V19H19V5H17V7H7M12,18L7,13H10V9H14V13H17L12,18Z";
var mdiClipboardArrowLeft = "M16,15H12V18L7,13L12,8V11H16M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiClipboardArrowLeftOutline = "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H9.18C9.6,1.84 10.7,1 12,1C13.3,1 14.4,1.84 14.82,3H19M12,3A1,1 0 0,0 11,4A1,1 0 0,0 12,5A1,1 0 0,0 13,4A1,1 0 0,0 12,3M7,7V5H5V19H19V5H17V7H7M7,13L12,18V15H16V11H12V8L7,13Z";
var mdiClipboardArrowRight = "M17,13L12,18V15H8V11H12V8M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiClipboardArrowRightOutline = "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H9.18C9.6,1.84 10.7,1 12,1C13.3,1 14.4,1.84 14.82,3H19M12,3A1,1 0 0,0 11,4A1,1 0 0,0 12,5A1,1 0 0,0 13,4A1,1 0 0,0 12,3M7,7V5H5V19H19V5H17V7H7M16.91,13L11.91,18V15H7.91V11H11.91V8L16.91,13Z";
var mdiClipboardArrowUp = "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H9.18C9.6,1.84 10.7,1 12,1C13.3,1 14.4,1.84 14.82,3H19M12,8L7,13H10V17H14V13H17L12,8M12,3A1,1 0 0,0 11,4A1,1 0 0,0 12,5A1,1 0 0,0 13,4A1,1 0 0,0 12,3Z";
var mdiClipboardArrowUpOutline = "M12,8L17,13H14V17H10V13H7L12,8M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H9.18C9.6,1.84 10.7,1 12,1C13.3,1 14.4,1.84 14.82,3H19M12,3A1,1 0 0,0 11,4A1,1 0 0,0 12,5A1,1 0 0,0 13,4A1,1 0 0,0 12,3M7,7V5H5V19H19V5H17V7H7Z";
var mdiClipboardCheck = "M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiClipboardCheckMultiple = "M4 7H2V21C2 22.1 2.9 23 4 23H18V21H4M20 3H16.8C16.4 1.8 15.3 1 14 1C12.7 1 11.6 1.8 11.2 3H8C6.9 3 6 3.9 6 5V17C6 18.1 6.9 19 8 19H20C21.1 19 22 18.1 22 17V5C22 3.9 21.1 3 20 3M14 3C14.6 3 15 3.5 15 4C15 4.5 14.5 5 14 5C13.5 5 13 4.5 13 4C13 3.5 13.4 3 14 3M12.3 15.1L9 11.8L10.4 10.4L12.3 12.3L17.6 7L19 8.4";
var mdiClipboardCheckMultipleOutline = "M4 7V21H18V23H4C2.9 23 2 22.1 2 21V7H4M12.8 15.35L9.5 12.05L10.9 10.65L12.8 12.55L17.1 8.25L18.5 9.65L12.8 15.35M20 3C21.1 3 22 3.9 22 5V17C22 18.1 21.1 19 20 19H8C6.9 19 6 18.1 6 17V5C6 3.9 6.9 3 8 3H11.18C11.6 1.84 12.7 1 14 1C15.3 1 16.4 1.84 16.82 3H20M14 3C13.45 3 13 3.45 13 4C13 4.55 13.45 5 14 5C14.55 5 15 4.55 15 4C15 3.45 14.55 3 14 3M10 7V5H8V17H20V5H18V7H10Z";
var mdiClipboardCheckOutline = "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M7,7H17V5H19V19H5V5H7V7M7.5,13.5L9,12L11,14L15.5,9.5L17,11L11,17L7.5,13.5Z";
var mdiClipboardClock = "M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25M23 16C23 19.87 19.87 23 16 23C14.09 23 12.37 22.24 11.11 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H9.18C9.6 1.84 10.7 1 12 1S14.4 1.84 14.82 3H19C20.11 3 21 3.9 21 5V11.11C22.24 12.37 23 14.09 23 16M11 4C11 4.55 11.45 5 12 5S13 4.55 13 4 12.55 3 12 3 11 3.45 11 4M21 16C21 13.24 18.76 11 16 11S11 13.24 11 16 13.24 21 16 21 21 18.76 21 16Z";
var mdiClipboardClockOutline = "M21 11.11V5C21 3.9 20.11 3 19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H11.11C12.37 22.24 14.09 23 16 23C19.87 23 23 19.87 23 16C23 14.09 22.24 12.37 21 11.11M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M5 19V5H7V7H17V5H19V9.68C18.09 9.25 17.08 9 16 9C12.13 9 9 12.13 9 16C9 17.08 9.25 18.09 9.68 19H5M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25Z";
var mdiClipboardEdit = "M21.04 12.13C21.18 12.13 21.31 12.19 21.42 12.3L22.7 13.58C22.92 13.79 22.92 14.14 22.7 14.35L21.7 15.35L19.65 13.3L20.65 12.3C20.76 12.19 20.9 12.13 21.04 12.13M19.07 13.88L21.12 15.93L15.06 22H13V19.94L19.07 13.88M19 3C20.1 3 21 3.9 21 5V9L11 19V21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H9.18C9.6 1.84 10.7 1 12 1C13.3 1 14.4 1.84 14.82 3H19M12 3C11.45 3 11 3.45 11 4C11 4.55 11.45 5 12 5C12.55 5 13 4.55 13 4C13 3.45 12.55 3 12 3Z";
var mdiClipboardEditOutline = "M21.04 12.13C21.18 12.13 21.31 12.19 21.42 12.3L22.7 13.58C22.92 13.79 22.92 14.14 22.7 14.35L21.7 15.35L19.65 13.3L20.65 12.3C20.76 12.19 20.9 12.13 21.04 12.13M19.07 13.88L21.12 15.93L15.06 22H13V19.94L19.07 13.88M11 19L9 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H9.18C9.6 1.84 10.7 1 12 1C13.3 1 14.4 1.84 14.82 3H19C20.1 3 21 3.9 21 5V9L19 11V5H17V7H7V5H5V19H11M12 3C11.45 3 11 3.45 11 4C11 4.55 11.45 5 12 5C12.55 5 13 4.55 13 4C13 3.45 12.55 3 12 3Z";
var mdiClipboardFile = "M19 3C20.1 3 21 3.9 21 5V9.17L19.83 8H15C12.79 8 11 9.79 11 12V21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H9.18C9.6 1.84 10.7 1 12 1C13.3 1 14.4 1.84 14.82 3H19M12 3C11.45 3 11 3.45 11 4C11 4.55 11.45 5 12 5C12.55 5 13 4.55 13 4C13 3.45 12.55 3 12 3M15 23C13.9 23 13 22.11 13 21V12C13 10.9 13.9 10 15 10H19L23 14V21C23 22.11 22.11 23 21 23H15M21 14.83L18.17 12H18V15H21V14.83Z";
var mdiClipboardFileOutline = "M15 23C13.9 23 13 22.11 13 21V12C13 10.9 13.9 10 15 10H19L23 14V21C23 22.11 22.11 23 21 23H15M15 21H21V14.83L18.17 12H15V21M19 3C20.1 3 21 3.9 21 5V9.17L19.83 8H19V5H17V7H7V5H5V19H11V21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H9.18C9.6 1.84 10.7 1 12 1C13.3 1 14.4 1.84 14.82 3H19M12 3C11.45 3 11 3.45 11 4C11 4.55 11.45 5 12 5C12.55 5 13 4.55 13 4C13 3.45 12.55 3 12 3Z";
var mdiClipboardFlow = "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M15,19L11,15H14V8H16V15H19L15,19M10,16H8V9H5L9,5L13,9H10V16";
var mdiClipboardFlowOutline = "M19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M7 7H17V5H19V19H5V5H7V7M10 16H8V11H6L9 8L12 11H10V16M14 10H16V15H18L15 18L12 15H14V10Z";
var mdiClipboardList = "M19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M7 8H9V12H8V9H7V8M10 17V18H7V17.08L9 15H7V14H9.25C9.66 14 10 14.34 10 14.75C10 14.95 9.92 15.14 9.79 15.27L8.12 17H10M11 4C11 3.45 11.45 3 12 3S13 3.45 13 4 12.55 5 12 5 11 4.55 11 4M17 17H12V15H17V17M17 11H12V9H17V11Z";
var mdiClipboardListOutline = "M19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M7 7H17V5H19V19H5V5H7V7M12 17V15H17V17H12M12 11V9H17V11H12M8 12V9H7V8H9V12H8M9.25 14C9.66 14 10 14.34 10 14.75C10 14.95 9.92 15.14 9.79 15.27L8.12 17H10V18H7V17.08L9 15H7V14H9.25";
var mdiClipboardMinus = "M19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M16 14H8V12H16V14Z";
var mdiClipboardMinusOutline = "M19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M19 19H5V5H7V7H17V5H19V19M8 12H16V14H8V12Z";
var mdiClipboardMultiple = "M4 7H2V21C2 22.1 2.9 23 4 23H18V21H4M20 3H16.8C16.4 1.8 15.3 1 14 1C12.7 1 11.6 1.8 11.2 3H8C6.9 3 6 3.9 6 5V17C6 18.1 6.9 19 8 19H20C21.1 19 22 18.1 22 17V5C22 3.9 21.1 3 20 3M14 3C14.6 3 15 3.5 15 4C15 4.5 14.5 5 14 5C13.5 5 13 4.5 13 4C13 3.5 13.4 3 14 3Z";
var mdiClipboardMultipleOutline = "M4 7V21H18V23H4C2.9 23 2 22.1 2 21V7H4M20 3C21.1 3 22 3.9 22 5V17C22 18.1 21.1 19 20 19H8C6.9 19 6 18.1 6 17V5C6 3.9 6.9 3 8 3H11.18C11.6 1.84 12.7 1 14 1C15.3 1 16.4 1.84 16.82 3H20M14 3C13.45 3 13 3.45 13 4C13 4.55 13.45 5 14 5C14.55 5 15 4.55 15 4C15 3.45 14.55 3 14 3M10 7V5H8V17H20V5H18V7H10Z";
var mdiClipboardOff = "M21 5C21 3.9 20.11 3 19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H6.2L21 17.8V5M12 5C11.45 5 11 4.55 11 4S11.45 3 12 3 13 3.45 13 4 12.55 5 12 5M22.11 21.46L20.84 22.73L19.1 21C19.07 21 19.03 21 19 21H5C3.9 21 3 20.11 3 19V5C3 4.97 3 4.93 3 4.9L1.11 3L2.39 1.73L22.11 21.46Z";
var mdiClipboardOffOutline = "M2.39 1.73L1.11 3L3 4.9C3 4.93 3 4.97 3 5V19C3 20.11 3.9 21 5 21H19C19.03 21 19.07 21 19.1 21L20.84 22.73L22.11 21.46L2.39 1.73M5 19V6.89L17.11 19H5M17 7V5H19V15.8L21 17.8V5C21 3.9 20.11 3 19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H6.2L10.2 7H17M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3Z";
var mdiClipboardOutline = "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M7,7H17V5H19V19H5V5H7V7Z";
var mdiClipboardPlay = "M19,3H14.82C14.25,1.44 12.53,0.64 11,1.2C10.14,1.5 9.5,2.16 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M10,17V9L15,13L10,17Z";
var mdiClipboardPlayMultiple = "M4 21H18V23H4C2.9 23 2 22.1 2 21V7H4M22 5V17C22 18.1 21.1 19 20 19H8C6.9 19 6 18.1 6 17V5C6 3.9 6.9 3 8 3H11.2C11.6 1.8 12.7 1 14 1C15.3 1 16.4 1.8 16.8 3H20C21.1 3 22 3.9 22 5M13 4C13 4.5 13.5 5 14 5C14.5 5 15 4.5 15 4C15 3.5 14.6 3 14 3C13.4 3 13 3.5 13 4M17 12L12 8V16";
var mdiClipboardPlayMultipleOutline = "M4 7V21H18V23H4C2.9 23 2 22.1 2 21V7H4M20 3C21.1 3 22 3.9 22 5V17C22 18.1 21.1 19 20 19H8C6.9 19 6 18.1 6 17V5C6 3.9 6.9 3 8 3H11.2C11.6 1.8 12.7 1 14 1C15.3 1 16.4 1.8 16.8 3H20M14 3C13.4 3 13 3.5 13 4C13 4.5 13.4 5 14 5C14.6 5 15 4.6 15 4C15 3.4 14.6 3 14 3M10 7V5H8V17H20V5H18V7M12 15V9L17 12";
var mdiClipboardPlayOutline = "M19,3H14.82C14.25,1.44 12.53,0.64 11,1.2C10.14,1.5 9.5,2.16 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M7,7H17V5H19V19H5V5H7V7M10,17V9L15,13L10,17Z";
var mdiClipboardPlus = "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M13,12H16V14H13V17H11V14H8V12H11V9H13V12Z";
var mdiClipboardPlusOutline = "M19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M7 7H17V5H19V19H5V5H7V7M13 12H16V14H13V17H11V14H8V12H11V9H13V12Z";
var mdiClipboardPulse = "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M5,13.46H7.17L10.5,7.08L11.44,14.05L13.93,10.86L16.53,13.46H19V15H15.89L14.07,13.21L10.38,17.92L9.62,12.15L8.11,15H5V13.46Z";
var mdiClipboardPulseOutline = "M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M5,15H8.11L9.62,12.15L10.38,17.92L14.07,13.21L15.89,15H19V19H5V15M19,13.46H16.53L13.93,10.86L11.44,14.05L10.5,7.08L7.17,13.46H5V5H7V6H17V5H19V6L19,13.46Z";
var mdiClipboardRemove = "M19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M15.54 15.12L14.12 16.54L12 14.41L9.88 16.54L8.47 15.12L10.59 13L8.47 10.88L9.88 9.47L12 11.59L14.12 9.47L15.54 10.88L13.41 13L15.54 15.12Z";
var mdiClipboardRemoveOutline = "M19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M19 19H5V5H7V7H17V5H19V19M15.54 10.88L13.41 13L15.54 15.12L14.12 16.54L12 14.41L9.88 16.54L8.47 15.12L10.59 13L8.47 10.88L9.88 9.47L12 11.59L14.12 9.47L15.54 10.88Z";
var mdiClipboardSearch = "M11.9 10.9C14.41 8.4 18.45 8.37 21 10.82V5C21 3.9 20.11 3 19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H13.06C12.65 20.74 12.26 20.45 11.9 20.1C9.37 17.56 9.37 13.44 11.9 10.9M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M20.31 17.9C20.75 17.21 21 16.38 21 15.5C21 13 19 11 16.5 11S12 13 12 15.5 14 20 16.5 20C17.37 20 18.19 19.75 18.88 19.32L22 22.39L23.39 21L20.31 17.9M16.5 18C15.12 18 14 16.88 14 15.5S15.12 13 16.5 13 19 14.12 19 15.5 17.88 18 16.5 18Z";
var mdiClipboardSearchOutline = "M11.03 19H5V5H7V7H17V5H19V9.5C19.72 9.8 20.4 10.24 21 10.82V5C21 3.9 20.11 3 19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H13.06C12.65 20.74 12.26 20.45 11.9 20.1C11.57 19.76 11.27 19.39 11.03 19M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M20.31 17.9C20.75 17.21 21 16.38 21 15.5C21 13 19 11 16.5 11S12 13 12 15.5 14 20 16.5 20C17.37 20 18.19 19.75 18.88 19.32L22 22.39L23.39 21L20.31 17.9M16.5 18C15.12 18 14 16.88 14 15.5S15.12 13 16.5 13 19 14.12 19 15.5 17.88 18 16.5 18Z";
var mdiClipboardText = "M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiClipboardTextClock = "M21 11.11V5C21 3.9 20.11 3 19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H11.11C12.37 22.24 14.09 23 16 23C19.87 23 23 19.87 23 16C23 14.09 22.24 12.37 21 11.11M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M6 7H18V9H6V7M9.08 17H6V15H9.08C9.03 15.33 9 15.66 9 16S9.03 16.67 9.08 17M6 13V11H11.11C10.5 11.57 10.04 12.25 9.68 13H6M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25Z";
var mdiClipboardTextClockOutline = "M21 11.11V5C21 3.9 20.11 3 19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H11.11C12.37 22.24 14.09 23 16 23C19.87 23 23 19.87 23 16C23 14.09 22.24 12.37 21 11.11M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M5 19V5H7V7H17V5H19V9.68C18.09 9.25 17.08 9 16 9H7V11H11.1C10.5 11.57 10.04 12.25 9.68 13H7V15H9.08C9.03 15.33 9 15.66 9 16C9 17.08 9.25 18.09 9.68 19H5M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25Z";
var mdiClipboardTextMultiple = "M20 3H16.8C16.4 1.8 15.3 1 14 1C12.7 1 11.6 1.8 11.2 3H8C6.9 3 6 3.9 6 5V17C6 18.1 6.9 19 8 19H20C21.1 19 22 18.1 22 17V5C22 3.9 21.1 3 20 3M14 3C14.6 3 15 3.5 15 4C15 4.5 14.5 5 14 5C13.5 5 13 4.5 13 4C13 3.5 13.4 3 14 3M16 14H9V12H16M19 10H9V8H19M4 21H18V23H4C2.9 23 2 22.1 2 21V7H4";
var mdiClipboardTextMultipleOutline = "M4 7V21H18V23H4C2.9 23 2 22.1 2 21V7H4M20 3C21.1 3 22 3.9 22 5V17C22 18.1 21.1 19 20 19H8C6.9 19 6 18.1 6 17V5C6 3.9 6.9 3 8 3H11.18C11.6 1.84 12.7 1 14 1C15.3 1 16.4 1.84 16.82 3H20M14 3C13.45 3 13 3.45 13 4C13 4.55 13.45 5 14 5C14.55 5 15 4.55 15 4C15 3.45 14.55 3 14 3M10 7V5H8V17H20V5H18V7M15 15H10V13H15M18 11H10V9H18V11Z";
var mdiClipboardTextOff = "M2.39 1.73L1.11 3L3 4.9C3 4.93 3 4.97 3 5V19C3 20.11 3.9 21 5 21H19C19.03 21 19.07 21 19.1 21L20.84 22.73L22.11 21.46L2.39 1.73M7 11H9.11L11.11 13H7V11M14 17H7V15H13.11L14 15.89V17M17 7V9H12.2L14.2 11H17V13H16.2L21 17.8V5C21 3.9 20.11 3 19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H6.2L10.2 7H17M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3Z";
var mdiClipboardTextOffOutline = "M17 7V5H19V15.8L21 17.8V5C21 3.9 20.11 3 19 3H14.82C14.25 1.44 12.53 .64 11 1.2C10.14 1.5 9.5 2.16 9.18 3H6.2L10.2 7H17M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M14.2 11L12.2 9H17V11H14.2M2.39 1.73L1.11 3L3 4.9C3 4.93 3 4.97 3 5V19C3 20.11 3.9 21 5 21H19C19.03 21 19.07 21 19.1 21L20.84 22.73L22.11 21.46L2.39 1.73M5 19V6.89L7.11 9H7V11H9.11L11.11 13H7V15H13.11L17.11 19H5Z";
var mdiClipboardTextOutline = "M19,3H14.82C14.25,1.44 12.53,0.64 11,1.2C10.14,1.5 9.5,2.16 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M7,7H17V5H19V19H5V5H7V7M17,11H7V9H17V11M15,15H7V13H15V15Z";
var mdiClipboardTextPlay = "M19,3A2,2 0 0,1 21,5V13.34C20.36,13.11 19.68,13 19,13C15.68,13 13,15.69 13,19C13,19.68 13.11,20.36 13.34,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H9.18C9.5,2.16 10.14,1.5 11,1.2C12.53,0.64 14.25,1.44 14.82,3H19M12,3A1,1 0 0,0 11,4A1,1 0 0,0 12,5A1,1 0 0,0 13,4A1,1 0 0,0 12,3M11,17V15H7V17H11M13,13V11H7V13H13M17,9V7H7V9H17M17,16L22,19L17,22V16Z";
var mdiClipboardTextPlayOutline = "M19,3H14.82C14.25,1.44 12.53,0.64 11,1.2C10.14,1.5 9.5,2.16 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H15V19H5V5H7V7H17V5H19V14H21V5A2,2 0 0,0 19,3M12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5M17,16V22L22,19L17,16M17,11H7V9H17V11M15,15H7V13H15V15Z";
var mdiClipboardTextSearch = "M10.18 17H7V15H10C10.08 14.32 10.23 13.64 10.5 13H7V11H11.82C11.85 10.97 11.87 10.94 11.9 10.9C13.17 9.64 14.84 9 16.5 9H7V7H17V9H16.5C18.12 9 19.74 9.61 21 10.82V5C21 3.9 20.11 3 19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H13.06C12.65 20.74 12.26 20.45 11.9 20.1C11 19.21 10.45 18.13 10.18 17M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M20.31 17.9C20.75 17.21 21 16.38 21 15.5C21 13 19 11 16.5 11S12 13 12 15.5 14 20 16.5 20C17.37 20 18.19 19.75 18.88 19.32L22 22.39L23.39 21L20.31 17.9M16.5 18C15.12 18 14 16.88 14 15.5S15.12 13 16.5 13 19 14.12 19 15.5 17.88 18 16.5 18Z";
var mdiClipboardTextSearchOutline = "M17 9H16.5 17M7 15H10C10.08 14.32 10.23 13.64 10.5 13H7V15M11.9 10.9C13.17 9.64 14.84 9 16.5 9H7V11H11.82C11.85 10.97 11.87 10.94 11.9 10.9M11.9 20.1C12.26 20.45 12.65 20.74 13.06 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H9.18C9.5 2.16 10.14 1.5 11 1.2C12.53 .64 14.25 1.44 14.82 3H19C20.11 3 21 3.9 21 5V10.82C20.4 10.24 19.72 9.8 19 9.5V5H17V7H7V5H5V19H11.03C11.27 19.39 11.57 19.76 11.9 20.1M11 4C11 4.55 11.45 5 12 5S13 4.55 13 4 12.55 3 12 3 11 3.45 11 4M23.39 21L22 22.39L18.88 19.32C18.19 19.75 17.37 20 16.5 20C14 20 12 18 12 15.5S14 11 16.5 11 21 13 21 15.5C21 16.38 20.75 17.21 20.31 17.9L23.39 21M19 15.5C19 14.12 17.88 13 16.5 13S14 14.12 14 15.5 15.12 18 16.5 18 19 16.88 19 15.5Z";
var mdiClippy = "M15,15.5A2.5,2.5 0 0,1 12.5,18A2.5,2.5 0 0,1 10,15.5V13.75A0.75,0.75 0 0,1 10.75,13A0.75,0.75 0 0,1 11.5,13.75V15.5A1,1 0 0,0 12.5,16.5A1,1 0 0,0 13.5,15.5V11.89C12.63,11.61 12,10.87 12,10C12,8.9 13,8 14.25,8C15.5,8 16.5,8.9 16.5,10C16.5,10.87 15.87,11.61 15,11.89V15.5M8.25,8C9.5,8 10.5,8.9 10.5,10C10.5,10.87 9.87,11.61 9,11.89V17.25A3.25,3.25 0 0,0 12.25,20.5A3.25,3.25 0 0,0 15.5,17.25V13.75A0.75,0.75 0 0,1 16.25,13A0.75,0.75 0 0,1 17,13.75V17.25A4.75,4.75 0 0,1 12.25,22A4.75,4.75 0 0,1 7.5,17.25V11.89C6.63,11.61 6,10.87 6,10C6,8.9 7,8 8.25,8M10.06,6.13L9.63,7.59C9.22,7.37 8.75,7.25 8.25,7.25C7.34,7.25 6.53,7.65 6.03,8.27L4.83,7.37C5.46,6.57 6.41,6 7.5,5.81V5.75A3.75,3.75 0 0,1 11.25,2A3.75,3.75 0 0,1 15,5.75V5.81C16.09,6 17.04,6.57 17.67,7.37L16.47,8.27C15.97,7.65 15.16,7.25 14.25,7.25C13.75,7.25 13.28,7.37 12.87,7.59L12.44,6.13C12.77,6 13.13,5.87 13.5,5.81V5.75C13.5,4.5 12.5,3.5 11.25,3.5C10,3.5 9,4.5 9,5.75V5.81C9.37,5.87 9.73,6 10.06,6.13M14.25,9.25C13.7,9.25 13.25,9.59 13.25,10C13.25,10.41 13.7,10.75 14.25,10.75C14.8,10.75 15.25,10.41 15.25,10C15.25,9.59 14.8,9.25 14.25,9.25M8.25,9.25C7.7,9.25 7.25,9.59 7.25,10C7.25,10.41 7.7,10.75 8.25,10.75C8.8,10.75 9.25,10.41 9.25,10C9.25,9.59 8.8,9.25 8.25,9.25Z";
var mdiClock = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z";
var mdiClockAlert = "M20 12H22V18H20V12M20 20H22V22H20V20M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22C14.3 22 16.3 21.2 18 20V10H21.8C20.9 5.4 16.8 2 12 2M16.2 16.2L11 13V7H12.5V12.2L17 14.9L16.2 16.2Z";
var mdiClockAlertOutline = "M11 7V13L16.2 16.1L17 14.9L12.5 12.2V7H11M20 12V18H22V12H20M20 20V22H22V20H20M18 20C16.3 21.3 14.3 22 12 22C6.5 22 2 17.5 2 12S6.5 2 12 2C16.8 2 20.9 5.4 21.8 10H19.7C18.8 6.6 15.7 4 12 4C7.6 4 4 7.6 4 12S7.6 20 12 20C14.4 20 16.5 18.9 18 17.3V20Z";
var mdiClockCheck = "M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M13 19C13 17.5 13.5 16.2 14.4 15.1L11 13V7H12.5V12.2L15.6 14.1C16.6 13.4 17.7 13 19 13C20 13 21 13.3 21.8 13.7C21.9 13.1 22 12.6 22 12C22 6.5 17.5 2 12 2S2 6.5 2 12 6.5 22 12 22C12.6 22 13.2 21.9 13.7 21.8C13.3 21 13 20 13 19Z";
var mdiClockCheckOutline = "M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M13.1 19.9C12.7 20 12.4 20 12 20C7.6 20 4 16.4 4 12S7.6 4 12 4 20 7.6 20 12C20 12.4 20 12.7 19.9 13.1C20.6 13.2 21.2 13.4 21.8 13.7C21.9 13.1 22 12.6 22 12C22 6.5 17.5 2 12 2S2 6.5 2 12C2 17.5 6.5 22 12 22C12.6 22 13.2 21.9 13.7 21.8C13.4 21.3 13.2 20.6 13.1 19.9M15.6 14.1L12.5 12.3V7H11V13L14.5 15.1C14.8 14.7 15.2 14.4 15.6 14.1Z";
var mdiClockDigital = "M2,6A2,2 0 0,0 0,8V16A2,2 0 0,0 2,18H22A2,2 0 0,0 24,16V8A2,2 0 0,0 22,6M2,8H22V16H2M3,9V10.5H6.25L3,15H4.75L8,10.5V9M9.25,9V10.5H10.75V9M12,9V10.5H13.5V15H15V9M17,9A1,1 0 0,0 16,10V14A1,1 0 0,0 17,15H20A1,1 0 0,0 21,14V10A1,1 0 0,0 20,9M17.5,10.5H19.5V13.5H17.5M9.25,13.5V15H10.75V13.5";
var mdiClockEdit = "M21 13.1C20.9 13.1 20.7 13.2 20.6 13.3L19.6 14.3L21.7 16.4L22.7 15.4C22.9 15.2 22.9 14.8 22.7 14.6L21.4 13.3C21.3 13.2 21.2 13.1 21 13.1M19.1 14.9L13 20.9V23H15.1L21.2 16.9L19.1 14.9M11 21.9C5.9 21.4 2 17.1 2 12C2 6.5 6.5 2 12 2C17.3 2 21.6 6.1 22 11.3C21.7 11.2 21.4 11.1 21 11.1C20.2 11.1 19.6 11.5 19.2 11.9L16.5 14.6L12.5 12.2V7H11V13L15.4 15.7L11 20.1V21.9Z";
var mdiClockEditOutline = "M21 13.1C20.9 13.1 20.7 13.2 20.6 13.3L19.6 14.3L21.7 16.4L22.7 15.4C22.9 15.2 22.9 14.8 22.7 14.6L21.4 13.3C21.3 13.2 21.2 13.1 21 13.1M19.1 14.9L13 20.9V23H15.1L21.2 16.9L19.1 14.9M12.5 7V12.2L16.5 14.6L15.5 15.6L11 13V7H12.5M11 21.9C5.9 21.4 2 17.1 2 12C2 6.5 6.5 2 12 2C17.3 2 21.6 6.1 22 11.3C21.7 11.2 21.4 11.1 21 11.1C20.6 11.1 20.3 11.2 20 11.3C19.6 7.2 16.2 4 12 4C7.6 4 4 7.6 4 12C4 16.1 7.1 19.5 11.1 19.9L11 20.1V21.9Z";
var mdiClockEnd = "M12,1C8.14,1 5,4.14 5,8A7,7 0 0,0 12,15C15.86,15 19,11.87 19,8C19,4.14 15.86,1 12,1M12,3.15C14.67,3.15 16.85,5.32 16.85,8C16.85,10.68 14.67,12.85 12,12.85A4.85,4.85 0 0,1 7.15,8A4.85,4.85 0 0,1 12,3.15M11,5V8.69L14.19,10.53L14.94,9.23L12.5,7.82V5M15,16V19H3V21H15V24L19,20M19,20V24H21V16H19";
var mdiClockFast = "M15,4A8,8 0 0,1 23,12A8,8 0 0,1 15,20A8,8 0 0,1 7,12A8,8 0 0,1 15,4M15,6A6,6 0 0,0 9,12A6,6 0 0,0 15,18A6,6 0 0,0 21,12A6,6 0 0,0 15,6M14,8H15.5V11.78L17.83,14.11L16.77,15.17L14,12.4V8M2,18A1,1 0 0,1 1,17A1,1 0 0,1 2,16H5.83C6.14,16.71 6.54,17.38 7,18H2M3,13A1,1 0 0,1 2,12A1,1 0 0,1 3,11H5.05L5,12L5.05,13H3M4,8A1,1 0 0,1 3,7A1,1 0 0,1 4,6H7C6.54,6.62 6.14,7.29 5.83,8H4Z";
var mdiClockIn = "M2.21,0.79L0.79,2.21L4.8,6.21L3,8H8V3L6.21,4.8M12,8C8.14,8 5,11.13 5,15A7,7 0 0,0 12,22C15.86,22 19,18.87 19,15A7,7 0 0,0 12,8M12,10.15C14.67,10.15 16.85,12.32 16.85,15A4.85,4.85 0 0,1 12,19.85C9.32,19.85 7.15,17.68 7.15,15A4.85,4.85 0 0,1 12,10.15M11,12V15.69L14.19,17.53L14.94,16.23L12.5,14.82V12";
var mdiClockMinus = "M13.72 21.84C13.16 21.94 12.59 22 12 22C6.5 22 2 17.5 2 12S6.5 2 12 2 22 6.5 22 12C22 12.59 21.94 13.16 21.84 13.72C21 13.26 20.03 13 19 13C17.74 13 16.57 13.39 15.6 14.06L12.5 12.2V7H11V13L14.43 15.11C13.54 16.16 13 17.5 13 19C13 20.03 13.26 21 13.72 21.84M15 18V20H23V18H15Z";
var mdiClockMinusOutline = "M14.47 15.08L11 13V7H12.5V12.25L15.58 14.08C15.17 14.36 14.79 14.7 14.47 15.08M13.08 19.92C12.72 19.97 12.37 20 12 20C7.58 20 4 16.42 4 12S7.58 4 12 4 20 7.58 20 12C20 12.37 19.97 12.72 19.92 13.08C20.61 13.18 21.25 13.4 21.84 13.72C21.94 13.16 22 12.59 22 12C22 6.5 17.5 2 12 2S2 6.5 2 12C2 17.5 6.47 22 12 22C12.59 22 13.16 21.94 13.72 21.84C13.4 21.25 13.18 20.61 13.08 19.92M15 18V20H23V18H15Z";
var mdiClockOut = "M18,1L19.8,2.79L15.79,6.79L17.21,8.21L21.21,4.21L23,6V1M12,8C8.14,8 5,11.13 5,15A7,7 0 0,0 12,22C15.86,22 19,18.87 19,15A7,7 0 0,0 12,8M12,10.15C14.67,10.15 16.85,12.32 16.85,15A4.85,4.85 0 0,1 12,19.85C9.32,19.85 7.15,17.68 7.15,15A4.85,4.85 0 0,1 12,10.15M11,12V15.69L14.19,17.53L14.94,16.23L12.5,14.82V12";
var mdiClockOutline = "M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z";
var mdiClockPlus = "M13.72 21.84C13.16 21.94 12.59 22 12 22C6.5 22 2 17.5 2 12S6.5 2 12 2 22 6.5 22 12C22 12.59 21.94 13.16 21.84 13.72C21 13.26 20.03 13 19 13C17.74 13 16.57 13.39 15.6 14.06L12.5 12.2V7H11V13L14.43 15.11C13.54 16.16 13 17.5 13 19C13 20.03 13.26 21 13.72 21.84M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiClockPlusOutline = "M14.47 15.08L11 13V7H12.5V12.25L15.58 14.08C15.17 14.36 14.79 14.7 14.47 15.08M13.08 19.92C12.72 19.97 12.37 20 12 20C7.58 20 4 16.42 4 12S7.58 4 12 4 20 7.58 20 12C20 12.37 19.97 12.72 19.92 13.08C20.61 13.18 21.25 13.4 21.84 13.72C21.94 13.16 22 12.59 22 12C22 6.5 17.5 2 12 2S2 6.5 2 12C2 17.5 6.47 22 12 22C12.59 22 13.16 21.94 13.72 21.84C13.4 21.25 13.18 20.61 13.08 19.92M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiClockRemove = "M13.72 21.84C13.16 21.94 12.59 22 12 22C6.5 22 2 17.5 2 12S6.5 2 12 2 22 6.5 22 12C22 12.59 21.94 13.16 21.84 13.72C21 13.26 20.03 13 19 13C17.74 13 16.57 13.39 15.6 14.06L12.5 12.2V7H11V13L14.43 15.11C13.54 16.16 13 17.5 13 19C13 20.03 13.26 21 13.72 21.84M21.12 15.46L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46Z";
var mdiClockRemoveOutline = "M14.47 15.08L11 13V7H12.5V12.25L15.58 14.08C15.17 14.36 14.79 14.7 14.47 15.08M13.08 19.92C12.72 19.97 12.37 20 12 20C7.58 20 4 16.42 4 12S7.58 4 12 4 20 7.58 20 12C20 12.37 19.97 12.72 19.92 13.08C20.61 13.18 21.25 13.4 21.84 13.72C21.94 13.16 22 12.59 22 12C22 6.5 17.5 2 12 2S2 6.5 2 12C2 17.5 6.47 22 12 22C12.59 22 13.16 21.94 13.72 21.84C13.4 21.25 13.18 20.61 13.08 19.92M21.12 15.46L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46Z";
var mdiClockStarFourPoints = "M14.4 15.1C13.5 16.2 13 17.5 13 19C13 20 13.3 21 13.7 21.8C13.2 21.9 12.6 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 12.5 21.92 12.97 21.84 13.5L21.8 13.7C21 13.3 20 13 19 13C17.7 13 16.6 13.4 15.6 14.1L12.5 12.2V7H11V13L14.4 15.1M17.74 17.75L19 15L20.25 17.75L23 19L20.25 20.26L19 23L17.74 20.26L15 19L17.74 17.75Z";
var mdiClockStarFourPointsOutline = "M12 20C12.4 20 12.7 20 13.1 19.9C13.2 20.6 13.4 21.3 13.7 21.8C13.2 21.9 12.6 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 12.5 21.92 12.97 21.84 13.5L21.8 13.7C21.2 13.4 20.6 13.2 19.9 13.1C20 12.7 20 12.4 20 12C20 7.6 16.4 4 12 4C7.6 4 4 7.6 4 12C4 16.4 7.6 20 12 20M12.5 12.3L15.6 14.1C15.2 14.4 14.8 14.7 14.5 15.1L11 13V7H12.5V12.3M17.74 17.75L19 15L20.25 17.75L23 19L20.25 20.26L19 23L17.74 20.26L15 19L17.74 17.75Z";
var mdiClockStart = "M12,1C8.14,1 5,4.14 5,8A7,7 0 0,0 12,15C15.86,15 19,11.87 19,8C19,4.14 15.86,1 12,1M12,3.15C14.67,3.15 16.85,5.32 16.85,8C16.85,10.68 14.67,12.85 12,12.85A4.85,4.85 0 0,1 7.15,8A4.85,4.85 0 0,1 12,3.15M11,5V8.69L14.19,10.53L14.94,9.23L12.5,7.82V5M4,16V24H6V21H18V24L22,20L18,16V19H6V16";
var mdiClockTimeEight = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M7.7 15.5L7 14.2L11 11.9V7H12.5V12.8L7.7 15.5Z";
var mdiClockTimeEightOutline = "M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12.5 12.8L7.7 15.6L7 14.2L11 11.9V7H12.5V12.8Z";
var mdiClockTimeEleven = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M12.5 13H11L8.5 8.6L9.8 7.8L11 10V7H12.5V13Z";
var mdiClockTimeElevenOutline = "M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12.5 7V13H11L8.5 8.6L9.8 7.8L11 10V7H12.5Z";
var mdiClockTimeFive = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M14 17L11 11.8V7H12.5V11.4L15.3 16.3L14 17Z";
var mdiClockTimeFiveOutline = "M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M15.3 16.2L14 17L11 11.8V7H12.5V11.4L15.3 16.2Z";
var mdiClockTimeFour = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M16.3 15.2L11 12.3V7H12.5V11.4L17 13.9L16.3 15.2Z";
var mdiClockTimeFourOutline = "M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M17 13.9L16.3 15.2L11 12.3V7H12.5V11.4L17 13.9Z";
var mdiClockTimeNine = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M12.5 13H7V11.5H11V7H12.5V13Z";
var mdiClockTimeNineOutline = "M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12.5 7V13H7V11.5H11V7H12.5Z";
var mdiClockTimeOne = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M12.3 13H11V7H12.5V9.7L14 7.1L15.3 7.9L12.3 13Z";
var mdiClockTimeOneOutline = "M12 20C16.42 20 20 16.42 20 12S16.42 4 12 4 4 7.58 4 12 7.58 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.47 22 2 17.5 2 12C2 6.5 6.5 2 12 2M15.3 7.8L12.3 13H11V7H12.5V9.65L14 7.05L15.3 7.8Z";
var mdiClockTimeSeven = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M12.5 12.2L9.8 17L8.5 16.2L11 11.8V7H12.5V12.2Z";
var mdiClockTimeSevenOutline = "M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12.5 7V12.2L9.8 17L8.5 16.2L11 11.8V7H12.5Z";
var mdiClockTimeSix = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M12.5 17H11V7H12.5V17Z";
var mdiClockTimeSixOutline = "M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12.5 7V17H11V7H12.5Z";
var mdiClockTimeTen = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M12.5 13H11L7 10.7L7.8 9.4L11.1 11.3V7H12.6V13Z";
var mdiClockTimeTenOutline = "M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12.5 13H11L7 10.7L7.8 9.4L11.1 11.3V7H12.6V13Z";
var mdiClockTimeThree = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M17 13H11V7H12.5V11.5H17V13Z";
var mdiClockTimeThreeOutline = "M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M17 11.5V13H11V7H12.5V11.5H17Z";
var mdiClockTimeTwelve = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M12.5 13H11V7H12.5V13Z";
var mdiClockTimeTwelveOutline = "M12 20C16.42 20 20 16.42 20 12S16.42 4 12 4 4 7.58 4 12 7.58 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.47 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12.5 13.03H11V7H12.5V13.03Z";
var mdiClockTimeTwo = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M12.5 13H11V7H12.5V11.3L16.2 9.2L17 10.5L12.5 13Z";
var mdiClockTimeTwoOutline = "M12 20C16.42 20 20 16.42 20 12S16.42 4 12 4 4 7.58 4 12 7.58 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.47 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12.5 13V13H11V7H12.5V11.26L16.2 9.13L16.95 10.43L12.5 13Z";
var mdiClose = "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z";
var mdiCloseBox = "M19,3H16.3H7.7H5A2,2 0 0,0 3,5V7.7V16.4V19A2,2 0 0,0 5,21H7.7H16.4H19A2,2 0 0,0 21,19V16.3V7.7V5A2,2 0 0,0 19,3M15.6,17L12,13.4L8.4,17L7,15.6L10.6,12L7,8.4L8.4,7L12,10.6L15.6,7L17,8.4L13.4,12L17,15.6L15.6,17Z";
var mdiCloseBoxMultiple = "M4 20H18V22H4C2.9 22 2 21.11 2 20V6H4V20M20.22 2H7.78C6.8 2 6 2.8 6 3.78V16.22C6 17.2 6.8 18 7.78 18H20.22C21.2 18 22 17.2 22 16.22V3.78C22 2.8 21.2 2 20.22 2M19 13.6L17.6 15L14 11.4L10.4 15L9 13.6L12.6 10L9 6.4L10.4 5L14 8.6L17.6 5L19 6.4L15.4 10L19 13.6Z";
var mdiCloseBoxMultipleOutline = "M20 2H8C6.9 2 6 2.9 6 4V16C6 17.11 6.9 18 8 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M20 16H8V4H20V16M4 6V20H18V22H4C2.9 22 2 21.11 2 20V6H4M9.77 12.84L12.6 10L9.77 7.15L11.17 5.75L14 8.6L16.84 5.77L18.24 7.17L15.4 10L18.23 12.84L16.83 14.24L14 11.4L11.17 14.24L9.77 12.84Z";
var mdiCloseBoxOutline = "M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,8.4L13.4,12L17,15.6L15.6,17L12,13.4L8.4,17L7,15.6L10.6,12L7,8.4L8.4,7L12,10.6L15.6,7L17,8.4Z";
var mdiCloseCircle = "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z";
var mdiCloseCircleMultiple = "M2 12C2 9.21 3.64 6.8 6 5.68V3.5C2.5 4.76 0 8.09 0 12S2.5 19.24 6 20.5V18.32C3.64 17.2 2 14.79 2 12M15 3C10.04 3 6 7.04 6 12S10.04 21 15 21 24 16.96 24 12 19.96 3 15 3M20 15.59L18.59 17L15 13.41L11.41 17L10 15.59L13.59 12L10 8.41L11.41 7L15 10.59L18.59 7L20 8.41L16.41 12L20 15.59Z";
var mdiCloseCircleMultipleOutline = "M18.54 9.88L17.12 8.47L15 10.59L12.88 8.47L11.47 9.88L13.59 12L11.47 14.12L12.88 15.54L15 13.41L17.12 15.54L18.54 14.12L16.41 12M2 12C2 9.21 3.64 6.8 6 5.68V3.5C2.5 4.76 0 8.09 0 12S2.5 19.24 6 20.5V18.32C3.64 17.2 2 14.79 2 12M15 3C10.04 3 6 7.04 6 12S10.04 21 15 21 24 16.96 24 12 19.96 3 15 3M15 19C11.14 19 8 15.86 8 12S11.14 5 15 5 22 8.14 22 12 18.86 19 15 19Z";
var mdiCloseCircleOutline = "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M14.59,8L12,10.59L9.41,8L8,9.41L10.59,12L8,14.59L9.41,16L12,13.41L14.59,16L16,14.59L13.41,12L16,9.41L14.59,8Z";
var mdiCloseNetwork = "M14.59,6L12,8.59L9.41,6L8,7.41L10.59,10L8,12.59L9.41,14L12,11.41L14.59,14L16,12.59L13.41,10L16,7.41L14.59,6M17,3A2,2 0 0,1 19,5V15A2,2 0 0,1 17,17H13V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H7C5.89,17 5,16.1 5,15V5A2,2 0 0,1 7,3H17Z";
var mdiCloseNetworkOutline = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M7,15V5H17V15H7M15.54,12.12L13.41,10L15.53,7.87L14.12,6.46L12,8.59L9.88,6.46L8.47,7.87L10.59,10L8.47,12.13L9.88,13.54L12,11.41L14.12,13.54L15.54,12.12Z";
var mdiCloseOctagon = "M8.27,3L3,8.27V15.73L8.27,21H15.73L21,15.73V8.27L15.73,3M8.41,7L12,10.59L15.59,7L17,8.41L13.41,12L17,15.59L15.59,17L12,13.41L8.41,17L7,15.59L10.59,12L7,8.41";
var mdiCloseOctagonOutline = "M8.27,3L3,8.27V15.73L8.27,21H15.73C17.5,19.24 21,15.73 21,15.73V8.27L15.73,3M9.1,5H14.9L19,9.1V14.9L14.9,19H9.1L5,14.9V9.1M9.12,7.71L7.71,9.12L10.59,12L7.71,14.88L9.12,16.29L12,13.41L14.88,16.29L16.29,14.88L13.41,12L16.29,9.12L14.88,7.71L12,10.59";
var mdiCloseOutline = "M3,16.74L7.76,12L3,7.26L7.26,3L12,7.76L16.74,3L21,7.26L16.24,12L21,16.74L16.74,21L12,16.24L7.26,21L3,16.74M12,13.41L16.74,18.16L18.16,16.74L13.41,12L18.16,7.26L16.74,5.84L12,10.59L7.26,5.84L5.84,7.26L10.59,12L5.84,16.74L7.26,18.16L12,13.41Z";
var mdiCloseThick = "M20 6.91L17.09 4L12 9.09L6.91 4L4 6.91L9.09 12L4 17.09L6.91 20L12 14.91L17.09 20L20 17.09L14.91 12L20 6.91Z";
var mdiClosedCaption = "M18,11H16.5V10.5H14.5V13.5H16.5V13H18V14A1,1 0 0,1 17,15H14A1,1 0 0,1 13,14V10A1,1 0 0,1 14,9H17A1,1 0 0,1 18,10M11,11H9.5V10.5H7.5V13.5H9.5V13H11V14A1,1 0 0,1 10,15H7A1,1 0 0,1 6,14V10A1,1 0 0,1 7,9H10A1,1 0 0,1 11,10M19,4H5C3.89,4 3,4.89 3,6V18A2,2 0 0,0 5,20H19A2,2 0 0,0 21,18V6C21,4.89 20.1,4 19,4Z";
var mdiClosedCaptionOutline = "M5,4C4.45,4 4,4.18 3.59,4.57C3.2,4.96 3,5.44 3,6V18C3,18.56 3.2,19.04 3.59,19.43C4,19.82 4.45,20 5,20H19C19.5,20 20,19.81 20.39,19.41C20.8,19 21,18.53 21,18V6C21,5.47 20.8,5 20.39,4.59C20,4.19 19.5,4 19,4H5M4.5,5.5H19.5V18.5H4.5V5.5M7,9C6.7,9 6.47,9.09 6.28,9.28C6.09,9.47 6,9.7 6,10V14C6,14.3 6.09,14.53 6.28,14.72C6.47,14.91 6.7,15 7,15H10C10.27,15 10.5,14.91 10.71,14.72C10.91,14.53 11,14.3 11,14V13H9.5V13.5H7.5V10.5H9.5V11H11V10C11,9.7 10.91,9.47 10.71,9.28C10.5,9.09 10.27,9 10,9H7M14,9C13.73,9 13.5,9.09 13.29,9.28C13.09,9.47 13,9.7 13,10V14C13,14.3 13.09,14.53 13.29,14.72C13.5,14.91 13.73,15 14,15H17C17.3,15 17.53,14.91 17.72,14.72C17.91,14.53 18,14.3 18,14V13H16.5V13.5H14.5V10.5H16.5V11H18V10C18,9.7 17.91,9.47 17.72,9.28C17.53,9.09 17.3,9 17,9H14Z";
var mdiCloud = "M6.5 20Q4.22 20 2.61 18.43 1 16.85 1 14.58 1 12.63 2.17 11.1 3.35 9.57 5.25 9.15 5.88 6.85 7.75 5.43 9.63 4 12 4 14.93 4 16.96 6.04 19 8.07 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 17.38 21.69 18.69 20.38 20 18.5 20Z";
var mdiCloudAlert = "M21.86 12.5C21.1 11.63 20.15 11.13 19 11C19 9.05 18.32 7.4 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H18.5C19.75 20 20.81 19.56 21.69 18.69C22.56 17.81 23 16.75 23 15.5C23 14.35 22.62 13.35 21.86 12.5M13 17H11V15H13V17M13 13H11V7H13V13Z";
var mdiCloudAlertOutline = "M21.86 12.5C21.1 11.63 20.15 11.13 19 11C19 9.05 18.32 7.4 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H18.5C19.75 20 20.81 19.56 21.69 18.69C22.56 17.81 23 16.75 23 15.5C23 14.35 22.62 13.35 21.86 12.5M20.27 17.27C19.79 17.76 19.2 18 18.5 18H6.5C5.53 18 4.71 17.66 4.03 17C3.34 16.29 3 15.47 3 14.5S3.34 12.71 4.03 12.03C4.71 11.34 5.53 11 6.5 11H7C7 9.62 7.5 8.44 8.46 7.46C9.44 6.5 10.62 6 12 6S14.56 6.5 15.54 7.46C16.5 8.44 17 9.62 17 11V13H18.5C19.2 13 19.79 13.24 20.27 13.73S21 14.8 21 15.5 20.76 16.79 20.27 17.27M11 15H13V17H11V15M11 7H13V13H11V7Z";
var mdiCloudArrowDown = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C15.69 13 13 15.69 13 19M20 16H18V20H16L19 23L22 20H20V16Z";
var mdiCloudArrowDownOutline = "M4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18H13.09C13.04 18.33 13 18.66 13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C18.89 13 18.79 13 18.68 13C18.62 13 18.56 13 18.5 13H17V11C17 9.62 16.5 8.44 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03M20 16H18V20H16L19 23L22 20H20V16Z";
var mdiCloudArrowLeft = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C15.69 13 13 15.69 13 19M18 16L15 19L18 22V20H22V18H18V16Z";
var mdiCloudArrowLeftOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13H17V11C17 9.62 16.5 8.44 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18H13.09C13.04 18.33 13 18.66 13 19M18 16L15 19L18 22V20H22V18H18V16Z";
var mdiCloudArrowRight = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C15.69 13 13 15.69 13 19M23 19L20 16V18H16V20H20V22L23 19Z";
var mdiCloudArrowRightOutline = "M4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18H13.09C13.04 18.33 13 18.66 13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C18.89 13 18.79 13 18.68 13C18.62 13 18.56 13 18.5 13H17V11C17 9.62 16.5 8.44 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03M23 19L20 16V18H16V20H20V22L23 19Z";
var mdiCloudArrowUp = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C15.69 13 13 15.69 13 19M16 18H18V22H20V18H22L19 15L16 18Z";
var mdiCloudArrowUpOutline = "M4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18H13.09C13.04 18.33 13 18.66 13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C18.89 13 18.79 13 18.68 13C18.62 13 18.56 13 18.5 13H17V11C17 9.62 16.5 8.44 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03M16 18H18V22H20V18H22L19 15L16 18Z";
var mdiCloudBraces = "M21.86 12.5C21.1 11.63 20.15 11.13 19 11C19 9.05 18.32 7.4 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H18.5C19.75 20 20.81 19.56 21.69 18.69C22.56 17.81 23 16.75 23 15.5C23 14.35 22.62 13.35 21.86 12.5M10.5 10H9V11C9 12.11 8.11 13 7 13C8.11 13 9 13.9 9 15V16H10.5V18H9C7.9 18 7 17.11 7 16V15C7 14.45 6.55 14 6 14H5.5V12H6C6.55 12 7 11.55 7 11V10C7 8.9 7.9 8 9 8H10.5V10M18.5 14H18C17.45 14 17 14.45 17 15V16C17 17.11 16.11 18 15 18H13.5V16H15V15C15 13.9 15.9 13 17 13C15.9 13 15 12.11 15 11V10H13.5V8H15C16.11 8 17 8.9 17 10V11C17 11.55 17.45 12 18 12H18.5V14Z";
var mdiCloudCancel = "M12 18.5C12 19 12.07 19.5 12.18 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.1 12.76 22.29 13.05 22.46 13.36C21.36 12.5 20 12 18.5 12C14.91 12 12 14.91 12 18.5M23 18.5C23 21 21 23 18.5 23S14 21 14 18.5 16 14 18.5 14 23 16 23 18.5M20 21.08L15.92 17C15.65 17.42 15.5 17.94 15.5 18.5C15.5 20.16 16.84 21.5 18.5 21.5C19.06 21.5 19.58 21.35 20 21.08M21.5 18.5C21.5 16.84 20.16 15.5 18.5 15.5C17.94 15.5 17.42 15.65 17 15.92L21.08 20C21.35 19.58 21.5 19.06 21.5 18.5Z";
var mdiCloudCancelOutline = "M12 18.5C12 19 12.07 19.5 12.18 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.1 12.76 22.29 13.05 22.46 13.36C21.36 12.5 20 12 18.5 12C18 12 17.5 12.07 17 12.18V11C17 9.62 16.5 8.44 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18H12.03C12 18.17 12 18.33 12 18.5M23 18.5C23 21 21 23 18.5 23S14 21 14 18.5 16 14 18.5 14 23 16 23 18.5M20 21.08L15.92 17C15.65 17.42 15.5 17.94 15.5 18.5C15.5 20.16 16.84 21.5 18.5 21.5C19.06 21.5 19.58 21.35 20 21.08M21.5 18.5C21.5 16.84 20.16 15.5 18.5 15.5C17.94 15.5 17.42 15.65 17 15.92L21.08 20C21.35 19.58 21.5 19.06 21.5 18.5Z";
var mdiCloudCheck = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C15.69 13 13 15.69 13 19M17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84L17.75 19.43Z";
var mdiCloudCheckOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C18.89 13 18.79 13 18.68 13C18.62 13 18.56 13 18.5 13H17V11C17 9.62 16.5 8.44 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18H13.09C13.04 18.33 13 18.66 13 19M17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84L17.75 19.43Z";
var mdiCloudCheckVariant = "M10.35 17L16 11.35L14.55 9.9L10.33 14.13L8.23 12.03L6.8 13.45M6.5 20Q4.22 20 2.61 18.43 1 16.85 1 14.58 1 12.63 2.17 11.1 3.35 9.57 5.25 9.15 5.88 6.85 7.75 5.43 9.63 4 12 4 14.93 4 16.96 6.04 19 8.07 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 17.38 21.69 18.69 20.38 20 18.5 20Z";
var mdiCloudCheckVariantOutline = "M10.35 17L16 11.35L14.55 9.9L10.33 14.13L8.23 12.03L6.8 13.45M6.5 20Q4.22 20 2.61 18.43 1 16.85 1 14.58 1 12.63 2.17 11.1 3.35 9.57 5.25 9.15 5.88 6.85 7.75 5.43 9.63 4 12 4 14.93 4 16.96 6.04 19 8.07 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 17.38 21.69 18.69 20.38 20 18.5 20M6.5 18H18.5Q19.55 18 20.27 17.27 21 16.55 21 15.5 21 14.45 20.27 13.73 19.55 13 18.5 13H17V11Q17 8.93 15.54 7.46 14.08 6 12 6 9.93 6 8.46 7.46 7 8.93 7 11H6.5Q5.05 11 4.03 12.03 3 13.05 3 14.5 3 15.95 4.03 17 5.05 18 6.5 18M12 12Z";
var mdiCloudCircle = "M8.5 16H16Q17.25 16 18.13 15.13T19 13Q19 11.75 18.13 10.88T16 10Q15.8 8.55 14.68 7.53 13.55 6.5 12.15 6.5 10.88 6.5 9.84 7.15 8.8 7.8 8.3 9 6.88 9.13 5.94 10.09 5 11.05 5 12.5 5 13.95 6.03 15 7.05 16 8.5 16M12 22Q9.93 22 8.1 21.21 6.28 20.43 4.93 19.08 3.58 17.73 2.79 15.9 2 14.08 2 12T2.79 8.1Q3.58 6.28 4.93 4.93 6.28 3.58 8.1 2.79 9.93 2 12 2T15.9 2.79Q17.73 3.58 19.08 4.93 20.43 6.28 21.21 8.1 22 9.93 22 12T21.21 15.9Q20.43 17.73 19.08 19.08 17.73 20.43 15.9 21.21 14.08 22 12 22Z";
var mdiCloudCircleOutline = "M8.5 16H16Q17.25 16 18.13 15.13T19 13Q19 11.75 18.13 10.88T16 10Q15.8 8.55 14.68 7.53 13.55 6.5 12.15 6.5 10.88 6.5 9.84 7.15 8.8 7.8 8.3 9 6.88 9.13 5.94 10.09 5 11.05 5 12.5 5 13.95 6.03 15 7.05 16 8.5 16M12 22Q9.93 22 8.1 21.21 6.28 20.43 4.93 19.08 3.58 17.73 2.79 15.9 2 14.08 2 12T2.79 8.1Q3.58 6.28 4.93 4.93 6.28 3.58 8.1 2.79 9.93 2 12 2T15.9 2.79Q17.73 3.58 19.08 4.93 20.43 6.28 21.21 8.1 22 9.93 22 12T21.21 15.9Q20.43 17.73 19.08 19.08 17.73 20.43 15.9 21.21 14.08 22 12 22M12 20Q15.33 20 17.66 17.66 20 15.33 20 12T17.66 6.34Q15.33 4 12 4T6.34 6.34Q4 8.68 4 12T6.34 17.66Q8.68 20 12 20M8.5 14Q7.88 14 7.44 13.56 7 13.13 7 12.5T7.44 11.44Q7.88 11 8.5 11H10V10.5Q10 9.68 10.59 9.09 11.18 8.5 12 8.5T13.41 9.09Q14 9.68 14 10.5V12H16Q16.43 12 16.71 12.29 17 12.58 17 13T16.71 13.71Q16.43 14 16 14M12 12Z";
var mdiCloudClock = "M23 15.5C23 14.79 22.84 14.14 22.55 13.54C21.89 11.79 20.56 10.38 18.86 9.62C18.61 8.26 18 7.06 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H10.26C11.53 21.81 13.62 23 16 23C19.87 23 23 19.87 23 16C23 15.89 23 15.79 23 15.68C23 15.62 23 15.56 23 15.5M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25Z";
var mdiCloudClockOutline = "M23 15.5C23 14.79 22.84 14.14 22.55 13.54C21.89 11.79 20.56 10.38 18.86 9.62C18.61 8.26 18 7.06 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H10.26C11.53 21.81 13.62 23 16 23C19.87 23 23 19.87 23 16C23 15.89 23 15.79 23 15.68C23 15.62 23 15.56 23 15.5M6.5 18C5.53 18 4.71 17.66 4.03 17C3.34 16.29 3 15.47 3 14.5S3.34 12.71 4.03 12.03C4.71 11.34 5.53 11 6.5 11H7C7 9.62 7.5 8.44 8.46 7.46C9.44 6.5 10.62 6 12 6S14.56 6.5 15.54 7.46C16 7.93 16.35 8.46 16.59 9.03C16.4 9 16.2 9 16 9C12.13 9 9 12.13 9 16C9 16.7 9.11 17.37 9.29 18H6.5M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25Z";
var mdiCloudCog = "M12 19C12 19.34 12.03 19.67 12.08 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C21.92 12.55 21.96 12.63 22 12.69C21.1 12.25 20.08 12 19 12C15.13 12 12 15.13 12 19M23.83 20.64L22.83 22.37C22.76 22.5 22.63 22.5 22.5 22.5L21.27 22C21 22.18 20.73 22.34 20.43 22.47L20.24 23.79C20.22 23.91 20.11 24 20 24H18C17.86 24 17.76 23.91 17.74 23.79L17.55 22.47C17.24 22.35 16.96 22.18 16.7 22L15.46 22.5C15.34 22.5 15.21 22.5 15.15 22.37L14.15 20.64C14.09 20.53 14.12 20.4 14.21 20.32L15.27 19.5C15.25 19.33 15.24 19.17 15.24 19S15.25 18.67 15.27 18.5L14.21 17.68C14.11 17.6 14.09 17.47 14.15 17.36L15.15 15.63C15.22 15.5 15.35 15.5 15.46 15.5L16.7 16C16.96 15.82 17.25 15.66 17.55 15.53L17.74 14.21C17.76 14.09 17.87 14 18 14H20C20.11 14 20.22 14.09 20.23 14.21L20.42 15.53C20.73 15.65 21 15.82 21.27 16L22.5 15.5C22.63 15.5 22.76 15.5 22.82 15.63L23.82 17.36C23.88 17.47 23.85 17.6 23.76 17.68L22.7 18.5C22.73 18.67 22.74 18.83 22.74 19S22.72 19.33 22.7 19.5L23.77 20.32C23.86 20.4 23.89 20.53 23.83 20.64M20.5 19C20.5 18.17 19.82 17.5 19 17.5S17.5 18.17 17.5 19 18.16 20.5 19 20.5 20.5 19.83 20.5 19Z";
var mdiCloudCogOutline = "M12 19C12 19.34 12.03 19.67 12.08 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C21.92 12.55 21.96 12.63 22 12.69C21.1 12.25 20.08 12 19 12C18.31 12 17.63 12.11 17 12.29V11C17 9.62 16.5 8.44 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18H12.08C12.03 18.33 12 18.66 12 19M23.83 20.64L22.83 22.37C22.76 22.5 22.63 22.5 22.5 22.5L21.27 22C21 22.18 20.73 22.34 20.43 22.47L20.24 23.79C20.22 23.91 20.11 24 20 24H18C17.86 24 17.76 23.91 17.74 23.79L17.55 22.47C17.24 22.35 16.96 22.18 16.7 22L15.46 22.5C15.34 22.5 15.21 22.5 15.15 22.37L14.15 20.64C14.09 20.53 14.12 20.4 14.21 20.32L15.27 19.5C15.25 19.33 15.24 19.17 15.24 19S15.25 18.67 15.27 18.5L14.21 17.68C14.11 17.6 14.09 17.47 14.15 17.36L15.15 15.63C15.22 15.5 15.35 15.5 15.46 15.5L16.7 16C16.96 15.82 17.25 15.66 17.55 15.53L17.74 14.21C17.76 14.09 17.87 14 18 14H20C20.11 14 20.22 14.09 20.23 14.21L20.42 15.53C20.73 15.65 21 15.82 21.27 16L22.5 15.5C22.63 15.5 22.76 15.5 22.82 15.63L23.82 17.36C23.88 17.47 23.85 17.6 23.76 17.68L22.7 18.5C22.73 18.67 22.74 18.83 22.74 19S22.72 19.33 22.7 19.5L23.77 20.32C23.86 20.4 23.89 20.53 23.83 20.64M20.5 19C20.5 18.17 19.82 17.5 19 17.5S17.5 18.17 17.5 19 18.16 20.5 19 20.5 20.5 19.83 20.5 19Z";
var mdiCloudDownload = "M6.5 20Q4.22 20 2.61 18.43 1 16.85 1 14.58 1 12.63 2.17 11.1 3.35 9.57 5.25 9.15 5.83 7.13 7.39 5.75 8.95 4.38 11 4.08V12.15L9.4 10.6L8 12L12 16L16 12L14.6 10.6L13 12.15V4.08Q15.58 4.43 17.29 6.39 19 8.35 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 17.38 21.69 18.69 20.38 20 18.5 20Z";
var mdiCloudDownloadOutline = "M6.5 20Q4.22 20 2.61 18.43 1 16.85 1 14.58 1 12.63 2.17 11.1 3.35 9.57 5.25 9.15 5.68 7.35 7.38 5.73 9.07 4.1 11 4.1 11.83 4.1 12.41 4.69 13 5.28 13 6.1V12.15L14.6 10.6L16 12L12 16L8 12L9.4 10.6L11 12.15V6.1Q9.1 6.45 8.05 7.94 7 9.43 7 11H6.5Q5.05 11 4.03 12.03 3 13.05 3 14.5 3 15.95 4.03 17 5.05 18 6.5 18H18.5Q19.55 18 20.27 17.27 21 16.55 21 15.5 21 14.45 20.27 13.73 19.55 13 18.5 13H17V11Q17 9.8 16.45 8.76 15.9 7.73 15 7V4.68Q16.85 5.55 17.93 7.26 19 9 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 17.38 21.69 18.69 20.38 20 18.5 20M12 11.05Z";
var mdiCloudKey = "M9.41 20H6.5C5 20 3.68 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1C2.96 10.08 4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43C9 4.5 10.42 4 12 4C13.95 4 15.61 4.68 16.96 6.04C18.32 7.39 19 9.05 19 11C20.15 11.13 21.11 11.63 21.86 12.5C22.5 13.23 22.86 14.06 22.96 15H18C17.07 13.77 15.61 13 14 13C11.2 13 9 15.2 9 18C9 18.72 9.15 19.39 9.41 20M23 17V19H21V21H19V19H16.8C16.4 20.2 15.3 21 14 21C12.3 21 11 19.7 11 18S12.3 15 14 15C15.3 15 16.4 15.8 16.8 17H23M15 18C15 17.5 14.6 17 14 17S13 17.5 13 18 13.4 19 14 19 15 18.5 15 18Z";
var mdiCloudKeyOutline = "M9.41 20H6.5C5 20 3.68 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1C2.96 10.08 4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43C9 4.5 10.42 4 12 4C13.95 4 15.61 4.68 16.96 6.04C18.32 7.39 19 9.05 19 11C20.15 11.13 21.11 11.63 21.86 12.5C22.5 13.23 22.86 14.06 22.96 15H20.96C20.86 14.5 20.64 14.09 20.27 13.73C19.79 13.24 19.2 13 18.5 13H17V11C17 9.62 16.5 8.44 15.54 7.46C14.57 6.5 13.39 6 12 6C10.62 6 9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.3 4.03 17C4.71 17.67 5.53 18 6.5 18H9C9 18.72 9.15 19.39 9.41 20M23 17V19H21V21H19V19H16.8C16.4 20.2 15.3 21 14 21C12.3 21 11 19.7 11 18S12.3 15 14 15C15.3 15 16.4 15.8 16.8 17H23M15 18C15 17.5 14.6 17 14 17S13 17.5 13 18 13.4 19 14 19 15 18.5 15 18Z";
var mdiCloudLock = "M14.2 14.5V14.74C13.5 15.34 13 16.24 13 17.2V20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.08 7.16 18.73 8.5 18.93 10C16.36 10.04 14.2 12.08 14.2 14.5M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiCloudLockOpen = "M14.2 13.5V14.74C13.5 15.34 13 16.24 13 17.2V20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C17.84 6.91 18.42 7.91 18.74 9.03C16.25 9.16 14.2 11.15 14.2 13.5M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiCloudLockOpenOutline = "M6.5 18H13V20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C17.84 6.91 18.42 7.91 18.74 9.03C18.03 9.06 17.37 9.25 16.78 9.56C16.55 8.78 16.15 8.08 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiCloudLockOutline = "M6.5 18H13V20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.08 7.16 18.73 8.5 18.93 10C18.23 10 17.56 10.19 16.95 10.46C16.84 9.31 16.38 8.31 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiCloudMinus = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C15.69 13 13 15.69 13 19M15 18V20H23V18H15Z";
var mdiCloudMinusOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C18.89 13 18.79 13 18.68 13C18.62 13 18.56 13 18.5 13H17V11C17 9.62 16.5 8.44 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18H13.09C13.04 18.33 13 18.66 13 19M15 18V20H23V18H15Z";
var mdiCloudOff = "M19.8 22.6L17.15 20H6.5Q4.2 20 2.6 18.4T1 14.5Q1 12.58 2.19 11.08 3.38 9.57 5.25 9.15 5.33 8.95 5.4 8.76 5.5 8.57 5.55 8.35L1.4 4.2L2.8 2.8L21.2 21.2M21.6 18.75L8.05 5.23Q8.93 4.63 9.91 4.31 10.9 4 12 4 14.93 4 16.96 6.04 19 8.07 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 16.5 22.63 17.31 22.25 18.15 21.6 18.75Z";
var mdiCloudOffOutline = "M19.8 22.6L17.15 20H6.5Q4.2 20 2.6 18.4T1 14.5Q1 12.58 2.19 11.08 3.38 9.57 5.25 9.15 5.33 8.95 5.4 8.76 5.5 8.57 5.55 8.35L1.4 4.2L2.8 2.8L21.2 21.2M6.5 18H15.15L7.1 9.95Q7.05 10.23 7.03 10.5 7 10.73 7 11H6.5Q5.05 11 4.03 12.03 3 13.05 3 14.5 3 15.95 4.03 17 5.05 18 6.5 18M11.13 14M21.6 18.75L20.15 17.35Q20.58 17 20.79 16.54 21 16.08 21 15.5 21 14.45 20.27 13.73 19.55 13 18.5 13H17V11Q17 8.93 15.54 7.46 14.08 6 12 6 11.33 6 10.7 6.16 10.07 6.33 9.5 6.68L8.05 5.23Q8.93 4.63 9.91 4.31 10.9 4 12 4 14.93 4 16.96 6.04 19 8.07 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 16.5 22.63 17.31 22.25 18.15 21.6 18.75M14.83 12.03Z";
var mdiCloudOutline = "M6.5 20Q4.22 20 2.61 18.43 1 16.85 1 14.58 1 12.63 2.17 11.1 3.35 9.57 5.25 9.15 5.88 6.85 7.75 5.43 9.63 4 12 4 14.93 4 16.96 6.04 19 8.07 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 17.38 21.69 18.69 20.38 20 18.5 20M6.5 18H18.5Q19.55 18 20.27 17.27 21 16.55 21 15.5 21 14.45 20.27 13.73 19.55 13 18.5 13H17V11Q17 8.93 15.54 7.46 14.08 6 12 6 9.93 6 8.46 7.46 7 8.93 7 11H6.5Q5.05 11 4.03 12.03 3 13.05 3 14.5 3 15.95 4.03 17 5.05 18 6.5 18M12 12Z";
var mdiCloudPercent = "M21.86 12.5C21.1 11.63 20.15 11.13 19 11C19 9.05 18.32 7.4 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H18.5C19.75 20 20.81 19.56 21.69 18.69C22.56 17.81 23 16.75 23 15.5C23 14.35 22.62 13.35 21.86 12.5M9.45 9.03C10.23 9.03 10.87 9.67 10.87 10.45C10.87 11.23 10.23 11.87 9.45 11.87C8.67 11.87 8.03 11.23 8.03 10.45C8.03 9.67 8.67 9.03 9.45 9.03M14.55 16.97C13.77 16.97 13.13 16.33 13.13 15.55C13.13 14.77 13.77 14.13 14.55 14.13C15.33 14.13 15.97 14.77 15.97 15.55C15.97 16.33 15.33 16.97 14.55 16.97M9.2 17L8 15.8L14.8 9L16 10.2L9.2 17Z";
var mdiCloudPercentOutline = "M21.86 12.5C21.1 11.63 20.15 11.13 19 11C19 9.05 18.32 7.4 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H18.5C19.75 20 20.81 19.56 21.69 18.69C22.56 17.81 23 16.75 23 15.5C23 14.35 22.62 13.35 21.86 12.5M20.27 17.27C19.79 17.76 19.2 18 18.5 18H6.5C5.53 18 4.71 17.66 4.03 17C3.34 16.29 3 15.47 3 14.5S3.34 12.71 4.03 12.03C4.71 11.34 5.53 11 6.5 11H7C7 9.62 7.5 8.44 8.46 7.46C9.44 6.5 10.62 6 12 6S14.56 6.5 15.54 7.46C16.5 8.44 17 9.62 17 11V13H18.5C19.2 13 19.79 13.24 20.27 13.73S21 14.8 21 15.5 20.76 16.79 20.27 17.27M8.03 10.45C8.03 9.67 8.67 9.03 9.45 9.03C10.23 9.03 10.87 9.67 10.87 10.45C10.87 11.23 10.23 11.87 9.45 11.87C8.67 11.87 8.03 11.23 8.03 10.45M15.97 15.55C15.97 16.33 15.33 16.97 14.55 16.97C13.77 16.97 13.13 16.33 13.13 15.55C13.13 14.77 13.77 14.13 14.55 14.13C15.33 14.13 15.97 14.77 15.97 15.55M14.8 9L16 10.2L9.2 17L8 15.8L14.8 9Z";
var mdiCloudPlus = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C15.69 13 13 15.69 13 19M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiCloudPlusOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C18.89 13 18.79 13 18.68 13C18.62 13 18.56 13 18.5 13H17V11C17 9.62 16.5 8.44 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18H13.09C13.04 18.33 13 18.66 13 19M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiCloudPrint = "M21.86 10.5C21.1 9.63 20.15 9.13 19 9C19 7.05 18.32 5.4 16.96 4.04C15.6 2.68 13.95 2 12 2C10.42 2 9 2.5 7.75 3.43S5.67 5.62 5.25 7.15C4 7.43 2.96 8.08 2.17 9.1S1 11.28 1 12.58C1 14.09 1.54 15.38 2.61 16.43C3.57 17.36 4.7 17.85 6 17.95V22H18V18H18.5C19.75 18 20.81 17.56 21.69 16.69C22.56 15.81 23 14.75 23 13.5C23 12.35 22.62 11.35 21.86 10.5M16 20H8V13H16V20M15 15H9V14H15V15M15 17H9V16H15V17M15 19H9V18H15V19Z";
var mdiCloudPrintOutline = "M15 15H9V14H15V15M15 16H9V17H15V16M15 18H9V19H15V18M23 13.5C23 14.75 22.56 15.81 21.69 16.69C20.81 17.56 19.75 18 18.5 18H18V22H6V17.95C4.7 17.85 3.57 17.36 2.61 16.43C1.54 15.38 1 14.09 1 12.58C1 11.28 1.39 10.12 2.17 9.1S4 7.43 5.25 7.15C5.67 5.62 6.5 4.38 7.75 3.43S10.42 2 12 2C13.95 2 15.6 2.68 16.96 4.04C18.32 5.4 19 7.05 19 9C20.15 9.13 21.1 9.63 21.86 10.5C22.62 11.35 23 12.35 23 13.5M6 15.95V11H17V9C17 7.62 16.5 6.44 15.54 5.46C14.56 4.5 13.38 4 12 4S9.44 4.5 8.46 5.46C7.5 6.44 7 7.62 7 9H6.5C5.53 9 4.71 9.34 4.03 10.03C3.34 10.71 3 11.53 3 12.5S3.34 14.29 4.03 15C4.59 15.54 5.25 15.85 6 15.95M16 13H8V20H16V13M21 13.5C21 12.8 20.76 12.21 20.27 11.73S19.2 11 18.5 11H18V16H18.5C19.2 16 19.79 15.76 20.27 15.28S21 14.2 21 13.5Z";
var mdiCloudQuestion = "M21.86 12.5C21.1 11.63 20.15 11.13 19 11C19 9.05 18.32 7.4 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H18.5C19.75 20 20.81 19.56 21.69 18.69C22.56 17.81 23 16.75 23 15.5C23 14.35 22.62 13.35 21.86 12.5M13 17H11V15H13V17M14.8 11.82C14.5 12.21 14.13 12.5 13.67 12.75C13.41 12.91 13.24 13.07 13.15 13.26C13.06 13.45 13 13.69 13 14H11C11 13.45 11.11 13.08 11.3 12.82C11.5 12.56 11.85 12.25 12.37 11.91C12.63 11.75 12.84 11.56 13 11.32C13.15 11.09 13.23 10.81 13.23 10.5C13.23 10.18 13.14 9.94 12.96 9.76C12.78 9.56 12.5 9.47 12.2 9.47C11.93 9.47 11.71 9.55 11.5 9.7C11.35 9.85 11.25 10.08 11.25 10.39H9.28C9.23 9.64 9.5 9 10.06 8.59C10.6 8.2 11.31 8 12.2 8C13.14 8 13.89 8.23 14.43 8.68S15.24 9.75 15.24 10.5C15.24 11 15.09 11.41 14.8 11.82Z";
var mdiCloudQuestionOutline = "M21.86 12.5C21.1 11.63 20.15 11.13 19 11C19 9.05 18.32 7.4 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H18.5C19.75 20 20.81 19.56 21.69 18.69C22.56 17.81 23 16.75 23 15.5C23 14.35 22.62 13.35 21.86 12.5M20.27 17.27C19.79 17.76 19.2 18 18.5 18H6.5C5.53 18 4.71 17.66 4.03 17C3.34 16.29 3 15.47 3 14.5S3.34 12.71 4.03 12.03C4.71 11.34 5.53 11 6.5 11H7C7 9.62 7.5 8.44 8.46 7.46C9.44 6.5 10.62 6 12 6S14.56 6.5 15.54 7.46C16.5 8.44 17 9.62 17 11V13H18.5C19.2 13 19.79 13.24 20.27 13.73S21 14.8 21 15.5 20.76 16.79 20.27 17.27M11 15H13V17H11V15M14.43 8.68C14.97 9.13 15.24 9.75 15.24 10.5C15.24 11 15.09 11.41 14.8 11.82C14.5 12.21 14.13 12.5 13.67 12.75C13.41 12.91 13.24 13.07 13.15 13.26C13.06 13.45 13 13.69 13 14H11C11 13.45 11.11 13.08 11.3 12.82C11.5 12.56 11.85 12.25 12.37 11.91C12.63 11.75 12.84 11.56 13 11.32C13.15 11.09 13.23 10.81 13.23 10.5C13.23 10.18 13.14 9.94 12.96 9.76C12.78 9.56 12.5 9.47 12.2 9.47C11.93 9.47 11.71 9.55 11.5 9.7C11.35 9.85 11.25 10.08 11.25 10.39H9.28C9.23 9.64 9.5 9 10.06 8.59C10.6 8.2 11.31 8 12.2 8C13.14 8 13.89 8.23 14.43 8.68Z";
var mdiCloudRefresh = "M12 18.5C12 19 12.07 19.5 12.18 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.1 12.76 22.29 13.05 22.46 13.36C21.36 12.5 20 12 18.5 12C14.91 12 12 14.91 12 18.5M18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5Z";
var mdiCloudRefreshOutline = "M12 18.5C12 19 12.07 19.5 12.18 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.1 12.76 22.29 13.05 22.46 13.36C21.36 12.5 20 12 18.5 12C18 12 17.5 12.07 17 12.18V11C17 9.62 16.5 8.44 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18H12.03C12 18.17 12 18.33 12 18.5M18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5Z";
var mdiCloudRefreshVariant = "M21.86 12.5C21.1 11.63 20.15 11.13 19 11C19 9.05 18.32 7.4 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H18.5C19.75 20 20.81 19.56 21.69 18.69C22.56 17.81 23 16.75 23 15.5C23 14.35 22.62 13.35 21.86 12.5M16 13H12L13.77 11.23C13.32 10.78 12.69 10.5 12 10.5C10.62 10.5 9.5 11.62 9.5 13S10.62 15.5 12 15.5C12.82 15.5 13.54 15.11 14 14.5H15.71C15.12 15.97 13.68 17 12 17C9.79 17 8 15.21 8 13S9.79 9 12 9C13.11 9 14.11 9.45 14.83 10.17L16 9V13Z";
var mdiCloudRefreshVariantOutline = "M21.86 12.5C21.1 11.63 20.15 11.13 19 11C19 9.05 18.32 7.4 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H18.5C19.75 20 20.81 19.56 21.69 18.69C22.56 17.81 23 16.75 23 15.5C23 14.35 22.62 13.35 21.86 12.5M20.27 17.27C19.79 17.76 19.2 18 18.5 18H6.5C5.53 18 4.71 17.66 4.03 17C3.34 16.29 3 15.47 3 14.5S3.34 12.71 4.03 12.03C4.71 11.34 5.53 11 6.5 11H7C7 9.62 7.5 8.44 8.46 7.46C9.44 6.5 10.62 6 12 6S14.56 6.5 15.54 7.46C16.5 8.44 17 9.62 17 11V13H18.5C19.2 13 19.79 13.24 20.27 13.73S21 14.8 21 15.5 20.76 16.79 20.27 17.27M14.83 10.17L16 9V13H12L13.77 11.23C13.32 10.78 12.69 10.5 12 10.5C10.62 10.5 9.5 11.62 9.5 13S10.62 15.5 12 15.5C12.82 15.5 13.54 15.11 14 14.5H15.71C15.12 15.97 13.68 17 12 17C9.79 17 8 15.21 8 13S9.79 9 12 9C13.11 9 14.11 9.45 14.83 10.17Z";
var mdiCloudRemove = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C15.69 13 13 15.69 13 19M21.12 15.46L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46Z";
var mdiCloudRemoveOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C20.15 11.13 21.1 11.63 21.86 12.5C22.37 13.07 22.7 13.71 22.86 14.42C21.82 13.54 20.5 13 19 13C18.89 13 18.79 13 18.68 13C18.62 13 18.56 13 18.5 13H17V11C17 9.62 16.5 8.44 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18H13.09C13.04 18.33 13 18.66 13 19M21.12 15.46L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46Z";
var mdiCloudSearch = "M21.86 12.5C21.1 11.63 20.15 11.13 19 11C19 9.05 18.32 7.4 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H18.5C19.75 20 20.81 19.56 21.69 18.69C22.56 17.81 23 16.75 23 15.5C23 14.35 22.62 13.35 21.86 12.5M16.57 18L14 15.43C13.43 15.79 12.74 16 12 16C9.79 16 8 14.21 8 12S9.79 8 12 8 16 9.79 16 12C16 12.74 15.79 13.43 15.43 14L18 16.57L16.57 18M14 12C14 13.11 13.11 14 12 14S10 13.11 10 12 10.9 10 12 10 14 10.9 14 12Z";
var mdiCloudSearchOutline = "M21.86 12.5C21.1 11.63 20.15 11.13 19 11C19 9.05 18.32 7.4 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H18.5C19.75 20 20.81 19.56 21.69 18.69C22.56 17.81 23 16.75 23 15.5C23 14.35 22.62 13.35 21.86 12.5M20.27 17.27C19.79 17.76 19.2 18 18.5 18H6.5C5.53 18 4.71 17.66 4.03 17C3.34 16.29 3 15.47 3 14.5S3.34 12.71 4.03 12.03C4.71 11.34 5.53 11 6.5 11H7C7 9.62 7.5 8.44 8.46 7.46C9.44 6.5 10.62 6 12 6S14.56 6.5 15.54 7.46C16.5 8.44 17 9.62 17 11V13H18.5C19.2 13 19.79 13.24 20.27 13.73S21 14.8 21 15.5 20.76 16.79 20.27 17.27M16 12C16 9.79 14.21 8 12 8S8 9.79 8 12 9.79 16 12 16C12.74 16 13.43 15.79 14 15.43L16.57 18L18 16.57L15.43 14C15.79 13.43 16 12.74 16 12M12 14C10.9 14 10 13.11 10 12S10.9 10 12 10 14 10.9 14 12 13.11 14 12 14Z";
var mdiCloudSync = "M13 17.5C13 18.39 13.18 19.23 13.5 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C19.04 11 19.07 11 19.1 11C15.7 11.23 13 14.05 13 17.5M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20Z";
var mdiCloudSyncOutline = "M13.03 18C13.08 18.7 13.24 19.38 13.5 20H6.5C5 20 3.69 19.5 2.61 18.43C1.54 17.38 1 16.09 1 14.58C1 13.28 1.39 12.12 2.17 11.1S4 9.43 5.25 9.15C5.67 7.62 6.5 6.38 7.75 5.43S10.42 4 12 4C13.95 4 15.6 4.68 16.96 6.04C18.32 7.4 19 9.05 19 11C19.04 11 19.07 11 19.1 11C18.36 11.07 17.65 11.23 17 11.5V11C17 9.62 16.5 8.44 15.54 7.46C14.56 6.5 13.38 6 12 6S9.44 6.5 8.46 7.46C7.5 8.44 7 9.62 7 11H6.5C5.53 11 4.71 11.34 4.03 12.03C3.34 12.71 3 13.53 3 14.5S3.34 16.29 4.03 17C4.71 17.66 5.53 18 6.5 18H13.03M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20Z";
var mdiCloudTags = "M21.86 12.5C21.1 11.63 20.15 11.13 19 11C19 9.05 18.32 7.4 16.96 6.04C15.6 4.68 13.95 4 12 4C10.42 4 9 4.47 7.75 5.43S5.67 7.62 5.25 9.15C4 9.43 2.96 10.08 2.17 11.1S1 13.28 1 14.58C1 16.09 1.54 17.38 2.61 18.43C3.69 19.5 5 20 6.5 20H18.5C19.75 20 20.81 19.56 21.69 18.69C22.56 17.81 23 16.75 23 15.5C23 14.35 22.62 13.35 21.86 12.5M10.5 16.18L9.09 17.6L4.5 13L9.09 8.4L10.5 9.82L7.32 13L10.5 16.18M14.91 17.6L13.5 16.18L16.68 13L13.5 9.82L14.91 8.4L19.5 13L14.91 17.6Z";
var mdiCloudUpload = "M11 20H6.5Q4.22 20 2.61 18.43 1 16.85 1 14.58 1 12.63 2.17 11.1 3.35 9.57 5.25 9.15 5.88 6.85 7.75 5.43 9.63 4 12 4 14.93 4 16.96 6.04 19 8.07 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 17.38 21.69 18.69 20.38 20 18.5 20H13V12.85L14.6 14.4L16 13L12 9L8 13L9.4 14.4L11 12.85Z";
var mdiCloudUploadOutline = "M6.5 20Q4.22 20 2.61 18.43 1 16.85 1 14.58 1 12.63 2.17 11.1 3.35 9.57 5.25 9.15 5.88 6.85 7.75 5.43 9.63 4 12 4 14.93 4 16.96 6.04 19 8.07 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 17.38 21.69 18.69 20.38 20 18.5 20H13Q12.18 20 11.59 19.41 11 18.83 11 18V12.85L9.4 14.4L8 13L12 9L16 13L14.6 14.4L13 12.85V18H18.5Q19.55 18 20.27 17.27 21 16.55 21 15.5 21 14.45 20.27 13.73 19.55 13 18.5 13H17V11Q17 8.93 15.54 7.46 14.08 6 12 6 9.93 6 8.46 7.46 7 8.93 7 11H6.5Q5.05 11 4.03 12.03 3 13.05 3 14.5 3 15.95 4.03 17 5.05 18 6.5 18H9V20M12 13Z";
var mdiClouds = "M19.19 12.07C19.69 11.54 20 10.82 20 10C20 8.3 18.7 6.84 17 6.84H14.2C14.2 4.17 12.03 2 9.36 2C7.31 2 5.56 3.28 4.85 5.08C2.72 5.14 1 6.89 1 9.04C1 11.22 2.78 13 4.96 13H8.1C8.04 13.33 8 13.66 8 14H7.5C5.57 14 4 15.57 4 17.5S5.57 21 7.5 21H18.5C21 21 23 19 23 16.5C23 14.26 21.34 12.41 19.19 12.07M18.5 19H7.5C6.67 19 6 18.33 6 17.5S6.67 16 7.5 16H10V14C10 12.07 11.57 10.5 13.5 10.5S17 12.07 17 14H18.5C19.88 14 21 15.12 21 16.5S19.88 19 18.5 19Z";
var mdiClover = "M12,11.18C15.3,8.18 17,6.64 17,4.69C17,3.19 15.75,2 14.25,2C13.39,2 12.57,2.36 12,3C11.43,2.36 10.61,2 9.69,2C8.19,2 7,3.25 7,4.75C7,6.64 8.7,8.18 12,11.18M11.18,12C8.18,8.7 6.64,7 4.69,7C3.19,7 2,8.25 2,9.75C2,10.61 2.36,11.43 3,12C2.36,12.57 2,13.39 2,14.31C2,15.81 3.25,17 4.75,17C6.64,17 8.18,15.3 11.18,12M12.83,12C15.82,15.3 17.36,17 19.31,17C20.81,17 22,15.75 22,14.25C22,13.39 21.64,12.57 21,12C21.64,11.43 22,10.61 22,9.69C22,8.19 20.75,7 19.25,7C17.36,7 15.82,8.7 12.83,12M12,12.82C8.7,15.82 7,17.36 7,19.31C7,20.81 8.25,22 9.75,22C10.61,22 11.43,21.64 12,21C12.57,21.64 13.39,22 14.31,22C15.81,22 17,20.75 17,19.25C17,17.36 15.3,15.82 12,12.82Z";
var mdiCloverOutline = "M10.61 12.62L10.65 12.58L11.16 12.03L11.18 12L11.16 11.97C11 11.78 10.82 11.6 10.66 11.42L10.61 11.38C8.42 8.97 7.03 7.53 5.58 7.12C5.29 7.04 5 7 4.69 7C3.19 7 2 8.25 2 9.75C2 10.38 2.19 11 2.55 11.5C2.68 11.68 2.83 11.85 3 12C2.83 12.15 2.68 12.32 2.55 12.5C2.19 13 2 13.64 2 14.31C2 15.81 3.25 17 4.75 17C5.03 17 5.31 16.96 5.58 16.89C7 16.5 8.4 15.05 10.61 12.62M8.47 12C7.57 12.97 6.88 13.69 6.26 14.21C5.43 14.91 5 15 4.75 15C4.3 15 4 14.65 4 14.31C4 13.93 4.14 13.66 4.33 13.5L6 12L4.33 10.5C4.13 10.33 4 10.05 4 9.75C4 9.3 4.35 9 4.69 9C5 9 5.43 9.1 6.26 9.8C6.88 10.31 7.57 11.03 8.47 12M7.12 18.43C7.04 18.72 7 19 7 19.31C7 20.81 8.25 22 9.75 22C10.38 22 11 21.81 11.5 21.45C11.68 21.32 11.85 21.17 12 21C12.15 21.17 12.32 21.32 12.5 21.45C13 21.81 13.64 22 14.31 22C15.81 22 17 20.75 17 19.25C17 18.97 16.96 18.69 16.89 18.42C16.5 17 15.05 15.6 12.62 13.39L12.58 13.35L12.03 12.85L12 12.82L11.97 12.85L11.42 13.35L11.38 13.38C8.97 15.58 7.53 16.97 7.12 18.43M12 15.53C12.97 16.43 13.69 17.12 14.21 17.74C14.91 18.57 15 19 15 19.25C15 19.7 14.65 20 14.31 20C13.93 20 13.66 19.86 13.5 19.67L12 18L10.5 19.67C10.33 19.87 10.05 20 9.75 20C9.3 20 9 19.65 9 19.31C9 19 9.1 18.57 9.8 17.74C10.31 17.12 11.03 16.43 12 15.53M13.39 12.62C15.59 15.03 16.97 16.47 18.43 16.88C18.72 16.96 19 17 19.31 17C20.81 17 22 15.75 22 14.25C22 13.62 21.81 13 21.45 12.5C21.32 12.32 21.17 12.15 21 12C21.17 11.85 21.32 11.68 21.45 11.5C21.81 11 22 10.37 22 9.69C22 8.19 20.75 7 19.25 7C18.97 7 18.69 7.04 18.42 7.11C17 7.5 15.6 8.95 13.39 11.38L13.36 11.42L12.83 12L12.83 12L12.83 12L13.36 12.58L13.39 12.62M15.54 12C16.43 11.03 17.13 10.31 17.74 9.79C18.58 9.09 19 9 19.25 9C19.7 9 20 9.35 20 9.69C20 10.07 19.86 10.34 19.67 10.5L18 12L19.67 13.5C19.87 13.68 20 13.95 20 14.25C20 14.7 19.65 15 19.31 15C19 15 18.57 14.9 17.74 14.2C17.13 13.69 16.43 12.97 15.54 12M12.62 10.62C15.03 8.42 16.47 7.03 16.88 5.58C16.96 5.29 17 5 17 4.69C17 3.19 15.75 2 14.25 2C13.62 2 13 2.19 12.5 2.55C12.32 2.68 12.15 2.83 12 3C11.85 2.83 11.68 2.68 11.5 2.55C11 2.19 10.37 2 9.69 2C8.19 2 7 3.25 7 4.75C7 5.03 7.04 5.31 7.11 5.58C7.5 7 8.95 8.4 11.38 10.62L11.42 10.65L11.97 11.15L12 11.18L12.03 11.16L12.59 10.65L12.62 10.61M12 8.47C11.03 7.57 10.31 6.88 9.79 6.26C9.09 5.43 9 5 9 4.75C9 4.3 9.35 4 9.69 4C10.07 4 10.34 4.14 10.5 4.33L12 6L13.5 4.33C13.68 4.13 13.95 4 14.25 4C14.7 4 15 4.35 15 4.69C15 5 14.9 5.43 14.2 6.26C13.69 6.88 12.97 7.57 12 8.47Z";
var mdiCoachLamp = "M16 5L15 2H13L12 5L6 8H8L8.6 11H4V7H2V17H4V13H9L10 18L12 20L13 22H15L16 20L18 18L20 8H22M16.16 17H11.84L10 8H18Z";
var mdiCoachLampVariant = "M12.5 2L12 4L10 6.31L5 9H7L9.5 18L12 20L12.5 22H13.5L14 20L16.5 18L19 9H21L16 6.31L14 4L13.5 2M9 9H17L14.78 17H11.22M3 14V22H11.5L11 20H8L5 17V14Z";
var mdiCoatRack = "M18.33 7.78A1 1 0 0 0 16.66 8.89A2 2 0 1 1 13 10V7.82A3 3 0 1 0 11 7.82V10A2 2 0 1 1 7.34 8.89A1 1 0 1 0 5.67 7.78A4 4 0 0 0 11 13.46V20A2 2 0 0 0 9 22H15A2 2 0 0 0 13 20V13.46A4 4 0 0 0 18.33 7.78M12 4A1 1 0 1 1 11 5A1 1 0 0 1 12 4Z";
var mdiCodeArray = "M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M6,6V18H10V16H8V8H10V6H6M16,16H14V18H18V6H14V8H16V16Z";
var mdiCodeBlockBraces = "M5 3C3.9 3 3 3.9 3 5S2.1 7 1 7V9C2.1 9 3 9.9 3 11S3.9 13 5 13H7V11H5V10C5 8.9 4.1 8 3 8C4.1 8 5 7.1 5 6V5H7V3M11 3C12.1 3 13 3.9 13 5S13.9 7 15 7V9C13.9 9 13 9.9 13 11S12.1 13 11 13H9V11H11V10C11 8.9 11.9 8 13 8C11.9 8 11 7.1 11 6V5H9V3H11M22 6V18C22 19.11 21.11 20 20 20H4C2.9 20 2 19.11 2 18V15H4V18H20V6H17.03V4H20C21.11 4 22 4.89 22 6Z";
var mdiCodeBlockBrackets = "M2 3V13H6V11H4V5H6V3H2M12 11H10V13H14V3H10V5H12V11M22 6V18C22 19.11 21.11 20 20 20H4C2.9 20 2 19.11 2 18V15H4V18H20V6H17.03V4H20C21.11 4 22 4.89 22 6Z";
var mdiCodeBlockParentheses = "M11.6 3C13.1 4.3 14 6.1 14 8S13.1 11.7 11.6 13L10 12.4C11.3 11.4 12 9.7 12 8S11.3 4.6 10 3.6L11.6 3M4.4 3L6 3.6C4.7 4.6 4 6.3 4 8S4.7 11.4 6 12.4L4.4 13C2.9 11.7 2 9.9 2 8S2.9 4.3 4.4 3M22 6V18C22 19.11 21.11 20 20 20H4C2.9 20 2 19.11 2 18V15H4V18H20V6H16.03V4H20C21.11 4 22 4.89 22 6Z";
var mdiCodeBlockTags = "M5.59 3.41L7 4.82L3.82 8L7 11.18L5.59 12.6L1 8L5.59 3.41M11.41 3.41L16 8L11.41 12.6L10 11.18L13.18 8L10 4.82L11.41 3.41M22 6V18C22 19.11 21.11 20 20 20H4C2.9 20 2 19.11 2 18V14H4V18H20V6H17.03V4H20C21.11 4 22 4.89 22 6Z";
var mdiCodeBraces = "M8,3A2,2 0 0,0 6,5V9A2,2 0 0,1 4,11H3V13H4A2,2 0 0,1 6,15V19A2,2 0 0,0 8,21H10V19H8V14A2,2 0 0,0 6,12A2,2 0 0,0 8,10V5H10V3M16,3A2,2 0 0,1 18,5V9A2,2 0 0,0 20,11H21V13H20A2,2 0 0,0 18,15V19A2,2 0 0,1 16,21H14V19H16V14A2,2 0 0,1 18,12A2,2 0 0,1 16,10V5H14V3H16Z";
var mdiCodeBracesBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M11 8H9V10C9 11.1 8.1 12 7 12C8.1 12 9 12.9 9 14V16H11V18H9C7.9 18 7 17.1 7 16V15C7 13.9 6.1 13 5 13V11C6.1 11 7 10.1 7 9V8C7 6.9 7.9 6 9 6H11V8M19 13C17.9 13 17 13.9 17 15V16C17 17.1 16.1 18 15 18H13V16H15V14C15 12.9 15.9 12 17 12C15.9 12 15 11.1 15 10V8H13V6H15C16.1 6 17 6.9 17 8V9C17 10.1 17.9 11 19 11V13Z";
var mdiCodeBrackets = "M15,4V6H18V18H15V20H20V4M4,4V20H9V18H6V6H9V4H4Z";
var mdiCodeEqual = "M6,13H11V15H6M13,13H18V15H13M13,9H18V11H13M6,9H11V11H6M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5Z";
var mdiCodeGreaterThan = "M10.41,7.41L15,12L10.41,16.6L9,15.18L12.18,12L9,8.82M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5Z";
var mdiCodeGreaterThanOrEqual = "M13,13H18V15H13M13,9H18V11H13M6.91,7.41L11.5,12L6.91,16.6L5.5,15.18L8.68,12L5.5,8.82M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5Z";
var mdiCodeJson = "M5,3H7V5H5V10A2,2 0 0,1 3,12A2,2 0 0,1 5,14V19H7V21H5C3.93,20.73 3,20.1 3,19V15A2,2 0 0,0 1,13H0V11H1A2,2 0 0,0 3,9V5A2,2 0 0,1 5,3M19,3A2,2 0 0,1 21,5V9A2,2 0 0,0 23,11H24V13H23A2,2 0 0,0 21,15V19A2,2 0 0,1 19,21H17V19H19V14A2,2 0 0,1 21,12A2,2 0 0,1 19,10V5H17V3H19M12,15A1,1 0 0,1 13,16A1,1 0 0,1 12,17A1,1 0 0,1 11,16A1,1 0 0,1 12,15M8,15A1,1 0 0,1 9,16A1,1 0 0,1 8,17A1,1 0 0,1 7,16A1,1 0 0,1 8,15M16,15A1,1 0 0,1 17,16A1,1 0 0,1 16,17A1,1 0 0,1 15,16A1,1 0 0,1 16,15Z";
var mdiCodeLessThan = "M13.59,7.41L9,12L13.59,16.6L15,15.18L11.82,12L15,8.82M19,3C20.11,3 21,3.9 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19Z";
var mdiCodeLessThanOrEqual = "M13,13H18V15H13M13,9H18V11H13M10.09,7.41L11.5,8.82L8.32,12L11.5,15.18L10.09,16.6L5.5,12M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5Z";
var mdiCodeNotEqual = "M6,15H8V17H6M11,13H18V15H11M11,9H18V11H11M6,7H8V13H6M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5Z";
var mdiCodeNotEqualVariant = "M11,6.5V9.33L8.33,12L11,14.67V17.5L5.5,12M13,6.43L18.57,12L13,17.57V14.74L15.74,12L13,9.26M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5Z";
var mdiCodeParentheses = "M17.62,3C19.13,5.27 20,8.55 20,12C20,15.44 19.13,18.72 17.62,21L16,19.96C17.26,18.07 18,15.13 18,12C18,8.87 17.26,5.92 16,4.03L17.62,3M6.38,3L8,4.04C6.74,5.92 6,8.87 6,12C6,15.13 6.74,18.08 8,19.96L6.38,21C4.87,18.73 4,15.45 4,12C4,8.55 4.87,5.27 6.38,3Z";
var mdiCodeParenthesesBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M10 17.3L8.4 18C6.9 16.5 6 14.3 6 12S6.9 7.5 8.4 6L10 6.7C8.7 7.9 8 9.9 8 12S8.7 16.1 10 17.3M15.6 18L14 17.3C15.3 16 16 14.1 16 12S15.3 7.9 14 6.7L15.6 6C17.1 7.5 18 9.7 18 12C18 14.3 17.1 16.5 15.6 18Z";
var mdiCodeString = "M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M12.5,11H11.5A1.5,1.5 0 0,1 10,9.5A1.5,1.5 0 0,1 11.5,8H12.5A1.5,1.5 0 0,1 14,9.5H16A3.5,3.5 0 0,0 12.5,6H11.5A3.5,3.5 0 0,0 8,9.5A3.5,3.5 0 0,0 11.5,13H12.5A1.5,1.5 0 0,1 14,14.5A1.5,1.5 0 0,1 12.5,16H11.5A1.5,1.5 0 0,1 10,14.5H8A3.5,3.5 0 0,0 11.5,18H12.5A3.5,3.5 0 0,0 16,14.5A3.5,3.5 0 0,0 12.5,11Z";
var mdiCodeTags = "M14.6,16.6L19.2,12L14.6,7.4L16,6L22,12L16,18L14.6,16.6M9.4,16.6L4.8,12L9.4,7.4L8,6L2,12L8,18L9.4,16.6Z";
var mdiCodeTagsCheck = "M6.59,3.41L2,8L6.59,12.6L8,11.18L4.82,8L8,4.82L6.59,3.41M12.41,3.41L11,4.82L14.18,8L11,11.18L12.41,12.6L17,8L12.41,3.41M21.59,11.59L13.5,19.68L9.83,16L8.42,17.41L13.5,22.5L23,13L21.59,11.59Z";
var mdiCodepen = "M8.21 12L6.88 12.89V11.11L8.21 12M11.47 9.82V7.34L7.31 10.12L9.16 11.36L11.47 9.82M16.7 10.12L12.53 7.34V9.82L14.84 11.36L16.7 10.12M7.31 13.88L11.47 16.66V14.18L9.16 12.64L7.31 13.88M12.53 14.18V16.66L16.7 13.88L14.84 12.64L12.53 14.18M12 10.74L10.12 12L12 13.26L13.88 12L12 10.74M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12M18.18 10.12C18.18 10.09 18.18 10.07 18.18 10.05L18.17 10L18.17 10L18.16 9.95C18.15 9.94 18.15 9.93 18.14 9.91L18.13 9.89L18.11 9.85L18.1 9.83L18.08 9.8L18.06 9.77L18.03 9.74L18 9.72L18 9.7L17.96 9.68L17.95 9.67L12.3 5.91C12.12 5.79 11.89 5.79 11.71 5.91L6.05 9.67L6.05 9.68L6 9.7C6 9.71 6 9.72 6 9.72L5.97 9.74L5.94 9.77L5.93 9.8L5.9 9.83L5.89 9.85L5.87 9.89L5.86 9.91L5.84 9.95L5.84 10L5.83 10L5.82 10.05C5.82 10.07 5.82 10.09 5.82 10.12V13.88C5.82 13.91 5.82 13.93 5.82 13.95L5.83 14L5.84 14L5.84 14.05C5.85 14.06 5.85 14.07 5.86 14.09L5.87 14.11L5.89 14.15L5.9 14.17L5.92 14.2L5.94 14.23C5.95 14.24 5.96 14.25 5.97 14.26L6 14.28L6 14.3L6.04 14.32L6.05 14.33L11.71 18.1C11.79 18.16 11.9 18.18 12 18.18C12.1 18.18 12.21 18.15 12.3 18.1L17.95 14.33L17.96 14.32L18 14.3L18 14.28L18.03 14.26L18.06 14.23L18.08 14.2L18.1 14.17L18.11 14.15L18.13 14.11L18.14 14.09L18.16 14.05L18.16 14L18.17 14L18.18 13.95C18.18 13.93 18.18 13.91 18.18 13.88V10.12M17.12 12.89V11.11L15.79 12L17.12 12.89Z";
var mdiCoffee = "M2,21H20V19H2M20,8H18V5H20M20,3H4V13A4,4 0 0,0 8,17H14A4,4 0 0,0 18,13V10H20A2,2 0 0,0 22,8V5C22,3.89 21.1,3 20,3Z";
var mdiCoffeeMaker = "M18 6V4H20V2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H20V20H15.97C17.2 19.09 18 17.64 18 16V11H8V16C8 17.64 8.81 19.09 10.03 20H6V4H8V6C8 6.55 8.45 7 9 7H17C17.55 7 18 6.55 18 6M13 8C13.55 8 14 8.45 14 9S13.55 10 13 10 12 9.55 12 9 12.45 8 13 8Z";
var mdiCoffeeMakerCheck = "M17.75 21.16L15 18.16L16.16 17L17.75 18.59L21.34 15L22.5 16.41L17.75 21.16M13 18C13 15.78 14.21 13.85 16 12.81V11H6V16C6 17.64 6.81 19.09 8.03 20H4V4H6V6C6 6.55 6.45 7 7 7H15C15.55 7 16 6.55 16 6V4H18V2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H14.54C13.58 20.94 13 19.54 13 18M10 9C10 9.55 10.45 10 11 10S12 9.55 12 9 11.55 8 11 8 10 8.45 10 9Z";
var mdiCoffeeMakerCheckOutline = "M17.75 21.16L15 18.16L16.16 17L17.75 18.59L21.34 15L22.5 16.41L17.75 21.16M13 18.21C12.5 18.7 11.78 19 11 19C9.35 19 8 17.65 8 16V13H14V14.69C14.5 13.92 15.2 13.27 16 12.81V11H6V16C6 17.64 6.81 19.09 8.03 20H4V4H6V6C6 6.55 6.45 7 7 7H15C15.55 7 16 6.55 16 6V4H18V2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H14.54C13.63 21 13.06 19.67 13 18.21M10 9C10 9.55 10.45 10 11 10S12 9.55 12 9 11.55 8 11 8 10 8.45 10 9Z";
var mdiCoffeeMakerOutline = "M18 6V4H20V2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H20V20H15.97C17.2 19.09 18 17.64 18 16V11H8V16C8 17.64 8.81 19.09 10.03 20H6V4H8V6C8 6.55 8.45 7 9 7H17C17.55 7 18 6.55 18 6M10 16V13H16V16C16 17.65 14.65 19 13 19S10 17.65 10 16M13 8C13.55 8 14 8.45 14 9S13.55 10 13 10 12 9.55 12 9 12.45 8 13 8Z";
var mdiCoffeeOff = "M3.27 2L22 20.72L20.72 22L19.73 21H2V19H17.73L15.44 16.71C15 16.89 14.5 17 14 17H8C5.79 17 4 15.21 4 13V5.27L2 3.27L3.27 2M22 5V8C22 9.1 21.1 10 20 10H18V13C18 13.36 17.94 13.7 17.85 14.04L6.81 3H20C21.1 3 22 3.89 22 5M20 5H18V8H20V5Z";
var mdiCoffeeOffOutline = "M2 3.27L4 5.27V13C4 15.21 5.79 17 8 17H14C14.5 17 15 16.89 15.44 16.71L17.73 19H2V21H19.73L20.72 22L22 20.72L3.27 2L2 3.27M8 15C6.9 15 6 14.1 6 13V7.27L13.73 15H8M20 3H6.81L8.81 5H16V12.19L17.85 14.04C17.94 13.7 18 13.36 18 13V10H20C21.1 10 22 9.1 22 8V5C22 3.9 21.1 3 20 3M20 8H18V5H20V8Z";
var mdiCoffeeOutline = "M2,21V19H20V21H2M20,8V5H18V8H20M20,3A2,2 0 0,1 22,5V8A2,2 0 0,1 20,10H18V13A4,4 0 0,1 14,17H8A4,4 0 0,1 4,13V3H20M16,5H6V13A2,2 0 0,0 8,15H14A2,2 0 0,0 16,13V5Z";
var mdiCoffeeToGo = "M3,19V17H17L15.26,15.24L16.67,13.83L20.84,18L16.67,22.17L15.26,20.76L17,19H3M17,8V5H15V8H17M17,3C18.11,3 19,3.9 19,5V8C19,9.11 18.11,10 17,10H15V11A4,4 0 0,1 11,15H7A4,4 0 0,1 3,11V3H17Z";
var mdiCoffeeToGoOutline = "M3 3V11A4 4 0 0 0 7 15H11A4 4 0 0 0 15 11V10H17C18.11 10 19 9.11 19 8V5C19 3.9 18.11 3 17 3H3M5 5H13V11A2 2 0 0 1 11 13H7A2 2 0 0 1 5 11V5M15 5H17V8H15V5M16.67 13.83L15.26 15.24L17 17H3V19H17L15.26 20.76L16.67 22.17L20.84 18L16.67 13.83Z";
var mdiCoffin = "M8,22L5,8L8,2H16L19,8L16,22H8M11,6V8H9V10H11V15H13V10H15V8H13V6H11Z";
var mdiCog = "M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z";
var mdiCogBox = "M17.25,12C17.25,12.23 17.23,12.46 17.2,12.68L18.68,13.84C18.81,13.95 18.85,14.13 18.76,14.29L17.36,16.71C17.27,16.86 17.09,16.92 16.93,16.86L15.19,16.16C14.83,16.44 14.43,16.67 14,16.85L13.75,18.7C13.72,18.87 13.57,19 13.4,19H10.6C10.43,19 10.28,18.87 10.25,18.7L10,16.85C9.56,16.67 9.17,16.44 8.81,16.16L7.07,16.86C6.91,16.92 6.73,16.86 6.64,16.71L5.24,14.29C5.15,14.13 5.19,13.95 5.32,13.84L6.8,12.68C6.77,12.46 6.75,12.23 6.75,12C6.75,11.77 6.77,11.54 6.8,11.32L5.32,10.16C5.19,10.05 5.15,9.86 5.24,9.71L6.64,7.29C6.73,7.13 6.91,7.07 7.07,7.13L8.81,7.84C9.17,7.56 9.56,7.32 10,7.15L10.25,5.29C10.28,5.13 10.43,5 10.6,5H13.4C13.57,5 13.72,5.13 13.75,5.29L14,7.15C14.43,7.32 14.83,7.56 15.19,7.84L16.93,7.13C17.09,7.07 17.27,7.13 17.36,7.29L18.76,9.71C18.85,9.86 18.81,10.05 18.68,10.16L17.2,11.32C17.23,11.54 17.25,11.77 17.25,12M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M12,10C10.89,10 10,10.89 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12C14,10.89 13.1,10 12,10Z";
var mdiCogClockwise = "M12 3C7.03 3 3 7.03 3 12S7.03 21 12 21C14 21 15.92 20.34 17.5 19.14L16.06 17.7C14.87 18.54 13.45 19 12 19C8.13 19 5 15.87 5 12S8.13 5 12 5 19 8.13 19 12H16L20 16L24 12H21C21 7.03 16.97 3 12 3M7.71 13.16C7.62 13.23 7.59 13.35 7.64 13.45L8.54 15C8.6 15.12 8.72 15.12 8.82 15.12L9.95 14.67C10.19 14.83 10.44 14.97 10.7 15.09L10.88 16.28C10.9 16.39 11 16.47 11.1 16.47H12.9C13 16.5 13.11 16.41 13.13 16.3L13.31 15.12C13.58 15 13.84 14.85 14.07 14.67L15.19 15.12C15.3 15.16 15.42 15.11 15.47 15L16.37 13.5C16.42 13.38 16.39 13.26 16.31 13.19L15.31 12.45C15.34 12.15 15.34 11.85 15.31 11.55L16.31 10.79C16.4 10.72 16.42 10.61 16.37 10.5L15.47 8.95C15.41 8.85 15.3 8.81 15.19 8.85L14.07 9.3C13.83 9.13 13.57 9 13.3 8.88L13.13 7.69C13.11 7.58 13 7.5 12.9 7.5H11.14C11.04 7.5 10.95 7.57 10.93 7.67L10.76 8.85C10.5 8.97 10.23 9.12 10 9.3L8.85 8.88C8.74 8.84 8.61 8.89 8.56 9L7.65 10.5C7.6 10.62 7.63 10.74 7.71 10.81L8.71 11.55C8.69 11.7 8.69 11.85 8.71 12C8.7 12.15 8.7 12.3 8.71 12.45L7.71 13.19M12 13.5H12C11.16 13.5 10.5 12.82 10.5 12C10.5 11.17 11.17 10.5 12 10.5S13.5 11.17 13.5 12 12.83 13.5 12 13.5";
var mdiCogCounterclockwise = "M12 3C7.03 3 3 7.03 3 12H0L4 16L8 12H5C5 8.13 8.13 5 12 5S19 8.13 19 12 15.87 19 12 19C10.55 19 9.13 18.54 7.94 17.7L6.5 19.14C8.08 20.34 10 21 12 21C16.97 21 21 16.97 21 12S16.97 3 12 3M16.29 13.19L15.29 12.45C15.3 12.3 15.3 12.15 15.29 12C15.31 11.85 15.31 11.7 15.29 11.55L16.29 10.81C16.37 10.74 16.4 10.62 16.35 10.5L15.44 9C15.39 8.89 15.26 8.84 15.15 8.88L14 9.3C13.77 9.12 13.5 8.97 13.24 8.85L13.07 7.67C13.05 7.57 12.96 7.5 12.86 7.5H11.1C11 7.5 10.89 7.58 10.87 7.69L10.7 8.88C10.43 9 10.17 9.13 9.93 9.3L8.81 8.85C8.71 8.81 8.59 8.85 8.53 8.95L7.63 10.5C7.58 10.61 7.6 10.72 7.69 10.79L8.69 11.55C8.66 11.85 8.66 12.15 8.69 12.45L7.69 13.19C7.61 13.26 7.58 13.38 7.63 13.5L8.53 15C8.58 15.11 8.7 15.16 8.81 15.12L9.93 14.67C10.16 14.85 10.42 15 10.69 15.12L10.87 16.3C10.89 16.41 11 16.5 11.1 16.47H12.9C13 16.47 13.11 16.39 13.12 16.28L13.3 15.09C13.56 14.97 13.81 14.83 14.05 14.67L15.18 15.12C15.28 15.12 15.4 15.12 15.46 15L16.36 13.45C16.41 13.35 16.38 13.23 16.29 13.16M12 13.5C11.17 13.5 10.5 12.83 10.5 12S11.17 10.5 12 10.5 13.5 11.17 13.5 12C13.5 12.82 12.84 13.5 12 13.5H12";
var mdiCogOff = "M22.12 21.46L2.4 1.73L1.12 3L4 5.87L2.34 8.73C2.21 8.95 2.27 9.22 2.46 9.37L4.57 11C4.53 11.34 4.5 11.67 4.5 12S4.53 12.65 4.57 12.97L2.46 14.63C2.27 14.78 2.21 15.05 2.34 15.27L4.34 18.73C4.46 18.95 4.73 19.03 4.95 18.95L7.44 17.94C7.96 18.34 8.5 18.68 9.13 18.93L9.5 21.58C9.54 21.82 9.75 22 10 22H14C14.25 22 14.46 21.82 14.5 21.58L14.87 18.93C15.38 18.72 15.83 18.45 16.26 18.14L20.85 22.73L22.12 21.46M12 15.5C10.07 15.5 8.5 13.93 8.5 12C8.5 11.5 8.62 11.08 8.79 10.67L13.33 15.21C12.92 15.39 12.5 15.5 12 15.5M11.74 8.53L8.56 5.35C8.75 5.25 8.93 5.15 9.13 5.07L9.5 2.42C9.54 2.18 9.75 2 10 2H14C14.25 2 14.46 2.18 14.5 2.42L14.87 5.07C15.5 5.32 16.04 5.66 16.56 6.05L19.05 5.05C19.27 4.96 19.54 5.05 19.66 5.27L21.66 8.73C21.78 8.95 21.73 9.22 21.54 9.37L19.43 11C19.47 11.34 19.5 11.67 19.5 12S19.47 12.65 19.43 12.97L21.54 14.63C21.73 14.78 21.78 15.05 21.66 15.27L20.5 17.29L15.47 12.26C15.5 12.18 15.5 12.09 15.5 12C15.5 10.07 13.93 8.5 12 8.5C11.91 8.5 11.83 8.5 11.74 8.53Z";
var mdiCogOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L4 5.88L2.34 8.73C2.21 8.95 2.27 9.22 2.46 9.37L4.57 11L4.5 12L4.57 12.97L2.46 14.63C2.27 14.78 2.21 15.05 2.34 15.27L4.34 18.73C4.46 18.95 4.73 19.03 4.95 18.95L7.44 17.94C7.96 18.34 8.5 18.68 9.13 18.93L9.5 21.58C9.54 21.82 9.75 22 10 22H14C14.25 22 14.46 21.82 14.5 21.58L14.87 18.93C15.38 18.73 15.83 18.45 16.26 18.15L20.84 22.73L22.11 21.46M10 11.9L12.1 14C12.06 14 12.03 14 12 14C10.9 14 10 13.11 10 12C10 11.97 10 11.94 10 11.9M13.13 17.39L12.76 20H11.24L10.87 17.38C9.68 17.14 8.63 16.5 7.86 15.62L5.43 16.66L4.68 15.36L6.8 13.8C6.4 12.64 6.4 11.37 6.8 10.2L4.69 8.65L5.44 7.35L5.5 7.37L8.4 10.29C8.15 10.8 8 11.38 8 12C8 14.21 9.79 16 12 16C12.62 16 13.2 15.86 13.71 15.6L14.83 16.72C14.31 17.03 13.74 17.26 13.13 17.39M10.06 6.86L8.55 5.35C8.74 5.26 8.93 5.15 9.13 5.07L9.5 2.42C9.54 2.18 9.75 2 10 2H14C14.25 2 14.46 2.18 14.5 2.42L14.87 5.07C15.5 5.32 16.04 5.66 16.56 6.05L19.05 5.05C19.27 4.96 19.54 5.05 19.66 5.27L21.66 8.73C21.79 8.95 21.73 9.22 21.54 9.37L19.43 11L19.5 12L19.43 13L21.54 14.63C21.73 14.78 21.79 15.05 21.66 15.27L20.5 17.29L19.04 15.84L19.32 15.36L17.2 13.81C17.6 12.64 17.6 11.37 17.2 10.2L19.31 8.65L18.56 7.35L16.15 8.39C15.38 7.5 14.32 6.86 13.12 6.62L12.75 4H11.25L10.88 6.61C10.6 6.67 10.32 6.75 10.06 6.86M12 8C14.21 8 16 9.79 16 12C16 12.25 15.97 12.5 15.93 12.73L11.27 8.07C11.5 8.03 11.75 8 12 8Z";
var mdiCogOutline = "M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M10,22C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.79,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,13L21.54,14.63C21.73,14.78 21.79,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.04 19.05,18.95L16.56,17.95C16.04,18.34 15.5,18.68 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10M11.25,4L10.88,6.61C9.68,6.86 8.62,7.5 7.85,8.39L5.44,7.35L4.69,8.65L6.8,10.2C6.4,11.37 6.4,12.64 6.8,13.8L4.68,15.36L5.43,16.66L7.86,15.62C8.63,16.5 9.68,17.14 10.87,17.38L11.24,20H12.76L13.13,17.39C14.32,17.14 15.37,16.5 16.14,15.62L18.57,16.66L19.32,15.36L17.2,13.81C17.6,12.64 17.6,11.37 17.2,10.2L19.31,8.65L18.56,7.35L16.15,8.39C15.38,7.5 14.32,6.86 13.12,6.62L12.75,4H11.25Z";
var mdiCogPause = "M13.53 22H10C9.75 22 9.54 21.82 9.5 21.58L9.13 18.93C8.5 18.68 7.96 18.34 7.44 17.94L4.95 18.95C4.73 19.03 4.46 18.95 4.34 18.73L2.34 15.27C2.21 15.05 2.27 14.78 2.46 14.63L4.57 12.97C4.53 12.65 4.5 12.33 4.5 12S4.53 11.34 4.57 11L2.46 9.37C2.27 9.22 2.21 8.95 2.34 8.73L4.34 5.27C4.46 5.05 4.73 4.96 4.95 5.05L7.44 6.05C7.96 5.66 8.5 5.32 9.13 5.07L9.5 2.42C9.54 2.18 9.75 2 10 2H14C14.25 2 14.46 2.18 14.5 2.42L14.87 5.07C15.5 5.32 16.04 5.66 16.56 6.05L19.05 5.05C19.27 4.96 19.54 5.05 19.66 5.27L21.66 8.73C21.78 8.95 21.73 9.22 21.54 9.37L19.43 11C19.47 11.34 19.5 11.67 19.5 12C19.5 12.06 19.5 12.12 19.5 12.19C19 12.07 18.5 12 18 12C17.08 12 16.22 12.21 15.44 12.58C15.47 12.39 15.5 12.2 15.5 12C15.5 10.07 13.93 8.5 12 8.5S8.5 10.07 8.5 12 10.07 15.5 12 15.5C12.2 15.5 12.39 15.47 12.58 15.44C12.21 16.22 12 17.08 12 18C12 19.54 12.58 20.94 13.53 22M19 15H21V21H19M15 15H17V21H15V15Z";
var mdiCogPauseOutline = "M13.54 22H10C9.75 22 9.54 21.82 9.5 21.58L9.13 18.93C8.5 18.68 7.96 18.34 7.44 17.94L4.95 18.95C4.73 19.03 4.46 18.95 4.34 18.73L2.34 15.27C2.21 15.05 2.27 14.78 2.46 14.63L4.57 12.97L4.5 12L4.57 11L2.46 9.37C2.27 9.22 2.21 8.95 2.34 8.73L4.34 5.27C4.46 5.05 4.73 4.96 4.95 5.05L7.44 6.05C7.96 5.66 8.5 5.32 9.13 5.07L9.5 2.42C9.54 2.18 9.75 2 10 2H14C14.25 2 14.46 2.18 14.5 2.42L14.87 5.07C15.5 5.32 16.04 5.66 16.56 6.05L19.05 5.05C19.27 4.96 19.54 5.05 19.66 5.27L21.66 8.73C21.79 8.95 21.73 9.22 21.54 9.37L19.43 11L19.5 12L19.5 12.19C19 12.07 18.5 12 18 12C17.83 12 17.66 12 17.5 12.03C17.5 11.41 17.4 10.79 17.2 10.2L19.31 8.65L18.56 7.35L16.15 8.39C15.38 7.5 14.32 6.86 13.12 6.62L12.75 4H11.25L10.88 6.61C9.68 6.86 8.62 7.5 7.85 8.39L5.44 7.35L4.69 8.65L6.8 10.2C6.4 11.37 6.4 12.64 6.8 13.8L4.68 15.36L5.43 16.66L7.86 15.62C8.63 16.5 9.68 17.14 10.87 17.38L11.24 20H12.35C12.61 20.75 13 21.42 13.54 22M12.36 15.96C12.24 16 12.12 16 12 16C9.79 16 8 14.21 8 12S9.79 8 12 8 16 9.79 16 12C16 12.12 16 12.24 15.96 12.36C14.29 12.97 12.97 14.29 12.36 15.96M14 12C14 10.9 13.11 10 12 10S10 10.9 10 12 10.9 14 12 14 14 13.11 14 12M19 15H21V21H19M15 15H17V21H15V15Z";
var mdiCogPlay = "M13.53 22H10C9.75 22 9.54 21.82 9.5 21.58L9.13 18.93C8.5 18.68 7.96 18.34 7.44 17.94L4.95 18.95C4.73 19.03 4.46 18.95 4.34 18.73L2.34 15.27C2.21 15.05 2.27 14.78 2.46 14.63L4.57 12.97C4.53 12.65 4.5 12.33 4.5 12S4.53 11.34 4.57 11L2.46 9.37C2.27 9.22 2.21 8.95 2.34 8.73L4.34 5.27C4.46 5.05 4.73 4.96 4.95 5.05L7.44 6.05C7.96 5.66 8.5 5.32 9.13 5.07L9.5 2.42C9.54 2.18 9.75 2 10 2H14C14.25 2 14.46 2.18 14.5 2.42L14.87 5.07C15.5 5.32 16.04 5.66 16.56 6.05L19.05 5.05C19.27 4.96 19.54 5.05 19.66 5.27L21.66 8.73C21.78 8.95 21.73 9.22 21.54 9.37L19.43 11C19.47 11.34 19.5 11.67 19.5 12V12.19C19 12.07 18.5 12 18 12C17.08 12 16.22 12.21 15.44 12.58C15.47 12.39 15.5 12.2 15.5 12C15.5 10.07 13.93 8.5 12 8.5S8.5 10.07 8.5 12 10.07 15.5 12 15.5C12.2 15.5 12.39 15.47 12.58 15.44C12.21 16.22 12 17.08 12 18C12 19.54 12.58 20.94 13.53 22M16 15V21L21 18L16 15Z";
var mdiCogPlayOutline = "M13.54 22H10C9.75 22 9.54 21.82 9.5 21.58L9.13 18.93C8.5 18.68 7.96 18.34 7.44 17.94L4.95 18.95C4.73 19.03 4.46 18.95 4.34 18.73L2.34 15.27C2.21 15.05 2.27 14.78 2.46 14.63L4.57 12.97L4.5 12L4.57 11L2.46 9.37C2.27 9.22 2.21 8.95 2.34 8.73L4.34 5.27C4.46 5.05 4.73 4.96 4.95 5.05L7.44 6.05C7.96 5.66 8.5 5.32 9.13 5.07L9.5 2.42C9.54 2.18 9.75 2 10 2H14C14.25 2 14.46 2.18 14.5 2.42L14.87 5.07C15.5 5.32 16.04 5.66 16.56 6.05L19.05 5.05C19.27 4.96 19.54 5.05 19.66 5.27L21.66 8.73C21.79 8.95 21.73 9.22 21.54 9.37L19.43 11L19.5 12V12.19C19 12.07 18.5 12 18 12C17.83 12 17.66 12 17.5 12.03C17.5 11.41 17.4 10.79 17.2 10.2L19.31 8.65L18.56 7.35L16.15 8.39C15.38 7.5 14.32 6.86 13.12 6.62L12.75 4H11.25L10.88 6.61C9.68 6.86 8.62 7.5 7.85 8.39L5.44 7.35L4.69 8.65L6.8 10.2C6.4 11.37 6.4 12.64 6.8 13.8L4.68 15.36L5.43 16.66L7.86 15.62C8.63 16.5 9.68 17.14 10.87 17.38L11.24 20H12.35C12.61 20.75 13 21.42 13.54 22M15.96 12.36C16 12.24 16 12.12 16 12C16 9.79 14.21 8 12 8S8 9.79 8 12 9.79 16 12 16C12.12 16 12.24 16 12.36 15.96C12.97 14.29 14.29 12.97 15.96 12.36M12 14C10.9 14 10 13.11 10 12S10.9 10 12 10 14 10.9 14 12 13.11 14 12 14M16 15V21L21 18L16 15Z";
var mdiCogRefresh = "M18 14.5C19.1 14.5 20.1 14.9 20.8 15.7L22 14.5V18.5H18L19.8 16.7C19.3 16.3 18.7 16 18 16C16.6 16 15.5 17.1 15.5 18.5S16.6 21 18 21C18.8 21 19.5 20.6 20 20H21.7C21.1 21.5 19.7 22.5 18 22.5C15.8 22.5 14 20.7 14 18.5S15.8 14.5 18 14.5M11.5 18.5C11.5 17.4 11.8 16.4 12.2 15.5H12C10.1 15.5 8.5 13.9 8.5 12S10.1 8.5 12 8.5 15.5 10.1 15.5 12C15.5 12.2 15.5 12.4 15.4 12.5C16.2 12.2 17 12 18 12C18.5 12 19 12.1 19.5 12.2V12C19.5 11.7 19.5 11.3 19.4 11L21.5 9.4C21.7 9.2 21.7 9 21.6 8.8L19.6 5.3C19.5 5 19.3 5 19 5L16.5 6C16 5.6 15.4 5.3 14.8 5L14.4 2.3C14.5 2.2 14.2 2 14 2H10C9.8 2 9.5 2.2 9.5 2.4L9.1 5.1C8.5 5.3 8 5.7 7.4 6L5 5C4.7 5 4.5 5 4.3 5.3L2.3 8.8C2.2 9 2.3 9.2 2.5 9.4L4.6 11C4.6 11.3 4.5 11.7 4.5 12S4.5 12.7 4.6 13L2.5 14.7C2.3 14.9 2.3 15.1 2.4 15.3L4.4 18.8C4.5 19 4.7 19 5 19L7.5 18C8 18.4 8.6 18.7 9.2 19L9.6 21.7C9.6 21.9 9.8 22.1 10.1 22.1H12.6C11.9 21 11.5 19.8 11.5 18.5Z";
var mdiCogRefreshOutline = "M18 14.5C19.1 14.5 20.1 14.9 20.8 15.7L22 14.5V18.5H18L19.8 16.7C19.3 16.3 18.7 16 18 16C16.6 16 15.5 17.1 15.5 18.5S16.6 21 18 21C18.8 21 19.5 20.6 20 20H21.7C21.1 21.5 19.7 22.5 18 22.5C15.8 22.5 14 20.7 14 18.5S15.8 14.5 18 14.5M11.7 20H11.3L10.9 17.4C9.7 17.2 8.7 16.5 7.9 15.6L5.5 16.6L4.7 15.3L6.8 13.7C6.4 12.5 6.4 11.3 6.8 10.1L4.7 8.7L5.5 7.4L7.9 8.4C8.7 7.5 9.7 6.9 10.9 6.6L11.2 4H12.7L13.1 6.6C14.3 6.8 15.4 7.5 16.1 8.4L18.5 7.4L19.3 8.7L17.2 10.2C17.4 10.8 17.5 11.4 17.5 12H18C18.5 12 19 12.1 19.5 12.2V12L19.4 11L21.5 9.4C21.7 9.2 21.7 9 21.6 8.8L19.6 5.3C19.5 5 19.3 5 19 5L16.5 6C16 5.6 15.4 5.3 14.8 5L14.4 2.3C14.5 2.2 14.2 2 14 2H10C9.8 2 9.5 2.2 9.5 2.4L9.1 5.1C8.5 5.3 8 5.7 7.4 6L5 5C4.7 5 4.5 5 4.3 5.3L2.3 8.8C2.2 9 2.3 9.2 2.5 9.4L4.6 11L4.5 12L4.6 13L2.5 14.7C2.3 14.9 2.3 15.1 2.4 15.3L4.4 18.8C4.5 19 4.7 19 5 19L7.5 18C8 18.4 8.6 18.7 9.2 19L9.6 21.7C9.6 21.9 9.8 22.1 10.1 22.1H12.6C12.1 21.4 11.9 20.7 11.7 20M16 12.3V12C16 9.8 14.2 8 12 8S8 9.8 8 12C8 14.2 9.8 16 12 16C12.7 14.3 14.2 12.9 16 12.3M10 12C10 10.9 10.9 10 12 10S14 10.9 14 12 13.1 14 12 14 10 13.1 10 12Z";
var mdiCogStop = "M13.53 22H10C9.75 22 9.54 21.82 9.5 21.58L9.13 18.93C8.5 18.68 7.96 18.34 7.44 17.94L4.95 18.95C4.73 19.03 4.46 18.95 4.34 18.73L2.34 15.27C2.21 15.05 2.27 14.78 2.46 14.63L4.57 12.97C4.53 12.65 4.5 12.33 4.5 12S4.53 11.34 4.57 11L2.46 9.37C2.27 9.22 2.21 8.95 2.34 8.73L4.34 5.27C4.46 5.05 4.73 4.96 4.95 5.05L7.44 6.05C7.96 5.66 8.5 5.32 9.13 5.07L9.5 2.42C9.54 2.18 9.75 2 10 2H14C14.25 2 14.46 2.18 14.5 2.42L14.87 5.07C15.5 5.32 16.04 5.66 16.56 6.05L19.05 5.05C19.27 4.96 19.54 5.05 19.66 5.27L21.66 8.73C21.78 8.95 21.73 9.22 21.54 9.37L19.43 11C19.47 11.34 19.5 11.67 19.5 12C19.5 12.06 19.5 12.12 19.5 12.19C19 12.07 18.5 12 18 12C17.08 12 16.22 12.21 15.44 12.58C15.47 12.39 15.5 12.2 15.5 12C15.5 10.07 13.93 8.5 12 8.5S8.5 10.07 8.5 12 10.07 15.5 12 15.5C12.2 15.5 12.39 15.47 12.58 15.44C12.21 16.22 12 17.08 12 18C12 19.54 12.58 20.94 13.53 22M21 15H15V21H21V15Z";
var mdiCogStopOutline = "M13.54 22H10C9.75 22 9.54 21.82 9.5 21.58L9.13 18.93C8.5 18.68 7.96 18.34 7.44 17.94L4.95 18.95C4.73 19.03 4.46 18.95 4.34 18.73L2.34 15.27C2.21 15.05 2.27 14.78 2.46 14.63L4.57 12.97L4.5 12L4.57 11L2.46 9.37C2.27 9.22 2.21 8.95 2.34 8.73L4.34 5.27C4.46 5.05 4.73 4.96 4.95 5.05L7.44 6.05C7.96 5.66 8.5 5.32 9.13 5.07L9.5 2.42C9.54 2.18 9.75 2 10 2H14C14.25 2 14.46 2.18 14.5 2.42L14.87 5.07C15.5 5.32 16.04 5.66 16.56 6.05L19.05 5.05C19.27 4.96 19.54 5.05 19.66 5.27L21.66 8.73C21.79 8.95 21.73 9.22 21.54 9.37L19.43 11L19.5 12L19.5 12.19C19 12.07 18.5 12 18 12C17.83 12 17.66 12 17.5 12.03C17.5 11.41 17.4 10.79 17.2 10.2L19.31 8.65L18.56 7.35L16.15 8.39C15.38 7.5 14.32 6.86 13.12 6.62L12.75 4H11.25L10.88 6.61C9.68 6.86 8.62 7.5 7.85 8.39L5.44 7.35L4.69 8.65L6.8 10.2C6.4 11.37 6.4 12.64 6.8 13.8L4.68 15.36L5.43 16.66L7.86 15.62C8.63 16.5 9.68 17.14 10.87 17.38L11.24 20H12.35C12.61 20.75 13 21.42 13.54 22M12.36 15.96C12.24 16 12.12 16 12 16C9.79 16 8 14.21 8 12S9.79 8 12 8 16 9.79 16 12C16 12.12 16 12.24 15.96 12.36C14.29 12.97 12.97 14.29 12.36 15.96M14 12C14 10.9 13.11 10 12 10S10 10.9 10 12 10.9 14 12 14 14 13.11 14 12M15 15H21V21H15V15Z";
var mdiCogSync = "M11.5 18.5C11.5 17.4 11.8 16.4 12.2 15.5H12C10.1 15.5 8.5 13.9 8.5 12S10.1 8.5 12 8.5 15.5 10.1 15.5 12C15.5 12.2 15.5 12.4 15.4 12.5C16.2 12.2 17 12 18 12C18.5 12 19 12.1 19.5 12.2V12C19.5 11.7 19.5 11.3 19.4 11L21.5 9.4C21.7 9.2 21.7 9 21.6 8.8L19.6 5.3C19.5 5 19.3 5 19 5L16.5 6C16 5.6 15.4 5.3 14.8 5L14.4 2.3C14.5 2.2 14.2 2 14 2H10C9.8 2 9.5 2.2 9.5 2.4L9.1 5.1C8.5 5.3 8 5.7 7.4 6L5 5C4.7 5 4.5 5 4.3 5.3L2.3 8.8C2.2 9 2.3 9.2 2.5 9.4L4.6 11C4.6 11.3 4.5 11.7 4.5 12S4.5 12.7 4.6 13L2.5 14.7C2.3 14.9 2.3 15.1 2.4 15.3L4.4 18.8C4.5 19 4.7 19 5 19L7.5 18C8 18.4 8.6 18.7 9.2 19L9.6 21.7C9.6 21.9 9.8 22.1 10.1 22.1H12.6C11.9 21 11.5 19.8 11.5 18.5M18 14.5V13L15.8 15.2L18 17.4V16C19.4 16 20.5 17.1 20.5 18.5C20.5 18.9 20.4 19.3 20.2 19.6L21.3 20.7C22.5 18.9 22 16.4 20.2 15.2C19.6 14.7 18.8 14.5 18 14.5M18 21C16.6 21 15.5 19.9 15.5 18.5C15.5 18.1 15.6 17.7 15.8 17.4L14.7 16.3C13.5 18.1 14 20.6 15.8 21.8C16.5 22.2 17.2 22.5 18 22.5V24L20.2 21.8L18 19.5V21Z";
var mdiCogSyncOutline = "M11.7 20H11.3L10.9 17.4C9.7 17.2 8.7 16.5 7.9 15.6L5.5 16.6L4.7 15.3L6.8 13.7C6.4 12.5 6.4 11.3 6.8 10.1L4.7 8.7L5.5 7.4L7.9 8.4C8.7 7.5 9.7 6.9 10.9 6.6L11.2 4H12.7L13.1 6.6C14.3 6.8 15.4 7.5 16.1 8.4L18.5 7.4L19.3 8.7L17.2 10.2C17.4 10.8 17.5 11.4 17.5 12H18C18.5 12 19 12.1 19.5 12.2V12L19.4 11L21.5 9.4C21.7 9.2 21.7 9 21.6 8.8L19.6 5.3C19.5 5 19.3 5 19 5L16.5 6C16 5.6 15.4 5.3 14.8 5L14.4 2.3C14.5 2.2 14.2 2 14 2H10C9.8 2 9.5 2.2 9.5 2.4L9.1 5.1C8.5 5.3 8 5.7 7.4 6L5 5C4.7 5 4.5 5 4.3 5.3L2.3 8.8C2.2 9 2.3 9.2 2.5 9.4L4.6 11L4.5 12L4.6 13L2.5 14.7C2.3 14.9 2.3 15.1 2.4 15.3L4.4 18.8C4.5 19 4.7 19 5 19L7.5 18C8 18.4 8.6 18.7 9.2 19L9.6 21.7C9.6 21.9 9.8 22.1 10.1 22.1H12.6C12.1 21.4 11.9 20.7 11.7 20M16 12.3V12C16 9.8 14.2 8 12 8S8 9.8 8 12C8 14.2 9.8 16 12 16C12.7 14.3 14.2 12.9 16 12.3M10 12C10 10.9 10.9 10 12 10S14 10.9 14 12 13.1 14 12 14 10 13.1 10 12M18 14.5V13L15.8 15.2L18 17.4V16C19.4 16 20.5 17.1 20.5 18.5C20.5 18.9 20.4 19.3 20.2 19.6L21.3 20.7C22.5 18.9 22 16.4 20.2 15.2C19.6 14.7 18.8 14.5 18 14.5M18 21C16.6 21 15.5 19.9 15.5 18.5C15.5 18.1 15.6 17.7 15.8 17.4L14.7 16.3C13.5 18.1 14 20.6 15.8 21.8C16.5 22.2 17.2 22.5 18 22.5V24L20.2 21.8L18 19.5V21Z";
var mdiCogTransfer = "M14 18V16L10 19.5L14 23V21H17V18H14M22 15.5L18 12V14H15V17H18V19L22 15.5M21.66 8.73L19.66 5.27C19.54 5.05 19.28 4.96 19.05 5.05L16.56 6.05C16.05 5.64 15.5 5.31 14.87 5.05L14.5 2.42C14.46 2.18 14.25 2 14 2H10C9.75 2 9.54 2.18 9.5 2.42L9.13 5.07C8.5 5.33 7.96 5.66 7.44 6.07L5 5.05C4.77 4.96 4.5 5.05 4.39 5.27L2.39 8.73C2.26 8.94 2.31 9.22 2.5 9.37L4.57 11C4.53 11.33 4.5 11.67 4.5 12C4.5 12.33 4.53 12.67 4.57 13L2.46 14.63C2.26 14.78 2.21 15.06 2.34 15.27L4.34 18.73C4.45 19 4.74 19.11 5 19L5 19L7.5 18C7.74 18.19 8 18.37 8.26 18.53L11.77 15.53C9.84 15.4 8.38 13.73 8.5 11.8C8.65 9.87 10.32 8.41 12.25 8.55C13.69 8.64 14.92 9.62 15.35 11H19.43L21.54 9.37C21.73 9.22 21.78 8.94 21.66 8.73Z";
var mdiCogTransferOutline = "M15 17V14H18V12L22 15.5L18 19V17H15M17 18V21H14V23L10 19.5L14 16V18H17M12 8C9.79 8 8 9.8 8 12C8 13.91 9.35 15.54 11.21 15.92L16 11.86C15.93 9.71 14.16 8 12 8M12 14C10.9 14 10 13.11 10 12S10.9 10 12 10 14 10.9 14 12 13.11 14 12 14M21.66 8.73L19.66 5.27C19.54 5.05 19.28 4.96 19.05 5.05L16.56 6.05C16.05 5.64 15.5 5.31 14.87 5.05L14.5 2.42C14.46 2.18 14.25 2 14 2H10C9.75 2 9.54 2.18 9.5 2.42L9.13 5.07C8.5 5.33 7.96 5.66 7.44 6.07L5 5.05C4.77 4.96 4.5 5.05 4.39 5.27L2.39 8.73C2.26 8.94 2.31 9.22 2.5 9.37L4.57 11L4.5 12L4.57 13L2.46 14.63C2.26 14.78 2.21 15.06 2.34 15.27L4.34 18.73C4.45 19 4.74 19.11 5 19L5 19L7.5 18C7.74 18.19 8 18.37 8.26 18.53L9.91 17.13C9.14 16.8 8.46 16.31 7.91 15.68L5.5 16.68L4.73 15.38L6.8 13.8C6.4 12.63 6.4 11.37 6.8 10.2L4.69 8.65L5.44 7.35L7.85 8.35C8.63 7.45 9.68 6.82 10.85 6.57L11.25 4H12.75L13.12 6.62C14.29 6.86 15.34 7.5 16.12 8.39L18.53 7.39L19.28 8.69L17.2 10.2C17.29 10.46 17.36 10.73 17.4 11H19.4L21.5 9.37C21.72 9.23 21.78 8.95 21.66 8.73M12 8C9.79 8 8 9.8 8 12C8 13.91 9.35 15.54 11.21 15.92L16 11.86C15.93 9.71 14.16 8 12 8M12 14C10.9 14 10 13.11 10 12S10.9 10 12 10 14 10.9 14 12 13.11 14 12 14M12 8C9.79 8 8 9.8 8 12C8 13.91 9.35 15.54 11.21 15.92L16 11.86C15.93 9.71 14.16 8 12 8M12 14C10.9 14 10 13.11 10 12S10.9 10 12 10 14 10.9 14 12 13.11 14 12 14Z";
var mdiCogs = "M15.9,18.45C17.25,18.45 18.35,17.35 18.35,16C18.35,14.65 17.25,13.55 15.9,13.55C14.54,13.55 13.45,14.65 13.45,16C13.45,17.35 14.54,18.45 15.9,18.45M21.1,16.68L22.58,17.84C22.71,17.95 22.75,18.13 22.66,18.29L21.26,20.71C21.17,20.86 21,20.92 20.83,20.86L19.09,20.16C18.73,20.44 18.33,20.67 17.91,20.85L17.64,22.7C17.62,22.87 17.47,23 17.3,23H14.5C14.32,23 14.18,22.87 14.15,22.7L13.89,20.85C13.46,20.67 13.07,20.44 12.71,20.16L10.96,20.86C10.81,20.92 10.62,20.86 10.54,20.71L9.14,18.29C9.05,18.13 9.09,17.95 9.22,17.84L10.7,16.68L10.65,16L10.7,15.31L9.22,14.16C9.09,14.05 9.05,13.86 9.14,13.71L10.54,11.29C10.62,11.13 10.81,11.07 10.96,11.13L12.71,11.84C13.07,11.56 13.46,11.32 13.89,11.15L14.15,9.29C14.18,9.13 14.32,9 14.5,9H17.3C17.47,9 17.62,9.13 17.64,9.29L17.91,11.15C18.33,11.32 18.73,11.56 19.09,11.84L20.83,11.13C21,11.07 21.17,11.13 21.26,11.29L22.66,13.71C22.75,13.86 22.71,14.05 22.58,14.16L21.1,15.31L21.15,16L21.1,16.68M6.69,8.07C7.56,8.07 8.26,7.37 8.26,6.5C8.26,5.63 7.56,4.92 6.69,4.92A1.58,1.58 0 0,0 5.11,6.5C5.11,7.37 5.82,8.07 6.69,8.07M10.03,6.94L11,7.68C11.07,7.75 11.09,7.87 11.03,7.97L10.13,9.53C10.08,9.63 9.96,9.67 9.86,9.63L8.74,9.18L8,9.62L7.81,10.81C7.79,10.92 7.7,11 7.59,11H5.79C5.67,11 5.58,10.92 5.56,10.81L5.4,9.62L4.64,9.18L3.5,9.63C3.41,9.67 3.3,9.63 3.24,9.53L2.34,7.97C2.28,7.87 2.31,7.75 2.39,7.68L3.34,6.94L3.31,6.5L3.34,6.06L2.39,5.32C2.31,5.25 2.28,5.13 2.34,5.03L3.24,3.47C3.3,3.37 3.41,3.33 3.5,3.37L4.63,3.82L5.4,3.38L5.56,2.19C5.58,2.08 5.67,2 5.79,2H7.59C7.7,2 7.79,2.08 7.81,2.19L8,3.38L8.74,3.82L9.86,3.37C9.96,3.33 10.08,3.37 10.13,3.47L11.03,5.03C11.09,5.13 11.07,5.25 11,5.32L10.03,6.06L10.06,6.5L10.03,6.94Z";
var mdiCollage = "M5,3C3.89,3 3,3.89 3,5V19C3,20.11 3.89,21 5,21H11V3M13,3V11H21V5C21,3.89 20.11,3 19,3M13,13V21H19C20.11,21 21,20.11 21,19V13";
var mdiCollapseAll = "M14,4H4V14H2V4A2,2 0 0,1 4,2H14V4M18,6H8A2,2 0 0,0 6,8V18H8V8H18V6M22,12V20A2,2 0 0,1 20,22H12A2,2 0 0,1 10,20V12A2,2 0 0,1 12,10H20A2,2 0 0,1 22,12M20,15H12V17H20V15Z";
var mdiCollapseAllOutline = "M4,2A2,2 0 0,0 2,4V14H4V4H14V2H4M8,6A2,2 0 0,0 6,8V18H8V8H18V6H8M20,12V20H12V12H20M20,10H12A2,2 0 0,0 10,12V20A2,2 0 0,0 12,22H20A2,2 0 0,0 22,20V12A2,2 0 0,0 20,10M19,17H13V15H19V17Z";
var mdiColorHelper = "M0,24H24V20H0V24Z";
var mdiComma = "M7,3H16.95V12.96L12.96,20.94H8L11.97,12.96H7V3Z";
var mdiCommaBox = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M15,13V7H9V13H12L10,17H13L15,13Z";
var mdiCommaBoxOutline = "M10,17L12,13H9V7H15V13L13,17H10M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiCommaCircle = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M15,13L13,17H10L12,13H9V7H15V13Z";
var mdiCommaCircleOutline = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M10,17H13L15,13V7H9V13H12L10,17Z";
var mdiComment = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9Z";
var mdiCommentAccount = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M16,14V13C16,11.67 13.33,11 12,11C10.67,11 8,11.67 8,13V14H16M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6Z";
var mdiCommentAccountOutline = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M16,14H8V13C8,11.67 10.67,11 12,11C13.33,11 16,11.67 16,13V14M12,6A2,2 0 0,1 14,8A2,2 0 0,1 12,10A2,2 0 0,1 10,8A2,2 0 0,1 12,6Z";
var mdiCommentAlert = "M9 22C8.4 22 8 21.6 8 21V18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H13.9L10.2 21.7C10 21.9 9.8 22 9.5 22H9M13 11V5H11V11M13 15V13H11V15H13Z";
var mdiCommentAlertOutline = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M13,10H11V6H13V10M13,14H11V12H13V14Z";
var mdiCommentArrowLeft = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H8V21C8 21.6 8.4 22 9 22H9.5C9.7 22 10 21.9 10.2 21.7L13.9 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M16 11H11.5L13.3 12.8L12 14L8 10L12 6L13.2 7.2L11.5 9H16V11Z";
var mdiCommentArrowLeftOutline = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H8V21C8 21.6 8.4 22 9 22H9.5C9.7 22 10 21.9 10.2 21.7L13.9 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H13.1L10 19.1V16H4V4H20V16M16 11V9H11.5L13.3 7.2L12 6L8 10L12 14L13.2 12.8L11.5 11H16Z";
var mdiCommentArrowRight = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H8V21C8 21.6 8.4 22 9 22H9.5C9.7 22 10 21.9 10.2 21.7L13.9 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M12 14L10.8 12.8L12.6 11H8V9H12.5L10.7 7.2L12 6L16 10L12 14Z";
var mdiCommentArrowRightOutline = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H8V21C8 21.6 8.4 22 9 22H9.5C9.7 22 10 21.9 10.2 21.7L13.9 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H13.1L10 19.1V16H4V4H20V16M8 9V11H12.5L10.7 12.8L12 14L16 10L12 6L10.8 7.2L12.5 9H8Z";
var mdiCommentBookmark = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H8V21C8 21.6 8.4 22 9 22H9.5C9.7 22 10 21.9 10.2 21.7L13.9 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M19 13L16.5 11.5L14 13V5H19V13Z";
var mdiCommentBookmarkOutline = "M9 22C8.4 22 8 21.6 8 21V18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H13.9L10.2 21.7C10 21.9 9.8 22 9.5 22H9M10 16V19.1L13.1 16H20V4H4V16H10M18 14V6H13V14L15.5 12.5L18 14Z";
var mdiCommentCheck = "M20 2H4C2.9 2 2 2.89 2 4V16C2 17.11 2.9 18 4 18H8V21C8 21.55 8.45 22 9 22H9.5C9.75 22 10 21.9 10.2 21.71L13.9 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M10.47 14L7 10.5L8.4 9.09L10.47 11.17L15.6 6L17 7.41L10.47 14Z";
var mdiCommentCheckOutline = "M9 22C8.45 22 8 21.55 8 21V18H4C2.9 18 2 17.11 2 16V4C2 2.89 2.9 2 4 2H20C21.11 2 22 2.9 22 4V16C22 17.11 21.11 18 20 18H13.9L10.2 21.71C10 21.9 9.75 22 9.5 22H9M10 16V19.08L13.08 16H20V4H4V16H10M15.6 6L17 7.41L10.47 14L7 10.5L8.4 9.09L10.47 11.17L15.6 6";
var mdiCommentEdit = "M20 2H4C2.89 2 2 2.89 2 4V16C2 17.11 2.9 18 4 18H8V21C8 21.55 8.45 22 9 22H9.5C9.75 22 10 21.9 10.2 21.71L13.9 18H20C21.1 18 22 17.1 22 16V4C22 2.89 21.1 2 20 2M9.08 15H7V12.91L13.17 6.72L15.24 8.8L9.08 15M16.84 7.2L15.83 8.21L13.76 6.18L14.77 5.16C14.97 4.95 15.31 4.94 15.55 5.16L16.84 6.41C17.05 6.62 17.06 6.96 16.84 7.2Z";
var mdiCommentEditOutline = "M9 22C8.45 22 8 21.55 8 21V18H4C2.9 18 2 17.11 2 16V4C2 2.89 2.9 2 4 2H20C21.11 2 22 2.9 22 4V16C22 17.11 21.11 18 20 18H13.9L10.2 21.71C10 21.9 9.75 22 9.5 22H9M10 16V19.08L13.08 16H20V4H4V16H10M15.84 8.2L14.83 9.21L12.76 7.18L13.77 6.16C13.97 5.95 14.31 5.94 14.55 6.16L15.84 7.41C16.05 7.62 16.06 7.96 15.84 8.2M8 11.91L12.17 7.72L14.24 9.8L10.08 14H8V11.91Z";
var mdiCommentEye = "M20,12V16C20,17.11 19.11,18 18,18H13.9L10.2,21.71C10,21.89 9.76,22 9.5,22H9A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V6C2,4.89 2.9,4 4,4H9.5C8.95,4.67 8.5,5.42 8.14,6.25L7.85,7L8.14,7.75C9.43,10.94 12.5,13 16,13C17.44,13 18.8,12.63 20,12M16,6C16.56,6 17,6.44 17,7C17,7.56 16.56,8 16,8C15.44,8 15,7.56 15,7C15,6.44 15.44,6 16,6M16,3C18.73,3 21.06,4.66 22,7C21.06,9.34 18.73,11 16,11C13.27,11 10.94,9.34 10,7C10.94,4.66 13.27,3 16,3M16,4.5A2.5,2.5 0 0,0 13.5,7A2.5,2.5 0 0,0 16,9.5A2.5,2.5 0 0,0 18.5,7A2.5,2.5 0 0,0 16,4.5";
var mdiCommentEyeOutline = "M16,6C16.56,6 17,6.44 17,7C17,7.56 16.56,8 16,8C15.44,8 15,7.56 15,7C15,6.44 15.44,6 16,6M16,3C18.73,3 21.06,4.66 22,7C21.06,9.34 18.73,11 16,11C13.27,11 10.94,9.34 10,7C10.94,4.66 13.27,3 16,3M16,4.5A2.5,2.5 0 0,0 13.5,7A2.5,2.5 0 0,0 16,9.5A2.5,2.5 0 0,0 18.5,7A2.5,2.5 0 0,0 16,4.5M18,12.75V16H13.08L10,19.08V16H4V6H8.27C8.59,5.27 9,4.6 9.5,4H4A2,2 0 0,0 2,6V16C2,17.11 2.9,18 4,18H8V21A1,1 0 0,0 9,22H9.5C9.75,22 10,21.9 10.2,21.71L13.9,18H18C19.11,18 20,17.11 20,16V12C19.37,12.33 18.7,12.58 18,12.75Z";
var mdiCommentFlash = "M22.5 16H20.3L22 12H17V18H19V23L22.5 16M15 18H13.9L10.2 21.7C10 21.9 9.8 22 9.5 22H9C8.4 22 8 21.6 8 21V18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V10H15V18Z";
var mdiCommentFlashOutline = "M22.5 16H20.3L22 12H17V18H19V23L22.5 16M15 18H13.9L10.2 21.7C10 21.9 9.8 22 9.5 22H9C8.4 22 8 21.6 8 21V18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V10H20V4H4V16H10V19.1L13.1 16H15V18Z";
var mdiCommentMinus = "M20 2H4C2.9 2 2 2.89 2 4V16C2 17.11 2.9 18 4 18H8V21C8 21.55 8.45 22 9 22H9.5C9.75 22 10 21.9 10.2 21.71L13.9 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M16 11H8V9H16V11Z";
var mdiCommentMinusOutline = "M16 11H8V9H16V11M22 4V16C22 17.11 21.11 18 20 18H13.9L10.2 21.71C10 21.9 9.75 22 9.5 22H9C8.45 22 8 21.55 8 21V18H4C2.9 18 2 17.11 2 16V4C2 2.89 2.9 2 4 2H20C21.11 2 22 2.9 22 4M20 4H4V16H10V19.08L13.08 16H20V4";
var mdiCommentMultiple = "M12,23A1,1 0 0,1 11,22V19H7A2,2 0 0,1 5,17V7A2,2 0 0,1 7,5H21A2,2 0 0,1 23,7V17A2,2 0 0,1 21,19H16.9L13.2,22.71C13,22.89 12.76,23 12.5,23H12M3,15H1V3A2,2 0 0,1 3,1H19V3H3V15Z";
var mdiCommentMultipleOutline = "M12,23A1,1 0 0,1 11,22V19H7A2,2 0 0,1 5,17V7C5,5.89 5.9,5 7,5H21A2,2 0 0,1 23,7V17A2,2 0 0,1 21,19H16.9L13.2,22.71C13,22.9 12.75,23 12.5,23V23H12M13,17V20.08L16.08,17H21V7H7V17H13M3,15H1V3A2,2 0 0,1 3,1H19V3H3V15Z";
var mdiCommentOff = "M22.11 21.46L20.84 22.73L16.11 18H13.9L10.2 21.71C10 21.9 9.75 22 9.5 22H9C8.45 22 8 21.55 8 21V18H4C2.9 18 2 17.11 2 16V4 3.9L1.11 3L2.39 1.73L22.11 21.46M22 16V4C22 2.9 21.11 2 20 2H5.2L20.95 17.75C21.57 17.41 22 16.76 22 16Z";
var mdiCommentOffOutline = "M7.2 4L5.2 2H20C21.11 2 22 2.9 22 4V16C22 16.76 21.57 17.41 20.95 17.75L19.2 16H20V4H7.2M22.11 21.46L20.84 22.73L16.11 18H13.9L10.2 21.71C10 21.9 9.75 22 9.5 22H9C8.45 22 8 21.55 8 21V18H4C2.9 18 2 17.11 2 16V4C2 3.97 2 3.93 2 3.9L1.11 3L2.39 1.73L22.11 21.46M14.11 16L4 5.89V16H10V19.08L13.08 16H14.11Z";
var mdiCommentOutline = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10Z";
var mdiCommentPlus = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22H9M11,6V9H8V11H11V14H13V11H16V9H13V6H11Z";
var mdiCommentPlusOutline = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M11,6H13V9H16V11H13V14H11V11H8V9H11V6Z";
var mdiCommentProcessing = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M17,11V9H15V11H17M13,11V9H11V11H13M9,11V9H7V11H9Z";
var mdiCommentProcessingOutline = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M17,11H15V9H17V11M13,11H11V9H13V11M9,11H7V9H9V11Z";
var mdiCommentQuestion = "M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2M12.19,5.5C11.3,5.5 10.59,5.68 10.05,6.04C9.5,6.4 9.22,7 9.27,7.69H11.24C11.24,7.41 11.34,7.2 11.5,7.06C11.7,6.92 11.92,6.85 12.19,6.85C12.5,6.85 12.77,6.93 12.95,7.11C13.13,7.28 13.22,7.5 13.22,7.8C13.22,8.08 13.14,8.33 13,8.54C12.83,8.76 12.62,8.94 12.36,9.08C11.84,9.4 11.5,9.68 11.29,9.92C11.1,10.16 11,10.5 11,11H13C13,10.72 13.05,10.5 13.14,10.32C13.23,10.15 13.4,10 13.66,9.85C14.12,9.64 14.5,9.36 14.79,9C15.08,8.63 15.23,8.24 15.23,7.8C15.23,7.1 14.96,6.54 14.42,6.12C13.88,5.71 13.13,5.5 12.19,5.5M11,12V14H13V12H11Z";
var mdiCommentQuestionOutline = "M4,2A2,2 0 0,0 2,4V16A2,2 0 0,0 4,18H8V21A1,1 0 0,0 9,22H9.5V22C9.75,22 10,21.9 10.2,21.71L13.9,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2H4M4,4H20V16H13.08L10,19.08V16H4V4M12.19,5.5C11.3,5.5 10.59,5.68 10.05,6.04C9.5,6.4 9.22,7 9.27,7.69C0.21,7.69 6.57,7.69 11.24,7.69C11.24,7.41 11.34,7.2 11.5,7.06C11.7,6.92 11.92,6.85 12.19,6.85C12.5,6.85 12.77,6.93 12.95,7.11C13.13,7.28 13.22,7.5 13.22,7.8C13.22,8.08 13.14,8.33 13,8.54C12.83,8.76 12.62,8.94 12.36,9.08C11.84,9.4 11.5,9.68 11.29,9.92C11.1,10.16 11,10.5 11,11H13C13,10.72 13.05,10.5 13.14,10.32C13.23,10.15 13.4,10 13.66,9.85C14.12,9.64 14.5,9.36 14.79,9C15.08,8.63 15.23,8.24 15.23,7.8C15.23,7.1 14.96,6.54 14.42,6.12C13.88,5.71 13.13,5.5 12.19,5.5M11,12V14H13V12H11Z";
var mdiCommentQuote = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H8V21C8 21.6 8.4 22 9 22H9.5C9.7 22 10 21.9 10.2 21.7L13.9 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M11 13H7V8.8L8.3 6H10.3L8.9 9H11V13M17 13H13V8.8L14.3 6H16.3L14.9 9H17V13Z";
var mdiCommentQuoteOutline = "M9 22C8.4 22 8 21.6 8 21V18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H13.9L10.2 21.7C10 21.9 9.8 22 9.5 22H9M10 16V19.1L13.1 16H20V4H4V16H10M16.3 6L14.9 9H17V13H13V8.8L14.3 6H16.3M10.3 6L8.9 9H11V13H7V8.8L8.3 6H10.3Z";
var mdiCommentRemove = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M9.41,6L8,7.41L10.59,10L8,12.59L9.41,14L12,11.41L14.59,14L16,12.59L13.41,10L16,7.41L14.59,6L12,8.59L9.41,6Z";
var mdiCommentRemoveOutline = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M9.41,6L12,8.59L14.59,6L16,7.41L13.41,10L16,12.59L14.59,14L12,11.41L9.41,14L8,12.59L10.59,10L8,7.41L9.41,6Z";
var mdiCommentSearch = "M15.5,2C18,2 20,4 20,6.5C20,7.38 19.75,8.2 19.31,8.89L22.41,12L21,13.39L17.89,10.31C17.2,10.75 16.38,11 15.5,11C13,11 11,9 11,6.5C11,4 13,2 15.5,2M15.5,4A2.5,2.5 0 0,0 13,6.5A2.5,2.5 0 0,0 15.5,9A2.5,2.5 0 0,0 18,6.5A2.5,2.5 0 0,0 15.5,4M4,4H9.5C9.19,4.79 9,5.64 9,6.5A6.5,6.5 0 0,0 15.5,13C16.18,13 16.83,12.89 17.46,12.69L20,15.23V16A2,2 0 0,1 18,18H13.9L10.2,21.71C10,21.89 9.76,22 9.5,22H9A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V6A2,2 0 0,1 4,4Z";
var mdiCommentSearchOutline = "M4,4H9.5C9.25,4.64 9.09,5.31 9.04,6H4V16H10V19.08L13.08,16H18V13.23L20,15.23V16A2,2 0 0,1 18,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22H9A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V6C2,4.89 2.9,4 4,4M15.5,2C18,2 20,4 20,6.5C20,7.38 19.75,8.2 19.31,8.89L22.41,12L21,13.39L17.89,10.31C17.2,10.75 16.38,11 15.5,11C13,11 11,9 11,6.5C11,4 13,2 15.5,2M15.5,4A2.5,2.5 0 0,0 13,6.5A2.5,2.5 0 0,0 15.5,9A2.5,2.5 0 0,0 18,6.5A2.5,2.5 0 0,0 15.5,4Z";
var mdiCommentText = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M5,5V7H19V5H5M5,9V11H13V9H5M5,13V15H15V13H5Z";
var mdiCommentTextMultiple = "M3,15H1V3A2,2 0 0,1 3,1H19V3H3V15M12,23A1,1 0 0,1 11,22V19H7A2,2 0 0,1 5,17V7A2,2 0 0,1 7,5H21A2,2 0 0,1 23,7V17A2,2 0 0,1 21,19H16.9L13.2,22.71C13,22.89 12.76,23 12.5,23H12M9,9V11H19V9H9M9,13V15H17V13H9Z";
var mdiCommentTextMultipleOutline = "M12,23A1,1 0 0,1 11,22V19H7A2,2 0 0,1 5,17V7A2,2 0 0,1 7,5H21A2,2 0 0,1 23,7V17A2,2 0 0,1 21,19H16.9L13.2,22.71C13,22.89 12.76,23 12.5,23H12M13,17V20.08L16.08,17H21V7H7V17H13M3,15H1V3A2,2 0 0,1 3,1H19V3H3V15M9,9H19V11H9V9M9,13H17V15H9V13Z";
var mdiCommentTextOutline = "M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M6,7H18V9H6V7M6,11H15V13H6V11Z";
var mdiCompare = "M19,3H14V5H19V18L14,12V21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M10,18H5L10,12M10,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H10V23H12V1H10V3Z";
var mdiCompareHorizontal = "M9 14H2V16H9V19L13 15L9 11V14M15 13V10H22V8H15V5L11 9L15 13Z";
var mdiCompareRemove = "M19 5H14V3H19C20.1 3 21 3.9 21 5V13.4C20.4 13.2 19.7 13 19 13V5M10 1H12V23H10V21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H10V1M10 12L5 18H10V12M15.7 14L14 12V15.7C14.4 15 15 14.5 15.7 14M21.1 15.5L19 17.6L16.9 15.5L15.5 16.9L17.6 19L15.5 21.1L16.9 22.5L19 20.4L21.1 22.5L22.5 21.1L20.4 19L22.5 16.9L21.1 15.5Z";
var mdiCompareVertical = "M14 15V22H16V15H19L15 11L11 15H14M13 9H10V2H8V9H5L9 13L13 9Z";
var mdiCompass = "M14.19,14.19L6,18L9.81,9.81L18,6M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,10.9A1.1,1.1 0 0,0 10.9,12A1.1,1.1 0 0,0 12,13.1A1.1,1.1 0 0,0 13.1,12A1.1,1.1 0 0,0 12,10.9Z";
var mdiCompassOff = "M1,3.5L2.28,2.25L21.75,21.72L20.5,23L17.7,20.22C16.08,21.34 14.12,22 12,22A10,10 0 0,1 2,12C2,9.88 2.66,7.92 3.78,6.3L1,3.5M6,18L12.47,15L9,11.53L6,18M18,6L11.56,9L6.33,3.76C7.94,2.65 9.9,2 12,2A10,10 0 0,1 22,12C22,14.1 21.35,16.06 20.24,17.67L15,12.44L18,6Z";
var mdiCompassOffOutline = "M1,3.5L2.28,2.25L21.75,21.72L20.5,23L17.7,20.22C16.08,21.34 14.12,22 12,22A10,10 0 0,1 2,12C2,9.88 2.66,7.92 3.78,6.3L1,3.5M7,17L9.39,11.91L5.23,7.74C4.45,9 4,10.44 4,12A8,8 0 0,0 12,20C13.56,20 15,19.55 16.26,18.77L12.09,14.61L7,17M17,7L14.62,12.05L11.95,9.38L17,7M12,2A10,10 0 0,1 22,12C22,14.1 21.35,16.06 20.24,17.67L18.8,16.22C19.56,15 20,13.55 20,12A8,8 0 0,0 12,4C10.45,4 9,4.44 7.78,5.2L6.33,3.76C7.94,2.65 9.9,2 12,2Z";
var mdiCompassOutline = "M7,17L10.2,10.2L17,7L13.8,13.8L7,17M12,11.1A0.9,0.9 0 0,0 11.1,12A0.9,0.9 0 0,0 12,12.9A0.9,0.9 0 0,0 12.9,12A0.9,0.9 0 0,0 12,11.1M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiCompassRose = "M15 9L12 0L9 9L0 12L9 15L12 24L15 15L24 12L15 9M4 12L10 10L11 12H4M12 20L10 14L12 13V20M12 4L14 10L12 11V4M14 14L13 12H20L14 14M8.7 17.3L5 19L6.7 15.3L8.3 15.8L8.7 17.3M17.3 15.3L19 19L15.3 17.3L15.8 15.7L17.3 15.3M6.7 8.7L5 5L8.7 6.7L8.2 8.2L6.7 8.7M15.3 6.7L19 5L17.3 8.7L15.7 8.2L15.3 6.7Z";
var mdiCompost = "M18.92 14C18.64 15.97 17.53 17.68 15.96 18.76C15.76 17.93 14.53 17.25 12.92 17.06C13.09 15.87 13.44 14.76 13.68 14.12C14.06 14.36 14.5 14.5 15 14.5C18.55 14.5 18 8.5 18 8.5S17.5 9.5 16 9.5H15C13.62 9.5 12.5 10.62 12.5 12C12.5 12.5 12.64 12.93 12.87 13.31C13.53 12.62 14.24 12 15 11.5C13.68 12.83 12.67 14.5 12 16.1C11.37 14.87 10.58 13.93 10 13.5C10.47 13.7 10.91 14 11.33 14.3C11.44 14.06 11.5 13.79 11.5 13.5C11.45 10.77 7 11 7 11C7.31 11.42 7.5 11.95 7.5 12.5V13.5C7.5 14.6 8.4 15.5 9.5 15.5C10 15.5 10.45 15.32 10.8 15C11.03 15.63 11.2 16.35 11.29 17.04C9.57 17.19 8.25 17.89 8.04 18.77C6.21 17.5 5 15.39 5 13C5 9.14 8.14 6 12 6V9L17 5L12 1V4C7.03 4 3 8.03 3 13S7.03 22 12 22C16.63 22 20.44 18.5 20.94 14H18.92Z";
var mdiCone = "M21.62 16.68H21.62L12.85 2.5C12.66 2.16 12.33 2 12 2C11.67 2 11.34 2.16 11.15 2.47L2.38 16.65H2.4C2.15 17.04 2 17.5 2 18C2 19.5 3.3 22 12 22C15.74 22 22 21.5 22 18C22 17.61 21.91 17.15 21.62 16.68M12 4.9L18 14.58C16.53 14.23 14.6 14 12 14C10.25 14 7.96 14.12 6 14.6L12 4.9M12 20C7.58 20 4 19.11 4 18C4 16.9 7.58 16 12 16S20 16.9 20 18C20 19.11 16.42 20 12 20Z";
var mdiConeOff = "M10.5 7.31L9.06 5.86L11.15 2.47C11.34 2.16 11.67 2 12 2C12.33 2 12.66 2.16 12.85 2.5L21.62 16.68H21.62C21.91 17.15 22 17.61 22 18C22 18.25 21.96 18.5 21.9 18.7L17.73 14.53C17.81 14.55 17.9 14.56 18 14.58L12 4.9L10.5 7.31M22.11 21.46L20.84 22.73L19.17 21.06C17.03 21.83 14.11 22 12 22C3.3 22 2 19.5 2 18C2 17.5 2.15 17.04 2.4 16.65H2.38L7.11 9L1.11 3L2.39 1.73L22.11 21.46M6 14.6C7.96 14.12 10.25 14 12 14L12.11 14L8.56 10.45L6 14.6M17.55 19.44L14.19 16.08C13.5 16.03 12.76 16 12 16C7.58 16 4 16.9 4 18S7.58 20 12 20C14.16 20 16.11 19.79 17.55 19.44Z";
var mdiConnection = "M21.4 7.5C22.2 8.3 22.2 9.6 21.4 10.3L18.6 13.1L10.8 5.3L13.6 2.5C14.4 1.7 15.7 1.7 16.4 2.5L18.2 4.3L21.2 1.3L22.6 2.7L19.6 5.7L21.4 7.5M15.6 13.3L14.2 11.9L11.4 14.7L9.3 12.6L12.1 9.8L10.7 8.4L7.9 11.2L6.4 9.8L3.6 12.6C2.8 13.4 2.8 14.7 3.6 15.4L5.4 17.2L1.4 21.2L2.8 22.6L6.8 18.6L8.6 20.4C9.4 21.2 10.7 21.2 11.4 20.4L14.2 17.6L12.8 16.2L15.6 13.3Z";
var mdiConsole = "M20,19V7H4V19H20M20,3A2,2 0 0,1 22,5V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V5C2,3.89 2.9,3 4,3H20M13,17V15H18V17H13M9.58,13L5.57,9H8.4L11.7,12.3C12.09,12.69 12.09,13.33 11.7,13.72L8.42,17H5.59L9.58,13Z";
var mdiConsoleLine = "M13,19V16H21V19H13M8.5,13L2.47,7H6.71L11.67,11.95C12.25,12.54 12.25,13.5 11.67,14.07L6.74,19H2.5L8.5,13Z";
var mdiConsoleNetwork = "M17,3A2,2 0 0,1 19,5V15A2,2 0 0,1 17,17H13V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H7A2,2 0 0,1 5,15V5A2,2 0 0,1 7,3H17M7,7L11,11L7,15H9.85L13.13,11.72C13.5,11.33 13.5,10.7 13.13,10.3L9.83,7H7M17,13H14V15H17V13Z";
var mdiConsoleNetworkOutline = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M7,15V5H17V15H7M8,6.89L11.56,10.45L8,14H10.53L13.45,11.08C13.78,10.74 13.78,10.18 13.45,9.82L10.5,6.89H8M16,12.22H13.33V14H16V12.22Z";
var mdiConsolidate = "M18 9H20V4H22V9A2 2 0 0 1 20 11H18V13L15 10L18 7M14 10A2 2 0 1 0 12 12A2 2 0 0 0 14 10M2 11V16H4V11H6V13L9 10L6 7V9H4A2 2 0 0 0 2 11M15 16L12 13L9 16H11V18A2 2 0 0 0 13 20H18V18H13V16";
var mdiContactlessPayment = "M16.79,23C16.37,22.83 16.07,22.45 16,22C15.95,21.74 16,21.56 16.4,20.84C17.9,18.14 18.67,15.09 18.63,12C18.67,9 17.94,6.07 16.5,3.44C16.29,3 16.1,2.58 15.94,2.13C16,1.75 16.19,1.4 16.5,1.19C16.95,0.95 17.5,1 17.91,1.28C18.19,1.64 18.43,2 18.63,2.42C19.71,4.5 20.44,6.7 20.8,9C21.03,10.81 21.06,12.65 20.89,14.47C20.58,16.81 19.89,19.07 18.83,21.18C18.19,22.46 17.83,23 17.45,23C17.37,23 17.28,23 17.2,23C17.06,23 16.93,23 16.79,23V23M12.43,20.79C11.86,20.63 11.5,20.05 11.62,19.47C11.62,19.35 11.93,18.8 12.21,18.24C13.39,15.97 13.9,13.41 13.67,10.86C13.53,9.03 13,7.25 12.13,5.64C11.5,4.38 11.46,4.18 11.83,3.64C12.27,3.15 13,3.08 13.54,3.5C14.26,4.56 14.83,5.72 15.25,6.94C16.53,10.73 16.33,14.86 14.69,18.5C13.85,20.39 13.26,21 12.43,20.74V20.79M7.93,18.56C7.57,18.4 7.3,18.08 7.2,17.7C7.2,17.5 7.2,17.24 7.65,16.44C9.14,13.74 9.14,10.46 7.65,7.76C7,6.5 7,6.24 7.53,5.76C7.72,5.54 8,5.43 8.3,5.47C8.94,5.47 9.3,5.78 9.84,6.91C10.69,8.47 11.13,10.22 11.12,12C11.16,13.81 10.72,15.61 9.85,17.2C9.31,18.25 9.04,18.5 8.5,18.59C8.31,18.61 8.11,18.59 7.93,18.5V18.56M3.72,16.43C3.39,16.27 3.13,16 3,15.65C2.9,15.3 3,15 3.4,14.36C3.9,13.68 4.14,12.84 4.09,12C4.16,11.15 3.93,10.31 3.44,9.61C3.27,9.36 3.13,9.09 3,8.82C2.89,8.19 3.31,7.59 4,7.47C4.54,7.37 4.92,7.6 5.42,8.36C6.87,10.57 6.87,13.42 5.42,15.63C4.91,16.4 4.33,16.63 3.73,16.43H3.72Z";
var mdiContactlessPaymentCircle = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M8.43 14.44L7.07 13.83C7.35 13.27 7.5 12.67 7.5 12.05C7.5 11.39 7.35 10.76 7.07 10.17L8.43 9.56C8.81 10.37 9 11.2 9 12.05C9 12.8 8.81 13.6 8.43 14.44M11.53 15.94L10.22 15.29C10.75 14.16 11 13 11 11.86C11 10.73 10.75 9.69 10.22 8.71L11.53 7.96C12.19 9.12 12.5 10.42 12.5 11.86C12.5 13.33 12.19 14.69 11.53 15.94M14.68 17.35L13.31 16.65C14.1 15.11 14.5 13.57 14.5 12S14.1 8.87 13.31 7.31L14.68 6.65C15.55 8.43 16 10.22 16 12C16 13.82 15.55 15.6 14.68 17.35Z";
var mdiContactlessPaymentCircleOutline = "M12 4C16.41 4 20 7.59 20 12S16.41 20 12 20 4 16.41 4 12 7.59 4 12 4M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M8.43 14.44L7.07 13.83C7.35 13.27 7.5 12.67 7.5 12.05C7.5 11.39 7.35 10.76 7.07 10.17L8.43 9.56C8.81 10.37 9 11.2 9 12.05C9 12.8 8.81 13.6 8.43 14.44M11.53 15.94L10.22 15.29C10.75 14.16 11 13 11 11.86C11 10.73 10.75 9.69 10.22 8.71L11.53 7.96C12.19 9.12 12.5 10.42 12.5 11.86C12.5 13.33 12.19 14.69 11.53 15.94M14.68 17.35L13.31 16.65C14.1 15.11 14.5 13.57 14.5 12S14.1 8.87 13.31 7.31L14.68 6.65C15.55 8.43 16 10.22 16 12C16 13.82 15.55 15.6 14.68 17.35Z";
var mdiContacts = "M20,0H4V2H20V0M4,24H20V22H4V24M20,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6A2,2 0 0,0 20,4M12,6.75A2.25,2.25 0 0,1 14.25,9A2.25,2.25 0 0,1 12,11.25A2.25,2.25 0 0,1 9.75,9A2.25,2.25 0 0,1 12,6.75M17,17H7V15.5C7,13.83 10.33,13 12,13C13.67,13 17,13.83 17,15.5V17Z";
var mdiContactsOutline = "M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4M20 18H4V6H20V18M4 0H20V2H4M4 22H20V24H4M12 12C13.38 12 14.5 10.88 14.5 9.5S13.38 7 12 7 9.5 8.12 9.5 9.5 10.62 12 12 12M12 8.5C12.55 8.5 13 8.95 13 9.5S12.55 10.5 12 10.5 11 10.05 11 9.5 11.45 8.5 12 8.5M17 16C17 13.9 13.69 13 12 13S7 13.9 7 16V17H17V16M8.81 15.5C9.42 15 10.84 14.5 12 14.5C13.17 14.5 14.59 15 15.2 15.5H8.81Z";
var mdiContain = "M2,3H8V5H4V19H8V21H2V3M7,17V15H9V17H7M11,17V15H13V17H11M15,17V15H17V17H15M22,3V21H16V19H20V5H16V3H22Z";
var mdiContainEnd = "M7,17V15H9V17H7M11,17V15H13V17H11M15,17V15H17V17H15M22,3V21H16V19H20V5H16V3H22Z";
var mdiContainStart = "M2,3H8V5H4V19H8V21H2V3M7,17V15H9V17H7M11,17V15H13V17H11M15,17V15H17V17H15Z";
var mdiContentCopy = "M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z";
var mdiContentCut = "M19,3L13,9L15,11L22,4V3M12,12.5A0.5,0.5 0 0,1 11.5,12A0.5,0.5 0 0,1 12,11.5A0.5,0.5 0 0,1 12.5,12A0.5,0.5 0 0,1 12,12.5M6,20A2,2 0 0,1 4,18C4,16.89 4.9,16 6,16A2,2 0 0,1 8,18C8,19.11 7.1,20 6,20M6,8A2,2 0 0,1 4,6C4,4.89 4.9,4 6,4A2,2 0 0,1 8,6C8,7.11 7.1,8 6,8M9.64,7.64C9.87,7.14 10,6.59 10,6A4,4 0 0,0 6,2A4,4 0 0,0 2,6A4,4 0 0,0 6,10C6.59,10 7.14,9.87 7.64,9.64L10,12L7.64,14.36C7.14,14.13 6.59,14 6,14A4,4 0 0,0 2,18A4,4 0 0,0 6,22A4,4 0 0,0 10,18C10,17.41 9.87,16.86 9.64,16.36L12,14L19,21H22V20L9.64,7.64Z";
var mdiContentDuplicate = "M11,17H4A2,2 0 0,1 2,15V3A2,2 0 0,1 4,1H16V3H4V15H11V13L15,16L11,19V17M19,21V7H8V13H6V7A2,2 0 0,1 8,5H19A2,2 0 0,1 21,7V21A2,2 0 0,1 19,23H8A2,2 0 0,1 6,21V19H8V21H19Z";
var mdiContentPaste = "M19,20H5V4H7V7H17V4H19M12,2A1,1 0 0,1 13,3A1,1 0 0,1 12,4A1,1 0 0,1 11,3A1,1 0 0,1 12,2M19,2H14.82C14.4,0.84 13.3,0 12,0C10.7,0 9.6,0.84 9.18,2H5A2,2 0 0,0 3,4V20A2,2 0 0,0 5,22H19A2,2 0 0,0 21,20V4A2,2 0 0,0 19,2Z";
var mdiContentSave = "M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z";
var mdiContentSaveAlert = "M13 9H3V5H13M10 19C8.3 19 7 17.7 7 16S8.3 13 10 13 13 14.3 13 16 11.7 19 10 19M15 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H17C18.1 21 19 20.1 19 19V7L15 3M23 13H21V7H23V13M23 17H21V15H23V17Z";
var mdiContentSaveAlertOutline = "M15 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H17C18.1 21 19 20.1 19 19V7L15 3M17 19H3V5H14.2L17 7.8V19M10 12C8.3 12 7 13.3 7 15S8.3 18 10 18 13 16.7 13 15 11.7 12 10 12M4 6H13V10H4V6M23 13H21V7H23V13M23 17H21V15H23V17Z";
var mdiContentSaveAll = "M17,7V3H7V7H17M14,17A3,3 0 0,0 17,14A3,3 0 0,0 14,11A3,3 0 0,0 11,14A3,3 0 0,0 14,17M19,1L23,5V17A2,2 0 0,1 21,19H7C5.89,19 5,18.1 5,17V3A2,2 0 0,1 7,1H19M1,7H3V21H17V23H3A2,2 0 0,1 1,21V7Z";
var mdiContentSaveAllOutline = "M1 7H3V21H17V23H3C1.9 23 1 22.11 1 21V7M19 1H7C5.89 1 5 1.9 5 3V17C5 18.1 5.89 19 7 19H21C22.1 19 23 18.1 23 17V5L19 1M21 17H7V3H18.17L21 5.83V17M14 10C12.34 10 11 11.34 11 13S12.34 16 14 16 17 14.66 17 13 15.66 10 14 10M8 4H17V8H8V4Z";
var mdiContentSaveCheck = "M17 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H11.81C11.42 20.34 11.17 19.6 11.07 18.84C9.5 18.31 8.66 16.6 9.2 15.03C9.61 13.83 10.73 13 12 13C12.44 13 12.88 13.1 13.28 13.29C15.57 11.5 18.83 11.59 21 13.54V7L17 3M15 9H5V5H15V9M15.75 21L13 18L14.16 16.84L15.75 18.43L19.34 14.84L20.5 16.25L15.75 21";
var mdiContentSaveCheckOutline = "M14 12.8C13.5 12.31 12.78 12 12 12C10.34 12 9 13.34 9 15C9 16.31 9.84 17.41 11 17.82C11.07 15.67 12.27 13.8 14 12.8M11.09 19H5V5H16.17L19 7.83V12.35C19.75 12.61 20.42 13 21 13.54V7L17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H11.81C11.46 20.39 11.21 19.72 11.09 19M6 10H15V6H6V10M15.75 21L13 18L14.16 16.84L15.75 18.43L19.34 14.84L20.5 16.25L15.75 21";
var mdiContentSaveCog = "M21 11.7V7L17 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H11.7C11.4 20.3 11.2 19.6 11.1 18.8C9.9 18.4 9 17.3 9 16C9 14.3 10.3 13 12 13C12.3 13 12.6 13.1 12.9 13.2C14.2 11.8 16 11 18 11C19.1 11 20.1 11.2 21 11.7M15 9H5V5H15V9M21.7 18.6V17.6L22.8 16.8C22.9 16.7 23 16.6 22.9 16.5L21.9 14.8C21.9 14.7 21.7 14.7 21.6 14.7L20.4 15.2C20.1 15 19.8 14.8 19.5 14.7L19.3 13.4C19.3 13.3 19.2 13.2 19.1 13.2H17.1C16.9 13.2 16.8 13.3 16.8 13.4L16.6 14.7C16.3 14.9 16.1 15 15.8 15.2L14.6 14.7C14.5 14.7 14.4 14.7 14.3 14.8L13.3 16.5C13.3 16.6 13.3 16.7 13.4 16.8L14.5 17.6V18.6L13.4 19.4C13.3 19.5 13.2 19.6 13.3 19.7L14.3 21.4C14.4 21.5 14.5 21.5 14.6 21.5L15.8 21C16 21.2 16.3 21.4 16.6 21.5L16.8 22.8C16.9 22.9 17 23 17.1 23H19.1C19.2 23 19.3 22.9 19.3 22.8L19.5 21.5C19.8 21.3 20 21.2 20.3 21L21.5 21.4C21.6 21.4 21.7 21.4 21.8 21.3L22.8 19.6C22.9 19.5 22.9 19.4 22.8 19.4L21.7 18.6M18 19.5C17.2 19.5 16.5 18.8 16.5 18S17.2 16.5 18 16.5 19.5 17.2 19.5 18 18.8 19.5 18 19.5Z";
var mdiContentSaveCogOutline = "M11.1 19C11.2 19.7 11.4 20.4 11.7 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H17L21 7V11.7C20.4 11.4 19.7 11.2 19 11.1V7.8L16.2 5H5V19H11.1M12 12C10.3 12 9 13.3 9 15C9 16.3 9.8 17.4 11 17.8C11.1 15.6 12.1 13.7 13.7 12.5C13.2 12.2 12.6 12 12 12M15 10V6H6V10H15M22.8 19.6L21.8 21.3C21.7 21.4 21.6 21.4 21.5 21.4L20.3 21C20 21.2 19.8 21.3 19.5 21.5L19.3 22.8C19.3 22.9 19.2 23 19.1 23H17.1C17 23 16.9 22.9 16.8 22.8L16.6 21.5C16.3 21.4 16 21.2 15.8 21L14.6 21.5C14.5 21.5 14.4 21.5 14.3 21.4L13.3 19.7C13.2 19.6 13.3 19.5 13.4 19.4L14.5 18.6V17.6L13.4 16.8C13.3 16.7 13.3 16.6 13.3 16.5L14.3 14.8C14.4 14.7 14.5 14.7 14.6 14.7L15.8 15.2C16.1 15 16.3 14.9 16.6 14.7L16.8 13.4C16.8 13.3 16.9 13.2 17.1 13.2H19.1C19.2 13.2 19.3 13.3 19.3 13.4L19.5 14.7C19.8 14.8 20.1 15 20.4 15.2L21.6 14.7C21.7 14.7 21.9 14.7 21.9 14.8L22.9 16.5C23 16.6 22.9 16.7 22.8 16.8L21.7 17.6V18.6L22.8 19.4C22.9 19.4 22.9 19.5 22.8 19.6M19.5 18C19.5 17.2 18.8 16.5 18 16.5S16.5 17.2 16.5 18 17.2 19.5 18 19.5C18.8 19.5 19.5 18.8 19.5 18Z";
var mdiContentSaveEdit = "M10,19L10.14,18.86C8.9,18.5 8,17.36 8,16A3,3 0 0,1 11,13C12.36,13 13.5,13.9 13.86,15.14L20,9V7L16,3H4C2.89,3 2,3.9 2,5V19A2,2 0 0,0 4,21H10V19M4,5H14V9H4V5M20.04,12.13C19.9,12.13 19.76,12.19 19.65,12.3L18.65,13.3L20.7,15.35L21.7,14.35C21.92,14.14 21.92,13.79 21.7,13.58L20.42,12.3C20.31,12.19 20.18,12.13 20.04,12.13M18.07,13.88L12,19.94V22H14.06L20.12,15.93L18.07,13.88Z";
var mdiContentSaveEditOutline = "M4 19H10V21H4C2.89 21 2 20.1 2 19V5C2 3.9 2.89 3 4 3H16L20 7V9.12L18 11.12V7.83L15.17 5H4V19M14 10V6H5V10H14M20.42 12.3C20.31 12.19 20.18 12.13 20.04 12.13C19.9 12.13 19.76 12.19 19.65 12.3L18.65 13.3L20.7 15.35L21.7 14.35C21.92 14.14 21.92 13.79 21.7 13.58L20.42 12.3M12 19.94V22H14.06L20.12 15.93L18.07 13.88L12 19.94M14 15C14 13.34 12.66 12 11 12S8 13.34 8 15 9.34 18 11 18C11.04 18 11.08 18 11.13 18L14 15.13C14 15.09 14 15.05 14 15";
var mdiContentSaveMinus = "M17 3H5C3.89 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H12.81C12.45 20.38 12.2 19.7 12.08 19L12 19C10.34 19 9 17.66 9 16S10.34 13 12 13C12.68 13 13.34 13.23 13.87 13.65C15 12.59 16.46 12 18 12C19.05 12 20.09 12.28 21 12.81V7L17 3M15 9H5V5H15V9M14 17V19H22V17H14Z";
var mdiContentSaveMinusOutline = "M5 3C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H12.81C12.45 20.38 12.2 19.7 12.08 19H5V5H16.17L19 7.83V12.08C19.7 12.2 20.38 12.45 21 12.81V7L17 3H5M6 6V10H15V6H6M12 12C10.34 12 9 13.34 9 15S10.34 18 12 18C12 16.11 12.89 14.34 14.39 13.21C13.85 12.5 13 12 12 12M14 17V19H22V17H14Z";
var mdiContentSaveMove = "M17,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H11.81C11.42,20.34 11.17,19.6 11.07,18.84C9.5,18.31 8.66,16.6 9.2,15.03C9.61,13.83 10.73,13 12,13C12.44,13 12.88,13.1 13.28,13.29C15.57,11.5 18.83,11.59 21,13.54V7L17,3M15,9H5V5H15V9M13,17H17V14L22,18.5L17,23V20H13V17";
var mdiContentSaveMoveOutline = "M13 17H17V14L22 18.5L17 23V20H13V17M14 12.8C13.5 12.31 12.78 12 12 12C10.34 12 9 13.34 9 15C9 16.31 9.84 17.41 11 17.82C11.07 15.67 12.27 13.8 14 12.8M11.09 19H5V5H16.17L19 7.83V12.35C19.75 12.61 20.42 13 21 13.54V7L17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H11.81C11.46 20.39 11.21 19.72 11.09 19M6 10H15V6H6V10Z";
var mdiContentSaveOff = "M8.2 5L6.2 3H17L21 7V17.8L12.2 9H15V5H8.2M22.11 21.46L20.84 22.73L19.1 21C19.07 21 19.03 21 19 21H5C3.9 21 3 20.11 3 19V5C3 4.97 3 4.93 3 4.9L1.11 3L2.39 1.73L22.11 21.46M7.11 9L5 6.89V9H7.11M14.89 16.78L11.22 13.11C9.95 13.46 9 14.61 9 16C9 17.66 10.34 19 12 19C13.39 19 14.54 18.05 14.89 16.78Z";
var mdiContentSaveOffOutline = "M8.2 5L6.2 3H17L21 7V17.8L19 15.8V7.83L16.17 5H8.2M15 10V6H9.2L13.2 10H15M22.11 21.46L20.84 22.73L19.1 21C19.07 21 19.03 21 19 21H5C3.89 21 3 20.1 3 19V5C3 4.97 3 4.93 3 4.9L1.11 3L2.39 1.73L22.11 21.46M17.11 19L14.59 16.5C14.08 17.39 13.12 18 12 18C10.34 18 9 16.66 9 15C9 13.88 9.61 12.92 10.5 12.41L8.11 10H6V7.89L5 6.89V19H17.11Z";
var mdiContentSaveOutline = "M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3M19 19H5V5H16.17L19 7.83V19M12 12C10.34 12 9 13.34 9 15S10.34 18 12 18 15 16.66 15 15 13.66 12 12 12M6 6H15V10H6V6Z";
var mdiContentSavePlus = "M17 3H5C3.89 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H12.81C12.45 20.38 12.2 19.7 12.08 19L12 19C10.34 19 9 17.66 9 16S10.34 13 12 13C12.68 13 13.34 13.23 13.87 13.65C15 12.59 16.46 12 18 12C19.05 12 20.09 12.28 21 12.81V7L17 3M15 9H5V5H15V9M17 14V17H14V19H17V22H19V19H22V17H19V14H17Z";
var mdiContentSavePlusOutline = "M5 3C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H12.81C12.45 20.38 12.2 19.7 12.08 19H5V5H16.17L19 7.83V12.08C19.7 12.2 20.38 12.45 21 12.81V7L17 3H5M6 6V10H15V6H6M12 12C10.34 12 9 13.34 9 15S10.34 18 12 18C12 16.11 12.89 14.34 14.39 13.21C13.85 12.5 13 12 12 12M17 14V17H14V19H17V22H19V19H22V17H19V14H17Z";
var mdiContentSaveSettings = "M15,8V4H5V8H15M12,18A3,3 0 0,0 15,15A3,3 0 0,0 12,12A3,3 0 0,0 9,15A3,3 0 0,0 12,18M17,2L21,6V18A2,2 0 0,1 19,20H5C3.89,20 3,19.1 3,18V4A2,2 0 0,1 5,2H17M11,22H13V24H11V22M7,22H9V24H7V22M15,22H17V24H15V22Z";
var mdiContentSaveSettingsOutline = "M7 22H9V24H7V22M11 22H13V24H11V22M15 22H17V24H15V22M17 2H5C3.89 2 3 2.9 3 4V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6L17 2M19 18H5V4H16.17L19 6.83V18M12 11C10.34 11 9 12.34 9 14S10.34 17 12 17 15 15.66 15 14 13.66 11 12 11M6 5H15V9H6V5Z";
var mdiContrast = "M4.38,20.9C3.78,20.71 3.3,20.23 3.1,19.63L19.63,3.1C20.23,3.3 20.71,3.78 20.9,4.38L4.38,20.9M20,16V18H13V16H20M3,6H6V3H8V6H11V8H8V11H6V8H3V6Z";
var mdiContrastBox = "M17,15.5H12V17H17M19,19H5L19,5M5.5,7.5H7.5V5.5H9V7.5H11V9H9V11H7.5V9H5.5M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiContrastCircle = "M12,20C9.79,20 7.79,19.1 6.34,17.66L17.66,6.34C19.1,7.79 20,9.79 20,12A8,8 0 0,1 12,20M6,8H8V6H9.5V8H11.5V9.5H9.5V11.5H8V9.5H6M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,16H17V14.5H12V16Z";
var mdiController = "M7.97,16L5,19C4.67,19.3 4.23,19.5 3.75,19.5A1.75,1.75 0 0,1 2,17.75V17.5L3,10.12C3.21,7.81 5.14,6 7.5,6H16.5C18.86,6 20.79,7.81 21,10.12L22,17.5V17.75A1.75,1.75 0 0,1 20.25,19.5C19.77,19.5 19.33,19.3 19,19L16.03,16H7.97M7,8V10H5V11H7V13H8V11H10V10H8V8H7M16.5,8A0.75,0.75 0 0,0 15.75,8.75A0.75,0.75 0 0,0 16.5,9.5A0.75,0.75 0 0,0 17.25,8.75A0.75,0.75 0 0,0 16.5,8M14.75,9.75A0.75,0.75 0 0,0 14,10.5A0.75,0.75 0 0,0 14.75,11.25A0.75,0.75 0 0,0 15.5,10.5A0.75,0.75 0 0,0 14.75,9.75M18.25,9.75A0.75,0.75 0 0,0 17.5,10.5A0.75,0.75 0 0,0 18.25,11.25A0.75,0.75 0 0,0 19,10.5A0.75,0.75 0 0,0 18.25,9.75M16.5,11.5A0.75,0.75 0 0,0 15.75,12.25A0.75,0.75 0 0,0 16.5,13A0.75,0.75 0 0,0 17.25,12.25A0.75,0.75 0 0,0 16.5,11.5Z";
var mdiControllerClassic = "M6,7H18A5,5 0 0,1 23,12A5,5 0 0,1 18,17C16.36,17 14.91,16.21 14,15H10C9.09,16.21 7.64,17 6,17A5,5 0 0,1 1,12A5,5 0 0,1 6,7M19.75,9.5A1.25,1.25 0 0,0 18.5,10.75A1.25,1.25 0 0,0 19.75,12A1.25,1.25 0 0,0 21,10.75A1.25,1.25 0 0,0 19.75,9.5M17.25,12A1.25,1.25 0 0,0 16,13.25A1.25,1.25 0 0,0 17.25,14.5A1.25,1.25 0 0,0 18.5,13.25A1.25,1.25 0 0,0 17.25,12M5,9V11H3V13H5V15H7V13H9V11H7V9H5Z";
var mdiControllerClassicOutline = "M17.5,7A5.5,5.5 0 0,1 23,12.5A5.5,5.5 0 0,1 17.5,18C15.79,18 14.27,17.22 13.26,16H10.74C9.73,17.22 8.21,18 6.5,18A5.5,5.5 0 0,1 1,12.5A5.5,5.5 0 0,1 6.5,7H17.5M6.5,9A3.5,3.5 0 0,0 3,12.5A3.5,3.5 0 0,0 6.5,16C7.9,16 9.1,15.18 9.66,14H14.34C14.9,15.18 16.1,16 17.5,16A3.5,3.5 0 0,0 21,12.5A3.5,3.5 0 0,0 17.5,9H6.5M5.75,10.25H7.25V11.75H8.75V13.25H7.25V14.75H5.75V13.25H4.25V11.75H5.75V10.25M16.75,12.5A1,1 0 0,1 17.75,13.5A1,1 0 0,1 16.75,14.5A1,1 0 0,1 15.75,13.5A1,1 0 0,1 16.75,12.5M18.75,10.5A1,1 0 0,1 19.75,11.5A1,1 0 0,1 18.75,12.5A1,1 0 0,1 17.75,11.5A1,1 0 0,1 18.75,10.5Z";
var mdiControllerOff = "M2,5.27L3.28,4L20,20.72L18.73,22L12.73,16H7.97L5,19C4.67,19.3 4.23,19.5 3.75,19.5A1.75,1.75 0 0,1 2,17.75V17.5L3,10.12C3.1,9.09 3.53,8.17 4.19,7.46L2,5.27M5,10V11H7V13H8V11.27L6.73,10H5M16.5,6C18.86,6 20.79,7.81 21,10.12L22,17.5V17.75C22,18.41 21.64,19 21.1,19.28L7.82,6H16.5M16.5,8A0.75,0.75 0 0,0 15.75,8.75A0.75,0.75 0 0,0 16.5,9.5A0.75,0.75 0 0,0 17.25,8.75A0.75,0.75 0 0,0 16.5,8M14.75,9.75A0.75,0.75 0 0,0 14,10.5A0.75,0.75 0 0,0 14.75,11.25A0.75,0.75 0 0,0 15.5,10.5A0.75,0.75 0 0,0 14.75,9.75M18.25,9.75A0.75,0.75 0 0,0 17.5,10.5A0.75,0.75 0 0,0 18.25,11.25A0.75,0.75 0 0,0 19,10.5A0.75,0.75 0 0,0 18.25,9.75M16.5,11.5A0.75,0.75 0 0,0 15.75,12.25A0.75,0.75 0 0,0 16.5,13A0.75,0.75 0 0,0 17.25,12.25A0.75,0.75 0 0,0 16.5,11.5Z";
var mdiCookie = "M12,3A9,9 0 0,0 3,12A9,9 0 0,0 12,21A9,9 0 0,0 21,12C21,11.5 20.96,11 20.87,10.5C20.6,10 20,10 20,10H18V9C18,8 17,8 17,8H15V7C15,6 14,6 14,6H13V4C13,3 12,3 12,3M9.5,6A1.5,1.5 0 0,1 11,7.5A1.5,1.5 0 0,1 9.5,9A1.5,1.5 0 0,1 8,7.5A1.5,1.5 0 0,1 9.5,6M6.5,10A1.5,1.5 0 0,1 8,11.5A1.5,1.5 0 0,1 6.5,13A1.5,1.5 0 0,1 5,11.5A1.5,1.5 0 0,1 6.5,10M11.5,11A1.5,1.5 0 0,1 13,12.5A1.5,1.5 0 0,1 11.5,14A1.5,1.5 0 0,1 10,12.5A1.5,1.5 0 0,1 11.5,11M16.5,13A1.5,1.5 0 0,1 18,14.5A1.5,1.5 0 0,1 16.5,16H16.5A1.5,1.5 0 0,1 15,14.5H15A1.5,1.5 0 0,1 16.5,13M11,16A1.5,1.5 0 0,1 12.5,17.5A1.5,1.5 0 0,1 11,19A1.5,1.5 0 0,1 9.5,17.5A1.5,1.5 0 0,1 11,16Z";
var mdiCookieAlert = "M18 10H16V9C16 8 15 8 15 8H13V7C13 6 12 6 12 6H11V4C11 3 10 3 10 3C5 3 1 7 1 12S5 21 10 21 19 17 19 12C19 11.5 19 11 18.9 10.5C18.6 10 18 10 18 10M4.5 13C3.7 13 3 12.3 3 11.5S3.7 10 4.5 10 6 10.7 6 11.5 5.3 13 4.5 13M6 7.5C6 6.7 6.7 6 7.5 6S9 6.7 9 7.5 8.3 9 7.5 9 6 8.3 6 7.5M9 19C8.2 19 7.5 18.3 7.5 17.5S8.2 16 9 16 10.5 16.7 10.5 17.5 9.8 19 9 19M9.5 14C8.7 14 8 13.3 8 12.5S8.7 11 9.5 11 11 11.7 11 12.5 10.3 14 9.5 14M14.5 16C13.7 16 13 15.3 13 14.5S13.7 13 14.5 13C15.3 13 16 13.7 16 14.5S15.3 16 14.5 16M21 15H23V17H21V15M23 7V13H21V7H23Z";
var mdiCookieAlertOutline = "M16 14.5C16 15.3 15.3 16 14.5 16S13 15.3 13 14.5 13.7 13 14.5 13C15.3 13 16 13.7 16 14.5M18.9 10.5C19 11 19 11.5 19 12C19 17 15 21 10 21S1 17 1 12 5 3 10 3C10 3 11 3 11 4V6H12C12 6 13 6 13 7V8H15C15 8 16 8 16 9V10H18C18 10 18.6 10 18.9 10.5M17 12H15.5C14.7 12 14 11.3 14 10.5V10H12.5C11.7 10 11 9.3 11 8.5V8H10.5C9.7 8 9 7.3 9 6.5V5.1C5.9 5.5 3.5 8 3.1 11.1C3.2 10.5 3.8 10 4.5 10C5.3 10 6 10.7 6 11.5S5.3 13 4.5 13C3.7 13 3.1 12.4 3 11.6C3 12.1 3 12.6 3.1 13.1C3.5 15.8 5.6 18 8.2 18.7C7.8 18.4 7.5 18 7.5 17.5C7.5 16.7 8.2 16 9 16S10.5 16.7 10.5 17.5C10.5 18.2 10 18.8 9.3 19C13.5 19.4 17 16.1 17 12M9.5 11C8.7 11 8 11.7 8 12.5S8.7 14 9.5 14 11 13.3 11 12.5 10.3 11 9.5 11M9 7.5C9 6.7 8.3 6 7.5 6S6 6.7 6 7.5 6.7 9 7.5 9 9 8.3 9 7.5M21 17H23V15H21V17M21 7V13H23V7H21Z";
var mdiCookieCheck = "M15 14.53C15 14.5 15 14.5 15 14.5C15 13.67 15.67 13 16.5 13C16.8 13 17.08 13.09 17.32 13.24C17.85 13.09 18.42 13 19 13C19.66 13 20.3 13.12 20.89 13.32C20.96 12.89 21 12.45 21 12C21 11.5 20.96 11 20.87 10.5C20.6 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12S7.03 21 12 21C12.45 21 12.89 20.96 13.32 20.89C13.12 20.3 13 19.66 13 19C13 17.22 13.78 15.63 15 14.53M6.5 13C5.67 13 5 12.33 5 11.5S5.67 10 6.5 10 8 10.67 8 11.5 7.33 13 6.5 13M8 7.5C8 6.67 8.67 6 9.5 6S11 6.67 11 7.5 10.33 9 9.5 9 8 8.33 8 7.5M11 19C10.17 19 9.5 18.33 9.5 17.5S10.17 16 11 16 12.5 16.67 12.5 17.5 11.83 19 11 19M11.5 14C10.67 14 10 13.33 10 12.5S10.67 11 11.5 11 13 11.67 13 12.5 12.33 14 11.5 14M22.5 17.25L17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25Z";
var mdiCookieCheckOutline = "M15 10H14.5C13.67 10 13 9.33 13 8.5V8H12.5C11.67 8 11 7.33 11 6.5V5.07C7.91 5.5 5.47 8 5.07 11.08C5.25 10.46 5.82 10 6.5 10C7.33 10 8 10.67 8 11.5S7.33 13 6.5 13C5.71 13 5.07 12.39 5 11.62C5 12.11 5 12.61 5.09 13.12C5.5 15.81 7.54 18.04 10.16 18.74C9.76 18.47 9.5 18 9.5 17.5C9.5 16.67 10.17 16 11 16S12.5 16.67 12.5 17.5C12.5 18.22 12 18.82 11.32 18.96C11.9 19 12.46 19 13 18.92C13 18.95 13 18.97 13 19C13 19.66 13.12 20.3 13.32 20.89C12.89 20.96 12.45 21 12 21C7.03 21 3 16.97 3 12S7.03 3 12 3C12 3 13 3 13 4V6H14C14 6 15 6 15 7V8H17C17 8 18 8 18 9V10H20C20 10 20.6 10 20.87 10.5C20.96 11 21 11.5 21 12C21 12.45 20.96 12.89 20.89 13.32C20.3 13.12 19.66 13 19 13C18.97 13 18.95 13 18.92 13C18.97 12.68 19 12.34 19 12H17.5C16.67 12 16 11.33 16 10.5V10H15M15 14.5C15 14.5 15 14.5 15 14.53C15.66 13.95 16.45 13.5 17.32 13.24C17.08 13.09 16.8 13 16.5 13C15.67 13 15 13.67 15 14.5M11.5 14C12.33 14 13 13.33 13 12.5S12.33 11 11.5 11 10 11.67 10 12.5 10.67 14 11.5 14M11 7.5C11 6.67 10.33 6 9.5 6S8 6.67 8 7.5 8.67 9 9.5 9 11 8.33 11 7.5M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiCookieClock = "M19.97 10.24C19.95 10 19.91 9.74 19.87 9.5C19.6 9 19 9 19 9H17V8C17 7 16 7 16 7H14V6C14 5 13 5 13 5H12V3C12 2 11 2 11 2C6.03 2 2 6.03 2 11C2 15.71 5.62 19.57 10.23 19.96C11.5 21.8 13.61 23 16 23C19.87 23 23 19.87 23 16C23 13.61 21.8 11.5 19.97 10.24M11.64 10.53C10.87 11.15 10.23 11.92 9.78 12.81C9.32 12.55 9 12.06 9 11.5C9 10.67 9.67 10 10.5 10C10.96 10 11.36 10.21 11.64 10.53M5.5 12C4.67 12 4 11.33 4 10.5S4.67 9 5.5 9 7 9.67 7 10.5 6.33 12 5.5 12M7 6.5C7 5.67 7.67 5 8.5 5S10 5.67 10 6.5 9.33 8 8.5 8 7 7.33 7 6.5M8.5 16.5C8.5 16.04 8.71 15.64 9.03 15.36C9 15.57 9 15.79 9 16C9 16.62 9.09 17.22 9.24 17.79C8.8 17.5 8.5 17.05 8.5 16.5M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25Z";
var mdiCookieClockOutline = "M8.5 8C7.67 8 7 7.33 7 6.5S7.67 5 8.5 5 10 5.67 10 6.5 9.33 8 8.5 8M16.5 12H15V17L18.61 19.16L19.36 17.94L16.5 16.25V12M23 16C23 19.87 19.87 23 16 23C13.61 23 11.5 21.8 10.23 19.96C5.62 19.57 2 15.71 2 11C2 6.03 6.03 2 11 2C11 2 12 2 12 3V5H13C13 5 14 5 14 6V7H16C16 7 17 7 17 8V9H19C19 9 19.6 9 19.87 9.5C19.91 9.74 19.95 10 19.97 10.24C21.8 11.5 23 13.61 23 16M9.16 17.74C8.76 17.47 8.5 17 8.5 16.5C8.5 16.04 8.71 15.64 9.03 15.36C9.12 14.45 9.38 13.59 9.78 12.81C9.32 12.55 9 12.06 9 11.5C9 10.67 9.67 10 10.5 10C10.96 10 11.36 10.21 11.64 10.53C12.59 9.77 13.74 9.26 15 9.08V9H13.5C12.67 9 12 8.33 12 7.5V7H11.5C10.67 7 10 6.33 10 5.5V4.07C6.91 4.5 4.47 7 4.07 10.08C4.25 9.46 4.82 9 5.5 9C6.33 9 7 9.67 7 10.5S6.33 12 5.5 12C4.71 12 4.07 11.39 4 10.62C4 11.11 4 11.61 4.09 12.12C4.5 14.81 6.54 17.04 9.16 17.74M21 16C21 13.24 18.76 11 16 11S11 13.24 11 16 13.24 21 16 21 21 18.76 21 16Z";
var mdiCookieCog = "M21 12.29C21 12.19 21 12.1 21 12C21 11.5 20.96 11 20.87 10.5C20.6 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12S7.03 21 12 21C12.1 21 12.19 21 12.29 21C12.11 20.36 12 19.69 12 19C12 18.86 12 18.73 12 18.59C11.75 18.84 11.4 19 11 19C10.17 19 9.5 18.33 9.5 17.5S10.17 16 11 16C11.59 16 12.1 16.35 12.34 16.84C13.25 14.03 15.89 12 19 12C19.69 12 20.36 12.11 21 12.29M6.5 13C5.67 13 5 12.33 5 11.5S5.67 10 6.5 10 8 10.67 8 11.5 7.33 13 6.5 13M9.5 9C8.67 9 8 8.33 8 7.5S8.67 6 9.5 6 11 6.67 11 7.5 10.33 9 9.5 9M11.5 14C10.67 14 10 13.33 10 12.5S10.67 11 11.5 11 13 11.67 13 12.5 12.33 14 11.5 14M22.7 19.6V18.6L23.8 17.8C23.9 17.7 24 17.6 23.9 17.5L22.9 15.8C22.9 15.7 22.7 15.7 22.6 15.7L21.4 16.2C21.1 16 20.8 15.8 20.5 15.7L20.3 14.4C20.3 14.3 20.2 14.2 20.1 14.2H18.1C17.9 14.2 17.8 14.3 17.8 14.4L17.6 15.7C17.3 15.9 17.1 16 16.8 16.2L15.6 15.7C15.5 15.7 15.4 15.7 15.3 15.8L14.3 17.5C14.3 17.6 14.3 17.7 14.4 17.8L15.5 18.6V19.6L14.4 20.4C14.3 20.5 14.2 20.6 14.3 20.7L15.3 22.4C15.4 22.5 15.5 22.5 15.6 22.5L16.8 22C17 22.2 17.3 22.4 17.6 22.5L17.8 23.8C17.9 23.9 18 24 18.1 24H20.1C20.2 24 20.3 23.9 20.3 23.8L20.5 22.5C20.8 22.3 21 22.2 21.3 22L22.5 22.4C22.6 22.4 22.7 22.4 22.8 22.3L23.8 20.6C23.9 20.5 23.9 20.4 23.8 20.4L22.7 19.6M19 20.5C18.2 20.5 17.5 19.8 17.5 19S18.2 17.5 19 17.5 20.5 18.2 20.5 19 19.8 20.5 19 20.5Z";
var mdiCookieCogOutline = "M14.5 10C13.67 10 13 9.33 13 8.5V8H12.5C11.67 8 11 7.33 11 6.5V5.07C7.91 5.5 5.47 8 5.07 11.08C5.25 10.46 5.82 10 6.5 10C7.33 10 8 10.67 8 11.5S7.33 13 6.5 13C5.71 13 5.07 12.39 5 11.62C5 12.11 5 12.61 5.09 13.12C5.5 15.81 7.54 18.04 10.16 18.74C9.76 18.47 9.5 18 9.5 17.5C9.5 16.67 10.17 16 11 16C11.59 16 12.1 16.35 12.34 16.84C12.16 17.39 12.06 17.97 12 18.57C11.83 18.76 11.6 18.9 11.32 18.96C11.55 19 11.78 19 12 19V19C12 19.69 12.11 20.36 12.29 21C12.19 21 12.1 21 12 21C7.03 21 3 16.97 3 12S7.03 3 12 3C12 3 13 3 13 4V6H14C14 6 15 6 15 7V8H17C17 8 18 8 18 9V10H20C20 10 20.6 10 20.87 10.5C20.96 11 21 11.5 21 12C21 12.1 21 12.19 21 12.29C20.36 12.11 19.69 12 19 12H17.5C16.67 12 16 11.33 16 10.5V10H14.5M11.5 11C10.67 11 10 11.67 10 12.5S10.67 14 11.5 14 13 13.33 13 12.5 12.33 11 11.5 11M11 7.5C11 6.67 10.33 6 9.5 6S8 6.67 8 7.5 8.67 9 9.5 9 11 8.33 11 7.5M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiCookieEdit = "M15.1 15.03C15.04 14.86 15 14.69 15 14.5C15 13.67 15.67 13 16.5 13C16.69 13 16.86 13.04 17.03 13.1L19.39 10.74C19.69 10.44 20.05 10.24 20.44 10.12C20.21 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12C3 16.63 6.5 20.44 11 20.94V19.13L11.14 19C11.1 19 11.05 19 11 19C10.17 19 9.5 18.33 9.5 17.5S10.17 16 11 16 12.5 16.67 12.5 17.5C12.5 17.55 12.5 17.6 12.5 17.64L15.1 15.03M6.5 13C5.67 13 5 12.33 5 11.5S5.67 10 6.5 10 8 10.67 8 11.5 7.33 13 6.5 13M9.5 9C8.67 9 8 8.33 8 7.5S8.67 6 9.5 6 11 6.67 11 7.5 10.33 9 9.5 9M11.5 14C10.67 14 10 13.33 10 12.5S10.67 11 11.5 11 13 11.67 13 12.5 12.33 14 11.5 14M22.85 14.19L21.87 15.17L19.83 13.13L20.81 12.15C21 11.95 21.33 11.95 21.53 12.15L22.85 13.47C23.05 13.67 23.05 14 22.85 14.19M19.13 13.83L21.17 15.87L15.04 22H13V19.96L19.13 13.83Z";
var mdiCookieEditOutline = "M9.5 6C10.33 6 11 6.67 11 7.5S10.33 9 9.5 9 8 8.33 8 7.5 8.67 6 9.5 6M11.5 11C10.67 11 10 11.67 10 12.5S10.67 14 11.5 14 13 13.33 13 12.5 12.33 11 11.5 11M11 16C10.17 16 9.5 16.67 9.5 17.5C9.5 18 9.76 18.47 10.16 18.74C7.54 18.04 5.5 15.81 5.09 13.12C5 12.61 5 12.11 5 11.62C5.07 12.39 5.71 13 6.5 13C7.33 13 8 12.33 8 11.5S7.33 10 6.5 10C5.82 10 5.25 10.46 5.07 11.08C5.47 8 7.91 5.5 11 5.07V6.5C11 7.33 11.67 8 12.5 8H13V8.5C13 9.33 13.67 10 14.5 10H16V10.5C16 11.33 16.67 12 17.5 12H18.13L19.39 10.74C19.69 10.44 20.05 10.24 20.44 10.12C20.21 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12C3 16.63 6.5 20.44 11 20.94V19.13L12.47 17.66C12.5 17.6 12.5 17.55 12.5 17.5C12.5 16.67 11.83 16 11 16M15 14.5C15 14.69 15.04 14.86 15.1 15.03L17.03 13.1C16.86 13.04 16.69 13 16.5 13C15.67 13 15 13.67 15 14.5M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96Z";
var mdiCookieLock = "M18.5 11C19.42 11 20.27 11.29 21 11.77C21 11.35 20.95 10.92 20.87 10.5C20.6 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12S7.03 21 12 21C12.34 21 12.67 21 13 20.94V17C13 16.08 13.42 15.26 14.07 14.71C14.45 12.6 16.29 11 18.5 11M6.5 13C5.67 13 5 12.33 5 11.5S5.67 10 6.5 10 8 10.67 8 11.5 7.33 13 6.5 13M8 7.5C8 6.67 8.67 6 9.5 6S11 6.67 11 7.5 10.33 9 9.5 9 8 8.33 8 7.5M11 19C10.17 19 9.5 18.33 9.5 17.5S10.17 16 11 16 12.5 16.67 12.5 17.5 11.83 19 11 19M11.5 14C10.67 14 10 13.33 10 12.5S10.67 11 11.5 11 13 11.67 13 12.5 12.33 14 11.5 14M21 16V15.5C21 14.12 19.88 13 18.5 13S16 14.12 16 15.5V16C15.45 16 15 16.45 15 17V21C15 21.55 15.45 22 16 22H21C21.55 22 22 21.55 22 21V17C22 16.45 21.55 16 21 16M20 16H17V15.5C17 14.67 17.67 14 18.5 14S20 14.67 20 15.5V16Z";
var mdiCookieLockOutline = "M10 12.5C10 11.67 10.67 11 11.5 11S13 11.67 13 12.5 12.33 14 11.5 14 10 13.33 10 12.5M16 10V10.5C16 10.9 16.16 11.26 16.41 11.53C17.04 11.2 17.75 11 18.5 11C19.42 11 20.27 11.29 21 11.77C21 11.35 20.95 10.92 20.87 10.5C20.6 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12S7.03 21 12 21C12.34 21 12.67 21 13 20.94V18.92C12.46 19 11.9 19 11.32 18.96C12 18.82 12.5 18.22 12.5 17.5C12.5 16.67 11.83 16 11 16S9.5 16.67 9.5 17.5C9.5 18 9.76 18.47 10.16 18.74C7.54 18.04 5.5 15.81 5.09 13.12C5 12.61 5 12.11 5 11.62C5.07 12.39 5.71 13 6.5 13C7.33 13 8 12.33 8 11.5S7.33 10 6.5 10C5.82 10 5.25 10.46 5.07 11.08C5.47 8 7.91 5.5 11 5.07V6.5C11 7.33 11.67 8 12.5 8H13V8.5C13 9.33 13.67 10 14.5 10H16M11 7.5C11 6.67 10.33 6 9.5 6S8 6.67 8 7.5 8.67 9 9.5 9 11 8.33 11 7.5M22 17V21C22 21.55 21.55 22 21 22H16C15.45 22 15 21.55 15 21V17C15 16.45 15.45 16 16 16V15.5C16 14.12 17.12 13 18.5 13S21 14.12 21 15.5V16C21.55 16 22 16.45 22 17M20 15.5C20 14.67 19.33 14 18.5 14S17 14.67 17 15.5V16H20V15.5Z";
var mdiCookieMinus = "M15 14.53C15 14.5 15 14.5 15 14.5C15 13.67 15.67 13 16.5 13C16.8 13 17.08 13.09 17.32 13.24C17.85 13.09 18.42 13 19 13C19.66 13 20.3 13.12 20.89 13.32C20.96 12.89 21 12.45 21 12C21 11.5 20.96 11 20.87 10.5C20.6 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12S7.03 21 12 21C12.45 21 12.89 20.96 13.32 20.89C13.12 20.3 13 19.66 13 19C13 17.22 13.78 15.63 15 14.53M6.5 13C5.67 13 5 12.33 5 11.5S5.67 10 6.5 10 8 10.67 8 11.5 7.33 13 6.5 13M8 7.5C8 6.67 8.67 6 9.5 6S11 6.67 11 7.5 10.33 9 9.5 9 8 8.33 8 7.5M11 19C10.17 19 9.5 18.33 9.5 17.5S10.17 16 11 16 12.5 16.67 12.5 17.5 11.83 19 11 19M11.5 14C10.67 14 10 13.33 10 12.5S10.67 11 11.5 11 13 11.67 13 12.5 12.33 14 11.5 14M23 18V20H15V18H23Z";
var mdiCookieMinusOutline = "M15 10H14.5C13.67 10 13 9.33 13 8.5V8H12.5C11.67 8 11 7.33 11 6.5V5.07C7.91 5.5 5.47 8 5.07 11.08C5.25 10.46 5.82 10 6.5 10C7.33 10 8 10.67 8 11.5S7.33 13 6.5 13C5.71 13 5.07 12.39 5 11.62C5 12.11 5 12.61 5.09 13.12C5.5 15.81 7.54 18.04 10.16 18.74C9.76 18.47 9.5 18 9.5 17.5C9.5 16.67 10.17 16 11 16S12.5 16.67 12.5 17.5C12.5 18.22 12 18.82 11.32 18.96C11.9 19 12.46 19 13 18.92C13 18.95 13 18.97 13 19C13 19.66 13.12 20.3 13.32 20.89C12.89 20.96 12.45 21 12 21C7.03 21 3 16.97 3 12S7.03 3 12 3C12 3 13 3 13 4V6H14C14 6 15 6 15 7V8H17C17 8 18 8 18 9V10H20C20 10 20.6 10 20.87 10.5C20.96 11 21 11.5 21 12C21 12.45 20.96 12.89 20.89 13.32C20.3 13.12 19.66 13 19 13C18.97 13 18.95 13 18.92 13C18.97 12.68 19 12.34 19 12H17.5C16.67 12 16 11.33 16 10.5V10H15M15 14.5C15 14.5 15 14.5 15 14.53C15.66 13.95 16.45 13.5 17.32 13.24C17.08 13.09 16.8 13 16.5 13C15.67 13 15 13.67 15 14.5M11 7.5C11 6.67 10.33 6 9.5 6S8 6.67 8 7.5 8.67 9 9.5 9 11 8.33 11 7.5M11.5 14C12.33 14 13 13.33 13 12.5S12.33 11 11.5 11 10 11.67 10 12.5 10.67 14 11.5 14M15 18V20H23V18H15Z";
var mdiCookieOff = "M9.25 6.05L7.45 4.25C8.79 3.46 10.34 3 12 3C12 3 13 3 13 4V6H14C14 6 15 6 15 7V8H17C17 8 18 8 18 9V10H20C20 10 20.6 10 20.87 10.5C20.96 11 21 11.5 21 12C21 13.66 20.54 15.22 19.75 16.55L17.95 14.75C17.97 14.67 18 14.59 18 14.5C18 13.67 17.33 13 16.5 13C16.41 13 16.33 13.03 16.25 13.05L10.95 7.75C10.97 7.67 11 7.59 11 7.5C11 6.67 10.33 6 9.5 6C9.41 6 9.33 6.03 9.25 6.05M22.11 21.46L20.84 22.73L17.34 19.23C15.85 20.34 14 21 12 21C7.03 21 3 16.97 3 12C3 10 3.66 8.15 4.77 6.66L1.11 3L2.39 1.73L22.11 21.46M8 11.5C8 10.67 7.33 10 6.5 10S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5M10 12.5C10 13.33 10.67 14 11.5 14C11.68 14 11.85 13.96 12 13.9L10.1 12C10.04 12.15 10 12.32 10 12.5M12.5 17.5C12.5 16.67 11.83 16 11 16S9.5 16.67 9.5 17.5 10.17 19 11 19 12.5 18.33 12.5 17.5Z";
var mdiCookieOffOutline = "M8.93 5.73L7.45 4.25C8.79 3.46 10.34 3 12 3C12 3 13 3 13 4V6H14C14 6 15 6 15 7V8H17C17 8 18 8 18 9V10H20C20 10 20.6 10 20.87 10.5C20.96 11 21 11.5 21 12C21 13.66 20.54 15.22 19.75 16.55L18.28 15.08C18.74 14.15 19 13.11 19 12H17.5C16.67 12 16 11.33 16 10.5V10H14.5C13.67 10 13 9.33 13 8.5V8H12.5C11.67 8 11 7.33 11 6.5V5.07C10.26 5.18 9.57 5.41 8.93 5.73M9.25 6.05L10.95 7.75C10.97 7.67 11 7.59 11 7.5C11 6.67 10.33 6 9.5 6C9.41 6 9.33 6.03 9.25 6.05M16.25 13.05L17.95 14.75C17.97 14.67 18 14.59 18 14.5C18 13.67 17.33 13 16.5 13C16.41 13 16.33 13.03 16.25 13.05M22.11 21.46L20.84 22.73L17.34 19.23C15.85 20.34 14 21 12 21C7.03 21 3 16.97 3 12C3 10 3.66 8.15 4.77 6.66L1.11 3L2.39 1.73L22.11 21.46M15.9 17.79L12 13.9C11.85 13.96 11.68 14 11.5 14C10.67 14 10 13.33 10 12.5C10 12.32 10.04 12.15 10.1 12L6.21 8.1C5.62 9 5.21 10 5.07 11.08C5.25 10.46 5.82 10 6.5 10C7.33 10 8 10.67 8 11.5S7.33 13 6.5 13C5.71 13 5.07 12.39 5 11.62C5 12.11 5 12.61 5.09 13.12C5.5 15.81 7.54 18.04 10.16 18.74C9.76 18.47 9.5 18 9.5 17.5C9.5 16.67 10.17 16 11 16S12.5 16.67 12.5 17.5C12.5 18.22 12 18.82 11.32 18.96C13.03 19.12 14.61 18.66 15.9 17.79Z";
var mdiCookieOutline = "M20.87 10.5C20.6 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 11.5 20.96 11 20.87 10.5M11.32 18.96C12 18.82 12.5 18.22 12.5 17.5C12.5 16.67 11.83 16 11 16S9.5 16.67 9.5 17.5C9.5 18 9.76 18.47 10.16 18.74C7.54 18.04 5.5 15.81 5.09 13.12C5 12.61 5 12.11 5 11.62C5.07 12.39 5.71 13 6.5 13C7.33 13 8 12.33 8 11.5S7.33 10 6.5 10C5.82 10 5.25 10.46 5.07 11.08C5.47 8 7.91 5.5 11 5.07V6.5C11 7.33 11.67 8 12.5 8H13V8.5C13 9.33 13.67 10 14.5 10H16V10.5C16 11.33 16.67 12 17.5 12H19C19 16.08 15.5 19.36 11.32 18.96M9.5 9C8.67 9 8 8.33 8 7.5S8.67 6 9.5 6 11 6.67 11 7.5 10.33 9 9.5 9M13 12.5C13 13.33 12.33 14 11.5 14S10 13.33 10 12.5 10.67 11 11.5 11 13 11.67 13 12.5M18 14.5C18 15.33 17.33 16 16.5 16S15 15.33 15 14.5 15.67 13 16.5 13 18 13.67 18 14.5Z";
var mdiCookiePlus = "M15 14.53C15 14.5 15 14.5 15 14.5C15 13.67 15.67 13 16.5 13C16.8 13 17.08 13.09 17.32 13.24C17.85 13.09 18.42 13 19 13C19.66 13 20.3 13.12 20.89 13.32C20.96 12.89 21 12.45 21 12C21 11.5 20.96 11 20.87 10.5C20.6 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12S7.03 21 12 21C12.45 21 12.89 20.96 13.32 20.89C13.12 20.3 13 19.66 13 19C13 17.22 13.78 15.63 15 14.53M6.5 13C5.67 13 5 12.33 5 11.5S5.67 10 6.5 10 8 10.67 8 11.5 7.33 13 6.5 13M8 7.5C8 6.67 8.67 6 9.5 6S11 6.67 11 7.5 10.33 9 9.5 9 8 8.33 8 7.5M11 19C10.17 19 9.5 18.33 9.5 17.5S10.17 16 11 16 12.5 16.67 12.5 17.5 11.83 19 11 19M11.5 14C10.67 14 10 13.33 10 12.5S10.67 11 11.5 11 13 11.67 13 12.5 12.33 14 11.5 14M23 18V20H20V23H18V20H15V18H18V15H20V18H23Z";
var mdiCookiePlusOutline = "M16.5 13C16.8 13 17.08 13.09 17.32 13.24C16.45 13.5 15.66 13.95 15 14.53C15 14.5 15 14.5 15 14.5C15 13.67 15.67 13 16.5 13M16 10V10.5C16 11.33 16.67 12 17.5 12H19C19 12.34 18.97 12.68 18.92 13C18.95 13 18.97 13 19 13C19.66 13 20.3 13.12 20.89 13.32C20.96 12.89 21 12.45 21 12C21 11.5 20.96 11 20.87 10.5C20.6 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12S7.03 21 12 21C12.45 21 12.89 20.96 13.32 20.89C13.12 20.3 13 19.66 13 19C13 18.97 13 18.95 13 18.92C12.46 19 11.9 19 11.32 18.96C12 18.82 12.5 18.22 12.5 17.5C12.5 16.67 11.83 16 11 16S9.5 16.67 9.5 17.5C9.5 18 9.76 18.47 10.16 18.74C7.54 18.04 5.5 15.81 5.09 13.12C5 12.61 5 12.11 5 11.62C5.07 12.39 5.71 13 6.5 13C7.33 13 8 12.33 8 11.5S7.33 10 6.5 10C5.82 10 5.25 10.46 5.07 11.08C5.47 8 7.91 5.5 11 5.07V6.5C11 7.33 11.67 8 12.5 8H13V8.5C13 9.33 13.67 10 14.5 10H16M11.5 14C12.33 14 13 13.33 13 12.5S12.33 11 11.5 11 10 11.67 10 12.5 10.67 14 11.5 14M11 7.5C11 6.67 10.33 6 9.5 6S8 6.67 8 7.5 8.67 9 9.5 9 11 8.33 11 7.5M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiCookieRefresh = "M11 16C11.53 16 12 16.28 12.26 16.69C13.04 14 15.54 12 18.5 12C19.38 12 20.21 12.18 21 12.5C21 12.33 21 12.17 21 12C21 11.5 20.96 11 20.87 10.5C20.6 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12S7.03 21 12 21C12.17 21 12.33 21 12.5 21C12.19 20.24 12 19.44 12 18.61C11.74 18.85 11.39 19 11 19C10.17 19 9.5 18.33 9.5 17.5S10.17 16 11 16M13 12.5C13 13.33 12.33 14 11.5 14S10 13.33 10 12.5 10.67 11 11.5 11 13 11.67 13 12.5M6.5 13C5.67 13 5 12.33 5 11.5S5.67 10 6.5 10 8 10.67 8 11.5 7.33 13 6.5 13M8 7.5C8 6.67 8.67 6 9.5 6S11 6.67 11 7.5 10.33 9 9.5 9 8 8.33 8 7.5M18 18.5L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5S16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5S15.79 14.5 18 14.5C19.11 14.5 20.11 14.95 20.83 15.67L22 14.5V18.5H18Z";
var mdiCookieRefreshOutline = "M13 12.5C13 13.33 12.33 14 11.5 14S10 13.33 10 12.5 10.67 11 11.5 11 13 11.67 13 12.5M11 7.5C11 6.67 10.33 6 9.5 6S8 6.67 8 7.5 8.67 9 9.5 9 11 8.33 11 7.5M15 10H16V10.5C16 11.33 16.67 12 17.5 12H19L19 12.03C19.69 12.09 20.36 12.24 21 12.5C21 12.33 21 12.17 21 12C21 11.5 20.96 11 20.87 10.5C20.6 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12S7.03 21 12 21C12.17 21 12.33 21 12.5 21C12.24 20.36 12.09 19.69 12.03 19C11.8 19 11.56 19 11.32 18.96C11.59 18.9 11.81 18.76 12 18.58C12 18.55 12 18.53 12 18.5C12 17.87 12.1 17.27 12.26 16.69C12 16.28 11.53 16 11 16C10.17 16 9.5 16.67 9.5 17.5C9.5 18 9.76 18.47 10.16 18.74C7.54 18.04 5.5 15.81 5.09 13.12C5 12.61 5 12.11 5 11.62C5.07 12.39 5.71 13 6.5 13C7.33 13 8 12.33 8 11.5S7.33 10 6.5 10C5.82 10 5.25 10.46 5.07 11.08C5.47 8 7.91 5.5 11 5.07V6.5C11 7.33 11.67 8 12.5 8H13V8.5C13 9.33 13.67 10 14.5 10H15M22 18.5V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22Z";
var mdiCookieRemove = "M16.5 13C16.8 13 17.08 13.09 17.32 13.24C17.85 13.09 18.42 13 19 13C19.66 13 20.3 13.12 20.89 13.32C20.96 12.89 21 12.45 21 12C21 11.5 20.96 11 20.87 10.5C20.6 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12S7.03 21 12 21C12.45 21 12.89 20.96 13.32 20.89C13.12 20.3 13 19.66 13 19C13 17.22 13.78 15.63 15 14.53C15 14.5 15 14.5 15 14.5C15 13.67 15.67 13 16.5 13M6.5 13C5.67 13 5 12.33 5 11.5S5.67 10 6.5 10 8 10.67 8 11.5 7.33 13 6.5 13M8 7.5C8 6.67 8.67 6 9.5 6S11 6.67 11 7.5 10.33 9 9.5 9 8 8.33 8 7.5M11 19C10.17 19 9.5 18.33 9.5 17.5S10.17 16 11 16 12.5 16.67 12.5 17.5 11.83 19 11 19M11.5 14C10.67 14 10 13.33 10 12.5S10.67 11 11.5 11 13 11.67 13 12.5 12.33 14 11.5 14M20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19Z";
var mdiCookieRemoveOutline = "M17.32 13.24C16.45 13.5 15.66 13.95 15 14.53C15 14.5 15 14.5 15 14.5C15 13.67 15.67 13 16.5 13C16.8 13 17.08 13.09 17.32 13.24M16 10V10.5C16 11.33 16.67 12 17.5 12H19C19 12.34 18.97 12.68 18.92 13C18.95 13 18.97 13 19 13C19.66 13 20.3 13.12 20.89 13.32C20.96 12.89 21 12.45 21 12C21 11.5 20.96 11 20.87 10.5C20.6 10 20 10 20 10H18V9C18 8 17 8 17 8H15V7C15 6 14 6 14 6H13V4C13 3 12 3 12 3C7.03 3 3 7.03 3 12S7.03 21 12 21C12.45 21 12.89 20.96 13.32 20.89C13.12 20.3 13 19.66 13 19C13 18.97 13 18.95 13 18.92C12.46 19 11.9 19 11.32 18.96C12 18.82 12.5 18.22 12.5 17.5C12.5 16.67 11.83 16 11 16S9.5 16.67 9.5 17.5C9.5 18 9.76 18.47 10.16 18.74C7.54 18.04 5.5 15.81 5.09 13.12C5 12.61 5 12.11 5 11.62C5.07 12.39 5.71 13 6.5 13C7.33 13 8 12.33 8 11.5S7.33 10 6.5 10C5.82 10 5.25 10.46 5.07 11.08C5.47 8 7.91 5.5 11 5.07V6.5C11 7.33 11.67 8 12.5 8H13V8.5C13 9.33 13.67 10 14.5 10H16M11 7.5C11 6.67 10.33 6 9.5 6S8 6.67 8 7.5 8.67 9 9.5 9 11 8.33 11 7.5M11.5 14C12.33 14 13 13.33 13 12.5S12.33 11 11.5 11 10 11.67 10 12.5 10.67 14 11.5 14M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiCookieSettings = "M20.87 9.5C20.6 9 20 9 20 9H18V8C18 7 17 7 17 7H15V6C15 5 14 5 14 5H13V3C13 2 12 2 12 2C7.03 2 3 6.03 3 11S7.03 20 12 20 21 15.97 21 11C21 10.5 20.96 10 20.87 9.5M6.5 12C5.67 12 5 11.33 5 10.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12M8 6.5C8 5.67 8.67 5 9.5 5S11 5.67 11 6.5 10.33 8 9.5 8 8 7.33 8 6.5M11 18C10.17 18 9.5 17.33 9.5 16.5S10.17 15 11 15 12.5 15.67 12.5 16.5 11.83 18 11 18M11.5 13C10.67 13 10 12.33 10 11.5S10.67 10 11.5 10 13 10.67 13 11.5 12.33 13 11.5 13M16.5 15C15.67 15 15 14.33 15 13.5S15.67 12 16.5 12 18 12.67 18 13.5 17.33 15 16.5 15M7 22H9V24H7V22M11 22H13V24H11V22M15 22H17V24H15V22Z";
var mdiCookieSettingsOutline = "M13 11.5C13 12.33 12.33 13 11.5 13S10 12.33 10 11.5 10.67 10 11.5 10 13 10.67 13 11.5M11 6.5C11 5.67 10.33 5 9.5 5S8 5.67 8 6.5 8.67 8 9.5 8 11 7.33 11 6.5M21 11C21 15.97 16.97 20 12 20S3 15.97 3 11 7.03 2 12 2C12 2 13 2 13 3V5H14C14 5 15 5 15 6V7H17C17 7 18 7 18 8V9H20C20 9 20.6 9 20.87 9.5C20.96 10 21 10.5 21 11M19 11H17.5C16.67 11 16 10.33 16 9.5V9H14.5C13.67 9 13 8.33 13 7.5V7H12.5C11.67 7 11 6.33 11 5.5V4.07C7.91 4.5 5.47 7 5.07 10.08C5.25 9.46 5.82 9 6.5 9C7.33 9 8 9.67 8 10.5S7.33 12 6.5 12C5.71 12 5.07 11.39 5 10.62C5 11.11 5 11.61 5.09 12.12C5.5 14.81 7.54 17.04 10.16 17.74C9.76 17.47 9.5 17 9.5 16.5C9.5 15.67 10.17 15 11 15S12.5 15.67 12.5 16.5C12.5 17.22 12 17.82 11.32 17.96C15.5 18.36 19 15.08 19 11M16.5 12C15.67 12 15 12.67 15 13.5S15.67 15 16.5 15 18 14.33 18 13.5 17.33 12 16.5 12M7 24H9V22H7V24M15 24H17V22H15V24M11 24H13V22H11V24Z";
var mdiCoolantTemperature = "M11.5,1A1.5,1.5 0 0,0 10,2.5V14.5C9.37,14.97 9,15.71 9,16.5A2.5,2.5 0 0,0 11.5,19A2.5,2.5 0 0,0 14,16.5C14,15.71 13.63,15 13,14.5V13H17V11H13V9H17V7H13V5H17V3H13V2.5A1.5,1.5 0 0,0 11.5,1M0,15V17C0.67,17 0.79,17.21 1.29,17.71C1.79,18.21 2.67,19 4,19C5.33,19 6.21,18.21 6.71,17.71C6.82,17.59 6.91,17.5 7,17.41V15.16C6.21,15.42 5.65,15.93 5.29,16.29C4.79,16.79 4.67,17 4,17C3.33,17 3.21,16.79 2.71,16.29C2.21,15.79 1.33,15 0,15M16,15V17C16.67,17 16.79,17.21 17.29,17.71C17.79,18.21 18.67,19 20,19C21.33,19 22.21,18.21 22.71,17.71C23.21,17.21 23.33,17 24,17V15C22.67,15 21.79,15.79 21.29,16.29C20.79,16.79 20.67,17 20,17C19.33,17 19.21,16.79 18.71,16.29C18.21,15.79 17.33,15 16,15M8,20C6.67,20 5.79,20.79 5.29,21.29C4.79,21.79 4.67,22 4,22C3.33,22 3.21,21.79 2.71,21.29C2.35,20.93 1.79,20.42 1,20.16V22.41C1.09,22.5 1.18,22.59 1.29,22.71C1.79,23.21 2.67,24 4,24C5.33,24 6.21,23.21 6.71,22.71C7.21,22.21 7.33,22 8,22C8.67,22 8.79,22.21 9.29,22.71C9.73,23.14 10.44,23.8 11.5,23.96C11.66,24 11.83,24 12,24C13.33,24 14.21,23.21 14.71,22.71C15.21,22.21 15.33,22 16,22C16.67,22 16.79,22.21 17.29,22.71C17.79,23.21 18.67,24 20,24C21.33,24 22.21,23.21 22.71,22.71C22.82,22.59 22.91,22.5 23,22.41V20.16C22.21,20.42 21.65,20.93 21.29,21.29C20.79,21.79 20.67,22 20,22C19.33,22 19.21,21.79 18.71,21.29C18.21,20.79 17.33,20 16,20C14.67,20 13.79,20.79 13.29,21.29C12.79,21.79 12.67,22 12,22C11.78,22 11.63,21.97 11.5,21.92C11.22,21.82 11.05,21.63 10.71,21.29C10.21,20.79 9.33,20 8,20Z";
var mdiCopyleft = "M13.92 10.86C14.04 11.85 14.12 13.1 13.62 14C13.5 14.27 13.28 14.5 13.03 14.64C12.8 14.79 12.5 14.86 12.14 14.87C11.72 14.87 11.33 14.73 11 14.47C10.87 14.34 10.75 14.19 10.66 14C10.57 13.83 10.5 13.64 10.5 13.43H8.72C8.73 13.84 8.84 14.22 9 14.58C9.2 14.94 9.45 15.25 9.76 15.5C11.2 16.83 13.85 16.62 15.06 15.13C16.37 13.46 16.34 10.54 15.05 8.87C13.83 7.35 11.13 7.16 9.68 8.5C9.38 8.78 9.15 9.12 9 9.5C8.81 9.9 8.72 10.33 8.7 10.8H10.5C10.5 10.37 10.69 9.94 10.97 9.63C11.26 9.34 11.67 9.14 12.12 9.14C12.81 9.15 13.33 9.44 13.62 10C13.76 10.24 13.87 10.53 13.92 10.86M12 2C6.5 2 2 6.5 2 12C2.53 25.26 21.47 25.27 22 12C22 6.5 17.5 2 12 2M4 12C4.44 1.39 19.56 1.39 20 12C20 16.41 16.41 20 12 20S4 16.41 4 12Z";
var mdiCopyright = "M10.08 10.86C10.13 10.53 10.24 10.24 10.38 10C10.68 9.44 11.19 9.15 11.88 9.14C12.33 9.14 12.74 9.34 13.03 9.63C13.31 9.94 13.5 10.37 13.5 10.8H15.3C15.28 10.33 15.19 9.9 15 9.5C14.85 9.12 14.62 8.78 14.32 8.5C12.87 7.16 10.18 7.35 8.95 8.87C7.66 10.54 7.63 13.46 8.94 15.13C10.15 16.62 12.8 16.83 14.24 15.5C14.55 15.25 14.8 14.94 15 14.58C15.16 14.22 15.27 13.84 15.28 13.43H13.5C13.5 13.64 13.43 13.83 13.34 14C13.25 14.19 13.13 14.34 13 14.47C12.67 14.73 12.28 14.87 11.86 14.87C11.5 14.86 11.2 14.79 10.97 14.64C10.72 14.5 10.5 14.27 10.38 14C9.88 13.1 9.96 11.85 10.08 10.86M12 2C6.5 2 2 6.5 2 12C2.53 25.27 21.5 25.26 22 12C22 6.5 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12C4.44 1.39 19.56 1.39 20 12C20 16.41 16.41 20 12 20Z";
var mdiCordova = "M20.18,21.55H16.94L17.17,18.82H15.58L15.35,21.55H8.65L8.42,18.82H6.83L7.06,21.55H3.82L2,9.73L6.55,2.45H17.45L22,9.73L20.18,21.55M16.55,6.09H13.62L13.82,7.45H10.18L10.38,6.09H7.45L5.64,9.73L6.55,17H17.45L18.36,9.73L16.55,6.09M14.95,14.59C14.7,14.59 14.5,13.83 14.5,12.9C14.5,11.96 14.7,11.2 14.95,11.2C15.21,11.2 15.41,11.96 15.41,12.9C15.41,13.83 15.21,14.59 14.95,14.59M9.22,14.73C8.96,14.73 8.76,13.97 8.76,13.04C8.76,12.1 8.96,11.35 9.22,11.35C9.47,11.35 9.67,12.1 9.67,13.04C9.67,13.97 9.47,14.73 9.22,14.73Z";
var mdiCorn = "M11,12H8.82C9.62,12.5 10.35,13.07 11,13.68V12M7,11C7.27,5.88 9.37,2 12,2C14.66,2 16.77,5.94 17,11.12C18.5,10.43 20.17,10 22,10C16.25,12.57 18.25,22 12,22C6,22 7.93,12.57 2,10C3.82,10 5.5,10.4 7,11M11,11V9H8.24L8.03,11H11M11,8V6H9.05C8.8,6.6 8.6,7.27 8.43,8H11M11,5V3.3C10.45,3.63 9.95,4.22 9.5,5H11M12,3V5H13V6H12V8H14V9H12V11H15V12H12V14H14V15H12.23C13.42,16.45 14.15,18 14.32,19.23C15.31,17.56 15.96,14.84 16,11.76C15.94,7 14.13,3 12,3Z";
var mdiCornOff = "M22.1 21.5L2.4 1.7L1.1 3L7.2 9.1C7.1 9.7 7 10.3 7 11C5.5 10.4 3.8 10 2 10C7.9 12.6 6 22 12 22C14.5 22 15.7 20.5 16.6 18.5L20.9 22.8L22.1 21.5M8.1 10L9.1 11H8L8.1 10M8.8 12H10.1L11 12.9V13.7C10.3 13.1 9.6 12.5 8.8 12M14.3 19.2C14.1 18 13.4 16.4 12.2 15H13.1L15.2 17.1C15 17.9 14.7 18.6 14.3 19.2M11 6V7.8L12.2 9H14V8H12V6H13V5H12V3C14.1 3 15.9 7 16 11.8V12.8L18 14.8C18.8 12.8 19.9 10.9 22 10C20.2 10 18.5 10.4 17 11.1C16.8 5.9 14.7 2 12 2C10.5 2 9.2 3.2 8.3 5.1L9.2 6H11M11 3.3V5H9.5C10 4.2 10.5 3.6 11 3.3M15 11.8L14.2 11H15V11.8Z";
var mdiCosineWave = "M22 2V4C20.26 4 19 8.58 17.96 12.27C16.57 17.27 15.26 22 12 22C8.74 22 7.43 17.27 6.04 12.27C5 8.58 3.74 4 2 4V2C5.26 2 6.57 6.73 7.96 11.73C9 15.42 10.26 20 12 20C13.74 20 15 15.42 16.04 11.73C17.43 6.73 18.74 2 22 2Z";
var mdiCounter = "M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M4,6V18H11V6H4M20,18V6H18.76C19,6.54 18.95,7.07 18.95,7.13C18.88,7.8 18.41,8.5 18.24,8.75L15.91,11.3L19.23,11.28L19.24,12.5L14.04,12.47L14,11.47C14,11.47 17.05,8.24 17.2,7.95C17.34,7.67 17.91,6 16.5,6C15.27,6.05 15.41,7.3 15.41,7.3L13.87,7.31C13.87,7.31 13.88,6.65 14.25,6H13V18H15.58L15.57,17.14L16.54,17.13C16.54,17.13 17.45,16.97 17.46,16.08C17.5,15.08 16.65,15.08 16.5,15.08C16.37,15.08 15.43,15.13 15.43,15.95H13.91C13.91,15.95 13.95,13.89 16.5,13.89C19.1,13.89 18.96,15.91 18.96,15.91C18.96,15.91 19,17.16 17.85,17.63L18.37,18H20M8.92,16H7.42V10.2L5.62,10.76V9.53L8.76,8.41H8.92V16Z";
var mdiCountertop = "M18 10V7C18 5.34 16.66 4 15 4S12 5.34 12 7H14C14 6.45 14.45 6 15 6S16 6.45 16 7V10H8C9.1 10 10 9.1 10 8V4H4V8C4 9.1 4.9 10 6 10H2V12H4V20H20V12H22V10H18M13 18H11V12H13V18Z";
var mdiCountertopOutline = "M22 10H18V7C18 5.34 16.66 4 15 4S12 5.34 12 7H14C14 6.45 14.45 6 15 6S16 6.45 16 7V10H8C9.1 10 10 9.1 10 8V4H4V8C4 9.1 4.9 10 6 10H2V12H4V20H20V12H22V10M6 6H8V8H6V6M6 18V12H11V18H6M18 18H13V12H18V18Z";
var mdiCow = "M10.5,18A0.5,0.5 0 0,1 11,18.5A0.5,0.5 0 0,1 10.5,19A0.5,0.5 0 0,1 10,18.5A0.5,0.5 0 0,1 10.5,18M13.5,18A0.5,0.5 0 0,1 14,18.5A0.5,0.5 0 0,1 13.5,19A0.5,0.5 0 0,1 13,18.5A0.5,0.5 0 0,1 13.5,18M10,11A1,1 0 0,1 11,12A1,1 0 0,1 10,13A1,1 0 0,1 9,12A1,1 0 0,1 10,11M14,11A1,1 0 0,1 15,12A1,1 0 0,1 14,13A1,1 0 0,1 13,12A1,1 0 0,1 14,11M18,18C18,20.21 15.31,22 12,22C8.69,22 6,20.21 6,18C6,17.1 6.45,16.27 7.2,15.6C6.45,14.6 6,13.35 6,12L6.12,10.78C5.58,10.93 4.93,10.93 4.4,10.78C3.38,10.5 1.84,9.35 2.07,8.55C2.3,7.75 4.21,7.6 5.23,7.9C5.82,8.07 6.45,8.5 6.82,8.96L7.39,8.15C6.79,7.05 7,4 10,3L9.91,3.14V3.14C9.63,3.58 8.91,4.97 9.67,6.47C10.39,6.17 11.17,6 12,6C12.83,6 13.61,6.17 14.33,6.47C15.09,4.97 14.37,3.58 14.09,3.14L14,3C17,4 17.21,7.05 16.61,8.15L17.18,8.96C17.55,8.5 18.18,8.07 18.77,7.9C19.79,7.6 21.7,7.75 21.93,8.55C22.16,9.35 20.62,10.5 19.6,10.78C19.07,10.93 18.42,10.93 17.88,10.78L18,12C18,13.35 17.55,14.6 16.8,15.6C17.55,16.27 18,17.1 18,18M12,16C9.79,16 8,16.9 8,18C8,19.1 9.79,20 12,20C14.21,20 16,19.1 16,18C16,16.9 14.21,16 12,16M12,14C13.12,14 14.17,14.21 15.07,14.56C15.65,13.87 16,13 16,12A4,4 0 0,0 12,8A4,4 0 0,0 8,12C8,13 8.35,13.87 8.93,14.56C9.83,14.21 10.88,14 12,14M14.09,3.14V3.14Z";
var mdiCowOff = "M22.1 21.5L2.4 1.7L1.1 3L6.9 8.8L6.8 9C6.4 8.5 5.8 8.1 5.2 7.9C4.2 7.6 2.3 7.7 2 8.5S3.3 10.5 4.3 10.7C4.8 10.8 5.5 10.8 6 10.7V12C6 13.3 6.5 14.6 7.2 15.6C6.5 16.3 6 17.1 6 18C6 20.2 8.7 22 12 22C14.5 22 16.7 21 17.6 19.5L20.9 22.8L22.1 21.5M9.4 11.2C9.1 11.4 9 11.7 9 12C9 12.6 9.4 13 10 13C10.3 13 10.6 12.9 10.8 12.6L12.2 14H12.1C11 14 9.9 14.2 9 14.6C8.3 13.9 8 13 8 12C8 11.4 8.1 10.8 8.4 10.3L9.4 11.2M16 18C16 19.1 14.2 20 12 20S8 19.1 8 18 9.8 16 12 16C13 16 13.9 16.2 14.6 16.5L16 17.9V18M9.7 6.5L7.8 4.6C8.3 3.9 9 3.3 10 3L9.9 3.1C9.6 3.6 8.9 5 9.7 6.5M11.3 8.1L9.7 6.5C10.4 6.2 11.2 6 12 6S13.6 6.2 14.3 6.5C15.1 5 14.3 3.6 14.1 3.2L14 3C17 4 17.2 7 16.6 8.2L17.2 9C17.6 8.5 18.2 8.1 18.8 7.9C19.8 7.6 21.7 7.7 22 8.5S20.7 10.5 19.7 10.7C19.2 10.8 18.5 10.8 18 10.7V12C18 12.8 17.8 13.6 17.5 14.3L15.9 12.7C15.9 12.5 16 12.2 16 12C16 9.8 14.2 8 12 8C11.8 8 11.5 8 11.3 8.1M14 18.5C14 18.8 13.8 19 13.5 19S13 18.8 13 18.5 13.2 18 13.5 18 14 18.2 14 18.5M11 18.5C11 18.8 10.8 19 10.5 19S10 18.8 10 18.5 10.2 18 10.5 18 11 18.2 11 18.5Z";
var mdiCpu32Bit = "M9,3V5H7A2,2 0 0,0 5,7V9H3V11H5V13H3V15H5V17A2,2 0 0,0 7,19H9V21H11V19H13V21H15V19H17A2,2 0 0,0 19,17V15H21V13H19V11H21V9H19V7A2,2 0 0,0 17,5H15V3H13V5H11V3M7,9H10.5A1,1 0 0,1 11.5,10V14A1,1 0 0,1 10.5,15H7V13.5H10V12.75H8.5V11.25H10V10.5H7M12.5,9H16A1,1 0 0,1 17,10V11.75A1,1 0 0,1 16,12.75H14V13.5H17V15H12.5V12.25A1,1 0 0,1 13.5,11.25H15.5V10.5H12.5";
var mdiCpu64Bit = "M9,3V5H7A2,2 0 0,0 5,7V9H3V11H5V13H3V15H5V17A2,2 0 0,0 7,19H9V21H11V19H13V21H15V19H17A2,2 0 0,0 19,17V15H21V13H19V11H21V9H19V7A2,2 0 0,0 17,5H15V3H13V5H11V3M8,9H11.5V10.5H8.5V11.25H10.5A1,1 0 0,1 11.5,12.25V14A1,1 0 0,1 10.5,15H8A1,1 0 0,1 7,14V10A1,1 0 0,1 8,9M12.5,9H14V11H15.5V9H17V15H15.5V12.5H12.5M8.5,12.75V13.5H10V12.75";
var mdiCradle = "M18 9H12V4H8C5.8 4 4 5.8 4 8V14C4 15.1 4.9 16 6 16H8V18.9C7.4 18.5 6.8 18.1 6.3 17.6L4.9 19C6.7 20.9 9.2 22 12 22S17.3 20.9 19.1 19.1L17.7 17.7C17.2 18.2 16.7 18.6 16.1 19V16H18.1C19.2 16 20.1 15.1 20.1 14V11C20 9.9 19.1 9 18 9M14 19.8C13.4 20 12.7 20 12 20S10.6 19.9 10 19.8V16H14V19.8Z";
var mdiCradleOutline = "M18 9H12V4H8C5.8 4 4 5.8 4 8V14C4 15.1 4.9 16 6 16H8V18.9C7.4 18.5 6.8 18.1 6.3 17.6L4.9 19C6.7 20.9 9.2 22 12 22S17.3 20.9 19.1 19.1L17.7 17.7C17.2 18.2 16.7 18.6 16.1 19V16H18.1C19.2 16 20.1 15.1 20.1 14V11C20 9.9 19.1 9 18 9M14 19.8C13.4 20 12.7 20 12 20S10.6 19.9 10 19.8V16H14V19.8M18 14H6V8C6 6.9 6.9 6 8 6H10V11H18V14Z";
var mdiCrane = "M20,6V5A1,1 0 0,0 19,4H9V3H6V4H5V6H6V15H5V13H3V15H2V17H3V21H5V17H10V21H12V19.92L12,17H13V15H12V13H10V15H9V6H17V10.62C16.53,10.79 16.19,11.23 16.19,11.76C16.19,12.2 16.43,12.6 16.8,12.82V14H17.42C17.76,14 18.03,14.28 18.03,14.62C18.03,14.96 17.76,15.24 17.42,15.24C17.2,15.24 17,15.12 16.89,14.93C16.71,14.64 16.34,14.54 16.05,14.71C15.75,14.87 15.65,15.25 15.82,15.55C16.15,16.11 16.76,16.47 17.42,16.47C18.43,16.47 19.26,15.64 19.26,14.62C19.26,13.84 18.76,13.14 18.03,12.88V12.82C18.41,12.6 18.65,12.2 18.65,11.76C18.65,11.3 18.38,10.91 18,10.7V6H20M8,13.66L7,14.66V13.24L8,12.24V13.66M8,10.71L7,11.71V10.29L8,9.29V10.71M7,8.71V7.29L8,6.29V7.71L7,8.71Z";
var mdiCreation = "M19,1L17.74,3.75L15,5L17.74,6.26L19,9L20.25,6.26L23,5L20.25,3.75M9,4L6.5,9.5L1,12L6.5,14.5L9,20L11.5,14.5L17,12L11.5,9.5M19,15L17.74,17.74L15,19L17.74,20.25L19,23L20.25,20.25L23,19L20.25,17.74";
var mdiCreationOutline = "M9 4L11.5 9.5L17 12L11.5 14.5L9 20L6.5 14.5L1 12L6.5 9.5L9 4M9 8.83L8 11L5.83 12L8 13L9 15.17L10 13L12.17 12L10 11L9 8.83M19 9L17.74 6.26L15 5L17.74 3.75L19 1L20.25 3.75L23 5L20.25 6.26L19 9M19 23L17.74 20.26L15 19L17.74 17.75L19 15L20.25 17.75L23 19L20.25 20.26L19 23Z";
var mdiCreativeCommons = "M11.89,10.34L10.55,11.04C10.41,10.74 10.24,10.53 10.03,10.41C9.82,10.29 9.62,10.23 9.45,10.23C8.55,10.23 8.11,10.82 8.11,12C8.11,12.54 8.22,12.97 8.45,13.29C8.67,13.61 9,13.77 9.45,13.77C10.03,13.77 10.44,13.5 10.68,12.91L11.91,13.54C11.65,14.03 11.29,14.41 10.82,14.69C10.36,14.97 9.85,15.11 9.29,15.11C8.39,15.11 7.67,14.84 7.12,14.29C6.58,13.74 6.3,13 6.3,12C6.3,11.05 6.58,10.3 7.13,9.74C7.69,9.18 8.39,8.9 9.23,8.9C10.47,8.89 11.36,9.38 11.89,10.34M17.66,10.34L16.34,11.04C16.2,10.74 16,10.53 15.81,10.41C15.6,10.29 15.4,10.23 15.21,10.23C14.32,10.23 13.87,10.82 13.87,12C13.87,12.54 14,12.97 14.21,13.29C14.44,13.61 14.77,13.77 15.21,13.77C15.8,13.77 16.21,13.5 16.45,12.91L17.7,13.54C17.42,14.03 17.05,14.41 16.59,14.69C16.12,14.97 15.62,15.11 15.07,15.11C14.17,15.11 13.44,14.84 12.9,14.29C12.36,13.74 12.09,13 12.09,12C12.09,11.05 12.37,10.3 12.92,9.74C13.47,9.18 14.17,8.9 15,8.9C16.26,8.89 17.14,9.38 17.66,10.34M12,3.5A8.5,8.5 0 0,1 20.5,12A8.5,8.5 0 0,1 12,20.5A8.5,8.5 0 0,1 3.5,12A8.5,8.5 0 0,1 12,3.5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiCreditCard = "M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V6A2 2 0 0 0 20 4M20 11H4V8H20Z";
var mdiCreditCardCheck = "M20 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.03 19.67 13 19.34 13 19C13 15.69 15.69 13 19 13C20.06 13 21.09 13.28 22 13.81V6C22 4.89 21.11 4 20 4M20 11H4V8H20M17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25L17.75 22";
var mdiCreditCardCheckOutline = "M13 19C13 18.66 13.04 18.33 13.09 18H3V12H19V13C19.7 13 20.37 13.13 21 13.35V6C21 4.89 20.11 4 19 4H3C1.89 4 1 4.89 1 6V18C1 19.1 1.89 20 3 20H13.09C13.04 19.67 13 19.34 13 19M3 6H19V8H3V6M17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25L17.75 22";
var mdiCreditCardChip = "M20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4M10 14H5V10H10V14Z";
var mdiCreditCardChipOutline = "M20 6L20 18L4 18L4 6H20M20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4M11 10H6V14H11V10Z";
var mdiCreditCardClock = "M16,14H17.5V16.82L19.94,18.23L19.19,19.53L16,17.69V14M24,17A7,7 0 0,1 17,24C14.21,24 11.8,22.36 10.67,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H20A2,2 0 0,1 22,6V12.1C23.24,13.36 24,15.09 24,17M17,12A5,5 0 0,0 12,17A5,5 0 0,0 17,22A5,5 0 0,0 22,17A5,5 0 0,0 17,12M20,10V7H4V10H20Z";
var mdiCreditCardClockOutline = "M16,14H17.5V16.82L19.94,18.23L19.19,19.53L16,17.69V14M24,17A7,7 0 0,1 17,24C14.21,24 11.8,22.36 10.67,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H20A2,2 0 0,1 22,6V12.1C23.24,13.36 24,15.09 24,17M10,17C10,15.04 10.81,13.27 12.1,12H4V18H10.07C10,17.67 10,17.34 10,17M17,12A5,5 0 0,0 12,17A5,5 0 0,0 17,22A5,5 0 0,0 22,17A5,5 0 0,0 17,12M20,8V6H4V8H20Z";
var mdiCreditCardEdit = "M20.6 11.3C20.7 11.2 20.8 11.1 21 11.1C21.1 11.1 21.3 11.2 21.4 11.3L22.6 12.5C22.8 12.7 22.8 13.1 22.6 13.3L21.6 14.3L19.6 12.3L20.6 11.3M13 18.9L19 12.8L21.1 14.9L15.1 21H13V18.9M11 19.1V18.1L11.6 17.5L18.1 11H4V8H20V9.1L22 7.1V6C22 4.9 21.1 4 20 4H4C3.5 4 3 4.2 2.6 4.6C2.2 5 2 5.5 2 6V18C2 18.5 2.2 19 2.6 19.4C3 19.8 3.5 20 4 20H11V19.1Z";
var mdiCreditCardEditOutline = "M13 18.9L19.1 12.8L21.2 14.9L15.1 21H13V18.9M21.4 11.3L22.7 12.6C22.9 12.8 22.9 13.1 22.7 13.3L21.7 14.3L19.6 12.3L20.6 11.3C20.7 11.2 20.8 11.1 21 11.1C21.2 11.1 21.3 11.2 21.4 11.3M11 18H4V12H17.1L22 7.1V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H11V18M4 6H20V8H4V6Z";
var mdiCreditCardFast = "M3 8C2.45 8 2 7.55 2 7S2.45 6 3 6H5.54C5.19 6.6 5 7.29 5 8H3M5 13H2C1.45 13 1 12.55 1 12S1.45 11 2 11H5V13M1 18C.448 18 0 17.55 0 17S.448 16 1 16H5C5 16.71 5.19 17.4 5.54 18H1M21 6H9C7.89 6 7 6.89 7 8V16C7 17.11 7.89 18 9 18H21C22.11 18 23 17.11 23 16V8C23 6.89 22.11 6 21 6M21 12H9V9H21V12Z";
var mdiCreditCardFastOutline = "M3 8C2.45 8 2 7.55 2 7S2.45 6 3 6H5.54C5.19 6.6 5 7.29 5 8H3M5 13H2C1.45 13 1 12.55 1 12S1.45 11 2 11H5V13M1 18C.448 18 0 17.55 0 17S.448 16 1 16H5C5 16.71 5.19 17.4 5.54 18H1M21 6H9C7.89 6 7 6.89 7 8V16C7 17.11 7.89 18 9 18H21C22.11 18 23 17.11 23 16V8C23 6.89 22.11 6 21 6M21 8V9H9V8H21M9 16L9 12H21L21 16L9 16Z";
var mdiCreditCardLock = "M21.8 15V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V15C15.6 15 15 15.6 15 16.2V19.7C15 20.4 15.6 21 16.2 21H21.7C22.4 21 23 20.4 23 19.8V16.3C23 15.6 22.4 15 21.8 15M20.5 15H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V15M13.03 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H20C21.11 4 22 4.89 22 6V10.04C21.42 9.6 20.75 9.26 20 9.11V8H4V11H15.04C14.5 11.72 14.2 12.58 14.2 13.5V13.74C13.5 14.34 13 15.24 13 16.2V19.7C13 19.8 13 19.9 13.03 20Z";
var mdiCreditCardLockOutline = "M21.8 15V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V15C15.6 15 15 15.6 15 16.2V19.7C15 20.4 15.6 21 16.2 21H21.7C22.4 21 23 20.4 23 19.8V16.3C23 15.6 22.4 15 21.8 15M20.5 15H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V15M13 19.7V18H4V12H14.5C15.18 10.28 16.96 9 19 9C20.13 9 21.17 9.4 22 10.04V6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.03C13 19.9 13 19.8 13 19.7M4 6H20V8H4V6Z";
var mdiCreditCardMarker = "M18.5 12C16.6 12 15 13.6 15 15.5C15 18.1 18.5 22 18.5 22S22 18.1 22 15.5C22 13.6 20.4 12 18.5 12M18.5 16.8C17.8 16.8 17.3 16.2 17.3 15.6C17.3 14.9 17.9 14.4 18.5 14.4S19.7 15 19.7 15.6C19.8 16.2 19.2 16.8 18.5 16.8M14.55 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H20C21.11 4 22 4.89 22 6V11.3C21.42 10.81 20.74 10.44 20 10.22V8H4V11H15.39C13.96 12 13 13.66 13 15.5C13 17 13.72 18.61 14.55 20Z";
var mdiCreditCardMarkerOutline = "M13.5,18H4V12H14.3C15.3,10.8 16.8,10 18.5,10C19.8,10 21,10.5 22,11.3V6A2,2 0 0,0 20,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H14.6C14.2,19.4 13.8,18.7 13.5,18M4,6H20V8H4V6M18.5,12C16.6,12 15,13.6 15,15.5C15,18.1 18.5,22 18.5,22C18.5,22 22,18.1 22,15.5C22,13.6 20.4,12 18.5,12M18.5,16.8C17.8,16.8 17.3,16.2 17.3,15.6C17.3,14.9 17.9,14.4 18.5,14.4C19.1,14.4 19.7,15 19.7,15.6C19.8,16.2 19.2,16.8 18.5,16.8Z";
var mdiCreditCardMinus = "M20 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.03 19.67 13 19.34 13 19C13 15.69 15.69 13 19 13C20.06 13 21.09 13.28 22 13.81V6C22 4.89 21.11 4 20 4M20 11H4V8H20M23 18V20H15V18H23Z";
var mdiCreditCardMinusOutline = "M24 18V20H16V18M19 8V6H3V8H19M19 12H3V18H14V20H3C1.89 20 1 19.1 1 18V6C1 4.89 1.89 4 3 4H19C20.11 4 21 4.89 21 6V13H19V12Z";
var mdiCreditCardMultiple = "M21 9V6H7V9H21M21 3A2 2 0 0 1 23 5V15A2 2 0 0 1 21 17H7A2 2 0 0 1 5 15V5A2 2 0 0 1 7 3H21M3 19H18V21H3A2 2 0 0 1 1 19V8H3Z";
var mdiCreditCardMultipleOutline = "M21,8V6H7V8H21M21,16V11H7V16H21M21,4A2,2 0 0,1 23,6V16A2,2 0 0,1 21,18H7C5.89,18 5,17.1 5,16V6C5,4.89 5.89,4 7,4H21M3,20H18V22H3A2,2 0 0,1 1,20V9H3V20Z";
var mdiCreditCardOff = "M11.2 8L7.2 4H20A2 2 0 0 1 22 6V18A1.91 1.91 0 0 1 21.88 18.68L14.2 11H20V8M20.84 22.73L18.11 20H4A2 2 0 0 1 2 18V6A2 2 0 0 1 2.65 4.54L1.11 3L2.39 1.73L22.11 21.46M9.11 11L6.11 8H4V11Z";
var mdiCreditCardOffOutline = "M0.93,4.2L2.21,2.93L20,20.72L18.73,22L16.73,20H4C2.89,20 2,19.1 2,18V6C2,5.78 2.04,5.57 2.11,5.38L0.93,4.2M20,8V6H7.82L5.82,4H20A2,2 0 0,1 22,6V18C22,18.6 21.74,19.13 21.32,19.5L19.82,18H20V12H13.82L9.82,8H20M4,8H4.73L4,7.27V8M4,12V18H14.73L8.73,12H4Z";
var mdiCreditCardOutline = "M20,8H4V6H20M20,18H4V12H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z";
var mdiCreditCardPlus = "M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H13.09A5.47 5.47 0 0 1 13 19A6 6 0 0 1 19 13A5.88 5.88 0 0 1 22 13.81V6A2 2 0 0 0 20 4M20 11H4V8H20M20 15V18H23V20H20V23H18V20H15V18H18V15Z";
var mdiCreditCardPlusOutline = "M21,18H24V20H21V23H19V20H16V18H19V15H21V18M19,8V6H3V8H19M19,12H3V18H14V20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H19A2,2 0 0,1 21,6V13H19V12Z";
var mdiCreditCardRefresh = "M20 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H11.68C11.57 19.5 11.5 19 11.5 18.5C11.5 14.91 14.41 12 18 12C19.5 12 20.9 12.53 22 13.4V6C22 4.89 21.11 4 20 4M20 11H4V8H20V11M20.83 15.67L22 14.5V18.5H18L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5S16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5S15.79 14.5 18 14.5C19.11 14.5 20.11 14.95 20.83 15.67Z";
var mdiCreditCardRefreshOutline = "M20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H11.68C11.57 19.5 11.5 19 11.5 18.5C11.5 18.33 11.5 18.17 11.53 18H4V12H20V12.32C20.74 12.56 21.41 12.93 22 13.4V6C22 4.89 21.1 4 20 4M20 8H4V6H20V8M20.83 15.67L22 14.5V18.5H18L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5S16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5S15.79 14.5 18 14.5C19.11 14.5 20.11 14.95 20.83 15.67Z";
var mdiCreditCardRefund = "M18 11H6A2 2 0 0 0 4 13V21A2 2 0 0 0 6 23H18A2 2 0 0 0 20 21V13A2 2 0 0 0 18 11M18 17H6V14H18M17 5V10H15.5V6.5H9.88L12.3 8.93L11.24 10L7 5.75L11.24 1.5L12.3 2.57L9.88 5Z";
var mdiCreditCardRefundOutline = "M18,11H6A2,2 0 0,0 4,13V21A2,2 0 0,0 6,23H18A2,2 0 0,0 20,21V13A2,2 0 0,0 18,11M18,21H6V17H18V21M18,15H6V13H18V15M17,5V10H15.5V6.5H9.88L12.3,8.93L11.24,10L7,5.75L11.24,1.5L12.3,2.57L9.88,5H17Z";
var mdiCreditCardRemove = "M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H13.09A5.47 5.47 0 0 1 13 19A6 6 0 0 1 19 13A5.88 5.88 0 0 1 22 13.81V6A2 2 0 0 0 20 4M20 11H4V8H20M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.46 21.12L17.59 19L15.46 16.88L16.88 15.46L19 17.59L21.12 15.46Z";
var mdiCreditCardRemoveOutline = "M13 19C13 18.66 13.04 18.33 13.09 18H3V12H19V13C19.7 13 20.37 13.13 21 13.35V6C21 4.89 20.11 4 19 4H3C1.89 4 1 4.89 1 6V18C1 19.1 1.89 20 3 20H13.09C13.04 19.67 13 19.34 13 19M3 6H19V8H3V6M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.46L22.54 16.88Z";
var mdiCreditCardScan = "M18 6H6A2 2 0 0 0 4 8V16A2 2 0 0 0 6 18H18A2 2 0 0 0 20 16V8A2 2 0 0 0 18 6M18 12H6V9H18M2 4H6V2H2A2 2 0 0 0 0 4V8H2V4M22 2H18V4H22V8H24V4A2 2 0 0 0 22 2M2 16H0V20A2 2 0 0 0 2 22H6V20H2V16M22 20H18V22H22A2 2 0 0 0 24 20V16H22V20";
var mdiCreditCardScanOutline = "M2,4H6V2H2A2,2 0 0,0 0,4V8H2V4M22,2H18V4H22V8H24V4A2,2 0 0,0 22,2M2,16H0V20A2,2 0 0,0 2,22H6V20H2V16M22,20H18V22H22A2,2 0 0,0 24,20V16H22V20M4,8V16A2,2 0 0,0 6,18H18A2,2 0 0,0 20,16V8A2,2 0 0,0 18,6H6A2,2 0 0,0 4,8M6,16V12H18V16H6M18,8V10H6V8H18Z";
var mdiCreditCardSearch = "M11.82 11C9.4 13.5 9.4 17.5 11.82 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H20C21.11 4 22 4.89 22 6V12.06C21.74 11.65 21.45 11.26 21.1 10.9C20.76 10.57 20.39 10.27 20 10.03V8H4V11H11.82M23.39 21L22 22.39L18.88 19.32C18.19 19.75 17.37 20 16.5 20C14 20 12 18 12 15.5S14 11 16.5 11 21 13 21 15.5C21 16.38 20.75 17.21 20.31 17.9L23.39 21M19 15.5C19 14.12 17.88 13 16.5 13S14 14.12 14 15.5 15.12 18 16.5 18 19 16.88 19 15.5Z";
var mdiCreditCardSearchOutline = "M11.03 12C11.28 11.61 11.57 11.24 11.9 10.9C14.44 8.37 18.56 8.37 21.1 10.9C21.45 11.26 21.74 11.65 22 12.06V6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H11.82C11.24 19.4 10.8 18.72 10.5 18H4V12H11.03M4 6H20V8H4V6M20.31 17.9C20.75 17.21 21 16.38 21 15.5C21 13 19 11 16.5 11S12 13 12 15.5 14 20 16.5 20C17.37 20 18.19 19.75 18.88 19.32L22 22.39L23.39 21L20.31 17.9M16.5 18C15.12 18 14 16.88 14 15.5S15.12 13 16.5 13 19 14.12 19 15.5 17.88 18 16.5 18Z";
var mdiCreditCardSettings = "M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V6A2 2 0 0 0 20 4M20 11H4V8H20M7 22H9V24H7V22M11 22H13V24H11V22M15 22H17V24H15Z";
var mdiCreditCardSettingsOutline = "M20,8H4V6H20M20,18H4V12H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z";
var mdiCreditCardSync = "M13 17.5C13 18.39 13.18 19.23 13.5 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H20C21.11 4 22 4.89 22 6V11.5C21.23 11.18 20.39 11 19.5 11H20V8H4V11H19.5C15.91 11 13 13.91 13 17.5M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5Z";
var mdiCreditCardSyncOutline = "M4 18V12H16.05C17.05 11.37 18.23 11 19.5 11C20.39 11 21.23 11.18 22 11.5V6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.5C13.24 19.38 13.08 18.7 13.03 18H4M4 6H20V8H4V6M23 17.5C23 18.32 22.75 19.08 22.33 19.71L21.24 18.62C21.41 18.28 21.5 17.9 21.5 17.5C21.5 16.12 20.38 15 19 15V16.5L16.75 14.25L19 12V13.5C21.21 13.5 23 15.29 23 17.5M19 18.5L21.25 20.75L19 23V21.5C16.79 21.5 15 19.71 15 17.5C15 16.68 15.25 15.92 15.67 15.29L16.76 16.38C16.59 16.72 16.5 17.1 16.5 17.5C16.5 18.88 17.62 20 19 20V18.5Z";
var mdiCreditCardWireless = "M4.93 4.92L6.34 6.33C9.46 3.2 14.53 3.2 17.66 6.33L19.07 4.92C15.17 1 8.84 1 4.93 4.92M7.76 7.75L9.17 9.16C10.73 7.6 13.26 7.6 14.83 9.16L16.24 7.75C13.9 5.41 10.1 5.41 7.76 7.75M18 11H6C4.89 11 4 11.9 4 13V21C4 22.11 4.89 23 6 23H18C19.11 23 20 22.11 20 21V13C20 11.9 19.11 11 18 11M18 17H6V14H18V17Z";
var mdiCreditCardWirelessOff = "M12 2C9.85 2 7.7 2.69 5.9 4.08L7.32 5.5C10.45 3.24 14.84 3.5 17.66 6.33L19.07 4.92C17.12 2.96 14.56 2 12 2M3.28 4L2 5.27L7.73 11H6C4.89 11 4 11.9 4 13V21C4 22.11 4.89 23 6 23H18C18.5 23 18.92 22.82 19.27 22.54L19.73 23L21 21.72M12 6C10.87 6 9.75 6.31 8.77 6.94L10.24 8.41C11.73 7.68 13.58 7.92 14.83 9.16L16.24 7.75C15.07 6.58 13.54 6 12 6M12.82 11L15.82 14H18V16.18L20 18.18V13C20 11.9 19.11 11 18 11M6 14H10.73L13.73 17H6Z";
var mdiCreditCardWirelessOffOutline = "M12 2C9.85 2 7.7 2.69 5.9 4.08L7.32 5.5C10.45 3.24 14.84 3.5 17.66 6.33L19.07 4.92C17.12 2.96 14.56 2 12 2M3.28 4L2 5.27L7.73 11H6C4.89 11 4 11.9 4 13V21C4 22.11 4.89 23 6 23H18C18.47 23 18.92 22.84 19.27 22.54L19.73 23L21 21.72M12 6C10.87 6 9.75 6.31 8.77 6.94L10.24 8.41C11.73 7.68 13.58 7.92 14.83 9.16L16.24 7.75C15.07 6.58 13.54 6 12 6M12.82 11L14.82 13H18V15H16.82L20 18.18V13C20 11.9 19.11 11 18 11M6 13H9.73L11.73 15H6M6 17H13.73L17.73 21H6Z";
var mdiCreditCardWirelessOutline = "M18,11H6A2,2 0 0,0 4,13V21A2,2 0 0,0 6,23H18A2,2 0 0,0 20,21V13A2,2 0 0,0 18,11M18,21H6V17H18V21M18,15H6V13H18V15M4.93,4.92L6.34,6.33C9.46,3.2 14.53,3.2 17.66,6.33L19.07,4.92C15.17,1 8.84,1 4.93,4.92M7.76,7.75L9.17,9.16C10.73,7.6 13.26,7.6 14.83,9.16L16.24,7.75C13.9,5.41 10.1,5.41 7.76,7.75Z";
var mdiCricket = "M14.34,17.77L15.75,16.36L20,20.58L18.56,22L14.34,17.77M18.5,2A3.5,3.5 0 0,1 22,5.5A3.5,3.5 0 0,1 18.5,9A3.5,3.5 0 0,1 15,5.5A3.5,3.5 0 0,1 18.5,2M2.24,7.11L5.07,4.28C5.46,3.89 6.09,3.89 6.5,4.28L14.97,12.77C15.36,13.16 15.36,13.79 14.97,14.18L12.14,17C11.75,17.4 11.12,17.4 10.72,17L2.24,8.53C1.85,8.13 1.85,7.5 2.24,7.11Z";
var mdiCrop = "M7,17V1H5V5H1V7H5V17A2,2 0 0,0 7,19H17V23H19V19H23V17M17,15H19V7C19,5.89 18.1,5 17,5H9V7H17V15Z";
var mdiCropFree = "M19,3H15V5H19V9H21V5C21,3.89 20.1,3 19,3M19,19H15V21H19A2,2 0 0,0 21,19V15H19M5,15H3V19A2,2 0 0,0 5,21H9V19H5M3,5V9H5V5H9V3H5A2,2 0 0,0 3,5Z";
var mdiCropLandscape = "M19,17H5V7H19M19,5H5A2,2 0 0,0 3,7V17A2,2 0 0,0 5,19H19A2,2 0 0,0 21,17V7C21,5.89 20.1,5 19,5Z";
var mdiCropPortrait = "M17,19H7V5H17M17,3H7A2,2 0 0,0 5,5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V5C19,3.89 18.1,3 17,3Z";
var mdiCropRotate = "M7.47,21.5C4.2,19.93 1.86,16.76 1.5,13H0C0.5,19.16 5.66,24 11.95,24C12.18,24 12.39,24 12.61,23.97L8.8,20.15L7.47,21.5M12.05,0C11.82,0 11.61,0 11.39,0.04L15.2,3.85L16.53,2.5C19.8,4.07 22.14,7.24 22.5,11H24C23.5,4.84 18.34,0 12.05,0M16,14H18V8C18,6.89 17.1,6 16,6H10V8H16V14M8,16V4H6V6H4V8H6V16A2,2 0 0,0 8,18H16V20H18V18H20V16H8Z";
var mdiCropSquare = "M18,18H6V6H18M18,4H6A2,2 0 0,0 4,6V18A2,2 0 0,0 6,20H18A2,2 0 0,0 20,18V6C20,4.89 19.1,4 18,4Z";
var mdiCross = "M10.5,2H13.5V8H19V11H13.5V22H10.5V11H5V8H10.5V2Z";
var mdiCrossBolnisi = "M22,7L21.5,6.5C19.93,8 18.47,9.4 16.93,10.18C15.5,10.91 14.44,10.91 13,11C13.09,9.56 13.09,8.5 13.82,7.07C14.6,5.53 16,4.07 17.5,2.5L17,2C15.32,3.23 13.64,3.83 12,3.83C10.36,3.83 8.68,3.23 7,2L6.5,2.5C8,4.07 9.4,5.53 10.18,7.07C10.91,8.5 10.91,9.56 11,11C9.56,10.91 8.5,10.91 7.07,10.18C5.53,9.4 4.06,8 2.5,6.5L2,7C3.23,8.68 3.83,10.36 3.83,12C3.83,13.64 3.23,15.32 2,17L2.5,17.5C4.07,16 5.53,14.6 7.07,13.82C8.5,13.09 9.56,13.09 11,13C10.91,14.44 10.91,15.5 10.18,16.93C9.4,18.47 8,19.93 6.5,21.5L7,22C8.68,20.77 10.36,20.17 12,20.17C13.64,20.17 15.32,20.77 17,22L17.5,21.5C16,19.93 14.6,18.47 13.82,16.93C13.09,15.5 13.09,14.44 13,13C14.44,13.09 15.5,13.09 16.93,13.82C18.47,14.6 19.93,16 21.5,17.5L22,17C20.77,15.32 20.17,13.64 20.17,12C20.17,10.36 20.77,8.68 22,7Z";
var mdiCrossCeltic = "M17.8,8C17.26,5.89 15.61,4.24 13.5,3.7V2H10.5V3.7C8.39,4.24 6.74,5.89 6.2,8H4V11H6.2C6.74,13.11 8.39,14.76 10.5,15.3V22H13.5V15.3C15.61,14.76 17.26,13.11 17.8,11H19.97V8H17.8M12.04,9.53L14.5,11H15.76C15.35,12.03 14.53,12.84 13.5,13.26V12L12.06,9.56L12,9.5L11.94,9.56L10.5,12V13.26C9.47,12.84 8.66,12.03 8.24,11H9.5L11.96,9.53L12,9.5H11.96L9.5,8H8.24C8.65,6.97 9.47,6.16 10.5,5.74V7L11.94,9.44L12,9.5L12.06,9.44L13.5,7V5.74C14.53,6.16 15.35,6.97 15.76,8H14.5L12.04,9.5H12L12.04,9.53Z";
var mdiCrossOutline = "M15.5,6V1H8.5V6H3V13H8.5V23H15.5V13H21V6H15.5M19,11H13.5V21H10.5V11H5V8H10.5V3H13.5V8H19V11Z";
var mdiCrosshairs = "M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z";
var mdiCrosshairsGps = "M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z";
var mdiCrosshairsOff = "M20.94 11C20.5 6.83 17.17 3.5 13 3.06V1H11V3.06C9.87 3.18 8.81 3.5 7.84 4.03L9.34 5.53C10.16 5.19 11.06 5 12 5C15.87 5 19 8.13 19 12C19 12.94 18.81 13.84 18.5 14.65L20 16.15C20.5 15.19 20.82 14.13 20.95 13H23V11H20.94M3 4.27L5.04 6.31C3.97 7.62 3.25 9.23 3.06 11H1V13H3.06C3.5 17.17 6.83 20.5 11 20.94V23H13V20.94C14.77 20.74 16.38 20.03 17.69 18.96L19.73 21L21 19.73L4.27 3L3 4.27M16.27 17.54C15.09 18.45 13.61 19 12 19C8.13 19 5 15.87 5 12C5 10.39 5.55 8.91 6.46 7.73L16.27 17.54Z";
var mdiCrosshairsQuestion = "M3.05 13H1V11H3.05C3.5 6.83 6.83 3.5 11 3.05V1H13V3.05C17.17 3.5 20.5 6.83 20.95 11H23V13H20.95C20.5 17.17 17.17 20.5 13 20.95V23H11V20.95C6.83 20.5 3.5 17.17 3.05 13M12 5C8.13 5 5 8.13 5 12S8.13 19 12 19 19 15.87 19 12 15.87 5 12 5M11.13 17.25H12.88V15.5H11.13V17.25M12 6.75C10.07 6.75 8.5 8.32 8.5 10.25H10.25C10.25 9.28 11.03 8.5 12 8.5S13.75 9.28 13.75 10.25C13.75 12 11.13 11.78 11.13 14.63H12.88C12.88 12.66 15.5 12.44 15.5 10.25C15.5 8.32 13.93 6.75 12 6.75Z";
var mdiCrowd = "M3.69 9.12C3.5 8.93 3.29 8.84 3.04 8.84C2.63 8.84 2.32 9.03 2.12 9.42S1.97 10.18 2.29 10.53C3.47 11.59 4.22 12.34 4.54 12.78C4.95 13.34 5.15 14.16 5.15 15.22C5.15 16.53 5.65 17.5 6.65 18.17C7.21 18.61 7.82 18.94 8.5 19.16L8.5 15.27C8.5 14.33 8.17 13.55 7.54 12.92M16.46 12.97C15.84 13.59 15.5 14.36 15.5 15.27L15.5 19.2C16.46 18.86 17.26 18.33 17.92 17.63C18.57 16.93 18.9 16.16 18.9 15.22C18.9 14.09 19.09 13.28 19.47 12.78C19.56 12.62 19.73 12.42 20 12.17C20.23 11.92 20.47 11.68 20.71 11.46C20.94 11.25 21.17 11.03 21.39 10.81L21.72 10.53C21.91 10.34 22 10.12 22 9.87C22 9.59 21.91 9.34 21.72 9.14C21.53 8.94 21.3 8.84 21 8.84S20.5 8.93 20.31 9.12M12 20C12.69 20 13.36 19.91 14 19.72L14 16.15C14 15.56 13.82 15.1 13.41 14.66C13 14.22 12.53 14 12 14C11.47 14 11 14.2 10.62 14.61C10.22 15 10 15.46 10 16.06L10 19.72C10.64 19.91 11.31 20 12 20M9 8.5C9 9.33 8.33 10 7.5 10S6 9.33 6 8.5 6.67 7 7.5 7 9 7.67 9 8.5M18 8.5C18 9.33 17.33 10 16.5 10C15.67 10 15 9.33 15 8.5S15.67 7 16.5 7C17.33 7 18 7.67 18 8.5M13.5 5.5C13.5 6.33 12.83 7 12 7S10.5 6.33 10.5 5.5 11.17 4 12 4 13.5 4.67 13.5 5.5M13.5 11C13.5 11.83 12.83 12.5 12 12.5S10.5 11.83 10.5 11 11.17 9.5 12 9.5 13.5 10.17 13.5 11Z";
var mdiCrown = "M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5M19 19C19 19.6 18.6 20 18 20H6C5.4 20 5 19.6 5 19V18H19V19Z";
var mdiCrownCircle = "M12 2C6.47 2 2 6.5 2 12C2 17.5 6.5 22 12 22S22 17.5 22 12 17.5 2 12 2M16 15.44C16 15.78 15.78 16 15.44 16H8.56C8.22 16 8 15.78 8 15.44V15H16V15.44M16 14H8L7 8L10 10L12 7L14 10L17 8L16 14Z";
var mdiCrownCircleOutline = "M12 2C6.47 2 2 6.5 2 12C2 17.5 6.5 22 12 22S22 17.5 22 12 17.5 2 12 2M12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4S20 7.58 20 12C20 16.42 16.42 20 12 20M8 14L7 8L10 10L12 7L14 10L17 8L16 14H8M8.56 16C8.22 16 8 15.78 8 15.44V15H16V15.44C16 15.78 15.78 16 15.44 16H8.56Z";
var mdiCrownOutline = "M12 8L15 13.2L18 10.5L17.3 14H6.7L6 10.5L9 13.2L12 8M12 4L8.5 10L3 5L5 16H19L21 5L15.5 10L12 4M19 18H5V19C5 19.6 5.4 20 6 20H18C18.6 20 19 19.6 19 19V18Z";
var mdiCryengine = "M23.03,12.4M23.03,12.5V12.5C23,13 20.91,15.23 17.82,16.24C14.05,17.5 7.97,17.03 7.97,12.3C7.97,10.08 9.78,8.27 12,8.27C14.25,8.27 16.05,10.09 16.05,12.31C16.05,13.39 15.58,14.44 14.87,15.18C15.54,15.17 17.94,15 20.21,13.12C20.46,12.88 20.62,12.68 20.69,12.55C20.71,12.5 20.74,12.46 20.73,12.4C20.73,11.92 18.12,8.19 12.72,7.12C19.22,7.46 23,11.32 23.03,12.4V12.5H23.03M12,10C10.74,10 9.71,11.04 9.71,12.3C9.71,13.57 10.74,14.59 12,14.59C13.27,14.59 14.29,13.57 14.29,12.3C14.29,11.04 13.27,10 12,10M3.31,12.34C3.31,12.34 3.31,12.31 3.31,12.42V12.42C3.41,12.94 4.82,15.41 10.28,16.88C3.96,16.37 1.12,13.28 1.04,12.42H1.03C1.03,12.31 1.03,12.36 1.03,12.35C1.03,11.5 4.96,7.58 10.92,7.15C6.14,8.26 3.31,11.87 3.31,12.34V12.34Z";
var mdiCrystalBall = "M9.38,8.38L11.5,9.34L13.62,8.38L12.66,10.5L13.62,12.62L11.5,11.66L9.38,12.62L10.34,10.5L9.38,8.38M16.5,2.5L17.59,5.41L20.5,6.5L17.59,7.59L16.5,10.5L15.41,7.59L12.5,6.5L15.41,5.41L16.5,2.5M6,19H7V18A1,1 0 0,1 8,17H8.26C6,15.7 4.5,13.28 4.5,10.5A7.5,7.5 0 0,1 12,3C13.05,3 14.05,3.22 14.96,3.61L14.59,4.59L13.17,5.12C12.79,5.04 12.4,5 12,5A5.5,5.5 0 0,0 6.5,10.5A5.5,5.5 0 0,0 12,16C14.91,16 17.3,13.73 17.5,10.87L18.41,8.41L19.12,8.14C19.37,8.88 19.5,9.68 19.5,10.5C19.5,13.28 18,15.7 15.74,17H16A1,1 0 0,1 17,18V19H18A2,2 0 0,1 20,21V22H4V21A2,2 0 0,1 6,19Z";
var mdiCube = "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L6.04,7.5L12,10.85L17.96,7.5L12,4.15Z";
var mdiCubeOff = "M20.84 22.73L17.28 19.17L12.57 21.82C12.41 21.94 12.21 22 12 22S11.59 21.94 11.43 21.82L3.53 17.38C3.21 17.21 3 16.88 3 16.5V7.5C3 7.12 3.21 6.79 3.53 6.62L4.3 6.19L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M12 4.15L17.96 7.5L13.31 10.11L20.53 17.33C20.82 17.16 21 16.85 21 16.5V7.5C21 7.12 20.79 6.79 20.47 6.62L12.57 2.18C12.41 2.06 12.21 2 12 2S11.59 2.06 11.43 2.18L7.56 4.36L9 5.82L12 4.15Z";
var mdiCubeOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L4.3 6.19L3.53 6.62C3.21 6.79 3 7.12 3 7.5V16.5C3 16.88 3.21 17.21 3.53 17.38L11.43 21.82C11.59 21.94 11.79 22 12 22S12.41 21.94 12.57 21.82L17.28 19.17L20.84 22.73L22.11 21.46M5 15.91V9.21L10.29 12.18L11 12.89V19.29L5 15.91M13 19.29V14.89L15.82 17.7L13 19.29M9 5.82L7.56 4.36L11.43 2.18C11.59 2.06 11.79 2 12 2S12.41 2.06 12.57 2.18L20.47 6.62C20.79 6.79 21 7.12 21 7.5V16.5C21 16.85 20.82 17.16 20.53 17.33L19 15.8V9.21L14.78 11.58L13.31 10.11L17.96 7.5L12 4.15L9 5.82Z";
var mdiCubeOutline = "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L6.04,7.5L12,10.85L17.96,7.5L12,4.15M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V9.21L13,12.58V19.29L19,15.91Z";
var mdiCubeScan = "M17,22V20H20V17H22V20.5C22,20.89 21.84,21.24 21.54,21.54C21.24,21.84 20.89,22 20.5,22H17M7,22H3.5C3.11,22 2.76,21.84 2.46,21.54C2.16,21.24 2,20.89 2,20.5V17H4V20H7V22M17,2H20.5C20.89,2 21.24,2.16 21.54,2.46C21.84,2.76 22,3.11 22,3.5V7H20V4H17V2M7,2V4H4V7H2V3.5C2,3.11 2.16,2.76 2.46,2.46C2.76,2.16 3.11,2 3.5,2H7M13,17.25L17,14.95V10.36L13,12.66V17.25M12,10.92L16,8.63L12,6.28L8,8.63L12,10.92M7,14.95L11,17.25V12.66L7,10.36V14.95M18.23,7.59C18.73,7.91 19,8.34 19,8.91V15.23C19,15.8 18.73,16.23 18.23,16.55L12.75,19.73C12.25,20.05 11.75,20.05 11.25,19.73L5.77,16.55C5.27,16.23 5,15.8 5,15.23V8.91C5,8.34 5.27,7.91 5.77,7.59L11.25,4.41C11.5,4.28 11.75,4.22 12,4.22C12.25,4.22 12.5,4.28 12.75,4.41L18.23,7.59Z";
var mdiCubeSend = "M16,4L9,8.04V15.96L16,20L23,15.96V8.04M16,6.31L19.8,8.5L16,10.69L12.21,8.5M0,7V9H7V7M11,10.11L15,12.42V17.11L11,14.81M21,10.11V14.81L17,17.11V12.42M2,11V13H7V11M4,15V17H7V15";
var mdiCubeUnfolded = "M6,9V4H13V9H23V16H18V21H11V16H1V9H6M16,16H13V19H16V16M8,9H11V6H8V9M6,14V11H3V14H6M18,11V14H21V11H18M13,11V14H16V11H13M8,11V14H11V11H8Z";
var mdiCup = "M18.32,8H5.67L5.23,4H18.77M3,2L5,20.23C5.13,21.23 5.97,22 7,22H17C18,22 18.87,21.23 19,20.23L21,2H3Z";
var mdiCupOff = "M1,4.27L2.28,3L21,21.72L19.73,23L18.27,21.54C17.93,21.83 17.5,22 17,22H7C5.97,22 5.13,21.23 5,20.23L3.53,6.8L1,4.27M18.32,8L18.77,4H5.82L3.82,2H21L19.29,17.47L9.82,8H18.32Z";
var mdiCupOffOutline = "M3.83 2L5.83 4H18.78L17.5 15.66L19.3 17.5L21 2M2.27 3L1 4.27L3.53 6.8L5 20.23C5.13 21.23 5.97 22 7 22H17C17.47 22 17.91 21.82 18.26 21.54L19.73 23L21 21.73M5.78 9.06L16.73 20H7Z";
var mdiCupOutline = "M3 2L5 20.23C5.13 21.23 5.97 22 7 22H17C18 22 18.87 21.23 19 20.23L21 2H3M5.22 4H18.78L17 20H7L5.22 4Z";
var mdiCupWater = "M18.32,8H5.67L5.23,4H18.77M12,19A3,3 0 0,1 9,16C9,14 12,10.6 12,10.6C12,10.6 15,14 15,16A3,3 0 0,1 12,19M3,2L5,20.23C5.13,21.23 5.97,22 7,22H17C18,22 18.87,21.23 19,20.23L21,2H3Z";
var mdiCupboard = "M17 2H7C5.9 2 5 2.9 5 4V19C5 20.11 5.9 21 7 21V22H9V21H15V22H17V21C18.11 21 19 20.11 19 19V4C19 2.9 18.11 2 17 2M10 18H8V15H10V18M16 18H14V15H16V18M17 12H7V9H17V12M17 7H7V4H17V7Z";
var mdiCupboardOutline = "M7 2C5.9 2 5 2.9 5 4V19C5 20.11 5.9 21 7 21V22H9V21H15V22H17V21C18.11 21 19 20.11 19 19V4C19 2.9 18.11 2 17 2H7M7 4H17V7H7V4M7 9H17V12H7V9M7 14H11V19H7V14M13 14H17V19H13V14M8 15V18H10V15H8M14 15V18H16V15H14Z";
var mdiCupcake = "M12,1.5A2.5,2.5 0 0,1 14.5,4A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 9.5,4A2.5,2.5 0 0,1 12,1.5M15.87,5C18,5 20,7 20,9C22.7,9 22.7,13 20,13H4C1.3,13 1.3,9 4,9C4,7 6,5 8.13,5C8.57,6.73 10.14,8 12,8C13.86,8 15.43,6.73 15.87,5M5,15H8L9,22H7L5,15M10,15H14L13,22H11L10,15M16,15H19L17,22H15L16,15Z";
var mdiCurling = "M10,3V5C12.5,5 13.9,5.05 14.72,5.41C15.26,5.65 15.73,6.21 16.25,7H5V9H19.62L18.89,7.55C17.86,5.5 16.96,4.22 15.53,3.59C14.1,2.95 12.5,3 10,3M6,11C3.78,11 2,12.78 2,15V18C2,20.22 3.78,22 6,22H18C20.22,22 22,20.22 22,18V15C22,12.78 20.22,11 18,11H6Z";
var mdiCurrencyBdt = "M18.09,10.5V9H9.59V4.5A1.5,1.5 0 0,0 8.09,3A1.5,1.5 0 0,0 6.59,4.5A1.5,1.5 0 0,0 8.09,6V9H5.09V10.5H8.09V16.7C8.09,19.06 10,20.97 12.34,21C14.68,20.96 16.54,19.04 16.5,16.7C16.5,15.11 15.75,13.61 14.5,12.62C14.28,12.44 14.05,12.28 13.8,12.15C13.58,12.05 13.34,12 13.1,12C12.39,12 11.74,12.39 11.39,13C11.2,13.3 11.1,13.65 11.1,14C11.11,15.1 12,16 13.11,16C13.73,16 14.31,15.69 14.69,15.2C14.9,15.67 15,16.18 15,16.7C15.04,18.2 13.86,19.45 12.34,19.5C10.81,19.5 9.58,18.23 9.59,16.7V10.5H18.09Z";
var mdiCurrencyBrl = "M12,15H14C14,16.08 15.37,17 17,17C18.63,17 20,16.08 20,15C20,13.9 18.96,13.5 16.76,12.97C14.64,12.44 12,11.78 12,9C12,7.21 13.47,5.69 15.5,5.18V3H18.5V5.18C20.53,5.69 22,7.21 22,9H20C20,7.92 18.63,7 17,7C15.37,7 14,7.92 14,9C14,10.1 15.04,10.5 17.24,11.03C19.36,11.56 22,12.22 22,15C22,16.79 20.53,18.31 18.5,18.82V21H15.5V18.82C13.47,18.31 12,16.79 12,15M2,3H5.5A5.5,5.5 0 0,1 11,8.5C11,10.69 9.71,12.59 7.86,13.47L11.64,21H9.4L5.88,14H5.5L4,14V21H2V3M5.5,12A3.5,3.5 0 0,0 9,8.5A3.5,3.5 0 0,0 5.5,5H4V12H5.5Z";
var mdiCurrencyBtc = "M17.06 11.57C17.65 10.88 18 10 18 9C18 7.14 16.73 5.57 15 5.13V3H13V5H11V3H9V5H6V7H8V17H6V19H9V21H11V19H13V21H15V19C17.21 19 19 17.21 19 15C19 13.55 18.22 12.27 17.06 11.57M10 7H14C15.1 7 16 7.9 16 9S15.1 11 14 11H10V7M15 17H10V13H15C16.1 13 17 13.9 17 15S16.1 17 15 17Z";
var mdiCurrencyCny = "M13.28 12H18V14H13V21H11V14H6V12H10.72L5 3H7.37L12 10.29L16.63 3H19L13.28 12Z";
var mdiCurrencyEth = "M6,5H18V7H6M7,11H17V13H7M5.5,17H18.5V19H5.5";
var mdiCurrencyEur = "M15 18.5C12.5 18.5 10.32 17.08 9.24 15H15L16 13H8.58C8.53 12.67 8.5 12.34 8.5 12S8.53 11.33 8.58 11H15L16 9H9.24C10.32 6.92 12.5 5.5 15 5.5C16.61 5.5 18.09 6.09 19.23 7.07L21 5.3C19.41 3.87 17.3 3 15 3C11.08 3 7.76 5.5 6.5 9H3L2 11H6.06C6 11.33 6 11.66 6 12S6 12.67 6.06 13H3L2 15H6.5C7.76 18.5 11.08 21 15 21C17.31 21 19.41 20.13 21 18.7L19.22 16.93C18.09 17.91 16.62 18.5 15 18.5Z";
var mdiCurrencyEurOff = "M22.11 21.46L2.39 1.73L1.11 3L6.7 8.59C6.64 8.73 6.57 8.86 6.5 9H3L2 11H6.06C6 11.33 6 11.66 6 12S6 12.67 6.06 13H3L2 15H6.5C7.76 18.5 11.08 21 15 21C16.21 21 17.36 20.74 18.41 20.3L20.84 22.73L22.11 21.46M8.58 13C8.53 12.67 8.5 12.34 8.5 12S8.53 11.33 8.58 11H9.11L11.11 13H8.58M15 18.5C12.5 18.5 10.32 17.08 9.24 15H13.11L16.44 18.33C15.97 18.43 15.5 18.5 15 18.5M12.2 9H16L15 11H14.2L12.2 9M10.5 7.32L8.74 5.54C10.36 3.97 12.56 3 15 3C17.3 3 19.41 3.87 21 5.3L19.23 7.07C18.09 6.09 16.61 5.5 15 5.5C13.26 5.5 11.69 6.2 10.5 7.32Z";
var mdiCurrencyFra = "M18 5V3H7V16H5V18H7V21H9V18H13V16H9V13H17V11H9V5H18Z";
var mdiCurrencyGbp = "M14 21C15.93 21 17.62 19.83 18 18L16.25 17.12C16 18.21 15.33 19 14 19H9.1C9.93 18 10.6 16.66 10.6 15C10.6 14.65 10.57 14.31 10.5 14H14V12H9.82C9 10.42 8 9.6 8 8C8 6.07 9.57 4.5 11.5 4.5C13 4.5 14.29 5.45 14.78 6.78L16.63 6C15.83 3.95 13.84 2.5 11.5 2.5C8.46 2.5 6 4.96 6 8C6 9.78 6.79 10.9 7.5 12H6V14H8.47C8.55 14.31 8.6 14.64 8.6 15C8.6 17.7 6 19 6 19V21H14Z";
var mdiCurrencyIls = "M22,16A5,5 0 0,1 17,21H8V9H10V19H17A3,3 0 0,0 20,16V3H22V16M16,8V15H14V8A3,3 0 0,0 11,5H4V21H2V3H11A5,5 0 0,1 16,8Z";
var mdiCurrencyInr = "M8,3H18L17,5H13.74C14.22,5.58 14.58,6.26 14.79,7H18L17,9H15C14.75,11.57 12.74,13.63 10.2,13.96V14H9.5L15.5,21H13L7,14V12H9.5V12C11.26,12 12.72,10.7 12.96,9H7L8,7H12.66C12.1,5.82 10.9,5 9.5,5H7L8,3Z";
var mdiCurrencyJpy = "M13.92 11H18V13H13V15H18V17H13V21H11V17H6V15H11V13H6V11H10.08L5 3H7.37L12 10.29L16.63 3H19L13.92 11Z";
var mdiCurrencyKrw = "M2,3H4L5.33,9H9.33L10.67,3H13.33L14.67,9H18.67L20,3H22L20.67,9H22V11H20.22L19.78,13H22V15H19.33L18,21H15.33L14,15H10L8.67,21H6L4.67,15H2V13H4.22L3.78,11H2V9H3.33L2,3M13.11,11H10.89L10.44,13H13.56L13.11,11M7.33,18L8,15H6.67L7.33,18M8.89,11H5.78L6.22,13H8.44L8.89,11M16.67,18L17.33,15H16L16.67,18M18.22,11H15.11L15.56,13H17.78L18.22,11M12,6L11.33,9H12.67L12,6Z";
var mdiCurrencyKzt = "M5,3H19V5H5V3M5,6H19V8H13V21H11V8H5V6Z";
var mdiCurrencyMnt = "M13 5V8.62L17 7.17V9.29L13 10.74V12.5L17 11.07V13.2L13 14.65V21H11V15.38L7 16.84V14.71L11 13.24V11.47L7 12.92V10.8L11 9.35V5H5V3H19V5H13Z";
var mdiCurrencyNgn = "M4,9H6V3H8L11.42,9H16V3H18V9H20V11H18V13H20V15H18V21H16L12.57,15H8V21H6V15H4V13H6V11H4V9M8,9H9.13L8,7.03V9M8,11V13H11.42L10.28,11H8M16,17V15H14.85L16,17M12.56,11L13.71,13H16V11H12.56Z";
var mdiCurrencyPhp = "M5,2V6H3V8H5V10H3V12H5V22H7V16H13C15.7,16 18.16,14.44 19.32,12H22V10H19.92C20.03,9.34 20.03,8.66 19.92,8H22V6H19.32C18.16,3.56 15.7,2 13,2M7,4H13C14.57,4 16.06,4.74 17,6H7V4M13,14H7V12H17C16.06,13.26 14.57,14 13,14M18,9C18,9.34 17.96,9.67 17.9,10H7V8H17.9C17.96,8.33 18,8.66 18,9Z";
var mdiCurrencyRial = "M11,17H13V19H11V17M14,17H16V19H14V17M9,4H11V15A4,4 0 0,1 7,19H5A3,3 0 0,1 2,16V12H4V16A1,1 0 0,0 5,17H7C8.11,17 9,16.11 9,15V4M12,4H14V13H17V8H19V13C19,14.11 18.11,15 17,15H14C12.89,15 12,14.11 12,13V4M20,10H22V17A3,3 0 0,1 19,20H17V18H19A1,1 0 0,0 20,17V10Z";
var mdiCurrencyRub = "M13.5 3H7V12H5V14H7V16H5V18H7V21H9V18H13V16H9V14H13.5C16.54 14 19 11.54 19 8.5S16.54 3 13.5 3M13.5 12H9V5H13.5C15.43 5 17 6.57 17 8.5S15.43 12 13.5 12Z";
var mdiCurrencyRupee = "M13.66 7C13.1 5.82 11.9 5 10.5 5H6V3H18V5H14.74C15.22 5.58 15.58 6.26 15.79 7H18V9H16C15.73 11.8 13.37 14 10.5 14H9.77L16.5 21H13.73L7 14V12H10.5C12.26 12 13.72 10.7 13.96 9H6V7H13.66Z";
var mdiCurrencySign = "M4.41 3L3 4.41L5.69 7.1C4.63 8.46 4 10.15 4 12C4 13.85 4.63 15.55 5.69 16.9L3 19.59L4.41 21L7.1 18.31C8.46 19.37 10.15 20 12 20C13.85 20 15.55 19.37 16.9 18.31L19.59 21L21 19.59L18.31 16.9C19.37 15.54 20 13.85 20 12C20 10.15 19.37 8.45 18.31 7.1L21 4.41L19.59 3L16.9 5.69C15.54 4.63 13.85 4 12 4C10.15 4 8.45 4.63 7.1 5.69L4.41 3M12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6Z";
var mdiCurrencyThb = "M16.1 11.6C16.7 10.9 17 10 17 9C17 7.1 15.7 5.6 14 5.1L13 5V3H11V5H7V19H11V21H13V19H14C16.2 19 18 17.2 18 15C18 13.5 17.2 12.3 16.1 11.6M15 9C15 10.1 14.1 11 13 11V7C14.1 7 15 7.9 15 9M9 7H11V11H9V7M9 17V13H11V17H9M14 17H13V13H14C15.1 13 16 13.9 16 15S15.1 17 14 17Z";
var mdiCurrencyTry = "M9 8.76V3H11V7.5L15 5V7.36L11 9.87L11 12.22L15 9.72V12.08L11 14.59V19C13.76 19 16 16.76 16 14H18C18 17.87 14.87 21 11 21H9V15.84L6 17.72V15.36L9 13.5V11.12L6 13V10.64L9 8.76Z";
var mdiCurrencyTwd = "M3,11H21V13H15V19H21V21H15A2,2 0 0,1 13,19V13H10.35L5.73,21L4,20L8.04,13H3V11M5,3H19V5H5V3Z";
var mdiCurrencyUah = "M14.59 11H18V9H16.32C16.74 8.34 17 7.68 17 7C17 4.37 14.5 3 12 3C9.65 3 7.53 5.06 7.29 5.29L8.71 6.71C9.19 6.23 10.71 5 12 5C13.04 5 15 5.42 15 7C15 7.5 14.5 8.24 13.76 9H6V11H11.63C11.21 11.36 9.75 12.67 9.41 13H6V15H7.68C7.26 15.66 7 16.32 7 17C7 19.63 9.5 21 12 21C14.35 21 16.47 18.94 16.71 18.71L15.29 17.29C14.82 17.77 13.29 19 12 19C10.96 19 9 18.58 9 17C9 16.5 9.5 15.76 10.24 15H18V13H12.38L14.59 11Z";
var mdiCurrencyUsd = "M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z";
var mdiCurrencyUsdOff = "M3,4.27L4.28,3L21,19.72L19.73,21L16.06,17.33C15.44,18 14.54,18.55 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15H9C9,16.08 10.37,17 12,17C13.13,17 14.14,16.56 14.65,15.92L11.68,12.95C9.58,12.42 7,11.75 7,9C7,8.77 7,8.55 7.07,8.34L3,4.27M10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C11.63,7 11.28,7.05 10.95,7.13L9.4,5.58L10.5,5.18Z";
var mdiCurrentAc = "M12.43 11C12.28 10.84 10 7 7 7S2.32 10.18 2 11V13H11.57C11.72 13.16 14 17 17 17S21.68 13.82 22 13V11H12.43M7 9C8.17 9 9.18 9.85 10 11H4.31C4.78 10.17 5.54 9 7 9M17 15C15.83 15 14.82 14.15 14 13H19.69C19.22 13.83 18.46 15 17 15Z";
var mdiCurrentDc = "M2,9V11H22V9H2M2,13V15H7V13H2M9,13V15H15V13H9M17,13V15H22V13H17Z";
var mdiCursorDefault = "M13.64,21.97C13.14,22.21 12.54,22 12.31,21.5L10.13,16.76L7.62,18.78C7.45,18.92 7.24,19 7,19A1,1 0 0,1 6,18V3A1,1 0 0,1 7,2C7.24,2 7.47,2.09 7.64,2.23L7.65,2.22L19.14,11.86C19.57,12.22 19.62,12.85 19.27,13.27C19.12,13.45 18.91,13.57 18.7,13.61L15.54,14.23L17.74,18.96C18,19.46 17.76,20.05 17.26,20.28L13.64,21.97Z";
var mdiCursorDefaultClick = "M10.76,8.69A0.76,0.76 0 0,0 10,9.45V20.9C10,21.32 10.34,21.66 10.76,21.66C10.95,21.66 11.11,21.6 11.24,21.5L13.15,19.95L14.81,23.57C14.94,23.84 15.21,24 15.5,24C15.61,24 15.72,24 15.83,23.92L18.59,22.64C18.97,22.46 19.15,22 18.95,21.63L17.28,18L19.69,17.55C19.85,17.5 20,17.43 20.12,17.29C20.39,16.97 20.35,16.5 20,16.21L11.26,8.86L11.25,8.87C11.12,8.76 10.95,8.69 10.76,8.69M15,10V8H20V10H15M13.83,4.76L16.66,1.93L18.07,3.34L15.24,6.17L13.83,4.76M10,0H12V5H10V0M3.93,14.66L6.76,11.83L8.17,13.24L5.34,16.07L3.93,14.66M3.93,3.34L5.34,1.93L8.17,4.76L6.76,6.17L3.93,3.34M7,10H2V8H7V10";
var mdiCursorDefaultClickOutline = "M11.5,11L17.88,16.37L17,16.55L16.36,16.67C15.73,16.8 15.37,17.5 15.65,18.07L15.92,18.65L17.28,21.59L15.86,22.25L14.5,19.32L14.24,18.74C13.97,18.15 13.22,17.97 12.72,18.38L12.21,18.78L11.5,19.35V11M10.76,8.69A0.76,0.76 0 0,0 10,9.45V20.9C10,21.32 10.34,21.66 10.76,21.66C10.95,21.66 11.11,21.6 11.24,21.5L13.15,19.95L14.81,23.57C14.94,23.84 15.21,24 15.5,24C15.61,24 15.72,24 15.83,23.92L18.59,22.64C18.97,22.46 19.15,22 18.95,21.63L17.28,18L19.69,17.55C19.85,17.5 20,17.43 20.12,17.29C20.39,16.97 20.35,16.5 20,16.21L11.26,8.86L11.25,8.87C11.12,8.76 10.95,8.69 10.76,8.69M15,10V8H20V10H15M13.83,4.76L16.66,1.93L18.07,3.34L15.24,6.17L13.83,4.76M10,0H12V5H10V0M3.93,14.66L6.76,11.83L8.17,13.24L5.34,16.07L3.93,14.66M3.93,3.34L5.34,1.93L8.17,4.76L6.76,6.17L3.93,3.34M7,10H2V8H7V10";
var mdiCursorDefaultGesture = "M15.59 8C15.26 8 15 8.27 15 8.6V17.57C15 17.9 15.26 18.17 15.59 18.17C15.74 18.17 15.86 18.12 15.96 18.04L17.45 16.83L18.74 19.66C18.84 19.88 19.05 20 19.27 20C19.36 20 19.44 20 19.53 19.94L21.67 18.93C21.97 18.79 22.11 18.43 21.95 18.14L20.66 15.3L22.53 14.94C22.65 14.91 22.77 14.85 22.86 14.74C23.07 14.5 23.04 14.12 22.77 13.89L16 8.13C15.88 8.05 15.74 8 15.59 8M12.5 6.73C12.72 6.66 13.17 7.19 13.59 7.76L15 6.71C14.87 6.5 14.69 6.25 14.47 5.96C14.31 5.75 13.59 4.93 12.66 4.8C12.04 4.72 10.81 5.06 10.6 6.61C10.47 7.58 10.76 8.19 11.21 9.08C11.46 9.6 12.04 10.96 12.18 11.78C12.33 12.59 12.06 13.16 11.74 13.12C11.44 13.08 11.2 12.65 11.03 12.41C10.89 12.22 10 10.82 9.67 10.23C9.22 9.5 8.04 7.96 6.44 7.74C4.35 7.46 3.44 9.2 3.18 10.36L1 10.06V11.88L2.93 12.15C2.75 15.6 4.5 16.82 5.67 17C6.92 17.15 8.08 16.28 8.24 15.06C8.41 13.84 7.56 11.5 4.96 10.69C5.1 10.15 5.21 9.43 6.36 9.59C7.26 9.71 8.21 11.26 8.93 12.44C9.58 13.53 10.1 14.39 10.83 14.72C11.45 15 12.16 14.97 12.73 14.65C13.42 14.26 13.86 13.55 14 12.63C14.22 10.9 12.7 8.17 12.57 7.84C12.4 7.46 12.12 6.82 12.5 6.73M6.5 14.78C6.43 15.11 6.1 15.25 5.88 15.22C5.38 15.16 4.66 14.5 4.71 12.53C6.17 13.13 6.53 14.35 6.5 14.78Z";
var mdiCursorDefaultGestureOutline = "M16.5 10.54L20.37 13.83L18.5 14.18L19.29 15.92L20.22 17.96L19.72 18.19L18.81 16.2L18 14.43L16.5 15.66V10.54M15.59 8C15.26 8 15 8.27 15 8.6V17.57C15 17.9 15.26 18.17 15.59 18.17C15.74 18.17 15.86 18.12 15.96 18.04L17.45 16.83L18.74 19.66C18.84 19.88 19.05 20 19.27 20C19.36 20 19.44 20 19.53 19.94L21.67 18.93C21.97 18.79 22.11 18.43 21.95 18.14L20.66 15.3L22.53 14.94C22.65 14.91 22.77 14.85 22.86 14.74C23.07 14.5 23.04 14.12 22.77 13.89L16 8.13C15.88 8.05 15.74 8 15.59 8M12.5 6.73C12.72 6.66 13.17 7.19 13.59 7.76L15 6.71C14.87 6.5 14.69 6.25 14.47 5.96C14.31 5.75 13.59 4.93 12.66 4.8C12.04 4.72 10.81 5.06 10.6 6.61C10.47 7.58 10.76 8.19 11.21 9.08C11.46 9.6 12.04 10.96 12.18 11.78C12.33 12.59 12.06 13.16 11.74 13.12C11.44 13.08 11.2 12.65 11.03 12.41C10.89 12.22 10 10.82 9.67 10.23C9.22 9.5 8.04 7.96 6.44 7.74C4.35 7.46 3.44 9.2 3.18 10.36L1 10.06V11.88L2.93 12.15C2.75 15.6 4.5 16.82 5.67 17C6.92 17.15 8.08 16.28 8.24 15.06C8.41 13.84 7.56 11.5 4.96 10.69C5.1 10.15 5.21 9.43 6.36 9.59C7.26 9.71 8.21 11.26 8.93 12.44C9.58 13.53 10.1 14.39 10.83 14.72C11.45 15 12.16 14.97 12.73 14.65C13.42 14.26 13.86 13.55 14 12.63C14.22 10.9 12.7 8.17 12.57 7.84C12.4 7.46 12.12 6.82 12.5 6.73M6.5 14.78C6.43 15.11 6.1 15.25 5.88 15.22C5.38 15.16 4.66 14.5 4.71 12.53C6.17 13.13 6.53 14.35 6.5 14.78Z";
var mdiCursorDefaultOutline = "M10.07,14.27C10.57,14.03 11.16,14.25 11.4,14.75L13.7,19.74L15.5,18.89L13.19,13.91C12.95,13.41 13.17,12.81 13.67,12.58L13.95,12.5L16.25,12.05L8,5.12V15.9L9.82,14.43L10.07,14.27M13.64,21.97C13.14,22.21 12.54,22 12.31,21.5L10.13,16.76L7.62,18.78C7.45,18.92 7.24,19 7,19A1,1 0 0,1 6,18V3A1,1 0 0,1 7,2C7.24,2 7.47,2.09 7.64,2.23L7.65,2.22L19.14,11.86C19.57,12.22 19.62,12.85 19.27,13.27C19.12,13.45 18.91,13.57 18.7,13.61L15.54,14.23L17.74,18.96C18,19.46 17.76,20.05 17.26,20.28L13.64,21.97Z";
var mdiCursorMove = "M13,6V11H18V7.75L22.25,12L18,16.25V13H13V18H16.25L12,22.25L7.75,18H11V13H6V16.25L1.75,12L6,7.75V11H11V6H7.75L12,1.75L16.25,6H13Z";
var mdiCursorPointer = "M13.75,10.19L14.38,10.32L18.55,12.4C19.25,12.63 19.71,13.32 19.65,14.06V14.19L19.65,14.32L18.75,20.44C18.69,20.87 18.5,21.27 18.15,21.55C17.84,21.85 17.43,22 17,22H10.12C9.63,22 9.18,21.82 8.85,21.47L2.86,15.5L3.76,14.5C4,14.25 4.38,14.11 4.74,14.13H5.03L9,15V4.5A2,2 0 0,1 11,2.5A2,2 0 0,1 13,4.5V10.19H13.75Z";
var mdiCursorText = "M13,19A1,1 0 0,0 14,20H16V22H13.5C12.95,22 12,21.55 12,21C12,21.55 11.05,22 10.5,22H8V20H10A1,1 0 0,0 11,19V5A1,1 0 0,0 10,4H8V2H10.5C11.05,2 12,2.45 12,3C12,2.45 12.95,2 13.5,2H16V4H14A1,1 0 0,0 13,5V19Z";
var mdiCurtains = "M23 3H1V1H23V3M2 22H6C6 19 4 17 4 17C10 13 11 4 11 4H2V22M22 4H13C13 4 14 13 20 17C20 17 18 19 18 22H22V4Z";
var mdiCurtainsClosed = "M23 3H1V1H23V3M2 22H11V4H2V22M22 4H13V22H22V4Z";
var mdiCylinder = "M12 2C9.89 2 3 2.29 3 6V18C3 21.71 9.89 22 12 22C14.11 22 21 21.71 21 18V6C21 2.29 14.11 2 12 2M12 10C13.38 10 16.8 9.87 19 8.75V15.25C16.8 14.13 13.38 14 12 14S7.2 14.13 5 15.25V8.75C7.2 9.87 10.62 10 12 10M12 4C15.87 4 19 4.89 19 6C19 7.11 15.87 8 12 8C8.13 8 5 7.11 5 6C5 4.89 8.13 4 12 4M12 20C8.13 20 5 19.11 5 18C5 16.9 8.13 16 12 16C15.87 16 19 16.9 19 18C19 19.11 15.87 20 12 20Z";
var mdiCylinderOff = "M7.64 4.44L6.03 2.83C8.15 2.1 10.82 2 12 2C14.11 2 21 2.29 21 6V17.8L18.06 14.86C18.39 14.97 18.7 15.1 19 15.25V8.75C17.28 9.63 14.82 9.89 13.17 9.97L11.18 8C11.45 8 11.72 8 12 8C15.87 8 19 7.11 19 6S15.87 4 12 4C10.35 4 8.84 4.17 7.64 4.44M22.11 21.46L20.84 22.73L18.91 20.8C16.7 21.87 13.36 22 12 22C9.89 22 3 21.71 3 18V6C3 5.66 3.08 5.36 3.18 5.07L1.11 3L2.39 1.73L22.11 21.46M5 15.25C7.2 14.13 10.62 14 12 14L12.11 14L7.73 9.62C6.76 9.43 5.8 9.15 5 8.75V15.25M17.39 19.28L14.21 16.1C13.5 16.04 12.78 16 12 16C8.13 16 5 16.9 5 18S8.13 20 12 20C14.17 20 16.1 19.72 17.39 19.28Z";
var mdiDanceBallroom = "M14 3.5C14 4.33 13.33 5 12.5 5S11 4.33 11 3.5 11.67 2 12.5 2 14 2.67 14 3.5M8.5 5C7.67 5 7 5.67 7 6.5S7.67 8 8.5 8 10 7.33 10 6.5 9.33 5 8.5 5M14 12L13.22 9.75H16.18L18.34 8.67C18.71 8.5 18.86 8.04 18.67 7.67C18.5 7.3 18.04 7.14 17.67 7.33L16.85 7.74L16.36 6.9C16.07 6.25 15.36 5.88 14.66 6.04L12.19 6.57C11.5 6.72 11 7.35 11 8.07V8.77L8.57 10.39H8.58C8.5 10.46 8.39 10.55 8.33 10.67L7.44 12.44L5.66 13.33C5.29 13.5 5.14 13.97 5.33 14.34C5.46 14.6 5.73 14.75 6 14.75C6.11 14.75 6.23 14.73 6.34 14.67L8.56 13.56L9.6 11.5L11 13C10 16 3 20 3 20S7 22 12 22 21 20 21 20 16 16 14 12M16.85 11.09L16.53 11.25H15.33L15.39 11.41C15.91 12.44 16.67 13.5 17.5 14.44L16.97 11.03L16.85 11.09Z";
var mdiDancePole = "M12 1V2L11.23 1.36L7.76 5.5L11 7.5V5.16L10.78 5L12 3.56V23H14V13.24L15.93 11.31C18.5 11.71 21.13 10.36 22.66 8.83L21.24 7.41C20.1 8.56 17.7 9.61 16 9.26L14 7.24V1M17 4A2 2 0 0 0 15 6A2 2 0 0 0 17 8A2 2 0 0 0 19 6A2 2 0 0 0 17 4M11 7.76L7.1 11.66C5.25 13.5 4.31 14.85 3.06 18.16L4.94 18.86C5.94 16.2 6.66 15.14 7.87 13.84L9.22 15.19L4.27 20.14L5.69 21.56L11 16.24Z";
var mdiDataMatrix = "M2 2V22H22V20H20V18H22V16H20V14H22V12H18V10H16V12H14V10H12V8H8V12H12V16H10V18H12V20H10V18H8V16H6V14H4V12H6V6H4V2H2M6 6H8V2H6V6M8 16H10V14H8V16M18 10H22V8H18V10M18 8V4H16V6H14V8H18M16 4V2H14V4H16M18 4H20V2H18V4M20 4V6H22V4H20M10 2V6H12V2H10M14 14H16V16H18V20H14V14M4 18H6V20H4V18Z";
var mdiDataMatrixEdit = "M20 12.1C19.9 12.1 19.7 12.2 19.6 12.3L18.6 13.3L20.7 15.4L21.7 14.4C21.9 14.2 21.9 13.8 21.7 13.6L20.4 12.3C20.3 12.2 20.2 12.1 20 12.1M18.1 13.9L12 19.9V22H14.1L20.2 15.9L18.1 13.9M8 6H6V2H8V6M10 16H8V14H10V16M12 6H10V2H12V6M16 2V4H14V2H16M20 4H18V2H20V4M10 20V18H8V16H6V14H4V12H6V6H4V2H2V22H10V20M6 20H4V18H6V20M22 10H18V8H22V10M20 6V4H22V6H20M18 4V8H14V6H16V4H18M10 18V16H12V12H8V8H12V10H14V12H16V10H18V11.1L15.1 14H14V15.1L11.1 18H10Z";
var mdiDataMatrixMinus = "M16 2V4H14V2H16M12 2H10V6H12V2M10 14H8V16H10V14M16 4V6H14V8H18V4H16M8 2H6V6H8V2M20 2H18V4H20V2M13.8 22H2V2H4V6H6V12H4V14H6V16H8V18H10V20H12V18H10V16H12V12H8V8H12V10H14V12H16V10H18V12H22V13.8C21.1 13.3 20.1 13 19 13C17.8 13 16.6 13.4 15.7 14H14V15.7C13.4 16.6 13 17.8 13 19C13 20.1 13.3 21.1 13.8 22M6 18H4V20H6V18M22 8H18V10H22V8M22 6V4H20V6H22M15 18V20H23V18H15Z";
var mdiDataMatrixPlus = "M16 2V4H14V2H16M12 2H10V6H12V2M10 14H8V16H10V14M16 4V6H14V8H18V4H16M8 2H6V6H8V2M20 2H18V4H20V2M13.8 22H2V2H4V6H6V12H4V14H6V16H8V18H10V20H12V18H10V16H12V12H8V8H12V10H14V12H16V10H18V12H22V13.8C21.1 13.3 20.1 13 19 13C17.8 13 16.6 13.4 15.7 14H14V15.7C13.4 16.6 13 17.8 13 19C13 20.1 13.3 21.1 13.8 22M6 18H4V20H6V18M22 8H18V10H22V8M22 6V4H20V6H22M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiDataMatrixRemove = "M16 2V4H14V2H16M12 2H10V6H12V2M10 14H8V16H10V14M16 4V6H14V8H18V4H16M8 2H6V6H8V2M20 2H18V4H20V2M13.8 22H2V2H4V6H6V12H4V14H6V16H8V18H10V20H12V18H10V16H12V12H8V8H12V10H14V12H16V10H18V12H22V13.8C21.1 13.3 20.1 13 19 13C17.8 13 16.6 13.4 15.7 14H14V15.7C13.4 16.6 13 17.8 13 19C13 20.1 13.3 21.1 13.8 22M6 18H4V20H6V18M22 8H18V10H22V8M22 6V4H20V6H22M21.1 15.5L19 17.6L16.9 15.5L15.5 16.9L17.6 19L15.5 21.1L16.9 22.5L19 20.4L21.1 22.5L22.5 21.1L20.4 19L22.5 16.9L21.1 15.5Z";
var mdiDataMatrixScan = "M2 2H6V0H2C.9 0 0 .9 0 2V6H2V2M22 0H18V2H22V6H24V2C24 .9 23.1 0 22 0M2 18H0V22C0 23.1 .9 24 2 24H6V22H2V18M22 22H18V24H22C23.1 24 24 23.1 24 22V18H22V22M8 6V4H10V6H8M10 14V12H12V14H10M16 4H18V6H16V4M18 6H20V8H18V6M18 14H20V16H18V14M20 12H16V18H20V20H4V4H6V6H8V10H6V12H8V14H10V16H12V18H14V16H12V14H14V10H10V6H12V4H14V8H16V10H20V12M8 18V16H6V18H8Z";
var mdiDatabase = "M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z";
var mdiDatabaseAlert = "M18 7C18 9.21 14.42 11 10 11S2 9.21 2 7 5.58 3 10 3 18 4.79 18 7M10 18C5.58 18 2 16.21 2 14V17C2 19.21 5.58 21 10 21S18 19.21 18 17V14C18 16.21 14.42 18 10 18M10 13C5.58 13 2 11.21 2 9V12C2 14.21 5.58 16 10 16S18 14.21 18 12V9C18 11.21 14.42 13 10 13M20 17H22V15H20V17M20 7V13H22V7H20Z";
var mdiDatabaseAlertOutline = "M10 3C5.58 3 2 4.79 2 7V17C2 19.21 5.59 21 10 21S18 19.21 18 17V7C18 4.79 14.42 3 10 3M16 17C16 17.5 13.87 19 10 19S4 17.5 4 17V14.77C5.61 15.55 7.72 16 10 16S14.39 15.55 16 14.77V17M16 12.45C14.7 13.4 12.42 14 10 14S5.3 13.4 4 12.45V9.64C5.47 10.47 7.61 11 10 11S14.53 10.47 16 9.64V12.45M10 9C6.13 9 4 7.5 4 7S6.13 5 10 5 16 6.5 16 7 13.87 9 10 9M22 7V13H20V7H22M20 15H22V17H20V15Z";
var mdiDatabaseArrowDown = "M19 13C16.83 13 14.93 14.16 13.88 15.89C13.28 15.96 12.65 16 12 16C7.58 16 4 14.21 4 12V9C4 11.21 7.58 13 12 13S20 11.21 20 9V12C20 12.36 19.9 12.71 19.72 13.05C19.5 13 19.24 13 19 13M12 11C16.42 11 20 9.21 20 7S16.42 3 12 3 4 4.79 4 7 7.58 11 12 11M13.1 17.96C12.74 18 12.37 18 12 18C7.58 18 4 16.21 4 14V17C4 19.21 7.58 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19C13 18.64 13.04 18.3 13.1 17.96M20 20V16H18V20H16L19 23L22 20H20Z";
var mdiDatabaseArrowDownOutline = "M20 13.09V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19L13 18.95C12.68 19 12.35 19 12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.65 16 13.27 15.96 13.88 15.89C14.93 14.16 16.83 13 19 13C19.34 13 19.67 13.04 20 13.09M18 12.45C16.7 13.4 14.42 14 12 14S7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.45M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5 18 6.5 18 7 15.87 9 12 9M22 20L19 23L16 20H18V16H20V20H22Z";
var mdiDatabaseArrowLeft = "M4 7C4 4.79 7.58 3 12 3S20 4.79 20 7 16.42 11 12 11 4 9.21 4 7M19.72 13.05C19.9 12.71 20 12.36 20 12V9C20 11.21 16.42 13 12 13S4 11.21 4 9V12C4 14.21 7.58 16 12 16C12.65 16 13.28 15.96 13.88 15.89C14.93 14.16 16.83 13 19 13C19.24 13 19.5 13 19.72 13.05M13.1 17.96C12.74 18 12.37 18 12 18C7.58 18 4 16.21 4 14V17C4 19.21 7.58 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19C13 18.64 13.04 18.3 13.1 17.96M18 18V16L15 19L18 22V20H22V18H18Z";
var mdiDatabaseArrowLeftOutline = "M20 13.09V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19L13 18.95C12.68 19 12.35 19 12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.65 16 13.27 15.96 13.88 15.89C14.93 14.16 16.83 13 19 13C19.34 13 19.67 13.04 20 13.09M18 12.45C16.7 13.4 14.42 14 12 14S7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.45M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5 18 6.5 18 7 15.87 9 12 9M22 18V20H18V22L15 19L18 16V18H22Z";
var mdiDatabaseArrowRight = "M4 7C4 4.79 7.58 3 12 3S20 4.79 20 7 16.42 11 12 11 4 9.21 4 7M19.72 13.05C19.9 12.71 20 12.36 20 12V9C20 11.21 16.42 13 12 13S4 11.21 4 9V12C4 14.21 7.58 16 12 16C12.65 16 13.28 15.96 13.88 15.89C14.93 14.16 16.83 13 19 13C19.24 13 19.5 13 19.72 13.05M13.1 17.96C12.74 18 12.37 18 12 18C7.58 18 4 16.21 4 14V17C4 19.21 7.58 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19C13 18.64 13.04 18.3 13.1 17.96M23 19L20 16V18H16V20H20V22L23 19Z";
var mdiDatabaseArrowRightOutline = "M20 13.09V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19L13 18.95C12.68 19 12.35 19 12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.65 16 13.27 15.96 13.88 15.89C14.93 14.16 16.83 13 19 13C19.34 13 19.67 13.04 20 13.09M18 12.45C16.7 13.4 14.42 14 12 14S7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.45M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5 18 6.5 18 7 15.87 9 12 9M20 22V20H16V18H20V16L23 19L20 22Z";
var mdiDatabaseArrowUp = "M19 13C16.83 13 14.93 14.16 13.88 15.89C13.28 15.96 12.65 16 12 16C7.58 16 4 14.21 4 12V9C4 11.21 7.58 13 12 13S20 11.21 20 9V12C20 12.36 19.9 12.71 19.72 13.05C19.5 13 19.24 13 19 13M12 11C16.42 11 20 9.21 20 7S16.42 3 12 3 4 4.79 4 7 7.58 11 12 11M13.1 17.96C12.74 18 12.37 18 12 18C7.58 18 4 16.21 4 14V17C4 19.21 7.58 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19C13 18.64 13.04 18.3 13.1 17.96M19 15L16 18H18V22H20V18H22L19 15Z";
var mdiDatabaseArrowUpOutline = "M20 13.09V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19L13 18.95C12.68 19 12.35 19 12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.65 16 13.27 15.96 13.88 15.89C14.93 14.16 16.83 13 19 13C19.34 13 19.67 13.04 20 13.09M18 12.45C16.7 13.4 14.42 14 12 14S7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.45M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5 18 6.5 18 7 15.87 9 12 9M22 18H20V22H18V18H16L19 15L22 18Z";
var mdiDatabaseCheck = "M12 3C16.42 3 20 4.79 20 7S16.42 11 12 11 4 9.21 4 7 7.58 3 12 3M4 9C4 11.21 7.58 13 12 13S20 11.21 20 9V12.08L19 12C16.41 12 14.2 13.64 13.36 15.94L12 16C7.58 16 4 14.21 4 12V9M4 14C4 16.21 7.58 18 12 18H13C13 19.05 13.27 20.04 13.75 20.9L12 21C7.58 21 4 19.21 4 17V14M18 21.08L15.25 18.08L16.41 16.92L18 18.5L21.59 14.92L22.75 16.33L18 21.08";
var mdiDatabaseCheckOutline = "M20 13.09V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19L13 18.95C12.68 19 12.35 19 12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.65 16 13.27 15.96 13.88 15.89C14.93 14.16 16.83 13 19 13C19.34 13 19.67 13.04 20 13.09M18 12.45C16.7 13.4 14.42 14 12 14S7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.45M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5 18 6.5 18 7 15.87 9 12 9M22.5 17.25L17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25Z";
var mdiDatabaseClock = "M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25M23 16C23 19.87 19.87 23 16 23C13.61 23 11.5 21.8 10.25 20C6.18 19.79 3 18.08 3 16V13C3 14.88 5.58 16.44 9.06 16.88C9.03 16.59 9 16.3 9 16C9 15.62 9.04 15.25 9.1 14.88C5.6 14.45 3 12.88 3 11V8C3 10.09 6.2 11.8 10.27 12C10.87 11.14 11.64 10.44 12.53 9.93C12.04 9.97 11.5 10 11 10C6.58 10 3 8.21 3 6S6.58 2 11 2 19 3.79 19 6C19 7.2 17.93 8.28 16.25 9C17 9.04 17.75 9.19 18.44 9.45C18.79 9 19 8.5 19 8V9.68C21.36 10.81 23 13.21 23 16M21 16C21 13.24 18.76 11 16 11S11 13.24 11 16 13.24 21 16 21 21 18.76 21 16Z";
var mdiDatabaseClockOutline = "M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25M23 16C23 19.87 19.87 23 16 23C13.61 23 11.5 21.8 10.25 20C6.19 19.79 3 18.08 3 16V6C3 3.79 6.58 2 11 2S19 3.79 19 6V9.68C21.36 10.81 23 13.21 23 16M17 9.08V8.64C16.77 8.77 16.5 8.9 16.24 9C16.5 9 16.75 9.04 17 9.08M5 6C5 6.5 7.13 8 11 8S17 6.5 17 6 14.87 4 11 4 5 5.5 5 6M5 11.45C6.07 12.23 7.8 12.76 9.72 12.93C10.33 11.67 11.32 10.62 12.54 9.92C12.04 9.97 11.53 10 11 10C8.61 10 6.47 9.47 5 8.64V11.45M9.26 17.87C9.1 17.27 9 16.65 9 16C9 15.61 9.04 15.23 9.1 14.86C7.56 14.69 6.15 14.33 5 13.77V16C5 16.42 6.5 17.5 9.26 17.87M21 16C21 13.24 18.76 11 16 11S11 13.24 11 16 13.24 21 16 21 21 18.76 21 16Z";
var mdiDatabaseCog = "M4 7C4 4.79 7.58 3 12 3S20 4.79 20 7 16.42 11 12 11 4 9.21 4 7M12.08 18L12 18C7.58 18 4 16.21 4 14V17C4 19.21 7.58 21 12 21C12.1 21 12.2 21 12.29 21C12.11 20.36 12 19.69 12 19C12 18.66 12.03 18.33 12.08 18M20 12.08C20 12.05 20 12.03 20 12V9C20 11.21 16.42 13 12 13S4 11.21 4 9V12C4 14.21 7.58 16 12 16C12.23 16 12.46 16 12.69 16C13.82 13.63 16.22 12 19 12C19.34 12 19.67 12.03 20 12.08M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiDatabaseCogOutline = "M12 14C9.58 14 7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.08C18.33 12.03 18.66 12 19 12C19.34 12 19.67 12.03 20 12.08V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.1 21 12.2 21 12.29 21C12.11 20.36 12 19.69 12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.24 16 12.47 16 12.7 15.97C13.1 15.14 13.65 14.41 14.32 13.81C13.58 13.93 12.8 14 12 14M12 5C15.87 5 18 6.5 18 7S15.87 9 12 9 6 7.5 6 7 8.13 5 12 5M22.7 19.6V18.6L23.8 17.8C23.9 17.7 24 17.6 23.9 17.5L22.9 15.8C22.9 15.7 22.7 15.7 22.6 15.7L21.4 16.2C21.1 16 20.8 15.8 20.5 15.7L20.3 14.4C20.3 14.3 20.2 14.2 20.1 14.2H18.1C17.9 14.2 17.8 14.3 17.8 14.4L17.6 15.7C17.3 15.9 17.1 16 16.8 16.2L15.6 15.7C15.5 15.7 15.4 15.7 15.3 15.8L14.3 17.5C14.3 17.6 14.3 17.7 14.4 17.8L15.5 18.6V19.6L14.4 20.4C14.3 20.5 14.2 20.6 14.3 20.7L15.3 22.4C15.4 22.5 15.5 22.5 15.6 22.5L16.8 22C17 22.2 17.3 22.4 17.6 22.5L17.8 23.8C17.9 23.9 18 24 18.1 24H20.1C20.2 24 20.3 23.9 20.3 23.8L20.5 22.5C20.8 22.3 21 22.2 21.3 22L22.5 22.4C22.6 22.4 22.7 22.4 22.8 22.3L23.8 20.6C23.9 20.5 23.9 20.4 23.8 20.4L22.7 19.6M19 20.5C18.2 20.5 17.5 19.8 17.5 19S18.2 17.5 19 17.5 20.5 18.2 20.5 19 19.8 20.5 19 20.5Z";
var mdiDatabaseEdit = "M4,14V17C4,19 7.05,20.72 11,21V18.11L11.13,18C7.12,17.76 4,16.06 4,14M12,13C7.58,13 4,11.21 4,9V12C4,14.21 7.58,16 12,16C12.39,16 12.77,16 13.16,16L17,12.12C15.4,12.72 13.71,13 12,13M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M21,11.13C20.85,11.13 20.71,11.19 20.61,11.3L19.61,12.3L21.66,14.3L22.66,13.3C22.87,13.1 22.88,12.76 22.66,12.53L21.42,11.3C21.32,11.19 21.18,11.13 21.04,11.13M19.04,12.88L13,18.94V21H15.06L21.12,14.93L19.04,12.88Z";
var mdiDatabaseEditOutline = "M12 16C12.8 16 13.57 15.93 14.31 15.82L17.22 12.91C15.89 13.59 14 14 12 14C9.58 14 7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.13L19.39 10.74C19.57 10.56 19.78 10.42 20 10.3V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.04 7.06 20.72 11 20.97V19.13L11.17 18.96C7.84 18.76 6 17.46 6 17V14.77C7.61 15.55 9.72 16 12 16M12 5C15.87 5 18 6.5 18 7S15.87 9 12 9 6 7.5 6 7 8.13 5 12 5M19.13 13.83L21.17 15.87L15.04 22H13V19.96L19.13 13.83M22.85 14.19L21.87 15.17L19.83 13.13L20.81 12.15C21 11.95 21.33 11.95 21.53 12.15L22.85 13.47C23.05 13.67 23.05 14 22.85 14.19Z";
var mdiDatabaseExport = "M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C12.5,11 13,10.97 13.5,10.92V9.5H16.39L15.39,8.5L18.9,5C17.5,3.8 14.94,3 12,3M18.92,7.08L17.5,8.5L20,11H15V13H20L17.5,15.5L18.92,16.92L23.84,12M4,9V12C4,14.21 7.58,16 12,16C13.17,16 14.26,15.85 15.25,15.63L16.38,14.5H13.5V12.92C13,12.97 12.5,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C14.94,21 17.5,20.2 18.9,19L17,17.1C15.61,17.66 13.9,18 12,18C7.58,18 4,16.21 4,14Z";
var mdiDatabaseExportOutline = "M17.86 18L18.9 19C17.5 20.2 14.94 21 12 21C7.59 21 4 19.21 4 17V7C4 4.79 7.58 3 12 3C14.95 3 17.5 3.8 18.9 5L17.86 6L17.5 6.4C16.65 5.77 14.78 5 12 5C8.13 5 6 6.5 6 7S8.13 9 12 9C13.37 9 14.5 8.81 15.42 8.54L16.38 9.5H13.5V10.92C13 10.97 12.5 11 12 11C9.61 11 7.47 10.47 6 9.64V12.45C7.3 13.4 9.58 14 12 14C12.5 14 13 13.97 13.5 13.92V14.5H16.38L15.38 15.5L15.5 15.61C14.41 15.86 13.24 16 12 16C9.72 16 7.61 15.55 6 14.77V17C6 17.5 8.13 19 12 19C14.78 19 16.65 18.23 17.5 17.61L17.86 18M18.92 7.08L17.5 8.5L20 11H15V13H20L17.5 15.5L18.92 16.92L23.84 12L18.92 7.08Z";
var mdiDatabaseEye = "M4 12V9C4 11.2 7.6 13 12 13S20 11.2 20 9V12C20 12.5 19.8 12.9 19.5 13.4C18.7 13.1 17.9 13 17 13C14.5 13 12.1 14.1 10.6 15.9C6.8 15.6 4 14 4 12M12 11C16.4 11 20 9.2 20 7S16.4 3 12 3 4 4.8 4 7 7.6 11 12 11M9.1 19.7L8.8 19L9.1 18.3C9.2 18.1 9.3 18 9.3 17.8C6.2 17.2 4 15.8 4 14V17C4 18.8 6.4 20.3 9.7 20.8C9.5 20.5 9.3 20.1 9.1 19.7M17 18C16.4 18 16 18.4 16 19S16.4 20 17 20 18 19.6 18 19 17.6 18 17 18M23 19C22.1 21.3 19.7 23 17 23S11.9 21.3 11 19C11.9 16.7 14.3 15 17 15S22.1 16.7 23 19M19.5 19C19.5 17.6 18.4 16.5 17 16.5S14.5 17.6 14.5 19 15.6 21.5 17 21.5 19.5 20.4 19.5 19Z";
var mdiDatabaseEyeOff = "M14.1 10.9L7.1 3.9C8.4 3.3 10.1 3 12 3C16.4 3 20 4.8 20 7C20 8.9 17.5 10.4 14.1 10.9M16.2 13H17C17.9 13 18.7 13.1 19.5 13.4C19.8 13 20 12.5 20 12V9C20 10.5 18.3 11.9 15.7 12.5L16.2 13M18.4 15.2L22.8 19.6C22.9 19.4 23 19.2 23.1 19.1C22.2 17.1 20.5 15.6 18.4 15.2M22.1 21.5L20.8 22.8L20.2 22.2C19.2 22.7 18.1 23.1 17 23.1C14.3 23.1 11.9 21.4 11 19.1C11.6 17.7 12.6 16.6 13.9 15.9L12.4 14.4C11.7 14.8 11.1 15.4 10.5 16C6.8 15.6 4 14 4 12V9C4 11.1 7.1 12.7 11.1 13L8.8 10.7C6 10 4 8.6 4 7C4 6.7 4.1 6.4 4.2 6.1L1.1 3L2.4 1.7L22.1 21.5M18.8 20.7L17.7 19.6C17.6 19.9 17.3 20 17 20C16.4 20 16 19.6 16 19C16 18.7 16.1 18.4 16.4 18.2L15.3 17.1C14.8 17.6 14.5 18.2 14.5 18.9C14.5 20.3 15.6 21.4 17 21.4C17.7 21.5 18.4 21.2 18.8 20.7M8.8 19L9.1 18.3C9.2 18.1 9.3 18 9.3 17.8C6.2 17.2 4 15.8 4 14V17C4 18.8 6.4 20.3 9.7 20.8C9.5 20.5 9.3 20.1 9.2 19.7L8.8 19Z";
var mdiDatabaseEyeOffOutline = "M23 19C22.9 19.2 22.8 19.4 22.7 19.5L18.3 15.1C20.5 15.6 22.2 17.1 23 19M12 5C15.9 5 18 6.5 18 7C18 7.5 15.9 8.9 12.2 9L14.1 10.9C15.6 10.7 17 10.3 18 9.7V12.5C17.7 12.7 17.4 12.9 17 13.1C18 13.1 19 13.3 20 13.7V7C20 4.8 16.4 3 12 3C10.1 3 8.4 3.3 7.1 3.9L8.7 5.5C9.5 5.2 10.7 5 12 5M22.1 21.5L20.8 22.8L20.2 22.2C19.2 22.7 18.1 23.1 17 23.1C14.3 23.1 11.9 21.4 11 19.1C11.6 17.7 12.6 16.6 13.9 15.9L12.4 14.4C11.7 14.8 11.1 15.4 10.5 16C8.8 15.9 7.2 15.5 5.9 14.8V17C5.9 17.3 7 18.2 8.9 18.6L8.8 19L9.1 19.7C9.3 20.1 9.4 20.4 9.6 20.8C6.4 20.3 4 18.8 4 17V7C4 6.7 4.1 6.4 4.2 6.1L1.1 3L2.4 1.7L22.1 21.5M12.1 14L8.7 10.6C7.6 10.4 6.7 10 5.9 9.6V12.4C7.2 13.4 9.5 13.9 11.9 13.9C12 14 12.1 14 12.1 14M18.8 20.7L17.7 19.6C17.6 19.9 17.3 20 17 20C16.4 20 16 19.6 16 19C16 18.7 16.1 18.4 16.4 18.2L15.3 17.1C14.8 17.6 14.5 18.2 14.5 18.9C14.5 20.3 15.6 21.4 17 21.4C17.7 21.5 18.4 21.2 18.8 20.7Z";
var mdiDatabaseEyeOutline = "M9.1 19.7L8.8 19L9 18.6C7.1 18.1 6 17.3 6 17V14.8C7.3 15.4 8.8 15.8 10.6 16C11.3 15.2 12.2 14.5 13.1 14H12C9.6 14 7.3 13.4 6 12.5V9.6C7.5 10.4 9.6 11 12 11S16.5 10.5 18 9.6V12.4C17.7 12.6 17.4 12.8 17 13C18 13 19 13.2 20 13.6V7C20 4.8 16.4 3 12 3S4 4.8 4 7V17C4 18.8 6.4 20.3 9.7 20.8C9.5 20.5 9.3 20.1 9.1 19.7M12 5C15.9 5 18 6.5 18 7S15.9 9 12 9 6 7.5 6 7 8.1 5 12 5M17 18C17.6 18 18 18.4 18 19S17.6 20 17 20 16 19.6 16 19 16.4 18 17 18M17 15C14.3 15 11.9 16.7 11 19C11.9 21.3 14.3 23 17 23S22.1 21.3 23 19C22.1 16.7 19.7 15 17 15M17 21.5C15.6 21.5 14.5 20.4 14.5 19S15.6 16.5 17 16.5 19.5 17.6 19.5 19 18.4 21.5 17 21.5Z";
var mdiDatabaseImport = "M12,3C8.59,3 5.69,4.07 4.54,5.57L9.79,10.82C10.5,10.93 11.22,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M3.92,7.08L2.5,8.5L5,11H0V13H5L2.5,15.5L3.92,16.92L8.84,12M20,9C20,11.21 16.42,13 12,13C11.34,13 10.7,12.95 10.09,12.87L7.62,15.34C8.88,15.75 10.38,16 12,16C16.42,16 20,14.21 20,12M20,14C20,16.21 16.42,18 12,18C9.72,18 7.67,17.5 6.21,16.75L4.53,18.43C5.68,19.93 8.59,21 12,21C16.42,21 20,19.21 20,17";
var mdiDatabaseImportOutline = "M8.84 12L3.92 16.92L2.5 15.5L5 13H0V11H5L2.5 8.5L3.92 7.08L8.84 12M12 3C8.59 3 5.68 4.07 4.53 5.57L5 6L6.03 7.07C6 7.05 6 7 6 7C6 6.5 8.13 5 12 5S18 6.5 18 7 15.87 9 12 9C9.38 9 7.58 8.31 6.68 7.72L9.8 10.84C10.5 10.94 11.24 11 12 11C14.39 11 16.53 10.47 18 9.64V12.45C16.7 13.4 14.42 14 12 14C11.04 14 10.1 13.9 9.24 13.73L7.59 15.37C8.91 15.77 10.41 16 12 16C14.28 16 16.39 15.55 18 14.77V17C18 17.5 15.87 19 12 19S6 17.5 6 17V16.96L5 18L4.54 18.43C5.69 19.93 8.6 21 12 21C16.41 21 20 19.21 20 17V7C20 4.79 16.42 3 12 3Z";
var mdiDatabaseLock = "M11,3C15.42,3 19,4.79 19,7C19,9.21 15.42,11 11,11C6.58,11 3,9.21 3,7C3,4.79 6.58,3 11,3M19,12.03C17.11,12.24 15.57,13.62 15.13,15.43C13.92,15.79 12.5,16 11,16C6.58,16 3,14.21 3,12V9C3,11.21 6.58,13 11,13C15.42,13 19,11.21 19,9V12.03M14,17.71V20.71C13.07,20.9 12.06,21 11,21C6.58,21 3,19.21 3,17V14C3,16.21 6.58,18 11,18C12.06,18 13.07,17.9 14,17.71M19.5,14A2.5,2.5 0 0,1 22,16.5V17A1,1 0 0,1 23,18V22A1,1 0 0,1 22,23H17A1,1 0 0,1 16,22V18A1,1 0 0,1 17,17V16.5A2.5,2.5 0 0,1 19.5,14M19.5,15A1.5,1.5 0 0,0 18,16.5V17H21V16.5A1.5,1.5 0 0,0 19.5,15Z";
var mdiDatabaseLockOutline = "M6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V11.05C18.17 11.03 18.33 11 18.5 11C19.03 11 19.53 11.1 20 11.26V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.34 21 12.67 21 13 20.97V18.95C12.68 19 12.35 19 12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.41 16 12.81 15.97 13.21 15.94C13.4 15.46 13.68 15.03 14.07 14.7C14.13 14.39 14.23 14.09 14.34 13.8C13.6 13.93 12.81 14 12 14C9.58 14 7.3 13.4 6 12.45M12 5C15.87 5 18 6.5 18 7S15.87 9 12 9 6 7.5 6 7 8.13 5 12 5M21 16V15.5C21 14.12 19.88 13 18.5 13S16 14.12 16 15.5V16C15.45 16 15 16.45 15 17V21C15 21.55 15.45 22 16 22H21C21.55 22 22 21.55 22 21V17C22 16.45 21.55 16 21 16M20 16H17V15.5C17 14.67 17.67 14 18.5 14S20 14.67 20 15.5V16Z";
var mdiDatabaseMarker = "M18.5 12C16.6 12 15 13.6 15 15.5C15 18.1 18.5 22 18.5 22S22 18.1 22 15.5C22 13.6 20.4 12 18.5 12M18.5 16.8C17.8 16.8 17.3 16.2 17.3 15.6C17.3 14.9 17.9 14.4 18.5 14.4S19.7 15 19.7 15.6C19.8 16.2 19.2 16.8 18.5 16.8M4 12V9C4 11.21 7.58 13 12 13C12.57 13 13.13 12.97 13.67 12.91C13.25 13.69 13 14.57 13 15.5C13 15.65 13 15.81 13.03 15.96C12.69 16 12.35 16 12 16C7.58 16 4 14.21 4 12M4 7C4 4.79 7.58 3 12 3S20 4.79 20 7 16.42 11 12 11 4 9.21 4 7M15 20.71C14.07 20.9 13.06 21 12 21C7.58 21 4 19.21 4 17V14C4 16.21 7.58 18 12 18C12.5 18 13.03 17.97 13.5 17.93C13.9 18.91 14.44 19.87 15 20.71Z";
var mdiDatabaseMarkerOutline = "M12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.35 16 12.69 15.97 13.03 15.95C13 15.8 13 15.65 13 15.5C13 14.96 13.09 14.44 13.24 13.94C12.83 14 12.42 14 12 14C9.58 14 7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V10.03C18.17 10 18.33 10 18.5 10C19 10 19.5 10.08 20 10.22V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C13.06 21 14.07 20.89 15 20.71C14.62 20.14 14.25 19.5 13.93 18.85C13.34 18.94 12.71 19 12 19M12 5C15.87 5 18 6.5 18 7S15.87 9 12 9 6 7.5 6 7 8.13 5 12 5M18.5 12C16.6 12 15 13.6 15 15.5C15 18.1 18.5 22 18.5 22S22 18.1 22 15.5C22 13.6 20.4 12 18.5 12M18.5 16.8C17.8 16.8 17.3 16.2 17.3 15.6C17.3 14.9 17.9 14.4 18.5 14.4S19.7 15 19.7 15.6C19.8 16.2 19.2 16.8 18.5 16.8Z";
var mdiDatabaseMinus = "M23 17V19H15V17M12 3C16.42 3 20 4.79 20 7S16.42 11 12 11 4 9.21 4 7 7.58 3 12 3M4 9C4 11.21 7.58 13 12 13S20 11.21 20 9V12.08L19 12C16.41 12 14.2 13.64 13.36 15.94L12 16C7.58 16 4 14.21 4 12V9M4 14C4 16.21 7.58 18 12 18H13C13 19.05 13.27 20.04 13.75 20.9L12 21C7.58 21 4 19.21 4 17V14Z";
var mdiDatabaseMinusOutline = "M20 13.09V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19L13 18.95C12.68 19 12.35 19 12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.65 16 13.27 15.96 13.88 15.89C14.93 14.16 16.83 13 19 13C19.34 13 19.67 13.04 20 13.09M18 12.45C16.7 13.4 14.42 14 12 14S7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.45M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5 18 6.5 18 7 15.87 9 12 9M23 18V20H15V18H23Z";
var mdiDatabaseOff = "M19.07 15.87C19.66 15.31 20 14.68 20 14V16.8L19.07 15.87M20 9C20 10.54 18.27 11.86 15.73 12.53L17.89 14.69C19.19 14 20 13.04 20 12V9M20 7C20 4.79 16.42 3 12 3C10.13 3 8.42 3.33 7.06 3.86L14.06 10.86C17.5 10.41 20 8.85 20 7M2.39 1.73L1.11 3L4.21 6.1C4.08 6.39 4 6.69 4 7C4 8.63 5.96 10.04 8.77 10.66L11.08 12.97C7.1 12.74 4 11.06 4 9V12C4 14.21 7.58 16 12 16C12.69 16 13.35 15.95 14 15.87L15.66 17.55C14.57 17.84 13.32 18 12 18C7.58 18 4 16.21 4 14V17C4 19.21 7.58 21 12 21C14.31 21 16.38 20.5 17.84 19.73L20.84 22.73L22.11 21.46L2.39 1.73Z";
var mdiDatabaseOffOutline = "M2.39 1.73L1.11 3L4.21 6.1C4.08 6.39 4 6.69 4 7V17C4 19.21 7.59 21 12 21C14.3 21 16.38 20.5 17.84 19.73L20.84 22.73L22.11 21.46L2.39 1.73M6 9.64C6.76 10.07 7.7 10.42 8.76 10.65L12.11 14C12.07 14 12.04 14 12 14C9.58 14 7.3 13.4 6 12.45V9.64M12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.68 16 13.34 15.95 14 15.87L16.34 18.23C15.33 18.65 13.87 19 12 19M8.64 5.44L7.06 3.86C8.42 3.33 10.13 3 12 3C16.42 3 20 4.79 20 7V16.8L18 14.8V14.77L18 14.78L16.45 13.25C17.05 13.03 17.58 12.76 18 12.45V9.64C16.97 10.22 15.61 10.65 14.06 10.86L12.19 9C15.94 8.94 18 7.5 18 7C18 6.5 15.87 5 12 5C10.66 5 9.54 5.18 8.64 5.44Z";
var mdiDatabaseOutline = "M12 3C7.58 3 4 4.79 4 7V17C4 19.21 7.59 21 12 21S20 19.21 20 17V7C20 4.79 16.42 3 12 3M18 17C18 17.5 15.87 19 12 19S6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16S16.39 15.55 18 14.77V17M18 12.45C16.7 13.4 14.42 14 12 14C9.58 14 7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11C14.39 11 16.53 10.47 18 9.64V12.45M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5C15.87 5 18 6.5 18 7S15.87 9 12 9Z";
var mdiDatabasePlus = "M18,14H20V17H23V19H20V22H18V19H15V17H18V14M12,3C16.42,3 20,4.79 20,7C20,9.21 16.42,11 12,11C7.58,11 4,9.21 4,7C4,4.79 7.58,3 12,3M4,9C4,11.21 7.58,13 12,13C16.42,13 20,11.21 20,9V9L20,12.08L19,12C16.41,12 14.2,13.64 13.36,15.94L12,16C7.58,16 4,14.21 4,12V9M4,14C4,16.21 7.58,18 12,18H13C13,19.05 13.27,20.04 13.75,20.9L12,21C7.58,21 4,19.21 4,17V14Z";
var mdiDatabasePlusOutline = "M20 13.09V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19L13 18.95C12.68 19 12.35 19 12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.65 16 13.27 15.96 13.88 15.89C14.93 14.16 16.83 13 19 13C19.34 13 19.67 13.04 20 13.09M18 12.45C16.7 13.4 14.42 14 12 14S7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.45M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5 18 6.5 18 7 15.87 9 12 9M23 18V20H20V23H18V20H15V18H18V15H20V18H23Z";
var mdiDatabaseRefresh = "M12 3C16.42 3 20 4.79 20 7C20 9.21 16.42 11 12 11C7.58 11 4 9.21 4 7C4 4.79 7.58 3 12 3M4 9C4 11.21 7.58 13 12 13C13.11 13 14.18 12.89 15.14 12.68C14.19 13.54 13.5 14.67 13.18 15.96L12 16C7.58 16 4 14.21 4 12V9M20 9V11L19.5 11L18.9 11.03C19.6 10.43 20 9.74 20 9M4 14C4 16.21 7.58 18 12 18L13 17.97C13.09 19.03 13.42 20 13.95 20.88L12 21C7.58 21 4 19.21 4 17V14M19 13.5C20.11 13.5 21.11 13.95 21.83 14.67L23 13.5V17.5H19L20.77 15.73C20.32 15.28 19.69 15 19 15C17.62 15 16.5 16.12 16.5 17.5C16.5 18.88 17.62 20 19 20C19.82 20 20.54 19.61 21 19H22.71C22.12 20.47 20.68 21.5 19 21.5C16.79 21.5 15 19.71 15 17.5C15 15.29 16.79 13.5 19 13.5Z";
var mdiDatabaseRefreshOutline = "M6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.03C18.17 12 18.33 12 18.5 12C19 12 19.5 12.07 20 12.18V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.17 21 12.33 21 12.5 21C12.24 20.37 12.09 19.7 12.03 19L12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.17 16 12.34 16 12.5 16C12.85 15.18 13.34 14.46 13.95 13.86C13.32 13.95 12.67 14 12 14C9.58 14 7.3 13.4 6 12.45M12 5C15.87 5 18 6.5 18 7S15.87 9 12 9 6 7.5 6 7 8.13 5 12 5M18 18.5L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5S16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5S15.79 14.5 18 14.5C19.11 14.5 20.11 14.95 20.83 15.67L22 14.5V18.5H18Z";
var mdiDatabaseRemove = "M15.46,15.88L16.88,14.46L19,16.59L21.12,14.47L22.53,15.88L20.41,18L22.54,20.12L21.12,21.54L19,19.41L16.88,21.53L15.47,20.12L17.59,18L15.46,15.88M12,3C16.42,3 20,4.79 20,7C20,9.21 16.42,11 12,11C7.58,11 4,9.21 4,7C4,4.79 7.58,3 12,3M4,9C4,11.21 7.58,13 12,13C16.42,13 20,11.21 20,9V12.08L19,12C16.41,12 14.2,13.64 13.36,15.94L12,16C7.58,16 4,14.21 4,12V9M4,14C4,16.21 7.58,18 12,18H13C13,19.05 13.27,20.04 13.75,20.9L12,21C7.58,21 4,19.21 4,17V14Z";
var mdiDatabaseRemoveOutline = "M20 13.09V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19L13 18.95C12.68 19 12.35 19 12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.65 16 13.27 15.96 13.88 15.89C14.93 14.16 16.83 13 19 13C19.34 13 19.67 13.04 20 13.09M18 12.45C16.7 13.4 14.42 14 12 14S7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.45M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5 18 6.5 18 7 15.87 9 12 9M20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19";
var mdiDatabaseSearch = "M18.68,12.32C16.92,10.56 14.07,10.57 12.32,12.33C10.56,14.09 10.56,16.94 12.32,18.69C13.81,20.17 16.11,20.43 17.89,19.32L21,22.39L22.39,21L19.3,17.89C20.43,16.12 20.17,13.8 18.68,12.32M17.27,17.27C16.29,18.25 14.71,18.24 13.73,17.27C12.76,16.29 12.76,14.71 13.74,13.73C14.71,12.76 16.29,12.76 17.27,13.73C18.24,14.71 18.24,16.29 17.27,17.27M10.9,20.1C10.25,19.44 9.74,18.65 9.42,17.78C6.27,17.25 4,15.76 4,14V17C4,19.21 7.58,21 12,21V21C11.6,20.74 11.23,20.44 10.9,20.1M4,9V12C4,13.68 6.07,15.12 9,15.7C9,15.63 9,15.57 9,15.5C9,14.57 9.2,13.65 9.58,12.81C6.34,12.3 4,10.79 4,9M12,3C7.58,3 4,4.79 4,7C4,9 7,10.68 10.85,11H10.9C12.1,9.74 13.76,9 15.5,9C16.41,9 17.31,9.19 18.14,9.56C19.17,9.09 19.87,8.12 20,7C20,4.79 16.42,3 12,3Z";
var mdiDatabaseSearchOutline = "M11 18.95C7.77 18.72 6 17.45 6 17V14.77C7.13 15.32 8.5 15.69 10 15.87C10 15.21 10.04 14.54 10.21 13.89C8.5 13.67 6.97 13.16 6 12.45V9.64C7.43 10.45 9.5 10.97 11.82 11C11.85 10.97 11.87 10.93 11.9 10.9C14.1 8.71 17.5 8.41 20 10.03V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.34 21 12.68 21 13 20.97C12.62 20.72 12.24 20.44 11.9 20.1C11.55 19.74 11.25 19.36 11 18.95M12 5C15.87 5 18 6.5 18 7S15.87 9 12 9 6 7.5 6 7 8.13 5 12 5M20.31 17.9C20.75 17.21 21 16.38 21 15.5C21 13 19 11 16.5 11S12 13 12 15.5 14 20 16.5 20C17.37 20 18.19 19.75 18.88 19.32L22 22.39L23.39 21L20.31 17.9M16.5 18C15.12 18 14 16.88 14 15.5S15.12 13 16.5 13 19 14.12 19 15.5 17.88 18 16.5 18Z";
var mdiDatabaseSettings = "M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22M12,3C16.42,3 20,4.79 20,7C20,9.21 16.42,11 12,11C7.58,11 4,9.21 4,7C4,4.79 7.58,3 12,3M4,9C4,11.21 7.58,13 12,13C16.42,13 20,11.21 20,9V12C20,14.21 16.42,16 12,16C7.58,16 4,14.21 4,12V9M4,14C4,16.21 7.58,18 12,18C16.42,18 20,16.21 20,14V17C20,18.19 18.95,19.27 17.29,20H6.71C5.05,19.27 4,18.19 4,17V14Z";
var mdiDatabaseSettingsOutline = "M12 3C7.58 3 4 4.79 4 7V17C4 18.2 5.06 19.27 6.73 20H17.27C18.94 19.27 20 18.2 20 17V7C20 4.79 16.42 3 12 3M18 17C18 17.5 15.87 19 12 19S6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16S16.39 15.55 18 14.77V17M18 12.45C16.7 13.4 14.42 14 12 14S7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.45M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5 18 6.5 18 7 15.87 9 12 9M7 22H9V24H7V22M15 22H17V24H15V22M11 22H13V24H11V22Z";
var mdiDatabaseSync = "M19,12V13.5A4,4 0 0,1 23,17.5C23,18.32 22.75,19.08 22.33,19.71L21.24,18.62C21.41,18.28 21.5,17.9 21.5,17.5A2.5,2.5 0 0,0 19,15V16.5L16.75,14.25L19,12M19,23V21.5A4,4 0 0,1 15,17.5C15,16.68 15.25,15.92 15.67,15.29L16.76,16.38C16.59,16.72 16.5,17.1 16.5,17.5A2.5,2.5 0 0,0 19,20V18.5L21.25,20.75L19,23M12,3C16.42,3 20,4.79 20,7C20,9.21 16.42,11 12,11C7.58,11 4,9.21 4,7C4,4.79 7.58,3 12,3M4,9C4,11.21 7.58,13 12,13C13.11,13 14.17,12.89 15.14,12.68C14.19,13.54 13.5,14.67 13.18,15.96L12,16C7.58,16 4,14.21 4,12V9M20,9V11H19.5L18.9,11.03C19.6,10.43 20,9.74 20,9M4,14C4,16.21 7.58,18 12,18L13,17.97C13.09,19.03 13.42,20 13.95,20.88L12,21C7.58,21 4,19.21 4,17V14Z";
var mdiDatabaseSyncOutline = "M12 16C12.41 16 12.81 15.97 13.21 15.94C13.4 15.18 13.72 14.46 14.16 13.83C13.47 13.94 12.74 14 12 14C9.58 14 7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V11.19C18.5 11.07 19 11 19.55 11C19.7 11 19.85 11 20 11.03V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.66 21 13.31 20.96 13.92 20.88C13.57 20.29 13.31 19.64 13.16 18.94C12.79 19 12.41 19 12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16M12 5C15.87 5 18 6.5 18 7S15.87 9 12 9 6 7.5 6 7 8.13 5 12 5M23 17.5C23 18.32 22.75 19.08 22.33 19.71L21.24 18.62C21.41 18.28 21.5 17.9 21.5 17.5C21.5 16.12 20.38 15 19 15V16.5L16.75 14.25L19 12V13.5C21.21 13.5 23 15.29 23 17.5M19 18.5L21.25 20.75L19 23V21.5C16.79 21.5 15 19.71 15 17.5C15 16.68 15.25 15.92 15.67 15.29L16.76 16.38C16.59 16.72 16.5 17.1 16.5 17.5C16.5 18.88 17.62 20 19 20V18.5Z";
var mdiDeathStar = "M2.05,13H21.95C21.45,18.05 17.19,22 12,22C6.82,22 2.55,18.05 2.05,13M21.95,11H2.05C2.55,5.95 6.82,2 12,2C17.18,2 21.45,5.95 21.95,11M12,6.75A2.5,2.5 0 0,0 9.5,4.25A2.5,2.5 0 0,0 7,6.75A2.5,2.5 0 0,0 9.5,9.25A2.5,2.5 0 0,0 12,6.75Z";
var mdiDeathStarVariant = "M2.05,13H21.94C21.88,13.69 21.74,14.36 21.54,15H14V17H17V19H15V21H12.5V22C12.33,22 12.17,22 12,22C6.82,22 2.55,18.05 2.05,13M21.94,11H2.05C2.55,5.95 6.82,2 12,2C13.62,2 15.15,2.39 16.5,3.08V5H18.5V7H20V9H21.54C21.74,9.64 21.88,10.31 21.94,11M12,6.75A2.5,2.5 0 0,0 9.5,4.25A2.5,2.5 0 0,0 7,6.75A2.5,2.5 0 0,0 9.5,9.25A2.5,2.5 0 0,0 12,6.75Z";
var mdiDeathlyHallows = "M12,2L1,21H23L12,2M12.75,11.47C14.56,11.87 15.7,13.67 15.3,15.5C15,16.75 14,17.75 12.75,18.03V11.47M11.25,18C9.44,17.6 8.3,15.8 8.7,14C9,12.72 10,11.72 11.25,11.44V18M16.88,14.72C16.83,12.35 15.09,10.36 12.75,10V6.29L20.4,19.5H13.07C15.29,19 16.87,17.03 16.88,14.75V14.72M11.25,6.29V10C8.6,10.4 6.77,12.88 7.18,15.54C7.5,17.5 8.97,19.12 10.93,19.55H3.6L11.25,6.29Z";
var mdiDebian = "M18.5,10.57L18.3,10.94C18.56,10.16 18.41,9.31 18.45,8.57L18.38,8.55C18.31,6.7 16.71,4.73 15.29,4.07C14.06,3.5 12.17,3.4 11.3,3.83C11.42,3.72 11.9,3.68 11.75,3.6C10.38,3.73 10.69,4.07 9.64,4.34C9.35,4.62 10.5,4.12 9.87,4.5C9.31,4.63 9.05,4.38 8.22,5.24C8.29,5.36 8.75,4.89 8.37,5.36C7.58,5.27 5.89,7.16 5.53,7.78L5.72,7.82C5.41,8.59 5,9.08 4.95,9.54C4.87,10.68 4.5,12.75 5.03,13.39L4.97,13.92L5.2,14.37L5.08,14.38C5.66,16.21 5.7,14.42 6.47,16.32C6.36,16.28 6.24,16.24 6.08,16C6.06,16.19 6.32,16.69 6.62,17.08L6.5,17.22C6.66,17.53 6.82,17.6 6.93,17.71C6.3,17.36 7.5,18.84 7.63,19.03L7.73,18.86C7.71,19.1 7.9,19.42 8.26,19.87L8.56,19.86C8.69,20.1 9.14,20.54 9.41,20.56L9.23,20.8C9.92,21 9.56,21.09 10.41,21.39L10.24,21.09C10.67,21.46 10.8,21.79 11.41,22.07C12.26,22.37 12.37,22.25 13.23,22.5C12.5,22.5 11.64,22.5 11.06,22.28C7.1,21.21 3.5,16.56 3.74,11.78C3.68,10.81 3.84,9.6 3.68,9.36C3.9,8.62 4.16,7.72 4.69,6.65C4.65,6.58 4.78,6.86 5.05,6.41C5.21,6.05 5.34,5.66 5.55,5.31L5.65,5.28C5.76,4.67 7.08,3.73 7.5,3.26V3.44C8.36,2.63 9.9,2.09 10.76,1.71C10.53,1.96 11.27,1.68 11.8,1.65L11.31,1.93C11.94,1.77 11.91,2 12.56,1.9C12.33,1.93 12.06,2 12.1,2.06C12.82,2.14 12.94,1.84 13.61,2.06L13.56,1.86C14.5,2.2 14.69,2.14 15.7,2.68C16.06,2.69 16.1,2.46 16.63,2.68C16.73,2.84 16.61,2.87 17.27,3.27C17.34,3.24 17.14,3.05 17,2.9C18.3,3.61 19.75,5.12 20.18,6.74C19.77,6 20.14,7.13 20,7.07C20.18,7.56 20.33,8.07 20.43,8.6C20.31,8.17 20.04,7.12 19.57,6.45C19.54,6.88 18.97,6.15 19.28,7.11C19.5,7.45 19.33,6.76 19.62,7.36C19.62,7.65 19.73,7.94 19.8,8.31C19.7,8.29 19.58,7.9 19.5,8C19.6,8.5 19.77,8.72 19.83,8.76C19.8,8.84 19.71,8.68 19.71,9C19.75,9.74 19.92,9.43 20,9.46C19.91,9.83 19.59,10.25 19.75,10.88L19.55,10.32C19.5,10.85 19.66,10.95 19.42,11.6C19.6,11 19.58,10.5 19.41,10.75C19.5,11.57 18.76,12.2 18.83,12.73L18.62,12.44C18.05,13.27 18.61,12.89 18.22,13.5C18.36,13.27 18.15,13.42 18.33,13.14C18.21,13.15 17.78,13.67 17.39,13.97C15.85,15.2 14,15.37 12.24,14.7H12.23C12.24,14.66 12.23,14.61 12.11,14.53C10.6,13.38 9.71,12.4 10,10.12C10.25,9.95 10.31,9 10.84,8.67C11.16,7.96 12.12,7.31 13.15,7.29C14.2,7.23 15.09,7.85 15.54,8.43C14.72,7.68 13.4,7.45 12.26,8C11.11,8.53 10.42,9.8 10.5,11.07C10.56,11 10.6,11.05 10.62,10.89C10.59,13.36 13.28,15.17 15.22,14.26L15.25,14.31C16.03,14.09 15.93,13.92 16.44,13.56C16.4,13.65 16.1,13.86 16.28,13.86C16.53,13.8 17.31,13.07 17.7,12.73C17.87,12.35 17.6,12.5 17.85,12.04L18.15,11.89C18.32,11.41 18.5,11.14 18.5,10.57";
var mdiDebugStepInto = "M12,22A2,2 0 0,1 10,20A2,2 0 0,1 12,18A2,2 0 0,1 14,20A2,2 0 0,1 12,22M13,2V13L17.5,8.5L18.92,9.92L12,16.84L5.08,9.92L6.5,8.5L11,13V2H13Z";
var mdiDebugStepOut = "M12,22A2,2 0 0,1 10,20A2,2 0 0,1 12,18A2,2 0 0,1 14,20A2,2 0 0,1 12,22M13,16H11V6L6.5,10.5L5.08,9.08L12,2.16L18.92,9.08L17.5,10.5L13,6V16Z";
var mdiDebugStepOver = "M12,14A2,2 0 0,1 14,16A2,2 0 0,1 12,18A2,2 0 0,1 10,16A2,2 0 0,1 12,14M23.46,8.86L21.87,15.75L15,14.16L18.8,11.78C17.39,9.5 14.87,8 12,8C8.05,8 4.77,10.86 4.12,14.63L2.15,14.28C2.96,9.58 7.06,6 12,6C15.58,6 18.73,7.89 20.5,10.72L23.46,8.86Z";
var mdiDecagram = "M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12Z";
var mdiDecagramOutline = "M23,12L20.56,14.78L20.9,18.46L17.29,19.28L15.4,22.46L12,21L8.6,22.47L6.71,19.29L3.1,18.47L3.44,14.78L1,12L3.44,9.21L3.1,5.53L6.71,4.72L8.6,1.54L12,3L15.4,1.54L17.29,4.72L20.9,5.54L20.56,9.22L23,12M20.33,12L18.5,9.89L18.74,7.1L16,6.5L14.58,4.07L12,5.18L9.42,4.07L8,6.5L5.26,7.09L5.5,9.88L3.67,12L5.5,14.1L5.26,16.9L8,17.5L9.42,19.93L12,18.81L14.58,19.92L16,17.5L18.74,16.89L18.5,14.1L20.33,12Z";
var mdiDecimal = "M10 7A3 3 0 0 0 7 10V13A3 3 0 0 0 13 13V10A3 3 0 0 0 10 7M11 13A1 1 0 0 1 9 13V10A1 1 0 0 1 11 10M17 7A3 3 0 0 0 14 10V13A3 3 0 0 0 20 13V10A3 3 0 0 0 17 7M18 13A1 1 0 0 1 16 13V10A1 1 0 0 1 18 10M6 15A1 1 0 1 1 5 14A1 1 0 0 1 6 15Z";
var mdiDecimalComma = "M10 7A3 3 0 0 1 13 10V13A3 3 0 0 1 7 13V10A3 3 0 0 1 10 7M10 9A1 1 0 0 0 9 10V13A1 1 0 0 0 11 13V10A1 1 0 0 0 10 9M17 7A3 3 0 0 1 20 10V13A3 3 0 0 1 14 13V10A3 3 0 0 1 17 7M17 9A1 1 0 0 0 16 10V13A1 1 0 0 0 18 13V10A1 1 0 0 0 17 9M5 14A1 1 0 0 0 4 15L5 18H6V15A1 1 0 0 0 5 14Z";
var mdiDecimalCommaDecrease = "M5 13V16H4L3 13A1 1 0 0 1 5 13M15 16V14L12 17L15 20V18H21V16M12 11A3 3 0 0 1 6 11V8A3 3 0 0 1 12 8M10 8A1 1 0 0 0 8 8V11A1 1 0 0 0 10 11Z";
var mdiDecimalCommaIncrease = "M9 5A3 3 0 0 0 6 8V11A3 3 0 0 0 12 11V8A3 3 0 0 0 9 5M10 11A1 1 0 0 1 8 11V8A1 1 0 0 1 10 8M16 14A3 3 0 0 0 19 11V8A3 3 0 0 0 13 8V11A3 3 0 0 0 16 14M15 8A1 1 0 0 1 17 8V11A1 1 0 0 1 15 11M19 20V18H13V16H19V14L22 17M5 13V16H4L3 13A1 1 0 0 1 5 13Z";
var mdiDecimalDecrease = "M12,17L15,20V18H21V16H15V14L12,17M9,5A3,3 0 0,1 12,8V11A3,3 0 0,1 9,14A3,3 0 0,1 6,11V8A3,3 0 0,1 9,5M9,7A1,1 0 0,0 8,8V11A1,1 0 0,0 9,12A1,1 0 0,0 10,11V8A1,1 0 0,0 9,7M4,12A1,1 0 0,1 5,13A1,1 0 0,1 4,14A1,1 0 0,1 3,13A1,1 0 0,1 4,12Z";
var mdiDecimalIncrease = "M22,17L19,20V18H13V16H19V14L22,17M9,5A3,3 0 0,1 12,8V11A3,3 0 0,1 9,14A3,3 0 0,1 6,11V8A3,3 0 0,1 9,5M9,7A1,1 0 0,0 8,8V11A1,1 0 0,0 9,12A1,1 0 0,0 10,11V8A1,1 0 0,0 9,7M16,5A3,3 0 0,1 19,8V11A3,3 0 0,1 16,14A3,3 0 0,1 13,11V8A3,3 0 0,1 16,5M16,7A1,1 0 0,0 15,8V11A1,1 0 0,0 16,12A1,1 0 0,0 17,11V8A1,1 0 0,0 16,7M4,12A1,1 0 0,1 5,13A1,1 0 0,1 4,14A1,1 0 0,1 3,13A1,1 0 0,1 4,12Z";
var mdiDelete = "M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z";
var mdiDeleteAlert = "M17 4V6H3V4H6.5L7.5 3H12.5L13.5 4H17M4 19V7H16V19C16 20.1 15.1 21 14 21H6C4.9 21 4 20.1 4 19M19 15H21V17H19V15M19 7H21V13H19V7Z";
var mdiDeleteAlertOutline = "M4 19V7H16V19C16 20.1 15.1 21 14 21H6C4.9 21 4 20.1 4 19M6 9V19H14V9H6M13.5 4H17V6H3V4H6.5L7.5 3H12.5L13.5 4M19 17V15H21V17H19M19 13V7H21V13H19Z";
var mdiDeleteCircle = "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M17,7H14.5L13.5,6H10.5L9.5,7H7V9H17V7M9,18H15A1,1 0 0,0 16,17V10H8V17A1,1 0 0,0 9,18Z";
var mdiDeleteCircleOutline = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M16,10V17A1,1 0 0,1 15,18H9A1,1 0 0,1 8,17V10H16M13.5,6L14.5,7H17V9H7V7H9.5L10.5,6H13.5Z";
var mdiDeleteClock = "M15 13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69V13M23 16C23 19.87 19.87 23 16 23C14.09 23 12.36 22.24 11.1 21H8C6.9 21 6 20.1 6 19V7H18V9.29C20.89 10.15 23 12.83 23 16M16 11C13.24 11 11 13.24 11 16C11 18.76 13.24 21 16 21C18.76 21 21 18.76 21 16C21 13.24 18.76 11 16 11M19 4V6H5V4H8.5L9.5 3H14.5L15.5 4H19Z";
var mdiDeleteClockOutline = "M15 13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69V13M23 16C23 19.87 19.87 23 16 23C14.09 23 12.36 22.24 11.1 21H8C6.9 21 6 20.1 6 19V7H18V9.29C20.89 10.15 23 12.83 23 16M9 16C9 12.13 12.13 9 16 9H8V19H9.67C9.24 18.09 9 17.07 9 16M16 11C13.24 11 11 13.24 11 16C11 18.76 13.24 21 16 21C18.76 21 21 18.76 21 16C21 13.24 18.76 11 16 11M15.5 4H19V6H5V4H8.5L9.5 3H14.5L15.5 4Z";
var mdiDeleteEmpty = "M20.37,8.91L19.37,10.64L7.24,3.64L8.24,1.91L11.28,3.66L12.64,3.29L16.97,5.79L17.34,7.16L20.37,8.91M6,19V7H11.07L18,11V19A2,2 0 0,1 16,21H8A2,2 0 0,1 6,19Z";
var mdiDeleteEmptyOutline = "M20.37,8.91L19.37,10.64L7.24,3.64L8.24,1.91L11.28,3.66L12.64,3.29L16.97,5.79L17.34,7.16L20.37,8.91M6,19V7H11.07L18,11V19A2,2 0 0,1 16,21H8A2,2 0 0,1 6,19M8,19H16V12.2L10.46,9H8V19Z";
var mdiDeleteForever = "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8.46,11.88L9.87,10.47L12,12.59L14.12,10.47L15.53,11.88L13.41,14L15.53,16.12L14.12,17.53L12,15.41L9.88,17.53L8.47,16.12L10.59,14L8.46,11.88M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z";
var mdiDeleteForeverOutline = "M14.12,10.47L12,12.59L9.87,10.47L8.46,11.88L10.59,14L8.47,16.12L9.88,17.53L12,15.41L14.12,17.53L15.53,16.12L13.41,14L15.53,11.88L14.12,10.47M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9Z";
var mdiDeleteOff = "M2 5.27L3.28 4L5 5.72L5.28 6L6.28 7L18 18.72L20 20.72L18.73 22L17.27 20.54C16.93 20.83 16.5 21 16 21H8C6.9 21 6 20.1 6 19V9.27L2 5.27M19 4V6H7.82L5.82 4H8.5L9.5 3H14.5L15.5 4H19M18 7V16.18L8.82 7H18Z";
var mdiDeleteOffOutline = "M2 5.27L3.28 4L5 5.72L5.28 6L6.28 7L8.28 9L16 16.72L18 18.72L20 20.72L18.73 22L17.27 20.54C16.93 20.83 16.5 21 16 21H8C6.9 21 6 20.1 6 19V9.27L2 5.27M8 19H15.73L8 11.27V19M18 7V16.18L16 14.18V9H10.82L8.82 7H18M15.5 4H19V6H7.82L5.82 4H8.5L9.5 3H14.5L15.5 4Z";
var mdiDeleteOutline = "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z";
var mdiDeleteRestore = "M14,14H16L12,10L8,14H10V18H14V14M6,7H18V19C18,19.5 17.8,20 17.39,20.39C17,20.8 16.5,21 16,21H8C7.5,21 7,20.8 6.61,20.39C6.2,20 6,19.5 6,19V7M19,4V6H5V4H8.5L9.5,3H14.5L15.5,4H19Z";
var mdiDeleteSweep = "M15,16H19V18H15V16M15,8H22V10H15V8M15,12H21V14H15V12M3,18A2,2 0 0,0 5,20H11A2,2 0 0,0 13,18V8H3V18M14,5H11L10,4H6L5,5H2V7H14V5Z";
var mdiDeleteSweepOutline = "M15,16H19V18H15V16M15,8H22V10H15V8M15,12H21V14H15V12M11,10V18H5V10H11M13,8H3V18A2,2 0 0,0 5,20H11A2,2 0 0,0 13,18V8M14,5H11L10,4H6L5,5H2V7H14V5Z";
var mdiDeleteVariant = "M21.03,3L18,20.31C17.83,21.27 17,22 16,22H8C7,22 6.17,21.27 6,20.31L2.97,3H21.03M5.36,5L8,20H16L18.64,5H5.36M9,18V14H13V18H9M13,13.18L9.82,10L13,6.82L16.18,10L13,13.18Z";
var mdiDelta = "M12,7.77L18.39,18H5.61L12,7.77M12,4L2,20H22";
var mdiDesk = "M3 6H21C21.55 6 22 6.45 22 7C22 7.55 21.55 8 21 8V19H19V17H15V19H13V8H5V19H3V8C2.45 8 2 7.55 2 7C2 6.45 2.45 6 3 6M16 10.5V11H18V10.5C18 10.22 17.78 10 17.5 10H16.5C16.22 10 16 10.22 16 10.5M16 14.5V15H18V14.5C18 14.22 17.78 14 17.5 14H16.5C16.22 14 16 14.22 16 14.5Z";
var mdiDeskLamp = "M10.85,2L9.18,4.5L10.32,5.25L7.14,10C7.1,10 7.05,10 7,10A2,2 0 0,0 5,12C5,12.94 5.66,13.75 6.58,13.95L10.62,20H7V22H17V20H13L8.53,13.28C8.83,12.92 9,12.47 9,12C9,11.7 8.93,11.4 8.8,11.13L12,6.37C11.78,8.05 12.75,9.89 14.45,11L18.89,4.37C17.2,3.24 15.12,3.04 13.65,3.87L10.85,2M18.33,7L16.67,9.5C17.35,9.95 18.29,9.77 18.75,9.08C19.21,8.39 19,7.46 18.33,7Z";
var mdiDeskLampOff = "M9 10.87L8.8 11.13C8.93 11.4 9 11.7 9 12C9 12.47 8.83 12.92 8.53 13.28L13 20H17V22H7V20H10.62L6.58 13.95C5.66 13.75 5 12.94 5 12C5 10.9 5.9 10 7 10H7.14L7.53 9.42L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73L9 10.87M18.33 7L16.67 9.5C17.35 9.95 18.29 9.77 18.75 9.08S19 7.46 18.33 7M9.57 6.37L11 7.82L12 6.37C11.78 8.05 12.75 9.89 14.45 11L18.89 4.37C17.2 3.24 15.12 3.04 13.65 3.87L10.85 2L9.18 4.5L10.32 5.25L9.57 6.37Z";
var mdiDeskLampOn = "M10.85 2L9.18 4.5L10.32 5.25L7.14 10H7C5.9 10 5 10.9 5 12C5 12.94 5.66 13.75 6.58 13.95L10.62 20H7V22H17V20H13L8.53 13.28C8.83 12.92 9 12.47 9 12C9 11.7 8.93 11.4 8.8 11.13L12 6.37C11.78 8.05 12.75 9.89 14.45 11L18.89 4.37C17.2 3.24 15.12 3.04 13.65 3.87L10.85 2M18.33 7L16.67 9.5C17.35 9.95 18.29 9.77 18.75 9.08C19.21 8.39 19 7.46 18.33 7M21.7 12.58L19.58 10.45L20.28 9.75L22.4 11.87L21.7 12.58M23 7H20V6H23V7M16 14V11H17V14H16Z";
var mdiDeskphone = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M15,5V19H19V5H15M5,5V9H13V5H5M5,11V13H7V11H5M8,11V13H10V11H8M11,11V13H13V11H11M5,14V16H7V14H5M8,14V16H10V14H8M11,14V16H13V14H11M11,17V19H13V17H11M8,17V19H10V17H8M5,17V19H7V17H5Z";
var mdiDesktopClassic = "M6,2C4.89,2 4,2.89 4,4V12C4,13.11 4.89,14 6,14H18C19.11,14 20,13.11 20,12V4C20,2.89 19.11,2 18,2H6M6,4H18V12H6V4M4,15C2.89,15 2,15.89 2,17V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V17C22,15.89 21.11,15 20,15H4M8,17H20V20H8V17M9,17.75V19.25H13V17.75H9M15,17.75V19.25H19V17.75H15Z";
var mdiDesktopTower = "M8,2H16A2,2 0 0,1 18,4V20A2,2 0 0,1 16,22H8A2,2 0 0,1 6,20V4A2,2 0 0,1 8,2M8,4V6H16V4H8M16,8H8V10H16V8M16,18H14V20H16V18Z";
var mdiDesktopTowerMonitor = "M22,18H17A1,1 0 0,1 16,17V7A1,1 0 0,1 17,6H22A1,1 0 0,1 23,7V17A1,1 0 0,1 22,18M22,8H17V9H22V8M22,10H17V11H22V10M9,15V17H10V18H5V17H6V15H2A1,1 0 0,1 1,14V7A1,1 0 0,1 2,6H13A1,1 0 0,1 14,7V14A1,1 0 0,1 13,15H9M12,8H3V13H12V8Z";
var mdiDetails = "M6.38,6H17.63L12,16L6.38,6M3,4L12,20L21,4H3Z";
var mdiDevTo = "M7.73 11.93C7.73 13.65 7.71 13.76 7.5 14C7.31 14.17 7.12 14.23 6.74 14.23L6.23 14.24L6.2 11.97L6.18 9.7H6.7C7.05 9.7 7.3 9.77 7.47 9.91C7.71 10.12 7.73 10.16 7.73 11.93M22 7.5V16.5C22 17.61 21.11 18.5 20 18.5H4C2.89 18.5 2 17.61 2 16.5V7.5C2 6.39 2.89 5.5 4 5.5H20C21.11 5.5 22 6.39 22 7.5M8.93 11.73C8.9 9.89 8.88 9.74 8.64 9.34C8.24 8.66 7.79 8.5 6.28 8.5H5V15.5H6.21C7.54 15.5 8.1 15.33 8.5 14.79C8.91 14.26 9 13.81 8.93 11.73M13.12 8.5H11.64C10.15 8.5 10.14 8.5 9.93 8.78S9.7 9.21 9.7 12V14.96L9.97 15.23C10.22 15.5 10.28 15.5 11.68 15.5H13.12V14.31L12.03 14.27L10.93 14.24V12.6L11.61 12.57L12.27 12.53V11.34H10.88V9.7H13.12V8.5M19 8.56C19 8.5 18.7 8.5 18.34 8.5L17.66 8.56L17.07 10.91C16.69 12.39 16.45 13.18 16.4 13.04C16.32 12.77 15.26 8.6 15.26 8.55C15.26 8.5 14.95 8.5 14.58 8.5H13.89L14.3 10.05C14.5 10.92 14.89 12.33 15.11 13.2C15.45 14.55 15.57 14.85 15.86 15.14C16.06 15.36 16.31 15.5 16.47 15.5C16.8 15.5 17.23 15.16 17.37 14.77C17.5 14.5 19 8.69 19 8.56Z";
var mdiDeveloperBoard = "M22,9V7H20V5A2,2 0 0,0 18,3H4A2,2 0 0,0 2,5V19A2,2 0 0,0 4,21H18A2,2 0 0,0 20,19V17H22V15H20V13H22V11H20V9H22M18,19H4V5H18V19M6,13H11V17H6V13M12,7H16V10H12V7M6,7H11V12H6V7M12,11H16V17H12V11Z";
var mdiDeviantart = "M6,6H12L14,2H18V6L14.5,13H18V18H12L10,22H6V18L9.5,11H6V6Z";
var mdiDevices = "M3 6H21V4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H7V18H3V6M13 12H9V13.78C8.39 14.33 8 15.11 8 16C8 16.89 8.39 17.67 9 18.22V20H13V18.22C13.61 17.67 14 16.88 14 16S13.61 14.33 13 13.78V12M11 17.5C10.17 17.5 9.5 16.83 9.5 16S10.17 14.5 11 14.5 12.5 15.17 12.5 16 11.83 17.5 11 17.5M22 8H16C15.5 8 15 8.5 15 9V19C15 19.5 15.5 20 16 20H22C22.5 20 23 19.5 23 19V9C23 8.5 22.5 8 22 8M21 18H17V10H21V18Z";
var mdiDharmachakra = "M11,2V3C9.27,3.2 7.69,3.9 6.4,4.94L5.64,4.18L4.22,5.6L5,6.35C3.9,7.68 3.21,9.3 3,11H2V13H3C3.21,14.68 3.9,16.26 5,17.56L4.22,18.32L5.64,19.74L6.39,19C7.71,20.07 9.3,20.77 11,21V22H13V21C14.69,20.77 16.29,20.07 17.6,19L18.36,19.74L19.78,18.32L19,17.57C20.1,16.27 20.79,14.68 21,13H22V11H21C20.79,9.3 20.1,7.69 19,6.36L19.78,5.6L18.36,4.18L17.61,4.94C16.29,3.87 14.69,3.2 13,3V2H11M11,5V8L10,8.5L7.81,6.35C8.72,5.67 9.81,5.17 11,5M13,5C14.16,5.18 15.26,5.64 16.2,6.35L14,8.5L13,8V5M6.4,7.76L8.5,10L8,11H5C5.16,9.84 5.7,8.7 6.39,7.75L6.4,7.76M17.6,7.76C18.33,8.71 18.81,9.82 19,11H16L15.5,10L17.61,7.76H17.6M12,10C13.12,10 14,10.88 14,12C14,13.12 13.12,14 12,14C10.88,14 10,13.12 10,12C10,10.88 10.88,10 12,10M5,13H8L8.57,14L6.39,16.15C5.67,15.24 5.19,14.16 5,13V13M16,13H19C18.81,14.15 18.33,15.24 17.61,16.16L15.5,14L16,13M10,15.5L11,16V19C9.83,18.8 8.73,18.31 7.8,17.57L10,15.5M14,15.5L16.19,17.57C15.28,18.25 14.19,18.83 13,19V16L14,15.5Z";
var mdiDiabetes = "M14.73 2.29A1 1 0 0 1 16.14 3.7L13 6.79L13.76 7.74L15.7 12.74A1.46 1.46 0 0 1 15.36 14.29L12.27 17.38A1.55 1.55 0 0 1 10.15 17.38L5.55 12.78A1.37 1.37 0 0 1 5.15 11.78L4.65 5.34H5.72A1 1 0 0 1 6.47 5.64L6.61 5.81L7.66 9.29M7.66 22L2 16.36L4.12 14.24L9.78 19.9M19.5 4.5S17 7.26 17 9A2.5 2.5 0 1 0 22 9C22 7.26 19.5 4.5 19.5 4.5Z";
var mdiDialpad = "M12,19A2,2 0 0,0 10,21A2,2 0 0,0 12,23A2,2 0 0,0 14,21A2,2 0 0,0 12,19M6,1A2,2 0 0,0 4,3A2,2 0 0,0 6,5A2,2 0 0,0 8,3A2,2 0 0,0 6,1M6,7A2,2 0 0,0 4,9A2,2 0 0,0 6,11A2,2 0 0,0 8,9A2,2 0 0,0 6,7M6,13A2,2 0 0,0 4,15A2,2 0 0,0 6,17A2,2 0 0,0 8,15A2,2 0 0,0 6,13M18,5A2,2 0 0,0 20,3A2,2 0 0,0 18,1A2,2 0 0,0 16,3A2,2 0 0,0 18,5M12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17A2,2 0 0,0 14,15A2,2 0 0,0 12,13M18,13A2,2 0 0,0 16,15A2,2 0 0,0 18,17A2,2 0 0,0 20,15A2,2 0 0,0 18,13M18,7A2,2 0 0,0 16,9A2,2 0 0,0 18,11A2,2 0 0,0 20,9A2,2 0 0,0 18,7M12,7A2,2 0 0,0 10,9A2,2 0 0,0 12,11A2,2 0 0,0 14,9A2,2 0 0,0 12,7M12,1A2,2 0 0,0 10,3A2,2 0 0,0 12,5A2,2 0 0,0 14,3A2,2 0 0,0 12,1Z";
var mdiDiameter = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M17,15V13H7V15L4,12L7,9V11H17V9L20,12L17,15Z";
var mdiDiameterOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M16,15V13H8V15L5,12L8,9V11H16V9L19,12L16,15Z";
var mdiDiameterVariant = "M4.15,21.46L5.47,19.58C3.35,17.74 2,15.03 2,12A10,10 0 0,1 12,2C13.78,2 15.44,2.46 16.89,3.27L18.21,1.39L19.85,2.54L18.53,4.42C20.65,6.26 22,8.97 22,12A10,10 0 0,1 12,22C10.22,22 8.56,21.54 7.11,20.73L5.79,22.61L4.15,21.46M12,4A8,8 0 0,0 4,12C4,14.35 5,16.46 6.63,17.93L15.73,4.92C14.62,4.33 13.35,4 12,4M12,20A8,8 0 0,0 20,12C20,9.65 19,7.54 17.37,6.07L8.27,19.08C9.38,19.67 10.65,20 12,20Z";
var mdiDiamond = "M6,2L2,8L12,22L22,8L18,2H6Z";
var mdiDiamondOutline = "M18,2H6L2,8L12,22L22,8L18,2M4.43,8L7.07,4H16.93L19.57,8L12,18.56L4.43,8Z";
var mdiDiamondStone = "M16,9H19L14,16M10,9H14L12,17M5,9H8L10,16M15,4H17L19,7H16M11,4H13L14,7H10M7,4H9L8,7H5M6,2L2,8L12,22L22,8L18,2H6Z";
var mdiDiaperOutline = "M21 4H3C2.45 4 2 4.45 2 5V10C2 15.5 6.5 20 12 20C17.5 20 22 15.5 22 10V5C22 4.45 21.55 4 21 4M4 6H20V8H15V10H20C20 10.34 20 10.67 19.94 11C16.12 11.03 13.03 14.12 13 17.94C12.67 18 12.34 18 12 18C11.66 18 11.33 18 11 17.94C10.97 14.12 7.88 11.03 4.06 11C4 10.67 4 10.34 4 10H9V8H4V6M15.04 17.4C15.31 15.12 17.12 13.31 19.41 13.04C18.59 15 17 16.59 15.03 17.41M4.6 13.04C6.88 13.31 8.7 15.12 8.97 17.41C7 16.59 5.41 15 4.6 13.03Z";
var mdiDice1 = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z";
var mdiDice1Outline = "M19 5V19H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M12 10.5C11.17 10.5 10.5 11.17 10.5 12S11.17 13.5 12 13.5 13.5 12.83 13.5 12 12.83 10.5 12 10.5";
var mdiDice2 = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M7,5A2,2 0 0,0 5,7A2,2 0 0,0 7,9A2,2 0 0,0 9,7A2,2 0 0,0 7,5M17,15A2,2 0 0,0 15,17A2,2 0 0,0 17,19A2,2 0 0,0 19,17A2,2 0 0,0 17,15Z";
var mdiDice2Outline = "M19 5V19H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M7.5 6C6.67 6 6 6.67 6 7.5S6.67 9 7.5 9 9 8.33 9 7.5 8.33 6 7.5 6M16.5 15C15.67 15 15 15.67 15 16.5C15 17.33 15.67 18 16.5 18C17.33 18 18 17.33 18 16.5C18 15.67 17.33 15 16.5 15Z";
var mdiDice3 = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M7,5A2,2 0 0,0 5,7A2,2 0 0,0 7,9A2,2 0 0,0 9,7A2,2 0 0,0 7,5M17,15A2,2 0 0,0 15,17A2,2 0 0,0 17,19A2,2 0 0,0 19,17A2,2 0 0,0 17,15Z";
var mdiDice3Outline = "M19 5V19H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M12 10.5C11.2 10.5 10.5 11.2 10.5 12S11.2 13.5 12 13.5 13.5 12.8 13.5 12 12.8 10.5 12 10.5M7.5 6C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9 9 8.3 9 7.5 8.3 6 7.5 6M16.5 15C15.7 15 15 15.7 15 16.5C15 17.3 15.7 18 16.5 18C17.3 18 18 17.3 18 16.5C18 15.7 17.3 15 16.5 15Z";
var mdiDice4 = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M7,5A2,2 0 0,0 5,7A2,2 0 0,0 7,9A2,2 0 0,0 9,7A2,2 0 0,0 7,5M17,15A2,2 0 0,0 15,17A2,2 0 0,0 17,19A2,2 0 0,0 19,17A2,2 0 0,0 17,15M17,5A2,2 0 0,0 15,7A2,2 0 0,0 17,9A2,2 0 0,0 19,7A2,2 0 0,0 17,5M7,15A2,2 0 0,0 5,17A2,2 0 0,0 7,19A2,2 0 0,0 9,17A2,2 0 0,0 7,15Z";
var mdiDice4Outline = "M19 5V19H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M7.5 6C6.67 6 6 6.67 6 7.5S6.67 9 7.5 9 9 8.33 9 7.5 8.33 6 7.5 6M16.5 15C15.67 15 15 15.67 15 16.5C15 17.33 15.67 18 16.5 18C17.33 18 18 17.33 18 16.5C18 15.67 17.33 15 16.5 15M16.5 6C15.67 6 15 6.67 15 7.5S15.67 9 16.5 9C17.33 9 18 8.33 18 7.5S17.33 6 16.5 6M7.5 15C6.67 15 6 15.67 6 16.5C6 17.33 6.67 18 7.5 18S9 17.33 9 16.5C9 15.67 8.33 15 7.5 15Z";
var mdiDice5 = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M7,5A2,2 0 0,0 5,7A2,2 0 0,0 7,9A2,2 0 0,0 9,7A2,2 0 0,0 7,5M17,15A2,2 0 0,0 15,17A2,2 0 0,0 17,19A2,2 0 0,0 19,17A2,2 0 0,0 17,15M17,5A2,2 0 0,0 15,7A2,2 0 0,0 17,9A2,2 0 0,0 19,7A2,2 0 0,0 17,5M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M7,15A2,2 0 0,0 5,17A2,2 0 0,0 7,19A2,2 0 0,0 9,17A2,2 0 0,0 7,15Z";
var mdiDice5Outline = "M19 5V19H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M7.5 6C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9 9 8.3 9 7.5 8.3 6 7.5 6M16.5 15C15.7 15 15 15.7 15 16.5C15 17.3 15.7 18 16.5 18C17.3 18 18 17.3 18 16.5C18 15.7 17.3 15 16.5 15M16.5 6C15.7 6 15 6.7 15 7.5S15.7 9 16.5 9C17.3 9 18 8.3 18 7.5S17.3 6 16.5 6M12 10.5C11.2 10.5 10.5 11.2 10.5 12S11.2 13.5 12 13.5 13.5 12.8 13.5 12 12.8 10.5 12 10.5M7.5 15C6.7 15 6 15.7 6 16.5C6 17.3 6.7 18 7.5 18S9 17.3 9 16.5C9 15.7 8.3 15 7.5 15Z";
var mdiDice6 = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M7,5A2,2 0 0,0 5,7A2,2 0 0,0 7,9A2,2 0 0,0 9,7A2,2 0 0,0 7,5M17,15A2,2 0 0,0 15,17A2,2 0 0,0 17,19A2,2 0 0,0 19,17A2,2 0 0,0 17,15M17,10A2,2 0 0,0 15,12A2,2 0 0,0 17,14A2,2 0 0,0 19,12A2,2 0 0,0 17,10M17,5A2,2 0 0,0 15,7A2,2 0 0,0 17,9A2,2 0 0,0 19,7A2,2 0 0,0 17,5M7,10A2,2 0 0,0 5,12A2,2 0 0,0 7,14A2,2 0 0,0 9,12A2,2 0 0,0 7,10M7,15A2,2 0 0,0 5,17A2,2 0 0,0 7,19A2,2 0 0,0 9,17A2,2 0 0,0 7,15Z";
var mdiDice6Outline = "M19 5V19H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M7.5 6C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9 9 8.3 9 7.5 8.3 6 7.5 6M16.5 15C15.7 15 15 15.7 15 16.5C15 17.3 15.7 18 16.5 18C17.3 18 18 17.3 18 16.5C18 15.7 17.3 15 16.5 15M16.5 10.5C15.7 10.5 15 11.2 15 12S15.7 13.5 16.5 13.5C17.3 13.5 18 12.8 18 12S17.3 10.5 16.5 10.5M16.5 6C15.7 6 15 6.7 15 7.5S15.7 9 16.5 9C17.3 9 18 8.3 18 7.5S17.3 6 16.5 6M7.5 10.5C6.7 10.5 6 11.2 6 12S6.7 13.5 7.5 13.5 9 12.8 9 12 8.3 10.5 7.5 10.5M7.5 15C6.7 15 6 15.7 6 16.5C6 17.3 6.7 18 7.5 18S9 17.3 9 16.5C9 15.7 8.3 15 7.5 15Z";
var mdiDiceD10 = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M14.07 8.21C15.5 8.21 16.64 9.36 16.64 10.78V13.42C16.64 14.84 15.5 16 14.07 16C12.64 16 11.5 14.84 11.5 13.42V10.78C11.5 9.36 12.65 8.21 14.07 8.21M10.36 8.41H10.5V16H9V10.21L7.22 10.76V9.53L10.36 8.41M14.06 9.65C13.47 9.65 13 10.13 13 10.71V13.5C13 14.07 13.47 14.54 14.06 14.54C14.64 14.54 15.14 14.06 15.14 13.5V10.71C15.14 10.12 14.64 9.65 14.06 9.65Z";
var mdiDiceD10Outline = "M10.5 16H9V10.21L7.22 10.76V9.53L10.36 8.41H10.5V16M14.07 8.21C15.5 8.21 16.64 9.36 16.64 10.78V13.42C16.64 14.84 15.5 16 14.07 16C12.64 16 11.5 14.84 11.5 13.42V10.78C11.5 9.36 12.65 8.21 14.07 8.21M14.06 9.65C13.47 9.65 13 10.13 13 10.71V13.5C13 14.07 13.47 14.54 14.06 14.54C14.64 14.54 15.14 14.06 15.14 13.5V10.71C15.14 10.12 14.64 9.65 14.06 9.65M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M12 4L20 12L12 20L4 12Z";
var mdiDiceD12 = "M12 2L1.5 9.64L5.5 22H18.5L22.5 9.64L12 2M10.5 17H8.89V10.89L7 11.47V10.19L10.31 9H10.5V17M17 17H11.66V15.91C11.66 15.91 15.23 12.45 15.23 11.4C15.23 10.12 14.18 10.25 14.18 10.25C13.5 10.3 13 10.87 13 11.55H11.44C11.5 10.09 12.72 8.94 14.27 9C16.74 9 16.77 10.85 16.77 11.3C16.77 13.07 13.58 15.77 13.58 15.77L17 15.75V17Z";
var mdiDiceD12Outline = "M12,2L1.5,9.64L5.5,22H18.5L22.5,9.64L12,2M17,20H7L3.85,10.4L12,4.47L20.15,10.4L17,20M17,15.75V17H11.66V15.91C11.66,15.91 15.23,12.45 15.23,11.4C15.23,10.12 14.18,10.25 14.18,10.25C13.5,10.3 13,10.87 13,11.55H11.44C11.5,10.09 12.72,8.94 14.27,9C16.74,9 16.77,10.85 16.77,11.3C16.77,13.07 13.58,15.77 13.58,15.77L17,15.75M10.5,17H8.89V10.89L7,11.47V10.19L10.31,9H10.5V17Z";
var mdiDiceD20 = "M20.47 6.62L12.57 2.18C12.41 2.06 12.21 2 12 2S11.59 2.06 11.43 2.18L3.53 6.62C3.21 6.79 3 7.12 3 7.5V16.5C3 16.88 3.21 17.21 3.53 17.38L11.43 21.82C11.59 21.94 11.79 22 12 22S12.41 21.94 12.57 21.82L20.47 17.38C20.79 17.21 21 16.88 21 16.5V7.5C21 7.12 20.79 6.79 20.47 6.62M11.45 15.96L6.31 15.93V14.91C6.31 14.91 9.74 11.58 9.75 10.57C9.75 9.33 8.73 9.46 8.73 9.46S7.75 9.5 7.64 10.71L6.14 10.76C6.14 10.76 6.18 8.26 8.83 8.26C11.2 8.26 11.23 10.04 11.23 10.5C11.23 12.18 8.15 14.77 8.15 14.77L11.45 14.76V15.96M17.5 13.5C17.5 14.9 16.35 16.05 14.93 16.05C13.5 16.05 12.36 14.9 12.36 13.5V10.84C12.36 9.42 13.5 8.27 14.93 8.27S17.5 9.42 17.5 10.84V13.5M16 10.77V13.53C16 14.12 15.5 14.6 14.92 14.6C14.34 14.6 13.86 14.12 13.86 13.53V10.77C13.86 10.18 14.34 9.71 14.92 9.71C15.5 9.71 16 10.18 16 10.77Z";
var mdiDiceD20Outline = "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15M14.93,8.27A2.57,2.57 0 0,1 17.5,10.84V13.5C17.5,14.9 16.35,16.05 14.93,16.05C13.5,16.05 12.36,14.9 12.36,13.5V10.84A2.57,2.57 0 0,1 14.93,8.27M14.92,9.71C14.34,9.71 13.86,10.18 13.86,10.77V13.53C13.86,14.12 14.34,14.6 14.92,14.6C15.5,14.6 16,14.12 16,13.53V10.77C16,10.18 15.5,9.71 14.92,9.71M11.45,14.76V15.96L6.31,15.93V14.91C6.31,14.91 9.74,11.58 9.75,10.57C9.75,9.33 8.73,9.46 8.73,9.46C8.73,9.46 7.75,9.5 7.64,10.71L6.14,10.76C6.14,10.76 6.18,8.26 8.83,8.26C11.2,8.26 11.23,10.04 11.23,10.5C11.23,12.18 8.15,14.77 8.15,14.77L11.45,14.76Z";
var mdiDiceD4 = "M10.25 15.15L11.92 12.47V15.15H10.25M21.92 21H2.08C1.24 21 .72 20.08 1.16 19.36L11.08 3.13C11.5 2.44 12.5 2.44 12.92 3.13L22.84 19.36C23.28 20.08 22.76 21 21.92 21M14.29 15.15H13.43V10.42H11.91L8.75 15.41L8.82 16.36H11.92V18H13.43V16.36H14.29V15.15Z";
var mdiDiceD4Outline = "M13.43,15.15H14.29V16.36H13.43V18H11.92V16.36H8.82L8.75,15.41L11.91,10.42H13.43V15.15M10.25,15.15H11.92V12.47L10.25,15.15M22,21H2C1.64,21 1.31,20.81 1.13,20.5C0.95,20.18 0.96,19.79 1.15,19.5L11.15,3C11.5,2.38 12.5,2.38 12.86,3L22.86,19.5C23.04,19.79 23.05,20.18 22.87,20.5C22.69,20.81 22.36,21 22,21M3.78,19H20.23L12,5.43L3.78,19Z";
var mdiDiceD6 = "M13.05 13.5C13.05 14.27 12.61 14.83 12 14.83S10.85 14.27 10.85 13.5L10.83 12.78C10.83 12.78 11.21 12 11.95 12.1C12.56 12.1 13.05 12.73 13.05 13.5M21 5V19C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H19C20.11 3 21 3.9 21 5M14.55 13.41C14.5 11.45 13.19 10.87 12.53 10.87C11.41 10.87 10.86 11.53 10.86 11.53S10.89 9.5 13.39 9.53V8.33C13.39 8.33 9.33 7.94 9.3 12.66C9.27 16.86 12.77 16 12.77 16S14.61 15.47 14.55 13.41Z";
var mdiDiceD6Outline = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5M13.39,9.53C10.89,9.5 10.86,11.53 10.86,11.53C10.86,11.53 11.41,10.87 12.53,10.87C13.19,10.87 14.5,11.45 14.55,13.41C14.61,15.47 12.77,16 12.77,16C12.77,16 9.27,16.86 9.3,12.66C9.33,7.94 13.39,8.33 13.39,8.33V9.53M11.95,12.1C11.21,12 10.83,12.78 10.83,12.78L10.85,13.5C10.85,14.27 11.39,14.83 12,14.83C12.61,14.83 13.05,14.27 13.05,13.5C13.05,12.73 12.56,12.1 11.95,12.1Z";
var mdiDiceD8 = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M12 8.25C13.31 8.25 14.38 9.2 14.38 10.38C14.38 11.07 14 11.68 13.44 12.07C14.14 12.46 14.6 13.13 14.6 13.9C14.6 15.12 13.44 16.1 12 16.1C10.56 16.1 9.4 15.12 9.4 13.9C9.4 13.13 9.86 12.46 10.56 12.07C10 11.68 9.63 11.07 9.63 10.38C9.63 9.2 10.69 8.25 12 8.25M12 9.5C11.5 9.5 11.1 9.95 11.1 10.5C11.1 11.05 11.5 11.5 12 11.5C12.5 11.5 12.9 11.05 12.9 10.5C12.9 9.95 12.5 9.5 12 9.5M12 12.65C11.39 12.65 10.9 13.14 10.9 13.75C10.9 14.36 11.39 14.85 12 14.85C12.61 14.85 13.1 14.36 13.1 13.75C13.1 13.14 12.61 12.65 12 12.65Z";
var mdiDiceD8Outline = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M12 4L20 12L12 20L4 12M12 8.25C13.31 8.25 14.38 9.2 14.38 10.38C14.38 11.07 14 11.68 13.44 12.07C14.14 12.46 14.6 13.13 14.6 13.9C14.6 15.12 13.44 16.1 12 16.1C10.56 16.1 9.4 15.12 9.4 13.9C9.4 13.13 9.86 12.46 10.56 12.07C10 11.68 9.63 11.07 9.63 10.38C9.63 9.2 10.69 8.25 12 8.25M12 12.65C11.39 12.65 10.9 13.14 10.9 13.75C10.9 14.36 11.39 14.85 12 14.85C12.61 14.85 13.1 14.36 13.1 13.75C13.1 13.14 12.61 12.65 12 12.65M12 9.5C11.5 9.5 11.1 9.95 11.1 10.5C11.1 11.05 11.5 11.5 12 11.5C12.5 11.5 12.9 11.05 12.9 10.5C12.9 9.95 12.5 9.5 12 9.5";
var mdiDiceMultiple = "M19.78,3H11.22C10.55,3 10,3.55 10,4.22V8H16V14H19.78C20.45,14 21,13.45 21,12.78V4.22C21,3.55 20.45,3 19.78,3M12.44,6.67C11.76,6.67 11.21,6.12 11.21,5.44C11.21,4.76 11.76,4.21 12.44,4.21A1.23,1.23 0 0,1 13.67,5.44C13.67,6.12 13.12,6.67 12.44,6.67M18.56,12.78C17.88,12.79 17.33,12.24 17.32,11.56C17.31,10.88 17.86,10.33 18.54,10.32C19.22,10.31 19.77,10.86 19.78,11.56C19.77,12.23 19.23,12.77 18.56,12.78M18.56,6.67C17.88,6.68 17.33,6.13 17.32,5.45C17.31,4.77 17.86,4.22 18.54,4.21C19.22,4.2 19.77,4.75 19.78,5.44C19.78,6.12 19.24,6.66 18.56,6.67M4.22,10H12.78A1.22,1.22 0 0,1 14,11.22V19.78C14,20.45 13.45,21 12.78,21H4.22C3.55,21 3,20.45 3,19.78V11.22C3,10.55 3.55,10 4.22,10M8.5,14.28C7.83,14.28 7.28,14.83 7.28,15.5C7.28,16.17 7.83,16.72 8.5,16.72C9.17,16.72 9.72,16.17 9.72,15.5A1.22,1.22 0 0,0 8.5,14.28M5.44,11.22C4.77,11.22 4.22,11.77 4.22,12.44A1.22,1.22 0 0,0 5.44,13.66C6.11,13.66 6.66,13.11 6.66,12.44V12.44C6.66,11.77 6.11,11.22 5.44,11.22M11.55,17.33C10.88,17.33 10.33,17.88 10.33,18.55C10.33,19.22 10.88,19.77 11.55,19.77A1.22,1.22 0 0,0 12.77,18.55H12.77C12.77,17.88 12.23,17.34 11.56,17.33H11.55Z";
var mdiDiceMultipleOutline = "M14 8C13.45 8 13 7.55 13 7S13.45 6 14 6C14.55 6 15 6.45 15 7C15 7.55 14.55 8 14 8M12 12V19H5V12H12M12.78 10H4.22C3.55 10 3 10.55 3 11.22V19.78C3 20.45 3.55 21 4.22 21H12.78C13.45 21 14 20.45 14 19.78V11.22C14 10.55 13.45 10 12.78 10M19.78 3H11.22C10.55 3 10 3.55 10 4.22V8H12V5H19V12H16V14H19.78C20.45 14 21 13.45 21 12.78V4.22C21 3.55 20.45 3 19.78 3M17 8C16.45 8 16 7.55 16 7S16.45 6 17 6C17.55 6 18 6.45 18 7C18 7.55 17.55 8 17 8M17 11C16.45 11 16 10.55 16 10S16.45 9 17 9C17.55 9 18 9.45 18 10C18 10.55 17.55 11 17 11M7 15C6.45 15 6 14.55 6 14S6.45 13 7 13C7.55 13 8 13.45 8 14C8 14.55 7.55 15 7 15M10 18C9.45 18 9 17.55 9 17S9.45 16 10 16C10.55 16 11 16.45 11 17C11 17.55 10.55 18 10 18";
var mdiDigitalOcean = "M6 12H2C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22V18H8V14H12V18C15.32 18 18 15.31 18 12C18 8.69 15.31 6 12 6C8.69 6 6 8.69 6 12M8 18V21H5V18H8M3 16H5V18H3V16Z";
var mdiDipSwitch = "M3,4H7A1,1 0 0,1 8,5V19A1,1 0 0,1 7,20H3A1,1 0 0,1 2,19V5A1,1 0 0,1 3,4M10,4H14A1,1 0 0,1 15,5V19A1,1 0 0,1 14,20H10A1,1 0 0,1 9,19V5A1,1 0 0,1 10,4M17,4H21A1,1 0 0,1 22,5V19A1,1 0 0,1 21,20H17A1,1 0 0,1 16,19V5A1,1 0 0,1 17,4M4,18H6V13H4V18M11,11H13V6H11V11M18,18H20V13H18V18Z";
var mdiDirections = "M14,14.5V12H10V15H8V11A1,1 0 0,1 9,10H14V7.5L17.5,11M21.71,11.29L12.71,2.29H12.7C12.31,1.9 11.68,1.9 11.29,2.29L2.29,11.29C1.9,11.68 1.9,12.32 2.29,12.71L11.29,21.71C11.68,22.09 12.31,22.1 12.71,21.71L21.71,12.71C22.1,12.32 22.1,11.68 21.71,11.29Z";
var mdiDirectionsFork = "M3,4V12.5L6,9.5L9,13C10,14 10,15 10,15V21H14V14C14,14 14,13 13.47,12C12.94,11 12,10 12,10L9,6.58L11.5,4M18,4L13.54,8.47L14,9C14,9 14.93,10 15.47,11C15.68,11.4 15.8,11.79 15.87,12.13L21,7";
var mdiDisc = "M12,14C10.89,14 10,13.1 10,12C10,10.89 10.89,10 12,10C13.11,10 14,10.89 14,12A2,2 0 0,1 12,14M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiDiscAlert = "M10 14C8.9 14 8 13.1 8 12C8 10.9 8.9 10 10 10C11.1 10 12 10.9 12 12S11.1 14 10 14M10 4C5.6 4 2 7.6 2 12S5.6 20 10 20 18 16.4 18 12 14.4 4 10 4M20 13H22V7H20M20 17H22V15H20V17Z";
var mdiDiscPlayer = "M14.5,10.37C15.54,10.37 16.38,9.53 16.38,8.5C16.38,7.46 15.54,6.63 14.5,6.63C13.46,6.63 12.63,7.46 12.63,8.5A1.87,1.87 0 0,0 14.5,10.37M14.5,1A7.5,7.5 0 0,1 22,8.5C22,10.67 21.08,12.63 19.6,14H9.4C7.93,12.63 7,10.67 7,8.5C7,4.35 10.36,1 14.5,1M6,21V22H4V21H2V15H22V21H20V22H18V21H6M4,18V19H13V18H4M15,17V19H17V17H15M19,17A1,1 0 0,0 18,18A1,1 0 0,0 19,19A1,1 0 0,0 20,18A1,1 0 0,0 19,17Z";
var mdiDishwasher = "M18,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V4A2,2 0 0,0 18,2M10,4A1,1 0 0,1 11,5A1,1 0 0,1 10,6A1,1 0 0,1 9,5A1,1 0 0,1 10,4M7,4A1,1 0 0,1 8,5A1,1 0 0,1 7,6A1,1 0 0,1 6,5A1,1 0 0,1 7,4M18,20H6V8H18V20M14.67,15.33C14.69,16.03 14.41,16.71 13.91,17.21C12.86,18.26 11.15,18.27 10.09,17.21C9.59,16.71 9.31,16.03 9.33,15.33C9.4,14.62 9.63,13.94 10,13.33C10.37,12.5 10.81,11.73 11.33,11L12,10C13.79,12.59 14.67,14.36 14.67,15.33";
var mdiDishwasherAlert = "M16 2H4C2.9 2 2 2.9 2 4V20C2 21.11 2.9 22 4 22H16C17.11 22 18 21.11 18 20V4C18 2.9 17.11 2 16 2M8 4C8.55 4 9 4.45 9 5S8.55 6 8 6 7 5.55 7 5 7.45 4 8 4M5 4C5.55 4 6 4.45 6 5S5.55 6 5 6 4 5.55 4 5 4.45 4 5 4M16 20H4V8H16V20M12.67 15.33C12.69 16.03 12.41 16.71 11.91 17.21C10.86 18.26 9.15 18.27 8.09 17.21C7.59 16.71 7.31 16.03 7.33 15.33C7.4 14.62 7.63 13.94 8 13.33C8.37 12.5 8.81 11.73 9.33 11L10 10C11.79 12.59 12.67 14.36 12.67 15.33M20 15H22V17H20V15M20 7H22V13H20V7Z";
var mdiDishwasherOff = "M22.11 21.46L2.39 1.73L1.11 3L4 5.89V20C4 21.11 4.89 22 6 22H18C18.58 22 19.1 21.75 19.46 21.35L20.84 22.73L22.11 21.46M18 20H6V8H6.11L10.5 12.37C10.31 12.69 10.15 13 10 13.33C9.63 13.94 9.4 14.62 9.33 15.33C9.31 16.03 9.59 16.71 10.09 17.21C11.15 18.27 12.86 18.26 13.91 17.21C14.16 16.97 14.35 16.68 14.5 16.36L18 19.89V20M11.2 8H18V14.8L20 16.8V4C20 2.9 19.11 2 18 2H6C5.76 2 5.54 2.05 5.33 2.13L11.2 8M10 4C10.55 4 11 4.45 11 5S10.55 6 10 6 9 5.55 9 5 9.45 4 10 4Z";
var mdiDisqus = "M12.08,22C9.63,22 7.39,21.11 5.66,19.63L1.41,20.21L3.05,16.15C2.5,14.88 2.16,13.5 2.16,12C2.16,6.5 6.6,2 12.08,2C17.56,2 22,6.5 22,12C22,17.5 17.56,22 12.08,22M17.5,11.97V11.94C17.5,9.06 15.46,7 11.95,7H8.16V17H11.9C15.43,17 17.5,14.86 17.5,11.97M12,14.54H10.89V9.46H12C13.62,9.46 14.7,10.39 14.7,12V12C14.7,13.63 13.62,14.54 12,14.54Z";
var mdiDistributeHorizontalCenter = "M8 2V5H10V19H8V22H6V19H4V5H6V2H8M16 2V7H14V17H16V22H18V17H20V7H18V2H16Z";
var mdiDistributeHorizontalLeft = "M21 7V17H16V22H14V2H16V7H21M5 2H3V22H5V19H10V5H5V2Z";
var mdiDistributeHorizontalRight = "M3 17V7H8V2H10V22H8V17H3M19 22H21V2H19V5H14V19H19V22Z";
var mdiDistributeVerticalBottom = "M7 3H17V8H22V10H2V8H7V3M2 19V21H22V19H19V14H5V19H2Z";
var mdiDistributeVerticalCenter = "M2 16H5V14H19V16H22V18H19V20H5V18H2V16M2 8H7V10H17V8H22V6H17V4H7V6H2V8Z";
var mdiDistributeVerticalTop = "M17 21H7V16H2V14H22V16H17V21M22 5V3H2V5H5V10H19V5H22Z";
var mdiDiversify = "M19 2V4H12C10.9 4 10 4.89 10 6V9H12V6H19V8L22 5L19 2M19 9V11H14V13H19V15L22 12L19 9M11.05 10C9.94 10 9.04 10.87 9.03 12S9.9 14 11 14C12.11 14 13 13.11 13 12C13 10.91 12.13 10.03 11.05 10M2 11V13H8V11H2M10 15V18C10 19.11 10.9 20 12 20H19V22L22 19L19 16V18H12V15H10Z";
var mdiDiving = "M13.26 5.2L13.3 5.18C13.72 4.82 14.35 4.88 14.71 5.3L16.97 8H20C20.55 8 21 8.45 21 9S20.55 10 20 10H16.5C16.15 10 15.85 9.82 15.67 9.56L14.17 7.77L11.64 10.13L14.57 12.18C14.83 12.36 15 12.66 15 13V17C15 17.55 14.55 18 14 18S13 17.55 13 17V13.5L9.77 11.26C8.82 10.6 8.74 9.23 9.6 8.46L13.26 5.2M16.5 5C17.34 5 18 4.33 18 3.5S17.34 2 16.5 2 15 2.67 15 3.5 15.68 5 16.5 5M6 19H5C3.34 19 2 20.34 2 22H6V20.5H15V19H6Z";
var mdiDivingFlippers = "M20.28,3.66C19.28,3.44 18.54,2.25 17.57,2.04C16.6,1.83 15.4,2.59 14.42,2.37C13.38,2 12.22,2.13 11.28,2.71L11.21,17L11,18C10.64,19.62 11.67,21.22 13.29,21.58C14.9,21.93 16.5,20.91 16.86,19.29L17.07,18.29L23,5.28C22.39,4.35 21.39,3.76 20.28,3.66M14.91,18.86C14.79,19.41 14.25,19.76 13.7,19.65C13.14,19.53 12.79,19 12.91,18.43L13.77,14.5C13.86,13.97 14.37,13.6 14.92,13.69C15.46,13.78 15.83,14.3 15.74,14.84C15.74,14.88 15.73,14.91 15.72,14.95L14.91,18.86M9.72,21.34C9.33,20.73 9.08,20.05 9,19.34L8.24,16C8.1,15.47 8.41,14.92 9,14.76C9.07,14.75 9.15,14.75 9.22,14.76V3.43C8.31,3.43 7.22,2.86 6.38,3.06C5.54,3.26 4.69,4.44 3.72,4.66C2.61,4.76 1.61,5.35 1,6.28L6.93,19.28L7.14,20.28C7.5,21.9 9.09,22.92 10.71,22.57H10.81C10.38,22.22 10,21.81 9.72,21.34Z";
var mdiDivingHelmet = "M16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8A4,4 0 0,1 16,12M19.45,7.89L18.07,8.58L18.32,9H20V15H18.33C17.84,16.03 17.11,16.92 16.21,17.6C17.85,18.11 19.1,18.91 19.67,19.86C18.69,21.1 15.62,22 12,22C8.38,22 5.31,21.1 4.33,19.86C4.9,18.91 6.15,18.11 7.79,17.6C6.89,16.92 6.16,16.03 5.67,15H4V9H5.68C6.37,7.54 7.54,6.37 9,5.68V4H15V5.68C15.68,6 16.29,6.46 16.82,7L18.55,6.14C19.93,5.42 20,4.1 20,2H22C22,4.06 22,6.62 19.45,7.89M17,12A5,5 0 0,0 12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12Z";
var mdiDivingScuba = "M1 13C1 11.9 1.9 11 3 11S5 11.9 5 13 4.1 15 3 15 1 14.1 1 13M8.89 10.11L13.42 8.9L12.64 6L8.11 7.21C7.31 7.42 6.83 8.25 7.05 9.05C7.27 9.85 8.09 10.33 8.89 10.11M20.5 5.9L23 3L22 2L19 5L17 9L7.5 11.87C6.7 12.07 6.13 12.76 6 13.55L5.24 18L2.4 21.8L4 23L7 19L8.14 15.86L14 14L19 10.5L20.5 5.9Z";
var mdiDivingScubaFlag = "M2,6L19,20H2V6M5,4L22,18V4H5Z";
var mdiDivingScubaMask = "M12,15C13.31,15 14.42,15.83 14.83,17H18A4,4 0 0,1 22,21V22H20V21A2,2 0 0,0 18,19H14.83C14.42,20.17 13.31,21 12,21A3,3 0 0,1 9,18A3,3 0 0,1 12,15M12,17A1,1 0 0,0 11,18A1,1 0 0,0 12,19A1,1 0 0,0 13,18A1,1 0 0,0 12,17M18,3A2,2 0 0,1 20,5V10A2,2 0 0,1 18,12H14.85C14.43,12 14.05,12.24 13.9,12.63C13.7,13.23 13.23,13.71 12.62,13.91C11.58,14.25 10.44,13.68 10.1,12.63C9.95,12.24 9.57,12 9.15,12H6A2,2 0 0,1 4,10V5A2,2 0 0,1 6,3H18M18,10V5H6V10H10.65C10.9,9.46 11.41,9.09 12,9C12.59,9.09 13.1,9.46 13.35,10H18Z";
var mdiDivingScubaTank = "M19,18.5A2.5,2.5 0 0,1 16.5,21A2.5,2.5 0 0,1 14,18.5C14,17.47 14.62,16.59 15.5,16.21V6H11V7.35C12.22,7.93 13,9.15 13,10.5V22H6V10.5C6,9.15 6.78,7.93 8,7.35V6H6V4H8V3.5A1.5,1.5 0 0,1 9.5,2A1.5,1.5 0 0,1 11,3.5V4H15.5A2,2 0 0,1 17.5,6V16.21C18.38,16.59 19,17.47 19,18.5Z";
var mdiDivingScubaTankMultiple = "M22,18.5A2.5,2.5 0 0,1 19.5,21A2.5,2.5 0 0,1 17,18.5C17,17.47 17.62,16.59 18.5,16.21V6H14V7.35C15.22,7.93 16,9.15 16,10.5V22H2V10.5C2,9.15 2.78,7.93 4,7.35V6H2V4H4V3.5A1.5,1.5 0 0,1 5.5,2A1.5,1.5 0 0,1 7,3.5V4H11V3.5A1.5,1.5 0 0,1 12.5,2A1.5,1.5 0 0,1 14,3.5V4H18.5A2,2 0 0,1 20.5,6V16.21C21.38,16.59 22,17.47 22,18.5M11,7.35V6H7V7.35C8.22,7.93 9,9.15 9,10.5C9,9.15 9.78,7.93 11,7.35Z";
var mdiDivingSnorkel = "M16,3H4A2,2 0 0,0 2,5V10A2,2 0 0,0 4,12H7.15C7.57,12 7.95,12.24 8.1,12.63C8.44,13.68 9.58,14.25 10.62,13.91C11.23,13.71 11.7,13.23 11.9,12.63C12.05,12.24 12.43,12 12.85,12H16A2,2 0 0,0 18,10V5A2,2 0 0,0 16,3M16,10H11.35C11.1,9.46 10.59,9.09 10,9C9.41,9.09 8.9,9.46 8.65,10H4V5H16V10M22,2V15.5A6.5,6.5 0 0,1 15.5,22C13.79,22 12.15,21.32 10.93,20.12C8.95,20.58 6.88,19.79 5.71,18.12L7.62,17.29C8.5,18.22 9.84,18.5 11,18C11.2,17.91 11.39,17.8 11.56,17.67C12.4,17.05 12.87,16.04 12.78,15L14.69,14.17C15.1,16.04 14.41,18 12.9,19.17C13.66,19.71 14.57,20 15.5,20C18,20 20,18 20,15.5V2H22Z";
var mdiDivision = "M19,13H5V11H19V13M12,5A2,2 0 0,1 14,7A2,2 0 0,1 12,9A2,2 0 0,1 10,7A2,2 0 0,1 12,5M12,15A2,2 0 0,1 14,17A2,2 0 0,1 12,19A2,2 0 0,1 10,17A2,2 0 0,1 12,15Z";
var mdiDivisionBox = "M17,13V11H7V13H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M12,7A1,1 0 0,0 11,8A1,1 0 0,0 12,9A1,1 0 0,0 13,8A1,1 0 0,0 12,7M12,15A1,1 0 0,0 11,16A1,1 0 0,0 12,17A1,1 0 0,0 13,16A1,1 0 0,0 12,15Z";
var mdiDlna = "M21.38,12.56H12.85C11.97,12.56 11.1,12.96 10.61,13.61V13.6C10.12,14.28 9.32,14.72 8.41,14.72C6.92,14.72 5.71,13.5 5.71,12C5.71,10.5 6.92,9.31 8.41,9.31C9.32,9.31 10.12,9.75 10.61,10.43V10.42C11.1,11.07 11.97,11.5 12.85,11.5H21.29C21.45,11.5 22,11.4 22,10.67C21.26,6.43 17.1,3.18 12.06,3.18C8.96,3.18 6.19,4.41 4.34,6.35C4.05,6.79 4.35,6.92 4.63,6.96H10.14C11,6.96 11.89,6.54 12.38,5.89V5.91C12.88,5.23 13.67,4.78 14.58,4.78C16.07,4.78 17.28,6 17.28,7.5C17.28,9 16.07,10.2 14.58,10.2C13.67,10.2 12.88,9.75 12.38,9.07V9.08C11.89,8.44 11,8.03 10.14,8.03H4.13L4.15,8.03C4.15,8.03 3.26,8 2.72,8.75C2.3,9.42 2,10.85 2,12C2,13.16 2.17,14.21 2.72,15.27C3.19,16.03 4.15,16 4.15,16H4.11L10.14,16C11,16 11.89,15.58 12.38,14.93V14.94C12.88,14.26 13.67,13.81 14.58,13.81C16.07,13.81 17.28,15.03 17.28,16.5C17.28,18 16.07,19.23 14.58,19.23C13.67,19.23 12.88,18.78 12.38,18.1V18.12C11.89,17.47 11,17.05 10.14,17.05H4.64C4.36,17.09 4.06,17.22 4.32,17.64C6.17,19.58 8.95,20.82 12.06,20.82C17.11,20.82 21.28,17.57 22,13.31C22,12.72 21.59,12.58 21.38,12.56";
var mdiDna = "M4,2H6V4C6,5.44 6.68,6.61 7.88,7.78C8.74,8.61 9.89,9.41 11.09,10.2L9.26,11.39C8.27,10.72 7.31,10 6.5,9.21C5.07,7.82 4,6.1 4,4V2M18,2H20V4C20,6.1 18.93,7.82 17.5,9.21C16.09,10.59 14.29,11.73 12.54,12.84C10.79,13.96 9.09,15.05 7.88,16.22C6.68,17.39 6,18.56 6,20V22H4V20C4,17.9 5.07,16.18 6.5,14.79C7.91,13.41 9.71,12.27 11.46,11.16C13.21,10.04 14.91,8.95 16.12,7.78C17.32,6.61 18,5.44 18,4V2M14.74,12.61C15.73,13.28 16.69,14 17.5,14.79C18.93,16.18 20,17.9 20,20V22H18V20C18,18.56 17.32,17.39 16.12,16.22C15.26,15.39 14.11,14.59 12.91,13.8L14.74,12.61M7,3H17V4L16.94,4.5H7.06L7,4V3M7.68,6H16.32C16.08,6.34 15.8,6.69 15.42,7.06L14.91,7.5H9.07L8.58,7.06C8.2,6.69 7.92,6.34 7.68,6M9.09,16.5H14.93L15.42,16.94C15.8,17.31 16.08,17.66 16.32,18H7.68C7.92,17.66 8.2,17.31 8.58,16.94L9.09,16.5M7.06,19.5H16.94L17,20V21H7V20L7.06,19.5Z";
var mdiDns = "M7,9A2,2 0 0,1 5,7A2,2 0 0,1 7,5A2,2 0 0,1 9,7A2,2 0 0,1 7,9M20,3H4A1,1 0 0,0 3,4V10A1,1 0 0,0 4,11H20A1,1 0 0,0 21,10V4A1,1 0 0,0 20,3M7,19A2,2 0 0,1 5,17A2,2 0 0,1 7,15A2,2 0 0,1 9,17A2,2 0 0,1 7,19M20,13H4A1,1 0 0,0 3,14V20A1,1 0 0,0 4,21H20A1,1 0 0,0 21,20V14A1,1 0 0,0 20,13Z";
var mdiDnsOutline = "M19,15V19H5V15H19M20,13H4A1,1 0 0,0 3,14V20A1,1 0 0,0 4,21H20A1,1 0 0,0 21,20V14A1,1 0 0,0 20,13M7,18.5A1.5,1.5 0 0,1 5.5,17A1.5,1.5 0 0,1 7,15.5A1.5,1.5 0 0,1 8.5,17A1.5,1.5 0 0,1 7,18.5M19,5V9H5V5H19M20,3H4A1,1 0 0,0 3,4V10A1,1 0 0,0 4,11H20A1,1 0 0,0 21,10V4A1,1 0 0,0 20,3M7,8.5A1.5,1.5 0 0,1 5.5,7A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 8.5,7A1.5,1.5 0 0,1 7,8.5Z";
var mdiDockBottom = "M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V6A2 2 0 0 0 20 4M20 13H4V6H20Z";
var mdiDockLeft = "M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V6A2 2 0 0 0 20 4M20 18H9V6H20Z";
var mdiDockRight = "M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V6A2 2 0 0 0 20 4M15 18H4V6H15Z";
var mdiDockTop = "M4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20M4 11H20V18H4V11Z";
var mdiDockWindow = "M18 18V20H4A2 2 0 0 1 2 18V8H4V18M22 6V14A2 2 0 0 1 20 16H8A2 2 0 0 1 6 14V6A2 2 0 0 1 8 4H20A2 2 0 0 1 22 6M20 6H8V14H20Z";
var mdiDocker = "M21.81 10.25C21.75 10.21 21.25 9.82 20.17 9.82C19.89 9.82 19.61 9.85 19.33 9.9C19.12 8.5 17.95 7.79 17.9 7.76L17.61 7.59L17.43 7.86C17.19 8.22 17 8.63 16.92 9.05C16.72 9.85 16.84 10.61 17.25 11.26C16.76 11.54 15.96 11.61 15.79 11.61H2.62C2.28 11.61 2 11.89 2 12.24C2 13.39 2.18 14.54 2.58 15.62C3.03 16.81 3.71 17.69 4.58 18.23C5.56 18.83 7.17 19.17 9 19.17C9.79 19.17 10.61 19.1 11.42 18.95C12.54 18.75 13.62 18.36 14.61 17.79C15.43 17.32 16.16 16.72 16.78 16C17.83 14.83 18.45 13.5 18.9 12.35H19.09C20.23 12.35 20.94 11.89 21.33 11.5C21.59 11.26 21.78 10.97 21.92 10.63L22 10.39L21.81 10.25M3.85 11.24H5.61C5.69 11.24 5.77 11.17 5.77 11.08V9.5C5.77 9.42 5.7 9.34 5.61 9.34H3.85C3.76 9.34 3.69 9.41 3.69 9.5V11.08C3.7 11.17 3.76 11.24 3.85 11.24M6.28 11.24H8.04C8.12 11.24 8.2 11.17 8.2 11.08V9.5C8.2 9.42 8.13 9.34 8.04 9.34H6.28C6.19 9.34 6.12 9.41 6.12 9.5V11.08C6.13 11.17 6.19 11.24 6.28 11.24M8.75 11.24H10.5C10.6 11.24 10.67 11.17 10.67 11.08V9.5C10.67 9.42 10.61 9.34 10.5 9.34H8.75C8.67 9.34 8.6 9.41 8.6 9.5V11.08C8.6 11.17 8.66 11.24 8.75 11.24M11.19 11.24H12.96C13.04 11.24 13.11 11.17 13.11 11.08V9.5C13.11 9.42 13.05 9.34 12.96 9.34H11.19C11.11 9.34 11.04 9.41 11.04 9.5V11.08C11.04 11.17 11.11 11.24 11.19 11.24M6.28 9H8.04C8.12 9 8.2 8.91 8.2 8.82V7.25C8.2 7.16 8.13 7.09 8.04 7.09H6.28C6.19 7.09 6.12 7.15 6.12 7.25V8.82C6.13 8.91 6.19 9 6.28 9M8.75 9H10.5C10.6 9 10.67 8.91 10.67 8.82V7.25C10.67 7.16 10.61 7.09 10.5 7.09H8.75C8.67 7.09 8.6 7.15 8.6 7.25V8.82C8.6 8.91 8.66 9 8.75 9M11.19 9H12.96C13.04 9 13.11 8.91 13.11 8.82V7.25C13.11 7.16 13.04 7.09 12.96 7.09H11.19C11.11 7.09 11.04 7.15 11.04 7.25V8.82C11.04 8.91 11.11 9 11.19 9M11.19 6.72H12.96C13.04 6.72 13.11 6.65 13.11 6.56V5C13.11 4.9 13.04 4.83 12.96 4.83H11.19C11.11 4.83 11.04 4.89 11.04 5V6.56C11.04 6.64 11.11 6.72 11.19 6.72M13.65 11.24H15.41C15.5 11.24 15.57 11.17 15.57 11.08V9.5C15.57 9.42 15.5 9.34 15.41 9.34H13.65C13.57 9.34 13.5 9.41 13.5 9.5V11.08C13.5 11.17 13.57 11.24 13.65 11.24";
var mdiDoctor = "M14.84,16.26C17.86,16.83 20,18.29 20,20V22H4V20C4,18.29 6.14,16.83 9.16,16.26L12,21L14.84,16.26M8,8H16V10A4,4 0 0,1 12,14A4,4 0 0,1 8,10V8M8,7L8.41,2.9C8.46,2.39 8.89,2 9.41,2H14.6C15.11,2 15.54,2.39 15.59,2.9L16,7H8M12,3H11V4H10V5H11V6H12V5H13V4H12V3Z";
var mdiDog = "M18,4C16.29,4 15.25,4.33 14.65,4.61C13.88,4.23 13,4 12,4C11,4 10.12,4.23 9.35,4.61C8.75,4.33 7.71,4 6,4C3,4 1,12 1,14C1,14.83 2.32,15.59 4.14,15.9C4.78,18.14 7.8,19.85 11.5,20V15.72C10.91,15.35 10,14.68 10,14C10,13 12,13 12,13C12,13 14,13 14,14C14,14.68 13.09,15.35 12.5,15.72V20C16.2,19.85 19.22,18.14 19.86,15.9C21.68,15.59 23,14.83 23,14C23,12 21,4 18,4M4.15,13.87C3.65,13.75 3.26,13.61 3,13.5C3.25,10.73 5.2,6.4 6.05,6C6.59,6 7,6.06 7.37,6.11C5.27,8.42 4.44,12.04 4.15,13.87M9,12A1,1 0 0,1 8,11C8,10.46 8.45,10 9,10A1,1 0 0,1 10,11C10,11.56 9.55,12 9,12M15,12A1,1 0 0,1 14,11C14,10.46 14.45,10 15,10A1,1 0 0,1 16,11C16,11.56 15.55,12 15,12M19.85,13.87C19.56,12.04 18.73,8.42 16.63,6.11C17,6.06 17.41,6 17.95,6C18.8,6.4 20.75,10.73 21,13.5C20.75,13.61 20.36,13.75 19.85,13.87Z";
var mdiDogService = "M14,8L17,11V21H15V15H8L6,18V21H4V15L5,14V11L2,8L3,7L5,9H7V12A1,1 0 0,0 8,13H12A1,1 0 0,0 13,12V9L14,8M19,5V3L15,7L18,10L19,9L20,10L22,8L19,5M11.5,9.5L4.5,2.5C4.23,2.22 3.79,2.22 3.5,2.5V2.5C3.22,2.77 3.22,3.21 3.5,3.5L10.5,10.5C10.77,10.78 11.21,10.78 11.5,10.5V10.5C11.78,10.23 11.78,9.79 11.5,9.5Z";
var mdiDogSide = "M19,3L15,7L18,10L19,9L20,10L22,8L19,5V3M3,7L2,8L5,11V14L4,15V21H6V18L8,15H15V21H17V11L14,8L13,9H5L3,7Z";
var mdiDogSideOff = "M18 10L15 7L19 3V5L22 8L20 10L19 9L18 10M17 11L14 8L13 9H12.2L17 13.8V11M2.39 1.73L1.11 3L7.11 9H5L3 7L2 8L5 11V14L4 15V21H6V18L8 15H13.11L15 16.89V21H17V18.89L20.84 22.73L22.11 21.46L2.39 1.73Z";
var mdiDolby = "M2,5V19H22V5H2M6,17H4V7H6C8.86,7.09 11.1,9.33 11,12C11.1,14.67 8.86,16.91 6,17M20,17H18C15.14,16.91 12.9,14.67 13,12C12.9,9.33 15.14,7.09 18,7H20V17Z";
var mdiDolly = "M11.97,19.88C10.93,20.26 9.78,19.72 9.4,18.69C9,17.65 9.55,16.5 10.59,16.13C11.63,15.75 12.78,16.28 13.16,17.31C13.54,18.35 13,19.5 11.97,19.88M9.9,14.25C7.83,15 6.76,17.3 7.5,19.38C8.28,21.45 10.58,22.5 12.66,21.75C14.73,21 15.79,18.7 15.04,16.63C14.28,14.55 11.97,13.5 9.9,14.25M15.94,4.58L9.37,7L10.75,10.74L17.32,8.33M20.32,13.62L15.54,15.37C15.71,15.66 15.85,15.96 15.97,16.28C16.09,16.6 16.17,16.93 16.22,17.25L21,15.5M19.54,8.58L11.09,11.68L11.58,13C12.83,13.09 14,13.64 14.89,14.55L20.92,12.34M2,2V4H5.09L8.66,13.75C8.94,13.57 9.24,13.43 9.56,13.31C9.88,13.19 10.21,13.11 10.53,13.06L6.5,2";
var mdiDolphin = "M20 7C20 7 20 3 15 3C13.47 3 12.15 3.19 11 3.5C10.5 3.06 7.26 .309 4 3.57L6.56 6.13C2.5 10.53 4 18 4 18S1 18 1 22C1 22 5 21 5 21C5 21 9 22 9 22C9 18 6 18 6 18S6.85 12.24 13 11.18V14C15 14 15.68 12.19 15.89 11H18C22 11 23 10 23 9S21 7 20 7M18 8C17.45 8 17 7.55 17 7S17.45 6 18 6 19 6.45 19 7 18.55 8 18 8Z";
var mdiDomain = "M18,15H16V17H18M18,11H16V13H18M20,19H12V17H14V15H12V13H14V11H12V9H20M10,7H8V5H10M10,11H8V9H10M10,15H8V13H10M10,19H8V17H10M6,7H4V5H6M6,11H4V9H6M6,15H4V13H6M6,19H4V17H6M12,7V3H2V21H22V7H12Z";
var mdiDomainOff = "M12,19H16L14,17H12V19M10,15V13H8V15H10M10,19V17H8V19H10M6,11V9H4V11H6M6,15V13H4V15H6M6,19V17H4V19H6M1.31,1.78L22.31,22.69L21,24L18,21H2V5L0.09,3.09L1.31,1.78M16,11H18V13H16V11M8,5V5.91L5.11,3H12V7H22V19.92L20,17.91V9H12V9.89L9.09,7H10V5H8Z";
var mdiDomainPlus = "M12 7V3H2V21H13.35A5.8 5.8 0 0 1 13 19H12V17H13.35A5 5 0 0 1 14 15.69V15H12V13H14V11H12V9H20V13.09A5.58 5.58 0 0 1 22 13.81V7M6 19H4V17H6M6 15H4V13H6M6 11H4V9H6M6 7H4V5H6M10 19H8V17H10M10 15H8V13H10M10 11H8V9H10M10 7H8V5H10M16 13H18V11H16M16 11V13H18V11M16 11V13H18V11M20 15V18H23V20H20V23H18V20H15V18H18V15Z";
var mdiDomainRemove = "M12 7V3H2V21H13.35A5.8 5.8 0 0 1 13 19H12V17H13.35A5 5 0 0 1 14 15.69V15H12V13H14V11H12V9H20V13.09A5.58 5.58 0 0 1 22 13.81V7M6 19H4V17H6M6 15H4V13H6M6 11H4V9H6M6 7H4V5H6M10 19H8V17H10M10 15H8V13H10M10 11H8V9H10M10 7H8V5H10M16 13H18V11H16M16 11V13H18V11M16 11V13H18V11M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.46 21.12L17.59 19L15.46 16.88L16.88 15.46L19 17.59L21.12 15.46Z";
var mdiDomainSwitch = "M16 9H18V11H16V9M22 15V5H12V1H2V15H22M20 13H12V11H14V9H12V7H20V13M8 5V3H10V5H8M8 9V7H10V9H8M8 13V11H10V13H8M4 5V3H6V5H4M4 9V7H6V9H4M4 13V11H6V13H4M9 17V19H15V17L18 20L15 23V21H9V23L6 20L9 17Z";
var mdiDomeLight = "M21 10C21 14.97 16.97 19 12 19C7.03 19 3 14.97 3 10V9.03C3 8.76 3.11 8.5 3.3 8.3C3.5 8.11 3.76 8 4.03 8H20C20.25 8 20.5 8.11 20.7 8.3C20.89 8.5 21 8.75 21 9V10M5 10C5 13.86 8.14 17 12 17C15.86 17 19 13.86 19 10H5M20 6V7H4V6C4 5.73 4.1 5.5 4.29 5.29C4.5 5.1 4.73 5 5 5H10V3H14V5H19C19.25 5 19.5 5.11 19.7 5.3C19.89 5.5 20 5.75 20 6Z";
var mdiDominoMask = "M15.83 9.81C14.7 9.7 13.69 10.38 13.46 11.5C13.46 11.84 14.81 12.29 16.05 12.29C17.29 12.29 18.41 11.5 18.41 11.28C18.41 11.05 17.63 9.93 15.83 9.81M8.18 9.81C6.38 9.93 5.59 10.94 5.59 11.27C5.59 11.5 6.82 12.29 7.95 12.29S10.54 11.84 10.54 11.5C10.31 10.38 9.19 9.7 8.18 9.81M16.95 16C15.04 16 13.8 13.75 12 13.75S8.85 16 7.05 16C4.69 16 3 13.86 3 10.04C3 7.68 3.68 7 6.71 7S10.54 8.24 12 8.24 14.36 7 17.29 7 21 7.79 21 10.04C21 13.86 19.31 16 16.95 16Z";
var mdiDonkey = "M21.34,10.35L21.27,10.28L21.18,10.19L18,7V6A0.5,0.5 0 0,0 17.5,5.5C17.36,5.5 17.22,5.56 17.13,5.66L13.46,9H7C6.32,9 5.69,9.35 5.32,9.92L2.62,12.59C2.29,13.04 2.39,13.66 2.84,14C3.18,14.24 3.65,14.25 4,14L5,13.07V19H8V15H13V19H16V13.83C16,13.3 16.21,12.79 16.59,12.42L18,11L20,12V12C20.15,12.08 20.32,12.13 20.5,12.13C21.1,12.11 21.59,11.61 21.58,11C21.57,10.76 21.5,10.53 21.34,10.35Z";
var mdiDoor = "M8,3C6.89,3 6,3.89 6,5V21H18V5C18,3.89 17.11,3 16,3H8M8,5H16V19H8V5M13,11V13H15V11H13Z";
var mdiDoorClosed = "M16,11H18V13H16V11M12,3H19C20.11,3 21,3.89 21,5V19H22V21H2V19H10V5C10,3.89 10.89,3 12,3M12,5V19H19V5H12Z";
var mdiDoorClosedCancel = "M6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11M3.92 5L8 9.09C7.58 9.35 7.06 9.5 6.5 9.5C4.84 9.5 3.5 8.16 3.5 6.5C3.5 5.94 3.65 5.42 3.92 5M9.5 6.5C9.5 7.06 9.35 7.58 9.09 8L5 3.92C5.42 3.65 5.94 3.5 6.5 3.5C8.16 3.5 9.5 4.84 9.5 6.5M10 12C10.81 11.46 11.5 10.77 12 9.97V19H19V5H12.83C12.66 4.28 12.37 3.61 12 3H19C20.11 3 21 3.89 21 5V19H22V21H2V19H10V12M16 11H18V13H16V11Z";
var mdiDoorClosedLock = "M16 11H18V13H16V11M12 3H19A2 2 0 0 1 21 5V19H22V21H2V19H10V5A2 2 0 0 1 12 3M12 5V19H19V5M6.2 5H2.8V4.5A1.7 1.7 0 0 1 6.2 4.5M7 5V4.5A2.5 2.5 0 0 0 2 4.5V5A1 1 0 0 0 1 6V10A1 1 0 0 0 2 11H7A1 1 0 0 0 8 10V6A1 1 0 0 0 7 5";
var mdiDoorOpen = "M12,3C10.89,3 10,3.89 10,5H3V19H2V21H22V19H21V5C21,3.89 20.11,3 19,3H12M12,5H19V19H12V5M5,11H7V13H5V11Z";
var mdiDoorSliding = "M10 13H8V11H10V13M16 11H14V13H16V11M21 19V21H3V19H4V5C4 3.9 4.9 3 6 3H18C19.1 3 20 3.9 20 5V19H21M11 5H6V19H11V5M18 5H13V19H18V5Z";
var mdiDoorSlidingLock = "M21.8 17V15.5C21.8 14.1 20.4 13 19 13S16.2 14.1 16.2 15.5V17C15.6 17 15 17.6 15 18.2V21.7C15 22.4 15.6 23 16.2 23H21.7C22.4 23 23 22.4 23 21.8V18.3C23 17.6 22.4 17 21.8 17M20.5 17H17.5V15.5C17.5 14.7 18.2 14.2 19 14.2S20.5 14.7 20.5 15.5V17M13 11H15V13H13V11M9 13H7V11H9V13M13 19H12V5H17V11.44C17.61 11.17 18.29 11 19 11V5C19 3.9 18.1 3 17 3H5C3.9 3 3 3.9 3 5V19H2V21H13V19M10 19H5V5H10V19Z";
var mdiDoorSlidingOpen = "M6 11V13H4V11H6M22 5H17V19H22V5M7 5H2L2 19H7V5M22 3C23.11 3 24 3.89 24 5V21H0V5C0 3.89 .894 3 2 3H9V19H15V3H22M20 11H18V13H20V11Z";
var mdiDoorbell = "M12 10C10.9 10 10 10.9 10 12S10.9 14 12 14 14 13.1 14 12 13.1 10 12 10M16 2H8C6.9 2 6 2.9 6 4V20C6 21.1 6.9 22 8 22H16C17.1 22 18 21.1 18 20V4C18 2.9 17.1 2 16 2M16 20H8V4H16V20Z";
var mdiDoorbellVideo = "M14 15C14 16.11 13.11 17 12 17S10 16.11 10 15 10.9 13 12 13 14 13.9 14 15M18 4V20C18 21.1 17.11 22 16 22H8C6.9 22 6 21.11 6 20V4C6 2.9 6.9 2 8 2H16C17.11 2 18 2.9 18 4M10.5 7C10.5 7.83 11.17 8.5 12 8.5S13.5 7.83 13.5 7 12.83 5.5 12 5.5 10.5 6.17 10.5 7M16 10H8V20H16V10Z";
var mdiDotNet = "M2,15A1,1 0 0,1 3,16A1,1 0 0,1 2,17A1,1 0 0,1 1,16A1,1 0 0,1 2,15M21,17H19V9H17V7H23V9H21V17M16,7V9H14V11H16V13H14V15H16V17H12V7H16M11,7V17H9L6,11V17H4V7H6L9,13V7H11Z";
var mdiDotsCircle = "M12 19C13.1 19 14 19.9 14 21S13.1 23 12 23 10 22.1 10 21 10.9 19 12 19M12 1C13.1 1 14 1.9 14 3S13.1 5 12 5 10 4.1 10 3 10.9 1 12 1M6 16C7.1 16 8 16.9 8 18S7.1 20 6 20 4 19.1 4 18 4.9 16 6 16M3 10C4.1 10 5 10.9 5 12S4.1 14 3 14 1 13.1 1 12 1.9 10 3 10M6 4C7.1 4 8 4.9 8 6S7.1 8 6 8 4 7.1 4 6 4.9 4 6 4M18 16C19.1 16 20 16.9 20 18S19.1 20 18 20 16 19.1 16 18 16.9 16 18 16M21 10C22.1 10 23 10.9 23 12S22.1 14 21 14 19 13.1 19 12 19.9 10 21 10M18 4C19.1 4 20 4.9 20 6S19.1 8 18 8 16 7.1 16 6 16.9 4 18 4Z";
var mdiDotsGrid = "M12 16C13.1 16 14 16.9 14 18S13.1 20 12 20 10 19.1 10 18 10.9 16 12 16M12 10C13.1 10 14 10.9 14 12S13.1 14 12 14 10 13.1 10 12 10.9 10 12 10M12 4C13.1 4 14 4.9 14 6S13.1 8 12 8 10 7.1 10 6 10.9 4 12 4M6 16C7.1 16 8 16.9 8 18S7.1 20 6 20 4 19.1 4 18 4.9 16 6 16M6 10C7.1 10 8 10.9 8 12S7.1 14 6 14 4 13.1 4 12 4.9 10 6 10M6 4C7.1 4 8 4.9 8 6S7.1 8 6 8 4 7.1 4 6 4.9 4 6 4M18 16C19.1 16 20 16.9 20 18S19.1 20 18 20 16 19.1 16 18 16.9 16 18 16M18 10C19.1 10 20 10.9 20 12S19.1 14 18 14 16 13.1 16 12 16.9 10 18 10M18 4C19.1 4 20 4.9 20 6S19.1 8 18 8 16 7.1 16 6 16.9 4 18 4Z";
var mdiDotsHexagon = "M16 12C16 10.9 16.9 10 18 10S20 10.9 20 12 19.1 14 18 14 16 13.1 16 12M10 12C10 10.9 10.9 10 12 10S14 10.9 14 12 13.1 14 12 14 10 13.1 10 12M4 12C4 10.9 4.9 10 6 10S8 10.9 8 12 7.1 14 6 14 4 13.1 4 12M13 18C13 16.9 13.9 16 15 16S17 16.9 17 18 16.1 20 15 20 13 19.1 13 18M7 18C7 16.9 7.9 16 9 16S11 16.9 11 18 10.1 20 9 20 7 19.1 7 18M13 6C13 4.9 13.9 4 15 4S17 4.9 17 6 16.1 8 15 8 13 7.1 13 6M7 6C7 4.9 7.9 4 9 4S11 4.9 11 6 10.1 8 9 8 7 7.1 7 6";
var mdiDotsHorizontal = "M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z";
var mdiDotsHorizontalCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5M6.5,10.5A1.5,1.5 0 0,0 5,12A1.5,1.5 0 0,0 6.5,13.5A1.5,1.5 0 0,0 8,12A1.5,1.5 0 0,0 6.5,10.5M17.5,10.5A1.5,1.5 0 0,0 16,12A1.5,1.5 0 0,0 17.5,13.5A1.5,1.5 0 0,0 19,12A1.5,1.5 0 0,0 17.5,10.5Z";
var mdiDotsHorizontalCircleOutline = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M12,10.5A1.5,1.5 0 0,1 13.5,12A1.5,1.5 0 0,1 12,13.5A1.5,1.5 0 0,1 10.5,12A1.5,1.5 0 0,1 12,10.5M7.5,10.5A1.5,1.5 0 0,1 9,12A1.5,1.5 0 0,1 7.5,13.5A1.5,1.5 0 0,1 6,12A1.5,1.5 0 0,1 7.5,10.5M16.5,10.5A1.5,1.5 0 0,1 18,12A1.5,1.5 0 0,1 16.5,13.5A1.5,1.5 0 0,1 15,12A1.5,1.5 0 0,1 16.5,10.5Z";
var mdiDotsSquare = "M12 16C13.1 16 14 16.9 14 18S13.1 20 12 20 10 19.1 10 18 10.9 16 12 16M12 4C13.1 4 14 4.9 14 6S13.1 8 12 8 10 7.1 10 6 10.9 4 12 4M6 16C7.1 16 8 16.9 8 18S7.1 20 6 20 4 19.1 4 18 4.9 16 6 16M6 10C7.1 10 8 10.9 8 12S7.1 14 6 14 4 13.1 4 12 4.9 10 6 10M6 4C7.1 4 8 4.9 8 6S7.1 8 6 8 4 7.1 4 6 4.9 4 6 4M18 16C19.1 16 20 16.9 20 18S19.1 20 18 20 16 19.1 16 18 16.9 16 18 16M18 10C19.1 10 20 10.9 20 12S19.1 14 18 14 16 13.1 16 12 16.9 10 18 10M18 4C19.1 4 20 4.9 20 6S19.1 8 18 8 16 7.1 16 6 16.9 4 18 4Z";
var mdiDotsTriangle = "M12 16C13.1 16 14 16.9 14 18S13.1 20 12 20 10 19.1 10 18 10.9 16 12 16M15 10C16.1 10 17 10.9 17 12S16.1 14 15 14 13 13.1 13 12 13.9 10 15 10M6 16C7.1 16 8 16.9 8 18S7.1 20 6 20 4 19.1 4 18 4.9 16 6 16M9 10C10.1 10 11 10.9 11 12S10.1 14 9 14 7 13.1 7 12 7.9 10 9 10M12 4C13.1 4 14 4.9 14 6S13.1 8 12 8 10 7.1 10 6 10.9 4 12 4M18 16C19.1 16 20 16.9 20 18S19.1 20 18 20 16 19.1 16 18 16.9 16 18 16";
var mdiDotsVertical = "M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z";
var mdiDotsVerticalCircle = "M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5A1.5,1.5 0 0,0 10.5,12M10.5,17.5A1.5,1.5 0 0,0 12,19A1.5,1.5 0 0,0 13.5,17.5A1.5,1.5 0 0,0 12,16A1.5,1.5 0 0,0 10.5,17.5M10.5,6.5A1.5,1.5 0 0,0 12,8A1.5,1.5 0 0,0 13.5,6.5A1.5,1.5 0 0,0 12,5A1.5,1.5 0 0,0 10.5,6.5Z";
var mdiDotsVerticalCircleOutline = "M10.5,12A1.5,1.5 0 0,1 12,10.5A1.5,1.5 0 0,1 13.5,12A1.5,1.5 0 0,1 12,13.5A1.5,1.5 0 0,1 10.5,12M10.5,16.5A1.5,1.5 0 0,1 12,15A1.5,1.5 0 0,1 13.5,16.5A1.5,1.5 0 0,1 12,18A1.5,1.5 0 0,1 10.5,16.5M10.5,7.5A1.5,1.5 0 0,1 12,6A1.5,1.5 0 0,1 13.5,7.5A1.5,1.5 0 0,1 12,9A1.5,1.5 0 0,1 10.5,7.5M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiDownload = "M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z";
var mdiDownloadBox = "M5 3H19C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3M8 17H16V15H8V17M16 10H13.5V7H10.5V10H8L12 14L16 10Z";
var mdiDownloadBoxOutline = "M8 17V15H16V17H8M16 10L12 14L8 10H10.5V7H13.5V10H16M5 3H19C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3M5 5V19H19V5H5Z";
var mdiDownloadCircle = "M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M8 17H16V15H8V17M16 10H13.5V6H10.5V10H8L12 14L16 10Z";
var mdiDownloadCircleOutline = "M8 17V15H16V17H8M16 10L12 14L8 10H10.5V6H13.5V10H16M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4Z";
var mdiDownloadLock = "M5 20H14V18H5M19 9H15V3H9V9H5L12 16M22 16A1.08 1.08 0 0 1 23 17V21A1.08 1.08 0 0 1 22 22H17A1.08 1.08 0 0 1 16 21V17A1.08 1.08 0 0 1 17 16V14.5A2.5 2.5 0 0 1 22 14.5V16M21 16V14.5A1.5 1.5 0 0 0 18 14.5V16H21";
var mdiDownloadLockOutline = "M22 16A1.08 1.08 0 0 1 23 17V21A1.08 1.08 0 0 1 22 22H17A1.08 1.08 0 0 1 16 21V17A1.08 1.08 0 0 1 17 16V14.5A2.5 2.5 0 0 1 22 14.5V16M21 16V14.5A1.5 1.5 0 0 0 18 14.5V16H21M13 5V11H14.17L12 13.17L9.83 11H11V5H13M15 3H9V9H5L12 16L19 9H15V3M14 18H5V20H14Z";
var mdiDownloadMultiple = "M9,1V7H5L12,14L19,7H15V1H9M5,16V18H19V16H5M5,20V22H19V20H5Z";
var mdiDownloadMultipleOutline = "M12 14L19 7H15V1H9V7H5L12 14M12 11.17L9.83 9H11V3H13V9H14.17L12 11.17M5 16V18H19V16H5M5 22V20H19V22H5Z";
var mdiDownloadNetwork = "M17,3A2,2 0 0,1 19,5V15A2,2 0 0,1 17,17H13V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H7C5.89,17 5,16.1 5,15V5A2,2 0 0,1 7,3H17M12,14.5L16.5,10H13V6H11V10H7.5L12,14.5Z";
var mdiDownloadNetworkOutline = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M7,15V5H17V15H7M12,14L16,10H13V6H11V10H8L12,14Z";
var mdiDownloadOff = "M20.84 22.73L18.11 20H5V18H16.11L13.06 14.95L12 16L5 9H7.11L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M19 9H15V3H9V5.8L15.6 12.4L19 9Z";
var mdiDownloadOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L7.11 9H5L12 16L13.06 14.95L16.11 18H5V20H18.11L20.84 22.73L22.11 21.46M11 5H13V9.8L15.6 12.4L19 9H15V3H9V5.8L11 7.8V5Z";
var mdiDownloadOutline = "M13,5V11H14.17L12,13.17L9.83,11H11V5H13M15,3H9V9H5L12,16L19,9H15V3M19,18H5V20H19V18Z";
var mdiDrag = "M7,19V17H9V19H7M11,19V17H13V19H11M15,19V17H17V19H15M7,15V13H9V15H7M11,15V13H13V15H11M15,15V13H17V15H15M7,11V9H9V11H7M11,11V9H13V11H11M15,11V9H17V11H15M7,7V5H9V7H7M11,7V5H13V7H11M15,7V5H17V7H15Z";
var mdiDragHorizontal = "M3,15V13H5V15H3M3,11V9H5V11H3M7,15V13H9V15H7M7,11V9H9V11H7M11,15V13H13V15H11M11,11V9H13V11H11M15,15V13H17V15H15M15,11V9H17V11H15M19,15V13H21V15H19M19,11V9H21V11H19Z";
var mdiDragHorizontalVariant = "M21 11H3V9H21V11M21 13H3V15H21V13Z";
var mdiDragVariant = "M22.67,12L18.18,16.5L15.67,14L17.65,12L15.67,10.04L18.18,7.53L22.67,12M12,1.33L16.47,5.82L13.96,8.33L12,6.35L10,8.33L7.5,5.82L12,1.33M12,22.67L7.53,18.18L10.04,15.67L12,17.65L14,15.67L16.5,18.18L12,22.67M1.33,12L5.82,7.5L8.33,10L6.35,12L8.33,13.96L5.82,16.47L1.33,12M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10Z";
var mdiDragVertical = "M9,3H11V5H9V3M13,3H15V5H13V3M9,7H11V9H9V7M13,7H15V9H13V7M9,11H11V13H9V11M13,11H15V13H13V11M9,15H11V17H9V15M13,15H15V17H13V15M9,19H11V21H9V19M13,19H15V21H13V19Z";
var mdiDragVerticalVariant = "M11 21H9V3H11V21M15 3H13V21H15V3Z";
var mdiDramaMasks = "M8.11,19.45C5.94,18.65 4.22,16.78 3.71,14.35L2.05,6.54C1.81,5.46 2.5,4.4 3.58,4.17L13.35,2.1L13.38,2.09C14.45,1.88 15.5,2.57 15.72,3.63L16.07,5.3L20.42,6.23H20.45C21.5,6.47 22.18,7.53 21.96,8.59L20.3,16.41C19.5,20.18 15.78,22.6 12,21.79C10.42,21.46 9.08,20.61 8.11,19.45V19.45M20,8.18L10.23,6.1L8.57,13.92V13.95C8,16.63 9.73,19.27 12.42,19.84C15.11,20.41 17.77,18.69 18.34,16L20,8.18M16,16.5C15.37,17.57 14.11,18.16 12.83,17.89C11.56,17.62 10.65,16.57 10.5,15.34L16,16.5M8.47,5.17L4,6.13L5.66,13.94L5.67,13.97C5.82,14.68 6.12,15.32 6.53,15.87C6.43,15.1 6.45,14.3 6.62,13.5L7.05,11.5C6.6,11.42 6.21,11.17 6,10.81C6.06,10.2 6.56,9.66 7.25,9.5C7.33,9.5 7.4,9.5 7.5,9.5L8.28,5.69C8.32,5.5 8.38,5.33 8.47,5.17M15.03,12.23C15.35,11.7 16.03,11.42 16.72,11.57C17.41,11.71 17.91,12.24 18,12.86C17.67,13.38 17,13.66 16.3,13.5C15.61,13.37 15.11,12.84 15.03,12.23M10.15,11.19C10.47,10.66 11.14,10.38 11.83,10.53C12.5,10.67 13.03,11.21 13.11,11.82C12.78,12.34 12.11,12.63 11.42,12.5C10.73,12.33 10.23,11.8 10.15,11.19M11.97,4.43L13.93,4.85L13.77,4.05L11.97,4.43Z";
var mdiDraw = "M9.75 20.85C11.53 20.15 11.14 18.22 10.24 17C9.35 15.75 8.12 14.89 6.88 14.06C6 13.5 5.19 12.8 4.54 12C4.26 11.67 3.69 11.06 4.27 10.94C4.86 10.82 5.88 11.4 6.4 11.62C7.31 12 8.21 12.44 9.05 12.96L10.06 11.26C8.5 10.23 6.5 9.32 4.64 9.05C3.58 8.89 2.46 9.11 2.1 10.26C1.78 11.25 2.29 12.25 2.87 13.03C4.24 14.86 6.37 15.74 7.96 17.32C8.3 17.65 8.71 18.04 8.91 18.5C9.12 18.94 9.07 18.97 8.6 18.97C7.36 18.97 5.81 18 4.8 17.36L3.79 19.06C5.32 20 7.88 21.47 9.75 20.85M20.84 5.25C21.06 5.03 21.06 4.67 20.84 4.46L19.54 3.16C19.33 2.95 18.97 2.95 18.76 3.16L17.74 4.18L19.82 6.26M11 10.92V13H13.08L19.23 6.85L17.15 4.77L11 10.92Z";
var mdiDrawPen = "M9.75 20.85C11.53 20.15 11.14 18.22 10.24 17C9.35 15.75 8.12 14.89 6.88 14.06C6 13.5 5.19 12.8 4.54 12C4.26 11.67 3.69 11.06 4.27 10.94C4.86 10.82 5.88 11.4 6.4 11.62C7.31 12 8.21 12.44 9.05 12.96L10.06 11.26C8.5 10.23 6.5 9.32 4.64 9.05C3.58 8.89 2.46 9.11 2.1 10.26C1.78 11.25 2.29 12.25 2.87 13.03C4.24 14.86 6.37 15.74 7.96 17.32C8.3 17.65 8.71 18.04 8.91 18.5C9.12 18.94 9.07 18.97 8.6 18.97C7.36 18.97 5.81 18 4.8 17.36L3.79 19.06C5.32 20 7.88 21.47 9.75 20.85M18.96 7.33L13.29 13H11V10.71L16.67 5.03L18.96 7.33M22.36 6.55C22.35 6.85 22.04 7.16 21.72 7.47L19.2 10L18.33 9.13L20.93 6.54L20.34 5.95L19.67 6.62L17.38 4.33L19.53 2.18C19.77 1.94 20.16 1.94 20.39 2.18L21.82 3.61C22.06 3.83 22.06 4.23 21.82 4.47C21.61 4.68 21.41 4.88 21.41 5.08C21.39 5.28 21.59 5.5 21.79 5.67C22.08 5.97 22.37 6.25 22.36 6.55Z";
var mdiDrawing = "M8.5,3A5.5,5.5 0 0,1 14,8.5C14,9.83 13.53,11.05 12.74,12H21V21H12V12.74C11.05,13.53 9.83,14 8.5,14A5.5,5.5 0 0,1 3,8.5A5.5,5.5 0 0,1 8.5,3Z";
var mdiDrawingBox = "M18,18H12V12.21C11.34,12.82 10.47,13.2 9.5,13.2C7.46,13.2 5.8,11.54 5.8,9.5A3.7,3.7 0 0,1 9.5,5.8C11.54,5.8 13.2,7.46 13.2,9.5C13.2,10.47 12.82,11.34 12.21,12H18M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiDresser = "M4 3C2.9 3 2 3.9 2 5V8H22V5C22 3.9 21.11 3 20 3H4M10 5H14V6H10V5M2 9V14H22V9H2M10 11H14V12H10V11M2 15V18C2 19.11 2.9 20 4 20V21H6V20H18V21H20V20C21.11 20 22 19.11 22 18V15H2M10 17H14V18H10V17Z";
var mdiDresserOutline = "M4 3C2.9 3 2 3.9 2 5V18C2 19.11 2.9 20 4 20V21H6V20H18V21H20V20C21.11 20 22 19.11 22 18V5C22 3.9 21.11 3 20 3H4M4 5H20V8H4V5M10 6V7H14V6H10M4 10H20V13H4V10M10 11V12H14V11H10M4 15H20V18H4V15M10 16V17H14V16H10Z";
var mdiDrone = "M22,11H21L20,9H13.75L16,12.5H14L10.75,9H4C3.45,9 2,8.55 2,8C2,7.45 3.5,5.5 5.5,5.5C7.5,5.5 7.67,6.5 9,7H21A1,1 0 0,1 22,8V9L22,11M10.75,6.5L14,3H16L13.75,6.5H10.75M18,11V9.5H19.75L19,11H18M3,19A1,1 0 0,1 2,18A1,1 0 0,1 3,17A4,4 0 0,1 7,21A1,1 0 0,1 6,22A1,1 0 0,1 5,21A2,2 0 0,0 3,19M11,21A1,1 0 0,1 10,22A1,1 0 0,1 9,21A6,6 0 0,0 3,15A1,1 0 0,1 2,14A1,1 0 0,1 3,13A8,8 0 0,1 11,21Z";
var mdiDropbox = "M3 6.2L8 9.39L13 6.2L8 3L3 6.2M13 6.2L18 9.39L23 6.2L18 3L13 6.2M3 12.55L8 15.74L13 12.55L8 9.35L3 12.55M18 9.35L13 12.55L18 15.74L23 12.55L18 9.35M8.03 16.8L13.04 20L18.04 16.8L13.04 13.61L8.03 16.8Z";
var mdiDrupal = "M20.47,14.65C20.47,15.29 20.25,16.36 19.83,17.1C19.4,17.85 19.08,18.06 18.44,18.06C17.7,17.95 16.31,15.82 15.36,15.72C14.18,15.72 11.73,18.17 9.71,18.17C8.54,18.17 8.11,17.95 7.79,17.74C7.15,17.31 6.94,16.67 6.94,15.82C6.94,14.22 8.43,12.84 10.24,12.84C12.59,12.84 14.18,15.18 15.36,15.08C16.31,15.08 18.23,13.16 19.19,13.16C20.15,12.95 20.47,14 20.47,14.65M16.63,5.28C15.57,4.64 14.61,4.32 13.54,3.68C12.91,3.25 12.05,2.3 11.31,1.44C11,2.83 10.78,3.36 10.24,3.79C9.18,4.53 8.64,4.85 7.69,5.28C6.94,5.7 3,8.05 3,13.16C3,18.27 7.37,22 12.05,22C16.85,22 21,18.5 21,13.27C21.21,8.05 17.27,5.7 16.63,5.28Z";
var mdiDuck = "M8.5,5A1.5,1.5 0 0,0 7,6.5A1.5,1.5 0 0,0 8.5,8A1.5,1.5 0 0,0 10,6.5A1.5,1.5 0 0,0 8.5,5M10,2A5,5 0 0,1 15,7C15,8.7 14.15,10.2 12.86,11.1C14.44,11.25 16.22,11.61 18,12.5C21,14 22,12 22,12C22,12 21,21 15,21H9C9,21 4,21 4,16C4,13 7,12 6,10C2,10 2,6.5 2,6.5C3,7 4.24,7 5,6.65C5.19,4.05 7.36,2 10,2Z";
var mdiDumbbell = "M20.57,14.86L22,13.43L20.57,12L17,15.57L8.43,7L12,3.43L10.57,2L9.14,3.43L7.71,2L5.57,4.14L4.14,2.71L2.71,4.14L4.14,5.57L2,7.71L3.43,9.14L2,10.57L3.43,12L7,8.43L15.57,17L12,20.57L13.43,22L14.86,20.57L16.29,22L18.43,19.86L19.86,21.29L21.29,19.86L19.86,18.43L22,16.29L20.57,14.86Z";
var mdiDumpTruck = "M20,8H19L17,8H15V14H2V17H3A3,3 0 0,0 6,20A3,3 0 0,0 9,17H15A3,3 0 0,0 18,20A3,3 0 0,0 21,17H23V12L20,8M6,18.5A1.5,1.5 0 0,1 4.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,17A1.5,1.5 0 0,1 6,18.5M18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5M17,12V9.5H19.5L21.46,12H17M18,7H14V13H3L1.57,8H1V6H13L14,5H18V7Z";
var mdiEarHearing = "M17,20C16.71,20 16.44,19.94 16.24,19.85C15.53,19.5 15.03,18.97 14.53,17.47C14,15.91 13.06,15.18 12.14,14.47C11.35,13.86 10.53,13.23 9.82,11.94C9.29,11 9,9.93 9,9C9,6.2 11.2,4 14,4C16.8,4 19,6.2 19,9H21C21,5.07 17.93,2 14,2C10.07,2 7,5.07 7,9C7,10.26 7.38,11.65 8.07,12.9C9,14.55 10.05,15.38 10.92,16.05C11.73,16.67 12.31,17.12 12.63,18.1C13.23,19.92 14,20.94 15.36,21.65C15.87,21.88 16.43,22 17,22A4,4 0 0,0 21,18H19A2,2 0 0,1 17,20M7.64,2.64L6.22,1.22C4.23,3.21 3,5.96 3,9C3,12.04 4.23,14.79 6.22,16.78L7.63,15.37C6,13.74 5,11.5 5,9C5,6.5 6,4.26 7.64,2.64M11.5,9A2.5,2.5 0 0,0 14,11.5A2.5,2.5 0 0,0 16.5,9A2.5,2.5 0 0,0 14,6.5A2.5,2.5 0 0,0 11.5,9Z";
var mdiEarHearingLoop = "M12 6.5C10.62 6.5 9.5 7.62 9.5 9S10.62 11.5 12 11.5 14.5 10.38 14.5 9 13.38 6.5 12 6.5M16 17V19H18V23H20V19H22V17H16M11.69 13.47L3.67 22L2.4 20.73L9.75 12.87C10.33 13.21 11 13.42 11.69 13.47M19 9C19 10.26 18.62 11.65 17.93 12.9C17 14.55 15.95 15.38 15.08 16.05C14.27 16.67 13.69 17.12 13.37 18.1C12.77 19.92 12 20.94 10.64 21.65C10.13 21.88 9.57 22 9 22C7.81 22 6.75 21.47 6 20.65L7.43 19.22C7.79 19.69 8.36 20 9 20C9.29 20 9.56 19.94 9.76 19.85C10.47 19.5 10.97 18.97 11.47 17.47C12 15.91 12.94 15.18 13.86 14.47C14.65 13.86 15.47 13.23 16.18 11.94C16.71 11 17 9.93 17 9C17 6.2 14.8 4 12 4S7 6.2 7 9H5C5 5.07 8.07 2 12 2S19 5.07 19 9M18.37 4.12L20.72 1.73L22 3L19.32 5.72C19.06 5.15 18.74 4.61 18.37 4.12Z";
var mdiEarHearingOff = "M1,4.27L2.28,3L20,20.72L18.73,22L12.91,16.18C12.19,16.74 11.67,17.19 11.37,18.1C10.77,19.92 10,20.94 8.64,21.65C8.13,21.88 7.57,22 7,22A4,4 0 0,1 3,18H5A2,2 0 0,0 7,20C7.29,20 7.56,19.94 7.76,19.85C8.47,19.5 8.97,18.97 9.47,17.47C9.91,16.12 10.69,15.39 11.5,14.76L5.04,8.31C5,8.54 5,8.77 5,9H3C3,8.17 3.14,7.39 3.39,6.66L1,4.27M14.18,11.94C14.71,11 15,9.93 15,9C15,6.2 12.8,4 10,4C8.81,4 7.74,4.39 6.89,5.06L5.46,3.63C6.67,2.61 8.25,2 10,2C13.93,2 17,5.07 17,9C17,10.26 16.62,11.65 15.93,12.9L15.47,13.65L14.03,12.2L14.18,11.94M16.36,2.64L17.78,1.22C19.77,3.21 21,5.96 21,9C21,11.83 19.93,14.41 18.18,16.36L16.77,14.94C18.15,13.36 19,11.28 19,9C19,6.5 18,4.26 16.36,2.64M12.5,9C12.5,9.5 12.36,9.93 12.13,10.31L8.69,6.87C9.07,6.64 9.5,6.5 10,6.5A2.5,2.5 0 0,1 12.5,9Z";
var mdiEarbuds = "M10 8V20C10 20.55 9.55 21 9 21H8C7.45 21 7 20.55 7 20V13.27C6.32 13.72 5.61 14 5 14C3 14 2 12 2 11V6C2 5 3 3 5 3S10 6 10 8M16.5 3C13.46 3 11 5.46 11 8.5S13.46 14 16.5 14 22 11.54 22 8.5 19.54 3 16.5 3M14.5 14.68V20C14.5 20.55 14.95 21 15.5 21H17.5C18.05 21 18.5 20.55 18.5 20V14.68C17.87 14.89 17.2 15 16.5 15S15.13 14.89 14.5 14.68Z";
var mdiEarbudsOff = "M10 9.34V9.34L11.56 10.91L11.56 10.9L14.1 13.45L14.09 13.44L15.58 14.93L15.59 14.93L18.5 17.84V17.85L22.11 21.46L20.84 22.73L18.43 20.33C18.3 20.72 17.94 21 17.5 21H15.5C14.95 21 14.5 20.55 14.5 20V16.39L10 11.89V20C10 20.55 9.55 21 9 21H8C7.45 21 7 20.55 7 20V13.27C6.32 13.72 5.61 14 5 14C3 14 2 12 2 11V6C2 5.58 2.19 5 2.55 4.43L1.11 3L2.39 1.73L6.1 5.44M22 8.5C22 5.46 19.54 3 16.5 3C13.69 3 11.37 5.12 11.04 7.84L17.16 13.96C19.89 13.63 22 11.32 22 8.5Z";
var mdiEarbudsOffOutline = "M22.11 21.46L18.5 17.85V17.84L15.58 14.93L15.58 14.93L14.09 13.44L14.1 13.44L11.56 10.9L11.56 10.9L10 9.34V9.34L7 6.34L7 6.34L6.66 6L6.67 6L6.1 5.44L2.39 1.73L1.11 3L2.55 4.43C2.19 5 2 5.58 2 6V11C2 12 3 14 5 14C5.61 14 6.32 13.72 7 13.27V20C7 20.55 7.45 21 8 21H9C9.55 21 10 20.55 10 20V11.89L14.5 16.39V20C14.5 20.55 14.95 21 15.5 21H17.5C17.94 21 18.3 20.72 18.43 20.32L20.84 22.73L22.11 21.46M8 10.23L5.91 11.6C5.4 11.93 5.08 12 5 12C4.3 12 4 11.08 4 11L4 6.03C4 6 4 5.97 4.03 5.92L8 9.89V10.23M13.53 10.33L11.04 7.84C11.37 5.12 13.69 3 16.5 3C19.54 3 22 5.46 22 8.5C22 11.32 19.89 13.63 17.16 13.96L14.67 11.47C15.2 11.8 15.83 12 16.5 12C18.43 12 20 10.43 20 8.5S18.43 5 16.5 5 13 6.57 13 8.5C13 9.17 13.2 9.8 13.53 10.33Z";
var mdiEarbudsOutline = "M5 3C3 3 2 5 2 6V11C2 12 3 14 5 14C5.61 14 6.32 13.72 7 13.27V20C7 20.55 7.45 21 8 21H9C9.55 21 10 20.55 10 20V8C10 6 7 3 5 3M8 10.23L5.91 11.6C5.4 11.93 5.08 12 5 12C4.3 12 4 11.08 4 11L4 6.03C4 5.92 4.3 5 5 5C5.9 5 8 7.1 8 8V10.23M16.5 15C17.2 15 17.87 14.89 18.5 14.68V20C18.5 20.55 18.05 21 17.5 21H15.5C14.95 21 14.5 20.55 14.5 20V14.68C15.13 14.89 15.8 15 16.5 15M16.5 3C13.46 3 11 5.46 11 8.5S13.46 14 16.5 14 22 11.54 22 8.5 19.54 3 16.5 3M16.5 12C14.57 12 13 10.43 13 8.5S14.57 5 16.5 5 20 6.57 20 8.5 18.43 12 16.5 12Z";
var mdiEarth = "M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13A1,1 0 0,0 14,12H8V10H10A1,1 0 0,0 11,9V7H13A2,2 0 0,0 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16A2,2 0 0,0 11,18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiEarthArrowDown = "M15 19H17V15H19V19H21L18 22L15 19M12 18C12 15.8 13.2 13.9 15 12.8C14.9 12.3 14.5 12 14 12H8V10H10C10.6 10 11 9.6 11 9V7H13C14.1 7 15 6.1 15 5V4.6C17.9 5.8 20 8.6 20 12V12.3C20.7 12.5 21.3 12.9 21.9 13.4C22 13 22 12.5 22 12C22 6.5 17.5 2 12 2S2 6.5 2 12 6.5 22 12 22C12.5 22 13 22 13.4 21.9C12.5 20.8 12 19.5 12 18M11 19.9C7 19.4 4 16.1 4 12C4 11.4 4.1 10.8 4.2 10.2L9 15V16C9 17.1 9.9 18 11 18V19.9Z";
var mdiEarthArrowLeft = "M17 15V17H21V19H17V21L14 18L17 15M12 18C12 15.8 13.2 13.9 15 12.8C14.9 12.3 14.5 12 14 12H8V10H10C10.6 10 11 9.6 11 9V7H13C14.1 7 15 6.1 15 5V4.6C17.9 5.8 20 8.6 20 12V12.3C20.7 12.5 21.3 12.9 21.9 13.4C22 13 22 12.5 22 12C22 6.5 17.5 2 12 2S2 6.5 2 12 6.5 22 12 22C12.5 22 13 22 13.4 21.9C12.5 20.8 12 19.5 12 18M11 19.9C7 19.4 4 16.1 4 12C4 11.4 4.1 10.8 4.2 10.2L9 15V16C9 17.1 9.9 18 11 18V19.9Z";
var mdiEarthArrowRight = "M19 21V19H15V17H19V15L22 18L19 21M12 18C12 15.8 13.2 13.9 15 12.8C14.9 12.3 14.5 12 14 12H8V10H10C10.6 10 11 9.6 11 9V7H13C14.1 7 15 6.1 15 5V4.6C17.9 5.8 20 8.6 20 12V12.3C20.7 12.5 21.3 12.9 21.9 13.4C22 13 22 12.5 22 12C22 6.5 17.5 2 12 2S2 6.5 2 12 6.5 22 12 22C12.5 22 13 22 13.4 21.9C12.5 20.8 12 19.5 12 18M11 19.9C7 19.4 4 16.1 4 12C4 11.4 4.1 10.8 4.2 10.2L9 15V16C9 17.1 9.9 18 11 18V19.9Z";
var mdiEarthArrowUp = "M21 17H19V21H17V17H15L18 14L21 17M12 18C12 15.8 13.2 13.9 15 12.8C14.9 12.3 14.5 12 14 12H8V10H10C10.6 10 11 9.6 11 9V7H13C14.1 7 15 6.1 15 5V4.6C17.9 5.8 20 8.6 20 12V12.3C20.7 12.5 21.3 12.9 21.9 13.4C22 13 22 12.5 22 12C22 6.5 17.5 2 12 2S2 6.5 2 12 6.5 22 12 22C12.5 22 13 22 13.4 21.9C12.5 20.8 12 19.5 12 18M11 19.9C7 19.4 4 16.1 4 12C4 11.4 4.1 10.8 4.2 10.2L9 15V16C9 17.1 9.9 18 11 18V19.9Z";
var mdiEarthBox = "M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H5M15.78,5H19V17.18C18.74,16.38 17.69,15.79 16.8,15.79H15.8V12.79A1,1 0 0,0 14.8,11.79H8.8V9.79H10.8A1,1 0 0,0 11.8,8.79V6.79H13.8C14.83,6.79 15.67,6 15.78,5M5,10.29L9.8,14.79V15.79C9.8,16.9 10.7,17.79 11.8,17.79V19H5V10.29Z";
var mdiEarthBoxMinus = "M22 17V19H14V17H22M5 3H19C20.1 3 21 3.89 21 5V12.8C20.39 12.45 19.72 12.2 19 12.08V5H15.78C15.67 6 14.83 6.79 13.8 6.79H11.8V8.79C11.8 9.35 11.35 9.79 10.8 9.79H8.8V11.79H14.8C15.23 11.79 15.6 12.06 15.74 12.44C13.6 13.31 12.07 15.39 12 17.83C10.7 17.79 9.8 16.9 9.8 15.79V14.79L5 10.29V19H12.08C12.2 19.72 12.45 20.39 12.8 21H5C3.9 21 3 20.11 3 19V5C3 3.89 3.89 3 5 3Z";
var mdiEarthBoxOff = "M23,4.27L21,6.27V19A2,2 0 0,1 19,21H6.27L4.27,23L3,21.72L21.72,3L23,4.27M5,3H19.18L17.18,5H15.78C15.67,6 14.83,6.79 13.8,6.79H11.8V8.79C11.8,9.35 11.35,9.79 10.8,9.79H8.8V11.79H10.38L8.55,13.62L5,10.29V17.18L3,19.18V5C3,3.89 3.89,3 5,3M11.8,19V17.79C11.17,17.79 10.6,17.5 10.23,17.04L8.27,19H11.8M15.8,12.79V15.79H16.8C17.69,15.79 18.74,16.38 19,17.18V8.27L15.33,11.94C15.61,12.12 15.8,12.43 15.8,12.79Z";
var mdiEarthBoxPlus = "M17 14H19V17H22V19H19V22H17V19H14V17H17V14M5 3H19C20.1 3 21 3.89 21 5V12.8C20.39 12.45 19.72 12.2 19 12.08V5H15.78C15.67 6 14.83 6.79 13.8 6.79H11.8V8.79C11.8 9.35 11.35 9.79 10.8 9.79H8.8V11.79H14.8C15.23 11.79 15.6 12.06 15.74 12.44C13.6 13.31 12.07 15.39 12 17.83C10.7 17.79 9.8 16.9 9.8 15.79V14.79L5 10.29V19H12.08C12.2 19.72 12.45 20.39 12.8 21H5C3.9 21 3 20.11 3 19V5C3 3.89 3.89 3 5 3Z";
var mdiEarthBoxRemove = "M14.46 15.88L15.88 14.46L18 16.59L20.12 14.47L21.54 15.88L19.41 18L21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.46 20.12L16.59 18L14.47 15.88M5 3H19C20.1 3 21 3.89 21 5V12.8C20.39 12.45 19.72 12.2 19 12.08V5H15.78C15.67 6 14.83 6.79 13.8 6.79H11.8V8.79C11.8 9.35 11.35 9.79 10.8 9.79H8.8V11.79H14.8C15.23 11.79 15.6 12.06 15.74 12.44C13.6 13.31 12.07 15.39 12 17.83C10.7 17.79 9.8 16.9 9.8 15.79V14.79L5 10.29V19H12.08C12.2 19.72 12.45 20.39 12.8 21H5C3.9 21 3 20.11 3 19V5C3 3.89 3.89 3 5 3Z";
var mdiEarthMinus = "M14 17H22V19H14V17M20 12C20 8.64 17.93 5.77 15 4.59V5C15 6.1 14.1 7 13 7H11V9C11 9.55 10.55 10 10 10H8V12H14C14.5 12 14.9 12.35 15 12.81C13.2 13.85 12 15.79 12 18C12 19.5 12.54 20.85 13.44 21.9L12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12L21.9 13.44C21.34 12.96 20.7 12.59 20 12.34L20 12M11 19.93V18C9.9 18 9 17.1 9 16V15L4.21 10.21C4.08 10.78 4 11.38 4 12C4 16.08 7.06 19.44 11 19.93Z";
var mdiEarthOff = "M22,5.27L20.5,6.75C21.46,8.28 22,10.07 22,12A10,10 0 0,1 12,22C10.08,22 8.28,21.46 6.75,20.5L5.27,22L4,20.72L20.72,4L22,5.27M17.9,17.39C19.2,15.97 20,14.08 20,12C20,10.63 19.66,9.34 19.05,8.22L14.83,12.44C14.94,12.6 15,12.79 15,13V16H16C16.89,16 17.64,16.59 17.9,17.39M11,19.93V18C10.5,18 10.07,17.83 9.73,17.54L8.22,19.05C9.07,19.5 10,19.8 11,19.93M15,4.59V5A2,2 0 0,1 13,7H11V9A1,1 0 0,1 10,10H8V12H10.18L8.09,14.09L4.21,10.21C4.08,10.78 4,11.38 4,12C4,13.74 4.56,15.36 5.5,16.67L4.08,18.1C2.77,16.41 2,14.3 2,12A10,10 0 0,1 12,2C14.3,2 16.41,2.77 18.1,4.08L16.67,5.5C16.16,5.14 15.6,4.83 15,4.59Z";
var mdiEarthPlus = "M17 14H19V17H22V19H19V22H17V19H14V17H17V14M20 12C20 8.64 17.93 5.77 15 4.59V5C15 6.1 14.1 7 13 7H11V9C11 9.55 10.55 10 10 10H8V12H14C14.5 12 14.9 12.35 15 12.81C13.2 13.85 12 15.79 12 18C12 19.5 12.54 20.85 13.44 21.9L12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12L21.9 13.44C21.34 12.96 20.7 12.59 20 12.34L20 12M11 19.93V18C9.9 18 9 17.1 9 16V15L4.21 10.21C4.08 10.78 4 11.38 4 12C4 16.08 7.06 19.44 11 19.93Z";
var mdiEarthRemove = "M14.46 15.88L15.88 14.46L18 16.59L20.12 14.47L21.54 15.88L19.41 18L21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.46 20.12L16.59 18L14.47 15.88M20 12C20 8.64 17.93 5.77 15 4.59V5C15 6.1 14.1 7 13 7H11V9C11 9.55 10.55 10 10 10H8V12H14C14.5 12 14.9 12.35 15 12.81C13.2 13.85 12 15.79 12 18C12 19.5 12.54 20.85 13.44 21.9L12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12L21.9 13.44C21.34 12.96 20.7 12.59 20 12.34L20 12M11 19.93V18C9.9 18 9 17.1 9 16V15L4.21 10.21C4.08 10.78 4 11.38 4 12C4 16.08 7.06 19.44 11 19.93Z";
var mdiEgg = "M19.5,14.5A7.5,7.5 0 0,1 12,22A7.5,7.5 0 0,1 4.5,14.5C4.5,10.36 7.86,2 12,2C16.14,2 19.5,10.36 19.5,14.5Z";
var mdiEggEaster = "M6.89,6.36C8.23,3.91 10,2 12,2C14,2 15.77,3.91 17.11,6.36C16.26,6.57 15.5,7.07 15,7.77C13.79,6.11 11.46,5.75 9.8,6.97C9.5,7.19 9.22,7.46 9,7.77C8.5,7.07 7.74,6.57 6.89,6.36M15,18.06L12,15.06L9,18.06L6,15.06L4.73,16.33C5.75,20.35 9.83,22.77 13.84,21.76C16.5,21.08 18.59,19 19.27,16.33L18,15.06L15,18.06M9,15.94L12,12.94L15,15.94L18,12.94L19.5,14.44C19.37,12.13 18.8,9.86 17.81,7.76C16.65,7.86 15.75,8.83 15.75,10H14.25A2.25,2.25 0 0,0 12,7.75A2.25,2.25 0 0,0 9.75,10H8.25C8.25,8.83 7.35,7.86 6.19,7.76C5.2,9.86 4.63,12.13 4.5,14.44L6,12.94L9,15.94Z";
var mdiEggFried = "M12 4.5C14.17 4.5 14.58 5.07 15.5 6.32C15.88 6.85 16.32 7.44 16.94 8.06C17.43 8.55 17.86 8.93 18.21 9.24C19.3 10.19 19.5 10.36 19.5 12C19.5 14.93 19.5 15.38 17.94 16.94C16 18.86 15.38 19.5 13 19.5C11.88 19.5 11.5 19.18 10.89 18.69C10.27 18.19 9.43 17.5 8 17.5C4.96 17.5 4.5 14.05 4.5 12C4.5 10.65 5 8.91 6.47 8.42C8.25 7.83 9.2 6.71 9.96 5.81C10.75 4.88 11.11 4.5 12 4.5M12 3C9 3 9 6 6 7C3.88 7.71 3 10 3 12C3 15 4 19 8 19C10 19 10 21 13 21S17 20 19 18 21 15 21 12 20 9 18 7 16 3 12 3M12 8C9.79 8 8 9.79 8 12S9.79 16 12 16 16 14.21 16 12 14.21 8 12 8M12 10C10.9 10 10 10.9 10 12H9C9 10.35 10.35 9 12 9V10Z";
var mdiEggOff = "M22.1 21.5L2.4 1.7L1.1 3L6.1 8C5.1 10.3 4.5 12.8 4.5 14.5C4.5 18.6 7.9 22 12 22C14.2 22 16.2 21 17.6 19.5L20.8 22.7L22.1 21.5M19.5 14.5C19.5 10.4 16.1 2 12 2C10.5 2 9.1 3.1 7.9 4.7L19.3 16.1C19.4 15.6 19.5 15.1 19.5 14.5Z";
var mdiEggOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L6.1 8C5.1 10.28 4.5 12.76 4.5 14.5C4.5 18.64 7.86 22 12 22C14.23 22 16.22 21 17.59 19.5L20.84 22.73L22.11 21.46M12 20C8.97 20 6.5 17.53 6.5 14.5C6.5 13.08 6.95 11.25 7.63 9.5L16.17 18.06C15.16 19.24 13.67 20 12 20M9.36 6.16L7.92 4.72C9.1 3.11 10.5 2 12 2C16.14 2 19.5 10.36 19.5 14.5C19.5 15.06 19.43 15.6 19.32 16.12L17.5 14.29C17.38 10.46 14.28 4 12 4C11.17 4 10.22 4.87 9.36 6.16Z";
var mdiEggOutline = "M12 4C14.32 4 17.5 10.7 17.5 14.5C17.5 17.53 15.03 20 12 20S6.5 17.53 6.5 14.5C6.5 10.7 9.68 4 12 4M12 2C7.86 2 4.5 10.36 4.5 14.5C4.5 18.64 7.86 22 12 22S19.5 18.64 19.5 14.5C19.5 10.36 16.14 2 12 2Z";
var mdiEiffelTower = "M8.21 17C8.65 16.15 9.06 15.16 9.44 14H9V12H10C10.61 9.4 11 6.13 11 2H13C13 6.13 13.4 9.4 14 12H15V14H14.56C14.94 15.16 15.35 16.15 15.79 17H17L17 19L19 22H16.58C15.81 20.24 14.05 19 12 19C9.95 19 8.19 20.24 7.42 22H5L7 19L6.97 17H8.21M12.59 14H11.41C11.07 15.13 10.69 16.13 10.28 17H13.72C13.32 16.13 12.93 15.13 12.59 14Z";
var mdiEightTrack = "M7,2L5,5V16L6,20C6.27,21.07 6.9,22 8,22H16A2,2 0 0,0 18,20L19,16V5L17,2H15V3H13V2H7M7,6H17V16H7V6Z";
var mdiEject = "M12,5L5.33,15H18.67M5,17H19V19H5V17Z";
var mdiEjectCircle = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M16.5 16H7.5V14H16.5V16M7.5 12L12 6L16.5 12H7.5Z";
var mdiEjectCircleOutline = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.5 12L12 6L7.5 12H16.5M16.5 16H7.5V14H16.5V16Z";
var mdiEjectOutline = "M5,17H19V19H5V17M12,5L5.33,15H18.67L12,5M12,8.6L14.93,13H9.07L12,8.6Z";
var mdiElectricSwitch = "M1,11H3.17C3.58,9.83 4.69,9 6,9C6.65,9 7.25,9.21 7.74,9.56L14.44,4.87L15.58,6.5L8.89,11.2C8.96,11.45 9,11.72 9,12A3,3 0 0,1 6,15C4.69,15 3.58,14.17 3.17,13H1V11M23,11V13H20.83C20.42,14.17 19.31,15 18,15A3,3 0 0,1 15,12A3,3 0 0,1 18,9C19.31,9 20.42,9.83 20.83,11H23M6,11A1,1 0 0,0 5,12A1,1 0 0,0 6,13A1,1 0 0,0 7,12A1,1 0 0,0 6,11M18,11A1,1 0 0,0 17,12A1,1 0 0,0 18,13A1,1 0 0,0 19,12A1,1 0 0,0 18,11Z";
var mdiElectricSwitchClosed = "M20.83 11A3 3 0 0 0 15.18 11H8.82A3 3 0 0 0 3.17 11H1V13H3.17A3 3 0 0 0 8.82 13H15.18A3 3 0 0 0 20.83 13H23V11M6 13A1 1 0 1 1 7 12A1 1 0 0 1 6 13M18 13A1 1 0 1 1 19 12A1 1 0 0 1 18 13Z";
var mdiElectronFramework = "M12 22C10.33 22 8.84 20.5 7.9 17.93C7.83 17.73 7.93 17.5 8.14 17.44C8.34 17.36 8.56 17.47 8.63 17.67C9.44 19.9 10.7 21.23 12 21.23C12.94 21.23 13.87 20.55 14.62 19.31C14.73 19.13 14.96 19.07 15.15 19.18C15.33 19.29 15.39 19.53 15.28 19.71C14.38 21.19 13.22 22 12 22M15.91 17.72C15.87 17.72 15.83 17.71 15.8 17.7C15.59 17.63 15.5 17.42 15.54 17.21C16 15.81 16.22 14.18 16.22 12.5C16.22 8.65 14.97 5.24 13.19 4.14C12.94 4.5 12.5 4.78 12 4.78C11.24 4.78 10.61 4.16 10.61 3.39C10.61 2.62 11.24 2 12 2C12.77 2 13.4 2.61 13.41 3.37C15.53 4.5 17 8.21 17 12.5C17 14.25 16.75 15.96 16.28 17.45C16.23 17.61 16.08 17.72 15.91 17.72M12 2.77C11.66 2.77 11.38 3.05 11.38 3.39C11.38 3.73 11.67 4 12 4C12.35 4 12.64 3.73 12.64 3.39C12.64 3.05 12.35 2.77 12 2.77M4.08 18.54C3.31 18.54 2.68 17.91 2.68 17.15C2.68 16.66 2.94 16.22 3.33 15.97C3.19 13.56 5.68 10.41 9.5 8.22C11.09 7.32 12.75 6.67 14.32 6.34C14.5 6.29 14.73 6.42 14.77 6.63C14.82 6.84 14.69 7.05 14.5 7.09C13 7.41 11.41 8.03 9.9 8.89C6.46 10.86 4.1 13.68 4.1 15.76C4.86 15.77 5.5 16.39 5.5 17.15C5.5 17.92 4.85 18.54 4.08 18.54M4.08 16.53C3.74 16.53 3.46 16.81 3.46 17.15C3.46 17.5 3.74 17.77 4.08 17.77S4.71 17.5 4.71 17.15C4.71 16.81 4.42 16.53 4.08 16.53M18.5 13.44C18.43 13.44 18.34 13.41 18.27 13.35C18.11 13.21 18.09 12.97 18.23 12.8C19.77 11 20.3 9.26 19.64 8.14C19.17 7.33 18.1 6.88 16.63 6.86C16.41 6.86 16.24 6.68 16.25 6.47C16.25 6.26 16.43 6.1 16.64 6.09C18.39 6.11 19.7 6.7 20.31 7.75C21.15 9.19 20.6 11.21 18.82 13.3C18.74 13.39 18.63 13.44 18.5 13.44M16.5 18.9C14.5 18.9 11.94 18.16 9.5 16.77C7.95 15.88 6.57 14.79 5.5 13.63C5.35 13.47 5.36 13.23 5.5 13.08C5.68 12.94 5.92 12.95 6.07 13.11C7.08 14.21 8.4 15.25 9.89 16.1C13.2 18 16.77 18.63 18.65 17.72C18.57 17.55 18.5 17.35 18.5 17.15C18.5 16.38 19.15 15.76 19.92 15.76C20.69 15.76 21.32 16.38 21.32 17.15C21.32 17.92 20.69 18.54 19.92 18.54C19.64 18.54 19.39 18.46 19.17 18.32C18.47 18.71 17.56 18.9 16.5 18.9M19.5 17.63C19.63 17.71 19.77 17.77 19.92 17.77C20.27 17.77 20.55 17.5 20.55 17.15C20.55 16.81 20.27 16.53 19.92 16.53S19.3 16.81 19.3 17.15C19.3 17.29 19.35 17.42 19.43 17.53C19.47 17.55 19.5 17.59 19.5 17.63M4.46 12C4.33 12 4.2 11.92 4.13 11.8C3.23 10.25 3.08 8.81 3.7 7.74C4.54 6.3 6.58 5.76 9.31 6.25C9.5 6.29 9.66 6.5 9.62 6.7C9.59 6.91 9.39 7.05 9.18 7C6.82 6.59 5 7 4.37 8.13C3.89 8.95 4.04 10.11 4.8 11.41C4.9 11.6 4.84 11.83 4.65 11.94C4.59 11.97 4.53 12 4.46 12M12.21 13.4C11.71 13.5 11.21 13.19 11.11 12.69C11 12.2 11.32 11.71 11.81 11.6C12.31 11.5 12.81 11.81 12.91 12.31C13 12.8 12.7 13.29 12.21 13.4Z";
var mdiElephant = "M19.5,15.5A0.5,0.5 0 0,1 19,16A0.5,0.5 0 0,1 18.5,15.5V8.5C18.5,6.57 16.43,5 14.5,5H6A4,4 0 0,0 2,9V19H6V15H11V19H15V14.5A0.5,0.5 0 0,1 15.5,14A0.5,0.5 0 0,1 16,14.5V16A3,3 0 0,0 19,19A3,3 0 0,0 22,16V14H19.5V15.5Z";
var mdiElevationDecline = "M21,21H3V11.25L9.45,15L13.22,12.8L21,17.29V21M3,8.94V6.75L9.45,10.5L13.22,8.3L21,12.79V15L13.22,10.5L9.45,12.67L3,8.94Z";
var mdiElevationRise = "M3,21V17.29L10.78,12.8L14.55,15L21,11.25V21H3M21,8.94L14.55,12.67L10.78,10.5L3,15V12.79L10.78,8.3L14.55,10.5L21,6.75V8.94Z";
var mdiElevator = "M7,2L11,6H8V10H6V6H3L7,2M17,10L13,6H16V2H18V6H21L17,10M7,12H17A2,2 0 0,1 19,14V20A2,2 0 0,1 17,22H7A2,2 0 0,1 5,20V14A2,2 0 0,1 7,12M7,14V20H17V14H7Z";
var mdiElevatorDown = "M7 10L11 6H8V2H6V6H3L7 10M17 10L13 6H16V2H18V6H21L17 10M7 12H17C18.11 12 19 12.9 19 14V20C19 21.11 18.11 22 17 22H7C5.9 22 5 21.11 5 20V14C5 12.9 5.9 12 7 12M7 14V20H17V14H7Z";
var mdiElevatorPassenger = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M8.5 6C9.19 6 9.75 6.56 9.75 7.25S9.19 8.5 8.5 8.5 7.25 7.94 7.25 7.25 7.81 6 8.5 6M11 14H10V18H7V14H6V11.5C6 10.4 6.9 9.5 8 9.5H9C10.1 9.5 11 10.4 11 11.5V14M15.5 17L13 13H18L15.5 17M13 11L15.5 7L18 11H13Z";
var mdiElevatorPassengerOff = "M22.11 21.46L20.7 20.05L20.7 20.04L2.39 1.73L1.11 3L3 4.9C3 4.94 3 4.97 3 5V19C3 20.1 3.9 21 5 21H19C19.03 21 19.06 21 19.1 21L20.84 22.73L22.11 21.46M11 14H10V18H7V14H6V11.5C6 10.5 6.71 9.71 7.65 9.54L11 12.89V14M13.46 10.26L6.2 3H19C20.1 3 21 3.9 21 5V17.8L17.31 14.11L18 13H16.2L14.2 11H18L15.5 7L13.46 10.26Z";
var mdiElevatorPassengerOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L3 4.9C3 4.94 3 4.97 3 5V19C3 20.1 3.9 21 5 21H19C19.03 21 19.06 21 19.1 21L20.84 22.73L22.11 21.46M5 19V6.89L7.65 9.54C6.71 9.71 6 10.5 6 11.5V14H7V18H10V14H11V12.89L17.11 19H5M8.2 5L6.2 3H19C20.1 3 21 3.9 21 5V17.8L19 15.8V5H8.2M18 11H14.2L13.46 10.26L15.5 7L18 11M17.31 14.11L16.2 13H18L17.31 14.11Z";
var mdiElevatorPassengerOutline = "M19 5V19H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M10 18V14H11V11.5C11 10.4 10.1 9.5 9 9.5H8C6.9 9.5 6 10.4 6 11.5V14H7V18H10M8.5 8.5C9.19 8.5 9.75 7.94 9.75 7.25S9.19 6 8.5 6 7.25 6.56 7.25 7.25 7.81 8.5 8.5 8.5M18 11L15.5 7L13 11H18M13 13L15.5 17L18 13H13Z";
var mdiElevatorUp = "M7 2L11 6H8V10H6V6H3L7 2M17 2L13 6H16V10H18V6H21L17 2M7 12H17C18.11 12 19 12.9 19 14V20C19 21.11 18.11 22 17 22H7C5.9 22 5 21.11 5 20V14C5 12.9 5.9 12 7 12M7 14V20H17V14H7Z";
var mdiEllipse = "M12,4C6.5,4 2,7.58 2,12C2,16.42 6.5,20 12,20C17.5,20 22,16.42 22,12C22,7.58 17.5,4 12,4Z";
var mdiEllipseOutline = "M12,6C16.41,6 20,8.69 20,12C20,15.31 16.41,18 12,18C7.59,18 4,15.31 4,12C4,8.69 7.59,6 12,6M12,4C6.5,4 2,7.58 2,12C2,16.42 6.5,20 12,20C17.5,20 22,16.42 22,12C22,7.58 17.5,4 12,4Z";
var mdiEmail = "M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z";
var mdiEmailAlert = "M18 8L10 13L2 8V6L10 11L18 6M18 4H2C.9 4 0 4.9 0 6V18C0 19.1 .9 20 2 20H18C19.1 20 20 19.1 20 18V6C20 4.9 19.1 4 18 4M24 7H22V13H24V7M24 15H22V17H24V15Z";
var mdiEmailAlertOutline = "M24 7H22V13H24V7M24 15H22V17H24V15M20 6C20 4.9 19.1 4 18 4H2C.9 4 0 4.9 0 6V18C0 19.1 .9 20 2 20H18C19.1 20 20 19.1 20 18V6M18 6L10 11L2 6H18M18 18H2V8L10 13L18 8V18Z";
var mdiEmailArrowLeft = "M13 19C13 15.69 15.69 13 19 13C20.1 13 21.12 13.3 22 13.81V6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19M4 8V6L12 11L20 6V8L12 13L4 8M18 16V18H22V20H18V22L15 19L18 16Z";
var mdiEmailArrowLeftOutline = "M13 19C13 18.66 13.04 18.33 13.09 18H4V8L12 13L20 8V13.09C20.72 13.21 21.39 13.46 22 13.81V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19M20 6L12 11L4 6H20M18 16V18H22V20H18V22L15 19L18 16Z";
var mdiEmailArrowRight = "M13 19C13 15.69 15.69 13 19 13C20.1 13 21.12 13.3 22 13.81V6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19M4 8V6L12 11L20 6V8L12 13L4 8M20 22V20H16V18H20V16L23 19L20 22Z";
var mdiEmailArrowRightOutline = "M13 19C13 18.66 13.04 18.33 13.09 18H4V8L12 13L20 8V13.09C20.72 13.21 21.39 13.46 22 13.81V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19M20 6L12 11L4 6H20M20 22V20H16V18H20V16L23 19L20 22Z";
var mdiEmailBox = "M5,3A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5M6.4,6.5H17.6C18.37,6.5 19,7.12 19,7.9V16.1A1.4,1.4 0 0,1 17.6,17.5H6.4C5.63,17.5 5,16.87 5,16.1V7.9C5,7.12 5.62,6.5 6.4,6.5M6,8V10L12,14L18,10V8L12,12L6,8Z";
var mdiEmailCheck = "M13 19C13 15.69 15.69 13 19 13C20.1 13 21.12 13.3 22 13.81V6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19M4 8V6L12 11L20 6V8L12 13L4 8M17.75 22.16L15 19.16L16.16 18L17.75 19.59L21.34 16L22.5 17.41L17.75 22.16";
var mdiEmailCheckOutline = "M13 19C13 18.66 13.04 18.33 13.09 18H4V8L12 13L20 8V13.09C20.72 13.21 21.39 13.46 22 13.81V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19M20 6L12 11L4 6H20M17.75 22.16L15 19.16L16.16 18L17.75 19.59L21.34 16L22.5 17.41L17.75 22.16";
var mdiEmailEdit = "M21,12.13C20.85,12.14 20.71,12.19 20.61,12.3L19.61,13.3L21.66,15.3L22.66,14.3C22.88,14.09 22.88,13.74 22.66,13.53L21.42,12.3C21.32,12.19 21.18,12.14 21.04,12.13M19.04,13.88L13,19.94V22H15.06L21.12,15.93M20,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H11V19.11L19.24,10.89C19.71,10.4 20.36,10.13 21.04,10.13C21.38,10.13 21.72,10.19 22.04,10.32V6C22.04,4.88 21.12,4 20,4M20,8L12,13L4,8V6L12,11L20,6";
var mdiEmailEditOutline = "M19.07 13.88L13 19.94V22H15.06L21.12 15.93M22.7 13.58L21.42 12.3C21.32 12.19 21.18 12.13 21.04 12.13C20.89 12.14 20.75 12.19 20.65 12.3L19.65 13.3L21.7 15.3L22.7 14.3C22.89 14.1 22.89 13.78 22.7 13.58M11 18H4V8L12 13L20 8V10H22V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H11V18M20 6L12 11L4 6H20Z";
var mdiEmailFast = "M22 5.5H9C7.9 5.5 7 6.4 7 7.5V16.5C7 17.61 7.9 18.5 9 18.5H22C23.11 18.5 24 17.61 24 16.5V7.5C24 6.4 23.11 5.5 22 5.5M22 9.17L15.5 12.5L9 9.17V7.5L15.5 10.81L22 7.5V9.17M5 16.5C5 16.67 5.03 16.83 5.05 17H1C.448 17 0 16.55 0 16S.448 15 1 15H5V16.5M3 7H5.05C5.03 7.17 5 7.33 5 7.5V9H3C2.45 9 2 8.55 2 8S2.45 7 3 7M1 12C1 11.45 1.45 11 2 11H5V13H2C1.45 13 1 12.55 1 12Z";
var mdiEmailFastOutline = "M22 5.5H9C7.9 5.5 7 6.4 7 7.5V16.5C7 17.61 7.9 18.5 9 18.5H22C23.11 18.5 24 17.61 24 16.5V7.5C24 6.4 23.11 5.5 22 5.5M22 16.5H9V9.17L15.5 12.5L22 9.17V16.5M15.5 10.81L9 7.5H22L15.5 10.81M5 16.5C5 16.67 5.03 16.83 5.05 17H1C.448 17 0 16.55 0 16S.448 15 1 15H5V16.5M3 7H5.05C5.03 7.17 5 7.33 5 7.5V9H3C2.45 9 2 8.55 2 8S2.45 7 3 7M1 12C1 11.45 1.45 11 2 11H5V13H2C1.45 13 1 12.55 1 12Z";
var mdiEmailHeartOutline = "M10 9C8.9 9 8 9.92 8 11.05C8 11.62 8.22 12.12 8.59 12.5L12 16L15.42 12.5C15.78 12.13 16 11.61 16 11.05C16 9.92 15.1 9 14 9C13.46 9 12.95 9.23 12.59 9.6L12 10.2L11.42 9.61C11.05 9.23 10.54 9 10 9M20 4C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H20M16.7 8.06L20 6H4L7.3 8.06C6.89 8.45 6.55 8.92 6.33 9.45L4 8V18H20V8L17.67 9.45C17.45 8.92 17.11 8.45 16.7 8.06Z";
var mdiEmailLock = "M12 18.2C12 17.24 12.5 16.34 13.2 15.74V15.5C13.2 13.06 15.4 11 18 11C19.65 11 21.13 11.83 22 13.06V6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H12V18.2M4 6L12 11L20 6V8L12 13L4 8V6M20.8 17V15.5C20.8 14.1 19.4 13 18 13S15.2 14.1 15.2 15.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17M19.5 17H16.5V15.5C16.5 14.7 17.2 14.2 18 14.2S19.5 14.7 19.5 15.5V17Z";
var mdiEmailLockOutline = "M12 18.2C12 18.13 12 18.07 12 18H4V8L12 13L20 8V11.44C20.81 11.8 21.5 12.36 22 13.06V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H12V18.2M20 6L12 11L4 6H20M20.8 17V15.5C20.8 14.1 19.4 13 18 13S15.2 14.1 15.2 15.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17M19.5 17H16.5V15.5C16.5 14.7 17.2 14.2 18 14.2S19.5 14.7 19.5 15.5V17Z";
var mdiEmailMarkAsUnread = "M18.84,7H16.22L10.5,4L4,7.41V17A2,2 0 0,1 2,15V7.17C2,6.5 2.28,6.06 2.81,5.81L10.5,2L18.05,5.81C18.5,6.09 18.78,6.5 18.84,7M7,8H20A2,2 0 0,1 22,10V19A2,2 0 0,1 20,21H7A2,2 0 0,1 5,19V10A2,2 0 0,1 7,8M20,11.67V10L13.5,13.31L7,10V11.67L13.5,15L20,11.67Z";
var mdiEmailMinus = "M13 19C13 15.69 15.69 13 19 13C20.1 13 21.12 13.3 22 13.81V6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19M4 8V6L12 11L20 6V8L12 13L4 8M23 18V20H15V18H23Z";
var mdiEmailMinusOutline = "M13 19C13 18.66 13.04 18.33 13.09 18H4V8L12 13L20 8V13.09C20.72 13.21 21.39 13.46 22 13.81V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19M20 6L12 11L4 6H20M23 18V20H15V18H23Z";
var mdiEmailMultiple = "M22,6V4L14,9L6,4V6L14,11L22,6M22,2A2,2 0 0,1 24,4V16A2,2 0 0,1 22,18H6C4.89,18 4,17.1 4,16V4C4,2.89 4.89,2 6,2H22M2,6V20H20V22H2A2,2 0 0,1 0,20V6H2Z";
var mdiEmailMultipleOutline = "M2 6V20H20V22H2C.895 22 0 21.11 0 20V6H2M24 4C24 2.9 23.1 2 22 2H6C4.9 2 4 2.9 4 4V16C4 17.1 4.9 18 6 18H22C23.1 18 24 17.1 24 16V4M22 4L14 9L6 4H22M22 16H6V6L14 11L22 6V16Z";
var mdiEmailNewsletter = "M12 .64L8.23 3H5V5L2.97 6.29C2.39 6.64 2 7.27 2 8V18C2 19.11 2.9 20 4 20H20C21.11 20 22 19.11 22 18V8C22 7.27 21.61 6.64 21.03 6.29L19 5V3H15.77M7 5H17V9.88L12 13L7 9.88M8 6V7.5H16V6M5 7.38V8.63L4 8M19 7.38L20 8L19 8.63M8 8.5V10H16V8.5Z";
var mdiEmailOff = "M22.1 21.5L2.4 1.7L1.1 3L2.6 4.5C2.2 4.9 2 5.4 2 6V18C2 19.1 2.9 20 4 20H18.1L20.8 22.7L22.1 21.5M4 8V6L4.3 6.2L9.6 11.5L4 8M13.4 10.2L7.2 4H20C21.1 4 22 4.9 22 6V18C22 18.2 22 18.5 21.9 18.7L14.6 11.4L20 8V6L13.4 10.2Z";
var mdiEmailOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L2.6 4.5C2.3 4.9 2 5.4 2 6V18C2 19.1 2.9 20 4 20H18.1L20.8 22.7L22.1 21.5M4 18V8L9.6 11.5L16.1 18H4M9.2 6L7.2 4H20C21.1 4 22 4.9 22 6V18C22 18.2 22 18.5 21.9 18.7L20 16.8V8L14.6 11.4L13.4 10.2L20 6H9.2Z";
var mdiEmailOpen = "M4,8L12,13L20,8V8L12,3L4,8V8M22,8V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V8C2,7.27 2.39,6.64 2.97,6.29L12,0.64L21.03,6.29C21.61,6.64 22,7.27 22,8Z";
var mdiEmailOpenHeartOutline = "M10 9C8.9 9 8 9.92 8 11.05C8 11.62 8.22 12.12 8.59 12.5L12 16L15.42 12.5C15.78 12.13 16 11.61 16 11.05C16 9.92 15.1 9 14 9C13.46 9 12.95 9.23 12.59 9.6L12 10.2L11.42 9.61C11.05 9.23 10.54 9 10 9M12 .64L21.03 6.29C21.61 6.64 22 7.27 22 8V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V8C2 7.27 2.39 6.64 2.97 6.29L12 .64M4 10V18H20V10L18 11.25C18 11.19 18 11.12 18 11.05C18 10.5 17.88 9.95 17.67 9.45L20 8L12 3L4 8L6.33 9.45C6.12 9.95 6 10.5 6 11.05C6 11.12 6 11.19 6 11.25L4 10Z";
var mdiEmailOpenMultiple = "M6,8L14,13L22,8V8L14,3L6,8V8M24,8V18A2,2 0 0,1 22,20H6A2,2 0 0,1 4,18V8C4,7.27 4.39,6.64 4.97,6.29L14,0.64L23.03,6.29C23.61,6.64 24,7.27 24,8M2,8V22H20V24H2A2,2 0 0,1 0,22V8H2Z";
var mdiEmailOpenMultipleOutline = "M2 8V22H20V24H2C.895 24 0 23.11 0 22V8H2M23.03 6.29L14 .64L4.97 6.29C4.39 6.64 4 7.27 4 8V18C4 19.1 4.9 20 6 20H22C23.1 20 24 19.1 24 18V8C24 7.27 23.61 6.64 23.03 6.29M22 18H6V10L14 15L22 10V18M14 13L6 8L14 3L22 8L14 13Z";
var mdiEmailOpenOutline = "M21.03 6.29L12 .64L2.97 6.29C2.39 6.64 2 7.27 2 8V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 7.27 21.61 6.64 21.03 6.29M20 18H4V10L12 15L20 10V18M12 13L4 8L12 3L20 8L12 13Z";
var mdiEmailOutline = "M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z";
var mdiEmailPlus = "M13 19C13 15.69 15.69 13 19 13C20.1 13 21.12 13.3 22 13.81V6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19M4 8V6L12 11L20 6V8L12 13L4 8M20 15V18H23V20H20V23H18V20H15V18H18V15H20Z";
var mdiEmailPlusOutline = "M13 19C13 18.66 13.04 18.33 13.09 18H4V8L12 13L20 8V13.09C20.72 13.21 21.39 13.46 22 13.81V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19M20 6L12 11L4 6H20M20 15V18H23V20H20V23H18V20H15V18H18V15H20Z";
var mdiEmailRemove = "M20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H20C21.1 4 22 4.89 22 6V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M20 8V6L12 11L4 6V8L12 13L20 8Z";
var mdiEmailRemoveOutline = "M13.09 18H4V8L12 13L20 8V13.09C20.72 13.21 21.39 13.46 22 13.81V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H13.09C13.04 19.67 13 19.34 13 19C13 18.66 13.04 18.33 13.09 18M20 6L12 11L4 6H20M20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19Z";
var mdiEmailSeal = "M12.5 13.3C12.2 12.4 12.4 11.7 12.5 11.3C12.4 10.9 12.2 10.3 12.4 9.4C12.7 8.6 13.2 8.2 13.5 7.9C13.6 7.5 13.8 6.9 14.6 6.3C15.3 5.8 16 5.8 16.4 5.8C16.5 5.7 16.7 5.6 16.9 5.5V2.6C17 1.7 16.3 1 15.4 1H2.6C1.7 1 1 1.7 1 2.6V12.4C1 13.3 1.7 14 2.6 14H12.9C12.7 13.8 12.6 13.6 12.5 13.3M3 5V3L9 6L15 3V5L9 8L3 5M22.6 9.9C22.4 9.3 21.9 9.2 21.6 8.9C21.4 8.6 21.4 8 20.9 7.7C20.4 7.3 19.9 7.5 19.5 7.4C19.1 7.3 18.8 6.8 18.2 6.8S17.3 7.2 16.9 7.4C16.5 7.5 16 7.3 15.5 7.7C15 8 15.1 8.5 14.8 8.9C14.5 9.2 14 9.4 13.8 9.9C13.6 10.5 14 10.9 14 11.3C14 11.7 13.6 12.1 13.8 12.7C14 13.3 14.5 13.4 14.8 13.7C15 14 15 14.6 15.5 14.9C16 15.3 16.5 15.1 16.9 15.2C17.3 15.3 17.6 15.8 18.2 15.8S19.1 15.4 19.5 15.2C19.9 15.1 20.4 15.3 20.9 14.9C21.4 14.5 21.4 14 21.6 13.7C21.9 13.4 22.4 13.2 22.6 12.7C22.8 12.1 22.4 11.7 22.4 11.3C22.4 10.9 22.8 10.5 22.6 9.9M18.2 14.4C16.5 14.4 15.2 13 15.2 11.4S16.6 8.4 18.2 8.4 21.2 9.8 21.2 11.4 19.9 14.4 18.2 14.4M19.7 11.3C19.7 12.1 19 12.8 18.2 12.8S16.7 12.1 16.7 11.3C16.7 10.5 17.4 9.8 18.2 9.8S19.7 10.5 19.7 11.3M19.5 17.1L19 19.8L18.4 22.9L16.4 21L14 22.1L15 16.4C15.4 16.6 15.9 16.7 16.4 16.7C16.7 16.9 17.1 17.1 17.4 17.2C17.6 17.3 17.9 17.3 18.2 17.3C18.7 17.4 19.1 17.3 19.5 17.1M22.7 19.5L20.7 18.8L21.1 16.6L21.7 16.3L21.8 16.2L22.7 19.5Z";
var mdiEmailSealOutline = "M12.5 13.3C12.3 12.8 12.3 12.4 12.4 12H3V4.5L9 8.5L15 4.5V6.2C15.6 5.9 16.1 5.9 16.4 5.9C16.5 5.8 16.7 5.7 16.9 5.6V2.6C17 1.7 16.3 1 15.4 1H2.6C1.7 1 1 1.7 1 2.6V12.4C1 13.3 1.7 14 2.6 14H12.9C12.7 13.8 12.6 13.6 12.5 13.3M15 3L9 7L3 3H15M22.6 9.9C22.4 9.3 21.9 9.2 21.6 8.9C21.4 8.6 21.4 8 20.9 7.7C20.4 7.3 19.9 7.5 19.5 7.4C19.1 7.3 18.8 6.8 18.2 6.8S17.3 7.2 16.9 7.4C16.5 7.5 16 7.3 15.5 7.7C15 8 15.1 8.5 14.8 8.9C14.5 9.2 14 9.4 13.8 9.9C13.6 10.5 14 10.9 14 11.3C14 11.7 13.6 12.1 13.8 12.7C14 13.3 14.5 13.4 14.8 13.7C15 14 15 14.6 15.5 14.9C16 15.3 16.5 15.1 16.9 15.2C17.3 15.3 17.6 15.8 18.2 15.8S19.1 15.4 19.5 15.2C19.9 15.1 20.4 15.3 20.9 14.9C21.4 14.5 21.4 14 21.6 13.7C21.9 13.4 22.4 13.2 22.6 12.7C22.8 12.1 22.4 11.7 22.4 11.3C22.4 10.9 22.8 10.5 22.6 9.9M18.2 14.4C16.5 14.4 15.2 13 15.2 11.4S16.6 8.4 18.2 8.4 21.2 9.8 21.2 11.4 19.9 14.4 18.2 14.4M19.7 11.3C19.7 12.1 19 12.8 18.2 12.8S16.7 12.1 16.7 11.3C16.7 10.5 17.4 9.8 18.2 9.8S19.7 10.5 19.7 11.3M19.5 17.1L19 19.8L18.4 22.9L16.4 21L14 22.1L15 16.4C15.4 16.6 15.9 16.7 16.4 16.7C16.7 16.9 17.1 17.1 17.4 17.2C17.6 17.3 17.9 17.3 18.2 17.3C18.7 17.4 19.1 17.3 19.5 17.1M22.7 19.5L20.7 18.8L21.1 16.6L21.7 16.3L21.8 16.2L22.7 19.5Z";
var mdiEmailSearch = "M3,4H19A2,2 0 0,1 21,6V10.82C20,9.85 18.7,9.23 17.31,9.06L19,8V6L11,11L3,6V8L10.62,12.76C10.21,13.62 10,14.55 10,15.5C10,17.18 10.65,18.79 11.81,20H3A2,2 0 0,1 1,18V6C1,4.89 1.89,4 3,4M16.5,11C19,11 21,13 21,15.5C21,16.38 20.75,17.21 20.31,17.9L23.39,21L22,22.39L18.88,19.32C18.19,19.75 17.37,20 16.5,20C14,20 12,18 12,15.5C12,13 14,11 16.5,11M16.5,13A2.5,2.5 0 0,0 14,15.5A2.5,2.5 0 0,0 16.5,18A2.5,2.5 0 0,0 19,15.5A2.5,2.5 0 0,0 16.5,13Z";
var mdiEmailSearchOutline = "M16.5 11C19 11 21 13 21 15.5C21 16.38 20.75 17.21 20.31 17.9L23.39 21L22 22.39L18.88 19.32C18.19 19.75 17.37 20 16.5 20C14 20 12 18 12 15.5S14 11 16.5 11M16.5 13C15.12 13 14 14.12 14 15.5S15.12 18 16.5 18 19 16.88 19 15.5 17.88 13 16.5 13M10.5 18H3V8L10.62 12.76C11.65 10.54 13.9 9 16.5 9C16.77 9 17.04 9 17.31 9.06L19 8V9.5C19.75 9.81 20.42 10.27 21 10.82V6C21 4.9 20.1 4 19 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H11.82C11.27 19.42 10.82 18.75 10.5 18M19 6L11 11L3 6H19Z";
var mdiEmailSync = "M3 4C1.89 4 1 4.89 1 6V18C1 19.11 1.9 20 3 20H13.5A6.5 6.5 0 0 1 13 17.5A6.5 6.5 0 0 1 19.5 11A6.5 6.5 0 0 1 21 11.18V6C21 4.89 20.1 4 19 4H3M3 6L11 11L19 6V8L11 13L3 8V6M19 12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5V12M15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29Z";
var mdiEmailSyncOutline = "M3 4C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H13.5A6.5 6.5 0 0 1 13 18H3V8L11 13L19 8V11A6.5 6.5 0 0 1 19.5 11A6.5 6.5 0 0 1 21 11.18V6C21 4.9 20.1 4 19 4H3M3 6H19L11 11L3 6M19 12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5V12M15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29Z";
var mdiEmailVariant = "M12,13L2,6.76V6C2,4.89 2.89,4 4,4H20A2,2 0 0,1 22,6V6.75L12,13M22,18A2,2 0 0,1 20,20H4C2.89,20 2,19.1 2,18V9.11L4,10.36V18H20V10.36L22,9.11V18Z";
var mdiEmber = "M22,14.22C22,14.22 17.61,17.35 14.72,17.39C11.84,17.44 12.13,15.56 12.13,15.56C12.13,15.56 22.71,11.94 19.83,4.79C18.53,2.95 17,2.37 14.89,2.42C12.76,2.46 10.17,3.76 8.46,7.6C7.64,9.44 7.41,11.18 7.24,12.5V12.5C7.24,12.5 5.32,12.88 4.32,12.04C3.32,11.2 2.77,12.04 2.77,12.04C2.77,12.04 1.03,14.2 2.75,14.87C4.46,15.54 7.12,15.82 7.12,15.82V15.82C7.36,17 8.08,19 10.17,20.6C13.3,23 19.32,20.4 19.32,20.4M11.63,12.33C11.76,7.36 15,5.18 16.15,6.27C17.27,7.36 16.86,9.7 14.72,11.16C12.59,12.63 11.63,12.33 11.63,12.33Z";
var mdiEmby = "M11,2L6,7L7,8L2,13L7,18L8,17L13,22L18,17L17,16L22,11L17,6L16,7L11,2M10,8.5L16,12L10,15.5V8.5Z";
var mdiEmoticon = "M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M15.5,8A1.5,1.5 0 0,1 17,9.5A1.5,1.5 0 0,1 15.5,11A1.5,1.5 0 0,1 14,9.5A1.5,1.5 0 0,1 15.5,8M8.5,8A1.5,1.5 0 0,1 10,9.5A1.5,1.5 0 0,1 8.5,11A1.5,1.5 0 0,1 7,9.5A1.5,1.5 0 0,1 8.5,8M12,17.5C9.67,17.5 7.69,16.04 6.89,14H17.11C16.3,16.04 14.33,17.5 12,17.5Z";
var mdiEmoticonAngry = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,9.5V8L10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5M14.77,17.23C14.32,16.5 13.25,16 12,16C10.75,16 9.68,16.5 9.23,17.23L7.81,15.81C8.71,14.72 10.25,14 12,14C13.75,14 15.29,14.72 16.19,15.81L14.77,17.23M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5L17,8V9.5Z";
var mdiEmoticonAngryOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,14C13.75,14 15.29,14.72 16.19,15.81L14.77,17.23C14.32,16.5 13.25,16 12,16C10.75,16 9.68,16.5 9.23,17.23L7.81,15.81C8.71,14.72 10.25,14 12,14M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5V8L10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5L17,8V9.5";
var mdiEmoticonConfused = "M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2M8.5 8A1.5 1.5 0 1 1 7 9.5A1.54 1.54 0 0 1 8.5 8M17 16H13A4 4 0 0 0 9.53 18L7.8 17A6 6 0 0 1 13 14H17M15.5 11A1.5 1.5 0 1 1 17 9.5A1.54 1.54 0 0 1 15.5 11Z";
var mdiEmoticonConfusedOutline = "M20 12A8 8 0 1 0 12 20A8 8 0 0 0 20 12M22 12A10 10 0 1 1 12 2A10 10 0 0 1 22 12M15.5 8A1.5 1.5 0 1 1 14 9.5A1.54 1.54 0 0 1 15.5 8M10 9.5A1.5 1.5 0 1 1 8.5 8A1.54 1.54 0 0 1 10 9.5M17 15H13A4 4 0 0 0 9.53 17L7.8 16A6 6 0 0 1 13 13H17Z";
var mdiEmoticonCool = "M3.22,7.22C4.91,4.11 8.21,2 12,2C15.79,2 19.09,4.11 20.78,7.22L20,8H4L3.22,7.22M21.4,8.6C21.78,9.67 22,10.81 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12C2,10.81 2.22,9.67 2.6,8.6L4,10H5C5,11.38 7.12,12.5 8.5,12.5C9.88,12.5 11.25,11.38 11.25,10H12.75C12.75,11.38 14.12,12.5 15.5,12.5C16.88,12.5 19,11.38 19,10H20L21.4,8.6M16.19,15.42L14.77,14C14.32,14.72 13.25,15.23 12,15.23C10.75,15.23 9.68,14.72 9.23,14L7.81,15.42C8.71,16.5 10.25,17.23 12,17.23C13.75,17.23 15.29,16.5 16.19,15.42Z";
var mdiEmoticonCoolOutline = "M19,10C19,11.38 16.88,12.5 15.5,12.5C14.12,12.5 12.75,11.38 12.75,10H11.25C11.25,11.38 9.88,12.5 8.5,12.5C7.12,12.5 5,11.38 5,10H4.25C4.09,10.64 4,11.31 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12C20,11.31 19.91,10.64 19.75,10H19M12,4C9.04,4 6.45,5.61 5.07,8H18.93C17.55,5.61 14.96,4 12,4M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z";
var mdiEmoticonCry = "M5.14,17.57C5.14,16.5 6.32,14.5 7.57,12.81C8.82,14.5 10,16.5 10,17.57A2.43,2.43 0 0,1 7.57,20C6.23,20 5.14,18.91 5.14,17.57M22,12A10,10 0 0,1 12,22C11.08,22 10.18,21.86 9.33,21.63C10.9,20.95 12,19.39 12,17.57C12,17.12 11.89,16.6 11.69,16C11.79,16 11.89,16 12,16C13.25,16 14.32,16.5 14.77,17.23L16.19,15.81C15.29,14.72 13.75,14 12,14C11.59,14 11.19,14.04 10.81,14.12C10.38,13.36 9.85,12.53 9.19,11.63L8.71,11C9.42,10.87 10,10.23 10,9.5C10,8.7 9.3,8 8.5,8C7.7,8 7,8.7 7,9.5C7,9.69 7.04,9.87 7.11,10.04L5.96,11.63C4.4,13.75 3.5,15.5 3.23,16.81C2.45,15.38 2,13.74 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M17,9.5C17,8.7 16.3,8 15.5,8C14.7,8 14,8.7 14,9.5C14,10.3 14.7,11 15.5,11C16.3,11 17,10.3 17,9.5Z";
var mdiEmoticonCryOutline = "M7.57,20C6.23,20 5.14,18.91 5.14,17.57C5.14,16.5 6.32,14.5 7.57,12.81C8.82,14.5 10,16.5 10,17.57A2.43,2.43 0 0,1 7.57,20M12,2A10,10 0 0,0 2,12C2,13.75 2.45,15.38 3.24,16.81C3.4,16 3.81,15.07 4.31,14.17C4.11,13.5 4,12.75 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20C11.76,20 11.53,20 11.29,19.96C10.82,20.7 10.14,21.28 9.34,21.63C10.19,21.87 11.08,22 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,14C11.59,14 11.19,14.04 10.81,14.12C11.16,14.75 11.47,15.4 11.69,16C11.79,16 11.89,16 12,16C13.25,16 14.32,16.5 14.77,17.23L16.19,15.81C15.29,14.72 13.75,14 12,14M15.5,8C14.7,8 14,8.7 14,9.5C14,10.3 14.7,11 15.5,11C16.3,11 17,10.3 17,9.5C17,8.7 16.3,8 15.5,8M10,9.5C10,8.7 9.3,8 8.5,8C7.7,8 7,8.7 7,9.5C7,10.3 7.7,11 8.5,11C9.3,11 10,10.3 10,9.5";
var mdiEmoticonDead = "M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2M6.76,8.82L7.82,7.76L8.88,8.82L9.94,7.76L11,8.82L9.94,9.88L11,10.94L9.94,12L8.88,10.94L7.82,12L6.76,10.94L7.82,9.88L6.76,8.82M6.89,17.5C7.69,15.46 9.67,14 12,14C14.33,14 16.31,15.46 17.11,17.5H6.89M17.24,10.94L16.18,12L15.12,10.94L14.06,12L13,10.94L14.06,9.88L13,8.82L14.06,7.76L15.12,8.82L16.18,7.76L17.24,8.82L16.18,9.88L17.24,10.94Z";
var mdiEmoticonDeadOutline = "M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M16.18,7.76L15.12,8.82L14.06,7.76L13,8.82L14.06,9.88L13,10.94L14.06,12L15.12,10.94L16.18,12L17.24,10.94L16.18,9.88L17.24,8.82L16.18,7.76M7.82,12L8.88,10.94L9.94,12L11,10.94L9.94,9.88L11,8.82L9.94,7.76L8.88,8.82L7.82,7.76L6.76,8.82L7.82,9.88L6.76,10.94L7.82,12M12,14C9.67,14 7.69,15.46 6.89,17.5H17.11C16.31,15.46 14.33,14 12,14Z";
var mdiEmoticonDevil = "M22.5,2.09C21.6,3 20.13,3.73 18.31,4.25C16.59,2.84 14.39,2 12,2C9.61,2 7.41,2.84 5.69,4.25C3.87,3.73 2.4,3 1.5,2.09C1.53,3.72 2.35,5.21 3.72,6.4C2.63,8 2,9.92 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,9.92 21.37,8 20.28,6.4C21.65,5.21 22.47,3.72 22.5,2.09M7.5,8.5L10.5,10C10.5,10.8 9.8,11.5 9,11.5C8.2,11.5 7.5,10.8 7.5,10V8.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23M16.5,10C16.5,10.8 15.8,11.5 15,11.5C14.2,11.5 13.5,10.8 13.5,10L16.5,8.5V10Z";
var mdiEmoticonDevilOutline = "M1.5,2.09C2.4,3 3.87,3.73 5.69,4.25C7.41,2.84 9.61,2 12,2C14.39,2 16.59,2.84 18.31,4.25C20.13,3.73 21.6,3 22.5,2.09C22.47,3.72 21.65,5.21 20.28,6.4C21.37,8 22,9.92 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12C2,9.92 2.63,8 3.72,6.4C2.35,5.21 1.53,3.72 1.5,2.09M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M10.5,10C10.5,10.8 9.8,11.5 9,11.5C8.2,11.5 7.5,10.8 7.5,10V8.5L10.5,10M16.5,10C16.5,10.8 15.8,11.5 15,11.5C14.2,11.5 13.5,10.8 13.5,10L16.5,8.5V10M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z";
var mdiEmoticonExcited = "M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2M8.88,7.82L11,9.94L9.94,11L8.88,9.94L7.82,11L6.76,9.94L8.88,7.82M12,17.5C9.67,17.5 7.69,16.04 6.89,14H17.11C16.31,16.04 14.33,17.5 12,17.5M16.18,11L15.12,9.94L14.06,11L13,9.94L15.12,7.82L17.24,9.94L16.18,11Z";
var mdiEmoticonExcitedOutline = "M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M13,9.94L14.06,11L15.12,9.94L16.18,11L17.24,9.94L15.12,7.82L13,9.94M8.88,9.94L9.94,11L11,9.94L8.88,7.82L6.76,9.94L7.82,11L8.88,9.94M12,17.5C14.33,17.5 16.31,16.04 17.11,14H6.89C7.69,16.04 9.67,17.5 12,17.5Z";
var mdiEmoticonFrown = "M12 2C6.47 2 2 6.5 2 12S6.47 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M15.5 8C16.33 8 17 8.67 17 9.5S16.33 11 15.5 11 14 10.33 14 9.5 14.67 8 15.5 8M8.5 8C9.33 8 10 8.67 10 9.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8M6.89 17C7.69 14.96 9.67 13.5 12 13.5S16.31 14.96 17.11 17H6.89Z";
var mdiEmoticonFrownOutline = "M12 2C6.47 2 2 6.5 2 12S6.47 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M12 20C7.58 20 4 16.42 4 12S7.58 4 12 4 20 7.58 20 12 16.42 20 12 20M15.5 11C16.33 11 17 10.33 17 9.5S16.33 8 15.5 8 14 8.67 14 9.5 14.67 11 15.5 11M8.5 11C9.33 11 10 10.33 10 9.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11M12 13.5C9.67 13.5 7.69 14.96 6.89 17H17.11C16.31 14.96 14.33 13.5 12 13.5Z";
var mdiEmoticonHappy = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23M15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5C17,10.3 16.3,11 15.5,11Z";
var mdiEmoticonHappyOutline = "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z";
var mdiEmoticonKiss = "M18.9,18.94L15.94,16C15.76,15.79 15.55,15.5 15.55,15.05A1.3,1.3 0 0,1 16.85,13.75C17.19,13.75 17.53,13.89 17.77,14.15L18.91,15.26L20.03,14.13C20.27,13.89 20.61,13.75 20.95,13.75A1.3,1.3 0 0,1 22.25,15.05C22.25,15.39 22.11,15.73 21.87,15.97L18.9,18.94M17.46,19.62C15.72,21.1 13.47,22 11,22A10,10 0 0,1 1,12A10,10 0 0,1 11,2A10,10 0 0,1 21,12C21,12.09 21,12.17 20.95,12.25C20.21,12.25 19.5,12.55 18.97,13.07L18.9,13.14L18.84,13.09C18.32,12.55 17.6,12.25 16.85,12.25A2.8,2.8 0 0,0 14.05,15.05C14.05,15.78 14.34,16.5 14.87,17.03L17.46,19.62M13,9.5C13,10.3 13.7,11 14.5,11C15.3,11 16,10.3 16,9.5C16,8.7 15.3,8 14.5,8C13.7,8 13,8.7 13,9.5M9,9.5C9,8.7 8.3,8 7.5,8C6.7,8 6,8.7 6,9.5C6,10.3 6.7,11 7.5,11C8.3,11 9,10.3 9,9.5M12.94,15.18L14,14.12L11.88,12L10.82,13.06L11.88,14.12L10.82,15.18L11.88,16.24L10.82,17.3L11.88,18.36L14,16.24L12.94,15.18Z";
var mdiEmoticonKissOutline = "M9,9.5C9,10.3 8.3,11 7.5,11C6.7,11 6,10.3 6,9.5C6,8.7 6.7,8 7.5,8C8.3,8 9,8.7 9,9.5M16,9.5C16,10.3 15.3,11 14.5,11C13.7,11 13,10.3 13,9.5C13,8.7 13.7,8 14.5,8C15.3,8 16,8.7 16,9.5M14,14.12L11.88,12L10.82,13.06L11.88,14.12L10.82,15.18L11.88,16.24L10.82,17.3L11.88,18.36L14,16.24L12.94,15.18L14,14.12M16.85,13A2.05,2.05 0 0,0 14.8,15.05C14.8,15.62 15.03,16.12 15.4,16.5L18.9,20L22.4,16.5C22.77,16.13 23,15.61 23,15.05A2.05,2.05 0 0,0 20.95,13C20.4,13 19.87,13.23 19.5,13.6L18.9,14.2L18.3,13.61C17.93,13.23 17.4,13 16.85,13M15,18.92C13.82,19.6 12.46,20 11,20A8,8 0 0,1 3,12A8,8 0 0,1 11,4C15.26,4 18.73,7.33 19,11.5C19.58,11.19 20.26,11 20.95,11C20.45,5.95 16.18,2 11,2A10,10 0 0,0 1,12A10,10 0 0,0 11,22C13,22 14.88,21.4 16.45,20.38L15,18.92Z";
var mdiEmoticonLol = "M15.07 8.93V4.93A4.06 4.06 0 0 1 15.73 2.72A10 10 0 0 0 2.73 15.72A4.06 4.06 0 0 1 4.94 15.06H8.94V19.06A4.06 4.06 0 0 1 8.28 21.27A10 10 0 0 0 21.28 8.27A4.06 4.06 0 0 1 19.07 8.93M11 6H12.5V7.5H14V9H11M7.5 14V12.5H6V11H9V14M15.89 15.9A5.5 5.5 0 0 1 9.8 17L17 9.8A5.5 5.5 0 0 1 15.89 15.89M4.89 21.08A2 2 0 0 1 2.89 19.08A2 2 0 0 1 4.89 17.08H6.89V19.08A2 2 0 0 1 4.93 21.07M19.07 2.93A2 2 0 0 1 21.07 4.93A2 2 0 0 1 19.07 6.93H17.07V4.93A2 2 0 0 1 19.07 2.93Z";
var mdiEmoticonLolOutline = "M6 11V12.5H7.5V14H9V11M12.5 6H11V9H14V7.5H12.5M9.8 17A5.5 5.5 0 0 0 17 9.8M6.34 6.34A8 8 0 0 1 15.08 4.62A4.11 4.11 0 0 1 15.73 2.72A10 10 0 0 0 2.73 15.72A4.11 4.11 0 0 1 4.63 15.07A8 8 0 0 1 6.34 6.34M17.66 17.66A8 8 0 0 1 8.92 19.38A4.11 4.11 0 0 1 8.27 21.28A10 10 0 0 0 21.27 8.28A4.11 4.11 0 0 1 19.37 8.93A8 8 0 0 1 17.66 17.66M6 11V12.5H7.5V14H9V11M9.8 17A5.5 5.5 0 0 0 17 9.8M12.5 6H11V9H14V7.5H12.5M6 11V12.5H7.5V14H9V11M12.5 6H11V9H14V7.5H12.5M9.8 17A5.5 5.5 0 0 0 17 9.8M4.93 21A2 2 0 0 1 2.93 19A2 2 0 0 1 4.93 17H6.93V19A2 2 0 0 1 4.93 21.07M19.07 2.93A2 2 0 0 1 21.07 4.93A2 2 0 0 1 19.07 6.93H17.07V4.93A2 2 0 0 1 19.07 2.93Z";
var mdiEmoticonMinus = "M15 18H23V20H15V18M12 2C17.5 2 22 6.5 22 12C22 12.59 21.95 13.16 21.85 13.72C21 13.26 20.03 13 19 13C17.77 13 16.63 13.37 15.68 14H6.89C7.69 16.04 9.67 17.5 12 17.5C12.42 17.5 12.83 17.45 13.23 17.36C13.08 17.88 13 18.43 13 19C13 20.03 13.26 21 13.72 21.85C13.16 21.95 12.59 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.47 2 12 2M15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8M8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8Z";
var mdiEmoticonMinusOutline = "M15 18H23V20H15V18M12 17.5C9.67 17.5 7.69 16.04 6.89 14H15.69C14.5 14.78 13.62 15.97 13.23 17.36C12.83 17.45 12.42 17.5 12 17.5M8.5 11C7.67 11 7 10.33 7 9.5C7 8.67 7.67 8 8.5 8C9.33 8 10 8.67 10 9.5C10 10.33 9.33 11 8.5 11M15.5 11C14.67 11 14 10.33 14 9.5C14 8.67 14.67 8 15.5 8C16.33 8 17 8.67 17 9.5C17 10.33 16.33 11 15.5 11M12 20L13.07 19.93C13.18 20.61 13.4 21.26 13.72 21.85C13.16 21.95 12.58 22 12 22C6.47 22 2 17.5 2 12C2 6.5 6.47 2 12 2C17.5 2 22 6.5 22 12C22 12.59 21.95 13.16 21.85 13.72C21.26 13.4 20.62 13.18 19.93 13.07L20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20Z";
var mdiEmoticonNeutral = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,9.5A1.5,1.5 0 0,1 8.5,8A1.5,1.5 0 0,1 10,9.5A1.5,1.5 0 0,1 8.5,11A1.5,1.5 0 0,1 7,9.5M16,16H8V14H16V16M15.5,11A1.5,1.5 0 0,1 14,9.5A1.5,1.5 0 0,1 15.5,8A1.5,1.5 0 0,1 17,9.5A1.5,1.5 0 0,1 15.5,11Z";
var mdiEmoticonNeutralOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M8.5,11A1.5,1.5 0 0,1 7,9.5A1.5,1.5 0 0,1 8.5,8A1.5,1.5 0 0,1 10,9.5A1.5,1.5 0 0,1 8.5,11M17,9.5A1.5,1.5 0 0,1 15.5,11A1.5,1.5 0 0,1 14,9.5A1.5,1.5 0 0,1 15.5,8A1.5,1.5 0 0,1 17,9.5M16,14V16H8V14H16Z";
var mdiEmoticonOutline = "M12,17.5C14.33,17.5 16.3,16.04 17.11,14H6.89C7.69,16.04 9.67,17.5 12,17.5M8.5,11A1.5,1.5 0 0,0 10,9.5A1.5,1.5 0 0,0 8.5,8A1.5,1.5 0 0,0 7,9.5A1.5,1.5 0 0,0 8.5,11M15.5,11A1.5,1.5 0 0,0 17,9.5A1.5,1.5 0 0,0 15.5,8A1.5,1.5 0 0,0 14,9.5A1.5,1.5 0 0,0 15.5,11M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiEmoticonPlus = "M15 18H18V15H20V18H23V20H20V23H18V20H15V18M12 2C17.5 2 22 6.5 22 12C22 12.59 21.95 13.16 21.85 13.72C21 13.26 20.03 13 19 13C17.77 13 16.63 13.37 15.68 14H6.89C7.69 16.04 9.67 17.5 12 17.5C12.42 17.5 12.83 17.45 13.23 17.36C13.08 17.88 13 18.43 13 19C13 20.03 13.26 21 13.72 21.85C13.16 21.95 12.59 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.47 2 12 2M15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8M8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8Z";
var mdiEmoticonPlusOutline = "M15 18H18V15H20V18H23V20H20V23H18V20H15V18M12 17.5C9.67 17.5 7.69 16.04 6.89 14H15.69C14.5 14.78 13.62 15.97 13.23 17.36C12.83 17.45 12.42 17.5 12 17.5M8.5 11C7.67 11 7 10.33 7 9.5C7 8.67 7.67 8 8.5 8C9.33 8 10 8.67 10 9.5C10 10.33 9.33 11 8.5 11M15.5 11C14.67 11 14 10.33 14 9.5C14 8.67 14.67 8 15.5 8C16.33 8 17 8.67 17 9.5C17 10.33 16.33 11 15.5 11M12 20L13.07 19.93C13.18 20.61 13.4 21.26 13.72 21.85C13.16 21.95 12.58 22 12 22C6.47 22 2 17.5 2 12C2 6.5 6.47 2 12 2C17.5 2 22 6.5 22 12C22 12.59 21.95 13.16 21.85 13.72C21.26 13.4 20.62 13.18 19.93 13.07L20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20Z";
var mdiEmoticonPoop = "M11.36,2C11.15,2 10.87,2.12 10.57,2.32C10,2.7 8.85,3.9 8.4,5.1C8.06,6 8.05,6.82 8.19,7.43C7.63,7.53 7.22,7.71 7.06,7.78C6.55,8 5.47,8.96 5.37,10.45C5.34,10.97 5.41,11.5 5.57,12C4.91,12.19 4.53,12.43 4.5,12.44C4.18,12.56 3.65,12.93 3.5,13.13C3.15,13.53 2.92,14 2.79,14.5C2.5,15.59 2.6,16.83 3.13,17.83C3.42,18.39 3.82,19 4.26,19.43C5.7,20.91 8.18,21.47 10.14,21.79C12.53,22.19 15.03,22.05 17.26,21.13C20.61,19.74 21.5,17.5 21.64,16.89C21.93,15.5 21.57,14.19 21.42,13.87C21.2,13.41 20.84,12.94 20.25,12.64C19.85,12.39 19.5,12.26 19.24,12.2C19.5,11.25 19.13,10.5 18.62,9.94C17.85,9.12 17.06,9 17.06,9V9C17.32,8.5 17.42,7.9 17.28,7.32C17.12,6.61 16.73,6.16 16.22,5.86C15.7,5.55 15.06,5.4 14.4,5.28C14.08,5.22 12.75,5.03 12.2,4.27C11.75,3.65 11.74,2.53 11.62,2.2C11.57,2.07 11.5,2 11.36,2M16,9.61C16.07,9.61 16.13,9.62 16.19,9.62C17.62,9.78 18.64,11.16 18.47,12.69C18.3,14.22 17,15.34 15.57,15.18V15.18C14.14,15 13.12,13.65 13.29,12.11C13.45,10.66 14.64,9.56 16,9.61M8.62,9.61C9.95,9.65 11.06,10.78 11.16,12.21C11.28,13.75 10.21,15.08 8.78,15.19H8.77C7.34,15.3 6.08,14.14 5.96,12.6V12.6C5.85,11.06 6.92,9.73 8.35,9.62V9.62C8.44,9.61 8.53,9.61 8.62,9.61M8.64,11.31C8.6,11.31 8.57,11.31 8.53,11.32C7.97,11.39 7.57,11.9 7.64,12.45C7.7,13 8.21,13.39 8.77,13.32C9.33,13.25 9.73,12.74 9.67,12.19C9.61,11.67 9.15,11.3 8.64,11.31M15.94,11.33C15.42,11.35 15,11.75 14.96,12.28C14.92,12.83 15.35,13.31 15.91,13.34C16.5,13.38 16.96,12.95 17,12.4C17.04,11.84 16.61,11.36 16.05,11.33C16,11.33 16,11.33 15.94,11.33M8.71,16.15C9,16.14 9.26,16.23 9.5,16.28C10.68,16.5 11.7,16.53 12.19,16.53C12.68,16.53 13.69,16.5 14.86,16.28C15.27,16.2 15.74,16.03 16.11,16.28C16.59,16.6 16.24,17.75 15.5,18.53C15.04,19 13.97,19.91 12.19,19.91C10.41,19.91 9.33,19 8.88,18.53C8.14,17.75 7.79,16.6 8.26,16.28C8.4,16.19 8.55,16.15 8.71,16.15Z";
var mdiEmoticonPoopOutline = "M21.42,13.87C21.2,13.41 20.84,12.94 20.25,12.64C19.85,12.39 19.5,12.26 19.24,12.2C19.5,11.25 19.13,10.5 18.62,9.94C17.85,9.12 17.06,9 17.06,9C17.32,8.5 17.42,7.9 17.28,7.32C17.12,6.61 16.73,6.16 16.22,5.86C15.7,5.55 15.06,5.4 14.4,5.28C14.08,5.22 12.75,5.03 12.2,4.27C11.75,3.65 11.74,2.53 11.62,2.2C11.57,2.07 11.5,2 11.36,2C11.15,2 10.87,2.12 10.57,2.32C10,2.7 8.85,3.9 8.4,5.1C8.06,6 8.05,6.82 8.19,7.43C7.63,7.53 7.22,7.71 7.06,7.78C6.55,8 5.47,8.96 5.37,10.45C5.34,10.89 5.41,11.34 5.5,11.78C5.5,11.86 5.5,11.94 5.5,12.03C4.88,12.22 4.53,12.43 4.5,12.44C4.18,12.56 3.65,12.93 3.5,13.13C3.15,13.53 2.92,14 2.79,14.5C2.5,15.59 2.6,16.83 3.13,17.83C3.42,18.39 3.82,19 4.26,19.43C5.7,20.91 8.18,21.47 10.14,21.79C10.96,21.93 11.8,22 12.63,22C14.22,22 15.8,21.73 17.26,21.13C20.61,19.74 21.5,17.5 21.64,16.89C21.93,15.5 21.57,14.19 21.42,13.87M16.05,11.33C16.61,11.36 17.04,11.84 17,12.4C16.96,12.95 16.5,13.38 15.91,13.34C15.35,13.31 14.92,12.83 14.96,12.28C15,11.75 15.42,11.35 15.94,11.33C16,11.33 16,11.33 16.05,11.33M20.18,16.55C20.17,16.57 19.7,18.5 16.69,19.74C15.47,20.25 14.1,20.5 12.63,20.5C11.9,20.5 11.14,20.44 10.38,20.31C8.76,20.05 6.5,19.56 5.31,18.36C5.04,18.09 4.72,17.63 4.46,17.13C4.12,16.5 4.04,15.65 4.24,14.88C4.32,14.58 4.45,14.32 4.63,14.12L4.65,14.09C4.74,14 4.95,13.88 5.03,13.84V13.84L5.14,13.8L5.26,13.74C5.32,13.7 5.46,13.63 5.67,13.55C6.13,14.81 7.28,15.7 8.59,15.7C8.67,15.7 8.74,15.69 8.82,15.69C9.65,15.63 10.41,15.22 10.94,14.55C11.47,13.89 11.73,13.04 11.66,12.17C11.54,10.5 10.22,9.16 8.64,9.11H8.62C8.5,9.11 8.4,9.11 8.31,9.12C8,9.15 7.73,9.23 7.46,9.34C7.55,9.24 7.63,9.17 7.66,9.15C7.79,9.1 8.07,9 8.45,8.91L10,8.63L9.65,7.09C9.61,6.9 9.53,6.35 9.81,5.63C9.96,5.2 10.27,4.76 10.58,4.38C10.68,4.65 10.81,4.91 11,5.15C11.77,6.23 13.12,6.58 14.06,6.74L14.13,6.76C14.6,6.84 15.13,6.95 15.46,7.15C15.67,7.28 15.76,7.41 15.82,7.67C15.87,7.87 15.84,8.1 15.73,8.31L15.21,9.2C13.95,9.5 12.95,10.64 12.79,12.06C12.59,13.87 13.78,15.46 15.5,15.68C15.62,15.69 15.74,15.7 15.85,15.7C16.56,15.7 17.25,15.44 17.82,14.95C18.23,14.59 18.54,14.13 18.74,13.62L18.9,13.66C19,13.68 19.17,13.74 19.45,13.91L19.5,13.95L19.57,14C19.78,14.08 19.94,14.26 20.05,14.5C20.13,14.67 20.38,15.6 20.18,16.55M7.64,12.45C7.57,11.9 7.97,11.39 8.53,11.32C8.57,11.31 8.6,11.31 8.64,11.31C9.15,11.3 9.61,11.67 9.67,12.19C9.73,12.74 9.33,13.25 8.77,13.32C8.21,13.39 7.7,13 7.64,12.45M8.71,16.15C9,16.14 9.26,16.23 9.5,16.28C10.68,16.5 11.7,16.53 12.19,16.53C12.68,16.53 13.69,16.5 14.86,16.28C15.27,16.2 15.74,16.03 16.11,16.28C16.59,16.6 16.24,17.75 15.5,18.53C15.04,19 13.97,19.91 12.19,19.91C10.41,19.91 9.33,19 8.88,18.53C8.14,17.75 7.79,16.6 8.26,16.28C8.4,16.19 8.55,16.15 8.71,16.15Z";
var mdiEmoticonRemove = "M16.88 15.46L19 17.59L21.12 15.47L22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.46 21.12L17.59 19L15.47 16.88L16.88 15.46M12 2C17.5 2 22 6.5 22 12C22 12.59 21.95 13.16 21.85 13.72C21 13.26 20.03 13 19 13C17.77 13 16.63 13.37 15.68 14H6.89C7.69 16.04 9.67 17.5 12 17.5C12.42 17.5 12.83 17.45 13.23 17.36C13.08 17.88 13 18.43 13 19C13 20.03 13.26 21 13.72 21.85C13.16 21.95 12.59 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.47 2 12 2M15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8M8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8Z";
var mdiEmoticonRemoveOutline = "M16.88 15.46L19 17.59L21.12 15.47L22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.46 21.12L17.59 19L15.47 16.88L16.88 15.46M12 17.5C9.67 17.5 7.69 16.04 6.89 14H15.69C14.5 14.78 13.62 15.97 13.23 17.36C12.83 17.45 12.42 17.5 12 17.5M8.5 11C7.67 11 7 10.33 7 9.5C7 8.67 7.67 8 8.5 8C9.33 8 10 8.67 10 9.5C10 10.33 9.33 11 8.5 11M15.5 11C14.67 11 14 10.33 14 9.5C14 8.67 14.67 8 15.5 8C16.33 8 17 8.67 17 9.5C17 10.33 16.33 11 15.5 11M12 20L13.07 19.93C13.18 20.61 13.4 21.26 13.72 21.85C13.16 21.95 12.58 22 12 22C6.47 22 2 17.5 2 12C2 6.5 6.47 2 12 2C17.5 2 22 6.5 22 12C22 12.59 21.95 13.16 21.85 13.72C21.26 13.4 20.62 13.18 19.93 13.07L20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20Z";
var mdiEmoticonSad = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5M14.77,17.23C14.32,16.5 13.25,16 12,16C10.75,16 9.68,16.5 9.23,17.23L7.81,15.81C8.71,14.72 10.25,14 12,14C13.75,14 15.29,14.72 16.19,15.81L14.77,17.23M15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5C17,10.3 16.3,11 15.5,11Z";
var mdiEmoticonSadOutline = "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M15.5,8C16.3,8 17,8.7 17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M12,14C13.75,14 15.29,14.72 16.19,15.81L14.77,17.23C14.32,16.5 13.25,16 12,16C10.75,16 9.68,16.5 9.23,17.23L7.81,15.81C8.71,14.72 10.25,14 12,14Z";
var mdiEmoticonSick = "M21 9C19.9 9 19 8.1 19 7S21 3 21 3 23 5.9 23 7 22.1 9 21 9M17.5 7C17.5 6.27 17.91 5.29 18.42 4.34C16.68 2.88 14.44 2 12 2C6.47 2 2 6.5 2 12S6.47 22 12 22C17.5 22 22 17.5 22 12C22 11.45 21.94 10.91 21.86 10.38C21.58 10.45 21.3 10.5 21 10.5C19.07 10.5 17.5 8.93 17.5 7M15.62 7.38L16.68 8.44L15.62 9.5L16.68 10.56L15.62 11.62L13.5 9.5L15.62 7.38M7.32 8.44L8.38 7.38L10.5 9.5L8.38 11.62L7.32 10.56L8.38 9.5L7.32 8.44M15.44 17C14.75 15.81 13.47 15 12 15S9.25 15.81 8.56 17H6.88C7.18 16.24 7.64 15.57 8.22 15L5.24 13.3C4.79 13.56 4.23 13.58 3.75 13.3C3.03 12.89 2.79 11.97 3.2 11.25S4.53 10.29 5.25 10.7C5.73 11 6 11.5 6 12L9.57 14.06C10.3 13.7 11.12 13.5 12 13.5C14.33 13.5 16.32 14.95 17.12 17H15.44Z";
var mdiEmoticonSickOutline = "M7.32 10.56L8.38 9.5L7.32 8.44L8.38 7.38L10.5 9.5L8.38 11.62L7.32 10.56M4.5 9C4.53 9 4.55 9 4.58 9C5.77 6.07 8.64 4 12 4C14.19 4 16.16 4.88 17.61 6.3C17.76 5.7 18.06 5 18.42 4.34C16.68 2.88 14.44 2 12 2C7.11 2 3.05 5.5 2.18 10.14C2.74 9.44 3.59 9 4.5 9M21 10.5C20.58 10.5 20.18 10.41 19.81 10.28C19.93 10.83 20 11.41 20 12C20 16.42 16.42 20 12 20C8.64 20 5.77 17.93 4.58 15C4.55 15 4.53 15 4.5 15C4 15 3.46 14.86 3 14.6C2.68 14.42 2.41 14.18 2.18 13.9C3.07 18.5 7.11 22 12 22C17.5 22 22 17.5 22 12C22 11.45 21.94 10.91 21.86 10.38C21.58 10.45 21.3 10.5 21 10.5M21 3C21 3 19 5.9 19 7S19.9 9 21 9 23 8.1 23 7 21 3 21 3M15.62 7.38L13.5 9.5L15.62 11.62L16.68 10.56L15.62 9.5L16.68 8.44L15.62 7.38M8.56 17C9.25 15.81 10.53 15 12 15S14.75 15.81 15.44 17H17.12C16.32 14.95 14.33 13.5 12 13.5C11.13 13.5 10.3 13.7 9.57 14.07L6 12C6 11.5 5.73 11 5.25 10.71C4.53 10.3 3.62 10.54 3.2 11.26C2.79 12 3.03 12.89 3.75 13.31C4.23 13.59 4.8 13.56 5.24 13.31L8.21 15.03C7.64 15.56 7.18 16.24 6.88 17H8.56Z";
var mdiEmoticonTongue = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7.27,11C7.1,10.71 7,10.36 7,10C7,8.89 7.89,8 9,8A2,2 0 0,1 11,10C11,10.36 10.9,10.71 10.73,11C10.39,10.4 9.74,10 9,10C8.26,10 7.61,10.4 7.27,11M16,15H15C15,17 14.1,18 13,18C11.9,18 11,17 11,15H8V13H16V15M16.73,11C16.39,10.4 15.74,10 15,10C14.26,10 13.61,10.4 13.27,11C13.1,10.71 13,10.36 13,10C13,8.89 13.89,8 15,8A2,2 0 0,1 17,10C17,10.36 16.9,10.71 16.73,11Z";
var mdiEmoticonTongueOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M9,10C8.26,10 7.61,10.4 7.27,11C7.1,10.71 7,10.36 7,10A2,2 0 0,1 9,8C10.11,8 11,8.9 11,10C11,10.36 10.9,10.71 10.73,11C10.39,10.4 9.74,10 9,10M17,10C17,10.36 16.9,10.71 16.73,11C16.39,10.4 15.74,10 15,10C14.26,10 13.61,10.4 13.27,11C13.1,10.71 13,10.36 13,10A2,2 0 0,1 15,8C16.11,8 17,8.9 17,10M16,13V15H15C15,17 14.1,18 13,18C11.9,18 11,17 11,15H8V13H16Z";
var mdiEmoticonWink = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23M17,10H13V9H17V10Z";
var mdiEmoticonWinkOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23M17,10H13V9H17V10Z";
var mdiEngine = "M7,4V6H10V8H7L5,10V13H3V10H1V18H3V15H5V18H8L10,20H18V16H20V19H23V9H20V12H18V8H12V6H15V4H7Z";
var mdiEngineOff = "M3.78,2.5L21.5,20.22L20.23,21.5L18,19.27V20H10L8,18H5V15H3V18H1V10H3V13H5V10L6.87,8.14L2.5,3.77L3.78,2.5M20,9V12H18V8H12V6H15V4H7.82L22.82,19H23V9H20Z";
var mdiEngineOffOutline = "M2.5,3.77L6.87,8.14L5,10V13H3V10H1V18H3V15H5V18H8L10,20H18V19.27L21.23,22.5L22.5,21.22L3.78,2.5L2.5,3.77M16,18H11L9,16H7V11L8,10H8.73L16,17.27V18M23,9V19H22.82L16,12.18V10H13.82L7.82,4H15V6H12V8H18V12H20V9H23Z";
var mdiEngineOutline = "M8,10H16V18H11L9,16H7V11M7,4V6H10V8H7L5,10V13H3V10H1V18H3V15H5V18H8L10,20H18V16H20V19H23V9H20V12H18V8H12V6H15V4H7Z";
var mdiEpsilon = "M15.05 7.78L16.15 6.18C16.15 6.18 14.91 5 12.77 5C10.04 5 8.35 6.84 8.35 8.76C8.35 10.68 10.08 11.69 10.08 11.69C10.08 11.69 8 12.38 8 15C8 17.63 10.14 19 12.44 19C15.38 19 17 17.04 17 17.04L15.6 15.5C15.6 15.5 14.14 16.87 12.59 16.87C10.66 16.87 10.21 15.69 10.21 14.92C10.21 13.87 10.54 12.65 13.83 12.65L13.82 10.77C13.82 10.77 10.44 11.11 10.44 8.78C10.44 7.21 11.9 6.92 12.64 6.92C14.28 6.92 15.05 7.78 15.05 7.78";
var mdiEqual = "M19,10H5V8H19V10M19,16H5V14H19V16Z";
var mdiEqualBox = "M17,16V14H7V16H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M17,10V8H7V10H17Z";
var mdiEqualizer = "M10,20H14V4H10V20M4,20H8V12H4V20M16,9V20H20V9H16Z";
var mdiEqualizerOutline = "M15,21H9V3H15V21M11,19H13V5H11V19M8,21H2V11H8V21M4,19H6V13H4V19M22,21H16V8H22V21M18,19H20V10H18V19Z";
var mdiEraser = "M16.24,3.56L21.19,8.5C21.97,9.29 21.97,10.55 21.19,11.34L12,20.53C10.44,22.09 7.91,22.09 6.34,20.53L2.81,17C2.03,16.21 2.03,14.95 2.81,14.16L13.41,3.56C14.2,2.78 15.46,2.78 16.24,3.56M4.22,15.58L7.76,19.11C8.54,19.9 9.8,19.9 10.59,19.11L14.12,15.58L9.17,10.63L4.22,15.58Z";
var mdiEraserVariant = "M15.14,3C14.63,3 14.12,3.2 13.73,3.59L2.59,14.73C1.81,15.5 1.81,16.77 2.59,17.56L5.03,20H12.69L21.41,11.27C22.2,10.5 22.2,9.23 21.41,8.44L16.56,3.59C16.17,3.2 15.65,3 15.14,3M17,18L15,20H22V18";
var mdiEscalator = "M20,8H18.95L6.95,20H4A2,2 0 0,1 2,18A2,2 0 0,1 4,16H5.29L7,14.29V10A1,1 0 0,1 8,9H9A1,1 0 0,1 10,10V11.29L17.29,4H20A2,2 0 0,1 22,6A2,2 0 0,1 20,8M8.5,5A1.5,1.5 0 0,1 10,6.5A1.5,1.5 0 0,1 8.5,8A1.5,1.5 0 0,1 7,6.5A1.5,1.5 0 0,1 8.5,5Z";
var mdiEscalatorBox = "M5 3C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3H5M14.34 6H17.05C18.16 6 19.05 6.9 19.05 8C19.05 9.11 18.16 10 17.05 10H16L10 18H7.05C5.95 18 5.05 17.11 5.05 16C5.05 14.9 5.95 14 7.05 14H8.34L14.34 6Z";
var mdiEscalatorDown = "M20 8H18.95L6.95 20H4C2.9 20 2 19.11 2 18C2 16.9 2.9 16 4 16H5.29L7 14.29V10C7 9.45 7.45 9 8 9H9C9.55 9 10 9.45 10 10V11.29L17.29 4H20C21.11 4 22 4.89 22 6C22 7.11 21.11 8 20 8M8.5 5C9.33 5 10 5.67 10 6.5C10 7.33 9.33 8 8.5 8C7.67 8 7 7.33 7 6.5C7 5.67 7.67 5 8.5 5M14.83 17.34L20.34 11.83L22.17 13.66L16.66 19.17L18.5 21H13V15.5L14.83 17.34Z";
var mdiEscalatorUp = "M20 8H18.95L6.95 20H4C2.9 20 2 19.11 2 18C2 16.9 2.9 16 4 16H5.29L7 14.29V10C7 9.45 7.45 9 8 9H9C9.55 9 10 9.45 10 10V11.29L17.29 4H20C21.11 4 22 4.89 22 6C22 7.11 21.11 8 20 8M8.5 5C9.33 5 10 5.67 10 6.5C10 7.33 9.33 8 8.5 8C7.67 8 7 7.33 7 6.5C7 5.67 7.67 5 8.5 5M20.17 15.66L14.66 21.17L12.83 19.34L18.34 13.83L16.5 12H22V17.5L20.17 15.66Z";
var mdiEslint = "M7.95,9.55L11.84,7.3C11.94,7.25 12.06,7.25 12.16,7.3L16.05,9.55C16.15,9.61 16.21,9.71 16.21,9.82V14.32C16.21,14.43 16.15,14.53 16.05,14.59L12.16,16.84C12.06,16.89 11.94,16.89 11.84,16.84L7.95,14.59C7.85,14.53 7.79,14.43 7.79,14.32V9.82C7.79,9.71 7.85,9.61 7.95,9.55M22.12,11.6C22.29,11.89 22.29,12.23 22.12,12.53L17.47,20.56C17.3,20.86 17,21 16.65,21H7.35C7,21 6.7,20.85 6.53,20.56L1.88,12.53C1.71,12.24 1.71,11.87 1.88,11.58L6.53,3.5C6.7,3.22 7,3 7.35,3H16.65C17,3 17.3,3.22 17.47,3.5L22.12,11.6M18.27,15.5V8.65C18.27,8.53 18.2,8.42 18.09,8.36L12.16,4.95C12.06,4.89 11.93,4.89 11.83,4.95L5.91,8.36C5.8,8.42 5.73,8.53 5.73,8.65V15.5C5.73,15.61 5.8,15.72 5.91,15.78L11.84,19.19C11.94,19.25 12.07,19.25 12.17,19.19L18.09,15.78C18.2,15.72 18.27,15.61 18.27,15.5Z";
var mdiEt = "M23,8.78L21.71,7.22C21.45,7.42 20.53,8 19.77,8C19.26,8 18.3,7.75 17.45,7.53C16.39,7.26 15.39,7 14.6,7C14,7 13.43,7.15 12.93,7.35C12.62,5.45 11,4 9,4C4.58,4 2,7.58 2,12C2,16.42 5.58,19 10,19C12.06,19 13.93,18.43 15.34,17.39L15,21.29L17,21.47L18,9.74C18.66,9.89 19.27,10 19.77,10C21.38,10 22.84,8.91 23,8.78M9,6A2,2 0 0,1 11,8A2,2 0 0,1 9,10H4.23C4.8,7.67 6.39,6 9,6M10,17C6.69,17 4,15.31 4,12H9C10.6,12 11.83,11.17 12.5,9.91V9.91C12.76,9.71 13.85,9 14.6,9C14.94,9 15.5,9.11 16.05,9.25L15.65,13.89C14.82,15.95 12.6,17 10,17Z";
var mdiEthereum = "M12,1.75L5.75,12.25L12,16L18.25,12.25L12,1.75M5.75,13.5L12,22.25L18.25,13.5L12,17.25L5.75,13.5Z";
var mdiEthernet = "M7,15H9V18H11V15H13V18H15V15H17V18H19V9H15V6H9V9H5V18H7V15M4.38,3H19.63C20.94,3 22,4.06 22,5.38V19.63A2.37,2.37 0 0,1 19.63,22H4.38C3.06,22 2,20.94 2,19.63V5.38C2,4.06 3.06,3 4.38,3Z";
var mdiEthernetCable = "M11,3V7H13V3H11M8,4V11H16V4H14V8H10V4H8M10,12V22H14V12H10Z";
var mdiEthernetCableOff = "M11,3H13V7H11V3M8,4H10V8H14V4H16V11H12.82L8,6.18V4M20,20.72L18.73,22L14,17.27V22H10V13.27L2,5.27L3.28,4L20,20.72Z";
var mdiEthernetOff = "M2.39 1.73L1.11 3L2.32 4.21C2.12 4.56 2 4.95 2 5.38V19.63C2 20.94 3.06 22 4.38 22H19.63C19.78 22 19.92 22 20.07 21.96L20.84 22.73L22.11 21.46L2.39 1.73M15 18H13V15H11V18H9V15H7V18H5V9H7.11L15 16.89V18M9.2 6L6.2 3H19.63C20.94 3 22 4.06 22 5.38V18.8L19 15.8V9H15V6H9.2Z";
var mdiEvPlugCcs1 = "M7.5 20C7.5 20.8 6.8 21.5 6 21.5S4.5 20.8 4.5 20 5.2 18.5 6 18.5 7.5 19.2 7.5 20M18 18.5C17.2 18.5 16.5 19.2 16.5 20S17.2 21.5 18 21.5 19.5 20.8 19.5 20 18.8 18.5 18 18.5M22 20C22 22.2 20.2 24 18 24H6C3.8 24 2 22.2 2 20S3.8 16 6 16H6.3C4.3 14.4 3 11.8 3 9C3 4 7 0 12 0S21 4 21 9C21 11.8 19.7 14.4 17.7 16H18C20.2 16 22 17.8 22 20M12 16C15.9 16 19 12.9 19 9S15.9 2 12 2 5 5.1 5 9 8.1 16 12 16M20 20C20 18.9 19.1 18 18 18H6C4.9 18 4 18.9 4 20S4.9 22 6 22H18C19.1 22 20 21.1 20 20M12.9 6.3C12.9 5.3 13.7 4.5 14.7 4.5S16.5 5.3 16.5 6.3 15.7 8.1 14.7 8.1 12.9 7.3 12.9 6.3M7.5 6.3C7.5 5.3 8.3 4.5 9.3 4.5S11.1 5.3 11.1 6.3 10.3 8.1 9.3 8.1 7.5 7.3 7.5 6.3M9.3 10.2C9.3 10.8 8.8 11.3 8.2 11.3C7.6 11.3 7.1 10.8 7.1 10.2S7.5 9 8.1 9C8.8 9 9.3 9.6 9.3 10.2M13.8 12.7C13.8 13.7 13 14.5 12 14.5S10.2 13.7 10.2 12.7 11 10.9 12 10.9 13.8 11.7 13.8 12.7M17 10.2C17 10.8 16.5 11.3 15.9 11.3C15.3 11.3 14.8 10.8 14.8 10.2S15.2 9 15.9 9C16.5 9 17 9.6 17 10.2";
var mdiEvPlugCcs2 = "M7.5 19C7.5 19.8 6.8 20.5 6 20.5S4.5 19.8 4.5 19 5.2 17.5 6 17.5 7.5 18.2 7.5 19M18 17.5C17.2 17.5 16.5 18.2 16.5 19S17.2 20.5 18 20.5 19.5 19.8 19.5 19 18.8 17.5 18 17.5M18 15H17.7C19.7 13.4 21 10.8 21 8S19.7 2.6 17.7 1H6.3C4.3 2.6 3 5.2 3 8S4.3 13.4 6.3 15H6C3.8 15 2 16.8 2 19S3.8 23 6 23H18C20.2 23 22 21.2 22 19S20.2 15 18 15M5 8C5 6.1 5.8 4.3 7.1 3H16.9C18.2 4.3 19 6.1 19 8C19 11.9 15.9 15 12 15S5 11.9 5 8M18 21H6C4.9 21 4 20.1 4 19S4.9 17 6 17H18C19.1 17 20 17.9 20 19S19.1 21 18 21M12.9 5.3C12.9 6 13.5 6.6 14.2 6.6C14.9 6.6 15.5 6 15.5 5.3S14.9 4 14.1 4C13.4 4 12.9 4.6 12.9 5.3M8.6 5.3C8.6 6 9.2 6.6 9.9 6.6C10.6 6.6 11.2 6 11.2 5.3S10.6 4 9.9 4C9.1 4 8.6 4.6 8.6 5.3M7.7 10C8.7 10 9.4 9.2 9.4 8.3C9.4 7.4 8.6 6.6 7.7 6.6S6 7.3 6 8.3C6 9.2 6.8 10 7.7 10M11.6 11.7C11.6 10.8 10.8 10 9.9 10C8.9 10 8.2 10.8 8.2 11.7C8.2 12.7 9 13.4 9.9 13.4C10.8 13.4 11.6 12.7 11.6 11.7M12 10C13 10 13.7 9.2 13.7 8.3C13.7 7.4 12.9 6.6 12 6.6S10.3 7.4 10.3 8.3C10.3 9.2 11.1 10 12 10M15.9 11.7C15.9 10.8 15.1 10 14.2 10C13.2 10 12.5 10.8 12.5 11.7C12.5 12.7 13.3 13.4 14.2 13.4C15.1 13.4 15.9 12.7 15.9 11.7M18 8.3C18 7.4 17.2 6.6 16.3 6.6C15.3 6.6 14.6 7.4 14.6 8.3C14.6 9.3 15.4 10 16.3 10C17.2 10 18 9.2 18 8.3";
var mdiEvPlugChademo = "M7.5 9.5C6.1 9.5 5 10.6 5 12S6.1 14.5 7.5 14.5 10 13.4 10 12 8.9 9.5 7.5 9.5M16.5 9.5C15.1 9.5 14 10.6 14 12S15.1 14.5 16.5 14.5 19 13.4 19 12 17.9 9.5 16.5 9.5M12 4C16.4 4 20 7.6 20 12S16.4 20 12 20 4 16.4 4 12 7.6 4 12 4M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 5C10.6 5 9.5 6.1 9.5 7.5S10.6 10 12 10 14.5 8.9 14.5 7.5 13.4 5 12 5M13.5 7.5C13.5 7.7 13.4 7.9 13.3 8.1L12.7 7.5L13.3 6.9C13.4 7.1 13.5 7.3 13.5 7.5M12.6 6.2L12 6.8L11.4 6.2C11.6 6.1 11.8 6 12 6S12.4 6.1 12.6 6.2M10.7 8.1C10.6 7.9 10.5 7.7 10.5 7.5S10.6 7.1 10.7 6.9L11.3 7.5L10.7 8.1M11.4 8.8L12 8.2L12.6 8.8C12.4 8.9 12.2 9 12 9S11.6 8.9 11.4 8.8M12 14C10.6 14 9.5 15.1 9.5 16.5S10.6 19 12 19 14.5 17.9 14.5 16.5 13.4 14 12 14M13.5 16.5C13.5 16.7 13.4 16.9 13.3 17.1L12.7 16.5L13.3 15.9C13.4 16.1 13.5 16.3 13.5 16.5M12.6 15.2L12 15.8L11.4 15.2C11.6 15.1 11.8 15 12 15S12.4 15.1 12.6 15.2M10.7 17.1C10.6 16.9 10.5 16.7 10.5 16.5S10.6 16.1 10.7 15.9L11.3 16.5L10.7 17.1M11.4 17.8L12 17.2L12.6 17.8C12.4 17.9 12.2 18 12 18S11.6 17.9 11.4 17.8Z";
var mdiEvPlugTesla = "M6 9C6 8.45 6.45 8 7 8S8 8.45 8 9 7.55 10 7 10 6 9.55 6 9M17 10C17.55 10 18 9.55 18 9S17.55 8 17 8 16 8.45 16 9 16.45 10 17 10M22 9.93V11C22 15.97 17.97 20 13 20H11C6.03 20 2 16 2 11V9.93C2 6.65 4.65 4 7.93 4H16.07C19.35 4 22 6.65 22 9.93M14.5 9C14.5 10.38 15.62 11.5 17 11.5S19.5 10.38 19.5 9 18.38 6.5 17 6.5 14.5 7.62 14.5 9M4.5 9C4.5 10.38 5.62 11.5 7 11.5S9.5 10.38 9.5 9 8.38 6.5 7 6.5 4.5 7.62 4.5 9M9 17C9 16.45 8.55 16 8 16S7 16.45 7 17 7.45 18 8 18 9 17.55 9 17M13.5 17C13.5 16.17 12.83 15.5 12 15.5S10.5 16.17 10.5 17 11.17 18.5 12 18.5 13.5 17.83 13.5 17M17 17C17 16.45 16.55 16 16 16S15 16.45 15 17 15.45 18 16 18 17 17.55 17 17M19.97 11.66C19.23 12.5 18.18 13 17 13C14.79 13 13 11.21 13 9C13 7.8 13.54 6.73 14.38 6H9.62C10.46 6.73 11 7.8 11 9C11 11.21 9.21 13 7 13C5.82 13 4.76 12.5 4.03 11.66C4.19 13.32 4.93 14.82 6.04 15.94C7.71 14.73 9.76 14 12 14C14.24 14 16.29 14.73 17.96 15.94C19.07 14.82 19.81 13.32 19.97 11.66Z";
var mdiEvPlugType1 = "M13 9C13 10.1 13.9 11 15 11S17 10.1 17 9 16.1 7 15 7 13 7.9 13 9M7 9C7 10.1 7.9 11 9 11S11 10.1 11 9 10.1 7 9 7 7 7.9 7 9M9 13.2C9 12.6 8.4 12 7.8 12S6.6 12.6 6.6 13.2 7.2 14.4 7.8 14.4 9 13.9 9 13.2M14 16C14 14.9 13.1 14 12 14S10 14.9 10 16 10.9 18 12 18 14 17.1 14 16M12 4C16.4 4 20 7.6 20 12S16.4 20 12 20 4 16.4 4 12 7.6 4 12 4M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M17.5 13.2C17.5 12.5 16.9 12 16.3 12C15.6 12 15.1 12.6 15.1 13.2S15.7 14.4 16.3 14.4C16.9 14.5 17.5 13.9 17.5 13.2";
var mdiEvPlugType2 = "M17.3 5C19 6.5 20 8.6 20 11C20 15.4 16.4 19 12 19S4 15.4 4 11C4 8.6 5.1 6.5 6.7 5H17.3M18 3H6L5.4 3.5C3.2 5.4 2 8.1 2 11C2 16.5 6.5 21 12 21S22 16.5 22 11C22 8.1 20.8 5.4 18.6 3.5L18 3M13 7.5C13 8.3 13.7 9 14.5 9S16 8.3 16 7.5 15.3 6 14.5 6 13 6.7 13 7.5M8 7.5C8 8.3 8.7 9 9.5 9S11 8.3 11 7.5 10.3 6 9.5 6 8 6.7 8 7.5M7 13C8.1 13 9 12.1 9 11C9 9.9 8.1 9 7 9S5 9.9 5 11C5 12.1 5.9 13 7 13M11.5 15C11.5 13.9 10.6 13 9.5 13S7.5 13.9 7.5 15C7.5 16.1 8.4 17 9.5 17S11.5 16.1 11.5 15M12 13C13.1 13 14 12.1 14 11C14 9.9 13.1 9 12 9S10 9.9 10 11C10 12.1 10.9 13 12 13M16.5 15C16.5 13.9 15.6 13 14.5 13S12.5 13.9 12.5 15C12.5 16.1 13.4 17 14.5 17S16.5 16.1 16.5 15M19 11C19 9.9 18.1 9 17 9S15 9.9 15 11C15 12.1 15.9 13 17 13S19 12.1 19 11";
var mdiEvStation = "M19.77,7.23L19.78,7.22L16.06,3.5L15,4.56L17.11,6.67C16.17,7.03 15.5,7.93 15.5,9A2.5,2.5 0 0,0 18,11.5C18.36,11.5 18.69,11.42 19,11.29V18.5A1,1 0 0,1 18,19.5A1,1 0 0,1 17,18.5V14A2,2 0 0,0 15,12H14V5A2,2 0 0,0 12,3H6A2,2 0 0,0 4,5V21H14V13.5H15.5V18.5A2.5,2.5 0 0,0 18,21A2.5,2.5 0 0,0 20.5,18.5V9C20.5,8.31 20.22,7.68 19.77,7.23M18,10A1,1 0 0,1 17,9A1,1 0 0,1 18,8A1,1 0 0,1 19,9A1,1 0 0,1 18,10M8,18V13.5H6L10,6V11H12L8,18Z";
var mdiEvernote = "M15.09,11.63C15.09,11.63 15.28,10.35 16,10.35C16.76,10.35 17.78,12.06 17.78,12.06C17.78,12.06 15.46,11.63 15.09,11.63M19,4.69C18.64,4.09 16.83,3.41 15.89,3.41C14.96,3.41 13.5,3.41 13.5,3.41C13.5,3.41 12.7,2 10.88,2C9.05,2 9.17,2.81 9.17,3.5V6.32L8.34,7.19H4.5C4.5,7.19 3.44,7.91 3.44,9.44C3.44,11 3.92,16.35 7.13,16.85C10.93,17.43 11.58,15.67 11.58,15.46C11.58,14.56 11.6,13.21 11.6,13.21C11.6,13.21 12.71,15.33 14.39,15.33C16.07,15.33 17.04,16.3 17.04,17.29C17.04,18.28 17.04,19.13 17.04,19.13C17.04,19.13 17,20.28 16,20.28C15,20.28 13.89,20.28 13.89,20.28C13.89,20.28 13.2,19.74 13.2,19C13.2,18.25 13.53,18.05 13.93,18.05C14.32,18.05 14.65,18.09 14.65,18.09V16.53C14.65,16.53 11.47,16.5 11.47,18.94C11.47,21.37 13.13,22 14.46,22C15.8,22 16.63,22 16.63,22C16.63,22 20.56,21.5 20.56,13.75C20.56,6 19.33,5.28 19,4.69M7.5,6.31H4.26L8.32,2.22V5.5L7.5,6.31Z";
var mdiExcavator = "M18.5 18.5C19.04 18.5 19.5 18.96 19.5 19.5S19.04 20.5 18.5 20.5H6.5C5.96 20.5 5.5 20.04 5.5 19.5S5.96 18.5 6.5 18.5H18.5M18.5 17H6.5C5.13 17 4 18.13 4 19.5S5.13 22 6.5 22H18.5C19.88 22 21 20.88 21 19.5S19.88 17 18.5 17M21 11H18V7H13L10 11V16H22L21 11M11.54 11L13.5 8.5H16V11H11.54M9.76 3.41L4.76 2L2 11.83C1.66 13.11 2.41 14.44 3.7 14.8L4.86 15.12L8.15 12.29L4.27 11.21L6.15 4.46L8.94 5.24C9.5 5.53 10.71 6.34 11.47 7.37L12.5 6H12.94C11.68 4.41 9.85 3.46 9.76 3.41Z";
var mdiExclamation = "M 11,4L 13,4L 13,15L 11,15L 11,4 Z M 13,18L 13,20L 11,20L 11,18L 13,18 Z";
var mdiExclamationThick = "M10 3H14V14H10V3M10 21V17H14V21H10Z";
var mdiExitRun = "M13.34,8.17C12.41,8.17 11.65,7.4 11.65,6.47A1.69,1.69 0 0,1 13.34,4.78C14.28,4.78 15.04,5.54 15.04,6.47C15.04,7.4 14.28,8.17 13.34,8.17M10.3,19.93L4.37,18.75L4.71,17.05L8.86,17.9L10.21,11.04L8.69,11.64V14.5H7V10.54L11.4,8.67L12.07,8.59C12.67,8.59 13.17,8.93 13.5,9.44L14.36,10.79C15.04,12 16.39,12.82 18,12.82V14.5C16.14,14.5 14.44,13.67 13.34,12.4L12.84,14.94L14.61,16.63V23H12.92V17.9L11.14,16.21L10.3,19.93M21,23H19V3H6V16.11L4,15.69V1H21V23M6,23H4V19.78L6,20.2V23Z";
var mdiExitToApp = "M19,3H5C3.89,3 3,3.89 3,5V9H5V5H19V19H5V15H3V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M10.08,15.58L11.5,17L16.5,12L11.5,7L10.08,8.41L12.67,11H3V13H12.67L10.08,15.58Z";
var mdiExpandAll = "M18,8H8V18H6V8A2,2 0 0,1 8,6H18V8M14,2H4A2,2 0 0,0 2,4V14H4V4H14V2M22,12V20A2,2 0 0,1 20,22H12A2,2 0 0,1 10,20V12A2,2 0 0,1 12,10H20A2,2 0 0,1 22,12M20,15H17V12H15V15H12V17H15V20H17V17H20V15Z";
var mdiExpandAllOutline = "M4,2A2,2 0 0,0 2,4V14H4V4H14V2H4M8,6A2,2 0 0,0 6,8V18H8V8H18V6H8M20,12V20H12V12H20M20,10H12A2,2 0 0,0 10,12V20A2,2 0 0,0 12,22H20A2,2 0 0,0 22,20V12A2,2 0 0,0 20,10M19,17H17V19H15V17H13V15H15V13H17V15H19V17Z";
var mdiExpansionCard = "M2,7V8.5H3V17H4.5V7C3.7,7 2.8,7 2,7M6,7V7L6,16H7V17H14V16H22V7H6M17.5,9A2.5,2.5 0 0,1 20,11.5A2.5,2.5 0 0,1 17.5,14A2.5,2.5 0 0,1 15,11.5A2.5,2.5 0 0,1 17.5,9Z";
var mdiExpansionCardVariant = "M2 7H4.5V17H3V8.5H2M22 7V16H14V17H7V16H6V7M10 9H8V12H10M13 9H11V12H13M20 9H15V14H20V9Z";
var mdiExponent = "M15.38,3L17.77,8.75C17.55,9.68 17.27,10.32 17,10.7C16.67,11.18 16.44,11.25 16.19,11.25V12.75C16.94,12.75 17.74,12.35 18.24,11.56C19.87,8.94 22,3 22,3H20.38L18.69,7.05L17,3H15.38M3.42,8.59L2,10L6.79,14.79L2,19.59L3.41,21L8.21,16.21L13,21L14.41,19.59L9.62,14.79L14.41,10L13,8.59L8.21,13.38L3.41,8.59H3.42Z";
var mdiExponentBox = "M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5M13.76,6H15.39L16.5,8.6L17.59,6H19.24C19.24,6 17.5,10.57 16.46,12.32C16.08,12.89 15.35,13.27 14.5,13.25V11.75C14.96,11.76 15.25,11.5 15.5,11.13C15.61,11 15.68,10.8 15.74,10.64L13.76,6M6.41,9.59L9.21,12.38L12,9.59L13.41,11L10.62,13.79L13.41,16.59L12,18L9.21,15.21L6.41,18L5,16.59L7.79,13.79L5,11L6.41,9.59Z";
var mdiExport = "M23,12L19,8V11H10V13H19V16M1,18V6C1,4.89 1.9,4 3,4H15A2,2 0 0,1 17,6V9H15V6H3V18H15V15H17V18A2,2 0 0,1 15,20H3A2,2 0 0,1 1,18Z";
var mdiExportVariant = "M12,1L8,5H11V14H13V5H16M18,23H6C4.89,23 4,22.1 4,21V9A2,2 0 0,1 6,7H9V9H6V21H18V9H15V7H18A2,2 0 0,1 20,9V21A2,2 0 0,1 18,23Z";
var mdiEye = "M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z";
var mdiEyeArrowLeft = "M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C12.36 19.5 12.72 19.5 13.08 19.45C13.03 19.13 13 18.82 13 18.5C13 17.94 13.08 17.38 13.24 16.84C12.83 16.94 12.42 17 12 17C9.24 17 7 14.76 7 12S9.24 7 12 7 17 9.24 17 12C17 12.29 16.97 12.59 16.92 12.88C17.58 12.63 18.29 12.5 19 12.5C20.17 12.5 21.31 12.84 22.29 13.5C22.56 13 22.8 12.5 23 12C21.27 7.61 17 4.5 12 4.5M12 9C10.34 9 9 10.34 9 12S10.34 15 12 15 15 13.66 15 12 13.66 9 12 9M18 15V17H22V19H18V21L15 18L18 15";
var mdiEyeArrowLeftOutline = "M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C12.36 19.5 12.72 19.5 13.08 19.45C13.03 19.13 13 18.82 13 18.5C13 18.14 13.04 17.78 13.1 17.42C12.74 17.46 12.37 17.5 12 17.5C8.24 17.5 4.83 15.36 3.18 12C4.83 8.64 8.24 6.5 12 6.5S19.17 8.64 20.82 12C20.7 12.24 20.56 12.45 20.43 12.68C21.09 12.84 21.72 13.11 22.29 13.5C22.56 13 22.8 12.5 23 12C21.27 7.61 17 4.5 12 4.5M12 9C10.34 9 9 10.34 9 12S10.34 15 12 15 15 13.66 15 12 13.66 9 12 9M18 15V17H22V19H18V21L15 18L18 15";
var mdiEyeArrowRight = "M12 4.5C7 4.5 2.7 7.6 1 12C2.7 16.4 7 19.5 12 19.5H13.1C13 19.2 13 18.9 13 18.5C13 17.9 13.1 17.4 13.2 16.8C12.8 16.9 12.4 17 12 17C9.2 17 7 14.8 7 12S9.2 7 12 7 17 9.2 17 12C17 12.3 17 12.6 16.9 12.9C17.6 12.7 18.3 12.5 19 12.5C20.2 12.5 21.3 12.8 22.3 13.5C22.6 13 22.8 12.5 23 12C21.3 7.6 17 4.5 12 4.5M12 9C10.3 9 9 10.3 9 12S10.3 15 12 15 15 13.7 15 12 13.7 9 12 9M19 21V19H15V17H19V15L22 18L19 21";
var mdiEyeArrowRightOutline = "M12 4.5C7 4.5 2.7 7.6 1 12C2.7 16.4 7 19.5 12 19.5H13.1C13 19.2 13 18.9 13 18.5C13 18.1 13 17.8 13.1 17.4C12.7 17.4 12.4 17.5 12 17.5C8.2 17.5 4.8 15.4 3.2 12C4.8 8.6 8.2 6.5 12 6.5S19.2 8.6 20.8 12C20.7 12.2 20.5 12.4 20.4 12.7C21.1 12.9 21.7 13.1 22.3 13.5C22.6 13 22.8 12.5 23 12C21.3 7.6 17 4.5 12 4.5M12 9C10.3 9 9 10.3 9 12S10.3 15 12 15 15 13.7 15 12 13.7 9 12 9M19 21V19H15V17H19V15L22 18L19 21";
var mdiEyeCheck = "M23.5,17L18.5,22L15,18.5L16.5,17L18.5,19L22,15.5L23.5,17M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,17C12.5,17 12.97,16.93 13.42,16.79C13.15,17.5 13,18.22 13,19V19.45L12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5C17,4.5 21.27,7.61 23,12C22.75,12.64 22.44,13.26 22.08,13.85C21.18,13.31 20.12,13 19,13C18.22,13 17.5,13.15 16.79,13.42C16.93,12.97 17,12.5 17,12A5,5 0 0,0 12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17Z";
var mdiEyeCheckOutline = "M23.5,17L18.5,22L15,18.5L16.5,17L18.5,19L22,15.5L23.5,17M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.75,12.65 22.44,13.26 22.08,13.85C21.5,13.5 20.86,13.25 20.18,13.12L20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12C4.83,15.36 8.24,17.5 12,17.5L13.21,17.43C13.07,17.93 13,18.46 13,19V19.46L12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5Z";
var mdiEyeCircle = "M12,9.5A2.5,2.5 0 0,0 9.5,12A2.5,2.5 0 0,0 12,14.5A2.5,2.5 0 0,0 14.5,12A2.5,2.5 0 0,0 12,9.5M12,13A1,1 0 0,1 11,12A1,1 0 0,1 12,11A1,1 0 0,1 13,12A1,1 0 0,1 12,13M12,9.5A2.5,2.5 0 0,0 9.5,12A2.5,2.5 0 0,0 12,14.5A2.5,2.5 0 0,0 14.5,12A2.5,2.5 0 0,0 12,9.5M12,13A1,1 0 0,1 11,12A1,1 0 0,1 12,11A1,1 0 0,1 13,12A1,1 0 0,1 12,13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,16C9.37,16 7,14.43 6,12C7.38,8.69 11.19,7.12 14.5,8.5C16.08,9.16 17.34,10.42 18,12C17,14.43 14.63,16 12,16M12,9.5A2.5,2.5 0 0,0 9.5,12A2.5,2.5 0 0,0 12,14.5A2.5,2.5 0 0,0 14.5,12A2.5,2.5 0 0,0 12,9.5M12,13A1,1 0 0,1 11,12A1,1 0 0,1 12,11A1,1 0 0,1 13,12A1,1 0 0,1 12,13Z";
var mdiEyeCircleOutline = "M12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,11A1,1 0 0,1 13,12A1,1 0 0,1 12,13A1,1 0 0,1 11,12A1,1 0 0,1 12,11M12,8C14.63,8 17,9.57 18,12C16.62,15.31 12.81,16.88 9.5,15.5C7.92,14.84 6.66,13.58 6,12C7,9.57 9.37,8 12,8M12,9.5A2.5,2.5 0 0,0 9.5,12A2.5,2.5 0 0,0 12,14.5A2.5,2.5 0 0,0 14.5,12A2.5,2.5 0 0,0 12,9.5";
var mdiEyeClosed = "M12 17.5C8.2 17.5 4.8 15.4 3.2 12H1C2.7 16.4 7 19.5 12 19.5S21.3 16.4 23 12H20.8C19.2 15.4 15.8 17.5 12 17.5Z";
var mdiEyeLock = "M20.8 17V15.5C20.8 14.1 19.4 13 18 13S15.2 14.1 15.2 15.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17M19.5 17H16.5V15.5C16.5 14.7 17.2 14.2 18 14.2S19.5 14.7 19.5 15.5V17M15 12C14.1 12.7 13.5 13.6 13.3 14.7C12.9 14.9 12.5 15 12 15C10.3 15 9 13.7 9 12S10.3 9 12 9 15 10.3 15 12M12 19.5C7 19.5 2.7 16.4 1 12C2.7 7.6 7 4.5 12 4.5S21.3 7.6 23 12C22.8 12.5 22.5 13 22.3 13.5C21.5 12 19.8 11 18 11C17.6 11 17.3 11.1 16.9 11.1C16.5 8.8 14.5 7 12 7C9.2 7 7 9.2 7 12S9.2 17 12 17H12.3C12.1 17.4 12 17.8 12 18.2V19.5Z";
var mdiEyeLockOpen = "M14.9 11.1C13.9 11.9 13.2 13.1 13.2 14.5V14.7C12.8 14.9 12.4 15 12 15C10.3 15 9 13.7 9 12S10.3 9 12 9C13.4 9 14.5 9.9 14.9 11.1M12 18.2C12 17.8 12.1 17.4 12.3 17H12C9.2 17 7 14.8 7 12S9.2 7 12 7C14.1 7 15.9 8.3 16.7 10.2C17.1 10.1 17.6 10 18 10C20.1 10 21.9 11.3 22.5 13.1C22.7 12.8 22.8 12.4 23 12C21.3 7.6 17 4.5 12 4.5S2.7 7.6 1 12C2.7 16.4 7 19.5 12 19.5V18.2M20.8 17H16.5V14.5C16.5 13.7 17.2 13.2 18 13.2S19.5 13.7 19.5 14.5V15H20.8V14.5C20.8 13.1 19.4 12 18 12S15.2 13.1 15.2 14.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17Z";
var mdiEyeLockOpenOutline = "M12 19.5C7 19.5 2.7 16.4 1 12C2.7 7.6 7 4.5 12 4.5S21.3 7.6 23 12C22.9 12.4 22.7 12.7 22.5 13.1C22 11.9 21 10.9 19.7 10.4C17.9 8 15.1 6.5 12 6.5C8.2 6.5 4.8 8.6 3.2 12C4.9 15.4 8.3 17.5 12 17.5H12.1C12 17.7 12 18 12 18.2V19.5M12 9C10.3 9 9 10.3 9 12S10.3 15 12 15C12.4 15 12.8 14.9 13.2 14.7V14.5C13.2 13.2 13.9 12 14.9 11.1C14.5 9.9 13.4 9 12 9M20.8 17H16.5V14.5C16.5 13.7 17.2 13.2 18 13.2S19.5 13.7 19.5 14.5V15H20.8V14.5C20.8 13.1 19.4 12 18 12S15.2 13.1 15.2 14.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17Z";
var mdiEyeLockOutline = "M20.8 17V15.5C20.8 14.1 19.4 13 18 13S15.2 14.1 15.2 15.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17M19.5 17H16.5V15.5C16.5 14.7 17.2 14.2 18 14.2S19.5 14.7 19.5 15.5V17M15 12C14.1 12.7 13.5 13.6 13.3 14.7C12.9 14.9 12.5 15 12 15C10.3 15 9 13.7 9 12S10.3 9 12 9 15 10.3 15 12M12 19.5C7 19.5 2.7 16.4 1 12C2.7 7.6 7 4.5 12 4.5S21.3 7.6 23 12C22.8 12.5 22.5 13 22.3 13.5C21.9 12.8 21.4 12.2 20.7 11.8C19 8.5 15.7 6.5 12 6.5C8.2 6.5 4.8 8.6 3.2 12C4.9 15.4 8.3 17.5 12 17.5H12.1C12 17.7 12 18 12 18.2V19.5Z";
var mdiEyeMinus = "M12 4.5A11.8 11.8 0 0 0 1 12A11.8 11.8 0 0 0 12 19.5H13.1A3.8 3.8 0 0 1 13 18.5A9.9 9.9 0 0 1 13.2 16.8L12 17A5 5 0 1 1 17 12A2.8 2.8 0 0 1 16.9 12.9A5.2 5.2 0 0 1 19 12.5A5.6 5.6 0 0 1 22.3 13.5A10.1 10.1 0 0 0 23 12A11.8 11.8 0 0 0 12 4.5M12 9A3 3 0 1 0 15 12A2.9 2.9 0 0 0 12 9M15 17.5V19.5H23V17.5Z";
var mdiEyeMinusOutline = "M12 4.5A11.8 11.8 0 0 0 1 12A11.8 11.8 0 0 0 12 19.5H13.1A3.8 3.8 0 0 1 13 18.5A4.1 4.1 0 0 1 13.1 17.4H12A9.6 9.6 0 0 1 3.2 12A9.6 9.6 0 0 1 12 6.5A9.6 9.6 0 0 1 20.8 12L20.4 12.7A4.6 4.6 0 0 1 22.3 13.5A10.1 10.1 0 0 0 23 12A11.8 11.8 0 0 0 12 4.5M12 9A3 3 0 1 0 15 12A2.9 2.9 0 0 0 12 9M15 17.5V19.5H23V17.5Z";
var mdiEyeOff = "M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z";
var mdiEyeOffOutline = "M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z";
var mdiEyeOutline = "M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z";
var mdiEyePlus = "M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C12.36,19.5 12.72,19.5 13.08,19.45C13.03,19.13 13,18.82 13,18.5C13,17.94 13.08,17.38 13.24,16.84C12.83,16.94 12.42,17 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12C17,12.29 16.97,12.59 16.92,12.88C17.58,12.63 18.29,12.5 19,12.5C20.17,12.5 21.31,12.84 22.29,13.5C22.56,13 22.8,12.5 23,12C21.27,7.61 17,4.5 12,4.5M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M18,14.5V17.5H15V19.5H18V22.5H20V19.5H23V17.5H20V14.5H18Z";
var mdiEyePlusOutline = "M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C12.36,19.5 12.72,19.5 13.08,19.45C13.03,19.13 13,18.82 13,18.5C13,18.14 13.04,17.78 13.1,17.42C12.74,17.46 12.37,17.5 12,17.5C8.24,17.5 4.83,15.36 3.18,12C4.83,8.64 8.24,6.5 12,6.5C15.76,6.5 19.17,8.64 20.82,12C20.7,12.24 20.56,12.45 20.43,12.68C21.09,12.84 21.72,13.11 22.29,13.5C22.56,13 22.8,12.5 23,12C21.27,7.61 17,4.5 12,4.5M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M18,14.5V17.5H15V19.5H18V22.5H20V19.5H23V17.5H20V14.5H18Z";
var mdiEyeRefresh = "M12 9C10.3 9 9 10.3 9 12S10.3 15 12 15 15 13.7 15 12 13.7 9 12 9M18 18.5L19.8 16.7C19.3 16.3 18.7 16 18 16C16.6 16 15.5 17.1 15.5 18.5S16.6 21 18 21C18.8 21 19.5 20.6 20 20H21.7C21.1 21.5 19.7 22.5 18 22.5C15.8 22.5 14 20.7 14 18.5S15.8 14.5 18 14.5C19.1 14.5 20.1 14.9 20.8 15.7L22 14.5V18.5H18M12.1 19.5C12.1 19.5 12 19.5 12.1 19.5C7 19.5 2.7 16.4 1 12C2.7 7.6 7 4.5 12 4.5S21.3 7.6 23 12C22.8 12.4 22.6 12.9 22.4 13.3C21.3 12.5 20 12 18.5 12C18 12 17.5 12.1 17 12.2V12C17 9.2 14.8 7 12 7S7 9.2 7 12 9.2 17 12 17H12.2C12.1 17.5 12 18 12 18.5C12 18.8 12 19.2 12.1 19.5Z";
var mdiEyeRefreshOutline = "M12 9C13.7 9 15 10.3 15 12S13.7 15 12 15 9 13.7 9 12 10.3 9 12 9M18 18.5L19.8 16.7C19.3 16.3 18.7 16 18 16C16.6 16 15.5 17.1 15.5 18.5S16.6 21 18 21C18.8 21 19.5 20.6 20 20H21.7C21.1 21.5 19.7 22.5 18 22.5C15.8 22.5 14 20.7 14 18.5S15.8 14.5 18 14.5C19.1 14.5 20.1 14.9 20.8 15.7L22 14.5V18.5H18M12 18.5C12 18.2 12 17.8 12.1 17.5H12C8.2 17.5 4.8 15.4 3.2 12C4.8 8.6 8.2 6.5 12 6.5S19.2 8.6 20.8 12C20.7 12.1 20.7 12.2 20.6 12.4C21.2 12.6 21.8 12.9 22.4 13.3C22.6 12.9 22.8 12.4 23 12C21.3 7.6 17 4.5 12 4.5S2.7 7.6 1 12C2.7 16.4 7 19.5 12 19.5H12.1C12 19.2 12 18.8 12 18.5Z";
var mdiEyeRemove = "M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88M12 9C10.34 9 9 10.34 9 12S10.34 15 12 15 15 13.66 15 12 13.66 9 12 9M12 17C9.24 17 7 14.76 7 12S9.24 7 12 7 17 9.24 17 12C17 12.5 16.9 13 16.77 13.43C17.46 13.16 18.21 13 19 13C20.12 13 21.17 13.32 22.07 13.85C22.43 13.27 22.74 12.65 23 12C21.27 7.61 17 4.5 12 4.5S2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C12.35 19.5 12.69 19.5 13.03 19.45C13 19.3 13 19.15 13 19C13 18.21 13.16 17.46 13.43 16.77C13 16.9 12.5 17 12 17Z";
var mdiEyeRemoveOutline = "M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88M12 9C10.34 9 9 10.34 9 12S10.34 15 12 15 15 13.66 15 12 13.66 9 12 9M12 17.5C8.24 17.5 4.83 15.36 3.18 12C4.83 8.64 8.24 6.5 12 6.5S19.17 8.64 20.82 12C20.63 12.39 20.41 12.77 20.17 13.13C20.85 13.26 21.5 13.5 22.07 13.85C22.43 13.27 22.74 12.65 23 12C21.27 7.61 17 4.5 12 4.5S2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C12.35 19.5 12.69 19.5 13.03 19.45C13 19.3 13 19.15 13 19C13 18.45 13.08 17.92 13.22 17.41C12.82 17.46 12.41 17.5 12 17.5Z";
var mdiEyeSettings = "M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7.14,4.5 2.78,7.5 1,12C3.39,18.08 10.25,21.06 16.33,18.67C19.38,17.47 21.8,15.06 23,12C21.22,7.5 16.86,4.5 12,4.5M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z";
var mdiEyeSettingsOutline = "M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C16.86,4.5 21.22,7.5 23,12C20.61,18.08 13.75,21.06 7.67,18.67C4.62,17.47 2.2,15.06 1,12C2.78,7.5 7.14,4.5 12,4.5M3.18,12C5.56,16.87 11.45,18.89 16.32,16.5C18.28,15.54 19.86,13.96 20.82,12C18.44,7.13 12.55,5.11 7.68,7.5C5.72,8.46 4.14,10.04 3.18,12M9,22H7V24H9V22M13,22H11V24H13V22M17,22H15V24H17V22Z";
var mdiEyedropper = "M19.35,11.72L17.22,13.85L15.81,12.43L8.1,20.14L3.5,22L2,20.5L3.86,15.9L11.57,8.19L10.15,6.78L12.28,4.65L19.35,11.72M16.76,3C17.93,1.83 19.83,1.83 21,3C22.17,4.17 22.17,6.07 21,7.24L19.08,9.16L14.84,4.92L16.76,3M5.56,17.03L4.5,19.5L6.97,18.44L14.4,11L13,9.6L5.56,17.03Z";
var mdiEyedropperMinus = "M19.35 11.72L17.22 13.85L15.81 12.43L8.1 20.14L3.5 22L2 20.5L3.86 15.9L11.57 8.19L10.15 6.78L12.28 4.65L19.35 11.72M16.76 3C17.93 1.83 19.83 1.83 21 3S22.17 6.07 21 7.24L19.08 9.16L14.84 4.92L16.76 3M5.56 17.03L4.5 19.5L6.97 18.44L14.4 11L13 9.6L5.56 17.03M9 4V6H1V4H9Z";
var mdiEyedropperOff = "M21 7.24L19.08 9.16L14.84 4.92L16.76 3C17.93 1.83 19.83 1.83 21 3S22.17 6.07 21 7.24M10.94 8.82L12.36 10.24L13 9.6L14.4 11L13.76 11.64L15.18 13.06L15.81 12.43L17.22 13.85L19.35 11.72L12.28 4.65L10.15 6.78L11.57 8.19L10.94 8.82M19.86 20.29L18.58 21.57L12.63 15.61L8.1 20.14L3.5 22L2 20.5L3.86 15.9L8.39 11.37L1.86 4.85L3.14 3.57L19.86 20.29M11.21 14.2L9.81 12.79L5.56 17.03L4.5 19.5L6.97 18.44L11.21 14.2Z";
var mdiEyedropperPlus = "M19.35 11.72L17.22 13.85L15.81 12.43L8.1 20.14L3.5 22L2 20.5L3.86 15.9L11.57 8.19L10.15 6.78L12.28 4.65L19.35 11.72M16.76 3C17.93 1.83 19.83 1.83 21 3S22.17 6.07 21 7.24L19.08 9.16L14.84 4.92L16.76 3M5.56 17.03L4.5 19.5L6.97 18.44L14.4 11L13 9.6L5.56 17.03M6 1V4H9V6H6V9H4V6H1V4H4V1H6Z";
var mdiEyedropperRemove = "M19.35 11.72L17.22 13.85L15.81 12.43L8.1 20.14L3.5 22L2 20.5L3.86 15.9L11.57 8.19L10.15 6.78L12.28 4.65L19.35 11.72M16.76 3C17.93 1.83 19.83 1.83 21 3S22.17 6.07 21 7.24L19.08 9.16L14.84 4.92L16.76 3M5.56 17.03L4.5 19.5L6.97 18.44L14.4 11L13 9.6L5.56 17.03M8.54 2.88L6.41 5L8.54 7.12L7.12 8.54L5 6.41L2.88 8.54L1.46 7.12L3.59 5L1.46 2.88L2.88 1.47L5 3.59L7.12 1.47L8.54 2.88Z";
var mdiEyedropperVariant = "M6.92,19L5,17.08L13.06,9L15,10.94M20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L13.84,6.41L11.91,4.5L10.5,5.91L11.92,7.33L3,16.25V21H7.75L16.67,12.08L18.09,13.5L19.5,12.09L17.58,10.17L20.7,7.05C21.1,6.65 21.1,6 20.71,5.63Z";
var mdiFaceAgent = "M18.72,14.76C19.07,13.91 19.26,13 19.26,12C19.26,11.28 19.15,10.59 18.96,9.95C18.31,10.1 17.63,10.18 16.92,10.18C13.86,10.18 11.15,8.67 9.5,6.34C8.61,8.5 6.91,10.26 4.77,11.22C4.73,11.47 4.73,11.74 4.73,12A7.27,7.27 0 0,0 12,19.27C13.05,19.27 14.06,19.04 14.97,18.63C15.54,19.72 15.8,20.26 15.78,20.26C14.14,20.81 12.87,21.08 12,21.08C9.58,21.08 7.27,20.13 5.57,18.42C4.53,17.38 3.76,16.11 3.33,14.73H2V10.18H3.09C3.93,6.04 7.6,2.92 12,2.92C14.4,2.92 16.71,3.87 18.42,5.58C19.69,6.84 20.54,8.45 20.89,10.18H22V14.67H22V14.69L22,14.73H21.94L18.38,18L13.08,17.4V15.73H17.91L18.72,14.76M9.27,11.77C9.57,11.77 9.86,11.89 10.07,12.11C10.28,12.32 10.4,12.61 10.4,12.91C10.4,13.21 10.28,13.5 10.07,13.71C9.86,13.92 9.57,14.04 9.27,14.04C8.64,14.04 8.13,13.54 8.13,12.91C8.13,12.28 8.64,11.77 9.27,11.77M14.72,11.77C15.35,11.77 15.85,12.28 15.85,12.91C15.85,13.54 15.35,14.04 14.72,14.04C14.09,14.04 13.58,13.54 13.58,12.91A1.14,1.14 0 0,1 14.72,11.77Z";
var mdiFaceMan = "M9,11.75A1.25,1.25 0 0,0 7.75,13A1.25,1.25 0 0,0 9,14.25A1.25,1.25 0 0,0 10.25,13A1.25,1.25 0 0,0 9,11.75M15,11.75A1.25,1.25 0 0,0 13.75,13A1.25,1.25 0 0,0 15,14.25A1.25,1.25 0 0,0 16.25,13A1.25,1.25 0 0,0 15,11.75M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,11.71 4,11.42 4.05,11.14C6.41,10.09 8.28,8.16 9.26,5.77C11.07,8.33 14.05,10 17.42,10C18.2,10 18.95,9.91 19.67,9.74C19.88,10.45 20,11.21 20,12C20,16.41 16.41,20 12,20Z";
var mdiFaceManOutline = "M10.25,13A1.25,1.25 0 0,1 9,14.25A1.25,1.25 0 0,1 7.75,13A1.25,1.25 0 0,1 9,11.75A1.25,1.25 0 0,1 10.25,13M15,11.75A1.25,1.25 0 0,0 13.75,13A1.25,1.25 0 0,0 15,14.25A1.25,1.25 0 0,0 16.25,13A1.25,1.25 0 0,0 15,11.75M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10.66,4.12C12.06,6.44 14.6,8 17.5,8C17.96,8 18.41,7.95 18.84,7.88C17.44,5.56 14.9,4 12,4C11.54,4 11.09,4.05 10.66,4.12M4.42,9.47C6.13,8.5 7.45,6.92 8.08,5.03C6.37,6 5.05,7.58 4.42,9.47M20,12C20,11.22 19.88,10.47 19.67,9.76C18.97,9.91 18.25,10 17.5,10C14.37,10 11.58,8.56 9.74,6.31C8.69,8.87 6.6,10.88 4,11.86C4,11.9 4,11.95 4,12C4,16.41 7.59,20 12,20C16.41,20 20,16.41 20,12Z";
var mdiFaceManProfile = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,8.39C13.57,9.4 15.42,10 17.42,10C18.2,10 18.95,9.91 19.67,9.74C19.88,10.45 20,11.21 20,12C20,16.41 16.41,20 12,20C9,20 6.39,18.34 5,15.89L6.75,14V13A1.25,1.25 0 0,1 8,11.75A1.25,1.25 0 0,1 9.25,13V14H12M16,11.75A1.25,1.25 0 0,0 14.75,13A1.25,1.25 0 0,0 16,14.25A1.25,1.25 0 0,0 17.25,13A1.25,1.25 0 0,0 16,11.75Z";
var mdiFaceManShimmer = "M18.41 3.41L16 4.5L18.41 5.59L19.5 8L20.6 5.59L23 4.5L20.6 3.41L19.5 1M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 10.53 21.67 9.13 21.1 7.87L19.86 10.59C19.94 11.05 20 11.5 20 12C20 16.43 16.43 20 12 20C7.57 20 4 16.43 4 12C4 11.96 4 11.91 4 11.87A10 10 0 0 0 9.74 6.31A10 10 0 0 0 17.5 10A10 10 0 0 0 18.83 9.91L17.35 6.65L12.6 4.5L16.13 2.9C14.87 2.33 13.47 2 12 2M9 11.75A1.25 1.25 0 0 0 7.75 13A1.25 1.25 0 0 0 9 14.25A1.25 1.25 0 0 0 10.25 13A1.25 1.25 0 0 0 9 11.75M15 11.75A1.25 1.25 0 0 0 13.75 13A1.25 1.25 0 0 0 15 14.25A1.25 1.25 0 0 0 16.25 13A1.25 1.25 0 0 0 15 11.75Z";
var mdiFaceManShimmerOutline = "M19.5 1L18.41 3.41L16 4.5L18.41 5.59L19.5 8L20.6 5.59L23 4.5L20.6 3.41L19.5 1M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 10.53 21.67 9.13 21.1 7.87L19.86 10.57C19.95 11.04 20 11.5 20 12C20 16.43 16.43 20 12 20C7.57 20 4 16.43 4 12C4 11.95 4 11.91 4 11.86A10 10 0 0 0 9.74 6.31C11.61 8.61 14.44 10 17.5 10C17.94 10 18.39 9.97 18.83 9.91L17.96 8C17.81 8 17.65 8 17.5 8C14.68 8 12.1 6.5 10.66 4.12C11.1 4.05 11.54 4 12 4C12.5 4 12.96 4.05 13.42 4.13L16.13 2.91C14.87 2.33 13.47 2 12 2M8.09 5A8 8 0 0 1 4.41 9.5C5.04 7.57 6.37 6 8.09 5M9 11.75A1.25 1.25 0 0 0 7.75 13A1.25 1.25 0 0 0 9 14.25A1.25 1.25 0 0 0 10.25 13A1.25 1.25 0 0 0 9 11.75M15 11.75A1.25 1.25 0 0 0 13.75 13A1.25 1.25 0 0 0 15 14.25A1.25 1.25 0 0 0 16.25 13A1.25 1.25 0 0 0 15 11.75Z";
var mdiFaceMask = "M20.25 6C18.79 6 17.61 7.14 17.5 8.58L12.55 7.16C12.19 7.05 11.81 7.05 11.45 7.16L6.5 8.58C6.39 7.14 5.21 6 3.75 6C2.23 6 1 7.23 1 8.75V12.25C1 13.77 2.23 15 3.75 15H5.68C6.81 17.36 9.21 19 12 19S17.19 17.36 18.32 15H20.25C21.77 15 23 13.77 23 12.25V8.75C23 7.23 21.77 6 20.25 6M5 13.5H3.75C3.06 13.5 2.5 12.94 2.5 12.25V8.75C2.5 8.06 3.06 7.5 3.75 7.5S5 8.06 5 8.75V13.5M15 12L12.4 11.3C12.1 11.2 11.8 11.2 11.6 11.3L9 12V11L11.3 10.3C11.7 10.2 12.2 10.2 12.7 10.3L15 11V12M21.5 12.25C21.5 12.94 20.94 13.5 20.25 13.5H19V8.75C19 8.06 19.56 7.5 20.25 7.5S21.5 8.06 21.5 8.75V12.25Z";
var mdiFaceMaskOutline = "M15 12L12.4 11.3C12.1 11.2 11.8 11.2 11.6 11.3L9 12V11L11.3 10.3C11.7 10.2 12.2 10.2 12.7 10.3L15 11V12M20.25 6C18.79 6 17.61 7.14 17.5 8.58L12.55 7.16C12.37 7.11 12.19 7.08 12 7.08C11.82 7.08 11.63 7.11 11.45 7.16L6.5 8.58C6.39 7.14 5.21 6 3.75 6C2.23 6 1 7.23 1 8.75V12.25C1 13.77 2.23 15 3.75 15H5.68C6.81 17.36 9.21 19 12 19S17.19 17.36 18.32 15H20.25C21.77 15 23 13.77 23 12.25V8.75C23 7.23 21.77 6 20.25 6M5 13.5H3.75C3.06 13.5 2.5 12.94 2.5 12.25V8.75C2.5 8.06 3.06 7.5 3.75 7.5S5 8.06 5 8.75V13.5M17 12C17 14.76 14.76 17 12 17S7 14.76 7 12L7 10.5L12 9.08H12L17 10.5V12M21.5 12.25C21.5 12.94 20.94 13.5 20.25 13.5H19V8.75C19 8.06 19.56 7.5 20.25 7.5S21.5 8.06 21.5 8.75V12.25Z";
var mdiFaceRecognition = "M9,11.75A1.25,1.25 0 0,0 7.75,13A1.25,1.25 0 0,0 9,14.25A1.25,1.25 0 0,0 10.25,13A1.25,1.25 0 0,0 9,11.75M15,11.75A1.25,1.25 0 0,0 13.75,13A1.25,1.25 0 0,0 15,14.25A1.25,1.25 0 0,0 16.25,13A1.25,1.25 0 0,0 15,11.75M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12C3.97,11.71 3.97,11.43 4,11.14C6.38,10.1 8.27,8.17 9.26,5.77C11.13,8.42 14.17,10 17.42,10C18.18,10 18.93,9.91 19.67,9.74C20.92,14 18.5,18.43 14.26,19.67C13.5,19.89 12.76,20 12,20M0,2A2,2 0 0,1 2,0H6V2H2V6H0V2M24,22A2,2 0 0,1 22,24H18V22H22V18H24V22M2,24A2,2 0 0,1 0,22V18H2V22H6V24H2M22,0A2,2 0 0,1 24,2V6H22V2H18V0H22Z";
var mdiFaceWoman = "M13.75 13C13.75 12.31 14.31 11.75 15 11.75S16.25 12.31 16.25 13 15.69 14.25 15 14.25 13.75 13.69 13.75 13M22 12V22H2V12C2 6.5 6.5 2 12 2S22 6.5 22 12M4 12C4 16.41 7.59 20 12 20S20 16.41 20 12C20 11.21 19.88 10.45 19.67 9.74C18.95 9.91 18.2 10 17.42 10C14.05 10 11.07 8.33 9.26 5.77C8.28 8.16 6.41 10.09 4.05 11.14C4 11.42 4 11.71 4 12M9 14.25C9.69 14.25 10.25 13.69 10.25 13S9.69 11.75 9 11.75 7.75 12.31 7.75 13 8.31 14.25 9 14.25Z";
var mdiFaceWomanOutline = "M12 2C6.5 2 2 6.5 2 12V22H22V12C22 6.5 17.5 2 12 2M12 4C14.9 4 17.44 5.56 18.84 7.88C18.41 7.95 17.96 8 17.5 8C14.6 8 12.06 6.44 10.66 4.12C11.09 4.05 11.54 4 12 4M8.08 5.03C7.45 6.92 6.13 8.5 4.42 9.47C5.05 7.58 6.37 6 8.08 5.03M4 11.86C6.6 10.88 8.69 8.87 9.74 6.31C11.58 8.56 14.37 10 17.5 10C18.25 10 18.97 9.91 19.67 9.76C19.88 10.47 20 11.22 20 12C20 16.41 16.41 20 12 20S4 16.41 4 12V11.86M4 20V18C4.57 18.75 5.25 19.43 6 20H4M20 20H18C18.75 19.43 19.43 18.75 20 18V20M13.75 13C13.75 12.31 14.31 11.75 15 11.75S16.25 12.31 16.25 13 15.69 14.25 15 14.25 13.75 13.69 13.75 13M7.75 13C7.75 12.31 8.31 11.75 9 11.75S10.25 12.31 10.25 13 9.69 14.25 9 14.25 7.75 13.69 7.75 13Z";
var mdiFaceWomanProfile = "M17.25 13C17.25 13.69 16.69 14.25 16 14.25S14.75 13.69 14.75 13 15.31 11.75 16 11.75 17.25 12.31 17.25 13M22 12C22 17.5 17.5 22 12 22H2V12C2 6.5 6.5 2 12 2S22 6.5 22 12M7 18C8.41 19.23 10 20 12 20C16.41 20 20 16.41 20 12C20 11.21 19.88 10.45 19.67 9.74C18.95 9.91 18.2 10 17.42 10C15.42 10 13.57 9.4 12 8.39C12 8.39 10.54 13.76 8.03 13C7.37 12.8 7 13.31 7 14";
var mdiFaceWomanShimmer = "M19.5 1L18.41 3.41L16 4.5L18.41 5.59L19.5 8L20.6 5.59L23 4.5L20.6 3.41L19.5 1M12 2C6.5 2 2 6.5 2 12V22H22V12C22 10.53 21.67 9.13 21.1 7.87L19.86 10.59C19.94 11.05 20 11.5 20 12C20 16.43 16.43 20 12 20C7.57 20 4 16.43 4 12C4 11.96 4 11.91 4 11.87A10 10 0 0 0 9.74 6.31A10 10 0 0 0 17.5 10A10 10 0 0 0 18.83 9.91L17.35 6.65L12.6 4.5L16.13 2.9C14.87 2.33 13.47 2 12 2M9 11.75A1.25 1.25 0 0 0 7.75 13A1.25 1.25 0 0 0 9 14.25A1.25 1.25 0 0 0 10.25 13A1.25 1.25 0 0 0 9 11.75M15 11.75A1.25 1.25 0 0 0 13.75 13A1.25 1.25 0 0 0 15 14.25A1.25 1.25 0 0 0 16.25 13A1.25 1.25 0 0 0 15 11.75Z";
var mdiFaceWomanShimmerOutline = "M19.5 1L18.41 3.41L16 4.5L18.41 5.59L19.5 8L20.6 5.59L23 4.5L20.6 3.41M12 2C6.5 2 2 6.5 2 12V22H22V12C22 10.53 21.67 9.13 21.1 7.87L19.86 10.57C19.95 11.04 20 11.5 20 12C20 16.43 16.43 20 12 20C7.57 20 4 16.43 4 12C4 11.95 4 11.91 4 11.86C6.61 10.89 8.69 8.88 9.74 6.31C11.61 8.61 14.44 10 17.5 10C17.94 10 18.39 9.97 18.83 9.91L17.96 8C17.81 8 17.65 8 17.5 8C14.68 8 12.1 6.5 10.66 4.12C11.1 4.05 11.54 4 12 4C12.5 4 12.96 4.05 13.42 4.13L16.13 2.91C14.87 2.33 13.47 2 12 2M8.09 5C7.46 6.91 6.15 8.5 4.41 9.5C5.04 7.57 6.37 6 8.09 5M9 11.75C8.31 11.75 7.75 12.31 7.75 13C7.75 13.69 8.31 14.25 9 14.25C9.69 14.25 10.25 13.69 10.25 13C10.25 12.31 9.69 11.75 9 11.75M15 11.75C14.31 11.75 13.75 12.31 13.75 13C13.75 13.69 14.31 14.25 15 14.25C15.69 14.25 16.25 13.69 16.25 13C16.25 12.31 15.69 11.75 15 11.75M4 17.97C4.58 18.74 5.26 19.42 6.03 20H4M20 17.97V20H17.97C18.74 19.42 19.42 18.74 20 17.97Z";
var mdiFacebook = "M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z";
var mdiFacebookGaming = "M9.5 14.5V9.5H21V21H15.5V14.5H9.5M3 3H21L21 8.5H8.5V15.5H14.5V21H3V3Z";
var mdiFacebookMessenger = "M12,2C6.36,2 2,6.13 2,11.7C2,14.61 3.19,17.14 5.14,18.87C5.3,19 5.4,19.22 5.41,19.44L5.46,21.22C5.5,21.79 6.07,22.16 6.59,21.93L8.57,21.06C8.74,21 8.93,20.97 9.1,21C10,21.27 11,21.4 12,21.4C17.64,21.4 22,17.27 22,11.7C22,6.13 17.64,2 12,2M18,9.46L15.07,14.13C14.6,14.86 13.6,15.05 12.9,14.5L10.56,12.77C10.35,12.61 10.05,12.61 9.84,12.77L6.68,15.17C6.26,15.5 5.71,15 6,14.54L8.93,9.87C9.4,9.14 10.4,8.95 11.1,9.47L13.44,11.23C13.66,11.39 13.95,11.39 14.16,11.23L17.32,8.83C17.74,8.5 18.29,9 18,9.46Z";
var mdiFacebookWorkplace = "M19.69,16.12C19.42,16.43 18.95,16.92 18.19,16.92C17.13,16.92 16.78,16.15 16.46,15.34L14.86,11.41L13.26,15.34C13,16 12.7,16.92 11.53,16.92C10.36,16.92 10.07,16 9.79,15.34L7.11,8.72H9.37L11.53,14.17L13.14,10.2C13.39,9.57 13.69,8.62 14.86,8.62C16,8.62 16.32,9.57 16.58,10.2L18.33,14.5C19.22,13.14 19.6,11.5 19.38,9.89C19.16,8.28 18.37,6.8 17.14,5.73C15.92,4.66 14.34,4.06 12.72,4.06C11.03,4.05 9.39,4.58 8,5.56C6.66,6.55 5.64,7.94 5.12,9.54C4.6,11.14 4.6,12.87 5.12,14.47C5.64,16.07 6.66,17.46 8.03,18.44C9.4,19.43 11.04,19.95 12.72,19.94C13.45,19.94 14.17,19.84 14.87,19.64V21.75C14.16,21.91 13.44,22 12.72,22C10.61,22 8.54,21.34 6.82,20.1C5.1,18.86 3.82,17.11 3.17,15.1C2.5,13.09 2.5,10.92 3.16,8.9C3.82,6.89 5.1,5.14 6.82,3.9C8.53,2.66 10.6,2 12.72,2C17.56,2 21.5,5.94 21.5,10.79C21.5,12.71 20.86,14.59 19.69,16.12V16.12Z";
var mdiFactory = "M4,18V20H8V18H4M4,14V16H14V14H4M10,18V20H14V18H10M16,14V16H20V14H16M16,18V20H20V18H16M2,22V8L7,12V8L12,12V8L17,12L18,2H21L22,12V22H2Z";
var mdiFamilyTree = "M12 1A2.5 2.5 0 0 0 9.5 3.5A2.5 2.5 0 0 0 11 5.79V7H7A2 2 0 0 0 5 9V9.71A2.5 2.5 0 0 0 3.5 12A2.5 2.5 0 0 0 5 14.29V15H4A2 2 0 0 0 2 17V18.21A2.5 2.5 0 0 0 .5 20.5A2.5 2.5 0 0 0 3 23A2.5 2.5 0 0 0 5.5 20.5A2.5 2.5 0 0 0 4 18.21V17H8V18.21A2.5 2.5 0 0 0 6.5 20.5A2.5 2.5 0 0 0 9 23A2.5 2.5 0 0 0 11.5 20.5A2.5 2.5 0 0 0 10 18.21V17A2 2 0 0 0 8 15H7V14.29A2.5 2.5 0 0 0 8.5 12A2.5 2.5 0 0 0 7 9.71V9H17V9.71A2.5 2.5 0 0 0 15.5 12A2.5 2.5 0 0 0 17 14.29V15H16A2 2 0 0 0 14 17V18.21A2.5 2.5 0 0 0 12.5 20.5A2.5 2.5 0 0 0 15 23A2.5 2.5 0 0 0 17.5 20.5A2.5 2.5 0 0 0 16 18.21V17H20V18.21A2.5 2.5 0 0 0 18.5 20.5A2.5 2.5 0 0 0 21 23A2.5 2.5 0 0 0 23.5 20.5A2.5 2.5 0 0 0 22 18.21V17A2 2 0 0 0 20 15H19V14.29A2.5 2.5 0 0 0 20.5 12A2.5 2.5 0 0 0 19 9.71V9A2 2 0 0 0 17 7H13V5.79A2.5 2.5 0 0 0 14.5 3.5A2.5 2.5 0 0 0 12 1M12 2.5A1 1 0 0 1 13 3.5A1 1 0 0 1 12 4.5A1 1 0 0 1 11 3.5A1 1 0 0 1 12 2.5M6 11A1 1 0 0 1 7 12A1 1 0 0 1 6 13A1 1 0 0 1 5 12A1 1 0 0 1 6 11M18 11A1 1 0 0 1 19 12A1 1 0 0 1 18 13A1 1 0 0 1 17 12A1 1 0 0 1 18 11M3 19.5A1 1 0 0 1 4 20.5A1 1 0 0 1 3 21.5A1 1 0 0 1 2 20.5A1 1 0 0 1 3 19.5M9 19.5A1 1 0 0 1 10 20.5A1 1 0 0 1 9 21.5A1 1 0 0 1 8 20.5A1 1 0 0 1 9 19.5M15 19.5A1 1 0 0 1 16 20.5A1 1 0 0 1 15 21.5A1 1 0 0 1 14 20.5A1 1 0 0 1 15 19.5M21 19.5A1 1 0 0 1 22 20.5A1 1 0 0 1 21 21.5A1 1 0 0 1 20 20.5A1 1 0 0 1 21 19.5Z";
var mdiFan = "M12,11A1,1 0 0,0 11,12A1,1 0 0,0 12,13A1,1 0 0,0 13,12A1,1 0 0,0 12,11M12.5,2C17,2 17.11,5.57 14.75,6.75C13.76,7.24 13.32,8.29 13.13,9.22C13.61,9.42 14.03,9.73 14.35,10.13C18.05,8.13 22.03,8.92 22.03,12.5C22.03,17 18.46,17.1 17.28,14.73C16.78,13.74 15.72,13.3 14.79,13.11C14.59,13.59 14.28,14 13.88,14.34C15.87,18.03 15.08,22 11.5,22C7,22 6.91,18.42 9.27,17.24C10.25,16.75 10.69,15.71 10.89,14.79C10.4,14.59 9.97,14.27 9.65,13.87C5.96,15.85 2,15.07 2,11.5C2,7 5.56,6.89 6.74,9.26C7.24,10.25 8.29,10.68 9.22,10.87C9.41,10.39 9.73,9.97 10.14,9.65C8.15,5.96 8.94,2 12.5,2Z";
var mdiFanAlert = "M10 11C9.43 11 9 11.45 9 12S9.43 13 10 13C10.54 13 11 12.55 11 12S10.54 11 10 11M10.5 2C15 2 15.09 5.57 12.73 6.75C11.74 7.24 11.3 8.29 11.11 9.22C11.59 9.42 12 9.73 12.33 10.13C16.03 8.13 20 8.92 20 12.5C20 17 16.43 17.1 15.26 14.73C14.76 13.74 13.7 13.3 12.77 13.11C12.57 13.59 12.26 14 11.86 14.34C13.85 18.03 13.06 22 9.5 22C5 22 4.9 18.42 7.26 17.24C8.24 16.75 8.68 15.71 8.88 14.79C8.39 14.59 7.96 14.27 7.64 13.87C3.95 15.85 0 15.07 0 11.5C0 7 3.56 6.89 4.73 9.26C5.23 10.25 6.28 10.68 7.21 10.87C7.4 10.39 7.72 9.97 8.13 9.65C6.14 5.96 6.93 2 10.5 2M22 13V7H24V13H22M22 17V15H24V17H22Z";
var mdiFanAuto = "M12.5 2C8.93 2 8.14 5.96 10.13 9.65C9.72 9.97 9.4 10.39 9.21 10.87C8.28 10.68 7.23 10.25 6.73 9.26C5.56 6.89 2 7 2 11.5C2 15.07 5.95 15.85 9.64 13.87C9.96 14.27 10.39 14.59 10.88 14.79C10.68 15.71 10.24 16.75 9.26 17.24C6.9 18.42 7 22 11.5 22C12.31 22 13 21.78 13.5 21.41C13.19 20.67 13 19.86 13 19C13 17.59 13.5 16.3 14.3 15.28C14.17 14.97 14.03 14.65 13.86 14.34C14.26 14 14.57 13.59 14.77 13.11C15.26 13.21 15.78 13.39 16.25 13.67C17.07 13.25 18 13 19 13C20.05 13 21.03 13.27 21.89 13.74C21.95 13.37 22 12.96 22 12.5C22 8.92 18.03 8.13 14.33 10.13C14 9.73 13.59 9.42 13.11 9.22C13.3 8.29 13.74 7.24 14.73 6.75C17.09 5.57 17 2 12.5 2M12 11C12.54 11 13 11.45 13 12C13 12.55 12.54 13 12 13C11.43 13 11 12.55 11 12C11 11.45 11.43 11 12 11M18 15C16.89 15 16 15.9 16 17V23H18V21H20V23H22V17C22 15.9 21.1 15 20 15M18 17H20V19H18Z";
var mdiFanChevronDown = "M13 19C13 17.59 13.5 16.3 14.3 15.28C14.17 14.97 14.03 14.65 13.86 14.34C14.26 14 14.57 13.59 14.77 13.11C15.26 13.21 15.78 13.39 16.25 13.67C17.07 13.25 18 13 19 13C20.05 13 21.03 13.27 21.89 13.74C21.95 13.37 22 12.96 22 12.5C22 8.92 18.03 8.13 14.33 10.13C14 9.73 13.59 9.42 13.11 9.22C13.3 8.29 13.74 7.24 14.73 6.75C17.09 5.57 17 2 12.5 2C8.93 2 8.14 5.96 10.13 9.65C9.72 9.97 9.4 10.39 9.21 10.87C8.28 10.68 7.23 10.25 6.73 9.26C5.56 6.89 2 7 2 11.5C2 15.07 5.95 15.85 9.64 13.87C9.96 14.27 10.39 14.59 10.88 14.79C10.68 15.71 10.24 16.75 9.26 17.24C6.9 18.42 7 22 11.5 22C12.31 22 13 21.78 13.5 21.41C13.19 20.67 13 19.86 13 19M12 13C11.43 13 11 12.55 11 12S11.43 11 12 11C12.54 11 13 11.45 13 12S12.54 13 12 13M19 19.17L22.17 16L23.59 17.41L19 22L14.41 17.41L15.83 16L19 19.17";
var mdiFanChevronUp = "M13 19C13 17.59 13.5 16.3 14.3 15.28C14.17 14.97 14.03 14.65 13.86 14.34C14.26 14 14.57 13.59 14.77 13.11C15.26 13.21 15.78 13.39 16.25 13.67C17.07 13.25 18 13 19 13C20.05 13 21.03 13.27 21.89 13.74C21.95 13.37 22 12.96 22 12.5C22 8.92 18.03 8.13 14.33 10.13C14 9.73 13.59 9.42 13.11 9.22C13.3 8.29 13.74 7.24 14.73 6.75C17.09 5.57 17 2 12.5 2C8.93 2 8.14 5.96 10.13 9.65C9.72 9.97 9.4 10.39 9.21 10.87C8.28 10.68 7.23 10.25 6.73 9.26C5.56 6.89 2 7 2 11.5C2 15.07 5.95 15.85 9.64 13.87C9.96 14.27 10.39 14.59 10.88 14.79C10.68 15.71 10.24 16.75 9.26 17.24C6.9 18.42 7 22 11.5 22C12.31 22 13 21.78 13.5 21.41C13.19 20.67 13 19.86 13 19M12 13C11.43 13 11 12.55 11 12S11.43 11 12 11C12.54 11 13 11.45 13 12S12.54 13 12 13M19 17.83L15.83 21L14.41 19.59L19 15L23.59 19.59L22.17 21L19 17.83";
var mdiFanClock = "M16 14H17.5V16.8L19.9 18.2L19.1 19.5L16 17.7V14M21 11.3C20.8 7.9 17 7.2 13.3 9.2C13 8.8 12.6 8.5 12.1 8.3C12.3 7.4 12.7 6.3 13.7 5.8C16.1 4.6 16 1 11.5 1C7.9 1 7.2 5 9.1 8.7C8.7 9 8.4 9.4 8.2 9.9C7.3 9.7 6.2 9.3 5.7 8.3C4.6 5.9 1 6 1 10.5C1 14.1 5 14.8 8.7 12.9C9 13.3 9.5 13.6 9.9 13.8C9.7 14.7 9.3 15.8 8.3 16.3C5.9 17.4 6 21 10.5 21C10.8 21 11 21 11.2 20.9C12.5 22.8 14.6 24 17 24C20.9 24 24 20.9 24 17C24 14.6 22.8 12.5 21 11.3M11 10C11.6 10 12 10.4 12 11S11.6 12 11 12 10 11.6 10 11 10.4 10 11 10M17 22C14.2 22 12 19.8 12 17S14.2 12 17 12 22 14.2 22 17 19.8 22 17 22Z";
var mdiFanMinus = "M13 19C13 17.59 13.5 16.3 14.3 15.28C14.17 14.97 14.03 14.65 13.86 14.34C14.26 14 14.57 13.59 14.77 13.11C15.26 13.21 15.78 13.39 16.25 13.67C17.07 13.25 18 13 19 13C20.05 13 21.03 13.27 21.89 13.74C21.95 13.37 22 12.96 22 12.5C22 8.92 18.03 8.13 14.33 10.13C14 9.73 13.59 9.42 13.11 9.22C13.3 8.29 13.74 7.24 14.73 6.75C17.09 5.57 17 2 12.5 2C8.93 2 8.14 5.96 10.13 9.65C9.72 9.97 9.4 10.39 9.21 10.87C8.28 10.68 7.23 10.25 6.73 9.26C5.56 6.89 2 7 2 11.5C2 15.07 5.95 15.85 9.64 13.87C9.96 14.27 10.39 14.59 10.88 14.79C10.68 15.71 10.24 16.75 9.26 17.24C6.9 18.42 7 22 11.5 22C12.31 22 13 21.78 13.5 21.41C13.19 20.67 13 19.86 13 19M12 13C11.43 13 11 12.55 11 12S11.43 11 12 11C12.54 11 13 11.45 13 12S12.54 13 12 13M23 18V20H15V18H23Z";
var mdiFanOff = "M12.5,2C9.64,2 8.57,4.55 9.29,7.47L15,13.16C15.87,13.37 16.81,13.81 17.28,14.73C18.46,17.1 22.03,17 22.03,12.5C22.03,8.92 18.05,8.13 14.35,10.13C14.03,9.73 13.61,9.42 13.13,9.22C13.32,8.29 13.76,7.24 14.75,6.75C17.11,5.57 17,2 12.5,2M3.28,4L2,5.27L4.47,7.73C3.22,7.74 2,8.87 2,11.5C2,15.07 5.96,15.85 9.65,13.87C9.97,14.27 10.4,14.59 10.89,14.79C10.69,15.71 10.25,16.75 9.27,17.24C6.91,18.42 7,22 11.5,22C13.8,22 14.94,20.36 14.94,18.21L18.73,22L20,20.72L3.28,4Z";
var mdiFanPlus = "M13 19C13 17.59 13.5 16.3 14.3 15.28C14.17 14.97 14.03 14.65 13.86 14.34C14.26 14 14.57 13.59 14.77 13.11C15.26 13.21 15.78 13.39 16.25 13.67C17.07 13.25 18 13 19 13C20.05 13 21.03 13.27 21.89 13.74C21.95 13.37 22 12.96 22 12.5C22 8.92 18.03 8.13 14.33 10.13C14 9.73 13.59 9.42 13.11 9.22C13.3 8.29 13.74 7.24 14.73 6.75C17.09 5.57 17 2 12.5 2C8.93 2 8.14 5.96 10.13 9.65C9.72 9.97 9.4 10.39 9.21 10.87C8.28 10.68 7.23 10.25 6.73 9.26C5.56 6.89 2 7 2 11.5C2 15.07 5.95 15.85 9.64 13.87C9.96 14.27 10.39 14.59 10.88 14.79C10.68 15.71 10.24 16.75 9.26 17.24C6.9 18.42 7 22 11.5 22C12.31 22 13 21.78 13.5 21.41C13.19 20.67 13 19.86 13 19M12 13C11.43 13 11 12.55 11 12S11.43 11 12 11C12.54 11 13 11.45 13 12S12.54 13 12 13M20 15V18H23V20H20V23H18V20H15V18H18V15H20Z";
var mdiFanRemove = "M13 19C13 17.59 13.5 16.3 14.3 15.28C14.17 14.97 14.03 14.65 13.86 14.34C14.26 14 14.57 13.59 14.77 13.11C15.26 13.21 15.78 13.39 16.25 13.67C17.07 13.25 18 13 19 13C20.05 13 21.03 13.27 21.89 13.74C21.95 13.37 22 12.96 22 12.5C22 8.92 18.03 8.13 14.33 10.13C14 9.73 13.59 9.42 13.11 9.22C13.3 8.29 13.74 7.24 14.73 6.75C17.09 5.57 17 2 12.5 2C8.93 2 8.14 5.96 10.13 9.65C9.72 9.97 9.4 10.39 9.21 10.87C8.28 10.68 7.23 10.25 6.73 9.26C5.56 6.89 2 7 2 11.5C2 15.07 5.95 15.85 9.64 13.87C9.96 14.27 10.39 14.59 10.88 14.79C10.68 15.71 10.24 16.75 9.26 17.24C6.9 18.42 7 22 11.5 22C12.31 22 13 21.78 13.5 21.41C13.19 20.67 13 19.86 13 19M12 13C11.43 13 11 12.55 11 12S11.43 11 12 11C12.54 11 13 11.45 13 12S12.54 13 12 13M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88Z";
var mdiFanSpeed1 = "M13 19C13 17.59 13.5 16.3 14.3 15.28C14.17 14.97 14.03 14.65 13.86 14.34C14.26 14 14.57 13.59 14.77 13.11C15.26 13.21 15.78 13.39 16.25 13.67C17.07 13.25 18 13 19 13C20.05 13 21.03 13.27 21.89 13.74C21.95 13.37 22 12.96 22 12.5C22 8.92 18.03 8.13 14.33 10.13C14 9.73 13.59 9.42 13.11 9.22C13.3 8.29 13.74 7.24 14.73 6.75C17.09 5.57 17 2 12.5 2C8.93 2 8.14 5.96 10.13 9.65C9.72 9.97 9.4 10.39 9.21 10.87C8.28 10.68 7.23 10.25 6.73 9.26C5.56 6.89 2 7 2 11.5C2 15.07 5.95 15.85 9.64 13.87C9.96 14.27 10.39 14.59 10.88 14.79C10.68 15.71 10.24 16.75 9.26 17.24C6.9 18.42 7 22 11.5 22C12.31 22 13 21.78 13.5 21.41C13.19 20.67 13 19.86 13 19M12 13C11.43 13 11 12.55 11 12S11.43 11 12 11C12.54 11 13 11.45 13 12S12.54 13 12 13M17 15V17H18V23H20V15H17Z";
var mdiFanSpeed2 = "M13 19C13 17.59 13.5 16.3 14.3 15.28C14.17 14.97 14.03 14.65 13.86 14.34C14.26 14 14.57 13.59 14.77 13.11C15.26 13.21 15.78 13.39 16.25 13.67C17.07 13.25 18 13 19 13C20.05 13 21.03 13.27 21.89 13.74C21.95 13.37 22 12.96 22 12.5C22 8.92 18.03 8.13 14.33 10.13C14 9.73 13.59 9.42 13.11 9.22C13.3 8.29 13.74 7.24 14.73 6.75C17.09 5.57 17 2 12.5 2C8.93 2 8.14 5.96 10.13 9.65C9.72 9.97 9.4 10.39 9.21 10.87C8.28 10.68 7.23 10.25 6.73 9.26C5.56 6.89 2 7 2 11.5C2 15.07 5.95 15.85 9.64 13.87C9.96 14.27 10.39 14.59 10.88 14.79C10.68 15.71 10.24 16.75 9.26 17.24C6.9 18.42 7 22 11.5 22C12.31 22 13 21.78 13.5 21.41C13.19 20.67 13 19.86 13 19M12 13C11.43 13 11 12.55 11 12S11.43 11 12 11C12.54 11 13 11.45 13 12S12.54 13 12 13M16 15V17H19V18H18C16.9 18 16 18.9 16 20V23H21V21H18V20H19C20.11 20 21 19.11 21 18V17C21 15.9 20.11 15 19 15H16Z";
var mdiFanSpeed3 = "M13 19C13 17.59 13.5 16.3 14.3 15.28C14.17 14.97 14.03 14.65 13.86 14.34C14.26 14 14.57 13.59 14.77 13.11C15.26 13.21 15.78 13.39 16.25 13.67C17.07 13.25 18 13 19 13C20.05 13 21.03 13.27 21.89 13.74C21.95 13.37 22 12.96 22 12.5C22 8.92 18.03 8.13 14.33 10.13C14 9.73 13.59 9.42 13.11 9.22C13.3 8.29 13.74 7.24 14.73 6.75C17.09 5.57 17 2 12.5 2C8.93 2 8.14 5.96 10.13 9.65C9.72 9.97 9.4 10.39 9.21 10.87C8.28 10.68 7.23 10.25 6.73 9.26C5.56 6.89 2 7 2 11.5C2 15.07 5.95 15.85 9.64 13.87C9.96 14.27 10.39 14.59 10.88 14.79C10.68 15.71 10.24 16.75 9.26 17.24C6.9 18.42 7 22 11.5 22C12.31 22 13 21.78 13.5 21.41C13.19 20.67 13 19.86 13 19M12 13C11.43 13 11 12.55 11 12S11.43 11 12 11C12.54 11 13 11.45 13 12S12.54 13 12 13M21 21V20.5C21 19.67 20.33 19 19.5 19C20.33 19 21 18.33 21 17.5V17C21 15.89 20.1 15 19 15H16V17H19V18H17V20H19V21H16V23H19C20.11 23 21 22.11 21 21";
var mdiFastForward = "M13,6V18L21.5,12M4,18L12.5,12L4,6V18Z";
var mdiFastForward10 = "M10,12V22H8V14H6V12H10M18,14V20C18,21.11 17.11,22 16,22H14A2,2 0 0,1 12,20V14A2,2 0 0,1 14,12H16C17.11,12 18,12.9 18,14M14,14V20H16V14H14M11.5,3C14.15,3 16.55,4 18.4,5.6L21,3V10H14L16.62,7.38C15.23,6.22 13.46,5.5 11.5,5.5C7.96,5.5 4.95,7.81 3.9,11L1.53,10.22C2.92,6.03 6.85,3 11.5,3Z";
var mdiFastForward15 = "M11.5 3C14.15 3 16.55 4 18.4 5.6L21 3V10H14L16.62 7.38C15.23 6.22 13.46 5.5 11.5 5.5C7.96 5.5 4.95 7.81 3.9 11L1.53 10.22C2.92 6.03 6.85 3 11.5 3M10 12V22H8V14H6V12H10M12 12H18V14H14V16H16C17.11 16 18 16.9 18 18V20C18 21.11 17.11 22 16 22H12V20H16V18H12V12Z";
var mdiFastForward30 = "M11.5,3C6.85,3 2.92,6.03 1.53,10.22L3.9,11C4.95,7.81 7.96,5.5 11.5,5.5C13.46,5.5 15.23,6.22 16.62,7.38L14,10H21V3L18.4,5.6C16.55,4 14.15,3 11.5,3M19,14V20C19,21.11 18.11,22 17,22H15A2,2 0 0,1 13,20V14A2,2 0 0,1 15,12H17C18.11,12 19,12.9 19,14M15,14V20H17V14H15M11,20C11,21.11 10.1,22 9,22H5V20H9V18H7V16H9V14H5V12H9A2,2 0 0,1 11,14V15.5A1.5,1.5 0 0,1 9.5,17A1.5,1.5 0 0,1 11,18.5V20Z";
var mdiFastForward45 = "M11.5 3C14.1 3 16.5 4 18.4 5.6L21 3V10H14L16.6 7.4C15.2 6.2 13.4 5.5 11.5 5.5C8 5.5 4.9 7.8 3.9 11L1.5 10.2C2.9 6 6.8 3 11.5 3M13 12H19V14H15V16H17C18.1 16 19 16.9 19 18V20C19 21.1 18.1 22 17 22H13V20H17V18H13V12M5 12V18H9V22H11V12H9V16H7V12H5Z";
var mdiFastForward5 = "M11.5 3C14.15 3 16.55 4 18.4 5.6L21 3V10H14L16.62 7.38C15.23 6.22 13.46 5.5 11.5 5.5C7.96 5.5 4.95 7.81 3.9 11L1.53 10.22C2.92 6.03 6.85 3 11.5 3M9 12H15V14H11V16H13C14.11 16 15 16.9 15 18V20C15 21.11 14.11 22 13 22H9V20H13V18H9V12Z";
var mdiFastForward60 = "M11.5 3C6.8 3 2.9 6 1.5 10.2L3.9 11C4.9 7.8 8 5.5 11.5 5.5C13.5 5.5 15.2 6.2 16.6 7.4L14 10H21V3L18.4 5.6C16.5 4 14.1 3 11.5 3M19 14V20C19 21.1 18.1 22 17 22H15C13.9 22 13 21.1 13 20V14C13 12.9 13.9 12 15 12H17C18.1 12 19 12.9 19 14M15 14V20H17V14H15M7 12C5.9 12 5 12.9 5 14V20C5 21.1 5.9 22 7 22H9C10.1 22 11 21.1 11 20V18C11 16.9 10.1 16 9 16H7V14H11V12H7M7 18H9V20H7V18Z";
var mdiFastForwardOutline = "M15,9.9L18,12L15,14.1V9.9M6,9.9L9,12L6,14.1V9.9M13,6V18L21.5,12L13,6M4,6V18L12.5,12L4,6Z";
var mdiFaucet = "M19 14V16H16V14.28L19 14M19 13C19 11.9 18 11 16.8 11H10V10H5V21H10V13.91L19 13M5 9H10V7L15.36 5.21C15.74 5.09 16 4.73 16 4.33C16 3.68 15.36 3.23 14.75 3.45L5 7V9Z";
var mdiFaucetVariant = "M21 21H3C3 19.9 3.9 19 5 19H19C20.11 19 21 19.89 21 21M19 7C19 5.39 17.93 3 15 3S11 5.39 11 7V18H13V7C13 6.54 13.17 5 15 5S17 6.54 17 7H16.5V9H19.5V7H19M7 12C6.45 12 6 12.45 6 13V14H3V15H6V18H8V13C8 12.45 7.55 12 7 12M21 14H18V13C18 12.45 17.55 12 17 12S16 12.45 16 13V18H18V15H21V14Z";
var mdiFax = "M19 9H18V4H8V20H22V12C22 10.34 20.66 9 19 9M10 6H16V9H10V6M14 17H10V12H14V17M16 17C15.45 17 15 16.55 15 16C15 15.45 15.45 15 16 15C16.55 15 17 15.45 17 16C17 16.55 16.55 17 16 17M16 14C15.45 14 15 13.55 15 13S15.45 12 16 12C16.55 12 17 12.45 17 13S16.55 14 16 14M19 17C18.45 17 18 16.55 18 16C18 15.45 18.45 15 19 15S20 15.45 20 16C20 16.55 19.55 17 19 17M19 14C18.45 14 18 13.55 18 13S18.45 12 19 12 20 12.45 20 13 19.55 14 19 14M4.5 8C3.12 8 2 9.12 2 10.5V18.5C2 19.88 3.12 21 4.5 21S7 19.88 7 18.5V10.5C7 9.12 5.88 8 4.5 8Z";
var mdiFeather = "M22,2C22,2 14.36,1.63 8.34,9.88C3.72,16.21 2,22 2,22L3.94,21C5.38,18.5 6.13,17.47 7.54,16C10.07,16.74 12.71,16.65 15,14C13,13.44 11.4,13.57 9.04,13.81C11.69,12 13.5,11.6 16,12L17,10C15.2,9.66 14,9.63 12.22,10.04C14.19,8.65 15.56,7.87 18,8L19.21,6.07C17.65,5.96 16.71,6.13 14.92,6.57C16.53,5.11 18,4.45 20.14,4.32C20.14,4.32 21.19,2.43 22,2Z";
var mdiFeatureSearch = "M20,20A2,2 0 0,1 18,22H4A2,2 0 0,1 2,20V6A2,2 0 0,1 4,4H9.5C9.2,4.8 9,5.6 9,6.5C9,10.1 11.9,13 15.5,13C16.3,13 17,12.9 17.6,12.6L20,15V20M19.3,8.9C19.7,8.2 20,7.4 20,6.5C20,4 18,2 15.5,2C13,2 11,4 11,6.5C11,9 13,11 15.5,11C16.4,11 17.2,10.7 17.9,10.3L21,13.4L22.4,12L19.3,8.9M15.5,9C14.1,9 13,7.9 13,6.5C13,5.1 14.1,4 15.5,4C16.9,4 18,5.1 18,6.5C18,7.9 16.9,9 15.5,9Z";
var mdiFeatureSearchOutline = "M15.5,2C13,2 11,4 11,6.5C11,9 13,11 15.5,11C16.4,11 17.2,10.7 17.9,10.3L21,13.4L22.4,12L19.3,8.9C19.7,8.2 20,7.4 20,6.5C20,4 18,2 15.5,2M4,4A2,2 0 0,0 2,6V20A2,2 0 0,0 4,22H18A2,2 0 0,0 20,20V15L18,13V20H4V6H9.03C9.09,5.3 9.26,4.65 9.5,4H4M15.5,4C16.9,4 18,5.1 18,6.5C18,7.9 16.9,9 15.5,9C14.1,9 13,7.9 13,6.5C13,5.1 14.1,4 15.5,4Z";
var mdiFedora = "M12 2C6.5 2 2 6.47 2 12H2V19.73H2C2 21 3 22 4.27 22H12C17.53 22 22 17.5 22 12C22 6.5 17.5 2 12 2M14.03 6.12C15.71 6.12 17.29 7.4 17.29 9.18C17.29 9.34 17.29 9.5 17.27 9.69C17.22 10.16 16.79 10.5 16.32 10.44C15.85 10.37 15.53 9.92 15.62 9.46C15.62 9.4 15.63 9.32 15.63 9.18C15.63 8.17 14.81 7.78 14.03 7.78C13.25 7.78 12.55 8.44 12.55 9.18C12.56 10.03 12.55 10.88 12.55 11.74L14 11.72C15.12 11.7 15.13 13.4 14 13.39L12.55 13.4L12.54 15.79C12.36 17.67 10.77 19.16 8.85 19.16C6.82 19.16 5.14 17.5 5.14 15.46C5.2 13.37 6.88 11.72 9 11.74L10.15 11.73V13.4L9 13.41H8.97C7.81 13.44 6.82 14.23 6.81 15.47C6.81 16.59 7.72 17.5 8.85 17.5C10 17.5 10.88 16.67 10.88 15.47C10.9 13.46 10.87 11.25 10.88 9.17C10.88 9.05 10.89 8.96 10.9 8.83C11.09 7.29 12.47 6.12 14.03 6.12";
var mdiFence = "M9 9V11H7V9H5V11H3V9H1V21H3V19H5V21H7V19H9V21H11V19H13V21H15V19H17V21H19V19H21V21H23V9H21V11H19V9H17V11H15V9H13V11H11V9H9M3 13H5V17H3V13M7 13H9V17H7V13M11 13H13V17H11V13M15 13H17V17H15V13M19 13H21V17H19V13Z";
var mdiFenceElectric = "M9 9V11H7V9H5V11H3V9H1V21H3V19H5V21H7V19H9V21H11V19H13V21H15V19H17V21H19V19H21V21H23V9H21V11H19V9H17V11H15V9H13V11H11V9H9M3 13H5V17H3V13M7 13H9V17H7V13M11 13H13V17H11V13M15 13H17V17H15V13M19 13H21V17H19V13M7 4H11V2L17 5H13V7L7 4Z";
var mdiFencing = "M4.5 17.42L5.58 18.5L3.28 20.78C3 21.07 2.5 21.07 2.22 20.78S1.93 20 2.22 19.72L4.5 17.42M18.29 5.42L18.29 4L12 10.29L5.71 4L5.71 5.42L11.29 11L7.5 14.81C6.32 13.97 4.68 14.07 3.63 15.12L7.88 19.37C8.93 18.32 9.03 16.68 8.2 15.5L18.29 5.42M21.78 19.72L19.5 17.42L18.42 18.5L20.72 20.78C21 21.07 21.5 21.07 21.78 20.78S22.07 20 21.78 19.72M16.5 14.81L13.42 11.71L12.71 12.42L15.81 15.5C14.97 16.68 15.07 18.32 16.12 19.37L20.37 15.12C19.32 14.07 17.68 13.97 16.5 14.81Z";
var mdiFerrisWheel = "M12,19C12.86,19 13.59,19.54 13.87,20.29C14.42,20.17 14.95,20 15.46,19.77L13.7,15.62C13.18,15.87 12.61,16 12,16C11.39,16 10.82,15.87 10.3,15.62L8.54,19.77C9.05,20 9.58,20.17 10.13,20.29C10.41,19.54 11.14,19 12,19M18.25,17.76C18,17.42 17.81,17 17.81,16.5C17.81,15.41 18.71,14.5 19.81,14.5L20.12,14.53C20.37,13.73 20.5,12.88 20.5,12C20.5,11.12 20.37,10.27 20.12,9.5H19.81C18.7,9.5 17.81,8.61 17.81,7.5C17.81,7 17.97,6.59 18.25,6.24C17.1,5 15.59,4.09 13.87,3.71C13.59,4.46 12.86,5 12,5C11.14,5 10.41,4.46 10.13,3.71C8.41,4.09 6.9,5 5.75,6.24C6.03,6.59 6.2,7.03 6.2,7.5C6.2,8.61 5.3,9.5 4.2,9.5H3.88C3.63,10.28 3.5,11.12 3.5,12C3.5,12.89 3.64,13.74 3.89,14.55L4.2,14.5C5.31,14.5 6.2,15.42 6.2,16.5C6.2,17 6.04,17.43 5.76,17.77C6.08,18.12 6.44,18.44 6.81,18.73L8.71,14.27C8.26,13.62 8,12.84 8,12A4,4 0 0,1 12,8A4,4 0 0,1 16,12C16,12.84 15.74,13.62 15.29,14.27L17.19,18.73C17.57,18.44 17.92,18.11 18.25,17.76M12,23C11,23 10.16,22.26 10,21.29C9.37,21.16 8.75,20.95 8.15,20.69L7.17,23H5L6.41,19.68C5.88,19.3 5.39,18.86 4.96,18.37C4.72,18.47 4.47,18.5 4.2,18.5A2,2 0 0,1 2.2,16.5C2.2,15.88 2.5,15.32 2.97,14.95C2.66,14 2.5,13.03 2.5,12C2.5,11 2.66,10 2.96,9.08C2.5,8.71 2.2,8.15 2.2,7.5C2.2,6.41 3.09,5.5 4.2,5.5C4.46,5.5 4.71,5.56 4.93,5.65C6.25,4.18 8,3.13 10,2.71C10.16,1.74 11,1 12,1C13,1 13.84,1.74 14,2.71C16,3.13 17.74,4.18 19.06,5.64C19.29,5.55 19.54,5.5 19.81,5.5A2,2 0 0,1 21.81,7.5C21.81,8.14 21.5,8.71 21.04,9.07C21.34,10 21.5,11 21.5,12C21.5,13 21.34,14 21.04,14.93C21.5,15.3 21.81,15.87 21.81,16.5C21.81,17.62 20.92,18.5 19.81,18.5C19.54,18.5 19.29,18.46 19.05,18.36C18.61,18.85 18.12,19.29 17.59,19.68L19,23H16.83L15.85,20.69C15.25,20.95 14.63,21.16 14,21.29C13.84,22.26 13,23 12,23Z";
var mdiFerry = "M6,6H18V9.96L12,8L6,9.96M3.94,19H4C5.6,19 7,18.12 8,17C9,18.12 10.4,19 12,19C13.6,19 15,18.12 16,17C17,18.12 18.4,19 20,19H20.05L21.95,12.31C22.03,12.06 22,11.78 21.89,11.54C21.76,11.3 21.55,11.12 21.29,11.04L20,10.62V6C20,4.89 19.1,4 18,4H15V1H9V4H6A2,2 0 0,0 4,6V10.62L2.71,11.04C2.45,11.12 2.24,11.3 2.11,11.54C2,11.78 1.97,12.06 2.05,12.31M20,21C18.61,21 17.22,20.53 16,19.67C13.56,21.38 10.44,21.38 8,19.67C6.78,20.53 5.39,21 4,21H2V23H4C5.37,23 6.74,22.65 8,22C10.5,23.3 13.5,23.3 16,22C17.26,22.65 18.62,23 20,23H22V21H20Z";
var mdiFile = "M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z";
var mdiFileAccount = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M14,20V19C14,17.67 11.33,17 10,17C8.67,17 6,17.67 6,19V20H14M10,12A2,2 0 0,0 8,14A2,2 0 0,0 10,16A2,2 0 0,0 12,14A2,2 0 0,0 10,12Z";
var mdiFileAccountOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M13 13C13 14.1 12.1 15 11 15S9 14.1 9 13 9.9 11 11 11 13 11.9 13 13M15 18V19H7V18C7 16.67 9.67 16 11 16S15 16.67 15 18Z";
var mdiFileAlert = "M20 17H22V15H20V17M20 7V13H22V7M4 2C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H16C17.11 22 18 21.11 18 20V8L12 2M11 3.5L16.5 9H11Z";
var mdiFileAlertOutline = "M20 17H22V15H20V17M20 7V13H22V7M4 2C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H16C17.11 22 18 21.11 18 20V8L12 2M4 4H11V9H16V20H4Z";
var mdiFileArrowLeftRight = "M19 13C19.34 13 19.67 13.04 20 13.09V8L14 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M13 3.5L18.5 9H13V3.5M20 19.5V18H16V16H20V14.5L23 17L20 19.5M18 20H22V22H18V23.5L15 21L18 18.5V20Z";
var mdiFileArrowLeftRightOutline = "M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H14L20 8V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V9H13V4H6V20H13.09M23 17L20 14.5V16H16V18H20V19.5L23 17M18 18.5L15 21L18 23.5V22H22V20H18V18.5Z";
var mdiFileArrowUpDown = "M19 13C19.34 13 19.67 13.04 20 13.09V8L14 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M13 3.5L18.5 9H13V3.5M23.5 20L21 23L18.5 20H20V16H22V20H23.5M19.5 18H18V22H16V18H14.5L17 15L19.5 18Z";
var mdiFileArrowUpDownOutline = "M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H14L20 8V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V9H13V4H6V20H13.09M17 15L14.5 18H16V22H18V18H19.5L17 15M22 20V16H20V20H18.5L21 23L23.5 20H22Z";
var mdiFileCabinet = "M14,8H10V6H14V8M20,4V20C20,21.11 19.11,22 18,22H6C4.89,22 4,21.11 4,20V4A2,2 0 0,1 6,2H18C19.11,2 20,2.9 20,4M18,13H6V20H18V13M18,4H6V11H18V4M14,15H10V17H14V15Z";
var mdiFileCad = "M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2M13 3.5L18.5 9H13M9.88 9.25H11.12V10.19C11.81 10.18 12.38 10.75 12.38 11.44V13.5L12.26 13.63L13.15 15.17C13.47 14.67 13.63 14.09 13.62 13.5H14.88C14.88 14.54 14.5 15.55 13.83 16.35L15.5 19.25V20.5L14.42 19.88L12.87 17.19C12.17 17.65 11.34 17.89 10.5 17.89C9.66 17.89 8.84 17.65 8.13 17.19L6.58 19.88L5.5 20.5V19.25L8.74 13.63L8.62 13.5V11.44C8.62 10.75 9.19 10.18 9.88 10.19M10.5 11.44C9.81 11.44 9.46 12.28 9.95 12.77C10.44 13.26 11.28 12.92 11.28 12.22C11.28 11.79 10.93 11.44 10.5 11.44M9.66 14.54L8.76 16.11C9.81 16.82 11.19 16.82 12.24 16.11L11.34 14.54C10.87 15 10.13 15 9.66 14.54Z";
var mdiFileCadBox = "M5 3C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M11.25 5.25H12.75V6.38C13.58 6.38 14.25 7.05 14.25 7.88V10.37L14.11 10.5L15.18 12.36C15.55 11.76 15.75 11.07 15.75 10.36H17.25C17.26 11.61 16.81 12.82 16 13.77L18 17.25V18.75L16.7 18L14.84 14.78C13.12 15.91 10.89 15.91 9.16 14.78L7.3 18L6 18.75V17.25L9.89 10.5L9.75 10.37V7.88C9.75 7.05 10.42 6.38 11.25 6.38M12 7.88C11.16 7.88 10.74 8.9 11.34 9.5C11.94 10.08 12.95 9.65 12.94 8.81C12.94 8.29 12.5 7.88 12 7.88M11 11.6L9.91 13.5C11.17 14.36 12.83 14.36 14.09 13.5L13 11.6C12.43 12.11 11.57 12.11 11 11.6Z";
var mdiFileCancel = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M10.5,11C8,11 6,13 6,15.5C6,18 8,20 10.5,20C13,20 15,18 15,15.5C15,13 13,11 10.5,11M10.5,12.5A3,3 0 0,1 13.5,15.5C13.5,16.06 13.35,16.58 13.08,17L9,12.92C9.42,12.65 9.94,12.5 10.5,12.5M7.5,15.5C7.5,14.94 7.65,14.42 7.92,14L12,18.08C11.58,18.35 11.06,18.5 10.5,18.5A3,3 0 0,1 7.5,15.5Z";
var mdiFileCancelOutline = "M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M11.5,10C14,10 16,12 16,14.5C16,17 14,19 11.5,19C9,19 7,17 7,14.5C7,12 9,10 11.5,10M11.5,11.5C10.94,11.5 10.42,11.65 10,11.92L14.08,16C14.35,15.58 14.5,15.06 14.5,14.5A3,3 0 0,0 11.5,11.5M8.5,14.5A3,3 0 0,0 11.5,17.5C12.06,17.5 12.58,17.35 13,17.08L8.92,13C8.65,13.42 8.5,13.94 8.5,14.5Z";
var mdiFileCertificate = "M14 2H7A2 2 0 0 0 5 4V18A2 2 0 0 0 7 20H10V23L12 22L14 23V20H17A2 2 0 0 0 19 18V7M14 15V17L12 16L10 17V15L8 14L10 13V11L12 12L14 11V13L16 14M13 8V3.5L17.5 8Z";
var mdiFileCertificateOutline = "M14 13V11L12 12L10 11V13L8 14L10 15V17L12 16L14 17V15L16 14M14 2H7A2 2 0 0 0 5 4V18A2 2 0 0 0 7 20H8V18H7V4H13V8H17V18H16V20H17A2 2 0 0 0 19 18V7M14 13V11L12 12L10 11V13L8 14L10 15V17L12 16L14 17V15L16 14M10 23L12 22L14 23V18H10M14 13V11L12 12L10 11V13L8 14L10 15V17L12 16L14 17V15L16 14Z";
var mdiFileChart = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M7,20H9V14H7V20M11,20H13V12H11V20M15,20H17V16H15V20Z";
var mdiFileChartCheck = "M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H13.8C13.3 21.1 13 20.1 13 19V20H11V12H13V19C13 15.7 15.7 13 19 13C19.3 13 19.7 13 20 13.1V8L14 2H6M13 3.5L18.5 9H13V3.5M7 14H9V20H7V14Z";
var mdiFileChartCheckOutline = "M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H13.8C13.4 21.4 13.2 20.7 13.1 20H6V4H13V9H18V13.1C18.3 13 18.7 13 19 13C19.3 13 19.7 13 20 13.1V8L14 2H6M11 11V19H13V11H11M7 13V19H9V13H7Z";
var mdiFileChartOutline = "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2M18 20H6V4H13V9H18V20M9 13V19H7V13H9M15 15V19H17V15H15M11 11V19H13V11H11Z";
var mdiFileCheck = "M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M6 2C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.81C13.28 21.09 13 20.05 13 19C13 15.69 15.69 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M13 3.5L18.5 9H13Z";
var mdiFileCheckOutline = "M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M13.09 20H6V4H13V9H18V13.09C18.33 13.04 18.66 13 19 13S19.67 13.04 20 13.09V8L14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.46 21.39 13.21 20.72 13.09 20Z";
var mdiFileClock = "M4 2C2.89 2 2 2.89 2 4V20A2 2 0 0 0 4 22H12.41A7 7 0 0 0 16 23A7 7 0 0 0 23 16A7 7 0 0 0 18 9.3V8L12 2H4M11 3.5L16.5 9H11V3.5M16 11A5 5 0 0 1 21 16A5 5 0 0 1 16 21A5 5 0 0 1 11 16A5 5 0 0 1 16 11M15 12V17L18.61 19.16L19.36 17.94L16.5 16.25V12H15Z";
var mdiFileClockOutline = "M4 2A2 2 0 0 0 2 4V20A2 2 0 0 0 4 22H12.41A7 7 0 0 0 16 23A7 7 0 0 0 23 16A7 7 0 0 0 18 9.3V8L12 2H4M4 4H11V9H16A7 7 0 0 0 9 16A7 7 0 0 0 10.26 20H4V4M16 11A5 5 0 0 1 21 16A5 5 0 0 1 16 21A5 5 0 0 1 11 16A5 5 0 0 1 16 11M15 12V17L18.61 19.16L19.36 17.94L16.5 16.25V12H15Z";
var mdiFileCloud = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15.68,15C15.34,13.3 13.82,12 12,12C10.55,12 9.3,12.82 8.68,14C7.17,14.18 6,15.45 6,17A3,3 0 0,0 9,20H15.5A2.5,2.5 0 0,0 18,17.5C18,16.18 16.97,15.11 15.68,15Z";
var mdiFileCloudOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M17 16.92C17 18.07 16.07 19 14.92 19H9.5C8.12 19 7 17.88 7 16.5C7 15.21 8 14.15 9.23 14C9.75 13 10.79 12.33 12 12.33C13.5 12.33 14.78 13.42 15.07 14.83C16.14 14.93 17 15.82 17 16.92Z";
var mdiFileCode = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M6.12,15.5L9.86,19.24L11.28,17.83L8.95,15.5L11.28,13.17L9.86,11.76L6.12,15.5M17.28,15.5L13.54,11.76L12.12,13.17L14.45,15.5L12.12,17.83L13.54,19.24L17.28,15.5Z";
var mdiFileCodeOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M9.54 15.65L11.63 17.74L10.35 19L7 15.65L10.35 12.3L11.63 13.56L9.54 15.65M17 15.65L13.65 19L12.38 17.74L14.47 15.65L12.38 13.56L13.65 12.3L17 15.65Z";
var mdiFileCog = "M6 2C4.89 2 4 2.89 4 4V20A2 2 0 0 0 6 22H12.68A7 7 0 0 1 12 19A7 7 0 0 1 19 12A7 7 0 0 1 20 12.08V8L14 2H6M13 3.5L18.5 9H13V3.5M18 14C17.87 14 17.76 14.09 17.74 14.21L17.55 15.53C17.25 15.66 16.96 15.82 16.7 16L15.46 15.5C15.35 15.5 15.22 15.5 15.15 15.63L14.15 17.36C14.09 17.47 14.11 17.6 14.21 17.68L15.27 18.5C15.25 18.67 15.24 18.83 15.24 19C15.24 19.17 15.25 19.33 15.27 19.5L14.21 20.32C14.12 20.4 14.09 20.53 14.15 20.64L15.15 22.37C15.21 22.5 15.34 22.5 15.46 22.5L16.7 22C16.96 22.18 17.24 22.35 17.55 22.47L17.74 23.79C17.76 23.91 17.86 24 18 24H20C20.11 24 20.22 23.91 20.24 23.79L20.43 22.47C20.73 22.34 21 22.18 21.27 22L22.5 22.5C22.63 22.5 22.76 22.5 22.83 22.37L23.83 20.64C23.89 20.53 23.86 20.4 23.77 20.32L22.7 19.5C22.72 19.33 22.74 19.17 22.74 19C22.74 18.83 22.73 18.67 22.7 18.5L23.76 17.68C23.85 17.6 23.88 17.47 23.82 17.36L22.82 15.63C22.76 15.5 22.63 15.5 22.5 15.5L21.27 16C21 15.82 20.73 15.65 20.42 15.53L20.23 14.21C20.22 14.09 20.11 14 20 14H18M19 17.5C19.83 17.5 20.5 18.17 20.5 19C20.5 19.83 19.83 20.5 19 20.5C18.16 20.5 17.5 19.83 17.5 19C17.5 18.17 18.17 17.5 19 17.5Z";
var mdiFileCogOutline = "M6 2C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H12V20H6V4H13V9H18V12H20V8L14 2M18 14C17.87 14 17.76 14.09 17.74 14.21L17.55 15.53C17.25 15.66 16.96 15.82 16.7 16L15.46 15.5C15.35 15.5 15.22 15.5 15.15 15.63L14.15 17.36C14.09 17.47 14.11 17.6 14.21 17.68L15.27 18.5C15.25 18.67 15.24 18.83 15.24 19C15.24 19.17 15.25 19.33 15.27 19.5L14.21 20.32C14.12 20.4 14.09 20.53 14.15 20.64L15.15 22.37C15.21 22.5 15.34 22.5 15.46 22.5L16.7 22C16.96 22.18 17.24 22.35 17.55 22.47L17.74 23.79C17.76 23.91 17.86 24 18 24H20C20.11 24 20.22 23.91 20.24 23.79L20.43 22.47C20.73 22.34 21 22.18 21.27 22L22.5 22.5C22.63 22.5 22.76 22.5 22.83 22.37L23.83 20.64C23.89 20.53 23.86 20.4 23.77 20.32L22.7 19.5C22.72 19.33 22.74 19.17 22.74 19C22.74 18.83 22.73 18.67 22.7 18.5L23.76 17.68C23.85 17.6 23.88 17.47 23.82 17.36L22.82 15.63C22.76 15.5 22.63 15.5 22.5 15.5L21.27 16C21 15.82 20.73 15.65 20.42 15.53L20.23 14.21C20.22 14.09 20.11 14 20 14M19 17.5C19.83 17.5 20.5 18.17 20.5 19C20.5 19.83 19.83 20.5 19 20.5C18.16 20.5 17.5 19.83 17.5 19C17.5 18.17 18.17 17.5 19 17.5Z";
var mdiFileCompare = "M10,18H6V16H10V18M10,14H6V12H10V14M10,1V2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10V23H12V1H10M20,8V20C20,21.11 19.11,22 18,22H14V20H18V11H14V9H18.5L14,4.5V2L20,8M16,14H14V12H16V14M16,18H14V16H16V18Z";
var mdiFileDelimited = "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2M15 16L13 20H10L12 16H9V11H15V16M13 9V3.5L18.5 9H13Z";
var mdiFileDelimitedOutline = "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2M18 20H6V4H13V9H18V20M10 19L12 15H9V10H15V15L13 19H10";
var mdiFileDocument = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z";
var mdiFileDocumentAlert = "M20 17H22V15H20V17M20 7V13H22V7H20M11 9H16.5L11 3.5V9M4 2H12L18 8V20C18 21.11 17.11 22 16 22H4C2.89 22 2 21.1 2 20V4C2 2.89 2.89 2 4 2M13 18V16H4V18H13M16 14V12H4V14H16Z";
var mdiFileDocumentAlertOutline = "M20 17H22V15H20V17M20 7V13H22V7M6 16H11V18H6M6 12H14V14H6M4 2C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H16C17.11 22 18 21.11 18 20V8L12 2M4 4H11V9H16V20H4Z";
var mdiFileDocumentArrowRight = "M23 19L20 16V18H16V20H20V22L23 19M13 19C13 18.7 13 18.3 13.1 18H6V16H13.8C14.3 15.2 14.9 14.5 15.7 14H6V12H18V13.1C18.3 13 18.7 13 19 13S19.7 13 20 13.1V8L14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H13.8C13.3 21.1 13 20.1 13 19M13 3.5L18.5 9H13V3.5Z";
var mdiFileDocumentArrowRightOutline = "M23 19L20 16V18H16V20H20V22L23 19M13.8 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2H14L20 8V13.1C19.7 13 19.3 13 19 13S18.3 13 18 13.1V9H13V4H6V20H13.1C13.2 20.7 13.5 21.4 13.8 22M8 12H16V13.8C15.9 13.9 15.8 13.9 15.7 14H8V12M8 16H13V18H8V16Z";
var mdiFileDocumentCheck = "M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M6 2C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.81C13.28 21.09 13 20.05 13 19C13 18.67 13.03 18.33 13.08 18H6V16H13.81C14.27 15.2 14.91 14.5 15.68 14H6V12H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M13 3.5L18.5 9H13Z";
var mdiFileDocumentCheckOutline = "M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M6 2C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.45 21.38 13.2 20.7 13.08 20H6V4H13V9H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M8 12V14H16V12M8 16V18H13V16Z";
var mdiFileDocumentEdit = "M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10V20.09L12.09,18H6V16H14.09L16.09,14H6V12H18.09L20,10.09V8L14,2H6M13,3.5L18.5,9H13V3.5M20.15,13C20,13 19.86,13.05 19.75,13.16L18.73,14.18L20.82,16.26L21.84,15.25C22.05,15.03 22.05,14.67 21.84,14.46L20.54,13.16C20.43,13.05 20.29,13 20.15,13M18.14,14.77L12,20.92V23H14.08L20.23,16.85L18.14,14.77Z";
var mdiFileDocumentEditOutline = "M8,12H16V14H8V12M10,20H6V4H13V9H18V12.1L20,10.1V8L14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H10V20M8,18H12.1L13,17.1V16H8V18M20.2,13C20.3,13 20.5,13.1 20.6,13.2L21.9,14.5C22.1,14.7 22.1,15.1 21.9,15.3L20.9,16.3L18.8,14.2L19.8,13.2C19.9,13.1 20,13 20.2,13M20.2,16.9L14.1,23H12V20.9L18.1,14.8L20.2,16.9Z";
var mdiFileDocumentMinus = "M15 18H23V20H15M6 2C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.81C13.28 21.09 13 20.05 13 19C13 18.67 13.03 18.33 13.08 18H6V16H13.81C14.27 15.2 14.91 14.5 15.68 14H6V12H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M13 3.5L18.5 9H13Z";
var mdiFileDocumentMinusOutline = "M23 18H15V20H23M6 2C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.45 21.38 13.2 20.7 13.08 20H6V4H13V9H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M8 12V14H16V12M8 16V18H13V16Z";
var mdiFileDocumentMultiple = "M4 4V22H20V24H4C2.9 24 2 23.1 2 22V4H4M15 7H20.5L15 1.5V7M8 0H16L22 6V18C22 19.11 21.11 20 20 20H8C6.89 20 6 19.1 6 18V2C6 .89 6.89 0 8 0M17 16V14H8V16H17M20 12V10H8V12H20Z";
var mdiFileDocumentMultipleOutline = "M16 0H8C6.9 0 6 .9 6 2V18C6 19.1 6.9 20 8 20H20C21.1 20 22 19.1 22 18V6L16 0M20 18H8V2H15V7H20V18M4 4V22H20V24H4C2.9 24 2 23.1 2 22V4H4M10 10V12H18V10H10M10 14V16H15V14H10Z";
var mdiFileDocumentOutline = "M6,2A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6M6,4H13V9H18V20H6V4M8,12V14H16V12H8M8,16V18H13V16H8Z";
var mdiFileDocumentPlus = "M14 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.81C13.28 21.09 13 20.05 13 19C13 18.67 13.03 18.33 13.08 18H6V16H13.81C14.27 15.2 14.91 14.5 15.68 14H6V12H18V13.08C18.33 13.03 18.67 13 19 13S19.67 13.03 20 13.08V8L14 2M13 9V3.5L18.5 9H13M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiFileDocumentPlusOutline = "M23 18H20V15H18V18H15V20H18V23H20V20H23M6 2C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.45 21.38 13.2 20.7 13.08 20H6V4H13V9H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M8 12V14H16V12M8 16V18H13V16Z";
var mdiFileDocumentRefresh = "M6 2H14L20 8V12.17C19.5 12.06 19 12 18.5 12H6V14H13.81C13.26 14.58 12.81 15.25 12.5 16H6V18H12V18.5C12 19.79 12.38 21 13 22H6C4.89 22 4 21.1 4 20V4C4 2.89 4.89 2 6 2M13 9H18.5L13 3.5V9M18 14.5C19.11 14.5 20.11 14.95 20.83 15.67L22 14.5V18.5H18L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5C15.5 19.88 16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5C14 16.29 15.79 14.5 18 14.5Z";
var mdiFileDocumentRefreshOutline = "M6 2C5.47 2 4.96 2.21 4.59 2.59C4.21 2.96 4 3.47 4 4V20C4 20.53 4.21 21.04 4.59 21.41C4.96 21.79 5.47 22 6 22H13C12.63 21.4 12.34 20.72 12.17 20H6V4H13V9H18V12H18.5C19 12 19.5 12.06 20 12.17V8L14 2H6M12 18C12.07 17.3 12.24 16.62 12.5 16H8V18H12M13.81 14C14.43 13.36 15.17 12.85 16 12.5V12H8V14H13.81M18 14.5C19.11 14.5 20.11 14.95 20.83 15.67L22 14.5V18.5H18L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5C15.5 19.88 16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5C14 16.29 15.79 14.5 18 14.5Z";
var mdiFileDocumentRemove = "M21.12 15.46L19 17.59L16.88 15.46L15.46 16.88L17.59 19L15.46 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88M6 2C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.81C13.28 21.09 13 20.05 13 19C13 18.67 13.03 18.33 13.08 18H6V16H13.81C14.27 15.2 14.91 14.5 15.68 14H6V12H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M13 3.5L18.5 9H13Z";
var mdiFileDocumentRemoveOutline = "M22.54 21.12L20.41 19L22.54 16.88L21.12 15.46L19 17.59L16.88 15.46L15.46 16.88L17.59 19L15.46 21.12L16.88 22.54L19 20.41L21.12 22.54M6 2C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.45 21.38 13.2 20.7 13.08 20H6V4H13V9H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M8 12V14H16V12M8 16V18H13V16Z";
var mdiFileDownload = "M14,2H6C4.89,2 4,2.89 4,4V20C4,21.11 4.89,22 6,22H18C19.11,22 20,21.11 20,20V8L14,2M12,19L8,15H10.5V12H13.5V15H16L12,19M13,9V3.5L18.5,9H13Z";
var mdiFileDownloadOutline = "M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M12,19L8,15H10.5V12H13.5V15H16L12,19Z";
var mdiFileEdit = "M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H10V20.1L20 10.1V8L14 2H6M13 3.5L18.5 9H13V3.5M20.1 13C20 13 19.8 13.1 19.7 13.2L18.7 14.2L20.8 16.3L21.8 15.3C22 15.1 22 14.7 21.8 14.5L20.5 13.2C20.4 13.1 20.3 13 20.1 13M18.1 14.8L12 20.9V23H14.1L20.2 16.9L18.1 14.8Z";
var mdiFileEditOutline = "M10 20H6V4H13V9H18V12.1L20 10.1V8L14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H10V20M20.2 13C20.3 13 20.5 13.1 20.6 13.2L21.9 14.5C22.1 14.7 22.1 15.1 21.9 15.3L20.9 16.3L18.8 14.2L19.8 13.2C19.9 13.1 20 13 20.2 13M20.2 16.9L14.1 23H12V20.9L18.1 14.8L20.2 16.9Z";
var mdiFileExcel = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z";
var mdiFileExcelBox = "M16.2,17H14.2L12,13.2L9.8,17H7.8L11,12L7.8,7H9.8L12,10.8L14.2,7H16.2L13,12M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiFileExcelBoxOutline = "M5 3C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3H5M5 5H19V19H5V5M13 12L16.2 17H14.2L12 13.2L9.8 17H7.8L11 12L7.8 7H9.8L12 10.8L14.2 7H16.2L13 12Z";
var mdiFileExcelOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M12.9 14.5L15.8 19H14L12 15.6L10 19H8.2L11.1 14.5L8.2 10H10L12 13.4L14 10H15.8L12.9 14.5Z";
var mdiFileExport = "M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35";
var mdiFileExportOutline = "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2M18 20H6V4H13V9H18V20M16 11V18.1L13.9 16L11.1 18.8L8.3 16L11.1 13.2L8.9 11H16Z";
var mdiFileEye = "M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.14,19.75L8.85,19L9.14,18.26C10.43,15.06 13.5,13 17,13C18.05,13 19.06,13.21 20,13.56V8L14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10.5C9.95,21.34 9.5,20.58 9.14,19.75M13,3.5L18.5,9H13V3.5Z";
var mdiFileEyeOutline = "M17,18C17.56,18 18,18.44 18,19C18,19.56 17.56,20 17,20C16.44,20 16,19.56 16,19C16,18.44 16.44,18 17,18M17,15C14.27,15 11.94,16.66 11,19C11.94,21.34 14.27,23 17,23C19.73,23 22.06,21.34 23,19C22.06,16.66 19.73,15 17,15M17,21.5A2.5,2.5 0 0,1 14.5,19A2.5,2.5 0 0,1 17,16.5A2.5,2.5 0 0,1 19.5,19A2.5,2.5 0 0,1 17,21.5M9.27,20H6V4H13V9H18V13.07C18.7,13.15 19.36,13.32 20,13.56V8L14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H10.5C10,21.41 9.59,20.73 9.27,20Z";
var mdiFileFind = "M9,13A3,3 0 0,0 12,16A3,3 0 0,0 15,13A3,3 0 0,0 12,10A3,3 0 0,0 9,13M20,19.59V8L14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18C18.45,22 18.85,21.85 19.19,21.6L14.76,17.17C13.96,17.69 13,18 12,18A5,5 0 0,1 7,13A5,5 0 0,1 12,8A5,5 0 0,1 17,13C17,14 16.69,14.96 16.17,15.75L20,19.59Z";
var mdiFileFindOutline = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M6,4H13L18,9V17.58L16.16,15.74C17.44,13.8 17.23,11.17 15.5,9.46C14.55,8.5 13.28,8 12,8C10.72,8 9.45,8.5 8.47,9.46C6.5,11.41 6.5,14.57 8.47,16.5C9.44,17.5 10.72,17.97 12,17.97C12.96,17.97 13.92,17.69 14.75,17.14L17.6,20H6V4M14.11,15.1C13.55,15.66 12.8,16 12,16C11.2,16 10.45,15.67 9.89,15.1C9.33,14.54 9,13.79 9,13C9,12.19 9.32,11.44 9.89,10.88C10.45,10.31 11.2,10 12,10C12.8,10 13.55,10.31 14.11,10.88C14.67,11.44 15,12.19 15,13C15,13.79 14.68,14.54 14.11,15.1Z";
var mdiFileGifBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M10 10.5H7.5V13.5H8.5V12H10V13.7C10 14.4 9.5 15 8.7 15H7.3C6.5 15 6 14.3 6 13.7V10.4C6 9.7 6.5 9 7.3 9H8.6C9.5 9 10 9.7 10 10.3V10.5M13 15H11.5V9H13V15M17.5 10.5H16V11.5H17.5V13H16V15H14.5V9H17.5V10.5Z";
var mdiFileHidden = "M13,9H14V11H11V7H13V9M18.5,9L16.38,6.88L17.63,5.63L20,8V10H18V11H15V9H18.5M13,3.5V2H12V4H13V6H11V4H9V2H8V4H6V5H4V4C4,2.89 4.89,2 6,2H14L16.36,4.36L15.11,5.61L13,3.5M20,20A2,2 0 0,1 18,22H16V20H18V19H20V20M18,15H20V18H18V15M12,22V20H15V22H12M8,22V20H11V22H8M6,22C4.89,22 4,21.1 4,20V18H6V20H7V22H6M4,14H6V17H4V14M4,10H6V13H4V10M18,11H20V14H18V11M4,6H6V9H4V6Z";
var mdiFileImage = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M6,20H15L18,20V12L14,16L12,14L6,20M8,9A2,2 0 0,0 6,11A2,2 0 0,0 8,13A2,2 0 0,0 10,11A2,2 0 0,0 8,9Z";
var mdiFileImageMarker = "M6 20L12 14L13.03 15.03C13.28 12.26 15.68 10 18.5 10C19 10 19.5 10.08 20 10.22V8L14 2H6C4.89 2 4 2.89 4 4V20C4 21.1 4.89 22 6 22H15.91C15.5 21.44 15 20.76 14.55 20H6M13 3.5L18.5 9H13V3.5M8 9C9.11 9 10 9.9 10 11S9.11 13 8 13 6 12.11 6 11 6.9 9 8 9M18.5 12C16.6 12 15 13.6 15 15.5C15 18.1 18.5 22 18.5 22S22 18.1 22 15.5C22 13.6 20.4 12 18.5 12M18.5 16.8C17.8 16.8 17.3 16.2 17.3 15.6C17.3 14.9 17.9 14.4 18.5 14.4S19.7 15 19.7 15.6C19.8 16.2 19.2 16.8 18.5 16.8Z";
var mdiFileImageMarkerOutline = "M8.5 12C7.67 12 7 11.33 7 10.5S7.67 9 8.5 9 10 9.67 10 10.5 9.33 12 8.5 12M14 19C13.43 17.86 13 16.64 13 15.5C13 15.34 13 15.18 13.03 15.03L12 14L7 19H14M6 20V4H13V9H18V10.03C18.17 10 18.33 10 18.5 10C19 10 19.5 10.08 20 10.22V8L14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H15.91C15.5 21.44 15 20.76 14.55 20H6M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiFileImageMinus = "M13.09 20H6L12 14L13.88 15.88C14.5 14.9 15.36 14.1 16.4 13.6L18 12V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V8L14 2H6C4.89 2 4 2.89 4 4V20C4 21.1 4.89 22 6 22H13.81C13.46 21.39 13.21 20.72 13.09 20M13 3.5L18.5 9H13V3.5M8 9C9.11 9 10 9.9 10 11S9.11 13 8 13 6 12.11 6 11 6.9 9 8 9M23 18V20H15V18H23Z";
var mdiFileImageMinusOutline = "M7 19L12 14L13.88 15.88C13.33 16.79 13 17.86 13 19H7M10 10.5C10 9.67 9.33 9 8.5 9S7 9.67 7 10.5 7.67 12 8.5 12 10 11.33 10 10.5M13.09 20H6V4H13V9H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V8L14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.46 21.39 13.21 20.72 13.09 20M15 18V20H23V18H15Z";
var mdiFileImageOutline = "M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M17,13V19H7L12,14L14,16M10,10.5A1.5,1.5 0 0,1 8.5,12A1.5,1.5 0 0,1 7,10.5A1.5,1.5 0 0,1 8.5,9A1.5,1.5 0 0,1 10,10.5Z";
var mdiFileImagePlus = "M13.09 20H6L12 14L13.88 15.88C14.5 14.9 15.36 14.1 16.4 13.6L18 12V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V8L14 2H6C4.89 2 4 2.89 4 4V20C4 21.1 4.89 22 6 22H13.81C13.46 21.39 13.21 20.72 13.09 20M13 3.5L18.5 9H13V3.5M8 9C9.11 9 10 9.9 10 11S9.11 13 8 13 6 12.11 6 11 6.9 9 8 9M20 15V18H23V20H20V23H18V20H15V18H18V15H20Z";
var mdiFileImagePlusOutline = "M7 19L12 14L13.88 15.88C13.33 16.79 13 17.86 13 19H7M10 10.5C10 9.67 9.33 9 8.5 9S7 9.67 7 10.5 7.67 12 8.5 12 10 11.33 10 10.5M13.09 20H6V4H13V9H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V8L14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.46 21.39 13.21 20.72 13.09 20M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiFileImageRemove = "M13.09 20H6L12 14L13.88 15.88C14.5 14.9 15.36 14.1 16.4 13.6L18 12V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V8L14 2H6C4.89 2 4 2.89 4 4V20C4 21.1 4.89 22 6 22H13.81C13.46 21.39 13.21 20.72 13.09 20M13 3.5L18.5 9H13V3.5M8 9C9.11 9 10 9.9 10 11S9.11 13 8 13 6 12.11 6 11 6.9 9 8 9M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88Z";
var mdiFileImageRemoveOutline = "M7 19L12 14L13.88 15.88C13.33 16.79 13 17.86 13 19H7M10 10.5C10 9.67 9.33 9 8.5 9S7 9.67 7 10.5 7.67 12 8.5 12 10 11.33 10 10.5M13.09 20H6V4H13V9H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V8L14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.46 21.39 13.21 20.72 13.09 20M21.12 15.46L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46Z";
var mdiFileImport = "M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M10.05,11.22L12.88,14.05L15,11.93V19H7.93L10.05,16.88L7.22,14.05";
var mdiFileImportOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M15 11.93V19H7.93L10.05 16.88L7.22 14.05L10.05 11.22L12.88 14.05L15 11.93Z";
var mdiFileJpgBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9 13.5C9 14.6 8.1 15 7 15S5 14.6 5 13.5V12H6.5V13.5H7.5V9H9V13.5M14 11.5C14 12.3 13.3 13 12.5 13H11.5V15H10V9H12.5C13.3 9 14 9.7 14 10.5V11.5M19 10.5H16.5V13.5H17.5V12H19V13.7C19 14.4 18.5 15 17.7 15H16.4C15.6 15 15.1 14.3 15.1 13.7V10.4C15 9.7 15.5 9 16.3 9H17.6C18.4 9 18.9 9.7 18.9 10.3V10.5M11.5 10.5H12.5V11.5H11.5V10.5Z";
var mdiFileKey = "M11 16C11 16.6 10.6 17 10 17S9 16.6 9 16C9 15.4 9.4 15 10 15S11 15.4 11 16M20 8V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2H14M18 15H12.8C12.2 13.4 10.5 12.6 9 13.2C7.4 13.8 6.6 15.5 7.2 17S9.5 19.4 11 18.8C11.9 18.5 12.5 17.8 12.8 17H14V19H16V17H18M18.5 9L13 3.5V9H18.5Z";
var mdiFileKeyOutline = "M14 2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8L14 2M18 20H6V4H13V9H18M12.83 15A3 3 0 1 0 12.83 17H14V19H16V17H17V15M10 17A1 1 0 1 1 11 16A1 1 0 0 1 10 17Z";
var mdiFileLink = "M14 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M11 20H10C8.39 20 6 18.94 6 16C6 13.07 8.39 12 10 12H11V14H10C9.54 14 8 14.17 8 16C8 17.9 9.67 18 10 18H11V20M15 15V17H9V15H15M14 20H13V18H14C14.46 18 16 17.83 16 16C16 14.1 14.33 14 14 14H13V12H14C15.61 12 18 13.07 18 16C18 18.94 15.61 20 14 20M13 9V3.5L18.5 9H13Z";
var mdiFileLinkOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M11 19H10.75C9.45 19 7 18.22 7 15.25S9.45 11.5 10.75 11.5H11V13H10.75C10.38 13 8.5 13.13 8.5 15.25C8.5 17.44 10.5 17.5 10.75 17.5H11V19M14 16H10V14.5H14V16M13 11.5H13.25C14.55 11.5 17 12.28 17 15.25S14.55 19 13.25 19H13V17.5H13.25C13.62 17.5 15.5 17.37 15.5 15.25C15.5 13.06 13.5 13 13.25 13H13V11.5Z";
var mdiFileLock = "M18 13C16.6 13 15.2 14.1 15.2 15.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17V15.5C20.8 14.1 19.4 13 18 13M18 14.2C18.8 14.2 19.5 14.7 19.5 15.5V17H16.5V15.5C16.5 14.7 17.2 14.2 18 14.2M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H12V18.2C12 17.2 12.4 16.5 13 16C13.1 15.9 13.2 15.9 13.2 15.8V15.5C13.2 12.8 15.6 11 18 11C18.7 11 19.4 11.2 20 11.4V8L14 2H6M13 3.5L18.5 9H13V3.5Z";
var mdiFileLockOpen = "M22 18.3V21.8C22 22.4 21.4 23 20.7 23H15.2C14.6 23 14 22.4 14 21.7V18.2C14 17.6 14.6 17 15.2 17V14.5C15.2 13.1 16.6 12 18 12S20.8 13.1 20.8 14.5V15H19.5V14.5C19.5 13.7 18.8 13.2 18 13.2S16.5 13.7 16.5 14.5V17H20.8C21.4 17 22 17.6 22 18.3M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H12V18.2C12 17.2 12.4 16.5 13 16C13.1 15.9 13.2 15.9 13.2 15.8V14.5C13.2 11.8 15.6 10 18 10C18.7 10 19.4 10.2 20 10.4V8L14 2H6M13 3.5L18.5 9H13V3.5Z";
var mdiFileLockOpenOutline = "M22 18.3V21.8C22 22.4 21.4 23 20.7 23H15.2C14.6 23 14 22.4 14 21.7V18.2C14 17.6 14.6 17 15.2 17V14.5C15.2 13.1 16.6 12 18 12S20.8 13.1 20.8 14.5V15H19.5V14.5C19.5 13.7 18.8 13.2 18 13.2S16.5 13.7 16.5 14.5V17H20.8C21.4 17 22 17.6 22 18.3M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H12V20H6V4H13V9H18V10C18.7 10 19.4 10.2 20 10.4V8L14 2H6Z";
var mdiFileLockOutline = "M18 13C16.6 13 15.2 14.1 15.2 15.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17V15.5C20.8 14.1 19.4 13 18 13M18 14.2C18.8 14.2 19.5 14.7 19.5 15.5V17H16.5V15.5C16.5 14.7 17.2 14.2 18 14.2M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H12V20H6V4H13V9H18V11C18.7 11 19.4 11.2 20 11.4V8L14 2H6Z";
var mdiFileMarker = "M18.5 10C19 10 19.5 10.08 20 10.22V8L14 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H15.91C14.7 20.41 13 17.78 13 15.5C13 12.5 15.5 10 18.5 10M13 3.5L18.5 9H13V3.5M18.5 12C16.6 12 15 13.6 15 15.5C15 18.1 18.5 22 18.5 22S22 18.1 22 15.5C22 13.6 20.4 12 18.5 12M18.5 16.8C17.8 16.8 17.3 16.2 17.3 15.6C17.3 14.9 17.9 14.4 18.5 14.4S19.7 15 19.7 15.6C19.8 16.2 19.2 16.8 18.5 16.8Z";
var mdiFileMarkerOutline = "M14.55 20C15 20.76 15.5 21.44 15.91 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H14L20 8V10.22C19.5 10.08 19 10 18.5 10C18.33 10 18.17 10 18 10.03V9H13V4H6V20H14.55M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiFileMinus = "M14 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.81C13.28 21.09 13 20.05 13 19C13 15.69 15.69 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M13 9V3.5L18.5 9H13M23 20H15V18H23V20Z";
var mdiFileMinusOutline = "M13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H14L20 8V13.09C19.67 13.04 19.34 13 19 13S18.33 13.04 18 13.09V9H13V4H6V20H13.09C13.21 20.72 13.46 21.39 13.81 22M23 18H15V20H23V18Z";
var mdiFileMove = "M14,17H18V14L23,18.5L18,23V20H14V17M13,9H18.5L13,3.5V9M6,2H14L20,8V12.34C19.37,12.12 18.7,12 18,12A6,6 0 0,0 12,18C12,19.54 12.58,20.94 13.53,22H6C4.89,22 4,21.1 4,20V4A2,2 0 0,1 6,2Z";
var mdiFileMoveOutline = "M14 2H6C4.9 2 4 2.9 4 4V20C4 20.41 4.12 20.8 4.34 21.12C4.41 21.23 4.5 21.33 4.59 21.41C4.95 21.78 5.45 22 6 22H13.53C13 21.42 12.61 20.75 12.35 20H6V4H13V9H18V12C18.7 12 19.37 12.12 20 12.34V8L14 2M18 23L23 18.5L20 15.8L18 14V17H14V20H18V23Z";
var mdiFileMultiple = "M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z";
var mdiFileMultipleOutline = "M16 0H8C6.9 0 6 .9 6 2V18C6 19.1 6.9 20 8 20H20C21.1 20 22 19.1 22 18V6L16 0M20 18H8V2H15V7H20V18M4 4V22H20V24H4C2.9 24 2 23.1 2 22V4H4Z";
var mdiFileMusic = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,13H11V18A2,2 0 0,1 9,20A2,2 0 0,1 7,18A2,2 0 0,1 9,16C9.4,16 9.7,16.1 10,16.3V11H13V13M13,9V3.5L18.5,9H13Z";
var mdiFileMusicOutline = "M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M13,10V12H11V17A2,2 0 0,1 9,19A2,2 0 0,1 7,17A2,2 0 0,1 9,15C9.4,15 9.7,15.1 10,15.3V10H13Z";
var mdiFileOutline = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z";
var mdiFilePdfBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.5 11.5C9.5 12.3 8.8 13 8 13H7V15H5.5V9H8C8.8 9 9.5 9.7 9.5 10.5V11.5M14.5 13.5C14.5 14.3 13.8 15 13 15H10.5V9H13C13.8 9 14.5 9.7 14.5 10.5V13.5M18.5 10.5H17V11.5H18.5V13H17V15H15.5V9H18.5V10.5M12 10.5H13V13.5H12V10.5M7 10.5H8V11.5H7V10.5Z";
var mdiFilePercent = "M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M7.37,20L15,12.35L13.65,11L6,18.65L7.37,20M13,9H18.5L13,3.5V9M7.5,11A1.5,1.5 0 0,0 6,12.5A1.5,1.5 0 0,0 7.5,14A1.5,1.5 0 0,0 9,12.5A1.5,1.5 0 0,0 7.5,11M13.5,17A1.5,1.5 0 0,0 12,18.5A1.5,1.5 0 0,0 13.5,20A1.5,1.5 0 0,0 15,18.5A1.5,1.5 0 0,0 13.5,17Z";
var mdiFilePercentOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M10 11.5C10 12.33 9.33 13 8.5 13S7 12.33 7 11.5 7.67 10 8.5 10 10 10.67 10 11.5M16 17.5C16 18.33 15.33 19 14.5 19S13 18.33 13 17.5 13.67 16 14.5 16 16 16.67 16 17.5M16 11.35L8.37 19L7 17.65L14.65 10L16 11.35Z";
var mdiFilePhone = "M14 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M17 19.44C17 19.75 16.75 20 16.44 20C11.23 20 7 15.77 7 10.56C7 10.25 7.25 10 7.56 10H9.5C9.81 10 10.06 10.25 10.06 10.56C10.06 11.25 10.17 11.92 10.37 12.54C10.43 12.73 10.39 12.95 10.23 13.11L9 14.33C9.81 15.9 11.1 17.19 12.67 18L13.9 16.77C14.05 16.61 14.27 16.57 14.46 16.63C15.08 16.83 15.75 16.95 16.45 16.95C16.75 16.95 17 17.19 17 17.5V19.44M13 9V3.5L18.5 9H13Z";
var mdiFilePhoneOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M9 13.33C9.81 14.9 11.1 16.19 12.67 17L13.89 15.77C14.05 15.61 14.27 15.57 14.46 15.63C15.08 15.83 15.75 15.95 16.44 15.95C16.75 15.95 17 16.19 17 16.5V18.45C17 18.75 16.75 19 16.44 19C11.23 19 7 14.77 7 9.56C7 9.25 7.25 9 7.56 9H9.5C9.81 9 10.06 9.25 10.06 9.56C10.06 10.25 10.17 10.92 10.37 11.54C10.43 11.73 10.39 11.95 10.23 12.11L9 13.33Z";
var mdiFilePlus = "M14 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.81C13.28 21.09 13 20.05 13 19C13 15.69 15.69 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M13 9V3.5L18.5 9H13M23 20H20V23H18V20H15V18H18V15H20V18H23V20Z";
var mdiFilePlusOutline = "M13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H14L20 8V13.09C19.67 13.04 19.34 13 19 13S18.33 13.04 18 13.09V9H13V4H6V20H13.09C13.21 20.72 13.46 21.39 13.81 22M23 18H20V15H18V18H15V20H18V23H20V20H23V18Z";
var mdiFilePngBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9 11.5C9 12.3 8.3 13 7.5 13H6.5V15H5V9H7.5C8.3 9 9 9.7 9 10.5V11.5M14 15H12.5L11.5 12.5V15H10V9H11.5L12.5 11.5V9H14V15M19 10.5H16.5V13.5H17.5V12H19V13.7C19 14.4 18.5 15 17.7 15H16.4C15.6 15 15.1 14.3 15.1 13.7V10.4C15 9.7 15.5 9 16.3 9H17.6C18.4 9 18.9 9.7 18.9 10.3V10.5H19M6.5 10.5H7.5V11.5H6.5V10.5Z";
var mdiFilePowerpoint = "M12.6,12.3H10.6V15.5H12.7C13.3,15.5 13.6,15.3 13.9,15C14.2,14.7 14.3,14.4 14.3,13.9C14.3,13.4 14.2,13.1 13.9,12.8C13.6,12.5 13.2,12.3 12.6,12.3M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.2,16C14.6,16.5 14.1,16.7 12.8,16.7H10.6V20H9V11H12.8C14.1,11 14.7,11.3 15.2,11.8C15.8,12.4 16,13 16,13.9C16,14.8 15.8,15.5 15.2,16M13,9V3.5L18.5,9H13Z";
var mdiFilePowerpointBox = "M9.8,13.4H12.3C13.8,13.4 14.46,13.12 15.1,12.58C15.74,12.03 16,11.25 16,10.23C16,9.26 15.75,8.5 15.1,7.88C14.45,7.29 13.83,7 12.3,7H8V17H9.8V13.4M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5C3,3.89 3.9,3 5,3H19M9.8,12V8.4H12.1C12.76,8.4 13.27,8.65 13.6,9C13.93,9.35 14.1,9.72 14.1,10.24C14.1,10.8 13.92,11.19 13.6,11.5C13.28,11.81 12.9,12 12.22,12H9.8Z";
var mdiFilePowerpointBoxOutline = "M5 3C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3H5M5 5H19V19H5V5M15.1 7.88C14.45 7.29 13.83 7 12.3 7H8V17H9.8V13.4H12.3C13.8 13.4 14.46 13.12 15.1 12.58C15.74 12.03 16 11.25 16 10.23C16 9.26 15.75 8.5 15.1 7.88M13.6 11.5C13.28 11.81 12.9 12 12.22 12H9.8V8.4H12.1C12.76 8.4 13.27 8.65 13.6 9C13.93 9.35 14.1 9.72 14.1 10.24C14.1 10.8 13.92 11.19 13.6 11.5Z";
var mdiFilePowerpointOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M15.2 10.8C14.7 10.3 14.1 10 12.8 10H9V19H10.6V15.7H12.8C14.1 15.7 14.6 15.5 15.2 15C15.8 14.5 16 13.8 16 12.9C16 12 15.8 11.4 15.2 10.8M13.9 14C13.6 14.3 13.3 14.5 12.7 14.5H10.6V11.3H12.6C13.2 11.3 13.6 11.5 13.9 11.8C14.2 12.1 14.3 12.4 14.3 12.9S14.2 13.7 13.9 14Z";
var mdiFilePresentationBox = "M19,16H5V8H19M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiFileQuestion = "M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6M13,3.5L18.5,9H13V3.5M12,11A3,3 0 0,1 15,14C15,15.88 12.75,16.06 12.75,17.75H11.25C11.25,15.31 13.5,15.5 13.5,14A1.5,1.5 0 0,0 12,12.5A1.5,1.5 0 0,0 10.5,14H9A3,3 0 0,1 12,11M11.25,18.5H12.75V20H11.25V18.5Z";
var mdiFileQuestionOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M15 13C15 14.89 12.75 15.07 12.75 16.76H11.25C11.25 14.32 13.5 14.5 13.5 13C13.5 12.18 12.83 11.5 12 11.5S10.5 12.18 10.5 13H9C9 11.35 10.34 10 12 10S15 11.35 15 13M12.75 17.5V19H11.25V17.5H12.75Z";
var mdiFileRefresh = "M18 14.5C19.11 14.5 20.11 14.95 20.83 15.67L22 14.5V18.5H18L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5C15.5 19.88 16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5C14 16.29 15.79 14.5 18 14.5M13 9H18.5L13 3.5V9M6 2H14L20 8V12.17C19.5 12.06 19 12 18.5 12C14.91 12 12 14.91 12 18.5C12 19.79 12.37 21 13 22H6C4.88 22 4 21.1 4 20L4 4C4 2.89 4.89 2 6 2Z";
var mdiFileRefreshOutline = "M18 14.5C19.11 14.5 20.11 14.95 20.83 15.67L22 14.5V18.5H18L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5C15.5 19.88 16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5C14 16.29 15.79 14.5 18 14.5M14 2L20 8V12.17C19.5 12.06 19 12 18.5 12L18 12V9H13V4H6V20H12.17C12.34 20.72 12.63 21.39 13 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2H14Z";
var mdiFileRemove = "M21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19L22.54 21.12L21.12 22.54M14 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.81C13.28 21.09 13 20.05 13 19C13 15.69 15.69 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M13 9V3.5L18.5 9H13Z";
var mdiFileRemoveOutline = "M13.81 22H6C4.89 22 4 21.11 4 20V4C4 2.9 4.89 2 6 2H14L20 8V13.09C19.67 13.04 19.34 13 19 13S18.33 13.04 18 13.09V9H13V4H6V20H13.09C13.21 20.72 13.46 21.39 13.81 22M22.54 21.12L20.41 19L22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12Z";
var mdiFileReplace = "M14,12H19.5L14,6.5V12M8,5H15L21,11V21A2,2 0 0,1 19,23H8C6.89,23 6,22.1 6,21V18H11V20L15,17L11,14V16H6V7A2,2 0 0,1 8,5M13.5,3H4V16H6V18H4A2,2 0 0,1 2,16V3A2,2 0 0,1 4,1H11.5L13.5,3Z";
var mdiFileReplaceOutline = "M14,3L12,1H4A2,2 0 0,0 2,3V15A2,2 0 0,0 4,17H11V19L15,16L11,13V15H4V3H14M21,10V21A2,2 0 0,1 19,23H8A2,2 0 0,1 6,21V19H8V21H19V12H14V7H8V13H6V7A2,2 0 0,1 8,5H16L21,10Z";
var mdiFileRestore = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M12,18C9.95,18 8.19,16.76 7.42,15H9.13C9.76,15.9 10.81,16.5 12,16.5A3.5,3.5 0 0,0 15.5,13A3.5,3.5 0 0,0 12,9.5C10.65,9.5 9.5,10.28 8.9,11.4L10.5,13H6.5V9L7.8,10.3C8.69,8.92 10.23,8 12,8A5,5 0 0,1 17,13A5,5 0 0,1 12,18Z";
var mdiFileRestoreOutline = "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2M18 20H6V4H13L18 9V20M17 13.24C17 15.86 14.87 18 12.24 18C10.29 18 8.61 16.82 7.88 15.14H9.5C10.11 16 11.11 16.57 12.24 16.57C14.08 16.57 15.57 15.07 15.57 13.24S14.08 9.9 12.24 9.9C10.95 9.9 9.86 10.65 9.29 11.71L10.81 13.24H7V9.43L8.24 10.67C9.09 9.35 10.55 8.5 12.24 8.5C14.87 8.47 17 10.61 17 13.24Z";
var mdiFileRotateLeft = "M17 7H13C11.9 7 11 7.9 11 9V18C11 19.11 11.9 20 13 20H19C20.11 20 21 19.11 21 18V11L17 7M19 12H16V9H16.17L19 11.83V12M4 11C4 6.58 7.58 3 12 3L13 3.06V5.08L12 5C8.69 5 6 7.69 6 11H9L5 15L1 11H4";
var mdiFileRotateLeftOutline = "M4 11C4 6.58 7.58 3 12 3L13 3.06V5.08L12 5C8.69 5 6 7.69 6 11H9L5 15L1 11H4M17 7H13C11.9 7 11 7.9 11 9V18C11 19.11 11.9 20 13 20H19C20.11 20 21 19.11 21 18V11L17 7M19 18H13V9H16V12H19V18Z";
var mdiFileRotateRight = "M5 20C3.9 20 3 19.11 3 18V9C3 7.9 3.9 7 5 7H9L13 11V18C13 19.11 12.11 20 11 20H5M11 11.83L8.17 9H8V12H11V11.83M20 11H23L19 15L15 11H18C18 7.69 15.31 5 12 5L11 5.08V3.06L12 3C16.42 3 20 6.58 20 11";
var mdiFileRotateRightOutline = "M20 11H23L19 15L15 11H18C18 7.69 15.31 5 12 5L11 5.08V3.06L12 3C16.42 3 20 6.58 20 11M9 7H5C3.9 7 3 7.9 3 9V18C3 19.11 3.9 20 5 20H11C12.11 20 13 19.11 13 18V11L9 7M11 18H5V9H8V12H11V18Z";
var mdiFileSearch = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H13C12.59,21.75 12.2,21.44 11.86,21.1C9.22,18.67 9.05,14.56 11.5,11.92C13.69,9.5 17.33,9.13 20,11V8L14,2M13,9V3.5L18.5,9H13M20.31,18.9C21.64,16.79 21,14 18.91,12.68C16.8,11.35 14,12 12.69,14.08C11.35,16.19 12,18.97 14.09,20.3C15.55,21.23 17.41,21.23 18.88,20.32L22,23.39L23.39,22L20.31,18.9M16.5,19A2.5,2.5 0 0,1 14,16.5A2.5,2.5 0 0,1 16.5,14A2.5,2.5 0 0,1 19,16.5A2.5,2.5 0 0,1 16.5,19Z";
var mdiFileSearchOutline = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H13C12.59,21.75 12.2,21.44 11.86,21.1C11.53,20.77 11.25,20.4 11,20H6V4H13V9H18V10.18C18.71,10.34 19.39,10.61 20,11V8L14,2M20.31,18.9C21.64,16.79 21,14 18.91,12.68C16.8,11.35 14,12 12.69,14.08C11.35,16.19 12,18.97 14.09,20.3C15.55,21.23 17.41,21.23 18.88,20.32L22,23.39L23.39,22L20.31,18.9M16.5,19A2.5,2.5 0 0,1 14,16.5A2.5,2.5 0 0,1 16.5,14A2.5,2.5 0 0,1 19,16.5A2.5,2.5 0 0,1 16.5,19Z";
var mdiFileSend = "M14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M12.54,19.37V17.37H8.54V15.38H12.54V13.38L15.54,16.38L12.54,19.37M13,9V3.5L18.5,9H13Z";
var mdiFileSendOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M12.54 18.5V16.5H8.54V14.5H12.54V12.5L15.54 15.5L12.54 18.5Z";
var mdiFileSettings = "M6 0C4.89 0 4 .89 4 2V18A2 2 0 0 0 6 20H18A2 2 0 0 0 20 18V6L14 0H6M13 1.5L18.5 7H13V1.5M7 22V24H9V22H7M11 22V24H13V22H11M15 22V24H17V22H15Z";
var mdiFileSettingsOutline = "M6 0A2 2 0 0 0 4 2V18A2 2 0 0 0 6 20H18A2 2 0 0 0 20 18V6L14 0H6M6 2H13V7H18V18H6V2M7 22V24H9V22H7M11 22V24H13V22H11M15 22V24H17V22H15Z";
var mdiFileSign = "M19.7 12.9L14 18.6H11.7V16.3L17.4 10.6L19.7 12.9M23.1 12.1C23.1 12.4 22.8 12.7 22.5 13L20 15.5L19.1 14.6L21.7 12L21.1 11.4L20.4 12.1L18.1 9.8L20.3 7.7C20.5 7.5 20.9 7.5 21.2 7.7L22.6 9.1C22.8 9.3 22.8 9.7 22.6 10C22.4 10.2 22.2 10.4 22.2 10.6C22.2 10.8 22.4 11 22.6 11.2C22.9 11.5 23.2 11.8 23.1 12.1M3 20V4H10V9H15V10.5L17 8.5V8L11 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H15C16.1 22 17 21.1 17 20H3M11 17.1C10.8 17.1 10.6 17.2 10.5 17.2L10 15H8.5L6.4 16.7L7 14H5.5L4.5 19H6L8.9 16.4L9.5 18.7H10.5L11 18.6V17.1Z";
var mdiFileStar = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2M14.5 18.9L12 17.5L9.5 19L10.2 16.2L8 14.3L10.9 14.1L12 11.4L13.1 14L16 14.2L13.8 16.1L14.5 18.9M13 9V3.5L18.5 9H13Z";
var mdiFileStarFourPoints = "M4 4C4 2.89 4.89 2 6 2H14L20 8V20C20 20.53 19.79 21.04 19.41 21.41C19.04 21.79 18.53 22 18 22H6C5.47 22 4.96 21.79 4.59 21.41C4.21 21.04 4 20.53 4 20V4M13 3.5V9H18.5L13 3.5M12 11L10.74 13.75L8 15L10.74 16.26L12 19L13.25 16.26L16 15L13.25 13.75L12 11Z";
var mdiFileStarFourPointsOutline = "M12 11L10.74 13.75L8 15L10.74 16.26L12 19L13.25 16.26L16 15L13.25 13.75L12 11M6 2H14L20 8V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2M6 4V20H18V9H13V4H6Z";
var mdiFileStarOutline = "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2M18 20H6V4H13V9H18V20M9.5 18L10.2 15.2L8 13.3L10.9 13.1L12 10.4L13.1 13L16 13.2L13.8 15.1L14.5 17.9L12 16.5L9.5 18Z";
var mdiFileSwap = "M14 2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8M14 18V16H10V18L7 15L10 12V14H14V12L17 15M13 9V3.5L18.5 9Z";
var mdiFileSwapOutline = "M17 15L14 12V14H10V12L7 15L10 18V16H14V18M14 2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8L14 2M18 20H6V4H13V9H18Z";
var mdiFileSync = "M11 17.5C11 13.9 13.9 11 17.5 11C18.4 11 19.2 11.2 20 11.5V8L14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H12.8C11.7 20.8 11 19.2 11 17.5M13 3.5L18.5 9H13V3.5M17 12V13.5C19.2 13.5 21 15.3 21 17.5C21 18.3 20.8 19.1 20.3 19.7L19.2 18.6C19.4 18.3 19.5 17.9 19.5 17.5C19.5 16.1 18.4 15 17 15V16.5L14.8 14.3L17 12M17 23V21.5C14.8 21.5 13 19.7 13 17.5C13 16.7 13.2 15.9 13.7 15.3L14.8 16.4C14.6 16.7 14.5 17.1 14.5 17.5C14.5 18.9 15.6 20 17 20V18.5L19.2 20.7L17 23Z";
var mdiFileSyncOutline = "M12.8 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2H14L20 8V11.5C19.4 11.2 18.7 11.1 18 11V9H13V4H6V20H11.5C11.8 20.7 12.3 21.4 12.8 22M17 12L14.8 14.2L17 16.4V15C18.4 15 19.5 16.1 19.5 17.5C19.5 17.9 19.4 18.3 19.2 18.6L20.3 19.7C20.7 19.1 21 18.3 21 17.5C21 15.3 19.2 13.5 17 13.5V12M19.2 20.8L17 18.5V20C15.6 20 14.5 18.9 14.5 17.5C14.5 17.1 14.6 16.7 14.8 16.4L13.7 15.3C13.3 15.9 13 16.7 13 17.5C13 19.7 14.8 21.5 17 21.5V23L19.2 20.8Z";
var mdiFileTable = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M10,19H7V17H10V19M10,16H7V14H10V16M10,13H7V11H10V13M14,19H11V17H14V19M14,16H11V14H14V16M14,13H11V11H14V13M13,9V3.5L18.5,9H13Z";
var mdiFileTableBox = "M19 3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.89 20.1 3 19 3M9 18H6V16H9V18M9 15H6V13H9V15M9 12H6V10H9V12M13 18H10V16H13V18M13 15H10V13H13V15M13 12H10V10H13V12Z";
var mdiFileTableBoxMultiple = "M3 5V21H19V23H3C1.9 23 1 22.1 1 21V5H3M21 1H7C5.89 1 5 1.89 5 3V17C5 18.11 5.9 19 7 19H21C22.11 19 23 18.11 23 17V3C23 1.89 22.1 1 21 1M11 16H8V14H11V16M11 13H8V11H11V13M11 10H8V8H11V10M15 16H12V14H15V16M15 13H12V11H15V13M15 10H12V8H15V10Z";
var mdiFileTableBoxMultipleOutline = "M3 5V21H19V23H3C1.9 23 1 22.1 1 21V5H3M21 1H7C5.89 1 5 1.89 5 3V17C5 18.1 5.9 19 7 19H21C22.11 19 23 18.11 23 17V3C23 1.9 22.1 1 21 1M21 17H7V3H21V17M11 14H8V16H11V14M15 14H12V16H15V14M11 11H8V13H11V11M15 11H12V13H15V11M11 8H8V10H11V8M15 8H12V10H15V8Z";
var mdiFileTableBoxOutline = "M19 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3M19 19H5V5H19V19M9 18H6V16H9V18M13 18H10V16H13V18M9 15H6V13H9V15M13 15H10V13H13V15M9 12H6V10H9V12M13 12H10V10H13V12Z";
var mdiFileTableOutline = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20M10,13H7V11H10V13M14,13H11V11H14V13M10,16H7V14H10V16M14,16H11V14H14V16M10,19H7V17H10V19M14,19H11V17H14V19Z";
var mdiFileTree = "M3,3H9V7H3V3M15,10H21V14H15V10M15,17H21V21H15V17M13,13H7V18H13V20H7L5,20V9H7V11H13V13Z";
var mdiFileTreeOutline = "M12 13H7V18H12V20H5V10H7V11H12V13M8 4V6H4V4H8M10 2H2V8H10V2M20 11V13H16V11H20M22 9H14V15H22V9M20 18V20H16V18H20M22 16H14V22H22V16Z";
var mdiFileUndo = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M12.16,14.31C10.6,14.31 9.19,14.89 8.11,15.83L6,13.72V19H11.28L9.15,16.88C9.97,16.2 11,15.78 12.16,15.78C14.23,15.78 16,17.13 16.61,19L18,18.54C17.19,16.09 14.88,14.31 12.16,14.31Z";
var mdiFileUndoOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M17 17.61L15.84 18C15.33 16.44 13.86 15.31 12.13 15.31C11.17 15.31 10.31 15.66 9.63 16.23L11.4 18H7V13.6L8.76 15.36C9.66 14.57 10.83 14.09 12.13 14.09C14.4 14.09 16.33 15.57 17 17.61Z";
var mdiFileUpload = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13.5,16V19H10.5V16H8L12,12L16,16H13.5M13,9V3.5L18.5,9H13Z";
var mdiFileUploadOutline = "M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M12,12L16,16H13.5V19H10.5V16H8L12,12Z";
var mdiFileVideo = "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M17,19V13L14,15.2V13H7V19H14V16.8L17,19Z";
var mdiFileVideoOutline = "M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M16,18L13.5,16.3V18H8V13H13.5V14.7L16,13V18Z";
var mdiFileWord = "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.2,20H13.8L12,13.2L10.2,20H8.8L6.6,11H8.1L9.5,17.8L11.3,11H12.6L14.4,17.8L15.8,11H17.3L15.2,20M13,9V3.5L18.5,9H13Z";
var mdiFileWordBox = "M15.5,17H14L12,9.5L10,17H8.5L6.1,7H7.8L9.34,14.5L11.3,7H12.7L14.67,14.5L16.2,7H17.9M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiFileWordBoxOutline = "M5 3C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3H5M5 5H19V19H5V5M17.9 7L15.5 17H14L12 9.5L10 17H8.5L6.1 7H7.8L9.34 14.5L11.3 7H12.7L14.67 14.5L16.2 7H17.9Z";
var mdiFileWordOutline = "M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M17.35 10L15.25 19H13.85L12.05 12.21L10.25 19H8.85L6.65 10H8.15L9.55 16.81L11.35 10H12.65L14.45 16.81L15.85 10H17.35Z";
var mdiFileXmlBox = "M19 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3M8 15H6.5L6 13L5.5 15H4L4.75 12L4 9H5.5L6 11L6.5 9H8L7.25 12L8 15M15.5 15H14V10.5H13V14H11.5V10.5H10.5V15H9V11C9 9.9 9.9 9 11 9H13.5C14.61 9 15.5 9.9 15.5 11V15M20 15H17V9H18.5V13.5H20V15Z";
var mdiFilm = "M3.5,3H5V1.8C5,1.36 5.36,1 5.8,1H10.2C10.64,1 11,1.36 11,1.8V3H12.5A1.5,1.5 0 0,1 14,4.5V5H22V20H14V20.5A1.5,1.5 0 0,1 12.5,22H3.5A1.5,1.5 0 0,1 2,20.5V4.5A1.5,1.5 0 0,1 3.5,3M18,7V9H20V7H18M14,7V9H16V7H14M10,7V9H12V7H10M14,16V18H16V16H14M18,16V18H20V16H18M10,16V18H12V16H10Z";
var mdiFilmstrip = "M18,9H16V7H18M18,13H16V11H18M18,17H16V15H18M8,9H6V7H8M8,13H6V11H8M8,17H6V15H8M18,3V5H16V3H8V5H6V3H4V21H6V19H8V21H16V19H18V21H20V3H18Z";
var mdiFilmstripBox = "M19 3C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19M7 18V16H5V18H7M7 13V11H5V13H7M7 8V6H5V8H7M19 18V16H17V18H19M19 13V11H17V13H19M19 8V6H17V8H19Z";
var mdiFilmstripBoxMultiple = "M4,6H2V20A2,2 0 0,0 4,22H18V20H4V6M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M10,15H8V13H10V15M10,11H8V9H10V11M10,7H8V5H10V7M20,15H18V13H20V15M20,11H18V9H20V11M20,7H18V5H20V7Z";
var mdiFilmstripOff = "M1,4.27L2.28,3L21,21.72L19.73,23L16,19.27V21H8V19H6V21H4V7.27L1,4.27M18,9V7H16V9H18M18,13V11H16V13H18M18,15H16.82L6.82,5H8V3H16V5H18V3H20V18.18L18,16.18V15M8,13V11.27L7.73,11H6V13H8M8,17V15H6V17H8M6,3V4.18L4.82,3H6Z";
var mdiFilter = "M14,12V19.88C14.04,20.18 13.94,20.5 13.71,20.71C13.32,21.1 12.69,21.1 12.3,20.71L10.29,18.7C10.06,18.47 9.96,18.16 10,17.87V12H9.97L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L14.03,12H14Z";
var mdiFilterCheck = "M12 12V19.88C12.04 20.18 11.94 20.5 11.71 20.71C11.32 21.1 10.69 21.1 10.3 20.71L8.29 18.7C8.06 18.47 7.96 18.16 8 17.87V12H7.97L2.21 4.62C1.87 4.19 1.95 3.56 2.38 3.22C2.57 3.08 2.78 3 3 3H17C17.22 3 17.43 3.08 17.62 3.22C18.05 3.56 18.13 4.19 17.79 4.62L12.03 12H12M17.75 21L15 18L16.16 16.84L17.75 18.43L21.34 14.84L22.5 16.25L17.75 21";
var mdiFilterCheckOutline = "M13 19.88C13.04 20.18 12.94 20.5 12.72 20.71C12.32 21.1 11.69 21.1 11.3 20.71L7.29 16.7C7.06 16.47 6.96 16.16 7 15.87V10.75L2.21 4.62C1.87 4.19 1.95 3.56 2.38 3.22C2.57 3.08 2.78 3 3 3H17C17.22 3 17.43 3.08 17.62 3.22C18.05 3.56 18.13 4.19 17.79 4.62L13 10.75V19.88M5.04 5L9 10.07V15.58L11 17.58V10.05L14.96 5H5.04M17.75 21L15 18L16.16 16.84L17.75 18.43L21.34 14.84L22.5 16.25L17.75 21";
var mdiFilterCog = "M22.77 19.32L21.7 18.5C21.72 18.33 21.74 18.17 21.74 18S21.73 17.67 21.7 17.5L22.76 16.68C22.85 16.6 22.88 16.47 22.82 16.36L21.82 14.63C21.76 14.5 21.63 14.5 21.5 14.5L20.27 15C20 14.82 19.73 14.65 19.42 14.53L19.23 13.21C19.22 13.09 19.11 13 19 13H17C16.87 13 16.76 13.09 16.74 13.21L16.55 14.53C16.25 14.66 15.96 14.82 15.7 15L14.46 14.5C14.35 14.5 14.22 14.5 14.15 14.63L13.15 16.36C13.09 16.47 13.11 16.6 13.21 16.68L14.27 17.5C14.25 17.67 14.24 17.83 14.24 18S14.25 18.33 14.27 18.5L13.21 19.32C13.12 19.4 13.09 19.53 13.15 19.64L14.15 21.37C14.21 21.5 14.34 21.5 14.46 21.5L15.7 21C15.96 21.18 16.24 21.35 16.55 21.47L16.74 22.79C16.76 22.91 16.86 23 17 23H19C19.11 23 19.22 22.91 19.24 22.79L19.43 21.47C19.73 21.34 20 21.18 20.27 21L21.5 21.5C21.63 21.5 21.76 21.5 21.83 21.37L22.83 19.64C22.89 19.53 22.86 19.4 22.77 19.32M18 19.5C17.16 19.5 16.5 18.83 16.5 18S17.17 16.5 18 16.5 19.5 17.17 19.5 18 18.83 19.5 18 19.5M3 3C2.78 3 2.57 3.08 2.38 3.22C1.95 3.56 1.87 4.19 2.21 4.62L7.97 12H8V17.87C7.96 18.16 8.06 18.47 8.29 18.7L10.3 20.71C10.65 21.06 11.19 21.08 11.58 20.8C11.2 19.91 11 18.96 11 18C11 16.73 11.35 15.5 12 14.4V12H12.03L17.79 4.62C18.13 4.19 18.05 3.56 17.62 3.22C17.43 3.08 17.22 3 17 3H3Z";
var mdiFilterCogOutline = "M22.77 19.32L21.7 18.5C21.72 18.33 21.74 18.17 21.74 18S21.73 17.67 21.7 17.5L22.76 16.68C22.85 16.6 22.88 16.47 22.82 16.36L21.82 14.63C21.76 14.5 21.63 14.5 21.5 14.5L20.27 15C20 14.82 19.73 14.65 19.42 14.53L19.23 13.21C19.22 13.09 19.11 13 19 13H17C16.87 13 16.76 13.09 16.74 13.21L16.55 14.53C16.25 14.66 15.96 14.82 15.7 15L14.46 14.5C14.35 14.5 14.22 14.5 14.15 14.63L13.15 16.36C13.09 16.47 13.11 16.6 13.21 16.68L14.27 17.5C14.25 17.67 14.24 17.83 14.24 18S14.25 18.33 14.27 18.5L13.21 19.32C13.12 19.4 13.09 19.53 13.15 19.64L14.15 21.37C14.21 21.5 14.34 21.5 14.46 21.5L15.7 21C15.96 21.18 16.24 21.35 16.55 21.47L16.74 22.79C16.76 22.91 16.86 23 17 23H19C19.11 23 19.22 22.91 19.24 22.79L19.43 21.47C19.73 21.34 20 21.18 20.27 21L21.5 21.5C21.63 21.5 21.76 21.5 21.83 21.37L22.83 19.64C22.89 19.53 22.86 19.4 22.77 19.32M18 19.5C17.16 19.5 16.5 18.83 16.5 18S17.17 16.5 18 16.5 19.5 17.17 19.5 18 18.83 19.5 18 19.5M17.62 3.22C17.43 3.08 17.22 3 17 3H3C2.78 3 2.57 3.08 2.38 3.22C1.95 3.56 1.87 4.19 2.21 4.62L7 10.75V15.87C6.96 16.16 7.06 16.47 7.29 16.7L11.3 20.71C11.4 20.81 11.5 20.88 11.65 20.93C11.22 20 11 19 11 18C11 16.17 11.72 14.41 13 13.1V10.75L17.79 4.62C18.13 4.19 18.05 3.56 17.62 3.22M11 10.05V17.58L9 15.58V10.06L5.04 5H14.96L11 10.05Z";
var mdiFilterMenu = "M11 11L16.76 3.62A1 1 0 0 0 16.59 2.22A1 1 0 0 0 16 2H2A1 1 0 0 0 1.38 2.22A1 1 0 0 0 1.21 3.62L7 11V16.87A1 1 0 0 0 7.29 17.7L9.29 19.7A1 1 0 0 0 10.7 19.7A1 1 0 0 0 11 18.87V11M13 16L18 21L23 16Z";
var mdiFilterMenuOutline = "M12 18.88A1 1 0 0 1 11.71 19.71A1 1 0 0 1 10.3 19.71L6.3 15.71A1 1 0 0 1 6 14.87V9.75L1.21 3.62A1 1 0 0 1 1.38 2.22A1 1 0 0 1 2 2H16A1 1 0 0 1 16.62 2.22A1 1 0 0 1 16.79 3.62L12 9.75V18.88M4 4L8 9.06V14.58L10 16.58V9.05L14 4M13 16L18 21L23 16Z";
var mdiFilterMinus = "M12 12V19.88C12.04 20.18 11.94 20.5 11.71 20.71C11.32 21.1 10.69 21.1 10.3 20.71L8.29 18.7C8.06 18.47 7.96 18.16 8 17.86V12H7.97L2.21 4.62C1.87 4.19 1.95 3.56 2.38 3.22C2.57 3.08 2.78 3 3 3V3H17V3C17.22 3 17.43 3.08 17.62 3.22C18.05 3.56 18.13 4.19 17.79 4.62L12.03 12H12M15 17H23V19H15V17Z";
var mdiFilterMinusOutline = "M15 17H23V19H15V17M13 19.88C13.04 20.18 12.94 20.5 12.72 20.71C12.32 21.1 11.69 21.1 11.3 20.71L7.29 16.7C7.06 16.47 6.96 16.16 7 15.87V10.75L2.21 4.62C1.87 4.19 1.95 3.56 2.38 3.22C2.57 3.08 2.78 3 3 3V3H17V3C17.22 3 17.43 3.08 17.62 3.22C18.05 3.56 18.13 4.19 17.79 4.62L13 10.75V19.88M5.04 5L9 10.07V15.58L11 17.58V10.05L14.96 5H5.04Z";
var mdiFilterMultiple = "M3.46 5C3.25 5 3.04 5.08 2.87 5.21C2.43 5.55 2.35 6.18 2.69 6.61L2.69 6.62L8 13.42V19.41L10.29 21.71C10.68 22.1 11.32 22.1 11.71 21.71C12.1 21.32 12.1 20.68 11.71 20.29L10 18.59V12.73L4.27 5.39C4.08 5.14 3.78 5 3.46 5M16 12V19.88C16.04 20.18 15.94 20.5 15.71 20.71C15.32 21.1 14.69 21.1 14.3 20.71L12.29 18.7C12.06 18.47 11.96 18.16 12 17.87V12H11.97L6.21 4.62C5.87 4.19 5.95 3.56 6.38 3.22C6.57 3.08 6.78 3 7 3H21C21.22 3 21.43 3.08 21.62 3.22C22.05 3.56 22.13 4.19 21.79 4.62L16.03 12H16Z";
var mdiFilterMultipleOutline = "M3.47 5C3.25 5 3.04 5.08 2.87 5.21C2.43 5.55 2.35 6.18 2.69 6.61L2.69 6.62L7 12.14V18.05L10.64 21.71C11 22.1 11.66 22.1 12.05 21.71L12.05 21.71C12.44 21.32 12.44 20.69 12.06 20.3L9 17.22V11.45L4.27 5.39C4.08 5.14 3.78 5 3.47 5M21.62 3.22C21.43 3.08 21.22 3 21 3H7C6.78 3 6.57 3.08 6.38 3.22C5.95 3.56 5.87 4.19 6.21 4.62L11 10.75V15.87C10.96 16.16 11.06 16.47 11.29 16.7L15.3 20.71C15.69 21.1 16.32 21.1 16.71 20.71C16.94 20.5 17.04 20.18 17 19.88V10.75L21.79 4.62C22.13 4.19 22.05 3.56 21.62 3.22M15 10.05V17.58L13 15.58V10.06L9.04 5H18.96L15 10.05Z";
var mdiFilterOff = "M2.39 1.73L1.11 3L9.5 11.37L9.97 12H10V17.87C9.96 18.16 10.06 18.47 10.29 18.7L12.3 20.71C12.69 21.1 13.32 21.1 13.71 20.71C13.94 20.5 14.04 20.18 14 19.88V15.89L20.84 22.73L22.11 21.46L14 13.35L9.41 8.76L4.15 3.5L2.39 1.73M6.21 3L14.54 11.34L19.79 4.62C20.13 4.19 20.05 3.56 19.62 3.22C19.43 3.08 19.22 3 19 3H6.21Z";
var mdiFilterOffOutline = "M2.39 1.73L1.11 3L9 10.89V15.87C8.96 16.16 9.06 16.47 9.29 16.7L13.3 20.71C13.69 21.1 14.32 21.1 14.71 20.71C14.94 20.5 15.04 20.18 15 19.88V16.89L20.84 22.73L22.11 21.46L15 14.35V14.34L13 12.35L11 10.34L4.15 3.5L2.39 1.73M6.21 3L8.2 5H16.96L13.11 9.91L15 11.8V10.75L19.79 4.62C20.13 4.19 20.05 3.56 19.62 3.22C19.43 3.08 19.22 3 19 3H6.21M11 12.89L13 14.89V17.58L11 15.58V12.89Z";
var mdiFilterOutline = "M15,19.88C15.04,20.18 14.94,20.5 14.71,20.71C14.32,21.1 13.69,21.1 13.3,20.71L9.29,16.7C9.06,16.47 8.96,16.16 9,15.87V10.75L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L15,10.75V19.88M7.04,5L11,10.06V15.58L13,17.58V10.05L16.96,5H7.04Z";
var mdiFilterPlus = "M12 12V19.88C12.04 20.18 11.94 20.5 11.71 20.71C11.32 21.1 10.69 21.1 10.3 20.71L8.29 18.7C8.06 18.47 7.96 18.16 8 17.87V12H7.97L2.21 4.62C1.87 4.19 1.95 3.56 2.38 3.22C2.57 3.08 2.78 3 3 3H17C17.22 3 17.43 3.08 17.62 3.22C18.05 3.56 18.13 4.19 17.79 4.62L12.03 12H12M15 17H18V14H20V17H23V19H20V22H18V19H15V17Z";
var mdiFilterPlusOutline = "M15 17H18V14H20V17H23V19H20V22H18V19H15V17M13 19.88C13.04 20.18 12.94 20.5 12.72 20.71C12.32 21.1 11.69 21.1 11.3 20.71L7.29 16.7C7.06 16.47 6.96 16.16 7 15.87V10.75L2.21 4.62C1.87 4.19 1.95 3.56 2.38 3.22C2.57 3.08 2.78 3 3 3V3H17V3C17.22 3 17.43 3.08 17.62 3.22C18.05 3.56 18.13 4.19 17.79 4.62L13 10.75V19.88M5.04 5L9 10.07V15.58L11 17.58V10.05L14.96 5H5.04Z";
var mdiFilterRemove = "M14.76,20.83L17.6,18L14.76,15.17L16.17,13.76L19,16.57L21.83,13.76L23.24,15.17L20.43,18L23.24,20.83L21.83,22.24L19,19.4L16.17,22.24L14.76,20.83M12,12V19.88C12.04,20.18 11.94,20.5 11.71,20.71C11.32,21.1 10.69,21.1 10.3,20.71L8.29,18.7C8.06,18.47 7.96,18.16 8,17.87V12H7.97L2.21,4.62C1.87,4.19 1.95,3.56 2.38,3.22C2.57,3.08 2.78,3 3,3V3H17V3C17.22,3 17.43,3.08 17.62,3.22C18.05,3.56 18.13,4.19 17.79,4.62L12.03,12H12Z";
var mdiFilterRemoveOutline = "M14.73,20.83L17.58,18L14.73,15.17L16.15,13.76L19,16.57L21.8,13.76L23.22,15.17L20.41,18L23.22,20.83L21.8,22.24L19,19.4L16.15,22.24L14.73,20.83M13,19.88C13.04,20.18 12.94,20.5 12.71,20.71C12.32,21.1 11.69,21.1 11.3,20.71L7.29,16.7C7.06,16.47 6.96,16.16 7,15.87V10.75L2.21,4.62C1.87,4.19 1.95,3.56 2.38,3.22C2.57,3.08 2.78,3 3,3V3H17V3C17.22,3 17.43,3.08 17.62,3.22C18.05,3.56 18.13,4.19 17.79,4.62L13,10.75V19.88M5.04,5L9,10.06V15.58L11,17.58V10.05L14.96,5H5.04Z";
var mdiFilterSettings = "M15 22H17V24H15M11 22H13V24H11M7 22H9V24H7M14 12V19.88C14.04 20.18 13.94 20.5 13.71 20.71C13.32 21.1 12.69 21.1 12.3 20.71L10.29 18.7C10.06 18.47 9.96 18.16 10 17.87V12H9.97L4.21 4.62C3.87 4.19 3.95 3.56 4.38 3.22C4.57 3.08 4.78 3 5 3H19C19.22 3 19.43 3.08 19.62 3.22C20.05 3.56 20.13 4.19 19.79 4.62L14.03 12Z";
var mdiFilterSettingsOutline = "M15 22H17V24H15M11 22H13V24H11M7 22H9V24H7M15 19.88C15.04 20.18 14.94 20.5 14.71 20.71C14.32 21.1 13.69 21.1 13.3 20.71L9.29 16.7C9.06 16.47 8.96 16.16 9 15.87V10.75L4.21 4.62C3.87 4.19 3.95 3.56 4.38 3.22C4.57 3.08 4.78 3 5 3H19C19.22 3 19.43 3.08 19.62 3.22C20.05 3.56 20.13 4.19 19.79 4.62L15 10.75V19.88M7.04 5L11 10.06V15.58L13 17.58V10.05L16.96 5Z";
var mdiFilterVariant = "M6,13H18V11H6M3,6V8H21V6M10,18H14V16H10V18Z";
var mdiFilterVariantMinus = "M21 8H3V6H21V8M13.81 16H10V18H13.09C13.21 17.28 13.46 16.61 13.81 16M18 11H6V13H18V11M23 18H15V20H23V18Z";
var mdiFilterVariantPlus = "M21 8H3V6H21V8M13.81 16H10V18H13.09C13.21 17.28 13.46 16.61 13.81 16M18 11H6V13H18V11M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiFilterVariantRemove = "M21 8H3V6H21V8M13.81 16H10V18H13.09C13.21 17.28 13.46 16.61 13.81 16M18 11H6V13H18V11M21.12 15.46L19 17.59L16.88 15.46L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46Z";
var mdiFinance = "M6,16.5L3,19.44V11H6M11,14.66L9.43,13.32L8,14.64V7H11M16,13L13,16V3H16M18.81,12.81L17,11H22V16L20.21,14.21L13,21.36L9.53,18.34L5.75,22H3L9.47,15.66L13,18.64";
var mdiFindReplace = "M11,6C12.38,6 13.63,6.56 14.54,7.46L12,10H18V4L15.95,6.05C14.68,4.78 12.93,4 11,4C7.47,4 4.57,6.61 4.08,10H6.1C6.56,7.72 8.58,6 11,6M16.64,15.14C17.3,14.24 17.76,13.17 17.92,12H15.9C15.44,14.28 13.42,16 11,16C9.62,16 8.37,15.44 7.46,14.54L10,12H4V18L6.05,15.95C7.32,17.22 9.07,18 11,18C12.55,18 14,17.5 15.14,16.64L20,21.5L21.5,20L16.64,15.14Z";
var mdiFingerprint = "M17.81,4.47C17.73,4.47 17.65,4.45 17.58,4.41C15.66,3.42 14,3 12,3C10.03,3 8.15,3.47 6.44,4.41C6.2,4.54 5.9,4.45 5.76,4.21C5.63,3.97 5.72,3.66 5.96,3.53C7.82,2.5 9.86,2 12,2C14.14,2 16,2.47 18.04,3.5C18.29,3.65 18.38,3.95 18.25,4.19C18.16,4.37 18,4.47 17.81,4.47M3.5,9.72C3.4,9.72 3.3,9.69 3.21,9.63C3,9.47 2.93,9.16 3.09,8.93C4.08,7.53 5.34,6.43 6.84,5.66C10,4.04 14,4.03 17.15,5.65C18.65,6.42 19.91,7.5 20.9,8.9C21.06,9.12 21,9.44 20.78,9.6C20.55,9.76 20.24,9.71 20.08,9.5C19.18,8.22 18.04,7.23 16.69,6.54C13.82,5.07 10.15,5.07 7.29,6.55C5.93,7.25 4.79,8.25 3.89,9.5C3.81,9.65 3.66,9.72 3.5,9.72M9.75,21.79C9.62,21.79 9.5,21.74 9.4,21.64C8.53,20.77 8.06,20.21 7.39,19C6.7,17.77 6.34,16.27 6.34,14.66C6.34,11.69 8.88,9.27 12,9.27C15.12,9.27 17.66,11.69 17.66,14.66A0.5,0.5 0 0,1 17.16,15.16A0.5,0.5 0 0,1 16.66,14.66C16.66,12.24 14.57,10.27 12,10.27C9.43,10.27 7.34,12.24 7.34,14.66C7.34,16.1 7.66,17.43 8.27,18.5C8.91,19.66 9.35,20.15 10.12,20.93C10.31,21.13 10.31,21.44 10.12,21.64C10,21.74 9.88,21.79 9.75,21.79M16.92,19.94C15.73,19.94 14.68,19.64 13.82,19.05C12.33,18.04 11.44,16.4 11.44,14.66A0.5,0.5 0 0,1 11.94,14.16A0.5,0.5 0 0,1 12.44,14.66C12.44,16.07 13.16,17.4 14.38,18.22C15.09,18.7 15.92,18.93 16.92,18.93C17.16,18.93 17.56,18.9 17.96,18.83C18.23,18.78 18.5,18.96 18.54,19.24C18.59,19.5 18.41,19.77 18.13,19.82C17.56,19.93 17.06,19.94 16.92,19.94M14.91,22C14.87,22 14.82,22 14.78,22C13.19,21.54 12.15,20.95 11.06,19.88C9.66,18.5 8.89,16.64 8.89,14.66C8.89,13.04 10.27,11.72 11.97,11.72C13.67,11.72 15.05,13.04 15.05,14.66C15.05,15.73 16,16.6 17.13,16.6C18.28,16.6 19.21,15.73 19.21,14.66C19.21,10.89 15.96,7.83 11.96,7.83C9.12,7.83 6.5,9.41 5.35,11.86C4.96,12.67 4.76,13.62 4.76,14.66C4.76,15.44 4.83,16.67 5.43,18.27C5.53,18.53 5.4,18.82 5.14,18.91C4.88,19 4.59,18.87 4.5,18.62C4,17.31 3.77,16 3.77,14.66C3.77,13.46 4,12.37 4.45,11.42C5.78,8.63 8.73,6.82 11.96,6.82C16.5,6.82 20.21,10.33 20.21,14.65C20.21,16.27 18.83,17.59 17.13,17.59C15.43,17.59 14.05,16.27 14.05,14.65C14.05,13.58 13.12,12.71 11.97,12.71C10.82,12.71 9.89,13.58 9.89,14.65C9.89,16.36 10.55,17.96 11.76,19.16C12.71,20.1 13.62,20.62 15.03,21C15.3,21.08 15.45,21.36 15.38,21.62C15.33,21.85 15.12,22 14.91,22Z";
var mdiFingerprintOff = "M1.5,4.77L2.78,3.5L20.5,21.22L19.23,22.5L16.67,19.94C15.58,19.9 14.62,19.6 13.82,19.05C12.34,18.05 11.46,16.43 11.44,14.71L10.27,13.53C10.03,13.85 9.89,14.23 9.89,14.65C9.89,16.36 10.55,17.96 11.76,19.16C12.71,20.1 13.62,20.62 15.03,21C15.3,21.08 15.45,21.36 15.38,21.62C15.33,21.85 15.12,22 14.91,22H14.78C13.19,21.54 12.15,20.95 11.06,19.88C9.66,18.5 8.89,16.64 8.89,14.66C8.89,13.97 9.14,13.33 9.56,12.83L8.5,11.77C7.78,12.54 7.34,13.55 7.34,14.66C7.34,16.1 7.66,17.43 8.27,18.5C8.91,19.66 9.35,20.15 10.12,20.93C10.31,21.13 10.31,21.44 10.12,21.64C10,21.74 9.88,21.79 9.75,21.79C9.62,21.79 9.5,21.74 9.4,21.64C8.53,20.77 8.06,20.21 7.39,19C6.7,17.77 6.34,16.27 6.34,14.66C6.34,13.28 6.89,12 7.79,11.06L6.7,9.97C6.15,10.5 5.69,11.15 5.35,11.86C4.96,12.67 4.76,13.62 4.76,14.66C4.76,15.44 4.83,16.67 5.43,18.27C5.53,18.53 5.4,18.82 5.14,18.91C4.88,19 4.59,18.87 4.5,18.62C4,17.31 3.77,16 3.77,14.66C3.77,13.46 4,12.37 4.45,11.42C4.84,10.61 5.36,9.88 6,9.26L4.97,8.24C4.58,8.63 4.22,9.05 3.89,9.5C3.81,9.65 3.66,9.72 3.5,9.72L3.21,9.63C3,9.47 2.93,9.16 3.09,8.93C3.45,8.43 3.84,7.96 4.27,7.53L1.5,4.77M17.81,4.47L17.58,4.41C15.66,3.42 14,3 12,3C10.03,3 8.15,3.47 6.44,4.41L6.29,4.46L5.71,3.89C5.73,3.74 5.82,3.61 5.96,3.53C7.82,2.5 9.86,2 12,2C14.14,2 16,2.47 18.04,3.5C18.29,3.65 18.38,3.95 18.25,4.19C18.16,4.37 18,4.47 17.81,4.47M17.15,5.65C18.65,6.42 19.91,7.5 20.9,8.9C21.06,9.12 21,9.44 20.78,9.6C20.55,9.76 20.24,9.71 20.08,9.5C19.18,8.22 18.04,7.23 16.69,6.54C14.06,5.19 10.76,5.08 8.03,6.21L7.27,5.45C10.34,4.04 14.14,4.1 17.15,5.65M12,9.27C15.12,9.27 17.66,11.69 17.66,14.66A0.5,0.5 0 0,1 17.16,15.16L16.93,15.11L16.72,14.89L16.66,14.66C16.66,12.27 14.62,10.32 12.09,10.27L11.15,9.33L12,9.27M14.38,18.22C14.71,18.45 15.07,18.62 15.47,18.73L12.63,15.9C12.92,16.82 13.53,17.65 14.38,18.22M19.21,14.66C19.21,10.89 15.96,7.83 11.96,7.83C11.26,7.83 10.58,7.93 9.93,8.11L9.12,7.3C10,7 10.97,6.82 11.96,6.82C16.5,6.82 20.21,10.33 20.21,14.65C20.21,15.65 19.69,16.53 18.89,17.06L18.17,16.34C18.79,16 19.21,15.38 19.21,14.66Z";
var mdiFire = "M17.66 11.2C17.43 10.9 17.15 10.64 16.89 10.38C16.22 9.78 15.46 9.35 14.82 8.72C13.33 7.26 13 4.85 13.95 3C13 3.23 12.17 3.75 11.46 4.32C8.87 6.4 7.85 10.07 9.07 13.22C9.11 13.32 9.15 13.42 9.15 13.55C9.15 13.77 9 13.97 8.8 14.05C8.57 14.15 8.33 14.09 8.14 13.93C8.08 13.88 8.04 13.83 8 13.76C6.87 12.33 6.69 10.28 7.45 8.64C5.78 10 4.87 12.3 5 14.47C5.06 14.97 5.12 15.47 5.29 15.97C5.43 16.57 5.7 17.17 6 17.7C7.08 19.43 8.95 20.67 10.96 20.92C13.1 21.19 15.39 20.8 17.03 19.32C18.86 17.66 19.5 15 18.56 12.72L18.43 12.46C18.22 12 17.66 11.2 17.66 11.2M14.5 17.5C14.22 17.74 13.76 18 13.4 18.1C12.28 18.5 11.16 17.94 10.5 17.28C11.69 17 12.4 16.12 12.61 15.23C12.78 14.43 12.46 13.77 12.33 13C12.21 12.26 12.23 11.63 12.5 10.94C12.69 11.32 12.89 11.7 13.13 12C13.9 13 15.11 13.44 15.37 14.8C15.41 14.94 15.43 15.08 15.43 15.23C15.46 16.05 15.1 16.95 14.5 17.5H14.5Z";
var mdiFireAlert = "M15.66 11.2C15.43 10.9 15.15 10.64 14.89 10.38C14.22 9.78 13.46 9.35 12.82 8.72C11.33 7.26 11 4.85 11.95 3C11 3.23 10.17 3.75 9.46 4.32C6.87 6.4 5.85 10.07 7.07 13.22C7.11 13.32 7.15 13.42 7.15 13.55C7.15 13.77 7 13.97 6.8 14.05C6.57 14.15 6.33 14.09 6.14 13.93C6.08 13.88 6.04 13.83 6 13.76C4.87 12.33 4.69 10.28 5.45 8.64C3.78 10 2.87 12.3 3 14.47C3.06 14.97 3.12 15.47 3.29 15.97C3.43 16.57 3.7 17.17 4 17.7C5.08 19.43 6.95 20.67 8.96 20.92C11.1 21.19 13.39 20.8 15.03 19.32C16.86 17.66 17.5 15 16.56 12.72L16.43 12.46C16.22 12 15.66 11.2 15.66 11.2M12.5 17.5C12.22 17.74 11.76 18 11.4 18.1C10.28 18.5 9.16 17.94 8.5 17.28C9.69 17 10.4 16.12 10.61 15.23C10.78 14.43 10.46 13.77 10.33 13C10.21 12.26 10.23 11.63 10.5 10.94C10.69 11.32 10.89 11.7 11.13 12C11.9 13 13.11 13.44 13.37 14.8C13.41 14.94 13.43 15.08 13.43 15.23C13.46 16.05 13.1 16.95 12.5 17.5H12.5M21 13H19V7H21V13M21 17H19V15H21V17Z";
var mdiFireCircle = "M14.66 14.18C14.69 14.29 14.7 14.4 14.7 14.5C14.73 15.15 14.44 15.85 13.97 16.28C13.75 16.47 13.39 16.67 13.11 16.75C12.23 17.06 11.35 16.62 10.83 16.11C11.77 15.89 12.32 15.21 12.5 14.5C12.62 13.89 12.37 13.38 12.27 12.78C12.17 12.2 12.19 11.71 12.4 11.18C12.55 11.47 12.71 11.77 12.9 12C13.5 12.78 14.45 13.12 14.66 14.18M22 12C22 17.5 17.5 22 12 22S2 17.5 2 12 6.5 2 12 2 22 6.5 22 12M17.16 12.56L17.06 12.36C16.9 12 16.45 11.38 16.45 11.38C16.27 11.15 16.05 10.94 15.85 10.74C15.32 10.27 14.73 9.94 14.22 9.45C13.05 8.31 12.79 6.44 13.54 5C12.79 5.18 12.14 5.58 11.58 6.03C9.55 7.65 8.75 10.5 9.71 12.95C9.74 13.03 9.77 13.11 9.77 13.21C9.77 13.38 9.65 13.53 9.5 13.6C9.31 13.67 9.13 13.63 9 13.5C8.93 13.46 8.9 13.42 8.87 13.37C8 12.26 7.84 10.66 8.43 9.39C7.12 10.45 6.41 12.24 6.5 13.92C6.56 14.31 6.6 14.7 6.74 15.09C6.85 15.56 7.06 16 7.3 16.44C8.14 17.78 9.61 18.75 11.19 18.94C12.87 19.15 14.67 18.85 15.96 17.7C17.4 16.4 17.9 14.33 17.16 12.56Z";
var mdiFireExtinguisher = "M10.5,7H11.75L12,5H10.25L6,7.5V9H4V6.5L10,3H12V2H14V3H16L17,2.5V5.5L16,5H14L14.25,7H15.5A1.5,1.5 0 0,1 17,8.5V22H9V8.5A1.5,1.5 0 0,1 10.5,7Z";
var mdiFireHydrant = "M5 15V14H4V12H5V11H7V15H5M19 12V11H17V15H19V14H20V12H19M18 6H15.86C15.5 4.6 14.4 3.5 13 3.14V2H11V3.14C9.6 3.5 8.5 4.6 8.14 6H6V8H18V6M18 22H6C6 20.9 6.9 20 8 20V9H16V20C17.11 20 18 20.9 18 22M10 13C10 14.11 10.9 15 12 15S14 14.11 14 13 13.11 11 12 11 10 11.9 10 13Z";
var mdiFireHydrantAlert = "M22 7H20V13H22V7M22 15H20V17H22V15M3 15V14H2V12H3V11H5V15H3M17 12V11H15V15H17V14H18V12H17M16 6H13.86C13.5 4.6 12.4 3.5 11 3.14V2H9V3.14C7.6 3.5 6.5 4.6 6.14 6H4V8H16V6M16 22H4C4 20.9 4.89 20 6 20V9H14V20C15.11 20 16 20.9 16 22M8 13C8 14.11 8.9 15 10 15S12 14.11 12 13 11.11 11 10 11 8 11.9 8 13Z";
var mdiFireHydrantOff = "M20.84 22.73L22.11 21.46L2.39 1.73L1.11 3L8 9.89V20C6.9 20 6 20.9 6 22H18C18 20.9 17.11 20 16 20V17.89L20.84 22.73M10.22 12.11L12.89 14.78C12.62 14.92 12.32 15 12 15C10.9 15 10 14.11 10 13C10 12.68 10.08 12.38 10.22 12.11M11.2 8L8.44 5.24C8.94 4.21 9.87 3.43 11 3.14V2H13V3.14C14.4 3.5 15.5 4.6 15.86 6H18V8H11.2M19 11V12H20V14H19V15H18.2L17 13.8V11H19M5 15V14H4V12H5V11H7V15H5M16 12.8L12.2 9H16V12.8Z";
var mdiFireOff = "M22.11 21.46L2.39 1.73L1.11 3L7.09 9C5.66 10.36 4.88 12.47 5 14.47C5.06 14.97 5.12 15.47 5.29 15.97C5.43 16.57 5.7 17.17 6 17.7C7.08 19.43 8.95 20.67 10.96 20.92C13.1 21.19 15.39 20.8 17.03 19.32C17.1 19.26 17.15 19.18 17.22 19.11L20.84 22.73L22.11 21.46M8.8 14.05C8.57 14.15 8.33 14.09 8.14 13.93C8.08 13.88 8.04 13.83 8 13.76C7 12.47 6.74 10.69 7.26 9.15L8.58 10.47C8.58 11.4 8.73 12.33 9.07 13.22C9.11 13.32 9.15 13.42 9.15 13.55C9.15 13.77 9 13.97 8.8 14.05M14.5 17.5C14.22 17.74 13.76 18 13.4 18.1C12.28 18.5 11.16 17.94 10.5 17.28C11.69 17 12.4 16.12 12.61 15.23C12.66 15 12.66 14.76 12.64 14.53L15 16.88C14.85 17.11 14.69 17.33 14.5 17.5M18.92 15.72L9.65 6.46C10.12 5.65 10.72 4.92 11.46 4.32C12.17 3.75 13 3.23 13.95 3C13 4.85 13.33 7.26 14.82 8.72C15.46 9.35 16.22 9.78 16.89 10.38C17.15 10.64 17.43 10.9 17.66 11.2C17.66 11.2 18.22 12 18.43 12.46L18.56 12.72C18.96 13.69 19.06 14.72 18.92 15.72Z";
var mdiFireStation = "M13.11 10.39C13.37 10.15 13.53 9.75 13.5 9.39V9.2C13.43 8.81 13.18 8.6 12.92 8.37C12.78 8.24 12.63 8.12 12.5 7.95L12.26 7.5C12.13 7.8 12.12 8.08 12.17 8.41C12.19 8.5 12.21 8.6 12.24 8.69C12.29 8.92 12.35 9.14 12.29 9.39C12.2 9.78 11.9 10.17 11.37 10.3C11.67 10.59 12.15 10.82 12.64 10.66L13.11 10.39M2 22V7C2 6.74 2.11 6.5 2.29 6.29C2.5 6.11 2.74 6 3 6H7V2H17V6H21C21.27 6 21.5 6.11 21.71 6.29C21.9 6.5 22 6.74 22 7V22H19V17C19 17 19 15 15 15C11 15 11 17 11 17V22H8V17H4V22H2M14.47 7.62H14.5L14.14 7.25L13.25 6.5C12.61 5.88 12.46 4.82 12.87 4C12.5 4.1 12.1 4.33 11.79 4.58C10.68 5.5 10.23 7.12 10.76 8.5L10.8 8.65C10.8 8.75 10.73 8.84 10.64 8.87C10.55 8.92 10.44 8.89 10.36 8.82L10.3 8.74C9.81 8.11 9.73 7.21 10.06 6.5C9.34 7.09 8.96 8.1 9 9.06L9.13 9.72C9.19 10 9.3 10.25 9.45 10.5C9.9 11.24 10.71 11.79 11.58 11.9C12.5 12 13.5 11.85 14.21 11.19C15 10.45 15.29 9.3 14.87 8.29L14.81 8.17L14.47 7.62Z";
var mdiFireTruck = "M17.04,2C16.85,2 16.66,2.04 16.5,2.14L5.59,8.5H9.55L17.5,3.86C18,3.58 18.13,2.97 17.85,2.5C17.68,2.2 17.38,2 17.04,2M16,8V10H3A2,2 0 0,0 1,12H2V15H1V19H3A3,3 0 0,0 6,22A3,3 0 0,0 9,19H15A3,3 0 0,0 18,22A3,3 0 0,0 21,19H23V12.5L19.5,8H16M18,9.5H19L21.5,12.5V13.5H18V9.5M4,12H7V15H4V12M9,12H12V15H9V12M14,12H16V15H14V12M6,17.5A1.5,1.5 0 0,1 7.5,19A1.5,1.5 0 0,1 6,20.5A1.5,1.5 0 0,1 4.5,19A1.5,1.5 0 0,1 6,17.5M18,17.5A1.5,1.5 0 0,1 19.5,19A1.5,1.5 0 0,1 18,20.5A1.5,1.5 0 0,1 16.5,19A1.5,1.5 0 0,1 18,17.5Z";
var mdiFirebase = "M20,18.69L12.7,22.74C12.2,23 11.7,23 11.2,22.74L4,18.69L17.05,5.54L17.4,5.44C17.7,5.44 17.87,5.57 17.9,5.84L20,18.69M9.35,5.74L4.8,13.29L6.7,1.34C6.73,1.07 6.9,0.94 7.2,0.94C7.4,0.94 7.53,1 7.6,1.19L9.75,5.14L9.35,5.74M13.85,7L4.3,16.59L11.55,4.29C11.65,4.09 11.8,4 12,4C12.2,4 12.33,4.09 12.4,4.29L13.85,7Z";
var mdiFirefox = "M9.27 7.94C9.27 7.94 9.27 7.94 9.27 7.94M6.85 6.74C6.86 6.74 6.86 6.74 6.85 6.74M21.28 8.6C20.85 7.55 19.96 6.42 19.27 6.06C19.83 7.17 20.16 8.28 20.29 9.1L20.29 9.12C19.16 6.3 17.24 5.16 15.67 2.68C15.59 2.56 15.5 2.43 15.43 2.3C15.39 2.23 15.36 2.16 15.32 2.09C15.26 1.96 15.2 1.83 15.17 1.69C15.17 1.68 15.16 1.67 15.15 1.67H15.13L15.12 1.67L15.12 1.67L15.12 1.67C12.9 2.97 11.97 5.26 11.74 6.71C11.05 6.75 10.37 6.92 9.75 7.22C9.63 7.27 9.58 7.41 9.62 7.53C9.67 7.67 9.83 7.74 9.96 7.68C10.5 7.42 11.1 7.27 11.7 7.23L11.75 7.23C11.83 7.22 11.92 7.22 12 7.22C12.5 7.21 12.97 7.28 13.44 7.42L13.5 7.44C13.6 7.46 13.67 7.5 13.75 7.5C13.8 7.54 13.86 7.56 13.91 7.58L14.05 7.64C14.12 7.67 14.19 7.7 14.25 7.73C14.28 7.75 14.31 7.76 14.34 7.78C14.41 7.82 14.5 7.85 14.54 7.89C14.58 7.91 14.62 7.94 14.66 7.96C15.39 8.41 16 9.03 16.41 9.77C15.88 9.4 14.92 9.03 14 9.19C17.6 11 16.63 17.19 11.64 16.95C11.2 16.94 10.76 16.85 10.34 16.7C10.24 16.67 10.14 16.63 10.05 16.58C10 16.56 9.93 16.53 9.88 16.5C8.65 15.87 7.64 14.68 7.5 13.23C7.5 13.23 8 11.5 10.83 11.5C11.14 11.5 12 10.64 12.03 10.4C12.03 10.31 10.29 9.62 9.61 8.95C9.24 8.59 9.07 8.42 8.92 8.29C8.84 8.22 8.75 8.16 8.66 8.1C8.43 7.3 8.42 6.45 8.63 5.65C7.6 6.12 6.8 6.86 6.22 7.5H6.22C5.82 7 5.85 5.35 5.87 5C5.86 5 5.57 5.16 5.54 5.18C5.19 5.43 4.86 5.71 4.56 6C4.21 6.37 3.9 6.74 3.62 7.14C3 8.05 2.5 9.09 2.28 10.18C2.28 10.19 2.18 10.59 2.11 11.1L2.08 11.33C2.06 11.5 2.04 11.65 2 11.91L2 11.94L2 12.27L2 12.32C2 17.85 6.5 22.33 12 22.33C16.97 22.33 21.08 18.74 21.88 14C21.9 13.89 21.91 13.76 21.93 13.63C22.13 11.91 21.91 10.11 21.28 8.6Z";
var mdiFireplace = "M22,22H2V20H22V22M22,6H2V3H22V6M20,7V19H17V11C17,11 14.5,10 12,10C9.5,10 7,11 7,11V19H4V7H20M14.5,14.67H14.47L14.81,15.22L14.87,15.34C15.29,16.35 15,17.5 14.21,18.24C13.5,18.9 12.5,19.07 11.58,18.95C10.71,18.84 9.9,18.29 9.45,17.53C9.3,17.3 9.19,17.03 9.13,16.77L9,16.11C8.96,15.15 9.34,14.14 10.06,13.54C9.73,14.26 9.81,15.16 10.3,15.79L10.36,15.87C10.44,15.94 10.55,15.97 10.64,15.92C10.73,15.89 10.8,15.8 10.8,15.7L10.76,15.56C10.23,14.17 10.68,12.55 11.79,11.63C12.1,11.38 12.5,11.15 12.87,11.05C12.46,11.87 12.61,12.93 13.25,13.57L14.14,14.3L14.5,14.67M13.11,17.44V17.44C13.37,17.2 13.53,16.8 13.5,16.44V16.25C13.38,15.65 12.85,15.46 12.5,15L12.26,14.55C12.13,14.85 12.12,15.13 12.17,15.46C12.23,15.8 12.37,16.09 12.29,16.44C12.2,16.83 11.9,17.22 11.37,17.35C11.67,17.64 12.15,17.87 12.64,17.71L13.11,17.44Z";
var mdiFireplaceOff = "M22,22H2V20H22V22M22,6H2V3H22V6M20,7V19H17V11C17,11 14.5,10 12,10C9.5,10 7,11 7,11V19H4V7H20Z";
var mdiFirewire = "M12 10C13.1 10 14 10.9 14 12S13.1 14 12 14 10 13.1 10 12 10.9 10 12 10M12 8C9.8 8 8 9.8 8 12S9.8 16 12 16 16 14.2 16 12 14.2 8 12 8M15 17H9V19H15V17M15 20H9V22H15V20M6.3 10.6L10.5 6.4L9.2 4.9L4.9 9.2L6.3 10.6M4.2 8.5L8.4 4.3L7.1 2.8L2.8 7.1L4.2 8.5M15 17H9V19H15V17M13.4 6.3L17.6 10.5L21.1 7L16.9 2.8L13.4 6.3Z";
var mdiFirework = "M5.8,16.59L4.5,15.28L12.26,7.5L16.5,11.74L8.72,19.5L7.29,18.09C7.04,18.16 6.8,18.28 6.63,18.5C6.57,18.57 6.5,18.65 6.5,18.74C6.42,18.88 6.38,19 6.32,19.15C6.21,19.42 6.09,19.69 5.93,19.93C5.81,20.1 5.68,20.26 5.53,20.39C5.42,20.5 5.29,20.59 5.16,20.66C5.08,20.71 5,20.76 4.9,20.79C4.3,21.04 3.63,21 3,21V19C3.23,19 3.83,19 3.9,19C4,19 4.08,19 4.16,18.94C4.18,18.92 4.19,18.91 4.21,18.89C4.28,18.81 4.34,18.7 4.39,18.6C4.47,18.42 4.53,18.24 4.6,18.06L4.64,17.96C4.76,17.69 4.9,17.45 5.08,17.23C5.18,17.1 5.3,17 5.42,16.87C5.54,16.77 5.66,16.67 5.8,16.59M21,3L19.88,11.19L12.81,4.12L21,3Z";
var mdiFireworkOff = "M20.84 22.73L13.17 15.06L8.72 19.5L7.29 18.09C7.04 18.16 6.8 18.28 6.63 18.5C6.57 18.57 6.5 18.65 6.5 18.74C6.42 18.88 6.38 19 6.32 19.15C6.21 19.42 6.09 19.69 5.93 19.93C5.81 20.1 5.68 20.26 5.53 20.39C5.42 20.5 5.29 20.59 5.16 20.66C5.08 20.71 5 20.76 4.9 20.79C4.3 21.04 3.63 21 3 21V19H3.9C4 19 4.08 19 4.16 18.94L4.21 18.89C4.28 18.81 4.34 18.7 4.39 18.6C4.47 18.42 4.53 18.24 4.6 18.06L4.64 17.96C4.76 17.69 4.9 17.45 5.08 17.23C5.18 17.1 5.3 17 5.42 16.87C5.54 16.77 5.66 16.67 5.8 16.59L4.5 15.28L8.94 10.83L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M21 3L12.81 4.12L19.88 11.19L21 3M16.5 11.74L12.26 7.5L11.5 8.28L15.72 12.5L16.5 11.74Z";
var mdiFish = "M12,20L12.76,17C9.5,16.79 6.59,15.4 5.75,13.58C5.66,14.06 5.53,14.5 5.33,14.83C4.67,16 3.33,16 2,16C3.1,16 3.5,14.43 3.5,12.5C3.5,10.57 3.1,9 2,9C3.33,9 4.67,9 5.33,10.17C5.53,10.5 5.66,10.94 5.75,11.42C6.4,10 8.32,8.85 10.66,8.32L9,5C11,5 13,5 14.33,5.67C15.46,6.23 16.11,7.27 16.69,8.38C19.61,9.08 22,10.66 22,12.5C22,14.38 19.5,16 16.5,16.66C15.67,17.76 14.86,18.78 14.17,19.33C13.33,20 12.67,20 12,20M17,11A1,1 0 0,0 16,12A1,1 0 0,0 17,13A1,1 0 0,0 18,12A1,1 0 0,0 17,11Z";
var mdiFishOff = "M20.8 22.7L15.7 17.6C15.1 18.3 14.6 18.9 14.1 19.3C13.3 20 12.7 20 12 20L12.8 17C9.5 16.8 6.6 15.4 5.8 13.6C5.7 14.1 5.6 14.5 5.4 14.8C4.7 16 3.3 16 2 16C3.1 16 3.5 14.4 3.5 12.5S3.1 9 2 9C3.3 9 4.7 9 5.3 10.2C5.5 10.5 5.6 11 5.7 11.4C6 10.7 6.7 10 7.6 9.5L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M9.8 6.6L9 5C11 5 13 5 14.3 5.7C15.4 6.3 16.1 7.3 16.7 8.4C19.6 9.1 22 10.7 22 12.5C22 13.8 20.8 15 19 15.8L9.8 6.6M16 12C16 12.6 16.4 13 17 13S18 12.6 18 12 17.6 11 17 11 16 11.4 16 12Z";
var mdiFishbowl = "M19.11,5H21V3H3V5H4.89C3.11,6.8 2,9.27 2,12C2,15.97 4.31,19.39 7.66,21H16.34C19.69,19.39 22,15.97 22,12C22,9.27 20.89,6.8 19.11,5M13.25,17C12.09,17 11.06,16.64 10.33,16.17C9.67,17 8.33,17 7,17C8.1,17 8.5,15.88 8.5,14.5C8.5,13.12 8.1,12 7,12C8.33,12 9.67,12 10.37,12.91C11.06,12.36 12.09,12 13.25,12C15.32,12 17,13.12 17,14.5C17,15.88 15.32,17 13.25,17M16,7C13.56,8.71 10.44,8.71 8,7C7.06,7.66 6,8.09 4.95,8.25C5.31,7.58 5.77,6.96 6.32,6.41L7.7,5H16.3L17.68,6.41C18.23,6.96 18.69,7.58 19.05,8.25C18,8.09 16.94,7.66 16,7Z";
var mdiFishbowlOutline = "M19.11,5H21V3H3V5H4.89C3.11,6.8 2,9.27 2,12C2,15.97 4.31,19.39 7.66,21H16.34C19.69,19.39 22,15.97 22,12C22,9.27 20.89,6.8 19.11,5M6.32,6.41L7.7,5H16.3L17.68,6.41C18.23,6.96 18.69,7.58 19.05,8.25C18,8.09 16.94,7.66 16,7C13.56,8.71 10.44,8.71 8,7C7.06,7.66 6,8.09 4.95,8.25C5.31,7.58 5.77,6.96 6.32,6.41M15.85,19H8.15C5.58,17.59 4,14.95 4,12C4,11.43 4.07,10.86 4.19,10.32C5.5,10.29 6.8,9.95 8,9.33C10.5,10.63 13.5,10.63 16,9.33C17.2,9.95 18.5,10.29 19.81,10.32C19.93,10.86 20,11.43 20,12C20,14.95 18.42,17.59 15.85,19M17,14.5C17,15.88 15.32,17 13.25,17C12.09,17 11.06,16.64 10.33,16.16C9.67,17 8.33,17 7,17C8.1,17 8.5,15.88 8.5,14.5C8.5,13.12 8.1,12 7,12C8.33,12 9.67,12 10.37,12.91C11.06,12.36 12.09,12 13.25,12C15.32,12 17,13.12 17,14.5Z";
var mdiFitToPage = "M20,2H4C2.89,2 2,2.89 2,4V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V4C22,2.89 21.11,2 20,2M12,4L15,7H13V9H11V7H9M7,15L4,12L7,9V11H9V13H7M12,20L9,17H11V15H13V17H15M17,15V13H15V11H17V9L20,12";
var mdiFitToPageOutline = "M20,2H4C2.89,2 2,2.89 2,4V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V4C22,2.89 21.11,2 20,2M20,20H4V4H20M13,8V10H11V8H9L12,5L15,8M16,15V13H14V11H16V9L19,12M10,13H8V15L5,12L8,9V11H10M15,16L12,19L9,16H11V14H13V16";
var mdiFitToScreen = "M17 4H20C21.1 4 22 4.9 22 6V8H20V6H17V4M4 8V6H7V4H4C2.9 4 2 4.9 2 6V8H4M20 16V18H17V20H20C21.1 20 22 19.1 22 18V16H20M7 18H4V16H2V18C2 19.1 2.9 20 4 20H7V18M18 8H6V16H18V8Z";
var mdiFitToScreenOutline = "M17 4H20C21.1 4 22 4.9 22 6V8H20V6H17V4M4 8V6H7V4H4C2.9 4 2 4.9 2 6V8H4M20 16V18H17V20H20C21.1 20 22 19.1 22 18V16H20M7 18H4V16H2V18C2 19.1 2.9 20 4 20H7V18M16 10V14H8V10H16M18 8H6V16H18V8Z";
var mdiFlag = "M14.4,6L14,4H5V21H7V14H12.6L13,16H20V6H14.4Z";
var mdiFlagCheckered = "M14.4,6H20V16H13L12.6,14H7V21H5V4H14L14.4,6M14,14H16V12H18V10H16V8H14V10L13,8V6H11V8H9V6H7V8H9V10H7V12H9V10H11V12H13V10L14,12V14M11,10V8H13V10H11M14,10H16V12H14V10Z";
var mdiFlagMinus = "M12.4,5H18V15H11L10.6,13H5V20H3V3H12L12.4,5M14,17H22V19H14V17Z";
var mdiFlagMinusOutline = "M12.36 6L12.76 8H18V14H14.64L14.24 12H7V6H12.36M14 4H5V21H7V14H12.6L13 16H20V6H14.4M23 18H15V20H23V18Z";
var mdiFlagOff = "M20.84 22.73L14.11 16H13L12.72 14.61L12.11 14H7V21H5V6.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M20 16V6H14.4L14 4H7.2L19.2 16H20";
var mdiFlagOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L5 6.89V21H7V14H12.11L12.72 14.61L13 16H14.11L20.84 22.73L22.11 21.46M7 12V8.89L10.11 12H7M9.2 6L7.2 4H14L14.4 6H20V16H19.2L17.2 14H18V8H12.76L12.36 6H9.2Z";
var mdiFlagOutline = "M12.36,6L12.76,8H18V14H14.64L14.24,12H7V6H12.36M14,4H5V21H7V14H12.6L13,16H20V6H14.4";
var mdiFlagPlus = "M17,14H19V17H22V19H19V22H17V19H14V17H17V14M12.4,5H18V12C15.78,12 13.84,13.21 12.8,15H11L10.6,13H5V20H3V3H12L12.4,5Z";
var mdiFlagPlusOutline = "M13 16L12.6 14H7V21H5V4H14L14.4 6H20V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V8H12.76L12.36 6H7V12H14.24L14.64 14H15.69C14.92 14.5 14.27 15.2 13.81 16H13M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiFlagRemove = "M14.46,15.88L15.88,14.46L18,16.59L20.12,14.46L21.54,15.88L19.41,18L21.54,20.12L20.12,21.54L18,19.41L15.88,21.54L14.46,20.12L16.59,18L14.46,15.88M12.4,5H18V12C15.78,12 13.84,13.21 12.8,15H11L10.6,13H5V20H3V3H12L12.4,5Z";
var mdiFlagRemoveOutline = "M13 16L12.6 14H7V21H5V4H14L14.4 6H20V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V8H12.76L12.36 6H7V12H14.24L14.64 14H15.69C14.92 14.5 14.27 15.2 13.81 16H13M21.12 15.46L19 17.59L16.88 15.46L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46Z";
var mdiFlagTriangle = "M7,2H9V22H7V2M19,9L11,14.6V3.4L19,9Z";
var mdiFlagVariant = "M6,3A1,1 0 0,1 7,4V4.88C8.06,4.44 9.5,4 11,4C14,4 14,6 16,6C19,6 20,4 20,4V12C20,12 19,14 16,14C13,14 13,12 11,12C8,12 7,14 7,14V21H5V4A1,1 0 0,1 6,3Z";
var mdiFlagVariantMinus = "M6 3C6.6 3 7 3.4 7 4V4.9C8.1 4.4 9.5 4 11 4C14 4 14 6 16 6C19 6 20 4 20 4V12C20 12 19 14 16 14S13 12 11 12C8 12 7 14 7 14V21H5V4C5 3.4 5.4 3 6 3M15 18V20H23V18H15Z";
var mdiFlagVariantMinusOutline = "M6 3C6.6 3 7 3.4 7 4V4.9C8.1 4.4 9.5 4 11 4C14 4 14 6 16 6C19 6 20 4 20 4V12C20 12 19 14 16 14S13 12 11 12C8 12 7 14 7 14V21H5V4C5 3.4 5.4 3 6 3M7 7.2V11.4C7 11.4 9 9.9 11 9.9S14 11.9 16 11.9 18 10.9 18 10.9V7.5C18 7.5 17 8 16 8C14 8 13 6 11 6S7 7.2 7 7.2M15 18V20H23V18H15Z";
var mdiFlagVariantOff = "M20.8 22.7L10.2 12.1C7.8 12.4 7 14 7 14V21H5V6.9L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M20 12V4C20 4 19 6 16 6C14 6 14 4 11 4C9.8 4 8.7 4.3 7.8 4.6L17.1 13.9C19.2 13.5 20 12 20 12Z";
var mdiFlagVariantOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L5 6.9V21H7V14C7 14 7.8 12.4 10.2 12.1L20.9 22.8L22.1 21.5M7 11.5V8.9L8.7 10.6C7.7 11 7 11.5 7 11.5M9.4 6.2L7.8 4.6C8.7 4.3 9.8 4 11 4C14 4 14 6 16 6C19 6 20 4 20 4V12C20 12 19.2 13.5 17.1 13.9L15 11.8C15.3 11.9 15.6 12 16 12C18 12 18 11 18 11V7.5C18 7.5 17 8 16 8C14 8 13 6 11 6C10.5 6 9.9 6.1 9.4 6.2Z";
var mdiFlagVariantOutline = "M6,3A1,1 0 0,1 7,4V4.88C8.06,4.44 9.5,4 11,4C14,4 14,6 16,6C19,6 20,4 20,4V12C20,12 19,14 16,14C13,14 13,12 11,12C8,12 7,14 7,14V21H5V4A1,1 0 0,1 6,3M7,7.25V11.5C7,11.5 9,10 11,10C13,10 14,12 16,12C18,12 18,11 18,11V7.5C18,7.5 17,8 16,8C14,8 13,6 11,6C9,6 7,7.25 7,7.25Z";
var mdiFlagVariantPlus = "M6 3C6.6 3 7 3.4 7 4V4.9C8.1 4.4 9.5 4 11 4C14 4 14 6 16 6C19 6 20 4 20 4V12C20 12 19 14 16 14S13 12 11 12C8 12 7 14 7 14V21H5V4C5 3.4 5.4 3 6 3M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiFlagVariantPlusOutline = "M6 3C6.6 3 7 3.4 7 4V4.9C8.1 4.4 9.5 4 11 4C14 4 14 6 16 6C19 6 20 4 20 4V12C20 12 19 14 16 14S13 12 11 12C8 12 7 14 7 14V21H5V4C5 3.4 5.4 3 6 3M7 7.2V11.4C7 11.4 9 9.9 11 9.9S14 11.9 16 11.9 18 10.9 18 10.9V7.5C18 7.5 17 8 16 8C14 8 13 6 11 6S7 7.2 7 7.2M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiFlagVariantRemove = "M6 3C6.6 3 7 3.4 7 4V4.9C8.1 4.4 9.5 4 11 4C14 4 14 6 16 6C19 6 20 4 20 4V12C20 12 19 14 16 14S13 12 11 12C8 12 7 14 7 14V21H5V4C5 3.4 5.4 3 6 3M21.1 15.5L19 17.6L16.9 15.5L15.5 16.9L17.6 19L15.5 21.1L16.9 22.5L19 20.4L21.1 22.5L22.5 21.1L20.4 19L22.5 16.9L21.1 15.5Z";
var mdiFlagVariantRemoveOutline = "M6 3C6.6 3 7 3.4 7 4V4.9C8.1 4.4 9.5 4 11 4C14 4 14 6 16 6C19 6 20 4 20 4V12C20 12 19 14 16 14S13 12 11 12C8 12 7 14 7 14V21H5V4C5 3.4 5.4 3 6 3M7 7.2V11.4C7 11.4 9 9.9 11 9.9S14 11.9 16 11.9 18 10.9 18 10.9V7.5C18 7.5 17 8 16 8C14 8 13 6 11 6S7 7.2 7 7.2M21.1 15.5L19 17.6L16.9 15.5L15.5 16.9L17.6 19L15.5 21.1L16.9 22.5L19 20.4L21.1 22.5L22.5 21.1L20.4 19L22.5 16.9L21.1 15.5Z";
var mdiFlare = "M7,11H1V13H7V11M9.17,7.76L7.05,5.64L5.64,7.05L7.76,9.17L9.17,7.76M13,1H11V7H13V1M18.36,7.05L16.95,5.64L14.83,7.76L16.24,9.17L18.36,7.05M17,11V13H23V11H17M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M14.83,16.24L16.95,18.36L18.36,16.95L16.24,14.83L14.83,16.24M5.64,16.95L7.05,18.36L9.17,16.24L7.76,14.83L5.64,16.95M11,23H13V17H11V23Z";
var mdiFlash = "M7,2V13H10V22L17,10H13L17,2H7Z";
var mdiFlashAlert = "M5,2V13H8V22L15,10H11L15,2M17,15H19V17H17V15M17,7H19V13H17V7Z";
var mdiFlashAlertOutline = "M5,2H15L11.5,9H15L8,22V14H5V2M7,4V12H10V14.66L12,11H8.24L11.76,4M17,15H19V17H17V15M17,7H19V13H17V7Z";
var mdiFlashAuto = "M16.85,7.65L18,4L19.15,7.65M19,2H17L13.8,11H15.7L16.4,9H19.6L20.3,11H22.2M3,2V14H6V23L13,11H9L13,2H3Z";
var mdiFlashOff = "M17,10H13L17,2H7V4.18L15.46,12.64M3.27,3L2,4.27L7,9.27V13H10V22L13.58,15.86L17.73,20L19,18.73L3.27,3Z";
var mdiFlashOffOutline = "M9 6.19L7 4.19V2H17L13.5 9H17L15.18 12.37L11.43 8.62L13.76 4H9V6.19M19 18.73L17.73 20L13.41 15.68L10 22V14H7V9.27L2 4.27L3.27 3L19 18.73Z";
var mdiFlashOutline = "M7,2H17L13.5,9H17L10,22V14H7V2M9,4V12H12V14.66L14,11H10.24L13.76,4H9Z";
var mdiFlashRedEye = "M16,5C15.44,5 15,5.44 15,6C15,6.56 15.44,7 16,7C16.56,7 17,6.56 17,6C17,5.44 16.56,5 16,5M16,2C13.27,2 10.94,3.66 10,6C10.94,8.34 13.27,10 16,10C18.73,10 21.06,8.34 22,6C21.06,3.66 18.73,2 16,2M16,3.5A2.5,2.5 0 0,1 18.5,6A2.5,2.5 0 0,1 16,8.5A2.5,2.5 0 0,1 13.5,6A2.5,2.5 0 0,1 16,3.5M3,2V14H6V23L13,11H9L10.12,8.5C9.44,7.76 8.88,6.93 8.5,6C9.19,4.29 10.5,2.88 12.11,2H3Z";
var mdiFlashTriangle = "M12 2L1 21H23L12 2M10 15V10H14L12.5 13.5H14.5L11.5 19V15H10Z";
var mdiFlashTriangleOutline = "M12 2L1 21H23M12 6L19.5 19H4.5M14 14H12.5L14 11H10V15H11V18L14 14Z";
var mdiFlashlight = "M9,10L6,5H18L15,10H9M18,4H6V2H18V4M9,22V11H15V22H9M12,13A1,1 0 0,0 11,14A1,1 0 0,0 12,15A1,1 0 0,0 13,14A1,1 0 0,0 12,13Z";
var mdiFlashlightOff = "M2,5.27L3.28,4L20,20.72L18.73,22L15,18.27V22H9V12.27L2,5.27M18,5L15,10H11.82L6.82,5H18M18,4H6V2H18V4M15,11V13.18L12.82,11H15Z";
var mdiFlask = "M6,22A3,3 0 0,1 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6A1,1 0 0,1 8,5V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V5A1,1 0 0,1 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19A3,3 0 0,1 18,22H6M5,19A1,1 0 0,0 6,20H18A1,1 0 0,0 19,19C19,18.79 18.93,18.59 18.82,18.43L16.53,14.47L14,17L8.93,11.93L5.18,18.43C5.07,18.59 5,18.79 5,19M13,10A1,1 0 0,0 12,11A1,1 0 0,0 13,12A1,1 0 0,0 14,11A1,1 0 0,0 13,10Z";
var mdiFlaskEmpty = "M6,22A3,3 0 0,1 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6A1,1 0 0,1 8,5V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V5A1,1 0 0,1 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19A3,3 0 0,1 18,22H6Z";
var mdiFlaskEmptyMinus = "M23 17V19H15V17H23M6 22C4.34 22 3 20.66 3 19C3 18.4 3.18 17.84 3.5 17.36L9 7.81V6C8.45 6 8 5.55 8 5V4C8 2.9 8.9 2 10 2H14C15.11 2 16 2.9 16 4V5C16 5.55 15.55 6 15 6V7.81L17.5 12.18C14.92 12.84 13 15.2 13 18C13 19.54 13.58 20.94 14.53 22H6Z";
var mdiFlaskEmptyMinusOutline = "M23 17V19H15V17H23M5 19C5 19.55 5.45 20 6 20H13.34C13.61 20.75 14 21.42 14.53 22H6C4.34 22 3 20.66 3 19C3 18.4 3.18 17.84 3.5 17.36L9 7.81V6C8.45 6 8 5.55 8 5V4C8 2.9 8.9 2 10 2H14C15.11 2 16 2.9 16 4V5C16 5.55 15.55 6 15 6V7.81L17.5 12.18C16.86 12.35 16.24 12.63 15.69 13L13 8.35V4H11V8.35L5.18 18.43C5.07 18.59 5 18.79 5 19Z";
var mdiFlaskEmptyOff = "M20.8 22.7L19.6 21.5C19.1 21.8 18.6 22 18 22H6C4.3 22 3 20.7 3 19C3 18.4 3.2 17.8 3.5 17.4L7.9 9.8L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M15 7.8V6C15.6 6 16 5.6 16 5V4C16 2.9 15.1 2 14 2H10C8.9 2 8 2.9 8 4V4.8L20.4 17.2L15 7.8Z";
var mdiFlaskEmptyOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L7.9 9.8L3.5 17.4C3.2 17.8 3 18.4 3 19C3 20.7 4.3 22 6 22H18C18.6 22 19.2 21.8 19.6 21.5L20.8 22.7L22.1 21.5M18 20H6C5.4 20 5 19.6 5 19C5 18.8 5.1 18.6 5.2 18.4L9.4 11.2L18 20C18.1 20 18 20 18 20M11 7.8L8 4.8V4C8 2.9 8.9 2 10 2H14C15.1 2 16 2.9 16 4V5C16 5.6 15.6 6 15 6V7.8L20.4 17.2L15 11.8L13 8.4V4H11V7.8Z";
var mdiFlaskEmptyOutline = "M5,19A1,1 0 0,0 6,20H18A1,1 0 0,0 19,19C19,18.79 18.93,18.59 18.82,18.43L13,8.35V4H11V8.35L5.18,18.43C5.07,18.59 5,18.79 5,19M6,22A3,3 0 0,1 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6A1,1 0 0,1 8,5V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V5A1,1 0 0,1 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19A3,3 0 0,1 18,22H6Z";
var mdiFlaskEmptyPlus = "M18 14H20V17H23V19H20V22H18V19H15V17H18V14M6 22C4.34 22 3 20.66 3 19C3 18.4 3.18 17.84 3.5 17.36L9 7.81V6C8.45 6 8 5.55 8 5V4C8 2.9 8.9 2 10 2H14C15.11 2 16 2.9 16 4V5C16 5.55 15.55 6 15 6V7.81L17.5 12.18C14.92 12.84 13 15.2 13 18C13 19.54 13.58 20.94 14.53 22H6Z";
var mdiFlaskEmptyPlusOutline = "M18 14H20V17H23V19H20V22H18V19H15V17H18V14M5 19C5 19.55 5.45 20 6 20H13.34C13.61 20.75 14 21.42 14.53 22H6C4.34 22 3 20.66 3 19C3 18.4 3.18 17.84 3.5 17.36L9 7.81V6C8.45 6 8 5.55 8 5V4C8 2.9 8.9 2 10 2H14C15.11 2 16 2.9 16 4V5C16 5.55 15.55 6 15 6V7.81L17.5 12.18C16.86 12.35 16.24 12.63 15.69 13L13 8.35V4H11V8.35L5.18 18.43C5.07 18.59 5 18.79 5 19Z";
var mdiFlaskEmptyRemove = "M15.46 15.88L16.88 14.46L19 16.59L21.12 14.47L22.53 15.88L20.41 18L22.54 20.12L21.12 21.54L19 19.41L16.88 21.53L15.47 20.12L17.59 18L15.46 15.88M6 22C4.34 22 3 20.66 3 19C3 18.4 3.18 17.84 3.5 17.36L9 7.81V6C8.45 6 8 5.55 8 5V4C8 2.9 8.9 2 10 2H14C15.11 2 16 2.9 16 4V5C16 5.55 15.55 6 15 6V7.81L17.5 12.18C14.92 12.84 13 15.2 13 18C13 19.54 13.58 20.94 14.53 22H6Z";
var mdiFlaskEmptyRemoveOutline = "M15.46 15.88L16.88 14.46L19 16.59L21.12 14.47L22.53 15.88L20.41 18L22.54 20.12L21.12 21.54L19 19.41L16.88 21.53L15.47 20.12L17.59 18L15.46 15.88M5 19C5 19.55 5.45 20 6 20H13.34C13.61 20.75 14 21.42 14.53 22H6C4.34 22 3 20.66 3 19C3 18.4 3.18 17.84 3.5 17.36L9 7.81V6C8.45 6 8 5.55 8 5V4C8 2.9 8.9 2 10 2H14C15.11 2 16 2.9 16 4V5C16 5.55 15.55 6 15 6V7.81L17.5 12.18C16.86 12.35 16.24 12.63 15.69 13L13 8.35V4H11V8.35L5.18 18.43C5.07 18.59 5 18.79 5 19Z";
var mdiFlaskMinus = "M23 17V19H15V17H23M6 22C4.34 22 3 20.66 3 19C3 18.4 3.18 17.84 3.5 17.36L9 7.81V6C8.45 6 8 5.55 8 5V4C8 2.9 8.9 2 10 2H14C15.11 2 16 2.9 16 4V5C16 5.55 15.55 6 15 6V7.81L17.5 12.18C15.5 12.7 13.86 14.26 13.26 16.26L8.93 11.93L5.18 18.43C5.07 18.59 5 18.79 5 19C5 19.55 5.45 20 6 20H13.34C13.61 20.75 14 21.42 14.53 22H6M13 10C12.45 10 12 10.45 12 11C12 11.55 12.45 12 13 12C13.55 12 14 11.55 14 11C14 10.45 13.55 10 13 10Z";
var mdiFlaskMinusOutline = "M23 17V19H15V17H23M5 19C5 19.55 5.45 20 6 20H13.34C13.61 20.75 14 21.42 14.53 22H6C4.34 22 3 20.66 3 19C3 18.4 3.18 17.84 3.5 17.36L9 7.81V6C8.45 6 8 5.55 8 5V4C8 2.9 8.9 2 10 2H14C15.11 2 16 2.9 16 4V5C16 5.55 15.55 6 15 6V7.81L17.5 12.18C16.86 12.35 16.24 12.63 15.69 13L13 8.35V4H11V8.35L5.18 18.43C5.07 18.59 5 18.79 5 19M13 16L13.58 15.42C13.21 16.2 13 17.08 13 18H7.73L10.39 13.39L13 16M12.5 12C12.78 12 13 12.22 13 12.5C13 12.78 12.78 13 12.5 13C12.22 13 12 12.78 12 12.5C12 12.22 12.22 12 12.5 12Z";
var mdiFlaskOff = "M22.1 21.5L2.4 1.7L1.1 3L7.9 9.8L3.5 17.4C3.2 17.8 3 18.4 3 19C3 20.7 4.3 22 6 22H18C18.6 22 19.2 21.8 19.6 21.5L20.8 22.7L22.1 21.5M18 20H6C5.4 20 5 19.6 5 19C5 18.8 5.1 18.6 5.2 18.4L9 11.9L14 17L14.6 16.4L18 20C18.1 20 18 20 18 20M8 4.8V4C8 2.9 8.9 2 10 2H14C15.1 2 16 2.9 16 4V5C16 5.6 15.6 6 15 6V7.8L20.4 17.2L8 4.8Z";
var mdiFlaskOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L7.9 9.8L3.5 17.4C3.2 17.8 3 18.4 3 19C3 20.7 4.3 22 6 22H18C18.6 22 19.2 21.8 19.6 21.5L20.8 22.7L22.1 21.5M18 20H6C5.4 20 5 19.6 5 19C5 18.8 5.1 18.6 5.2 18.4L9.4 11.2L13.6 15.4L13 16L10.4 13.4L7.7 18H16.1L18 20C18.1 20 18 20 18 20M11 7.8L8 4.8V4C8 2.9 8.9 2 10 2H14C15.1 2 16 2.9 16 4V5C16 5.6 15.6 6 15 6V7.8L20.4 17.2L15 11.8L13 8.4V4H11V7.8Z";
var mdiFlaskOutline = "M5,19A1,1 0 0,0 6,20H18A1,1 0 0,0 19,19C19,18.79 18.93,18.59 18.82,18.43L13,8.35V4H11V8.35L5.18,18.43C5.07,18.59 5,18.79 5,19M6,22A3,3 0 0,1 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6A1,1 0 0,1 8,5V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V5A1,1 0 0,1 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19A3,3 0 0,1 18,22H6M13,16L14.34,14.66L16.27,18H7.73L10.39,13.39L13,16M12.5,12A0.5,0.5 0 0,1 13,12.5A0.5,0.5 0 0,1 12.5,13A0.5,0.5 0 0,1 12,12.5A0.5,0.5 0 0,1 12.5,12Z";
var mdiFlaskPlus = "M18 14H20V17H23V19H20V22H18V19H15V17H18V14M6 22C4.34 22 3 20.66 3 19C3 18.4 3.18 17.84 3.5 17.36L9 7.81V6C8.45 6 8 5.55 8 5V4C8 2.9 8.9 2 10 2H14C15.11 2 16 2.9 16 4V5C16 5.55 15.55 6 15 6V7.81L17.5 12.18C15.5 12.7 13.86 14.26 13.26 16.26L8.93 11.93L5.18 18.43C5.07 18.59 5 18.79 5 19C5 19.55 5.45 20 6 20H13.34C13.61 20.75 14 21.42 14.53 22H6M13 10C12.45 10 12 10.45 12 11C12 11.55 12.45 12 13 12C13.55 12 14 11.55 14 11C14 10.45 13.55 10 13 10Z";
var mdiFlaskPlusOutline = "M18 14H20V17H23V19H20V22H18V19H15V17H18V14M5 19C5 19.55 5.45 20 6 20H13.34C13.61 20.75 14 21.42 14.53 22H6C4.34 22 3 20.66 3 19C3 18.4 3.18 17.84 3.5 17.36L9 7.81V6C8.45 6 8 5.55 8 5V4C8 2.9 8.9 2 10 2H14C15.11 2 16 2.9 16 4V5C16 5.55 15.55 6 15 6V7.81L17.5 12.18C16.86 12.35 16.24 12.63 15.69 13L13 8.35V4H11V8.35L5.18 18.43C5.07 18.59 5 18.79 5 19M13 16L13.58 15.42C13.21 16.2 13 17.08 13 18H7.73L10.39 13.39L13 16M12.5 12C12.78 12 13 12.22 13 12.5C13 12.78 12.78 13 12.5 13C12.22 13 12 12.78 12 12.5C12 12.22 12.22 12 12.5 12Z";
var mdiFlaskRemove = "M15.46 15.88L16.88 14.46L19 16.59L21.12 14.47L22.53 15.88L20.41 18L22.54 20.12L21.12 21.54L19 19.41L16.88 21.53L15.47 20.12L17.59 18L15.46 15.88M6 22C4.34 22 3 20.66 3 19C3 18.4 3.18 17.84 3.5 17.36L9 7.81V6C8.45 6 8 5.55 8 5V4C8 2.9 8.9 2 10 2H14C15.11 2 16 2.9 16 4V5C16 5.55 15.55 6 15 6V7.81L17.5 12.18C15.5 12.7 13.86 14.26 13.26 16.26L8.93 11.93L5.18 18.43C5.07 18.59 5 18.79 5 19C5 19.55 5.45 20 6 20H13.34C13.61 20.75 14 21.42 14.53 22H6M13 10C12.45 10 12 10.45 12 11C12 11.55 12.45 12 13 12C13.55 12 14 11.55 14 11C14 10.45 13.55 10 13 10Z";
var mdiFlaskRemoveOutline = "M15.46 15.88L16.88 14.46L19 16.59L21.12 14.47L22.53 15.88L20.41 18L22.54 20.12L21.12 21.54L19 19.41L16.88 21.53L15.47 20.12L17.59 18L15.46 15.88M5 19C5 19.55 5.45 20 6 20H13.34C13.61 20.75 14 21.42 14.53 22H6C4.34 22 3 20.66 3 19C3 18.4 3.18 17.84 3.5 17.36L9 7.81V6C8.45 6 8 5.55 8 5V4C8 2.9 8.9 2 10 2H14C15.11 2 16 2.9 16 4V5C16 5.55 15.55 6 15 6V7.81L17.5 12.18C16.86 12.35 16.24 12.63 15.69 13L13 8.35V4H11V8.35L5.18 18.43C5.07 18.59 5 18.79 5 19M13 16L13.58 15.42C13.21 16.2 13 17.08 13 18H7.73L10.39 13.39L13 16M12.5 12C12.78 12 13 12.22 13 12.5C13 12.78 12.78 13 12.5 13C12.22 13 12 12.78 12 12.5C12 12.22 12.22 12 12.5 12Z";
var mdiFlaskRoundBottom = "M19 15C19 18.87 15.87 22 12 22C8.13 22 5 18.87 5 15C5 12.21 6.64 9.8 9 8.67V5C9 4.45 9.45 4 10 4H10.5L9.5 2H14.5L13.5 4H14C14.55 4 15 4.45 15 5V8.67C17.36 9.8 19 12.21 19 15M11 6V10.1C8.72 10.56 7 12.58 7 15L7.08 15.91L9 13.93L13.07 18L16.93 14.14C16.58 12.12 15 10.5 13 10.1V6H11M13.07 12C13.62 12 14.07 12.45 14.07 13C14.07 13.55 13.62 14 13.07 14C12.5 14 12.07 13.55 12.07 13C12.07 12.45 12.5 12 13.07 12Z";
var mdiFlaskRoundBottomEmpty = "M19 15C19 18.87 15.87 22 12 22C8.13 22 5 18.87 5 15C5 12.21 6.64 9.8 9 8.67V5C9 4.45 9.45 4 10 4H10.5L9.5 2H14.5L13.5 4H14C14.55 4 15 4.45 15 5V8.67C17.36 9.8 19 12.21 19 15Z";
var mdiFlaskRoundBottomEmptyOutline = "M19 15C19 18.87 15.87 22 12 22C8.13 22 5 18.87 5 15C5 12.21 6.64 9.8 9 8.67V5C9 4.45 9.45 4 10 4H10.5L9.5 2H14.5L13.5 4H14C14.55 4 15 4.45 15 5V8.67C17.36 9.8 19 12.21 19 15M11 6V10.1C8.72 10.56 7 12.58 7 15C7 17.76 9.24 20 12 20C14.76 20 17 17.76 17 15C17 12.58 15.28 10.56 13 10.1V6H11Z";
var mdiFlaskRoundBottomOutline = "M15 15C15 16.66 13.66 18 12 18C10.34 18 9 16.66 9 15V14H11V15C11 15.55 11.45 16 12 16C12.55 16 13 15.55 13 15V14H15V15M19 15C19 18.87 15.87 22 12 22C8.13 22 5 18.87 5 15C5 12.21 6.64 9.8 9 8.67V5C9 4.45 9.45 4 10 4H10.5L9.5 2H14.5L13.5 4H14C14.55 4 15 4.45 15 5V8.67C17.36 9.8 19 12.21 19 15M11 6V10.1C8.72 10.56 7 12.58 7 15C7 17.76 9.24 20 12 20C14.76 20 17 17.76 17 15C17 12.58 15.28 10.56 13 10.1V6H11Z";
var mdiFleurDeLis = "M12 2S9 4 9 7 11 12 11 16H10S10 14 9 12C7 8 3 10 3 13S5 16 5 16C5 13 8.5 13 8.5 16H7V18H10.5L9 20S10 21 11 20L12 22L13 20C14 21 15 20 15 20L13.5 18H17V16H15.5C15.5 13 19 13 19 16C19 16 21 16 21 13S17 8 15 12C14 14 14 16 14 16H13C13 12 15 10 15 7S12 2 12 2Z";
var mdiFlipHorizontal = "M15 21H17V19H15M19 9H21V7H19M3 5V19C3 20.1 3.9 21 5 21H9V19H5V5H9V3H5C3.9 3 3 3.9 3 5M19 3V5H21C21 3.9 20.1 3 19 3M11 23H13V1H11M19 17H21V15H19M15 5H17V3H15M19 13H21V11H19M19 21C20.1 21 21 20.1 21 19H19Z";
var mdiFlipToBack = "M15,17H17V15H15M15,5H17V3H15M5,7H3V19A2,2 0 0,0 5,21H17V19H5M19,17A2,2 0 0,0 21,15H19M19,9H21V7H19M19,13H21V11H19M9,17V15H7A2,2 0 0,0 9,17M13,3H11V5H13M19,3V5H21C21,3.89 20.1,3 19,3M13,15H11V17H13M9,3C7.89,3 7,3.89 7,5H9M9,11H7V13H9M9,7H7V9H9V7Z";
var mdiFlipToFront = "M7,21H9V19H7M11,21H13V19H11M19,15H9V5H19M19,3H9C7.89,3 7,3.89 7,5V15A2,2 0 0,0 9,17H14L18,17H19A2,2 0 0,0 21,15V5C21,3.89 20.1,3 19,3M15,21H17V19H15M3,9H5V7H3M5,21V19H3A2,2 0 0,0 5,21M3,17H5V15H3M3,13H5V11H3V13Z";
var mdiFlipVertical = "M3 15V17H5V15M15 19V21H17V19M19 3H5C3.9 3 3 3.9 3 5V9H5V5H19V9H21V5C21 3.9 20.1 3 19 3M21 19H19V21C20.1 21 21 20.1 21 19M1 11V13H23V11M7 19V21H9V19M19 15V17H21V15M11 19V21H13V19M3 19C3 20.1 3.9 21 5 21V19Z";
var mdiFloorLamp = "M15,2L17,9H7L9,2M11,10H13V20H16V22H8V20H11V10Z";
var mdiFloorLampDual = "M11.73 10.06L10.17 11.24L11 12.2V20H8V22H16V20H13V12.3L13.85 11.26L12.27 10.07L11.73 10.06M9.08 10.82L3 6.81L9.39 2L11.55 8.93L9.08 10.82M14.61 2L21 6.81L14.92 10.82L12.44 8.95L14.61 2Z";
var mdiFloorLampDualOutline = "M11.73 10.06L10.17 11.24L11 12.2V20H8V22H16V20H13V12.3L13.85 11.26L12.27 10.07L11.73 10.06M8.32 5.31L9.23 8.19L9 8.37L6.47 6.7L8.32 5.31M9.39 2L3 6.81L9.08 10.82L11.55 8.93L9.39 2M15.67 5.3L17.53 6.7L15 8.37L14.77 8.2L15.67 5.3M14.61 2L12.44 8.95L14.92 10.82L21 6.81L14.61 2Z";
var mdiFloorLampOutline = "M15 2L17 9H7L9 2M13.6 4H10.4L9.55 7H14.45M11 10H13V20H16V22H8V20H11Z";
var mdiFloorLampTorchiere = "M7 2L10 9H14L17 2H7M13 20H16V22H8V20H11V10H13V20Z";
var mdiFloorLampTorchiereOutline = "M14 4L12.7 7H11.3L10 4H14M17 2H7L10 9H14L17 2M13 20H16V22H8V20H11V10H13V20Z";
var mdiFloorLampTorchiereVariant = "M7 2L10 9H14L17 2H7M15.92 22L13 15V22H11V15L8.08 22H5.92L10.92 10H13.08L18.08 22H15.92Z";
var mdiFloorLampTorchiereVariantOutline = "M13.97 4L12.68 7H11.32L10.03 4H13.97M17 2H7L10 9H14L17 2M15.92 22L13 15V22H11V15L8.08 22H5.92L10.92 10H13.08L18.08 22H15.92Z";
var mdiFloorPlan = "M10,5V10H9V5H5V13H9V12H10V17H9V14H5V19H12V17H13V19H19V17H21V21H3V3H21V15H19V10H13V15H12V9H19V5H10Z";
var mdiFloppy = "M5,3A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5.5L18.5,3H17V9A1,1 0 0,1 16,10H8A1,1 0 0,1 7,9V3H5M12,4V9H15V4H12M7,12H17A1,1 0 0,1 18,13V19H6V13A1,1 0 0,1 7,12Z";
var mdiFloppyVariant = "M3,3V21H21V3H3M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,15A1,1 0 0,1 13,16V19A1,1 0 0,1 12,20A1,1 0 0,1 11,19V16A1,1 0 0,1 12,15Z";
var mdiFlower = "M3,13A9,9 0 0,0 12,22C12,17 7.97,13 3,13M12,5.5A2.5,2.5 0 0,1 14.5,8A2.5,2.5 0 0,1 12,10.5A2.5,2.5 0 0,1 9.5,8A2.5,2.5 0 0,1 12,5.5M5.6,10.25A2.5,2.5 0 0,0 8.1,12.75C8.63,12.75 9.12,12.58 9.5,12.31C9.5,12.37 9.5,12.43 9.5,12.5A2.5,2.5 0 0,0 12,15A2.5,2.5 0 0,0 14.5,12.5C14.5,12.43 14.5,12.37 14.5,12.31C14.88,12.58 15.37,12.75 15.9,12.75C17.28,12.75 18.4,11.63 18.4,10.25C18.4,9.25 17.81,8.4 16.97,8C17.81,7.6 18.4,6.74 18.4,5.75C18.4,4.37 17.28,3.25 15.9,3.25C15.37,3.25 14.88,3.41 14.5,3.69C14.5,3.63 14.5,3.56 14.5,3.5A2.5,2.5 0 0,0 12,1A2.5,2.5 0 0,0 9.5,3.5C9.5,3.56 9.5,3.63 9.5,3.69C9.12,3.41 8.63,3.25 8.1,3.25A2.5,2.5 0 0,0 5.6,5.75C5.6,6.74 6.19,7.6 7.03,8C6.19,8.4 5.6,9.25 5.6,10.25M12,22A9,9 0 0,0 21,13C16,13 12,17 12,22Z";
var mdiFlowerOutline = "M8.66,13.07C6.92,13.07 5.5,11.66 5.5,9.93C5.5,9.22 5.76,8.54 6.19,8C5.77,7.46 5.5,6.78 5.5,6.07C5.5,4.34 6.93,2.93 8.66,2.93L9.09,2.96C9.56,1.81 10.69,1 12,1C13.31,1 14.44,1.81 14.91,2.96L15.34,2.93C17.07,2.93 18.5,4.34 18.5,6.07C18.5,6.78 18.24,7.46 17.81,8C18.23,8.54 18.5,9.22 18.5,9.93C18.5,11.66 17.07,13.07 15.34,13.07L14.91,13.04C14.44,14.19 13.31,15 12,15C10.69,15 9.56,14.19 9.09,13.04L8.66,13.07M12,13C12.62,13 13.12,12.5 13.14,11.9L13.03,10.81C12.71,10.93 12.36,11 12,11C11.64,11 11.3,10.93 11,10.81L10.86,11.9C10.88,12.5 11.38,13 12,13M15.34,11.07C15.97,11.07 16.5,10.56 16.5,9.92C16.5,9.5 16.23,9.08 15.83,8.89L14.95,8.47C14.83,9.21 14.44,9.85 13.89,10.3L14.7,10.87C14.88,11 15.1,11.07 15.34,11.07M14.69,5.13L13.87,5.69C14.43,6.14 14.82,6.78 14.94,7.5L15.82,7.1C16.23,6.9 16.5,6.5 16.5,6.07C16.5,5.44 15.97,4.93 15.34,4.93C15.11,4.93 14.89,5 14.69,5.13M12,3C11.38,3 10.88,3.5 10.86,4.1L11,5.19C11.3,5.07 11.64,5 12,5C12.36,5 12.71,5.07 13.03,5.19L13.14,4.1C13.12,3.5 12.62,3 12,3M8.66,4.93C8.03,4.93 7.5,5.44 7.5,6.07C7.5,6.5 7.77,6.9 8.17,7.1L9.05,7.5C9.17,6.78 9.56,6.14 10.11,5.69L9.3,5.13C9.12,5 8.9,4.93 8.66,4.93M8.17,8.9C7.77,9.1 7.5,9.5 7.5,9.92C7.5,10.55 8.03,11.06 8.66,11.06C8.89,11.06 9.11,11 9.31,10.86L10.12,10.31C9.56,9.86 9.17,9.22 9.05,8.5L8.17,8.9M12,22A9,9 0 0,1 3,13A9,9 0 0,1 12,22A9,9 0 0,1 21,13A9,9 0 0,1 12,22M14.44,19.56C16.34,18.85 17.85,17.34 18.56,15.44C16.66,16.14 15.15,17.66 14.44,19.56M5.44,15.44C6.15,17.34 7.66,18.85 9.56,19.56C8.86,17.66 7.34,16.15 5.44,15.44Z";
var mdiFlowerPollen = "M18.4 12.75C18.4 11.37 17.28 10.25 15.9 10.25C15.37 10.25 14.88 10.41 14.5 10.69V10.5C14.5 9.12 13.38 8 12 8S9.5 9.12 9.5 10.5V10.69C9.12 10.41 8.63 10.25 8.1 10.25C6.72 10.25 5.6 11.37 5.6 12.75C5.6 13.74 6.19 14.6 7.03 15C6.19 15.4 5.6 16.25 5.6 17.25C5.6 18.63 6.72 19.75 8.1 19.75C8.63 19.75 9.12 19.58 9.5 19.31V19.5C9.5 20.88 10.62 22 12 22S14.5 20.88 14.5 19.5V19.31C14.88 19.58 15.37 19.75 15.9 19.75C17.28 19.75 18.4 18.63 18.4 17.25C18.4 16.25 17.81 15.4 16.97 15C17.81 14.6 18.4 13.74 18.4 12.75M12 17.5C10.62 17.5 9.5 16.38 9.5 15S10.62 12.5 12 12.5 14.5 13.62 14.5 15 13.38 17.5 12 17.5M11 6C11 5.45 11.45 5 12 5S13 5.45 13 6 12.55 7 12 7 11 6.55 11 6M7 8C7 7.45 7.45 7 8 7S9 7.45 9 8 8.55 9 8 9 7 8.55 7 8M5 6C4.45 6 4 5.55 4 5S4.45 4 5 4 6 4.45 6 5 5.55 6 5 6M8 3C8 2.45 8.45 2 9 2S10 2.45 10 3 9.55 4 9 4 8 3.55 8 3M14 3C14 2.45 14.45 2 15 2S16 2.45 16 3 15.55 4 15 4 14 3.55 14 3M20 5C20 5.55 19.55 6 19 6S18 5.55 18 5 18.45 4 19 4 20 4.45 20 5M16 7C16.55 7 17 7.45 17 8S16.55 9 16 9 15 8.55 15 8 15.45 7 16 7Z";
var mdiFlowerPollenOutline = "M11 6C11 5.45 11.45 5 12 5S13 5.45 13 6 12.55 7 12 7 11 6.55 11 6M8 9C8.55 9 9 8.55 9 8S8.55 7 8 7 7 7.45 7 8 7.45 9 8 9M6 5C6 4.45 5.55 4 5 4S4 4.45 4 5 4.45 6 5 6 6 5.55 6 5M9 4C9.55 4 10 3.55 10 3S9.55 2 9 2 8 2.45 8 3 8.45 4 9 4M15 4C15.55 4 16 3.55 16 3S15.55 2 15 2 14 2.45 14 3 14.45 4 15 4M19 4C18.45 4 18 4.45 18 5S18.45 6 19 6 20 5.55 20 5 19.55 4 19 4M15 8C15 8.55 15.45 9 16 9S17 8.55 17 8 16.55 7 16 7 15 7.45 15 8M18.5 13.07C18.5 13.78 18.24 14.46 17.81 15C18.23 15.54 18.5 16.22 18.5 16.93C18.5 18.66 17.07 20.07 15.34 20.07L14.91 20.04C14.44 21.19 13.31 22 12 22S9.56 21.19 9.09 20.04L8.66 20.07C6.92 20.07 5.5 18.66 5.5 16.93C5.5 16.22 5.76 15.54 6.19 15C5.77 14.46 5.5 13.78 5.5 13.07C5.5 11.34 6.93 9.93 8.66 9.93L9.09 9.96C9.56 8.81 10.69 8 12 8S14.44 8.81 14.91 9.96L15.34 9.93C17.07 9.93 18.5 11.34 18.5 13.07M7.5 13.07C7.5 13.5 7.77 13.9 8.17 14.1L9.05 14.5C9.17 13.78 9.56 13.14 10.11 12.69L9.3 12.13C9.12 12 8.9 11.93 8.66 11.93C8.03 11.93 7.5 12.44 7.5 13.07M10.12 17.31C9.56 16.86 9.17 16.22 9.05 15.5L8.17 15.9C7.77 16.1 7.5 16.5 7.5 16.92C7.5 17.55 8.03 18.06 8.66 18.06C8.89 18.06 9.11 18 9.31 17.86L10.12 17.31M13.14 18.9L13.03 17.81C12.71 17.93 12.36 18 12 18S11.3 17.93 11 17.81L10.86 18.9C10.88 19.5 11.38 20 12 20S13.12 19.5 13.14 18.9M13.14 11.1C13.12 10.5 12.62 10 12 10S10.88 10.5 10.86 11.1L11 12.19C11.3 12.07 11.64 12 12 12S12.71 12.07 13.03 12.19L13.14 11.1M16.5 16.92C16.5 16.5 16.23 16.08 15.83 15.89L14.95 15.47C14.83 16.21 14.44 16.85 13.89 17.3L14.7 17.87C14.88 18 15.1 18.07 15.34 18.07C15.97 18.07 16.5 17.56 16.5 16.92M16.5 13.07C16.5 12.44 15.97 11.93 15.34 11.93C15.11 11.93 14.89 12 14.69 12.13L13.87 12.69C14.43 13.14 14.82 13.78 14.94 14.5L15.82 14.1C16.23 13.9 16.5 13.5 16.5 13.07Z";
var mdiFlowerPoppy = "M18.5,12A3.5,3.5 0 0,0 22,8.5A6.5,6.5 0 0,0 15.5,2A3.5,3.5 0 0,0 12,5.5A3.5,3.5 0 0,0 8.5,2A6.5,6.5 0 0,0 2,8.5A3.5,3.5 0 0,0 5.5,12A3.5,3.5 0 0,0 2,15.5A6.5,6.5 0 0,0 8.5,22A3.5,3.5 0 0,0 12,18.5A3.5,3.5 0 0,0 15.5,22A6.5,6.5 0 0,0 22,15.5A3.5,3.5 0 0,0 18.5,12M12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16M14.5,12A2.5,2.5 0 0,1 12,14.5A2.5,2.5 0 0,1 9.5,12A2.5,2.5 0 0,1 12,9.5A2.5,2.5 0 0,1 14.5,12Z";
var mdiFlowerTulip = "M3,13A9,9 0 0,0 12,22A9,9 0 0,0 3,13M12,22A9,9 0 0,0 21,13A9,9 0 0,0 12,22M18,3V8A6,6 0 0,1 12,14A6,6 0 0,1 6,8V3C6.74,3 7.47,3.12 8.16,3.39C8.71,3.62 9.2,3.96 9.61,4.39L12,2L14.39,4.39C14.8,3.96 15.29,3.62 15.84,3.39C16.53,3.12 17.26,3 18,3Z";
var mdiFlowerTulipOutline = "M3,13A9,9 0 0,0 12,22A9,9 0 0,0 3,13M5.44,15.44C7.35,16.15 8.85,17.65 9.56,19.56C7.65,18.85 6.15,17.35 5.44,15.44M12,22A9,9 0 0,0 21,13A9,9 0 0,0 12,22M14.42,19.57C15.11,17.64 16.64,16.11 18.57,15.42C17.86,17.34 16.34,18.86 14.42,19.57M12,14A6,6 0 0,0 18,8V3C17.26,3 16.53,3.12 15.84,3.39C15.29,3.62 14.8,3.96 14.39,4.39L12,2L9.61,4.39C9.2,3.96 8.71,3.62 8.16,3.39C7.47,3.12 6.74,3 6,3V8A6,6 0 0,0 12,14M8,5.61L9.57,7.26L12,4.83L14.43,7.26L16,5.61V8A4,4 0 0,1 12,12A4,4 0 0,1 8,8V5.61Z";
var mdiFocusAuto = "M19 19H15V21H19C20.1 21 21 20.1 21 19V15H19M19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3M5 5H9V3H5C3.9 3 3 3.9 3 5V9H5M5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15M8 7C6.9 7 6 7.9 6 9V17H8V13H10V17H12V9C12 7.9 11.1 7 10 7H8M8 9H10V11H8V9M13 7V17H15V13H17V11H15V9H18V7H13Z";
var mdiFocusField = "M19 19H15V21H19C20.1 21 21 20.1 21 19V15H19M19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3M5 5H9V3H5C3.9 3 3 3.9 3 5V9H5M5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15M7 11H9V13H7V11M11 11H13V13H11V11M15 11H17V13H15V11M7 7H9V9H7V7M11 7H13V9H11V7M15 7H17V9H15V7M7 15H9V17H7V15M11 15H13V17H11V15M15 15H17V17H15V15Z";
var mdiFocusFieldHorizontal = "M19 19H15V21H19C20.1 21 21 20.1 21 19V15H19M19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3M5 5H9V3H5C3.9 3 3 3.9 3 5V9H5M5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15M7 11H9V13H7V11M11 11H13V13H11V11M15 11H17V13H15V11Z";
var mdiFocusFieldVertical = "M19 19H15V21H19C20.1 21 21 20.1 21 19V15H19M19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3M5 5H9V3H5C3.9 3 3 3.9 3 5V9H5M5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15M11 11H13V13H11V11M11 7H13V9H11V7M11 15H13V17H11V15Z";
var mdiFolder = "M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z";
var mdiFolderAccount = "M19,17H11V16C11,14.67 13.67,14 15,14C16.33,14 19,14.67 19,16M15,9A2,2 0 0,1 17,11A2,2 0 0,1 15,13A2,2 0 0,1 13,11C13,9.89 13.9,9 15,9M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z";
var mdiFolderAccountOutline = "M15 14C16.33 14 19 14.67 19 16V17H11V16C11 14.67 13.67 14 15 14M15 13C16.11 13 17 12.11 17 11S16.11 9 15 9C13.9 9 13 9.89 13 11C13 12.11 13.9 13 15 13M22 8V18C22 19.11 21.11 20 20 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H10L12 6H20C21.11 6 22 6.9 22 8M20 8H4V18H20V8Z";
var mdiFolderAlert = "M15,12H17V17H15V12M15,18H17V20H15V18M23,16A7,7 0 0,1 16,23C13.62,23 11.5,21.81 10.25,20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H9L11,6H19A2,2 0 0,1 21,8V11.1C22.24,12.36 23,14.09 23,16M16,11A5,5 0 0,0 11,16A5,5 0 0,0 16,21A5,5 0 0,0 21,16A5,5 0 0,0 16,11Z";
var mdiFolderAlertOutline = "M15,12H17V17H15V12M15,18H17V20H15V18M16,9C17.07,9 18.09,9.24 19,9.67V8H3V18H9.29C9.1,17.36 9,16.69 9,16A7,7 0 0,1 16,9M23,16A7,7 0 0,1 16,23C13.62,23 11.5,21.81 10.25,20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H9L11,6H19A2,2 0 0,1 21,8V11.1C22.24,12.36 23,14.09 23,16M16,11A5,5 0 0,0 11,16A5,5 0 0,0 16,21A5,5 0 0,0 21,16A5,5 0 0,0 16,11Z";
var mdiFolderArrowDown = "M22 8V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8M20 16H18V20H16L19 23L22 20H20V16Z";
var mdiFolderArrowDownOutline = "M22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8M20 16H18V20H16L19 23L22 20H20V16Z";
var mdiFolderArrowLeft = "M22 8V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8M18 16L15 19L18 22V20H22V18H18V16Z";
var mdiFolderArrowLeftOutline = "M22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8M18 16L15 19L18 22V20H22V18H18V16Z";
var mdiFolderArrowLeftRight = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M23 17L20 14.5V16H16V18H20V19.5L23 17M18 18.5L15 21L18 23.5V22H22V20H18V18.5Z";
var mdiFolderArrowLeftRightOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19M23 17L20 14.5V16H16V18H20V19.5L23 17M18 18.5L15 21L18 23.5V22H22V20H18V18.5Z";
var mdiFolderArrowRight = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M23 19L20 16V18H16V20H20V22L23 19Z";
var mdiFolderArrowRightOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19M23 19L20 16V18H16V20H20V22L23 19Z";
var mdiFolderArrowUp = "M22 8V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8M16 18H18V22H20V18H22L19 15L16 18Z";
var mdiFolderArrowUpDown = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M17 15L14.5 18H16V22H18V18H19.5L17 15M22 20V16H20V20H18.5L21 23L23.5 20H22Z";
var mdiFolderArrowUpDownOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19M22 20V16H20V20H18.5L21 23L23.5 20H22M17 15L14.5 18H16V22H18V18H19.5L17 15Z";
var mdiFolderArrowUpOutline = "M22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8M16 18H18V22H20V18H22L19 15L16 18Z";
var mdiFolderCancel = "M12 18.5C12 19 12.07 19.5 12.18 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.04C21 12.39 19.79 12 18.5 12C14.91 12 12 14.91 12 18.5M23 18.5C23 21 21 23 18.5 23S14 21 14 18.5 16 14 18.5 14 23 16 23 18.5M20 21.08L15.92 17C15.65 17.42 15.5 17.94 15.5 18.5C15.5 20.16 16.84 21.5 18.5 21.5C19.06 21.5 19.58 21.35 20 21.08M21.5 18.5C21.5 16.84 20.16 15.5 18.5 15.5C17.94 15.5 17.42 15.65 17 15.92L21.08 20C21.35 19.58 21.5 19.06 21.5 18.5Z";
var mdiFolderCancelOutline = "M12 18.5C12 19 12.07 19.5 12.18 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.04C21.39 12.65 20.72 12.36 20 12.18V8H4V18H12.03C12 18.17 12 18.33 12 18.5M23 18.5C23 21 21 23 18.5 23S14 21 14 18.5 16 14 18.5 14 23 16 23 18.5M20 21.08L15.92 17C15.65 17.42 15.5 17.94 15.5 18.5C15.5 20.16 16.84 21.5 18.5 21.5C19.06 21.5 19.58 21.35 20 21.08M21.5 18.5C21.5 16.84 20.16 15.5 18.5 15.5C17.94 15.5 17.42 15.65 17 15.92L21.08 20C21.35 19.58 21.5 19.06 21.5 18.5Z";
var mdiFolderCheck = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiFolderCheckOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiFolderClock = "M3,4C1.89,4 1,4.89 1,6V18A2,2 0 0,0 3,20H10.26C11.57,21.88 13.71,23 16,23A7,7 0 0,0 23,16C23,14.17 22.28,12.42 21,11.11V8C21,6.89 20.1,6 19,6H11L9,4H3M16,11A5,5 0 0,1 21,16A5,5 0 0,1 16,21A5,5 0 0,1 11,16A5,5 0 0,1 16,11M15,12V17L18.61,19.16L19.36,17.94L16.5,16.25V12H15Z";
var mdiFolderClockOutline = "M15,12H16.5V16.25L19.36,17.94L18.61,19.16L15,17V12M19,8H3V18H9.29C9.1,17.37 9,16.7 9,16A7,7 0 0,1 16,9C17.07,9 18.09,9.24 19,9.67V8M3,20C1.89,20 1,19.1 1,18V6A2,2 0 0,1 3,4H9L11,6H19A2,2 0 0,1 21,8V11.1C22.24,12.36 23,14.09 23,16A7,7 0 0,1 16,23C13.62,23 11.5,21.81 10.25,20H3M16,11A5,5 0 0,0 11,16A5,5 0 0,0 16,21A5,5 0 0,0 21,16A5,5 0 0,0 16,11Z";
var mdiFolderCog = "M4 4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H12.08A7 7 0 0 1 12 19A7 7 0 0 1 19 12A7 7 0 0 1 22 12.69V8C22 6.89 21.1 6 20 6H12L10 4H4M18 14C17.87 14 17.76 14.09 17.74 14.21L17.55 15.53C17.25 15.66 16.96 15.82 16.7 16L15.46 15.5C15.35 15.5 15.22 15.5 15.15 15.63L14.15 17.36C14.09 17.47 14.11 17.6 14.21 17.68L15.27 18.5C15.25 18.67 15.24 18.83 15.24 19C15.24 19.17 15.25 19.33 15.27 19.5L14.21 20.32C14.12 20.4 14.09 20.53 14.15 20.64L15.15 22.37C15.21 22.5 15.34 22.5 15.46 22.5L16.7 22C16.96 22.18 17.24 22.35 17.55 22.47L17.74 23.79C17.76 23.91 17.86 24 18 24H20C20.11 24 20.22 23.91 20.24 23.79L20.43 22.47C20.73 22.34 21 22.18 21.27 22L22.5 22.5C22.63 22.5 22.76 22.5 22.83 22.37L23.83 20.64C23.89 20.53 23.86 20.4 23.77 20.32L22.7 19.5C22.72 19.33 22.74 19.17 22.74 19C22.74 18.83 22.73 18.67 22.7 18.5L23.76 17.68C23.85 17.6 23.88 17.47 23.82 17.36L22.82 15.63C22.76 15.5 22.63 15.5 22.5 15.5L21.27 16C21 15.82 20.73 15.65 20.42 15.53L20.23 14.21C20.22 14.09 20.11 14 20 14H18M19 17.5C19.83 17.5 20.5 18.17 20.5 19C20.5 19.83 19.83 20.5 19 20.5C18.16 20.5 17.5 19.83 17.5 19C17.5 18.17 18.17 17.5 19 17.5Z";
var mdiFolderCogOutline = "M4 4C2.89 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H12V18H4V8H20V12H22V8C22 6.89 21.1 6 20 6H12L10 4M18 14C17.87 14 17.76 14.09 17.74 14.21L17.55 15.53C17.25 15.66 16.96 15.82 16.7 16L15.46 15.5C15.35 15.5 15.22 15.5 15.15 15.63L14.15 17.36C14.09 17.47 14.11 17.6 14.21 17.68L15.27 18.5C15.25 18.67 15.24 18.83 15.24 19C15.24 19.17 15.25 19.33 15.27 19.5L14.21 20.32C14.12 20.4 14.09 20.53 14.15 20.64L15.15 22.37C15.21 22.5 15.34 22.5 15.46 22.5L16.7 22C16.96 22.18 17.24 22.35 17.55 22.47L17.74 23.79C17.76 23.91 17.86 24 18 24H20C20.11 24 20.22 23.91 20.24 23.79L20.43 22.47C20.73 22.34 21 22.18 21.27 22L22.5 22.5C22.63 22.5 22.76 22.5 22.83 22.37L23.83 20.64C23.89 20.53 23.86 20.4 23.77 20.32L22.7 19.5C22.72 19.33 22.74 19.17 22.74 19C22.74 18.83 22.73 18.67 22.7 18.5L23.76 17.68C23.85 17.6 23.88 17.47 23.82 17.36L22.82 15.63C22.76 15.5 22.63 15.5 22.5 15.5L21.27 16C21 15.82 20.73 15.65 20.42 15.53L20.23 14.21C20.22 14.09 20.11 14 20 14M19 17.5C19.83 17.5 20.5 18.17 20.5 19C20.5 19.83 19.83 20.5 19 20.5C18.16 20.5 17.5 19.83 17.5 19C17.5 18.17 18.17 17.5 19 17.5Z";
var mdiFolderDownload = "M20,6A2,2 0 0,1 22,8V18A2,2 0 0,1 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H20M19.25,13H16V9H14V13H10.75L15,17.25";
var mdiFolderDownloadOutline = "M20 18H4V8H20M20 6H12L10 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8A2 2 0 0 0 20 6M14 9H16V13H19L15 17L11 13H14Z";
var mdiFolderEdit = "M19.39 10.74L11 19.13V20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V10.15C21.74 10.06 21.46 10 21.17 10C20.5 10 19.87 10.26 19.39 10.74M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47Z";
var mdiFolderEditOutline = "M4 18H12.13L11 19.13V20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V10.15C21.74 10.06 21.46 10 21.17 10C20.75 10 20.36 10.11 20 10.3V8H4V18M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96Z";
var mdiFolderEye = "M9.3 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H10L12 6H20C21.1 6 22 6.9 22 8V14.6C20.6 13.6 18.9 13 17 13C13.5 13 10.4 15.1 9.1 18.3L8.8 19L9.1 19.7C9.2 19.8 9.2 19.9 9.3 20M23 19C22.1 21.3 19.7 23 17 23S11.9 21.3 11 19C11.9 16.7 14.3 15 17 15S22.1 16.7 23 19M19.5 19C19.5 17.6 18.4 16.5 17 16.5S14.5 17.6 14.5 19 15.6 21.5 17 21.5 19.5 20.4 19.5 19M17 18C16.4 18 16 18.4 16 19S16.4 20 17 20 18 19.6 18 19 17.6 18 17 18";
var mdiFolderEyeOutline = "M9.3 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H10L12 6H20C21.1 6 22 6.9 22 8V14.6C21.4 14.2 20.7 13.8 20 13.5V8H4V18H9.3C9.3 18.1 9.2 18.2 9.2 18.3L8.8 19L9.1 19.7C9.2 19.8 9.2 19.9 9.3 20M23 19C22.1 21.3 19.7 23 17 23S11.9 21.3 11 19C11.9 16.7 14.3 15 17 15S22.1 16.7 23 19M19.5 19C19.5 17.6 18.4 16.5 17 16.5S14.5 17.6 14.5 19 15.6 21.5 17 21.5 19.5 20.4 19.5 19M17 18C16.4 18 16 18.4 16 19S16.4 20 17 20 18 19.6 18 19 17.6 18 17 18";
var mdiFolderFile = "M15 8C12.79 8 11 9.79 11 12V20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V10.17L20.41 8.59L19.83 8H15M23 14V21C23 22.11 22.11 23 21 23H15C13.9 23 13 22.11 13 21V12C13 10.9 13.9 10 15 10H19L23 14M21 14.83L18.17 12H18V15H21V14.83Z";
var mdiFolderFileOutline = "M4 18H11V20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V10.17L20.41 8.59L20 8.17V8H4V18M23 14V21C23 22.11 22.11 23 21 23H15C13.9 23 13 22.11 13 21V12C13 10.9 13.9 10 15 10H19L23 14M21 15H18V12H15V21H21V15Z";
var mdiFolderGoogleDrive = "M13.75,9H16.14L19,14H16.05L13.5,9.46M18.3,17H12.75L14.15,14.5H19.27L19.53,14.96M11.5,17L10.4,14.86L13.24,9.9L14.74,12.56L12.25,17M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z";
var mdiFolderHeart = "M20 6H12L10 4H4C2.89 4 2 4.89 2 6V18C2 19.1 2.89 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6M18.42 13.5L15 17L11.59 13.5C11.22 13.12 11 12.62 11 12.05C11 10.92 11.9 10 13 10C13.54 10 14.05 10.23 14.42 10.61L15 11.2L15.59 10.6C15.95 10.23 16.46 10 17 10C18.1 10 19 10.92 19 12.05C19 12.61 18.78 13.13 18.42 13.5Z";
var mdiFolderHeartOutline = "M20 18H4V8H20M20 6H12L10 4H4C2.89 4 2 4.89 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.89 21.1 6 20 6M13 10C11.9 10 11 10.92 11 12.05C11 12.62 11.22 13.12 11.59 13.5L15 17L18.42 13.5C18.78 13.13 19 12.61 19 12.05C19 10.92 18.1 10 17 10C16.46 10 15.95 10.23 15.59 10.6L15 11.2L14.42 10.61C14.05 10.23 13.54 10 13 10Z";
var mdiFolderHidden = "M9 4V8H6V4H9M4 16V13H2V16H4M2 12H4V9H2V12M18 8H22C22 6.89 21.1 6 20 6H18V8M22 13H20V16H22V13M20 9V12H22V9H20M9 20V18H6V20H9M5 18H4V17H2V18C2 19.11 2.9 20 4 20H5V18M20 17V18H18V20H20C21.11 20 22 19.11 22 18V17H20M4 8H5V4H4C2.89 4 2 4.89 2 6V8H4M17 18H14V20H17V18M13 18H10V20H13V18M17 6H14V8H17V6M10 8H13V6H12L10 4V8Z";
var mdiFolderHome = "M20 6H12L10 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8A2 2 0 0 0 20 6M17 13V17H15V14H13V17H11V13H9L14 9L19 13Z";
var mdiFolderHomeOutline = "M20 6H12L10 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8A2 2 0 0 0 20 6M20 18H4V8H20M13 17V14H15V17H17V13H19L14 9L9 13H11V17Z";
var mdiFolderImage = "M5,17L9.5,11L13,15.5L15.5,12.5L19,17M20,6H12L10,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8A2,2 0 0,0 20,6Z";
var mdiFolderInformation = "M21 11.1V8C21 6.9 20.1 6 19 6H11L9 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H10.3C11.6 21.9 13.8 23 16 23C19.9 23 23 19.9 23 16C23 14.2 22.3 12.4 21 11.1M16 21C13.2 21 11 18.8 11 16S13.2 11 16 11 21 13.2 21 16 18.8 21 16 21M17 20H15V15H17V20M17 14H15V12H17V14Z";
var mdiFolderInformationOutline = "M21 11.1V8C21 6.9 20.1 6 19 6H11L9 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H10.2C11.4 21.8 13.6 23 16 23C19.9 23 23 19.9 23 16C23 14.1 22.2 12.4 21 11.1M9.3 18H3V8H19V9.7C18.1 9.2 17.1 9 16 9C12.1 9 9 12.1 9 16C9 16.7 9.1 17.4 9.3 18M16 21C13.2 21 11 18.8 11 16S13.2 11 16 11 21 13.2 21 16 18.8 21 16 21M17 14H15V12H17V14M17 20H15V15H17V20Z";
var mdiFolderKey = "M4 4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4M11 10C12.3 10 13.4 10.8 13.8 12H20V14H18V16H16V14H13.8C13.4 15.2 12.3 16 11 16C9.3 16 8 14.7 8 13S9.3 10 11 10M11 12C10.4 12 10 12.4 10 13C10 13.6 10.4 14 11 14C11.6 14 12 13.6 12 13S11.6 12 11 12Z";
var mdiFolderKeyNetwork = "M6 5C4.9 5 4 5.9 4 7V15C4 16.1 4.9 17 6 17H11V19H10C9.4 19 9 19.4 9 20H2V22H9C9 22.6 9.4 23 10 23H14C14.6 23 15 22.6 15 22H22V20H15C15 19.4 14.6 19 14 19H13V17H18C19.1 17 20 16.1 20 15V9C20 7.9 19.1 7 18 7H12L10 5H6M9 9C10.3 9 11.4 9.8 11.8 11H18V13H16V15H14V13H11.8C11.4 14.2 10.3 15 9 15C7.3 15 6 13.7 6 12S7.3 9 9 9M9 11C8.4 11 8 11.4 8 12C8 12.6 8.4 13 9 13C9.6 13 10 12.6 10 12S9.6 11 9 11Z";
var mdiFolderKeyNetworkOutline = "M9 8C7.3 8 6 9.3 6 11S7.3 14 9 14C10.3 14 11.4 13.2 11.8 12H14V14H16V12H18V10H11.8C11.4 8.8 10.3 8 9 8M9 12C8.4 12 8 11.6 8 11S8.4 10 9 10 10 10.4 10 11 9.6 12 9 12M15 20C15 19.5 14.6 19 14 19H13V17H19C20.1 17 21 16.1 21 15V7C21 5.9 20.1 5 19 5H13L11 3H5C3.9 3 3 3.9 3 5V15C3 16.1 3.9 17 5 17H11V19H10C9.4 19 9 19.5 9 20H2V22H9C9 22.5 9.4 23 10 23H14C14.6 23 15 22.5 15 22H22V20H15M5 15V7H19V15H5Z";
var mdiFolderKeyOutline = "M20 18H4V8H20M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6M12.8 12C12.4 10.8 11.3 10 10 10C8.3 10 7 11.3 7 13S8.3 16 10 16C11.3 16 12.4 15.2 12.8 14H15V16H17V14H19V12H12.8M10 14C9.4 14 9 13.6 9 13C9 12.4 9.4 12 10 12S11 12.4 11 13 10.6 14 10 14Z";
var mdiFolderLock = "M13 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V11.04C21.17 10.4 20.13 10 19 10C16.4 10 14.2 12.06 14.2 14.5V14.74C13.5 15.34 13 16.24 13 17.2V20M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiFolderLockOpen = "M14.2 13.5V14.74C13.5 15.34 13 16.24 13 17.2V20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V10.04C21.17 9.4 20.13 9 19 9C16.4 9 14.2 11.06 14.2 13.5M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiFolderLockOpenOutline = "M4 18H13V20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V10.04C21.42 9.6 20.75 9.26 20 9.11V8H4V18M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiFolderLockOutline = "M13 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V11.04C21.42 10.6 20.75 10.26 20 10.11V8H4V18H13V20M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiFolderMarker = "M10 4L12 6H20C21.1 6 22 6.89 22 8V11.34C21.04 10.5 19.82 10 18.5 10C15.5 10 13 12.65 13 15.5C13 16.97 13.65 18.55 14.5 20H4C2.89 20 2 19.1 2 18L2 6C2 4.89 2.89 4 4 4H10M18.5 12C20.4 12 22 13.6 22 15.5C22 18.1 18.5 22 18.5 22C18.5 22 15 18.1 15 15.5C15 13.6 16.6 12 18.5 12M18.5 16.8C19.2 16.8 19.8 16.2 19.7 15.6C19.7 15 19.1 14.4 18.5 14.4C17.9 14.4 17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8Z";
var mdiFolderMarkerOutline = "M18.5 12C20.4 12 22 13.6 22 15.5C22 18.1 18.5 22 18.5 22C18.5 22 15 18.1 15 15.5C15 13.6 16.6 12 18.5 12M18.5 16.8C19.2 16.8 19.8 16.2 19.7 15.6C19.7 15 19.1 14.4 18.5 14.4C17.9 14.4 17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8M20 8H4V18H13.5C13.79 18.68 14.13 19.35 14.5 20H4C2.89 20 2 19.1 2 18L2 6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V11.34C21.42 10.84 20.74 10.45 20 10.23V8Z";
var mdiFolderMinus = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M15 18V20H23V18H15Z";
var mdiFolderMinusOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19M15 18V20H23V18H15Z";
var mdiFolderMove = "M14,18V15H10V11H14V8L19,13M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z";
var mdiFolderMoveOutline = "M20 18H4V8H20V18M12 6L10 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H20C21.11 20 22 19.11 22 18V8C22 6.9 21.11 6 20 6H12M11 14V12H15V9L19 13L15 17V14H11Z";
var mdiFolderMultiple = "M22,4H14L12,2H6A2,2 0 0,0 4,4V16A2,2 0 0,0 6,18H22A2,2 0 0,0 24,16V6A2,2 0 0,0 22,4M2,6H0V11H0V20A2,2 0 0,0 2,22H20V20H2V6Z";
var mdiFolderMultipleImage = "M7,15L11.5,9L15,13.5L17.5,10.5L21,15M22,4H14L12,2H6A2,2 0 0,0 4,4V16A2,2 0 0,0 6,18H22A2,2 0 0,0 24,16V6A2,2 0 0,0 22,4M2,6H0V11H0V20A2,2 0 0,0 2,22H20V20H2V6Z";
var mdiFolderMultipleOutline = "M22,4A2,2 0 0,1 24,6V16A2,2 0 0,1 22,18H6A2,2 0 0,1 4,16V4A2,2 0 0,1 6,2H12L14,4H22M2,6V20H20V22H2A2,2 0 0,1 0,20V11H0V6H2M6,6V16H22V6H6Z";
var mdiFolderMultiplePlus = "M2 20V6H0V20C0 21.1 .9 22 2 22H20V20H2M22 4H14L12 2H6C5.6 2 5.2 2.1 4.9 2.3L4.3 2.9C4.1 3.2 4 3.6 4 4V16C4 16.4 4.1 16.8 4.3 17.1C4.4 17.2 4.5 17.3 4.5 17.4C5 17.8 5.5 18 6 18H22C23.1 18 24 17.1 24 16V6C24 4.9 23.1 4 22 4M22 12H19V15H17V12H14V10H17V7H19V10H22V12Z";
var mdiFolderMultiplePlusOutline = "M22 4C23.1 4 24 4.9 24 6V16C24 17.1 23.1 18 22 18H6C4.9 18 4 17.1 4 16V4C4 2.9 4.9 2 6 2H12L14 4H22M2 6V20H20V22H2C.9 22 0 21.1 0 20V6H2M6 6V16H22V6H6M14 10H16V8H18V10H20V12H18V14H16V12H14V10Z";
var mdiFolderMusic = "M22 8V11H16.5V16.11C14.66 16.53 13.26 18.09 13.04 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8M18.5 13V18.21C18.19 18.07 17.86 18 17.5 18C16.12 18 15 19.12 15 20.5S16.12 23 17.5 23 20 21.88 20 20.5V15H22V13H18.5Z";
var mdiFolderMusicOutline = "M22 8V11H20V8H4V18H13.78C13.38 18.59 13.13 19.26 13.04 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8M18.5 13V18.21C18.19 18.07 17.86 18 17.5 18C16.12 18 15 19.12 15 20.5S16.12 23 17.5 23 20 21.88 20 20.5V15H22V13H18.5Z";
var mdiFolderNetwork = "M3,15V5A2,2 0 0,1 5,3H11L13,5H19A2,2 0 0,1 21,7V15A2,2 0 0,1 19,17H13V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H5A2,2 0 0,1 3,15Z";
var mdiFolderNetworkOutline = "M15 20C15 19.45 14.55 19 14 19H13V17H19C20.11 17 21 16.11 21 15V7C21 5.9 20.11 5 19 5H13L11 3H5C3.9 3 3 3.9 3 5V15C3 16.11 3.9 17 5 17H11V19H10C9.45 19 9 19.45 9 20H2V22H9C9 22.55 9.45 23 10 23H14C14.55 23 15 22.55 15 22H22V20H15M5 15V7H19V15H5Z";
var mdiFolderOff = "M22.11 21.46L20.84 22.73L18.11 20H4C2.9 20 2 19.11 2 18V6C2 5.42 2.25 4.9 2.64 4.53L1.11 3L2.39 1.73L22.11 21.46M22 18V8C22 6.89 21.1 6 20 6H12L10 4H7.2L21.88 18.68C21.96 18.47 22 18.24 22 18Z";
var mdiFolderOffOutline = "M2.39 1.73L1.11 3L2.64 4.53C2.25 4.9 2 5.42 2 6V18C2 19.11 2.9 20 4 20H18.11L20.84 22.73L22.11 21.46L2.39 1.73M4 18V8H6.11L16.11 18H4M11.2 8L7.2 4H10L12 6H20C21.1 6 22 6.89 22 8V18C22 18.24 21.96 18.47 21.88 18.68L20 16.8V8H11.2Z";
var mdiFolderOpen = "M19,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H19A2,2 0 0,1 21,8H21L4,8V18L6.14,10H23.21L20.93,18.5C20.7,19.37 19.92,20 19,20Z";
var mdiFolderOpenOutline = "M6.1,10L4,18V8H21A2,2 0 0,0 19,6H12L10,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H19C19.9,20 20.7,19.4 20.9,18.5L23.2,10H6.1M19,18H6L7.6,12H20.6L19,18Z";
var mdiFolderOutline = "M20,18H4V8H20M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z";
var mdiFolderPlay = "M22 8V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8M17 22L22 19L17 16V22Z";
var mdiFolderPlayOutline = "M22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8M17 22L22 19L17 16V22Z";
var mdiFolderPlus = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiFolderPlusOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiFolderPound = "M15.25,13H17.25L16.75,15H14.75L15.25,13M22,8V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H20A2,2 0 0,1 22,8M20,12H18.5L19,10H18L17.5,12H15.5L16,10H15L14.5,12H13V13H14.25L13.75,15H12V16H13.5L13,18H14L14.5,16H16.5L16,18H17L17.5,16H19V15H17.75L18.25,13H20V12Z";
var mdiFolderPoundOutline = "M20,18H4V8H20M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6M19,12V11H17.5L18,9H17L16.5,11H14.5L15,9H14L13.5,11H12V12H13.25L12.75,14H11V15H12.5L12,17H13L13.5,15H15.5L15,17H16L16.5,15H18V14H16.75L17.25,12H19M15.75,14H13.75L14.25,12H16.25L15.75,14Z";
var mdiFolderQuestion = "M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6M16.8 18H15.3V16.5H16.8V18M16.8 15.8H15.3C15.3 13.4 17.5 13.5 17.5 12C17.5 11.2 16.8 10.5 16 10.5S14.5 11.2 14.5 12H13C13 10.3 14.3 9 16 9S19 10.3 19 12C19 13.9 16.8 14.1 16.8 15.8Z";
var mdiFolderQuestionOutline = "M20 18H4V8H20M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6M19 11.7C19 13.4 17 13.5 17 15H15.7C15.7 12.8 17.7 13 17.7 11.7C17.7 11 17.1 10.4 16.4 10.4C15.7 10.4 15.1 11 15.1 11.7H13.8C13.8 10.2 15 9 16.5 9S19 10.2 19 11.7M17 15.7V17H15.7V15.7H17Z";
var mdiFolderRefresh = "M18 14.5C19.11 14.5 20.11 14.95 20.83 15.67L22 14.5V18.5H18L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5C15.5 19.88 16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5C14 16.29 15.79 14.5 18 14.5M10 4L12 6H20C21.1 6 22 6.89 22 8V13C21 12.38 19.79 12 18.5 12C14.91 12 12 14.91 12 18.5C12 19 12.06 19.5 12.17 20H4C2.89 20 2 19.1 2 18L2 6C2 4.89 2.89 4 4 4H10Z";
var mdiFolderRefreshOutline = "M18 14.5C19.11 14.5 20.11 14.95 20.83 15.67L22 14.5V18.5H18L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5C15.5 19.88 16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5C14 16.29 15.79 14.5 18 14.5M20 8H4V18H12L12 18.5C12 19 12.06 19.5 12.17 20H4C2.89 20 2 19.1 2 18L2 6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13C21.39 12.63 20.72 12.34 20 12.17V8Z";
var mdiFolderRemove = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiFolderRemoveOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiFolderSearch = "M16.5,12C19,12 21,14 21,16.5C21,17.38 20.75,18.21 20.31,18.9L23.39,22L22,23.39L18.88,20.32C18.19,20.75 17.37,21 16.5,21C14,21 12,19 12,16.5C12,14 14,12 16.5,12M16.5,14A2.5,2.5 0 0,0 14,16.5A2.5,2.5 0 0,0 16.5,19A2.5,2.5 0 0,0 19,16.5A2.5,2.5 0 0,0 16.5,14M9,4L11,6H19A2,2 0 0,1 21,8V11.81C19.83,10.69 18.25,10 16.5,10A6.5,6.5 0 0,0 10,16.5C10,17.79 10.37,19 11,20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H9Z";
var mdiFolderSearchOutline = "M16.5,12C19,12 21,14 21,16.5C21,17.38 20.75,18.21 20.31,18.9L23.39,22L22,23.39L18.88,20.32C18.19,20.75 17.37,21 16.5,21C14,21 12,19 12,16.5C12,14 14,12 16.5,12M16.5,14A2.5,2.5 0 0,0 14,16.5A2.5,2.5 0 0,0 16.5,19A2.5,2.5 0 0,0 19,16.5A2.5,2.5 0 0,0 16.5,14M19,8H3V18H10.17C10.34,18.72 10.63,19.39 11,20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H9L11,6H19A2,2 0 0,1 21,8V11.81C20.42,11.26 19.75,10.81 19,10.5V8Z";
var mdiFolderSettings = "M4 4C2.89 4 2 4.89 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8C22 6.89 21.1 6 20 6H12L10 4H4M7 22V24H9V22H7M11 22V24H13V22H11M15 22V24H17V22H15Z";
var mdiFolderSettingsOutline = "M4 4C2.89 4 2 4.89 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8C22 6.89 21.1 6 20 6H12L10 4H4M4 8H20V18H4V8M7 22V24H9V22H7M11 22V24H13V22H11M15 22V24H17V22H15";
var mdiFolderStar = "M20,6H12L10,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8A2,2 0 0,0 20,6M17.94,17L15,15.28L12.06,17L12.84,13.67L10.25,11.43L13.66,11.14L15,8L16.34,11.14L19.75,11.43L17.16,13.67L17.94,17Z";
var mdiFolderStarMultiple = "M2 6H0V20C0 21.11 .895 22 2 22H20V20H2V6M22 4H14L12 2H6C4.89 2 4 2.89 4 4V16C4 17.1 4.89 18 6 18H22C23.11 18 24 17.1 24 16V6C24 4.89 23.11 4 22 4M19.94 15L17 13.27L14.06 15L14.84 11.66L12.25 9.42L15.66 9.13L17 6L18.34 9.13L21.75 9.42L19.16 11.66L19.94 15Z";
var mdiFolderStarMultipleOutline = "M2 6V20H20V22H2C.895 22 0 21.11 0 20V6H2M12.78 10.05L15.81 9.79L17 7L18.19 9.79L21.22 10.05L18.92 12.04L19.61 15L17 13.47L14.39 15L15.08 12.04L12.78 10.05M24 6V16C24 17.11 23.11 18 22 18H6C4.9 18 4 17.11 4 16V4C4 2.89 4.9 2 6 2H12L14 4H22C23.11 4 24 4.9 24 6M22 6H6V16H22V6Z";
var mdiFolderStarOutline = "M10.78 12.05L13.81 11.79L15 9L16.19 11.79L19.22 12.05L16.92 14.04L17.61 17L15 15.47L12.39 17L13.08 14.04L10.78 12.05M22 8V18C22 19.11 21.11 20 20 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H10L12 6H20C21.11 6 22 6.9 22 8M20 8H4V18H20V8Z";
var mdiFolderSwap = "M20 6H12L10 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8A2 2 0 0 0 20 6M15 16V14H9V16L6 13L9 10V12H15V10L18 13Z";
var mdiFolderSwapOutline = "M20 18H4V8H20M20 6H12L10 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8A2 2 0 0 0 20 6M18 13L15 10V12H9V10L6 13L9 16V14H15V16Z";
var mdiFolderSync = "M10,4L12,6H20A2,2 0 0,1 22,8V11.5C21.23,11.18 20.39,11 19.5,11A6.5,6.5 0 0,0 13,17.5C13,18.39 13.18,19.23 13.5,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10M19,12V13.5A4,4 0 0,1 23,17.5C23,18.32 22.75,19.08 22.33,19.71L21.24,18.62C21.41,18.28 21.5,17.9 21.5,17.5A2.5,2.5 0 0,0 19,15V16.5L16.75,14.25L19,12M19,23V21.5A4,4 0 0,1 15,17.5C15,16.68 15.25,15.92 15.67,15.29L16.76,16.38C16.59,16.72 16.5,17.1 16.5,17.5A2.5,2.5 0 0,0 19,20V18.5L21.25,20.75L19,23Z";
var mdiFolderSyncOutline = "M10,4L12,6H20A2,2 0 0,1 22,8V11.5C21.38,11.24 20.7,11.07 20,11V8H4V18H13C13.07,18.7 13.24,19.38 13.5,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10M19,12V13.5A4,4 0 0,1 23,17.5C23,18.32 22.75,19.08 22.33,19.71L21.24,18.62C21.41,18.28 21.5,17.9 21.5,17.5A2.5,2.5 0 0,0 19,15V16.5L16.75,14.25L16.72,14.22C16.78,14.17 16.85,14.13 19,12M19,23V21.5A4,4 0 0,1 15,17.5C15,16.68 15.25,15.92 15.67,15.29L16.76,16.38C16.59,16.72 16.5,17.1 16.5,17.5A2.5,2.5 0 0,0 19,20V18.5L21.25,20.75L21.28,20.78C21.22,20.83 21.15,20.87 19,23Z";
var mdiFolderTable = "M4 4C2.89 4 2 4.89 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8C22 6.89 21.1 6 20 6H12L10 4H4M12 9H15V11H12V9M16 9H19V11H16V9M12 12H15V14H12V12M16 12H19V14H16V12M12 15H15V17H12V15M16 15H19V17H16V15Z";
var mdiFolderTableOutline = "M4 4C2.89 4 2 4.89 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8C22 6.89 21.1 6 20 6H12L10 4H4M4 8H20V18H4V8M12 9V11H15V9H12M16 9V11H19V9H16M12 12V14H15V12H12M16 12V14H19V12H16M12 15V17H15V15H12M16 15V17H19V15H16Z";
var mdiFolderText = "M20,6H12L10,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8A2,2 0 0,0 20,6M15,16H6V14H15V16M18,12H6V10H18V12Z";
var mdiFolderTextOutline = "M20,18H4V8H20M20,6H12L10,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8A2,2 0 0,0 20,6M15,16H6V14H15V16M18,12H6V10H18V12Z";
var mdiFolderUpload = "M20,6A2,2 0 0,1 22,8V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H10L12,6H20M10.75,13H14V17H16V13H19.25L15,8.75";
var mdiFolderUploadOutline = "M20 18H4V8H20M20 6H12L10 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8A2 2 0 0 0 20 6M16 17H14V13H11L15 9L19 13H16Z";
var mdiFolderWrench = "M13.03 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V17.5L20.96 16.44C20.97 16.3 21 16.15 21 16C21 13.24 18.76 11 16 11S11 13.24 11 16C11 17.64 11.8 19.09 13.03 20M22.87 21.19L18.76 17.08C19.17 16.04 18.94 14.82 18.08 13.97C17.18 13.06 15.83 12.88 14.74 13.38L16.68 15.32L15.33 16.68L13.34 14.73C12.8 15.82 13.05 17.17 13.93 18.08C14.79 18.94 16 19.16 17.05 18.76L21.16 22.86C21.34 23.05 21.61 23.05 21.79 22.86L22.83 21.83C23.05 21.65 23.05 21.33 22.87 21.19Z";
var mdiFolderWrenchOutline = "M13.03 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V17.5L20.96 16.44C20.97 16.3 21 16.15 21 16C21 14.88 20.62 13.86 20 13.03V8H4V18H11.42C11.77 18.8 12.33 19.5 13.03 20M22.87 21.19L18.76 17.08C19.17 16.04 18.94 14.82 18.08 13.97C17.18 13.06 15.83 12.88 14.74 13.38L16.68 15.32L15.33 16.68L13.34 14.73C12.8 15.82 13.05 17.17 13.93 18.08C14.79 18.94 16 19.16 17.05 18.76L21.16 22.86C21.34 23.05 21.61 23.05 21.79 22.86L22.83 21.83C23.05 21.65 23.05 21.33 22.87 21.19Z";
var mdiFolderZip = "M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6M18 12H16V14H18V16H16V18H14V16H16V14H14V12H16V10H14V8H16V10H18V12Z";
var mdiFolderZipOutline = "M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6M20 18H16V16H14V18H4V8H14V10H16V8H20V18M16 12V10H18V12H16M14 12H16V14H14V12M18 16H16V14H18V16Z";
var mdiFontAwesome = "M19.76 2H4.24C3 2 2 3 2 4.24V19.76C2 21 3 22 4.24 22H19.76C21 22 22 21 22 19.76V4.24C22 3 21 2 19.76 2M17.73 14.69C17.73 14.88 17.57 14.96 17.38 15.04C16.64 15.36 15.84 15.65 15 15.65C13.78 15.65 13.22 14.91 11.78 14.91C10.74 14.91 9.65 15.28 8.77 15.68C8.71 15.71 8.66 15.71 8.61 15.73V17.76C8.61 17.84 8.61 17.92 8.58 17.97V18.03C8.47 18.4 8.13 18.67 7.73 18.67C7.22 18.67 6.82 18.26 6.82 17.76V8C6.47 7.73 6.24 7.31 6.24 6.83C6.24 6 6.9 5.33 7.73 5.33C8.56 5.33 9.23 6 9.23 6.83C9.23 7.31 9 7.73 8.64 8V8.83C8.72 8.8 8.8 8.77 8.88 8.72C9.71 8.37 10.7 8.08 11.63 8.08C12.64 8.08 13.44 8.35 14.35 8.69C14.54 8.77 14.72 8.8 14.93 8.8C15.95 8.8 17.07 8.08 17.34 8.08C17.55 8.08 17.74 8.24 17.74 8.43V14.69H17.73Z";
var mdiFood = "M18.06 23H19.72C20.56 23 21.25 22.35 21.35 21.53L23 5.05H18V1H16.03V5.05H11.06L11.36 7.39C13.07 7.86 14.67 8.71 15.63 9.65C17.07 11.07 18.06 12.54 18.06 14.94V23M1 22V21H16.03V22C16.03 22.54 15.58 23 15 23H2C1.45 23 1 22.54 1 22M16.03 15C16.03 7 1 7 1 15H16.03M1 17H16V19H1V17Z";
var mdiFoodApple = "M20,10C22,13 17,22 15,22C13,22 13,21 12,21C11,21 11,22 9,22C7,22 2,13 4,10C6,7 9,7 11,8V5C5.38,8.07 4.11,3.78 4.11,3.78C4.11,3.78 6.77,0.19 11,5V3H13V8C15,7 18,7 20,10Z";
var mdiFoodAppleOutline = "M20,10C18.58,7.57 15.5,6.69 13,8V3H11V8C8.5,6.69 5.42,7.57 4,10C2,13 7,22 9,22C11,22 11,21 12,21C13,21 13,22 15,22C17,22 22,13 20,10M18.25,13.38C17.63,15.85 16.41,18.12 14.7,20C14.5,20 14.27,19.9 14.1,19.75C12.87,18.76 11.13,18.76 9.9,19.75C9.73,19.9 9.5,20 9.3,20C7.59,18.13 6.36,15.85 5.75,13.39C5.5,12.66 5.45,11.87 5.66,11.12C6.24,10.09 7.32,9.43 8.5,9.4C9.06,9.41 9.61,9.54 10.11,9.79L11,10.24H13L13.89,9.79C14.39,9.54 14.94,9.41 15.5,9.4C16.68,9.43 17.76,10.08 18.34,11.11C18.55,11.86 18.5,12.65 18.25,13.38M11,5C5.38,8.07 4.11,3.78 4.11,3.78C4.11,3.78 6.77,0.19 11,5Z";
var mdiFoodCroissant = "M22,19L19,17L22,15V19M15,15L19,9L22,13L18,16L15,15M5,17L2,19V15L5,17M9,15L6,16L2,13L5,9L9,15M14,6L18,8L13,15H11L6,8L10,6H14Z";
var mdiFoodDrumstick = "M20.16 12.73C22.93 9.96 22.57 5.26 19.09 3C17.08 1.67 14.39 1.66 12.36 2.97C10.6 4.1 9.63 5.86 9.46 7.68C9.33 9 8.83 10.23 7.91 11.15L7.88 11.18C6.72 12.34 6.72 14.11 7.81 15.19L8.8 16.18C9.89 17.27 11.66 17.27 12.75 16.18C13.72 15.21 15 14.68 16.39 14.53C17.76 14.38 19.1 13.78 20.16 12.73M6.26 19.86C6.53 20.42 6.44 21.1 5.97 21.56C5.39 22.15 4.44 22.15 3.85 21.56C3.58 21.29 3.44 20.94 3.42 20.58C3.06 20.56 2.71 20.42 2.44 20.15C1.85 19.56 1.85 18.61 2.44 18.03C2.9 17.57 3.59 17.47 4.14 17.74L6.62 15.31C6.76 15.5 6.92 15.72 7.1 15.9L8.09 16.89C8.3 17.09 8.5 17.26 8.76 17.41L6.26 19.86Z";
var mdiFoodDrumstickOff = "M20.8 22.7L13.6 15.5C13.3 15.7 13 15.9 12.7 16.2C11.6 17.3 9.8 17.3 8.7 16.2L7.7 15.2C6.6 14.1 6.6 12.3 7.8 11.2C8 11 8.2 10.7 8.4 10.4L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M8.1 16.9L7.1 15.9C6.9 15.7 6.8 15.5 6.6 15.3L4.1 17.7C3.5 17.4 2.9 17.5 2.4 18C1.8 18.6 1.8 19.5 2.4 20.1C2.7 20.4 3 20.5 3.4 20.5C3.4 20.9 3.6 21.2 3.8 21.5C4.4 22.1 5.3 22.1 5.9 21.5C6.4 21 6.5 20.4 6.2 19.8L8.7 17.4C8.5 17.3 8.3 17.1 8.1 16.9M20.2 12.7C23 9.9 22.6 5.2 19.1 3C17.1 1.7 14.4 1.7 12.4 3C11 3.9 10.1 5.1 9.7 6.5L17.5 14.3C18.5 14 19.4 13.5 20.2 12.7Z";
var mdiFoodDrumstickOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L8.5 10.4C8.3 10.7 8.1 10.9 7.9 11.2C6.7 12.4 6.7 14.1 7.8 15.2L8.8 16.2C9.3 16.7 10.1 17 10.8 17C11.5 17 12.2 16.7 12.8 16.2C13.1 15.9 13.4 15.7 13.7 15.5L20.9 22.7L22.1 21.5M11.3 14.8C11.1 15 10.9 15 10.8 15S10.4 15 10.2 14.8L9.2 13.8C9 13.6 9 13.4 9 13.2C9 13 9.1 12.7 9.3 12.5C9.5 12.3 9.7 12 9.9 11.8L12.1 14C11.9 14.3 11.6 14.5 11.3 14.8M11.4 8.2L9.7 6.5C10.1 5.1 11 3.9 12.4 3C13.4 2.4 14.6 2 15.7 2C16.9 2 18.1 2.3 19.1 3C22.6 5.3 22.9 10 20.2 12.7C19.4 13.5 18.5 14 17.5 14.3L15.8 12.6C15.9 12.6 16 12.5 16.2 12.5C17.2 12.4 18.1 12 18.8 11.3C19.7 10.4 20.2 9.1 20 7.8C19.9 6.5 19.2 5.4 18 4.6C17.3 4.2 16.5 4 15.7 4C14.9 4 14.1 4.2 13.4 4.7C12.2 5.4 11.5 6.6 11.4 7.9V8.2M8.8 17.4L6.3 19.8C6.6 20.4 6.5 21 6 21.5C5.4 22.1 4.5 22.1 3.9 21.5C3.6 21.2 3.5 20.9 3.5 20.5C3.1 20.5 2.8 20.3 2.5 20.1C1.9 19.5 1.9 18.6 2.5 18C3 17.5 3.6 17.4 4.2 17.7L6.7 15.3C6.8 15.5 7 15.7 7.2 15.9L8.2 16.9C8.3 17.1 8.5 17.3 8.8 17.4";
var mdiFoodDrumstickOutline = "M15.71 4C16.54 4 17.33 4.22 18 4.66C19.14 5.4 19.84 6.53 20 7.84C20.11 9.13 19.66 10.4 18.75 11.31C18.05 12 17.16 12.44 16.18 12.54C14.27 12.74 12.59 13.5 11.34 14.77C11.13 14.97 10.9 15 10.77 15C10.65 15 10.42 14.97 10.21 14.77L9.22 13.78C9.04 13.6 9 13.39 9 13.25C9 13 9.11 12.78 9.32 12.57C10.53 11.35 11.27 9.73 11.45 7.87C11.58 6.54 12.29 5.4 13.45 4.65C14.11 4.22 14.89 4 15.71 4M15.71 2C14.54 2 13.37 2.32 12.36 2.97C10.6 4.1 9.63 5.86 9.46 7.68C9.33 9 8.83 10.23 7.91 11.15L7.88 11.18C6.72 12.34 6.72 14.11 7.81 15.19L8.8 16.18C9.35 16.73 10.06 17 10.77 17S12.2 16.73 12.75 16.18C13.72 15.21 15 14.68 16.39 14.53C17.76 14.38 19.1 13.78 20.16 12.73C22.93 9.96 22.57 5.26 19.09 3C18.08 2.33 16.9 2 15.71 2M6.26 19.86C6.53 20.42 6.44 21.1 5.97 21.56C5.39 22.15 4.44 22.15 3.85 21.56C3.58 21.29 3.44 20.94 3.42 20.58C3.06 20.56 2.71 20.42 2.44 20.15C1.85 19.56 1.85 18.61 2.44 18.03C2.9 17.57 3.59 17.47 4.14 17.74L6.62 15.31C6.76 15.5 6.92 15.72 7.1 15.9L8.09 16.89C8.3 17.09 8.5 17.26 8.76 17.41L6.26 19.86Z";
var mdiFoodForkDrink = "M3,3A1,1 0 0,0 2,4V8L2,9.5C2,11.19 3.03,12.63 4.5,13.22V19.5A1.5,1.5 0 0,0 6,21A1.5,1.5 0 0,0 7.5,19.5V13.22C8.97,12.63 10,11.19 10,9.5V8L10,4A1,1 0 0,0 9,3A1,1 0 0,0 8,4V8A0.5,0.5 0 0,1 7.5,8.5A0.5,0.5 0 0,1 7,8V4A1,1 0 0,0 6,3A1,1 0 0,0 5,4V8A0.5,0.5 0 0,1 4.5,8.5A0.5,0.5 0 0,1 4,8V4A1,1 0 0,0 3,3M19.88,3C19.75,3 19.62,3.09 19.5,3.16L16,5.25V9H12V11H13L14,21H20L21,11H22V9H18V6.34L20.5,4.84C21,4.56 21.13,4 20.84,3.5C20.63,3.14 20.26,2.95 19.88,3Z";
var mdiFoodHalal = "M7 5V15C7 16.11 6.11 17 5 17H4C3.45 17 3 16.55 3 16V13H1V16C1 17.66 2.34 19 4 19H5C7.21 19 9 17.21 9 15V5M23 13.38L21.77 12.15C21.03 11.41 20.04 11 19 11H17V13H19C19.5 13 20 13.2 20.35 13.56L20.7 13.91L19.5 14.6C19.04 14.86 18.53 15 18 15H17C16.44 15 16 14.56 16 14V6H14V9.81L13.38 9.12C12.7 8.37 11.6 8 10.59 8H10V10H10.59C11.23 10 11.84 10.25 12.29 10.71L14 12.41V14C14 15.12 13.12 16 12 16H10V18H12C13.37 18 14.5 17.3 15.17 16.24C15.63 16.71 16.25 17 17 17H18C18.88 17 19.74 16.77 20.5 16.33L23 14.89Z";
var mdiFoodHotDog = "M21 5.77C20.85 5.65 20.72 5.55 20.59 5.45L20.62 5.41C21.4 4.63 21.4 3.37 20.62 2.59C19.84 1.81 18.58 1.81 17.79 2.59L17.05 3.33C15.68 2.3 13.74 2.4 12.5 3.65L3.65 12.5C2.4 13.74 2.3 15.68 3.33 17.05L2.59 17.79C1.8 18.58 1.8 19.84 2.59 20.62C3.37 21.4 4.63 21.4 5.41 20.62L5.45 20.59C5.55 20.72 5.65 20.85 5.77 21C7.13 22.34 9.35 22.34 10.72 21L20.97 10.72C22.34 9.35 22.34 7.14 21 5.77M4.77 15.61C4.5 15.05 4.6 14.36 5.06 13.9L13.9 5.06C14.36 4.6 15.05 4.5 15.61 4.77L4.77 15.61M19.56 9.3L9.3 19.56C8.72 20.15 7.77 20.15 7.18 19.56C6.6 19 6.6 18 7.18 17.44L17.44 7.18C18 6.6 19 6.6 19.56 7.18C20.15 7.77 20.15 8.72 19.56 9.3Z";
var mdiFoodKosher = "M1 7V9H3C3.57 9 4 9.43 4 10V17H6V10C6 8.36 4.64 7 3 7H1M7 7V14C7 15.65 8.36 17 10 17H14C15.65 17 17 15.65 17 14V7H15V14C15 14.57 14.57 15 14 15H10C9.43 15 9 14.57 9 14V13H10C11.65 13 13 11.65 13 10V7H11V10C11 10.57 10.57 11 10 11H9V7H7M18 7V9H20C20.57 9 21 9.43 21 10V14C21 14.57 20.57 15 20 15H18V17H20C21.65 17 23 15.65 23 14V10C23 8.36 21.65 7 20 7H18Z";
var mdiFoodOff = "M11.35 8.5L11 5H16V1H18V5H23L21.62 18.79L11.35 8.5M1 21V22C1 22.55 1.45 23 2 23H15C15.55 23 16 22.55 16 22V21H1M21.9 21.9L2.1 2.1L.69 3.5L6.39 9.21C3.28 9.87 1 12 1 15H12.17L14.17 17H1V19H16V18.83L20.5 23.32L21.9 21.9Z";
var mdiFoodOffOutline = "M1 21H16V22C16 22.54 15.56 23 15 23H2C1.45 23 1 22.54 1 22V21M20.5 23.31L16 18.83V19H1V17H14.17L12.17 15H1C1 11.76 3.46 9.83 6.38 9.21L.68 3.5L2.1 2.1L13 13L15 15L21.9 21.9L20.5 23.31M10.17 13L8.17 11C6.75 11.06 4.65 11.56 3.62 13H10.17M23 5H18V1H16V5H11L11.23 7H20.79L19.79 16.97L21.62 18.8L23 5Z";
var mdiFoodOutline = "M1 22C1 22.54 1.45 23 2 23H15C15.56 23 16 22.54 16 22V21H1V22M8.5 9C4.75 9 1 11 1 15H16C16 11 12.25 9 8.5 9M3.62 13C4.73 11.45 7.09 11 8.5 11S12.27 11.45 13.38 13H3.62M1 17H16V19H1V17M18 5V1H16V5H11L11.23 7H20.79L19.39 21H18V23H19.72C20.56 23 21.25 22.35 21.35 21.53L23 5H18Z";
var mdiFoodSteak = "M11.9 2C8 2 4.9 5.4 5 9.3C5.1 11.9 6.6 14.1 8.7 15.2C10.1 15.9 11 17.3 11 18.8V19C11 20.7 12.3 22 14 22C18 22 19 17 19 9C19 9 19 2 11.9 2M14 20C13.4 20 13 19.6 13 19V18.8C13 16.6 11.7 14.5 9.7 13.4C8.1 12.6 7.1 11 7 9.2C7 7.9 7.5 6.5 8.4 5.5C9.3 4.5 10.6 4 11.8 4C16.7 4 17 8.2 17 9C17 18.9 15.3 20 14 20M15.8 7.6L8.3 10.3C8.1 10 8 9.6 8 9.1C8 8.4 8.2 7.8 8.5 7.1L13.7 5.2C14.9 5.8 15.5 6.7 15.8 7.6M12.9 15.1L15.7 14.1C15.6 15.6 15.3 16.7 15.1 17.4L13.8 17.9C13.8 16.9 13.5 16 12.9 15.1M16 9.2C16 10.4 16 11.5 15.9 12.4L11.9 13.9C11.4 13.4 10.8 12.9 10.1 12.6C9.7 12.4 9.3 12.1 9 11.8L16 9.2Z";
var mdiFoodSteakOff = "M2.39 1.73L1.11 3L5.27 7.16C5.08 7.83 5 8.53 5 9.26C5.1 11.83 6.59 14.05 8.74 15.19C10.1 15.9 11 17.25 11 18.79V19C11 20.66 12.34 22 14 22C15.68 22 16.83 21.11 17.6 19.5L20.84 22.73L22.11 21.46L2.39 1.73M14 20C13.45 20 13 19.55 13 19V18.79C13 16.56 11.72 14.5 9.67 13.42C8.09 12.58 7.07 10.96 7 9.18C7 9.09 7 9 7 8.9L8.16 10.05C8.19 10.15 8.21 10.25 8.24 10.35L8.4 10.29L9.62 11.5L9.08 11.71C9.38 12.04 9.73 12.32 10.14 12.53C10.81 12.89 11.4 13.34 11.91 13.85L11.95 13.84L13.17 15.06L12.95 15.14C13.46 15.96 13.8 16.89 13.93 17.85L15.2 17.39C15.22 17.32 15.25 17.24 15.27 17.16L16.07 17.96C15.47 19.68 14.68 20 14 20M15.79 7.6L12.14 8.94L9.88 6.68L13.69 5.3C14.94 5.77 15.53 6.72 15.79 7.6M8.59 5.39L7.17 3.97C8.41 2.77 10.07 2 11.88 2H11.88C19 2 19 9 19 9C19 11.46 18.9 13.63 18.66 15.46L16.84 13.64C16.94 12.36 17 10.83 17 9C17 8.18 16.69 4 11.88 4H11.88C10.67 4 9.5 4.5 8.59 5.39M15.68 12.5L13.36 10.15L16 9.19C16 10.41 15.97 11.46 15.92 12.4L15.68 12.5Z";
var mdiFoodTakeoutBox = "M5.26 11H18.74L18.07 20H5.93L5.26 11M9 4H14.97L19 7.38L20.59 5.79L22 7.21L19.21 10H4.79L2 7.21L3.41 5.8L5 7.38L9 4Z";
var mdiFoodTakeoutBoxOutline = "M7.79 18L7.28 11H16.74L16.23 18H7.79M9.83 5H14.16L16.96 7.73L16.87 9H7.12L7.03 7.73L9.83 5M22 7.46L20.59 6.05L19 7.63L19.03 7.07L15 3H9L4.97 7.07L5 7.57L3.41 6L2 7.44L5.23 10.55L5.93 20H18.07L18.77 10.56L22 7.46Z";
var mdiFoodTurkey = "M5.44 7.96L5.96 7.43C6.54 6.85 7.5 6.85 8.1 7.47L8.12 7.5C8.61 8 9.26 8.24 9.97 8.31C10.94 8.4 11.88 8.92 12.5 9.86C13.18 10.94 13.17 12.38 12.46 13.45C11.26 15.3 8.75 15.5 7.28 14C6.72 13.45 6.4 12.74 6.32 12C6.24 11.27 5.95 10.58 5.44 10.07C4.86 9.5 4.86 8.54 5.44 7.96M9.64 16C8.47 16 7.38 15.55 6.57 14.72C5.87 14 5.43 13.1 5.32 12.12C5.29 11.82 5.2 11.43 4.96 11.07C4.36 11.9 4 12.9 4 14C4 15.64 4.8 17.09 6.03 18H19V17C19 13.4 16.61 10.35 13.34 9.35C14.23 10.75 14.21 12.62 13.3 14C12.5 15.25 11.12 16 9.64 16M14.78 7.56H16.05C16.92 7.56 17.68 8.17 17.68 9.26V10H18.93V9C18.93 7.5 17.6 6.36 16.05 6.36H14.78C13.95 6.36 13.24 5.54 13.24 4.7S13.95 3.24 14.78 3.24V2C13.24 2 12 3.24 12 4.78S13.24 7.56 14.78 7.56M4.5 7.55C4.56 7.45 4.64 7.35 4.73 7.25L5.25 6.73C5.34 6.64 5.44 6.57 5.54 6.5L4.13 5.07C4.27 4.8 4.22 4.45 4 4.22C3.7 3.93 3.22 3.93 2.93 4.22C2.79 4.36 2.72 4.53 2.71 4.71C2.53 4.72 2.36 4.79 2.22 4.93C1.93 5.22 1.93 5.7 2.22 6C2.45 6.22 2.79 6.27 3.07 6.13L4.5 7.55M18.39 4.39C18.9 3.88 19.22 3.19 19.22 2.42H17.97C17.97 3.25 17.27 3.95 16.44 3.95V5.19C18.3 5.19 19.76 6.71 19.76 8.57V11H21V8.57C21 6.72 19.94 5.13 18.39 4.39M5 21H19C20.11 21 21 20.11 21 19H3C3 20.11 3.9 21 5 21Z";
var mdiFoodVariant = "M22,18A4,4 0 0,1 18,22H15A4,4 0 0,1 11,18V16H17.79L20.55,11.23L22.11,12.13L19.87,16H22V18M9,22H2C2,19 2,16 2.33,12.83C2.6,10.3 3.08,7.66 3.6,5H3V3H4L7,3H8V5H7.4C7.92,7.66 8.4,10.3 8.67,12.83C9,16 9,19 9,22Z";
var mdiFoodVariantOff = "M2.28 3L1 4.27L3.31 6.58C2.91 8.7 2.55 10.8 2.33 12.83C2 16 2 19 2 22H9C9 19 9 16 8.67 12.83C8.63 12.5 8.58 12.15 8.54 11.81L12.73 16H11V18C11 20.21 12.79 22 15 22H18C18.23 22 18.45 22 18.67 21.94L19.73 23L21 21.72M4.82 3L7.53 5.71C7.5 5.47 7.45 5.24 7.4 5H8V3H7M20.55 11.23L17.8 16L21.59 19.76C21.86 19.21 22 18.61 22 18V16H19.87L22.11 12.13Z";
var mdiFootPrint = "M16 2A2 2 0 1 1 14 4A2 2 0 0 1 16 2M12.04 3A1.5 1.5 0 1 1 10.54 4.5A1.5 1.5 0 0 1 12.04 3M9.09 4.5A1 1 0 1 1 8.09 5.5A1 1 0 0 1 9.09 4.5M7.04 6A1 1 0 1 1 6.04 7A1 1 0 0 1 7.04 6M14.53 12A2.5 2.5 0 0 0 17 9.24A2.6 2.6 0 0 0 14.39 7H11.91A6 6 0 0 0 6.12 11.4A2 2 0 0 0 6.23 12.8A6.8 6.8 0 0 1 6.91 15.76A6.89 6.89 0 0 1 6.22 18.55A1.92 1.92 0 0 0 6.3 20.31A3.62 3.62 0 0 0 10.19 21.91A3.5 3.5 0 0 0 12.36 16.63A2.82 2.82 0 0 1 11.91 15S11.68 12 14.53 12Z";
var mdiFootball = "M8.39 21L3 15.61C3 16.7 3.04 17.71 3.2 18.63C3.35 19.55 3.5 20.1 3.71 20.29C3.9 20.5 4.44 20.65 5.35 20.81S7.27 21 8.39 21M15.5 9.89L9.89 15.5L8.5 14.11L14.11 8.5L15.5 9.89M3.29 13.08L10.92 20.71C13.7 20.21 15.9 19.15 17.53 17.53C19.15 15.9 20.21 13.7 20.71 10.92L13.08 3.29C10.3 3.79 8.1 4.85 6.47 6.47S3.79 10.3 3.29 13.08M15.61 3L21 8.39C21 7.3 20.96 6.29 20.81 5.37C20.65 4.45 20.5 3.9 20.29 3.71C20.1 3.5 19.56 3.35 18.65 3.2S16.73 3 15.61 3Z";
var mdiFootballAustralian = "M7.5,7.5C9.17,5.87 11.29,4.69 13.37,4.18C18,3 21,6 19.82,10.63C19.31,12.71 18.13,14.83 16.5,16.5C14.83,18.13 12.71,19.31 10.63,19.82C6,21 3,18 4.18,13.37C4.69,11.29 5.87,9.17 7.5,7.5M10.62,11.26L10.26,11.62L12.38,13.74L12.74,13.38L10.62,11.26M11.62,10.26L11.26,10.62L13.38,12.74L13.74,12.38L11.62,10.26M9.62,12.26L9.26,12.62L11.38,14.74L11.74,14.38L9.62,12.26M12.63,9.28L12.28,9.63L14.4,11.75L14.75,11.4L12.63,9.28M8.63,13.28L8.28,13.63L10.4,15.75L10.75,15.4L8.63,13.28M13.63,8.28L13.28,8.63L15.4,10.75L15.75,10.4L13.63,8.28Z";
var mdiFootballHelmet = "M13.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,15A1.5,1.5 0 0,0 15,13.5A1.5,1.5 0 0,0 13.5,12M13.5,3C18.19,3 22,6.58 22,11C22,12.62 22,14 21.09,16C17,16 16,20 12.5,20C10.32,20 9.27,18.28 9.05,16H9L8.24,16L6.96,20.3C6.81,20.79 6.33,21.08 5.84,21H3A1,1 0 0,1 2,20A1,1 0 0,1 3,19V16A1,1 0 0,1 2,15A1,1 0 0,1 3,14H6.75L7.23,12.39C6.72,12.14 6.13,12 5.5,12H5.07L5,11C5,6.58 8.81,3 13.5,3M5,16V19H5.26L6.15,16H5Z";
var mdiForest = "M16 12L9 2L2 12H3.86L0 18H7V22H11V18H18L14.14 12H16M20.14 12H22L15 2L12.61 5.41L17.92 13H15.97L19.19 18H24L20.14 12M13 19H17V22H13V19Z";
var mdiForestOutline = "M19.19 18H24L20.14 12H22L15 2L12.61 5.41L17.92 13H15.97L19.19 18M16 12L9 2L2 12H3.86L0 18H7V22H11V18H18L14.14 12H16M12.16 10H10.5L14.34 16H3.67L7.53 10H5.84L9 5.5L12.16 10M13 19V22H17V19H13Z";
var mdiForklift = "M6,4V11H4C2.89,11 2,11.89 2,13V17A3,3 0 0,0 5,20A3,3 0 0,0 8,17H10A3,3 0 0,0 13,20A3,3 0 0,0 16,17V13L12,4H6M17,5V19H22V17.5H18.5V5H17M7.5,5.5H11.2L14.5,13H7.5V5.5M5,15.5A1.5,1.5 0 0,1 6.5,17A1.5,1.5 0 0,1 5,18.5A1.5,1.5 0 0,1 3.5,17A1.5,1.5 0 0,1 5,15.5M13,15.5A1.5,1.5 0 0,1 14.5,17A1.5,1.5 0 0,1 13,18.5A1.5,1.5 0 0,1 11.5,17A1.5,1.5 0 0,1 13,15.5Z";
var mdiFormDropdown = "M17 5H20L18.5 7L17 5M3 2H21C22.11 2 23 2.9 23 4V8C23 9.11 22.11 10 21 10H16V20C16 21.11 15.11 22 14 22H3C1.9 22 1 21.11 1 20V4C1 2.9 1.9 2 3 2M3 4V8H14V4H3M21 8V4H16V8H21M3 20H14V10H3V20M5 12H12V14H5V12M5 16H12V18H5V16Z";
var mdiFormSelect = "M15 5H18L16.5 7L15 5M5 2H19C20.11 2 21 2.9 21 4V20C21 21.11 20.11 22 19 22H5C3.9 22 3 21.11 3 20V4C3 2.9 3.9 2 5 2M5 4V8H19V4H5M5 20H19V10H5V20M7 12H17V14H7V12M7 16H17V18H7V16Z";
var mdiFormTextarea = "M13 9H4V23H2V7H13M23 9V7H17V5A1 1 0 0 1 18 4H20V2H17.5C17 2 16 2.45 16 3C16 2.45 15.05 2 14.5 2H12V4H14A1 1 0 0 1 15 5V19A1 1 0 0 1 14 20H12V22H14.5C15.05 22 16 21.55 16 21C16 21.55 16.95 22 17.5 22H20V20H18A1 1 0 0 1 17 19V9Z";
var mdiFormTextbox = "M17,7H22V17H17V19A1,1 0 0,0 18,20H20V22H17.5C16.95,22 16,21.55 16,21C16,21.55 15.05,22 14.5,22H12V20H14A1,1 0 0,0 15,19V5A1,1 0 0,0 14,4H12V2H14.5C15.05,2 16,2.45 16,3C16,2.45 16.95,2 17.5,2H20V4H18A1,1 0 0,0 17,5V7M2,7H13V9H4V15H13V17H2V7M20,15V9H17V15H20Z";
var mdiFormTextboxLock = "M2 7H6V9H4V15H6V17H2V7M10 7H22V12C21.42 11.56 20.74 11.25 20 11.1V9H10V15H14.25C13.56 15 13 15.56 13 16.25V17H10V19C10 19.55 10.45 20 11 20H13V22H10.5C9.95 22 9 21.55 9 21C9 21.55 8.05 22 7.5 22H5V20H7C7.55 20 8 19.55 8 19V5C8 4.45 7.55 4 7 4H5V2H7.5C8.05 2 9 2.45 9 3C9 2.45 9.95 2 10.5 2H13V4H11C10.45 4 10 4.45 10 5V7M21.8 17C22.4 17 23 17.6 23 18.3V21.8C23 22.4 22.4 23 21.7 23H16.2C15.6 23 15 22.4 15 21.7V18.2C15 17.6 15.6 17 16.2 17V15.5C16.2 14.1 17.6 13 19 13C20.4 13 21.8 14.1 21.8 15.5V17M20.5 17V15.5C20.5 14.7 19.8 14.2 19 14.2C18.2 14.2 17.5 14.7 17.5 15.5V17H20.5Z";
var mdiFormTextboxPassword = "M17,7H22V17H17V19A1,1 0 0,0 18,20H20V22H17.5C16.95,22 16,21.55 16,21C16,21.55 15.05,22 14.5,22H12V20H14A1,1 0 0,0 15,19V5A1,1 0 0,0 14,4H12V2H14.5C15.05,2 16,2.45 16,3C16,2.45 16.95,2 17.5,2H20V4H18A1,1 0 0,0 17,5V7M2,7H13V9H4V15H13V17H2V7M20,15V9H17V15H20M8.5,12A1.5,1.5 0 0,0 7,10.5A1.5,1.5 0 0,0 5.5,12A1.5,1.5 0 0,0 7,13.5A1.5,1.5 0 0,0 8.5,12M13,10.89C12.39,10.33 11.44,10.38 10.88,11C10.32,11.6 10.37,12.55 11,13.11C11.55,13.63 12.43,13.63 13,13.11V10.89Z";
var mdiFormatAlignBottom = "M13,9L15.5,6.5L16.92,7.92L12,12.84L7.08,7.92L8.5,6.5L11,9V3H13V9M3,15H21V17H3V15M3,19H13V21H3V19Z";
var mdiFormatAlignCenter = "M3,3H21V5H3V3M7,7H17V9H7V7M3,11H21V13H3V11M7,15H17V17H7V15M3,19H21V21H3V19Z";
var mdiFormatAlignJustify = "M3,3H21V5H3V3M3,7H21V9H3V7M3,11H21V13H3V11M3,15H21V17H3V15M3,19H21V21H3V19Z";
var mdiFormatAlignLeft = "M3,3H21V5H3V3M3,7H15V9H3V7M3,11H21V13H3V11M3,15H15V17H3V15M3,19H21V21H3V19Z";
var mdiFormatAlignMiddle = "M13,6L15,4L16.42,5.42L12,9.84L7.58,5.42L9,4L11,6V2H13V6M3,11H21V13H3V11M13,18V22H11V18L9,20L7.58,18.58L12,14.16L16.42,18.58L15,20L13,18Z";
var mdiFormatAlignRight = "M3,3H21V5H3V3M9,7H21V9H9V7M3,11H21V13H3V11M9,15H21V17H9V15M3,19H21V21H3V19Z";
var mdiFormatAlignTop = "M13,15L15.5,17.5L16.92,16.08L12,11.16L7.08,16.08L8.5,17.5L11,15V21H13V15M3,3H21V5H3V3M3,7H13V9H3V7Z";
var mdiFormatAnnotationMinus = "M10.5,7H8.5L3,21H5.2L6.3,18H12.5L13.6,21H16L10.5,7M7.1,16L9.5,9.7L11.9,16H7.1M22,7H14V5H22V7Z";
var mdiFormatAnnotationPlus = "M8.5,7H10.5L16,21H13.6L12.5,18H6.3L5.2,21H3L8.5,7M7.1,16H11.9L9.5,9.7L7.1,16M22,5V7H19V10H17V7H14V5H17V2H19V5H22Z";
var mdiFormatBold = "M13.5,15.5H10V12.5H13.5A1.5,1.5 0 0,1 15,14A1.5,1.5 0 0,1 13.5,15.5M10,6.5H13A1.5,1.5 0 0,1 14.5,8A1.5,1.5 0 0,1 13,9.5H10M15.6,10.79C16.57,10.11 17.25,9 17.25,8C17.25,5.74 15.5,4 13.25,4H7V18H14.04C16.14,18 17.75,16.3 17.75,14.21C17.75,12.69 16.89,11.39 15.6,10.79Z";
var mdiFormatClear = "M6,5V5.18L8.82,8H11.22L10.5,9.68L12.6,11.78L14.21,8H20V5H6M3.27,5L2,6.27L8.97,13.24L6.5,19H9.5L11.07,15.34L16.73,21L18,19.73L3.55,5.27L3.27,5Z";
var mdiFormatColorFill = "M19,11.5C19,11.5 17,13.67 17,15A2,2 0 0,0 19,17A2,2 0 0,0 21,15C21,13.67 19,11.5 19,11.5M5.21,10L10,5.21L14.79,10M16.56,8.94L7.62,0L6.21,1.41L8.59,3.79L3.44,8.94C2.85,9.5 2.85,10.47 3.44,11.06L8.94,16.56C9.23,16.85 9.62,17 10,17C10.38,17 10.77,16.85 11.06,16.56L16.56,11.06C17.15,10.47 17.15,9.5 16.56,8.94Z";
var mdiFormatColorHighlight = "M4,17L6.75,14.25L6.72,14.23C6.14,13.64 6.14,12.69 6.72,12.11L11.46,7.37L15.7,11.61L10.96,16.35C10.39,16.93 9.46,16.93 8.87,16.37L8.24,17H4M15.91,2.91C16.5,2.33 17.45,2.33 18.03,2.91L20.16,5.03C20.74,5.62 20.74,6.57 20.16,7.16L16.86,10.45L12.62,6.21L15.91,2.91Z";
var mdiFormatColorMarkerCancel = "M16.5 8C14 8 12 10 12 12.5S14 17 16.5 17 21 15 21 12.5 19 8 16.5 8M16.5 15.5C14.8 15.5 13.5 14.2 13.5 12.5C13.5 11.9 13.7 11.4 13.9 11L18 15.1C17.6 15.3 17.1 15.5 16.5 15.5M19.1 14L15 9.9C15.4 9.6 15.9 9.5 16.5 9.5C18.2 9.5 19.5 10.8 19.5 12.5C19.5 13.1 19.3 13.6 19.1 14M12.1 7.7L10.6 6.2L13.9 2.9C14.5 2.3 15.4 2.3 16 2.9L18.2 5C18.6 5.4 18.7 5.8 18.6 6.3C18 6.1 17.3 6 16.6 6C14.8 6 13.3 6.7 12.1 7.7M10.5 14.9L9 16.3C8.4 16.9 7.5 16.9 6.9 16.3L6.2 17H2L4.8 14.2C4.2 13.6 4.2 12.7 4.8 12.1L9.5 7.4L11.1 9C10.4 10 10 11.2 10 12.5C10 13.3 10.2 14.1 10.5 14.9Z";
var mdiFormatColorText = "M9.62,12L12,5.67L14.37,12M11,3L5.5,17H7.75L8.87,14H15.12L16.25,17H18.5L13,3H11Z";
var mdiFormatColumns = "M3,3H11V5H3V3M13,3H21V5H13V3M3,7H11V9H3V7M13,7H21V9H13V7M3,11H11V13H3V11M13,11H21V13H13V11M3,15H11V17H3V15M13,15H21V17H13V15M3,19H11V21H3V19M13,19H21V21H13V19Z";
var mdiFormatFloatCenter = "M9,7H15V13H9V7M3,3H21V5H3V3M3,15H21V17H3V15M3,19H17V21H3V19Z";
var mdiFormatFloatLeft = "M3,7H9V13H3V7M3,3H21V5H3V3M21,7V9H11V7H21M21,11V13H11V11H21M3,15H17V17H3V15M3,19H21V21H3V19Z";
var mdiFormatFloatNone = "M3,7H9V13H3V7M3,3H21V5H3V3M21,11V13H11V11H21M3,15H17V17H3V15M3,19H21V21H3V19Z";
var mdiFormatFloatRight = "M15,7H21V13H15V7M3,3H21V5H3V3M13,7V9H3V7H13M9,11V13H3V11H9M3,15H17V17H3V15M3,19H21V21H3V19Z";
var mdiFormatFont = "M17,8H20V20H21V21H17V20H18V17H14L12.5,20H14V21H10V20H11L17,8M18,9L14.5,16H18V9M5,3H10C11.11,3 12,3.89 12,5V16H9V11H6V16H3V5C3,3.89 3.89,3 5,3M6,5V9H9V5H6Z";
var mdiFormatFontSizeDecrease = "M5.12,14L7.5,7.67L9.87,14M6.5,5L1,19H3.25L4.37,16H10.62L11.75,19H14L8.5,5H6.5M18,17L23,11.93L21.59,10.5L19,13.1V7H17V13.1L14.41,10.5L13,11.93L18,17Z";
var mdiFormatFontSizeIncrease = "M5.12,14L7.5,7.67L9.87,14M6.5,5L1,19H3.25L4.37,16H10.62L11.75,19H14L8.5,5H6.5M18,7L13,12.07L14.41,13.5L17,10.9V17H19V10.9L21.59,13.5L23,12.07L18,7Z";
var mdiFormatHeader1 = "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M14,18V16H16V6.31L13.5,7.75V5.44L16,4H18V16H20V18H14Z";
var mdiFormatHeader2 = "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M21,18H15A2,2 0 0,1 13,16C13,15.47 13.2,15 13.54,14.64L18.41,9.41C18.78,9.05 19,8.55 19,8A2,2 0 0,0 17,6A2,2 0 0,0 15,8H13A4,4 0 0,1 17,4A4,4 0 0,1 21,8C21,9.1 20.55,10.1 19.83,10.83L15,16H21V18Z";
var mdiFormatHeader3 = "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M15,4H19A2,2 0 0,1 21,6V16A2,2 0 0,1 19,18H15A2,2 0 0,1 13,16V15H15V16H19V12H15V10H19V6H15V7H13V6A2,2 0 0,1 15,4Z";
var mdiFormatHeader4 = "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M18,18V13H13V11L18,4H20V11H21V13H20V18H18M18,11V7.42L15.45,11H18Z";
var mdiFormatHeader5 = "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M15,4H20V6H15V10H17A4,4 0 0,1 21,14A4,4 0 0,1 17,18H15A2,2 0 0,1 13,16V15H15V16H17A2,2 0 0,0 19,14A2,2 0 0,0 17,12H15A2,2 0 0,1 13,10V6A2,2 0 0,1 15,4Z";
var mdiFormatHeader6 = "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M15,4H19A2,2 0 0,1 21,6V7H19V6H15V10H19A2,2 0 0,1 21,12V16A2,2 0 0,1 19,18H15A2,2 0 0,1 13,16V6A2,2 0 0,1 15,4M15,12V16H19V12H15Z";
var mdiFormatHeaderDecrease = "M4,4H6V10H10V4H12V18H10V12H6V18H4V4M20.42,7.41L16.83,11L20.42,14.59L19,16L14,11L19,6L20.42,7.41Z";
var mdiFormatHeaderEqual = "M4,4H6V10H10V4H12V18H10V12H6V18H4V4M14,10V8H21V10H14M14,12H21V14H14V12Z";
var mdiFormatHeaderIncrease = "M4,4H6V10H10V4H12V18H10V12H6V18H4V4M14.59,7.41L18.17,11L14.59,14.59L16,16L21,11L16,6L14.59,7.41Z";
var mdiFormatHeaderPound = "M3,4H5V10H9V4H11V18H9V12H5V18H3V4M13,8H15.31L15.63,5H17.63L17.31,8H19.31L19.63,5H21.63L21.31,8H23V10H21.1L20.9,12H23V14H20.69L20.37,17H18.37L18.69,14H16.69L16.37,17H14.37L14.69,14H13V12H14.9L15.1,10H13V8M17.1,10L16.9,12H18.9L19.1,10H17.1Z";
var mdiFormatHorizontalAlignCenter = "M19,16V13H23V11H19V8L15,12L19,16M5,8V11H1V13H5V16L9,12L5,8M11,20H13V4H11V20Z";
var mdiFormatHorizontalAlignLeft = "M11,16V13H21V11H11V8L7,12L11,16M3,20H5V4H3V20Z";
var mdiFormatHorizontalAlignRight = "M13,8V11H3V13H13V16L17,12L13,8M19,20H21V4H19V20Z";
var mdiFormatIndentDecrease = "M11,13H21V11H11M11,9H21V7H11M3,3V5H21V3M3,21H21V19H3M3,12L7,16V8M11,17H21V15H11V17Z";
var mdiFormatIndentIncrease = "M11,13H21V11H11M11,9H21V7H11M3,3V5H21V3M11,17H21V15H11M3,8V16L7,12M3,21H21V19H3V21Z";
var mdiFormatItalic = "M10,4V7H12.21L8.79,15H6V18H14V15H11.79L15.21,7H18V4H10Z";
var mdiFormatLetterCase = "M20.06,18C20,17.83 19.91,17.54 19.86,17.11C19.19,17.81 18.38,18.16 17.45,18.16C16.62,18.16 15.93,17.92 15.4,17.45C14.87,17 14.6,16.39 14.6,15.66C14.6,14.78 14.93,14.1 15.6,13.61C16.27,13.12 17.21,12.88 18.43,12.88H19.83V12.24C19.83,11.75 19.68,11.36 19.38,11.07C19.08,10.78 18.63,10.64 18.05,10.64C17.53,10.64 17.1,10.76 16.75,11C16.4,11.25 16.23,11.54 16.23,11.89H14.77C14.77,11.46 14.92,11.05 15.22,10.65C15.5,10.25 15.93,9.94 16.44,9.71C16.95,9.5 17.5,9.36 18.13,9.36C19.11,9.36 19.87,9.6 20.42,10.09C20.97,10.58 21.26,11.25 21.28,12.11V16C21.28,16.8 21.38,17.42 21.58,17.88V18H20.06M17.66,16.88C18.11,16.88 18.54,16.77 18.95,16.56C19.35,16.35 19.65,16.07 19.83,15.73V14.16H18.7C16.93,14.16 16.04,14.63 16.04,15.57C16.04,16 16.19,16.3 16.5,16.53C16.8,16.76 17.18,16.88 17.66,16.88M5.46,13.71H9.53L7.5,8.29L5.46,13.71M6.64,6H8.36L13.07,18H11.14L10.17,15.43H4.82L3.86,18H1.93L6.64,6Z";
var mdiFormatLetterCaseLower = "M20.06,18C20,17.83 19.91,17.54 19.86,17.11C19.19,17.81 18.38,18.16 17.45,18.16C16.62,18.16 15.93,17.92 15.4,17.45C14.87,17 14.6,16.39 14.6,15.66C14.6,14.78 14.93,14.1 15.6,13.61C16.27,13.12 17.21,12.88 18.43,12.88H19.83V12.24C19.83,11.75 19.68,11.36 19.38,11.07C19.08,10.78 18.63,10.64 18.05,10.64C17.53,10.64 17.1,10.76 16.75,11C16.4,11.25 16.23,11.54 16.23,11.89H14.77C14.77,11.46 14.92,11.05 15.22,10.65C15.5,10.25 15.93,9.94 16.44,9.71C16.95,9.5 17.5,9.36 18.13,9.36C19.11,9.36 19.87,9.6 20.42,10.09C20.97,10.58 21.26,11.25 21.28,12.11V16C21.28,16.8 21.38,17.42 21.58,17.88V18H20.06M17.66,16.88C18.11,16.88 18.54,16.77 18.95,16.56C19.35,16.35 19.65,16.07 19.83,15.73V14.16H18.7C16.93,14.16 16.04,14.63 16.04,15.57C16.04,16 16.19,16.3 16.5,16.53C16.8,16.76 17.18,16.88 17.66,16.88M5.46,13.71H9.53L7.5,8.29L5.46,13.71M6.64,6H8.36L13.07,18H11.14L10.17,15.43H4.82L3.86,18H1.93L6.64,6M22,20V22H14.5V20H22Z";
var mdiFormatLetterCaseUpper = "M20.06,18C20,17.83 19.91,17.54 19.86,17.11C19.19,17.81 18.38,18.16 17.45,18.16C16.62,18.16 15.93,17.92 15.4,17.45C14.87,17 14.6,16.39 14.6,15.66C14.6,14.78 14.93,14.1 15.6,13.61C16.27,13.12 17.21,12.88 18.43,12.88H19.83V12.24C19.83,11.75 19.68,11.36 19.38,11.07C19.08,10.78 18.63,10.64 18.05,10.64C17.53,10.64 17.1,10.76 16.75,11C16.4,11.25 16.23,11.54 16.23,11.89H14.77C14.77,11.46 14.92,11.05 15.22,10.65C15.5,10.25 15.93,9.94 16.44,9.71C16.95,9.5 17.5,9.36 18.13,9.36C19.11,9.36 19.87,9.6 20.42,10.09C20.97,10.58 21.26,11.25 21.28,12.11V16C21.28,16.8 21.38,17.42 21.58,17.88V18H20.06M17.66,16.88C18.11,16.88 18.54,16.77 18.95,16.56C19.35,16.35 19.65,16.07 19.83,15.73V14.16H18.7C16.93,14.16 16.04,14.63 16.04,15.57C16.04,16 16.19,16.3 16.5,16.53C16.8,16.76 17.18,16.88 17.66,16.88M5.46,13.71H9.53L7.5,8.29L5.46,13.71M6.64,6H8.36L13.07,18H11.14L10.17,15.43H4.82L3.86,18H1.93L6.64,6M2,20H13V22H2V20Z";
var mdiFormatLetterEndsWith = "M11.14 4L6.43 16H8.36L9.32 13.43H14.67L15.64 16H17.57L12.86 4M12 6.29L14.03 11.71H9.96M20 14V18H2V20H22V14Z";
var mdiFormatLetterMatches = "M11.14 4L6.43 16H8.36L9.32 13.43H14.67L15.64 16H17.57L12.86 4M12 6.29L14.03 11.71H9.96M20 14V18H4V15H2V20H22V14Z";
var mdiFormatLetterSpacing = "M14.4 10.7H18.5L16.5 5.3L14.4 10.7M15.6 3H17.3L22 15H20.1L19.1 12.4H13.7L12.7 15H10.8L15.6 3M11.2 3H13.1L8.4 15H6.7L2 3H3.9L7.5 12.7M19 22V20H5V22L2 19L5 16V18H19V16L22 19L19 22Z";
var mdiFormatLetterSpacingVariant = "M22 3V21H20V3H22M4 3V21H2V3H4M10 13.7H14L12 8.3L10 13.7M11.2 6H12.9L17.6 18H15.6L14.7 15.4H9.4L8.5 18H6.5L11.2 6Z";
var mdiFormatLetterStartsWith = "M11.14 4L6.43 16H8.36L9.32 13.43H14.67L15.64 16H17.57L12.86 4M12 6.29L14.03 11.71H9.96M4 18V15H2V20H22V18Z";
var mdiFormatLineHeight = "M21 22H3V20H21V22M21 4H3V2H21V4M10 13.7H14L12 8.3L10 13.7M11.2 6H12.9L17.6 18H15.6L14.7 15.4H9.4L8.5 18H6.5L11.2 6Z";
var mdiFormatLineSpacing = "M10,13H22V11H10M10,19H22V17H10M10,7H22V5H10M6,7H8.5L5,3.5L1.5,7H4V17H1.5L5,20.5L8.5,17H6V7Z";
var mdiFormatLineStyle = "M3,16H8V14H3V16M9.5,16H14.5V14H9.5V16M16,16H21V14H16V16M3,20H5V18H3V20M7,20H9V18H7V20M11,20H13V18H11V20M15,20H17V18H15V20M19,20H21V18H19V20M3,12H11V10H3V12M13,12H21V10H13V12M3,4V8H21V4H3Z";
var mdiFormatLineWeight = "M3,17H21V15H3V17M3,20H21V19H3V20M3,13H21V10H3V13M3,4V8H21V4H3Z";
var mdiFormatListBulleted = "M7,5H21V7H7V5M7,13V11H21V13H7M4,4.5A1.5,1.5 0 0,1 5.5,6A1.5,1.5 0 0,1 4,7.5A1.5,1.5 0 0,1 2.5,6A1.5,1.5 0 0,1 4,4.5M4,10.5A1.5,1.5 0 0,1 5.5,12A1.5,1.5 0 0,1 4,13.5A1.5,1.5 0 0,1 2.5,12A1.5,1.5 0 0,1 4,10.5M7,19V17H21V19H7M4,16.5A1.5,1.5 0 0,1 5.5,18A1.5,1.5 0 0,1 4,19.5A1.5,1.5 0 0,1 2.5,18A1.5,1.5 0 0,1 4,16.5Z";
var mdiFormatListBulletedSquare = "M3,4H7V8H3V4M9,5V7H21V5H9M3,10H7V14H3V10M9,11V13H21V11H9M3,16H7V20H3V16M9,17V19H21V17H9";
var mdiFormatListBulletedTriangle = "M5,15.5L7.5,20H2.5L5,15.5M9,19H21V17H9V19M5,9.5L7.5,14H2.5L5,9.5M9,13H21V11H9V13M5,3.5L7.5,8H2.5L5,3.5M9,7H21V5H9V7Z";
var mdiFormatListBulletedType = "M5,9.5L7.5,14H2.5L5,9.5M3,4H7V8H3V4M5,20A2,2 0 0,0 7,18A2,2 0 0,0 5,16A2,2 0 0,0 3,18A2,2 0 0,0 5,20M9,5V7H21V5H9M9,19H21V17H9V19M9,13H21V11H9V13Z";
var mdiFormatListCheckbox = "M21,19V17H8V19H21M21,13V11H8V13H21M8,7H21V5H8V7M4,5V7H6V5H4M3,5A1,1 0 0,1 4,4H6A1,1 0 0,1 7,5V7A1,1 0 0,1 6,8H4A1,1 0 0,1 3,7V5M4,11V13H6V11H4M3,11A1,1 0 0,1 4,10H6A1,1 0 0,1 7,11V13A1,1 0 0,1 6,14H4A1,1 0 0,1 3,13V11M4,17V19H6V17H4M3,17A1,1 0 0,1 4,16H6A1,1 0 0,1 7,17V19A1,1 0 0,1 6,20H4A1,1 0 0,1 3,19V17Z";
var mdiFormatListChecks = "M3,5H9V11H3V5M5,7V9H7V7H5M11,7H21V9H11V7M11,15H21V17H11V15M5,20L1.5,16.5L2.91,15.09L5,17.17L9.59,12.59L11,14L5,20Z";
var mdiFormatListGroup = "M5 5V19H7V21H3V3H7V5H5M20 7H7V9H20V7M20 11H7V13H20V11M20 15H7V17H20V15Z";
var mdiFormatListGroupPlus = "M17 14V17H14V19H17V22H19V19H22V17H19V14M20 11V12.3C19.4 12.1 18.7 12 18 12C16.8 12 15.6 12.4 14.7 13H7V11H20M12.1 17H7V15H12.8C12.5 15.6 12.2 16.3 12.1 17M7 7H20V9H7V7M5 19H7V21H3V3H7V5H5V19Z";
var mdiFormatListNumbered = "M7,13V11H21V13H7M7,19V17H21V19H7M7,7V5H21V7H7M3,8V5H2V4H4V8H3M2,17V16H5V20H2V19H4V18.5H3V17.5H4V17H2M4.25,10A0.75,0.75 0 0,1 5,10.75C5,10.95 4.92,11.14 4.79,11.27L3.12,13H5V14H2V13.08L4,11H2V10H4.25Z";
var mdiFormatListNumberedRtl = "M3,13V11H17V13H3M3,19V17H17V19H3M3,7V5H17V7H3M20,8V5H19V4H21V8H20M19,17V16H22V20H19V19H21V18.5H20V17.5H21V17H19M21.25,10C21.67,10 22,10.34 22,10.75C22,10.95 21.92,11.14 21.79,11.27L20.12,13H22V14H19V13.08L21,11H19V10H21.25Z";
var mdiFormatListText = "M2 14H8V20H2M16 8H10V10H16M2 10H8V4H2M10 4V6H22V4M10 20H16V18H10M10 16H22V14H10";
var mdiFormatOverline = "M5,5H19V3H5V5M9.62,16L12,9.67L14.37,16M11,7L5.5,21H7.75L8.87,18H15.12L16.25,21H18.5L13,7H11Z";
var mdiFormatPageBreak = "M18,20H6V18H4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V18H18V20M14,2H6A2,2 0 0,0 4,4V12H6V4H14V8H18V12H20V8L14,2M11,16H8V14H11V16M16,16H13V14H16V16M3,14H6V16H3V14M21,16H18V14H21V16Z";
var mdiFormatPageSplit = "M11 11V7H13V11H11M13 1V5H11V1H13M11 17V13H13V17H11M9 20H6V4H9V2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H9V20M15 3V8H18V20H15V22H18C19.11 22 20 21.11 20 20V8L15 3M13 19H11V23H13V19Z";
var mdiFormatPaint = "M18,4V3A1,1 0 0,0 17,2H5A1,1 0 0,0 4,3V7A1,1 0 0,0 5,8H17A1,1 0 0,0 18,7V6H19V10H9V21A1,1 0 0,0 10,22H12A1,1 0 0,0 13,21V12H21V4H18Z";
var mdiFormatParagraph = "M13,4A4,4 0 0,1 17,8A4,4 0 0,1 13,12H11V18H9V4H13M13,10A2,2 0 0,0 15,8A2,2 0 0,0 13,6H11V10H13Z";
var mdiFormatParagraphSpacing = "M3 17H21V19H3V17M3 2H21V4H3V2M3 20H21V22H3V20M13 8H15L12 5L9 8H11V13H9L12 16L15 13H13V8Z";
var mdiFormatPilcrow = "M10,11A4,4 0 0,1 6,7A4,4 0 0,1 10,3H18V5H16V21H14V5H12V21H10V11Z";
var mdiFormatPilcrowArrowLeft = "M8,17V14L4,18L8,22V19H20V17M10,10V15H12V4H14V15H16V4H18V2H10A4,4 0 0,0 6,6A4,4 0 0,0 10,10Z";
var mdiFormatPilcrowArrowRight = "M21,18L17,14V17H5V19H17V22M9,10V15H11V4H13V15H15V4H17V2H9A4,4 0 0,0 5,6A4,4 0 0,0 9,10Z";
var mdiFormatQuoteClose = "M14,17H17L19,13V7H13V13H16M6,17H9L11,13V7H5V13H8L6,17Z";
var mdiFormatQuoteCloseOutline = "M13 6V14H14.88L12.88 18H18.62L21 13.24V6M15 8H19V12.76L17.38 16H16.12L18.12 12H15M3 6V14H4.88L2.88 18H8.62L11 13.24V6M5 8H9V12.76L7.38 16H6.12L8.12 12H5Z";
var mdiFormatQuoteOpen = "M10,7L8,11H11V17H5V11L7,7H10M18,7L16,11H19V17H13V11L15,7H18Z";
var mdiFormatQuoteOpenOutline = "M11 18V10H9.12L11.12 6H5.38L3 10.76V18M9 16H5V11.24L6.62 8H7.88L5.88 12H9M21 18V10H19.12L21.12 6H15.38L13 10.76V18M19 16H15V11.24L16.62 8H17.88L15.88 12H19Z";
var mdiFormatRotate90 = "M7.34,6.41L0.86,12.9L7.35,19.38L13.84,12.9L7.34,6.41M3.69,12.9L7.35,9.24L11,12.9L7.34,16.56L3.69,12.9M19.36,6.64C17.61,4.88 15.3,4 13,4V0.76L8.76,5L13,9.24V6C14.79,6 16.58,6.68 17.95,8.05C20.68,10.78 20.68,15.22 17.95,17.95C16.58,19.32 14.79,20 13,20C12.03,20 11.06,19.79 10.16,19.39L8.67,20.88C10,21.62 11.5,22 13,22C15.3,22 17.61,21.12 19.36,19.36C22.88,15.85 22.88,10.15 19.36,6.64Z";
var mdiFormatSection = "M15.67,4.42C14.7,3.84 13.58,3.54 12.45,3.56C10.87,3.56 9.66,4.34 9.66,5.56C9.66,6.96 11,7.47 13,8.14C15.5,8.95 17.4,9.97 17.4,12.38C17.36,13.69 16.69,14.89 15.6,15.61C16.25,16.22 16.61,17.08 16.6,17.97C16.6,20.79 14,21.97 11.5,21.97C10.04,22.03 8.59,21.64 7.35,20.87L8,19.34C9.04,20.05 10.27,20.43 11.53,20.44C13.25,20.44 14.53,19.66 14.53,18.24C14.53,17 13.75,16.31 11.25,15.45C8.5,14.5 6.6,13.5 6.6,11.21C6.67,9.89 7.43,8.69 8.6,8.07C7.97,7.5 7.61,6.67 7.6,5.81C7.6,3.45 9.77,2 12.53,2C13.82,2 15.09,2.29 16.23,2.89L15.67,4.42M11.35,13.42C12.41,13.75 13.44,14.18 14.41,14.71C15.06,14.22 15.43,13.45 15.41,12.64C15.41,11.64 14.77,10.76 13,10.14C11.89,9.77 10.78,9.31 9.72,8.77C8.97,9.22 8.5,10.03 8.5,10.91C8.5,11.88 9.23,12.68 11.35,13.42Z";
var mdiFormatSize = "M2 4V7H7V19H10V7H15V4H2M21 9H12V12H15V19H18V12H21V9Z";
var mdiFormatStrikethrough = "M3,14H21V12H3M5,4V7H10V10H14V7H19V4M10,19H14V16H10V19Z";
var mdiFormatStrikethroughVariant = "M7.2 9.8C6 7.5 7.7 4.8 10.1 4.3C13.2 3.3 17.7 4.7 17.6 8.5H14.6C14.6 8.2 14.5 7.9 14.5 7.7C14.3 7.1 13.9 6.8 13.3 6.6C12.5 6.3 11.2 6.4 10.5 6.9C9 8.2 10.4 9.5 12 10H7.4C7.3 9.9 7.3 9.8 7.2 9.8M21 13V11H3V13H12.6C12.8 13.1 13 13.1 13.2 13.2C13.8 13.5 14.3 13.7 14.5 14.3C14.6 14.7 14.7 15.2 14.5 15.6C14.3 16.1 13.9 16.3 13.4 16.5C11.6 17 9.4 16.3 9.5 14.1H6.5C6.4 16.7 8.6 18.5 11 18.8C14.8 19.6 19.3 17.2 17.3 12.9L21 13Z";
var mdiFormatSubscript = "M16,7.41L11.41,12L16,16.59L14.59,18L10,13.41L5.41,18L4,16.59L8.59,12L4,7.41L5.41,6L10,10.59L14.59,6L16,7.41M21.85,21.03H16.97V20.03L17.86,19.23C18.62,18.58 19.18,18.04 19.56,17.6C19.93,17.16 20.12,16.75 20.13,16.36C20.14,16.08 20.05,15.85 19.86,15.66C19.68,15.5 19.39,15.38 19,15.38C18.69,15.38 18.42,15.44 18.16,15.56L17.5,15.94L17.05,14.77C17.32,14.56 17.64,14.38 18.03,14.24C18.42,14.1 18.85,14 19.32,14C20.1,14.04 20.7,14.25 21.1,14.66C21.5,15.07 21.72,15.59 21.72,16.23C21.71,16.79 21.53,17.31 21.18,17.78C20.84,18.25 20.42,18.7 19.91,19.14L19.27,19.66V19.68H21.85V21.03Z";
var mdiFormatSuperscript = "M16,7.41L11.41,12L16,16.59L14.59,18L10,13.41L5.41,18L4,16.59L8.59,12L4,7.41L5.41,6L10,10.59L14.59,6L16,7.41M21.85,9H16.97V8L17.86,7.18C18.62,6.54 19.18,6 19.56,5.55C19.93,5.11 20.12,4.7 20.13,4.32C20.14,4.04 20.05,3.8 19.86,3.62C19.68,3.43 19.39,3.34 19,3.33C18.69,3.34 18.42,3.4 18.16,3.5L17.5,3.89L17.05,2.72C17.32,2.5 17.64,2.33 18.03,2.19C18.42,2.05 18.85,2 19.32,2C20.1,2 20.7,2.2 21.1,2.61C21.5,3 21.72,3.54 21.72,4.18C21.71,4.74 21.53,5.26 21.18,5.73C20.84,6.21 20.42,6.66 19.91,7.09L19.27,7.61V7.63H21.85V9Z";
var mdiFormatText = "M18.5,4L19.66,8.35L18.7,8.61C18.25,7.74 17.79,6.87 17.26,6.43C16.73,6 16.11,6 15.5,6H13V16.5C13,17 13,17.5 13.33,17.75C13.67,18 14.33,18 15,18V19H9V18C9.67,18 10.33,18 10.67,17.75C11,17.5 11,17 11,16.5V6H8.5C7.89,6 7.27,6 6.74,6.43C6.21,6.87 5.75,7.74 5.3,8.61L4.34,8.35L5.5,4H18.5Z";
var mdiFormatTextRotationAngleDown = "M14.25 21H10.03L11.44 19.59L2.58 10.73L4.03 9.33L12.84 18.19L14.25 16.78M12.61 8L15.23 10.64L17.43 5.77M19.41 4.92L14.95 16.03L13.5 14.58L14.39 12.38L10.88 8.81L8.68 9.75L7.22 8.25L18.33 3.84Z";
var mdiFormatTextRotationAngleUp = "M20.58 9.33V13.55L19.17 12.14L10.31 21L8.91 19.59L17.72 10.73L16.31 9.33M7.59 11L10.22 8.39L5.34 6.14M4.5 4.22L15.61 8.63L14.16 10.13L11.96 9.19L8.39 12.75L9.33 14.91L7.83 16.41L3.42 5.25Z";
var mdiFormatTextRotationDown = "M6,19.73L3,16.73H5V4.27H7V16.73H9L6,19.73M14,9.38V13.13L19.03,11.25L14,9.38M21,12L10,16.73V14.67L12.19,13.73V8.77L10,7.83V5.77L21,10.5V12Z";
var mdiFormatTextRotationDownVertical = "M15.25 4H13.75L9 15H11.1L12 12.8H17L17.9 15H20L15.25 4M12.63 11L14.5 6L16.37 11H12.63M5 17.5L8 14.5H6V2H4V14.5H2L5 17.5M22 20L19 17V19H6.5V21H19V23L22 20Z";
var mdiFormatTextRotationNone = "M20.5,18L17.5,21V19H5V17H17.5V15L20.5,18M10.13,10H13.88L12,4.97L10.13,10M12.75,3L17.5,14H15.42L14.5,11.81H9.5L8.58,14H6.5L11.25,3H12.75Z";
var mdiFormatTextRotationUp = "M3 12V13.5L14 18.25V16.15L11.8 15.25V10.25L14 9.35V7.25L3 12M10 14.62L5 12.75L10 10.88V14.62M18 4.25L15 7.25H17V19.75H19V7.25H21L18 4.25Z";
var mdiFormatTextRotationVertical = "M15.75 5H14.25L9.5 16H11.6L12.5 13.8H17.5L18.4 16H20.5L15.75 5M13.13 12L15 7L16.87 12H13.13M6 19.75L9 16.75H7V4.25H5V16.75H3L6 19.75Z";
var mdiFormatTextVariant = "M9.6,14L12,7.7L14.4,14M11,5L5.5,19H7.7L8.8,16H15L16.1,19H18.3L13,5H11Z";
var mdiFormatTextVariantOutline = "M11 3C10.18 3 9.44 3.5 9.14 4.27L3.64 18.27C3.12 19.58 4.09 21 5.5 21H7.75C8.59 21 9.33 20.5 9.62 19.7L10.26 18H13.74L14.38 19.7C14.67 20.5 15.42 21 16.25 21H18.5C19.91 21 20.88 19.58 20.36 18.27L14.86 4.27C14.56 3.5 13.82 3 13 3M11 5H13L18.5 19H16.25L15.12 16H8.87L7.75 19H5.5M12 7.67L9.62 14H14.37Z";
var mdiFormatTextWrappingClip = "M7,21H5V3H7V21M17,3V11H9V13H17V21H19V3H17Z";
var mdiFormatTextWrappingOverflow = "M7,21H5V3H7V21M14,3H12V9H14V3M14,15H12V21H14V15M19,12L16,9V11H9V13H16V15L19,12Z";
var mdiFormatTextWrappingWrap = "M7,21H5V3H7V21M19,3H17V21H19V3M13,8H9V10H12.97C13.14,10 14,10.16 14,12C14,13.84 13.14,14 13,14H11V12L8,15L11,18V16H13C14.04,16 16,15.16 16,12C16,8.84 14.04,8 13,8Z";
var mdiFormatTextbox = "M21,7V3H17V4H7V3H3V7H4V17H3V21H7V20H17V21H21V17H20V7H21M18,4H20V6H18V4M4,4H6V6H4V4M6,20H4V18H6V20M20,20H18V18H20V20M18,17H17V18H7V17H6V7H7V6H17V7H18V17M16,8V10H13V16H11V10H8V8H16Z";
var mdiFormatTitle = "M5,4V7H10.5V19H13.5V7H19V4H5Z";
var mdiFormatUnderline = "M5,21H19V19H5V21M12,17A6,6 0 0,0 18,11V3H15.5V11A3.5,3.5 0 0,1 12,14.5A3.5,3.5 0 0,1 8.5,11V3H6V11A6,6 0 0,0 12,17Z";
var mdiFormatUnderlineWavy = "M12 17C15.31 17 18 14.31 18 11V3H15.5V11C15.5 12.93 13.93 14.5 12 14.5S8.5 12.93 8.5 11V3H6V11C6 14.31 8.69 17 12 17M20 22C18.6 22 17.8 21.3 17.3 20.7C16.8 20.2 16.6 20 16 20S15.2 20.2 14.7 20.7C14.2 21.3 13.4 22 12 22S9.8 21.3 9.3 20.7C8.8 20.2 8.6 20 8 20S7.2 20.2 6.7 20.7C6.2 21.3 5.4 22 4 22V20C4.6 20 4.8 19.8 5.3 19.3C5.8 18.7 6.6 18 8 18S10.2 18.7 10.7 19.3C11.2 19.8 11.4 20 12 20S12.8 19.8 13.3 19.3C13.8 18.7 14.6 18 16 18S18.2 18.7 18.7 19.3C19.2 19.8 19.4 20 20 20V22Z";
var mdiFormatVerticalAlignBottom = "M16,13H13V3H11V13H8L12,17L16,13M4,19V21H20V19H4Z";
var mdiFormatVerticalAlignCenter = "M8,19H11V23H13V19H16L12,15L8,19M16,5H13V1H11V5H8L12,9L16,5M4,11V13H20V11H4Z";
var mdiFormatVerticalAlignTop = "M8,11H11V21H13V11H16L12,7L8,11M4,3V5H20V3H4Z";
var mdiFormatWrapInline = "M8,7L13,17H3L8,7M3,3H21V5H3V3M21,15V17H14V15H21M3,19H21V21H3V19Z";
var mdiFormatWrapSquare = "M12,7L17,17H7L12,7M3,3H21V5H3V3M3,7H6V9H3V7M21,7V9H18V7H21M3,11H6V13H3V11M21,11V13H18V11H21M3,15H6V17H3V15M21,15V17H18V15H21M3,19H21V21H3V19Z";
var mdiFormatWrapTight = "M12,7L17,17H7L12,7M3,3H21V5H3V3M3,7H9V9H3V7M21,7V9H15V7H21M3,11H7V13H3V11M21,11V13H17V11H21M3,15H6V17H3V15M21,15V17H18V15H21M3,19H21V21H3V19Z";
var mdiFormatWrapTopBottom = "M12,7L17,17H7L12,7M3,3H21V5H3V3M3,19H21V21H3V19Z";
var mdiForum = "M17,12V3A1,1 0 0,0 16,2H3A1,1 0 0,0 2,3V17L6,13H16A1,1 0 0,0 17,12M21,6H19V15H6V17A1,1 0 0,0 7,18H18L22,22V7A1,1 0 0,0 21,6Z";
var mdiForumMinus = "M21 6H19V12.1C20.2 12.3 21.2 12.8 22 13.5V7C22 6.5 21.5 6 21 6M6 17C6 17.5 6.5 18 7 18H12C12 16.9 12.3 15.9 12.8 15H6V17M16 2H3C2.5 2 2 2.5 2 3V17L6 13H14.7C15.4 12.5 16.2 12.2 17 12.1V3C17 2.5 16.5 2 16 2M22 17V19H14V17H22Z";
var mdiForumMinusOutline = "M21 6H19V12.1C20.2 12.3 21.2 12.8 22 13.5V7C22 6.5 21.5 6 21 6M6 17C6 17.5 6.5 18 7 18H12C12 16.9 12.3 15.9 12.8 15H6V17M16 2H3C2.5 2 2 2.5 2 3V17L6 13H14.7C15.4 12.5 16.2 12.2 17 12.1V3C17 2.5 16.5 2 16 2M15 11H5.2L4 12.2V4H15V11M22 17V19H14V17H22Z";
var mdiForumOutline = "M15,4V11H5.17L4,12.17V4H15M16,2H3A1,1 0 0,0 2,3V17L6,13H16A1,1 0 0,0 17,12V3A1,1 0 0,0 16,2M21,6H19V15H6V17A1,1 0 0,0 7,18H18L22,22V7A1,1 0 0,0 21,6Z";
var mdiForumPlus = "M21 6H19V12.1C20.2 12.3 21.2 12.8 22 13.5V7C22 6.5 21.5 6 21 6M6 17C6 17.5 6.5 18 7 18H12C12 16.9 12.3 15.9 12.8 15H6V17M16 2H3C2.5 2 2 2.5 2 3V17L6 13H14.7C15.4 12.5 16.2 12.2 17 12.1V3C17 2.5 16.5 2 16 2M17 14H19V17H22V19H19V22H17V19H14V17H17V14Z";
var mdiForumPlusOutline = "M21 6H19V12.1C20.2 12.3 21.2 12.8 22 13.5V7C22 6.5 21.5 6 21 6M6 17C6 17.5 6.5 18 7 18H12C12 16.9 12.3 15.9 12.8 15H6V17M16 2H3C2.5 2 2 2.5 2 3V17L6 13H14.7C15.4 12.5 16.2 12.2 17 12.1V3C17 2.5 16.5 2 16 2M15 11H5.2L4 12.2V4H15V11M17 14H19V17H22V19H19V22H17V19H14V17H17V14Z";
var mdiForumRemove = "M21 6H19V12.1C20.2 12.3 21.2 12.8 22 13.5V7C22 6.5 21.5 6 21 6M6 17C6 17.5 6.5 18 7 18H12C12 16.9 12.3 15.9 12.8 15H6V17M16 2H3C2.5 2 2 2.5 2 3V17L6 13H14.7C15.4 12.5 16.2 12.2 17 12.1V3C17 2.5 16.5 2 16 2M20.12 14.46L21.54 15.88L19.41 18L21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.47 20.12L16.59 18L14.47 15.88L15.88 14.47L18 16.59L20.12 14.46Z";
var mdiForumRemoveOutline = "M21 6H19V12.1C20.2 12.3 21.2 12.8 22 13.5V7C22 6.5 21.5 6 21 6M6 17C6 17.5 6.5 18 7 18H12C12 16.9 12.3 15.9 12.8 15H6V17M16 2H3C2.5 2 2 2.5 2 3V17L6 13H14.7C15.4 12.5 16.2 12.2 17 12.1V3C17 2.5 16.5 2 16 2M15 11H5.2L4 12.2V4H15V11M20.12 14.46L21.54 15.88L19.41 18L21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.47 20.12L16.59 18L14.47 15.88L15.88 14.47L18 16.59L20.12 14.46Z";
var mdiForward = "M12,8V4L20,12L12,20V16H4V8H12Z";
var mdiForwardburger = "M19,13H3V11H19L15,7L16.4,5.6L22.8,12L16.4,18.4L15,17L19,13M3,6H13V8H3V6M13,16V18H3V16H13Z";
var mdiFountain = "M7.5,2C4.47,2 2,4.46 2,7.5V7.5L2,8H4V7.5A3.5,3.5 0 0,1 7.5,4C9,4 10.26,4.93 10.76,6.24C10.37,6.08 9.95,6 9.5,6C8.11,6 6.9,6.82 6.34,8L8.08,9C8.29,8.42 8.85,8 9.5,8A1.5,1.5 0 0,1 11,9.5V11H13V9.5A1.5,1.5 0 0,1 14.5,8C15.16,8 15.71,8.42 15.92,9L17.66,8C17.1,6.82 15.9,6 14.5,6C14.05,6 13.63,6.08 13.24,6.24C13.74,4.93 15,4 16.5,4A3.5,3.5 0 0,1 20,7.5V8H22V7.5H22A5.5,5.5 0 0,0 16.5,2C14.64,2 13,2.93 12,4.34C11,2.93 9.36,2 7.5,2M6,12V14H7.42C7.92,15.15 8.85,16.07 10,16.57C10,17.38 10,18.19 10,19H2C2,19 2.82,20.23 3.41,21.11C3.78,21.67 4.4,22 5.07,22H18.93C19.6,22 20.22,21.67 20.59,21.11L22,19H14C14,18.19 14,17.38 14,16.57C15.15,16.07 16.08,15.15 16.58,14H18V12H6Z";
var mdiFountainPen = "M6.95,14.93L11.19,9.27L19.68,2.2C20.07,1.81 20.72,1.81 21.09,2.2L21.8,2.91C22.19,3.28 22.19,3.93 21.8,4.32L14.73,12.81L9.07,17.05L6.95,14.93M8.36,17.76L6.24,15.64L3.41,17.05L2,21.29L4.12,19.17C4.32,19 4.63,19 4.83,19.17C5,19.37 5,19.68 4.83,19.88L2.71,22L6.95,20.59L8.36,17.76Z";
var mdiFountainPenTip = "M15.54,3.5L20.5,8.47L19.07,9.88L14.12,4.93L15.54,3.5M3.5,19.78L10,13.31C9.9,13 9.97,12.61 10.23,12.35C10.62,11.96 11.26,11.96 11.65,12.35C12.04,12.75 12.04,13.38 11.65,13.77C11.39,14.03 11,14.1 10.69,14L4.22,20.5L14.83,16.95L18.36,10.59L13.42,5.64L7.05,9.17L3.5,19.78Z";
var mdiFractionOneHalf = "M5.79 21.61L4.21 20.39L18.21 2.39L19.79 3.61L5.79 21.61M4 2V4H6V12H8V2H4M15 12V14H19V16H17C15.9 16 15 16.9 15 18V22H21V20H17V18H19C20.11 18 21 17.11 21 16V14C21 12.9 20.11 12 19 12H15Z";
var mdiFreebsd = "M2.69,2C3.54,1.95 6.08,3.16 6.13,3.19C4.84,4 3.74,5.09 2.91,6.38C2.09,4.81 1.34,2.91 2,2.25C2.17,2.08 2.4,2 2.69,2M20.84,2.13C21.25,2.08 21.58,2.14 21.78,2.34C22.85,3.42 19.88,8.15 19.38,8.66C18.87,9.16 17.57,8.7 16.5,7.63C15.43,6.55 14.97,5.26 15.47,4.75C15.88,4.34 19.09,2.3 20.84,2.13M12,2.56C13.29,2.56 14.53,2.82 15.66,3.28C15.17,3.6 14.81,3.85 14.69,3.97C13.7,4.96 14.14,6.83 15.72,8.41C16.7,9.38 17.84,9.97 18.78,9.97C19.46,9.97 19.92,9.68 20.16,9.44C20.33,9.27 20.6,8.88 20.91,8.41C21.42,9.59 21.69,10.88 21.69,12.25C21.69,17.61 17.36,21.97 12,21.97C6.64,21.97 2.31,17.61 2.31,12.25C2.31,6.89 6.64,2.56 12,2.56Z";
var mdiFrenchFries = "M18 11V6H15V4H12V2H8V5H6V11H5L7 22H17L19 11H18M15.86 11C15.7 11.61 15.4 12.16 15 12.62V8.62L17 9.62V11H15.86M17 7V8.5L15 7.5V7H17M12 5H14V8.5L12 9.5V5M12 10.62L14 9.62V13.45C13.41 13.8 12.73 14 12 14V10.62M11 13.86C10.21 13.65 9.5 13.22 9 12.62V9.62L11 8.62V13.86M9 3H11V7.5L10 8V5H9V3M7 6H9V8.5L8 9V11H7V6Z";
var mdiFrequentlyAskedQuestions = "M18,15H6L2,19V3A1,1 0 0,1 3,2H18A1,1 0 0,1 19,3V14A1,1 0 0,1 18,15M23,9V23L19,19H8A1,1 0 0,1 7,18V17H21V8H22A1,1 0 0,1 23,9M8.19,4C7.32,4 6.62,4.2 6.08,4.59C5.56,5 5.3,5.57 5.31,6.36L5.32,6.39H7.25C7.26,6.09 7.35,5.86 7.53,5.7C7.71,5.55 7.93,5.47 8.19,5.47C8.5,5.47 8.76,5.57 8.94,5.75C9.12,5.94 9.2,6.2 9.2,6.5C9.2,6.82 9.13,7.09 8.97,7.32C8.83,7.55 8.62,7.75 8.36,7.91C7.85,8.25 7.5,8.55 7.31,8.82C7.11,9.08 7,9.5 7,10H9C9,9.69 9.04,9.44 9.13,9.26C9.22,9.08 9.39,8.9 9.64,8.74C10.09,8.5 10.46,8.21 10.75,7.81C11.04,7.41 11.19,7 11.19,6.5C11.19,5.74 10.92,5.13 10.38,4.68C9.85,4.23 9.12,4 8.19,4M7,11V13H9V11H7M13,13H15V11H13V13M13,4V10H15V4H13Z";
var mdiFridge = "M7,2H17A2,2 0 0,1 19,4V9H5V4A2,2 0 0,1 7,2M19,19A2,2 0 0,1 17,21V22H15V21H9V22H7V21A2,2 0 0,1 5,19V10H19V19M8,5V7H10V5H8M8,12V15H10V12H8Z";
var mdiFridgeAlert = "M5 2H15C16.11 2 17 2.9 17 4V9H3V4C3 2.9 3.9 2 5 2M17 19C17 20.11 16.11 21 15 21V22H13V21H7V22H5V21C3.9 21 3 20.11 3 19V10H17V19M6 5V7H8V5H6M6 12V15H8V12H6M19 15H21V17H19V15M19 7H21V13H19V7Z";
var mdiFridgeAlertOutline = "M7 21V22H5V21C3.9 21 3 20.11 3 19V4C3 2.9 3.9 2 5 2H15C16.11 2 17 2.9 17 4V19C17 20.11 16.11 21 15 21V22H13V21H7M5 4V9H15V4H5M5 19H15V11H5V19M6 12H8V15H6V12M6 6H8V8H6V6M19 15H21V17H19V15M19 7H21V13H19V7Z";
var mdiFridgeBottom = "M7,2A2,2 0 0,0 5,4V19A2,2 0 0,0 7,21V22H9V21H15V22H17V21A2,2 0 0,0 19,19V4A2,2 0 0,0 17,2H7M8,6H10V8H8V6M7,11H17V19H7V11M8,12V15H10V12H8Z";
var mdiFridgeIndustrial = "M17 2H7C5.9 2 5 2.9 5 4V19C5 20.11 5.9 21 7 21V22H9V21H15V22H17V21C18.11 21 19 20.11 19 19V4C19 2.9 18.11 2 17 2M10 15H8V10H10V15Z";
var mdiFridgeIndustrialAlert = "M15 2H5C3.9 2 3 2.9 3 4V19C3 20.11 3.9 21 5 21V22H7V21H13V22H15V21C16.11 21 17 20.11 17 19V4C17 2.9 16.11 2 15 2M8 15H6V10H8V15M21 7V13H19V7H21M19 15H21V17H19V15Z";
var mdiFridgeIndustrialAlertOutline = "M8 15H6V10H8V15M17 4V19C17 20.11 16.11 21 15 21V22H13V21H7V22H5V21C3.9 21 3 20.11 3 19V4C3 2.9 3.9 2 5 2H15C16.11 2 17 2.9 17 4M15 4H5V19H15V4M19 17H21V15H19V17M19 7V13H21V7H19Z";
var mdiFridgeIndustrialOff = "M19 15.8L5.7 2.5C6.05 2.19 6.5 2 7 2H17C18.11 2 19 2.9 19 4V15.8M22.11 21.46L20.84 22.73L18.46 20.35C18.1 20.75 17.58 21 17 21V22H15V21H9V22H7V21C5.9 21 5 20.11 5 19V6.89L1.11 3L2.39 1.73L22.11 21.46M10 11.89L8.11 10H8V15H10V11.89Z";
var mdiFridgeIndustrialOffOutline = "M7.2 4L5.7 2.5C6.05 2.19 6.5 2 7 2H17C18.11 2 19 2.9 19 4V15.8L17 13.8V4H7.2M22.11 21.46L20.84 22.73L18.46 20.35C18.1 20.75 17.58 21 17 21V22H15V21H9V22H7V21C5.9 21 5 20.11 5 19V6.89L1.11 3L2.39 1.73L22.11 21.46M17 18.89L10 11.89V15H8V10H8.11L7 8.89V19H17V18.89Z";
var mdiFridgeIndustrialOutline = "M17 2H7C5.9 2 5 2.9 5 4V19C5 20.11 5.9 21 7 21V22H9V21H15V22H17V21C18.11 21 19 20.11 19 19V4C19 2.9 18.11 2 17 2M17 19H7V4H17V19M10 15H8V10H10V15Z";
var mdiFridgeOff = "M22.11 21.46L2.39 1.73L1.11 3L5 6.89V9H7.11L8.11 10H5V19C5 20.11 5.9 21 7 21V22H9V21H15V22H17V21C17.58 21 18.1 20.75 18.46 20.35L20.84 22.73L22.11 21.46M10 15H8V12H10V15M19 15.8L13.2 10H19V15.8M8.2 5L5.7 2.5C6.05 2.19 6.5 2 7 2H17C18.11 2 19 2.9 19 4V9H12.2L10 6.8V5H8.2Z";
var mdiFridgeOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L5 6.89V19C5 20.11 5.9 21 7 21V22H9V21H15V22H17V21C17.58 21 18.1 20.75 18.46 20.35L20.84 22.73L22.11 21.46M17 19H7V11H9.11L17 18.89V19M7.2 4L5.7 2.5C6.05 2.19 6.5 2 7 2H17C18.11 2 19 2.9 19 4V15.8L17 13.8V11H14.2L12.2 9H17V4H7.2M8 12H10V15H8V12Z";
var mdiFridgeOutline = "M9,21V22H7V21A2,2 0 0,1 5,19V4A2,2 0 0,1 7,2H17A2,2 0 0,1 19,4V19A2,2 0 0,1 17,21V22H15V21H9M7,4V9H17V4H7M7,19H17V11H7V19M8,12H10V15H8V12M8,6H10V8H8V6Z";
var mdiFridgeTop = "M8,8V6H10V8H8M7,2H17A2,2 0 0,1 19,4V19A2,2 0 0,1 17,21V22H15V21H9V22H7V21A2,2 0 0,1 5,19V4A2,2 0 0,1 7,2M7,4V9H17V4H7M8,12V15H10V12H8Z";
var mdiFridgeVariant = "M19 4V19C19 20.11 18.11 21 17 21V22H15V21H12.5V2H17C18.11 2 19 2.9 19 4M7 2H11.5V21H9V22H7V21C5.9 21 5 20.11 5 19V4C5 2.9 5.9 2 7 2M10 10H7V14H10V10Z";
var mdiFridgeVariantAlert = "M17 4V19C17 20.11 16.11 21 15 21V22H13V21H10.5V2H15C16.11 2 17 2.9 17 4M5 2H9.5V21H7V22H5V21C3.9 21 3 20.11 3 19V4C3 2.9 3.9 2 5 2M8 10H5V14H8V10M19 7V13H21V7H19M19 17H21V15H19V17Z";
var mdiFridgeVariantAlertOutline = "M15 2H5C3.9 2 3 2.9 3 4V19C3 20.11 3.9 21 5 21V22H7V21H13V22H15V21C16.11 21 17 20.11 17 19V4C17 2.9 16.11 2 15 2M9 19H5V14H8V10H5V4H9V19M15 19H11V4H15V19M19 15H21V17H19V15M21 7V13H19V7H21Z";
var mdiFridgeVariantOff = "M2.39 1.73L1.11 3L5 6.89V19C5 20.11 5.9 21 7 21V22H9V21H11.5V13.39L12.5 14.39V21H15V22H17V21C17.58 21 18.1 20.75 18.46 20.35L20.84 22.73L22.11 21.46L2.39 1.73M10 14H7V10H8.11L10 11.89V14M19 15.8L12.5 9.3V2H17C18.11 2 19 2.9 19 4V15.8M11.5 8.3L5.7 2.5C6.05 2.19 6.5 2 7 2H11.5V8.3Z";
var mdiFridgeVariantOffOutline = "M7.2 4L5.7 2.5C6.05 2.19 6.5 2 7 2H17C18.11 2 19 2.9 19 4V15.8L17 13.8V4H13V9.8L11 7.8V4H7.2M22.11 21.46L20.84 22.73L18.46 20.35C18.1 20.75 17.58 21 17 21V22H15V21H9V22H7V21C5.9 21 5 20.11 5 19V6.89L1.11 3L2.39 1.73L22.11 21.46M7 10H8.11L7 8.89V10M11 12.89L10 11.89V14H7V19H11V12.89M17 18.89L13 14.89V19H17V18.89Z";
var mdiFridgeVariantOutline = "M17 2H7C5.9 2 5 2.9 5 4V19C5 20.11 5.9 21 7 21V22H9V21H15V22H17V21C18.11 21 19 20.11 19 19V4C19 2.9 18.11 2 17 2M7 19V14H10V10H7V4H11V19H7M17 19H13V4H17V19Z";
var mdiFruitCherries = "M16 13H15.5C14.8 11.7 14.3 10 13.8 8.3L14.7 9.2C17.4 11.3 19.8 10.9 19.8 10.9S20.5 7.1 17.8 5.1C15.5 3.3 13.4 3.3 12.8 3.4C12.7 2.8 12.7 2.3 12.6 1.9L11.2 2C11.2 5.2 8.5 11.1 7.6 13C5.6 13.2 4 14.9 4 17C4 19.2 5.8 21 8 21C9.1 21 10 20.6 10.7 19.9C10.3 19 10 18 10 17S10.3 15 10.7 14.1C10.3 13.7 9.7 13.4 9.2 13.2C9.9 11.7 11.1 9 11.9 6.4C12.3 8.7 13.1 11.4 14.1 13.5C12.9 14.2 12 15.5 12 17C12 19.2 13.8 21 16 21S20 19.2 20 17 18.2 13 16 13M8 15.5C7.2 15.5 6.5 16.2 6.5 17H5.5C5.5 15.6 6.6 14.5 8 14.5V15.5M16 15.5C15.2 15.5 14.5 16.2 14.5 17H13.5C13.5 15.6 14.6 14.5 16 14.5V15.5Z";
var mdiFruitCherriesOff = "M22.1 21.5L2.4 1.7L1.1 3L8.7 10.6C8.3 11.6 7.9 12.5 7.6 13C5.6 13.2 4 14.9 4 17C4 19.2 5.8 21 8 21C9.1 21 10 20.6 10.7 19.9C10.3 19 10 18 10 17S10.3 15 10.7 14.1C10.3 13.7 9.7 13.4 9.2 13.2C9.4 12.8 9.6 12.3 9.9 11.7L12.8 14.6C12.3 15.3 12 16.1 12 17C12 19.2 13.8 21 16 21C16.9 21 17.7 20.7 18.3 20.2L20.8 22.7L22.1 21.5M8 15.5C7.2 15.5 6.5 16.2 6.5 17H5.5C5.5 15.6 6.6 14.5 8 14.5V15.5M14.5 17H13.5C13.5 16.5 13.6 16.1 13.8 15.7L14.6 16.5C14.5 16.7 14.5 16.8 14.5 17M20 16.8L16.2 13C18.2 13.1 19.9 14.8 20 16.8M11.3 8.1L10.1 6.9C10.7 5.1 11.2 3.3 11.2 2L12.6 1.9C12.7 2.3 12.7 2.8 12.8 3.4C13.4 3.3 15.5 3.3 17.8 5.1C20.5 7.1 19.8 10.9 19.8 10.9S17.4 11.3 14.7 9.2L13.8 8.3C14.1 9.5 14.5 10.7 14.9 11.7L12.6 9.4C12.3 8.4 12.1 7.4 11.9 6.4C11.7 7 11.5 7.6 11.3 8.1Z";
var mdiFruitCitrus = "M9 15.9C6.9 15.7 5.1 14.9 4 13.6C3.2 13.6 2.4 13.1 2.1 12.3C1.8 11.5 2.1 10.7 2.8 10.2C2.9 7.2 5.6 4.1 9.7 2.7C13.8 1.3 18 2.1 20 4.4C20.8 4.4 21.6 4.9 21.9 5.7C22.2 6.5 21.9 7.3 21.2 7.8C21.2 8.6 21 9.4 20.6 10.2C19.4 9.5 18 9 16.5 9C12.6 9 9.3 12 9 15.9M22 16.5C22 19.5 19.5 22 16.5 22S11 19.5 11 16.5 13.5 11 16.5 11 22 13.5 22 16.5M13.3 18L15.6 16.5L13.3 15C13.1 15.5 13 16 13 16.5S13.1 17.5 13.3 18M16 17.4L13.9 18.8C14.4 19.4 15.2 19.8 16 20V17.4M16 13.1C15.2 13.2 14.4 13.6 13.9 14.3L16 15.7V13.1M17 15.6L19.1 14.2C18.6 13.6 17.8 13.2 17 13V15.6M19.1 18.8L17 17.4V19.9C17.8 19.8 18.6 19.4 19.1 18.8M20 16.5C20 16 19.9 15.5 19.7 15L17.4 16.5L19.7 18C19.9 17.5 20 17 20 16.5Z";
var mdiFruitCitrusOff = "M22.1 21.5L2.4 1.7L1.1 3L4.4 6.3C3.4 7.5 2.9 8.9 2.8 10.2C2.1 10.7 1.8 11.5 2.1 12.3C2.4 13.1 3.2 13.6 4 13.6C5.1 14.9 6.9 15.7 9 15.9C9.1 14.5 9.6 13.3 10.3 12.2L11.8 13.7C11.3 14.5 11 15.5 11 16.5C11 19.5 13.5 22 16.5 22C17.5 22 18.5 21.7 19.3 21.2L20.8 22.7L22.1 21.5M13 16.5C13 16 13.1 15.6 13.3 15.1L15 16.8L13.3 18C13.1 17.5 13 17 13 16.5M13.9 18.8L15.7 17.6L16 17.9V20C15.2 19.8 14.4 19.4 13.9 18.8M17 19.9V18.9L17.8 19.7C17.5 19.8 17.3 19.9 17 19.9M20 16.8V16.5C20 16 19.9 15.5 19.7 15L18.8 15.6L18.1 14.9L19.1 14.2C18.6 13.6 17.8 13.2 17 13V13.8L14.6 11.4C15.2 11.2 15.9 11 16.5 11C19.5 11 22 13.5 22 16.5C22 17.2 21.9 17.8 21.6 18.4L20 16.8M13 9.8L7.1 3.9C7.9 3.4 8.8 3 9.7 2.7C13.8 1.3 18 2.1 20 4.4C20.8 4.4 21.6 4.9 21.9 5.7C22.2 6.5 21.9 7.3 21.2 7.8C21.2 8.6 21 9.4 20.6 10.2C19.4 9.5 18 9 16.5 9C15.3 9 14.1 9.3 13 9.8Z";
var mdiFruitGrapes = "M14 12C14 13.1 13.1 14 12 14S10 13.1 10 12 10.9 10 12 10 14 10.9 14 12M7 10C5.9 10 5 10.9 5 12S5.9 14 7 14 9 13.1 9 12 8.1 10 7 10M17 10C15.9 10 15 10.9 15 12S15.9 14 17 14 19 13.1 19 12 18.1 10 17 10M14.5 6C13.4 6 12.5 6.9 12.5 8S13.4 10 14.5 10 16.5 9.1 16.5 8 15.6 6 14.5 6M9.5 6C8.4 6 7.5 6.9 7.5 8S8.4 10 9.5 10 11.5 9.1 11.5 8 10.6 6 9.5 6M14.5 14C13.4 14 12.5 14.9 12.5 16S13.4 18 14.5 18 16.5 17.1 16.5 16 15.6 14 14.5 14M9.5 14C8.4 14 7.5 14.9 7.5 16S8.4 18 9.5 18 11.5 17.1 11.5 16 10.6 14 9.5 14M12 18C10.9 18 10 18.9 10 20S10.9 22 12 22 14 21.1 14 20 13.1 18 12 18M14.4 2.2L13.6 1C11.4 2 11.2 5.6 11.2 6H12.7C12.8 5.2 13.1 2.7 14.4 2.2Z";
var mdiFruitGrapesOutline = "M19 12C19 10.61 18.05 9.47 16.78 9.12C16.92 8.78 17 8.4 17 8C17 6.34 15.66 5 14 5C13.57 5 13.17 5.1 12.81 5.26C13 4.19 13.39 2.59 14.4 2.2L13.6 1C11.9 1.77 11.4 4.09 11.26 5.29C10.87 5.11 10.45 5 10 5C8.34 5 7 6.34 7 8C7 8.4 7.08 8.77 7.22 9.12C5.94 9.46 5 10.62 5 12C5 13.39 5.95 14.54 7.23 14.88C7.09 15.22 7 15.6 7 16C7 17.39 7.94 18.54 9.22 18.88C9.08 19.23 9 19.61 9 20C9 21.66 10.34 23 12 23S15 21.66 15 20C15 19.61 14.92 19.23 14.78 18.88C16.06 18.54 17 17.39 17 16C17 15.6 16.92 15.23 16.77 14.88C18.05 14.54 19 13.39 19 12M16.31 9.88V9.9H16.3L16.31 9.88M14 6.5C14.83 6.5 15.5 7.17 15.5 8S14.83 9.5 14 9.5 12.5 8.83 12.5 8 13.17 6.5 14 6.5M13.5 12C13.5 12.83 12.83 13.5 12 13.5S10.5 12.83 10.5 12 11.17 10.5 12 10.5 13.5 11.17 13.5 12M10 6.5C10.83 6.5 11.5 7.17 11.5 8S10.83 9.5 10 9.5 8.5 8.83 8.5 8 9.17 6.5 10 6.5M6.5 12C6.5 11.17 7.17 10.5 8 10.5S9.5 11.17 9.5 12 8.83 13.5 8 13.5 6.5 12.83 6.5 12M8.5 16C8.5 15.17 9.17 14.5 10 14.5S11.5 15.17 11.5 16 10.83 17.5 10 17.5 8.5 16.83 8.5 16M12 21.5C11.17 21.5 10.5 20.83 10.5 20S11.17 18.5 12 18.5 13.5 19.17 13.5 20 12.83 21.5 12 21.5M14 17.5C13.17 17.5 12.5 16.83 12.5 16S13.17 14.5 14 14.5 15.5 15.17 15.5 16 14.83 17.5 14 17.5M16 13.5C15.17 13.5 14.5 12.83 14.5 12S15.17 10.5 16 10.5 17.5 11.17 17.5 12 16.83 13.5 16 13.5Z";
var mdiFruitPear = "M18 16C18 19.31 15.31 22 12 22C8.69 22 6 19.31 6 16C6 13 8 13 8 10C8 8.56 8.75 7.22 10 6.5C10.4 6.27 10.82 6.12 11.25 6.04V5C11.25 4.63 11.17 4.42 11.03 4.28C10.9 4.14 10.63 4 10 4V2.5C10.88 2.5 11.6 2.73 12.09 3.22C12.58 3.71 12.75 4.38 12.75 5V6.04C13.18 6.12 13.61 6.27 14 6.5C15.25 7.22 16 8.56 16 10C16 13 18 13 18 16Z";
var mdiFruitPineapple = "M14.4 7.7C16.4 6.4 19 7 19 7C17.2 4.6 15.1 4.7 13.6 5.2V5C14.7 3.4 16.9 3.5 16.9 3.5C15.3 2.1 13.9 2.5 13 3C12.5 1.8 12 1 12 1C11.6 1.7 11.3 2.4 11 3.1C10.1 2.5 8.6 2.1 7 3.5C7 3.5 9.3 3.5 10.4 5.2C8.9 4.7 6.8 4.6 5 7C5 7 7.6 6.4 9.6 7.7C7.5 8.9 6 11.7 6 15C6 19.4 8.7 23 12 23S18 19.4 18 15C18 11.7 16.5 8.9 14.4 7.7M15.8 16.8C15.7 17.2 15.6 17.6 15.4 18L14 16L12.5 18L14.1 20.1C13.8 20.3 13.6 20.5 13.3 20.7L12 19L10.7 20.7C10.4 20.6 10.1 20.4 9.9 20.1L11.5 18L10 16L8.5 17.9C8.4 17.5 8.2 17.1 8.1 16.7L9.5 15L8.2 13.2C8.3 12.8 8.4 12.4 8.6 12L10 14L11.5 12L9.9 9.9C10.2 9.7 10.4 9.5 10.7 9.3L12 11L13.3 9.3C13.6 9.4 13.9 9.6 14.1 9.9L12.5 12L14 14L15.5 12.1C15.6 12.5 15.8 12.9 15.9 13.3L14.5 15L15.8 16.8M12 13L13.5 15L12 17L10.5 15L12 13Z";
var mdiFruitWatermelon = "M16.4 16.4C19.8 13 19.8 7.5 16.4 4.2L4.2 16.4C7.5 19.8 13 19.8 16.4 16.4M16 7C16.6 7 17 7.4 17 8C17 8.6 16.6 9 16 9S15 8.6 15 8C15 7.4 15.4 7 16 7M16 11C16.6 11 17 11.4 17 12C17 12.6 16.6 13 16 13S15 12.6 15 12C15 11.4 15.4 11 16 11M12 11C12.6 11 13 11.4 13 12C13 12.6 12.6 13 12 13S11 12.6 11 12C11 11.4 11.4 11 12 11M12 15C12.6 15 13 15.4 13 16C13 16.6 12.6 17 12 17S11 16.6 11 16C11 15.4 11.4 15 12 15M8 17C7.4 17 7 16.6 7 16C7 15.4 7.4 15 8 15S9 15.4 9 16C9 16.6 8.6 17 8 17M18.6 18.6C14 23.2 6.6 23.2 2 18.6L3.4 17.2C7.2 21 13.3 21 17.1 17.2C20.9 13.4 20.9 7.3 17.1 3.5L18.6 2C23.1 6.6 23.1 14 18.6 18.6Z";
var mdiFuel = "M3,2H6C6.28,2 6.53,2.11 6.71,2.29L8.79,4.38L9.59,3.59C10,3.2 10.5,3 11,3H17C17.5,3 18,3.2 18.41,3.59L19.41,4.59C19.8,5 20,5.5 20,6V19A2,2 0 0,1 18,21H8A2,2 0 0,1 6,19V13L6,12V8C6,7.5 6.2,7 6.59,6.59L7.38,5.79L5.59,4H3V2M11,5V7H17V5H11M11.41,11L9.41,9H8V10.41L10,12.41V15.59L8,17.59V19H9.41L11.41,17H14.59L16.59,19H18V17.59L16,15.59V12.41L18,10.41V9H16.59L14.59,11H11.41M12,13H14V15H12V13Z";
var mdiFuelCell = "M6 3V5H4C2.9 5 2 5.9 2 7V17C2 18.1 2.9 19 4 19V20C4 21.1 4.9 22 6 22H7C8.1 22 9 21.1 9 20V19H15V20C15 21.1 15.9 22 17 22H18C19.1 22 20 21.1 20 20V19C21.1 19 22 18.1 22 17H11V5H8V3H6M16 3V5H13V7H22C22 5.9 21.1 5 20 5H18V3H16M7 7V11H9L6 17V13H4L7 7M13 9V11H22V9H13M13 13V15H22V13H13Z";
var mdiFullscreen = "M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z";
var mdiFullscreenExit = "M14,14H19V16H16V19H14V14M5,14H10V19H8V16H5V14M8,5H10V10H5V8H8V5M19,8V10H14V5H16V8H19Z";
var mdiFunction = "M15.6,5.29C14.5,5.19 13.53,6 13.43,7.11L13.18,10H16V12H13L12.56,17.07C12.37,19.27 10.43,20.9 8.23,20.7C6.92,20.59 5.82,19.86 5.17,18.83L6.67,17.33C6.91,18.07 7.57,18.64 8.4,18.71C9.5,18.81 10.47,18 10.57,16.89L11,12H8V10H11.17L11.44,6.93C11.63,4.73 13.57,3.1 15.77,3.3C17.08,3.41 18.18,4.14 18.83,5.17L17.33,6.67C17.09,5.93 16.43,5.36 15.6,5.29Z";
var mdiFunctionVariant = "M12.42,5.29C11.32,5.19 10.35,6 10.25,7.11L10,10H12.82V12H9.82L9.38,17.07C9.18,19.27 7.24,20.9 5.04,20.7C3.79,20.59 2.66,19.9 2,18.83L3.5,17.33C3.83,18.38 4.96,18.97 6,18.63C6.78,18.39 7.33,17.7 7.4,16.89L7.82,12H4.82V10H8L8.27,6.93C8.46,4.73 10.39,3.1 12.6,3.28C13.86,3.39 15,4.09 15.66,5.17L14.16,6.67C13.91,5.9 13.23,5.36 12.42,5.29M22,13.65L20.59,12.24L17.76,15.07L14.93,12.24L13.5,13.65L16.35,16.5L13.5,19.31L14.93,20.72L17.76,17.89L20.59,20.72L22,19.31L19.17,16.5L22,13.65Z";
var mdiFuriganaHorizontal = "M8.5 2C7.12 2 6 3.12 6 4.5S7.12 7 8.5 7 11 5.88 11 4.5 9.88 2 8.5 2M15.5 2C14.12 2 13 3.12 13 4.5S14.12 7 15.5 7 18 5.88 18 4.5 16.88 2 15.5 2M11 8V10H5V12H14.95C14.53 13.13 13.5 14.5 12.16 15.67C11.12 14.74 10.35 13.82 9.82 13H7.5C8.08 14.25 9.13 15.62 10.62 16.96L6.55 20.22L5.76 20.84L7 22.41L7.8 21.78L12.17 18.28L16.55 21.78L17.33 22.41L18.58 20.84L17.8 20.22L13.73 16.97C15.34 15.5 16.7 13.85 17.07 12H19V10H13V8H11Z";
var mdiFuriganaVertical = "M8 5V7H2V9H11.95C11.53 10.13 10.5 11.5 9.16 12.67C8.12 11.74 7.35 10.82 6.82 10H4.5C5.08 11.25 6.13 12.62 7.62 13.96L3.55 17.22L2.76 17.84L4 19.41L4.8 18.78L9.17 15.28L13.55 18.78L14.33 19.41L15.58 17.84L14.8 17.22L10.73 13.97C12.34 12.5 13.7 10.85 14.07 9H16V7H10V5H8M19.5 6C18.12 6 17 7.12 17 8.5S18.12 11 19.5 11 22 9.88 22 8.5 20.88 6 19.5 6M19.47 13C18.09 13 16.97 14.12 16.97 15.5S18.09 18 19.47 18 21.97 16.88 21.97 15.5 20.85 13 19.47 13Z";
var mdiFuse = "M8,7V17H15V7H8M11.16,16V12.87H9.41L11.91,8V11.14H13.59L11.16,16M16,2V6H7V2A1,1 0 0,1 8,1H15A1,1 0 0,1 16,2M16,18V22A1,1 0 0,1 15,23H8A1,1 0 0,1 7,22V18H16Z";
var mdiFuseAlert = "M6 7V17H13V7H6M9.16 16V12.87H7.41L9.91 8V11.14H11.59L9.16 16M14 2V6H5V2C5 1.45 5.45 1 6 1H13C13.55 1 14 1.45 14 2M14 18V22C14 22.55 13.55 23 13 23H6C5.45 23 5 22.55 5 22V18H14M19 13H17V7H19V13M19 17H17V15H19V17Z";
var mdiFuseBlade = "M10,21H8L6,19V16H10V21M18,16H14V21H16L18,19V16M3,3V4A1,1 0 0,0 4,5V14A1,1 0 0,0 5,15H19A1,1 0 0,0 20,14V5H20A1,1 0 0,0 21,4V3H3M11.83,13V9.73H10L12.61,4.66V7.93H14.36L11.83,13Z";
var mdiFuseOff = "M15 11.8L10.2 7H15V11.8M16 6V2C16 1.45 15.55 1 15 1H8C7.45 1 7 1.45 7 2V3.8L9.2 6H16M2.39 1.73L1.11 3L8 9.89V17H15.11L20.84 22.73L22.11 21.46L2.39 1.73M7 22C7 22.55 7.45 23 8 23H15C15.55 23 16 22.55 16 22V18H7V22Z";
var mdiGamepad = "M16.5,9L13.5,12L16.5,15H22V9M9,16.5V22H15V16.5L12,13.5M7.5,9H2V15H7.5L10.5,12M15,7.5V2H9V7.5L12,10.5L15,7.5Z";
var mdiGamepadCircle = "M5,8A4,4 0 0,1 9,12A4,4 0 0,1 5,16A4,4 0 0,1 1,12A4,4 0 0,1 5,8M12,1A4,4 0 0,1 16,5A4,4 0 0,1 12,9A4,4 0 0,1 8,5A4,4 0 0,1 12,1M12,15A4,4 0 0,1 16,19A4,4 0 0,1 12,23A4,4 0 0,1 8,19A4,4 0 0,1 12,15M19,8A4,4 0 0,1 23,12A4,4 0 0,1 19,16A4,4 0 0,1 15,12A4,4 0 0,1 19,8Z";
var mdiGamepadCircleDown = "M5,8A4,4 0 0,1 9,12A4,4 0 0,1 5,16A4,4 0 0,1 1,12A4,4 0 0,1 5,8M12,1A4,4 0 0,1 16,5A4,4 0 0,1 12,9A4,4 0 0,1 8,5A4,4 0 0,1 12,1M12,15A4,4 0 0,1 16,19A4,4 0 0,1 12,23A4,4 0 0,1 8,19A4,4 0 0,1 12,15M19,8A4,4 0 0,1 23,12A4,4 0 0,1 19,16A4,4 0 0,1 15,12A4,4 0 0,1 19,8M12,3A2,2 0 0,0 10,5A2,2 0 0,0 12,7A2,2 0 0,0 14,5A2,2 0 0,0 12,3M5,10A2,2 0 0,0 3,12A2,2 0 0,0 5,14A2,2 0 0,0 7,12A2,2 0 0,0 5,10M19,10A2,2 0 0,0 17,12A2,2 0 0,0 19,14A2,2 0 0,0 21,12A2,2 0 0,0 19,10Z";
var mdiGamepadCircleLeft = "M5,8A4,4 0 0,1 9,12A4,4 0 0,1 5,16A4,4 0 0,1 1,12A4,4 0 0,1 5,8M12,1A4,4 0 0,1 16,5A4,4 0 0,1 12,9A4,4 0 0,1 8,5A4,4 0 0,1 12,1M12,15A4,4 0 0,1 16,19A4,4 0 0,1 12,23A4,4 0 0,1 8,19A4,4 0 0,1 12,15M19,8A4,4 0 0,1 23,12A4,4 0 0,1 19,16A4,4 0 0,1 15,12A4,4 0 0,1 19,8M19,10A2,2 0 0,0 17,12A2,2 0 0,0 19,14A2,2 0 0,0 21,12A2,2 0 0,0 19,10M12,17A2,2 0 0,0 10,19A2,2 0 0,0 12,21A2,2 0 0,0 14,19A2,2 0 0,0 12,17M12,3A2,2 0 0,0 10,5A2,2 0 0,0 12,7A2,2 0 0,0 14,5A2,2 0 0,0 12,3Z";
var mdiGamepadCircleOutline = "M5,8A4,4 0 0,1 9,12A4,4 0 0,1 5,16A4,4 0 0,1 1,12A4,4 0 0,1 5,8M5,10A2,2 0 0,0 3,12A2,2 0 0,0 5,14A2,2 0 0,0 7,12A2,2 0 0,0 5,10M12,1A4,4 0 0,1 16,5A4,4 0 0,1 12,9A4,4 0 0,1 8,5A4,4 0 0,1 12,1M12,3A2,2 0 0,0 10,5A2,2 0 0,0 12,7A2,2 0 0,0 14,5A2,2 0 0,0 12,3M12,15A4,4 0 0,1 16,19A4,4 0 0,1 12,23A4,4 0 0,1 8,19A4,4 0 0,1 12,15M12,17A2,2 0 0,0 10,19A2,2 0 0,0 12,21A2,2 0 0,0 14,19A2,2 0 0,0 12,17M19,8A4,4 0 0,1 23,12A4,4 0 0,1 19,16A4,4 0 0,1 15,12A4,4 0 0,1 19,8M19,10A2,2 0 0,0 17,12A2,2 0 0,0 19,14A2,2 0 0,0 21,12A2,2 0 0,0 19,10Z";
var mdiGamepadCircleRight = "M5,8A4,4 0 0,1 9,12A4,4 0 0,1 5,16A4,4 0 0,1 1,12A4,4 0 0,1 5,8M12,1A4,4 0 0,1 16,5A4,4 0 0,1 12,9A4,4 0 0,1 8,5A4,4 0 0,1 12,1M12,15A4,4 0 0,1 16,19A4,4 0 0,1 12,23A4,4 0 0,1 8,19A4,4 0 0,1 12,15M19,8A4,4 0 0,1 23,12A4,4 0 0,1 19,16A4,4 0 0,1 15,12A4,4 0 0,1 19,8M12,3A2,2 0 0,0 10,5A2,2 0 0,0 12,7A2,2 0 0,0 14,5A2,2 0 0,0 12,3M5,10A2,2 0 0,0 3,12A2,2 0 0,0 5,14A2,2 0 0,0 7,12A2,2 0 0,0 5,10M12,17A2,2 0 0,0 10,19A2,2 0 0,0 12,21A2,2 0 0,0 14,19A2,2 0 0,0 12,17Z";
var mdiGamepadCircleUp = "M5,8A4,4 0 0,1 9,12A4,4 0 0,1 5,16A4,4 0 0,1 1,12A4,4 0 0,1 5,8M12,1A4,4 0 0,1 16,5A4,4 0 0,1 12,9A4,4 0 0,1 8,5A4,4 0 0,1 12,1M12,15A4,4 0 0,1 16,19A4,4 0 0,1 12,23A4,4 0 0,1 8,19A4,4 0 0,1 12,15M19,8A4,4 0 0,1 23,12A4,4 0 0,1 19,16A4,4 0 0,1 15,12A4,4 0 0,1 19,8M5,10A2,2 0 0,0 3,12A2,2 0 0,0 5,14A2,2 0 0,0 7,12A2,2 0 0,0 5,10M19,10A2,2 0 0,0 17,12A2,2 0 0,0 19,14A2,2 0 0,0 21,12A2,2 0 0,0 19,10M12,17A2,2 0 0,0 10,19A2,2 0 0,0 12,21A2,2 0 0,0 14,19A2,2 0 0,0 12,17Z";
var mdiGamepadDown = "M9,2V7.5L12,10.5L15,7.5V2H9M2,9V15H7.5L10.5,12L7.5,9H2M16.5,9L13.5,12L16.5,15H22V9H16.5M12,13.5L9,16.5V22H15V16.5L12,13.5M11,18H13V20H11V18Z";
var mdiGamepadLeft = "M9,2V7.5L12,10.5L15,7.5V2H9M2,9V15H7.5L10.5,12L7.5,9H2M16.5,9L13.5,12L16.5,15H22V9H16.5M4,11H6V13H4V11M12,13.5L9,16.5V22H15V16.5L12,13.5Z";
var mdiGamepadOutline = "M7.5 9H2V15H7.5L10.5 12L7.5 9M6 13H4V11H6V13M15 7.5V2H9V7.5L12 10.5L15 7.5M11 4H13V6H11V4M9 16.5V22H15V16.5L12 13.5L9 16.5M13 20H11V18H13V20M16.5 9L13.5 12L16.5 15H22V9H16.5M20 13H18V11H20V13Z";
var mdiGamepadRight = "M9,2V7.5L12,10.5L15,7.5V2H9M2,9V15H7.5L10.5,12L7.5,9H2M16.5,9L13.5,12L16.5,15H22V9H16.5M18,11H20V13H18V11M12,13.5L9,16.5V22H15V16.5L12,13.5Z";
var mdiGamepadRound = "M4,8H8V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V8H20A2,2 0 0,1 22,10V14A2,2 0 0,1 20,16H16V20A2,2 0 0,1 14,22H10A2,2 0 0,1 8,20V16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8Z";
var mdiGamepadRoundDown = "M4,8H8V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V8H20A2,2 0 0,1 22,10V14A2,2 0 0,1 20,16H16V20A2,2 0 0,1 14,22H10A2,2 0 0,1 8,20V16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8M10,16V20H14V16H10Z";
var mdiGamepadRoundLeft = "M4,8H8V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V8H20A2,2 0 0,1 22,10V14A2,2 0 0,1 20,16H16V20A2,2 0 0,1 14,22H10A2,2 0 0,1 8,20V16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8M4,10V14H8V10H4Z";
var mdiGamepadRoundOutline = "M4,8H8V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V8H20A2,2 0 0,1 22,10V14A2,2 0 0,1 20,16H16V20A2,2 0 0,1 14,22H10A2,2 0 0,1 8,20V16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8M4,10V14H10V20H14V14H20V10H14V4H10V10H4Z";
var mdiGamepadRoundRight = "M4,8H8V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V8H20A2,2 0 0,1 22,10V14A2,2 0 0,1 20,16H16V20A2,2 0 0,1 14,22H10A2,2 0 0,1 8,20V16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8M16,10V14H20V10H16Z";
var mdiGamepadRoundUp = "M4,8H8V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V8H20A2,2 0 0,1 22,10V14A2,2 0 0,1 20,16H16V20A2,2 0 0,1 14,22H10A2,2 0 0,1 8,20V16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8M10,4V8H14V4H10Z";
var mdiGamepadSquare = "M21,6H3A2,2 0 0,0 1,8V16A2,2 0 0,0 3,18H21A2,2 0 0,0 23,16V8A2,2 0 0,0 21,6M11,13H8V16H6V13H3V11H6V8H8V11H11M15.5,15A1.5,1.5 0 0,1 14,13.5A1.5,1.5 0 0,1 15.5,12A1.5,1.5 0 0,1 17,13.5A1.5,1.5 0 0,1 15.5,15M19.5,12A1.5,1.5 0 0,1 18,10.5A1.5,1.5 0 0,1 19.5,9A1.5,1.5 0 0,1 21,10.5A1.5,1.5 0 0,1 19.5,12Z";
var mdiGamepadSquareOutline = "M21,6H3A2,2 0 0,0 1,8V16A2,2 0 0,0 3,18H21A2,2 0 0,0 23,16V8A2,2 0 0,0 21,6M21,16H3V8H21M6,15H8V13H10V11H8V9H6V11H4V13H6M14.5,12A1.5,1.5 0 0,1 16,13.5A1.5,1.5 0 0,1 14.5,15A1.5,1.5 0 0,1 13,13.5A1.5,1.5 0 0,1 14.5,12M18.5,9A1.5,1.5 0 0,1 20,10.5A1.5,1.5 0 0,1 18.5,12A1.5,1.5 0 0,1 17,10.5A1.5,1.5 0 0,1 18.5,9Z";
var mdiGamepadUp = "M9,2V7.5L12,10.5L15,7.5V2H9M11,4H13V6H11V4M2,9V15H7.5L10.5,12L7.5,9H2M16.5,9L13.5,12L16.5,15H22V9H16.5M12,13.5L9,16.5V22H15V16.5L12,13.5Z";
var mdiGamepadVariant = "M7,6H17A6,6 0 0,1 23,12A6,6 0 0,1 17,18C15.22,18 13.63,17.23 12.53,16H11.47C10.37,17.23 8.78,18 7,18A6,6 0 0,1 1,12A6,6 0 0,1 7,6M6,9V11H4V13H6V15H8V13H10V11H8V9H6M15.5,12A1.5,1.5 0 0,0 14,13.5A1.5,1.5 0 0,0 15.5,15A1.5,1.5 0 0,0 17,13.5A1.5,1.5 0 0,0 15.5,12M18.5,9A1.5,1.5 0 0,0 17,10.5A1.5,1.5 0 0,0 18.5,12A1.5,1.5 0 0,0 20,10.5A1.5,1.5 0 0,0 18.5,9Z";
var mdiGamepadVariantOutline = "M6,9H8V11H10V13H8V15H6V13H4V11H6V9M18.5,9A1.5,1.5 0 0,1 20,10.5A1.5,1.5 0 0,1 18.5,12A1.5,1.5 0 0,1 17,10.5A1.5,1.5 0 0,1 18.5,9M15.5,12A1.5,1.5 0 0,1 17,13.5A1.5,1.5 0 0,1 15.5,15A1.5,1.5 0 0,1 14,13.5A1.5,1.5 0 0,1 15.5,12M17,5A7,7 0 0,1 24,12A7,7 0 0,1 17,19C15.04,19 13.27,18.2 12,16.9C10.73,18.2 8.96,19 7,19A7,7 0 0,1 0,12A7,7 0 0,1 7,5H17M7,7A5,5 0 0,0 2,12A5,5 0 0,0 7,17C8.64,17 10.09,16.21 11,15H13C13.91,16.21 15.36,17 17,17A5,5 0 0,0 22,12A5,5 0 0,0 17,7H7Z";
var mdiGamma = "M11.76 19C12.92 19 13.58 18 13.58 16.29C13.58 15.2 13.5 13.88 13.3 12.67L18 5H15.28L12.71 9.82L12.55 9.33C11.83 7.19 10.82 5 8.68 5C8 5 7.45 5.18 7 5.54C6 6.39 6 8 6 8.5H6.91C6.97 8.06 7.21 6.83 8.25 6.83C10 6.83 10.8 10 11.4 12.42C10.5 14.58 10 16.14 10 16.97C10 17.95 10.56 19 11.76 19";
var mdiGantryCrane = "M21,6H22V4H21V3H18V4H6V3H3V4H2V6H3V20H2V22H7V20H6V6H11V7H11.5V10.62C11,10.79 10.69,11.25 10.69,11.76C10.69,12.2 10.92,12.6 11.3,12.82V14H11.92C12.26,14 12.54,14.27 12.55,14.61C12.55,14.96 12.28,15.24 11.93,15.24C11.71,15.24 11.5,15.12 11.39,14.93C11.22,14.64 10.84,14.54 10.55,14.71C10.26,14.87 10.15,15.25 10.32,15.55C10.65,16.12 11.26,16.47 11.92,16.47C12.94,16.46 13.76,15.62 13.75,14.6C13.74,13.83 13.26,13.14 12.53,12.88V12.82C13.12,12.5 13.34,11.78 13.03,11.2C12.92,11 12.74,10.81 12.53,10.7V7H13V6H18V20H17V22H22V20H21V6M5,15.29V16.71L4,17.71V16.29L5,15.29M4,20V19.24L5,18.24V19.66L4.66,20H4M4,7.29L5,6.29V7.71L4,8.71V7.29M4,10.29L5,9.29V10.71L4,11.71V10.29M4,13.29L5,12.29V13.71L4,14.71V13.24L4,13.29M20,15.29V16.71L19,17.71V16.29L20,15.29M19,20V19.24L20,18.24V19.66L19.66,20H19M19,7.29L20,6.29V7.71L19,8.71V7.29M19,10.29L20,9.29V10.71L19,11.71V10.29M19,13.29L20,12.29V13.71L19,14.71V13.24L19,13.29Z";
var mdiGarage = "M19,20H17V11H7V20H5V9L12,5L19,9V20M8,12H16V14H8V12M8,15H16V17H8V15M16,18V20H8V18H16Z";
var mdiGarageAlert = "M17,20H15V11H5V20H3V9L10,5L17,9V20M6,12H14V14H6V12M6,15H14V17H6V15M19,15V10H21V15H19M19,19V17H21V19H19Z";
var mdiGarageAlertVariant = "M20 9V20H18V11H2V20H0V9L10 5L20 9M17 12H3V14H17V12M17 15H3V17H17V15M22 15V10H24V15H22M22 19V17H24V19H22Z";
var mdiGarageLock = "M20.8 16V14.5C20.8 13.1 19.4 12 18 12S15.2 13.1 15.2 14.5V16C14.6 16 14 16.6 14 17.2V20.7C14 21.4 14.6 22 15.2 22H20.7C21.4 22 22 21.4 22 20.8V17.3C22 16.6 21.4 16 20.8 16M19.5 16H16.5V14.5C16.5 13.7 17.2 13.2 18 13.2S19.5 13.7 19.5 14.5V16M5 12H13V14H5V12M5 15H12.95C12.42 15.54 12.08 16.24 12 17H5V15M12 20H5V18H12V20M14 11H4V20H2V9L9 5L16 9V10.44C15.19 10.8 14.5 11.36 14 12.06V11Z";
var mdiGarageOpen = "M19,20H17V11H7V20H5V9L12,5L19,9V20M8,12H16V14H8V12Z";
var mdiGarageOpenVariant = "M22 9V20H20V11H4V20H2V9L12 5L22 9M19 12H5V14H19V12Z";
var mdiGarageVariant = "M22 9V20H20V11H4V20H2V9L12 5L22 9M19 12H5V14H19V12M19 18H5V20H19V18M19 15H5V17H19V15Z";
var mdiGarageVariantLock = "M21.8 16V14.5C21.8 13.1 20.4 12 19 12S16.2 13.1 16.2 14.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16M20.5 16H17.5V14.5C17.5 13.7 18.2 13.2 19 13.2S20.5 13.7 20.5 14.5V16M5 12H15.04C14.61 12.59 14.35 13.27 14.26 14H5V12M16.06 11H4V20H2V9L12 5L22 9V11.04C21.17 10.4 20.13 10 19 10C17.9 10 16.88 10.39 16.06 11M13 20H5V18H13V20M5 15H13.95C13.42 15.54 13.08 16.24 13 17H5V15Z";
var mdiGasBurner = "M16.14 8.79L16.12 8.8C16.35 9.07 16.55 9.39 16.7 9.72L16.79 9.91C17.5 11.6 17 13.55 15.69 14.77C14.5 15.86 12.84 16.15 11.3 15.95C9.84 15.77 8.5 14.85 7.73 13.58C7.5 13.19 7.3 12.75 7.2 12.3C7.07 11.93 7.03 11.57 7 11.2C6.91 9.6 7.55 7.9 8.76 6.9C8.21 8.11 8.34 9.62 9.15 10.67L9.26 10.8C9.4 10.92 9.57 10.96 9.73 10.89C9.88 10.83 10 10.68 10 10.5L9.93 10.28C9.05 7.96 9.79 5.25 11.66 3.72C12.17 3.3 12.8 2.92 13.46 2.75C12.78 4.11 13 5.89 14.09 6.96C14.55 7.43 15.1 7.74 15.58 8.18L16.14 8.79M13.86 13.43L13.85 13.42C14.3 13.03 14.55 12.36 14.53 11.76L14.5 11.44C14.3 10.44 13.43 10.11 12.87 9.38C12.7 9.16 12.55 8.88 12.44 8.6C12.22 9.1 12.2 9.57 12.29 10.11C12.39 10.68 12.62 11.17 12.5 11.76C12.34 12.41 11.83 13.06 10.94 13.27C11.44 13.76 12.25 14.15 13.06 13.87C13.32 13.8 13.65 13.61 13.86 13.43M11 18V19C11 19.55 11.45 20 12 20C12.55 20 13 19.55 13 19V18H15V19C15 19.55 15.45 20 16 20C16.55 20 17 19.55 17 19V18C18.11 18 20 18.9 20 20V22H4V20C4 18.9 5.9 18 7 18V19C7 19.55 7.45 20 8 20C8.55 20 9 19.55 9 19V18H11Z";
var mdiGasCylinder = "M16,9V14L16,20A2,2 0 0,1 14,22H10A2,2 0 0,1 8,20V14L8,9C8,7.14 9.27,5.57 11,5.13V4H9V2H15V4H13V5.13C14.73,5.57 16,7.14 16,9Z";
var mdiGasStation = "M18,10A1,1 0 0,1 17,9A1,1 0 0,1 18,8A1,1 0 0,1 19,9A1,1 0 0,1 18,10M12,10H6V5H12M19.77,7.23L19.78,7.22L16.06,3.5L15,4.56L17.11,6.67C16.17,7 15.5,7.93 15.5,9A2.5,2.5 0 0,0 18,11.5C18.36,11.5 18.69,11.42 19,11.29V18.5A1,1 0 0,1 18,19.5A1,1 0 0,1 17,18.5V14C17,12.89 16.1,12 15,12H14V5C14,3.89 13.1,3 12,3H6C4.89,3 4,3.89 4,5V21H14V13.5H15.5V18.5A2.5,2.5 0 0,0 18,21A2.5,2.5 0 0,0 20.5,18.5V9C20.5,8.31 20.22,7.68 19.77,7.23Z";
var mdiGasStationInUse = "M17 18.5V8.5C17 7.81 17.28 7.18 17.73 6.73L17.72 6.72L21.44 3L22.5 4.06L20.39 6.17C21.33 6.5 22 7.43 22 8.5C22 8.83 21.94 9.15 21.81 9.46C21.68 9.76 21.5 10.04 21.27 10.27C20.8 10.74 20.16 11 19.5 11C19.14 11 18.81 10.92 18.5 10.79V18.5C18.5 18.83 18.43 19.15 18.31 19.46C18.18 19.76 18 20.04 17.77 20.27C17.54 20.5 17.26 20.69 16.96 20.81C16.65 20.94 16.33 21 16 21C15.34 21 14.7 20.74 14.23 20.27C13.76 19.8 13.5 19.16 13.5 18.5V13.5H12V21H2V5C2 3.89 2.89 3 4 3H10C11.1 3 12 3.89 12 5V12H13C14.1 12 15 12.89 15 14V18.5C15 18.77 15.11 19 15.29 19.21C15.5 19.4 15.74 19.5 16 19.5C16.27 19.5 16.5 19.4 16.71 19.21C16.9 19 17 18.77 17 18.5M10 10V5H4V10H10M19.5 9.5C19.77 9.5 20 9.4 20.21 9.21C20.4 9 20.5 8.77 20.5 8.5C20.5 8.24 20.4 8 20.21 7.79C20 7.61 19.77 7.5 19.5 7.5C19.24 7.5 19 7.61 18.79 7.79C18.61 8 18.5 8.24 18.5 8.5C18.5 8.77 18.61 9 18.79 9.21C19 9.4 19.24 9.5 19.5 9.5Z";
var mdiGasStationInUseOutline = "M17.73 6.73C17.28 7.17999 17 7.81 17 8.5V18.5C17 18.7652 16.8946 19.0196 16.7071 19.2071C16.5196 19.3946 16.2652 19.5 16 19.5C15.7348 19.5 15.4804 19.3946 15.2929 19.2071C15.1054 19.0196 15 18.7652 15 18.5V14C15 12.89 14.1 12 13 12H12V5C12 3.89 11.1 3 10 3H4C2.89 3 2 3.89 2 5V21H12V13.5H13.5V18.5C13.5 19.163 13.7634 19.7989 14.2322 20.2678C14.7011 20.7366 15.337 21 16 21C16.3283 21 16.6534 20.9353 16.9567 20.8097C17.26 20.6841 17.5356 20.4999 17.7678 20.2678C17.9999 20.0356 18.1841 19.76 18.3097 19.4567C18.4353 19.1534 18.5 18.8283 18.5 18.5V10.79C18.81 10.92 19.14 11 19.5 11C20.163 11 20.7989 10.7366 21.2678 10.2678C21.4999 10.0356 21.6841 9.76003 21.8097 9.45671C21.9353 9.1534 22 8.82831 22 8.5C22 7.42999 21.33 6.5 20.39 6.17L22.5 4.06L21.44 3L17.72 6.72L17.73 6.73ZM4 10V5H10V10H4ZM20.2071 9.20711C20.0196 9.39464 19.7652 9.5 19.5 9.5C19.2348 9.5 18.9804 9.39464 18.7929 9.20711C18.6054 9.01958 18.5 8.76521 18.5 8.5C18.5 8.23479 18.6054 7.98042 18.7929 7.79289C18.9804 7.60536 19.2348 7.5 19.5 7.5C19.7652 7.5 20.0196 7.60536 20.2071 7.79289C20.3946 7.98042 20.5 8.23479 20.5 8.5C20.5 8.76521 20.3946 9.01958 20.2071 9.20711ZM10 12V19H4V12H10Z";
var mdiGasStationOff = "M1 4.27L2.28 3L21 21.72L19.73 23L17.71 21C16.56 20.85 15.65 19.94 15.5 18.78L14 17.27V21H4V7.27L1 4.27M18 10C18.55 10 19 9.55 19 9C19 8.45 18.55 8 18 8C17.45 8 17 8.45 17 9C17 9.55 17.45 10 18 10M12 10V5H6.82L5.06 3.23C5.34 3.08 5.66 3 6 3H12C13.1 3 14 3.89 14 5V12H15C16.1 12 17 12.89 17 14V15.18L11.82 10H12M6 10H6.73L6 9.27V10M19.77 7.23C20.22 7.68 20.5 8.31 20.5 9L20.5 18.67L19 17.18V11.29C18.69 11.42 18.36 11.5 18 11.5C16.62 11.5 15.5 10.38 15.5 9C15.5 7.93 16.17 7.03 17.11 6.67L15 4.56L16.06 3.5L19.78 7.22L19.77 7.23Z";
var mdiGasStationOffOutline = "M1 4.27L2.28 3L6 6.72L21 21.72L19.73 23L17.72 21C16.56 20.85 15.65 19.94 15.5 18.78L14 17.27V21H4V7.27L1 4.27M19.77 7.23C20.22 7.68 20.5 8.31 20.5 9L20.5 18.67L19 17.18V11.29C18.69 11.42 18.36 11.5 18 11.5C16.62 11.5 15.5 10.38 15.5 9C15.5 7.93 16.17 7.03 17.11 6.67L15 4.56L16.06 3.5L19.78 7.22L19.77 7.23M11.82 10H12V5H6.82L5.06 3.24C5.34 3.09 5.66 3 6 3H12C13.1 3 14 3.9 14 5V12H15C16.1 12 17 12.9 17 14V15.18L11.82 10M6 10H6.73L6 9.27V10M6 12V19H12V15.27L8.73 12H6M18 10C18.55 10 19 9.55 19 9C19 8.45 18.55 8 18 8C17.45 8 17 8.45 17 9C17 9.55 17.45 10 18 10Z";
var mdiGasStationOutline = "M19.77,7.23L19.78,7.22L16.06,3.5L15,4.56L17.11,6.67C16.17,7.03 15.5,7.93 15.5,9A2.5,2.5 0 0,0 18,11.5C18.36,11.5 18.69,11.42 19,11.29V18.5A1,1 0 0,1 18,19.5A1,1 0 0,1 17,18.5V14A2,2 0 0,0 15,12H14V5A2,2 0 0,0 12,3H6A2,2 0 0,0 4,5V21H14V13.5H15.5V18.5A2.5,2.5 0 0,0 18,21A2.5,2.5 0 0,0 20.5,18.5V9C20.5,8.31 20.22,7.68 19.77,7.23M12,13.5V19H6V12H12V13.5M12,10H6V5H12V10M18,10A1,1 0 0,1 17,9A1,1 0 0,1 18,8A1,1 0 0,1 19,9A1,1 0 0,1 18,10Z";
var mdiGate = "M9 6V11H7V7H5V11H3V9H1V21H3V19H5V21H7V19H9V21H11V19H13V21H15V19H17V21H19V19H21V21H23V9H21V11H19V7H17V11H15V6H13V11H11V6H9M3 13H5V17H3V13M7 13H9V17H7V13M11 13H13V17H11V13M15 13H17V17H15V13M19 13H21V17H19V13Z";
var mdiGateAlert = "M21 17H19V19H21V17M21 9H19V15H21V9M17 13V11H15V6H13V11H11V6H9V11H7V7H5V11H3V9H1V21H3V19H5V21H7V19H9V21H11V19H13V21H15V19H17V17H15V13H17M5 17H3V13H5V17M9 17H7V13H9V17M13 17H11V13H13V17Z";
var mdiGateAnd = "M2,4V20H14A8,8 0 0,0 22,12A8,8 0 0,0 14,4H2M4,6H14A6,6 0 0,1 20,12A6,6 0 0,1 14,18H4V6Z";
var mdiGateArrowLeft = "M9 6H7V11H5V6H3V11H2V13H3V14.81C3.62 14.45 4.3 14.21 5 14.09V13H7V14.09C7.7 14.21 8.38 14.45 9 14.81V13H11V16.69C11.65 17.67 12 18.82 12 20C12 20.34 11.97 20.67 11.91 21H13V19H15V21H17V9H15V11H13V7H11V11H9V6M15 13V17H13V13H15M2 20L5 23V21H9V19H5V17L2 20Z";
var mdiGateArrowRight = "M15 6V11H13V7H11V11H9V9H7V21H9V19H11V21H12.09C12.03 20.67 12 20.34 12 20C12 18.82 12.35 17.67 13 16.69V13H15V14.81C15.62 14.45 16.3 14.21 17 14.09V13H19V14.09C19.7 14.21 20.38 14.45 21 14.81V13H22V11H21V6H19V11H17V6H15M9 13H11V17H9V13M19 17V19H15V21H19V23L22 20L19 17Z";
var mdiGateBuffer = "M6 7.24L15.53 12L6 16.76V7.24M4 4V20L20 12L4 4Z";
var mdiGateNand = "M2,4V20H10C13.43,20 16.5,17.84 17.6,14.6C18,14.8 18.5,15 19,15A3,3 0 0,0 22,12A3,3 0 0,0 19,9C18.5,9 18.03,9.15 17.6,9.4C16.5,6.16 13.43,4 10,4H2M4,6H10A6,6 0 0,1 16,12A6,6 0 0,1 10,18H4V6M19,11C19.5,11 20,11.5 20,12C20,12.5 19.5,13 19,13A1,1 0 0,1 18,12C18,11.5 18.5,11 19,11Z";
var mdiGateNor = "M2,4C5,10 5,14 2,20H5C9.4,20 13,17.7 16.6,13.7C17.15,14.5 18.04,15 19,15A3,3 0 0,0 22,12A3,3 0 0,0 19,9C18.04,9 17.15,9.5 16.6,10.3C13,6.3 9.4,4 5,4H2M5,6C8.8,6 12,8.1 15.3,12C12,15.9 8.8,18 5,18C6.5,14 6.5,10 5,6M19,11C19.5,11 20,11.5 20,12C20,12.5 19.5,13 19,13A1,1 0 0,1 18,12C18,11.5 18.5,11 19,11Z";
var mdiGateNot = "M2,4V20L16.2,13C16.62,14.19 17.74,15 19,15A3,3 0 0,0 22,12A3,3 0 0,0 19,9C17.74,9 16.62,9.81 16.2,11L2,4M4,7.3L13.7,12L4,16.7V7.3M19,11C19.5,11 20,11.5 20,12C20,12.5 19.5,13 19,13A1,1 0 0,1 18,12C18,11.5 18.5,11 19,11Z";
var mdiGateOpen = "M7 21V7H5V11H3V9H1V21H3V19H5V21H7M3 17V13H5V17H3M21 9V11H19V7H17V21H19V19H21V21H23V9H21M21 17H19V13H21V17Z";
var mdiGateOr = "M2,4C5,10 5,14 2,20H8C13,20 19,16 22,12C19,8 13,4 8,4H2M5,6H8C11.5,6 16.3,9 19.3,12C16.3,15 11.5,18 8,18H5C6.4,13.9 6.4,10.1 5,6Z";
var mdiGateXnor = "M2,4C5,10 5,14 2,20H4C7,14 7,10 4.1,4H2M6,4C9,10 9,14 6,20H9C12.2,20 14.8,16.8 16.7,14C17.28,14.65 18.12,15 19,15A3,3 0 0,0 22,12A3,3 0 0,0 19,9C18.12,9 17.28,9.35 16.7,10C14.7,7.2 12.2,4 9,4H6M9,6C12,6 14,10 15.5,12C14,14 12,18 9,18C10.6,14 10.6,10 9,6M19,11C19.5,11 20,11.5 20,12C20,12.5 19.5,13 19,13A1,1 0 0,1 18,12C18,11.5 18.5,11 19,11Z";
var mdiGateXor = "M2,4C5,10 5,14 2,20H4C7,14 7,10 4.1,4H2M6,4C9,10 9,14 6,20H9C14,20 18,17 22,12C18,7 14,4 9,4H6M9,6C12.8,6 16,8.1 19.3,12C15.9,15.9 12.8,18 9,18C10.5,14 10.5,10 9,6Z";
var mdiGatsby = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4C8.27,4 5.14,6.55 4.25,10L14,19.75C17.45,18.86 20,15.73 20,12H14.75V13.5H18.2C17.71,15.54 16.24,17.19 14.31,17.94L6.06,9.69C7,7.31 9.3,5.63 12,5.63C14.13,5.63 16,6.67 17.18,8.28L18.41,7.22C16.95,5.26 14.63,4 12,4M4,12A8,8 0 0,0 12,20C12.04,20 12.09,20 4,12Z";
var mdiGauge = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12C20,14.4 19,16.5 17.3,18C15.9,16.7 14,16 12,16C10,16 8.2,16.7 6.7,18C5,16.5 4,14.4 4,12A8,8 0 0,1 12,4M14,5.89C13.62,5.9 13.26,6.15 13.1,6.54L11.81,9.77L11.71,10C11,10.13 10.41,10.6 10.14,11.26C9.73,12.29 10.23,13.45 11.26,13.86C12.29,14.27 13.45,13.77 13.86,12.74C14.12,12.08 14,11.32 13.57,10.76L13.67,10.5L14.96,7.29L14.97,7.26C15.17,6.75 14.92,6.17 14.41,5.96C14.28,5.91 14.15,5.89 14,5.89M10,6A1,1 0 0,0 9,7A1,1 0 0,0 10,8A1,1 0 0,0 11,7A1,1 0 0,0 10,6M7,9A1,1 0 0,0 6,10A1,1 0 0,0 7,11A1,1 0 0,0 8,10A1,1 0 0,0 7,9M17,9A1,1 0 0,0 16,10A1,1 0 0,0 17,11A1,1 0 0,0 18,10A1,1 0 0,0 17,9Z";
var mdiGaugeEmpty = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,14.4 5,16.5 6.7,18C8.1,16.7 10,16 12,16C14,16 15.8,16.7 17.3,18C19,16.5 20,14.4 20,12A8,8 0 0,0 12,4M14,6A1,1 0 0,1 15,7A1,1 0 0,1 14,8A1,1 0 0,1 13,7A1,1 0 0,1 14,6M10,6A1,1 0 0,1 11,7A1,1 0 0,1 10,8A1,1 0 0,1 9,7A1,1 0 0,1 10,6M6.91,8.94C7.04,8.94 7.16,8.97 7.3,9L10.5,10.32L10.77,10.43C11.33,10 12.09,9.88 12.75,10.15C13.77,10.56 14.27,11.73 13.85,12.75C13.44,13.77 12.27,14.27 11.25,13.85C10.59,13.59 10.12,13 10,12.28L9.77,12.18L6.55,10.88L6.53,10.87C6,10.66 5.77,10.08 5.97,9.56C6.13,9.18 6.5,8.93 6.91,8.94V8.94M17,9A1,1 0 0,1 18,10A1,1 0 0,1 17,11A1,1 0 0,1 16,10A1,1 0 0,1 17,9Z";
var mdiGaugeFull = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12C20,14.4 19,16.5 17.3,18C15.9,16.7 14,16 12,16C10,16 8.2,16.7 6.7,18C5,16.5 4,14.4 4,12A8,8 0 0,1 12,4M10,6A1,1 0 0,0 9,7A1,1 0 0,0 10,8A1,1 0 0,0 11,7A1,1 0 0,0 10,6M14,6A1,1 0 0,0 13,7A1,1 0 0,0 14,8A1,1 0 0,0 15,7A1,1 0 0,0 14,6M17.09,8.94C16.96,8.94 16.84,8.97 16.7,9L13.5,10.32L13.23,10.43C12.67,10 11.91,9.88 11.25,10.15C10.23,10.56 9.73,11.73 10.15,12.75C10.56,13.77 11.73,14.27 12.75,13.85C13.41,13.59 13.88,13 14,12.28L14.23,12.18L17.45,10.88L17.47,10.87C18,10.66 18.23,10.08 18.03,9.56C17.87,9.18 17.5,8.93 17.09,8.94M7,9A1,1 0 0,0 6,10A1,1 0 0,0 7,11A1,1 0 0,0 8,10A1,1 0 0,0 7,9Z";
var mdiGaugeLow = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,14.4 5,16.5 6.7,18C8.1,16.7 10,16 12,16C14,16 15.8,16.7 17.3,18C19,16.5 20,14.4 20,12A8,8 0 0,0 12,4M10,5.89C10.38,5.9 10.74,6.15 10.9,6.54L12.19,9.77L12.29,10C13,10.13 13.59,10.6 13.86,11.26C14.27,12.29 13.77,13.45 12.74,13.86C11.71,14.27 10.55,13.77 10.14,12.74C9.88,12.08 10,11.32 10.43,10.76L10.33,10.5L9.04,7.29L9.03,7.26C8.83,6.75 9.08,6.17 9.59,5.96C9.72,5.91 9.85,5.89 10,5.89V5.89M14,6A1,1 0 0,1 15,7A1,1 0 0,1 14,8A1,1 0 0,1 13,7A1,1 0 0,1 14,6M17,9A1,1 0 0,1 18,10A1,1 0 0,1 17,11A1,1 0 0,1 16,10A1,1 0 0,1 17,9M7,9A1,1 0 0,1 8,10A1,1 0 0,1 7,11A1,1 0 0,1 6,10A1,1 0 0,1 7,9Z";
var mdiGavel = "M2.3,20.28L11.9,10.68L10.5,9.26L9.78,9.97C9.39,10.36 8.76,10.36 8.37,9.97L7.66,9.26C7.27,8.87 7.27,8.24 7.66,7.85L13.32,2.19C13.71,1.8 14.34,1.8 14.73,2.19L15.44,2.9C15.83,3.29 15.83,3.92 15.44,4.31L14.73,5L16.15,6.43C16.54,6.04 17.17,6.04 17.56,6.43C17.95,6.82 17.95,7.46 17.56,7.85L18.97,9.26L19.68,8.55C20.07,8.16 20.71,8.16 21.1,8.55L21.8,9.26C22.19,9.65 22.19,10.29 21.8,10.68L16.15,16.33C15.76,16.72 15.12,16.72 14.73,16.33L14.03,15.63C13.63,15.24 13.63,14.6 14.03,14.21L14.73,13.5L13.32,12.09L3.71,21.7C3.32,22.09 2.69,22.09 2.3,21.7C1.91,21.31 1.91,20.67 2.3,20.28M20,19A2,2 0 0,1 22,21V22H12V21A2,2 0 0,1 14,19H20Z";
var mdiGenderFemale = "M12,4A6,6 0 0,1 18,10C18,12.97 15.84,15.44 13,15.92V18H15V20H13V22H11V20H9V18H11V15.92C8.16,15.44 6,12.97 6,10A6,6 0 0,1 12,4M12,6A4,4 0 0,0 8,10A4,4 0 0,0 12,14A4,4 0 0,0 16,10A4,4 0 0,0 12,6Z";
var mdiGenderMale = "M9,9C10.29,9 11.5,9.41 12.47,10.11L17.58,5H13V3H21V11H19V6.41L13.89,11.5C14.59,12.5 15,13.7 15,15A6,6 0 0,1 9,21A6,6 0 0,1 3,15A6,6 0 0,1 9,9M9,11A4,4 0 0,0 5,15A4,4 0 0,0 9,19A4,4 0 0,0 13,15A4,4 0 0,0 9,11Z";
var mdiGenderMaleFemale = "M17.58,4H14V2H21V9H19V5.41L15.17,9.24C15.69,10.03 16,11 16,12C16,14.42 14.28,16.44 12,16.9V19H14V21H12V23H10V21H8V19H10V16.9C7.72,16.44 6,14.42 6,12A5,5 0 0,1 11,7C12,7 12.96,7.3 13.75,7.83L17.58,4M11,9A3,3 0 0,0 8,12A3,3 0 0,0 11,15A3,3 0 0,0 14,12A3,3 0 0,0 11,9Z";
var mdiGenderMaleFemaleVariant = "M7 3A5 5 0 0 0 9 7A5 5 0 0 0 7 11A5 5 0 0 0 11 15.9V18H9V20H11V22H13V20H15V18H13V15.9A5 5 0 0 0 17 11A5 5 0 0 0 15 7A5 5 0 0 0 17 3H15A3 3 0 0 1 12 6A3 3 0 0 1 9 3M12 8A3 3 0 0 1 15 11A3 3 0 0 1 12 14A3 3 0 0 1 9 11A3 3 0 0 1 12 8Z";
var mdiGenderNonBinary = "M13 3H11V5.27L9.04 4.13L8.04 5.87L10 7L8.04 8.13L9.04 9.87L11 8.73V12.1C8.72 12.56 7 14.58 7 17C7 19.76 9.24 22 12 22S17 19.76 17 17C17 14.58 15.28 12.56 13 12.1V8.73L14.96 9.87L15.96 8.13L14 7L15.96 5.87L14.96 4.13L13 5.27V3M12 20C10.35 20 9 18.65 9 17S10.35 14 12 14 15 15.35 15 17 13.65 20 12 20Z";
var mdiGenderTransgender = "M19.58,3H15V1H23V9H21V4.41L16.17,9.24C16.69,10.03 17,11 17,12C17,14.42 15.28,16.44 13,16.9V19H15V21H13V23H11V21H9V19H11V16.9C8.72,16.44 7,14.42 7,12C7,11 7.3,10.04 7.82,9.26L6.64,8.07L5.24,9.46L3.83,8.04L5.23,6.65L3,4.42V8H1V1H8V3H4.41L6.64,5.24L8.08,3.81L9.5,5.23L8.06,6.66L9.23,7.84C10,7.31 11,7 12,7C13,7 13.96,7.3 14.75,7.83L19.58,3M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z";
var mdiGeneratorMobile = "M4 2H2V19C2 20.11 2.9 21 4 21H12.1C12.03 20.68 12 20.34 12 20C12 19.66 12.03 19.32 12.1 19H4V2M13 17C13.91 15.79 15.36 15 17 15C18.64 15 20.09 15.79 21 17H22V6C22 4.89 21.11 4 20 4H8C6.9 4 6 4.89 6 6V17H13M20 6V8H14V6H20M14 10H20V12H14V10M7 11L10 5V9H12L9 15V11H7M14.17 19C14.06 19.31 14 19.65 14 20C14 20.35 14.06 20.69 14.17 21C14.58 22.17 15.7 23 17 23C18.66 23 20 21.66 20 20C20 18.34 18.66 17 17 17C15.69 17 14.58 17.84 14.17 19Z";
var mdiGeneratorPortable = "M7 2C5.9 2 5 2.9 5 4V6H4C2.9 6 2 6.9 2 8V20H4V21C4 21.55 4.45 22 5 22H6C6.55 22 7 21.55 7 21V20H17V21C17 21.55 17.45 22 18 22H19C19.55 22 20 21.55 20 21V20H22V8C22 6.9 21.11 6 20 6H19V4C19 2.9 18.11 2 17 2H7M14 10V8H20V10H14M14 14V12H20V14H14M7 4H17V6H7V4M7 8V12H9L6 18V14H4L7 8Z";
var mdiGeneratorStationary = "M6 3C4.89 3 4 3.9 4 5V16H6V17C6 17.55 6.45 18 7 18H8C8.55 18 9 17.55 9 17V16H15V17C15 17.55 15.45 18 16 18H17C17.55 18 18 17.55 18 17V16H20V5C20 3.9 19.11 3 18 3H6M12 7V5H18V7H12M12 9H18V11H12V9M8 5V9H10L7 15V11H5L8 5M22 20V22H2V20H22Z";
var mdiGentoo = "M10.28,2C9.93,2 9.57,2.03 9.23,2.1C5.61,2.76 3.06,5.89 2.85,7.96C2.74,8.97 3.29,9.73 3.59,10.06C4.4,10.97 6.03,11.66 7.07,12.23C5.56,13.5 4.87,14.14 4.19,14.86C3.17,15.93 2.45,17.1 2.45,17.95C2.45,18.22 2.4,19.09 2.76,19.77C2.89,20.03 3.27,20.89 4.41,21.53C5.14,21.94 6.17,22.09 7.19,21.95C10.33,21.5 14.54,18.83 17.55,16.35C19.46,14.77 20.86,13.23 21.26,12.5C21.59,11.87 21.63,10.78 21.44,10.09C20.9,8.14 16.53,4.15 12.96,2.55C12.14,2.18 11.2,2 10.28,2M11.34,4.91C11.59,4.91 11.81,4.94 12,5C13.15,5.3 15.08,6.68 14.91,7.94C14.68,9.6 13.23,10.27 11.56,10.03C10.58,9.9 8.63,8.8 8.78,6.89C8.89,5.4 10.3,4.9 11.34,4.91M11.32,6.65C11.05,6.65 10.84,6.71 10.74,6.87C10.27,7.59 10.5,8.09 10.92,8.42C11.07,8.04 12.71,8.45 12.75,8.79C14.17,7.72 12.36,6.66 11.32,6.65Z";
var mdiGesture = "M4.59,6.89C5.29,6.18 6,5.54 6.3,5.67C6.8,5.87 6.3,6.7 6,7.19C5.75,7.61 3.14,11.08 3.14,13.5C3.14,14.78 3.62,15.84 4.5,16.5C5.23,17.04 6.22,17.21 7.12,16.94C8.19,16.63 9.07,15.54 10.18,14.17C11.39,12.68 13,10.73 14.26,10.73C15.89,10.73 15.91,11.74 16,12.5C12.24,13.16 10.64,16.19 10.64,17.89C10.64,19.59 12.08,21 13.85,21C15.5,21 18.14,19.65 18.54,14.88H21V12.38H18.53C18.38,10.73 17.44,8.18 14.5,8.18C12.25,8.18 10.32,10.09 9.56,11C9,11.75 7.5,13.5 7.27,13.74C7,14.04 6.59,14.58 6.16,14.58C5.71,14.58 5.44,13.75 5.8,12.66C6.15,11.57 7.2,9.8 7.65,9.14C8.43,8 8.95,7.22 8.95,5.86C8.95,3.69 7.31,3 6.44,3C5.12,3 3.97,4 3.72,4.25C3.36,4.61 3.06,4.91 2.84,5.18L4.59,6.89M13.88,18.55C13.57,18.55 13.14,18.29 13.14,17.83C13.14,17.23 13.87,15.63 16,15.07C15.71,17.76 14.58,18.55 13.88,18.55Z";
var mdiGestureDoubleTap = "M10,9A1,1 0 0,1 11,8A1,1 0 0,1 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M11,5A4,4 0 0,1 15,9C15,10.5 14.2,11.77 13,12.46V11.24C13.61,10.69 14,9.89 14,9A3,3 0 0,0 11,6A3,3 0 0,0 8,9C8,9.89 8.39,10.69 9,11.24V12.46C7.8,11.77 7,10.5 7,9A4,4 0 0,1 11,5M11,3A6,6 0 0,1 17,9C17,10.7 16.29,12.23 15.16,13.33L14.16,12.88C15.28,11.96 16,10.56 16,9A5,5 0 0,0 11,4A5,5 0 0,0 6,9C6,11.05 7.23,12.81 9,13.58V14.66C6.67,13.83 5,11.61 5,9A6,6 0 0,1 11,3Z";
var mdiGesturePinch = "M13,9A1,1 0 0,1 14,8A1,1 0 0,1 15,9V13.47L16.21,13.6L21.15,15.8C21.67,16.04 22,16.56 22,17.14V21.5C21.97,22.32 21.32,22.97 20.5,23H14C13.62,23 13.26,22.85 13,22.57L8.1,18.37L8.84,17.6C9.03,17.39 9.3,17.28 9.58,17.28H9.8L13,19V9M14,5C15.42,5 16.74,5.76 17.45,7C18.56,8.9 17.91,11.35 16,12.46V11.23C16.64,10.67 17,9.85 17,9A3,3 0 0,0 14,6A3,3 0 0,0 11,9C11,9.85 11.36,10.67 12,11.23V12.46C10.77,11.75 10,10.43 10,9A4,4 0 0,1 14,5M4,9L7,12H5V15H3V12H1L4,9M4,7L1,4H3V1H5V4H7L4,7M9,14C9.73,14 10.41,14.19 11,14.54V15.76C10.47,15.29 9.77,15 9,15A3,3 0 0,0 6,18C6,19 6.5,19.87 7.22,20.42L9.31,22H9A4,4 0 0,1 5,18A4,4 0 0,1 9,14Z";
var mdiGestureSpread = "M4,1L7,4H5V7H3V4H1L4,1M4,15L1,12H3V9H5V12H7L4,15M13,9A1,1 0 0,1 14,8A1,1 0 0,1 15,9V13.47L16.21,13.6L21.15,15.8C21.67,16.04 22,16.56 22,17.14V21.5C21.97,22.32 21.32,22.97 20.5,23H14C13.62,23 13.26,22.85 13,22.57L8.1,18.37L8.84,17.6C9.03,17.39 9.3,17.28 9.58,17.28H9.8L13,19V9M14,5C15.42,5 16.74,5.76 17.45,7C18.56,8.9 17.91,11.35 16,12.46V11.23C16.64,10.67 17,9.85 17,9A3,3 0 0,0 14,6A3,3 0 0,0 11,9C11,9.85 11.36,10.67 12,11.23V12.46C10.77,11.75 10,10.43 10,9A4,4 0 0,1 14,5M9,14C9.73,14 10.41,14.19 11,14.54V15.76C10.47,15.29 9.77,15 9,15A3,3 0 0,0 6,18C6,19 6.5,19.87 7.22,20.42L9.31,22H9A4,4 0 0,1 5,18A4,4 0 0,1 9,14Z";
var mdiGestureSwipe = "M20.11,3.89L22,2V7H17L19.08,4.92C18.55,4.23 17.64,3.66 16.36,3.19C15.08,2.72 13.63,2.5 12,2.5C10.38,2.5 8.92,2.72 7.64,3.19C6.36,3.66 5.45,4.23 4.92,4.92L7,7H2V2L3.89,3.89C4.64,3 5.74,2.31 7.2,1.78C8.65,1.25 10.25,1 12,1C13.75,1 15.35,1.25 16.8,1.78C18.26,2.31 19.36,3 20.11,3.89M19.73,16.27V16.45L19,21.7C18.92,22.08 18.76,22.39 18.5,22.64C18.23,22.89 17.91,23 17.53,23H10.73C10.36,23 10,22.86 9.7,22.55L4.73,17.63L5.53,16.83C5.75,16.61 6,16.5 6.33,16.5H6.56L10,17.25V6.5C10,6.11 10.13,5.76 10.43,5.46C10.73,5.16 11.08,5 11.5,5C11.89,5 12.24,5.16 12.54,5.46C12.84,5.76 13,6.11 13,6.5V12.5H13.78C13.88,12.5 14.05,12.55 14.3,12.61L18.84,14.86C19.44,15.14 19.73,15.61 19.73,16.27Z";
var mdiGestureSwipeDown = "M10,9A1,1 0 0,1 11,8A1,1 0 0,1 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M1,9L4,12L7,9H5V3H3V9H1Z";
var mdiGestureSwipeHorizontal = "M6,1L3,4L6,7V5H9V7L12,4L9,1V3H6V1M11,8A1,1 0 0,0 10,9V19L6.8,17.28H6.58C6.3,17.28 6.03,17.39 5.84,17.6L5.1,18.37L10,22.57C10.26,22.85 10.62,23 11,23H17.5A1.5,1.5 0 0,0 19,21.5V17.14C19,16.56 18.68,16.03 18.15,15.79L13.21,13.6L12,13.47V9A1,1 0 0,0 11,8Z";
var mdiGestureSwipeLeft = "M10,9A1,1 0 0,1 11,8A1,1 0 0,1 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M3,4L6,7V5H12V3H6V1L3,4Z";
var mdiGestureSwipeRight = "M10,9A1,1 0 0,1 11,8A1,1 0 0,1 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M12,4L9,1V3H3V5H9V7L12,4Z";
var mdiGestureSwipeUp = "M10,9A1,1 0 0,1 11,8A1,1 0 0,1 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M7,6L4,3L1,6H3V12H5V6H7Z";
var mdiGestureSwipeVertical = "M4,3L1,6H3V9H1L4,12L7,9H5V6H7L4,3M11,8A1,1 0 0,0 10,9V19L6.8,17.28H6.58C6.3,17.28 6.03,17.39 5.84,17.6L5.1,18.37L10,22.57C10.26,22.85 10.62,23 11,23H17.5A1.5,1.5 0 0,0 19,21.5V17.14C19,16.56 18.68,16.03 18.15,15.79L13.21,13.6L12,13.47V9A1,1 0 0,0 11,8Z";
var mdiGestureTap = "M10,9A1,1 0 0,1 11,8A1,1 0 0,1 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M11,5A4,4 0 0,1 15,9C15,10.5 14.2,11.77 13,12.46V11.24C13.61,10.69 14,9.89 14,9A3,3 0 0,0 11,6A3,3 0 0,0 8,9C8,9.89 8.39,10.69 9,11.24V12.46C7.8,11.77 7,10.5 7,9A4,4 0 0,1 11,5Z";
var mdiGestureTapBox = "M20 2H4C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H20C21.11 22 22 21.11 22 20V4C22 2.89 21.11 2 20 2M11 4C13.21 4 15 5.79 15 8C15 9.5 14.2 10.77 13 11.46V10.24C13.61 9.69 14 8.89 14 8C14 6.34 12.66 5 11 5S8 6.34 8 8C8 8.89 8.39 9.69 9 10.24V11.46C7.8 10.77 7 9.5 7 8C7 5.79 8.79 4 11 4M18 18.5C17.97 19.32 17.32 19.97 16.5 20H11C10.62 20 10.26 19.85 10 19.57L6 15.37L6.74 14.6C6.93 14.39 7.2 14.28 7.5 14.28H7.7L10 16V8C10 7.45 10.45 7 11 7S12 7.45 12 8V12.47L13.21 12.6L17.15 14.79C17.68 15.03 18 15.56 18 16.14V18.5Z";
var mdiGestureTapButton = "M13 5C15.21 5 17 6.79 17 9C17 10.5 16.2 11.77 15 12.46V11.24C15.61 10.69 16 9.89 16 9C16 7.34 14.66 6 13 6S10 7.34 10 9C10 9.89 10.39 10.69 11 11.24V12.46C9.8 11.77 9 10.5 9 9C9 6.79 10.79 5 13 5M20 20.5C19.97 21.32 19.32 21.97 18.5 22H13C12.62 22 12.26 21.85 12 21.57L8 17.37L8.74 16.6C8.93 16.39 9.2 16.28 9.5 16.28H9.7L12 18V9C12 8.45 12.45 8 13 8S14 8.45 14 9V13.47L15.21 13.6L19.15 15.79C19.68 16.03 20 16.56 20 17.14V20.5M20 2H4C2.9 2 2 2.9 2 4V12C2 13.11 2.9 14 4 14H8V12L4 12L4 4H20L20 12H18V14H20V13.96L20.04 14C21.13 14 22 13.09 22 12V4C22 2.9 21.11 2 20 2Z";
var mdiGestureTapHold = "M10,9A1,1 0 0,1 11,8A1,1 0 0,1 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M9,12.44V9A2,2 0 0,1 11,7A2,2 0 0,1 13,9V12.44C14.19,11.75 15,10.47 15,9A4,4 0 0,0 11,5A4,4 0 0,0 7,9C7,10.47 7.81,11.75 9,12.44Z";
var mdiGestureTwoDoubleTap = "M19,15.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9A1,1 0 0,1 11,8A1,1 0 0,1 12,9V7A1,1 0 0,1 13,6A1,1 0 0,1 14,7V12L18.15,13.84C18.66,14.07 19,14.58 19,15.14M13,3A4,4 0 0,1 17,7C17,8.5 16.2,9.77 15,10.46V9.24C15.61,8.69 16,7.89 16,7A3,3 0 0,0 13,4C11.65,4 10.5,4.9 10.13,6.13C8.9,6.5 8,7.65 8,9C8,9.89 8.39,10.69 9,11.24V12.46C7.8,11.77 7,10.5 7,9C7,7.38 7.97,6 9.35,5.35C10,3.97 11.38,3 13,3M13,1A6,6 0 0,1 19,7C19,9.06 17.96,10.88 16.38,11.96L15.26,11.46C16.89,10.64 18,8.95 18,7A5,5 0 0,0 13,2C11.11,2 9.46,3.05 8.61,4.61C7.05,5.46 6,7.11 6,9C6,11.05 7.23,12.81 9,13.58V14.66C6.67,13.83 5,11.61 5,9C5,6.83 6.15,4.93 7.88,3.88C8.93,2.15 10.83,1 13,1Z";
var mdiGestureTwoTap = "M19,15.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9A1,1 0 0,1 11,8A1,1 0 0,1 12,9V7A1,1 0 0,1 13,6A1,1 0 0,1 14,7V12L18.15,13.84C18.66,14.07 19,14.58 19,15.14M15,10.45V9.24L15,9.23C15.23,9.03 15.42,8.79 15.57,8.54C15.84,8.09 16,7.56 16,7A3,3 0 0,0 13,4C12.21,4 11.5,4.31 10.95,4.81L10.81,4.95C10.68,5.09 10.56,5.24 10.46,5.4C10.36,5.56 10.27,5.74 10.2,5.92C10.17,6 10.15,6.06 10.13,6.13C8.9,6.5 8,7.65 8,9C8,9.7 8.24,10.34 8.64,10.85C8.74,11 8.87,11.11 9,11.23V11.24L9,12.46V12.46C7.8,11.77 7,10.5 7,9C7,7.38 7.97,6 9.35,5.35C10,3.97 11.38,3 13,3A4,4 0 0,1 17,7C17,8.5 16.2,9.77 15,10.46V10.45Z";
var mdiGhost = "M12,2A9,9 0 0,0 3,11V22L6,19L9,22L12,19L15,22L18,19L21,22V11A9,9 0 0,0 12,2M9,8A2,2 0 0,1 11,10A2,2 0 0,1 9,12A2,2 0 0,1 7,10A2,2 0 0,1 9,8M15,8A2,2 0 0,1 17,10A2,2 0 0,1 15,12A2,2 0 0,1 13,10A2,2 0 0,1 15,8Z";
var mdiGhostOff = "M2,3.27L3.28,2L22,20.72L20.73,22L17.87,19.13L15,22L12,19L9,22L6,19L3,22V11C3,9.09 3.59,7.33 4.6,5.87L2,3.27M12,2A9,9 0 0,1 21,11V17.18L15.7,11.88C16.46,11.59 17,10.86 17,10A2,2 0 0,0 15,8C14.14,8 13.41,8.54 13.13,9.3L7.2,3.38C8.59,2.5 10.24,2 12,2M7,10A2,2 0 0,0 9,12C9.5,12 9.93,11.83 10.27,11.54L7.46,8.73C7.17,9.07 7,9.5 7,10Z";
var mdiGhostOffOutline = "M8.29 5.09L6.84 3.64C8.3 2.61 10.08 2 12 2C16.97 2 21 6.03 21 11V17.8L19 15.8V11C19 7.14 15.86 4 12 4C10.63 4 9.36 4.4 8.29 5.09M22.11 21.46L20.84 22.73L17.56 19.45L15 22L12 19L9 22L6 19L3 22V11C3 9.26 3.5 7.63 4.36 6.25L1.11 3L2.39 1.73L6.89 6.23L8.69 8.03H8.69L10.97 10.31V10.31L17.41 16.76L17.42 16.76L21 20.34V20.35L22.11 21.46M16.14 18.03L9.89 11.78C9.62 11.92 9.32 12 9 12C7.9 12 7 11.11 7 10C7 9.68 7.08 9.38 7.22 9.11L5.82 7.71C5.3 8.69 5 9.81 5 11V17.17L6 16.17L7.41 17.59L9 19.17L10.59 17.59L12 16.17L13.41 17.59L15 19.17L16.14 18.03M15 8C13.96 8 13.11 8.8 13 9.82L15.18 12C16.2 11.89 17 11.04 17 10C17 8.9 16.11 8 15 8Z";
var mdiGhostOutline = "M12 2C7.03 2 3 6.03 3 11V22L6 19L9 22L12 19L15 22L18 19L21 22V11C21 6.03 16.97 2 12 2M19 17.17L18 16.17L16.59 17.59L15 19.17L13.41 17.59L12 16.17L10.59 17.59L9 19.17L7.41 17.59L6 16.17L5 17.17V11C5 7.14 8.14 4 12 4S19 7.14 19 11V17.17M11 10C11 11.11 10.11 12 9 12S7 11.11 7 10 7.9 8 9 8 11 8.9 11 10M17 10C17 11.11 16.11 12 15 12S13 11.11 13 10 13.9 8 15 8 17 8.9 17 10Z";
var mdiGift = "M9.06,1.93C7.17,1.92 5.33,3.74 6.17,6H3A2,2 0 0,0 1,8V10A1,1 0 0,0 2,11H11V8H13V11H22A1,1 0 0,0 23,10V8A2,2 0 0,0 21,6H17.83C19,2.73 14.6,0.42 12.57,3.24L12,4L11.43,3.22C10.8,2.33 9.93,1.94 9.06,1.93M9,4C9.89,4 10.34,5.08 9.71,5.71C9.08,6.34 8,5.89 8,5A1,1 0 0,1 9,4M15,4C15.89,4 16.34,5.08 15.71,5.71C15.08,6.34 14,5.89 14,5A1,1 0 0,1 15,4M2,12V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V12H13V20H11V12H2Z";
var mdiGiftOff = "M1.11 3L4.14 6.04H3C1.9 6.04 1 6.93 1 8.04V10.04C1 10.59 1.45 11.04 2 11.04H9.15L10.15 12.04H2V20.04C2 21.14 2.9 22.04 4 22.04H20C20.05 22.04 20.09 22.03 20.13 22L21.56 23.45L22.83 22.18L2.39 1.73L1.11 3M11 12.89L13 14.89V20.04H11V12.89M22 12.04V18.8L15.24 12.04H22M21 6.04H17.83C19 2.77 14.6 .455 12.57 3.28L12 4.04L11.43 3.26C10.8 2.37 9.93 2 9.06 1.97C8.06 1.96 7.08 2.5 6.5 3.3L8.04 4.84C8.13 4.38 8.5 4.04 9 4.04C9.89 4.04 10.34 5.12 9.71 5.75C9.56 5.89 9.39 6 9.21 6L11.24 8.04H13V9.8L14.24 11.04H22C22.55 11.04 23 10.59 23 10.04V8.04C23 6.93 22.11 6.04 21 6.04M15.71 5.75C15.08 6.38 14 5.93 14 5.04C14 4.5 14.45 4.04 15 4.04C15.89 4.04 16.34 5.12 15.71 5.75Z";
var mdiGiftOffOutline = "M21 6H17.83C17.94 5.69 18 5.35 18 5C18 3.34 16.66 2 15 2C14 2 13.12 2.5 12.57 3.24V3.23L12 4L11.43 3.23V3.24C10.88 2.5 10 2 9 2C7.97 2 7.06 2.5 6.5 3.32L8.03 4.83C8.12 4.36 8.5 4 9 4C9.55 4 10 4.45 10 5C10 5.5 9.64 5.88 9.17 5.97L13 9.8V8H21V10H13.2L15.2 12H20V16.8L22 18.8V12C22.55 12 23 11.55 23 11V8C23 6.9 22.11 6 21 6M15 6C14.45 6 14 5.55 14 5S14.45 4 15 4 16 4.45 16 5 15.55 6 15 6M1.11 3L4.11 6H3C1.9 6 1 6.9 1 8V11C1 11.55 1.45 12 2 12V20C2 21.11 2.9 22 4 22H20C20.03 22 20.07 22 20.1 22L21.56 23.45L22.83 22.18L2.39 1.73L1.11 3M13 14.89L18.11 20H13V14.89M11 12.89V20H4V12H10.11L11 12.89M8.11 10H3V8H6.11L8.11 10Z";
var mdiGiftOpen = "M22 10.92L19.26 9.33C21.9 7.08 19.25 2.88 16.08 4.31L15.21 4.68L15.1 3.72C15 2.64 14.44 1.87 13.7 1.42C12.06 .467 9.56 1.12 9.16 3.5L6.41 1.92C5.45 1.36 4.23 1.69 3.68 2.65L2.68 4.38C2.4 4.86 2.57 5.47 3.05 5.75L10.84 10.25L12.34 7.65L14.07 8.65L12.57 11.25L20.36 15.75C20.84 16 21.46 15.86 21.73 15.38L22.73 13.65C23.28 12.69 22.96 11.47 22 10.92M12.37 5C11.5 5.25 10.8 4.32 11.24 3.55C11.5 3.07 12.13 2.91 12.61 3.18C13.38 3.63 13.23 4.79 12.37 5M17.56 8C16.7 8.25 16 7.32 16.44 6.55C16.71 6.07 17.33 5.91 17.8 6.18C18.57 6.63 18.42 7.79 17.56 8M20.87 16.88C21.28 16.88 21.67 16.74 22 16.5V20C22 21.11 21.11 22 20 22H4C2.9 22 2 21.11 2 20V11H10.15L11 11.5V20H13V12.65L19.87 16.61C20.17 16.79 20.5 16.88 20.87 16.88Z";
var mdiGiftOpenOutline = "M22 10.87L19.26 9.28C19.5 9.07 19.73 8.8 19.9 8.5C20.73 7.07 20.24 5.23 18.8 4.4C17.94 3.9 16.93 3.9 16.08 4.26L16.09 4.25L15.21 4.64L15.1 3.68L15.09 3.69C15 2.78 14.47 1.9 13.61 1.4C12.17 .575 10.34 1.07 9.5 2.5C9.33 2.8 9.22 3.13 9.16 3.45L6.41 1.87C5.45 1.32 4.23 1.64 3.68 2.6L2.18 5.2C1.9 5.68 2.07 6.29 2.55 6.56L4.28 7.56L8.5 10H2V20C2 21.11 2.9 22 4 22H20C21.11 22 22 21.11 22 20V14.87L22.73 13.6C23.28 12.64 22.96 11.42 22 10.87M16.44 6.5C16.71 6 17.33 5.86 17.8 6.13C18.28 6.41 18.45 7 18.17 7.5C17.89 8 17.28 8.14 16.8 7.87C16.33 7.59 16.16 7 16.44 6.5M14.07 8.6L21 12.6L20 14.33L13.07 10.33L14.07 8.6M11 20H4V12H11V20M11.34 9.33L4.41 5.33L5.41 3.6L12.34 7.6L11.34 9.33M11.61 4.87C11.13 4.59 10.97 4 11.24 3.5C11.5 3 12.13 2.86 12.61 3.13C13.09 3.41 13.25 4 12.97 4.5C12.7 5 12.09 5.14 11.61 4.87M13 20V12.6L20 16.64V20H13Z";
var mdiGiftOutline = "M22,12V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V12A1,1 0 0,1 1,11V8A2,2 0 0,1 3,6H6.17C6.06,5.69 6,5.35 6,5A3,3 0 0,1 9,2C10,2 10.88,2.5 11.43,3.24V3.23L12,4L12.57,3.23V3.24C13.12,2.5 14,2 15,2A3,3 0 0,1 18,5C18,5.35 17.94,5.69 17.83,6H21A2,2 0 0,1 23,8V11A1,1 0 0,1 22,12M4,20H11V12H4V20M20,20V12H13V20H20M9,4A1,1 0 0,0 8,5A1,1 0 0,0 9,6A1,1 0 0,0 10,5A1,1 0 0,0 9,4M15,4A1,1 0 0,0 14,5A1,1 0 0,0 15,6A1,1 0 0,0 16,5A1,1 0 0,0 15,4M3,8V10H11V8H3M13,8V10H21V8H13Z";
var mdiGit = "M2.6,10.59L8.38,4.8L10.07,6.5C9.83,7.35 10.22,8.28 11,8.73V14.27C10.4,14.61 10,15.26 10,16A2,2 0 0,0 12,18A2,2 0 0,0 14,16C14,15.26 13.6,14.61 13,14.27V9.41L15.07,11.5C15,11.65 15,11.82 15,12A2,2 0 0,0 17,14A2,2 0 0,0 19,12A2,2 0 0,0 17,10C16.82,10 16.65,10 16.5,10.07L13.93,7.5C14.19,6.57 13.71,5.55 12.78,5.16C12.35,5 11.9,4.96 11.5,5.07L9.8,3.38L10.59,2.6C11.37,1.81 12.63,1.81 13.41,2.6L21.4,10.59C22.19,11.37 22.19,12.63 21.4,13.41L13.41,21.4C12.63,22.19 11.37,22.19 10.59,21.4L2.6,13.41C1.81,12.63 1.81,11.37 2.6,10.59Z";
var mdiGithub = "M12,2A10,10 0 0,0 2,12C2,16.42 4.87,20.17 8.84,21.5C9.34,21.58 9.5,21.27 9.5,21C9.5,20.77 9.5,20.14 9.5,19.31C6.73,19.91 6.14,17.97 6.14,17.97C5.68,16.81 5.03,16.5 5.03,16.5C4.12,15.88 5.1,15.9 5.1,15.9C6.1,15.97 6.63,16.93 6.63,16.93C7.5,18.45 8.97,18 9.54,17.76C9.63,17.11 9.89,16.67 10.17,16.42C7.95,16.17 5.62,15.31 5.62,11.5C5.62,10.39 6,9.5 6.65,8.79C6.55,8.54 6.2,7.5 6.75,6.15C6.75,6.15 7.59,5.88 9.5,7.17C10.29,6.95 11.15,6.84 12,6.84C12.85,6.84 13.71,6.95 14.5,7.17C16.41,5.88 17.25,6.15 17.25,6.15C17.8,7.5 17.45,8.54 17.35,8.79C18,9.5 18.38,10.39 18.38,11.5C18.38,15.32 16.04,16.16 13.81,16.41C14.17,16.72 14.5,17.33 14.5,18.26C14.5,19.6 14.5,20.68 14.5,21C14.5,21.27 14.66,21.59 15.17,21.5C19.14,20.16 22,16.42 22,12A10,10 0 0,0 12,2Z";
var mdiGitlab = "M21.94 13.11L20.89 9.89C20.89 9.86 20.88 9.83 20.87 9.8L18.76 3.32C18.65 3 18.33 2.75 17.96 2.75C17.6 2.75 17.28 3 17.17 3.33L15.17 9.5H8.84L6.83 3.33C6.72 3 6.4 2.75 6.04 2.75H6.04C5.67 2.75 5.35 3 5.24 3.33L3.13 9.82C3.13 9.82 3.13 9.83 3.13 9.83L2.06 13.11C1.9 13.61 2.07 14.15 2.5 14.45L11.72 21.16C11.89 21.28 12.11 21.28 12.28 21.15L21.5 14.45C21.93 14.15 22.1 13.61 21.94 13.11M8.15 10.45L10.72 18.36L4.55 10.45M13.28 18.37L15.75 10.78L15.85 10.45H19.46L13.87 17.61M17.97 3.94L19.78 9.5H16.16M14.86 10.45L13.07 15.96L12 19.24L9.14 10.45M6.03 3.94L7.84 9.5H4.23M3.05 13.69C2.96 13.62 2.92 13.5 2.96 13.4L3.75 10.97L9.57 18.42M20.95 13.69L14.44 18.42L14.46 18.39L20.25 10.97L21.04 13.4C21.08 13.5 21.04 13.62 20.95 13.69";
var mdiGlassCocktail = "M7.5,7L5.5,5H18.5L16.5,7M11,13V19H6V21H18V19H13V13L21,5V3H3V5L11,13Z";
var mdiGlassCocktailOff = "M13.33 12.67L7.66 7L6.13 5.47L2.39 1.73L1.11 3L3 4.89V5L11 13V19H6V21H18V19.89L20.84 22.73L22.11 21.46L13.33 12.67M13 19V14.89L17.11 19H13M8.2 5L6.2 3H21V5L14.6 11.4L10.2 7H16.5L18.5 5H8.2Z";
var mdiGlassFlute = "M8,2H16C15.67,5 15.33,8 14.75,9.83C14.17,11.67 13.33,12.33 12.92,14.08C12.5,15.83 12.5,18.67 13.08,20C13.67,21.33 14.83,21.17 15.42,21.25C16,21.33 16,21.67 16,22H8C8,21.67 8,21.33 8.58,21.25C9.17,21.17 10.33,21.33 10.92,20C11.5,18.67 11.5,15.83 11.08,14.08C10.67,12.33 9.83,11.67 9.25,9.83C8.67,8 8.33,5 8,2M10,4C10.07,5.03 10.15,6.07 10.24,7H13.76C13.85,6.07 13.93,5.03 14,4H10Z";
var mdiGlassFragile = "M13 20H18V22H6V20H11V13.97C8.19 13.7 6 11.34 6 8.46C6 8.15 6.03 7.85 6.08 7.55L7 2H13.54L12.33 4.41L11.79 5.5H13.79L12.33 8.41L11.79 9.5H14L13 12.75L15.67 9.09L16.46 8H14.21L15.67 5.09L16.21 4H14.21L15.21 2H17L17.93 7.55C18 7.85 18 8.15 18 8.46C18 11.34 15.81 13.7 13 13.97V20Z";
var mdiGlassMug = "M10,4V7H18V4H10M8,2H20L21,2V3L20,4V20L21,21V22H20L8,22H7V21L8,20V18.6L4.2,16.83C3.5,16.5 3,15.82 3,15V8A2,2 0 0,1 5,6H8V4L7,3V2H8M5,15L8,16.39V8H5V15Z";
var mdiGlassMugOff = "M20 19.35V19.34L6.66 6L6.07 5.41L2.39 1.73L1.11 3L4.26 6.15C3.5 6.44 3 7.16 3 8V15C3 15.82 3.5 16.5 4.2 16.83L8 18.6V20L7 21V22H20.11L20.84 22.73L22.11 21.46L20 19.35M8 16.39L5 15V8H6.11L8 9.89V16.39M8 4L7 3V2H21V3L20 4V16.8L10.2 7H18V4H10V6.8L8 4.8V4Z";
var mdiGlassMugVariant = "M9.5 3C7.56 3 5.85 4.24 5.23 6.08C3.36 6.44 2 8.09 2 10C2 12.21 3.79 14 6 14V22H17V20H20C20.55 20 21 19.55 21 19V11C21 10.45 20.55 10 20 10H18V8C18 5.79 16.21 4 14 4H12.32C11.5 3.35 10.53 3 9.5 3M9.5 5C10.29 5 11.03 5.37 11.5 6H14C15.11 6 16 6.9 16 8H12C10 8 9.32 9.13 8.5 10.63C7.68 12.13 6 12 6 12C4.89 12 4 11.11 4 10C4 8.9 4.89 8 6 8H7V7.5C7 6.12 8.12 5 9.5 5M17 12H19V18H17Z";
var mdiGlassMugVariantOff = "M8.44 5.24L7 3.79C7.71 3.29 8.57 3 9.5 3C10.53 3 11.5 3.35 12.32 4H14C16.21 4 18 5.79 18 8V10H20C20.55 10 21 10.45 21 11V17.8L19 15.8V12H17V13.8L11.26 8.06C11.5 8 11.73 8 12 8H16C16 6.9 15.11 6 14 6H11.5C11.03 5.37 10.29 5 9.5 5C9.12 5 8.76 5.09 8.44 5.24M22.11 21.46L20.84 22.73L18.11 20H17V22H6V14C3.79 14 2 12.21 2 10C2 8.37 3 6.94 4.44 6.33L1.11 3L2.39 1.73L7.19 6.54L9.61 8.96L17 16.34V16.35L18.65 18H18.66L20.5 19.84V19.85L22.11 21.46M8.59 10.5L6.11 8H6C4.89 8 4 8.9 4 10C4 11.11 4.89 12 6 12C6 12 7.68 12.13 8.5 10.63L8.59 10.5Z";
var mdiGlassPintOutline = "M4 2L6 22H17L19 2H4M6.2 4H16.8L15.2 20H7.8L6.2 4Z";
var mdiGlassStange = "M8,2H16V22H8V2M10,4V7H14V4H10Z";
var mdiGlassTulip = "M8,2H16C15.67,2.67 15.33,3.33 15.58,5C15.83,6.67 16.67,9.33 16.25,10.74C15.83,12.14 14.17,12.28 13.33,13.86C12.5,15.44 12.5,18.47 13.08,19.9C13.67,21.33 14.83,21.17 15.42,21.25C16,21.33 16,21.67 16,22H8C8,21.67 8,21.33 8.58,21.25C9.17,21.17 10.33,21.33 10.92,19.9C11.5,18.47 11.5,15.44 10.67,13.86C9.83,12.28 8.17,12.14 7.75,10.74C7.33,9.33 8.17,6.67 8.42,5C8.67,3.33 8.33,2.67 8,2M10,4C10,5.19 9.83,6.17 9.64,7H14.27C14.13,6.17 14,5.19 14,4H10Z";
var mdiGlassWine = "M15.5,21.27L14.66,21.18C13.9,21.11 13.25,20.6 13,19.87C12.47,17.91 12.47,15.83 13,13.87C15.32,13.4 17,11.37 17,9C17,7 15,2 15,2H9C9,2 7,7 7,9C7,11.38 8.67,13.42 11,13.9C11.53,15.86 11.53,17.94 11,19.9C10.76,20.62 10.12,21.13 9.37,21.21L8.5,21.3C8.5,21.3 8,21.28 8,22H16C16,21.28 15.5,21.27 15.5,21.27M9.44,7L10.44,4H13.56L14.56,7H9.44Z";
var mdiGlasses = "M3,10C2.76,10 2.55,10.09 2.41,10.25C2.27,10.4 2.21,10.62 2.24,10.86L2.74,13.85C2.82,14.5 3.4,15 4,15H7C7.64,15 8.36,14.44 8.5,13.82L9.56,10.63C9.6,10.5 9.57,10.31 9.5,10.19C9.39,10.07 9.22,10 9,10H3M7,17H4C2.38,17 0.96,15.74 0.76,14.14L0.26,11.15C0.15,10.3 0.39,9.5 0.91,8.92C1.43,8.34 2.19,8 3,8H9C9.83,8 10.58,8.35 11.06,8.96C11.17,9.11 11.27,9.27 11.35,9.45C11.78,9.36 12.22,9.36 12.64,9.45C12.72,9.27 12.82,9.11 12.94,8.96C13.41,8.35 14.16,8 15,8H21C21.81,8 22.57,8.34 23.09,8.92C23.6,9.5 23.84,10.3 23.74,11.11L23.23,14.18C23.04,15.74 21.61,17 20,17H17C15.44,17 13.92,15.81 13.54,14.3L12.64,11.59C12.26,11.31 11.73,11.31 11.35,11.59L10.43,14.37C10.07,15.82 8.56,17 7,17M15,10C14.78,10 14.61,10.07 14.5,10.19C14.42,10.31 14.4,10.5 14.45,10.7L15.46,13.75C15.64,14.44 16.36,15 17,15H20C20.59,15 21.18,14.5 21.25,13.89L21.76,10.82C21.79,10.62 21.73,10.4 21.59,10.25C21.45,10.09 21.24,10 21,10H15Z";
var mdiGlobeLight = "M7.1 10C8.1 9 9.5 8.3 11 8.1V2H13V8.1C14.5 8.3 15.9 9 16.9 10H7.1M5.3 13C5.1 13.6 5 14.3 5 15C5 18.9 8.1 22 12 22S19 18.9 19 15C19 14.3 18.9 13.6 18.7 13H5.3Z";
var mdiGlobeLightOutline = "M13 8.08V2H11V8.08C7.61 8.57 5 11.47 5 15C5 18.87 8.13 22 12 22S19 18.87 19 15C19 11.47 16.39 8.57 13 8.08M12 20C9.24 20 7 17.76 7 15C7 13.87 7.39 12.84 8.03 12H15.97C16.61 12.84 17 13.87 17 15C17 17.76 14.76 20 12 20Z";
var mdiGlobeModel = "M17.36,2.64L15.95,4.06C17.26,5.37 18,7.14 18,9A7,7 0 0,1 11,16C9.15,16 7.37,15.26 6.06,13.95L4.64,15.36C6.08,16.8 7.97,17.71 10,17.93V20H6V22H16V20H12V17.94C16.55,17.43 20,13.58 20,9C20,6.62 19.05,4.33 17.36,2.64M11,3.5A5.5,5.5 0 0,0 5.5,9A5.5,5.5 0 0,0 11,14.5A5.5,5.5 0 0,0 16.5,9A5.5,5.5 0 0,0 11,3.5M11,5.5C12.94,5.5 14.5,7.07 14.5,9A3.5,3.5 0 0,1 11,12.5A3.5,3.5 0 0,1 7.5,9A3.5,3.5 0 0,1 11,5.5Z";
var mdiGmail = "M20,18H18V9.25L12,13L6,9.25V18H4V6H5.2L12,10.25L18.8,6H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z";
var mdiGnome = "M18.42,2C14.26,2 13.5,7.93 15.82,7.93C18.16,7.93 22.58,2 18.42,2M12,2.73C11.92,2.73 11.85,2.73 11.78,2.74C9.44,3.04 10.26,7.12 11.5,7.19C12.72,7.27 14.04,2.73 12,2.73M7.93,4.34C7.81,4.34 7.67,4.37 7.53,4.43C5.65,5.21 7.24,8.41 8.3,8.2C9.27,8 9.39,4.3 7.93,4.34M4.93,6.85C4.77,6.84 4.59,6.9 4.41,7.03C2.9,8.07 4.91,10.58 5.8,10.19C6.57,9.85 6.08,6.89 4.93,6.85M13.29,8.77C10.1,8.8 6.03,10.42 5.32,13.59C4.53,17.11 8.56,22 12.76,22C14.83,22 17.21,20.13 17.66,17.77C18,15.97 13.65,16.69 13.81,17.88C14,19.31 12.76,20 11.55,19.1C7.69,16.16 17.93,14.7 17.25,10.69C17.03,9.39 15.34,8.76 13.29,8.77Z";
var mdiGoKart = "M18,10H15.53L14.38,8.28L15.8,7.33L14.7,5.67L10.2,8.67L11.3,10.33L12.73,9.38L13.88,11.12L13,12H10.2L5.83,5.45L4.17,6.55L5.87,9.11C3.04,9.65 1,12.12 1,15V17H3A3,3 0 0,0 6,20A3,3 0 0,0 9,17H15A3,3 0 0,0 18,20A3,3 0 0,0 21,17H23V15A5,5 0 0,0 18,10M6,18.5A1.5,1.5 0 0,1 4.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,17A1.5,1.5 0 0,1 6,18.5M18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5Z";
var mdiGoKartTrack = "M22,5.5A3.5,3.5 0 0,0 18.5,2A3.5,3.5 0 0,0 15,5.5V6A3,3 0 0,1 12,9C10,9 9,6 6,6A4,4 0 0,0 2,10V11H4V10A2,2 0 0,1 6,8C6.86,8 7.42,8.45 8.32,9.24C9.28,10.27 10.6,10.9 12,11A5,5 0 0,0 17,6V5.5A1.5,1.5 0 0,1 18.5,4A1.5,1.5 0 0,1 20,5.5C19.86,6.35 19.58,7.18 19.17,7.94C18.5,9.2 18.11,10.58 18,12C18.09,13.37 18.5,14.71 19.21,15.89C19.6,16.54 19.87,17.25 20,18A2,2 0 0,1 18,20A2,2 0 0,1 16,18A3.75,3.75 0 0,0 12.25,14.25A3.75,3.75 0 0,0 8.5,18V18.5A1.5,1.5 0 0,1 7,20A3,3 0 0,1 4,17V15H6V13H0V15H2V17A5,5 0 0,0 7,22A3.5,3.5 0 0,0 10.5,18.5V18A1.75,1.75 0 0,1 12.25,16.25A1.75,1.75 0 0,1 14,18A4,4 0 0,0 18,22A4,4 0 0,0 22,18C22,16 20,14 20,12C20,10 22,7.5 22,5.5Z";
var mdiGog = "M4,3H20A2,2 0 0,1 22,5V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V5A2,2 0 0,1 4,3M10.46,5.54C9.95,5.54 9.54,5.95 9.54,6.46V9.54A0.92,0.92 0 0,0 10.46,10.46H13.54A0.92,0.92 0 0,0 14.46,9.54V6.46C14.46,5.95 14.05,5.54 13.54,5.54H10.46M11.08,6.77H12.92A0.31,0.31 0 0,1 13.23,7.08V8.92A0.31,0.31 0 0,1 12.92,9.23H11.08A0.31,0.31 0 0,1 10.77,8.92V7.08A0.31,0.31 0 0,1 11.08,6.77M4.92,5.54A0.92,0.92 0 0,0 4,6.46V9.54C4,10.05 4.41,10.46 4.92,10.46H7.08V9.23H5.54C5.37,9.23 5.23,9.09 5.23,8.92V7.08C5.23,6.91 5.37,6.77 5.54,6.77H7.38A0.31,0.31 0 0,1 7.69,7.08V10.77A0.31,0.31 0 0,1 7.38,11.08H4V12.31H8C8.5,12.31 8.92,11.89 8.92,11.38V6.46A0.92,0.92 0 0,0 8,5.54H4.92M16,5.54C15.5,5.54 15.08,5.95 15.08,6.46V9.54C15.08,10.05 15.5,10.46 16,10.46H18.15V9.23H16.62C16.45,9.23 16.31,9.09 16.31,8.92V7.08C16.31,6.91 16.45,6.77 16.62,6.77H18.46C18.63,6.77 18.77,6.91 18.77,7.08V10.77C18.77,10.94 18.63,11.08 18.46,11.08H15.08V12.31H19.08C19.59,12.31 20,11.89 20,11.38V6.46C20,5.95 19.59,5.54 19.08,5.54H16M9.85,13.54C9.34,13.54 8.92,13.95 8.92,14.46V17.54C8.92,18.05 9.34,18.46 9.85,18.46H12.92C13.43,18.46 13.85,18.05 13.85,17.54V14.46C13.85,13.95 13.43,13.54 12.92,13.54H9.85M10.46,14.77H12.31C12.5,14.77 12.62,14.91 12.62,15.08V16.92A0.31,0.31 0 0,1 12.31,17.23H10.46C10.29,17.23 10.15,17.09 10.15,16.92V15.08A0.31,0.31 0 0,1 10.46,14.77M4.92,13.54C4.41,13.54 4,13.95 4,14.46V17.54C4,18.05 4.41,18.46 4.92,18.46H8.31V17.23H5.54C5.37,17.23 5.23,17.09 5.23,16.92V15.08C5.23,14.91 5.37,14.77 5.54,14.77H8.31V13.54H4.92M15.38,13.54C14.87,13.54 14.46,13.95 14.46,14.46V18.46H15.69V15.08A0.31,0.31 0 0,1 16,14.77H16.62V18.46H17.85V14.77H18.77V18.46H20V13.54H15.38Z";
var mdiGold = "M1 22L2.5 17H9.5L11 22H1M13 22L14.5 17H21.5L23 22H13M6 15L7.5 10H14.5L16 15H6M23 6.05L19.14 7.14L18.05 11L16.96 7.14L13.1 6.05L16.96 4.96L18.05 1.1L19.14 4.96L23 6.05Z";
var mdiGolf = "M19.5,18A1.5,1.5 0 0,1 21,19.5A1.5,1.5 0 0,1 19.5,21A1.5,1.5 0 0,1 18,19.5A1.5,1.5 0 0,1 19.5,18M17,5.92L11,9V18.03C13.84,18.19 16,19 16,20C16,21.1 13.31,22 10,22C6.69,22 4,21.1 4,20C4,19.26 5.21,18.62 7,18.27V20H9V2L17,5.92Z";
var mdiGolfCart = "M19.89 12.37L18.25 5H19V3H3V7H1V9H3V12.54A6 6 0 0 0 1 17V19H3A3 3 0 0 0 9 19H15A3 3 0 0 0 21 19H23V17A5 5 0 0 0 19.89 12.37M6 20.5A1.5 1.5 0 1 1 7.5 19A1.5 1.5 0 0 1 6 20.5M15.53 12L14.38 10.28L15.8 9.33L14.7 7.67L10.2 10.67L11.3 12.33L12.73 11.38L13.88 13.12L13 14H10.2L5 7V5H16.2L17.75 12M18 20.5A1.5 1.5 0 1 1 19.5 19A1.5 1.5 0 0 1 18 20.5Z";
var mdiGolfTee = "M7 19V17H17V19H15C14.5 19 14 19.2 13.6 19.6S13 20.5 13 21V22H11V21C11 20.5 10.8 20 10.4 19.6S9.5 19 9 19H7M11 6C11 5.7 11.1 5.5 11.3 5.3S11.7 5 12 5 12.5 5.1 12.7 5.3 13 5.7 13 6 12.9 6.5 12.7 6.7 12.3 7 12 7 11.5 6.9 11.3 6.7 11 6.3 11 6M13 8C13 7.7 13.1 7.5 13.3 7.3S13.7 7 14 7 14.5 7.1 14.7 7.3 15 7.7 15 8 14.9 8.5 14.7 8.7 14.3 9 14 9 13.5 8.9 13.3 8.7 13 8.3 13 8M9 8C9 7.7 9.1 7.5 9.3 7.3S9.7 7 10 7 10.5 7.1 10.7 7.3 11 7.7 11 8 10.9 8.5 10.7 8.7 10.3 9 10 9 9.5 8.9 9.3 8.7 9 8.3 9 8M16.9 4.1C15.5 2.7 13.9 2.1 12 2.1S8.4 2.8 7.1 4.1 5 7.1 5 9 5.7 12.6 7 13.9 10 15.9 11.9 15.9 15.5 15.2 16.8 13.9 18.8 10.9 18.8 9 18.3 5.4 16.9 4.1M15.5 12.5C14.5 13.5 13.3 14 12 14S9.4 13.5 8.5 12.5 7 10.4 7 9 7.5 6.4 8.5 5.5 10.6 4 12 4 14.6 4.5 15.5 5.5 17 7.6 17 9 16.5 11.6 15.5 12.5Z";
var mdiGondola = "M18,10H13V7.59L22.12,6.07L21.88,4.59L16.41,5.5C16.46,5.35 16.5,5.18 16.5,5A1.5,1.5 0 0,0 15,3.5A1.5,1.5 0 0,0 13.5,5C13.5,5.35 13.63,5.68 13.84,5.93L13,6.07V5H11V6.41L10.41,6.5C10.46,6.35 10.5,6.18 10.5,6A1.5,1.5 0 0,0 9,4.5A1.5,1.5 0 0,0 7.5,6C7.5,6.36 7.63,6.68 7.83,6.93L1.88,7.93L2.12,9.41L11,7.93V10H6C4.89,10 4,10.9 4,12V18A2,2 0 0,0 6,20H18A2,2 0 0,0 20,18V12A2,2 0 0,0 18,10M6,12H8.25V16H6V12M9.75,16V12H14.25V16H9.75M18,16H15.75V12H18V16Z";
var mdiGoodreads = "M17,12.77C15.96,14.42 14.22,15.5 12.25,15.5C9.07,15.5 6.5,12.7 6.5,9.25C6.5,5.8 9.07,3 12.25,3C14.22,3 15.96,4.08 17,5.73V3H18V15.25C18,20.71 14.54,21 11.5,21C9,21 7.55,19.31 7.13,17H8.14C8.5,18.75 9.54,20 11.5,20C13.72,20 17,20.05 17,15.25V15.25L17,12.77M12.25,4C9.63,4 7.5,6.35 7.5,9.25C7.5,12.15 9.63,14.5 12.25,14.5C14.87,14.5 17,12.15 17,9.25C17,6.35 14.87,4 12.25,4Z";
var mdiGoogle = "M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z";
var mdiGoogleAds = "M12.25 1.47C11.55 1.42 10.82 1.58 10.17 1.96C8.41 2.97 7.81 5.21 8.82 6.96L16.16 19.66C17.17 21.42 19.41 22 21.17 21C22.92 20 23.5 17.75 22.5 16L15.18 3.3C14.54 2.2 13.43 1.56 12.25 1.47M6.82 6.76L1.5 16A3.67 3.67 0 0 0 1 17.83A3.67 3.67 0 0 0 4.67 21.5A3.67 3.67 0 0 0 7.84 19.66V19.67L11 14.19C9.65 11.89 8.27 9.6 7.03 7.23C6.95 7.08 6.88 6.92 6.83 6.76ZL16.4 5Z";
var mdiGoogleAnalytics = "M15.86 4.39V19.39C15.86 21.06 17 22 18.25 22C19.39 22 20.64 21.21 20.64 19.39V4.5C20.64 2.96 19.5 2 18.25 2S15.86 3.06 15.86 4.39M9.61 12V19.39C9.61 21.07 10.77 22 12 22C13.14 22 14.39 21.21 14.39 19.39V12.11C14.39 10.57 13.25 9.61 12 9.61S9.61 10.67 9.61 12M5.75 17.23C7.07 17.23 8.14 18.3 8.14 19.61C8.14 20.93 7.07 22 5.75 22S3.36 20.93 3.36 19.61C3.36 18.3 4.43 17.23 5.75 17.23Z";
var mdiGoogleAssistant = "M7,2A6,6 0 0,0 1,8A6,6 0 0,0 7,14A6,6 0 0,0 13,8A6,6 0 0,0 7,2M21.5,6A1.5,1.5 0 0,0 20,7.5A1.5,1.5 0 0,0 21.5,9A1.5,1.5 0 0,0 23,7.5A1.5,1.5 0 0,0 21.5,6M17,8A3,3 0 0,0 14,11A3,3 0 0,0 17,14A3,3 0 0,0 20,11A3,3 0 0,0 17,8M17,15A3.5,3.5 0 0,0 13.5,18.5A3.5,3.5 0 0,0 17,22A3.5,3.5 0 0,0 20.5,18.5A3.5,3.5 0 0,0 17,15Z";
var mdiGoogleCardboard = "M20.74,6H3.2C2.55,6 2,6.57 2,7.27V17.73C2,18.43 2.55,19 3.23,19H8C8.54,19 9,18.68 9.16,18.21L10.55,14.74C10.79,14.16 11.35,13.75 12,13.75C12.65,13.75 13.21,14.16 13.45,14.74L14.84,18.21C15.03,18.68 15.46,19 15.95,19H20.74C21.45,19 22,18.43 22,17.73V7.27C22,6.57 21.45,6 20.74,6M7.22,14.58C6,14.58 5,13.55 5,12.29C5,11 6,10 7.22,10C8.44,10 9.43,11 9.43,12.29C9.43,13.55 8.44,14.58 7.22,14.58M16.78,14.58C15.56,14.58 14.57,13.55 14.57,12.29C14.57,11.03 15.56,10 16.78,10C18,10 19,11.03 19,12.29C19,13.55 18,14.58 16.78,14.58Z";
var mdiGoogleChrome = "M12,20L15.46,14H15.45C15.79,13.4 16,12.73 16,12C16,10.8 15.46,9.73 14.62,9H19.41C19.79,9.93 20,10.94 20,12A8,8 0 0,1 12,20M4,12C4,10.54 4.39,9.18 5.07,8L8.54,14H8.55C9.24,15.19 10.5,16 12,16C12.45,16 12.88,15.91 13.29,15.77L10.89,19.91C7,19.37 4,16.04 4,12M15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9A3,3 0 0,1 15,12M12,4C14.96,4 17.54,5.61 18.92,8H12C10.06,8 8.45,9.38 8.08,11.21L5.7,7.08C7.16,5.21 9.44,4 12,4M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiGoogleCircles = "M16.66,15H17C18,15 19,14.8 19.87,14.46C19.17,18.73 15.47,22 11,22C6,22 2,17.97 2,13C2,8.53 5.27,4.83 9.54,4.13C9.2,5 9,6 9,7V7.34C6.68,8.16 5,10.38 5,13A6,6 0 0,0 11,19C13.62,19 15.84,17.32 16.66,15M17,10A3,3 0 0,0 20,7A3,3 0 0,0 17,4A3,3 0 0,0 14,7A3,3 0 0,0 17,10M17,1A6,6 0 0,1 23,7A6,6 0 0,1 17,13A6,6 0 0,1 11,7C11,3.68 13.69,1 17,1Z";
var mdiGoogleCirclesCommunities = "M15,12C13.89,12 13,12.89 13,14A2,2 0 0,0 15,16A2,2 0 0,0 17,14C17,12.89 16.1,12 15,12M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M14,9C14,7.89 13.1,7 12,7C10.89,7 10,7.89 10,9A2,2 0 0,0 12,11A2,2 0 0,0 14,9M9,12A2,2 0 0,0 7,14A2,2 0 0,0 9,16A2,2 0 0,0 11,14C11,12.89 10.1,12 9,12Z";
var mdiGoogleCirclesExtended = "M18,19C16.89,19 16,18.1 16,17C16,15.89 16.89,15 18,15A2,2 0 0,1 20,17A2,2 0 0,1 18,19M18,13A4,4 0 0,0 14,17A4,4 0 0,0 18,21A4,4 0 0,0 22,17A4,4 0 0,0 18,13M12,11.1A1.9,1.9 0 0,0 10.1,13A1.9,1.9 0 0,0 12,14.9A1.9,1.9 0 0,0 13.9,13A1.9,1.9 0 0,0 12,11.1M6,19C4.89,19 4,18.1 4,17C4,15.89 4.89,15 6,15A2,2 0 0,1 8,17A2,2 0 0,1 6,19M6,13A4,4 0 0,0 2,17A4,4 0 0,0 6,21A4,4 0 0,0 10,17A4,4 0 0,0 6,13M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8C10.89,8 10,7.1 10,6C10,4.89 10.89,4 12,4M12,10A4,4 0 0,0 16,6A4,4 0 0,0 12,2A4,4 0 0,0 8,6A4,4 0 0,0 12,10Z";
var mdiGoogleCirclesGroup = "M5,10A2,2 0 0,0 3,12C3,13.11 3.9,14 5,14C6.11,14 7,13.11 7,12A2,2 0 0,0 5,10M5,16A4,4 0 0,1 1,12A4,4 0 0,1 5,8A4,4 0 0,1 9,12A4,4 0 0,1 5,16M10.5,11H14V8L18,12L14,16V13H10.5V11M5,6C4.55,6 4.11,6.05 3.69,6.14C5.63,3.05 9.08,1 13,1C19.08,1 24,5.92 24,12C24,18.08 19.08,23 13,23C9.08,23 5.63,20.95 3.69,17.86C4.11,17.95 4.55,18 5,18C5.8,18 6.56,17.84 7.25,17.56C8.71,19.07 10.74,20 13,20A8,8 0 0,0 21,12A8,8 0 0,0 13,4C10.74,4 8.71,4.93 7.25,6.44C6.56,6.16 5.8,6 5,6Z";
var mdiGoogleClassroom = "M23,2H1A1,1 0 0,0 0,3V21A1,1 0 0,0 1,22H23A1,1 0 0,0 24,21V3A1,1 0 0,0 23,2M22,20H20V19H15V20H2V4H22V20M10.29,9.71A1.71,1.71 0 0,1 12,8C12.95,8 13.71,8.77 13.71,9.71C13.71,10.66 12.95,11.43 12,11.43C11.05,11.43 10.29,10.66 10.29,9.71M5.71,11.29C5.71,10.58 6.29,10 7,10A1.29,1.29 0 0,1 8.29,11.29C8.29,12 7.71,12.57 7,12.57C6.29,12.57 5.71,12 5.71,11.29M15.71,11.29A1.29,1.29 0 0,1 17,10A1.29,1.29 0 0,1 18.29,11.29C18.29,12 17.71,12.57 17,12.57C16.29,12.57 15.71,12 15.71,11.29M20,15.14V16H16L14,16H10L8,16H4V15.14C4,14.2 5.55,13.43 7,13.43C7.55,13.43 8.11,13.54 8.6,13.73C9.35,13.04 10.7,12.57 12,12.57C13.3,12.57 14.65,13.04 15.4,13.73C15.89,13.54 16.45,13.43 17,13.43C18.45,13.43 20,14.2 20,15.14Z";
var mdiGoogleCloud = "M23 14.75C23 18.2 20.2 21 16.75 21H7.25C3.8 21 1 18.2 1 14.75C1 12.61 2.08 10.72 3.71 9.6C4.58 5.82 7.96 3 12 3C16.04 3 19.42 5.82 20.29 9.6C21.93 10.72 23 12.61 23 14.75M16.63 17C17.94 17 19 15.94 19 14.63C19 13.35 18 12.3 16.72 12.25L16.75 11.75C16.75 9.13 14.62 7 12 7C10.58 7 9.3 7.62 8.43 8.61C9.93 8.9 11.23 9.72 12.14 10.86L9.5 13.5C9.08 12.77 8.29 12.25 7.38 12.25C6.06 12.25 5 13.31 5 14.63C5 15.9 6 16.93 7.25 17V17H16.63Z";
var mdiGoogleDownasaur = "M13 2V3H12V9H11V10H9V11H8V12H7V13H5V12H4V11H3V9H2V15H3V16H4V17H5V18H6V22H8V21H7V20H8V19H9V18H10V19H11V22H13V21H12V17H13V16H14V15H15V12H16V13H17V11H15V9H20V8H17V7H22V3H21V2M14 3H15V4H14Z";
var mdiGoogleDrive = "M7.71,3.5L1.15,15L4.58,21L11.13,9.5M9.73,15L6.3,21H19.42L22.85,15M22.28,14L15.42,2H8.58L8.57,2L15.43,14H22.28Z";
var mdiGoogleEarth = "M12,12.14C11.09,10.77 10.14,9.78 9.14,9.19C8.14,8.59 7.27,8.38 6.5,8.55C5.77,8.73 5.14,9.14 4.64,9.8C4.2,10.39 4,11.06 4,11.81V12C4,12.78 4.11,13.58 4.36,14.39C4.45,14.64 4.5,14.64 4.55,14.39C4.67,13.77 4.96,13.31 5.41,13.03C5.87,12.75 6.47,12.76 7.22,13.05C7.97,13.35 8.7,14 9.42,14.95C10.7,16.67 12.2,17.72 13.92,18.09C16.14,18.41 17.81,17.7 18.94,16C19.25,15.39 19.5,14.86 19.64,14.39C19.73,14.08 19.69,14.05 19.5,14.3C19.03,14.92 18.4,15.33 17.6,15.5C16.8,15.7 15.89,15.5 14.86,15C13.83,14.43 12.88,13.5 12,12.14M16.97,8.16C15.41,5.81 13.72,4.5 11.91,4.17C10.47,3.95 8.91,4.45 7.22,5.67C7,5.83 6.9,5.91 6.91,5.93C6.93,5.95 7.06,5.89 7.31,5.77C9.81,4.55 12.22,5.83 14.53,9.61C15.03,10.45 15.55,11.11 16.1,11.58C16.65,12.05 17.16,12.33 17.65,12.42C18.13,12.5 18.57,12.5 18.96,12.38C19.35,12.25 19.7,12.05 20,11.77C20,11.17 19.91,10.5 19.69,9.8C19.19,9.92 18.74,9.88 18.35,9.68C17.96,9.5 17.5,8.97 16.97,8.16M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.75 21,17.1 19.05,19.05C17.1,21 14.75,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z";
var mdiGoogleFit = "M17,4A5,5 0 0,1 22,9C22,10.38 21.44,11.63 20.54,12.54L12,21.07L3.46,12.54C2.56,11.63 2,10.38 2,9A5,5 0 0,1 7,4C8.38,4 9.63,4.56 10.54,5.46L12,6.93L13.46,5.46C14.37,4.56 15.62,4 17,4M15.59,7.59L9.17,14L12,16.83L18.41,10.41C18.78,10.05 19,9.55 19,9A2,2 0 0,0 17,7C16.45,7 15.95,7.22 15.59,7.59M8.41,7.59C8.05,7.22 7.55,7 7,7A2,2 0 0,0 5,9C5,9.55 5.22,10.05 5.59,10.41L7.05,11.88L9.88,9.05L8.41,7.59Z";
var mdiGoogleGlass = "M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M16.75 18H15.25V8.9L6.72 18H4.66L15.45 6.5C15.66 6.26 16 6.19 16.27 6.3C16.56 6.42 16.75 6.69 16.75 7V18Z";
var mdiGoogleHangouts = "M15,11L14,13H12.5L13.5,11H12V8H15M11,11L10,13H8.5L9.5,11H8V8H11M11.5,2A8.5,8.5 0 0,0 3,10.5A8.5,8.5 0 0,0 11.5,19H12V22.5C16.86,20.15 20,15 20,10.5C20,5.8 16.19,2 11.5,2Z";
var mdiGoogleKeep = "M4 2H20C21.11 2 22 2.9 22 4V17.33L17.33 22H4C2.9 22 2 21.11 2 20V4C2 2.9 2.9 2 4 2M17 17V20.25L20.25 17H17M10 19H14V18H15V13C16.21 12.09 17 10.64 17 9C17 6.24 14.76 4 12 4S7 6.24 7 9C7 10.64 7.79 12.09 9 13V18H10V19M14 17H10V15H14V17M12 5C14.21 5 16 6.79 16 9C16 10.5 15.2 11.77 14 12.46V14H10V12.46C8.8 11.77 8 10.5 8 9C8 6.79 9.79 5 12 5Z";
var mdiGoogleLens = "M6,2H18A4,4 0 0,1 22,6V12H20V6A2,2 0 0,0 18,4H6A2,2 0 0,0 4,6V18A2,2 0 0,0 6,20H12V22H6A4,4 0 0,1 2,18V6A4,4 0 0,1 6,2M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M18,16A2,2 0 0,1 20,18A2,2 0 0,1 18,20A2,2 0 0,1 16,18A2,2 0 0,1 18,16Z";
var mdiGoogleMaps = "M18.27 6C19.28 8.17 19.05 10.73 17.94 12.81C17 14.5 15.65 15.93 14.5 17.5C14 18.2 13.5 18.95 13.13 19.76C13 20.03 12.91 20.31 12.81 20.59C12.71 20.87 12.62 21.15 12.53 21.43C12.44 21.69 12.33 22 12 22H12C11.61 22 11.5 21.56 11.42 21.26C11.18 20.53 10.94 19.83 10.57 19.16C10.15 18.37 9.62 17.64 9.08 16.93L18.27 6M9.12 8.42L5.82 12.34C6.43 13.63 7.34 14.73 8.21 15.83C8.42 16.08 8.63 16.34 8.83 16.61L13 11.67L12.96 11.68C11.5 12.18 9.88 11.44 9.3 10C9.22 9.83 9.16 9.63 9.12 9.43C9.07 9.06 9.06 8.79 9.12 8.43L9.12 8.42M6.58 4.62L6.57 4.63C4.95 6.68 4.67 9.53 5.64 11.94L9.63 7.2L9.58 7.15L6.58 4.62M14.22 2.36L11 6.17L11.04 6.16C12.38 5.7 13.88 6.28 14.56 7.5C14.71 7.78 14.83 8.08 14.87 8.38C14.93 8.76 14.95 9.03 14.88 9.4L14.88 9.41L18.08 5.61C17.24 4.09 15.87 2.93 14.23 2.37L14.22 2.36M9.89 6.89L13.8 2.24L13.76 2.23C13.18 2.08 12.59 2 12 2C10.03 2 8.17 2.85 6.85 4.31L6.83 4.32L9.89 6.89Z";
var mdiGoogleMyBusiness = "M22 8.5C22 9.87 20.88 11 19.5 11S17 9.87 17 8.5C17 9.87 15.88 11 14.5 11C13.12 11 12 9.87 12 8.5C12 9.87 10.88 11 9.5 11S7 9.87 7 8.5C7 9.87 5.88 11 4.5 11S2 9.87 2 8.5L3.39 3.08C3.39 3.08 3.68 2 4.7 2H19.3C20.32 2 20.61 3.08 20.61 3.08L22 8.5M21 12.2V20C21 21.1 20.1 22 19 22H5C3.9 22 3 21.1 3 20V12.2C3.46 12.39 3.97 12.5 4.5 12.5C5.45 12.5 6.32 12.17 7 11.62C7.69 12.17 8.56 12.5 9.5 12.5C10.45 12.5 11.32 12.17 12 11.62C12.69 12.17 13.56 12.5 14.5 12.5C15.45 12.5 16.32 12.17 17 11.62C17.68 12.17 18.56 12.5 19.5 12.5C20.03 12.5 20.54 12.39 21 12.2M19 17.33C19 17.13 19 16.92 18.95 16.7L18.92 16.54H15.95V17.71H17.76C17.7 17.93 17.62 18.15 17.45 18.33C17.12 18.66 16.67 18.84 16.19 18.84C15.69 18.84 15.2 18.63 14.84 18.28C14.15 17.57 14.15 16.42 14.86 15.7C15.55 15 16.69 15 17.41 15.67L17.55 15.8L18.39 14.95L18.23 14.81C17.67 14.29 16.93 14 16.15 14H16.14C15.33 14 14.57 14.31 14 14.87C13.41 15.45 13.08 16.21 13.08 17C13.08 17.8 13.39 18.54 13.96 19.09H13.96C14.54 19.66 15.35 20 16.18 20H16.2C17 20 17.71 19.71 18.23 19.2C18.7 18.72 19 18 19 17.33Z";
var mdiGoogleNearby = "M21.36,10.46L13.54,2.64C12.69,1.79 11.31,1.79 10.46,2.64L2.64,10.46C1.79,11.31 1.79,12.69 2.64,13.54L10.46,21.36C11.31,22.21 12.69,22.21 13.54,21.36L21.36,13.54C22.21,12.69 22.21,11.31 21.36,10.46M12,19L5,12L12,5L19,12L12,19M16.5,12L12,16.5L7.5,12L12,7.5L16.5,12Z";
var mdiGooglePlay = "M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z";
var mdiGooglePlus = "M23,11H21V9H19V11H17V13H19V15H21V13H23M8,11V13.4H12C11.8,14.4 10.8,16.4 8,16.4C5.6,16.4 3.7,14.4 3.7,12C3.7,9.6 5.6,7.6 8,7.6C9.4,7.6 10.3,8.2 10.8,8.7L12.7,6.9C11.5,5.7 9.9,5 8,5C4.1,5 1,8.1 1,12C1,15.9 4.1,19 8,19C12,19 14.7,16.2 14.7,12.2C14.7,11.7 14.7,11.4 14.6,11H8Z";
var mdiGooglePodcast = "M17.68,7.22V8.62C17.68,9.3 17.13,9.86 16.43,9.86C15.74,9.86 15.18,9.3 15.18,8.62V7.22A1.25,1.25 0 0,1 16.43,5.97C17.13,5.97 17.68,6.53 17.68,7.22M13.25,8.36V15.63C13.25,16.32 12.69,16.88 12,16.88C11.31,16.88 10.75,16.32 10.75,15.63V8.36C10.75,7.68 11.31,7.11 12,7.11C12.69,7.11 13.25,7.68 13.25,8.36M22,11.3V12.7C22,13.38 21.44,13.94 20.75,13.94C20.06,13.94 19.5,13.38 19.5,12.7V11.3C19.5,10.61 20.06,10.06 20.75,10.06C21.44,10.06 22,10.61 22,11.3M4.5,11.3V12.7C4.5,13.38 3.94,13.94 3.25,13.94C2.55,13.94 2,13.38 2,12.7V11.3C2,10.61 2.55,10.06 3.25,10.06C3.94,10.06 4.5,10.61 4.5,11.3M8.82,15.38V16.77C8.82,17.45 8.26,18 7.57,18C6.88,18 6.32,17.45 6.32,16.77V15.38C6.32,14.68 6.88,14.13 7.57,14.13A1.25,1.25 0 0,1 8.82,15.38M13.25,19.36V20.75A1.25,1.25 0 0,1 12,22A1.25,1.25 0 0,1 10.75,20.75V19.36A1.25,1.25 0 0,1 12,18.11A1.25,1.25 0 0,1 13.25,19.36M13.25,3.25V4.64A1.25,1.25 0 0,1 12,5.89A1.25,1.25 0 0,1 10.75,4.64V3.25C10.75,2.55 11.31,2 12,2A1.25,1.25 0 0,1 13.25,3.25M17.68,12.34V16.77C17.68,17.46 17.13,18 16.43,18C15.74,18 15.18,17.46 15.18,16.77V12.34C15.18,11.64 15.74,11.09 16.43,11.09C17.13,11.09 17.68,11.64 17.68,12.34M8.82,7.22V11.65C8.82,12.35 8.26,12.9 7.57,12.9A1.25,1.25 0 0,1 6.32,11.65V7.22A1.25,1.25 0 0,1 7.57,5.97A1.25,1.25 0 0,1 8.82,7.22Z";
var mdiGoogleSpreadsheet = "M19,11V9H11V5H9V9H5V11H9V19H11V11H19M19,3C19.5,3 20,3.2 20.39,3.61C20.8,4 21,4.5 21,5V19C21,19.5 20.8,20 20.39,20.39C20,20.8 19.5,21 19,21H5C4.5,21 4,20.8 3.61,20.39C3.2,20 3,19.5 3,19V5C3,4.5 3.2,4 3.61,3.61C4,3.2 4.5,3 5,3H19Z";
var mdiGoogleStreetView = "M11.95,9.27C13.96,9.27 15.59,7.64 15.59,5.63C15.59,3.63 13.96,2 11.95,2C9.94,2 8.32,3.63 8.32,5.63C8.32,7.64 9.94,9.27 11.95,9.27M9.36,12.97C9.36,12.97 8.27,15.94 7.96,16.5C7.85,16.71 7.87,16.77 7.6,16.77C7.33,16.77 6.91,16.5 6.91,16.5C6.91,16.5 6.71,16.37 6.79,16.14C7.03,15.4 8.12,11.08 8.35,10.25C8.6,9.36 9.28,9.39 9.28,9.39H9.93L12.03,13.04L14.14,9.39H14.92C14.92,9.39 15.23,9.43 15.46,9.7C15.7,9.97 15.75,10.44 15.75,10.44L17.14,15.84C17.14,15.84 17.24,16.22 17.21,16.33C17.17,16.5 17.08,16.5 17.08,16.5C17.08,16.5 16.69,16.62 16.47,16.69C16.07,16.82 16,16.44 16,16.44L14.7,13.04L14.55,22H12.6L12.27,16.89C12.27,16.89 12.21,16.76 12.03,16.76C11.86,16.76 11.8,16.89 11.8,16.89L11.45,22H9.5L9.37,12.97H9.36Z";
var mdiGoogleTranslate = "M20,5H10.88L10,2H4A2,2 0 0,0 2,4V17A2,2 0 0,0 4,19H11L12,22H20A2,2 0 0,0 22,20V7A2,2 0 0,0 20,5M7.17,14.59A4.09,4.09 0 0,1 3.08,10.5A4.09,4.09 0 0,1 7.17,6.41C8.21,6.41 9.16,6.78 9.91,7.5L10,7.54L8.75,8.72L8.69,8.67C8.4,8.4 7.91,8.08 7.17,8.08C5.86,8.08 4.79,9.17 4.79,10.5C4.79,11.83 5.86,12.92 7.17,12.92C8.54,12.92 9.13,12.05 9.29,11.46H7.08V9.91H11.03L11.04,10C11.08,10.19 11.09,10.38 11.09,10.59C11.09,12.94 9.5,14.59 7.17,14.59M13.2,12.88C13.53,13.5 13.94,14.06 14.39,14.58L13.85,15.11L13.2,12.88M13.97,12.12H13L12.67,11.08H16.66C16.66,11.08 16.32,12.39 15.1,13.82C14.58,13.2 14.21,12.59 13.97,12.12M21,20A1,1 0 0,1 20,21H13L15,19L14.19,16.23L15.11,15.31L17.79,18L18.5,17.27L15.81,14.59C16.71,13.56 17.41,12.34 17.73,11.08H19V10.04H15.36V9H14.32V10.04H12.36L11.18,6H20A1,1 0 0,1 21,7V20Z";
var mdiGradientHorizontal = "M9 13V11H11V13M11 15V13H13V15M11 11V9H13V11M9 9V7H11V9M9 17V15H11V17M3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5M18 15V17H16V15M18 11V13H16V11M18 7V9H16V7M11 5V7H13V5H15V7H13V9H15V11H13V13H15V15H13V17H15V19H13V17H11V19H5V5Z";
var mdiGradientVertical = "M11,9H13V11H11V9M9,11H11V13H9V11M13,11H15V13H13V11M15,9H17V11H15V9M7,9H9V11H7V9M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M9,18H7V16H9V18M13,18H11V16H13V18M17,18H15V16H17V18M19,11H17V13H19V15H17V13H15V15H13V13H11V15H9V13H7V15H5V13H7V11H5V5H19V11Z";
var mdiGrain = "M10,12A2,2 0 0,0 8,14A2,2 0 0,0 10,16A2,2 0 0,0 12,14A2,2 0 0,0 10,12M6,8A2,2 0 0,0 4,10A2,2 0 0,0 6,12A2,2 0 0,0 8,10A2,2 0 0,0 6,8M6,16A2,2 0 0,0 4,18A2,2 0 0,0 6,20A2,2 0 0,0 8,18A2,2 0 0,0 6,16M18,8A2,2 0 0,0 20,6A2,2 0 0,0 18,4A2,2 0 0,0 16,6A2,2 0 0,0 18,8M14,16A2,2 0 0,0 12,18A2,2 0 0,0 14,20A2,2 0 0,0 16,18A2,2 0 0,0 14,16M18,12A2,2 0 0,0 16,14A2,2 0 0,0 18,16A2,2 0 0,0 20,14A2,2 0 0,0 18,12M14,8A2,2 0 0,0 12,10A2,2 0 0,0 14,12A2,2 0 0,0 16,10A2,2 0 0,0 14,8M10,4A2,2 0 0,0 8,6A2,2 0 0,0 10,8A2,2 0 0,0 12,6A2,2 0 0,0 10,4Z";
var mdiGraph = "M19.5 17C19.37 17 19.24 17 19.11 17.04L17.5 13.79C17.95 13.34 18.25 12.71 18.25 12C18.25 10.62 17.13 9.5 15.75 9.5C15.62 9.5 15.5 9.5 15.36 9.54L13.73 6.29C14.21 5.84 14.5 5.21 14.5 4.5C14.5 3.12 13.38 2 12 2S9.5 3.12 9.5 4.5C9.5 5.21 9.79 5.84 10.26 6.29L8.64 9.54C8.5 9.5 8.38 9.5 8.25 9.5C6.87 9.5 5.75 10.62 5.75 12C5.75 12.71 6.05 13.34 6.5 13.79L4.89 17.04C4.76 17 4.63 17 4.5 17C3.12 17 2 18.12 2 19.5C2 20.88 3.12 22 4.5 22S7 20.88 7 19.5C7 18.8 6.71 18.16 6.24 17.71L7.86 14.46C8 14.5 8.12 14.5 8.25 14.5C8.38 14.5 8.5 14.5 8.64 14.46L10.27 17.71C9.8 18.16 9.5 18.8 9.5 19.5C9.5 20.88 10.62 22 12 22S14.5 20.88 14.5 19.5C14.5 18.12 13.38 17 12 17C11.87 17 11.74 17 11.61 17.04L10 13.79C10.46 13.34 10.75 12.71 10.75 12S10.46 10.66 10 10.21L11.61 6.96C11.74 7 11.87 7 12 7S12.26 7 12.39 6.96L14 10.21C13.55 10.66 13.25 11.3 13.25 12C13.25 13.38 14.37 14.5 15.75 14.5C15.88 14.5 16 14.5 16.14 14.46L17.77 17.71C17.3 18.16 17 18.8 17 19.5C17 20.88 18.12 22 19.5 22S22 20.88 22 19.5C22 18.12 20.88 17 19.5 17Z";
var mdiGraphOutline = "M19.5 17C19.36 17 19.24 17 19.11 17.04L17.5 13.8C17.95 13.35 18.25 12.71 18.25 12C18.25 10.62 17.13 9.5 15.75 9.5C15.61 9.5 15.5 9.5 15.35 9.54L13.74 6.3C14.21 5.84 14.5 5.21 14.5 4.5C14.5 3.12 13.38 2 12 2S9.5 3.12 9.5 4.5C9.5 5.2 9.79 5.84 10.26 6.29L8.65 9.54C8.5 9.5 8.39 9.5 8.25 9.5C6.87 9.5 5.75 10.62 5.75 12C5.75 12.71 6.04 13.34 6.5 13.79L4.89 17.04C4.76 17 4.64 17 4.5 17C3.12 17 2 18.12 2 19.5C2 20.88 3.12 22 4.5 22S7 20.88 7 19.5C7 18.8 6.71 18.16 6.24 17.71L7.86 14.46C8 14.5 8.12 14.5 8.25 14.5C8.38 14.5 8.5 14.5 8.63 14.46L10.26 17.71C9.79 18.16 9.5 18.8 9.5 19.5C9.5 20.88 10.62 22 12 22S14.5 20.88 14.5 19.5C14.5 18.12 13.38 17 12 17C11.87 17 11.74 17 11.61 17.04L10 13.8C10.45 13.35 10.75 12.71 10.75 12C10.75 11.3 10.46 10.67 10 10.21L11.61 6.96C11.74 7 11.87 7 12 7C12.13 7 12.26 7 12.39 6.96L14 10.21C13.54 10.66 13.25 11.3 13.25 12C13.25 13.38 14.37 14.5 15.75 14.5C15.88 14.5 16 14.5 16.13 14.46L17.76 17.71C17.29 18.16 17 18.8 17 19.5C17 20.88 18.12 22 19.5 22S22 20.88 22 19.5C22 18.12 20.88 17 19.5 17M4.5 20.5C3.95 20.5 3.5 20.05 3.5 19.5S3.95 18.5 4.5 18.5 5.5 18.95 5.5 19.5 5.05 20.5 4.5 20.5M13 19.5C13 20.05 12.55 20.5 12 20.5S11 20.05 11 19.5 11.45 18.5 12 18.5 13 18.95 13 19.5M7.25 12C7.25 11.45 7.7 11 8.25 11S9.25 11.45 9.25 12 8.8 13 8.25 13 7.25 12.55 7.25 12M11 4.5C11 3.95 11.45 3.5 12 3.5S13 3.95 13 4.5 12.55 5.5 12 5.5 11 5.05 11 4.5M14.75 12C14.75 11.45 15.2 11 15.75 11S16.75 11.45 16.75 12 16.3 13 15.75 13 14.75 12.55 14.75 12M19.5 20.5C18.95 20.5 18.5 20.05 18.5 19.5S18.95 18.5 19.5 18.5 20.5 18.95 20.5 19.5 20.05 20.5 19.5 20.5Z";
var mdiGraphql = "M12,5.37L11.56,5.31L6,14.9C6.24,15.11 6.4,15.38 6.47,15.68H17.53C17.6,15.38 17.76,15.11 18,14.9L12.44,5.31L12,5.37M6.6,16.53L10.88,19.06C11.17,18.79 11.57,18.63 12,18.63C12.43,18.63 12.83,18.79 13.12,19.06L17.4,16.53H6.6M12,22A1.68,1.68 0 0,1 10.32,20.32L10.41,19.76L6.11,17.21C5.8,17.57 5.35,17.79 4.84,17.79A1.68,1.68 0 0,1 3.16,16.11C3.16,15.32 3.69,14.66 4.42,14.47V9.36C3.59,9.25 2.95,8.54 2.95,7.68A1.68,1.68 0 0,1 4.63,6C5.18,6 5.66,6.26 5.97,6.66L10.38,4.13L10.32,3.68C10.32,2.75 11.07,2 12,2C12.93,2 13.68,2.75 13.68,3.68L13.62,4.13L18.03,6.66C18.34,6.26 18.82,6 19.37,6A1.68,1.68 0 0,1 21.05,7.68C21.05,8.54 20.41,9.25 19.58,9.36V14.47C20.31,14.66 20.84,15.32 20.84,16.11A1.68,1.68 0 0,1 19.16,17.79C18.65,17.79 18.2,17.57 17.89,17.21L13.59,19.76L13.68,20.32A1.68,1.68 0 0,1 12,22M10.8,4.86L6.3,7.44L6.32,7.68C6.32,8.39 5.88,9 5.26,9.25L5.29,14.5L10.8,4.86M13.2,4.86L18.71,14.5L18.74,9.25C18.12,9 17.68,8.39 17.68,7.68L17.7,7.44L13.2,4.86Z";
var mdiGrass = "M12 20H2V18H7.75C7 15.19 4.81 13 2 12.26C2.64 12.1 3.31 12 4 12C8.42 12 12 15.58 12 20M22 12.26C21.36 12.1 20.69 12 20 12C17.07 12 14.5 13.58 13.12 15.93C13.41 16.59 13.65 17.28 13.79 18C13.92 18.65 14 19.32 14 20H22V18H16.24C17 15.19 19.19 13 22 12.26M15.64 11C16.42 8.93 17.87 7.18 19.73 6C15.44 6.16 12 9.67 12 14V14C12.95 12.75 14.2 11.72 15.64 11M11.42 8.85C10.58 6.66 8.88 4.89 6.7 4C8.14 5.86 9 8.18 9 10.71C9 10.92 8.97 11.12 8.96 11.32C9.39 11.56 9.79 11.84 10.18 12.14C10.39 10.96 10.83 9.85 11.42 8.85Z";
var mdiGraveStone = "M10,2H14C17.31,2 19,4.69 19,8V18.66C16.88,17.63 15.07,17 12,17C8.93,17 7.12,17.63 5,18.66V8C5,4.69 6.69,2 10,2M8,8V9.5H16V8H8M9,12V13.5H15V12H9M3,22V21.31C5.66,19.62 13.23,15.84 21,21.25V22H3Z";
var mdiGreasePencil = "M18.62,1.5C18.11,1.5 17.6,1.69 17.21,2.09L10.75,8.55L14.95,12.74L21.41,6.29C22.2,5.5 22.2,4.24 21.41,3.46L20.04,2.09C19.65,1.69 19.14,1.5 18.62,1.5M9.8,9.5L3.23,16.07L3.93,16.77C3.4,17.24 2.89,17.78 2.38,18.29C1.6,19.08 1.6,20.34 2.38,21.12C3.16,21.9 4.42,21.9 5.21,21.12C5.72,20.63 6.25,20.08 6.73,19.58L7.43,20.27L14,13.7";
var mdiGreaterThan = "M5.5,4.14L4.5,5.86L15,12L4.5,18.14L5.5,19.86L19,12L5.5,4.14Z";
var mdiGreaterThanOrEqual = "M6.5,2.27L20,10.14L6.5,18L5.5,16.27L16.03,10.14L5.5,4L6.5,2.27M20,20V22H5V20H20Z";
var mdiGreenhouse = "M12 3L4 9V21H20V9L12 3M10 10H14V19H10V10M16 10H18V13H16V10M15.33 8H8.67L12 5.5L15.33 8M8 10V13H6V10H8M6 15H8V19H6V15M16 19V15H18V19H16Z";
var mdiGrid = "M10,4V8H14V4H10M16,4V8H20V4H16M16,10V14H20V10H16M16,16V20H20V16H16M14,20V16H10V20H14M8,20V16H4V20H8M8,14V10H4V14H8M8,8V4H4V8H8M10,14H14V10H10V14M4,2H20A2,2 0 0,1 22,4V20A2,2 0 0,1 20,22H4C2.92,22 2,21.1 2,20V4A2,2 0 0,1 4,2Z";
var mdiGridLarge = "M4,2H20A2,2 0 0,1 22,4V20A2,2 0 0,1 20,22H4C2.92,22 2,21.1 2,20V4A2,2 0 0,1 4,2M4,4V11H11V4H4M4,20H11V13H4V20M20,20V13H13V20H20M20,4H13V11H20V4Z";
var mdiGridOff = "M0,2.77L1.28,1.5L22.5,22.72L21.23,24L19.23,22H4C2.92,22 2,21.1 2,20V4.77L0,2.77M10,4V7.68L8,5.68V4H6.32L4.32,2H20A2,2 0 0,1 22,4V19.7L20,17.7V16H18.32L16.32,14H20V10H16V13.68L14,11.68V10H12.32L10.32,8H14V4H10M16,4V8H20V4H16M16,20H17.23L16,18.77V20M4,8H5.23L4,6.77V8M10,14H11.23L10,12.77V14M14,20V16.77L13.23,16H10V20H14M8,20V16H4V20H8M8,14V10.77L7.23,10H4V14H8Z";
var mdiGrill = "M8.06,2C7.88,3.17 8.17,4.16 8.95,4.97C9.45,5.47 9.61,6.14 9.42,7H10.41C10.53,6.45 10.55,6 10.45,5.55C10.36,5.13 10.05,4.63 9.5,4.03C9.05,3.47 8.89,2.8 9.05,2H8.06M10.55,2C10.36,3.17 10.66,4.16 11.44,4.97C11.94,5.47 12.09,6.14 11.91,7H12.89C13,6.45 13.03,6 12.94,5.55C12.84,5.13 12.53,4.63 12,4.03C11.53,3.47 11.38,2.8 11.53,2H10.55M13.08,2C12.89,3.17 13.19,4.16 13.97,4.97C14.47,5.47 14.61,6.14 14.39,7H15.42C15.55,6.45 15.56,6 15.47,5.55C15.38,5.13 15.06,4.63 14.53,4.03C14.06,3.47 13.91,2.8 14.06,2H13.08M5,8C5,9.42 5.39,10.7 6.14,11.84C6.87,12.96 7.91,13.85 9.14,14.39L5.16,20.44C5.06,20.56 5,20.75 5,21C5,21.41 5.16,21.69 5.44,21.84C5.56,21.94 5.75,22 6,22C6.41,22 6.69,21.84 6.84,21.56L7.83,19.97H14.2C14.41,20.55 14.79,21.05 15.28,21.42C15.78,21.8 16.36,22 17,22C17.83,22 18.53,21.69 19.13,21.09C19.72,20.5 20,19.8 20,19C20,18.17 19.72,17.47 19.13,16.88C18.53,16.28 17.83,16 17,16C16.36,16 15.78,16.17 15.28,16.55C14.78,16.92 14.42,17.41 14.2,18H9.14L11.11,14.95C11.27,15 11.56,15 12,15C12.44,15 12.73,15 12.89,14.95L13.88,16.5C14.29,15.96 14.84,15.54 15.47,15.28L14.91,14.39C16.03,13.89 17,13 17.79,11.77C18.59,10.5 19,9.27 19,8H5M17,18C17.3,18 17.53,18.09 17.72,18.28C17.91,18.47 18,18.72 18,19C18,19.27 17.91,19.5 17.72,19.71C17.54,19.91 17.28,20 17,20C16.74,20 16.5,19.91 16.29,19.71C16.09,19.5 16,19.26 16,19C16,18.7 16.09,18.47 16.29,18.28C16.5,18.09 16.73,18 17,18Z";
var mdiGrillOutline = "M17 22A3 3 0 1 0 14.18 18H9.14L11.13 14.94A6.36 6.36 0 0 0 12.87 14.94L13.89 16.5C14.31 16 14.85 15.56 15.5 15.3L14.89 14.37A7 7 0 0 0 19 8H5A7 7 0 0 0 9.12 14.37L5.17 20.45A1 1 0 0 0 6.84 21.54L7.84 20H14.18A3 3 0 0 0 17 22M17 18A1 1 0 0 1 18 19C18 19.55 17.55 20 17 20S16 19.55 16 19A1 1 0 0 1 17 18M7.42 10H16.58A5 5 0 0 1 7.42 10M9.41 7H10.41C10.56 5.85 10.64 5.36 9.5 4.04C9.1 3.54 8.84 3.27 9.06 2H8.07A3.14 3.14 0 0 0 8.96 4.96C9.18 5.2 9.75 5.63 9.41 7M11.89 7H12.89C13.04 5.85 13.12 5.36 12 4.04C11.58 3.54 11.32 3.26 11.54 2H10.55A3.14 3.14 0 0 0 11.44 4.96C11.67 5.2 12.24 5.63 11.89 7M14.41 7H15.41C15.56 5.85 15.64 5.36 14.5 4.04C14.1 3.54 13.84 3.27 14.06 2H13.07A3.14 3.14 0 0 0 13.96 4.96C14.18 5.2 14.75 5.63 14.41 7Z";
var mdiGroup = "M1,1V5H2V19H1V23H5V22H19V23H23V19H22V5H23V1H19V2H5V1M5,4H19V5H20V19H19V20H5V19H4V5H5M6,6V14H9V18H18V9H14V6M8,8H12V12H8M14,11H16V16H11V14H14";
var mdiGuitarAcoustic = "M19.59,3H22V5H20.41L16.17,9.24C15.8,8.68 15.32,8.2 14.76,7.83L19.59,3M12,8A4,4 0 0,1 16,12C16,13.82 14.77,15.42 13,15.87V16A5,5 0 0,1 8,21A5,5 0 0,1 3,16A5,5 0 0,1 8,11H8.13C8.58,9.24 10.17,8 12,8M12,10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5M6.94,14.24L6.23,14.94L9.06,17.77L9.77,17.06L6.94,14.24Z";
var mdiGuitarElectric = "M19.59,3H22V5H20.41L15.12,10.29L13.71,8.9L19.59,3M12,9C12.26,9 12.5,9.1 12.71,9.3L14.71,11.3C14.89,11.5 15,11.73 15,12L14.9,12.4L10.9,20.4C10.71,20.75 10.36,20.93 10,20.93C9.65,20.93 9.29,20.75 9.11,20.4L7.25,16.7L3.55,14.9C3.18,14.7 3,14.35 3,14C3,13.65 3.18,13.3 3.55,13.1L11.55,9.1C11.69,9 11.84,9 12,9M9.35,11.82L8.65,12.5L11.5,15.35L12.18,14.65L9.35,11.82M7.94,13.23L7.23,13.94L10.06,16.77L10.77,16.06L7.94,13.23Z";
var mdiGuitarPick = "M19,4.1C18.1,3.3 17,2.8 15.8,2.5C15.5,2.4 13.6,2 12.2,2C12.2,2 12.1,2 12,2C12,2 11.9,2 11.8,2C10.4,2 8.4,2.4 8.1,2.5C7,2.8 5.9,3.3 5,4.1C3,5.9 3,8.7 4,11C5,13.5 6.1,15.7 7.6,17.9C8.8,19.6 10.1,22 12,22C13.9,22 15.2,19.6 16.5,17.9C18,15.8 19.1,13.5 20.1,11C21,8.7 21,5.9 19,4.1Z";
var mdiGuitarPickOutline = "M19,4.1C18.1,3.3 17,2.8 15.8,2.5C15.5,2.4 13.6,2 12.2,2C12.2,2 12.1,2 12,2C12,2 11.9,2 11.8,2C10.4,2 8.4,2.4 8.1,2.5C7,2.8 5.9,3.3 5,4.1C3,5.9 3,8.7 4,11C5,13.5 6.1,15.7 7.6,17.9C8.8,19.6 10.1,22 12,22C13.9,22 15.2,19.6 16.5,17.9C18,15.8 19.1,13.5 20.1,11C21,8.7 21,5.9 19,4.1M18.2,10.2C17.1,12.9 16.1,14.9 14.8,16.7C14.6,16.9 14.5,17.2 14.3,17.4C13.8,18.2 12.6,20 12,20C12,20 12,20 12,20C11.3,20 10.2,18.3 9.6,17.4C9.4,17.2 9.3,16.9 9.1,16.7C7.9,14.9 6.8,12.9 5.7,10.2C5.5,9.5 4.7,7 6.3,5.5C6.8,5 7.6,4.7 8.6,4.4C9,4.4 10.7,4 11.8,4C11.8,4 12.1,4 12.1,4C13.2,4 14.9,4.3 15.3,4.4C16.3,4.7 17.1,5 17.6,5.5C19.3,7 18.5,9.5 18.2,10.2Z";
var mdiGuyFawkesMask = "M21,13A9,9 0 0,1 12,22A9,9 0 0,1 3,13L3.03,4.43C5.68,2.88 8.76,2 12.05,2C15.3,2 18.36,2.87 21,4.38V13M13,19.93C16.39,19.44 19,16.5 19,13V5.59C16.9,4.57 14.54,4 12.05,4C9.5,4 7.08,4.6 4.94,5.66L5,13C5,16.5 7.63,19.44 11,19.93V18H13V19.93M11,16H8L6,13L9,14H10L11,13H13L14,14H15L18,13L16,16H13L12,15L11,16M6,9.03C6.64,8.4 7.5,8.05 8.5,8.05C9.45,8.05 10.34,8.4 11,9.03C10.34,9.65 9.45,10 8.5,10C7.5,10 6.64,9.65 6,9.03M13,9.03C13.64,8.4 14.5,8.05 15.5,8.05C16.45,8.05 17.34,8.4 18,9.03C17.34,9.65 16.45,10 15.5,10C14.5,10 13.64,9.65 13,9.03Z";
var mdiGymnastics = "M4 6C4 4.9 4.9 4 6 4S8 4.9 8 6 7.1 8 6 8 4 7.1 4 6M1 9H7L14 4L15.31 5.5L11.14 8.5H14L21.8 4L23 5.4L14.5 12L14 22H12L11.5 12L8 11H1V9Z";
var mdiHail = "M4,16H7V22H4V16M19,2.39C18.92,3.86 18.55,5.13 17.86,6.21C17.17,7.29 16.22,8 15,8.39V22H13V16H11V22H9V10.08C8.72,10.17 8.5,10.28 8.39,10.41C7.45,11.16 7,12.19 7,13.5V14H5V13.5C5,11.53 5.72,9.94 7.13,8.72C8.53,7.56 10.16,7 12,7C13.41,7 14.56,6.64 15.47,5.95C16.5,5.11 17,3.95 17,2.5V2H19V2.39M12,2A2,2 0 0,1 14,4A2,2 0 0,1 12,6A2,2 0 0,1 10,4A2,2 0 0,1 12,2Z";
var mdiHairDryer = "M22 9A4.32 4.32 0 0 1 19.78 8.45A3.4 3.4 0 0 0 18 8V7A4.32 4.32 0 0 1 20.22 7.55A3.4 3.4 0 0 0 22 8M22 6A3.4 3.4 0 0 1 20.22 5.55A4.32 4.32 0 0 0 18 5V6A3.4 3.4 0 0 1 19.78 6.45A4.32 4.32 0 0 0 22 7M22 10A3.4 3.4 0 0 1 20.22 9.55A4.32 4.32 0 0 0 18 9V10A3.4 3.4 0 0 1 19.78 10.45A4.32 4.32 0 0 0 22 11M10 12.73A70.39 70.39 0 0 0 17 11V4S10.5 2 7.5 2A5.5 5.5 0 0 0 6.12 12.82L7 19H8A3 3 0 0 0 9.46 21.33A3.15 3.15 0 0 1 11 24H12A4.12 4.12 0 0 0 10.09 20.55C9.39 20 9 19.63 9 19H10M7.5 10A2.5 2.5 0 1 1 10 7.5A2.5 2.5 0 0 1 7.5 10Z";
var mdiHairDryerOutline = "M10 12.73A70.39 70.39 0 0 0 17 11V4S10.5 2 7.5 2A5.5 5.5 0 0 0 6.12 12.82L7 19H8A3 3 0 0 0 9.46 21.33A3.15 3.15 0 0 1 11 24H12A4.12 4.12 0 0 0 10.09 20.55C9.39 20 9 19.63 9 19H10M4 7.5A3.5 3.5 0 0 1 7.5 4A37.08 37.08 0 0 1 15 5.5V9.5A37.08 37.08 0 0 1 7.5 11A3.5 3.5 0 0 1 4 7.5M22 9A4.32 4.32 0 0 1 19.78 8.45A3.4 3.4 0 0 0 18 8V7A4.32 4.32 0 0 1 20.22 7.55A3.4 3.4 0 0 0 22 8M22 6A3.4 3.4 0 0 1 20.22 5.55A4.32 4.32 0 0 0 18 5V6A3.4 3.4 0 0 1 19.78 6.45A4.32 4.32 0 0 0 22 7M22 10A3.4 3.4 0 0 1 20.22 9.55A4.32 4.32 0 0 0 18 9V10A3.4 3.4 0 0 1 19.78 10.45A4.32 4.32 0 0 0 22 11M9 7.5A1.5 1.5 0 1 1 7.5 6A1.5 1.5 0 0 1 9 7.5Z";
var mdiHalloween = "M6.5,6C7.47,6 8.37,6.5 9.11,7.38C9.66,6.79 10.31,6.36 11,6.15V4A2,2 0 0,1 13,2H15V4H13V6.15C13.69,6.36 14.34,6.79 14.89,7.38C15.63,6.5 16.53,6 17.5,6C20,6 22,9.36 22,13.5C22,17.64 20,21 17.5,21C16.53,21 15.63,20.5 14.89,19.62C14.08,20.5 13.08,21 12,21C10.92,21 9.92,20.5 9.11,19.62C8.37,20.5 7.47,21 6.5,21C4,21 2,17.64 2,13.5C2,9.36 4,6 6.5,6M9,10L7.75,12.25H10.25L9,10M15,10L13.75,12.25H16.25L15,10M8,17H10L11,16L12,17H14L15,16L16,17L17.5,14L13.92,14.62L13,16L12,15H10L9,16L8,15L6,14L8,17Z";
var mdiHamburger = "M22 13C22 14.11 21.11 15 20 15H4C2.9 15 2 14.11 2 13S2.9 11 4 11H13L15.5 13L18 11H20C21.11 11 22 11.9 22 13M12 3C3 3 3 9 3 9H21C21 9 21 3 12 3M3 18C3 19.66 4.34 21 6 21H18C19.66 21 21 19.66 21 18V17H3V18Z";
var mdiHamburgerCheck = "M21 9H3C3 9 3 3 12 3S21 9 21 9M13.35 17H3V18C3 19.66 4.34 21 6 21H13.35C13.13 20.37 13 19.7 13 19C13 18.3 13.13 17.63 13.35 17M21.86 13.73C21.95 13.5 22 13.26 22 13C22 11.9 21.11 11 20 11H11L8.5 13L6 11H4C2.9 11 2 11.9 2 13S2.9 15 4 15H14.54C15.64 13.78 17.23 13 19 13C20.04 13 21 13.26 21.86 13.73M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiHamburgerMinus = "M21 9H3C3 9 3 3 12 3S21 9 21 9M13.35 17H3V18C3 19.66 4.34 21 6 21H13.35C13.13 20.37 13 19.7 13 19C13 18.3 13.13 17.63 13.35 17M21.86 13.73C21.95 13.5 22 13.26 22 13C22 11.9 21.11 11 20 11H11L8.5 13L6 11H4C2.9 11 2 11.9 2 13S2.9 15 4 15H14.54C15.64 13.78 17.23 13 19 13C20.04 13 21 13.26 21.86 13.73M15 18V20H23V18H15Z";
var mdiHamburgerOff = "M20 11C21.11 11 22 11.9 22 13S21.11 15 20 15H18.2L14.2 11H20M20.42 19.77L20.42 19.76L17.66 17H17.65L15.65 15H15.66L11.66 11H11.66L9.66 9H9.66L2.39 1.73L1.11 3L4.12 6C3 7.5 3 9 3 9H7.11L9.11 11H4C2.9 11 2 11.9 2 13S2.9 15 4 15H13.11L15.11 17H3V18C3 19.66 4.34 21 6 21H18C18.33 21 18.65 20.93 18.94 20.83L20.84 22.73L22.11 21.46L20.42 19.77M21 9C21 9 21 3 12 3C9.88 3 8.28 3.34 7.05 3.85L12.2 9H21Z";
var mdiHamburgerPlus = "M21 9H3C3 9 3 3 12 3S21 9 21 9M13.35 17H3V18C3 19.66 4.34 21 6 21H13.35C13.13 20.37 13 19.7 13 19C13 18.3 13.13 17.63 13.35 17M21.86 13.73C21.95 13.5 22 13.26 22 13C22 11.9 21.11 11 20 11H11L8.5 13L6 11H4C2.9 11 2 11.9 2 13S2.9 15 4 15H14.54C15.64 13.78 17.23 13 19 13C20.04 13 21 13.26 21.86 13.73M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiHamburgerRemove = "M21 9H3C3 9 3 3 12 3S21 9 21 9M13.35 17H3V18C3 19.66 4.34 21 6 21H13.35C13.13 20.37 13 19.7 13 19C13 18.3 13.13 17.63 13.35 17M21.86 13.73C21.95 13.5 22 13.26 22 13C22 11.9 21.11 11 20 11H11L8.5 13L6 11H4C2.9 11 2 11.9 2 13S2.9 15 4 15H14.54C15.64 13.78 17.23 13 19 13C20.04 13 21 13.26 21.86 13.73M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiHammer = "M2 19.63L13.43 8.2L12.72 7.5L14.14 6.07L12 3.89C13.2 2.7 15.09 2.7 16.27 3.89L19.87 7.5L18.45 8.91H21.29L22 9.62L18.45 13.21L17.74 12.5V9.62L16.27 11.04L15.56 10.33L4.13 21.76L2 19.63Z";
var mdiHammerScrewdriver = "M16.06 13.09L21.69 18.68L18.37 21.96L12.78 16.37V15.45L15.14 13.09H16.06M16.97 10.56L16 9.6L11.21 14.4V16.37L5.58 22L2.3 18.68L7.89 13.09H9.86L10.64 12.31L6.8 8.46H5.5L2.69 5.62L5.31 3L8.11 5.8V7.11L12 10.95L14.66 8.29L13.7 7.28L15 5.97H12.34L11.69 5.32L15 2L15.66 2.66V5.32L16.97 4L20.25 7.28C21.34 8.38 21.34 10.17 20.25 11.26L18.28 9.25L16.97 10.56Z";
var mdiHammerSickle = "M22 20.59L20.59 22L17.45 18.86C16.89 19.23 16.3 19.56 15.66 19.78C14 20.36 12.2 20.4 10.53 19.88C9.5 19.58 8.56 19.05 7.75 18.37L4.56 21.56C4 22.15 3.03 22.15 2.44 21.56C1.86 21 1.86 20 2.44 19.44L5.82 16.06L8.47 15.54C9.19 16.45 10.19 17.13 11.28 17.5C12.44 17.85 13.72 17.84 14.87 17.46C15.16 17.37 15.44 17.26 15.7 17.12L7.6 9L5.83 10.78L3 7.95L7.95 3L12.19 4.41L9 7.6L17.31 15.89C17.5 15.71 17.65 15.53 17.8 15.33C19.3 13.36 19.42 10.42 18.09 8C16.78 5.57 14.5 3.55 12 2C13.41 2.5 14.76 3.17 16 4.04C17.24 4.91 18.43 5.93 19.33 7.25C20.23 8.54 20.87 10.12 21 11.79C21.1 13.47 20.66 15.23 19.7 16.65C19.5 17 19.24 17.28 19 17.56L22 20.59Z";
var mdiHammerWrench = "M13.78 15.3L19.78 21.3L21.89 19.14L15.89 13.14L13.78 15.3M17.5 10.1C17.11 10.1 16.69 10.05 16.36 9.91L4.97 21.25L2.86 19.14L10.27 11.74L8.5 9.96L7.78 10.66L6.33 9.25V12.11L5.63 12.81L2.11 9.25L2.81 8.55H5.62L4.22 7.14L7.78 3.58C8.95 2.41 10.83 2.41 12 3.58L9.89 5.74L11.3 7.14L10.59 7.85L12.38 9.63L14.2 7.75C14.06 7.42 14 7 14 6.63C14 4.66 15.56 3.11 17.5 3.11C18.09 3.11 18.61 3.25 19.08 3.53L16.41 6.2L17.91 7.7L20.58 5.03C20.86 5.5 21 6 21 6.63C21 8.55 19.45 10.1 17.5 10.1Z";
var mdiHandBackLeft = "M3 16V5.75C3 5.06 3.56 4.5 4.25 4.5S5.5 5.06 5.5 5.75V12H6.5V2.75C6.5 2.06 7.06 1.5 7.75 1.5C8.44 1.5 9 2.06 9 2.75V12H10V1.25C10 .56 10.56 0 11.25 0S12.5 .56 12.5 1.25V12H13.5V3.25C13.5 2.56 14.06 2 14.75 2S16 2.56 16 3.25V15H16.75L18.16 11.47C18.38 10.92 18.84 10.5 19.4 10.31L20.19 10.05C21 9.79 21.74 10.58 21.43 11.37L18.4 19C17.19 22 14.26 24 11 24C6.58 24 3 20.42 3 16Z";
var mdiHandBackLeftOff = "M22.11 21.46L2.39 1.73L1.11 3L3.21 5.1C3.09 5.29 3 5.5 3 5.75V16C3 20.42 6.58 24 11 24C13.93 24 16.58 22.39 17.97 19.86L20.84 22.73L22.11 21.46M5.5 12V7.39L6.5 8.39V12H5.5M10 12H9V10.89L10 11.89V12M16 12.8L13.5 10.3V3.25C13.5 2.56 14.06 2 14.75 2S16 2.56 16 3.25V12.8M19.5 16.28L17.16 13.96L18.16 11.47C18.38 10.92 18.84 10.5 19.4 10.31L20.19 10.05C21 9.79 21.74 10.58 21.43 11.37L19.5 16.28M9 5.8L6.5 3.3V2.75C6.5 2.06 7.06 1.5 7.75 1.5S9 2.06 9 2.75V5.8M12.5 9.3L10 6.8V1.25C10 .56 10.56 0 11.25 0S12.5 .56 12.5 1.25V9.3Z";
var mdiHandBackLeftOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L3.56 5.45C3.21 5.87 3 6.41 3 7V16C3 20.42 6.58 24 11 24C13.94 24 16.62 22.45 18.12 20L20.84 22.73L22.11 21.46M11 22C7.69 22 5 19.31 5 16V7C5 6.97 5 6.94 5 6.91L6 7.89V12H8V9.89L9 10.89V12H10.11L16.65 18.54C15.57 20.64 13.41 22 11 22M8 4.8L6.21 3C6.59 2.12 7.47 1.5 8.5 1.5C8.73 1.5 8.96 1.53 9.17 1.59C9.54 .66 10.44 0 11.5 0C12.73 0 13.75 .89 13.96 2.06C14.13 2 14.31 2 14.5 2C15.88 2 17 3.12 17 4.5V10.39C17.34 10.08 17.76 9.85 18.22 9.73L19 9.5C19.82 9.29 20.69 9.61 21.18 10.35C21.56 10.92 21.58 11.66 21.33 12.3L19.67 16.47L18.13 14.93L19.5 11.45L19 11.59C18.5 11.71 18.15 12.05 18 12.5L17.34 14.14L15 11.8V4.5C15 4.22 14.78 4 14.5 4S14 4.22 14 4.5V10.8L12 8.8V2.5C12 2.22 11.78 2 11.5 2S11 2.22 11 2.5V7.8L9 5.8V4C9 3.72 8.78 3.5 8.5 3.5S8 3.72 8 4V4.8Z";
var mdiHandBackLeftOutline = "M3 16C3 20.42 6.58 24 11 24C14.43 24 17.5 21.91 18.77 18.73L21.33 12.3C21.58 11.66 21.56 10.92 21.18 10.35C20.69 9.61 19.82 9.29 19 9.5L18.22 9.73C17.76 9.85 17.34 10.08 17 10.39V4.5C17 3.12 15.88 2 14.5 2C14.31 2 14.13 2 13.96 2.06C13.75 .89 12.73 0 11.5 0C10.44 0 9.54 .66 9.17 1.59C8.96 1.53 8.73 1.5 8.5 1.5C7.12 1.5 6 2.62 6 4V4.55C5.84 4.5 5.67 4.5 5.5 4.5C4.12 4.5 3 5.62 3 7V16M5 7C5 6.72 5.22 6.5 5.5 6.5S6 6.72 6 7V12H8V4C8 3.72 8.22 3.5 8.5 3.5S9 3.72 9 4V12H11V2.5C11 2.22 11.22 2 11.5 2S12 2.22 12 2.5V12H14V4.5C14 4.22 14.22 4 14.5 4S15 4.22 15 4.5V15H17L18 12.5C18.15 12.05 18.5 11.71 19 11.59L19.5 11.45L16.91 18C15.95 20.41 13.61 22 11 22C7.69 22 5 19.31 5 16V7Z";
var mdiHandBackRight = "M13 24C9.74 24 6.81 22 5.6 19L2.57 11.37C2.26 10.58 3 9.79 3.81 10.05L4.6 10.31C5.16 10.5 5.62 10.92 5.84 11.47L7.25 15H8V3.25C8 2.56 8.56 2 9.25 2S10.5 2.56 10.5 3.25V12H11.5V1.25C11.5 .56 12.06 0 12.75 0S14 .56 14 1.25V12H15V2.75C15 2.06 15.56 1.5 16.25 1.5C16.94 1.5 17.5 2.06 17.5 2.75V12H18.5V5.75C18.5 5.06 19.06 4.5 19.75 4.5S21 5.06 21 5.75V16C21 20.42 17.42 24 13 24Z";
var mdiHandBackRightOff = "M20.84 22.73L19.17 21.06C17.7 22.85 15.5 24 13 24C9.74 24 6.81 22 5.6 19L2.57 11.37C2.26 10.58 3 9.79 3.81 10.05L4.6 10.31C5.16 10.5 5.62 10.92 5.84 11.47L7.25 15H8V9.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M14 1.25C14 .56 13.44 0 12.75 0S11.5 .56 11.5 1.25V8.3L14 10.8V1.25M21 16V5.75C21 5.06 20.44 4.5 19.75 4.5S18.5 5.06 18.5 5.75V12H17.5V2.75C17.5 2.06 16.94 1.5 16.25 1.5S15 2.06 15 2.75V11.8L20.83 17.63C20.94 17.11 21 16.56 21 16M10.5 3.25C10.5 2.56 9.94 2 9.25 2S8 2.56 8 3.25V4.8L10.5 7.3V3.25Z";
var mdiHandBackRightOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L7 8.89V10.39C6.66 10.08 6.24 9.85 5.78 9.73L5 9.5C4.18 9.29 3.31 9.61 2.82 10.35C2.44 10.92 2.42 11.66 2.67 12.3L5.23 18.73C6.5 21.91 9.57 24 13 24C15.5 24 17.7 22.85 19.17 21.06L20.84 22.73L22.11 21.46M13 22C10.39 22 8.05 20.41 7.09 18L4.5 11.45L5 11.59C5.5 11.71 5.85 12.05 6 12.5L7 15H9V10.89L17.75 19.64C16.66 21.07 14.94 22 13 22M9 5.8L7.09 3.89C7.36 2.8 8.33 2 9.5 2C9.69 2 9.87 2 10.04 2.06C10.25 .89 11.27 0 12.5 0C13.56 0 14.46 .66 14.83 1.59C15.04 1.53 15.27 1.5 15.5 1.5C16.88 1.5 18 2.62 18 4V4.55C18.16 4.5 18.33 4.5 18.5 4.5C19.88 4.5 21 5.62 21 7V16C21 16.56 20.94 17.11 20.83 17.63L19 15.8V7C19 6.72 18.78 6.5 18.5 6.5S18 6.72 18 7V12H16V4C16 3.72 15.78 3.5 15.5 3.5S15 3.72 15 4V11.8L13 9.8V2.5C13 2.22 12.78 2 12.5 2S12 2.22 12 2.5V8.8L10 6.8V4.5C10 4.22 9.78 4 9.5 4S9 4.22 9 4.5V5.8Z";
var mdiHandBackRightOutline = "M21 7C21 5.62 19.88 4.5 18.5 4.5C18.33 4.5 18.16 4.5 18 4.55V4C18 2.62 16.88 1.5 15.5 1.5C15.27 1.5 15.04 1.53 14.83 1.59C14.46 .66 13.56 0 12.5 0C11.27 0 10.25 .89 10.04 2.06C9.87 2 9.69 2 9.5 2C8.12 2 7 3.12 7 4.5V10.39C6.66 10.08 6.24 9.85 5.78 9.73L5 9.5C4.18 9.29 3.31 9.61 2.82 10.35C2.44 10.92 2.42 11.66 2.67 12.3L5.23 18.73C6.5 21.91 9.57 24 13 24C17.42 24 21 20.42 21 16V7M19 16C19 19.31 16.31 22 13 22C10.39 22 8.05 20.41 7.09 18L4.5 11.45L5 11.59C5.5 11.71 5.85 12.05 6 12.5L7 15H9V4.5C9 4.22 9.22 4 9.5 4S10 4.22 10 4.5V12H12V2.5C12 2.22 12.22 2 12.5 2S13 2.22 13 2.5V12H15V4C15 3.72 15.22 3.5 15.5 3.5S16 3.72 16 4V12H18V7C18 6.72 18.22 6.5 18.5 6.5S19 6.72 19 7V16Z";
var mdiHandClap = "M7.9 21.47C6 19.81 5.35 17.17 6.18 14.84L8.31 8.91C8.53 8.3 9.36 8.22 9.69 8.78L10 9.33C10.24 9.72 10.29 10.2 10.14 10.63L9.16 13.37L9.59 13.75L15.55 7C15.9 6.6 16.5 6.56 16.91 6.91C17.3 7.26 17.34 7.87 17 8.26L12.55 13.29L13.13 13.8L18.58 7.62C18.93 7.22 19.54 7.18 19.93 7.53C20.33 7.88 20.37 8.5 20 8.89L14.56 15.07L15.14 15.58L19.83 10.26C20.18 9.86 20.79 9.82 21.18 10.17S21.62 11.13 21.27 11.5L16.58 16.84L17.15 17.35L20.32 13.76C20.67 13.36 21.28 13.32 21.68 13.67S22.11 14.63 21.76 15L16.56 20.92C14.32 23.47 10.44 23.71 7.9 21.47M11.59 9.22L14.43 6C14.67 5.73 14.97 5.5 15.3 5.37L15.68 4.59C15.92 4.12 15.72 3.54 15.24 3.31C14.77 3.08 14.19 3.28 13.96 3.75L11.45 8.89C11.5 9 11.56 9.11 11.59 9.22M11 8L11 8.05L13.78 2.38C14 1.9 13.81 1.33 13.33 1.1C12.86 .865 12.28 1.06 12.05 1.54L9.41 6.95C10.06 7.06 10.63 7.43 11 8M4.77 14.33L6.9 8.4C7.17 7.65 7.8 7.14 8.55 6.97L10.69 2.58C10.92 2.1 10.72 1.53 10.25 1.3C9.77 1.07 9.2 1.26 8.97 1.74L5 9.84L4.5 9.59L4.71 6.68C4.75 6.23 4.57 5.78 4.25 5.46L3.79 5C3.32 4.57 2.55 4.86 2.5 5.5L2 11.79C1.87 13.83 2.77 15.78 4.35 17C4.33 16.12 4.46 15.21 4.77 14.33Z";
var mdiHandClapOff = "M22.11 21.46L2.39 1.73L1.11 3L2.97 4.86C2.72 4.96 2.5 5.19 2.5 5.5L2 11.79C1.87 13.83 2.77 15.78 4.35 17C4.33 16.12 4.46 15.21 4.77 14.33L6.8 8.69L7.97 9.86L6.18 14.84C5.35 17.17 6 19.81 7.9 21.47C10.44 23.71 14.32 23.47 16.56 20.92L17.72 19.61L20.84 22.73L22.11 21.46M5 9.84L4.5 9.59L4.71 6.68C4.71 6.65 4.71 6.63 4.71 6.6L5.97 7.86L5 9.84M9.59 13.75L9.16 13.37L9.77 11.66L10.65 12.54L9.59 13.75M14.94 11.74L18.58 7.62C18.93 7.22 19.54 7.18 19.93 7.53C20.33 7.88 20.37 8.5 20 8.89L16.3 13.1L14.94 11.74M19.83 10.26C20.18 9.86 20.79 9.82 21.18 10.17C21.57 10.5 21.62 11.13 21.27 11.5L18.2 15L16.85 13.65L19.83 10.26M21.68 13.67C22.08 14 22.11 14.63 21.76 15L20.1 16.9L18.74 15.54L20.32 13.76C20.67 13.36 21.28 13.32 21.68 13.67M15.55 7C15.9 6.6 16.5 6.56 16.91 6.91C17.3 7.26 17.34 7.87 17 8.26L14.4 11.2L13.04 9.84L15.55 7M11.66 8.46L13.96 3.75C14.19 3.28 14.77 3.08 15.24 3.31C15.72 3.54 15.92 4.12 15.68 4.59L15.3 5.37C14.97 5.5 14.67 5.73 14.43 6L12 8.78L11.66 8.46M9.08 5.88L7.64 4.44L8.97 1.74C9.2 1.26 9.77 1.07 10.25 1.3C10.72 1.53 10.92 2.1 10.69 2.58L9.08 5.88M9.65 6.45L12.05 1.54C12.28 1.06 12.86 .865 13.33 1.1C13.81 1.33 14 1.9 13.78 2.38L11.08 7.88L9.65 6.45Z";
var mdiHandCoin = "M16 12C18.76 12 21 9.76 21 7S18.76 2 16 2 11 4.24 11 7 13.24 12 16 12M21.45 17.6C21.06 17.2 20.57 17 20 17H13L10.92 16.27L11.25 15.33L13 16H15.8C16.15 16 16.43 15.86 16.66 15.63S17 15.12 17 14.81C17 14.27 16.74 13.9 16.22 13.69L8.95 11H7V20L14 22L22.03 19C22.04 18.47 21.84 18 21.45 17.6M5 11H.984V22H5V11Z";
var mdiHandCoinOutline = "M16 2C13.24 2 11 4.24 11 7S13.24 12 16 12 21 9.76 21 7 18.76 2 16 2M16 10C14.34 10 13 8.66 13 7S14.34 4 16 4 19 5.34 19 7 17.66 10 16 10M19 16H17C17 14.8 16.25 13.72 15.13 13.3L8.97 11H1V22H7V20.56L14 22.5L22 20V19C22 17.34 20.66 16 19 16M5 20H3V13H5V20M13.97 20.41L7 18.5V13H8.61L14.43 15.17C14.77 15.3 15 15.63 15 16C15 16 13 15.95 12.7 15.85L10.32 15.06L9.69 16.96L12.07 17.75C12.58 17.92 13.11 18 13.65 18H19C19.39 18 19.74 18.24 19.9 18.57L13.97 20.41Z";
var mdiHandCycle = "M19.5 13C18.18 13 17.05 13.74 16.45 14.81L13.23 12.18L10.96 13L9.87 11.32L11.21 11.69L13.87 9.5L12.93 8.36L10.9 10.03L7.96 9C7.96 9 7.96 9 7.95 9C7.54 8.85 7.08 8.89 6.69 9.14C6.04 9.56 5.83 10.39 6.16 11.07C5.95 11.03 5.73 11 5.5 11C3 11 1 13 1 15.5S3 20 5.5 20 10 18 10 15.5C10 15.37 9.97 15.25 9.96 15.12L13 14L16 16.5L16 16.5C16 18.43 17.57 20 19.5 20S23 18.43 23 16.5 21.43 13 19.5 13M5.5 18.5C3.85 18.5 2.5 17.15 2.5 15.5S3.85 12.5 5.5 12.5 8.5 13.85 8.5 15.5 7.15 18.5 5.5 18.5M19.5 18.5C18.4 18.5 17.5 17.6 17.5 16.5S18.4 14.5 19.5 14.5 21.5 15.4 21.5 16.5 20.6 18.5 19.5 18.5M6.44 7.57C5.85 7 5.85 6.06 6.44 5.5C7.03 4.89 7.97 4.89 8.56 5.5C9.15 6.06 9.15 7 8.56 7.57C7.97 8.15 7.03 8.15 6.44 7.57";
var mdiHandExtended = "M20 13C20.6 13 21.1 13.2 21.5 13.6C21.8 14 22 14.5 22 15L14 18L7 16V7H8.9L16.2 9.7C16.7 9.9 17 10.3 17 10.8C17 11.1 16.9 11.4 16.7 11.6S16.1 12 15.8 12H13L11.2 11.3L10.9 12.2L13 13H20M1 7H5V18H1V7Z";
var mdiHandExtendedOutline = "M22 15V16L14 18.5L7 16.6V18H1V7H9L15.2 9.3C16.2 9.7 17 10.8 17 12H19C20.7 12 22 13.3 22 15M5 16V9H3V16H5M19.9 14.6C19.7 14.2 19.4 14 19 14H13.6C13.1 14 12.5 13.9 12 13.8L9.7 13L10.3 11.1L12.7 11.9C13 11.9 15 12 15 12C15 11.6 14.8 11.3 14.4 11.2L8.6 9H7V14.5L14 16.4L19.9 14.6Z";
var mdiHandFrontLeft = "M3 9.25V15.75C3 20.31 6.69 24 11.25 24S19.5 20.31 19.5 15.75V5.75C19.5 5.06 18.94 4.5 18.25 4.5S17 5.06 17 5.75V12H16V2.75C16 2.06 15.44 1.5 14.75 1.5S13.5 2.06 13.5 2.75V11H12.5V1.25C12.5 .56 11.94 0 11.25 0S10 .56 10 1.25V11H9V3.25C9 2.56 8.44 2 7.75 2C7.06 2 6.5 2.56 6.5 3.25V14.03C8.47 14.28 10 15.96 10 18H9C9 16.35 7.65 15 6 15H5.5V9.25C5.5 8.56 4.94 8 4.25 8S3 8.56 3 9.25Z";
var mdiHandFrontLeftOutline = "M3 10.5V15.5C3 20.19 6.81 24 11.5 24S20 20.19 20 15.5V7C20 5.62 18.88 4.5 17.5 4.5C17.33 4.5 17.16 4.5 17 4.55V4C17 2.62 15.88 1.5 14.5 1.5C14.27 1.5 14.04 1.53 13.83 1.59C13.46 .66 12.56 0 11.5 0C10.27 0 9.25 .89 9.04 2.06C8.87 2 8.69 2 8.5 2C7.12 2 6 3.12 6 4.5V8.05C5.84 8 5.67 8 5.5 8C4.12 8 3 9.12 3 10.5M5 10.5C5 10.22 5.22 10 5.5 10S6 10.22 6 10.5V15C7.66 15 9 16.34 9 18H11C11 15.95 9.77 14.19 8 13.42V4.5C8 4.22 8.22 4 8.5 4S9 4.22 9 4.5V11H11V2.5C11 2.22 11.22 2 11.5 2S12 2.22 12 2.5V11H14V4C14 3.72 14.22 3.5 14.5 3.5S15 3.72 15 4V12H17V7C17 6.72 17.22 6.5 17.5 6.5S18 6.72 18 7V15.5C18 19.09 15.09 22 11.5 22S5 19.09 5 15.5V10.5Z";
var mdiHandFrontRight = "M19.75 8C19.06 8 18.5 8.56 18.5 9.25V15H18C16.35 15 15 16.35 15 18H14C14 15.96 15.53 14.28 17.5 14.03V3.25C17.5 2.56 16.94 2 16.25 2C15.56 2 15 2.56 15 3.25V11H14V1.25C14 .56 13.44 0 12.75 0S11.5 .56 11.5 1.25V11H10.5V2.75C10.5 2.06 9.94 1.5 9.25 1.5S8 2.06 8 2.75V12H7V5.75C7 5.06 6.44 4.5 5.75 4.5S4.5 5.06 4.5 5.75V15.75C4.5 20.31 8.19 24 12.75 24S21 20.31 21 15.75V9.25C21 8.56 20.44 8 19.75 8Z";
var mdiHandFrontRightOutline = "M18.5 8C18.33 8 18.16 8 18 8.05V4.5C18 3.12 16.88 2 15.5 2C15.31 2 15.13 2 14.96 2.06C14.75 .89 13.73 0 12.5 0C11.44 0 10.54 .66 10.17 1.59C9.96 1.53 9.73 1.5 9.5 1.5C8.12 1.5 7 2.62 7 4V4.55C6.84 4.5 6.67 4.5 6.5 4.5C5.12 4.5 4 5.62 4 7V15.5C4 20.19 7.81 24 12.5 24S21 20.19 21 15.5V10.5C21 9.12 19.88 8 18.5 8M19 15.5C19 19.09 16.09 22 12.5 22S6 19.09 6 15.5V7C6 6.72 6.22 6.5 6.5 6.5S7 6.72 7 7V12H9V4C9 3.72 9.22 3.5 9.5 3.5S10 3.72 10 4V11H12V2.5C12 2.22 12.22 2 12.5 2S13 2.22 13 2.5V11H15V4.5C15 4.22 15.22 4 15.5 4S16 4.22 16 4.5V13.42C14.23 14.19 13 15.95 13 18H15C15 16.34 16.34 15 18 15V10.5C18 10.22 18.22 10 18.5 10S19 10.22 19 10.5V15.5Z";
var mdiHandHeart = "M20 17Q20.86 17 21.45 17.6T22.03 19L14 22L7 20V11H8.95L16.22 13.69Q17 14 17 14.81 17 15.28 16.66 15.63T15.8 16H13L11.25 15.33L10.92 16.27L13 17H20M16 3.23Q17.06 2 18.7 2 20.06 2 21 3T22 5.3Q22 6.33 21 7.76T19.03 10.15 16 13Q13.92 11.11 12.94 10.15T10.97 7.76 10 5.3Q10 3.94 10.97 3T13.31 2Q14.91 2 16 3.23M.984 11H5V22H.984V11Z";
var mdiHandHeartOutline = "M16 3.23C16.71 2.41 17.61 2 18.7 2C19.61 2 20.37 2.33 21 3C21.63 3.67 21.96 4.43 22 5.3C22 6 21.67 6.81 21 7.76S19.68 9.5 19.03 10.15C18.38 10.79 17.37 11.74 16 13C14.61 11.74 13.59 10.79 12.94 10.15S11.63 8.71 10.97 7.76C10.31 6.81 10 6 10 5.3C10 4.39 10.32 3.63 10.97 3C11.62 2.37 12.4 2.04 13.31 2C14.38 2 15.27 2.41 16 3.23M22 19V20L14 22.5L7 20.56V22H1V11H8.97L15.13 13.3C16.25 13.72 17 14.8 17 16H19C20.66 16 22 17.34 22 19M5 20V13H3V20H5M19.9 18.57C19.74 18.24 19.39 18 19 18H13.65C13.11 18 12.58 17.92 12.07 17.75L9.69 16.96L10.32 15.06L12.7 15.85C13 15.95 15 16 15 16C15 15.63 14.77 15.3 14.43 15.17L8.61 13H7V18.5L13.97 20.41L19.9 18.57Z";
var mdiHandOkay = "M13.3,19.26L18.96,13.61L21.08,15.73L15.42,21.38L13.3,19.26M16.5,11.13L13.4,8.05C13.27,7.92 13.13,7.83 13,7.76L11.88,3.47C11.74,2.93 11.2,2.61 10.66,2.75C10.13,2.88 9.81,3.43 9.94,3.96L11,8.03V8.03L8.67,3.19C8.44,2.69 7.84,2.5 7.34,2.71C6.84,2.95 6.63,3.55 6.87,4.05L8.56,7.59L5.19,4.25C4.8,3.86 4.16,3.86 3.77,4.25C3.38,4.65 3.39,5.28 3.78,5.67L7.5,9.37L6.8,9.64L5.72,10.07L3.81,11.39C3.81,11.39 3,12.44 2.93,12.89C2.85,13.34 3.72,15.6 3.72,15.6H3.73C3.89,15.94 4.23,16.18 4.63,16.18A1,1 0 0,0 5.63,15.18C5.63,15.08 5.6,15 5.57,14.91L5.59,14.9L5,13.17L6.23,12.19C6.7,12.21 7.71,12.29 8.2,12.32C10.93,14.77 8.35,15.73 8.35,15.73L4.89,16.79L4.72,16.93C4.5,17.13 4.41,17.4 4.42,17.68L4.44,18.75L10.87,18.25C11.25,18.26 11.61,18.12 11.89,17.85L16.5,13.25C17.03,12.71 17.05,11.7 16.5,11.13Z";
var mdiHandPeace = "M7,19H15V22H7V19M16.15,12V12L12.97,10.34C12.82,10.34 12.69,10.4 12.6,10.5L12.3,10.81L12.89,13.23L11.91,13.47L10.72,8.5L9.25,9.18L10.29,13.47L9.32,13.7L8.32,9.59L7.85,9.8C7.35,10 7,10.53 7,11.14V15.5C7,16.3 7.73,17 8.5,17H15C15.39,17 15.74,16.84 16,16.57L16.5,16.16C16.5,16.16 17,15.78 17,15.36V13.7C17,13.7 17,12.56 16.15,12M16.94,1C16.4,0.91 15.87,1.25 15.76,1.8L14.69,7.97C14.47,7.94 14.38,7.86 14.08,7.83L13.65,7.88L12.41,1.8C12.3,1.26 11.78,0.91 11.24,1C10.69,1.13 10.34,1.66 10.45,2.2L11.65,8.11V8.11L12,9.67C12.28,9.47 12.61,9.34 12.97,9.34H13.31L16.31,10.95L17.72,2.2C17.83,1.66 17.5,1.13 16.94,1Z";
var mdiHandPeaceVariant = "M7,19H15V22H7V19M16.94,1C16.4,0.91 15.87,1.25 15.76,1.8L14.75,7.57C14.53,7.54 14.29,7.5 14,7.47L13.57,7.5L12.41,1.8C12.31,1.26 11.78,0.91 11.24,1C10.7,1.13 10.35,1.66 10.45,2.2L11.65,8.11L7.85,9.8C7.35,10 7,10.53 7,11.14V15.5C7,16.3 7.73,17 8.5,17H15C15.39,17 15.74,16.84 16,16.57L16.5,16.16C16.5,16.16 17,15.78 17,15.36V13C17,13 17,11.86 16.13,11.3L17.71,2.2C17.83,1.66 17.5,1.13 16.94,1Z";
var mdiHandPointingDown = "M9.9,21V11L6.7,12.69L6.5,12.72C6.19,12.72 5.93,12.6 5.74,12.4L5,11.63L9.9,7.43C10.16,7.16 10.5,7 10.9,7H17.4C18.17,7 18.9,7.7 18.9,8.5V12.86C18.9,13.47 18.55,14 18.05,14.2L13.11,16.4L11.9,16.53V21A1,1 0 0,1 10.9,22A1,1 0 0,1 9.9,21M18.9,5H10.9V2H18.9V5Z";
var mdiHandPointingLeft = "M3,9H13L11.31,5.8L11.28,5.58C11.28,5.29 11.4,5.03 11.6,4.84L12.37,4.1L16.57,9C16.84,9.26 17,9.61 17,10V16.5C17,17.27 16.3,18 15.5,18H11.14C10.53,18 10,17.65 9.8,17.15L7.6,12.21L7.47,11H3A1,1 0 0,1 2,10A1,1 0 0,1 3,9M19,18V10H22V18H19Z";
var mdiHandPointingRight = "M21,9A1,1 0 0,1 22,10A1,1 0 0,1 21,11H16.53L16.4,12.21L14.2,17.15C14,17.65 13.47,18 12.86,18H8.5C7.7,18 7,17.27 7,16.5V10C7,9.61 7.16,9.26 7.43,9L11.63,4.1L12.4,4.84C12.6,5.03 12.72,5.29 12.72,5.58L12.69,5.8L11,9H21M2,18V10H5V18H2Z";
var mdiHandPointingUp = "M14,3V13L17.2,11.31L17.42,11.28C17.71,11.28 17.97,11.4 18.16,11.6L18.9,12.37L14,16.57C13.74,16.84 13.39,17 13,17H6.5C5.73,17 5,16.3 5,15.5V11.14C5,10.53 5.35,10 5.85,9.8L10.79,7.6L12,7.47V3A1,1 0 0,1 13,2A1,1 0 0,1 14,3M5,19H13V22H5V19Z";
var mdiHandSaw = "M9.8,17L5.9,11.6L20,2L22,5V8H19V11H16V14H13V17M9.7,18.7L9.2,21.5L7.6,22.7C6.7,23.3 5.5,23.1 4.8,22.2L1.3,17.3C0.7,16.4 0.9,15.2 1.8,14.5L5.1,12.2L9.7,18.7M4.6,15L3,16.1L6.5,21L8.1,19.8L4.6,15Z";
var mdiHandWash = "M17 5L17.62 6.37L19 7L17.62 7.63L17 9L16.36 7.63L15 7L16.36 6.37L17 5M11 6.13V4H13C13.57 4 14.1 4.17 14.55 4.45L16 3C15.15 2.39 14.13 2 13 2H7.5V4H9V6.14C7.23 6.5 5.81 7.8 5.26 9.5H9.24L15 11.65V11.03C15 8.61 13.28 6.59 11 6.13M1 22H5V11H1V22M20 17H13L10.91 16.27L11.24 15.33L13 16H15.82C16.47 16 17 15.47 17 14.82C17 14.33 16.69 13.89 16.23 13.71L8.97 11H7V20L14 22L22 19C22 17.9 21.11 17 20 17M20 14C21.1 14 22 13.1 22 12S20 8 20 8 18 10.9 18 12 18.9 14 20 14Z";
var mdiHandWashOutline = "M17 5L17.62 6.37L19 7L17.62 7.63L17 9L16.36 7.63L15 7L16.36 6.37L17 5M20 14C21.1 14 22 13.1 22 12S20 8 20 8 18 10.9 18 12 18.9 14 20 14M11 6.1V4H13C13.57 4 14.1 4.17 14.55 4.45L16 3C15.15 2.39 14.13 2 13 2H7.5V4H9V6.11C7.22 6.5 5.8 7.79 5.25 9.5H7.41C7.94 8.61 8.89 8 10 8C11.62 8 12.94 9.29 13 10.9L15 11.65V11C15 8.58 13.28 6.56 11 6.1M22 19V20L14 22.5L7 20.56V22H1V11H8.97L15.13 13.3C16.25 13.72 17 14.8 17 16H19C20.66 16 22 17.34 22 19M5 20V13H3V20H5M19.9 18.57C19.74 18.24 19.39 18 19 18H13.65C13.11 18 12.58 17.92 12.07 17.75L9.69 16.96L10.32 15.06L12.7 15.85C13 15.95 15 16 15 16C15 15.63 14.77 15.3 14.43 15.17L8.61 13H7V18.5L13.97 20.41L19.9 18.57Z";
var mdiHandWater = "M17.42 22.5H5.33C3.5 22.5 2 21 2 19.17V13.08C2 12.18 2.36 11.33 3 10.71L8.63 5.17C8.63 5.17 9.66 6.22 9.67 6.25C9.83 6.43 9.92 6.66 9.92 6.91C9.92 7.09 9.87 7.26 9.78 7.41C9.77 7.44 8 10 8 10H18.67C19.36 10 19.92 10.56 19.92 11.25C19.92 11.94 19.36 12.5 18.67 12.5H12.83V13.33H20.75C21.44 13.33 22 13.89 22 14.58C22 15.28 21.44 15.83 20.75 15.83H12.83V16.67H19.92C20.61 16.67 21.17 17.22 21.17 17.92C21.17 18.61 20.61 19.17 19.92 19.17H12.83V20H17.42C18.11 20 18.67 20.56 18.67 21.25C18.67 21.94 18.11 22.5 17.42 22.5M13.5 4.8C13.5 4.8 12 6.46 12 7.5C12 9.5 15 9.5 15 7.5C15 6.46 13.5 4.8 13.5 4.8M18.5 1C18.5 1 16 3.76 16 5.5C16 8.83 21 8.83 21 5.5C21 3.76 18.5 1 18.5 1Z";
var mdiHandWave = "M23 17C23 20.31 20.31 23 17 23V21.5C19.5 21.5 21.5 19.5 21.5 17H23M1 7C1 3.69 3.69 1 7 1V2.5C4.5 2.5 2.5 4.5 2.5 7H1M8 4.32L3.41 8.92C.19 12.14 .19 17.37 3.41 20.59S11.86 23.81 15.08 20.59L22.15 13.5C22.64 13.03 22.64 12.24 22.15 11.75C21.66 11.26 20.87 11.26 20.38 11.75L15.96 16.17L15.25 15.46L21.79 8.92C22.28 8.43 22.28 7.64 21.79 7.15S20.5 6.66 20 7.15L14.19 13L13.5 12.27L20.37 5.38C20.86 4.89 20.86 4.1 20.37 3.61S19.09 3.12 18.6 3.61L11.71 10.5L11 9.8L16.5 4.32C17 3.83 17 3.04 16.5 2.55S15.22 2.06 14.73 2.55L7.11 10.17C8.33 11.74 8.22 14 6.78 15.45L6.07 14.74C7.24 13.57 7.24 11.67 6.07 10.5L5.72 10.15L9.79 6.08C10.28 5.59 10.28 4.8 9.79 4.31C9.29 3.83 8.5 3.83 8 4.32Z";
var mdiHandWaveOutline = "M7.03 4.95L3.5 8.5C.17 11.81 .17 17.19 3.5 20.5S12.19 23.83 15.5 20.5L21.5 14.5C22.5 13.53 22.5 11.94 21.5 10.96C21.4 10.84 21.27 10.73 21.13 10.64L21.5 10.25C22.5 9.28 22.5 7.69 21.5 6.71C21.36 6.55 21.17 6.41 21 6.3C21.38 5.38 21.21 4.28 20.46 3.53C19.59 2.66 18.24 2.57 17.26 3.25C17.16 3.1 17.05 2.96 16.92 2.83C15.95 1.86 14.36 1.86 13.38 2.83L10.87 5.34C10.78 5.2 10.67 5.07 10.55 4.95C9.58 4 8 4 7.03 4.95M8.44 6.37C8.64 6.17 8.95 6.17 9.15 6.37S9.35 6.88 9.15 7.08L5.97 10.26C7.14 11.43 7.14 13.33 5.97 14.5L7.38 15.91C8.83 14.46 9.2 12.34 8.5 10.55L14.8 4.25C15 4.05 15.31 4.05 15.5 4.25S15.71 4.76 15.5 4.96L10.91 9.56L12.32 10.97L18.33 4.96C18.53 4.76 18.84 4.76 19.04 4.96C19.24 5.16 19.24 5.47 19.04 5.67L13.03 11.68L14.44 13.09L19.39 8.14C19.59 7.94 19.9 7.94 20.1 8.14C20.3 8.34 20.3 8.65 20.1 8.85L14.44 14.5L15.85 15.92L19.39 12.38C19.59 12.18 19.9 12.18 20.1 12.38C20.3 12.58 20.3 12.89 20.1 13.09L14.1 19.1C11.56 21.64 7.45 21.64 4.91 19.1S2.37 12.45 4.91 9.91L8.44 6.37M23 17C23 20.31 20.31 23 17 23V21.5C19.5 21.5 21.5 19.5 21.5 17H23M1 7C1 3.69 3.69 1 7 1V2.5C4.5 2.5 2.5 4.5 2.5 7H1Z";
var mdiHandball = "M15.83 10.43A6.93 6.93 0 0 1 18.39 14.86A6.64 6.64 0 0 1 17.5 19.5L15.78 18.5A5 5 0 0 0 16.44 16A5.22 5.22 0 0 0 15.46 13.06L9.18 23.93L7.44 22.95L10.44 17.75L8.71 16.76L7.21 19.34L5.5 18.36L10.63 9.45A7 7 0 0 1 8.8 5.46A6.91 6.91 0 0 1 9.69 1.1L11.43 2.13A4.84 4.84 0 0 0 10.91 5.9A4.74 4.74 0 0 0 13.21 8.93M16 5A2 2 0 1 0 18 7A2 2 0 0 0 16 5M13.5 1A1.5 1.5 0 1 0 15 2.5A1.5 1.5 0 0 0 13.5 1Z";
var mdiHandcuffs = "M20.24 6.76C18.4 4.91 15.65 4.53 13.42 5.59L12.46 4.63C12.07 4.24 11.44 4.24 11.05 4.63L10.97 4.72C10.83 3.75 10 3 9 3C7.9 3 7 3.9 7 5C7 5.09 7 5.18 7.03 5.26C6.42 5.61 6 6.25 6 7C6 7.46 6.16 7.87 6.42 8.21C6.17 8.39 6 8.67 6 9V10.35C3.67 11.17 2 13.39 2 16C2 19.31 4.69 22 8 22S14 19.31 14 16C14 13.39 12.33 11.17 10 10.35V9C10 8.67 9.83 8.39 9.58 8.21C9.84 7.87 10 7.46 10 7C10 6.91 10 6.82 9.97 6.74C10.15 6.64 10.3 6.5 10.43 6.38C11.36 6.88 12 7.86 12 9V9.08C12.13 9.15 12.25 9.25 12.38 9.33C12.57 8.91 12.83 8.5 13.17 8.17C14.73 6.61 17.27 6.61 18.83 8.17C20.39 9.73 20.39 12.27 18.83 13.83C18.03 14.63 17 15 15.93 15C16 15.32 16 15.66 16 16C16 16.34 15.97 16.67 15.93 17C17.5 17 19.05 16.43 20.24 15.24C22.59 12.9 22.59 9.1 20.24 6.76M9 4C9.55 4 10 4.45 10 5C10 5.33 9.83 5.61 9.58 5.79C9.22 5.31 8.65 5 8 5C8 4.45 8.45 4 9 4M7.42 6.21C7.78 6.69 8.35 7 9 7C9 7.55 8.55 8 8 8S7 7.55 7 7C7 6.67 7.17 6.39 7.42 6.21M12 16C12 18.21 10.21 20 8 20S4 18.21 4 16C4 13.79 5.79 12 8 12S12 13.79 12 16Z";
var mdiHandsPray = "M11.43 9.67C11.47 9.78 11.5 9.88 11.5 10V15.22C11.5 15.72 11.31 16.2 10.97 16.57L8.18 19.62L4.78 16.22L6 15L8.8 2.86C8.92 2.36 9.37 2 9.89 2C10.5 2 11 2.5 11 3.11V8.07C10.84 8.03 10.67 8 10.5 8C9.4 8 8.5 8.9 8.5 10V13C8.5 13.28 8.72 13.5 9 13.5S9.5 13.28 9.5 13V10C9.5 9.45 9.95 9 10.5 9C10.69 9 10.85 9.07 11 9.16C11.12 9.23 11.21 9.32 11.3 9.42C11.33 9.46 11.36 9.5 11.38 9.55C11.4 9.59 11.42 9.63 11.43 9.67M2 19L6 22L7.17 20.73L3.72 17.28L2 19M18 15L15.2 2.86C15.08 2.36 14.63 2 14.11 2C13.5 2 13 2.5 13 3.11V8.07C13.16 8.03 13.33 8 13.5 8C14.6 8 15.5 8.9 15.5 10V13C15.5 13.28 15.28 13.5 15 13.5S14.5 13.28 14.5 13V10C14.5 9.45 14.05 9 13.5 9C13.31 9 13.15 9.07 13 9.16C12.88 9.23 12.79 9.32 12.71 9.42C12.68 9.46 12.64 9.5 12.62 9.55C12.6 9.59 12.58 9.63 12.57 9.67C12.53 9.78 12.5 9.88 12.5 10V15.22C12.5 15.72 12.69 16.2 13.03 16.57L15.82 19.62L19.22 16.22L18 15M20.28 17.28L16.83 20.73L18 22L22 19L20.28 17.28Z";
var mdiHandshake = "M11 6H14L17.29 2.7A1 1 0 0 1 18.71 2.7L21.29 5.29A1 1 0 0 1 21.29 6.7L19 9H11V11A1 1 0 0 1 10 12A1 1 0 0 1 9 11V8A2 2 0 0 1 11 6M5 11V15L2.71 17.29A1 1 0 0 0 2.71 18.7L5.29 21.29A1 1 0 0 0 6.71 21.29L11 17H15A1 1 0 0 0 16 16V15H17A1 1 0 0 0 18 14V13H19A1 1 0 0 0 20 12V11H13V12A2 2 0 0 1 11 14H9A2 2 0 0 1 7 12V9Z";
var mdiHandshakeOutline = "M21.71 8.71C22.96 7.46 22.39 6 21.71 5.29L18.71 2.29C17.45 1.04 16 1.61 15.29 2.29L13.59 4H11C9.1 4 8 5 7.44 6.15L3 10.59V14.59L2.29 15.29C1.04 16.55 1.61 18 2.29 18.71L5.29 21.71C5.83 22.25 6.41 22.45 6.96 22.45C7.67 22.45 8.32 22.1 8.71 21.71L11.41 19H15C16.7 19 17.56 17.94 17.87 16.9C19 16.6 19.62 15.74 19.87 14.9C21.42 14.5 22 13.03 22 12V9H21.41L21.71 8.71M20 12C20 12.45 19.81 13 19 13L18 13L18 14C18 14.45 17.81 15 17 15L16 15L16 16C16 16.45 15.81 17 15 17H10.59L7.31 20.28C7 20.57 6.82 20.4 6.71 20.29L3.72 17.31C3.43 17 3.6 16.82 3.71 16.71L5 15.41V11.41L7 9.41V11C7 12.21 7.8 14 10 14S13 12.21 13 11H20V12M20.29 7.29L18.59 9H11V11C11 11.45 10.81 12 10 12S9 11.45 9 11V8C9 7.54 9.17 6 11 6H14.41L16.69 3.72C17 3.43 17.18 3.6 17.29 3.71L20.28 6.69C20.57 7 20.4 7.18 20.29 7.29Z";
var mdiHanger = "M12 4A3.5 3.5 0 0 0 8.5 7.5H10.5A1.5 1.5 0 0 1 12 6A1.5 1.5 0 0 1 13.5 7.5A1.5 1.5 0 0 1 12 9C11.45 9 11 9.45 11 10V11.75L2.4 18.2A1 1 0 0 0 3 20H21A1 1 0 0 0 21.6 18.2L13 11.75V10.85A3.5 3.5 0 0 0 15.5 7.5A3.5 3.5 0 0 0 12 4M12 13.5L18 18H6Z";
var mdiHardHat = "M9.87,12.15L9,6.46C10.95,5.84 13.05,5.84 15,6.46L14.13,12.15C14.06,12.64 13.63,13 13.13,13H10.86C10.37,13 9.94,12.64 9.87,12.15M22,16V16C22,15.21 21.53,14.5 20.8,14.17C20.32,11.86 18.96,9.83 17,8.5L15.24,13.34C15.1,13.74 14.72,14 14.3,14H9.7C9.28,14 8.9,13.74 8.76,13.34L7,8.5C5.04,9.83 3.68,11.86 3.2,14.16C2.47,14.5 2,15.2 2,16L8.45,17.84C8.81,17.94 9.18,18 9.55,18H14.43C14.8,18 15.17,17.94 15.53,17.84L22,16Z";
var mdiHarddisk = "M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M12,4A6,6 0 0,0 6,10C6,13.31 8.69,16 12.1,16L11.22,13.77C10.95,13.29 11.11,12.68 11.59,12.4L12.45,11.9C12.93,11.63 13.54,11.79 13.82,12.27L15.74,14.69C17.12,13.59 18,11.9 18,10A6,6 0 0,0 12,4M12,9A1,1 0 0,1 13,10A1,1 0 0,1 12,11A1,1 0 0,1 11,10A1,1 0 0,1 12,9M7,18A1,1 0 0,0 6,19A1,1 0 0,0 7,20A1,1 0 0,0 8,19A1,1 0 0,0 7,18M12.09,13.27L14.58,19.58L17.17,18.08L12.95,12.77L12.09,13.27Z";
var mdiHarddiskPlus = "M12 9A1 1 0 1 0 13 10A1 1 0 0 0 12 9M12 9A1 1 0 1 0 13 10A1 1 0 0 0 12 9M18 2H6A2 2 0 0 0 4 4V13.09A5.47 5.47 0 0 1 5 13A5.71 5.71 0 0 1 7 13.36A6 6 0 1 1 15.71 14.69L13.79 12.27A1 1 0 0 0 12.42 11.9L11.56 12.4A1 1 0 0 0 11.19 13.77L12.1 16A6.12 6.12 0 0 1 10 15.62A6 6 0 0 1 10.19 22H18A2 2 0 0 0 20 20V4A2 2 0 0 0 18 2M14.58 19.58L12.09 13.27L12.95 12.77L17.17 18.08M12 11A1 1 0 1 0 11 10A1 1 0 0 0 12 11M9 20H6V23H4V20H1V18H4V15H6V18H9Z";
var mdiHarddiskRemove = "M12 9A1 1 0 1 0 13 10A1 1 0 0 0 12 9M12 9A1 1 0 1 0 13 10A1 1 0 0 0 12 9M18 2H6A2 2 0 0 0 4 4V13.09A5.47 5.47 0 0 1 5 13A5.71 5.71 0 0 1 7 13.36A6 6 0 1 1 15.71 14.69L13.79 12.27A1 1 0 0 0 12.42 11.9L11.56 12.4A1 1 0 0 0 11.19 13.77L12.1 16A6.12 6.12 0 0 1 10 15.62A6 6 0 0 1 10.19 22H18A2 2 0 0 0 20 20V4A2 2 0 0 0 18 2M14.58 19.58L12.09 13.27L12.95 12.77L17.17 18.08M12 11A1 1 0 1 0 11 10A1 1 0 0 0 12 11M7.12 22.54L5 20.41L2.88 22.54L1.46 21.12L3.59 19L1.46 16.88L2.88 15.46L5 17.59L7.12 15.46L8.54 16.88L6.41 19L8.54 21.12Z";
var mdiHatFedora = "M19.11,11.92C19.13,11.71 19.14,11.5 19.14,11.29C19.14,7.86 17.71,4.14 16.28,4.14C14.85,4.14 13.42,5.57 12,5.57C10.57,5.57 9.14,4.14 7.71,4.14C6.28,4.14 4.86,7.79 4.86,11.29C4.86,11.5 4.86,11.71 4.88,11.92C7.22,12.45 9.6,12.72 12,12.71C14.45,12.71 16.83,12.44 19.11,11.92M3.45,18.18C9,19.85 14.96,19.86 20.54,18.18C20.96,18.04 21.33,17.77 21.59,17.41C21.85,17.05 22,16.61 22,16.17C22,15.72 21.86,15.29 21.61,14.92C21.35,14.56 21,14.29 20.56,14.14C17.86,15 15,15.45 12,15.45C9,15.45 6.13,15 3.43,14.14C3,14.29 2.65,14.57 2.39,14.93C2.14,15.29 2,15.72 2,16.17C2,17.11 2.61,17.9 3.45,18.18V18.18Z";
var mdiHazardLights = "M12,12L14.33,16H9.68L12,12M12,8L6.21,18H17.8L12,8M12,2L1,21H23L12,2M12,6L19.53,19H4.47L12,6Z";
var mdiHdmiPort = "M21 7H3C1.9 7 1 7.9 1 9V14C1 15.1 1.9 16 3 16H4L5.4 17.4C5.8 17.8 6.3 18 6.8 18H17.1C17.6 18 18.1 17.8 18.5 17.4L20 16H21C22.1 16 23 15.1 23 14V9C23 7.9 22.1 7 21 7M3 14V9H21V14H19.2L17.2 16H6.8L4.8 14H3M19 11H5V13H19V11Z";
var mdiHdr = "M21,11.5V10.5C21,9.7 20.3,9 19.5,9H16V15H17.5V13H18.6L19.5,15H21L20.1,12.9C20.6,12.6 21,12.1 21,11.5M19.5,11.5H17.5V10.5H19.5V11.5M6.5,11H4.5V9H3V15H4.5V12.5H6.5V15H8V9H6.5V11M13,9H9.5V15H13C13.8,15 14.5,14.3 14.5,13.5V10.5C14.5,9.7 13.8,9 13,9M13,13.5H11V10.5H13V13.5Z";
var mdiHdrOff = "M17.5,15V13H18.6L19.5,15H21L20.1,12.9C20.6,12.7 21,12.1 21,11.5V10.5C21,9.7 20.3,9 19.5,9H16V13.9L17.1,15H17.5M17.5,10.5H19.5V11.5H17.5V10.5M13,10.5V10.9L14.5,12.4V10.5C14.5,9.7 13.8,9 13,9H11.1L12.6,10.5H13M9.5,9.5L2.5,2.5L1.4,3.5L6.9,9H6.5V11H4.5V9H3V15H4.5V12.5H6.5V15H8V10.1L9.5,11.6V15H12.9L20.5,22.6L21.6,21.5L9.5,9.5Z";
var mdiHead = "M13 3C9.2 3 6.2 5.9 6 9.7L4.1 12.2C3.9 12.5 4.1 13 4.5 13H6V16C6 17.1 6.9 18 8 18H9V21H16V16.3C18.4 15.2 20 12.8 20 10C20 6.1 16.9 3 13 3";
var mdiHeadAlert = "M13 3C9.2 3 6.2 5.9 6 9.7L4.1 12.2C3.9 12.5 4.1 13 4.5 13H6V16C6 17.1 6.9 18 8 18H9V21H16V16.3C18.4 15.2 20 12.8 20 10C20 6.1 16.9 3 13 3M14 15H12V13H14V14M14 11H12V5H14V11Z";
var mdiHeadAlertOutline = "M13 3C16.9 3 20 6.1 20 10C20 12.8 18.4 15.2 16 16.3V21H9V18H8C6.9 18 6 17.1 6 16V13H4.5C4.1 13 3.8 12.5 4.1 12.2L6 9.7C6.2 5.9 9.2 3 13 3M13 1C8.4 1 4.6 4.4 4.1 8.9L2.5 11C1.9 11.8 1.9 12.8 2.3 13.6C2.7 14.3 3.3 14.8 4 14.9V16C4 17.9 5.3 19.4 7 19.9V23H18V17.5C20.5 15.8 22 13.1 22 10C22 5 18 1 13 1M14 15H12V13H14V15M14 11H12V5H14";
var mdiHeadCheck = "M13 3C9.23 3 6.19 5.95 6 9.66L4.08 12.19C3.84 12.5 4.08 13 4.5 13H6V16C6 17.11 6.89 18 8 18H9V21H16V16.31C18.37 15.19 20 12.8 20 10C20 6.14 16.88 3 13 3M12.47 13L9 9.5L10.4 8.09L12.47 10.17L16.6 6L18 7.41L12.47 13Z";
var mdiHeadCheckOutline = "M13 3C16.88 3 20 6.14 20 10C20 12.8 18.37 15.19 16 16.31V21H9V18H8C6.89 18 6 17.11 6 16V13H4.5C4.08 13 3.84 12.5 4.08 12.19L6 9.66C6.19 5.95 9.23 3 13 3M13 1C8.42 1 4.61 4.43 4.06 8.91L2.5 11C1.92 11.72 1.82 12.72 2.24 13.59C2.6 14.31 3.24 14.8 4 14.95V16C4 17.86 5.28 19.43 7 19.87V23H18V17.47C20.5 15.83 22 13.06 22 10C22 5.04 17.96 1 13 1M12.47 13L9 9.5L10.4 8.09L12.47 10.17L16.6 6L18 7.41L12.47 13Z";
var mdiHeadCog = "M13 8.58C13.78 8.58 14.44 9.19 14.44 10S13.78 11.44 13 11.44 11.58 10.78 11.58 10 12.19 8.58 13 8.58M13 3C16.88 3 20 6.14 20 10C20 12.8 18.37 15.19 16 16.31V21H9V18H8C6.89 18 6 17.11 6 16V13H4.5C4.08 13 3.84 12.5 4.08 12.19L6 9.66C6.19 5.95 9.23 3 13 3M16 10C16 9.84 16 9.75 15.94 9.61L16.83 8.95C16.88 8.91 16.92 8.77 16.88 8.67L16.08 7.31C16.03 7.22 15.89 7.17 15.8 7.22L14.81 7.64C14.63 7.45 14.39 7.31 14.16 7.22L14 6.19C13.97 6.05 13.92 6 13.78 6H12.19C12.09 6 12 6.05 12 6.19L11.86 7.22C11.63 7.31 11.39 7.45 11.2 7.64L10.17 7.22C10.08 7.17 10 7.22 9.94 7.31L9.14 8.67C9.09 8.81 9.09 8.91 9.19 8.95L10.03 9.61C10.03 9.75 10 9.89 10 10C10 10.13 10.03 10.27 10.03 10.41L9.19 11.06C9.09 11.11 9.09 11.2 9.14 11.3L9.94 12.7C10 12.8 10.08 12.8 10.17 12.8L11.16 12.37C11.39 12.56 11.58 12.66 11.86 12.75L12 13.83C12 13.92 12.09 14 12.19 14H13.78C13.92 14 13.97 13.92 14 13.83L14.16 12.75C14.39 12.66 14.63 12.56 14.81 12.38L15.8 12.8C15.89 12.8 16.03 12.8 16.08 12.7L16.88 11.3C16.92 11.2 16.88 11.11 16.83 11.06L16 10.41V10Z";
var mdiHeadCogOutline = "M13 3C16.88 3 20 6.14 20 10C20 12.8 18.37 15.19 16 16.31V21H9V18H8C6.89 18 6 17.11 6 16V13H4.5C4.08 13 3.84 12.5 4.08 12.19L6 9.66C6.19 5.95 9.23 3 13 3M13 1C8.42 1 4.61 4.43 4.06 8.91L2.5 11C1.92 11.72 1.82 12.72 2.24 13.59C2.6 14.31 3.24 14.8 4 14.95V16C4 17.86 5.28 19.43 7 19.87V23H18V17.47C20.5 15.83 22 13.06 22 10C22 5.04 17.96 1 13 1M16.1 9.42V9C16.1 8.85 16.1 8.76 16.04 8.62L16.93 7.96C17 7.92 17 7.78 17 7.68L16.18 6.32C16.13 6.23 16 6.18 15.9 6.23L14.91 6.65C14.73 6.46 14.5 6.32 14.26 6.23L14.1 5.2C14.07 5.06 14 5 13.88 5H12.29C12.19 5 12.1 5.06 12.1 5.2L11.96 6.23C11.73 6.32 11.5 6.46 11.3 6.65L10.27 6.23C10.18 6.18 10.1 6.23 10.04 6.32L9.24 7.68C9.19 7.82 9.19 7.92 9.29 7.96L10.13 8.62C10.13 8.76 10.1 8.9 10.1 9C10.1 9.14 10.13 9.28 10.13 9.42L9.29 10.07C9.19 10.12 9.19 10.21 9.24 10.31L10.04 11.71C10.1 11.81 10.18 11.81 10.27 11.81L11.26 11.38C11.5 11.57 11.68 11.67 11.96 11.76L12.1 12.84C12.1 12.93 12.19 13 12.29 13H13.88C14 13 14.07 12.93 14.1 12.84L14.26 11.76C14.5 11.67 14.73 11.57 14.91 11.39L15.9 11.81C16 11.81 16.13 11.81 16.18 11.71L17 10.31C17 10.21 17 10.12 16.93 10.07L16.1 9.42M13.1 10.45C12.32 10.45 11.68 9.79 11.68 9S12.29 7.59 13.1 7.59C13.88 7.59 14.54 8.2 14.54 9S13.88 10.45 13.1 10.45Z";
var mdiHeadDotsHorizontal = "M13 3C9.23 3 6.19 5.95 6 9.66L4.08 12.19C3.84 12.5 4.08 13 4.5 13H6V16C6 17.11 6.89 18 8 18H9V21H16V16.31C18.37 15.19 20 12.8 20 10C20 6.14 16.88 3 13 3M10 11C9.45 11 9 10.55 9 10S9.45 9 10 9 11 9.45 11 10 10.55 11 10 11M13 11C12.45 11 12 10.55 12 10S12.45 9 13 9 14 9.45 14 10 13.55 11 13 11M16 11C15.45 11 15 10.55 15 10S15.45 9 16 9 17 9.45 17 10 16.55 11 16 11Z";
var mdiHeadDotsHorizontalOutline = "M13 3C16.9 3 20 6.1 20 10C20 12.8 18.4 15.2 16 16.3V21H9V18H8C6.9 18 6 17.1 6 16V13H4.5C4.1 13 3.8 12.5 4.1 12.2L6 9.7C6.2 5.9 9.2 3 13 3M13 1C8.4 1 4.6 4.4 4.1 8.9L2.5 11C1.9 11.8 1.9 12.8 2.3 13.6C2.7 14.3 3.3 14.8 4 14.9V16C4 17.9 5.3 19.4 7 19.9V23H18V17.5C20.5 15.8 22 13.1 22 10C22 5 18 1 13 1M10 10C9.4 10 9 9.6 9 9S9.4 8 10 8 11 8.4 11 9 10.6 10 10 10M13 10C12.4 10 12 9.6 12 9S12.4 8 13 8 14 8.4 14 9 13.6 10 13 10M16 10C15.5 10 15 9.6 15 9S15.5 8 16 8 17 8.4 17 9 16.5 10 16 10Z";
var mdiHeadFlash = "M13 3C9.2 3 6.2 6 6 9.7L4.1 12.2C3.9 12.5 4.1 13 4.5 13H6V16C6 17.1 6.9 18 8 18H9V21H16V16.3C18.4 15.2 20 12.8 20 10C20 6.1 16.9 3 13 3M15 9L11.9 15L12.5 11H10.5L12.5 6H15L13.5 9H15Z";
var mdiHeadFlashOutline = "M13 3C16.9 3 20 6.1 20 10C20 12.8 18.4 15.2 16 16.3V21H9V18H8C6.9 18 6 17.1 6 16V13H4.5C4.1 13 3.8 12.5 4.1 12.2L6 9.7C6.2 5.9 9.2 3 13 3M13 1C8.4 1 4.6 4.4 4.1 8.9L2.5 11C1.9 11.8 1.9 12.8 2.3 13.6C2.7 14.3 3.3 14.8 4 14.9V16C4 17.9 5.3 19.4 7 19.9V23H18V17.5C20.5 15.8 22 13.1 22 10C22 5 18 1 13 1M15 9L11.9 15L12.5 11H10.4L12.5 6H15L13.5 9H15Z";
var mdiHeadHeart = "M13 3C9.23 3 6.19 5.95 6 9.66L4.08 12.19C3.84 12.5 4.08 13 4.5 13H6V16C6 17.11 6.89 18 8 18H9V21H16V16.31C18.37 15.19 20 12.8 20 10C20 6.14 16.88 3 13 3M17 8.83C17 10.37 15.64 11.6 13.58 13.47L13 14L12.42 13.47C10.36 11.6 9 10.37 9 8.83C9 7.63 9.96 6.64 11.16 6.63H11.2C11.89 6.63 12.55 6.94 13 7.46C13.45 6.94 14.11 6.63 14.8 6.63C16 6.62 17 7.59 17 8.79V8.83Z";
var mdiHeadHeartOutline = "M13 3C16.88 3 20 6.14 20 10C20 12.8 18.37 15.19 16 16.31V21H9V18H8C6.89 18 6 17.11 6 16V13H4.5C4.08 13 3.84 12.5 4.08 12.19L6 9.66C6.19 5.95 9.23 3 13 3M13 1C8.41 1 4.61 4.42 4.06 8.9L2.5 11L2.47 11L2.45 11.03C1.9 11.79 1.83 12.79 2.26 13.62C2.62 14.31 3.26 14.79 4 14.94V16C4 17.85 5.28 19.42 7 19.87V23H18V17.5C20.5 15.83 22 13.06 22 10C22 5.03 17.96 1 13 1M17 8.83C17 10.37 15.64 11.6 13.58 13.47L13 14L12.42 13.47C10.36 11.6 9 10.37 9 8.83C9 7.63 9.96 6.64 11.16 6.63H11.2C11.89 6.63 12.55 6.94 13 7.46C13.45 6.94 14.11 6.63 14.8 6.63C16 6.62 17 7.59 17 8.79V8.83Z";
var mdiHeadLightbulb = "M13 3C9.23 3 6.19 5.95 6 9.66L4.08 12.19C3.84 12.5 4.08 13 4.5 13H6V16C6 17.11 6.89 18 8 18H9V21H16V16.31C18.37 15.19 20 12.8 20 10C20 6.14 16.88 3 13 3M14 14H12V13H14V14M15.6 9.5C15.34 9.94 14.96 10.32 14.5 10.58V12H11.5V10.58C10.07 9.75 9.57 7.92 10.4 6.5S13.07 4.56 14.5 5.38 16.43 8.05 15.6 9.5Z";
var mdiHeadLightbulbOutline = "M13 3C16.9 3 20 6.1 20 10C20 12.8 18.4 15.2 16 16.3V21H9V18H8C6.9 18 6 17.1 6 16V13H4.5C4.1 13 3.8 12.5 4.1 12.2L6 9.7C6.2 5.9 9.2 3 13 3M13 1C8.4 1 4.6 4.4 4.1 8.9L2.5 11C1.9 11.8 1.9 12.8 2.3 13.6C2.7 14.3 3.3 14.8 4 14.9V16C4 17.9 5.3 19.4 7 19.9V23H18V17.5C20.5 15.8 22 13.1 22 10C22 5 18 1 13 1M14 14H12V13H14V14M15.6 9.5C15.3 9.9 15 10.3 14.5 10.6V12H11.5V10.6C10.1 9.8 9.6 7.9 10.4 6.5S13.1 4.6 14.5 5.4 16.4 8.1 15.6 9.5Z";
var mdiHeadMinus = "M13 3C9.2 3 6.2 5.9 6 9.7L4.1 12.2C3.9 12.5 4.1 13 4.5 13H6V16C6 17.1 6.9 18 8 18H9V21H16V16.3C18.4 15.2 20 12.8 20 10C20 6.1 16.9 3 13 3M17 10H9V8H17V10Z";
var mdiHeadMinusOutline = "M13 3C16.9 3 20 6.1 20 10C20 12.8 18.4 15.2 16 16.3V21H9V18H8C6.9 18 6 17.1 6 16V13H4.5C4.1 13 3.8 12.5 4.1 12.2L6 9.7C6.2 5.9 9.2 3 13 3M13 1C8.4 1 4.6 4.4 4.1 8.9L2.5 11C1.9 11.7 1.8 12.7 2.2 13.6C2.6 14.3 3.2 14.8 4 15V16C4 17.9 5.3 19.4 7 19.9V23H18V17.5C20.5 15.9 22 13.1 22 10C22 5 18 1 13 1M17 10H9V8H17V10Z";
var mdiHeadOutline = "M13 1C8.4 1 4.6 4.4 4.1 8.9L2.5 11C2 11.8 1.9 12.8 2.3 13.6C2.7 14.3 3.3 14.8 4 14.9V16C4 17.8 5.3 19.4 7 19.9V23H18V17.5C20.5 15.8 22 13.1 22 10C22 5 18 1 13 1M16 16.3V21H9V18H8C6.9 18 6 17.1 6 16V13H4.5C4.1 13 3.8 12.5 4.1 12.2L6 9.7C6.2 6 9.2 3 13 3C16.9 3 20 6.1 20 10C20 12.8 18.4 15.2 16 16.3Z";
var mdiHeadPlus = "M13 3C9.2 3 6.2 5.9 6 9.7L4.1 12.2C3.9 12.5 4.1 13 4.5 13H6V16C6 17.1 6.9 18 8 18H9V21H16V16.3C18.4 15.2 20 12.8 20 10C20 6.1 16.9 3 13 3M17 10H14V13H12V10H9V8H12V5H14V8H17V10Z";
var mdiHeadPlusOutline = "M13 3C16.9 3 20 6.1 20 10C20 12.8 18.4 15.2 16 16.3V21H9V18H8C6.9 18 6 17.1 6 16V13H4.5C4.1 13 3.8 12.5 4.1 12.2L6 9.7C6.2 5.9 9.2 3 13 3M13 1C8.4 1 4.6 4.4 4.1 8.9L2.5 11C1.9 11.7 1.8 12.7 2.2 13.6C2.6 14.3 3.2 14.8 4 15V16C4 17.9 5.3 19.4 7 19.9V23H18V17.5C20.5 15.9 22 13.1 22 10C22 5 18 1 13 1M17 10H14V13H12V10H9V8H12V5H14V8H17V10Z";
var mdiHeadQuestion = "M13 3C9.23 3 6.19 5.95 6 9.66L4.08 12.19C3.84 12.5 4.08 13 4.5 13H6V16C6 17.11 6.89 18 8 18H9V21H16V16.31C18.37 15.19 20 12.8 20 10C20 6.14 16.88 3 13 3M14 14H12V12H14V14M15.75 8.81C15.46 9.21 15.09 9.5 14.64 9.74C14.39 9.9 14.22 10.07 14.13 10.26C14.04 10.44 14 10.69 14 11H12C12 10.5 12.11 10.08 12.31 9.82C12.5 9.55 12.85 9.25 13.36 8.91C13.62 8.75 13.83 8.55 13.97 8.32C14.13 8.09 14.2 7.82 14.2 7.5C14.2 7.2 14.12 6.94 13.94 6.75C13.76 6.57 13.5 6.47 13.19 6.47C12.93 6.47 12.71 6.55 12.53 6.7C12.35 6.86 12.26 7.09 12.25 7.39H10.32L10.31 7.36C10.3 6.57 10.56 6 11.08 5.59C11.62 5.2 12.32 5 13.19 5C14.12 5 14.85 5.23 15.38 5.68C15.92 6.13 16.19 6.74 16.19 7.5C16.19 8 16.04 8.41 15.75 8.81Z";
var mdiHeadQuestionOutline = "M13 3C16.88 3 20 6.14 20 10C20 12.8 18.37 15.19 16 16.31V21H9V18H8C6.89 18 6 17.11 6 16V13H4.5C4.08 13 3.84 12.5 4.08 12.19L6 9.66C6.19 5.95 9.23 3 13 3M10.32 7.39H12.25C12.26 7.09 12.35 6.86 12.53 6.7C12.71 6.55 12.93 6.47 13.19 6.47C13.5 6.47 13.76 6.57 13.94 6.75C14.12 6.94 14.2 7.2 14.2 7.5C14.2 7.82 14.13 8.09 13.97 8.32C13.83 8.55 13.62 8.75 13.36 8.91C12.85 9.25 12.5 9.55 12.31 9.82C12.11 10.08 12 10.5 12 11H14C14 10.69 14.04 10.44 14.13 10.26C14.22 10.07 14.39 9.9 14.64 9.74C15.09 9.5 15.46 9.21 15.75 8.81C16.04 8.41 16.19 8 16.19 7.5C16.19 6.74 15.92 6.13 15.38 5.68C14.85 5.23 14.12 5 13.19 5C12.32 5 11.62 5.2 11.08 5.59C10.56 6 10.3 6.57 10.31 7.36L10.32 7.39M12 14H14V12H12V14M13 1C8.41 1 4.61 4.42 4.06 8.9L2.5 11L2.47 11L2.45 11.03C1.9 11.79 1.83 12.79 2.26 13.62C2.62 14.31 3.26 14.79 4 14.94V16C4 17.85 5.28 19.42 7 19.87V23H18V17.5C20.5 15.83 22 13.06 22 10C22 5.03 17.96 1 13 1Z";
var mdiHeadRemove = "M13 3C9.2 3 6.2 5.9 6 9.7L4.1 12.2C3.9 12.5 4.1 13 4.5 13H6V16C6 17.1 6.9 18 8 18H9V21H16V16.3C18.4 15.2 20 12.8 20 10C20 6.1 16.9 3 13 3M15.1 12.5L13 10.4L10.9 12.5L9.5 11.1L11.6 9L9.5 6.9L10.9 5.5L13 7.6L15.1 5.5L16.5 6.9L14.4 9L16.5 11.1L15.1 12.5Z";
var mdiHeadRemoveOutline = "M13 3C16.9 3 20 6.1 20 10C20 12.8 18.4 15.2 16 16.3V21H9V18H8C6.9 18 6 17.1 6 16V13H4.5C4.1 13 3.8 12.5 4.1 12.2L6 9.7C6.2 5.9 9.2 3 13 3M13 1C8.4 1 4.6 4.4 4.1 8.9L2.5 11C1.9 11.7 1.8 12.7 2.2 13.6C2.6 14.3 3.2 14.8 4 15V16C4 17.9 5.3 19.4 7 19.9V23H18V17.5C20.5 15.9 22 13.1 22 10C22 5 18 1 13 1M16.5 6.9L14.4 9L16.5 11.1L15.1 12.5L13 10.4L10.9 12.5L9.5 11.1L11.6 9L9.5 6.9L10.9 5.5L13 7.6L15.1 5.5L16.5 6.9Z";
var mdiHeadSnowflake = "M13 3C9.23 3 6.19 5.95 6 9.66L4.08 12.19C3.84 12.5 4.08 13 4.5 13H6V16C6 17.11 6.89 18 8 18H9V21H16V16.31C18.37 15.19 20 12.8 20 10C20 6.14 16.88 3 13 3M17.06 9.57L15.1 10.09L16.54 11.54C16.89 11.88 16.89 12.46 16.54 12.81C16.19 13.16 15.61 13.16 15.27 12.81L13.81 11.37L13.3 13.33C13.18 13.82 12.68 14.1 12.21 13.97C11.72 13.84 11.44 13.35 11.57 12.87L12.1 10.9L10.13 11.43C9.65 11.56 9.15 11.28 9.03 10.79C8.9 10.32 9.18 9.82 9.67 9.7L11.63 9.19L10.19 7.73C9.84 7.39 9.84 6.82 10.19 6.46C10.54 6.11 11.12 6.11 11.46 6.46L12.91 7.9L13.43 5.94C13.55 5.46 14.04 5.18 14.5 5.3C15 5.43 15.28 5.92 15.16 6.41L14.63 8.37L16.59 7.84C17.08 7.72 17.57 8 17.7 8.5C17.82 8.96 17.54 9.45 17.06 9.57Z";
var mdiHeadSnowflakeOutline = "M13 3C16.88 3 20 6.14 20 10C20 12.8 18.37 15.19 16 16.31V21H9V18H8C6.89 18 6 17.11 6 16V13H4.5C4.08 13 3.84 12.5 4.08 12.19L6 9.66C6.19 5.95 9.23 3 13 3M13 1C8.41 1 4.61 4.42 4.06 8.9L2.5 11L2.47 11L2.45 11.03C1.9 11.79 1.83 12.79 2.26 13.62C2.62 14.31 3.26 14.79 4 14.94V16C4 17.85 5.28 19.42 7 19.87V23H18V17.5C20.5 15.83 22 13.06 22 10C22 5.03 17.96 1 13 1M17.33 9.3L15.37 9.81L16.81 11.27C17.16 11.61 17.16 12.19 16.81 12.54S15.88 12.89 15.54 12.54L14.09 11.1L13.57 13.06C13.45 13.55 12.96 13.82 12.5 13.7C12 13.57 11.72 13.08 11.84 12.59L12.37 10.63L10.41 11.16C9.92 11.28 9.43 11 9.3 10.5C9.18 10.05 9.46 9.55 9.94 9.43L11.9 8.91L10.46 7.46C10.11 7.12 10.11 6.55 10.46 6.19C10.81 5.84 11.39 5.84 11.73 6.19L13.19 7.63L13.7 5.67C13.82 5.18 14.32 4.9 14.79 5.03C15.28 5.16 15.56 5.65 15.43 6.13L14.9 8.1L16.87 7.57C17.35 7.44 17.84 7.72 17.97 8.21C18.1 8.68 17.82 9.18 17.33 9.3Z";
var mdiHeadSync = "M13 3C9.23 3 6.19 5.95 6 9.66L4.08 12.19C3.84 12.5 4.08 13 4.5 13H6V16C6 17.11 6.89 18 8 18H9V21H16V16.31C18.37 15.19 20 12.8 20 10C20 6.14 16.88 3 13 3M13 15V13.5C10.79 13.5 9 11.71 9 9.5C9 8.68 9.25 7.92 9.67 7.29L10.76 8.38C10.59 8.72 10.5 9.1 10.5 9.5C10.5 10.88 11.62 12 13 12V10.5L15.25 12.75L13 15M16.33 11.71L15.24 10.62C15.41 10.28 15.5 9.9 15.5 9.5C15.5 8.12 14.38 7 13 7V8.5L10.75 6.25L13 4V5.5C15.21 5.5 17 7.29 17 9.5C17 10.32 16.75 11.08 16.33 11.71Z";
var mdiHeadSyncOutline = "M13 3C16.88 3 20 6.14 20 10C20 12.8 18.37 15.19 16 16.31V21H9V18H8C6.89 18 6 17.11 6 16V13H4.5C4.08 13 3.84 12.5 4.08 12.19L6 9.66C6.19 5.95 9.23 3 13 3M13 1C8.41 1 4.61 4.42 4.06 8.9L2.5 11L2.47 11L2.45 11.03C1.9 11.79 1.83 12.79 2.26 13.62C2.62 14.31 3.26 14.79 4 14.94V16C4 17.85 5.28 19.42 7 19.87V23H18V17.5C20.5 15.83 22 13.06 22 10C22 5.03 17.96 1 13 1M14 15V13.5C11.79 13.5 10 11.71 10 9.5C10 8.68 10.25 7.92 10.67 7.29L11.76 8.38C11.59 8.72 11.5 9.1 11.5 9.5C11.5 10.88 12.62 12 14 12V10.5L16.25 12.75L14 15M17.33 11.71L16.24 10.62C16.41 10.28 16.5 9.9 16.5 9.5C16.5 8.12 15.38 7 14 7V8.5L11.75 6.25L14 4V5.5C16.21 5.5 18 7.29 18 9.5C18 10.32 17.75 11.08 17.33 11.71Z";
var mdiHeadphones = "M12,1C7,1 3,5 3,10V17A3,3 0 0,0 6,20H9V12H5V10A7,7 0 0,1 12,3A7,7 0 0,1 19,10V12H15V20H18A3,3 0 0,0 21,17V10C21,5 16.97,1 12,1Z";
var mdiHeadphonesBluetooth = "M8,6A6,6 0 0,0 2,12V16.8C2,17.46 2.54,18 3.2,18H6V14H4V12A4,4 0 0,1 8,8A4,4 0 0,1 12,12V14H10V18H12.8A1.2,1.2 0 0,0 14,16.8V12A6,6 0 0,0 8,6M19,7V10.79L16.71,8.5L16,9.21L18.79,12L16,14.79L16.71,15.5L19,13.21V17H19.5L22.35,14.14L20.21,12L22.35,9.85L19.5,7H19M20,8.91L20.94,9.85L20,10.79V8.91M20,13.21L20.94,14.14L20,15.08V13.21Z";
var mdiHeadphonesBox = "M7.2,18C6.54,18 6,17.46 6,16.8V13.2L6,12A6,6 0 0,1 12,6A6,6 0 0,1 18,12V13.2L18,16.8A1.2,1.2 0 0,1 16.8,18H14V14H16V12A4,4 0 0,0 12,8A4,4 0 0,0 8,12V14H10V18M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiHeadphonesOff = "M12,1A9,9 0 0,1 21,10V17C21,17.62 20.81,18.19 20.5,18.67L15,13.18V12H19V10A7,7 0 0,0 12,3C10,3 8.23,3.82 6.96,5.14L5.55,3.72C7.18,2.04 9.47,1 12,1M2.78,3.5L20.5,21.22L19.23,22.5L16.73,20H15V18.27L9,12.27V20H6A3,3 0 0,1 3,17V10C3,8.89 3.2,7.82 3.57,6.84L1.5,4.77L2.78,3.5M5.17,8.44C5.06,8.94 5,9.46 5,10V12H8.73L5.17,8.44Z";
var mdiHeadphonesSettings = "M12,1A9,9 0 0,1 21,10V17A3,3 0 0,1 18,20H15V12H19V10A7,7 0 0,0 12,3A7,7 0 0,0 5,10V12H9V20H6A3,3 0 0,1 3,17V10A9,9 0 0,1 12,1M15,24V22H17V24H15M11,24V22H13V24H11M7,24V22H9V24H7Z";
var mdiHeadset = "M12,1C7,1 3,5 3,10V17A3,3 0 0,0 6,20H9V12H5V10A7,7 0 0,1 12,3A7,7 0 0,1 19,10V12H15V20H19V21H12V23H18A3,3 0 0,0 21,20V10C21,5 16.97,1 12,1Z";
var mdiHeadsetDock = "M2,18H9V6.13C7.27,6.57 6,8.14 6,10V11H8V17H6A2,2 0 0,1 4,15V10A6,6 0 0,1 10,4H11A6,6 0 0,1 17,10V12H18V9H20V12A2,2 0 0,1 18,14H17V15A2,2 0 0,1 15,17H13V11H15V10C15,8.14 13.73,6.57 12,6.13V18H22V20H2V18Z";
var mdiHeadsetOff = "M1.5,4.77L3.57,6.84C3.2,7.82 3,8.89 3,10V20A3,3 0 0,0 6,23H12V21H5V20H9V12.27L15,18.27V20H16.73L19.23,22.5L20.5,21.22L2.78,3.5L1.5,4.77M12,1C9.47,1 7.18,2.04 5.55,3.72L6.96,5.14C8.23,3.82 10,3 12,3A7,7 0 0,1 19,10V12H15V13.18L20.5,18.67C20.81,18.19 21,17.62 21,17V10A9,9 0 0,0 12,1M5,12V10C5,9.46 5.06,8.94 5.17,8.44L8.73,12H5Z";
var mdiHeart = "M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z";
var mdiHeartBox = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M12,17L12.72,16.34C15.3,14 17,12.46 17,10.57C17,9.03 15.79,7.82 14.25,7.82C13.38,7.82 12.55,8.23 12,8.87C11.45,8.23 10.62,7.82 9.75,7.82C8.21,7.82 7,9.03 7,10.57C7,12.46 8.7,14 11.28,16.34L12,17Z";
var mdiHeartBoxOutline = "M12,17L11.28,16.34C8.7,14 7,12.46 7,10.57C7,9.03 8.21,7.82 9.75,7.82C10.62,7.82 11.45,8.23 12,8.87C12.55,8.23 13.38,7.82 14.25,7.82C15.79,7.82 17,9.03 17,10.57C17,12.46 15.3,14 12.72,16.34L12,17M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5Z";
var mdiHeartBroken = "M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C8.17,3 8.82,3.12 9.44,3.33L13,9.35L9,14.35L12,21.35V21.35M16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35L11,14.35L15.5,9.35L12.85,4.27C13.87,3.47 15.17,3 16.5,3Z";
var mdiHeartBrokenOutline = "M7.5,5C7.7,5 7.9,5 8.1,5.1L10.5,9.2L6.8,13.8C5.1,11.8 4,10.2 4,8.5C4,6.5 5.5,5 7.5,5M7.5,3C4.4,3 2,5.4 2,8.5C2,12.3 5.4,15.4 10.6,20L12,21.3L9,14.3L13,9.3L9.4,3.3C8.8,3.1 8.2,3 7.5,3M16.5,5C18.5,5 20,6.5 20,8.5C20,11.1 17.4,13.7 13.4,17.3L13.1,15L17.9,9.7L15.6,5.2C15.9,5 16.2,5 16.5,5M16.5,3C15.2,3 13.9,3.5 12.9,4.3L15.5,9.4L11,14.4L12,21.4L13.4,20.1C18.6,15.4 22,12.3 22,8.6C22,5.4 19.6,3 16.5,3Z";
var mdiHeartCircle = "M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M9.75,7.82C10.62,7.82 11.45,8.23 12,8.87C12.55,8.23 13.38,7.82 14.25,7.82C15.79,7.82 17,9.03 17,10.57C17,12.46 15.3,14 12.72,16.34L12,17L11.28,16.34C8.7,14 7,12.46 7,10.57C7,9.03 8.21,7.82 9.75,7.82Z";
var mdiHeartCircleOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M9.75,7.82C8.21,7.82 7,9.03 7,10.57C7,12.46 8.7,14 11.28,16.34L12,17L12.72,16.34C15.3,14 17,12.46 17,10.57C17,9.03 15.79,7.82 14.25,7.82C13.38,7.82 12.55,8.23 12,8.87C11.45,8.23 10.62,7.82 9.75,7.82Z";
var mdiHeartCog = "M12 19C12 19.71 12.12 20.4 12.32 21.06L12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 9.8 21.59 11 20.84 12.25C20.25 12.09 19.63 12 19 12C15.14 12 12 15.14 12 19M23.83 20.64L22.83 22.37C22.76 22.5 22.63 22.5 22.5 22.5L21.27 22C21 22.18 20.73 22.34 20.43 22.47L20.24 23.79C20.22 23.91 20.11 24 20 24H18C17.86 24 17.76 23.91 17.74 23.79L17.55 22.47C17.24 22.35 16.96 22.18 16.7 22L15.46 22.5C15.34 22.5 15.21 22.5 15.15 22.37L14.15 20.64C14.09 20.53 14.12 20.4 14.21 20.32L15.27 19.5C15.25 19.33 15.24 19.17 15.24 19S15.25 18.67 15.27 18.5L14.21 17.68C14.11 17.6 14.09 17.47 14.15 17.36L15.15 15.63C15.22 15.5 15.35 15.5 15.46 15.5L16.7 16C16.96 15.82 17.25 15.66 17.55 15.53L17.74 14.21C17.76 14.09 17.87 14 18 14H20C20.11 14 20.22 14.09 20.23 14.21L20.42 15.53C20.73 15.65 21 15.82 21.27 16L22.5 15.5C22.63 15.5 22.76 15.5 22.82 15.63L23.82 17.36C23.88 17.47 23.85 17.6 23.76 17.68L22.7 18.5C22.73 18.67 22.74 18.83 22.74 19S22.72 19.33 22.7 19.5L23.77 20.32C23.86 20.4 23.89 20.53 23.83 20.64M20.5 19C20.5 18.17 19.83 17.5 19 17.5S17.5 18.17 17.5 19 18.16 20.5 19 20.5C19.83 20.5 20.5 19.83 20.5 19Z";
var mdiHeartCogOutline = "M16.5 5C14.96 5 13.46 6 12.93 7.36H11.07C10.54 6 9.04 5 7.5 5C5.5 5 4 6.5 4 8.5C4 11.39 7.14 14.24 11.89 18.55L12 18.65L12 18.63C12 18.75 12 18.88 12 19C12 19.71 12.12 20.4 12.32 21.06L12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 9.8 21.59 11 20.84 12.25C20.25 12.09 19.63 12 19 12C18.87 12 18.74 12 18.6 12C19.5 10.79 20 9.65 20 8.5C20 6.5 18.5 5 16.5 5M23.83 20.64L22.83 22.37C22.76 22.5 22.63 22.5 22.5 22.5L21.27 22C21 22.18 20.73 22.34 20.43 22.47L20.24 23.79C20.22 23.91 20.11 24 20 24H18C17.86 24 17.76 23.91 17.74 23.79L17.55 22.47C17.24 22.35 16.96 22.18 16.7 22L15.46 22.5C15.34 22.5 15.21 22.5 15.15 22.37L14.15 20.64C14.09 20.53 14.12 20.4 14.21 20.32L15.27 19.5C15.25 19.33 15.24 19.17 15.24 19S15.25 18.67 15.27 18.5L14.21 17.68C14.11 17.6 14.09 17.47 14.15 17.36L15.15 15.63C15.22 15.5 15.35 15.5 15.46 15.5L16.7 16C16.96 15.82 17.25 15.66 17.55 15.53L17.74 14.21C17.76 14.09 17.87 14 18 14H20C20.11 14 20.22 14.09 20.23 14.21L20.42 15.53C20.73 15.65 21 15.82 21.27 16L22.5 15.5C22.63 15.5 22.76 15.5 22.82 15.63L23.82 17.36C23.88 17.47 23.85 17.6 23.76 17.68L22.7 18.5C22.73 18.67 22.74 18.83 22.74 19S22.72 19.33 22.7 19.5L23.77 20.32C23.86 20.4 23.89 20.53 23.83 20.64M20.5 19C20.5 18.17 19.83 17.5 19 17.5S17.5 18.17 17.5 19 18.16 20.5 19 20.5C19.83 20.5 20.5 19.83 20.5 19Z";
var mdiHeartFlash = "M16.5,2.83C14.76,2.83 13.09,3.64 12,4.9C10.91,3.64 9.24,2.83 7.5,2.83C4.42,2.83 2,5.24 2,8.33C2,12.1 5.4,15.19 10.55,19.86L12,21.17L13.45,19.86C18.6,15.19 22,12.1 22,8.33C22,5.24 19.58,2.83 16.5,2.83M12,17.83V13.83H9L12,6.83V10.83H15";
var mdiHeartHalf = "M13,7.2V17.74L13,20.44L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C10,3 13,5 13,7.2Z";
var mdiHeartHalfFull = "M16.5,5C15,5 13.58,5.91 13,7.2V17.74C17.25,13.87 20,11.2 20,8.5C20,6.5 18.5,5 16.5,5M16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3Z";
var mdiHeartHalfOutline = "M4,8.5C4,11.2 6.75,13.87 11,17.74V7.2C10.42,5.91 9,5 7.5,5C5.5,5 4,6.5 4,8.5M13,7.2V17.74L13,20.44L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C10,3 13,5 13,7.2Z";
var mdiHeartMinus = "M12 18C12 19 12.25 19.92 12.67 20.74L12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 9.93 21.5 11.26 20.62 12.61C19.83 12.23 18.94 12 18 12C14.69 12 12 14.69 12 18M14 17V19H22V17H14Z";
var mdiHeartMinusOutline = "M12.67 20.74L12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 9.93 21.5 11.26 20.62 12.61C20 12.31 19.31 12.11 18.59 12.04C19.5 10.8 20 9.65 20 8.5C20 6.5 18.5 5 16.5 5C14.96 5 13.46 6 12.93 7.36H11.07C10.54 6 9.04 5 7.5 5C5.5 5 4 6.5 4 8.5C4 11.39 7.14 14.24 11.89 18.55L12 18.65L12.04 18.61C12.12 19.37 12.34 20.09 12.67 20.74M14 17V19H22V17H14Z";
var mdiHeartMultiple = "M13.5,20C6.9,13.9 3.5,10.8 3.5,7.1C3.5,4 5.9,1.6 9,1.6C10.7,1.6 12.4,2.4 13.5,3.7C14.6,2.4 16.3,1.6 18,1.6C21.1,1.6 23.5,4 23.5,7.1C23.5,10.9 20.1,14 13.5,20M12,21.1C5.4,15.2 1.5,11.7 1.5,7C1.5,6.8 1.5,6.6 1.5,6.4C0.9,7.3 0.5,8.4 0.5,9.6C0.5,13.4 3.9,16.5 10.5,22.4L12,21.1Z";
var mdiHeartMultipleOutline = "M12,21.1L10.5,22.4C3.9,16.5 0.5,13.4 0.5,9.6C0.5,8.4 0.9,7.3 1.5,6.4C1.5,6.6 1.5,6.8 1.5,7C1.5,11.7 5.4,15.2 12,21.1M13.6,17C18.3,12.7 21.5,9.9 21.6,7C21.6,5 20.1,3.5 18.1,3.5C16.5,3.5 15,4.5 14.5,5.9H12.6C12,4.5 10.5,3.5 9,3.5C7,3.5 5.5,5 5.5,7C5.5,9.9 8.6,12.7 13.4,17L13.5,17.1M18,1.5C21.1,1.5 23.5,3.9 23.5,7C23.5,10.7 20.1,13.8 13.5,19.8C6.9,13.9 3.5,10.8 3.5,7C3.5,3.9 5.9,1.5 9,1.5C10.7,1.5 12.4,2.3 13.5,3.6C14.6,2.3 16.3,1.5 18,1.5Z";
var mdiHeartOff = "M1,4.27L2.28,3L20,20.72L18.73,22L15.18,18.44L13.45,20.03L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,7.55 2.23,6.67 2.63,5.9L1,4.27M7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,11.07 20.42,13.32 17.79,15.97L5.27,3.45C5.95,3.16 6.7,3 7.5,3Z";
var mdiHeartOffOutline = "M2.39 1.73L1.11 3L3.19 5.08C2.45 6 2 7.19 2 8.5C2 12.27 5.4 15.36 10.55 20.03L12 21.35L13.45 20.03C14.32 19.24 15.14 18.5 15.9 17.79L20 22L21.27 20.73M12.1 18.55L12 18.65L11.89 18.55C7.14 14.24 4 11.39 4 8.5C4 7.74 4.22 7.06 4.61 6.5L14.5 16.37C13.74 17.06 12.95 17.78 12.1 18.55M8.3 5.1L6.33 3.13C6.7 3.05 7.1 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 10.84 20.69 12.92 18.47 15.27L17.06 13.86C18.91 11.88 20 10.2 20 8.5C20 6.5 18.5 5 16.5 5C15.1 5 13.74 5.83 13.11 7H10.89C10.38 6.06 9.39 5.34 8.3 5.1Z";
var mdiHeartOutline = "M12.1,18.55L12,18.65L11.89,18.55C7.14,14.24 4,11.39 4,8.5C4,6.5 5.5,5 7.5,5C9.04,5 10.54,6 11.07,7.36H12.93C13.46,6 14.96,5 16.5,5C18.5,5 20,6.5 20,8.5C20,11.39 16.86,14.24 12.1,18.55M16.5,3C14.76,3 13.09,3.81 12,5.08C10.91,3.81 9.24,3 7.5,3C4.42,3 2,5.41 2,8.5C2,12.27 5.4,15.36 10.55,20.03L12,21.35L13.45,20.03C18.6,15.36 22,12.27 22,8.5C22,5.41 19.58,3 16.5,3Z";
var mdiHeartPlus = "M12 18C12 19 12.25 19.92 12.67 20.74L12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 9.93 21.5 11.26 20.62 12.61C19.83 12.23 18.94 12 18 12C14.69 12 12 14.69 12 18M19 14H17V17H14V19H17V22H19V19H22V17H19V14Z";
var mdiHeartPlusOutline = "M12.67 20.74L12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 9.93 21.5 11.26 20.62 12.61C20 12.31 19.31 12.11 18.59 12.04C19.5 10.8 20 9.65 20 8.5C20 6.5 18.5 5 16.5 5C14.96 5 13.46 6 12.93 7.36H11.07C10.54 6 9.04 5 7.5 5C5.5 5 4 6.5 4 8.5C4 11.39 7.14 14.24 11.89 18.55L12 18.65L12.04 18.61C12.12 19.37 12.34 20.09 12.67 20.74M17 14V17H14V19H17V22H19V19H22V17H19V14H17Z";
var mdiHeartPulse = "M7.5,4A5.5,5.5 0 0,0 2,9.5C2,10 2.09,10.5 2.22,11H6.3L7.57,7.63C7.87,6.83 9.05,6.75 9.43,7.63L11.5,13L12.09,11.58C12.22,11.25 12.57,11 13,11H21.78C21.91,10.5 22,10 22,9.5A5.5,5.5 0 0,0 16.5,4C14.64,4 13,4.93 12,6.34C11,4.93 9.36,4 7.5,4V4M3,12.5A1,1 0 0,0 2,13.5A1,1 0 0,0 3,14.5H5.44L11,20C12,20.9 12,20.9 13,20L18.56,14.5H21A1,1 0 0,0 22,13.5A1,1 0 0,0 21,12.5H13.4L12.47,14.8C12.07,15.81 10.92,15.67 10.55,14.83L8.5,9.5L7.54,11.83C7.39,12.21 7.05,12.5 6.6,12.5H3Z";
var mdiHeartRemove = "M12 18C12 19 12.25 19.92 12.67 20.74L12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 9.93 21.5 11.26 20.62 12.61C19.83 12.23 18.94 12 18 12C14.69 12 12 14.69 12 18M21.54 15.88L20.12 14.47L18 16.59L15.88 14.47L14.47 15.88L16.59 18L14.47 20.12L15.88 21.54L18 19.41L20.12 21.54L21.54 20.12L19.41 18L21.54 15.88Z";
var mdiHeartRemoveOutline = "M12.67 20.74L12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 9.93 21.5 11.26 20.62 12.61C20 12.31 19.31 12.11 18.59 12.04C19.5 10.8 20 9.65 20 8.5C20 6.5 18.5 5 16.5 5C14.96 5 13.46 6 12.93 7.36H11.07C10.54 6 9.04 5 7.5 5C5.5 5 4 6.5 4 8.5C4 11.39 7.14 14.24 11.89 18.55L12 18.65L12.04 18.61C12.12 19.37 12.34 20.09 12.67 20.74M20.12 14.46L18 16.59L15.88 14.47L14.47 15.88L16.59 18L14.47 20.12L15.88 21.54L18 19.41L20.12 21.54L21.54 20.12L19.41 18L21.54 15.88L20.12 14.46Z";
var mdiHeartSearch = "M19.3 14.9C19.7 14.2 20 13.4 20 12.5C20 10 18 8 15.5 8S11 10 11 12.5 13 17 15.5 17C16.4 17 17.2 16.7 17.9 16.3L20.8 19.2L22.2 17.8L19.3 14.9M15.5 15C14.1 15 13 13.9 13 12.5S14.1 10 15.5 10 18 11.1 18 12.5 16.9 15 15.5 15M14.7 18.9C14.3 19.3 13.9 19.6 13.5 20L12 21.3L10.5 20C5.4 15.4 2 12.3 2 8.5C2 5.4 4.4 3 7.5 3C9.2 3 10.9 3.8 12 5.1C13.1 3.8 14.8 3 16.5 3C19.6 3 22 5.4 22 8.5C22 9.2 21.9 9.8 21.7 10.5C20.8 7.9 18.4 6 15.5 6C11.9 6 9 8.9 9 12.5C9 15.8 11.5 18.5 14.7 18.9Z";
var mdiHeartSettings = "M15 22H17V24H15V22M11 24H13V22H11V24M7 24H9V22H7V24M16.5 3C14.76 3 13.09 3.81 12 5.08C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.41 2 8.5C2 12.27 5.4 15.36 10.55 20.03L12 21.35L13.45 20.03C18.6 15.36 22 12.27 22 8.5C22 5.41 19.58 3 16.5 3Z";
var mdiHeartSettingsOutline = "M7 22H9V24H7V22M11 24H13V22H11V24M15 24H17V22H15V24M22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5M20 8.5C20 6.5 18.5 5 16.5 5C14.96 5 13.46 6 12.93 7.36H11.07C10.54 6 9.04 5 7.5 5C5.5 5 4 6.5 4 8.5C4 11.39 7.14 14.24 11.89 18.55L12 18.65L12.1 18.55C16.86 14.24 20 11.39 20 8.5Z";
var mdiHeatPump = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M12.75 7.08C13.57 7.2 14.32 7.5 14.95 8L12.75 10.19V7.08M11.25 7.08V10.19L9.05 8C9.68 7.5 10.43 7.2 11.25 7.08M8 9.05L10.19 11.25H7.08C7.2 10.43 7.5 9.68 8 9.05M7.08 12.75H10.19L8 14.95C7.5 14.32 7.2 13.57 7.08 12.75M11.25 16.92C10.43 16.8 9.68 16.5 9.05 16L11.25 13.81V16.92M12 13C11.45 13 11 12.55 11 12S11.45 11 12 11 13 11.45 13 12 12.55 13 12 13M12.75 16.92V13.81L14.95 16C14.32 16.5 13.57 16.8 12.75 16.92M16 14.95L13.81 12.75H16.92C16.8 13.57 16.5 14.32 16 14.95M13.81 11.25L16 9.05C16.5 9.69 16.8 10.44 16.92 11.25H13.81Z";
var mdiHeatPumpOutline = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V5H19V19M12 18C15.31 18 18 15.31 18 12S15.31 6 12 6 6 8.69 6 12 8.69 18 12 18M11.25 15.92C10.7 15.82 10.2 15.6 9.75 15.3L11.25 13.8V15.92M12.75 15.92V13.81L14.25 15.31C13.8 15.61 13.3 15.82 12.75 15.92M15.31 14.25L13.81 12.75H15.92C15.82 13.3 15.61 13.8 15.31 14.25M15.92 11.25H13.81L15.31 9.75C15.61 10.2 15.82 10.7 15.92 11.25M12.75 8.08C13.3 8.18 13.8 8.4 14.25 8.7L12.75 10.2V8.08M12 11C12.55 11 13 11.45 13 12S12.55 13 12 13 11 12.55 11 12 11.45 11 12 11M11.25 8.08V10.19L9.75 8.69C10.2 8.39 10.7 8.18 11.25 8.08M8.69 9.75L10.19 11.25H8.08C8.18 10.7 8.39 10.2 8.69 9.75M10.19 12.75L8.69 14.25C8.39 13.81 8.18 13.3 8.07 12.75H10.19Z";
var mdiHeatWave = "M8.5 4.5L5.4 9.5L8.5 14.7L5.2 20.5L3.4 19.6L6.1 14.7L3 9.5L6.7 3.6L8.5 4.5M14.7 4.4L11.6 9.5L14.7 14.5L11.4 20.3L9.6 19.4L12.3 14.5L9.2 9.5L12.9 3.5L14.7 4.4M21 4.4L17.9 9.5L21 14.5L17.7 20.3L15.9 19.4L18.6 14.5L15.5 9.5L19.2 3.5L21 4.4";
var mdiHeatingCoil = "M19 17C20.21 17 22 16.2 22 14S20.21 11 19 11H17V9H19C21.2 9 22 7.21 22 6C22 3.8 20.21 3 19 3H17V2H16V3H8V2H7V3H2V5H7V7H5C3.79 7 2 7.8 2 10S3.79 13 5 13H7V15H5C3.79 15 2 15.8 2 18S3.79 21 5 21H7V22H8V21H16V22H17V21H22V19H17V17H19M19 13C19.45 13 20 13.19 20 14S19.45 15 19 15H17V13H19M16 11H8V9H16V11M19 5C19.45 5 20 5.2 20 6C20 6.45 19.81 7 19 7H17V5H19M8 5H16V7H8V5M5 11C4.55 11 4 10.81 4 10S4.55 9 5 9H7V11H5M8 13H16V15H8V13M5 19C4.55 19 4 18.81 4 18S4.55 17 5 17H7V19H5M16 19H8V17H16V19Z";
var mdiHelicopter = "M3,3H17V5H3V3M23,6V10.5L14.75,12.2C14.91,12.6 15,13.04 15,13.5C15,14.9 14.18,16.1 13,16.66V17L13,19H16V21H4A3,3 0 0,1 1,18V17H3V18A1,1 0 0,0 4,19H5V16.74C3.25,16.13 2,14.46 2,12.5C2,10 4,8 6.5,8H9V6H11V8H21V6H23M11,19V17H7V19H11M7.5,10C6.12,10 5,10.9 5,12C5,13.1 6.12,14 7.5,14C8.88,14 10,13.1 10,12C10,10.9 8.88,10 7.5,10Z";
var mdiHelp = "M10,19H13V22H10V19M12,2C17.35,2.22 19.68,7.62 16.5,11.67C15.67,12.67 14.33,13.33 13.67,14.17C13,15 13,16 13,17H10C10,15.33 10,13.92 10.67,12.92C11.33,11.92 12.67,11.33 13.5,10.67C15.92,8.43 15.32,5.26 12,5A3,3 0 0,0 9,8H6A6,6 0 0,1 12,2Z";
var mdiHelpBox = "M11,18H13V16H11V18M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z";
var mdiHelpBoxMultiple = "M16 20V22H4C2.9 22 2 21.1 2 20V7H4V20H16M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M15 14H13V12H15V14M16.8 8.8C16.5 9.2 16.1 9.5 15.7 9.7C15.5 9.9 15.3 10 15.2 10.2C15 10.4 15 10.7 15 11H13C13 10.5 13.1 10.1 13.3 9.8C13.5 9.5 13.8 9.2 14.3 8.9C14.6 8.7 14.8 8.5 14.9 8.3C15.1 8.1 15.1 7.8 15.1 7.5C15.1 7.2 15 6.9 14.8 6.7C14.6 6.5 14.4 6.4 14 6.4C13.7 6.4 13.5 6.5 13.3 6.6C13.1 6.8 13 7 13 7.3H11.1C11.1 6.5 11.3 5.9 11.9 5.5C12.6 5.2 13.3 5 14.2 5C15.1 5 15.9 5.2 16.4 5.7C16.9 6.2 17.2 6.8 17.2 7.5C17.2 8 17 8.4 16.8 8.8Z";
var mdiHelpBoxMultipleOutline = "M20 16V4H8V16H20M22 16C22 17.1 21.1 18 20 18H8C6.9 18 6 17.1 6 16V4C6 2.9 6.9 2 8 2H20C21.1 2 22 2.9 22 4V16M16 20V22H4C2.9 22 2 21.1 2 20V7H4V20H16M14.2 5C13.3 5 12.6 5.2 12.1 5.6C11.6 6 11.3 6.6 11.3 7.4H13.2C13.2 7.1 13.3 6.9 13.5 6.7C13.7 6.6 13.9 6.5 14.2 6.5C14.5 6.5 14.8 6.6 15 6.8C15.2 7 15.3 7.2 15.3 7.6C15.3 7.9 15.2 8.2 15.1 8.4C15 8.6 14.7 8.8 14.5 9C14 9.3 13.6 9.6 13.5 9.9C13.1 10.1 13 10.5 13 11H15C15 10.7 15 10.4 15.1 10.3C15.2 10.1 15.4 9.9 15.6 9.8C16 9.6 16.4 9.3 16.7 8.9C17 8.4 17.2 8 17.2 7.5C17.2 6.7 16.9 6.1 16.4 5.7C15.9 5.2 15.1 5 14.2 5M13 12V14H15V12H13Z";
var mdiHelpBoxOutline = "M11 18H13V16H11V18M12 6C9.8 6 8 7.8 8 10H10C10 8.9 10.9 8 12 8S14 8.9 14 10C14 12 11 11.8 11 15H13C13 12.8 16 12.5 16 10C16 7.8 14.2 6 12 6M19 5V19H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z";
var mdiHelpCircle = "M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z";
var mdiHelpCircleOutline = "M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z";
var mdiHelpNetwork = "M17,3A2,2 0 0,1 19,5V15A2,2 0 0,1 17,17H13V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H7C5.89,17 5,16.1 5,15V5A2,2 0 0,1 7,3H17M12.19,5C11.32,5 10.62,5.2 10.08,5.59C9.56,6 9.3,6.57 9.31,7.36L9.32,7.39H11.25C11.26,7.09 11.35,6.86 11.53,6.7C11.71,6.55 11.93,6.47 12.19,6.47C12.5,6.47 12.76,6.57 12.94,6.75C13.12,6.94 13.2,7.2 13.2,7.5C13.2,7.82 13.13,8.09 12.97,8.32C12.83,8.55 12.62,8.75 12.36,8.91C11.85,9.25 11.5,9.55 11.31,9.82C11.11,10.08 11,10.5 11,11H13C13,10.69 13.04,10.44 13.13,10.26C13.22,10.07 13.39,9.9 13.64,9.74C14.09,9.5 14.46,9.21 14.75,8.81C15.04,8.41 15.19,8 15.19,7.5C15.19,6.74 14.92,6.13 14.38,5.68C13.85,5.23 13.12,5 12.19,5M11,12V14H13V12H11Z";
var mdiHelpNetworkOutline = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M7,15V5H17V15H7M11.95,6C11.17,6 10.55,6.18 10.07,6.5C9.61,6.89 9.38,7.4 9.39,8.1L9.4,8.13H11.11C11.12,7.86 11.2,7.65 11.36,7.5C11.5,7.38 11.72,7.31 11.95,7.31C12.22,7.31 12.45,7.4 12.61,7.56C12.77,7.73 12.85,7.96 12.85,8.22C12.85,8.5 12.78,8.75 12.64,8.95C12.5,9.16 12.33,9.33 12.1,9.5C11.65,9.78 11.34,10.05 11.17,10.29C11,10.5 10.89,10.89 10.89,11.33H12.67C12.67,11.06 12.7,10.84 12.78,10.68C12.86,10.5 13,10.36 13.24,10.21C13.64,10 13.97,9.74 14.22,9.39C14.5,9.03 14.62,8.67 14.62,8.22C14.62,7.55 14.38,7 13.9,6.61C13.42,6.2 12.77,6 11.95,6M10.89,12.22V14H12.67V12.22H10.89Z";
var mdiHelpRhombus = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M12 6.95C14.7 7.06 15.87 9.78 14.28 11.81C13.86 12.31 13.19 12.64 12.85 13.07C12.5 13.5 12.5 14 12.5 14.5H11C11 13.65 11 12.94 11.35 12.44C11.68 11.94 12.35 11.64 12.77 11.31C14 10.18 13.68 8.59 12 8.46C11.18 8.46 10.5 9.13 10.5 9.97H9C9 8.3 10.35 6.95 12 6.95M11 15.5H12.5V17H11V15.5Z";
var mdiHelpRhombusOutline = "M11 15.5H12.5V17H11V15.5M12 6.95C14.7 7.06 15.87 9.78 14.28 11.81C13.86 12.31 13.19 12.64 12.85 13.07C12.5 13.5 12.5 14 12.5 14.5H11C11 13.65 11 12.94 11.35 12.44C11.68 11.94 12.35 11.64 12.77 11.31C14 10.18 13.68 8.59 12 8.46C11.18 8.46 10.5 9.13 10.5 9.97H9C9 8.3 10.35 6.95 12 6.95M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M12 4L20 12L12 20L4 12Z";
var mdiHexadecimal = "M7 7C5.9 7 5 7.9 5 9V15C5 16.11 5.9 17 7 17H9C10.11 17 11 16.11 11 15V9C11 7.9 10.11 7 9 7H7M7 9H9V15H7V9M17.6 17L15.5 14.9L13.4 17L12 15.6L14.1 13.5L12 11.4L13.4 10L15.5 12.1L17.6 10L19 11.4L16.9 13.5L19 15.6L17.6 17Z";
var mdiHexagon = "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5Z";
var mdiHexagonMultiple = "M10.25,2C10.44,2 10.61,2.11 10.69,2.26L12.91,6.22L13,6.5L12.91,6.78L10.69,10.74C10.61,10.89 10.44,11 10.25,11H5.75C5.56,11 5.39,10.89 5.31,10.74L3.09,6.78L3,6.5L3.09,6.22L5.31,2.26C5.39,2.11 5.56,2 5.75,2H10.25M10.25,13C10.44,13 10.61,13.11 10.69,13.26L12.91,17.22L13,17.5L12.91,17.78L10.69,21.74C10.61,21.89 10.44,22 10.25,22H5.75C5.56,22 5.39,21.89 5.31,21.74L3.09,17.78L3,17.5L3.09,17.22L5.31,13.26C5.39,13.11 5.56,13 5.75,13H10.25M19.5,7.5C19.69,7.5 19.86,7.61 19.94,7.76L22.16,11.72L22.25,12L22.16,12.28L19.94,16.24C19.86,16.39 19.69,16.5 19.5,16.5H15C14.81,16.5 14.64,16.39 14.56,16.24L12.34,12.28L12.25,12L12.34,11.72L14.56,7.76C14.64,7.61 14.81,7.5 15,7.5H19.5Z";
var mdiHexagonMultipleOutline = "M9.37 4L10.78 6.5L9.37 9H6.63L5.23 6.5L6.63 4H9.37M10.25 2H5.75C5.56 2 5.39 2.11 5.31 2.26L3.09 6.22L3 6.5L3.09 6.78L5.31 10.74C5.39 10.89 5.56 11 5.75 11H10.25C10.44 11 10.61 10.89 10.69 10.74L12.91 6.78L13 6.5L12.91 6.22L10.69 2.26C10.61 2.11 10.44 2 10.25 2M18.62 9.5L20 12L18.62 14.5H15.88L14.5 12L15.88 9.5H18.62M19.5 7.5H15C14.81 7.5 14.64 7.61 14.56 7.76L12.34 11.72L12.25 12L12.34 12.28L14.56 16.24C14.64 16.39 14.81 16.5 15 16.5H19.5C19.69 16.5 19.86 16.39 19.94 16.24L22.16 12.28L22.25 12L22.16 11.72L19.94 7.76C19.86 7.61 19.69 7.5 19.5 7.5M9.37 15L10.78 17.5L9.37 20H6.63L5.23 17.5L6.63 15H9.37M10.25 13H5.75C5.56 13 5.39 13.11 5.31 13.26L3.09 17.22L3 17.5L3.09 17.78L5.31 21.74C5.39 21.89 5.56 22 5.75 22H10.25C10.44 22 10.61 21.89 10.69 21.74L12.91 17.78L13 17.5L12.91 17.22L10.69 13.26C10.61 13.11 10.44 13 10.25 13Z";
var mdiHexagonOutline = "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z";
var mdiHexagonSlice1 = "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15M12,12V5.32L17.94,8.66L12,12Z";
var mdiHexagonSlice2 = "M18,15.38L12,12V5.32L18,8.69V15.38M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z";
var mdiHexagonSlice3 = "M12,5.32L18,8.69V15.31L12,18.68V5.32M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z";
var mdiHexagonSlice4 = "M12,5.32L18,8.69V15.31L12,18.68L6.06,15.34L12,12V5.32M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z";
var mdiHexagonSlice5 = "M12,5.32L18,8.69V15.31L12,18.68L6,15.31V8.69L12,12V5.32M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z";
var mdiHexagonSlice6 = "M12,5.32L18,8.69V15.31L12,18.68L6,15.31V8.69L12,5.32M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z";
var mdiHexagram = "M14.5,7.66L20.64,6.97L17,12L20.68,16.97L14.5,16.32L12.03,22L9.5,16.34L3.36,17.03L7,12L3.32,7.03L9.5,7.68L11.97,2L14.5,7.66Z";
var mdiHexagramOutline = "M12,7L13.3,9.8L16.5,9.4L14.5,12L16.4,14.5L13.2,14.1L12,17L10.7,14.2L7.5,14.6L9.5,12L7.6,9.5L10.8,9.9L12,7M12,2L9.5,7.7L3.3,7L7,12L3.4,17L9.6,16.3L12,22L14.5,16.3L20.7,16.9L17,12L20.6,7L14.4,7.7L12,2Z";
var mdiHighDefinition = "M5,7H7V11H9V7H11V17H9V13H7V17H5V7M13,7H16A3,3 0 0,1 19,10V14A3,3 0 0,1 16,17H13V7M16,15A1,1 0 0,0 17,14V10A1,1 0 0,0 16,9H15V15H16Z";
var mdiHighDefinitionBox = "M19,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M11,15H9.5V13H7.5V15H6V9H7.5V11.5H9.5V9H11V15M13,9H17A1,1 0 0,1 18,10V14A1,1 0 0,1 17,15H13V9M14.5,13.5H16.5V10.5H14.5V13.5Z";
var mdiHighway = "M10,2L8,8H11V2H10M13,2V8H16L14,2H13M2,9V10H4V11H6V10H18L18.06,11H20V10H22V9H2M7,11L3.34,22H11V11H7M13,11V22H20.66L17,11H13Z";
var mdiHiking = "M17.47 8.67H19V23H17.47V12.6C16.67 12.44 15.92 12.14 15.21 11.71S13.9 10.78 13.39 10.2L12.77 13.27L15 15.47V23H13V17L10.76 14.8L8.89 23H6.73C6.73 23 9.86 7.22 9.89 7.09C10 6.61 10.22 6.24 10.59 6C10.96 5.73 11.33 5.6 11.71 5.6C12.1 5.6 12.46 5.69 12.79 5.87C13.13 6.04 13.39 6.29 13.58 6.61L14.64 8.24C14.93 8.78 15.32 9.25 15.81 9.63S16.86 10.3 17.47 10.5V8.67M8.55 5.89L7.4 5.65C6.83 5.5 6.31 5.62 5.84 5.94C5.38 6.26 5.1 6.7 5 7.28L4.19 11.26C4.16 11.55 4.22 11.81 4.38 12.05C4.54 12.29 4.75 12.42 5 12.46L7.21 12.89L8.55 5.89M13 1C11.9 1 11 1.9 11 3S11.9 5 13 5 15 4.11 15 3 14.11 1 13 1Z";
var mdiHistory = "M13.5,8H12V13L16.28,15.54L17,14.33L13.5,12.25V8M13,3A9,9 0 0,0 4,12H1L4.96,16.03L9,12H6A7,7 0 0,1 13,5A7,7 0 0,1 20,12A7,7 0 0,1 13,19C11.07,19 9.32,18.21 8.06,16.94L6.64,18.36C8.27,20 10.5,21 13,21A9,9 0 0,0 22,12A9,9 0 0,0 13,3";
var mdiHockeyPuck = "M12,5C6.5,5 2,6.57 2,8.5C2,10.43 6.5,12 12,12C17.5,12 22,10.43 22,8.5C22,6.57 17.5,5 12,5M2,11.76V16.5C2,18.43 6.5,20 12,20C17.5,20 22,18.43 22,16.5V11.76C21.33,12.22 20.58,12.57 19.73,12.86C17.62,13.6 14.95,14 12,14C9.05,14 6.38,13.6 4.27,12.86C3.42,12.57 2.67,12.22 2,11.76Z";
var mdiHockeySticks = "M17.68 4H14.3L12.56 8C12.53 8.04 12.45 8.22 12.31 8.5S12.06 9.04 12 9.19L9.7 4H6.32L10.41 12.84C10.5 13.06 10.73 13.59 11.11 14.43C11.5 15.28 11.78 15.91 12 16.35L13.41 19.44C13.6 19.78 13.89 19.95 14.3 19.95L19 20V16H15L13.6 12.84L17.68 4M20.03 16V20H22V17C22 16.73 21.91 16.5 21.72 16.28C21.53 16.08 21.3 16 21 16H20.03M5 16V20L9.7 19.95C10.11 19.95 10.4 19.78 10.59 19.44L11.44 17.5L9.84 14.06L9 16H5M2 20H3.97V16H3C2.7 16 2.47 16.08 2.28 16.28C2.09 16.5 2 16.73 2 17V20Z";
var mdiHololens = "M12,8C12,8 22,8 22,11C22,11 22.09,14.36 21.75,14.25C21,11 12,11 12,11C12,11 3,11 2.25,14.25C1.91,14.36 2,11 2,11C2,8 12,8 12,8M12,12C20,12 20.75,14.25 20.75,14.25C19.75,17.25 19,18 15,18C12,18 13,16.5 12,16.5C11,16.5 12,18 9,18C5,18 4.25,17.25 3.25,14.25C3.25,14.25 4,12 12,12Z";
var mdiHome = "M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z";
var mdiHomeAccount = "M12,3L2,12H5V20H19V12H22L12,3M12,8.75A2.25,2.25 0 0,1 14.25,11A2.25,2.25 0 0,1 12,13.25A2.25,2.25 0 0,1 9.75,11A2.25,2.25 0 0,1 12,8.75M12,15C13.5,15 16.5,15.75 16.5,17.25V18H7.5V17.25C7.5,15.75 10.5,15 12,15Z";
var mdiHomeAlert = "M12 3L2 12H5V20H19V12H22L12 3M13 18H11V16H13V18M13 14H11V8H13V14Z";
var mdiHomeAlertOutline = "M12 5.7L17 10.2V18H7V10.2L12 5.7M19 20V12H22L12 3L2 12H5V20M13 8H11V13H13V8M13 15H11V17H13V15";
var mdiHomeAnalytics = "M12,3L2,12H5V20H19V12H22M9,18H7V12H9M13,18H11V10H13M17,18H15V14H17";
var mdiHomeAssistant = "M21.8,13H20V21H13V17.67L15.79,14.88L16.5,15C17.66,15 18.6,14.06 18.6,12.9C18.6,11.74 17.66,10.8 16.5,10.8A2.1,2.1 0 0,0 14.4,12.9L14.5,13.61L13,15.13V9.65C13.66,9.29 14.1,8.6 14.1,7.8A2.1,2.1 0 0,0 12,5.7A2.1,2.1 0 0,0 9.9,7.8C9.9,8.6 10.34,9.29 11,9.65V15.13L9.5,13.61L9.6,12.9A2.1,2.1 0 0,0 7.5,10.8A2.1,2.1 0 0,0 5.4,12.9A2.1,2.1 0 0,0 7.5,15L8.21,14.88L11,17.67V21H4V13H2.25C1.83,13 1.42,13 1.42,12.79C1.43,12.57 1.85,12.15 2.28,11.72L11,3C11.33,2.67 11.67,2.33 12,2.33C12.33,2.33 12.67,2.67 13,3L17,7V6H19V9L21.78,11.78C22.18,12.18 22.59,12.59 22.6,12.8C22.6,13 22.2,13 21.8,13M7.5,12A0.9,0.9 0 0,1 8.4,12.9A0.9,0.9 0 0,1 7.5,13.8A0.9,0.9 0 0,1 6.6,12.9A0.9,0.9 0 0,1 7.5,12M16.5,12C17,12 17.4,12.4 17.4,12.9C17.4,13.4 17,13.8 16.5,13.8A0.9,0.9 0 0,1 15.6,12.9A0.9,0.9 0 0,1 16.5,12M12,6.9C12.5,6.9 12.9,7.3 12.9,7.8C12.9,8.3 12.5,8.7 12,8.7C11.5,8.7 11.1,8.3 11.1,7.8C11.1,7.3 11.5,6.9 12,6.9Z";
var mdiHomeAutomation = "M12,3L2,12H5V20H19V12H22L12,3M12,8.5C14.34,8.5 16.46,9.43 18,10.94L16.8,12.12C15.58,10.91 13.88,10.17 12,10.17C10.12,10.17 8.42,10.91 7.2,12.12L6,10.94C7.54,9.43 9.66,8.5 12,8.5M12,11.83C13.4,11.83 14.67,12.39 15.6,13.3L14.4,14.47C13.79,13.87 12.94,13.5 12,13.5C11.06,13.5 10.21,13.87 9.6,14.47L8.4,13.3C9.33,12.39 10.6,11.83 12,11.83M12,15.17C12.94,15.17 13.7,15.91 13.7,16.83C13.7,17.75 12.94,18.5 12,18.5C11.06,18.5 10.3,17.75 10.3,16.83C10.3,15.91 11.06,15.17 12,15.17Z";
var mdiHomeBattery = "M12 20L5 20V12H2L12 3L14.78 5.5H14V7.17C12.84 7.58 12 8.7 12 10V20M15 9H16V7.5H20V9H21C21.55 9 22 9.45 22 10V21C22 21.55 21.55 22 21 22H15C14.45 22 14 21.55 14 21V10C14 9.45 14.45 9 15 9M16 11V14H20V11H16Z";
var mdiHomeBatteryOutline = "M15 9H16V7.5H20V9H21C21.55 9 22 9.45 22 10V21C22 21.55 21.55 22 21 22H15C14.45 22 14 21.55 14 21V10C14 9.45 14.45 9 15 9M16 11V14H20V11H16M12 5.69L7 10.19V18H12V20H5V12H2L12 3L14.78 5.5H14V7.17L13.76 7.27L12 5.69Z";
var mdiHomeCircle = "M19.07,4.93C17.22,3 14.66,1.96 12,2C9.34,1.96 6.79,3 4.94,4.93C3,6.78 1.96,9.34 2,12C1.96,14.66 3,17.21 4.93,19.06C6.78,21 9.34,22.04 12,22C14.66,22.04 17.21,21 19.06,19.07C21,17.22 22.04,14.66 22,12C22.04,9.34 21,6.78 19.07,4.93M17,12V18H13.5V13H10.5V18H7V12H5L12,5L19.5,12H17Z";
var mdiHomeCircleOutline = "M12 20C7.6 20 4 16.4 4 12S7.6 4 12 4 20 7.6 20 12 16.4 20 12 20M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M11 14H13V17H16V12H18L12 7L6 12H8V17H11V14";
var mdiHomeCity = "M0,21V10L7.5,5L15,10V21H10V14H5V21H0M24,2V21H17V8.93L16,8.27V6H14V6.93L10,4.27V2H24M21,14H19V16H21V14M21,10H19V12H21V10M21,6H19V8H21V6Z";
var mdiHomeCityOutline = "M10,2V4.26L12,5.59V4H22V19H17V21H24V2H10M7.5,5L0,10V21H15V10L7.5,5M14,6V6.93L15.61,8H16V6H14M18,6V8H20V6H18M7.5,7.5L13,11V19H10V13H5V19H2V11L7.5,7.5M18,10V12H20V10H18M18,14V16H20V14H18Z";
var mdiHomeClock = "M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25M23 16C23 19.87 19.87 23 16 23C13.62 23 11.53 21.81 10.26 20H4V12H1L11 3L18 9.29C20.89 10.15 23 12.83 23 16M21 16C21 13.24 18.76 11 16 11S11 13.24 11 16 13.24 21 16 21 21 18.76 21 16Z";
var mdiHomeClockOutline = "M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25M23 16C23 19.87 19.87 23 16 23C13.62 23 11.53 21.81 10.26 20H4V12H1L11 3L18 9.29C20.89 10.15 23 12.83 23 16M9.29 18C9.11 17.37 9 16.7 9 16C9 12.54 11.5 9.68 14.8 9.11L11 5.69L6 10.19V18H9.29M21 16C21 13.24 18.76 11 16 11S11 13.24 11 16 13.24 21 16 21 21 18.76 21 16Z";
var mdiHomeEdit = "M12 3L2 12H5V20H10V14H14V15.11L19.43 9.68L12 3M21.04 11.14C20.9 11.14 20.76 11.2 20.65 11.3L19.65 12.3L21.7 14.35L22.7 13.35C22.91 13.14 22.91 12.79 22.7 12.58L21.42 11.3C21.32 11.2 21.18 11.14 21.04 11.14M19.06 12.88L13 18.94V21H15.06L21.11 14.93L19.06 12.88Z";
var mdiHomeEditOutline = "M 21.0413,11.14C 21.1827,11.14 21.3173,11.1973 21.4213,11.3027L 22.6973,12.5787C 22.912,12.792 22.912,13.14 22.6973,13.3493L 21.6973,14.3493L 19.6507,12.3027L 20.6507,11.3027C 20.76,11.1973 20.9013,11.14 21.0413,11.14 Z M 19.0627,12.88L 21.1093,14.932L 15.0627,21L 13,21L 13,18.9373L 19.0627,12.88 Z M 12,5.688L 7,10.188L 7,18L 11,18L 11,20L 5,20L 5,12L 2,12L 12,3L 19.4587,9.71285L 17,12.1716L 17,10.188L 12,5.688 Z";
var mdiHomeExportOutline = "M24 13L20 17V14H11V12H20V9L24 13M4 20V12H1L11 3L18 9.3V10H15.79L11 5.69L6 10.19V18H16V16H18V20H4Z";
var mdiHomeFlood = "M18.67 19C16.72 19 16.58 20 15.34 20C14.15 20 13.92 19 12 19C10.06 19 9.91 20 8.67 20S7.29 19 5.34 19 3.24 20 2 20V22C3.95 22 4.11 21 5.34 21C6.58 21 6.72 22 8.67 22S10.77 21 12 21C13.23 21 13.41 22 15.34 22S17.44 21 18.67 21C19.89 21 20.07 22 22 22V20C20.76 20 20.62 19 18.67 19M8.68 17.5C10.63 17.5 10.77 16.5 12 16.5C13.2 16.5 13.43 17.5 15.34 17.5C17.29 17.5 17.43 16.5 18.67 16.5C19.86 16.5 20.07 17.5 22 17.5V15.5C21.35 15.5 21 15.22 20.5 14.95L18.5 7.42L20.57 8.27L21.31 6.41L9.78 2L2 11.61L3.57 12.84L4.96 11.06L5.89 14.54C5.71 14.5 5.54 14.5 5.33 14.5C3.38 14.5 3.24 15.5 2 15.5V17.5C3.9 17.5 4.17 16.5 5.35 16.5C6.54 16.5 6.77 17.5 8.68 17.5M14.04 10.18L15.46 15.5C14.12 15.58 14 14.5 12 14.5C11.63 14.5 11.34 14.54 11.08 14.6L10.17 11.21L14.04 10.18Z";
var mdiHomeFloor0 = "M11,10H13V16H11V10M22,12H19V20H5V12H2L12,3L22,12M15,10A2,2 0 0,0 13,8H11A2,2 0 0,0 9,10V16A2,2 0 0,0 11,18H13A2,2 0 0,0 15,16V10Z";
var mdiHomeFloor1 = "M12,3L2,12H5V20H19V12H22L12,3M10,8H14V18H12V10H10V8Z";
var mdiHomeFloor2 = "M12,3L2,12H5V20H19V12H22L12,3M9,8H13A2,2 0 0,1 15,10V12A2,2 0 0,1 13,14H11V16H15V18H9V14A2,2 0 0,1 11,12H13V10H9V8Z";
var mdiHomeFloor3 = "M12,3L22,12H19V20H5V12H2L12,3M15,11.5V10C15,8.89 14.1,8 13,8H9V10H13V12H11V14H13V16H9V18H13A2,2 0 0,0 15,16V14.5A1.5,1.5 0 0,0 13.5,13A1.5,1.5 0 0,0 15,11.5Z";
var mdiHomeFloorA = "M12,3L2,12H5V20H19V12H22L12,3M11,8H13A2,2 0 0,1 15,10V18H13V15H11V18H9V10C9,8.89 9.9,8 11,8M11,10V13H13V10H11Z";
var mdiHomeFloorB = "M12,3L2,12H5V20H19V12H22L12,3M9,8H13A2,2 0 0,1 15,10V11.5A1.5,1.5 0 0,1 13.5,13A1.5,1.5 0 0,1 15,14.5V16A2,2 0 0,1 13,18H9V8M11,10V12H13V10H11M11,14V16H13V14H11Z";
var mdiHomeFloorG = "M12,3L2,12H5V20H19V12H22L12,3M11,8H15V10H11V16H13V12H15V16C15,17.11 14.1,18 13,18H11A2,2 0 0,1 9,16V10C9,8.89 9.9,8 11,8Z";
var mdiHomeFloorL = "M12,3L2,12H5V20H19V12H22L12,3M9,8H11V16H15V18H9V8Z";
var mdiHomeFloorNegative1 = "M12,3L2,12H5V20H19V12H22L12,3M11,15H7V13H11V15M15,18H13V10H11V8H15V18Z";
var mdiHomeGroup = "M17,16H15V22H12V17H8V22H5V16H3L10,10L17,16M6,2L10,6H9V9H7V6H5V9H3V6H2L6,2M18,3L23,8H22V12H19V9H17V12H15.34L14,10.87V8H13L18,3Z";
var mdiHomeGroupMinus = "M2 6H1L5 2L9 6H8V9H6V6H4V9H2V6M13 10.9L14.3 12H16V9H18V12H21V8H22L17 3L12 8H13V10.9M13.8 22C13.3 21.1 13 20.1 13 19C13 17.4 13.6 15.9 14.7 14.9L9 10L2 16H4V22H7V17H11V22H13.8M15 18V20H23V18H15Z";
var mdiHomeGroupPlus = "M2 6H1L5 2L9 6H8V9H6V6H4V9H2V6M13 10.9L14.3 12H16V9H18V12H21V8H22L17 3L12 8H13V10.9M13.8 22C13.3 21.1 13 20.1 13 19C13 17.4 13.6 15.9 14.7 14.9L9 10L2 16H4V22H7V17H11V22H13.8M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiHomeGroupRemove = "M2 6H1L5 2L9 6H8V9H6V6H4V9H2V6M13 10.9L14.3 12H16V9H18V12H21V8H22L17 3L12 8H13V10.9M13.8 22C13.3 21.1 13 20.1 13 19C13 17.4 13.6 15.9 14.7 14.9L9 10L2 16H4V22H7V17H11V22H13.8M21.1 15.5L19 17.6L16.9 15.5L15.5 16.9L17.6 19L15.5 21.1L16.9 22.5L19 20.4L21.1 22.5L22.5 21.1L20.4 19L22.5 16.9L21.1 15.5Z";
var mdiHomeHeart = "M2,12L12,3L22,12H19V20H5V12H2M12,18L12.72,17.34C15.3,15 17,13.46 17,11.57C17,10.03 15.79,8.82 14.25,8.82C13.38,8.82 12.55,9.23 12,9.87C11.45,9.23 10.62,8.82 9.75,8.82C8.21,8.82 7,10.03 7,11.57C7,13.46 8.7,15 11.28,17.34L12,18Z";
var mdiHomeImportOutline = "M15 13L11 17V14H2V12H11V9L15 13M5 20V16H7V18H17V10.19L12 5.69L7.21 10H4.22L12 3L22 12H19V20H5Z";
var mdiHomeLightbulb = "M12 3L2 12H5V20H19V12H22M13 18H11V17H13M13.5 14.58V16H10.5V14.58A3 3 0 1 1 13.5 14.58Z";
var mdiHomeLightbulbOutline = "M5 20V12H2L12 3L22 12H19V20H5M12 5.69L7 10.19V18H17V10.19L12 5.69M11 17V16H13V17H11M11 15C10.72 15 10.5 14.78 10.5 14.5V13.6C9.6 13.08 9 12.11 9 11C9 9.34 10.34 8 12 8C13.66 8 15 9.34 15 11C15 12.11 14.4 13.08 13.5 13.6V14.5C13.5 14.78 13.28 15 13 15H11Z";
var mdiHomeLightningBolt = "M12 3L2 12H5V20H19V12H22L12 3M11.5 18V14H9L12.5 7V11H15L11.5 18Z";
var mdiHomeLightningBoltOutline = "M5 20V12H2L12 3L22 12H19V20H5M12 5.69L7 10.19V18H17V10.19L12 5.69M11.5 18V14H9L12.5 7V11H15L11.5 18Z";
var mdiHomeLock = "M12,3L2,12H5V20H19V12H22L12,3M12,9A3,3 0 0,1 15,12V13H16V17H8V13H9V12A3,3 0 0,1 12,9M12,11A1,1 0 0,0 11,12V13H13V12C13,11.5 12.6,11 12,11Z";
var mdiHomeLockOpen = "M12,3L2,12H5V20H19V12H22L12,3M12,8A3,3 0 0,1 15,11H13A1,1 0 0,0 12,10A1,1 0 0,0 11,11V13H16V17H8V13H9V11A3,3 0 0,1 12,8Z";
var mdiHomeMapMarker = "M12,3L2,12H5V20H19V12H22L12,3M12,7.7C14.1,7.7 15.8,9.4 15.8,11.5C15.8,14.5 12,18 12,18C12,18 8.2,14.5 8.2,11.5C8.2,9.4 9.9,7.7 12,7.7M12,10A1.5,1.5 0 0,0 10.5,11.5A1.5,1.5 0 0,0 12,13A1.5,1.5 0 0,0 13.5,11.5A1.5,1.5 0 0,0 12,10Z";
var mdiHomeMinus = "M22 17V19H14V17H22M12 3L22 12H18C14.69 12 12 14.69 12 18C12 18.7 12.12 19.37 12.34 20H5V12H2L12 3Z";
var mdiHomeMinusOutline = "M14 17H22V19H14V17M5 20V12H2L12 3L22 12H17V10.19L12 5.69L7 10.19V18H12C12 18.7 12.12 19.37 12.34 20H5Z";
var mdiHomeModern = "M6,21V8A2,2 0 0,1 8,6L16,3V6A2,2 0 0,1 18,8V21H12V16H8V21H6M14,19H16V16H14V19M8,13H10V9H8V13M12,13H16V9H12V13Z";
var mdiHomeOff = "M20.84 22.73L18.11 20H14V15.89L12.11 14H10V20H5V12H2L6.27 8.16L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M19 12H22L12 3L8.95 5.75L19 15.8V12Z";
var mdiHomeOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L6.27 8.16L2 12H5V20H11V14H12.11L13 14.89V20H18.11L20.84 22.73L22.11 21.46M9 12V18H7V10.19L7.68 9.57L10.11 12H9M15 18V16.89L16.11 18H15M10.36 7.16L8.95 5.75L12 3L22 12H19V15.8L17 13.8V10.19L12 5.69L10.36 7.16Z";
var mdiHomeOutline = "M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69M12 3L2 12H5V20H11V14H13V20H19V12H22";
var mdiHomePercent = "M19 12V20H5V12H2L12 3L22 12H19M15.53 11.03L14.47 9.97L8.47 15.97L9.53 17.03L15.53 11.03M10.63 10.37C10.4 10.13 10.08 10 9.75 10C9.42 10 9.1 10.13 8.87 10.37C8.63 10.6 8.5 10.92 8.5 11.25C8.5 11.58 8.63 11.9 8.87 12.13C9.1 12.37 9.42 12.5 9.75 12.5C10.08 12.5 10.4 12.37 10.63 12.13C10.87 11.9 11 11.58 11 11.25C11 10.92 10.87 10.6 10.63 10.37M15.13 14.87C14.9 14.63 14.58 14.5 14.25 14.5C13.92 14.5 13.6 14.63 13.37 14.87C13.13 15.1 13 15.42 13 15.75C13 16.08 13.13 16.4 13.37 16.63C13.6 16.87 13.92 17 14.25 17C14.58 17 14.9 16.87 15.13 16.63C15.37 16.4 15.5 16.08 15.5 15.75C15.5 15.42 15.37 15.1 15.13 14.87Z";
var mdiHomePercentOutline = "M15.53 11.03L14.47 9.97L8.47 15.97L9.53 17.03L15.53 11.03M10.63 10.37C10.4 10.13 10.08 10 9.75 10C9.42 10 9.1 10.13 8.87 10.37C8.63 10.6 8.5 10.92 8.5 11.25C8.5 11.58 8.63 11.9 8.87 12.13C9.1 12.37 9.42 12.5 9.75 12.5C10.08 12.5 10.4 12.37 10.63 12.13C10.87 11.9 11 11.58 11 11.25C11 10.92 10.87 10.6 10.63 10.37M15.13 14.87C14.9 14.63 14.58 14.5 14.25 14.5C13.92 14.5 13.6 14.63 13.37 14.87C13.13 15.1 13 15.42 13 15.75C13 16.08 13.13 16.4 13.37 16.63C13.6 16.87 13.92 17 14.25 17C14.58 17 14.9 16.87 15.13 16.63C15.37 16.4 15.5 16.08 15.5 15.75C15.5 15.42 15.37 15.1 15.13 14.87M19 12V20H5V12H2L12 3L22 12H19M17 10.2L12 5.7L7 10.2V18H17V10.2Z";
var mdiHomePlus = "M17 14H19V17H22V19H19V22H17V19H14V17H17V14M12 3L22 12H18C14.69 12 12 14.69 12 18C12 18.7 12.12 19.37 12.34 20H5V12H2L12 3Z";
var mdiHomePlusOutline = "M17 14H19V17H22V19H19V22H17V19H14V17H17V14M5 20V12H2L12 3L22 12H17V10.19L12 5.69L7 10.19V18H12C12 18.7 12.12 19.37 12.34 20H5Z";
var mdiHomeRemove = "M14.46 15.88L15.88 14.46L18 16.59L20.12 14.47L21.54 15.88L19.41 18L21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.46 20.12L16.59 18L14.47 15.88M12 3L22 12H18C14.69 12 12 14.69 12 18C12 18.7 12.12 19.37 12.34 20H5V12H2L12 3Z";
var mdiHomeRemoveOutline = "M14.46 15.88L15.88 14.46L18 16.59L20.12 14.47L21.54 15.88L19.41 18L21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.46 20.12L16.59 18L14.47 15.88M5 20V12H2L12 3L22 12H17V10.19L12 5.69L7 10.19V18H12C12 18.7 12.12 19.37 12.34 20H5Z";
var mdiHomeRoof = "M19 16H22L12 7L2 16H5L12 9.69L19 16M7 8.81V7H4V11.5L7 8.81Z";
var mdiHomeSearch = "M19.31 18.9C19.75 18.21 20 17.38 20 16.5C20 14 18 12 15.5 12S11 14 11 16.5 13 21 15.5 21C16.37 21 17.19 20.75 17.88 20.32L21 23.39L22.39 22L19.31 18.9M15.5 19C14.12 19 13 17.88 13 16.5S14.12 14 15.5 14 18 15.12 18 16.5 16.88 19 15.5 19M5 20V12H2L12 3L22 12H20.18C19 10.77 17.34 10 15.5 10C11.92 10 9 12.92 9 16.5C9 17.79 9.38 19 10.03 20H5Z";
var mdiHomeSearchOutline = "M19.31 18.9C19.75 18.21 20 17.38 20 16.5C20 14 18 12 15.5 12S11 14 11 16.5 13 21 15.5 21C16.37 21 17.19 20.75 17.88 20.32L21 23.39L22.39 22L19.31 18.9M15.5 19C14.12 19 13 17.88 13 16.5S14.12 14 15.5 14 18 15.12 18 16.5 16.88 19 15.5 19M5 20V12H2L12 3L22 12H20.18C19.33 11.11 18.23 10.47 17 10.18L12 5.69L7 10.19V18H9.18C9.35 18.72 9.64 19.39 10.03 20H5Z";
var mdiHomeSilo = "M24 7.8C23.6 4.5 20.9 2 17.5 2C15.8 2 14.1 2.7 12.9 3.9C12.2 4.6 11.7 5.3 11.4 6.2L17 9.9V10H20V12H17V14H20V16H17V18H20V20H17V22H24V7.8M13.3 7C13.9 5.2 15.6 4 17.5 4S21.1 5.2 21.7 7H13.3M0 11V22H5V15H10V22H15V11L7.5 6L0 11Z";
var mdiHomeSiloOutline = "M20 21H17V19H20V21M20 17H17V15H20V17M20 13H17V11H20V13M24 7.8C23.6 4.5 20.8 2 17.5 2C15.8 2 14.1 2.7 12.9 3.9C12.2 4.6 11.7 5.3 11.4 6.2L15.6 9H22V22H24V7.8M13.3 7C13.9 5.2 15.6 4 17.5 4S21.1 5.2 21.7 7H13.3M7.5 6L0 11V22H15V11L7.5 6M13 20H10V14H5V20H2V12L7.5 8.5L13 12V20Z";
var mdiHomeSoundIn = "M6.58045 2C6.50974 4.6163 4.52984 6.59619 1.98426 6.59619V8.01041C5.44908 8.08112 8.13609 5.39411 7.99467 2H6.58045Z M1.98426 3.62635V5.04056C3.75202 4.96985 5.02482 3.69706 5.02482 2H3.6106C3.46918 2.84853 2.83278 3.48492 1.98426 3.62635Z M22.0157 6.59619C19.4702 6.59619 17.4903 4.6163 17.4196 2H16.0053C15.8639 5.39411 18.5509 8.08112 22.0157 8.01041V6.59619Z M22.0157 5.04056V3.62635C21.1672 3.48492 20.5308 2.84853 20.3894 2H18.9752C18.9752 3.69706 20.248 4.96985 22.0157 5.04056Z M19 20V12H22L12 3L2 12H5V20H19Z";
var mdiHomeSoundInOutline = "M6.58045 2C6.50974 4.6163 4.52984 6.59619 1.98425 6.59619V8.01041C5.44908 8.08112 8.13608 5.39411 7.99466 2H6.58045Z M1.98425 3.62635V5.04056C3.75202 4.96985 5.02481 3.69706 5.02481 2H3.6106C3.46918 2.84853 2.83278 3.48492 1.98425 3.62635Z M22.0157 6.59619C19.4702 6.59619 17.4903 4.6163 17.4195 2H16.0053C15.8639 5.39411 18.5509 8.08112 22.0157 8.01041V6.59619Z M22.0157 5.04056V3.62635C21.1672 3.48492 20.5308 2.84853 20.3894 2H18.9752C18.9752 3.69706 20.248 4.96985 22.0157 5.04056Z M19 20V12H22L12 3L2 12H5V20H19ZM12 5.7L17 10.2V18H7V10.2L12 5.7Z";
var mdiHomeSoundOut = "M2.4038 7.01172C2.47451 4.39542 4.45441 2.41552 7 2.41552V1.00131C3.53517 0.9306 0.848167 3.61761 0.989589 7.01172L2.4038 7.01172Z M7 5.38537V3.97116C5.23223 4.04187 3.95944 5.31466 3.95944 7.01172H5.37365C5.51507 6.16319 6.15147 5.52679 7 5.38537Z M17 2.41552C19.5456 2.41552 21.5255 4.39542 21.5962 7.01172L23.0104 7.01172C23.1518 3.61761 20.4648 0.9306 17 1.00131V2.41552Z M17 3.97116V5.38537C17.8485 5.52679 18.4849 6.16319 18.6263 7.01172H20.0406C20.0406 5.31466 18.7678 4.04187 17 3.97116Z M19 20V12H22L12 3L2 12H5V20H19Z";
var mdiHomeSoundOutOutline = "M2.4038 7.01172C2.47451 4.39542 4.45441 2.41552 7 2.41552V1.00131C3.53517 0.9306 0.848167 3.61761 0.989589 7.01172L2.4038 7.01172Z M7 5.38537V3.97116C5.23223 4.04187 3.95944 5.31466 3.95944 7.01172H5.37365C5.51507 6.16319 6.15147 5.52679 7 5.38537Z M17 2.41552C19.5456 2.41552 21.5255 4.39542 21.5962 7.01172L23.0104 7.01172C23.1518 3.61761 20.4648 0.9306 17 1.00131V2.41552Z M17 3.97116V5.38537C17.8485 5.52679 18.4849 6.16319 18.6263 7.01172H20.0406C20.0406 5.31466 18.7678 4.04187 17 3.97116Z M19 20V12H22L12 3L2 12H5V20H19ZM12 5.7L17 10.2V18H7V10.2L12 5.7Z";
var mdiHomeSwitch = "M6.5 15V11H9.5V15H13V9H15L8 3L1 9H3V15H6.5M9 16V18H15V16L18 19L15 22V20H9V22L6 19L9 16M23 9H21V15H15V10H19L13.54 5.11L16 3L23 9Z";
var mdiHomeSwitchOutline = "M8 3L1 9H3V15H7V11H9V15H13V9H15L8 3M11.5 9V13.5H10.5V9.5H5.5V13.5H4.5V8L8 5L11.5 8V9M9 16V18H15V16L18 19L15 22V20H9V22L6 19L9 16M23 9H21V15H15V10H19L13.54 5.11L16 3L23 9Z";
var mdiHomeThermometer = "M19 8C20.11 8 21 8.9 21 10V16.76C21.61 17.31 22 18.11 22 19C22 20.66 20.66 22 19 22C17.34 22 16 20.66 16 19C16 18.11 16.39 17.31 17 16.76V10C17 8.9 17.9 8 19 8M19 9C18.45 9 18 9.45 18 10V11H20V10C20 9.45 19.55 9 19 9M5 20V12H2L12 3L16.4 6.96C15.54 7.69 15 8.78 15 10V16C14.37 16.83 14 17.87 14 19L14.1 20H5Z";
var mdiHomeThermometerOutline = "M19 8C20.11 8 21 8.9 21 10V16.76C21.61 17.31 22 18.11 22 19C22 20.66 20.66 22 19 22C17.34 22 16 20.66 16 19C16 18.11 16.39 17.31 17 16.76V10C17 8.9 17.9 8 19 8M19 9C18.45 9 18 9.45 18 10V11H20V10C20 9.45 19.55 9 19 9M12 5.69L7 10.19V18H14.1L14 19L14.1 20H5V12H2L12 3L16.4 6.96C15.89 7.4 15.5 7.97 15.25 8.61L12 5.69Z";
var mdiHomeVariant = "M12,3L20,9V21H15V14H9V21H4V9L12,3Z";
var mdiHomeVariantOutline = "M9,13H15V19H18V10L12,5.5L6,10V19H9V13M4,21V9L12,3L20,9V21H4Z";
var mdiHook = "M18,6C18,7.82 16.76,9.41 15,9.86V17A5,5 0 0,1 10,22A5,5 0 0,1 5,17V12L10,17H7A3,3 0 0,0 10,20A3,3 0 0,0 13,17V9.86C11.23,9.4 10,7.8 10,5.97C10,3.76 11.8,2 14,2C16.22,2 18,3.79 18,6M14,8A2,2 0 0,0 16,6A2,2 0 0,0 14,4A2,2 0 0,0 12,6A2,2 0 0,0 14,8Z";
var mdiHookOff = "M13,9.86V11.18L15,13.18V9.86C17.14,9.31 18.43,7.13 17.87,5C17.32,2.85 15.14,1.56 13,2.11C10.86,2.67 9.57,4.85 10.13,7C10.5,8.4 11.59,9.5 13,9.86M14,4A2,2 0 0,1 16,6A2,2 0 0,1 14,8A2,2 0 0,1 12,6A2,2 0 0,1 14,4M18.73,22L14.86,18.13C14.21,20.81 11.5,22.46 8.83,21.82C6.6,21.28 5,19.29 5,17V12L10,17H7A3,3 0 0,0 10,20A3,3 0 0,0 13,17V16.27L2,5.27L3.28,4L13,13.72L15,15.72L20,20.72L18.73,22Z";
var mdiHoopHouse = "M12 5C6.5 5 2 9.5 2 15V21H22V15C22 9.5 17.5 5 12 5M12 7C14.53 7 16.78 8.17 18.25 10H5.76C7.22 8.17 9.47 7 12 7M8 19H4V15C4 13.94 4.21 12.93 4.58 12H8V19M14 19H10V12H14V19M20 19H16V12H19.42C19.79 12.93 20 13.94 20 15V19Z";
var mdiHops = "M21,12C21,12 12.5,10 12.5,2C12.5,2 21,2 21,12M3,12C3,2 11.5,2 11.5,2C11.5,10 3,12 3,12M12,6.5C12,6.5 13,8.66 15,10.5C14.76,14.16 12,16 12,16C12,16 9.24,14.16 9,10.5C11,8.66 12,6.5 12,6.5M20.75,13.25C20.75,13.25 20,17 18,19C18,19 15.53,17.36 14.33,14.81C15.05,13.58 15.5,12.12 15.75,11.13C17.13,12.18 18.75,13 20.75,13.25M15.5,18.25C14.5,20.25 12,21.75 12,21.75C12,21.75 9.5,20.25 8.5,18.25C8.5,18.25 9.59,17.34 10.35,15.8C10.82,16.35 11.36,16.79 12,17C12.64,16.79 13.18,16.35 13.65,15.8C14.41,17.34 15.5,18.25 15.5,18.25M3.25,13.25C5.25,13 6.87,12.18 8.25,11.13C8.5,12.12 8.95,13.58 9.67,14.81C8.47,17.36 6,19 6,19C4,17 3.25,13.25 3.25,13.25Z";
var mdiHorizontalRotateClockwise = "M12 14L8 10L4 14H7.1C7.56 18.56 9.58 22 12 22S16.44 18.56 16.9 14H14.91C14.57 17.45 13.4 20 12 20S9.43 17.45 9.09 14H12M12 4C13.4 4 14.57 6.55 14.91 10H16.9C16.44 5.44 14.42 2 12 2C9.84 2 8 4.74 7.3 8.58L8 7.88L9.21 9.08C9.64 6.11 10.73 4 12 4M22 13V11H11L13 13H22M2 13H3L5 11H2V13Z";
var mdiHorizontalRotateCounterclockwise = "M12 10H9.09C9.43 6.55 10.6 4 12 4S14.57 6.55 14.91 10H16.9C16.44 5.44 14.42 2 12 2S7.56 5.44 7.1 10H4L8 14L12 10M12 20C10.73 20 9.64 17.89 9.21 14.92L8 16.12L7.3 15.42C8 19.26 9.84 22 12 22C14.42 22 16.44 18.56 16.9 14H14.91C14.57 17.45 13.4 20 12 20M22 11H13L11 13H22V11M2 13H5L3 11H2V13";
var mdiHorse = "M22 6V9.5L20.5 10L18.96 7.54C18.83 7.33 18.5 7.42 18.5 7.67V11.25C18.5 12.23 18.11 13.11 17.5 13.78V21H15V15C14.92 15 14.84 15 14.75 15C14.54 15 14.33 14.97 14.13 14.94L9.69 14.2L8.57 16.21L9.53 21H7L6 16.25C5.97 15.95 6 15.65 6.16 15.39L7.18 13.58C6.2 13.03 5.53 12 5.5 10.81C5.46 10.96 5.44 11.18 5.47 11.5C5.5 11.94 5.61 12.59 5.54 13.31C5.5 14.03 5.17 14.77 4.75 15.26C4.32 15.75 3.85 16.09 3.35 16.35L2.65 15.65C2.84 15.18 3.03 14.76 3.07 14.37C3.13 14 3.06 13.7 2.95 13.43L2.42 12.3C2.21 11.79 1.95 11.05 2 10.18C2.03 9.33 2.5 8.22 3.39 7.61C4.29 7 5.26 6.92 6.05 7.08C6.55 7.18 7.06 7.42 7.5 7.76C7.87 7.59 8.3 7.5 8.75 7.5H14.5V7C14.5 4.79 16.29 3 18.5 3H22L21.11 4.34C21.65 4.7 22 5.31 22 6Z";
var mdiHorseHuman = "M10 3.5C10 2.67 10.67 2 11.5 2S13 2.67 13 3.5 12.33 5 11.5 5 10 4.33 10 3.5M22 8V11.5L20.97 11.85C20.8 13.06 19.76 14 18.5 14H18.42C18.28 14.68 17.95 15.29 17.5 15.78V22H15V17C14.92 17 14.84 17 14.75 17C14.54 17 14.33 16.97 14.13 16.94L9.69 16.2L8.57 18.21L9.32 22H6.78L6 18.25C5.97 17.95 6 17.65 6.16 17.39L7.18 15.58C6.2 15.03 5.53 14 5.5 12.81C5.46 12.96 5.44 13.18 5.47 13.5C5.5 13.94 5.61 14.59 5.54 15.31C5.5 16.03 5.17 16.77 4.75 17.26C4.32 17.75 3.85 18.09 3.35 18.35L2.65 17.65C2.84 17.18 3.03 16.76 3.07 16.37C3.13 16 3.06 15.7 2.95 15.43L2.42 14.3C2.21 13.79 1.95 13.05 2 12.18C2.03 11.33 2.5 10.22 3.39 9.61C4.29 9 5.26 8.91 6.05 9.08C6.55 9.18 7.06 9.42 7.5 9.76C7.87 9.59 8.3 9.5 8.75 9.5H9V8.11C9 7.11 9.68 6.19 10.66 6.03C11.92 5.82 13 6.79 13 8V9.5H14.5V9C14.5 6.79 16.29 5 18.5 5H22L21.11 6.34C21.65 6.7 22 7.31 22 8M20 11.2L18.96 9.54C18.83 9.33 18.5 9.42 18.5 9.67V13C19.33 13 20 12.33 20 11.5V11.2Z";
var mdiHorseVariant = "M20 8V16L17 17L13.91 11.5C13.65 11.04 12.92 11.27 13 11.81L14 21L4 17L5.15 8.94C5.64 5.53 8.56 3 12 3H20L18.42 5.37C19.36 5.88 20 6.86 20 8Z";
var mdiHorseVariantFast = "M23 8V16L20 17L16.91 11.5C16.65 11.04 15.92 11.27 16 11.81L17 21L7 17L8.15 8.94C8.64 5.53 11.56 3 15 3H23L21.42 5.37C22.36 5.88 23 6.86 23 8M4 5H7.58C8.08 4.24 8.7 3.57 9.41 3H4C3.45 3 3 3.45 3 4S3.45 5 4 5M5.84 11H2C1.45 11 1 11.45 1 12S1.45 13 2 13H5.55L5.84 11M3 9H6.12L6.17 8.66C6.25 8.08 6.39 7.53 6.58 7H3C2.45 7 2 7.45 2 8S2.45 9 3 9Z";
var mdiHorseshoe = "M19,4H20V1H16V4C16,4 18,8 18,12C18,16 16,19 12,19C8,19 6,16 6,12C6,8 8,4 8,4V1H4V4H5C5,4 2,8 2,14C2,19 7,23 12,23C17,23 22,19 22,14C22,8 19,4 19,4M4,13C3.4,13 3,12.6 3,12C3,11.4 3.4,11 4,11C4.6,11 5,11.4 5,12C5,12.6 4.6,13 4,13M6,19C5.4,19 5,18.6 5,18C5,17.4 5.4,17 6,17C6.6,17 7,17.4 7,18C7,18.6 6.6,19 6,19M12,22C11.4,22 11,21.6 11,21C11,20.4 11.4,20 12,20C12.6,20 13,20.4 13,21C13,21.6 12.6,22 12,22M18,19C17.4,19 17,18.6 17,18C17,17.4 17.4,17 18,17C18.6,17 19,17.4 19,18C19,18.6 18.6,19 18,19M20,13C19.4,13 19,12.6 19,12C19,11.4 19.4,11 20,11C20.6,11 21,11.4 21,12C21,12.6 20.6,13 20,13Z";
var mdiHospital = "M18 14H14V18H10V14H6V10H10V6H14V10H18";
var mdiHospitalBox = "M18,14H14V18H10V14H6V10H10V6H14V10H18M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiHospitalBoxOutline = "M18 14H14V18H10V14H6V10H10V6H14V10H18M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M20 20H4V4H20V20Z";
var mdiHospitalBuilding = "M2,22V7A1,1 0 0,1 3,6H7V2H17V6H21A1,1 0 0,1 22,7V22H14V17H10V22H2M9,4V10H11V8H13V10H15V4H13V6H11V4H9M4,20H8V17H4V20M4,15H8V12H4V15M16,20H20V17H16V20M16,15H20V12H16V15M10,15H14V12H10V15Z";
var mdiHospitalMarker = "M12,2C15.86,2 19,5.13 19,9C19,14.25 12,22 12,22C12,22 5,14.25 5,9A7,7 0 0,1 12,2M9,6V12H11V10H13V12H15V6H13V8H11V6H9Z";
var mdiHotTub = "M7,4A2,2 0 0,1 9,6A2,2 0 0,1 7,8A2,2 0 0,1 5,6A2,2 0 0,1 7,4M11.15,12H22V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V12H5V11.25C5,10 6,9 7.25,9H7.28C7.62,9 7.95,9.09 8.24,9.23C8.5,9.35 8.74,9.5 8.93,9.73L10.33,11.28C10.56,11.54 10.84,11.78 11.15,12M7,20V14H5V20H7M11,20V14H9V20H11M15,20V14H13V20H15M19,20V14H17V20H19M18.65,5.86C19.68,6.86 20.16,8.21 19.95,9.57L19.89,10H18L18.09,9.41C18.24,8.62 18,7.83 17.42,7.21L17.35,7.15C16.32,6.14 15.85,4.79 16.05,3.43L16.11,3H18L17.91,3.59C17.76,4.38 18,5.17 18.58,5.79L18.65,5.86M14.65,5.86C15.68,6.86 16.16,8.21 15.95,9.57L15.89,10H14L14.09,9.41C14.24,8.62 14,7.83 13.42,7.21L13.35,7.15C12.32,6.14 11.85,4.79 12.05,3.43L12.11,3H14L13.91,3.59C13.76,4.38 14,5.17 14.58,5.79L14.65,5.86Z";
var mdiHours12 = "M13 2V4C17 4.5 20 7.8 20 11.9C20 15.1 18.1 17.9 15.3 19.2L13 17V22H18L16.8 20.8C19.9 19.1 22 15.8 22 12C22 6.8 18 2.5 13 2M11 2C9.1 2.2 7.2 3 5.7 4.2L7.1 5.6C8.2 4.8 9.6 4.2 11 4V2M4.2 5.7C3 7.2 2.2 9.1 2 11H4C4.2 9.6 4.8 8.2 5.6 7.1L4.2 5.7M2 13C2.2 14.9 3 16.8 4.2 18.3L5.6 16.9C4.8 15.8 4.2 14.4 4 13H2M7.1 18.4L5.7 19.8C7.2 21 9.1 21.8 11 22V20C9.6 19.8 8.2 19.2 7.1 18.4M12 8V10H15V11H14C12.9 11 12 11.9 12 13V16H17V14H14V13H15C16.1 13 17 12.1 17 11V10C17 8.9 16.1 8 15 8H12M7 8V10H8V16H10V8H7Z";
var mdiHours24 = "M13 2.05V4.07C16.95 4.56 20 7.92 20 12C20 15.21 18.08 18 15.28 19.28L13 17V22H18L16.78 20.78C19.91 19.07 22 15.76 22 12C22 6.82 18.05 2.55 13 2.05M11 2C9.05 2.2 7.2 2.96 5.68 4.21L7.1 5.63C8.23 4.75 9.58 4.2 11 4V2M4.2 5.68C2.96 7.2 2.2 9.05 2 11H4C4.19 9.58 4.75 8.23 5.63 7.1L4.2 5.68M6 8V10H9V11H8C6.9 11 6 11.9 6 13V16H11V14H8V13H9C10.11 13 11 12.11 11 11V10C11 8.9 10.11 8 9 8H6M12 8V13H15V16H17V13H18V11H17V8H15V11H14V8H12M2 13C2.2 14.95 2.97 16.8 4.22 18.32L5.64 16.9C4.76 15.77 4.2 14.42 4 13H2M7.11 18.37L5.68 19.79C7.2 21.03 9.05 21.8 11 22V20C9.58 19.81 8.24 19.25 7.11 18.37Z";
var mdiHub = "M8.4 18.2C8.8 18.7 9 19.3 9 20C9 21.7 7.7 23 6 23S3 21.7 3 20 4.3 17 6 17C6.4 17 6.8 17.1 7.2 17.3L8.6 15.5C7.7 14.5 7.3 13.1 7.5 11.8L5.5 11.1C5 11.9 4.1 12.5 3 12.5C1.3 12.5 0 11.2 0 9.5S1.3 6.5 3 6.5 6 7.8 6 9.5V9.7L8 10.4C8.6 9.2 9.8 8.3 11.2 8.1V5.9C10 5.6 9 4.4 9 3C9 1.3 10.3 0 12 0S15 1.3 15 3C15 4.4 14 5.6 12.8 5.9V8.1C14.2 8.3 15.4 9.2 16 10.4L18 9.7V9.5C18 7.8 19.3 6.5 21 6.5S24 7.8 24 9.5 22.7 12.5 21 12.5C19.9 12.5 19 11.9 18.5 11.1L16.5 11.8C16.7 13.1 16.3 14.5 15.4 15.5L16.8 17.3C17.2 17.1 17.6 17 18 17C19.7 17 21 18.3 21 20S19.7 23 18 23 15 21.7 15 20C15 19.3 15.2 18.7 15.6 18.2L14.2 16.4C12.8 17.2 11.2 17.2 9.8 16.4L8.4 18.2Z";
var mdiHubOutline = "M21 6.5C19.3 6.5 18 7.8 18 9.5V9.7L16 10.4C15.4 9.2 14.2 8.3 12.8 8.1V5.9C14 5.6 15 4.4 15 3C15 1.3 13.7 0 12 0S9 1.3 9 3C9 4.4 10 5.6 11.2 5.9V8.1C9.9 8.3 8.7 9.2 8 10.4L6 9.7V9.5C6 7.8 4.7 6.5 3 6.5S0 7.8 0 9.5 1.3 12.5 3 12.5C4.1 12.5 5 11.9 5.5 11.1L7.5 11.8C7.3 13.1 7.7 14.5 8.6 15.5L7.2 17.3C6.8 17.1 6.4 17 6 17C4.3 17 3 18.3 3 20S4.3 23 6 23 9 21.7 9 20C9 19.3 8.8 18.7 8.4 18.2L9.8 16.4C11.2 17.2 12.8 17.2 14.2 16.4L15.6 18.2C15.2 18.7 15 19.3 15 20C15 21.7 16.3 23 18 23S21 21.7 21 20 19.7 17 18 17C17.6 17 17.1 17.1 16.8 17.3L15.4 15.5C16.3 14.5 16.7 13.1 16.5 11.8L18.5 11.1C19 11.9 20 12.5 21 12.5C22.7 12.5 24 11.2 24 9.5S22.7 6.5 21 6.5M3 10.5C2.5 10.5 2 10.1 2 9.5S2.5 8.5 3 8.5 4 8.9 4 9.5 3.5 10.5 3 10.5M6 21C5.4 21 5 20.5 5 20S5.4 19 6 19 7 19.5 7 20 6.6 21 6 21M11 3C11 2.5 11.4 2 12 2S13 2.5 13 3 12.6 4 12 4 11 3.5 11 3M12 15C10.6 15 9.5 13.9 9.5 12.5S10.6 10 12 10 14.5 11.1 14.5 12.5 13.4 15 12 15M18 19C18.5 19 19 19.5 19 20S18.5 21 18 21 17 20.5 17 20 17.5 19 18 19M21 10.5C20.5 10.5 20 10.1 20 9.5S20.5 8.5 21 8.5 22 8.9 22 9.5 21.5 10.5 21 10.5Z";
var mdiHubspot = "M17.1,8.6V6.2C17.7,5.9 18.2,5.3 18.2,4.6V4.5C18.2,3.5 17.4,2.7 16.4,2.7H16.3C15.3,2.7 14.5,3.5 14.5,4.5V4.6C14.5,5.3 14.9,5.9 15.6,6.2V8.6C14.7,8.7 13.8,9.1 13.1,9.7L6.5,4.6C6.8,3.5 6.1,2.3 5,2.1C3.9,1.9 2.8,2.4 2.5,3.5C2.2,4.6 2.9,5.8 4,6.1C4.5,6.2 5.1,6.2 5.6,5.9L12,10.9C10.8,12.7 10.8,15 12.1,16.8L10.1,18.8C9.9,18.8 9.8,18.7 9.6,18.7C8.7,18.7 7.9,19.5 7.9,20.4C7.9,21.3 8.7,22 9.6,22C10.5,22 11.3,21.2 11.3,20.3V20.3C11.3,20.1 11.3,20 11.2,19.8L13.1,17.9C15.4,19.6 18.7,19.2 20.4,16.9C22.1,14.6 21.7,11.3 19.4,9.6C18.8,9.1 18,8.7 17.1,8.6M16.3,16.4C14.8,16.4 13.6,15.2 13.6,13.7C13.6,12.2 14.8,11 16.3,11C17.8,11 19,12.2 19,13.7C19,15.2 17.8,16.4 16.3,16.4";
var mdiHulu = "M19.5,12.8V22H14.7V13.9C14.7,13.2 14.1,12.6 13.4,12.6H10.5C9.8,12.6 9.2,13.2 9.2,13.9V22H4.5V2H9.3V8.4C9.6,8.3 9.9,8.2 10.2,8.2H15C17.5,8.2 19.5,10.3 19.5,12.8Z";
var mdiHuman = "M21,9H15V22H13V16H11V22H9V9H3V7H21M12,2A2,2 0 0,1 14,4A2,2 0 0,1 12,6C10.89,6 10,5.1 10,4C10,2.89 10.89,2 12,2Z";
var mdiHumanBabyChangingTable = "M6.5 6.08C5.72 6.12 5 6.62 4.72 7.4L3 12.13V22H7V12.84L8.42 8.94L10.7 10H14V8H11.15L7.29 6.2C7.03 6.11 6.76 6.07 6.5 6.08M9 17H21V19H9M10 3.5A2 2 0 0 1 8 5.5A2 2 0 0 1 6 3.5A2 2 0 0 1 8 1.5A2 2 0 0 1 10 3.5M21 14.5A1.5 1.5 0 0 1 19.5 16A1.5 1.5 0 0 1 18 14.5A1.5 1.5 0 0 1 19.5 13A1.5 1.5 0 0 1 21 14.5M9 11V13H11V14C11 15.11 11.89 16 13 16H15C16.11 16 17 15.11 17 14V11H15V13H13V12A1 1 0 0 0 12 11Z";
var mdiHumanCane = "M18 12.24V22H17.06V12.24C17.06 12.09 17 12 16.93 11.89C16.84 11.8 16.74 11.76 16.62 11.76C16.47 11.76 16.36 11.8 16.27 11.89C16.18 12 16.14 12.1 16.14 12.24V13.16H15.23V12.5C14.53 12.33 13.9 12.04 13.35 11.63C12.8 11.22 12.34 10.74 11.96 10.19L11.61 11.39C11.5 11.81 11.5 12.24 11.5 12.68L11.5 13L11.5 13.33L13.35 15.94V22H11.5V17.34L9.82 15L9.65 18.25L6.86 22L5.38 20.87L7.77 17.64V12.68C7.77 12.15 7.82 11.63 7.91 11.11L8.25 9.54L6.86 10.32V13.63H5V9.23L10 6.4C10.29 6.26 10.59 6.18 10.91 6.18C11.23 6.18 11.54 6.27 11.83 6.44C12.15 6.62 12.39 6.88 12.57 7.23L13.31 8.8C13.6 9.38 14.04 9.87 14.64 10.26C15.23 10.65 15.89 10.85 16.62 10.85C17 10.85 17.32 11 17.6 11.24C17.88 11.5 18 11.83 18 12.24M12 2C13.11 2 14 2.9 14 4C14 5.11 13.11 6 12 6C10.9 6 10 5.11 10 4C10 2.9 10.9 2 12 2Z";
var mdiHumanCapacityDecrease = "M16 4C16 2.9 16.9 2 18 2S20 2.9 20 4 19.1 6 18 6 16 5.1 16 4M20.78 7.58C19.93 7.21 19 7 18 7C17.33 7 16.69 7.1 16.08 7.28C16.66 7.83 17 8.6 17 9.43V10H22V9.43C22 8.62 21.5 7.9 20.78 7.58M6 6C7.1 6 8 5.1 8 4S7.1 2 6 2 4 2.9 4 4 4.9 6 6 6M7.92 7.28C7.31 7.1 6.67 7 6 7C5 7 4.07 7.21 3.22 7.58C2.5 7.9 2 8.62 2 9.43V10H7V9.43C7 8.6 7.34 7.83 7.92 7.28M10 4C10 2.9 10.9 2 12 2S14 2.9 14 4 13.1 6 12 6 10 5.1 10 4M16 10H8V9.43C8 8.62 8.5 7.9 9.22 7.58C10.07 7.21 11 7 12 7C13 7 13.93 7.21 14.78 7.58C15.5 7.9 16 8.62 16 9.43V10M15 16C15 14.9 15.9 14 17 14S19 14.9 19 16 18.1 18 17 18 15 17.1 15 16M21 22H13V21.43C13 20.62 13.5 19.9 14.22 19.58C15.07 19.21 16 19 17 19C18 19 18.93 19.21 19.78 19.58C20.5 19.9 21 20.62 21 21.43V22M5 16C5 14.9 5.9 14 7 14S9 14.9 9 16 8.1 18 7 18 5 17.1 5 16M11 22H3V21.43C3 20.62 3.5 19.9 4.22 19.58C5.07 19.21 6 19 7 19C8 19 8.93 19.21 9.78 19.58C10.5 19.9 11 20.62 11 21.43V22M12.75 13V11H11.25V13H9L12 16L15 13H12.75Z";
var mdiHumanCapacityIncrease = "M16 4C16 2.9 16.9 2 18 2C19.1 2 20 2.9 20 4C20 5.1 19.1 6 18 6C16.9 6 16 5.1 16 4M20.78 7.58C19.93 7.21 19 7 18 7C17.33 7 16.69 7.1 16.08 7.28C16.66 7.83 17 8.6 17 9.43V10H22V9.43C22 8.62 21.5 7.9 20.78 7.58M6 6C7.1 6 8 5.1 8 4C8 2.9 7.1 2 6 2C4.9 2 4 2.9 4 4C4 5.1 4.9 6 6 6M7.92 7.28C7.31 7.1 6.67 7 6 7C5 7 4.07 7.21 3.22 7.58C2.5 7.9 2 8.62 2 9.43V10H7V9.43C7 8.6 7.34 7.83 7.92 7.28M10 4C10 2.9 10.9 2 12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4M16 10H8V9.43C8 8.62 8.5 7.9 9.22 7.58C10.07 7.21 11 7 12 7C13 7 13.93 7.21 14.78 7.58C15.5 7.9 16 8.62 16 9.43M15 16C15 14.9 15.9 14 17 14C18.1 14 19 14.9 19 16C19 17.1 18.1 18 17 18C15.9 18 15 17.1 15 16M21 22H13V21.43C13 20.62 13.5 19.9 14.22 19.58C15.07 19.21 16 19 17 19C18 19 18.93 19.21 19.78 19.58C20.5 19.9 21 20.62 21 21.43M5 16C5 14.9 5.9 14 7 14C8.1 14 9 14.9 9 16C9 17.1 8.1 18 7 18C5.9 18 5 17.1 5 16M11 22H3V21.43C3 20.62 3.5 19.9 4.22 19.58C5.07 19.21 6 19 7 19C8 19 8.93 19.21 9.78 19.58C10.5 19.9 11 20.62 11 21.43M12.75 14V16H11.25V14H9L12 11L15 14Z";
var mdiHumanChild = "M12,2A3,3 0 0,1 15,5A3,3 0 0,1 12,8A3,3 0 0,1 9,5A3,3 0 0,1 12,2M11,22H8V16H6V9H18V16H16V22H13V18H11V22Z";
var mdiHumanDolly = "M16.78 21.84C15.77 22.27 14.59 21.8 14.16 20.78C13.73 19.77 14.2 18.59 15.22 18.16C16.23 17.73 17.41 18.2 17.84 19.22C18.27 20.23 17.8 21.41 16.78 21.84M7.62 6C8.73 6 9.62 5.11 9.62 4C9.62 2.9 8.73 2 7.62 2C6.5 2 5.62 2.9 5.62 4C5.62 5.11 6.5 6 7.62 6M22.05 16.34L18.2 18C18.42 18.22 18.62 18.5 18.76 18.82C18.9 19.15 18.96 19.5 19 19.82L22.83 18.18L22.05 16.34M10.16 8.78L10.9 10.59C10.66 10.5 10.44 10.38 10.26 10.26C9.66 9.87 9.22 9.38 8.93 8.8L8.19 7.23C8 6.88 7.77 6.62 7.45 6.44C7.16 6.27 6.85 6.18 6.53 6.18C6.21 6.18 5.91 6.26 5.62 6.4C4.22 7.5 3.87 9.54 3.87 9.54L3.53 11.11C3.44 11.63 3.39 12.15 3.39 12.68V17.64L1 20.87L2.5 22L5.27 18.25L5.44 15L7.12 17.34V22H8.97V15.94L7.12 13.33V12.68C7.12 12.24 7.12 11.81 7.23 11.39L7.58 10.19C7.96 10.74 8.42 11.22 8.97 11.63C9.42 11.97 10.68 12.57 11.87 12.86L14 17.8C14.22 17.58 14.5 17.38 14.83 17.24C15.15 17.1 15.5 17.04 15.82 17L12 8L10.16 8.78M15.36 12.12L17.32 16.72L22.95 14.31L21 9.72";
var mdiHumanEdit = "M19.07 14.88L21.12 16.93L15.06 23H13V20.94L19.07 14.88M21.04 13.13C21.18 13.13 21.31 13.19 21.42 13.3L22.7 14.58C22.92 14.79 22.92 15.14 22.7 15.35L21.7 16.35L19.65 14.3L20.65 13.3C20.76 13.19 20.9 13.13 21.04 13.13M21 9H15V16L13 18V16H11V22H9V9H3V7H21V9M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2Z";
var mdiHumanFemale = "M12,2A2,2 0 0,1 14,4A2,2 0 0,1 12,6A2,2 0 0,1 10,4A2,2 0 0,1 12,2M10.5,22V16H7.5L10.09,8.41C10.34,7.59 11.1,7 12,7C12.9,7 13.66,7.59 13.91,8.41L16.5,16H13.5V22H10.5Z";
var mdiHumanFemaleBoy = "M7.5,2A2,2 0 0,1 9.5,4A2,2 0 0,1 7.5,6A2,2 0 0,1 5.5,4A2,2 0 0,1 7.5,2M6,22V16H3L5.6,8.4C5.9,7.6 6.6,7 7.5,7C8.4,7 9.2,7.6 9.4,8.4L12,16H9V22H6M14.5,12A2,2 0 0,1 16.5,10A2,2 0 0,1 18.5,12A2,2 0 0,1 16.5,14A2,2 0 0,1 14.5,12M13.5,15H19.5V19H18V22H15V19H13.5V15Z";
var mdiHumanFemaleDance = "M17 17H15V23H13V17H10.88L9.34 18.93L11.71 21.29L10.29 22.71L7.93 20.34C7.58 20 7.38 19.53 7.35 19.04C7.32 18.55 7.47 18.06 7.78 17.68L8.32 17H7L9 13V10C8.38 10.47 7.88 11.07 7.53 11.76C7.18 12.46 7 13.22 7 14H5C5 12.14 5.74 10.36 7.05 9.05C8.36 7.74 10.14 7 12 7C13.33 7 14.6 6.47 15.54 5.54C16.47 4.6 17 3.33 17 2H19C19 3.32 18.62 4.62 17.91 5.73C17.2 6.85 16.2 7.74 15 8.31V13L17 17M14 4C14 4.4 13.88 4.78 13.66 5.11C13.44 5.44 13.13 5.7 12.77 5.85C12.4 6 12 6.04 11.61 5.96C11.22 5.88 10.87 5.69 10.59 5.41C10.31 5.13 10.12 4.78 10.04 4.39C9.96 4 10 3.6 10.15 3.24C10.3 2.87 10.56 2.56 10.89 2.34C11.22 2.12 11.6 2 12 2C12.53 2 13.04 2.21 13.41 2.59C13.79 2.96 14 3.47 14 4Z";
var mdiHumanFemaleFemale = "M7.5,2A2,2 0 0,1 9.5,4A2,2 0 0,1 7.5,6A2,2 0 0,1 5.5,4A2,2 0 0,1 7.5,2M6,22V16H3L5.6,8.4C5.9,7.6 6.6,7 7.5,7C8.4,7 9.2,7.6 9.4,8.4L12,16L14.6,8.4C14.9,7.6 15.6,7 16.5,7C17.4,7 18.2,7.6 18.4,8.4L21,16H18V22H15V16H12L9,16V22H6M16.5,2A2,2 0 0,1 18.5,4A2,2 0 0,1 16.5,6A2,2 0 0,1 14.5,4A2,2 0 0,1 16.5,2Z";
var mdiHumanFemaleFemaleChild = "M16 4C16 2.9 16.9 2 18 2S20 2.9 20 4 19.1 6 18 6 16 5.1 16 4M20 16H22.5L20 8.4C19.7 7.6 19 7 18.1 7H18C17.1 7 16.4 7.6 16.1 8.4L15.2 11C16.3 11.6 17 12.7 17 14.1V22H20M12.5 11.5C13.3 11.5 14 10.8 14 10S13.3 8.5 12.5 8.5 11 9.2 11 10 11.7 11.5 12.5 11.5M5 6C6.1 6 7 5.1 7 4S6.1 2 5 2 3 2.9 3 4 3.9 6 5 6M14 22V18H15V14C15 13.2 14.3 12.5 13.5 12.5H11.5C10.7 12.5 10 13.2 10 14V18H11V22H14M7 22V16H9.5L7 8.4C6.7 7.6 6 7 5.1 7H5C4.1 7 3.4 7.6 3.1 8.4L1.5 16H4V22H7Z";
var mdiHumanFemaleGirl = "M7.5,2A2,2 0 0,1 9.5,4A2,2 0 0,1 7.5,6A2,2 0 0,1 5.5,4A2,2 0 0,1 7.5,2M6,22V16H3L5.6,8.4C5.9,7.6 6.6,7 7.5,7C8.4,7 9.2,7.6 9.4,8.4L12,16H9V22H6M14.5,12A2,2 0 0,1 16.5,10A2,2 0 0,1 18.5,12A2,2 0 0,1 16.5,14A2,2 0 0,1 14.5,12M15,15H18L19.5,19H18V22H15V19H13.5L15,15Z";
var mdiHumanGreeting = "M12 2C13.1 2 14 2.9 14 4S13.1 6 12 6 10 5.1 10 4 10.9 2 12 2M15.9 8.1C15.5 7.7 14.8 7 13.5 7H11C8.2 7 6 4.8 6 2H4C4 5.2 6.1 7.8 9 8.7V22H11V16H13V22H15V10.1L19 14L20.4 12.6L15.9 8.1Z";
var mdiHumanGreetingProximity = "M11 14H9C9 9.03 13.03 5 18 5V7C14.13 7 11 10.13 11 14M18 11V9C15.24 9 13 11.24 13 14H15C15 12.34 16.34 11 18 11M7 4C7 2.89 6.11 2 5 2S3 2.89 3 4 3.89 6 5 6 7 5.11 7 4M11.45 4.5H9.45C9.21 5.92 8 7 6.5 7H3.5C2.67 7 2 7.67 2 8.5V11H8V8.74C9.86 8.15 11.25 6.5 11.45 4.5M19 17C20.11 17 21 16.11 21 15S20.11 13 19 13 17 13.89 17 15 17.89 17 19 17M20.5 18H17.5C16 18 14.79 16.92 14.55 15.5H12.55C12.75 17.5 14.14 19.15 16 19.74V22H22V19.5C22 18.67 21.33 18 20.5 18Z";
var mdiHumanGreetingVariant = "M1.5,4V5.5C1.5,9.65 3.71,13.28 7,15.3V20H22V18C22,15.34 16.67,14 14,14C14,14 13.83,14 13.75,14C9,14 5,10 5,5.5V4M14,4A4,4 0 0,0 10,8A4,4 0 0,0 14,12A4,4 0 0,0 18,8A4,4 0 0,0 14,4Z";
var mdiHumanHandsdown = "M12,1C10.89,1 10,1.9 10,3C10,4.11 10.89,5 12,5C13.11,5 14,4.11 14,3A2,2 0 0,0 12,1M10,6C9.73,6 9.5,6.11 9.31,6.28H9.3L4,11.59L5.42,13L9,9.41V22H11V15H13V22H15V9.41L18.58,13L20,11.59L14.7,6.28C14.5,6.11 14.27,6 14,6";
var mdiHumanHandsup = "M5,1C5,3.7 6.56,6.16 9,7.32V22H11V15H13V22H15V7.31C17.44,6.16 19,3.7 19,1H17A5,5 0 0,1 12,6A5,5 0 0,1 7,1M12,1C10.89,1 10,1.89 10,3C10,4.11 10.89,5 12,5C13.11,5 14,4.11 14,3C14,1.89 13.11,1 12,1Z";
var mdiHumanMale = "M12,2A2,2 0 0,1 14,4A2,2 0 0,1 12,6A2,2 0 0,1 10,4A2,2 0 0,1 12,2M10.5,7H13.5A2,2 0 0,1 15.5,9V14.5H14V22H10V14.5H8.5V9A2,2 0 0,1 10.5,7Z";
var mdiHumanMaleBoard = "M20,17A2,2 0 0,0 22,15V4A2,2 0 0,0 20,2H9.46C9.81,2.61 10,3.3 10,4H20V15H11V17M15,7V9H9V22H7V16H5V22H3V14H1.5V9A2,2 0 0,1 3.5,7H15M8,4A2,2 0 0,1 6,6A2,2 0 0,1 4,4A2,2 0 0,1 6,2A2,2 0 0,1 8,4Z";
var mdiHumanMaleBoardPoll = "M20 17C21.1 17 22 16.1 22 15V4C22 2.9 21.1 2 20 2H9.5C9.8 2.6 10 3.3 10 4H20V15H11V17M15 7V9H9V22H7V16H5V22H3V14H1.5V9C1.5 7.9 2.4 7 3.5 7H15M8 4C8 5.1 7.1 6 6 6S4 5.1 4 4 4.9 2 6 2 8 2.9 8 4M17 6H19V14H17V6M14 10H16V14H14V10M11 10H13V14H11V10Z";
var mdiHumanMaleBoy = "M7.5,2A2,2 0 0,1 9.5,4A2,2 0 0,1 7.5,6A2,2 0 0,1 5.5,4A2,2 0 0,1 7.5,2M6,7H9A2,2 0 0,1 11,9V14.5H9.5V22H5.5V14.5H4V9A2,2 0 0,1 6,7M14.5,12A2,2 0 0,1 16.5,10A2,2 0 0,1 18.5,12A2,2 0 0,1 16.5,14A2,2 0 0,1 14.5,12M13.5,15H19.5V19H18V22H15V19H13.5V15Z";
var mdiHumanMaleChild = "M7 2C5.9 2 5 2.9 5 4S5.9 6 7 6 9 5.11 9 4 8.11 2 7 2M5 7C3.89 7 3 7.89 3 9V15H5V22H10V11.6L12.53 16H14.97L16 14.66V22H20V17H21V14C21 12.89 20.11 12 19 12H16.5C15.9 12 15.37 12.26 15 12.68C14.67 13.1 14.32 13.56 14 14H13.69L10 7.66C9.84 7.38 9.22 7 8.5 7H5M18 8C17.17 8 16.5 8.67 16.5 9.5S17.17 11 18 11 19.5 10.33 19.5 9.5 18.83 8 18 8Z";
var mdiHumanMaleFemale = "M7.5,2A2,2 0 0,1 9.5,4A2,2 0 0,1 7.5,6A2,2 0 0,1 5.5,4A2,2 0 0,1 7.5,2M6,7H9A2,2 0 0,1 11,9V14.5H9.5V22H5.5V14.5H4V9A2,2 0 0,1 6,7M16.5,2A2,2 0 0,1 18.5,4A2,2 0 0,1 16.5,6A2,2 0 0,1 14.5,4A2,2 0 0,1 16.5,2M15,22V16H12L14.59,8.41C14.84,7.59 15.6,7 16.5,7C17.4,7 18.16,7.59 18.41,8.41L21,16H18V22H15Z";
var mdiHumanMaleFemaleChild = "M16 4C16 2.9 16.9 2 18 2S20 2.9 20 4 19.1 6 18 6 16 5.1 16 4M20 22V16H22.5L20 8.4C19.7 7.6 19 7 18.1 7H18C17.1 7 16.4 7.6 16.1 8.4L15.2 11C16.3 11.6 17 12.7 17 14.1V22H20M12.5 11.5C13.3 11.5 14 10.8 14 10S13.3 8.5 12.5 8.5 11 9.2 11 10 11.7 11.5 12.5 11.5M5.5 6C6.6 6 7.5 5.1 7.5 4S6.6 2 5.5 2 3.5 2.9 3.5 4 4.4 6 5.5 6M7.5 22V15H9V9C9 7.9 8.1 7 7 7H4C2.9 7 2 7.9 2 9V15H3.5V22H7.5M14 22V18H15V14C15 13.2 14.3 12.5 13.5 12.5H11.5C10.7 12.5 10 13.2 10 14V18H11V22H14Z";
var mdiHumanMaleGirl = "M7.5,2A2,2 0 0,1 9.5,4A2,2 0 0,1 7.5,6A2,2 0 0,1 5.5,4A2,2 0 0,1 7.5,2M6,7H9A2,2 0 0,1 11,9V14.5H9.5V22H5.5V14.5H4V9A2,2 0 0,1 6,7M14.5,12A2,2 0 0,1 16.5,10A2,2 0 0,1 18.5,12A2,2 0 0,1 16.5,14A2,2 0 0,1 14.5,12M15,15H18L19.5,19H18V22H15V19H13.5L15,15Z";
var mdiHumanMaleHeight = "M7,2C8.78,2 9.67,4.16 8.42,5.42C7.16,6.67 5,5.78 5,4A2,2 0 0,1 7,2M5.5,7H8.5A2,2 0 0,1 10.5,9V14.5H9V22H5V14.5H3.5V9A2,2 0 0,1 5.5,7M21,8H15V10H21M21,11H18V13H21M21,2H15V4H21M21,5H18V7H21M21,14H15V16H21M21,20H15V22H21M21,17H18V19H21";
var mdiHumanMaleHeightVariant = "M7,2C8.78,2 9.67,4.16 8.42,5.42C7.16,6.67 5,5.78 5,4A2,2 0 0,1 7,2M5.5,7H8.5A2,2 0 0,1 10.5,9V14.5H9V22H5V14.5H3.5V9A2,2 0 0,1 5.5,7M19,8H21L18,4L15,8H17V16H15L18,20L21,16H19M22,2H14V4H22M22,20H14V22H22";
var mdiHumanMaleMale = "M7.5,2A2,2 0 0,1 9.5,4A2,2 0 0,1 7.5,6A2,2 0 0,1 5.5,4A2,2 0 0,1 7.5,2M6,7H9A2,2 0 0,1 11,9V14.5H9.5V22H5.5V14.5H4V9A2,2 0 0,1 6,7M16.5,2A2,2 0 0,1 18.5,4A2,2 0 0,1 16.5,6A2,2 0 0,1 14.5,4A2,2 0 0,1 16.5,2M15,7H18A2,2 0 0,1 20,9V14.5H18.5V22H14.5V14.5H13V9A2,2 0 0,1 15,7Z";
var mdiHumanMaleMaleChild = "M12.5 11.5C13.3 11.5 14 10.8 14 10S13.3 8.5 12.5 8.5 11 9.2 11 10 11.7 11.5 12.5 11.5M5.5 6C6.6 6 7.5 5.1 7.5 4S6.6 2 5.5 2 3.5 2.9 3.5 4 4.4 6 5.5 6M7.5 22V15H9V9C9 7.9 8.1 7 7 7H4C2.9 7 2 7.9 2 9V15H3.5V22H7.5M14 22V18H15V14C15 13.2 14.3 12.5 13.5 12.5H11.5C10.7 12.5 10 13.2 10 14V18H11V22H14M18.5 6C19.6 6 20.5 5.1 20.5 4S19.6 2 18.5 2 16.5 2.9 16.5 4 17.4 6 18.5 6M22 9V15H20.5V22H17V14C17 12.6 16.2 11.4 15 10.9V9C15 7.9 15.9 7 17 7H20C21.1 7 22 7.9 22 9Z";
var mdiHumanNonBinary = "M12 2C13.11 2 14 2.9 14 4S13.11 6 12 6 10 5.11 10 4 10.9 2 12 2M13.91 8.41C13.66 7.59 12.9 7 12 7H10.5C9.4 7 8.5 7.9 8.5 9V14.5H10V22H13.5V16H16.5L13.91 8.41Z";
var mdiHumanPregnant = "M9,4C9,2.89 9.89,2 11,2C12.11,2 13,2.89 13,4C13,5.11 12.11,6 11,6C9.89,6 9,5.11 9,4M16,13C16,11.66 15.17,10.5 14,10A3,3 0 0,0 11,7A3,3 0 0,0 8,10V17H10V22H13V17H16V13Z";
var mdiHumanQueue = "M5 6C3.9 6 3 6.9 3 8S3.9 10 5 10 7 9.11 7 8 6.11 6 5 6M12 4C10.9 4 10 4.89 10 6S10.9 8 12 8 14 7.11 14 6 13.11 4 12 4M19 2C17.9 2 17 2.9 17 4S17.9 6 19 6 21 5.11 21 4 20.11 2 19 2M3.5 11C2.67 11 2 11.67 2 12.5V17H3V22H7V17H8V12.5C8 11.67 7.33 11 6.5 11H3.5M10.5 9C9.67 9 9 9.67 9 10.5V15H10V20H14V15H15V10.5C15 9.67 14.33 9 13.5 9H10.5M17.5 7C16.67 7 16 7.67 16 8.5V13H17V18H21V13H22V8.5C22 7.67 21.33 7 20.5 7H17.5Z";
var mdiHumanScooter = "M16.5 2.25C17.33 2.25 18 2.92 18 3.75C18 4.58 17.33 5.25 16.5 5.25C15.67 5.25 15 4.58 15 3.75C15 2.92 15.67 2.25 16.5 2.25M20 18C21.11 18 22 18.9 22 20C22 21.11 21.11 22 20 22C19.26 22 18.61 21.6 18.27 21H8.73C8.39 21.6 7.74 22 7 22C5.9 22 5 21.11 5 20C5 18.9 5.9 18 7 18C7.74 18 8.39 18.4 8.73 19H13V13.5L9.73 11.23L6.77 14C6.36 14.37 5.73 14.34 5.35 13.94L2.28 10.65C1.91 10.24 1.93 9.61 2.33 9.23C2.74 8.86 3.37 8.88 3.74 9.28L6.13 11.84L13.26 5.2L13.3 5.18C13.72 4.82 14.35 4.88 14.71 5.3L16.97 8H20C20.55 8 21 8.45 21 9C21 9.55 20.55 10 20 10H16.5C16.15 10 15.85 9.82 15.67 9.56L14.17 7.77L11.64 10.13L14.57 12.18H14.57C14.83 12.36 15 12.66 15 13V19H15.61C16.04 17.13 17.63 15.7 19.58 15.5L18.81 11H20.31L21.39 17.34C20.97 17.12 20.5 17 20 17C18.69 17 17.58 17.84 17.17 19H18.27C18.61 18.4 19.26 18 20 18Z";
var mdiHumanWalker = "M12 2C13.1 2 14 2.9 14 4S13.1 6 12 6 10 5.1 10 4 10.9 2 12 2M19.8 17.7L19.2 11.3C19.1 10.5 18.5 10 17.7 10H16C14.5 10 13.1 9.5 12.2 8.6L10.2 6.6C10.1 6.4 9.6 6 8.8 6C8.3 6 7.8 6.2 7.4 6.6L4.1 9.9C3.6 10.6 3.6 11.5 3.9 12L5.3 14.8L2.2 18.8L3.8 20L7.5 15.3L7.2 14L8 14.8V20H10V13.9L7.9 11.8L10.3 9.4C11.2 10.3 12 11.2 13.9 11.7L13 20H14.5L14.9 16.5H18.1L18.2 17.7C17.8 18 17.5 18.4 17.5 19C17.5 19.8 18.2 20.5 19 20.5S20.5 19.8 20.5 19C20.5 18.5 20.2 18 19.8 17.7M15.1 15L15.5 11.5H17.5L17.9 15H15.1Z";
var mdiHumanWheelchair = "M8.5 4A2 2 0 0 1 6.5 6A2 2 0 0 1 4.5 4A2 2 0 0 1 6.5 2A2 2 0 0 1 8.5 4M5 7C3.89 7 3 7.89 3 9V15H5V22H8.61A7 7 0 0 1 6.5 17A7 7 0 0 1 10 10.95V9C10 7.89 9.11 7 8 7M13 8V16H18.5L21.2 19.6L22.8 18.4L19.5 14H15V8M12 12.23A5 5 0 0 0 8.5 17A5 5 0 0 0 13.5 22A5 5 0 0 0 18.5 17H16.5A3 3 0 0 1 13.5 20A3 3 0 0 1 10.5 17A3 3 0 0 1 12 14.41Z";
var mdiHumanWhiteCane = "M8 4C8 2.9 8.9 2 10 2C11.11 2 12 2.9 12 4C12 5.11 11.11 6 10 6C8.9 6 8 5.11 8 4M20.65 21.5L14.5 10.85L14.5 10.85V10.85C13.77 10.85 13.23 10.65 12.64 10.26C12.04 9.87 11.6 9.38 11.31 8.8L10.57 7.23C10.39 6.88 10.15 6.62 9.83 6.44C9.54 6.27 9.23 6.18 8.91 6.18C8.59 6.18 8.29 6.26 8 6.4L3 9.23V13.63H4.86V10.32L6.25 9.54L5.91 11.11C5.82 11.63 5.77 12.15 5.77 12.68V17.64L3.38 20.87L4.86 22L7.65 18.25L7.82 15L9.5 17.34V22H11.35V15.94L9.5 13.33V12.68C9.5 12.24 9.5 11.81 9.61 11.39L9.96 10.19C10.34 10.74 10.81 11.2 11.35 11.63C12.2 12.31 13 12.59 14.35 12.58L19.78 22L20.65 21.5Z";
var mdiHumbleBundle = "M16.91,18.12C14.09,18.12 18.43,2.13 18.43,2.13H15.53C15.53,2.13 14.34,5.89 13.55,10.07H11.05C11.11,9.21 11.15,8.34 11.13,7.5C11,0.59 7,1.87 5.18,3.45C3.47,4.95 2.03,7.8 2,10C2.27,10 3.35,10 3.35,10C3.35,10 4.25,5.88 7.07,5.88C9.89,5.88 5.54,21.87 5.54,21.87H8.45C8.45,21.87 9.95,17.59 10.7,12.81L13.09,12.8C12.95,14.04 12.91,15.4 12.93,16.67C13.04,23.56 17.06,22.08 18.86,20.5C20.67,18.92 22,15.58 22,14H20.61C20.62,14.12 19.73,18.12 16.91,18.12V18.12Z";
var mdiHvac = "M8.58 14C8.3 13.55 8.11 13.03 8.06 12.5H15.94C15.89 13.03 15.7 13.55 15.47 14H8.58M12 16C10.97 16 10.08 15.61 9.38 15H14.63C13.92 15.61 13.03 16 12 16M12 8C13.03 8 13.92 8.39 14.63 9H9.38C10.08 8.39 10.97 8 12 8M8.58 10H15.42C15.7 10.45 15.89 10.97 15.94 11.5H8.06C8.11 10.97 8.3 10.45 8.58 10M3 3V21H21V3H3M12 18C8.67 18 6 15.33 6 12S8.67 6 12 6 18 8.67 18 12 15.33 18 12 18Z";
var mdiHvacOff = "M22.11 21.46L2.39 1.73L1.11 3L3 4.89V21H19.11L20.84 22.73L22.11 21.46M12 18C8.67 18 6 15.33 6 12C6 10.82 6.34 9.73 6.92 8.81L8.43 10.32C8.24 10.69 8.1 11.09 8.06 11.5H9.61L10.61 12.5H8.06C8.11 13.03 8.3 13.55 8.58 14H12.11L13.11 15H9.38C10.08 15.61 10.97 16 12 16C12.63 16 13.19 15.84 13.7 15.59L15.19 17.08C14.27 17.66 13.18 18 12 18M12 8C13.03 8 13.92 8.39 14.63 9H12.2L11.27 8.07C11.5 8.03 11.75 8 12 8M9.67 6.47L6.2 3H21V17.8L17.53 14.33C17.83 13.62 18 12.83 18 12C18 8.67 15.33 6 12 6C11.17 6 10.38 6.17 9.67 6.47M15.94 11.5H14.7L13.2 10H15.42C15.7 10.45 15.89 10.97 15.94 11.5Z";
var mdiHydraulicOilLevel = "M15 18C13.34 18 12 16.66 12 15C12 13 15 9.63 15 9.63S18 13 18 15C18 16.66 16.66 18 15 18M20 4V20H10V4H8V20C8 21.11 8.89 22 10 22H20C21.11 22 22 21.11 22 20V4H20M2 19L7 14L2 9V19M16 6V2H14V6H11V8H19V6H16Z";
var mdiHydraulicOilTemperature = "M9 18C7.34 18 6 16.66 6 15C6 13 9 9.63 9 9.63S12 13 12 15C12 16.66 10.66 18 9 18M14 4V20H4V4H2V20C2 21.11 2.89 22 4 22H14C15.11 22 16 21.11 16 20V4H14M10 6V2H8V6H5V8H13V6H10M21 17.5V5.5C21 4.67 20.33 4 19.5 4S18 4.67 18 5.5V17.5C17.37 17.97 17 18.71 17 19.5C17 20.88 18.12 22 19.5 22S22 20.88 22 19.5C22 18.71 21.63 18 21 17.5M20 13H19V6H20V13Z";
var mdiHydroPower = "M17.12 3.55A2 2 0 0 0 15.2 4.95L14.4 7.5A3 3 0 0 0 13.33 7.74L11.5 5.77L10.17 4.29A2 2 0 0 0 10.05 7.12L11.86 9.09A3 3 0 0 0 11.64 9.6A3 3 0 0 0 11.53 10.13L8.92 10.71L6.96 11.15A2 2 0 0 0 9.35 12.67L11.96 12.08A3 3 0 0 0 12.7 12.89L11.9 15.44L11.3 17.35A2 2 0 0 0 13.8 16.04L14.61 13.5A3 3 0 0 0 15.68 13.26L17.5 15.23L18.83 16.7A2 2 0 0 0 18.96 13.88L17.15 11.91A3 3 0 0 0 17.36 11.4A3 3 0 0 0 17.5 10.86L20.09 10.28L22.04 9.85A2 2 0 0 0 19.66 8.33L17.05 8.91A3 3 0 0 0 16.31 8.11L17.11 5.55L17.71 3.65A2 2 0 0 0 17.12 3.55M14.56 9A1.5 1.5 0 0 1 14.95 9.07A1.5 1.5 0 0 1 15.93 10.95A1.5 1.5 0 0 1 14.05 11.93A1.5 1.5 0 0 1 13.07 10.05A1.5 1.5 0 0 1 14.55 9M8 13.67C6.78 14.53 5.39 15 4 15H2V17H4C5.37 17 6.74 16.65 8 16C8.77 16.4 9.58 16.66 10.41 16.81L10.94 15.14L11.03 14.88C9.97 14.73 8.93 14.32 8 13.67M20.45 15C20.5 15.7 20.33 16.41 19.91 17C19.93 17 19.97 17 20 17H22V15H20.45M8 17.67C6.78 18.53 5.39 19 4 19H2V21H4C5.37 21 6.74 20.65 8 20C10.5 21.3 13.5 21.3 16 20C17.26 20.65 18.62 21 20 21H22V19H20C18.61 19 17.22 18.53 16 17.67C13.56 19.38 10.44 19.38 8 17.67Z";
var mdiHydrogenStation = "M6 3C4.89 3 4 3.9 4 5V21H14V13.5H15.5V18.5C15.5 19.88 16.62 21 18 21S20.5 19.88 20.5 18.5V9C20.5 8.31 20.22 7.68 19.77 7.23L19.78 7.22L16.06 3.5L15 4.56L17.11 6.67C16.17 7.03 15.5 7.93 15.5 9C15.5 10.38 16.62 11.5 18 11.5C18.36 11.5 18.69 11.42 19 11.29V18.5C19 19.05 18.55 19.5 18 19.5S17 19.05 17 18.5V14C17 12.9 16.11 12 15 12H14V5C14 3.9 13.11 3 12 3H6M6 7H8V11H10V7H12V17H10V13H8V17H6V7M18 8C18.55 8 19 8.45 19 9S18.55 10 18 10 17 9.55 17 9 17.45 8 18 8Z";
var mdiIceCream = "M17.5 6.05C17.25 3.22 14.89 1 12 1S6.75 3.22 6.5 6.05C5.09 6.28 4 7.5 4 9C4 10.66 5.34 12 7 12L12 22L17 12C18.66 12 20 10.66 20 9C20 7.5 18.91 6.28 17.5 6.05M12 17.53L8.89 11.31C8.95 11.26 9 11.21 9.08 11.16C9.93 11.69 10.93 12 12 12S14.07 11.69 14.92 11.16C15 11.21 15.05 11.26 15.11 11.31L12 17.53Z";
var mdiIceCreamOff = "M22.11 21.46L2.39 1.73L1.11 3L4.95 6.84C4.37 7.38 4 8.14 4 9C4 10.66 5.34 12 7 12L12 22L14.7 16.59L20.84 22.73L22.11 21.46M12 17.53L8.89 11.31C8.95 11.26 9 11.21 9.08 11.16C9.21 11.24 9.35 11.3 9.5 11.37L13.21 15.1L12 17.53M7.15 3.95C8.07 2.2 9.89 1 12 1C14.89 1 17.25 3.22 17.5 6.05C18.91 6.28 20 7.5 20 9C20 10.66 18.66 12 17 12L16.4 13.2L7.15 3.95Z";
var mdiIcePop = "M18.15 14.96L9.95 18.65L5.85 9.65C7.21 9.13 8.12 7.82 8.15 6.36C8.14 5 7.36 3.76 6.15 3.15C6.54 2.8 7 2.5 7.45 2.25C9.71 1.25 12.37 2.23 13.45 4.46M13.15 18.36L14.75 21.86L17.45 20.65L15.85 17.15";
var mdiIdCard = "M4 4C2.89 4 2 4.89 2 6V18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4H4M4 6H20V10H4V6M4 12H8V14H4V12M10 12H20V14H10V12M4 16H14V18H4V16M16 16H20V18H16V16Z";
var mdiIdentifier = "M10 7V9H9V15H10V17H6V15H7V9H6V7H10M16 7C17.11 7 18 7.9 18 9V15C18 16.11 17.11 17 16 17H12V7M16 9H14V15H16V9Z";
var mdiIdeogramCjk = "M11 4V6H4V10H6V8H18V10H20V6H13V4M8 10V12H13.59L11.59 14H4V16H11V18H10V20H13V16H20V14H14.21L16 12.21V10Z";
var mdiIdeogramCjkVariant = "M11 4V6H4V8H15.36C15.13 8.87 14.63 9.77 13.88 10.69C13.35 11.35 12.71 12 12 12.67C11.29 12 10.65 11.35 10.12 10.69C9.65 10.12 9.3 9.55 9.03 9H6.85C7.21 10.05 7.82 11.03 8.56 11.95C9.13 12.66 9.79 13.34 10.5 14L5.36 18.23L6.64 19.77L12 15.34L17.36 19.77L18.64 18.23L13.5 14C14.21 13.34 14.87 12.66 15.44 11.95C16.41 10.74 17.16 9.43 17.4 8H20V6H13V4Z";
var mdiImage = "M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z";
var mdiImageAlbum = "M6,19L9,15.14L11.14,17.72L14.14,13.86L18,19H6M6,4H11V12L8.5,10.5L6,12M18,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V4A2,2 0 0,0 18,2Z";
var mdiImageArea = "M20,5A2,2 0 0,1 22,7V17A2,2 0 0,1 20,19H4C2.89,19 2,18.1 2,17V7C2,5.89 2.89,5 4,5H20M5,16H19L14.5,10L11,14.5L8.5,11.5L5,16Z";
var mdiImageAreaClose = "M12,23L8,19H16L12,23M20,3A2,2 0 0,1 22,5V15A2,2 0 0,1 20,17H4A2,2 0 0,1 2,15V5A2,2 0 0,1 4,3H20M5,14H19L14.5,8L11,12.5L8.5,9.5L5,14Z";
var mdiImageAutoAdjust = "M19 10V19H5V5H14V3H5C3.92 3 3 3.9 3 5V19C3 20.1 3.92 21 5 21H19C20.12 21 21 20.1 21 19V10H19M17 10L17.94 7.94L20 7L17.94 6.06L17 4L16.06 6.06L14 7L16.06 7.94L17 10M13.25 10.75L12 8L10.75 10.75L8 12L10.75 13.25L12 16L13.25 13.25L16 12L13.25 10.75Z";
var mdiImageBroken = "M19,3A2,2 0 0,1 21,5V11H19V13H19L17,13V15H15V17H13V19H11V21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H19M21,15V19A2,2 0 0,1 19,21H19L15,21V19H17V17H19V15H21M19,8.5A0.5,0.5 0 0,0 18.5,8H5.5A0.5,0.5 0 0,0 5,8.5V15.5A0.5,0.5 0 0,0 5.5,16H11V15H13V13H15V11H17V9H19V8.5Z";
var mdiImageBrokenVariant = "M21,5V11.59L18,8.58L14,12.59L10,8.59L6,12.59L3,9.58V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5M18,11.42L21,14.43V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V12.42L6,15.41L10,11.41L14,15.41";
var mdiImageCheck = "M12.5 21C12.18 20.23 12 19.39 12 18.5C12 18.33 12 18.17 12.03 18H5L8.5 13.5L11 16.5L14.5 12L15.19 12.92C16.16 12.34 17.29 12 18.5 12C19.39 12 20.23 12.18 21 12.5V5C21 4.47 20.79 3.96 20.41 3.59C20.04 3.21 19.53 3 19 3H5C3.9 3 3 3.9 3 5V19C3 19.53 3.21 20.04 3.59 20.41C3.96 20.79 4.47 21 5 21H12.5M17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25L17.75 22Z";
var mdiImageCheckOutline = "M12.18 17C12.54 15.5 13.43 14.16 14.68 13.25L13.96 12.29L11.21 15.83L9.25 13.47L6.5 17H12.18M5 5V19H12.03C12.09 19.7 12.24 20.38 12.5 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 3.9 3.9 3 5 3H19C19.53 3 20.04 3.21 20.41 3.59C20.79 3.96 21 4.47 21 5V12.5C20.38 12.24 19.7 12.09 19 12.03V5H5M17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25L17.75 22Z";
var mdiImageEdit = "M22.7 14.3L21.7 15.3L19.7 13.3L20.7 12.3C20.8 12.2 20.9 12.1 21.1 12.1C21.2 12.1 21.4 12.2 21.5 12.3L22.8 13.6C22.9 13.8 22.9 14.1 22.7 14.3M13 19.9V22H15.1L21.2 15.9L19.2 13.9L13 19.9M21 5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H11V19.1L12.1 18H5L8.5 13.5L11 16.5L14.5 12L16.1 14.1L21 9.1V5Z";
var mdiImageEditOutline = "M22.7 14.3L21.7 15.3L19.7 13.3L20.7 12.3C20.8 12.2 20.9 12.1 21.1 12.1C21.2 12.1 21.4 12.2 21.5 12.3L22.8 13.6C22.9 13.8 22.9 14.1 22.7 14.3M13 19.9V22H15.1L21.2 15.9L19.2 13.9L13 19.9M11.21 15.83L9.25 13.47L6.5 17H13.12L15.66 14.55L13.96 12.29L11.21 15.83M11 19.9V19.05L11.05 19H5V5H19V11.31L21 9.38V5C21 3.9 20.11 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H11V19.9Z";
var mdiImageFilterBlackWhite = "M19,19L12,11V19H5L12,11V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiImageFilterCenterFocus = "M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M19,19H15V21H19A2,2 0 0,0 21,19V15H19M19,3H15V5H19V9H21V5A2,2 0 0,0 19,3M5,5H9V3H5A2,2 0 0,0 3,5V9H5M5,15H3V19A2,2 0 0,0 5,21H9V19H5V15Z";
var mdiImageFilterCenterFocusStrong = "M12 8C8.44 8 6.65 12.31 9.17 14.83C11.69 17.35 16 15.56 16 12C16 9.79 14.21 8 12 8M5 15H3V19C3 20.1 3.9 21 5 21H9V19H5M5 5H9V3H5C3.9 3 3 3.9 3 5V9H5M19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3M19 19H15V21H19C20.1 21 21 20.1 21 19V15H19";
var mdiImageFilterCenterFocusStrongOutline = "M17 12C17 7.55 11.62 5.31 8.46 8.46C5.31 11.61 7.55 17 12 17C14.76 17 17 14.76 17 12M12 15C9.33 15 8 11.77 9.88 9.88C11.77 8 15 9.33 15 12C15 13.66 13.66 15 12 15M5 15H3V19C3 20.1 3.9 21 5 21H9V19H5M5 5H9V3H5C3.9 3 3 3.9 3 5V9H5M19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3M19 19H15V21H19C20.1 21 21 20.1 21 19V15H19";
var mdiImageFilterCenterFocusWeak = "M5,15H3V19A2,2 0 0,0 5,21H9V19H5M5,5H9V3H5A2,2 0 0,0 3,5V9H5M19,3H15V5H19V9H21V5A2,2 0 0,0 19,3M19,19H15V21H19A2,2 0 0,0 21,19V15H19M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8M12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14Z";
var mdiImageFilterDrama = "M6.5 20H18.5Q20.38 20 21.69 18.69 23 17.38 23 15.5 23 13.8 21.79 12.4 20.58 11 19 11 19 8.05 17 6.03 14.95 4 12 4 9.88 4 8.29 5.08 6.7 6.15 6.25 8 8.8 8.45 10.4 10.19 12 11.93 12 14.5H10Q10 12.68 8.66 11.34 7.33 10 5.5 10T2.34 11.34Q1 12.68 1 14.5 1 16.8 2.6 18.4T6.5 20Z";
var mdiImageFilterDramaOutline = "M6.5 20Q4.2 20 2.6 18.4T1 14.5Q1 12.55 2.21 11.06 3.43 9.57 5.25 9.15 5.88 6.9 7.73 5.45 9.57 4 12 4 15 4 17 6.06 19 8.13 19 11 20.88 11.2 21.94 12.55 23 13.9 23 15.5 23 17.35 21.69 18.68 20.38 20 18.5 20M6.5 18H18.5Q19.55 18 20.27 17.27 21 16.55 21 15.5 21 14.45 20.27 13.73 19.55 13 18.5 13H17V11Q17 8.93 15.54 7.46 14.08 6 12 6 10.43 6 9.2 6.86 8 7.73 7.4 9.07 9.35 9.4 10.68 10.91 12 12.43 12 14.5H10Q10 13.05 9 12.03 7.95 11 6.5 11 5.05 11 4.03 12.03 3 13.05 3 14.5 3 15.95 4.03 17 5.05 18 6.5 18Z";
var mdiImageFilterFrames = "M18,8H6V18H18M20,20H4V6H8.5L12.04,2.5L15.5,6H20M20,4H16L12,0L8,4H4A2,2 0 0,0 2,6V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V6A2,2 0 0,0 20,4Z";
var mdiImageFilterHdr = "M14,6L10.25,11L13.1,14.8L11.5,16C9.81,13.75 7,10 7,10L1,18H23L14,6Z";
var mdiImageFilterHdrOutline = "M23 18H1L8.25 8.33L10.25 11L14 6L23 18M11.5 12.67L14 16L19 16L14 9.33L11.5 12.67M5 16L11.5 16L8.25 11.67L5 16Z";
var mdiImageFilterNone = "M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M3,5H1V21A2,2 0 0,0 3,23H19V21H3V5Z";
var mdiImageFilterTiltShift = "M5.68,19.74C7.16,20.95 9,21.75 11,21.95V19.93C9.54,19.75 8.21,19.17 7.1,18.31M13,19.93V21.95C15,21.75 16.84,20.95 18.32,19.74L16.89,18.31C15.79,19.17 14.46,19.75 13,19.93M18.31,16.9L19.74,18.33C20.95,16.85 21.75,15 21.95,13H19.93C19.75,14.46 19.17,15.79 18.31,16.9M15,12A3,3 0 0,0 12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12M4.07,13H2.05C2.25,15 3.05,16.84 4.26,18.32L5.69,16.89C4.83,15.79 4.25,14.46 4.07,13M5.69,7.1L4.26,5.68C3.05,7.16 2.25,9 2.05,11H4.07C4.25,9.54 4.83,8.21 5.69,7.1M19.93,11H21.95C21.75,9 20.95,7.16 19.74,5.68L18.31,7.1C19.17,8.21 19.75,9.54 19.93,11M18.32,4.26C16.84,3.05 15,2.25 13,2.05V4.07C14.46,4.25 15.79,4.83 16.9,5.69M11,4.07V2.05C9,2.25 7.16,3.05 5.68,4.26L7.1,5.69C8.21,4.83 9.54,4.25 11,4.07Z";
var mdiImageFilterVintage = "M12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16M18.7,12.4C18.42,12.24 18.13,12.11 17.84,12C18.13,11.89 18.42,11.76 18.7,11.6C20.62,10.5 21.69,8.5 21.7,6.41C19.91,5.38 17.63,5.3 15.7,6.41C15.42,6.57 15.16,6.76 14.92,6.95C14.97,6.64 15,6.32 15,6C15,3.78 13.79,1.85 12,0.81C10.21,1.85 9,3.78 9,6C9,6.32 9.03,6.64 9.08,6.95C8.84,6.75 8.58,6.56 8.3,6.4C6.38,5.29 4.1,5.37 2.3,6.4C2.3,8.47 3.37,10.5 5.3,11.59C5.58,11.75 5.87,11.88 6.16,12C5.87,12.1 5.58,12.23 5.3,12.39C3.38,13.5 2.31,15.5 2.3,17.58C4.09,18.61 6.37,18.69 8.3,17.58C8.58,17.42 8.84,17.23 9.08,17.04C9.03,17.36 9,17.68 9,18C9,20.22 10.21,22.15 12,23.19C13.79,22.15 15,20.22 15,18C15,17.68 14.97,17.36 14.92,17.05C15.16,17.25 15.42,17.43 15.7,17.59C17.62,18.7 19.9,18.62 21.7,17.59C21.69,15.5 20.62,13.5 18.7,12.4Z";
var mdiImageFrame = "M10,14.29L6.5,19H17.46L14.75,15.46L12.78,17.8L10,14.29M5,21V7H18.96V21H5M12,2.4L14.61,5.03H9.37L12,2.4M5,5.03C4.5,5.03 4,5.22 3.61,5.61C3.2,6 3,6.46 3,7V21C3,21.5 3.2,22 3.61,22.39C4,22.8 4.5,23 5,23H18.96C19.5,23 19.96,22.8 20.37,22.39C20.77,22 21,21.5 21,21V7C21,6.46 20.77,6 20.37,5.61C19.96,5.22 19.5,5.03 18.96,5.03H16L12,1L7.96,5.03H5Z";
var mdiImageLock = "M21.8 16V14.5C21.8 13.1 20.4 12 19 12S16.2 13.1 16.2 14.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16M20.5 16H17.5V14.5C17.5 13.7 18.2 13.2 19 13.2S20.5 13.7 20.5 14.5V16M5 3C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H13.03C13 20.9 13 20.8 13 20.7V18H5L8.5 13.5L11 16.5L14.5 12L14.77 12.37C15.61 10.89 17.27 10 19 10C19.69 10 20.37 10.16 21 10.42V5C21 3.89 20.1 3 19 3H5Z";
var mdiImageLockOutline = "M21.8 16V14.5C21.8 13.1 20.4 12 19 12S16.2 13.1 16.2 14.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16M20.5 16H17.5V14.5C17.5 13.7 18.2 13.2 19 13.2S20.5 13.7 20.5 14.5V16M5 3C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H13.03C13 20.9 13 20.8 13 20.7V19H5V5H19V10C19.69 10 20.37 10.16 21 10.42V5C21 3.9 20.11 3 19 3H5M13.96 12.29L11.21 15.83L9.25 13.47L6.5 17H13C13.08 16.14 13.46 15.46 13.96 14.96C14.03 14.89 14.13 14.85 14.2 14.79V14.5C14.2 13.95 14.3 13.44 14.47 12.97L13.96 12.29Z";
var mdiImageMarker = "M13.55 18C13.97 19.08 14.59 20.12 15.19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.89 21 5V10.63C20.25 10.23 19.39 10 18.5 10C16.29 10 14.33 11.39 13.47 13.33L11 16.5L8.5 13.5L5 18H13.55M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiImageMarkerOutline = "M14 19C14.36 19.72 14.78 20.4 15.19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H19C20.11 3 21 3.9 21 5V10.63C20.39 10.3 19.71 10.09 19 10.03V5H5V19H14M13.96 12.29L11.21 15.83L9.25 13.47L6.5 17H13.22C13.09 16.5 13 16 13 15.5C13 14.35 13.38 13.26 14 12.37L13.96 12.29M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiImageMinus = "M15 18V20H23V18H15M13.3 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V13.3C20.4 13.1 19.7 13 19 13C17.9 13 16.8 13.3 15.9 13.9L14.5 12L11 16.5L8.5 13.5L5 18H13.1C13 18.3 13 18.7 13 19C13 19.7 13.1 20.4 13.3 21Z";
var mdiImageMinusOutline = "M15.4 14.21C14.47 14.91 13.75 15.88 13.35 17H6.5L9.25 13.47L11.21 15.83L13.96 12.29L15.4 14.21M5 19V5H19V13C19.7 13 20.37 13.13 21 13.35V5C21 3.9 20.11 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H13.35C13.13 20.37 13 19.7 13 19H5M15 18V20H23V18H15Z";
var mdiImageMove = "M15,3H19V0L24,5L19,10V7H15V3M21,11.94V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H12.06C12,3.33 12,3.67 12,4A8,8 0 0,0 20,12C20.33,12 20.67,12 21,11.94M19,18L14.5,12L11,16.5L8.5,13.5L5,18H19Z";
var mdiImageMultiple = "M22,16V4A2,2 0 0,0 20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16M11,12L13.03,14.71L16,11L20,16H8M2,6V20A2,2 0 0,0 4,22H18V20H4V6";
var mdiImageMultipleOutline = "M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M3,5H1V21A2,2 0 0,0 3,23H19V21H3M15.96,10.29L13.21,13.83L11.25,11.47L8.5,15H19.5L15.96,10.29Z";
var mdiImageOff = "M21 17.2L6.8 3H19C20.1 3 21 3.9 21 5V17.2M20.7 22L19.7 21H5C3.9 21 3 20.1 3 19V4.3L2 3.3L3.3 2L22 20.7L20.7 22M16.8 18L12.9 14.1L11 16.5L8.5 13.5L5 18H16.8Z";
var mdiImageOffOutline = "M22 20.7L3.3 2L2 3.3L3 4.3V19C3 20.1 3.9 21 5 21H19.7L20.7 22L22 20.7M5 19V6.3L12.6 13.9L11.1 15.8L9 13.1L6 17H15.7L17.7 19H5M8.8 5L6.8 3H19C20.1 3 21 3.9 21 5V17.2L19 15.2V5H8.8";
var mdiImageOutline = "M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M13.96,12.29L11.21,15.83L9.25,13.47L6.5,17H17.5L13.96,12.29Z";
var mdiImagePlus = "M18 15V18H15V20H18V23H20V20H23V18H20V15H18M13.3 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V13.3C20.4 13.1 19.7 13 19 13C17.9 13 16.8 13.3 15.9 13.9L14.5 12L11 16.5L8.5 13.5L5 18H13.1C13 18.3 13 18.7 13 19C13 19.7 13.1 20.4 13.3 21Z";
var mdiImagePlusOutline = "M13 19C13 19.7 13.13 20.37 13.35 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H19C20.11 3 21 3.9 21 5V13.35C20.37 13.13 19.7 13 19 13V5H5V19H13M13.96 12.29L11.21 15.83L9.25 13.47L6.5 17H13.35C13.75 15.88 14.47 14.91 15.4 14.21L13.96 12.29M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiImageRefresh = "M12 18.5C12 19.39 12.18 20.23 12.5 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.89 21 5V12.5C20.23 12.18 19.39 12 18.5 12C17.29 12 16.16 12.34 15.19 12.92L14.5 12L11 16.5L8.5 13.5L5 18H12.03C12 18.17 12 18.33 12 18.5M22 18.5V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22Z";
var mdiImageRefreshOutline = "M14.68 13.25C13.45 14.15 12.54 15.47 12.18 17H6.5L9.25 13.47L11.21 15.83L13.96 12.29L14.68 13.25M5 19V5H19V12.03C19.7 12.09 20.38 12.24 21 12.5V5C21 3.9 20.11 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H12.5C12.24 20.38 12.09 19.7 12.03 19H5M22 18.5V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22Z";
var mdiImageRemove = "M13.3 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V13.3C20.4 13.1 19.7 13 19 13C17.9 13 16.8 13.3 15.9 13.9L14.5 12L11 16.5L8.5 13.5L5 18H13.1C13 18.3 13 18.7 13 19C13 19.7 13.1 20.4 13.3 21M20.4 19L22.5 21.1L21.1 22.5L19 20.4L16.9 22.5L15.5 21.1L17.6 19L15.5 16.9L16.9 15.5L19 17.6L21.1 15.5L22.5 16.9L20.4 19Z";
var mdiImageRemoveOutline = "M13 19C13 19.7 13.13 20.37 13.35 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H19C20.11 3 21 3.9 21 5V13.35C20.37 13.13 19.7 13 19 13V5H5V19H13M11.21 15.83L9.25 13.47L6.5 17H13.35C13.75 15.88 14.47 14.91 15.4 14.21L13.96 12.29L11.21 15.83M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiImageSearch = "M15.5,2C18,2 20,4 20,6.5C20,7.38 19.75,8.21 19.31,8.9L22.39,12L21,13.39L17.88,10.32C17.19,10.75 16.37,11 15.5,11C13,11 11,9 11,6.5C11,4 13,2 15.5,2M15.5,4A2.5,2.5 0 0,0 13,6.5A2.5,2.5 0 0,0 15.5,9A2.5,2.5 0 0,0 18,6.5A2.5,2.5 0 0,0 15.5,4M7.5,14.5L4,19H18L13.5,13L10,17.5L7.5,14.5M20,20A2,2 0 0,1 18,22H4A2,2 0 0,1 2,20V6A2,2 0 0,1 4,4H9.5C9.18,4.77 9,5.61 9,6.5A6.5,6.5 0 0,0 15.5,13C16.18,13 16.84,12.89 17.46,12.7L20,15.24V20Z";
var mdiImageSearchOutline = "M15.5,9C16.2,9 16.79,8.76 17.27,8.27C17.76,7.79 18,7.2 18,6.5C18,5.83 17.76,5.23 17.27,4.73C16.79,4.23 16.2,4 15.5,4C14.83,4 14.23,4.23 13.73,4.73C13.23,5.23 13,5.83 13,6.5C13,7.2 13.23,7.79 13.73,8.27C14.23,8.76 14.83,9 15.5,9M19.31,8.91L22.41,12L21,13.41L17.86,10.31C17.08,10.78 16.28,11 15.47,11C14.22,11 13.16,10.58 12.3,9.7C11.45,8.83 11,7.77 11,6.5C11,5.27 11.45,4.2 12.33,3.33C13.2,2.45 14.27,2 15.5,2C16.77,2 17.83,2.45 18.7,3.33C19.58,4.2 20,5.27 20,6.5C20,7.33 19.78,8.13 19.31,8.91M16.5,18H5.5L8.25,14.5L10.22,16.83L12.94,13.31L16.5,18M18,13L20,15V20C20,20.55 19.81,21 19.41,21.4C19,21.79 18.53,22 18,22H4C3.45,22 3,21.79 2.6,21.4C2.21,21 2,20.55 2,20V6C2,5.47 2.21,5 2.6,4.59C3,4.19 3.45,4 4,4H9.5C9.2,4.64 9.03,5.31 9,6H4V20H18V13Z";
var mdiImageSizeSelectActual = "M21,3H3C2,3 1,4 1,5V19A2,2 0 0,0 3,21H21C22,21 23,20 23,19V5C23,4 22,3 21,3M5,17L8.5,12.5L11,15.5L14.5,11L19,17H5Z";
var mdiImageSizeSelectLarge = "M21,15H23V17H21V15M21,11H23V13H21V11M23,19H21V21C22,21 23,20 23,19M13,3H15V5H13V3M21,7H23V9H21V7M21,3V5H23C23,4 22,3 21,3M1,7H3V9H1V7M17,3H19V5H17V3M17,19H19V21H17V19M3,3C2,3 1,4 1,5H3V3M9,3H11V5H9V3M5,3H7V5H5V3M1,11V19A2,2 0 0,0 3,21H15V11H1M3,19L5.5,15.79L7.29,17.94L9.79,14.72L13,19H3Z";
var mdiImageSizeSelectSmall = "M23,15H21V17H23V15M23,11H21V13H23V11M23,19H21V21C22,21 23,20 23,19M15,3H13V5H15V3M23,7H21V9H23V7M21,3V5H23C23,4 22,3 21,3M3,21H11V15H1V19A2,2 0 0,0 3,21M3,7H1V9H3V7M15,19H13V21H15V19M19,3H17V5H19V3M19,19H17V21H19V19M3,3C2,3 1,4 1,5H3V3M3,11H1V13H3V11M11,3H9V5H11V3M7,3H5V5H7V3Z";
var mdiImageSync = "M8.5 13.5L5 18H13.03C13.11 19.1 13.47 20.12 14.03 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.89 21 5V11.18C20.5 11.07 20 11 19.5 11C17.78 11 16.23 11.67 15.07 12.76L14.5 12L11 16.5L8.5 13.5M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5Z";
var mdiImageSyncOutline = "M13.18 19C13.35 19.72 13.64 20.39 14.03 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3H19C20.11 3 21 3.9 21 5V11.18C20.5 11.07 20 11 19.5 11C19.33 11 19.17 11 19 11.03V5H5V19H13.18M11.21 15.83L9.25 13.47L6.5 17H13.03C13.14 15.54 13.73 14.22 14.64 13.19L13.96 12.29L11.21 15.83M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20Z";
var mdiImageText = "M22 13H14V11H22V13M22 7H14V9H22V7M14 17H22V15H14V17M12 9V15C12 16.1 11.1 17 10 17H4C2.9 17 2 16.1 2 15V9C2 7.9 2.9 7 4 7H10C11.1 7 12 7.9 12 9M10.5 15L8.3 12L6.5 14.3L5.3 12.8L3.5 15H10.5Z";
var mdiImport = "M14,12L10,8V11H2V13H10V16M20,18V6C20,4.89 19.1,4 18,4H6A2,2 0 0,0 4,6V9H6V6H18V18H6V15H4V18A2,2 0 0,0 6,20H18A2,2 0 0,0 20,18Z";
var mdiInbox = "M19,15H15A3,3 0 0,1 12,18A3,3 0 0,1 9,15H5V5H19M19,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiInboxArrowDown = "M16,10H14V7H10V10H8L12,14M19,15H15A3,3 0 0,1 12,18A3,3 0 0,1 9,15H5V5H19M19,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiInboxArrowDownOutline = "M19 3H5A2 2 0 0 0 3 5V19A2 2 0 0 0 5 21H19A2 2 0 0 0 21 19V5A2 2 0 0 0 19 3M5 19V17H8.13A4.13 4.13 0 0 0 9.4 19M19 19H14.6A4.13 4.13 0 0 0 15.87 17H19M19 15H14V16A2 2 0 0 1 10 16V15H5V5H19M16 10H14V7H10V10H8L12 14";
var mdiInboxArrowUp = "M14,14H10V11H8L12,7L16,11H14V14M16,11M5,15V5H19V15H15A3,3 0 0,1 12,18A3,3 0 0,1 9,15H5M19,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3";
var mdiInboxArrowUpOutline = "M19 3H5A2 2 0 0 0 3 5V19A2 2 0 0 0 5 21H19A2 2 0 0 0 21 19V5A2 2 0 0 0 19 3M5 19V17H8.13A4.13 4.13 0 0 0 9.4 19M19 19H14.6A4.13 4.13 0 0 0 15.87 17H19M19 15H14V16A2 2 0 0 1 10 16V15H5V5H19M8 11H10V14H14V11H16L12 7";
var mdiInboxFull = "M19 15V5H5V15H9C9 16.66 10.34 18 12 18C13.66 18 15 16.66 15 15H19M19 3C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19L3 5C3 3.9 3.89 3 5 3H19M7 13V11H17V13H7M7 9V7H17V9H7Z";
var mdiInboxFullOutline = "M19 3C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19M5 19H9.4C8.79 18.47 8.35 17.78 8.13 17H5V19M19 19V17H15.87C15.65 17.78 15.21 18.47 14.6 19H19M19 15V5H5V15H10V16C10 18.67 14 18.67 14 16V15H19M7 7H17V9H7V7M17 11V13H7V11H17Z";
var mdiInboxMultiple = "M19,8V5H5V8H9A3,3 0 0,0 12,11A3,3 0 0,0 15,8H19M19,3A2,2 0 0,1 21,5V12A2,2 0 0,1 19,14H5A2,2 0 0,1 3,12V5A2,2 0 0,1 5,3H19M3,15H9A3,3 0 0,0 12,18A3,3 0 0,0 15,15H21V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V15Z";
var mdiInboxMultipleOutline = "M19,3A2,2 0 0,1 21,5V12A2,2 0 0,1 19,14H5A2,2 0 0,1 3,12V5A2,2 0 0,1 5,3H19M5,10V12H9.4C8.8,11.47 8.34,10.78 8.13,10H5M19,12V10H15.87C15.66,10.78 15.2,11.47 14.6,12H19M19,8V5H5V8H10V9C10,10.07 10.93,11 12,11C13.07,11 14,10.07 14,9V8H19M21,19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V15H10V16C10,17.07 10.93,18 12,18C13.07,18 14,17.07 14,16V15H21V19M5,17V19H9.4C8.8,18.47 8.34,17.78 8.13,17H5M19,19V17H15.87C15.66,17.78 15.2,18.47 14.6,19H19Z";
var mdiInboxOutline = "M19 3H5A2 2 0 0 0 3 5V19A2 2 0 0 0 5 21H19A2 2 0 0 0 21 19V5A2 2 0 0 0 19 3M5 19V17H8.13A4.13 4.13 0 0 0 9.4 19M19 19H14.6A4.13 4.13 0 0 0 15.87 17H19M19 15H14V16A2 2 0 0 1 10 16V15H5V5H19Z";
var mdiInboxRemove = "M19 15H15C15 16.7 13.7 18 12 18S9 16.7 9 15H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M14.1 6.5L15.5 7.9L13.4 10L15.5 12.1L14.1 13.5L12 11.4L9.9 13.5L8.5 12.1L10.6 10L8.5 7.9L9.9 6.5L12 8.6L14.1 6.5Z";
var mdiInboxRemoveOutline = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M5 19V17H8.1C8.3 17.8 8.8 18.5 9.4 19M19 19H14.6C15.2 18.5 15.7 17.8 15.9 17H19M19 15H14V16C14 17.1 13.1 18 12 18S10 17.1 10 16V15H5V5H19V15M14.1 6.5L15.5 7.9L13.4 10L15.5 12.1L14.1 13.5L12 11.4L9.9 13.5L8.5 12.1L10.6 10L8.5 7.9L9.9 6.5L12 8.6L14.1 6.5Z";
var mdiIncognito = "M17.06 13C15.2 13 13.64 14.33 13.24 16.1C12.29 15.69 11.42 15.8 10.76 16.09C10.35 14.31 8.79 13 6.94 13C4.77 13 3 14.79 3 17C3 19.21 4.77 21 6.94 21C9 21 10.68 19.38 10.84 17.32C11.18 17.08 12.07 16.63 13.16 17.34C13.34 19.39 15 21 17.06 21C19.23 21 21 19.21 21 17C21 14.79 19.23 13 17.06 13M6.94 19.86C5.38 19.86 4.13 18.58 4.13 17S5.39 14.14 6.94 14.14C8.5 14.14 9.75 15.42 9.75 17S8.5 19.86 6.94 19.86M17.06 19.86C15.5 19.86 14.25 18.58 14.25 17S15.5 14.14 17.06 14.14C18.62 14.14 19.88 15.42 19.88 17S18.61 19.86 17.06 19.86M22 10.5H2V12H22V10.5M15.53 2.63C15.31 2.14 14.75 1.88 14.22 2.05L12 2.79L9.77 2.05L9.72 2.04C9.19 1.89 8.63 2.17 8.43 2.68L6 9H18L15.56 2.68L15.53 2.63Z";
var mdiIncognitoCircle = "M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22 2 17.5 2 12 6.5 2 12 2M14.92 12.81C13.84 12.81 12.95 13.56 12.71 14.56C12.17 14.33 11.66 14.39 11.29 14.55C11.05 13.55 10.15 12.81 9.08 12.81C7.83 12.81 6.82 13.82 6.82 15.07C6.82 16.32 7.83 17.33 9.08 17.33C10.28 17.33 11.24 16.42 11.33 15.25C11.53 15.12 12.04 14.86 12.67 15.26C12.77 16.42 13.73 17.33 14.92 17.33C16.17 17.33 17.18 16.32 17.18 15.07C17.18 13.82 16.17 12.81 14.92 12.81M9.08 13.45C10 13.45 10.7 14.18 10.7 15.07C10.7 15.96 10 16.69 9.08 16.69C8.19 16.69 7.46 15.96 7.46 15.07C7.46 14.18 8.19 13.45 9.08 13.45M14.92 13.45C15.81 13.45 16.54 14.18 16.54 15.07C16.54 15.96 15.81 16.69 14.92 16.69C14 16.69 13.3 15.96 13.3 15.07C13.3 14.18 14 13.45 14.92 13.45M17.83 11.5H6.17V12.17H17.83V11.5M14.15 6.89C14 6.59 13.67 6.43 13.35 6.53L12 7L10.65 6.53L10.61 6.5C10.29 6.43 9.95 6.61 9.84 6.92L8.36 10.83H15.64L14.16 6.92L14.15 6.89Z";
var mdiIncognitoCircleOff = "M22.11 21.46L2.39 1.73L1.11 3L4.06 5.95C2.77 7.63 2 9.72 2 12C2 17.5 6.5 22 12 22C14.28 22 16.37 21.23 18.05 19.94L20.84 22.73L22.11 21.46M8.94 10.83H8.36L8.5 10.41L8.94 10.83M6.17 11.5H9.61L10.28 12.17H6.17V11.5M14.92 17.33C13.73 17.33 12.77 16.42 12.67 15.26C12.04 14.86 11.53 15.12 11.33 15.25C11.24 16.42 10.28 17.33 9.08 17.33C7.83 17.33 6.82 16.32 6.82 15.07C6.82 13.82 7.83 12.81 9.08 12.81C10.15 12.81 11.05 13.55 11.29 14.55C11.65 14.4 12.13 14.34 12.65 14.54L13.31 15.2C13.37 16 14 16.61 14.78 16.67L15.38 17.27C15.23 17.3 15.08 17.33 14.92 17.33M9.94 6.74L6.72 3.5C8.25 2.56 10.06 2 12 2C17.5 2 22 6.5 22 12C22 13.94 21.44 15.75 20.5 17.28L15.37 12.17H17.83V11.5H14.7L14.03 10.83H15.64L14.16 6.92L14.15 6.89C14 6.59 13.67 6.43 13.35 6.53L12 7L10.65 6.53L10.61 6.5C10.36 6.45 10.1 6.55 9.94 6.74M10.7 15.07C10.7 15.96 10 16.69 9.08 16.69C8.19 16.69 7.46 15.96 7.46 15.07S8.19 13.45 9.08 13.45C10 13.45 10.7 14.18 10.7 15.07Z";
var mdiIncognitoOff = "M22.11 21.46L2.39 1.73L1.11 3L6.31 8.2L6 9H7.11L8.61 10.5H2V12H10.11L13.5 15.37C13.38 15.61 13.3 15.85 13.24 16.1C12.29 15.69 11.41 15.8 10.76 16.09C10.35 14.31 8.79 13 6.94 13C4.77 13 3 14.79 3 17C3 19.21 4.77 21 6.94 21C9 21 10.68 19.38 10.84 17.32C11.18 17.08 12.07 16.63 13.16 17.34C13.34 19.39 15 21 17.06 21C17.66 21 18.22 20.86 18.72 20.61L20.84 22.73L22.11 21.46M6.94 19.86C5.38 19.86 4.13 18.58 4.13 17C4.13 15.42 5.39 14.14 6.94 14.14C8.5 14.14 9.75 15.42 9.75 17C9.75 18.58 8.5 19.86 6.94 19.86M17.06 19.86C15.5 19.86 14.25 18.58 14.25 17C14.25 16.74 14.29 16.5 14.36 16.25L17.84 19.73C17.59 19.81 17.34 19.86 17.06 19.86M22 12H15.2L13.7 10.5H22V12M17.06 13C19.23 13 21 14.79 21 17C21 17.25 20.97 17.5 20.93 17.73L19.84 16.64C19.68 15.34 18.66 14.32 17.38 14.17L16.29 13.09C16.54 13.03 16.8 13 17.06 13M12.2 9L7.72 4.5L8.43 2.68C8.63 2.17 9.19 1.89 9.72 2.04L9.77 2.05L12 2.79L14.22 2.05C14.75 1.88 15.32 2.14 15.54 2.63L15.56 2.68L18 9H12.2Z";
var mdiInduction = "M23 2C20.75 2 18.75 2.61 17.19 3.33C15.79 2.61 14 2 12 2S8.21 2.61 6.81 3.33C5.25 2.61 3.25 2 1 2V4C2.36 4 3.61 4.27 4.71 4.64C4.03 5.15 3.63 5.54 3.59 5.59C3.21 5.96 3 6.47 3 7V18C3 20.21 4.79 22 7 22S11 20.21 11 18V7C11 6.42 10.75 5.88 10.32 5.5C10.26 5.45 9.8 5.05 9 4.54C9.92 4.22 10.92 4 12 4S14.08 4.22 15 4.54C14.2 5.05 13.74 5.45 13.68 5.5C13.25 5.88 13 6.42 13 7V18C13 20.21 14.79 22 17 22S21 20.21 21 18V7C21 6.47 20.79 5.96 20.41 5.59C20.37 5.54 19.97 5.15 19.29 4.64C20.39 4.27 21.64 4 23 4V2M9 7V18C9 19.11 8.11 20 7 20S5 19.11 5 18V7C5 7 5.7 6.31 6.87 5.58C8.2 6.31 9 7 9 7M19 7V18C19 19.11 18.11 20 17 20S15 19.11 15 18V7C15 7 15.8 6.31 17.13 5.58C18.3 6.31 19 7 19 7Z";
var mdiInfinity = "M18.6,6.62C21.58,6.62 24,9 24,12C24,14.96 21.58,17.37 18.6,17.37C17.15,17.37 15.8,16.81 14.78,15.8L12,13.34L9.17,15.85C8.2,16.82 6.84,17.38 5.4,17.38C2.42,17.38 0,14.96 0,12C0,9.04 2.42,6.62 5.4,6.62C6.84,6.62 8.2,7.18 9.22,8.2L12,10.66L14.83,8.15C15.8,7.18 17.16,6.62 18.6,6.62M7.8,14.39L10.5,12L7.84,9.65C7.16,8.97 6.31,8.62 5.4,8.62C3.53,8.62 2,10.13 2,12C2,13.87 3.53,15.38 5.4,15.38C6.31,15.38 7.16,15.03 7.8,14.39M16.2,9.61L13.5,12L16.16,14.35C16.84,15.03 17.7,15.38 18.6,15.38C20.47,15.38 22,13.87 22,12C22,10.13 20.47,8.62 18.6,8.62C17.69,8.62 16.84,8.97 16.2,9.61Z";
var mdiInformation = "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiInformationBox = "M5 3H19C20.1 3 21 3.89 21 5V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 3.89 3.89 3 5 3M13 9V7H11V9H13M13 17V11H11V17H13Z";
var mdiInformationBoxOutline = "M13 9H11V7H13V9M13 17H11V11H13V17M5 3H19C20.1 3 21 3.89 21 5V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 3.89 3.89 3 5 3M19 19V5H5V19H19Z";
var mdiInformationOff = "M22.1 21.5L2.4 1.7L1.1 3L4.1 6C2.8 7.6 2 9.7 2 12C2 17.5 6.5 22 12 22C14.3 22 16.4 21.2 18 19.9L20.8 22.7L22.1 21.5M13 17H11V12.9L13 14.9V17M11 7.8L6.7 3.5C8.3 2.6 10.1 2 12 2C17.5 2 22 6.5 22 12C22 13.9 21.4 15.7 20.5 17.3L12.2 9H13V7H11V7.8Z";
var mdiInformationOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L4.1 6C2.8 7.6 2 9.7 2 12C2 17.5 6.5 22 12 22C14.3 22 16.4 21.2 18 19.9L20.8 22.7L22.1 21.5M12 20C7.6 20 4 16.4 4 12C4 10.3 4.6 8.7 5.5 7.4L11 12.9V17H13V14.9L16.6 18.5C15.3 19.4 13.7 20 12 20M8.2 5L6.7 3.5C8.3 2.6 10.1 2 12 2C17.5 2 22 6.5 22 12C22 13.9 21.4 15.7 20.5 17.3L19 15.8C19.6 14.7 20 13.4 20 12C20 7.6 16.4 4 12 4C10.6 4 9.3 4.4 8.2 5M11 7H13V9H11V7Z";
var mdiInformationOutline = "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z";
var mdiInformationSlabBox = "M5 3H19C20.1 3 21 3.89 21 5V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 3.89 3.89 3 5 3M11 9H13V7H11V9M14 17V15H13V11H10V13H11V15H10V17H14Z";
var mdiInformationSlabBoxOutline = "M11 9H13V7H11V9M14 17V15H13V11H10V13H11V15H10V17H14M5 3H19C20.1 3 21 3.89 21 5V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 3.89 3.89 3 5 3M19 19V5H5V19H19Z";
var mdiInformationSlabCircle = "M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22M11 7H13V9H11V7M14 17H10V15H11V13H10V11H13V15H14V17Z";
var mdiInformationSlabCircleOutline = "M11 7V9H13V7H11M14 17V15H13V11H10V13H11V15H10V17H14M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12M20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12Z";
var mdiInformationSlabSymbol = "M13 9H11V7H13V9M14 15V17H10V15H11V13H10V11H13V15H14Z";
var mdiInformationSymbol = "M11 9H13V7H11V9M11 17H13V11H11V17Z";
var mdiInformationVariant = "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z";
var mdiInformationVariantBox = "M5 3H19C20.1 3 21 3.89 21 5V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 3.89 3.89 3 5 3M12.3 7.29C12.11 7.5 12 7.74 12 8C12 8.27 12.11 8.5 12.3 8.71C12.5 8.9 12.74 9 13 9C13.27 9 13.5 8.9 13.71 8.71C13.9 8.5 14 8.27 14 8C14 7.74 13.9 7.5 13.71 7.29C13.5 7.11 13.27 7 13 7C12.74 7 12.5 7.11 12.3 7.29M9.8 11.97C9.7 12.06 9.7 12.07 9.77 12.17L9.82 12.25L9.85 12.31C9.92 12.44 9.93 12.44 10.04 12.36C10.17 12.27 10.39 12.13 10.76 11.91C11.68 11.32 11.5 12 11.09 13.5C10.87 14.33 10.59 15.39 10.38 16.62C10.14 18.37 11.71 17.47 12.12 17.2C12.5 16.96 13.44 16.3 13.66 16.15L13.7 16.13C13.82 16.04 13.77 16 13.68 15.86L13.62 15.78C13.54 15.67 13.46 15.75 13.46 15.75L13.3 15.86C12.85 16.16 12.23 16.59 12.13 16.25C12.04 16 12.41 14.64 12.79 13.25C12.96 12.64 13.13 12 13.26 11.47L13.28 11.41C13.35 10.97 13.5 10.12 12.77 10.18C11.97 10.25 9.8 11.97 9.8 11.97Z";
var mdiInformationVariantBoxOutline = "M12.3 7.29C12.5 7.11 12.74 7 13 7C13.27 7 13.5 7.11 13.71 7.29C13.9 7.5 14 7.74 14 8C14 8.27 13.9 8.5 13.71 8.71C13.5 8.9 13.27 9 13 9C12.74 9 12.5 8.9 12.3 8.71C12.11 8.5 12 8.27 12 8C12 7.74 12.11 7.5 12.3 7.29M9.8 11.97C9.8 11.97 11.97 10.25 12.76 10.18C13.5 10.12 13.35 10.97 13.28 11.41L13.27 11.47C13.13 12 12.96 12.64 12.79 13.25C12.41 14.64 12.04 16 12.13 16.25C12.23 16.59 12.85 16.16 13.3 15.86C13.36 15.82 13.41 15.78 13.46 15.75C13.46 15.75 13.54 15.67 13.62 15.78C13.64 15.81 13.66 15.84 13.68 15.86C13.77 16 13.82 16.05 13.7 16.13L13.66 16.15C13.44 16.3 12.5 16.96 12.12 17.2C11.71 17.47 10.14 18.37 10.38 16.62C10.59 15.39 10.87 14.33 11.09 13.5C11.5 12 11.68 11.32 10.76 11.91C10.39 12.13 10.17 12.27 10.04 12.36C9.93 12.44 9.92 12.44 9.85 12.31L9.82 12.25L9.77 12.17C9.7 12.07 9.7 12.06 9.8 11.97M5 3H19C20.1 3 21 3.89 21 5V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 3.89 3.89 3 5 3M19 19V5H5V19H19Z";
var mdiInformationVariantCircle = "M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22M12.3 7.29C12.5 7.11 12.74 7 13 7C13.27 7 13.5 7.11 13.71 7.29C13.9 7.5 14 7.74 14 8C14 8.27 13.9 8.5 13.71 8.71C13.5 8.9 13.27 9 13 9C12.74 9 12.5 8.9 12.3 8.71C12.11 8.5 12 8.27 12 8C12 7.74 12.11 7.5 12.3 7.29M9.8 11.97C9.8 11.97 11.97 10.25 12.76 10.18C13.5 10.12 13.35 10.97 13.28 11.41L13.27 11.47C13.13 12 12.96 12.64 12.79 13.25C12.41 14.64 12.04 16 12.13 16.25C12.23 16.59 12.85 16.16 13.3 15.86C13.36 15.82 13.41 15.78 13.46 15.75C13.46 15.75 13.54 15.67 13.62 15.78C13.64 15.81 13.66 15.84 13.68 15.86C13.77 16 13.82 16.05 13.7 16.13L13.66 16.15C13.44 16.3 12.5 16.96 12.12 17.2C11.71 17.47 10.14 18.37 10.38 16.62C10.59 15.39 10.87 14.33 11.09 13.5C11.5 12 11.68 11.32 10.76 11.91C10.39 12.13 10.17 12.27 10.04 12.36C9.93 12.44 9.92 12.44 9.85 12.31L9.82 12.25L9.77 12.17C9.7 12.07 9.7 12.06 9.8 11.97Z";
var mdiInformationVariantCircleOutline = "M12.3 7.29C12.5 7.11 12.74 7 13 7C13.27 7 13.5 7.11 13.71 7.29C13.9 7.5 14 7.74 14 8C14 8.27 13.9 8.5 13.71 8.71C13.5 8.9 13.27 9 13 9C12.74 9 12.5 8.9 12.3 8.71C12.11 8.5 12 8.27 12 8C12 7.74 12.11 7.5 12.3 7.29M9.8 11.97C9.8 11.97 11.97 10.25 12.76 10.18C13.5 10.12 13.35 10.97 13.28 11.41L13.27 11.47C13.13 12 12.96 12.64 12.79 13.25C12.41 14.64 12.04 16 12.13 16.25C12.23 16.59 12.85 16.16 13.3 15.86C13.36 15.82 13.41 15.78 13.46 15.75C13.46 15.75 13.54 15.67 13.62 15.78C13.64 15.81 13.66 15.84 13.68 15.86C13.77 16 13.82 16.05 13.7 16.13L13.66 16.15C13.44 16.3 12.5 16.96 12.12 17.2C11.71 17.47 10.14 18.37 10.38 16.62C10.59 15.39 10.87 14.33 11.09 13.5C11.5 12 11.68 11.32 10.76 11.91C10.39 12.13 10.17 12.27 10.04 12.36C9.93 12.44 9.92 12.44 9.85 12.31L9.82 12.25L9.77 12.17C9.7 12.07 9.7 12.06 9.8 11.97M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12M20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12Z";
var mdiInstagram = "M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z";
var mdiInstrumentTriangle = "M11.5 2H10.5V6.2C10.4 6.3 10.3 6.3 10.2 6.5L2.1 20.7C1.8 21.3 2.2 22 2.9 22H16V20H4.8L11 9.2L16.7 19.2L18.4 18.2L11.8 6.4L11.5 6.1V2M21 6H20V18L19.5 22H21.5L21 18V6Z";
var mdiIntegratedCircuitChip = "M10 4H20C21.11 4 22 4.89 22 6V8H18.59L16 10.59V14.59L14 16.59V20H10V16.59L8 14.59V9.41L10 7.41V4M18 11.41V14H22V10H19.41L18 11.41M6.59 8L8 6.59V4H4C2.89 4 2 4.89 2 6V8H6.59M6 14V10H2V14H6M8 17.41L6.59 16H2V18C2 19.11 2.89 20 4 20H8V17.41M17.41 16L16 17.41V20H20C21.11 20 22 19.11 22 18V16H17.41Z";
var mdiInvertColors = "M12,19.58V19.58C10.4,19.58 8.89,18.96 7.76,17.83C6.62,16.69 6,15.19 6,13.58C6,12 6.62,10.47 7.76,9.34L12,5.1M17.66,7.93L12,2.27V2.27L6.34,7.93C3.22,11.05 3.22,16.12 6.34,19.24C7.9,20.8 9.95,21.58 12,21.58C14.05,21.58 16.1,20.8 17.66,19.24C20.78,16.12 20.78,11.05 17.66,7.93Z";
var mdiInvertColorsOff = "M20.65,20.87L18.3,18.5L12,12.23L8.44,8.66L7,7.25L4.27,4.5L3,5.77L5.78,8.55C3.23,11.69 3.42,16.31 6.34,19.24C7.9,20.8 9.95,21.58 12,21.58C13.79,21.58 15.57,21 17.03,19.8L19.73,22.5L21,21.23L20.65,20.87M12,19.59C10.4,19.59 8.89,18.97 7.76,17.83C6.62,16.69 6,15.19 6,13.59C6,12.27 6.43,11 7.21,10L12,14.77V19.59M12,5.1V9.68L19.25,16.94C20.62,14 20.09,10.37 17.65,7.93L12,2.27L8.3,5.97L9.71,7.38L12,5.1Z";
var mdiInvoice = "M21 22L18 20L15 22L12 20L9 22L6 20L3 22V3H21V22Z";
var mdiInvoiceArrowLeft = "M21 13.34C20.37 13.12 19.7 13 19 13C15.69 13 13 15.69 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22V3H21V13.34M18 18V16L15 19L18 22V20H22V18H18Z";
var mdiInvoiceArrowLeftOutline = "M21 13.34C20.37 13.12 19.7 13 19 13V5H5V18.26L6 17.6L9 19.6L12 17.6L13.04 18.29C13 18.5 13 18.76 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22V3H21V13.34M18 18V16L15 19L18 22V20H22V18H18Z";
var mdiInvoiceArrowRight = "M21 13.34C20.37 13.12 19.7 13 19 13C15.69 13 13 15.69 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22V3H21V13.34M19 22V20H15V18H19V16L22 19L19 22Z";
var mdiInvoiceArrowRightOutline = "M21 13.34C20.37 13.12 19.7 13 19 13V5H5V18.26L6 17.6L9 19.6L12 17.6L13.04 18.29C13 18.5 13 18.76 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22V3H21V13.34M19 22V20H15V18H19V16L22 19L19 22Z";
var mdiInvoiceCheck = "M19 13C19.7 13 20.37 13.12 21 13.34V3H3V22L6 20L9 22L12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13 15.69 15.69 13 19 13M15.5 19L18.25 22L23 17.23L21.84 15.82L18.25 19.41L16.66 17.82L15.5 19Z";
var mdiInvoiceCheckOutline = "M19 13C19.7 13 20.37 13.12 21 13.34V3H3V22L6 20L9 22L12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13 18.76 13 18.5 13.04 18.29L12 17.6L9 19.6L6 17.6L5 18.26V5H19V13M15.5 19L18.25 22L23 17.23L21.84 15.82L18.25 19.41L16.66 17.82L15.5 19Z";
var mdiInvoiceClock = "M15 13V16.69L18.19 18.53L18.94 17.23L16.5 15.82V13H15M9 22L10.87 20.76C12.14 22.14 13.97 23 16 23C19.87 23 23 19.87 23 16C23 14.09 22.24 12.36 21 11.1V3H3V22L6 20L9 22M16 21C13.24 21 11 18.76 11 16C11 13.24 13.24 11 16 11C18.76 11 21 13.24 21 16C21 18.76 18.76 21 16 21Z";
var mdiInvoiceClockOutline = "M15 16.69V13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69M10.87 20.76L9 22L6 20L3 22V3H21V11.1C22.24 12.36 23 14.09 23 16C23 19.87 19.87 23 16 23C13.97 23 12.14 22.14 10.87 20.76M9.73 19.11C9.26 18.17 9 17.12 9 16C9 12.13 12.13 9 16 9C17.07 9 18.09 9.24 19 9.67V5H5V18.26L6 17.6L9 19.6L9.73 19.11M16 21C18.76 21 21 18.76 21 16C21 13.24 18.76 11 16 11C13.24 11 11 13.24 11 16C11 18.76 13.24 21 16 21Z";
var mdiInvoiceEdit = "M9.86 21.43L9 22L6 20L3 22V3H21V10.2C20.1 9.82 19 10 18.24 10.75L9.86 19.13V21.43M11.86 19.96L18 13.83L20.03 15.87L13.9 22H11.86V19.96M20.39 12.15C20.37 12.13 20.34 12.1 20.31 12.09C20.12 11.96 19.86 11.97 19.69 12.13L19.67 12.15L18.69 13.13L20.73 15.17L21.71 14.19C21.91 14 21.91 13.67 21.71 13.47L20.39 12.15Z";
var mdiInvoiceEditOutline = "M9.86 21.43L9 22L6 20L3 22V3H21V10.2C20.37 9.93 19.64 9.93 19 10.22V5H5V18.26L6 17.6L9 19.6L9.86 19V21.43M11.86 19.96L18 13.83L20.03 15.87L13.9 22H11.86V19.96M20.73 15.17L21.71 14.19C21.91 14 21.91 13.67 21.71 13.47L20.39 12.15C20.37 12.13 20.34 12.1 20.31 12.09C20.12 11.96 19.86 11.97 19.69 12.13L19.67 12.15L18.69 13.13L20.73 15.17Z";
var mdiInvoiceExportOutline = "M21 22L18 20L15 22L12 20L9 22L6 20L3 22V3H21V9.67L19 7.67V5H5V18.26L6 17.6L9 19.6L12 17.6L15 19.6L18 17.6L19 18.26V16.33L21 14.33V22M20.5 12L15.5 7L14.08 8.41L16.67 11H7V13H16.67L14.08 15.58L15.5 17L20.5 12Z";
var mdiInvoiceFast = "M22 5H7V21L9.5 19.32L12 21L14.5 19.32L17 21L19.5 19.32L22 21V5M2 8C2 7.4 2.4 7 3 7H5V9H3C2.4 9 2 8.6 2 8M1 12C1 11.4 1.4 11 2 11H5V13H2C1.4 13 1 12.6 1 12M0 16C0 15.4 .4 15 1 15H5V17H1C.4 17 0 16.6 0 16Z";
var mdiInvoiceFastOutline = "M19.5 19.32L22 21V5H7V21L9.5 19.32L12 21L14.5 19.32L17 21L19.5 19.32M20 7V16.57L17 18.59L14.5 16.9L12 18.59L9 16.57V7H20M2 8C2 7.4 2.4 7 3 7H5V9H3C2.4 9 2 8.6 2 8M2 11C1.4 11 1 11.4 1 12C1 12.6 1.4 13 2 13H5V11H2M0 16C0 15.4 .4 15 1 15H5V17H1C.4 17 0 16.6 0 16Z";
var mdiInvoiceImport = "M18 20L21 22V3H3V11H12.67L10.08 8.41L11.5 7L16.5 12L11.5 17L10.08 15.58L12.67 13H3V22L6 20L9 22L12 20L15 22L18 20Z";
var mdiInvoiceImportOutline = "M18 20L21 22V3H3V9H5V5H19V18.26L18 17.6L15 19.6L12 17.6L9 19.6L6 17.6L5 18.26V15H3V22L6 20L9 22L12 20L15 22L18 20M11.5 17L10.08 15.58L12.67 13H3V11H12.67L10.08 8.41L11.5 7L16.5 12L11.5 17Z";
var mdiInvoiceList = "M3 22V3H21V22L18 20L15 22L12 20L9 22L6 20L3 22M17 9V7H15V9H17M13 9V7H7V9H13M13 11H7V13H13V11M15 13H17V11H15V13Z";
var mdiInvoiceListOutline = "M17 7V9H15V7H17M13 7V9H7V7H13M13 11H7V13H13V11M15 11V13H17V11H15M21 22L18 20L15 22L12 20L9 22L6 20L3 22V3H21V22M19 18.26V5H5V18.26L6 17.6L9 19.6L12 17.6L15 19.6L18 17.6L19 18.26Z";
var mdiInvoiceMinus = "M3 22V3H21V13.34C20.37 13.12 19.7 13 19 13C15.69 13 13 15.69 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22M15 18V20H23V18H15Z";
var mdiInvoiceMinusOutline = "M21 13.34C20.37 13.12 19.7 13 19 13V5H5V18.26L6 17.6L9 19.6L12 17.6L13.04 18.29C13 18.5 13 18.76 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22V3H21V13.34M15 18V20H23V18H15Z";
var mdiInvoiceMultiple = "M17 2H2V17H4V4H17V2M21 22L18.5 20.32L16 22L13.5 20.32L11 22L8.5 20.32L6 22V6H21V22Z";
var mdiInvoiceMultipleOutline = "M2 2V17H4V4H17V2H2M18.5 20.32L21 22V6H6V22L8.5 20.32L11 22L13.5 20.32L16 22L18.5 20.32M19 8V17.57L16 19.59L13.5 17.9L11 19.59L8 17.57V8H19Z";
var mdiInvoiceOutline = "M21 22L18 20L15 22L12 20L9 22L6 20L3 22V3H21V22M19 18.26V5H5V18.26L6 17.6L9 19.6L12 17.6L15 19.6L18 17.6L19 18.26Z";
var mdiInvoicePlus = "M3 22V3H21V13.34C20.37 13.12 19.7 13 19 13C15.69 13 13 15.69 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiInvoicePlusOutline = "M21 13.34C20.37 13.12 19.7 13 19 13V5H5V18.26L6 17.6L9 19.6L12 17.6L13.04 18.29C13 18.5 13 18.76 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22V3H21V13.34M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiInvoiceRemove = "M19 13C19.7 13 20.37 13.12 21 13.34V3H3V22L6 20L9 22L12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13 15.69 15.69 13 19 13M19 17.6L16.9 15.5L15.5 16.9L17.6 19L15.5 21.1L16.9 22.5L19 20.4L21.1 22.5L22.5 21.1L20.4 19L22.5 16.9L21.1 15.5L19 17.6Z";
var mdiInvoiceRemoveOutline = "M19 13C19.7 13 20.37 13.12 21 13.34V3H3V22L6 20L9 22L12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13 18.76 13 18.5 13.04 18.29L12 17.6L9 19.6L6 17.6L5 18.26V5H19V13M19 17.6L16.9 15.5L15.5 16.9L17.6 19L15.5 21.1L16.9 22.5L19 20.4L21.1 22.5L22.5 21.1L20.4 19L22.5 16.9L21.1 15.5L19 17.6Z";
var mdiInvoiceSend = "M3 22V3H21V14.26L12 9.76V20L9 22L6 20L3 22M24 18L14 23V19L18 18L14 17V13L24 18Z";
var mdiInvoiceSendOutline = "M24 18L14 13V17L18 18L14 19V23L24 18M19 13.26L21 14.26V3H3V22L6 20L9 22L12 20V17.6L9 19.6L6 17.6L5 18.26V5H19V13.26Z";
var mdiInvoiceText = "M3 3V22L6 20L9 22L12 20L15 22L18 20L21 22V3H3M17 7V9H7V7H17M15 11V13H7V11H15Z";
var mdiInvoiceTextArrowLeft = "M3 22V3H21V13.34C20.37 13.12 19.7 13 19 13C15.69 13 13 15.69 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22M17 9V7H7V9H17M15 13V11H7V13H15M18 18V16L15 19L18 22V20H22V18H18Z";
var mdiInvoiceTextArrowLeftOutline = "M13.3 20.86L12 20L9 22L6 20L3 22V3H21V13.34C20.37 13.12 19.7 13 19 13V5H5V18.26L6 17.6L9 19.6L12 17.6L13.04 18.29C13 18.5 13 18.76 13 19C13 19.65 13.1 20.28 13.3 20.86M17 7V9H7V7H17M15 11V13H7V11H15M18 18V16L15 19L18 22V20H22V18H18Z";
var mdiInvoiceTextArrowRight = "M3 22V3H21V13.34C20.37 13.12 19.7 13 19 13C15.69 13 13 15.69 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22M17 9V7H7V9H17M15 13V11H7V13H15M19 22V20H15V18H19V16L22 19L19 22Z";
var mdiInvoiceTextArrowRightOutline = "M13.3 20.86L12 20L9 22L6 20L3 22V3H21V13.34C20.37 13.12 19.7 13 19 13V5H5V18.26L6 17.6L9 19.6L12 17.6L13.04 18.29C13 18.5 13 18.76 13 19C13 19.65 13.1 20.28 13.3 20.86M17 7V9H7V7H17M15 11V13H7V11H15M19 22V20H15V18H19V16L22 19L19 22Z";
var mdiInvoiceTextCheck = "M3 3V22L6 20L9 22L12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13 15.69 15.69 13 19 13C19.7 13 20.37 13.12 21 13.34V3H3M17 7V9H7V7H17M15 11V13H7V11H15M15.5 19L18.25 22L23 17.23L21.84 15.82L18.25 19.41L16.66 17.82L15.5 19Z";
var mdiInvoiceTextCheckOutline = "M12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13 18.76 13 18.5 13.04 18.29L12 17.6L9 19.6L6 17.6L5 18.26V5H19V13C19.7 13 20.37 13.12 21 13.34V3H3V22L6 20L9 22L12 20M17 9V7H7V9H17M15 13V11H7V13H15M15.5 19L18.25 22L23 17.23L21.84 15.82L18.25 19.41L16.66 17.82L15.5 19Z";
var mdiInvoiceTextClock = "M15 16.69V13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69M3 22V3H21V11.1C22.24 12.36 23 14.09 23 16C23 19.87 19.87 23 16 23C13.97 23 12.14 22.14 10.87 20.76L9 22L6 20L3 22M9.67 13C10.03 12.25 10.5 11.57 11.1 11H7V13H9.67M17 9V7H7V9H17M16 21C18.76 21 21 18.76 21 16C21 13.24 18.76 11 16 11C13.24 11 11 13.24 11 16C11 18.76 13.24 21 16 21Z";
var mdiInvoiceTextClockOutline = "M17 9H7V7H17V9M15 13V16.69L18.19 18.53L18.94 17.23L16.5 15.82V13H15M9 22L10.87 20.76C12.14 22.14 13.97 23 16 23C19.87 23 23 19.87 23 16C23 14.09 22.24 12.36 21 11.1V3H3V22L6 20L9 22M9 19.6L6 17.6L5 18.26V5H19V9.67C18.09 9.24 17.07 9 16 9C14.09 9 12.36 9.76 11.1 11H7V13H9.67C9.24 13.91 9 14.93 9 16C9 17.12 9.26 18.17 9.73 19.11L9 19.6M16 21C13.24 21 11 18.76 11 16C11 13.24 13.24 11 16 11C18.76 11 21 13.24 21 16C21 18.76 18.76 21 16 21Z";
var mdiInvoiceTextEdit = "M9.86 21.43L9 22L6 20L3 22V3H21V10.2C20.1 9.82 19 10 18.24 10.75L9.86 19.13V21.43M17 7H7V9H17V7M15 11H7V13H15V11M11.86 19.96V22H13.9L20.03 15.87L18 13.83L11.86 19.96M21.71 13.47L20.39 12.15C20.37 12.13 20.34 12.1 20.31 12.09C20.12 11.96 19.86 11.97 19.69 12.13L19.67 12.15L18.69 13.13L20.73 15.17L21.71 14.19C21.91 14 21.91 13.67 21.71 13.47Z";
var mdiInvoiceTextEditOutline = "M9.86 21.43L9 22L6 20L3 22V3H21V10.2C20.37 9.93 19.64 9.93 19 10.22V5H5V18.26L6 17.6L9 19.6L9.86 19V21.43M11.86 19.96L18 13.83L20.03 15.87L13.9 22H11.86V19.96M21.71 14.19L20.73 15.17L18.69 13.13L19.67 12.15L19.68 12.14L19.69 12.13C19.86 11.97 20.12 11.96 20.31 12.09C20.34 12.1 20.37 12.13 20.39 12.15L21.71 13.47C21.91 13.67 21.91 14 21.71 14.19M17 9V7H7V9H17M15 13V11H7V13H15Z";
var mdiInvoiceTextFast = "M7 5H22V21L19.5 19.32L17 21L14.5 19.32L12 21L9.5 19.32L7 21V5M18 9H11V11H18V9M11 13V15H16V13H11M3 7C2.4 7 2 7.4 2 8C2 8.6 2.4 9 3 9H5V7H3M1 12C1 11.4 1.4 11 2 11H5V13H2C1.4 13 1 12.6 1 12M1 15C.4 15 0 15.4 0 16C0 16.6 .4 17 1 17H5V15H1Z";
var mdiInvoiceTextFastOutline = "M18 9H11V11H18V9M11 13H16V15H11V13M22 21L19.5 19.32L17 21L14.5 19.32L12 21L9.5 19.32L7 21V5H22V21M20 16.57V7H9V16.57L12 18.59L14.5 16.9L17 18.59L20 16.57M3 7C2.4 7 2 7.4 2 8C2 8.6 2.4 9 3 9H5V7H3M2 11C1.4 11 1 11.4 1 12C1 12.6 1.4 13 2 13H5V11H2M1 15C.4 15 0 15.4 0 16C0 16.6 .4 17 1 17H5V15H1Z";
var mdiInvoiceTextMinus = "M3 3V22L6 20L9 22L12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13 15.69 15.69 13 19 13C19.7 13 20.37 13.12 21 13.34V3H3M17 7V9H7V7H17M15 11V13H7V11H15M15 18V20H23V18H15Z";
var mdiInvoiceTextMinusOutline = "M21 13.34C20.37 13.12 19.7 13 19 13V5H5V18.26L6 17.6L9 19.6L12 17.6L13.04 18.29C13 18.5 13 18.76 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22V3H21V13.34M17 9V7H7V9H17M15 13V11H7V13H15M15 18V20H23V18H15Z";
var mdiInvoiceTextMultiple = "M17 2H2V17H4V4H17V2M21 22L18.5 20.32L16 22L13.5 20.32L11 22L8.5 20.32L6 22V6H21V22M10 10V12H17V10H10M15 14H10V16H15V14Z";
var mdiInvoiceTextMultipleOutline = "M2 2V17H4V4H17V2H2M10 10H17V12H10V10M15 14H10V16H15V14M18.5 20.32L21 22V6H6V22L8.5 20.32L11 22L13.5 20.32L16 22L18.5 20.32M19 8V17.57L16 19.59L13.5 17.9L11 19.59L8 17.57V8H19Z";
var mdiInvoiceTextOutline = "M17 7V9H7V7H17M15 11V13H7V11H15M18 20L21 22V3H3V22L6 20L9 22L12 20L15 22L18 20M19 5V18.26L18 17.6L15 19.6L12 17.6L9 19.6L6 17.6L5 18.26V5H19Z";
var mdiInvoiceTextPlus = "M3 3V22L6 20L9 22L12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13 15.69 15.69 13 19 13C19.7 13 20.37 13.12 21 13.34V3H3M17 7V9H7V7H17M15 11V13H7V11H15M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiInvoiceTextPlusOutline = "M21 13.34C20.37 13.12 19.7 13 19 13V5H5V18.26L6 17.6L9 19.6L12 17.6L13.04 18.29C13 18.5 13 18.76 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22V3H21V13.34M17 9V7H7V9H17M15 13V11H7V13H15M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiInvoiceTextRemove = "M3 3V22L6 20L9 22L12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13 15.69 15.69 13 19 13C19.7 13 20.37 13.12 21 13.34V3H3M17 7V9H7V7H17M15 11V13H7V11H15M19 17.6L16.9 15.5L15.5 16.9L17.6 19L15.5 21.1L16.9 22.5L19 20.4L21.1 22.5L22.5 21.1L20.4 19L22.5 16.9L21.1 15.5L19 17.6Z";
var mdiInvoiceTextRemoveOutline = "M12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13 18.76 13 18.5 13.04 18.29L12 17.6L9 19.6L6 17.6L5 18.26V5H19V13C19.7 13 20.37 13.12 21 13.34V3H3V22L6 20L9 22L12 20M17 9V7H7V9H17M15 13V11H7V13H15M19 17.6L16.9 15.5L15.5 16.9L17.6 19L15.5 21.1L16.9 22.5L19 20.4L21.1 22.5L22.5 21.1L20.4 19L22.5 16.9L21.1 15.5L19 17.6Z";
var mdiInvoiceTextSend = "M3 3V22L6 20L9 22L12 20V13H7V11H14.47L21 14.26V3H3M17 9H7V7H17V9M14 23V19L18 18L14 17V13L24 18L14 23Z";
var mdiInvoiceTextSendOutline = "M24 18L14 23V19L18 18L14 17V13L24 18M21 14.26L19 13.26V5H5V18.26L6 17.6L9 19.6L12 17.6V20L9 22L6 20L3 22V3H21V14.26M17 7V9H7V7H17M12 13V11H7V13H12Z";
var mdiIobroker = "M12 2C11.5 2 11 2.04 10.5 2.11V4.85C11 4.75 11.5 4.7 12 4.7C12.5 4.7 13 4.75 13.5 4.85V2.12C13 2.04 12.5 2 12 2M9.82 2.25C5.4 3.25 2.11 7.24 2.11 12C2.11 17.5 6.53 22 12 22C17.47 22 21.89 17.5 21.89 12C21.89 7.24 18.6 3.25 14.19 2.25V5.03C17.17 5.96 19.34 8.73 19.34 12C19.34 16 16.05 19.3 12 19.3C7.96 19.3 4.67 16 4.67 12C4.67 8.73 6.84 5.96 9.82 5.03M12 5.45C11.5 5.45 11 5.5 10.5 5.62V18.27C11 18.38 11.5 18.44 12 18.44C12.5 18.44 13 18.39 13.5 18.27V5.62C13 5.5 12.5 5.45 12 5.45Z";
var mdiIp = "M16,11H14V9H16V11M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M10,7H8V17H10V7M12,17H14V13H16A2,2 0 0,0 18,11V9A2,2 0 0,0 16,7H12V17Z";
var mdiIpNetwork = "M15,9H13V7H15V9M22,20V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H7A2,2 0 0,1 5,15V5A2,2 0 0,1 7,3H17A2,2 0 0,1 19,5V15A2,2 0 0,1 17,17H13V19H14A1,1 0 0,1 15,20H22M9,5H7V15H9V5M11,15H13V11H15A2,2 0 0,0 17,9V7A2,2 0 0,0 15,5H11V15Z";
var mdiIpNetworkOutline = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M7,15V5H17V15H7M10,6H8V14H10V6M14,6H11V14H13V12H14A2,2 0 0,0 16,10V8A2,2 0 0,0 14,6M14,10H13V8H14V10Z";
var mdiIpOutline = "M19 5V19H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9 7H7V17H9V7M15 7H11V17H13V13H15C16.1 13 17 12.1 17 11V9C17 7.9 16.1 7 15 7M15 11H13V9H15V11Z";
var mdiIpod = "M7,2A2,2 0 0,0 5,4V20A2,2 0 0,0 7,22H17A2,2 0 0,0 19,20V4A2,2 0 0,0 17,2H7M7,4H17V10H7V4M12,12A4,4 0 0,1 16,16A4,4 0 0,1 12,20A4,4 0 0,1 8,16A4,4 0 0,1 12,12M12,14A2,2 0 0,0 10,16A2,2 0 0,0 12,18A2,2 0 0,0 14,16A2,2 0 0,0 12,14Z";
var mdiIron = "M21 6C19.34 6 18 7.34 18 9V13C18 13.55 17.55 14 17 14V10C17 8.34 15.66 7 14 7H10C8.34 7 7 8.34 7 10H9C9 9.45 9.45 9 10 9H14C14.55 9 15 9.45 15 10V11H6C3.79 11 2 12.79 2 15V18H17V16C18.66 16 20 14.66 20 13V9C20 8.45 20.45 8 21 8H22V6H21Z";
var mdiIronBoard = "M19 6H16V4.8C16 3.68 16.56 2.63 17.5 2C18.44 2.63 19 3.68 19 4.8V6M15.28 13.63L19.59 19C20.38 19.06 21 19.7 21 20.5C21 21.33 20.33 22 19.5 22S18 21.33 18 20.5C18 20.42 18 20.34 18 20.26L14 15.23L10 20.26C10 20.34 10 20.42 10 20.5C10 21.33 9.33 22 8.5 22S7 21.33 7 20.5C7 19.7 7.63 19.06 8.41 19L12.72 13.63L9 9H3V7H21V9H19L15.28 13.63M14 12L16.42 9H11.58L14 12Z";
var mdiIronOutline = "M21 6C19.34 6 18 7.34 18 9V13C18 13.55 17.55 14 17 14V10C17 8.34 15.66 7 14 7H10C8.34 7 7 8.34 7 10H9C9 9.45 9.45 9 10 9H14C14.55 9 15 9.45 15 10V11H6C3.79 11 2 12.79 2 15V18H17V16C18.66 16 20 14.66 20 13V9C20 8.45 20.45 8 21 8H22V6H21M15 16H4V15C4 13.9 4.9 13 6 13H15V16Z";
var mdiIsland = "M20 20C18.61 20 17.22 19.53 16 18.67C13.56 20.38 10.44 20.38 8 18.67C6.78 19.53 5.39 20 4 20H2V22H4C5.37 22 6.74 21.65 8 21C10.5 22.3 13.5 22.3 16 21C17.26 21.65 18.62 22 20 22H22V20H20M20.78 19H20C18.82 19 17.64 18.6 16.58 17.85L16 17.45L15.42 17.85C14.39 18.57 13.21 18.95 12 18.95C10.77 18.95 9.59 18.57 8.56 17.85L8 17.45L7.43 17.85C6.36 18.6 5.18 19 4 19H3.22C3.75 17.54 5.58 15 12 15C14 15 15 15.24 15 15.24C15.68 13.87 16.83 10.77 16 6.82L17.06 7.53C17.39 8.96 18 11.75 16.8 15.65C19.43 16.5 20.42 18 20.78 19M22 7.59C21.21 6.5 20 5.71 18.58 5.53C18.7 5.67 18.81 5.83 18.92 6C20.12 7.91 19.87 10.32 18.47 11.95C19.06 10.5 19 8.79 18.08 7.36C18 7.28 17.96 7.2 17.9 7.11C17.5 6.53 16.96 6.06 16.38 5.72C14.35 6.37 12.88 8.27 12.88 10.5C12.88 11.03 12.96 11.53 13.1 12C12.5 11.17 12.16 10.17 12.16 9.07C12.16 7.41 12.96 5.95 14.2 5.03C13.16 4.95 12.09 5.18 11.14 5.78C10.7 6.05 10.32 6.38 10 6.76C10.39 5.82 11.05 5 12 4.4C13.04 3.74 14.25 3.5 15.39 3.69C15.1 3.29 14.75 2.92 14.33 2.6C13.92 2.29 13.47 2.05 13 1.88C14 1.91 15.04 2.24 15.91 2.89C16.35 3.22 16.7 3.62 17 4.05C17.06 4.05 17.12 4.04 17.19 4.04C19.45 4.04 21.37 5.53 22 7.59Z";
var mdiIslandVariant = "M15 15.26V13H11L15 9H12L15 6H13L16 3L19 6H17L20 9H17L21 13H17V15.76C19.13 16.47 20.68 17.67 21 19C19.3 18.87 17.62 18.54 16 18C14.79 18.61 13.37 19 12 19C10.71 19 9.17 18.58 8 18C6.37 18.54 4.72 18.87 3 19C3.54 16.77 7.4 15 12 15C13.05 15 14.06 15.09 15 15.26M8 19C8 19 5 20 2 20V22C5 22 8 21 8 21C8 21 10 22 12 22C14 22 16 21 16 21C16 21 19 22 22 22V20C19 20 16 19 16 19C16 19 14 20 12 20C10 20 8 19 8 19Z";
var mdiIvBag = "M14 1H10C5 1 5 3 5 3V15C5 15 5 17 10 17V19H11V20C11 21.21 11.8 23 14 23H18V21H14C13.19 21 13 20.45 13 20V19H14V17C19 17 19 15 19 15V3C19 3 19 1 14 1M17 12H14V11H17V12M17 5H14V6H17V8H14V9H17V10H7V3.5C7.3 3.32 8.13 3 10 3H14C15.88 3 16.7 3.32 17 3.5V5Z";
var mdiJabber = "M5.23,5.72C4.61,5.55 5,3.19 5,3.17C5,3.19 12.58,-0.71 16.7,5.73C20.8,12.15 15.86,14.86 13.97,16.06C12.08,17.27 12.73,19.72 12.73,20.13C12.73,20.53 12.16,20.97 12,20.41C11.88,19.84 11.25,16.55 13.33,15.16C17.13,12.61 17.9,10.1 16,6.42C14.2,3 8.28,3.41 7.03,4.08C5.78,4.75 5.86,5.89 5.23,5.72M9.33,12.63L9.11,12.16C9.23,10.28 7.63,10.39 8.08,13.33C8.21,14.16 7.47,13.8 7.45,13.73C6.89,11.44 7.42,10.22 8.55,10.45C9.62,10.68 9.53,11.83 9.53,11.83C9.56,11.78 11,10.17 11.5,10.92C12.58,12.5 10.53,14.47 10.41,14.63C10.28,14.78 10.14,15.05 9.92,14.84C9.7,14.64 9.72,14.5 9.89,14.27C12.77,10 9.59,12.22 9.33,12.63M6.5,15.33V15.31C6.5,15.31 8,18.13 10.61,17.08C11,16.92 11.17,17.14 11.2,17.27C11.27,17.53 11.13,17.64 10.86,17.73C7.86,18.72 5.89,16.63 5.63,16.13C5.39,15.68 5.5,15.38 5.75,15.22C6,15.06 6.5,15.33 6.5,15.33M6,17.5C6,17.5 7.67,19.5 10.8,19C11.09,18.94 11.2,19.13 11.25,19.38C11.3,19.63 11.22,19.84 10.92,19.94C10.63,20.03 7.08,20.5 5.13,17.72C5,17.56 5.3,17.36 5.47,17.36C5.64,17.36 6.03,17.5 6,17.5M5.95,19.39C7.53,21.5 10.33,21.55 11.28,20.88C11.5,20.73 11.7,21.05 11.56,21.19C9.64,23.16 5.67,21 5.27,20.33C5.09,20.05 5.13,19.66 5.31,19.45C5.5,19.25 5.93,19.38 5.95,19.39Z";
var mdiJeepney = "M19,13V7H20V4H4V7H5V13H2C2,13.93 2.5,14.71 3.5,14.93V20A1,1 0 0,0 4.5,21H5.5A1,1 0 0,0 6.5,20V19H17.5V20A1,1 0 0,0 18.5,21H19.5A1,1 0 0,0 20.5,20V14.93C21.5,14.7 22,13.93 22,13H19M8,15A1.5,1.5 0 0,1 6.5,13.5A1.5,1.5 0 0,1 8,12A1.5,1.5 0 0,1 9.5,13.5A1.5,1.5 0 0,1 8,15M16,15A1.5,1.5 0 0,1 14.5,13.5A1.5,1.5 0 0,1 16,12A1.5,1.5 0 0,1 17.5,13.5A1.5,1.5 0 0,1 16,15M17.5,10.5C15.92,10.18 14.03,10 12,10C9.97,10 8,10.18 6.5,10.5V7H17.5V10.5Z";
var mdiJellyfish = "M19.5,14.5C18.92,14.43 18.43,14.92 18.5,15.5C18.5,16.17 17.5,16.17 17.5,15.5V13.2L19.2,12.7C19.92,12.36 20.41,11.68 20.5,10.9C20.5,5.5 16.7,2 12,2C7.3,2 3.5,5.5 3.5,10.9C3.56,11.7 4.06,12.4 4.8,12.7L6.5,13.2V15.5A0.5,0.5 0 0,1 6,16A0.5,0.5 0 0,1 5.5,15.5C5.57,14.92 5.08,14.43 4.5,14.5C3.92,14.43 3.43,14.92 3.5,15.5C3.44,16.91 4.59,18.06 6,18C7.41,18.06 8.56,16.91 8.5,15.5V13.7H9.5V19.4C9.5,20.07 8.5,20.07 8.5,19.4C8.57,18.82 8.08,18.33 7.5,18.4C6.92,18.33 6.43,18.82 6.5,19.4C6.38,20.84 7.55,22.07 9,22C10.41,22.06 11.56,20.91 11.5,19.5V14H12.5V19.5C12.44,20.91 13.59,22.06 15,22C16.41,22.06 17.56,20.91 17.5,19.5C17.5,18.17 15.5,18.17 15.5,19.5C15.5,20.17 14.5,20.17 14.5,19.5V13.8H15.5V15.6C15.5,16.96 16.63,18.06 18,18C19.41,18.06 20.56,16.91 20.5,15.5C20.57,14.92 20.08,14.43 19.5,14.5M10.6,4.7C9.09,5.03 7.79,5.97 7,7.3C6.83,7.5 6.5,7.57 6.3,7.4C6.08,7.23 6.04,6.92 6.2,6.7C7.16,5.19 8.67,4.12 10.4,3.7C10.67,3.68 10.91,3.85 11,4.1C11.06,4.37 10.88,4.65 10.6,4.7Z";
var mdiJellyfishOutline = "M12,4C15.8,4 18.5,6.8 18.5,10.8C14.31,12.39 9.69,12.39 5.5,10.8C5.5,6.8 8.2,4 12,4M12,2C7.3,2 3.5,5.5 3.5,10.9C3.56,11.7 4.06,12.4 4.8,12.7L6.5,13.2V15.5A0.5,0.5 0 0,1 6,16A0.5,0.5 0 0,1 5.5,15.5C5.57,14.92 5.08,14.43 4.5,14.5C3.92,14.43 3.43,14.92 3.5,15.5C3.44,16.86 4.54,18 5.9,18H6C7.41,18.06 8.56,16.91 8.5,15.5V13.7H9.5V19.4C9.5,20.07 8.5,20.07 8.5,19.4C8.57,18.82 8.08,18.33 7.5,18.4C6.92,18.33 6.43,18.82 6.5,19.4C6.39,20.8 7.5,22 8.9,22H9C10.41,22.06 11.56,20.91 11.5,19.5V14H12.5V19.5C12.44,20.91 13.59,22.06 15,22H15.1C16.47,22 17.56,20.86 17.5,19.5C17.5,18.17 15.5,18.17 15.5,19.5C15.5,20.17 14.5,20.17 14.5,19.5V13.8H15.5V15.6C15.5,16.96 16.63,18.06 18,18H18.1C19.47,18 20.56,16.86 20.5,15.5C20.5,14.17 18.5,14.17 18.5,15.5C18.5,16.17 17.5,16.17 17.5,15.5V13.2L19.2,12.7C19.92,12.36 20.41,11.68 20.5,10.9C20.5,5.5 16.7,2 12,2M12,6.2C10.53,6.6 9.24,7.53 8.4,8.8C8,9.33 7.2,8.73 7.6,8.2C8.6,6.73 10.09,5.67 11.8,5.2C12.08,5.14 12.35,5.32 12.4,5.6C12.5,5.9 12.3,6.1 12,6.2Z";
var mdiJira = "M11.53,2C11.53,4.4 13.5,6.35 15.88,6.35H17.66V8.05C17.66,10.45 19.6,12.39 22,12.4V2.84A0.84,0.84 0 0,0 21.16,2H11.53M6.77,6.8C6.78,9.19 8.72,11.13 11.11,11.14H12.91V12.86C12.92,15.25 14.86,17.19 17.25,17.2V7.63C17.24,7.17 16.88,6.81 16.42,6.8H6.77M2,11.6C2,14 3.95,15.94 6.35,15.94H8.13V17.66C8.14,20.05 10.08,22 12.47,22V12.43A0.84,0.84 0 0,0 11.63,11.59L2,11.6Z";
var mdiJquery = "M22.88,10.41C20.77,12.18 17.61,11.9 15.84,9.79C14.06,7.67 14.34,4.5 16.45,2.75L16.96,2.37C15.27,4.19 15.16,7.03 16.8,9C18.43,10.94 21.25,11.32 23.34,9.97L22.88,10.41M21.1,14.5C17.93,17.17 13.2,16.76 10.54,13.58C7.87,10.41 8.29,5.68 11.46,3L12.38,2.36C9.96,5.09 9.84,9.26 12.26,12.14C14.68,15 18.8,15.63 21.91,13.72L21.1,14.5M19.97,19.38C15.53,23.11 8.9,22.53 5.17,18.08C1.45,13.64 2.03,7 6.47,3.29L7.58,2.5C4.07,6.3 3.85,12.23 7.28,16.32C10.71,20.4 16.59,21.22 20.96,18.43L19.97,19.38Z";
var mdiJsfiddle = "M17.34 13.7C17.34 15 16.23 16.04 14.86 16.04C13.65 16.04 12.64 15 11.75 14.04L11.5 13.79C11.5 13.76 11.47 13.73 11.45 13.7C10.74 12.96 9.96 12.22 9.21 12.22C8.32 12.22 7.6 12.88 7.6 13.69C7.6 14.5 8.32 15.17 9.21 15.17C9.97 15.17 10.35 14.75 10.63 14.45L10.7 14.37C10.86 14.2 11.14 14.19 11.31 14.35C11.5 14.5 11.5 14.79 11.33 14.96L11.27 15.03C10.94 15.38 10.35 16.03 9.21 16.03C7.84 16.03 6.73 15 6.73 13.69C6.73 12.4 7.84 11.35 9.21 11.35C10.42 11.35 11.43 12.41 12.32 13.35L12.56 13.6C12.58 13.63 12.6 13.66 12.62 13.69C13.33 14.43 14.11 15.17 14.86 15.17C15.75 15.17 16.47 14.5 16.47 13.69C16.47 12.88 15.75 12.22 14.86 12.22C14.11 12.22 13.72 12.64 13.44 12.94L13.37 13C13.21 13.19 12.94 13.2 12.76 13.04C12.59 12.87 12.58 12.6 12.74 12.42L12.81 12.36C13.13 12 13.73 11.36 14.86 11.36C16.23 11.36 17.34 12.4 17.34 13.7M22 14.85C22 15.96 21.57 17 20.78 17.79C20 18.57 18.95 19 17.84 19H6.28C3.96 18.96 2.07 17.06 2.07 14.75C2.07 13.37 2.76 12.07 3.89 11.28C3.85 11.09 3.83 10.9 3.83 10.7C3.83 9.03 5.2 7.67 6.88 7.67C7.39 7.67 7.88 7.79 8.32 8.03C9.41 6.17 11.43 5 13.6 5C16.97 5 19.7 7.72 19.7 11.07L19.7 11.14C21.11 11.84 22 13.27 22 14.85M21.13 14.85C21.13 13.5 20.33 12.32 19.09 11.81C18.92 11.74 18.81 11.57 18.82 11.38L18.83 11.29C18.83 11.22 18.84 11.14 18.84 11.07C18.84 8.2 16.5 5.87 13.6 5.87C11.6 5.87 9.74 7.03 8.87 8.83C8.82 8.95 8.71 9.04 8.58 9.07C8.46 9.1 8.32 9.07 8.22 9C7.83 8.69 7.37 8.53 6.88 8.53C5.68 8.53 4.7 9.5 4.7 10.7C4.7 10.92 4.73 11.14 4.8 11.34C4.86 11.54 4.78 11.75 4.61 11.85C3.56 12.47 2.94 13.55 2.94 14.75C2.94 16.59 4.44 18.1 6.29 18.13H17.83C18.72 18.13 19.54 17.79 20.16 17.17C20.79 16.55 21.13 15.73 21.13 14.85Z";
var mdiJumpRope = "M21 4.5V10.5C21 11.2 20.5 11.9 19.8 12V17.3C19.8 18.6 19 21.1 16 21.1H14.5C14.9 20.7 15.3 20.2 15.5 19.6H16C18.1 19.6 18.2 17.7 18.2 17.4V12C17.5 11.9 17 11.3 17 10.5V4.5C17 3.7 17.7 3 18.5 3H19.5C20.3 3 21 3.7 21 4.5M14.8 18.2C14.8 19.7 13.6 21 12 21H8C5 21 4.2 18.5 4.2 17.2V12C3.5 11.9 3 11.2 3 10.5V4.5C3 3.7 3.7 3 4.5 3H5.5C6.3 3 7 3.7 7 4.5V10.5C7 11.2 6.5 11.9 5.8 12V17.3C5.8 17.7 5.9 19.5 8 19.5H9.6C9.4 19.1 9.3 18.7 9.3 18.3V8.3C9.3 6.8 10.5 5.5 12.1 5.5S14.8 6.7 14.8 8.3M13.2 8.2C13.2 7.6 12.7 7 12 7S10.8 7.6 10.8 8.2V18.2C10.8 18.9 11.4 19.4 12 19.4S13.2 18.8 13.2 18.2V8.2Z";
var mdiKabaddi = "M11.2 10.6C12.2 11.6 13.4 12.1 14.8 12.1L14.9 14.2C13 14.2 11.3 13.5 9.8 12.1L9.1 11.4L6.8 13.8L9 15.9V21.9H7V16.7L5.7 15.5V17.7L1.5 22L.1 20.6L3.7 17L2.5 13.5C2.3 12.9 2.6 12.4 3.1 12L6.4 8.7C6.8 8.2 7.3 8 7.8 8C8.3 8 8.6 8.1 8.9 8.3L11.2 10.6M24 11.9H22V8.5L20.2 7.8L21.1 12.2L22.1 17.4L23 21.8H20.9L19.1 13.8L17 15.8V21.8H15V14.3L17.1 12.3L16.5 9.3C15.9 9.9 15.2 10.5 14.4 10.9C13.5 10.8 12.6 10.4 11.9 9.7C13.5 9.4 14.6 8.6 15.3 7.4L16.3 5.8C16.9 4.8 17.8 4.5 18.9 5L24 7.2V11.9M11.4 4.4C12.5 4.4 13.4 5.3 13.4 6.4C13.4 7.5 12.5 8.4 11.4 8.4C10.3 8.4 9.4 7.5 9.4 6.4C9.4 5.3 10.3 4.4 11.4 4.4M16.5 .3C17.6 .3 18.5 1.2 18.5 2.3C18.5 3.4 17.6 4.3 16.5 4.3C15.4 4.3 14.5 3.4 14.5 2.3C14.5 1.2 15.4 .3 16.5 .3Z";
var mdiKangaroo = "M19.8 6.59L19 7.97V10.04L17.69 11.61L17.31 13.25L16 14L15.5 13.12L16.44 12.59L16.7 11.45L16.7 11.45L16.77 11.15L16.77 11.15V11.15L17.47 10.31C17.65 10.1 17.62 9.78 17.41 9.61C17.2 9.43 16.88 9.46 16.7 9.67L15.85 10.69L15.56 11.93C15.38 11.96 15.2 12 15 12C14.31 12 13.68 11.76 13.23 11.4C13.15 12.7 12.73 13.81 12.13 14.43L10.5 16.19L9.96 19.79L8.07 21L7.53 20.17L9.04 19.19L9.5 15.92L9.5 15.91L10 14.54C9.47 14.08 9.08 13.28 8.88 12.3L8.71 12.61C8.35 13.25 8 13.9 7.56 14.56C7.11 15.2 6.66 15.9 5.78 16.44C5.34 16.72 4.7 16.84 4.17 16.73C3.61 16.61 3.14 16.26 2.86 15.89C2.31 15.13 2.15 14.35 2 13.62L2.97 13.36C3.2 14 3.5 14.65 3.88 15C4.26 15.33 4.57 15.26 4.84 15C5.16 14.73 5.47 14.15 5.73 13.55C6 12.94 6.22 12.28 6.45 11.6C6.93 10.24 7.39 8.82 8.2 7.36C8.62 6.64 9.13 5.89 9.92 5.22C10.7 4.55 11.73 4 13 4S15.7 5.22 16.58 6.34C17 6.89 17.87 6.82 18.22 6.21L19.14 4.63C19 4.58 18.89 4.5 18.79 4.4C18.4 4 18.4 3.38 18.79 3L19.93 4.13C19.96 4.13 20 4.11 20 4.11C20.41 4.11 20.75 4.35 20.91 4.69L22 7L21 7.5L19.8 6.59Z";
var mdiKarate = "M19.8 2L11.6 8.7L10.39 7.66L14 5.58L9.41 1L8 2.41L10.74 5.15L5 8.46L3.81 12.75L6.27 17L8 16L5.97 12.5L6.32 11.18L9.5 13L10 22H12L12.5 12L21 3.4L19.8 2M5 3C6.11 3 7 3.9 7 5S6.11 7 5 7 3 6.11 3 5 3.9 3 5 3Z";
var mdiKayaking = "M22 23V21C20.58 21.05 19.21 20.9 18 20C16.23 21.25 13.77 21.25 12 20C10.23 21.25 7.77 21.25 6 20C4.79 20.9 3.42 21.05 2 21V23C3.38 23.05 4.79 22.94 6 22.25C7.84 23.25 10.16 23.25 12 22.25C13.84 23.25 16.16 23.25 18 22.25C19.21 22.94 20.62 23.05 22 23M23.39 17.21C21.13 16.29 18.3 15.56 15.66 15.22L19.36 6.88L20.67 6.41L22 3.41L18.8 2L17.5 4.95L18 6.27L16.31 9.97L13.5 11.47L11 10.2C10.95 10.14 10.86 10.09 10.74 10.06C9.82 9.73 8.77 10.32 8.5 11.23L7.13 15.41C6.59 15.18 1.25 16.97 .915 17.12L0 17.47C1.33 18.04 2.2 18.39 3.94 18.88C4.75 18.63 5.44 18.09 6 17.47C7.5 19.42 10.5 19.42 12 17.47C13.5 19.42 16.5 19.42 18 17.47C18.56 18.09 19.25 18.63 20.06 18.88L22.95 17.91L24 17.47L23.39 17.21M14.06 15.08C13.07 15 12.06 15 11.06 15L11.77 12.83L13.5 13.77L15 12.92L14.06 15.08M14 7.5C14 8.61 13.11 9.5 12 9.5S10 8.61 10 7.5 10.9 5.5 12 5.5 14 6.4 14 7.5Z";
var mdiKeg = "M5,22V20H6V16H5V14H6V11H5V7H11V3H10V2H11L13,2H14V3H13V7H19V11H18V14H19V16H18V20H19V22H5M17,9A1,1 0 0,0 16,8H14A1,1 0 0,0 13,9A1,1 0 0,0 14,10H16A1,1 0 0,0 17,9Z";
var mdiKettle = "M12.5,3C7.81,3 4,5.69 4,9V9C4,10.19 4.5,11.34 5.44,12.33C4.53,13.5 4,14.96 4,16.5C4,17.64 4,18.83 4,20C4,21.11 4.89,22 6,22H19C20.11,22 21,21.11 21,20C21,18.85 21,17.61 21,16.5C21,15.28 20.66,14.07 20,13L22,11L19,8L16.9,10.1C15.58,9.38 14.05,9 12.5,9C10.65,9 8.95,9.53 7.55,10.41C7.19,9.97 7,9.5 7,9C7,7.21 9.46,5.75 12.5,5.75V5.75C13.93,5.75 15.3,6.08 16.33,6.67L18.35,4.65C16.77,3.59 14.68,3 12.5,3M12.5,11C12.84,11 13.17,11.04 13.5,11.09C10.39,11.57 8,14.25 8,17.5V20H6V17.5A6.5,6.5 0 0,1 12.5,11Z";
var mdiKettleAlert = "M9.5 3C4.8 3 1 5.7 1 9C1 10.2 1.5 11.3 2.4 12.3C1.5 13.5 1 15 1 16.5V20C1 21.1 1.9 22 3 22H16C17.1 22 18 21.1 18 20V16.5C18 15.3 17.7 14.1 17 13L19 11L16 8L13.9 10.1C12.6 9.4 11.1 9 9.5 9C7.7 9 5.9 9.5 4.6 10.4C4.2 10 4 9.5 4 9C4 7.2 6.5 5.8 9.5 5.8C10.9 5.8 12.3 6.1 13.3 6.7L15.3 4.7C13.8 3.6 11.7 3 9.5 3M9.5 11C9.8 11 10.2 11 10.5 11.1C7.4 11.6 5 14.2 5 17.5V20H3V17.5C3 13.9 5.9 11 9.5 11M21 13V7H23V13H21M21 17V15H23V17H21Z";
var mdiKettleAlertOutline = "M9.5 3C4.8 3 1 5.7 1 9C1 10.2 1.5 11.3 2.4 12.3C1.5 13.5 1 15 1 16.5V20C1 21.1 1.9 22 3 22H16C17.1 22 18 21.1 18 20V16.5C18 15.3 17.7 14.1 17 13L19 11L16 8L13.9 10.1C11 8.5 7.4 8.6 4.6 10.4C4.2 10 4 9.5 4 9C4 7.2 6.5 5.7 9.5 5.7C10.9 5.7 12.3 6.1 13.3 6.7L15.3 4.7C13.6 3.5 11.6 3 9.5 3M9.5 11C13 11 16 14 16 16.5V20H3V16.5C3 14 6 11 9.5 11M10 12.5C7 12.5 5 14 5 17V18H7V17C7 16 7 13.5 10 12.5M21 13V7H23V13H21M21 17V15H23V17H21Z";
var mdiKettleOff = "M22.1 21.5L2.4 1.7L1.1 3L4.7 6.6C4.3 7.3 4 8.1 4 9C4 10.2 4.5 11.3 5.4 12.3C4.5 13.5 4 15 4 16.5V20C4 21.1 4.9 22 6 22H19C19.3 22 19.6 21.9 19.9 21.8L20.8 22.7L22.1 21.5M8.2 10.1L7.6 10.4C7.2 10 7 9.5 7 9V8.9L8.2 10.1M8 17.5V20H6V17.5C6 14.9 7.5 12.7 9.7 11.6L10.5 12.4C9 13.6 8 15.4 8 17.5M16.9 10.1L19 8L22 11L20 13C20.7 14.1 21 15.3 21 16.5V17.8L12.2 9H12.5C14 9 15.6 9.4 16.9 10.1M9.5 6.3L7.4 4.2C8.8 3.5 10.6 3 12.5 3C14.7 3 16.8 3.6 18.3 4.7L16.3 6.7C15.3 6.1 13.9 5.8 12.5 5.8C11.4 5.8 10.4 5.9 9.5 6.3Z";
var mdiKettleOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L4.7 6.6C4.3 7.3 4 8.1 4 9C4 10.2 4.5 11.3 5.4 12.3C4.5 13.5 4 15 4 16.5V20C4 21.1 4.9 22 6 22H19C19.3 22 19.6 21.9 19.9 21.8L20.8 22.7L22.1 21.5M8.2 10.1L7.6 10.4C7.2 10 7 9.5 7 9V8.9L8.2 10.1M6 20V16.5C6 14.7 7.6 12.6 9.7 11.6L10.9 12.8C9.1 13.4 8 14.8 8 17V18H10V17C10 16.2 10 14.5 11.4 13.3L18.1 20H6M16.9 10.1L19 8L22 11L20 13C20.7 14.1 21 15.3 21 16.5V17.8L18.9 15.7C18.5 13.9 16.8 12.1 14.6 11.4L12.2 9C13.8 8.9 15.4 9.3 16.9 10.1M9.5 6.3L7.4 4.2C8.8 3.5 10.6 3 12.5 3C14.6 3 16.6 3.5 18.3 4.7L16.3 6.7C15.3 6.1 13.9 5.7 12.5 5.7C11.4 5.7 10.3 5.9 9.5 6.3Z";
var mdiKettleOutline = "M12.5 3C7.8 3 4 5.7 4 9C4 10.2 4.5 11.3 5.4 12.3A6.8 6.8 0 0 0 4 16.5V20C4 21.1 4.9 22 6 22H19A2 2 0 0 0 21 20V16.5C21 15.3 20.7 14.1 20 13L22 11L19 8L16.9 10.1A9.2 9.2 0 0 0 7.6 10.4A2 2 0 0 1 7 9C7 7.2 9.5 5.7 12.5 5.7C13.9 5.7 15.3 6.1 16.3 6.7L18.3 4.7A10 10 0 0 0 12.5 3M12.5 11C16 11 19 14 19 16.5V20H6V16.5C6 14 9 11 12.5 11M13 12.5C10 12.5 8 14 8 17V18H10V17C10 16 10 13.5 13 12.5Z";
var mdiKettlePourOver = "M10 4C9.4 4 9 4.4 9 5V6H14V5C14 4.4 13.6 4 13 4H10M3 7L4.1 14.1C4.2 14.8 4.5 15.5 5.1 16.1C5.5 16.6 6.2 16.9 7 17C7 17.6 7.4 18 8 18H16C16.6 18 17 17.6 17 17L15 11H17L20.3 16L22 15L18.7 10L20 9.2L19 7.5L16.4 9H15V7H8V11L7.2 16C6.5 15.9 6.1 15.7 5.8 15.4C5.4 15 5.2 14.5 5.1 13.9L4 7H3M4 19V21H20V19H4Z";
var mdiKettleSteam = "M19 11L16 8L13.9 10.1C12.58 9.38 11.05 9 9.5 9C7.65 9 5.95 9.53 4.55 10.41C4.19 9.97 4 9.5 4 9C4 7.21 6.46 5.75 9.5 5.75C10.93 5.75 12.3 6.08 13.33 6.67L15.35 4.65C13.77 3.59 11.68 3 9.5 3C4.81 3 1 5.69 1 9C1 10.19 1.5 11.34 2.44 12.33C1.53 13.5 1 14.96 1 16.5V20C1 21.11 1.89 22 3 22H16C17.11 22 18 21.11 18 20V16.5C18 15.28 17.66 14.07 17 13L19 11M5 17.5V20H3V17.5C3 13.91 5.91 11 9.5 11C9.84 11 10.17 11.04 10.5 11.09C7.39 11.57 5 14.25 5 17.5M23 7.3C23 8.93 21.91 10.6 20.38 10.97L19.71 10.29L19 9.6H19.75C20.75 9.6 21.5 8.22 21.5 7.2C21.5 6.18 20.65 5.14 19.65 5.14V3.64C21.5 3.64 23 5.45 23 7.3M17.65 6.73C17.03 6.12 16.65 5.28 16.65 4.35C16.65 2.5 18.15 1 20 1V2.5C19 2.5 18.15 3.33 18.15 4.35C18.15 5.37 19 6.2 20 6.2V7.7C19.18 7.7 18.42 7.95 17.79 8.38L16.72 7.31C17 7.09 17.32 6.89 17.65 6.73Z";
var mdiKettleSteamOutline = "M9.5 3C4.8 3 1 5.7 1 9C1 10.2 1.5 11.3 2.4 12.3C1.5 13.5 .985 15 1 16.5V20C1 21.1 1.9 22 3 22H16C17.11 22 18 21.11 18 20V16.5C18 15.3 17.7 14.1 17 13L19 11L16 8L13.9 10.1C10.97 8.5 7.42 8.63 4.6 10.4C4.22 10.03 4 9.53 4 9C4 7.2 6.5 5.7 9.5 5.7C10.9 5.7 12.3 6.1 13.3 6.7L15.3 4.7C13.59 3.55 11.56 2.96 9.5 3M9.5 11C13 11 16 14 16 16.5V20H3V16.5C3 14 6 11 9.5 11M10 12.5C7 12.5 5 14 5 17V18H7V17C7 16 7 13.5 10 12.5M23 7.3C23 8.93 21.91 10.6 20.38 10.97L19.71 10.29L19 9.6H19.75C20.75 9.6 21.5 8.22 21.5 7.2C21.5 6.18 20.65 5.14 19.65 5.14V3.64C21.5 3.64 23 5.45 23 7.3M17.65 6.73C17.03 6.12 16.65 5.28 16.65 4.35C16.65 2.5 18.15 1 20 1V2.5C19 2.5 18.15 3.33 18.15 4.35C18.15 5.37 19 6.2 20 6.2V7.7C19.18 7.7 18.42 7.95 17.79 8.38L16.72 7.31C17 7.09 17.32 6.89 17.65 6.73Z";
var mdiKettlebell = "M16.2 10.7L16.8 8.3C16.9 8 17.3 6.6 16.5 5.4C15.9 4.5 14.7 4 13 4H11C9.3 4 8.1 4.5 7.5 5.4C6.7 6.6 7.1 7.9 7.2 8.3L7.8 10.7C6.7 11.8 6 13.3 6 15C6 17.1 7.1 18.9 8.7 20H15.3C16.9 18.9 18 17.1 18 15C18 13.3 17.3 11.8 16.2 10.7M9.6 9.5L9.1 7.8V7.7C9.1 7.7 8.9 7 9.2 6.6C9.4 6.2 10 6 11 6H13C13.9 6 14.6 6.2 14.9 6.5C15.2 6.9 15 7.6 15 7.6L14.5 9.5C13.7 9.2 12.9 9 12 9C11.1 9 10.3 9.2 9.6 9.5Z";
var mdiKey = "M7 14C5.9 14 5 13.1 5 12S5.9 10 7 10 9 10.9 9 12 8.1 14 7 14M12.6 10C11.8 7.7 9.6 6 7 6C3.7 6 1 8.7 1 12S3.7 18 7 18C9.6 18 11.8 16.3 12.6 14H16V18H20V14H23V10H12.6Z";
var mdiKeyAlert = "M4 6.5C4 4 6 2 8.5 2S13 4 13 6.5C13 8.46 11.75 10.13 10 10.74V15H13V18H10V22H7V10.74C5.25 10.13 4 8.46 4 6.5M7 6.5C7 7.33 7.67 8 8.5 8S10 7.33 10 6.5 9.33 5 8.5 5 7 5.67 7 6.5M18 7H20V13H18M18 17H20V15H18";
var mdiKeyAlertOutline = "M16 22H12V24H6V13.32C3.58 12.17 2 9.72 2 7C2 3.14 5.14 0 9 0C12.86 0 16 3.14 16 7C16 9.72 14.42 12.18 12 13.32V16H16V22M14 18H10V11.94L10.67 11.71C12.66 11 14 9.11 14 7C14 4.24 11.76 2 9 2S4 4.24 4 7C4 9.11 5.34 11 7.33 11.71L8 11.94V22H10V20H14V18M12 7C12 8.66 10.66 10 9 10S6 8.66 6 7 7.34 4 9 4 12 5.34 12 7M9 8C9.55 8 10 7.55 10 7S9.55 6 9 6 8 6.45 8 7 8.45 8 9 8M20 7H22V13H20M20 17H22V15H20";
var mdiKeyArrowRight = "M11.7 6C11.1 4.2 9.4 3 7.5 3C5 3 3 5 3 7.5S5 12 7.5 12C9.5 12 11.1 10.8 11.7 9H15V12H18V9H21V6H11.7M7.5 9C6.7 9 6 8.3 6 7.5S6.7 6 7.5 6 9 6.7 9 7.5 8.3 9 7.5 9M13 21V19H8V17H13V15L16 18L13 21";
var mdiKeyChain = "M12.67 13.67C12.2 14.13 11.63 14.5 11 14.73V23H8V21H5V18H8V14.72C6.26 14.1 5 12.46 5 10.5C5 8 7 6 9.5 6C9.54 6 9.57 6 9.6 6C9.13 6.95 8.92 8 9.03 9.08C8.44 9.28 8 9.84 8 10.5C8 11.33 8.67 12 9.5 12C9.73 12 9.95 11.94 10.15 11.85C10.79 12.69 11.67 13.32 12.67 13.67M20.73 19.44L17.97 20.6L17.19 18.76L14.43 19.93L13.26 17.16L16.03 16L14.76 13C12.91 13.08 11.11 12.05 10.35 10.25C9.39 7.96 10.47 5.32 12.76 4.35C13 4.25 13.26 4.18 13.5 4.12C12.84 2.87 11.5 2 10 2C7.79 2 6 3.79 6 6C6 6.08 6 6.16 6 6.24C5.7 6.5 5.4 6.82 5.15 7.15C5.06 6.78 5 6.4 5 6C5 3.24 7.24 1 10 1S15 3.24 15 6C15 7.42 14.4 8.67 13.45 9.57C13.87 10 14.5 10.13 15.08 9.88C15.85 9.56 16.2 8.68 15.88 7.92C15.85 7.83 15.8 7.74 15.74 7.66C15.9 7.13 16 6.58 16 6C16 5.37 15.9 4.76 15.72 4.19C17 4.55 18.1 5.44 18.65 6.76C19.41 8.56 18.89 10.57 17.5 11.81L20.73 19.44M13 8.6C13.37 8.19 13.65 7.71 13.82 7.18C13.28 7.45 12.97 8 13 8.6Z";
var mdiKeyChainVariant = "M12.66 13.67C12.32 14 11.93 14.29 11.5 14.5V21L9.5 23L7.5 21L9.5 19.29L8 18L9.5 16.71L7.5 15V14.5C6 13.77 5 12.26 5 10.5C5 8 7 6 9.5 6C9.54 6 9.58 6 9.61 6C9.59 6.07 9.54 6.12 9.5 6.18C9.23 6.79 9.08 7.43 9.03 8.08C8.43 8.28 8 8.84 8 9.5C8 10.33 8.67 11 9.5 11C9.53 11 9.57 11 9.6 11C10.24 12.25 11.34 13.2 12.66 13.67M16 6C16 5.37 15.9 4.75 15.72 4.18C17.06 4.56 18.21 5.55 18.73 6.96C19.33 8.62 18.89 10.39 17.75 11.59L20 17.68L18.78 20.25L16.22 19.05L17.5 16.76L15.66 16.06L16.63 14.34L14.16 13.41L14 12.95C12.36 12.77 10.88 11.7 10.27 10.04C9.42 7.71 10.63 5.12 12.96 4.27C13.14 4.21 13.33 4.17 13.5 4.13C12.84 2.87 11.53 2 10 2C7.79 2 6 3.79 6 6C6 6.09 6 6.17 6.03 6.26C5.7 6.53 5.4 6.82 5.15 7.15C5.06 6.78 5 6.4 5 6C5 3.24 7.24 1 10 1S15 3.24 15 6C15 7.16 14.6 8.21 13.94 9.06C16.08 8.88 16 6 16 6M12.81 8.1C12.87 8.27 12.96 8.41 13.06 8.54C13.62 7.88 13.97 7.04 14 6.11C13.89 6.13 13.8 6.15 13.7 6.18C12.92 6.47 12.5 7.33 12.81 8.1Z";
var mdiKeyChange = "M7.5 2C9.5 2 11.1 3.2 11.7 5H21V8H18V11H15V8H11.7C11.1 9.8 9.4 11 7.5 11C5 11 3 9 3 6.5S5 2 7.5 2M7.5 5C6.7 5 6 5.7 6 6.5S6.7 8 7.5 8 9 7.3 9 6.5 8.3 5 7.5 5M7.5 13C9.5 13 11.1 14.2 11.7 16H21V19H20V22H18V19H16V22H13V19H11.7C11.1 20.8 9.4 22 7.5 22C5 22 3 20 3 17.5S5 13 7.5 13M7.5 16C6.7 16 6 16.7 6 17.5S6.7 19 7.5 19 9 18.3 9 17.5 8.3 16 7.5 16Z";
var mdiKeyLink = "M7.5 3C5 3 3 5 3 7.5S5 12 7.5 12C9.5 12 11.1 10.8 11.7 9H15V12H18V9H21V6H11.7C11.1 4.2 9.5 3 7.5 3M7.5 6C8.3 6 9 6.7 9 7.5S8.3 9 7.5 9 6 8.3 6 7.5 6.7 6 7.5 6M10 14C8.4 14 6 15.1 6 18C6 20.9 8.4 22 10 22H11V20H10C9.7 20 8 19.9 8 18C8 16.2 9.5 16 10 16H11V14M13 14V16H14C14.3 16 16 16.1 16 18C16 19.8 14.5 20 14 20H13V22H14C15.6 22 18 20.9 18 18C18 15.1 15.6 14 14 14M9 17V19H15V17H9Z";
var mdiKeyMinus = "M7.5 3C9.5 3 11.1 4.2 11.7 6H21V9H18V12H15V9H11.7C11.1 10.8 9.4 12 7.5 12C5 12 3 10 3 7.5S5 3 7.5 3M7.5 6C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9 9 8.3 9 7.5 8.3 6 7.5 6M8 17H16V19H8V17Z";
var mdiKeyOutline = "M21 18H15V15H13.3C12.2 17.4 9.7 19 7 19C3.1 19 0 15.9 0 12S3.1 5 7 5C9.7 5 12.2 6.6 13.3 9H24V15H21V18M17 16H19V13H22V11H11.9L11.7 10.3C11 8.3 9.1 7 7 7C4.2 7 2 9.2 2 12S4.2 17 7 17C9.1 17 11 15.7 11.7 13.7L11.9 13H17V16M7 15C5.3 15 4 13.7 4 12S5.3 9 7 9 10 10.3 10 12 8.7 15 7 15M7 11C6.4 11 6 11.4 6 12S6.4 13 7 13 8 12.6 8 12 7.6 11 7 11Z";
var mdiKeyPlus = "M7.5 3C9.5 3 11.1 4.2 11.7 6H21V9H18V12H15V9H11.7C11.1 10.8 9.4 12 7.5 12C5 12 3 10 3 7.5S5 3 7.5 3M7.5 6C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9 9 8.3 9 7.5 8.3 6 7.5 6M8 17H11V14H13V17H16V19H13V22H11V19H8V17Z";
var mdiKeyRemove = "M7.5 3C9.5 3 11.1 4.2 11.7 6H21V9H18V12H15V9H11.7C11.1 10.8 9.4 12 7.5 12C5 12 3 10 3 7.5S5 3 7.5 3M7.5 6C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9 9 8.3 9 7.5 8.3 6 7.5 6M14.6 14L16 15.4L13.4 18L16 20.6L14.6 22L12 19.4L9.4 22L8 20.6L10.6 18L8 15.4L9.4 14L12 16.6L14.6 14Z";
var mdiKeyStar = "M7.5 3C5 3 3 5 3 7.5S5 12 7.5 12C9.5 12 11.1 10.8 11.7 9H15V12H18V9H21V6H11.7C11.1 4.2 9.5 3 7.5 3M7.5 6C8.3 6 9 6.7 9 7.5S8.3 9 7.5 9 6 8.3 6 7.5 6.7 6 7.5 6M12 14L10.9 16.6L8 16.9L10.2 18.8L9.5 21.6L12 20.1L14.4 21.6L13.8 18.8L16 16.9L13.1 16.7L12 14Z";
var mdiKeyVariant = "M22,18V22H18V19H15V16H12L9.74,13.74C9.19,13.91 8.61,14 8,14A6,6 0 0,1 2,8A6,6 0 0,1 8,2A6,6 0 0,1 14,8C14,8.61 13.91,9.19 13.74,9.74L22,18M7,5A2,2 0 0,0 5,7A2,2 0 0,0 7,9A2,2 0 0,0 9,7A2,2 0 0,0 7,5Z";
var mdiKeyWireless = "M4.9 5.9L6.3 7.3C9.4 4.2 14.5 4.2 17.6 7.3L19 5.9C15.2 2 8.8 2 4.9 5.9M7.8 8.8L9.2 10.2C10.8 8.6 13.3 8.6 14.9 10.2L16.3 8.8C13.9 6.4 10.1 6.4 7.8 8.8M11.8 15C11 12.7 8.4 11.4 6.1 12.3S2.4 15.7 3.3 18 6.7 21.6 9 20.7C10.3 20.2 11.3 19.2 11.7 18H15V21H18V18H21V15M7.5 18C6.7 18 6 17.3 6 16.5C6 15.7 6.7 15 7.5 15S9 15.7 9 16.5C9 17.3 8.3 18 7.5 18Z";
var mdiKeyboard = "M19,10H17V8H19M19,13H17V11H19M16,10H14V8H16M16,13H14V11H16M16,17H8V15H16M7,10H5V8H7M7,13H5V11H7M8,11H10V13H8M8,8H10V10H8M11,11H13V13H11M11,8H13V10H11M20,5H4C2.89,5 2,5.89 2,7V17A2,2 0 0,0 4,19H20A2,2 0 0,0 22,17V7C22,5.89 21.1,5 20,5Z";
var mdiKeyboardBackspace = "M21,11H6.83L10.41,7.41L9,6L3,12L9,18L10.41,16.58L6.83,13H21V11Z";
var mdiKeyboardCaps = "M6,18H18V16H6M12,8.41L16.59,13L18,11.58L12,5.58L6,11.58L7.41,13L12,8.41Z";
var mdiKeyboardClose = "M12,23L16,19H8M19,8H17V6H19M19,11H17V9H19M16,8H14V6H16M16,11H14V9H16M16,15H8V13H16M7,8H5V6H7M7,11H5V9H7M8,9H10V11H8M8,6H10V8H8M11,9H13V11H11M11,6H13V8H11M20,3H4C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H20A2,2 0 0,0 22,15V5C22,3.89 21.1,3 20,3Z";
var mdiKeyboardCloseOutline = "M12 23L16 19H8M4 3C2.9 3 2 3.9 2 5V15C2 16.1 2.9 17 4 17H20C21.1 17 22 16.1 22 15V5C22 3.9 21.1 3 20 3H4M4 5H20V15H4V5M5 6V8H7V6H5M8 6V8H10V6H8M11 6V8H13V6H11M14 6V8H16V6H14M17 6V8H19V6H17M5 9V11H7V9H5M8 9V11H10V9H8M11 9V11H13V9H11M14 9V11H16V9H14M17 9V11H19V9H17M8 12V14H16V12H8Z";
var mdiKeyboardEsc = "M1 7H7V9H3V11H7V13H3V15H7V17H1V7M11 7H15V9H11V11H13C14.11 11 15 11.9 15 13V15C15 16.11 14.11 17 13 17H9V15H13V13H11C9.9 13 9 12.11 9 11V9C9 7.9 9.9 7 11 7M19 7H21C22.11 7 23 7.9 23 9V10H21V9H19V15H21V14H23V15C23 16.11 22.11 17 21 17H19C17.9 17 17 16.11 17 15V9C17 7.9 17.9 7 19 7Z";
var mdiKeyboardF1 = "M6 7H12V9H8V11H11V13H8V17H6V7M14 7H18V17H16V9H14V7Z";
var mdiKeyboardF10 = "M2 7H8V9H4V11H7V13H4V17H2V7M10 7H14V17H12V9H10V7M18 7H20C21.11 7 22 7.9 22 9V15C22 16.11 21.11 17 20 17H18C16.9 17 16 16.11 16 15V9C16 7.9 16.9 7 18 7M18 9V15H20V9H18Z";
var mdiKeyboardF11 = "M3 7H9V9H5V11H8V13H5V17H3V7M11 7H15V17H13V9H11V7M17 7H21V17H19V9H17V7Z";
var mdiKeyboardF12 = "M2 7H8V9H4V11H7V13H4V17H2V7M16 7H20C21.11 7 22 7.9 22 9V11C22 12.11 21.11 13 20 13H18V15H22V17H16V13C16 11.9 16.9 11 18 11H20V9H16V7M10 7H14V17H12V9H10V7Z";
var mdiKeyboardF2 = "M5 7H11V9H7V11H10V13H7V17H5V7M13 7H17C18.11 7 19 7.9 19 9V11C19 12.11 18.11 13 17 13H15V15H19V17H13V13C13 11.9 13.9 11 15 11H17V9H13V7Z";
var mdiKeyboardF3 = "M5 7H11V9H7V11H10V13H7V17H5V7M19 15C19 16.11 18.11 17 17 17H13V15H17V13H15V11H17V9H13V7H17C18.1 7 19 7.89 19 9V10.5C19 11.33 18.33 12 17.5 12C18.33 12 19 12.67 19 13.5V15Z";
var mdiKeyboardF4 = "M5 7H11V9H7V11H10V13H7V17H5V7M13 7H15V11H17V7H19V17H17V13H13V7Z";
var mdiKeyboardF5 = "M5 7H11V9H7V11H10V13H7V17H5V7M13 7H19V9H15V11H17C18.11 11 19 11.9 19 13V15C19 16.11 18.11 17 17 17H13V15H17V13H13V7Z";
var mdiKeyboardF6 = "M5 7H11V9H7V11H10V13H7V17H5V7M15 7H19V9H15V11H17C18.11 11 19 11.9 19 13V15C19 16.11 18.11 17 17 17H15C13.9 17 13 16.11 13 15V9C13 7.9 13.9 7 15 7M15 13V15H17V13H15Z";
var mdiKeyboardF7 = "M5 7H11V9H7V11H10V13H7V17H5V7M15 17H13L17 9H13V7H19V9L15 17Z";
var mdiKeyboardF8 = "M5 7H11V9H7V11H10V13H7V17H5V7M15 13V15H17V13H15M15 9V11H17V9H15M15 17C13.9 17 13 16.11 13 15V13.5C13 12.67 13.67 12 14.5 12C13.67 12 13 11.33 13 10.5V9C13 7.9 13.9 7 15 7H17C18.1 7 19 7.89 19 9V10.5C19 11.33 18.33 12 17.5 12C18.33 12 19 12.67 19 13.5V15C19 16.11 18.11 17 17 17H15Z";
var mdiKeyboardF9 = "M5 7H11V9H7V11H10V13H7V17H5V7M17 17H13V15H17V13H15C13.9 13 13 12.11 13 11V9C13 7.9 13.9 7 15 7H17C18.11 7 19 7.9 19 9V15C19 16.11 18.11 17 17 17M17 11V9H15V11H17Z";
var mdiKeyboardOff = "M1,4.27L2.28,3L20,20.72L18.73,22L15.73,19H4C2.89,19 2,18.1 2,17V7C2,6.5 2.18,6.07 2.46,5.73L1,4.27M19,10V8H17V10H19M19,13V11H17V13H19M16,10V8H14V10H16M16,13V11H14V12.18L11.82,10H13V8H11V9.18L9.82,8L6.82,5H20A2,2 0 0,1 22,7V17C22,17.86 21.46,18.59 20.7,18.87L14.82,13H16M8,15V17H13.73L11.73,15H8M5,10H6.73L5,8.27V10M7,13V11H5V13H7M8,13H9.73L8,11.27V13Z";
var mdiKeyboardOffOutline = "M1,4.27L2.47,5.74C2.18,6.08 2,6.5 2,7V17A2,2 0 0,0 4,19H15.73L18.73,22L20,20.72L2.28,3L1,4.27M4,17V7.27L5,8.27V10H6.73L8,11.27V13H9.73L10.73,14H8V16H12.73L13.73,17H4M5,11H7V13H5V11M17,11H19V13H17V11M19,10H17V8H19V10M14,11H16V13H14.83L14,12.17V11M13,10H11.83L11,9.17V8H13V10M22,7V17C22,17.86 21.45,18.58 20.7,18.87L18.83,17H20V7H8.83L6.83,5H20A2,2 0 0,1 22,7M16,10H14V8H16V10Z";
var mdiKeyboardOutline = "M4,5A2,2 0 0,0 2,7V17A2,2 0 0,0 4,19H20A2,2 0 0,0 22,17V7A2,2 0 0,0 20,5H4M4,7H20V17H4V7M5,8V10H7V8H5M8,8V10H10V8H8M11,8V10H13V8H11M14,8V10H16V8H14M17,8V10H19V8H17M5,11V13H7V11H5M8,11V13H10V11H8M11,11V13H13V11H11M14,11V13H16V11H14M17,11V13H19V11H17M8,14V16H16V14H8Z";
var mdiKeyboardReturn = "M19,7V11H5.83L9.41,7.41L8,6L2,12L8,18L9.41,16.58L5.83,13H21V7H19Z";
var mdiKeyboardSettings = "M19,10H17V8H19M19,13H17V11H19M16,10H14V8H16M16,13H14V11H16M16,17H8V15H16M7,10H5V8H7M7,13H5V11H7M8,11H10V13H8M8,8H10V10H8M11,11H13V13H11M11,8H13V10H11M20,5H4A2,2 0 0,0 2,7V17A2,2 0 0,0 4,19H20A2,2 0 0,0 22,17V7A2,2 0 0,0 20,5M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z";
var mdiKeyboardSettingsOutline = "M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22M4,5A2,2 0 0,0 2,7V17A2,2 0 0,0 4,19H20A2,2 0 0,0 22,17V7A2,2 0 0,0 20,5H4M4,7H20V17H4V7M5,8V10H7V8H5M8,8V10H10V8H8M11,8V10H13V8H11M14,8V10H16V8H14M17,8V10H19V8H17M5,11V13H7V11H5M8,11V13H10V11H8M11,11V13H13V11H11M14,11V13H16V11H14M17,11V13H19V11H17M8,14V16H16V14H8Z";
var mdiKeyboardSpace = "M3 15H5V19H19V15H21V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V15Z";
var mdiKeyboardTab = "M20,18H22V6H20M11.59,7.41L15.17,11H1V13H15.17L11.59,16.58L13,18L19,12L13,6L11.59,7.41Z";
var mdiKeyboardTabReverse = "M4 6H2V18H4M11 6L5 12L11 18L12.41 16.58L8.83 13H23V11H8.83L12.41 7.41L11 6Z";
var mdiKeyboardVariant = "M6,16H18V18H6V16M6,13V15H2V13H6M7,15V13H10V15H7M11,15V13H13V15H11M14,15V13H17V15H14M18,15V13H22V15H18M2,10H5V12H2V10M19,12V10H22V12H19M18,12H16V10H18V12M8,12H6V10H8V12M12,12H9V10H12V12M15,12H13V10H15V12M2,9V7H4V9H2M5,9V7H7V9H5M8,9V7H10V9H8M11,9V7H13V9H11M14,9V7H16V9H14M17,9V7H22V9H17Z";
var mdiKhanda = "M16 20C19.72 18 22 15.27 22 12C22 9.34 20.46 6.9 17.89 5H17.82C19 6.35 19.68 8.09 19.68 10C19.68 13 18 15 15.5 16.83C15.5 16.84 14.38 17.54 13 18.41V17.33L15 16C15 16 14.8 15.4 14.58 14.46C16.6 13.58 18 11.69 18 9.5C18 7.34 16.64 5.47 14.65 4.57C14.84 3.63 15 3 15 3L12 1L9 3C9 3 9.16 3.63 9.35 4.57C7.37 5.47 6 7.34 6 9.5C6 11.69 7.4 13.58 9.42 14.46C9.2 15.4 9 16 9 16L11 17.33V18.41C9.62 17.54 8.5 16.84 8.5 16.83C6 15 4.32 13 4.32 10C4.32 8.09 5 6.35 6.18 5H6.12C3.54 6.9 2 9.34 2 12C2 15.27 4.29 18 8 20L9 18.5L10.92 19.73L7.34 22L8 23L11 21.07V23H13V21.07L16 23L16.66 22L13.08 19.73L15 18.5L16 20M16.75 9.5C16.75 11.09 15.76 12.46 14.31 13.19C14.14 12.23 14 11.12 14 10C14 8.67 14.2 7.15 14.42 5.86C15.81 6.6 16.75 7.95 16.75 9.5M7.25 9.5C7.25 7.95 8.19 6.6 9.59 5.86C9.8 7.15 10 8.67 10 10C10 11.12 9.86 12.23 9.69 13.19C8.24 12.46 7.25 11.09 7.25 9.5Z";
var mdiKickstarter = "M19.3 10.2L17.5 12L19.3 13.8C21.19 15.67 21.19 18.72 19.3 20.59C17.42 22.46 14.35 22.46 12.47 20.59L11.8 19.93C10.93 21.19 9.5 22 7.83 22C5.16 22 3 19.85 3 17.2V6.8C3 4.15 5.16 2 7.83 2C9.5 2 10.93 2.82 11.8 4.07L12.47 3.41C14.35 1.54 17.42 1.54 19.3 3.41C21.19 5.28 21.19 8.33 19.3 10.2Z";
var mdiKite = "M13.69 3.46C13.35 3.15 12.96 3 12.5 3C12.05 3 11.66 3.15 11.33 3.46L5.54 9.08C5.23 9.38 5.06 9.75 5 10.2C5 10.64 5.08 11.04 5.33 11.4L11.45 19.83C11.2 20.36 10.75 20.62 10.09 20.62C9.29 20.62 8.79 20.25 8.6 19.5C8.4 18.84 8 18.27 7.38 17.8C6.76 17.34 6.1 17.1 5.41 17.1C4.36 17.1 3.5 17.5 2.85 18.3L4.21 19.42C4.5 19.03 4.92 18.84 5.41 18.84C6.21 18.84 6.71 19.21 6.9 19.95C7.09 20.62 7.5 21.19 8.12 21.67C8.74 22.15 9.4 22.4 10.09 22.4C11.33 22.4 12.28 21.83 12.94 20.7L19.68 11.39C19.93 11.04 20.03 10.64 20 10.2C19.95 9.75 19.77 9.38 19.47 9.08L13.69 3.46Z";
var mdiKiteOutline = "M12.5 5.1L17.95 10.38L12.5 17.88L7.07 10.38L12.5 5.1M12.5 3C12.05 3 11.66 3.15 11.33 3.46L5.54 9.08C5.23 9.38 5.06 9.75 5 10.2C5 10.64 5.08 11.04 5.33 11.4L11.45 19.83C11.2 20.36 10.75 20.62 10.09 20.62C9.29 20.62 8.79 20.25 8.6 19.5C8.4 18.84 8 18.27 7.38 17.8C6.76 17.34 6.1 17.1 5.41 17.1C4.36 17.1 3.5 17.5 2.85 18.3L4.21 19.42C4.5 19.03 4.92 18.84 5.41 18.84C6.21 18.84 6.71 19.21 6.9 19.95C7.09 20.62 7.5 21.19 8.12 21.67S9.4 22.4 10.09 22.4C11.33 22.4 12.28 21.83 12.94 20.7L19.68 11.4C19.93 11.04 20.03 10.64 20 10.2C19.95 9.76 19.77 9.38 19.47 9.08L13.68 3.46C13.35 3.15 12.96 3 12.5 3Z";
var mdiKitesurfing = "M16.5 4.5L15.5 3.43L17.92 1H20L16.5 4.5M20.96 23C19.9 23 18.9 22.75 17.96 22.25C16.12 23.25 13.81 23.25 11.97 22.25C10.13 23.25 7.82 23.25 6 22.25C4.77 22.94 3.36 23.05 2 23V21C3.41 21.05 4.77 20.9 6 20C7.74 21.25 10.21 21.25 11.97 20C13.74 21.25 16.2 21.25 17.96 20C19.17 20.9 20.54 21.05 21.94 21V23H20.96M20.35 12.26C18.3 11.5 16.14 12.61 14.08 13.36L12.39 11.5H9.58V8C11.89 8.19 14.29 7.67 15.9 5.96L14.5 4.56C13.6 5.46 12.3 6 11 6H8C6.89 6 5.95 6.92 6 8C6.07 9.35 5.67 12.73 6.45 13.87L8 16.82C7.43 17.23 6.93 17.62 6.5 18C8.09 19.5 10.65 19.17 11.97 17.5C12.91 18.59 14.45 19.3 15.9 18.83C17.45 17.77 22.74 14 20.35 12.26M11.43 14.65C11 14.89 10.16 15.37 9.82 15.61L8.97 13.59L11.46 13.5L12.16 14.25L11.43 14.65M8 1C6.9 1 6 1.9 6 3S6.9 5 8 5 10 4.11 10 3 9.11 1 8 1Z";
var mdiKlingon = "M4.79 21.5L4.71 21.24C4.53 20.65 4.47 20.08 4.5 19.4C4.6 18.17 5.14 17.31 5.82 16.59C5.64 16 5.53 15.39 5.53 14.74C5.53 13 6.26 11.44 7.45 10.3C8.33 9.46 9.46 8.86 10.71 8.6C11.37 6.23 11.8 3.8 12 1.5C12.24 3.5 12.65 6.12 13.3 8.58C14.6 8.82 15.76 9.43 16.67 10.3C17.85 11.44 18.59 13 18.59 14.74C18.59 15.35 18.5 15.93 18.33 16.5C19.21 16.92 20.2 17.17 21.5 17.29L21.44 17.44C21.32 17.77 21 18 20.71 18.18L20.69 18.19C20.13 18.57 19.18 19 17.85 19C17.7 19 17.56 19 17.41 19C17.23 19 17.06 18.97 16.9 18.95C16.83 19 16.75 19.1 16.67 19.18C15.5 20.31 13.86 21 12.06 21C10.27 21 8.64 20.31 7.46 19.18C7.42 19.14 7.38 19.1 7.34 19.06C6.34 19.59 5.54 20.33 4.94 21.27L4.8 21.5M6.5 15.94C6.65 15.82 8.2 14.5 8.63 13.78L8.73 13.61C9.65 15 10.4 16.28 11.43 18.08L11.22 18.09C10.08 18.16 9.05 18.37 8.15 18.7C9.17 19.62 10.55 20.19 12.06 20.19C13.54 20.19 14.88 19.65 15.89 18.77C15.64 18.72 15.39 18.65 15.15 18.59C14.38 18.41 13.65 18.22 12.81 18.19L12.62 18.18L12.7 18C13.1 17.2 14.8 14.41 15.23 13.63L15.34 13.81C16 14.77 16.73 15.5 17.58 16.07C17.69 15.64 17.75 15.2 17.75 14.75C17.75 13.25 17.11 11.89 16.09 10.9C15.4 10.24 14.53 9.74 13.55 9.5C13.85 10.5 14.2 11.5 14.59 12.35L14.62 12.4L14.59 12.46C14.2 13.22 13.76 13.95 13.33 14.66C12.94 15.3 12.54 15.96 12.18 16.64L12.08 16.83L11.96 16.65C11.39 15.82 9.75 13.06 9.41 12.5C9.81 11.5 10.15 10.5 10.45 9.5C9.5 9.78 8.7 10.26 8.03 10.9C7 11.88 6.37 13.25 6.37 14.74C6.37 15.16 6.42 15.56 6.5 15.95";
var mdiKnife = "M20.62,2C23.97,7.61 12.47,20.15 12.47,20.15L9.6,17.28L4.91,22L2.77,19.86L20.62,2Z";
var mdiKnifeMilitary = "M22,2L17.39,3.75L10.46,10.68L14,14.22L20.92,7.29C22.43,5.78 22,2 22,2M8.33,10L6.92,11.39L8.33,12.8L2.68,18.46L6.21,22L11.87,16.34L13.28,17.76L14.7,16.34L8.33,10Z";
var mdiKnob = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M13 10H11V4.1C11.3 4 11.7 4 12 4S12.7 4 13 4.1V10Z";
var mdiKoala = "M19 3C18.1 3 15.5 3 14.3 6.1C13.9 6 13.4 6 13 6H11C10.6 6 10.1 6 9.7 6.1C8.5 3 5.9 3 5 3C4 3 1 4 1 9C1 12.6 3.5 13.6 5 13.9V15C5 18.3 7.7 21 11 21H13C16.3 21 19 18.3 19 15V13.9C20.5 13.6 23 12.6 23 9C23 4 20 3 19 3M5 12V12.4C2.9 11.8 3.3 9.5 4.3 8.7C4 8.3 3 9 3 8.6C3 8.1 4.8 7.4 5.1 7.3C4.8 6.8 3.6 7 3.6 6.6C3.6 6.3 4.8 5.8 5.8 6C6.3 6.1 6.9 6.3 7.4 6.7C6 8 5 9.8 5 12M8.5 15C6.5 15 6.5 12 8.5 12C10.5 12 10.5 15 8.5 15M12.5 18H11.5C10.8 18 10.3 17.3 10.6 16.7L11.3 13.7C11.4 13.3 11.8 13.1 12.1 13C12.4 13 12.7 13.2 12.9 13.7L13.6 16.7C13.7 17.3 13.2 18 12.5 18M15.5 15C13.5 15 13.5 12 15.5 12C17.5 12 17.5 15 15.5 15M19.7 8.6C20.7 9.4 21.1 11.7 19 12.3C19.1 10.1 18.1 8 16.6 6.7C17.1 6.3 17.7 6.1 18.2 6C19.2 5.8 20.4 6.2 20.4 6.6C20.4 7 19.2 6.8 18.9 7.2C19.2 7.4 21 8.1 21 8.6C21 9 20.1 8.3 19.7 8.6Z";
var mdiKodi = "M12.03,1C11.82,1 11.6,1.11 11.41,1.31C10.56,2.16 9.72,3 8.88,3.84C8.66,4.06 8.6,4.18 8.38,4.38C8.09,4.62 7.96,4.91 7.97,5.28C8,6.57 8,7.84 8,9.13C8,10.46 8,11.82 8,13.16C8,13.26 8,13.34 8.03,13.44C8.11,13.75 8.31,13.82 8.53,13.59C9.73,12.39 10.8,11.3 12,10.09C13.36,8.73 14.73,7.37 16.09,6C16.5,5.6 16.5,5.15 16.09,4.75C14.94,3.6 13.77,2.47 12.63,1.31C12.43,1.11 12.24,1 12.03,1M18.66,7.66C18.45,7.66 18.25,7.75 18.06,7.94C16.91,9.1 15.75,10.24 14.59,11.41C14.2,11.8 14.2,12.23 14.59,12.63C15.74,13.78 16.88,14.94 18.03,16.09C18.43,16.5 18.85,16.5 19.25,16.09C20.36,15 21.5,13.87 22.59,12.75C22.76,12.58 22.93,12.42 23,12.19V11.88C22.93,11.64 22.76,11.5 22.59,11.31C21.47,10.19 20.37,9.06 19.25,7.94C19.06,7.75 18.86,7.66 18.66,7.66M4.78,8.09C4.65,8.04 4.58,8.14 4.5,8.22C3.35,9.39 2.34,10.43 1.19,11.59C0.93,11.86 0.93,12.24 1.19,12.5C1.81,13.13 2.44,13.75 3.06,14.38C3.6,14.92 4,15.33 4.56,15.88C4.72,16.03 4.86,16 4.94,15.81C5,15.71 5,15.58 5,15.47C5,14.29 5,13.37 5,12.19C5,11 5,9.81 5,8.63C5,8.55 5,8.45 4.97,8.38C4.95,8.25 4.9,8.14 4.78,8.09M12.09,14.25C11.89,14.25 11.66,14.34 11.47,14.53C10.32,15.69 9.18,16.87 8.03,18.03C7.63,18.43 7.63,18.85 8.03,19.25C9.14,20.37 10.26,21.47 11.38,22.59C11.54,22.76 11.71,22.93 11.94,23H12.22C12.44,22.94 12.62,22.79 12.78,22.63C13.9,21.5 15.03,20.38 16.16,19.25C16.55,18.85 16.5,18.4 16.13,18C14.97,16.84 13.84,15.69 12.69,14.53C12.5,14.34 12.3,14.25 12.09,14.25Z";
var mdiKubernetes = "M13.95 13.5H13.72C13.54 13.61 13.46 13.82 13.54 14L14.4 16.11C15.23 15.58 15.86 14.79 16.19 13.86L13.96 13.5H13.95M10.5 13.79C10.44 13.62 10.29 13.5 10.12 13.5H10.04L7.82 13.87C8.15 14.79 8.78 15.57 9.61 16.1L10.46 14.03V14C10.5 13.95 10.5 13.86 10.5 13.79M12.33 14.6C12.23 14.42 12 14.35 11.82 14.45C11.75 14.5 11.7 14.53 11.67 14.6H11.66L10.57 16.57C11.35 16.83 12.19 16.88 13 16.69C13.14 16.66 13.29 16.62 13.43 16.57L12.34 14.6H12.33M15.78 10.03L14.1 11.5L14.11 11.53C13.95 11.67 13.93 11.91 14.07 12.06C14.12 12.12 14.18 12.16 14.25 12.18L14.26 12.19L16.43 12.81C16.5 11.84 16.29 10.86 15.78 10.03M12.67 10.19C12.68 10.4 12.85 10.56 13.06 10.55C13.14 10.55 13.21 10.53 13.27 10.5H13.28L15.11 9.19C14.41 8.5 13.5 8.07 12.54 7.95L12.67 10.19M10.73 10.5C10.9 10.61 11.13 10.58 11.25 10.41C11.3 10.35 11.32 10.28 11.33 10.2H11.34L11.46 7.95C11.31 7.97 11.16 8 11 8.03C10.2 8.21 9.46 8.61 8.88 9.19L10.72 10.5H10.73M9.74 12.19C9.94 12.14 10.06 11.93 10 11.73C10 11.65 9.95 11.59 9.89 11.54V11.53L8.21 10C7.69 10.86 7.47 11.84 7.58 12.82L9.74 12.2V12.19M11.38 12.85L12 13.15L12.62 12.85L12.77 12.18L12.34 11.65H11.65L11.22 12.18L11.38 12.85M22.27 14.17L20.5 6.5C20.41 6.08 20.13 5.74 19.76 5.56L12.59 2.13C12.22 1.96 11.78 1.96 11.4 2.13L4.24 5.56C3.87 5.74 3.59 6.08 3.5 6.5L1.73 14.17C1.68 14.37 1.68 14.57 1.73 14.76C1.74 14.82 1.76 14.88 1.78 14.94C1.81 15.03 1.86 15.13 1.91 15.21C1.94 15.25 1.96 15.29 2 15.32L6.95 21.5C6.97 21.5 7 21.54 7 21.56C7.1 21.65 7.19 21.72 7.28 21.78C7.4 21.86 7.54 21.92 7.68 21.95C7.79 22 7.91 22 8 22H16.12C16.19 22 16.26 21.97 16.32 21.95C16.37 21.94 16.42 21.92 16.46 21.91C16.5 21.89 16.53 21.88 16.57 21.86C16.62 21.84 16.67 21.81 16.72 21.78C16.84 21.7 16.95 21.6 17.05 21.5L17.2 21.3L22 15.32C22.1 15.2 22.17 15.07 22.22 14.94C22.24 14.88 22.26 14.82 22.27 14.76C22.32 14.57 22.32 14.36 22.27 14.17M14.84 17.16C14.86 17.22 14.88 17.28 14.91 17.33C14.87 17.41 14.85 17.5 14.88 17.59C15 17.83 15.11 18.05 15.26 18.27C15.34 18.38 15.42 18.5 15.5 18.61C15.5 18.64 15.53 18.69 15.54 18.73C15.66 18.93 15.6 19.19 15.39 19.32S14.92 19.37 14.8 19.17C14.79 19.14 14.78 19.12 14.77 19.09C14.75 19.06 14.73 19 14.71 19C14.66 18.85 14.62 18.72 14.59 18.59C14.5 18.34 14.42 18.1 14.29 17.87C14.24 17.8 14.16 17.75 14.08 17.73L14 17.57C12.71 18.05 11.3 18.05 10.03 17.56L9.93 17.74C9.86 17.75 9.79 17.78 9.74 17.83C9.6 18.07 9.5 18.32 9.41 18.6C9.38 18.73 9.34 18.86 9.29 19C9.27 19 9.25 19.07 9.23 19.1C9.15 19.32 8.91 19.44 8.68 19.36C8.46 19.28 8.34 19.04 8.42 18.81C8.43 18.78 8.45 18.76 8.46 18.73C8.5 18.7 8.5 18.65 8.5 18.62C8.59 18.5 8.66 18.39 8.74 18.27C8.9 18.06 9.03 17.82 9.13 17.58C9.14 17.5 9.13 17.41 9.1 17.33L9.17 17.15C8 16.45 7.12 15.36 6.7 14.06L6.5 14.09C6.44 14.04 6.35 14 6.27 14C6 14.05 5.76 14.13 5.5 14.22C5.39 14.28 5.26 14.33 5.13 14.37C5.1 14.38 5.06 14.39 5 14.4C4.78 14.47 4.54 14.35 4.46 14.13C4.39 13.9 4.5 13.66 4.74 13.58C4.76 13.58 4.79 13.57 4.82 13.57V13.56H4.83L4.94 13.54C5.08 13.5 5.22 13.5 5.35 13.5C5.61 13.5 5.87 13.44 6.12 13.38C6.2 13.33 6.26 13.27 6.31 13.19L6.5 13.14C6.29 11.78 6.6 10.41 7.36 9.27L7.22 9.15C7.22 9.06 7.19 8.97 7.14 8.9C6.94 8.73 6.73 8.58 6.5 8.45C6.38 8.39 6.26 8.32 6.14 8.24C6.12 8.22 6.08 8.19 6.06 8.17L6.05 8.16C5.85 8 5.8 7.74 5.94 7.53C6.03 7.43 6.15 7.38 6.29 7.38C6.4 7.39 6.5 7.43 6.59 7.5L6.68 7.57C6.78 7.66 6.87 7.77 6.96 7.87C7.14 8.06 7.33 8.24 7.54 8.39C7.62 8.43 7.71 8.44 7.8 8.42L7.95 8.53C8.7 7.73 9.68 7.17 10.75 6.93C11 6.87 11.27 6.83 11.53 6.81L11.54 6.63C11.61 6.57 11.65 6.5 11.68 6.4C11.69 6.14 11.67 5.88 11.63 5.63C11.6 5.5 11.58 5.36 11.57 5.22V5.1C11.55 4.86 11.72 4.65 11.96 4.62S12.4 4.77 12.43 5V5.22C12.42 5.36 12.4 5.5 12.37 5.63C12.33 5.88 12.31 6.14 12.32 6.4C12.34 6.5 12.39 6.57 12.46 6.62L12.47 6.81C13.83 6.93 15.09 7.54 16.03 8.53L16.19 8.41C16.28 8.43 16.37 8.42 16.45 8.38C16.66 8.23 16.86 8.05 17.03 7.86C17.12 7.76 17.21 7.66 17.31 7.56C17.34 7.54 17.38 7.5 17.41 7.5C17.58 7.32 17.85 7.32 18 7.5C18.19 7.66 18.18 7.93 18 8.1C18 8.12 17.97 8.14 17.94 8.16C17.92 8.18 17.88 8.21 17.85 8.23C17.74 8.31 17.62 8.38 17.5 8.44C17.27 8.57 17.05 8.72 16.86 8.89C16.8 8.96 16.77 9.04 16.78 9.13L16.62 9.27C17.39 10.4 17.7 11.78 17.5 13.13L17.69 13.18C17.73 13.26 17.8 13.32 17.88 13.36C18.13 13.43 18.39 13.47 18.65 13.5H19.06C19.09 13.53 19.14 13.54 19.18 13.55C19.42 13.58 19.58 13.8 19.55 14.04C19.5 14.27 19.31 14.44 19.07 14.41C19.04 14.4 19 14.4 19 14.39V14.38C18.94 14.38 18.9 14.37 18.86 14.36C18.73 14.32 18.61 14.27 18.5 14.21C18.24 14.11 18 14.04 17.73 14C17.64 14 17.56 14 17.5 14.08C17.43 14.07 17.37 14.06 17.31 14.05C16.9 15.36 16 16.46 14.84 17.16Z";
var mdiLabel = "M17.63,5.84C17.27,5.33 16.67,5 16,5H5A2,2 0 0,0 3,7V17A2,2 0 0,0 5,19H16C16.67,19 17.27,18.66 17.63,18.15L22,12L17.63,5.84Z";
var mdiLabelMultiple = "M4 19H13L11 21H4C3.5 21 2.97 20.79 2.59 20.41C2.21 20.03 2 19.5 2 19V9H4V19M17.63 5.84C17.27 5.33 16.67 5 16 5H8C6.9 5 6 5.9 6 7V15C6 16.1 6.9 17 8 17H16C16.67 17 17.27 16.66 17.63 16.15L22 11L17.63 5.84Z";
var mdiLabelMultipleOutline = "M4 18H13L11 20H4C3.5 20 2.97 19.79 2.59 19.41C2.21 19.03 2 18.5 2 18V8H4V18M17.63 4.84C17.27 4.33 16.67 4 16 4H8C6.9 4 6 4.9 6 6V14C6 15.1 6.9 16 8 16H16C16.67 16 17.27 15.66 17.63 15.15L22 10L17.63 4.84M16 14H8V6H16L19.55 10Z";
var mdiLabelOff = "M2,4.27L3.28,3L20,19.72L18.73,21L16.63,18.9C16.43,18.96 16.22,19 16,19H5A2,2 0 0,1 3,17V7C3,6.5 3.17,6.07 3.46,5.73L2,4.27M17.63,5.84L22,12L19,16.2L7.83,5H16C16.67,5 17.27,5.33 17.63,5.84Z";
var mdiLabelOffOutline = "M2,4.27L3.28,3L20,19.72L18.73,21L16.63,18.9C16.43,18.96 16.22,19 16,19H5A2,2 0 0,1 3,17V7C3,6.5 3.17,6.07 3.46,5.73L2,4.27M5,17H14.73L5,7.27V17M19.55,12L16,7H9.82L7.83,5H16C16.67,5 17.27,5.33 17.63,5.84L22,12L19,16.2L17.59,14.76L19.55,12Z";
var mdiLabelOutline = "M16,17H5V7H16L19.55,12M17.63,5.84C17.27,5.33 16.67,5 16,5H5A2,2 0 0,0 3,7V17A2,2 0 0,0 5,19H16C16.67,19 17.27,18.66 17.63,18.15L22,12L17.63,5.84Z";
var mdiLabelPercent = "M17.63 5.84C17.27 5.33 16.67 5 16 5H5C3.9 5 3 5.9 3 7V17C3 18.11 3.9 19 5 19H16C16.67 19 17.27 18.66 17.63 18.15L22 12L17.63 5.84M8.45 8.03C9.23 8.03 9.87 8.67 9.87 9.45S9.23 10.87 8.45 10.87 7.03 10.23 7.03 9.45 7.67 8.03 8.45 8.03M13.55 15.97C12.77 15.97 12.13 15.33 12.13 14.55S12.77 13.13 13.55 13.13 14.97 13.77 14.97 14.55 14.33 15.97 13.55 15.97M8.2 16L7 14.8L13.8 8L15 9.2L8.2 16Z";
var mdiLabelPercentOutline = "M16 17H5V7H16L19.55 12M17.63 5.84C17.27 5.33 16.67 5 16 5H5C3.9 5 3 5.9 3 7V17C3 18.11 3.9 19 5 19H16C16.67 19 17.27 18.66 17.63 18.15L22 12L17.63 5.84M13.8 8L15 9.2L8.2 16L7 14.8M8.45 8.03C9.23 8.03 9.87 8.67 9.87 9.45S9.23 10.87 8.45 10.87 7.03 10.23 7.03 9.45 7.67 8.03 8.45 8.03M13.55 13.13C14.33 13.13 14.97 13.77 14.97 14.55C14.97 15.33 14.33 15.97 13.55 15.97C12.77 15.97 12.13 15.33 12.13 14.55C12.13 13.77 12.77 13.13 13.55 13.13Z";
var mdiLabelVariant = "M3.5,19L8.34,12L3.5,5H14.5C15.17,5 15.72,5.3 16.13,5.86L20.5,12L16.13,18.14C15.72,18.7 15.17,19 14.5,19H3.5Z";
var mdiLabelVariantOutline = "M6.5,17H15L18.5,12L15,7H6.5L10,12L6.5,17M15,19H3L7.5,12L3,5H15C15.69,5 16.23,5.3 16.64,5.86L21,12L16.64,18.14C16.23,18.7 15.69,19 15,19Z";
var mdiLadder = "M14 1V3H10V1H8V22H10V20H14V22H16V1H14M14 5V8H10V5H14M14 10V13H10V10H14M10 18V15H14V18H10Z";
var mdiLadybug = "M12,5C12.74,5 13.47,5.1 14.15,5.29L15.78,2.46C16.06,2 16.67,1.82 17.15,2.1C17.63,2.37 17.79,3 17.5,3.46L16,6.07C17.22,6.78 18.23,7.79 18.93,9H5.07C5.77,7.79 6.78,6.78 8,6.07L6.5,3.46C6.21,3 6.37,2.37 6.85,2.1C7.33,1.82 7.94,2 8.22,2.46L9.85,5.29C10.53,5.1 11.26,5 12,5M20,13C20,17.17 16.82,20.59 12.75,20.97V10.5H19.6C19.86,11.29 20,12.13 20,13M4,13C4,12.13 4.14,11.29 4.4,10.5H11.25V20.97C7.18,20.59 4,17.17 4,13Z";
var mdiLambda = "M6,20L10.16,7.91L9.34,6H8V4H10C10.42,4 10.78,4.26 10.93,4.63L16.66,18H18V20H16C15.57,20 15.21,19.73 15.07,19.36L11.33,10.65L8.12,20H6Z";
var mdiLamp = "M8,2H16L20,14H4L8,2M11,15H13V20H18V22H6V20H11V15Z";
var mdiLampOutline = "M14.56 4L17.23 12H6.78L9.44 4H14.56M16 2H8L4 14H20L16 2M11 15H13V20H18V22H6V20H11V15Z";
var mdiLamps = "M10 2L12 9H2L4 2M6 10H8V20H11V22H3V20H6V10M20 8L22 15H12L14 8M16 16H18V20H21V22H13V20H16V16Z";
var mdiLampsOutline = "M8.5 4L9.35 7H4.65L5.5 4H8.5M10 2H4L2 9H12L10 2M6 10H8V20H11V22H3V20H6V10M18.5 10L19.35 13H14.65L15.5 10H18.5M20 8H14L12 15H22L20 8M16 16H18V20H21V22H13V20H16V16Z";
var mdiLan = "M10,2C8.89,2 8,2.89 8,4V7C8,8.11 8.89,9 10,9H11V11H2V13H6V15H5C3.89,15 3,15.89 3,17V20C3,21.11 3.89,22 5,22H9C10.11,22 11,21.11 11,20V17C11,15.89 10.11,15 9,15H8V13H16V15H15C13.89,15 13,15.89 13,17V20C13,21.11 13.89,22 15,22H19C20.11,22 21,21.11 21,20V17C21,15.89 20.11,15 19,15H18V13H22V11H13V9H14C15.11,9 16,8.11 16,7V4C16,2.89 15.11,2 14,2H10M10,4H14V7H10V4M5,17H9V20H5V17M15,17H19V20H15V17Z";
var mdiLanCheck = "M4 1C2.89 1 2 1.89 2 3V7C2 8.11 2.89 9 4 9H1V11H13V9H10C11.11 9 12 8.11 12 7V3C12 1.89 11.11 1 10 1H4M4 3H10V7H4V3M14 13C12.89 13 12 13.89 12 15V19C12 20.11 12.89 21 14 21H11V23H23V21H20C21.11 21 22 20.11 22 19V15C22 13.89 21.11 13 20 13H14M14 15H20V19H14V15M5.5 20.5L10.5 15.5L9 14L5.5 17.5L3.5 15.5L2 17L5.5 20.5Z";
var mdiLanConnect = "M4,1C2.89,1 2,1.89 2,3V7C2,8.11 2.89,9 4,9H1V11H13V9H10C11.11,9 12,8.11 12,7V3C12,1.89 11.11,1 10,1H4M4,3H10V7H4V3M3,13V18L3,20H10V18H5V13H3M14,13C12.89,13 12,13.89 12,15V19C12,20.11 12.89,21 14,21H11V23H23V21H20C21.11,21 22,20.11 22,19V15C22,13.89 21.11,13 20,13H14M14,15H20V19H14V15Z";
var mdiLanDisconnect = "M4,1C2.89,1 2,1.89 2,3V7C2,8.11 2.89,9 4,9H1V11H13V9H10C11.11,9 12,8.11 12,7V3C12,1.89 11.11,1 10,1H4M4,3H10V7H4V3M14,13C12.89,13 12,13.89 12,15V19C12,20.11 12.89,21 14,21H11V23H23V21H20C21.11,21 22,20.11 22,19V15C22,13.89 21.11,13 20,13H14M3.88,13.46L2.46,14.88L4.59,17L2.46,19.12L3.88,20.54L6,18.41L8.12,20.54L9.54,19.12L7.41,17L9.54,14.88L8.12,13.46L6,15.59L3.88,13.46M14,15H20V19H14V15Z";
var mdiLanPending = "M4,1C2.89,1 2,1.89 2,3V7C2,8.11 2.89,9 4,9H1V11H13V9H10C11.11,9 12,8.11 12,7V3C12,1.89 11.11,1 10,1H4M4,3H10V7H4V3M3,12V14H5V12H3M14,13C12.89,13 12,13.89 12,15V19C12,20.11 12.89,21 14,21H11V23H23V21H20C21.11,21 22,20.11 22,19V15C22,13.89 21.11,13 20,13H14M3,15V17H5V15H3M14,15H20V19H14V15M3,18V20H5V18H3M6,18V20H8V18H6M9,18V20H11V18H9Z";
var mdiLandFields = "M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M15.3 4C14.5 5.1 14 6.5 14 8H10C10 6.4 10.8 4.9 12 4H15.3M14 14H10C10 12.5 9.5 11.1 8.7 10H12C13.2 10.9 14 12.4 14 14M4 4H9.3C8.5 5.1 8 6.5 8 8H4V4M4 10H6C7.2 10.9 8 12.3 8 14H4V10M4 20V16H9.3C8.5 17.1 8 18.5 8 20H4M10 20C10 18.4 10.8 16.9 12 16H15.3C14.5 17.1 14 18.5 14 20H10M20 20H16C16 18.4 16.8 16.9 18 16H20V20M20 14H16C16 12.5 15.5 11.1 14.7 10H20V14M20 8H16C16 6.4 16.8 4.9 18 4H20V8Z";
var mdiLandPlots = "M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M4 4H8V14H4V4M4 20V16H8V20H4M20 20H10V10H20V20M20 8H10V4H20V8Z";
var mdiLandPlotsCircle = "M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M13 7.5C13 5.6 14.6 4 16.5 4C18.4 4 20 5.6 20 7.5C20 9.4 18.4 11 16.5 11C14.6 11 13 9.4 13 7.5M4 4H11V11H4V4M4 20V13H11V20H4M20 20H13V13H20V20Z";
var mdiLandPlotsCircleVariant = "M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M20 9C20 11.8 17.8 14 15 14C12.2 14 10 11.8 10 9C10 6.2 12.2 4 15 4C17.8 4 20 6.2 20 9M4 4H8V14H4V4M4 20V16H8V20H4M20 20H10V16H20V20Z";
var mdiLandPlotsMarker = "M4 2H20C21.1 2 22 2.9 22 4V10H10V20H14.55C14.73 20.3 14.91 20.58 15.09 20.84C15.38 21.27 15.66 21.66 15.92 22H4C2.9 22 2 21.1 2 20V4C2 2.9 2.9 2 4 2M8 4H4V14H8V4M4 16V20H8V16H4M10 8H20V4H10V8M18.5 22C18.5 22 17.92 21.35 17.23 20.41C17.14 20.28 17.04 20.14 16.94 20C16 18.66 15 16.89 15 15.5C15 13.6 16.6 12 18.5 12C19.03 12 19.54 12.13 20 12.35C21.17 12.92 22 14.13 22 15.5C22 17.04 20.77 19.04 19.77 20.41C19.08 21.35 18.5 22 18.5 22M17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8C19.2 16.8 19.8 16.2 19.7 15.6C19.7 15 19.1 14.4 18.5 14.4C17.9 14.4 17.3 14.9 17.3 15.6Z";
var mdiLandRowsHorizontal = "M22 20V4C22 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20M4 6.5V4H20V6.5H4M4 11V8.5H20V11H4M4 15.5V13H20V15.5H4M4 20V17.5H20V20H4Z";
var mdiLandRowsVertical = "M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M6.5 20H4V4H6.5V20M11 20H8.5V4H11V20M15.5 20H13V4H15.5V20M20 20H17.5V4H20V20Z";
var mdiLandslide = "M15.47 13.79L12.89 12.76L6 15.05L2 13.5V15.61L6 16.95L15.47 13.79M10.57 11.42L8 8H2V11.61L6 12.95L10.57 11.42M6 19.05L2 17.72V22H22L17.03 15.38L6 19.05M17 6V1L12 0L9 2V6L12 8L17 6M18.5 7L16 9V12L18.5 14L23 12V8L18.5 7Z";
var mdiLandslideOutline = "M11 12L8 8H2V22H22L16 14L11 12M12.53 14.77L6 16.95L4 16.28V14.39L6 15.06L9.95 13.74L12.53 14.77M7 10L8.57 12.09L6 12.95L4 12.28V10H7M4 20V18.39L6 19.06L15.03 16.05L18 20H4M17 6V1L12 0L9 2V6L12 8L17 6M11 3.07L12.42 2.12L15 2.64V4.65L12.23 5.76L11 4.93V3.07M18.5 7L16 9V12L18.5 14L23 12V8L18.5 7M21 10.7L18.8 11.68L18 11.04V9.96L19 9.16L21 9.6V10.7Z";
var mdiLanguageC = "M15.45,15.97L15.87,18.41C15.61,18.55 15.19,18.68 14.63,18.8C14.06,18.93 13.39,19 12.62,19C10.41,18.96 8.75,18.3 7.64,17.04C6.5,15.77 5.96,14.16 5.96,12.21C6,9.9 6.68,8.13 8,6.89C9.28,5.64 10.92,5 12.9,5C13.65,5 14.3,5.07 14.84,5.19C15.38,5.31 15.78,5.44 16.04,5.59L15.44,8.08L14.4,7.74C14,7.64 13.53,7.59 13,7.59C11.85,7.58 10.89,7.95 10.14,8.69C9.38,9.42 9,10.54 8.96,12.03C8.97,13.39 9.33,14.45 10.04,15.23C10.75,16 11.74,16.4 13.03,16.41L14.36,16.29C14.79,16.21 15.15,16.1 15.45,15.97Z";
var mdiLanguageCpp = "M10.5,15.97L10.91,18.41C10.65,18.55 10.23,18.68 9.67,18.8C9.1,18.93 8.43,19 7.66,19C5.45,18.96 3.79,18.3 2.68,17.04C1.56,15.77 1,14.16 1,12.21C1.05,9.9 1.72,8.13 3,6.89C4.32,5.64 5.96,5 7.94,5C8.69,5 9.34,5.07 9.88,5.19C10.42,5.31 10.82,5.44 11.08,5.59L10.5,8.08L9.44,7.74C9.04,7.64 8.58,7.59 8.05,7.59C6.89,7.58 5.93,7.95 5.18,8.69C4.42,9.42 4.03,10.54 4,12.03C4,13.39 4.37,14.45 5.08,15.23C5.79,16 6.79,16.4 8.07,16.41L9.4,16.29C9.83,16.21 10.19,16.1 10.5,15.97M11,11H13V9H15V11H17V13H15V15H13V13H11V11M18,11H20V9H22V11H24V13H22V15H20V13H18V11Z";
var mdiLanguageCsharp = "M11.5,15.97L11.91,18.41C11.65,18.55 11.23,18.68 10.67,18.8C10.1,18.93 9.43,19 8.66,19C6.45,18.96 4.79,18.3 3.68,17.04C2.56,15.77 2,14.16 2,12.21C2.05,9.9 2.72,8.13 4,6.89C5.32,5.64 6.96,5 8.94,5C9.69,5 10.34,5.07 10.88,5.19C11.42,5.31 11.82,5.44 12.08,5.59L11.5,8.08L10.44,7.74C10.04,7.64 9.58,7.59 9.05,7.59C7.89,7.58 6.93,7.95 6.18,8.69C5.42,9.42 5.03,10.54 5,12.03C5,13.39 5.37,14.45 6.08,15.23C6.79,16 7.79,16.4 9.07,16.41L10.4,16.29C10.83,16.21 11.19,16.1 11.5,15.97M13.89,19L14.5,15H13L13.34,13H14.84L15.16,11H13.66L14,9H15.5L16.11,5H18.11L17.5,9H18.5L19.11,5H21.11L20.5,9H22L21.66,11H20.16L19.84,13H21.34L21,15H19.5L18.89,19H16.89L17.5,15H16.5L15.89,19H13.89M16.84,13H17.84L18.16,11H17.16L16.84,13Z";
var mdiLanguageCss3 = "M5,3L4.35,6.34H17.94L17.5,8.5H3.92L3.26,11.83H16.85L16.09,15.64L10.61,17.45L5.86,15.64L6.19,14H2.85L2.06,18L9.91,21L18.96,18L20.16,11.97L20.4,10.76L21.94,3H5Z";
var mdiLanguageFortran = "M5 4V6H6C6.55 6 7 6.45 7 7V17C7 17.55 6.55 18 6 18H5V20H14V18H12C11.45 18 11 17.55 11 17V13H13C13.55 13 14 13.45 14 14V16H16V8H14V10C14 10.55 13.55 11 13 11H11V6H16C17.11 6 18 7.34 18 9V10H20V4Z";
var mdiLanguageGo = "M2.64,10.33L2.62,10.27L2.84,10L2.96,9.92H6.8L6.83,10L6.65,10.26L6.54,10.32L2.64,10.33M1.03,11.31L1,11.26L1.22,10.97L1.34,10.91H6.24L6.29,11L6.21,11.24L6.11,11.31H1.03M3.63,12.3L3.59,12.24L3.75,11.96L3.85,11.9H6L6.07,11.97L6.05,12.22L5.97,12.3H3.63M14.78,10.14L13,10.61C12.81,10.65 12.8,10.66 12.66,10.5C12.5,10.32 12.39,10.21 12.16,10.1C11.5,9.76 10.83,9.86 10.22,10.25C9.5,10.73 9.11,11.42 9.12,12.3C9.13,13.16 9.72,13.87 10.57,14C11.3,14.09 11.91,13.83 12.4,13.28L12.69,12.89H10.62C10.4,12.89 10.35,12.75 10.42,12.57L10.97,11.39C11,11.33 11.08,11.22 11.24,11.22H14.68C14.83,10.72 15.09,10.26 15.43,9.81C16.21,8.78 17.16,8.24 18.43,8C19.5,7.82 20.56,7.93 21.5,8.57C22.34,9.15 22.87,9.93 23,10.96C23.19,12.41 22.76,13.59 21.76,14.61C21.05,15.33 20.18,15.78 19.19,16L18.33,16.08C17.35,16.06 16.46,15.78 15.71,15.13C15.19,14.68 14.83,14.14 14.65,13.5C14.5,13.74 14.38,13.97 14.21,14.2C13.44,15.22 12.43,15.85 11.15,16C10.1,16.16 9.12,15.95 8.26,15.31C7.47,14.71 7,13.91 6.9,12.92C6.76,11.75 7.1,10.7 7.81,9.78C8.57,8.78 9.58,8.15 10.82,7.92C11.82,7.74 12.79,7.86 13.66,8.44C14.23,8.82 14.63,9.34 14.9,9.96C14.94,10.05 14.9,10.11 14.78,10.14M20.89,11.74L20.86,11.38C20.67,10.32 19.69,9.72 18.67,9.95C17.66,10.17 17,10.8 16.79,11.81C16.6,12.65 17,13.5 17.77,13.84C18.36,14.1 18.96,14.06 19.53,13.78C20.37,13.35 20.84,12.66 20.89,11.74Z";
var mdiLanguageHaskell = "M2.08,19L6.75,12L2.08,5H5.58L10.25,12L5.58,19H2.08M6.75,19L11.42,12L6.75,5H10.25L19.59,19H16.09L13.17,14.63L10.25,19H6.75M18.03,14.92L16.5,12.58H21.92V14.92H18.03M15.7,11.42L14.14,9.08H21.92V11.42H15.7Z";
var mdiLanguageHtml5 = "M12,17.56L16.07,16.43L16.62,10.33H9.38L9.2,8.3H16.8L17,6.31H7L7.56,12.32H14.45L14.22,14.9L12,15.5L9.78,14.9L9.64,13.24H7.64L7.93,16.43L12,17.56M4.07,3H19.93L18.5,19.2L12,21L5.5,19.2L4.07,3Z";
var mdiLanguageJava = "M16.5,6.08C16.5,6.08 9.66,7.79 12.94,11.56C13.91,12.67 12.69,13.67 12.69,13.67C12.69,13.67 15.14,12.42 14,10.82C12.94,9.35 12.14,8.62 16.5,6.08M12.03,7.28C16.08,4.08 14,2 14,2C14.84,5.3 11.04,6.3 9.67,8.36C8.73,9.76 10.13,11.27 12,13C11.29,11.3 8.78,9.84 12.03,7.28M9.37,17.47C6.29,18.33 11.25,20.1 15.16,18.43C14.78,18.28 14.41,18.1 14.06,17.89C12.7,18.2 11.3,18.26 9.92,18.07C8.61,17.91 9.37,17.47 9.37,17.47M14.69,15.79C12.94,16.17 11.13,16.26 9.35,16.05C8.04,15.92 8.9,15.28 8.9,15.28C5.5,16.41 10.78,17.68 15.5,16.3C15.21,16.19 14.93,16 14.69,15.79M18.11,19.09C18.11,19.09 18.68,19.56 17.5,19.92C15.22,20.6 8.07,20.81 6.09,19.95C5.38,19.64 6.72,19.21 7.14,19.12C7.37,19.06 7.6,19.04 7.83,19.04C7.04,18.5 2.7,20.14 5.64,20.6C13.61,21.9 20.18,20 18.11,19.09M15.37,14.23C15.66,14.04 15.97,13.88 16.29,13.74C16.29,13.74 14.78,14 13.27,14.14C11.67,14.3 10.06,14.32 8.46,14.2C6.11,13.89 9.75,13 9.75,13C8.65,13 7.57,13.26 6.59,13.75C4.54,14.75 11.69,15.2 15.37,14.23M16.27,16.65C16.25,16.69 16.23,16.72 16.19,16.75C21.2,15.44 19.36,12.11 16.96,12.94C16.83,13 16.72,13.08 16.65,13.19C16.79,13.14 16.93,13.1 17.08,13.07C18.28,12.83 20,14.7 16.27,16.65M16.4,21.26C13.39,21.78 10.31,21.82 7.28,21.4C7.28,21.4 7.74,21.78 10.09,21.93C13.69,22.16 19.22,21.8 19.35,20.1C19.38,20.11 19.12,20.75 16.4,21.26Z";
var mdiLanguageJavascript = "M3,3H21V21H3V3M7.73,18.04C8.13,18.89 8.92,19.59 10.27,19.59C11.77,19.59 12.8,18.79 12.8,17.04V11.26H11.1V17C11.1,17.86 10.75,18.08 10.2,18.08C9.62,18.08 9.38,17.68 9.11,17.21L7.73,18.04M13.71,17.86C14.21,18.84 15.22,19.59 16.8,19.59C18.4,19.59 19.6,18.76 19.6,17.23C19.6,15.82 18.79,15.19 17.35,14.57L16.93,14.39C16.2,14.08 15.89,13.87 15.89,13.37C15.89,12.96 16.2,12.64 16.7,12.64C17.18,12.64 17.5,12.85 17.79,13.37L19.1,12.5C18.55,11.54 17.77,11.17 16.7,11.17C15.19,11.17 14.22,12.13 14.22,13.4C14.22,14.78 15.03,15.43 16.25,15.95L16.67,16.13C17.45,16.47 17.91,16.68 17.91,17.26C17.91,17.74 17.46,18.09 16.76,18.09C15.93,18.09 15.45,17.66 15.09,17.06L13.71,17.86Z";
var mdiLanguageKotlin = "M2 2H22L12 12L22 22H2Z";
var mdiLanguageLua = "M10.5,5A8.5,8.5 0 0,0 2,13.5A8.5,8.5 0 0,0 10.5,22A8.5,8.5 0 0,0 19,13.5A8.5,8.5 0 0,0 10.5,5M13.5,13A2.5,2.5 0 0,1 11,10.5A2.5,2.5 0 0,1 13.5,8A2.5,2.5 0 0,1 16,10.5A2.5,2.5 0 0,1 13.5,13M19.5,2A2.5,2.5 0 0,0 17,4.5A2.5,2.5 0 0,0 19.5,7A2.5,2.5 0 0,0 22,4.5A2.5,2.5 0 0,0 19.5,2";
var mdiLanguageMarkdown = "M20.56 18H3.44C2.65 18 2 17.37 2 16.59V7.41C2 6.63 2.65 6 3.44 6H20.56C21.35 6 22 6.63 22 7.41V16.59C22 17.37 21.35 18 20.56 18M6.81 15.19V11.53L8.73 13.88L10.65 11.53V15.19H12.58V8.81H10.65L8.73 11.16L6.81 8.81H4.89V15.19H6.81M19.69 12H17.77V8.81H15.85V12H13.92L16.81 15.28L19.69 12Z";
var mdiLanguageMarkdownOutline = "M20.56 18H3.44C2.65 18 2 17.37 2 16.59V7.41C2 6.63 2.65 6 3.44 6H20.56C21.35 6 22 6.63 22 7.41V16.59C22 17.37 21.35 18 20.56 18M3.44 6.94C3.18 6.94 2.96 7.15 2.96 7.41V16.6C2.96 16.85 3.18 17.06 3.44 17.06H20.56C20.82 17.06 21.04 16.85 21.04 16.6V7.41C21.04 7.15 20.82 6.94 20.56 6.94H3.44M4.89 15.19V8.81H6.81L8.73 11.16L10.65 8.81H12.58V15.19H10.65V11.53L8.73 13.88L6.81 11.53V15.19H4.89M16.9 15.19L14 12.09H15.94V8.81H17.86V12.09H19.79L16.9 15.19";
var mdiLanguagePhp = "M12,18.08C5.37,18.08 0,15.36 0,12C0,8.64 5.37,5.92 12,5.92C18.63,5.92 24,8.64 24,12C24,15.36 18.63,18.08 12,18.08M6.81,10.13C7.35,10.13 7.72,10.23 7.9,10.44C8.08,10.64 8.12,11 8.03,11.47C7.93,12 7.74,12.34 7.45,12.56C7.17,12.78 6.74,12.89 6.16,12.89H5.29L5.82,10.13H6.81M3.31,15.68H4.75L5.09,13.93H6.32C6.86,13.93 7.3,13.87 7.65,13.76C8,13.64 8.32,13.45 8.61,13.18C8.85,12.96 9.04,12.72 9.19,12.45C9.34,12.19 9.45,11.89 9.5,11.57C9.66,10.79 9.55,10.18 9.17,9.75C8.78,9.31 8.18,9.1 7.35,9.1H4.59L3.31,15.68M10.56,7.35L9.28,13.93H10.7L11.44,10.16H12.58C12.94,10.16 13.18,10.22 13.29,10.34C13.4,10.46 13.42,10.68 13.36,11L12.79,13.93H14.24L14.83,10.86C14.96,10.24 14.86,9.79 14.56,9.5C14.26,9.23 13.71,9.1 12.91,9.1H11.64L12,7.35H10.56M18,10.13C18.55,10.13 18.91,10.23 19.09,10.44C19.27,10.64 19.31,11 19.22,11.47C19.12,12 18.93,12.34 18.65,12.56C18.36,12.78 17.93,12.89 17.35,12.89H16.5L17,10.13H18M14.5,15.68H15.94L16.28,13.93H17.5C18.05,13.93 18.5,13.87 18.85,13.76C19.2,13.64 19.5,13.45 19.8,13.18C20.04,12.96 20.24,12.72 20.38,12.45C20.53,12.19 20.64,11.89 20.7,11.57C20.85,10.79 20.74,10.18 20.36,9.75C20,9.31 19.37,9.1 18.54,9.1H15.79L14.5,15.68Z";
var mdiLanguagePython = "M19.14,7.5A2.86,2.86 0 0,1 22,10.36V14.14A2.86,2.86 0 0,1 19.14,17H12C12,17.39 12.32,17.96 12.71,17.96H17V19.64A2.86,2.86 0 0,1 14.14,22.5H9.86A2.86,2.86 0 0,1 7,19.64V15.89C7,14.31 8.28,13.04 9.86,13.04H15.11C16.69,13.04 17.96,11.76 17.96,10.18V7.5H19.14M14.86,19.29C14.46,19.29 14.14,19.59 14.14,20.18C14.14,20.77 14.46,20.89 14.86,20.89A0.71,0.71 0 0,0 15.57,20.18C15.57,19.59 15.25,19.29 14.86,19.29M4.86,17.5C3.28,17.5 2,16.22 2,14.64V10.86C2,9.28 3.28,8 4.86,8H12C12,7.61 11.68,7.04 11.29,7.04H7V5.36C7,3.78 8.28,2.5 9.86,2.5H14.14C15.72,2.5 17,3.78 17,5.36V9.11C17,10.69 15.72,11.96 14.14,11.96H8.89C7.31,11.96 6.04,13.24 6.04,14.82V17.5H4.86M9.14,5.71C9.54,5.71 9.86,5.41 9.86,4.82C9.86,4.23 9.54,4.11 9.14,4.11C8.75,4.11 8.43,4.23 8.43,4.82C8.43,5.41 8.75,5.71 9.14,5.71Z";
var mdiLanguageR = "M12,4.29C6.5,4.29 2,7.29 2,11C2,14.28 5.56,17 10.24,17.58V19.71H13.65V17.59C14.5,17.5 15.29,17.34 16.04,17.11L17.42,19.71H21.28L18.96,15.8C20.83,14.58 22,12.87 22,11C22,7.29 17.5,4.29 12,4.29V4.29M13.53,6.91C17.73,6.91 20.83,8.31 20.83,11.5C20.83,13.21 19.91,14.41 18.41,15.15C18.32,15.1 18.24,15.05 18.19,15C17.83,14.84 17.23,14.66 17.23,14.66C17.23,14.66 20.21,14.44 20.21,11.47C20.21,8.5 17.09,8.45 17.09,8.45H10.24V15.61C7.69,14.87 5.93,13.3 5.93,11.5C5.93,8.96 9.33,6.91 13.53,6.91M13.68,10.89H15.75C15.75,10.89 16.7,10.84 16.7,11.83C16.7,12.8 15.75,12.8 15.75,12.8H13.68V10.89M13.65,15.3H14.57C14.75,15.3 14.84,15.35 15,15.5C15.13,15.6 15.27,15.79 15.39,15.96C14.84,16.03 14.26,16.06 13.65,16.06V15.3Z";
var mdiLanguageRuby = "M18.8,2.07C21.32,2.5 22.04,4.23 22,6.04V6L20.86,20.93L6.08,21.94H6.09C4.86,21.89 2.13,21.77 2,17.95L3.37,15.45L6.14,21.91L8.5,14.29L8.45,14.3L8.47,14.28L16.18,16.74L14.19,8.96L21.54,8.5L15.75,3.76L18.8,2.06V2.07M2,17.91V17.93L2,17.91V17.91M6.28,6.23C9.24,3.28 13.07,1.54 14.54,3.03C16,4.5 14.46,8.12 11.5,11.06C8.5,14 4.73,15.84 3.26,14.36C1.79,12.87 3.3,9.17 6.27,6.23H6.28Z";
var mdiLanguageRubyOnRails = "M19.8,16.7C19.8,16.7 21.6,16.5 21.6,14.3C21.6,12.1 19.5,11.8 19.5,11.8H15.7V19H17.6V17.3L19.3,19H22L19.8,16.7M19,15.3H17.5V13.7H19C19,13.7 19.4,13.9 19.4,14.5C19.5,15.1 19,15.3 19,15.3M21.3,8.2V8.4C13.2,6.1 10,13.2 10.6,18.7C10.6,18.7 4.9,18.7 4.3,18.7C5,13.3 11.8,2.6 21.3,8.2M20.5,6.9C19.8,6.6 19.1,6.3 18.4,6.1L18.5,4.8L20.6,5.6L20.5,6.9M18.5,8.7C19.2,8.7 19.9,8.8 20.6,9L20.5,10.2L18.7,10L18.5,8.7M13.9,5.8L13.5,4.6L15.6,4.4L16,5.7C15.8,5.7 14.1,5.8 13.9,5.8M15.2,9.5C15.6,9.3 16.3,9 17.2,8.8L17.6,10L15.8,10.7L15.2,9.5M11.8,6.5C11.2,6.8 10.6,7.1 10,7.5L9.2,6.2L11,5.2L11.8,6.5M14.3,10.1L15.1,11.3L14,12.6L12.9,11.6C13.2,11 13.7,10.5 14.3,10.1M11.6,15C11.7,14.2 11.9,13.5 12.2,12.7L13.4,13.7L13.1,15.6L11.6,15M7.9,9.3C7.4,9.8 6.9,10.4 6.5,10.9L5.2,9.8L6.7,8.2L7.9,9.3M4.8,13.7C4.4,14.5 4.1,15.3 3.8,16L2,15.3L2.9,13L4.8,13.7M11.5,16.3L13.3,16.9L13.6,18.9L11.6,18.4C11.6,18.2 11.5,17.5 11.5,16.3Z";
var mdiLanguageRust = "M21.9 11.7L21 11.2V11L21.7 10.3C21.8 10.2 21.8 10 21.7 9.9L21.6 9.8L20.7 9.5C20.7 9.4 20.7 9.3 20.6 9.3L21.2 8.5C21.3 8.4 21.3 8.2 21.1 8.1C21.1 8.1 21 8.1 21 8L20 7.8C20 7.7 19.9 7.7 19.9 7.6L20.3 6.7V6.4C20.2 6.3 20.1 6.3 20 6.3H19C19 6.3 19 6.2 18.9 6.2L19.1 5.2C19.1 5 19 4.9 18.9 4.9H18.8L17.8 5.1C17.8 5 17.7 5 17.6 4.9V3.9C17.6 3.7 17.5 3.6 17.3 3.6H17.2L16.3 4H16.2L16 3C16 2.8 15.8 2.7 15.7 2.8H15.6L14.8 3.4C14.7 3.4 14.6 3.4 14.6 3.3L14.3 2.4C14.2 2.3 14.1 2.2 13.9 2.2C13.9 2.2 13.8 2.2 13.8 2.3L13 3H12.8L12.3 2.2C12.2 2 12 2 11.8 2L11.7 2.1L11.2 3H11L10.3 2.3C10.2 2.2 10 2.2 9.9 2.3L9.8 2.4L9.5 3.3C9.4 3.3 9.3 3.3 9.3 3.4L8.5 2.8C8.3 2.7 8.1 2.7 8 2.9V3L7.8 4C7.8 4 7.7 4 7.6 4.1L6.7 3.7C6.6 3.6 6.4 3.7 6.3 3.8V4.9C6.3 5 6.2 5 6.2 5.1L5.2 4.9C5 4.8 4.9 4.9 4.9 5.1V5.2L5.1 6.2C5 6.2 5 6.3 4.9 6.3H3.9C3.7 6.3 3.6 6.4 3.6 6.6V6.7L4 7.6V7.8L3 8C2.8 8 2.7 8.2 2.7 8.3V8.4L3.3 9.2C3.3 9.3 3.3 9.4 3.2 9.4L2.4 9.8C2.3 9.9 2.2 10 2.2 10.2C2.2 10.2 2.2 10.3 2.3 10.3L3 11V11.2L2.2 11.7C2 11.8 2 12 2 12.1L2.1 12.2L3 12.8V13L2.3 13.7C2.2 13.8 2.2 14 2.3 14.1L2.4 14.2L3.3 14.5C3.3 14.6 3.3 14.7 3.4 14.7L2.8 15.5C2.7 15.6 2.7 15.8 2.9 15.9C2.9 15.9 3 15.9 3 16L4 16.2C4 16.3 4.1 16.3 4.1 16.4L3.7 17.3C3.6 17.4 3.7 17.6 3.8 17.7H4.9C5 17.7 5 17.8 5.1 17.8L4.9 18.8C4.9 19 5 19.1 5.1 19.1H5.2L6.2 18.9C6.2 19 6.3 19 6.4 19.1V20.1C6.4 20.3 6.5 20.4 6.7 20.4H6.8L7.7 20H7.8L8 21C8 21.2 8.2 21.3 8.3 21.2H8.4L9.2 20.6C9.3 20.6 9.4 20.6 9.4 20.7L9.7 21.6C9.8 21.7 9.9 21.8 10.1 21.8C10.1 21.8 10.2 21.8 10.2 21.7L11 21H11.2L11.7 21.8C11.8 21.9 12 22 12.1 21.9L12.2 21.8L12.7 21H12.9L13.6 21.7C13.7 21.8 13.9 21.8 14 21.7L14.1 21.6L14.4 20.7C14.5 20.7 14.6 20.7 14.6 20.6L15.4 21.2C15.5 21.3 15.7 21.3 15.8 21.1C15.8 21.1 15.8 21 15.9 21L16.1 20C16.2 20 16.2 19.9 16.3 19.9L17.2 20.3C17.3 20.4 17.5 20.3 17.6 20.2V19.1L17.8 18.9L18.8 19.1C19 19.1 19.1 19 19.1 18.9V18.8L18.9 17.8L19.1 17.6H20.1C20.3 17.6 20.4 17.5 20.4 17.3V17.2L20 16.3C20 16.2 20.1 16.2 20.1 16.1L21.1 15.9C21.3 15.9 21.4 15.7 21.3 15.6V15.5L20.7 14.7L20.8 14.5L21.7 14.2C21.8 14.1 21.9 14 21.9 13.8C21.9 13.8 21.9 13.7 21.8 13.7L21 13V12.8L21.8 12.3C22 12.2 22 12 21.9 11.7C21.9 11.8 21.9 11.8 21.9 11.7M16.2 18.7C15.9 18.6 15.7 18.3 15.7 18C15.8 17.7 16.1 17.5 16.4 17.5C16.7 17.6 16.9 17.9 16.9 18.2C16.9 18.6 16.6 18.8 16.2 18.7M16 16.8C15.7 16.7 15.4 16.9 15.4 17.2L15 18.6C14.1 19 13.1 19.2 12 19.2C10.9 19.2 9.9 19 8.9 18.5L8.6 17.1C8.5 16.8 8.3 16.6 8 16.7L6.8 17C6.6 16.8 6.4 16.5 6.2 16.3H12.2C12.3 16.3 12.3 16.3 12.3 16.2V14.1C12.3 14 12.3 14 12.2 14H10.5V12.7H12.4C12.6 12.7 13.3 12.7 13.6 13.7C13.7 14 13.8 15 14 15.3C14.1 15.6 14.6 16.3 15.1 16.3H18.2C18 16.6 17.8 16.8 17.5 17.1L16 16.8M7.7 18.7C7.4 18.8 7.1 18.6 7 18.2C6.9 17.9 7.1 17.6 7.5 17.5S8.1 17.6 8.2 18C8.2 18.3 8 18.6 7.7 18.7M5.4 9.5C5.5 9.8 5.4 10.2 5.1 10.3C4.8 10.4 4.4 10.3 4.3 10C4.2 9.7 4.3 9.3 4.6 9.2C5 9.1 5.3 9.2 5.4 9.5M4.7 11.1L6 10.6C6.3 10.5 6.4 10.2 6.3 9.9L6 9.3H7V14H5C4.7 13 4.6 12.1 4.7 11.1M10.3 10.7V9.3H12.8C12.9 9.3 13.7 9.4 13.7 10C13.7 10.5 13.1 10.7 12.6 10.7H10.3M19.3 11.9V12.4H18.5C18.4 12.4 18.4 12.4 18.4 12.5V12.8C18.4 13.6 17.9 13.8 17.5 13.8C17.1 13.8 16.7 13.6 16.6 13.4C16.4 12.1 16 11.9 15.4 11.4C16.1 10.9 16.9 10.2 16.9 9.3C16.9 8.3 16.2 7.7 15.8 7.4C15.1 7 14.4 6.9 14.2 6.9H6.6C7.7 5.7 9.1 4.9 10.7 4.6L11.6 5.6C11.8 5.8 12.1 5.8 12.4 5.6L13.4 4.6C15.5 5 17.3 6.3 18.4 8.2L17.7 9.8C17.6 10.1 17.7 10.4 18 10.5L19.3 11.1V11.9M11.6 3.9C11.8 3.7 12.2 3.7 12.4 3.9C12.6 4.1 12.6 4.5 12.4 4.7C12.1 5 11.8 5 11.5 4.7C11.3 4.5 11.4 4.2 11.6 3.9M18.5 9.5C18.6 9.2 19 9.1 19.3 9.2C19.6 9.3 19.7 9.7 19.6 10C19.5 10.3 19.1 10.4 18.8 10.3C18.5 10.2 18.4 9.8 18.5 9.5Z";
var mdiLanguageSwift = "M17.09,19.72C14.73,21.08 11.5,21.22 8.23,19.82C5.59,18.7 3.4,16.74 2,14.5C2.67,15.05 3.46,15.5 4.3,15.9C7.67,17.47 11.03,17.36 13.4,15.9C10.03,13.31 7.16,9.94 5.03,7.19C4.58,6.74 4.25,6.18 3.91,5.68C12.19,11.73 11.83,13.27 6.32,4.67C11.21,9.61 15.75,12.41 15.75,12.41C15.91,12.5 16,12.57 16.11,12.63C16.21,12.38 16.3,12.12 16.37,11.85C17.16,9 16.26,5.73 14.29,3.04C18.84,5.79 21.54,10.95 20.41,15.28C20.38,15.39 20.35,15.5 20.36,15.67C22.6,18.5 22,21.45 21.71,20.89C20.5,18.5 18.23,19.24 17.09,19.72V19.72Z";
var mdiLanguageTypescript = "M3,3H21V21H3V3M13.71,17.86C14.21,18.84 15.22,19.59 16.8,19.59C18.4,19.59 19.6,18.76 19.6,17.23C19.6,15.82 18.79,15.19 17.35,14.57L16.93,14.39C16.2,14.08 15.89,13.87 15.89,13.37C15.89,12.96 16.2,12.64 16.7,12.64C17.18,12.64 17.5,12.85 17.79,13.37L19.1,12.5C18.55,11.54 17.77,11.17 16.7,11.17C15.19,11.17 14.22,12.13 14.22,13.4C14.22,14.78 15.03,15.43 16.25,15.95L16.67,16.13C17.45,16.47 17.91,16.68 17.91,17.26C17.91,17.74 17.46,18.09 16.76,18.09C15.93,18.09 15.45,17.66 15.09,17.06L13.71,17.86M13,11.25H8V12.75H9.5V20H11.25V12.75H13V11.25Z";
var mdiLanguageXaml = "M16.93 7.9L19.31 12L16.95 16.09L16.33 15L17.8 12.5C17.97 12.19 17.97 11.83 17.8 11.54L16.32 9L16.93 7.9M16.92 6.57C16.89 6.57 16.85 6.59 16.83 6.62L15.56 8.87C15.5 8.94 15.5 9 15.56 9.09L17.18 11.9C17.22 11.97 17.22 12.05 17.18 12.12L15.57 14.91C15.53 14.97 15.53 15.06 15.57 15.13L16.85 17.36C16.87 17.4 16.91 17.42 16.94 17.42C17 17.42 17 17.4 17.04 17.36L20 12.23C20.08 12.09 20.08 11.92 20 11.79L17 6.62C17 6.59 16.96 6.57 16.92 6.57M21.91 11.67L17.23 3.58C17.11 3.38 16.89 3.25 16.66 3.25H7.28C7.05 3.25 6.83 3.38 6.71 3.58L2 11.67C1.91 11.87 1.91 12.13 2 12.33L6.71 20.42C6.83 20.62 7.05 20.75 7.28 20.75H16.66C16.89 20.75 17.11 20.62 17.23 20.42L21.91 12.33C22.03 12.13 22.03 11.88 21.91 11.67M7.3 3.95H16.12L11.76 11.65H6.93L10.87 4.82C10.91 4.75 10.86 4.66 10.78 4.66L8.21 4.65C8.13 4.65 8.06 4.7 8 4.76L4.04 11.65H2.84L7.3 3.95M6.17 12.46L9.74 18.63L8.5 18.63L4.87 12.35L4.67 12L4.87 11.65L8.5 5.37L9.73 5.37L6.17 11.53C6.15 11.57 6.13 11.61 6.11 11.65C6.03 11.88 6.03 12.13 6.12 12.35C6.13 12.39 6.15 12.43 6.17 12.46M7.3 20.05L2.85 12.35H4.05L8.03 19.23C8.07 19.3 8.14 19.34 8.22 19.34L10.79 19.34C10.87 19.34 10.92 19.25 10.88 19.18L6.94 12.35H11.77L16.17 20.05H7.3M16.8 19.75L12.37 12L16.78 4.21L21.29 12L16.8 19.75Z";
var mdiLaptop = "M4,6H20V16H4M20,18A2,2 0 0,0 22,16V6C22,4.89 21.1,4 20,4H4C2.89,4 2,4.89 2,6V16A2,2 0 0,0 4,18H0V20H24V18H20Z";
var mdiLaptopAccount = "M20 4C21.1 4 22 4.89 22 6V16C22 17.11 21.11 18 20 18H24V20H0V18H4C2.9 18 2 17.11 2 16V6C2 4.89 2.89 4 4 4H20M20 6H4V16H20V6M12 12C14.21 12 16 12.9 16 14V15H8V14C8 12.9 9.79 12 12 12M12 7C13.11 7 14 7.9 14 9S13.11 11 12 11 10 10.11 10 9 10.9 7 12 7Z";
var mdiLaptopOff = "M1,4.27L2.28,3L20,20.72L18.73,22L16.73,20H0V18H4C2.89,18 2,17.1 2,16V6C2,5.78 2.04,5.57 2.1,5.37L1,4.27M4,16H12.73L4,7.27V16M20,16V6H7.82L5.82,4H20A2,2 0 0,1 22,6V16A2,2 0 0,1 20,18H24V20H21.82L17.82,16H20Z";
var mdiLaravel = "M21.7 6.53C21.71 6.55 21.71 6.58 21.71 6.61V10.9C21.71 11 21.65 11.12 21.56 11.17L17.95 13.25V17.36C17.95 17.47 17.9 17.57 17.8 17.63L10.28 21.96C10.26 21.97 10.24 22 10.22 22L10.2 22C10.15 22 10.09 22 10.04 22C10.03 22 10 22 10 22C10 22 10 21.97 9.96 21.96L2.44 17.63C2.35 17.58 2.29 17.47 2.29 17.36V4.5C2.29 4.45 2.29 4.42 2.3 4.4C2.3 4.39 2.31 4.38 2.31 4.37C2.31 4.35 2.32 4.34 2.33 4.32C2.33 4.31 2.34 4.3 2.35 4.29C2.36 4.28 2.37 4.27 2.38 4.26C2.39 4.25 2.4 4.24 2.41 4.23C2.42 4.22 2.43 4.21 2.44 4.21L6.2 2.04C6.3 2 6.42 2 6.5 2.04L10.28 4.21H10.28C10.29 4.22 10.3 4.22 10.31 4.23C10.32 4.24 10.33 4.25 10.34 4.26C10.35 4.27 10.36 4.28 10.37 4.29C10.38 4.3 10.39 4.31 10.39 4.32C10.4 4.34 10.41 4.35 10.41 4.37C10.41 4.38 10.42 4.39 10.42 4.4C10.43 4.43 10.43 4.45 10.43 4.5V12.5L13.57 10.72V6.61C13.57 6.58 13.57 6.55 13.58 6.53L13.59 6.5C13.59 6.5 13.6 6.47 13.61 6.45C13.61 6.44 13.62 6.43 13.63 6.42C13.64 6.41 13.65 6.4 13.66 6.39C13.67 6.38 13.68 6.37 13.69 6.36C13.7 6.35 13.71 6.34 13.72 6.34L17.5 4.17C17.58 4.11 17.7 4.11 17.8 4.17L21.56 6.34C21.57 6.34 21.58 6.35 21.59 6.36L21.62 6.39C21.63 6.4 21.64 6.41 21.65 6.42C21.66 6.43 21.66 6.44 21.67 6.45C21.68 6.47 21.68 6.5 21.69 6.5C21.7 6.5 21.7 6.5 21.7 6.53M21.09 10.72V7.15L17.95 8.95V12.5L21.09 10.72M17.33 17.18V13.6L10.43 17.54V21.15L17.33 17.18M2.91 5V17.18L9.81 21.15V17.54L6.21 15.5L6.2 15.5L6.2 15.5C6.19 15.5 6.18 15.5 6.17 15.47C6.16 15.47 6.15 15.46 6.14 15.45V15.45C6.13 15.44 6.12 15.43 6.11 15.42C6.1 15.41 6.1 15.4 6.09 15.39V15.39C6.08 15.37 6.08 15.36 6.07 15.35C6.07 15.33 6.06 15.32 6.06 15.31C6.05 15.3 6.05 15.28 6.05 15.27C6.05 15.25 6.05 15.24 6.05 15.23V6.82L2.91 5M6.36 2.68L3.23 4.5L6.36 6.28L9.5 4.5L6.36 2.68M9.81 12.88V5L6.67 6.82V14.69L9.81 12.88M17.64 4.8L14.5 6.61L17.64 8.41L20.77 6.61L17.64 4.8M17.33 8.95L14.19 7.15V10.72L17.33 12.5V8.95M10.12 17L17 13.06L13.88 11.26L7 15.23L10.12 17Z";
var mdiLaserPointer = "M9 13L5 16C4 16.88 3.86 18.12 4 19C4.13 20 4.91 21.22 6 21.68C7.57 22.35 9.09 21.9 10.04 20.92L19 13C20.86 11.62 20 9 18 9H12L19.46 4.61C19.9 4.29 20.08 3.82 20.06 3.37C20 2.67 19.46 2 18.6 2H18.54C18.19 2 17.86 2.11 17.56 2.29L5 9C4.19 9.46 3.94 10.24 4 11C4.05 12.03 4.74 13 6 13M5 18.5C5 17.12 6.12 16 7.5 16S10 17.12 10 18.5 8.88 21 7.5 21 5 19.88 5 18.5Z";
var mdiLasso = "M22 9C22 5.13 17.5 2 12 2C6.5 2 2 5.13 2 9C2 9.00843 2.00002 9.01685 2.00006 9.02527C2.00952 10.8953 3.06771 12.5956 4.78 13.85C4.78103 13.847 4.78207 13.844 4.7831 13.841C5.18858 14.1369 5.63069 14.408 6.10419 14.6507C6.03614 14.9227 6 15.2072 6 15.5C6 16.76 6.67 17.87 7.67 18.5C7.46 19.11 6.97 20.96 8.3 22.05C9.91 23.38 11.66 22.97 12.56 22.69C12.8116 22.6126 13.0655 22.5076 13.3395 22.3944C14.0563 22.0981 14.9105 21.7451 16.22 21.68C17.6764 21.5995 18.9321 21.8104 19.5651 21.9167C19.7188 21.9425 19.8358 21.9622 19.91 21.97C19.91 21.97 20.86 21.97 20.97 21.04C21.08 20.1 20.03 19.97 20.03 19.97C20.03 19.97 18.43 19.7 16.39 19.71C14.9823 19.7145 13.7447 20.1595 12.703 20.5341C11.4434 20.987 10.4704 21.3368 9.83 20.68C9.18 20 9.39 19.36 9.6 19C11.3416 18.9542 12.7471 17.6481 12.9693 15.9673C13.4921 15.9319 14.0034 15.8699 14.5 15.78C18.6753 15.0244 21.7995 12.4293 21.9907 9.30406C21.9969 9.20324 22 9.10187 22 9ZM20 9C20 10.2554 19.2572 11.4047 18.032 12.2843C16.6998 13.2393 14.7966 13.8752 12.6542 13.9835C12.0881 12.8109 10.887 12 9.5 12C8.57261 12 7.72834 12.3625 7.10143 12.9533C6.61638 12.7181 6.17578 12.4489 5.78883 12.1513L5.79 12.15C4.6875 11.3034 4.02105 10.2243 4.00049 9.05571C4.00016 9.03717 4 9.01859 4 9C4 6.24 7.58 4 12 4C16.42 4 20 6.24 20 9ZM10.9988 15.5603C10.9933 15.6993 10.9689 15.8333 10.9281 15.96C10.7345 16.5641 10.1694 17 9.5 17C8.67 17 8 16.33 8 15.5C8 15.4718 8.00078 15.4437 8.00231 15.4159C8.04595 14.6266 8.69981 14 9.5 14C10.3284 14 11 14.6716 11 15.5C11 15.5202 10.9996 15.5403 10.9988 15.5603Z";
var mdiLastpass = "M14,12A2,2 0 0,1 16,10A2,2 0 0,1 18,12A2,2 0 0,1 16,14A2,2 0 0,1 14,12M8,12A2,2 0 0,1 10,10A2,2 0 0,1 12,12A2,2 0 0,1 10,14A2,2 0 0,1 8,12M2,12A2,2 0 0,1 4,10A2,2 0 0,1 6,12A2,2 0 0,1 4,14A2,2 0 0,1 2,12M22,5H20V19H22V5Z";
var mdiLatitude = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 4C15 4 17.5 5.6 18.9 8H5.1C6.5 5.6 9 4 12 4M12 20C9 20 6.5 18.4 5.1 16H18.9C17.5 18.4 15 20 12 20M4.3 14C4.1 13.4 4 12.7 4 12S4.1 10.6 4.3 10H19.8C20 10.6 20.1 11.3 20.1 12S20 13.4 19.8 14H4.3Z";
var mdiLaunch = "M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z";
var mdiLavaLamp = "M10,3L8,16H16L14,3H10M11.5,5.75A0.75,0.75 0 0,1 12.25,6.5A0.75,0.75 0 0,1 11.5,7.25A0.75,0.75 0 0,1 10.75,6.5A0.75,0.75 0 0,1 11.5,5.75M12.5,8.5A1,1 0 0,1 13.5,9.5A1,1 0 0,1 12.5,10.5A1,1 0 0,1 11.5,9.5A1,1 0 0,1 12.5,8.5M11.5,12A1.5,1.5 0 0,1 13,13.5A1.5,1.5 0 0,1 11.5,15A1.5,1.5 0 0,1 10,13.5A1.5,1.5 0 0,1 11.5,12M8,17L10,19L8,21H16L14,19L16,17H8Z";
var mdiLayers = "M12,16L19.36,10.27L21,9L12,2L3,9L4.63,10.27M12,18.54L4.62,12.81L3,14.07L12,21.07L21,14.07L19.37,12.8L12,18.54Z";
var mdiLayersEdit = "M4.63 10.27L3 9L12 2L19.94 8.17L12.5 15.61L12 16L4.63 10.27M10 18.94V18.11L10.59 17.53L10.63 17.5L4.62 12.81L3 14.07L10 19.5V18.94M21.7 12.58L20.42 11.3C20.21 11.09 19.86 11.09 19.65 11.3L18.65 12.3L20.7 14.35L21.7 13.35C21.91 13.14 21.91 12.79 21.7 12.58M12 21H14.06L20.11 14.93L18.06 12.88L12 18.94V21Z";
var mdiLayersMinus = "M22,17V19H14V17H22M11,16L2,9L11,2L20,9L11,16M11,18.54L12,17.75V18C12,18.71 12.12,19.39 12.35,20L11,21.07L2,14.07L3.62,12.81L11,18.54Z";
var mdiLayersOff = "M3.27,1L2,2.27L6.22,6.5L3,9L4.63,10.27L12,16L14.1,14.37L15.53,15.8L12,18.54L4.63,12.81L3,14.07L12,21.07L16.95,17.22L20.73,21L22,19.73L3.27,1M19.36,10.27L21,9L12,2L9.09,4.27L16.96,12.15L19.36,10.27M19.81,15L21,14.07L19.57,12.64L18.38,13.56L19.81,15Z";
var mdiLayersOffOutline = "M12,4.53L10.83,5.44L9.41,4L12,2L21,9L17.28,11.89L15.85,10.47L17.74,9L12,4.53M21,14.07L20.13,14.75L18.7,13.32L19.37,12.8L21,14.07M3.41,0.86L22.14,19.59L20.73,21L16.95,17.22L12,21.07L3,14.07L4.62,12.81L12,18.54L15.5,15.79L14.1,14.37L12,16L3,9L6.22,6.5L2,2.27L3.41,0.86M12,13.47L12.67,12.94L7.65,7.92L6.26,9L12,13.47Z";
var mdiLayersOutline = "M12,18.54L19.37,12.8L21,14.07L12,21.07L3,14.07L4.62,12.81L12,18.54M12,16L3,9L12,2L21,9L12,16M12,4.53L6.26,9L12,13.47L17.74,9L12,4.53Z";
var mdiLayersPlus = "M17,14H19V17H22V19H19V22H17V19H14V17H17V14M11,16L2,9L11,2L20,9L11,16M11,18.54L12,17.75V18C12,18.71 12.12,19.39 12.35,20L11,21.07L2,14.07L3.62,12.81L11,18.54Z";
var mdiLayersRemove = "M14.46,15.88L15.88,14.46L18,16.59L20.12,14.46L21.54,15.88L19.41,18L21.54,20.12L20.12,21.54L18,19.41L15.88,21.54L14.46,20.12L16.59,18L14.46,15.88M11,16L2,9L11,2L20,9L11,16M11,18.54L12,17.75V18C12,18.71 12.12,19.39 12.35,20L11,21.07L2,14.07L3.62,12.81L11,18.54Z";
var mdiLayersSearch = "M19.31 18.9C19.75 18.21 20 17.38 20 16.5C20 14 18 12 15.5 12S11 14 11 16.5 13 21 15.5 21C16.37 21 17.19 20.75 17.88 20.32L21 23.39L22.39 22L19.31 18.9M15.5 19C14.12 19 13 17.88 13 16.5S14.12 14 15.5 14 18 15.12 18 16.5 16.88 19 15.5 19M9.59 19.2L3 14.07L4.62 12.81L9 16.22C9 16.32 9 16.41 9 16.5C9 17.46 9.22 18.38 9.59 19.2M4.63 10.27L3 9L12 2L21 9L19.36 10.27L18.65 10.82C17.72 10.3 16.64 10 15.5 10C12.79 10 10.46 11.68 9.5 14.05L4.63 10.27Z";
var mdiLayersSearchOutline = "M19.31 18.9C19.75 18.21 20 17.38 20 16.5C20 14 18 12 15.5 12S11 14 11 16.5 13 21 15.5 21C16.37 21 17.19 20.75 17.88 20.32L21 23.39L22.39 22L19.31 18.9M15.5 19C14.12 19 13 17.88 13 16.5S14.12 14 15.5 14 18 15.12 18 16.5 16.88 19 15.5 19M9.59 19.2L3 14.07L4.62 12.81L9 16.22C9 16.32 9 16.41 9 16.5C9 17.46 9.22 18.38 9.59 19.2M9.5 14.04L3 9L12 2L21 9L18.66 10.82C17.96 10.44 17.19 10.18 16.37 10.07L17.74 9L12 4.53L6.26 9L10.53 12.32C10.1 12.84 9.74 13.42 9.5 14.04Z";
var mdiLayersTriple = "M12 0L3 7L4.63 8.27L12 14L19.36 8.27L21 7L12 0M19.37 10.73L12 16.47L4.62 10.74L3 12L12 19L21 12L19.37 10.73M19.37 15.73L12 21.47L4.62 15.74L3 17L12 24L21 17L19.37 15.73Z";
var mdiLayersTripleOutline = "M12 16.54L19.37 10.8L21 12.07L12 19.07L3 12.07L4.62 10.81L12 16.54M12 14L3 7L12 0L21 7L12 14M12 2.53L6.26 7L12 11.47L17.74 7L12 2.53M12 21.47L19.37 15.73L21 17L12 24L3 17L4.62 15.74L12 21.47";
var mdiLeadPencil = "M16.84,2.73C16.45,2.73 16.07,2.88 15.77,3.17L13.65,5.29L18.95,10.6L21.07,8.5C21.67,7.89 21.67,6.94 21.07,6.36L17.9,3.17C17.6,2.88 17.22,2.73 16.84,2.73M12.94,6L4.84,14.11L7.4,14.39L7.58,16.68L9.86,16.85L10.15,19.41L18.25,11.3M4.25,15.04L2.5,21.73L9.2,19.94L8.96,17.78L6.65,17.61L6.47,15.29";
var mdiLeaf = "M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C19,20 22,3 22,3C21,5 14,5.25 9,6.25C4,7.25 2,11.5 2,13.5C2,15.5 3.75,17.25 3.75,17.25C7,8 17,8 17,8Z";
var mdiLeafCircle = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M9.6 17.2C9.38 17.2 9.08 17.12 8.8 17L8.23 18.4L7.09 18L7.25 17.61C8.45 14.59 9.83 11.15 15 10C15 10 9 10 7.05 15.55C7.05 15.55 6 14.5 6 13.3S7.2 9.55 10.2 8.95C11.05 8.78 12 8.65 12.94 8.5C15.3 8.18 17.57 7.86 18 7C18 7 16.2 17.2 9.6 17.2Z";
var mdiLeafCircleOutline = "M8.04 16.34C9.05 13.83 10.19 10.96 14.5 10C14.5 10 9.5 10 7.88 14.63C7.88 14.63 7 13.75 7 12.75S8 9.63 10.5 9.13C11.21 9 12 8.87 12.78 8.76C14.75 8.5 16.64 8.22 17 7.5C17 7.5 15.5 16 10 16C9.82 16 9.57 15.94 9.33 15.85L8.86 17L7.91 16.67L8.04 16.34M12 4C16.41 4 20 7.59 20 12S16.41 20 12 20 4 16.41 4 12 7.59 4 12 4M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2Z";
var mdiLeafMaple = "M21.79,13L16,16L17,18L13,17.25V21H11V17.25L7,18L8,16L2.21,13L3.21,11.27L1.61,8L5.21,7.77L6.21,6L9.63,9.9L8,5H10L12,2L14,5H16L14.37,9.9L17.79,6L18.79,7.73L22.39,7.96L20.79,11.19L21.79,13Z";
var mdiLeafMapleOff = "M18.11 14.91L8.2 5H10L12 2L14 5H16L14.37 9.9L17.79 6L18.79 7.73L22.39 7.96L20.79 11.19L21.79 13L18.11 14.91M2.39 1.73L1.11 3L5.45 7.34L5.21 7.77L1.61 8L3.21 11.27L2.21 13L8 16L7 18L11 17.25V21H13V17.25L15.91 17.8L20.84 22.73L22.11 21.46L2.39 1.73Z";
var mdiLeafOff = "M20.84 22.73L15.14 17.03C13.26 18.79 10.92 20 8 20C7.64 20 7.14 19.87 6.66 19.7L5.71 22L3.82 21.34C5.15 18.03 6.5 14.32 9.66 11.55L8.77 10.66C6.76 12.03 4.86 14.1 3.75 17.25C3.75 17.25 2 15.5 2 13.5C2 12 3.12 9.32 5.72 7.61L1.11 3L2.39 1.73C2.39 1.73 16.39 15.74 16.39 15.74L22.11 21.46L20.84 22.73M17 8C15.35 8.37 13.93 8.88 12.7 9.5L17.5 14.29C20.87 9.35 22 3 22 3C21.03 4.95 14.35 5.24 9.38 6.18L12.15 8.95C14.81 8 17 8 17 8Z";
var mdiLeak = "M6,3H3V6A3,3 0 0,0 6,3M14,3H12A9,9 0 0,1 3,12V14C9.08,14 14,9.07 14,3M10,3H8A5,5 0 0,1 3,8V10A7,7 0 0,0 10,3M10,21H12A9,9 0 0,1 21,12V10A11,11 0 0,0 10,21M18,21H21V18A3,3 0 0,0 18,21M14,21H16A5,5 0 0,1 21,16V14A7,7 0 0,0 14,21Z";
var mdiLeakOff = "M10,3H8C8,3.37 7.96,3.72 7.88,4.06L9.47,5.65C9.81,4.84 10,3.94 10,3M3,4.27L5.84,7.11C5.03,7.67 4.06,8 3,8V10C4.61,10 6.09,9.45 7.27,8.54L8.7,9.97C7.14,11.24 5.16,12 3,12V14C5.71,14 8.19,13 10.11,11.38L12.61,13.88C11,15.81 10,18.29 10,21H12C12,18.84 12.76,16.86 14.03,15.31L15.46,16.74C14.55,17.91 14,19.39 14,21H16C16,19.94 16.33,18.97 16.89,18.16L19.73,21L21,19.73L4.27,3L3,4.27M14,3H12C12,4.5 11.63,5.91 11,7.16L12.44,8.62C13.42,7 14,5.06 14,3M19.94,16.12C20.28,16.04 20.63,16 21,16V14C20.06,14 19.16,14.19 18.34,14.5L19.94,16.12M15.38,11.56L16.84,13C18.09,12.37 19.5,12 21,12V10C18.94,10 17,10.58 15.38,11.56Z";
var mdiLectern = "M17 21V22H7V21H9V11H15V21H17M17.5 6C17.5 4.39 16.41 3.05 14.93 2.64C14.78 2.27 14.43 2 14 2C13.45 2 13 2.45 13 3C13 3.55 13.45 4 14 4C14.31 4 14.58 3.85 14.76 3.63C15.77 3.95 16.5 4.89 16.5 6H4L5 10H19L20 6H17.5Z";
var mdiLedOff = "M12,6A4,4 0 0,0 8,10V16H6V18H9V23H11V18H13V23H15V18H18V16H16V10A4,4 0 0,0 12,6Z";
var mdiLedOn = "M11,0V4H13V0H11M18.3,2.29L15.24,5.29L16.64,6.71L19.7,3.71L18.3,2.29M5.71,2.29L4.29,3.71L7.29,6.71L8.71,5.29L5.71,2.29M12,6A4,4 0 0,0 8,10V16H6V18H9V23H11V18H13V23H15V18H18V16H16V10A4,4 0 0,0 12,6M2,9V11H6V9H2M18,9V11H22V9H18Z";
var mdiLedOutline = "M12,6A4,4 0 0,0 8,10V16H6V18H9V23H11V18H13V23H15V18H18V16H16V10A4,4 0 0,0 12,6M12,8A2,2 0 0,1 14,10V15H10V10A2,2 0 0,1 12,8Z";
var mdiLedStrip = "M2.81,8.46L14.83,20.5L15.54,19.78L16.95,21.19L18.36,19.78L16.95,18.36L18.36,16.95L19.78,18.36L21.19,16.95L19.78,15.54L20.5,14.83L8.46,2.81L2.81,8.46M5.64,8.46L8.46,5.64L17.66,14.83L14.83,17.66L5.64,8.46M7.05,8.46L8.46,9.88L9.88,8.46L8.46,7.05L7.05,8.46M9.17,10.59L10.59,12L12,10.59L10.59,9.17L9.17,10.59M11.29,12.71L12.71,14.12L14.12,12.71L12.71,11.29L11.29,12.71M13.41,14.83L14.83,16.24L16.24,14.83L14.83,13.41L13.41,14.83Z";
var mdiLedStripVariant = "M2.95 3L2 6.91L19.34 11.25L20.29 7.34L2.95 3M6.09 6.89L4.16 6.41L4.64 4.46L6.57 4.94L6.09 6.89M9.94 7.86L8 7.38L8.5 5.42L10.42 5.91L9.94 7.86M13.8 8.82L11.87 8.34L12.35 6.39L14.27 6.87L13.8 8.82M17.65 9.79L15.72 9.31L16.2 7.35L18.13 7.84L17.65 9.79M4.66 12.75L3.71 16.66L21.05 21L22 17.1L4.66 12.75M7.8 16.65L5.88 16.16L6.35 14.21L8.28 14.69L7.8 16.65M11.65 17.61L9.73 17.13L10.2 15.18L12.13 15.66L11.65 17.61M15.5 18.58L13.58 18.09L14.06 16.14L16 16.62L15.5 18.58M19.36 19.54L17.43 19.06L17.91 17.11L19.84 17.59L19.36 19.54M6.25 12.11L11 10.2L17.75 11.89L13 13.8L6.25 12.11Z";
var mdiLedStripVariantOff = "M22.11 21.46L2.39 1.73L1.11 3L2.59 4.5L2 6.91L6.03 7.92L9.08 10.97L6.25 12.11L11.55 13.44L12.94 14.83L4.66 12.75L3.71 16.66L18.46 20.35L20.84 22.73L22.11 21.46M7.8 16.65L5.88 16.16L6.35 14.21L8.28 14.69L7.8 16.65M11.65 17.61L9.73 17.13L10.2 15.18L12.13 15.66L11.65 17.61M15.5 18.58L13.58 18.09L14.06 16.14L14.31 16.2L15.74 17.63L15.5 18.58M19.73 16.53L22 17.1L21.67 18.47L19.73 16.53M15.85 12.65L14.2 11L17.75 11.89L15.85 12.65M10.42 5.91L10.16 6.96L12.82 9.62L19.34 11.25L20.29 7.34L7.29 4.09L8.66 5.46L10.42 5.91M16.2 7.35L18.13 7.84L17.65 9.79L15.72 9.31L16.2 7.35M12.35 6.39L14.27 6.87L13.8 8.82L11.87 8.34L12.35 6.39Z";
var mdiLedVariantOff = "M12,3C10.05,3 8.43,4.4 8.08,6.25L16.82,15H18V13H16V7A4,4 0 0,0 12,3M3.28,4L2,5.27L8,11.27V13H6V15H9V21H11V15H11.73L13,16.27V21H15V18.27L18.73,22L20,20.72L15,15.72L8,8.72L3.28,4Z";
var mdiLedVariantOn = "M12,3A4,4 0 0,0 8,7V13H6V15H9V21H11V15H13V21H15V15H18V13H16V7A4,4 0 0,0 12,3Z";
var mdiLedVariantOutline = "M12,3A4,4 0 0,0 8,7V13H6V15H9V21H11V15H13V21H15V15H18V13H16V7A4,4 0 0,0 12,3M12,5A2,2 0 0,1 14,7V12H10V7A2,2 0 0,1 12,5Z";
var mdiLeek = "M10 2V5.55L12 7.55L14 5.55V2H10M6.34 4L3.87 6.5L15 17.62V12.67L6.34 4M17.66 4L13.06 8.61L15.54 11.09L20.13 6.5L17.66 4M9 13.74V20A2 2 0 0 0 11 22H13A2 2 0 0 0 15 20V19.74L13 17.74V20H11V15.74L9 13.74Z";
var mdiLessThan = "M18.5,4.14L19.5,5.86L8.97,12L19.5,18.14L18.5,19.86L5,12L18.5,4.14Z";
var mdiLessThanOrEqual = "M18.5,2.27L5,10.14L18.5,18L19.5,16.27L8.97,10.14L19.5,4L18.5,2.27M5,20V22H20V20H5Z";
var mdiLibrary = "M12,8A3,3 0 0,0 15,5A3,3 0 0,0 12,2A3,3 0 0,0 9,5A3,3 0 0,0 12,8M12,11.54C9.64,9.35 6.5,8 3,8V19C6.5,19 9.64,20.35 12,22.54C14.36,20.35 17.5,19 21,19V8C17.5,8 14.36,9.35 12,11.54Z";
var mdiLibraryOutline = "M12 14.27L10.64 13C9.09 11.57 7.16 10.57 5 10.18V17.13C7.61 17.47 10 18.47 12 19.95C14 18.47 16.39 17.47 19 17.13V10.18C16.84 10.57 14.91 11.57 13.36 13M19 8.15C19.65 8.05 20.32 8 21 8V19C17.5 19 14.36 20.35 12 22.54C9.64 20.35 6.5 19 3 19V8C3.68 8 4.35 8.05 5 8.15C7.69 8.56 10.1 9.78 12 11.54C13.9 9.78 16.31 8.56 19 8.15M12 6C12.27 6 12.5 5.9 12.71 5.71C12.9 5.5 13 5.27 13 5S12.9 4.5 12.71 4.29C12.5 4.11 12.27 4 12 4S11.5 4.11 11.29 4.29C11.11 4.5 11 4.74 11 5S11.11 5.5 11.29 5.71C11.5 5.9 11.74 6 12 6M14.12 7.12C13.56 7.68 12.8 8 12 8S10.44 7.68 9.88 7.12C9.32 6.56 9 5.8 9 5S9.32 3.44 9.88 2.88C10.44 2.32 11.2 2 12 2S13.56 2.32 14.12 2.88 15 4.2 15 5 14.68 6.56 14.12 7.12Z";
var mdiLibraryShelves = "M19.5,9V1.5H16.5V9H13.5V1.5H10.5V9H7.5V1.5H4.65V9H3V10.5H21V9H19.5M19.5,13.5H16.5V21H13.5V13.5H10.5V21H7.5V13.5H4.65V21H3V22.5H21V21H19.5V13.5Z";
var mdiLicense = "M9 10A3.04 3.04 0 0 1 12 7A3.04 3.04 0 0 1 15 10A3.04 3.04 0 0 1 12 13A3.04 3.04 0 0 1 9 10M12 19L16 20V16.92A7.54 7.54 0 0 1 12 18A7.54 7.54 0 0 1 8 16.92V20M12 4A5.78 5.78 0 0 0 7.76 5.74A5.78 5.78 0 0 0 6 10A5.78 5.78 0 0 0 7.76 14.23A5.78 5.78 0 0 0 12 16A5.78 5.78 0 0 0 16.24 14.23A5.78 5.78 0 0 0 18 10A5.78 5.78 0 0 0 16.24 5.74A5.78 5.78 0 0 0 12 4M20 10A8.04 8.04 0 0 1 19.43 12.8A7.84 7.84 0 0 1 18 15.28V23L12 21L6 23V15.28A7.9 7.9 0 0 1 4 10A7.68 7.68 0 0 1 6.33 4.36A7.73 7.73 0 0 1 12 2A7.73 7.73 0 0 1 17.67 4.36A7.68 7.68 0 0 1 20 10Z";
var mdiLifebuoy = "M19.79,15.41C20.74,13.24 20.74,10.75 19.79,8.59L17.05,9.83C17.65,11.21 17.65,12.78 17.06,14.17L19.79,15.41M15.42,4.21C13.25,3.26 10.76,3.26 8.59,4.21L9.83,6.94C11.22,6.35 12.79,6.35 14.18,6.95L15.42,4.21M4.21,8.58C3.26,10.76 3.26,13.24 4.21,15.42L6.95,14.17C6.35,12.79 6.35,11.21 6.95,9.82L4.21,8.58M8.59,19.79C10.76,20.74 13.25,20.74 15.42,19.78L14.18,17.05C12.8,17.65 11.22,17.65 9.84,17.06L8.59,19.79M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z";
var mdiLightFloodDown = "M8 11H2V9H8C8.55 9 9 9.45 9 10C9 10.55 8.55 11 8 11M14.87 4.35L14.5 5.27L8.18 4.86L6.9 8H8C9.1 8 10 8.9 10 10S9.1 12 8 12H5.27L4.41 14.12L9.21 18.24L8.83 19.16L10.69 19.92L16.72 5.1L14.87 4.35M20.81 6.29L21.57 8.14L19.26 9.1L18.5 7.25L20.81 6.29M18.78 13.57L21.55 14.72L20.79 16.57L18 15.42L18.78 13.57M16.15 21.23L14.3 22L13.34 19.69L15.19 18.93L16.15 21.23Z";
var mdiLightFloodUp = "M8 15H2V13H8C8.55 13 9 13.45 9 14C9 14.55 8.55 15 8 15M16.72 18.9L10.69 4.08L8.83 4.84L9.21 5.76L4.41 9.88L5.27 12H8C9.1 12 10 12.9 10 14S9.1 16 8 16H6.9L8.18 19.14L14.5 18.73L14.87 19.65L16.72 18.9M20.81 17.71L18.5 16.75L19.26 14.9L21.57 15.86L20.81 17.71M18.78 10.43L18 8.58L20.79 7.43L21.55 9.28L18.78 10.43M15.19 5.07L13.34 4.31L14.3 2L16.15 2.77L15.19 5.07Z";
var mdiLightRecessed = "M12 7C6.5 7 2 9.46 2 12.5S6.5 18 12 18 22 15.54 22 12.5 17.5 7 12 7M16.5 10C16.5 10.4 14.9 11.54 12 11.54S7.5 10.4 7.5 10C7.5 9.91 7.65 9.74 7.9 9.55C9.06 9.21 10.44 9 12 9S14.94 9.21 16.1 9.55C16.35 9.74 16.5 9.91 16.5 10M12 16C7.12 16 4 13.93 4 12.5C4 11.81 4.73 11 6.03 10.29C6.3 11.83 8.87 13.04 12 13.04C15.13 13.04 17.7 11.83 17.97 10.29C19.27 11 20 11.81 20 12.5C20 13.93 16.88 16 12 16Z";
var mdiLightSwitch = "M8 6V18H16V6H8M14 10H10V8H14V10M19.4 1.6C19 1.2 18.5 1 18 1H6C5.5 1 5 1.2 4.6 1.6C4.2 2 4 2.5 4 3V21C4 21.5 4.2 22 4.6 22.4C5 22.8 5.5 23 6 23H18C18.5 23 19 22.8 19.4 22.4C19.8 22 20 21.5 20 21V3C20 2.5 19.8 2 19.4 1.6M18 21H6V3H18V21Z";
var mdiLightSwitchOff = "M19.4 1.6C19 1.2 18.5 1 18 1H6C5.5 1 5 1.2 4.6 1.6C4.2 2 4 2.5 4 3V21C4 21.5 4.2 22 4.6 22.4C5 22.8 5.5 23 6 23H18C18.5 23 19 22.8 19.4 22.4C19.8 22 20 21.5 20 21V3C20 2.5 19.8 2 19.4 1.6M18 21H6V3H18V21M8 6V18H16V6H8M15 17H9V7H15V17M10 14H14V16H10V14Z";
var mdiLightbulb = "M12,2A7,7 0 0,0 5,9C5,11.38 6.19,13.47 8,14.74V17A1,1 0 0,0 9,18H15A1,1 0 0,0 16,17V14.74C17.81,13.47 19,11.38 19,9A7,7 0 0,0 12,2M9,21A1,1 0 0,0 10,22H14A1,1 0 0,0 15,21V20H9V21Z";
var mdiLightbulbAlert = "M10 2C6.1 2 3 5.1 3 9C3 11.4 4.2 13.5 6 14.7V17C6 17.6 6.4 18 7 18H13C13.6 18 14 17.6 14 17V14.7C15.8 13.4 17 11.3 17 9C17 5.1 13.9 2 10 2M7 21C7 21.6 7.4 22 8 22H12C12.6 22 13 21.6 13 21V20H7V21M19 12V7H21V13H19M19 17V15H21V17H19Z";
var mdiLightbulbAlertOutline = "M10 2C13.9 2 17 5.1 17 9C17 11.4 15.8 13.5 14 14.7V17C14 17.6 13.6 18 13 18H7C6.4 18 6 17.6 6 17V14.7C4.2 13.5 3 11.4 3 9C3 5.1 6.1 2 10 2M7 21V20H13V21C13 21.6 12.6 22 12 22H8C7.4 22 7 21.6 7 21M10 4C7.2 4 5 6.2 5 9C5 11.1 6.2 12.8 8 13.6V16H12V13.6C13.8 12.8 15 11.1 15 9C15 6.2 12.8 4 10 4M19 12V7H21V13H19M19 17V15H21V17H19Z";
var mdiLightbulbAuto = "M9 2C5.13 2 2 5.13 2 9C2 11.38 3.19 13.47 5 14.74V17C5 17.55 5.45 18 6 18H12C12.55 18 13 17.55 13 17V14.74C14.81 13.47 16 11.38 16 9C16 5.13 12.87 2 9 2M6 21C6 21.55 6.45 22 7 22H11C11.55 22 12 21.55 12 21V20H6V21M19 13H17L13.8 22H15.7L16.4 20H19.6L20.3 22H22.2L19 13M16.85 18.65L18 15L19.15 18.65H16.85Z";
var mdiLightbulbAutoOutline = "M9 2C12.87 2 16 5.13 16 9C16 11.38 14.81 13.47 13 14.74V17C13 17.55 12.55 18 12 18H6C5.45 18 5 17.55 5 17V14.74C3.19 13.47 2 11.38 2 9C2 5.13 5.13 2 9 2M6 21V20H12V21C12 21.55 11.55 22 11 22H7C6.45 22 6 21.55 6 21M9 4C6.24 4 4 6.24 4 9C4 11.05 5.23 12.81 7 13.58V16H11V13.58C12.77 12.81 14 11.05 14 9C14 6.24 11.76 4 9 4M19 13H17L13.8 22H15.7L16.4 20H19.6L20.3 22H22.2L19 13M16.85 18.65L18 15L19.15 18.65H16.85Z";
var mdiLightbulbCfl = "M10.5 2C11.88 2 13 3.12 13 4.5V14H14V4.47C14 3.56 13.63 2.7 13 2.05C13.17 2 13.33 2 13.5 2C14.88 2 16 3.12 16 4.5V14H17V17C17 17.55 16.55 18 16 18H8C7.45 18 7 17.55 7 17V14H8V4.5C8 3.12 9.12 2 10.5 2M10.5 4C10.22 4 10 4.22 10 4.5V14H11V4.5C11 4.22 10.78 4 10.5 4M9 20H15V21C15 21.55 14.55 22 14 22H10C9.45 22 9 21.55 9 21V20Z";
var mdiLightbulbCflOff = "M14 4.47C14 3.56 13.63 2.7 13 2.05C13.17 2 13.33 2 13.5 2C14.88 2 16 3.12 16 4.5V14H17V15.18L14 12.18V4.5L14 4.47M10 4.5C10 4.22 10.22 4 10.5 4S11 4.22 11 4.5V9.18L13 11.18V4.5C13 3.12 11.88 2 10.5 2S8 3.12 8 4.5V6.18L10 8.18V4.5M9 21C9 21.55 9.45 22 10 22H14C14.55 22 15 21.55 15 21V20H9V21M20 20.72L18.73 22L14.73 18H8C7.45 18 7 17.55 7 17V14H8V11.27L2 5.27L3.28 4L20 20.72Z";
var mdiLightbulbCflSpiral = "M11 2C10.84 2 10.69 2.03 10.55 2.1L8.55 3.1C7.56 3.66 8 5 9 5C9.16 5 9.32 4.95 9.45 4.9L11.45 3.9C12.43 3.36 12 2 11 2M15 4C14.83 4 14.69 4.03 14.55 4.1L8.55 7.1C7.56 7.68 8 9 9 9C9.18 9 9.32 8.95 9.45 8.9L15.45 5.9C16.41 5.43 16 4 15 4M15 8C14.84 8 14.69 8.03 14.55 8.1L8.7 11.03C8.2 11.25 8 11.6 8 12V14H7V17C7 17.55 7.44 18 8 18H16C16.55 18 17 17.55 17 17V14H16V13C16 12.44 15.55 12 15 12C14.45 12 14 12.45 14 13V14H10V12.62L15.45 9.9C16.42 9.34 16 8 15 8M9 20V21C9 21.57 9.46 22 10 22H14C14.56 22 15 21.55 15 21V20";
var mdiLightbulbCflSpiralOff = "M15.45 9.9L13.88 10.68L12.38 9.18L14.55 8.1C14.69 8.03 14.84 8 15 8C16 8 16.42 9.34 15.45 9.9M11.22 8L15.45 5.9C16.41 5.43 16 4 15 4C14.83 4 14.69 4.03 14.55 4.1L9.72 6.5L11.22 8M20.84 22.73L16.09 18H8C7.44 18 7 17.55 7 17V14H8V12C8 11.6 8.2 11.25 8.7 11.03L9 10.88L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M12.11 14L10.5 12.38L10 12.62V14H12.11M9 21C9 21.57 9.46 22 10 22H14C14.56 22 15 21.55 15 21V20H9V21M9 5C9.16 5 9.32 4.95 9.45 4.9L11.45 3.9C12.43 3.36 12 2 11 2C10.84 2 10.69 2.03 10.55 2.1L8.55 3.1C7.56 3.66 8 5 9 5Z";
var mdiLightbulbFluorescentTube = "M7.05 2.81L6.5 3.34L5.11 1.92L3.87 3.16L5.28 4.58L4.58 5.28L3.16 3.87L1.92 5.11L3.34 6.5L2.81 7.05L16.95 21.19L17.5 20.66L18.89 22.08L20.13 20.84L18.72 19.43L19.42 18.72L20.84 20.13L22.08 18.9L20.66 17.5L21.19 16.95L7.05 2.81Z";
var mdiLightbulbFluorescentTubeOutline = "M7.05 2.81L6.5 3.34L5.11 1.92L3.87 3.16L5.28 4.58L4.58 5.28L3.16 3.87L1.92 5.11L3.34 6.5L2.81 7.05L4.22 8.46L15.54 19.78L16.95 21.19L17.5 20.66L18.89 22.08L20.13 20.84L18.72 19.43L19.43 18.72L20.84 20.13L22.08 18.89L20.66 17.5L21.19 16.95L19.78 15.54L8.46 4.22M7.05 5.64L18.36 16.95L16.95 18.36L5.64 7.05Z";
var mdiLightbulbGroup = "M15 14V16A1 1 0 0 1 14 17H10A1 1 0 0 1 9 16V14A5 5 0 1 1 15 14M14 18H10V19A1 1 0 0 0 11 20H13A1 1 0 0 0 14 19M7 19V18H5V19A1 1 0 0 0 6 20H7.17A2.93 2.93 0 0 1 7 19M5 10A6.79 6.79 0 0 1 5.68 7A4 4 0 0 0 4 14.45V16A1 1 0 0 0 5 17H7V14.88A6.92 6.92 0 0 1 5 10M17 18V19A2.93 2.93 0 0 1 16.83 20H18A1 1 0 0 0 19 19V18M18.32 7A6.79 6.79 0 0 1 19 10A6.92 6.92 0 0 1 17 14.88V17H19A1 1 0 0 0 20 16V14.45A4 4 0 0 0 18.32 7Z";
var mdiLightbulbGroupOff = "M20.84 22.73L18.09 20C18.06 20 18.03 20 18 20H16.83C16.94 19.68 17 19.34 17 19V18.89L14.75 16.64C14.57 16.86 14.31 17 14 17H10C9.45 17 9 16.55 9 16V14C7.4 12.8 6.74 10.84 7.12 9L5.5 7.4C5.18 8.23 5 9.11 5 10C5 11.83 5.72 13.58 7 14.88V17H5C4.45 17 4 16.55 4 16V14.45C2.86 13.79 2.12 12.62 2 11.31C1.85 9.27 3.25 7.5 5.2 7.09L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M15 6C13.22 4.67 10.86 4.72 9.13 5.93L16.08 12.88C17.63 10.67 17.17 7.63 15 6M19.79 16.59C19.91 16.42 20 16.22 20 16V14.45C21.91 13.34 22.57 10.9 21.46 9C20.8 7.85 19.63 7.11 18.32 7C18.77 7.94 19 8.96 19 10C19 11.57 18.47 13.09 17.5 14.31L19.79 16.59M10 19C10 19.55 10.45 20 11 20H13C13.55 20 14 19.55 14 19V18H10V19M7 18H5V19C5 19.55 5.45 20 6 20H7.17C7.06 19.68 7 19.34 7 19V18Z";
var mdiLightbulbGroupOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L5.2 7.09C3.25 7.5 1.85 9.27 2 11.31C2.12 12.62 2.86 13.79 4 14.45V16C4 16.55 4.45 17 5 17H7V14.88C5.72 13.58 5 11.83 5 10C5 9.11 5.18 8.23 5.5 7.4L7.12 9C6.74 10.84 7.4 12.8 9 14V16C9 16.55 9.45 17 10 17H14C14.31 17 14.57 16.86 14.75 16.64L17 18.89V19C17 19.34 16.94 19.68 16.83 20H18C18.03 20 18.06 20 18.09 20L20.84 22.73L22.11 21.46M9.23 11.12L10.87 12.76C10.11 12.46 9.53 11.86 9.23 11.12M13 15H11V12.89L13 14.89V15M10.57 7.37L9.13 5.93C10.86 4.72 13.22 4.67 15 6C16.26 6.94 17 8.43 17 10C17 11.05 16.67 12.05 16.08 12.88L14.63 11.43C14.86 11 15 10.5 15 10C15 8.34 13.67 7 12 7C11.5 7 11 7.14 10.57 7.37M17.5 14.31C18.47 13.09 19 11.57 19 10C19 8.96 18.77 7.94 18.32 7C19.63 7.11 20.8 7.85 21.46 9C22.57 10.9 21.91 13.34 20 14.45V16C20 16.22 19.91 16.42 19.79 16.59L17.5 14.31M10 18H14V19C14 19.55 13.55 20 13 20H11C10.45 20 10 19.55 10 19V18M7 19C7 19.34 7.06 19.68 7.17 20H6C5.45 20 5 19.55 5 19V18H7V19Z";
var mdiLightbulbGroupOutline = "M7 19A2.93 2.93 0 0 0 7.17 20H6A1 1 0 0 1 5 19V18H7M10 19A1 1 0 0 0 11 20H13A1 1 0 0 0 14 19V18H10M4 16A1 1 0 0 0 5 17H7V14.88A6.92 6.92 0 0 1 5 10A6.79 6.79 0 0 1 5.68 7A4 4 0 0 0 4 14.45M17 19A2.93 2.93 0 0 1 16.83 20H18A1 1 0 0 0 19 19V18H17M17 10A5 5 0 0 1 15 14V16A1 1 0 0 1 14 17H10A1 1 0 0 1 9 16V14A5 5 0 1 1 17 10M15 10A3 3 0 1 0 11 12.82V15H13V12.82A3 3 0 0 0 15 10M18.32 7A6.79 6.79 0 0 1 19 10A6.92 6.92 0 0 1 17 14.88V17H19A1 1 0 0 0 20 16V14.45A4 4 0 0 0 18.32 7Z";
var mdiLightbulbMultiple = "M17 16V18C17 18.55 16.53 19 16 19H12C11.42 19 11 18.55 11 18V16C8.77 14.34 8.32 11.21 10 9S14.77 6.34 17 8 19.63 12.79 18 15C17.69 15.38 17.35 15.72 17 16M16 20H12V21C12 21.55 12.42 22 13 22H15C15.53 22 16 21.55 16 21M7.66 15H7V16C7 16.55 7.42 17 8 17H9V16.88C8.44 16.33 8 15.7 7.66 15M13.58 5C12.46 2.47 9.5 1.33 7 2.45S3.31 6.5 4.43 9.04C4.77 9.81 5.3 10.5 6 11V13C6 13.55 6.42 14 7 14H7.28C7.07 13.35 6.97 12.68 7 12C6.97 8.29 9.87 5.21 13.58 5Z";
var mdiLightbulbMultipleOff = "M20.84 22.73L16.74 18.63C16.55 18.85 16.29 19 16 19H12C11.42 19 11 18.55 11 18V16C9.37 14.8 8.71 12.82 9.1 11L7.5 9.39C7.17 10.2 6.97 11.08 7 12C6.97 12.68 7.07 13.35 7.28 14H7C6.42 14 6 13.55 6 13V11C5.3 10.5 4.77 9.81 4.43 9.04C4 8.05 3.91 7 4.12 6L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M13.58 5C12.46 2.47 9.5 1.33 7 2.45C6.68 2.58 6.39 2.75 6.13 2.93L9.67 6.47C10.76 5.63 12.1 5.08 13.58 5M18.06 14.86C19.6 12.66 19.14 9.62 17 8C15.2 6.67 12.84 6.72 11.12 7.92L18.06 14.86M12 21C12 21.55 12.42 22 13 22H15C15.53 22 16 21.55 16 21V20H12V21M7 15V16C7 16.55 7.42 17 8 17H9V16.88C8.43 16.33 8 15.7 7.66 15H7Z";
var mdiLightbulbMultipleOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L4.14 6.03C3.93 7 4 8.05 4.45 9.04C4.79 9.81 5.33 10.5 6 11V13C6 13.55 6.45 14 7 14H7.3C7.1 13.35 7 12.68 7 12C7 11.08 7.19 10.21 7.5 9.41L9.11 11C9.05 11.33 9 11.66 9 12C9 13.57 9.74 15.06 11 16V18C11 18.55 11.45 19 12 19H16C16.31 19 16.57 18.86 16.75 18.64L20.84 22.73L22.11 21.46M11.23 13.12L12.87 14.76C12.1 14.44 11.53 13.85 11.23 13.12M15 17H13V14.89L15 16.89V17M9.69 6.5L6.14 2.94C6.41 2.75 6.7 2.58 7 2.44C9.53 1.33 12.5 2.47 13.6 5C12.12 5.09 10.77 5.63 9.69 6.5M11.12 7.92C11.94 7.35 12.93 7 14 7C15.57 7 17.06 7.74 18 9C19.33 10.78 19.28 13.14 18.07 14.87L16.62 13.42C16.7 13.28 16.77 13.14 16.83 13C17.38 11.43 16.56 9.72 15 9.16C14.16 8.87 13.29 8.97 12.57 9.37L11.12 7.92M7.68 15C8 15.7 8.46 16.33 9 16.88V17H8C7.45 17 7 16.55 7 16V15H7.68M12 20H16V21C16 21.55 15.55 22 15 22H13C12.45 22 12 21.55 12 21V20Z";
var mdiLightbulbMultipleOutline = "M12 21C12 21.55 12.45 22 13 22H15C15.55 22 16 21.55 16 21V20H12M14 7C11.24 7 9 9.24 9 12C9 13.57 9.74 15.06 11 16V18C11 18.55 11.45 19 12 19H16C16.55 19 17 18.55 17 18V16C19.21 14.34 19.66 11.21 18 9C17.06 7.74 15.57 7 14 7M15 14.82V17H13V14.82C11.44 14.27 10.62 12.55 11.17 11C11.72 9.43 13.44 8.61 15 9.16C16.56 9.72 17.38 11.43 16.83 13C16.53 13.85 15.85 14.5 15 14.82M7.68 15H7V16C7 16.55 7.45 17 8 17H9V16.88C8.46 16.33 8 15.7 7.68 15M13.6 5C12.5 2.47 9.53 1.33 7 2.45S3.34 6.5 4.45 9.04C4.79 9.81 5.33 10.5 6 11V13C6 13.55 6.45 14 7 14H7.3C7.1 13.35 7 12.68 7 12C7 8.29 9.89 5.21 13.6 5Z";
var mdiLightbulbNight = "M6 21C6 21.55 6.45 22 7 22H11C11.55 22 12 21.55 12 21V20H6V21M13 16.32V17C13 17.55 12.55 18 12 18H6C5.45 18 5 17.55 5 17V14.74C3.19 13.47 2 11.38 2 9C2 5.13 5.13 2 9 2C10.65 2 12.16 2.57 13.35 3.5C10.8 4.57 9 7.07 9 10C9 12.79 10.64 15.19 13 16.32M20.92 9.94L19.5 9.03L18.1 10L18.5 8.35L17.17 7.32L18.85 7.21L19.41 5.6L20.04 7.18L21.72 7.22L20.42 8.3L20.92 9.94M19.39 13C17.5 15.27 14.03 15.19 12.22 12.95C10 10.13 11.56 6 15 5.34C15.34 5.29 15.64 5.63 15.5 5.97C15.05 7.25 15.12 8.71 15.85 9.97C16.58 11.24 17.79 12.03 19.12 12.25C19.47 12.3 19.62 12.74 19.39 13Z";
var mdiLightbulbNightOutline = "M6 20H12V21C12 21.55 11.55 22 11 22H7C6.45 22 6 21.55 6 21V20M11 14.89V16H7V13.58C5.23 12.81 4 11.05 4 9C4 6.24 6.24 4 9 4C9.9 4 10.73 4.26 11.46 4.67C12 4.2 12.66 3.81 13.35 3.5C12.16 2.57 10.65 2 9 2C5.13 2 2 5.13 2 9C2 11.38 3.19 13.47 5 14.74V17C5 17.55 5.45 18 6 18H12C12.55 18 13 17.55 13 17V16.32C12.25 15.96 11.57 15.5 11 14.89M20.92 9.94L20.42 8.3L21.72 7.22L20.04 7.18L19.41 5.6L18.85 7.21L17.17 7.32L18.5 8.35L18.1 10L19.5 9.03L20.92 9.94M19.12 12.25C17.79 12.03 16.58 11.24 15.85 9.97C15.12 8.71 15.05 7.25 15.5 5.97C15.64 5.63 15.34 5.29 15 5.34C11.56 6 10 10.13 12.22 12.95C14.03 15.19 17.5 15.27 19.39 13C19.62 12.74 19.47 12.3 19.12 12.25Z";
var mdiLightbulbOff = "M12,2C9.76,2 7.78,3.05 6.5,4.68L16.31,14.5C17.94,13.21 19,11.24 19,9A7,7 0 0,0 12,2M3.28,4L2,5.27L5.04,8.3C5,8.53 5,8.76 5,9C5,11.38 6.19,13.47 8,14.74V17A1,1 0 0,0 9,18H14.73L18.73,22L20,20.72L3.28,4M9,20V21A1,1 0 0,0 10,22H14A1,1 0 0,0 15,21V20H9Z";
var mdiLightbulbOffOutline = "M12,2C9.76,2 7.78,3.05 6.5,4.68L7.93,6.11C8.84,4.84 10.32,4 12,4A5,5 0 0,1 17,9C17,10.68 16.16,12.16 14.89,13.06L16.31,14.5C17.94,13.21 19,11.24 19,9A7,7 0 0,0 12,2M3.28,4L2,5.27L5.04,8.3C5,8.53 5,8.76 5,9C5,11.38 6.19,13.47 8,14.74V17A1,1 0 0,0 9,18H14.73L18.73,22L20,20.72L3.28,4M7.23,10.5L12.73,16H10V13.58C8.68,13 7.66,11.88 7.23,10.5M9,20V21A1,1 0 0,0 10,22H14A1,1 0 0,0 15,21V20H9Z";
var mdiLightbulbOn = "M12,6A6,6 0 0,1 18,12C18,14.22 16.79,16.16 15,17.2V19A1,1 0 0,1 14,20H10A1,1 0 0,1 9,19V17.2C7.21,16.16 6,14.22 6,12A6,6 0 0,1 12,6M14,21V22A1,1 0 0,1 13,23H11A1,1 0 0,1 10,22V21H14M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63Z";
var mdiLightbulbOn10 = "M1 11H4V13H1V11M19.1 3.5L17 5.6L18.4 7L20.5 4.9L19.1 3.5M11 1H13V4H11V1M4.9 3.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5M10 22C10 22.6 10.4 23 11 23H13C13.6 23 14 22.6 14 22V21H10V22M12 6C8.7 6 6 8.7 6 12C6 14.2 7.2 16.2 9 17.2V19C9 19.6 9.4 20 10 20H14C14.6 20 15 19.6 15 19V17.2C16.8 16.2 18 14.2 18 12C18 8.7 15.3 6 12 6M13 15.9V17H11V15.9C9.3 15.5 8 13.9 8 12C8 9.8 9.8 8 12 8S16 9.8 16 12C16 13.9 14.7 15.4 13 15.9M20 11H23V13H20V11Z";
var mdiLightbulbOn20 = "M1 11H4V13H1V11M4.9 3.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5M13 1H11V4H13V1M20 11V13H23V11H20M10 22C10 22.6 10.4 23 11 23H13C13.6 23 14 22.6 14 22V21H10V22M19.1 3.5L17 5.6L18.4 7L20.5 4.9L19.1 3.5M18 12C18 14.2 16.8 16.2 15 17.2V19C15 19.6 14.6 20 14 20H10C9.4 20 9 19.6 9 19V17.2C7.2 16.2 6 14.2 6 12C6 8.7 8.7 6 12 6S18 8.7 18 12M16 12C16 9.79 14.21 8 12 8S8 9.79 8 12 9.79 16 12 16 16 14.21 16 12Z";
var mdiLightbulbOn30 = "M7 5.6L5.6 7L3.5 4.9L4.9 3.5L7 5.6M1 13H4V11H1V13M13 1H11V4H13V1M18 12C18 14.2 16.8 16.2 15 17.2V19C15 19.6 14.6 20 14 20H10C9.4 20 9 19.6 9 19V17.2C7.2 16.2 6 14.2 6 12C6 8.7 8.7 6 12 6S18 8.7 18 12M16 12C16 9.79 14.21 8 12 8S8 9.79 8 12C8 13.2 8.54 14.27 9.38 15H14.62C15.46 14.27 16 13.2 16 12M10 22C10 22.6 10.4 23 11 23H13C13.6 23 14 22.6 14 22V21H10V22M20 11V13H23V11H20M19.1 3.5L17 5.6L18.4 7L20.5 4.9L19.1 3.5Z";
var mdiLightbulbOn40 = "M1 11H4V13H1V11M13 1H11V4H13V1M4.9 3.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5M19.1 3.5L17 5.6L18.4 7L20.5 4.9L19.1 3.5M10 22C10 22.6 10.4 23 11 23H13C13.6 23 14 22.6 14 22V21H10V22M20 11V13H23V11H20M18 12C18 14.2 16.8 16.2 15 17.2V19C15 19.6 14.6 20 14 20H10C9.4 20 9 19.6 9 19V17.2C7.2 16.2 6 14.2 6 12C6 8.7 8.7 6 12 6S18 8.7 18 12M16 12C16 9.79 14.21 8 12 8S8 9.79 8 12C8 12.74 8.22 13.41 8.57 14H15.43C15.78 13.41 16 12.74 16 12Z";
var mdiLightbulbOn50 = "M1 11H4V13H1V11M10 22C10 22.6 10.4 23 11 23H13C13.6 23 14 22.6 14 22V21H10V22M13 1H11V4H13V1M4.9 3.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5M20 11V13H23V11H20M19.1 3.5L17 5.6L18.4 7L20.5 4.9L19.1 3.5M18 12C18 14.2 16.8 16.2 15 17.2V19C15 19.6 14.6 20 14 20H10C9.4 20 9 19.6 9 19V17.2C7.2 16.2 6 14.2 6 12C6 8.7 8.7 6 12 6S18 8.7 18 12M8 12C8 12.35 8.05 12.68 8.14 13H15.86C15.95 12.68 16 12.35 16 12C16 9.79 14.21 8 12 8S8 9.79 8 12Z";
var mdiLightbulbOn60 = "M10 21H14V22C14 22.6 13.6 23 13 23H11C10.4 23 10 22.6 10 22V21M1 13H4V11H1V13M4.9 3.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5M13 1H11V4H13V1M20 11V13H23V11H20M18 12C18 14.2 16.8 16.2 15 17.2V19C15 19.6 14.6 20 14 20H10C9.4 20 9 19.6 9 19V17.2C7.2 16.2 6 14.2 6 12C6 8.7 8.7 6 12 6S18 8.7 18 12M8 12H16C16 9.79 14.21 8 12 8S8 9.79 8 12M19.1 3.5L17 5.6L18.4 7L20.5 4.9L19.1 3.5Z";
var mdiLightbulbOn70 = "M7 5.6L5.6 7L3.5 4.9L4.9 3.5L7 5.6M13 1H11V4H13V1M1 13H4V11H1V13M10 22C10 22.6 10.4 23 11 23H13C13.6 23 14 22.6 14 22V21H10V22M19.1 3.5L17 5.6L18.4 7L20.5 4.9L19.1 3.5M18 12C18 14.2 16.8 16.2 15 17.2V19C15 19.6 14.6 20 14 20H10C9.4 20 9 19.6 9 19V17.2C7.2 16.2 6 14.2 6 12C6 8.7 8.7 6 12 6S18 8.7 18 12M8.14 11H15.86C15.41 9.28 13.86 8 12 8S8.59 9.28 8.14 11M20 11V13H23V11H20Z";
var mdiLightbulbOn80 = "M7 5.6L5.6 7L3.5 4.9L4.9 3.5L7 5.6M1 13H4V11H1V13M13 1H11V4H13V1M10 22C10 22.6 10.4 23 11 23H13C13.6 23 14 22.6 14 22V21H10V22M20 11V13H23V11H20M19.1 3.5L17 5.6L18.4 7L20.5 4.9L19.1 3.5M18 12C18 14.2 16.8 16.2 15 17.2V19C15 19.6 14.6 20 14 20H10C9.4 20 9 19.6 9 19V17.2C7.2 16.2 6 14.2 6 12C6 8.7 8.7 6 12 6S18 8.7 18 12M8.56 10H15.44C14.75 8.81 13.5 8 12 8S9.25 8.81 8.56 10Z";
var mdiLightbulbOn90 = "M7 5.6L5.6 7L3.5 4.9L4.9 3.5L7 5.6M10 22C10 22.6 10.4 23 11 23H13C13.6 23 14 22.6 14 22V21H10V22M1 13H4V11H1V13M13 1H11V4H13V1M20 11V13H23V11H20M19.1 3.5L17 5.6L18.4 7L20.5 4.9L19.1 3.5M18 12C18 14.2 16.8 16.2 15 17.2V19C15 19.6 14.6 20 14 20H10C9.4 20 9 19.6 9 19V17.2C7.2 16.2 6 14.2 6 12C6 8.7 8.7 6 12 6S18 8.7 18 12M12 8C11 8 10.09 8.38 9.39 9H14.61C13.91 8.38 13 8 12 8Z";
var mdiLightbulbOnOutline = "M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63M12,6A6,6 0 0,1 18,12C18,14.22 16.79,16.16 15,17.2V19A1,1 0 0,1 14,20H10A1,1 0 0,1 9,19V17.2C7.21,16.16 6,14.22 6,12A6,6 0 0,1 12,6M14,21V22A1,1 0 0,1 13,23H11A1,1 0 0,1 10,22V21H14M11,18H13V15.87C14.73,15.43 16,13.86 16,12A4,4 0 0,0 12,8A4,4 0 0,0 8,12C8,13.86 9.27,15.43 11,15.87V18Z";
var mdiLightbulbOutline = "M12,2A7,7 0 0,1 19,9C19,11.38 17.81,13.47 16,14.74V17A1,1 0 0,1 15,18H9A1,1 0 0,1 8,17V14.74C6.19,13.47 5,11.38 5,9A7,7 0 0,1 12,2M9,21V20H15V21A1,1 0 0,1 14,22H10A1,1 0 0,1 9,21M12,4A5,5 0 0,0 7,9C7,11.05 8.23,12.81 10,13.58V16H14V13.58C15.77,12.81 17,11.05 17,9A5,5 0 0,0 12,4Z";
var mdiLightbulbQuestion = "M8 2C4.1 2 1 5.1 1 9C1 11.4 2.2 13.5 4 14.7V17C4 17.6 4.4 18 5 18H11C11.6 18 12 17.6 12 17V14.7C13.8 13.4 15 11.3 15 9C15 5.1 11.9 2 8 2M5 21C5 21.6 5.4 22 6 22H10C10.6 22 11 21.6 11 21V20H5V21M20.5 14.5V16H19V14.5H20.5M18.5 9.5H17V9C17 7.3 18.3 6 20 6S23 7.3 23 9C23 10 22.5 10.9 21.7 11.4L21.4 11.6C20.8 12 20.5 12.6 20.5 13.3V13.5H19V13.3C19 12.1 19.6 11 20.6 10.4L20.9 10.2C21.3 9.9 21.5 9.5 21.5 9C21.5 8.2 20.8 7.5 20 7.5S18.5 8.2 18.5 9V9.5Z";
var mdiLightbulbQuestionOutline = "M8 2C11.9 2 15 5.1 15 9C15 11.4 13.8 13.5 12 14.7V17C12 17.6 11.6 18 11 18H5C4.4 18 4 17.6 4 17V14.7C2.2 13.5 1 11.4 1 9C1 5.1 4.1 2 8 2M5 21V20H11V21C11 21.6 10.6 22 10 22H6C5.4 22 5 21.6 5 21M8 4C5.2 4 3 6.2 3 9C3 11.1 4.2 12.8 6 13.6V16H10V13.6C11.8 12.8 13 11.1 13 9C13 6.2 10.8 4 8 4M20.5 14.5V16H19V14.5H20.5M18.5 9.5H17V9C17 7.3 18.3 6 20 6S23 7.3 23 9C23 10 22.5 10.9 21.7 11.4L21.4 11.6C20.8 12 20.5 12.6 20.5 13.3V13.5H19V13.3C19 12.1 19.6 11 20.6 10.4L20.9 10.2C21.3 9.9 21.5 9.5 21.5 9C21.5 8.2 20.8 7.5 20 7.5S18.5 8.2 18.5 9V9.5Z";
var mdiLightbulbSpot = "M9 19H11V22H9L9 19M13 22H15V19H13V22M2 2V4H22V2H2M9 14L9 17H15V14C17.5 12.57 20 11 20 6H4C4 11 6.5 12.57 9 14Z";
var mdiLightbulbSpotOff = "M20.84 22.73L15.11 17H9L9 14C6.5 12.57 4 11 4 6V5.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M22 4V2H5.2L7.2 4H22M20 6H9.2L16.37 13.17C18.33 11.87 20 10.07 20 6M13 22H15V19H13V22M9 22H11V19H9L9 22Z";
var mdiLightbulbVariant = "M9 20H15V21C15 21.55 14.55 22 14 22H10C9.45 22 9 21.55 9 21V20M19 9C19 11.38 17.81 13.47 16 14.74V17C16 17.55 15.55 18 15 18H9C8.45 18 8 17.55 8 17V14.74C6.19 13.47 5 11.38 5 9C5 5.13 8.13 2 12 2S19 5.13 19 9M14.71 8.29C14.32 7.9 13.68 7.9 13.29 8.29L12 9.59L10.71 8.29C10.32 7.9 9.68 7.9 9.29 8.29C8.9 8.68 8.9 9.32 9.29 9.71L11 11.41V16H13V11.41L14.71 9.71C15.1 9.32 15.1 8.68 14.71 8.29Z";
var mdiLightbulbVariantOutline = "M12 2C8.13 2 5 5.13 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.13 15.87 2 12 2M14 13.58V16H13V11.41L14.71 9.71C15.1 9.32 15.1 8.68 14.71 8.29C14.32 7.9 13.68 7.9 13.29 8.29L12 9.59L10.71 8.29C10.32 7.9 9.68 7.9 9.29 8.29C8.9 8.68 8.9 9.32 9.29 9.71L11 11.41V16H10V13.58C8.23 12.81 7 11.05 7 9C7 6.24 9.24 4 12 4S17 6.24 17 9C17 11.05 15.77 12.81 14 13.58M9 20H15V21C15 21.55 14.55 22 14 22H10C9.45 22 9 21.55 9 21V20Z";
var mdiLighthouse = "M8,10V8H9V4H8V3L12,1L16,3V4H15V8H16V10H14.74L8.44,13.64L9,10H8M13,8V4H11V8H13M7,23L7.04,22.76L16.15,17.5L16.67,20.88L13,23H7M8.05,16.17L15.31,12L15.83,15.37L7.43,20.22L8.05,16.17Z";
var mdiLighthouseOn = "M1,10V2L10,5V7L1,10M8,10V8H13V4H8V3L12,1L16,3V4H15V8H16V10H14.74L8.44,13.64L9,10H8M7,23L7.04,22.76L16.15,17.5L16.67,20.88L13,23H7M8.05,16.17L15.31,12L15.83,15.37L7.43,20.22L8.05,16.17Z";
var mdiLightningBolt = "M11 15H6L13 1V9H18L11 23V15Z";
var mdiLightningBoltCircle = "M11.5,20L16.36,10.27H13V4L8,13.73H11.5V20M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.75 21,17.1 19.05,19.05C17.1,21 14.75,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z";
var mdiLightningBoltOutline = "M11 9.47V11H14.76L13 14.53V13H9.24L11 9.47M13 1L6 15H11V23L18 9H13V1Z";
var mdiLineScan = "M17 22V20H20V17H22V20.5C22 20.9 21.8 21.2 21.5 21.5C21.2 21.8 20.8 22 20.5 22H17M7 22H3.5C3.1 22 2.8 21.8 2.5 21.5C2.2 21.2 2 20.8 2 20.5V17H4V20H7V22M17 2H20.5C20.9 2 21.2 2.2 21.5 2.5C21.8 2.8 22 3.1 22 3.5V7H20V4H17V2M7 2V4H4V7H2V3.5C2 3.1 2.2 2.8 2.5 2.5S3.1 2 3.5 2H7M19 11H5V13H19V11Z";
var mdiLingerie = "M22 7H20V2H18V4.34L12 6.91L6 4.34V2H4V7H2V9H4.05C4.3 11.25 6.19 13 8.5 13C9.92 13 11.18 12.33 12 11.3C12.83 12.33 14.08 13 15.5 13C17.81 13 19.7 11.25 19.95 9H22V7M8.5 11C7.12 11 6 9.88 6 8.5V6.5L11 8.65C10.9 9.96 9.83 11 8.5 11M18 8.5C18 9.88 16.88 11 15.5 11C14.17 11 13.1 9.96 13 8.65L18 6.5V8.5M2 15V17H3C5.97 17 8.43 19.17 8.91 22H15.09C15.57 19.17 18.03 17 21 17H22V15H2M13.59 20H10.41C9.94 18.84 9.21 17.82 8.29 17H15.71C14.79 17.82 14.06 18.84 13.59 20Z";
var mdiLink = "M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z";
var mdiLinkBox = "M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M11,16H10C8.39,16 6,14.94 6,12C6,9.07 8.39,8 10,8H11V10H10C9.54,10 8,10.17 8,12C8,13.9 9.67,14 10,14H11V16M15,11V13H9V11H15M14,16H13V14H14C14.46,14 16,13.83 16,12C16,10.1 14.33,10 14,10H13V8H14C15.61,8 18,9.07 18,12C18,14.94 15.61,16 14,16Z";
var mdiLinkBoxOutline = "M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M11,16H10C8.39,16 6,14.94 6,12C6,9.07 8.39,8 10,8H11V10H10C9.54,10 8,10.17 8,12C8,13.9 9.67,14 10,14H11V16M14,16H13V14H14C14.46,14 16,13.83 16,12C16,10.1 14.33,10 14,10H13V8H14C15.61,8 18,9.07 18,12C18,14.94 15.61,16 14,16M15,13H9V11H15V13Z";
var mdiLinkBoxVariant = "M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M13.94,14.81L11.73,17C11.08,17.67 10.22,18 9.36,18C8.5,18 7.64,17.67 7,17C5.67,15.71 5.67,13.58 7,12.26L8.35,10.9L8.34,11.5C8.33,12 8.41,12.5 8.57,12.94L8.62,13.09L8.22,13.5C7.91,13.8 7.74,14.21 7.74,14.64C7.74,15.07 7.91,15.47 8.22,15.78C8.83,16.4 9.89,16.4 10.5,15.78L12.7,13.59C13,13.28 13.18,12.87 13.18,12.44C13.18,12 13,11.61 12.7,11.3C12.53,11.14 12.44,10.92 12.44,10.68C12.44,10.45 12.53,10.23 12.7,10.06C13.03,9.73 13.61,9.74 13.94,10.06C14.57,10.7 14.92,11.54 14.92,12.44C14.92,13.34 14.57,14.18 13.94,14.81M17,11.74L15.66,13.1V12.5C15.67,12 15.59,11.5 15.43,11.06L15.38,10.92L15.78,10.5C16.09,10.2 16.26,9.79 16.26,9.36C16.26,8.93 16.09,8.53 15.78,8.22C15.17,7.6 14.1,7.61 13.5,8.22L11.3,10.42C11,10.72 10.82,11.13 10.82,11.56C10.82,12 11,12.39 11.3,12.7C11.47,12.86 11.56,13.08 11.56,13.32C11.56,13.56 11.47,13.78 11.3,13.94C11.13,14.11 10.91,14.19 10.68,14.19C10.46,14.19 10.23,14.11 10.06,13.94C8.75,12.63 8.75,10.5 10.06,9.19L12.27,7C13.58,5.67 15.71,5.68 17,7C17.65,7.62 18,8.46 18,9.36C18,10.26 17.65,11.1 17,11.74Z";
var mdiLinkBoxVariantOutline = "M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M13.94,10.06C14.57,10.7 14.92,11.54 14.92,12.44C14.92,13.34 14.57,14.18 13.94,14.81L11.73,17C11.08,17.67 10.22,18 9.36,18C8.5,18 7.64,17.67 7,17C5.67,15.71 5.67,13.58 7,12.26L8.35,10.9L8.34,11.5C8.33,12 8.41,12.5 8.57,12.94L8.62,13.09L8.22,13.5C7.91,13.8 7.74,14.21 7.74,14.64C7.74,15.07 7.91,15.47 8.22,15.78C8.83,16.4 9.89,16.4 10.5,15.78L12.7,13.59C13,13.28 13.18,12.87 13.18,12.44C13.18,12 13,11.61 12.7,11.3C12.53,11.14 12.44,10.92 12.44,10.68C12.44,10.45 12.53,10.23 12.7,10.06C13.03,9.73 13.61,9.74 13.94,10.06M18,9.36C18,10.26 17.65,11.1 17,11.74L15.66,13.1V12.5C15.67,12 15.59,11.5 15.43,11.06L15.38,10.92L15.78,10.5C16.09,10.2 16.26,9.79 16.26,9.36C16.26,8.93 16.09,8.53 15.78,8.22C15.17,7.6 14.1,7.61 13.5,8.22L11.3,10.42C11,10.72 10.82,11.13 10.82,11.56C10.82,12 11,12.39 11.3,12.7C11.47,12.86 11.56,13.08 11.56,13.32C11.56,13.56 11.47,13.78 11.3,13.94C11.13,14.11 10.91,14.19 10.68,14.19C10.46,14.19 10.23,14.11 10.06,13.94C8.75,12.63 8.75,10.5 10.06,9.19L12.27,7C13.58,5.67 15.71,5.68 17,7C17.65,7.62 18,8.46 18,9.36Z";
var mdiLinkCircle = "M8.17 2.76C9.39 2.26 10.69 2 12 2C13.31 2 14.61 2.26 15.83 2.76C17.04 3.26 18.14 4 19.07 4.93C20 5.86 20.74 6.96 21.24 8.17C21.74 9.39 22 10.69 22 12C22 14.65 20.95 17.2 19.07 19.07C17.2 20.95 14.65 22 12 22C10.69 22 9.39 21.74 8.17 21.24C6.96 20.74 5.86 20 4.93 19.07C3.05 17.2 2 14.65 2 12C2 9.35 3.05 6.8 4.93 4.93C5.86 4 6.96 3.26 8.17 2.76M10 16H11V14H10C9.67 14 8 13.9 8 12C8 10.17 9.54 10 10 10H11V8H10C8.39 8 6 9.07 6 12C6 14.94 8.39 16 10 16M13 16H14C15.61 16 18 14.94 18 12C18 9.07 15.61 8 14 8H13V10H14C14.33 10 16 10.1 16 12C16 13.83 14.46 14 14 14H13V16M9 13H15V11H9V13Z";
var mdiLinkCircleOutline = "M10 16H11V14H10C9.67 14 8 13.9 8 12C8 10.17 9.54 10 10 10H11V8H10C8.39 8 6 9.07 6 12C6 14.94 8.39 16 10 16M13 16H14C15.61 16 18 14.94 18 12C18 9.07 15.61 8 14 8H13V10H14C14.33 10 16 10.1 16 12C16 13.83 14.46 14 14 14H13V16M9 13H15V11H9V13M8.17 2.76C9.39 2.26 10.69 2 12 2C13.31 2 14.61 2.26 15.83 2.76C17.04 3.26 18.14 4 19.07 4.93C20 5.86 20.74 6.96 21.24 8.17C21.74 9.39 22 10.69 22 12C22 14.65 20.95 17.2 19.07 19.07C17.2 20.95 14.65 22 12 22C10.69 22 9.39 21.74 8.17 21.24C6.96 20.74 5.86 20 4.93 19.07C3.05 17.2 2 14.65 2 12C2 9.35 3.05 6.8 4.93 4.93C5.86 4 6.96 3.26 8.17 2.76M6.34 17.66C7.84 19.16 9.88 20 12 20C14.12 20 16.16 19.16 17.66 17.66C19.16 16.16 20 14.12 20 12C20 9.88 19.16 7.84 17.66 6.34C16.16 4.84 14.12 4 12 4C9.88 4 7.84 4.84 6.34 6.34C4.84 7.84 4 9.88 4 12C4 14.12 4.84 16.16 6.34 17.66Z";
var mdiLinkEdit = "M13 22V19.96L19.13 13.83L21.17 15.88L15.04 22H13M21.53 12.15L22.85 13.47C23.05 13.67 23.05 14 22.85 14.19L21.87 15.17L19.83 13.13L20.81 12.15C21 11.95 21.33 11.95 21.53 12.15M20.54 8.46C20.73 8.65 20.9 8.86 21.06 9.08L19.68 10.45C19.15 9.5 18.15 8.9 17 8.9H13V7H17C18.33 7 19.6 7.53 20.54 8.46M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C5.67 7 4.4 7.53 3.46 8.46C2.53 9.4 2 10.67 2 12C2 13.33 2.53 14.6 3.46 15.54C4.4 16.47 5.67 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12M8 13H16V11H8V13Z";
var mdiLinkLock = "M23 16V15.5A2.5 2.5 0 0 0 18 15.5V16A1 1 0 0 0 17 17V21A1 1 0 0 0 18 22H23A1 1 0 0 0 24 21V17A1 1 0 0 0 23 16M22 16H19V15.5A1.5 1.5 0 0 1 22 15.5M7 8.9H11V7H7A5 5 0 0 0 7 17H11V15.1H7A3.1 3.1 0 0 1 7 8.9M8 11V13H16V11M13 15.1V17H15V15.1M17 7H13V8.9H17A3.09 3.09 0 0 1 19.94 11A5.12 5.12 0 0 1 20.5 11H21.9A5 5 0 0 0 17 7Z";
var mdiLinkOff = "M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.43 19.12,14.63 17.79,15L19.25,16.44C20.88,15.61 22,13.95 22,12A5,5 0 0,0 17,7M16,11H13.81L15.81,13H16V11M2,4.27L5.11,7.38C3.29,8.12 2,9.91 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12C3.9,10.41 5.11,9.1 6.66,8.93L8.73,11H8V13H10.73L13,15.27V17H14.73L18.74,21L20,19.74L3.27,3L2,4.27Z";
var mdiLinkPlus = "M7,7H11V9H7A3,3 0 0,0 4,12A3,3 0 0,0 7,15H11V17H7A5,5 0 0,1 2,12A5,5 0 0,1 7,7M17,7A5,5 0 0,1 22,12H20A3,3 0 0,0 17,9H13V7H17M8,11H16V13H8V11M17,12H19V15H22V17H19V20H17V17H14V15H17V12Z";
var mdiLinkVariant = "M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z";
var mdiLinkVariantMinus = "M10.6 13.4A1 1 0 0 1 9.2 14.8A4.8 4.8 0 0 1 9.2 7.8L12.7 4.2A5.1 5.1 0 0 1 19.8 4.2A5.1 5.1 0 0 1 19.8 11.3L18.3 12.8A6.4 6.4 0 0 0 17.9 10.4L18.4 9.9A3.2 3.2 0 0 0 18.4 5.6A3.2 3.2 0 0 0 14.1 5.6L10.6 9.2A2.9 2.9 0 0 0 10.6 13.4M23 18V20H15V18M16.2 13.7A4.8 4.8 0 0 0 14.8 9.2A1 1 0 0 0 13.4 10.6A2.9 2.9 0 0 1 13.4 14.8L9.9 18.4A3.2 3.2 0 0 1 5.6 18.4A3.2 3.2 0 0 1 5.6 14.1L6.1 13.7A7.3 7.3 0 0 1 5.7 11.2L4.2 12.7A5.1 5.1 0 0 0 4.2 19.8A5.1 5.1 0 0 0 11.3 19.8L13.1 18A6 6 0 0 1 16.2 13.7Z";
var mdiLinkVariantOff = "M2,5.27L3.28,4L20,20.72L18.73,22L13.9,17.17L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L12.5,15.76L10.88,14.15C10.87,14.39 10.77,14.64 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C8.12,13.77 7.63,12.37 7.72,11L2,5.27M12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.79,8.97L9.38,7.55L12.71,4.22M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.2,10.54 16.61,12.5 16.06,14.23L14.28,12.46C14.23,11.78 13.94,11.11 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z";
var mdiLinkVariantPlus = "M10.6 13.4A1 1 0 0 1 9.2 14.8A4.8 4.8 0 0 1 9.2 7.8L12.7 4.2A5.1 5.1 0 0 1 19.8 4.2A5.1 5.1 0 0 1 19.8 11.3L18.3 12.8A6.4 6.4 0 0 0 17.9 10.4L18.4 9.9A3.2 3.2 0 0 0 18.4 5.6A3.2 3.2 0 0 0 14.1 5.6L10.6 9.2A2.9 2.9 0 0 0 10.6 13.4M23 18V20H20V23H18V20H15V18H18V15H20V18M16.2 13.7A4.8 4.8 0 0 0 14.8 9.2A1 1 0 0 0 13.4 10.6A2.9 2.9 0 0 1 13.4 14.8L9.9 18.4A3.2 3.2 0 0 1 5.6 18.4A3.2 3.2 0 0 1 5.6 14.1L6.1 13.7A7.3 7.3 0 0 1 5.7 11.2L4.2 12.7A5.1 5.1 0 0 0 4.2 19.8A5.1 5.1 0 0 0 11.3 19.8L13.1 18A6 6 0 0 1 16.2 13.7Z";
var mdiLinkVariantRemove = "M10.6 13.4A1 1 0 0 1 9.2 14.8A4.8 4.8 0 0 1 9.2 7.8L12.7 4.2A5.1 5.1 0 0 1 19.8 4.2A5.1 5.1 0 0 1 19.8 11.3L18.3 12.8A6.4 6.4 0 0 0 17.9 10.4L18.4 9.9A3.2 3.2 0 0 0 18.4 5.6A3.2 3.2 0 0 0 14.1 5.6L10.6 9.2A2.9 2.9 0 0 0 10.6 13.4M16.2 13.7A4.8 4.8 0 0 0 14.8 9.2A1 1 0 0 0 13.4 10.6A2.9 2.9 0 0 1 13.4 14.8L9.9 18.4A3.2 3.2 0 0 1 5.6 18.4A3.2 3.2 0 0 1 5.6 14.1L6.1 13.7A7.3 7.3 0 0 1 5.7 11.2L4.2 12.7A5.1 5.1 0 0 0 4.2 19.8A5.1 5.1 0 0 0 11.3 19.8L13.1 18A6 6 0 0 1 16.2 13.7M21.1 15.5L19 17.6L16.9 15.5L15.5 16.9L17.6 19L15.5 21.1L16.9 22.5L19 20.4L21.1 22.5L22.5 21.1L20.4 19L22.5 16.9Z";
var mdiLinkedin = "M19 3A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19M18.5 18.5V13.2A3.26 3.26 0 0 0 15.24 9.94C14.39 9.94 13.4 10.46 12.92 11.24V10.13H10.13V18.5H12.92V13.57C12.92 12.8 13.54 12.17 14.31 12.17A1.4 1.4 0 0 1 15.71 13.57V18.5H18.5M6.88 8.56A1.68 1.68 0 0 0 8.56 6.88C8.56 5.95 7.81 5.19 6.88 5.19A1.69 1.69 0 0 0 5.19 6.88C5.19 7.81 5.95 8.56 6.88 8.56M8.27 18.5V10.13H5.5V18.5H8.27Z";
var mdiLinux = "M14.62,8.35C14.2,8.63 12.87,9.39 12.67,9.54C12.28,9.85 11.92,9.83 11.53,9.53C11.33,9.37 10,8.61 9.58,8.34C9.1,8.03 9.13,7.64 9.66,7.42C11.3,6.73 12.94,6.78 14.57,7.45C15.06,7.66 15.08,8.05 14.62,8.35M21.84,15.63C20.91,13.54 19.64,11.64 18,9.97C17.47,9.42 17.14,8.8 16.94,8.09C16.84,7.76 16.77,7.42 16.7,7.08C16.5,6.2 16.41,5.3 16,4.47C15.27,2.89 14,2.07 12.16,2C10.35,2.05 9,2.81 8.21,4.4C8,4.83 7.85,5.28 7.75,5.74C7.58,6.5 7.43,7.29 7.25,8.06C7.1,8.71 6.8,9.27 6.29,9.77C4.68,11.34 3.39,13.14 2.41,15.12C2.27,15.41 2.13,15.7 2.04,16C1.85,16.66 2.33,17.12 3.03,16.96C3.47,16.87 3.91,16.78 4.33,16.65C4.74,16.5 4.9,16.6 5,17C5.65,19.15 7.07,20.66 9.24,21.5C13.36,23.06 18.17,20.84 19.21,16.92C19.28,16.65 19.38,16.55 19.68,16.65C20.14,16.79 20.61,16.89 21.08,17C21.57,17.09 21.93,16.84 22,16.36C22.03,16.1 21.94,15.87 21.84,15.63";
var mdiLinuxMint = "M2,3.23V6.8H3.5C4.59,6.8 4.78,7.53 4.78,8.55V14.86C4.78,18.12 7.65,20.77 11.18,20.77H19.9C21,20.77 22,20.07 22,19V9.2C22,5.93 19.13,3.28 15.6,3.28H11.93V3.27L2,3.23V3.23M6.62,5.46H8.37V14.45C8.37,15.65 9.19,16.59 10.16,16.59L16.13,16.61C17.38,16.61 18.35,15.75 18.35,14.73L18.34,9.96C18.34,9.65 18.24,9.41 18,9.19C17.79,8.96 17.56,8.86 17.25,8.86C16.94,8.86 16.71,8.96 16.5,9.19C16.27,9.41 16.16,9.65 16.16,9.96V14.05H14.31V9.96C14.31,9.65 14.21,9.41 14,9.19C13.77,8.96 13.54,8.86 13.22,8.86C12.92,8.86 12.68,8.96 12.46,9.19C12.24,9.41 12.14,9.65 12.14,9.96V14.05H10.29V9.96C10.29,9.15 10.58,8.44 11.15,7.86C11.72,7.29 12.43,7 13.22,7C14,7 14.68,7.28 15.24,7.82C15.79,7.28 16.47,7 17.25,7C18.05,7 18.76,7.29 19.32,7.86C19.89,8.44 20.19,9.15 20.19,9.96L20.2,15.06C20.11,15.91 19.75,16.67 19.13,17.31V17.31C18.4,18.04 17.5,18.42 16.5,18.42H9.83C9,18.34 8.29,17.95 7.69,17.36C7,16.65 6.62,15.79 6.62,14.79V5.46H6.62Z";
var mdiLipstick = "M9 23C8.45 23 8 22.55 8 22V13C8 12.45 8.45 12 9 12H15C15.55 12 16 12.45 16 13V22C16 22.55 15.55 23 15 23H9M10 11C9.45 11 9 10.55 9 10V5.25C9 5.25 11 3 11.75 1C12.83 1.67 13.92 2.33 14.46 3.83C15 5.33 15 7.67 15 10C15 10.55 14.55 11 14 11H10Z";
var mdiLiquidSpot = "M18.14 16.7C17.23 18.21 16.08 17.73 15 17.09S12.9 15.68 12.25 16.59C11.54 17.37 12.09 18.62 12.37 19.72C12.65 20.83 12.67 21.79 10.9 22C9.5 21.81 9.58 20.65 9.81 19.42C10.04 18.19 10.4 16.89 9.5 16.43C8.78 15.95 8.28 16.78 7.65 17.6C7 18.41 6.26 19.2 5.04 18.62C3.94 17.71 4.36 17.18 4.94 16.5S6.27 14.91 5.84 13.31C5.66 12.66 4.76 12.81 3.87 12.79C3 12.77 2.12 12.59 2.03 11.29C1.96 10.5 2.55 10.18 3.16 9.93C3.78 9.68 4.41 9.5 4.42 8.87C4.45 8.26 4.04 7.83 3.78 7.38S3.41 6.46 4.03 5.76C5.08 4.9 5.92 5.63 6.76 6.42S8.43 8.04 9.46 7.39C10.28 6.85 9.53 5.9 8.95 4.97S7.96 3.15 9.46 2.74C10.76 2.38 11.26 3.27 11.71 4.3C12.17 5.33 12.57 6.5 13.67 6.71C15.24 7 16.38 5.16 17.47 3.7S19.63 1.15 21 2.95C22.5 4.84 21.07 5.72 19.4 6.5C17.73 7.23 15.81 7.87 16.27 9.28C16.54 10.1 17.42 9.65 18.35 9.34C19.27 9.03 20.26 8.86 20.74 10.27C21.25 11.76 20.04 12.1 18.68 12.24C17.32 12.38 15.8 12.32 15.7 13C15.59 13.71 16.5 14 17.29 14.42C18.08 14.85 18.75 15.42 18.14 16.7M20.5 19C19.55 19 19.06 18.26 19.06 17.5C19.06 16.74 19.54 16 20.5 16C21.5 16 22 16.74 22 17.5C22 18.26 21.5 19 20.5 19Z";
var mdiLiquor = "M3 14C3 15.3 3.8 16.4 5 16.8V20H3V22H9V20H7V16.8C8.2 16.4 9 15.3 9 14V6H3V14M5 8H7V11H5V8M20.6 8.5L19.6 8.2C19.3 8.1 19 7.7 19 7.3V3C19 2.5 18.5 2 18 2H15C14.4 2 14 2.5 14 3V7.3C14 7.7 13.7 8.1 13.3 8.3L12.4 8.6C11.6 8.9 11 9.6 11 10.5V20C11 21.1 11.9 22 13 22H20C21.1 22 22 21.1 22 20V10.4C22 9.6 21.5 8.8 20.6 8.5M16 4H17V5H16V4M13 10.4L13.9 10.1C15.2 9.7 16 8.6 16 7.3V7H17V7.3C17 8.6 17.8 9.7 19 10.1L20 10.4V12H13V10.4M20 20H13V18H20V20Z";
var mdiListBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M7 7H9V9H7V7M7 11H9V13H7V11M7 15H9V17H7V15M17 17H11V15H17V17M17 13H11V11H17V13M17 9H11V7H17V9Z";
var mdiListBoxOutline = "M11 15H17V17H11V15M9 7H7V9H9V7M11 13H17V11H11V13M11 9H17V7H11V9M9 11H7V13H9V11M21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5M19 5H5V19H19V5M9 15H7V17H9V15Z";
var mdiListStatus = "M16.5 11L13 7.5L14.4 6.1L16.5 8.2L20.7 4L22.1 5.4L16.5 11M11 7H2V9H11V7M21 13.4L19.6 12L17 14.6L14.4 12L13 13.4L15.6 16L13 18.6L14.4 20L17 17.4L19.6 20L21 18.6L18.4 16L21 13.4M11 15H2V17H11V15Z";
var mdiLitecoin = "M12.55,15.92L13.16,13.78L14.81,13.19L16.25,7.63L14.56,8.31L16.25,2H8L5.38,11.77L3.72,12.34L2.22,17.91L4,17.27L2.66,22H20.16L21.78,15.92H12.55M19.39,21H4L5.46,15.65L3.72,16.3L4.58,13.11L6.24,12.54L8.74,3H15L13.13,10L14.83,9.3L14,12.42L12.33,13L11.22,16.91H20.5L19.39,21Z";
var mdiLoading = "M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z";
var mdiLocationEnter = "M14 12L10 8V11H2V13H10V16M22 12A10 10 0 0 1 2.46 15H4.59A8 8 0 1 0 4.59 9H2.46A10 10 0 0 1 22 12Z";
var mdiLocationExit = "M22 12L18 8V11H10V13H18V16M20 18A10 10 0 1 1 20 6H17.27A8 8 0 1 0 17.27 18Z";
var mdiLock = "M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z";
var mdiLockAlert = "M10 17C11.1 17 12 16.1 12 15C12 13.9 11.1 13 10 13C8.9 13 8 13.9 8 15S8.9 17 10 17M16 8C17.1 8 18 8.9 18 10V20C18 21.1 17.1 22 16 22H4C2.9 22 2 21.1 2 20V10C2 8.9 2.9 8 4 8H5V6C5 3.2 7.2 1 10 1S15 3.2 15 6V8H16M10 3C8.3 3 7 4.3 7 6V8H13V6C13 4.3 11.7 3 10 3M22 13H20V7H22V13M22 17H20V15H22V17Z";
var mdiLockAlertOutline = "M10 17C8.9 17 8 16.1 8 15C8 13.9 8.9 13 10 13C11.1 13 12 13.9 12 15S11.1 17 10 17M16 20V10H4V20H16M16 8C17.1 8 18 8.9 18 10V20C18 21.1 17.1 22 16 22H4C2.9 22 2 21.1 2 20V10C2 8.9 2.9 8 4 8H5V6C5 3.2 7.2 1 10 1S15 3.2 15 6V8H16M10 3C8.3 3 7 4.3 7 6V8H13V6C13 4.3 11.7 3 10 3M22 7H20V13H22V7M22 15H20V17H22V15Z";
var mdiLockCheck = "M19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6V8H6C4.9 8 4 8.89 4 10V20C4 21.11 4.89 22 6 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M9 6C9 4.34 10.34 3 12 3S15 4.34 15 6V8H9V6M12 17C10.9 17 10 16.11 10 15S10.9 13 12 13C13.1 13 14 13.89 14 15C14 16.11 13.11 17 12 17M22.5 17.25L17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25Z";
var mdiLockCheckOutline = "M14 15C14 16.11 13.11 17 12 17C10.89 17 10 16.1 10 15C10 13.89 10.89 13 12 13C13.11 13 14 13.9 14 15M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.1 4 20V10C4 8.89 4.89 8 6 8H7V6C7 3.24 9.24 1 12 1S17 3.24 17 6V8H18C19.11 8 20 8.9 20 10V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V10H6V20H13.09M9 8H15V6C15 4.34 13.66 3 12 3S9 4.34 9 6V8M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiLockClock = "M8.5,2C6,2 4,4 4,6.5V7C2.89,7 2,7.89 2,9V18C2,19.11 2.89,20 4,20H8.72C10.18,21.29 12.06,22 14,22A8,8 0 0,0 22,14A8,8 0 0,0 14,6C13.66,6 13.32,6.03 13,6.08C12.76,3.77 10.82,2 8.5,2M8.5,4A2.5,2.5 0 0,1 11,6.5V7H6V6.5A2.5,2.5 0 0,1 8.5,4M14,8A6,6 0 0,1 20,14A6,6 0 0,1 14,20A6,6 0 0,1 8,14A6,6 0 0,1 14,8M13,10V15L16.64,17.19L17.42,15.9L14.5,14.15V10H13Z";
var mdiLockMinus = "M19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6V8H6C4.9 8 4 8.89 4 10V20C4 21.11 4.89 22 6 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M9 6C9 4.34 10.34 3 12 3S15 4.34 15 6V8H9V6M12 17C10.9 17 10 16.11 10 15S10.9 13 12 13C13.1 13 14 13.89 14 15C14 16.11 13.11 17 12 17M23 18V20H15V18H23Z";
var mdiLockMinusOutline = "M14 15C14 16.11 13.11 17 12 17C10.89 17 10 16.1 10 15C10 13.89 10.89 13 12 13C13.11 13 14 13.9 14 15M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.1 4 20V10C4 8.89 4.89 8 6 8H7V6C7 3.24 9.24 1 12 1S17 3.24 17 6V8H18C19.11 8 20 8.9 20 10V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V10H6V20H13.09M9 8H15V6C15 4.34 13.66 3 12 3S9 4.34 9 6V8M15 18V20H23V18H15Z";
var mdiLockOff = "M9 5.82L7.36 4.16C8.09 2.31 9.89 1 12 1C14.76 1 17 3.24 17 6V8H18C19.11 8 20 8.9 20 10V16.8L11.2 8H15V6C15 4.34 13.66 3 12 3C10.41 3 9.11 4.25 9 5.82M22.11 21.46L20.84 22.73L19.46 21.35C19.1 21.75 18.58 22 18 22H6C4.89 22 4 21.11 4 20V10C4 8.89 4.9 8 6 8H6.11L1.11 3L2.39 1.73L22.11 21.46M13.85 15.74L11.26 13.15C10.5 13.44 10 14.16 10 15C10 16.11 10.9 17 12 17C12.84 17 13.56 16.5 13.85 15.74Z";
var mdiLockOffOutline = "M9 5.82L7.36 4.16C8.09 2.31 9.89 1 12 1C14.76 1 17 3.24 17 6V8H18C19.11 8 20 8.9 20 10V16.8L18 14.8V10H13.2L11.2 8H15V6C15 4.34 13.66 3 12 3C10.41 3 9.11 4.25 9 5.82M22.11 21.46L20.84 22.73L19.46 21.35C19.1 21.75 18.58 22 18 22H6C4.89 22 4 21.1 4 20V10C4 8.89 4.89 8 6 8H6.11L1.11 3L2.39 1.73L22.11 21.46M18 19.89L13.85 15.74C13.56 16.5 12.84 17 12 17C10.89 17 10 16.1 10 15C10 14.15 10.5 13.44 11.26 13.15L8.11 10H6V20H18V19.89Z";
var mdiLockOpen = "M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10A2,2 0 0,1 6,8H15V6A3,3 0 0,0 12,3A3,3 0 0,0 9,6H7A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,17A2,2 0 0,0 14,15A2,2 0 0,0 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17Z";
var mdiLockOpenAlert = "M16 8C17.1 8 18 8.9 18 10V20C18 21.1 17.1 22 16 22H4C2.9 22 2 21.1 2 20V10C2 8.9 2.9 8 4 8H13V6C13 4.3 11.7 3 10 3S7 4.3 7 6H5C5 3.2 7.2 1 10 1S15 3.2 15 6V8H16M10 17C11.1 17 12 16.1 12 15S11.1 13 10 13 8 13.9 8 15 8.9 17 10 17M22 13H20V7H22V13M22 17H20V15H22V17Z";
var mdiLockOpenAlertOutline = "M16 20V10H4V20H16M16 8C17.1 8 18 8.9 18 10V20C18 21.1 17.1 22 16 22H4C2.9 22 2 21.1 2 20V10C2 8.9 2.9 8 4 8H13V6C13 4.3 11.7 3 10 3S7 4.3 7 6H5C5 3.2 7.2 1 10 1S15 3.2 15 6V8H16M10 17C8.9 17 8 16.1 8 15S8.9 13 10 13 12 13.9 12 15 11.1 17 10 17M22 7H20V13H22V7M22 15H20V17H22V15Z";
var mdiLockOpenCheck = "M19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6H9C9 4.34 10.34 3 12 3S15 4.34 15 6V8H6C4.89 8 4 8.9 4 10V20C4 21.1 4.89 22 6 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M12 17C10.9 17 10 16.11 10 15S10.9 13 12 13 14 13.9 14 15 13.11 17 12 17M22.5 17.25L17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25Z";
var mdiLockOpenCheckOutline = "M14 15C14 16.11 13.11 17 12 17S10 16.11 10 15 10.9 13 12 13 14 13.9 14 15M6 20V10H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6H9C9 4.34 10.34 3 12 3S15 4.34 15 6V8H6C4.89 8 4 8.9 4 10V20C4 21.1 4.89 22 6 22H13.81C13.46 21.39 13.22 20.72 13.09 20H6M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiLockOpenMinus = "M19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6H9C9 4.34 10.34 3 12 3S15 4.34 15 6V8H6C4.89 8 4 8.9 4 10V20C4 21.1 4.89 22 6 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M12 17C10.9 17 10 16.11 10 15S10.9 13 12 13 14 13.9 14 15 13.11 17 12 17M23 18V20H15V18H23Z";
var mdiLockOpenMinusOutline = "M14 15C14 16.11 13.11 17 12 17S10 16.11 10 15 10.9 13 12 13 14 13.9 14 15M6 20V10H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6H9C9 4.34 10.34 3 12 3S15 4.34 15 6V8H6C4.89 8 4 8.9 4 10V20C4 21.1 4.89 22 6 22H13.81C13.46 21.39 13.22 20.72 13.09 20H6M15 18V20H23V18H15Z";
var mdiLockOpenOutline = "M18,20V10H6V20H18M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10A2,2 0 0,1 6,8H15V6A3,3 0 0,0 12,3A3,3 0 0,0 9,6H7A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17Z";
var mdiLockOpenPlus = "M19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6H9C9 4.34 10.34 3 12 3S15 4.34 15 6V8H6C4.89 8 4 8.9 4 10V20C4 21.1 4.89 22 6 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M12 17C10.9 17 10 16.11 10 15S10.9 13 12 13 14 13.9 14 15 13.11 17 12 17M23 18V20H20V23H18V20H15V18H18V15H20V18H23Z";
var mdiLockOpenPlusOutline = "M14 15C14 16.11 13.11 17 12 17S10 16.11 10 15 10.9 13 12 13 14 13.9 14 15M6 20V10H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6H9C9 4.34 10.34 3 12 3S15 4.34 15 6V8H6C4.89 8 4 8.9 4 10V20C4 21.1 4.89 22 6 22H13.81C13.46 21.39 13.22 20.72 13.09 20H6M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiLockOpenRemove = "M19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6H9C9 4.34 10.34 3 12 3S15 4.34 15 6V8H6C4.89 8 4 8.9 4 10V20C4 21.1 4.89 22 6 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M12 17C10.9 17 10 16.11 10 15S10.9 13 12 13 14 13.9 14 15 13.11 17 12 17M20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19Z";
var mdiLockOpenRemoveOutline = "M14 15C14 16.11 13.11 17 12 17S10 16.11 10 15 10.9 13 12 13 14 13.9 14 15M6 20V10H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6H9C9 4.34 10.34 3 12 3S15 4.34 15 6V8H6C4.89 8 4 8.9 4 10V20C4 21.1 4.89 22 6 22H13.81C13.46 21.39 13.22 20.72 13.09 20H6M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiLockOpenVariant = "M18 1C15.24 1 13 3.24 13 6V8H4C2.9 8 2 8.89 2 10V20C2 21.11 2.9 22 4 22H16C17.11 22 18 21.11 18 20V10C18 8.9 17.11 8 16 8H15V6C15 4.34 16.34 3 18 3C19.66 3 21 4.34 21 6V8H23V6C23 3.24 20.76 1 18 1M10 13C11.1 13 12 13.89 12 15C12 16.11 11.11 17 10 17C8.9 17 8 16.11 8 15C8 13.9 8.9 13 10 13Z";
var mdiLockOpenVariantOutline = "M10 13C11.1 13 12 13.89 12 15C12 16.11 11.11 17 10 17S8 16.11 8 15 8.9 13 10 13M18 1C15.24 1 13 3.24 13 6V8H4C2.9 8 2 8.9 2 10V20C2 21.1 2.9 22 4 22H16C17.1 22 18 21.1 18 20V10C18 8.9 17.1 8 16 8H15V6C15 4.34 16.34 3 18 3S21 4.34 21 6V8H23V6C23 3.24 20.76 1 18 1M16 10V20H4V10H16Z";
var mdiLockOutline = "M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M18,20V10H6V20H18M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10C4,8.89 4.89,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z";
var mdiLockPattern = "M7,3A4,4 0 0,1 11,7C11,8.86 9.73,10.43 8,10.87V13.13C8.37,13.22 8.72,13.37 9.04,13.56L13.56,9.04C13.2,8.44 13,7.75 13,7A4,4 0 0,1 17,3A4,4 0 0,1 21,7A4,4 0 0,1 17,11C16.26,11 15.57,10.8 15,10.45L10.45,15C10.8,15.57 11,16.26 11,17A4,4 0 0,1 7,21A4,4 0 0,1 3,17C3,15.14 4.27,13.57 6,13.13V10.87C4.27,10.43 3,8.86 3,7A4,4 0 0,1 7,3M17,13A4,4 0 0,1 21,17A4,4 0 0,1 17,21A4,4 0 0,1 13,17A4,4 0 0,1 17,13M17,15A2,2 0 0,0 15,17A2,2 0 0,0 17,19A2,2 0 0,0 19,17A2,2 0 0,0 17,15Z";
var mdiLockPercent = "M18 8H17V6C17 3.2 14.8 1 12 1S7 3.2 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8M9 6C9 4.3 10.3 3 12 3S15 4.3 15 6V8H9V6M9.5 11C10.3 11 11 11.7 11 12.5S10.3 14 9.5 14 8 13.3 8 12.5 8.7 11 9.5 11M14.5 19C13.7 19 13 18.3 13 17.5S13.7 16 14.5 16 16 16.7 16 17.5 15.3 19 14.5 19M9.2 19.2L7.8 17.8L14.9 10.7L16.3 12.1L9.2 19.2Z";
var mdiLockPercentOpen = "M18 8H17V6C17 3.2 14.8 1 12 1S7 3.2 7 6H9C9 4.3 10.3 3 12 3S15 4.3 15 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8M9.5 11C10.3 11 11 11.7 11 12.5S10.3 14 9.5 14 8 13.3 8 12.5 8.7 11 9.5 11M14.5 19C13.7 19 13 18.3 13 17.5S13.7 16 14.5 16 16 16.7 16 17.5 15.3 19 14.5 19M9.2 19.2L7.8 17.8L14.9 10.7L16.3 12.1L9.2 19.2Z";
var mdiLockPercentOpenOutline = "M9.5 11C10.3 11 11 11.7 11 12.5S10.3 14 9.5 14 8 13.3 8 12.5 8.7 11 9.5 11M14.5 19C13.7 19 13 18.3 13 17.5S13.7 16 14.5 16 16 16.7 16 17.5 15.3 19 14.5 19M9.2 19.2L7.8 17.8L14.9 10.7L16.3 12.1L9.2 19.2M18 8H17V6C17 3.2 14.8 1 12 1S7 3.2 7 6H9C9 4.3 10.3 3 12 3S15 4.3 15 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8M18 20H6V10H18V20Z";
var mdiLockPercentOpenVariant = "M18 1C15.2 1 13 3.2 13 6V8H4C2.9 8 2 8.9 2 10V20C2 21.1 2.9 22 4 22H16C17.1 22 18 21.1 18 20V10C18 8.9 17.1 8 16 8H15V6C15 4.3 16.3 3 18 3S21 4.3 21 6V8H23V6C23 3.2 20.8 1 18 1M7.5 11C8.3 11 9 11.7 9 12.5S8.3 14 7.5 14 6 13.3 6 12.5 6.7 11 7.5 11M12.5 19C11.7 19 11 18.3 11 17.5S11.7 16 12.5 16 14 16.7 14 17.5 13.3 19 12.5 19M7.2 19.2L5.8 17.8L12.9 10.7L14.3 12.1L7.2 19.2Z";
var mdiLockPercentOpenVariantOutline = "M7.5 11C8.3 11 9 11.7 9 12.5S8.3 14 7.5 14 6 13.3 6 12.5 6.7 11 7.5 11M12.5 19C11.7 19 11 18.3 11 17.5S11.7 16 12.5 16 14 16.7 14 17.5 13.3 19 12.5 19M7.2 19.2L5.8 17.8L12.9 10.7L14.3 12.1L7.2 19.2M18 1C15.2 1 13 3.2 13 6V8H4C2.9 8 2 8.9 2 10V20C2 21.1 2.9 22 4 22H16C17.1 22 18 21.1 18 20V10C18 8.9 17.1 8 16 8H15V6C15 4.3 16.3 3 18 3S21 4.3 21 6V8H23V6C23 3.2 20.8 1 18 1M16 10V20H4V10H16Z";
var mdiLockPercentOutline = "M18 8H17V6C17 3.2 14.8 1 12 1S7 3.2 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8M9 6C9 4.3 10.3 3 12 3S15 4.3 15 6V8H9V6M18 20H6V10H18V20M11 12.5C11 13.3 10.3 14 9.5 14S8 13.3 8 12.5 8.7 11 9.5 11 11 11.7 11 12.5M16 17.5C16 18.3 15.3 19 14.5 19S13 18.3 13 17.5 13.7 16 14.5 16 16 16.7 16 17.5M16.2 12.2L9.1 19.3L7.7 17.9L14.8 10.8L16.2 12.2Z";
var mdiLockPlus = "M19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6V8H6C4.9 8 4 8.89 4 10V20C4 21.11 4.89 22 6 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M9 6C9 4.34 10.34 3 12 3S15 4.34 15 6V8H9V6M12 17C10.9 17 10 16.11 10 15S10.9 13 12 13C13.1 13 14 13.89 14 15C14 16.11 13.11 17 12 17M23 18V20H20V23H18V20H15V18H18V15H20V18H23Z";
var mdiLockPlusOutline = "M6 20V10H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6V8H6C4.89 8 4 8.89 4 10V20C4 21.1 4.89 22 6 22H13.81C13.46 21.39 13.22 20.72 13.09 20H6M9 6C9 4.34 10.34 3 12 3S15 4.34 15 6V8H9V6M14 15C14 16.11 13.11 17 12 17C10.89 17 10 16.1 10 15C10 13.89 10.89 13 12 13C13.11 13 14 13.9 14 15M23 18V20H20V23H18V20H15V18H18V15H20V18H23Z";
var mdiLockQuestion = "M12,1A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8H17V6A5,5 0 0,0 12,1M12,2.9C13.71,2.9 15.1,4.29 15.1,6V8H8.9V6C8.9,4.29 10.29,2.9 12,2.9M12.19,10.5C13.13,10.5 13.88,10.71 14.42,11.12C14.96,11.54 15.23,12.1 15.23,12.8C15.23,13.24 15.08,13.63 14.79,14C14.5,14.36 14.12,14.64 13.66,14.85C13.4,15 13.23,15.15 13.14,15.32C13.05,15.5 13,15.72 13,16H11C11,15.5 11.1,15.16 11.29,14.92C11.5,14.68 11.84,14.4 12.36,14.08C12.62,13.94 12.83,13.76 13,13.54C13.14,13.33 13.22,13.08 13.22,12.8C13.22,12.5 13.13,12.28 12.95,12.11C12.77,11.93 12.5,11.85 12.19,11.85C11.92,11.85 11.7,11.92 11.5,12.06C11.34,12.2 11.24,12.41 11.24,12.69H9.27C9.22,12 9.5,11.4 10.05,11.04C10.59,10.68 11.3,10.5 12.19,10.5M11,17H13V19H11V17Z";
var mdiLockRemove = "M19 13C19.34 13 19.67 13.04 20 13.09V10C20 8.9 19.11 8 18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6V8H6C4.9 8 4 8.89 4 10V20C4 21.11 4.89 22 6 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M9 6C9 4.34 10.34 3 12 3S15 4.34 15 6V8H9V6M12 17C10.9 17 10 16.11 10 15S10.9 13 12 13C13.1 13 14 13.89 14 15C14 16.11 13.11 17 12 17M20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19Z";
var mdiLockRemoveOutline = "M14 15C14 16.11 13.11 17 12 17C10.89 17 10 16.1 10 15C10 13.89 10.89 13 12 13C13.11 13 14 13.9 14 15M13.09 20C13.21 20.72 13.46 21.39 13.81 22H6C4.89 22 4 21.1 4 20V10C4 8.89 4.89 8 6 8H7V6C7 3.24 9.24 1 12 1S17 3.24 17 6V8H18C19.11 8 20 8.9 20 10V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V10H6V20H13.09M9 8H15V6C15 4.34 13.66 3 12 3S9 4.34 9 6V8M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiLockReset = "M12.63,2C18.16,2 22.64,6.5 22.64,12C22.64,17.5 18.16,22 12.63,22C9.12,22 6.05,20.18 4.26,17.43L5.84,16.18C7.25,18.47 9.76,20 12.64,20A8,8 0 0,0 20.64,12A8,8 0 0,0 12.64,4C8.56,4 5.2,7.06 4.71,11H7.47L3.73,14.73L0,11H2.69C3.19,5.95 7.45,2 12.63,2M15.59,10.24C16.09,10.25 16.5,10.65 16.5,11.16V15.77C16.5,16.27 16.09,16.69 15.58,16.69H10.05C9.54,16.69 9.13,16.27 9.13,15.77V11.16C9.13,10.65 9.54,10.25 10.04,10.24V9.23C10.04,7.7 11.29,6.46 12.81,6.46C14.34,6.46 15.59,7.7 15.59,9.23V10.24M12.81,7.86C12.06,7.86 11.44,8.47 11.44,9.23V10.24H14.19V9.23C14.19,8.47 13.57,7.86 12.81,7.86Z";
var mdiLockSmart = "M12,2A6,6 0 0,0 6,8V16A6,6 0 0,0 12,22A6,6 0 0,0 18,16V8A6,6 0 0,0 12,2M8,6H10V8H8V6M11,6H13V8H11V6M14,6H16V8H14V6M8,9H10V11H8V9M11,9H13V11H11V9M14,9H16V11H14V9M8,12H10V14H8V12M11,12H13V14H11V12M14,12H16V14H14V12M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16Z";
var mdiLocker = "M8,2H16A2,2 0 0,1 18,4V20A2,2 0 0,1 16,22H8A2,2 0 0,1 6,20V4A2,2 0 0,1 8,2M8,4V20H16V4H8M10,13H12V17H10V13M10,6H14V7.5H10V6M10,9H14V10.5H10V9Z";
var mdiLockerMultiple = "M3,2H21A2,2 0 0,1 23,4V20A2,2 0 0,1 21,22H3A2,2 0 0,1 1,20V4A2,2 0 0,1 3,2M13,4V20H21V4H13M3,4V20H11V4H3M5,13H7V17H5V13M5,6H9V7.5H5V6M5,9H9V10.5H5V9M15,13H17V17H15V13M15,6H19V7.5H15V6M15,9H19V10.5H15V9Z";
var mdiLogin = "M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7M20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z";
var mdiLoginVariant = "M19,3H5C3.89,3 3,3.89 3,5V9H5V5H19V19H5V15H3V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M10.08,15.58L11.5,17L16.5,12L11.5,7L10.08,8.41L12.67,11H3V13H12.67L10.08,15.58Z";
var mdiLogout = "M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12M4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z";
var mdiLogoutVariant = "M14.08,15.59L16.67,13H7V11H16.67L14.08,8.41L15.5,7L20.5,12L15.5,17L14.08,15.59M19,3A2,2 0 0,1 21,5V9.67L19,7.67V5H5V19H19V16.33L21,14.33V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19Z";
var mdiLongitude = "M12 2A10 10 0 1 0 22 12A10.03 10.03 0 0 0 12 2M9.4 19.6A8.05 8.05 0 0 1 9.4 4.4A16.45 16.45 0 0 0 7.5 12A16.45 16.45 0 0 0 9.4 19.6M12 20A13.81 13.81 0 0 1 9.5 12A13.81 13.81 0 0 1 12 4A13.81 13.81 0 0 1 14.5 12A13.81 13.81 0 0 1 12 20M14.6 19.6A16.15 16.15 0 0 0 14.6 4.4A8.03 8.03 0 0 1 20 12A7.9 7.9 0 0 1 14.6 19.6Z";
var mdiLooks = "M12,6A11,11 0 0,0 1,17H3C3,12.04 7.04,8 12,8C16.96,8 21,12.04 21,17H23A11,11 0 0,0 12,6M12,10C8.14,10 5,13.14 5,17H7A5,5 0 0,1 12,12A5,5 0 0,1 17,17H19C19,13.14 15.86,10 12,10Z";
var mdiLotion = "M15.5 6.5C15.5 5.66 17 4 17 4S18.5 5.66 18.5 6.5C18.5 7.33 17.83 8 17 8S15.5 7.33 15.5 6.5M19.5 15C20.88 15 22 13.88 22 12.5C22 10.83 19.5 8 19.5 8S17 10.83 17 12.5C17 13.88 18.12 15 19.5 15M16 12V22H4V12C4 9.03 6.16 6.57 9 6.09V4H7V2H13C14.13 2 15.15 2.39 16 3L14.56 4.44C14.1 4.17 13.57 4 13 4H11V6.09C13.84 6.57 16 9.03 16 12Z";
var mdiLotionOutline = "M15.5 6.5C15.5 5.66 17 4 17 4S18.5 5.66 18.5 6.5C18.5 7.33 17.83 8 17 8S15.5 7.33 15.5 6.5M19.5 15C20.88 15 22 13.88 22 12.5C22 10.83 19.5 8 19.5 8S17 10.83 17 12.5C17 13.88 18.12 15 19.5 15M16 12V20C16 21.1 15.1 22 14 22H6C4.9 22 4 21.1 4 20V12C4 9.03 6.16 6.57 9 6.09V4H7V2H13C14.13 2 15.15 2.39 16 3L14.56 4.44C14.1 4.17 13.57 4 13 4H11V6.09C13.84 6.57 16 9.03 16 12M14 12C14 9.79 12.21 8 10 8S6 9.79 6 12V20H14V12Z";
var mdiLotionPlus = "M15.5 6.5C15.5 5.66 17 4 17 4S18.5 5.66 18.5 6.5C18.5 7.33 17.83 8 17 8S15.5 7.33 15.5 6.5M19.5 15C20.88 15 22 13.88 22 12.5C22 10.83 19.5 8 19.5 8S17 10.83 17 12.5C17 13.88 18.12 15 19.5 15M13 14H11V12H9V14H7V16H9V18H11V16H13V14M16 12V22H4V12C4 9.03 6.16 6.57 9 6.09V4H7V2H13C14.13 2 15.15 2.39 16 3L14.56 4.44C14.1 4.17 13.57 4 13 4H11V6.09C13.84 6.57 16 9.03 16 12Z";
var mdiLotionPlusOutline = "M15.5 6.5C15.5 5.66 17 4 17 4S18.5 5.66 18.5 6.5C18.5 7.33 17.83 8 17 8S15.5 7.33 15.5 6.5M19.5 15C20.88 15 22 13.88 22 12.5C22 10.83 19.5 8 19.5 8S17 10.83 17 12.5C17 13.88 18.12 15 19.5 15M13 14H11V12H9V14H7V16H9V18H11V16H13V14M16 12V20C16 21.1 15.1 22 14 22H6C4.9 22 4 21.1 4 20V12C4 9.03 6.16 6.57 9 6.09V4H7V2H13C14.13 2 15.15 2.39 16 3L14.56 4.44C14.1 4.17 13.57 4 13 4H11V6.09C13.84 6.57 16 9.03 16 12M14 12C14 9.79 12.21 8 10 8S6 9.79 6 12V20H14V12Z";
var mdiLoupe = "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22H20A2,2 0 0,0 22,20V12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z";
var mdiLumx = "M12.35,1.75L20.13,9.53L13.77,15.89L12.35,14.47L17.3,9.53L10.94,3.16L12.35,1.75M15.89,9.53L14.47,10.94L10.23,6.7L5.28,11.65L3.87,10.23L10.23,3.87L15.89,9.53M10.23,8.11L11.65,9.53L6.7,14.47L13.06,20.84L11.65,22.25L3.87,14.47L10.23,8.11M8.11,14.47L9.53,13.06L13.77,17.3L18.72,12.35L20.13,13.77L13.77,20.13L8.11,14.47Z";
var mdiLungs = "M15.47 3.11C15 2.85 14.37 3.05 14.11 3.54C14.04 3.68 14 3.84 14 4V6.59L13.29 5.88C13.1 5.69 13 5.44 13 5.18V1H11V5.17C11 5.44 10.9 5.69 10.71 5.88L10 6.59V4C10 3.44 9.54 3 9 3C8.83 3 8.67 3.04 8.53 3.11C4.72 5 2 9.97 2 15.77C2 17.67 2.33 19.55 3 21.32C3.19 21.85 3.76 22.13 4.29 21.94C4.34 21.92 4.39 21.9 4.44 21.87L9.5 19.07C9.81 18.9 10 18.56 10 18.19V9.41L11.3 8.12C11.69 7.73 12.32 7.73 12.71 8.12L14 9.42V18.2C14 18.56 14.21 18.9 14.5 19.08L19.58 21.88C20.07 22.14 20.68 21.96 20.94 21.46C20.96 21.42 21 21.37 21 21.32C21.67 19.55 22 17.67 22 15.77C22 9.97 19.29 5 15.47 3.11Z";
var mdiMace = "M19.92 9.27C19.97 9 20 8.76 20 8.5S19.97 8 19.92 7.73L23 8.5L19.92 9.27M14.69 12.92L15.5 16.16L16.31 12.92C16.05 12.97 15.78 13 15.5 13S14.95 12.97 14.69 12.92M11.7 10.89L6.79 15.79L6.09 15.09L1 20.17L3.83 23L8.91 17.91L8.21 17.21L13.11 12.3C12.54 11.94 12.06 11.46 11.7 10.89M16.27 4.08L15.5 1L14.73 4.08C15 4.03 15.24 4 15.5 4S16 4.03 16.27 4.08M8 8.5L11.08 9.27C11.03 9 11 8.76 11 8.5S11.03 8 11.08 7.73L8 8.5M18.63 10.04C18.86 9.58 19 9.06 19 8.5S18.86 7.42 18.63 6.96L21 3L17.04 5.37C16.58 5.14 16.06 5 15.5 5S14.42 5.14 13.96 5.37L10 3L12.37 6.96C12.14 7.42 12 7.94 12 8.5C12 10.43 13.57 12 15.5 12C16.06 12 16.58 11.86 17.04 11.63L21 14L18.63 10.04Z";
var mdiMagazinePistol = "M14 1L12 3H7L9 21H8V23H18V21L16 1M9 5H12L12.24 7H9.24M9.47 9H12.47L12.71 11H9.71M9.94 13H12.94L13.18 15H10.18M10.41 17H13.41L13.65 19H10.65Z";
var mdiMagazineRifle = "M7 1V3H8V13L5 19L14 23L18 13V3H19V1M10 3H16V5H11.88V13.45L9.6 18.14L8 17.5L10 13.5Z";
var mdiMagicStaff = "M17.5 9C16.12 9 15 7.88 15 6.5S16.12 4 17.5 4 20 5.12 20 6.5 18.88 9 17.5 9M14.43 8.15L2 20.59L3.41 22L15.85 9.57C15.25 9.24 14.76 8.75 14.43 8.15M13 5L13.63 3.63L15 3L13.63 2.37L13 1L12.38 2.37L11 3L12.38 3.63L13 5M21 5L21.63 3.63L23 3L21.63 2.37L21 1L20.38 2.37L19 3L20.38 3.63L21 5M21 9L20.38 10.37L19 11L20.38 11.63L21 13L21.63 11.63L23 11L21.63 10.37L21 9Z";
var mdiMagnet = "M3,7V13A9,9 0 0,0 12,22A9,9 0 0,0 21,13V7H17V13A5,5 0 0,1 12,18A5,5 0 0,1 7,13V7M17,5H21V2H17M3,5H7V2H3";
var mdiMagnetOn = "M3,7V13A9,9 0 0,0 12,22A9,9 0 0,0 21,13V7H17V13A5,5 0 0,1 12,18A5,5 0 0,1 7,13V7M17,5H21V2H17M3,5H7V2H3M13,1.5L9,9H11V14.5L15,7H13V1.5Z";
var mdiMagnify = "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z";
var mdiMagnifyClose = "M9,2A7,7 0 0,1 16,9C16,10.5 15.5,12 14.61,13.19L15.41,14H16L22,20L20,22L14,16V15.41L13.19,14.61C12,15.5 10.5,16 9,16A7,7 0 0,1 2,9A7,7 0 0,1 9,2M11.12,5.46L9,7.59L6.88,5.46L5.46,6.88L7.59,9L5.46,11.12L6.88,12.54L9,10.41L11.12,12.54L12.54,11.12L10.41,9L12.54,6.88L11.12,5.46Z";
var mdiMagnifyExpand = "M18 16H17.42L16.61 15.19C17.5 14 18 12.5 18 11C18 7.13 14.87 4 11 4C9.5 4 8 4.5 6.79 5.4C3.7 7.72 3.07 12.11 5.39 15.2C7.71 18.29 12.1 18.92 15.19 16.6L16 17.41V18L21 23L23 21L18 16M11 16C8.24 16 6 13.76 6 11S8.24 6 11 6 16 8.24 16 11 13.76 16 11 16M3 6L1 8V1H8L6 3H3V6M21 1V8L19 6V3H16L14 1H21M6 19L8 21H1V14L3 16V19H6Z";
var mdiMagnifyMinus = "M9,2A7,7 0 0,1 16,9C16,10.57 15.5,12 14.61,13.19L15.41,14H16L22,20L20,22L14,16V15.41L13.19,14.61C12,15.5 10.57,16 9,16A7,7 0 0,1 2,9A7,7 0 0,1 9,2M5,8V10H13V8H5Z";
var mdiMagnifyMinusCursor = "M11,4A7,7 0 0,1 18,11C18,12.5 17.5,14 16.61,15.19L17.42,16H18L23,21L21,23L16,18V17.41L15.19,16.6C12.1,18.92 7.71,18.29 5.39,15.2C3.07,12.11 3.7,7.72 6.79,5.4C8,4.5 9.5,4 11,4M7,10V12H15V10H7M1,1V8L8,1H1Z";
var mdiMagnifyMinusOutline = "M15.5,14H14.71L14.43,13.73C15.41,12.59 16,11.11 16,9.5A6.5,6.5 0 0,0 9.5,3A6.5,6.5 0 0,0 3,9.5A6.5,6.5 0 0,0 9.5,16C11.11,16 12.59,15.41 13.73,14.43L14,14.71V15.5L19,20.5L20.5,19L15.5,14M9.5,14C7,14 5,12 5,9.5C5,7 7,5 9.5,5C12,5 14,7 14,9.5C14,12 12,14 9.5,14M7,9H12V10H7V9Z";
var mdiMagnifyPlus = "M9,2A7,7 0 0,1 16,9C16,10.57 15.5,12 14.61,13.19L15.41,14H16L22,20L20,22L14,16V15.41L13.19,14.61C12,15.5 10.57,16 9,16A7,7 0 0,1 2,9A7,7 0 0,1 9,2M8,5V8H5V10H8V13H10V10H13V8H10V5H8Z";
var mdiMagnifyPlusCursor = "M11,4A7,7 0 0,1 18,11C18,12.5 17.5,14 16.61,15.19L17.42,16H18L23,21L21,23L16,18V17.41L15.19,16.6C12.1,18.92 7.71,18.29 5.39,15.2C3.07,12.11 3.7,7.72 6.79,5.4C8,4.5 9.5,4 11,4M10,7V10H7V12H10V15H12V12H15V10H12V7H10M1,1V8L8,1H1Z";
var mdiMagnifyPlusOutline = "M15.5,14L20.5,19L19,20.5L14,15.5V14.71L13.73,14.43C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.43,13.73L14.71,14H15.5M9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14M12,10H10V12H9V10H7V9H9V7H10V9H12V10Z";
var mdiMagnifyRemoveCursor = "M1 1V8L8 1H1M18 16H17.42L16.61 15.19C17.5 14 18 12.5 18 11C18 7.13 14.87 4 11 4C9.5 4 8 4.5 6.79 5.4C3.7 7.72 3.07 12.11 5.39 15.2C7.71 18.29 12.1 18.92 15.19 16.6L16 17.41V18L21 23L23 21L18 16M14.6 13.16L13.18 14.58L11.06 12.45L8.94 14.58L7.5 13.16L9.65 11.04L7.5 8.92L8.94 7.5L11.06 9.63L13.18 7.5L14.6 8.92L12.47 11.04L14.6 13.16Z";
var mdiMagnifyRemoveOutline = "M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.5L20.5 19L15.5 14M9.5 14C7 14 5 12 5 9.5S7 5 9.5 5 14 7 14 9.5 12 14 9.5 14M10.91 11.62L9.5 10.21L8.09 11.62L7.38 10.91L8.79 9.5L7.38 8.09L8.09 7.38L9.5 8.79L10.91 7.38L11.62 8.09L10.21 9.5L11.62 10.91L10.91 11.62Z";
var mdiMagnifyScan = "M17 22V20H20V17H22V20.5C22 20.89 21.84 21.24 21.54 21.54C21.24 21.84 20.89 22 20.5 22H17M7 22H3.5C3.11 22 2.76 21.84 2.46 21.54C2.16 21.24 2 20.89 2 20.5V17H4V20H7V22M17 2H20.5C20.89 2 21.24 2.16 21.54 2.46C21.84 2.76 22 3.11 22 3.5V7H20V4H17V2M7 2V4H4V7H2V3.5C2 3.11 2.16 2.76 2.46 2.46C2.76 2.16 3.11 2 3.5 2H7M10.5 6C13 6 15 8 15 10.5C15 11.38 14.75 12.2 14.31 12.9L17.57 16.16L16.16 17.57L12.9 14.31C12.2 14.75 11.38 15 10.5 15C8 15 6 13 6 10.5C6 8 8 6 10.5 6M10.5 8C9.12 8 8 9.12 8 10.5C8 11.88 9.12 13 10.5 13C11.88 13 13 11.88 13 10.5C13 9.12 11.88 8 10.5 8Z";
var mdiMail = "M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4M17,17H7V15H17M17,13H7V11H17M20,9H17V6H20";
var mdiMailbox = "M17,4H7A5,5 0 0,0 2,9V20H20A2,2 0 0,0 22,18V9A5,5 0 0,0 17,4M10,18H4V9A3,3 0 0,1 7,6A3,3 0 0,1 10,9V18M19,15H17V13H13V11H19V15M9,11H5V9H9V11Z";
var mdiMailboxOpen = "M8,4A5,5 0 0,0 3,9V18H1V20H21A2,2 0 0,0 23,18V9A5,5 0 0,0 18,4H8M8,6A3,3 0 0,1 11,9V18H5V9A3,3 0 0,1 8,6M14,11H20V15H18V13H14V11Z";
var mdiMailboxOpenOutline = "M14,11H20V15H18V13H14V11M18,4H8A5,5 0 0,0 3,9V18H1V20H21A2,2 0 0,0 23,18V9A5,5 0 0,0 18,4M11,18H5V9A3,3 0 0,1 8,6A3,3 0 0,1 11,9V18M21,18H13V9C13,7.92 12.65,6.86 12,6H18A3,3 0 0,1 21,9V18Z";
var mdiMailboxOpenUp = "M8,4A5,5 0 0,0 3,9V18H1V20H21A2,2 0 0,0 23,18V9A5,5 0 0,0 18,4H8M8,6A3,3 0 0,1 11,9V18H5V9A3,3 0 0,1 8,6M13,13V7H17V9H15V13H13Z";
var mdiMailboxOpenUpOutline = "M14,12.85V6.85H18V8.85H16V12.85H14M18,3.85H8A5,5 0 0,0 3,8.85V17.85H1V19.85H21A2,2 0 0,0 23,17.85V8.85A5,5 0 0,0 18,3.85M11,17.85H5V8.85A3,3 0 0,1 8,5.85A3,3 0 0,1 11,8.85V17.85M21,17.85H13V8.85C13,7.76 12.65,6.71 12,5.85H18A3,3 0 0,1 21,8.85V17.85Z";
var mdiMailboxOutline = "M17,4H7A5,5 0 0,0 2,9V20H20A2,2 0 0,0 22,18V9A5,5 0 0,0 17,4M10,18H4V9A3,3 0 0,1 7,6A3,3 0 0,1 10,9V18M20,18H12V9C12,7.92 11.65,6.86 11,6H17A3,3 0 0,1 20,9V18M13,11V13H17V15H19V11H13M9,11H5V9H9V11Z";
var mdiMailboxUp = "M5,9H9V11H5V9M22,9V18A2,2 0 0,1 20,20H2V9A5,5 0 0,1 7,4H17A5,5 0 0,1 22,9M10,9A3,3 0 0,0 7,6A3,3 0 0,0 4,9V18H10V9M16,7H12V13H14V9H16V7Z";
var mdiMailboxUpOutline = "M17,4H7A5,5 0 0,0 2,9V20H20A2,2 0 0,0 22,18V9A5,5 0 0,0 17,4M10,18H4V9A3,3 0 0,1 7,6A3,3 0 0,1 10,9V18M20,18H12V9C12,7.92 11.65,6.86 11,6H17A3,3 0 0,1 20,9V18M13,13H15V9H17V7H13V13M9,11H5V9H9V11Z";
var mdiManjaro = "M2 2V22H7.6V7.6H14.8V2H2M9.2 9.2V22H14.8V9.2H9.2M16.4 2V22H22V2H16.4Z";
var mdiMap = "M15,19L9,16.89V5L15,7.11M20.5,3C20.44,3 20.39,3 20.34,3L15,5.1L9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5A0.5,0.5 0 0,0 3.5,21C3.55,21 3.61,21 3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19 21,18.85 21,18.62V3.5A0.5,0.5 0 0,0 20.5,3Z";
var mdiMapCheck = "M18.25,22L15.5,19L16.66,17.82L18.25,19.41L21.84,15.82L23,17.23M20.5,3A0.5,0.5 0 0,1 21,3.5V13.36C20.36,13.13 19.69,13 19,13C17.46,13 16.06,13.6 15,14.56V7.1L9,5V16.9L13.04,18.3C13,18.54 13,18.77 13,19C13,19.46 13.06,19.92 13.16,20.36L9,18.9L3.66,20.97C3.59,21 3.55,21 3.5,21A0.5,0.5 0 0,1 3,20.5V5.38C3,5.15 3.16,4.97 3.35,4.9L9,3L15,5.1L20.33,3";
var mdiMapCheckOutline = "M18.25,22L15.5,19L16.66,17.82L18.25,19.41L21.84,15.82L23,17.23L18.25,22M20.5,3A0.5,0.5 0 0,1 21,3.5V13.34C20.37,13.12 19.7,13 19,13V5.7L16,6.86V13.8C15.2,14.27 14.5,14.91 14,15.68V6.87L10,5.47V17.13L13.05,18.2L13,19C13,19.46 13.05,19.92 13.15,20.35L9,18.9L3.66,20.97L3.5,21A0.5,0.5 0 0,1 3,20.5V5.38C3,5.15 3.15,4.97 3.36,4.9L9,3L15,5.1L20.34,3.03L20.5,3M5,6.46V18.31L8,17.15V5.45L5,6.46Z";
var mdiMapClock = "M15,12H16.5V16.25L19.36,17.94L18.61,19.16L15,17V12M23,16A7,7 0 0,1 16,23C13,23 10.4,21.08 9.42,18.4L8,17.9L2.66,19.97L2.5,20A0.5,0.5 0 0,1 2,19.5V4.38C2,4.15 2.15,3.97 2.36,3.9L8,2L14,4.1L19.34,2H19.5A0.5,0.5 0 0,1 20,2.5V10.25C21.81,11.5 23,13.62 23,16M9,16C9,12.83 11.11,10.15 14,9.29V6.11L8,4V15.89L9,16.24C9,16.16 9,16.08 9,16M16,11A5,5 0 0,0 11,16A5,5 0 0,0 16,21A5,5 0 0,0 21,16A5,5 0 0,0 16,11Z";
var mdiMapClockOutline = "M15,12H16.5V16.25L19.36,17.94L18.61,19.16L15,17V12M16,9C16.69,9 17.37,9.1 18,9.29V4.7L15,5.86V9.07C15.33,9 15.66,9 16,9M23,16A7,7 0 0,1 16,23C13,23 10.4,21.08 9.42,18.4L8,17.9L2.66,19.97L2.5,20A0.5,0.5 0 0,1 2,19.5V4.38C2,4.15 2.15,3.97 2.36,3.9L8,2L14,4.1L19.34,2.03L19.5,2A0.5,0.5 0 0,1 20,2.5V10.25C21.81,11.5 23,13.62 23,16M9,16C9,13.21 10.63,10.8 13,9.67V5.87L9,4.47V16.13H9C9,16.09 9,16.04 9,16M16,11A5,5 0 0,0 11,16A5,5 0 0,0 16,21A5,5 0 0,0 21,16A5,5 0 0,0 16,11M4,5.46V17.31L7,16.15V4.45L4,5.46Z";
var mdiMapLegend = "M9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5A0.5,0.5 0 0,0 3.5,21L3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19.03 21,18.85 21,18.62V3.5A0.5,0.5 0 0,0 20.5,3L20.34,3.03L15,5.1L9,3M8,5.45V17.15L5,18.31V6.46L8,5.45M10,5.47L14,6.87V18.53L10,17.13V5.47M19,5.7V17.54L16,18.55V6.86L19,5.7M7.46,6.3L5.57,6.97V9.12L7.46,8.45V6.3M7.46,9.05L5.57,9.72V11.87L7.46,11.2V9.05M7.46,11.8L5.57,12.47V14.62L7.46,13.95V11.8M7.46,14.55L5.57,15.22V17.37L7.46,16.7V14.55Z";
var mdiMapMarker = "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z";
var mdiMapMarkerAccount = "M12 2C8.14 2 5 5.14 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.14 15.86 2 12 2M12 4C13.1 4 14 4.9 14 6C14 7.11 13.1 8 12 8S10 7.11 10 6C10 4.9 10.9 4 12 4M12 14C10.33 14 8.86 13.15 8 11.85C8 10.53 10.67 9.8 12 9.8S16 10.53 16 11.85C15.14 13.15 13.67 14 12 14Z";
var mdiMapMarkerAccountOutline = "M12 4C14.8 4 17 6.2 17 9C17 11.9 14.1 16.2 12 18.9C9.9 16.2 7 11.9 7 9C7 6.2 9.2 4 12 4M12 2C8.1 2 5 5.1 5 9C5 14.2 12 22 12 22S19 14.2 19 9C19 5.1 15.9 2 12 2M12 10C13.33 10 16 10.67 16 12V12.16C15.03 13.28 13.6 14 12 14S8.97 13.28 8 12.16V12C8 10.67 10.67 10 12 10M12 9C10.9 9 10 8.1 10 7S10.9 5 12 5 14 5.9 14 7 13.1 9 12 9Z";
var mdiMapMarkerAlert = "M12 2C15.9 2 19 5.1 19 9C19 14.2 12 22 12 22S5 14.2 5 9C5 5.1 8.1 2 12 2M11 6V12H13V6H11M11 14V16H13V14H11Z";
var mdiMapMarkerAlertOutline = "M12,2A7,7 0 0,1 19,9C19,14.25 12,22 12,22C12,22 5,14.25 5,9A7,7 0 0,1 12,2M12,4A5,5 0 0,0 7,9C7,10 7,12 12,18.71C17,12 17,10 17,9A5,5 0 0,0 12,4M11,6H13V11H11V6M11,13H13V15H11V13Z";
var mdiMapMarkerCheck = "M12,2C15.86,2 19,5.14 19,9C19,14.25 12,22 12,22C12,22 5,14.25 5,9C5,5.14 8.14,2 12,2M10.47,14L17,7.41L15.6,6L10.47,11.18L8.4,9.09L7,10.5L10.47,14Z";
var mdiMapMarkerCheckOutline = "M12 4C14.8 4 17 6.2 17 9C17 11.9 14.1 16.2 12 18.9C9.9 16.2 7 11.9 7 9C7 6.2 9.2 4 12 4M12 2C8.1 2 5 5.1 5 9C5 14.2 12 22 12 22S19 14.2 19 9C19 5.1 15.9 2 12 2M11.3 14L16.2 9L14.8 7.6L11.3 11.2L9.7 9.6L8.3 11L11.3 14Z";
var mdiMapMarkerCircle = "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,12.5A1.5,1.5 0 0,1 10.5,11A1.5,1.5 0 0,1 12,9.5A1.5,1.5 0 0,1 13.5,11A1.5,1.5 0 0,1 12,12.5M12,7.2C9.9,7.2 8.2,8.9 8.2,11C8.2,14 12,17.5 12,17.5C12,17.5 15.8,14 15.8,11C15.8,8.9 14.1,7.2 12,7.2Z";
var mdiMapMarkerDistance = "M6.5,8.11C5.61,8.11 4.89,7.39 4.89,6.5A1.61,1.61 0 0,1 6.5,4.89C7.39,4.89 8.11,5.61 8.11,6.5V6.5A1.61,1.61 0 0,1 6.5,8.11M6.5,2C4,2 2,4 2,6.5C2,9.87 6.5,14.86 6.5,14.86C6.5,14.86 11,9.87 11,6.5C11,4 9,2 6.5,2M17.5,8.11A1.61,1.61 0 0,1 15.89,6.5C15.89,5.61 16.61,4.89 17.5,4.89C18.39,4.89 19.11,5.61 19.11,6.5A1.61,1.61 0 0,1 17.5,8.11M17.5,2C15,2 13,4 13,6.5C13,9.87 17.5,14.86 17.5,14.86C17.5,14.86 22,9.87 22,6.5C22,4 20,2 17.5,2M17.5,16C16.23,16 15.1,16.8 14.68,18H9.32C8.77,16.44 7.05,15.62 5.5,16.17C3.93,16.72 3.11,18.44 3.66,20C4.22,21.56 5.93,22.38 7.5,21.83C8.35,21.53 9,20.85 9.32,20H14.69C15.24,21.56 16.96,22.38 18.5,21.83C20.08,21.28 20.9,19.56 20.35,18C19.92,16.8 18.78,16 17.5,16V16M17.5,20.5A1.5,1.5 0 0,1 16,19A1.5,1.5 0 0,1 17.5,17.5A1.5,1.5 0 0,1 19,19A1.5,1.5 0 0,1 17.5,20.5Z";
var mdiMapMarkerDown = "M12 2A7 7 0 0 0 5 9C5 14.25 12 22 12 22S19 14.25 19 9A7 7 0 0 0 12 2M7.5 10H10V5H14V10H16.5L12 14.5Z";
var mdiMapMarkerLeft = "M15 11.5C13.62 11.5 12.5 10.38 12.5 9S13.62 6.5 15 6.5 17.5 7.62 17.5 9 16.38 11.5 15 11.5M8 9C8 14.25 15 22 15 22S22 14.25 22 9C22 5.13 18.87 2 15 2S8 5.13 8 9M6 7L1 12L6 17V7Z";
var mdiMapMarkerLeftOutline = "M15 6.5C16.38 6.5 17.5 7.62 17.5 9S16.38 11.5 15 11.5 12.5 10.38 12.5 9 13.62 6.5 15 6.5M15 2C18.87 2 22 5.13 22 9C22 14.25 15 22 15 22S8 14.25 8 9C8 5.13 11.13 2 15 2M10 9C10 10 10 12 15 18.71C20 12 20 10 20 9C20 6.24 17.76 4 15 4S10 6.24 10 9M6 7L1 12L6 17V7Z";
var mdiMapMarkerMinus = "M9,11.5A2.5,2.5 0 0,0 11.5,9A2.5,2.5 0 0,0 9,6.5A2.5,2.5 0 0,0 6.5,9A2.5,2.5 0 0,0 9,11.5M9,2C12.86,2 16,5.13 16,9C16,14.25 9,22 9,22C9,22 2,14.25 2,9A7,7 0 0,1 9,2M15,17H23V19H15V17Z";
var mdiMapMarkerMinusOutline = "M15 17H23V19H15V17M9 6.5C10.4 6.5 11.5 7.6 11.5 9S10.4 11.5 9 11.5 6.5 10.4 6.5 9 7.6 6.5 9 6.5M9 2C12.9 2 16 5.1 16 9C16 14.2 9 22 9 22S2 14.2 2 9C2 5.1 5.1 2 9 2M9 4C6.2 4 4 6.2 4 9C4 10 4 12 9 18.7C14 12 14 10 14 9C14 6.2 11.8 4 9 4Z";
var mdiMapMarkerMultiple = "M14,11.5A2.5,2.5 0 0,0 16.5,9A2.5,2.5 0 0,0 14,6.5A2.5,2.5 0 0,0 11.5,9A2.5,2.5 0 0,0 14,11.5M14,2C17.86,2 21,5.13 21,9C21,14.25 14,22 14,22C14,22 7,14.25 7,9A7,7 0 0,1 14,2M5,9C5,13.5 10.08,19.66 11,20.81L10,22C10,22 3,14.25 3,9C3,5.83 5.11,3.15 8,2.29C6.16,3.94 5,6.33 5,9Z";
var mdiMapMarkerMultipleOutline = "M11.5 9C11.5 7.62 12.62 6.5 14 6.5C15.1 6.5 16.03 7.21 16.37 8.19C16.45 8.45 16.5 8.72 16.5 9C16.5 10.38 15.38 11.5 14 11.5C12.91 11.5 12 10.81 11.64 9.84C11.55 9.58 11.5 9.29 11.5 9M5 9C5 13.5 10.08 19.66 11 20.81L10 22C10 22 3 14.25 3 9C3 5.83 5.11 3.15 8 2.29C6.16 3.94 5 6.33 5 9M14 2C17.86 2 21 5.13 21 9C21 14.25 14 22 14 22C14 22 7 14.25 7 9C7 5.13 10.14 2 14 2M14 4C11.24 4 9 6.24 9 9C9 10 9 12 14 18.71C19 12 19 10 19 9C19 6.24 16.76 4 14 4Z";
var mdiMapMarkerOff = "M16.37,16.1L11.75,11.47L11.64,11.36L3.27,3L2,4.27L5.18,7.45C5.06,7.95 5,8.46 5,9C5,14.25 12,22 12,22C12,22 13.67,20.15 15.37,17.65L18.73,21L20,19.72M12,6.5A2.5,2.5 0 0,1 14.5,9C14.5,9.73 14.17,10.39 13.67,10.85L17.3,14.5C18.28,12.62 19,10.68 19,9A7,7 0 0,0 12,2C10,2 8.24,2.82 6.96,4.14L10.15,7.33C10.61,6.82 11.26,6.5 12,6.5Z";
var mdiMapMarkerOffOutline = "M20 19.7L3.3 3L2 4.3L5.2 7.5C5.1 8 5 8.5 5 9C5 14.2 12 22 12 22S13.7 20.1 15.4 17.6L18.8 21L20 19.7M12 18.7C7.4 12.5 7 10.4 7 9.3L13.8 16.1C13.3 16.9 12.7 17.7 12 18.7M8.4 5.6L7 4.2C8.2 2.8 10 2 12 2C15.9 2 19 5.1 19 9C19 10.7 18.3 12.6 17.3 14.5L15.8 13C17 10.6 17 9.6 17 9C17 6.2 14.8 4 12 4C10.6 4 9.3 4.6 8.4 5.6M12 6.5C13.4 6.5 14.5 7.6 14.5 9C14.5 9.7 14.2 10.4 13.7 10.9L10.2 7.4C10.6 6.8 11.3 6.5 12 6.5Z";
var mdiMapMarkerOutline = "M12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5M12,2A7,7 0 0,1 19,9C19,14.25 12,22 12,22C12,22 5,14.25 5,9A7,7 0 0,1 12,2M12,4A5,5 0 0,0 7,9C7,10 7,12 12,18.71C17,12 17,10 17,9A5,5 0 0,0 12,4Z";
var mdiMapMarkerPath = "M18,15A3,3 0 0,1 21,18A3,3 0 0,1 18,21C16.69,21 15.58,20.17 15.17,19H14V17H15.17C15.58,15.83 16.69,15 18,15M18,17A1,1 0 0,0 17,18A1,1 0 0,0 18,19A1,1 0 0,0 19,18A1,1 0 0,0 18,17M18,8A1.43,1.43 0 0,0 19.43,6.57C19.43,5.78 18.79,5.14 18,5.14C17.21,5.14 16.57,5.78 16.57,6.57A1.43,1.43 0 0,0 18,8M18,2.57A4,4 0 0,1 22,6.57C22,9.56 18,14 18,14C18,14 14,9.56 14,6.57A4,4 0 0,1 18,2.57M8.83,17H10V19H8.83C8.42,20.17 7.31,21 6,21A3,3 0 0,1 3,18C3,16.69 3.83,15.58 5,15.17V14H7V15.17C7.85,15.47 8.53,16.15 8.83,17M6,17A1,1 0 0,0 5,18A1,1 0 0,0 6,19A1,1 0 0,0 7,18A1,1 0 0,0 6,17M6,3A3,3 0 0,1 9,6C9,7.31 8.17,8.42 7,8.83V10H5V8.83C3.83,8.42 3,7.31 3,6A3,3 0 0,1 6,3M6,5A1,1 0 0,0 5,6A1,1 0 0,0 6,7A1,1 0 0,0 7,6A1,1 0 0,0 6,5M11,19V17H13V19H11M7,13H5V11H7V13Z";
var mdiMapMarkerPlus = "M9,11.5A2.5,2.5 0 0,0 11.5,9A2.5,2.5 0 0,0 9,6.5A2.5,2.5 0 0,0 6.5,9A2.5,2.5 0 0,0 9,11.5M9,2C12.86,2 16,5.13 16,9C16,14.25 9,22 9,22C9,22 2,14.25 2,9A7,7 0 0,1 9,2M15,17H18V14H20V17H23V19H20V22H18V19H15V17Z";
var mdiMapMarkerPlusOutline = "M15 17H18V14H20V17H23V19H20V22H18V19H15V17M9 6.5C10.4 6.5 11.5 7.6 11.5 9S10.4 11.5 9 11.5 6.5 10.4 6.5 9 7.6 6.5 9 6.5M9 2C12.9 2 16 5.1 16 9C16 14.2 9 22 9 22S2 14.2 2 9C2 5.1 5.1 2 9 2M9 4C6.2 4 4 6.2 4 9C4 10 4 12 9 18.7C14 12 14 10 14 9C14 6.2 11.8 4 9 4Z";
var mdiMapMarkerQuestion = "M12,2C8.14,2 5,5.14 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9C19,5.14 15.86,2 12,2M12.88,15.75H11.13V14H12.88M12.88,12.88H11.13C11.13,10.04 13.75,10.26 13.75,8.5A1.75,1.75 0 0,0 12,6.75A1.75,1.75 0 0,0 10.25,8.5H8.5A3.5,3.5 0 0,1 12,5A3.5,3.5 0 0,1 15.5,8.5C15.5,10.69 12.88,10.91 12.88,12.88Z";
var mdiMapMarkerQuestionOutline = "M12,1C7.59,1 4,4.59 4,9C4,14.57 10.96,22.34 11.26,22.67L12,23.5L12.74,22.67C13.04,22.34 20,14.57 20,9C20,4.59 16.41,1 12,1M12,20.47C9.82,17.86 6,12.54 6,9A6,6 0 0,1 12,3A6,6 0 0,1 18,9C18,12.83 13.75,18.36 12,20.47M11.13,14H12.88V15.75H11.13M12,5A3.5,3.5 0 0,0 8.5,8.5H10.25A1.75,1.75 0 0,1 12,6.75A1.75,1.75 0 0,1 13.75,8.5C13.75,10.26 11.13,10.04 11.13,12.88H12.88C12.88,10.91 15.5,10.69 15.5,8.5A3.5,3.5 0 0,0 12,5Z";
var mdiMapMarkerRadius = "M12,2C15.31,2 18,4.66 18,7.95C18,12.41 12,19 12,19C12,19 6,12.41 6,7.95C6,4.66 8.69,2 12,2M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M20,19C20,21.21 16.42,23 12,23C7.58,23 4,21.21 4,19C4,17.71 5.22,16.56 7.11,15.83L7.75,16.74C6.67,17.19 6,17.81 6,18.5C6,19.88 8.69,21 12,21C15.31,21 18,19.88 18,18.5C18,17.81 17.33,17.19 16.25,16.74L16.89,15.83C18.78,16.56 20,17.71 20,19Z";
var mdiMapMarkerRadiusOutline = "M12 4C14.2 4 16 5.8 16 8C16 10.1 13.9 13.5 12 15.9C10.1 13.4 8 10.1 8 8C8 5.8 9.8 4 12 4M12 2C8.7 2 6 4.7 6 8C6 12.5 12 19 12 19S18 12.4 18 8C18 4.7 15.3 2 12 2M12 6C10.9 6 10 6.9 10 8S10.9 10 12 10 14 9.1 14 8 13.1 6 12 6M20 19C20 21.2 16.4 23 12 23S4 21.2 4 19C4 17.7 5.2 16.6 7.1 15.8L7.7 16.7C6.7 17.2 6 17.8 6 18.5C6 19.9 8.7 21 12 21S18 19.9 18 18.5C18 17.8 17.3 17.2 16.2 16.7L16.8 15.8C18.8 16.6 20 17.7 20 19Z";
var mdiMapMarkerRemove = "M9,2C5.14,2 2,5.14 2,9C2,14.25 9,22 9,22C9,22 16,14.25 16,9A7,7 0 0,0 9,2M9,6.5A2.5,2.5 0 0,1 11.5,9A2.5,2.5 0 0,1 9,11.5A2.5,2.5 0 0,1 6.5,9A2.5,2.5 0 0,1 9,6.5M16.58,14.16L15.17,15.58L17.58,18L15.17,20.41L16.58,21.82L19,19.41L21.41,21.82L22.83,20.41L20.41,18L22.83,15.58L21.41,14.16L19,16.58";
var mdiMapMarkerRemoveOutline = "M16.6 14.2L15.2 15.6L17.6 18L15.2 20.4L16.6 21.8L19 19.4L21.4 21.8L22.8 20.4L20.4 18L22.8 15.6L21.4 14.2L19 16.6M9 6.5C10.4 6.5 11.5 7.6 11.5 9S10.4 11.5 9 11.5 6.5 10.4 6.5 9 7.6 6.5 9 6.5M9 2C12.9 2 16 5.1 16 9C16 14.2 9 22 9 22S2 14.2 2 9C2 5.1 5.1 2 9 2M9 4C6.2 4 4 6.2 4 9C4 10 4 12 9 18.7C14 12 14 10 14 9C14 6.2 11.8 4 9 4Z";
var mdiMapMarkerRemoveVariant = "M12,2C8.14,2 5,5.14 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9C19,5.14 15.86,2 12,2M9.59,5.17L12,7.58L14.41,5.17L15.83,6.58L13.41,9L15.83,11.41L14.41,12.83L12,10.41L9.59,12.83L8.17,11.41L10.59,9L8.17,6.58";
var mdiMapMarkerRight = "M9 11.5C7.62 11.5 6.5 10.38 6.5 9S7.62 6.5 9 6.5 11.5 7.62 11.5 9 10.38 11.5 9 11.5M9 2C5.13 2 2 5.13 2 9C2 14.25 9 22 9 22S16 14.25 16 9C16 5.13 12.87 2 9 2M18 17L23 12L18 7V17Z";
var mdiMapMarkerRightOutline = "M9 6.5C10.38 6.5 11.5 7.62 11.5 9S10.38 11.5 9 11.5 6.5 10.38 6.5 9 7.62 6.5 9 6.5M9 2C12.87 2 16 5.13 16 9C16 14.25 9 22 9 22S2 14.25 2 9C2 5.13 5.13 2 9 2M9 4C6.24 4 4 6.24 4 9C4 10 4 12 9 18.71C14 12 14 10 14 9C14 6.24 11.76 4 9 4M18 17L23 12L18 7V17Z";
var mdiMapMarkerStar = "M12 2C8.1 2 5 5.1 5 9C5 14.2 12 22 12 22S19 14.2 19 9C19 5.1 15.9 2 12 2M14.5 13L12 11.5L9.5 13L10.2 10.2L8 8.3L10.9 8.1L12 5.4L13.1 8L16 8.3L13.8 10.2L14.5 13Z";
var mdiMapMarkerStarOutline = "M12 2C15.9 2 19 5.1 19 9C19 14.2 12 22 12 22S5 14.2 5 9C5 5.1 8.1 2 12 2M12 4C9.2 4 7 6.2 7 9C7 10 7 12 12 18.7C17 12 17 10 17 9C17 6.2 14.8 4 12 4M12 11.5L14.4 13L13.8 10.2L16 8.3L13.1 8.1L12 5.4L10.9 8L8 8.3L10.2 10.2L9.5 13L12 11.5Z";
var mdiMapMarkerUp = "M12 2A7 7 0 0 0 5 9C5 14.25 12 22 12 22S19 14.25 19 9A7 7 0 0 0 12 2M16.5 9H14V14H10V9H7.5L12 4.5Z";
var mdiMapMinus = "M15 18V20H23V18H15M13.16 20.36L9 18.9L3.66 20.97C3.6 21 3.55 21 3.5 21C3.22 21 3 20.78 3 20.5V5.38C3 5.15 3.16 4.97 3.36 4.9L9 3L15 5.1L20.34 3H20.5C20.78 3 21 3.22 21 3.5V13.35C20.37 13.13 19.7 13 19 13C17.46 13 16.06 13.58 15 14.54V7.1L9 5V16.9L13.04 18.32C13 18.54 13 18.77 13 19C13 19.47 13.06 19.92 13.16 20.36Z";
var mdiMapOutline = "M20.5,3L20.34,3.03L15,5.1L9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5A0.5,0.5 0 0,0 3.5,21L3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19.03 21,18.85 21,18.62V3.5A0.5,0.5 0 0,0 20.5,3M10,5.47L14,6.87V18.53L10,17.13V5.47M5,6.46L8,5.45V17.15L5,18.31V6.46M19,17.54L16,18.55V6.86L19,5.7V17.54Z";
var mdiMapPlus = "M9,3L3.36,4.9C3.16,4.97 3,5.15 3,5.38V20.5A0.5,0.5 0 0,0 3.5,21C3.55,21 3.6,21 3.66,20.97L9,18.9L13.16,20.36C13.06,19.92 13,19.46 13,19C13,18.77 13,18.54 13.04,18.3L9,16.9V5L15,7.1V14.56C16.07,13.6 17.47,13 19,13C19.7,13 20.37,13.13 21,13.36V3.5A0.5,0.5 0 0,0 20.5,3H20.34L15,5.1L9,3M18,15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiMapSearch = "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14M14,6.11L8,4V15.89L9,16.24V16.5C9,17.14 9.09,17.76 9.26,18.34L8,17.9L2.66,19.97L2.5,20A0.5,0.5 0 0,1 2,19.5V4.38C2,4.15 2.15,3.97 2.36,3.9L8,2L14,4.1L19.34,2H19.5A0.5,0.5 0 0,1 20,2.5V11.81C18.83,10.69 17.25,10 15.5,10C15,10 14.5,10.06 14,10.17V6.11Z";
var mdiMapSearchOutline = "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.2 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14M19.5,2A0.5,0.5 0 0,1 20,2.5V11.81C19.42,11.26 18.75,10.81 18,10.5V4.7L15,5.86V10C14.3,10.07 13.62,10.24 13,10.5V5.87L9,4.47V16.13H9V16.5C9,17.14 9.09,17.76 9.26,18.34L8,17.9L2.66,19.97L2.5,20A0.5,0.5 0 0,1 2,19.5V4.38C2,4.15 2.15,3.97 2.36,3.9L8,2L14,4.1L19.34,2.03L19.5,2M4,5.46V17.31L7,16.15V4.45L4,5.46Z";
var mdiMapbox = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M16.75,14.45C18.65,12.55 18.58,9.39 16.59,7.41C14.6,5.43 11.45,5.35 9.55,7.25C6.12,10.68 7.22,16.78 7.22,16.78C7.22,16.78 13.33,17.87 16.75,14.45M13.15,7.86L14.13,9.87L16.14,10.85L14.13,11.83L13.15,13.84L12.17,11.83L10.16,10.85L12.17,9.87L13.15,7.86Z";
var mdiMargin = "M20,4V9L18.5,7.5L5.5,20.5L3.5,18.5L16.5,5.5L15,4H20M17,20A3,3 0 0,1 14,17V15A3,3 0 0,1 17,12A3,3 0 0,1 20,15V17A3,3 0 0,1 17,20M17,14A1,1 0 0,0 16,15V17A1,1 0 0,0 17,18A1,1 0 0,0 18,17V15A1,1 0 0,0 17,14M7,12A3,3 0 0,1 4,9V7A3,3 0 0,1 7,4A3,3 0 0,1 10,7V9A3,3 0 0,1 7,12M7,6A1,1 0 0,0 6,7V9A1,1 0 0,0 7,10A1,1 0 0,0 8,9V7A1,1 0 0,0 7,6Z";
var mdiMarker = "M18.5,1.15C17.97,1.15 17.46,1.34 17.07,1.73L11.26,7.55L16.91,13.2L22.73,7.39C23.5,6.61 23.5,5.35 22.73,4.56L19.89,1.73C19.5,1.34 19,1.15 18.5,1.15M10.3,8.5L4.34,14.46C3.56,15.24 3.56,16.5 4.36,17.31C3.14,18.54 1.9,19.77 0.67,21H6.33L7.19,20.14C7.97,20.9 9.22,20.89 10,20.12L15.95,14.16";
var mdiMarkerCancel = "M17.5,13C20,13 22,15 22,17.5C22,20 20,22 17.5,22C15,22 13,20 13,17.5C13,15 15,13 17.5,13M17.5,14.5C16.94,14.5 16.42,14.65 16,14.92L20.08,19C20.35,18.58 20.5,18.06 20.5,17.5A3,3 0 0,0 17.5,14.5M14.5,17.5A3,3 0 0,0 17.5,20.5C18.06,20.5 18.58,20.35 19,20.08L14.92,16C14.65,16.42 14.5,16.94 14.5,17.5M18.5,1.15C19,1.15 19.5,1.34 19.89,1.73L22.73,4.56C23.5,5.35 23.5,6.61 22.73,7.39L18.95,11.16C18.5,11.06 18,11 17.5,11C16.67,11 15.88,11.16 15.15,11.44L11.26,7.55L17.07,1.73C17.46,1.34 17.97,1.15 18.5,1.15M10.3,8.5L13.89,12.1C12.15,13.26 11,15.25 11,17.5C11,18 11.06,18.5 11.16,18.95L10,20.12C9.22,20.89 7.97,20.9 7.19,20.14L6.33,21H0.67L4.36,17.31C3.56,16.5 3.56,15.24 4.34,14.46L10.3,8.5Z";
var mdiMarkerCheck = "M10,16L5,11L6.41,9.58L10,13.17L17.59,5.58L19,7M19,1H5C3.89,1 3,1.89 3,3V15.93C3,16.62 3.35,17.23 3.88,17.59L12,23L20.11,17.59C20.64,17.23 21,16.62 21,15.93V3C21,1.89 20.1,1 19,1Z";
var mdiMastodon = "M20.94,14C20.66,15.41 18.5,16.96 15.97,17.26C14.66,17.41 13.37,17.56 12,17.5C9.75,17.39 8,16.96 8,16.96V17.58C8.32,19.8 10.22,19.93 12.03,20C13.85,20.05 15.47,19.54 15.47,19.54L15.55,21.19C15.55,21.19 14.27,21.87 12,22C10.75,22.07 9.19,21.97 7.38,21.5C3.46,20.45 2.78,16.26 2.68,12L2.67,8.57C2.67,4.23 5.5,2.96 5.5,2.96C6.95,2.3 9.41,2 11.97,2H12.03C14.59,2 17.05,2.3 18.5,2.96C18.5,2.96 21.33,4.23 21.33,8.57C21.33,8.57 21.37,11.78 20.94,14M18,8.91C18,7.83 17.7,7 17.15,6.35C16.59,5.72 15.85,5.39 14.92,5.39C13.86,5.39 13.05,5.8 12.5,6.62L12,7.5L11.5,6.62C10.94,5.8 10.14,5.39 9.07,5.39C8.15,5.39 7.41,5.72 6.84,6.35C6.29,7 6,7.83 6,8.91V14.17H8.1V9.06C8.1,8 8.55,7.44 9.46,7.44C10.46,7.44 10.96,8.09 10.96,9.37V12.16H13.03V9.37C13.03,8.09 13.53,7.44 14.54,7.44C15.44,7.44 15.89,8 15.89,9.06V14.17H18V8.91Z";
var mdiMaterialDesign = "M21,12C21,9.97 20.33,8.09 19,6.38V17.63C20.33,15.97 21,14.09 21,12M17.63,19H6.38C7.06,19.55 7.95,20 9.05,20.41C10.14,20.8 11.13,21 12,21C12.88,21 13.86,20.8 14.95,20.41C16.05,20 16.94,19.55 17.63,19M11,17L7,9V17H11M17,9L13,17H17V9M12,14.53L15.75,7H8.25L12,14.53M17.63,5C15.97,3.67 14.09,3 12,3C9.91,3 8.03,3.67 6.38,5H17.63M5,17.63V6.38C3.67,8.09 3,9.97 3,12C3,14.09 3.67,15.97 5,17.63M23,12C23,15.03 21.94,17.63 19.78,19.78C17.63,21.94 15.03,23 12,23C8.97,23 6.38,21.94 4.22,19.78C2.06,17.63 1,15.03 1,12C1,8.97 2.06,6.38 4.22,4.22C6.38,2.06 8.97,1 12,1C15.03,1 17.63,2.06 19.78,4.22C21.94,6.38 23,8.97 23,12Z";
var mdiMaterialUi = "M8,16.61V15.37L14,11.91V7.23L9,10.12L4,7.23V13L3,13.58L2,13V5L3.07,4.38L9,7.81L12.93,5.54L14.93,4.38L16,5V13.06L10.92,16L14.97,18.33L20,15.43V11L21,10.42L22,11V16.58L14.97,20.64L8,16.61M22,9.75L21,10.33L20,9.75V8.58L21,8L22,8.58V9.75Z";
var mdiMathCompass = "M20,19.88V22L18.2,20.83L13.41,11.83C14.07,11.62 14.67,11.28 15.19,10.83L20,19.88M15,7A3,3 0 0,1 12,10C11.85,10 11.71,10 11.56,10L5.8,20.83L4,22V19.88L9.79,9C8.69,7.77 8.79,5.87 10.03,4.76C10.57,4.28 11.27,4 12,4V2A1,1 0 0,1 13,3V4.18C14.2,4.6 15,5.73 15,7M13,7A1,1 0 0,0 12,6A1,1 0 0,0 11,7A1,1 0 0,0 12,8A1,1 0 0,0 13,7Z";
var mdiMathCos = "M4,7A2,2 0 0,0 2,9V15A2,2 0 0,0 4,17H6A2,2 0 0,0 8,15V14H6V15H4V9H6V10H8V9A2,2 0 0,0 6,7H4M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11M11,9H13V15H11V9M18,7A2,2 0 0,0 16,9V11A2,2 0 0,0 18,13H20V15H16V17H20A2,2 0 0,0 22,15V13A2,2 0 0,0 20,11H18V9H22V7H18Z";
var mdiMathIntegral = "M11.5 19.1C11.3 20.2 10.9 21 10.2 21.5C9.5 22 8.6 22.1 7.5 21.9C7.1 21.8 6.3 21.7 6 21.5L6.5 20C6.8 20.1 7.4 20.3 7.7 20.3C8.8 20.5 9.4 20 9.6 18.8L12 5.2C12.2 4 12.7 3.2 13.4 2.6C14.1 2.1 15.1 1.9 16.2 2.1C16.6 2.2 17.4 2.3 18 2.6L17.5 4C17.3 3.9 16.6 3.8 16.3 3.7C15 3.5 14.3 4.1 14 5.6L11.5 19.1Z";
var mdiMathIntegralBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M15.9 6.9C15.9 6.9 15.2 6.6 14.9 6.6C14.3 6.5 13.9 6.7 13.7 7.7L12 16.8C11.8 17.6 11.5 18.2 11 18.6C10.6 18.9 10.2 19 9.7 19C8.9 19 7.7 18.5 7.7 18.5L8.2 17.1C8.2 17.1 9 17.4 9.2 17.4C9.5 17.5 9.7 17.4 9.9 17.3C10.1 17.2 10.2 16.9 10.3 16.6L11.9 7.4C12 6.6 12.4 6 12.9 5.5C13.5 5.1 14.2 5 15 5.1C15.7 5.2 16.5 5.6 16.5 5.6L15.9 6.9Z";
var mdiMathLog = "M18 7C16.9 7 16 7.9 16 9V15C16 16.1 16.9 17 18 17H20C21.1 17 22 16.1 22 15V11H20V15H18V9H22V7H18M2 7V17H8V15H4V7H2M11 7C9.9 7 9 7.9 9 9V15C9 16.1 9.9 17 11 17H13C14.1 17 15 16.1 15 15V9C15 7.9 14.1 7 13 7H11M11 9H13V15H11V9Z";
var mdiMathNorm = "M14 21V3H16V21H14M8 21V3H10V21H8Z";
var mdiMathNormBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M10 18H8V6H10V18M16 18H14V6H16V18Z";
var mdiMathSin = "M4,7A2,2 0 0,0 2,9V11A2,2 0 0,0 4,13H6V15H2V17H6A2,2 0 0,0 8,15V13A2,2 0 0,0 6,11H4V9H8V7H4M14,7V9H13V15H14V17H10V15H11V9H10V7H14M16,7V17H18V12L20,17H22V7H20V12L18,7H16Z";
var mdiMathTan = "M2,7V9H4V17H6V9H8V7H2M11,7A2,2 0 0,0 9,9V17H11V13H13V17H15V9A2,2 0 0,0 13,7H11M11,9H13V11H11V9M16,7V17H18V12L20,17H22V7H20V12L18,7H16Z";
var mdiMatrix = "M2,2H6V4H4V20H6V22H2V2M20,4H18V2H22V22H18V20H20V4M9,5H10V10H11V11H8V10H9V6L8,6.5V5.5L9,5M15,13H16V18H17V19H14V18H15V14L14,14.5V13.5L15,13M9,13C10.1,13 11,14.34 11,16C11,17.66 10.1,19 9,19C7.9,19 7,17.66 7,16C7,14.34 7.9,13 9,13M9,14C8.45,14 8,14.9 8,16C8,17.1 8.45,18 9,18C9.55,18 10,17.1 10,16C10,14.9 9.55,14 9,14M15,5C16.1,5 17,6.34 17,8C17,9.66 16.1,11 15,11C13.9,11 13,9.66 13,8C13,6.34 13.9,5 15,5M15,6C14.45,6 14,6.9 14,8C14,9.1 14.45,10 15,10C15.55,10 16,9.1 16,8C16,6.9 15.55,6 15,6Z";
var mdiMedal = "M20,2H4V4L9.81,8.36C6.14,9.57 4.14,13.53 5.35,17.2C6.56,20.87 10.5,22.87 14.19,21.66C17.86,20.45 19.86,16.5 18.65,12.82C17.95,10.71 16.3,9.05 14.19,8.36L20,4V2M14.94,19.5L12,17.78L9.06,19.5L9.84,16.17L7.25,13.93L10.66,13.64L12,10.5L13.34,13.64L16.75,13.93L14.16,16.17L14.94,19.5Z";
var mdiMedalOutline = "M14.94 19.5L12 17.77L9.06 19.5L9.84 16.16L7.25 13.92L10.66 13.63L12 10.5L13.34 13.63L16.75 13.92L14.16 16.16M20 2H4V4L8.86 7.64A8 8 0 1 0 15.14 7.64L20 4M18 15A6 6 0 1 1 10.82 9.12A5.86 5.86 0 0 1 13.18 9.12A6 6 0 0 1 18 15M12.63 7H11.37L7.37 4H16.71Z";
var mdiMedicalBag = "M10,3L8,5V7H5C3.85,7 3.12,8 3,9L2,19C1.88,20 2.54,21 4,21H20C21.46,21 22.12,20 22,19L21,9C20.88,8 20.06,7 19,7H16V5L14,3H10M10,5H14V7H10V5M11,10H13V13H16V15H13V18H11V15H8V13H11V10Z";
var mdiMedicalCottonSwab = "M3 3H15V5H3V3M2 21H16V6H2V21M5 12H7.5V9.5H10.5V12H13V15H10.5V17.5H7.5V15H5V12M20 6C18.3 6 17 7.8 17 10C17 11.8 17.8 13.2 19 13.8V21H21V13.8C22.2 13.3 23 11.8 23 10C23 7.8 21.7 6 20 6Z";
var mdiMedication = "M6 3H18V5H6V3M17 6H7C5.9 6 5 6.9 5 8V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V8C19 6.9 18.1 6 17 6M16 15H13.5V17.5H10.5V15H8V12H10.5V9.5H13.5V12H16V15Z";
var mdiMedicationOutline = "M10.5 15H8V12H10.5V9.5H13.5V12H16V15H13.5V17.5H10.5V15M19 8V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V8C5 6.9 5.9 6 7 6H17C18.1 6 19 6.9 19 8M17 8H7V19H17V8M18 3H6V5H18V3";
var mdiMeditation = "M12 4C13.11 4 14 4.89 14 6S13.11 8 12 8 10 7.11 10 6 10.9 4 12 4M21 16V14C18.76 14 16.84 13.04 15.4 11.32L14.06 9.72C13.68 9.26 13.12 9 12.53 9H11.5C10.89 9 10.33 9.26 9.95 9.72L8.61 11.32C7.16 13.04 5.24 14 3 14V16C5.77 16 8.19 14.83 10 12.75V15L6.12 16.55C5.45 16.82 5 17.5 5 18.21C5 19.2 5.8 20 6.79 20H9V19.5C9 18.12 10.12 17 11.5 17H14.5C14.78 17 15 17.22 15 17.5S14.78 18 14.5 18H11.5C10.67 18 10 18.67 10 19.5V20H17.21C18.2 20 19 19.2 19 18.21C19 17.5 18.55 16.82 17.88 16.55L14 15V12.75C15.81 14.83 18.23 16 21 16Z";
var mdiMemory = "M17,17H7V7H17M21,11V9H19V7C19,5.89 18.1,5 17,5H15V3H13V5H11V3H9V5H7C5.89,5 5,5.89 5,7V9H3V11H5V13H3V15H5V17A2,2 0 0,0 7,19H9V21H11V19H13V21H15V19H17A2,2 0 0,0 19,17V15H21V13H19V11M13,13H11V11H13M15,9H9V15H15V9Z";
var mdiMemoryArrowDown = "M19 19V15H17V19H15L18 22L21 19H19M12.1 19H11V21H9V19H7C5.9 19 5 18.1 5 17V15H3V13H5V11H3V9H5V7C5 5.9 5.9 5 7 5H9V3H11V5H13V3H15V5H17C18.1 5 19 5.9 19 7V9H21V11H19V12.1C18.7 12 18.3 12 18 12S17.3 12 17 12.1V7H7V17H12.1C12 17.3 12 17.7 12 18S12 18.7 12.1 19M9 15H12.8C13.3 14.1 14.1 13.3 15 12.8V9H9V15M11 11H13V13H11V11Z";
var mdiMenorah = "M21 11V6L19 5V11H17V6L15 5V11H13V3L11 2V11H9V6L7 5V11H5V6L3 5V11C2.45 11 2 11.45 2 12S2.45 13 3 13H4.25C4.95 14.92 6.94 17.58 11 17.95V20H10C8.9 20 8 20.9 8 22H16C16 20.9 15.11 20 14 20H13V17.95C17.06 17.57 19.05 14.92 19.75 13H21C21.55 13 22 12.55 22 12S21.55 11 21 11M11 15.94C8.34 15.63 7.05 14.11 6.45 13H11V15.94M13 15.94V13H17.55C16.95 14.11 15.66 15.63 13 15.94Z";
var mdiMenorahFire = "M21.5 11.15V10C21.5 9.45 21.05 9 20.5 9H19.5C18.95 9 18.5 9.45 18.5 10V11H17.5V10C17.5 9.45 17.05 9 16.5 9H15.5C14.95 9 14.5 9.45 14.5 10V11H13.5V8C13.5 7.45 13.05 7 12.5 7H11.5C10.95 7 10.5 7.45 10.5 8V11H9.5V10C9.5 9.45 9.05 9 8.5 9H7.5C6.95 9 6.5 9.45 6.5 10V11H5.5V10C5.5 9.45 5.05 9 4.5 9H3.5C2.95 9 2.5 9.45 2.5 10V11.15C2.21 11.33 2 11.63 2 12C2 12.55 2.45 13 3 13H4.25C4.95 14.92 6.94 17.58 11 17.95V20H10C8.9 20 8 20.9 8 22H16C16 20.9 15.11 20 14 20H13V17.95C17.06 17.57 19.05 14.92 19.75 13H21C21.55 13 22 12.55 22 12C22 11.63 21.79 11.33 21.5 11.15M6.45 13H11V15.94C8.34 15.63 7.05 14.11 6.45 13M13 15.94V13H17.55C16.95 14.11 15.66 15.63 13 15.94M12 6C12.83 6 13.5 5.33 13.5 4.5C13.5 3.67 12.83 2 12 2S10.5 3.67 10.5 4.5C10.5 5.33 11.17 6 12 6M12 4.25C12.28 4.25 12.5 4.47 12.5 4.75S12.28 5.25 12 5.25 11.5 5.03 11.5 4.75 11.72 4.25 12 4.25M16 8C16.83 8 17.5 7.33 17.5 6.5C17.5 5.67 16.83 4 16 4S14.5 5.67 14.5 6.5C14.5 7.33 15.17 8 16 8M16 6.25C16.28 6.25 16.5 6.47 16.5 6.75S16.28 7.25 16 7.25 15.5 7.03 15.5 6.75 15.72 6.25 16 6.25M20 8C20.83 8 21.5 7.33 21.5 6.5C21.5 5.67 20.83 4 20 4S18.5 5.67 18.5 6.5C18.5 7.33 19.17 8 20 8M20 6.25C20.28 6.25 20.5 6.47 20.5 6.75S20.28 7.25 20 7.25 19.5 7.03 19.5 6.75 19.72 6.25 20 6.25M4 8C4.83 8 5.5 7.33 5.5 6.5C5.5 5.67 4.83 4 4 4S2.5 5.67 2.5 6.5C2.5 7.33 3.17 8 4 8M4 6.25C4.28 6.25 4.5 6.47 4.5 6.75S4.28 7.25 4 7.25 3.5 7.03 3.5 6.75 3.72 6.25 4 6.25M8 8C8.83 8 9.5 7.33 9.5 6.5C9.5 5.67 8.83 4 8 4S6.5 5.67 6.5 6.5C6.5 7.33 7.17 8 8 8M8 6.25C8.28 6.25 8.5 6.47 8.5 6.75S8.28 7.25 8 7.25 7.5 7.03 7.5 6.75 7.72 6.25 8 6.25Z";
var mdiMenu = "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z";
var mdiMenuClose = "M3 6H13V8H3V6M3 16H13V18H3V16M3 11H15V13H3V11M16 7L14.58 8.39L18.14 12L14.58 15.61L16 17L21 12L16 7Z";
var mdiMenuDown = "M7,10L12,15L17,10H7Z";
var mdiMenuDownOutline = "M18,9V10.5L12,16.5L6,10.5V9H18M12,13.67L14.67,11H9.33L12,13.67Z";
var mdiMenuLeft = "M14,7L9,12L14,17V7Z";
var mdiMenuLeftOutline = "M15,18H13.5L7.5,12L13.5,6H15V18M10.33,12L13,14.67V9.33L10.33,12Z";
var mdiMenuOpen = "M21,15.61L19.59,17L14.58,12L19.59,7L21,8.39L17.44,12L21,15.61M3,6H16V8H3V6M3,13V11H13V13H3M3,18V16H16V18H3Z";
var mdiMenuRight = "M10,17L15,12L10,7V17Z";
var mdiMenuRightOutline = "M9,6H10.5L16.5,12L10.5,18H9V6M13.67,12L11,9.33V14.67L13.67,12Z";
var mdiMenuSwap = "M12,6L7,11H17L12,6M7,13L12,18L17,13H7Z";
var mdiMenuSwapOutline = "M12,3.5L6,9.5V11H18V9.5L12,3.5M12,6.33L14.67,9H9.33L12,6.33M6,13V14.5L12,20.5L18,14.5V13H6M9.33,15H14.67L12,17.67L9.33,15Z";
var mdiMenuUp = "M7,15L12,10L17,15H7Z";
var mdiMenuUpOutline = "M18,16V14.5L12,8.5L6,14.5V16H18M12,11.33L14.67,14H9.33L12,11.33Z";
var mdiMerge = "M8 17L12 13H15.2C15.6 14.2 16.7 15 18 15C19.7 15 21 13.7 21 12S19.7 9 18 9C16.7 9 15.6 9.8 15.2 11H12L8 7V3H3V8H6L10.2 12L6 16H3V21H8V17Z";
var mdiMessage = "M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z";
var mdiMessageAlert = "M13 11H11V5H13M13 15H11V13H13M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z";
var mdiMessageAlertOutline = "M13,10H11V6H13V10M13,12H11V14H13V12M22,4V16A2,2 0 0,1 20,18H6L2,22V4A2,2 0 0,1 4,2H20A2,2 0 0,1 22,4M20,4H4V17.2L5.2,16H20V4Z";
var mdiMessageArrowLeft = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M16 11H11.5L13.3 12.8L12 14L8 10L12 6L13.2 7.2L11.5 9H16V11Z";
var mdiMessageArrowLeftOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M16 11V9H11.5L13.3 7.2L12 6L8 10L12 14L13.2 12.8L11.5 11H16Z";
var mdiMessageArrowRight = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M12 14L10.8 12.8L12.6 11H8V9H12.5L10.7 7.2L12 6L16 10L12 14Z";
var mdiMessageArrowRightOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M8 9V11H12.5L10.7 12.8L12 14L16 10L12 6L10.8 7.2L12.5 9H8Z";
var mdiMessageBadge = "M22 7V16C22 17.1 21.1 18 20 18H6L2 22V4C2 2.9 2.9 2 4 2H14.1C14 2.3 14 2.7 14 3C14 5.8 16.2 8 19 8C20.1 8 21.2 7.6 22 7M16 3C16 4.7 17.3 6 19 6S22 4.7 22 3 20.7 0 19 0 16 1.3 16 3Z";
var mdiMessageBadgeOutline = "M22 7V16C22 17.1 21.1 18 20 18H6L2 22V4C2 2.9 2.9 2 4 2H14.1C14 2.3 14 2.7 14 3S14 3.7 14.1 4H4V16H20V7.9C20.7 7.8 21.4 7.4 22 7M16 3C16 4.7 17.3 6 19 6S22 4.7 22 3 20.7 0 19 0 16 1.3 16 3Z";
var mdiMessageBookmark = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M19 13L16.5 11.5L14 13V5H19V13Z";
var mdiMessageBookmarkOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M18 14V6H13V14L15.5 12.5L18 14";
var mdiMessageBulleted = "M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M8,14H6V12H8V14M8,11H6V9H8V11M8,8H6V6H8V8M15,14H10V12H15V14M18,11H10V9H18V11M18,8H10V6H18V8Z";
var mdiMessageBulletedOff = "M1.27,1.73L0,3L2,5V22L6,18H15L20.73,23.73L22,22.46L1.27,1.73M8,14H6V12H8V14M6,11V9L8,11H6M20,2H4.08L10,7.92V6H18V8H10.08L11.08,9H18V11H13.08L20.07,18C21.14,17.95 22,17.08 22,16V4A2,2 0 0,0 20,2Z";
var mdiMessageCheck = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.11 18 22 17.11 22 16V4C22 2.89 21.1 2 20 2M10.47 14L7 10.5L8.4 9.09L10.47 11.17L15.6 6L17 7.41L10.47 14Z";
var mdiMessageCheckOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M10.47 14L7 10.5L8.4 9.09L10.47 11.17L15.6 6L17 7.41L10.47 14Z";
var mdiMessageCog = "M13.5,10A1.5,1.5 0 0,1 12,11.5C11.16,11.5 10.5,10.83 10.5,10A1.5,1.5 0 0,1 12,8.5A1.5,1.5 0 0,1 13.5,10M22,4V16A2,2 0 0,1 20,18H6L2,22V4A2,2 0 0,1 4,2H20A2,2 0 0,1 22,4M16.77,11.32L15.7,10.5C15.71,10.33 15.71,10.16 15.7,10C15.72,9.84 15.72,9.67 15.7,9.5L16.76,8.68C16.85,8.6 16.88,8.47 16.82,8.36L15.82,6.63C15.76,6.5 15.63,6.47 15.5,6.5L14.27,7C14,6.8 13.73,6.63 13.42,6.5L13.23,5.19C13.21,5.08 13.11,5 13,5H11C10.88,5 10.77,5.09 10.75,5.21L10.56,6.53C10.26,6.65 9.97,6.81 9.7,7L8.46,6.5C8.34,6.46 8.21,6.5 8.15,6.61L7.15,8.34C7.09,8.45 7.11,8.58 7.21,8.66L8.27,9.5C8.23,9.82 8.23,10.16 8.27,10.5L7.21,11.32C7.12,11.4 7.09,11.53 7.15,11.64L8.15,13.37C8.21,13.5 8.34,13.53 8.46,13.5L9.7,13C9.96,13.2 10.24,13.37 10.55,13.5L10.74,14.81C10.77,14.93 10.88,15 11,15H13C13.12,15 13.23,14.91 13.25,14.79L13.44,13.47C13.74,13.34 14,13.18 14.28,13L15.53,13.5C15.65,13.5 15.78,13.5 15.84,13.37L16.84,11.64C16.9,11.53 16.87,11.4 16.77,11.32Z";
var mdiMessageCogOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M16.8 11.3L15.7 10.5V10 9.5L16.8 8.7C16.9 8.6 16.9 8.5 16.9 8.4L15.9 6.7C15.8 6.6 15.7 6.5 15.6 6.6L14.3 7C14 6.8 13.8 6.6 13.4 6.5L13.2 5.2C13.2 5.1 13.1 5 13 5H11C10.9 5 10.8 5.1 10.8 5.2L10.6 6.5C10.3 6.7 10 6.8 9.7 7L8.5 6.5C8.4 6.5 8.3 6.5 8.2 6.6L7.2 8.3C7.1 8.4 7.2 8.5 7.3 8.6L8.4 9.4V10.4L7.3 11.2C7.2 11.3 7.2 11.4 7.2 11.5L8.2 13.2C8.3 13.3 8.4 13.4 8.5 13.3L9.7 13C10 13.2 10.2 13.4 10.5 13.5L10.7 14.8C10.7 14.9 10.8 15 11 15H13C13.1 15 13.2 14.9 13.2 14.8L13.4 13.5C13.7 13.4 14 13.2 14.2 13L15.4 13.5C15.5 13.5 15.6 13.5 15.7 13.4L16.7 11.7C16.9 11.5 16.9 11.4 16.8 11.3M12 11.5C11.2 11.5 10.5 10.8 10.5 10S11.2 8.5 12 8.5 13.5 9.2 13.5 10 12.8 11.5 12 11.5Z";
var mdiMessageDraw = "M18,14H10.5L12.5,12H18M6,14V11.5L12.88,4.64C13.07,4.45 13.39,4.45 13.59,4.64L15.35,6.41C15.55,6.61 15.55,6.92 15.35,7.12L8.47,14M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z";
var mdiMessageFast = "M3 7C2.4 7 2 7.4 2 8S2.4 9 3 9H5V7H3M2 11C1.4 11 1 11.4 1 12S1.4 13 2 13H5V11H2M1 15C.4 15 0 15.4 0 16C0 16.6 .4 17 1 17H5V15H1M20 5H9C7.9 5 7 5.9 7 7V21L11 17H20C21.1 17 22 16.1 22 15V7C22 5.9 21.1 5 20 5Z";
var mdiMessageFastOutline = "M20 5H9C7.9 5 7 5.9 7 7V21L11 17H20C21.1 17 22 16.1 22 15V7C22 5.9 21.1 5 20 5M20 15H10.2L9 16.2V7H20V15M3 7C2.4 7 2 7.4 2 8S2.4 9 3 9H5V7H3M2 11C1.4 11 1 11.4 1 12S1.4 13 2 13H5V11H2M1 15C.4 15 0 15.4 0 16C0 16.6 .4 17 1 17H5V15H1Z";
var mdiMessageFlash = "M22 4C22 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V22L6 18H15V10H22V4M22.5 16H20.3L22 12H17V18H19V23L22.5 16Z";
var mdiMessageFlashOutline = "M4 17.2V4H20V10H22V4C22 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V22L6 18H15V16H5.2L4 17.2M22.5 16H20.3L22 12H17V18H19V23L22.5 16Z";
var mdiMessageImage = "M5,14L8.5,9.5L11,12.5L14.5,8L19,14M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z";
var mdiMessageImageOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M5 14L8.5 9.5L11 12.5L14.5 8L19 14";
var mdiMessageLock = "M20.5 0A2.5 2.5 0 0 0 18 2.5V3A1 1 0 0 0 17 4V8A1 1 0 0 0 18 9H23A1 1 0 0 0 24 8V4A1 1 0 0 0 23 3V2.5A2.5 2.5 0 0 0 20.5 0M20.5 1A1.5 1.5 0 0 1 22 2.5V3H19V2.5A1.5 1.5 0 0 1 20.5 1M4 2A2 2 0 0 0 2 4V22L6 18H20A2 2 0 0 0 22 16V11H17C15.89 11 15 10.11 15 9V2H4Z";
var mdiMessageLockOutline = "M23 3V2.5C23 1.1 21.9 0 20.5 0S18 1.1 18 2.5V3C17.5 3 17 3.5 17 4V8C17 8.5 17.5 9 18 9H23C23.5 9 24 8.5 24 8V4C24 3.5 23.5 3 23 3M22 3H19V2.5C19 1.7 19.7 1 20.5 1S22 1.7 22 2.5V3M22 11V16C22 17.1 21.1 18 20 18H6L2 22V4C2 2.9 2.9 2 4 2H15V4H4V17.2L5.2 16H20V11H22Z";
var mdiMessageMinus = "M20 2C21.11 2 22 2.9 22 4V16C22 17.11 21.11 18 20 18H6L2 22V4C2 2.89 2.9 2 4 2H20M8 9V11H16V9H8Z";
var mdiMessageMinusOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M8 9V11H16V9H8Z";
var mdiMessageOff = "M20.95 17.75L5.2 2H20C21.1 2 22 2.89 22 4V16C22 16.76 21.57 17.41 20.95 17.75M2.39 1.73L1.11 3L2 3.9C2 3.93 2 3.97 2 4V22L6 18H16.11L20.84 22.73L22.11 21.46L2.39 1.73Z";
var mdiMessageOffOutline = "M7.2 4L5.2 2H20C21.11 2 22 2.9 22 4V16C22 16.76 21.57 17.41 20.95 17.75L19.2 16H20V4H7.2M22.11 21.46L20.84 22.73L16.11 18H6L2 22V4C2 3.97 2 3.93 2 3.9L1.11 3L2.39 1.73L6.1 5.44L16.65 16H16.66L18.66 18H18.65L22.11 21.46M14.11 16L4 5.89V18L6 16H14.11Z";
var mdiMessageOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16Z";
var mdiMessagePlus = "M20,2A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H6L2,22V4C2,2.89 2.9,2 4,2H20M11,6V9H8V11H11V14H13V11H16V9H13V6H11Z";
var mdiMessagePlusOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M16 9V11H13V14H11V11H8V9H11V6H13V9H16Z";
var mdiMessageProcessing = "M17,11H15V9H17M13,11H11V9H13M9,11H7V9H9M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z";
var mdiMessageProcessingOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M17 11H15V9H17M13 11H11V9H13M9 11H7V9H9";
var mdiMessageQuestion = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M13 14H11V12H13V14M14.8 9C14.5 9.4 14.1 9.6 13.7 9.8C13.4 10 13.3 10.1 13.2 10.3C13 10.5 13 10.7 13 11H11C11 10.5 11.1 10.2 11.3 9.9C11.5 9.7 11.9 9.4 12.4 9.1C12.7 9 12.9 8.8 13 8.6C13.1 8.4 13.2 8.1 13.2 7.9C13.2 7.6 13.1 7.4 12.9 7.2C12.7 7 12.4 6.9 12.1 6.9C11.8 6.9 11.6 7 11.4 7.1C11.2 7.2 11.1 7.4 11.1 7.7H9.1C9.2 7 9.5 6.4 10 6C10.5 5.6 11.2 5.5 12.1 5.5C13 5.5 13.8 5.7 14.3 6.1C14.8 6.5 15.1 7.1 15.1 7.8C15.2 8.2 15.1 8.6 14.8 9Z";
var mdiMessageQuestionOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M12.2 5.5C11.3 5.5 10.6 5.7 10.1 6C9.5 6.4 9.2 7 9.3 7.7H11.3C11.3 7.4 11.4 7.2 11.6 7.1C11.8 7 12 6.9 12.3 6.9C12.6 6.9 12.9 7 13.1 7.2C13.3 7.4 13.4 7.6 13.4 7.9C13.4 8.2 13.3 8.4 13.2 8.6C13 8.8 12.8 9 12.6 9.1C12.1 9.4 11.7 9.7 11.5 9.9C11.1 10.2 11 10.5 11 11H13C13 10.7 13.1 10.5 13.1 10.3C13.2 10.1 13.4 10 13.6 9.8C14.1 9.6 14.4 9.3 14.7 8.9C15 8.5 15.1 8.1 15.1 7.7C15.1 7 14.8 6.4 14.3 6C13.9 5.7 13.1 5.5 12.2 5.5M11 12V14H13V12H11Z";
var mdiMessageReply = "M22,4C22,2.89 21.1,2 20,2H4A2,2 0 0,0 2,4V16A2,2 0 0,0 4,18H18L22,22V4Z";
var mdiMessageReplyOutline = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4C22 2.9 21.1 2 20 2M20 17.2L18.8 16H4V4H20V17.2Z";
var mdiMessageReplyText = "M18,8H6V6H18V8M18,11H6V9H18V11M18,14H6V12H18V14M22,4A2,2 0 0,0 20,2H4A2,2 0 0,0 2,4V16A2,2 0 0,0 4,18H18L22,22V4Z";
var mdiMessageReplyTextOutline = "M9 11H18V13H9V11M18 7H6V9H18V7M22 4V22L18 18H4C2.9 18 2 17.11 2 16V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.89 22 4M20 4H4V16H18.83L20 17.17V4Z";
var mdiMessageSettings = "M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M11,24H13V22H11V24M7,24H9V22H7V24M15,24H17V22H15V24Z";
var mdiMessageSettingsOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M11 24H13V22H11V24M7 24H9V22H7V24M15 24H17V22H15V24";
var mdiMessageStar = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M14.6 14L12 12.4L9.4 14L10.1 11L7.8 9L10.8 8.7L12 6L13.2 8.8L16.2 9.1L13.9 11.1L14.6 14Z";
var mdiMessageStarOutline = "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M12 12.4L14.6 14L13.9 11L16.2 9L13.2 8.7L12 6L10.8 8.8L7.8 9L10.1 11L9.4 14L12 12.4Z";
var mdiMessageText = "M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M6,9H18V11H6M14,14H6V12H14M18,8H6V6H18";
var mdiMessageTextClock = "M22 12.41V4C22 2.9 21.11 2 20 2H4C2.9 2 2 2.9 2 4V22L6 18H9.29C10.15 20.89 12.83 23 16 23C19.86 23 23 19.87 23 16C23 14.69 22.63 13.46 22 12.41M6 6H18V8H6V6M16 9C14.1 9 12.37 9.77 11.11 11H6V9H16M6 12H10.26C9.84 12.6 9.5 13.28 9.3 14H6V12M16 20.85C13.32 20.85 11.15 18.68 11.15 16S13.32 11.15 16 11.15C18.67 11.15 20.85 13.32 20.85 16S18.67 20.85 16 20.85M16.5 15.82L18.94 17.23L18.19 18.53L15 16.69V13H16.5V15.82Z";
var mdiMessageTextClockOutline = "M22 12.41V4C22 2.9 21.11 2 20 2H4C2.9 2 2 2.89 2 4V22L6 18H9.29C10.15 20.89 12.83 23 16 23C19.86 23 23 19.87 23 16C23 14.69 22.63 13.46 22 12.41M5.17 16L4 17.17V4H20V10.26C18.86 9.47 17.5 9 16 9C14.1 9 12.37 9.77 11.11 11H6V13H9.69C9.25 13.91 9 14.93 9 16H5.17M16 20.85C13.32 20.85 11.15 18.68 11.15 16S13.32 11.15 16 11.15C18.67 11.15 20.85 13.32 20.85 16S18.67 20.85 16 20.85M18 9H6V7H18V9M16.5 15.82L18.94 17.23L18.19 18.53L15 16.69V13H16.5V15.82Z";
var mdiMessageTextFast = "M9 5C7.9 5 7 5.9 7 7V21L11 17H20C21.1 17 22 16.1 22 15V7C22 5.9 21.1 5 20 5H9M3 7C2.4 7 2 7.4 2 8S2.4 9 3 9H5V7H3M11 8H19V10H11V8M2 11C1.4 11 1 11.4 1 12S1.4 13 2 13H5V11H2M11 12H16V14H11V12M1 15C.4 15 0 15.4 0 16C0 16.6 .4 17 1 17H5V15H1Z";
var mdiMessageTextFastOutline = "M10 11.5H17V13H10V11.5M10 8.5H19V10H10V8.5M20 5H9C7.9 5 7 5.9 7 7V21L11 17H20C21.1 17 22 16.1 22 15V7C22 5.9 21.1 5 20 5M20 15H10.2L9 16.2V7H20V15M3 7C2.4 7 2 7.4 2 8S2.4 9 3 9H5V7H3M2 11C1.4 11 1 11.4 1 12S1.4 13 2 13H5V11H2M1 15C.4 15 0 15.4 0 16C0 16.6 .4 17 1 17H5V15H1Z";
var mdiMessageTextLock = "M20.5 0A2.5 2.5 0 0 0 18 2.5V3A1 1 0 0 0 17 4V8A1 1 0 0 0 18 9H23A1 1 0 0 0 24 8V4A1 1 0 0 0 23 3V2.5A2.5 2.5 0 0 0 20.5 0M20.5 1A1.5 1.5 0 0 1 22 2.5V3H19V2.5A1.5 1.5 0 0 1 20.5 1M4 2A2 2 0 0 0 2 4V22L6 18H20A2 2 0 0 0 22 16V11H17C15.89 11 15 10.11 15 9V2H4M6 6H13V8H6V6M6 9H13V11H6V9M6 12H14V14H6V12Z";
var mdiMessageTextLockOutline = "M23 3V2.5C23 1.12 21.88 0 20.5 0S18 1.12 18 2.5V3C17.45 3 17 3.45 17 4V8C17 8.55 17.45 9 18 9H23C23.55 9 24 8.55 24 8V4C24 3.45 23.55 3 23 3M22 3H19V2.5C19 1.67 19.67 1 20.5 1S22 1.67 22 2.5V3M6 11H15V13H6V11M6 7H15V9H6V7M22 11V16C22 17.11 21.11 18 20 18H6L2 22V4C2 2.89 2.9 2 4 2H15V4H4V17.17L5.17 16H20V11H22Z";
var mdiMessageTextOutline = "M20,2A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H6L2,22V4C2,2.89 2.9,2 4,2H20M4,4V17.17L5.17,16H20V4H4M6,7H18V9H6V7M6,11H15V13H6V11Z";
var mdiMessageVideo = "M18,14L14,10.8V14H6V6H14V9.2L18,6M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z";
var mdiMeteor = "M2.8,3L19.67,18.82C19.67,18.82 20,19.27 19.58,19.71C19.17,20.15 18.63,19.77 18.63,19.77L2.8,3M7.81,4.59L20.91,16.64C20.91,16.64 21.23,17.08 20.82,17.5C20.4,17.97 19.86,17.59 19.86,17.59L7.81,4.59M4.29,8L17.39,20.03C17.39,20.03 17.71,20.47 17.3,20.91C16.88,21.36 16.34,21 16.34,21L4.29,8M12.05,5.96L21.2,14.37C21.2,14.37 21.42,14.68 21.13,15C20.85,15.3 20.47,15.03 20.47,15.03L12.05,5.96M5.45,11.91L14.6,20.33C14.6,20.33 14.82,20.64 14.54,20.95C14.25,21.26 13.87,21 13.87,21L5.45,11.91M16.38,7.92L20.55,11.74C20.55,11.74 20.66,11.88 20.5,12.03C20.38,12.17 20.19,12.05 20.19,12.05L16.38,7.92M7.56,16.1L11.74,19.91C11.74,19.91 11.85,20.06 11.7,20.2C11.56,20.35 11.37,20.22 11.37,20.22L7.56,16.1Z";
var mdiMeterElectric = "M12 2C7.04 2 3 6.04 3 11C3 14.91 5.5 18.24 9 19.47V22H11V19.94C11.33 20 11.66 20 12 20S12.67 20 13 19.94V22H15V19.47C18.5 18.23 21 14.9 21 11C21 6.04 16.96 2 12 2M14.25 14L11.25 17L9.75 15.5L11 14.25L9.75 13L12.75 10L14.25 11.5L13 12.75L14.25 14M16 9H8V7H16V9Z";
var mdiMeterElectricOutline = "M21 11C21 6.03 16.97 2 12 2S3 6.03 3 11C3 14.92 5.5 18.24 9 19.5V22H11V19.94C11.33 20 11.66 20 12 20S12.67 20 13 19.94V22H15V19.5C18.5 18.24 21 14.92 21 11M12 18C8.14 18 5 14.86 5 11S8.14 4 12 4 19 7.14 19 11 15.86 18 12 18M8 7H16V9H8V7M12.75 10L9.75 13L11 14.25L9.75 15.5L11.25 17L14.25 14L13 12.75L14.25 11.5L12.75 10Z";
var mdiMeterGas = "M16 4H15V2H13V4H11V2H9V4H8C5.79 4 4 5.79 4 8V18C4 20.21 5.79 22 8 22H16C18.21 22 20 20.21 20 18V8C20 5.79 18.21 4 16 4M12 18C10.62 18 9.5 16.9 9.5 15.54C9.5 14.45 9.93 14.15 12 11.75C14.05 14.13 14.5 14.45 14.5 15.54C14.5 16.9 13.38 18 12 18M16 10H8V8H16V10Z";
var mdiMeterGasOutline = "M16 4H15V2H13V4H11V2H9V4H8C5.79 4 4 5.79 4 8V18C4 20.21 5.79 22 8 22H16C18.21 22 20 20.21 20 18V8C20 5.79 18.21 4 16 4M18 18C18 19.1 17.1 20 16 20H8C6.9 20 6 19.1 6 18V8C6 6.9 6.9 6 8 6H16C17.1 6 18 6.9 18 8V18M9.5 15.54C9.5 16.9 10.62 18 12 18S14.5 16.9 14.5 15.54C14.5 14.45 14.05 14.13 12 11.75C9.93 14.15 9.5 14.46 9.5 15.54M8 8H16V10H8V8Z";
var mdiMetronome = "M12,1.75L8.57,2.67L4.06,19.53C4.03,19.68 4,19.84 4,20C4,21.11 4.89,22 6,22H18C19.11,22 20,21.11 20,20C20,19.84 19.97,19.68 19.94,19.53L18.58,14.42L17,16L17.2,17H13.41L16.25,14.16L14.84,12.75L10.59,17H6.8L10.29,4H13.71L15.17,9.43L16.8,7.79L15.43,2.67L12,1.75M11.25,5V14.75L12.75,13.25V5H11.25M19.79,7.8L16.96,10.63L16.25,9.92L14.84,11.34L17.66,14.16L19.08,12.75L18.37,12.04L21.2,9.21L19.79,7.8Z";
var mdiMetronomeTick = "M12,1.75L8.57,2.67L4.07,19.5C4.06,19.5 4,19.84 4,20C4,21.11 4.89,22 6,22H18C19.11,22 20,21.11 20,20C20,19.84 19.94,19.5 19.93,19.5L15.43,2.67L12,1.75M10.29,4H13.71L17.2,17H13V12H11V17H6.8L10.29,4M11,5V9H10V11H14V9H13V5H11Z";
var mdiMicroSd = "M8,2A2,2 0 0,0 6,4V11L4,13V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V4A2,2 0 0,0 18,2H8M9,4H11V8H9V4M12,4H14V8H12V4M15,4H17V8H15V4Z";
var mdiMicrophone = "M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z";
var mdiMicrophoneMessage = "M8,7A2,2 0 0,1 10,9V14A2,2 0 0,1 8,16A2,2 0 0,1 6,14V9A2,2 0 0,1 8,7M14,14C14,16.97 11.84,19.44 9,19.92V22H7V19.92C4.16,19.44 2,16.97 2,14H4A4,4 0 0,0 8,18A4,4 0 0,0 12,14H14M21.41,9.41L17.17,13.66L18.18,10H14A2,2 0 0,1 12,8V4A2,2 0 0,1 14,2H20A2,2 0 0,1 22,4V8C22,8.55 21.78,9.05 21.41,9.41Z";
var mdiMicrophoneMessageOff = "M2,5.27L3.28,4L20,20.72L18.73,22L13.38,16.65C12.55,18.35 10.93,19.59 9,19.92V22H7V19.92C4.16,19.44 2,16.97 2,14H4A4,4 0 0,0 8,18C9.82,18 11.36,16.78 11.84,15.11L10,13.27V14A2,2 0 0,1 8,16A2,2 0 0,1 6,14V9.27L2,5.27M21.41,9.41L17.17,13.66L18.18,10H14A2,2 0 0,1 12,8V4A2,2 0 0,1 14,2H20A2,2 0 0,1 22,4V8C22,8.55 21.78,9.05 21.41,9.41Z";
var mdiMicrophoneMinus = "M9,2A3,3 0 0,1 12,5V11A3,3 0 0,1 9,14A3,3 0 0,1 6,11V5A3,3 0 0,1 9,2M16,11C16,14.5 13.44,17.43 10,17.93V21H8V17.93C4.56,17.43 2,14.5 2,11H4A5,5 0 0,0 9,16A5,5 0 0,0 14,11H16M15,5H23V7H15V5Z";
var mdiMicrophoneOff = "M19,11C19,12.19 18.66,13.3 18.1,14.28L16.87,13.05C17.14,12.43 17.3,11.74 17.3,11H19M15,11.16L9,5.18V5A3,3 0 0,1 12,2A3,3 0 0,1 15,5V11L15,11.16M4.27,3L21,19.73L19.73,21L15.54,16.81C14.77,17.27 13.91,17.58 13,17.72V21H11V17.72C7.72,17.23 5,14.41 5,11H6.7C6.7,14 9.24,16.1 12,16.1C12.81,16.1 13.6,15.91 14.31,15.58L12.65,13.92L12,14A3,3 0 0,1 9,11V10.28L3,4.27L4.27,3Z";
var mdiMicrophoneOutline = "M17.3,11C17.3,14 14.76,16.1 12,16.1C9.24,16.1 6.7,14 6.7,11H5C5,14.41 7.72,17.23 11,17.72V21H13V17.72C16.28,17.23 19,14.41 19,11M10.8,4.9C10.8,4.24 11.34,3.7 12,3.7C12.66,3.7 13.2,4.24 13.2,4.9L13.19,11.1C13.19,11.76 12.66,12.3 12,12.3C11.34,12.3 10.8,11.76 10.8,11.1M12,14A3,3 0 0,0 15,11V5A3,3 0 0,0 12,2A3,3 0 0,0 9,5V11A3,3 0 0,0 12,14Z";
var mdiMicrophonePlus = "M9,2A3,3 0 0,1 12,5V11A3,3 0 0,1 9,14A3,3 0 0,1 6,11V5A3,3 0 0,1 9,2M16,11C16,14.5 13.44,17.43 10,17.93V21H8V17.93C4.56,17.43 2,14.5 2,11H4A5,5 0 0,0 9,16A5,5 0 0,0 14,11H16M15,5H18V2H20V5H23V7H20V10H18V7H15V5Z";
var mdiMicrophoneQuestion = "M9 2C10.66 2 12 3.34 12 5V11C12 12.66 10.66 14 9 14S6 12.66 6 11V5C6 3.34 7.34 2 9 2M16 11C16 14.53 13.39 17.44 10 17.93V21H8V17.93C4.61 17.44 2 14.53 2 11H4C4 13.76 6.24 16 9 16S14 13.76 14 11H16M20.5 14.5V16H19V14.5H20.5M18.5 9.5H17V9C17 7.34 18.34 6 20 6S23 7.34 23 9C23 9.97 22.5 10.88 21.71 11.41L21.41 11.6C20.84 12 20.5 12.61 20.5 13.3V13.5H19V13.3C19 12.11 19.6 11 20.59 10.35L20.88 10.16C21.27 9.9 21.5 9.47 21.5 9C21.5 8.17 20.83 7.5 20 7.5S18.5 8.17 18.5 9V9.5Z";
var mdiMicrophoneQuestionOutline = "M14.3 11C14.3 14 11.76 16.1 9 16.1S3.7 14 3.7 11H2C2 14.41 4.72 17.23 8 17.72V21H10V17.72C13.28 17.23 16 14.41 16 11M7.8 4.9C7.8 4.24 8.34 3.7 9 3.7S10.2 4.24 10.2 4.9L10.19 11.1C10.19 11.76 9.66 12.3 9 12.3S7.8 11.76 7.8 11.1M9 14C10.66 14 12 12.66 12 11V5C12 3.34 10.66 2 9 2S6 3.34 6 5V11C6 12.66 7.34 14 9 14M20.5 14.5V16H19V14.5H20.5M18.5 9.5H17V9C17 7.34 18.34 6 20 6S23 7.34 23 9C23 9.97 22.5 10.88 21.71 11.41L21.41 11.6C20.84 12 20.5 12.61 20.5 13.3V13.5H19V13.3C19 12.11 19.6 11 20.59 10.35L20.88 10.16C21.27 9.9 21.5 9.47 21.5 9C21.5 8.17 20.83 7.5 20 7.5S18.5 8.17 18.5 9V9.5Z";
var mdiMicrophoneSettings = "M19,10H17.3C17.3,13 14.76,15.1 12,15.1C9.24,15.1 6.7,13 6.7,10H5C5,13.41 7.72,16.23 11,16.72V20H13V16.72C16.28,16.23 19,13.41 19,10M15,24H17V22H15M11,24H13V22H11M12,13A3,3 0 0,0 15,10V4A3,3 0 0,0 12,1A3,3 0 0,0 9,4V10A3,3 0 0,0 12,13M7,24H9V22H7V24Z";
var mdiMicrophoneVariant = "M9,3A4,4 0 0,1 13,7H5A4,4 0 0,1 9,3M11.84,9.82L11,18H10V19A2,2 0 0,0 12,21A2,2 0 0,0 14,19V14A4,4 0 0,1 18,10H20L19,11L20,12H18A2,2 0 0,0 16,14V19A4,4 0 0,1 12,23A4,4 0 0,1 8,19V18H7L6.16,9.82C5.67,9.32 5.31,8.7 5.13,8H12.87C12.69,8.7 12.33,9.32 11.84,9.82M9,11A1,1 0 0,0 8,12A1,1 0 0,0 9,13A1,1 0 0,0 10,12A1,1 0 0,0 9,11Z";
var mdiMicrophoneVariantOff = "M2,5.27L3.28,4L20,20.72L18.73,22L16,19.26C15.86,21.35 14.12,23 12,23A4,4 0 0,1 8,19V18H7L6.16,9.82C5.82,9.47 5.53,9.06 5.33,8.6L2,5.27M9,3A4,4 0 0,1 13,7H8.82L6.08,4.26C6.81,3.5 7.85,3 9,3M11.84,9.82L11.82,10L9.82,8H12.87C12.69,8.7 12.33,9.32 11.84,9.82M11,18H10V19A2,2 0 0,0 12,21A2,2 0 0,0 14,19V17.27L11.35,14.62L11,18M18,10H20L19,11L20,12H18A2,2 0 0,0 16,14V14.18L14.3,12.5C14.9,11 16.33,10 18,10M8,12A1,1 0 0,0 9,13C9.21,13 9.4,12.94 9.56,12.83L8.17,11.44C8.06,11.6 8,11.79 8,12Z";
var mdiMicroscope = "M9.46,6.28L11.05,9C8.47,9.26 6.5,11.41 6.5,14A5,5 0 0,0 11.5,19C13.55,19 15.31,17.77 16.08,16H13.5V14H21.5V16H19.25C18.84,17.57 17.97,18.96 16.79,20H19.5V22H3.5V20H6.21C4.55,18.53 3.5,16.39 3.5,14C3.5,10.37 5.96,7.2 9.46,6.28M12.74,2.07L13.5,3.37L14.36,2.87L17.86,8.93L14.39,10.93L10.89,4.87L11.76,4.37L11,3.07L12.74,2.07Z";
var mdiMicrosoft = "M2,3H11V12H2V3M11,22H2V13H11V22M21,3V12H12V3H21M21,22H12V13H21V22Z";
var mdiMicrosoftAccess = "M14.5 2.63Q15.84 2.63 17.18 2.77L17.85 2.86Q18.3 2.93 18.84 3.04 19.37 3.15 19.93 3.31 20.5 3.47 20.96 3.69 21.42 3.91 21.71 4.19 22 4.47 22 4.81V19.19Q22 19.53 21.71 19.81 21.41 20.09 20.96 20.31 20.5 20.53 19.93 20.69 19.37 20.85 18.83 20.96 18.3 21.07 17.86 21.14 17.41 21.21 17.17 21.23 15.84 21.38 14.5 21.38 13.15 21.38 11.82 21.23 11.59 21.21 11.15 21.14 10.7 21.07 10.16 20.96 9.63 20.85 9.07 20.69 8.5 20.53 8.05 20.31 7.59 20.09 7.29 19.81 7 19.53 7 19.19V17H2.83Q2.5 17 2.24 16.76 2 16.5 2 16.17V7.83Q2 7.5 2.24 7.24 2.5 7 2.83 7H7V4.81Q7 4.47 7.29 4.19 7.59 3.91 8.05 3.69 8.5 3.47 9.07 3.31 9.63 3.15 10.17 3.04 10.7 2.93 11.14 2.86 11.59 2.8 11.83 2.77 13.15 2.63 14.5 2.63M14.5 3.88Q13.87 3.88 13.08 3.92 12.3 3.96 11.5 4.07 10.69 4.18 9.93 4.36 9.17 4.54 8.58 4.81 9.19 5.1 9.95 5.28 10.7 5.46 11.5 5.56 12.29 5.66 13.07 5.71 13.85 5.75 14.5 5.75 15.16 5.75 15.93 5.71 16.71 5.66 17.5 5.56 18.3 5.46 19.06 5.28 19.81 5.1 20.42 4.81 19.83 4.54 19.07 4.36 18.31 4.18 17.5 4.07 16.7 3.96 15.92 3.92 15.14 3.88 14.5 3.88M5.94 13.79H8.06L8.55 15.28H10.22L7.83 8.72H6.2L3.78 15.28H5.44M20.75 19V16Q20.11 16.31 19.31 16.5 18.5 16.68 17.67 16.79 16.83 16.9 16 16.95 15.19 17 14.5 17 13.79 17 13.08 16.96 12.37 16.91 11.67 16.83 11.44 17 11.17 17H8.25V19Q8.53 19.21 9 19.38 9.5 19.56 10.07 19.68 10.65 19.81 11.29 19.9 11.92 20 12.5 20.03 13.12 20.09 13.64 20.11 14.16 20.13 14.5 20.13 14.84 20.12 15.36 20.1 15.88 20.09 16.5 20.03 17.08 20 17.71 19.9 18.35 19.81 18.93 19.68 19.5 19.56 20 19.38 20.47 19.21 20.75 19M20.75 14.63V11Q20.11 11.31 19.31 11.5 18.5 11.68 17.67 11.79 16.83 11.9 16 11.95 15.19 12 14.5 12 13.88 12 13.25 11.97 12.63 11.93 12 11.87V15.62Q12.63 15.69 13.25 15.72 13.88 15.75 14.5 15.75 14.86 15.75 15.38 15.73 15.9 15.71 16.5 15.66 17.08 15.6 17.7 15.5 18.33 15.44 18.9 15.31 19.5 15.18 19.96 15 20.45 14.85 20.75 14.63M20.75 9.63V6Q20.11 6.31 19.31 6.5 18.5 6.68 17.67 6.79 16.83 6.9 16 6.95 15.19 7 14.5 7 13.81 7 13 6.95 12.17 6.9 11.33 6.79 10.5 6.68 9.69 6.5 8.89 6.31 8.25 6V7H11.17Q11.5 7 11.76 7.24 12 7.5 12 7.83V10.62Q12.63 10.69 13.25 10.72 13.88 10.75 14.5 10.75 14.86 10.75 15.38 10.73 15.9 10.71 16.5 10.66 17.08 10.6 17.7 10.5 18.33 10.44 18.9 10.31 19.5 10.18 19.96 10 20.44 9.85 20.75 9.63M6.32 12.5L7 10.5L7.65 12.5Z";
var mdiMicrosoftAzure = "M13.05,4.24L6.56,18.05L2,18L7.09,9.24L13.05,4.24M13.75,5.33L22,19.76H6.74L16.04,18.1L11.17,12.31L13.75,5.33Z";
var mdiMicrosoftAzureDevops = "M22 18L17 22L9 19V22L4.81 16.25L17.72 17.3V6.34L22 5.65V18M4.81 16.25V8.96L17.72 6.34L10.6 2V4.84L3.97 6.76L2 9.38V15.07L4.81 16.25Z";
var mdiMicrosoftBing = "M5,3V19L8.72,21L18,15.82V11.73H18L9.77,8.95L11.38,12.84L13.94,14L8.7,16.92V4.27L5,3";
var mdiMicrosoftDynamics365 = "M6,2L17.25,8.5L13.5,11.5L6,8V2M6,9L9.5,11.25L6,22L18,9V15L6,22V9Z";
var mdiMicrosoftEdge = "M10.86 15.37C10.17 14.6 9.7 13.68 9.55 12.65C9.25 13.11 9 13.61 8.82 14.15C7.9 16.9 9.5 20.33 12.22 21.33C14.56 22.11 17.19 20.72 18.92 19.2C19.18 18.85 21.23 17.04 20.21 16.84C17.19 18.39 13.19 17.95 10.86 15.37M11.46 9.56C12.5 9.55 11.5 9.13 11.07 8.81C10.03 8.24 8.81 7.96 7.63 7.96C3.78 8 .995 10.41 2.3 14.4C3.24 18.28 6.61 21.4 10.59 21.9C8.54 20.61 7.3 18.19 7.3 15.78C7.38 13.25 8.94 10.28 11.46 9.56M2.78 8.24C5.82 6 10.66 6.18 13.28 9C14.3 10.11 15 12 14.07 13.37C12.33 15.25 17.15 15.5 18.18 15.22C21.92 14.5 22.91 10.15 21.13 7.15C19.43 3.75 15.66 1.97 11.96 2C7.9 1.93 4.25 4.5 2.78 8.24Z";
var mdiMicrosoftExcel = "M21.17 3.25Q21.5 3.25 21.76 3.5 22 3.74 22 4.08V19.92Q22 20.26 21.76 20.5 21.5 20.75 21.17 20.75H7.83Q7.5 20.75 7.24 20.5 7 20.26 7 19.92V17H2.83Q2.5 17 2.24 16.76 2 16.5 2 16.17V7.83Q2 7.5 2.24 7.24 2.5 7 2.83 7H7V4.08Q7 3.74 7.24 3.5 7.5 3.25 7.83 3.25M7 13.06L8.18 15.28H9.97L8 12.06L9.93 8.89H8.22L7.13 10.9L7.09 10.96L7.06 11.03Q6.8 10.5 6.5 9.96 6.25 9.43 5.97 8.89H4.16L6.05 12.08L4 15.28H5.78M13.88 19.5V17H8.25V19.5M13.88 15.75V12.63H12V15.75M13.88 11.38V8.25H12V11.38M13.88 7V4.5H8.25V7M20.75 19.5V17H15.13V19.5M20.75 15.75V12.63H15.13V15.75M20.75 11.38V8.25H15.13V11.38M20.75 7V4.5H15.13V7Z";
var mdiMicrosoftInternetExplorer = "M13,3L14,3.06C16.8,1.79 19.23,1.64 20.5,2.92C21.5,3.93 21.58,5.67 20.92,7.72C21.61,9 22,10.45 22,12L21.95,13H9.08C9.45,15.28 11.06,17 13,17C14.31,17 15.47,16.21 16.2,15H21.5C20.25,18.5 16.92,21 13,21C11.72,21 10.5,20.73 9.41,20.25C6.5,21.68 3.89,21.9 2.57,20.56C1,18.96 1.68,15.57 4,12C4.93,10.54 6.14,9.06 7.57,7.65L8.38,6.88C7.21,7.57 5.71,8.62 4.19,10.17C5.03,6.08 8.66,3 13,3M13,7C11.21,7 9.69,8.47 9.18,10.5H16.82C16.31,8.47 14.79,7 13,7M20.06,4.06C19.4,3.39 18.22,3.35 16.74,3.81C18.22,4.5 19.5,5.56 20.41,6.89C20.73,5.65 20.64,4.65 20.06,4.06M3.89,20C4.72,20.84 6.4,20.69 8.44,19.76C6.59,18.67 5.17,16.94 4.47,14.88C3.27,17.15 3,19.07 3.89,20Z";
var mdiMicrosoftOffice = "M19.94 5.59V18.39Q19.94 19.06 19.55 19.59 19.16 20.11 18.5 20.29L12.77 21.94Q12.65 21.97 12.5 22H12.28Q11.95 22 11.68 21.91 11.41 21.82 11.13 21.67L7.38 19.55Q7.17 19.43 7.05 19.24 6.93 19.05 6.93 18.81 6.93 18.45 7.19 18.2 7.44 17.95 7.8 17.95H12.66V6.14L9 7.44Q8.57 7.6 8.3 8 8.03 8.38 8.03 8.85V15.58Q8.03 16 7.82 16.34 7.62 16.68 7.25 16.88L5.53 17.82Q5.29 17.95 5.05 17.95 4.64 17.95 4.35 17.66 4.06 17.37 4.06 16.95V7.47Q4.06 6.95 4.33 6.5 4.61 6 5.06 5.74L11.22 2.24Q11.43 2.12 11.67 2.06 11.91 2 12.15 2 12.32 2 12.46 2.03 12.6 2.05 12.77 2.1L18.5 3.69Q18.83 3.78 19.09 3.96 19.35 4.14 19.54 4.39 19.74 4.65 19.84 4.95 19.94 5.26 19.94 5.59M18.62 18.39V5.59Q18.62 5.36 18.5 5.19 18.35 5 18.13 4.96L15.31 4.18Q15 4.09 14.65 4 14.32 3.89 14 3.81V20.21L18.13 19Q18.35 18.96 18.5 18.79 18.62 18.62 18.62 18.39Z";
var mdiMicrosoftOnedrive = "M18.21 10.29Q19 10.34 19.7 10.68 20.39 11 20.9 11.57 21.41 12.12 21.71 12.83 22 13.54 22 14.34 22 15.18 21.68 15.92 21.36 16.66 20.8 17.21 20.25 17.76 19.5 18.08 18.78 18.41 17.94 18.41H7Q5.97 18.41 5.06 18 4.15 17.61 3.47 16.94 2.79 16.26 2.4 15.35 2 14.44 2 13.41 2 12.59 2.26 11.83 2.5 11.08 3 10.45 3.44 9.82 4.08 9.35 4.72 8.88 5.5 8.63 5.87 8.5 6.21 8.5 6.56 8.43 6.93 8.41H6.94Q7.37 7.75 7.95 7.23 8.5 6.71 9.2 6.34 9.87 6 10.62 5.78 11.37 5.59 12.16 5.59 13.22 5.59 14.2 5.94 15.18 6.29 16 6.91 16.8 7.53 17.37 8.39 17.95 9.26 18.21 10.29M12.16 6.84Q11.05 6.84 10.06 7.3 9.06 7.75 8.36 8.6 8.73 8.7 9.07 8.85 9.4 9 9.73 9.2L13.71 11.58L16 10.62Q16.21 10.53 16.44 10.45 16.67 10.38 16.92 10.33 16.68 9.55 16.21 8.91 15.74 8.27 15.11 7.81 14.5 7.35 13.73 7.1 13 6.84 12.16 6.84M4 15.66L12.27 12.18L9.08 10.26Q8.59 9.97 8.06 9.81 7.5 9.66 6.95 9.66 6.19 9.66 5.5 9.96 4.84 10.26 4.34 10.77 3.84 11.29 3.54 11.97 3.25 12.65 3.25 13.41 3.25 14 3.45 14.59 3.64 15.19 4 15.66M17.94 17.16Q18.41 17.16 18.84 17 19.27 16.86 19.64 16.58L13.61 13L5.03 16.59Q5.47 16.86 5.97 17 6.47 17.16 7 17.16M20.45 15.61Q20.75 15 20.75 14.34 20.75 13.7 20.5 13.17 20.26 12.65 19.85 12.28 19.43 11.91 18.88 11.71 18.32 11.5 17.7 11.5 17.35 11.5 17 11.6 16.66 11.68 16.33 11.81 16 11.93 15.67 12.08 15.35 12.23 15.04 12.37Z";
var mdiMicrosoftOnenote = "M21.17 3.25Q21.5 3.25 21.76 3.5 22 3.74 22 4.08V19.92Q22 20.26 21.76 20.5 21.5 20.75 21.17 20.75H7.83Q7.5 20.75 7.24 20.5 7 20.26 7 19.92V17H2.83Q2.5 17 2.24 16.76 2 16.5 2 16.17V7.83Q2 7.5 2.24 7.24 2.5 7 2.83 7H7V4.08Q7 3.74 7.24 3.5 7.5 3.25 7.83 3.25M5.8 11.17L8.16 15.27H9.65V8.73H8.2V12.92L5.93 8.73H4.35V15.27H5.8M20.75 19.5V17H18.25V19.5M20.75 15.75V13.25H18.25V15.75M20.75 12V9.5H18.25V12M20.75 8.25V4.5H8.25V7H11.17Q11.5 7 11.76 7.24 12 7.5 12 7.83V16.17Q12 16.5 11.76 16.76 11.5 17 11.17 17H8.25V19.5H17V8.25Z";
var mdiMicrosoftOutlook = "M8.56 12.03Q8.56 12.41 8.5 12.76 8.39 13.1 8.2 13.38 8 13.65 7.71 13.81 7.41 13.97 7 13.97 6.58 13.97 6.29 13.8 6 13.63 5.81 13.35 5.62 13.07 5.54 12.72 5.45 12.37 5.45 12 5.45 11.64 5.54 11.28 5.62 10.93 5.81 10.65 6 10.37 6.31 10.2 6.61 10.03 7.03 10.03 7.46 10.03 7.75 10.2 8.05 10.38 8.23 10.66 8.41 10.95 8.5 11.3 8.56 11.66 8.56 12.03M22 12V19.81Q22 20.2 21.73 20.5 21.45 20.75 21.06 20.75H7.94Q7.55 20.75 7.27 20.5 7 20.2 7 19.81V17H2.83Q2.5 17 2.24 16.76 2 16.5 2 16.17V7.83Q2 7.5 2.24 7.24 2.5 7 2.83 7H8.25V4.13Q8.25 3.76 8.5 3.5 8.76 3.25 9.13 3.25H19.87Q20.24 3.25 20.5 3.5 20.75 3.76 20.75 4.13V11.04L21.79 11.64H21.8Q21.88 11.7 21.94 11.8 22 11.89 22 12M17 5.13V7.63H19.5V5.13M17 8.88V11.38H19.5V8.88M17 12.63V14.15L19.54 12.63M12.63 5.13V7.63H15.75V5.13M12.63 8.88V11.38H15.75V8.88M12.63 12.63V14.32L14.64 15.56L15.75 14.9V12.63M9.5 5.13V7H11.27Q11.33 7 11.38 7.04V5.12M7 15.32Q7.73 15.32 8.32 15.06 8.9 14.8 9.31 14.35 9.71 13.9 9.91 13.28 10.12 12.66 10.13 11.94 10.13 11.25 9.92 10.65 9.72 10.06 9.32 9.62 8.93 9.18 8.37 8.93 7.8 8.68 7.08 8.68 6.31 8.68 5.71 8.93 5.12 9.18 4.71 9.63 4.3 10.09 4.09 10.71 3.88 11.34 3.88 12.08 3.88 12.78 4.09 13.38 4.31 13.97 4.71 14.4 5.11 14.83 5.68 15.08 6.26 15.32 7 15.32M8.25 19.5H18.57L12 15.4V16.17Q12 16.5 11.76 16.76 11.5 17 11.17 17H8.25M20.75 19.39V13.36L15.83 16.31Z";
var mdiMicrosoftPowerpoint = "M13.25 3.25Q14.46 3.25 15.58 3.56 16.7 3.88 17.67 4.45 18.64 5 19.44 5.81 20.23 6.61 20.8 7.58 21.38 8.55 21.69 9.67 22 10.79 22 12 22 13.21 21.69 14.33 21.38 15.45 20.8 16.42 20.23 17.39 19.44 18.19 18.64 19 17.67 19.55 16.7 20.13 15.58 20.44 14.46 20.75 13.25 20.75 12.18 20.75 11.15 20.5 10.12 20.24 9.2 19.76 8.28 19.27 7.5 18.58 6.69 17.88 6.07 17H2.83Q2.5 17 2.24 16.76 2 16.5 2 16.17V7.83Q2 7.5 2.24 7.25 2.5 7 2.83 7H6.07Q6.69 6.12 7.5 5.42 8.28 4.72 9.2 4.24 10.13 3.76 11.15 3.5 12.18 3.25 13.25 3.25M13.88 4.53V11.37H20.72Q20.6 10 20.03 8.81 19.46 7.62 18.55 6.7 17.64 5.79 16.43 5.22 15.23 4.65 13.88 4.53M9.5 10.84Q9.5 10.27 9.3 9.87 9.11 9.46 8.78 9.21 8.45 8.95 8 8.84 7.55 8.72 7 8.72H4.37V15.27H5.91V13H6.94Q7.42 13 7.87 12.84 8.33 12.7 8.69 12.43 9.05 12.17 9.27 11.76 9.5 11.36 9.5 10.84M13.25 19.5Q14.23 19.5 15.14 19.26 16.04 19 16.85 18.58 17.66 18.13 18.33 17.5 19 16.89 19.5 16.13 20 15.36 20.33 14.47 20.64 13.58 20.72 12.62H12.64V4.53Q11.19 4.65 9.91 5.29 8.63 5.93 7.67 7H11.17Q11.5 7 11.76 7.25 12 7.5 12 7.83V16.17Q12 16.5 11.76 16.76 11.5 17 11.17 17H7.67Q8.2 17.6 8.84 18.06 9.5 18.5 10.19 18.84 10.91 19.17 11.68 19.33 12.45 19.5 13.25 19.5M6.85 10Q7.32 10 7.61 10.19 7.89 10.38 7.89 10.89 7.89 11.11 7.79 11.25 7.69 11.39 7.53 11.5 7.37 11.57 7.18 11.6 7 11.64 6.8 11.64H5.91V10H6.85Z";
var mdiMicrosoftSharepoint = "M22 13.25Q22 14.29 21.6 15.2 21.21 16.1 20.53 16.78 19.85 17.46 18.94 17.86 18.03 18.25 17 18.25 16.36 18.25 15.73 18.09 15.64 18.92 15.27 19.63 14.89 20.35 14.3 20.88 13.72 21.41 12.97 21.7 12.21 22 11.38 22 10.47 22 9.67 21.65 8.88 21.31 8.28 20.72 7.69 20.13 7.35 19.33 7 18.53 7 17.63V17.31Q7.03 17.16 7.05 17H2.83Q2.5 17 2.24 16.76 2 16.5 2 16.17V7.83Q2 7.5 2.24 7.24 2.5 7 2.83 7H5.78Q5.9 5.94 6.39 5 6.87 4.11 7.63 3.44 8.38 2.76 9.34 2.38 10.3 2 11.38 2 12.54 2 13.56 2.44 14.59 2.89 15.35 3.65 16.11 4.41 16.56 5.44 17 6.46 17 7.63V7.94Q17 8.09 16.96 8.25 18 8.25 18.91 8.64 19.83 9.03 20.5 9.71 21.21 10.38 21.6 11.29 22 12.21 22 13.25M11.37 3.25Q10.56 3.25 9.83 3.54 9.09 3.82 8.5 4.32 7.94 4.82 7.55 5.5 7.17 6.2 7.05 7H11.17Q11.5 7 11.76 7.25 12 7.5 12 7.83V11.95L12.18 11.92Q12.35 11.3 12.68 10.74 13 10.17 13.47 9.72 13.92 9.27 14.5 8.93 15.04 8.6 15.67 8.43 15.75 8 15.75 7.63 15.75 6.72 15.4 5.92 15.06 5.13 14.46 4.54 13.87 3.95 13.08 3.6 12.28 3.25 11.37 3.25M7.1 15.25Q7.55 15.25 8 15.16 8.42 15.07 8.76 14.85 9.1 14.64 9.31 14.29 9.5 13.93 9.5 13.41 9.5 12.88 9.3 12.53 9.08 12.18 8.75 11.94 8.42 11.71 8.04 11.56L7.32 11.27Q7 11.14 6.77 11 6.55 10.85 6.55 10.62 6.55 10.46 6.67 10.35 6.79 10.25 6.95 10.2 7.11 10.13 7.28 10.11 7.46 10.1 7.58 10.1 8.07 10.1 8.46 10.22 8.84 10.35 9.25 10.6V9.12Q9 9.05 8.81 9 8.61 8.95 8.42 8.92 8.22 8.89 8 8.87 7.8 8.86 7.55 8.86 7.12 8.86 6.67 8.95 6.22 9.05 5.85 9.27 5.5 9.5 5.26 9.83 5.03 10.18 5.03 10.69 5.03 11.19 5.25 11.5 5.47 11.85 5.8 12.09 6.13 12.32 6.5 12.5L7.22 12.79Q7.56 12.93 7.78 13.08 8 13.24 8 13.46 8 13.65 7.89 13.76 7.79 13.87 7.63 13.92 7.5 14 7.31 14H7Q6.41 14 5.96 13.82 5.5 13.62 5.04 13.3V14.86Q6.03 15.25 7.1 15.25M11.37 20.75Q12 20.75 12.58 20.5 13.15 20.26 13.58 19.84 14 19.41 14.25 18.84 14.5 18.27 14.5 17.63 14.5 17.07 14.31 16.56 14.13 16.05 13.8 15.65 13.46 15.24 13 14.96 12.55 14.68 12 14.56V16.17Q12 16.5 11.76 16.76 11.5 17 11.17 17H8.31Q8.25 17.31 8.25 17.63 8.25 18.27 8.5 18.84 8.74 19.41 9.16 19.84 9.59 20.26 10.16 20.5 10.73 20.75 11.37 20.75M17 17Q17.77 17 18.45 16.71 19.14 16.42 19.65 15.9 20.16 15.39 20.46 14.71 20.75 14.03 20.75 13.25 20.75 12.5 20.46 11.8 20.16 11.11 19.65 10.6 19.14 10.09 18.45 9.79 17.77 9.5 17 9.5 16.23 9.5 15.55 9.8 14.87 10.1 14.36 10.61 13.85 11.12 13.55 11.8 13.25 12.5 13.25 13.25V13.46L13.27 13.68Q13.73 13.9 14.12 14.22 14.5 14.54 14.82 14.93 15.12 15.33 15.34 15.79 15.55 16.25 15.66 16.74 16.32 17 17 17Z";
var mdiMicrosoftTeams = "M19.19 8.77Q18.73 8.77 18.33 8.6 17.94 8.43 17.64 8.13 17.34 7.83 17.17 7.44 17 7.04 17 6.58 17 6.13 17.17 5.73 17.34 5.33 17.64 5.04 17.94 4.74 18.33 4.57 18.73 4.39 19.19 4.4 19.64 4.39 20.04 4.57 20.44 4.74 20.74 5.04 21.03 5.33 21.21 5.73 21.38 6.13 21.38 6.58 21.38 7.04 21.21 7.44 21.04 7.83 20.74 8.13 20.44 8.43 20.04 8.6 19.64 8.77 19.19 8.77M19.19 5.65Q18.8 5.65 18.5 5.92 18.25 6.19 18.25 6.58 18.25 6.97 18.5 7.25 18.8 7.5 19.19 7.5 19.58 7.5 19.85 7.25 20.13 7 20.13 6.58 20.13 6.19 19.85 5.92 19.58 5.65 19.19 5.65M22 10.33V15Q22 15.63 21.76 16.2 21.5 16.77 21.09 17.19 20.66 17.62 20.09 17.86 19.5 18.11 18.88 18.11 18.5 18.11 18.12 18 17.73 17.93 17.41 17.75 17.17 18.54 16.7 19.19 16.23 19.84 15.6 20.3 14.97 20.76 14.21 21 13.45 21.27 12.63 21.27 11.67 21.27 10.82 20.94 10 20.61 9.32 20 8.66 19.43 8.23 18.64 7.79 17.84 7.66 16.9H2.83Q2.5 16.9 2.24 16.65 2 16.41 2 16.07V7.73Q2 7.39 2.24 7.14 2.5 6.9 2.83 6.9H10Q9.71 6.3 9.71 5.65 9.71 5.04 9.94 4.5 10.16 4 10.56 3.58 10.96 3.19 11.5 2.96 12 2.73 12.62 2.73 13.23 2.73 13.76 2.96 14.29 3.19 14.69 3.58 15.09 4 15.31 4.5 15.54 5.04 15.54 5.65 15.54 6.25 15.31 6.79 15.09 7.32 14.69 7.71 14.29 8.11 13.76 8.34 13.23 8.57 12.62 8.57 12.47 8.57 12.31 8.55 12.16 8.53 12 8.5V9.4H21.06Q21.45 9.4 21.73 9.67 22 9.94 22 10.33M12.63 4Q12.28 4 12 4.11 11.67 4.24 11.44 4.47 11.22 4.7 11.09 5 10.96 5.31 10.96 5.65 10.96 6 11.09 6.3 11.22 6.6 11.44 6.83 11.67 7.05 12 7.19 12.28 7.32 12.63 7.32 12.97 7.32 13.27 7.19 13.57 7.05 13.8 6.83 14.03 6.6 14.16 6.3 14.3 6 14.3 5.65 14.3 5.31 14.16 5 14.03 4.7 13.8 4.47 13.57 4.24 13.27 4.11 12.97 4 12.63 4M7.78 10.18H9.66V8.62H4.34V10.18H6.22V15.18H7.78M16.38 16.27V10.65H12V16.07Q12 16.41 11.76 16.65 11.5 16.9 11.17 16.9H8.92Q9.05 17.57 9.39 18.15 9.73 18.72 10.21 19.14 10.69 19.55 11.31 19.79 11.92 20 12.63 20 13.4 20 14.08 19.73 14.76 19.43 15.28 18.92 15.79 18.41 16.08 17.73 16.38 17.05 16.38 16.27M20.75 15V10.65H17.63V16.36Q17.88 16.61 18.2 16.74 18.5 16.86 18.88 16.86 19.27 16.86 19.61 16.71 19.95 16.56 20.2 16.31 20.46 16.06 20.6 15.71 20.75 15.37 20.75 15Z";
var mdiMicrosoftVisualStudio = "M17,8.5L12.25,12.32L17,16V8.5M4.7,18.4L2,16.7V7.7L5,6.7L9.3,10.03L18,2L22,4.5V20L17,22L9.34,14.66L4.7,18.4M5,14L6.86,12.28L5,10.5V14Z";
var mdiMicrosoftVisualStudioCode = "M17,16.47V7.39L11,11.93M2.22,9.19C1.92,8.87 1.91,8.37 2.2,8.04L3.4,6.93C3.6,6.75 4.09,6.67 4.45,6.93L7.87,9.54L15.8,2.29C16.12,1.97 16.67,1.84 17.3,2.17L21.3,4.08C21.66,4.29 22,4.62 22,5.23V18.73C22,19.13 21.71,19.56 21.4,19.73L17,21.83C16.68,21.96 16.08,21.84 15.87,21.63L7.85,14.33L4.45,16.93C4.07,17.19 3.6,17.12 3.4,16.93L2.2,15.83C1.88,15.5 1.92,14.96 2.25,14.63L5.25,11.93";
var mdiMicrosoftWindows = "M3,12V6.75L9,5.43V11.91L3,12M20,3V11.75L10,11.9V5.21L20,3M3,13L9,13.09V19.9L3,18.75V13M20,13.25V22L10,20.09V13.1L20,13.25Z";
var mdiMicrosoftWindowsClassic = "M2.67,5.3V5.91L1.96,6.21V5.6L2.67,5.3M2.67,11.24V11.86L1.96,12.15V11.56L2.67,11.24M2.67,17.27V17.89L1.96,18.18V17.59L2.67,17.27M2.6,7.29V7.84L2.03,8.1V7.56L2.6,7.29M2.6,9.28V9.82L2.03,10.08V9.54L2.6,9.28M2.6,13.31V13.84L2.03,14.1V13.56L2.6,13.31M2.6,15.33V15.87L2.03,16.13V15.6L2.6,15.33M4.5,5.64V6.36L3.5,6.73V6L4.5,5.64M4.5,11.66V12.37L3.5,12.74V12.03L4.5,11.66M4.5,17.7V18.41L3.5,18.81V18.1L4.5,17.7M4.43,7.72V8.38L3.64,8.68V8L4.43,7.72M4.43,9.73V10.37L3.65,10.67V10L4.43,9.73M4.43,13.74V14.38L3.65,14.69V14.03L4.43,13.74M4.43,15.76V16.41L3.65,16.72V16.06L4.43,15.76M6.31,6.09V6.94L5.05,7.43V6.59L6.31,6.09M6.31,12.11V12.96L5.05,13.45V12.61L6.31,12.11M6.31,18.08V18.93L5.05,19.43V18.58L6.31,18.08M6.25,8.18V8.94L5.19,9.34V8.61L6.25,8.18M6.25,10.18V10.93L5.19,11.35V10.6L6.25,10.18M6.25,14.19V14.94L5.19,15.37V14.62L6.25,14.19M6.25,16.14V16.9L5.19,17.32V16.57L6.25,16.14M8.29,6.04V7.16L6.72,7.78V6.67L8.29,6.04M8.29,12.06V13.19L6.72,13.8V12.68L8.29,12.06M8.29,18.03V19.15L6.72,19.77V18.66L8.29,18.03M8.2,8.13V9.16L6.89,9.69V8.66L8.2,8.13M8.2,10.13V11.15L6.89,11.68V10.65L8.2,10.13M8.2,14.15V15.18L6.89,15.7V14.67L8.2,14.15M8.2,16.1V17.12L6.89,17.64V16.63L8.2,16.1M10.34,5.85V7.32L8.61,8V6.56L10.34,5.85M10.34,11.87V13.33L8.61,14.03V12.56L10.34,11.87M10.34,17.84V19.3L8.61,20V18.54L10.34,17.84M10.26,8.05V9.28L8.78,9.87V8.64L10.26,8.05M10.26,9.97V11.2L8.78,11.78V10.56L10.26,9.97M10.26,14.06V15.31L8.78,15.88V14.65L10.26,14.06M10.26,16V17.25L8.78,17.84V16.6L10.26,16M12.45,5.12V7.12L10.59,7.89V6C11.23,5.65 11.85,5.35 12.45,5.12M12.45,7.33V9.06L10.59,9.84V8.1L12.45,7.33M12.45,9.28V11.04L10.59,11.82V10.06L12.45,9.28M12.45,11.25V13L10.59,13.77V12L12.45,11.25M12.45,13.21V15L10.59,15.78V14L12.45,13.21M12.45,15.21V16.96L10.59,17.76V16L12.45,15.21M12.45,17.17V19.04C11.72,19.32 11.1,19.59 10.59,19.84V17.96L12.45,17.17M22.04,5.18V19.23C20.85,18.44 19.37,18.05 17.59,18.05C16.12,18.05 14.47,18.35 12.65,18.96V17.06C13.62,16.69 14.68,16.42 15.84,16.26V11.69C14.86,11.81 13.8,12.15 12.65,12.71V11.4C13.64,10.94 14.71,10.63 15.84,10.46V6C14.82,6.18 13.76,6.53 12.65,7V5.03C14.27,4.34 15.86,4 17.41,4C19.09,4 20.63,4.39 22.04,5.18M20.15,6.41C19.39,6 18.5,5.82 17.42,5.82C17.29,5.82 17.17,5.83 17.05,5.84V10.38L17.46,10.37C18.37,10.37 19.27,10.5 20.15,10.8V6.41M20.15,12.1C19.34,11.74 18.43,11.56 17.44,11.56C17.31,11.56 17.18,11.57 17.05,11.58V16.16H17.46C18.45,16.16 19.35,16.28 20.15,16.53V12.1H20.15Z";
var mdiMicrosoftWord = "M21.17 3.25Q21.5 3.25 21.76 3.5 22 3.74 22 4.08V19.92Q22 20.26 21.76 20.5 21.5 20.75 21.17 20.75H7.83Q7.5 20.75 7.24 20.5 7 20.26 7 19.92V17H2.83Q2.5 17 2.24 16.76 2 16.5 2 16.17V7.83Q2 7.5 2.24 7.24 2.5 7 2.83 7H7V4.08Q7 3.74 7.24 3.5 7.5 3.25 7.83 3.25M7.03 11.34L8.23 15.28H9.6L10.91 8.72H9.53L8.75 12.6L7.64 8.85H6.5L5.31 12.62L4.53 8.72H3.09L4.4 15.28H5.77M20.75 19.5V17H8.25V19.5M20.75 15.75V12.63H12V15.75M20.75 11.38V8.25H12V11.38M20.75 7V4.5H8.25V7Z";
var mdiMicrosoftXbox = "M6.43,3.72C6.5,3.66 6.57,3.6 6.62,3.56C8.18,2.55 10,2 12,2C13.88,2 15.64,2.5 17.14,3.42C17.25,3.5 17.54,3.69 17.7,3.88C16.25,2.28 12,5.7 12,5.7C10.5,4.57 9.17,3.8 8.16,3.5C7.31,3.29 6.73,3.5 6.46,3.7M19.34,5.21C19.29,5.16 19.24,5.11 19.2,5.06C18.84,4.66 18.38,4.56 18,4.59C17.61,4.71 15.9,5.32 13.8,7.31C13.8,7.31 16.17,9.61 17.62,11.96C19.07,14.31 19.93,16.16 19.4,18.73C21,16.95 22,14.59 22,12C22,9.38 21,7 19.34,5.21M15.73,12.96C15.08,12.24 14.13,11.21 12.86,9.95C12.59,9.68 12.3,9.4 12,9.1C12,9.1 11.53,9.56 10.93,10.17C10.16,10.94 9.17,11.95 8.61,12.54C7.63,13.59 4.81,16.89 4.65,18.74C4.65,18.74 4,17.28 5.4,13.89C6.3,11.68 9,8.36 10.15,7.28C10.15,7.28 9.12,6.14 7.82,5.35L7.77,5.32C7.14,4.95 6.46,4.66 5.8,4.62C5.13,4.67 4.71,5.16 4.71,5.16C3.03,6.95 2,9.35 2,12A10,10 0 0,0 12,22C14.93,22 17.57,20.74 19.4,18.73C19.4,18.73 19.19,17.4 17.84,15.5C17.53,15.07 16.37,13.69 15.73,12.96Z";
var mdiMicrosoftXboxController = "M8.75,15.75C6.75,15.75 6,18 4,19C2,19 0.5,16 4.5,7.5H4.75L5.19,6.67C5.19,6.67 8,5 9.33,6.23H14.67C16,5 18.81,6.67 18.81,6.67L19.25,7.5H19.5C23.5,16 22,19 20,19C18,18 17.25,15.75 15.25,15.75H8.75M12,7A1,1 0 0,0 11,8A1,1 0 0,0 12,9A1,1 0 0,0 13,8A1,1 0 0,0 12,7Z";
var mdiMicrosoftXboxControllerBatteryAlert = "M21,19V7H15V19H21M21.67,5C22.4,5 23,5.6 23,6.33V19.67A1.33,1.33 0 0,1 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33A1.33,1.33 0 0,1 14.33,5H16V3H20V5H21.67M11,8A1,1 0 0,0 10,9A1,1 0 0,0 11,10A1,1 0 0,0 12,9A1,1 0 0,0 11,8M17,9H19V14H17V9M17,15H19V17H17V15Z";
var mdiMicrosoftXboxControllerBatteryCharging = "M20,5H21.67C22.4,5 23,5.6 23,6.33V19.67A1.33,1.33 0 0,1 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33A1.33,1.33 0 0,1 14.33,5H16V3H20V5M21,7H15V19H21V7M15.5,14L18.5,7.5V12H20.5L17.5,18.5V14H15.5M11,8A1,1 0 0,0 10,9A1,1 0 0,0 11,10A1,1 0 0,0 12,9A1,1 0 0,0 11,8Z";
var mdiMicrosoftXboxControllerBatteryEmpty = "M21,19V7H15V19H21M21.67,5C22.4,5 23,5.6 23,6.33V19.67A1.33,1.33 0 0,1 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33A1.33,1.33 0 0,1 14.33,5H16V3H20V5H21.67M11,8A1,1 0 0,0 10,9A1,1 0 0,0 11,10A1,1 0 0,0 12,9A1,1 0 0,0 11,8Z";
var mdiMicrosoftXboxControllerBatteryFull = "M21.67,5C22.4,5 23,5.6 23,6.33V19.67A1.33,1.33 0 0,1 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33A1.33,1.33 0 0,1 14.33,5H16V3H20V5H21.67M11,8A1,1 0 0,0 10,9A1,1 0 0,0 11,10A1,1 0 0,0 12,9A1,1 0 0,0 11,8Z";
var mdiMicrosoftXboxControllerBatteryLow = "M21,16V7H15V16H21M21.67,5C22.4,5 23,5.6 23,6.33V19.67A1.33,1.33 0 0,1 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33A1.33,1.33 0 0,1 14.33,5H16V3H20V5H21.67M11,8A1,1 0 0,0 10,9A1,1 0 0,0 11,10A1,1 0 0,0 12,9A1,1 0 0,0 11,8Z";
var mdiMicrosoftXboxControllerBatteryMedium = "M21,12V7H15V12H21M21.67,5C22.4,5 23,5.6 23,6.33V19.67A1.33,1.33 0 0,1 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33A1.33,1.33 0 0,1 14.33,5H16V3H20V5H21.67M11,8A1,1 0 0,0 10,9A1,1 0 0,0 11,10A1,1 0 0,0 12,9A1,1 0 0,0 11,8Z";
var mdiMicrosoftXboxControllerBatteryUnknown = "M21.67,5C22.4,5 23,5.6 23,6.33V19.67A1.33,1.33 0 0,1 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33A1.33,1.33 0 0,1 14.33,5H16V3H20V5H21.67M11,8A1,1 0 0,0 10,9A1,1 0 0,0 11,10A1,1 0 0,0 12,9A1,1 0 0,0 11,8M18.19,8C17.32,8 16.62,8.2 16.08,8.59C15.56,9 15.3,9.57 15.31,10.36L15.32,10.39H17.25C17.26,10.09 17.35,9.86 17.53,9.7C17.71,9.55 17.93,9.47 18.19,9.47C18.5,9.47 18.76,9.57 18.94,9.75C19.12,9.94 19.2,10.2 19.2,10.5C19.2,10.82 19.13,11.09 18.97,11.32C18.83,11.55 18.62,11.75 18.36,11.91C17.85,12.25 17.5,12.55 17.31,12.82C17.11,13.08 17,13.5 17,14H19C19,13.69 19.04,13.44 19.13,13.26C19.22,13.08 19.39,12.9 19.64,12.74C20.09,12.5 20.46,12.21 20.75,11.81C21.04,11.41 21.19,11 21.19,10.5C21.19,9.74 20.92,9.13 20.38,8.68C19.85,8.23 19.12,8 18.19,8M17,15V17H19V15H17Z";
var mdiMicrosoftXboxControllerMenu = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M6,7H18V9H6V7M6,11H18V13H6V11M6,15H18V17H6V15Z";
var mdiMicrosoftXboxControllerOff = "M2,5.27L3.28,4L20,20.72L18.73,22L12.5,15.75H8.75C6.75,15.75 6,18 4,19C2,19 0.5,16.04 4.42,7.69L2,5.27M9.33,6.23H14.67C16,5 18.81,6.67 18.81,6.67L19.25,7.5H19.5C23,15 22.28,18.2 20.69,18.87L7.62,5.8C8.25,5.73 8.87,5.81 9.33,6.23M12,7A1,1 0 0,0 11,8A1,1 0 0,0 12,9A1,1 0 0,0 13,8A1,1 0 0,0 12,7Z";
var mdiMicrosoftXboxControllerView = "M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M6,7H15V9H8V14H6V7M9,10H18V17H9V10M11,12V15H16V12H11Z";
var mdiMicrowave = "M4,5A2,2 0 0,0 2,7V17A2,2 0 0,0 4,19H20A2,2 0 0,0 22,17V7A2,2 0 0,0 20,5H4M4,7H16V17H4V7M19,7A1,1 0 0,1 20,8A1,1 0 0,1 19,9A1,1 0 0,1 18,8A1,1 0 0,1 19,7M13,9V15H15V9H13M19,11A1,1 0 0,1 20,12A1,1 0 0,1 19,13A1,1 0 0,1 18,12A1,1 0 0,1 19,11Z";
var mdiMicrowaveOff = "M22.11 21.46L2.39 1.73L1.11 3L3.26 5.15C2.5 5.44 2 6.16 2 7V17C2 18.11 2.9 19 4 19H17.11L20.84 22.73L22.11 21.46M4 17V7H5.11L15.11 17H4M16 7V12.8L21.5 18.31C21.81 17.95 22 17.5 22 17V7C22 5.9 21.11 5 20 5H8.2L10.2 7H16M19 7C19.55 7 20 7.45 20 8S19.55 9 19 9 18 8.55 18 8 18.45 7 19 7M19 11C19.55 11 20 11.45 20 12S19.55 13 19 13 18 12.55 18 12 18.45 11 19 11M13 9.8V9H15V11.8L13 9.8Z";
var mdiMiddleware = "M23 12L19 8V11H14.82C14.4 9.84 13.3 9 12 9S9.6 9.84 9.18 11H5L2 8V16L5 13H9.18C9.6 14.16 10.7 15 12 15S14.4 14.16 14.82 13H19V16L23 12Z";
var mdiMiddlewareOutline = "M23 12L19 8V11H15.86C15.41 9.28 13.86 8 12 8S8.59 9.28 8.14 11H5L2 8V16L5 13H8.14C8.59 14.72 10.14 16 12 16S15.41 14.72 15.86 13H19V16L23 12M12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10S14 10.9 14 12C14 13.1 13.1 14 12 14Z";
var mdiMidi = "M20.15 8.26H22V15.74H20.15M13 8.26H18.43C19 8.26 19.3 8.74 19.3 9.3V14.81C19.3 15.5 19 15.74 18.38 15.74H13V11H14.87V13.91H17.5V9.95H13M10.32 8.26H12.14V15.74H10.32M2 8.26H8.55C9.1 8.26 9.41 8.74 9.41 9.3V15.74H7.59V10.15H6.5V15.74H4.87V10.15H3.83V15.74H2Z";
var mdiMidiPort = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M20.18,12C20.18,8.18 17.55,4.96 14,4.07V6H10V4.07C6.45,4.96 3.82,8.18 3.82,12A8.18,8.18 0 0,0 12,20.18A8.18,8.18 0 0,0 20.18,12M7,10.64A1.36,1.36 0 0,1 8.36,12A1.36,1.36 0 0,1 7,13.36C6.25,13.36 5.64,12.75 5.64,12C5.64,11.25 6.25,10.64 7,10.64M17,10.64A1.36,1.36 0 0,1 18.36,12A1.36,1.36 0 0,1 17,13.36A1.36,1.36 0 0,1 15.64,12A1.36,1.36 0 0,1 17,10.64M8.36,14.27A1.37,1.37 0 0,1 9.73,15.64C9.73,16.39 9.12,17 8.36,17A1.36,1.36 0 0,1 7,15.64C7,14.88 7.61,14.27 8.36,14.27M15.64,14.27C16.39,14.27 17,14.88 17,15.64A1.36,1.36 0 0,1 15.64,17C14.88,17 14.27,16.39 14.27,15.64A1.37,1.37 0 0,1 15.64,14.27M12,15.64A1.36,1.36 0 0,1 13.36,17A1.36,1.36 0 0,1 12,18.36A1.36,1.36 0 0,1 10.64,17A1.36,1.36 0 0,1 12,15.64Z";
var mdiMine = "M23,13V11H19.93C19.75,9.58 19.19,8.23 18.31,7.1L20.5,4.93L19.07,3.5L16.9,5.69C15.77,4.81 14.42,4.25 13,4.07V1H11V4.07C9.58,4.25 8.23,4.81 7.1,5.69L4.93,3.5L3.5,4.93L5.69,7.1C4.81,8.23 4.25,9.58 4.07,11H1V13H4.07C4.25,14.42 4.81,15.77 5.69,16.9L3.5,19.07L4.93,20.5L7.1,18.31C8.23,19.19 9.58,19.75 11,19.93V23H13V19.93C14.42,19.75 15.77,19.19 16.9,18.31L19.07,20.5L20.5,19.07L18.31,16.9C19.19,15.77 19.75,14.42 19.93,13H23M12,8A4,4 0 0,0 8,12H6A6,6 0 0,1 12,6V8Z";
var mdiMinecraft = "M4,2H20A2,2 0 0,1 22,4V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V4A2,2 0 0,1 4,2M6,6V10H10V12H8V18H10V16H14V18H16V12H14V10H18V6H14V10H10V6H6Z";
var mdiMiniSd = "M6,4A2,2 0 0,0 4,6V18A2,2 0 0,0 6,20H18A2,2 0 0,0 20,18V12L18,10V6A2,2 0 0,0 16,4H6M7,6H9V10H7V6M10,6H12V10H10V6M13,6H15V10H13V6Z";
var mdiMinidisc = "M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H5M12,5C15.09,5 17.82,7.04 18.7,10H16A1,1 0 0,0 15,11V13A1,1 0 0,0 16,14H18.71C17.82,16.97 15.09,19 12,19A7,7 0 0,1 5,12A7,7 0 0,1 12,5M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z";
var mdiMinus = "M19,13H5V11H19V13Z";
var mdiMinusBox = "M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiMinusBoxMultiple = "M19 11H9V9H19M20 2H8C6.9 2 6 2.9 6 4V16C6 17.11 6.9 18 8 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M4 6H2V20C2 21.11 2.9 22 4 22H18V20H4V6Z";
var mdiMinusBoxMultipleOutline = "M18 11H10V9H18M20 4V16H8V4H20M20 2H8C6.9 2 6 2.9 6 4V16C6 17.11 6.9 18 8 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M4 6H2V20C2 21.11 2.9 22 4 22H18V20H4V6Z";
var mdiMinusBoxOutline = "M19,19V5H5V19H19M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5C3,3.89 3.9,3 5,3H19M17,11V13H7V11H17Z";
var mdiMinusCircle = "M17,13H7V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiMinusCircleMultiple = "M2 12C2 9.21 3.64 6.8 6 5.68V3.5C2.5 4.76 0 8.09 0 12S2.5 19.24 6 20.5V18.32C3.64 17.2 2 14.79 2 12M15 3C10.04 3 6 7.04 6 12S10.04 21 15 21 24 16.96 24 12 19.96 3 15 3M20 13H10V11H20V13Z";
var mdiMinusCircleMultipleOutline = "M11 11V13H19V11H11M2 12C2 9.21 3.64 6.8 6 5.68V3.5C2.5 4.76 0 8.09 0 12S2.5 19.24 6 20.5V18.32C3.64 17.2 2 14.79 2 12M15 3C10.04 3 6 7.04 6 12S10.04 21 15 21 24 16.96 24 12 19.96 3 15 3M15 19C11.14 19 8 15.86 8 12S11.14 5 15 5 22 8.14 22 12 18.86 19 15 19Z";
var mdiMinusCircleOff = "M22.1 21.5L2.4 1.7L1.1 3L4.1 6C2.8 7.6 2 9.7 2 12C2 17.5 6.5 22 12 22C14.3 22 16.4 21.2 18 19.9L20.8 22.7L22.1 21.5M7 13V11H9.1L11.1 13H7M14.2 11L6.7 3.5C8.3 2.6 10.1 2 12 2C17.5 2 22 6.5 22 12C22 13.9 21.4 15.7 20.5 17.3L16.2 13H17V11H14.2Z";
var mdiMinusCircleOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L4.1 6C2.8 7.6 2 9.7 2 12C2 17.5 6.5 22 12 22C14.3 22 16.4 21.2 18 19.9L20.8 22.7L22.1 21.5M12 20C7.6 20 4 16.4 4 12C4 10.3 4.6 8.7 5.5 7.4L9.1 11H7V13H11.1L16.6 18.5C15.3 19.4 13.7 20 12 20M8.2 5L6.7 3.5C8.3 2.6 10.1 2 12 2C17.5 2 22 6.5 22 12C22 13.9 21.4 15.7 20.5 17.3L19 15.8C19.6 14.7 20 13.4 20 12C20 7.6 16.4 4 12 4C10.6 4 9.3 4.4 8.2 5M16.2 13L14.2 11H17V13H16.2Z";
var mdiMinusCircleOutline = "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,13H17V11H7";
var mdiMinusNetwork = "M16,11V9H8V11H16M17,3A2,2 0 0,1 19,5V15A2,2 0 0,1 17,17H13V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H7C5.89,17 5,16.1 5,15V5A2,2 0 0,1 7,3H17Z";
var mdiMinusNetworkOutline = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M7,15V5H17V15H7M15,11V9H9V11H15";
var mdiMinusThick = "M20 14H4V10H20";
var mdiMirror = "M12 1C16.69 1 20.5 5.93 20.5 12C20.5 18.08 16.69 23 12 23C7.31 23 3.5 18.08 3.5 12C3.5 5.93 7.31 1 12 1M12 3C8.41 3 5.5 7.03 5.5 12C5.5 16.97 8.41 21 12 21C15.59 21 18.5 16.97 18.5 12C18.5 7.03 15.59 3 12 3M8.29 10.28L11.53 7.03L12.59 8.09L9.35 11.34L8.29 10.28M8.7 14.61L14.36 8.95L15.42 10L9.76 15.67L8.7 14.61Z";
var mdiMirrorRectangle = "M8.29 10.28L11.53 7.03L12.59 8.09L9.35 11.34L8.29 10.28M8.7 14.61L14.36 8.95L15.42 10L9.76 15.67L8.7 14.61M18 3V21H6V3H18M20 1H4V23H20V1Z";
var mdiMirrorVariant = "M8.29 10.28L11.53 7.03L12.59 8.09L9.35 11.34L8.29 10.28M8.7 14.61L14.36 8.95L15.42 10L9.76 15.67L8.7 14.61M14.17 3L18 6.83V17.17L14.17 21H9.83L6 17.17V6.83L9.83 3H14.17M15 1H9L4 6V18L9 23H15L20 18V6L15 1Z";
var mdiMixedMartialArts = "M15,10V7H7V10H15M18,7C18.28,7 18.5,7.09 18.7,7.29C18.89,7.5 19,7.73 19,8V10.78C19,10.97 18.97,11.11 18.94,11.2L18.14,15.19C18,15.72 17.7,16 17.2,16H6.8C6.27,16 5.95,15.72 5.86,15.19L5.06,11.2C5.03,11.11 5,10.97 5,10.78V5C5,4.5 5.21,4 5.6,3.61C6,3.2 6.45,3 7,3H15C15.53,3 16,3.2 16.41,3.61C16.81,4 17,4.5 17,5V8C17,7.73 17.11,7.5 17.3,7.29C17.5,7.09 17.72,7 18,7M7,20V17H17V20C17,20.3 16.91,20.53 16.71,20.72C16.5,20.91 16.27,21 16,21H8C7.73,21 7.5,20.91 7.29,20.72C7.09,20.53 7,20.3 7,20Z";
var mdiMixedReality = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3M8.25,15H9.75L10.75,11.57V15H12.25V9H10L9,12.43L8,9H5.75V15H7.25V11.57L8.25,15M13.5,9V15H15V13H16.15L17,15H18.5L17.6,12.9C18.1,12.65 18.5,12.1 18.5,11.5V10.5C18.5,9.65 17.85,9 17,9H13.5M15,10.5H17V11.5H15V10.5Z";
var mdiMolecule = "M7.27,10L9,7H14.42L15.58,5L15.5,4.5A1.5,1.5 0 0,1 17,3A1.5,1.5 0 0,1 18.5,4.5C18.5,5.21 18,5.81 17.33,5.96L16.37,7.63L17.73,10L18.59,8.5L18.5,8A1.5,1.5 0 0,1 20,6.5A1.5,1.5 0 0,1 21.5,8C21.5,8.71 21,9.3 20.35,9.46L18.89,12L20.62,15C21.39,15.07 22,15.71 22,16.5A1.5,1.5 0 0,1 20.5,18A1.5,1.5 0 0,1 19,16.5V16.24L17.73,14L16.37,16.37L17.33,18.04C18,18.19 18.5,18.79 18.5,19.5A1.5,1.5 0 0,1 17,21A1.5,1.5 0 0,1 15.5,19.5L15.58,19L14.42,17H10.58L9.42,19L9.5,19.5A1.5,1.5 0 0,1 8,21A1.5,1.5 0 0,1 6.5,19.5C6.5,18.79 7,18.19 7.67,18.04L8.63,16.37L4.38,9C3.61,8.93 3,8.29 3,7.5A1.5,1.5 0 0,1 4.5,6A1.5,1.5 0 0,1 6,7.5C6,7.59 6,7.68 6,7.76L7.27,10M10.15,9L8.42,12L10.15,15H14.85L16.58,12L14.85,9H10.15Z";
var mdiMoleculeCo = "M8 7C6.9 7 6 7.9 6 9V15C6 16.11 6.9 17 8 17H11V15H8V9H11V7H8M14 7C12.9 7 12 7.9 12 9V15C12 16.11 12.9 17 14 17H16C17.11 17 18 16.11 18 15V9C18 7.9 17.11 7 16 7H14M14 9H16V15H14V9";
var mdiMoleculeCo2 = "M5,7A2,2 0 0,0 3,9V15A2,2 0 0,0 5,17H8V15H5V9H8V7H5M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11M11,9H13V15H11V9M16,10.5V12H19V13.5H17.5A1.5,1.5 0 0,0 16,15V18H20.5V16.5H17.5V15H19A1.5,1.5 0 0,0 20.5,13.5V12A1.5,1.5 0 0,0 19,10.5H16Z";
var mdiMonitor = "M21,16H3V4H21M21,2H3C1.89,2 1,2.89 1,4V16A2,2 0 0,0 3,18H10V20H8V22H16V20H14V18H21A2,2 0 0,0 23,16V4C23,2.89 22.1,2 21,2Z";
var mdiMonitorAccount = "M21 2C22.05 2 22.92 2.81 23 3.85L23 4V16C23 17.05 22.18 17.92 21.15 18L21 18H14V20H16V22H8V20H10V18H3C1.95 18 1.08 17.18 1 16.15L1 16V4C1 2.94 1.81 2.08 2.85 2L3 2H21M21 4H3V16H21V4M12 11C14.21 11 16 11.9 16 13V14H8V13C8 11.9 9.79 11 12 11M12 6C13.11 6 14 6.9 14 8S13.11 10 12 10 10 9.11 10 8 10.9 6 12 6Z";
var mdiMonitorArrowDown = "M21 16H3V4H21M21 2H3C1.9 2 1 2.9 1 4V16C1 17.1 1.9 18 3 18H10V20H8V22H16V20H14V18H21C22.1 18 23 17.1 23 16V4C23 2.9 22.1 2 21 2M16 10H13V6H11V10H8L12 14L16 10";
var mdiMonitorArrowDownVariant = "M17 14L22 9L20.6 7.6L18 10.2V3H16V10.2L13.4 7.6L12 9L17 14M23 14V16C23 17.1 22.1 18 21 18H14V20H16V22H8V20H10V18H3C1.9 18 1 17.1 1 16V4C1 2.9 1.9 2 3 2H12V4H3V16H21V14H23Z";
var mdiMonitorCellphone = "M23,11H18A1,1 0 0,0 17,12V21A1,1 0 0,0 18,22H23A1,1 0 0,0 24,21V12A1,1 0 0,0 23,11M23,20H18V13H23V20M20,2H2C0.89,2 0,2.89 0,4V16A2,2 0 0,0 2,18H9V20H7V22H15V20H13V18H15V16H2V4H20V9H22V4C22,2.89 21.1,2 20,2Z";
var mdiMonitorCellphoneStar = "M23,11H18A1,1 0 0,0 17,12V21A1,1 0 0,0 18,22H23A1,1 0 0,0 24,21V12A1,1 0 0,0 23,11M23,20H18V13H23V20M20,2H2C0.89,2 0,2.89 0,4V16A2,2 0 0,0 2,18H9V20H7V22H15V20H13V18H15V16H2V4H20V9H22V4C22,2.89 21.1,2 20,2M11.97,9L11,6L10.03,9H7L9.47,10.76L8.53,13.67L11,11.87L13.47,13.67L12.53,10.76L15,9H11.97Z";
var mdiMonitorDashboard = "M21,16V4H3V16H21M21,2A2,2 0 0,1 23,4V16A2,2 0 0,1 21,18H14V20H16V22H8V20H10V18H3C1.89,18 1,17.1 1,16V4C1,2.89 1.89,2 3,2H21M5,6H14V11H5V6M15,6H19V8H15V6M19,9V14H15V9H19M5,12H9V14H5V12M10,12H14V14H10V12Z";
var mdiMonitorEdit = "M21 2H3C1.9 2 1 2.9 1 4V16C1 17.11 1.9 18 3 18H10V20H8V22H16V20H14V18H21C22.11 18 23 17.11 23 16V4C23 2.9 22.11 2 21 2M21 16H3V4H21V16M15.84 8.2L14.83 9.21L12.76 7.18L13.77 6.16C13.97 5.95 14.31 5.94 14.55 6.16L15.84 7.41C16.05 7.62 16.06 7.96 15.84 8.2M8 11.91L12.17 7.72L14.24 9.8L10.08 14H8V11.91Z";
var mdiMonitorEye = "M3 4V16H21V4H3M3 2H21C22.1 2 23 2.89 23 4V16C23 16.53 22.79 17.04 22.41 17.41C22.04 17.79 21.53 18 21 18H14V20H16V22H8V20H10V18H3C2.47 18 1.96 17.79 1.59 17.41C1.21 17.04 1 16.53 1 16V4C1 2.89 1.89 2 3 2M10.84 8.93C11.15 8.63 11.57 8.45 12 8.45C12.43 8.46 12.85 8.63 13.16 8.94C13.46 9.24 13.64 9.66 13.64 10.09C13.64 10.53 13.46 10.94 13.16 11.25C12.85 11.56 12.43 11.73 12 11.73C11.57 11.73 11.15 11.55 10.84 11.25C10.54 10.94 10.36 10.53 10.36 10.09C10.36 9.66 10.54 9.24 10.84 8.93M10.07 12C10.58 12.53 11.28 12.82 12 12.82C12.72 12.82 13.42 12.53 13.93 12C14.44 11.5 14.73 10.81 14.73 10.09C14.73 9.37 14.44 8.67 13.93 8.16C13.42 7.65 12.72 7.36 12 7.36C11.28 7.36 10.58 7.65 10.07 8.16C9.56 8.67 9.27 9.37 9.27 10.09C9.27 10.81 9.56 11.5 10.07 12M6 10.09C6.94 7.7 9.27 6 12 6C14.73 6 17.06 7.7 18 10.09C17.06 12.5 14.73 14.18 12 14.18C9.27 14.18 6.94 12.5 6 10.09Z";
var mdiMonitorLock = "M20.5,13A2.5,2.5 0 0,1 23,15.5V16A1,1 0 0,1 24,17V21A1,1 0 0,1 23,22H18A1,1 0 0,1 17,21V17A1,1 0 0,1 18,16V15.5A2.5,2.5 0 0,1 20.5,13M20.5,14A1.5,1.5 0 0,0 19,15.5V16H22V15.5A1.5,1.5 0 0,0 20.5,14M20,4H2V16H15V18H13V20H15V22H7V20H9V18H2C0.89,18 0,17.1 0,16V4C0,2.89 0.89,2 2,2H20A2,2 0 0,1 22,4V11.53C21.41,11.19 20.73,11 20,11V4Z";
var mdiMonitorMultiple = "M22,17V7H6V17H22M22,5A2,2 0 0,1 24,7V17C24,18.11 23.1,19 22,19H16V21H18V23H10V21H12V19H6C4.89,19 4,18.11 4,17V7A2,2 0 0,1 6,5H22M2,3V15H0V3A2,2 0 0,1 2,1H20V3H2Z";
var mdiMonitorOff = "M14,18V20H16V22H8V20H10V18H3A2,2 0 0,1 1,16V4L0,3L1.41,1.58L22.16,22.34L20.75,23.75L15,18H14M3,16H13L3,6V16M21,2A2,2 0 0,1 23,4V16A2,2 0 0,1 21,18H20.66L18.66,16H21V4H6.66L4.66,2H21Z";
var mdiMonitorScreenshot = "M9,6H5V10H7V8H9M19,10H17V12H15V14H19M21,16H3V4H21M21,2H3C1.89,2 1,2.89 1,4V16A2,2 0 0,0 3,18H10V20H8V22H16V20H14V18H21A2,2 0 0,0 23,16V4C23,2.89 22.1,2 21,2";
var mdiMonitorShare = "M23 4V16C23 17.11 22.11 18 21 18H15V16H21V4H3V16H9V18H3C1.9 18 1 17.11 1 16V4C1 2.89 1.89 2 3 2H21C22.1 2 23 2.89 23 4M13 13H16L12 9L8 13H11V20H8V22H16V20H13V13Z";
var mdiMonitorShimmer = "M21 16H3V4H21M21 2H3C1.89 2 1 2.89 1 4V16C1 17.11 1.9 18 3 18H10V20H8V22H16V20H14V18H21C22.11 18 23 17.11 23 16V4C23 2.89 22.1 2 21 2M15 5.5L14.38 6.87L13 7.5L14.38 8.13L15 9.5L15.63 8.13L17 7.5L15.63 6.87L15 5.5M10.5 7.5L9.41 9.91L7 11L9.41 12.09L10.5 14.5L11.6 12.09L14 11L11.6 9.91L10.5 7.5";
var mdiMonitorSmall = "M19 2H5C3.89 2 3 2.89 3 4V16C3 17.11 3.9 18 5 18H10V20H8V22H16V20H14V18H19C20.11 18 21 17.11 21 16V4C21 2.89 20.1 2 19 2M19 16H5V4H19V16Z";
var mdiMonitorSpeaker = "M3 2C1.9 2 1 2.9 1 4V16C1 17.1 1.9 18 3 18H10V20H8V22H12V16H3V4H21V7H23V4C23 2.9 22.1 2 21 2H3M21 9H16C14.9 9 14 9.9 14 11V20C14 21.1 14.9 22 16 22H21C22.1 22 23 21.1 23 20V11C23 9.9 22.1 9 21 9M18.5 10.5C19.3 10.5 20 11.2 20 12S19.3 13.5 18.5 13.5 17 12.8 17 12 17.7 10.5 18.5 10.5M18.5 20.5C16.8 20.5 15.5 19.2 15.5 17.5C15.5 15.9 16.8 14.5 18.4 14.5H18.5C20.2 14.5 21.5 15.8 21.5 17.5S20.2 20.5 18.5 20.5M18.5 16C17.7 16 17 16.7 17 17.5S17.7 19 18.5 19 20 18.3 20 17.5 19.3 16 18.5 16Z";
var mdiMonitorSpeakerOff = "M2.4 1.7L1.1 3L1.2 3.1C1.1 3.4 1 3.7 1 4V16C1 17.1 1.9 18 3 18H10V20H8V22H12V16H3V4.9L14 15.9V20C14 21.1 14.9 22 16 22H20.1L20.8 22.7C20.8 22.7 22 21.7 22.2 21.5L2.4 1.7M18.5 20.5C16.8 20.5 15.5 19.2 15.5 17.5V17.4L18.6 20.5H18.5M23 4V7H21V4H7.2L5.2 2H21C22.1 2 23 2.9 23 4M21 9H16C15 9 14.1 9.8 14 10.8L17.8 14.6C18 14.5 18.2 14.5 18.5 14.5H18.6C20.3 14.5 21.6 15.8 21.6 17.5C21.6 17.7 21.6 18 21.5 18.2L23.1 19.8V11C23 9.9 22.1 9 21 9M18.5 13.5C17.7 13.5 17 12.8 17 12S17.7 10.5 18.5 10.5 20 11.2 20 12 19.3 13.5 18.5 13.5Z";
var mdiMonitorStar = "M21,16V4H3V16H21M21,2A2,2 0 0,1 23,4V16A2,2 0 0,1 21,18H14V20H16V22H8V20H10V18H3C1.89,18 1,17.1 1,16V4C1,2.89 1.89,2 3,2H21M12.97,9H16L13.53,10.76L14.47,13.67L12,11.87L9.53,13.67L10.47,10.76L8,9H11.03L12,6L12.97,9Z";
var mdiMonitorVertical = "M16 2H8C6.89 2 6 2.89 6 4V16C6 17.11 6.9 18 8 18H10V20H8V22H16V20H14V18H16C17.11 18 18 17.11 18 16V4C18 2.89 17.1 2 16 2M16 16H8V4H16V16Z";
var mdiMoonFirstQuarter = "M12 2V22A10 10 0 0 0 12 2Z";
var mdiMoonFull = "M12 2A10 10 0 1 1 2 12A10 10 0 0 1 12 2Z";
var mdiMoonLastQuarter = "M12 2A10 10 0 0 0 12 22Z";
var mdiMoonNew = "M12 20A8 8 0 1 1 20 12A8 8 0 0 1 12 20M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2Z";
var mdiMoonWaningCrescent = "M2 12A10 10 0 0 0 15 21.54A10 10 0 0 1 15 2.46A10 10 0 0 0 2 12Z";
var mdiMoonWaningGibbous = "M18 12C18 7.5 16.08 3.26 12 2A10 10 0 0 0 12 22C16.08 20.74 18 16.5 18 12Z";
var mdiMoonWaxingCrescent = "M12 2A9.91 9.91 0 0 0 9 2.46A10 10 0 0 1 9 21.54A10 10 0 1 0 12 2Z";
var mdiMoonWaxingGibbous = "M6 12C6 7.5 7.93 3.26 12 2A10 10 0 0 1 12 22C7.93 20.74 6 16.5 6 12Z";
var mdiMoped = "M19 15C19.55 15 20 15.45 20 16C20 16.55 19.55 17 19 17S18 16.55 18 16C18 15.45 18.45 15 19 15M19 13C17.34 13 16 14.34 16 16S17.34 19 19 19 22 17.66 22 16 20.66 13 19 13M10 6H5V8H10V6M17 5H14V7H17V9.65L13.5 14H10V9H6C3.79 9 2 10.79 2 13V16H4C4 17.66 5.34 19 7 19S10 17.66 10 16H14.5L19 10.35V7C19 5.9 18.11 5 17 5M7 17C6.45 17 6 16.55 6 16H8C8 16.55 7.55 17 7 17Z";
var mdiMopedElectric = "M19 5C19 3.9 18.1 3 17 3H14V5H17V7.65L13.5 12H10V7H6C3.79 7 2 8.79 2 11V14H4C4 15.66 5.34 17 7 17S10 15.66 10 14H14.5L19 8.35V5M7 15C6.45 15 6 14.55 6 14H8C8 14.55 7.55 15 7 15M5 4H10V6H5V4M19 11C17.34 11 16 12.34 16 14S17.34 17 19 17 22 15.66 22 14 20.66 11 19 11M19 15C18.45 15 18 14.55 18 14S18.45 13 19 13 20 13.45 20 14 19.55 15 19 15M7 20H11V18L17 21H13V23L7 20Z";
var mdiMopedElectricOutline = "M19 5C19 3.9 18.1 3 17 3H14V5H17V7.65L13.5 12H10V7H6C3.79 7 2 8.79 2 11V14H4C4 15.66 5.34 17 7 17S10 15.66 10 14H14.5L19 8.35V5M4 12V11C4 9.9 4.9 9 6 9H8V12H4M7 15C6.45 15 6 14.55 6 14H8C8 14.55 7.55 15 7 15M5 4H10V6H5V4M19 11C17.34 11 16 12.34 16 14S17.34 17 19 17 22 15.66 22 14 20.66 11 19 11M19 15C18.45 15 18 14.55 18 14S18.45 13 19 13 20 13.45 20 14 19.55 15 19 15M7 20H11V18L17 21H13V23L7 20Z";
var mdiMopedOutline = "M19 7C19 5.9 18.11 5 17 5H14V7H17V9.65L13.5 14H10V9H6C3.79 9 2 10.79 2 13V16H4C4 17.66 5.34 19 7 19S10 17.66 10 16H14.5L19 10.35V7M7 17C6.45 17 6 16.55 6 16H8C8 16.55 7.55 17 7 17M8 14H4V13C4 11.9 4.9 11 6 11H8V14M19 13C17.34 13 16 14.34 16 16S17.34 19 19 19 22 17.66 22 16 20.66 13 19 13M19 17C18.45 17 18 16.55 18 16S18.45 15 19 15 20 15.45 20 16 19.55 17 19 17M10 8H5V6H10V8Z";
var mdiMore = "M19,13.5A1.5,1.5 0 0,1 17.5,12A1.5,1.5 0 0,1 19,10.5A1.5,1.5 0 0,1 20.5,12A1.5,1.5 0 0,1 19,13.5M14,13.5A1.5,1.5 0 0,1 12.5,12A1.5,1.5 0 0,1 14,10.5A1.5,1.5 0 0,1 15.5,12A1.5,1.5 0 0,1 14,13.5M9,13.5A1.5,1.5 0 0,1 7.5,12A1.5,1.5 0 0,1 9,10.5A1.5,1.5 0 0,1 10.5,12A1.5,1.5 0 0,1 9,13.5M22,3H7C6.31,3 5.77,3.35 5.41,3.88L0,12L5.41,20.11C5.77,20.64 6.37,21 7.06,21H22A2,2 0 0,0 24,19V5C24,3.89 23.1,3 22,3Z";
var mdiMortarPestle = "M21 7L19 13L21 19V21H3V19L5 13L3 7V5H15.7L17.2 1L19.5 1.8L18.3 5H21V7Z";
var mdiMortarPestlePlus = "M16,14H13V17H11V14H8V12H11V9H13V12H16M21,5H18.35L19.5,1.85L17.15,1L15.69,5H3V7L5,13L3,19V21H21V19L19,13L21,7V5Z";
var mdiMosque = "M7 8H17C17.3 8 17.6 8.1 17.8 8.1C17.9 7.8 18 7.4 18 7.1C18 5.8 17.4 4.6 16.3 3.9L12 1L7.7 3.8C6.7 4.6 6 5.8 6 7.1C6 7.5 6.1 7.8 6.2 8.1C6.4 8.1 6.7 8 7 8M24 7C24 5.9 22 4 22 4S20 5.9 20 7C20 7.7 20.4 8.4 21 8.7V13H19V11C19 9.9 18.1 9 17 9H7C5.9 9 5 9.9 5 11V13H3V8.7C3.6 8.4 4 7.7 4 7C4 5.9 2 4 2 4S0 5.9 0 7C0 7.7 .4 8.4 1 8.7V21H10V17C10 15.9 10.9 15 12 15S14 15.9 14 17V21H23V8.7C23.6 8.4 24 7.7 24 7Z";
var mdiMosqueOutline = "M24 7C24 5.9 22 4 22 4S20 5.9 20 7C20 7.7 20.4 8.4 21 8.7V13H19V11C19 10.1 18.3 9.3 17.5 9.1C17.8 8.5 18 7.9 18 7.1C18 5.8 17.4 4.6 16.3 3.9L12 1L7.7 3.8C6.7 4.6 6 5.8 6 7.1C6 7.8 6.2 8.5 6.6 9.1C5.7 9.3 5 10.1 5 11V13H3V8.7C3.6 8.4 4 7.7 4 7C4 5.9 2 4 2 4S0 5.9 0 7C0 7.7 .4 8.4 1 8.7V21H11V17C11 16.5 11.4 16 12 16S13 16.5 13 17V21H23V8.7C23.6 8.4 24 7.7 24 7M8.9 5.5L12 3.4L15.1 5.5C15.7 5.9 16 6.4 16 7.1C16 8.1 15.1 9 14.1 9H9.9C8.9 9 8 8.1 8 7.1C8 6.4 8.3 5.9 8.9 5.5M21 19H15V17C15 15.4 13.6 14 12 14S9 15.4 9 17V19H3V15H7V11H17V15H21V19Z";
var mdiMotherHeart = "M12 2C13.66 2 15 3.34 15 5S13.66 8 12 8 9 6.66 9 5 10.34 2 12 2M20 18L18 12.56C17.65 11.57 17.34 10.71 16 10C14.63 9.3 13.63 9 12 9C10.39 9 9.39 9.3 8 10C6.68 10.71 6.37 11.57 6 12.56L4 18C3.77 19.13 6.38 20.44 8.13 21.19C9.34 21.72 10.64 22 12 22C13.38 22 14.67 21.72 15.89 21.19C17.64 20.44 20.25 19.13 20 18M15.42 17.5L12 21L8.58 17.5C8.22 17.12 8 16.61 8 16.05C8 14.92 8.9 14 10 14C10.55 14 11.06 14.23 11.42 14.61L12 15.2L12.58 14.6C12.94 14.23 13.45 14 14 14C15.11 14 16 14.92 16 16.05C16 16.61 15.78 17.13 15.42 17.5Z";
var mdiMotherNurse = "M12,2A3,3 0 0,1 15,5A3,3 0 0,1 12,8A3,3 0 0,1 9,5A3,3 0 0,1 12,2M20,18L18,12.56C17.65,11.57 17.34,10.71 16,10C14.62,9.3 13.62,9 12,9C10.37,9 9.38,9.3 8,10C6.66,10.71 6.35,11.57 6,12.56L4,18C3.68,19.35 6.36,20.44 8.11,21.19V19C8.11,18.05 8.97,17.38 10.69,16.97C10.85,16.93 11,16.91 11.12,16.89C10.58,16.07 10.36,15.34 10.34,15.28L12.11,14.68C12.12,14.7 12.63,16.27 13.84,17.06C14.05,17.13 14.26,17.21 14.46,17.3C15.23,17.64 15.69,18.08 15.84,18.61C14.5,19.14 13.22,19.41 12,19.41L11,19.31V21.94L12,22C13.37,22 14.67,21.72 15.89,21.19C17.64,20.44 20.25,19.13 20,18M15.5,17A1.5,1.5 0 0,1 14,15.5A1.5,1.5 0 0,1 15.5,14A1.5,1.5 0 0,1 17,15.5A1.5,1.5 0 0,1 15.5,17Z";
var mdiMotion = "M7 13H3C2.45 13 2 12.55 2 12S2.45 11 3 11H7C7.55 11 8 11.45 8 12S7.55 13 7 13M6 8C6 7.45 5.55 7 5 7H4C3.45 7 3 7.45 3 8S3.45 9 4 9H5C5.55 9 6 8.55 6 8M22 12C22 14.76 19.76 17 17 17H4C3.45 17 3 16.55 3 16S3.45 15 4 15H13C12.58 14.42 12.25 13.74 12.1 13H10C9.45 13 9 12.55 9 12S9.45 11 10 11H12.1C12.25 10.26 12.58 9.58 13 9H8C7.45 9 7 8.55 7 8S7.45 7 8 7H17C19.76 7 22 9.24 22 12Z";
var mdiMotionOutline = "M7 13H3C2.45 13 2 12.55 2 12S2.45 11 3 11H7C7.55 11 8 11.45 8 12S7.55 13 7 13M6 8C6 7.45 5.55 7 5 7H4C3.45 7 3 7.45 3 8S3.45 9 4 9H5C5.55 9 6 8.55 6 8M22 12C22 14.76 19.76 17 17 17H4C3.45 17 3 16.55 3 16S3.45 15 4 15H13C12.58 14.42 12.25 13.74 12.1 13H10C9.45 13 9 12.55 9 12S9.45 11 10 11H12.1C12.25 10.26 12.58 9.58 13 9H8C7.45 9 7 8.55 7 8S7.45 7 8 7H17C19.76 7 22 9.24 22 12M20 12C20 10.35 18.65 9 17 9S14 10.35 14 12C14 13.65 15.35 15 17 15S20 13.65 20 12Z";
var mdiMotionPause = "M22 12C22 6.46 17.54 2 12 2C10.83 2 9.7 2.19 8.62 2.56L9.32 4.5C10.17 4.16 11.06 3.97 12 3.97C16.41 3.97 20.03 7.59 20.03 12C20.03 16.41 16.41 20.03 12 20.03C7.59 20.03 3.97 16.41 3.97 12C3.97 11.06 4.16 10.12 4.5 9.28L2.56 8.62C2.19 9.7 2 10.83 2 12C2 17.54 6.46 22 12 22C17.54 22 22 17.54 22 12M5.47 3.97C6.32 3.97 7 4.68 7 5.47C7 6.32 6.32 7 5.47 7C4.68 7 3.97 6.32 3.97 5.47C3.97 4.68 4.68 3.97 5.47 3.97M18 12C18 8.67 15.33 6 12 6C8.67 6 6 8.67 6 12C6 15.33 8.67 18 12 18C15.33 18 18 15.33 18 12M11 9V15H9V9M15 9V15H13V9";
var mdiMotionPauseOutline = "M22 12C22 6.46 17.54 2 12 2C10.83 2 9.7 2.19 8.62 2.56L9.32 4.5C10.17 4.16 11.06 3.97 12 3.97C16.41 3.97 20.03 7.59 20.03 12C20.03 16.41 16.41 20.03 12 20.03C7.59 20.03 3.97 16.41 3.97 12C3.97 11.06 4.16 10.12 4.5 9.28L2.56 8.62C2.19 9.7 2 10.83 2 12C2 17.54 6.46 22 12 22C17.54 22 22 17.54 22 12M5.47 7C4.68 7 3.97 6.32 3.97 5.47C3.97 4.68 4.68 3.97 5.47 3.97C6.32 3.97 7 4.68 7 5.47C7 6.32 6.32 7 5.47 7M9 9H11V15H9M13 9H15V15H13";
var mdiMotionPlay = "M22 12C22 6.46 17.54 2 12 2C10.83 2 9.7 2.19 8.62 2.56L9.32 4.5C10.17 4.16 11.06 3.97 12 3.97C16.41 3.97 20.03 7.59 20.03 12C20.03 16.41 16.41 20.03 12 20.03C7.59 20.03 3.97 16.41 3.97 12C3.97 11.06 4.16 10.12 4.5 9.28L2.56 8.62C2.19 9.7 2 10.83 2 12C2 17.54 6.46 22 12 22C17.54 22 22 17.54 22 12M5.47 3.97C6.32 3.97 7 4.68 7 5.47C7 6.32 6.32 7 5.47 7C4.68 7 3.97 6.32 3.97 5.47C3.97 4.68 4.68 3.97 5.47 3.97M18 12C18 8.67 15.33 6 12 6C8.67 6 6 8.67 6 12C6 15.33 8.67 18 12 18C15.33 18 18 15.33 18 12M15 12L10 15V9";
var mdiMotionPlayOutline = "M10 16.5L16 12L10 7.5M22 12C22 6.46 17.54 2 12 2C10.83 2 9.7 2.19 8.62 2.56L9.32 4.5C10.17 4.16 11.06 3.97 12 3.97C16.41 3.97 20.03 7.59 20.03 12C20.03 16.41 16.41 20.03 12 20.03C7.59 20.03 3.97 16.41 3.97 12C3.97 11.06 4.16 10.12 4.5 9.28L2.56 8.62C2.19 9.7 2 10.83 2 12C2 17.54 6.46 22 12 22C17.54 22 22 17.54 22 12M5.47 3.97C6.32 3.97 7 4.68 7 5.47C7 6.32 6.32 7 5.47 7C4.68 7 3.97 6.32 3.97 5.47C3.97 4.68 4.68 3.97 5.47 3.97Z";
var mdiMotionSensor = "M10,0.2C9,0.2 8.2,1 8.2,2C8.2,3 9,3.8 10,3.8C11,3.8 11.8,3 11.8,2C11.8,1 11,0.2 10,0.2M15.67,1A7.33,7.33 0 0,0 23,8.33V7A6,6 0 0,1 17,1H15.67M18.33,1C18.33,3.58 20.42,5.67 23,5.67V4.33C21.16,4.33 19.67,2.84 19.67,1H18.33M21,1A2,2 0 0,0 23,3V1H21M7.92,4.03C7.75,4.03 7.58,4.06 7.42,4.11L2,5.8V11H3.8V7.33L5.91,6.67L2,22H3.8L6.67,13.89L9,17V22H10.8V15.59L8.31,11.05L9.04,8.18L10.12,10H15V8.2H11.38L9.38,4.87C9.08,4.37 8.54,4.03 7.92,4.03Z";
var mdiMotionSensorOff = "M11.4 8.2H15V10H13.2L11.4 8.2M19.67 1H18.33C18.33 3.58 20.42 5.67 23 5.67V4.33C21.16 4.33 19.67 2.84 19.67 1M21 1C21 2.11 21.9 3 23 3V1H21M17 1H15.67C15.67 5.05 18.95 8.33 23 8.33V7C19.69 7 17 4.31 17 1M10 3.8C11 3.8 11.8 3 11.8 2S11 .2 10 .2 8.2 1 8.2 2 9 3.8 10 3.8M2.39 1.73L1.11 3L3.46 5.35L2 5.8V11H3.8V7.33L5.05 6.94L5.68 7.57L2 22H3.8L6.67 13.89L9 17V22H10.8V15.59L8.31 11.05L8.5 10.37L20.84 22.73L22.11 21.46L2.39 1.73M9.38 4.87C9.08 4.37 8.54 4.03 7.92 4.03C7.75 4.03 7.58 4.06 7.42 4.11L7.34 4.14L11.35 8.15L9.38 4.87Z";
var mdiMotorbike = "M17.42,10L13.41,6H9V8H12.59L14.59,10H6.5C4,10 2,12 2,14.5C2,17 4,19 6.5,19C8.72,19 10.56,17.38 10.92,15.27L13.04,14C13,14.17 13,14.33 13,14.5C13,17 15,19 17.5,19C20,19 22,17 22,14.5C22,12 20,10 17.5,10M8.84,15.26C8.5,16.27 7.58,17 6.47,17C5.09,17 3.97,15.88 3.97,14.5C3.97,13.12 5.09,12 6.47,12C7.59,12 8.5,12.74 8.84,13.75H6V15.25L8.84,15.26M17.47,17C16.09,17 14.97,15.88 14.97,14.5C14.97,13.12 16.09,12 17.47,12A2.5,2.5 0 0,1 19.97,14.5A2.5,2.5 0 0,1 17.47,17Z";
var mdiMotorbikeElectric = "M17.42 8L13.41 4H9V6H12.59L14.59 8H6.5C4 8 2 10 2 12.5S4 17 6.5 17C8.72 17 10.56 15.38 10.92 13.27L13.04 12C13 12.17 13 12.33 13 12.5C13 15 15 17 17.5 17S22 15 22 12.5 20 8 17.5 8M8.84 13.26C8.5 14.27 7.58 15 6.47 15C5.09 15 3.97 13.88 3.97 12.5S5.09 10 6.47 10C7.59 10 8.5 10.74 8.84 11.75H6V13.25L8.84 13.26M17.47 15C16.09 15 14.97 13.88 14.97 12.5S16.09 10 17.47 10C18.85 10 19.97 11.12 19.97 12.5S18.85 15 17.47 15M11 20H7L13 23V21H17L11 18V20Z";
var mdiMotorbikeOff = "M22.1 21.5L2.4 1.7L1.1 3L8.1 10H6.5C4 10 2 12 2 14.5S4 19 6.5 19C8.7 19 10.6 17.4 10.9 15.3L12.4 14.4L13 15C13.2 17.1 14.9 18.8 17 19L20.8 22.8L22.1 21.5M8.8 15.3C8.5 16.3 7.5 17 6.4 17C5.1 17 4 15.9 4 14.5S5.1 12 6.5 12C7.6 12 8.5 12.7 8.9 13.8H6V15.3H8.8M11.2 8L9.2 6H13.4L17.4 10H17.5C20 10 22 12 22 14.5C22 15.7 21.5 16.8 20.8 17.6L19.4 16.2C19.8 15.8 20 15.2 20 14.6C20 13.2 18.9 12.1 17.5 12.1C16.9 12.1 16.3 12.3 15.9 12.7L13.2 10H14.6L12.6 8H11.2Z";
var mdiMouse = "M11,1.07C7.05,1.56 4,4.92 4,9H11M4,15A8,8 0 0,0 12,23A8,8 0 0,0 20,15V11H4M13,1.07V9H20C20,4.92 16.94,1.56 13,1.07Z";
var mdiMouseBluetooth = "M20,7H20.5L23.35,9.85L21.21,12L23.35,14.14L20.5,17H20V13.21L17.71,15.5L17,14.79L19.79,12L17,9.21L17.71,8.5L20,10.79V7M21,8.91V10.79L21.94,9.85L21,8.91M21,13.21V15.08L21.94,14.14L21,13.21M15,9V10H9V2.07C12.39,2.56 15,5.47 15,9M1,10V9C1,5.47 3.61,2.56 7,2.07V10H1M15,15A7,7 0 0,1 8,22A7,7 0 0,1 1,15V12H15V15Z";
var mdiMouseLeftClick = "M13 9V1.07C16.94 1.56 20 4.92 20 9H13M6.34 20.66C4.84 19.16 4 17.12 4 15V11H20V15C20 17.12 19.16 19.16 17.66 20.66C16.16 22.16 14.12 23 12 23C9.88 23 7.84 22.16 6.34 20.66M11 9V1.07C10.3 1.16 9.63 1.33 9 1.59C6.67 2.53 4.89 4.53 4.25 7C4.09 7.64 4 8.31 4 9H11M6.34 7C6.82 5.65 7.78 4.5 9 3.81V7H6.34Z";
var mdiMouseLeftClickOutline = "M13 9V1.07C13.7 1.16 14.37 1.33 15 1.59C17.33 2.53 19.11 4.53 19.75 7C19.91 7.64 20 8.31 20 9H13M17.66 7C17.18 5.65 16.23 4.5 15 3.81V7H17.66M6 15V13H18V15C18 16.59 17.37 18.12 16.24 19.24C15.12 20.37 13.59 21 12 21C10.41 21 8.88 20.37 7.76 19.24C6.63 18.12 6 16.59 6 15M4 15C4 17.12 4.84 19.16 6.34 20.66C7.84 22.16 9.88 23 12 23C14.12 23 16.16 22.16 17.66 20.66C19.16 19.16 20 17.12 20 15V11H4V15M11 9V1.07C7.06 1.56 4 4.92 4 9H11Z";
var mdiMouseMoveDown = "M7 9H2C2 6.04 4.17 3.57 7 3.09V9M20 7H18V13H15L19 17L23 13H20V7M9 3.09V9H14C14 6.04 11.83 3.57 9 3.09M2 15C2 18.3 4.7 21 8 21S14 18.3 14 15V11H2V15Z";
var mdiMouseMoveUp = "M7 9H2C2 6.04 4.17 3.57 7 3.09V9M18 17H20V11H23L19 7L15 11H18V17M9 3.09V9H14C14 6.04 11.83 3.57 9 3.09M2 15C2 18.3 4.7 21 8 21S14 18.3 14 15V11H2V15Z";
var mdiMouseMoveVertical = "M20 6H23L19 2L15 6H18V18H15L19 22L23 18H20V6M9 3.09C11.83 3.57 14 6.04 14 9H9V3.09M14 11V15C14 18.3 11.3 21 8 21S2 18.3 2 15V11H14M7 9H2C2 6.04 4.17 3.57 7 3.09V9Z";
var mdiMouseOff = "M2,5.27L3.28,4L20,20.72L18.73,22L17.5,20.79C16.08,22.16 14.14,23 12,23A8,8 0 0,1 4,15V11H7.73L5.73,9H4C4,8.46 4.05,7.93 4.15,7.42L2,5.27M11,1.07V9H10.82L5.79,3.96C7.05,2.4 8.9,1.33 11,1.07M20,11V15C20,15.95 19.83,16.86 19.53,17.71L12.82,11H20M13,1.07C16.94,1.56 20,4.92 20,9H13V1.07Z";
var mdiMouseOutline = "M13 9V1.07C13.7 1.16 14.37 1.33 15 1.59C17.33 2.53 19.11 4.53 19.75 7C19.91 7.64 20 8.31 20 9H13M17.66 7C17.18 5.65 16.23 4.5 15 3.81V7H17.66M11 9V1.07C10.3 1.16 9.63 1.33 9 1.59C6.67 2.53 4.89 4.53 4.25 7C4.09 7.64 4 8.31 4 9H11M6.34 7C6.82 5.65 7.78 4.5 9 3.81V7H6.34M6 15V13H18V15C18 16.59 17.37 18.12 16.24 19.24C15.12 20.37 13.59 21 12 21C10.41 21 8.88 20.37 7.76 19.24C6.63 18.12 6 16.59 6 15M4 15C4 17.12 4.84 19.16 6.34 20.66C7.84 22.16 9.88 23 12 23C14.12 23 16.16 22.16 17.66 20.66C19.16 19.16 20 17.12 20 15V11H4V15Z";
var mdiMouseRightClick = "M13 9V1.07C13.7 1.16 14.37 1.33 15 1.59C17.33 2.53 19.11 4.53 19.75 7C19.91 7.64 20 8.31 20 9H13M17.66 7C17.18 5.65 16.23 4.5 15 3.81V7H17.66M11 9V1.07C7.06 1.56 4 4.92 4 9H11M6.34 20.66C4.84 19.16 4 17.12 4 15V11H20V15C20 17.12 19.16 19.16 17.66 20.66C16.16 22.16 14.12 23 12 23C9.88 23 7.84 22.16 6.34 20.66Z";
var mdiMouseRightClickOutline = "M13 9V1.07C16.94 1.56 20 4.92 20 9H13M11 9V1.07C10.3 1.16 9.63 1.33 9 1.59C6.67 2.53 4.89 4.53 4.25 7C4.09 7.64 4 8.31 4 9H11M6.34 7C6.82 5.65 7.78 4.5 9 3.81V7H6.34M6 15V13H18V15C18 16.59 17.37 18.12 16.24 19.24C15.12 20.37 13.59 21 12 21C10.41 21 8.88 20.37 7.76 19.24C6.63 18.12 6 16.59 6 15M4 15C4 17.12 4.84 19.16 6.34 20.66C7.84 22.16 9.88 23 12 23C14.12 23 16.16 22.16 17.66 20.66C19.16 19.16 20 17.12 20 15V11H4V15Z";
var mdiMouseScrollWheel = "M11 1.07C7.05 1.56 4 4.92 4 9H11V7.73C10.4 7.39 10 6.74 10 6V4C10 3.26 10.4 2.61 11 2.27V1.07M13 9V7.73C13.6 7.39 14 6.74 14 6V4C14 3.26 13.6 2.61 13 2.27V1.07C16.94 1.56 20 4.92 20 9H13M4 15C4 17.12 4.84 19.16 6.34 20.66C7.84 22.16 9.88 23 12 23C14.12 23 16.16 22.16 17.66 20.66C19.16 19.16 20 17.12 20 15V11H4V15M13 6V4C13 3.45 12.55 3 12 3C11.45 3 11 3.45 11 4V6C11 6.55 11.45 7 12 7C12.55 7 13 6.55 13 6Z";
var mdiMouseVariant = "M14,7H10V2.1C12.28,2.56 14,4.58 14,7M4,7C4,4.58 5.72,2.56 8,2.1V7H4M14,12C14,14.42 12.28,16.44 10,16.9V18A3,3 0 0,0 13,21A3,3 0 0,0 16,18V13A4,4 0 0,1 20,9H22L21,10L22,11H20A2,2 0 0,0 18,13H18V18A5,5 0 0,1 13,23A5,5 0 0,1 8,18V16.9C5.72,16.44 4,14.42 4,12V9H14V12Z";
var mdiMouseVariantOff = "M2,5.27L3.28,4L20,20.72L18.73,22L17.29,20.56C16.42,22 14.82,23 13,23A5,5 0 0,1 8,18V16.9C5.72,16.44 4,14.42 4,12V9H5.73L2,5.27M14,7H10V2.1C12.28,2.56 14,4.58 14,7M8,2.1V6.18L5.38,3.55C6.07,2.83 7,2.31 8,2.1M14,12V12.17L10.82,9H14V12M10,16.9V18A3,3 0 0,0 13,21C14.28,21 15.37,20.2 15.8,19.07L12.4,15.67C11.74,16.28 10.92,16.71 10,16.9M16,13A4,4 0 0,1 20,9H22L21,10L22,11H20A2,2 0 0,0 18,13V16.18L16,14.18V13Z";
var mdiMoveResize = "M9,1V2H10V5H9V6H12V5H11V2H12V1M9,7C7.89,7 7,7.89 7,9V21C7,22.11 7.89,23 9,23H21C22.11,23 23,22.11 23,21V9C23,7.89 22.11,7 21,7M1,9V12H2V11H5V12H6V9H5V10H2V9M9,9H21V21H9M14,10V11H15V16H11V15H10V18H11V17H15V19H14V20H17V19H16V17H19V18H20V15H19V16H16V11H17V10";
var mdiMoveResizeVariant = "M1.88,0.46L0.46,1.88L5.59,7H2V9H9V2H7V5.59M11,7V9H21V15H23V9A2,2 0 0,0 21,7M7,11V21A2,2 0 0,0 9,23H15V21H9V11M15.88,14.46L14.46,15.88L19.6,21H17V23H23V17H21V19.59";
var mdiMovie = "M18,4L20,8H17L15,4H13L15,8H12L10,4H8L10,8H7L5,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V4H18Z";
var mdiMovieCheck = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiMovieCheckOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V13.81C21.39 13.46 20.72 13.22 20 13.09V10H5.76L4 6.47V18H13.09C13.04 18.33 13 18.66 13 19M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiMovieCog = "M12 19C12 19.34 12.03 19.67 12.08 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V12.68C21.09 12.25 20.08 12 19 12C15.13 12 12 15.13 12 19M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiMovieCogOutline = "M12 19C12 19.34 12.03 19.67 12.08 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V12.68C21.38 12.39 20.71 12.18 20 12.08V10H5.76L4 6.47V18H12.08C12.03 18.33 12 18.66 12 19M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiMovieEdit = "M21.04 11.13C20.9 11.13 20.76 11.19 20.65 11.3L19.65 12.3L21.7 14.35L22.7 13.35C22.92 13.14 22.92 12.79 22.7 12.58L21.42 11.3C21.31 11.19 21.18 11.13 21.04 11.13M19.07 12.88L13 18.94V21H15.06L21.12 14.93L19.07 12.88M11 20H3C1.9 20 1 19.11 1 18V6C1 4.89 1.9 4 3 4H4L6 8H9L7 4H9L11 8H14L12 4H14L16 8H19L17 4H21V8.12L11 18.11V20Z";
var mdiMovieEditOutline = "M21 4V8.12L19.12 10H4.76L3 6.47V18H11V20H3C1.9 20 1 19.11 1 18V6C1 4.89 1.9 4 3 4H4L6 8H9L7 4H9L11 8H14L12 4H14L16 8H19L17 4H21M21.42 12.3L22.7 13.58C22.92 13.79 22.92 14.14 22.7 14.35L21.7 15.35L19.65 13.3L20.65 12.3C20.76 12.19 20.9 12.13 21.04 12.13C21.18 12.13 21.31 12.19 21.42 12.3M21.12 15.93L15.06 22H13V19.94L19.07 13.88L21.12 15.93Z";
var mdiMovieFilter = "M18 4L20 7H17L15 4H13L15 7H12L10 4H8L10 7H7L5 4H4C2.9 4 2 4.9 2 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V4H18M11.25 15.25L10 18L8.75 15.25L6 14L8.75 12.75L10 10L11.25 12.75L14 14L11.25 15.25M16.94 11.94L16 14L15.06 11.94L13 11L15.06 10.06L16 8L16.94 10.06L19 11L16.94 11.94Z";
var mdiMovieFilterOutline = "M10 11L9.06 13.06L7 14L9.06 14.94L10 17L10.94 14.94L13 14L10.94 13.06M18 4L20 8H17L15 4H13L15 8H12L10 4H8L10 8H7L5 4H4C2.91 4 2 4.9 2 6L2 18C2 19.1 2.91 20 4 20H20C21.11 20 22 19.1 22 18V4H18M20 18H4V6.47L5.77 10H16L15.37 11.37L14 12L15.37 12.63L16 14L16.63 12.63L18 12L16.63 11.37L16 10H20V18Z";
var mdiMovieMinus = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M15 18V20H23V18H15Z";
var mdiMovieMinusOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V13.81C21.39 13.46 20.72 13.22 20 13.09V10H5.76L4 6.47V18H13.09C13.04 18.33 13 18.66 13 19M15 18V20H23V18H15Z";
var mdiMovieOff = "M22.11 21.46L20.84 22.73L18.11 20H4C2.9 20 2 19.11 2 18V6C2 5.42 2.25 4.9 2.65 4.54L1.11 3L2.39 1.73L22.11 21.46M21.88 18.68C21.96 18.47 22 18.24 22 18V4H18L20 8H17L15 4H13L15 8H12L10 4H8L8.8 5.6L21.88 18.68Z";
var mdiMovieOffOutline = "M2.39 1.73L1.11 3L2.65 4.54C2.25 4.9 2 5.42 2 6V18C2 19.11 2.9 20 4 20H18.11L20.84 22.73L22.11 21.46L2.39 1.73M4 18V6.47L5.76 10H8.11L16.11 18H4M8.8 5.6L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V18C22 18.24 21.96 18.47 21.88 18.68L20 16.8V10H13.2L8.8 5.6Z";
var mdiMovieOpen = "M20.84 2.18L16.91 2.96L19.65 6.5L21.62 6.1L20.84 2.18M13.97 3.54L12 3.93L14.75 7.46L16.71 7.07L13.97 3.54M9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05L9.07 4.5M4.16 5.5L3.18 5.69A2 2 0 0 0 1.61 8.04L2 10L6.9 9.03L4.16 5.5M2 10V20C2 21.11 2.9 22 4 22H20C21.11 22 22 21.11 22 20V10H2Z";
var mdiMovieOpenCheck = "M19.65 6.5L16.91 2.96L20.84 2.18L21.62 6.1L19.65 6.5M16.71 7.07L13.97 3.54L12 3.93L14.75 7.46L16.71 7.07M19 13C20.1 13 21.12 13.3 22 13.81V10H2V20C2 21.11 2.9 22 4 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M4.16 5.5L3.18 5.69C2.1 5.91 1.4 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiMovieOpenCheckOutline = "M14.75 7.46L12 3.93L13.97 3.54L16.71 7.07L14.75 7.46M21.62 6.1L20.84 2.18L16.91 2.96L19.65 6.5L21.62 6.1M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M4.16 5.5L3.18 5.69C2.1 5.9 1.39 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M4 20V12H20V13.09C20.72 13.21 21.39 13.46 22 13.81V10H2V20C2 21.11 2.9 22 4 22H13.81C13.46 21.39 13.22 20.72 13.09 20H4M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiMovieOpenCog = "M14.75 7.46L12 3.93L13.97 3.54L16.71 7.07L14.75 7.46M21.62 6.1L20.84 2.18L16.91 2.96L19.65 6.5L21.62 6.1M19 12C20.08 12 21.09 12.25 22 12.68V10H2V20C2 21.11 2.9 22 4 22H12.68C12.25 21.09 12 20.08 12 19C12 15.13 15.13 12 19 12M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M4.16 5.5L3.18 5.69C2.1 5.91 1.4 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiMovieOpenCogOutline = "M14.75 7.46L12 3.93L13.97 3.54L16.71 7.07L14.75 7.46M21.62 6.1L20.84 2.18L16.91 2.96L19.65 6.5L21.62 6.1M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M4.16 5.5L3.18 5.69C2.1 5.9 1.39 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M4 20V12H20V12.08C20.71 12.18 21.38 12.39 22 12.69V10H2V20C2 21.11 2.9 22 4 22H12.68C12.39 21.38 12.18 20.71 12.08 20H4M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiMovieOpenEdit = "M19.65 6.5L16.91 2.96L20.84 2.18L21.62 6.1L19.65 6.5M16.71 7.07L13.97 3.54L12 3.93L14.75 7.46L16.71 7.07M2 10V20C2 21.11 2.9 22 4 22H11V19.13L20.13 10H2M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M4.16 5.5L3.18 5.69C2.1 5.91 1.4 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47Z";
var mdiMovieOpenEditOutline = "M14.75 7.46L12 3.93L13.97 3.54L16.71 7.07L14.75 7.46M21.62 6.1L20.84 2.18L16.91 2.96L19.65 6.5L21.62 6.1M4 12H18.13L20.13 10H2V20C2 21.11 2.9 22 4 22H11V20H4V12M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M4.16 5.5L3.18 5.69C2.1 5.9 1.39 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47Z";
var mdiMovieOpenMinus = "M14.75 7.46L12 3.93L13.97 3.54L16.71 7.07L14.75 7.46M21.62 6.1L20.84 2.18L16.91 2.96L19.65 6.5L21.62 6.1M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M4.16 5.5L3.18 5.69C2.1 5.91 1.4 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M19 13C20.1 13 21.12 13.3 22 13.81V10H2V20C2 21.11 2.9 22 4 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M15 18V20H23V18H15Z";
var mdiMovieOpenMinusOutline = "M13.09 20C13.21 20.72 13.46 21.39 13.81 22H4C2.9 22 2 21.11 2 20V10H22V13.81C21.39 13.46 20.72 13.22 20 13.09V12H4V20H13.09M21.62 6.1L20.84 2.18L16.91 2.96L19.65 6.5L21.62 6.1M16.71 7.07L13.97 3.54L12 3.93L14.75 7.46L16.71 7.07M4.16 5.5L3.18 5.69C2.1 5.9 1.39 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M15 18V20H23V18H15Z";
var mdiMovieOpenOff = "M13.2 10H22V18.8L13.2 10M21.6 6.1L20.8 2.2L16.9 3L19.6 6.5L21.6 6.1M11.8 8L9.1 4.5L7.9 4.7L11.3 8.1L11.8 8M2.4 1.7L1.1 3L3.7 5.6L3.2 5.7C2.1 5.9 1.4 7 1.6 8L2 10L7.1 9L8.1 10H2V20C2 21.1 2.9 22 4 22H20.1L20.8 22.7L22.1 21.4L2.4 1.7M16.7 7.1L14 3.5L12 3.9L14.8 7.4L16.7 7.1Z";
var mdiMovieOpenOffOutline = "M19.7 6.5L16.9 3L20.8 2.2L21.6 6.1L19.7 6.5M22.1 21.5L20.8 22.8L20.1 22H4C2.9 22 2 21.1 2 20V10H8.1L7.1 9L2 10L1.6 8C1.4 7 2.1 5.9 3.2 5.7L3.7 5.6L1.1 3L2.4 1.7L22.1 21.5M18.1 20L10.1 12H4V20H18.1M22 18.8V10H13.2L15.2 12H20V16.8L22 18.8M16.7 7.1L14 3.5L12 3.9L14.8 7.4L16.7 7.1M11.8 8L9.1 4.5L7.9 4.7L11.3 8.1L11.8 8Z";
var mdiMovieOpenOutline = "M20.84 2.18L16.91 2.96L19.65 6.5L21.62 6.1L20.84 2.18M13.97 3.54L12 3.93L14.75 7.46L16.71 7.07L13.97 3.54M9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05L9.07 4.5M4.16 5.5L3.18 5.69C2.1 5.9 1.39 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M20 12V20H4V12H20M22 10H2V20C2 21.11 2.9 22 4 22H20C21.11 22 22 21.11 22 20V10Z";
var mdiMovieOpenPlay = "M14.75 7.46L12 3.93L13.97 3.54L16.71 7.07L14.75 7.46M21.62 6.1L20.84 2.18L16.91 2.96L19.65 6.5L21.62 6.1M4.16 5.5L3.18 5.69C2.1 5.91 1.4 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M2 10V20C2 21.11 2.9 22 4 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13C20.1 13 21.12 13.3 22 13.81V10H2M17 22L22 19L17 16V22Z";
var mdiMovieOpenPlayOutline = "M22 10V13.81C21.39 13.46 20.72 13.22 20 13.09V12H4V20H13.09C13.21 20.72 13.46 21.39 13.81 22H4C2.9 22 2 21.11 2 20V10H22M16.71 7.07L13.97 3.54L12 3.93L14.75 7.46L16.71 7.07M21.62 6.1L20.84 2.18L16.91 2.96L19.65 6.5L21.62 6.1M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M4.16 5.5L3.18 5.69C2.1 5.9 1.39 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M17 22L22 19L17 16V22Z";
var mdiMovieOpenPlus = "M19.65 6.5L16.91 2.96L20.84 2.18L21.62 6.1L19.65 6.5M16.71 7.07L13.97 3.54L12 3.93L14.75 7.46L16.71 7.07M19 13C20.1 13 21.12 13.3 22 13.81V10H2V20C2 21.11 2.9 22 4 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M4.16 5.5L3.18 5.69C2.1 5.91 1.4 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiMovieOpenPlusOutline = "M14.75 7.46L12 3.93L13.97 3.54L16.71 7.07L14.75 7.46M21.62 6.1L20.84 2.18L16.91 2.96L19.65 6.5L21.62 6.1M4 20V12H20V13.09C20.72 13.21 21.39 13.46 22 13.81V10H2V20C2 21.11 2.9 22 4 22H13.81C13.46 21.39 13.22 20.72 13.09 20H4M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M4.16 5.5L3.18 5.69C2.1 5.9 1.39 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiMovieOpenRemove = "M14.75 7.46L12 3.93L13.97 3.54L16.71 7.07L14.75 7.46M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M21.62 6.1L20.84 2.18L16.91 2.96L19.65 6.5L21.62 6.1M19 13C20.1 13 21.12 13.3 22 13.81V10H2V20C2 21.11 2.9 22 4 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M4.16 5.5L3.18 5.69C2.1 5.91 1.4 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiMovieOpenRemoveOutline = "M19.65 6.5L16.91 2.96L20.84 2.18L21.62 6.1L19.65 6.5M16.71 7.07L13.97 3.54L12 3.93L14.75 7.46L16.71 7.07M4.16 5.5L3.18 5.69C2.1 5.9 1.39 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M4 20V12H20V13.09C20.72 13.21 21.39 13.46 22 13.81V10H2V20C2 21.11 2.9 22 4 22H13.81C13.46 21.39 13.22 20.72 13.09 20H4M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiMovieOpenSettings = "M14.75 5.46L12 1.93L13.97 1.54L16.71 5.07L14.75 5.46M21.62 4.1L20.84 .18L16.91 .96L19.65 4.5L21.62 4.1M11.81 6.05L9.07 2.5L7.1 2.91L9.85 6.44L11.81 6.05M2 8V18C2 19.11 2.9 20 4 20H20C21.11 20 22 19.11 22 18V8H2M4.16 3.5L3.18 3.69C2.1 3.91 1.4 4.96 1.61 6.04L2 8L6.9 7.03L4.16 3.5M11 24H13V22H11V24M7 24H9V22H7V24M15 24H17V22H15V24Z";
var mdiMovieOpenSettingsOutline = "M19.65 4.5L16.91 .96L20.84 .18L21.62 4.1L19.65 4.5M16.71 5.07L13.97 1.54L12 1.93L14.75 5.46L16.71 5.07M11.81 6.05L9.07 2.5L7.1 2.91L9.85 6.44L11.81 6.05M4.16 3.5L3.18 3.69C2.1 3.9 1.39 4.96 1.61 6.04L2 8L6.9 7.03L4.16 3.5M22 8V18C22 19.11 21.11 20 20 20H4C2.9 20 2 19.11 2 18V8H22M20 10H4V18H20V10M7 24H9V22H7V24M15 24H17V22H15V24M11 24H13V22H11V24Z";
var mdiMovieOpenStar = "M19.65 6.5L16.91 2.96L20.84 2.18L21.62 6.1L19.65 6.5M16.71 7.07L13.97 3.54L12 3.93L14.75 7.46L16.71 7.07M19 13C20.1 13 21.12 13.3 22 13.81V10H2V20C2 21.11 2.9 22 4 22H13.81C13.3 21.12 13 20.1 13 19C13 15.69 15.69 13 19 13M4.16 5.5L3.18 5.69C2.1 5.91 1.4 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M23 17.89L20.11 17.64L19 15L17.87 17.64L15 17.89L17.18 19.77L16.5 22.58L19 21.09L21.45 22.58L20.8 19.77L23 17.89Z";
var mdiMovieOpenStarOutline = "M19.65 6.5L16.91 2.96L20.84 2.18L21.62 6.1L19.65 6.5M16.71 7.07L13.97 3.54L12 3.93L14.75 7.46L16.71 7.07M4.16 5.5L3.18 5.69C2.1 5.9 1.39 6.96 1.61 8.04L2 10L6.9 9.03L4.16 5.5M11.81 8.05L9.07 4.5L7.1 4.91L9.85 8.44L11.81 8.05M4 20V12H20V13.09C20.72 13.21 21.39 13.46 22 13.81V10H2V20C2 21.11 2.9 22 4 22H13.81C13.46 21.39 13.22 20.72 13.09 20H4M23 17.89L20.11 17.64L19 15L17.87 17.64L15 17.89L17.18 19.77L16.5 22.58L19 21.09L21.45 22.58L20.8 19.77L23 17.89Z";
var mdiMovieOutline = "M5.76,10H20V18H4V6.47M22,4H18L20,8H17L15,4H13L15,8H12L10,4H8L10,8H7L5,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V4Z";
var mdiMoviePlay = "M22 4V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22M17 22L22 19L17 16V22Z";
var mdiMoviePlayOutline = "M22 4V13.81C21.39 13.46 20.72 13.22 20 13.09V10H5.76L4 6.47V18H13.09C13.04 18.33 13 18.66 13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22M17 22L22 19L17 16V22Z";
var mdiMoviePlus = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiMoviePlusOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V13.81C21.39 13.46 20.72 13.22 20 13.09V10H5.76L4 6.47V18H13.09C13.04 18.33 13 18.66 13 19M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiMovieRemove = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiMovieRemoveOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V13.81C21.39 13.46 20.72 13.22 20 13.09V10H5.76L4 6.47V18H13.09C13.04 18.33 13 18.66 13 19M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiMovieRoll = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A2.5,2.5 0 0,0 9.5,6.5A2.5,2.5 0 0,0 12,9A2.5,2.5 0 0,0 14.5,6.5A2.5,2.5 0 0,0 12,4M4.4,9.53C3.97,10.84 4.69,12.25 6,12.68C7.32,13.1 8.73,12.39 9.15,11.07C9.58,9.76 8.86,8.35 7.55,7.92C6.24,7.5 4.82,8.21 4.4,9.53M19.61,9.5C19.18,8.21 17.77,7.5 16.46,7.92C15.14,8.34 14.42,9.75 14.85,11.07C15.28,12.38 16.69,13.1 18,12.67C19.31,12.25 20.03,10.83 19.61,9.5M7.31,18.46C8.42,19.28 10,19.03 10.8,17.91C11.61,16.79 11.36,15.23 10.24,14.42C9.13,13.61 7.56,13.86 6.75,14.97C5.94,16.09 6.19,17.65 7.31,18.46M16.7,18.46C17.82,17.65 18.07,16.09 17.26,14.97C16.45,13.85 14.88,13.6 13.77,14.42C12.65,15.23 12.4,16.79 13.21,17.91C14,19.03 15.59,19.27 16.7,18.46M12,10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5Z";
var mdiMovieSearch = "M11.03 20H4C2.9 20 2 19.1 2 18L2 6C2 4.9 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V13.05C20.85 11.22 18.82 10 16.5 10C12.92 10 10 12.92 10 16.5C10 17.79 10.38 19 11.03 20M23.39 22L22 23.39L18.88 20.32C18.19 20.75 17.37 21 16.5 21C14 21 12 19 12 16.5S14 12 16.5 12 21 14 21 16.5C21 17.38 20.75 18.21 20.31 18.9L23.39 22M19 16.5C19 15.12 17.88 14 16.5 14S14 15.12 14 16.5 15.12 19 16.5 19 19 17.88 19 16.5Z";
var mdiMovieSearchOutline = "M11 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V13C21.5 12.2 20.8 11.5 20 11V10H5.8L4 6.5V18H10.2C10.4 18.7 10.6 19.4 11 20M20.3 18.9C20.7 18.2 21 17.4 21 16.5C21 14 19 12 16.5 12S12 14 12 16.5 14 21 16.5 21C17.4 21 18.2 20.8 18.9 20.3L22 23.4L23.4 22L20.3 18.9M16.5 19C15.1 19 14 17.9 14 16.5S15.1 14 16.5 14 19 15.1 19 16.5 17.9 19 16.5 19Z";
var mdiMovieSettings = "M22 4V18C22 19.11 21.11 20 20 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22M7 24H9V22H7V24M11 24H13V22H11V24M15 24H17V22H15V24Z";
var mdiMovieSettingsOutline = "M18 4L20 8H17L15 4H13L15 8H12L10 4H8L10 8H7L5 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H20C21.11 20 22 19.11 22 18V4H18M20 18H4V6.47L5.76 10H20V18M11 22H13V24H11V22M7 22H9V24H7V22M15 22H17V24H15V22Z";
var mdiMovieStar = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V13.81C21.12 13.3 20.1 13 19 13C15.69 13 13 15.69 13 19M23 17.89L20.11 17.64L19 15L17.87 17.64L15 17.89L17.18 19.77L16.5 22.58L19 21.09L21.45 22.58L20.8 19.77L23 17.89Z";
var mdiMovieStarOutline = "M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.9 4 4 4H5L7 8H10L8 4H10L12 8H15L13 4H15L17 8H20L18 4H22V13.81C21.39 13.46 20.72 13.22 20 13.09V10H5.76L4 6.47V18H13.09C13.04 18.33 13 18.66 13 19M23 17.89L20.11 17.64L19 15L17.87 17.64L15 17.89L17.18 19.77L16.5 22.58L19 21.09L21.45 22.58L20.8 19.77L23 17.89Z";
var mdiMower = "M18.5 14C17.55 14 16.69 14.38 16.06 15H9.39L5.74 3H2V5H4.26L7 14.05C6.85 14.03 6.68 14 6.5 14C4.57 14 3 15.57 3 17.5S4.57 21 6.5 21C7.89 21 9.09 20.18 9.65 19H15.35C15.91 20.18 17.11 21 18.5 21C20.43 21 22 19.43 22 17.5S20.43 14 18.5 14M6.5 19C5.67 19 5 18.33 5 17.5S5.67 16 6.5 16 8 16.67 8 17.5 7.33 19 6.5 19M18.5 19C17.67 19 17 18.33 17 17.5S17.67 16 18.5 16 20 16.67 20 17.5 19.33 19 18.5 19M10.13 14L9.53 12H12.76C13.5 12 14.21 12.43 14.55 13.11L15 14H10.13Z";
var mdiMowerBag = "M11.95 14L10.82 12H14.76C15.5 12 16.21 12.43 16.55 13.11L17 14H11.95M23 18C23 19.66 21.66 21 20 21C18.7 21 17.6 20.16 17.18 19H11.65C11.09 20.18 9.89 21 8.5 21S5.91 20.18 5.35 19H2C1.45 19 1 18.55 1 18V11C1 10.67 1.17 10.36 1.44 10.17C1.71 10 2.06 9.95 2.37 10.07L7.43 12.09L3.42 5H1V3H4.58L11.37 15H20C21.66 15 23 16.34 23 18M7.34 14.21L3 12.5V17H5.05C5.24 15.7 6.13 14.64 7.34 14.21M10 17.5C10 16.67 9.33 16 8.5 16S7 16.67 7 17.5 7.67 19 8.5 19 10 18.33 10 17.5M21 18C21 17.45 20.55 17 20 17S19 17.45 19 18 19.45 19 20 19 21 18.55 21 18Z";
var mdiMowerBagOn = "M12 2H14V7H12V2M22 6.3L20.6 4.9L17 8.4L18.4 9.8C18.4 9.8 21.9 6.3 22 6.3M10.8 12L11.9 14H17L16.5 13.1C16.2 12.4 15.5 12 14.7 12H10.8M20 15H11.4L4.6 3H1V5H3.4L7.4 12.1L2.3 10.1C2.1 10 1.7 10 1.4 10.2C1.2 10.4 1 10.7 1 11V18C1 18.5 1.5 19 2 19H5.3C5.9 20.2 7.1 21 8.5 21S11.1 20.2 11.7 19H17.2C17.6 20.2 18.7 21 20 21C21.7 21 23 19.7 23 18S21.7 15 20 15M5 17H3V12.5L7.3 14.2C6.1 14.6 5.2 15.7 5 17M8.5 19C7.7 19 7 18.3 7 17.5S7.7 16 8.5 16 10 16.7 10 17.5 9.3 19 8.5 19M20 19C19.5 19 19 18.5 19 18S19.5 17 20 17 21 17.5 21 18 20.5 19 20 19Z";
var mdiMowerOn = "M12 2H14V7H12V2M22 6.3L20.6 4.9L17 8.4L18.4 9.8C18.4 9.8 21.9 6.3 22 6.3M18.5 14C17.5 14 16.7 14.4 16.1 15H9.4L5.7 3H2V5H4.3L7 14H6.5C4.6 14 3 15.6 3 17.5S4.6 21 6.5 21C7.9 21 9.1 20.2 9.7 19H15.4C16 20.2 17.2 21 18.6 21C20.5 21 22.1 19.4 22.1 17.5S20.4 14 18.5 14M6.5 19C5.7 19 5 18.3 5 17.5S5.7 16 6.5 16 8 16.7 8 17.5 7.3 19 6.5 19M18.5 19C17.7 19 17 18.3 17 17.5S17.7 16 18.5 16 20 16.7 20 17.5 19.3 19 18.5 19M9.5 12L10.1 14H15L14.6 13.1C14.3 12.4 13.5 12 12.8 12H9.5Z";
var mdiMuffin = "M16,5C16,5 15,2 12,2C9,2 8,5 8,5C6,5 4,7 4,9C1.3,9 1.3,13 4,13H20C22.7,13 22.7,9 20,9C20,7 18,5 16,5M5,15L7,22H9L8,15H5M10,15L11,22H13L14,15H10M16,15L15,22H17L19,15H16Z";
var mdiMulticast = "M17 2V4H12C10.9 4 10 4.89 10 6V9H12V6H17V8L20 5L17 2M17 9V11H6.73C6.37 10.38 5.71 10 5 10C3.9 10 3 10.9 3 12S3.9 14 5 14C5.71 14 6.37 13.62 6.73 13H17V15L20 12L17 9M10 15V18C10 19.11 10.9 20 12 20H17V22L20 19L17 16V18H12V15H10Z";
var mdiMultimedia = "M9 13V5C9 3.9 9.9 3 11 3H20C21.1 3 22 3.9 22 5V11H18.57L17.29 9.26C17.23 9.17 17.11 9.17 17.05 9.26L15.06 12C15 12.06 14.88 12.07 14.82 12L13.39 10.25C13.33 10.18 13.22 10.18 13.16 10.25L11.05 12.91C10.97 13 11.04 13.15 11.16 13.15H17.5V15H11C9.89 15 9 14.11 9 13M6 22V21H4V22H2V2H4V3H6V2H8.39C7.54 2.74 7 3.8 7 5V13C7 15.21 8.79 17 11 17H15.7C14.67 17.83 14 19.08 14 20.5C14 21.03 14.11 21.53 14.28 22H6M4 7H6V5H4V7M4 11H6V9H4V11M4 15H6V13H4V15M6 19V17H4V19H6M23 13V15H21V20.5C21 21.88 19.88 23 18.5 23S16 21.88 16 20.5 17.12 18 18.5 18C18.86 18 19.19 18.07 19.5 18.21V13H23Z";
var mdiMultiplication = "M11,3H13V10.27L19.29,6.64L20.29,8.37L14,12L20.3,15.64L19.3,17.37L13,13.72V21H11V13.73L4.69,17.36L3.69,15.63L10,12L3.72,8.36L4.72,6.63L11,10.26V3Z";
var mdiMultiplicationBox = "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M11,17H13V13.73L15.83,15.36L16.83,13.63L14,12L16.83,10.36L15.83,8.63L13,10.27V7H11V10.27L8.17,8.63L7.17,10.36L10,12L7.17,13.63L8.17,15.36L11,13.73V17Z";
var mdiMushroom = "M12,2A10,10 0 0,1 22,12A2,2 0 0,1 20,14H4A2,2 0 0,1 2,12A10,10 0 0,1 12,2M12,8A2,2 0 0,0 14,6A2,2 0 0,0 12,4A2,2 0 0,0 10,6A2,2 0 0,0 12,8M17,12A2,2 0 0,0 19,10A2,2 0 0,0 17,8A2,2 0 0,0 15,10A2,2 0 0,0 17,12M7,12A2,2 0 0,0 9,10A2,2 0 0,0 7,8A2,2 0 0,0 5,10A2,2 0 0,0 7,12M15,15L16.27,19.45L16.35,20C16.35,21.1 15.45,22 14.35,22H9.65A2,2 0 0,1 7.65,20L7.73,19.45L9,15H15Z";
var mdiMushroomOff = "M22.1 21.5L2.4 1.7L1.1 3L4.1 6C2.8 7.6 2 9.7 2 12C2 13.1 2.9 14 4 14H12.1L13.1 15H9L7.7 19.5V20C7.7 21.1 8.6 22 9.7 22H14.4C15.5 22 16.4 21.1 16.4 20L16.3 19.5L15.8 17.7L20.9 22.8L22.1 21.5M7 12C5.9 12 5 11.1 5 10C5 9.2 5.5 8.4 6.3 8.1L8.9 10.7C8.6 11.5 7.8 12 7 12M10 6C10 4.9 10.9 4 12 4S14 4.9 14 6 13.1 8 12 8C11.5 8 11.1 7.8 10.7 7.5L17.2 14H20C21.1 14 22 13.1 22 12C22 6.5 17.5 2 12 2C10.1 2 8.3 2.6 6.7 3.5L10.4 7.2C10.2 6.9 10 6.5 10 6M17 8C18.1 8 19 8.9 19 10S18.1 12 17 12 15 11.1 15 10 15.9 8 17 8Z";
var mdiMushroomOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L4.1 6C2.8 7.6 2 9.7 2 12C2 13.1 2.9 14 4 14H12.1L13.1 15H9L8 18.5L7.7 19.5C7.4 20.6 8.1 21.7 9.1 21.9L9.7 22H14.4C15.5 22 16.4 21.1 16.4 20L16.3 19.5L16 18.5L15.8 17.6L20.9 22.7L22.1 21.5M4 12C4 10.3 4.6 8.7 5.5 7.4L6.2 8.1C6.1 8.4 6 8.7 6 9C6 10.1 6.9 11 8 11C8.3 11 8.6 10.9 8.9 10.8L10.1 12H4M9.7 20L10 19L10.6 17H13.6L14.2 19L14.5 20H9.7M16 11C14.9 11 14 10.1 14 9S14.9 7 16 7 18 7.9 18 9 17.1 11 16 11M8.2 5L6.7 3.5C8.3 2.6 10.1 2 12 2C17.5 2 22 6.5 22 12C22 13.1 21.1 14 20 14H17.2L15.2 12H20C20 8.3 17.4 5.1 14 4.2C13.9 5.2 13 6 12 6S10.1 5.2 10 4.2C9.4 4.4 8.7 4.7 8.2 5Z";
var mdiMushroomOutline = "M4,12H20C20,8.27 17.44,5.13 14,4.25C13.86,5.24 13,6 12,6C11,6 10.14,5.24 10,4.25C6.56,5.13 4,8.27 4,12M12,2A10,10 0 0,1 22,12A2,2 0 0,1 20,14H4A2,2 0 0,1 2,12A10,10 0 0,1 12,2M13.5,17H10.5L9.92,19L9.65,20H14.35L14.08,19L13.5,17M15,15L16,18.5L16.27,19.45L16.35,20C16.35,21.1 15.45,22 14.35,22H9.65L9.17,21.94C8.1,21.66 7.45,20.57 7.73,19.5L8,18.5L9,15H15M16,7A2,2 0 0,1 18,9A2,2 0 0,1 16,11A2,2 0 0,1 14,9A2,2 0 0,1 16,7M8,7A2,2 0 0,1 10,9A2,2 0 0,1 8,11A2,2 0 0,1 6,9A2,2 0 0,1 8,7Z";
var mdiMusic = "M21,3V15.5A3.5,3.5 0 0,1 17.5,19A3.5,3.5 0 0,1 14,15.5A3.5,3.5 0 0,1 17.5,12C18.04,12 18.55,12.12 19,12.34V6.47L9,8.6V17.5A3.5,3.5 0 0,1 5.5,21A3.5,3.5 0 0,1 2,17.5A3.5,3.5 0 0,1 5.5,14C6.04,14 6.55,14.12 7,14.34V6L21,3Z";
var mdiMusicAccidentalDoubleFlat = "M15.5 9C14.8 9 14.11 9.28 13.5 9.67V5H11.5V9.62C11.04 9.24 10.39 9 9.5 9C8.8 9 8.11 9.28 7.5 9.67V5H5.5V19C8.5 17.32 10.43 15.79 11.5 14.41V19C16.36 16.26 18.5 13.91 18.5 12C18.5 10.59 17.79 9 15.5 9M7.5 15.38V12.26C8.12 11.59 8.95 11 9.5 11C10.09 11 10.5 11.07 10.5 12C10.5 12.15 10.4 13.3 7.5 15.38M13.5 15.38V12.26C14.12 11.59 14.95 11 15.5 11C16.09 11 16.5 11.07 16.5 12C16.5 12.15 16.4 13.3 13.5 15.38Z";
var mdiMusicAccidentalDoubleSharp = "M15.41 10H17V7H14V8.59L12 10.59L10 8.59V7H7V10H8.59L10.59 12L8.59 14H7V17H10V15.41L12 13.41L14 15.41V17H17V14H15.41L13.41 12L15.41 10Z";
var mdiMusicAccidentalFlat = "M8.5 19C13.36 16.26 15.5 13.91 15.5 12C15.5 10.59 14.79 9 12.5 9C11.8 9 11.11 9.28 10.5 9.67V5H8.5M10.5 15.38V12.26C11.12 11.59 11.95 11 12.5 11C13.09 11 13.5 11.07 13.5 12C13.5 12.15 13.4 13.3 10.5 15.38Z";
var mdiMusicAccidentalNatural = "M10 8.75V3.5H8V17.5L14 15.25V20.5H16V6.5L10 8.75M14 13.25L10 14.75V10.75L14 9.25V13.25Z";
var mdiMusicAccidentalSharp = "M17 9.5V7.5L15 8.1V5.5H13V8.7L11 9.3V6.5H9V9.9L7 10.5V12.5L9 11.9V13.9L7 14.5V16.5L9 15.9V18.5H11V15.3L13 14.7V17.5H15V14.1L17 13.5V11.5L15 12.1V10.1L17 9.5M13 12.7L11 13.3V11.3L13 10.7V12.7Z";
var mdiMusicBox = "M16,9H13V14.5A2.5,2.5 0 0,1 10.5,17A2.5,2.5 0 0,1 8,14.5A2.5,2.5 0 0,1 10.5,12C11.07,12 11.58,12.19 12,12.5V7H16M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiMusicBoxMultiple = "M4,6H2V20A2,2 0 0,0 4,22H18V20H4M18,7H15V12.5A2.5,2.5 0 0,1 12.5,15A2.5,2.5 0 0,1 10,12.5A2.5,2.5 0 0,1 12.5,10C13.07,10 13.58,10.19 14,10.5V5H18M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2Z";
var mdiMusicBoxMultipleOutline = "M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M20,16H8V4H20M12.5,15A2.5,2.5 0 0,0 15,12.5V7H18V5H14V10.5C13.58,10.19 13.07,10 12.5,10A2.5,2.5 0 0,0 10,12.5A2.5,2.5 0 0,0 12.5,15M4,6H2V20A2,2 0 0,0 4,22H18V20H4";
var mdiMusicBoxOutline = "M16,9H13V14.5A2.5,2.5 0 0,1 10.5,17A2.5,2.5 0 0,1 8,14.5A2.5,2.5 0 0,1 10.5,12C11.07,12 11.58,12.19 12,12.5V7H16V9M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M5,5V19H19V5H5Z";
var mdiMusicCircle = "M16,9V7H12V12.5C11.58,12.19 11.07,12 10.5,12A2.5,2.5 0 0,0 8,14.5A2.5,2.5 0 0,0 10.5,17A2.5,2.5 0 0,0 13,14.5V9H16M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiMusicCircleOutline = "M16,9H13V14.5A2.5,2.5 0 0,1 10.5,17A2.5,2.5 0 0,1 8,14.5A2.5,2.5 0 0,1 10.5,12C11.07,12 11.58,12.19 12,12.5V7H16V9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiMusicClefAlto = "M5 4H7V20H5M15.46 13H14.83L13.83 12L14.83 11H15.46A3.5 3.5 0 1 0 11.96 7.5H13.96A1.5 1.5 0 1 1 15.46 9H14L12 11H11V4H9V20H11V13H12L14 15H15.46A1.5 1.5 0 1 1 13.96 16.5H11.96A3.5 3.5 0 1 0 15.46 13Z";
var mdiMusicClefBass = "M18.5 5A1.5 1.5 0 1 1 17 6.5A1.5 1.5 0 0 1 18.5 5M18.5 11A1.5 1.5 0 1 1 17 12.5A1.5 1.5 0 0 1 18.5 11M10 4A5 5 0 0 0 5 9V10A2 2 0 1 0 7.18 8A3 3 0 0 1 10 6A4 4 0 0 1 14 10C14 13.59 11.77 16.19 7 18.2L7.76 20.04C13.31 17.72 16 14.43 16 10A6 6 0 0 0 10 4Z";
var mdiMusicClefTreble = "M13 11V7.5L15.2 5.29C16 4.5 16.15 3.24 15.59 2.26C15.14 1.47 14.32 1 13.45 1C13.24 1 13 1.03 12.81 1.09C11.73 1.38 11 2.38 11 3.5V6.74L7.86 9.91C6.2 11.6 5.7 14.13 6.61 16.34C7.38 18.24 9.06 19.55 11 19.89V20.5C11 20.76 10.77 21 10.5 21H9V23H10.5C11.85 23 13 21.89 13 20.5V20C15.03 20 17.16 18.08 17.16 15.25C17.16 12.95 15.24 11 13 11M13 3.5C13 3.27 13.11 3.09 13.32 3.03C13.54 2.97 13.77 3.06 13.88 3.26C14 3.46 13.96 3.71 13.8 3.87L13 4.73V3.5M11 11.5C10.03 12.14 9.3 13.24 9.04 14.26L11 14.78V17.83C9.87 17.53 8.9 16.71 8.43 15.57C7.84 14.11 8.16 12.45 9.26 11.33L11 9.5V11.5M13 18V12.94C14.17 12.94 15.18 14.04 15.18 15.25C15.18 17 13.91 18 13 18Z";
var mdiMusicNote = "M12 3V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17S7.79 21 10 21 14 19.21 14 17V7H18V3H12Z";
var mdiMusicNoteBluetooth = "M22 9.85L19.14 7H18.64V10.79L16.35 8.5L15.64 9.21L18.43 12L15.64 14.79L16.35 15.5L18.64 13.21V17H19.14L22 14.15L19.85 12L22 9.85M19.64 8.91L20.58 9.85L19.64 10.79V8.91M20.58 14.15L19.64 15.09V13.21L20.58 14.15M9.64 3V13.55C9.05 13.21 8.37 13 7.64 13C5.43 13 3.64 14.79 3.64 17S5.43 21 7.64 21 11.64 19.21 11.64 17V7H15.64V3H9.64Z";
var mdiMusicNoteBluetoothOff = "M22 9.85L19.14 7H18.64V10.79L16.35 8.5L15.64 9.21L18.43 12L15.64 14.79L16.35 15.5L18.64 13.21V17H19.14L22 14.15L19.85 12L22 9.85M19.64 8.91L20.58 9.85L19.64 10.79V8.91M20.58 14.15L19.64 15.09V13.21L20.58 14.15M1.96 3L.687 4.27L9.69 13.27V13.55C9.1 13.21 8.42 13 7.69 13C5.5 13 3.69 14.79 3.69 17S5.5 21 7.69 21 11.69 19.21 11.69 17V15.27L17.42 21L18.69 19.73L1.96 3M11.69 7H15.69V3H9.69V8.18L11.69 10.18V7Z";
var mdiMusicNoteEighth = "M12 3V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17S7.79 21 10 21 14 19.21 14 17V7H18V3H12Z";
var mdiMusicNoteEighthDotted = "M12 3V13.55A4 4 0 1 0 14 17V7H18V3M16.5 20A1.5 1.5 0 1 1 18 18.5A1.5 1.5 0 0 1 16.5 20Z";
var mdiMusicNoteHalf = "M16 3H14V13.56A3.96 3.96 0 0 0 12 13A4 4 0 1 0 16 17V3M12 19A2 2 0 1 1 14 17A2 2 0 0 1 12 19Z";
var mdiMusicNoteHalfDotted = "M14 3H12V13.56A3.96 3.96 0 0 0 10 13A4 4 0 1 0 14 17V3M10 19A2 2 0 1 1 12 17A2 2 0 0 1 10 19M16.5 20A1.5 1.5 0 1 1 18 18.5A1.5 1.5 0 0 1 16.5 20Z";
var mdiMusicNoteMinus = "M14 12V14H22V12H14M9 3V13.55C8.41 13.21 7.73 13 7 13C4.79 13 3 14.79 3 17S4.79 21 7 21 11 19.21 11 17V7H15V3H9Z";
var mdiMusicNoteOff = "M4.27 3L3 4.27L12 13.27V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17S7.79 21 10 21 14 19.21 14 17V15.27L19.73 21L21 19.73L4.27 3M14 7H18V3H12V8.18L14 10.18Z";
var mdiMusicNoteOffOutline = "M14 7H18V3H12V7.61L14 9.61M12 10.44L4.41 2.86L3 4.27L12 13.27V13.55A3.94 3.94 0 0 0 8.67 13.23A4 4 0 0 0 10.65 20.95A4.1 4.1 0 0 0 14 16.85V15.27L19.73 21L21.14 19.59M10 19A2 2 0 1 1 12 17A2 2 0 0 1 10 19Z";
var mdiMusicNoteOutline = "M12 3V13.55A4 4 0 1 0 14 17V7H18V3M10 19A2 2 0 1 1 12 17A2 2 0 0 1 10 19Z";
var mdiMusicNotePlus = "M17 9V12H14V14H17V17H19V14H22V12H19V9H17M9 3V13.55C8.41 13.21 7.73 13 7 13C4.79 13 3 14.79 3 17S4.79 21 7 21 11 19.21 11 17V7H15V3H9Z";
var mdiMusicNoteQuarter = "M14 3V13.56C13.41 13.21 12.73 13 12 13C9.79 13 8 14.79 8 17S9.79 21 12 21 16 19.21 16 17V3H14Z";
var mdiMusicNoteQuarterDotted = "M12 13V13.56A3.96 3.96 0 0 0 10 13A4 4 0 1 0 14 17V3H12M16.5 17A1.5 1.5 0 1 1 15 18.5A1.5 1.5 0 0 1 16.5 17Z";
var mdiMusicNoteSixteenth = "M18 7V3H12V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17S7.79 21 10 21 14 19.21 14 17V11H18V8H14V7H18Z";
var mdiMusicNoteSixteenthDotted = "M18 18.5A1.5 1.5 0 1 1 16.5 17A1.5 1.5 0 0 1 18 18.5M18 7V3H12V13.55A4 4 0 1 0 14 17V11H18V8H14V7Z";
var mdiMusicNoteWhole = "M12 15A2 2 0 1 1 10 17A2 2 0 0 1 12 15M12 13A4 4 0 1 0 16 17A4 4 0 0 0 12 13Z";
var mdiMusicNoteWholeDotted = "M10 15A2 2 0 1 1 8 17A2 2 0 0 1 10 15M10 13A4 4 0 1 0 14 17A4 4 0 0 0 10 13M16.5 17A1.5 1.5 0 1 1 15 18.5A1.5 1.5 0 0 1 16.5 17Z";
var mdiMusicOff = "M2,5.27L3.28,4L20,20.72L18.73,22L9,12.27V17.5A3.5,3.5 0 0,1 5.5,21A3.5,3.5 0 0,1 2,17.5A3.5,3.5 0 0,1 5.5,14C6.04,14 6.55,14.12 7,14.34V10.27L2,5.27M21,3V15.5C21,16.5 20.57,17.42 19.88,18.06L14.94,13.12C15.58,12.43 16.5,12 17.5,12C18.04,12 18.55,12.12 19,12.34V6.47L10.17,8.35L7.66,5.84L21,3Z";
var mdiMusicRestEighth = "M14 6A5.56 5.56 0 0 1 10.95 7.86A1.5 1.5 0 1 0 9.5 9H9.74A6.32 6.32 0 0 0 13.25 7.93L10 18H12L16 6Z";
var mdiMusicRestHalf = "M6 14H8V10H16V14H18V15H6V14Z";
var mdiMusicRestQuarter = "M11.71 16.81C10.91 17.6 10.88 18.84 11.64 19.58L10.19 21C8.66 19.5 8.72 17.03 10.32 15.46C10.85 14.94 11.5 14.61 12.16 14.42L9 11.34L10.45 9.92L10.82 9.57C11.82 8.59 11.85 7.04 10.9 6.11L9.16 4.42L10.62 3L14.78 7.06C15.54 7.81 15.5 9.05 14.71 9.83L12.53 11.95L16 15.33L15.61 15.72C15.11 16.21 14.38 16.46 13.72 16.28C13.04 16.1 12.26 16.28 11.71 16.81Z";
var mdiMusicRestSixteenth = "M15 3A5.56 5.56 0 0 1 11.95 4.86A1.5 1.5 0 1 0 10.5 6H10.74A6.32 6.32 0 0 0 14.25 4.93L12.9 9.1A5.56 5.56 0 0 1 9.95 10.86A1.5 1.5 0 1 0 8.5 12H8.74A6.32 6.32 0 0 0 12.25 10.93L9 21H11L17 3Z";
var mdiMusicRestWhole = "M18 10H16V14H8V10H6V9H18V10Z";
var mdiMustache = "M21 12C19 12 18 9 15 9S12 11 12 11 12 9 9 9 5 12 3 12C2 12 1 11 1 11S2 16 6 16C11 16 12 13 12 13S13 16 18 16C22 16 23 11 23 11S22 12 21 12Z";
var mdiNail = "M13.5,5V16L12,22L10.5,16V5H13.5M17,2H7V4H17V2Z";
var mdiNas = "M4,5C2.89,5 2,5.89 2,7V17C2,18.11 2.89,19 4,19H20C21.11,19 22,18.11 22,17V7C22,5.89 21.11,5 20,5H4M4.5,7A1,1 0 0,1 5.5,8A1,1 0 0,1 4.5,9A1,1 0 0,1 3.5,8A1,1 0 0,1 4.5,7M7,7H20V17H7V7M8,8V16H11V8H8M12,8V16H15V8H12M16,8V16H19V8H16M9,9H10V10H9V9M13,9H14V10H13V9M17,9H18V10H17V9Z";
var mdiNativescript = "M7.5,3H16.5C19,3 21,5 21,7.5V16.5C21,19 19,21 16.5,21H7.5C5,21 3,19 3,16.5V7.5C3,5 5,3 7.5,3M6,13.5V16.5A1.5,1.5 0 0,0 7.5,18H9V10.5L15,18H16.5A1.5,1.5 0 0,0 18,16.5V13.5A1.5,1.5 0 0,1 19.5,12A1.5,1.5 0 0,1 18,10.5V7.5A1.5,1.5 0 0,0 16.5,6H15V13.5L9,6H7.5A1.5,1.5 0 0,0 6,7.5V10.5A1.5,1.5 0 0,1 4.5,12A1.5,1.5 0 0,1 6,13.5Z";
var mdiNature = "M13,16.12C16.47,15.71 19.17,12.76 19.17,9.17C19.17,5.3 16.04,2.17 12.17,2.17A7,7 0 0,0 5.17,9.17C5.17,12.64 7.69,15.5 11,16.06V20H5V22H19V20H13V16.12Z";
var mdiNatureOutline = "M12.08 14.22L12.77 14.13C15.24 13.84 17.17 11.73 17.17 9.17C17.17 6.41 14.94 4.17 12.17 4.17C10.84 4.17 9.57 4.7 8.63 5.63C7.7 6.57 7.17 7.84 7.17 9.17C7.17 11.64 8.96 13.69 11.33 14.09L12.08 14.22M13 16.12V20H19V22H5V20H11V16.06C7.69 15.5 5.17 12.64 5.17 9.17C5.17 7.31 5.91 5.53 7.22 4.22C8.53 2.91 10.31 2.17 12.17 2.17C16.04 2.17 19.17 5.3 19.17 9.17C19.17 12.76 16.47 15.71 13 16.12Z";
var mdiNaturePeople = "M4.5,11A1.5,1.5 0 0,0 6,9.5A1.5,1.5 0 0,0 4.5,8A1.5,1.5 0 0,0 3,9.5A1.5,1.5 0 0,0 4.5,11M22.17,9.17C22.17,5.3 19.04,2.17 15.17,2.17A7,7 0 0,0 8.17,9.17C8.17,12.64 10.69,15.5 14,16.06V20H6V17H7V13A1,1 0 0,0 6,12H3A1,1 0 0,0 2,13V17H3V22H19V20H16V16.12C19.47,15.71 22.17,12.76 22.17,9.17Z";
var mdiNaturePeopleOutline = "M16 20V16.12C19.47 15.71 22.17 12.76 22.17 9.17C22.17 5.3 19.04 2.17 15.17 2.17C13.31 2.17 11.53 2.91 10.22 4.22C8.91 5.53 8.17 7.31 8.17 9.17C8.17 9.95 8.3 10.69 8.53 11.38C8.64 11.71 8.77 12.03 8.93 12.33C9.91 14.27 11.78 15.68 14 16.06V20H6V17H7V12.95C7 12.72 6.89 12.5 6.74 12.33L6.71 12.29L6.66 12.25C6.5 12.09 6.25 12 6 12H3C2.76 12 2.5 12.09 2.34 12.25L2.29 12.29C2.11 12.5 2 12.74 2 13V17H3V22H19V20H16M15.08 14.22L14.33 14.09C11.96 13.69 10.17 11.64 10.17 9.17C10.17 7.84 10.7 6.57 11.63 5.63C12.57 4.7 13.85 4.17 15.17 4.17C17.93 4.17 20.17 6.41 20.17 9.17C20.17 11.73 18.24 13.84 15.77 14.13L15.08 14.21M4.5 11C5.33 11 6 10.33 6 9.5C6 8.67 5.33 8 4.5 8C3.67 8 3 8.67 3 9.5C3 10.33 3.67 11 4.5 11Z";
var mdiNavigation = "M12,2L4.5,20.29L5.21,21L12,18L18.79,21L19.5,20.29L12,2Z";
var mdiNavigationOutline = "M12 7.3L16.3 17.7L12.8 16.2L12 15.8L11.2 16.2L7.7 17.7L12 7.3M12 2L4.5 20.3L5.2 21L12 18L18.8 21L19.5 20.3L12 2Z";
var mdiNavigationVariant = "M21 3L3 10.53V11.5L9.84 14.16L12.5 21H13.46L21 3Z";
var mdiNavigationVariantOutline = "M17.27 6.73L13.03 16.86L11.71 13.44L11.39 12.61L10.57 12.29L7.14 10.96L17.27 6.73M21 3L3 10.53V11.5L9.84 14.16L12.5 21H13.46L21 3Z";
var mdiNearMe = "M21,3L3,10.53V11.5L9.84,14.16L12.5,21H13.46L21,3Z";
var mdiNecklace = "M21.5 5H19.5C19.5 9.14 16.14 12.5 12 12.5C7.86 12.5 4.5 9.14 4.5 5H2.5C2.55 10.11 6.59 14.29 11.7 14.5C11.1 15.4 10 17.2 10 18C10 20.67 14 20.67 14 18C14 17.2 12.9 15.4 12.3 14.5C17.41 14.29 21.45 10.11 21.5 5Z";
var mdiNeedle = "M11.15,15.18L9.73,13.77L11.15,12.35L12.56,13.77L13.97,12.35L12.56,10.94L13.97,9.53L15.39,10.94L16.8,9.53L13.97,6.7L6.9,13.77L9.73,16.6L11.15,15.18M3.08,19L6.2,15.89L4.08,13.77L13.97,3.87L16.1,6L17.5,4.58L16.1,3.16L17.5,1.75L21.75,6L20.34,7.4L18.92,6L17.5,7.4L19.63,9.53L9.73,19.42L7.61,17.3L3.08,21.84V19Z";
var mdiNeedleOff = "M22.1 21.5L2.4 1.7L1.1 3L8 9.9L4.1 13.8L6.2 15.9L3.1 19V21.8L7.6 17.3L9.7 19.4L13.6 15.5L20.8 22.7L22.1 21.5M11.2 15.2L9.8 16.6L7 13.8L9.5 11.3L10.9 12.7L9.8 13.8L11.2 15.2M11.9 8.7L10.5 7.3L14 3.9L16.1 6L17.5 4.6L16.1 3.2L17.5 1.8L21.8 6L20.4 7.4L18.9 6L17.5 7.4L19.6 9.5L16.2 13L13.4 10.2L14 9.5L15.4 10.9L16.8 9.5L14 6.7L11.9 8.7Z";
var mdiNetflix = "M6.5,2H10.5L13.44,10.83L13.5,2H17.5V22C16.25,21.78 14.87,21.64 13.41,21.58L10.5,13L10.43,21.59C9.03,21.65 7.7,21.79 6.5,22V2Z";
var mdiNetwork = "M17,3A2,2 0 0,1 19,5V15A2,2 0 0,1 17,17H13V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H7C5.89,17 5,16.1 5,15V5A2,2 0 0,1 7,3H17Z";
var mdiNetworkOff = "M1,5.27L5,9.27V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H17.73L19.73,24L21,22.72L2.28,4L1,5.27M15,20A1,1 0 0,0 14,19H13V17.27L15.73,20H15M17.69,16.87L5.13,4.31C5.41,3.55 6.14,3 7,3H17A2,2 0 0,1 19,5V15C19,15.86 18.45,16.59 17.69,16.87M22,20V21.18L20.82,20H22Z";
var mdiNetworkOffOutline = "M1.04,5.27L5,9.23V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H17.77L19.77,24L21.04,22.72L2.32,4L1.04,5.27M7,11.23L10.77,15H7V11.23M15,20A1,1 0 0,0 14,19H13V17.23L15.77,20H15M22,20V21.14L20.86,20H22M7,6.14L5.14,4.28C5.43,3.53 6.16,3 7,3H17A2,2 0 0,1 19,5V15C19,15.85 18.47,16.57 17.72,16.86L15.86,15H17V5H7V6.14Z";
var mdiNetworkOutline = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M7,15V5H17V15H7Z";
var mdiNetworkPos = "M17 9H8V7H17V9M7 7H5V9H7V7M7 4H5V6H7V4M10 4H8V6H10V4M13 17V19H14C14.55 19 15 19.45 15 20H22V22H15C15 22.55 14.55 23 14 23H10C9.45 23 9 22.55 9 22H2V20H9C9 19.45 9.45 19 10 19H11V17H4C2.89 17 2 16.11 2 15L2 3C2 1.89 2.9 1 4 1H20C21.11 1 22 1.89 22 3L22 15C22 16.11 21.11 17 20 17H13M20 15V3H4V15L20 15M11 6H19V4H11V6M5 12H11V10H5V12M13 14H19V12H13V14Z";
var mdiNetworkStrength1 = "M1,21H21V1M19,5.83V19H11V13.83";
var mdiNetworkStrength1Alert = "M21 1L1 21H17V19H11V13.8L19 5.8V9H21M19 11V17H21V11M19 19V21H21V19";
var mdiNetworkStrength2 = "M1,21H21V1M19,5.83V19H13V11.83";
var mdiNetworkStrength2Alert = "M21 1L1 21H17V19H13V11.8L19 5.8V9H21M19 11V17H21V11M19 19V21H21V19";
var mdiNetworkStrength3 = "M1,21H21V1M19,5.83V19H16V8.83";
var mdiNetworkStrength3Alert = "M21 1L1 21H17V19H16V8.8L19 5.8V9H21M19 11V17H21V11M19 19V21H21V19";
var mdiNetworkStrength4 = "M1,21H21V1";
var mdiNetworkStrength4Alert = "M19 17H21V11H19M19 21H21V19H19M1 21H17V9H21V1";
var mdiNetworkStrength4Cog = "M17 13C16.9 13 16.8 13.1 16.7 13.2L16.5 14.5C16.2 14.6 15.9 14.8 15.7 15L14.5 14.5C14.4 14.5 14.3 14.5 14.2 14.6L13.2 16.3C13.1 16.4 13.2 16.5 13.3 16.6L14.4 17.4V18.4L13.3 19.2C13.2 19.3 13.2 19.4 13.2 19.5L14.2 21.2C14.3 21.3 14.4 21.3 14.5 21.3L15.7 20.8C16 21 16.2 21.2 16.5 21.3L16.7 22.6C16.7 22.7 16.8 22.8 17 22.8H19C19.1 22.8 19.2 22.7 19.2 22.6L19.4 21.3C19.7 21.2 20 21 20.2 20.8L21.4 21.3C21.5 21.3 21.7 21.3 21.7 21.2L22.7 19.5C22.8 19.4 22.7 19.3 22.6 19.2L21.5 18.4V17.9 17.4L22.6 16.6C22.7 16.5 22.7 16.4 22.7 16.3L21.7 14.6C21.6 14.5 21.5 14.5 21.4 14.5L20.3 15C20 14.8 19.8 14.6 19.4 14.5L19.2 13.2C19.2 13.1 19.1 13 19 13H17M18 16.5C18.8 16.5 19.5 17.2 19.5 18S18.8 19.5 18 19.5C17.2 19.5 16.5 18.8 16.5 18S17.2 16.5 18 16.5M11.7 21H1L21 1V11.7C20.1 11.3 19.1 11 18 11C14.1 11 11 14.1 11 18C11 19.1 11.2 20.1 11.7 21Z";
var mdiNetworkStrengthOff = "M21,1L12.4,9.6L21,18.19M4.77,4.5L3.5,5.77L9.86,12.13L1,21H18.73L20.73,23L22,21.73";
var mdiNetworkStrengthOffOutline = "M21,1L12.4,9.6L13.85,11.05L19,5.83V16.19L21,18.19M4.77,4.5L3.5,5.77L9.86,12.13L1,21H18.73L20.73,23L22,21.73M11.33,13.6L16.73,19H6";
var mdiNetworkStrengthOutline = "M1,21H21V1M19,5.83V19H6";
var mdiNewBox = "M20,4C21.11,4 22,4.89 22,6V18C22,19.11 21.11,20 20,20H4C2.89,20 2,19.11 2,18V6C2,4.89 2.89,4 4,4H20M8.5,15V9H7.25V12.5L4.75,9H3.5V15H4.75V11.5L7.3,15H8.5M13.5,10.26V9H9.5V15H13.5V13.75H11V12.64H13.5V11.38H11V10.26H13.5M20.5,14V9H19.25V13.5H18.13V10H16.88V13.5H15.75V9H14.5V14A1,1 0 0,0 15.5,15H19.5A1,1 0 0,0 20.5,14Z";
var mdiNewspaper = "M20,11H4V8H20M20,15H13V13H20M20,19H13V17H20M11,19H4V13H11M20.33,4.67L18.67,3L17,4.67L15.33,3L13.67,4.67L12,3L10.33,4.67L8.67,3L7,4.67L5.33,3L3.67,4.67L2,3V19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19V3L20.33,4.67Z";
var mdiNewspaperCheck = "M20.33 4.67L18.67 3L17 4.67L15.33 3L13.67 4.67L12 3L10.33 4.67L8.67 3L7 4.67L5.33 3L3.67 4.67L2 3V19C2 20.11 2.9 21 4 21H12.8C12.29 20.12 12 19.09 12 18C12 16.77 12.37 15.63 13 14.68V13H14.68C15.63 12.37 16.77 12 18 12C19.53 12 20.93 12.58 22 13.5V3L20.33 4.67M11 19H4V13H11V19M20 11H4V8H20V11M16.75 21.16L14 18.16L15.16 17L16.75 18.59L20.34 15L21.5 16.41L16.75 21.16";
var mdiNewspaperMinus = "M22,17V19H14V17H22M20,11V8H4V11H20M13,13V14.68C12.37,15.63 12,16.77 12,18C12,19.09 12.29,20.12 12.8,21H4A2,2 0 0,1 2,19V3L3.67,4.67L5.33,3L7,4.67L8.67,3L10.33,4.67L12,3L13.67,4.67L15.33,3L17,4.67L18.67,3L20.33,4.67L22,3V13.5C20.93,12.58 19.53,12 18,12C16.77,12 15.63,12.37 14.68,13H13M11,19V13H4V19H11Z";
var mdiNewspaperPlus = "M17,14H19V17H22V19H19V22H17V19H14V17H17V14M20,11V8H4V11H20M13,13V14.68C12.37,15.63 12,16.77 12,18C12,19.09 12.29,20.12 12.8,21H4A2,2 0 0,1 2,19V3L3.67,4.67L5.33,3L7,4.67L8.67,3L10.33,4.67L12,3L13.67,4.67L15.33,3L17,4.67L18.67,3L20.33,4.67L22,3V13.5C20.93,12.58 19.53,12 18,12C16.77,12 15.63,12.37 14.68,13H13M11,19V13H4V19H11Z";
var mdiNewspaperRemove = "M20.12 14.46L21.54 15.88L19.41 18L21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.47 20.12L16.59 18L14.47 15.88L15.88 14.47L18 16.59L20.12 14.46M20.33 4.67L18.67 3L17 4.67L15.33 3L13.67 4.67L12 3L10.33 4.67L8.67 3L7 4.67L5.33 3L3.67 4.67L2 3V19C2 20.11 2.9 21 4 21H12.8C12.29 20.12 12 19.09 12 18C12 16.77 12.37 15.63 13 14.68V13H14.68C15.63 12.37 16.77 12 18 12C19.53 12 20.93 12.58 22 13.5V3L20.33 4.67M11 19H4V13H11V19M20 11H4V8H20V11Z";
var mdiNewspaperVariant = "M20 3H4C2.89 3 2 3.89 2 5V19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V5C22 3.89 21.11 3 20 3M5 7H10V13H5V7M19 17H5V15H19V17M19 13H12V11H19V13M19 9H12V7H19V9Z";
var mdiNewspaperVariantMultiple = "M4 7V19H19V21H4C2 21 2 19 2 19V7H4M21.3 3H7.7C6.76 3 6 3.7 6 4.55V15.45C6 16.31 6.76 17 7.7 17H21.3C22.24 17 23 16.31 23 15.45V4.55C23 3.7 22.24 3 21.3 3M8 5H13V11H8V5M21 15H8V13H21V15M21 11H15V9H21V11M21 7H15V5H21V7Z";
var mdiNewspaperVariantMultipleOutline = "M4 7V19H19V21H4C2 21 2 19 2 19V7H4M21 5V15H8V5H21M21.3 3H7.7C6.76 3 6 3.7 6 4.55V15.45C6 16.31 6.76 17 7.7 17H21.3C22.24 17 23 16.31 23 15.45V4.55C23 3.7 22.24 3 21.3 3M9 6H12V11H9V6M20 14H9V12H20V14M20 8H14V6H20V8M20 11H14V9H20V11Z";
var mdiNewspaperVariantOutline = "M20 5L20 19L4 19L4 5H20M20 3H4C2.89 3 2 3.89 2 5V19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V5C22 3.89 21.11 3 20 3M18 15H6V17H18V15M10 7H6V13H10V7M12 9H18V7H12V9M18 11H12V13H18V11Z";
var mdiNfc = "M7.24 2C5.6 2 3.96 2 3.55 2.04C2.67 2.09 2.08 2.73 2.04 3.56C2 4.37 2 19.59 2.04 20.41C2.09 21.23 2.71 21.86 3.55 21.91C4.46 21.96 7.44 21.97 8.29 21.97C6.76 20.91 6.55 18.92 6.41 15.23C6.33 13.04 6.4 5.36 6.41 5.04L6.45 2.94L14.5 11V13.5L8.09 7.11C8.08 8.38 8.06 10.03 8.06 11.54C8.06 13 8.08 14.34 8.12 15.05C8.36 19.07 8.74 20.96 10.83 21.7C11.5 21.93 12.07 22 13.07 22C13.89 22 19.63 22 20.45 21.96C21.33 21.91 21.93 21.27 21.97 20.44C22 19.63 22 4.45 21.97 3.62C21.91 2.8 21.29 2.18 20.45 2.13C19.54 2.08 16.57 2.03 15.71 2.03C17.24 3.09 17.44 5.08 17.59 8.78C17.67 10.97 17.6 18.64 17.59 18.97L17.55 21.06L9.53 13V10.5L15.91 16.89C15.92 15.62 15.94 13.97 15.94 12.46C15.94 11 15.92 9.66 15.88 8.96C15.64 4.93 15.26 3.04 13.17 2.3C12.53 2.07 11.93 2 10.93 2H7.24Z";
var mdiNfcSearchVariant = "M16.5,12C19,12 21,14 21,16.5C21,17.38 20.76,18.21 20.32,18.9L23.4,22L22,23.39L18.89,20.32C18.2,20.75 17.38,21 16.5,21C14,21 12,19 12,16.5C12,14 14,12 16.5,12M16.5,14A2.5,2.5 0 0,0 14,16.5A2.5,2.5 0 0,0 16.5,19C17.89,19 19,17.88 19,16.5A2.5,2.5 0 0,0 16.5,14M18,6V10.18C17.33,10 16.66,9.97 16,10V8H13V10.28L13.53,10.72C12.34,11.33 11.35,12.3 10.72,13.53C10.28,13.17 10,12.62 10,12C10,11.26 10.41,10.62 11,10.28V8A2,2 0 0,1 13,6H18M6,18V6H8L10,6V8H8V16H10C9.96,16.68 10,17.35 10.17,18H6M20,4H4V20H11C11.53,20.8 12.21,21.5 13.03,22H4C2.89,22 2,21.1 2,20V4A2,2 0 0,1 4,2H20A2,2 0 0,1 22,4V13.04C21.5,12.24 20.82,11.54 20,11V4Z";
var mdiNfcTap = "M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M4,4H11A2,2 0 0,1 13,6V9H11V6H4V11H6V9L9,12L6,15V13H4A2,2 0 0,1 2,11V6A2,2 0 0,1 4,4M20,20H13A2,2 0 0,1 11,18V15H13V18H20V13H18V15L15,12L18,9V11H20A2,2 0 0,1 22,13V18A2,2 0 0,1 20,20Z";
var mdiNfcVariant = "M18,6H13A2,2 0 0,0 11,8V10.28C10.41,10.62 10,11.26 10,12A2,2 0 0,0 12,14C13.11,14 14,13.1 14,12C14,11.26 13.6,10.62 13,10.28V8H16V16H8V8H10V6H8L6,6V18H18M20,20H4V4H20M20,2H4A2,2 0 0,0 2,4V20A2,2 0 0,0 4,22H20C21.11,22 22,21.1 22,20V4C22,2.89 21.11,2 20,2Z";
var mdiNfcVariantOff = "M1.25,2.05L21.95,22.75L20.7,24L18.7,22H4A2,2 0 0,1 2,20V5.3L0,3.3L1.25,2.05M3.81,2C3.87,2 3.94,2 4,2H20C21.11,2 22,2.89 22,4V20C22,20.06 22,20.13 22,20.19L20,18.2V4H5.8L3.81,2M6,9.3L4,7.3V20H16.7L14.7,18H6V9.3M18,16.2L16,14.2V8H13V10.28C13.6,10.62 14,11.26 14,12C14,12.06 14,12.13 14,12.19L11,9.2V8A2,2 0 0,1 13,6H18V16.2M8,16H12.7L8,11.3V16M10,8H9.8L7.8,6H10V8Z";
var mdiNinja = "M7.75,13C7.74,12.65 7.9,12.31 8.17,12.08C8.92,12.24 9.62,12.55 10.25,13C10.25,13.68 9.69,14.24 9,14.24C8.31,14.24 7.76,13.69 7.75,13M13.75,13C14.38,12.56 15.08,12.25 15.83,12.09C16.1,12.32 16.26,12.66 16.25,13C16.25,13.7 15.69,14.26 15,14.26C14.31,14.26 13.75,13.7 13.75,13V13M12,9C9.23,8.96 6.5,9.65 4.07,11L4,12C4,13.23 4.29,14.44 4.84,15.54C7.21,15.18 9.6,15 12,15C14.4,15 16.79,15.18 19.16,15.54C19.71,14.44 20,13.23 20,12L19.93,11C17.5,9.65 14.77,8.96 12,9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiNintendoGameBoy = "M7 1C5.9 1 5 1.9 5 3V21C5 22.11 5.9 23 7 23H14C16.76 23 19 20.76 19 18V3C19 1.9 18.11 1 17 1H7M8 4H16V11H8V4M9 14H10V16H12V17H10V19H9V17H7V16H9V14M16 15C16.55 15 17 15.45 17 16C17 16.55 16.55 17 16 17C15.45 17 15 16.55 15 16C15 15.45 15.45 15 16 15M14 17C14.55 17 15 17.45 15 18C15 18.55 14.55 19 14 19C13.45 19 13 18.55 13 18C13 17.45 13.45 17 14 17Z";
var mdiNintendoSwitch = "M10.04,20.4H7.12C6.19,20.4 5.3,20 4.64,19.36C4,18.7 3.6,17.81 3.6,16.88V7.12C3.6,6.19 4,5.3 4.64,4.64C5.3,4 6.19,3.62 7.12,3.62H10.04V20.4M7.12,2A5.12,5.12 0 0,0 2,7.12V16.88C2,19.71 4.29,22 7.12,22H11.65V2H7.12M5.11,8C5.11,9.04 5.95,9.88 7,9.88C8.03,9.88 8.87,9.04 8.87,8C8.87,6.96 8.03,6.12 7,6.12C5.95,6.12 5.11,6.96 5.11,8M17.61,11C18.72,11 19.62,11.89 19.62,13C19.62,14.12 18.72,15 17.61,15C16.5,15 15.58,14.12 15.58,13C15.58,11.89 16.5,11 17.61,11M16.88,22A5.12,5.12 0 0,0 22,16.88V7.12C22,4.29 19.71,2 16.88,2H13.65V22H16.88Z";
var mdiNintendoWii = "M17.84,16.94H15.97V10.79H17.84V16.94M18,8.58C18,9.19 17.5,9.69 16.9,9.69A1.11,1.11 0 0,1 15.79,8.58C15.79,7.96 16.29,7.46 16.9,7.46C17.5,7.46 18,7.96 18,8.58M21.82,16.94H19.94V10.79H21.82V16.94M22,8.58C22,9.19 21.5,9.69 20.88,9.69A1.11,1.11 0 0,1 19.77,8.58C19.77,7.96 20.27,7.46 20.88,7.46C21.5,7.46 22,7.96 22,8.58M12.9,8.05H14.9L12.78,15.5C12.78,15.5 12.5,17.04 11.28,17.04C10.07,17.04 9.79,15.5 9.79,15.5L8.45,10.64L7.11,15.5C7.11,15.5 6.82,17.04 5.61,17.04C4.4,17.04 4.12,15.5 4.12,15.5L2,8.05H4L5.72,14.67L7.11,9.3C7.43,7.95 8.45,7.97 8.45,7.97C8.45,7.97 9.47,7.95 9.79,9.3L11.17,14.67L12.9,8.05Z";
var mdiNintendoWiiu = "M2,15.96C2,18.19 3.54,19.5 5.79,19.5H18.57C20.47,19.5 22,18.2 22,16.32V6.97C22,5.83 21.15,4.6 20.11,4.6H17.15V12.3C17.15,18.14 6.97,18.09 6.97,12.41V4.5H4.72C3.26,4.5 2,5.41 2,6.85V15.96M9.34,11.23C9.34,15.74 14.66,15.09 14.66,11.94V4.5H9.34V11.23Z";
var mdiNix = "M9.9 8.7L5 17.2L3.9 15.3L5.2 13H2.6L2 12L2.6 11H6.3L7.6 8.7H9.9M10.2 15.5H19.9L18.8 17.4H16.2L17.5 19.7L16.9 20.7H15.8L14 17.4H11.3L10.2 15.5M15.9 11.8L11 3.3H13.2L14.5 5.6L15.8 3.3H16.9L17.5 4.3L15.6 7.5L17 9.8L15.9 11.8M13.8 8.5H4L5.1 6.6H7.7L6.4 4.3L7 3.3H8.1L10 6.5H12.7L13.8 8.5M14.1 15.3L19 6.8L20.1 8.7L18.8 11H21.4L22 12L21.4 13H17.7L16.4 15.3H14.1M8.1 12.2L13 20.6H10.8L9.5 18.3L8.4 20.6H7.1L6.5 19.6L8.4 16.4L7 14.2L8.1 12.2Z";
var mdiNodejs = "M12,1.85C11.73,1.85 11.45,1.92 11.22,2.05L3.78,6.35C3.3,6.63 3,7.15 3,7.71V16.29C3,16.85 3.3,17.37 3.78,17.65L5.73,18.77C6.68,19.23 7,19.24 7.44,19.24C8.84,19.24 9.65,18.39 9.65,16.91V8.44C9.65,8.32 9.55,8.22 9.43,8.22H8.5C8.37,8.22 8.27,8.32 8.27,8.44V16.91C8.27,17.57 7.59,18.22 6.5,17.67L4.45,16.5C4.38,16.45 4.34,16.37 4.34,16.29V7.71C4.34,7.62 4.38,7.54 4.45,7.5L11.89,3.21C11.95,3.17 12.05,3.17 12.11,3.21L19.55,7.5C19.62,7.54 19.66,7.62 19.66,7.71V16.29C19.66,16.37 19.62,16.45 19.55,16.5L12.11,20.79C12.05,20.83 11.95,20.83 11.88,20.79L10,19.65C9.92,19.62 9.84,19.61 9.79,19.64C9.26,19.94 9.16,20 8.67,20.15C8.55,20.19 8.36,20.26 8.74,20.47L11.22,21.94C11.46,22.08 11.72,22.15 12,22.15C12.28,22.15 12.54,22.08 12.78,21.94L20.22,17.65C20.7,17.37 21,16.85 21,16.29V7.71C21,7.15 20.7,6.63 20.22,6.35L12.78,2.05C12.55,1.92 12.28,1.85 12,1.85M14,8C11.88,8 10.61,8.89 10.61,10.39C10.61,12 11.87,12.47 13.91,12.67C16.34,12.91 16.53,13.27 16.53,13.75C16.53,14.58 15.86,14.93 14.3,14.93C12.32,14.93 11.9,14.44 11.75,13.46C11.73,13.36 11.64,13.28 11.53,13.28H10.57C10.45,13.28 10.36,13.37 10.36,13.5C10.36,14.74 11.04,16.24 14.3,16.24C16.65,16.24 18,15.31 18,13.69C18,12.08 16.92,11.66 14.63,11.35C12.32,11.05 12.09,10.89 12.09,10.35C12.09,9.9 12.29,9.3 14,9.3C15.5,9.3 16.09,9.63 16.32,10.66C16.34,10.76 16.43,10.83 16.53,10.83H17.5C17.55,10.83 17.61,10.81 17.65,10.76C17.69,10.72 17.72,10.66 17.7,10.6C17.56,8.82 16.38,8 14,8Z";
var mdiNoodles = "M22 3L10 4.41V6H22V7H10V12H22C22 13.81 21.43 15.46 20.32 16.95S17.77 19.53 16 20.25V22H8V20.25C6.24 19.53 4.79 18.43 3.68 16.95S2 13.81 2 12H5V4L22 2V3M6 4.88V6H7V4.78L6 4.88M6 7V12H7V7H6M9 12V7H8V12H9M9 6V4.55L8 4.64V6H9Z";
var mdiNotEqual = "M21,10H9V8H21V10M21,16H9V14H21V16M4,5H6V16H4V5M6,18V20H4V18H6Z";
var mdiNotEqualVariant = "M14.08,4.61L15.92,5.4L14.8,8H19V10H13.95L12.23,14H19V16H11.38L9.92,19.4L8.08,18.61L9.2,16H5V14H10.06L11.77,10H5V8H12.63L14.08,4.61Z";
var mdiNote = "M14,10V4.5L19.5,10M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V9L15,3H5Z";
var mdiNoteAlert = "M3 3C1.89 3 1 3.89 1 5V19C1 20.11 1.9 21 3 21H17C18.11 21 19 20.11 19 19V9L13 3H3M12 10V4.5L17.5 10H12M23 7V13H21V7H23M21 15H23V17H21V15Z";
var mdiNoteAlertOutline = "M3 3C1.89 3 1 3.89 1 5V19C1 20.1 1.89 21 3 21H17C18.11 21 19 20.11 19 19V9L13 3H3M17 19H3V5H10V12H17V19M12 10V4.5L17.5 10H12M23 7V13H21V7H23M21 15H23V17H21V15Z";
var mdiNoteCheck = "M19 13C19.7 13 20.37 13.13 21 13.35V9L15 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H13.35C13.13 20.37 13 19.7 13 19C13 15.69 15.69 13 19 13M14 4.5L19.5 10H14V4.5M22.5 17.25L17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25Z";
var mdiNoteCheckOutline = "M5 19V5H12V12H19V13C19.7 13 20.37 13.13 21 13.35V9L15 3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.89 21 5 21H13.35C13.13 20.37 13 19.7 13 19H5M14 4.5L19.5 10H14V4.5M22.5 17.25L17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25Z";
var mdiNoteEdit = "M21 10V9L15 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H11V19.13L19.39 10.74C19.83 10.3 20.39 10.06 21 10M14 4.5L19.5 10H14V4.5M22.85 14.19L21.87 15.17L19.83 13.13L20.81 12.15C21 11.95 21.33 11.95 21.53 12.15L22.85 13.47C23.05 13.67 23.05 14 22.85 14.19M19.13 13.83L21.17 15.87L15.04 22H13V19.96L19.13 13.83Z";
var mdiNoteEditOutline = "M18.13 12L19.39 10.74C19.83 10.3 20.39 10.06 21 10V9L15 3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.89 21 5 21H11V19.13L11.13 19H5V5H12V12H18.13M14 4.5L19.5 10H14V4.5M19.13 13.83L21.17 15.87L15.04 22H13V19.96L19.13 13.83M22.85 14.19L21.87 15.17L19.83 13.13L20.81 12.15C21 11.95 21.33 11.95 21.53 12.15L22.85 13.47C23.05 13.67 23.05 14 22.85 14.19Z";
var mdiNoteMinus = "M19 13C19.7 13 20.37 13.13 21 13.35V9L15 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H13.35C13.13 20.37 13 19.7 13 19C13 15.69 15.69 13 19 13M14 4.5L19.5 10H14V4.5M23 18V20H15V18H23Z";
var mdiNoteMinusOutline = "M23 18V20H15V18H23M13 19C13 19.7 13.13 20.37 13.35 21H5C3.89 21 3 20.1 3 19V5C3 3.89 3.89 3 5 3H15L21 9V13.35C20.37 13.13 19.7 13 19 13V12H12V5H5V19H13M14 10H19.5L14 4.5V10Z";
var mdiNoteMultiple = "M16,9H21.5L16,3.5V9M7,2H17L23,8V18A2,2 0 0,1 21,20H7C5.89,20 5,19.1 5,18V4A2,2 0 0,1 7,2M3,6V22H21V24H3A2,2 0 0,1 1,22V6H3Z";
var mdiNoteMultipleOutline = "M3,6V22H21V24H3A2,2 0 0,1 1,22V6H3M16,9H21.5L16,3.5V9M7,2H17L23,8V18A2,2 0 0,1 21,20H7C5.89,20 5,19.1 5,18V4A2,2 0 0,1 7,2M7,4V18H21V11H14V4H7Z";
var mdiNoteOff = "M22.11 21.46L20.84 22.73L19.1 21C19.07 21 19.03 21 19 21H5C3.9 21 3 20.11 3 19V5C3 4.97 3 4.93 3 4.9L1.11 3L2.39 1.73L20.7 20.04L20.7 20.05L22.11 21.46M21 17.8L6.2 3H15L21 9V17.8M19.5 10L14 4.5V10H19.5Z";
var mdiNoteOffOutline = "M12 5V8.8L15.2 12H19V15.8L21 17.8V9L15 3H6.2L8.2 5H12M14 4.5L19.5 10H14V4.5M20.7 20.05L20.7 20.04L19 18.34V18.35L12.66 12H12.66L12 11.34V11.35L6.14 5.5L2.39 1.73L1.11 3L3 4.9C3 4.93 3 4.97 3 5V19C3 20.1 3.89 21 5 21H19C19.03 21 19.07 21 19.1 21L20.84 22.73L22.11 21.46L20.7 20.05M5 19V6.89L17.11 19H5Z";
var mdiNoteOutline = "M14,10H19.5L14,4.5V10M5,3H15L21,9V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3M5,5V19H19V12H12V5H5Z";
var mdiNotePlus = "M19 13C19.7 13 20.37 13.13 21 13.35V9L15 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H13.35C13.13 20.37 13 19.7 13 19C13 15.69 15.69 13 19 13M14 4.5L19.5 10H14V4.5M23 18V20H20V23H18V20H15V18H18V15H20V18H23Z";
var mdiNotePlusOutline = "M5 19V5H12V12H19V13C19.7 13 20.37 13.13 21 13.35V9L15 3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.89 21 5 21H13.35C13.13 20.37 13 19.7 13 19H5M14 4.5L19.5 10H14V4.5M23 18V20H20V23H18V20H15V18H18V15H20V18H23Z";
var mdiNoteRemove = "M19 13C19.7 13 20.37 13.13 21 13.35V9L15 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H13.35C13.13 20.37 13 19.7 13 19C13 15.69 15.69 13 19 13M14 4.5L19.5 10H14V4.5M20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19Z";
var mdiNoteRemoveOutline = "M5 19V5H12V12H19V13C19.7 13 20.37 13.13 21 13.35V9L15 3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.89 21 5 21H13.35C13.13 20.37 13 19.7 13 19H5M14 4.5L19.5 10H14V4.5M20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19Z";
var mdiNoteSearch = "M15 3H5C3.89 3 3 3.89 3 5V10.82C5.55 8.37 9.59 8.4 12.1 10.9C14.63 13.44 14.63 17.56 12.1 20.1C11.74 20.45 11.35 20.74 10.94 21H19C20.11 21 21 20.11 21 19V9L15 3M14 10V4.5L19.5 10H14M7.5 11C5 11 3 13 3 15.5C3 16.38 3.25 17.21 3.69 17.9L.61 21L2 22.39L5.12 19.32C5.81 19.75 6.63 20 7.5 20C10 20 12 18 12 15.5S10 11 7.5 11M7.5 18C6.12 18 5 16.88 5 15.5S6.12 13 7.5 13 10 14.12 10 15.5 8.88 18 7.5 18Z";
var mdiNoteSearchOutline = "M15 3H5C3.89 3 3 3.89 3 5V10.82C3.6 10.24 4.28 9.8 5 9.5V5H12V10.82C12.03 10.85 12.07 10.87 12.1 10.9C12.44 11.24 12.73 11.61 12.97 12H19V19H12.97C12.73 19.39 12.44 19.76 12.1 20.1C11.74 20.45 11.35 20.74 10.94 21H19C20.11 21 21 20.11 21 19V9L15 3M14 10V4.5L19.5 10H14M7.5 11C5 11 3 13 3 15.5C3 16.38 3.25 17.21 3.69 17.9L.61 21L2 22.39L5.12 19.32C5.81 19.75 6.63 20 7.5 20C10 20 12 18 12 15.5S10 11 7.5 11M7.5 18C6.12 18 5 16.88 5 15.5S6.12 13 7.5 13 10 14.12 10 15.5 8.88 18 7.5 18Z";
var mdiNoteText = "M14,10H19.5L14,4.5V10M5,3H15L21,9V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3M5,12V14H19V12H5M5,16V18H14V16H5Z";
var mdiNoteTextOutline = "M15 3H5A2 2 0 0 0 3 5V19A2 2 0 0 0 5 21H19A2 2 0 0 0 21 19V9L15 3M19 19H5V5H14V10H19M17 14H7V12H17M14 17H7V15H14";
var mdiNotebook = "M3,7V5H5V4C5,2.89 5.9,2 7,2H13V9L15.5,7.5L18,9V2H19C20.05,2 21,2.95 21,4V20C21,21.05 20.05,22 19,22H7C5.95,22 5,21.05 5,20V19H3V17H5V13H3V11H5V7H3M7,11H5V13H7V11M7,7V5H5V7H7M7,19V17H5V19H7Z";
var mdiNotebookCheck = "M16.75 22.16L14 19.16L15.16 18L16.75 19.59L20.34 16L21.5 17.41L16.75 22.16M3 7V5H5V4C5 2.89 5.9 2 7 2H13V9L15.5 7.5L18 9V2H19C20.05 2 21 2.95 21 4V13.8C20.12 13.29 19.09 13 18 13C14.69 13 12 15.69 12 19C12 20.09 12.29 21.12 12.8 22H7C5.95 22 5 21.05 5 20V19H3V17H5V13H3V11H5V7H3M5 5V7H7V5H5M5 19H7V17H5V19M5 13H7V11H5V13Z";
var mdiNotebookCheckOutline = "M16.75 22.16L14 19.16L15.16 18L16.75 19.59L20.34 16L21.5 17.41L16.75 22.16M17 4V10L15 8L13 10V4H9V20H12.08C12.2 20.72 12.45 21.39 12.8 22H7C5.95 22 5 21.05 5 20V19H3V17H5V13H3V11H5V7H3V5H5V4C5 2.89 5.9 2 7 2H19C20.05 2 21 2.95 21 4V13.8C20.39 13.45 19.72 13.2 19 13.08V4H17M5 19H7V17H5V19M5 13H7V11H5V13M5 7H7V5H5V7Z";
var mdiNotebookEdit = "M21.04 13.13C21.18 13.13 21.31 13.19 21.42 13.3L22.7 14.58C22.92 14.79 22.92 15.14 22.7 15.35L21.7 16.35L19.65 14.3L20.65 13.3C20.76 13.19 20.9 13.13 21.04 13.13M19.07 14.88L21.12 16.93L15.06 23H13V20.94L19.07 14.88M3 7V5H5V4C5 2.89 5.9 2 7 2H13V9L15.5 7.5L18 9V2H19C20.05 2 21 2.95 21 4V10L11 20V22H7C5.95 22 5 21.05 5 20V19H3V17H5V13H3V11H5V7H3M5 7H7V5H5V7M5 11V13H7V11H5M5 17V19H7V17H5Z";
var mdiNotebookEditOutline = "M19.07 14.88L21.12 16.93L15.06 23H13V20.94L19.07 14.88M21.04 13.13C21.18 13.13 21.31 13.19 21.42 13.3L22.7 14.58C22.92 14.79 22.92 15.14 22.7 15.35L21.7 16.35L19.65 14.3L20.65 13.3C20.76 13.19 20.9 13.13 21.04 13.13M17 4V10L15 8L13 10V4H9V20H11V22H7C5.95 22 5 21.05 5 20V19H3V17H5V13H3V11H5V7H3V5H5V4C5 2.89 5.9 2 7 2H19C20.05 2 21 2.95 21 4V10L19 12V4H17M5 5V7H7V5H5M5 11V13H7V11H5M5 17V19H7V17H5Z";
var mdiNotebookHeart = "M19 23.3L18.4 22.8C16.4 20.9 15 19.7 15 18.2C15 17 16 16 17.2 16C17.9 16 18.6 16.3 19 16.8C19.4 16.3 20.1 16 20.8 16C22 16 23 16.9 23 18.2C23 19.7 21.6 20.9 19.6 22.8L19 23.3M3 7V5H5V4C5 2.89 5.9 2 7 2H13V9L15.5 7.5L18 9V2H19C20.05 2 21 2.95 21 4V13.34C20.37 13.12 19.7 13 19 13C15.69 13 13 15.69 13 19C13 20.09 13.29 21.12 13.8 22H7C5.95 22 5 21.05 5 20V19H3V17H5V13H3V11H5V7H3M5 5V7H7V5H5M5 19H7V17H5V19M5 13H7V11H5V13Z";
var mdiNotebookHeartOutline = "M19 23.3L18.4 22.8C16.4 20.9 15 19.7 15 18.2C15 17 16 16 17.2 16C17.9 16 18.6 16.3 19 16.8C19.4 16.3 20.1 16 20.8 16C22 16 23 16.9 23 18.2C23 19.7 21.6 20.9 19.6 22.8L19 23.3M17 4V10L15 8L13 10V4H9V20H13.08C13.2 20.72 13.45 21.39 13.8 22H7C5.95 22 5 21.05 5 20V19H3V17H5V13H3V11H5V7H3V5H5V4C5 2.89 5.9 2 7 2H19C20.05 2 21 2.95 21 4V13.34C20.37 13.12 19.7 13 19 13V4H17M5 19H7V17H5V19M5 13H7V11H5V13M5 7H7V5H5V7Z";
var mdiNotebookMinus = "M3 7V5H5V4C5 2.9 5.9 2 7 2H13V9L15.5 7.5L18 9V2H19C20 2 21 3 21 4V13.8C20.1 13.3 19.1 13 18 13C14.7 13 12 15.7 12 19C12 20.1 12.3 21.1 12.8 22H7C5.9 22 5 21 5 20V19H3V17H5V13H3V11H5V7H3M5 5V7H7V5H5M5 19H7V17H5V19M5 13H7V11H5V13M14 18V20H22V18H14Z";
var mdiNotebookMinusOutline = "M17 4V10L15 8L13 10V4H9V20H12.1C12.2 20.7 12.5 21.4 12.8 22H7C5.9 22 5 21 5 20V19H3V17H5V13H3V11H5V7H3V5H5V4C5 2.9 5.9 2 7 2H19C20 2 21 3 21 4V13.8C20.4 13.4 19.7 13.2 19 13.1V4H17M5 19H7V17H5V19M5 13H7V11H5V13M5 7H7V5H5V7M14 18V20H22V18H14Z";
var mdiNotebookMultiple = "M9.05,9H7.06V6H9.05V4.03H7.06V3.03C7.06,1.92 7.95,1.04 9.05,1.04H15.03V8L17.5,6.5L20,8V1.04H21C22.05,1.04 23,2 23,3.03V17C23,18.03 22.05,19 21,19H9.05C8,19 7.06,18.05 7.06,17V16H9.05V14H7.06V11H9.05V9M1,18H3V15H1V13H3V10H1V8H3V5H5V8H3V10H5V13H3V15H5V18H3V20H5V21H21V23H5A2,2 0 0,1 3,21V20H1V18Z";
var mdiNotebookOutline = "M17,4V10L15,8L13,10V4H9V20H19V4H17M3,7V5H5V4C5,2.89 5.9,2 7,2H19C20.05,2 21,2.95 21,4V20C21,21.05 20.05,22 19,22H7C5.95,22 5,21.05 5,20V19H3V17H5V13H3V11H5V7H3M5,5V7H7V5H5M5,19H7V17H5V19M5,13H7V11H5V13Z";
var mdiNotebookPlus = "M3 7V5H5V4C5 2.9 5.9 2 7 2H13V9L15.5 7.5L18 9V2H19C20 2 21 3 21 4V13.8C20.1 13.3 19.1 13 18 13C14.7 13 12 15.7 12 19C12 20.1 12.3 21.1 12.8 22H7C5.9 22 5 21 5 20V19H3V17H5V13H3V11H5V7H3M5 5V7H7V5H5M5 19H7V17H5V19M5 13H7V11H5V13M17 15V18H14V20H17V23H19V20H22V18H19V15H17Z";
var mdiNotebookPlusOutline = "M17 4V10L15 8L13 10V4H9V20H12.1C12.2 20.7 12.5 21.4 12.8 22H7C5.9 22 5 21 5 20V19H3V17H5V13H3V11H5V7H3V5H5V4C5 2.9 5.9 2 7 2H19C20 2 21 3 21 4V13.8C20.4 13.4 19.7 13.2 19 13.1V4H17M5 19H7V17H5V19M5 13H7V11H5V13M5 7H7V5H5V7M17 15V18H14V20H17V23H19V20H22V18H19V15H17Z";
var mdiNotebookRemove = "M3 7V5H5V4C5 2.9 5.9 2 7 2H13V9L15.5 7.5L18 9V2H19C20 2 21 3 21 4V13.8C20.1 13.3 19.1 13 18 13C14.7 13 12 15.7 12 19C12 20.1 12.3 21.1 12.8 22H7C5.9 22 5 21 5 20V19H3V17H5V13H3V11H5V7H3M5 5V7H7V5H5M5 19H7V17H5V19M5 13H7V11H5V13M20.1 15.5L18 17.6L15.9 15.5L14.5 16.9L16.6 19L14.5 21.1L15.9 22.5L18 20.4L20.1 22.5L21.5 21.1L19.4 19L21.5 16.9L20.1 15.5Z";
var mdiNotebookRemoveOutline = "M17 4V10L15 8L13 10V4H9V20H12.1C12.2 20.7 12.5 21.4 12.8 22H7C5.9 22 5 21 5 20V19H3V17H5V13H3V11H5V7H3V5H5V4C5 2.9 5.9 2 7 2H19C20 2 21 3 21 4V13.8C20.4 13.4 19.7 13.2 19 13.1V4H17M5 19H7V17H5V19M5 13H7V11H5V13M5 7H7V5H5V7M20.1 15.5L18 17.6L15.9 15.5L14.5 16.9L16.6 19L14.5 21.1L15.9 22.5L18 20.4L20.1 22.5L21.5 21.1L19.4 19L21.5 16.9L20.1 15.5Z";
var mdiNotificationClearAll = "M5,13H19V11H5M3,17H17V15H3M7,7V9H21V7";
var mdiNpm = "M4,10V14H6V11H7V14H8V10H4M9,10V15H11V14H13V10H9M12,11V13H11V11H12M14,10V14H16V11H17V14H18V11H19V14H20V10H14M3,9H21V15H12V16H8V15H3V9Z";
var mdiNuke = "M14.04,12H10V11H5.5A3.5,3.5 0 0,1 2,7.5A3.5,3.5 0 0,1 5.5,4C6.53,4 7.45,4.44 8.09,5.15C8.5,3.35 10.08,2 12,2C13.92,2 15.5,3.35 15.91,5.15C16.55,4.44 17.47,4 18.5,4A3.5,3.5 0 0,1 22,7.5A3.5,3.5 0 0,1 18.5,11H14.04V12M10,16.9V15.76H5V13.76H19V15.76H14.04V16.92L20,19.08C20.58,19.29 21,19.84 21,20.5A1.5,1.5 0 0,1 19.5,22H4.5A1.5,1.5 0 0,1 3,20.5C3,19.84 3.42,19.29 4,19.08L10,16.9Z";
var mdiNull = "M12,2C13.85,2 15.55,2.78 16.9,4.1L18.6,1.93L20.18,3.16L18.2,5.68C19.33,7.41 20,9.6 20,12C20,17.5 16.42,22 12,22C10.15,22 8.45,21.22 7.1,19.9L5.4,22.07L3.82,20.84L5.8,18.32C4.67,16.59 4,14.4 4,12C4,6.5 7.58,2 12,2M12,4C8.69,4 6,7.58 6,12C6,13.73 6.41,15.33 7.11,16.64L15.67,5.67C14.66,4.62 13.38,4 12,4M12,20C15.31,20 18,16.42 18,12C18,10.27 17.59,8.67 16.89,7.36L8.33,18.33C9.34,19.38 10.62,20 12,20Z";
var mdiNumeric = "M4,17V9H2V7H6V17H4M22,15C22,16.11 21.1,17 20,17H16V15H20V13H18V11H20V9H16V7H20A2,2 0 0,1 22,9V10.5A1.5,1.5 0 0,1 20.5,12A1.5,1.5 0 0,1 22,13.5V15M14,15V17H8V13C8,11.89 8.9,11 10,11H12V9H8V7H12A2,2 0 0,1 14,9V11C14,12.11 13.1,13 12,13H10V15H14Z";
var mdiNumeric0 = "M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11M11,9H13V15H11V9Z";
var mdiNumeric0Box = "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11M11,9H13V15H11V9Z";
var mdiNumeric0BoxMultiple = "M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21M13,5A2,2 0 0,0 11,7V13A2,2 0 0,0 13,15H15A2,2 0 0,0 17,13V7A2,2 0 0,0 15,5H13M13,7H15V13H13V7Z";
var mdiNumeric0BoxMultipleOutline = "M21,17V3H7V17H21M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M13,5H15A2,2 0 0,1 17,7V13A2,2 0 0,1 15,15H13A2,2 0 0,1 11,13V7A2,2 0 0,1 13,5M13,7V13H15V7H13Z";
var mdiNumeric0BoxOutline = "M19,19V5H5V19H19M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M11,7H13A2,2 0 0,1 15,9V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M11,9V15H13V9H11Z";
var mdiNumeric0Circle = "M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11M11,9H13V15H11V9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiNumeric0CircleOutline = "M11,7H13A2,2 0 0,1 15,9V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M11,9V15H13V9H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiNumeric1 = "M10,7V9H12V17H14V7H10Z";
var mdiNumeric1Box = "M14,17H12V9H10V7H14M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiNumeric1BoxMultiple = "M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21M14,15H16V5H12V7H14V15Z";
var mdiNumeric1BoxMultipleOutline = "M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M14,15H16V5H12V7H14M3,5H1V21A2,2 0 0,0 3,23H19V21H3V5Z";
var mdiNumeric1BoxOutline = "M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,17H14V7H10V9H12";
var mdiNumeric1Circle = "M10,7V9H12V17H14V7H10M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiNumeric1CircleOutline = "M10,7H14V17H12V9H10V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiNumeric10 = "M10 7H6V9H8V17H10V7M16 7H14C12.9 7 12 7.9 12 9V15C12 16.11 12.9 17 14 17H16C17.11 17 18 16.11 18 15V9C18 7.9 17.11 7 16 7M16 15H14V9H16V15Z";
var mdiNumeric10Box = "M14,9H16V15H14V9M21,5V19C21,20.11 20.11,21 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19C20.11,3 21,3.9 21,5M10,7H6V9H8V17H10V7M18,9A2,2 0 0,0 16,7H14A2,2 0 0,0 12,9V15C12,16.11 12.9,17 14,17H16C17.11,17 18,16.11 18,15V9Z";
var mdiNumeric10BoxMultiple = "M3 5V21H19V23H3C1.9 23 1 22.11 1 21V5H3M16 13H18V7H16V13M21 1H7C5.9 1 5 1.9 5 3V17C5 18.11 5.9 19 7 19H21C22.11 19 23 18.11 23 17V3C23 1.9 22.11 1 21 1M12 15H10V7H8V5H12V15M20 13C20 14.11 19.11 15 18 15H16C14.9 15 14 14.11 14 13V7C14 5.9 14.9 5 16 5H18C19.11 5 20 5.9 20 7V13Z";
var mdiNumeric10BoxMultipleOutline = "M21 17V3H7V17H21M21 1C22.11 1 23 1.9 23 3V17C23 18.11 22.11 19 21 19H7C5.9 19 5 18.11 5 17V3C5 1.9 5.9 1 7 1H21M3 5V21H19V23H3C1.9 23 1 22.11 1 21V5H3M12 5H8V7H10V15H12V5M18 5H16C14.9 5 14 5.9 14 7V13C14 14.11 14.9 15 16 15H18C19.11 15 20 14.11 20 13V7C20 5.9 19.11 5 18 5M18 13H16V7H18V13Z";
var mdiNumeric10BoxOutline = "M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5A2,2 0 0,0 19,3M8,17H10V7H6V9H8M14,7H16C17.11,7 18,7.9 18,9V15C18,16.11 17.11,17 16,17H14A2,2 0 0,1 12,15V9A2,2 0 0,1 14,7M14,9V15H16V9H14Z";
var mdiNumeric10Circle = "M14 9H16V15H14V9M22 12C22 17.5 17.5 22 12 22S2 17.5 2 12 6.5 2 12 2 22 6.5 22 12M10 7H6V9H8V17H10V7M18 9C18 7.9 17.11 7 16 7H14C12.9 7 12 7.9 12 9V15C12 16.11 12.9 17 14 17H16C17.11 17 18 16.11 18 15V9Z";
var mdiNumeric10CircleOutline = "M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22 2 17.5 2 12 6.5 2 12 2M12 4C7.58 4 4 7.58 4 12S7.58 20 12 20 20 16.42 20 12 16.42 4 12 4M10 7H6V9H8V17H10V7M16 7H14C12.9 7 12 7.9 12 9V15C12 16.11 12.9 17 14 17H16C17.11 17 18 16.11 18 15V9C18 7.9 17.11 7 16 7M16 15H14V9H16V15Z";
var mdiNumeric2 = "M9,7V9H13V11H11A2,2 0 0,0 9,13V17H11L15,17V15H11V13H13A2,2 0 0,0 15,11V9A2,2 0 0,0 13,7H9Z";
var mdiNumeric2Box = "M15,11C15,12.11 14.1,13 13,13H11V15H15V17H9V13C9,11.89 9.9,11 11,11H13V9H9V7H13A2,2 0 0,1 15,9M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiNumeric2BoxMultiple = "M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M17,13H13V11H15A2,2 0 0,0 17,9V7C17,5.89 16.1,5 15,5H11V7H15V9H13A2,2 0 0,0 11,11V15H17V13M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21Z";
var mdiNumeric2BoxMultipleOutline = "M17,13H13V11H15A2,2 0 0,0 17,9V7C17,5.89 16.1,5 15,5H11V7H15V9H13A2,2 0 0,0 11,11V15H17M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M3,5H1V21A2,2 0 0,0 3,23H19V21H3V5Z";
var mdiNumeric2BoxOutline = "M15,15H11V13H13A2,2 0 0,0 15,11V9C15,7.89 14.1,7 13,7H9V9H13V11H11A2,2 0 0,0 9,13V17H15M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiNumeric2Circle = "M9,7V9H13V11H11A2,2 0 0,0 9,13V17H11L15,17V15H11V13H13A2,2 0 0,0 15,11V9A2,2 0 0,0 13,7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiNumeric2CircleOutline = "M9,7H13A2,2 0 0,1 15,9V11A2,2 0 0,1 13,13H11V15H15V17H11L9,17V13A2,2 0 0,1 11,11H13V9H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiNumeric3 = "M15,15V13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 15,10.5V9C15,7.89 14.1,7 13,7H9V9H13V11H11V13H13V15H9V17H13A2,2 0 0,0 15,15";
var mdiNumeric3Box = "M15,10.5A1.5,1.5 0 0,1 13.5,12C14.34,12 15,12.67 15,13.5V15C15,16.11 14.11,17 13,17H9V15H13V13H11V11H13V9H9V7H13C14.11,7 15,7.89 15,9M19,3H5C3.91,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19C20.11,21 21,20.1 21,19V5A2,2 0 0,0 19,3Z";
var mdiNumeric3BoxMultiple = "M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M17,13V11.5A1.5,1.5 0 0,0 15.5,10A1.5,1.5 0 0,0 17,8.5V7C17,5.89 16.1,5 15,5H11V7H15V9H13V11H15V13H11V15H15A2,2 0 0,0 17,13M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21Z";
var mdiNumeric3BoxMultipleOutline = "M17,13V11.5A1.5,1.5 0 0,0 15.5,10A1.5,1.5 0 0,0 17,8.5V7C17,5.89 16.1,5 15,5H11V7H15V9H13V11H15V13H11V15H15A2,2 0 0,0 17,13M3,5H1V21A2,2 0 0,0 3,23H19V21H3M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1Z";
var mdiNumeric3BoxOutline = "M15,15V13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 15,10.5V9C15,7.89 14.1,7 13,7H9V9H13V11H11V13H13V15H9V17H13A2,2 0 0,0 15,15M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiNumeric3Circle = "M15,15V13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 15,10.5V9C15,7.89 14.1,7 13,7H9V9H13V11H11V13H13V15H9V17H13A2,2 0 0,0 15,15M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiNumeric3CircleOutline = "M15,15A2,2 0 0,1 13,17H9V15H13V13H11V11H13V9H9V7H13A2,2 0 0,1 15,9V10.5A1.5,1.5 0 0,1 13.5,12A1.5,1.5 0 0,1 15,13.5V15M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiNumeric4 = "M9,7V13H13V17H15V7H13V11H11V7H9Z";
var mdiNumeric4Box = "M15,17H13V13H9V7H11V11H13V7H15M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiNumeric4BoxMultiple = "M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21M15,15H17V5H15V9H13V5H11V11H15V15Z";
var mdiNumeric4BoxMultipleOutline = "M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M15,15H17V5H15V9H13V5H11V11H15M3,5H1V21A2,2 0 0,0 3,23H19V21H3V5Z";
var mdiNumeric4BoxOutline = "M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M13,17H15V7H13V11H11V7H9V13H13";
var mdiNumeric4Circle = "M9,7V13H13V17H15V7H13V11H11V7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiNumeric4CircleOutline = "M9,7H11V11H13V7H15V17H13V13H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiNumeric5 = "M9,7V13H13V15H9V17H13A2,2 0 0,0 15,15V13A2,2 0 0,0 13,11H11V9H15V7H9Z";
var mdiNumeric5Box = "M15,9H11V11H13A2,2 0 0,1 15,13V15C15,16.11 14.1,17 13,17H9V15H13V13H9V7H15M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiNumeric5BoxMultiple = "M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21M17,13V11C17,9.89 16.1,9 15,9H13V7H17V5H11V11H15V13H11V15H15A2,2 0 0,0 17,13Z";
var mdiNumeric5BoxMultipleOutline = "M17,13V11C17,9.89 16.1,9 15,9H13V7H17V5H11V11H15V13H11V15H15A2,2 0 0,0 17,13M3,5H1V21A2,2 0 0,0 3,23H19V21H3M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1Z";
var mdiNumeric5BoxOutline = "M15,15V13C15,11.89 14.1,11 13,11H11V9H15V7H9V13H13V15H9V17H13A2,2 0 0,0 15,15M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiNumeric5Circle = "M9,7V13H13V15H9V17H13A2,2 0 0,0 15,15V13A2,2 0 0,0 13,11H11V9H15V7H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiNumeric5CircleOutline = "M9,7H15V9H11V11H13A2,2 0 0,1 15,13V15A2,2 0 0,1 13,17H9V15H13V13H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiNumeric6 = "M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V13A2,2 0 0,0 13,11H11V9H15V7H11M11,13H13V15H11V13Z";
var mdiNumeric6Box = "M15,9H11V11H13A2,2 0 0,1 15,13V15C15,16.11 14.1,17 13,17H11A2,2 0 0,1 9,15V9C9,7.89 9.9,7 11,7H15M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M11,15H13V13H11V15Z";
var mdiNumeric6BoxMultiple = "M13,11H15V13H13V11M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21M13,15H15A2,2 0 0,0 17,13V11C17,9.89 16.1,9 15,9H13V7H17V5H13A2,2 0 0,0 11,7V13C11,14.11 11.9,15 13,15Z";
var mdiNumeric6BoxMultipleOutline = "M13,11H15V13H13M13,15H15A2,2 0 0,0 17,13V11C17,9.89 16.1,9 15,9H13V7H17V5H13A2,2 0 0,0 11,7V13C11,14.11 11.9,15 13,15M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M3,5H1V21A2,2 0 0,0 3,23H19V21H3V5Z";
var mdiNumeric6BoxOutline = "M11,13H13V15H11M11,17H13A2,2 0 0,0 15,15V13C15,11.89 14.1,11 13,11H11V9H15V7H11A2,2 0 0,0 9,9V15C9,16.11 9.9,17 11,17M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiNumeric6Circle = "M11,7A2,2 0 0,0 9,9V15A2,2 0 0,0 11,17H13A2,2 0 0,0 15,15V13A2,2 0 0,0 13,11H11V9H15V7H11M11,13H13V15H11V13M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiNumeric6CircleOutline = "M11,7H15V9H11V11H13A2,2 0 0,1 15,13V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7M11,13V15H13V13H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiNumeric7 = "M11,17L15,9V7H9V9H13L9,17";
var mdiNumeric7Box = "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M11,17L15,9V7H9V9H13L9,17H11Z";
var mdiNumeric7BoxMultiple = "M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M13,15L17,7V5H11V7H15L11,15H13M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21Z";
var mdiNumeric7BoxMultipleOutline = "M13,15L17,7V5H11V7H15L11,15M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M3,5H1V21A2,2 0 0,0 3,23H19V21H3V5Z";
var mdiNumeric7BoxOutline = "M11,17L15,9V7H9V9H13L9,17M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiNumeric7Circle = "M11,17L15,9V7H9V9H13L9,17H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiNumeric7CircleOutline = "M11,17H9L13,9H9V7H15V9L11,17M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiNumeric8 = "M11,13H13V15H11M11,9H13V11H11M11,17H13A2,2 0 0,0 15,15V13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 15,10.5V9C15,7.89 14.1,7 13,7H11A2,2 0 0,0 9,9V10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 9,13.5V15C9,16.11 9.9,17 11,17";
var mdiNumeric8Box = "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M11,17H13A2,2 0 0,0 15,15V13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 15,10.5V9C15,7.89 14.1,7 13,7H11A2,2 0 0,0 9,9V10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 9,13.5V15C9,16.11 9.9,17 11,17M11,13H13V15H11V13M11,9H13V11H11V9Z";
var mdiNumeric8BoxMultiple = "M13,11H15V13H13V11M13,7H15V9H13V7M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M13,15H15A2,2 0 0,0 17,13V11.5A1.5,1.5 0 0,0 15.5,10A1.5,1.5 0 0,0 17,8.5V7C17,5.89 16.1,5 15,5H13A2,2 0 0,0 11,7V8.5A1.5,1.5 0 0,0 12.5,10A1.5,1.5 0 0,0 11,11.5V13C11,14.11 11.9,15 13,15M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21Z";
var mdiNumeric8BoxMultipleOutline = "M13,11H15V13H13M13,7H15V9H13M13,15H15A2,2 0 0,0 17,13V11.5A1.5,1.5 0 0,0 15.5,10A1.5,1.5 0 0,0 17,8.5V7C17,5.89 16.1,5 15,5H13A2,2 0 0,0 11,7V8.5A1.5,1.5 0 0,0 12.5,10A1.5,1.5 0 0,0 11,11.5V13C11,14.11 11.9,15 13,15M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M3,5H1V21A2,2 0 0,0 3,23H19V21H3V5Z";
var mdiNumeric8BoxOutline = "M11,13H13V15H11M11,9H13V11H11M11,17H13A2,2 0 0,0 15,15V13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 15,10.5V9C15,7.89 14.1,7 13,7H11A2,2 0 0,0 9,9V10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 9,13.5V15C9,16.11 9.9,17 11,17M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiNumeric8Circle = "M11,13H13V15H11V13M11,9H13V11H11V9M11,17H13A2,2 0 0,0 15,15V13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 15,10.5V9C15,7.89 14.1,7 13,7H11A2,2 0 0,0 9,9V10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 9,13.5V15C9,16.11 9.9,17 11,17M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiNumeric8CircleOutline = "M11,13V15H13V13H11M11,9V11H13V9H11M11,17A2,2 0 0,1 9,15V13.5A1.5,1.5 0 0,1 10.5,12A1.5,1.5 0 0,1 9,10.5V9A2,2 0 0,1 11,7H13A2,2 0 0,1 15,9V10.5A1.5,1.5 0 0,1 13.5,12A1.5,1.5 0 0,1 15,13.5V15A2,2 0 0,1 13,17H11M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiNumeric9 = "M13,17A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11A2,2 0 0,0 9,9V11A2,2 0 0,0 11,13H13V15H9V17H13M13,11H11V9H13V11Z";
var mdiNumeric9Box = "M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M13,11H11V9H13V11M13,7H11A2,2 0 0,0 9,9V11C9,12.11 9.9,13 11,13H13V15H9V17H13A2,2 0 0,0 15,15V9C15,7.89 14.1,7 13,7Z";
var mdiNumeric9BoxMultiple = "M15,9H13V7H15V9M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M15,5H13A2,2 0 0,0 11,7V9C11,10.11 11.9,11 13,11H15V13H11V15H15A2,2 0 0,0 17,13V7C17,5.89 16.1,5 15,5M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21Z";
var mdiNumeric9BoxMultipleOutline = "M15,9H13V7H15M15,5H13A2,2 0 0,0 11,7V9C11,10.11 11.9,11 13,11H15V13H11V15H15A2,2 0 0,0 17,13V7C17,5.89 16.1,5 15,5M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M3,5H1V21A2,2 0 0,0 3,23H19V21H3V5Z";
var mdiNumeric9BoxOutline = "M13,11H11V9H13M13,7H11A2,2 0 0,0 9,9V11C9,12.11 9.9,13 11,13H13V15H9V17H13A2,2 0 0,0 15,15V9C15,7.89 14.1,7 13,7M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z";
var mdiNumeric9Circle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M13,17A2,2 0 0,0 15,15V9A2,2 0 0,0 13,7H11A2,2 0 0,0 9,9V11A2,2 0 0,0 11,13H13V15H9V17H13M13,11H11V9H13V11Z";
var mdiNumeric9CircleOutline = "M13,17H9V15H13V13H11A2,2 0 0,1 9,11V9A2,2 0 0,1 11,7H13A2,2 0 0,1 15,9V15A2,2 0 0,1 13,17M13,11V9H11V11H13M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiNumeric9Plus = "M19 11H17V9H15V11H13V13H15V15H17V13H19V11M10 7H8C6.9 7 6 7.9 6 9V11C6 12.11 6.9 13 8 13H10V15H6V17H10C11.11 17 12 16.11 12 15V9C12 7.89 11.1 7 10 7M10 11H8V9H10V11Z";
var mdiNumeric9PlusBox = "M21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5M19,11H17V9H15V11H13V13H15V15H17V13H19V11M10,7H8A2,2 0 0,0 6,9V11C6,12.11 6.9,13 8,13H10V15H6V17H10A2,2 0 0,0 12,15V9C12,7.89 11.1,7 10,7M8,9H10V11H8V9Z";
var mdiNumeric9PlusBoxMultiple = "M11,9V8H12V9H11M21,1A2,2 0 0,1 23,3V17A2,2 0 0,1 21,19H7A2,2 0 0,1 5,17V3A2,2 0 0,1 7,1H21M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M15,9V11H17V13H19V11H21V9H19V7H17V9H15M14,12V8C14,6.89 13.1,6 12,6H11A2,2 0 0,0 9,8V9C9,10.11 9.9,11 11,11H12V12H9V14H12A2,2 0 0,0 14,12Z";
var mdiNumeric9PlusBoxMultipleOutline = "M21,9H19V7H17V9H15V11H17V13H19V11H21V17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M11,9V8H12V9M14,12V8C14,6.89 13.1,6 12,6H11A2,2 0 0,0 9,8V9C9,10.11 9.9,11 11,11H12V12H9V14H12A2,2 0 0,0 14,12M3,5H1V21A2,2 0 0,0 3,23H19V21H3V5Z";
var mdiNumeric9PlusBoxOutline = "M19,11H17V9H15V11H13V13H15V15H17V13H19V19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M9,11V10H10V11M12,14V10C12,8.89 11.1,8 10,8H9A2,2 0 0,0 7,10V11C7,12.11 7.9,13 9,13H10V14H7V16H10A2,2 0 0,0 12,14Z";
var mdiNumeric9PlusCircle = "M19,11H17V9H15V11H13V13H15V15H17V13H19V11M10,7H8A2,2 0 0,0 6,9V11C6,12.11 6.9,13 8,13H10V15H6V17H10A2,2 0 0,0 12,15V9C12,7.89 11.1,7 10,7M8,9H10V11H8V9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z";
var mdiNumeric9PlusCircleOutline = "M19,11V13H17V15H15V13H13V11H15V9H17V11H19M10,7A2,2 0 0,1 12,9V15C12,16.11 11.1,17 10,17H6V15H10V13H8A2,2 0 0,1 6,11V9C6,7.89 6.9,7 8,7H10M8,9V11H10V9H8M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiNumericNegative1 = "M13 7V9H15V17H17V7H13M11 13H5V11H11V13Z";
var mdiNumericOff = "M22.1 21.5L2.4 1.7L1.1 3L5.1 7H2V9H4V17H6V7.9L9.3 11.2C8.5 11.4 8 12.2 8 13V17H14V15.9L20.8 22.7L22.1 21.5M10 15V13H11.1L13.1 15H10M14 10.8L10.2 7H12C13.1 7 14 7.9 14 9V10.8M20 9H16V7H20C21.1 7 22 7.9 22 9V10.5C22 11.3 21.3 12 20.5 12C21.3 12 22 12.7 22 13.5V15C22 16 21.2 16.9 20.2 17L18.2 15H20V13H18V11H20V9Z";
var mdiNumericPositive1 = "M13 7V9H15V17H17V7H13M11 13H9V15H7V13H5V11H7V9H9V11H11V13Z";
var mdiNut = "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z";
var mdiNutrition = "M22,18A4,4 0 0,1 18,22H14A4,4 0 0,1 10,18V16H22V18M4,3H14A2,2 0 0,1 16,5V14H8V19H4A2,2 0 0,1 2,17V5A2,2 0 0,1 4,3M4,6V8H6V6H4M14,8V6H8V8H14M4,10V12H6V10H4M8,10V12H14V10H8M4,14V16H6V14H4Z";
var mdiNuxt = "M21.8 18.36L16.03 8.08C15.93 8 15.63 7.43 15.03 7.43C14.78 7.43 14.43 7.53 14.07 8.08L13.33 9.26L11.31 5.65C11.26 5.55 10.91 5 10.31 5C10.06 5 9.66 5.1 9.36 5.65L2.18 18.31C2.13 18.41 1.83 19 2.13 19.5C2.23 19.75 2.53 20 3.19 20H20.85C20.95 20 21.6 20 21.9 19.5C22 19.26 22.1 18.86 21.8 18.36M8.1 18.31L7.95 18.86H3.24L10.36 6.34L12.66 10.47L8.1 18.31M9.21 18.86L13.32 11.66L17.5 18.86H9.21M18.74 18.86L18.54 18.31L14 10.46L15.03 8.73L20.75 18.86H18.74Z";
var mdiOar = "M20.23,15.21C18.77,13.75 14.97,10.2 12.77,11.27L4.5,3L3,4.5L11.28,12.79C10.3,15 13.88,18.62 15.35,20.08C17.11,21.84 18.26,20.92 19.61,19.57C21.1,18.08 21.61,16.61 20.23,15.21Z";
var mdiOcarina = "M20,12C16.8,10.4 13.4,9.7 10.8,9.3L9.7,5.9C9.3,4.8 7.7,4.8 7.3,5.9L6.3,9C3.9,9.4 2,11.5 2,14C2,16.8 4.2,19 7,19C7,19 14,19 20,16C20,16 22,15 22,14C22,13 20,12 20,12M5,14C4.4,14 4,13.6 4,13C4,12.4 4.4,12 5,12C5.6,12 6,12.4 6,13C6,13.5 5.6,14 5,14M7,17C6.4,17 6,16.6 6,16C6,15.4 6.4,15 7,15C7.6,15 8,15.4 8,16C8,16.5 7.6,17 7,17M9,14C8.4,14 8,13.6 8,13C8,12.4 8.4,12 9,12C9.6,12 10,12.4 10,13C10,13.5 9.6,14 9,14M11,17C10.4,17 10,16.6 10,16C10,15.4 10.4,15 11,15C11.6,15 12,15.4 12,16C12,16.5 11.6,17 11,17M16,14C15.4,14 15,13.6 15,13C15,12.4 15.4,12 16,12C16.6,12 17,12.4 17,13C17,13.5 16.6,14 16,14M19,15C18.4,15 18,14.6 18,14C18,13.4 18.4,13 19,13C19.6,13 20,13.4 20,14C20,14.5 19.6,15 19,15Z";
var mdiOci = "M2 2V22H22V2M19.12 19.03H4.87V5H19.13V19.03M14.83 10.71H17.69V17.59H14.83M14.83 6.41H17.69V9.27H14.83M6.3 6.41V17.59H13.4V14.72H9.17V9.28H13.4V6.41Z";
var mdiOcr = "M2 5V19H14V17H12C10.89 17 10 16.11 10 15V9C10 7.89 10.89 7 12 7H14V5M14 7V9H16V7M14 9H12V15H14M14 15V17H16V15M5 7H7C8.11 7 9 7.89 9 9V15C9 16.11 8.11 17 7 17H5C3.89 17 3 16.11 3 15V9C3 7.89 3.89 7 5 7M17 7V17H19V13H20V14H21V17H23V14H22V12H23V8H22V7M5 9V15H7V9M19 9H21V11H19Z";
var mdiOctagon = "M15.73,3H8.27L3,8.27V15.73L8.27,21H15.73L21,15.73V8.27";
var mdiOctagonOutline = "M8.27,3L3,8.27V15.73L8.27,21H15.73C17.5,19.24 21,15.73 21,15.73V8.27L15.73,3M9.1,5H14.9L19,9.1V14.9L14.9,19H9.1L5,14.9V9.1";
var mdiOctagram = "M2.2,16.06L3.88,12L2.2,7.94L6.26,6.26L7.94,2.2L12,3.88L16.06,2.2L17.74,6.26L21.8,7.94L20.12,12L21.8,16.06L17.74,17.74L16.06,21.8L12,20.12L7.94,21.8L6.26,17.74L2.2,16.06Z";
var mdiOctagramEdit = "M2.2 16.06L3.88 12L2.2 7.94L6.26 6.26L7.94 2.2L12 3.88L16.06 2.2L17.74 6.26L21.8 7.94L20.94 10C20.38 10.06 19.82 10.3 19.38 10.75L11 19.13V20.53L7.94 21.8L6.26 17.74L2.2 16.06M19.83 13.13L20.81 12.15C21 11.95 21.33 11.95 21.53 12.15L22.85 13.47C23.05 13.67 23.05 14 22.85 14.19L21.87 15.17L19.83 13.13M21.17 15.88L15.04 22H13V19.96L19.13 13.83L21.17 15.88L21.17 15.88Z";
var mdiOctagramEditOutline = "M3.88 12L2.2 16.06L6.26 17.74L7.94 21.8L11 20.53V18.36L9 19.19L7.79 16.21L4.81 15L6.05 12L4.81 9L7.79 7.79L9 4.81L12 6.05L15 4.81L16.21 7.79L19.19 9L17.95 12L18 12.13L19.38 10.75C19.82 10.3 20.38 10.06 20.94 10L21.8 7.94L17.74 6.26L16.06 2.2L12 3.88L7.94 2.2L6.26 6.26L2.2 7.94L3.88 12M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96Z";
var mdiOctagramMinus = "M2.2 16.06L3.88 12L2.2 7.94L6.26 6.26L7.94 2.2L12 3.88L16.06 2.2L17.74 6.26L21.8 7.94L20.12 12L20.63 13.22C20.11 13.08 19.56 13 19 13C15.69 13 13 15.69 13 19C13 19.56 13.08 20.11 13.22 20.63L12 20.12L7.94 21.8L6.26 17.74L2.2 16.06M15 20V18H23V20H15Z";
var mdiOctagramMinusOutline = "M2.2 16.06L3.88 12L2.2 7.94L6.26 6.26L7.94 2.2L12 3.88L16.06 2.2L17.74 6.26L21.8 7.94L20.12 12L20.63 13.22C20.11 13.08 19.56 13 19 13C18.79 13 18.58 13 18.38 13.03L17.95 12L19.19 9L16.21 7.79L15 4.81L12 6.05L9 4.81L7.79 7.79L4.81 9L6.05 12L4.81 15L7.79 16.21L9 19.19L12 17.95L13.03 18.38C13 18.58 13 18.79 13 19C13 19.56 13.08 20.11 13.22 20.63L12 20.12L7.94 21.8L6.26 17.74L2.2 16.06M15 18V20H23V18H15Z";
var mdiOctagramOutline = "M2.2,16.06L3.88,12L2.2,7.94L6.26,6.26L7.94,2.2L12,3.88L16.06,2.2L17.74,6.26L21.8,7.94L20.12,12L21.8,16.06L17.74,17.74L16.06,21.8L12,20.12L7.94,21.8L6.26,17.74L2.2,16.06M4.81,9L6.05,12L4.81,15L7.79,16.21L9,19.19L12,17.95L15,19.19L16.21,16.21L19.19,15L17.95,12L19.19,9L16.21,7.79L15,4.81L12,6.05L9,4.81L7.79,7.79L4.81,9Z";
var mdiOctagramPlus = "M2.2 16.06L3.88 12L2.2 7.94L6.26 6.26L7.94 2.2L12 3.88L16.06 2.2L17.74 6.26L21.8 7.94L20.12 12L20.63 13.22C20.11 13.08 19.56 13 19 13C15.69 13 13 15.69 13 19C13 19.56 13.08 20.11 13.22 20.63L12 20.12L7.94 21.8L6.26 17.74L2.2 16.06M20 20H23V18H20V15H18V18H15V20H18V23H20V20Z";
var mdiOctagramPlusOutline = "M2.2 16.06L3.88 12L2.2 7.94L6.26 6.26L7.94 2.2L12 3.88L16.06 2.2L17.74 6.26L21.8 7.94L20.12 12L20.63 13.22C20.11 13.08 19.56 13 19 13C18.79 13 18.58 13 18.38 13.03L17.95 12L19.19 9L16.21 7.79L15 4.81L12 6.05L9 4.81L7.79 7.79L4.81 9L6.05 12L4.81 15L7.79 16.21L9 19.19L12 17.95L13.03 18.38C13 18.58 13 18.79 13 19C13 19.56 13.08 20.11 13.22 20.63L12 20.12L7.94 21.8L6.26 17.74L2.2 16.06M20 20H23V18H20V15H18V18H15V20H18V23H20V20Z";
var mdiOctahedron = "M21.7 11.29H21.71L12.71 2.29C12.5 2.1 12.26 2 12 2C11.74 2 11.5 2.1 11.29 2.29L2.29 11.29H2.3C1.91 11.68 1.91 12.32 2.3 12.71H2.29L11.29 21.71C11.5 21.9 11.74 22 12 22C12.26 22 12.5 21.9 12.71 21.71L21.71 12.71H21.7C22.09 12.32 22.09 11.68 21.7 11.29M13 8.28V5.41L17.3 9.71L13 8.28M11 8.28L6.7 9.71L11 5.41V8.28M12 10.05L17.84 12L12 13.95L6.16 12L12 10.05M11 15.72V18.59L6.7 14.29L11 15.72M13 15.72L17.3 14.29L13 18.59V15.72Z";
var mdiOctahedronOff = "M11 5.41V7.8L13.88 10.68L17.84 12L15.86 12.66L18.81 15.61L21.71 12.71H21.7C22.09 12.32 22.09 11.68 21.7 11.29H21.71L12.71 2.29C12.5 2.1 12.26 2 12 2S11.5 2.1 11.29 2.29L8.39 5.19L9.81 6.61L11 5.41M13 5.41L17.3 9.71L13 8.28V5.41M2.39 1.73L1.11 3L5.85 7.74L2.29 11.29H2.3C1.91 11.68 1.91 12.32 2.3 12.71H2.29L11.29 21.71C11.5 21.9 11.74 22 12 22S12.5 21.9 12.71 21.71L16.26 18.15L20.84 22.73L22.11 21.46L2.39 1.73M7.26 9.15L7.54 9.43L6.7 9.71L7.26 9.15M11 18.59L6.7 14.29L11 15.72V18.59M12 13.95L6.16 12L9.12 11L12.04 13.93L12 13.95M13 18.59V15.72L13.62 15.5L14.85 16.74L13 18.59Z";
var mdiOdnoklassniki = "M17.83,12.74C17.55,12.17 16.76,11.69 15.71,12.5C14.28,13.64 12,13.64 12,13.64C12,13.64 9.72,13.64 8.29,12.5C7.24,11.69 6.45,12.17 6.17,12.74C5.67,13.74 6.23,14.23 7.5,15.04C8.59,15.74 10.08,16 11.04,16.1L10.24,16.9C9.1,18.03 8,19.12 7.25,19.88C6.8,20.34 6.8,21.07 7.25,21.5L7.39,21.66C7.84,22.11 8.58,22.11 9.03,21.66L12,18.68C13.15,19.81 14.24,20.9 15,21.66C15.45,22.11 16.18,22.11 16.64,21.66L16.77,21.5C17.23,21.07 17.23,20.34 16.77,19.88L13.79,16.9L13,16.09C13.95,16 15.42,15.73 16.5,15.04C17.77,14.23 18.33,13.74 17.83,12.74M12,4.57C13.38,4.57 14.5,5.69 14.5,7.06C14.5,8.44 13.38,9.55 12,9.55C10.62,9.55 9.5,8.44 9.5,7.06C9.5,5.69 10.62,4.57 12,4.57M12,12.12C14.8,12.12 17.06,9.86 17.06,7.06C17.06,4.27 14.8,2 12,2C9.2,2 6.94,4.27 6.94,7.06C6.94,9.86 9.2,12.12 12,12.12Z";
var mdiOffer = "M21 13C21.6 13 22.1 13.2 22.4 13.6C22.8 14 23 14.5 23 15L15 18L8 16V7H9.9L17.2 9.7C17.7 9.9 18 10.3 18 10.8C18 11.1 17.9 11.4 17.7 11.6C17.5 11.8 17.2 12 16.8 12H14L12.3 11.3L12 12.2L14 13H21M2 7H6V18H2V7Z";
var mdiOfficeBuilding = "M5,3V21H11V17.5H13V21H19V3H5M7,5H9V7H7V5M11,5H13V7H11V5M15,5H17V7H15V5M7,9H9V11H7V9M11,9H13V11H11V9M15,9H17V11H15V9M7,13H9V15H7V13M11,13H13V15H11V13M15,13H17V15H15V13M7,17H9V19H7V17M15,17H17V19H15V17Z";
var mdiOfficeBuildingCog = "M16 13C15.87 13 15.76 13.09 15.74 13.21L15.55 14.53C15.25 14.66 14.96 14.82 14.7 15L13.46 14.5C13.35 14.5 13.22 14.5 13.15 14.63L12.15 16.36C12.09 16.47 12.11 16.6 12.21 16.68L13.27 17.5C13.25 17.67 13.24 17.83 13.24 18S13.25 18.33 13.27 18.5L12.21 19.32C12.12 19.4 12.09 19.53 12.15 19.64L13.15 21.37C13.21 21.5 13.34 21.5 13.46 21.5L14.7 21C14.96 21.18 15.24 21.35 15.55 21.47L15.74 22.79C15.76 22.91 15.86 23 16 23H18C18.11 23 18.22 22.91 18.24 22.79L18.43 21.47C18.73 21.34 19 21.18 19.27 21L20.5 21.5C20.63 21.5 20.76 21.5 20.83 21.37L21.83 19.64C21.89 19.53 21.86 19.4 21.77 19.32L20.7 18.5C20.72 18.33 20.74 18.17 20.74 18S20.73 17.67 20.7 17.5L21.76 16.68C21.85 16.6 21.88 16.47 21.82 16.36L20.82 14.63C20.76 14.5 20.63 14.5 20.5 14.5L19.27 15C19 14.82 18.73 14.65 18.42 14.53L18.23 13.21C18.22 13.09 18.11 13 18 13H16M17 16.5C17.83 16.5 18.5 17.17 18.5 18S17.83 19.5 17 19.5C16.16 19.5 15.5 18.83 15.5 18S16.17 16.5 17 16.5M16 11.08V3H2V21H8V17.5H10.03C10.26 14.2 12.77 11.54 16 11.08M6 19H4V17H6V19M6 15H4V13H6V15M6 11H4V9H6V11M6 7H4V5H6V7M12 5H14V7H12V5M12 9H14V11H12V9M10 15H8V13H10V15M10 11H8V9H10V11M8 7V5H10V7H8Z";
var mdiOfficeBuildingCogOutline = "M17 13C16.87 13 16.76 13.09 16.74 13.21L16.55 14.53C16.25 14.66 15.96 14.82 15.7 15L14.46 14.5C14.35 14.5 14.22 14.5 14.15 14.63L13.15 16.36C13.09 16.47 13.11 16.6 13.21 16.68L14.27 17.5C14.25 17.67 14.24 17.83 14.24 18S14.25 18.33 14.27 18.5L13.21 19.32C13.12 19.4 13.09 19.53 13.15 19.64L14.15 21.37C14.21 21.5 14.34 21.5 14.46 21.5L15.7 21C15.96 21.18 16.24 21.35 16.55 21.47L16.74 22.79C16.76 22.91 16.86 23 17 23H19C19.11 23 19.22 22.91 19.24 22.79L19.43 21.47C19.73 21.34 20 21.18 20.27 21L21.5 21.5C21.63 21.5 21.76 21.5 21.83 21.37L22.83 19.64C22.89 19.53 22.86 19.4 22.77 19.32L21.7 18.5C21.72 18.33 21.74 18.17 21.74 18S21.73 17.67 21.7 17.5L22.76 16.68C22.85 16.6 22.88 16.47 22.82 16.36L21.82 14.63C21.76 14.5 21.63 14.5 21.5 14.5L20.27 15C20 14.82 19.73 14.65 19.42 14.53L19.23 13.21C19.22 13.09 19.11 13 19 13H17M18 16.5C18.83 16.5 19.5 17.17 19.5 18S18.83 19.5 18 19.5C17.16 19.5 16.5 18.83 16.5 18S17.17 16.5 18 16.5M10 5H12V7H10V5M16 7H14V5H16V7M14 9H16V11H14V9M10 9H12V11H10V9M13.11 23H2V1H20V11.29C19.37 11.11 18.7 11 18 11V3H4V21H10V17.5H11.03C11 17.67 11 17.83 11 18C11 19.96 11.81 21.73 13.11 23M8 15H6V13H8V15M8 11H6V9H8V11M8 7H6V5H8V7M6 17H8V19H6V17M10 13H12V14.41C11.89 14.6 11.78 14.8 11.68 15H10V13Z";
var mdiOfficeBuildingMarker = "M15.19 21C14.12 19.43 13 17.36 13 15.5C13 13.67 13.96 12 15.4 11H15V9H17V10.23C17.5 10.09 18 10 18.5 10C18.67 10 18.84 10 19 10.03V3H5V21H11V17.5H13V21H15.19M15 5H17V7H15V5M9 19H7V17H9V19M9 15H7V13H9V15M9 11H7V9H9V11M9 7H7V5H9V7M11 5H13V7H11V5M11 9H13V11H11V9M11 15V13H13V15H11M18.5 12C16.6 12 15 13.61 15 15.5C15 18.11 18.5 22 18.5 22S22 18.11 22 15.5C22 13.61 20.4 12 18.5 12M18.5 16.81C17.8 16.81 17.3 16.21 17.3 15.61C17.3 14.91 17.9 14.41 18.5 14.41S19.7 15 19.7 15.61C19.8 16.21 19.2 16.81 18.5 16.81Z";
var mdiOfficeBuildingMarkerOutline = "M15 9H17V11H15V9M17 5H15V7H17V5M11 15H13V13H11V15M13 5H11V7H13V5M11 11H13V9H11V11M9 5H7V7H9V5M9 9H7V11H9V9M14.55 21H13V17.5H11V21H5V3H19V11.03C19.71 11.09 20.39 11.31 21 11.63V1H3V23H15.91C15.5 22.44 15 21.76 14.55 21M7 19H9V17H7V19M9 13H7V15H9V13M22 16.5C22 19.1 18.5 23 18.5 23S15 19.1 15 16.5C15 14.6 16.6 13 18.5 13S22 14.6 22 16.5M19.7 16.6C19.7 16 19.1 15.4 18.5 15.4S17.3 15.9 17.3 16.6C17.3 17.2 17.8 17.8 18.5 17.8S19.8 17.2 19.7 16.6Z";
var mdiOfficeBuildingMinus = "M13.4 21C13.2 20.4 13 19.7 13 19C13 17.5 13.6 16.1 14.5 15H13V13H15V14.5C15.6 14 16.3 13.6 17 13.3V3H3V21H9V17.5H11V21H13.4M13 5H15V7H13V5M13 9H15V11H13V9M7 19H5V17H7V19M7 15H5V13H7V15M7 11H5V9H7V11M7 7H5V5H7V7M9 5H11V7H9V5M9 9H11V11H9V9M9 15V13H11V15H9M23 18V20H15V18H23Z";
var mdiOfficeBuildingMinusOutline = "M12 11H10V9H12V11M14 11H16V9H14V11M13.4 21H12V17.5H10V21H4V3H18V13.1C18.3 13 18.7 13 19 13C19.3 13 19.7 13 20 13.1V1H2V23H14.5C14 22.4 13.6 21.7 13.4 21M14 7H16V5H14V7M16 13.8V13H14V15H14.5C15 14.5 15.5 14.1 16 13.8M8 5H6V7H8V5M8 9H6V11H8V9M6 19H8V17H6V19M12 5H10V7H12V5M10 15H12V13H10V15M8 13H6V15H8V13M15 18V20H23V18H15Z";
var mdiOfficeBuildingOutline = "M19 3V21H13V17.5H11V21H5V3H19M15 7H17V5H15V7M11 7H13V5H11V7M7 7H9V5H7V7M15 11H17V9H15V11M11 11H13V9H11V11M7 11H9V9H7V11M15 15H17V13H15V15M11 15H13V13H11V15M7 15H9V13H7V15M15 19H17V17H15V19M7 19H9V17H7V19M21 1H3V23H21V1Z";
var mdiOfficeBuildingPlus = "M13.4 21C13.2 20.4 13 19.7 13 19C13 17.5 13.6 16.1 14.5 15H13V13H15V14.5C15.6 14 16.3 13.6 17 13.3V3H3V21H9V17.5H11V21H13.4M13 5H15V7H13V5M13 9H15V11H13V9M7 19H5V17H7V19M7 15H5V13H7V15M7 11H5V9H7V11M7 7H5V5H7V7M9 5H11V7H9V5M9 9H11V11H9V9M9 15V13H11V15H9M20 15V18H23V20H20V23H18V20H15V18H18V15H20Z";
var mdiOfficeBuildingPlusOutline = "M12 11H10V9H12V11M14 11H16V9H14V11M13.4 21H12V17.5H10V21H4V3H18V13.1C18.3 13 18.7 13 19 13C19.3 13 19.7 13 20 13.1V1H2V23H14.5C14 22.4 13.6 21.7 13.4 21M14 7H16V5H14V7M16 13.8V13H14V15H14.5C15 14.5 15.5 14.1 16 13.8M8 5H6V7H8V5M8 9H6V11H8V9M6 19H8V17H6V19M12 5H10V7H12V5M10 15H12V13H10V15M8 13H6V15H8V13M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiOfficeBuildingRemove = "M13.4 21C13.2 20.4 13 19.7 13 19C13 17.5 13.6 16.1 14.5 15H13V13H15V14.5C15.6 14 16.3 13.6 17 13.3V3H3V21H9V17.5H11V21H13.4M13 5H15V7H13V5M13 9H15V11H13V9M7 19H5V17H7V19M7 15H5V13H7V15M7 11H5V9H7V11M7 7H5V5H7V7M9 5H11V7H9V5M9 9H11V11H9V9M9 15V13H11V15H9M22.5 16.9L20.4 19L22.5 21.1L21.1 22.5L19 20.4L16.9 22.5L15.5 21.1L17.6 19L15.5 16.9L16.9 15.5L19 17.6L21.1 15.5L22.5 16.9Z";
var mdiOfficeBuildingRemoveOutline = "M12 11H10V9H12V11M14 11H16V9H14V11M13.4 21H12V17.5H10V21H4V3H18V13.1C18.3 13 18.7 13 19 13C19.3 13 19.7 13 20 13.1V1H2V23H14.5C14 22.4 13.6 21.7 13.4 21M14 7H16V5H14V7M16 13.8V13H14V15H14.5C15 14.5 15.5 14.1 16 13.8M8 5H6V7H8V5M8 9H6V11H8V9M6 19H8V17H6V19M12 5H10V7H12V5M10 15H12V13H10V15M8 13H6V15H8V13M21.1 15.5L19 17.6L16.9 15.5L15.5 16.9L17.6 19L15.5 21.1L16.9 22.5L19 20.4L21.1 22.5L22.5 21.1L20.4 19L22.5 16.9L21.1 15.5Z";
var mdiOil = "M22,12.5C22,12.5 24,14.67 24,16A2,2 0 0,1 22,18A2,2 0 0,1 20,16C20,14.67 22,12.5 22,12.5M6,6H10A1,1 0 0,1 11,7A1,1 0 0,1 10,8H9V10H11C11.74,10 12.39,10.4 12.73,11L19.24,7.24L22.5,9.13C23,9.4 23.14,10 22.87,10.5C22.59,10.97 22,11.14 21.5,10.86L19.4,9.65L15.75,15.97C15.41,16.58 14.75,17 14,17H5A2,2 0 0,1 3,15V12A2,2 0 0,1 5,10H7V8H6A1,1 0 0,1 5,7A1,1 0 0,1 6,6M5,12V15H14L16.06,11.43L12.6,13.43L11.69,12H5M0.38,9.21L2.09,7.5C2.5,7.11 3.11,7.11 3.5,7.5C3.89,7.89 3.89,8.5 3.5,8.91L1.79,10.62C1.4,11 0.77,11 0.38,10.62C0,10.23 0,9.6 0.38,9.21Z";
var mdiOilLamp = "M5,20H16V22H5M11,5H10A2,2 0 0,0 8,7H13A2,2 0 0,0 11,5M16,8H22A2,2 0 0,1 20,10H19A4,4 0 0,0 15,14V15A4,4 0 0,1 11,19H10A4,4 0 0,1 6,15H4A2,2 0 0,1 2,13V10A2,2 0 0,1 4,8M6,10H4V13H6M19,5A2,2 0 0,1 21,7H22A2.9,2.9 0 0,0 19,4A2,2 0 0,1 17,2H16A2.9,2.9 0 0,0 19,5";
var mdiOilLevel = "M8 18C6.67 18 5.79 18.79 5.29 19.29S4.67 20 4 20 3.21 19.79 2.71 19.29C2.35 18.93 1.79 18.42 1 18.16V20.41C1.09 20.5 1.18 20.59 1.29 20.71C1.79 21.21 2.67 22 4 22S6.21 21.21 6.71 20.71 7.33 20 8 20 8.79 20.21 9.29 20.71C9.73 21.14 10.44 21.8 11.5 21.96C11.66 22 11.83 22 12 22C13.33 22 14.21 21.21 14.71 20.71S15.33 20 16 20 16.79 20.21 17.29 20.71 18.67 22 20 22 22.21 21.21 22.71 20.71C22.82 20.59 22.91 20.5 23 20.41V18.16C22.21 18.42 21.65 18.93 21.29 19.29C20.79 19.79 20.67 20 20 20S19.21 19.79 18.71 19.29 17.33 18 16 18 13.79 18.79 13.29 19.29 12.67 20 12 20C11.78 20 11.63 19.97 11.5 19.92C11.22 19.82 11.05 19.63 10.71 19.29C10.21 18.79 9.33 18 8 18M22 10.5C22 10.5 24 12.67 24 14C24 15.1 23.1 16 22 16S20 15.1 20 14C20 12.67 22 10.5 22 10.5M22.5 7.13L19.24 5.24L12.73 9C12.39 8.4 11.74 8 11 8H9V6H10C10.55 6 11 5.55 11 5S10.55 4 10 4H6C5.45 4 5 4.45 5 5S5.45 6 6 6H7V8H5C3.9 8 3 8.9 3 10V13C3 14.1 3.9 15 5 15H14C14.75 15 15.41 14.58 15.75 13.97L19.4 7.65L21.5 8.86C22 9.14 22.59 8.97 22.87 8.5C23.14 8 23 7.4 22.5 7.13M14 13H5V10H11.69L12.6 11.43L16.06 9.43L14 13M3.5 6.92L1.79 8.62A1 1 0 0 1 .38 7.21L2.09 5.5A1 1 0 0 1 3.5 5.5C3.89 5.89 3.89 6.5 3.5 6.92Z";
var mdiOilTemperature = "M10 5H13V3H10V2C10 1.4 9.6 1 9 1S8 1.4 8 2V15.3C7.4 15.6 7 16.3 7 17C7 18.1 7.9 19 9 19S11 18.1 11 17C11 16.3 10.6 15.6 10 15.3V13H13V11H10V9H13V7H10V5M22 17.5C22 17.5 24 19.7 24 21C24 22.1 23.1 23 22 23S20 22.1 20 21C20 19.7 22 17.5 22 17.5M22.9 15.5C22.6 16 22 16.1 21.5 15.9L19.4 14.7L15.8 21C15.5 21.6 14.8 22 14 22H5C3.9 22 3 21.1 3 20V17C3 15.9 3.9 15 5 15V20H14L16.1 16.4L13 18.2V15.8L19.2 12.2L22.5 14.1C23 14.4 23.1 15 22.9 15.5M3.5 13.9L1.8 15.6C1.4 16 .8 16 .4 15.6S0 14.6.4 14.2L2.1 12.5C2.5 12.1 3.1 12.1 3.5 12.5S3.9 13.5 3.5 13.9Z";
var mdiOm = "M15,2L13.5,3.5L15,5L16.5,3.5L15,2M11,3C10,9 17,10 20,6L18,4.5C17,6 13,8 11,3M9,7C7,7 4.5,8.5 4.5,8.5L6,11C7,10 9,9.5 10,10C12,11 9,13 7,12V15.5C10,14 12,16 11,17.5C8,22 3,16 3,13C1,19 6,22 9,22C12,22 14,20 12.5,15H14C12.5,19.5 18,24 21,18C22,16 22,9.5 17,9.5C13,9.5 14,15 10.5,13.5C14,10 12,7 9,7M19,12C22,15 15,21 15,15C15,13 17,10.5 19,12Z";
var mdiOmega = "M19.15,19H13.39V16.87C15.5,15.25 16.59,13.24 16.59,10.84C16.59,9.34 16.16,8.16 15.32,7.29C14.47,6.42 13.37,6 12.03,6C10.68,6 9.57,6.42 8.71,7.3C7.84,8.17 7.41,9.37 7.41,10.88C7.41,13.26 8.5,15.26 10.61,16.87V19H4.85V16.87H8.41C6.04,15.32 4.85,13.23 4.85,10.6C4.85,8.5 5.5,6.86 6.81,5.66C8.12,4.45 9.84,3.85 11.97,3.85C14.15,3.85 15.89,4.45 17.19,5.64C18.5,6.83 19.15,8.5 19.15,10.58C19.15,13.21 17.95,15.31 15.55,16.87H19.15V19Z";
var mdiOneUp = "M10,19V19C9.4,19 9,18.6 9,18V17C9,16.5 9.4,16 10,16V16C10.5,16 11,16.4 11,17V18C11,18.6 10.6,19 10,19M15,18V17C15,16.5 14.6,16 14,16V16C13.5,16 13,16.4 13,17V18C13,18.5 13.4,19 14,19V19C14.6,19 15,18.6 15,18M22,12C22,14.6 20.4,16.9 18,18.4V20A2,2 0 0,1 16,22H8A2,2 0 0,1 6,20V18.4C3.6,16.9 2,14.6 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M7,10C7,8.9 6.4,7.9 5.5,7.4C4.5,8.7 4,10.3 4,12C4,12.3 4,12.7 4.1,13C5.7,12.9 7,11.6 7,10M9,9C9,10.7 10.3,12 12,12C13.7,12 15,10.7 15,9C15,7.3 13.7,6 12,6C10.3,6 9,7.3 9,9M16,20V15.5C14.8,15.2 13.4,15 12,15C10.6,15 9.2,15.2 8,15.5V20H16M19.9,13C20,12.7 20,12.3 20,12C20,10.3 19.5,8.7 18.5,7.4C17.6,7.9 17,8.9 17,10C17,11.6 18.3,12.9 19.9,13Z";
var mdiOnepassword = "M12,1C5.92,1 1,5.92 1,12C1,18.08 5.92,23 12,23C18.08,23 23,18.08 23,12C23,5.92 18.08,1 12,1M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M13,13.5C13,14.13 13.4,14.7 14,14.91V18H10V11.91C10.78,11.64 11.19,10.8 10.93,10C10.78,9.58 10.44,9.24 10,9.09V6H14V12.09C13.4,12.3 13,12.87 13,13.5Z";
var mdiOpacity = "M17.66,8L12,2.35L6.34,8C4.78,9.56 4,11.64 4,13.64C4,15.64 4.78,17.75 6.34,19.31C7.9,20.87 9.95,21.66 12,21.66C14.05,21.66 16.1,20.87 17.66,19.31C19.22,17.75 20,15.64 20,13.64C20,11.64 19.22,9.56 17.66,8M6,14C6,12 6.62,10.73 7.76,9.6L12,5.27L16.24,9.65C17.38,10.77 18,12 18,14H6Z";
var mdiOpenInApp = "M12,10L8,14H11V20H13V14H16M19,4H5C3.89,4 3,4.9 3,6V18A2,2 0 0,0 5,20H9V18H5V8H19V18H15V20H19A2,2 0 0,0 21,18V6A2,2 0 0,0 19,4Z";
var mdiOpenInNew = "M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z";
var mdiOpenSourceInitiative = "M15.41,22C15.35,22 15.28,22 15.22,22C15.1,21.95 15,21.85 14.96,21.73L12.74,15.93C12.65,15.69 12.77,15.42 13,15.32C13.71,15.06 14.28,14.5 14.58,13.83C15.22,12.4 14.58,10.73 13.15,10.09C11.72,9.45 10.05,10.09 9.41,11.5C9.11,12.21 9.09,13 9.36,13.69C9.66,14.43 10.25,15 11,15.28C11.24,15.37 11.37,15.64 11.28,15.89L9,21.69C8.96,21.81 8.87,21.91 8.75,21.96C8.63,22 8.5,22 8.39,21.96C3.24,19.97 0.67,14.18 2.66,9.03C4.65,3.88 10.44,1.31 15.59,3.3C18.06,4.26 20.05,6.15 21.13,8.57C22.22,11 22.29,13.75 21.33,16.22C20.32,18.88 18.23,21 15.58,22C15.5,22 15.47,22 15.41,22M12,3.59C7.03,3.46 2.9,7.39 2.77,12.36C2.68,16.08 4.88,19.47 8.32,20.9L10.21,16C8.38,15 7.69,12.72 8.68,10.89C9.67,9.06 11.96,8.38 13.79,9.36C15.62,10.35 16.31,12.64 15.32,14.47C14.97,15.12 14.44,15.65 13.79,16L15.68,20.93C17.86,19.95 19.57,18.16 20.44,15.93C22.28,11.31 20.04,6.08 15.42,4.23C14.33,3.8 13.17,3.58 12,3.59Z";
var mdiOpenid = "M14,2L11,3.5V19.94C7,19.5 4,17.46 4,15C4,12.75 6.5,10.85 10,10.22V8.19C4.86,8.88 1,11.66 1,15C1,18.56 5.36,21.5 11,21.94C11.03,21.94 11.06,21.94 11.09,21.94L14,20.5V2M15,8.19V10.22C16.15,10.43 17.18,10.77 18.06,11.22L16.5,12L23,13.5L22.5,9L20.5,10C19,9.12 17.12,8.47 15,8.19Z";
var mdiOpera = "M9.04,17.07C8.04,15.9 7.4,14.16 7.35,12.21V11.79C7.4,9.84 8.04,8.1 9.04,6.93C9.86,5.95 10.93,5.37 12.1,5.37C14.72,5.37 16.84,8.34 16.84,12C16.84,15.66 14.72,18.63 12.1,18.63C10.93,18.63 10.33,18.5 9.04,17.07M12.03,3H12A9,9 0 0,0 3,12C3,16.83 6.8,20.77 11.57,21H12C14.3,21 16.4,20.13 18,18.71C19.84,17.06 21,14.67 21,12C21,9.33 19.84,6.94 18,5.29C16.41,3.87 14.32,3 12.03,3Z";
var mdiOrbit = "M8.11,1.75C9.3,1.25 10.62,1 12,1C18.08,1 23,5.92 23,12C23,18.08 18.08,23 12,23C5.92,23 1,18.08 1,12C1,10.62 1.25,9.3 1.72,8.08C2.24,8.61 2.83,8.96 3.45,9.18C3.16,10.07 3,11 3,12A9,9 0 0,0 12,21A9,9 0 0,0 21,12A9,9 0 0,0 12,3C11,3 10.07,3.16 9.18,3.45C8.96,2.83 8.61,2.24 8.11,1.75M4.93,2.93C6.03,2.93 6.93,3.82 6.93,4.93A2,2 0 0,1 4.93,6.93C3.82,6.93 2.93,6.03 2.93,4.93C2.93,3.82 3.82,2.93 4.93,2.93M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7Z";
var mdiOrbitVariant = "M19 8L15 12H18C18 15.31 15.31 18 12 18C11 18 10.03 17.75 9.2 17.3L7.74 18.76C8.97 19.54 10.43 20 12 20C16.42 20 20 16.42 20 12H23M6 12C6 8.69 8.69 6 12 6C13 6 13.97 6.25 14.8 6.7L16.26 5.24C15.03 4.46 13.57 4 12 4C7.58 4 4 7.58 4 12H1L5 16L9 12M14 12C14 13.11 13.11 14 12 14S10 13.11 10 12 10.9 10 12 10 14 10.9 14 12Z";
var mdiOrderAlphabeticalAscending = "M12 5H22V7H12M12 19V17H22V19M12 11H22V13H12M9 13V15L5.67 19H9V21H3V19L6.33 15H3V13M7 3H5C3.9 3 3 3.9 3 5V11H5V9H7V11H9V5C9 3.9 8.11 3 7 3M7 7H5V5H7Z";
var mdiOrderAlphabeticalDescending = "M7 13H5C3.9 13 3 13.9 3 15V21H5V19H7V21H9V15C9 13.9 8.11 13 7 13M7 17H5V15H7M9 3V5L5.67 9H9V11H3V9L6.33 5H3V3M12 5H22V7H12M12 19V17H22V19M12 11H22V13H12Z";
var mdiOrderBoolAscending = "M6 3C3.79 3 2 4.79 2 7S3.79 11 6 11 10 9.21 10 7 8.21 3 6 3M6 9C4.9 9 4 8.1 4 7S4.9 5 6 5 8 5.9 8 7 7.1 9 6 9M6 13C3.79 13 2 14.79 2 17S3.79 21 6 21 10 19.21 10 17 8.21 13 6 13M12 5H22V7H12V5M12 19V17H22V19H12M12 11H22V13H12V11Z";
var mdiOrderBoolAscendingVariant = "M4 13C2.89 13 2 13.89 2 15V19C2 20.11 2.89 21 4 21H8C9.11 21 10 20.11 10 19V15C10 13.89 9.11 13 8 13M8.2 14.5L9.26 15.55L5.27 19.5L2.74 16.95L3.81 15.9L5.28 17.39M4 3C2.89 3 2 3.89 2 5V9C2 10.11 2.89 11 4 11H8C9.11 11 10 10.11 10 9V5C10 3.89 9.11 3 8 3M4 5H8V9H4M12 5H22V7H12M12 19V17H22V19M12 11H22V13H12Z";
var mdiOrderBoolDescending = "M6 13C3.79 13 2 14.79 2 17S3.79 21 6 21 10 19.21 10 17 8.21 13 6 13M6 19C4.9 19 4 18.1 4 17S4.9 15 6 15 8 15.9 8 17 7.1 19 6 19M6 3C3.79 3 2 4.79 2 7S3.79 11 6 11 10 9.21 10 7 8.21 3 6 3M12 5H22V7H12V5M12 19V17H22V19H12M12 11H22V13H12V11Z";
var mdiOrderBoolDescendingVariant = "M4 3C2.89 3 2 3.89 2 5V9C2 10.11 2.89 11 4 11H8C9.11 11 10 10.11 10 9V5C10 3.89 9.11 3 8 3M8.2 4.5L9.26 5.55L5.27 9.5L2.74 6.95L3.81 5.9L5.28 7.39M4 13C2.89 13 2 13.89 2 15V19C2 20.11 2.89 21 4 21H8C9.11 21 10 20.11 10 19V15C10 13.89 9.11 13 8 13M4 15H8V19H4M12 5H22V7H12M12 19V17H22V19M12 11H22V13H12Z";
var mdiOrderNumericAscending = "M7 21H3V19H7V18H5C3.9 18 3 17.11 3 16V15C3 13.9 3.9 13 5 13H7C8.11 13 9 13.9 9 15V19C9 20.11 8.11 21 7 21M7 15H5V16H7M5 3H7C8.11 3 9 3.9 9 5V9C9 10.11 8.11 11 7 11H5C3.9 11 3 10.11 3 9V5C3 3.9 3.9 3 5 3M5 9H7V5H5M12 5H22V7H12M12 19V17H22V19M12 11H22V13H12Z";
var mdiOrderNumericDescending = "M7 11H3V9H7V8H5C3.9 8 3 7.11 3 6V5C3 3.9 3.9 3 5 3H7C8.11 3 9 3.9 9 5V9C9 10.11 8.11 11 7 11M7 5H5V6H7M5 13H7C8.11 13 9 13.9 9 15V19C9 20.11 8.11 21 7 21H5C3.9 21 3 20.11 3 19V15C3 13.9 3.9 13 5 13M5 19H7V15H5M12 5H22V7H12M12 19V17H22V19M12 11H22V13H12Z";
var mdiOrigin = "M12,2.13C12,2.23 11.95,2.33 11.89,2.41C11.5,3 11.16,3.64 11.04,4.33L11,4.56L12,4.5A7.5,7.5 0 0,1 19.5,12C19.5,13.62 19,15.11 18.12,16.34C16.73,18.68 14.72,20.65 12.34,21.97C12.25,22 12.12,22 12.06,21.93C12,21.83 12,21.7 12.09,21.61C12.47,21.09 12.73,20.5 12.87,19.85L12.93,19.44L12,19.5A7.5,7.5 0 0,1 4.5,12C4.5,10.39 5,8.89 5.88,7.67C7.26,5.32 9.28,3.34 11.67,2C11.78,1.95 11.94,2 12,2.13M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z";
var mdiOrnament = "M12,1A3,3 0 0,1 15,4V5A1,1 0 0,1 16,6V7.07C18.39,8.45 20,11.04 20,14A8,8 0 0,1 12,22A8,8 0 0,1 4,14C4,11.04 5.61,8.45 8,7.07V6A1,1 0 0,1 9,5V4A3,3 0 0,1 12,1M12,3A1,1 0 0,0 11,4V5H13V4A1,1 0 0,0 12,3M12,8C10.22,8 8.63,8.77 7.53,10H16.47C15.37,8.77 13.78,8 12,8M6.34,16H7.59L6,14.43C6.05,15 6.17,15.5 6.34,16M12.59,16L8.59,12H6.41L10.41,16H12.59M17.66,12H16.41L18,13.57C17.95,13 17.83,12.5 17.66,12M11.41,12L15.41,16H17.59L13.59,12H11.41M12,20C13.78,20 15.37,19.23 16.47,18H7.53C8.63,19.23 10.22,20 12,20Z";
var mdiOrnamentVariant = "M12,1A3,3 0 0,1 15,4V5A1,1 0 0,1 16,6V7.07C18.39,8.45 20,11.04 20,14A8,8 0 0,1 12,22A8,8 0 0,1 4,14C4,11.04 5.61,8.45 8,7.07V6A1,1 0 0,1 9,5V4A3,3 0 0,1 12,1M12,3A1,1 0 0,0 11,4V5H13V4A1,1 0 0,0 12,3M12,8C10.22,8 8.63,8.77 7.53,10H16.47C15.37,8.77 13.78,8 12,8M12,20C13.78,20 15.37,19.23 16.47,18H7.53C8.63,19.23 10.22,20 12,20M12,12A2,2 0 0,0 10,14A2,2 0 0,0 12,16A2,2 0 0,0 14,14A2,2 0 0,0 12,12M18,14C18,13.31 17.88,12.65 17.67,12C16.72,12.19 16,13 16,14C16,15 16.72,15.81 17.67,15.97C17.88,15.35 18,14.69 18,14M6,14C6,14.69 6.12,15.35 6.33,15.97C7.28,15.81 8,15 8,14C8,13 7.28,12.19 6.33,12C6.12,12.65 6,13.31 6,14Z";
var mdiOutdoorLamp = "M15 22H13C11.9 22 11 21.1 11 20V15H17V20C17 21.1 16.1 22 15 22M7 14H21L15 9.71V6C15 4.39 13.94 2 11 2S7 4.39 7 6C7 6.45 6.81 7 6 7H5V3H3V12H5V9H6C8.2 9 9 7.21 9 6C9 5.67 9.1 4 11 4C12.83 4 13 5.54 13 6V9.71L7 14Z";
var mdiOverscan = "M12 5.5L10 8H14L12 5.5M18 10V14L20.5 12L18 10M6 10L3.5 12L6 14V10M14 16H10L12 18.5L14 16M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3M21 19H3V5H21V19Z";
var mdiOwl = "M12,16C12.56,16.84 13.31,17.53 14.2,18L12,20.2L9.8,18C10.69,17.53 11.45,16.84 12,16M17,11.2A2,2 0 0,0 15,13.2A2,2 0 0,0 17,15.2A2,2 0 0,0 19,13.2C19,12.09 18.1,11.2 17,11.2M7,11.2A2,2 0 0,0 5,13.2A2,2 0 0,0 7,15.2A2,2 0 0,0 9,13.2C9,12.09 8.1,11.2 7,11.2M17,8.7A4,4 0 0,1 21,12.7A4,4 0 0,1 17,16.7A4,4 0 0,1 13,12.7A4,4 0 0,1 17,8.7M7,8.7A4,4 0 0,1 11,12.7A4,4 0 0,1 7,16.7A4,4 0 0,1 3,12.7A4,4 0 0,1 7,8.7M2.24,1C4,4.7 2.73,7.46 1.55,10.2C1.19,11 1,11.83 1,12.7A6,6 0 0,0 7,18.7C7.21,18.69 7.42,18.68 7.63,18.65L10.59,21.61L12,23L13.41,21.61L16.37,18.65C16.58,18.68 16.79,18.69 17,18.7A6,6 0 0,0 23,12.7C23,11.83 22.81,11 22.45,10.2C21.27,7.46 20,4.7 21.76,1C19.12,3.06 15.36,4.69 12,4.7C8.64,4.69 4.88,3.06 2.24,1Z";
var mdiPacMan = "M12,12L19.07,19.07C15.17,23 8.83,23 4.93,19.07C1,15.17 1,8.84 4.93,4.93C8.83,1 15.16,1 19.07,4.93L12,12M19,10A2,2 0 0,0 17,12A2,2 0 0,0 19,14A2,2 0 0,0 21,12A2,2 0 0,0 19,10Z";
var mdiPackage = "M5.12,5H18.87L17.93,4H5.93L5.12,5M20.54,5.23C20.83,5.57 21,6 21,6.5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V6.5C3,6 3.17,5.57 3.46,5.23L4.84,3.55C5.12,3.21 5.53,3 6,3H18C18.47,3 18.88,3.21 19.15,3.55L20.54,5.23M6,18H12V15H6V18Z";
var mdiPackageCheck = "M6 3C5.5 3 5.1 3.2 4.8 3.6L3.5 5.2C3.2 5.6 3 6 3 6.5V19C3 20.1 3.9 21 5 21H13.3C13.1 20.4 13 19.7 13 19C13 15.7 15.7 13 19 13C19.7 13 20.4 13.1 21 13.3V6.5C21 6 20.8 5.6 20.5 5.2L19.1 3.5C18.9 3.2 18.5 3 18 3H6M5.9 4H17.9L18.8 5H5.1L5.9 4M6 15H12V18H6V15M21.3 15.8L17.7 19.4L16.1 17.8L15 19L17.8 22L22.6 17.2L21.3 15.8Z";
var mdiPackageDown = "M5.12,5L5.93,4H17.93L18.87,5M12,17.5L6.5,12H10V10H14V12H17.5L12,17.5M20.54,5.23L19.15,3.55C18.88,3.21 18.47,3 18,3H6C5.53,3 5.12,3.21 4.84,3.55L3.46,5.23C3.17,5.57 3,6 3,6.5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V6.5C21,6 20.83,5.57 20.54,5.23Z";
var mdiPackageUp = "M20.54,5.23C20.83,5.57 21,6 21,6.5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V6.5C3,6 3.17,5.57 3.46,5.23L4.84,3.55C5.12,3.21 5.53,3 6,3H18C18.47,3 18.88,3.21 19.15,3.55L20.54,5.23M5.12,5H18.87L17.93,4H5.93L5.12,5M12,9.5L6.5,15H10V17H14V15H17.5L12,9.5Z";
var mdiPackageVariant = "M2,10.96C1.5,10.68 1.35,10.07 1.63,9.59L3.13,7C3.24,6.8 3.41,6.66 3.6,6.58L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.66,6.72 20.82,6.88 20.91,7.08L22.36,9.6C22.64,10.08 22.47,10.69 22,10.96L21,11.54V16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V10.96C2.7,11.13 2.32,11.14 2,10.96M12,4.15V4.15L12,10.85V10.85L17.96,7.5L12,4.15M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V12.69L14,15.59C13.67,15.77 13.3,15.76 13,15.6V19.29L19,15.91M13.85,13.36L20.13,9.73L19.55,8.72L13.27,12.35L13.85,13.36Z";
var mdiPackageVariantClosed = "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L10.11,5.22L16,8.61L17.96,7.5L12,4.15M6.04,7.5L12,10.85L13.96,9.75L8.08,6.35L6.04,7.5M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V9.21L13,12.58V19.29L19,15.91Z";
var mdiPackageVariantClosedCheck = "M12 2C11.8 2 11.6 2.1 11.4 2.2L3.5 6.6C3.2 6.8 3 7.1 3 7.5V16.5C3 16.9 3.2 17.2 3.5 17.4L11.4 21.8C11.6 21.9 11.8 22 12 22S12.4 21.9 12.6 21.8L13.5 21.3C13.2 20.7 13.1 20 13 19.3V12.6L19 9.2V13C19.7 13 20.4 13.1 21 13.3V7.5C21 7.1 20.8 6.8 20.5 6.6L12.6 2.2C12.4 2.1 12.2 2 12 2M12 4.2L18 7.5L16 8.6L10.1 5.2L12 4.2M8.1 6.3L14 9.8L12 10.9L6 7.5L8.1 6.3M5 9.2L11 12.6V19.3L5 15.9V9.2M21.3 15.8L17.7 19.4L16.1 17.8L15 19L17.8 22L22.6 17.2L21.3 15.8Z";
var mdiPackageVariantClosedMinus = "M13 12.6L19 9.2V13C19.7 13 20.4 13.1 21 13.4V7.5C21 7.1 20.8 6.8 20.5 6.6L12.6 2.2C12.4 2.1 12.2 2 12 2S11.6 2.1 11.4 2.2L3.5 6.6C3.2 6.8 3 7.1 3 7.5V16.5C3 16.9 3.2 17.2 3.5 17.4L11.4 21.8C11.6 21.9 11.8 22 12 22S12.4 21.9 12.6 21.8L13.5 21.3C13.2 20.7 13.1 20 13 19.3M12 4.2L18 7.5L16 8.6L10.1 5.2L12 4.2M11 19.3L5 15.9V9.2L11 12.6V19.3M12 10.8L6 7.5L8 6.3L14 9.8L12 10.8M23 18V20H15V18H23Z";
var mdiPackageVariantClosedPlus = "M13 19.3V12.6L19 9.2V13C19.7 13 20.4 13.1 21 13.4V7.5C21 7.1 20.8 6.8 20.5 6.6L12.6 2.2C12.4 2.1 12.2 2 12 2S11.6 2.1 11.4 2.2L3.5 6.6C3.2 6.8 3 7.1 3 7.5V16.5C3 16.9 3.2 17.2 3.5 17.4L11.4 21.8C11.6 21.9 11.8 22 12 22S12.4 21.9 12.6 21.8L13.5 21.3C13.2 20.7 13.1 20 13 19.3M12 4.2L18 7.5L16 8.6L10.1 5.2L12 4.2M11 19.3L5 15.9V9.2L11 12.6V19.3M12 10.8L6 7.5L8 6.3L14 9.8L12 10.8M20 15V18H23V20H20V23H18V20H15V18H18V15H20Z";
var mdiPackageVariantClosedRemove = "M13 12.6L19 9.2V13C19.7 13 20.4 13.1 21 13.4V7.5C21 7.1 20.8 6.8 20.5 6.6L12.6 2.2C12.4 2.1 12.2 2 12 2S11.6 2.1 11.4 2.2L3.5 6.6C3.2 6.8 3 7.1 3 7.5V16.5C3 16.9 3.2 17.2 3.5 17.4L11.4 21.8C11.6 21.9 11.8 22 12 22S12.4 21.9 12.6 21.8L13.5 21.3C13.2 20.7 13.1 20 13 19.3M12 4.2L18 7.5L16 8.6L10.1 5.2L12 4.2M11 19.3L5 15.9V9.2L11 12.6V19.3M12 10.8L6 7.5L8 6.3L14 9.8L12 10.8M16.9 15.5L19 17.6L21.1 15.5L22.5 16.9L20.4 19L22.5 21.1L21.1 22.5L19 20.4L16.9 22.5L15.5 21.1L17.6 19L15.5 16.9L16.9 15.5Z";
var mdiPackageVariantMinus = "M13 15.6C13.3 15.8 13.7 15.8 14 15.6L19 12.7V13C19.7 13 20.4 13.1 21 13.4V11.6L22 11C22.5 10.7 22.6 10.1 22.4 9.6L20.9 7.1C20.8 6.9 20.7 6.7 20.5 6.6L12.6 2.2C12.4 2.1 12.2 2 12 2S11.6 2.1 11.4 2.2L3.6 6.6C3.4 6.7 3.2 6.8 3.1 7L1.6 9.6C1.3 10.1 1.5 10.7 2 11C2.3 11.2 2.7 11.2 3 11V16.5C3 16.9 3.2 17.2 3.5 17.4L11.4 21.8C11.6 21.9 11.8 22 12 22S12.4 21.9 12.6 21.8L13.5 21.3C13.2 20.7 13.1 20 13 19.3M11 19.3L5 15.9V9.2L11 12.6V19.3M20.1 9.7L13.8 13.3L13.2 12.3L19.5 8.7L20.1 9.7M12 10.8V4.2L18 7.5L12 10.8M23 20H15V18H23V20Z";
var mdiPackageVariantPlus = "M13 15.6C13.3 15.8 13.7 15.8 14 15.6L19 12.7V13C19.7 13 20.4 13.1 21 13.4V11.6L22 11C22.5 10.7 22.6 10.1 22.4 9.6L20.9 7.1C20.8 6.9 20.7 6.7 20.5 6.6L12.6 2.2C12.4 2.1 12.2 2 12 2S11.6 2.1 11.4 2.2L3.6 6.6C3.4 6.7 3.2 6.8 3.1 7L1.6 9.6C1.3 10.1 1.5 10.7 2 11C2.3 11.2 2.7 11.2 3 11V16.5C3 16.9 3.2 17.2 3.5 17.4L11.4 21.8C11.6 21.9 11.8 22 12 22S12.4 21.9 12.6 21.8L13.5 21.3C13.2 20.7 13.1 20 13 19.3M11 19.3L5 15.9V9.2L11 12.6V19.3M20.1 9.7L13.8 13.3L13.2 12.3L19.5 8.7L20.1 9.7M12 10.8V4.2L18 7.5L12 10.8M20 15V18H23V20H20V23H18V20H15V18H18V15H20Z";
var mdiPackageVariantRemove = "M13 15.6C13.3 15.8 13.7 15.8 14 15.6L19 12.7V13C19.7 13 20.4 13.1 21 13.4V11.6L22 11C22.5 10.7 22.6 10.1 22.4 9.6L20.9 7.1C20.8 6.9 20.7 6.7 20.5 6.6L12.6 2.2C12.4 2.1 12.2 2 12 2S11.6 2.1 11.4 2.2L3.6 6.6C3.4 6.7 3.2 6.8 3.1 7L1.6 9.6C1.3 10.1 1.5 10.7 2 11C2.3 11.2 2.7 11.2 3 11V16.5C3 16.9 3.2 17.2 3.5 17.4L11.4 21.8C11.6 21.9 11.8 22 12 22S12.4 21.9 12.6 21.8L13.5 21.3C13.2 20.7 13.1 20 13 19.3M11 19.3L5 15.9V9.2L11 12.6V19.3M20.1 9.7L13.8 13.3L13.2 12.3L19.5 8.7L20.1 9.7M12 10.8V4.2L18 7.5L12 10.8M22.5 16.9L20.4 19L22.5 21.1L21.1 22.5L19 20.4L16.9 22.5L15.5 21.1L17.6 19L15.5 16.9L16.9 15.5L19 17.6L21.1 15.5L22.5 16.9Z";
var mdiPageFirst = "M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z";
var mdiPageLast = "M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z";
var mdiPageLayoutBody = "M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M6,8V16H18V8H6Z";
var mdiPageLayoutFooter = "M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M6,16V20H18V16H6Z";
var mdiPageLayoutHeader = "M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M6,4V8H18V4H6Z";
var mdiPageLayoutHeaderFooter = "M18 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V4C20 2.9 19.11 2 18 2M18 20H6V16H18V20M18 8H6V4H18V8Z";
var mdiPageLayoutSidebarLeft = "M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M6,8V16H10V8H6Z";
var mdiPageLayoutSidebarRight = "M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M14,8V16H18V8H14Z";
var mdiPageNext = "M20,3H5A2,2 0 0,0 3,5V11H7V9L11,12L7,15V13H3V19A2,2 0 0,0 5,21H20A2,2 0 0,0 22,19V5A2,2 0 0,0 20,3M17,17H13V15H17V17M20,13H13V11H20V13M20,9H13V7H20V9M3,13H0V11H3V13Z";
var mdiPageNextOutline = "M22,3H5A2,2 0 0,0 3,5V9H5V5H22V19H5V15H3V19A2,2 0 0,0 5,21H22A2,2 0 0,0 24,19V5A2,2 0 0,0 22,3M7,15V13H0V11H7V9L11,12L7,15M20,13H13V11H20V13M20,9H13V7H20V9M17,17H13V15H17V17Z";
var mdiPagePrevious = "M4,21H19A2,2 0 0,0 21,19V13H17V15L13,12L17,9V11H21V5A2,2 0 0,0 19,3H4A2,2 0 0,0 2,5V19A2,2 0 0,0 4,21M4,15H8V17H4V15M4,11H11V13H4V11M4,7H11V9H4V7M21,11H24V13H21V11Z";
var mdiPagePreviousOutline = "M2,3H19A2,2 0 0,1 21,5V9H19V5H2V19H19V15H21V19A2,2 0 0,1 19,21H2A2,2 0 0,1 0,19V5A2,2 0 0,1 2,3M17,15V13H24V11H17V9L13,12L17,15M4,13H11V11H4V13M4,9H11V7H4V9M4,17H8V15H4V17Z";
var mdiPail = "M11.5 7.63C11.97 7.35 12.58 7.5 12.86 8C13.14 8.47 12.97 9.09 12.5 9.36L4.27 14.11C3.79 14.39 3.18 14.23 2.9 13.75C2.62 13.27 2.79 12.66 3.27 12.38L11.5 7.63M7 21L5.79 14.97L13.21 10.69C14 10.26 14.5 9.44 14.5 8.5C14.5 7.12 13.38 6 12 6C11.53 6 11.09 6.13 10.71 6.36L4.76 9.79L4 6H3V4H21V6H20L17 21H7Z";
var mdiPailMinus = "M12.5 9.36L4.27 14.11C3.79 14.39 3.18 14.23 2.9 13.75C2.62 13.27 2.79 12.66 3.27 12.38L11.5 7.63C11.97 7.35 12.58 7.5 12.86 8C13.14 8.47 12.97 9.09 12.5 9.36M13 19C13 15.82 15.47 13.23 18.6 13L20 6H21V4H3V6H4L4.76 9.79L10.71 6.36C11.09 6.13 11.53 6 12 6C13.38 6 14.5 7.12 14.5 8.5C14.5 9.44 14 10.26 13.21 10.69L5.79 14.97L7 21H13.35C13.13 20.37 13 19.7 13 19M15 18V20H23V18H15Z";
var mdiPailMinusOutline = "M4 6H3V4H21V6H20L18.6 13C17.83 13.07 17.11 13.26 16.45 13.58L17.96 6H6.04L6.5 8.22L4.65 9.27L4 6M12.86 8C12.58 7.5 11.97 7.35 11.5 7.63L3.27 12.38C2.79 12.66 2.62 13.27 2.9 13.75C3.18 14.23 3.79 14.39 4.27 14.11L12.5 9.36C12.97 9.09 13.14 8.47 12.86 8M13 19H8.64L7.73 14.43L5.9 15.5L7 21H13.35C13.13 20.37 13 19.7 13 19M15 18V20H23V18H15Z";
var mdiPailOff = "M20.84 22.73L17.35 19.24L17 21H7L5.79 14.97L10.41 12.3L9.31 11.2L4.27 14.11C3.79 14.39 3.18 14.23 2.9 13.75C2.62 13.27 2.79 12.66 3.27 12.38L7.85 9.74L6.75 8.64L4.76 9.79L4 6H3V4.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M10.71 6.36C11.09 6.13 11.53 6 12 6C13.38 6 14.5 7.12 14.5 8.5C14.5 9.27 14.16 9.94 13.6 10.4L18.2 15L20 6H21V4H7.2L10 6.78L10.71 6.36M11.5 7.63L11.08 7.88L12.53 9.33C12.97 9.05 13.13 8.46 12.86 8C12.58 7.5 11.97 7.35 11.5 7.63Z";
var mdiPailOffOutline = "M20.84 22.73L17.35 19.24L17 21H7L5.9 15.5L7.73 14.43L8.64 19H15.36L15.65 17.54L9.31 11.2L4.27 14.11C3.79 14.39 3.18 14.23 2.9 13.75C2.62 13.27 2.79 12.66 3.27 12.38L7.85 9.74L6.38 8.27L4.65 9.27L4 6H3V4.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M17.96 6L16.5 13.3L18.2 15L20 6H21V4H7.2L9.2 6H17.96M11.5 7.63L11.08 7.88L12.53 9.33C12.97 9.05 13.13 8.46 12.86 8C12.58 7.5 11.97 7.35 11.5 7.63Z";
var mdiPailOutline = "M11.5 7.63C11.97 7.35 12.58 7.5 12.86 8C13.14 8.47 12.97 9.09 12.5 9.36L4.27 14.11C3.79 14.39 3.18 14.23 2.9 13.75S2.79 12.66 3.27 12.38L11.5 7.63M3 4V6H4L4.65 9.27L6.5 8.22L6.04 6H17.96L15.36 19H8.64L7.73 14.43L5.9 15.5L7 21H17L20 6H21V4H3Z";
var mdiPailPlus = "M12.5 9.36L4.27 14.11C3.79 14.39 3.18 14.23 2.9 13.75C2.62 13.27 2.79 12.66 3.27 12.38L11.5 7.63C11.97 7.35 12.58 7.5 12.86 8C13.14 8.47 12.97 9.09 12.5 9.36M13 19C13 15.82 15.47 13.23 18.6 13L20 6H21V4H3V6H4L4.76 9.79L10.71 6.36C11.09 6.13 11.53 6 12 6C13.38 6 14.5 7.12 14.5 8.5C14.5 9.44 14 10.26 13.21 10.69L5.79 14.97L7 21H13.35C13.13 20.37 13 19.7 13 19M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiPailPlusOutline = "M4 6H3V4H21V6H20L18.6 13C17.83 13.07 17.11 13.26 16.45 13.58L17.96 6H6.04L6.5 8.22L4.65 9.27L4 6M12.86 8C12.58 7.5 11.97 7.35 11.5 7.63L3.27 12.38C2.79 12.66 2.62 13.27 2.9 13.75C3.18 14.23 3.79 14.39 4.27 14.11L12.5 9.36C12.97 9.09 13.14 8.47 12.86 8M13 19H8.64L7.73 14.43L5.9 15.5L7 21H13.35C13.13 20.37 13 19.7 13 19M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiPailRemove = "M12.5 9.36L4.27 14.11C3.79 14.39 3.18 14.23 2.9 13.75C2.62 13.27 2.79 12.66 3.27 12.38L11.5 7.63C11.97 7.35 12.58 7.5 12.86 8C13.14 8.47 12.97 9.09 12.5 9.36M13 19C13 15.82 15.47 13.23 18.6 13L20 6H21V4H3V6H4L4.76 9.79L10.71 6.36C11.09 6.13 11.53 6 12 6C13.38 6 14.5 7.12 14.5 8.5C14.5 9.44 14 10.26 13.21 10.69L5.79 14.97L7 21H13.35C13.13 20.37 13 19.7 13 19M21.12 15.46L19 17.59L16.88 15.46L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46Z";
var mdiPailRemoveOutline = "M4 6H3V4H21V6H20L18.6 13C17.83 13.07 17.11 13.26 16.45 13.58L17.96 6H6.04L6.5 8.22L4.65 9.27L4 6M12.86 8C12.58 7.5 11.97 7.35 11.5 7.63L3.27 12.38C2.79 12.66 2.62 13.27 2.9 13.75C3.18 14.23 3.79 14.39 4.27 14.11L12.5 9.36C12.97 9.09 13.14 8.47 12.86 8M13 19H8.64L7.73 14.43L5.9 15.5L7 21H13.35C13.13 20.37 13 19.7 13 19M21.12 15.46L19 17.59L16.88 15.46L15.46 16.88L17.58 19L15.46 21.12L16.87 22.54L19 20.41L21.12 22.54L22.53 21.12L20.41 19L22.53 16.88L21.12 15.46Z";
var mdiPalette = "M17.5,12A1.5,1.5 0 0,1 16,10.5A1.5,1.5 0 0,1 17.5,9A1.5,1.5 0 0,1 19,10.5A1.5,1.5 0 0,1 17.5,12M14.5,8A1.5,1.5 0 0,1 13,6.5A1.5,1.5 0 0,1 14.5,5A1.5,1.5 0 0,1 16,6.5A1.5,1.5 0 0,1 14.5,8M9.5,8A1.5,1.5 0 0,1 8,6.5A1.5,1.5 0 0,1 9.5,5A1.5,1.5 0 0,1 11,6.5A1.5,1.5 0 0,1 9.5,8M6.5,12A1.5,1.5 0 0,1 5,10.5A1.5,1.5 0 0,1 6.5,9A1.5,1.5 0 0,1 8,10.5A1.5,1.5 0 0,1 6.5,12M12,3A9,9 0 0,0 3,12A9,9 0 0,0 12,21A1.5,1.5 0 0,0 13.5,19.5C13.5,19.11 13.35,18.76 13.11,18.5C12.88,18.23 12.73,17.88 12.73,17.5A1.5,1.5 0 0,1 14.23,16H16A5,5 0 0,0 21,11C21,6.58 16.97,3 12,3Z";
var mdiPaletteAdvanced = "M22,22H10V20H22V22M2,22V20H9V22H2M18,18V10H22V18H18M18,3H22V9H18V3M2,18V3H16V18H2M9,14.56A3,3 0 0,0 12,11.56C12,9.56 9,6.19 9,6.19C9,6.19 6,9.56 6,11.56A3,3 0 0,0 9,14.56Z";
var mdiPaletteOutline = "M12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2C17.5,2 22,6 22,11A6,6 0 0,1 16,17H14.2C13.9,17 13.7,17.2 13.7,17.5C13.7,17.6 13.8,17.7 13.8,17.8C14.2,18.3 14.4,18.9 14.4,19.5C14.5,20.9 13.4,22 12,22M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C12.3,20 12.5,19.8 12.5,19.5C12.5,19.3 12.4,19.2 12.4,19.1C12,18.6 11.8,18.1 11.8,17.5C11.8,16.1 12.9,15 14.3,15H16A4,4 0 0,0 20,11C20,7.1 16.4,4 12,4M6.5,10C7.3,10 8,10.7 8,11.5C8,12.3 7.3,13 6.5,13C5.7,13 5,12.3 5,11.5C5,10.7 5.7,10 6.5,10M9.5,6C10.3,6 11,6.7 11,7.5C11,8.3 10.3,9 9.5,9C8.7,9 8,8.3 8,7.5C8,6.7 8.7,6 9.5,6M14.5,6C15.3,6 16,6.7 16,7.5C16,8.3 15.3,9 14.5,9C13.7,9 13,8.3 13,7.5C13,6.7 13.7,6 14.5,6M17.5,10C18.3,10 19,10.7 19,11.5C19,12.3 18.3,13 17.5,13C16.7,13 16,12.3 16,11.5C16,10.7 16.7,10 17.5,10Z";
var mdiPaletteSwatch = "M2.53,19.65L3.87,20.21V11.18L1.44,17.04C1.03,18.06 1.5,19.23 2.53,19.65M22.03,15.95L17.07,4C16.76,3.23 16.03,2.77 15.26,2.75C15,2.75 14.73,2.79 14.47,2.9L7.1,5.95C6.35,6.26 5.89,7 5.87,7.75C5.86,8 5.91,8.29 6,8.55L11,20.5C11.29,21.28 12.03,21.74 12.81,21.75C13.07,21.75 13.33,21.7 13.58,21.6L20.94,18.55C21.96,18.13 22.45,16.96 22.03,15.95M7.88,8.75A1,1 0 0,1 6.88,7.75A1,1 0 0,1 7.88,6.75C8.43,6.75 8.88,7.2 8.88,7.75C8.88,8.3 8.43,8.75 7.88,8.75M5.88,19.75A2,2 0 0,0 7.88,21.75H9.33L5.88,13.41V19.75Z";
var mdiPaletteSwatchOutline = "M2.5 19.6L3.8 20.2V11.2L1.4 17C1 18.1 1.5 19.2 2.5 19.6M15.2 4.8L20.2 16.8L12.9 19.8L7.9 7.9V7.8L15.2 4.8M15.3 2.8C15 2.8 14.8 2.8 14.5 2.9L7.1 6C6.4 6.3 5.9 7 5.9 7.8C5.9 8 5.9 8.3 6 8.6L11 20.5C11.3 21.3 12 21.7 12.8 21.7C13.1 21.7 13.3 21.7 13.6 21.6L21 18.5C22 18.1 22.5 16.9 22.1 15.9L17.1 4C16.8 3.2 16 2.8 15.3 2.8M10.5 9.9C9.9 9.9 9.5 9.5 9.5 8.9S9.9 7.9 10.5 7.9C11.1 7.9 11.5 8.4 11.5 8.9S11.1 9.9 10.5 9.9M5.9 19.8C5.9 20.9 6.8 21.8 7.9 21.8H9.3L5.9 13.5V19.8Z";
var mdiPaletteSwatchVariant = "M20 14H6C3.8 14 2 15.8 2 18S3.8 22 6 22H20C21.1 22 22 21.1 22 20V16C22 14.9 21.1 14 20 14M6 20C4.9 20 4 19.1 4 18S4.9 16 6 16 8 16.9 8 18 7.1 20 6 20M6.3 12L13 5.3C13.8 4.5 15 4.5 15.8 5.3L18.6 8.1C19.4 8.9 19.4 10.1 18.6 10.9L17.7 12H6.3M2 13.5V4C2 2.9 2.9 2 4 2H8C9.1 2 10 2.9 10 4V5.5L2 13.5Z";
var mdiPalmTree = "M12 9C13.59 16.61 10 22 10 22H13C14.88 16.2 14 12.09 13.5 10M15.66 7.16C15.83 7.37 16 7.59 16.13 7.82C17.84 10.53 17.5 13.95 15.5 16.26C16.34 14.21 16.22 11.79 14.95 9.77C14.87 9.64 14.78 9.53 14.7 9.41C14.11 8.58 13.36 7.92 12.54 7.43C9.66 8.35 7.58 11.04 7.58 14.22C7.58 14.96 7.69 15.67 7.89 16.33C7.05 15.16 6.56 13.73 6.56 12.19C6.56 9.84 7.7 7.76 9.45 6.46C8 6.35 6.46 6.67 5.12 7.5C4.5 7.91 3.96 8.38 3.5 8.91C4.05 7.58 5 6.39 6.3 5.57C7.8 4.63 9.5 4.32 11.14 4.56C10.73 4 10.23 3.47 9.63 3C9.05 2.58 8.42 2.24 7.76 2C9.2 2.04 10.64 2.5 11.87 3.43C12.5 3.9 13 4.47 13.4 5.07C13.5 5.07 13.59 5.06 13.69 5.06C16.89 5.06 19.6 7.17 20.5 10.08C19.38 8.5 17.65 7.43 15.66 7.16Z";
var mdiPan = "M12,2.5L8,7H16L12,2.5M7,8L2.5,12L7,16V8M17,8V16L21.5,12L17,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M8,17L12,21.5L16,17H8Z";
var mdiPanBottomLeft = "M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M5.35,13L11,18.65L5,19L5.35,13Z";
var mdiPanBottomRight = "M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M13,18.65L18.65,13L19,19L13,18.65Z";
var mdiPanDown = "M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M8,17L12,21.5L16,17H8Z";
var mdiPanHorizontal = "M7,8L2.5,12L7,16V8M17,8V16L21.5,12L17,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z";
var mdiPanLeft = "M7,8L2.5,12L7,16V8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z";
var mdiPanRight = "M17,8V16L21.5,12L17,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z";
var mdiPanTopLeft = "M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M11,5.35L5.35,11L5,5L11,5.35Z";
var mdiPanTopRight = "M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M18.65,11L13,5.35L19,5L18.65,11Z";
var mdiPanUp = "M12,2.5L8,7H16L12,2.5M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z";
var mdiPanVertical = "M12,2.5L8,7H16L12,2.5M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M8,17L12,21.5L16,17H8Z";
var mdiPanda = "M12,3C13.74,3 15.36,3.5 16.74,4.35C17.38,3.53 18.38,3 19.5,3A3.5,3.5 0 0,1 23,6.5C23,8 22.05,9.28 20.72,9.78C20.9,10.5 21,11.23 21,12A9,9 0 0,1 12,21A9,9 0 0,1 3,12C3,11.23 3.1,10.5 3.28,9.78C1.95,9.28 1,8 1,6.5A3.5,3.5 0 0,1 4.5,3C5.62,3 6.62,3.53 7.26,4.35C8.64,3.5 10.26,3 12,3M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5M16.19,10.3C16.55,11.63 16.08,12.91 15.15,13.16C14.21,13.42 13.17,12.54 12.81,11.2C12.45,9.87 12.92,8.59 13.85,8.34C14.79,8.09 15.83,8.96 16.19,10.3M7.81,10.3C8.17,8.96 9.21,8.09 10.15,8.34C11.08,8.59 11.55,9.87 11.19,11.2C10.83,12.54 9.79,13.42 8.85,13.16C7.92,12.91 7.45,11.63 7.81,10.3M12,14C12.6,14 13.13,14.19 13.5,14.5L12.5,15.5C12.5,15.92 12.84,16.25 13.25,16.25A0.75,0.75 0 0,0 14,15.5A0.5,0.5 0 0,1 14.5,15A0.5,0.5 0 0,1 15,15.5A1.75,1.75 0 0,1 13.25,17.25C12.76,17.25 12.32,17.05 12,16.72C11.68,17.05 11.24,17.25 10.75,17.25A1.75,1.75 0 0,1 9,15.5A0.5,0.5 0 0,1 9.5,15A0.5,0.5 0 0,1 10,15.5A0.75,0.75 0 0,0 10.75,16.25A0.75,0.75 0 0,0 11.5,15.5L10.5,14.5C10.87,14.19 11.4,14 12,14Z";
var mdiPandora = "M10,20A1,1 0 0,1 9,21H4V3H13.71A6.75,6.75 0 0,1 20.46,9.75C20.46,13.5 17.44,16.5 13.71,16.5H10V20Z";
var mdiPanorama = "M8.5,12.5L11,15.5L14.5,11L19,17H5M23,18V6A2,2 0 0,0 21,4H3A2,2 0 0,0 1,6V18A2,2 0 0,0 3,20H21A2,2 0 0,0 23,18Z";
var mdiPanoramaFisheye = "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2Z";
var mdiPanoramaHorizontal = "M12 5.5C8.1 5.5 5.1 4.7 3.3 4.1C2.7 3.8 2 4.3 2 5V19C2 19.7 2.7 20.2 3.3 20C5.4 19.3 8.1 18.5 12 18.5C15.9 18.5 18.7 19.3 20.7 20C21.4 20.2 22 19.7 22 19V5C22 4.3 21.3 3.8 20.7 4.1C18.7 4.7 15.9 5.5 12 5.5Z";
var mdiPanoramaHorizontalOutline = "M21.43,4C21.33,4 21.23,4 21.12,4.06C18.18,5.16 15.09,5.7 12,5.7C8.91,5.7 5.82,5.15 2.88,4.06C2.77,4 2.66,4 2.57,4C2.23,4 2,4.23 2,4.63V19.38C2,19.77 2.23,20 2.57,20C2.67,20 2.77,20 2.88,19.94C5.82,18.84 8.91,18.3 12,18.3C15.09,18.3 18.18,18.85 21.12,19.94C21.23,20 21.33,20 21.43,20C21.76,20 22,19.77 22,19.37V4.63C22,4.23 21.76,4 21.43,4M20,6.54V17.45C17.4,16.68 14.72,16.29 12,16.29C9.28,16.29 6.6,16.68 4,17.45V6.54C6.6,7.31 9.28,7.7 12,7.7C14.72,7.71 17.4,7.32 20,6.54Z";
var mdiPanoramaOutline = "M21 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H21C22.1 20 23 19.1 23 18V6C23 4.9 22.1 4 21 4M21 18H3V6H21V18M14.5 11L11 15.5L8.5 12.5L5 17H19L14.5 11Z";
var mdiPanoramaSphere = "M22 8.1C21.7 8 21.3 7.8 21 7.7C19.4 4.3 16 2 12 2S4.6 4.3 3 7.7C2.7 7.8 2.3 8 2.1 8.1C1.4 8.5 1 9.2 1 9.9V14.1C1 14.8 1.4 15.5 2 15.9C2.3 16 2.7 16.2 3 16.3C4.6 19.7 8 22 12 22S19.4 19.7 21 16.3C21.3 16.2 21.6 16 21.9 15.8C22.5 15.4 23 14.8 23 14V9.9C23 9.2 22.6 8.5 22 8.1M12 4C14.4 4 16.5 5 18 6.7C16.2 6.2 14.1 6 12 6S7.8 6.2 6.1 6.7C7.5 5 9.6 4 12 4M12 20C9.6 20 7.5 19 6.1 17.3C7.8 17.8 9.9 18 12 18S16.2 17.8 18 17.3C16.5 19 14.4 20 12 20Z";
var mdiPanoramaSphereOutline = "M22 8.1C21.7 8 21.3 7.8 21 7.7C19.4 4.3 16 2 12 2S4.6 4.3 3 7.7C2.7 7.8 2.3 8 2.1 8.1C1.4 8.5 1 9.2 1 9.9V14.1C1 14.8 1.4 15.5 2 15.9C2.3 16 2.7 16.2 3 16.3C4.6 19.7 8 22 12 22S19.4 19.7 21 16.3C21.3 16.2 21.6 16 21.9 15.8C22.5 15.4 23 14.8 23 14V9.9C23 9.2 22.6 8.5 22 8.1M21 9.9V14.1C18.8 15.3 15.5 16 12 16S5.2 15.3 3 14.1V9.9C5.2 8.7 8.5 8 12 8S18.8 8.7 21 9.9M12 4C14.4 4 16.5 5 18 6.7C16.2 6.2 14.1 6 12 6S7.8 6.2 6.1 6.7C7.5 5 9.6 4 12 4M12 20C9.6 20 7.5 19 6.1 17.3C7.8 17.8 9.9 18 12 18S16.2 17.8 18 17.3C16.5 19 14.4 20 12 20Z";
var mdiPanoramaVariant = "M20.7 4.1C18.7 4.8 15.9 5.5 12 5.5C8.1 5.5 5.1 4.7 3.3 4.1C2.7 3.8 2 4.3 2 5V19C2 19.7 2.7 20.2 3.3 20C5.4 19.3 8.1 18.5 12 18.5C15.9 18.5 18.7 19.3 20.7 20C21.4 20.2 22 19.7 22 19V5C22 4.3 21.3 3.8 20.7 4.1M12 15C9.7 15 7.5 15.1 5.5 15.4L9.2 11L11.2 13.4L14 10L18.5 15.4C16.5 15.1 14.3 15 12 15Z";
var mdiPanoramaVariantOutline = "M21 4C20.4 4 17.4 5.5 12 5.5C6.7 5.5 3.5 4 3 4C2.5 4 2 4.4 2 5V19C2 19.6 2.5 20 3 20C3.6 20 6.5 18.5 12 18.5C17.4 18.5 20.4 20 21 20C21.5 20 22 19.6 22 19V5C22 4.4 21.5 4 21 4M20 17.6C18 17 15.4 16.5 12 16.5C8.6 16.5 6 17 4 17.6V6.4C6.6 7.1 9.3 7.5 12 7.5C15.4 7.5 18 7 20 6.4V17.6M9.2 11L5.5 15.4C7.5 15.1 9.7 15 12 15C14.3 15 16.5 15.1 18.5 15.4L14 10L11.2 13.4L9.2 11Z";
var mdiPanoramaVertical = "M18.5 12C18.5 8.1 19.3 5.1 19.9 3.3C20.1 2.7 19.7 2 19 2H5C4.3 2 3.8 2.7 4.1 3.3C4.7 5.4 5.5 8.1 5.5 12C5.5 15.9 4.7 18.7 4.1 20.7C3.8 21.3 4.3 22 5 22H19C19.7 22 20.2 21.3 20 20.7C19.3 18.7 18.5 15.9 18.5 12Z";
var mdiPanoramaVerticalOutline = "M6.54,20C7.31,17.4 7.7,14.72 7.7,12C7.7,9.28 7.31,6.6 6.54,4H17.45C16.68,6.6 16.29,9.28 16.29,12C16.29,14.72 16.68,17.4 17.45,20M19.94,21.12C18.84,18.18 18.3,15.09 18.3,12C18.3,8.91 18.85,5.82 19.94,2.88C20,2.77 20,2.66 20,2.57C20,2.23 19.77,2 19.37,2H4.63C4.23,2 4,2.23 4,2.57C4,2.67 4,2.77 4.06,2.88C5.16,5.82 5.71,8.91 5.71,12C5.71,15.09 5.16,18.18 4.07,21.12C4,21.23 4,21.34 4,21.43C4,21.76 4.23,22 4.63,22H19.38C19.77,22 20,21.76 20,21.43C20,21.33 20,21.23 19.94,21.12Z";
var mdiPanoramaWideAngle = "M12 4C8 4 5.2 4.6 3 5C2.5 7 2 8.9 2 12C2 15 2.5 17 3 19C5.2 19.4 8 20 12 20C16 20 18.9 19.4 21 19C21.6 17 22 15 22 12C22 9 21.5 6.9 21 5C18.9 4.6 16 4 12 4Z";
var mdiPanoramaWideAngleOutline = "M12,4C9.27,4 6.78,4.24 4.05,4.72L3.12,4.88L2.87,5.78C2.29,7.85 2,9.93 2,12C2,14.07 2.29,16.15 2.87,18.22L3.12,19.11L4.05,19.27C6.78,19.76 9.27,20 12,20C14.73,20 17.22,19.76 19.95,19.28L20.88,19.12L21.13,18.23C21.71,16.15 22,14.07 22,12C22,9.93 21.71,7.85 21.13,5.78L20.88,4.89L19.95,4.73C17.22,4.24 14.73,4 12,4M12,6C14.45,6 16.71,6.2 19.29,6.64C19.76,8.42 20,10.22 20,12C20,13.78 19.76,15.58 19.29,17.36C16.71,17.8 14.45,18 12,18C9.55,18 7.29,17.8 4.71,17.36C4.24,15.58 4,13.78 4,12C4,10.22 4.24,8.42 4.71,6.64C7.29,6.2 9.55,6 12,6Z";
var mdiPaperCutVertical = "M11.43,3.23L12,4L12.57,3.23V3.24C13.12,2.5 14,2 15,2A3,3 0 0,1 18,5C18,5.35 17.94,5.69 17.83,6H20A2,2 0 0,1 22,8V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V8A2,2 0 0,1 4,6H6.17C6.06,5.69 6,5.35 6,5A3,3 0 0,1 9,2C10,2 10.88,2.5 11.43,3.24V3.23M4,8V20H11A1,1 0 0,1 12,19A1,1 0 0,1 13,20H20V8H15L14.9,8L17,10.92L15.4,12.1L12.42,8H11.58L8.6,12.1L7,10.92L9.1,8H9L4,8M9,4A1,1 0 0,0 8,5A1,1 0 0,0 9,6A1,1 0 0,0 10,5A1,1 0 0,0 9,4M15,4A1,1 0 0,0 14,5A1,1 0 0,0 15,6A1,1 0 0,0 16,5A1,1 0 0,0 15,4M12,16A1,1 0 0,1 13,17A1,1 0 0,1 12,18A1,1 0 0,1 11,17A1,1 0 0,1 12,16M12,13A1,1 0 0,1 13,14A1,1 0 0,1 12,15A1,1 0 0,1 11,14A1,1 0 0,1 12,13M12,10A1,1 0 0,1 13,11A1,1 0 0,1 12,12A1,1 0 0,1 11,11A1,1 0 0,1 12,10Z";
var mdiPaperRoll = "M9 3C5.69 3 3.14 5.69 3 9V21H12V13.46C13.1 14.45 14.5 15 16 15C19.31 15 22 12.31 22 9C22 5.69 19.31 3 16 3H9M16 5C18.21 5 20 6.79 20 9C20 11.21 18.21 13 16 13C13.79 13 12 11.21 12 9C12 6.79 13.79 5 16 5M16 7.25C15.03 7.25 14.25 8.03 14.25 9C14.25 9.97 15.03 10.75 16 10.75C16.97 10.75 17.75 9.97 17.75 9C17.75 8.03 16.97 7.25 16 7.25M4 12H5V13H4V12M6 12H7V13H6V12M8 12H9V13H8V12M10 12H11V13H10V12Z";
var mdiPaperRollOutline = "M9 3C5.69 3 3.14 5.69 3 9V21H12V13.46C13.1 14.45 14.5 15 16 15C19.31 15 22 12.31 22 9C22 5.69 19.31 3 16 3H9M9 5H11.54C10.55 6.1 10 7.5 10 9V12H9V13H10V19H5V13H6V12H5V9C5 6.79 6.79 5 9 5M16 5C18.21 5 20 6.79 20 9C20 11.21 18.21 13 16 13C13.79 13 12 11.21 12 9C12 6.79 13.79 5 16 5M16 7.25C15.03 7.25 14.25 8.03 14.25 9C14.25 9.97 15.03 10.75 16 10.75C16.97 10.75 17.75 9.97 17.75 9C17.75 8.03 16.97 7.25 16 7.25M7 12V13H8V12H7Z";
var mdiPaperclip = "M16.5,6V17.5A4,4 0 0,1 12.5,21.5A4,4 0 0,1 8.5,17.5V5A2.5,2.5 0 0,1 11,2.5A2.5,2.5 0 0,1 13.5,5V15.5A1,1 0 0,1 12.5,16.5A1,1 0 0,1 11.5,15.5V6H10V15.5A2.5,2.5 0 0,0 12.5,18A2.5,2.5 0 0,0 15,15.5V5A4,4 0 0,0 11,1A4,4 0 0,0 7,5V17.5A5.5,5.5 0 0,0 12.5,23A5.5,5.5 0 0,0 18,17.5V6H16.5Z";
var mdiPaperclipCheck = "M13.5 21.36C13.7 21.84 13.97 22.29 14.29 22.7C13.73 22.89 13.13 23 12.5 23C9.46 23 7 20.54 7 17.5V5C7 2.79 8.79 1 11 1S15 2.79 15 5V14.54C14.03 15.41 13.35 16.58 13.1 17.92C12.91 17.97 12.71 18 12.5 18C11.12 18 10 16.88 10 15.5V6H11.5V15.5C11.5 16.05 11.95 16.5 12.5 16.5S13.5 16.05 13.5 15.5V5C13.5 3.62 12.38 2.5 11 2.5S8.5 3.62 8.5 5V17.5C8.5 19.71 10.29 21.5 12.5 21.5C12.84 21.5 13.17 21.44 13.5 21.36M18 6H16.5V13.55C16.97 13.34 17.47 13.18 18 13.09V6M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiPaperclipLock = "M18 13C16.6 13 15.2 14.1 15.2 15.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17V15.5C20.8 14.1 19.4 13 18 13M18 14.2C18.8 14.2 19.5 14.7 19.5 15.5V17H16.5V15.5C16.5 14.7 17.2 14.2 18 14.2M8.9 2C6.8 2 5 3.8 5 6V16.5C5 19.5 7.5 22 10.5 22C11 22 11.5 21.9 12 21.8V20.2C11.5 20.4 11 20.5 10.5 20.5C8.3 20.5 6.5 18.7 6.5 16.5V6C6.5 4.6 7.6 3.5 9 3.5S11.5 4.6 11.5 6V14.5C11.5 15.1 11.1 15.5 10.5 15.5S9.5 15.1 9.5 14.5V7H8V14.5C8 15.9 9.1 17 10.5 17S13 15.9 13 14.5V6C13 3.8 11.2 2 8.9 2C9 2 9 2 8.9 2M14.5 7V12.4C14.9 12 15.4 11.6 16 11.4V7H14.5Z";
var mdiPaperclipMinus = "M18 13.09C17.47 13.18 16.97 13.34 16.5 13.55V6H18V13.09M12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5S13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5S11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C12.71 18 12.91 17.97 13.1 17.92C13.35 16.58 14.03 15.41 15 14.54V5C15 2.79 13.21 1 11 1S7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C13.13 23 13.73 22.89 14.29 22.7C13.97 22.29 13.7 21.84 13.5 21.36C13.17 21.44 12.84 21.5 12.5 21.5M15 18V20H23V18H15Z";
var mdiPaperclipOff = "M8.5 5.3L7.16 3.96C7.62 2.26 9.15 1 11 1C13.21 1 15 2.79 15 5V11.8L13.5 10.3V5C13.5 3.62 12.38 2.5 11 2.5S8.5 3.62 8.5 5V5.3M18 6H16.5V13.3L18 14.8V6M22.11 21.46L20.84 22.73L17.62 19.5C16.81 21.55 14.83 23 12.5 23C9.46 23 7 20.54 7 17.5V8.89L1.11 3L2.39 1.73L22.11 21.46M11.5 15.5C11.5 16.05 11.95 16.5 12.5 16.5S13.5 16.05 13.5 15.5V15.39L11.5 13.39V15.5M16.42 18.31L14.73 16.62C14.32 17.43 13.5 18 12.5 18C11.12 18 10 16.88 10 15.5V11.89L8.5 10.39V17.5C8.5 19.71 10.29 21.5 12.5 21.5C14.43 21.5 16.04 20.13 16.42 18.31M10 6.8L11.5 8.3V6H10V6.8Z";
var mdiPaperclipPlus = "M18 13.09C17.47 13.18 16.97 13.34 16.5 13.55V6H18V13.09M12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5S13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5S11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C12.71 18 12.91 17.97 13.1 17.92C13.35 16.58 14.03 15.41 15 14.54V5C15 2.79 13.21 1 11 1S7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C13.13 23 13.73 22.89 14.29 22.7C13.97 22.29 13.7 21.84 13.5 21.36C13.17 21.44 12.84 21.5 12.5 21.5M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiPaperclipRemove = "M18 13.09C17.47 13.18 16.97 13.34 16.5 13.55V6H18V13.09M11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C13.13 23 13.73 22.89 14.29 22.7C13.97 22.29 13.7 21.84 13.5 21.36C13.17 21.44 12.84 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5S13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5S11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C12.71 18 12.91 17.97 13.1 17.92C13.35 16.58 14.03 15.41 15 14.54V5C15 2.79 13.21 1 11 1M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiParachute = "M21.2,10.95L12,23L2.78,10.96L2.87,10.88C3.08,10.67 3.33,10.5 3.58,10.36L10.73,19.69L8.58,13L9.24,11.81L12,20.38L14.73,11.8L15.4,13L13.27,19.69L20.41,10.35C20.66,10.5 20.9,10.64 21.1,10.85L21.2,10.95M5,9C6.5,9 7.81,9.86 8.5,11.1C9.17,9.86 10.47,9 12,9C13.5,9 14.8,9.85 15.5,11.09C16.16,9.84 17.47,9 19,9C20.09,9 21.09,9.42 21.81,10.14C20.94,5.5 16.88,2 12,2C7.09,2 3.03,5.5 2.16,10.17C2.89,9.45 3.89,9 5,9Z";
var mdiParachuteOutline = "M21.2,10.95L12,23L2.78,10.96L2.87,10.88C3.08,10.67 3.33,10.5 3.58,10.36L10.73,19.69L8.58,13L9.24,11.81L12,20.38L14.73,11.8L15.4,13L13.27,19.69L20.41,10.35C20.66,10.5 20.9,10.64 21.1,10.85L21.2,10.95M12,4C14.5,4 16.77,5.17 18.25,7.03C17.24,7.15 16.28,7.54 15.47,8.13C14.47,7.41 13.26,7 12,7C10.71,7 9.5,7.41 8.5,8.14C7.68,7.55 6.72,7.17 5.71,7.04C7.19,5.17 9.47,4 12,4M12,2C7.09,2 3.03,5.5 2.16,10.17C2.89,9.45 3.89,9 5,9C6.5,9 7.81,9.86 8.5,11.1C9.17,9.86 10.47,9 12,9C13.5,9 14.8,9.85 15.5,11.09C16.16,9.84 17.47,9 19,9C20.09,9 21.09,9.42 21.81,10.14C20.94,5.5 16.88,2 12,2Z";
var mdiParagliding = "M12 17C10.9 17 10 16.11 10 15S10.9 13 12 13 14 13.9 14 15 13.11 17 12 17M19 14H17C17 16.76 14.76 19 12 19S7 16.76 7 14H5C5 16.79 6.64 19.19 9 20.32V23H15V20.32C17.36 19.19 19 16.79 19 14M23 7.76C23.04 8.56 22.05 9.06 21.41 8.6C21.27 8.46 21.16 8.44 21 8.32L18.97 13H17L15.5 6.73C13.21 6.5 10.79 6.5 8.5 6.73L7 13H5.03L3 8.32C2.84 8.44 2.73 8.46 2.59 8.6C1.95 9.06 .959 8.56 1 7.76V4C1 4 1 1 12 1S23 4 23 4M6.9 7C6 7.2 5.15 7.43 4.37 7.71L5.87 11.27L6.9 7M19.63 7.71C18.85 7.43 18 7.2 17.1 7L18.13 11.27L19.63 7.71Z";
var mdiParking = "M13.2,11H10V7H13.2A2,2 0 0,1 15.2,9A2,2 0 0,1 13.2,11M13,3H6V21H10V15H13A6,6 0 0,0 19,9C19,5.68 16.31,3 13,3Z";
var mdiPartyPopper = "M14.53 1.45L13.45 2.53L15.05 4.13C15.27 4.38 15.38 4.67 15.38 5S15.27 5.64 15.05 5.86L11.5 9.47L12.5 10.55L16.13 6.94C16.66 6.35 16.92 5.7 16.92 5C16.92 4.3 16.66 3.64 16.13 3.05L14.53 1.45M10.55 3.47L9.47 4.55L10.08 5.11C10.3 5.33 10.41 5.63 10.41 6S10.3 6.67 10.08 6.89L9.47 7.45L10.55 8.53L11.11 7.92C11.64 7.33 11.91 6.69 11.91 6C11.91 5.28 11.64 4.63 11.11 4.03L10.55 3.47M21 5.06C20.31 5.06 19.67 5.33 19.08 5.86L13.45 11.5L14.53 12.5L20.11 6.94C20.36 6.69 20.66 6.56 21 6.56S21.64 6.69 21.89 6.94L22.5 7.55L23.53 6.47L22.97 5.86C22.38 5.33 21.72 5.06 21 5.06M7 8L2 22L16 17L7 8M19 11.06C18.3 11.06 17.66 11.33 17.06 11.86L15.47 13.45L16.55 14.53L18.14 12.94C18.39 12.69 18.67 12.56 19 12.56C19.33 12.56 19.63 12.69 19.88 12.94L21.5 14.53L22.55 13.5L20.95 11.86C20.36 11.33 19.7 11.06 19 11.06Z";
var mdiPassport = "M6,2A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V4A2,2 0 0,0 18,2H6M12,5A5,5 0 0,1 17,10A5,5 0 0,1 12,15A5,5 0 0,1 7,10A5,5 0 0,1 12,5M12,6C11.59,6.62 11.25,7.29 11.04,8H12.96C12.75,7.29 12.42,6.62 12,6M10.7,6.22C9.78,6.53 9,7.17 8.54,8H10C10.18,7.38 10.4,6.78 10.7,6.22M13.29,6.22C13.59,6.78 13.82,7.38 14,8H15.46C15,7.17 14.21,6.54 13.29,6.22M8.13,9C8.05,9.32 8,9.65 8,10C8,10.35 8.05,10.68 8.13,11H9.82C9.78,10.67 9.75,10.34 9.75,10C9.75,9.66 9.78,9.33 9.82,9H8.13M10.83,9C10.78,9.32 10.75,9.66 10.75,10C10.75,10.34 10.78,10.67 10.83,11H13.17C13.21,10.67 13.25,10.34 13.25,10C13.25,9.66 13.21,9.32 13.17,9H10.83M14.18,9C14.22,9.33 14.25,9.66 14.25,10C14.25,10.34 14.22,10.67 14.18,11H15.87C15.95,10.68 16,10.35 16,10C16,9.65 15.95,9.32 15.87,9H14.18M8.54,12C9,12.83 9.78,13.46 10.7,13.78C10.4,13.22 10.18,12.63 10,12H8.54M11.04,12C11.25,12.72 11.59,13.38 12,14C12.42,13.38 12.75,12.72 12.96,12H11.04M14,12C13.82,12.63 13.59,13.22 13.29,13.78C14.21,13.46 15,12.83 15.46,12H14M7,17H17V19H7V17Z";
var mdiPassportAlert = "M10 6C9.59 6.62 9.25 7.29 9.04 8H10.96C10.75 7.29 10.42 6.62 10 6M8.7 6.22C7.78 6.53 7 7.17 6.54 8H8C8.18 7.38 8.4 6.78 8.7 6.22M11.29 6.22C11.59 6.78 11.82 7.38 12 8H13.46C13 7.17 12.21 6.54 11.29 6.22M6.13 9C6.05 9.32 6 9.65 6 10C6 10.35 6.05 10.68 6.13 11H7.82C7.78 10.67 7.75 10.34 7.75 10C7.75 9.66 7.78 9.33 7.82 9H6.13M8.83 9C8.78 9.32 8.75 9.66 8.75 10C8.75 10.34 8.78 10.67 8.83 11H11.17C11.21 10.67 11.25 10.34 11.25 10C11.25 9.66 11.21 9.32 11.17 9H8.83M12.18 9C12.22 9.33 12.25 9.66 12.25 10C12.25 10.34 12.22 10.67 12.18 11H13.87C13.95 10.68 14 10.35 14 10C14 9.65 13.95 9.32 13.87 9H12.18M6.54 12C7 12.83 7.78 13.46 8.7 13.78C8.4 13.22 8.18 12.63 8 12H6.54M9.04 12C9.25 12.72 9.59 13.38 10 14C10.42 13.38 10.75 12.72 10.96 12H9.04M12 12C11.82 12.63 11.59 13.22 11.29 13.78C12.21 13.46 13 12.83 13.46 12H12M4 2C3.47 2 2.96 2.21 2.59 2.59C2.21 2.96 2 3.47 2 4V20C2 20.53 2.21 21.04 2.59 21.41C2.96 21.79 3.47 22 4 22H16C16.53 22 17.04 21.79 17.41 21.41C17.79 21.04 18 20.53 18 20V4C18 3.47 17.79 2.96 17.41 2.59C17.04 2.21 16.53 2 16 2H4M10 5C11.33 5 12.6 5.53 13.54 6.46C14.47 7.4 15 8.67 15 10C15 11.33 14.47 12.6 13.54 13.54C12.6 14.47 11.33 15 10 15C8.67 15 7.4 14.47 6.46 13.54C5.53 12.6 5 11.33 5 10C5 8.67 5.53 7.4 6.46 6.46C7.4 5.53 8.67 5 10 5M15 17V19H5V17H15M20 7H22V13H20V7M22 15H20V17H22V15Z";
var mdiPassportBiometric = "M4,4A2,2 0 0,0 2,6V11H8.13C8.59,9.24 10.18,8 12,8C13.82,8 15.41,9.24 15.87,11H22V6A2,2 0 0,0 20,4H4M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M2,13V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V13H15.87C15.41,14.76 13.82,16 12,16C10.18,16 8.59,14.76 8.13,13H2Z";
var mdiPassportCancel = "M6 2C5.47 2 4.96 2.21 4.59 2.59C4.21 2.96 4 3.47 4 4V20C4 20.53 4.21 21.04 4.59 21.41C4.96 21.79 5.47 22 6 22H13C12.46 21.12 12.1 20.1 12 19H7V17H12.17C12.36 16.23 12.67 15.5 13.1 14.88C12.74 14.96 12.37 15 12 15C10.67 15 9.4 14.47 8.46 13.54C7.53 12.6 7 11.33 7 10C7 8.67 7.53 7.4 8.46 6.46C9.4 5.53 10.67 5 12 5C13.33 5 14.6 5.53 15.54 6.46C16.47 7.4 17 8.67 17 10C17 10.82 16.8 11.63 16.42 12.34C17.07 12.12 17.77 12 18.5 12C19 12 19.5 12.06 20 12.17V4C20 3.47 19.79 2.96 19.41 2.59C19.04 2.21 18.53 2 18 2H6M12 6C11.59 6.62 11.25 7.29 11.04 8H12.96C12.75 7.29 12.42 6.62 12 6M10.7 6.22C9.78 6.53 9 7.17 8.54 8H10C10.18 7.38 10.4 6.78 10.7 6.22M13.29 6.22C13.59 6.78 13.82 7.38 14 8H15.46C15 7.17 14.21 6.54 13.29 6.22M8.13 9C8.05 9.32 8 9.65 8 10C8 10.35 8.05 10.68 8.13 11H9.82C9.78 10.67 9.75 10.34 9.75 10C9.75 9.66 9.78 9.33 9.82 9H8.13M10.83 9C10.78 9.32 10.75 9.66 10.75 10C10.75 10.34 10.78 10.67 10.83 11H13.17C13.21 10.67 13.25 10.34 13.25 10C13.25 9.66 13.21 9.32 13.17 9H10.83M14.18 9C14.22 9.33 14.25 9.66 14.25 10C14.25 10.34 14.22 10.67 14.18 11H15.87C15.95 10.68 16 10.35 16 10C16 9.65 15.95 9.32 15.87 9H14.18M8.54 12C9 12.83 9.78 13.46 10.7 13.78C10.4 13.22 10.18 12.63 10 12H8.54M11.04 12C11.25 12.72 11.59 13.38 12 14C12.42 13.38 12.75 12.72 12.96 12H11.04M14 12C13.82 12.63 13.59 13.22 13.29 13.78C14.21 13.46 15 12.83 15.46 12H14M18.5 23C21 23 23 21 23 18.5C23 16 21 14 18.5 14C16 14 14 16 14 18.5C14 21 16 23 18.5 23M15.92 17L20 21.09C19.58 21.35 19.06 21.5 18.5 21.5C16.84 21.5 15.5 20.16 15.5 18.5C15.5 17.94 15.65 17.42 15.92 17M21.5 18.5C21.5 19.06 21.35 19.58 21.09 20L17 15.92C17.42 15.65 17.94 15.5 18.5 15.5C20.16 15.5 21.5 16.84 21.5 18.5Z";
var mdiPassportCheck = "M12 6C11.59 6.62 11.25 7.29 11.04 8H12.96C12.75 7.29 12.42 6.62 12 6M10.7 6.22C9.78 6.53 9 7.17 8.54 8H10C10.18 7.38 10.4 6.78 10.7 6.22M13.29 6.22C13.59 6.78 13.82 7.38 14 8H15.46C15 7.17 14.21 6.54 13.29 6.22M8.13 9C8.05 9.32 8 9.65 8 10C8 10.35 8.05 10.68 8.13 11H9.82C9.78 10.67 9.75 10.34 9.75 10C9.75 9.66 9.78 9.33 9.82 9H8.13M10.83 9C10.78 9.32 10.75 9.66 10.75 10C10.75 10.34 10.78 10.67 10.83 11H13.17C13.21 10.67 13.25 10.34 13.25 10C13.25 9.66 13.21 9.32 13.17 9H10.83M14.18 9C14.22 9.33 14.25 9.66 14.25 10C14.25 10.34 14.22 10.67 14.18 11H15.87C15.95 10.68 16 10.35 16 10C16 9.65 15.95 9.32 15.87 9H14.18M8.54 12C9 12.83 9.78 13.46 10.7 13.78C10.4 13.22 10.18 12.63 10 12H8.54M11.04 12C11.25 12.72 11.59 13.38 12 14C12.42 13.38 12.75 12.72 12.96 12H11.04M14 12C13.82 12.63 13.59 13.22 13.29 13.78C14.21 13.46 15 12.83 15.46 12H14M6 2C5.47 2 4.96 2.21 4.59 2.59C4.21 2.96 4 3.47 4 4V20C4 20.53 4.21 21.04 4.59 21.41C4.96 21.79 5.47 22 6 22H14.8C14.29 21.12 14 20.09 14 19H7V17H14.34C15.17 14.67 17.39 13 20 13V4C20 3.47 19.79 2.96 19.41 2.59C19.04 2.21 18.53 2 18 2H6M12 5C13.33 5 14.6 5.53 15.54 6.46C16.47 7.4 17 8.67 17 10C17 11.33 16.47 12.6 15.54 13.54C14.6 14.47 13.33 15 12 15C10.67 15 9.4 14.47 8.46 13.54C7.53 12.6 7 11.33 7 10C7 8.67 7.53 7.4 8.46 6.46C9.4 5.53 10.67 5 12 5M18.75 22.16L16 19.16L17.16 18L18.75 19.59L22.34 16L23.5 17.41L18.75 22.16Z";
var mdiPassportMinus = "M12 6C11.59 6.62 11.25 7.29 11.04 8H12.96C12.75 7.29 12.42 6.62 12 6Z M10.7 6.22C9.78 6.53 9 7.17 8.54 8H10C10.18 7.38 10.4 6.78 10.7 6.22Z M13.29 6.22C13.59 6.78 13.82 7.38 14 8H15.46C15 7.17 14.21 6.54 13.29 6.22Z M8.13 9C8.05 9.32 8 9.65 8 10C8 10.35 8.05 10.68 8.13 11H9.82C9.78 10.67 9.75 10.34 9.75 10C9.75 9.66 9.78 9.33 9.82 9H8.13Z M10.83 9C10.78 9.32 10.75 9.66 10.75 10C10.75 10.34 10.78 10.67 10.83 11H13.17C13.21 10.67 13.25 10.34 13.25 10C13.25 9.66 13.21 9.32 13.17 9H10.83Z M14.18 9C14.22 9.33 14.25 9.66 14.25 10C14.25 10.34 14.22 10.67 14.18 11H15.87C15.95 10.68 16 10.35 16 10C16 9.65 15.95 9.32 15.87 9H14.18Z M8.54 12C9 12.83 9.78 13.46 10.7 13.78C10.4 13.22 10.18 12.63 10 12H8.54Z M11.04 12C11.25 12.72 11.59 13.38 12 14C12.42 13.38 12.75 12.72 12.96 12H11.04Z M14 12C13.82 12.63 13.59 13.22 13.29 13.78C14.21 13.46 15 12.83 15.46 12H14Z M6 2C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H13.8027C13.2922 21.1175 13 20.0929 13 19H7V17H13.3414C14.1651 14.6696 16.3876 13 19 13C19.3407 13 19.6748 13.0284 20 13.083V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2H6ZM12 5C13.3261 5 14.5979 5.52678 15.5355 6.46447C16.4732 7.40215 17 8.67392 17 10C17 11.3261 16.4732 12.5979 15.5355 13.5355C14.5979 14.4732 13.3261 15 12 15C10.6739 15 9.40215 14.4732 8.46447 13.5355C7.52678 12.5979 7 11.3261 7 10C7 8.67392 7.52678 7.40215 8.46447 6.46447C9.40215 5.52678 10.6739 5 12 5Z M23 20V18H15V20H23Z";
var mdiPassportPlus = "M12 6C11.59 6.62 11.25 7.29 11.04 8H12.96C12.75 7.29 12.42 6.62 12 6M10.7 6.22C9.78 6.53 9 7.17 8.54 8H10C10.18 7.38 10.4 6.78 10.7 6.22M13.29 6.22C13.59 6.78 13.82 7.38 14 8H15.46C15 7.17 14.21 6.54 13.29 6.22M8.13 9C8.05 9.32 8 9.65 8 10C8 10.35 8.05 10.68 8.13 11H9.82C9.78 10.67 9.75 10.34 9.75 10C9.75 9.66 9.78 9.33 9.82 9H8.13M10.83 9C10.78 9.32 10.75 9.66 10.75 10C10.75 10.34 10.78 10.67 10.83 11H13.17C13.21 10.67 13.25 10.34 13.25 10C13.25 9.66 13.21 9.32 13.17 9H10.83M14.18 9C14.22 9.33 14.25 9.66 14.25 10C14.25 10.34 14.22 10.67 14.18 11H15.87C15.95 10.68 16 10.35 16 10C16 9.65 15.95 9.32 15.87 9H14.18M8.54 12C9 12.83 9.78 13.46 10.7 13.78C10.4 13.22 10.18 12.63 10 12H8.54M11.04 12C11.25 12.72 11.59 13.38 12 14C12.42 13.38 12.75 12.72 12.96 12H11.04M14 12C13.82 12.63 13.59 13.22 13.29 13.78C14.21 13.46 15 12.83 15.46 12H14M6 2C5.47 2 4.96 2.21 4.59 2.59C4.21 2.96 4 3.47 4 4V20C4 20.53 4.21 21.04 4.59 21.41C4.96 21.79 5.47 22 6 22H13.8C13.29 21.12 13 20.09 13 19H7V17H13.34C14.17 14.67 16.39 13 19 13C19.34 13 19.68 13.03 20 13.08V4C20 3.47 19.79 2.96 19.41 2.59C19.04 2.21 18.53 2 18 2H6M12 5C13.33 5 14.6 5.53 15.54 6.46C16.47 7.4 17 8.67 17 10C17 11.33 16.47 12.6 15.54 13.54C14.6 14.47 13.33 15 12 15C10.67 15 9.4 14.47 8.46 13.54C7.53 12.6 7 11.33 7 10C7 8.67 7.53 7.4 8.46 6.46C9.4 5.53 10.67 5 12 5M18 18V15H20V18H23V20H20V23H18V20H15V18H18Z";
var mdiPassportRemove = "M12 6C11.59 6.62 11.25 7.29 11.04 8H12.96C12.75 7.29 12.42 6.62 12 6M10.7 6.22C9.78 6.53 9 7.17 8.54 8H10C10.18 7.38 10.4 6.78 10.7 6.22M13.29 6.22C13.59 6.78 13.82 7.38 14 8H15.46C15 7.17 14.21 6.54 13.29 6.22M8.13 9C8.05 9.32 8 9.65 8 10C8 10.35 8.05 10.68 8.13 11H9.82C9.78 10.67 9.75 10.34 9.75 10C9.75 9.66 9.78 9.33 9.82 9H8.13M10.83 9C10.78 9.32 10.75 9.66 10.75 10C10.75 10.34 10.78 10.67 10.83 11H13.17C13.21 10.67 13.25 10.34 13.25 10C13.25 9.66 13.21 9.32 13.17 9H10.83M14.18 9C14.22 9.33 14.25 9.66 14.25 10C14.25 10.34 14.22 10.67 14.18 11H15.87C15.95 10.68 16 10.35 16 10C16 9.65 15.95 9.32 15.87 9H14.18M8.54 12C9 12.83 9.78 13.46 10.7 13.78C10.4 13.22 10.18 12.63 10 12H8.54M11.04 12C11.25 12.72 11.59 13.38 12 14C12.42 13.38 12.75 12.72 12.96 12H11.04M14 12C13.82 12.63 13.59 13.22 13.29 13.78C14.21 13.46 15 12.83 15.46 12H14M6 2C5.47 2 4.96 2.21 4.59 2.59C4.21 2.96 4 3.47 4 4V20C4 20.53 4.21 21.04 4.59 21.41C4.96 21.79 5.47 22 6 22H13.8C13.29 21.12 13 20.09 13 19H7V17H13.34C14.17 14.67 16.39 13 19 13C19.34 13 19.68 13.03 20 13.08V4C20 3.47 19.79 2.96 19.41 2.59C19.04 2.21 18.53 2 18 2H6M12 5C13.33 5 14.6 5.53 15.54 6.46C16.47 7.4 17 8.67 17 10C17 11.33 16.47 12.6 15.54 13.54C14.6 14.47 13.33 15 12 15C10.67 15 9.4 14.47 8.46 13.54C7.53 12.6 7 11.33 7 10C7 8.67 7.53 7.4 8.46 6.46C9.4 5.53 10.67 5 12 5M15.46 16.88L16.88 15.46L19 17.59L21.12 15.47L22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.46 21.12L17.59 19L15.47 16.88Z";
var mdiPasta = "M4 16.5V8H3V7H4V6H3V5H4V4H3V3H9C9.5 3.03 9.95 3.24 10.34 3.63S10.95 4.5 11 5H21V6H11C10.95 6.53 10.73 7 10.34 7.43S9.5 8.05 9 8H7V15.05C7.05 15.05 7.13 15.04 7.24 15S7.44 15 7.5 15C8.06 15 8.7 15.14 9.42 15.42C9.83 14.5 10.53 13.68 11.53 13S13.53 12 14.53 12C16.06 12 17.36 12.53 18.42 13.59S20 15.95 20 17.5C20 17.55 20 17.64 20 17.77S19.97 17.97 19.97 18H3.14C3.27 17.5 3.55 17 4 16.5M6 15.23V8H5V15.7C5.5 15.45 5.81 15.3 6 15.23M9 7V6H7V7H9M9 4H7V5H9V4M5 4V5H6V4H5M5 6V7H6V6H5M2 19H22L20 21H4L2 19Z";
var mdiPatioHeater = "M15 22H9V21H15V22M19 4L15 2H9L5 4H19M8 5L8.4 6H15.6L16 5H8M10 10H11V15C10.4 15 10 15.4 10 16V20H14V16C14 15.4 13.6 15 13 15V10H14L14.4 9H9.6L10 10M9.2 8H14.8L15.2 7H8.8L9.2 8Z";
var mdiPatreon = "M14.82 2.41C18.78 2.41 22 5.65 22 9.62C22 13.58 18.78 16.8 14.82 16.8C10.85 16.8 7.61 13.58 7.61 9.62C7.61 5.65 10.85 2.41 14.82 2.41M2 21.6H5.5V2.41H2V21.6Z";
var mdiPause = "M14,19H18V5H14M6,19H10V5H6V19Z";
var mdiPauseBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.1 3 19 3M11 16H9V8H11V16M15 16H13V8H15V16Z";
var mdiPauseBoxOutline = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V5H19V19M13 16V8H15V16H13M9 16V8H11V16H9";
var mdiPauseCircle = "M15,16H13V8H15M11,16H9V8H11M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiPauseCircleOutline = "M13,16V8H15V16H13M9,16V8H11V16H9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiPauseOctagon = "M15.73,3L21,8.27V15.73L15.73,21H8.27L3,15.73V8.27L8.27,3H15.73M15,16V8H13V16H15M11,16V8H9V16H11Z";
var mdiPauseOctagonOutline = "M15,16H13V8H15V16M11,16H9V8H11V16M15.73,3L21,8.27V15.73L15.73,21H8.27L3,15.73V8.27L8.27,3H15.73M14.9,5H9.1L5,9.1V14.9L9.1,19H14.9L19,14.9V9.1L14.9,5Z";
var mdiPaw = "M8.35,3C9.53,2.83 10.78,4.12 11.14,5.9C11.5,7.67 10.85,9.25 9.67,9.43C8.5,9.61 7.24,8.32 6.87,6.54C6.5,4.77 7.17,3.19 8.35,3M15.5,3C16.69,3.19 17.35,4.77 17,6.54C16.62,8.32 15.37,9.61 14.19,9.43C13,9.25 12.35,7.67 12.72,5.9C13.08,4.12 14.33,2.83 15.5,3M3,7.6C4.14,7.11 5.69,8 6.5,9.55C7.26,11.13 7,12.79 5.87,13.28C4.74,13.77 3.2,12.89 2.41,11.32C1.62,9.75 1.9,8.08 3,7.6M21,7.6C22.1,8.08 22.38,9.75 21.59,11.32C20.8,12.89 19.26,13.77 18.13,13.28C17,12.79 16.74,11.13 17.5,9.55C18.31,8 19.86,7.11 21,7.6M19.33,18.38C19.37,19.32 18.65,20.36 17.79,20.75C16,21.57 13.88,19.87 11.89,19.87C9.9,19.87 7.76,21.64 6,20.75C5,20.26 4.31,18.96 4.44,17.88C4.62,16.39 6.41,15.59 7.47,14.5C8.88,13.09 9.88,10.44 11.89,10.44C13.89,10.44 14.95,13.05 16.3,14.5C17.41,15.72 19.26,16.75 19.33,18.38Z";
var mdiPawOff = "M2,4.27L3.28,3L21.5,21.22L20.23,22.5L18.23,20.5C18.09,20.6 17.94,20.68 17.79,20.75C16,21.57 13.88,19.87 11.89,19.87C9.9,19.87 7.76,21.64 6,20.75C5,20.26 4.31,18.96 4.44,17.88C4.62,16.39 6.41,15.59 7.47,14.5C8.21,13.77 8.84,12.69 9.55,11.82L2,4.27M8.35,3C9.53,2.83 10.78,4.12 11.14,5.9C11.32,6.75 11.26,7.56 11,8.19L7.03,4.2C7.29,3.55 7.75,3.1 8.35,3M15.5,3C16.69,3.19 17.35,4.77 17,6.54C16.62,8.32 15.37,9.61 14.19,9.43C13,9.25 12.35,7.67 12.72,5.9C13.08,4.12 14.33,2.83 15.5,3M3,7.6C4.14,7.11 5.69,8 6.5,9.55C7.26,11.13 7,12.79 5.87,13.28C4.74,13.77 3.2,12.89 2.41,11.32C1.62,9.75 1.9,8.08 3,7.6M21,7.6C22.1,8.08 22.38,9.75 21.59,11.32C20.8,12.89 19.26,13.77 18.13,13.28C17,12.79 16.74,11.13 17.5,9.55C18.31,8 19.86,7.11 21,7.6Z";
var mdiPawOffOutline = "M22.83 8.25C22.56 7.5 22.05 6.96 21.39 6.68C20.22 6.18 18.8 6.6 17.7 7.66C17.81 7.37 17.91 7.06 18 6.73C18.25 5.38 18 4.03 17.38 3.12C16.95 2.5 16.33 2.11 15.64 2C14.1 1.78 12.57 3.08 11.93 5C11.28 3.05 9.74 1.76 8.19 2C7.5 2.12 6.88 2.53 6.45 3.16C6.44 3.18 6.43 3.2 6.42 3.22L7.91 4.71C7.96 4.54 8 4.4 8.1 4.29C8.22 4.12 8.36 4 8.5 4C9 3.91 9.88 4.69 10.16 6.1C10.23 6.44 10.24 6.75 10.22 7L11.88 8.68C11.89 8.65 11.91 8.62 11.93 8.58C11.97 8.69 12.04 8.78 12.09 8.89L13.43 10.23C13.63 10.32 13.83 10.39 14.04 10.42C14.16 10.44 14.29 10.45 14.41 10.45C15.13 10.45 15.83 10.12 16.43 9.57C16 10.64 15.96 11.73 16.29 12.63C16.56 13.35 17.07 13.91 17.73 14.2C18.07 14.34 18.43 14.41 18.8 14.41C20.18 14.41 21.66 13.4 22.5 11.77C23.08 10.58 23.21 9.3 22.83 8.25M16 6.33C15.72 7.73 14.83 8.5 14.34 8.44C14.28 8.43 14.12 8.41 13.94 8.15C13.69 7.79 13.5 7.07 13.7 6.1C13.97 4.76 14.8 4 15.29 4C15.31 4 15.34 4 15.36 4C15.5 4 15.63 4.11 15.75 4.27C16.07 4.73 16.18 5.54 16 6.33M20.7 10.87C20.12 12 19.08 12.6 18.53 12.36C18.47 12.34 18.28 12.26 18.16 11.93C18 11.43 18.07 10.68 18.39 10C18.9 9.04 19.74 8.47 20.33 8.47C20.43 8.47 20.5 8.5 20.6 8.5H20.6C20.75 8.58 20.87 8.72 20.95 8.94C21.09 9.34 21.1 10.06 20.7 10.87M1.11 3L4.8 6.69C4.06 6.41 3.29 6.39 2.6 6.68C1.94 6.97 1.43 7.53 1.17 8.27C.793 9.31 .919 10.58 1.5 11.77C2.34 13.4 3.82 14.41 5.21 14.41C5.57 14.41 5.93 14.34 6.27 14.2C6.93 13.91 7.44 13.35 7.71 12.63C8 11.79 8 10.77 7.64 9.76C7.83 9.91 8.04 10.03 8.24 10.13L9.73 11.62C8.94 12.5 8.27 13.7 7.47 14.5C6.41 15.59 4.62 16.39 4.44 17.88C4.31 18.96 5 20.26 6 20.75C6.35 20.93 6.72 21 7.1 21C8.61 21 10.3 19.87 11.89 19.87C13.5 19.87 15.18 20.97 16.71 20.97C17.08 20.97 17.44 20.91 17.79 20.75C18 20.65 18.23 20.5 18.43 20.32L20.84 22.73L22.11 21.46L2.39 1.73L1.11 3M11.15 13.04L17 18.9C17 18.91 16.97 18.92 16.96 18.93C16.92 18.95 16.85 18.97 16.71 18.97C16.28 18.97 15.63 18.75 15 18.54C14.08 18.23 13.03 17.87 11.89 17.87C10.75 17.87 9.7 18.24 8.78 18.56C8.15 18.77 7.5 19 7.1 19C6.97 19 6.92 19 6.88 18.95C6.66 18.84 6.4 18.37 6.43 18.12C6.5 17.89 7.23 17.31 7.59 17C8.03 16.68 8.5 16.33 8.89 15.91C9.44 15.36 9.89 14.73 10.33 14.12C10.55 13.8 10.86 13.38 11.15 13.04M5.6 10C5.93 10.68 6 11.43 5.84 11.93C5.71 12.26 5.53 12.34 5.47 12.36C4.92 12.6 3.88 12 3.3 10.87C2.9 10.06 2.91 9.35 3.05 8.94C3.13 8.73 3.25 8.58 3.4 8.5C3.5 8.5 3.57 8.46 3.68 8.46C4.26 8.46 5.1 9.03 5.6 10Z";
var mdiPawOutline = "M22.83 8.25C22.56 7.5 22.05 6.96 21.4 6.68C20.23 6.18 18.81 6.6 17.7 7.66C17.81 7.37 17.91 7.06 18 6.73C18.25 5.38 18.03 4.03 17.38 3.12C16.95 2.5 16.33 2.11 15.64 2C14.1 1.78 12.57 3.08 11.93 5C11.29 3.05 9.74 1.76 8.19 2C7.5 2.12 6.88 2.53 6.45 3.16C5.81 4.09 5.61 5.39 5.89 6.74C5.94 7 6 7.24 6.09 7.47C5 6.56 3.7 6.2 2.6 6.68C1.94 6.97 1.44 7.53 1.17 8.27C.794 9.31 .92 10.58 1.5 11.77C2.34 13.4 3.82 14.41 5.21 14.41C5.57 14.41 5.93 14.34 6.27 14.2C6.93 13.91 7.44 13.35 7.71 12.63C8.03 11.79 8 10.77 7.64 9.76C8.19 10.19 8.81 10.45 9.45 10.45C9.57 10.45 9.7 10.44 9.82 10.42C10.5 10.32 11.12 9.92 11.55 9.3C11.7 9.08 11.83 8.84 11.93 8.58C12.03 8.84 12.15 9.08 12.3 9.29C12.73 9.91 13.35 10.31 14.04 10.42C14.16 10.44 14.29 10.45 14.41 10.45C15.13 10.45 15.83 10.12 16.43 9.57C16 10.64 15.96 11.73 16.29 12.63C16.56 13.36 17.07 13.91 17.73 14.2C18.07 14.34 18.43 14.41 18.8 14.41C20.18 14.41 21.66 13.4 22.5 11.77C23.08 10.58 23.21 9.3 22.83 8.25M5.84 11.93C5.72 12.26 5.53 12.34 5.47 12.36C4.92 12.6 3.88 12 3.3 10.87C2.9 10.06 2.91 9.35 3.05 8.94C3.13 8.73 3.25 8.58 3.4 8.5C3.5 8.5 3.58 8.46 3.68 8.46C4.26 8.46 5.1 9.03 5.6 10C5.93 10.68 6.03 11.43 5.84 11.93M9.91 8.16C9.79 8.32 9.66 8.42 9.5 8.44C9 8.5 8.14 7.73 7.85 6.34C7.65 5.38 7.85 4.66 8.1 4.29C8.22 4.12 8.36 4 8.5 4C9 3.91 9.88 4.69 10.16 6.1C10.36 7.07 10.16 7.8 9.91 8.16M16 6.33C15.72 7.73 14.83 8.5 14.34 8.44C14.28 8.43 14.12 8.41 13.94 8.15C13.69 7.79 13.5 7.07 13.7 6.1C13.97 4.76 14.8 4 15.29 4C15.32 4 15.34 4 15.36 4C15.5 4 15.63 4.11 15.75 4.27C16.07 4.73 16.18 5.54 16 6.33M20.7 10.87C20.12 12 19.08 12.6 18.53 12.36C18.47 12.34 18.28 12.26 18.16 11.93C18 11.43 18.07 10.68 18.39 10C18.9 9.04 19.75 8.47 20.33 8.47C20.43 8.47 20.5 8.5 20.6 8.5H20.61C20.76 8.58 20.87 8.72 20.95 8.94C21.1 9.34 21.11 10.06 20.7 10.87M16.3 14.5C14.95 13.05 13.89 10.44 11.89 10.44C9.88 10.44 8.88 13.09 7.47 14.5C6.41 15.59 4.62 16.39 4.44 17.88C4.31 18.96 5 20.26 6 20.75C6.35 20.93 6.72 21 7.1 21C8.61 21 10.3 19.87 11.89 19.87C13.5 19.87 15.18 20.97 16.71 20.97C17.08 20.97 17.44 20.91 17.79 20.75C18.65 20.36 19.37 19.32 19.33 18.38C19.26 16.75 17.41 15.72 16.3 14.5M16.96 18.93C16.92 18.95 16.85 18.97 16.71 18.97C16.29 18.97 15.63 18.75 15 18.54C14.08 18.23 13.03 17.87 11.89 17.87C10.75 17.87 9.7 18.24 8.78 18.56C8.15 18.77 7.5 19 7.1 19C6.97 19 6.92 19 6.88 18.95C6.66 18.84 6.4 18.37 6.43 18.12C6.5 17.89 7.23 17.31 7.59 17C8.03 16.68 8.5 16.33 8.89 15.91C9.44 15.36 9.89 14.73 10.33 14.12C10.78 13.5 11.53 12.44 11.89 12.44C12.29 12.44 13.08 13.56 13.56 14.22C13.95 14.78 14.36 15.35 14.82 15.85C15.21 16.27 15.62 16.64 16 17C16.54 17.45 17.32 18.14 17.33 18.44C17.32 18.58 17.12 18.86 16.96 18.93Z";
var mdiPeace = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,14.41V19.93C9.58,19.75 8.23,19.19 7.1,18.31L11,14.41M13,14.41L16.9,18.31C15.77,19.19 14.42,19.75 13,19.93V14.41M4,12C4,7.97 7,4.57 11,4.07V11.59L5.69,16.9C4.59,15.5 4,13.78 4,12M18.31,16.9L13,11.59V4.07C17,4.57 20,7.97 20,12C20,13.78 19.41,15.5 18.31,16.9Z";
var mdiPeanut = "M16 12.77A2 2 0 0 1 15.86 10.12A5 5 0 0 0 13.04 2.12A5.74 5.74 0 0 0 12 2A5 5 0 0 0 7 7A5 5 0 0 0 8.11 10.12A2 2 0 0 1 8 12.72A5.5 5.5 0 0 0 10.81 21.87A5.42 5.42 0 0 0 12 22A5.5 5.5 0 0 0 16 12.77M13 5A1 1 0 1 1 12 6A1 1 0 0 1 13 5M11 18A1 1 0 1 1 12 17A1 1 0 0 1 11 18M12 15A1 1 0 1 1 13 16A1 1 0 0 1 12 15M14 19A1 1 0 1 1 15 18A1 1 0 0 1 14 19Z";
var mdiPeanutOff = "M15.9 10.12A5 5 0 0 0 13.08 2.12A5.74 5.74 0 0 0 12 2A5 5 0 0 0 7.68 4.5L16.38 13.18A4.35 4.35 0 0 0 16.04 12.77A2 2 0 0 1 15.9 10.12M13 7A1 1 0 1 1 14 6A1 1 0 0 1 13 7M7 6.39L2.39 1.73L1.11 3L7.8 9.69C7.9 9.84 8 10 8.11 10.12A2 2 0 0 1 8 12.72A5.5 5.5 0 0 0 10.81 21.87A5.42 5.42 0 0 0 12 22A5.5 5.5 0 0 0 17 18.86L20.87 22.73L22.14 21.46M11 18A1 1 0 1 1 12 17A1 1 0 0 1 11 18M14 19A1 1 0 1 1 15 18A1 1 0 0 1 14 19M13 16A1 1 0 0 1 12 15A1 1 0 0 1 12.35 14.24L13.76 15.65A1 1 0 0 1 13 16Z";
var mdiPeanutOffOutline = "M22.11 21.46L20.84 22.73L17.69 19.58C17.36 20.21 16.93 20.77 16.41 21.25C14.86 22.71 12.69 23.31 10.61 22.85C7.1 22.1 4.87 18.64 5.62 15.13C5.87 13.95 6.45 12.87 7.28 12C7.62 11.64 7.62 11.08 7.28 10.72C6.63 9.91 6.21 8.95 6.04 7.93L1.11 3L2.39 1.73L22.11 21.46M15.3 19.56C15.69 19.13 16 18.63 16.19 18.08L13.75 15.64C13.57 15.87 13.29 16 13 16C12.45 16 12 15.55 12 15C12 14.71 12.13 14.43 12.36 14.25L9.55 11.44C9.53 12.18 9.24 12.88 8.73 13.41C7.03 15.22 7.13 18.07 8.94 19.77L8.95 19.78C10.76 21.47 13.61 21.37 15.3 19.56M14 17C12.71 17 12.72 19 14 19C15.28 19 15.29 17 14 17M6.9 3.7L8.43 5.23C8.68 4.71 9.05 4.25 9.5 3.89C10.2 3.31 11.09 3 12 3H12.88C13.47 3.14 14 3.41 14.5 3.79C16.22 5.17 16.5 7.69 15.12 9.41C14.7 9.93 14.46 10.58 14.45 11.25L18.32 15.12C18.07 13.97 17.5 12.92 16.72 12.06C16.37 11.7 16.33 11.13 16.62 10.72C16.62 10.72 18 9 18 7S15.97.997 12 .997 6.9 3.7 6.9 3.7M12 17C12 15.71 10 15.72 10 17C10 18.28 12 18.29 12 17M13 5C11.71 5 11.72 7 13 7C14.28 7 14.29 5 13 5Z";
var mdiPeanutOutline = "M12 23C11.53 23 11.07 22.95 10.61 22.85C7.1 22.1 4.87 18.64 5.62 15.13C5.87 13.95 6.45 12.87 7.28 12C7.62 11.64 7.62 11.08 7.28 10.72C5.2 8.14 5.6 4.36 8.18 2.28S14.54.607 16.62 3.19C18.39 5.38 18.39 8.5 16.62 10.72C16.33 11.13 16.37 11.7 16.72 12.06C19.17 14.68 19.04 18.8 16.41 21.25C15.22 22.37 13.64 23 12 23M12 3C11.09 3 10.2 3.31 9.5 3.89C8.55 4.65 8 5.79 8 7C8 7.91 8.31 8.79 8.88 9.5C9.84 10.64 9.77 12.33 8.73 13.41C7.03 15.22 7.13 18.07 8.94 19.77S13.6 21.38 15.3 19.56C16.92 17.83 16.92 15.14 15.3 13.41C14.23 12.32 14.15 10.6 15.12 9.41C16.5 7.69 16.22 5.17 14.5 3.79C14 3.41 13.47 3.14 12.88 3C12.59 3 12.29 3 12 3M12 6C12 6.55 12.45 7 13 7S14 6.55 14 6 13.55 5 13 5 12 5.45 12 6M14 19C14.55 19 15 18.55 15 18S14.55 17 14 17 13 17.45 13 18 13.45 19 14 19M13 16C13.55 16 14 15.55 14 15S13.55 14 13 14 12 14.45 12 15 12.45 16 13 16M11 18C11.55 18 12 17.55 12 17S11.55 16 11 16 10 16.45 10 17 10.45 18 11 18Z";
var mdiPen = "M20.71,7.04C20.37,7.38 20.04,7.71 20.03,8.04C20,8.36 20.34,8.69 20.66,9C21.14,9.5 21.61,9.95 21.59,10.44C21.57,10.93 21.06,11.44 20.55,11.94L16.42,16.08L15,14.66L19.25,10.42L18.29,9.46L16.87,10.87L13.12,7.12L16.96,3.29C17.35,2.9 18,2.9 18.37,3.29L20.71,5.63C21.1,6 21.1,6.65 20.71,7.04M3,17.25L12.56,7.68L16.31,11.43L6.75,21H3V17.25Z";
var mdiPenLock = "M21.7,7C21.4,7.4 21,7.7 21,8C21,8.3 21.3,8.6 21.6,9C22.1,9.5 22.6,9.9 22.5,10.4C22.5,10.9 22,11.4 21.5,11.9L17.4,16L16,14.7L20.2,10.5L19.2,9.5L17.8,10.9L14,7.1L18,3.3C18.4,2.9 19,2.9 19.4,3.3L21.7,5.6C22.1,6 22.1,6.7 21.7,7M4,17.2L13.6,7.6L17.3,11.4L7.8,21H4V17.2M8,5V4.5C8,3.1 6.9,2 5.5,2C4.1,2 3,3.1 3,4.5V5C2.4,5 2,5.4 2,6V10C2,10.6 2.4,11 3,11H8C8.6,11 9,10.6 9,10V6C9,5.4 8.6,5 8,5M7,5H4V4.5C4,3.7 4.7,3 5.5,3C6.3,3 7,3.7 7,4.5V5Z";
var mdiPenMinus = "M20.7,7C20.4,7.4 20,7.7 20,8C20,8.3 20.3,8.6 20.6,9C21.1,9.5 21.6,9.9 21.5,10.4C21.5,10.9 21,11.4 20.5,11.9L16.4,16L15,14.7L19.2,10.5L18.2,9.5L16.8,10.9L13,7.1L17,3.3C17.4,2.9 18,2.9 18.4,3.3L20.7,5.6C21.1,6 21.1,6.7 20.7,7M3,17.2L12.6,7.6L16.3,11.4L6.8,21H3V17.2M10,5V7H2V5H10Z";
var mdiPenOff = "M2.3,5L1,6.3L7.5,12.8L3,17.2V21H6.8L11.3,16.5L17.8,23L19.1,21.7L2.3,5M16.9,10.9L13.1,7.1L17,3.3C17.4,2.9 18,2.9 18.4,3.3L20.7,5.6C21.1,6 21.1,6.6 20.7,7C20.4,7.4 20,7.7 20,8C20,8.3 20.3,8.7 20.6,9C21.1,9.5 21.6,10 21.5,10.4C21.5,10.9 21,11.4 20.5,11.9L16.4,16L15,14.7L19.2,10.5L18.2,9.5L16.9,10.9M10,10.2L12.5,7.7L16.3,11.5L13.8,14L10,10.2Z";
var mdiPenPlus = "M20.7,7C20.4,7.4 20,7.7 20,8C20,8.3 20.3,8.6 20.6,9C21.1,9.5 21.6,9.9 21.5,10.4C21.5,10.9 21,11.4 20.5,11.9L16.4,16L15,14.7L19.2,10.5L18.2,9.5L16.8,10.9L13,7.1L17,3.3C17.4,2.9 18,2.9 18.4,3.3L20.7,5.6C21.1,6 21.1,6.7 20.7,7M3,17.2L12.6,7.6L16.3,11.4L6.8,21H3V17.2M7,2V5H10V7H7V10H5V7H2V5H5V2H7Z";
var mdiPenRemove = "M20.7,7C20.4,7.4 20,7.7 20,8C20,8.3 20.3,8.6 20.6,9C21.1,9.5 21.6,9.9 21.5,10.4C21.5,10.9 21,11.4 20.5,11.9L16.4,16L15,14.7L19.2,10.5L18.2,9.5L16.8,10.9L13,7.1L17,3.3C17.4,2.9 18,2.9 18.4,3.3L20.7,5.6C21.1,6 21.1,6.7 20.7,7M3,17.2L12.6,7.6L16.3,11.4L6.8,21H3V17.2M3.88,2.46L6,4.59L8.12,2.46L9.54,3.88L7.41,6L9.54,8.12L8.12,9.54L6,7.41L3.88,9.54L2.46,8.12L4.59,6L2.46,3.88L3.88,2.46Z";
var mdiPencil = "M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z";
var mdiPencilBox = "M19,3A2,2 0 0,1 21,5V19C21,20.11 20.1,21 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M16.7,9.35C16.92,9.14 16.92,8.79 16.7,8.58L15.42,7.3C15.21,7.08 14.86,7.08 14.65,7.3L13.65,8.3L15.7,10.35L16.7,9.35M7,14.94V17H9.06L15.12,10.94L13.06,8.88L7,14.94Z";
var mdiPencilBoxMultiple = "M20.22 2H7.78C6.8 2 6 2.8 6 3.78V16.22C6 17.2 6.8 18 7.78 18H20.22C21.2 18 22 17.21 22 16.22V3.78C22 2.8 21.2 2 20.22 2M11.06 15H9V12.94L15.06 6.88L17.12 8.94L11.06 15M18.7 7.35L17.7 8.35L15.65 6.3L16.65 5.3C16.86 5.08 17.21 5.08 17.42 5.3L18.7 6.58C18.92 6.79 18.92 7.14 18.7 7.35M4 6H2V20C2 21.11 2.9 22 4 22H18V20H4V6Z";
var mdiPencilBoxMultipleOutline = "M4 6H2V20C2 21.11 2.9 22 4 22H18V20H4V6M18.7 7.35L17.7 8.35L15.65 6.3L16.65 5.3C16.86 5.08 17.21 5.08 17.42 5.3L18.7 6.58C18.92 6.79 18.92 7.14 18.7 7.35M9 12.94L15.06 6.88L17.12 8.94L11.06 15H9V12.94M20 4L20 4L20 16L8 16L8 4H20M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z";
var mdiPencilBoxOutline = "M19,19V5H5V19H19M19,3A2,2 0 0,1 21,5V19C21,20.11 20.1,21 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M16.7,9.35L15.7,10.35L13.65,8.3L14.65,7.3C14.86,7.08 15.21,7.08 15.42,7.3L16.7,8.58C16.92,8.79 16.92,9.14 16.7,9.35M7,14.94L13.06,8.88L15.12,10.94L9.06,17H7V14.94Z";
var mdiPencilCircle = "M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M15.1,7.07C15.24,7.07 15.38,7.12 15.5,7.23L16.77,8.5C17,8.72 17,9.07 16.77,9.28L15.77,10.28L13.72,8.23L14.72,7.23C14.82,7.12 14.96,7.07 15.1,7.07M13.13,8.81L15.19,10.87L9.13,16.93H7.07V14.87L13.13,8.81Z";
var mdiPencilCircleOutline = "M7,14.94L13.06,8.88L15.12,10.94L9.06,17H7V14.94M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M16.7,9.35L15.7,10.35L13.65,8.3L14.65,7.3C14.86,7.08 15.21,7.08 15.42,7.3L16.7,8.58C16.92,8.79 16.92,9.14 16.7,9.35M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2";
var mdiPencilLock = "M5.5,2A2.5,2.5 0 0,0 3,4.5V5A1,1 0 0,0 2,6V10A1,1 0 0,0 3,11H8A1,1 0 0,0 9,10V6A1,1 0 0,0 8,5V4.5A2.5,2.5 0 0,0 5.5,2M5.5,3A1.5,1.5 0 0,1 7,4.5V5H4V4.5A1.5,1.5 0 0,1 5.5,3M19.66,3C19.4,3 19.16,3.09 18.97,3.28L17.13,5.13L20.88,8.88L22.72,7.03C23.11,6.64 23.11,6 22.72,5.63L20.38,3.28C20.18,3.09 19.91,3 19.66,3M16.06,6.19L5,17.25V21H8.75L19.81,9.94L16.06,6.19Z";
var mdiPencilLockOutline = "M16.1,9L17,9.9L7.9,19H7V18.1L16.1,9M19.7,3C19.5,3 19.2,3.1 19,3.3L17.2,5.1L20.9,8.9L22.7,7C23.1,6.6 23.1,6 22.7,5.6L20.4,3.3C20.2,3.1 19.9,3 19.7,3M16.1,6.2L5,17.2V21H8.8L19.8,9.9L16.1,6.2M8,5V4.5C8,3.1 6.9,2 5.5,2C4.1,2 3,3.1 3,4.5V5C2.4,5 2,5.4 2,6V10C2,10.6 2.4,11 3,11H8C8.6,11 9,10.6 9,10V6C9,5.4 8.6,5 8,5M7,5H4V4.5C4,3.7 4.7,3 5.5,3C6.3,3 7,3.7 7,4.5V5Z";
var mdiPencilMinus = "M20.7,7C21.1,6.6 21.1,6 20.7,5.6L18.4,3.3C18,2.9 17.4,2.9 17,3.3L15.2,5.1L19,8.9M3,17.2V21H6.8L17.8,9.9L14.1,6.1L3,17.2M10,5V7H2V5H10Z";
var mdiPencilMinusOutline = "M14.1,9L15,9.9L5.9,19H5V18.1L14.1,9M17.7,3C17.5,3 17.2,3.1 17,3.3L15.2,5.1L18.9,8.9L20.7,7C21.1,6.6 21.1,6 20.7,5.6L18.4,3.3C18.2,3.1 17.9,3 17.7,3M14.1,6.2L3,17.2V21H6.8L17.8,9.9L14.1,6.2M10,5V7H2V5H10Z";
var mdiPencilOff = "M18.66,2C18.4,2 18.16,2.09 17.97,2.28L16.13,4.13L19.88,7.88L21.72,6.03C22.11,5.64 22.11,5 21.72,4.63L19.38,2.28C19.18,2.09 18.91,2 18.66,2M3.28,4L2,5.28L8.5,11.75L4,16.25V20H7.75L12.25,15.5L18.72,22L20,20.72L13.5,14.25L9.75,10.5L3.28,4M15.06,5.19L11.03,9.22L14.78,12.97L18.81,8.94L15.06,5.19Z";
var mdiPencilOffOutline = "M10,10.2L14,6.2L17.8,10L13.8,14L12.4,12.6L15,9.9L14.1,9L11.5,11.6L10,10.2M20.7,5.6L18.4,3.3C18.2,3.1 17.9,3 17.7,3C17.5,3 17.2,3.1 17,3.3L15.2,5.1L19,8.9L20.7,7C21.1,6.7 21.1,6 20.7,5.6M19,21.7L17.7,23L11.2,16.5L6.8,21H3V17.2L7.5,12.7L1,6.3L2.3,5L19,21.7M9.8,15.1L8.9,14.2L5,18.1V19H5.9L9.8,15.1Z";
var mdiPencilOutline = "M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z";
var mdiPencilPlus = "M20.7,7C21.1,6.6 21.1,6 20.7,5.6L18.4,3.3C18,2.9 17.4,2.9 17,3.3L15.2,5.1L19,8.9M3,17.2V21H6.8L17.8,9.9L14.1,6.1L3,17.2M7,2V5H10V7H7V10H5V7H2V5H5V2H7Z";
var mdiPencilPlusOutline = "M14.1,9L15,9.9L5.9,19H5V18.1L14.1,9M17.7,3C17.5,3 17.2,3.1 17,3.3L15.2,5.1L18.9,8.9L20.7,7C21.1,6.6 21.1,6 20.7,5.6L18.4,3.3C18.2,3.1 17.9,3 17.7,3M14.1,6.2L3,17.2V21H6.8L17.8,9.9L14.1,6.2M7,2V5H10V7H7V10H5V7H2V5H5V2H7Z";
var mdiPencilRemove = "M20.7,7C21.1,6.6 21.1,6 20.7,5.6L18.4,3.3C18,2.9 17.4,2.9 17,3.3L15.2,5.1L19,8.9M3,17.2V21H6.8L17.8,9.9L14.1,6.1L3,17.2M3.9,2.4L6,4.5L8.1,2.4L9.5,3.8L7.4,5.9L9.5,8L8.1,9.5L6,7.4L3.9,9.5L2.5,8.1L4.6,6L2.5,3.8L3.9,2.4Z";
var mdiPencilRemoveOutline = "M17.7,3C17.5,3 17.2,3.1 17,3.3L15.2,5.1L18.9,8.9L20.7,7C21.1,6.6 21.1,6 20.7,5.6L18.4,3.3C18.2,3.1 17.9,3 17.7,3M14.1,6.2L3,17.2V21H6.8L17.8,9.9L14.1,6.2M5.9,19H5V18.1L14.1,9L15,9.9L5.9,19M3.9,2.5L6,4.6L8.1,2.5L9.5,3.9L7.4,6L9.5,8.1L8.1,9.5L6,7.4L3.9,9.5L2.5,8.1L4.6,6L2.5,3.9L3.9,2.5Z";
var mdiPencilRuler = "M3 17.25V21H6.75L17.81 9.93L14.06 6.18L3 17.25M22.61 18.36L18.36 22.61L13.16 17.41L14.93 15.64L15.93 16.64L18.4 14.16L19.82 15.58L18.36 17L19.42 18L20.84 16.6L22.61 18.36M6.61 10.83L1.39 5.64L5.64 1.39L7.4 3.16L4.93 5.64L6 6.7L8.46 4.22L9.88 5.64L8.46 7.05L9.46 8.05L6.61 10.83M20.71 7C21.1 6.61 21.1 6 20.71 5.59L18.37 3.29C18 2.9 17.35 2.9 16.96 3.29L15.12 5.12L18.87 8.87L20.71 7Z";
var mdiPencilRulerOutline = "M22.61 18.36L18.36 22.61L13.16 17.41L14.93 15.64L15.93 16.64L18.4 14.16L19.82 15.58L18.36 17L19.42 18L20.84 16.6L22.61 18.36M6.61 10.83L1.39 5.64L5.64 1.39L7.4 3.16L4.93 5.64L6 6.7L8.46 4.22L9.88 5.64L8.46 7.05L9.46 8.05L6.61 10.83M14.06 9L15 9.93L5.92 19H5V18.08L14.06 9M17.67 3C17.42 3 17.16 3.09 16.96 3.29L15.12 5.12L18.87 8.87L20.71 7C21.1 6.61 21.1 6 20.71 5.59L18.37 3.29C18.18 3.1 17.93 3 17.67 3M14.06 6.18L3 17.25V21H6.75L17.81 9.93L14.06 6.18Z";
var mdiPenguin = "M19,16C19,17.72 18.37,19.3 17.34,20.5C17.75,20.89 18,21.41 18,22H6C6,21.41 6.25,20.89 6.66,20.5C5.63,19.3 5,17.72 5,16H3C3,14.75 3.57,13.64 4.46,12.91L4.47,12.89C6,11.81 7,10 7,8V7A5,5 0 0,1 12,2A5,5 0 0,1 17,7V8C17,10 18,11.81 19.53,12.89L19.54,12.91C20.43,13.64 21,14.75 21,16H19M16,16A4,4 0 0,0 12,12A4,4 0 0,0 8,16A4,4 0 0,0 12,20A4,4 0 0,0 16,16M10,9L12,10.5L14,9L12,7.5L10,9M10,5A1,1 0 0,0 9,6A1,1 0 0,0 10,7A1,1 0 0,0 11,6A1,1 0 0,0 10,5M14,5A1,1 0 0,0 13,6A1,1 0 0,0 14,7A1,1 0 0,0 15,6A1,1 0 0,0 14,5Z";
var mdiPentagon = "M12,2.5L2,9.8L5.8,21.5H18.2L22,9.8L12,2.5Z";
var mdiPentagonOutline = "M12,5L19.6,10.5L16.7,19.4H7.3L4.4,10.5L12,5M12,2.5L2,9.8L5.8,21.5H18.1L22,9.8L12,2.5Z";
var mdiPentagram = "M16.15 14.4L18.71 22.26L12 17.4L5.28 22.3L7.85 14.37L1.15 9.5H9.44L12 1.61L14.56 9.5H22.89L16.15 14.4M13.3 16.47L15.86 18.33L14.88 15.32L13.3 16.47M11 9.5H13L12 6.47L11 9.5M10.74 16.47L9.13 15.3L8.13 18.37L10.74 16.47M18.28 11H15.05L15.67 12.9L18.28 11M10.53 11L9.62 13.8L12 15.54L14.39 13.82L13.47 11H10.53M5.76 11L8.34 12.87L8.95 11H5.76Z";
var mdiPercent = "M18.5,3.5L3.5,18.5L5.5,20.5L20.5,5.5M7,4A3,3 0 0,0 4,7A3,3 0 0,0 7,10A3,3 0 0,0 10,7A3,3 0 0,0 7,4M17,14A3,3 0 0,0 14,17A3,3 0 0,0 17,20A3,3 0 0,0 20,17A3,3 0 0,0 17,14Z";
var mdiPercentBox = "M19 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.1 3 19 3M8.83 7.05C9.81 7.05 10.6 7.84 10.6 8.83C10.6 9.81 9.81 10.6 8.83 10.6C7.84 10.6 7.05 9.81 7.05 8.83C7.05 7.84 7.84 7.05 8.83 7.05M15.22 17C14.24 17 13.45 16.2 13.45 15.22C13.45 14.24 14.24 13.45 15.22 13.45C16.2 13.45 17 14.24 17 15.22C17 16.2 16.2 17 15.22 17M8.5 17.03L7 15.53L15.53 7L17.03 8.5L8.5 17.03Z";
var mdiPercentBoxOutline = "M19 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.1 3 19 3M19 19H5V5H19V19M17 15.22C17 16.2 16.2 17 15.22 17C14.24 17 13.45 16.2 13.45 15.22C13.45 14.24 14.24 13.45 15.22 13.45C16.2 13.45 17 14.24 17 15.22M8.5 17.03L7 15.53L15.53 7L17.03 8.5L8.5 17.03M7.05 8.83C7.05 7.84 7.84 7.05 8.83 7.05C9.81 7.05 10.6 7.84 10.6 8.83C10.6 9.81 9.81 10.6 8.83 10.6C7.84 10.6 7.05 9.81 7.05 8.83Z";
var mdiPercentCircle = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M8.83 7.05C9.81 7.05 10.6 7.84 10.6 8.83C10.6 9.81 9.81 10.6 8.83 10.6C7.84 10.6 7.05 9.81 7.05 8.83C7.05 7.84 7.84 7.05 8.83 7.05M15.22 17C14.24 17 13.45 16.2 13.45 15.22C13.45 14.24 14.24 13.45 15.22 13.45C16.2 13.45 17 14.24 17 15.22C17 16.2 16.2 17 15.22 17M8.5 17.03L7 15.53L15.53 7L17.03 8.5L8.5 17.03Z";
var mdiPercentCircleOutline = "M17 15.22C17 16.2 16.2 17 15.22 17C14.24 17 13.45 16.2 13.45 15.22C13.45 14.24 14.24 13.45 15.22 13.45C16.2 13.45 17 14.24 17 15.22M8.83 10.6C9.81 10.6 10.6 9.81 10.6 8.83C10.6 7.84 9.81 7.05 8.83 7.05C7.84 7.05 7.05 7.84 7.05 8.83C7.05 9.81 7.84 10.6 8.83 10.6M7 15.53L8.5 17.03L17.03 8.5L15.53 7L7 15.53M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12M20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12Z";
var mdiPercentOutline = "M18.5 3.5L20.5 5.5L5.5 20.5L3.5 18.5L18.5 3.5M7 4C8.66 4 10 5.34 10 7C10 8.66 8.66 10 7 10C5.34 10 4 8.66 4 7C4 5.34 5.34 4 7 4M17 14C18.66 14 20 15.34 20 17C20 18.66 18.66 20 17 20C15.34 20 14 18.66 14 17C14 15.34 15.34 14 17 14M7 6C6.45 6 6 6.45 6 7C6 7.55 6.45 8 7 8C7.55 8 8 7.55 8 7C8 6.45 7.55 6 7 6M17 16C16.45 16 16 16.45 16 17C16 17.55 16.45 18 17 18C17.55 18 18 17.55 18 17C18 16.45 17.55 16 17 16Z";
var mdiPeriodicTable = "M2,4V6H4V4H2M20,4V6H22V4H20M2,7V9H4V7H2M5,7V9H7V7H5M14,7V9H16V7H14M17,7V9H19V7H17M20,7V9H22V7H20M2,10V12H4V10H2M5,10V12H7V10H5M8,10V12H10V10H8M11,10V12H13V10H11M14,10V12H16V10H14M17,10V12H19V10H17M20,10V12H22V10H20M2,13V15H4V13H2M5,13V15H7V13H5M8,13V15H10V13H8M11,13V15H13V13H11M14,13V15H16V13H14M17,13V15H19V13H17M20,13V15H22V13H20M5,17V19H7V17H5M8,17V19H10V17H8M11,17V19H13V17H11M14,17V19H16V17H14M17,17V19H19V17H17Z";
var mdiPerspectiveLess = "M16.56,12L19.23,20H4.78L7.44,12H16.56M7,1L3,5L7,9V6H11V4H7V1M17,1V4H13V6H17V9L21,5L17,1M18,10H6L2,22H22L18,10Z";
var mdiPerspectiveMore = "M16.56,12L19.23,20H4.78L7.44,12H16.56M17,1L13,5L17,9V6H21V4H17V1M7,1V4H3V6H7V9L11,5L7,1M18,10H6L2,22H22L18,10Z";
var mdiPh = "M13 7V17H15V13H17V17H19V7H17V11H15V7H13M11 15V13C11 11.9 10.11 11 9 11H5V21H7V17H9C10.11 17 11 16.11 11 15M9 15H7V13H9V15Z";
var mdiPhone = "M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z";
var mdiPhoneAlert = "M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4C3,3.44 3.45,3 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.24 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.58L6.62,10.79M17,12V10H19V12H17M17,8V2H19V8H17Z";
var mdiPhoneAlertOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M17 12V10H19V12H17M17 8V2H19V8H17Z";
var mdiPhoneBluetooth = "M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4A1,1 0 0,0 7.5,3H4A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5M18,7.21L18.94,8.14L18,9.08M18,2.91L18.94,3.85L18,4.79M14.71,9.5L17,7.21V11H17.5L20.35,8.14L18.21,6L20.35,3.85L17.5,1H17V4.79L14.71,2.5L14,3.21L16.79,6L14,8.79L14.71,9.5Z";
var mdiPhoneBluetoothOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M18 7.21L18.94 8.14L18 9.08M18 2.91L18.94 3.85L18 4.79M14.71 9.5L17 7.21V11H17.5L20.35 8.14L18.21 6L20.35 3.85L17.5 1H17V4.79L14.71 2.5L14 3.21L16.79 6L14 8.79L14.71 9.5Z";
var mdiPhoneCancel = "M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79M16.5 2C14 2 12 4 12 6.5S14 11 16.5 11 21 9 21 6.5 19 2 16.5 2M16.5 9.5C14.84 9.5 13.5 8.16 13.5 6.5C13.5 5.94 13.65 5.42 13.92 5L18 9.08C17.58 9.35 17.06 9.5 16.5 9.5M19.08 8L15 3.92C15.42 3.65 15.94 3.5 16.5 3.5C18.16 3.5 19.5 4.84 19.5 6.5C19.5 7.06 19.35 7.58 19.08 8Z";
var mdiPhoneCancelOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M16.5 2C14 2 12 4 12 6.5S14 11 16.5 11 21 9 21 6.5 19 2 16.5 2M16.5 9.5C14.84 9.5 13.5 8.16 13.5 6.5C13.5 5.94 13.65 5.42 13.92 5L18 9.08C17.58 9.35 17.06 9.5 16.5 9.5M19.08 8L15 3.92C15.42 3.65 15.94 3.5 16.5 3.5C18.16 3.5 19.5 4.84 19.5 6.5C19.5 7.06 19.35 7.58 19.08 8Z";
var mdiPhoneCheck = "M6.62 10.79A15.1 15.1 0 0 0 13.21 17.38L15.41 15.18A1 1 0 0 1 16.41 14.93A11.36 11.36 0 0 0 20 15.5A1 1 0 0 1 21 16.5V20A1 1 0 0 1 20 21A17 17 0 0 1 3 4A1 1 0 0 1 4 3H7.5A1 1 0 0 1 8.5 4A11.36 11.36 0 0 0 9.07 7.57A1 1 0 0 1 8.82 8.57M21.71 4.71L20.29 3.29L15 8.59L12.71 6.29L11.29 7.71L15 11.41Z";
var mdiPhoneCheckOutline = "M20 15.5A11.36 11.36 0 0 1 16.43 14.93A1 1 0 0 0 15.43 15.18L13.23 17.38A15.1 15.1 0 0 1 6.64 10.79L8.84 8.59A1 1 0 0 0 9.09 7.59A11.36 11.36 0 0 1 8.5 4A1 1 0 0 0 7.5 3H4A1 1 0 0 0 3 4A17 17 0 0 0 20 21A1 1 0 0 0 21 20V16.5A1 1 0 0 0 20 15.5M5 5H6.54A12.54 12.54 0 0 0 7 7.59L5.79 8.8A15 15 0 0 1 5 5M19 19A15 15 0 0 1 15.2 18.24L16.41 17A12.31 12.31 0 0 0 19 17.45M15 11.44L11.29 7.74L12.71 6.32L15 8.59L20.29 3.29L21.71 4.71Z";
var mdiPhoneClassic = "M12,3C7.46,3 3.34,4.78 0.29,7.67C0.11,7.85 0,8.1 0,8.38C0,8.66 0.11,8.91 0.29,9.09L2.77,11.57C2.95,11.75 3.2,11.86 3.5,11.86C3.75,11.86 4,11.75 4.18,11.58C4.97,10.84 5.87,10.22 6.84,9.73C7.17,9.57 7.4,9.23 7.4,8.83V5.73C8.85,5.25 10.39,5 12,5C13.59,5 15.14,5.25 16.59,5.72V8.82C16.59,9.21 16.82,9.56 17.15,9.72C18.13,10.21 19,10.84 19.82,11.57C20,11.75 20.25,11.85 20.5,11.85C20.8,11.85 21.05,11.74 21.23,11.56L23.71,9.08C23.89,8.9 24,8.65 24,8.37C24,8.09 23.88,7.85 23.7,7.67C20.65,4.78 16.53,3 12,3M9,7V10C9,10 3,15 3,18V22H21V18C21,15 15,10 15,10V7H13V9H11V7H9M12,12A4,4 0 0,1 16,16A4,4 0 0,1 12,20A4,4 0 0,1 8,16A4,4 0 0,1 12,12M12,13.5A2.5,2.5 0 0,0 9.5,16A2.5,2.5 0 0,0 12,18.5A2.5,2.5 0 0,0 14.5,16A2.5,2.5 0 0,0 12,13.5Z";
var mdiPhoneClassicOff = "M12 3C16.53 3 20.65 4.78 23.7 7.67C23.88 7.85 24 8.09 24 8.37C24 8.65 23.89 8.9 23.71 9.08L21.23 11.56C21.05 11.74 20.8 11.85 20.5 11.85C20.25 11.85 20 11.75 19.82 11.57C19 10.84 18.13 10.21 17.15 9.72C16.82 9.56 16.59 9.21 16.59 8.82V5.72C15.14 5.25 13.59 5 12 5C10.44 5 8.93 5.24 7.5 5.69L5.94 4.11C7.82 3.4 9.86 3 12 3M9 7H11V9H13V7H15V10C15 10 21 15 21 18V19.18L9 7.18V7M1 4.27L2.28 3L21.5 22.22L20.23 23.5L18.73 22H3V18C3 15.86 6.05 12.71 7.8 11.07L6.59 9.86C5.71 10.33 4.9 10.9 4.18 11.58C4 11.75 3.75 11.86 3.5 11.86C3.2 11.86 2.95 11.75 2.77 11.57L.29 9.09C.11 8.91 0 8.66 0 8.38C0 8.1 .11 7.85 .29 7.67C.996 7 2.58 5.85 2.58 5.85L1 4.27M8 16C8 18.21 9.79 20 12 20C13.29 20 14.44 19.39 15.17 18.44L14.1 17.36C13.65 18.05 12.88 18.5 12 18.5C10.62 18.5 9.5 17.38 9.5 16C9.5 15.12 9.95 14.35 10.64 13.91L9.56 12.83C8.61 13.56 8 14.71 8 16Z";
var mdiPhoneClock = "M15.9 1C12.1 1.1 9 4.2 9 8C9 11.9 12.1 15 16 15S23 11.9 23 8 19.9 1 15.9 1C16 1 15.9 1 15.9 1M16 3C18.8 3 21 5.2 21 8S18.8 13 16 13 11 10.8 11 8 13.2 3 16 3M15 4V9L18.6 11.2L19.4 10L16.5 8.3V4H15M4.6 12.8C6 15.6 8.4 18 11.2 19.4L13.4 17.2C13.7 16.9 14.1 16.8 14.4 17C15.5 17.4 16.7 17.6 18 17.6C18.5 17.6 19 18.1 19 18.6V22C19 22.5 18.5 23 18 23C8.6 23 1 15.4 1 6C1 5.4 1.5 5 2 5H5.5C6.1 5 6.5 5.4 6.5 6C6.5 7.2 6.7 8.4 7.1 9.6C7.2 10 7.1 10.3 6.9 10.6L4.6 12.8";
var mdiPhoneDial = "M6.6 10.8C8 13.6 10.4 15.9 13.2 17.4L15.4 15.2C15.7 14.9 16.1 14.8 16.4 15C17.5 15.4 18.7 15.6 20 15.6C20.6 15.6 21 16 21 16.6V20C21 20.6 20.6 21 20 21C10.6 21 3 13.4 3 4C3 3.4 3.5 3 4 3H7.5C8.1 3 8.5 3.4 8.5 4C8.5 5.2 8.7 6.4 9.1 7.6C9.2 7.9 9.1 8.3 8.9 8.6L6.6 10.8M14 3C13.4 3 13 3.4 13 4S13.4 5 14 5 15 4.6 15 4 14.6 3 14 3M17 3C16.4 3 16 3.4 16 4S16.4 5 17 5 18 4.6 18 4 17.6 3 17 3M20 3C19.4 3 19 3.4 19 4S19.4 5 20 5 21 4.6 21 4 20.6 3 20 3M14 6C13.4 6 13 6.4 13 7S13.4 8 14 8 15 7.6 15 7 14.6 6 14 6M17 6C16.4 6 16 6.4 16 7S16.4 8 17 8 18 7.6 18 7 17.6 6 17 6M20 6C19.4 6 19 6.4 19 7S19.4 8 20 8 21 7.6 21 7 20.6 6 20 6M14 9C13.4 9 13 9.4 13 10S13.4 11 14 11 15 10.6 15 10 14.6 9 14 9M17 9C16.4 9 16 9.4 16 10S16.4 11 17 11 18 10.6 18 10 17.6 9 17 9M20 9C19.4 9 19 9.4 19 10S19.4 11 20 11 21 10.6 21 10 20.6 9 20 9Z";
var mdiPhoneDialOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M15 4C15 4.6 14.6 5 14 5S13 4.6 13 4 13.4 3 14 3 15 3.4 15 4M18 4C18 4.6 17.6 5 17 5S16 4.6 16 4 16.4 3 17 3 18 3.4 18 4M21 4C21 4.6 20.6 5 20 5S19 4.6 19 4 19.4 3 20 3 21 3.4 21 4M15 7C15 7.6 14.6 8 14 8S13 7.6 13 7 13.4 6 14 6 15 6.4 15 7M18 7C18 7.6 17.6 8 17 8S16 7.6 16 7 16.4 6 17 6 18 6.4 18 7M21 7C21 7.6 20.6 8 20 8S19 7.6 19 7 19.4 6 20 6 21 6.4 21 7M15 10C15 10.6 14.6 11 14 11S13 10.6 13 10 13.4 9 14 9 15 9.4 15 10M18 10C18 10.6 17.6 11 17 11S16 10.6 16 10 16.4 9 17 9 18 9.4 18 10M21 10C21 10.6 20.6 11 20 11S19 10.6 19 10 19.4 9 20 9 21 9.4 21 10Z";
var mdiPhoneForward = "M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4A1,1 0 0,0 7.5,3H4A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5M18,11L23,6L18,1V4H14V8H18V11Z";
var mdiPhoneForwardOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M18 11L23 6L18 1V4H14V8H18V11Z";
var mdiPhoneHangup = "M12,9C10.4,9 8.85,9.25 7.4,9.72V12.82C7.4,13.22 7.17,13.56 6.84,13.72C5.86,14.21 4.97,14.84 4.17,15.57C4,15.75 3.75,15.86 3.5,15.86C3.2,15.86 2.95,15.74 2.77,15.56L0.29,13.08C0.11,12.9 0,12.65 0,12.38C0,12.1 0.11,11.85 0.29,11.67C3.34,8.77 7.46,7 12,7C16.54,7 20.66,8.77 23.71,11.67C23.89,11.85 24,12.1 24,12.38C24,12.65 23.89,12.9 23.71,13.08L21.23,15.56C21.05,15.74 20.8,15.86 20.5,15.86C20.25,15.86 20,15.75 19.82,15.57C19.03,14.84 18.14,14.21 17.16,13.72C16.83,13.56 16.6,13.22 16.6,12.82V9.72C15.15,9.25 13.6,9 12,9Z";
var mdiPhoneHangupOutline = "M23.71 11.67A17 17 0 0 0 .29 11.67A1 1 0 0 0 0 12.38A1 1 0 0 0 .29 13.08L2.77 15.56A1 1 0 0 0 3.5 15.85A1 1 0 0 0 4.18 15.57A11.5 11.5 0 0 1 6.84 13.72A1 1 0 0 0 7.4 12.82V9.72A14.91 14.91 0 0 1 12 9A14.5 14.5 0 0 1 16.59 9.73V12.83A1 1 0 0 0 17.15 13.73A11.27 11.27 0 0 1 19.82 15.58A1 1 0 0 0 20.5 15.86A1 1 0 0 0 21.23 15.57L23.71 13.09A1 1 0 0 0 23.71 11.67M5.4 12.22A13.68 13.68 0 0 0 3.53 13.5L2.46 12.42A15.54 15.54 0 0 1 5.4 10.5M20.5 13.5A13.75 13.75 0 0 0 18.6 12.23V10.53A14.26 14.26 0 0 1 21.55 12.43Z";
var mdiPhoneInTalk = "M15,12H17A5,5 0 0,0 12,7V9A3,3 0 0,1 15,12M19,12H21C21,7 16.97,3 12,3V5C15.86,5 19,8.13 19,12M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4A1,1 0 0,0 7.5,3H4A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5Z";
var mdiPhoneInTalkOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M15 12H17A5 5 0 0 0 12 7V9A3 3 0 0 1 15 12M19 12H21C21 7 16.97 3 12 3V5C15.86 5 19 8.13 19 12Z";
var mdiPhoneIncoming = "M4,3A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.17L13.21,17.37C10.38,15.93 8.06,13.62 6.62,10.78L8.82,8.57C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4A1,1 0 0,0 7.5,3H4M19,11V9.5H15.5L21,4L20,3L14.5,8.5V5H13V11H19Z";
var mdiPhoneIncomingOutgoing = "M20 17.5V21C20 21.55 19.55 22 19 22C9.61 22 2 14.39 2 5C2 4.45 2.45 4 3 4H6.5C7.05 4 7.5 4.45 7.5 5C7.5 6.25 7.7 7.45 8.07 8.57C8.18 8.92 8.1 9.31 7.82 9.57L5.62 11.78C7.06 14.62 9.38 16.93 12.21 18.37L14.41 16.17C14.69 15.9 15.08 15.82 15.43 15.93C16.55 16.3 17.75 16.5 19 16.5C19.55 16.5 20 16.95 20 17.5M16 7.5H12.5L18 2L17 1L11.5 6.5V3H10V9H16V7.5M17 6V7.5H20.5L15 13L16 14L21.5 8.5V12H23V6H17Z";
var mdiPhoneIncomingOutgoingOutline = "M19 16.5C17.8 16.5 16.5 16.3 15.4 15.9H15.1C14.8 15.9 14.6 16 14.4 16.2L12.2 18.4C9.4 16.9 7 14.6 5.6 11.8L7.8 9.6C8.1 9.3 8.2 8.9 8 8.6C7.7 7.5 7.5 6.2 7.5 5C7.5 4.5 7 4 6.5 4H3C2.5 4 2 4.5 2 5C2 14.4 9.6 22 19 22C19.5 22 20 21.5 20 21V17.5C20 17 19.5 16.5 19 16.5M4 6H5.5C5.6 6.9 5.8 7.8 6 8.6L4.8 9.8C4.4 8.6 4.1 7.3 4 6M18 20C16.7 19.9 15.4 19.6 14.2 19.2L15.4 18C16.2 18.2 17.1 18.4 18 18.4V20M16 9V7.5H12.5L18 2L17 1L11.5 6.5V3H10V9H16M17 6V7.5H20.5L15 13L16 14L21.5 8.5V12H23V6H17Z";
var mdiPhoneIncomingOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M19 11V9.5H15.5L21 4L20 3L14.5 8.5V5H13V11H19Z";
var mdiPhoneLock = "M19.2,4H15.8V3.5C15.8,2.56 16.56,1.8 17.5,1.8C18.44,1.8 19.2,2.56 19.2,3.5M20,4V3.5A2.5,2.5 0 0,0 17.5,1A2.5,2.5 0 0,0 15,3.5V4A1,1 0 0,0 14,5V9A1,1 0 0,0 15,10H20A1,1 0 0,0 21,9V5A1,1 0 0,0 20,4M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4A1,1 0 0,0 7.5,3H4A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5Z";
var mdiPhoneLockOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M19.2 4H15.8V3.5C15.8 2.56 16.56 1.8 17.5 1.8C18.44 1.8 19.2 2.56 19.2 3.5M20 4V3.5A2.5 2.5 0 0 0 17.5 1A2.5 2.5 0 0 0 15 3.5V4A1 1 0 0 0 14 5V9A1 1 0 0 0 15 10H20A1 1 0 0 0 21 9V5A1 1 0 0 0 20 4Z";
var mdiPhoneLog = "M20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.24 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.58L6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5M12,3H14V5H12M15,3H21V5H15M12,6H14V8H12M15,6H21V8H15M12,9H14V11H12M15,9H21V11H15";
var mdiPhoneLogOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M12 3H14V5H12M15 3H21V5H15M12 6H14V8H12M15 6H21V8H15M12 9H14V11H12M15 9H21V11H15Z";
var mdiPhoneMessage = "M20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.08 14.82 15.69 14.9 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.58C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5M12 3V13L15 10H21V3H12Z";
var mdiPhoneMessageOutline = "M20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 15 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.58C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5M5.03 5H6.53C6.6 5.88 6.75 6.75 7 7.59L5.79 8.8C5.38 7.59 5.12 6.32 5.03 5M19 18.97C17.68 18.88 16.4 18.62 15.2 18.21L16.4 17C17.25 17.25 18.12 17.4 19 17.46V18.97M12 3V13L15 10H21V3H12M19 8H14V5H19V8Z";
var mdiPhoneMinus = "M4,3A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5C18.76,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.07,13.62 6.62,10.79L8.82,8.58C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.24 8.5,4A1,1 0 0,0 7.5,3M13,6V8H21V6";
var mdiPhoneMinusOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M13 6V8H21V6Z";
var mdiPhoneMissed = "M23.71,16.67C20.66,13.77 16.54,12 12,12C7.46,12 3.34,13.77 0.29,16.67C0.11,16.85 0,17.1 0,17.38C0,17.65 0.11,17.9 0.29,18.08L2.77,20.56C2.95,20.74 3.2,20.86 3.5,20.86C3.75,20.86 4,20.75 4.18,20.57C4.97,19.83 5.86,19.21 6.84,18.72C7.17,18.56 7.4,18.22 7.4,17.82V14.72C8.85,14.25 10.39,14 12,14C13.6,14 15.15,14.25 16.6,14.72V17.82C16.6,18.22 16.83,18.56 17.16,18.72C18.14,19.21 19.03,19.83 19.82,20.57C20,20.75 20.25,20.86 20.5,20.86C20.8,20.86 21.05,20.74 21.23,20.56L23.71,18.08C23.89,17.9 24,17.65 24,17.38C24,17.1 23.89,16.85 23.71,16.67M6.5,5.5L12,11L19,4L18,3L12,9L7.5,4.5H11V3H5V9H6.5V5.5Z";
var mdiPhoneMissedOutline = "M18.6 15.5v1.8c.7.4 1.3.8 1.9 1.3l1.1-1.1c-.9-.9-1.9-1.5-3-2m-13.2 0c-1 .5-2 1.1-2.9 1.9l1.1 1.1c.6-.5 1.2-.9 1.9-1.3v-1.7M12 12c4.5 0 8.7 1.7 11.7 4.7.2.2.3.4.3.7 0 .3-.1.5-.3.7l-2.5 2.5c-.2.2-.4.3-.7.3-.2 0-.5-.1-.7-.3-.8-.7-1.7-1.4-2.7-1.8-.3-.2-.6-.5-.6-.9v-3.1c-1.5-.5-3-.7-4.6-.7-1.6 0-3.1.2-4.6.7v3.1c0 .4-.2.7-.6.9-1 .5-1.9 1.1-2.7 1.8-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L.1 18.1c0-.2-.1-.5-.1-.7 0-.3.1-.5.3-.7C3.3 13.8 7.5 12 12 12zM6.5 5.5V9H5V3h6v1.5H7.5L12 9l6-6 1 1-7 7-5.5-5.5z";
var mdiPhoneOff = "M20.22,2.5L2.5,20.22L3.77,21.5L8.65,16.62C11.76,19.43 15.81,21 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C12.06,16.8 11,16.06 10.06,15.21L21.5,3.77L20.22,2.5M4,3A1,1 0 0,0 3,4C3,7.57 4.14,11.05 6.24,13.94L7.66,12.5C7.28,11.97 6.93,11.39 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4A1,1 0 0,0 7.5,3H4Z";
var mdiPhoneOffOutline = "M16.4 17C17.2 17.2 18.1 17.4 19 17.5V19C17.7 18.9 16.4 18.7 15.2 18.2L16.4 17M20.2 2.5L2.5 20.2L3.8 21.5L8.7 16.6C11.8 19.4 15.8 21 20 21C20.6 21 21 20.6 21 20V16.5C21 15.9 20.6 15.5 20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C12.1 16.8 11 16.1 10.1 15.2L21.5 3.8L20.2 2.5M6.5 5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5H6.5M7.5 3H4C3.4 3 3 3.4 3 4C3 7.6 4.1 11 6.2 13.9L7.6 12.5C7.2 12 6.9 11.4 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.4 8.5 5.2 8.5 4C8.5 3.4 8.1 3 7.5 3Z";
var mdiPhoneOutgoing = "M4,3A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.17L13.21,17.37C10.38,15.93 8.06,13.62 6.62,10.78L8.82,8.57C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4A1,1 0 0,0 7.5,3H4M15,3V4.5H18.5L13,10L14,11L19.5,5.5V9H21V3H15Z";
var mdiPhoneOutgoingOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M15 3V4.5H18.5L13 10L14 11L19.5 5.5V9H21V3H15Z";
var mdiPhoneOutline = "M20,15.5C18.8,15.5 17.5,15.3 16.4,14.9C16.3,14.9 16.2,14.9 16.1,14.9C15.8,14.9 15.6,15 15.4,15.2L13.2,17.4C10.4,15.9 8,13.6 6.6,10.8L8.8,8.6C9.1,8.3 9.2,7.9 9,7.6C8.7,6.5 8.5,5.2 8.5,4C8.5,3.5 8,3 7.5,3H4C3.5,3 3,3.5 3,4C3,13.4 10.6,21 20,21C20.5,21 21,20.5 21,20V16.5C21,16 20.5,15.5 20,15.5M5,5H6.5C6.6,5.9 6.8,6.8 7,7.6L5.8,8.8C5.4,7.6 5.1,6.3 5,5M19,19C17.7,18.9 16.4,18.6 15.2,18.2L16.4,17C17.2,17.2 18.1,17.4 19,17.4V19Z";
var mdiPhonePaused = "M19,10H21V3H19M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4A1,1 0 0,0 7.5,3H4A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5M17,3H15V10H17V3Z";
var mdiPhonePausedOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M19 10H21V3H19M17 3H15V10H17V3Z";
var mdiPhonePlus = "M4,3A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5C18.76,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.07,13.62 6.62,10.79L8.82,8.58C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.24 8.5,4A1,1 0 0,0 7.5,3M16,3V6H13V8H16V11H18V8H21V6H18V3";
var mdiPhonePlusOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M16 3V6H13V8H16V11H18V8H21V6H18V3Z";
var mdiPhoneRefresh = "M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79M17 7L18.77 5.23C18.32 4.78 17.69 4.5 17 4.5C15.62 4.5 14.5 5.62 14.5 7S15.62 9.5 17 9.5C17.82 9.5 18.54 9.11 19 8.5H20.71C20.12 9.97 18.68 11 17 11C14.79 11 13 9.21 13 7S14.79 3 17 3C18.11 3 19.11 3.45 19.83 4.17L21 3V7H17Z";
var mdiPhoneRefreshOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M17 7L18.77 5.23C18.32 4.78 17.69 4.5 17 4.5C15.62 4.5 14.5 5.62 14.5 7S15.62 9.5 17 9.5C17.82 9.5 18.54 9.11 19 8.5H20.71C20.12 9.97 18.68 11 17 11C14.79 11 13 9.21 13 7S14.79 3 17 3C18.11 3 19.11 3.45 19.83 4.17L21 3V7H17Z";
var mdiPhoneRemove = "M4 3C3.4 3 3 3.4 3 4C3 13.4 10.6 21 20 21C20.6 21 21 20.6 21 20V16.5C21 15.9 20.6 15.5 20 15.5C18.8 15.5 17.5 15.3 16.4 14.9C16 14.8 15.7 14.9 15.4 15.1L13.2 17.3C10.4 15.9 8.1 13.5 6.6 10.7L8.8 8.5C9.1 8.2 9.2 7.8 9 7.5C8.7 6.4 8.5 5.2 8.5 4C8.5 3.4 8.1 3 7.5 3M19.1 3.5L17 5.6L14.9 3.5L13.5 4.9L15.6 7L13.5 9.1L14.9 10.5L17 8.4L19.1 10.5L20.5 9.1L18.4 7L20.5 4.9";
var mdiPhoneRemoveOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M19.1 3.5L17 5.6L14.9 3.5L13.5 4.9L15.6 7L13.5 9.1L14.9 10.5L17 8.4L19.1 10.5L20.5 9.1L18.4 7L20.5 4.9L19.1 3.5Z";
var mdiPhoneReturn = "M21,6V11H19.5V7.5H13.87L16.3,9.93L15.24,11L11,6.75L15.24,2.5L16.3,3.57L13.87,6H21M8.82,8.58C9.08,8.32 9.17,7.93 9.06,7.58C8.69,6.42 8.5,5.22 8.5,4A1,1 0 0,0 7.5,3H4A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5C18.79,15.5 17.58,15.31 16.43,14.93C16.08,14.82 15.69,14.91 15.43,15.17L13.23,17.37C10.39,15.92 8.09,13.62 6.64,10.78L8.82,8.58Z";
var mdiPhoneReturnOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M21 6V11H19.5V7.5H13.87L16.3 9.93L15.24 11L11 6.75L15.24 2.5L16.3 3.57L13.87 6H21Z";
var mdiPhoneRing = "M23.71 16.67C20.66 13.78 16.54 12 12 12S3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71a.99.99 0 0 0-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z";
var mdiPhoneRingOutline = "M23.71 16.67C20.66 13.78 16.54 12 12 12S3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71a.99.99 0 0 0-.29-.7zm-18.31.56c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7H5.4zm15.07 1.26c-.59-.48-1.21-.9-1.87-1.27v-1.7c1.04.51 2.03 1.15 2.94 1.9l-1.07 1.07zm.69-12.23l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM11 2h2v5h-2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z";
var mdiPhoneRotateLandscape = "M9,1H3A2,2 0 0,0 1,3V16A2,2 0 0,0 3,18H9A2,2 0 0,0 11,16V3A2,2 0 0,0 9,1M9,15H3V3H9V15M21,13H13V15H21V21H9V20H6V21A2,2 0 0,0 8,23H21A2,2 0 0,0 23,21V15A2,2 0 0,0 21,13M23,10L19,8L20.91,7.09C19.74,4.31 17,2.5 14,2.5V1A9,9 0 0,1 23,10Z";
var mdiPhoneRotatePortrait = "M9,1H3A2,2 0 0,0 1,3V16A2,2 0 0,0 3,18H4V15H3V3H9V11H11V3A2,2 0 0,0 9,1M23,21V15A2,2 0 0,0 21,13H8A2,2 0 0,0 6,15V21A2,2 0 0,0 8,23H21A2,2 0 0,0 23,21M9,21V15H21V21H9M23,10H21.5C21.5,7 19.69,4.27 16.92,3.09L16,5L14,1A9,9 0 0,1 23,10Z";
var mdiPhoneSettings = "M19,11H21V9H19M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4A1,1 0 0,0 7.5,3H4A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5M17,9H15V11H17M13,9H11V11H13V9Z";
var mdiPhoneSettingsOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M17 9H15V11H17M13 9H11V11H13V9M19 11H21V9H19Z";
var mdiPhoneSync = "M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79M17 3V1.5L14.75 3.75L17 6V4.5C18.38 4.5 19.5 5.62 19.5 7C19.5 7.4 19.41 7.78 19.24 8.12L20.33 9.21C20.75 8.58 21 7.82 21 7C21 4.79 19.21 3 17 3M17 9.5C15.62 9.5 14.5 8.38 14.5 7C14.5 6.6 14.59 6.22 14.76 5.88L13.67 4.79C13.25 5.42 13 6.18 13 7C13 9.21 14.79 11 17 11V12.5L19.25 10.25L17 8V9.5Z";
var mdiPhoneSyncOutline = "M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9H16.1C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8 13.6 6.6 10.8L8.8 8.6C9.1 8.3 9.2 7.9 9 7.6C8.7 6.5 8.5 5.2 8.5 4C8.5 3.5 8 3 7.5 3H4C3.5 3 3 3.5 3 4C3 13.4 10.6 21 20 21C20.5 21 21 20.5 21 20V16.5C21 16 20.5 15.5 20 15.5M5 5H6.5C6.6 5.9 6.8 6.8 7 7.6L5.8 8.8C5.4 7.6 5.1 6.3 5 5M19 19C17.7 18.9 16.4 18.6 15.2 18.2L16.4 17C17.2 17.2 18.1 17.4 19 17.4V19M17 3V1.5L14.75 3.75L17 6V4.5C18.38 4.5 19.5 5.62 19.5 7C19.5 7.4 19.41 7.78 19.24 8.12L20.33 9.21C20.75 8.58 21 7.82 21 7C21 4.79 19.21 3 17 3M17 9.5C15.62 9.5 14.5 8.38 14.5 7C14.5 6.6 14.59 6.22 14.76 5.88L13.67 4.79C13.25 5.42 13 6.18 13 7C13 9.21 14.79 11 17 11V12.5L19.25 10.25L17 8V9.5Z";
var mdiPhoneVoip = "M13,17V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H13M23.7,7.67C23.88,7.85 24,8.09 24,8.37C24,8.65 23.89,8.9 23.71,9.08L21.23,11.56C21.05,11.74 20.8,11.85 20.5,11.85C20.25,11.85 20,11.75 19.82,11.57C19,10.84 18.13,10.21 17.15,9.72C16.82,9.56 16.59,9.21 16.59,8.82V5.72C15.14,5.25 13.59,5 12,5C10.4,5 8.85,5.25 7.4,5.73V8.83C7.4,9.23 7.17,9.57 6.84,9.73C5.87,10.22 4.97,10.84 4.18,11.58C4,11.75 3.75,11.86 3.5,11.86C3.2,11.86 2.95,11.75 2.77,11.57L0.29,9.09C0.11,8.91 0,8.66 0,8.38C0,8.1 0.11,7.85 0.29,7.67C3.34,4.78 7.46,3 12,3C16.53,3 20.65,4.78 23.7,7.67M11,10V15H10V10H11M12,10H15V13H13V15H12V10M14,12V11H13V12H14Z";
var mdiPi = "M4,5V7H6V19H8V7H14V16A3,3 0 0,0 17,19A3,3 0 0,0 20,16H18A1,1 0 0,1 17,17A1,1 0 0,1 16,16V7H18V5";
var mdiPiBox = "M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M6,7H17V9H15V14A1,1 0 0,0 16,15A1,1 0 0,0 17,14H19A3,3 0 0,1 16,17A3,3 0 0,1 13,14V9H10V17H8V9H6";
var mdiPiHole = "M5.62,2C9.5,2 11.57,4.29 11.77,7.93C12.5,3.57 15.93,4.08 15.93,4.08C16.1,6.55 14.07,8.05 11.77,8.17C11.12,6.81 7.25,3.47 7.25,3.47C7.23,3.5 10.97,6.74 10.83,8.15C8.33,7.88 5.82,6 5.62,2M6.06,13.11L9.92,9.25C11.09,8.08 13,8.08 14.16,9.25L18,13.11C19.19,14.28 19.19,16.18 18,17.35L14.16,21.21C13,22.38 11.09,22.38 9.92,21.21L6.06,17.35C4.89,16.18 4.89,14.28 6.06,13.11M9.39,19.59C9.39,18.36 10.15,16.85 12.09,16.85C13.4,16.85 14.87,18.1 16.31,17.96C14.87,17.92 13.59,16.85 13.59,15.19C13.59,13.86 14.69,12.9 14.69,11.34C14.63,12.33 13.82,13.77 12,13.77C10.59,13.77 9.55,12.63 7.87,12.63C8.58,12.67 10.5,13.3 10.5,15.35C10.5,17 9.39,17.5 9.39,19.59Z";
var mdiPiano = "M20 2H4C2.9 2 2 2.9 2 4V20C2 21.11 2.9 22 4 22H20C21.11 22 22 21.11 22 20V4C22 2.9 21.11 2 20 2M14.74 14H15V20H9V14H9.31C9.86 14 10.3 13.56 10.3 13V4H13.75V13C13.75 13.56 14.19 14 14.74 14M4 4H6.8V13C6.8 13.56 7.24 14 7.79 14H8V20H4V4M20 20H16V14H16.26C16.81 14 17.25 13.56 17.25 13V4H20V20Z";
var mdiPianoOff = "M22.11 21.46L2.39 1.73L1.11 3L2 3.89V20C2 21.11 2.9 22 4 22H20.11L20.84 22.73L22.11 21.46M8 20H4V5.89L6.8 8.69V13C6.8 13.56 7.24 14 7.79 14H8V20M15 20H9V14H9.31C9.86 14 10.3 13.56 10.3 13V12.19L15 16.89V20M16 20V17.89L18.11 20H16M10.3 7.1L5.2 2H20C21.11 2 22 2.9 22 4V18.8L20 16.8V4H17.25V13C17.25 13.3 17.13 13.55 16.93 13.73L13.75 10.55V4H10.3V7.1Z";
var mdiPickaxe = "M14.79,10.62L3.5,21.9L2.1,20.5L13.38,9.21L14.79,10.62M19.27,7.73L19.86,7.14L19.07,6.35L19.71,5.71L18.29,4.29L17.65,4.93L16.86,4.14L16.27,4.73C14.53,3.31 12.57,2.17 10.47,1.37L9.64,3.16C11.39,4.08 13,5.19 14.5,6.5L14,7L17,10L17.5,9.5C18.81,11 19.92,12.61 20.84,14.36L22.63,13.53C21.83,11.43 20.69,9.47 19.27,7.73Z";
var mdiPictureInPictureBottomRight = "M19,11H11V17H19V11M23,19V5C23,3.88 22.1,3 21,3H3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19M21,19H3V4.97H21V19Z";
var mdiPictureInPictureBottomRightOutline = "M19,11H11V17H19V11M17,15H13V13H17V15M21,3H3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V5C23,3.88 22.1,3 21,3M21,19H3V4.97H21V19Z";
var mdiPictureInPictureTopRight = "M19,7H11V13H19V7M21,3H3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V5A2,2 0 0,0 21,3M21,19H3V5H21V19Z";
var mdiPictureInPictureTopRightOutline = "M19,7H11V13H19V7M17,11H13V9H17V11M21,3H3A2,2 0 0,0 1,5V19C1,20.11 1.9,21 3,21H21A2,2 0 0,0 23,19V5C23,3.91 22.1,3 21,3M21,19H3V5H21V19Z";
var mdiPier = "M20,18C18.6,18 17.2,17.5 16,16.7C13.6,18.4 10.4,18.4 8,16.7C6.8,17.5 5.4,18 4,18H2V20H4C5.4,20 6.7,19.6 8,19C10.5,20.3 13.5,20.3 16,19C17.3,19.6 18.6,20 20,20H22V18H20M20,13H19V16.9C18.3,16.8 17.6,16.6 17,16.2V13H12V17C11.3,17 10.7,16.9 10,16.7V13H5V16.9C4.7,17 4.3,17 4,17H3V13H2V11H3V9H5V11H10V9H12V11H17V9H19V11H20V13Z";
var mdiPierCrane = "M20,20C18.61,20 17.22,19.53 16,18.67C13.56,20.38 10.44,20.38 8,18.67C6.78,19.53 5.39,20 4,20H2V22H4C5.37,22 6.74,21.65 8,21C10.5,22.3 13.5,22.3 16,21C17.26,21.65 18.62,22 20,22H22V20H20M20,4V3A1,1 0 0,0 19,2H9V1H6V2H5V4H6V13H5V11H3V13H2V15H3V19H4C4.33,19 4.67,18.97 5,18.92V15H10V18.65C10.65,18.85 11.33,18.95 12,18.95V18.92L12,15H13V13H12V11H10V13H9V4H17V8.62C16.53,8.79 16.19,9.23 16.19,9.76C16.19,10.2 16.43,10.6 16.8,10.82V12H17.42C17.76,12 18.03,12.28 18.03,12.62C18.03,12.96 17.76,13.24 17.42,13.24C17.2,13.24 17,13.12 16.88,12.93C16.71,12.64 16.34,12.54 16.05,12.71C15.75,12.87 15.65,13.25 15.82,13.55C16.15,14.11 16.76,14.47 17.42,14.47C18.43,14.47 19.26,13.64 19.26,12.62C19.26,11.84 18.76,11.14 18.03,10.88V10.82C18.41,10.6 18.65,10.2 18.65,9.76C18.65,9.3 18.38,8.91 18,8.7V4H20M8,11.66L7,12.66V11.24L8,10.24V11.66M8,8.71L7,9.71V8.29L8,7.29V8.71M7,6.71V5.29L8,4.29V5.71L7,6.71Z";
var mdiPig = "M9.5,9A1.5,1.5 0 0,0 8,10.5A1.5,1.5 0 0,0 9.5,12A1.5,1.5 0 0,0 11,10.5A1.5,1.5 0 0,0 9.5,9M14.5,9A1.5,1.5 0 0,0 13,10.5A1.5,1.5 0 0,0 14.5,12A1.5,1.5 0 0,0 16,10.5A1.5,1.5 0 0,0 14.5,9M12,4L12.68,4.03C13.62,3.24 14.82,2.59 15.72,2.35C17.59,1.85 20.88,2.23 21.31,3.83C21.62,5 20.6,6.45 19.03,7.38C20.26,8.92 21,10.87 21,13A9,9 0 0,1 12,22A9,9 0 0,1 3,13C3,10.87 3.74,8.92 4.97,7.38C3.4,6.45 2.38,5 2.69,3.83C3.12,2.23 6.41,1.85 8.28,2.35C9.18,2.59 10.38,3.24 11.32,4.03L12,4M10,16A1,1 0 0,1 11,17A1,1 0 0,1 10,18A1,1 0 0,1 9,17A1,1 0 0,1 10,16M14,16A1,1 0 0,1 15,17A1,1 0 0,1 14,18A1,1 0 0,1 13,17A1,1 0 0,1 14,16M12,13C9.24,13 7,15.34 7,17C7,18.66 9.24,20 12,20C14.76,20 17,18.66 17,17C17,15.34 14.76,13 12,13M7.76,4.28C7.31,4.16 4.59,4.35 4.59,4.35C4.59,4.35 6.8,6.1 7.24,6.22C7.69,6.34 9.77,6.43 9.91,5.9C10.06,5.36 8.2,4.4 7.76,4.28M16.24,4.28C15.8,4.4 13.94,5.36 14.09,5.9C14.23,6.43 16.31,6.34 16.76,6.22C17.2,6.1 19.41,4.35 19.41,4.35C19.41,4.35 16.69,4.16 16.24,4.28Z";
var mdiPigVariant = "M19.83 7.5L17.56 5.23C17.63 4.81 17.74 4.42 17.88 4.08C17.96 3.9 18 3.71 18 3.5C18 2.67 17.33 2 16.5 2C14.86 2 13.41 2.79 12.5 4H7.5C4.46 4 2 6.46 2 9.5S4.5 21 4.5 21H10V19H12V21H17.5L19.18 15.41L22 14.47V7.5H19.83M16 11C15.45 11 15 10.55 15 10S15.45 9 16 9C16.55 9 17 9.45 17 10S16.55 11 16 11Z";
var mdiPigVariantOutline = "M15 10C15 9.45 15.45 9 16 9C16.55 9 17 9.45 17 10S16.55 11 16 11 15 10.55 15 10M22 7.5V14.47L19.18 15.41L17.5 21H12V19H10V21H4.5C4.5 21 2 12.54 2 9.5S4.46 4 7.5 4H12.5C13.41 2.79 14.86 2 16.5 2C17.33 2 18 2.67 18 3.5C18 3.71 17.96 3.9 17.88 4.08C17.74 4.42 17.62 4.81 17.56 5.23L19.83 7.5H22M20 9.5H19L15.5 6C15.5 5.35 15.59 4.71 15.76 4.09C14.79 4.34 14 5.06 13.67 6H7.5C5.57 6 4 7.57 4 9.5C4 11.38 5.22 16.15 6 19H8V17H14V19H16L17.56 13.85L20 13.03V9.5Z";
var mdiPiggyBank = "M19.83 7.5L17.56 5.23C17.63 4.81 17.74 4.42 17.88 4.08C17.96 3.9 18 3.71 18 3.5C18 2.67 17.33 2 16.5 2C14.86 2 13.41 2.79 12.5 4H7.5C4.46 4 2 6.46 2 9.5S4.5 21 4.5 21H10V19H12V21H17.5L19.18 15.41L22 14.47V7.5H19.83M13 9H8V7H13V9M16 11C15.45 11 15 10.55 15 10S15.45 9 16 9C16.55 9 17 9.45 17 10S16.55 11 16 11Z";
var mdiPiggyBankOutline = "M15 10C15 9.45 15.45 9 16 9C16.55 9 17 9.45 17 10S16.55 11 16 11 15 10.55 15 10M8 9H13V7H8V9M22 7.5V14.47L19.18 15.41L17.5 21H12V19H10V21H4.5C4.5 21 2 12.54 2 9.5S4.46 4 7.5 4H12.5C13.41 2.79 14.86 2 16.5 2C17.33 2 18 2.67 18 3.5C18 3.71 17.96 3.9 17.88 4.08C17.74 4.42 17.62 4.81 17.56 5.23L19.83 7.5H22M20 9.5H19L15.5 6C15.5 5.35 15.59 4.71 15.76 4.09C14.79 4.34 14 5.06 13.67 6H7.5C5.57 6 4 7.57 4 9.5C4 11.38 5.22 16.15 6 19H8V17H14V19H16L17.56 13.85L20 13.03V9.5Z";
var mdiPill = "M4.22,11.29L11.29,4.22C13.64,1.88 17.43,1.88 19.78,4.22C22.12,6.56 22.12,10.36 19.78,12.71L12.71,19.78C10.36,22.12 6.56,22.12 4.22,19.78C1.88,17.43 1.88,13.64 4.22,11.29M5.64,12.71C4.59,13.75 4.24,15.24 4.6,16.57L10.59,10.59L14.83,14.83L18.36,11.29C19.93,9.73 19.93,7.2 18.36,5.64C16.8,4.07 14.27,4.07 12.71,5.64L5.64,12.71Z";
var mdiPillMultiple = "M16.2 3.5C15.2 2.5 13.9 2 12.7 2S10.1 2.5 9.2 3.5L3.4 9.1C1.4 11.1 1.4 14.2 3.4 16.2S8.5 18.2 10.5 16.2L16.2 10.5C18.1 8.6 18.1 5.4 16.2 3.5M14.8 9.1L12 11.9L8.4 8.4L4 12.8C4 12 4.2 11.1 4.9 10.5L10.6 4.8C11.1 4.3 11.9 4 12.6 4S14.1 4.3 14.7 4.8C15.9 6.1 15.9 7.9 14.8 9.1M19.6 7.1C19.6 7.9 19.4 8.6 19.2 9.4C20.2 10.6 20.2 12.4 19.1 13.5L16.3 16.3L14.8 14.8L12 17.6C10.7 18.9 8.9 19.6 7.2 19.6C7.4 19.9 7.6 20.2 7.9 20.5C9.9 22.5 13 22.5 15 20.5L20.7 14.8C22.7 12.8 22.7 9.7 20.7 7.7C20.2 7.5 19.9 7.3 19.6 7.1Z";
var mdiPillOff = "M22.11 21.46L2.39 1.73L1.11 3L6.81 8.7L4.22 11.29C1.88 13.64 1.88 17.43 4.22 19.78C6.56 22.12 10.36 22.12 12.71 19.78L15.3 17.19L20.84 22.73L22.11 21.46M4.6 16.57C4.24 15.24 4.59 13.75 5.64 12.71L8.23 10.12L9.64 11.53L4.6 16.57M10.78 7.58L9.36 6.16L11.29 4.22C13.64 1.88 17.43 1.88 19.78 4.22C22.12 6.56 22.12 10.36 19.78 12.71L17.85 14.65L16.43 13.23L18.36 11.29C19.93 9.73 19.93 7.2 18.36 5.64C16.8 4.07 14.27 4.07 12.71 5.64L10.78 7.58Z";
var mdiPillar = "M6,5H18A1,1 0 0,1 19,6A1,1 0 0,1 18,7H6A1,1 0 0,1 5,6A1,1 0 0,1 6,5M21,2V4H3V2H21M15,8H17V22H15V8M7,8H9V22H7V8M11,8H13V22H11V8Z";
var mdiPin = "M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z";
var mdiPinOff = "M2,5.27L3.28,4L20,20.72L18.73,22L12.8,16.07V22H11.2V16H6V14L8,12V11.27L2,5.27M16,12L18,14V16H17.82L8,6.18V4H7V2H17V4H16V12Z";
var mdiPinOffOutline = "M8,6.2V4H7V2H17V4H16V12L18,14V16H17.8L14,12.2V4H10V8.2L8,6.2M20,20.7L18.7,22L12.8,16.1V22H11.2V16H6V14L8,12V11.3L2,5.3L3.3,4L20,20.7M8.8,14H10.6L9.7,13.1L8.8,14Z";
var mdiPinOutline = "M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12M8.8,14L10,12.8V4H14V12.8L15.2,14H8.8Z";
var mdiPineTree = "M10,21V18H3L8,13H5L10,8H7L12,3L17,8H14L19,13H16L21,18H14V21H10Z";
var mdiPineTreeBox = "M4,2H20A2,2 0 0,1 22,4V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V4A2,2 0 0,1 4,2M11,19H13V17H18L14,13H17L13,9H16L12,5L8,9H11L7,13H10L6,17H11V19Z";
var mdiPineTreeFire = "M22.14 14.84L22.12 14.85C22.35 15.13 22.55 15.44 22.7 15.77L22.79 15.96C23.5 17.65 23 19.6 21.69 20.82C20.5 21.91 18.84 22.2 17.3 22C15.84 21.82 14.5 20.9 13.73 19.63C13.5 19.24 13.3 18.8 13.2 18.35C13.07 18 13.03 17.62 13 17.25C12.91 15.65 13.55 13.95 14.76 12.95C14.21 14.16 14.34 15.67 15.15 16.72L15.26 16.85C15.4 16.97 15.57 17 15.73 16.94C15.88 16.88 16 16.73 16 16.57L15.93 16.33C15.05 14 15.79 11.3 17.66 9.77C18.17 9.35 18.8 8.97 19.46 8.8C18.78 10.16 19 11.94 20.09 13C20.55 13.5 21.11 13.79 21.58 14.23L22.14 14.84M19.86 19.5L19.85 19.47C20.3 19.08 20.55 18.41 20.53 17.81L20.5 17.5C20.3 16.5 19.43 16.16 18.87 15.43C18.7 15.21 18.55 14.93 18.44 14.65C18.22 15.15 18.2 15.62 18.29 16.16C18.39 16.73 18.61 17.22 18.5 17.81C18.34 18.46 17.83 19.11 16.94 19.32C17.44 19.81 18.25 20.2 19.06 19.92C19.32 19.85 19.65 19.66 19.86 19.5M9 21V18H2L7 13H4L9 8H6L11 3L16 8H13L14.82 9.82C12.55 11.06 11 13.59 11 16.5C11 18.19 11.5 19.75 12.4 21H9Z";
var mdiPineTreeVariant = "M19 12L12 2L5 12H6.86L3 18H10V22H14V18H21L17.14 12H19Z";
var mdiPineTreeVariantOutline = "M19 12L12 2L5 12H6.86L3 18H10V22H14V18H21L17.14 12H19M15.16 10H13.5L17.34 16H6.67L10.53 10H8.84L12 5.5L15.16 10Z";
var mdiPinterest = "M9.04,21.54C10,21.83 10.97,22 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2A10,10 0 0,0 2,12C2,16.25 4.67,19.9 8.44,21.34C8.35,20.56 8.26,19.27 8.44,18.38L9.59,13.44C9.59,13.44 9.3,12.86 9.3,11.94C9.3,10.56 10.16,9.53 11.14,9.53C12,9.53 12.4,10.16 12.4,10.97C12.4,11.83 11.83,13.06 11.54,14.24C11.37,15.22 12.06,16.08 13.06,16.08C14.84,16.08 16.22,14.18 16.22,11.5C16.22,9.1 14.5,7.46 12.03,7.46C9.21,7.46 7.55,9.56 7.55,11.77C7.55,12.63 7.83,13.5 8.29,14.07C8.38,14.13 8.38,14.21 8.35,14.36L8.06,15.45C8.06,15.62 7.95,15.68 7.78,15.56C6.5,15 5.76,13.18 5.76,11.71C5.76,8.55 8,5.68 12.32,5.68C15.76,5.68 18.44,8.15 18.44,11.43C18.44,14.87 16.31,17.63 13.26,17.63C12.29,17.63 11.34,17.11 11,16.5L10.33,18.87C10.1,19.73 9.47,20.88 9.04,21.57V21.54Z";
var mdiPinwheel = "M12,12C12,9 14.5,6.5 17.5,6.5C20.5,6.5 23,9 23,12H12M12,12C12,15 9.5,17.5 6.5,17.5C3.5,17.5 1,15 1,12H12M12,12C9,12 6.5,9.5 6.5,6.5C6.5,3.5 9,1 12,1V12M12,12C15,12 17.5,14.5 17.5,17.5C17.5,20.5 15,23 12,23V12Z";
var mdiPinwheelOutline = "M12,23H11V16.43C9.93,17.4 8.5,18 7,18C3.75,18 1,15.25 1,12V11H7.57C6.6,9.93 6,8.5 6,7C6,3.75 8.75,1 12,1H13V7.57C14.07,6.6 15.5,6 17,6C20.25,6 23,8.75 23,12V13H16.43C17.4,14.07 18,15.5 18,17C18,20.25 15.25,23 12,23M13,13.13V20.87C14.7,20.41 16,18.83 16,17C16,15.17 14.7,13.59 13,13.13M3.13,13C3.59,14.7 5.17,16 7,16C8.83,16 10.41,14.7 10.87,13H3.13M13.13,11H20.87C20.41,9.3 18.82,8 17,8C15.18,8 13.59,9.3 13.13,11M11,3.13C9.3,3.59 8,5.18 8,7C8,8.82 9.3,10.41 11,10.87V3.13Z";
var mdiPipe = "M22,14H20V16H14V13H16V11H14V6A2,2 0 0,0 12,4H4V2H2V10H4V8H10V11H8V13H10V18A2,2 0 0,0 12,20H20V22H22";
var mdiPipeDisconnected = "M16,9V11H8V9H10V8H4V10H2V2H4V4H12A2,2 0 0,1 14,6V9H16M10,15V18A2,2 0 0,0 12,20H20V22H22V14H20V16H14V15H16V13H8V15H10Z";
var mdiPipeLeak = "M2,5V13H4V11H10L12,9L10,7H4V5H2M20,5V7H12L14,9L12,11H20V13H22V5H20M12,13C12,13 10,15.17 10,16.5A2,2 0 0,0 12,18.5A2,2 0 0,0 14,16.5C14,15.17 12,13 12,13Z";
var mdiPipeValve = "M22 13V21H20V19H16.58C15.81 20.76 14.05 22 12 22S8.19 20.76 7.42 19H4V21H2V13H4V15H7.43C7.93 13.85 8.85 12.93 10 12.42V11H8V9H16V11H14V12.42C15.15 12.93 16.07 13.85 16.57 15H20V13H22M17 2H7C6.45 2 6 2.45 6 3S6.45 4 7 4H10V5H11V8H13V5H14V4H17C17.55 4 18 3.55 18 3S17.55 2 17 2Z";
var mdiPipeWrench = "M16.17 5.63L14.06 7.78L11.91 5.63L16.17 1.41L19.69 4.92C20.86 6.09 20.86 8 19.69 9.19L16.17 5.63M4.83 12.7L7 14.81L10.5 11.3L8.39 9.19L4.83 12.7M15.47 7.78L19 11.3L17.58 12.7L16.88 12L6.23 22.59L3.42 19.78L11.91 11.3L7.69 7.03L9.8 4.92L14.06 9.19L15.47 7.78Z";
var mdiPirate = "M8.2,12.1C7.9,12.3 7.7,12.7 7.8,13C7.8,13.7 8.5,14.2 9.1,14.2C9.7,14.2 10.3,13.7 10.3,13C9.7,12.6 9,12.3 8.2,12.1M22,11L23,7C23,7 21,7 18,5C15,3 15,1 12,1C9,1 9,3 6,5C3,7 1,7 1,7L2,11H2.1C2,11.3 2,11.7 2,12C2,15.5 3.8,18.6 6.5,20.4L6,21.3C12.4,25.4 18,21.3 18,21.3L17.5,20.4C20.2,18.6 22,15.5 22,12C22,11.7 22,11.3 22,11M11.3,4.5L9.9,3.1L10.6,2.4L12,3.8L13.4,2.4L14.1,3.1L12.7,4.5L14.1,5.9L13.4,6.6L12,5.2L10.6,6.6L9.9,5.9L11.3,4.5M9.3,8.5C10.3,8.2 11.3,8 12,8C14.2,8 17.9,9.6 19.8,10.4C19.9,10.7 19.9,11 19.9,11.3L9.3,8.5M13.6,19.1C12.9,19.5 12.2,19.8 11.4,19.9C10.9,19.5 10.9,18.7 11.4,18.3C11.8,17.9 12.7,17.7 13.2,18.2C13.5,18.3 13.6,18.8 13.6,19.1M20,13.4C19.5,15.5 18.2,17.4 16.5,18.6L15,16H9L7.5,18.6C5.4,17.2 4,14.8 4,12C4,11.5 4.1,11 4.2,10.5C4.7,10.3 5.3,10 6,9.7L13.1,11.6V14C13.1,14.5 13.5,15 14.1,15H16.1C16.6,15 17.1,14.6 17.1,14V12.6L20,13.4Z";
var mdiPistol = "M7,5H23V9H22V10H16A1,1 0 0,0 15,11V12A2,2 0 0,1 13,14H9.62C9.24,14 8.89,14.22 8.72,14.56L6.27,19.45C6.1,19.79 5.76,20 5.38,20H2C2,20 -1,20 3,14C3,14 6,10 2,10V5H3L3.5,4H6.5L7,5M14,12V11A1,1 0 0,0 13,10H12C12,10 11,11 12,12A2,2 0 0,1 10,10A1,1 0 0,0 9,11V12A1,1 0 0,0 10,13H13A1,1 0 0,0 14,12Z";
var mdiPiston = "M13,16.18C13.5,16.35 13.9,16.63 14.23,17H15V21H14.21C13.89,21.35 13.5,21.63 13,21.8C11.85,22.22 10.58,21.87 9.78,21H9V17H9.77C10.1,16.63 10.5,16.35 11,16.18V12H13V16.18M12,20A1,1 0 0,0 13,19A1,1 0 0,0 12,18A1,1 0 0,0 11,19A1,1 0 0,0 12,20M17,4H15V5H17V11H7V5H9V4H7V2H17V4M12,9A1,1 0 0,0 13,8A1,1 0 0,0 12,7A1,1 0 0,0 11,8A1,1 0 0,0 12,9Z";
var mdiPitchfork = "M15.9 .9L13.1 3.7C12.3 4.5 12.3 5.7 13.1 6.5L14.5 8L9.2 13.4L7.8 12C7 11.2 5.8 11.2 5 12L1 16L2.4 17.4L6.4 13.4L7.8 14.8L3.8 18.8L5.2 20.2L9.2 16.2L10.6 17.6L9.9 18.4L6.7 21.6L8 23L12 19C12.8 18.2 12.8 17 12 16.2L10.6 14.8L15.9 9.4L17.3 10.8C18.1 11.6 19.3 11.6 20.1 10.8L23 8L15.9 .9M18.7 9.4L14.5 5.2L15.9 3.8L20.1 8L18.7 9.4Z";
var mdiPizza = "M12,15A2,2 0 0,1 10,13C10,11.89 10.9,11 12,11A2,2 0 0,1 14,13A2,2 0 0,1 12,15M7,7C7,5.89 7.89,5 9,5A2,2 0 0,1 11,7A2,2 0 0,1 9,9C7.89,9 7,8.1 7,7M12,2C8.43,2 5.23,3.54 3,6L12,22L21,6C18.78,3.54 15.57,2 12,2Z";
var mdiPlaneCar = "M21.57 12.66C21.43 12.26 21.05 12 20.6 12H13.41C12.95 12 12.58 12.26 12.43 12.66L11 16.77V22.28C11 22.66 11.32 23 11.7 23H12.32C12.7 23 13 22.62 13 22.24V21H21V22.24C21 22.62 21.31 23 21.69 23H22.3C22.68 23 23 22.66 23 22.28V16.77L21.57 12.66M13.41 13H20.6L21.63 16H12.38L13.41 13M13 19C12.45 19 12 18.55 12 18S12.45 17 13 17 14 17.45 14 18 13.55 19 13 19M21 19C20.45 19 20 18.55 20 18S20.45 17 21 17 22 17.45 22 18 21.55 19 21 19M6.66 14.53L7 17L5.95 18.06L4.19 14.88L1 13.11L2.06 12.03L4.56 12.4L8.43 8.53L1 4.62L2.42 3.21L11.61 5.33L15.5 1.44C16.06 .855 17.06 .855 17.62 1.44C18.21 2.03 18.21 3 17.62 3.56L13.73 7.45L14.55 11H13.41C12.54 11 11.79 11.5 11.5 12.31L11.47 12.37L10.56 10.63L6.66 14.53Z";
var mdiPlaneTrain = "M20 8H14C12.34 8 11 9.34 11 11V18C11 19.66 12.34 21 14 21L13 22V23H14L16 20.97H18L20 23H21V22L20 21C21.66 21 23 19.66 23 18V11C23 9.34 21.66 8 20 8M14 19C13.45 19 13 18.55 13 18S13.45 17 14 17 15 17.45 15 18 14.55 19 14 19M20 19C19.45 19 19 18.55 19 18S19.45 17 20 17 21 17.45 21 18 20.55 19 20 19M21 16H13V10H21V16M6.66 14.53L7 17L5.95 18.06L4.19 14.88L1 13.11L2.06 12.03L4.56 12.4L8.43 8.53L1 4.62L2.42 3.21L11.61 5.33L15.5 1.44C16.06 .855 17.06 .855 17.62 1.44C18.21 2.03 18.21 3 17.62 3.56L14.18 7H14C11.79 7 10 8.79 10 11V11.19L6.66 14.53Z";
var mdiPlay = "M8,5.14V19.14L19,12.14L8,5.14Z";
var mdiPlayBox = "M19 3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.89 20.1 3 19 3M10 16V8L15 12";
var mdiPlayBoxEditOutline = "M13 18.9L19.1 12.8L21.2 14.9L15.1 21H13V18.9M21.4 11.3L22.7 12.6C22.9 12.8 22.9 13.1 22.7 13.3L21.7 14.3L19.6 12.3L20.6 11.3C20.7 11.2 20.8 11.1 21 11.1S21.3 11.1 21.4 11.3M11 21H5C4.5 21 4 20.8 3.6 20.4C3.2 20 3 19.5 3 19V5C3 4.5 3.2 4 3.6 3.6C4 3.2 4.5 3 5 3H19C20.1 3 21 3.9 21 5V9H19V5H5V19H11V21M15 12L10 8V16L15 12Z";
var mdiPlayBoxLock = "M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12C20.4 12 21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M13 19V21H4C2.89 21 2 20.1 2 19V5C2 3.89 2.89 3 4 3H18C19.1 3 20 3.89 20 5V10.1L19 10L18 10.1C15.79 10.55 14.12 12.45 14 14.76C13.39 15.31 13 16.11 13 17V19M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2C18.2 13.2 17.5 13.7 17.5 14.5V16H20.5V14.5M9 8V16L14 12L9 8Z";
var mdiPlayBoxLockOpen = "M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V13.5C16.2 12.1 17.6 11 19 11C20.4 11 21.8 12.1 21.8 13.5V14H20.5V13.5C20.5 12.7 19.8 12.2 19 12.2C18.2 12.2 17.5 12.7 17.5 13.5V16H21.8C22.4 16 23 16.6 23 17.3M9 8V16L14 12L9 8M13 19V21H4C2.89 21 2 20.1 2 19V5C2 3.89 2.89 3 4 3H18C19.1 3 20 3.89 20 5V9.1L19 9C16.24 9 14 11.24 14 14V14.76C13.39 15.31 13 16.11 13 17V19Z";
var mdiPlayBoxLockOpenOutline = "M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V13.5C16.2 12.1 17.6 11 19 11C20.4 11 21.8 12.1 21.8 13.5V14H20.5V13.5C20.5 12.7 19.8 12.2 19 12.2C18.2 12.2 17.5 12.7 17.5 13.5V16H21.8C22.4 16 23 16.6 23 17.3M18 5H4V19H13V21H4C2.89 21 2 20.1 2 19V5C2 3.89 2.89 3 4 3H18C19.1 3 20 3.89 20 5V9.1L19 9L18 9.1V5M9 8L14 12L9 16V8Z";
var mdiPlayBoxLockOutline = "M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12C20.4 12 21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2C18.2 13.2 17.5 13.7 17.5 14.5V16H20.5V14.5M18 5H4V19H13V21H4C2.89 21 2 20.1 2 19V5C2 3.89 2.89 3 4 3H18C19.1 3 20 3.89 20 5V10.1L19 10L18 10.1V5M9 8L14 12L9 16V8Z";
var mdiPlayBoxMultiple = "M4,6H2V20A2,2 0 0,0 4,22H18V20H4V6M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M12,14.5V5.5L18,10L12,14.5Z";
var mdiPlayBoxMultipleOutline = "M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6M20 4V16H8V4H20M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M12 14.5V5.5L18 10L12 14.5Z";
var mdiPlayBoxOutline = "M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M10,8V16L15,12L10,8Z";
var mdiPlayCircle = "M10,16.5V7.5L16,12M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiPlayCircleOutline = "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M10,16.5L16,12L10,7.5V16.5Z";
var mdiPlayNetwork = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M10,14V6L15,10L10,14Z";
var mdiPlayNetworkOutline = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M7,15V5H17V15H7M10,14V6L15,10L10,14Z";
var mdiPlayOutline = "M8.5,8.64L13.77,12L8.5,15.36V8.64M6.5,5V19L17.5,12";
var mdiPlayPause = "M3,5V19L11,12M13,19H16V5H13M18,5V19H21V5";
var mdiPlayProtectedContent = "M2,5V18H11V16H4V7H17V11H19V5H2M9,9V14L12.5,11.5L9,9M21.04,11.67L16.09,16.62L13.96,14.5L12.55,15.91L16.09,19.45L22.45,13.09L21.04,11.67Z";
var mdiPlaySpeed = "M13,2.05V4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03V2.05M5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37L5.67,19.74M7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74M5.69,7.1L4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1M4.06,13H2.06C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13M10,16.5L16,12L10,7.5V16.5Z";
var mdiPlaylistCheck = "M14 10H3V12H14V10M14 6H3V8H14V6M3 16H10V14H3V16M21.5 11.5L23 13L16 20L11.5 15.5L13 14L16 17L21.5 11.5Z";
var mdiPlaylistEdit = "M3 6V8H14V6H3M3 10V12H14V10H3M20 10.1C19.9 10.1 19.7 10.2 19.6 10.3L18.6 11.3L20.7 13.4L21.7 12.4C21.9 12.2 21.9 11.8 21.7 11.6L20.4 10.3C20.3 10.2 20.2 10.1 20 10.1M18.1 11.9L12 17.9V20H14.1L20.2 13.9L18.1 11.9M3 14V16H10V14H3Z";
var mdiPlaylistMinus = "M3 16H10V14H3M12 14V16H22V14M14 6H3V8H14M14 10H3V12H14V10Z";
var mdiPlaylistMusic = "M15,6H3V8H15V6M15,10H3V12H15V10M3,16H11V14H3V16M17,6V14.18C16.69,14.07 16.35,14 16,14A3,3 0 0,0 13,17A3,3 0 0,0 16,20A3,3 0 0,0 19,17V8H22V6H17Z";
var mdiPlaylistMusicOutline = "M15,6V8H3V6H15M15,10V12H3V10H15M3,16V14H11V16H3M17,6H22V8H19V17A3,3 0 0,1 16,20A3,3 0 0,1 13,17A3,3 0 0,1 16,14C16.35,14 16.69,14.07 17,14.18V6M16,16A1,1 0 0,0 15,17A1,1 0 0,0 16,18A1,1 0 0,0 17,17A1,1 0 0,0 16,16Z";
var mdiPlaylistPlay = "M3 10H14V12H3V10M3 6H14V8H3V6M3 14H10V16H3V14M16 13V21L22 17L16 13Z";
var mdiPlaylistPlus = "M3 16H10V14H3M18 14V10H16V14H12V16H16V20H18V16H22V14M14 6H3V8H14M14 10H3V12H14V10Z";
var mdiPlaylistRemove = "M14 10H3V12H14V10M14 6H3V8H14V6M3 16H10V14H3V16M14.4 22L17 19.4L19.6 22L21 20.6L18.4 18L21 15.4L19.6 14L17 16.6L14.4 14L13 15.4L15.6 18L13 20.6L14.4 22Z";
var mdiPlaylistStar = "M17 19.1L19.5 20.6L18.8 17.8L21 15.9L18.1 15.7L17 13L15.9 15.6L13 15.9L15.2 17.8L14.5 20.6L17 19.1M3 14H11V16H3V14M3 6H15V8H3V6M3 10H15V12H3V10Z";
var mdiPlex = "M4,2C2.89,2 2,2.89 2,4V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V4C22,2.89 21.11,2 20,2H4M8.56,6H12.06L15.5,12L12.06,18H8.56L12,12L8.56,6Z";
var mdiPliers = "M9.4 12.2C9.4 12.2 11.7 15.3 13.8 17.4C14.7 18.3 15.6 18.9 16.3 19.4C17.1 19.9 17.3 21 16.6 21.7C16.2 22.1 15.5 22.3 15 22C14.2 21.6 13 20.8 11.7 19.6C9.6 17.5 7.3 14.4 7.3 14.4L9.4 12.2M12.2 9.4C12.2 9.4 15.3 11.7 17.4 13.8C18.3 14.7 18.9 15.6 19.4 16.3C19.9 17.1 21 17.3 21.7 16.6C22.1 16.2 22.3 15.5 22 15C21.6 14.2 20.8 13 19.6 11.7C17.5 9.6 14.4 7.3 14.4 7.3L12.2 9.4M10.4 5.5L7.6 2.7L4.1 2L3.6 2.5L5.9 4.8C6.4 4.7 6.9 4.8 7.3 5.2C7.9 5.8 7.9 6.7 7.3 7.3S5.8 7.9 5.2 7.3C4.8 6.9 4.7 6.3 4.8 5.8L2.5 3.6L2 4.1L2.7 7.6L5.5 10.4L6.9 13.2L8.8 11.3L7.8 9.5L9.4 7.9L11.3 8.8L13.2 6.9L10.4 5.5Z";
var mdiPlus = "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z";
var mdiPlusBox = "M17,13H13V17H11V13H7V11H11V7H13V11H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiPlusBoxMultiple = "M19,11H15V15H13V11H9V9H13V5H15V9H19M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M4,6H2V20A2,2 0 0,0 4,22H18V20H4V6Z";
var mdiPlusBoxMultipleOutline = "M18 11H15V14H13V11H10V9H13V6H15V9H18M20 4V16H8V4H20M20 2H8C6.9 2 6 2.9 6 4V16C6 17.11 6.9 18 8 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M4 6H2V20C2 21.11 2.9 22 4 22H18V20H4V6Z";
var mdiPlusBoxOutline = "M19,19V5H5V19H19M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5C3,3.89 3.9,3 5,3H19M11,7H13V11H17V13H13V17H11V13H7V11H11V7Z";
var mdiPlusCircle = "M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiPlusCircleMultiple = "M2 12C2 9.2 3.6 6.8 6 5.7V3.5C2.5 4.8 0 8.1 0 12S2.5 19.2 6 20.5V18.3C3.6 17.2 2 14.8 2 12M15 3C10 3 6 7 6 12S10 21 15 21 24 17 24 12 20 3 15 3M20 13H16V17H14V13H10V11H14V7H16V11H20V13Z";
var mdiPlusCircleMultipleOutline = "M16,8H14V11H11V13H14V16H16V13H19V11H16M2,12C2,9.21 3.64,6.8 6,5.68V3.5C2.5,4.76 0,8.09 0,12C0,15.91 2.5,19.24 6,20.5V18.32C3.64,17.2 2,14.79 2,12M15,3C10.04,3 6,7.04 6,12C6,16.96 10.04,21 15,21C19.96,21 24,16.96 24,12C24,7.04 19.96,3 15,3M15,19C11.14,19 8,15.86 8,12C8,8.14 11.14,5 15,5C18.86,5 22,8.14 22,12C22,15.86 18.86,19 15,19Z";
var mdiPlusCircleOutline = "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z";
var mdiPlusLock = "M21.14 17.67V17.22C21.14 16 20.2 15 19 15S16.86 16 16.86 17.22V17.67C16.34 17.67 16 18 16 18.56V22.11C16 22.65 16.34 23 16.86 23H21.14C21.66 23 22 22.65 22 22.11V18.55C22 18 21.66 17.67 21.14 17.67M20.29 17.67H17.72V17.22C17.72 16.5 18.31 15.89 19 15.89C19.69 15.89 20.29 16.5 20.29 17.22V17.67M11 5V11H5V13H11V19H13V13H19V11H13V5H11Z";
var mdiPlusLockOpen = "M11 5V11H5V13H11V19H13V13H19V11H13V5H11M19 15C17.95 15 16.9 15.8 16.9 16.82V18.64C16.45 18.64 16 19.07 16 19.5V22.05C16 22.56 16.45 23 16.9 23H21.03C21.55 23 22 22.56 22 22.13V19.58C22 19.07 21.55 18.64 21.1 18.64H17.88V16.82C17.88 16.24 18.4 15.87 19 15.87S20.13 16.24 20.13 16.82V17.18H21.1V16.82C21.1 15.8 20.05 15 19 15Z";
var mdiPlusMinus = "M11,4V9H6V11H11V16H13V11H18V9H13V4H11M6,18V20H18V18H6Z";
var mdiPlusMinusBox = "M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5M11,6H13V9H16V11H13V14H11V11H8V9H11V6M8,16H16V18H8V16Z";
var mdiPlusMinusVariant = "M3 7H6V4H8V7H11V9H8V12H6V9H3V7M13 15H21V17H13V15M16.04 3H18.35L7.96 21H5.65L16.04 3Z";
var mdiPlusNetwork = "M16,11V9H13V6H11V9H8V11H11V14H13V11H16M17,3A2,2 0 0,1 19,5V15A2,2 0 0,1 17,17H13V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H7C5.89,17 5,16.1 5,15V5A2,2 0 0,1 7,3H17Z";
var mdiPlusNetworkOutline = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M7,15V5H17V15H7M15,11H13V13H11V11H9V9H11V7H13V9H15V11Z";
var mdiPlusOutline = "M4,9H9V4H15V9H20V15H15V20H9V15H4V9M11,13V18H13V13H18V11H13V6H11V11H6V13H11Z";
var mdiPlusThick = "M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z";
var mdiPocket = "M4 3H20V17.63L12 22.25L4 17.63V3M18 9H6V16.5L12 19.94L18 16.5V9M18 5H6V7H18V5Z";
var mdiPodcast = "M17,18.25V21.5H7V18.25C7,16.87 9.24,15.75 12,15.75C14.76,15.75 17,16.87 17,18.25M12,5.5A6.5,6.5 0 0,1 18.5,12C18.5,13.25 18.15,14.42 17.54,15.41L16,14.04C16.32,13.43 16.5,12.73 16.5,12C16.5,9.5 14.5,7.5 12,7.5C9.5,7.5 7.5,9.5 7.5,12C7.5,12.73 7.68,13.43 8,14.04L6.46,15.41C5.85,14.42 5.5,13.25 5.5,12A6.5,6.5 0 0,1 12,5.5M12,1.5A10.5,10.5 0 0,1 22.5,12C22.5,14.28 21.77,16.39 20.54,18.11L19.04,16.76C19.96,15.4 20.5,13.76 20.5,12A8.5,8.5 0 0,0 12,3.5A8.5,8.5 0 0,0 3.5,12C3.5,13.76 4.04,15.4 4.96,16.76L3.46,18.11C2.23,16.39 1.5,14.28 1.5,12A10.5,10.5 0 0,1 12,1.5M12,9.5A2.5,2.5 0 0,1 14.5,12A2.5,2.5 0 0,1 12,14.5A2.5,2.5 0 0,1 9.5,12A2.5,2.5 0 0,1 12,9.5Z";
var mdiPodium = "M12,7.09L14.45,8.58L13.8,5.77L16,3.89L13.11,3.64L12,1L10.87,3.64L8,3.89L10.18,5.77L9.5,8.58L12,7.09M4,13.09L6.45,14.58L5.8,11.77L8,9.89L5.11,9.64L4,7L2.87,9.64L0,9.89L2.18,11.77L1.5,14.58L4,13.09M20,10.09L22.45,11.58L21.8,8.77L24,6.89L21.11,6.64L20,4L18.87,6.64L16,6.89L18.18,8.77L17.5,11.58L20,10.09M15,23H9V10H15V23M7,23H1V17H7V23M23,23H17V13H23V23Z";
var mdiPodiumBronze = "M4,13.09L6.45,14.58L5.8,11.77L8,9.89L5.11,9.64L4,7L2.87,9.64L0,9.89L2.18,11.77L1.5,14.58L4,13.09M7,23H1V17H7V23M9,10V23H15V10H9M13,21H11V12H13V21M17,13V23H23V13H17M21,21H19V15H21V21Z";
var mdiPodiumGold = "M12,7.09L14.45,8.58L13.8,5.77L16,3.89L13.11,3.64L12,1L10.87,3.64L8,3.89L10.18,5.77L9.5,8.58L12,7.09M15,23H9V10H15V23M1,17V23H7V17H1M5,21H3V19H5V21M17,13V23H23V13H17M21,21H19V15H21V21Z";
var mdiPodiumSilver = "M20,10.09L22.45,11.58L21.8,8.77L24,6.89L21.11,6.64L20,4L18.87,6.64L16,6.89L18.18,8.77L17.5,11.58L20,10.09M23,23H17V13H23V23M1,17V23H7V17H1M5,21H3V19H5V21M9,10V23H15V10H9M13,21H11V12H13V21Z";
var mdiPointOfSale = "M20,5C19.4,5 19,5.5 19,6.1V16C19,16.6 19.4,17 20,17.1C20.6,17.1 21,16.6 21,16V6.1C21,5.5 20.6,5 20,5M16.4,2H4.6C3.7,2 3,2.7 3,3.6V17.4C3,18.3 3.7,19 4.6,19H6V21C6,21.6 6.4,22 7,22H13C13.6,22 14,21.6 14,21V19H16.4C17.3,19 18,18.3 18,17.4V3.6C18,2.7 17.3,2 16.4,2M5,8H8V10H5V8M12,11V13H9V11H12M9,10V8H12V10H9M12,14V16H9V14H12M5,11H8V13H5V11M5,16V14H8V16H5M8,21H7V19H8V21M13,21H10V19H13V21M16,16H13V14H16V16M16,13H13V11H16V13M16,10H13V8H16V10M16,6H5V4H16V6Z";
var mdiPokeball = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4C7.92,4 4.55,7.05 4.06,11H8.13C8.57,9.27 10.14,8 12,8C13.86,8 15.43,9.27 15.87,11H19.94C19.45,7.05 16.08,4 12,4M12,20C16.08,20 19.45,16.95 19.94,13H15.87C15.43,14.73 13.86,16 12,16C10.14,16 8.57,14.73 8.13,13H4.06C4.55,16.95 7.92,20 12,20M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z";
var mdiPokemonGo = "M12,2A7,7 0 0,1 19,9C19,10.4 18.59,11.71 17.88,12.8L12,22.21L6.12,12.8C5.41,11.71 5,10.4 5,9A7,7 0 0,1 12,2M12,3.5C9.3,3.5 7.06,5.44 6.59,8H9.17C9.58,6.83 10.69,6 12,6C13.31,6 14.42,6.83 14.83,8H17.41C16.94,5.44 14.7,3.5 12,3.5M12,12C10.69,12 9.58,11.17 9.17,10H6.59C6.72,10.69 6.97,11.34 7.34,11.91V11.91L7.38,12C8.36,13.5 10.06,14.5 12,14.5C13.94,14.5 15.64,13.5 16.62,12L16.66,11.91V11.91C17.03,11.34 17.28,10.69 17.41,10H14.83C14.42,11.17 13.31,12 12,12M12,7.5A1.5,1.5 0 0,0 10.5,9A1.5,1.5 0 0,0 12,10.5A1.5,1.5 0 0,0 13.5,9A1.5,1.5 0 0,0 12,7.5Z";
var mdiPokerChip = "M23,12C23,18.08 18.08,23 12,23C5.92,23 1,18.08 1,12C1,5.92 5.92,1 12,1C18.08,1 23,5.92 23,12M13,4.06C15.13,4.33 17.07,5.45 18.37,7.16L20.11,6.16C18.45,3.82 15.86,2.3 13,2V4.06M3.89,6.16L5.63,7.16C6.93,5.45 8.87,4.33 11,4.06V2C8.14,2.3 5.55,3.82 3.89,6.16M2.89,16.1L4.62,15.1C3.79,13.12 3.79,10.88 4.62,8.9L2.89,7.9C1.7,10.5 1.7,13.5 2.89,16.1M11,19.94C8.87,19.67 6.93,18.55 5.63,16.84L3.89,17.84C5.55,20.18 8.14,21.7 11,22V19.94M20.11,17.84L18.37,16.84C17.07,18.55 15.13,19.67 13,19.94V21.94C15.85,21.65 18.44,20.16 20.11,17.84M21.11,16.1C22.3,13.5 22.3,10.5 21.11,7.9L19.38,8.9C20.21,10.88 20.21,13.12 19.38,15.1L21.11,16.1M15,12L12,7L9,12L12,17L15,12Z";
var mdiPolaroid = "M6,3H18A2,2 0 0,1 20,5V19A2,2 0 0,1 18,21H6A2,2 0 0,1 4,19V5A2,2 0 0,1 6,3M6,5V17H18V5H6Z";
var mdiPoliceBadge = "M22 4L20 2C18.85 2.64 17.4 3 16 3C14.6 3 13.14 2.63 12 2C10.86 2.63 9.4 3 8 3C6.6 3 5.15 2.64 4 2L2 4C2 4 4 6 4 8S2 14 2 16C2 20 12 22 12 22S22 20 22 16C22 14 20 10 20 8S22 4 22 4M15.05 16.45L11.97 14.59L8.9 16.45L9.72 12.95L7 10.61L10.58 10.3L11.97 7L13.37 10.29L16.95 10.6L14.23 12.94L15.05 16.45Z";
var mdiPoliceBadgeOutline = "M12 4.21C13.24 4.72 14.65 5 16 5C17.05 5 18.1 4.84 19.08 4.54C18.5 5.5 18 6.71 18 8C18 9.32 18.54 10.93 19.1 12.63C19.5 13.83 20 15.33 20 16C20 17.03 16.47 19 12 19.96C7.54 19 4 17.03 4 16C4 15.33 4.5 13.83 4.9 12.63C5.46 10.93 6 9.32 6 8C6 6.71 5.5 5.5 4.92 4.54C5.9 4.84 6.96 5 8 5C9.35 5 10.76 4.72 12 4.21M20 2C18.85 2.64 17.4 3 16 3C14.6 3 13.14 2.63 12 2C10.86 2.63 9.4 3 8 3C6.6 3 5.15 2.64 4 2L2 4C2 4 4 6 4 8S2 14 2 16C2 20 12 22 12 22S22 20 22 16C22 14 20 10 20 8S22 4 22 4L20 2M15.05 16.45L11.97 14.59L8.9 16.45L9.72 12.95L7 10.61L10.58 10.3L11.97 7L13.37 10.29L16.95 10.6L14.23 12.94L15.05 16.45";
var mdiPoliceStation = "M12 10C12 10 16 9.2 16 7.6C16 6.8 15.2 5.2 15.2 4.4C15.2 3.6 16 2.8 16 2.8L15.2 2C14.74 2.26 14.16 2.4 13.6 2.4S12.46 2.25 12 2C11.54 2.25 10.96 2.4 10.4 2.4C9.84 2.4 9.26 2.26 8.8 2L8 2.8C8 2.8 8.8 3.6 8.8 4.4C8.8 5.2 8 6.8 8 7.6C8 9.2 12 10 12 10M11.43 5.32L12 4L12.55 5.32L14 5.44L12.89 6.38L13.22 7.78L12 7.04L10.76 7.78L11.09 6.38L10 5.44L11.43 5.32M21 6H16.65C16.84 6.58 17 7.12 17 7.6C17 9.85 13.32 10.76 12.2 11L12 11L11.8 11C10.68 10.76 7 9.85 7 7.6C7 7.12 7.16 6.58 7.35 6H3C2.45 6 2 6.45 2 7V22H10V17H14V22H22V7C22 6.45 21.55 6 21 6M8 20H4V17H8V20M8 15H4V12H8V15M14 15H10V12H14V15M20 20H16V17H20V20M20 15H16V12H20V15Z";
var mdiPoll = "M3,22V8H7V22H3M10,22V2H14V22H10M17,22V14H21V22H17Z";
var mdiPolo = "M22 9.5C22 10.88 20.88 12 19.5 12S17 10.88 17 9.5 18.12 7 19.5 7 22 8.12 22 9.5M11 17V3H8V17H2L6 21H13V17H11M16 17H14V21H16V17Z";
var mdiPolymer = "M19,4H15L7.1,16.63L4.5,12L9,4H5L0.5,12L5,20H9L16.89,7.37L19.5,12L15,20H19L23.5,12L19,4Z";
var mdiPool = "M2,15C3.67,14.25 5.33,13.5 7,13.17V5A3,3 0 0,1 10,2C11.31,2 12.42,2.83 12.83,4H10A1,1 0 0,0 9,5V6H14V5A3,3 0 0,1 17,2C18.31,2 19.42,2.83 19.83,4H17A1,1 0 0,0 16,5V14.94C18,14.62 20,13 22,13V15C19.78,15 17.56,17 15.33,17C13.11,17 10.89,15 8.67,15C6.44,15 4.22,16 2,17V15M14,8H9V10H14V8M14,12H9V13C10.67,13.16 12.33,14.31 14,14.79V12M2,19C4.22,18 6.44,17 8.67,17C10.89,17 13.11,19 15.33,19C17.56,19 19.78,17 22,17V19C19.78,19 17.56,21 15.33,21C13.11,21 10.89,19 8.67,19C6.44,19 4.22,20 2,21V19Z";
var mdiPoolThermometer = "M19 6C17.9 6 17 6.9 17 8V14.8C16.4 15.4 16 16.2 16 17C16 18.7 17.3 20 19 20S22 18.7 22 17C22 16.1 21.6 15.3 21 14.8V8C21 6.9 20.1 6 19 6M19 7C19.5 7 20 7.4 20 8V9H18V8C18 7.4 18.5 7 19 7M15 20.3C14.1 20.7 13.2 21 12.3 21C10.1 21 7.9 19 5.6 19C4.4 19 3.2 19.3 1.9 19.7V17.7C3.2 17.3 4.4 17 5.7 17C7.9 17 10.1 19 12.4 19C13.3 19 14.2 18.7 15.1 18.3V20.3M12.3 17C13.2 17 14.1 16.7 15 16.3V14.3C14.3 14.6 13.7 14.8 13 15V5C13 4.4 13.4 4 14 4H16.8C16.4 2.8 15.3 2 14 2C12.3 2 11 3.3 11 5V6H6V5C6 4.4 6.4 4 7 4H9.8C9.4 2.8 8.3 2 7 2C5.3 2 4 3.3 4 5V13.2C3.3 13.3 2.7 13.5 2 13.8V15.8C3.2 15.3 4.4 15 5.7 15C7.9 15 10.1 17 12.3 17M6 8H11V10H6V8M6 12H11V14.8C9.3 14.3 7.7 13.2 6 13V12Z";
var mdiPopcorn = "M7,22H4.75C4.75,22 4,22 3.81,20.65L2.04,3.81L2,3.5C2,2.67 2.9,2 4,2C5.1,2 6,2.67 6,3.5C6,2.67 6.9,2 8,2C9.1,2 10,2.67 10,3.5C10,2.67 10.9,2 12,2C13.09,2 14,2.66 14,3.5V3.5C14,2.67 14.9,2 16,2C17.1,2 18,2.67 18,3.5C18,2.67 18.9,2 20,2C21.1,2 22,2.67 22,3.5L21.96,3.81L20.19,20.65C20,22 19.25,22 19.25,22H17L16.5,22H13.75L10.25,22H7.5L7,22M17.85,4.93C17.55,4.39 16.84,4 16,4C15.19,4 14.36,4.36 14,4.87L13.78,20H16.66L17.85,4.93M10,4.87C9.64,4.36 8.81,4 8,4C7.16,4 6.45,4.39 6.15,4.93L7.34,20H10.22L10,4.87Z";
var mdiPost = "M3 3V21H21V3H3M18 18H6V17H18V18M18 16H6V15H18V16M18 12H6V6H18V12Z";
var mdiPostLamp = "M14 3L13 1H11L10 3L5 6H7L8 14L10 16L10.5 17H9V23H15V17H13.5L14 16L16 14L17 6H19L14 3M14.16 13H9.84L9 6H15L14.16 13Z";
var mdiPostOutline = "M19 5V19H5V5H19M21 3H3V21H21V3M17 17H7V16H17V17M17 15H7V14H17V15M17 12H7V7H17V12Z";
var mdiPostageStamp = "M2,2V5.5C3.1,5.5 4,6.62 4,8C4,9.38 3.1,10.5 2,10.5V13.5C3.1,13.5 4,14.62 4,16C4,17.38 3.1,18.5 2,18.5V22H5.5C5.5,20.9 6.62,20 8,20C9.38,20 10.5,20.9 10.5,22H13.5C13.5,20.9 14.62,20 16,20C17.38,20 18.5,20.9 18.5,22H22V18.5C20.9,18.5 20,17.38 20,16V16C20,14.62 20.9,13.5 22,13.5V10.5C20.9,10.5 20,9.38 20,8V8C20,6.62 20.9,5.5 22,5.5V2H18.5C18.5,3.1 17.38,4 16,4C14.62,4 13.5,3.1 13.5,2H10.5C10.5,3.1 9.38,4 8,4C6.62,4 5.5,3.1 5.5,2H2M6,6H18V18H6V6M9,7A2,2 0 0,0 7,9A2,2 0 0,0 9,11A2,2 0 0,0 11,9A2,2 0 0,0 9,7M17,10L14,13L12,12L7,17H17V10Z";
var mdiPot = "M19 19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V12H3V10H21V12H19V19Z";
var mdiPotMix = "M14.6 9L18 3.1L19.7 4.1L16.9 9H14.6M14 10H3V12H5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V12H21V10H14Z";
var mdiPotMixOutline = "M14.6 9L18 3.1L19.7 4.1L16.9 9H14.6M16.3 10H21V12H19V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V12H3V10H16.3M17 12H7V19H17V12Z";
var mdiPotOutline = "M3 10V12H5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V12H21V10H3M7 12H17V19H7V12Z";
var mdiPotSteam = "M19 19C19 20.11 18.11 21 17 21H7C5.9 21 5 20.11 5 19V12H3V10H21V12H19M8 1.5C6.15 1.5 4.65 3 4.65 4.85C4.65 6.7 6.15 8.2 8 8.2H9.53C9.92 8.2 10.29 8.3 10.61 8.5H12.63C12.05 7.45 10.86 6.75 9.53 6.75H8C7 6.75 6.15 5.77 6.15 4.75C6.15 3.73 7 3 8 3M12.85 2C12.85 3 12 3.85 11 3.85V5.35C12.92 5.35 14.5 6.7 14.89 8.5H16.42C16.12 6.67 14.96 5.15 13.35 4.38C13.97 3.77 14.35 2.93 14.35 2Z";
var mdiPotSteamOutline = "M8 1.5C6.15 1.5 4.65 3 4.65 4.85C4.65 6.7 6.15 8.2 8 8.2H9.53C9.92 8.2 10.29 8.3 10.61 8.5H12.63C12.05 7.45 10.86 6.75 9.53 6.75H8C7 6.75 6.15 5.77 6.15 4.75C6.15 3.73 7 3 8 3V1.5M12.85 2C12.85 3 12 3.85 11 3.85V5.35C12.92 5.35 14.5 6.7 14.89 8.5H16.42C16.12 6.67 14.96 5.15 13.35 4.38C13.97 3.77 14.35 2.93 14.35 2H12.85M3 10V12H5V19C5 20.11 5.9 21 7 21H17C18.11 21 19 20.11 19 19V12H21V10H3M7 12H17V19H7V12Z";
var mdiPound = "M5.41,21L6.12,17H2.12L2.47,15H6.47L7.53,9H3.53L3.88,7H7.88L8.59,3H10.59L9.88,7H15.88L16.59,3H18.59L17.88,7H21.88L21.53,9H17.53L16.47,15H20.47L20.12,17H16.12L15.41,21H13.41L14.12,17H8.12L7.41,21H5.41M9.53,9L8.47,15H14.47L15.53,9H9.53Z";
var mdiPoundBox = "M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M7,18H9L9.35,16H13.35L13,18H15L15.35,16H17.35L17.71,14H15.71L16.41,10H18.41L18.76,8H16.76L17.12,6H15.12L14.76,8H10.76L11.12,6H9.12L8.76,8H6.76L6.41,10H8.41L7.71,14H5.71L5.35,16H7.35L7,18M10.41,10H14.41L13.71,14H9.71L10.41,10Z";
var mdiPoundBoxOutline = "M19 19H5V5H19M19 3H5A2 2 0 0 0 3 5V19A2 2 0 0 0 5 21H19A2 2 0 0 0 21 19V5A2 2 0 0 0 19 3M7 9H9.31L9.63 6H11.63L11.31 9H13.31L13.63 6H15.63L15.31 9H17V11H15.1L14.9 13H17V15H14.69L14.37 18H12.37L12.69 15H10.69L10.37 18H8.37L8.69 15H7V13H8.9L9.1 11H7V9M11.1 11L10.9 13H12.9L13.1 11Z";
var mdiPower = "M16.56,5.44L15.11,6.89C16.84,7.94 18,9.83 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12C6,9.83 7.16,7.94 8.88,6.88L7.44,5.44C5.36,6.88 4,9.28 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12C20,9.28 18.64,6.88 16.56,5.44M13,3H11V13H13";
var mdiPowerCycle = "M12,3A9,9 0 0,0 3,12A9,9 0 0,0 12,21A9,9 0 0,0 21,12A9,9 0 0,0 12,3M12,19A7,7 0 0,1 5,12A7,7 0 0,1 12,5A7,7 0 0,1 19,12A7,7 0 0,1 12,19M13,17H11V7H13V17Z";
var mdiPowerOff = "M12,3A9,9 0 0,0 3,12A9,9 0 0,0 12,21A9,9 0 0,0 21,12A9,9 0 0,0 12,3M12,19A7,7 0 0,1 5,12A7,7 0 0,1 12,5A7,7 0 0,1 19,12A7,7 0 0,1 12,19Z";
var mdiPowerOn = "M11,3H13V21H11V3Z";
var mdiPowerPlug = "M16,7V3H14V7H10V3H8V7H8C7,7 6,8 6,9V14.5L9.5,18V21H14.5V18L18,14.5V9C18,8 17,7 16,7Z";
var mdiPowerPlugBattery = "M12 10C12 9.35 11.57 8.7 11 8.32C10.7 8.12 10.35 8 10 8V4H8V8H4V4H2V8C1 8 0 9 0 10V15.5L3.5 19V22H8.5V19L12 15.5V10M12.33 4C12.22 4 12.11 4 12 4.04V6.59C12.3 6.77 12.56 7 12.79 7.21C13.44 7.87 14 8.85 14 10V16.33L11 19.33V20.67C11 21.4 11.6 22 12.33 22H21.67C22 22 22.36 21.86 22.61 21.61C22.86 21.36 23 21 23 20.67V5.33C23 4.6 22.4 4 21.67 4H20V2H14V4H12.33Z";
var mdiPowerPlugBatteryOutline = "M11 8.32C11.57 8.7 12 9.35 12 10V15.5L8.5 19V22H3.5V19L0 15.5V10C0 9 1 8 2 8V4H4V8H8V4H10V8C10.35 8 10.7 8.12 11 8.32M7.09 17.59L10 14.67V10.09C10 10.06 9.95 10 9.92 10H2.09C2.06 10 2 10.06 2 10.09V14.67L5.33 18H6.67L7.09 17.59M12 4.04C12.11 4 12.22 4 12.33 4H14V2H20V4H21.67C22.4 4 23 4.6 23 5.33V20.67C23 21 22.86 21.36 22.61 21.61C22.36 21.86 22 22 21.67 22H12.33C11.6 22 11 21.4 11 20.67V19.33L13 17.33V20H21V6H12V4.04Z";
var mdiPowerPlugOff = "M20.84 22.73L15.31 17.2L14.5 18V21H9.5V18L6 14.5V9C6 8.7 6.1 8.41 6.25 8.14L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M18 14.5V9C18 8 17 7 16 7V3H14V7H10.2L17.85 14.65L18 14.5M10 3H8V4.8L10 6.8V3Z";
var mdiPowerPlugOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L6.25 8.14C6.1 8.41 6 8.7 6 9V14.5L9.5 18V21H14.5V18L15.31 17.2L20.84 22.73L22.11 21.46M13.09 16.59L12.67 17H11.33L10.92 16.59L8 13.67V9.89L13.89 15.78L13.09 16.59M12.2 9L10.2 7H14V3H16V7C17 7 18 8 18 9V14.5L17.85 14.65L16 12.8V9.09C16 9.06 15.95 9 15.92 9H12.2M10 6.8L8 4.8V3H10V6.8Z";
var mdiPowerPlugOutline = "M16 7V3H14V7H10V3H8V7C7 7 6 8 6 9V14.5L9.5 18V21H14.5V18L18 14.5V9C18 8 17 7 16 7M16 13.67L13.09 16.59L12.67 17H11.33L10.92 16.59L8 13.67V9.09C8 9.06 8.06 9 8.09 9H15.92C15.95 9 16 9.06 16 9.09V13.67Z";
var mdiPowerSettings = "M15,24H17V22H15M16.56,4.44L15.11,5.89C16.84,6.94 18,8.83 18,11A6,6 0 0,1 12,17A6,6 0 0,1 6,11C6,8.83 7.16,6.94 8.88,5.88L7.44,4.44C5.36,5.88 4,8.28 4,11A8,8 0 0,0 12,19A8,8 0 0,0 20,11C20,8.28 18.64,5.88 16.56,4.44M13,2H11V12H13M11,24H13V22H11M7,24H9V22H7V24Z";
var mdiPowerSleep = "M18.73,18C15.4,21.69 9.71,22 6,18.64C2.33,15.31 2.04,9.62 5.37,5.93C6.9,4.25 9,3.2 11.27,3C7.96,6.7 8.27,12.39 12,15.71C13.63,17.19 15.78,18 18,18C18.25,18 18.5,18 18.73,18Z";
var mdiPowerSocket = "M15,15H17V11H15M7,15H9V11H7M11,13H13V9H11M8.83,7H15.2L19,10.8V17H5V10.8M8,5L3,10V19H21V10L16,5H8Z";
var mdiPowerSocketAu = "M4.22,2A2.22,2.22 0 0,0 2,4.22V19.78C2,21 3,22 4.22,22H19.78A2.22,2.22 0 0,0 22,19.78V4.22C22,3 21,2 19.78,2H4.22M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M8.27,7.54L6.27,11L8,12L10,8.54L8.27,7.54M15.73,7.54L14,8.54L16,12L17.73,11L15.73,7.54M11,14V18H13V14H11Z";
var mdiPowerSocketCh = "M19.78 2H4.22C3 2 2 3 2 4.22V19.78C2 21 3 22 4.22 22H19.78C21 22 22 21 22 19.78V4.22C22 3 21 2 19.78 2M20 13L16.55 16.45C16.19 16.81 15.75 17 15.3 17H8.7C8.25 17 7.81 16.81 7.45 16.45L4 13C3.5 12.5 3.5 11.5 4 11L7.45 7.55C7.81 7.19 8.25 7 8.7 7H15.3C15.75 7 16.19 7.19 16.55 7.55L20 11C20.5 11.5 20.5 12.5 20 13M10.5 14C10.5 13.17 11.17 12.5 12 12.5S13.5 13.17 13.5 14 12.83 15.5 12 15.5 10.5 14.83 10.5 14M15.5 12C15.5 11.17 16.17 10.5 17 10.5S18.5 11.17 18.5 12 17.83 13.5 17 13.5 15.5 12.83 15.5 12M5.5 12C5.5 11.17 6.17 10.5 7 10.5S8.5 11.17 8.5 12 7.83 13.5 7 13.5 5.5 12.83 5.5 12Z";
var mdiPowerSocketDe = "M4.22 2A2.22 2.22 0 0 0 2 4.22V19.78C2 21 3 22 4.22 22H19.78A2.22 2.22 0 0 0 22 19.78V4.22C22 3 21 2 19.78 2H4.22M11 4.07V6H13V4.07A8 8 0 0 1 20 12A8 8 0 0 1 13 19.93V18H11V19.93A8 8 0 0 1 4 12A8 8 0 0 1 11 4.07M7.5 10.5A1.5 1.5 0 0 0 6 12C6 12.83 6.66 13.5 7.5 13.5A1.5 1.5 0 0 0 9 12A1.5 1.5 0 0 0 7.5 10.5M16.5 10.5A1.5 1.5 0 0 0 15 12A1.5 1.5 0 0 0 16.5 13.5A1.5 1.5 0 0 0 18 12A1.5 1.5 0 0 0 16.5 10.5Z";
var mdiPowerSocketEu = "M7.5,10.5A1.5,1.5 0 0,1 9,12A1.5,1.5 0 0,1 7.5,13.5C6.66,13.5 6,12.83 6,12A1.5,1.5 0 0,1 7.5,10.5M16.5,10.5A1.5,1.5 0 0,1 18,12A1.5,1.5 0 0,1 16.5,13.5A1.5,1.5 0 0,1 15,12A1.5,1.5 0 0,1 16.5,10.5M4.22,2H19.78C21,2 22,3 22,4.22V19.78A2.22,2.22 0 0,1 19.78,22H4.22C3,22 2,21 2,19.78V4.22A2.22,2.22 0 0,1 4.22,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiPowerSocketFr = "M4.22 2A2.22 2.22 0 0 0 2 4.22V19.78C2 21 3 22 4.22 22H19.78A2.22 2.22 0 0 0 22 19.78V4.22C22 3 21 2 19.78 2H4.22M12 4A8 8 0 0 1 20 12A8 8 0 0 1 12 20A8 8 0 0 1 4 12A8 8 0 0 1 12 4M12 6A1.5 1.5 0 0 0 10.5 7.5A1.5 1.5 0 0 0 12 9A1.5 1.5 0 0 0 13.5 7.5A1.5 1.5 0 0 0 12 6M7.5 10.5A1.5 1.5 0 0 0 6 12C6 12.83 6.66 13.5 7.5 13.5A1.5 1.5 0 0 0 9 12A1.5 1.5 0 0 0 7.5 10.5M16.5 10.5A1.5 1.5 0 0 0 15 12A1.5 1.5 0 0 0 16.5 13.5A1.5 1.5 0 0 0 18 12A1.5 1.5 0 0 0 16.5 10.5Z";
var mdiPowerSocketIt = "M10.5 16.5C10.5 15.68 11.17 15 12 15C12.83 15 13.5 15.68 13.5 16.5C13.5 17.34 12.83 18 12 18C11.17 18 10.5 17.34 10.5 16.5M10.5 7.5C10.5 6.67 11.17 6 12 6C12.83 6 13.5 6.67 13.5 7.5C13.5 8.33 12.83 9 12 9C11.17 9 10.5 8.33 10.5 7.5M4.22 2H19.78C21 2 22 3 22 4.22V19.78C22 21 21 22 19.78 22H4.22C3 22 2 21 2 19.78V4.22C2 3 3 2 4.22 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4M10.5 12C10.5 11.17 11.17 10.5 12 10.5C12.83 10.5 13.5 11.17 13.5 12C13.5 12.83 12.83 13.5 12 13.5C11.17 13.5 10.5 12.83 10.5 12Z";
var mdiPowerSocketJp = "M10 9.5V14.5H8V9.5M19.78 2C21 2 22 3 22 4.22V19.78C22 21 21 22 19.78 22H4.22C3 22 2 21 2 19.78V4.22C2 3 3 2 4.22 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4M16 9.5V14.5H14V9.5Z";
var mdiPowerSocketUk = "M4 2A2 2 0 0 0 2 4V20A2 2 0 0 0 4 22H20A2 2 0 0 0 22 20V4A2 2 0 0 0 20 2H4M4 4H20V20H4V4M11 7V11H13V7H11M6 14.75V17H9.5V14.75H6M14.5 14.75V17H18V14.75H14.5Z";
var mdiPowerSocketUs = "M8,7H10V12H8V7M4.22,2H19.78C21,2 22,3 22,4.22V19.78A2.22,2.22 0 0,1 19.78,22H4.22C3,22 2,21 2,19.78V4.22A2.22,2.22 0 0,1 4.22,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M14,7.5H16V11.5H14V7.5M10.5,16.25A1.5,1.5 0 0,1 12,14.75A1.5,1.5 0 0,1 13.5,16.25V17H10.5V16.25Z";
var mdiPowerStandby = "M13,3H11V13H13V3M17.83,5.17L16.41,6.59C18.05,7.91 19,9.9 19,12A7,7 0 0,1 12,19C8.14,19 5,15.88 5,12C5,9.91 5.95,7.91 7.58,6.58L6.17,5.17C2.38,8.39 1.92,14.07 5.14,17.86C8.36,21.64 14.04,22.1 17.83,18.88C19.85,17.17 21,14.65 21,12C21,9.37 19.84,6.87 17.83,5.17Z";
var mdiPowershell = "M21.83,4C22.32,4 22.63,4.4 22.5,4.89L19.34,19.11C19.23,19.6 18.75,20 18.26,20H2.17C1.68,20 1.37,19.6 1.5,19.11L4.66,4.89C4.77,4.4 5.25,4 5.74,4H21.83M15.83,16H11.83C11.37,16 11,16.38 11,16.84C11,17.31 11.37,17.69 11.83,17.69H15.83C16.3,17.69 16.68,17.31 16.68,16.84C16.68,16.38 16.3,16 15.83,16M5.78,16.28C5.38,16.56 5.29,17.11 5.57,17.5C5.85,17.92 6.41,18 6.81,17.73C14.16,12.56 14.21,12.5 14.26,12.47C14.44,12.31 14.53,12.09 14.54,11.87C14.55,11.67 14.5,11.5 14.38,11.31L9.46,6.03C9.13,5.67 8.57,5.65 8.21,6C7.85,6.32 7.83,6.88 8.16,7.24L12.31,11.68L5.78,16.28Z";
var mdiPrescription = "M4,4V10L4,14H6V10H8L13.41,15.41L9.83,19L11.24,20.41L14.83,16.83L18.41,20.41L19.82,19L16.24,15.41L19.82,11.83L18.41,10.41L14.83,14L10.83,10H11A3,3 0 0,0 14,7A3,3 0 0,0 11,4H4M6,6H11A1,1 0 0,1 12,7A1,1 0 0,1 11,8H6V6Z";
var mdiPresentation = "M2,3H10A2,2 0 0,1 12,1A2,2 0 0,1 14,3H22V5H21V16H15.25L17,22H15L13.25,16H10.75L9,22H7L8.75,16H3V5H2V3M5,5V14H19V5H5Z";
var mdiPresentationPlay = "M2,3H10A2,2 0 0,1 12,1A2,2 0 0,1 14,3H22V5H21V16H15.25L17,22H15L13.25,16H10.75L9,22H7L8.75,16H3V5H2V3M5,5V14H19V5H5M11.85,11.85C11.76,11.94 11.64,12 11.5,12A0.5,0.5 0 0,1 11,11.5V7.5A0.5,0.5 0 0,1 11.5,7C11.64,7 11.76,7.06 11.85,7.15L13.25,8.54C13.57,8.86 13.89,9.18 13.89,9.5C13.89,9.82 13.57,10.14 13.25,10.46L11.85,11.85Z";
var mdiPretzel = "M5.15 15.84C3.81 14.27 3 12.23 3 10V9.97C3 7.22 5.25 5 8 5C9.64 5 11.09 5.79 12 7C12.91 5.79 14.37 5 16 5C18.76 5 21 7.24 21 10C21 12.23 20.19 14.27 18.85 15.84L20.21 17.2L18.79 18.61L17.39 17.21C15.89 18.33 14 19 12 19C10 19 8.11 18.33 6.61 17.21L5.21 18.61L3.79 17.2L5.15 15.84M15.96 15.77L12 11.82L8.04 15.77C9.17 16.55 10.53 17 12 17C13.47 17 14.83 16.55 15.96 15.77M11 10C11 8.34 9.65 7 8 7C6.34 7 5 8.34 5 10C5 11.68 5.59 13.21 6.57 14.42L11 10M17.43 14.42C18.41 13.21 19 11.68 19 10V10C19 8.33 17.65 7 16 7C14.35 7 13 8.34 13 10L17.43 14.42Z";
var mdiPrinter = "M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z";
var mdiPrinter3d = "M19,6A1,1 0 0,0 20,5A1,1 0 0,0 19,4A1,1 0 0,0 18,5A1,1 0 0,0 19,6M19,2A3,3 0 0,1 22,5V11H18V7H6V11H2V5A3,3 0 0,1 5,2H19M18,18.25C18,18.63 17.79,18.96 17.47,19.13L12.57,21.82C12.4,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L6.53,19.13C6.21,18.96 6,18.63 6,18.25V13C6,12.62 6.21,12.29 6.53,12.12L11.43,9.68C11.59,9.56 11.79,9.5 12,9.5C12.21,9.5 12.4,9.56 12.57,9.68L17.47,12.12C17.79,12.29 18,12.62 18,13V18.25M12,11.65L9.04,13L12,14.6L14.96,13L12,11.65M8,17.66L11,19.29V16.33L8,14.71V17.66M16,17.66V14.71L13,16.33V19.29L16,17.66Z";
var mdiPrinter3dNozzle = "M7,2H17V8H19V13H16.5L13,17H11L7.5,13H5V8H7V2M10,22H2V20H10A1,1 0 0,0 11,19V18H13V19A3,3 0 0,1 10,22Z";
var mdiPrinter3dNozzleAlert = "M7 2H17V8H19V13H16.5L13 17H11L7.5 13H5V8H7V2M10 22H2V20H10C10.6 20 11 19.5 11 19V18H13V19C13 20.7 11.7 22 10 22M21 13V7H23V13H21M21 17V15H23V17H21Z";
var mdiPrinter3dNozzleAlertOutline = "M7 2H17V7H19V13H16.5L13 17H11L7.5 13H5V7H7V2M10 22H2V20H10C10.6 20 11 19.5 11 19V18H13V19C13 20.7 11.7 22 10 22M7 9V11H8.5L12 15L15.5 11H17V9H15V4H9V9H7M21 13V7H23V13H21M21 17V15H23V17H21Z";
var mdiPrinter3dNozzleHeat = "M4 2H14V7H16V13H13.5L10 17H8L4.5 13H2V7H4V2M23 14.5L21.6 16.7L23 18.9L21 22L19.2 21.1L20.7 18.9L19.2 16.7L21.2 13.6L23 14.5M18.7 14.5L17.2 16.7L18.7 18.9L16.7 22L14.9 21.1L16.3 18.9L14.9 16.7L16.9 13.6L18.7 14.5";
var mdiPrinter3dNozzleHeatOutline = "M23 14.5L21.6 16.7L23 18.9L21 22L19.2 21.1L20.7 18.9L19.2 16.7L21.2 13.6L23 14.5M18.7 14.5L17.2 16.7L18.7 18.9L16.7 22L14.9 21.1L16.3 18.9L14.9 16.7L16.9 13.6L18.7 14.5M4 2H14V7H16V13H13.5L10 17H8L4.5 13H2V7H4V2M4 9V11H5.5L9 15L12.5 11H14V9H12V4H6V9H4Z";
var mdiPrinter3dNozzleOff = "M20.8 22.7L14 15.9L13 17H11L7.5 13H5V8H6.1L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M11 19C11 19.6 10.6 20 10 20H2V22H10C11.7 22 13 20.7 13 19V18H11V19M19 13V8H17V2H7V3.8L16.2 13H19Z";
var mdiPrinter3dNozzleOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L5.1 7H5V13H7.5L11 17H13L14 15.9L20.9 22.8L22.1 21.5M12 15L8.5 11H7V9H7.1L12.5 14.4L12 15M11 18H13V19C13 20.7 11.7 22 10 22H2V20H10C10.6 20 11 19.6 11 19V18M9 5.8L7 3.8V2H17V7H19V13H16.2L14.9 11.7L15.5 11H17V9H15V4H9V5.8Z";
var mdiPrinter3dNozzleOutline = "M7,2H17V7H19V13H16.5L13,17H11L7.5,13H5V7H7V2M10,22H2V20H10A1,1 0 0,0 11,19V18H13V19A3,3 0 0,1 10,22M7,9V11H8.5L12,15L15.5,11H17V9H15V4H9V9H7Z";
var mdiPrinter3dOff = "M2.3 2L1 3.3L2.1 4.4C2 4.6 2 4.8 2 5V11H6V8.3L8.7 11L6.5 12.1C6.2 12.3 6 12.6 6 13V18.2C6 18.6 6.2 18.9 6.5 19.1L11.4 21.8C11.6 21.9 11.8 22 12 22S12.4 21.9 12.6 21.8L17.1 19.3L20.8 23L22.1 21.7L2.3 2M4.9 2H4.8L9.8 7H18V11H22V5C22 3.3 20.7 2 19 2H4.9C5 2 5 2 4.9 2M19 4C19.6 4 20 4.4 20 5S19.6 6 19 6 18 5.6 18 5 18.4 4 19 4M12.4 9.6L18 15.2V13C18 12.6 17.8 12.3 17.5 12.1L12.6 9.7C12.5 9.7 12.5 9.6 12.4 9.6M10.2 12.5L12.2 14.5L12 14.6L9 13L10.2 12.5M8 14.7L11 16.3V19.3L8 17.7V14.7M13.7 16L15.6 17.9L13 19.3V16.3L13.7 16Z";
var mdiPrinterAlert = "M16 3H4V7H16M17 12C16.4 12 16 11.6 16 11S16.4 10 17 10 18 10.4 18 11 17.6 12 17 12M14 19H6V14H14M17 8H3C1.3 8 0 9.3 0 11V17H4V21H16V17H20V11C20 9.3 18.7 8 17 8M24 13H22V7H24V13M24 17H22V15H24V17Z";
var mdiPrinterCheck = "M18 7H6V3H18V7M6 21V17H2V11C2 9.34 3.34 8 5 8H19C20.66 8 22 9.34 22 11V13.81C21.12 13.3 20.1 13 19 13C17.77 13 16.64 13.37 15.69 14H8V19H13C13 19.7 13.13 20.37 13.35 21H6M18 11C18 11.55 18.45 12 19 12S20 11.55 20 11 19.55 10 19 10 18 10.45 18 11M23.5 17L22 15.5L18.5 19L16.5 17L15 18.5L18.5 22L23.5 17";
var mdiPrinterEye = "M9.8 21C9.6 20.6 9.3 20.2 9.2 19.7L8.8 19H8V14H13C14.2 13.4 15.6 13 17 13C18.9 13 20.6 13.6 22 14.6V11C22 9.3 20.7 8 19 8H5C3.3 8 2 9.3 2 11V17H6V21H9.8M19 10C19.6 10 20 10.4 20 11S19.6 12 19 12 18 11.6 18 11 18.4 10 19 10M18 7H6V3H18V7M17 18C17.6 18 18 18.4 18 19S17.6 20 17 20 16 19.6 16 19 16.4 18 17 18M17 15C14.3 15 11.9 16.7 11 19C11.9 21.3 14.3 23 17 23S22.1 21.3 23 19C22.1 16.7 19.7 15 17 15M17 21.5C15.6 21.5 14.5 20.4 14.5 19S15.6 16.5 17 16.5 19.5 17.6 19.5 19 18.4 21.5 17 21.5Z";
var mdiPrinterOff = "M6,3V4.18L8.82,7H18V3H6M2.28,3L1,4.27L4.75,8C3.19,8.15 2,9.44 2,11V17H6V21H17.73L19.73,23L21,21.72L2.28,3M9.82,8L18.82,17H22V11A3,3 0 0,0 19,8H9.82M19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10M8,14H10.73L15.73,19H8V14Z";
var mdiPrinterOffOutline = "M1.41 1.6L22.36 22.55L20.95 23.96L18 21H6V17H2V11C2 9.34 3.34 8 5 8L0 3L1.41 1.6M6 15V13H10L7 10H5C4.45 10 4 10.45 4 11V15H6M8 19H16L12 15H8V19M8 5V5.36L6 3.36V3H18V8H19C20.66 8 22 9.34 22 11V17H19.66L15.66 13H18V15L20 15V11C20 10.45 19.55 10 19 10H12.66L10.66 8H16V5H8M19 11.5C19 12.06 18.55 12.5 18 12.5C17.45 12.5 17 12.06 17 11.5C17 10.96 17.45 10.5 18 10.5C18.55 10.5 19 10.96 19 11.5Z";
var mdiPrinterOutline = "M19 8C20.66 8 22 9.34 22 11V17H18V21H6V17H2V11C2 9.34 3.34 8 5 8H6V3H18V8H19M8 5V8H16V5H8M16 19V15H8V19H16M18 15H20V11C20 10.45 19.55 10 19 10H5C4.45 10 4 10.45 4 11V15H6V13H18V15M19 11.5C19 12.05 18.55 12.5 18 12.5C17.45 12.5 17 12.05 17 11.5C17 10.95 17.45 10.5 18 10.5C18.55 10.5 19 10.95 19 11.5Z";
var mdiPrinterPos = "M18 10H6A2 2 0 0 0 4 12V19H20V12A2 2 0 0 0 18 10M18 14H14V12H18M17 9H7V4H17Z";
var mdiPrinterPosAlert = "M16 10H4C2.9 10 2 10.9 2 12V19H18V12C18 10.9 17.11 10 16 10M16 14H12V12H16V14M15 9H5V4H15V9M22 7V13H20V7H22M20 15H22V17H20V15Z";
var mdiPrinterPosAlertOutline = "M15 15H11V13H15V15M18 12V19H2V12C2 10.9 2.9 10 4 10H5V4H15V10H16C17.11 10 18 10.9 18 12M7 10H13V6H7V10M16 12H4V17H16V12M20 17H22V15H20V17M20 7V13H22V7H20Z";
var mdiPrinterPosCancel = "M17 9H7V4H17V9M12 18.5C12 18.67 12 18.83 12.03 19H4V12C4 10.9 4.89 10 6 10H18C19.11 10 20 10.9 20 12V12.18C19.5 12.07 19 12 18.5 12C14.91 12 12 14.91 12 18.5M10 12H6V14H10V12M23 18.5C23 21 21 23 18.5 23S14 21 14 18.5 16 14 18.5 14 23 16 23 18.5M20 21.08L15.92 17C15.65 17.42 15.5 17.94 15.5 18.5C15.5 20.16 16.84 21.5 18.5 21.5C19.06 21.5 19.58 21.35 20 21.08M21.5 18.5C21.5 16.84 20.16 15.5 18.5 15.5C17.94 15.5 17.42 15.65 17 15.92L21.08 20C21.35 19.58 21.5 19.06 21.5 18.5Z";
var mdiPrinterPosCancelOutline = "M18.5 14C16 14 14 16 14 18.5S16 23 18.5 23 23 21 23 18.5 21 14 18.5 14M18.5 21.5C16.84 21.5 15.5 20.16 15.5 18.5C15.5 17.94 15.65 17.42 15.92 17L20 21.08C19.58 21.35 19.06 21.5 18.5 21.5M21.08 20L17 15.92C17.42 15.65 17.94 15.5 18.5 15.5C20.16 15.5 21.5 16.84 21.5 18.5C21.5 19.06 21.35 19.58 21.08 20M7 15V13H11V15H7M6 17V12H20C20 10.9 19.11 10 18 10H17V4H7V10H6C4.89 10 4 10.9 4 12V19H12.03C12 18.83 12 18.67 12 18.5C12 18 12.07 17.5 12.18 17H6M9 6H15V10H9V6Z";
var mdiPrinterPosCheck = "M17 9H7V4H17V9M19 13C15.69 13 13 15.69 13 19H4V12C4 10.9 4.89 10 6 10H18C19.11 10 20 10.9 20 12V13.09C19.67 13.04 19.34 13 19 13M10 12H6V14H10V12M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiPrinterPosCheckOutline = "M7 15V13H11V15H7M6 17H13.35C13.13 17.63 13 18.3 13 19H4V12C4 10.9 4.89 10 6 10H7V4H17V10H18C19.11 10 20 10.9 20 12V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V12H6V17M9 10H15V6H9V10M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiPrinterPosCog = "M17 9H7V4H17V9M19 12C15.13 12 12 15.13 12 19H4V12C4 10.9 4.89 10 6 10H18C19.11 10 20 10.9 20 12V12.08C19.67 12.03 19.34 12 19 12M10 12H6V14H10V12M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiPrinterPosCogOutline = "M22.7 19.6V18.6L23.8 17.8C23.9 17.7 24 17.6 23.9 17.5L22.9 15.8C22.9 15.7 22.7 15.7 22.6 15.7L21.4 16.2C21.1 16 20.8 15.8 20.5 15.7L20.3 14.4C20.3 14.3 20.2 14.2 20.1 14.2H18.1C17.9 14.2 17.8 14.3 17.8 14.4L17.6 15.7C17.3 15.9 17.1 16 16.8 16.2L15.6 15.7C15.5 15.7 15.4 15.7 15.3 15.8L14.3 17.5C14.3 17.6 14.3 17.7 14.4 17.8L15.5 18.6V19.6L14.4 20.4C14.3 20.5 14.2 20.6 14.3 20.7L15.3 22.4C15.4 22.5 15.5 22.5 15.6 22.5L16.8 22C17 22.2 17.3 22.4 17.6 22.5L17.8 23.8C17.9 23.9 18 24 18.1 24H20.1C20.2 24 20.3 23.9 20.3 23.8L20.5 22.5C20.8 22.3 21 22.2 21.3 22L22.5 22.4C22.6 22.4 22.7 22.4 22.8 22.3L23.8 20.6C23.9 20.5 23.9 20.4 23.8 20.4L22.7 19.6M19 20.5C18.2 20.5 17.5 19.8 17.5 19S18.2 17.5 19 17.5 20.5 18.2 20.5 19 19.8 20.5 19 20.5M7 15V13H11V15H7M6 12H20C20 10.9 19.11 10 18 10H17V4H7V10H6C4.89 10 4 10.9 4 12V19H12C12 18.31 12.11 17.63 12.29 17H6V12M9 6H15V10H9V6Z";
var mdiPrinterPosEdit = "M17 9H7V4H17V9M19.39 10.74L11.13 19H4V12C4 10.9 4.89 10 6 10H18C18.59 10 19.11 10.26 19.5 10.67C19.45 10.69 19.42 10.71 19.39 10.74M10 12H6V14H10V12M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47Z";
var mdiPrinterPosEditOutline = "M6 17V12H18.13L19.39 10.74C19.42 10.71 19.45 10.69 19.5 10.67C19.11 10.26 18.59 10 18 10H17V4H7V10H6C4.89 10 4 10.9 4 12V19H11.13L13.13 17H6M9 6H15V10H9V6M7 15V13H11V15H7M22.85 14.19L21.87 15.17L19.83 13.13L20.81 12.15C21 11.95 21.33 11.95 21.53 12.15L22.85 13.47C23.05 13.67 23.05 14 22.85 14.19M19.13 13.83L21.17 15.87L15.04 22H13V19.96L19.13 13.83Z";
var mdiPrinterPosMinus = "M17 9H7V4H17V9M19 13C15.69 13 13 15.69 13 19H4V12C4 10.9 4.89 10 6 10H18C19.11 10 20 10.9 20 12V13.09C19.67 13.04 19.34 13 19 13M10 12H6V14H10V12M15 18V20H23V18H15Z";
var mdiPrinterPosMinusOutline = "M6 12H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V12C20 10.9 19.11 10 18 10H17V4H7V10H6C4.89 10 4 10.9 4 12V19H13C13 18.3 13.13 17.63 13.35 17H6V12M9 6H15V10H9V6M7 15V13H11V15H7M23 18V20H15V18H23Z";
var mdiPrinterPosNetwork = "M17 7H7V2H17V7M22 20V22H15C15 22.55 14.55 23 14 23H10C9.45 23 9 22.55 9 22H2V20H9C9 19.45 9.45 19 10 19H11V17H4V10C4 8.9 4.89 8 6 8H18C19.11 8 20 8.9 20 10V17H13V19H14C14.55 19 15 19.45 15 20H22M18 10H14V12H18V10Z";
var mdiPrinterPosNetworkOutline = "M13 11H17V13H13V11M22 20V22H15C15 22.55 14.55 23 14 23H10C9.45 23 9 22.55 9 22H2V20H9C9 19.45 9.45 19 10 19H11V17H4V10C4 8.9 4.89 8 6 8H7V2H17V8H18C19.11 8 20 8.9 20 10V17H13V19H14C14.55 19 15 19.45 15 20H22M9 8H15V4H9V8M18 15V10H6V15H18Z";
var mdiPrinterPosOff = "M12.2 9L7.2 4H17V9H12.2M20 16.8V12C20 10.9 19.11 10 18 10H13.2L20 16.8M22.11 21.46L20.84 22.73L17.11 19H4V12C4 10.9 4.89 10 6 10H8.11L1.11 3L2.39 1.73L22.11 21.46M10 12H6V14H10V12Z";
var mdiPrinterPosOffOutline = "M2.39 1.73L1.11 3L7 8.89V10H6C4.89 10 4 10.9 4 12V19H17.11L20.84 22.73L22.11 21.46L2.39 1.73M6 17V12H10.11L15.11 17H6M9.2 6L7.2 4H17V10H18C19.11 10 20 10.9 20 12V16.8L18 14.8V12H15.2L13.2 10H15V6H9.2M7 13H11V15H7V13Z";
var mdiPrinterPosOutline = "M18 10H17V4H7V10H6C4.89 10 4 10.9 4 12V19H20V12C20 10.9 19.11 10 18 10M9 6H15V10H9V6M18 17H6V12H18V17M17 15H13V13H17V15Z";
var mdiPrinterPosPause = "M17 9H7V4H17V9M20 13.09C19.67 13.04 19.34 13 19 13C15.69 13 13 15.69 13 19H4V12C4 10.9 4.89 10 6 10H18C19.11 10 20 10.9 20 12V13.09M10 12H6V14H10V12M16 22H18V16H16V22M20 16V22H22V16H20Z";
var mdiPrinterPosPauseOutline = "M20 12C20 10.9 19.11 10 18 10H17V4H7V10H6C4.89 10 4 10.9 4 12V19H13C13 18.3 13.13 17.63 13.35 17H6V12H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V12M15 10H9V6H15V10M7 15V13H11V15H7M16 16H18V22H16V16M22 16V22H20V16H22Z";
var mdiPrinterPosPlay = "M20 13.09V12C20 10.9 19.11 10 18 10H6C4.89 10 4 10.9 4 12V19H13C13 15.69 15.69 13 19 13C19.34 13 19.67 13.04 20 13.09M10 14H6V12H10V14M17 9H7V4H17V9M22 19L17 22V16L22 19Z";
var mdiPrinterPosPlayOutline = "M7 15V13H11V15H7M6 17H13.35C13.13 17.63 13 18.3 13 19H4V12C4 10.9 4.89 10 6 10H7V4H17V10H18C19.11 10 20 10.9 20 12V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V12H6V17M9 10H15V6H9V10M17 16V22L22 19L17 16Z";
var mdiPrinterPosPlus = "M17 9H7V4H17V9M19 13C15.69 13 13 15.69 13 19H4V12C4 10.9 4.89 10 6 10H18C19.11 10 20 10.9 20 12V13.09C19.67 13.04 19.34 13 19 13M10 12H6V14H10V12M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiPrinterPosPlusOutline = "M6 12H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V12C20 10.9 19.11 10 18 10H17V4H7V10H6C4.89 10 4 10.9 4 12V19H13C13 18.3 13.13 17.63 13.35 17H6V12M9 6H15V10H9V6M7 15V13H11V15H7M23 18V20H20V23H18V20H15V18H18V15H20V18H23Z";
var mdiPrinterPosRefresh = "M17 9H7V4H17V9M12 18.5C12 18.67 12 18.83 12.03 19H4V12C4 10.9 4.89 10 6 10H18C19.11 10 20 10.9 20 12V12.18C19.5 12.07 19 12 18.5 12C14.91 12 12 14.91 12 18.5M10 12H6V14H10V12M22 18.5V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22Z";
var mdiPrinterPosRefreshOutline = "M7 15V13H11V15H7M22 18.5V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22M12.18 17C12.07 17.5 12 18 12 18.5C12 18.67 12 18.83 12.03 19H4V12C4 10.9 4.89 10 6 10H7V4H17V10H18C19.11 10 20 10.9 20 12H6V17H12.18M9 10H15V6H9V10Z";
var mdiPrinterPosRemove = "M17 9H7V4H17V9M19 13C15.69 13 13 15.69 13 19H4V12C4 10.9 4.89 10 6 10H18C19.11 10 20 10.9 20 12V13.09C19.67 13.04 19.34 13 19 13M10 12H6V14H10V12M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiPrinterPosRemoveOutline = "M7 15V13H11V15H7M6 17H13.35C13.13 17.63 13 18.3 13 19H4V12C4 10.9 4.89 10 6 10H7V4H17V10H18C19.11 10 20 10.9 20 12V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V12H6V17M9 10H15V6H9V10M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiPrinterPosStar = "M17 9H7V4H17V9M19 13C15.69 13 13 15.69 13 19H4V12C4 10.9 4.89 10 6 10H18C19.11 10 20 10.9 20 12V13.09C19.67 13.04 19.34 13 19 13M10 12H6V14H10V12M23 17.89L20.11 17.64L19 15L17.87 17.64L15 17.89L17.18 19.77L16.5 22.58L19 21.09L21.45 22.58L20.8 19.77L23 17.89Z";
var mdiPrinterPosStarOutline = "M6 12H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V12C20 10.9 19.11 10 18 10H17V4H7V10H6C4.89 10 4 10.9 4 12V19H13C13 18.3 13.13 17.63 13.35 17H6V12M9 6H15V10H9V6M7 15V13H11V15H7M20.8 19.77L21.45 22.58L19 21.09L16.5 22.58L17.18 19.77L15 17.89L17.87 17.64L19 15L20.11 17.64L23 17.89L20.8 19.77Z";
var mdiPrinterPosStop = "M17 9H7V4H17V9M19 13C15.69 13 13 15.69 13 19H4V12C4 10.9 4.89 10 6 10H18C19.11 10 20 10.9 20 12V13.09C19.67 13.04 19.34 13 19 13M10 12H6V14H10V12M16 16V22H22V16H16Z";
var mdiPrinterPosStopOutline = "M6 12H18V13.09C18.33 13.04 18.66 13 19 13C19.34 13 19.67 13.04 20 13.09V12C20 10.9 19.11 10 18 10H17V4H7V10H6C4.89 10 4 10.9 4 12V19H13C13 18.3 13.13 17.63 13.35 17H6V12M9 6H15V10H9V6M7 15V13H11V15H7M22 16V22H16V16H22Z";
var mdiPrinterPosSync = "M17 9H7V4H17V9M13 17.5C13 18 13.07 18.5 13.18 19H4V12C4 10.9 4.89 10 6 10H18C18.74 10 19.38 10.41 19.73 11C19.65 11 19.58 11 19.5 11C15.91 11 13 13.91 13 17.5M10 12H6V14H10V12M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5Z";
var mdiPrinterPosSyncOutline = "M7 15V13H11V15H7M13 17.5C13 18 13.07 18.5 13.18 19H4V12C4 10.9 4.89 10 6 10H7V4H17V10H18C18.74 10 19.38 10.41 19.73 11C19.65 11 19.58 11 19.5 11C18.23 11 17.05 11.37 16.05 12H6V17H13.03C13 17.17 13 17.33 13 17.5M9 10H15V6H9V10M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20Z";
var mdiPrinterPosWrench = "M17 9H7V4H17V9M11 16C11 17.13 11.39 18.16 12 19H4V12C4 10.9 4.89 10 6 10H18C19.11 10 20 10.9 20 12V13.03C19.09 11.8 17.64 11 16 11C13.24 11 11 13.24 11 16M10 12H6V14H10V12M22.87 21.19L18.76 17.08C19.17 16.04 18.94 14.82 18.08 13.97C17.18 13.06 15.83 12.88 14.74 13.38L16.68 15.32L15.33 16.68L13.34 14.73C12.8 15.82 13.05 17.17 13.93 18.08C14.79 18.94 16 19.16 17.05 18.76L21.16 22.86C21.34 23.05 21.61 23.05 21.79 22.86L22.83 21.83C23.05 21.65 23.05 21.33 22.87 21.19Z";
var mdiPrinterPosWrenchOutline = "M7 15V13H11V15H7M13.03 12H6V17H11.1C11.25 17.74 11.58 18.42 12 19H4V12C4 10.9 4.89 10 6 10H7V4H17V10H18C19.11 10 20 10.9 20 12V13.03C19.09 11.8 17.64 11 16 11C14.88 11 13.86 11.38 13.03 12M9 10H15V6H9V10M22.87 21.19L18.76 17.08C19.17 16.04 18.94 14.82 18.08 13.97C17.18 13.06 15.83 12.88 14.74 13.38L16.68 15.32L15.33 16.68L13.34 14.73C12.8 15.82 13.05 17.17 13.93 18.08C14.79 18.94 16 19.16 17.05 18.76L21.16 22.86C21.34 23.05 21.61 23.05 21.79 22.86L22.83 21.83C23.05 21.65 23.05 21.33 22.87 21.19Z";
var mdiPrinterSearch = "M20.3 18.9C20.7 18.2 21 17.4 21 16.5C21 14 19 12 16.5 12S12 14 12 16.5 14 21 16.5 21C17.4 21 18.2 20.8 18.9 20.3L22 23.4L23.4 22L20.3 18.9M16.5 19C15.1 19 14 17.9 14 16.5S15.1 14 16.5 14 19 15.1 19 16.5 17.9 19 16.5 19M18 7H6V3H18V7M6 21V17H2V11C2 9.3 3.3 8 5 8H19C20.7 8 22 9.3 22 11V13C20.8 11.2 18.8 10 16.5 10C13.8 10 11.5 11.7 10.5 14H8V19H10.5C10.8 19.7 11.3 20.4 11.8 21H6Z";
var mdiPrinterSettings = "M18,2V6H6V2H18M19,11A1,1 0 0,0 20,10A1,1 0 0,0 19,9A1,1 0 0,0 18,10A1,1 0 0,0 19,11M16,18V13H8V18H16M19,7A3,3 0 0,1 22,10V16H18V20H6V16H2V10A3,3 0 0,1 5,7H19M15,24V22H17V24H15M11,24V22H13V24H11M7,24V22H9V24H7Z";
var mdiPrinterWireless = "M4.93,3.92L6.34,5.33C9.46,2.2 14.53,2.2 17.66,5.33L19.07,3.92C15.17,0 8.84,0 4.93,3.92M7.76,6.75L9.17,8.16C10.73,6.6 13.26,6.6 14.83,8.16L16.24,6.75C13.9,4.41 10.1,4.41 7.76,6.75M19,14A1,1 0 0,1 18,13A1,1 0 0,1 19,12A1,1 0 0,1 20,13A1,1 0 0,1 19,14M16,20H8V15H16V20M19,10H5A3,3 0 0,0 2,13V18H6V22H18V18H22V13A3,3 0 0,0 19,10Z";
var mdiPriorityHigh = "M14,19H22V17H14V19M14,13.5H22V11.5H14V13.5M14,8H22V6H14V8M2,12.5C2,8.92 4.92,6 8.5,6H9V4L12,7L9,10V8H8.5C6,8 4,10 4,12.5C4,15 6,17 8.5,17H12V19H8.5C4.92,19 2,16.08 2,12.5Z";
var mdiPriorityLow = "M14,5H22V7H14V5M14,10.5H22V12.5H14V10.5M14,16H22V18H14V16M2,11.5C2,15.08 4.92,18 8.5,18H9V20L12,17L9,14V16H8.5C6,16 4,14 4,11.5C4,9 6,7 8.5,7H12V5H8.5C4.92,5 2,7.92 2,11.5Z";
var mdiProfessionalHexagon = "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M5,9V15H6.25V13H7A2,2 0 0,0 9,11A2,2 0 0,0 7,9H5M6.25,12V10H6.75A1,1 0 0,1 7.75,11A1,1 0 0,1 6.75,12H6.25M9.75,9V15H11V13H11.75L12.41,15H13.73L12.94,12.61C13.43,12.25 13.75,11.66 13.75,11A2,2 0 0,0 11.75,9H9.75M11,12V10H11.5A1,1 0 0,1 12.5,11A1,1 0 0,1 11.5,12H11M17,9C15.62,9 14.5,10.34 14.5,12C14.5,13.66 15.62,15 17,15C18.38,15 19.5,13.66 19.5,12C19.5,10.34 18.38,9 17,9M17,10.25C17.76,10.25 18.38,11.03 18.38,12C18.38,12.97 17.76,13.75 17,13.75C16.24,13.75 15.63,12.97 15.63,12C15.63,11.03 16.24,10.25 17,10.25Z";
var mdiProgressAlert = "M13,2V4C17.39,4.54 20.5,8.53 19.96,12.92C19.5,16.56 16.64,19.43 13,19.88V21.88C18.5,21.28 22.45,16.34 21.85,10.85C21.33,6.19 17.66,2.5 13,2M11,2C9.04,2.18 7.19,2.95 5.67,4.2L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.24,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.06,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37H7.06M13,13V7H11V13H13M13,17V15H11V17H13Z";
var mdiProgressCheck = "M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M15.5,8.5L10.62,13.38L8.5,11.26L7.44,12.32L10.62,15.5L16.56,9.56L15.5,8.5M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37Z";
var mdiProgressClock = "M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z";
var mdiProgressClose = "M13 2.03V4.05C17.39 4.59 20.5 8.58 19.96 12.97C19.5 16.61 16.64 19.5 13 19.93V21.93C18.5 21.38 22.5 16.5 21.95 11C21.5 6.25 17.73 2.5 13 2.03M11 2.06C9.05 2.25 7.19 3 5.67 4.26L7.1 5.74C8.22 4.84 9.57 4.26 11 4.06V2.06M4.26 5.67C3 7.19 2.25 9.04 2.05 11H4.05C4.24 9.58 4.8 8.23 5.69 7.1L4.26 5.67M2.06 13C2.26 14.96 3.03 16.81 4.27 18.33L5.69 16.9C4.81 15.77 4.24 14.42 4.06 13H2.06M7.1 18.37L5.67 19.74C7.18 21 9.04 21.79 11 22V20C9.58 19.82 8.23 19.25 7.1 18.37M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8Z";
var mdiProgressDownload = "M13,2.03C17.73,2.5 21.5,6.25 21.95,11C22.5,16.5 18.5,21.38 13,21.93V19.93C16.64,19.5 19.5,16.61 19.96,12.97C20.5,8.58 17.39,4.59 13,4.05V2.05L13,2.03M11,2.06V4.06C9.57,4.26 8.22,4.84 7.1,5.74L5.67,4.26C7.19,3 9.05,2.25 11,2.06M4.26,5.67L5.69,7.1C4.8,8.23 4.24,9.58 4.05,11H2.05C2.25,9.04 3,7.19 4.26,5.67M2.06,13H4.06C4.24,14.42 4.81,15.77 5.69,16.9L4.27,18.33C3.03,16.81 2.26,14.96 2.06,13M7.1,18.37C8.23,19.25 9.58,19.82 11,20V22C9.04,21.79 7.18,21 5.67,19.74L7.1,18.37M12,16.5L7.5,12H11V8H13V12H16.5L12,16.5Z";
var mdiProgressHelper = "M13 2V4C17.39 4.54 20.5 8.53 19.96 12.92C19.5 16.56 16.64 19.43 13 19.88V21.88C18.5 21.28 22.45 16.34 21.85 10.85C21.33 6.19 17.66 2.5 13 2M11 2C9.04 2.18 7.19 2.95 5.67 4.2L7.1 5.74C8.22 4.84 9.57 4.26 11 4.06V2M4.26 5.67C3 7.19 2.24 9.04 2.05 11H4.05C4.24 9.58 4.8 8.23 5.69 7.1L4.26 5.67M2.06 13C2.26 14.96 3.03 16.81 4.27 18.33L5.69 16.9C4.81 15.77 4.24 14.42 4.06 13H2.06M7.06 18.37L5.67 19.74C7.18 21 9.04 21.79 11 22V20C9.58 19.82 8.23 19.25 7.1 18.37H7.06Z";
var mdiProgressPencil = "M15.84 10.2L14.83 11.21L12.76 9.18L13.77 8.16C13.97 7.95 14.31 7.94 14.55 8.16L15.84 9.41C16.05 9.62 16.06 9.96 15.84 10.2M8 13.91L12.17 9.72L14.24 11.8L10.08 16H8V13.91M13 2V4C17.39 4.54 20.5 8.53 19.96 12.92C19.5 16.56 16.64 19.43 13 19.88V21.88C18.5 21.28 22.45 16.34 21.85 10.85C21.33 6.19 17.66 2.5 13 2M11 2C9.04 2.18 7.19 2.95 5.67 4.2L7.1 5.74C8.22 4.84 9.57 4.26 11 4.06V2.06M4.26 5.67C3 7.19 2.24 9.04 2.05 11H4.05C4.24 9.58 4.8 8.23 5.69 7.1L4.26 5.67M2.06 13C2.26 14.96 3.03 16.81 4.27 18.33L5.69 16.9C4.81 15.77 4.24 14.42 4.06 13H2.06M7.06 18.37L5.67 19.74C7.18 21 9.04 21.79 11 22V20C9.58 19.82 8.23 19.25 7.1 18.37H7.06Z";
var mdiProgressQuestion = "M13 18H11V16H13V18M13 15H11C11 11.75 14 12 14 10C14 8.9 13.1 8 12 8C10.9 8 10 8.9 10 10H8C8 7.79 9.79 6 12 6C14.21 6 16 7.79 16 10C16 12.5 13 12.75 13 15M22 12C22 17.18 18.05 21.45 13 21.95V19.94C16.95 19.45 20 16.08 20 12C20 7.92 16.95 4.55 13 4.06V2.05C18.05 2.55 22 6.82 22 12M11 2.05V4.06C9.54 4.24 8.2 4.82 7.09 5.68L5.67 4.26C7.15 3.05 9 2.25 11 2.05M4.06 11H2.05C2.25 9 3.05 7.15 4.26 5.67L5.68 7.1C4.82 8.2 4.24 9.54 4.06 11M11 19.94V21.95C9 21.75 7.15 20.96 5.67 19.74L7.09 18.32C8.2 19.18 9.54 19.76 11 19.94M2.05 13H4.06C4.24 14.46 4.82 15.8 5.68 16.91L4.26 18.33C3.05 16.85 2.25 15 2.05 13Z";
var mdiProgressStar = "M13 2V4C17.39 4.54 20.5 8.53 19.96 12.92C19.5 16.56 16.64 19.43 13 19.88V21.88C18.5 21.28 22.45 16.34 21.85 10.85C21.33 6.19 17.66 2.5 13 2M11 2C9.04 2.18 7.19 2.95 5.67 4.2L7.1 5.74C8.22 4.84 9.57 4.26 11 4.06V2.06M4.26 5.67C3 7.19 2.24 9.04 2.05 11H4.05C4.24 9.58 4.8 8.23 5.69 7.1L4.26 5.67M2.06 13C2.26 14.96 3.03 16.81 4.27 18.33L5.69 16.9C4.81 15.77 4.24 14.42 4.06 13H2.06M7.06 18.37L5.67 19.74C7.18 21 9.04 21.79 11 22V20C9.58 19.82 8.23 19.25 7.1 18.37H7.06M8.58 16.8L9.5 12.91L6.5 10.33L10.45 9.96L12 6.35L13.55 10L17.5 10.33L14.5 12.91L15.42 16.8L12 14.74L8.58 16.8";
var mdiProgressStarFourPoints = "M13 4V2C17.66 2.5 21.33 6.19 21.85 10.85C22.45 16.34 18.5 21.28 13 21.88V19.88C16.64 19.43 19.5 16.56 19.96 12.92C20.5 8.53 17.39 4.54 13 4M5.67 4.2C7.19 2.95 9.04 2.18 11 2V4.06C9.57 4.26 8.22 4.84 7.1 5.74L5.67 4.2M2.05 11C2.24 9.04 3 7.19 4.26 5.67L5.69 7.1C4.8 8.23 4.24 9.58 4.05 11H2.05M4.27 18.33C3.03 16.81 2.26 14.96 2.06 13H4.06C4.24 14.42 4.81 15.77 5.69 16.9L4.27 18.33M5.67 19.74L7.06 18.37H7.1C8.23 19.25 9.58 19.82 11 20V22C9.04 21.79 7.18 21 5.67 19.74M12 17L13.56 13.58L17 12L13.56 10.44L12 7L10.43 10.44L7 12L10.43 13.58L12 17Z";
var mdiProgressTag = "M13 4V2C17.66 2.5 21.33 6.19 21.85 10.85C22.45 16.34 18.5 21.28 13 21.88V19.88C16.64 19.43 19.5 16.56 19.96 12.92C20.5 8.53 17.39 4.54 13 4M5.67 4.2C7.19 2.95 9.04 2.18 11 2V4.06C9.57 4.26 8.22 4.84 7.1 5.74L5.67 4.2M2.05 11C2.24 9.04 3 7.19 4.26 5.67L5.69 7.1C4.8 8.23 4.24 9.58 4.05 11H2.05M4.27 18.33C3.03 16.81 2.26 14.96 2.06 13H4.06C4.24 14.42 4.81 15.77 5.69 16.9L4.27 18.33M5.67 19.74L7.06 18.37H7.1C8.23 19.25 9.58 19.82 11 20V22C9.04 21.79 7.18 21 5.67 19.74M11.6 8C11.8 8 12 8.1 12.2 8.2L15.8 11.8C15.9 12 16 12.2 16 12.4C16 12.7 15.9 12.9 15.8 13L13 15.8C12.8 15.9 12.6 16 12.4 16C12.1 16 11.9 15.9 11.8 15.8L8.2 12.2C8.1 12 8 11.8 8 11.6V8.8C8 8.4 8.4 8 8.8 8H11.6M8.8 9.4C8.8 9.7 9.1 10 9.4 10C9.7 10 10 9.7 10 9.4C10 9.1 9.7 8.8 9.4 8.8C9.1 8.8 8.8 9.1 8.8 9.4Z";
var mdiProgressUpload = "M13,2.03C17.73,2.5 21.5,6.25 21.95,11C22.5,16.5 18.5,21.38 13,21.93V19.93C16.64,19.5 19.5,16.61 19.96,12.97C20.5,8.58 17.39,4.59 13,4.05V2.05L13,2.03M11,2.06V4.06C9.57,4.26 8.22,4.84 7.1,5.74L5.67,4.26C7.19,3 9.05,2.25 11,2.06M4.26,5.67L5.69,7.1C4.8,8.23 4.24,9.58 4.05,11H2.05C2.25,9.04 3,7.19 4.26,5.67M2.06,13H4.06C4.24,14.42 4.81,15.77 5.69,16.9L4.27,18.33C3.03,16.81 2.26,14.96 2.06,13M7.1,18.37C8.23,19.25 9.58,19.82 11,20V22C9.04,21.79 7.18,21 5.67,19.74L7.1,18.37M12,7.5L7.5,12H11V16H13V12H16.5L12,7.5Z";
var mdiProgressWrench = "M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37M16.82,15.19L12.71,11.08C13.12,10.04 12.89,8.82 12.03,7.97C11.13,7.06 9.78,6.88 8.69,7.38L10.63,9.32L9.28,10.68L7.29,8.73C6.75,9.82 7,11.17 7.88,12.08C8.74,12.94 9.96,13.16 11,12.76L15.11,16.86C15.29,17.05 15.56,17.05 15.74,16.86L16.78,15.83C17,15.65 17,15.33 16.82,15.19Z";
var mdiProjector = "M16,6C14.87,6 13.77,6.35 12.84,7H4C2.89,7 2,7.89 2,9V15C2,16.11 2.89,17 4,17H5V18A1,1 0 0,0 6,19H8A1,1 0 0,0 9,18V17H15V18A1,1 0 0,0 16,19H18A1,1 0 0,0 19,18V17H20C21.11,17 22,16.11 22,15V9C22,7.89 21.11,7 20,7H19.15C18.23,6.35 17.13,6 16,6M16,7.5A3.5,3.5 0 0,1 19.5,11A3.5,3.5 0 0,1 16,14.5A3.5,3.5 0 0,1 12.5,11A3.5,3.5 0 0,1 16,7.5M4,9H8V10H4V9M16,9A2,2 0 0,0 14,11A2,2 0 0,0 16,13A2,2 0 0,0 18,11A2,2 0 0,0 16,9M4,11H8V12H4V11M4,13H8V14H4V13Z";
var mdiProjectorOff = "M16 9C14.97 9 14.1 9.79 14 10.82L16.18 13C18.72 12.76 18.55 9 16 9M15 14.35H15L18.95 18.31V18.3M7.64 7L12.65 12V12L7.65 7M20 7H19.15C17.26 5.67 14.73 5.67 12.84 7H10.19L12.8 9.61C13.78 7.34 16.73 6.78 18.5 8.53C20.22 10.27 19.66 13.22 17.39 14.2L20.18 17C21.21 16.9 22 16.04 22 15V9C22 7.9 21.1 7 20 7M16 9C14.97 9 14.1 9.79 14 10.82L16.18 13C18.72 12.76 18.55 9 16 9M16 9C14.97 9 14.1 9.79 14 10.82L16.18 13C18.72 12.76 18.55 9 16 9M22.25 21.61L2.53 1.89L1.26 3.16L5.1 7H4C2.9 7 2 7.9 2 9V15C2 16.11 2.9 17 4 17H5V18C5 18.55 5.45 19 6 19H8C8.55 19 9 18.55 9 18V17H15V18C15 18.55 15.45 19 16 19H17.1L21 22.89L22.26 21.61M8 14H4V13H8M8 12H4V11H8M8 10H4V9H7.1L8 9.9M2.54 1.89L7.64 7L2.53 1.89M7.65 7L12.65 12V12L7.64 7M18.95 18.3V18.31L15 14.35H15M7.64 7L2.53 1.89H2.54M12.65 12V12L7.64 7H7.65M18.95 18.3V18.31L15 14.35H15";
var mdiProjectorScreen = "M4,2A1,1 0 0,0 3,3V4A1,1 0 0,0 4,5H5V14H11V16.59L6.79,20.79L8.21,22.21L11,19.41V22H13V19.41L15.79,22.21L17.21,20.79L13,16.59V14H19V5H20A1,1 0 0,0 21,4V3A1,1 0 0,0 20,2H4Z";
var mdiProjectorScreenOff = "M13 14.89V16.59L17.21 20.79L15.79 22.21L13 19.41V22H11V19.41L8.21 22.21L6.79 20.79L11 16.59V14H5V6.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73L13 14.89M19 14V5H20C20.55 5 21 4.55 21 4V3C21 2.45 20.55 2 20 2H5.2L17.2 14H19Z";
var mdiProjectorScreenOffOutline = "M20.84 22.73L22.11 21.46L2.39 1.73L1.11 3L5 6.89V14H11V16.59L6.79 20.79L8.21 22.21L11 19.41V22H13V19.41L15.79 22.21L17.21 20.79L13 16.59V14.89L20.84 22.73M7 12V8.89L10.11 12H7M8.2 5L5.2 2H20C20.55 2 21 2.45 21 3V4C21 4.55 20.55 5 20 5H19V14H17.2L15.2 12H17V5H8.2Z";
var mdiProjectorScreenOutline = "M20 2H4C3.45 2 3 2.45 3 3V4C3 4.55 3.45 5 4 5H5V14H11V16.59L6.79 20.79L8.21 22.21L11 19.41V22H13V19.41L15.79 22.21L17.21 20.79L13 16.59V14H19V5H20C20.55 5 21 4.55 21 4V3C21 2.45 20.55 2 20 2M17 12H7V5H17V12Z";
var mdiProjectorScreenVariant = "M19 18V9H20C20.55 9 21 8.55 21 8V7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7V8C3 8.55 3.45 9 4 9H5V18H19Z";
var mdiProjectorScreenVariantOff = "M20.84 22.73L16.11 18H5V9H4C3.45 9 3 8.55 3 8V7C3 6.45 3.45 6 4 6H4.11L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M19 9H20C20.55 9 21 8.55 21 8V7C21 6.45 20.55 6 20 6H9.2L19 15.8V9Z";
var mdiProjectorScreenVariantOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L4.11 6H4C3.45 6 3 6.45 3 7V8C3 8.55 3.45 9 4 9H5V18H16.11L20.84 22.73L22.11 21.46M7 16V9H7.11L14.11 16H7M12.2 9L9.2 6H20C20.55 6 21 6.45 21 7V8C21 8.55 20.55 9 20 9H19V15.8L17 13.8V9H12.2Z";
var mdiProjectorScreenVariantOutline = "M20 6H4C3.45 6 3 6.45 3 7V8C3 8.55 3.45 9 4 9H5V18H19V9H20C20.55 9 21 8.55 21 8V7C21 6.45 20.55 6 20 6M17 16H7V9H17V16Z";
var mdiPropaneTank = "M4 15V18C4 20.21 5.79 22 8 22H16C18.21 22 20 20.21 20 18V15H4M20 13V10C20 8.14 18.72 6.59 17 6.14V4C17 2.9 16.1 2 15 2H9C7.9 2 7 2.9 7 4V6.14C5.28 6.59 4 8.14 4 10V13H20M9 4H15V6H13C13 5.45 12.55 5 12 5S11 5.45 11 6H9V4Z";
var mdiPropaneTankOutline = "M17 6.14V4C17 2.9 16.1 2 15 2H9C7.9 2 7 2.9 7 4V6.14C5.28 6.59 4 8.14 4 10V18C4 20.21 5.79 22 8 22H16C18.21 22 20 20.21 20 18V10C20 8.14 18.72 6.59 17 6.14M9 4H15V6H13C13 5.45 12.55 5 12 5S11 5.45 11 6H9V4M8 8H16C17.1 8 18 8.9 18 10V13H6V10C6 8.9 6.9 8 8 8M16 20H8C6.9 20 6 19.1 6 18V15H18V18C18 19.1 17.1 20 16 20Z";
var mdiProtocol = "M18 20H14L18 4H22M16 4H12L8 20H12M2 16.5A2.5 2.5 0 0 0 4.5 19A2.5 2.5 0 0 0 7 16.5A2.5 2.5 0 0 0 4.5 14A2.5 2.5 0 0 0 2 16.5M2 9.5A2.5 2.5 0 0 0 4.5 12A2.5 2.5 0 0 0 7 9.5A2.5 2.5 0 0 0 4.5 7A2.5 2.5 0 0 0 2 9.5Z";
var mdiPublish = "M5,4V6H19V4H5M5,14H9V20H15V14H19L12,7L5,14Z";
var mdiPublishOff = "M20.8 22.7L15 16.9V20H9V14H5L8.6 10.4L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M19 6V4H7.2L9.2 6H19M17.2 14H19L12 7L11.1 7.9L17.2 14Z";
var mdiPulse = "M3,13H5.79L10.1,4.79L11.28,13.75L14.5,9.66L17.83,13H21V15H17L14.67,12.67L9.92,18.73L8.94,11.31L7,15H3V13Z";
var mdiPump = "M2 21V15H3.5C3.18 14.06 3 13.05 3 12C3 7.03 7.03 3 12 3H22V9H20.5C20.82 9.94 21 10.95 21 12C21 16.97 16.97 21 12 21H2M5 12C5 13.28 5.34 14.47 5.94 15.5L9.4 13.5C9.15 13.06 9 12.55 9 12C9 11.35 9.21 10.75 9.56 10.26L6.3 7.93C5.5 9.08 5 10.5 5 12M12 19C14.59 19 16.85 17.59 18.06 15.5L14.6 13.5C14.08 14.4 13.11 15 12 15L11.71 15L11.33 18.97L12 19M12 9C13.21 9 14.26 9.72 14.73 10.76L18.37 9.1C17.27 6.68 14.83 5 12 5V9M12 11C11.45 11 11 11.45 11 12C11 12.55 11.45 13 12 13C12.55 13 13 12.55 13 12C13 11.45 12.55 11 12 11Z";
var mdiPumpOff = "M22.1 21.5L2.4 1.7L1.1 3L4.8 6.7C3.7 8.2 3 10 3 12C3 13 3.2 14.1 3.5 15H2V21H12C14 21 15.8 20.3 17.3 19.2L20.8 22.7L22.1 21.5M5.9 15.5C5.3 14.5 5 13.3 5 12C5 10.6 5.5 9.2 6.2 8.1L9.2 11.1C9.1 11.3 9 11.7 9 12C9 12.5 9.2 13.1 9.4 13.5L5.9 15.5M12 19H11.3L11.7 15H12C12.3 15 12.6 14.9 12.9 14.8L15.9 17.8C14.8 18.5 13.4 19 12 19M12 8.8L7.4 4.2C8.8 3.5 10.3 3 12 3H22V9H20.5C20.8 9.9 21 11 21 12C21 13.7 20.5 15.2 19.8 16.6L12.2 9C13.3 9.1 14.3 9.8 14.7 10.7L18.3 9C17.3 6.7 14.8 5 12 5V8.8Z";
var mdiPumpkin = "M6.5,6C7.47,6 8.37,6.5 9.11,7.38C9.66,6.79 10.31,6.36 11,6.15V4A2,2 0 0,1 13,2H15V4H13V6.15C13.69,6.36 14.34,6.79 14.89,7.38C15.63,6.5 16.53,6 17.5,6C20,6 22,9.36 22,13.5C22,17.64 20,21 17.5,21C16.53,21 15.63,20.5 14.89,19.62C14.08,20.5 13.08,21 12,21C10.92,21 9.92,20.5 9.11,19.62C8.37,20.5 7.47,21 6.5,21C4,21 2,17.64 2,13.5C2,9.36 4,6 6.5,6Z";
var mdiPurse = "M22,19.1L21,10.5A1.65,1.65 0 0,0 19.3,9H16V5L14,3H10L8,5V9H4.7A1.65,1.65 0 0,0 3,10.5L2,19.1A1.74,1.74 0 0,0 3.7,21H20.3A1.74,1.74 0 0,0 22,19.1M10,5H14V9H10";
var mdiPurseOutline = "M19,11L20,19H4L5,11H19M14,3H10L8,5V9H4.7A1.65,1.65 0 0,0 3,10.5L2,19.1A1.74,1.74 0 0,0 3.7,21H20.3A1.74,1.74 0 0,0 22,19.1L21,10.5A1.65,1.65 0 0,0 19.3,9H16V5L14,3M10,9V5H14V9";
var mdiPuzzle = "M20.5,11H19V7C19,5.89 18.1,5 17,5H13V3.5A2.5,2.5 0 0,0 10.5,1A2.5,2.5 0 0,0 8,3.5V5H4A2,2 0 0,0 2,7V10.8H3.5C5,10.8 6.2,12 6.2,13.5C6.2,15 5,16.2 3.5,16.2H2V20A2,2 0 0,0 4,22H7.8V20.5C7.8,19 9,17.8 10.5,17.8C12,17.8 13.2,19 13.2,20.5V22H17A2,2 0 0,0 19,20V16H20.5A2.5,2.5 0 0,0 23,13.5A2.5,2.5 0 0,0 20.5,11Z";
var mdiPuzzleCheck = "M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M20.5 11C21.88 11 23 12.12 23 13.5C23 13.81 22.94 14.11 22.84 14.39C21.8 13.5 20.46 13 19 13C15.69 13 13 15.69 13 19V19.54C12.64 18.5 11.65 17.8 10.5 17.8C9 17.8 7.8 19 7.8 20.5V22H4C2.9 22 2 21.1 2 20V16.2H3.5C5 16.2 6.2 15 6.2 13.5S5 10.8 3.5 10.8H2V7C2 5.89 2.9 5 4 5H8V3.5C8 2.12 9.12 .998 10.5 .998S13 2.12 13 3.5V5H17C18.1 5 19 5.89 19 7V11H20.5";
var mdiPuzzleCheckOutline = "M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M22 13.5L22 13.8C21.37 13.44 20.67 13.19 19.94 13.07C19.75 12.45 19.18 12 18.5 12H17V7H12V5.5C12 4.67 11.33 4 10.5 4C9.67 4 9 4.67 9 5.5V7H4L4 9.12C5.76 9.8 7 11.5 7 13.5C7 15.5 5.75 17.2 4 17.88V20H6.12C6.8 18.25 8.5 17 10.5 17C11.47 17 12.37 17.3 13.12 17.8L13 19C13 20.09 13.29 21.12 13.8 22H13.2V21.7C13.2 20.21 12 19 10.5 19C9 19 7.8 20.21 7.8 21.7V22H4C2.9 22 2 21.1 2 20V16.2H2.3C3.79 16.2 5 15 5 13.5C5 12 3.79 10.8 2.3 10.8H2V7C2 5.9 2.9 5 4 5H7.04C7.28 3.3 8.74 2 10.5 2C12.26 2 13.72 3.3 13.96 5H17C18.1 5 19 5.9 19 7V10.04C20.7 10.28 22 11.74 22 13.5Z";
var mdiPuzzleEdit = "M21.04 12.13C20.9 12.13 20.76 12.19 20.65 12.3L19.65 13.3L21.7 15.35L22.7 14.35C22.92 14.14 22.92 13.79 22.7 13.58L21.42 12.3C21.31 12.19 21.18 12.13 21.04 12.13M19.07 13.88L13 19.94V22H15.06L21.12 15.93L19.07 13.88M19 11.12L11.91 18.2C11.5 17.95 11 17.8 10.5 17.8C9 17.8 7.8 19 7.8 20.5V22H4C2.9 22 2 21.11 2 20V16.2H3.5C5 16.2 6.2 15 6.2 13.5S5 10.8 3.5 10.8H2V7C2 5.9 2.9 5 4 5H8V3.5C8 2.12 9.12 1 10.5 1S13 2.12 13 3.5V5H17C18.1 5 19 5.89 19 7V11.12Z";
var mdiPuzzleEditOutline = "M21.04 12.13C20.9 12.13 20.76 12.19 20.65 12.3L19.65 13.3L21.7 15.35L22.7 14.35C22.92 14.14 22.92 13.79 22.7 13.58L21.42 12.3C21.31 12.19 21.18 12.13 21.04 12.13M19.07 13.88L13 19.94V22H15.06L21.12 15.93L19.07 13.88M11.05 19.06C10.87 19 10.69 19 10.5 19C9 19 7.8 20.21 7.8 21.7V22H4C2.9 22 2 21.11 2 20V16.2H2.3C3.79 16.2 5 15 5 13.5S3.79 10.8 2.3 10.8H2V7C2 5.9 2.9 5 4 5H7.04C7.28 3.3 8.74 2 10.5 2S13.72 3.3 13.96 5H17C18.11 5 19 5.9 19 7V10.04C19.36 10.09 19.69 10.21 20 10.36C19.73 10.5 19.46 10.66 19.24 10.89L18.12 12H17V7H12V5.5C12 4.67 11.33 4 10.5 4S9 4.67 9 5.5V7H4V9.12C5.76 9.8 7 11.5 7 13.5S5.75 17.2 4 17.88V20H6.12C6.8 18.25 8.5 17 10.5 17C11.26 17 12 17.18 12.61 17.5L11.05 19.06Z";
var mdiPuzzleHeart = "M19 22.3L18.4 21.8C16.4 19.9 15 18.7 15 17.2C15 16 16 15 17.2 15C17.9 15 18.6 15.3 19 15.8C19.4 15.3 20.1 15 20.8 15C22 15 23 15.9 23 17.2C23 18.7 21.6 19.9 19.6 21.8L19 22.3M20.5 11H19V7C19 5.89 18.1 5 17 5H13V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4C2.9 5 2 5.9 2 7V10.8H3.5C5 10.8 6.2 12 6.2 13.5S5 16.2 3.5 16.2H2V20C2 21.11 2.9 22 4 22H7.8V20.5C7.8 19 9 17.8 10.5 17.8C11.44 17.8 12.27 18.27 12.75 19H13.09C13.04 18.67 13 18.34 13 18C13 14.69 15.69 12 19 12C20.54 12 21.94 12.58 23 13.53C23 13.5 23 13.5 23 13.5C23 12.12 21.88 11 20.5 11Z";
var mdiPuzzleHeartOutline = "M13.2 22V21.7C13.2 20.21 12 19 10.5 19C9 19 7.8 20.21 7.8 21.7V22H4C2.9 22 2 21.11 2 20V16.2H2.3C3.79 16.2 5 15 5 13.5S3.79 10.8 2.3 10.8H2V7C2 5.9 2.9 5 4 5H7.04C7.28 3.3 8.74 2 10.5 2S13.72 3.3 13.96 5H17C18.11 5 19 5.9 19 7V10.04C20.45 10.25 21.61 11.34 21.91 12.76C21.05 12.28 20.06 12 19 12C18.89 12 18.78 12 18.67 12C18.61 12 18.56 12 18.5 12H17V7H12V5.5C12 4.67 11.33 4 10.5 4S9 4.67 9 5.5V7H4V9.12C5.76 9.8 7 11.5 7 13.5S5.75 17.2 4 17.88V20H6.12C6.8 18.25 8.5 17 10.5 17C11.43 17 12.29 17.28 13 17.74C13 17.83 13 17.91 13 18C13 19.54 13.58 20.94 14.54 22H13.2M19 22.3L19.6 21.8C21.6 19.9 23 18.7 23 17.2C23 15.9 22 15 20.8 15C20.1 15 19.4 15.3 19 15.8C18.6 15.3 17.9 15 17.2 15C16 15 15 16 15 17.2C15 18.7 16.4 19.9 18.4 21.8L19 22.3";
var mdiPuzzleMinus = "M13.04 19.61C12.67 18.55 11.68 17.8 10.5 17.8C9 17.8 7.8 19 7.8 20.5V22H4C2.9 22 2 21.11 2 20V16.2H3.5C5 16.2 6.2 15 6.2 13.5S5 10.8 3.5 10.8H2V7C2 5.9 2.9 5 4 5H8V3.5C8 2.12 9.12 1 10.5 1S13 2.12 13 3.5V5H17C18.1 5 19 5.89 19 7V11H20.5C21.88 11 23 12.12 23 13.5C23 13.82 22.94 14.12 22.83 14.39C21.79 13.53 20.46 13 19 13C15.69 13 13 15.69 13 19C13 19.2 13 19.41 13.04 19.61M15 18V20H23V18H15Z";
var mdiPuzzleMinusOutline = "M13.2 22V21.7C13.2 20.21 12 19 10.5 19C9 19 7.8 20.21 7.8 21.7V22H4C2.9 22 2 21.11 2 20V16.2H2.3C3.79 16.2 5 15 5 13.5S3.79 10.8 2.3 10.8H2V7C2 5.9 2.9 5 4 5H7.04C7.28 3.3 8.74 2 10.5 2S13.72 3.3 13.96 5H17C18.11 5 19 5.9 19 7V10.04C20.7 10.28 22 11.74 22 13.5C22 13.6 22 13.7 21.97 13.79C21.35 13.44 20.67 13.2 19.93 13.08C19.75 12.46 19.18 12 18.5 12H17V7H12V5.5C12 4.67 11.33 4 10.5 4S9 4.67 9 5.5V7H4V9.12C5.76 9.8 7 11.5 7 13.5S5.75 17.2 4 17.88V20H6.12C6.8 18.25 8.5 17 10.5 17C11.47 17 12.37 17.3 13.12 17.81C13.04 18.19 13 18.59 13 19C13 20.1 13.3 21.12 13.81 22H13.2M15 18V20H23V18H15Z";
var mdiPuzzleOutline = "M22,13.5C22,15.26 20.7,16.72 19,16.96V20A2,2 0 0,1 17,22H13.2V21.7A2.7,2.7 0 0,0 10.5,19C9,19 7.8,20.21 7.8,21.7V22H4A2,2 0 0,1 2,20V16.2H2.3C3.79,16.2 5,15 5,13.5C5,12 3.79,10.8 2.3,10.8H2V7A2,2 0 0,1 4,5H7.04C7.28,3.3 8.74,2 10.5,2C12.26,2 13.72,3.3 13.96,5H17A2,2 0 0,1 19,7V10.04C20.7,10.28 22,11.74 22,13.5M17,15H18.5A1.5,1.5 0 0,0 20,13.5A1.5,1.5 0 0,0 18.5,12H17V7H12V5.5A1.5,1.5 0 0,0 10.5,4A1.5,1.5 0 0,0 9,5.5V7H4V9.12C5.76,9.8 7,11.5 7,13.5C7,15.5 5.75,17.2 4,17.88V20H6.12C6.8,18.25 8.5,17 10.5,17C12.5,17 14.2,18.25 14.88,20H17V15Z";
var mdiPuzzlePlus = "M13.04 19.61C12.67 18.55 11.68 17.8 10.5 17.8C9 17.8 7.8 19 7.8 20.5V22H4C2.9 22 2 21.11 2 20V16.2H3.5C5 16.2 6.2 15 6.2 13.5S5 10.8 3.5 10.8H2V7C2 5.9 2.9 5 4 5H8V3.5C8 2.12 9.12 1 10.5 1S13 2.12 13 3.5V5H17C18.1 5 19 5.89 19 7V11H20.5C21.88 11 23 12.12 23 13.5C23 13.82 22.94 14.12 22.83 14.39C21.79 13.53 20.46 13 19 13C15.69 13 13 15.69 13 19C13 19.2 13 19.41 13.04 19.61M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiPuzzlePlusOutline = "M13.2 22V21.7C13.2 20.21 12 19 10.5 19C9 19 7.8 20.21 7.8 21.7V22H4C2.9 22 2 21.11 2 20V16.2H2.3C3.79 16.2 5 15 5 13.5S3.79 10.8 2.3 10.8H2V7C2 5.9 2.9 5 4 5H7.04C7.28 3.3 8.74 2 10.5 2S13.72 3.3 13.96 5H17C18.11 5 19 5.9 19 7V10.04C20.7 10.28 22 11.74 22 13.5C22 13.6 22 13.7 21.97 13.79C21.35 13.44 20.67 13.2 19.93 13.08C19.75 12.46 19.18 12 18.5 12H17V7H12V5.5C12 4.67 11.33 4 10.5 4S9 4.67 9 5.5V7H4V9.12C5.76 9.8 7 11.5 7 13.5S5.75 17.2 4 17.88V20H6.12C6.8 18.25 8.5 17 10.5 17C11.47 17 12.37 17.3 13.12 17.81C13.04 18.19 13 18.59 13 19C13 20.1 13.3 21.12 13.81 22H13.2M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiPuzzleRemove = "M13.04 19.61C12.67 18.55 11.68 17.8 10.5 17.8C9 17.8 7.8 19 7.8 20.5V22H4C2.9 22 2 21.11 2 20V16.2H3.5C5 16.2 6.2 15 6.2 13.5S5 10.8 3.5 10.8H2V7C2 5.9 2.9 5 4 5H8V3.5C8 2.12 9.12 1 10.5 1S13 2.12 13 3.5V5H17C18.1 5 19 5.89 19 7V11H20.5C21.88 11 23 12.12 23 13.5C23 13.82 22.94 14.12 22.83 14.39C21.79 13.53 20.46 13 19 13C15.69 13 13 15.69 13 19C13 19.2 13 19.41 13.04 19.61M21.12 15.46L19 17.59L16.88 15.46L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46Z";
var mdiPuzzleRemoveOutline = "M13.2 22V21.7C13.2 20.21 12 19 10.5 19C9 19 7.8 20.21 7.8 21.7V22H4C2.9 22 2 21.11 2 20V16.2H2.3C3.79 16.2 5 15 5 13.5S3.79 10.8 2.3 10.8H2V7C2 5.9 2.9 5 4 5H7.04C7.28 3.3 8.74 2 10.5 2S13.72 3.3 13.96 5H17C18.11 5 19 5.9 19 7V10.04C20.7 10.28 22 11.74 22 13.5C22 13.6 22 13.7 21.97 13.79C21.35 13.44 20.67 13.2 19.93 13.08C19.75 12.46 19.18 12 18.5 12H17V7H12V5.5C12 4.67 11.33 4 10.5 4S9 4.67 9 5.5V7H4V9.12C5.76 9.8 7 11.5 7 13.5S5.75 17.2 4 17.88V20H6.12C6.8 18.25 8.5 17 10.5 17C11.47 17 12.37 17.3 13.12 17.81C13.04 18.19 13 18.59 13 19C13 20.1 13.3 21.12 13.81 22H13.2M21.12 15.46L19 17.59L16.88 15.46L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46Z";
var mdiPuzzleStar = "M19 20.09L21.45 21.58L20.8 18.77L23 16.89L20.11 16.64L19 14L17.87 16.64L15 16.89L17.18 18.77L16.5 21.58L19 20.09M23 13.5C23 13.5 23 13.5 23 13.53C21.94 12.58 20.54 12 19 12C15.69 12 13 14.69 13 18C13 18.34 13.04 18.67 13.09 19H12.75C12.27 18.27 11.44 17.8 10.5 17.8C9 17.8 7.8 19 7.8 20.5V22H4C2.9 22 2 21.11 2 20V16.2H3.5C5 16.2 6.2 15 6.2 13.5S5 10.8 3.5 10.8H2V7C2 5.9 2.9 5 4 5H8V3.5C8 2.12 9.12 1 10.5 1S13 2.12 13 3.5V5H17C18.1 5 19 5.89 19 7V11H20.5C21.88 11 23 12.12 23 13.5Z";
var mdiPuzzleStarOutline = "M13.2 22V21.7C13.2 20.21 12 19 10.5 19C9 19 7.8 20.21 7.8 21.7V22H4C2.9 22 2 21.11 2 20V16.2H2.3C3.79 16.2 5 15 5 13.5S3.79 10.8 2.3 10.8H2V7C2 5.9 2.9 5 4 5H7.04C7.28 3.3 8.74 2 10.5 2S13.72 3.3 13.96 5H17C18.11 5 19 5.9 19 7V10.04C20.45 10.25 21.61 11.34 21.91 12.76C21.05 12.28 20.06 12 19 12C18.89 12 18.78 12 18.67 12C18.61 12 18.56 12 18.5 12H17V7H12V5.5C12 4.67 11.33 4 10.5 4S9 4.67 9 5.5V7H4V9.12C5.76 9.8 7 11.5 7 13.5S5.75 17.2 4 17.88V20H6.12C6.8 18.25 8.5 17 10.5 17C11.43 17 12.29 17.28 13 17.74C13 17.83 13 17.91 13 18C13 19.54 13.58 20.94 14.54 22H13.2M19 20.09L16.5 21.58L17.18 18.77L15 16.89L17.87 16.64L19 14L20.11 16.64L23 16.89L20.8 18.77L21.45 21.58L19 20.09";
var mdiPyramid = "M21.85 16.96H21.85L12.85 2.47C12.65 2.16 12.33 2 12 2S11.35 2.16 11.15 2.47L2.15 16.96H2.15C1.84 17.45 2 18.18 2.64 18.43L11.64 21.93C11.75 22 11.88 22 12 22S12.25 22 12.36 21.93L21.36 18.43C22 18.18 22.16 17.45 21.85 16.96M11 6.5V13.32L5.42 15.5L11 6.5M12 19.93L5.76 17.5L12 15.07L18.24 17.5L12 19.93M13 13.32V6.5L18.58 15.5L13 13.32Z";
var mdiPyramidOff = "M10.5 7.3L9.05 5.85L11.15 2.47C11.35 2.16 11.67 2 12 2C12.33 2 12.65 2.16 12.85 2.47L21.85 16.96H21.85C22.13 17.4 22 18 21.5 18.32L18.41 15.21L13 6.5V9.8L11 7.8V6.5L10.5 7.3M22.11 21.46L20.84 22.73L17.89 19.78L12.36 21.93C12.25 22 12.12 22 12 22S11.75 22 11.64 21.93L2.64 18.43C2 18.18 1.84 17.45 2.15 16.96H2.15L7.1 9L1.11 3L2.39 1.73L22.11 21.46M5.42 15.5L11 13.32V12.89L8.55 10.44L5.42 15.5M16.35 18.24L13.94 15.83L12 15.07L5.76 17.5L12 19.93L16.35 18.24Z";
var mdiQi = "M12.09,6.56V14.64C12.09,14.72 12,14.79 11.94,14.79C9.62,14.79 7.75,12.91 7.75,10.6C7.75,8.28 9.62,6.4 11.94,6.4C12,6.4 12.09,6.47 12.09,6.56M12.09,17.86V20.29C12.06,21.69 13.12,22.87 14.5,23C14.66,23 14.78,22.89 14.79,22.73V4.47C14.78,4.3 14.68,4.15 14.5,4.09C10.92,2.67 6.86,4.44 5.44,8.03C4,11.63 5.79,15.69 9.38,17.11C10.16,17.42 11,17.58 11.81,17.6C11.95,17.59 12.07,17.71 12.08,17.87M16.19,5.5V15.72C16.19,16 16.19,16.2 16.46,16V16C19.42,13.5 19.81,9.09 17.33,6.13C17.07,5.81 16.77,5.5 16.46,5.26C16.19,5.05 16.19,5.26 16.19,5.53M14.79,2.43C14.79,1.66 15.42,1.03 16.19,1.03C16.96,1.03 17.59,1.66 17.59,2.43C17.59,3.2 16.96,3.83 16.19,3.83V3.83C15.42,3.83 14.79,3.2 14.79,2.43";
var mdiQqchat = "M3.18,13.54C3.76,12.16 4.57,11.14 5.17,10.92C5.16,10.12 5.31,9.62 5.56,9.22C5.56,9.19 5.5,8.86 5.72,8.45C5.87,4.85 8.21,2 12,2C15.79,2 18.13,4.85 18.28,8.45C18.5,8.86 18.44,9.19 18.44,9.22C18.69,9.62 18.84,10.12 18.83,10.92C19.43,11.14 20.24,12.16 20.82,13.55C21.57,15.31 21.69,17 21.09,17.3C20.68,17.5 20.03,17 19.42,16.12C19.18,17.1 18.58,18 17.73,18.71C18.63,19.04 19.21,19.58 19.21,20.19C19.21,21.19 17.63,22 15.69,22C13.93,22 12.5,21.34 12.21,20.5H11.79C11.5,21.34 10.07,22 8.31,22C6.37,22 4.79,21.19 4.79,20.19C4.79,19.58 5.37,19.04 6.27,18.71C5.42,18 4.82,17.1 4.58,16.12C3.97,17 3.32,17.5 2.91,17.3C2.31,17 2.43,15.31 3.18,13.54Z";
var mdiQrcode = "M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H11V13H9V11M15,11H17V13H19V11H21V13H19V15H21V19H19V21H17V19H13V21H11V17H15V15H17V13H15V11M19,19V15H17V19H19M15,3H21V9H15V3M17,5V7H19V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9V21H3V15M5,17V19H7V17H5Z";
var mdiQrcodeEdit = "M5,5H7V7H5V5M1,1H11V11H1V1M3,3V9H9V3H3M5,17H7V19H5V17M1,13H11V23H1V13M3,15V21H9V15H3M13,13H17V15H19V13H23V15H19V17H23V23H19V21H15V23H13V21H15V19H13V13M21,21V19H19V21H21M19,17H17V15H15V19H19V17M22.7,3.35L21.7,4.35L19.65,2.35L20.65,1.35C20.85,1.14 21.19,1.13 21.42,1.35L22.7,2.58C22.91,2.78 22.92,3.12 22.7,3.35M13,8.94L19.07,2.88L21.12,4.93L15.06,11H13V8.94Z";
var mdiQrcodeMinus = "M5 5H7V7H5V5M1 1H11V11H1V1M3 3V9H9V3H3M5 17H7V19H5V17M1 13H11V23H1V13M3 15V21H9V15H3M13 13H17V15H19V13H23V15H19V17H23V23H19V21H15V23H13V21H15V19H13V13M21 21V19H19V21H21M19 17H17V15H15V19H19V17M14 5V7H22V5Z";
var mdiQrcodePlus = "M5 5H7V7H5V5M1 1H11V11H1V1M3 3V9H9V3H3M5 17H7V19H5V17M1 13H11V23H1V13M3 15V21H9V15H3M13 13H17V15H19V13H23V15H19V17H23V23H19V21H15V23H13V21H15V19H13V13M21 21V19H19V21H21M19 17H17V15H15V19H19V17M17 2V5H14V7H17V10H19V7H22V5H19V2Z";
var mdiQrcodeRemove = "M5 5H7V7H5V5M1 1H11V11H1V1M3 3V9H9V3H3M5 17H7V19H5V17M1 13H11V23H1V13M3 15V21H9V15H3M13 13H17V15H19V13H23V15H19V17H23V23H19V21H15V23H13V21H15V19H13V13M21 21V19H19V21H21M19 17H17V15H15V19H19V17M15.17 1.76L13.76 3.17L16.59 6L13.76 8.83L15.17 10.24L18 7.41L20.83 10.24L22.24 8.83L19.41 6L22.24 3.17L20.83 1.76L18 4.59L15.17 1.76Z";
var mdiQrcodeScan = "M4,4H10V10H4V4M20,4V10H14V4H20M14,15H16V13H14V11H16V13H18V11H20V13H18V15H20V18H18V20H16V18H13V20H11V16H14V15M16,15V18H18V15H16M4,20V14H10V20H4M6,6V8H8V6H6M16,6V8H18V6H16M6,16V18H8V16H6M4,11H6V13H4V11M9,11H13V15H11V13H9V11M11,6H13V10H11V6M2,2V6H0V2A2,2 0 0,1 2,0H6V2H2M22,0A2,2 0 0,1 24,2V6H22V2H18V0H22M2,18V22H6V24H2A2,2 0 0,1 0,22V18H2M22,22V18H24V22A2,2 0 0,1 22,24H18V22H22Z";
var mdiQuadcopter = "M5.5,1C8,1 10,3 10,5.5C10,6.38 9.75,7.2 9.31,7.9L9.41,8H14.59L14.69,7.9C14.25,7.2 14,6.38 14,5.5C14,3 16,1 18.5,1C21,1 23,3 23,5.5C23,8 21,10 18.5,10C17.62,10 16.8,9.75 16.1,9.31L15,10.41V13.59L16.1,14.69C16.8,14.25 17.62,14 18.5,14C21,14 23,16 23,18.5C23,21 21,23 18.5,23C16,23 14,21 14,18.5C14,17.62 14.25,16.8 14.69,16.1L14.59,16H9.41L9.31,16.1C9.75,16.8 10,17.62 10,18.5C10,21 8,23 5.5,23C3,23 1,21 1,18.5C1,16 3,14 5.5,14C6.38,14 7.2,14.25 7.9,14.69L9,13.59V10.41L7.9,9.31C7.2,9.75 6.38,10 5.5,10C3,10 1,8 1,5.5C1,3 3,1 5.5,1M5.5,3A2.5,2.5 0 0,0 3,5.5A2.5,2.5 0 0,0 5.5,8A2.5,2.5 0 0,0 8,5.5A2.5,2.5 0 0,0 5.5,3M5.5,16A2.5,2.5 0 0,0 3,18.5A2.5,2.5 0 0,0 5.5,21A2.5,2.5 0 0,0 8,18.5A2.5,2.5 0 0,0 5.5,16M18.5,3A2.5,2.5 0 0,0 16,5.5A2.5,2.5 0 0,0 18.5,8A2.5,2.5 0 0,0 21,5.5A2.5,2.5 0 0,0 18.5,3M18.5,16A2.5,2.5 0 0,0 16,18.5A2.5,2.5 0 0,0 18.5,21A2.5,2.5 0 0,0 21,18.5A2.5,2.5 0 0,0 18.5,16M3.91,17.25L5.04,17.91C5.17,17.81 5.33,17.75 5.5,17.75A0.75,0.75 0 0,1 6.25,18.5L6.24,18.6L7.37,19.25L7.09,19.75L5.96,19.09C5.83,19.19 5.67,19.25 5.5,19.25A0.75,0.75 0 0,1 4.75,18.5L4.76,18.4L3.63,17.75L3.91,17.25M3.63,6.25L4.76,5.6L4.75,5.5A0.75,0.75 0 0,1 5.5,4.75C5.67,4.75 5.83,4.81 5.96,4.91L7.09,4.25L7.37,4.75L6.24,5.4L6.25,5.5A0.75,0.75 0 0,1 5.5,6.25C5.33,6.25 5.17,6.19 5.04,6.09L3.91,6.75L3.63,6.25M16.91,4.25L18.04,4.91C18.17,4.81 18.33,4.75 18.5,4.75A0.75,0.75 0 0,1 19.25,5.5L19.24,5.6L20.37,6.25L20.09,6.75L18.96,6.09C18.83,6.19 18.67,6.25 18.5,6.25A0.75,0.75 0 0,1 17.75,5.5L17.76,5.4L16.63,4.75L16.91,4.25M16.63,19.25L17.75,18.5A0.75,0.75 0 0,1 18.5,17.75C18.67,17.75 18.83,17.81 18.96,17.91L20.09,17.25L20.37,17.75L19.25,18.5A0.75,0.75 0 0,1 18.5,19.25C18.33,19.25 18.17,19.19 18.04,19.09L16.91,19.75L16.63,19.25Z";
var mdiQualityHigh = "M14.5,13.5H16.5V10.5H14.5M18,14A1,1 0 0,1 17,15H16.25V16.5H14.75V15H14A1,1 0 0,1 13,14V10A1,1 0 0,1 14,9H17A1,1 0 0,1 18,10M11,15H9.5V13H7.5V15H6V9H7.5V11.5H9.5V9H11M19,4H5C3.89,4 3,4.89 3,6V18A2,2 0 0,0 5,20H19A2,2 0 0,0 21,18V6C21,4.89 20.1,4 19,4Z";
var mdiQualityLow = "M14.5,13.5H16.5V10.5H14.5M18,14C18,14.6 17.6,15 17,15H16.25V16.5H14.75V15H14C13.4,15 13,14.6 13,14V10C13,9.4 13.4,9 14,9H17C17.6,9 18,9.4 18,10M19,4H5A2,2 0 0,0 3,6V18A2,2 0 0,0 5,20H19A2,2 0 0,0 21,18V6A2,2 0 0,0 19,4M11,13.5V15H6V9H7.5V13.5H11Z";
var mdiQualityMedium = "M21,6V18A2,2 0 0,1 19,20H5A2,2 0 0,1 3,18V6A2,2 0 0,1 5,4H19A2,2 0 0,1 21,6M12,10C12,9.5 11.5,9 11,9H6.5C6,9 5.5,9.5 5.5,10V15H7V10.5H8V14H9.5V10.5H10.5V15H12V10M14.5,9A1,1 0 0,0 13.5,10V14A1,1 0 0,0 14.5,15H15.5V16.5H16.75V15H17.5A1,1 0 0,0 18.5,14V10A1,1 0 0,0 17.5,9H14.5M15,10.5H17V13.5H15V10.5Z";
var mdiQueueFirstInLastOut = "M6 6H18V8H6V6M6 10.5H18V12.5H6V10.5M6 15H18V17H6V15M9 19H15L12 22L9 19M9 2H15L12 5L9 2Z";
var mdiQuora = "M19.7,18.8C20.2,18.2 20.1,17.7 20.1,17.7H21.6C21.6,17.7 21.6,18.1 21.5,18.6C21.4,19 21.3,19.3 21.2,19.6C21,20.3 20,21.1 20,21.1C18.9,22 17.7,21.9 17.7,21.9C17.7,21.9 16.3,22.1 15.2,21.4C14.1,20.7 13.2,19.2 13.2,19.2C13.2,19.2 8.8,20.4 5.4,17.5C2,14.6 2.2,11.1 2.2,10.8C2.2,10.1 2.6,2.3 10.8,2C15.6,1.8 18.2,4.8 19.2,7.2C19.9,8.9 19.9,10.2 19.9,10.4C19.9,10.6 19.9,11.5 19.7,12.4C19.6,13.3 19.2,14.3 18.9,14.8C18.6,15.3 18.2,16 17.7,16.5C17.2,17.1 16.6,17.6 16.5,17.7C16.5,17.7 17.5,18.9 18.1,19.1C18.3,19.1 19.2,19.4 19.7,18.8M12.7,17.3C12.8,17.2 12.4,16.7 12.2,16.4C12,16.1 12.3,16.5 11.5,15.4C11.2,14.9 10.8,14.7 10.2,14.6C10,14.6 9.7,14.6 9.5,14.6C9,14.6 8.7,14.7 8.6,14.7C8.6,14.6 8.4,14.4 8.3,14.2C8.2,14 8.2,13.7 8.2,13.7C8.2,13.5 9.7,12.8 11.4,12.8C12.8,12.8 13.8,13.6 14.2,14C14.6,14.3 14.7,14.7 15.1,15C15.1,15 15.2,15 15.2,15.1C15.6,15.4 16.1,12.1 16,9.9C15.9,7.7 15.8,6.6 15,5.5C14.3,4.5 12.8,3.7 11.4,3.7C10.7,3.7 8.4,3.8 7.4,5.5C6.2,7.5 6.4,11.1 6.4,11.1C6.4,11.1 6.1,14.3 7.8,16C9.5,17.7 11.2,17.4 12,17.4L12.7,17.3Z";
var mdiRabbit = "M18.05,21L15.32,16.26C15.32,14.53 14.25,13.42 12.95,13.42C12.05,13.42 11.27,13.92 10.87,14.66C11.2,14.47 11.59,14.37 12,14.37C13.3,14.37 14.36,15.43 14.36,16.73C14.36,18.04 13.31,19.11 12,19.11H15.3V21H6.79C6.55,21 6.3,20.91 6.12,20.72C5.75,20.35 5.75,19.75 6.12,19.38V19.38L6.62,18.88C6.28,18.73 6,18.5 5.72,18.26C5.5,18.76 5,19.11 4.42,19.11C3.64,19.11 3,18.47 3,17.68C3,16.9 3.64,16.26 4.42,16.26L4.89,16.34V14.37C4.89,11.75 7,9.63 9.63,9.63H9.65C11.77,9.64 13.42,10.47 13.42,9.16C13.42,8.23 13.62,7.86 13.96,7.34C13.23,7 12.4,6.79 11.53,6.79C11,6.79 10.58,6.37 10.58,5.84C10.58,5.41 10.86,5.05 11.25,4.93L10.58,4.89C10.06,4.89 9.63,4.47 9.63,3.95C9.63,3.42 10.06,3 10.58,3H11.53C13.63,3 15.47,4.15 16.46,5.85L16.74,5.84C17.45,5.84 18.11,6.07 18.65,6.45L19.1,6.83C21.27,8.78 21,10.1 21,10.11C21,11.39 19.94,12.44 18.65,12.44L18.16,12.39V12.47C18.16,13.58 17.68,14.57 16.93,15.27L20.24,21H18.05M18.16,7.74C17.63,7.74 17.21,8.16 17.21,8.68C17.21,9.21 17.63,9.63 18.16,9.63C18.68,9.63 19.11,9.21 19.11,8.68C19.11,8.16 18.68,7.74 18.16,7.74Z";
var mdiRabbitVariant = "M16.84 14.5C16.58 14.33 16.22 13.89 16.05 13.68C17.24 12 19 8.87 19 5C19 3.05 18.26 2 17 2C15.46 2 13.04 4.06 12 7.97C10.96 4.06 8.54 2 7 2C5.74 2 5 3.05 5 5C5 8.87 6.76 12 7.95 13.68C7.78 13.89 7.42 14.33 7.16 14.5C6.66 14.93 5.5 15.89 5.5 17.5C5.5 19.71 7.29 21.5 9.5 21.5C11.05 21.5 12 20.94 12 20.94S12.95 21.5 14.5 21.5C16.71 21.5 18.5 19.71 18.5 17.5C18.5 15.89 17.34 14.93 16.84 14.5M9.35 12.2C8.34 10.7 7 8.12 7 5C7 4.5 7.06 4.2 7.12 4.03C8.06 4.34 10.36 6.74 10.5 11.67C10.03 11.79 9.66 11.97 9.35 12.2M10.5 16.75C10.22 16.75 10 16.41 10 16S10.22 15.25 10.5 15.25 11 15.59 11 16 10.78 16.75 10.5 16.75M12 19.5C11.45 19.5 11 18.78 11 18.5S11.45 18 12 18 13 18.22 13 18.5 12.55 19.5 12 19.5M13.5 16.75C13.22 16.75 13 16.41 13 16S13.22 15.25 13.5 15.25 14 15.59 14 16 13.78 16.75 13.5 16.75M13.5 11.67C13.64 6.74 15.94 4.34 16.88 4.03C16.94 4.2 17 4.5 17 5C17 8.12 15.66 10.7 14.65 12.2C14.34 11.97 13.97 11.79 13.5 11.67Z";
var mdiRabbitVariantOutline = "M17 14C16.76 13.76 16.56 13.5 16.35 13.25C17.5 11.5 19 8.56 19 5C19 3.05 18.26 2 17 2C15.46 2 13.04 4.06 12 7.97C10.96 4.06 8.54 2 7 2C5.74 2 5 3.05 5 5C5 8.56 6.5 11.5 7.65 13.25C7.44 13.5 7.24 13.76 7 14C6.75 14.25 5 15.39 5 17.5C5 20 7 22 9.5 22C11 22 12 21.5 12 21.5S13 22 14.5 22C17 22 19 20 19 17.5C19 15.39 17.25 14.25 17 14M16.88 4.03C16.94 4.2 17 4.5 17 5C17 7.84 15.89 10.24 14.93 11.78C14.55 11.5 14.1 11.3 13.53 11.16C13.77 6.64 15.97 4.33 16.88 4.03M7 5C7 4.5 7.06 4.2 7.12 4.03C8.03 4.33 10.23 6.64 10.5 11.16C9.9 11.3 9.45 11.5 9.08 11.78C8.11 10.24 7 7.84 7 5M14.5 20C13.5 20 12.7 19.67 12.28 19.44C12.7 19.26 13 18.73 13 18.5C13 18.22 12.55 18 12 18S11 18.22 11 18.5C11 18.73 11.3 19.26 11.72 19.44C11.3 19.67 10.5 20 9.5 20C8.12 20 7 18.88 7 17.5C7 16.8 7.43 16.26 8 15.77C8.44 15.41 8.61 15.25 9.3 14.4C10.06 13.45 10.39 13 12 13S13.94 13.45 14.7 14.4C15.39 15.25 15.56 15.41 16 15.77C16.57 16.26 17 16.8 17 17.5C17 18.88 15.88 20 14.5 20M14 16C14 16.41 13.78 16.75 13.5 16.75S13 16.41 13 16 13.22 15.25 13.5 15.25 14 15.59 14 16M11 16C11 16.41 10.78 16.75 10.5 16.75S10 16.41 10 16 10.22 15.25 10.5 15.25 11 15.59 11 16Z";
var mdiRacingHelmet = "M2.2,11.2C2,13.6 2.7,15.6 4.2,17.4C5.7,19.2 7.7,20 10.1,20H20.1C20.6,20 21.1,19.8 21.5,19.4C21.9,19 22.1,18.5 22.1,18V17.2C22.1,16.6 22,15.9 21.9,15H13.7C12.7,15 11.9,14.6 11.2,13.9C10.5,13.2 10.1,12.3 10.1,11.4C10.1,9.8 10.8,8.7 12.3,8.1L17.1,6C15.4,4.8 13.4,4.1 11.1,4C8.9,3.8 6.9,4.5 5.1,5.9C3.3,7.3 2.4,9 2.2,11.2M12.1,11.4C12.1,11.8 12.3,12.2 12.6,12.5C12.9,12.8 13.3,13 13.7,13H21.5C20.9,10.8 20,9 18.7,7.6L13.1,9.9C12.4,10.1 12.1,10.6 12.1,11.4Z";
var mdiRacquetball = "M18.5,16C19.9,16 21,17.1 21,18.5C21,19.9 19.9,21 18.5,21C17.1,21 16,19.9 16,18.5C16,17.1 17.1,16 18.5,16M10.5,1C3,1 3,3.7 3,9.8C3,13.2 6.4,16.9 9,18.1V23H12V18.1C14.6,16.9 18,13.2 18,9.8C18,3.6 18,1 10.5,1M15.4,4.2C15.7,4.6 15.8,5.2 15.9,6H15V3.8C15.2,3.9 15.3,4.1 15.4,4.2M16,9.8C16,9.9 16,10 16,10H15V7H16C16,7.8 16,8.7 16,9.8M14,14H11V11H14V14M7,14V11H10V14H7M5,9.8C5,8.8 5,7.9 5,7H6V10H5C5,9.9 5,9.8 5,9.8M7,7H10V10H7V7M11,3C12.4,3 13.4,3.2 14,3.3V6H11V3M10,6H7V3.4C7.6,3.2 8.6,3 10,3V6M11,10V7H14V10H11M6,3.8V6H5.1C5.2,5.2 5.3,4.6 5.6,4.2C5.7,4.1 5.8,4 6,3.8M5.2,11H6V12.7C5.7,12.1 5.4,11.6 5.2,11M8,15H10V16.3L9.8,16.2C9.2,16 8.6,15.5 8,15M11.2,16.3H11V15H13C12.4,15.5 11.8,16 11.2,16.3M15,12.7V11H15.8C15.6,11.5 15.3,12.1 15,12.7Z";
var mdiRadar = "M19.07,4.93L17.66,6.34C19.1,7.79 20,9.79 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12C4,7.92 7.05,4.56 11,4.07V6.09C8.16,6.57 6,9.03 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12C18,10.34 17.33,8.84 16.24,7.76L14.83,9.17C15.55,9.9 16,10.9 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12C8,10.14 9.28,8.59 11,8.14V10.28C10.4,10.63 10,11.26 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12C14,11.26 13.6,10.62 13,10.28V2H12A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,9.24 20.88,6.74 19.07,4.93Z";
var mdiRadiator = "M7.95,3L6.53,5.19L7.95,7.4H7.94L5.95,10.5L4.22,9.6L5.64,7.39L4.22,5.19L6.22,2.09L7.95,3M13.95,2.89L12.53,5.1L13.95,7.3L13.94,7.31L11.95,10.4L10.22,9.5L11.64,7.3L10.22,5.1L12.22,2L13.95,2.89M20,2.89L18.56,5.1L20,7.3V7.31L18,10.4L16.25,9.5L17.67,7.3L16.25,5.1L18.25,2L20,2.89M2,22V14A2,2 0 0,1 4,12H20A2,2 0 0,1 22,14V22H20V20H4V22H2M6,14A1,1 0 0,0 5,15V17A1,1 0 0,0 6,18A1,1 0 0,0 7,17V15A1,1 0 0,0 6,14M10,14A1,1 0 0,0 9,15V17A1,1 0 0,0 10,18A1,1 0 0,0 11,17V15A1,1 0 0,0 10,14M14,14A1,1 0 0,0 13,15V17A1,1 0 0,0 14,18A1,1 0 0,0 15,17V15A1,1 0 0,0 14,14M18,14A1,1 0 0,0 17,15V17A1,1 0 0,0 18,18A1,1 0 0,0 19,17V15A1,1 0 0,0 18,14Z";
var mdiRadiatorDisabled = "M20,12H4A2,2 0 0,0 2,14V22H4V20H20V22H22V14A2,2 0 0,0 20,12M7,17A1,1 0 0,1 6,18A1,1 0 0,1 5,17V15A1,1 0 0,1 6,14A1,1 0 0,1 7,15V17M11,17A1,1 0 0,1 10,18A1,1 0 0,1 9,17V15A1,1 0 0,1 10,14A1,1 0 0,1 11,15V17M15,17A1,1 0 0,1 14,18A1,1 0 0,1 13,17V15A1,1 0 0,1 14,14A1,1 0 0,1 15,15V17M19,17A1,1 0 0,1 18,18A1,1 0 0,1 17,17V15A1,1 0 0,1 18,14A1,1 0 0,1 19,15V17Z";
var mdiRadiatorOff = "M3.28,2L2,3.27L4.77,6.04L5.64,7.39L4.22,9.6L5.95,10.5L7.23,8.5L10.73,12H4A2,2 0 0,0 2,14V22H4V20H18.73L20,21.27V22H22V20.73L22,20.72V20.72L3.28,2M7,17A1,1 0 0,1 6,18A1,1 0 0,1 5,17V15A1,1 0 0,1 6,14A1,1 0 0,1 7,15V17M11,17A1,1 0 0,1 10,18A1,1 0 0,1 9,17V15A1,1 0 0,1 10,14A1,1 0 0,1 11,15V17M15,17A1,1 0 0,1 14,18A1,1 0 0,1 13,17V15C13,14.79 13.08,14.61 13.18,14.45L15,16.27V17M16.25,9.5L17.67,7.3L16.25,5.1L18.25,2L20,2.89L18.56,5.1L20,7.3V7.31L18,10.4L16.25,9.5M22,14V18.18L19,15.18V15A1,1 0 0,0 18,14C17.95,14 17.9,14 17.85,14.03L15.82,12H20C21.11,12 22,12.9 22,14M11.64,7.3L10.22,5.1L12.22,2L13.95,2.89L12.53,5.1L13.95,7.3L13.94,7.31L12.84,9L11.44,7.62L11.64,7.3M7.5,3.69L6.1,2.28L6.22,2.09L7.95,3L7.5,3.69Z";
var mdiRadio = "M20,6A2,2 0 0,1 22,8V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V8C2,7.15 2.53,6.42 3.28,6.13L15.71,1L16.47,2.83L8.83,6H20M20,8H4V12H16V10H18V12H20V8M7,14A3,3 0 0,0 4,17A3,3 0 0,0 7,20A3,3 0 0,0 10,17A3,3 0 0,0 7,14Z";
var mdiRadioAm = "M5,7A2,2 0 0,0 3,9V17H5V13H7V17H9V9A2,2 0 0,0 7,7H5M5,9H7V11H5V9M13,7A2,2 0 0,0 11,9V17H13V9H15V16H17V9H19V17H21V9A2,2 0 0,0 19,7H13Z";
var mdiRadioFm = "M3,7V17H5V13H8V11H5V9H9V7H3M13,7A2,2 0 0,0 11,9V17H13V9H15V16H17V9H19V17H21V9A2,2 0 0,0 19,7H13Z";
var mdiRadioHandheld = "M9,2A1,1 0 0,0 8,3C8,8.67 8,14.33 8,20C8,21.11 8.89,22 10,22H15C16.11,22 17,21.11 17,20V9C17,7.89 16.11,7 15,7H10V3A1,1 0 0,0 9,2M10,9H15V13H10V9Z";
var mdiRadioOff = "M1 4.27L3 6.27C2.4 6.61 2 7.26 2 8V20C2 21.11 2.9 22 4 22H18.73L20.73 24L22 22.72L2.28 3L1 4.27M20 6H8.83L16.47 2.83L15.71 1L6.59 4.76L9.82 8H20V12H18V10H16V12H13.82L22 20.18V8C22 6.9 21.11 6 20 6M4 8H4.73L8.73 12H4V8M7 14C8.66 14 10 15.34 10 17C10 18.66 8.66 20 7 20C5.34 20 4 18.66 4 17C4 15.34 5.34 14 7 14Z";
var mdiRadioTower = "M12,10A2,2 0 0,1 14,12C14,12.5 13.82,12.94 13.53,13.29L16.7,22H14.57L12,14.93L9.43,22H7.3L10.47,13.29C10.18,12.94 10,12.5 10,12A2,2 0 0,1 12,10M12,8A4,4 0 0,0 8,12C8,12.5 8.1,13 8.28,13.46L7.4,15.86C6.53,14.81 6,13.47 6,12A6,6 0 0,1 12,6A6,6 0 0,1 18,12C18,13.47 17.47,14.81 16.6,15.86L15.72,13.46C15.9,13 16,12.5 16,12A4,4 0 0,0 12,8M12,4A8,8 0 0,0 4,12C4,14.36 5,16.5 6.64,17.94L5.92,19.94C3.54,18.11 2,15.23 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12C22,15.23 20.46,18.11 18.08,19.94L17.36,17.94C19,16.5 20,14.36 20,12A8,8 0 0,0 12,4Z";
var mdiRadioactive = "M14 11C14 12.1 13.1 13 12 13S10 12.1 10 11 10.9 9 12 9 14 9.9 14 11M16 11H22C22 7.3 20 4.1 17 2.3L14 7.5C15.2 8.2 16 9.5 16 11M12 15C11.3 15 10.6 14.8 10 14.4C8.8 16.5 7.4 18.8 7 19.6C8.5 20.5 10.2 20.9 12 20.9S15.5 20.4 17 19.6L14 14.4C13.4 14.8 12.7 15 12 15M10 7.6C8.8 5.5 7.4 3.1 7 2.3C4 4 2 7.3 2 11H8C8 9.5 8.8 8.2 10 7.6Z";
var mdiRadioactiveCircle = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M20 12H16C16 10.5 15.2 9.2 14 8.6L16 5.1C18.4 6.5 20 9 20 12M12 10C13.1 10 14 10.9 14 12S13.1 14 12 14 10 13.1 10 12 10.9 10 12 10M8 5.1C8.6 6.1 9.3 7.4 10 8.6C8.8 9.3 8 10.6 8 12H4C4 9 5.6 6.5 8 5.1M8 18.9C8.6 17.9 9.3 16.6 10 15.4C10.6 15.7 11.3 16 12 16S13.4 15.8 14 15.4L16 18.9C14.8 19.6 13.5 20 12 20C10.5 20 9.2 19.6 8 18.9Z";
var mdiRadioactiveCircleOutline = "M12 4C16.4 4 20 7.6 20 12S16.4 20 12 20 4 16.4 4 12 7.6 4 12 4M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M15 17.2L13.2 14.2C12.8 14.4 12.4 14.5 12 14.5S11.1 14.4 10.8 14.2C10.3 15.1 9.6 16.2 9 17.2C9.9 17.7 10.9 18 12 18S14.1 17.7 15 17.2M15 6.8L13.2 9.8C13.9 10.2 14.5 11 14.5 12H18C18 9.8 16.8 7.8 15 6.8M12 13C12.6 13 13 12.6 13 12S12.6 11 12 11 11 11.4 11 12 11.4 13 12 13M6 12H9.5C9.5 11.1 10 10.3 10.8 9.8C10.3 8.9 9.6 7.8 9 6.8C7.2 7.8 6 9.8 6 12Z";
var mdiRadioactiveOff = "M20.8 22.7L15.9 17.8L16.9 19.6C15.4 20.5 13.7 20.9 11.9 20.9S8.4 20.4 6.9 19.6C7.3 18.8 8.7 16.5 9.9 14.4C10.5 14.7 11.2 15 11.9 15C12.2 15 12.6 15 12.9 14.9L8.1 10C8.1 10.3 8 10.7 8 11H2C2 9 2.6 7.1 3.6 5.5L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M16 11H22C22 7.3 20 4.1 17 2.3L14 7.5C15.2 8.2 16 9.5 16 11M12.2 9L14 10.8C13.9 9.9 13.1 9.1 12.2 9M7 2.3L6.1 2.9L9 5.8C8.1 4.3 7.3 2.9 7 2.3Z";
var mdiRadioboxBlank = "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiRadioboxIndeterminateVariant = "M8.46 8.46C9.4 7.53 10.67 7 12 7C13.33 7 14.6 7.53 15.54 8.46L8.46 15.54C7.53 14.6 7 13.33 7 12C7 10.67 7.53 9.4 8.46 8.46M8.17 2.76C9.39 2.26 10.69 2 12 2C13.31 2 14.61 2.26 15.83 2.76C17.04 3.26 18.14 4 19.07 4.93C20 5.86 20.74 6.96 21.24 8.17C21.74 9.39 22 10.69 22 12C22 14.65 20.95 17.2 19.07 19.07C17.2 20.95 14.65 22 12 22C10.69 22 9.39 21.74 8.17 21.24C6.96 20.74 5.86 20 4.93 19.07C3.05 17.2 2 14.65 2 12C2 9.35 3.05 6.8 4.93 4.93C5.86 4 6.96 3.26 8.17 2.76M6.34 17.66C7.84 19.16 9.88 20 12 20C14.12 20 16.16 19.16 17.66 17.66C19.16 16.16 20 14.12 20 12C20 9.88 19.16 7.84 17.66 6.34C16.16 4.84 14.12 4 12 4C9.88 4 7.84 4.84 6.34 6.34C4.84 7.84 4 9.88 4 12C4 14.12 4.84 16.16 6.34 17.66Z";
var mdiRadioboxMarked = "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z";
var mdiRadiologyBox = "M19 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3M17.1 13H13V14H17C17 14 16.94 17 15.5 17C14.15 17 14.5 15.47 13 15V17C13 17.55 12.55 18 12 18S11 17.55 11 17V15C9.5 15.47 9.85 17 8.5 17C7.06 17 7 14 7 14H11V13H6.9C6.85 12.69 6.84 12.35 6.8 12H11V11H6.81C6.83 10.67 6.91 10.33 7 10H11V9H7.34C7.5 8.65 7.65 8.31 7.83 8H11V7C11 6.45 11.45 6 12 6S13 6.45 13 7V8H16.17C16.35 8.31 16.5 8.65 16.66 9H13V10H17C17.1 10.33 17.17 10.67 17.19 11H13V12H17.2C17.16 12.35 17.15 12.69 17.1 13Z";
var mdiRadiologyBoxOutline = "M19 5V19H5V5H19M19 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3M12 6C12.55 6 13 6.45 13 7V8H16.17C16.35 8.31 16.5 8.65 16.66 9H13V10H17C17.1 10.33 17.17 10.67 17.19 11H13V12H17.2C17.16 12.35 17.15 12.69 17.1 13H13V14H17C17 14 16.94 17 15.5 17C14.15 17 14.5 15.47 13 15V17C13 17.55 12.55 18 12 18S11 17.55 11 17V15C9.5 15.47 9.85 17 8.5 17C7.06 17 7 14 7 14H11V13H6.9C6.85 12.69 6.84 12.35 6.8 12H11V11H6.81C6.83 10.67 6.91 10.33 7 10H11V9H7.34C7.5 8.65 7.65 8.31 7.83 8H11V7C11 6.45 11.45 6 12 6Z";
var mdiRadius = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M17,15V13H13.72C13.36,13.62 12.71,14 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10C12.71,10 13.36,10.38 13.72,11H17V9L20,12L17,15Z";
var mdiRadiusOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M16,15V13H13.72C13.36,13.62 12.71,14 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10C12.71,10 13.36,10.38 13.72,11H16V9L19,12L16,15Z";
var mdiRailroadLight = "M17.67,10.5C16.4,10.5 15.27,11.3 14.85,12.5H13.17V7.77L16.66,9.86L17.66,8.14L14.11,6L17.68,3.86L16.68,2.14L13.17,4.23V2H11.17V4.23L7.68,2.14L6.68,3.86L10.23,6L6.66,8.14L7.66,9.86L11.17,7.77V12.5H9.5C8.36,9.32 3.66,10.13 3.66,13.5C3.66,16.87 8.36,17.68 9.5,14.5H11.17V20A2,2 0 0,0 9.17,22H15.17A2,2 0 0,0 13.17,20V14.5H14.85C15.66,16.8 18.73,17.22 20.13,15.23C21.53,13.24 20.1,10.5 17.67,10.5M6.67,14.5C5.78,14.5 5.33,13.42 5.96,12.79C6.59,12.16 7.67,12.61 7.67,13.5A1,1 0 0,1 6.67,14.5M17.67,14.5C16.78,14.5 16.33,13.42 16.96,12.79C17.59,12.16 18.67,12.61 18.67,13.5A1,1 0 0,1 17.67,14.5Z";
var mdiRake = "M10.5 17.05L9.43 16L22.07 3.35L20.66 1.93L8 14.58L6.95 13.5C6.17 12.73 4.9 12.73 4.12 13.5L2 15.64L2.71 16.34L4.83 14.22L5.54 14.93L3.41 17.05L4.12 17.76L6.24 15.64L6.95 16.34L4.83 18.46L5.54 19.17L7.66 17.05L8.36 17.76L6.24 19.88L6.95 20.59L9.07 18.46L9.78 19.17L7.66 21.29L8.36 22L10.5 19.88C11.27 19.1 11.27 17.83 10.5 17.05Z";
var mdiRaspberryPi = "M20,8H22V10H20V8M4,5H20A2,2 0 0,1 22,7H19V9H5V13H8V16H19V17H22A2,2 0 0,1 20,19H16V20H14V19H11V20H7V19H4A2,2 0 0,1 2,17V7A2,2 0 0,1 4,5M19,15H9V10H19V11H22V13H19V15M13,12V14H15V12H13M5,6V8H6V6H5M7,6V8H8V6H7M9,6V8H10V6H9M11,6V8H12V6H11M13,6V8H14V6H13M15,6V8H16V6H15M20,14H22V16H20V14Z";
var mdiRaw = "M6.5 9C7.3 9 8 9.7 8 10.5V11.5C8 12.1 7.6 12.6 7.1 12.9L8 15H6.5L5.6 13H4.5V15H3V9H6.5M6.5 11.5V10.5H4.5V11.5H6.5M10.25 9H12.75L14.25 15H12.75L12.38 13.5H10.63L10.25 15H8.75L10.25 9M11 12H12L11.75 11H11.25L11 12M20 9H21.5L20 15H18.5L17.74 11.96L17 15H15.5L14 9H15.5L16.24 12L17 9H18.5L19.24 12L20 9Z";
var mdiRawOff = "M17.15 14.32L14.72 11.9L14 9H15.5L16.24 12L17 9H18.5L19.24 12L20 9H21.5L20 15H18.5L17.74 11.96L17.15 14.32M1.39 4.22L2.81 2.81L21.19 21.2L19.78 22.61L10.67 13.5H10.63L10.25 15H8.75L9.43 12.26L8 10.83V11.5C8 12.1 7.6 12.6 7.1 12.9L8 15H6.5L5.6 13H4.5V15H3V9H6.17L1.39 4.22M6.5 11.5V10.5H4.5V11.5H6.5Z";
var mdiRayEnd = "M20,9C18.69,9 17.58,9.83 17.17,11H2V13H17.17C17.58,14.17 18.69,15 20,15A3,3 0 0,0 23,12A3,3 0 0,0 20,9Z";
var mdiRayEndArrow = "M1,12L5,16V13H17.17C17.58,14.17 18.69,15 20,15A3,3 0 0,0 23,12A3,3 0 0,0 20,9C18.69,9 17.58,9.83 17.17,11H5V8L1,12Z";
var mdiRayStart = "M4,9C5.31,9 6.42,9.83 6.83,11H22V13H6.83C6.42,14.17 5.31,15 4,15A3,3 0 0,1 1,12A3,3 0 0,1 4,9Z";
var mdiRayStartArrow = "M23,12L19,16V13H6.83C6.42,14.17 5.31,15 4,15A3,3 0 0,1 1,12A3,3 0 0,1 4,9C5.31,9 6.42,9.83 6.83,11H19V8L23,12Z";
var mdiRayStartEnd = "M4,9C5.31,9 6.42,9.83 6.83,11H17.17C17.58,9.83 18.69,9 20,9A3,3 0 0,1 23,12A3,3 0 0,1 20,15C18.69,15 17.58,14.17 17.17,13H6.83C6.42,14.17 5.31,15 4,15A3,3 0 0,1 1,12A3,3 0 0,1 4,9Z";
var mdiRayStartVertexEnd = "M20 9C18.69 9 17.58 9.83 17.17 11H14.82C14.4 9.84 13.3 9 12 9S9.6 9.84 9.18 11H6.83C6.42 9.83 5.31 9 4 9C2.34 9 1 10.34 1 12S2.34 15 4 15C5.31 15 6.42 14.17 6.83 13H9.18C9.6 14.16 10.7 15 12 15S14.4 14.16 14.82 13H17.17C17.58 14.17 18.69 15 20 15C21.66 15 23 13.66 23 12S21.66 9 20 9";
var mdiRayVertex = "M2,11H9.17C9.58,9.83 10.69,9 12,9C13.31,9 14.42,9.83 14.83,11H22V13H14.83C14.42,14.17 13.31,15 12,15C10.69,15 9.58,14.17 9.17,13H2V11Z";
var mdiRazorDoubleEdge = "M20 8C19.45 8 19 7.55 19 7C19 6.45 19.45 6 20 6V5H4V6C4.55 6 5 6.45 5 7C5 7.55 4.55 8 4 8H2V15H4C4.55 15 5 15.45 5 16C5 16.55 4.55 17 4 17V18H20V17C19.45 17 19 16.55 19 16C19 15.45 19.45 15 20 15H22V8H20M20 12H19V13H17V12H13.41C13.2 12.58 12.65 13 12 13S10.8 12.58 10.59 12H7V13H5V12H4V11H5V10H7V11H10.59C10.8 10.42 11.35 10 12 10S13.2 10.42 13.41 11H17V10H19V11H20V12Z";
var mdiRazorSingleEdge = "M22 5V8H2V5H22M22 13V18H2V13H3.5C4.33 13 5 12.33 5 11.5S4.33 10 3.5 10L2 10V9H22V10H20.5C19.67 10 19 10.67 19 11.5S19.67 13 20.5 13H22M13 11C13 10.45 12.55 10 12 10S11 10.45 11 11V13C11 13.55 11.45 14 12 14S13 13.55 13 13V11Z";
var mdiReact = "M12,10.11C13.03,10.11 13.87,10.95 13.87,12C13.87,13 13.03,13.85 12,13.85C10.97,13.85 10.13,13 10.13,12C10.13,10.95 10.97,10.11 12,10.11M7.37,20C8,20.38 9.38,19.8 10.97,18.3C10.45,17.71 9.94,17.07 9.46,16.4C8.64,16.32 7.83,16.2 7.06,16.04C6.55,18.18 6.74,19.65 7.37,20M8.08,14.26L7.79,13.75C7.68,14.04 7.57,14.33 7.5,14.61C7.77,14.67 8.07,14.72 8.38,14.77C8.28,14.6 8.18,14.43 8.08,14.26M14.62,13.5L15.43,12L14.62,10.5C14.32,9.97 14,9.5 13.71,9.03C13.17,9 12.6,9 12,9C11.4,9 10.83,9 10.29,9.03C10,9.5 9.68,9.97 9.38,10.5L8.57,12L9.38,13.5C9.68,14.03 10,14.5 10.29,14.97C10.83,15 11.4,15 12,15C12.6,15 13.17,15 13.71,14.97C14,14.5 14.32,14.03 14.62,13.5M12,6.78C11.81,7 11.61,7.23 11.41,7.5C11.61,7.5 11.8,7.5 12,7.5C12.2,7.5 12.39,7.5 12.59,7.5C12.39,7.23 12.19,7 12,6.78M12,17.22C12.19,17 12.39,16.77 12.59,16.5C12.39,16.5 12.2,16.5 12,16.5C11.8,16.5 11.61,16.5 11.41,16.5C11.61,16.77 11.81,17 12,17.22M16.62,4C16,3.62 14.62,4.2 13.03,5.7C13.55,6.29 14.06,6.93 14.54,7.6C15.36,7.68 16.17,7.8 16.94,7.96C17.45,5.82 17.26,4.35 16.62,4M15.92,9.74L16.21,10.25C16.32,9.96 16.43,9.67 16.5,9.39C16.23,9.33 15.93,9.28 15.62,9.23C15.72,9.4 15.82,9.57 15.92,9.74M17.37,2.69C18.84,3.53 19,5.74 18.38,8.32C20.92,9.07 22.75,10.31 22.75,12C22.75,13.69 20.92,14.93 18.38,15.68C19,18.26 18.84,20.47 17.37,21.31C15.91,22.15 13.92,21.19 12,19.36C10.08,21.19 8.09,22.15 6.62,21.31C5.16,20.47 5,18.26 5.62,15.68C3.08,14.93 1.25,13.69 1.25,12C1.25,10.31 3.08,9.07 5.62,8.32C5,5.74 5.16,3.53 6.62,2.69C8.09,1.85 10.08,2.81 12,4.64C13.92,2.81 15.91,1.85 17.37,2.69M17.08,12C17.42,12.75 17.72,13.5 17.97,14.26C20.07,13.63 21.25,12.73 21.25,12C21.25,11.27 20.07,10.37 17.97,9.74C17.72,10.5 17.42,11.25 17.08,12M6.92,12C6.58,11.25 6.28,10.5 6.03,9.74C3.93,10.37 2.75,11.27 2.75,12C2.75,12.73 3.93,13.63 6.03,14.26C6.28,13.5 6.58,12.75 6.92,12M15.92,14.26C15.82,14.43 15.72,14.6 15.62,14.77C15.93,14.72 16.23,14.67 16.5,14.61C16.43,14.33 16.32,14.04 16.21,13.75L15.92,14.26M13.03,18.3C14.62,19.8 16,20.38 16.62,20C17.26,19.65 17.45,18.18 16.94,16.04C16.17,16.2 15.36,16.32 14.54,16.4C14.06,17.07 13.55,17.71 13.03,18.3M8.08,9.74C8.18,9.57 8.28,9.4 8.38,9.23C8.07,9.28 7.77,9.33 7.5,9.39C7.57,9.67 7.68,9.96 7.79,10.25L8.08,9.74M10.97,5.7C9.38,4.2 8,3.62 7.37,4C6.74,4.35 6.55,5.82 7.06,7.96C7.83,7.8 8.64,7.68 9.46,7.6C9.94,6.93 10.45,6.29 10.97,5.7Z";
var mdiRead = "M21.59,11.59L23,13L13.5,22.5L8.42,17.41L9.83,16L13.5,19.68L21.59,11.59M4,16V3H6L9,3A4,4 0 0,1 13,7C13,8.54 12.13,9.88 10.85,10.55L14,16H12L9.11,11H6V16H4M6,9H9A2,2 0 0,0 11,7A2,2 0 0,0 9,5H6V9Z";
var mdiReceipt = "M3 22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.5 20.5L15 22L16.5 20.5L18 22L19.5 20.5L21 22V2L19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2";
var mdiReceiptClock = "M3 22L4.5 20.5L6 22L7.5 20.5L9 22L10.58 20.42C10.72 20.61 10.88 20.78 11.05 20.95C12.36 22.26 14.14 23 16 23C19.86 23 23 19.87 23 16C23 14.17 22.28 12.41 21 11.1V2L19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22M20.85 16C20.85 16.64 20.73 17.27 20.5 17.86C20.24 18.44 19.88 19 19.43 19.43C19 19.88 18.44 20.24 17.86 20.5C17.27 20.73 16.64 20.85 16 20.85C13.32 20.85 11.15 18.68 11.15 16C11.15 14.71 11.66 13.5 12.57 12.57C13.5 11.66 14.71 11.15 16 11.15C18.67 11.15 20.85 13.32 20.85 16M15 16.69V13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69Z";
var mdiReceiptClockOutline = "M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.58 20.42C10.72 20.61 10.88 20.78 11.05 20.95C12.36 22.26 14.14 23 16 23C19.86 23 23 19.87 23 16C23 14.17 22.28 12.41 21 11.1V2L19.5 3.5M19 9.68C18.07 9.24 17.05 9 16 9C12.14 9 9 12.13 9 16C9 17.05 9.24 18.07 9.68 19H5V5H19V9.68M20.85 16C20.85 16.64 20.73 17.27 20.5 17.86C20.24 18.44 19.88 19 19.43 19.43C19 19.88 18.44 20.24 17.86 20.5C17.27 20.73 16.64 20.85 16 20.85C13.32 20.85 11.15 18.68 11.15 16C11.15 14.71 11.66 13.5 12.57 12.57C13.5 11.66 14.71 11.15 16 11.15C18.67 11.15 20.85 13.32 20.85 16M15 16.69V13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69Z";
var mdiReceiptOutline = "M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.5 20.5L15 22L16.5 20.5L18 22L19.5 20.5L21 22V2L19.5 3.5M19 19H5V5H19V19Z";
var mdiReceiptSend = "M4.5 20.5L3 22V2L4.5 3.5L6 2L7.5 3.5L9 2L10.5 3.5L12 2L13.5 3.5L15 2L16.5 3.5L18 2L19.5 3.5L21 2V14.26L12 9.76V22L10.5 20.5L9 22L7.5 20.5L6 22L4.5 20.5M14 19L18 18L14 17V13L24 18L14 23V19Z";
var mdiReceiptSendOutline = "M18 2L19.5 3.5L21 2V14.26L19 13.26V5H5V19H12V22L10.5 20.5L9 22L7.5 20.5L6 22L4.5 20.5L3 22V2L4.5 3.5L6 2L7.5 3.5L9 2L10.5 3.5L12 2L13.5 3.5L15 2L16.5 3.5L18 2M14 19L18 18L14 17V13L24 18L14 23V19Z";
var mdiReceiptText = "M3,22L4.5,20.5L6,22L7.5,20.5L9,22L10.5,20.5L12,22L13.5,20.5L15,22L16.5,20.5L18,22L19.5,20.5L21,22V2L19.5,3.5L18,2L16.5,3.5L15,2L13.5,3.5L12,2L10.5,3.5L9,2L7.5,3.5L6,2L4.5,3.5L3,2M18,9H6V7H18M18,13H6V11H18M18,17H6V15H18V17Z";
var mdiReceiptTextArrowLeft = "M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.26 20.74C13.09 20.18 13 19.59 13 19C13 18.32 13.12 17.64 13.34 17H6V15H14.53C15.67 13.73 17.29 13 19 13C19.68 13 20.36 13.12 21 13.34V2L19.5 3.5M18 13H6V11H18V13M18 9H6V7H18V9M18 18V16L15 19L18 22V20H22V18H18Z";
var mdiReceiptTextArrowLeftOutline = "M12 22L13.26 20.74C13.1 20.22 13 19.66 13 19.09H5V4.91H19V13C19.7 13 20.37 13.13 21 13.35V2L19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22M13.35 17C13.61 16.25 14 15.58 14.54 15H6V17H13.35M18 11H6V13H18V11M18 7H6V9H18V7M18 20V22L15 19L18 16V18H22V20H18Z";
var mdiReceiptTextArrowRight = "M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.26 20.74C13.09 20.18 13 19.59 13 19C13 18.32 13.12 17.64 13.34 17H6V15H14.53C15.67 13.73 17.29 13 19 13C19.68 13 20.36 13.12 21 13.34V2L19.5 3.5M18 13H6V11H18V13M18 9H6V7H18V9M19 22V20H15V18H19V16L22 19L19 22Z";
var mdiReceiptTextArrowRightOutline = "M13.26 20.74L12 22L10.5 20.5L9 22L7.5 20.5L6 22L4.5 20.5L3 22V2L4.5 3.5L6 2L7.5 3.5L9 2L10.5 3.5L12 2L13.5 3.5L15 2L16.5 3.5L18 2L19.5 3.5L21 2V13.35C20.37 13.13 19.7 13 19 13V4.91H5V19.09H13C13 19.66 13.1 20.22 13.26 20.74M14.54 15C14 15.58 13.61 16.25 13.35 17H6V15H14.54M6 11H18V13H6V11M6 7H18V9H6V7M19 22V20H15V18H19V16L22 19L19 22Z";
var mdiReceiptTextCheck = "M18.25 22L15.5 19L16.66 17.82L18.25 19.41L21.84 15.82L23 17.23M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.26 20.74C13.09 20.18 13 19.59 13 19C13 18.32 13.12 17.64 13.34 17H6V15H14.53C15.67 13.73 17.29 13 19 13C19.68 13 20.36 13.12 21 13.34V2L19.5 3.5M18 13H6V11H18V13M18 9H6V7H18V9Z";
var mdiReceiptTextCheckOutline = "M13.26 20.74L12 22L10.5 20.5L9 22L7.5 20.5L6 22L4.5 20.5L3 22V2L4.5 3.5L6 2L7.5 3.5L9 2L10.5 3.5L12 2L13.5 3.5L15 2L16.5 3.5L18 2L19.5 3.5L21 2V13.35C20.37 13.13 19.7 13 19 13V5H5V19H13C13 19.57 13.1 20.22 13.26 20.74M6 15V17H13.35C13.61 16.25 14 15.58 14.54 15H6M6 13H18V11H6V13M6 9H18V7H6V9M23 17.23L21.84 15.82L18.25 19.41L16.66 17.82L15.5 19L18.25 22";
var mdiReceiptTextClock = "M15 16.69V13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.58 20.42C10.72 20.61 10.88 20.78 11.05 20.95C12.36 22.26 14.14 23 16 23C19.86 23 23 19.87 23 16C23 14.17 22.28 12.41 21 11.1V2L19.5 3.5M11.1 11C10.5 11.57 10.03 12.25 9.67 13H6V11H11.1M9.07 15C9 15.33 9 15.66 9 16C9 16.34 9 16.67 9.07 17H6V15H9.07M18 9H6V7H18V9M20.85 16C20.85 16.64 20.73 17.27 20.5 17.86C20.24 18.44 19.88 19 19.43 19.43C19 19.88 18.44 20.24 17.86 20.5C17.27 20.73 16.64 20.85 16 20.85C13.32 20.85 11.15 18.68 11.15 16C11.15 14.71 11.66 13.5 12.57 12.57C13.5 11.66 14.71 11.15 16 11.15C18.67 11.15 20.85 13.32 20.85 16Z";
var mdiReceiptTextClockOutline = "M15 16.69V13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69M10.58 20.42L9 22L7.5 20.5L6 22L4.5 20.5L3 22V2L4.5 3.5L6 2L7.5 3.5L9 2L10.5 3.5L12 2L13.5 3.5L15 2L16.5 3.5L18 2L19.5 3.5L21 2V11.1C22.28 12.41 23 14.17 23 16C23 19.87 19.86 23 16 23C14.14 23 12.36 22.26 11.05 20.95C10.88 20.78 10.72 20.61 10.58 20.42M9.72 19.09C9.4 18.43 9.18 17.73 9.07 17H6V15H9.07C9.17 14.29 9.38 13.62 9.68 13H6V11H11.1C12.37 9.76 14.1 9 16 9H6V7H18V9H16C17.05 9 18.07 9.24 19 9.68V4.91H5V19.09H9.72M20.85 16C20.85 13.32 18.67 11.15 16 11.15C14.71 11.15 13.5 11.66 12.57 12.57C11.66 13.5 11.15 14.71 11.15 16C11.15 18.68 13.32 20.85 16 20.85C16.64 20.85 17.27 20.73 17.86 20.5C18.44 20.24 19 19.88 19.43 19.43C19.88 19 20.24 18.44 20.5 17.86C20.73 17.27 20.85 16.64 20.85 16Z";
var mdiReceiptTextEdit = "M3 22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5V19.63L13.13 17H6V15H15.13L17.13 13H6V11H18V12.13L21 9.13V2L19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22M6 9V7H18V9H6M13 22V19.96L19.13 13.83L21.17 15.87L15.04 22H13M21 12.03C21.18 11.97 21.39 12 21.53 12.15L22.85 13.47C23.05 13.67 23.05 14 22.85 14.19L21.87 15.17L19.83 13.13L20.81 12.15L20.83 12.13C20.88 12.09 20.94 12.05 21 12.03Z";
var mdiReceiptTextEditOutline = "M18 2L19.5 3.5L21 2V9.13L19 11.13V4.91H5V19.09H10.5V20.5L9 22L7.5 20.5L6 22L4.5 20.5L3 22V2L4.5 3.5L6 2L7.5 3.5L9 2L10.5 3.5L12 2L13.5 3.5L15 2L16.5 3.5L18 2M13 19.96L19.13 13.83L21.17 15.87L15.04 22H13V19.96M19.83 13.13L20.81 12.15L20.83 12.13C20.88 12.09 20.94 12.05 21 12.03C21.18 11.97 21.39 12 21.53 12.15L22.85 13.47C23.05 13.67 23.05 14 22.85 14.19L21.87 15.17L19.83 13.13M18 12.13L17.13 13H6V11H18V12.13M15.13 15L13.13 17H6V15H15.13M18 9V7H6V9H18Z";
var mdiReceiptTextMinus = "M15 18V20H23V18H15M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.26 20.74C13.09 20.18 13 19.59 13 19C13 18.32 13.12 17.64 13.34 17H6V15H14.53C15.67 13.73 17.29 13 19 13C19.68 13 20.36 13.12 21 13.34V2L19.5 3.5M18 13H6V11H18V13M18 9H6V7H18V9Z";
var mdiReceiptTextMinusOutline = "M15 18V20H23V18H15M13.26 20.74L12 22L10.5 20.5L9 22L7.5 20.5L6 22L4.5 20.5L3 22V2L4.5 3.5L6 2L7.5 3.5L9 2L10.5 3.5L12 2L13.5 3.5L15 2L16.5 3.5L18 2L19.5 3.5L21 2V13.35C20.37 13.13 19.7 13 19 13V5H5V19H13C13 19.57 13.1 20.22 13.26 20.74M14.54 15C14 15.58 13.61 16.25 13.35 17H6V15H14.54M6 11H18V13H6V11M6 7H18V9H6V7Z";
var mdiReceiptTextOutline = "M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.5 20.5L15 22L16.5 20.5L18 22L19.5 20.5L21 22V2L19.5 3.5M19 19H5V5H19V19M6 15H18V17H6M6 11H18V13H6M6 7H18V9H6V7Z";
var mdiReceiptTextPlus = "M18 15V18H15V20H18V23H20V20H23V18H20V15H18M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.26 20.74C13.09 20.18 13 19.59 13 19C13 18.32 13.12 17.64 13.34 17H6V15H14.53C15.67 13.73 17.29 13 19 13C19.68 13 20.36 13.12 21 13.34V2L19.5 3.5M18 13H6V11H18V13M18 9H6V7H18V9Z";
var mdiReceiptTextPlusOutline = "M18 15V18H15V20H18V23H20V20H23V18H20V15H18M13.26 20.74L12 22L10.5 20.5L9 22L7.5 20.5L6 22L4.5 20.5L3 22V2L4.5 3.5L6 2L7.5 3.5L9 2L10.5 3.5L12 2L13.5 3.5L15 2L16.5 3.5L18 2L19.5 3.5L21 2V13.35C20.37 13.13 19.7 13 19 13V5H5V19H13C13 19.57 13.1 20.22 13.26 20.74M14.54 15C14 15.58 13.61 16.25 13.35 17H6V15H14.54M6 11H18V13H6V11M6 7H18V9H6V7Z";
var mdiReceiptTextRemove = "M21.12 15.46L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.26 20.74C13.09 20.18 13 19.59 13 19C13 18.32 13.12 17.64 13.34 17H6V15H14.53C15.67 13.73 17.29 13 19 13C19.68 13 20.36 13.12 21 13.34V2L19.5 3.5M18 13H6V11H18V13M18 9H6V7H18V9Z";
var mdiReceiptTextRemoveOutline = "M21.12 15.46L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46M13.26 20.74L12 22L10.5 20.5L9 22L7.5 20.5L6 22L4.5 20.5L3 22V2L4.5 3.5L6 2L7.5 3.5L9 2L10.5 3.5L12 2L13.5 3.5L15 2L16.5 3.5L18 2L19.5 3.5L21 2V13.35C20.37 13.13 19.7 13 19 13V5H5V19H13C13 19.57 13.1 20.22 13.26 20.74M14.54 15C14 15.58 13.61 16.25 13.35 17H6V15H14.54M6 11H18V13H6V11M6 7H18V9H6V7Z";
var mdiReceiptTextSend = "M4.5 20.5L3 22V2L4.5 3.5L6 2L7.5 3.5L9 2L10.5 3.5L12 2L13.5 3.5L15 2L16.5 3.5L18 2L19.5 3.5L21 2V14.26L18 12.76V11H6V13H12V15H6V17H12V22L10.5 20.5L9 22L7.5 20.5L6 22L4.5 20.5M6 7V9H18V7H6M14 13L24 18L14 23V19L18 18L14 17V13Z";
var mdiReceiptTextSendOutline = "M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22V19.09H5V4.91H19V13.26L21 14.26V2L19.5 3.5M14 23V19L18 18L14 17V13L24 18L14 23M12 11V13H6V11H12M6 17V15H12V17H6M18 7V9H6V7H18Z";
var mdiRecord = "M19,12C19,15.86 15.86,19 12,19C8.14,19 5,15.86 5,12C5,8.14 8.14,5 12,5C15.86,5 19,8.14 19,12Z";
var mdiRecordCircle = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z";
var mdiRecordCircleOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z";
var mdiRecordPlayer = "M5,17.5A0.5,0.5 0 0,1 4.5,18H3.5A0.5,0.5 0 0,1 3,17.5V17H2A1,1 0 0,1 1,16V13A1,1 0 0,1 2,12H19V10H7L6,11V9A1,1 0 0,1 7,8H19V7H21V8A1,1 0 0,1 22,9V10H21V12H22A1,1 0 0,1 23,13V16A1,1 0 0,1 22,17H21V17.5A0.5,0.5 0 0,1 20.5,18H19.5A0.5,0.5 0 0,1 19,17.5V17H5V17.5M3,14V15H5V14H3M6,14V15H8V14H6M20.5,13.5A1,1 0 0,0 19.5,14.5A1,1 0 0,0 20.5,15.5A1,1 0 0,0 21.5,14.5A1,1 0 0,0 20.5,13.5Z";
var mdiRecordRec = "M12.5,5A7.5,7.5 0 0,0 5,12.5A7.5,7.5 0 0,0 12.5,20A7.5,7.5 0 0,0 20,12.5A7.5,7.5 0 0,0 12.5,5M7,10H9A1,1 0 0,1 10,11V12C10,12.5 9.62,12.9 9.14,12.97L10.31,15H9.15L8,13V15H7M12,10H14V11H12V12H14V13H12V14H14V15H12A1,1 0 0,1 11,14V11A1,1 0 0,1 12,10M16,10H18V11H16V14H18V15H16A1,1 0 0,1 15,14V11A1,1 0 0,1 16,10M8,11V12H9V11";
var mdiRectangle = "M4,6V19H20V6H4Z";
var mdiRectangleOutline = "M4,6V19H20V6H4M18,17H6V8H18V17Z";
var mdiRecycle = "M21.82,15.42L19.32,19.75C18.83,20.61 17.92,21.06 17,21H15V23L12.5,18.5L15,14V16H17.82L15.6,12.15L19.93,9.65L21.73,12.77C22.25,13.54 22.32,14.57 21.82,15.42M9.21,3.06H14.21C15.19,3.06 16.04,3.63 16.45,4.45L17.45,6.19L19.18,5.19L16.54,9.6L11.39,9.69L13.12,8.69L11.71,6.24L9.5,10.09L5.16,7.59L6.96,4.47C7.37,3.64 8.22,3.06 9.21,3.06M5.05,19.76L2.55,15.43C2.06,14.58 2.13,13.56 2.64,12.79L3.64,11.06L1.91,10.06L7.05,10.14L9.7,14.56L7.97,13.56L6.56,16H11V21H7.4C6.47,21.07 5.55,20.61 5.05,19.76Z";
var mdiRecycleVariant = "M7.17 7.91L8.9 8.91L12.08 3.42L14.33 7.31L11.73 8.81L17.19 10.27L18.66 4.81L16.06 6.31L13.81 2.41C13.26 1.45 12.03 1.12 11.08 1.68C10.81 1.83 10.58 2.05 10.41 2.31M10 20V18L3.66 18L5.9 14.1L8.5 15.6L7.04 10.14L1.57 11.6L4.17 13.1L1.92 17C1.37 17.96 1.7 19.18 2.65 19.73C2.92 19.89 3.22 19.97 3.54 20M19.06 11.5L17.32 12.5L20.5 18H16V15L12 19L16 23V20H20.5C21.61 20 22.5 19.11 22.5 18C22.5 17.69 22.42 17.38 22.28 17.11Z";
var mdiReddit = "M14.5 15.41C14.58 15.5 14.58 15.69 14.5 15.8C13.77 16.5 12.41 16.56 12 16.56C11.61 16.56 10.25 16.5 9.54 15.8C9.44 15.69 9.44 15.5 9.54 15.41C9.65 15.31 9.82 15.31 9.92 15.41C10.38 15.87 11.33 16 12 16C12.69 16 13.66 15.87 14.1 15.41C14.21 15.31 14.38 15.31 14.5 15.41M10.75 13.04C10.75 12.47 10.28 12 9.71 12C9.14 12 8.67 12.47 8.67 13.04C8.67 13.61 9.14 14.09 9.71 14.08C10.28 14.08 10.75 13.61 10.75 13.04M14.29 12C13.72 12 13.25 12.5 13.25 13.05S13.72 14.09 14.29 14.09C14.86 14.09 15.33 13.61 15.33 13.05C15.33 12.5 14.86 12 14.29 12M22 12C22 17.5 17.5 22 12 22S2 17.5 2 12C2 6.5 6.5 2 12 2S22 6.5 22 12M18.67 12C18.67 11.19 18 10.54 17.22 10.54C16.82 10.54 16.46 10.7 16.2 10.95C15.2 10.23 13.83 9.77 12.3 9.71L12.97 6.58L15.14 7.05C15.16 7.6 15.62 8.04 16.18 8.04C16.75 8.04 17.22 7.57 17.22 7C17.22 6.43 16.75 5.96 16.18 5.96C15.77 5.96 15.41 6.2 15.25 6.55L12.82 6.03C12.75 6 12.68 6.03 12.63 6.07C12.57 6.11 12.54 6.17 12.53 6.24L11.79 9.72C10.24 9.77 8.84 10.23 7.82 10.96C7.56 10.71 7.2 10.56 6.81 10.56C6 10.56 5.35 11.21 5.35 12C5.35 12.61 5.71 13.11 6.21 13.34C6.19 13.5 6.18 13.62 6.18 13.78C6.18 16 8.79 17.85 12 17.85C15.23 17.85 17.85 16.03 17.85 13.78C17.85 13.64 17.84 13.5 17.81 13.34C18.31 13.11 18.67 12.6 18.67 12Z";
var mdiRedhat = "M15.34 13.16C16.66 13.16 18.56 12.89 18.56 11.32C18.57 11.2 18.56 11.08 18.53 10.96L17.75 7.56C17.57 6.81 17.41 6.47 16.09 5.81C15.07 5.29 12.85 4.43 12.19 4.43C11.58 4.43 11.4 5.22 10.67 5.22C9.97 5.22 9.45 4.63 8.79 4.63C8.16 4.63 7.75 5.06 7.43 5.94C7.43 5.94 6.55 8.44 6.43 8.8C6.42 8.87 6.41 8.93 6.41 9C6.41 9.97 10.23 13.15 15.34 13.15M18.77 11.96C18.95 12.82 18.95 12.91 18.95 13C18.95 14.5 17.29 15.31 15.12 15.31C10.2 15.31 5.89 12.43 5.89 10.53C5.89 10.26 5.95 10 6.05 9.76C4.28 9.84 2 10.16 2 12.18C2 15.5 9.84 19.57 16.05 19.57C20.81 19.57 22 17.42 22 15.72C22 14.38 20.85 12.86 18.77 11.96";
var mdiRedo = "M18.4,10.6C16.55,9 14.15,8 11.5,8C6.85,8 2.92,11.03 1.54,15.22L3.9,16C4.95,12.81 7.95,10.5 11.5,10.5C13.45,10.5 15.23,11.22 16.62,12.38L13,16H22V7L18.4,10.6Z";
var mdiRedoVariant = "M10.5,7A6.5,6.5 0 0,0 4,13.5A6.5,6.5 0 0,0 10.5,20H14V18H10.5C8,18 6,16 6,13.5C6,11 8,9 10.5,9H16.17L13.09,12.09L14.5,13.5L20,8L14.5,2.5L13.08,3.91L16.17,7H10.5M18,18H16V20H18V18Z";
var mdiReflectHorizontal = "M22,20H14A1,1 0 0,1 13,19V4.97C13,4.5 13.31,4.12 13.74,4C14.19,3.88 14.65,4.08 14.87,4.47L22.89,18.5C23.07,18.81 23.07,19.19 22.89,19.5C22.71,19.81 22.38,20 22,20M2,20C1.62,20 1.29,19.81 1.11,19.5C0.93,19.19 0.93,18.81 1.11,18.5L9.13,4.47C9.35,4.08 9.81,3.88 10.26,4C10.69,4.12 11,4.5 11,4.97V19A1,1 0 0,1 10,20H2M9,18V8.74L3.71,18H9Z";
var mdiReflectVertical = "M18,23H6C5.61,23 5.26,22.79 5.09,22.45C4.92,22.11 4.96,21.7 5.19,21.4L11.2,13.38C11.58,12.87 12.42,12.87 12.8,13.38L18.81,21.4C19.04,21.7 19.08,22.11 18.91,22.45C18.74,22.79 18.39,23 18,23M18,1C18.39,1 18.74,1.21 18.91,1.55C19.08,1.89 19.04,2.3 18.81,2.6L12.8,10.62C12.42,11.13 11.58,11.13 11.2,10.62L5.19,2.6C4.96,2.3 4.92,1.89 5.09,1.55C5.26,1.21 5.61,1 6,1H18M8,3L12,8.35L16,3H8Z";
var mdiRefresh = "M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z";
var mdiRefreshAuto = "M12.68 6H11.32L7 16H9L9.73 14H14.27L15 16H17L12.68 6M10.3 12.5L12 8L13.7 12.5H10.3M17.4 20.4L19 22H14V17L16 19C18.39 17.61 20 14.95 20 12C20 7.59 16.41 4 12 4S4 7.59 4 12C4 14.95 5.61 17.53 8 18.92V21.16C4.47 19.61 2 16.1 2 12C2 6.5 6.5 2 12 2S22 6.5 22 12C22 15.53 20.17 18.62 17.4 20.4Z";
var mdiRefreshCircle = "M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2M18 11H13L14.81 9.19A3.94 3.94 0 0 0 12 8A4 4 0 1 0 15.86 13H17.91A6 6 0 1 1 12 6A5.91 5.91 0 0 1 16.22 7.78L18 6Z";
var mdiRegex = "M16,16.92C15.67,16.97 15.34,17 15,17C14.66,17 14.33,16.97 14,16.92V13.41L11.5,15.89C11,15.5 10.5,15 10.11,14.5L12.59,12H9.08C9.03,11.67 9,11.34 9,11C9,10.66 9.03,10.33 9.08,10H12.59L10.11,7.5C10.3,7.25 10.5,7 10.76,6.76V6.76C11,6.5 11.25,6.3 11.5,6.11L14,8.59V5.08C14.33,5.03 14.66,5 15,5C15.34,5 15.67,5.03 16,5.08V8.59L18.5,6.11C19,6.5 19.5,7 19.89,7.5L17.41,10H20.92C20.97,10.33 21,10.66 21,11C21,11.34 20.97,11.67 20.92,12H17.41L19.89,14.5C19.7,14.75 19.5,15 19.24,15.24V15.24C19,15.5 18.75,15.7 18.5,15.89L16,13.41V16.92H16V16.92M5,19A2,2 0 0,1 7,17A2,2 0 0,1 9,19A2,2 0 0,1 7,21A2,2 0 0,1 5,19H5Z";
var mdiRegisteredTrademark = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12.25,13.27H10.81V16.5H9V7.71H12.26C13.29,7.71 14.09,7.94 14.66,8.4C15.22,8.87 15.5,9.5 15.5,10.36C15.5,10.96 15.37,11.46 15.11,11.86C14.85,12.26 14.46,12.58 13.93,12.81L15.83,16.4V16.5H13.89L12.25,13.27M10.81,11.81H12.27C12.72,11.81 13.07,11.69 13.32,11.46C13.57,11.23 13.69,10.91 13.69,10.5C13.69,10.09 13.58,9.77 13.34,9.53C13.11,9.29 12.75,9.18 12.26,9.18H10.81V11.81Z";
var mdiReiterate = "M10.5 4A6.5 6.5 0 0 0 4 10H1L5 14L9 10H6.03A4.5 4.5 0 0 1 10.5 6A4.5 4.5 0 0 1 15 10.5A4.5 4.5 0 0 1 10.5 15H2V17H10.5A6.5 6.5 0 0 0 17 10.5A6.5 6.5 0 0 0 10.5 4M19 12V15H16.5A7.5 7.5 0 0 1 14.24 17H19V20L23 16Z";
var mdiRelationManyToMany = "M22 13V19H21L19 17H11V9H5L3 11H2V5H3L5 7H13V15H19L21 13Z";
var mdiRelationManyToOne = "M22 15V17H19V19H17V17H11V9H5L3 11H2V5H3L5 7H13V15H17V13H19V15Z";
var mdiRelationManyToOneOrMany = "M22 13V19H21L19 17V19H17V17H11V9H5L3 11H2V5H3L5 7H13V15H17V13H19V15L21 13Z";
var mdiRelationManyToOnlyOne = "M22 15V17H21V19H19V17H18V19H16V17H11V9H5L3 11H2V5H3L5 7H13V15H16V13H18V15H19V13H21V15Z";
var mdiRelationManyToZeroOrMany = "M21 13L19 15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H5L3 5H2V11H3L5 9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19L21 19H22V13M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z";
var mdiRelationManyToZeroOrOne = "M21 15V13H19V15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H5L3 5H2V11H3L5 9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19V19H21V17H22V15M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z";
var mdiRelationOneOrManyToMany = "M22 13V19H21L19 17H11V9H7V11H5V9L3 11H2V5H3L5 7V5H7V7H13V15H19L21 13Z";
var mdiRelationOneOrManyToOne = "M22 15V17H19V19H17V17H11V9H7V11H5V9L3 11H2V5H3L5 7V5H7V7H13V15H17V13H19V15Z";
var mdiRelationOneOrManyToOneOrMany = "M22 13V19H21L19 17V19H17V17H11V9H7V11H5V9L3 11H2V5H3L5 7V5H7V7H13V15H17V13H19V15L21 13Z";
var mdiRelationOneOrManyToOnlyOne = "M22 15V17H21V19H19V17H18V19H16V17H11V9H7V11H5V9L3 11H2V5H3L5 7V5H7V7H13V15H16V13H18V15H19V13H21V15Z";
var mdiRelationOneOrManyToZeroOrMany = "M21 13L19 15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H7V5H5V7L3 5H2V11H3L5 9V11H7V9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19L21 19H22V13M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z";
var mdiRelationOneOrManyToZeroOrOne = "M21 15V13H19V15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H7V5H5V7L3 5H2V11H3L5 9V11H7V9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19V19H21V17H22V15M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z";
var mdiRelationOneToMany = "M22 13V19H21L19 17H11V9H7V11H5V9H2V7H5V5H7V7H13V15H19L21 13Z";
var mdiRelationOneToOne = "M22 15V17H19V19H17V17H11V9H7V11H5V9H2V7H5V5H7V7H13V15H17V13H19V15Z";
var mdiRelationOneToOneOrMany = "M22 13V19H21L19 17V19H17V17H11V9H7V11H5V9H2V7H5V5H7V7H13V15H17V13H19V15L21 13Z";
var mdiRelationOneToOnlyOne = "M22 15V17H21V19H19V17H18V19H16V17H11V9H7V11H5V9H2V7H5V5H7V7H13V15H16V13H18V15H19V13H21V15Z";
var mdiRelationOneToZeroOrMany = "M21 13L19 15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H7V5H5V7H2V9H5V11H7V9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19L21 19H22V13M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z";
var mdiRelationOneToZeroOrOne = "M21 15V13H19V15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H7V5H5V7H2V9H5V11H7V9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19V19H21V17H22V15M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z";
var mdiRelationOnlyOneToMany = "M22 13V19H21L19 17H11V9H8V11H6V9H5V11H3V9H2V7H3V5H5V7H6V5H8V7H13V15H19L21 13Z";
var mdiRelationOnlyOneToOne = "M22 15V17H19V19H17V17H11V9H8V11H6V9H5V11H3V9H2V7H3V5H5V7H6V5H8V7H13V15H17V13H19V15Z";
var mdiRelationOnlyOneToOneOrMany = "M22 13V19H21L19 17V19H17V17H11V9H8V11H6V9H5V11H3V9H2V7H3V5H5V7H6V5H8V7H13V15H17V13H19V15L21 13Z";
var mdiRelationOnlyOneToOnlyOne = "M22 15V17H21V19H19V17H18V19H16V17H11V9H8V11H6V9H5V11H3V9H2V7H3V5H5V7H6V5H8V7H13V15H16V13H18V15H19V13H21V15Z";
var mdiRelationOnlyOneToZeroOrMany = "M21 13L19 15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H8V5H6V7H5V5H3V7H2V9H3V11H5V9H6V11H8V9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19L21 19H22V13M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z";
var mdiRelationOnlyOneToZeroOrOne = "M21 15V13H19V15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H8V5H6V7H5V5H3V7H2V9H3V11H5V9H6V11H8V9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19V19H21V17H22V15M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z";
var mdiRelationZeroOrManyToMany = "M21 13L19 15H13V7H9.79A2.5 2.5 0 0 0 5.21 7H5L3 5H2V11H3L5 9H5.21A2.5 2.5 0 0 0 9.79 9H11V17H19L21 19H22V13M7.5 9A1 1 0 1 1 8.5 8A1 1 0 0 1 7.5 9Z";
var mdiRelationZeroOrManyToOne = "M19 15V13H17V15H13V7H9.79A2.5 2.5 0 0 0 5.21 7H5L3 5H2V11H3L5 9H5.21A2.5 2.5 0 0 0 9.79 9H11V17H17V19H19V17H22V15M7.5 9A1 1 0 1 1 8.5 8A1 1 0 0 1 7.5 9Z";
var mdiRelationZeroOrManyToOneOrMany = "M21 13L19 15V13H17V15H13V7H9.79A2.5 2.5 0 0 0 5.21 7H5L3 5H2V11H3L5 9H5.21A2.5 2.5 0 0 0 9.79 9H11V17H17V19H19V17L21 19H22V13M7.5 9A1 1 0 1 1 8.5 8A1 1 0 0 1 7.5 9Z";
var mdiRelationZeroOrManyToOnlyOne = "M21 15V13H19V15H18V13H16V15H13V7H9.79A2.5 2.5 0 0 0 5.21 7H5L3 5H2V11H3L5 9H5.21A2.5 2.5 0 0 0 9.79 9H11V17H16V19H18V17H19V19H21V17H22V15M7.5 9A1 1 0 1 1 8.5 8A1 1 0 0 1 7.5 9Z";
var mdiRelationZeroOrManyToZeroOrMany = "M21 13L19 15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H9.79A2.5 2.5 0 0 0 5.21 7H5L3 5H2V11H3L5 9H5.21A2.5 2.5 0 0 0 9.79 9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19L21 19H22V13M7.5 9A1 1 0 1 1 8.5 8A1 1 0 0 1 7.5 9M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z";
var mdiRelationZeroOrManyToZeroOrOne = "M21 15V13H19V15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H9.79A2.5 2.5 0 0 0 5.21 7H5L3 5H2V11H3L5 9H5.21A2.5 2.5 0 0 0 9.79 9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19V19H21V17H22V15M7.5 9A1 1 0 1 1 8.5 8A1 1 0 0 1 7.5 9M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z";
var mdiRelationZeroOrOneToMany = "M21 13L19 15H13V7H9.79A2.5 2.5 0 0 0 5.21 7H5V5H3V7H2V9H3V11H5V9H5.21A2.5 2.5 0 0 0 9.79 9H11V17H19L21 19H22V13M7.5 9A1 1 0 1 1 8.5 8A1 1 0 0 1 7.5 9Z";
var mdiRelationZeroOrOneToOne = "M19 15V13H17V15H13V7H9.79A2.5 2.5 0 0 0 5.21 7H5V5H3V7H2V9H3V11H5V9H5.21A2.5 2.5 0 0 0 9.79 9H11V17H17V19H19V17H22V15M7.5 9A1 1 0 1 1 8.5 8A1 1 0 0 1 7.5 9Z";
var mdiRelationZeroOrOneToOneOrMany = "M21 13L19 15V13H17V15H13V7H9.79A2.5 2.5 0 0 0 5.21 7H5V5H3V7H2V9H3V11H5V9H5.21A2.5 2.5 0 0 0 9.79 9H11V17H17V19H19V17L21 19H22V13M7.5 9A1 1 0 1 1 8.5 8A1 1 0 0 1 7.5 9Z";
var mdiRelationZeroOrOneToOnlyOne = "M21 15V13H19V15H18V13H16V15H13V7H9.79A2.5 2.5 0 0 0 5.21 7H5V5H3V7H2V9H3V11H5V9H5.21A2.5 2.5 0 0 0 9.79 9H11V17H16V19H18V17H19V19H21V17H22V15M7.5 9A1 1 0 1 1 8.5 8A1 1 0 0 1 7.5 9Z";
var mdiRelationZeroOrOneToZeroOrMany = "M21 13L19 15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H9.79A2.5 2.5 0 0 0 5.21 7H5V5H3V7H2V9H3V11H5V9H5.21A2.5 2.5 0 0 0 9.79 9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19L21 19H22V13M7.5 9A1 1 0 1 1 8.5 8A1 1 0 0 1 7.5 9M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z";
var mdiRelationZeroOrOneToZeroOrOne = "M21 15V13H19V15H18.79A2.5 2.5 0 0 0 14.21 15H13V7H9.79A2.5 2.5 0 0 0 5.21 7H5V5H3V7H2V9H3V11H5V9H5.21A2.5 2.5 0 0 0 9.79 9H11V17H14.21A2.5 2.5 0 0 0 18.79 17H19V19H21V17H22V15M7.5 9A1 1 0 1 1 8.5 8A1 1 0 0 1 7.5 9M16.5 17A1 1 0 1 1 17.5 16A1 1 0 0 1 16.5 17Z";
var mdiRelativeScale = "M20,18H4V6H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4M12,10H10V12H12M8,10H6V12H8M16,14H14V16H16M16,10H14V12H16V10Z";
var mdiReload = "M2 12C2 16.97 6.03 21 11 21C13.39 21 15.68 20.06 17.4 18.4L15.9 16.9C14.63 18.25 12.86 19 11 19C4.76 19 1.64 11.46 6.05 7.05C10.46 2.64 18 5.77 18 12H15L19 16H19.1L23 12H20C20 7.03 15.97 3 11 3C6.03 3 2 7.03 2 12Z";
var mdiReloadAlert = "M2 12C2 17 6 21 11 21C13.4 21 15.7 20.1 17.4 18.4L15.9 16.9C14.6 18.3 12.9 19 11 19C4.8 19 1.6 11.5 6.1 7.1S18 5.8 18 12H15L19 16H19.1L23 12H20C20 7 16 3 11 3S2 7 2 12M10 15H12V17H10V15M10 7H12V13H10V7";
var mdiReminder = "M7.25,3C7.9,3 8.5,3.21 9,3.56V3A2,2 0 0,1 11,1A2,2 0 0,1 13,3V3.57C13.5,3.22 14.1,3 14.75,3A3,3 0 0,1 17.75,6C17.75,7.58 16.54,8.87 15,9H13V10H14.24L14.72,10.13L19.31,12.42C20.13,12.73 20.53,13.34 20.53,14.25L20.5,14.39V14.53L19.5,21.28C19.44,21.75 19.22,22.16 18.84,22.5C18.47,22.84 18.05,23 17.58,23H10C9.45,23 9,22.81 8.58,22.41L2,15.84L3.05,14.77C3.33,14.5 3.69,14.34 4.13,14.34H4.45L9,15.33V10L9,9H7V9C5.46,8.86 4.25,7.57 4.25,6A3,3 0 0,1 7.25,3M9,6A1.75,1.75 0 0,0 7.25,4.25A1.75,1.75 0 0,0 5.5,6C5.5,6.88 6.15,7.61 7,7.73V7.75H9V6M15,7.75V7.74C15.85,7.62 16.5,6.89 16.5,6C16.5,5.04 15.72,4.26 14.75,4.26C13.78,4.26 13,5.04 13,6V7.75H15Z";
var mdiRemote = "M12,0C8.96,0 6.21,1.23 4.22,3.22L5.63,4.63C7.26,3 9.5,2 12,2C14.5,2 16.74,3 18.36,4.64L19.77,3.23C17.79,1.23 15.04,0 12,0M7.05,6.05L8.46,7.46C9.37,6.56 10.62,6 12,6C13.38,6 14.63,6.56 15.54,7.46L16.95,6.05C15.68,4.78 13.93,4 12,4C10.07,4 8.32,4.78 7.05,6.05M12,15A2,2 0 0,1 10,13A2,2 0 0,1 12,11A2,2 0 0,1 14,13A2,2 0 0,1 12,15M15,9H9A1,1 0 0,0 8,10V22A1,1 0 0,0 9,23H15A1,1 0 0,0 16,22V10A1,1 0 0,0 15,9Z";
var mdiRemoteDesktop = "M3,2A2,2 0 0,0 1,4V16C1,17.11 1.9,18 3,18H10V20H8V22H16V20H14V18H21A2,2 0 0,0 23,16V4A2,2 0 0,0 21,2M3,4H21V16H3M15,5L11.5,8.5L15,12L16.4,10.6L14.3,8.5L16.4,6.4M9,8L7.6,9.4L9.7,11.5L7.6,13.6L9,15L12.5,11.5";
var mdiRemoteOff = "M2,5.27L3.28,4L21,21.72L19.73,23L16,19.27V22A1,1 0 0,1 15,23H9C8.46,23 8,22.55 8,22V11.27L2,5.27M12,0C15.05,0 17.8,1.23 19.77,3.23L18.36,4.64C16.75,3 14.5,2 12,2C9.72,2 7.64,2.85 6.06,4.24L4.64,2.82C6.59,1.07 9.17,0 12,0M12,4C13.94,4 15.69,4.78 16.95,6.05L15.55,7.46C14.64,6.56 13.39,6 12,6C10.83,6 9.76,6.4 8.9,7.08L7.5,5.66C8.7,4.62 10.28,4 12,4M15,9C15.56,9 16,9.45 16,10V14.18L13.5,11.69L13.31,11.5L10.82,9H15M10.03,13.3C10.16,14.16 10.84,14.85 11.71,15L10.03,13.3Z";
var mdiRemoteTv = "M9,2C7.89,2 7,2.89 7,4V20C7,21.11 7.89,22 9,22H15C16.11,22 17,21.11 17,20V4C17,2.89 16.11,2 15,2H13V4H11V2H9M11,6H13V8H15V10H13V12H11V10H9V8H11V6M9,14H11V16H9V14M13,14H15V16H13V14M9,18H11V20H9V18M13,18H15V20H13V18Z";
var mdiRemoteTvOff = "M2,5.27L3.28,4L20,20.72L18.73,22L17,20.25C16.86,21.24 16,22 15,22H9A2,2 0 0,1 7,20V10.27L2,5.27M9,2H11V4H13V2H15A2,2 0 0,1 17,4V15.18L13,11.18V10H15V8H13V6H11V8H9.82L7,5.18V4A2,2 0 0,1 9,2M9,20H11V18H9V20M13,20H15V18.27L14.73,18H13V20M9,14V16H11V14.27L10.73,14H9Z";
var mdiRename = "M15 16L11 20H21V16H15M12.06 7.19L3 16.25V20H6.75L15.81 10.94L12.06 7.19M18.71 8.04C19.1 7.65 19.1 7 18.71 6.63L16.37 4.29C16.17 4.09 15.92 4 15.66 4C15.41 4 15.15 4.1 14.96 4.29L13.13 6.12L16.88 9.87L18.71 8.04Z";
var mdiRenameBox = "M18,17H10.5L12.5,15H18M6,17V14.5L13.88,6.65C14.07,6.45 14.39,6.45 14.59,6.65L16.35,8.41C16.55,8.61 16.55,8.92 16.35,9.12L8.47,17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiRenameBoxOutline = "M17 17H11.5L13.5 15H17M7 17V14.5L14.9 6.7C15.1 6.5 15.4 6.5 15.6 6.7L17.4 8.5C17.6 8.7 17.6 9 17.4 9.2L9.5 17M19 5V19H5V5H19M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z";
var mdiRenameOutline = "M15 16L11 20H21V16H15M12.06 7.19L3 16.25V20H6.75L15.81 10.94L12.06 7.19M5.92 18H5V17.08L12.06 10L13 10.94L5.92 18M18.71 8.04C19.1 7.65 19.1 7 18.71 6.63L16.37 4.29C16.17 4.09 15.92 4 15.66 4C15.41 4 15.15 4.1 14.96 4.29L13.13 6.12L16.88 9.87L18.71 8.04Z";
var mdiReorderHorizontal = "M3,15H21V13H3V15M3,19H21V17H3V19M3,11H21V9H3V11M3,5V7H21V5H3Z";
var mdiReorderVertical = "M9,3V21H11V3H9M5,3V21H7V3H5M13,3V21H15V3H13M19,3H17V21H19V3Z";
var mdiRepeat = "M17,17H7V14L3,18L7,22V19H19V13H17M7,7H17V10L21,6L17,2V5H5V11H7V7Z";
var mdiRepeatOff = "M2,5.27L3.28,4L20,20.72L18.73,22L15.73,19H7V22L3,18L7,14V17H13.73L7,10.27V11H5V8.27L2,5.27M17,13H19V17.18L17,15.18V13M17,5V2L21,6L17,10V7H8.82L6.82,5H17Z";
var mdiRepeatOnce = "M13,15V9H12L10,10V11H11.5V15M17,17H7V14L3,18L7,22V19H19V13H17M7,7H17V10L21,6L17,2V5H5V11H7V7Z";
var mdiRepeatVariant = "M6,5.75L10.25,10H7V16H13.5L15.5,18H7A2,2 0 0,1 5,16V10H1.75L6,5.75M18,18.25L13.75,14H17V8H10.5L8.5,6H17A2,2 0 0,1 19,8V14H22.25L18,18.25Z";
var mdiReplay = "M12,5V1L7,6L12,11V7A6,6 0 0,1 18,13A6,6 0 0,1 12,19A6,6 0 0,1 6,13H4A8,8 0 0,0 12,21A8,8 0 0,0 20,13A8,8 0 0,0 12,5Z";
var mdiReply = "M10,9V5L3,12L10,19V14.9C15,14.9 18.5,16.5 21,20C20,15 17,10 10,9Z";
var mdiReplyAll = "M13,9V5L6,12L13,19V14.9C18,14.9 21.5,16.5 24,20C23,15 20,10 13,9M7,8V5L0,12L7,19V16L3,12L7,8Z";
var mdiReplyAllOutline = "M11,9.8V10.7L12.7,10.9C15.3,11.3 17.2,12.3 18.6,13.6C16.9,13.1 15.1,12.8 13,12.8H11V14.1L8.8,12L11,9.8M13,5L6,12L13,19V14.9C18,14.9 21.5,16.5 24,20C23,15 20,10 13,9M7,8V5L0,12L7,19V16L3,12";
var mdiReplyCircle = "M2 12C2 17.5 6.5 22 12 22S22 17.5 22 12 17.5 2 12 2 2 6.5 2 12M5 11L10 6V9C15.06 9.73 17.28 13.33 18 17C16.19 14.43 13.61 13 10 13V16L5 11Z";
var mdiReplyOutline = "M8,9.8V10.7L9.7,11C12.3,11.4 14.2,12.4 15.6,13.7C13.9,13.2 12.1,12.9 10,12.9H8V14.2L5.8,12L8,9.8M10,5L3,12L10,19V14.9C15,14.9 18.5,16.5 21,20C20,15 17,10 10,9";
var mdiReproduction = "M12.72,13.15L13.62,12.26C13.6,11 14.31,9.44 15.62,8.14C17.57,6.18 20.11,5.55 21.28,6.72C22.45,7.89 21.82,10.43 19.86,12.38C18.56,13.69 17,14.4 15.74,14.38L14.85,15.28C14.5,15.61 14,15.66 13.6,15.41C12.76,15.71 12,16.08 11.56,16.8C11.03,17.68 11.03,19.1 10.47,19.95C9.91,20.81 8.79,21.1 7.61,21.1C6.43,21.1 5,21 3.95,19.5L6.43,19.92C7,20 8.5,19.39 9.05,18.54C9.61,17.68 9.61,16.27 10.14,15.38C10.61,14.6 11.5,14.23 12.43,13.91C12.42,13.64 12.5,13.36 12.72,13.15M7,2A5,5 0 0,1 12,7A5,5 0 0,1 7,12A5,5 0 0,1 2,7A5,5 0 0,1 7,2M7,4A3,3 0 0,0 4,7A3,3 0 0,0 7,10A3,3 0 0,0 10,7A3,3 0 0,0 7,4Z";
var mdiResistor = "M2,11H7L10.07,15.35L13.11,4L18,11H22V13H17L13.93,8.65L10.89,20L6,13H2V11Z";
var mdiResistorNodes = "M2,11H3.67C4.08,9.83 5.19,9 6.5,9A3,3 0 0,1 9.5,12C9.5,12.65 9.29,13.25 8.94,13.74L10.07,15.35L13.11,4L14.61,6.13L16.7,9.11L17.5,9C18.81,9 19.92,9.83 20.33,11H22V13H20.33C19.92,14.17 18.81,15 17.5,15A3,3 0 0,1 14.5,12C14.5,11.35 14.71,10.75 15.06,10.26L13.93,8.65L10.89,20L7.3,14.89C7.05,14.96 6.78,15 6.5,15C5.19,15 4.08,14.17 3.67,13H2V11M17.5,10.5A1.5,1.5 0 0,0 16,12A1.5,1.5 0 0,0 17.5,13.5A1.5,1.5 0 0,0 19,12A1.5,1.5 0 0,0 17.5,10.5M6.5,10.5A1.5,1.5 0 0,0 5,12A1.5,1.5 0 0,0 6.5,13.5A1.5,1.5 0 0,0 8,12A1.5,1.5 0 0,0 6.5,10.5Z";
var mdiResize = "M10.59,12L14.59,8H11V6H18V13H16V9.41L12,13.41V16H20V4H8V12H10.59M22,2V18H12V22H2V12H6V2H22M10,14H4V20H10V14Z";
var mdiResizeBottomRight = "M22,22H20V20H22V22M22,18H20V16H22V18M18,22H16V20H18V22M18,18H16V16H18V18M14,22H12V20H14V22M22,14H20V12H22V14Z";
var mdiResponsive = "M4,6V16H9V12A2,2 0 0,1 11,10H16A2,2 0 0,1 18,12V16H20V6H4M0,20V18H4A2,2 0 0,1 2,16V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V16A2,2 0 0,1 20,18H24V20H18V20C18,21.11 17.1,22 16,22H11A2,2 0 0,1 9,20H9L0,20M11.5,20A0.5,0.5 0 0,0 11,20.5A0.5,0.5 0 0,0 11.5,21A0.5,0.5 0 0,0 12,20.5A0.5,0.5 0 0,0 11.5,20M15.5,20A0.5,0.5 0 0,0 15,20.5A0.5,0.5 0 0,0 15.5,21A0.5,0.5 0 0,0 16,20.5A0.5,0.5 0 0,0 15.5,20M13,20V21H14V20H13M11,12V19H16V12H11Z";
var mdiRestart = "M12,4C14.1,4 16.1,4.8 17.6,6.3C20.7,9.4 20.7,14.5 17.6,17.6C15.8,19.5 13.3,20.2 10.9,19.9L11.4,17.9C13.1,18.1 14.9,17.5 16.2,16.2C18.5,13.9 18.5,10.1 16.2,7.7C15.1,6.6 13.5,6 12,6V10.6L7,5.6L12,0.6V4M6.3,17.6C3.7,15 3.3,11 5.1,7.9L6.6,9.4C5.5,11.6 5.9,14.4 7.8,16.2C8.3,16.7 8.9,17.1 9.6,17.4L9,19.4C8,19 7.1,18.4 6.3,17.6Z";
var mdiRestartAlert = "M10 4.03V.633L5 5.63L10 10.63V6.03C11.5 6.03 13.11 6.63 14.21 7.73C16.5 10.13 16.5 13.93 14.21 16.23C12.91 17.53 11.11 18.13 9.4 17.93L8.9 19.93C11.31 20.23 13.81 19.53 15.61 17.63C18.7 14.53 18.7 9.43 15.61 6.33C14.11 4.83 12.11 4.03 10 4.03M4.31 17.63C5.11 18.43 6 19.03 7 19.43L7.61 17.43C6.91 17.13 6.31 16.73 5.81 16.23C3.91 14.43 3.5 11.63 4.61 9.43L3.11 7.93C1.31 11.03 1.71 15.03 4.31 17.63M20 13H22V7H20V13M20 17H22V15H20V17Z";
var mdiRestartOff = "M20.8,22.7L16.6,18.5C14.9,19.7 12.9,20.2 10.9,19.9L11.4,17.9C12.7,18 14,17.7 15.1,17L1.1,3L2.4,1.7L16.5,15.8L17.9,17.2L22.1,21.4L20.8,22.7M12,6C13.5,6 15.1,6.6 16.2,7.8C18,9.6 18.4,12.2 17.5,14.4L19,15.9C20.7,12.9 20.2,9 17.6,6.4C16.1,4.8 14,4 12,4V0.7L7.9,4.7L12,8.8V6M6.6,9.4L5.1,7.9C3.3,11 3.7,15 6.3,17.7C7.1,18.4 8,19 9,19.4L9.5,17.4C8.9,17.1 8.3,16.7 7.7,16.2C5.9,14.4 5.5,11.6 6.6,9.4Z";
var mdiRestore = "M13,3A9,9 0 0,0 4,12H1L4.89,15.89L4.96,16.03L9,12H6A7,7 0 0,1 13,5A7,7 0 0,1 20,12A7,7 0 0,1 13,19C11.07,19 9.32,18.21 8.06,16.94L6.64,18.36C8.27,20 10.5,21 13,21A9,9 0 0,0 22,12A9,9 0 0,0 13,3Z";
var mdiRestoreAlert = "M13 3C8 3 4 7 4 12H1L4.9 15.9L5 16L9 12H6C6 8.1 9.1 5 13 5S20 8.1 20 12 16.9 19 13 19C11.1 19 9.3 18.2 8.1 16.9L6.7 18.3C8.3 20 10.5 21 13 21C18 21 22 17 22 12S18 3 13 3M12 15H14V17H12V15M12 7H14V13H12V7";
var mdiRewind = "M11.5,12L20,18V6M11,18V6L2.5,12L11,18Z";
var mdiRewind10 = "M12.5,3C17.15,3 21.08,6.03 22.47,10.22L20.1,11C19.05,7.81 16.04,5.5 12.5,5.5C10.54,5.5 8.77,6.22 7.38,7.38L10,10H3V3L5.6,5.6C7.45,4 9.85,3 12.5,3M10,12V22H8V14H6V12H10M18,14V20C18,21.11 17.11,22 16,22H14A2,2 0 0,1 12,20V14A2,2 0 0,1 14,12H16C17.11,12 18,12.9 18,14M14,14V20H16V14H14Z";
var mdiRewind15 = "M12.5 3C17.15 3 21.08 6.03 22.47 10.22L20.1 11C19.05 7.81 16.04 5.5 12.5 5.5C10.54 5.5 8.77 6.22 7.38 7.38L10 10H3V3L5.6 5.6C7.45 4 9.85 3 12.5 3M10 12V22H8V14H6V12H10M12 12H18V14H14V16H16C17.11 16 18 16.9 18 18V20C18 21.11 17.11 22 16 22H12V20H16V18H12V12Z";
var mdiRewind30 = "M19,14V20C19,21.11 18.11,22 17,22H15A2,2 0 0,1 13,20V14A2,2 0 0,1 15,12H17C18.11,12 19,12.9 19,14M15,14V20H17V14H15M11,20C11,21.11 10.1,22 9,22H5V20H9V18H7V16H9V14H5V12H9A2,2 0 0,1 11,14V15.5A1.5,1.5 0 0,1 9.5,17A1.5,1.5 0 0,1 11,18.5V20M12.5,3C17.15,3 21.08,6.03 22.47,10.22L20.1,11C19.05,7.81 16.04,5.5 12.5,5.5C10.54,5.5 8.77,6.22 7.38,7.38L10,10H3V3L5.6,5.6C7.45,4 9.85,3 12.5,3Z";
var mdiRewind45 = "M12.5 3C17.1 3 21.1 6 22.5 10.2L20.1 11C19 7.8 16 5.5 12.5 5.5C10.5 5.5 8.8 6.2 7.4 7.4L10 10H3V3L5.6 5.6C7.4 4 9.9 3 12.5 3M13 12H19V14H15V16H17C18.1 16 19 16.9 19 18V20C19 21.1 18.1 22 17 22H13V20H17V18H13V12M5 12V18H9V22H11V12H9V16H7V12H5Z";
var mdiRewind5 = "M12.5 3C17.15 3 21.08 6.03 22.47 10.22L20.1 11C19.05 7.81 16.04 5.5 12.5 5.5C10.54 5.5 8.77 6.22 7.38 7.38L10 10H3V3L5.6 5.6C7.45 4 9.85 3 12.5 3M9 12H15V14H11V16H13C14.11 16 15 16.9 15 18V20C15 21.11 14.11 22 13 22H9V20H13V18H9V12Z";
var mdiRewind60 = "M19 14V20C19 21.1 18.1 22 17 22H15C13.9 22 13 21.1 13 20V14C13 12.9 13.9 12 15 12H17C18.1 12 19 12.9 19 14M15 14V20H17V14H15M12.5 3C17.1 3 21.1 6 22.5 10.2L20.1 11C19 7.8 16 5.5 12.5 5.5C10.5 5.5 8.8 6.2 7.4 7.4L10 10H3V3L5.6 5.6C7.4 4 9.9 3 12.5 3M7 12C5.9 12 5 12.9 5 14V20C5 21.1 5.9 22 7 22H9C10.1 22 11 21.1 11 20V18C11 16.9 10.1 16 9 16H7V14H11V12H7M7 18H9V20H7V18Z";
var mdiRewindOutline = "M10,9.9L7,12L10,14.1V9.9M19,9.9L16,12L19,14.1V9.9M12,6V18L3.5,12L12,6M21,6V18L12.5,12L21,6Z";
var mdiRhombus = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2Z";
var mdiRhombusMedium = "M12 6.46C11.72 6.46 11.44 6.56 11.22 6.78L6.78 11.22C6.35 11.65 6.35 12.35 6.78 12.78L11.22 17.22C11.65 17.65 12.35 17.65 12.78 17.22L17.22 12.78C17.65 12.35 17.65 11.65 17.22 11.22L12.78 6.78C12.56 6.56 12.28 6.46 12 6.46Z";
var mdiRhombusMediumOutline = "M12 6.46C11.72 6.46 11.44 6.56 11.22 6.78L6.78 11.22C6.35 11.65 6.35 12.35 6.78 12.78L11.22 17.22C11.65 17.65 12.35 17.65 12.78 17.22L17.22 12.78C17.65 12.35 17.65 11.65 17.22 11.22L12.78 6.78C12.56 6.56 12.28 6.46 12 6.46M12 8.83L15.17 12L12 15.17L8.83 12L12 8.83Z";
var mdiRhombusOutline = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M12 4L20 12L12 20L4 12Z";
var mdiRhombusSplit = "M12 2C11.5 2 11 2.19 10.59 2.59L7.29 5.88L12 10.58L16.71 5.88L13.41 2.59C13 2.19 12.5 2 12 2M5.88 7.29L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L5.88 16.71L10.58 12L5.88 7.29M18.12 7.29L13.42 12L18.12 16.71L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L18.12 7.29M12 13.42L7.29 18.12L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L16.71 18.12L12 13.42Z";
var mdiRhombusSplitOutline = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M12 4L15.29 7.29L12 10.59L8.71 7.29L12 4M7.29 8.71L10.59 12L7.29 15.29L4 12L7.29 8.71M16.71 8.71L20 12L16.71 15.29L13.41 12L16.71 8.71M12 13.41L15.29 16.71L12 20L8.71 16.71L12 13.41Z";
var mdiRibbon = "M13.41,19.31L16.59,22.5L18,21.07L14.83,17.9M15.54,11.53H15.53L12,15.07L8.47,11.53H8.46V11.53C7.56,10.63 7,9.38 7,8A5,5 0 0,1 12,3A5,5 0 0,1 17,8C17,9.38 16.44,10.63 15.54,11.53M16.9,13C18.2,11.73 19,9.96 19,8A7,7 0 0,0 12,1A7,7 0 0,0 5,8C5,9.96 5.81,11.73 7.1,13V13L10.59,16.5L6,21.07L7.41,22.5L16.9,13Z";
var mdiRice = "M22,11H19.7C19.4,9.9 18.9,8.8 18.2,8L21.6,2.6L19.9,1.5L16.7,6.6C16.3,6.3 16,6.1 15.5,5.9L16.4,2.3L14.5,1.8L13.7,5.2C13.1,5.1 12.6,5 12,5C8.3,5 5.2,7.6 4.3,11H2C2,15.1 4.5,18.6 8,20.2V22H16V20.2C19.5,18.6 22,15.1 22,11M12,7C14.6,7 16.8,8.7 17.6,11H6.4C7.2,8.7 9.4,7 12,7Z";
var mdiRickshaw = "M20 14.05V12.73C20 12.26 19.84 11.8 19.54 11.44L15.6 6.72C15.22 6.26 14.66 6 14.06 6H4C2.9 6 2 6.9 2 8V15C2 16.1 2.9 17 4 17H4.05C4.28 18.14 5.29 19 6.5 19S8.72 18.14 8.95 17H17.05C17.28 18.14 18.29 19 19.5 19C20.88 19 22 17.88 22 16.5C22 15.29 21.14 14.28 20 14.05M3.5 8C3.5 7.73 3.73 7.5 4 7.5H7V12H3.5V8M6.5 17.5C5.95 17.5 5.5 17.05 5.5 16.5S5.95 15.5 6.5 15.5 7.5 15.95 7.5 16.5 7.05 17.5 6.5 17.5M13 15.5H9V14H11V12H9V7.5H13V15.5M15 8.34L18.05 12H15V8.34M19.5 17.5C18.95 17.5 18.5 17.05 18.5 16.5S18.95 15.5 19.5 15.5 20.5 15.95 20.5 16.5 20.05 17.5 19.5 17.5Z";
var mdiRickshawElectric = "M20 12.05V10.73C20 10.26 19.84 9.8 19.54 9.44L15.6 4.72C15.22 4.26 14.66 4 14.06 4H4C2.9 4 2 4.9 2 6V13C2 14.1 2.9 15 4 15H4.05C4.28 16.14 5.29 17 6.5 17S8.72 16.14 8.95 15H17.05C17.28 16.14 18.29 17 19.5 17C20.88 17 22 15.88 22 14.5C22 13.29 21.14 12.28 20 12.05M3.5 6C3.5 5.73 3.73 5.5 4 5.5H7V10H3.5V6M6.5 15.5C5.95 15.5 5.5 15.05 5.5 14.5S5.95 13.5 6.5 13.5 7.5 13.95 7.5 14.5 7.05 15.5 6.5 15.5M13 13.5H9V12H11V10H9V5.5H13V13.5M15 6.34L18.05 10H15V6.34M19.5 15.5C18.95 15.5 18.5 15.05 18.5 14.5S18.95 13.5 19.5 13.5 20.5 13.95 20.5 14.5 20.05 15.5 19.5 15.5M11 20H7L13 23V21H17L11 18V20Z";
var mdiRing = "M12,10L8,4.4L9.6,2H14.4L16,4.4L12,10M15.5,6.8L14.3,8.5C16.5,9.4 18,11.5 18,14A6,6 0 0,1 12,20A6,6 0 0,1 6,14C6,11.5 7.5,9.4 9.7,8.5L8.5,6.8C5.8,8.1 4,10.8 4,14A8,8 0 0,0 12,22A8,8 0 0,0 20,14C20,10.8 18.2,8.1 15.5,6.8Z";
var mdiRivet = "M11.43,2C10.61,2 9.94,2.65 9.94,3.5C9.94,4.64 9.94,5.8 9.94,6.96H7.95V7.95H15.91V6.96H13.92C13.92,5.8 13.92,4.64 13.92,3.5C13.92,2.65 13.25,2 12.43,2H11.43M10.94,8.95V21.87L11.93,22.87L12.92,21.87V8.95H10.94Z";
var mdiRoad = "M11,16H13V20H11M11,10H13V14H11M11,4H13V8H11M4,22H20V2H4V22Z";
var mdiRoadVariant = "M18.1,4.8C18,4.3 17.6,4 17.1,4H13L13.2,7H10.8L11,4H6.8C6.3,4 5.9,4.4 5.8,4.8L3.1,18.8C3,19.4 3.5,20 4.1,20H10L10.3,15H13.7L14,20H19.8C20.4,20 20.9,19.4 20.8,18.8L18.1,4.8M10.4,13L10.6,9H13.2L13.4,13H10.4Z";
var mdiRobber = "M10.7 12.5C10.7 12.8 9.4 13.2 8.4 13.2S6.3 12.5 6.3 12.3C6.3 12 7 11.1 8.6 11C9.5 10.9 10.5 11.5 10.7 12.5M15.4 11C14.4 10.9 13.5 11.5 13.3 12.5C13.3 12.8 14.5 13.2 15.6 13.2C16.7 13.2 17.7 12.5 17.7 12.3S17 11.1 15.4 11M22 12C22 17.5 17.5 22 12 22S2 17.5 2 12 6.5 2 12 2 22 6.5 22 12M20 11.2C20 9.2 19.3 8.5 16.7 8.5C14.1 8.5 13.3 9.6 12 9.6S10 8.5 7.3 8.5 4 9.1 4 11.2C4 14.6 5.5 16.5 7.6 16.5C9.2 16.5 10.4 14.5 12 14.5S14.7 16.5 16.4 16.5C18.5 16.5 20 14.6 20 11.2Z";
var mdiRobot = "M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2M7.5,13A2.5,2.5 0 0,0 5,15.5A2.5,2.5 0 0,0 7.5,18A2.5,2.5 0 0,0 10,15.5A2.5,2.5 0 0,0 7.5,13M16.5,13A2.5,2.5 0 0,0 14,15.5A2.5,2.5 0 0,0 16.5,18A2.5,2.5 0 0,0 19,15.5A2.5,2.5 0 0,0 16.5,13Z";
var mdiRobotAngry = "M22 14H21C21 10.13 17.87 7 14 7H13V5.73C13.6 5.39 14 4.74 14 4C14 2.9 13.11 2 12 2S10 2.9 10 4C10 4.74 10.4 5.39 11 5.73V7H10C6.13 7 3 10.13 3 14H2C1.45 14 1 14.45 1 15V18C1 18.55 1.45 19 2 19H3V20C3 21.11 3.9 22 5 22H19C20.11 22 21 21.11 21 20V19H22C22.55 19 23 18.55 23 18V15C23 14.45 22.55 14 22 14M7.5 18C6.12 18 5 16.88 5 15.5C5 14.68 5.4 13.96 6 13.5L9.83 16.38C9.5 17.32 8.57 18 7.5 18M16.5 18C15.43 18 14.5 17.32 14.17 16.38L18 13.5C18.6 13.96 19 14.68 19 15.5C19 16.88 17.88 18 16.5 18Z";
var mdiRobotAngryOutline = "M22 14H21C21 10.13 17.87 7 14 7H13V5.73C13.6 5.39 14 4.74 14 4C14 2.9 13.11 2 12 2S10 2.9 10 4C10 4.74 10.4 5.39 11 5.73V7H10C6.13 7 3 10.13 3 14H2C1.45 14 1 14.45 1 15V18C1 18.55 1.45 19 2 19H3V20C3 21.11 3.9 22 5 22H19C20.11 22 21 21.11 21 20V19H22C22.55 19 23 18.55 23 18V15C23 14.45 22.55 14 22 14M21 17H19V20H5V17H3V16H5V14C5 11.24 7.24 9 10 9H14C16.76 9 19 11.24 19 14V16H21V17M17.5 15.5C17.5 16.61 16.61 17.5 15.5 17.5C14.53 17.5 13.73 16.81 13.54 15.9L16.5 13.78C17.1 14.13 17.5 14.76 17.5 15.5M7.5 13.78L10.46 15.9C10.28 16.81 9.47 17.5 8.5 17.5C7.4 17.5 6.5 16.61 6.5 15.5C6.5 14.76 6.9 14.13 7.5 13.78Z";
var mdiRobotConfused = "M20 4H18V3H20.5C20.78 3 21 3.22 21 3.5V5.5C21 5.78 20.78 6 20.5 6H20V7H19V5H20V4M19 9H20V8H19V9M17 3H16V7H17V3M23 15V18C23 18.55 22.55 19 22 19H21V20C21 21.11 20.11 22 19 22H5C3.9 22 3 21.11 3 20V19H2C1.45 19 1 18.55 1 18V15C1 14.45 1.45 14 2 14H3C3 10.13 6.13 7 10 7H11V5.73C10.4 5.39 10 4.74 10 4C10 2.9 10.9 2 12 2S14 2.9 14 4C14 4.74 13.6 5.39 13 5.73V7H14C14.34 7 14.67 7.03 15 7.08V10H19.74C20.53 11.13 21 12.5 21 14H22C22.55 14 23 14.45 23 15M10 15.5C10 14.12 8.88 13 7.5 13S5 14.12 5 15.5 6.12 18 7.5 18 10 16.88 10 15.5M19 15.5C19 14.12 17.88 13 16.5 13S14 14.12 14 15.5 15.12 18 16.5 18 19 16.88 19 15.5M17 8H16V9H17V8Z";
var mdiRobotConfusedOutline = "M19 8H20V9H19V8M20 5H19V7H20V6H20.5C20.78 6 21 5.78 21 5.5V3.5C21 3.22 20.78 3 20.5 3H18V4H20V5M17 3H16V7H17V3M13.5 15.5C13.5 16.61 14.4 17.5 15.5 17.5S17.5 16.61 17.5 15.5 16.61 13.5 15.5 13.5 13.5 14.4 13.5 15.5M17 8H16V9H17V8M22 14H21C21 12.5 20.53 11.13 19.74 10H16.97C18.19 10.91 19 12.36 19 14V16H21V17H19V20H5V17H3V16H5V14C5 11.24 7.24 9 10 9H14C14.34 9 14.68 9.04 15 9.1V7.08C14.67 7.03 14.34 7 14 7H13V5.73C13.6 5.39 14 4.74 14 4C14 2.9 13.11 2 12 2S10 2.9 10 4C10 4.74 10.4 5.39 11 5.73V7H10C6.13 7 3 10.13 3 14H2C1.45 14 1 14.45 1 15V18C1 18.55 1.45 19 2 19H3V20C3 21.11 3.9 22 5 22H19C20.11 22 21 21.11 21 20V19H22C22.55 19 23 18.55 23 18V15C23 14.45 22.55 14 22 14M8.5 13.5C7.4 13.5 6.5 14.4 6.5 15.5S7.4 17.5 8.5 17.5 10.5 16.61 10.5 15.5 9.61 13.5 8.5 13.5Z";
var mdiRobotDead = "M22 14H21C21 10.13 17.87 7 14 7H13V5.73C13.6 5.39 14 4.74 14 4C14 2.9 13.11 2 12 2S10 2.9 10 4C10 4.74 10.4 5.39 11 5.73V7H10C6.13 7 3 10.13 3 14H2C1.45 14 1 14.45 1 15V18C1 18.55 1.45 19 2 19H3V20C3 21.11 3.9 22 5 22H19C20.11 22 21 21.11 21 20V19H22C22.55 19 23 18.55 23 18V15C23 14.45 22.55 14 22 14M9.86 16.68L8.68 17.86L7.5 16.68L6.32 17.86L5.14 16.68L6.32 15.5L5.14 14.32L6.32 13.14L7.5 14.32L8.68 13.14L9.86 14.32L8.68 15.5L9.86 16.68M18.86 16.68L17.68 17.86L16.5 16.68L15.32 17.86L14.14 16.68L15.32 15.5L14.14 14.32L15.32 13.14L16.5 14.32L17.68 13.14L18.86 14.32L17.68 15.5L18.86 16.68Z";
var mdiRobotDeadOutline = "M10.62 14.44L9.56 15.5L10.62 16.56L9.56 17.62L8.5 16.56L7.44 17.62L6.38 16.56L7.44 15.5L6.38 14.44L7.44 13.38L8.5 14.44L9.56 13.38L10.62 14.44M16.56 13.38L15.5 14.44L14.44 13.38L13.38 14.44L14.44 15.5L13.38 16.56L14.44 17.62L15.5 16.56L16.56 17.62L17.62 16.56L16.56 15.5L17.62 14.44L16.56 13.38M23 15V18C23 18.55 22.55 19 22 19H21V20C21 21.11 20.11 22 19 22H5C3.9 22 3 21.11 3 20V19H2C1.45 19 1 18.55 1 18V15C1 14.45 1.45 14 2 14H3C3 10.13 6.13 7 10 7H11V5.73C10.4 5.39 10 4.74 10 4C10 2.9 10.9 2 12 2S14 2.9 14 4C14 4.74 13.6 5.39 13 5.73V7H14C17.87 7 21 10.13 21 14H22C22.55 14 23 14.45 23 15M21 16H19V14C19 11.24 16.76 9 14 9H10C7.24 9 5 11.24 5 14V16H3V17H5V20H19V17H21V16Z";
var mdiRobotExcited = "M22 14H21C21 10.13 17.87 7 14 7H13V5.73C13.6 5.39 14 4.74 14 4C14 2.9 13.11 2 12 2S10 2.9 10 4C10 4.74 10.4 5.39 11 5.73V7H10C6.13 7 3 10.13 3 14H2C1.45 14 1 14.45 1 15V18C1 18.55 1.45 19 2 19H3V20C3 21.11 3.9 22 5 22H19C20.11 22 21 21.11 21 20V19H22C22.55 19 23 18.55 23 18V15C23 14.45 22.55 14 22 14M8.68 17.04L7.5 15.86L6.32 17.04L5.14 15.86L7.5 13.5L9.86 15.86L8.68 17.04M17.68 17.04L16.5 15.86L15.32 17.04L14.14 15.86L16.5 13.5L18.86 15.86L17.68 17.04Z";
var mdiRobotExcitedOutline = "M22 14H21C21 10.13 17.87 7 14 7H13V5.73C13.6 5.39 14 4.74 14 4C14 2.9 13.11 2 12 2S10 2.9 10 4C10 4.74 10.4 5.39 11 5.73V7H10C6.13 7 3 10.13 3 14H2C1.45 14 1 14.45 1 15V18C1 18.55 1.45 19 2 19H3V20C3 21.11 3.9 22 5 22H19C20.11 22 21 21.11 21 20V19H22C22.55 19 23 18.55 23 18V15C23 14.45 22.55 14 22 14M21 17H19V20H5V17H3V16H5V14C5 11.24 7.24 9 10 9H14C16.76 9 19 11.24 19 14V16H21V17M8.5 13.5L10.86 15.86L9.68 17.04L8.5 15.86L7.32 17.04L6.14 15.86L8.5 13.5M15.5 13.5L17.86 15.86L16.68 17.04L15.5 15.86L14.32 17.04L13.14 15.86L15.5 13.5Z";
var mdiRobotHappy = "M22 14H21C21 10.13 17.87 7 14 7H13V5.73C13.6 5.39 14 4.74 14 4C14 2.9 13.11 2 12 2S10 2.9 10 4C10 4.74 10.4 5.39 11 5.73V7H10C6.13 7 3 10.13 3 14H2C1.45 14 1 14.45 1 15V18C1 18.55 1.45 19 2 19H3V20C3 21.11 3.9 22 5 22H19C20.11 22 21 21.11 21 20V19H22C22.55 19 23 18.55 23 18V15C23 14.45 22.55 14 22 14M9.79 16.5C9.4 15.62 8.53 15 7.5 15S5.6 15.62 5.21 16.5C5.08 16.19 5 15.86 5 15.5C5 14.12 6.12 13 7.5 13S10 14.12 10 15.5C10 15.86 9.92 16.19 9.79 16.5M18.79 16.5C18.4 15.62 17.5 15 16.5 15S14.6 15.62 14.21 16.5C14.08 16.19 14 15.86 14 15.5C14 14.12 15.12 13 16.5 13S19 14.12 19 15.5C19 15.86 18.92 16.19 18.79 16.5Z";
var mdiRobotHappyOutline = "M10.5 15.5C10.5 15.87 10.4 16.2 10.22 16.5C9.88 15.91 9.24 15.5 8.5 15.5S7.12 15.91 6.78 16.5C6.61 16.2 6.5 15.87 6.5 15.5C6.5 14.4 7.4 13.5 8.5 13.5S10.5 14.4 10.5 15.5M23 15V18C23 18.55 22.55 19 22 19H21V20C21 21.11 20.11 22 19 22H5C3.9 22 3 21.11 3 20V19H2C1.45 19 1 18.55 1 18V15C1 14.45 1.45 14 2 14H3C3 10.13 6.13 7 10 7H11V5.73C10.4 5.39 10 4.74 10 4C10 2.9 10.9 2 12 2S14 2.9 14 4C14 4.74 13.6 5.39 13 5.73V7H14C17.87 7 21 10.13 21 14H22C22.55 14 23 14.45 23 15M21 16H19V14C19 11.24 16.76 9 14 9H10C7.24 9 5 11.24 5 14V16H3V17H5V20H19V17H21V16M15.5 13.5C14.4 13.5 13.5 14.4 13.5 15.5C13.5 15.87 13.61 16.2 13.78 16.5C14.12 15.91 14.76 15.5 15.5 15.5S16.88 15.91 17.22 16.5C17.4 16.2 17.5 15.87 17.5 15.5C17.5 14.4 16.61 13.5 15.5 13.5Z";
var mdiRobotIndustrial = "M18.41,4L16,6.41V6.59L18.41,9H22V11H17.59L16,9.41V12H15A2,2 0 0,1 13,10V7.5H9.86C9.77,7.87 9.62,8.22 9.42,8.55L15.18,19H20A2,2 0 0,1 22,21V22H2V21A2,2 0 0,1 4,19H10.61L5.92,10.5C4.12,10.47 2.56,9.24 2.11,7.5C1.56,5.36 2.85,3.18 5,2.63C7.13,2.08 9.31,3.36 9.86,5.5H13V3A2,2 0 0,1 15,1H16V3.59L17.59,2H22V4H18.41M6,4.5A2,2 0 0,0 4,6.5A2,2 0 0,0 6,8.5A2,2 0 0,0 8,6.5A2,2 0 0,0 6,4.5Z";
var mdiRobotIndustrialOutline = "M4 19H8.6L2.62 8.64C2.23 8 2 7.29 2 6.5C2 4.29 3.79 2.5 6 2.5C7.86 2.5 9.43 3.78 9.87 5.5H14V3C14 1.9 14.9 1 16 1V3.59L17.59 2H22V4H18.41L16 6.41V6.59L18.41 9H22V11H17.59L16 9.41V12C14.9 12 14 11.11 14 10V7.5H9.87C9.77 7.89 9.61 8.26 9.41 8.6L15.41 19H20C21.11 19 22 19.9 22 21V22H2V21C2 19.9 2.9 19 4 19M7.91 10C7.35 10.32 6.7 10.5 6 10.5L10.91 19H13.1L7.91 10M6 4.5C4.89 4.5 4 5.4 4 6.5C4 7.61 4.89 8.5 6 8.5C7.11 8.5 8 7.61 8 6.5C8 5.4 7.11 4.5 6 4.5Z";
var mdiRobotLove = "M22 14H21C21 10.13 17.87 7 14 7H13V5.73C13.6 5.39 14 4.74 14 4C14 2.9 13.11 2 12 2S10 2.9 10 4C10 4.74 10.4 5.39 11 5.73V7H10C6.13 7 3 10.13 3 14H2C1.45 14 1 14.45 1 15V18C1 18.55 1.45 19 2 19H3V20C3 21.11 3.9 22 5 22H19C20.11 22 21 21.11 21 20V19H22C22.55 19 23 18.55 23 18V15C23 14.45 22.55 14 22 14M9.7 15.45L8.97 16.18L7.5 17.65L5.3 15.45C4.9 15.05 4.9 14.39 5.3 14C5.71 13.58 6.36 13.58 6.77 14L7.5 14.72L8.23 14C8.64 13.58 9.29 13.58 9.7 14C10.1 14.39 10.1 15.05 9.7 15.45M18.7 15.45L17.97 16.18L16.5 17.65L14.3 15.45C13.9 15.05 13.9 14.39 14.3 14C14.71 13.58 15.36 13.58 15.77 14L16.5 14.72L17.23 14C17.64 13.58 18.29 13.58 18.7 14C19.1 14.39 19.1 15.05 18.7 15.45Z";
var mdiRobotLoveOutline = "M22 14H21C21 10.13 17.87 7 14 7H13V5.73C13.6 5.39 14 4.74 14 4C14 2.9 13.11 2 12 2S10 2.9 10 4C10 4.74 10.4 5.39 11 5.73V7H10C6.13 7 3 10.13 3 14H2C1.45 14 1 14.45 1 15V18C1 18.55 1.45 19 2 19H3V20C3 21.11 3.9 22 5 22H19C20.11 22 21 21.11 21 20V19H22C22.55 19 23 18.55 23 18V15C23 14.45 22.55 14 22 14M21 17H19V20H5V17H3V16H5V14C5 11.24 7.24 9 10 9H14C16.76 9 19 11.24 19 14V16H21V17M10.7 14C11.1 14.39 11.1 15.05 10.7 15.45L9.97 16.18L8.5 17.65L6.3 15.45C5.9 15.05 5.9 14.39 6.3 14C6.71 13.58 7.36 13.58 7.77 14L8.5 14.72L9.23 14C9.64 13.58 10.29 13.58 10.7 14M17.7 14C18.1 14.39 18.1 15.05 17.7 15.45L16.97 16.18L15.5 17.65L13.3 15.45C12.9 15.05 12.9 14.39 13.3 14C13.71 13.58 14.36 13.58 14.77 14L15.5 14.72L16.23 14C16.64 13.58 17.29 13.58 17.7 14Z";
var mdiRobotMower = "M1 14V5H13C18.5 5 23 9.5 23 15V17H20.83C20.42 18.17 19.31 19 18 19C16.69 19 15.58 18.17 15.17 17H10C9.09 18.21 7.64 19 6 19C3.24 19 1 16.76 1 14M6 11C4.34 11 3 12.34 3 14C3 15.66 4.34 17 6 17C7.66 17 9 15.66 9 14C9 12.34 7.66 11 6 11M15 10V12H20.25C19.92 11.27 19.5 10.6 19 10H15Z";
var mdiRobotMowerOutline = "M1 14C1 16.76 3.24 19 6 19C7.64 19 9.09 18.21 10 17H15.17C15.58 18.17 16.7 19 18 19C19.31 19 20.42 18.17 20.83 17H23V15C23 9.5 18.5 5 13 5H1V14M21 15H10.9C10.97 14.68 11 14.34 11 14C11 11.24 8.76 9 6 9C4.87 9 3.84 9.37 3 10V7H12.5C15.1 7 17.42 8.16 19 10H15V12H20.25C20.67 12.92 20.92 13.94 21 15M6 11C7.66 11 9 12.34 9 14C9 15.66 7.66 17 6 17C4.34 17 3 15.66 3 14C3 12.34 4.34 11 6 11Z";
var mdiRobotOff = "M23 15V18C23 18.5 22.64 18.88 22.17 18.97L18.97 15.77C19 15.68 19 15.59 19 15.5C19 14.12 17.88 13 16.5 13C16.41 13 16.32 13 16.23 13.03L10.2 7H11V5.73C10.4 5.39 10 4.74 10 4C10 2.9 10.9 2 12 2S14 2.9 14 4C14 4.74 13.6 5.39 13 5.73V7H14C17.87 7 21 10.13 21 14H22C22.55 14 23 14.45 23 15M22.11 21.46L20.84 22.73L19.89 21.78C19.62 21.92 19.32 22 19 22H5C3.9 22 3 21.11 3 20V19H2C1.45 19 1 18.55 1 18V15C1 14.45 1.45 14 2 14H3C3 11.53 4.29 9.36 6.22 8.11L1.11 3L2.39 1.73L22.11 21.46M10 15.5C10 14.12 8.88 13 7.5 13S5 14.12 5 15.5 6.12 18 7.5 18 10 16.88 10 15.5M16.07 17.96L14.04 15.93C14.23 16.97 15.04 17.77 16.07 17.96Z";
var mdiRobotOffOutline = "M23 15V18C23 18.5 22.64 18.88 22.17 18.97L20.2 17H21V16H19.2L19 15.8V14C19 11.24 16.76 9 14 9H12.2L10.2 7H11V5.73C10.4 5.39 10 4.74 10 4C10 2.9 10.9 2 12 2S14 2.9 14 4C14 4.74 13.6 5.39 13 5.73V7H14C17.87 7 21 10.13 21 14H22C22.55 14 23 14.45 23 15M8.5 13.5C7.4 13.5 6.5 14.4 6.5 15.5S7.4 17.5 8.5 17.5 10.5 16.61 10.5 15.5 9.61 13.5 8.5 13.5M22.11 21.46L20.84 22.73L19.89 21.78C19.62 21.92 19.32 22 19 22H5C3.9 22 3 21.11 3 20V19H2C1.45 19 1 18.55 1 18V15C1 14.45 1.45 14 2 14H3C3 11.53 4.29 9.36 6.22 8.11L1.11 3L2.39 1.73L22.11 21.46M18.11 20L15.6 17.5C15.57 17.5 15.53 17.5 15.5 17.5C14.4 17.5 13.5 16.61 13.5 15.5C13.5 15.47 13.5 15.43 13.5 15.4L7.7 9.59C6.1 10.42 5 12.08 5 14V16H3V17H5V20H18.11Z";
var mdiRobotOutline = "M17.5 15.5C17.5 16.61 16.61 17.5 15.5 17.5S13.5 16.61 13.5 15.5 14.4 13.5 15.5 13.5 17.5 14.4 17.5 15.5M8.5 13.5C7.4 13.5 6.5 14.4 6.5 15.5S7.4 17.5 8.5 17.5 10.5 16.61 10.5 15.5 9.61 13.5 8.5 13.5M23 15V18C23 18.55 22.55 19 22 19H21V20C21 21.11 20.11 22 19 22H5C3.9 22 3 21.11 3 20V19H2C1.45 19 1 18.55 1 18V15C1 14.45 1.45 14 2 14H3C3 10.13 6.13 7 10 7H11V5.73C10.4 5.39 10 4.74 10 4C10 2.9 10.9 2 12 2S14 2.9 14 4C14 4.74 13.6 5.39 13 5.73V7H14C17.87 7 21 10.13 21 14H22C22.55 14 23 14.45 23 15M21 16H19V14C19 11.24 16.76 9 14 9H10C7.24 9 5 11.24 5 14V16H3V17H5V20H19V17H21V16Z";
var mdiRobotVacuum = "M12,2C14.65,2 17.19,3.06 19.07,4.93L17.65,6.35C16.15,4.85 14.12,4 12,4C9.88,4 7.84,4.84 6.35,6.35L4.93,4.93C6.81,3.06 9.35,2 12,2M3.66,6.5L5.11,7.94C4.39,9.17 4,10.57 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12C20,10.57 19.61,9.17 18.88,7.94L20.34,6.5C21.42,8.12 22,10.04 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12C2,10.04 2.58,8.12 3.66,6.5M12,6A6,6 0 0,1 18,12C18,13.59 17.37,15.12 16.24,16.24L14.83,14.83C14.08,15.58 13.06,16 12,16C10.94,16 9.92,15.58 9.17,14.83L7.76,16.24C6.63,15.12 6,13.59 6,12A6,6 0 0,1 12,6M12,8A1,1 0 0,0 11,9A1,1 0 0,0 12,10A1,1 0 0,0 13,9A1,1 0 0,0 12,8Z";
var mdiRobotVacuumAlert = "M10 2C12.6 2 15.2 3.1 17.1 4.9L15.7 6.3C14.1 4.8 12.1 4 10 4S5.8 4.8 4.3 6.3L2.9 4.9C4.8 3.1 7.4 2 10 2M1.7 6.5L3.2 7.9C2.4 9.2 2 10.6 2 12C2 16.4 5.6 20 10 20S18 16.4 18 12C18 10.6 17.6 9.2 16.9 7.9L18.4 6.5C19.4 8.1 20 10 20 12C20 17.5 15.5 22 10 22S0 17.5 0 12C0 10 .6 8.1 1.7 6.5M10 6C13.3 6 16 8.7 16 12C16 13.6 15.4 15.1 14.2 16.2L12.8 14.8C12.1 15.6 11.1 16 10 16S7.9 15.6 7.2 14.8L5.8 16.2C4.6 15.1 4 13.6 4 12C4 8.7 6.7 6 10 6M10 8C9.4 8 9 8.4 9 9S9.4 10 10 10 11 9.6 11 9 10.6 8 10 8M22 12V7H24V13H22M22 17V15H24V17H22Z";
var mdiRobotVacuumOff = "M20.8 22.7L18 19.9C16.3 21.2 14.2 22 12 22C6.5 22 2 17.5 2 12C2 10 2.6 8.1 3.7 6.5L5.2 7.9C4.4 9.2 4 10.6 4 12C4 16.4 7.6 20 12 20C13.7 20 15.3 19.4 16.6 18.5L13.7 15.6C13.2 15.9 12.6 16 12 16C10.9 16 9.9 15.6 9.2 14.8L7.8 16.2C6.6 15.1 6 13.6 6 12C6 10.8 6.3 9.7 6.9 8.8L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M20 12C20 13.4 19.6 14.7 19 15.8L20.5 17.3C21.5 15.8 22 14 22 12C22 10 21.4 8.1 20.3 6.5L18.8 7.9C19.6 9.2 20 10.6 20 12M12 4C14.1 4 16.2 4.8 17.7 6.3L19.1 4.9C17.2 3.1 14.7 2 12 2C10.1 2 8.3 2.5 6.7 3.5L8.2 5C9.3 4.3 10.7 4 12 4M17.5 14.3C17.8 13.6 18 12.8 18 12C18 8.7 15.3 6 12 6C11.2 6 10.4 6.2 9.7 6.5L11.4 8.2C11.6 8.1 11.8 8 12 8C12.6 8 13 8.4 13 9C13 9.2 12.9 9.4 12.8 9.6L17.5 14.3Z";
var mdiRobotVacuumVariant = "M5,3A2,2 0 0,0 3,5V7H5V5H19V7H21V5A2,2 0 0,0 19,3H5M8,7V9H16V7H8M3,9V12A9,9 0 0,0 12,21A9,9 0 0,0 21,12V9H19V12A7,7 0 0,1 12,19A7,7 0 0,1 5,12V9H3M12,12A2.5,2.5 0 0,0 9.5,14.5A2.5,2.5 0 0,0 12,17A2.5,2.5 0 0,0 14.5,14.5A2.5,2.5 0 0,0 12,12Z";
var mdiRobotVacuumVariantAlert = "M3 3C1.9 3 1 3.9 1 5V7H3V5H17V7H19V5C19 3.9 18.1 3 17 3H3M6 7V9H14V7H6M1 9V12C1 17 5 21 10 21S19 17 19 12V9H17V12C17 15.9 13.9 19 10 19S3 15.9 3 12V9H1M10 12C8.6 12 7.5 13.1 7.5 14.5S8.6 17 10 17 12.5 15.9 12.5 14.5 11.4 12 10 12M21 12V7H23V13H21M21 17V15H23V17H21Z";
var mdiRobotVacuumVariantOff = "M20.8 22.7L17.3 19.2C15.8 20.3 14 21 12 21C7 21 3 17 3 12V9H5V12C5 15.9 8.1 19 12 19C13.4 19 14.8 18.5 15.9 17.8L14 15.9C13.5 16.5 12.8 17 12 17C10.6 17 9.5 15.9 9.5 14.5C9.5 13.7 9.9 12.9 10.6 12.5L5 6.9V7H3V4.9L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M19 5V7H21V5C21 3.9 20.1 3 19 3H6.2L8.2 5H19M19 12C19 13.1 18.7 14.1 18.3 15.1L19.8 16.6C20.6 15.3 21 13.7 21 12V9H19V12M16 9V7H10.2L12.2 9H16Z";
var mdiRocket = "M20 22L16.14 20.45C16.84 18.92 17.34 17.34 17.65 15.73L20 22M7.86 20.45L4 22L6.35 15.73C6.66 17.34 7.16 18.92 7.86 20.45M12 2C12 2 17 4 17 12C17 15.1 16.25 17.75 15.33 19.83C15 20.55 14.29 21 13.5 21H10.5C9.71 21 9 20.55 8.67 19.83C7.76 17.75 7 15.1 7 12C7 4 12 2 12 2M12 12C13.1 12 14 11.1 14 10C14 8.9 13.1 8 12 8C10.9 8 10 8.9 10 10C10 11.1 10.9 12 12 12Z";
var mdiRocketLaunch = "M13.13 22.19L11.5 18.36C13.07 17.78 14.54 17 15.9 16.09L13.13 22.19M5.64 12.5L1.81 10.87L7.91 8.1C7 9.46 6.22 10.93 5.64 12.5M21.61 2.39C21.61 2.39 16.66 .269 11 5.93C8.81 8.12 7.5 10.53 6.65 12.64C6.37 13.39 6.56 14.21 7.11 14.77L9.24 16.89C9.79 17.45 10.61 17.63 11.36 17.35C13.5 16.53 15.88 15.19 18.07 13C23.73 7.34 21.61 2.39 21.61 2.39M14.54 9.46C13.76 8.68 13.76 7.41 14.54 6.63S16.59 5.85 17.37 6.63C18.14 7.41 18.15 8.68 17.37 9.46C16.59 10.24 15.32 10.24 14.54 9.46M8.88 16.53L7.47 15.12L8.88 16.53M6.24 22L9.88 18.36C9.54 18.27 9.21 18.12 8.91 17.91L4.83 22H6.24M2 22H3.41L8.18 17.24L6.76 15.83L2 20.59V22M2 19.17L6.09 15.09C5.88 14.79 5.73 14.47 5.64 14.12L2 17.76V19.17Z";
var mdiRocketLaunchOutline = "M13.13 22.19L11.5 18.36C13.07 17.78 14.54 17 15.9 16.09L13.13 22.19M5.64 12.5L1.81 10.87L7.91 8.1C7 9.46 6.22 10.93 5.64 12.5M19.22 4C19.5 4 19.75 4 19.96 4.05C20.13 5.44 19.94 8.3 16.66 11.58C14.96 13.29 12.93 14.6 10.65 15.47L8.5 13.37C9.42 11.06 10.73 9.03 12.42 7.34C15.18 4.58 17.64 4 19.22 4M19.22 2C17.24 2 14.24 2.69 11 5.93C8.81 8.12 7.5 10.53 6.65 12.64C6.37 13.39 6.56 14.21 7.11 14.77L9.24 16.89C9.62 17.27 10.13 17.5 10.66 17.5C10.89 17.5 11.13 17.44 11.36 17.35C13.5 16.53 15.88 15.19 18.07 13C23.73 7.34 21.61 2.39 21.61 2.39S20.7 2 19.22 2M14.54 9.46C13.76 8.68 13.76 7.41 14.54 6.63S16.59 5.85 17.37 6.63C18.14 7.41 18.15 8.68 17.37 9.46C16.59 10.24 15.32 10.24 14.54 9.46M8.88 16.53L7.47 15.12L8.88 16.53M6.24 22L9.88 18.36C9.54 18.27 9.21 18.12 8.91 17.91L4.83 22H6.24M2 22H3.41L8.18 17.24L6.76 15.83L2 20.59V22M2 19.17L6.09 15.09C5.88 14.79 5.73 14.47 5.64 14.12L2 17.76V19.17Z";
var mdiRocketOutline = "M12 2C12 2 7 4 7 12C7 15.1 7.76 17.75 8.67 19.83C9 20.55 9.71 21 10.5 21H13.5C14.29 21 15 20.55 15.33 19.83C16.25 17.75 17 15.1 17 12C17 4 12 2 12 2M13.5 19H10.5C9.5 16.76 9 14.41 9 12C9 7.36 10.9 5.2 12 4.33C13.1 5.2 15 7.36 15 12C15 14.41 14.5 16.76 13.5 19M20 22L16.14 20.45C16.84 18.92 17.34 17.34 17.65 15.73M7.86 20.45L4 22L6.35 15.73C6.66 17.34 7.16 18.92 7.86 20.45M12 12C10.9 12 10 11.1 10 10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12Z";
var mdiRodent = "M21.33 17.39C22.73 18.66 21.8 21 19.92 21H11.06C8.25 21 6 18.75 6 15.94V15.89C3.7 15.42 2 13.41 2 11C2 8.25 4.22 6 7 6H9.5C9.8 6 10 5.77 10 5.5S9.8 5 9.5 5H7V3H9.5C10.88 3 12 4.13 12 5.5C12 6.89 10.88 8 9.5 8H7C5.34 8 4 9.33 4 11C4 12.37 4.92 13.5 6.14 13.87C6.7 11.67 8.67 10 11.06 10C11.86 10 12.66 10.22 13.36 10.55C11.95 11.34 11 12.8 11 14.5C11 15.75 11.5 16.87 12.33 17.67L13.03 16.97C12.38 16.36 12 15.47 12 14.5C12 11.91 14.34 11 15.5 11C17.58 11 19.45 12.89 18.94 15.23L21.33 17.39M18 19C18.56 19 19 18.56 19 18S18.56 17 18 17 17 17.44 17 18 17.44 19 18 19Z";
var mdiRollerShade = "M20 19V3H4V19H2V21H22V19H20M6 19V13H11V14.8C10.6 15.1 10.2 15.6 10.2 16.2C10.2 17.2 11 18 12 18S13.8 17.2 13.8 16.2C13.8 15.6 13.5 15.1 13 14.8V13H18V19H6Z";
var mdiRollerShadeClosed = "M20 19V3H4V19H2V21H10.25C10.25 21.97 11.03 22.75 12 22.75S13.75 21.97 13.75 21H22V19H20M6 19V17H11V19H6M13 19V17H18V19H13Z";
var mdiRollerSkate = "M6.5 18C5.1 18 4 19.12 4 20.5S5.1 23 6.5 23 9 21.88 9 20.5 7.86 18 6.5 18M16.5 18C15.1 18 14 19.12 14 20.5S15.1 23 16.5 23 19 21.88 19 20.5 17.86 18 16.5 18M20 17C20 15.63 20.09 13.81 19.5 12.95C18.55 10.9 15.82 10.56 13.91 10.05C13 10 12 9 11.82 8H9C8.71 8 8.5 7.78 8.5 7.5C8.5 7.22 8.71 7 9 7H11.5V6H9C8.71 6 8.5 5.78 8.5 5.5C8.5 5.22 8.71 5 9 5H11.5V2H3V17H20Z";
var mdiRollerSkateOff = "M20.84 22.73L18.95 20.84C18.78 22.06 17.75 23 16.5 23C15.1 23 14 21.88 14 20.5C14 19.24 14.93 18.2 16.14 18.03L15.11 17H3V4.9L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M9 5H11.5V2H5.2L8.5 5.32C8.59 5.13 8.77 5 9 5M12.56 9.36C12.18 9 11.9 8.5 11.82 8H11.2L12.56 9.36M19.5 12.95C18.55 10.9 15.82 10.56 13.91 10.05C13.45 10.03 13 9.77 12.6 9.4L20 16.79C20 15.45 20.06 13.76 19.5 12.95M9.2 6L10.2 7H11.5V6H9.2M6.5 18C5.1 18 4 19.12 4 20.5C4 21.88 5.1 23 6.5 23S9 21.88 9 20.5C9 19.12 7.86 18 6.5 18Z";
var mdiRollerblade = "M4.5 18C3.12 18 2 19.12 2 20.5S3.12 23 4.5 23 7 21.88 7 20.5 5.88 18 4.5 18M18.5 18C17.12 18 16 19.12 16 20.5S17.12 23 18.5 23 21 21.88 21 20.5 19.88 18 18.5 18M20 17C20 15.63 20.09 13.81 19.5 12.95C18.55 10.9 15.82 10.56 13.91 10.05C13 10 12 9 11.82 8H9C8.71 8 8.5 7.78 8.5 7.5C8.5 7.22 8.71 7 9 7H11.5V6H9C8.71 6 8.5 5.78 8.5 5.5C8.5 5.22 8.71 5 9 5H11.5V2H3V17H20M11.5 18C10.12 18 9 19.12 9 20.5S10.12 23 11.5 23 14 21.88 14 20.5 12.88 18 11.5 18Z";
var mdiRollerbladeOff = "M20.84 22.73L20.32 22.21C19.86 22.69 19.22 23 18.5 23C17.12 23 16 21.88 16 20.5C16 19.78 16.31 19.14 16.79 18.68L15.11 17H3V4.9L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M19.5 12.95C18.55 10.9 15.82 10.56 13.91 10.05C13.45 10.03 13 9.77 12.6 9.4L20 16.79C20 15.45 20.06 13.76 19.5 12.95M9.2 6L10.2 7H11.5V6H9.2M12.56 9.36C12.18 9 11.9 8.5 11.82 8H11.2L12.56 9.36M11.5 18C10.12 18 9 19.12 9 20.5C9 21.88 10.12 23 11.5 23S14 21.88 14 20.5C14 19.12 12.88 18 11.5 18M9 5H11.5V2H5.2L8.5 5.32C8.59 5.13 8.77 5 9 5M4.5 18C3.12 18 2 19.12 2 20.5C2 21.88 3.12 23 4.5 23S7 21.88 7 20.5C7 19.12 5.88 18 4.5 18Z";
var mdiRollupjs = "M19.46,8.64C19.46,11.11 18.11,13.26 16.12,14.4C16,14.5 15.93,14.66 16,14.81L19.41,21.55C19.5,21.76 19.36,22 19.13,22H6.1L6.17,21.96C6.66,21.68 10.06,14.97 13.38,11.79C16.7,8.61 17.12,9.67 15.29,6.21C15.29,6.21 16.7,8.96 15.5,9.17C14.56,9.34 12.4,7.25 13.2,5.37C14,3.53 17.15,3.88 18.6,5.38C19.15,6.34 19.46,7.45 19.46,8.64M7.16,13.13C5.84,15.56 5,17.33 4.54,18.57V2.31C4.54,2.14 4.68,2 4.85,2H12.92C15.26,2.04 17.31,3.28 18.46,5.15C17.62,4.1 16.3,3.5 15,3.5C12.53,3.5 11.91,4.4 7.16,13.13Z";
var mdiRolodex = "M19.89 5H18.5V7C18.5 8.38 17.38 9.5 16 9.5S13.5 8.38 13.5 7V5.25C13.5 5.11 13.39 5 13.25 5H10.75C10.61 5 10.5 5.11 10.5 5.25V7C10.5 8.38 9.38 9.5 8 9.5S5.5 8.38 5.5 7V5H4.11C3 4.97 2.03 5.87 2 7V19C2.03 20.13 3 21.03 4.11 21H19.89C21 21.03 21.97 20.13 22 19V7C21.97 5.87 21 4.97 19.89 5M7 18H5V16H7V18M7 14H5V12H7V14M11 18H9V16H11V18M11 14H9V12H11V14M15 18H13V16H15V18M15 14H13V12H15V14M19 18H17V16H19V18M19 14H17V12H19V14M16 8C15.45 8 15 7.55 15 7V4C15 3.45 15.45 3 16 3C16.55 3 17 3.45 17 4V7C17 7.55 16.55 8 16 8M8 8C7.45 8 7 7.55 7 7V4C7 3.45 7.45 3 8 3C8.55 3 9 3.45 9 4V7C9 7.55 8.55 8 8 8Z";
var mdiRolodexOutline = "M7 18H5V16H7V18M7 14H5V12H7V14M11 18H9V16H11V18M11 14H9V12H11V14M15 18H13V16H15V18M15 14H13V12H15V14M19 18H17V16H19V18M19 14H17V12H19V14M16 8C15.45 8 15 7.55 15 7V4C15 3.45 15.45 3 16 3C16.55 3 17 3.45 17 4V7C17 7.55 16.55 8 16 8M8 8C7.45 8 7 7.55 7 7V4C7 3.45 7.45 3 8 3C8.55 3 9 3.45 9 4V7C9 7.55 8.55 8 8 8M19.89 5H18.5V7C18.5 8.38 17.38 9.5 16 9.5S13.5 8.38 13.5 7V5.25C13.5 5.11 13.39 5 13.25 5H10.75C10.61 5 10.5 5.11 10.5 5.25V7C10.5 8.38 9.38 9.5 8 9.5S5.5 8.38 5.5 7V5H4.11C3 4.97 2.03 5.87 2 7V19C2.03 20.13 3 21.03 4.11 21H19.89C21 21.03 21.97 20.13 22 19V7C21.97 5.87 21 4.97 19.89 5M20 19H4V11H20V19Z";
var mdiRomanNumeral1 = "M14 7V9H13V15H14V17H10V15H11V9H10V7H14Z";
var mdiRomanNumeral10 = "M9 7L11 12L9 17H11L12 14.5L13 17H15L13 12L15 7H13L12 9.5L11 7H9Z";
var mdiRomanNumeral2 = "M11 7V9H10V15H11V17H7V15H8V9H7V7H11M17 7V9H16V15H17V17H13V15H14V9H13V7H17Z";
var mdiRomanNumeral3 = "M9 7V9H8V15H9V17H5V15H6V9H5V7H9M14 7V9H13V15H14V17H10V15H11V9H10V7H14M19 7V9H18V15H19V17H15V15H16V9H15V7H19Z";
var mdiRomanNumeral4 = "M12 7L14 17H16L18 7H16L15 12L14 7H12M11 7V9H10V15H11V17H7V15H8V9H7V7H11Z";
var mdiRomanNumeral5 = "M9 7L11 17H13L15 7H13L12 12L11 7H9Z";
var mdiRomanNumeral6 = "M6 7L8 17H10L12 7H10L9 12L8 7H6M17 7V9H16V15H17V17H13V15H14V9H13V7H17Z";
var mdiRomanNumeral7 = "M4 7L6 17H8L10 7H8L7 12L6 7H4M15 7V9H14V15H15V17H11V15H12V9H11V7H15M20 7V9H19V15H20V17H16V15H17V9H16V7H20Z";
var mdiRomanNumeral8 = "M1 7L3 17H5L7 7H5L4 12L3 7H1M12 7V9H11V15H12V17H8V15H9V9H8V7H12M17 7V9H16V15H17V17H13V15H14V9H13V7H17M22 7V9H21V15H22V17H18V15H19V9H18V7H22Z";
var mdiRomanNumeral9 = "M11 7V9H10V15H11V17H7V15H8V9H7V7H11M12 7L14 12L12 17H14L15 14.5L16 17H18L16 12L18 7H16L15 9.5L14 7H12Z";
var mdiRoomService = "M12,5A2,2 0 0,1 14,7C14,7.24 13.96,7.47 13.88,7.69C17.95,8.5 21,11.91 21,16H3C3,11.91 6.05,8.5 10.12,7.69C10.04,7.47 10,7.24 10,7A2,2 0 0,1 12,5M22,19H2V17H22V19Z";
var mdiRoomServiceOutline = "M12,5A2,2 0 0,1 14,7C14,7.24 13.96,7.47 13.88,7.69C17.95,8.5 21,11.91 21,16H3C3,11.91 6.05,8.5 10.12,7.69C10.04,7.47 10,7.24 10,7A2,2 0 0,1 12,5M22,19H2V17H22V19M12,9.5C8.89,9.5 6.25,11.39 5.34,14H18.66C17.75,11.39 15.11,9.5 12,9.5Z";
var mdiRotate360 = "M12 7C6.5 7 2 9.2 2 12C2 14.2 4.9 16.1 9 16.8V20L13 16L9 12V14.7C5.8 14.1 4 12.8 4 12C4 10.9 7 9 12 9S20 10.9 20 12C20 12.7 18.5 13.9 16 14.5V16.6C19.5 15.8 22 14.1 22 12C22 9.2 17.5 7 12 7Z";
var mdiRotate3d = "M7.47,21.5C4.2,19.94 1.86,16.76 1.5,13H0C0.5,19.16 5.66,24 11.95,24L12.61,23.97L8.8,20.16L7.47,21.5M8.36,14.96C8.17,14.96 8,14.93 7.84,14.88C7.68,14.82 7.55,14.75 7.44,14.64C7.33,14.54 7.24,14.42 7.18,14.27C7.12,14.13 7.09,13.97 7.09,13.8H5.79C5.79,14.16 5.86,14.5 6,14.75C6.14,15 6.33,15.25 6.56,15.44C6.8,15.62 7.07,15.76 7.38,15.85C7.68,15.95 8,16 8.34,16C8.71,16 9.06,15.95 9.37,15.85C9.69,15.75 9.97,15.6 10.2,15.41C10.43,15.22 10.62,15 10.75,14.69C10.88,14.4 10.95,14.08 10.95,13.72C10.95,13.53 10.93,13.34 10.88,13.16C10.83,13 10.76,12.81 10.65,12.65C10.55,12.5 10.41,12.35 10.25,12.22C10.08,12.09 9.88,12 9.64,11.91C9.84,11.82 10,11.71 10.16,11.58C10.31,11.45 10.43,11.31 10.53,11.16C10.63,11 10.7,10.86 10.75,10.7C10.8,10.54 10.82,10.38 10.82,10.22C10.82,9.86 10.76,9.54 10.64,9.26C10.5,9 10.35,8.75 10.13,8.57C9.93,8.38 9.66,8.24 9.36,8.14C9.05,8.05 8.71,8 8.34,8C8,8 7.65,8.05 7.34,8.16C7.04,8.27 6.77,8.42 6.55,8.61C6.34,8.8 6.17,9 6.04,9.28C5.92,9.54 5.86,9.82 5.86,10.13H7.16C7.16,9.96 7.19,9.81 7.25,9.68C7.31,9.55 7.39,9.43 7.5,9.34C7.61,9.25 7.73,9.17 7.88,9.12C8.03,9.07 8.18,9.04 8.36,9.04C8.76,9.04 9.06,9.14 9.25,9.35C9.44,9.55 9.54,9.84 9.54,10.21C9.54,10.39 9.5,10.55 9.46,10.7C9.41,10.85 9.32,10.97 9.21,11.07C9.1,11.17 8.96,11.25 8.8,11.31C8.64,11.37 8.44,11.4 8.22,11.4H7.45V12.43H8.22C8.44,12.43 8.64,12.45 8.82,12.5C9,12.55 9.15,12.63 9.27,12.73C9.39,12.84 9.5,12.97 9.56,13.13C9.63,13.29 9.66,13.5 9.66,13.7C9.66,14.11 9.54,14.42 9.31,14.63C9.08,14.86 8.76,14.96 8.36,14.96M16.91,9.04C16.59,8.71 16.21,8.45 15.77,8.27C15.34,8.09 14.85,8 14.31,8H11.95V16H14.25C14.8,16 15.31,15.91 15.76,15.73C16.21,15.55 16.6,15.3 16.92,14.97C17.24,14.64 17.5,14.24 17.66,13.78C17.83,13.31 17.92,12.79 17.92,12.21V11.81C17.92,11.23 17.83,10.71 17.66,10.24C17.5,9.77 17.23,9.37 16.91,9.04M16.5,12.2C16.5,12.62 16.47,13 16.38,13.33C16.28,13.66 16.14,13.95 15.95,14.18C15.76,14.41 15.5,14.59 15.24,14.71C14.95,14.83 14.62,14.89 14.25,14.89H13.34V9.12H14.31C15.03,9.12 15.58,9.35 15.95,9.81C16.33,10.27 16.5,10.93 16.5,11.8M11.95,0L11.29,0.03L15.1,3.84L16.43,2.5C19.7,4.06 22.04,7.23 22.39,11H23.89C23.39,4.84 18.24,0 11.95,0Z";
var mdiRotate3dVariant = "M12,5C16.97,5 21,7.69 21,11C21,12.68 19.96,14.2 18.29,15.29C19.36,14.42 20,13.32 20,12.13C20,9.29 16.42,7 12,7V10L8,6L12,2V5M12,19C7.03,19 3,16.31 3,13C3,11.32 4.04,9.8 5.71,8.71C4.64,9.58 4,10.68 4,11.88C4,14.71 7.58,17 12,17V14L16,18L12,22V19Z";
var mdiRotateLeft = "M13,4.07V1L8.45,5.55L13,10V6.09C15.84,6.57 18,9.03 18,12C18,14.97 15.84,17.43 13,17.91V19.93C16.95,19.44 20,16.08 20,12C20,7.92 16.95,4.56 13,4.07M7.1,18.32C8.26,19.22 9.61,19.76 11,19.93V17.9C10.13,17.75 9.29,17.41 8.54,16.87L7.1,18.32M6.09,13H4.07C4.24,14.39 4.79,15.73 5.69,16.89L7.1,15.47C6.58,14.72 6.23,13.88 6.09,13M7.11,8.53L5.7,7.11C4.8,8.27 4.24,9.61 4.07,11H6.09C6.23,10.13 6.58,9.28 7.11,8.53Z";
var mdiRotateLeftVariant = "M4,2H7A2,2 0 0,1 9,4V20A2,2 0 0,1 7,22H4A2,2 0 0,1 2,20V4A2,2 0 0,1 4,2M20,15A2,2 0 0,1 22,17V20A2,2 0 0,1 20,22H11V15H20M14,4A8,8 0 0,1 22,12L21.94,13H19.92L20,12A6,6 0 0,0 14,6V9L10,5L14,1V4Z";
var mdiRotateOrbit = "M8,14.25L4.75,11H7C7.25,5.39 9.39,1 12,1C14,1 15.77,3.64 16.55,7.45C20.36,8.23 23,10 23,12C23,13.83 20.83,15.43 17.6,16.3L17.89,14.27C19.8,13.72 21,12.91 21,12C21,10.94 19.35,10 16.87,9.5C16.95,10.29 17,11.13 17,12C17,18.08 14.76,23 12,23C10.17,23 8.57,20.83 7.7,17.6L9.73,17.89C10.28,19.8 11.09,21 12,21C13.66,21 15,16.97 15,12C15,11 14.95,10.05 14.85,9.15C13.95,9.05 13,9 12,9L10.14,9.06L10.43,7.05L12,7C12.87,7 13.71,7.05 14.5,7.13C14,4.65 13.06,3 12,3C10.46,3 9.18,6.5 9,11H11.25L8,14.25M14.25,16L11,19.25V17C5.39,16.75 1,14.61 1,12C1,10.17 3.17,8.57 6.4,7.7L6.11,9.73C4.2,10.28 3,11.09 3,12C3,13.54 6.5,14.82 11,15V12.75L14.25,16Z";
var mdiRotateRight = "M16.89,15.5L18.31,16.89C19.21,15.73 19.76,14.39 19.93,13H17.91C17.77,13.87 17.43,14.72 16.89,15.5M13,17.9V19.92C14.39,19.75 15.74,19.21 16.9,18.31L15.46,16.87C14.71,17.41 13.87,17.76 13,17.9M19.93,11C19.76,9.61 19.21,8.27 18.31,7.11L16.89,8.53C17.43,9.28 17.77,10.13 17.91,11M15.55,5.55L11,1V4.07C7.06,4.56 4,7.92 4,12C4,16.08 7.05,19.44 11,19.93V17.91C8.16,17.43 6,14.97 6,12C6,9.03 8.16,6.57 11,6.09V10L15.55,5.55Z";
var mdiRotateRightVariant = "M10,4V1L14,5L10,9V6A6,6 0 0,0 4,12L4.08,13H2.06L2,12A8,8 0 0,1 10,4M17,2H20A2,2 0 0,1 22,4V20A2,2 0 0,1 20,22H17A2,2 0 0,1 15,20V4A2,2 0 0,1 17,2M4,15H13V22H4A2,2 0 0,1 2,20V17A2,2 0 0,1 4,15Z";
var mdiRoundedCorner = "M19,19H21V21H19V19M19,17H21V15H19V17M3,13H5V11H3V13M3,17H5V15H3V17M3,9H5V7H3V9M3,5H5V3H3V5M7,5H9V3H7V5M15,21H17V19H15V21M11,21H13V19H11V21M15,21H17V19H15V21M7,21H9V19H7V21M3,21H5V19H3V21M21,8A5,5 0 0,0 16,3H11V5H16A3,3 0 0,1 19,8V13H21V8Z";
var mdiRouter = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2M12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20M13 13V16H15L12 19L9 16H11V13M5 13H8V15L11 12L8 9V11H5M11 11V8H9L12 5L15 8H13V11M19 11H16V9L13 12L16 15V13H19";
var mdiRouterNetwork = "M5 9C3.9 9 3 9.9 3 11V15C3 16.11 3.9 17 5 17H11V19H10C9.45 19 9 19.45 9 20H2V22H9C9 22.55 9.45 23 10 23H14C14.55 23 15 22.55 15 22H22V20H15C15 19.45 14.55 19 14 19H13V17H19C20.11 17 21 16.11 21 15V11C21 9.9 20.11 9 19 9H5M6 12H8V14H6V12M9.5 12H11.5V14H9.5V12M13 12H15V14H13V12Z";
var mdiRouterNetworkWireless = "M21 3.1L20.2 3.9C19 2.8 17.5 2.2 16 2.2C14.5 2.2 13 2.8 11.8 3.9L11 3.1C12.4 1.7 14.2 1 16 1C17.8 1 19.6 1.7 21 3.1M16 3.3C17.2 3.3 18.4 3.8 19.3 4.7L18.5 5.5C17.8 4.8 16.9 4.5 16 4.5C15.1 4.5 14.2 4.8 13.5 5.5L12.7 4.7C13.6 3.8 14.8 3.3 16 3.3M17 10H19C19.53 10 20.04 10.21 20.41 10.59C20.79 10.96 21 11.47 21 12V14C21 14.53 20.79 15.04 20.41 15.41C20.04 15.79 19.53 16 19 16H13V18H14C14.55 18 15 18.45 15 19H22V21H15C15 21.55 14.55 22 14 22H10C9.45 22 9 21.55 9 21H2V19H9C9 18.45 9.45 18 10 18H11V16H5C4.47 16 3.96 15.79 3.59 15.41C3.21 15.04 3 14.53 3 14V12C3 11.47 3.21 10.96 3.59 10.59C3.96 10.21 4.47 10 5 10H15V6H17V10M5 14H7V12H5V14M8.5 14H10.5V12H8.5V14M12 14H14V12H12V14Z";
var mdiRouterWireless = "M20.2,5.9L21,5.1C19.6,3.7 17.8,3 16,3C14.2,3 12.4,3.7 11,5.1L11.8,5.9C13,4.8 14.5,4.2 16,4.2C17.5,4.2 19,4.8 20.2,5.9M19.3,6.7C18.4,5.8 17.2,5.3 16,5.3C14.8,5.3 13.6,5.8 12.7,6.7L13.5,7.5C14.2,6.8 15.1,6.5 16,6.5C16.9,6.5 17.8,6.8 18.5,7.5L19.3,6.7M19,13H17V9H15V13H5A2,2 0 0,0 3,15V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V15A2,2 0 0,0 19,13M8,18H6V16H8V18M11.5,18H9.5V16H11.5V18M15,18H13V16H15V18Z";
var mdiRouterWirelessOff = "M11.8 5.9L11 5.1C12.4 3.7 14.2 3 16 3S19.6 3.7 21 5.1L20.2 5.9C19 4.8 17.5 4.2 16 4.2S13 4.8 11.8 5.9M21 15C21 13.9 20.1 13 19 13H17V9H15V11.8L21 17.8V15M18.5 7.5L19.3 6.7C18.4 5.8 17.2 5.3 16 5.3S13.6 5.8 12.7 6.7L13.5 7.5C14.2 6.8 15.1 6.5 16 6.5C16.9 6.5 17.8 6.8 18.5 7.5M22.1 21.5L20.8 22.8L19.1 21H5C3.9 21 3 20.1 3 19V15C3 13.9 3.9 13 5 13H11.1L1.1 3L2.4 1.7L22.1 21.5M8 16H6V18H8V16M11.5 16H9.5V18H11.5V16M15 16.9L14.1 16H13V18H15V16.9Z";
var mdiRouterWirelessSettings = "M20.2,4.9C19,3.8 17.5,3.2 16,3.2C14.5,3.2 13,3.8 11.8,4.9L11,4.1C12.4,2.7 14.2,2 16,2C17.8,2 19.6,2.7 21,4.1L20.2,4.9M19.3,5.7L18.5,6.5C17.8,5.8 16.9,5.5 16,5.5C15.1,5.5 14.2,5.8 13.5,6.5L12.7,5.7C13.6,4.8 14.8,4.3 16,4.3C17.2,4.3 18.4,4.8 19.3,5.7M19,12A2,2 0 0,1 21,14V18A2,2 0 0,1 19,20H5A2,2 0 0,1 3,18V14A2,2 0 0,1 5,12H15V8H17V12H19M8,17V15H6V17H8M11.5,17V15H9.5V17H11.5M15,17V15H13V17H15M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z";
var mdiRoutes = "M11,10H5L3,8L5,6H11V3L12,2L13,3V4H19L21,6L19,8H13V10H19L21,12L19,14H13V20A2,2 0 0,1 15,22H9A2,2 0 0,1 11,20V10Z";
var mdiRoutesClock = "M16.5 13H15V16.69L18.19 18.53L18.94 17.23L16.5 15.82V13M16 9C14.04 9 12.27 9.82 11 11.12V7H17L19 5L17 3H11V2L10 1L9 2V6H3L1 8L3 10H9V20C7.9 20 7 20.9 7 22H12.41C13.46 22.63 14.69 23 16 23C19.87 23 23 19.87 23 16S19.87 9 16 9M16 20.85C13.32 20.85 11.15 18.68 11.15 16S13.32 11.15 16 11.15 20.85 13.32 20.85 16 18.68 20.85 16 20.85Z";
var mdiRowing = "M8.5,14.5L4,19L5.5,20.5L9,17H11L8.5,14.5M15,1A2,2 0 0,0 13,3A2,2 0 0,0 15,5A2,2 0 0,0 17,3A2,2 0 0,0 15,1M21,21L18,24L15,21V19.5L7.91,12.41C7.6,12.46 7.3,12.5 7,12.5V10.32C8.66,10.35 10.61,9.45 11.67,8.28L13.07,6.73C13.26,6.5 13.5,6.35 13.76,6.23C14.05,6.09 14.38,6 14.72,6H14.75C16,6 17,7 17,8.26V14C17,14.85 16.65,15.62 16.08,16.17L12.5,12.59V10.32C11.87,10.84 11.07,11.34 10.21,11.71L16.5,18H18L21,21Z";
var mdiRss = "M6.18,15.64A2.18,2.18 0 0,1 8.36,17.82C8.36,19 7.38,20 6.18,20C5,20 4,19 4,17.82A2.18,2.18 0 0,1 6.18,15.64M4,4.44A15.56,15.56 0 0,1 19.56,20H16.73A12.73,12.73 0 0,0 4,7.27V4.44M4,10.1A9.9,9.9 0 0,1 13.9,20H11.07A7.07,7.07 0 0,0 4,12.93V10.1Z";
var mdiRssBox = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M7.5,15A1.5,1.5 0 0,0 6,16.5A1.5,1.5 0 0,0 7.5,18A1.5,1.5 0 0,0 9,16.5A1.5,1.5 0 0,0 7.5,15M6,10V12A6,6 0 0,1 12,18H14A8,8 0 0,0 6,10M6,6V8A10,10 0 0,1 16,18H18A12,12 0 0,0 6,6Z";
var mdiRssOff = "M2.5,3.77L3.78,2.5L21.5,20.22L20.23,21.5L18.73,20H16.73C16.73,19.25 16.67,18.5 16.54,17.81L6.19,7.46C5.5,7.33 4.75,7.27 4,7.27V5.27L2.5,3.77M6.18,15.64A2.18,2.18 0 0,1 8.36,17.82C8.36,19 7.38,20 6.18,20C5,20 4,19 4,17.82A2.18,2.18 0 0,1 6.18,15.64M4,10.1A9.9,9.9 0 0,1 13.9,20H11.07A7.07,7.07 0 0,0 4,12.93V10.1M9.13,5.31C13.59,6.87 17.13,10.41 18.69,14.87L9.13,5.31Z";
var mdiRug = "M12 14C10.9 14 10 13.11 10 12S10.9 10 12 10 14 10.9 14 12 13.11 14 12 14M23 19H1V17H4V15H1V13H4V11H1V9H4V7H1V5H23V7H20V9H23V11H20V13H23V15H20V17H23V19M12 15.92C12.62 16.62 13.66 16.81 14.5 16.33C15.34 15.85 15.69 14.84 15.4 13.96C16.31 13.78 17 12.97 17 12S16.31 10.22 15.4 10.04C15.69 9.16 15.34 8.15 14.5 7.67C13.66 7.19 12.62 7.38 12 8.08C11.38 7.38 10.34 7.19 9.5 7.67C8.66 8.15 8.31 9.16 8.61 10.04C7.69 10.22 7 11.03 7 12S7.69 13.78 8.61 13.96C8.31 14.84 8.66 15.85 9.5 16.33C10.34 16.82 11.38 16.62 12 15.92Z";
var mdiRugby = "M16.22,16.22C18.25,14.19 19.33,11.5 19.45,8.2C18.36,10.61 16.81,12.81 14.81,14.81C12.81,16.81 10.61,18.36 8.2,19.45C11.5,19.36 14.16,18.28 16.22,16.22M7.78,7.78C5.75,9.81 4.67,12.5 4.55,15.8C5,14.8 5.7,13.65 6.61,12.35C7.5,11.05 8.38,10 9.19,9.19C11.19,7.19 13.39,5.64 15.8,4.55C12.5,4.64 9.84,5.72 7.78,7.78M20.5,3.5C21,4.05 21.34,5.11 21.47,6.7C21.59,8.3 21.35,10.16 20.74,12.3C20.13,14.45 19.11,16.23 17.67,17.67C16.36,19 14.8,19.95 13,20.55C11.21,21.16 9.44,21.47 7.69,21.47C5.56,21.47 4.17,21.14 3.5,20.5C3,19.95 2.66,18.89 2.53,17.3C2.41,15.7 2.65,13.84 3.26,11.7C3.87,9.55 4.89,7.77 6.33,6.33C7.64,5 9.2,4.05 11,3.45C12.79,2.84 14.56,2.53 16.31,2.53C18.44,2.53 19.83,2.86 20.5,3.5Z";
var mdiRuler = "M1.39,18.36L3.16,16.6L4.58,18L5.64,16.95L4.22,15.54L5.64,14.12L8.11,16.6L9.17,15.54L6.7,13.06L8.11,11.65L9.53,13.06L10.59,12L9.17,10.59L10.59,9.17L13.06,11.65L14.12,10.59L11.65,8.11L13.06,6.7L14.47,8.11L15.54,7.05L14.12,5.64L15.54,4.22L18,6.7L19.07,5.64L16.6,3.16L18.36,1.39L22.61,5.64L5.64,22.61L1.39,18.36Z";
var mdiRulerSquare = "M3,5V21H9V19.5H7V18H9V16.5H5V15H9V13.5H7V12H9V10.5H5V9H9V5H10.5V9H12V7H13.5V9H15V5H16.5V9H18V7H19.5V9H21V3H5A2,2 0 0,0 3,5M6,7A1,1 0 0,1 5,6A1,1 0 0,1 6,5A1,1 0 0,1 7,6A1,1 0 0,1 6,7Z";
var mdiRulerSquareCompass = "M20 19.88V22L18.2 20.83L13.41 11.83A4.94 4.94 0 0 0 15.19 10.83M15 7A3 3 0 0 1 12 10A3.27 3.27 0 0 1 11.56 10L5.8 20.83L4 22V19.88L9.79 9A3 3 0 0 1 12 4V2A1 1 0 0 1 13 3V4.18A3 3 0 0 1 15 7M13 7A1 1 0 1 0 12 8A1 1 0 0 0 13 7M4.22 10L6 11.8L4.56 14.56L2.1 12.1M12 17.76L10.5 16.25L9 19L12 22L15 19L13.53 16.23M19.78 10L18 11.8L19.5 14.56L21.9 12.1Z";
var mdiRun = "M13.5,5.5C14.59,5.5 15.5,4.58 15.5,3.5C15.5,2.38 14.59,1.5 13.5,1.5C12.39,1.5 11.5,2.38 11.5,3.5C11.5,4.58 12.39,5.5 13.5,5.5M9.89,19.38L10.89,15L13,17V23H15V15.5L12.89,13.5L13.5,10.5C14.79,12 16.79,13 19,13V11C17.09,11 15.5,10 14.69,8.58L13.69,7C13.29,6.38 12.69,6 12,6C11.69,6 11.5,6.08 11.19,6.08L6,8.28V13H8V9.58L9.79,8.88L8.19,17L3.29,16L2.89,18L9.89,19.38Z";
var mdiRunFast = "M16.5,5.5A2,2 0 0,0 18.5,3.5A2,2 0 0,0 16.5,1.5A2,2 0 0,0 14.5,3.5A2,2 0 0,0 16.5,5.5M12.9,19.4L13.9,15L16,17V23H18V15.5L15.9,13.5L16.5,10.5C17.89,12.09 19.89,13 22,13V11C20.24,11.03 18.6,10.11 17.7,8.6L16.7,7C16.34,6.4 15.7,6 15,6C14.7,6 14.5,6.1 14.2,6.1L9,8.3V13H11V9.6L12.8,8.9L11.2,17L6.3,16L5.9,18L12.9,19.4M4,9A1,1 0 0,1 3,8A1,1 0 0,1 4,7H7V9H4M5,5A1,1 0 0,1 4,4A1,1 0 0,1 5,3H10V5H5M3,13A1,1 0 0,1 2,12A1,1 0 0,1 3,11H7V13H3Z";
var mdiRvTruck = "M20 8H22V6L20 4H3A2 2 0 0 0 1 6V15A2 2 0 0 0 3 17H4A3 3 0 0 0 7 20A3 3 0 0 0 10 17H15A3 3 0 0 0 21 17H23V12M7 18.5A1.5 1.5 0 0 1 7 15.5A1.5 1.5 0 0 1 7 18.5M9 12H3V9H9M14 15H11V9H14M18 18.5A1.5 1.5 0 1 1 19.5 17A1.54 1.54 0 0 1 18 18.5M17 12V9.5H19.5L21.5 12Z";
var mdiSack = "M16,9C20,11 21,18 21,18C21,18 22,22 16,22C10,22 8,22 8,22C2,22 3,18 3,18C3,18 4,11 8,9M14,4L12,2L10,4L6,2L8,7H16L18,2L14,4Z";
var mdiSackOutline = "M19 18.28V18.05C18.95 17.88 18.9 17.63 18.83 17.32C18.69 16.69 18.46 15.85 18.13 14.95C17.5 13.23 16.58 11.74 15.47 11H8.53C7.42 11.74 6.5 13.23 5.87 14.95C5.54 15.85 5.31 16.69 5.17 17.32C5.1 17.63 5.05 17.88 5 18.05V18.29L4.97 18.39L4.95 18.45C4.94 18.5 4.94 18.55 4.94 18.63C4.94 18.79 4.97 18.96 5.04 19.11C5.09 19.21 5.5 20 8 20H16C18.5 20 18.91 19.21 18.96 19.11C19.03 18.96 19.06 18.79 19.06 18.63C19.06 18.55 19.06 18.5 19.05 18.45L19.03 18.39L19 18.29V18.28M3 18C3 18 4 11 8 9H16C20 11 21 18 21 18C21 18 22 22 16 22H8C2 22 3 18 3 18M10 4L12 2L14 4L18 2L16 7H8L6 2L10 4Z";
var mdiSackPercent = "M8,7L6,2L10,4L12,2L14,4L18,2L16,7H8M16,22C10,22 8,22 8,22C2,22 3,18 3,18C3,18 4,11 8,9H16C20,11 21,18 21,18C21,18 22,22 16,22M7.5,12.5A1.5,1.5 0 0,0 9,14A1.5,1.5 0 0,0 10.5,12.5A1.5,1.5 0 0,0 9,11A1.5,1.5 0 0,0 7.5,12.5M16.5,18.5A1.5,1.5 0 0,0 15,17A1.5,1.5 0 0,0 13.5,18.5A1.5,1.5 0 0,0 15,20A1.5,1.5 0 0,0 16.5,18.5M16.5,12.35L15.15,11L7.5,18.65L8.87,20L16.5,12.35Z";
var mdiSafe = "M4,4A2,2 0 0,0 2,6V17A2,2 0 0,0 4,19V20H6V19H17V20H19V19A2,2 0 0,0 21,17V16H22V14H21V9H22V7H21V6A2,2 0 0,0 19,4H4M4,6H19V17H4V6M13.5,7.5A4,4 0 0,0 9.5,11.5A4,4 0 0,0 13.5,15.5A4,4 0 0,0 17.5,11.5A4,4 0 0,0 13.5,7.5M5,9V14H7V9H5M13.5,9.5A2,2 0 0,1 15.5,11.5A2,2 0 0,1 13.5,13.5A2,2 0 0,1 11.5,11.5A2,2 0 0,1 13.5,9.5Z";
var mdiSafeSquare = "M20 2C21.1 2 22 2.9 22 4V20C22 21.1 21.1 22 20 22H19V23H15V22H9V23H5V22H4C2.9 22 2 21.1 2 20V4C2 2.9 2.9 2 4 2H20M17 12C17 11 16.7 10 16.2 9.2L17.7 7.7L16.3 6.3L14.8 7.8C14 7.3 13 7 12 7C11 7 10 7.3 9.2 7.8L7.8 6.3L6.3 7.8L7.8 9.3C7.3 10 7 11 7 12C7 13 7.3 14 7.8 14.8L6.3 16.3L7.8 17.7L9.3 16.2C10 16.7 11 17 12 17C13 17 14 16.7 14.8 16.2L16.3 17.7L17.7 16.3L16.2 14.8C16.7 14 17 13 17 12M12 9C13.7 9 15 10.3 15 12C15 13.7 13.7 15 12 15C10.3 15 9 13.7 9 12C9 10.3 10.3 9 12 9M12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14Z";
var mdiSafeSquareOutline = "M10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14C10.9 14 10 13.1 10 12M7.8 17.7L6.3 16.3L7.8 14.8C7.3 14 7 13 7 12C7 11 7.3 10 7.8 9.3L6.3 7.8L7.8 6.3L9.2 7.8C10 7.3 11 7 12 7C13 7 14 7.3 14.8 7.8L16.3 6.3L17.7 7.7L16.2 9.2C16.7 10 17 11 17 12C17 13 16.7 14 16.2 14.8L17.7 16.3L16.3 17.7L14.8 16.2C14 16.7 13 17 12 17C11 17 10 16.7 9.3 16.2L7.8 17.7M12 9C10.3 9 9 10.3 9 12C9 13.7 10.3 15 12 15C13.7 15 15 13.7 15 12C15 10.3 13.7 9 12 9M20 2C21.1 2 22 2.9 22 4V20C22 21.1 21.1 22 20 22H19V23H15V22H9V23H5V22H4C2.9 22 2 21.1 2 20V4C2 2.9 2.9 2 4 2H20M20 20V4H4V20H20Z";
var mdiSafetyGoggles = "M18,9C19.11,9 20,9.89 20,11V14C20,15.11 19.11,16 18,16H15.77L14.53,14.77C13.78,14 12.77,13.6 11.7,13.6C10.63,13.6 9.63,14 8.87,14.77L7.64,16H6C4.89,16 4,15.11 4,14V11C4,9.89 4.89,9 6,9H18M18,7H6A4,4 0 0,0 2,11H2L1,11V14H2V14A4,4 0 0,0 6,18H8.5C8.54,17.94 8.59,17.88 10.29,16.18C10.68,15.79 11.19,15.6 11.7,15.6C12.22,15.6 12.73,15.79 13.12,16.18L14.91,18H18A4,4 0 0,0 22,14H22L23,14V11H22V11A4,4 0 0,0 18,7Z";
var mdiSailBoat = "M3 13.5L11 2.03V13.5H3M12.5 13.5C13.85 9.75 13.67 4.71 12.5 1C17.26 2.54 20.9 8.4 20.96 13.5H12.5M21.1 17.08C20.69 17.72 20.21 18.27 19.65 18.74C19 18.45 18.42 18 17.96 17.5C16.47 19.43 13.46 19.43 11.97 17.5C10.5 19.43 7.47 19.43 6 17.5C5.5 18 4.95 18.45 4.3 18.74C3.16 17.8 2.3 16.46 2 15H21.94C21.78 15.75 21.5 16.44 21.1 17.08M20.96 23C19.9 23 18.9 22.75 17.96 22.25C16.12 23.25 13.81 23.25 11.97 22.25C10.13 23.25 7.82 23.25 6 22.25C4.77 22.94 3.36 23.05 2 23V21C3.41 21.05 4.77 20.9 6 20C7.74 21.25 10.21 21.25 11.97 20C13.74 21.25 16.2 21.25 17.96 20C19.17 20.9 20.54 21.05 21.94 21V23H20.96Z";
var mdiSailBoatSink = "M20.96 21C19.9 21 18.9 20.74 17.96 20.24C16.12 21.24 13.81 21.24 11.97 20.24C10.13 21.24 7.82 21.24 6 20.24C4.77 20.93 3.36 21.04 2 21V19C3.41 19.04 4.77 18.89 6 18C7.74 19.24 10.21 19.24 11.97 18C13.74 19.24 16.2 19.24 17.96 18C19.17 18.89 20.54 19.04 21.94 19V21H20.96M22 3.5L7.11 5.96L13.11 12.17L22 3.5M10.81 16.36L11.97 15.54L13.12 16.36C13.65 16.72 14.3 16.93 14.97 16.93C15.12 16.93 15.28 16.91 15.43 16.89L5.2 6.31C4.29 7.65 3.9 9.32 4 10.92L9.74 16.83C10.13 16.74 10.5 16.58 10.81 16.36Z";
var mdiSale = "M18.65,2.85L19.26,6.71L22.77,8.5L21,12L22.78,15.5L19.24,17.29L18.63,21.15L14.74,20.54L11.97,23.3L9.19,20.5L5.33,21.14L4.71,17.25L1.22,15.47L3,11.97L1.23,8.5L4.74,6.69L5.35,2.86L9.22,3.5L12,0.69L14.77,3.46L18.65,2.85M9.5,7A1.5,1.5 0 0,0 8,8.5A1.5,1.5 0 0,0 9.5,10A1.5,1.5 0 0,0 11,8.5A1.5,1.5 0 0,0 9.5,7M14.5,14A1.5,1.5 0 0,0 13,15.5A1.5,1.5 0 0,0 14.5,17A1.5,1.5 0 0,0 16,15.5A1.5,1.5 0 0,0 14.5,14M8.41,17L17,8.41L15.59,7L7,15.59L8.41,17Z";
var mdiSaleOutline = "M9.5 7C10.33 7 11 7.67 11 8.5C11 9.33 10.33 10 9.5 10C8.67 10 8 9.33 8 8.5C8 7.67 8.67 7 9.5 7M14.5 14C15.33 14 16 14.67 16 15.5C16 16.33 15.33 17 14.5 17C13.67 17 13 16.33 13 15.5C13 14.67 13.67 14 14.5 14M8.41 17L7 15.59L15.59 7L17 8.41L8.41 17M18.65 2.85L19.26 6.71L22.77 8.5L21 12L22.78 15.5L19.24 17.29L18.63 21.15L14.74 20.54L11.97 23.31L9.19 20.5L5.33 21.14L4.71 17.25L1.22 15.47L3 11.97L1.23 8.5L4.74 6.69L5.35 2.87L9.22 3.5L12 .695L14.76 3.46L18.65 2.85M20.1 9.37L17.5 8L17 5.11L14.1 5.53L12 3.5L9.9 5.53L7 5.11L6.5 8L3.9 9.37L5.2 12L3.9 14.63L6.5 16L7 18.89L9.9 18.47L12 20.5L14.1 18.47L17 18.89L17.5 16L20.1 14.63L18.8 12L20.1 9.37Z";
var mdiSalesforce = "M18.38,6.37C17.68,6.37 17.07,6.58 16.47,6.78C15.77,5.57 14.46,4.77 13.05,4.77C11.95,4.77 10.95,5.27 10.24,5.97C9.44,4.97 8.23,4.26 6.83,4.26C4.5,4.26 2.5,6.17 2.5,8.5C2.5,9.09 2.71,9.69 2.91,10.29C1.8,10.9 1,12.1 1,13.5C1,15.5 2.61,17.22 4.62,17.22C4.92,17.22 5.22,17.22 5.42,17.12C5.82,18.63 7.33,19.74 9.14,19.74C10.84,19.74 12.25,18.73 12.75,17.32C13.26,17.53 13.76,17.73 14.26,17.73C15.57,17.73 16.77,17 17.37,15.92C17.68,16 18,16 18.28,16C20.89,16 23,13.91 23,11.2C23.1,8.5 21,6.37 18.38,6.37Z";
var mdiSass = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M10,15.33C10.16,15.87 10.14,16.37 10,16.83C10,16.88 9.96,16.93 9.94,17C9.92,17 9.9,17.07 9.87,17.12C9.76,17.36 9.6,17.59 9.41,17.79C8.83,18.43 8,18.67 7.67,18.47C7.29,18.25 7.5,17.35 8.16,16.64C8.88,15.88 9.92,15.38 9.92,15.38V15.38L10,15.33M18.27,6.28C17.82,4.5 14.87,3.92 12.09,4.91C10.43,5.5 8.63,6.42 7.34,7.63C5.81,9.07 5.56,10.32 5.66,10.84C6,12.68 8.54,13.89 9.58,14.78V14.79C9.28,14.94 7.04,16.07 6.5,17.23C5.96,18.45 6.6,19.33 7,19.45C8.34,19.81 9.69,19.16 10.41,18.07C11.11,17.03 11.06,15.68 10.75,15C11.17,14.9 11.66,14.85 12.28,14.92C14.04,15.13 14.38,16.22 14.31,16.68C14.25,17.14 13.88,17.39 13.76,17.47C13.64,17.54 13.6,17.57 13.61,17.63C13.62,17.71 13.68,17.71 13.78,17.69C13.93,17.66 14.71,17.32 14.74,16.47C14.78,15.39 13.75,14.19 11.93,14.22C11.18,14.24 10.71,14.31 10.37,14.44L10.29,14.35C9.16,13.15 7.08,12.3 7.17,10.68C7.2,10.09 7.4,8.55 11.17,6.67C14.25,5.13 16.72,5.55 17.15,6.5C17.76,7.83 15.83,10.32 12.63,10.68C11.41,10.82 10.76,10.34 10.6,10.17C10.43,10 10.41,9.97 10.35,10C10.24,10.07 10.31,10.23 10.35,10.33C10.44,10.58 10.84,11 11.5,11.24C12.09,11.43 13.53,11.54 15.26,10.87C17.2,10.12 18.72,8.03 18.27,6.28Z";
var mdiSatellite = "M5,18L8.5,13.5L11,16.5L14.5,12L19,18M5,12V10A5,5 0 0,0 10,5H12A7,7 0 0,1 5,12M5,5H8A3,3 0 0,1 5,8M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiSatelliteUplink = "M11.86,2L11.34,3.93C15.75,4.78 19.2,8.23 20.05,12.65L22,12.13C20.95,7.03 16.96,3.04 11.86,2M10.82,5.86L10.3,7.81C13.34,8.27 15.72,10.65 16.18,13.68L18.12,13.16C17.46,9.44 14.55,6.5 10.82,5.86M3.72,9.69C3.25,10.73 3,11.86 3,13C3,14.95 3.71,16.82 5,18.28V22H8V20.41C8.95,20.8 9.97,21 11,21C12.14,21 13.27,20.75 14.3,20.28L3.72,9.69M9.79,9.76L9.26,11.72A3,3 0 0,1 12.26,14.72L14.23,14.2C14,11.86 12.13,10 9.79,9.76Z";
var mdiSatelliteVariant = "M11.62,1L17.28,6.67L15.16,8.79L13.04,6.67L11.62,8.09L13.95,10.41L12.79,11.58L13.24,12.04C14.17,11.61 15.31,11.77 16.07,12.54L12.54,16.07C11.77,15.31 11.61,14.17 12.04,13.24L11.58,12.79L10.41,13.95L8.09,11.62L6.67,13.04L8.79,15.16L6.67,17.28L1,11.62L3.14,9.5L5.26,11.62L6.67,10.21L3.84,7.38C3.06,6.6 3.06,5.33 3.84,4.55L4.55,3.84C5.33,3.06 6.6,3.06 7.38,3.84L10.21,6.67L11.62,5.26L9.5,3.14L11.62,1M18,14A4,4 0 0,1 14,18V16A2,2 0 0,0 16,14H18M22,14A8,8 0 0,1 14,22V20A6,6 0 0,0 20,14H22Z";
var mdiSausage = "M19 5.3C20.2 5.8 21 7.1 21 8.5C21 15.4 15.4 21 8.5 21C7.1 21 5.9 20.2 5.3 19L3 20.5V14.5L5.3 16C5.9 14.8 7.1 14 8.5 14C11.5 14 14 11.5 14 8.5C14 7.1 14.8 5.9 16 5.3L14.5 3H20.5L19 5.3Z";
var mdiSausageOff = "M20.8 22.7L16.3 18.2C14.2 19.9 11.4 21 8.5 21C7.1 21 5.9 20.2 5.3 19L3 20.5V14.5L5.3 16C5.8 14.8 7.1 14 8.5 14C9.5 14 10.5 13.7 11.3 13.2L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M21 8.5C21 7.1 20.2 5.9 19 5.3L20.5 3H14.5L16 5.3C14.8 5.8 14 7.1 14 8.5C14 9.2 13.9 9.8 13.6 10.4L18.7 15.6C20.2 13.6 21 11.1 21 8.5Z";
var mdiSawBlade = "M20,15C20,15 18.6,16.3 21.1,17L18.3,19.8H15.5C15.5,19.8 13.6,19.7 15,22H11L9,20C9,20 7.7,18.6 7,21.1L4.2,18.3V15.5C4.2,15.5 4.3,13.6 2,15V11L4,9C4,9 5.4,7.7 2.8,7.1L5.6,4.2H8.5C8.5,4.2 10.4,4.3 9,2H13L15,4C15,4 16.3,5.4 17,2.8L19.8,5.6V8.5C19.8,8.5 19.7,10.4 22,9V13L20,15M14,12A2,2 0 0,0 12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12Z";
var mdiSawtoothWave = "M11 22V6.83L2 16V13.17L13 2V17.17L22 8V10.83L11 22Z";
var mdiSaxophone = "M4,2A1,1 0 0,0 3,3A1,1 0 0,0 4,4A3,3 0 0,1 7,7V8.66L7,15.5C7,19.1 9.9,22 13.5,22C17.1,22 20,19.1 20,15.5V13A1,1 0 0,0 21,12A1,1 0 0,0 20,11H14A1,1 0 0,0 13,12A1,1 0 0,0 14,13V15A1,1 0 0,1 13,16A1,1 0 0,1 12,15V11A1,1 0 0,0 13,10A1,1 0 0,0 12,9V8A1,1 0 0,0 13,7A1,1 0 0,0 12,6V5.5A3.5,3.5 0 0,0 8.5,2H4Z";
var mdiScale = "M8.46,15.06L7.05,16.47L5.68,15.1C4.82,16.21 4.24,17.54 4.06,19H6V21H2V20C2,15.16 5.44,11.13 10,10.2V8.2L2,5V3H22V5L14,8.2V10.2C18.56,11.13 22,15.16 22,20V21H18V19H19.94C19.76,17.54 19.18,16.21 18.32,15.1L16.95,16.47L15.54,15.06L16.91,13.68C15.8,12.82 14.46,12.24 13,12.06V14H11V12.06C9.54,12.24 8.2,12.82 7.09,13.68L8.46,15.06M12,18A2,2 0 0,1 14,20A2,2 0 0,1 12,22C11.68,22 11.38,21.93 11.12,21.79L7.27,20L11.12,18.21C11.38,18.07 11.68,18 12,18Z";
var mdiScaleBalance = "M12,3C10.73,3 9.6,3.8 9.18,5H3V7H4.95L2,14C1.53,16 3,17 5.5,17C8,17 9.56,16 9,14L6.05,7H9.17C9.5,7.85 10.15,8.5 11,8.83V20H2V22H22V20H13V8.82C13.85,8.5 14.5,7.85 14.82,7H17.95L15,14C14.53,16 16,17 18.5,17C21,17 22.56,16 22,14L19.05,7H21V5H14.83C14.4,3.8 13.27,3 12,3M12,5A1,1 0 0,1 13,6A1,1 0 0,1 12,7A1,1 0 0,1 11,6A1,1 0 0,1 12,5M5.5,10.25L7,14H4L5.5,10.25M18.5,10.25L20,14H17L18.5,10.25Z";
var mdiScaleBathroom = "M5,2H19A2,2 0 0,1 21,4V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2M12,4A4,4 0 0,0 8,8H11.26L10.85,5.23L12.9,8H16A4,4 0 0,0 12,4M5,10V20H19V10H5Z";
var mdiScaleOff = "M22.11 21.46L20.84 22.73L19.11 21H18V19.89L12.11 14H11V12.89L10.31 12.2A7.92 7.92 0 0 0 7.09 13.68L8.46 15.06L7.05 16.47L5.68 15.1A7.94 7.94 0 0 0 4.06 19H6V21H2V20A10 10 0 0 1 8.68 10.57L3.85 5.74L2 5V3.89L1.11 3L2.39 1.73M21.91 18.71A10 10 0 0 0 14 10.2V8.2L22 5V3H6.2M12 18A1.84 1.84 0 0 0 11.12 18.21L7.27 20L11.12 21.79A1.84 1.84 0 0 0 12 22A2 2 0 0 0 12 18Z";
var mdiScaleUnbalanced = "M13 20V8.8C13.5 8.6 14 8.3 14.3 7.9L17.8 9.2L14.9 16C14.4 18 15.9 19 18.4 19S22.5 18 21.9 16L19.3 9.7L20.2 10L20.9 8.1L15 6C15 4.8 14.3 3.6 13 3.1C11.8 2.6 10.5 3.1 9.7 4L3.9 2L3.2 3.8L4.8 4.4L2.1 11C1.6 13 3.1 14 5.6 14S9.7 13 9.1 11L6.6 5.1L9 6C9 7.2 9.7 8.4 11 8.9V20H2V22H22V20H13M19.9 16H16.9L18.4 12.2L19.9 16M7.1 11H4.1L5.6 7.2L7.1 11M11.1 5.7C11.3 5.2 11.9 4.9 12.4 5.1S13.2 5.9 13 6.4 12.2 7.2 11.7 7 10.9 6.2 11.1 5.7Z";
var mdiScanHelper = "M0 2A2 2 0 0 1 2 0H6V2H2V6H0V2M24 22A2 2 0 0 1 22 24H18V22H22V18H24V22M2 24A2 2 0 0 1 0 22V18H2V22H6V24H2M22 0A2 2 0 0 1 24 2V6H22V2H18V0H22Z";
var mdiScanner = "M4.2,10.7L19.8,5L20.5,6.9L6.4,12H19A2,2 0 0,1 21,14V18A2,2 0 0,1 19,20H5A2,2 0 0,1 3,18V12.5C3,11.7 3.5,10.9 4.2,10.7M17,17H19V15H17V17M5,17H15V15H5V17Z";
var mdiScannerOff = "M2,5.27L3.28,4L20,20.72L18.73,22L16.73,20H5A2,2 0 0,1 3,18V12.5C3,11.7 3.5,10.9 4.2,10.7L6.57,9.84L2,5.27M6.4,12H8.73L8.11,11.38L6.4,12M5,15V17H13.73L11.73,15H5M19.8,5L20.5,6.9L11.85,10.03L10.3,8.47L19.8,5M19,12A2,2 0 0,1 21,14V18C21,18.34 20.91,18.66 20.76,18.94L19,17.18V15H16.82L13.82,12H19Z";
var mdiScatterPlot = "M7,11A3,3 0 0,1 10,14A3,3 0 0,1 7,17A3,3 0 0,1 4,14A3,3 0 0,1 7,11M11,3A3,3 0 0,1 14,6A3,3 0 0,1 11,9A3,3 0 0,1 8,6A3,3 0 0,1 11,3M16.6,14.6C18.25,14.6 19.6,15.94 19.6,17.6A3,3 0 0,1 16.6,20.6C14.94,20.6 13.6,19.25 13.6,17.6A3,3 0 0,1 16.6,14.6Z";
var mdiScatterPlotOutline = "M7,18A4,4 0 0,1 3,14A4,4 0 0,1 7,10A4,4 0 0,1 11,14A4,4 0 0,1 7,18M7,12A2,2 0 0,0 5,14A2,2 0 0,0 7,16A2,2 0 0,0 9,14A2,2 0 0,0 7,12M11,10A4,4 0 0,1 7,6A4,4 0 0,1 11,2A4,4 0 0,1 15,6A4,4 0 0,1 11,10M11,4A2,2 0 0,0 9,6A2,2 0 0,0 11,8A2,2 0 0,0 13,6A2,2 0 0,0 11,4M16.6,21.6C14.39,21.6 12.6,19.81 12.6,17.6A4,4 0 0,1 16.6,13.6C18.81,13.6 20.6,15.39 20.6,17.6A4,4 0 0,1 16.6,21.6M16.6,15.6A2,2 0 0,0 14.6,17.6C14.6,18.7 15.5,19.6 16.6,19.6A2,2 0 0,0 18.6,17.6C18.6,16.5 17.7,15.6 16.6,15.6Z";
var mdiScent = "M17.5 5.1C18.5 6.4 19 7.6 19 9C19 10.7 18.3 12.3 16.6 14.1C14.7 16.1 13 18.3 13 20.5C13 20.9 13.1 21.3 13.2 21.8C13.2 21.9 13.2 22 13.1 22.1C13 22.2 12.9 22.1 12.9 22C11.9 20.7 11.4 19.5 11.4 18.1C11.4 16.4 12.1 14.8 13.8 13C15.7 11 17.4 8.8 17.4 6.6C17.4 6.2 17.3 5.8 17.2 5.3C17.2 5.2 17.2 5.1 17.3 5C17.4 5 17.4 5 17.5 5.1M9.7 2.1C10.4 3 10.7 4 10.7 4.9C10.7 6.2 10.1 7.4 8.9 8.7C7.5 10.2 6.2 11.9 6.2 13.5C6.2 13.8 6.3 14.2 6.4 14.4C6.4 14.5 6.4 14.5 6.3 14.6C6.2 14.7 6.1 14.6 6.1 14.6C5.3 13.6 5 12.6 5 11.7C5 10.4 5.6 9.2 6.8 7.9C8.2 6.4 9.5 4.7 9.5 3.1C9.5 2.8 9.4 2.4 9.3 2.2V2C9.5 2 9.6 2 9.7 2.1M10.1 9.9C12 7.9 13.7 5.7 13.7 3.5C13.7 3.1 13.6 2.7 13.5 2.2C13.5 2.1 13.5 2 13.6 1.9C13.7 1.8 13.8 1.9 13.8 2C14.8 3.3 15.3 4.5 15.3 5.9C15.3 7.6 14.6 9.2 12.9 11C11 13 9.3 15.2 9.3 17.4C9.3 17.8 9.4 18.2 9.5 18.7C9.5 18.8 9.5 18.9 9.4 19C9.3 19.1 9.2 19 9.2 18.9C8.2 17.6 7.7 16.4 7.7 15C7.7 13.3 8.4 11.7 10.1 9.9Z";
var mdiScentOff = "M14.6 16.5C13.7 17.8 13 19.2 13 20.5C13 20.9 13.1 21.3 13.2 21.8C13.2 21.9 13.2 22 13.1 22.1C13 22.2 12.9 22.1 12.9 22C11.9 20.7 11.4 19.5 11.4 18.1C11.4 16.9 11.8 15.7 12.6 14.5L11.2 13.1C10.1 14.5 9.4 16 9.4 17.5C9.4 17.9 9.5 18.3 9.6 18.8C9.6 18.9 9.6 19 9.5 19.1C9.4 19.2 9.3 19.1 9.3 19C8.3 17.7 7.8 16.5 7.8 15.1C7.8 13.8 8.3 12.5 9.3 11.1L7.9 9.8C6.9 11 6.2 12.2 6.2 13.4C6.2 13.7 6.3 14.1 6.4 14.3C6.4 14.4 6.4 14.4 6.3 14.5C6.2 14.6 6.1 14.5 6.1 14.5C5.3 13.6 5 12.6 5 11.7C5 10.6 5.5 9.5 6.4 8.4L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7L14.6 16.5M10.2 7C10.6 6.3 10.8 5.6 10.8 4.9C10.8 4 10.5 3 9.7 2.1C9.6 2 9.5 2 9.4 2C9.3 2 9.4 2.1 9.4 2.2C9.5 2.5 9.6 2.8 9.6 3.1C9.6 3.9 9.3 4.7 8.8 5.5L10.2 7M17.3 6.5C17.3 8.2 16.2 10 14.8 11.6L16.8 13.6C18.3 12.1 19 10.6 19 9C19 7.7 18.5 6.4 17.5 5.1C17.4 5 17.4 5 17.3 5C17.2 5.1 17.2 5.2 17.2 5.3C17.2 5.7 17.3 6.1 17.3 6.5M13.5 10.3C14.7 8.8 15.3 7.4 15.3 5.9C15.3 4.6 14.8 3.3 13.8 2H13.6C13.5 2.1 13.5 2.2 13.5 2.3C13.6 2.7 13.7 3.1 13.7 3.6C13.7 5.2 12.8 6.8 11.5 8.4L13.5 10.3Z";
var mdiSchool = "M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z";
var mdiSchoolOutline = "M12 3L1 9L5 11.18V17.18L12 21L19 17.18V11.18L21 10.09V17H23V9L12 3M18.82 9L12 12.72L5.18 9L12 5.28L18.82 9M17 16L12 18.72L7 16V12.27L12 15L17 12.27V16Z";
var mdiScissorsCutting = "M11,21H7V19H11V21M15.5,19H17V21H13V19H13.2L11.8,12.9L9.3,13.5C9.2,14 9,14.4 8.8,14.8C7.9,16.3 6,16.7 4.5,15.8C3,14.9 2.6,13 3.5,11.5C4.4,10 6.3,9.6 7.8,10.5C8.2,10.7 8.5,11.1 8.7,11.4L11.2,10.8L10.6,8.3C10.2,8.2 9.8,8 9.4,7.8C8,6.9 7.5,5 8.4,3.5C9.3,2 11.2,1.6 12.7,2.5C14.2,3.4 14.6,5.3 13.7,6.8C13.5,7.2 13.1,7.5 12.8,7.7L15.5,19M7,11.8C6.3,11.3 5.3,11.6 4.8,12.3C4.3,13 4.6,14 5.3,14.4C6,14.9 7,14.7 7.5,13.9C7.9,13.2 7.7,12.2 7,11.8M12.4,6C12.9,5.3 12.6,4.3 11.9,3.8C11.2,3.3 10.2,3.6 9.7,4.3C9.3,5 9.5,6 10.3,6.5C11,6.9 12,6.7 12.4,6M12.8,11.3C12.6,11.2 12.4,11.2 12.3,11.4C12.2,11.6 12.2,11.8 12.4,11.9C12.6,12 12.8,12 12.9,11.8C13.1,11.6 13,11.4 12.8,11.3M21,8.5L14.5,10L15,12.2L22.5,10.4L23,9.7L21,8.5M23,19H19V21H23V19M5,19H1V21H5V19Z";
var mdiScooter = "M7.82 19H15V18C15 15.79 16.79 14 19 14H19.74L17.84 5.56C17.63 4.65 16.82 4 15.89 4H12V6H15.89L17.29 12.25H17.28C15.12 12.9 13.47 14.73 13.09 17H7.82C7.34 15.66 5.96 14.76 4.4 15.06C3.22 15.29 2.27 16.26 2.05 17.44C1.7 19.34 3.16 21 5 21C6.3 21 7.4 20.16 7.82 19M5 19C4.45 19 4 18.55 4 18S4.45 17 5 17 6 17.45 6 18 5.55 19 5 19M19 15C17.34 15 16 16.34 16 18S17.34 21 19 21 22 19.66 22 18 20.66 15 19 15M19 19C18.45 19 18 18.55 18 18S18.45 17 19 17 20 17.45 20 18 19.55 19 19 19Z";
var mdiScooterElectric = "M7.82 16H15V15C15 12.79 16.79 11 19 11H19.74L17.84 2.56C17.63 1.65 16.82 1 15.89 1H12V3H15.89L17.29 9.25H17.28C15.12 9.9 13.47 11.73 13.09 14H7.82C7.34 12.66 5.96 11.76 4.4 12.06C3.22 12.29 2.27 13.26 2.05 14.44C1.7 16.34 3.16 18 5 18C6.3 18 7.4 17.16 7.82 16M5 16C4.45 16 4 15.55 4 15S4.45 14 5 14 6 14.45 6 15 5.55 16 5 16M19 12C17.34 12 16 13.34 16 15S17.34 18 19 18 22 16.66 22 15 20.66 12 19 12M19 16C18.45 16 18 15.55 18 15S18.45 14 19 14 20 14.45 20 15 19.55 16 19 16M11 20H7L13 23V21H17L11 18V20Z";
var mdiScoreboard = "M6 9H8V15H6V9M16 9H18V15H16V9M21 3C22.1 3 23 3.9 23 5V19C23 20.1 22.1 21 21 21H3C1.9 21 1 20.1 1 19V5C1 3.9 1.9 3 3 3H21M5 7C4.4 7 4 7.4 4 8V16C4 16.6 4.4 17 5 17H9C9.6 17 10 16.6 10 16V8C10 7.4 9.6 7 9 7H5M15 7C14.4 7 14 7.4 14 8V16C14 16.6 14.4 17 15 17H19C19.6 17 20 16.6 20 16V8C20 7.4 19.6 7 19 7H15M12 11C12.6 11 13 10.6 13 10C13 9.4 12.6 9 12 9C11.4 9 11 9.4 11 10C11 10.6 11.4 11 12 11M12 15C12.6 15 13 14.6 13 14C13 13.4 12.6 13 12 13C11.4 13 11 13.4 11 14C11 14.6 11.4 15 12 15Z";
var mdiScoreboardOutline = "M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3M21 19H3V5H21M5 7H9C9.6 7 10 7.4 10 8V16C10 16.6 9.6 17 9 17H5C4.4 17 4 16.6 4 16V8C4 7.4 4.4 7 5 7M6 9V15H8V9M15 7H19C19.6 7 20 7.4 20 8V16C20 16.6 19.6 17 19 17H15C14.4 17 14 16.6 14 16V8C14 7.4 14.4 7 15 7M16 9V15H18V9M12 11C12.6 11 13 10.6 13 10C13 9.4 12.6 9 12 9C11.4 9 11 9.4 11 10C11 10.6 11.4 11 12 11M12 15C12.6 15 13 14.6 13 14C13 13.4 12.6 13 12 13C11.4 13 11 13.4 11 14C11 14.6 11.4 15 12 15Z";
var mdiScreenRotation = "M7.5,21.5C4.25,19.94 1.91,16.76 1.55,13H0.05C0.56,19.16 5.71,24 12,24L12.66,23.97L8.85,20.16M14.83,21.19L2.81,9.17L9.17,2.81L21.19,14.83M10.23,1.75C9.64,1.16 8.69,1.16 8.11,1.75L1.75,8.11C1.16,8.7 1.16,9.65 1.75,10.23L13.77,22.25C14.36,22.84 15.31,22.84 15.89,22.25L22.25,15.89C22.84,15.3 22.84,14.35 22.25,13.77L10.23,1.75M16.5,2.5C19.75,4.07 22.09,7.24 22.45,11H23.95C23.44,4.84 18.29,0 12,0L11.34,0.03L15.15,3.84L16.5,2.5Z";
var mdiScreenRotationLock = "M16.8,2.5C16.8,1.56 17.56,0.8 18.5,0.8C19.44,0.8 20.2,1.56 20.2,2.5V3H16.8V2.5M16,9H21A1,1 0 0,0 22,8V4A1,1 0 0,0 21,3V2.5A2.5,2.5 0 0,0 18.5,0A2.5,2.5 0 0,0 16,2.5V3A1,1 0 0,0 15,4V8A1,1 0 0,0 16,9M8.47,20.5C5.2,18.94 2.86,15.76 2.5,12H1C1.5,18.16 6.66,23 12.95,23L13.61,22.97L9.8,19.15L8.47,20.5M23.25,12.77L20.68,10.2L19.27,11.61L21.5,13.83L15.83,19.5L4.5,8.17L10.17,2.5L12.27,4.61L13.68,3.2L11.23,0.75C10.64,0.16 9.69,0.16 9.11,0.75L2.75,7.11C2.16,7.7 2.16,8.65 2.75,9.23L14.77,21.25C15.36,21.84 16.31,21.84 16.89,21.25L23.25,14.89C23.84,14.3 23.84,13.35 23.25,12.77Z";
var mdiScrewFlatTop = "M13.5,17V19L12,22L10.5,19L13.5,17M14.5,6.3L13.5,7V6H10.5V9L9.5,9.7V10.7L14.5,7.4V6.3M14.5,10.3L13.5,11V9L10.5,11V13L9.5,13.7V14.7L14.5,11.4V10.3M14.5,14.3L13.5,15V13L10.5,15V17L9.5,17.7V18.7L14.5,15.4V14.3M8,2C8,2 7,2 7,3L10,5H14L17,3C17,3 17,2 16,2C15,2 8,2 8,2Z";
var mdiScrewLag = "M10,19.3L14,16.6V20L12,22L10,20V19.3M14,12.7L10,15.4V17.4L9,18V19L15,15.1V14L14,14.7V12.7M7,2V5H17V2H7M9,6V9L10,9.7V13.4L9,14V15L15,11.1V10L14,10.7C14,10.7 14,10.3 14,9.7L15,9V6H9Z";
var mdiScrewMachineFlatTop = "M14.5,7.3L13.5,8V7H10.5V10L9.5,10.7V11.7L14.5,8.4V7.3M14.5,11.3L13.5,12V10L10.5,12V14L9.5,14.7V15.7L14.5,12.4V11.3M14.5,15.3L13.5,16V14L10.5,16V18L9.5,18.7V19.7L14.5,16.4V15.3M8,3C8,3 7,3 7,4L10,6H14L17,4C17,4 17,3 16,3C15,3 8,3 8,3M13.5,18V21H10.5V20L13.5,18Z";
var mdiScrewMachineRoundTop = "M14.5,7.3L13.5,8V7H10.5V10L9.5,10.7V11.7L14.5,8.4V7.3M14.5,11.3L13.5,12V10L10.5,12V14L9.5,14.7V15.7L14.5,12.4V11.3M14.5,15.3L13.5,16V14L10.5,16V18L9.5,18.7V19.7L14.5,16.4V15.3M7,6H17C17,6 16,3 12,3C8,3 7,6 7,6M13.5,18V21H10.5V20L13.5,18Z";
var mdiScrewRoundTop = "M13.5,17V19L12,22L10.5,19L13.5,17M14.5,6.3L13.5,7V6H10.5V9L9.5,9.7V10.7L14.5,7.4V6.3M14.5,10.3L13.5,11V9L10.5,11V13L9.5,13.7V14.7L14.5,11.4V10.3M14.5,14.3L13.5,15V13L10.5,15V17L9.5,17.7V18.7L14.5,15.4V14.3M7,5H17C17,5 16,2 12,2C8,2 7,5 7,5Z";
var mdiScrewdriver = "M18,1.83C17.5,1.83 17,2 16.59,2.41C13.72,5.28 8,11 8,11L9.5,12.5L6,16H4L2,20L4,22L8,20V18L11.5,14.5L13,16C13,16 18.72,10.28 21.59,7.41C22.21,6.5 22.37,5.37 21.59,4.59L19.41,2.41C19,2 18.5,1.83 18,1.83M18,4L20,6L13,13L11,11L18,4Z";
var mdiScript = "M17.8,20C17.4,21.2 16.3,22 15,22H5C3.3,22 2,20.7 2,19V18H5L14.2,18C14.6,19.2 15.7,20 17,20H17.8M19,2H8C6.3,2 5,3.3 5,5V16H16V17C16,17.6 16.4,18 17,18H18V5C18,4.4 18.4,4 19,4C19.6,4 20,4.4 20,5V6H22V5C22,3.3 20.7,2 19,2Z";
var mdiScriptOutline = "M15,20A1,1 0 0,0 16,19V4H8A1,1 0 0,0 7,5V16H5V5A3,3 0 0,1 8,2H19A3,3 0 0,1 22,5V6H20V5A1,1 0 0,0 19,4A1,1 0 0,0 18,5V9L18,19A3,3 0 0,1 15,22H5A3,3 0 0,1 2,19V18H13A2,2 0 0,0 15,20Z";
var mdiScriptText = "M17.8,20C17.4,21.2 16.3,22 15,22H5C3.3,22 2,20.7 2,19V18H5L14.2,18C14.6,19.2 15.7,20 17,20H17.8M19,2C20.7,2 22,3.3 22,5V6H20V5C20,4.4 19.6,4 19,4C18.4,4 18,4.4 18,5V18H17C16.4,18 16,17.6 16,17V16H5V5C5,3.3 6.3,2 8,2H19M8,6V8H15V6H8M8,10V12H14V10H8Z";
var mdiScriptTextKey = "M17.8 19C17.4 17.8 16.3 17 15 17C13.3 17 12 18.3 12 20S13.3 23 15 23C16.3 23 17.4 22.2 17.8 21H19V23H21V21H23V19H17.8M15 21.3C14.3 21.3 13.7 20.7 13.7 20S14.3 18.7 15 18.7 16.3 19.3 16.3 20 15.7 21.3 15 21.3M15 15C16.1 15 17.2 15.4 18 16V5C18 4.4 18.4 4 19 4S20 4.4 20 5V6H22V5C22 3.3 20.7 2 19 2H8C6.3 2 5 3.3 5 5V16H12C12.8 15.4 13.9 15 15 15M8 6H15V8H8V6M8 10H14V12H8V10M10.4 22H5C3.3 22 2 20.7 2 19V18H10.4C10.1 18.6 10 19.3 10 20S10.1 21.4 10.4 22";
var mdiScriptTextKeyOutline = "M17.8 19C17.4 17.8 16.3 17 15 17C13.3 17 12 18.3 12 20S13.3 23 15 23C16.3 23 17.4 22.2 17.8 21H19V23H21V21H23V19H17.8M15 21.3C14.3 21.3 13.7 20.7 13.7 20S14.3 18.7 15 18.7 16.3 19.3 16.3 20 15.7 21.3 15 21.3M9 10H14V12H9V10M9 6H14V8H9V6M7 5C7 4.4 7.4 4 8 4H16V15.1C16.7 15.3 17.4 15.6 18 16V5C18 4.4 18.4 4 19 4S20 4.4 20 5V6H22V5C22 3.3 20.7 2 19 2H8C6.3 2 5 3.3 5 5V16H7V5M10 20C10 19.3 10.1 18.6 10.4 18H2V19C2 20.7 3.3 22 5 22H10.4C10.1 21.4 10 20.7 10 20M9 16H12C12.6 15.6 13.3 15.2 14 15.1V14H9V16Z";
var mdiScriptTextOutline = "M15,20A1,1 0 0,0 16,19V4H8A1,1 0 0,0 7,5V16H5V5A3,3 0 0,1 8,2H19A3,3 0 0,1 22,5V6H20V5A1,1 0 0,0 19,4A1,1 0 0,0 18,5V9L18,19A3,3 0 0,1 15,22H5A3,3 0 0,1 2,19V18H13A2,2 0 0,0 15,20M9,6H14V8H9V6M9,10H14V12H9V10M9,14H14V16H9V14Z";
var mdiScriptTextPlay = "M13.8 22H5C3.3 22 2 20.7 2 19V18H13.1C13 18.3 13 18.7 13 19C13 20.1 13.3 21.1 13.8 22M13.8 16H5V5C5 3.3 6.3 2 8 2H19C20.7 2 22 3.3 22 5V6H20V5C20 4.4 19.6 4 19 4S18 4.4 18 5V13.1C16.2 13.4 14.7 14.5 13.8 16M8 8H15V6H8V8M8 12H14V10H8V12M17 16V22L22 19L17 16Z";
var mdiScriptTextPlayOutline = "M9 14H14V15.7C13.9 15.8 13.9 15.9 13.8 16H9V14M9 12H14V10H9V12M9 8H14V6H9V8M7 5C7 4.4 7.4 4 8 4H16V13.8C16.6 13.4 17.3 13.2 18 13.1V5C18 4.4 18.4 4 19 4S20 4.4 20 5V6H22V5C22 3.3 20.7 2 19 2H8C6.3 2 5 3.3 5 5V16H7V5M13 19V18.4 18H2V19C2 20.7 3.3 22 5 22H13.8C13.3 21.1 13 20.1 13 19M17 16V22L22 19L17 16Z";
var mdiSd = "M18,8H16V4H18M15,8H13V4H15M12,8H10V4H12M18,2H10L4,8V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V4A2,2 0 0,0 18,2Z";
var mdiSeal = "M20.39,19.37L16.38,18L15,22L11.92,16L9,22L7.62,18L3.61,19.37L6.53,13.37C5.57,12.17 5,10.65 5,9A7,7 0 0,1 12,2A7,7 0 0,1 19,9C19,10.65 18.43,12.17 17.47,13.37L20.39,19.37M7,9L9.69,10.34L9.5,13.34L12,11.68L14.5,13.33L14.33,10.34L17,9L14.32,7.65L14.5,4.67L12,6.31L9.5,4.65L9.67,7.66L7,9Z";
var mdiSealVariant = "M17.71 6.15C17.46 5.38 16.79 5.21 16.45 4.77C16.14 4.31 16.18 3.62 15.53 3.15S14.23 2.92 13.7 2.77 12.81 2 12 2 10.82 2.58 10.3 2.77 9.13 2.67 8.47 3.15 7.86 4.31 7.55 4.77C7.21 5.21 6.55 5.38 6.29 6.15S6.5 7.45 6.5 8 6 9.08 6.29 9.85 7.21 10.79 7.55 11.23C7.86 11.69 7.82 12.38 8.47 12.85S9.77 13.08 10.3 13.23 11.19 14 12 14 13.18 13.42 13.7 13.23 14.87 13.33 15.53 12.85 16.14 11.69 16.45 11.23C16.79 10.79 17.45 10.62 17.71 9.85S17.5 8.55 17.5 8 18 6.92 17.71 6.15M12 12A4 4 0 1 1 16 8A4 4 0 0 1 12 12M14 8A2 2 0 1 1 12 6A2 2 0 0 1 14 8M13.71 15.56L13.08 19.16L12.35 23.29L9.74 20.8L6.44 22.25L7.77 14.75A4 4 0 0 0 9.66 15.17A4.15 4.15 0 0 0 11 15.85A3.32 3.32 0 0 0 12 16A3.5 3.5 0 0 0 13.71 15.56M17.92 18.78L15.34 17.86L15.85 14.92A3.2 3.2 0 0 0 16.7 14.47L16.82 14.37Z";
var mdiSearchWeb = "M15.5,14L20.5,19L19,20.5L14,15.5V14.71L13.73,14.43C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.43,13.73L14.71,14H15.5M9.5,4.5L8.95,4.53C8.71,5.05 8.34,5.93 8.07,7H10.93C10.66,5.93 10.29,5.05 10.05,4.53C9.87,4.5 9.69,4.5 9.5,4.5M13.83,7C13.24,5.97 12.29,5.17 11.15,4.78C11.39,5.31 11.7,6.08 11.93,7H13.83M5.17,7H7.07C7.3,6.08 7.61,5.31 7.85,4.78C6.71,5.17 5.76,5.97 5.17,7M4.5,9.5C4.5,10 4.58,10.53 4.73,11H6.87L6.75,9.5L6.87,8H4.73C4.58,8.47 4.5,9 4.5,9.5M14.27,11C14.42,10.53 14.5,10 14.5,9.5C14.5,9 14.42,8.47 14.27,8H12.13C12.21,8.5 12.25,9 12.25,9.5C12.25,10 12.21,10.5 12.13,11H14.27M7.87,8L7.75,9.5L7.87,11H11.13C11.21,10.5 11.25,10 11.25,9.5C11.25,9 11.21,8.5 11.13,8H7.87M9.5,14.5C9.68,14.5 9.86,14.5 10.03,14.47C10.28,13.95 10.66,13.07 10.93,12H8.07C8.34,13.07 8.72,13.95 8.97,14.47L9.5,14.5M13.83,12H11.93C11.7,12.92 11.39,13.69 11.15,14.22C12.29,13.83 13.24,13.03 13.83,12M5.17,12C5.76,13.03 6.71,13.83 7.85,14.22C7.61,13.69 7.3,12.92 7.07,12H5.17Z";
var mdiSeat = "M4,18V21H7V18H17V21H20V15H4V18M19,10H22V13H19V10M2,10H5V13H2V10M17,13H7V5A2,2 0 0,1 9,3H15A2,2 0 0,1 17,5V13Z";
var mdiSeatFlat = "M22,11V13H9V7H18A4,4 0 0,1 22,11M2,14V16H8V18H16V16H22V14M7.14,12.1C8.3,10.91 8.28,9 7.1,7.86C5.91,6.7 4,6.72 2.86,7.9C1.7,9.09 1.72,11 2.9,12.14C4.09,13.3 6,13.28 7.14,12.1Z";
var mdiSeatFlatAngled = "M22.25,14.29L21.56,16.18L9.2,11.71L11.28,6.05L19.84,9.14C21.94,9.9 23,12.2 22.25,14.29M1.5,12.14L8,14.5V19H16V17.37L20.5,19L21.21,17.11L2.19,10.25M7.3,10.2C8.79,9.5 9.42,7.69 8.71,6.2C8,4.71 6.2,4.08 4.7,4.8C3.21,5.5 2.58,7.3 3.3,8.8C4,10.29 5.8,10.92 7.3,10.2Z";
var mdiSeatIndividualSuite = "M7,13A3,3 0 0,0 10,10A3,3 0 0,0 7,7A3,3 0 0,0 4,10A3,3 0 0,0 7,13M19,7H11V14H3V7H1V17H23V11A4,4 0 0,0 19,7Z";
var mdiSeatLegroomExtra = "M4,12V3H2V12A5,5 0 0,0 7,17H13V15H7A3,3 0 0,1 4,12M22.83,17.24C22.45,16.5 21.54,16.27 20.8,16.61L19.71,17.11L16.3,10.13C15.96,9.45 15.27,9 14.5,9H11V3H5V11A3,3 0 0,0 8,14H15L18.41,21L22.13,19.3C22.9,18.94 23.23,18 22.83,17.24Z";
var mdiSeatLegroomNormal = "M5,12V3H3V12A5,5 0 0,0 8,17H14V15H8A3,3 0 0,1 5,12M20.5,18H19V11A2,2 0 0,0 17,9H12V3H6V11A3,3 0 0,0 9,14H16V21H20.5A1.5,1.5 0 0,0 22,19.5A1.5,1.5 0 0,0 20.5,18Z";
var mdiSeatLegroomReduced = "M19.97,19.2C20.15,20.16 19.42,21 18.5,21H14V18L15,14H9A3,3 0 0,1 6,11V3H12V9H17A2,2 0 0,1 19,11L17,18H18.44C19.17,18 19.83,18.5 19.97,19.2M5,12V3H3V12A5,5 0 0,0 8,17H12V15H8A3,3 0 0,1 5,12Z";
var mdiSeatOutline = "M15,5V12H9V5H15M15,3H9A2,2 0 0,0 7,5V14H17V5A2,2 0 0,0 15,3M22,10H19V13H22V10M5,10H2V13H5V10M20,15H4V21H6V17H18V21H20V15Z";
var mdiSeatPassenger = "M9 19H15V21H9C6.24 21 4 18.76 4 16V7H6V16C6 17.66 7.34 19 9 19M10.42 5.41C11.2 4.63 11.2 3.36 10.42 2.58C9.64 1.8 8.37 1.8 7.59 2.58C6.81 3.36 6.81 4.63 7.59 5.41C8.37 6.2 9.63 6.2 10.42 5.41M11.5 9C11.5 7.9 10.6 7 9.5 7H9C7.9 7 7 7.9 7 9V15C7 16.66 8.34 18 10 18H15.07L18.57 21.5L20 20.07L14.93 15H11.5L11.5 9Z";
var mdiSeatReclineExtra = "M5.35,5.64C4.45,5 4.23,3.76 4.86,2.85C5.5,1.95 6.74,1.73 7.65,2.36C8.55,3 8.77,4.24 8.14,5.15C7.5,6.05 6.26,6.27 5.35,5.64M16,19H8.93C7.45,19 6.19,17.92 5.97,16.46L4,7H2L4,16.76C4.37,19.2 6.47,21 8.94,21H16M16.23,15H11.35L10.32,10.9C11.9,11.79 13.6,12.44 15.47,12.12V10C13.84,10.3 12.03,9.72 10.78,8.74L9.14,7.47C8.91,7.29 8.65,7.17 8.38,7.09C8.06,7 7.72,6.97 7.39,7.03H7.37C6.14,7.25 5.32,8.42 5.53,9.64L6.88,15.56C7.16,17 8.39,18 9.83,18H16.68L20.5,21L22,19.5";
var mdiSeatReclineNormal = "M7.59,5.41C6.81,4.63 6.81,3.36 7.59,2.58C8.37,1.8 9.64,1.8 10.42,2.58C11.2,3.36 11.2,4.63 10.42,5.41C9.63,6.2 8.37,6.2 7.59,5.41M6,16V7H4V16A5,5 0 0,0 9,21H15V19H9A3,3 0 0,1 6,16M20,20.07L14.93,15H11.5V11.32C12.9,12.47 15.1,13.5 17,13.5V11.32C15.34,11.34 13.39,10.45 12.33,9.28L10.93,7.73C10.74,7.5 10.5,7.35 10.24,7.23C9.95,7.09 9.62,7 9.28,7H9.25C8,7 7,8 7,9.25V15A3,3 0 0,0 10,18H15.07L18.57,21.5";
var mdiSeatbelt = "M12,2C13.11,2 14,2.9 14,4C14,5.11 13.11,6 12,6A2,2 0 0,1 10,4A2,2 0 0,1 12,2M12.39,14.79C14.03,14.79 15.46,14.89 16.64,15.04C16.7,12.32 16.46,9.92 16,9C15.87,8.73 15.69,8.5 15.5,8.3L7.43,15.22C8.79,15 10.5,14.79 12.39,14.79M7.46,17C7.59,18.74 7.85,20.5 8.27,22H10.34C10.05,21.12 9.84,20.09 9.68,19C9.68,19 12,18.56 14.32,19C14.16,20.09 13.95,21.12 13.66,22H15.73C16.17,20.45 16.43,18.61 16.56,16.79C15.41,16.65 14,16.54 12.39,16.54C10.46,16.54 8.78,16.75 7.46,17M12,7C12,7 9,7 8,9C7.66,9.68 7.44,11.15 7.37,12.96L13.92,7.34C12.93,7 12,7 12,7M18.57,5.67L17.43,4.34L13.92,7.35C14.47,7.54 15.05,7.84 15.5,8.3L18.57,5.67M20.67,15.83C20.58,15.8 19.14,15.33 16.64,15.04C16.63,15.61 16.6,16.2 16.56,16.79C18.81,17.07 20.1,17.5 20.12,17.5L20.67,15.83M7.37,12.96L3.43,16.34L4.32,17.82C4.34,17.81 5.5,17.36 7.46,17C7.35,15.59 7.32,14.2 7.37,12.96Z";
var mdiSecurity = "M12,12H19C18.47,16.11 15.72,19.78 12,20.92V12H5V6.3L12,3.19M12,1L3,5V11C3,16.55 6.84,21.73 12,23C17.16,21.73 21,16.55 21,11V5L12,1Z";
var mdiSecurityNetwork = "M13,19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17.34C8.07,16.13 6,13 6,9.67V5.67L12,3L18,5.67V9.67C18,13 15.93,16.13 13,17.34V19M12,5L8,6.69V10H12V5M12,10V16C13.91,15.53 16,13.06 16,11V10H12Z";
var mdiSeed = "M20.7,3.3C20.7,3.3 19.3,3 17.2,3C11.7,3 1.6,5.1 3.2,20.8C4.3,20.9 5.4,21 6.4,21C24.3,21 20.7,3.3 20.7,3.3M7,17C7,17 7,7 17,7C17,7 11,9 7,17Z";
var mdiSeedOff = "M22.1 21.5L2.4 1.7L1.1 3L5.9 7.8C3.8 10.5 2.6 14.6 3.2 20.8C4.3 20.9 5.4 21 6.4 21C10.9 21 14.1 19.9 16.3 18.2L20.9 22.8L22.1 21.5M7 17C7 17 7 13.7 8.9 10.8L10.2 12.1C9.1 13.4 8 15 7 17M11.6 8.4L8.5 5.3C11.3 3.4 14.7 3 17.2 3C19.3 3 20.7 3.3 20.7 3.3S22.1 10.3 18.7 15.5L12.8 9.6C15.1 7.6 17 7 17 7C14.7 7 12.9 7.5 11.6 8.4Z";
var mdiSeedOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L5.9 7.8C3.8 10.5 2.6 14.6 3.2 20.8C4.3 20.9 5.4 21 6.4 21C10.9 21 14.1 19.9 16.3 18.2L20.9 22.8L22.1 21.5M6.4 19H5.1C4.9 14.8 5.6 11.5 7.3 9.2L8.9 10.8C7 13.7 7 17 7 17C8 15 9.1 13.4 10.2 12.1L14.8 16.7C12.8 18.2 10 19 6.4 19M10 6.8L8.5 5.3C11.3 3.4 14.7 3 17.2 3C19.3 3 20.7 3.3 20.7 3.3S22.1 10.3 18.7 15.5L17.2 14C19.1 10.9 19 7.1 18.9 5.1C18.4 5 17.8 5 17.2 5C15.1 5 12.3 5.3 10 6.8M12.8 9.6L11.6 8.4C12.9 7.5 14.7 7 17 7C17 7 15.1 7.6 12.8 9.6Z";
var mdiSeedOutline = "M17.2,5V5C17.8,5 18.4,5 18.9,5.1C19.1,7.4 19.1,12 16.4,15.2C14.4,17.7 11,19 6.4,19C6,19 5.5,19 5.1,19C4.9,14.4 5.8,10.8 7.9,8.5C10.4,5.6 14.4,5 17.2,5M17.2,3C11.7,3 1.6,5.1 3.2,20.8C4.3,20.9 5.4,21 6.4,21C24.3,21 20.7,3.3 20.7,3.3C20.7,3.3 19.3,3 17.2,3M17,7C7,7 7,17 7,17C11,9 17,7 17,7Z";
var mdiSeedPlus = "M17 17H14V19H17V22H19V19H22V17H19V14H17V17M12 18C12 14.69 14.69 12 18 12C18.77 12 19.5 12.15 20.17 12.41C21.63 7.9 20.7 3.3 20.7 3.3S19.3 3 17.2 3C11.7 3 1.6 5.1 3.2 20.8C4.3 20.9 5.4 21 6.4 21C8.76 21 10.74 20.69 12.41 20.15C12.15 19.5 12 18.76 12 18M7 17C7 17 7 7 17 7C17 7 11 9 7 17Z";
var mdiSeedPlusOutline = "M17.2 5C17.8 5 18.4 5 18.9 5.1C19.04 6.7 19.08 9.42 18.18 12C18.89 12 19.56 12.17 20.18 12.41C21.64 7.9 20.7 3.3 20.7 3.3S19.3 3 17.2 3C11.7 3 1.6 5.1 3.2 20.8C4.3 20.9 5.4 21 6.4 21C8.75 21 10.74 20.69 12.4 20.16C12.16 19.54 12 18.87 12 18.17C10.41 18.72 8.53 19 6.4 19H5.1C4.9 14.4 5.8 10.8 7.9 8.5C10.4 5.6 14.4 5 17.2 5M17 7C7 7 7 17 7 17C11 9 17 7 17 7M17 17H14V19H17V22H19V19H22V17H19V14H17V17Z";
var mdiSeesaw = "M21.68 13.26L22.04 15.23L2.35 18.77L2 16.8L4.95 16.27L4.6 14.3C4.5 13.76 4.86 13.24 5.41 13.14C5.95 13.04 6.47 13.4 6.57 13.95L6.92 15.91L16.76 14.15L16.41 12.18C16.31 11.63 16.67 11.11 17.22 11C17.76 10.92 18.28 11.28 18.38 11.82L18.73 13.79L21.68 13.26M10.06 18.4L8 22H16L13.58 17.77L10.06 18.4Z";
var mdiSegment = "M21,8H3V6H21M9,13H21V11H9M9,18H21V16H9";
var mdiSelect = "M4,3H5V5H3V4A1,1 0 0,1 4,3M20,3A1,1 0 0,1 21,4V5H19V3H20M15,5V3H17V5H15M11,5V3H13V5H11M7,5V3H9V5H7M21,20A1,1 0 0,1 20,21H19V19H21V20M15,21V19H17V21H15M11,21V19H13V21H11M7,21V19H9V21H7M4,21A1,1 0 0,1 3,20V19H5V21H4M3,15H5V17H3V15M21,15V17H19V15H21M3,11H5V13H3V11M21,11V13H19V11H21M3,7H5V9H3V7M21,7V9H19V7H21Z";
var mdiSelectAll = "M9,9H15V15H9M7,17H17V7H7M15,5H17V3H15M15,21H17V19H15M19,17H21V15H19M19,9H21V7H19M19,21A2,2 0 0,0 21,19H19M19,13H21V11H19M11,21H13V19H11M9,3H7V5H9M3,17H5V15H3M5,21V19H3A2,2 0 0,0 5,21M19,3V5H21A2,2 0 0,0 19,3M13,3H11V5H13M3,9H5V7H3M7,21H9V19H7M3,13H5V11H3M3,5H5V3A2,2 0 0,0 3,5Z";
var mdiSelectArrowDown = "M4 3H5V5H3V4C3 3.4 3.4 3 4 3M20 3C20.6 3 21 3.4 21 4V5H19V3H20M15 5V3H17V5H15M11 5V3H13V5H11M7 5V3H9V5H7M11 21V19H13V21H11M7 21V19H9V21H7M4 21C3.4 21 3 20.6 3 20V19H5V21H4M3 15H5V17H3V15M3 11H5V13H3V11M21 11V13H19V11H21M3 7H5V9H3V7M21 7V9H19V7H21M19 22L22 19H20V15H18V19H16L19 22Z";
var mdiSelectArrowUp = "M4 3H5V5H3V4C3 3.4 3.4 3 4 3M20 3C20.6 3 21 3.4 21 4V5H19V3H20M15 5V3H17V5H15M11 5V3H13V5H11M7 5V3H9V5H7M11 21V19H13V21H11M7 21V19H9V21H7M4 21C3.4 21 3 20.6 3 20V19H5V21H4M3 15H5V17H3V15M3 11H5V13H3V11M21 11V13H19V11H21M3 7H5V9H3V7M21 7V9H19V7H21M19 15L16 18H18V22H20V18H22L19 15Z";
var mdiSelectColor = "M3.88,3C3.38,3.06 3,3.5 3,4V4L3,5H4L5,5V4L5,3H4L3.88,3M7,3V5H9V3H7M11,3V5H13V3H11M15,3V5H17V3H15M19,3V4L19,5H20L21,5V4L21,3.88C20.94,3.38 20.5,3 20,3H19M3,7V9H5V7H3M19,7V9H21V7H19M3,11V13H5V11H3M19.31,12C19.18,12 19.05,12.05 18.95,12.14L17.39,13.71L16.43,12.75L15.72,13.46L16.43,14.17L11.97,18.63V21H14.35L18.8,16.54L19.5,17.25L20.22,16.54L19.26,15.58L20.82,14.03C21,13.83 21,13.5 20.82,13.31L19.65,12.14C19.56,12.05 19.44,12 19.31,12M3,15V17H5V15H3M17,15L17.97,15.97L13.93,20L12.97,19.04L17,15M3,19V20L3,20.12C3.06,20.62 3.5,21 4,21V21H5V20L5,19H4L3,19M7,19V21H9V19H7Z";
var mdiSelectCompare = "M13,23H11V1H13V23M9,19H5V5H9V3H5C3.89,3 3,3.89 3,5V19C3,20.11 3.9,21 5,21H9V19M19,7V9H21V7H19M19,5H21C21,3.89 20.1,3 19,3V5M21,15H19V17H21V15M19,11V13H21V11H19M17,3H15V5H17V3M19,21C20.11,21 21,20.11 21,19H19V21M17,19H15V21H17V19Z";
var mdiSelectDrag = "M13,17H17V13H19V17H23V19H19V23H17V19H13V17M11,17V19H9V17H11M7,17V19H5V17H7M19,9V11H17V9H19M19,5V7H17V5H19M15,5V7H13V5H15M11,5V7H9V5H11M7,5V7H5V5H7M7,13V15H5V13H7M7,9V11H5V9H7Z";
var mdiSelectGroup = "M5 3A2 2 0 0 0 3 5H5M7 3V5H9V3M11 3V5H13V3M15 3V5H17V3M19 3V5H21A2 2 0 0 0 19 3M3 7V9H5V7M7 7V11H11V7M13 7V11H17V7M19 7V9H21V7M3 11V13H5V11M19 11V13H21V11M7 13V17H11V13M13 13V17H17V13M3 15V17H5V15M19 15V17H21V15M3 19A2 2 0 0 0 5 21V19M7 19V21H9V19M11 19V21H13V19M15 19V21H17V19M19 19V21A2 2 0 0 0 21 19Z";
var mdiSelectInverse = "M5,3H7V5H9V3H11V5H13V3H15V5H17V3H19V5H21V7H19V9H21V11H19V13H21V15H19V17H21V19H19V21H17V19H15V21H13V19H11V21H9V19H7V21H5V19H3V17H5V15H3V13H5V11H3V9H5V7H3V5H5V3Z";
var mdiSelectMarker = "M4 3H5V5H3V4C3 3.45 3.45 3 4 3M20 3C20.55 3 21 3.45 21 4V5H19V3H20M15 5V3H17V5H15M11 5V3H13V5H11M7 5V3H9V5H7M11 21V19H13V21H11M7 21V19H9V21H7M4 21C3.45 21 3 20.55 3 20V19H5V21H4M3 15H5V17H3V15M3 11H5V13H3V11M3 7H5V9H3V7M21 7V9H19V7H21M19.5 13C21.4 13 23 14.6 23 16.5C23 19.1 19.5 23 19.5 23C19.5 23 16 19.1 16 16.5C16 14.6 17.6 13 19.5 13M19.5 17.8C20.2 17.8 20.8 17.2 20.7 16.6C20.7 16 20.1 15.4 19.5 15.4C18.9 15.4 18.3 15.9 18.3 16.6C18.3 17.2 18.8 17.8 19.5 17.8Z";
var mdiSelectMultiple = "M18 12H20V14H18V12M14 16H16V18H14V16M20 17C20 17.55 19.55 18 19 18H18V16H20V17M7 4H8V6H6V5C6 4.45 6.45 4 7 4M19 4C19.55 4 20 4.45 20 5V6H18V4H19M14 6V4H16V6H14M10 6V4H12V6H10M10 18V16H12V18H10M7 18C6.45 18 6 17.55 6 17V16H8V18H7M6 12H8V14H6V12M6 8H8V10H6V8M20 8V10H18V8H20M3 8H4V20H16V21C16 21.54 15.57 22 15.03 22H15L3 22C2.45 22 2 21.55 2 21V9C2 8.45 2.45 8 3 8Z";
var mdiSelectMultipleMarker = "M7 4H8V6H6V5C6 4.45 6.45 4 7 4M19 4C19.55 4 20 4.45 20 5V6H18V4H19M14 6V4H16V6H14M10 6V4H12V6H10M10 18V16H12V18H10M7 18C6.45 18 6 17.55 6 17V16H8V18H7M6 12H8V14H6V12M6 8H8V10H6V8M20 8V10H18V8H20M3 8H4V20H14.58L16.03 22L3 22C2.45 22 2 21.55 2 21V9C2 8.45 2.45 8 3 8M18.5 12C20.4 12 22 13.6 22 15.5C22 18.1 18.5 22 18.5 22C18.5 22 15 18.1 15 15.5C15 13.6 16.6 12 18.5 12M18.5 16.8C19.2 16.8 19.8 16.2 19.7 15.6C19.7 15 19.1 14.4 18.5 14.4C17.9 14.4 17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8Z";
var mdiSelectOff = "M1,4.27L2.28,3L21,21.72L19.73,23L17,20.27V21H15V19H15.73L5,8.27V9H3V7H3.73L1,4.27M20,3A1,1 0 0,1 21,4V5H19V3H20M15,5V3H17V5H15M11,5V3H13V5H11M7,5V3H9V5H7M11,21V19H13V21H11M7,21V19H9V21H7M4,21A1,1 0 0,1 3,20V19H5V21H4M3,15H5V17H3V15M21,15V17H19V15H21M3,11H5V13H3V11M21,11V13H19V11H21M21,7V9H19V7H21Z";
var mdiSelectPlace = "M4 3H5V5H3V4C3 3.5 3.5 3 4 3M20 3C20.5 3 21 3.5 21 4V5H19V3H20M15 5V3H17V5H15M11 5V3H13V5H11M7 5V3H9V5H7M21 12C21 12.5 20.5 13 20 13H19V11H21V12M15 13V11H17V13H15M11 13V11H13V13H11M7 13V11H9V13H7M4 13C3.5 13 3 12.5 3 12V11H5V13H4M3 7H5V9H3V7M21 7V9H19V7H21M7 16L12 21L17 16H7Z";
var mdiSelectRemove = "M21 20C21 20.55 20.55 21 20 21H19V19H21V20M15 21V19H17V21H15M11 21V19H13V21H11M7 21V19H9V21H7M4 21C3.45 21 3 20.55 3 20V19H5V21H4M3 15H5V17H3V15M21 15V17H19V15H21M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8M3 11H5V13H3V11M21 11V13H19V11H21M3 7H5V9H3V7M21 7V9H19V7H21M4 3H5V5H3V4C3 3.45 3.45 3 4 3M20 3C20.55 3 21 3.45 21 4V5H19V3H20M15 5V3H17V5H15M11 5V3H13V5H11M7 5V3H9V5H7Z";
var mdiSelectSearch = "M19.31 18.9C19.75 18.21 20 17.38 20 16.5C20 14 18 12 15.5 12S11 14 11 16.5 13 21 15.5 21C16.37 21 17.19 20.75 17.88 20.32L21 23.39L22.39 22L19.31 18.9M15.5 19C14.12 19 13 17.88 13 16.5S14.12 14 15.5 14 18 15.12 18 16.5 16.88 19 15.5 19M21 9H19V7H21V9M21 5H19V3H20C20.55 3 21 3.45 21 4V5M19 11.03V11H21V13H20.97C20.46 12.21 19.79 11.54 19 11.03M17 5H15V3H17V5M13 5H11V3H13V5M3 7H5V9H3V7M7 19H9V21H7V19M3 11H5V13H3V11M4 3H5V5H3V4C3 3.45 3.45 3 4 3M9 5H7V3H9V5M3 19H5V21H4C3.45 21 3 20.55 3 20V19M3 15H5V17H3V15Z";
var mdiSelection = "M2,4C2,2.89 2.9,2 4,2H7V4H4V7H2V4M22,4V7H20V4H17V2H20A2,2 0 0,1 22,4M20,20V17H22V20C22,21.11 21.1,22 20,22H17V20H20M2,20V17H4V20H7V22H4A2,2 0 0,1 2,20M10,2H14V4H10V2M10,20H14V22H10V20M20,10H22V14H20V10M2,10H4V14H2V10Z";
var mdiSelectionDrag = "M14,17H17V14H19V17H22V19H19V22H17V19H14V17M12,17V19H9V17H12M7,17V19H3V15H5V17H7M3,13V10H5V13H3M3,8V4H7V6H5V8H3M9,4H12V6H9V4M15,4H19V8H17V6H15V4M19,10V12H17V10H19Z";
var mdiSelectionEllipse = "M6.35,20.25L7.56,18.66C8.42,19.23 9.39,19.64 10.43,19.85L10.16,21.83C8.77,21.57 7.5,21 6.35,20.25M16.43,18.66L17.64,20.26C16.5,21.03 15.23,21.57 13.84,21.83L13.57,19.85C14.61,19.64 15.57,19.23 16.43,18.66M19.84,13.59L21.83,13.86C21.57,15.25 21,16.54 20.24,17.66L18.65,16.45C19.22,15.6 19.63,14.63 19.84,13.59M2.17,13.84L4.15,13.57C4.36,14.61 4.77,15.58 5.34,16.44L3.75,17.65C3,16.5 2.43,15.23 2.17,13.84M18.66,7.56L20.25,6.35C21.03,7.5 21.58,8.78 21.83,10.18L19.85,10.45C19.64,9.4 19.23,8.42 18.66,7.56M13.57,4.15L13.84,2.17C15.23,2.43 16.5,3 17.65,3.75L16.44,5.34C15.58,4.77 14.61,4.36 13.57,4.15M7.56,5.34L6.35,3.75C7.5,3 8.77,2.43 10.16,2.17L10.43,4.15C9.39,4.36 8.42,4.77 7.56,5.34M4.15,10.43L2.17,10.16C2.43,8.77 3,7.5 3.75,6.35L5.34,7.56C4.77,8.42 4.36,9.39 4.15,10.43Z";
var mdiSelectionEllipseArrowInside = "M11.2 4C9.94 4.12 8.72 4.53 7.64 5.2L6.64 3.47C7.95 2.64 9.45 2.13 11 2M17.53 6.25C16.62 5.39 15.53 4.73 14.34 4.33L15 2.39C16.5 2.84 17.89 3.66 19 4.78M5.34 7.41C4.64 8.44 4.19 9.6 4 10.83L2 10.55C2.2 9 2.79 7.5 3.7 6.23M22 12V12.66L20 12.5V12C20 10.92 19.81 9.86 19.39 8.86L21.22 8.06C21.75 9.31 22 10.65 22 12M6 17.3L4.5 18.61C3.47 17.43 2.72 16.04 2.3 14.53L4.17 14C4.53 15.22 5.16 16.35 6 17.3M12.14 22H12C10.5 22 9 21.68 7.64 21.07L8.53 19.24C9.62 19.75 10.8 20 12 20H12.19M17 21H15V15H21V17H18.42L21.14 19.76L19.73 21.17L17 18.5";
var mdiSelectionEllipseRemove = "M6.35 20.25L7.56 18.66C8.42 19.23 9.39 19.64 10.43 19.85L10.16 21.83C8.77 21.57 7.5 21 6.35 20.25M16.43 18.66L17.64 20.26C16.5 21.03 15.23 21.57 13.84 21.83L13.57 19.85C14.61 19.64 15.57 19.23 16.43 18.66M19.84 13.59L21.83 13.86C21.57 15.25 21 16.54 20.24 17.66L18.65 16.45C19.22 15.6 19.63 14.63 19.84 13.59M2.17 13.84L4.15 13.57C4.36 14.61 4.77 15.58 5.34 16.44L3.75 17.65C3 16.5 2.43 15.23 2.17 13.84M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8M18.66 7.56L20.25 6.35C21.03 7.5 21.58 8.78 21.83 10.18L19.85 10.45C19.64 9.4 19.23 8.42 18.66 7.56M4.15 10.43L2.17 10.16C2.43 8.77 3 7.5 3.75 6.35L5.34 7.56C4.77 8.42 4.36 9.39 4.15 10.43M13.57 4.15L13.84 2.17C15.23 2.43 16.5 3 17.65 3.75L16.44 5.34C15.58 4.77 14.61 4.36 13.57 4.15M7.56 5.34L6.35 3.75C7.5 3 8.77 2.43 10.16 2.17L10.43 4.15C9.39 4.36 8.42 4.77 7.56 5.34Z";
var mdiSelectionMarker = "M2 4C2 2.89 2.9 2 4 2H7V4H4V7H2V4M22 4V7H20V4H17V2H20C21.1 2 22 2.89 22 4M2 20V17H4V20H7V22H4C2.9 22 2 21.11 2 20M10 2H14V4H10V2M10 20H14V22H10V20M2 10H4V14H2V10M18.5 13C20.4 13 22 14.6 22 16.5C22 19.1 18.5 23 18.5 23C18.5 23 15 19.1 15 16.5C15 14.6 16.6 13 18.5 13M18.5 17.8C19.2 17.8 19.8 17.2 19.7 16.6C19.7 16 19.1 15.4 18.5 15.4C17.9 15.4 17.3 15.9 17.3 16.6C17.3 17.2 17.8 17.8 18.5 17.8M20 10H22V12.34C21.42 11.84 20.74 11.45 20 11.23V10Z";
var mdiSelectionMultiple = "M11 6V4H15V6H11M6 9H8V13H6V9M6 6C6 4.89 6.9 4 8 4H9V6H8V7H6V6M8 18C6.89 18 6 17.1 6 16V15H8V16H9V18H8M18 4C19.11 4 20 4.9 20 6V7H18V6H17V4H18M15 16V18H11V16H15M20 13H18V9H20V13M20 16C20 17.11 19.1 18 18 18H17V16H18V15H20V16M3 8H4V20H16V21C16 21.54 15.57 22 15.03 22H15L3 22C2.45 22 2 21.55 2 21V9C2 8.45 2.45 8 3 8Z";
var mdiSelectionMultipleMarker = "M7 4H9V6H8V7H6V5C6 4.45 6.45 4 7 4M19 4C19.55 4 20 4.45 20 5V7H18V6H17V4H19M11 6V4H15V6H11M7 18C6.45 18 6 17.55 6 17V15H8V16H9V18H7M6 9H8V13H6V9M3 8H4V20H14.58L16.03 22L3 22C2.45 22 2 21.55 2 21V9C2 8.45 2.45 8 3 8M18.5 12C20.4 12 22 13.6 22 15.5C22 18.1 18.5 22 18.5 22C18.5 22 15 18.1 15 15.5C15 13.6 16.6 12 18.5 12M18.5 16.8C19.2 16.8 19.8 16.2 19.7 15.6C19.7 15 19.1 14.4 18.5 14.4C17.9 14.4 17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8M11 18V16H13C13.09 16.66 13.27 17.33 13.5 18H11M20 9V10.23C19.5 10.08 19 10 18.5 10L18 10.03V9H20Z";
var mdiSelectionOff = "M0.5,3.77L1.78,2.5L21.5,22.22L20.23,23.5L18.73,22H17V20.27L3.73,7H2V5.27L0.5,3.77M4,2H7V4H5.82L3.83,2H4M22,4V7H20V4H17V2H20A2,2 0 0,1 22,4M20,17H22V20L22,20.17L20,18.18V17M2,20V17H4V20H7V22H4A2,2 0 0,1 2,20M10,2H14V4H10V2M10,20H14V22H10V20M20,10H22V14H20V10M2,10H4V14H2V10Z";
var mdiSelectionRemove = "M20 20V17H22V20C22 21.11 21.1 22 20 22H17V20H20M2 20V17H4V20H7V22H4C2.9 22 2 21.1 2 20M10 20H14V22H10V20M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8M20 10H22V14H20V10M2 10H4V14H2V10M2 4C2 2.89 2.9 2 4 2H7V4H4V7H2V4M22 4V7H20V4H17V2H20C21.1 2 22 2.9 22 4M10 2H14V4H10V2Z";
var mdiSelectionSearch = "M19.27 18.9C19.7 18.21 19.95 17.38 19.95 16.5C19.95 14 17.95 12 15.46 12S10.96 14 10.96 16.5 12.96 21 15.46 21C16.33 21 17.15 20.75 17.84 20.32L20.96 23.39L22.35 22L19.27 18.9M15.46 19C14.07 19 12.96 17.88 12.96 16.5S14.07 14 15.46 14 17.95 15.12 17.95 16.5 16.84 19 15.46 19M22 14H21.45C21.12 13.19 20.62 12.47 20 11.86V10H22V14M20 4H17V2H20C21.11 2 22 2.9 22 4V7H20V4M14 4H10V2H14V4M4 2H7V4H4V7H2V4C2 2.89 2.9 2 4 2M12 22H10V20C10.5 20.82 11.2 21.5 12 22M4 20H7V22H4C2.9 22 2 21.11 2 20V17H4V20M4 14H2V10H4V14Z";
var mdiSemanticWeb = "M12.9 4.22C18.73 6.84 20 2 20 2S18.89 8.07 13.79 10.55C12.75 11.06 12.1 11.33 12.1 11.33L3.73 7.25L12.1 3.82C12.1 3.82 11.9 3.76 12.9 4.22M11.12 22L3.33 17.78V9.07L11.12 13.04V22M12.88 22L20.68 17.78V9.07L12.88 13.04V22Z";
var mdiSend = "M2,21L23,12L2,3V10L17,12L2,14V21Z";
var mdiSendCheck = "M2 3V10L17 12L2 14V21L23 12M22 15.5L18.5 19L16.5 17L15 18.5L18.5 22L23.5 17Z";
var mdiSendCheckOutline = "M2 3V10L17 12L2 14V21L23 12M4 6.03L11.53 9.25L4 8.25M11.53 14.75L4 17.97V15.75M22 15.5L18.5 19L16.5 17L15 18.5L18.5 22L23.5 17Z";
var mdiSendCircle = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M8,7.71V11.05L15.14,12L8,12.95V16.29L18,12L8,7.71Z";
var mdiSendCircleOutline = "M8,7.71L18,12L8,16.29V12.95L15.14,12L8,11.05V7.71M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiSendClock = "M2 3V10L11 12L2 14V21L9.27 17.89A7 7 0 0 0 16 23A7 7 0 0 0 23 16A7 7 0 0 0 16 9L2 3M16 11A5 5 0 0 1 21 16A5 5 0 0 1 16 21A5 5 0 0 1 11 16A5 5 0 0 1 16 11M15 12.5V16.5L18 18.5L18.75 17.25L16.5 15.75V12.5H15Z";
var mdiSendClockOutline = "M2 3V10L11 12L2 14V21L9.27 17.89A7 7 0 0 0 16 23A7 7 0 0 0 23 16A7 7 0 0 0 16 9L2 3M4 6.03L12.78 9.8A7 7 0 0 0 12.1 10.2L4 8.4V6.03M16 11A5 5 0 0 1 21 16A5 5 0 0 1 16 21A5 5 0 0 1 11 16A5 5 0 0 1 16 11M15 12.5V16.5L18 18.5L18.75 17.25L16.5 15.75V12.5H15M9.18 14.45A7 7 0 0 0 9 15.82L4 17.97V15.6L9.18 14.45Z";
var mdiSendLock = "M23,18V17.5A2.5,2.5 0 0,0 20.5,15A2.5,2.5 0 0,0 18,17.5V18A1,1 0 0,0 17,19V23A1,1 0 0,0 18,24H23A1,1 0 0,0 24,23V19A1,1 0 0,0 23,18M22,18H19V17.5A1.5,1.5 0 0,1 20.5,16A1.5,1.5 0 0,1 22,17.5V18M23,12L2,21V14L17,12L2,10V3L23,12Z";
var mdiSendLockOutline = "M23 18V17.5C23 16.12 21.88 15 20.5 15S18 16.12 18 17.5V18C17.45 18 17 18.45 17 19V23C17 23.55 17.45 24 18 24H23C23.55 24 24 23.55 24 23V19C24 18.45 23.55 18 23 18M22 18H19V17.5C19 16.67 19.67 16 20.5 16S22 16.67 22 17.5V18M4 6.03L11.5 9.25L4 8.25L4 6.03M11.5 14.75L4 17.97V15.75L11.5 14.75M2 3L2 10L17 12L2 14L2 21L23 12L2 3Z";
var mdiSendOutline = "M4 6.03L11.5 9.25L4 8.25L4 6.03M11.5 14.75L4 17.97V15.75L11.5 14.75M2 3L2 10L17 12L2 14L2 21L23 12L2 3Z";
var mdiSendVariant = "M3 20V14L11 12L3 10V4L22 12Z";
var mdiSendVariantClock = "M15 16.69V13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69M3 20V14L10.11 12.22C10.19 12.09 10.28 11.97 10.37 11.84L3 10V4L15.03 9.07C15.35 9 15.67 9 16 9C17.86 9 19.64 9.74 20.95 11.05C21.2 11.3 21.43 11.57 21.63 11.85L22 12L21.8 12.08C22.58 13.23 23 14.59 23 16C23 19.87 19.86 23 16 23C14.14 23 12.36 22.26 11.05 20.95C10.08 20 9.42 18.74 9.14 17.41L3 20M20.85 16C20.85 13.32 18.67 11.15 16 11.15C14.71 11.15 13.5 11.66 12.57 12.57C11.66 13.5 11.15 14.71 11.15 16C11.15 18.68 13.32 20.85 16 20.85C16.64 20.85 17.27 20.73 17.86 20.5C18.44 20.24 19 19.88 19.43 19.43C19.88 19 20.24 18.44 20.5 17.86C20.73 17.27 20.85 16.64 20.85 16Z";
var mdiSendVariantClockOutline = "M15 16.69V13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69M21.63 11.85L22 12L21.8 12.08C22.58 13.23 23 14.59 23 16C23 19.87 19.86 23 16 23C14.14 23 12.36 22.26 11.05 20.95C10.08 20 9.42 18.74 9.14 17.41L3 20V4L15.03 9.07C15.35 9 15.67 9 16 9C17.86 9 19.64 9.74 20.95 11.05C21.2 11.3 21.43 11.57 21.63 11.85M12.28 10.07L5 7V10.5L10.37 11.84C10.89 11.14 11.54 10.54 12.28 10.07M10.11 12.22L5 13.5V17L9.04 15.3C9.15 14.17 9.53 13.13 10.11 12.22M20.85 16C20.85 13.32 18.67 11.15 16 11.15C14.71 11.15 13.5 11.66 12.57 12.57C11.66 13.5 11.15 14.71 11.15 16C11.15 18.68 13.32 20.85 16 20.85C16.64 20.85 17.27 20.73 17.86 20.5C18.44 20.24 19 19.88 19.43 19.43C19.88 19 20.24 18.44 20.5 17.86C20.73 17.27 20.85 16.64 20.85 16Z";
var mdiSendVariantOutline = "M3 20V4L22 12M5 17L16.85 12L5 7V10.5L11 12L5 13.5M5 17V7 13.5Z";
var mdiSerialPort = "M7,3H17V5H19V8H16V14H8V8H5V5H7V3M17,9H19V14H17V9M11,15H13V22H11V15M5,9H7V14H5V9Z";
var mdiServer = "M4,1H20A1,1 0 0,1 21,2V6A1,1 0 0,1 20,7H4A1,1 0 0,1 3,6V2A1,1 0 0,1 4,1M4,9H20A1,1 0 0,1 21,10V14A1,1 0 0,1 20,15H4A1,1 0 0,1 3,14V10A1,1 0 0,1 4,9M4,17H20A1,1 0 0,1 21,18V22A1,1 0 0,1 20,23H4A1,1 0 0,1 3,22V18A1,1 0 0,1 4,17M9,5H10V3H9V5M9,13H10V11H9V13M9,21H10V19H9V21M5,3V5H7V3H5M5,11V13H7V11H5M5,19V21H7V19H5Z";
var mdiServerMinus = "M4,4H20A1,1 0 0,1 21,5V9A1,1 0 0,1 20,10H4A1,1 0 0,1 3,9V5A1,1 0 0,1 4,4M9,8H10V6H9V8M5,6V8H7V6H5M8,16H16V18H8V16Z";
var mdiServerMinusOutline = "M8 17H16V19H8V17M2 5.6V10.4C2 11.3 2.5 12 3.2 12H20.9C21.5 12 22.1 11.3 22.1 10.4V5.6C22 4.7 21.5 4 20.8 4H3.2C2.5 4 2 4.7 2 5.6M10 9V7H9V9H10M5 9H7V7H5V9M20 10H4V6H20V10Z";
var mdiServerNetwork = "M13,19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H4A1,1 0 0,1 3,16V12A1,1 0 0,1 4,11H20A1,1 0 0,1 21,12V16A1,1 0 0,1 20,17H13V19M4,3H20A1,1 0 0,1 21,4V8A1,1 0 0,1 20,9H4A1,1 0 0,1 3,8V4A1,1 0 0,1 4,3M9,7H10V5H9V7M9,15H10V13H9V15M5,5V7H7V5H5M5,13V15H7V13H5Z";
var mdiServerNetworkOff = "M13,19H14A1,1 0 0,1 15,20H15.73L13,17.27V19M22,20V21.18L20.82,20H22M21,22.72L19.73,24L17.73,22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H4A1,1 0 0,1 3,16V12A1,1 0 0,1 4,11H6.73L4.73,9H4A1,1 0 0,1 3,8V7.27L1,5.27L2.28,4L21,22.72M4,3H20A1,1 0 0,1 21,4V8A1,1 0 0,1 20,9H9.82L7,6.18V5H5.82L3.84,3C3.89,3 3.94,3 4,3M20,11A1,1 0 0,1 21,12V16A1,1 0 0,1 20,17H17.82L11.82,11H20M9,7H10V5H9V7M9,15H10V14.27L9,13.27V15M5,13V15H7V13H5Z";
var mdiServerNetworkOutline = "M13 13V15H14C14.6 15 15 15.4 15 16H22V18H15C15 18.6 14.6 19 14 19H10C9.4 19 9 18.6 9 18H2V16H9C9 15.4 9.4 15 10 15H11V13H3.2C2.5 13 2 12.3 2 11.4V6.6C2 5.7 2.5 5 3.2 5H20.8C21.5 5 22 5.7 22 6.6V11.4C22 12.3 21.5 13 20.8 13H13M9 10V8H10V10H9M5 8H7V10H5V8M20 7H4V11H20V7Z";
var mdiServerOff = "M4,1H20A1,1 0 0,1 21,2V6A1,1 0 0,1 20,7H8.82L6.82,5H7V3H5V3.18L3.21,1.39C3.39,1.15 3.68,1 4,1M22,22.72L20.73,24L19.73,23H4A1,1 0 0,1 3,22V18A1,1 0 0,1 4,17H13.73L11.73,15H4A1,1 0 0,1 3,14V10A1,1 0 0,1 4,9H5.73L3.68,6.95C3.38,6.85 3.15,6.62 3.05,6.32L1,4.27L2.28,3L22,22.72M20,9A1,1 0 0,1 21,10V14A1,1 0 0,1 20,15H16.82L10.82,9H20M20,17A1,1 0 0,1 21,18V19.18L18.82,17H20M9,5H10V3H9V5M9,13H9.73L9,12.27V13M9,21H10V19H9V21M5,11V13H7V11H5M5,19V21H7V19H5Z";
var mdiServerOutline = "M2 4.6V9.4C2 10.3 2.5 11 3.2 11H20.9C21.5 11 22.1 10.3 22.1 9.4V4.6C22 3.7 21.5 3 20.8 3H3.2C2.5 3 2 3.7 2 4.6M10 8V6H9V8H10M5 8H7V6H5V8M20 9H4V5H20V9M2 14.6V19.4C2 20.3 2.5 21 3.2 21H20.9C21.5 21 22.1 20.3 22.1 19.4V14.6C22.1 13.7 21.6 13 20.9 13H3.2C2.5 13 2 13.7 2 14.6M10 18V16H9V18H10M5 18H7V16H5V18M20 19H4V15H20V19Z";
var mdiServerPlus = "M4,4H20A1,1 0 0,1 21,5V9A1,1 0 0,1 20,10H4A1,1 0 0,1 3,9V5A1,1 0 0,1 4,4M9,8H10V6H9V8M5,6V8H7V6H5M8,16H11V13H13V16H16V18H13V21H11V18H8V16Z";
var mdiServerPlusOutline = "M2 4.6V9.4C2 10.3 2.5 11 3.2 11H20.9C21.5 11 22.1 10.3 22.1 9.4V4.6C22 3.7 21.5 3 20.8 3H3.2C2.5 3 2 3.7 2 4.6M10 8V6H9V8H10M5 8H7V6H5V8M20 9H4V5H20V9M8 16H11V13H13V16H16V18H13V21H11V18H8V16Z";
var mdiServerRemove = "M4,4H20A1,1 0 0,1 21,5V9A1,1 0 0,1 20,10H4A1,1 0 0,1 3,9V5A1,1 0 0,1 4,4M9,8H10V6H9V8M5,6V8H7V6H5M10.59,17L8,14.41L9.41,13L12,15.59L14.59,13L16,14.41L13.41,17L16,19.59L14.59,21L12,18.41L9.41,21L8,19.59L10.59,17Z";
var mdiServerSecurity = "M3,1H19A1,1 0 0,1 20,2V6A1,1 0 0,1 19,7H3A1,1 0 0,1 2,6V2A1,1 0 0,1 3,1M3,9H19A1,1 0 0,1 20,10V10.67L17.5,9.56L11,12.44V15H3A1,1 0 0,1 2,14V10A1,1 0 0,1 3,9M3,17H11C11.06,19.25 12,21.4 13.46,23H3A1,1 0 0,1 2,22V18A1,1 0 0,1 3,17M8,5H9V3H8V5M8,13H9V11H8V13M8,21H9V19H8V21M4,3V5H6V3H4M4,11V13H6V11H4M4,19V21H6V19H4M17.5,12L22,14V17C22,19.78 20.08,22.37 17.5,23C14.92,22.37 13,19.78 13,17V14L17.5,12M17.5,13.94L15,15.06V17.72C15,19.26 16.07,20.7 17.5,21.06V13.94Z";
var mdiSetAll = "M9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5A7,7 0 0,1 22,12A7,7 0 0,1 15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19A7,7 0 0,1 2,12A7,7 0 0,1 9,5M8.5,12C8.5,13.87 9.29,15.56 10.56,16.75L11.56,16.29C10.31,15.29 9.5,13.74 9.5,12C9.5,10.26 10.31,8.71 11.56,7.71L10.56,7.25C9.29,8.44 8.5,10.13 8.5,12M15.5,12C15.5,10.13 14.71,8.44 13.44,7.25L12.44,7.71C13.69,8.71 14.5,10.26 14.5,12C14.5,13.74 13.69,15.29 12.44,16.29L13.44,16.75C14.71,15.56 15.5,13.87 15.5,12Z";
var mdiSetCenter = "M9,5A7,7 0 0,0 2,12A7,7 0 0,0 9,19C10.04,19 11.06,18.76 12,18.32C12.94,18.76 13.96,19 15,19A7,7 0 0,0 22,12A7,7 0 0,0 15,5C13.96,5 12.94,5.24 12,5.68C11.06,5.24 10.04,5 9,5M9,7C9.34,7 9.67,7.03 10,7.1C8.72,8.41 8,10.17 8,12C8,13.83 8.72,15.59 10,16.89C9.67,16.96 9.34,17 9,17A5,5 0 0,1 4,12A5,5 0 0,1 9,7M15,7A5,5 0 0,1 20,12A5,5 0 0,1 15,17C14.66,17 14.33,16.97 14,16.9C15.28,15.59 16,13.83 16,12C16,10.17 15.28,8.41 14,7.11C14.33,7.04 14.66,7 15,7Z";
var mdiSetCenterRight = "M15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19A7,7 0 0,1 2,12A7,7 0 0,1 9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5A7,7 0 0,1 22,12A7,7 0 0,1 15,19M9,17L10,16.89C8.72,15.59 8,13.83 8,12C8,10.17 8.72,8.41 10,7.1L9,7A5,5 0 0,0 4,12A5,5 0 0,0 9,17M15.5,12C15.5,10.13 14.71,8.44 13.44,7.25L12.44,7.71C13.69,8.71 14.5,10.26 14.5,12C14.5,13.74 13.69,15.29 12.44,16.29L13.44,16.75C14.71,15.56 15.5,13.87 15.5,12Z";
var mdiSetLeft = "M9,5A7,7 0 0,0 2,12A7,7 0 0,0 9,19C10.04,19 11.06,18.76 12,18.32C12.94,18.76 13.96,19 15,19A7,7 0 0,0 22,12A7,7 0 0,0 15,5C13.96,5 12.94,5.24 12,5.68C11.06,5.24 10.04,5 9,5M15,7A5,5 0 0,1 20,12A5,5 0 0,1 15,17C14.66,17 14.33,16.97 14,16.9C15.28,15.59 16,13.83 16,12C16,10.17 15.28,8.41 14,7.11C14.33,7.04 14.66,7 15,7M12,8C13.26,8.95 14,10.43 14,12C14,13.57 13.26,15.05 12,16C10.74,15.05 10,13.57 10,12C10,10.43 10.74,8.95 12,8Z";
var mdiSetLeftCenter = "M9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5A7,7 0 0,1 22,12A7,7 0 0,1 15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19A7,7 0 0,1 2,12A7,7 0 0,1 9,5M15,7L14,7.11C15.28,8.41 16,10.17 16,12C16,13.83 15.28,15.59 14,16.9L15,17A5,5 0 0,0 20,12A5,5 0 0,0 15,7M8.5,12C8.5,13.87 9.29,15.56 10.56,16.75L11.56,16.29C10.31,15.29 9.5,13.74 9.5,12C9.5,10.26 10.31,8.71 11.56,7.71L10.56,7.25C9.29,8.44 8.5,10.13 8.5,12Z";
var mdiSetLeftRight = "M9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5A7,7 0 0,1 22,12A7,7 0 0,1 15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19A7,7 0 0,1 2,12A7,7 0 0,1 9,5M9,12C9,14.22 10.21,16.16 12,17.2C13.79,16.16 15,14.22 15,12C15,9.78 13.79,7.84 12,6.8C10.21,7.84 9,9.78 9,12Z";
var mdiSetMerge = "M2 7V9H7V7H2M12 9V11H9V13H12V15L15 12L12 9M17 9V15H22V9H17M2 11V13H7V11H2M2 15V17H7V15H2Z";
var mdiSetNone = "M9,5A7,7 0 0,0 2,12A7,7 0 0,0 9,19C10.04,19 11.06,18.76 12,18.32C12.94,18.76 13.96,19 15,19A7,7 0 0,0 22,12A7,7 0 0,0 15,5C13.96,5 12.94,5.24 12,5.68C11.06,5.24 10.04,5 9,5M9,7C9.34,7 9.67,7.03 10,7.1C8.72,8.41 8,10.17 8,12C8,13.83 8.72,15.59 10,16.89C9.67,16.96 9.34,17 9,17A5,5 0 0,1 4,12A5,5 0 0,1 9,7M15,7A5,5 0 0,1 20,12A5,5 0 0,1 15,17C14.66,17 14.33,16.97 14,16.9C15.28,15.59 16,13.83 16,12C16,10.17 15.28,8.41 14,7.11C14.33,7.04 14.66,7 15,7M12,8C13.26,8.95 14,10.43 14,12C14,13.57 13.26,15.05 12,16C10.74,15.05 10,13.57 10,12C10,10.43 10.74,8.95 12,8Z";
var mdiSetRight = "M15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19A7,7 0 0,1 2,12A7,7 0 0,1 9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5A7,7 0 0,1 22,12A7,7 0 0,1 15,19M9,17L10,16.89C8.72,15.59 8,13.83 8,12C8,10.17 8.72,8.41 10,7.1L9,7A5,5 0 0,0 4,12A5,5 0 0,0 9,17M12,16C13.26,15.05 14,13.57 14,12C14,10.43 13.26,8.95 12,8C10.74,8.95 10,10.43 10,12C10,13.57 10.74,15.05 12,16Z";
var mdiSetSplit = "M17 7V9H22V7H17M2 9V15H7V9H2M12 9V11H9V13H12V15L15 12L12 9M17 11V13H22V11H17M17 15V17H22V15H17Z";
var mdiSetSquare = "M17.7 17.7L16.6 18.8L15.9 18L17 17L15 15L14 16.1L13.3 15.4L14.4 14.3L12.5 12.4L11.4 13.5L10.7 12.8L11.8 11.7L9.8 9.8L8.7 10.9L8 10.2L9 9L7.1 7.1L6 8.1L5.3 7.4L6.4 6.3L4 4V20H20L17.7 17.7M7 17V11.2L12.8 17H7Z";
var mdiSetTopBox = "M5,15.5A0.5,0.5 0 0,1 4.5,16H3.5A0.5,0.5 0 0,1 3,15.5V15H2A1,1 0 0,1 1,14V11A1,1 0 0,1 2,10H22A1,1 0 0,1 23,11V14A1,1 0 0,1 22,15H21V15.5A0.5,0.5 0 0,1 20.5,16H19.5A0.5,0.5 0 0,1 19,15.5V15H5V15.5M3,12V13H5V12H3M6,12V13H8V12H6M20.5,11.5A1,1 0 0,0 19.5,12.5A1,1 0 0,0 20.5,13.5A1,1 0 0,0 21.5,12.5A1,1 0 0,0 20.5,11.5Z";
var mdiSettingsHelper = "M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z";
var mdiShaker = "M7 16C7 16.55 6.55 17 6 17S5 16.55 5 16C5 15.45 5.45 15 6 15S7 15.45 7 16M9 16C8.45 16 8 16.45 8 17S8.45 18 9 18 10 17.55 10 17 9.55 16 9 16M4 18C3.45 18 3 18.45 3 19S3.45 20 4 20 5 19.55 5 19 4.55 18 4 18M7 19C6.45 19 6 19.45 6 20S6.45 21 7 21 8 20.55 8 20 7.55 19 7 19M15.33 2.72L9.8 9.65L13.34 13.19L20.28 7.67C21.18 6.91 21.25 5.54 20.41 4.7L18.3 2.59C17.46 1.75 16.09 1.82 15.33 2.72M8.39 12.5L10.5 14.6C10.9 15 11.54 15 11.93 14.6L12.63 13.9L9.1 10.36L8.39 11.07C8 11.46 8 12.09 8.39 12.5Z";
var mdiShakerOutline = "M16.88 4L16.88 4L19.03 6.1L13.5 10.5L12.5 9.5L16.87 4L16.88 4M16.88 2C16.3 2 15.73 2.24 15.33 2.72L9.8 9.65L13.34 13.19L20.28 7.67C21.18 6.91 21.25 5.54 20.41 4.7L18.3 2.59C17.9 2.19 17.39 2 16.88 2M9.1 10.36L8.39 11.07C8 11.46 8 12.09 8.39 12.5L10.5 14.6C10.71 14.8 10.96 14.89 11.22 14.89S11.73 14.8 11.93 14.6L12.63 13.9L9.1 10.36M6 15C5.45 15 5 15.45 5 16C5 16.55 5.45 17 6 17C6.55 17 7 16.55 7 16C7 15.45 6.55 15 6 15M9 16C8.45 16 8 16.45 8 17S8.45 18 9 18C9.55 18 10 17.55 10 17S9.55 16 9 16M4 18C3.45 18 3 18.45 3 19S3.45 20 4 20C4.55 20 5 19.55 5 19S4.55 18 4 18M7 19C6.45 19 6 19.45 6 20S6.45 21 7 21C7.55 21 8 20.55 8 20S7.55 19 7 19Z";
var mdiShape = "M11,13.5V21.5H3V13.5H11M12,2L17.5,11H6.5L12,2M17.5,13C20,13 22,15 22,17.5C22,20 20,22 17.5,22C15,22 13,20 13,17.5C13,15 15,13 17.5,13Z";
var mdiShapeCirclePlus = "M11,19A6,6 0 0,0 17,13H19A8,8 0 0,1 11,21A8,8 0 0,1 3,13A8,8 0 0,1 11,5V7A6,6 0 0,0 5,13A6,6 0 0,0 11,19M19,5H22V7H19V10H17V7H14V5H17V2H19V5Z";
var mdiShapeOutline = "M11,13.5V21.5H3V13.5H11M9,15.5H5V19.5H9V15.5M12,2L17.5,11H6.5L12,2M12,5.86L10.08,9H13.92L12,5.86M17.5,13C20,13 22,15 22,17.5C22,20 20,22 17.5,22C15,22 13,20 13,17.5C13,15 15,13 17.5,13M17.5,15A2.5,2.5 0 0,0 15,17.5A2.5,2.5 0 0,0 17.5,20A2.5,2.5 0 0,0 20,17.5A2.5,2.5 0 0,0 17.5,15Z";
var mdiShapeOvalPlus = "M19 5H22V7H19V10H17V7H14V5H17V2H19V5M11 4L12 4.09V6.14C11.68 6.05 11.34 6 11 6C8.24 6 6 9.13 6 13C6 16.87 8.24 20 11 20C13.76 20 16 16.87 16 13L15.95 12H17.96L18 13C18 17.97 14.87 22 11 22C7.13 22 4 17.97 4 13C4 8.03 7.13 4 11 4Z";
var mdiShapePlus = "M2,2H11V11H2V2M17.5,2C20,2 22,4 22,6.5C22,9 20,11 17.5,11C15,11 13,9 13,6.5C13,4 15,2 17.5,2M6.5,14L11,22H2L6.5,14M19,17H22V19H19V22H17V19H14V17H17V14H19V17Z";
var mdiShapePlusOutline = "M11 11V2H2V11M4 9V4H9V9M20 6.5C20 7.9 18.9 9 17.5 9S15 7.9 15 6.5 16.11 4 17.5 4 20 5.11 20 6.5M6.5 14L2 22H11M7.58 20H5.42L6.5 18.08M22 6.5C22 4 20 2 17.5 2S13 4 13 6.5 15 11 17.5 11 22 9 22 6.5M19 17V14H17V17H14V19H17V22H19V19H22V17Z";
var mdiShapePolygonPlus = "M17,15.7V13H19V17L10,21L3,14L7,5H11V7H8.3L5.4,13.6L10.4,18.6L17,15.7M22,5V7H19V10H17V7H14V5H17V2H19V5H22Z";
var mdiShapeRectanglePlus = "M19,6H22V8H19V11H17V8H14V6H17V3H19V6M17,17V14H19V19H3V6H11V8H5V17H17Z";
var mdiShapeSquarePlus = "M19,5H22V7H19V10H17V7H14V5H17V2H19V5M17,19V13H19V21H3V5H11V7H5V19H17Z";
var mdiShapeSquareRoundedPlus = "M17 2H19V5H22V7H19V10H17V7H14V5H17V2M7 5H11V7H7C5.9 7 5 7.9 5 9V17C5 18.11 5.9 19 7 19H15C16.11 19 17 18.11 17 17V13H19V17C19 19.21 17.21 21 15 21H7C4.79 21 3 19.21 3 17V9C3 6.79 4.79 5 7 5Z";
var mdiShare = "M21,12L14,5V9C7,10 4,15 3,20C5.5,16.5 9,14.9 14,14.9V19L21,12Z";
var mdiShareAll = "M11 9V5L18 12L11 19V14.9C6 14.9 2.5 16.5 0 20C1 15 4 10 11 9M17 8V5L24 12L17 19V16L21 12L17 8Z";
var mdiShareAllOutline = "M13 9.8V10.7L11.3 10.9C8.7 11.3 6.8 12.3 5.4 13.6C7.1 13.1 8.9 12.8 11 12.8H13V14.1L15.2 12L13 9.8M11 5L18 12L11 19V14.9C6 14.9 2.5 16.5 0 20C1 15 4 10 11 9M17 8V5L24 12L17 19V16L21 12";
var mdiShareCircle = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M14 16V13C10.39 13 7.81 14.43 6 17C6.72 13.33 8.94 9.73 14 9V6L19 11L14 16Z";
var mdiShareOff = "M20.8 22.7L15.6 17.5L14 19V15.9L13.1 14.9C8.6 15.2 5.4 16.8 3 20.1C3.58 16.31 5.72 12.94 8.9 10.8L1.1 3L2.4 1.7L22.1 21.5M18.1 14.9L21 12L14 5V9L12.5 9.3";
var mdiShareOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L8.9 10.8C5.4 12.9 3.7 16.4 3 20C5.3 16.7 8.6 15.1 13 14.9L14 15.9V19L15.6 17.4L20.8 22.7M8.3 13.8C8.94 13.22 9.65 12.71 10.4 12.3L11.3 13.1M14.2 11L12.5 9.3L14 9V5L21 12L18.1 14.9L16.7 13.5L18.2 12L16 9.8V10.7";
var mdiShareOutline = "M14,5V9C7,10 4,15 3,20C5.5,16.5 9,14.9 14,14.9V19L21,12L14,5M16,9.83L18.17,12L16,14.17V12.9H14C11.93,12.9 10.07,13.28 8.34,13.85C9.74,12.46 11.54,11.37 14.28,11L16,10.73V9.83Z";
var mdiShareVariant = "M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8A3,3 0 0,0 21,5A3,3 0 0,0 18,2A3,3 0 0,0 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,9 6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,20.61 20.92,19A2.92,2.92 0 0,0 18,16.08Z";
var mdiShareVariantOutline = "M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12S8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5S19.66 2 18 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12S4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.34C15.11 18.55 15.08 18.77 15.08 19C15.08 20.61 16.39 21.91 18 21.91S20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08M18 4C18.55 4 19 4.45 19 5S18.55 6 18 6 17 5.55 17 5 17.45 4 18 4M6 13C5.45 13 5 12.55 5 12S5.45 11 6 11 7 11.45 7 12 6.55 13 6 13M18 20C17.45 20 17 19.55 17 19S17.45 18 18 18 19 18.45 19 19 18.55 20 18 20Z";
var mdiShark = "M15.56 9.09C14.66 7.18 12.54 6 11 6C11.47 7.4 11.28 8.57 10.95 9.43C8.45 10 6 11 6 11S3 7 1 7L3 13L2 17C4 17 6 14 6 14S11 16 14 16V18C14.65 18 15.91 17.17 16.73 15.77C17.97 15.56 19 15.21 19.87 14.81C19.72 14.63 19.53 14.44 19.28 14.3C18.63 13.91 17.82 13.67 17 13.5C17.82 13.34 18.67 13.22 19.59 13.35C20.05 13.41 20.54 13.54 21 13.86C21.1 13.92 21.17 14 21.24 14.05C22.4 13.26 23 12.44 23 12C23 11.13 19.19 9.5 15.56 9.09M18 12C17.45 12 17 11.55 17 11C17 10.76 17.1 10.55 17.23 10.38C17.84 10.5 18.43 10.67 18.97 10.84C19 10.89 19 10.94 19 11C19 11.55 18.55 12 18 12Z";
var mdiSharkFin = "M22 16V18H20C18.6 18 17.2 17.6 16 17C13.5 18.3 10.5 18.3 8 17C6.8 17.6 5.4 18 4 18H2V16H4C5.4 16 6.8 15.5 8 14.7C10.4 16.4 13.6 16.4 16 14.7C17.2 15.5 18.6 16 20 16H22M5.28 13.79C5.82 13.63 6.37 13.38 6.89 13.04L8.03 12.27L9.16 13.07C10 13.66 11 14 12 14C13 14 14 13.66 14.84 13.07L15.97 12.27L17.11 13.04C17.93 13.59 18.83 13.9 19.67 13.97C18.24 7.4 12.37 2 6 2C5.65 2 5.33 2.18 5.15 2.47C4.97 2.77 4.95 3.14 5.11 3.45C7.28 7.79 6.61 11.29 5.28 13.79M16 18.7C13.6 20.4 10.4 20.4 8 18.7C6.8 19.5 5.4 20 4 20H2V22H4C5.4 22 6.8 21.6 8 21C10.5 22.3 13.5 22.3 16 21C17.2 21.6 18.6 22 20 22H22V20H20C18.6 20 17.2 19.5 16 18.7Z";
var mdiSharkFinOutline = "M22 16V18H20C18.6 18 17.2 17.6 16 17C13.5 18.3 10.5 18.3 8 17C6.8 17.6 5.4 18 4 18H2V16H4C5.4 16 6.8 15.5 8 14.7C10.4 16.4 13.6 16.4 16 14.7C17.2 15.5 18.6 16 20 16H22M5.28 13.79C5.82 13.63 6.37 13.38 6.89 13.04L8 12.28C8.69 10 8.78 7.27 7.59 4.14C11.95 4.89 15.89 8.65 17.37 13.19C18.12 13.64 18.91 13.91 19.66 13.97C18.24 7.4 12.37 2 6 2C5.65 2 5.33 2.18 5.15 2.47C4.97 2.77 4.95 3.14 5.11 3.45C7.28 7.79 6.61 11.29 5.28 13.79M16 18.7C13.6 20.4 10.4 20.4 8 18.7C6.8 19.5 5.4 20 4 20H2V22H4C5.4 22 6.8 21.6 8 21C10.5 22.3 13.5 22.3 16 21C17.2 21.6 18.6 22 20 22H22V20H20C18.6 20 17.2 19.5 16 18.7Z";
var mdiSharkOff = "M11.26 8.06L18.53 15.33C19 15.17 19.46 15 19.87 14.81C19.72 14.63 19.53 14.44 19.28 14.3C18.63 13.91 17.82 13.67 17 13.5C17.82 13.34 18.67 13.22 19.59 13.35C20.05 13.41 20.54 13.54 21 13.86C21.1 13.92 21.17 14 21.24 14.05C22.4 13.26 23 12.44 23 12C23 11.13 19.19 9.5 15.56 9.09C14.66 7.18 12.54 6 11 6C11.25 6.76 11.31 7.45 11.26 8.06M17.23 10.38C17.84 10.5 18.43 10.67 18.97 10.84C19 10.89 19 10.94 19 11C19 11.55 18.55 12 18 12S17 11.55 17 11C17 10.76 17.1 10.55 17.23 10.38M22.11 21.46L20.84 22.73L15.42 17.31C14.88 17.75 14.35 18 14 18V16C11 16 6 14 6 14S4 17 2 17L3 13L1 7C3 7 6 11 6 11S6.96 10.62 8.3 10.19L1.11 3L2.39 1.73L22.11 21.46Z";
var mdiSheep = "M20,8.5A2.5,2.5 0 0,1 17.5,11C16.42,11 15.5,10.31 15.16,9.36C14.72,9.75 14.14,10 13.5,10C12.94,10 12.42,9.81 12,9.5C11.58,9.81 11.07,10 10.5,10C9.86,10 9.28,9.75 8.84,9.36C8.5,10.31 7.58,11 6.5,11A2.5,2.5 0 0,1 4,8.5C4,7.26 4.91,6.23 6.1,6.04C6.04,5.87 6,5.69 6,5.5A1.5,1.5 0 0,1 7.5,4C7.7,4 7.89,4.04 8.06,4.11C8.23,3.47 8.81,3 9.5,3C9.75,3 10,3.07 10.18,3.17C10.5,2.5 11.19,2 12,2C12.81,2 13.5,2.5 13.82,3.17C14,3.07 14.25,3 14.5,3C15.19,3 15.77,3.47 15.94,4.11C16.11,4.04 16.3,4 16.5,4A1.5,1.5 0 0,1 18,5.5C18,5.69 17.96,5.87 17.9,6.04C19.09,6.23 20,7.26 20,8.5M10,12A1,1 0 0,0 9,13A1,1 0 0,0 10,14A1,1 0 0,0 11,13A1,1 0 0,0 10,12M14,12A1,1 0 0,0 13,13A1,1 0 0,0 14,14A1,1 0 0,0 15,13A1,1 0 0,0 14,12M20.23,10.66C19.59,11.47 18.61,12 17.5,12C17.05,12 16.62,11.9 16.21,11.73C16.2,14.28 15.83,17.36 14.45,18.95C13.93,19.54 13.3,19.86 12.5,19.96V18H11.5V19.96C10.7,19.86 10.07,19.55 9.55,18.95C8.16,17.35 7.79,14.29 7.78,11.74C7.38,11.9 6.95,12 6.5,12C5.39,12 4.41,11.47 3.77,10.66C2.88,11.55 2,12 2,12C2,12 3,14 5,14C5.36,14 5.64,13.96 5.88,13.91C6.22,17.73 7.58,22 12,22C16.42,22 17.78,17.73 18.12,13.91C18.36,13.96 18.64,14 19,14C21,14 22,12 22,12C22,12 21.12,11.55 20.23,10.66Z";
var mdiShield = "M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z";
var mdiShieldAccount = "M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M17.13,17C15.92,18.85 14.11,20.24 12,20.92C9.89,20.24 8.08,18.85 6.87,17C6.53,16.5 6.24,16 6,15.47C6,13.82 8.71,12.47 12,12.47C15.29,12.47 18,13.79 18,15.47C17.76,16 17.47,16.5 17.13,17Z";
var mdiShieldAccountOutline = "M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,3.18L19,6.3V11.22C19,12.92 18.5,14.65 17.65,16.17C16,14.94 13.26,14.5 12,14.5C10.74,14.5 8,14.94 6.35,16.17C5.5,14.65 5,12.92 5,11.22V6.3L12,3.18M12,6A3.5,3.5 0 0,0 8.5,9.5A3.5,3.5 0 0,0 12,13A3.5,3.5 0 0,0 15.5,9.5A3.5,3.5 0 0,0 12,6M12,8A1.5,1.5 0 0,1 13.5,9.5A1.5,1.5 0 0,1 12,11A1.5,1.5 0 0,1 10.5,9.5A1.5,1.5 0 0,1 12,8M12,16.5C13.57,16.5 15.64,17.11 16.53,17.84C15.29,19.38 13.7,20.55 12,21C10.3,20.55 8.71,19.38 7.47,17.84C8.37,17.11 10.43,16.5 12,16.5Z";
var mdiShieldAccountVariant = "M17 11C17.3 11 17.7 11 18 11.1V6.3L10.5 3L3 6.3V11.2C3 15.7 6.2 20 10.5 21C11.1 20.9 11.6 20.7 12.1 20.5C11.4 19.5 11 18.3 11 17C11 13.7 13.7 11 17 11M17 13C14.8 13 13 14.8 13 17S14.8 21 17 21 21 19.2 21 17 19.2 13 17 13M17 14.4C17.6 14.4 18.1 14.9 18.1 15.5C18.1 16.1 17.6 16.6 17 16.6S15.9 16.1 15.9 15.5 16.4 14.4 17 14.4M17 19.8C16.1 19.8 15.3 19.3 14.8 18.6C14.9 17.9 16.3 17.5 17 17.5S19.2 17.9 19.2 18.6C18.7 19.3 17.9 19.8 17 19.8Z";
var mdiShieldAccountVariantOutline = "M17 14.4C17.6 14.4 18.1 14.9 18.1 15.5S17.6 16.6 17 16.6 15.9 16.1 15.9 15.5 16.4 14.4 17 14.4M17 17.5C16.3 17.5 14.8 17.9 14.8 18.6C15.3 19.3 16.1 19.8 17 19.8S18.7 19.3 19.2 18.6C19.2 17.9 17.7 17.5 17 17.5M18 11.1V6.3L10.5 3L3 6.3V11.2C3 15.7 6.2 20 10.5 21C11.1 20.9 11.6 20.7 12.1 20.5C13.2 22 15 23 17 23C20.3 23 23 20.3 23 17C23 14 20.8 11.6 18 11.1M11 17C11 17.6 11.1 18.1 11.2 18.6C11 18.7 10.7 18.8 10.5 18.9C7.3 17.9 5 14.7 5 11.2V7.6L10.5 5.2L16 7.6V11.1C13.2 11.6 11 14 11 17M17 21C14.8 21 13 19.2 13 17S14.8 13 17 13 21 14.8 21 17 19.2 21 17 21Z";
var mdiShieldAirplane = "M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,5.68C12.5,5.68 12.95,6.11 12.95,6.63V10.11L18,13.26V14.53L12.95,12.95V16.42L14.21,17.37V18.32L12,17.68L9.79,18.32V17.37L11.05,16.42V12.95L6,14.53V13.26L11.05,10.11V6.63C11.05,6.11 11.5,5.68 12,5.68Z";
var mdiShieldAirplaneOutline = "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21M12,5.68C12.5,5.68 12.95,6.11 12.95,6.63V10.11L18,13.26V14.53L12.95,12.95V16.42L14.21,17.37V18.32L12,17.68L9.79,18.32V17.37L11.05,16.42V12.95L6,14.53V13.26L11.05,10.11V6.63C11.05,6.11 11.5,5.68 12,5.68Z";
var mdiShieldAlert = "M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5M11,7H13V13H11M11,15H13V17H11";
var mdiShieldAlertOutline = "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21M11,7H13V13H11V7M11,15H13V17H11V15Z";
var mdiShieldBug = "M11 13H13V14H11V13M21 5V11C21 16.5 17.2 21.7 12 23C6.8 21.7 3 16.5 3 11V5L12 1L21 5M17 10H14.8C14.6 9.4 14.2 8.9 13.7 8.5L14.9 7.3L14.2 6.6L12.8 8H12C11.8 8 11.5 8 11.3 8.1L9.9 6.6L9.1 7.4L10.3 8.6C9.8 8.9 9.4 9.4 9.2 10H7V11H9V12H7V13H9V14H7V15H9.2C9.6 16.2 10.7 17 12 17S14.4 16.2 14.8 15H17V14H15V13H17V12H15V11H17V10M11 12H13V11H11V12Z";
var mdiShieldBugOutline = "M9.9 6.6L9.1 7.4L10.3 8.6C9.8 8.9 9.4 9.4 9.2 10H7V11H9V12H7V13H9V14H7V15H9.2C9.6 16.2 10.7 17 12 17S14.4 16.2 14.8 15H17V14H15V13H17V12H15V11H17V10H14.8C14.6 9.4 14.2 8.9 13.7 8.5L14.9 7.3L14.2 6.6L12.8 8H12C11.8 8 11.5 8 11.3 8.1L9.9 6.6M11 11H13V12H11V11M11 13H13V14H11V13M21 11C21 16.5 17.2 21.7 12 23C6.8 21.7 3 16.5 3 11V5L12 1L21 5V11M12 21C15.8 20 19 15.5 19 11.2V6.3L12 3.2L5 6.3V11.2C5 15.5 8.2 20 12 21Z";
var mdiShieldCar = "M14.42 7.5L16 11H8L9.42 7.5H14.42M9 12C8.45 12 8 12.45 8 13S8.45 14 9 14 10 13.55 10 13 9.55 12 9 12M15 12C14.45 12 14 12.45 14 13S14.45 14 15 14 16 13.55 16 13 15.55 12 15 12M21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5L12 1L21 5M18 12L15.84 7C15.64 6.42 15.08 6 14.42 6H9.42C8.76 6 8.2 6.42 8 7L6 12V16C6 16.55 6.45 17 7 17H8C8.55 17 9 16.55 9 16V15H15V16C15 16.55 15.45 17 16 17H17C17.55 17 18 16.55 18 16V12Z";
var mdiShieldCheck = "M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z";
var mdiShieldCheckOutline = "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9";
var mdiShieldCross = "M12,1L3,5V11C3,16.5 6.8,21.7 12,23C17.2,21.7 21,16.5 21,11V5L12,1M16,10H13V18H11V10H8V8H11V5H13V8H16V10Z";
var mdiShieldCrossOutline = "M21,11C21,16.5 17.2,21.7 12,23C6.8,21.7 3,16.5 3,11V5L12,1L21,5V11M12,21C15.8,20 19,15.5 19,11.2V6.3L12,3.2L5,6.3V11.2C5,15.5 8.3,20 12,21M16,9H13V6H11V9H8V11H11V19H13V11H16V9Z";
var mdiShieldCrown = "M12 1L21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5L12 1M16 14H8V15.5C8 15.77 8.19 15.96 8.47 16L8.57 16H15.43C15.74 16 15.95 15.84 16 15.59L16 15.5V14M17 8L17 8L14.33 10.67L12 8.34L9.67 10.67L7 8L7 8L8 13H16L17 8Z";
var mdiShieldCrownOutline = "M12 1L21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5L12 1M12 3.18L5 6.3V11.22C5 15.54 8.25 20 12 21C15.75 20 19 15.54 19 11.22V6.3L12 3.18M16 14V15.5L16 15.59C15.96 15.81 15.78 15.96 15.53 16L15.43 16H8.57L8.47 16C8.22 15.96 8.04 15.81 8 15.59L8 15.5V14H16M17 8L16 13H8L7 8L7 8L9.67 10.67L12 8.34L14.33 10.67L17 8L17 8Z";
var mdiShieldEdit = "M21.7 14.4L20.7 15.4L18.6 13.3L19.6 12.3C19.8 12.1 20.2 12.1 20.4 12.3L21.7 13.6C21.9 13.8 21.9 14.1 21.7 14.4M12 19.9L18.1 13.8L20.2 15.9L14.1 22H12V19.9M10 19.1L21 8.1V5L12 1L3 5V11C3 15.8 5.9 20.3 10 22.3V19.1Z";
var mdiShieldEditOutline = "M21.7 13.6L20.4 12.3C20.3 12.2 20.2 12.1 20 12.1C19.9 12.1 19.7 12.2 19.6 12.3L18.6 13.3L20.6 15.3L21.6 14.3C21.9 14.1 21.9 13.8 21.7 13.6M12 19.9V22H14.1L20.2 15.9L18.2 13.8L12 19.9M10 22.3C5.9 20.3 3 15.8 3 11V5L12 1L21 5V8.1L19 10.1V6.3L12 3.2L5 6.3V11.2C5 14.7 7.2 18.3 10 20.1V22.3Z";
var mdiShieldHalf = "M12 1L3 5V11C3 16.5 6.8 21.7 12 23V1Z";
var mdiShieldHalfFull = "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18V21Z";
var mdiShieldHome = "M11,13H13V16H16V11H18L12,6L6,11H8V16H11V13M12,1L21,5V11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1Z";
var mdiShieldHomeOutline = "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21M11,14H13V17H16V12H18L12,7L6,12H8V17H11V14";
var mdiShieldKey = "M12,8A1,1 0 0,1 13,9A1,1 0 0,1 12,10A1,1 0 0,1 11,9A1,1 0 0,1 12,8M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,6A3,3 0 0,0 9,9C9,10.31 9.83,11.42 11,11.83V18H13V16H15V14H13V11.83C14.17,11.42 15,10.31 15,9A3,3 0 0,0 12,6Z";
var mdiShieldKeyOutline = "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21M12,6A3,3 0 0,1 15,9C15,10.31 14.17,11.42 13,11.83V14H15V16H13V18H11V11.83C9.83,11.42 9,10.31 9,9A3,3 0 0,1 12,6M12,8A1,1 0 0,0 11,9A1,1 0 0,0 12,10A1,1 0 0,0 13,9A1,1 0 0,0 12,8Z";
var mdiShieldLinkVariant = "M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M14.28,14.08L12.26,16.1C11.66,16.7 10.87,17 10.08,17C9.29,17 8.5,16.7 7.9,16.1C6.7,14.9 6.7,12.95 7.9,11.74L9.15,10.5L9.14,11.06C9.14,11.5 9.21,11.95 9.36,12.37L9.41,12.5L9.04,12.87C8.76,13.15 8.6,13.53 8.6,13.92C8.6,14.32 8.76,14.69 9.04,14.97C9.6,15.53 10.57,15.53 11.13,14.97L13.14,12.96C13.43,12.67 13.58,12.3 13.58,11.91C13.58,11.5 13.43,11.14 13.15,10.86C13,10.71 12.9,10.5 12.9,10.29C12.9,10.08 13,9.88 13.15,9.73C13.45,9.42 14,9.43 14.28,9.73C14.86,10.31 15.18,11.08 15.18,11.9C15.18,12.73 14.86,13.5 14.28,14.08M17.1,11.26L15.85,12.5L15.86,11.94C15.86,11.5 15.79,11.06 15.64,10.64L15.6,10.5L15.96,10.13C16.25,9.85 16.4,9.5 16.4,9.08C16.4,8.69 16.25,8.32 15.97,8.04C15.4,7.47 14.43,7.47 13.87,8.04L11.86,10.05C11.58,10.33 11.42,10.7 11.42,11.1C11.42,11.5 11.57,11.86 11.86,12.14C12,12.29 12.1,12.5 12.1,12.71C12.1,12.93 12,13.13 11.85,13.28C11.7,13.44 11.5,13.5 11.29,13.5C11.09,13.5 10.88,13.43 10.72,13.28C9.5,12.08 9.5,10.12 10.72,8.92L12.74,6.9C13.95,5.7 15.9,5.7 17.1,6.9C17.68,7.5 18,8.26 18,9.08C18,9.9 17.68,10.68 17.1,11.26Z";
var mdiShieldLinkVariantOutline = "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21M14.28,9.73C14.86,10.31 15.18,11.08 15.18,11.9C15.18,12.73 14.86,13.5 14.28,14.08L12.26,16.1C11.66,16.7 10.87,17 10.08,17C9.29,17 8.5,16.7 7.9,16.1C6.7,14.9 6.7,12.95 7.9,11.74L9.15,10.5L9.14,11.06C9.14,11.5 9.21,11.95 9.36,12.36L9.4,12.5L9.04,12.87C8.75,13.15 8.6,13.5 8.6,13.92C8.6,14.31 8.75,14.68 9.03,14.96C9.6,15.53 10.57,15.53 11.13,14.97L13.14,12.95C13.43,12.67 13.58,12.3 13.58,11.91C13.58,11.5 13.43,11.14 13.14,10.86C13,10.71 12.9,10.5 12.9,10.29C12.9,10.08 13,9.87 13.14,9.72C13.45,9.42 14,9.42 14.28,9.73M18,9.08C18,9.9 17.68,10.68 17.1,11.26L15.85,12.5L15.86,11.94C15.86,11.5 15.79,11.06 15.64,10.64L15.59,10.5L15.96,10.13C16.25,9.85 16.4,9.5 16.4,9.08C16.4,8.69 16.25,8.32 15.96,8.04C15.4,7.47 14.43,7.47 13.87,8.03L11.86,10.05C11.57,10.33 11.42,10.7 11.42,11.1C11.42,11.5 11.57,11.86 11.85,12.14C12,12.29 12.1,12.5 12.1,12.71C12.1,12.93 12,13.13 11.85,13.28C11.7,13.43 11.5,13.5 11.29,13.5C11.09,13.5 10.88,13.43 10.72,13.28C9.5,12.07 9.5,10.12 10.72,8.92L12.74,6.9C13.95,5.7 15.9,5.7 17.1,6.9C17.68,7.5 18,8.26 18,9.08Z";
var mdiShieldLock = "M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.1 14.8,9.5V11C15.4,11 16,11.6 16,12.3V15.8C16,16.4 15.4,17 14.7,17H9.2C8.6,17 8,16.4 8,15.7V12.2C8,11.6 8.6,11 9.2,11V9.5C9.2,8.1 10.6,7 12,7M12,8.2C11.2,8.2 10.5,8.7 10.5,9.5V11H13.5V9.5C13.5,8.7 12.8,8.2 12,8.2Z";
var mdiShieldLockOpen = "M12 1L3 5V11C3 16.5 6.8 21.7 12 23C17.2 21.7 21 16.5 21 11V5L12 1M16 15.8C16 16.4 15.4 17 14.7 17H9.2C8.6 17 8 16.4 8 15.7V12.2C8 11.6 8.6 11 9.2 11V8.5C9.2 7.1 10.6 6 12 6S14.8 7.1 14.8 8.5V9H13.5V8.5C13.5 7.7 12.8 7.2 12 7.2S10.5 7.7 10.5 8.5V11H14.8C15.4 11 16 11.6 16 12.3V15.8Z";
var mdiShieldLockOpenOutline = "M21 11C21 16.5 17.2 21.7 12 23C6.8 21.7 3 16.5 3 11V5L12 1L21 5V11M12 21C15.8 20 19 15.5 19 11.2V6.3L12 3.2L5 6.3V11.2C5 15.5 8.2 20 12 21M14.8 11H10.5V8.5C10.5 7.7 11.2 7.2 12 7.2S13.5 7.7 13.5 8.5V9H14.8V8.5C14.8 7.1 13.4 6 12 6S9.2 7.1 9.2 8.5V11C8.6 11 8 11.6 8 12.2V15.7C8 16.4 8.6 17 9.2 17H14.7C15.4 17 16 16.4 16 15.8V12.3C16 11.6 15.4 11 14.8 11Z";
var mdiShieldLockOutline = "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21M14.8,11V9.5C14.8,8.1 13.4,7 12,7C10.6,7 9.2,8.1 9.2,9.5V11C8.6,11 8,11.6 8,12.2V15.7C8,16.4 8.6,17 9.2,17H14.7C15.4,17 16,16.4 16,15.8V12.3C16,11.6 15.4,11 14.8,11M13.5,11H10.5V9.5C10.5,8.7 11.2,8.2 12,8.2C12.8,8.2 13.5,8.7 13.5,9.5V11Z";
var mdiShieldMoon = "M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1M15.97 14.41C14.13 16.58 10.76 16.5 9 14.34C6.82 11.62 8.36 7.62 11.7 7C12.04 6.95 12.33 7.28 12.21 7.61C11.75 8.84 11.82 10.25 12.53 11.47C13.24 12.69 14.42 13.46 15.71 13.67C16.05 13.72 16.2 14.14 15.97 14.41Z";
var mdiShieldMoonOutline = "M21 11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5L12 1L21 5V11M12 21C15.75 20 19 15.54 19 11.22V6.3L12 3.18L5 6.3V11.22C5 15.54 8.25 20 12 21M9 14.33C10.76 16.5 14.13 16.57 15.97 14.4C16.2 14.13 16.05 13.72 15.71 13.66C14.42 13.45 13.23 12.68 12.53 11.46C11.82 10.24 11.75 8.83 12.21 7.6C12.33 7.27 12.05 6.94 11.7 7C8.36 7.62 6.81 11.61 9 14.33";
var mdiShieldOff = "M1,4.27L2.28,3L20.5,21.22L19.23,22.5L17,20.25C15.57,21.57 13.87,22.54 12,23C6.84,21.74 3,16.55 3,11V6.27L1,4.27M12,1L21,5V11C21,13.28 20.35,15.5 19.23,17.41L5.65,3.82L12,1Z";
var mdiShieldOffOutline = "M1,4.27L3,6.27V11C3,16.55 6.84,21.74 12,23C13.87,22.54 15.57,21.56 16.97,20.24L19.23,22.5L20.5,21.22L2.28,3L1,4.27M12,21C8.25,20 5,15.54 5,11.22V8.27L15.59,18.86C14.53,19.89 13.3,20.65 12,21M21,5V11C21,13.28 20.35,15.5 19.23,17.4L17.77,15.95C18.54,14.5 19,12.84 19,11.22V6.3L12,3.18L7.16,5.34L5.65,3.82L12,1L21,5Z";
var mdiShieldOutline = "M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21Z";
var mdiShieldPlus = "M19,20V22.97H17V20H14V18H17V15H19V18H22V20H19M12,1L21,5V11C21,11.9 20.9,12.78 20.71,13.65C19.9,13.23 19,13 18,13A6,6 0 0,0 12,19C12,20.36 12.45,21.62 13.22,22.62L12,23C6.84,21.74 3,16.55 3,11V5L12,1Z";
var mdiShieldPlusOutline = "M19,20V22.97H17V20H14V18H17V15H19V18H22V20H19M21,11C21,11.9 20.9,12.78 20.71,13.65C20.13,13.35 19.5,13.15 18.81,13.05C18.93,12.45 19,11.83 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21L12.31,20.91C12.5,21.53 12.83,22.11 13.22,22.62L12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11Z";
var mdiShieldRefresh = "M18 12C19 12 20 12.2 20.9 12.7C21 12.1 21 11.6 21 11V5L12 1L3 5V11C3 16.5 6.8 21.7 12 23C12.4 22.9 12.7 22.8 13 22.7C12 21.5 11.5 20 11.5 18.5C11.5 14.9 14.4 12 18 12M18 14.5C19.1 14.5 20.1 14.9 20.8 15.7L22 14.5V18.5H18L19.8 16.7C19.3 16.3 18.7 16 18 16C16.6 16 15.5 17.1 15.5 18.5S16.6 21 18 21C18.8 21 19.5 20.6 20 20H21.7C21.1 21.5 19.7 22.5 18 22.5C15.8 22.5 14 20.7 14 18.5S15.8 14.5 18 14.5Z";
var mdiShieldRefreshOutline = "M12 21C8.2 20 5 15.5 5 11.2V6.3L12 3.2L19 6.3V12.1C19.7 12.2 20.3 12.4 20.9 12.7C21 12.1 21 11.6 21 11V5L12 1L3 5V11C3 16.5 6.8 21.7 12 23C12.4 22.9 12.7 22.8 13 22.7C12.6 22.2 12.2 21.6 12 21M18 14.5C19.1 14.5 20.1 14.9 20.8 15.7L22 14.5V18.5H18L19.8 16.7C19.3 16.3 18.7 16 18 16C16.6 16 15.5 17.1 15.5 18.5S16.6 21 18 21C18.8 21 19.5 20.6 20 20H21.7C21.1 21.5 19.7 22.5 18 22.5C15.8 22.5 14 20.7 14 18.5S15.8 14.5 18 14.5Z";
var mdiShieldRemove = "M19.43,19L21.5,21.11L20.12,22.5L18.03,20.41L15.91,22.53L14.5,21.11L16.61,19L14.5,16.86L15.88,15.47L18,17.59L20.12,15.47L21.55,16.9L19.43,19M12,1L21,5V11C21,11.9 20.9,12.78 20.71,13.65C19.9,13.23 19,13 18,13A6,6 0 0,0 12,19C12,20.36 12.45,21.62 13.22,22.62L12,23C6.84,21.74 3,16.55 3,11V5L12,1Z";
var mdiShieldRemoveOutline = "M19.43,19L21.5,21.11L20.12,22.5L18.03,20.41L15.91,22.53L14.5,21.11L16.61,19L14.5,16.86L15.88,15.47L18,17.59L20.12,15.47L21.55,16.9L19.43,19M21,11C21,11.9 20.9,12.78 20.71,13.65C20.13,13.35 19.5,13.15 18.81,13.05C18.93,12.45 19,11.83 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21L12.31,20.91C12.5,21.53 12.83,22.11 13.22,22.62L12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11Z";
var mdiShieldSearch = "M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M17.86,19.31C16.23,21.22 14.28,22.45 12,23C9.44,22.39 7.3,20.93 5.58,18.63C3.86,16.34 3,13.8 3,11V5L12,1L21,5V11C21,13.39 20.36,15.61 19.08,17.67L16.17,14.76C16.69,13.97 17,13 17,12A5,5 0 0,0 12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17C13,17 13.97,16.69 14.76,16.17L17.86,19.31Z";
var mdiShieldStar = "M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1M15.08 16L12 14.15L8.93 16L9.74 12.5L7.03 10.16L10.61 9.85L12 6.55L13.39 9.84L16.97 10.15L14.26 12.5L15.08 16Z";
var mdiShieldStarOutline = "M21 11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5L12 1L21 5V11M12 21C15.75 20 19 15.54 19 11.22V6.3L12 3.18L5 6.3V11.22C5 15.54 8.25 20 12 21M15.05 16L11.97 14.15L8.9 16L9.71 12.5L7 10.16L10.58 9.85L11.97 6.55L13.37 9.84L16.95 10.15L14.23 12.5L15.05 16";
var mdiShieldSun = "M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1M12 8.89C13.6 8.89 14.89 10.18 14.89 11.78S13.6 14.67 12 14.67 9.11 13.37 9.11 11.78 10.41 8.89 12 8.89M12 6L13.38 8C12.96 7.82 12.5 7.73 12 7.73S11.05 7.82 10.62 8L12 6M7 8.89L9.4 8.69C9.06 9 8.74 9.34 8.5 9.76C8.25 10.18 8.1 10.62 8 11.08L7 8.89M7 14.67L8.03 12.5C8.11 12.93 8.27 13.38 8.5 13.8C8.75 14.23 9.06 14.59 9.4 14.88L7 14.67M17 8.89L16 11.08C15.9 10.62 15.74 10.18 15.5 9.76C15.26 9.34 14.95 9 14.6 8.68L17 8.89M17 14.67L14.6 14.87C14.94 14.58 15.25 14.22 15.5 13.8C15.74 13.38 15.89 12.93 15.97 12.5L17 14.67M12 17.55L10.61 15.57C11.04 15.72 11.5 15.82 12 15.82C12.5 15.82 12.95 15.72 13.37 15.57L12 17.55Z";
var mdiShieldSunOutline = "M21 11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5L12 1L21 5V11M12 21C15.75 20 19 15.54 19 11.22V6.3L12 3.18L5 6.3V11.22C5 15.54 8.25 20 12 21M12 8.89C13.6 8.89 14.89 10.18 14.89 11.78S13.6 14.67 12 14.67 9.11 13.37 9.11 11.78 10.41 8.89 12 8.89M12 6L13.38 8C12.96 7.82 12.5 7.73 12 7.73S11.05 7.82 10.62 8L12 6M7 8.89L9.4 8.69C9.06 9 8.74 9.34 8.5 9.76C8.25 10.18 8.1 10.62 8 11.08L7 8.89M7 14.67L8.03 12.5C8.11 12.93 8.27 13.38 8.5 13.8C8.75 14.23 9.06 14.59 9.4 14.88L7 14.67M17 8.89L16 11.08C15.9 10.62 15.74 10.18 15.5 9.76C15.26 9.34 14.95 9 14.6 8.68L17 8.89M17 14.67L14.6 14.87C14.94 14.58 15.25 14.22 15.5 13.8C15.74 13.38 15.89 12.93 15.97 12.5L17 14.67M12 17.55L10.61 15.57C11.04 15.72 11.5 15.82 12 15.82C12.5 15.82 12.95 15.72 13.37 15.57L12 17.55Z";
var mdiShieldSword = "M12 1L3 5V11C3 16.5 6.8 21.7 12 23C17.2 21.7 21 16.5 21 11V5L12 1M15 15H13V18H11V15H9V13H11L10 7.1L12 5.5L14 7.1L13 13H15V15Z";
var mdiShieldSwordOutline = "M12 1L21 5V11C21 16.5 17.2 21.7 12 23C6.8 21.7 3 16.5 3 11V5L12 1M12 3.2L5 6.3V11.2C5 15.5 8.2 20 12 21C15.8 20 19 15.5 19 11.2V6.3L12 3.2M12 5.5L14 7.1L13 13H15V15H13V18H11V15H9V13H11L10 7.1L12 5.5Z";
var mdiShieldSync = "M18 12A6.41 6.41 0 0 1 20.87 12.67A11.63 11.63 0 0 0 21 11V5L12 1L3 5V11C3 16.55 6.84 21.74 12 23C12.35 22.91 12.7 22.8 13 22.68A6.42 6.42 0 0 1 11.5 18.5A6.5 6.5 0 0 1 18 12M18 14.5V13L15.75 15.25L18 17.5V16A2.5 2.5 0 0 1 20.24 19.62L21.33 20.71A4 4 0 0 0 18 14.5M18 21A2.5 2.5 0 0 1 15.76 17.38L14.67 16.29A4 4 0 0 0 18 22.5V24L20.25 21.75L18 19.5Z";
var mdiShieldSyncOutline = "M12 21C8.25 20 5 15.54 5 11.22V6.3L12 3.18L19 6.3V12.07A6.45 6.45 0 0 1 20.91 12.67A11.63 11.63 0 0 0 21 11V5L12 1L3 5V11C3 16.55 6.84 21.74 12 23C12.35 22.91 12.7 22.8 13 22.68A6.3 6.3 0 0 1 12 21M18 14.5V13L15.75 15.25L18 17.5V16A2.5 2.5 0 0 1 20.24 19.62L21.33 20.71A4 4 0 0 0 18 14.5M18 21A2.5 2.5 0 0 1 15.76 17.38L14.67 16.29A4 4 0 0 0 18 22.5V24L20.25 21.75L18 19.5Z";
var mdiShimmer = "M10.6 9.6L9 15L7.4 9.6L2 8L7.4 6.4L9 1L10.6 6.4L16 8L10.6 9.6M17 14.2L21 12L18.8 16L21 20L17 17.8L13 20L15.2 16L13 12L17 14.2M10 16L8.3 19L10 22L7 20.3L4 22L5.7 19L4 16L7 17.7L10 16";
var mdiShipWheel = "M2,11L4.05,11.1C4.3,8.83 5.5,6.85 7.25,5.56L6.13,3.84C5.86,3.36 6,2.75 6.5,2.47C7,2.2 7.59,2.36 7.87,2.84L8.8,4.66C9.78,4.24 10.86,4 12,4C13.14,4 14.22,4.24 15.2,4.66L16.13,2.84C16.41,2.36 17,2.2 17.5,2.47C18,2.75 18.14,3.36 17.87,3.84L16.75,5.56C18.5,6.85 19.7,8.83 19.95,11.1L22,11A1,1 0 0,1 23,12A1,1 0 0,1 22,13L19.95,12.9C19.7,15.17 18.5,17.15 16.75,18.44L17.87,20.16C18.14,20.64 18,21.25 17.5,21.53C17,21.8 16.41,21.64 16.13,21.16L15.2,19.34C14.22,19.76 13.14,20 12,20C10.86,20 9.78,19.76 8.8,19.34L7.87,21.16C7.59,21.64 7,21.8 6.5,21.53C6,21.25 5.86,20.64 6.13,20.16L7.25,18.44C5.5,17.15 4.3,15.17 4.05,12.9L2,13A1,1 0 0,1 1,12A1,1 0 0,1 2,11M9.07,11.35C9.2,10.74 9.53,10.2 10,9.79L8.34,7.25C7.11,8.19 6.27,9.6 6.05,11.2L9.07,11.35M12,9C12.32,9 12.62,9.05 12.9,9.14L14.28,6.45C13.58,6.16 12.81,6 12,6C11.19,6 10.42,6.16 9.72,6.45L11.1,9.14C11.38,9.05 11.68,9 12,9M14.93,11.35L17.95,11.2C17.73,9.6 16.89,8.19 15.66,7.25L14,9.79C14.47,10.2 14.8,10.74 14.93,11.35M14.93,12.65C14.8,13.26 14.47,13.8 14,14.21L15.66,16.75C16.89,15.81 17.73,14.4 17.95,12.8L14.93,12.65M12,15C11.68,15 11.38,14.95 11.09,14.86L9.72,17.55C10.42,17.84 11.19,18 12,18C12.81,18 13.58,17.84 14.28,17.55L12.91,14.86C12.62,14.95 12.32,15 12,15M9.07,12.65L6.05,12.8C6.27,14.4 7.11,15.81 8.34,16.75L10,14.21C9.53,13.8 9.2,13.26 9.07,12.65Z";
var mdiShippingPallet = "M3 20H5V18H11V20H13V18H19V20H21V15H19V16H17V15H15V16H13V15H11V16H9V15H7V16H5V15H3M5 13H19V4H5Z";
var mdiShoeBallet = "M12.78 11.97C12.27 8.54 10.86 2 7.53 2S2.8 8.54 2.28 11.97C2.07 13.42 2 14.89 2.16 16.35C2.5 19.39 3.55 20.84 4.27 21.5C4.64 21.83 5.11 22 5.6 22H9.47C9.96 22 10.43 21.83 10.8 21.5C11.5 20.84 12.55 19.39 12.91 16.35C13.08 14.89 13 13.42 12.78 11.97M7.53 4C7.89 3.87 8.59 4.73 9.27 6.31L4.58 10.33C5.41 6.26 6.94 3.79 7.53 4M9.75 13H5.31C5.1 13 4.92 12.92 4.76 12.81L10 8.33C10.29 9.35 10.56 10.5 10.75 11.83C10.84 12.44 10.37 13 9.75 13M21.78 11.97C21.27 8.54 19.86 2 16.53 2C15.04 2 13.94 3.32 13.13 5.08C13.5 6.04 13.84 7.14 14.13 8.37L19.31 12.81C19.15 12.92 18.97 13 18.75 13H14.92C15.04 14.27 15.03 15.45 14.89 16.59C14.62 18.87 14 20.45 13.32 21.53C13.68 21.84 14.13 22 14.6 22H18.47C18.96 22 19.43 21.83 19.8 21.5C20.5 20.84 21.55 19.39 21.91 16.35C22.08 14.89 22 13.42 21.78 11.97M14.8 6.31C15.5 4.73 16.18 3.87 16.53 4C17.13 3.79 18.65 6.26 19.5 10.33L14.8 6.31Z";
var mdiShoeCleat = "M21 8C20.76 8 20.53 8 20.3 8L20.25 7.97C18.14 7.84 16.38 7.17 15.53 6.23L14 7C13.95 7.1 13.89 7.19 13.84 7.28C14.55 7.89 15 8.65 15 9.5C15 9.83 14.91 10.14 14.79 10.45L12.92 8.58C12.7 8.83 12.47 9.07 12.22 9.29L14.25 11.32C14.04 11.57 13.8 11.79 13.5 12L11.43 9.91C11.14 10.11 10.85 10.28 10.55 10.45L12.58 12.5C12.25 12.63 11.89 12.74 11.5 12.82L9.59 10.91C9.25 11.05 8.91 11.18 8.56 11.29L10.26 13C10.17 13 10.09 13 10 13C8.5 13 7.2 12.54 6.28 11.82C5.46 11.95 4.68 12 4 12C2 12 2 15 2 15V15C2 16.11 2.89 17 4 17H4V18C4 18.55 4.45 19 5 19S6 18.55 6 18V17H7V18C7 18.55 7.45 19 8 19S9 18.55 9 18V17H10V18C10 18.55 10.45 19 11 19S12 18.55 12 18V17H15V18C15 18.55 15.45 19 16 19S17 18.55 17 18V17H18V18C18 18.55 18.45 19 19 19S20 18.55 20 18V17H21C21 17 22 17 22 12.5C22 9 21 8 21 8Z";
var mdiShoeFormal = "M21.5,9V8H20.5L19.5,9H15L14,8H13L7,12H4A2,2 0 0,0 2,14V16H10L13,15H15V16H21.5V14C21.5,14 22,13 22,11.5C22,10 21.5,9 21.5,9Z";
var mdiShoeHeel = "M3,18H11.7L17,14H18V18H20V14C20,14 21,12 21,10C21,8 20.5,6 20.5,6H18.5L18,7L10,14H8L3,16V18Z";
var mdiShoePrint = "M10.74,11.72C11.21,12.95 11.16,14.23 9.75,14.74C6.85,15.81 6.2,13 6.16,12.86L10.74,11.72M5.71,10.91L10.03,9.84C9.84,8.79 10.13,7.74 10.13,6.5C10.13,4.82 8.8,1.53 6.68,2.06C4.26,2.66 3.91,5.35 4,6.65C4.12,7.95 5.64,10.73 5.71,10.91M17.85,19.85C17.82,20 17.16,22.8 14.26,21.74C12.86,21.22 12.8,19.94 13.27,18.71L17.85,19.85M20,13.65C20.1,12.35 19.76,9.65 17.33,9.05C15.22,8.5 13.89,11.81 13.89,13.5C13.89,14.73 14.17,15.78 14,16.83L18.3,17.9C18.38,17.72 19.89,14.94 20,13.65Z";
var mdiShoeSneaker = "M2 15C2 15 2 12 4 12C4.68 12 5.46 11.95 6.28 11.82C7.2 12.54 8.5 13 10 13H10.25L8.56 11.29C8.91 11.18 9.25 11.05 9.59 10.91L11.5 12.82C11.89 12.74 12.25 12.63 12.58 12.5L10.55 10.45C10.85 10.28 11.14 10.11 11.43 9.91L13.5 12C13.8 11.79 14.04 11.56 14.25 11.32L12.22 9.29C12.46 9.07 12.7 8.83 12.92 8.58L14.79 10.45C14.91 10.14 15 9.83 15 9.5C15 8.65 14.55 7.89 13.84 7.28C13.89 7.19 13.95 7.1 14 7L15.53 6.23C16.38 7.17 18.14 7.84 20.25 7.97L20.3 8H21C21 8 22 9 22 12.5C22 13.07 22 13.57 21.96 14H19C17.9 14 16.58 14.26 15.3 14.5C14.12 14.76 12.9 15 12 15H2M21 17C21 17 21.58 17 21.86 15H19C17 15 14 16 12 16H2.28C2.62 16.6 3.26 17 4 17H21Z";
var mdiShopping = "M12,13A5,5 0 0,1 7,8H9A3,3 0 0,0 12,11A3,3 0 0,0 15,8H17A5,5 0 0,1 12,13M12,3A3,3 0 0,1 15,6H9A3,3 0 0,1 12,3M19,6H17A5,5 0 0,0 12,1A5,5 0 0,0 7,6H5C3.89,6 3,6.89 3,8V20A2,2 0 0,0 5,22H19A2,2 0 0,0 21,20V8C21,6.89 20.1,6 19,6Z";
var mdiShoppingMusic = "M12,3A3,3 0 0,0 9,6H15A3,3 0 0,0 12,3M19,6A2,2 0 0,1 21,8V20A2,2 0 0,1 19,22H5C3.89,22 3,21.1 3,20V8C3,6.89 3.89,6 5,6H7A5,5 0 0,1 12,1A5,5 0 0,1 17,6H19M9,19L16.5,14L9,10V19Z";
var mdiShoppingOutline = "M19 6H17C17 3.2 14.8 1 12 1S7 3.2 7 6H5C3.9 6 3 6.9 3 8V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V8C21 6.9 20.1 6 19 6M12 3C13.7 3 15 4.3 15 6H9C9 4.3 10.3 3 12 3M19 20H5V8H19V20M12 12C10.3 12 9 10.7 9 9H7C7 11.8 9.2 14 12 14S17 11.8 17 9H15C15 10.7 13.7 12 12 12Z";
var mdiShoppingSearch = "M19 6H17A5 5 0 0 0 7 6H5A2 2 0 0 0 3 8V20A2 2 0 0 0 5 22H12.05A6.5 6.5 0 0 1 9 16.5A6.4 6.4 0 0 1 10.25 12.68A5 5 0 0 1 7 8H9A3 3 0 0 0 12 11H12.06A6.22 6.22 0 0 1 14.06 10.16A3 3 0 0 0 15 8H17A4.88 4.88 0 0 1 16.54 10.09A6.5 6.5 0 0 1 21 13.09V8A2 2 0 0 0 19 6M9 6A3 3 0 0 1 15 6M19.31 18.9A4.5 4.5 0 1 0 17.88 20.32L21 23.39L22.39 22M15.5 19A2.5 2.5 0 1 1 18 16.5A2.5 2.5 0 0 1 15.5 19Z";
var mdiShoppingSearchOutline = "M19.31 18.9C20.64 16.8 20 14 17.91 12.69S13.03 12 11.7 14.1 11 19 13.1 20.3C14.56 21.22 16.42 21.23 17.88 20.32L21 23.39L22.39 22M15.5 19C14.12 19 13 17.88 13 16.5S14.12 14 15.5 14 18 15.12 18 16.5 16.88 19 15.5 19M10.03 20H5V8H19V11.03C19.81 11.55 20.5 12.24 21 13.05V8C21 6.9 20.1 6 19 6H17C17 3.2 14.8 1 12 1S7 3.2 7 6H5C3.9 6 3 6.9 3 8V20C3 21.1 3.9 22 5 22H12.05C11.24 21.5 10.55 20.81 10.03 20M12 3C13.7 3 15 4.3 15 6H9C9 4.3 10.3 3 12 3M15 9H17C17 9.4 16.95 9.78 16.86 10.15C16.42 10.05 15.97 10 15.5 10C15.27 10 15.04 10 14.82 10.04C14.93 9.71 15 9.37 15 9M9.76 13.46C8.12 12.65 7 11 7 9H9C9 10.34 9.82 11.42 11 11.82C10.5 12.3 10.08 12.85 9.76 13.46Z";
var mdiShore = "M20 12H22V14H20C18.6 14 17.3 13.6 16 13C13.5 14.3 10.5 14.3 8 13C6.7 13.6 5.4 14 4 14H2V12H4C5.4 12 6.8 11.5 8 10.7C10.4 12.4 13.6 12.4 16 10.7C17.2 11.5 18.6 12 20 12M20 6H22V8H20C18.6 8 17.3 7.7 16 7C13.5 8.3 10.5 8.3 8 7C6.7 7.7 5.4 8 4 8H2V6H4C5.4 6 6.8 5.5 8 4.7C10.4 6.4 13.6 6.4 16 4.7C17.2 5.5 18.6 6 20 6M22 20H2V18H22";
var mdiShovel = "M15.1,1.81L12.27,4.64C11.5,5.42 11.5,6.69 12.27,7.47L13.68,8.88L9.13,13.43L6.31,10.6L4.89,12C-0.06,17 3.5,20.5 3.5,20.5C3.5,20.5 7,24 12,19.09L13.41,17.68L10.61,14.88L15.15,10.34L16.54,11.73C17.32,12.5 18.59,12.5 19.37,11.73L22.2,8.9L15.1,1.81M17.93,10.28L16.55,8.9L15.11,7.46L13.71,6.06L15.12,4.65L19.35,8.88L17.93,10.28Z";
var mdiShovelOff = "M15.1,1.81L12.27,4.65C11.5,5.43 11.5,6.69 12.27,7.47L13.68,8.89L13,9.62L14.44,11.06L15.17,10.33L16.56,11.72C17.34,12.5 18.61,12.5 19.39,11.72L22.22,8.88L15.1,1.81M17.93,10.28L13.7,6.06L15.11,4.65L19.34,8.88L17.93,10.28M20.7,20.24L19.29,21.65L11.5,13.88L10.5,14.88L13.33,17.69L12,19.09C7,24 3.5,20.5 3.5,20.5C3.5,20.5 -0.06,17 4.89,12L6.31,10.6L9.13,13.43L10.13,12.43L2.35,4.68L3.77,3.26L20.7,20.24Z";
var mdiShower = "M21,14V15C21,16.91 19.93,18.57 18.35,19.41L19,22H17L16.5,20C16.33,20 16.17,20 16,20H8C7.83,20 7.67,20 7.5,20L7,22H5L5.65,19.41C4.07,18.57 3,16.91 3,15V14H2V12H20V5A1,1 0 0,0 19,4C18.5,4 18.12,4.34 18,4.79C18.63,5.33 19,6.13 19,7H13A3,3 0 0,1 16,4C16.06,4 16.11,4 16.17,4C16.58,2.84 17.69,2 19,2A3,3 0 0,1 22,5V14H21V14M19,14H5V15A3,3 0 0,0 8,18H16A3,3 0 0,0 19,15V14Z";
var mdiShowerHead = "M20,20A1,1 0 0,1 21,21A1,1 0 0,1 20,22A1,1 0 0,1 19,21A1,1 0 0,1 20,20M16,20A1,1 0 0,1 17,21A1,1 0 0,1 16,22A1,1 0 0,1 15,21A1,1 0 0,1 16,20M12,20A1,1 0 0,1 13,21A1,1 0 0,1 12,22A1,1 0 0,1 11,21A1,1 0 0,1 12,20M8,20A1,1 0 0,1 9,21A1,1 0 0,1 8,22A1,1 0 0,1 7,21A1,1 0 0,1 8,20M4,20A1,1 0 0,1 5,21A1,1 0 0,1 4,22A1,1 0 0,1 3,21A1,1 0 0,1 4,20M6,17A1,1 0 0,1 7,18A1,1 0 0,1 6,19H6A1,1 0 0,1 5,18A1,1 0 0,1 6,17H6M10,17A1,1 0 0,1 11,18A1,1 0 0,1 10,19A1,1 0 0,1 9,18A1,1 0 0,1 10,17M14,17A1,1 0 0,1 15,18A1,1 0 0,1 14,19A1,1 0 0,1 13,18A1,1 0 0,1 14,17M18,17A1,1 0 0,1 19,18A1,1 0 0,1 18,19A1,1 0 0,1 17,18A1,1 0 0,1 18,17M8,14A1,1 0 0,1 9,15A1,1 0 0,1 8,16A1,1 0 0,1 7,15A1,1 0 0,1 8,14M12,14A1,1 0 0,1 13,15A1,1 0 0,1 12,16A1,1 0 0,1 11,15A1,1 0 0,1 12,14M16,14A1,1 0 0,1 17,15A1,1 0 0,1 16,16A1,1 0 0,1 15,15A1,1 0 0,1 16,14M19,12H5V10H19V12M17.92,9H6.08C6.5,6.5 8.5,4.5 11,4.08V2H13V4.08C15.5,4.5 17.5,6.5 17.92,9Z";
var mdiShredder = "M6,3V7H8V5H16V7H18V3H6M5,8A3,3 0 0,0 2,11V17H5V14H19V17H22V11A3,3 0 0,0 19,8H5M18,10A1,1 0 0,1 19,11A1,1 0 0,1 18,12A1,1 0 0,1 17,11A1,1 0 0,1 18,10M7,16V21H9V16H7M11,16V20H13V16H11M15,16V21H17V16H15Z";
var mdiShuffle = "M14.83,13.41L13.42,14.82L16.55,17.95L14.5,20H20V14.5L17.96,16.54L14.83,13.41M14.5,4L16.54,6.04L4,18.59L5.41,20L17.96,7.46L20,9.5V4M10.59,9.17L5.41,4L4,5.41L9.17,10.58L10.59,9.17Z";
var mdiShuffleDisabled = "M16,4.5V7H5V9H16V11.5L19.5,8M16,12.5V15H5V17H16V19.5L19.5,16";
var mdiShuffleVariant = "M17,3L22.25,7.5L17,12L22.25,16.5L17,21V18H14.26L11.44,15.18L13.56,13.06L15.5,15H17V12L17,9H15.5L6.5,18H2V15H5.26L14.26,6H17V3M2,6H6.5L9.32,8.82L7.2,10.94L5.26,9H2V6Z";
var mdiShuriken = "M14.5 9.5L12 2L9.5 9.5L2 12L9.5 14.5L12 22L14.5 14.5L22 12L14.5 9.5M12 13.7C11.1 13.7 10.3 13 10.3 12C10.3 11.1 11 10.3 12 10.3C12.9 10.3 13.7 11 13.7 12C13.7 12.9 12.9 13.7 12 13.7Z";
var mdiSickle = "M19.3 7.2C17.5 4.7 14.9 3 12 2C26.2 10.5 15.4 22.9 8.5 15.5L5.9 16L2.5 19.4C1.9 20 1.9 21 2.5 21.5C3.1 22.1 4.1 22.1 4.6 21.5L7.8 18.3C15.3 24.3 25 15 19.3 7.2Z";
var mdiSigma = "M18,6H8.83L14.83,12L8.83,18H18V20H6V18L12,12L6,6V4H18V6Z";
var mdiSigmaLower = "M19,12C19,16.42 15.64,20 11.5,20C7.36,20 4,16.42 4,12C4,7.58 7.36,4 11.5,4H20V6H16.46C18,7.47 19,9.61 19,12M11.5,6C8.46,6 6,8.69 6,12C6,15.31 8.46,18 11.5,18C14.54,18 17,15.31 17,12C17,8.69 14.54,6 11.5,6Z";
var mdiSignCaution = "M2,3H22V13H18V21H16V13H8V21H6V13H2V3M18.97,11L20,9.97V7.15L16.15,11H18.97M13.32,11L19.32,5H16.5L10.5,11H13.32M7.66,11L13.66,5H10.83L4.83,11H7.66M5.18,5L4,6.18V9L8,5H5.18Z";
var mdiSignDirection = "M11,12H3.5L6,9.5L3.5,7H11V3L12,2L13,3V7H18L20.5,9.5L18,12H13V20A2,2 0 0,1 15,22H9A2,2 0 0,1 11,20V12Z";
var mdiSignDirectionMinus = "M20.5 9.5L18 12H13V22H9A2 2 0 0 1 11 20V12H3.5L6 9.5L3.5 7H11V3L12 2L13 3V7H18M23 18H15V20H23Z";
var mdiSignDirectionPlus = "M13 20H13.09A5.5 5.5 0 0 0 13.81 22H9A2 2 0 0 1 11 20V12H3.5L6 9.5L3.5 7H11V3L12 2L13 3V7H18L20.5 9.5L18 12H13M18 15V18H15V20H18V23H20V20H23V18H20V15Z";
var mdiSignDirectionRemove = "M13 20H13.09A5.5 5.5 0 0 0 13.81 22H9A2 2 0 0 1 11 20V12H3.5L6 9.5L3.5 7H11V3L12 2L13 3V7H18L20.5 9.5L18 12H13M21.12 15.46L19 17.59L16.88 15.46L15.46 16.88L17.59 19L15.46 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiSignLanguage = "M7.5 4C7.9 3.6 8.5 3.6 8.9 4L11.8 7C11 7.4 10.6 7.6 10.2 8.2L7.5 5.5C7.1 5.1 7.1 4.4 7.5 4M6.3 7.2C6.7 6.8 7.3 6.8 7.7 7.2L9.6 9.2C9.4 9.8 9.3 10.5 9.4 11H8.6L6.3 8.6C5.9 8.2 5.9 7.6 6.3 7.2M19 21.5C19 22.9 17.9 24 16.5 24H5.5C5 24 4.5 23.5 4.5 23S5 22 5.5 22H10V21H4C3.5 21 3 20.5 3 20S3.5 19 4 19H10V18H3C2.5 18 2 17.5 2 17S2.5 16 3 16H10V15H4.5C4 15 3.5 14.5 3.5 14S4 13 4.5 13H12.5L11.6 11.1C11.2 10.4 11.5 9.5 12.3 9.1L12.5 9L18.2 14.5C18.7 15 19 15.6 19 16.3V21.5M22 11.3C22 12 21.7 12.6 21.2 13.1L20.3 13.9C20.1 13.6 19.9 13.3 19.6 13L19 12.4L15.4 9L12.7 6.6L8.9 2.6C8.5 2.2 8.5 1.6 8.9 1.2C9.3 .8 9.9 .8 10.3 1.2L15.1 6.3L15.8 5.6L12 1.6C11.6 1.2 11.6 .6 12 .2S13-.2 13.4 .2L18.9 6L19.6 4C20.1 3.4 21 3 21.7 3.2L22 3.3V11.3Z";
var mdiSignLanguageOutline = "M7.5 4C7.9 3.6 8.5 3.6 8.9 4L11.8 7C11 7.4 10.6 7.6 10.2 8.2L7.5 5.5C7.1 5.1 7.1 4.4 7.5 4M6.3 7.2C6.7 6.8 7.3 6.8 7.7 7.2L9.6 9.2C9.4 9.8 9.3 10.5 9.4 11H8.6L6.3 8.6C5.9 8.2 5.9 7.6 6.3 7.2M18.2 14.5L12.5 9L12.2 9.1C11.5 9.5 11.2 10.4 11.5 11.1L12.4 13H4.4C3.9 13 3.4 13.5 3.4 14S3.9 15 4.4 15H10V16H3C2.5 16 2 16.5 2 17S2.5 18 3 18H10V19H4C3.5 19 3 19.5 3 20S3.5 21 4 21H10V22H5.5C5 22 4.5 22.5 4.5 23S5 24 5.5 24H16.5C17.9 24 19 22.9 19 21.5V16.3C19 15.6 18.7 14.9 18.2 14.5M17 21C17 21.5 16.5 22 16 22H12V15H14V13.2L16.7 15.7C16.9 15.9 17 16.2 17 16.4V21M22 11.3C22 12 21.7 12.6 21.2 13.1L20.3 13.9C20.1 13.6 19.9 13.3 19.6 13L19 12.4L19.7 11.7C19.9 11.5 20 11.2 20 11V7.3L18.7 8.5L17.3 7L15.4 9L12.7 6.6L8.9 2.6C8.5 2.2 8.5 1.6 8.9 1.2C9.3 .8 9.9 .8 10.3 1.2L15.1 6.3L15.8 5.6L12 1.6C11.6 1.2 11.6 .6 12 .2S13-.2 13.4 .2L18.9 6L19.6 4C20.1 3.4 21 3 21.7 3.2L22 3.3V11.3Z";
var mdiSignPole = "M11 3L12 2L13 3V20C14.11 20 15 20.9 15 22H9C9 20.9 9.9 20 11 20V3Z";
var mdiSignRealEstate = "M18 8H8C6.9 8 6 8.9 6 10V16C6 17.11 6.9 18 8 18H18C19.11 18 20 17.11 20 16V10C20 8.9 19.11 8 18 8M14 16H8V14H14V16M18 12H8V10H18V12M22 6H4V22H2V2H4V4H22V6Z";
var mdiSignText = "M11,3L12,2L13,3V5H20A1,1 0 0,1 21,6V16A1,1 0 0,1 20,17H13V20A2,2 0 0,1 15,22H9A2,2 0 0,1 11,20V17H4A1,1 0 0,1 3,16V6A1,1 0 0,1 4,5H11V3M6,8V10H18V8H6M6,12V14H13V12H6Z";
var mdiSignYield = "M20.5 3H3.5C2.4 3 1.6 4.3 2.2 5.3L10.7 20.2C11 20.7 11.5 21 12 21S13 20.7 13.3 20.2L21.8 5.3C22.4 4.3 21.6 3 20.5 3M12 18.5L4.3 5H19.6L12 18.5M6.9 6.5H17.1L12 15.5L6.9 6.5Z";
var mdiSignal = "M3,21H6V18H3M8,21H11V14H8M13,21H16V9H13M18,21H21V3H18V21Z";
var mdiSignal2g = "M11,19.5H2V13.5A3,3 0 0,1 5,10.5H8V7.5H2V4.5H8A3,3 0 0,1 11,7.5V10.5A3,3 0 0,1 8,13.5H5V16.5H11M22,10.5H17.5V13.5H19V16.5H16V7.5H22V4.5H16A3,3 0 0,0 13,7.5V16.5A3,3 0 0,0 16,19.5H19A3,3 0 0,0 22,16.5";
var mdiSignal3g = "M11,16.5V14.25C11,13 10,12 8.75,12C10,12 11,11 11,9.75V7.5A3,3 0 0,0 8,4.5H2V7.5H8V10.5H5V13.5H8V16.5H2V19.5H8A3,3 0 0,0 11,16.5M22,16.5V10.5H17.5V13.5H19V16.5H16V7.5H22V4.5H16A3,3 0 0,0 13,7.5V16.5A3,3 0 0,0 16,19.5H19A3,3 0 0,0 22,16.5Z";
var mdiSignal4g = "M22,16.5V10.5H17.5V13.5H19V16.5H16V7.5H22V4.5H16A3,3 0 0,0 13,7.5V16.5A3,3 0 0,0 16,19.5H19A3,3 0 0,0 22,16.5M8,19.5H11V4.5H8V10.5H5V4.5H2V13.5H8V19.5Z";
var mdiSignal5g = "M22,16.5V10.5H17.5V13.5H19V16.5H16V7.5H22V4.5H16A3,3 0 0,0 13,7.5V16.5A3,3 0 0,0 16,19.5H19A3,3 0 0,0 22,16.5M10,4.5H3V12L3,13.5H7V16.5H3V19.5H8.5A1.5,1.5 0 0,0 10,18V12A1.5,1.5 0 0,0 8.5,10.5H6V7.5H10V4.5Z";
var mdiSignalCellular1 = "M19.5,5.5V18.5H17.5V5.5H19.5M12.5,10.5V18.5H10.5V10.5H12.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z";
var mdiSignalCellular2 = "M19.5,5.5V18.5H17.5V5.5H19.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z";
var mdiSignalCellular3 = "M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z";
var mdiSignalCellularOutline = "M19.5,5.5V18.5H17.5V5.5H19.5M12.5,10.5V18.5H10.5V10.5H12.5M5.5,15.5V18.5H3.5V15.5H5.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z";
var mdiSignalDistanceVariant = "M4,6V4A12,12 0 0,1 16,16H14A10,10 0 0,0 4,6M4,10V8A8,8 0 0,1 12,16H10A6,6 0 0,0 4,10M4,12A4,4 0 0,1 8,16H4V12M3,18H19V16L22,19L19,22V20H3V18Z";
var mdiSignalHspa = "M10.5,10.5H13.5V4.5H16.5V19.5H13.5V13.5H10.5V19.5H7.5V4.5H10.5V10.5Z";
var mdiSignalHspaPlus = "M19,8V11H22V14H19V17H16V14H13V11H16V8H19M5,10.5H8V4.5H11V19.5H8V13.5H5V19.5H2V4.5H5V10.5Z";
var mdiSignalOff = "M18,3V16.18L21,19.18V3H18M4.28,5L3,6.27L10.73,14H8V21H11V14.27L13,16.27V21H16V19.27L19.73,23L21,21.72L4.28,5M13,9V11.18L16,14.18V9H13M3,18V21H6V18H3Z";
var mdiSignalVariant = "M4,6V4H4.1C12.9,4 20,11.1 20,19.9V20H18V19.9C18,12.2 11.8,6 4,6M4,10V8A12,12 0 0,1 16,20H14A10,10 0 0,0 4,10M4,14V12A8,8 0 0,1 12,20H10A6,6 0 0,0 4,14M4,16A4,4 0 0,1 8,20H4V16Z";
var mdiSignature = "M22,22H2V20H22V22M2.26,16.83L5.09,14L2.26,11.17L3.67,9.76L6.5,12.59L9.33,9.76L10.74,11.17L7.91,14L10.74,16.83L9.33,18.24L6.5,15.41L3.67,18.24L2.26,16.83Z";
var mdiSignatureFreehand = "M22,22H2V20H22V22M6.2,17.3L5.5,18L4.1,16.6L2.7,18L2,17.3L3.4,15.9L2,14.5L2.7,13.8L4.1,15.2L5.5,13.8L6.2,14.5L4.8,15.9L6.2,17.3M16.22,14.43C16.22,13.85 15.5,13.2 14.06,12.46C12.23,11.54 11,10.79 10.36,10.24C9.71,9.68 9.39,9.06 9.39,8.37C9.39,6.59 10.3,5.12 12.12,3.95C13.94,2.78 15.43,2.19 16.57,2.19C17.31,2.19 17.85,2.32 18.18,2.58C18.5,2.83 18.68,3.27 18.68,3.9C18.68,4.18 18.56,4.42 18.31,4.63C18.07,4.83 17.87,4.93 17.74,4.93C17.63,4.93 17.43,4.83 17.13,4.64L16.55,4.38C16.08,4.38 15.14,4.71 13.71,5.38C12.29,6.04 11.58,6.79 11.58,7.63C11.58,8.14 11.82,8.6 12.32,9C12.82,9.42 13.71,9.93 15,10.53C16.03,11 16.86,11.5 17.5,12.07C18.1,12.61 18.41,13.25 18.41,14C18.41,15.34 17.47,16.41 15.58,17.17C13.7,17.94 11.9,18.32 10.19,18.32C8.75,18.32 8,17.83 8,16.86C8,16.5 8.19,16.27 8.5,16.11C8.83,15.95 9.16,15.87 9.5,15.87L10.25,16L10.97,16.13C11.95,16.13 13,15.97 14.13,15.64C15.26,15.32 15.96,14.91 16.22,14.43Z";
var mdiSignatureImage = "M22,22H2V20H22V22M6.2,17.3L4.8,15.9L6.2,14.5L5.5,13.8L4.1,15.2L2.7,13.8L2,14.5L3.4,15.9L2,17.3L2.7,18L4.1,16.6L5.5,18L6.2,17.3M20,5H10A2,2 0 0,0 8,7V16A2,2 0 0,0 10,18H20A2,2 0 0,0 22,16V7A2,2 0 0,0 20,5M10,16L12.6,12.7L14.4,14.9L16.8,11.6L20,16H10Z";
var mdiSignatureText = "M22,22H2V20H22V22M6.2,17.3L4.8,15.9L6.2,14.5L5.5,13.8L4.1,15.2L2.7,13.8L2,14.5L3.4,15.9L2,17.3L2.7,18L4.1,16.6L5.5,18L6.2,17.3M20.5,3L21.7,7.4L20.7,7.7C20.2,6.8 19.8,6 19.3,5.5C18.7,5 18.1,5 17.5,5H15V15.5C15,16 15,16.5 15.3,16.7C15.6,16.9 16.3,16.9 17,16.9V17.9H11V16.9C11.7,16.9 12.3,16.9 12.7,16.7C13,16.5 13,16 13,15.5V5H10.5C9.9,5 9.3,5 8.7,5.4C8.2,5.8 7.7,6.7 7.3,7.6L6.3,7.3L7.5,3H20.5Z";
var mdiSilo = "M15 7.8C14.6 4.5 11.8 2 8.5 2C6.8 2 5.1 2.7 3.9 3.9S2 6.8 2 8.5V22H15V9.8L18 11.6V22H20V12.8L22 14V12L15 7.8M11 20H6V18H11V20M11 16H6V14H11V16M11 12H6V10H11V12M4.3 7C4.9 5.2 6.6 4 8.5 4S12.1 5.2 12.7 7H4.3Z";
var mdiSiloOutline = "M8.5,2C11.85,2 14.6,4.53 14.96,7.78L22,12V14L20,12.8V22H18V11.6L15,9.8V22H13V9H4V22H2V8.5A6.5,6.5 0 0,1 8.5,2M8.5,4C6.54,4 4.87,5.25 4.26,7H12.74C12.13,5.25 10.46,4 8.5,4M6,11H11V13H6V11M6,15H11V17H6V15M6,19H11V21H6V19Z";
var mdiSilverware = "M8.1,13.34L3.91,9.16C2.35,7.59 2.35,5.06 3.91,3.5L10.93,10.5L8.1,13.34M14.88,11.53L13.41,13L20.29,19.88L18.88,21.29L12,14.41L5.12,21.29L3.71,19.88L13.47,10.12C12.76,8.59 13.26,6.44 14.85,4.85C16.76,2.93 19.5,2.57 20.96,4.03C22.43,5.5 22.07,8.24 20.15,10.15C18.56,11.74 16.41,12.24 14.88,11.53Z";
var mdiSilverwareClean = "M15 0L14.38 1.37L13 2L14.38 2.63L15 4L15.63 2.63L17 2L15.63 1.37L15 0M10.5 2L9.41 4.41L7 5.5L9.41 6.59L10.5 9L11.6 6.59L14 5.5L11.6 4.41L10.5 2M18.89 5.14C17.56 5.06 16.04 5.65 14.84 6.84C13.25 8.43 12.75 10.58 13.46 12.11L3.7 21.87L5.11 23.28L12 16.41L18.88 23.29L20.29 21.88L13.41 15L14.88 13.53C16.41 14.24 18.56 13.74 20.15 12.15C22.06 10.24 22.43 7.5 20.96 6.03C20.41 5.5 19.68 5.19 18.89 5.14M3.91 5.5C2.35 7.06 2.35 9.59 3.91 11.16L8.1 15.34L10.93 12.5L3.91 5.5Z";
var mdiSilverwareFork = "M5.12,21.29L3.71,19.88L13.36,10.22L13.16,10C12.38,9.23 12.38,7.97 13.16,7.19L17.5,2.82L18.43,3.74L15.19,7L16.15,7.94L19.39,4.69L20.31,5.61L17.06,8.85L18,9.81L21.26,6.56L22.18,7.5L17.81,11.84C17.03,12.62 15.77,12.62 15,11.84L14.78,11.64L5.12,21.29Z";
var mdiSilverwareForkKnife = "M11,9H9V2H7V9H5V2H3V9C3,11.12 4.66,12.84 6.75,12.97V22H9.25V12.97C11.34,12.84 13,11.12 13,9V2H11V9M16,6V14H18.5V22H21V2C18.24,2 16,4.24 16,6Z";
var mdiSilverwareSpoon = "M14.88,11.53L5.12,21.29L3.71,19.88L13.47,10.12C12.76,8.59 13.26,6.44 14.85,4.85C16.76,2.93 19.5,2.57 20.96,4.03C22.43,5.5 22.07,8.24 20.15,10.15C18.56,11.74 16.41,12.24 14.88,11.53Z";
var mdiSilverwareVariant = "M8.1,13.34L3.91,9.16C2.35,7.59 2.35,5.06 3.91,3.5L10.93,10.5L8.1,13.34M13.41,13L20.29,19.88L18.88,21.29L12,14.41L5.12,21.29L3.71,19.88L13.36,10.22L13.16,10C12.38,9.23 12.38,7.97 13.16,7.19L17.5,2.82L18.43,3.74L15.19,7L16.15,7.94L19.39,4.69L20.31,5.61L17.06,8.85L18,9.81L21.26,6.56L22.18,7.5L17.81,11.84C17.03,12.62 15.77,12.62 15,11.84L14.78,11.64L13.41,13Z";
var mdiSim = "M20,4A2,2 0 0,0 18,2H10L4,8V20A2,2 0 0,0 6,22H18C19.11,22 20,21.1 20,20V4M9,19H7V17H9V19M17,19H15V17H17V19M9,15H7V11H9V15M13,19H11V15H13V19M13,13H11V11H13V13M17,15H15V11H17V15Z";
var mdiSimAlert = "M13 13H11V7H13M13 17H11V15H13M18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2Z";
var mdiSimAlertOutline = "M13 13H11V7H13M13 17H11V15H13M18 4V20H6V8.8L10.8 4H18M18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2Z";
var mdiSimOff = "M20.84 22.73L19.46 21.35C19.1 21.75 18.58 22 18 22H6C4.89 22 4 21.11 4 20V8L5.06 6.95L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M20 4C20 2.9 19.11 2 18 2H10L7.6 4.4L20 16.8V4Z";
var mdiSimOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L5.06 6.95L4 8V20C4 21.11 4.89 22 6 22H18C18.58 22 19.1 21.75 19.46 21.35L20.84 22.73L22.11 21.46M18 20H6V8.83L6.47 8.36L18 19.89V20M10.83 4H18V14.8L20 16.8V4C20 2.9 19.11 2 18 2H10L7.6 4.4L9 5.81L10.83 4Z";
var mdiSimOutline = "M18 4V20H6V8.8L10.8 4H18M18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2M9.5 19H7.5V17H9.5V19M16.5 19H14.5V17H16.5V19M9.5 15H7.5V11H9.5V15M13 19H11V15H13V19M13 13H11V11H13V13M16.5 15H14.5V11H16.5V15Z";
var mdiSimpleIcons = "M18.25 17C18.25 17.88 18.07 18.74 17.71 19.53H16.31C17.71 17.15 16.91 14.09 14.53 12.69C13.76 12.24 12.89 12 12 12C9.24 12 7 9.76 7 7C7 4.24 9.24 2 12 2C14.76 2 17 4.24 17 7H15.75C15.75 4.93 14.07 3.25 12 3.25C9.93 3.25 8.25 4.93 8.25 7C8.25 9.07 9.93 10.75 12 10.75C15.45 10.75 18.25 13.56 18.25 17M6.29 19.53C5.93 18.74 5.75 17.87 5.75 17H7C7 17.93 7.25 18.79 7.69 19.53H6.29M18.25 20.75V22H5.75V20.75H9.5V15.75H8.25V14.5H15.75V15.75H14.5V20.75H18.25M13.25 15.75H10.75V20.75H13.25V15.75M14.44 7.07C14.4 8.4 13.33 9.47 12 9.5C10.62 9.46 9.53 8.32 9.57 6.94C9.6 5.61 10.67 4.53 12 4.5C13.38 4.54 14.47 5.68 14.44 7.07M13.25 7C13.25 6.31 12.69 5.75 12 5.75C11.31 5.75 10.75 6.31 10.75 7C10.75 7.69 11.31 8.25 12 8.25C12.69 8.25 13.25 7.69 13.25 7Z";
var mdiSinaWeibo = "M9.82,13.87C10.89,13.87 11.77,14.74 11.77,15.82A1.95,1.95 0 0,1 9.82,17.77C8.74,17.77 7.87,16.89 7.87,15.82C7.87,14.74 8.74,13.87 9.82,13.87M14.5,3.34L15.18,3.31C18.94,3.31 22,6.37 22,10.13L21.95,10.95L20.76,10.58L20.78,10.13C20.78,7.04 18.27,4.53 15.18,4.53L14.83,4.54L14.5,3.34M15.32,6.23C17.38,6.3 19.05,8 19.08,10.06L17.84,9.68C17.65,8.56 16.78,7.68 15.67,7.5L15.32,6.23M2,15.41C1.97,14.8 2.07,12.64 4.95,9.97C8.35,6.81 9.82,7.05 9.82,7.05C9.82,7.05 13,6.75 11.06,10.46H11.13C11.6,9.96 12.62,9.21 14.69,9C16.77,8.79 16.77,10.5 16.5,11.7C18.38,12.64 19.56,14.03 19.56,15.58C19.56,18.4 15.63,20.69 10.78,20.69H10.65L10.5,20.69C7,20.69 4,19.42 2.71,17.59C2.25,16.97 2,16.29 2,15.58V15.41M9.82,11.92C6.59,11.92 3.97,13.67 3.97,15.82C3.97,17.97 6.59,19.72 9.82,19.72C13.05,19.72 15.67,17.97 15.67,15.82C15.67,13.67 13.05,11.92 9.82,11.92Z";
var mdiSineWave = "M16.5,21C13.5,21 12.31,16.76 11.05,12.28C10.14,9.04 9,5 7.5,5C4.11,5 4,11.93 4,12H2C2,11.63 2.06,3 7.5,3C10.5,3 11.71,7.25 12.97,11.74C13.83,14.8 15,19 16.5,19C19.94,19 20.03,12.07 20.03,12H22.03C22.03,12.37 21.97,21 16.5,21Z";
var mdiSitemap = "M9,2V8H11V11H5C3.89,11 3,11.89 3,13V16H1V22H7V16H5V13H11V16H9V22H15V16H13V13H19V16H17V22H23V16H21V13C21,11.89 20.11,11 19,11H13V8H15V2H9Z";
var mdiSitemapOutline = "M21 16V13C21 11.89 20.11 11 19 11H13V8H15V2H9V8H11V11H5C3.89 11 3 11.89 3 13V16H1V22H7V16H5V13H11V16H9V22H15V16H13V13H19V16H17V22H23V16H21M11 4H13V6H11V4M5 20H3V18H5V20M13 20H11V18H13V20M21 20H19V18H21V20Z";
var mdiSizeL = "M9 7V17H15V15H11V7H9Z";
var mdiSizeM = "M9 7C7.9 7 7 7.9 7 9V17H9V9H11V16H13V9H15V17H17V9C17 7.9 16.11 7 15 7H9Z";
var mdiSizeS = "M11 7C9.9 7 9 7.9 9 9V11C9 12.11 9.9 13 11 13H13V15H9V17H13C14.11 17 15 16.11 15 15V13C15 11.9 14.11 11 13 11H11V9H15V7H11Z";
var mdiSizeXl = "M6 7H8L9 9.5L10 7H12L10 12L12 17H10L9 14.5L8 17H6L8 12L6 7M13 7H15V15H19V17H13V7Z";
var mdiSizeXs = "M6 7H8L9 9.5L10 7H12L10 12L12 17H10L9 14.5L8 17H6L8 12L6 7M15 7H19V9H15V11H17C18.11 11 19 11.9 19 13V15C19 16.11 18.11 17 17 17H13V15H17V13H15C13.9 13 13 12.11 13 11V9C13 7.9 13.9 7 15 7Z";
var mdiSizeXxl = "M9 7H11L12 9.5L13 7H15L13 12L15 17H13L12 14.5L11 17H9L11 12L9 7M16 7H18V15H22V17H16V7M2 7H4L5 9.5L6 7H8L6 12L8 17H6L5 14.5L4 17H2L4 12L2 7Z";
var mdiSizeXxs = "M9 7H11L12 9.5L13 7H15L13 12L15 17H13L12 14.5L11 17H9L11 12L9 7M18 7H22V9H18V11H20C21.11 11 22 11.9 22 13V15C22 16.11 21.11 17 20 17H16V15H20V13H18C16.9 13 16 12.11 16 11V9C16 7.9 16.9 7 18 7M2 7H4L5 9.5L6 7H8L6 12L8 17H6L5 14.5L4 17H2L4 12L2 7Z";
var mdiSizeXxxl = "M9 7H11L12 9.5L13 7H15L13 12L15 17H13L12 14.5L11 17H9L11 12L9 7M16 7H18V15H22V17H16V7M8 15C8 16.11 7.11 17 6 17H2V15H6V13H4V11H6V9H2V7H6C7.1 7 8 7.89 8 9V10.5C8 11.33 7.33 12 6.5 12C7.33 12 8 12.67 8 13.5V15Z";
var mdiSkate = "M20.95 17C20.7 18.69 19.26 20 17.5 20H16V18H19C18.93 16.72 19.26 14.04 18.53 12.95C17.56 10.9 14.83 10.56 12.93 10.05C12 10 11 9 10.84 8H8C7.72 8 7.5 7.78 7.5 7.5C7.5 7.22 7.72 7 8 7H10.5V6H8C7.72 6 7.5 5.78 7.5 5.5C7.5 5.22 7.72 5 8 5H10.5V2H2.03V18H5V20H1V22H17.5C20.36 22 22.72 19.8 23 17H20.95M14 20H7V18H14V20Z";
var mdiSkateOff = "M19 15.81L13.36 10.16C15.22 10.62 17.63 11.05 18.53 12.95C18.95 13.57 19 14.71 19 15.81M20.95 17C20.92 17.21 20.87 17.41 20.8 17.6L22.32 19.12C22.68 18.5 22.92 17.77 23 17H20.95M10.5 7V6H9.2L10.2 7H10.5M22.11 21.46L20.84 22.73L19.66 21.55C19 21.83 18.27 22 17.5 22H1V20H5V18H2.03V3.92L1.11 3L2.03 2.09V2H2.12L2.39 1.73L22.11 21.46M14 18H7V20H14V18M18.06 19.95L16.11 18H16V20H17.5C17.69 20 17.88 20 18.06 19.95M10.5 5V2H5.2L8.2 5H10.5Z";
var mdiSkateboard = "M9 14.5C9 15.33 8.33 16 7.5 16S6 15.33 6 14.5 6.67 13 7.5 13 9 13.67 9 14.5M16.5 13C15.67 13 15 13.67 15 14.5S15.67 16 16.5 16C17.33 16 18 15.33 18 14.5S17.33 13 16.5 13M21.59 9.19C21.14 8.87 20.5 8.97 20.19 9.41L20.06 9.59C19.88 9.85 19.57 10 19.26 10L4.74 10C4.43 10 4.13 9.85 3.94 9.59L3.81 9.41C3.5 8.97 2.86 8.87 2.41 9.19C1.96 9.5 1.87 10.15 2.19 10.59L2.32 10.77C2.88 11.54 3.79 12 4.74 12H19.26C20.21 12 21.12 11.54 21.68 10.77L21.81 10.59C22.13 10.15 22.04 9.5 21.59 9.19Z";
var mdiSkateboarding = "M19.78 18.39C19.93 18.54 20 18.7 20 18.88C20 19 19.94 19.17 19.82 19.32C19.44 19.85 18.96 20.26 18.37 20.56C17.78 20.85 17.15 21 16.47 21H7.53C6.82 21 6.17 20.85 5.59 20.56C5 20.26 4.5 19.85 4.13 19.32C4.04 19.17 4 19.03 4 18.88C4 18.7 4.07 18.54 4.2 18.39S4.5 18.17 4.71 18.17C4.94 18.17 5.13 18.27 5.28 18.5C5.69 19 6.22 19.36 6.87 19.54L9.82 15.96L8.54 12.07C8.36 11.5 8.44 11 8.76 10.5L11 6.86H8.8L7 9.77L5.41 8.76L7.75 5H13.12C13.54 5 13.87 5.12 14.14 5.35C14.4 5.59 14.58 5.8 14.67 5.97L15.15 7.12C15.5 7.89 16 8.5 16.7 9C17.4 9.45 18.18 9.69 19.03 9.69V11.59C17.94 11.59 16.95 11.32 16.03 10.79C15.12 10.26 14.4 9.57 13.87 8.71L12.16 11.41L16.21 13.93V19.59H16.47C16.92 19.59 17.33 19.5 17.73 19.28S18.46 18.81 18.72 18.5C18.87 18.27 19.05 18.17 19.25 18.17S19.63 18.25 19.78 18.39M14.36 15.25L11.05 13.18L12 16.32L9.24 19.59H14.36V15.25M15 1C13.9 1 13 1.9 13 3S13.9 5 15 5 17 4.11 17 3 16.11 1 15 1M8 21.5C7.59 21.5 7.25 21.84 7.25 22.25S7.59 23 8 23C8.41 23 8.75 22.66 8.75 22.25S8.41 21.5 8 21.5M16 21.5C15.59 21.5 15.25 21.84 15.25 22.25S15.59 23 16 23 16.75 22.66 16.75 22.25 16.41 21.5 16 21.5Z";
var mdiSkewLess = "M17.5,11L15.41,20H10.5L12.59,11H17.5M20,9H11L8,22H17L20,9M4,6L8,2V5H16V7H8V10L4,6Z";
var mdiSkewMore = "M12.5,11L10.41,20H5.5L7.59,11H12.5M15,9H6L3,22H12L15,9M21,6L17,2V5H9V7H17V10L21,6Z";
var mdiSki = "M17.92 13.32C17.67 13.28 16.71 13 16.46 12.89L14.39 19.37L11.3 18.24L13.5 12.47L10.45 9L13 7.54C13.45 8.67 14.17 9.62 15.12 10.4S17.16 11.67 18.38 11.86L19.5 8.43L18.06 7.96L17.54 9.56C16.88 9.28 16.3 8.86 15.8 8.32C15.3 7.77 14.94 7.13 14.72 6.41L14.39 5.33C14.27 4.93 14.04 4.61 13.71 4.37C13.38 4.14 13 4 12.63 3.97C12.24 3.94 11.86 4 11.5 4.21L8 6.23C7.63 6.44 7.36 6.74 7.19 7.12C7 7.5 6.96 7.88 7 8.29S7.26 9.06 7.54 9.37L11.11 13.08L9.42 17.54L2.47 15.05L2 16.46L16.04 21.58C16.82 21.86 17.65 22 18.53 22C19.15 22 19.76 21.92 20.36 21.77C20.95 21.61 21.5 21.39 22 21.11L20.87 20C20.12 20.33 19.34 20.5 18.53 20.5C17.87 20.5 17.21 20.39 16.55 20.17L15.8 19.89L17.92 13.32M19 3C19 4.11 18.11 5 17 5S15 4.11 15 3 15.9 1 17 1 19 1.9 19 3Z";
var mdiSkiCrossCountry = "M19 14H17.6V22H19V14M6.44 22H5L7 14H8.44L6.44 22M8.76 9.54V13H7V8.32L11.61 6.31C12.04 6.14 12.5 6.13 12.96 6.27S13.79 6.69 14.06 7.1L15 8.58C15.37 9.25 15.9 9.95 16.62 10.37C17.33 10.79 18.13 11 19 11V12.83C18 12.83 17 12.62 16.13 12.2S14.5 11.06 13.88 10.37L13.31 13.16L15.28 15V22H13.4V16.5L11.5 14.55L9.77 22H7.8L10.43 8.89L8.76 9.54M16 4C16 5.11 15.11 6 14 6S12 5.11 12 4 12.9 2 14 2 16 2.9 16 4Z";
var mdiSkiWater = "M4.2 3.5C4.2 2.7 4.9 1.9 5.8 1.9C6.7 1.9 7.4 2.6 7.4 3.5S6.6 5 5.8 5 4.2 4.3 4.2 3.5M22 3.9L21.5 3L13.5 7.1L14 8L22 3.9M20.8 20.3L21.7 21.2C21.1 21.8 20.5 22.2 19.8 22.5S18.3 23 17.5 23H2V21.7H4.7L6.8 18.2L4.5 15L3.7 7.2C3.7 6.3 4.5 5.5 5.4 5.5C5.7 5.5 6 5.6 6.2 5.7L9.7 8.3L12 7.5L12.8 9.1L9.3 10.6C9.2 10.5 7.7 9.4 6.6 8.5L7 12L12.3 16.5L14 21.7H17.5C18.1 21.7 18.7 21.6 19.3 21.3C19.9 21.1 20.4 20.7 20.8 20.3M7 21.7H12L10.4 17.8L8.1 15.9L9.3 18.4L7 21.7Z";
var mdiSkipBackward = "M20,5V19L13,12M6,5V19H4V5M13,5V19L6,12";
var mdiSkipBackwardOutline = "M18,14.17L15.83,12L18,9.83V14.17M20,19V5L13,12M4,19H6V5H4M11,14.17L8.83,12L11,9.83V14.17M13,19V5L6,12";
var mdiSkipForward = "M4,5V19L11,12M18,5V19H20V5M11,5V19L18,12";
var mdiSkipForwardOutline = "M6,9.83L8.17,12L6,14.17V9.83M4,5V19L11,12M20,5H18V19H20M13,9.83L15.17,12L13,14.17V9.83M11,5V19L18,12";
var mdiSkipNext = "M16,18H18V6H16M6,18L14.5,12L6,6V18Z";
var mdiSkipNextCircle = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M8,8L13,12L8,16M14,8H16V16H14";
var mdiSkipNextCircleOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4M8,8V16L13,12M14,8V16H16V8";
var mdiSkipNextOutline = "M6,18L14.5,12L6,6M8,9.86L11.03,12L8,14.14M16,6H18V18H16";
var mdiSkipPrevious = "M6,18V6H8V18H6M9.5,12L18,6V18L9.5,12Z";
var mdiSkipPreviousCircle = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M8,8H10V16H8M16,8V16L11,12";
var mdiSkipPreviousCircleOutline = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4C7.59,4 4,7.59 4,12C4,16.41 7.59,20 12,20C16.41,20 20,16.41 20,12C20,7.59 16.41,4 12,4M16,8V16L11,12M10,8V16H8V8";
var mdiSkipPreviousOutline = "M6,6H8V18H6M9.5,12L18,18V6M16,14.14L12.97,12L16,9.86V14.14Z";
var mdiSkull = "M12,2A9,9 0 0,0 3,11C3,14.03 4.53,16.82 7,18.47V22H9V19H11V22H13V19H15V22H17V18.46C19.47,16.81 21,14 21,11A9,9 0 0,0 12,2M8,11A2,2 0 0,1 10,13A2,2 0 0,1 8,15A2,2 0 0,1 6,13A2,2 0 0,1 8,11M16,11A2,2 0 0,1 18,13A2,2 0 0,1 16,15A2,2 0 0,1 14,13A2,2 0 0,1 16,11M12,14L13.5,17H10.5L12,14Z";
var mdiSkullCrossbones = "M15.8,18.5L21.8,20.1L21.4,22L12,19.5L2.6,22L2.1,20.1L8.1,18.5L2,16.9L2.5,15L11.9,17.5L21.3,15L21.8,16.9L15.8,18.5M18,8C18,9.8 17.2,11.3 16,12.4V15H14V13.7L14,13H13V15H11V13H10V13.7L10,15H8V12.4C6.8,11.3 6,9.8 6,8A6,6 0 0,1 12,2A6,6 0 0,1 18,8M11,7.5C11,6.7 10.3,6 9.5,6C8.7,6 8,6.7 8,7.5C8,8.3 8.7,9 9.5,9C10.3,9 11,8.3 11,7.5M13,11L12,9L11,11H13M16,7.5C16,6.7 15.3,6 14.5,6C13.7,6 13,6.7 13,7.5C13,8.3 13.7,9 14.5,9C15.3,9 16,8.3 16,7.5Z";
var mdiSkullCrossbonesOutline = "M15.8,18.5L21.8,20.1L21.4,22L12,19.5L2.6,22L2.1,20.1L8.1,18.5L2,16.9L2.5,15L11.9,17.5L21.3,15L21.8,16.9L15.8,18.5M9.5,6C8.7,6 8,6.7 8,7.5C8,8.3 8.7,9 9.5,9C10.3,9 11,8.3 11,7.5C11,6.7 10.3,6 9.5,6M14.5,6C13.7,6 13,6.7 13,7.5C13,8.3 13.7,9 14.5,9C15.3,9 16,8.3 16,7.5C16,6.7 15.3,6 14.5,6M13,11L12,9L11,11H13M12,1C8.1,1 5,4.1 5,8C5,9.9 5.8,11.6 7,12.9V16H17V12.9C18.2,11.6 19,9.9 19,8C19,4.1 15.9,1 12,1M15,12V14H14V12H13V14H11V12H10V14H9V12H9C7.8,11.1 7,9.7 7,8C7,5.2 9.2,3 12,3C14.8,3 17,5.2 17,8C17,9.6 16.2,11.1 15,12Z";
var mdiSkullOutline = "M8,15A2,2 0 0,1 6,13A2,2 0 0,1 8,11A2,2 0 0,1 10,13A2,2 0 0,1 8,15M10.5,17L12,14L13.5,17H10.5M16,15A2,2 0 0,1 14,13A2,2 0 0,1 16,11A2,2 0 0,1 18,13A2,2 0 0,1 16,15M22,11A10,10 0 0,0 12,1A10,10 0 0,0 2,11C2,13.8 3.2,16.3 5,18.1V22H19V18.1C20.8,16.3 22,13.8 22,11M17,20H15V18H13V20H11V18H9V20H7V17.2C5.2,15.7 4,13.5 4,11A8,8 0 0,1 12,3A8,8 0 0,1 20,11C20,13.5 18.8,15.8 17,17.2V20Z";
var mdiSkullScan = "M2 0C.9 0 0 .9 0 2V6H2V2H6V0H2M18 0V2H22V6H24V2C24 .9 23.1 0 22 0H18M12 3C7.6 3 4 6.6 4 11C4 13.5 5.2 15.8 7 17.2V21H9V18H11V21H13V18H15V21H17V17.2C18.8 15.7 20 13.5 20 11C20 6.6 16.4 3 12 3M8 14C6.9 14 6 13.1 6 12S6.9 10 8 10 10 10.9 10 12 9.1 14 8 14M10.5 16L12 13L13.5 16H10.5M16 14C14.9 14 14 13.1 14 12S14.9 10 16 10 18 10.9 18 12 17.1 14 16 14M0 18V22C0 23.1 .9 24 2 24H6V22H2V18H0M22 18V22H18V24H22C23.1 24 24 23.1 24 22V18H22Z";
var mdiSkullScanOutline = "M2 0C.9 0 0 .9 0 2V6H2V2H6V0H2M18 0V2H22V6H24V2C24 .9 23.1 0 22 0H18M9.5 13C8.7 13 8 12.3 8 11.5S8.7 10 9.5 10 11 10.7 11 11.5 10.3 13 9.5 13M11 15L12 13L13 15H11M14.5 13C13.7 13 13 12.3 13 11.5S13.7 10 14.5 10 16 10.7 16 11.5 15.3 13 14.5 13M0 18V22C0 23.1 .9 24 2 24H6V22H2V18H0M22 18V22H18V24H22C23.1 24 24 23.1 24 22V18H22M12 3C7.6 3 4 6.6 4 11C4 13 4.8 14.9 6 16.3V21H18V16.3C19.2 14.9 20 13.1 20 11C20 6.6 16.4 3 12 3M16 15.4V19H14V17H13V19H11V17H10V19H8V15.4C6.8 14.3 6 12.7 6 11C6 7.7 8.7 5 12 5S18 7.7 18 11C18 12.8 17.2 14.3 16 15.4Z";
var mdiSkype = "M18,6C20.07,8.04 20.85,10.89 20.36,13.55C20.77,14.27 21,15.11 21,16A5,5 0 0,1 16,21C15.11,21 14.27,20.77 13.55,20.36C10.89,20.85 8.04,20.07 6,18C3.93,15.96 3.15,13.11 3.64,10.45C3.23,9.73 3,8.89 3,8A5,5 0 0,1 8,3C8.89,3 9.73,3.23 10.45,3.64C13.11,3.15 15.96,3.93 18,6M12.04,17.16C14.91,17.16 16.34,15.78 16.34,13.92C16.34,12.73 15.78,11.46 13.61,10.97L11.62,10.53C10.86,10.36 10,10.13 10,9.42C10,8.7 10.6,8.2 11.7,8.2C13.93,8.2 13.72,9.73 14.83,9.73C15.41,9.73 15.91,9.39 15.91,8.8C15.91,7.43 13.72,6.4 11.86,6.4C9.85,6.4 7.7,7.26 7.7,9.54C7.7,10.64 8.09,11.81 10.25,12.35L12.94,13.03C13.75,13.23 13.95,13.68 13.95,14.1C13.95,14.78 13.27,15.45 12.04,15.45C9.63,15.45 9.96,13.6 8.67,13.6C8.09,13.6 7.67,14 7.67,14.57C7.67,15.68 9,17.16 12.04,17.16Z";
var mdiSkypeBusiness = "M12.03,16.53C9.37,16.53 8.18,15.22 8.18,14.24C8.18,13.74 8.55,13.38 9.06,13.38C10.2,13.38 9.91,15 12.03,15C13.12,15 13.73,14.43 13.73,13.82C13.73,13.46 13.55,13.06 12.83,12.88L10.46,12.29C8.55,11.81 8.2,10.78 8.2,9.81C8.2,7.79 10.1,7.03 11.88,7.03C13.5,7.03 15.46,7.94 15.46,9.15C15.46,9.67 15,9.97 14.5,9.97C13.5,9.97 13.7,8.62 11.74,8.62C10.77,8.62 10.23,9.06 10.23,9.69C10.23,10.32 11,10.5 11.66,10.68L13.42,11.07C15.34,11.5 15.83,12.62 15.83,13.67C15.83,15.31 14.57,16.53 12.03,16.53M18,6C20.07,8.04 20.85,10.89 20.36,13.55C20.77,14.27 21,15.11 21,16A5,5 0 0,1 16,21C15.11,21 14.27,20.77 13.55,20.36C10.89,20.85 8.04,20.07 6,18C3.93,15.96 3.15,13.11 3.64,10.45C3.23,9.73 3,8.89 3,8A5,5 0 0,1 8,3C8.89,3 9.73,3.23 10.45,3.64C13.11,3.15 15.96,3.93 18,6M8,5A3,3 0 0,0 5,8C5,8.79 5.3,9.5 5.8,10.04C5.1,12.28 5.63,14.82 7.4,16.6C9.18,18.37 11.72,18.9 13.96,18.2C14.5,18.7 15.21,19 16,19A3,3 0 0,0 19,16C19,15.21 18.7,14.5 18.2,13.96C18.9,11.72 18.37,9.18 16.6,7.4C14.82,5.63 12.28,5.1 10.04,5.8C9.5,5.3 8.79,5 8,5Z";
var mdiSlack = "M6,15A2,2 0 0,1 4,17A2,2 0 0,1 2,15A2,2 0 0,1 4,13H6V15M7,15A2,2 0 0,1 9,13A2,2 0 0,1 11,15V20A2,2 0 0,1 9,22A2,2 0 0,1 7,20V15M9,7A2,2 0 0,1 7,5A2,2 0 0,1 9,3A2,2 0 0,1 11,5V7H9M9,8A2,2 0 0,1 11,10A2,2 0 0,1 9,12H4A2,2 0 0,1 2,10A2,2 0 0,1 4,8H9M17,10A2,2 0 0,1 19,8A2,2 0 0,1 21,10A2,2 0 0,1 19,12H17V10M16,10A2,2 0 0,1 14,12A2,2 0 0,1 12,10V5A2,2 0 0,1 14,3A2,2 0 0,1 16,5V10M14,18A2,2 0 0,1 16,20A2,2 0 0,1 14,22A2,2 0 0,1 12,20V18H14M14,17A2,2 0 0,1 12,15A2,2 0 0,1 14,13H19A2,2 0 0,1 21,15A2,2 0 0,1 19,17H14Z";
var mdiSlashForward = "M7 21L14.9 3H17L9.1 21H7Z";
var mdiSlashForwardBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.3 19H7L14.7 5H17L9.3 19Z";
var mdiSledding = "M22.91 16.64C22.75 15.95 22.44 15.34 21.97 14.81C21.5 14.28 20.91 13.91 20.2 13.69L19.77 15.14C20.43 15.33 20.91 15.73 21.23 16.36C21.54 17 21.58 17.62 21.37 18.27C21.15 18.93 20.73 19.41 20.12 19.73S18.88 20.08 18.23 19.86L14.9 18.79L15.37 17.38L18.7 18.46L19.16 17L17.2 16.4L15.14 11.91C14.95 11.5 14.66 11.19 14.27 10.97C13.88 10.75 13.45 10.67 13 10.74L10.88 11.11L11.91 7.84C12.06 7.37 12.03 6.91 11.81 6.5C11.6 6.04 11.24 5.74 10.74 5.59C10.33 5.46 9.91 5.5 9.47 5.68L4 8V12.1L2.4 11.58L1.94 13L5.87 14.3L5.4 15.7L1.47 14.44L1 15.84L17.76 21.32C18.45 21.54 19.13 21.57 19.82 21.41C20.5 21.26 21.12 20.94 21.65 20.5C22.18 20 22.55 19.43 22.77 18.74C23 18 23.07 17.32 22.91 16.64M6 9.33L7.93 8.5L6.9 11.67C6.74 12.14 6.79 12.61 7.04 13.08L6 12.75V9.33M13.5 18.32L6.81 16.17L7.27 14.76L13.92 16.92L13.5 18.32M9.47 13.87L13.45 13L14.62 15.56L9.47 13.87M14 3C14 4.11 13.11 5 12 5S10 4.11 10 3 10.9 1 12 1 14 1.9 14 3Z";
var mdiSleep = "M23,12H17V10L20.39,6H17V4H23V6L19.62,10H23V12M15,16H9V14L12.39,10H9V8H15V10L11.62,14H15V16M7,20H1V18L4.39,14H1V12H7V14L3.62,18H7V20Z";
var mdiSleepOff = "M2,5.27L3.28,4L20,20.72L18.73,22L12.73,16H9V14L9.79,13.06L2,5.27M23,12H17V10L20.39,6H17V4H23V6L19.62,10H23V12M9.82,8H15V10L13.54,11.72L9.82,8M7,20H1V18L4.39,14H1V12H7V14L3.62,18H7V20Z";
var mdiSlide = "M14.83 15.45C14.47 14.9 14.18 14.39 13.91 13.92C12.74 11.91 11.79 10.55 9 10.13V5.5C9 3.57 7.43 2 5.5 2S2 3.57 2 5.5V22H4V20H7V22H9V12.16C10.76 12.5 11.29 13.39 12.17 14.92C12.46 15.43 12.78 15.97 13.17 16.56C15.41 19.92 17.67 22 22 22V20C18.53 20 16.8 18.4 14.83 15.45M5.5 4C6.33 4 7 4.67 7 5.5V10H4V5.5C4 4.67 4.67 4 5.5 4M4 18V16H7V18H4M7 14H4V12H7V14Z";
var mdiSlopeDownhill = "M22,19V22H2V13L22,19M19.09,7.5L18.25,10.26L8.13,7.26C8.06,5.66 6.7,4.42 5.1,4.5C3.5,4.57 2.26,5.93 2.34,7.53C2.41,9.13 3.77,10.36 5.37,10.29C6.24,10.25 7.05,9.82 7.57,9.11L17.69,12.11L16.85,14.89L21.67,12.29L19.09,7.5Z";
var mdiSlopeUphill = "M22,13V22H2V19L22,13M21.68,7.06L16.86,4.46L17.7,7.24L7.58,10.24C6.63,8.95 4.82,8.67 3.53,9.62C2.24,10.57 1.96,12.38 2.91,13.67C3.85,14.97 5.67,15.24 6.96,14.29C7.67,13.78 8.1,12.97 8.14,12.09L18.26,9.09L19.1,11.87L21.68,7.06Z";
var mdiSlotMachine = "M5 12L7 8V7H4V8H6L4 12M9 12L11 8V7H8V8H10L8 12M13 12L15 8V7H12V8H14L12 12M21 2C19.9 2 19 2.9 19 4C19 4.7 19.4 5.4 20 5.7V17H17V15C17.6 15 18 14.6 18 14V5C18 4.4 17.6 4 17 4H13.2C12.4 2.8 11 2 9.5 2S6.6 2.8 5.8 4H2C1.4 4 1 4.4 1 5V14C1 14.6 1.4 15 2 15V22H17V19H20C21.1 19 22 18.1 22 17V5.7C22.6 5.4 23 4.7 23 4C23 2.9 22.1 2 21 2M13 19H6V17H13V19M16 13H3V6H16V13Z";
var mdiSlotMachineOutline = "M5 12L7 8V7H4V8H6L4 12M9 12L11 8V7H8V8H10L8 12M13 12L15 8V7H12V8H14L12 12M21 2C19.9 2 19 2.9 19 4C19 4.7 19.4 5.4 20 5.7V17H17V15C17.6 15 18 14.6 18 14V5C18 4.4 17.6 4 17 4H13.2C12.4 2.8 11 2 9.5 2S6.6 2.8 5.8 4H2C1.4 4 1 4.4 1 5V14C1 14.6 1.4 15 2 15V22H17V19H20C21.1 19 22 18.1 22 17V5.7C22.6 5.4 23 4.7 23 4C23 2.9 22.1 2 21 2M3 6H16V13H3V6M15 20H4V15H15V20M13 19H6V17H13V19Z";
var mdiSmartCard = "M2 3H22A2.07 2.07 0 0 1 24 5V19A2.07 2.07 0 0 1 22 21H2A2.07 2.07 0 0 1 0 19V5A2.07 2.07 0 0 1 2 3M8 13.91C6 13.91 2 15 2 17V18H14V17C14 15 10 13.91 8 13.91M8 6A3 3 0 1 0 11 9A3 3 0 0 0 8 6M17 10V13H21V10H17";
var mdiSmartCardOff = "M2.39 1.73L1.11 3L1.27 3.16C.545 3.47 .028 4.17 0 5V19C.036 20.09 .911 20.96 2 21H19.11L20.84 22.73L22.11 21.46L2.39 1.73M14 18H2V17C2 15 6 13.91 8 13.91S14 15 14 17V18M8 12C6.34 12 5 10.66 5 9C5 8.4 5.18 7.84 5.5 7.38L9.62 11.5C9.16 11.82 8.6 12 8 12M22 3H6.2L9.88 6.68C10.04 6.81 10.19 6.96 10.32 7.12L23.5 20.29C23.79 19.94 24 19.5 24 19V5C23.96 3.91 23.09 3.04 22 3M21 13H17V10H21V13Z";
var mdiSmartCardOffOutline = "M19 13H16.2L15 11.8V10H19V13M22 3H6.2L8.2 5H22V18.8L23.5 20.29C23.79 19.94 24 19.5 24 19V5C23.96 3.91 23.09 3.04 22 3M22.11 21.46L20.84 22.73L19.11 21H2C.911 20.96 .036 20.09 0 19V5C.028 4.17 .545 3.47 1.27 3.16L1.11 3L2.39 1.73L22.11 21.46M17.11 19L14 15.89V17H4V15.75C4 14.09 7.34 13.25 9 13.25C9.78 13.25 10.91 13.44 11.91 13.8L9.91 11.8C9.63 11.92 9.33 12 9 12C7.62 12 6.5 10.88 6.5 9.5C6.5 9.17 6.58 8.87 6.7 8.59L3.11 5H2V19H17.11Z";
var mdiSmartCardOutline = "M22 3H2A2.07 2.07 0 0 0 0 5V19A2.07 2.07 0 0 0 2 21H22A2.07 2.07 0 0 0 24 19V5A2.07 2.07 0 0 0 22 3M22 19H2V5H22M14 17V15.75C14 14.09 10.66 13.25 9 13.25S4 14.09 4 15.75V17H14M9 7A2.5 2.5 0 1 0 11.5 9.5A2.5 2.5 0 0 0 9 7M15 10V13H19V10H15";
var mdiSmartCardReader = "M21 4A2.07 2.07 0 0 0 19 2H5A2.07 2.07 0 0 0 3 4V18H21M8.25 16H7V6H8.25C9.91 6 10.75 9.34 10.75 11S9.91 16 8.25 16M14.5 13.5A2.5 2.5 0 1 1 17 11A2.5 2.5 0 0 1 14.5 13.5M23 21V22H1V21A2 2 0 0 1 3 19H21A2 2 0 0 1 23 21Z";
var mdiSmartCardReaderOutline = "M14.5 8.5A2.5 2.5 0 1 0 17 11A2.5 2.5 0 0 0 14.5 8.5M8.25 6H7V16H8.25C9.91 16 10.75 12.66 10.75 11S9.91 6 8.25 6M19 2H5A2.07 2.07 0 0 0 3 4V18H5V4H19V18H21V4A2.07 2.07 0 0 0 19 2M23 22H1V21A2 2 0 0 1 3 19H21A2 2 0 0 1 23 21Z";
var mdiSmog = "M12,2C10.08,2 8.5,3.35 8.09,5.15C7.45,4.44 6.53,4 5.5,4A3.5,3.5 0 0,0 2,7.5H2A3.5,3.5 0 0,0 5.5,11H6.68V12H10.72V11H13.28V12H17.32V11H18.5A3.5,3.5 0 0,0 22,7.5H22A3.5,3.5 0 0,0 18.5,4H18.5C17.47,4 16.55,4.44 15.91,5.15C15.5,3.35 13.92,2 12,2M7.2,14L6.4,22H11L10.2,14H7.2M13.8,14L13,22H17.6L16.8,14H13.8Z";
var mdiSmoke = "M17 19V22H15V19C15 17.9 14.1 17 13 17H10C7.2 17 5 14.8 5 12C5 10.8 5.4 9.8 6.1 8.9C3.8 8.5 2 6.4 2 4C2 3.3 2.2 2.6 2.4 2H4.8C4.3 2.5 4 3.2 4 4C4 5.7 5.3 7 7 7H10V9C8.3 9 7 10.3 7 12S8.3 15 10 15H13C15.2 15 17 16.8 17 19M17.9 8.9C20.2 8.5 22 6.4 22 4C22 3.3 21.8 2.6 21.6 2H19.2C19.7 2.5 20 3.2 20 4C20 5.7 18.7 7 17 7H15.8C15.9 7.3 16 7.6 16 8C16 9.7 14.7 11 13 11V13C15.8 13 18 15.2 18 18V22H20V18C20 15.3 18.5 13 16.2 11.8C17.1 11.1 17.7 10.1 17.9 8.9Z";
var mdiSmokeDetector = "M12,18A6,6 0 0,0 18,12C18,8.68 15.31,6 12,6C8.68,6 6,8.68 6,12A6,6 0 0,0 12,18M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M8,12A4,4 0 0,1 12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12Z";
var mdiSmokeDetectorAlert = "M10 18C13.3 18 16 15.3 16 12C16 8.7 13.3 6 10 6C6.7 6 4 8.7 4 12C4 15.3 6.7 18 10 18M17 3C18.1 3 19 3.9 19 5V19C19 20.1 18.1 21 17 21H3C1.9 21 1 20.1 1 19V5C1 3.9 1.9 3 3 3H17M6 12C6 9.8 7.8 8 10 8S14 9.8 14 12 12.2 16 10 16 6 14.2 6 12M23 7H21V13H23V8M23 15H21V17H23V15Z";
var mdiSmokeDetectorAlertOutline = "M17 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H17C18.1 21 19 20.1 19 19V5C19 3.9 18.1 3 17 3M17 19H3V5H17V19M10 18C13.3 18 16 15.3 16 12C16 8.7 13.3 6 10 6C6.7 6 4 8.7 4 12C4 15.3 6.7 18 10 18M10 8C12.2 8 14 9.8 14 12S12.2 16 10 16 6 14.2 6 12 7.8 8 10 8M23 7H21V13H23V8M23 15H21V17H23V15Z";
var mdiSmokeDetectorOff = "M12 8C14.21 8 16 9.79 16 12C16 12.25 15.97 12.5 15.93 12.73L11.27 8.07C11.5 8.03 11.75 8 12 8M12 6C15.31 6 18 8.68 18 12C18 12.83 17.82 13.6 17.5 14.32L21 17.8V5C21 3.9 20.11 3 19 3H6.2L9.68 6.5C10.4 6.18 11.17 6 12 6M22.11 21.46L20.84 22.73L19.1 21C19.07 21 19.03 21 19 21H5C3.89 21 3 20.1 3 19V5C3 4.97 3 4.93 3 4.9L1.11 3L2.39 1.73L22.11 21.46M15.19 17.08L13.71 15.6C13.19 15.85 12.62 16 12 16C9.79 16 8 14.21 8 12C8 11.39 8.15 10.81 8.4 10.29L6.92 8.81C6.34 9.74 6 10.83 6 12C6 15.31 8.69 18 12 18C13.17 18 14.26 17.66 15.19 17.08Z";
var mdiSmokeDetectorOffOutline = "M8.2 5L6.2 3H19C20.11 3 21 3.9 21 5V17.8L19 15.8V5H8.2M17.5 14.32C17.82 13.6 18 12.83 18 12C18 8.68 15.31 6 12 6C11.17 6 10.4 6.18 9.68 6.5L11.27 8.07C11.5 8.03 11.75 8 12 8C14.21 8 16 9.79 16 12C16 12.25 15.97 12.5 15.93 12.73L17.5 14.32M22.11 21.46L20.84 22.73L19.1 21C19.07 21 19.03 21 19 21H5C3.89 21 3 20.1 3 19V5C3 4.97 3 4.93 3 4.9L1.11 3L2.39 1.73L22.11 21.46M8 12C8 14.21 9.79 16 12 16C12.62 16 13.19 15.85 13.71 15.6L8.4 10.29C8.15 10.81 8 11.39 8 12M17.11 19L15.19 17.08C14.26 17.66 13.17 18 12 18C8.69 18 6 15.31 6 12C6 10.83 6.34 9.74 6.92 8.81L5 6.89V19H17.11Z";
var mdiSmokeDetectorOutline = "M19 3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M19 19H5V5H19V19M12 18C15.31 18 18 15.31 18 12C18 8.68 15.31 6 12 6C8.68 6 6 8.68 6 12C6 15.31 8.69 18 12 18M12 8C14.21 8 16 9.79 16 12S14.21 16 12 16 8 14.21 8 12 9.79 8 12 8Z";
var mdiSmokeDetectorVariant = "M12 4C16.41 4 20 7.59 20 12S16.41 20 12 20 4 16.41 4 12 7.59 4 12 4M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 11C11.45 11 11 11.45 11 12S11.45 13 12 13 13 12.55 13 12 12.55 11 12 11M10.72 9.3C11.11 9.11 11.54 9 12 9S12.89 9.11 13.29 9.3L14 8.57C13.43 8.22 12.74 8 12 8S10.58 8.22 10 8.57L10.72 9.3M15 12C15 12.46 14.89 12.89 14.7 13.29L15.43 14C15.79 13.43 16 12.74 16 12S15.79 10.58 15.43 10L14.7 10.72C14.89 11.11 15 11.54 15 12M9 12C9 11.54 9.11 11.11 9.3 10.72L8.57 10C8.22 10.58 8 11.26 8 12S8.22 13.43 8.57 14L9.3 13.29C9.11 12.89 9 12.46 9 12M13.29 14.7C12.89 14.89 12.46 15 12 15S11.11 14.89 10.72 14.7L10 15.43C10.58 15.79 11.26 16 12 16S13.43 15.79 14 15.43L13.29 14.7M16.89 8.53L16.17 9.25C16.69 10.04 17 11 17 12S16.69 13.96 16.17 14.75L16.89 15.47C17.59 14.5 18 13.3 18 12S17.59 9.5 16.89 8.53M9.25 7.83C10.04 7.31 11 7 12 7S13.96 7.31 14.75 7.83L15.47 7.11C14.5 6.42 13.3 6 12 6S9.5 6.42 8.53 7.11L9.25 7.83M14.75 16.17C13.96 16.69 13 17 12 17S10.04 16.69 9.25 16.17L8.53 16.89C9.5 17.59 10.7 18 12 18S14.5 17.59 15.47 16.89L14.75 16.17M7.83 14.75C7.31 13.96 7 13 7 12S7.31 10.04 7.83 9.25L7.11 8.53C6.42 9.5 6 10.7 6 12S6.42 14.5 7.11 15.47L7.83 14.75Z";
var mdiSmokeDetectorVariantAlert = "M10 4C14.4 4 18 7.6 18 12S14.4 20 10 20 2 16.4 2 12 5.6 4 10 4M10 2C4.5 2 0 6.5 0 12S4.5 22 10 22 20 17.5 20 12 15.5 2 10 2M10 11C9.4 11 9 11.4 9 12S9.4 13 10 13 11 12.6 11 12 10.6 11 10 11M8.7 9.3C9.1 9.1 9.5 9 10 9S10.9 9.1 11.3 9.3L12 8.6C11.4 8.2 10.7 8 10 8S8.6 8.2 8 8.6L8.7 9.3M13 12C13 12.5 12.9 12.9 12.7 13.3L13.4 14C13.8 13.4 14 12.7 14 12S13.8 10.6 13.4 10L12.7 10.7C12.9 11.1 13 11.5 13 12M7 12C7 11.5 7.1 11.1 7.3 10.7L6.6 10C6.2 10.6 6 11.3 6 12S6.2 13.4 6.6 14L7.3 13.3C7.1 12.9 7 12.5 7 12M11.3 14.7C10.9 14.9 10.5 15 10 15S9.1 14.9 8.7 14.7L8 15.4C8.6 15.8 9.3 16 10 16S11.4 15.8 12 15.4L11.3 14.7M14.9 8.5L14.2 9.2C14.7 10 15 11 15 12S14.7 14 14.2 14.8L14.9 15.5C15.6 14.5 16 13.3 16 12S15.6 9.5 14.9 8.5M7.2 7.8C8 7.3 9 7 10 7S12 7.3 12.8 7.8L13.5 7.1C12.5 6.4 11.3 6 10 6S7.5 6.4 6.5 7.1L7.2 7.8M12.8 16.2C12 16.7 11 17 10 17S8 16.7 7.2 16.2L6.5 16.9C7.5 17.6 8.7 18 10 18S12.5 17.6 13.5 16.9L12.8 16.2M5.8 14.8C5.3 14 5 13 5 12S5.3 10 5.8 9.2L5.1 8.5C4.4 9.5 4 10.7 4 12S4.4 14.5 5.1 15.5L5.8 14.8M24 7H22V13H24V8M24 15H22V17H24V15Z";
var mdiSmokeDetectorVariantOff = "M22.11 21.46L2.39 1.73L1.11 3L4.06 5.95C2.77 7.63 2 9.72 2 12C2 17.5 6.5 22 12 22C14.28 22 16.37 21.23 18.05 19.94L20.84 22.73L22.11 21.46M12 20C7.59 20 4 16.41 4 12C4 10.28 4.56 8.69 5.5 7.38L6.93 8.82C6.35 9.75 6 10.83 6 12C6 13.3 6.42 14.5 7.11 15.47L7.83 14.75C7.31 13.96 7 13 7 12C7 11.11 7.25 10.28 7.66 9.55L8.4 10.3C8.15 10.81 8 11.39 8 12C8 12.74 8.22 13.43 8.57 14L9.3 13.29C9.11 12.89 9 12.46 9 12C9 11.67 9.07 11.36 9.18 11.07L12.93 14.82C12.64 14.93 12.33 15 12 15C11.54 15 11.11 14.89 10.72 14.7L10 15.43C10.58 15.79 11.26 16 12 16C12.61 16 13.19 15.85 13.71 15.6L14.45 16.34C13.72 16.75 12.89 17 12 17C11 17 10.04 16.69 9.25 16.17L8.53 16.89C9.5 17.59 10.7 18 12 18C13.17 18 14.25 17.65 15.18 17.07L16.62 18.5C15.32 19.44 13.72 20 12 20M12 8C12.74 8 13.43 8.22 14 8.57L13.29 9.3C12.96 9.15 12.6 9.06 12.23 9.03L11.28 8.08C11.5 8.03 11.75 8 12 8M14.97 11.77C14.94 11.4 14.86 11.04 14.7 10.72L15.43 10C15.79 10.58 16 11.26 16 12C16 12.25 15.97 12.5 15.92 12.72L14.97 11.77M14.75 7.83C13.96 7.31 13 7 12 7C11.46 7 10.94 7.09 10.45 7.25L9.69 6.5C10.4 6.18 11.18 6 12 6C13.3 6 14.5 6.42 15.47 7.11L14.75 7.83M8.18 5L6.72 3.5C8.25 2.56 10.06 2 12 2C17.5 2 22 6.5 22 12C22 13.94 21.44 15.75 20.5 17.28L19 15.83C19.65 14.69 20 13.38 20 12C20 7.59 16.41 4 12 4C10.62 4 9.31 4.35 8.18 5M16.75 13.55C16.91 13.06 17 12.54 17 12C17 11 16.69 10.04 16.17 9.25L16.89 8.53C17.59 9.5 18 10.7 18 12C18 12.83 17.82 13.6 17.5 14.32L16.75 13.55Z";
var mdiSmoking = "M2,16H17V19H2V16M20.5,16H22V19H20.5V16M18,16H19.5V19H18V16M18.85,7.73C19.47,7.12 19.85,6.28 19.85,5.35C19.85,3.5 18.35,2 16.5,2V3.5C17.5,3.5 18.35,4.33 18.35,5.35C18.35,6.37 17.5,7.2 16.5,7.2V8.7C18.74,8.7 20.5,10.53 20.5,12.77V15H22V12.76C22,10.54 20.72,8.62 18.85,7.73M16.03,10.2H14.5C13.5,10.2 12.65,9.22 12.65,8.2C12.65,7.18 13.5,6.45 14.5,6.45V4.95C12.65,4.95 11.15,6.45 11.15,8.3A3.35,3.35 0 0,0 14.5,11.65H16.03C17.08,11.65 18,12.39 18,13.7V15H19.5V13.36C19.5,11.55 17.9,10.2 16.03,10.2Z";
var mdiSmokingOff = "M2,6L9,13H2V16H12L19,23L20.25,21.75L3.25,4.75L2,6M20.5,13H22V16H20.5V13M18,13H19.5V16H18V13M18.85,4.88C19.47,4.27 19.85,3.43 19.85,2.5H18.35C18.35,3.5 17.5,4.35 16.5,4.35V5.85C18.74,5.85 20.5,7.68 20.5,9.92V12H22V9.92C22,7.69 20.72,5.77 18.85,4.88M14.5,8.7H16.03C17.08,8.7 18,9.44 18,10.75V12H19.5V10.41C19.5,8.61 17.9,7.25 16.03,7.25H14.5C13.5,7.25 12.65,6.27 12.65,5.25C12.65,4.23 13.5,3.5 14.5,3.5V2A3.35,3.35 0 0,0 11.15,5.35A3.35,3.35 0 0,0 14.5,8.7M17,15.93V13H14.07L17,15.93Z";
var mdiSmokingPipe = "M16 13C14.89 13 14 13.89 14 15V18H13C12 18 11 17.92 10.3 17.23L6.53 13.47C5.6 12.53 4.33 12 3 12H2V14H3C3.8 14 4.56 14.32 5.12 14.88L8.89 18.65C11.72 21.5 13 22 16 22H18C20.21 22 22 20.21 22 18V15C22 13.89 21.11 13 20 13H16M14 7.2H12.5C11.45 7.12 10.65 6.25 10.65 5.2C10.67 4.22 11.5 3.43 12.46 3.45L12.5 3.45V2C10.65 2 9.15 3.5 9.15 5.35S10.65 8.7 12.5 8.7H14C15.07 8.66 15.96 9.5 16 10.56C16 10.61 16 10.65 16 10.7V12H17.5V10.36C17.42 8.53 15.88 7.12 14.05 7.2L14 7.2M20 9.76V12H18.5V9.77L18.5 9.7C18.5 7.5 16.71 5.7 14.5 5.7V4.2H14.5C15.5 4.2 16.35 3.37 16.35 2.35C16.35 2.23 16.34 2.11 16.32 2H17.79C17.89 3 17.58 4 16.82 4.73H16.85C18.78 5.66 20 7.62 20 9.76Z";
var mdiSmokingPipeOff = "M20.84 22.73L19.71 21.6C19.19 21.85 18.62 22 18 22H16C13 22 11.72 21.5 8.89 18.65L5.12 14.88C4.56 14.32 3.8 14 3 14H2V12H3C4.33 12 5.6 12.53 6.53 13.47L10.3 17.23C11 17.92 12 18 13 18H14V15.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M21.93 18.73C21.97 18.5 22 18.25 22 18V15C22 13.89 21.11 13 20 13H16.2L21.93 18.73M18.5 9.7L18.5 9.77V12H20V9.76C20 7.62 18.78 5.66 16.85 4.73H16.82C17.58 4 17.9 3 17.8 2H16.32C16.34 2.11 16.35 2.23 16.35 2.35C16.35 3.37 15.5 4.2 14.5 4.2H14.5V5.7C16.71 5.7 18.5 7.5 18.5 9.7M11.83 8.63C12.05 8.68 12.27 8.7 12.5 8.7H14C15.07 8.66 15.96 9.5 16 10.56C16 10.61 16 10.65 16 10.7V12H17.5V10.36C17.42 8.53 15.88 7.12 14.05 7.2L14 7.2H12.5C11.45 7.12 10.65 6.25 10.65 5.2C10.67 4.22 11.5 3.43 12.46 3.45L12.5 3.45V2C10.65 2 9.15 3.5 9.15 5.35C9.15 5.58 9.17 5.8 9.22 6L11.83 8.63Z";
var mdiSnail = "M20.31 8.03L21.24 4.95C21.67 4.85 22 4.47 22 4C22 3.45 21.55 3 21 3S20 3.45 20 4C20 4.26 20.11 4.5 20.27 4.68L19.5 7.26L18.73 4.68C18.89 4.5 19 4.26 19 4C19 3.45 18.55 3 18 3S17 3.45 17 4C17 4.47 17.33 4.85 17.76 4.95L18.69 8.03C17.73 8.18 17 9 17 10V12.25C15.65 9.16 12.63 7 9.11 7C5.19 7 2 10.26 2 14.26C2 16.1 2.82 17.75 4.1 18.85L2.88 19C2.38 19.06 2 19.5 2 20C2 20.55 2.45 21 3 21L19.12 21C20.16 21 21 20.16 21 19.12V11.72C21.6 11.38 22 10.74 22 10C22 9 21.27 8.18 20.31 8.03M15.6 17.41L12.07 17.86C12.5 17.1 12.8 16.21 12.8 15.26C12.8 12.94 10.95 11.06 8.67 11.06C8.14 11.06 7.62 11.18 7.14 11.41C6.65 11.66 6.44 12.26 6.69 12.75C6.93 13.25 7.53 13.45 8.03 13.21C8.23 13.11 8.45 13.06 8.67 13.06C9.85 13.06 10.8 14.04 10.8 15.26C10.8 16.92 9.5 18.27 7.89 18.27C5.75 18.27 4 16.47 4 14.26C4 11.36 6.29 9 9.11 9C12.77 9 15.75 12.06 15.75 15.82C15.75 16.36 15.69 16.89 15.6 17.41Z";
var mdiSnake = "M19.5 17H18C19.1 17 20 16.1 20 15S19.1 13 18 13V9C18 8 18 7 16.92 6.14C16.97 5.93 17 5.72 17 5.5C17 3.57 15 2 12.5 2C10.24 2 8.38 3.31 8.07 5H6L3.71 2.79L3 3.5L5 5.5L3 7.5L3.71 8.21L6 6H8.07C8.38 7.69 10.24 9 12.5 9C13 9 13.5 8.92 13.93 8.8C13.97 8.87 14 8.94 14 9V13H8C6.9 13 6 13.9 6 15S6.9 17 8 17H6.5C5.12 17 4 18.12 4 19.5C4 19.67 4 19.84 4.05 20H4C2.9 20 2 20.9 2 22H19.5C20.88 22 22 20.88 22 19.5S20.88 17 19.5 17M12 5C11.45 5 11 4.55 11 4S11.45 3 12 3 13 3.45 13 4 12.55 5 12 5Z";
var mdiSnapchat = "M21.93 16.56C21.79 16.18 21.5 16 21.22 15.81C21.17 15.78 21.11 15.75 21.07 15.73C21 15.68 20.89 15.64 20.8 15.59C19.86 15.09 19.12 14.46 18.61 13.72C18.47 13.5 18.35 13.29 18.24 13.06C18.2 12.93 18.2 12.86 18.23 12.8C18.26 12.75 18.3 12.7 18.35 12.67C18.5 12.56 18.68 12.46 18.79 12.38C19 12.25 19.15 12.15 19.25 12.08C19.64 11.81 19.91 11.5 20.08 11.2C20.32 10.75 20.35 10.22 20.16 9.75C19.91 9.08 19.27 8.66 18.5 8.66C18.34 8.66 18.18 8.68 18 8.71C18 8.72 17.94 8.73 17.9 8.74C17.9 8.28 17.89 7.8 17.85 7.32C17.71 5.64 17.12 4.76 16.5 4.06C16.11 3.62 15.65 3.24 15.14 2.95C14.21 2.42 13.15 2.15 12 2.15S9.8 2.42 8.87 2.95C8.35 3.24 7.89 3.62 7.5 4.06C6.88 4.76 6.3 5.64 6.15 7.32C6.11 7.8 6.1 8.28 6.11 8.74C6.06 8.73 6 8.72 6 8.71C5.82 8.68 5.66 8.66 5.5 8.66C4.73 8.66 4.09 9.08 3.84 9.75C3.65 10.22 3.68 10.75 3.92 11.2C4.09 11.5 4.36 11.81 4.75 12.08C4.85 12.15 5 12.25 5.21 12.39L5.63 12.66C5.69 12.7 5.73 12.75 5.77 12.8C5.8 12.87 5.8 12.94 5.75 13.07C5.65 13.3 5.53 13.5 5.39 13.72C4.89 14.45 4.18 15.07 3.27 15.56C2.78 15.82 2.28 16 2.07 16.56C1.91 17 2 17.5 2.42 17.91C2.57 18.06 2.74 18.19 2.93 18.29C3.33 18.5 3.75 18.68 4.18 18.79C4.27 18.82 4.36 18.85 4.43 18.91C4.58 19.03 4.56 19.23 4.76 19.5C4.86 19.66 5 19.79 5.13 19.89C5.54 20.18 6 20.19 6.5 20.21C6.94 20.23 7.44 20.25 8 20.44C8.26 20.5 8.5 20.67 8.79 20.85C9.5 21.27 10.42 21.85 12 21.85C13.57 21.85 14.5 21.27 15.22 20.84C15.5 20.67 15.75 20.5 16 20.44C16.55 20.25 17.06 20.23 17.5 20.21C18 20.2 18.46 20.18 18.87 19.89C19.04 19.77 19.18 19.61 19.29 19.43C19.43 19.19 19.43 19 19.56 18.91C19.63 18.86 19.71 18.82 19.8 18.8C20.24 18.68 20.66 18.5 21.06 18.29C21.27 18.18 21.45 18.04 21.6 17.87L21.61 17.87C22 17.46 22.08 17 21.93 16.56M20.53 17.31C19.67 17.78 19.1 17.73 18.66 18C18.5 18.12 18.45 18.28 18.42 18.44C18.41 18.5 18.4 18.58 18.39 18.64C18.37 18.78 18.34 18.9 18.24 18.97C17.9 19.2 16.91 18.95 15.63 19.37C14.57 19.72 13.9 20.73 12 20.73C10.1 20.73 9.45 19.73 8.37 19.37C7.1 18.95 6.1 19.2 5.77 18.97C5.5 18.78 5.72 18.26 5.34 18C4.9 17.73 4.33 17.78 3.5 17.31C3.19 17.15 3.14 17 3.18 16.93C3.22 16.84 3.34 16.77 3.42 16.73C5.07 15.94 6 14.91 6.47 14.1C6.91 13.38 7 12.83 7.03 12.75C7.06 12.54 7.09 12.38 6.86 12.17C6.64 11.96 5.66 11.36 5.39 11.17C4.93 10.85 4.74 10.54 4.88 10.15L4.88 10.15V10.15C5 9.88 5.23 9.78 5.5 9.78C5.58 9.78 5.66 9.79 5.74 9.81C6.24 9.91 6.72 10.16 7 10.23C7.03 10.24 7.06 10.24 7.1 10.24C7.19 10.24 7.24 10.21 7.27 10.15C7.28 10.11 7.29 10.06 7.29 10C7.25 9.46 7.18 8.41 7.26 7.42C7.3 7 7.37 6.64 7.46 6.33C7.66 5.65 8 5.2 8.34 4.79C8.59 4.5 9.75 3.27 12 3.27C13.85 3.27 14.96 4.11 15.44 4.56C15.54 4.66 15.62 4.74 15.66 4.79C16.04 5.23 16.38 5.71 16.58 6.47C16.65 6.74 16.71 7.06 16.74 7.42C16.82 8.4 16.75 9.46 16.71 10C16.71 10.04 16.71 10.08 16.72 10.11C16.73 10.2 16.79 10.24 16.9 10.24C16.94 10.24 16.97 10.24 17 10.23C17.28 10.16 17.76 9.91 18.26 9.8C18.34 9.79 18.42 9.78 18.5 9.78C18.75 9.78 19 9.87 19.1 10.1L19.11 10.14L19.12 10.14L19.12 10.15C19.27 10.53 19.07 10.85 18.62 11.16C18.35 11.35 17.36 11.96 17.14 12.16C16.91 12.38 16.94 12.54 16.97 12.75C17 12.85 17.18 13.8 18.08 14.86C18.63 15.5 19.42 16.17 20.58 16.73C20.65 16.76 20.74 16.81 20.79 16.87C20.82 16.92 20.84 16.96 20.83 17C20.82 17.1 20.73 17.2 20.53 17.31Z";
var mdiSnowboard = "M21.87 20.37C21.76 20.2 21.62 20.09 21.43 20.06C21.18 20 20.96 20.05 20.78 20.2C20.43 20.5 20.04 20.73 19.58 20.86C19.13 21 18.66 21 18.16 20.9L17.04 20.62L16 14.46L12.74 11.79L14.5 8.94C15.08 9.85 15.85 10.58 16.83 11.14C17.81 11.7 18.88 12 20.03 12V9.97C19.09 9.97 18.26 9.72 17.53 9.22S16.26 8.07 15.92 7.26L15.36 6.05C15.26 5.86 15.08 5.64 14.82 5.39C14.55 5.14 14.19 5 13.72 5H8.07L5.54 9L7.27 10.06L9.14 7H11.5L9 10.95C8.69 11.42 8.6 11.93 8.72 12.5L9.56 15.95L6.06 18.29L5.59 18.19C5.13 18.1 4.7 17.91 4.33 17.61C3.96 17.31 3.68 16.96 3.5 16.56C3.4 16.31 3.23 16.17 3 16.14C2.76 16.08 2.56 16.11 2.39 16.23S2.12 16.5 2.09 16.7C2.06 16.85 2.07 17 2.13 17.17C2.42 17.79 2.83 18.33 3.37 18.78C3.92 19.23 4.55 19.5 5.27 19.64L17.88 22.35C18.6 22.5 19.29 22.5 19.96 22.3C20.63 22.12 21.23 21.79 21.76 21.32C21.88 21.23 21.96 21.11 22 20.95C22 20.73 22 20.54 21.87 20.37M8.77 18.89L11.81 16.89L11.34 13.57L14.19 15.58L14.94 20.2L8.77 18.89M18 3C18 4.11 17.11 5 16 5S14 4.11 14 3 14.9 1 16 1 18 1.9 18 3Z";
var mdiSnowflake = "M20.79,13.95L18.46,14.57L16.46,13.44V10.56L18.46,9.43L20.79,10.05L21.31,8.12L19.54,7.65L20,5.88L18.07,5.36L17.45,7.69L15.45,8.82L13,7.38V5.12L14.71,3.41L13.29,2L12,3.29L10.71,2L9.29,3.41L11,5.12V7.38L8.5,8.82L6.5,7.69L5.92,5.36L4,5.88L4.47,7.65L2.7,8.12L3.22,10.05L5.55,9.43L7.55,10.56V13.45L5.55,14.58L3.22,13.96L2.7,15.89L4.47,16.36L4,18.12L5.93,18.64L6.55,16.31L8.55,15.18L11,16.62V18.88L9.29,20.59L10.71,22L12,20.71L13.29,22L14.7,20.59L13,18.88V16.62L15.5,15.17L17.5,16.3L18.12,18.63L20,18.12L19.53,16.35L21.3,15.88L20.79,13.95M9.5,10.56L12,9.11L14.5,10.56V13.44L12,14.89L9.5,13.44V10.56Z";
var mdiSnowflakeAlert = "M16.46,9.41L13,7.38V5.12L14.71,3.41L13.29,2L12,3.29L10.71,2L9.29,3.41L11,5.12V7.38L8.5,8.82L6.5,7.69L5.92,5.36L4,5.88L4.47,7.65L2.7,8.12L3.22,10.05L5.55,9.43L7.55,10.56V13.45L5.55,14.58L3.22,13.96L2.7,15.89L4.47,16.36L4,18.12L5.93,18.64L6.55,16.31L8.55,15.18L11,16.62V18.88L9.29,20.59L10.71,22L12,20.71L13.29,22L14.7,20.59L13,18.88V16.62L16.46,14.61M9.5,10.56L12,9.11L14.5,10.56V13.44L12,14.89L9.5,13.44M19,13V7H21V13H19M19,17V15H21V17H19Z";
var mdiSnowflakeCheck = "M17.75 21.16L15 18.16L16.16 17L17.75 18.59L21.34 15L22.5 16.41L17.75 21.16M12 18C12 16.46 12.59 15.06 13.54 14L12 14.89L9.5 13.44V10.56L12 9.11L14.5 10.56V13.13C15.08 12.71 15.75 12.4 16.46 12.21V10.56L18.46 9.43L20.79 10.05L21.31 8.12L19.54 7.65L20 5.88L18.07 5.36L17.45 7.69L15.45 8.82L13 7.38V5.12L14.71 3.41L13.29 2L12 3.29L10.71 2L9.29 3.41L11 5.12V7.38L8.5 8.82L6.5 7.69L5.92 5.36L4 5.88L4.47 7.65L2.7 8.12L3.22 10.05L5.55 9.43L7.55 10.56V13.45L5.55 14.58L3.22 13.96L2.7 15.89L4.47 16.36L4 18.12L5.93 18.64L6.55 16.31L8.55 15.18L11 16.62V18.88L9.29 20.59L10.71 22L12 20.71L13.29 22L13.42 21.87C12.54 20.83 12 19.5 12 18Z";
var mdiSnowflakeMelt = "M8 17.85C8 19.04 7.11 20 6 20S4 19.04 4 17.85C4 16.42 6 14 6 14S8 16.42 8 17.85M16.46 12V10.56L18.46 9.43L20.79 10.05L21.31 8.12L19.54 7.65L20 5.88L18.07 5.36L17.45 7.69L15.45 8.82L13 7.38V5.12L14.71 3.41L13.29 2L12 3.29L10.71 2L9.29 3.41L11 5.12V7.38L8.5 8.82L6.5 7.69L5.92 5.36L4 5.88L4.47 7.65L2.7 8.12L3.22 10.05L5.55 9.43L7.55 10.56V12H2V13H22V12H16.46M9.5 12V10.56L12 9.11L14.5 10.56V12H9.5M20 17.85C20 19.04 19.11 20 18 20S16 19.04 16 17.85C16 16.42 18 14 18 14S20 16.42 20 17.85M14 20.85C14 22.04 13.11 23 12 23S10 22.04 10 20.85C10 19.42 12 17 12 17S14 19.42 14 20.85Z";
var mdiSnowflakeOff = "M11 5.12L9.29 3.41L10.71 2L12 3.29L13.29 2L14.71 3.41L13 5.12V7.38L15.45 8.82L17.45 7.69L18.07 5.36L20 5.88L19.54 7.65L21.31 8.12L20.79 10.05L18.46 9.43L16.46 10.56V13.26L14.5 11.3V10.56L12.74 9.54L10.73 7.53L11 7.38V5.12M18.46 14.57L16.87 13.67L19.55 16.35L21.3 15.88L20.79 13.95L18.46 14.57M13 16.62V18.88L14.7 20.59L13.29 22L12 20.71L10.71 22L9.29 20.59L11 18.88V16.62L8.55 15.18L6.55 16.31L5.93 18.64L4 18.12L4.47 16.36L2.7 15.89L3.22 13.96L5.55 14.58L7.55 13.45V10.56L5.55 9.43L3.22 10.05L2.7 8.12L4.47 7.65L4 5.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73L14.1 16L13 16.62M12 14.89L12.63 14.5L9.5 11.39V13.44L12 14.89Z";
var mdiSnowflakeThermometer = "M14.46 9.41L11 7.38V5.12L12.71 3.41L11.29 2L10 3.29L8.71 2L7.29 3.41L9 5.12V7.38L6.5 8.82L4.5 7.69L3.92 5.36L2 5.88L2.47 7.65L.7 8.12L1.22 10.05L3.55 9.43L5.55 10.56V13.45L3.55 14.58L1.22 13.96L.7 15.89L2.47 16.36L2 18.12L3.93 18.64L4.55 16.31L6.55 15.18L9 16.62V18.88L7.29 20.59L8.71 22L10 20.71L11.29 22L12.7 20.59L11 18.88V16.62L14.46 14.61M7.5 10.56L10 9.11L12.5 10.56V13.44L10 14.89L7.5 13.44M19 5C17.89 5 17 5.89 17 7V13.76C16.36 14.33 16 15.15 16 16C16 17.66 17.34 19 19 19S22 17.66 22 16C22 15.15 21.64 14.33 21 13.77V7C21 5.89 20.11 5 19 5M19 6C19.55 6 20 6.45 20 7V8H18V7C18 6.45 18.45 6 19 6";
var mdiSnowflakeVariant = "M14.25,12L16.27,11H23L22,9H18.03L20.42,5.83L19.43,3.83L15.37,9.2L13.35,10.21L13.75,8L17.83,2.62L15.64,2.22L12,7L8.4,2.2L6.2,2.6L10.26,8L10.66,10.21L8.82,9.29L8.66,9.21L4.6,3.8L3.6,5.8L6,9H2L1,11H7.77L9.75,12L7.73,13H1L2,15H5.97L3.58,18.17L4.57,20.17L8.63,14.8L10.65,13.79L10.25,16L6.17,21.38L8.36,21.79L12,17L15.6,21.8L17.8,21.4L13.74,16L13.34,13.79L15.34,14.79L19.4,20.2L20.4,18.2L18,15H22L23,13H16.23";
var mdiSnowman = "M17,17A5,5 0 0,1 12,22A5,5 0 0,1 7,17C7,15.5 7.65,14.17 8.69,13.25C8.26,12.61 8,11.83 8,11C8,10.86 8,10.73 8,10.59L5.04,8.87L4.83,8.71L2.29,9.39L2.03,8.43L4.24,7.84L2.26,6.69L2.76,5.82L4.74,6.97L4.15,4.75L5.11,4.5L5.8,7.04L6.04,7.14L8.73,8.69C9.11,8.15 9.62,7.71 10.22,7.42C9.5,6.87 9,6 9,5A3,3 0 0,1 12,2A3,3 0 0,1 15,5C15,6 14.5,6.87 13.78,7.42C14.38,7.71 14.89,8.15 15.27,8.69L17.96,7.14L18.2,7.04L18.89,4.5L19.85,4.75L19.26,6.97L21.24,5.82L21.74,6.69L19.76,7.84L21.97,8.43L21.71,9.39L19.17,8.71L18.96,8.87L16,10.59V11C16,11.83 15.74,12.61 15.31,13.25C16.35,14.17 17,15.5 17,17Z";
var mdiSnowmobile = "M20.34 17.93L18.4 16C19.5 15.91 22.66 15.53 22.97 13.36C23 13.12 22.92 12.89 22.78 12.7C22.12 11.82 19.88 9.07 15 5H12V7H14L16 9L12 11L3 10L1 13L5.58 14.38L2.58 16.09C2.22 16.26 1 16.89 1 18.05C1 18.4 1 18.89 1.33 19.32C1.83 20 2.71 20 3 20H9C10.26 20 12.53 19.13 12.93 16H15.59L17.59 18H15V20H20C21.65 20 23 18.65 23 17H21C21 17.43 20.73 17.79 20.34 17.93M9 18H3.25C3.33 17.95 3.41 17.91 3.5 17.87L8.22 15.17L10.92 16C10.58 17.84 9.28 18 9 18Z";
var mdiSnowshoeing = "M12.5 3.5C12.5 2.4 13.4 1.5 14.5 1.5S16.5 2.4 16.5 3.5 15.6 5.5 14.5 5.5 12.5 4.6 12.5 3.5M6.32 19.03L5.18 17.56L4 18.5L6.38 21.54C6.89 22.19 7.54 22.69 8.26 22.95C8.54 23.05 8.79 23 9 22.84C9.28 22.61 9.4 22.14 9.1 21.77C9 21.67 8.9 21.6 8.79 21.55C8.36 21.37 7.97 21.1 7.65 20.72L7.57 20.62L11 18.2L11.89 15L14 17V21.5H12V23H15.87C16.69 23 17.5 22.79 18.13 22.39C18.39 22.23 18.5 22 18.5 21.75C18.5 21.37 18.2 21 17.73 21C17.6 21 17.47 21.04 17.36 21.1C16.96 21.33 16.5 21.47 16 21.5V15.5L13.89 13.5L14.5 10.5C15.79 12 17.8 13 20 13V11C18.1 11 16.5 10 15.69 8.58L14.69 7C14.29 6.4 13.69 6 13 6C12.24 6 11.58 6.34 7 8.28V13H9V9.58L10.79 8.88L9.2 17L6.32 19.03Z";
var mdiSoccer = "M16.93 17.12L16.13 15.76L17.59 11.39L19 10.92L20 11.67C20 11.7 20 11.75 20 11.81C20 11.88 20.03 11.94 20.03 12C20.03 13.97 19.37 15.71 18.06 17.21L16.93 17.12M9.75 15L8.38 10.97L12 8.43L15.62 10.97L14.25 15H9.75M12 20.03C11.12 20.03 10.29 19.89 9.5 19.61L8.81 18.1L9.47 17H14.58L15.19 18.1L14.5 19.61C13.71 19.89 12.88 20.03 12 20.03M5.94 17.21C5.41 16.59 4.95 15.76 4.56 14.75C4.17 13.73 3.97 12.81 3.97 12C3.97 11.94 4 11.88 4 11.81C4 11.75 4 11.7 4 11.67L5 10.92L6.41 11.39L7.87 15.76L7.07 17.12L5.94 17.21M11 5.29V6.69L7 9.46L5.66 9.04L5.24 7.68C5.68 7 6.33 6.32 7.19 5.66S8.87 4.57 9.65 4.35L11 5.29M14.35 4.35C15.13 4.57 15.95 5 16.81 5.66C17.67 6.32 18.32 7 18.76 7.68L18.34 9.04L17 9.47L13 6.7V5.29L14.35 4.35M4.93 4.93C3 6.89 2 9.25 2 12S3 17.11 4.93 19.07 9.25 22 12 22 17.11 21 19.07 19.07 22 14.75 22 12 21 6.89 19.07 4.93 14.75 2 12 2 6.89 3 4.93 4.93Z";
var mdiSoccerField = "M4,4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4H4M4,6H11V8.13C9.24,8.59 8,10.18 8,12C8,13.82 9.24,15.41 11,15.87V18H4V16H7V8H4V6M13,6H20V8H17V16H20V18H13V15.87C14.76,15.41 16,13.82 16,12C16,10.18 14.76,8.59 13,8.13V6M4,10H5V14H4V10M19,10H20V14H19V10M13,10.27C13.62,10.63 14,11.29 14,12C14,12.71 13.62,13.37 13,13.73V10.27M11,10.27V13.73C10.38,13.37 10,12.71 10,12C10,11.29 10.38,10.63 11,10.27Z";
var mdiSocialDistance2Meters = "M6 6C7.1 6 8 5.1 8 4S7.1 2 6 2 4 2.9 4 4 4.9 6 6 6M10 9.43C10 8.62 9.5 7.9 8.78 7.58C7.93 7.21 7 7 6 7S4.07 7.21 3.22 7.58C2.5 7.9 2 8.62 2 9.43V10H10V9.43M18 6C19.1 6 20 5.1 20 4S19.1 2 18 2 16 2.9 16 4 16.9 6 18 6M22 9.43C22 8.62 21.5 7.9 20.78 7.58C19.93 7.21 19 7 18 7S16.07 7.21 15.22 7.58C14.5 7.9 14 8.62 14 9.43V10H22V9.43M19 17V15L5 15V17L2 14L5 11V13L19 13V11L22 14L19 17M9 20.5V21H11V22H8V20.5C8 19.95 8.45 19.5 9 19.5H10V19H8V18H10C10.55 18 11 18.45 11 19V19.5C11 20.05 10.55 20.5 10 20.5H9M16 19V22H15V19H14.5V21H13.5V19H13V22H12V19C12 18.45 12.45 18 13 18H15C15.55 18 16 18.45 16 19Z";
var mdiSocialDistance6Feet = "M6 6C7.1 6 8 5.1 8 4S7.1 2 6 2 4 2.9 4 4 4.9 6 6 6M10 9.43C10 8.62 9.5 7.9 8.78 7.58C7.93 7.21 7 7 6 7S4.07 7.21 3.22 7.58C2.5 7.9 2 8.62 2 9.43V10H10V9.43M18 6C19.1 6 20 5.1 20 4S19.1 2 18 2 16 2.9 16 4 16.9 6 18 6M22 9.43C22 8.62 21.5 7.9 20.78 7.58C19.93 7.21 19 7 18 7S16.07 7.21 15.22 7.58C14.5 7.9 14 8.62 14 9.43V10H22V9.43M19 17V15H5V17L2 14L5 11V13H19V11L22 14L19 17M10 19V18H7.5C7.22 18 7 18.22 7 18.5V21.5C7 21.78 7.22 22 7.5 22H9.5C9.78 22 10 21.78 10 21.5V20C10 19.72 9.78 19.5 9.5 19.5H8V19H10M9 20.5V21H8V20.5H9M17.5 19H16.5V22H15.5V19H14.5V18H17.5V19M12.5 19V19.5H13.5V20.5H12.5V22H11.5V18H14V19H12.5Z";
var mdiSofa = "M12.5 7C12.5 5.89 13.39 5 14.5 5H18C19.1 5 20 5.9 20 7V9.16C18.84 9.57 18 10.67 18 11.97V14H12.5V7M6 11.96V14H11.5V7C11.5 5.89 10.61 5 9.5 5H6C4.9 5 4 5.9 4 7V9.15C5.16 9.56 6 10.67 6 11.96M20.66 10.03C19.68 10.19 19 11.12 19 12.12V15H5V12C5 10.9 4.11 10 3 10S1 10.9 1 12V17C1 18.1 1.9 19 3 19V21H5V19H19V21H21V19C22.1 19 23 18.1 23 17V12C23 10.79 21.91 9.82 20.66 10.03Z";
var mdiSofaOutline = "M21 9V7C21 5.35 19.65 4 18 4H14C13.23 4 12.53 4.3 12 4.78C11.47 4.3 10.77 4 10 4H6C4.35 4 3 5.35 3 7V9C1.35 9 0 10.35 0 12V17C0 18.65 1.35 20 3 20V22H5V20H19V22H21V20C22.65 20 24 18.65 24 17V12C24 10.35 22.65 9 21 9M14 6H18C18.55 6 19 6.45 19 7V9.78C18.39 10.33 18 11.12 18 12V14H13V7C13 6.45 13.45 6 14 6M5 7C5 6.45 5.45 6 6 6H10C10.55 6 11 6.45 11 7V14H6V12C6 11.12 5.61 10.33 5 9.78V7M22 17C22 17.55 21.55 18 21 18H3C2.45 18 2 17.55 2 17V12C2 11.45 2.45 11 3 11S4 11.45 4 12V16H20V12C20 11.45 20.45 11 21 11S22 11.45 22 12V17Z";
var mdiSofaSingle = "M5 9.15V7C5 5.9 5.9 5 7 5H17C18.1 5 19 5.9 19 7V9.16C17.84 9.57 17 10.67 17 11.97V14H7V11.96C7 10.67 6.16 9.56 5 9.15M20 10C18.9 10 18 10.9 18 12V15H6V12C6 10.9 5.11 10 4 10S2 10.9 2 12V17C2 18.1 2.9 19 4 19V21H6V19H18V21H20V19C21.1 19 22 18.1 22 17V12C22 10.9 21.1 10 20 10Z";
var mdiSofaSingleOutline = "M19 9V7C19 5.35 17.65 4 16 4H8C6.35 4 5 5.35 5 7V9C3.35 9 2 10.35 2 12V17C2 18.65 3.35 20 5 20V22H7V20H17V22H19V20C20.65 20 22 18.65 22 17V12C22 10.35 20.65 9 19 9M7 7C7 6.45 7.45 6 8 6H16C16.55 6 17 6.45 17 7V9.78C16.39 10.33 16 11.12 16 12V14H8V12C8 11.12 7.61 10.33 7 9.78V7M20 17C20 17.55 19.55 18 19 18H5C4.45 18 4 17.55 4 17V12C4 11.45 4.45 11 5 11S6 11.45 6 12V16H18V12C18 11.45 18.45 11 19 11S20 11.45 20 12V17Z";
var mdiSolarPanel = "M4,2H20A2,2 0 0,1 22,4V14A2,2 0 0,1 20,16H15V20H18V22H13V16H11V22H6V20H9V16H4A2,2 0 0,1 2,14V4A2,2 0 0,1 4,2M4,4V8H11V4H4M4,14H11V10H4V14M20,14V10H13V14H20M20,4H13V8H20V4Z";
var mdiSolarPanelLarge = "M3,6H6V3H3V6M8,3V6H11V3H8M13,3V6H16V3H13M18,3V6H21V3H18M21,8H18V11H21V8M21,13H18V16H21V13M16,16V13H13V16H16M11,16V13H8V16H11M6,16V13H3V16H6M3,11H6V8H3V11M13,8V11H16V8H13M8,8V11H11V8H8M3,1H21A2,2 0 0,1 23,3V16A2,2 0 0,1 21,18H15V21H18V23H13V18H11V23H6V21H9V18H3A2,2 0 0,1 1,16V3A2,2 0 0,1 3,1Z";
var mdiSolarPower = "M11.45,2V5.55L15,3.77L11.45,2M10.45,8L8,10.46L11.75,11.71L10.45,8M2,11.45L3.77,15L5.55,11.45H2M10,2H2V10C2.57,10.17 3.17,10.25 3.77,10.25C7.35,10.26 10.26,7.35 10.27,3.75C10.26,3.16 10.17,2.57 10,2M17,22V16H14L19,7V13H22L17,22Z";
var mdiSolarPowerVariant = "M3.33 16H11V13H4L3.33 16M13 16H20.67L20 13H13V16M21.11 18H13V22H22L21.11 18M2 22H11V18H2.89L2 22M11 8H13V11H11V8M15.76 7.21L17.18 5.79L19.3 7.91L17.89 9.33L15.76 7.21M4.71 7.91L6.83 5.79L8.24 7.21L6.12 9.33L4.71 7.91M3 2H6V4H3V2M18 2H21V4H18V2M12 7C14.76 7 17 4.76 17 2H7C7 4.76 9.24 7 12 7Z";
var mdiSolarPowerVariantOutline = "M20 12H4L2 22H22L20 12M18.36 14L18.76 16H13V14H18.36M11 14V16H5.24L5.64 14H11M4.84 18H11V20H4.44L4.84 18M13 20V18H19.16L19.56 20H13M11 8H13V11H11V8M15.76 7.21L17.18 5.79L19.3 7.91L17.89 9.33L15.76 7.21M4.71 7.91L6.83 5.79L8.24 7.21L6.12 9.33L4.71 7.91M3 2H6V4H3V2M18 2H21V4H18V2M12 7C14.76 7 17 4.76 17 2H15C15 3.65 13.65 5 12 5S9 3.65 9 2H7C7 4.76 9.24 7 12 7Z";
var mdiSolderingIron = "M4.86 4.03L2.03 6.86L5.21 10.04V12.87L6.63 14.28L12.28 8.63L10.87 7.21H8.04L4.86 4.03M17 6V7.5C18 7.5 18.85 8.33 18.85 9.35C18.85 10.37 18 11.2 17 11.2V12.7C19.24 12.7 21 14.53 21 16.77V21H22.5V16.76C22.5 14.54 21.22 12.62 19.35 11.73C19.97 11.12 20.35 10.28 20.35 9.35C20.35 7.5 18.85 6 17 6M11.93 11.1L9.1 13.93L14.05 18.88L14.76 18.17L16.88 20.29L19 21L18.29 18.88L16.17 16.76L16.88 16.05L11.93 11.1Z";
var mdiSolid = "M0,0H24V24H0";
var mdiSonyPlaystation = "M9.5,4.27C10.88,4.53 12.9,5.14 14,5.5C16.75,6.45 17.69,7.63 17.69,10.29C17.69,12.89 16.09,13.87 14.05,12.89V8.05C14.05,7.5 13.95,6.97 13.41,6.82C13,6.69 12.76,7.07 12.76,7.63V19.73L9.5,18.69V4.27M13.37,17.62L18.62,15.75C19.22,15.54 19.31,15.24 18.83,15.08C18.34,14.92 17.47,14.97 16.87,15.18L13.37,16.41V14.45L13.58,14.38C13.58,14.38 14.59,14 16,13.87C17.43,13.71 19.17,13.89 20.53,14.4C22.07,14.89 22.25,15.61 21.86,16.1C21.46,16.6 20.5,16.95 20.5,16.95L13.37,19.5V17.62M3.5,17.42C1.93,17 1.66,16.05 2.38,15.5C3.05,15 4.18,14.65 4.18,14.65L8.86,13V14.88L5.5,16.09C4.9,16.3 4.81,16.6 5.29,16.76C5.77,16.92 6.65,16.88 7.24,16.66L8.86,16.08V17.77L8.54,17.83C6.92,18.09 5.2,18 3.5,17.42Z";
var mdiSort = "M18 21L14 17H17V7H14L18 3L22 7H19V17H22M2 19V17H12V19M2 13V11H9V13M2 7V5H6V7H2Z";
var mdiSortAlphabeticalAscending = "M19 17H22L18 21L14 17H17V3H19M11 13V15L7.67 19H11V21H5V19L8.33 15H5V13M9 3H7C5.9 3 5 3.9 5 5V11H7V9H9V11H11V5C11 3.9 10.11 3 9 3M9 7H7V5H9Z";
var mdiSortAlphabeticalAscendingVariant = "M9.25 5L12.5 1.75L15.75 5H9.25M8.89 14.3H6L5.28 17H2.91L6 7H9L12.13 17H9.67L8.89 14.3M6.33 12.68H8.56L7.93 10.56L7.67 9.59L7.42 8.63H7.39L7.17 9.6L6.93 10.58L6.33 12.68M13.05 17V15.74L17.8 8.97V8.91H13.5V7H20.73V8.34L16.09 15V15.08H20.8V17H13.05Z";
var mdiSortAlphabeticalDescending = "M19 7H22L18 3L14 7H17V21H19M11 13V15L7.67 19H11V21H5V19L8.33 15H5V13M9 3H7C5.9 3 5 3.9 5 5V11H7V9H9V11H11V5C11 3.9 10.11 3 9 3M9 7H7V5H9Z";
var mdiSortAlphabeticalDescendingVariant = "M15.75 19L12.5 22.25L9.25 19H15.75M8.89 14.3H6L5.28 17H2.91L6 7H9L12.13 17H9.67L8.89 14.3M6.33 12.68H8.56L7.93 10.56L7.67 9.59L7.42 8.63H7.39L7.17 9.6L6.93 10.58L6.33 12.68M13.05 17V15.74L17.8 8.97V8.91H13.5V7H20.73V8.34L16.09 15V15.08H20.8V17H13.05Z";
var mdiSortAlphabeticalVariant = "M9.25,5L12.5,1.75L15.75,5H9.25M15.75,19L12.5,22.25L9.25,19H15.75M8.89,14.3H6L5.28,17H2.91L6,7H9L12.13,17H9.67L8.89,14.3M6.33,12.68H8.56L7.93,10.56L7.67,9.59L7.42,8.63H7.39L7.17,9.6L6.93,10.58L6.33,12.68M13.05,17V15.74L17.8,8.97V8.91H13.5V7H20.73V8.34L16.09,15V15.08H20.8V17H13.05Z";
var mdiSortAscending = "M19 17H22L18 21L14 17H17V3H19M2 17H12V19H2M6 5V7H2V5M2 11H9V13H2V11Z";
var mdiSortBoolAscending = "M19 17H22L18 21L14 17H17V3H19V17M7 3C4.79 3 3 4.79 3 7S4.79 11 7 11 11 9.21 11 7 9.21 3 7 3M7 9C5.9 9 5 8.1 5 7S5.9 5 7 5 9 5.9 9 7 8.1 9 7 9M7 13C4.79 13 3 14.79 3 17S4.79 21 7 21 11 19.21 11 17 9.21 13 7 13Z";
var mdiSortBoolAscendingVariant = "M19 17H22L18 21L14 17H17V3H19V17M9 13H5C3.89 13 3 13.89 3 15V19C3 20.11 3.89 21 5 21H9C10.11 21 11 20.11 11 19V15C11 13.89 10.11 13 9 13M6.27 19.5L3.74 16.95L4.81 15.9L6.28 17.39L9.2 14.5L10.26 15.55L6.27 19.5M9 3H5C3.89 3 3 3.89 3 5V9C3 10.11 3.89 11 5 11H9C10.11 11 11 10.11 11 9V5C11 3.89 10.11 3 9 3M9 9H5V5H9V9Z";
var mdiSortBoolDescending = "M19 7H22L18 3L14 7H17V21H19M5 7C5 8.1 5.9 9 7 9C8.1 9 9 8.1 9 7C9 5.9 8.1 5 7 5C5.9 5 5 5.9 5 7M7 3C9.21 3 11 4.79 11 7C11 9.21 9.21 11 7 11C4.79 11 3 9.21 3 7C3 4.79 4.79 3 7 3M7 13C4.79 13 3 14.79 3 17C3 19.21 4.79 21 7 21C9.21 21 11 19.21 11 17C11 14.79 9.21 13 7 13Z";
var mdiSortBoolDescendingVariant = "M19 7H22L18 3L14 7H17V21H19M5 13C3.89 13 3 13.89 3 15V19C3 20.11 3.89 21 5 21H9C10.11 21 11 20.11 11 19V15C11 13.89 10.11 13 9 13M9.2 14.5L10.26 15.55L6.27 19.5L3.74 16.95L4.81 15.9L6.28 17.39M5 3C3.89 3 3 3.89 3 5V9C3 10.11 3.89 11 5 11H9C10.11 11 11 10.11 11 9V5C11 3.89 10.11 3 9 3M5 5H9V9H5Z";
var mdiSortCalendarAscending = "M21 17H24L20 21L16 17H19V3H21V17M8 16H11V13H8V16M13 5H12V3H10V5H6V3H4V5H3C1.89 5 1 5.89 1 7V18C1 19.11 1.89 20 3 20H13C14.11 20 15 19.11 15 18V7C15 5.89 14.11 5 13 5M3 18L3 11H13L13 18L3 18Z";
var mdiSortCalendarDescending = "M19 7H16L20 3L24 7H21V21H19V7M8 16H11V13H8V16M13 5H12V3H10V5H6V3H4V5H3C1.89 5 1 5.89 1 7V18C1 19.11 1.89 20 3 20H13C14.11 20 15 19.11 15 18V7C15 5.89 14.11 5 13 5M3 18L3 11H13L13 18L3 18Z";
var mdiSortClockAscending = "M20 17H23L19 21L15 17H18V3H20V17M8 5C4.14 5 1 8.13 1 12C1 15.87 4.13 19 8 19C11.86 19 15 15.87 15 12C15 8.13 11.87 5 8 5M10.19 14.53L7 12.69V9H8.5V11.82L10.94 13.23L10.19 14.53Z";
var mdiSortClockAscendingOutline = "M20 17H23L19 21L15 17H18V3H20V17M8 5C4.14 5 1 8.13 1 12C1 15.87 4.13 19 8 19C11.86 19 15 15.87 15 12C15 8.13 11.87 5 8 5M8 7.15C10.67 7.15 12.85 9.32 12.85 12C12.85 14.68 10.68 16.85 8 16.85C5.32 16.85 3.15 14.68 3.15 12C3.15 9.32 5.32 7.15 8 7.15M7 9V12.69L10.19 14.53L10.94 13.23L8.5 11.82V9";
var mdiSortClockDescending = "M18 7H15L19 3L23 7H20V21H18V7M8 5C4.14 5 1 8.13 1 12C1 15.87 4.13 19 8 19C11.86 19 15 15.87 15 12C15 8.13 11.87 5 8 5M10.19 14.53L7 12.69V9H8.5V11.82L10.94 13.23L10.19 14.53Z";
var mdiSortClockDescendingOutline = "M18 7H15L19 3L23 7H20V21H18V7M8 5C4.14 5 1 8.13 1 12C1 15.87 4.13 19 8 19C11.86 19 15 15.87 15 12C15 8.13 11.87 5 8 5M8 7.15C10.67 7.15 12.85 9.32 12.85 12C12.85 14.68 10.68 16.85 8 16.85C5.32 16.85 3.15 14.68 3.15 12C3.15 9.32 5.32 7.15 8 7.15M7 9V12.69L10.19 14.53L10.94 13.23L8.5 11.82V9";
var mdiSortDescending = "M19 7H22L18 3L14 7H17V21H19M2 17H12V19H2M6 5V7H2V5M2 11H9V13H2V11Z";
var mdiSortNumericAscending = "M19 17H22L18 21L14 17H17V3H19V17M9 13H7C5.9 13 5 13.9 5 15V16C5 17.11 5.9 18 7 18H9V19H5V21H9C10.11 21 11 20.11 11 19V15C11 13.9 10.11 13 9 13M9 16H7V15H9V16M9 3H7C5.9 3 5 3.9 5 5V9C5 10.11 5.9 11 7 11H9C10.11 11 11 10.11 11 9V5C11 3.9 10.11 3 9 3M9 9H7V5H9V9Z";
var mdiSortNumericAscendingVariant = "M7.78 7C9.08 7.04 10 7.53 10.57 8.46C11.13 9.4 11.41 10.56 11.39 11.95C11.4 13.5 11.09 14.73 10.5 15.62C9.88 16.5 8.95 16.97 7.71 17C6.45 16.96 5.54 16.5 4.96 15.56C4.38 14.63 4.09 13.45 4.09 12S4.39 9.36 5 8.44C5.59 7.5 6.5 7.04 7.78 7M7.75 8.63C7.31 8.63 6.96 8.9 6.7 9.46C6.44 10 6.32 10.87 6.32 12C6.31 13.15 6.44 14 6.69 14.54C6.95 15.1 7.31 15.37 7.77 15.37C8.69 15.37 9.16 14.24 9.17 12C9.17 9.77 8.7 8.65 7.75 8.63M13.33 17V15.22L13.76 15.24L14.3 15.22L15.34 15.03C15.68 14.92 16 14.78 16.26 14.58C16.59 14.35 16.86 14.08 17.07 13.76C17.29 13.45 17.44 13.12 17.53 12.78L17.5 12.77C17.05 13.19 16.38 13.4 15.47 13.41C14.62 13.4 13.91 13.15 13.34 12.65S12.5 11.43 12.46 10.5C12.47 9.5 12.81 8.69 13.47 8.03C14.14 7.37 15 7.03 16.12 7C17.37 7.04 18.29 7.45 18.88 8.24C19.47 9 19.76 10 19.76 11.19C19.75 12.15 19.61 13 19.32 13.76C19.03 14.5 18.64 15.13 18.12 15.64C17.66 16.06 17.11 16.38 16.47 16.61C15.83 16.83 15.12 16.96 14.34 17H13.33M16.06 8.63C15.65 8.64 15.32 8.8 15.06 9.11C14.81 9.42 14.68 9.84 14.68 10.36C14.68 10.8 14.8 11.16 15.03 11.46C15.27 11.77 15.63 11.92 16.11 11.93C16.43 11.93 16.7 11.86 16.92 11.74C17.14 11.61 17.3 11.46 17.41 11.28C17.5 11.17 17.53 10.97 17.53 10.71C17.54 10.16 17.43 9.69 17.2 9.28C16.97 8.87 16.59 8.65 16.06 8.63M9.25 5L12.5 1.75L15.75 5H9.25";
var mdiSortNumericDescending = "M19 7H22L18 3L14 7H17V21H19M9 21H5V19H9V18H7C5.9 18 5 17.11 5 16V15C5 13.9 5.9 13 7 13H9C10.11 13 11 13.9 11 15V19C11 20.11 10.11 21 9 21M9 15H7V16H9M7 3H9C10.11 3 11 3.9 11 5V9C11 10.11 10.11 11 9 11H7C5.9 11 5 10.11 5 9V5C5 3.9 5.9 3 7 3M7 9H9V5H7Z";
var mdiSortNumericDescendingVariant = "M7.78 7C9.08 7.04 10 7.53 10.57 8.46C11.13 9.4 11.41 10.56 11.39 11.95C11.4 13.5 11.09 14.73 10.5 15.62C9.88 16.5 8.95 16.97 7.71 17C6.45 16.96 5.54 16.5 4.96 15.56C4.38 14.63 4.09 13.45 4.09 12S4.39 9.36 5 8.44C5.59 7.5 6.5 7.04 7.78 7M7.75 8.63C7.31 8.63 6.96 8.9 6.7 9.46C6.44 10 6.32 10.87 6.32 12C6.31 13.15 6.44 14 6.69 14.54C6.95 15.1 7.31 15.37 7.77 15.37C8.69 15.37 9.16 14.24 9.17 12C9.17 9.77 8.7 8.65 7.75 8.63M13.33 17V15.22L13.76 15.24L14.3 15.22L15.34 15.03C15.68 14.92 16 14.78 16.26 14.58C16.59 14.35 16.86 14.08 17.07 13.76C17.29 13.45 17.44 13.12 17.53 12.78L17.5 12.77C17.05 13.19 16.38 13.4 15.47 13.41C14.62 13.4 13.91 13.15 13.34 12.65S12.5 11.43 12.46 10.5C12.47 9.5 12.81 8.69 13.47 8.03C14.14 7.37 15 7.03 16.12 7C17.37 7.04 18.29 7.45 18.88 8.24C19.47 9 19.76 10 19.76 11.19C19.75 12.15 19.61 13 19.32 13.76C19.03 14.5 18.64 15.13 18.12 15.64C17.66 16.06 17.11 16.38 16.47 16.61C15.83 16.83 15.12 16.96 14.34 17H13.33M16.06 8.63C15.65 8.64 15.32 8.8 15.06 9.11C14.81 9.42 14.68 9.84 14.68 10.36C14.68 10.8 14.8 11.16 15.03 11.46C15.27 11.77 15.63 11.92 16.11 11.93C16.43 11.93 16.7 11.86 16.92 11.74C17.14 11.61 17.3 11.46 17.41 11.28C17.5 11.17 17.53 10.97 17.53 10.71C17.54 10.16 17.43 9.69 17.2 9.28C16.97 8.87 16.59 8.65 16.06 8.63M15.75 19L12.5 22.25L9.25 19H15.75Z";
var mdiSortNumericVariant = "M7.78,7C9.08,7.04 10,7.53 10.57,8.46C11.13,9.4 11.41,10.56 11.39,11.95C11.4,13.5 11.09,14.73 10.5,15.62C9.88,16.5 8.95,16.97 7.71,17C6.45,16.96 5.54,16.5 4.96,15.56C4.38,14.63 4.09,13.45 4.09,12C4.09,10.55 4.39,9.36 5,8.44C5.59,7.5 6.5,7.04 7.78,7M7.75,8.63C7.31,8.63 6.96,8.9 6.7,9.46C6.44,10 6.32,10.87 6.32,12C6.31,13.15 6.44,14 6.69,14.54C6.95,15.1 7.31,15.37 7.77,15.37C8.69,15.37 9.16,14.24 9.17,12C9.17,9.77 8.7,8.65 7.75,8.63M13.33,17V15.22L13.76,15.24L14.3,15.22L15.34,15.03C15.68,14.92 16,14.78 16.26,14.58C16.59,14.35 16.86,14.08 17.07,13.76C17.29,13.45 17.44,13.12 17.53,12.78L17.5,12.77C17.05,13.19 16.38,13.4 15.47,13.41C14.62,13.4 13.91,13.15 13.34,12.65C12.77,12.15 12.5,11.43 12.46,10.5C12.47,9.5 12.81,8.69 13.47,8.03C14.14,7.37 15,7.03 16.12,7C17.37,7.04 18.29,7.45 18.88,8.24C19.47,9 19.76,10 19.76,11.19C19.75,12.15 19.61,13 19.32,13.76C19.03,14.5 18.64,15.13 18.12,15.64C17.66,16.06 17.11,16.38 16.47,16.61C15.83,16.83 15.12,16.96 14.34,17H13.33M16.06,8.63C15.65,8.64 15.32,8.8 15.06,9.11C14.81,9.42 14.68,9.84 14.68,10.36C14.68,10.8 14.8,11.16 15.03,11.46C15.27,11.77 15.63,11.92 16.11,11.93C16.43,11.93 16.7,11.86 16.92,11.74C17.14,11.61 17.3,11.46 17.41,11.28C17.5,11.17 17.53,10.97 17.53,10.71C17.54,10.16 17.43,9.69 17.2,9.28C16.97,8.87 16.59,8.65 16.06,8.63M9.25,5L12.5,1.75L15.75,5H9.25M15.75,19L12.5,22.25L9.25,19H15.75Z";
var mdiSortReverseVariant = "M3 11H15V13H3M3 18V16H21V18M3 6H9V8H3Z";
var mdiSortVariant = "M3,13H15V11H3M3,6V8H21V6M3,18H9V16H3V18Z";
var mdiSortVariantLock = "M21.8 16V14.5C21.8 13.1 20.4 12 19 12S16.2 13.1 16.2 14.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16M20.5 16H17.5V14.5C17.5 13.7 18.2 13.2 19 13.2S20.5 13.7 20.5 14.5V16M3 13V11H15V13H3M3 6H21V8H3V6M3 18V16H9V18H3";
var mdiSortVariantLockOpen = "M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V13.5C16.2 12.1 17.6 11 19 11S21.8 12.1 21.8 13.5V14H20.5V13.5C20.5 12.7 19.8 12.2 19 12.2S17.5 12.7 17.5 13.5V16H21.8C22.4 16 23 16.6 23 17.3M3 13V11H15V13H3M3 6H21V8H3V6M3 18V16H9V18H3";
var mdiSortVariantOff = "M20.84 22.73L11.11 13H3V11H9.11L6.11 8H3V6H4.11L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M15 11H14.2L15 11.8V11M21 8V6H9.2L11.2 8H21M3 18H9V16H3V18Z";
var mdiSortVariantRemove = "M3 13H15V11H3M3 6V8H21V6M3 18H9V16H3V18M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.46L22.54 16.88";
var mdiSoundbar = "M4 8C2.9 8 2 8.9 2 10V14C2 15.11 2.9 16 4 16H20C21.11 16 22 15.11 22 14V10C22 8.9 21.11 8 20 8M9 10C10.11 10 11 10.9 11 12C11 13.11 10.11 14 9 14C7.9 14 7 13.11 7 12C7 10.9 7.9 10 9 10M15 10C16.11 10 17 10.9 17 12C17 13.11 16.11 14 15 14C13.9 14 13 13.11 13 12C13 10.9 13.9 10 15 10M5 11C5.55 11 6 11.45 6 12C6 12.55 5.55 13 5 13C4.45 13 4 12.55 4 12C4 11.45 4.45 11 5 11M9 11C8.45 11 8 11.45 8 12C8 12.55 8.45 13 9 13C9.55 13 10 12.55 10 12C10 11.45 9.55 11 9 11M15 11C14.45 11 14 11.45 14 12C14 12.55 14.45 13 15 13C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11M19 11C19.55 11 20 11.45 20 12C20 12.55 19.55 13 19 13C18.45 13 18 12.55 18 12C18 11.45 18.45 11 19 11Z";
var mdiSoundcloud = "M11.56,8.87V17H20.32V17C22.17,16.87 23,15.73 23,14.33C23,12.85 21.88,11.66 20.38,11.66C20,11.66 19.68,11.74 19.35,11.88C19.11,9.54 17.12,7.71 14.67,7.71C13.5,7.71 12.39,8.15 11.56,8.87M10.68,9.89C10.38,9.71 10.06,9.57 9.71,9.5V17H11.1V9.34C10.95,9.5 10.81,9.7 10.68,9.89M8.33,9.35V17H9.25V9.38C9.06,9.35 8.87,9.34 8.67,9.34C8.55,9.34 8.44,9.34 8.33,9.35M6.5,10V17H7.41V9.54C7.08,9.65 6.77,9.81 6.5,10M4.83,12.5C4.77,12.5 4.71,12.44 4.64,12.41V17H5.56V10.86C5.19,11.34 4.94,11.91 4.83,12.5M2.79,12.22V16.91C3,16.97 3.24,17 3.5,17H3.72V12.14C3.64,12.13 3.56,12.12 3.5,12.12C3.24,12.12 3,12.16 2.79,12.22M1,14.56C1,15.31 1.34,15.97 1.87,16.42V12.71C1.34,13.15 1,13.82 1,14.56Z";
var mdiSourceBranch = "M13,14C9.64,14 8.54,15.35 8.18,16.24C9.25,16.7 10,17.76 10,19A3,3 0 0,1 7,22A3,3 0 0,1 4,19C4,17.69 4.83,16.58 6,16.17V7.83C4.83,7.42 4,6.31 4,5A3,3 0 0,1 7,2A3,3 0 0,1 10,5C10,6.31 9.17,7.42 8,7.83V13.12C8.88,12.47 10.16,12 12,12C14.67,12 15.56,10.66 15.85,9.77C14.77,9.32 14,8.25 14,7A3,3 0 0,1 17,4A3,3 0 0,1 20,7C20,8.34 19.12,9.5 17.91,9.86C17.65,11.29 16.68,14 13,14M7,18A1,1 0 0,0 6,19A1,1 0 0,0 7,20A1,1 0 0,0 8,19A1,1 0 0,0 7,18M7,4A1,1 0 0,0 6,5A1,1 0 0,0 7,6A1,1 0 0,0 8,5A1,1 0 0,0 7,4M17,6A1,1 0 0,0 16,7A1,1 0 0,0 17,8A1,1 0 0,0 18,7A1,1 0 0,0 17,6Z";
var mdiSourceBranchCheck = "M13 14C9.64 14 8.54 15.35 8.18 16.24C9.25 16.7 10 17.76 10 19C10 20.66 8.66 22 7 22S4 20.66 4 19C4 17.69 4.83 16.58 6 16.17V7.83C4.83 7.42 4 6.31 4 5C4 3.34 5.34 2 7 2S10 3.34 10 5C10 6.31 9.17 7.42 8 7.83V13.12C8.88 12.47 10.16 12 12 12C14.67 12 15.56 10.66 15.85 9.77C14.77 9.32 14 8.25 14 7C14 5.34 15.34 4 17 4S20 5.34 20 7C20 8.34 19.12 9.5 17.91 9.86C17.65 11.29 16.68 14 13 14M7 18C6.45 18 6 18.45 6 19S6.45 20 7 20 8 19.55 8 19 7.55 18 7 18M7 4C6.45 4 6 4.45 6 5S6.45 6 7 6 8 5.55 8 5 7.55 4 7 4M17 6C16.45 6 16 6.45 16 7S16.45 8 17 8 18 7.55 18 7 17.55 6 17 6M16.75 21.16L14 18.16L15.16 17L16.75 18.59L20.34 15L21.5 16.41L16.75 21.16";
var mdiSourceBranchMinus = "M13 14C9.64 14 8.54 15.35 8.18 16.24C9.25 16.7 10 17.76 10 19C10 20.66 8.66 22 7 22S4 20.66 4 19C4 17.69 4.83 16.58 6 16.17V7.83C4.83 7.42 4 6.31 4 5C4 3.34 5.34 2 7 2S10 3.34 10 5C10 6.31 9.17 7.42 8 7.83V13.12C8.88 12.47 10.16 12 12 12C14.67 12 15.56 10.66 15.85 9.77C14.77 9.32 14 8.25 14 7C14 5.34 15.34 4 17 4S20 5.34 20 7C20 8.34 19.12 9.5 17.91 9.86C17.65 11.29 16.68 14 13 14M7 18C6.45 18 6 18.45 6 19S6.45 20 7 20 8 19.55 8 19 7.55 18 7 18M7 4C6.45 4 6 4.45 6 5S6.45 6 7 6 8 5.55 8 5 7.55 4 7 4M17 6C16.45 6 16 6.45 16 7S16.45 8 17 8 18 7.55 18 7 17.55 6 17 6M14 17V19H22V17H14Z";
var mdiSourceBranchPlus = "M13 14C9.64 14 8.54 15.35 8.18 16.24C9.25 16.7 10 17.76 10 19C10 20.66 8.66 22 7 22S4 20.66 4 19C4 17.69 4.83 16.58 6 16.17V7.83C4.83 7.42 4 6.31 4 5C4 3.34 5.34 2 7 2S10 3.34 10 5C10 6.31 9.17 7.42 8 7.83V13.12C8.88 12.47 10.16 12 12 12C14.67 12 15.56 10.66 15.85 9.77C14.77 9.32 14 8.25 14 7C14 5.34 15.34 4 17 4S20 5.34 20 7C20 8.34 19.12 9.5 17.91 9.86C17.65 11.29 16.68 14 13 14M7 18C6.45 18 6 18.45 6 19S6.45 20 7 20 8 19.55 8 19 7.55 18 7 18M7 4C6.45 4 6 4.45 6 5S6.45 6 7 6 8 5.55 8 5 7.55 4 7 4M17 6C16.45 6 16 6.45 16 7S16.45 8 17 8 18 7.55 18 7 17.55 6 17 6M17 14V17H14V19H17V22H19V19H22V17H19V14H17Z";
var mdiSourceBranchRefresh = "M13 14C9.64 14 8.54 15.35 8.18 16.24C9.25 16.7 10 17.76 10 19C10 20.66 8.66 22 7 22S4 20.66 4 19C4 17.69 4.83 16.58 6 16.17V7.83C4.83 7.42 4 6.31 4 5C4 3.34 5.34 2 7 2S10 3.34 10 5C10 6.31 9.17 7.42 8 7.83V13.12C8.88 12.47 10.16 12 12 12C14.67 12 15.56 10.66 15.85 9.77C14.77 9.32 14 8.25 14 7C14 5.34 15.34 4 17 4S20 5.34 20 7C20 8.34 19.12 9.5 17.91 9.86C17.65 11.29 16.68 14 13 14M7 18C6.45 18 6 18.45 6 19S6.45 20 7 20 8 19.55 8 19 7.55 18 7 18M7 4C6.45 4 6 4.45 6 5S6.45 6 7 6 8 5.55 8 5 7.55 4 7 4M17 6C16.45 6 16 6.45 16 7S16.45 8 17 8 18 7.55 18 7 17.55 6 17 6M18 14C19.1 14 20.1 14.4 20.8 15.2L22 14V18H18L19.8 16.2C19.3 15.8 18.7 15.5 18 15.5C16.6 15.5 15.5 16.6 15.5 18S16.6 20.5 18 20.5C18.8 20.5 19.5 20.1 20 19.5H21.7C21.1 21 19.7 22 18 22C15.8 22 14 20.2 14 18S15.8 14 18 14Z";
var mdiSourceBranchRemove = "M13 14C9.64 14 8.54 15.35 8.18 16.24C9.25 16.7 10 17.76 10 19C10 20.66 8.66 22 7 22S4 20.66 4 19C4 17.69 4.83 16.58 6 16.17V7.83C4.83 7.42 4 6.31 4 5C4 3.34 5.34 2 7 2S10 3.34 10 5C10 6.31 9.17 7.42 8 7.83V13.12C8.88 12.47 10.16 12 12 12C14.67 12 15.56 10.66 15.85 9.77C14.77 9.32 14 8.25 14 7C14 5.34 15.34 4 17 4S20 5.34 20 7C20 8.34 19.12 9.5 17.91 9.86C17.65 11.29 16.68 14 13 14M7 18C6.45 18 6 18.45 6 19S6.45 20 7 20 8 19.55 8 19 7.55 18 7 18M7 4C6.45 4 6 4.45 6 5S6.45 6 7 6 8 5.55 8 5 7.55 4 7 4M17 6C16.45 6 16 6.45 16 7S16.45 8 17 8 18 7.55 18 7 17.55 6 17 6M20.12 14.46L18 16.59L15.88 14.47L14.47 15.88L16.59 18L14.47 20.12L15.88 21.54L18 19.41L20.12 21.54L21.54 20.12L19.41 18L21.54 15.88L20.12 14.46Z";
var mdiSourceBranchSync = "M13 14C9.64 14 8.54 15.35 8.18 16.24C9.25 16.7 10 17.76 10 19C10 20.66 8.66 22 7 22S4 20.66 4 19C4 17.69 4.83 16.58 6 16.17V7.83C4.83 7.42 4 6.31 4 5C4 3.34 5.34 2 7 2S10 3.34 10 5C10 6.31 9.17 7.42 8 7.83V13.12C8.88 12.47 10.16 12 12 12C14.67 12 15.56 10.66 15.85 9.77C14.77 9.32 14 8.25 14 7C14 5.34 15.34 4 17 4S20 5.34 20 7C20 8.34 19.12 9.5 17.91 9.86C17.65 11.29 16.68 14 13 14M7 18C6.45 18 6 18.45 6 19S6.45 20 7 20 8 19.55 8 19 7.55 18 7 18M7 4C6.45 4 6 4.45 6 5S6.45 6 7 6 8 5.55 8 5 7.55 4 7 4M17 6C16.45 6 16 6.45 16 7S16.45 8 17 8 18 7.55 18 7 17.55 6 17 6M18 13V14.5C20.21 14.5 22 16.29 22 18.5C22 19.32 21.75 20.08 21.33 20.71L20.24 19.62C20.41 19.28 20.5 18.9 20.5 18.5C20.5 17.12 19.38 16 18 16V17.5L15.75 15.25L15.72 15.22C15.78 15.17 15.85 15.13 18 13M18 24V22.5C15.79 22.5 14 20.71 14 18.5C14 17.68 14.25 16.92 14.67 16.29L15.76 17.38C15.59 17.72 15.5 18.1 15.5 18.5C15.5 19.88 16.62 21 18 21V19.5L20.25 21.75L20.28 21.78C20.22 21.83 20.15 21.87 18 24";
var mdiSourceCommit = "M17,12C17,14.42 15.28,16.44 13,16.9V21H11V16.9C8.72,16.44 7,14.42 7,12C7,9.58 8.72,7.56 11,7.1V3H13V7.1C15.28,7.56 17,9.58 17,12M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z";
var mdiSourceCommitEnd = "M17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12C7,9.58 8.72,7.56 11,7.1V3H13V7.1C15.28,7.56 17,9.58 17,12M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z";
var mdiSourceCommitEndLocal = "M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M11,5V3H13V5H11Z";
var mdiSourceCommitLocal = "M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M11,5V3H13V5H11M11,21V19H13V21H11Z";
var mdiSourceCommitNextLocal = "M17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12C7,9.58 8.72,7.56 11,7.1V3H13V7.1C15.28,7.56 17,9.58 17,12M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M11,21V19H13V21H11Z";
var mdiSourceCommitStart = "M12,7A5,5 0 0,1 17,12C17,14.42 15.28,16.44 13,16.9V21H11V16.9C8.72,16.44 7,14.42 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z";
var mdiSourceCommitStartNextLocal = "M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M11,21V19H13V21H11Z";
var mdiSourceFork = "M6,2A3,3 0 0,1 9,5C9,6.28 8.19,7.38 7.06,7.81C7.15,8.27 7.39,8.83 8,9.63C9,10.92 11,12.83 12,14.17C13,12.83 15,10.92 16,9.63C16.61,8.83 16.85,8.27 16.94,7.81C15.81,7.38 15,6.28 15,5A3,3 0 0,1 18,2A3,3 0 0,1 21,5C21,6.32 20.14,7.45 18.95,7.85C18.87,8.37 18.64,9 18,9.83C17,11.17 15,13.08 14,14.38C13.39,15.17 13.15,15.73 13.06,16.19C14.19,16.62 15,17.72 15,19A3,3 0 0,1 12,22A3,3 0 0,1 9,19C9,17.72 9.81,16.62 10.94,16.19C10.85,15.73 10.61,15.17 10,14.38C9,13.08 7,11.17 6,9.83C5.36,9 5.13,8.37 5.05,7.85C3.86,7.45 3,6.32 3,5A3,3 0 0,1 6,2M6,4A1,1 0 0,0 5,5A1,1 0 0,0 6,6A1,1 0 0,0 7,5A1,1 0 0,0 6,4M18,4A1,1 0 0,0 17,5A1,1 0 0,0 18,6A1,1 0 0,0 19,5A1,1 0 0,0 18,4M12,18A1,1 0 0,0 11,19A1,1 0 0,0 12,20A1,1 0 0,0 13,19A1,1 0 0,0 12,18Z";
var mdiSourceMerge = "M7,3A3,3 0 0,1 10,6C10,7.29 9.19,8.39 8.04,8.81C8.58,13.81 13.08,14.77 15.19,14.96C15.61,13.81 16.71,13 18,13A3,3 0 0,1 21,16A3,3 0 0,1 18,19C16.69,19 15.57,18.16 15.16,17C10.91,16.8 9.44,15.19 8,13.39V15.17C9.17,15.58 10,16.69 10,18A3,3 0 0,1 7,21A3,3 0 0,1 4,18C4,16.69 4.83,15.58 6,15.17V8.83C4.83,8.42 4,7.31 4,6A3,3 0 0,1 7,3M7,5A1,1 0 0,0 6,6A1,1 0 0,0 7,7A1,1 0 0,0 8,6A1,1 0 0,0 7,5M7,17A1,1 0 0,0 6,18A1,1 0 0,0 7,19A1,1 0 0,0 8,18A1,1 0 0,0 7,17M18,15A1,1 0 0,0 17,16A1,1 0 0,0 18,17A1,1 0 0,0 19,16A1,1 0 0,0 18,15Z";
var mdiSourcePull = "M6,3A3,3 0 0,1 9,6C9,7.31 8.17,8.42 7,8.83V15.17C8.17,15.58 9,16.69 9,18A3,3 0 0,1 6,21A3,3 0 0,1 3,18C3,16.69 3.83,15.58 5,15.17V8.83C3.83,8.42 3,7.31 3,6A3,3 0 0,1 6,3M6,5A1,1 0 0,0 5,6A1,1 0 0,0 6,7A1,1 0 0,0 7,6A1,1 0 0,0 6,5M6,17A1,1 0 0,0 5,18A1,1 0 0,0 6,19A1,1 0 0,0 7,18A1,1 0 0,0 6,17M21,18A3,3 0 0,1 18,21A3,3 0 0,1 15,18C15,16.69 15.83,15.58 17,15.17V7H15V10.25L10.75,6L15,1.75V5H17A2,2 0 0,1 19,7V15.17C20.17,15.58 21,16.69 21,18M18,17A1,1 0 0,0 17,18A1,1 0 0,0 18,19A1,1 0 0,0 19,18A1,1 0 0,0 18,17Z";
var mdiSourceRepository = "M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M12.75,13.5C15.5,13.5 16.24,11.47 16.43,10.4C17.34,10.11 18,9.26 18,8.25C18,7 17,6 15.75,6C14.5,6 13.5,7 13.5,8.25C13.5,9.19 14.07,10 14.89,10.33C14.67,11 14,12 12,12C10.62,12 9.66,12.35 9,12.84V8.87C9.87,8.56 10.5,7.73 10.5,6.75C10.5,5.5 9.5,4.5 8.25,4.5C7,4.5 6,5.5 6,6.75C6,7.73 6.63,8.56 7.5,8.87V15.13C6.63,15.44 6,16.27 6,17.25C6,18.5 7,19.5 8.25,19.5C9.5,19.5 10.5,18.5 10.5,17.25C10.5,16.32 9.94,15.5 9.13,15.18C9.41,14.5 10.23,13.5 12.75,13.5M8.25,16.5A0.75,0.75 0 0,1 9,17.25A0.75,0.75 0 0,1 8.25,18A0.75,0.75 0 0,1 7.5,17.25A0.75,0.75 0 0,1 8.25,16.5M8.25,6A0.75,0.75 0 0,1 9,6.75A0.75,0.75 0 0,1 8.25,7.5A0.75,0.75 0 0,1 7.5,6.75A0.75,0.75 0 0,1 8.25,6M15.75,7.5A0.75,0.75 0 0,1 16.5,8.25A0.75,0.75 0 0,1 15.75,9A0.75,0.75 0 0,1 15,8.25A0.75,0.75 0 0,1 15.75,7.5Z";
var mdiSourceRepositoryMultiple = "M8,0H20A2,2 0 0,1 22,2V18A2,2 0 0,1 20,20H8A2,2 0 0,1 6,18V2A2,2 0 0,1 8,0M14.75,11.5C17.5,11.5 18.24,9.47 18.43,8.4C19.34,8.11 20,7.26 20,6.25C20,5 19,4 17.75,4C16.5,4 15.5,5 15.5,6.25C15.5,7.19 16.07,8 16.89,8.33C16.67,9 16,10 14,10C12.62,10 11.66,10.35 11,10.84V6.87C11.87,6.56 12.5,5.73 12.5,4.75C12.5,3.5 11.5,2.5 10.25,2.5C9,2.5 8,3.5 8,4.75C8,5.73 8.63,6.56 9.5,6.87V13.13C8.63,13.44 8,14.27 8,15.25C8,16.5 9,17.5 10.25,17.5C11.5,17.5 12.5,16.5 12.5,15.25C12.5,14.32 11.94,13.5 11.13,13.18C11.41,12.5 12.23,11.5 14.75,11.5M10.25,14.5A0.75,0.75 0 0,1 11,15.25A0.75,0.75 0 0,1 10.25,16A0.75,0.75 0 0,1 9.5,15.25A0.75,0.75 0 0,1 10.25,14.5M10.25,4A0.75,0.75 0 0,1 11,4.75A0.75,0.75 0 0,1 10.25,5.5A0.75,0.75 0 0,1 9.5,4.75A0.75,0.75 0 0,1 10.25,4M17.75,5.5A0.75,0.75 0 0,1 18.5,6.25A0.75,0.75 0 0,1 17.75,7A0.75,0.75 0 0,1 17,6.25A0.75,0.75 0 0,1 17.75,5.5M16,22V24H4A2,2 0 0,1 2,22V6H4V22H16Z";
var mdiSoySauce = "M13.9,7.5C13.9,6.8 14.1,6.3 14.2,6H14.8L15.7,3.5H16.5V2H7.5V3.5H8.3L9.2,6H9.8C10,6.3 10.1,6.8 10.1,7.5C10.1,8.8 6,13.7 6,17.6V19.6C6,21 8.7,21.9 12,21.9C15.3,21.9 18,21 18,19.6V17.6C18,13.7 13.9,8.8 13.9,7.5M12,15A2,2 0 0,1 10,13A2,2 0 0,1 12,11A2,2 0 0,1 14,13A2,2 0 0,1 12,15Z";
var mdiSoySauceOff = "M22.1 21.5L2.4 1.7L1.1 3L8.6 10.5C7.5 12.6 6 15.3 6 17.6V19.6C6 21 8.7 21.9 12 21.9C15.1 21.9 17.7 21.1 18 19.9L20.9 22.8L22.1 21.5M12 15C10.9 15 10 14.1 10 13C10 12.7 10.1 12.4 10.2 12.1L12.9 14.8C12.6 14.9 12.3 15 12 15M8.3 3.5H7.5V2H16.5V3.5H15.7L14.8 6H14.2C14.1 6.3 13.9 6.8 13.9 7.5C13.9 8.4 15.9 11 17.1 13.9L10.1 6.9C10 6.5 9.9 6.2 9.8 6H9.2L8.3 3.5Z";
var mdiSpa = "M15.5,9.63C15.31,6.84 14.18,4.12 12.06,2C9.92,4.14 8.74,6.86 8.5,9.63C9.79,10.31 10.97,11.19 12,12.26C13.03,11.2 14.21,10.32 15.5,9.63M12,15.45C9.85,12.17 6.18,10 2,10C2,20 11.32,21.89 12,22C12.68,21.88 22,20 22,10C17.82,10 14.15,12.17 12,15.45Z";
var mdiSpaOutline = "M15.5,9.63C14.21,10.32 13.03,11.2 12,12.26C10.97,11.19 9.79,10.31 8.5,9.63C8.74,6.86 9.92,4.14 12.06,2C14.18,4.12 15.31,6.84 15.5,9.63M12,15.45C14.15,12.17 17.82,10 22,10C22,20 12.68,21.88 12,22C11.32,21.89 2,20 2,10C6.18,10 9.85,12.17 12,15.45M12.05,5.19C11.39,6.23 10.93,7.38 10.68,8.58L12,9.55L13.35,8.57C13.12,7.37 12.68,6.22 12.05,5.19M12,19.97C12,19.97 18,19 19.74,12.25C14,14 12,19.1 12,19.1C12,19.1 9,13 4.26,12.26C6,19 12,19.97 12,19.97Z";
var mdiSpaceInvaders = "M7,6H5V4H7V6M17,6H19V4H17V6M23,12V18H21V14H19V18H17V16H7V18H5V14H3V18H1V12H3V10H5V8H7V6H9V8H15V6H17V8H19V10H21V12H23M15,10V12H17V10H15M7,12H9V10H7V12M11,18H7V20H11V18M17,18H13V20H17V18Z";
var mdiSpaceStation = "M15.5 19V21H13.73C13.39 21.6 12.74 22 12 22C11.26 22 10.61 21.6 10.27 21H8.5V19H10.27C10.44 18.7 10.7 18.44 11 18.27V17H10C9.45 17 9 16.55 9 16V13H6V17C6 17.55 5.55 18 5 18H3C2.45 18 2 17.55 2 17V8C2 7.45 2.45 7 3 7H5C5.55 7 6 7.45 6 8V11H9V8C9 7.45 9.45 7 10 7H11V6H10C9.45 6 9 5.55 9 5V4C9 3.45 9.45 3 10 3H14C14.55 3 15 3.45 15 4V5C15 5.55 14.55 6 14 6H13V7H14C14.55 7 15 7.45 15 8V11H18V8C18 7.45 18.45 7 19 7H21C21.55 7 22 7.45 22 8V17C22 17.55 21.55 18 21 18H19C18.45 18 18 17.55 18 17V13H15V16C15 16.55 14.55 17 14 17H13V18.27C13.3 18.44 13.56 18.7 13.73 19H15.5M3 16V17H5V16H3M3 14V15H5V14H3M3 12V13H5V12H3M3 10V11H5V10H3M3 8V9H5V8H3M19 16V17H21V16H19M19 14V15H21V14H19M19 12V13H21V12H19M19 10V11H21V10H19M19 8V9H21V8H19Z";
var mdiSpade = "M15.71,1.22L12.88,4.05C12.1,4.83 12.1,6.09 12.88,6.87L14.3,8.29L10.06,12.53L7.58,10.06L1.22,16.42L7.58,22.78L13.94,16.42L11.47,13.94L15.71,9.7L17.13,11.12C17.91,11.9 19.17,11.9 19.95,11.12L22.78,8.29L15.71,1.22M15.71,4.05L19.95,8.29L18.54,9.7L14.3,5.46L15.71,4.05Z";
var mdiSpeaker = "M12,12A3,3 0 0,0 9,15A3,3 0 0,0 12,18A3,3 0 0,0 15,15A3,3 0 0,0 12,12M12,20A5,5 0 0,1 7,15A5,5 0 0,1 12,10A5,5 0 0,1 17,15A5,5 0 0,1 12,20M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8C10.89,8 10,7.1 10,6C10,4.89 10.89,4 12,4M17,2H7C5.89,2 5,2.89 5,4V20A2,2 0 0,0 7,22H17A2,2 0 0,0 19,20V4C19,2.89 18.1,2 17,2Z";
var mdiSpeakerBluetooth = "M4,3A2,2 0 0,0 2,5V19A2,2 0 0,0 4,21H12A2,2 0 0,0 14,19V5A2,2 0 0,0 12,3H4M8,5A2,2 0 0,1 10,7A2,2 0 0,1 8,9A2,2 0 0,1 6,7A2,2 0 0,1 8,5M19,7V10.79L16.71,8.5L16,9.21L18.79,12L16,14.79L16.71,15.5L19,13.21V17H19.5L22.35,14.14L20.21,12L22.35,9.85L19.5,7H19M20,8.91L20.94,9.85L20,10.79V8.91M8,11A4,4 0 0,1 12,15A4,4 0 0,1 8,19A4,4 0 0,1 4,15A4,4 0 0,1 8,11M8,13A2,2 0 0,0 6,15A2,2 0 0,0 8,17A2,2 0 0,0 10,15A2,2 0 0,0 8,13M20,13.21L20.94,14.14L20,15.08V13.21Z";
var mdiSpeakerMessage = "M16.5 3H21.5C22.3 3 23 3.7 23 4.5V7.5C23 8.3 22.3 9 21.5 9H18L15 12V4.5C15 3.7 15.7 3 16.5 3M3 3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H11C12.1 21 13 20.1 13 19V5C13 3.9 12.1 3 11 3H3M7 5C8.1 5 9 5.9 9 7S8.1 9 7 9 5 8.1 5 7 5.9 5 7 5M7 11C9.2 11 11 12.8 11 15S9.2 19 7 19 3 17.2 3 15 4.8 11 7 11M7 13C5.9 13 5 13.9 5 15S5.9 17 7 17 9 16.1 9 15 8.1 13 7 13";
var mdiSpeakerMultiple = "M14,10A3,3 0 0,0 11,13A3,3 0 0,0 14,16A3,3 0 0,0 17,13A3,3 0 0,0 14,10M14,18A5,5 0 0,1 9,13A5,5 0 0,1 14,8A5,5 0 0,1 19,13A5,5 0 0,1 14,18M14,2A2,2 0 0,1 16,4A2,2 0 0,1 14,6A2,2 0 0,1 12,4A2,2 0 0,1 14,2M19,0H9A2,2 0 0,0 7,2V18A2,2 0 0,0 9,20H19A2,2 0 0,0 21,18V2A2,2 0 0,0 19,0M5,22H17V24H5A2,2 0 0,1 3,22V4H5";
var mdiSpeakerOff = "M2,5.27L3.28,4L21,21.72L19.73,23L18.27,21.54C17.93,21.83 17.5,22 17,22H7C5.89,22 5,21.1 5,20V8.27L2,5.27M12,18A3,3 0 0,1 9,15C9,14.24 9.28,13.54 9.75,13L8.33,11.6C7.5,12.5 7,13.69 7,15A5,5 0 0,0 12,20C13.31,20 14.5,19.5 15.4,18.67L14,17.25C13.45,17.72 12.76,18 12,18M17,15A5,5 0 0,0 12,10H11.82L5.12,3.3C5.41,2.54 6.14,2 7,2H17A2,2 0 0,1 19,4V17.18L17,15.17V15M12,4C10.89,4 10,4.89 10,6A2,2 0 0,0 12,8A2,2 0 0,0 14,6C14,4.89 13.1,4 12,4Z";
var mdiSpeakerPause = "M12.28 19.81C11.87 19.92 11.45 20 11 20C8.24 20 6 17.76 6 15S8.24 10 11 10C12.89 10 14.5 11.06 15.37 12.61C16.16 12.23 17.06 12 18 12V4C18 2.89 17.1 2 16 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.54C13 21.37 12.54 20.63 12.28 19.81M11 4C12.11 4 13 4.89 13 6S12.11 8 11 8C9.89 8 9 7.1 9 6C9 4.89 9.89 4 11 4M13.74 13.78C12.7 14.82 12.06 16.24 12 17.81C11.69 17.93 11.36 18 11 18C9.34 18 8 16.66 8 15S9.34 12 11 12C12.22 12 13.27 12.73 13.74 13.78M19 15H21V21H19M15 15H17V21H15V15Z";
var mdiSpeakerPlay = "M16 15V21L21 18L16 15M12.28 19.81C11.87 19.92 11.45 20 11 20C8.24 20 6 17.76 6 15S8.24 10 11 10C12.89 10 14.5 11.06 15.37 12.61C16.16 12.23 17.06 12 18 12V4C18 2.89 17.1 2 16 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.54C13 21.37 12.54 20.63 12.28 19.81M11 4C12.11 4 13 4.89 13 6S12.11 8 11 8C9.89 8 9 7.1 9 6C9 4.89 9.89 4 11 4M13.74 13.78C12.7 14.82 12.06 16.24 12 17.81C11.69 17.93 11.36 18 11 18C9.34 18 8 16.66 8 15S9.34 12 11 12C12.22 12 13.27 12.73 13.74 13.78Z";
var mdiSpeakerStop = "M12.28 19.81C11.87 19.92 11.45 20 11 20C8.24 20 6 17.76 6 15S8.24 10 11 10C12.89 10 14.5 11.06 15.37 12.61C16.16 12.23 17.06 12 18 12V4C18 2.89 17.1 2 16 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H13.54C13 21.37 12.54 20.63 12.28 19.81M11 4C12.11 4 13 4.89 13 6S12.11 8 11 8C9.89 8 9 7.1 9 6C9 4.89 9.89 4 11 4M13.74 13.78C12.7 14.82 12.06 16.24 12 17.81C11.69 17.93 11.36 18 11 18C9.34 18 8 16.66 8 15S9.34 12 11 12C12.22 12 13.27 12.73 13.74 13.78M21 15H15V21H21V15Z";
var mdiSpeakerWireless = "M20.07,19.07L18.66,17.66C20.11,16.22 21,14.21 21,12C21,9.78 20.11,7.78 18.66,6.34L20.07,4.93C21.88,6.74 23,9.24 23,12C23,14.76 21.88,17.26 20.07,19.07M17.24,16.24L15.83,14.83C16.55,14.11 17,13.11 17,12C17,10.89 16.55,9.89 15.83,9.17L17.24,7.76C18.33,8.85 19,10.35 19,12C19,13.65 18.33,15.15 17.24,16.24M4,3H12A2,2 0 0,1 14,5V19A2,2 0 0,1 12,21H4A2,2 0 0,1 2,19V5A2,2 0 0,1 4,3M8,5A2,2 0 0,0 6,7A2,2 0 0,0 8,9A2,2 0 0,0 10,7A2,2 0 0,0 8,5M8,11A4,4 0 0,0 4,15A4,4 0 0,0 8,19A4,4 0 0,0 12,15A4,4 0 0,0 8,11M8,13A2,2 0 0,1 10,15A2,2 0 0,1 8,17A2,2 0 0,1 6,15A2,2 0 0,1 8,13Z";
var mdiSpear = "M16 9H16.41L3.41 22L2 20.59L15 7.59V9H16M16 4V8H20L22 2L16 4Z";
var mdiSpeedometer = "M12,16A3,3 0 0,1 9,13C9,11.88 9.61,10.9 10.5,10.39L20.21,4.77L14.68,14.35C14.18,15.33 13.17,16 12,16M12,3C13.81,3 15.5,3.5 16.97,4.32L14.87,5.53C14,5.19 13,5 12,5A8,8 0 0,0 4,13C4,15.21 4.89,17.21 6.34,18.65H6.35C6.74,19.04 6.74,19.67 6.35,20.06C5.96,20.45 5.32,20.45 4.93,20.07V20.07C3.12,18.26 2,15.76 2,13A10,10 0 0,1 12,3M22,13C22,15.76 20.88,18.26 19.07,20.07V20.07C18.68,20.45 18.05,20.45 17.66,20.06C17.27,19.67 17.27,19.04 17.66,18.65V18.65C19.11,17.2 20,15.21 20,13C20,12 19.81,11 19.46,10.1L20.67,8C21.5,9.5 22,11.18 22,13Z";
var mdiSpeedometerMedium = "M12 1.38L9.14 12.06C8.8 13.1 9.04 14.29 9.86 15.12C11.04 16.29 12.94 16.29 14.11 15.12C14.9 14.33 15.16 13.2 14.89 12.21M14.6 3.35L15.22 5.68C18.04 6.92 20 9.73 20 13C20 15.21 19.11 17.21 17.66 18.65H17.65C17.26 19.04 17.26 19.67 17.65 20.06C18.04 20.45 18.68 20.45 19.07 20.07C20.88 18.26 22 15.76 22 13C22 8.38 18.86 4.5 14.6 3.35M9.4 3.36C5.15 4.5 2 8.4 2 13C2 15.76 3.12 18.26 4.93 20.07C5.32 20.45 5.95 20.45 6.34 20.06C6.73 19.67 6.73 19.04 6.34 18.65C4.89 17.2 4 15.21 4 13C4 9.65 5.94 6.86 8.79 5.65";
var mdiSpeedometerSlow = "M12 16C13.66 16 15 14.66 15 13C15 11.88 14.39 10.9 13.5 10.39L3.79 4.77L9.32 14.35C9.82 15.33 10.83 16 12 16M12 3C10.19 3 8.5 3.5 7.03 4.32L9.13 5.53C10 5.19 11 5 12 5C16.42 5 20 8.58 20 13C20 15.21 19.11 17.21 17.66 18.65H17.65C17.26 19.04 17.26 19.67 17.65 20.06C18.04 20.45 18.68 20.45 19.07 20.07C20.88 18.26 22 15.76 22 13C22 7.5 17.5 3 12 3M2 13C2 15.76 3.12 18.26 4.93 20.07C5.32 20.45 5.95 20.45 6.34 20.06C6.73 19.67 6.73 19.04 6.34 18.65C4.89 17.2 4 15.21 4 13C4 12 4.19 11 4.54 10.1L3.33 8C2.5 9.5 2 11.18 2 13Z";
var mdiSpellcheck = "M21.59,11.59L13.5,19.68L9.83,16L8.42,17.41L13.5,22.5L23,13M6.43,11L8.5,5.5L10.57,11M12.45,16H14.54L9.43,3H7.57L2.46,16H4.55L5.67,13H11.31L12.45,16Z";
var mdiSphere = "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2M12 14C7.58 14 4 13.11 4 12C4 10.9 7.58 10 12 10S20 10.9 20 12C20 13.11 16.42 14 12 14M12 4C15.37 4 18.25 6.09 19.43 9.05C17.93 8.43 15.61 8 12 8C9.8 8 6.73 8.19 4.57 9.05C5.75 6.09 8.63 4 12 4M12 20C8.63 20 5.75 17.91 4.57 14.95C6.07 15.57 8.39 16 12 16C14.2 16 17.27 15.81 19.43 14.95C18.25 17.91 15.37 20 12 20Z";
var mdiSphereOff = "M2.39 1.73L1.11 3L4.06 5.95C2.77 7.63 2 9.72 2 12C2 17.5 6.5 22 12 22C14.28 22 16.37 21.23 18.05 19.94L20.84 22.73L22.11 21.46L2.39 1.73M5.5 7.39L6.58 8.47C5.87 8.62 5.18 8.8 4.57 9.05C4.81 8.45 5.13 7.9 5.5 7.39M4 12C4 11.23 5.76 10.56 8.33 10.22L12.11 14L12 14C7.58 14 4 13.11 4 12M12 20C8.63 20 5.75 17.91 4.57 14.95C6.07 15.57 8.39 16 12 16C12.63 16 13.33 16 14.05 15.94L16.63 18.5C15.32 19.45 13.73 20 12 20M8.19 5L6.72 3.5C8.25 2.56 10.06 2 12 2C17.5 2 22 6.5 22 12C22 13.94 21.44 15.75 20.5 17.28L19 15.81C19.17 15.54 19.31 15.25 19.43 14.96C19.13 15.08 18.81 15.18 18.47 15.27L16.8 13.6C18.74 13.23 20 12.65 20 12C20 11 17.06 10.17 13.23 10.03L11.21 8C11.5 8 11.75 8 12 8C15.61 8 17.93 8.43 19.43 9.05C18.25 6.09 15.37 4 12 4C10.61 4 9.32 4.36 8.19 5Z";
var mdiSpider = "M21.29 16.71L22.71 15.29L19.5 12.11L16.5 11.26L18.41 11L22.6 7.8L21.4 6.2L17.59 9.05L14.91 9.5L18.11 6.31L17 1.76L15 2.24L15.86 5.69L14.76 6.83A3 3 0 0 0 9.24 6.83L8.11 5.69L9 2.24L7 1.76L5.89 6.31L9.09 9.5L6.4 9.05L2.6 6.2L1.4 7.8L5.6 11L7.46 11.31L4.46 12.16L1.29 15.29L2.71 16.71L5.5 13.89L7.87 13.22L4 16.54V22H6V17.46L7.56 16.12A4.5 4.5 0 0 0 16.44 16.12L18 17.46V22H20V16.54L16.13 13.22L18.5 13.89Z";
var mdiSpiderOutline = "M20 22H18V17.46L16.44 16.12C16.32 16.83 16.04 17.5 15.62 18.06C15.42 18.34 15.18 18.59 14.91 18.82C14.1 19.5 13.07 19.89 12 19.89C10.93 19.89 9.9 19.5 9.09 18.82C8.82 18.59 8.58 18.34 8.38 18.06C7.96 17.5 7.68 16.83 7.56 16.12L6 17.46V22H4V16.54L7.87 13.22L5.5 13.89L2.71 16.71L1.29 15.29L4.46 12.16L7.46 11.31L5.6 11L1.4 7.8L2.6 6.2L6.4 9.05L9.09 9.5L5.89 6.31L7 1.76L9 2.24L8.11 5.69L9.24 6.83L9.24 6.83C9.36 6.56 9.5 6.32 9.69 6.1C9.84 5.92 10 5.75 10.2 5.61C10.25 5.57 10.3 5.54 10.35 5.5C10.43 5.45 10.5 5.4 10.59 5.36C11.03 5.13 11.5 5 12 5C12.5 5 12.97 5.13 13.4 5.36C13.5 5.4 13.57 5.45 13.65 5.5C13.69 5.53 13.73 5.56 13.77 5.59C13.97 5.73 14.15 5.9 14.3 6.08C14.5 6.3 14.64 6.56 14.76 6.83L14.76 6.83L15.86 5.69L15 2.24L17 1.76L18.11 6.31L14.91 9.5L17.59 9.05L21.4 6.2L22.6 7.8L22.6 7.8L18.41 11L16.5 11.26L19.5 12.11L22.71 15.29L21.29 16.71L18.5 13.89L16.13 13.22L20 16.54V22M14.47 15.79L15 12.5L12 12L9 12.5L9.53 15.79C9.63 16.38 9.93 16.91 10.38 17.29C10.83 17.68 11.41 17.89 12 17.89C12.59 17.89 13.17 17.68 13.62 17.29C14.07 16.91 14.37 16.38 14.47 15.79M12 9.58L13.23 8.35L12.92 7.61C12.84 7.43 12.72 7.28 12.55 7.17C12.39 7.06 12.2 7 12 7C11.8 7 11.61 7.06 11.45 7.17C11.29 7.28 11.16 7.43 11.08 7.61L10.77 8.35L12 9.58Z";
var mdiSpiderThread = "M13 2V7.08A5.47 5.47 0 0 0 12 7A5.47 5.47 0 0 0 11 7.08V2M16.9 15A5 5 0 0 1 16.73 15.55L20 17.42V22H18V18.58L15.74 17.29A4.94 4.94 0 0 1 8.26 17.29L6 18.58V22H4V17.42L7.27 15.55A5 5 0 0 1 7.1 15H5.3L2.55 16.83L1.45 15.17L4.7 13H7.1A5 5 0 0 1 7.37 12.12L5.81 11.12L2.24 12L1.76 10L6.19 8.92L8.5 10.45A5 5 0 0 1 15.5 10.45L17.77 8.92L22.24 10L21.76 12L18.19 11.11L16.63 12.11A5 5 0 0 1 16.9 13H19.3L22.55 15.16L21.45 16.82L18.7 15M11 14A1 1 0 1 0 10 15A1 1 0 0 0 11 14M15 14A1 1 0 1 0 14 15A1 1 0 0 0 15 14Z";
var mdiSpiderWeb = "M13.62,13.28L15.26,15.54C15.29,15 15.38,14.47 15.56,13.93C15.74,13.37 16,12.86 16.3,12.41L13.62,13.28M17.77,19C17.75,17.68 17.95,16.27 18.41,14.85C18.88,13.42 19.56,12.14 20.36,11.09L18.32,11.75C17.54,12.26 16.87,13.14 16.5,14.23C16.17,15.29 16.18,16.36 16.5,17.22L17.77,19M19.25,21C18.75,21.46 18.21,21.86 17.63,22.2L17.31,21.76C15.9,21 14.04,20.5 12,20.5C9.96,20.5 8.1,21 6.69,21.76L6.37,22.2C5.79,21.86 5.25,21.46 4.75,21L5,20.69C5.33,19.08 5.22,17.12 4.58,15.14C3.94,13.19 2.9,11.56 1.71,10.46L1.27,10.32C1.42,9.66 1.63,9 1.89,8.41L2.29,8.54C3.92,8.37 5.74,7.65 7.43,6.43C9.09,5.22 10.32,3.73 11,2.26V1.79L12,1.75L13,1.79V2.21C13.67,3.71 14.91,5.23 16.6,6.45C18.26,7.66 20.06,8.37 21.67,8.56L22.11,8.41C22.37,9 22.58,9.66 22.73,10.32L22.23,10.5C21.04,11.58 20,13.21 19.37,15.16C18.74,17.09 18.62,19 18.92,20.57L19.25,21M11,11.37V8.5C10.66,8.92 10.26,9.32 9.78,9.67C9.29,10 8.77,10.29 8.25,10.5L11,11.37M11,4.22C10.25,5.31 9.24,6.35 8,7.24C6.78,8.14 5.46,8.78 4.18,9.16L6.15,9.8C7.11,9.88 8.22,9.56 9.19,8.86C10.13,8.18 10.76,7.27 11,6.36V4.22M13,11.37L15.74,10.5C15.23,10.3 14.72,10.03 14.25,9.69C13.76,9.33 13.34,8.92 13,8.5V11.37M19.8,9.16C18.53,8.78 17.23,8.15 16,7.26C14.77,6.36 13.76,5.31 13,4.2V6.27C13.22,7.21 13.86,8.17 14.84,8.88C15.77,9.56 16.83,9.87 17.77,9.82L19.8,9.16M10.38,13.28L7.64,12.39C7.95,12.84 8.2,13.35 8.38,13.91C8.57,14.5 8.66,15.06 8.68,15.62L10.38,13.28M3.58,11.07C4.38,12.12 5.06,13.4 5.53,14.83C6,16.29 6.2,17.74 6.17,19.08L7.38,17.41C7.76,16.5 7.8,15.36 7.43,14.22C7.07,13.12 6.4,12.24 5.61,11.73L3.58,11.07M12,14.45L10.35,16.72C10.87,16.58 11.42,16.5 12,16.5C12.58,16.5 13.13,16.58 13.65,16.72L12,14.45M7.84,20.18C9.08,19.75 10.5,19.5 12,19.5C13.5,19.5 14.92,19.75 16.16,20.18L14.88,18.42C14.16,17.85 13.13,17.5 12,17.5C10.87,17.5 9.84,17.85 9.12,18.42L7.84,20.18Z";
var mdiSpiritLevel = "M22 8H2V16H22V8M18 14V10H20V14H18M11 12H13C14.1 12 15 11.11 15 10H17V14H7V10H9C9 11.11 9.9 12 11 12M4 14V10H6V14H4Z";
var mdiSpoonSugar = "M6 13H3V10H6V13M10 10H7V13H10V10M8 6H5V9H8V6M18 12C14.25 12 12.28 13.25 11 14H2C2 16.21 3.79 18 6 18H7C8 18 8.92 17.63 9.62 17C11.06 15.78 12.68 14.74 14.55 14.36C15.61 14.15 16.78 14 18 14H22V12H18Z";
var mdiSpotify = "M17.9,10.9C14.7,9 9.35,8.8 6.3,9.75C5.8,9.9 5.3,9.6 5.15,9.15C5,8.65 5.3,8.15 5.75,8C9.3,6.95 15.15,7.15 18.85,9.35C19.3,9.6 19.45,10.2 19.2,10.65C18.95,11 18.35,11.15 17.9,10.9M17.8,13.7C17.55,14.05 17.1,14.2 16.75,13.95C14.05,12.3 9.95,11.8 6.8,12.8C6.4,12.9 5.95,12.7 5.85,12.3C5.75,11.9 5.95,11.45 6.35,11.35C10,10.25 14.5,10.8 17.6,12.7C17.9,12.85 18.05,13.35 17.8,13.7M16.6,16.45C16.4,16.75 16.05,16.85 15.75,16.65C13.4,15.2 10.45,14.9 6.95,15.7C6.6,15.8 6.3,15.55 6.2,15.25C6.1,14.9 6.35,14.6 6.65,14.5C10.45,13.65 13.75,14 16.35,15.6C16.7,15.75 16.75,16.15 16.6,16.45M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiSpotlight = "M2,6L7.09,8.55C6.4,9.5 6,10.71 6,12C6,13.29 6.4,14.5 7.09,15.45L2,18V6M6,3H18L15.45,7.09C14.5,6.4 13.29,6 12,6C10.71,6 9.5,6.4 8.55,7.09L6,3M22,6V18L16.91,15.45C17.6,14.5 18,13.29 18,12C18,10.71 17.6,9.5 16.91,8.55L22,6M18,21H6L8.55,16.91C9.5,17.6 10.71,18 12,18C13.29,18 14.5,17.6 15.45,16.91L18,21M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z";
var mdiSpotlightBeam = "M9,16.5L9.91,15.59L15.13,20.8L14.21,21.71L9,16.5M15.5,10L16.41,9.09L21.63,14.3L20.71,15.21L15.5,10M6.72,2.72L10.15,6.15L6.15,10.15L2.72,6.72C1.94,5.94 1.94,4.67 2.72,3.89L3.89,2.72C4.67,1.94 5.94,1.94 6.72,2.72M14.57,7.5L15.28,8.21L8.21,15.28L7.5,14.57L6.64,11.07L11.07,6.64L14.57,7.5Z";
var mdiSpray = "M10,4H12V6H10V4M7,3H9V5H7V3M7,6H9V8H7V6M6,8V10H4V8H6M6,5V7H4V5H6M6,2V4H4V2H6M13,22A2,2 0 0,1 11,20V10A2,2 0 0,1 13,8V7H14V4H17V7H18V8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H13M13,10V20H18V10H13Z";
var mdiSprayBottle = "M16.72 10.43C14.68 8.39 14.5 4.66 14.5 4H13V6H9V4H7C7 2.9 7.9 2 9 2H16V3C16 3.08 16.04 7.63 17.78 9.37L16.72 10.43M17 2V4H18V2H17M15 12C13 10 13 7 13 7H9V9C9 10 9 10 8 11S7 13 7 13V20C7 21.1 7.9 22 9 22H13C14.1 22 15 21.1 15 20V12Z";
var mdiSprinkler = "M11 7H13V9H11V7M5 22H9V10H5V22M14 11H16V9H14V11M17 10H19V8H17V10M17 5V7H19V5H17M14 8H16V6H14V8M17 13H19V11H17V13M5 7H5.33L6 9H8L8.67 7H9V6H5V7Z";
var mdiSprinklerFire = "M5 21V23H7V21H5M11 21H9V23H11V21M7 18V20H9V18H7M11 15V17H9V15H11M15 21H13V23H15V21M11 18V20H13V18H11M15 15V17H13V15H15M19 21H17V23H19V21M15 18V20H17V18H15M16 11V13H8V11H11V5H13V11H16M21 1V3H18V6L14 10V7.2L16 5.2V3H8V5.2L10 7.2V10L6 6V3H3V1H21Z";
var mdiSprinklerVariant = "M10 10H14V22H10V10M7 9H9V7H7V9M4 8H6V6H4V8M4 11H6V9H4V11M1 13H3V11H1V13M1 7H3V5H1V7M1 10H3V8H1V10M18 11H20V9H18V11M21 10H23V8H21V10M21 5V7H23V5H21M21 13H23V11H21V13M15 9H17V7H15V9M18 8H20V6H18V8M10 7H10.33L11 9H13L13.67 7H14V6H10V7Z";
var mdiSprout = "M2,22V20C2,20 7,18 12,18C17,18 22,20 22,20V22H2M11.3,9.1C10.1,5.2 4,6.1 4,6.1C4,6.1 4.2,13.9 9.9,12.7C9.5,9.8 8,9 8,9C10.8,9 11,12.4 11,12.4V17C11.3,17 11.7,17 12,17C12.3,17 12.7,17 13,17V12.8C13,12.8 13,8.9 16,7.9C16,7.9 14,10.9 14,12.9C21,13.6 21,4 21,4C21,4 12.1,3 11.3,9.1Z";
var mdiSproutOutline = "M23,4.1V2.3L21.2,2.1C21.1,2.1 20.5,2 19.5,2C15.4,2 12.4,3.2 10.7,5.3C9.4,4.5 7.6,4 5.5,4C4.5,4 3.8,4.1 3.8,4.1L1.9,4.4L2,6.1C2.1,9.1 3.6,14.8 8.8,14.8C8.9,14.8 8.9,14.8 9,14.8V18.2C5.2,18.7 2,20 2,20V22H22V20C22,20 18.8,18.7 15,18.2V15C21.3,14.9 23,7.8 23,4.1M12,18C11.7,18 11.3,18 11,18V12.4C11,12.4 10.8,9 8,9C8,9 9.5,9.8 9.9,12.7C9.5,12.8 9.1,12.8 8.8,12.8C4.2,12.8 4,6.1 4,6.1C4,6.1 4.6,6 5.5,6C7.4,6 10.5,6.4 11.4,9.1C11.9,4.6 17,4 19.5,4C20.4,4 21,4.1 21,4.1C21,4.1 21,13.1 14.7,13.1C14.5,13.1 14.2,13.1 14,13.1C14,11.1 16,8.1 16,8.1C13,9.1 13,13 13,13V18C12.7,18 12.3,18 12,18Z";
var mdiSquare = "M3,3V21H21V3";
var mdiSquareCircle = "M20 4V20H4V4H20M22 2H2V22H22V2M12 6C8.69 6 6 8.69 6 12S8.69 18 12 18 18 15.31 18 12 15.31 6 12 6Z";
var mdiSquareCircleOutline = "M18 12C18 8.69 15.31 6 12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12M12 8C14.21 8 16 9.8 16 12C16 14.21 14.21 16 12 16C9.8 16 8 14.21 8 12C8 9.8 9.8 8 12 8M20 4H4V20H20V4M22 2V22H2V2H22Z";
var mdiSquareEditOutline = "M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19H5V5H12V3H5M17.78,4C17.61,4 17.43,4.07 17.3,4.2L16.08,5.41L18.58,7.91L19.8,6.7C20.06,6.44 20.06,6 19.8,5.75L18.25,4.2C18.12,4.07 17.95,4 17.78,4M15.37,6.12L8,13.5V16H10.5L17.87,8.62L15.37,6.12Z";
var mdiSquareMedium = "M16,8H8V16H16V8Z";
var mdiSquareMediumOutline = "M14,10V14H10V10H14M16,8H8V16H16V8Z";
var mdiSquareOff = "M20.84 22.73L19.11 21H3V4.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M21 3H6.2L21 17.8V3Z";
var mdiSquareOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L3 4.89V21H19.11L20.84 22.73L22.11 21.46M5 19V6.89L17.11 19H5M8.2 5L6.2 3H21V17.8L19 15.8V5H8.2Z";
var mdiSquareOpacity = "M19 13V11H21V13H19M21 9V7H19V9H21M21 3H19V5H21V3M17 15H19V13H17V15M21 17V15H19V17H21M13 17V15H15V13H13V11H15V9H13V7H15V5H13V3H3V21H13V19H15V17H13M15 21H17V19H15V21M17 3H15V5H17V3M17 11H19V9H17V11M15 17H17V15H15V17M17 19H19V17H17V19M21 21V19H19V21H21M15 9H17V7H15V9M15 13H17V11H15V13M17 5V7H19V5H17Z";
var mdiSquareOutline = "M3,3H21V21H3V3M5,5V19H19V5H5Z";
var mdiSquareRoot = "M11.76,16.83L14.59,14L11.76,11.17L13.17,9.76L16,12.59L18.83,9.76L20.24,11.17L17.41,14L20.24,16.83L18.83,18.24L16,15.41L13.17,18.24L11.76,16.83M2,11H5V11H5L7.29,16.4L10,6H22V8H11.55L8.68,19H6.22L3.68,13H2V11Z";
var mdiSquareRootBox = "M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5M11.24,6H19V8H12.76L10,18H8L6.25,12H5V10H7.75L9,14.28L11.24,6V6M14,10.59L15.79,12.38L17.59,10.59L19,12L17.21,13.79L19,15.59L17.59,17L15.79,15.21L14,17L12.59,15.59L14.38,13.79L12.59,12L14,10.59Z";
var mdiSquareRounded = "M8 3H16C18.76 3 21 5.24 21 8V16C21 18.76 18.76 21 16 21H8C5.24 21 3 18.76 3 16V8C3 5.24 5.24 3 8 3Z";
var mdiSquareRoundedBadge = "M19.5 8C21.43 8 23 6.43 23 4.5C23 2.57 21.43 1 19.5 1C17.57 1 16 2.57 16 4.5C16 6.43 17.57 8 19.5 8M19.5 10C20 10 20.5 9.93 21 9.79V16C21 18.76 18.76 21 16 21H8C5.24 21 3 18.76 3 16V8C3 5.24 5.24 3 8 3H14.21C14.07 3.5 14 4 14 4.5C14 7.54 16.46 10 19.5 10Z";
var mdiSquareRoundedBadgeOutline = "M19.5 8C21.43 8 23 6.43 23 4.5C23 2.57 21.43 1 19.5 1C17.57 1 16 2.57 16 4.5C16 6.43 17.57 8 19.5 8M21 16V9.79C20.5 9.93 20 10 19.5 10C19.33 10 19.17 10 19 10V16C19 17.66 17.66 19 16 19H8C6.34 19 5 17.66 5 16V8C5 6.34 6.34 5 8 5H14C14 4.84 14 4.67 14 4.5C14 4 14.07 3.5 14.21 3H8C5.24 3 3 5.24 3 8V16C3 18.76 5.24 21 8 21H16C18.76 21 21 18.76 21 16Z";
var mdiSquareRoundedOutline = "M8 3H16C18.76 3 21 5.24 21 8V16C21 18.76 18.76 21 16 21H8C5.24 21 3 18.76 3 16V8C3 5.24 5.24 3 8 3M8 5C6.34 5 5 6.34 5 8V16C5 17.66 6.34 19 8 19H16C17.66 19 19 17.66 19 16V8C19 6.34 17.66 5 16 5H8Z";
var mdiSquareSmall = "M10,14V10H14V14H10Z";
var mdiSquareWave = "M2 2V12H4V4H11V22H22V12H20V20H13V2H2Z";
var mdiSqueegee = "M22,2V5H2V2H22M2,8H7L9,10H10V20A2,2 0 0,0 12,22A2,2 0 0,0 14,20V10H15L17,8H22V6H2V8Z";
var mdiSsh = "M4.5,9C3.9,9 3.5,9.5 3.5,10V11.75C3.5,12.25 3.9,12.75 4.5,12.75H7V13.5H3.5V15H7.5C8.1,15 8.5,14.5 8.5,14V12.25C8.5,11.75 8.1,11.25 7.5,11.25H5V10.5H8.5V9H4.5M10.5,9C9.9,9 9.5,9.5 9.5,10V11.75C9.5,12.25 9.9,12.75 10.5,12.75H13V13.5H9.5V15H13.5C14.1,15 14.5,14.5 14.5,14V12.25C14.5,11.75 14.1,11.25 13.5,11.25H11V10.5H14.5V9H10.5M15.5,9V15H17V12.5H19V15H20.5V9H19V11H17V9H15.5Z";
var mdiStackExchange = "M3.9 10.72H20V14.03H3.9V10.72M3.9 6.44H20V9.75H3.9V6.44M17.5 2H6.5C5.06 2 3.9 3.18 3.9 4.65V5.5H20V4.65C20 3.18 18.88 2 17.5 2M3.9 15V15.84C3.9 17.31 5.06 18.5 6.5 18.5H13.37V22L16.77 18.5H17.5C18.94 18.5 20.11 17.31 20.11 15.84V15H3.9Z";
var mdiStackOverflow = "M17.36,20.2V14.82H19.15V22H3V14.82H4.8V20.2H17.36M6.77,14.32L7.14,12.56L15.93,14.41L15.56,16.17L6.77,14.32M7.93,10.11L8.69,8.5L16.83,12.28L16.07,13.9L7.93,10.11M10.19,6.12L11.34,4.74L18.24,10.5L17.09,11.87L10.19,6.12M14.64,1.87L20,9.08L18.56,10.15L13.2,2.94L14.64,1.87M6.59,18.41V16.61H15.57V18.41H6.59Z";
var mdiStackpath = "M4.91 8C4.04 8 3.32 8.2 2.76 8.61C2.19 9 1.91 9.53 1.91 10.19C1.91 10.85 2.15 11.37 2.62 11.72C3.1 12.07 3.82 12.41 4.8 12.72C5.27 12.88 5.6 13.04 5.78 13.19C5.96 13.34 6.05 13.55 6.05 13.83C6.05 14.07 5.96 14.26 5.78 14.41C5.6 14.56 5.32 14.63 4.94 14.63C4.45 14.63 4.09 14.54 3.85 14.35C3.6 14.16 3.5 13.84 3.5 13.39H1.72L1.71 13.42C1.7 14.25 2 14.89 2.66 15.33C3.3 15.78 4.06 16 4.94 16C5.82 16 6.5 15.8 7.06 15.42C7.59 15.03 7.86 14.5 7.86 13.81C7.86 13.14 7.63 12.61 7.19 12.23C6.74 11.84 6.08 11.5 5.2 11.26C4.62 11.05 4.23 10.88 4 10.74C3.81 10.6 3.71 10.42 3.71 10.2C3.71 9.96 3.81 9.76 4 9.6C4.22 9.44 4.5 9.36 4.87 9.36C5.24 9.36 5.53 9.46 5.74 9.65C5.96 9.84 6.07 10.12 6.06 10.41H7.8L7.82 10.37C7.84 9.68 7.57 9.11 7 8.66C6.47 8.22 5.77 8 4.91 8M9 8.05V15.93H10.84V13.23H11.96C12.89 13.23 13.63 13 14.18 12.5C14.73 12.05 15 11.42 15 10.64C15 9.87 14.73 9.25 14.18 8.77C13.63 8.29 12.89 8.05 11.96 8.05H9M17.24 8.05L14.5 15.93H16.22L19 8.05M20.5 8.05L17.79 15.93H19.5L22.29 8.05M10.84 9.46H11.96C12.35 9.46 12.66 9.57 12.86 9.8C13.07 10 13.17 10.31 13.17 10.65C13.17 11 13.07 11.28 12.86 11.5C12.66 11.71 12.35 11.82 11.96 11.82H10.84";
var mdiStadium = "M7 5L3 7V3L7 5M18 3V7L22 5L18 3M11 2V6L15 4L11 2M5 10C6.4 10.5 8.8 11 12 11S17.6 10.5 19 10C19 9.8 16.2 9 12 9S5 9.9 5 10M15 17H9V21.9C4.9 21.5 2 20.4 2 19V10C2 8.3 6.5 7 12 7S22 8.3 22 10V19C22 20.3 19.1 21.5 15 21.9V17Z";
var mdiStadiumOutline = "M7 5L3 7V3L7 5M18 3V7L22 5L18 3M11 2V6L15 4L11 2M13 18H11V22C5.9 21.9 2 20.6 2 19V10C2 8.3 6.5 7 12 7S22 8.3 22 10V19C22 20.6 18 21.9 13 22V18M5 10C6.4 10.5 8.8 11 12 11S17.6 10.5 19 10C19 9.8 16.2 9 12 9S5 9.9 5 10M20 11.8C18.2 12.5 15.3 13 12 13S5.8 12.5 4 11.8V18.6C4.6 19 6.4 19.6 9 19.9V16H15V19.9C17.6 19.6 19.4 19 20 18.6V11.8Z";
var mdiStadiumVariant = "M5,3H7L10,5L7,7V8.33C8.47,8.12 10.18,8 12,8C13.82,8 15.53,8.12 17,8.33V3H19L22,5L19,7V8.71C20.85,9.17 22,9.8 22,10.5C22,11.88 17.5,13 12,13C6.5,13 2,11.88 2,10.5C2,9.8 3.15,9.17 5,8.71V3M12,9.5C8.69,9.5 7,9.67 7,10.5C7,11.33 8.69,11.5 12,11.5C15.31,11.5 17,11.33 17,10.5C17,9.67 15.31,9.5 12,9.5M12,14.75C15.81,14.75 19.2,14.08 21.4,13.05L20,21H15V19A2,2 0 0,0 13,17H11A2,2 0 0,0 9,19V21H4L2.6,13.05C4.8,14.08 8.19,14.75 12,14.75Z";
var mdiStairs = "M15,5V9H11V13H7V17H3V20H10V16H14V12H18V8H22V5H15Z";
var mdiStairsBox = "M5 3C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3H5M14 7H19V9H16V12H13V15H10V18H5V16H8V13H11V10H14V7Z";
var mdiStairsDown = "M15 6H22V9H18V13H14V17H10V21H3V18H7V14H11V10H15V6M4.83 8.34L10.34 2.83L12.17 4.66L6.66 10.17L8.5 12H3V6.5L4.83 8.34Z";
var mdiStairsUp = "M15 6H22V9H18V13H14V17H10V21H3V18H7V14H11V10H15V6M10.17 6.66L4.66 12.17L2.83 10.34L8.34 4.83L6.5 3H12V8.5L10.17 6.66Z";
var mdiStamper = "M12,3A3,3 0 0,0 9,6C9,9 14,13 6,13A2,2 0 0,0 4,15V17H20V15A2,2 0 0,0 18,13C10,13 15,9 15,6C15,4 13.66,3 12,3M6,19V21H18V19H6Z";
var mdiStandardDefinition = "M13,7H16A3,3 0 0,1 19,10V14A3,3 0 0,1 16,17H13V7M16,15A1,1 0 0,0 17,14V10A1,1 0 0,0 16,9H15V15H16M7,7H11V9H7V11H9A2,2 0 0,1 11,13V15A2,2 0 0,1 9,17H5V15H9V13H7A2,2 0 0,1 5,11V9A2,2 0 0,1 7,7Z";
var mdiStar = "M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z";
var mdiStarBox = "M19,3A2,2 0 0,1 21,5V19C21,20.11 20.1,21 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M15.58,17L14.63,12.92L17.79,10.19L13.62,9.83L12,6L10.38,9.84L6.21,10.2L9.37,12.93L8.42,17L12,14.84L15.58,17Z";
var mdiStarBoxMultiple = "M4 6V20H18V22H3C2.4 22 2 21.6 2 21V6H4M8 2H20C21.11 2 22 2.9 22 4V16C22 17.11 21.11 18 20 18H8C6.9 18 6 17.11 6 16V4C6 2.9 6.9 2 8 2M16.3 13.3L15.9 10.7L17.8 8.8L15.2 8.4L14 6L12.8 8.4L10.2 8.8L12.1 10.6L11.6 13.2L14 12L16.3 13.3Z";
var mdiStarBoxMultipleOutline = "M4 6V20H18V22H3C2.4 22 2 21.6 2 21V6H4M12.1 10.6L10.2 8.8L12.8 8.4L14 6L15.2 8.4L17.8 8.8L15.9 10.7L16.3 13.3L14 12L11.6 13.2L12.1 10.6M8 2H20C21.11 2 22 2.9 22 4V16C22 17.11 21.11 18 20 18H8C6.9 18 6 17.11 6 16V4C6 2.9 6.9 2 8 2M8 4V16H20V4H8Z";
var mdiStarBoxOutline = "M15.58,17L12,14.84L8.42,17L9.37,12.93L6.21,10.2L10.38,9.84L12,6L13.62,9.83L17.79,10.19L14.63,12.92L15.58,17M19,3A2,2 0 0,1 21,5V19C21,20.11 20.1,21 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M5,5V19H19V5H5Z";
var mdiStarCheck = "M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C14.9 12 12.4 14.3 12 17.3L5.8 21M17.8 21.2L22.6 16.4L21.3 15L17.7 18.6L16.2 17L15 18.2L17.8 21.2";
var mdiStarCheckOutline = "M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C17.3 12 16.6 12.1 15.9 12.4L18.1 10.5L13.7 10.1L12 6.1L10.3 10.1L5.9 10.5L9.2 13.4L8.2 17.7L12 15.4L12.5 15.7C12.3 16.2 12.1 16.8 12.1 17.3L5.8 21M17.8 21.2L15 18.2L16.2 17L17.8 18.6L21.4 15L22.6 16.4L17.8 21.2";
var mdiStarCircle = "M16.23,18L12,15.45L7.77,18L8.89,13.19L5.16,9.96L10.08,9.54L12,5L13.92,9.53L18.84,9.95L15.11,13.18L16.23,18M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiStarCircleOutline = "M8.58,17.25L9.5,13.36L6.5,10.78L10.45,10.41L12,6.8L13.55,10.45L17.5,10.78L14.5,13.36L15.42,17.25L12,15.19L8.58,17.25M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z";
var mdiStarCog = "M18.8 12C15.59 12.1 12.91 14.37 12.19 17.39L12 17.27L5.82 21L7.45 13.97L2 9.24L9.19 8.62L12 2L14.81 8.62L22 9.24L18.8 12M23.83 20.64L22.83 22.37C22.76 22.5 22.63 22.5 22.5 22.5L21.27 22C21 22.18 20.73 22.34 20.43 22.47L20.24 23.79C20.22 23.91 20.11 24 20 24H18C17.86 24 17.76 23.91 17.74 23.79L17.55 22.47C17.24 22.35 16.96 22.18 16.7 22L15.46 22.5C15.34 22.5 15.21 22.5 15.15 22.37L14.15 20.64C14.09 20.53 14.12 20.4 14.21 20.32L15.27 19.5C15.25 19.33 15.24 19.17 15.24 19S15.25 18.67 15.27 18.5L14.21 17.68C14.11 17.6 14.09 17.47 14.15 17.36L15.15 15.63C15.22 15.5 15.35 15.5 15.46 15.5L16.7 16C16.96 15.82 17.25 15.66 17.55 15.53L17.74 14.21C17.76 14.09 17.87 14 18 14H20C20.11 14 20.22 14.09 20.23 14.21L20.42 15.53C20.73 15.65 21 15.82 21.27 16L22.5 15.5C22.63 15.5 22.76 15.5 22.82 15.63L23.82 17.36C23.88 17.47 23.85 17.6 23.76 17.68L22.7 18.5C22.73 18.67 22.74 18.83 22.74 19S22.72 19.33 22.7 19.5L23.77 20.32C23.86 20.4 23.89 20.53 23.83 20.64M20.5 19C20.5 18.17 19.83 17.5 19 17.5S17.5 18.17 17.5 19 18.16 20.5 19 20.5C19.83 20.5 20.5 19.83 20.5 19Z";
var mdiStarCogOutline = "M10.29 10.13L5.91 10.5L9.23 13.38L8.24 17.66L12 15.39L12.76 15.85C12.5 16.33 12.32 16.85 12.19 17.39L12 17.27L5.82 21L7.45 13.97L2 9.24L9.19 8.63L12 2L14.81 8.63L22 9.24L18.8 12C17.29 12.05 15.91 12.57 14.78 13.43L14.77 13.38L18.09 10.5L13.71 10.13L12 6.09L10.29 10.13M23.83 20.64L22.83 22.37C22.76 22.5 22.63 22.5 22.5 22.5L21.27 22C21 22.18 20.73 22.34 20.43 22.47L20.24 23.79C20.22 23.91 20.11 24 20 24H18C17.86 24 17.76 23.91 17.74 23.79L17.55 22.47C17.24 22.35 16.96 22.18 16.7 22L15.46 22.5C15.34 22.5 15.21 22.5 15.15 22.37L14.15 20.64C14.09 20.53 14.12 20.4 14.21 20.32L15.27 19.5C15.25 19.33 15.24 19.17 15.24 19S15.25 18.67 15.27 18.5L14.21 17.68C14.11 17.6 14.09 17.47 14.15 17.36L15.15 15.63C15.22 15.5 15.35 15.5 15.46 15.5L16.7 16C16.96 15.82 17.25 15.66 17.55 15.53L17.74 14.21C17.76 14.09 17.87 14 18 14H20C20.11 14 20.22 14.09 20.23 14.21L20.42 15.53C20.73 15.65 21 15.82 21.27 16L22.5 15.5C22.63 15.5 22.76 15.5 22.82 15.63L23.82 17.36C23.88 17.47 23.85 17.6 23.76 17.68L22.7 18.5C22.73 18.67 22.74 18.83 22.74 19S22.72 19.33 22.7 19.5L23.77 20.32C23.86 20.4 23.89 20.53 23.83 20.64M20.5 19C20.5 18.17 19.83 17.5 19 17.5S17.5 18.17 17.5 19 18.16 20.5 19 20.5C19.83 20.5 20.5 19.83 20.5 19Z";
var mdiStarCrescent = "M12.3,2C12.2,2 12.1,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22C15,22 16.7,21 18.5,19.5C13,21 8,17 8,12C8,7 13,3 18.5,4.5C16.86,2.86 14.62,1.96 12.3,2M16.8,6.2L15.3,9.7L11.6,10L14.5,12.5L13.6,16L16.8,14L20,16L19,12.5L22,10L18.3,9.7L16.8,6.2Z";
var mdiStarDavid = "M12,2L9.1,7H3.3L6.3,12L3.3,17H9.1L12,22L14.9,17H20.7L17.7,12L20.7,7H14.9L12,2M12,5L13.2,7H10.8L12,5M8.2,8.5L7.1,10.5L5.9,8.5H8.2M10,8.5H14L16,12L14,15.5H10L8,12L10,8.5M18,8.5L16.8,10.5L15.7,8.5H18M7.1,13.5L8.2,15.5H6L7.1,13.5M16.9,13.5L18.1,15.5H15.8L16.9,13.5M13.3,17L12,19L10.8,17H13.3Z";
var mdiStarFace = "M12,2.5L8.42,8.06L2,9.74L6.2,14.88L5.82,21.5L12,19.09L18.18,21.5L17.8,14.88L22,9.74L15.58,8.06L12,2.5M9.38,10.5C10,10.5 10.5,11 10.5,11.63A1.12,1.12 0 0,1 9.38,12.75C8.75,12.75 8.25,12.25 8.25,11.63C8.25,11 8.75,10.5 9.38,10.5M14.63,10.5C15.25,10.5 15.75,11 15.75,11.63A1.12,1.12 0 0,1 14.63,12.75C14,12.75 13.5,12.25 13.5,11.63C13.5,11 14,10.5 14.63,10.5M9,15H15C14.5,16.21 13.31,17 12,17C10.69,17 9.5,16.21 9,15Z";
var mdiStarFourPoints = "M12,1L9,9L1,12L9,15L12,23L15,15L23,12L15,9L12,1Z";
var mdiStarFourPointsBox = "M5 3H19C20.1 3 21 3.89 21 5V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 3.89 3.89 3 5 3M12 17L13.56 13.58L17 12L13.56 10.44L12 7L10.43 10.44L7 12L10.43 13.58L12 17Z";
var mdiStarFourPointsBoxOutline = "M12 17L13.56 13.58L17 12L13.56 10.44L12 7L10.43 10.44L7 12L10.43 13.58L12 17M5 3H19C20.1 3 21 3.89 21 5V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 3.89 3.89 3 5 3M5 19H19V5H5V19Z";
var mdiStarFourPointsCircle = "M8.17 2.76C9.39 2.26 10.69 2 12 2C13.31 2 14.61 2.26 15.83 2.76C17.04 3.26 18.14 4 19.07 4.93C20 5.86 20.74 6.96 21.24 8.17C21.74 9.39 22 10.69 22 12C22 14.65 20.95 17.2 19.07 19.07C17.2 20.95 14.65 22 12 22C10.69 22 9.39 21.74 8.17 21.24C6.96 20.74 5.86 20 4.93 19.07C3.05 17.2 2 14.65 2 12C2 9.35 3.05 6.8 4.93 4.93C5.86 4 6.96 3.26 8.17 2.76M12 17L13.56 13.58L17 12L13.56 10.44L12 7L10.43 10.44L7 12L10.43 13.58L12 17Z";
var mdiStarFourPointsCircleOutline = "M12 17L13.56 13.58L17 12L13.56 10.44L12 7L10.43 10.44L7 12L10.43 13.58L12 17M8.17 2.76C9.39 2.26 10.69 2 12 2C13.31 2 14.61 2.26 15.83 2.76C17.04 3.26 18.14 4 19.07 4.93C20 5.86 20.74 6.96 21.24 8.17C21.74 9.39 22 10.69 22 12C22 14.65 20.95 17.2 19.07 19.07C17.2 20.95 14.65 22 12 22C10.69 22 9.39 21.74 8.17 21.24C6.96 20.74 5.86 20 4.93 19.07C3.05 17.2 2 14.65 2 12C2 9.35 3.05 6.8 4.93 4.93C5.86 4 6.96 3.26 8.17 2.76M6.34 17.66C7.84 19.16 9.88 20 12 20C14.12 20 16.16 19.16 17.66 17.66C19.16 16.16 20 14.12 20 12C20 9.88 19.16 7.84 17.66 6.34C16.16 4.84 14.12 4 12 4C9.88 4 7.84 4.84 6.34 6.34C4.84 7.84 4 9.88 4 12C4 14.12 4.84 16.16 6.34 17.66Z";
var mdiStarFourPointsOutline = "M12,6.7L13.45,10.55L17.3,12L13.45,13.45L12,17.3L10.55,13.45L6.7,12L10.55,10.55L12,6.7M12,1L9,9L1,12L9,15L12,23L15,15L23,12L15,9L12,1Z";
var mdiStarFourPointsSmall = "M10.74 10.75L12 8L13.25 10.75L16 12L13.25 13.26L12 16L10.74 13.26L8 12L10.74 10.75Z";
var mdiStarHalf = "M12 2L9.19 8.62L2 9.24L7.45 13.97L5.82 21L12 17.27V2Z";
var mdiStarHalfFull = "M12,15.4V6.1L13.71,10.13L18.09,10.5L14.77,13.39L15.76,17.67M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z";
var mdiStarMinus = "M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C14.9 12 12.4 14.3 12 17.3L5.8 21M14 17V19H22V17H14Z";
var mdiStarMinusOutline = "M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C17.3 12 16.6 12.1 15.9 12.4L18.1 10.5L13.7 10.1L12 6.1L10.3 10.1L5.9 10.5L9.2 13.4L8.2 17.7L12 15.4L12.5 15.7C12.3 16.2 12.1 16.8 12.1 17.3L5.8 21M14 17V19H22V17H14Z";
var mdiStarOff = "M20.8 22.7L17.9 19.8L18.2 21L12 17.3L5.8 21L7.4 14L2 9.2L6.9 8.8L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M22 9.2L14.8 8.6L12 2L10 6.8L16.9 13.7L22 9.2Z";
var mdiStarOffOutline = "M22.1 21.5L2.4 1.7L1.1 3L6.9 8.8L2 9.2L7.5 14L5.9 21L12.1 17.3L18.3 21L18 19.8L20.9 22.7L22.1 21.5M15.8 17.7L12 15.4L8.2 17.7L9.2 13.4L5.9 10.5L8.4 10.3L15.8 17.7M11.2 8L10 6.8L12 2L14.8 8.6L22 9.2L16.9 13.6L15.8 12.5L18.2 10.5L13.8 10.1L12.1 6.1L11.2 8Z";
var mdiStarOutline = "M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z";
var mdiStarPlus = "M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C14.9 12 12.4 14.3 12 17.3L5.8 21M17 14V17H14V19H17V22H19V19H22V17H19V14H17Z";
var mdiStarPlusOutline = "M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C17.3 12 16.6 12.1 15.9 12.4L18.1 10.5L13.7 10.1L12 6.1L10.3 10.1L5.9 10.5L9.2 13.4L8.2 17.7L12 15.4L12.5 15.7C12.3 16.2 12.1 16.8 12.1 17.3L5.8 21M17 14V17H14V19H17V22H19V19H22V17H19V14H17Z";
var mdiStarRemove = "M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C14.9 12 12.4 14.3 12 17.3L5.8 21M20.1 14.5L18 16.6L15.9 14.5L14.5 15.9L16.6 18L14.5 20.1L15.9 21.5L18 19.4L20.1 21.5L21.5 20.1L19.4 18L21.5 15.9L20.1 14.5Z";
var mdiStarRemoveOutline = "M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C17.3 12 16.6 12.1 15.9 12.4L18.1 10.5L13.7 10.1L12 6.1L10.3 10.1L5.9 10.5L9.2 13.4L8.2 17.7L12 15.4L12.5 15.7C12.3 16.2 12.1 16.8 12.1 17.3L5.8 21M20.1 14.5L18 16.6L15.9 14.5L14.5 15.9L16.6 18L14.5 20.1L15.9 21.5L18 19.4L20.1 21.5L21.5 20.1L19.4 18L21.5 15.9L20.1 14.5Z";
var mdiStarSettings = "M7 22H9V24H7V22M11 24H13V22H11V24M15 24H17V22H15V24M22 9.24L14.81 8.62L12 2L9.19 8.62L2 9.24L7.45 13.97L5.82 21L12 17.27L18.18 21L16.54 13.97L22 9.24Z";
var mdiStarSettingsOutline = "M11 22H13V24H11V22M7 24H9V22H7V24M15 24H17V22H15V24M16.54 13.97L18.18 21L12 17.27L5.82 21L7.45 13.97L2 9.24L9.19 8.63L12 2L14.81 8.63L22 9.24L16.54 13.97M15.76 17.66L14.77 13.38L18.09 10.5L13.71 10.13L12 6.09L10.29 10.13L5.91 10.5L9.23 13.38L8.24 17.66L12 15.39L15.76 17.66Z";
var mdiStarShooting = "M18.09 11.77L19.56 18.1L14 14.74L8.44 18.1L9.9 11.77L5 7.5L11.47 6.96L14 1L16.53 6.96L23 7.5L18.09 11.77M2 12.43C2.19 12.43 2.38 12.37 2.55 12.26L5.75 10.15L4.18 8.79L1.45 10.59C.989 10.89 .861 11.5 1.16 12C1.36 12.27 1.68 12.43 2 12.43M1.16 21.55C1.36 21.84 1.68 22 2 22C2.19 22 2.38 21.95 2.55 21.84L6.66 19.13L7 17.76L7.31 16.31L1.45 20.16C.989 20.47 .861 21.09 1.16 21.55M1.45 15.38C.989 15.68 .861 16.3 1.16 16.76C1.36 17.06 1.68 17.21 2 17.21C2.19 17.21 2.38 17.16 2.55 17.05L7.97 13.5L8.24 12.31L7.32 11.5L1.45 15.38Z";
var mdiStarShootingOutline = "M23 7.5L16.53 6.96L14 1L11.47 6.96L5 7.5L9.9 11.77L8.44 18.1L14 14.74L19.56 18.1L18.09 11.77L23 7.5M16.14 12.23L16.54 13.94L15.03 13.03L14 12.41L12.97 13.03L11.46 13.94L11.85 12.23L12.13 11.05L11.22 10.26L9.88 9.1L11.64 8.95L12.84 8.85L13.31 7.74L14 6.12L14.69 7.74L15.16 8.85L16.36 8.95L18.11 9.1L16.78 10.26L15.86 11.05L16.14 12.23M1.16 12C.861 11.5 .989 10.89 1.45 10.59L4.18 8.79L5.75 10.15L2.55 12.26C2.38 12.37 2.19 12.43 2 12.43C1.68 12.43 1.36 12.27 1.16 12M1.45 20.16L7.31 16.31L7 17.76L6.66 19.13L2.55 21.84C2.38 21.95 2.19 22 2 22C1.68 22 1.36 21.84 1.16 21.55C.861 21.09 .989 20.47 1.45 20.16M7.32 11.5L8.24 12.31L7.97 13.5L2.55 17.05C2.38 17.16 2.19 17.21 2 17.21C1.68 17.21 1.36 17.06 1.16 16.76C.861 16.3 .989 15.68 1.45 15.38L7.32 11.5Z";
var mdiStarThreePoints = "M12,2.6L9,12.4L2,19.9L12,17.6L22,20L15,12.5L12,2.6Z";
var mdiStarThreePointsOutline = "M12,9.5L13.2,13.5L16,16.5L12,15.6L7.9,16.5L10.7,13.5L12,9.5M12,2.6L9,12.4L2,19.9L12,17.6L22,20L15,12.5L12,2.6Z";
var mdiStateMachine = "M6.27 17.05C6.72 17.58 7 18.25 7 19C7 20.66 5.66 22 4 22S1 20.66 1 19 2.34 16 4 16C4.18 16 4.36 16 4.53 16.05L7.6 10.69L5.86 9.7L9.95 8.58L11.07 12.67L9.33 11.68L6.27 17.05M20 16C18.7 16 17.6 16.84 17.18 18H11V16L8 19L11 22V20H17.18C17.6 21.16 18.7 22 20 22C21.66 22 23 20.66 23 19S21.66 16 20 16M12 8C12.18 8 12.36 8 12.53 7.95L15.6 13.31L13.86 14.3L17.95 15.42L19.07 11.33L17.33 12.32L14.27 6.95C14.72 6.42 15 5.75 15 5C15 3.34 13.66 2 12 2S9 3.34 9 5 10.34 8 12 8Z";
var mdiSteam = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C7.4,22 3.55,18.92 2.36,14.73L6.19,16.31C6.45,17.6 7.6,18.58 8.97,18.58C10.53,18.58 11.8,17.31 11.8,15.75V15.62L15.2,13.19H15.28C17.36,13.19 19.05,11.5 19.05,9.42C19.05,7.34 17.36,5.65 15.28,5.65C13.2,5.65 11.5,7.34 11.5,9.42V9.47L9.13,12.93L8.97,12.92C8.38,12.92 7.83,13.1 7.38,13.41L2,11.2C2.43,6.05 6.73,2 12,2M8.28,17.17C9.08,17.5 10,17.13 10.33,16.33C10.66,15.53 10.28,14.62 9.5,14.29L8.22,13.76C8.71,13.58 9.26,13.57 9.78,13.79C10.31,14 10.72,14.41 10.93,14.94C11.15,15.46 11.15,16.04 10.93,16.56C10.5,17.64 9.23,18.16 8.15,17.71C7.65,17.5 7.27,17.12 7.06,16.67L8.28,17.17M17.8,9.42C17.8,10.81 16.67,11.94 15.28,11.94C13.9,11.94 12.77,10.81 12.77,9.42A2.5,2.5 0 0,1 15.28,6.91C16.67,6.91 17.8,8.04 17.8,9.42M13.4,9.42C13.4,10.46 14.24,11.31 15.29,11.31C16.33,11.31 17.17,10.46 17.17,9.42C17.17,8.38 16.33,7.53 15.29,7.53C14.24,7.53 13.4,8.38 13.4,9.42Z";
var mdiSteering = "M13,19.92C14.8,19.7 16.35,18.95 17.65,17.65C18.95,16.35 19.7,14.8 19.92,13H16.92C16.7,14 16.24,14.84 15.54,15.54C14.84,16.24 14,16.7 13,16.92V19.92M10,8H14L17,11H19.92C19.67,9.05 18.79,7.38 17.27,6C15.76,4.66 14,4 12,4C10,4 8.24,4.66 6.73,6C5.21,7.38 4.33,9.05 4.08,11H7L10,8M11,19.92V16.92C10,16.7 9.16,16.24 8.46,15.54C7.76,14.84 7.3,14 7.08,13H4.08C4.3,14.77 5.05,16.3 6.35,17.6C7.65,18.9 9.2,19.67 11,19.92M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.75 21,17.1 19.05,19.05C17.1,21 14.75,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z";
var mdiSteeringOff = "M2,5.27L3.28,4L20,20.72L18.73,22L17.25,20.5C15.7,21.5 13.95,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,10.05 2.5,8.3 3.5,6.75L2,5.27M13,19.92C14,19.8 14.93,19.5 15.78,19.05L13.5,16.78C13.34,16.84 13.16,16.88 13,16.92V19.92M4.08,11H7L7.37,10.63L4.96,8.23C4.5,9.08 4.21,10 4.08,11M19.92,13H16.92C16.8,13.54 16.6,14.05 16.33,14.5L9.91,8.09L10,8H14L17,11H19.92C19.67,9.05 18.79,7.38 17.27,6C15.76,4.66 14,4 12,4C10.26,4 8.71,4.5 7.34,5.5L5.91,4.09C7.66,2.71 9.69,2 12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.31 21.29,16.34 19.91,18.09L18.5,16.67C19.28,15.59 19.76,14.36 19.92,13M11,19.92V16.92C10,16.7 9.16,16.24 8.46,15.54C7.76,14.84 7.3,14 7.08,13H4.08C4.3,14.77 5.05,16.3 6.35,17.6C7.65,18.9 9.2,19.67 11,19.92Z";
var mdiStepBackward = "M19,5V19H16V5M14,5V19L3,12";
var mdiStepBackward2 = "M17,5H14V19H17V5M12,5L1,12L12,19V5M22,5H19V19H22V5Z";
var mdiStepForward = "M5,5V19H8V5M10,5V19L21,12";
var mdiStepForward2 = "M7,5H10V19H7V5M12,5L23,12L12,19V5M2,5H5V19H2V5Z";
var mdiStethoscope = "M19,8C19.56,8 20,8.43 20,9A1,1 0 0,1 19,10C18.43,10 18,9.55 18,9C18,8.43 18.43,8 19,8M2,2V11C2,13.96 4.19,16.5 7.14,16.91C7.76,19.92 10.42,22 13.5,22A6.5,6.5 0 0,0 20,15.5V11.81C21.16,11.39 22,10.29 22,9A3,3 0 0,0 19,6A3,3 0 0,0 16,9C16,10.29 16.84,11.4 18,11.81V15.41C18,17.91 16,19.91 13.5,19.91C11.5,19.91 9.82,18.7 9.22,16.9C12,16.3 14,13.8 14,11V2H10V5H12V11A4,4 0 0,1 8,15A4,4 0 0,1 4,11V5H6V2H2Z";
var mdiSticker = "M18.5 2H5.5C3.6 2 2 3.6 2 5.5V18.5C2 20.4 3.6 22 5.5 22H16L22 16V5.5C22 3.6 20.4 2 18.5 2M15 20V18.5C15 16.6 16.6 15 18.5 15H20L15 20Z";
var mdiStickerAlert = "M18.5 2H5.5C3.6 2 2 3.6 2 5.5V18.5C2 20.4 3.6 22 5.5 22H16L22 16V5.5C22 3.6 20.4 2 18.5 2M13 17H11V15H13V16M13 13H11V7H13V12M15 20V18.5C15 16.6 16.6 15 18.5 15H20L15 20Z";
var mdiStickerAlertOutline = "M11 15H13V17H11V15M11 13H13V7H11V13M22 5.5V16L16 22H5.5C3.6 22 2 20.4 2 18.5V5.5C2 3.6 3.6 2 5.5 2H18.5C20.4 2 22 3.6 22 5.5M20 5.8C20 4.8 19.2 4 18.2 4H5.8C4.8 4 4 4.8 4 5.8V18.3C4 19.3 4.8 20.1 5.8 20.1H15V18.6C15 16.7 16.6 15.1 18.5 15.1H20V5.8Z";
var mdiStickerCheck = "M18.5 2H5.5C3.6 2 2 3.6 2 5.5V18.5C2 20.4 3.6 22 5.5 22H16L22 16V5.5C22 3.6 20.4 2 18.5 2M7 12.5L8.3 11.1L10.4 13.2L15.6 8L17 9.4L10.5 16L7 12.5M15 20V18.5C15 16.6 16.6 15 18.5 15H20L15 20Z";
var mdiStickerCheckOutline = "M18.5 2H5.5C3.6 2 2 3.6 2 5.5V18.5C2 20.4 3.6 22 5.5 22H16L22 16V5.5C22 3.6 20.4 2 18.5 2M20 15H18.5C16.6 15 15 16.6 15 18.5V20H5.8C4.8 20 4 19.2 4 18.2V5.8C4 4.8 4.8 4 5.8 4H18.3C19.3 4 20.1 4.8 20.1 5.8V15M15.2 8.2L16.7 9.7L10.7 15.7L7.2 12.2L8.7 10.7L10.7 12.7L15.2 8.2Z";
var mdiStickerCircleOutline = "M12.12,18.46L18.3,12.28C16.94,12.59 15.31,13.2 14.07,14.46C13.04,15.5 12.39,16.83 12.12,18.46M20.75,10H21.05C21.44,10 21.79,10.27 21.93,10.64C22.07,11 22,11.43 21.7,11.71L11.7,21.71C11.5,21.9 11.26,22 11,22L10.64,21.93C10.27,21.79 10,21.44 10,21.05C9.84,17.66 10.73,14.96 12.66,13.03C15.5,10.2 19.62,10 20.75,10M12,2C16.5,2 20.34,5 21.58,9.11L20,9H19.42C18.24,6.07 15.36,4 12,4A8,8 0 0,0 4,12C4,15.36 6.07,18.24 9,19.42C8.97,20.13 9,20.85 9.11,21.57C5,20.33 2,16.5 2,12C2,6.47 6.5,2 12,2Z";
var mdiStickerEmoji = "M5.5,2C3.56,2 2,3.56 2,5.5V18.5C2,20.44 3.56,22 5.5,22H16L22,16V5.5C22,3.56 20.44,2 18.5,2H5.5M5.75,4H18.25A1.75,1.75 0 0,1 20,5.75V15H18.5C16.56,15 15,16.56 15,18.5V20H5.75A1.75,1.75 0 0,1 4,18.25V5.75A1.75,1.75 0 0,1 5.75,4M14.44,6.77C14.28,6.77 14.12,6.79 13.97,6.83C13.03,7.09 12.5,8.05 12.74,9C12.79,9.15 12.86,9.3 12.95,9.44L16.18,8.56C16.18,8.39 16.16,8.22 16.12,8.05C15.91,7.3 15.22,6.77 14.44,6.77M8.17,8.5C8,8.5 7.85,8.5 7.7,8.55C6.77,8.81 6.22,9.77 6.47,10.7C6.5,10.86 6.59,11 6.68,11.16L9.91,10.28C9.91,10.11 9.89,9.94 9.85,9.78C9.64,9 8.95,8.5 8.17,8.5M16.72,11.26L7.59,13.77C8.91,15.3 11,15.94 12.95,15.41C14.9,14.87 16.36,13.25 16.72,11.26Z";
var mdiStickerMinus = "M18.5 2H5.5C3.6 2 2 3.6 2 5.5V18.5C2 20.4 3.6 22 5.5 22H16L22 16V5.5C22 3.6 20.4 2 18.5 2M8 11H16V13H8V11M15 20V18.5C15 16.6 16.6 15 18.5 15H20L15 20Z";
var mdiStickerMinusOutline = "M8 11H16V13H8V11M22 5.5V16L16 22H5.5C3.6 22 2 20.4 2 18.5V5.5C2 3.6 3.6 2 5.5 2H18.5C20.4 2 22 3.6 22 5.5M20 5.8C20 4.8 19.2 4 18.2 4H5.8C4.8 4 4 4.8 4 5.8V18.3C4 19.3 4.8 20.1 5.8 20.1H15V18.6C15 16.7 16.6 15.1 18.5 15.1H20V5.8Z";
var mdiStickerOutline = "M5.5 2C3.6 2 2 3.6 2 5.5V18.5C2 20.4 3.6 22 5.5 22H16L22 16V5.5C22 3.6 20.4 2 18.5 2H5.5M5.8 4H18.3C19.3 4 20.1 4.8 20.1 5.8V15H18.6C16.7 15 15.1 16.6 15.1 18.5V20H5.8C4.8 20 4 19.2 4 18.2V5.8C4 4.8 4.8 4 5.8 4";
var mdiStickerPlus = "M18.5 2H5.5C3.6 2 2 3.6 2 5.5V18.5C2 20.4 3.6 22 5.5 22H16L22 16V5.5C22 3.6 20.4 2 18.5 2M13 16H11V13H8V11H11V8H13V11H16V13H13V16M15 20V18.5C15 16.6 16.6 15 18.5 15H20L15 20Z";
var mdiStickerPlusOutline = "M13 11H16V13H13V16H11V13H8V11H11V8H13V11M22 5.5V16L16 22H5.5C3.6 22 2 20.4 2 18.5V5.5C2 3.6 3.6 2 5.5 2H18.5C20.4 2 22 3.6 22 5.5M20 5.8C20 4.8 19.2 4 18.2 4H5.8C4.8 4 4 4.8 4 5.8V18.3C4 19.3 4.8 20.1 5.8 20.1H15V18.6C15 16.7 16.6 15.1 18.5 15.1H20V5.8Z";
var mdiStickerRemove = "M18.5 2H5.5C3.6 2 2 3.6 2 5.5V18.5C2 20.4 3.6 22 5.5 22H16L22 16V5.5C22 3.6 20.4 2 18.5 2M12 13.4L9.9 15.5L8.5 14.1L10.6 12L8.5 9.9L9.9 8.5L12 10.6L14.1 8.5L15.5 9.9L13.4 12L15.5 14.1L14.1 15.5L12 13.4M15 20V18.5C15 16.6 16.6 15 18.5 15H20L15 20Z";
var mdiStickerRemoveOutline = "M16 9.4L13.4 12L16 14.6L14.6 16L12 13.4L9.4 16L8 14.6L10.6 12L8 9.4L9.4 8L12 10.6L14.6 8L16 9.4M22 5.5V16L16 22H5.5C3.6 22 2 20.4 2 18.5V5.5C2 3.6 3.6 2 5.5 2H18.5C20.4 2 22 3.6 22 5.5M20 5.8C20 4.8 19.2 4 18.2 4H5.8C4.8 4 4 4.8 4 5.8V18.3C4 19.3 4.8 20.1 5.8 20.1H15V18.6C15 16.7 16.6 15.1 18.5 15.1H20V5.8Z";
var mdiStickerText = "M18.5 2H5.5C3.6 2 2 3.6 2 5.5V18.5C2 20.4 3.6 22 5.5 22H16L22 16V5.5C22 3.6 20.4 2 18.5 2M6 7H18V9H6V7M6 11H18V13H6V11M13 17H6V15H13V17M15 20V18.5C15 16.6 16.6 15 18.5 15H20L15 20Z";
var mdiStickerTextOutline = "M18.5 2H5.5C3.6 2 2 3.6 2 5.5V18.5C2 20.4 3.6 22 5.5 22H16L22 16V5.5C22 3.6 20.4 2 18.5 2M20.1 15H18.6C16.7 15 15.1 16.6 15.1 18.5V20H5.8C4.8 20 4 19.2 4 18.2V5.8C4 4.8 4.8 4 5.8 4H18.3C19.3 4 20.1 4.8 20.1 5.8V15M7 7H17V9H7V7M7 11H17V13H7V11M7 15H13V17H7V15Z";
var mdiStocking = "M17,2A2,2 0 0,1 19,4V7A2,2 0 0,1 17,9V17C17,17.85 16.5,18.57 15.74,18.86L9.5,21.77C8.5,22.24 7.29,21.81 6.83,20.81L6,19C5.5,18 5.95,16.8 6.95,16.34L10,14.91V9A2,2 0 0,1 8,7V4A2,2 0 0,1 10,2H17M10,4V7H17V4H10Z";
var mdiStomach = "M4 18C4.67 19.85 6.07 22 12 22C14.36 22 17.07 21.93 19 20C20 19 22 17 22 11S20 4 18 4C16.62 4 15 4 14 6V6.03A1.82 1.82 0 0 1 12.13 6.95C11 6.81 11 6.37 11 6V2H9V6A2.92 2.92 0 0 0 12 9C13 9 13 10.78 13 12C13 13.89 12.5 15.26 11 16C8.69 17.15 6.39 17 5.61 15.47A1.5 1.5 0 0 0 3.14 14.87A3.67 3.67 0 0 0 2 18V22H4Z";
var mdiStool = "M20 6C20 3.79 18.21 2 16 2H8C5.78 2 4 3.79 4 6V8H7L4 22H6L7.5 15H11V22H13V15H16.5L18 22H20L17 8H20V6M7.93 13L9 8H11V13H7.93M16.07 13H13V8H15L16.07 13Z";
var mdiStoolOutline = "M20 6C20 3.79 18.21 2 16 2H8C5.78 2 4 3.79 4 6V8H7L4 22H6L7.5 15H11V22H13V15H16.5L18 22H20L17 8H20V6M7.93 13L9 8H11V13H7.93M16.07 13H13V8H15L16.07 13M6 6C6 4.9 6.89 4 8 4H16C17.1 4 18 4.9 18 6H6Z";
var mdiStop = "M18,18H6V6H18V18Z";
var mdiStopCircle = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M9,9H15V15H9";
var mdiStopCircleOutline = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4M9,9V15H15V9";
var mdiStorageTank = "M17 6H16V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V6H7C3.69 6 1 8.69 1 12S3.69 18 7 18V21H9V18H15V21H17V18C20.31 18 23 15.31 23 12S20.31 6 17 6M10 5H14V6H10V5Z";
var mdiStorageTankOutline = "M17 6H16V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V6H7C3.69 6 1 8.69 1 12S3.69 18 7 18V21H9V18H15V21H17V18C20.31 18 23 15.31 23 12S20.31 6 17 6M10 5H14V6H10V5M17 16H7C4.79 16 3 14.21 3 12S4.79 8 7 8H17C19.21 8 21 9.79 21 12S19.21 16 17 16Z";
var mdiStore = "M12,18H6V14H12M21,14V12L20,7H4L3,12V14H4V20H14V14H18V20H20V14M20,4H4V6H20V4Z";
var mdiStore24Hour = "M16,12H15V10H13V7H14V9H15V7H16M11,10H9V11H11V12H8V9H10V8H8V7H11M19,7V4H5V7H2V20H10V16H14V20H22V7H19Z";
var mdiStoreAlert = "M2 7L1 12V14H2V20H12V14H16V20H18V14H19V12L18 7H2M10 18H4V14H10V18M18 6H2V4H18V6M23 7V13H21V7H23M21 15H23V17H21V15Z";
var mdiStoreAlertOutline = "M2 7L1 12V14H2V20H12V14H16V20H18V14H19V12L18 7H2M10 18H4V14H10V18M3.04 12L3.64 9H16.36L16.96 12H3.04M18 6H2V4H18V6M23 7V13H21V7H23M21 15H23V17H21V15Z";
var mdiStoreCheck = "M20 6H4V4H20V6M15.69 14H14V15.69C13.37 16.64 13 17.77 13 19C13 19.34 13.04 19.67 13.09 20H4V14H3V12L4 7H20L21 12V13.35C20.37 13.13 19.7 13 19 13C17.77 13 16.64 13.37 15.69 14M12 14H6V18H12V14M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiStoreCheckOutline = "M19 13C19.7 13 20.37 13.13 21 13.35V12L20 7H4L3 12V14H4V20H13.09C13.04 19.67 13 19.34 13 19C13 17.77 13.37 16.64 14 15.69V14H15.69C16.64 13.37 17.77 13 19 13M12 18H6V14H12V18M5.04 12L5.64 9H18.36L18.96 12H5.04M20 6H4V4H20V6M22.5 17.25L17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25";
var mdiStoreClock = "M18 4H2V2H18V4M17.5 13H16V18L19.61 20.16L20.36 18.94L17.5 17.25V13M24 17C24 20.87 20.87 24 17 24C13.47 24 10.57 21.39 10.08 18H2V12H1V10L2 5H18L19 10V10.29C21.89 11.16 24 13.83 24 17M4 16H10V12H4V16M22 17C22 14.24 19.76 12 17 12S12 14.24 12 17 14.24 22 17 22 22 19.76 22 17Z";
var mdiStoreClockOutline = "M18 4H2V2H18V4M17.5 13H16V18L19.61 20.16L20.36 18.94L17.5 17.25V13M24 17C24 20.87 20.87 24 17 24C13.47 24 10.57 21.39 10.08 18H2V12H1V10L2 5H18L19 10V10.29C21.89 11.16 24 13.83 24 17M3.04 10H16.96L16.36 7H3.64L3.04 10M4 16H10V12H4V16M22 17C22 14.24 19.76 12 17 12S12 14.24 12 17 14.24 22 17 22 22 19.76 22 17Z";
var mdiStoreCog = "M20 6H4V4H20V6M19 12C17.09 12 15.37 12.76 14.11 14H14V14.11C12.76 15.37 12 17.09 12 19C12 19.34 12.03 19.67 12.08 20H4V14H3V12L4 7H20L21 12V12.3C20.37 12.11 19.7 12 19 12M12 14H6V18H12V14M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiStoreCogOutline = "M20 6H4V4H20V6M19 12C17.09 12 15.37 12.76 14.11 14H14V14.11C12.76 15.37 12 17.09 12 19C12 19.34 12.03 19.67 12.08 20H4V14H3V12L4 7H20L21 12V12.3C20.37 12.11 19.7 12 19 12M12 14H6V18H12V14M18.96 12L18.36 9H5.64L5.04 12H18.96M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiStoreEdit = "M20 6H4V4H20V6M14 16.13L11 19.13V20H4V14H3V12L4 7H20L20.61 10.07C20.16 10.17 19.73 10.4 19.39 10.74L16.13 14H14V16.13M12 14H6V18H12V14M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96Z";
var mdiStoreEditOutline = "M20 6H4V4H20V6M14 16.13L11 19.13V20H4V14H3V12L4 7H20L20.61 10.07C20.16 10.17 19.73 10.4 19.39 10.74L18.82 11.31L18.36 9H5.64L5.04 12H18.13L16.13 14H14V16.13M12 14H6V18H12V14M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96Z";
var mdiStoreMarker = "M20 6H4V4H20V6M13 15.5C13 16.64 13.43 17.86 14 19V20H4V14H3V12L4 7H20L20.7 10.5C20 10.18 19.28 10 18.5 10C15.5 10 13 12.5 13 15.5M12 14H6V18H12V14M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiStoreMarkerOutline = "M20 6H4V4H20V6M14.3 12C13.5 12.96 13 14.18 13 15.5C13 16.64 13.43 17.86 14 19V20H4V14H3V12L4 7H20L20.7 10.5C20.04 10.18 19.32 10 18.56 10L18.36 9H5.64L5.04 12H14.3M12 14H6V18H12V14M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiStoreMinus = "M4 4V6H20V4M4 7L3 12V14H4V20H13C12.95 19.66 12.92 19.31 12.92 18.95C12.92 17.73 13.3 16.53 14 15.53V14H15.54C16.54 13.33 17.71 12.96 18.91 12.96C19.62 12.96 20.33 13.09 21 13.34V12L20 7M6 14H12V18H6M15 18V20H23V18";
var mdiStoreMinusOutline = "M20 6H4V4H20V6M15.69 14H14V15.69C13.37 16.64 13 17.77 13 19C13 19.34 13.04 19.67 13.09 20H4V14H3V12L4 7H20L21 12V13.35C20.37 13.13 19.7 13 19 13C17.77 13 16.64 13.37 15.69 14M12 14H6V18H12V14M18.96 12L18.36 9H5.64L5.04 12H18.96M15 18V20H23V18H15Z";
var mdiStoreOff = "M9.2 6L7.2 4H20V6H9.2M20 16.8V14H21V12L20 7H10.2L17.2 14H18V14.8L20 16.8M22.11 21.46L20.84 22.73L14 15.89V20H4V14H3V12L4 7H5.11L1.11 3L2.39 1.73L22.11 21.46M12 14H6V18H12V14Z";
var mdiStoreOffOutline = "M2.39 1.73L1.11 3L5.11 7H4L3 12V14H4V20H14V15.89L20.84 22.73L22.11 21.46L2.39 1.73M5.64 9H7.11L10.11 12H5.04L5.64 9M12 18H6V14H12V18M18 14.8V14H17.2L15.2 12H18.96L18.36 9H12.2L10.2 7H20L21 12V14H20V16.8L18 14.8M9.2 6L7.2 4H20V6H9.2Z";
var mdiStoreOutline = "M18.36 9L18.96 12H5.04L5.64 9H18.36M20 4H4V6H20V4M20 7H4L3 12V14H4V20H14V14H18V20H20V14H21V12L20 7M6 18V14H12V18H6Z";
var mdiStorePlus = "M4 4V6H20V4M4 7L3 12V14H4V20H13C12.95 19.66 12.92 19.31 12.92 18.95C12.92 17.73 13.3 16.53 14 15.53V14H15.54C16.54 13.33 17.71 12.96 18.91 12.96C19.62 12.96 20.33 13.09 21 13.34V12L20 7M6 14H12V18H6M18 15V18H15V20H18V23H20V20H23V18H20V15";
var mdiStorePlusOutline = "M20 6H4V4H20V6M15.69 14H14V15.69C13.37 16.64 13 17.77 13 19C13 19.34 13.04 19.67 13.09 20H4V14H3V12L4 7H20L21 12V13.35C20.37 13.13 19.7 13 19 13C17.77 13 16.64 13.37 15.69 14M12 14H6V18H12V14M18.96 12L18.36 9H5.64L5.04 12H18.96M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiStoreRemove = "M4 4H20V6H4V4M15.46 16.88L16.88 15.46L19 17.59L21.12 15.47L22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.46 21.12L17.59 19L15.47 16.88M4 7H20L21 12V13.34C20.33 13.09 19.62 12.96 18.91 12.96C17.71 12.96 16.54 13.33 15.54 14H14V15.53C13.3 16.53 12.92 17.73 12.92 18.95L13 20H4V14H3V12L4 7M6 14V18H12V14H6Z";
var mdiStoreRemoveOutline = "M20 6H4V4H20V6M15.69 14H14V15.69C13.37 16.64 13 17.77 13 19C13 19.34 13.04 19.67 13.09 20H4V14H3V12L4 7H20L21 12V13.35C20.37 13.13 19.7 13 19 13C17.77 13 16.64 13.37 15.69 14M12 14H6V18H12V14M18.96 12L18.36 9H5.64L5.04 12H18.96M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiStoreSearch = "M11.9 10.9C10.64 12.17 10 13.84 10 15.5V12H4V16H10V15.5C10 16.35 10.17 17.2 10.5 18H2V12H1V10L2 5H18L18.89 9.46C16.56 8.53 13.79 9 11.9 10.9M18 2H2V4H18V2M23.39 21L22 22.39L18.88 19.32C18.19 19.75 17.37 20 16.5 20C14 20 12 18 12 15.5S14 11 16.5 11 21 13 21 15.5C21 16.38 20.75 17.21 20.31 17.9L23.39 21M19 15.5C19 14.12 17.88 13 16.5 13S14 14.12 14 15.5 15.12 18 16.5 18 19 16.88 19 15.5Z";
var mdiStoreSearchOutline = "M18 4H2V2H18V4M13.04 10H3.04L3.64 7H16.36L16.76 9C17.5 9.04 18.21 9.19 18.89 9.46L18 5H2L1 10V12H2V18H10.5C10.17 17.2 10 16.35 10 15.5V16H4V12H10V15.5C10 13.84 10.64 12.17 11.9 10.9C12.26 10.55 12.64 10.25 13.04 10M23.39 21L22 22.39L18.88 19.32C18.19 19.75 17.37 20 16.5 20C14 20 12 18 12 15.5S14 11 16.5 11 21 13 21 15.5C21 16.38 20.75 17.21 20.31 17.9L23.39 21M19 15.5C19 14.12 17.88 13 16.5 13S14 14.12 14 15.5 15.12 18 16.5 18 19 16.88 19 15.5Z";
var mdiStoreSettings = "M20 6H4V4H20V6M21 12V14H20V20H18V14H14V20H4V14H3V12L4 7H20L21 12M12 14H6V18H12V14M7 24H9V22H7V24M11 24H13V22H11V24M15 24H17V22H15V24Z";
var mdiStoreSettingsOutline = "M20 6H4V4H20V6M21 12V14H20V20H18V14H14V20H4V14H3V12L4 7H20L21 12M12 14H6V18H12V14M18.96 12L18.36 9H5.64L5.04 12H18.96M7 24H9V22H7V24M11 24H13V22H11V24M15 24H17V22H15V24Z";
var mdiStorefront = "M5.06 3C4.63 3 4.22 3.14 3.84 3.42C3.46 3.7 3.24 4.06 3.14 4.5L2.11 8.91C1.86 10 2.06 10.92 2.69 11.73C2.81 11.85 2.93 11.97 3.04 12.07C3.63 12.64 4.28 13 5.22 13C6.16 13 6.91 12.59 7.47 12.05C8.1 12.67 8.86 13 9.8 13C10.64 13 11.44 12.63 12 12.07C12.68 12.7 13.45 13 14.3 13C15.17 13 15.91 12.67 16.54 12.05C17.11 12.62 17.86 13 18.81 13C19.76 13 20.43 12.65 21 12.06C21.09 11.97 21.18 11.87 21.28 11.77C21.94 10.95 22.14 10 21.89 8.91L20.86 4.5C20.73 4.06 20.5 3.7 20.13 3.42C19.77 3.14 19.38 3 18.94 3M18.89 4.97L19.97 9.38C20.06 9.81 19.97 10.2 19.69 10.55C19.44 10.86 19.13 11 18.75 11C18.44 11 18.17 10.9 17.95 10.66C17.73 10.43 17.61 10.16 17.58 9.84L16.97 5M5.06 5H7.03L6.42 9.84C6.3 10.63 5.91 11 5.25 11C4.84 11 4.53 10.86 4.31 10.55C4.03 10.2 3.94 9.81 4.03 9.38M9.05 5H11V9.7C11 10.05 10.89 10.35 10.64 10.62C10.39 10.88 10.08 11 9.7 11C9.36 11 9.07 10.88 8.84 10.59C8.61 10.3 8.5 10 8.5 9.66V9.5M13 5H14.95L15.5 9.5C15.58 9.92 15.5 10.27 15.21 10.57C14.95 10.87 14.61 11 14.2 11C13.89 11 13.61 10.88 13.36 10.62C13.11 10.35 13 10.05 13 9.7M3 14.03V19C3 20.11 3.89 21 5 21C9.67 21 14.33 21 19 21C20.1 21 21 20.11 21 19V14.05C20.45 14.63 19.75 14.96 19 15C18 15.03 17.25 14.74 16.54 14.05C15.94 14.65 15.14 15 14.3 15C13.4 15 12.6 14.64 12 14.07C11.43 14.64 10.65 15 9.78 15C8.87 15 8.07 14.65 7.47 14.05C6.89 14.64 6.1 15 5.23 15C4.33 15 3.66 14.65 3 14.03Z";
var mdiStorefrontCheck = "M5.06 3C4.63 3 4.22 3.14 3.84 3.42S3.24 4.06 3.14 4.5L2.11 8.91C1.86 10 2.06 10.92 2.69 11.73C2.81 11.85 2.93 11.97 3.04 12.07C3.63 12.64 4.28 13 5.22 13S6.91 12.59 7.47 12.05C8.1 12.67 8.86 13 9.8 13C10.64 13 11.44 12.63 12 12.07C12.68 12.7 13.45 13 14.3 13C15.17 13 15.91 12.67 16.54 12.05C17.11 12.62 17.86 13 18.81 13S20.43 12.65 21 12.06L21.13 11.92C21.18 11.87 21.23 11.82 21.28 11.77C21.94 10.95 22.14 10 21.89 8.91L20.86 4.5C20.73 4.06 20.5 3.7 20.13 3.42C19.77 3.14 19.38 3 18.94 3M18.89 4.97L19.97 9.38C20.06 9.81 19.97 10.2 19.69 10.55C19.44 10.86 19.13 11 18.75 11C18.44 11 18.17 10.9 17.95 10.66C17.73 10.43 17.61 10.16 17.58 9.84L16.97 5M5.06 5H7.03L6.42 9.84C6.3 10.63 5.91 11 5.25 11C4.84 11 4.53 10.86 4.31 10.55C4.03 10.2 3.94 9.81 4.03 9.38M9.05 5H11V9.7C11 10.05 10.89 10.35 10.64 10.62C10.39 10.88 10.08 11 9.7 11C9.36 11 9.07 10.88 8.84 10.59S8.5 10 8.5 9.66V9.5M13 5H14.95L15.5 9.5C15.58 9.92 15.5 10.27 15.21 10.57C14.95 10.87 14.61 11 14.2 11C13.89 11 13.61 10.88 13.36 10.62C13.11 10.35 13 10.05 13 9.7M12.97 14.72C12.61 14.56 12.28 14.34 12 14.07C11.43 14.64 10.65 15 9.78 15C8.87 15 8.07 14.65 7.47 14.05C6.89 14.64 6.1 15 5.23 15C4.33 15 3.66 14.65 3 14.03V19C3 20.11 3.89 21 5 21H12.8C12.29 20.12 12 19.09 12 18C12 16.79 12.36 15.66 12.97 14.72M17 21L14.25 18L15.41 16.84L17 18.43L20.59 14.84L21.75 16.25Z";
var mdiStorefrontCheckOutline = "M5.06 3C4.63 3 4.22 3.14 3.84 3.42S3.24 4.06 3.14 4.5L2.11 8.91C1.86 10 2.06 10.92 2.69 11.73C2.8 11.84 2.9 11.94 3 12.03V19C3 19.5 3.2 20 3.61 20.39S4.5 21 5 21H12.8C12.45 20.39 12.2 19.72 12.08 19H5V13C5.07 13 5.15 13 5.22 13C6.16 13 6.91 12.59 7.47 12.05C8.1 12.67 8.86 13 9.8 13C10.64 13 11.44 12.63 12 12.07C12.68 12.7 13.45 13 14.3 13C15.17 13 15.91 12.67 16.54 12.05C17.11 12.62 17.86 13 18.81 13S20.43 12.65 21 12.06L21.13 11.92C21.18 11.87 21.23 11.82 21.28 11.77C21.94 10.95 22.14 10 21.89 8.91L20.86 4.5C20.73 4.06 20.5 3.7 20.13 3.42C19.77 3.14 19.38 3 18.94 3M18.89 4.97L19.97 9.38C20.06 9.81 19.97 10.2 19.69 10.55C19.44 10.86 19.13 11 18.75 11C18.44 11 18.17 10.9 17.95 10.66C17.73 10.43 17.61 10.16 17.58 9.84L16.97 5M5.06 5H7.03L6.42 9.84C6.3 10.63 5.91 11 5.25 11C4.84 11 4.53 10.86 4.31 10.55C4.03 10.2 3.94 9.81 4.03 9.38M9.05 5H11V9.7C11 10.05 10.89 10.35 10.64 10.62C10.39 10.88 10.08 11 9.7 11C9.36 11 9.07 10.88 8.84 10.59S8.5 10 8.5 9.66V9.5M13 5H14.95L15.5 9.5C15.58 9.92 15.5 10.27 15.21 10.57C14.95 10.87 14.61 11 14.2 11C13.89 11 13.61 10.88 13.36 10.62C13.11 10.35 13 10.05 13 9.7M17 21L14.25 18L15.41 16.84L17 18.43L20.59 14.84L21.75 16.25Z";
var mdiStorefrontEdit = "M3.84 3.42C4.22 3.14 4.63 3 5.06 3H18.94C19.38 3 19.77 3.14 20.13 3.42C20.5 3.7 20.73 4.06 20.86 4.5L21.89 8.91C22 9.41 22 9.87 21.95 10.31C21.23 10.03 20.4 10.1 19.73 10.5C20 10.17 20.06 9.79 19.97 9.38L18.89 4.97L16.97 5L17.58 9.84C17.61 10.16 17.73 10.43 17.95 10.66C18.17 10.9 18.44 11 18.75 11C18.91 11 19.06 10.97 19.2 10.92L19.07 11.06L19.06 11.05L17.42 12.69C17.09 12.53 16.8 12.31 16.54 12.05C15.91 12.67 15.17 13 14.3 13C13.45 13 12.68 12.7 12 12.07C11.44 12.63 10.64 13 9.8 13C8.86 13 8.1 12.67 7.47 12.05C6.91 12.59 6.16 13 5.22 13S3.63 12.64 3.04 12.07C2.93 11.97 2.81 11.85 2.69 11.73C2.06 10.92 1.86 10 2.11 8.91L3.14 4.5C3.24 4.06 3.46 3.7 3.84 3.42M7.03 5H5.06L4.03 9.38C3.94 9.81 4.03 10.2 4.31 10.55C4.53 10.86 4.84 11 5.25 11C5.91 11 6.3 10.63 6.42 9.84M11 5H9.05L8.5 9.5V9.66C8.5 10 8.61 10.3 8.84 10.59S9.36 11 9.7 11C10.08 11 10.39 10.88 10.64 10.62C10.89 10.35 11 10.05 11 9.7M14.95 5H13V9.7C13 10.05 13.11 10.35 13.36 10.62C13.61 10.88 13.89 11 14.2 11C14.61 11 14.95 10.87 15.21 10.57C15.5 10.27 15.58 9.92 15.5 9.5M21.11 15.93L19.06 13.88L13 19.94V22H15.06M14.3 15C14.63 15 14.96 14.95 15.27 14.84L11 19.11V21H5C3.89 21 3 20.11 3 19V14.03C3.66 14.65 4.33 15 5.23 15C6.1 15 6.89 14.64 7.47 14.05C8.07 14.65 8.87 15 9.78 15C10.65 15 11.43 14.64 12 14.07C12.6 14.64 13.4 15 14.3 15M22.7 14.35L21.7 15.35L19.65 13.3L20.65 12.3C20.72 12.23 20.81 12.18 20.9 12.16C21.08 12.11 21.28 12.16 21.42 12.3L22.7 13.58C22.91 13.79 22.91 14.14 22.7 14.35Z";
var mdiStorefrontEditOutline = "M5.06 3C4.63 3 4.22 3.14 3.84 3.42S3.24 4.06 3.14 4.5L2.11 8.91C1.86 10 2.06 10.95 2.72 11.77L3 12.05V19C3 19.5 3.2 20 3.61 20.39S4.5 21 5 21H11V19.11L11.11 19H5V13H5.25C6.16 13 6.89 12.67 7.45 12.05C8.08 12.67 8.86 13 9.8 13C10.64 13 11.38 12.67 12 12.05C12.69 12.67 13.45 13 14.3 13C15.17 13 15.92 12.67 16.55 12.05C16.8 12.33 17.09 12.54 17.41 12.7L19.06 11.05L19.07 11.06L19.2 10.92C19.06 10.97 18.91 11 18.75 11C18.44 11 18.17 10.9 17.95 10.66C17.73 10.43 17.61 10.16 17.58 9.84L16.97 5L18.89 4.97L19.97 9.38C20.06 9.79 20 10.16 19.73 10.5C20.4 10.1 21.23 10.03 21.95 10.31C22 9.87 22 9.41 21.89 8.91L20.86 4.5C20.73 4.06 20.5 3.7 20.13 3.42C19.77 3.14 19.38 3 18.94 3M5.06 5H7.03L6.42 9.84C6.3 10.63 5.91 11 5.25 11C4.84 11 4.53 10.86 4.31 10.55C4.03 10.2 3.94 9.81 4.03 9.38M9.05 5H11V9.7C11 10.05 10.89 10.35 10.64 10.62C10.39 10.88 10.08 11 9.7 11C9.36 11 9.07 10.88 8.84 10.59S8.5 10 8.5 9.66V9.5M13 5H14.95L15.5 9.5C15.58 9.92 15.5 10.27 15.21 10.57C14.95 10.87 14.61 11 14.2 11C13.89 11 13.61 10.88 13.36 10.62C13.11 10.35 13 10.05 13 9.7M15.06 22H13V19.94L19.06 13.88L21.11 15.93M20.65 12.3C20.75 12.2 20.87 12.15 21 12.14C21.15 12.14 21.31 12.19 21.42 12.3L22.7 13.58C22.91 13.79 22.91 14.14 22.7 14.35L21.7 15.35L19.65 13.3Z";
var mdiStorefrontMinus = "M3.84 3.42C4.22 3.14 4.63 3 5.06 3H18.94C19.38 3 19.77 3.14 20.13 3.42C20.5 3.7 20.73 4.06 20.86 4.5L21.89 8.91C22.14 10 21.94 10.95 21.28 11.77C21.23 11.82 21.18 11.87 21.13 11.92L21 12.06C20.43 12.65 19.76 13 18.81 13S17.11 12.62 16.54 12.05C15.91 12.67 15.17 13 14.3 13C13.45 13 12.68 12.7 12 12.07C11.44 12.63 10.64 13 9.8 13C8.86 13 8.1 12.67 7.47 12.05C6.91 12.59 6.16 13 5.22 13S3.63 12.64 3.04 12.07C2.93 11.97 2.81 11.85 2.69 11.73C2.06 10.92 1.86 10 2.11 8.91L3.14 4.5C3.24 4.06 3.46 3.7 3.84 3.42M19.97 9.38L18.89 4.97L16.97 5L17.58 9.84C17.61 10.16 17.73 10.43 17.95 10.66C18.17 10.9 18.44 11 18.75 11C19.13 11 19.44 10.86 19.69 10.55C19.97 10.2 20.06 9.81 19.97 9.38M7.03 5H5.06L4.03 9.38C3.94 9.81 4.03 10.2 4.31 10.55C4.53 10.86 4.84 11 5.25 11C5.91 11 6.3 10.63 6.42 9.84L7.03 5M11 5H9.05L8.5 9.5V9.66C8.5 10 8.61 10.3 8.84 10.59S9.36 11 9.7 11C10.08 11 10.39 10.88 10.64 10.62C10.89 10.35 11 10.05 11 9.7V5M14.95 5H13V9.7C13 10.05 13.11 10.35 13.36 10.62C13.61 10.88 13.89 11 14.2 11C14.61 11 14.95 10.87 15.21 10.57C15.5 10.27 15.58 9.92 15.5 9.5L14.95 5M22 17V19H14V17H22M12 14.07C12.28 14.34 12.61 14.56 12.97 14.72C12.36 15.66 12 16.79 12 18C12 19.09 12.29 20.12 12.8 21H5C3.89 21 3 20.11 3 19V14.03C3.66 14.65 4.33 15 5.23 15C6.1 15 6.89 14.64 7.47 14.05C8.07 14.65 8.87 15 9.78 15C10.65 15 11.43 14.64 12 14.07Z";
var mdiStorefrontMinusOutline = "M3.84 3.42C4.22 3.14 4.63 3 5.06 3H18.94C19.38 3 19.77 3.14 20.13 3.42C20.5 3.7 20.73 4.06 20.86 4.5L21.89 8.91C22.14 10 21.94 10.95 21.28 11.77C21.23 11.82 21.18 11.87 21.13 11.92L21 12.06C20.43 12.65 19.76 13 18.81 13S17.11 12.62 16.54 12.05C15.91 12.67 15.17 13 14.3 13C13.45 13 12.68 12.7 12 12.07C11.44 12.63 10.64 13 9.8 13C8.86 13 8.1 12.67 7.47 12.05C6.91 12.59 6.16 13 5.22 13C5.15 13 5.07 13 5 13V19H12.08C12.2 19.72 12.45 20.39 12.8 21H5C4.5 21 4 20.78 3.61 20.39S3 19.5 3 19V12.03C2.9 11.94 2.8 11.84 2.69 11.73C2.06 10.92 1.86 10 2.11 8.91L3.14 4.5C3.24 4.06 3.46 3.7 3.84 3.42M19.97 9.38L18.89 4.97L16.97 5L17.58 9.84C17.61 10.16 17.73 10.43 17.95 10.66C18.17 10.9 18.44 11 18.75 11C19.13 11 19.44 10.86 19.69 10.55C19.97 10.2 20.06 9.81 19.97 9.38M7.03 5H5.06L4.03 9.38C3.94 9.81 4.03 10.2 4.31 10.55C4.53 10.86 4.84 11 5.25 11C5.91 11 6.3 10.63 6.42 9.84L7.03 5M11 5H9.05L8.5 9.5V9.66C8.5 10 8.61 10.3 8.84 10.59S9.36 11 9.7 11C10.08 11 10.39 10.88 10.64 10.62C10.89 10.35 11 10.05 11 9.7V5M14.95 5H13V9.7C13 10.05 13.11 10.35 13.36 10.62C13.61 10.88 13.89 11 14.2 11C14.61 11 14.95 10.87 15.21 10.57C15.5 10.27 15.58 9.92 15.5 9.5L14.95 5M14 17V19H22V17H14Z";
var mdiStorefrontOutline = "M5.06 3C4.63 3 4.22 3.14 3.84 3.42S3.24 4.06 3.14 4.5L2.11 8.91C1.86 10 2.06 10.95 2.72 11.77L3 12.05V19C3 19.5 3.2 20 3.61 20.39S4.5 21 5 21H19C19.5 21 20 20.8 20.39 20.39S21 19.5 21 19V12.05L21.28 11.77C21.94 10.95 22.14 10 21.89 8.91L20.86 4.5C20.73 4.06 20.5 3.7 20.13 3.42C19.77 3.14 19.38 3 18.94 3H5.06M18.89 4.97L19.97 9.38C20.06 9.81 19.97 10.2 19.69 10.55C19.44 10.86 19.13 11 18.75 11C18.44 11 18.17 10.9 17.95 10.66C17.73 10.43 17.61 10.16 17.58 9.84L16.97 5L18.89 4.97M5.06 5H7.03L6.42 9.84C6.3 10.63 5.91 11 5.25 11C4.84 11 4.53 10.86 4.31 10.55C4.03 10.2 3.94 9.81 4.03 9.38L5.06 5M9.05 5H11V9.7C11 10.05 10.89 10.35 10.64 10.62C10.39 10.88 10.08 11 9.7 11C9.36 11 9.07 10.88 8.84 10.59S8.5 10 8.5 9.66V9.5L9.05 5M13 5H14.95L15.5 9.5C15.58 9.92 15.5 10.27 15.21 10.57C14.95 10.87 14.61 11 14.2 11C13.89 11 13.61 10.88 13.36 10.62C13.11 10.35 13 10.05 13 9.7V5M7.45 12.05C8.08 12.67 8.86 13 9.8 13C10.64 13 11.38 12.67 12 12.05C12.69 12.67 13.45 13 14.3 13C15.17 13 15.92 12.67 16.55 12.05C17.11 12.67 17.86 13 18.8 13H19.03V19H5V13H5.25C6.16 13 6.89 12.67 7.45 12.05Z";
var mdiStorefrontPlus = "M3.84 3.42C4.22 3.14 4.63 3 5.06 3H18.94C19.38 3 19.77 3.14 20.13 3.42C20.5 3.7 20.73 4.06 20.86 4.5L21.89 8.91C22.14 10 21.94 10.95 21.28 11.77C21.23 11.82 21.18 11.87 21.13 11.92L21 12.06C20.43 12.65 19.76 13 18.81 13S17.11 12.62 16.54 12.05C15.91 12.67 15.17 13 14.3 13C13.45 13 12.68 12.7 12 12.07C11.44 12.63 10.64 13 9.8 13C8.86 13 8.1 12.67 7.47 12.05C6.91 12.59 6.16 13 5.22 13S3.63 12.64 3.04 12.07C2.93 11.97 2.81 11.85 2.69 11.73C2.06 10.92 1.86 10 2.11 8.91L3.14 4.5C3.24 4.06 3.46 3.7 3.84 3.42M19.97 9.38L18.89 4.97L16.97 5L17.58 9.84C17.61 10.16 17.73 10.43 17.95 10.66C18.17 10.9 18.44 11 18.75 11C19.13 11 19.44 10.86 19.69 10.55C19.97 10.2 20.06 9.81 19.97 9.38M7.03 5H5.06L4.03 9.38C3.94 9.81 4.03 10.2 4.31 10.55C4.53 10.86 4.84 11 5.25 11C5.91 11 6.3 10.63 6.42 9.84M11 5H9.05L8.5 9.5V9.66C8.5 10 8.61 10.3 8.84 10.59S9.36 11 9.7 11C10.08 11 10.39 10.88 10.64 10.62C10.89 10.35 11 10.05 11 9.7M14.95 5H13V9.7C13 10.05 13.11 10.35 13.36 10.62C13.61 10.88 13.89 11 14.2 11C14.61 11 14.95 10.87 15.21 10.57C15.5 10.27 15.58 9.92 15.5 9.5M17 14H19V17H22V19H19V22H17V19H14V17H17M12 14.07C12.28 14.34 12.61 14.56 12.97 14.72C12.36 15.66 12 16.79 12 18C12 19.09 12.29 20.12 12.8 21H5C3.89 21 3 20.11 3 19V14.03C3.66 14.65 4.33 15 5.23 15C6.1 15 6.89 14.64 7.47 14.05C8.07 14.65 8.87 15 9.78 15C10.65 15 11.43 14.64 12 14.07Z";
var mdiStorefrontPlusOutline = "M3.84 3.42C4.22 3.14 4.63 3 5.06 3H18.94C19.38 3 19.77 3.14 20.13 3.42C20.5 3.7 20.73 4.06 20.86 4.5L21.89 8.91C22.14 10 21.94 10.95 21.28 11.77C21.23 11.82 21.18 11.87 21.13 11.92L21 12.06C20.43 12.65 19.76 13 18.81 13S17.11 12.62 16.54 12.05C15.91 12.67 15.17 13 14.3 13C13.45 13 12.68 12.7 12 12.07C11.44 12.63 10.64 13 9.8 13C8.86 13 8.1 12.67 7.47 12.05C6.91 12.59 6.16 13 5.22 13C5.15 13 5.07 13 5 13V19H12.08C12.2 19.72 12.45 20.39 12.8 21H5C4.5 21 4 20.78 3.61 20.39S3 19.5 3 19V12.03C2.9 11.94 2.8 11.84 2.69 11.73C2.06 10.92 1.86 10 2.11 8.91L3.14 4.5C3.24 4.06 3.46 3.7 3.84 3.42M19.97 9.38L18.89 4.97L16.97 5L17.58 9.84C17.61 10.16 17.73 10.43 17.95 10.66C18.17 10.9 18.44 11 18.75 11C19.13 11 19.44 10.86 19.69 10.55C19.97 10.2 20.06 9.81 19.97 9.38M7.03 5H5.06L4.03 9.38C3.94 9.81 4.03 10.2 4.31 10.55C4.53 10.86 4.84 11 5.25 11C5.91 11 6.3 10.63 6.42 9.84M11 5H9.05L8.5 9.5V9.66C8.5 10 8.61 10.3 8.84 10.59S9.36 11 9.7 11C10.08 11 10.39 10.88 10.64 10.62C10.89 10.35 11 10.05 11 9.7M14.95 5H13V9.7C13 10.05 13.11 10.35 13.36 10.62C13.61 10.88 13.89 11 14.2 11C14.61 11 14.95 10.87 15.21 10.57C15.5 10.27 15.58 9.92 15.5 9.5M19 14H17V17H14V19H17V22H19V19H22V17H19Z";
var mdiStorefrontRemove = "M3.84 3.42C4.22 3.14 4.63 3 5.06 3H18.94C19.38 3 19.77 3.14 20.13 3.42C20.5 3.7 20.73 4.06 20.86 4.5L21.89 8.91C22.14 10 21.94 10.95 21.28 11.77C21.23 11.82 21.18 11.87 21.13 11.92L21 12.06C20.43 12.65 19.76 13 18.81 13S17.11 12.62 16.54 12.05C15.91 12.67 15.17 13 14.3 13C13.45 13 12.68 12.7 12 12.07C11.44 12.63 10.64 13 9.8 13C8.86 13 8.1 12.67 7.47 12.05C6.91 12.59 6.16 13 5.22 13S3.63 12.64 3.04 12.07C2.93 11.97 2.81 11.85 2.69 11.73C2.06 10.92 1.86 10 2.11 8.91L3.14 4.5C3.24 4.06 3.46 3.7 3.84 3.42M19.97 9.38L18.89 4.97L16.97 5L17.58 9.84C17.61 10.16 17.73 10.43 17.95 10.66C18.17 10.9 18.44 11 18.75 11C19.13 11 19.44 10.86 19.69 10.55C19.97 10.2 20.06 9.81 19.97 9.38M7.03 5H5.06L4.03 9.38C3.94 9.81 4.03 10.2 4.31 10.55C4.53 10.86 4.84 11 5.25 11C5.91 11 6.3 10.63 6.42 9.84L7.03 5M11 5H9.05L8.5 9.5V9.66C8.5 10 8.61 10.3 8.84 10.59S9.36 11 9.7 11C10.08 11 10.39 10.88 10.64 10.62C10.89 10.35 11 10.05 11 9.7V5M14.95 5H13V9.7C13 10.05 13.11 10.35 13.36 10.62C13.61 10.88 13.89 11 14.2 11C14.61 11 14.95 10.87 15.21 10.57C15.5 10.27 15.58 9.92 15.5 9.5L14.95 5M20.12 14.46L21.54 15.88L19.41 18L21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.47 20.12L16.59 18L14.47 15.88L15.88 14.47L18 16.59L20.12 14.46M12 14.07C12.28 14.34 12.61 14.56 12.97 14.72C12.36 15.66 12 16.79 12 18C12 19.09 12.29 20.12 12.8 21H5C3.89 21 3 20.11 3 19V14.03C3.66 14.65 4.33 15 5.23 15C6.1 15 6.89 14.64 7.47 14.05C8.07 14.65 8.87 15 9.78 15C10.65 15 11.43 14.64 12 14.07Z";
var mdiStorefrontRemoveOutline = "M3.84 3.42C4.22 3.14 4.63 3 5.06 3H18.94C19.38 3 19.77 3.14 20.13 3.42C20.5 3.7 20.73 4.06 20.86 4.5L21.89 8.91C22.14 10 21.94 10.95 21.28 11.77C21.23 11.82 21.18 11.87 21.13 11.92L21 12.06C20.43 12.65 19.76 13 18.81 13S17.11 12.62 16.54 12.05C15.91 12.67 15.17 13 14.3 13C13.45 13 12.68 12.7 12 12.07C11.44 12.63 10.64 13 9.8 13C8.86 13 8.1 12.67 7.47 12.05C6.91 12.59 6.16 13 5.22 13C5.15 13 5.07 13 5 13V19H12.08C12.2 19.72 12.45 20.39 12.8 21H5C4.5 21 4 20.78 3.61 20.39S3 19.5 3 19V12.03C2.9 11.94 2.8 11.84 2.69 11.73C2.06 10.92 1.86 10 2.11 8.91L3.14 4.5C3.24 4.06 3.46 3.7 3.84 3.42M19.97 9.38L18.89 4.97L16.97 5L17.58 9.84C17.61 10.16 17.73 10.43 17.95 10.66C18.17 10.9 18.44 11 18.75 11C19.13 11 19.44 10.86 19.69 10.55C19.97 10.2 20.06 9.81 19.97 9.38M7.03 5H5.06L4.03 9.38C3.94 9.81 4.03 10.2 4.31 10.55C4.53 10.86 4.84 11 5.25 11C5.91 11 6.3 10.63 6.42 9.84L7.03 5M11 5H9.05L8.5 9.5V9.66C8.5 10 8.61 10.3 8.84 10.59S9.36 11 9.7 11C10.08 11 10.39 10.88 10.64 10.62C10.89 10.35 11 10.05 11 9.7V5M14.95 5H13V9.7C13 10.05 13.11 10.35 13.36 10.62C13.61 10.88 13.89 11 14.2 11C14.61 11 14.95 10.87 15.21 10.57C15.5 10.27 15.58 9.92 15.5 9.5L14.95 5M21.54 15.88L20.12 14.47L18 16.59L15.88 14.47L14.47 15.88L16.59 18L14.47 20.12L15.88 21.54L18 19.41L20.12 21.54L21.54 20.12L19.41 18L21.54 15.88Z";
var mdiStove = "M6,14H8L11,17H9L6,14M4,4H5V3A1,1 0 0,1 6,2H10A1,1 0 0,1 11,3V4H13V3A1,1 0 0,1 14,2H18A1,1 0 0,1 19,3V4H20A2,2 0 0,1 22,6V19A2,2 0 0,1 20,21V22H17V21H7V22H4V21A2,2 0 0,1 2,19V6A2,2 0 0,1 4,4M18,7A1,1 0 0,1 19,8A1,1 0 0,1 18,9A1,1 0 0,1 17,8A1,1 0 0,1 18,7M14,7A1,1 0 0,1 15,8A1,1 0 0,1 14,9A1,1 0 0,1 13,8A1,1 0 0,1 14,7M20,6H4V10H20V6M4,19H20V12H4V19M6,7A1,1 0 0,1 7,8A1,1 0 0,1 6,9A1,1 0 0,1 5,8A1,1 0 0,1 6,7M13,14H15L18,17H16L13,14Z";
var mdiStrategy = "M6.91 5.5L9.21 7.79L7.79 9.21L5.5 6.91L3.21 9.21L1.79 7.79L4.09 5.5L1.79 3.21L3.21 1.79L5.5 4.09L7.79 1.79L9.21 3.21M22.21 16.21L20.79 14.79L18.5 17.09L16.21 14.79L14.79 16.21L17.09 18.5L14.79 20.79L16.21 22.21L18.5 19.91L20.79 22.21L22.21 20.79L19.91 18.5M20.4 6.83L17.18 11L15.6 9.73L16.77 8.23A9.08 9.08 0 0 0 10.11 13.85A4.5 4.5 0 1 1 7.5 13A4 4 0 0 1 8.28 13.08A11.27 11.27 0 0 1 16.43 6.26L15 5.18L16.27 3.6M10 17.5A2.5 2.5 0 1 0 7.5 20A2.5 2.5 0 0 0 10 17.5Z";
var mdiStretchToPage = "M20,2H4C2.89,2 2,2.89 2,4V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V4C22,2.89 21.11,2 20,2M9,19H5V15L6.29,16.29L7.83,14.75L9.25,16.17L7.71,17.71M7.83,9.25L6.29,7.71L5,9V5H9L7.71,6.29L9.25,7.83M19,19H15L16.29,17.71L14.75,16.17L16.17,14.75L17.71,16.29L19,15M19,9L17.71,7.71L16.17,9.25L14.75,7.83L16.29,6.29L15,5H19";
var mdiStretchToPageOutline = "M20,2H4C2.89,2 2,2.89 2,4V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V4C22,2.89 21.11,2 20,2M20,20H4V4H20M8.83,10.25L7.29,8.71L6,10V6H10L8.71,7.29L10.25,8.83M13.75,8.83L15.29,7.29L14,6H18V10L16.71,8.71L15.17,10.25M15.17,13.75L16.71,15.29L18,14V18H14L15.29,16.71L13.75,15.17M10.25,15.17L8.71,16.71L10,18H6V14L7.29,15.29L8.83,13.75";
var mdiStringLights = "M22.56 11.39C22.36 10.59 21.82 9.85 21.05 9.44L20.63 7.74C21.11 7.58 21.57 7.41 22 7.23V5C20 6.07 16.53 7.03 12 7.03S4 6.07 2 5V7.23C2.43 7.41 2.89 7.58 3.37 7.74L2.95 9.44C2.18 9.85 1.64 10.59 1.44 11.39C.905 13.57 .385 17.31 2.92 17.93C4 18.2 6 17.89 7.27 12.82C7.46 12 7.33 11.12 6.84 10.39L7.26 8.67C8.14 8.81 9.05 8.9 10 8.96V10.74C9.35 11.33 9 12.17 9 13C9 15.24 9.39 19 12 19C13.12 19 15 18.22 15 13C15 12.17 14.65 11.33 14 10.74V8.96C14.95 8.9 15.86 8.81 16.74 8.67L17.16 10.39C16.67 11.12 16.54 12 16.73 12.82C18 17.89 20 18.2 21.08 17.93C23.61 17.31 23.09 13.57 22.56 11.39M5.81 12.47C5.81 12.47 4.74 16.84 3.28 16.5C1.82 16.12 2.9 11.75 2.9 11.75S3.26 10.29 4.71 10.65 5.81 12.47 5.81 12.47M12 17.5C10.5 17.5 10.5 13 10.5 13S10.5 11.5 12 11.5 13.5 13 13.5 13 13.5 17.5 12 17.5M20.72 16.5C19.27 16.84 18.19 12.47 18.19 12.47S17.83 11 19.29 10.65 21.1 11.75 21.1 11.75 22.18 16.12 20.72 16.5Z";
var mdiStringLightsOff = "M14 10.74V8.96C14.95 8.9 15.86 8.81 16.74 8.67L17.16 10.39C16.67 11.12 16.54 12 16.73 12.82C16.82 13.17 16.91 13.5 17 13.8L21.12 17.92C23.61 17.26 23.09 13.55 22.56 11.39C22.36 10.59 21.82 9.85 21.05 9.44L20.63 7.74C21.11 7.58 21.57 7.41 22 7.23V5C20 6.07 16.53 7.03 12 7.03C11.37 7.03 10.76 7 10.17 6.97M20.72 16.5C19.27 16.84 18.19 12.47 18.19 12.47S17.83 11 19.29 10.65 21.1 11.75 21.1 11.75 22.18 16.12 20.72 16.5M14.95 14.29L13.5 12.83V12.83L12.18 11.5H12.18L10 9.34V9.34L9.58 8.93H9.59L7.32 6.66H7.32L2.39 1.73L1.11 3L3.91 5.8C3.19 5.55 2.53 5.28 2 5V7.23C2.43 7.41 2.89 7.58 3.37 7.74L2.95 9.44C2.18 9.85 1.64 10.59 1.44 11.39C.905 13.57 .385 17.31 2.92 17.93C4 18.2 6 17.89 7.27 12.82C7.46 12 7.33 11.12 6.84 10.39L7.17 9.06L9.5 11.38C9.18 11.87 9 12.44 9 13C9 15.24 9.39 19 12 19C12.8 19 13.97 18.59 14.59 16.5L20.84 22.73L22.11 21.46L14.95 14.3L14.95 14.29M5.81 12.47C5.81 12.47 4.74 16.84 3.28 16.5C1.82 16.12 2.9 11.75 2.9 11.75S3.26 10.29 4.71 10.65 5.81 12.47 5.81 12.47M12 17.5C10.5 17.5 10.5 13 10.5 13S10.5 12.77 10.6 12.5L13.32 15.21C13.13 16.35 12.76 17.5 12 17.5Z";
var mdiSubdirectoryArrowLeft = "M11,9L12.42,10.42L8.83,14H18V4H20V16H8.83L12.42,19.58L11,21L5,15L11,9Z";
var mdiSubdirectoryArrowRight = "M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z";
var mdiSubmarine = "M8 3.67C6.78 4.53 5.39 4.93 4 5H2V7H4C5.37 7 6.74 6.65 8 6C10.5 7.3 13.5 7.3 16 6C17.26 6.65 18.62 6.94 20 7H22V5H20C18.61 5 17.22 4.53 16 3.67C13.56 5.38 10.44 5.38 8 3.67M16 8.67L15 10V12H14L12 14H9L6 16L5 14H4V16L2 17L4 18V20H5.14L6 18L9 20H20A2 2 0 0 0 22 18V16A2 2 0 0 0 20 14H18L17 13V12H16V10H17V8.67Z";
var mdiSubtitles = "M20,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6A2,2 0 0,0 20,4M4,12H8V14H4V12M14,18H4V16H14V18M20,18H16V16H20V18M20,14H10V12H20V14Z";
var mdiSubtitlesOutline = "M20,4A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20M20,18V6H4V18H20M6,10H8V12H6V10M6,14H14V16H6V14M16,14H18V16H16V14M10,10H18V12H10V10Z";
var mdiSubway = "M8.5,15A1,1 0 0,1 9.5,16A1,1 0 0,1 8.5,17A1,1 0 0,1 7.5,16A1,1 0 0,1 8.5,15M7,9H17V14H7V9M15.5,15A1,1 0 0,1 16.5,16A1,1 0 0,1 15.5,17A1,1 0 0,1 14.5,16A1,1 0 0,1 15.5,15M18,15.88V9C18,6.38 15.32,6 12,6C9,6 6,6.37 6,9V15.88A2.62,2.62 0 0,0 8.62,18.5L7.5,19.62V20H9.17L10.67,18.5H13.5L15,20H16.5V19.62L15.37,18.5C16.82,18.5 18,17.33 18,15.88M17.8,2.8C20.47,3.84 22,6.05 22,8.86V22H2V8.86C2,6.05 3.53,3.84 6.2,2.8C8,2.09 10.14,2 12,2C13.86,2 16,2.09 17.8,2.8Z";
var mdiSubwayAlertVariant = "M16 11V6H11V11H16M14.5 17C15.3 17 16 16.3 16 15.5C16 14.7 15.3 14 14.5 14S13 14.7 13 15.5C13 16.3 13.7 17 14.5 17M9 11V6H4V11H9M5.5 17C6.3 17 7 16.3 7 15.5C7 14.7 6.3 14 5.5 14S4 14.7 4 15.5C4 16.3 4.7 17 5.5 17M10 2C14.4 2 18 2.5 18 6V15.5C18 17.4 16.4 19 14.5 19L16 20.5V21H4V20.5L5.5 19C3.6 19 2 17.4 2 15.5V6C2 2.5 5.6 2 10 2M20 13V7H22V13H20M20 17V15H22V17H20Z";
var mdiSubwayVariant = "M18,11H13V6H18M16.5,17A1.5,1.5 0 0,1 15,15.5A1.5,1.5 0 0,1 16.5,14A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 16.5,17M11,11H6V6H11M7.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,14A1.5,1.5 0 0,1 9,15.5A1.5,1.5 0 0,1 7.5,17M12,2C7.58,2 4,2.5 4,6V15.5A3.5,3.5 0 0,0 7.5,19L6,20.5V21H18V20.5L16.5,19A3.5,3.5 0 0,0 20,15.5V6C20,2.5 16.42,2 12,2Z";
var mdiSummit = "M15,3H17L22,5L17,7V10.17L22,21H2L8,13L11.5,17.7L15,10.17V3Z";
var mdiSunAngle = "M13.8 5.2C13 5 12.2 5 11.4 5L14.6 2.3L16 6.3C15.3 5.8 14.6 5.5 13.8 5.2M7 7.1C7.6 6.5 8.3 6 9 5.7L4.9 4.9L5.6 9C6 8.3 6.4 7.6 7 7.1M5.2 13.8C5 13 5 12.2 5 11.4L2.3 14.6L6.3 16C5.8 15.4 5.4 14.6 5.2 13.8M22 19V21H3L8.4 15.5C6.5 13.5 6.5 10.4 8.4 8.4C10.3 6.5 13.5 6.5 15.4 8.4L18.4 5.4L19.8 6.8L7.7 19H22Z";
var mdiSunAngleOutline = "M13.8 5.2C13 5 12.2 5 11.4 5L14.6 2.3L16 6.3C15.3 5.8 14.6 5.5 13.8 5.2M7 7.1C7.6 6.5 8.3 6 9 5.7L4.9 4.9L5.6 9C6 8.3 6.4 7.6 7 7.1M5.2 13.8C5 13 5 12.2 5 11.4L2.3 14.6L6.3 16C5.8 15.4 5.4 14.6 5.2 13.8M22 19V21H3L8.4 15.5C6.5 13.5 6.5 10.4 8.4 8.4C10.3 6.5 13.5 6.5 15.4 8.4L18.4 5.4L19.8 6.8L7.7 19H22M9.8 14.1L14 9.8C12.8 8.7 11 8.7 9.8 9.8C8.7 11 8.7 12.9 9.8 14.1Z";
var mdiSunClock = "M18.1 9.3L19.6 6L15.5 5.6C16.1 6.1 16.6 6.7 17 7.5C17.3 8.1 17.5 8.6 17.7 9.2C17.2 9.1 16.6 9 16 9H15.6C14.8 7.2 13.1 6 11 6C8.2 6 6 8.2 6 11C6 13.1 7.2 14.8 9 15.6V16C9 19.9 12.1 23 16 23S23 19.9 23 16C23 12.9 20.9 10.2 18.1 9.3M16 21C13.2 21 11 18.8 11 16S13.2 11 16 11 21 13.2 21 16 18.8 21 16 21M16.5 16.2L19.4 17.9L18.6 19.1L15 17V12H16.5V16.2M11 4C10.2 4 9.4 4.2 8.6 4.4L11 1L13.4 4.4C12.6 4.2 11.8 4 11 4M4.9 14.5C5.3 15.2 5.9 15.9 6.5 16.4L2.4 16L4.2 12.2C4.3 13 4.5 13.8 4.9 14.5M4.1 9.8L2.3 6L6.5 5.7C5.9 6.2 5.4 6.8 4.9 7.5C4.5 8.2 4.2 9 4.1 9.8Z";
var mdiSunClockOutline = "M18.1 9.32L19.65 6L15.5 5.64C16.1 6.15 16.63 6.78 17.05 7.5C17.37 8.05 17.58 8.63 17.73 9.22C17.18 9.08 16.6 9 16 9C15.86 9 15.72 9 15.58 9C14.81 7.25 13.06 6 11 6C8.24 6 6 8.24 6 11C6 13.06 7.25 14.81 9 15.58C9 15.72 9 15.86 9 16C9 19.87 12.13 23 16 23S23 19.87 23 16C23 12.87 20.94 10.21 18.1 9.32M8 11C8 9.35 9.35 8 11 8C12.08 8 13.03 8.58 13.56 9.45C11.66 10.15 10.15 11.66 9.45 13.56C8.58 13.03 8 12.08 8 11M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25M11 4C10.16 4 9.35 4.15 8.61 4.42L11 1L13.39 4.42C12.65 4.15 11.84 4 11 4M4.95 14.5C5.37 15.24 5.91 15.86 6.5 16.37L2.36 16L4.12 12.23C4.26 13 4.53 13.78 4.95 14.5M4.11 9.79L2.34 6L6.5 5.65C5.9 6.16 5.36 6.78 4.94 7.5C4.5 8.24 4.25 9 4.11 9.79Z";
var mdiSunCompass = "M9.7 4.3L12 1L14.3 4.3C13.6 4.1 12.8 4 12 4S10.4 4.1 9.7 4.3M17.5 6.2C18.6 7.3 19.5 8.7 19.8 10.3L21.5 6.6L17.5 6.2M5 8.1C5.1 8 5.1 8 5 8.1C5.1 8 5.1 8 5.1 7.9C5.5 7.3 6 6.7 6.5 6.2L2.5 6.5L4.2 10.2C4.4 9.5 4.7 8.7 5 8.1M19.2 15.4C19.2 15.4 19.2 15.5 19.2 15.4C19.1 15.6 19 15.8 18.9 15.9V16.1C18.5 16.8 18 17.3 17.5 17.9L21.6 17.6L19.9 13.9C19.7 14.4 19.5 14.9 19.2 15.4M5.2 16.2C5.2 16.1 5.1 16.1 5.1 16C5 15.9 5 15.9 5 15.8C4.9 15.6 4.8 15.5 4.8 15.3C4.6 14.8 4.4 14.3 4.3 13.8L2.6 17.5L6.7 17.8C6 17.3 5.6 16.8 5.2 16.2M12.6 20H11.4C10.8 20 10.2 19.8 9.7 19.7L12 23L14.3 19.7C13.8 19.8 13.2 19.9 12.6 20M16.2 7.8C13.9 5.5 10.1 5.5 7.7 7.8S5.4 13.9 7.7 16.3 13.8 18.6 16.2 16.3 18.6 10.1 16.2 7.8M8.5 15.5L10.6 10.6L15.6 8.4L13.5 13.3L8.5 15.5M12.7 12.7C12.3 13.1 11.7 13.1 11.3 12.7C10.9 12.3 10.9 11.7 11.3 11.3C11.7 10.9 12.3 10.9 12.7 11.3C13.1 11.7 13.1 12.3 12.7 12.7Z";
var mdiSunSnowflake = "M12 .69L8.69 4H4V8.69L.69 12L4 15.31V20H8.69L12 23.31L13 22.31V17.83L16.24 21.07L17.66 19.66L13 15V13H15L19.66 17.66L21.07 16.24L17.83 13H22V11H17.83L21.07 7.76L19.66 6.34L15 11H13V9L17.66 4.34L16.24 2.93L13 6.17V1.69M11 6.09V8.13C9.24 8.59 8 10.18 8 12C8 13.82 9.24 15.41 11 15.87V17.91C8.12 17.42 6 14.93 6 12C6 9.07 8.11 6.57 11 6.09Z";
var mdiSunSnowflakeVariant = "M12.92 1.58L11.18 2.58L12.39 4.67L11.8 6.85L9 7.6L7.38 6L7.42 3.59L5.43 3.59L5.43 5.42L3.59 5.42L3.6 7.42L6 7.42L7.65 9.03L6.9 11.82L4.68 12.4L2.59 11.2L1.59 12.93L3.17 13.84L2.26 15.42L4 16.42L5.19 14.33L7.42 13.75L7.92 14.26L9.32 12.86L8.78 12.32L9.53 9.54L12.32 8.78L12.85 9.32L14.26 7.91L13.73 7.37L14.32 5.19L16.41 4L15.41 2.25L13.83 3.16L12.92 1.58M20.72 4L4 20.72L5.27 22L10.16 17.11C10.63 17.43 11.15 17.68 11.71 17.83C14.38 18.55 17.12 16.96 17.83 14.29C18.22 12.86 17.93 11.36 17.11 10.16L22 5.27L20.72 4M18.74 9C19.18 9.63 19.53 10.38 19.75 11.19C19.97 12 20.03 12.81 19.96 13.61L22.65 10.41L18.74 9M19.32 15.95C19 16.67 18.5 17.35 17.93 17.94C17.34 18.53 16.66 19 15.96 19.34L20.05 20.06L19.32 15.95M9 18.71L10.41 22.66L13.59 19.95C12.81 20 12 19.97 11.19 19.76C10.36 19.54 9.62 19.17 9 18.71Z";
var mdiSunThermometer = "M10 2L7.6 5.4C8.4 5.2 9.2 5 10 5C10.8 5 11.6 5.2 12.4 5.4M19 5C17.89 5 17 5.89 17 7V13.76C16.36 14.33 16 15.15 16 16C16 17.66 17.34 19 19 19C20.66 19 22 17.66 22 16C22 15.15 21.64 14.33 21 13.77V7C21 5.89 20.11 5 19 5M19 6C19.55 6 20 6.45 20 7V8H18V7C18 6.45 18.45 6 19 6M5.5 6.7L1.3 7L3.1 10.8C3.2 10 3.5 9.2 3.9 8.5C4.4 7.8 4.9 7.2 5.5 6.7M10 7C7.2 7 5 9.2 5 12C5 14.8 7.2 17 10 17C12.8 17 15 14.8 15 12C15 9.2 12.8 7 10 7M3.2 13.2L1.4 17L5.5 17.4C5 16.9 4.4 16.2 4 15.5C3.5 14.8 3.3 14 3.2 13.2M7.6 18.6L10 22L12.4 18.6C11.6 18.8 10.8 19 10 19C9.1 19 8.3 18.8 7.6 18.6Z";
var mdiSunThermometerOutline = "M10 2L7.6 5.4C8.4 5.2 9.2 5 10 5S11.6 5.2 12.4 5.4L10 2M21 13.8V7C21 5.9 20.1 5 19 5S17 5.9 17 7V13.8C16.4 14.4 16 15.2 16 16C16 17.7 17.3 19 19 19S22 17.7 22 16C22 15.1 21.6 14.3 21 13.8M20 8H18V7C18 6.4 18.4 6 19 6S20 6.4 20 7V8M5.5 6.7L1.3 7L3.1 10.8C3.2 10 3.5 9.2 3.9 8.5C4.4 7.8 4.9 7.2 5.5 6.7M10 7C7.2 7 5 9.2 5 12S7.2 17 10 17 15 14.8 15 12 12.8 7 10 7M10 15C8.3 15 7 13.7 7 12S8.3 9 10 9 13 10.3 13 12 11.7 15 10 15M3.2 13.2L1.4 17L5.5 17.4C5 16.9 4.4 16.2 4 15.5C3.5 14.8 3.3 14 3.2 13.2M7.6 18.6L10 22L12.4 18.6C11.6 18.8 10.8 19 10 19C9.1 19 8.3 18.8 7.6 18.6Z";
var mdiSunWireless = "M11 6C13.76 6 16 8.24 16 11S13.76 16 11 16 6 13.76 6 11 8.24 6 11 6M11 1L13.39 4.42C12.65 4.15 11.84 4 11 4S9.35 4.15 8.61 4.42L11 1M2.34 6L6.5 5.65C5.9 6.16 5.36 6.78 4.94 7.5C4.5 8.24 4.25 9 4.11 9.79L2.34 6M2.36 16L4.12 12.23C4.26 13 4.53 13.78 4.95 14.5C5.37 15.24 5.91 15.86 6.5 16.37L2.36 16M19.65 6L17.88 9.79C17.74 9 17.47 8.23 17.05 7.5C16.63 6.78 16.1 6.15 15.5 5.64L19.65 6M23 13H21C21 15.05 20.22 17.1 18.66 18.66C17.09 20.23 15.05 21 13 21V23C15.56 23 18.12 22 20.07 20.07S23 15.56 23 13M19 13H17C17 14 16.61 15.05 15.83 15.83C15.05 16.61 14 17 13 17V19C14.54 19 16.08 18.41 17.25 17.24C18.41 16.08 19 14.54 19 13";
var mdiSunWirelessOutline = "M11 1L13.39 4.42C12.65 4.15 11.84 4 11 4S9.35 4.15 8.61 4.42L11 1M2.34 6L6.5 5.65C5.9 6.16 5.36 6.78 4.94 7.5C4.5 8.24 4.25 9 4.11 9.79L2.34 6M2.36 16L4.12 12.23C4.26 13 4.53 13.78 4.95 14.5C5.37 15.24 5.91 15.86 6.5 16.37L2.36 16M19.65 6L17.88 9.79C17.74 9 17.47 8.23 17.05 7.5C16.63 6.78 16.1 6.15 15.5 5.64L19.65 6M23 13H21C21 15.05 20.22 17.1 18.66 18.66C17.09 20.23 15.05 21 13 21V23C15.56 23 18.12 22 20.07 20.07S23 15.56 23 13M19 13H17C17 14 16.61 15.05 15.83 15.83C15.05 16.61 14 17 13 17V19C14.54 19 16.08 18.41 17.25 17.24C18.41 16.08 19 14.54 19 13M11 8C12.65 8 14 9.35 14 11S12.65 14 11 14 8 12.65 8 11 9.35 8 11 8M11 6C8.24 6 6 8.24 6 11S8.24 16 11 16 16 13.76 16 11 13.76 6 11 6Z";
var mdiSunglasses = "M7,17H4C2.38,17 0.96,15.74 0.76,14.14L0.26,11.15C0.15,10.3 0.39,9.5 0.91,8.92C1.43,8.34 2.19,8 3,8H9C9.83,8 10.58,8.35 11.06,8.96C11.17,9.11 11.27,9.27 11.35,9.45C11.78,9.36 12.22,9.36 12.64,9.45C12.72,9.27 12.82,9.11 12.94,8.96C13.41,8.35 14.16,8 15,8H21C21.81,8 22.57,8.34 23.09,8.92C23.6,9.5 23.84,10.3 23.74,11.11L23.23,14.18C23.04,15.74 21.61,17 20,17H17C15.44,17 13.92,15.81 13.54,14.3L12.64,11.59C12.26,11.31 11.73,11.31 11.35,11.59L10.43,14.37C10.07,15.82 8.56,17 7,17Z";
var mdiSurfing = "M22 23V21C20.59 21.05 19.22 20.9 18 20C16.24 21.25 13.77 21.25 12 20C10.23 21.25 7.76 21.25 6 20C4.78 20.9 3.41 21.05 2 21V23C3.37 23.05 4.78 22.94 6 22.25C7.84 23.25 10.15 23.25 12 22.25C13.85 23.25 16.16 23.25 18 22.25C19.22 22.94 20.63 23.05 22 23M20.5 11.97V9.95C18.74 9.96 17 9 16.18 7.41L15.29 5.86C15 5.4 14.55 5.11 14.07 4.97L8.5 3.94L5 6.38L6.13 8L8.95 6.1L10.97 6.43L8.81 7.88C8.21 8.29 7.88 9 8 9.71L8.53 12.81C7.12 12.26 3.21 11 3 13.23C3.36 15.67 6.07 17.32 8.06 18.82C9.5 19.29 11.06 18.58 12 17.46C13.32 19.16 15.89 19.46 17.5 18C17.03 17.58 16.5 17.15 16 16.8V12.95L12.19 9.95L14.44 8.44C15.62 10.59 18 12 20.5 11.97M14 14V15.47C14 15.43 11.66 14.16 11.81 14.24L10.73 13.7L10.31 11.08L14 14M19 3.5C19 4.61 18.11 5.5 17 5.5S15 4.61 15 3.5 15.9 1.5 17 1.5 19 2.4 19 3.5Z";
var mdiSurroundSound = "M20,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6A2,2 0 0,0 20,4M7.76,16.24L6.35,17.65C4.78,16.1 4,14.05 4,12C4,9.95 4.78,7.9 6.34,6.34L7.75,7.75C6.59,8.93 6,10.46 6,12C6,13.54 6.59,15.07 7.76,16.24M12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16M17.66,17.66L16.25,16.25C17.41,15.07 18,13.54 18,12C18,10.46 17.41,8.93 16.24,7.76L17.65,6.35C19.22,7.9 20,9.95 20,12C20,14.05 19.22,16.1 17.66,17.66M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z";
var mdiSurroundSound20 = "M3 7V9H7V11H5C3.9 11 3 11.9 3 13V17H9V15H5V13H7C8.1 13 9 12.1 9 11V9C9 7.9 8.1 7 7 7H3M13 17H11V15H13V17M17 7C15.9 7 15 7.9 15 9V15C15 16.1 15.9 17 17 17H19C20.1 17 21 16.1 21 15V9C21 7.9 20.1 7 19 7H17M17 9H19V15H17V9Z";
var mdiSurroundSound21 = "M4 7V9H8V11H6C4.9 11 4 11.9 4 13V17H10V15H6V13H8C9.1 13 10 12.1 10 11V9C10 7.9 9.1 7 8 7H4M14 17H12V15H14V17M16 7V9H18V17H20V7H16Z";
var mdiSurroundSound31 = "M14 17H12V15H14V17M20 7V17H18V9H16V7H20M10 15C10 16.1 9.1 17 8 17H4V15H8V13H6V11H8V9H4V7H8C9.1 7 10 7.9 10 9V10.5C10 11.3 9.3 12 8.5 12C9.3 12 10 12.7 10 13.5V15";
var mdiSurroundSound51 = "M14 17H12V15H14V17M20 7V17H18V9H16V7H20M10 7V9H6V11H8C9.1 11 10 11.9 10 13V15C10 16.1 9.1 17 8 17H4V15H8V13H4V7H10Z";
var mdiSurroundSound512 = "M18 7V9H22V11H20C18.9 11 18 11.9 18 13V17H24V15H20V13H22C23.1 13 24 12.1 24 11V9C24 7.9 23.1 7 22 7H18M9 17H7V15H9V17M9 7V9H11V17H13V7H9M0 7V13H4V15H0V17H4C5.1 17 6 16.1 6 15V13C6 11.9 5.1 11 4 11H2V9H6V7H0M17 17H15V15H17V17";
var mdiSurroundSound71 = "M14 17H12V15H14V17M20 7V17H18V9H16V7H20M4 17L8 9H4V7H10V9L6 17";
var mdiSvg = "M5.13,10.71H8.87L6.22,8.06C5.21,8.06 4.39,7.24 4.39,6.22A1.83,1.83 0 0,1 6.22,4.39C7.24,4.39 8.06,5.21 8.06,6.22L10.71,8.87V5.13C10,4.41 10,3.25 10.71,2.54C11.42,1.82 12.58,1.82 13.29,2.54C14,3.25 14,4.41 13.29,5.13V8.87L15.95,6.22C15.95,5.21 16.76,4.39 17.78,4.39C18.79,4.39 19.61,5.21 19.61,6.22C19.61,7.24 18.79,8.06 17.78,8.06L15.13,10.71H18.87C19.59,10 20.75,10 21.46,10.71C22.18,11.42 22.18,12.58 21.46,13.29C20.75,14 19.59,14 18.87,13.29H15.13L17.78,15.95C18.79,15.95 19.61,16.76 19.61,17.78A1.83,1.83 0 0,1 17.78,19.61C16.76,19.61 15.95,18.79 15.95,17.78L13.29,15.13V18.87C14,19.59 14,20.75 13.29,21.46C12.58,22.18 11.42,22.18 10.71,21.46C10,20.75 10,19.59 10.71,18.87V15.13L8.06,17.78C8.06,18.79 7.24,19.61 6.22,19.61C5.21,19.61 4.39,18.79 4.39,17.78C4.39,16.76 5.21,15.95 6.22,15.95L8.87,13.29H5.13C4.41,14 3.25,14 2.54,13.29C1.82,12.58 1.82,11.42 2.54,10.71C3.25,10 4.41,10 5.13,10.71Z";
var mdiSwapHorizontal = "M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z";
var mdiSwapHorizontalBold = "M8,10V13H14V18H8V21L2,15.5L8,10M22,8.5L16,3V6H10V11H16V14L22,8.5Z";
var mdiSwapHorizontalCircle = "M22 12C22 6.5 17.5 2 12 2S2 6.5 2 12 6.5 22 12 22 22 17.5 22 12M15 6.5L18.5 10L15 13.5V11H11V9H15V6.5M9 17.5L5.5 14L9 10.5V13H13V15H9V17.5Z";
var mdiSwapHorizontalCircleOutline = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M15 6.5V9H11V11H15V13.5L18.5 10L15 6.5M9 10.5L5.5 14L9 17.5V15H13V13H9V10.5Z";
var mdiSwapHorizontalHidden = "M17 5L21 9L17 13V5M16 8H13V10H16V8M12 10V8H10V10H12M3 15L7 11V19L3 15M8 16H11V14H8V16M12 14V16H14V14H12Z";
var mdiSwapHorizontalVariant = "M4,6L8,10V7H16A2,2 0 0,1 18,9A2,2 0 0,1 16,11H8A4,4 0 0,0 4,15A4,4 0 0,0 8,19H16V22L20,18L16,14V17H8A2,2 0 0,1 6,15A2,2 0 0,1 8,13H16A4,4 0 0,0 20,9A4,4 0 0,0 16,5H8V2L4,6Z";
var mdiSwapVertical = "M9,3L5,7H8V14H10V7H13M16,17V10H14V17H11L15,21L19,17H16Z";
var mdiSwapVerticalBold = "M14,8H11V14H6V8H3L8.5,2L14,8M15.5,22L21,16H18V10H13V16H10L15.5,22Z";
var mdiSwapVerticalCircle = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M6.5 9L10 5.5L13.5 9H11V13H9V9H6.5M17.5 15L14 18.5L10.5 15H13V11H15V15H17.5Z";
var mdiSwapVerticalCircleOutline = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M6.5 9L10 5.5L13.5 9H11V13H9V9H6.5M17.5 15L14 18.5L10.5 15H13V11H15V15H17.5Z";
var mdiSwapVerticalVariant = "M18,4L14,8H17V16A2,2 0 0,1 15,18A2,2 0 0,1 13,16V8A4,4 0 0,0 9,4A4,4 0 0,0 5,8V16H2L6,20L10,16H7V8A2,2 0 0,1 9,6A2,2 0 0,1 11,8V16A4,4 0 0,0 15,20A4,4 0 0,0 19,16V8H22L18,4Z";
var mdiSwim = "M2,18C4.22,17 6.44,16 8.67,16C10.89,16 13.11,18 15.33,18C17.56,18 19.78,16 22,16V19C19.78,19 17.56,21 15.33,21C13.11,21 10.89,19 8.67,19C6.44,19 4.22,20 2,21V18M8.67,13C7.89,13 7.12,13.12 6.35,13.32L11.27,9.88L10.23,8.64C10.09,8.47 10,8.24 10,8C10,7.66 10.17,7.35 10.44,7.17L16.16,3.17L17.31,4.8L12.47,8.19L17.7,14.42C16.91,14.75 16.12,15 15.33,15C13.11,15 10.89,13 8.67,13M18,7A2,2 0 0,1 20,9A2,2 0 0,1 18,11A2,2 0 0,1 16,9A2,2 0 0,1 18,7Z";
var mdiSwitch = "M13,18H14A1,1 0 0,1 15,19H22V21H15A1,1 0 0,1 14,22H10A1,1 0 0,1 9,21H2V19H9A1,1 0 0,1 10,18H11V16H8A1,1 0 0,1 7,15V3A1,1 0 0,1 8,2H16A1,1 0 0,1 17,3V15A1,1 0 0,1 16,16H13V18M13,6H14V4H13V6M9,4V6H11V4H9M9,8V10H11V8H9M9,12V14H11V12H9Z";
var mdiSword = "M6.92,5H5L14,14L15,13.06M19.96,19.12L19.12,19.96C18.73,20.35 18.1,20.35 17.71,19.96L14.59,16.84L11.91,19.5L10.5,18.09L11.92,16.67L3,7.75V3H7.75L16.67,11.92L18.09,10.5L19.5,11.91L16.83,14.58L19.95,17.7C20.35,18.1 20.35,18.73 19.96,19.12Z";
var mdiSwordCross = "M6.2,2.44L18.1,14.34L20.22,12.22L21.63,13.63L19.16,16.1L22.34,19.28C22.73,19.67 22.73,20.3 22.34,20.69L21.63,21.4C21.24,21.79 20.61,21.79 20.22,21.4L17,18.23L14.56,20.7L13.15,19.29L15.27,17.17L3.37,5.27V2.44H6.2M15.89,10L20.63,5.26V2.44H17.8L13.06,7.18L15.89,10M10.94,15L8.11,12.13L5.9,14.34L3.78,12.22L2.37,13.63L4.84,16.1L1.66,19.29C1.27,19.68 1.27,20.31 1.66,20.7L2.37,21.41C2.76,21.8 3.39,21.8 3.78,21.41L7,18.23L9.44,20.7L10.85,19.29L8.73,17.17L10.94,15Z";
var mdiSyllabaryHangul = "M8 4V6H4V8H6.39C5.55 8.74 5 9.8 5 11C5 13.2 6.8 15 9 15C11.2 15 13 13.2 13 11C13 9.8 12.45 8.74 11.61 8H14V6H10V4M15 4V16H17V11H20V9H17V4M9 9C10.12 9 11 9.88 11 11C11 12.12 10.12 13 9 13C7.88 13 7 12.12 7 11C7 9.88 7.88 9 9 9M7 16V20H17V18H9V16Z";
var mdiSyllabaryHiragana = "M9 4V6H6V8H9V10C6.25 10 4 12.27 4 15.03C4 17.8 6.26 20.06 9.03 20.06C9.89 20.06 10.72 19.77 11.4 19.26C11.63 19.54 11.88 19.82 12.15 20.09L13.56 18.67C13.3 18.42 13.07 18.15 12.86 17.89L13.86 16.89C14.93 15.82 15.78 14.23 16.42 12.59C17.31 13.11 18 13.9 18 15C18 16.32 17.47 17.6 16.54 18.54L17.95 19.95C19.26 18.64 20 16.86 20 15C20 13.04 18.82 11.36 17.15 10.55L17.5 9.29L15.55 8.78L15.21 10.05C15.13 10.05 15.06 10 14.97 10H11V8H16V6H11V4M11 12H14.5C13.94 13.37 13.19 14.72 12.44 15.47L11.79 16.13C11.25 14.93 11 13.59 11 12M9 12C9 14.07 9.41 15.94 10.3 17.59C9.94 17.89 9.5 18.06 9.03 18.06C7.33 18.06 6 16.73 6 15.03C6 13.34 7.32 12 9 12Z";
var mdiSyllabaryKatakana = "M4 4V6H18V6.09L14.29 9.79L15.71 11.21L20 6.91V4M11 9V13C11 15.78 10.25 16.89 8.36 18.46L9.64 20C11.75 18.24 13 16.22 13 13V9Z";
var mdiSyllabaryKatakanaHalfwidth = "M8 4V6H14L13 10.81L15 11.2L16 6.1V4M10 9V12C10 14.86 9.34 17.29 8.08 18.61L9.5 20C11.35 18.08 12 15.15 12 12V9Z";
var mdiSymbol = "M2 7V14H4V7H2M6 7V9H10V11H8V14H10V13C11.11 13 12 12.11 12 11V9C12 7.89 11.11 7 10 7H6M15.8 7L15.6 9H14V11H15.4L15.2 13H14V15H15L14.8 17H16.8L17 15H18.4L18.2 17H20.2L20.4 15H22V13H20.6L20.8 11H22V9H21L21.2 7H19.2L19 9H17.6L17.8 7H15.8M17.4 11H18.8L18.6 13H17.2L17.4 11M2 15V17H4V15H2M8 15V17H10V15H8Z";
var mdiSymfony = "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.37,5.7V5.7C17.39,5.67 18.15,6.13 18.21,6.84C18.22,7.15 18.04,7.75 17.42,7.77C16.95,7.79 16.63,7.5 16.62,7.09C16.61,6.93 16.88,6.42 16.88,6.33C16.87,6.06 16.47,6.05 16.36,6.06C14.86,6.11 14.46,8.13 14.14,9.78L14,10.65C14.84,10.78 15.46,10.62 15.8,10.4C16.28,10.09 15.66,9.77 15.74,9.41C15.82,9.04 16.15,8.87 16.41,8.86C16.78,8.85 17.04,9.23 17.03,9.62C17,10.26 16.17,11.14 14.5,11.1C14.28,11.1 14.09,11.08 13.91,11.06C13.3,14.16 12.92,16 11.56,17.58C10.39,18.97 9.2,19.18 8.67,19.2C7.67,19.24 7,18.71 7,18C6.97,17.32 7.57,16.94 7.97,16.93C8.5,16.91 8.87,17.3 8.88,17.74C8.9,18.11 8.7,18.23 8.57,18.3C8.5,18.37 8.35,18.45 8.36,18.6C8.36,18.67 8.43,18.82 8.65,18.81C9.07,18.8 9.34,18.59 9.54,18.45C10.5,17.65 10.88,16.24 11.37,13.68C11.63,12.23 11.82,11.3 12.1,10.38C11.42,9.87 11,9.23 10.09,9C9.46,8.81 9.08,8.96 8.81,9.3C8.5,9.71 8.6,10.23 8.9,10.54C10.05,11.82 10.39,12.38 10.26,13.14C10.06,14.35 8.62,15.27 6.92,14.75C5.47,14.3 5.2,13.28 5.37,12.71C5.53,12.22 5.92,12.12 6.31,12.24C6.73,12.37 6.89,12.87 6.77,13.26C6.75,13.3 6.55,13.67 6.5,13.79C6.41,14.1 6.83,14.31 7.12,14.4C7.77,14.6 8.4,14.26 8.55,13.73C8.7,13.25 8.4,12.91 8.27,12.78C7.38,11.8 6.76,10.93 7.06,9.95C7.18,9.58 7.42,9.18 7.78,8.91C8.53,8.36 9.35,8.26 10.12,8.5C11.13,8.77 11.61,9.44 12.24,9.95C12.59,8.93 13.08,7.92 13.81,7.07C14.47,6.3 15.35,5.74 16.37,5.7Z";
var mdiSynagogue = "M6 8V21H10V16C10 14.9 10.9 14 12 14S14 14.9 14 16V21H18V8L12 3L6 8M13.5 10C13.5 10.8 12.8 11.5 12 11.5S10.5 10.8 10.5 10 11.2 8.5 12 8.5 13.5 9.2 13.5 10M3 5C1.9 5 1 5.9 1 7V8H5V7C5 5.9 4.1 5 3 5M1 9H5V21H1V9M21 5C19.9 5 19 5.9 19 7V8H23V7C23 5.9 22.1 5 21 5M19 9H23V21H19V9Z";
var mdiSynagogueOutline = "M20 4C18.3 4 17 5.3 17 7V7.3L12 3L7 7.3V7C7 5.3 5.7 4 4 4S1 5.3 1 7V21H11V16C11 15.4 11.4 15 12 15S13 15.4 13 16V21H23V7C23 5.3 21.7 4 20 4M20 6C20.5 6 21 6.4 21 7V8H19V7C19 6.4 19.5 6 20 6M4 6C4.6 6 5 6.4 5 7V8H3V7C3 6.4 3.5 6 4 6M3 19V10H5V19H3M17 19H15V16C15 14.4 13.6 13 12 13S9 14.4 9 16V19H7V9.9L12 5.6L17 9.9V19M19 19V10H21V19H19M12 8.5C12.8 8.5 13.5 9.2 13.5 10S12.8 11.5 12 11.5 10.5 10.8 10.5 10 11.2 8.5 12 8.5Z";
var mdiSync = "M12,18A6,6 0 0,1 6,12C6,11 6.25,10.03 6.7,9.2L5.24,7.74C4.46,8.97 4,10.43 4,12A8,8 0 0,0 12,20V23L16,19L12,15M12,4V1L8,5L12,9V6A6,6 0 0,1 18,12C18,13 17.75,13.97 17.3,14.8L18.76,16.26C19.54,15.03 20,13.57 20,12A8,8 0 0,0 12,4Z";
var mdiSyncAlert = "M11,13H13V7H11M21,4H15V10L17.24,7.76C18.32,8.85 19,10.34 19,12C19,14.61 17.33,16.83 15,17.65V19.74C18.45,18.85 21,15.73 21,12C21,9.79 20.09,7.8 18.64,6.36M11,17H13V15H11M3,12C3,14.21 3.91,16.2 5.36,17.64L3,20H9V14L6.76,16.24C5.68,15.15 5,13.66 5,12C5,9.39 6.67,7.17 9,6.35V4.26C5.55,5.15 3,8.27 3,12Z";
var mdiSyncCircle = "M2 12A10 10 0 1 0 12 2A10 10 0 0 0 2 12M15.6 13.72A4 4 0 0 0 16 12A4 4 0 0 0 12 8V10L8.88 7L12 4V6A6 6 0 0 1 18 12A5.9 5.9 0 0 1 17.07 15.19M6 12A5.9 5.9 0 0 1 6.93 8.81L8.4 10.28A4 4 0 0 0 8 12A4 4 0 0 0 12 16V14L15 17L12 20V18A6 6 0 0 1 6 12Z";
var mdiSyncOff = "M20,4H14V10L16.24,7.76C17.32,8.85 18,10.34 18,12C18,13 17.75,13.94 17.32,14.77L18.78,16.23C19.55,15 20,13.56 20,12C20,9.79 19.09,7.8 17.64,6.36L20,4M2.86,5.41L5.22,7.77C4.45,9 4,10.44 4,12C4,14.21 4.91,16.2 6.36,17.64L4,20H10V14L7.76,16.24C6.68,15.15 6,13.66 6,12C6,11 6.25,10.06 6.68,9.23L14.76,17.31C14.5,17.44 14.26,17.56 14,17.65V19.74C14.79,19.53 15.54,19.2 16.22,18.78L18.58,21.14L19.85,19.87L4.14,4.14L2.86,5.41M10,6.35V4.26C9.2,4.47 8.45,4.8 7.77,5.22L9.23,6.68C9.5,6.56 9.73,6.44 10,6.35Z";
var mdiTab = "M21,3H3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V5A2,2 0 0,0 21,3M21,19H3V5H13V9H21V19Z";
var mdiTabMinus = "M3,3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V5A2,2 0 0,0 21,3H3M3,5H13V9H21V19H3V5M7,13V15H15V13H7Z";
var mdiTabPlus = "M3,3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V5A2,2 0 0,0 21,3H3M3,5H13V9H21V19H3V5M10,10V13H7V15H10V18H12V15H15V13H12V10H10Z";
var mdiTabRemove = "M7.46,11.88L8.88,10.46L11,12.59L13.12,10.46L14.54,11.88L12.41,14L14.54,16.12L13.12,17.54L11,15.41L8.88,17.54L7.46,16.12L9.59,14L7.46,11.88M3,3H21A2,2 0 0,1 23,5V19A2,2 0 0,1 21,21H3A2,2 0 0,1 1,19V5A2,2 0 0,1 3,3M3,5V19H21V9H13V5H3Z";
var mdiTabSearch = "M7.5 11C5 11 3 13 3 15.5C3 16.38 3.25 17.21 3.69 17.9L.61 21L2 22.39L5.12 19.32C5.81 19.75 6.63 20 7.5 20C10 20 12 18 12 15.5S10 11 7.5 11M7.5 18C6.12 18 5 16.88 5 15.5S6.12 13 7.5 13 10 14.12 10 15.5 8.88 18 7.5 18M23 5V19C23 20.11 22.11 21 21 21H10.95C11.76 20.5 12.45 19.81 12.97 19H21V9H13V5H3V10.82C1.77 12 1 13.66 1 15.5V5C1 3.9 1.9 3 3 3H21C22.11 3 23 3.9 23 5Z";
var mdiTabUnselected = "M1,9H3V7H1V9M1,13H3V11H1V13M1,5H3V3A2,2 0 0,0 1,5M9,21H11V19H9V21M1,17H3V15H1V17M3,21V19H1A2,2 0 0,0 3,21M21,3H13V9H23V5A2,2 0 0,0 21,3M21,17H23V15H21V17M9,5H11V3H9V5M5,21H7V19H5V21M5,5H7V3H5V5M21,21A2,2 0 0,0 23,19H21V21M21,13H23V11H21V13M13,21H15V19H13V21M17,21H19V19H17V21Z";
var mdiTable = "M5,4H19A2,2 0 0,1 21,6V18A2,2 0 0,1 19,20H5A2,2 0 0,1 3,18V6A2,2 0 0,1 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z";
var mdiTableAccount = "M4 3H18C19.11 3 20 3.9 20 5V12.08C18.45 11.82 16.92 12.18 15.68 13H12V17H13.08C12.97 17.68 12.97 18.35 13.08 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4M23 22V21C23 19.67 20.33 19 19 19S15 19.67 15 21V22H23M19 14C17.9 14 17 14.9 17 16S17.9 18 19 18 21 17.11 21 16 20.11 14 19 14Z";
var mdiTableAlert = "M3 4H17C18.11 4 19 4.89 19 6V18C19 19.11 18.11 20 17 20H3C1.9 20 1 19.11 1 18V6C1 4.89 1.9 4 3 4M3 8V12H9V8H3M11 8V12H17V8H11M3 14V18H9V14H3M11 14V18H17V14H11M23 7H21V13H23V7M23 15H21V17H23V15Z";
var mdiTableArrowDown = "M4 3H18C19.11 3 20 3.9 20 5V12.08C18.45 11.82 16.92 12.18 15.68 13H12V17H13.08C12.97 17.68 12.97 18.35 13.08 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4M15.94 18.5H17.94V14.5H19.94V18.5H21.94L18.94 21.5L15.94 18.5";
var mdiTableArrowLeft = "M4 3H18C19.11 3 20 3.9 20 5V12.08C18.45 11.82 16.92 12.18 15.68 13H12V17H13.08C12.97 17.68 12.97 18.35 13.08 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4M18.44 15V17H22.44V19H18.44V21L15.44 18L18.44 15";
var mdiTableArrowRight = "M4 3H18C19.11 3 20 3.9 20 5V12.08C18.45 11.82 16.92 12.18 15.68 13H12V17H13.08C12.97 17.68 12.97 18.35 13.08 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4M19.44 21V19H15.44V17H19.44V15L22.44 18L19.44 21";
var mdiTableArrowUp = "M4 3H18C19.11 3 20 3.9 20 5V12.08C18.45 11.82 16.92 12.18 15.68 13H12V17H13.08C12.97 17.68 12.97 18.35 13.08 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4M21.94 17.5H19.94V21.5H17.94V17.5H15.94L18.94 14.5L21.94 17.5";
var mdiTableBorder = "M21,19A1,1 0 0,1 20,20H19V18H21V19M15,20V18H17V20H15M11,20V18H13V20H11M7,20V18H9V20H7M4,20A1,1 0 0,1 3,19V18H5V20H4M19,4H5A2,2 0 0,0 3,6V8H5L11,8H13L19,8H21V6C21,4.89 20.11,4 19,4M5,14H3V16H5V14M5,10H3V12H5V10M21,10H19V12H21V10M21,14H19V16H21V14M11,16V14H13V16H11M11,12V10H13V12H11";
var mdiTableCancel = "M3 3H17C18.11 3 19 3.9 19 5V12.08C17.45 11.82 15.92 12.18 14.68 13H11V17H12.08C11.97 17.68 11.97 18.35 12.08 19H3C1.9 19 1 18.11 1 17V5C1 3.9 1.9 3 3 3M3 7V11H9V7H3M11 7V11H17V7H11M3 13V17H9V13H3M18.5 14C16 14 14 16 14 18.5S16 23 18.5 23 23 21 23 18.5 21 14 18.5 14M18.5 21.5C16.84 21.5 15.5 20.16 15.5 18.5C15.5 17.94 15.65 17.42 15.92 17L20 21.08C19.58 21.35 19.06 21.5 18.5 21.5M21.08 20L17 15.92C17.42 15.65 17.94 15.5 18.5 15.5C20.16 15.5 21.5 16.84 21.5 18.5C21.5 19.06 21.35 19.58 21.08 20Z";
var mdiTableChair = "M12 22H6A2 2 0 0 1 8 20V8H2V5H16V8H10V20A2 2 0 0 1 12 22M22 2V22H20V15H15V22H13V14A2 2 0 0 1 15 12H20V2Z";
var mdiTableCheck = "M4 3H18C19.11 3 20 3.9 20 5V12.08C18.45 11.82 16.92 12.18 15.68 13H12V17H13.08C12.97 17.68 12.97 18.35 13.08 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4M17.75 21L15 18L16.16 16.84L17.75 18.43L21.34 14.84L22.5 16.25L17.75 21";
var mdiTableClock = "M16.5 15.82L18.94 17.23L18.19 18.53L15 16.69V13H16.5V15.82M20 10.26V5C20 3.9 19.11 3 18 3H4C2.9 3 2 3.9 2 5V17C2 18.11 2.9 19 4 19H9.68C10.81 21.36 13.21 23 16 23C19.87 23 23 19.87 23 16C23 13.62 21.81 11.53 20 10.26M18 7V9.29C17.37 9.11 16.7 9 16 9C14.5 9 13.13 9.47 12 10.26V7H18M4 7H10V11H4V7M4 17V13H9.68C9.25 13.91 9 14.93 9 16C9 16.34 9.03 16.67 9.08 17H4M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21Z";
var mdiTableCog = "M3 3H17C18.11 3 19 3.9 19 5V12.08C17.45 11.82 15.92 12.18 14.68 13H11V17H12.08C11.97 17.68 11.97 18.35 12.08 19H3C1.9 19 1 18.11 1 17V5C1 3.9 1.9 3 3 3M3 7V11H9V7H3M11 7V11H17V7H11M3 13V17H9V13H3M22.78 19.32L21.71 18.5C21.73 18.33 21.75 18.17 21.75 18S21.74 17.67 21.71 17.5L22.77 16.68C22.86 16.6 22.89 16.47 22.83 16.36L21.83 14.63C21.77 14.5 21.64 14.5 21.5 14.5L20.28 15C20 14.82 19.74 14.65 19.43 14.53L19.24 13.21C19.23 13.09 19.12 13 19 13H17C16.88 13 16.77 13.09 16.75 13.21L16.56 14.53C16.26 14.66 15.97 14.82 15.71 15L14.47 14.5C14.36 14.5 14.23 14.5 14.16 14.63L13.16 16.36C13.1 16.47 13.12 16.6 13.22 16.68L14.28 17.5C14.26 17.67 14.25 17.83 14.25 18S14.26 18.33 14.28 18.5L13.22 19.32C13.13 19.4 13.1 19.53 13.16 19.64L14.16 21.37C14.22 21.5 14.35 21.5 14.47 21.5L15.71 21C15.97 21.18 16.25 21.35 16.56 21.47L16.75 22.79C16.77 22.91 16.87 23 17 23H19C19.12 23 19.23 22.91 19.25 22.79L19.44 21.47C19.74 21.34 20 21.18 20.28 21L21.5 21.5C21.64 21.5 21.77 21.5 21.84 21.37L22.84 19.64C22.9 19.53 22.87 19.4 22.78 19.32M18 19.5C17.17 19.5 16.5 18.83 16.5 18S17.18 16.5 18 16.5 19.5 17.17 19.5 18 18.84 19.5 18 19.5Z";
var mdiTableColumn = "M8,2H16A2,2 0 0,1 18,4V20A2,2 0 0,1 16,22H8A2,2 0 0,1 6,20V4A2,2 0 0,1 8,2M8,10V14H16V10H8M8,16V20H16V16H8M8,4V8H16V4H8Z";
var mdiTableColumnPlusAfter = "M11,2A2,2 0 0,1 13,4V20A2,2 0 0,1 11,22H2V2H11M4,10V14H11V10H4M4,16V20H11V16H4M4,4V8H11V4H4M15,11H18V8H20V11H23V13H20V16H18V13H15V11Z";
var mdiTableColumnPlusBefore = "M13,2A2,2 0 0,0 11,4V20A2,2 0 0,0 13,22H22V2H13M20,10V14H13V10H20M20,16V20H13V16H20M20,4V8H13V4H20M9,11H6V8H4V11H1V13H4V16H6V13H9V11Z";
var mdiTableColumnRemove = "M4,2H11A2,2 0 0,1 13,4V20A2,2 0 0,1 11,22H4A2,2 0 0,1 2,20V4A2,2 0 0,1 4,2M4,10V14H11V10H4M4,16V20H11V16H4M4,4V8H11V4H4M17.59,12L15,9.41L16.41,8L19,10.59L21.59,8L23,9.41L20.41,12L23,14.59L21.59,16L19,13.41L16.41,16L15,14.59L17.59,12Z";
var mdiTableColumnWidth = "M5,8H19A2,2 0 0,1 21,10V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V10A2,2 0 0,1 5,8M5,12V15H11V12H5M13,12V15H19V12H13M5,17V20H11V17H5M13,17V20H19V17H13M11,2H21V6H19V4H13V6H11V2Z";
var mdiTableEdit = "M21.7,13.35L20.7,14.35L18.65,12.3L19.65,11.3C19.86,11.08 20.21,11.08 20.42,11.3L21.7,12.58C21.92,12.79 21.92,13.14 21.7,13.35M12,18.94L18.07,12.88L20.12,14.93L14.06,21H12V18.94M4,2H18A2,2 0 0,1 20,4V8.17L16.17,12H12V16.17L10.17,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M4,6V10H10V6H4M12,6V10H18V6H12M4,12V16H10V12H4Z";
var mdiTableEye = "M17 16.88C17.56 16.88 18 17.32 18 17.88S17.56 18.88 17 18.88 16 18.43 16 17.88 16.44 16.88 17 16.88M17 13.88C19.73 13.88 22.06 15.54 23 17.88C22.06 20.22 19.73 21.88 17 21.88S11.94 20.22 11 17.88C11.94 15.54 14.27 13.88 17 13.88M17 15.38C15.62 15.38 14.5 16.5 14.5 17.88S15.62 20.38 17 20.38 19.5 19.26 19.5 17.88 18.38 15.38 17 15.38M18 3H4C2.9 3 2 3.9 2 5V17C2 18.1 2.9 19 4 19H9.42C9.26 18.68 9.12 18.34 9 18C9.12 17.66 9.26 17.32 9.42 17H4V13H10V15.97C10.55 15.11 11.23 14.37 12 13.76V13H13.15C14.31 12.36 15.62 12 17 12C18.06 12 19.07 12.21 20 12.59V5C20 3.9 19.1 3 18 3M10 11H4V7H10V11M18 11H12V7H18V11Z";
var mdiTableEyeOff = "M12 8.8L6.2 3H18C19.1 3 20 3.9 20 5V12.59C19.07 12.21 18.06 12 17 12C16.45 12 15.91 12.07 15.38 12.18L14.2 11H18V7H12V8.8M17.09 13.89L22.31 19.11C22.58 18.73 22.82 18.32 23 17.88C22.07 15.57 19.78 13.92 17.09 13.89M22.11 21.46L20.84 22.73L19.5 21.37C18.71 21.69 17.88 21.88 17 21.88C14.27 21.88 11.94 20.22 11 17.88C11.45 16.76 12.23 15.8 13.21 15.1L11.93 13.82C11.19 14.42 10.53 15.14 10 15.97V13H4V17H9.42C9.26 17.32 9.12 17.66 9 18C9.12 18.34 9.26 18.68 9.42 19H4C2.9 19 2 18.1 2 17V5C2 4.68 2.08 4.38 2.22 4.11L1.11 3L2.39 1.73L22.11 21.46M9.11 11L5.11 7H4V11H9.11M18.18 20.07L14.81 16.7C14.61 17.05 14.5 17.45 14.5 17.88C14.5 19.26 15.62 20.38 17 20.38C17.43 20.38 17.83 20.27 18.18 20.07Z";
var mdiTableFilter = "M17 21L18.8 22.77C19.3 23.27 20 22.87 20 22.28V18L22.8 14.6C23.3 13.9 22.8 13 22 13H15C14.2 13 13.7 14 14.2 14.6L17 18V21M12 11H20V3C20 1.9 19.11 1 18 1H4C2.9 1 2 1.9 2 3V15C2 16.11 2.9 17 4 17H13.42L12 15V11M12 5H18V9H12V5M10 15H4V11H10V15M10 9H4V5H10V9Z";
var mdiTableFurniture = "M2 7H22V10H20L21 19H18.5L17.94 14H6.06L5.5 19H3L4 10H2V7M17.5 10H6.5L6.29 12H17.71L17.5 10Z";
var mdiTableHeadersEye = "M1 6V19A2 2 0 0 0 3 21H9V11H21V6A2 2 0 0 0 19 4H3A2 2 0 0 0 1 6M3 6H7V9H3M7 19H3V16H7M7 14H3V11H7M9 9V6H13V9M19 9H15V6H19M17 16A1 1 0 1 1 16 17A1 1 0 0 1 17 16M17 13A6.45 6.45 0 0 1 23 17A6.5 6.5 0 0 1 11 17A6.45 6.45 0 0 1 17 13M17 14.5A2.5 2.5 0 1 0 19.5 17A2.5 2.5 0 0 0 17 14.5";
var mdiTableHeadersEyeOff = "M2.38 1.73L1.11 3L2.26 4.15A2 2 0 0 0 1 6V19A2 2 0 0 0 3 21H9V11H9.11L12.72 14.61A6.21 6.21 0 0 0 11 17A6.45 6.45 0 0 0 17 21A6.55 6.55 0 0 0 18.84 20.73L20.84 22.73L22.11 21.46L20.58 19.93M7 19H3V16H7M7 14H3V11H7M7 9H3V6H4.11L7 8.89M17 19.5A2.5 2.5 0 0 1 14.56 16.45L17.56 19.45A2.5 2.5 0 0 1 17 19.5M16.24 13L17.85 14.61A2.5 2.5 0 0 1 19.35 16.11L21.94 18.7A6.44 6.44 0 0 0 23 17A6.45 6.45 0 0 0 17 13H16.24M13 6V9H12.2L14.2 11H21V6A2 2 0 0 0 19 4H7.2L9.2 6M15 6H19V9H15Z";
var mdiTableHeart = "M4 3H18C19.11 3 20 3.9 20 5V12.08C18.45 11.82 16.92 12.18 15.68 13H12V17H13.08C12.97 17.68 12.97 18.35 13.08 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4M19 22.3L18.4 21.8C16.4 19.9 15 18.7 15 17.2C15 16 16 15 17.2 15C17.9 15 18.6 15.3 19 15.8C19.4 15.3 20.1 15 20.8 15C22 15 23 15.9 23 17.2C23 18.7 21.6 19.9 19.6 21.8L19 22.3";
var mdiTableKey = "M16.8 17C16.4 15.8 15.3 15 14 15C12.3 15 11 16.3 11 18S12.3 21 14 21C15.3 21 16.4 20.2 16.8 19H19V21H21V19H23V17H16.8M14 19C13.4 19 13 18.5 13 18S13.4 17 14 17 15 17.5 15 18 14.6 19 14 19M9 18H4V14H10V15C10.9 13.8 12.4 13 14 13C15.1 13 16.1 13.4 17 14H18V15H20V6C20 4.9 19.1 4 18 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H9.4C9.1 19.4 9 18.7 9 18M12 8H18V12H12V8M4 8H10V12H4V8Z";
var mdiTableLarge = "M4,3H20A2,2 0 0,1 22,5V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V5A2,2 0 0,1 4,3M4,7V10H8V7H4M10,7V10H14V7H10M20,10V7H16V10H20M4,12V15H8V12H4M4,20H8V17H4V20M10,12V15H14V12H10M10,20H14V17H10V20M20,20V17H16V20H20M20,12H16V15H20V12Z";
var mdiTableLargePlus = "M12.35 20H10V17H12.09C12.21 16.28 12.46 15.61 12.81 15H10V12H14V13.54C14.58 13 15.25 12.61 16 12.35V12H20V12.35C20.75 12.61 21.42 13 22 13.54V5C22 3.9 21.1 3 20 3H4C2.9 3 2 3.9 2 5V20C2 21.1 2.9 22 4 22H13.54C13 21.42 12.61 20.75 12.35 20M16 7H20V10H16V7M10 7H14V10H10V7M8 20H4V17H8V20M8 15H4V12H8V15M8 10H4V7H8V10M17 14H19V17H22V19H19V22H17V19H14V17H17V14";
var mdiTableLargeRemove = "M12.35 20H10V17H12.09C12.21 16.28 12.46 15.61 12.81 15H10V12H14V13.54C14.58 13 15.25 12.61 16 12.35V12H20V12.35C20.75 12.61 21.42 13 22 13.54V5C22 3.9 21.1 3 20 3H4C2.9 3 2 3.9 2 5V20C2 21.1 2.9 22 4 22H13.54C13 21.42 12.61 20.75 12.35 20M16 7H20V10H16V7M10 7H14V10H10V7M8 20H4V17H8V20M8 15H4V12H8V15M8 10H4V7H8V10M14.46 15.88L15.88 14.46L18 16.59L20.12 14.46L21.54 15.88L19.41 18L21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.46 20.12L16.59 18L14.46 15.88";
var mdiTableLock = "M21 16V15.5C21 14.12 19.88 13 18.5 13S16 14.12 16 15.5V16C15.45 16 15 16.45 15 17V21C15 21.55 15.45 22 16 22H21C21.55 22 22 21.55 22 21V17C22 16.45 21.55 16 21 16M20 16H17V15.5C17 14.67 17.67 14 18.5 14S20 14.67 20 15.5V16M13 18H12V14H14.26C14.54 13.21 15.04 12.5 15.69 12H12V8H18V11.05C18.17 11.03 18.33 11 18.5 11C19.03 11 19.53 11.1 20 11.26V6C20 4.89 19.11 4 18 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13V18M10 18H4V14H10V18M10 12H4V8H10V12Z";
var mdiTableMergeCells = "M5,10H3V4H11V6H5V10M19,18H13V20H21V14H19V18M5,18V14H3V20H11V18H5M21,4H13V6H19V10H21V4M8,13V15L11,12L8,9V11H3V13H8M16,11V9L13,12L16,15V13H21V11H16Z";
var mdiTableMinus = "M15 19V17H23V19H15M4 3H18C19.11 3 20 3.9 20 5V12.08C18.45 11.82 16.92 12.18 15.68 13H12V17H13.08C12.97 17.68 12.97 18.35 13.08 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4Z";
var mdiTableMultiple = "M7 2H21C22.11 2 23 2.9 23 4V16C23 17.11 22.11 18 21 18H7C5.9 18 5 17.11 5 16V4C5 2.9 5.9 2 7 2M7 6V10H13V6H7M15 6V10H21V6H15M7 12V16H13V12H7M15 12V16H21V12H15M3 20V6H1V20C1 21.11 1.89 22 3 22H19V20H3Z";
var mdiTableNetwork = "M15 20C15 19.45 14.55 19 14 19H13V17H19C20.11 17 21 16.11 21 15V3C21 1.9 20.11 1 19 1H5C3.9 1 3 1.9 3 3V15C3 16.11 3.9 17 5 17H11V19H10C9.45 19 9 19.45 9 20H2V22H9C9 22.55 9.45 23 10 23H14C14.55 23 15 22.55 15 22H22V20H15M13 5H19V9H13V5M13 11H19V15H13V11M5 5H11V9H5V5M5 15V11H11V15H5Z";
var mdiTableOfContents = "M3,9H17V7H3V9M3,13H17V11H3V13M3,17H17V15H3V17M19,17H21V15H19V17M19,7V9H21V7H19M19,13H21V11H19V13Z";
var mdiTableOff = "M22.11 21.46L2.39 1.73L1.11 3L3.22 5.11C3.08 5.38 3 5.68 3 6V18C3 19.11 3.9 20 5 20H18.11L20.84 22.73L22.11 21.46M10.11 12H5V8H6.11L10.11 12M11 18H5V14H11V18M13 18V14.89L16.11 18H13M13 9.8L7.2 4H19C20.11 4 21 4.89 21 6V17.8L19 15.8V14H17.2L15.2 12H19V8H13V9.8Z";
var mdiTablePicnic = "M4 6H20V9H18L18.22 11H23V13H18.44L19 18H16.5L15.94 13H8.06L7.5 18H5L5.56 13H1V11H5.78L6 9H4M15.5 9H8.5L8.29 11H15.71Z";
var mdiTablePivot = "M22 15H20V18C20 19.11 19.11 20 18 20H15V22L12 19L15 16V18H18V15H16L19 12L22 15M22 4V8C22 9.1 21.1 10 20 10H10V20C10 21.1 9.1 22 8 22H4C2.9 22 2 21.1 2 20V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4M4 8H8V4H4V8M4 10V14H8V10H4M8 20V16H4V20L8 20M14 8V4H10V8H14M20 4L20 4H16V8H20L20 4Z";
var mdiTablePlus = "M18,14H20V17H23V19H20V22H18V19H15V17H18V14M4,3H18A2,2 0 0,1 20,5V12.08C18.45,11.82 16.92,12.18 15.68,13H12V17H13.08C12.97,17.68 12.97,18.35 13.08,19H4A2,2 0 0,1 2,17V5A2,2 0 0,1 4,3M4,7V11H10V7H4M12,7V11H18V7H12M4,13V17H10V13H4Z";
var mdiTableQuestion = "M19.5 20.5V22H18V20.5H19.5M17.5 15.5H16V15C16 13.34 17.34 12 19 12S22 13.34 22 15C22 15.97 21.5 16.88 20.71 17.41L20.41 17.6C19.84 18 19.5 18.61 19.5 19.3V19.5H18V19.3C18 18.11 18.6 17 19.59 16.35L19.88 16.16C20.27 15.9 20.5 15.47 20.5 15C20.5 14.17 19.83 13.5 19 13.5S17.5 14.17 17.5 15V15.5M18 3H4C2.9 3 2 3.9 2 5V17C2 18.1 2.9 19 4 19H14V17H12V13H14.42C14.78 12.2 15.34 11.5 16.03 11H12V7H18V10.1C18.32 10.04 18.66 10 19 10S19.68 10.04 20 10.1V5C20 3.9 19.11 3 18 3M10 17H4V13H10V17M10 11H4V7H10V11Z";
var mdiTableRefresh = "M18 14.5C19.11 14.5 20.11 14.95 20.83 15.67L22 14.5V18.5H18L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5C15.5 19.88 16.62 21 18 21C18.82 21 19.55 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5C14 16.29 15.79 14.5 18 14.5M4 3H18C19.11 3 20 3.9 20 5V12.17C19.5 12.06 19 12 18.5 12C17.23 12 16.04 12.37 15.04 13H12V17H12.18C12.06 17.5 12 18 12 18.5L12 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4Z";
var mdiTableRemove = "M15.46,15.88L16.88,14.46L19,16.59L21.12,14.46L22.54,15.88L20.41,18L22.54,20.12L21.12,21.54L19,19.41L16.88,21.54L15.46,20.12L17.59,18L15.46,15.88M4,3H18A2,2 0 0,1 20,5V12.08C18.45,11.82 16.92,12.18 15.68,13H12V17H13.08C12.97,17.68 12.97,18.35 13.08,19H4A2,2 0 0,1 2,17V5A2,2 0 0,1 4,3M4,7V11H10V7H4M12,7V11H18V7H12M4,13V17H10V13H4Z";
var mdiTableRow = "M22,14A2,2 0 0,1 20,16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8H20A2,2 0 0,1 22,10V14M4,14H8V10H4V14M10,14H14V10H10V14M16,14H20V10H16V14Z";
var mdiTableRowHeight = "M3,5H15A2,2 0 0,1 17,7V17A2,2 0 0,1 15,19H3A2,2 0 0,1 1,17V7A2,2 0 0,1 3,5M3,9V12H8V9H3M10,9V12H15V9H10M3,14V17H8V14H3M10,14V17H15V14H10M23,14V7H19V9H21V12H19V14H23Z";
var mdiTableRowPlusAfter = "M22,10A2,2 0 0,1 20,12H4A2,2 0 0,1 2,10V3H4V5H8V3H10V5H14V3H16V5H20V3H22V10M4,10H8V7H4V10M10,10H14V7H10V10M20,10V7H16V10H20M11,14H13V17H16V19H13V22H11V19H8V17H11V14Z";
var mdiTableRowPlusBefore = "M22,14A2,2 0 0,0 20,12H4A2,2 0 0,0 2,14V21H4V19H8V21H10V19H14V21H16V19H20V21H22V14M4,14H8V17H4V14M10,14H14V17H10V14M20,14V17H16V14H20M11,10H13V7H16V5H13V2H11V5H8V7H11V10Z";
var mdiTableRowRemove = "M9.41,13L12,15.59L14.59,13L16,14.41L13.41,17L16,19.59L14.59,21L12,18.41L9.41,21L8,19.59L10.59,17L8,14.41L9.41,13M22,9A2,2 0 0,1 20,11H4A2,2 0 0,1 2,9V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V9M4,9H8V6H4V9M10,9H14V6H10V9M16,9H20V6H16V9Z";
var mdiTableSearch = "M19.3,17.89C20.62,15.79 20,13 17.89,11.68C15.79,10.36 13,11 11.68,13.09C10.36,15.2 11,18 13.09,19.3C14.56,20.22 16.42,20.22 17.89,19.3L21,22.39L22.39,21L19.3,17.89M17.3,17.27C16.32,18.25 14.74,18.24 13.76,17.27C12.79,16.29 12.79,14.71 13.77,13.73C14.74,12.76 16.32,12.76 17.3,13.73C18.26,14.72 18.25,16.3 17.27,17.27H17.3M19,4H5A2,2 0 0,0 3,6V18A2,2 0 0,0 5,20H10.81C10.25,19.42 9.8,18.74 9.5,18H5V14H9.18C9.34,13.29 9.61,12.61 10,12H5V8H11V10.81C11.58,10.25 12.26,9.8 13,9.5V8H19V10C19.4,10.25 19.77,10.55 20.1,10.88C20.44,11.22 20.74,11.59 21,12V6A2,2 0 0,0 19,4Z";
var mdiTableSettings = "M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22M5,4H19A2,2 0 0,1 21,6V18A2,2 0 0,1 19,20H5A2,2 0 0,1 3,18V6A2,2 0 0,1 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z";
var mdiTableSplitCell = "M19 14H21V20H3V14H5V18H19V14M3 4V10H5V6H19V10H21V4H3M11 11V13H8V15L5 12L8 9V11H11M16 11V9L19 12L16 15V13H13V11H16Z";
var mdiTableStar = "M4 3H18C19.11 3 20 3.9 20 5V12.08C18.45 11.82 16.92 12.18 15.68 13H12V17H13.08C12.97 17.68 12.97 18.35 13.08 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4M16.5 21.6L17.2 18.8L15 16.9L17.9 16.7L19 14L20.1 16.6L23 16.8L20.8 18.7L21.5 21.5L19 20.1L16.5 21.6Z";
var mdiTableSync = "M19 12V13.5C21.21 13.5 23 15.29 23 17.5C23 18.32 22.76 19.08 22.33 19.71L21.24 18.62C21.41 18.28 21.5 17.9 21.5 17.5C21.5 16.12 20.38 15 19 15V16.5L16.75 14.25L19 12M19 23V21.5C16.79 21.5 15 19.71 15 17.5C15 16.68 15.25 15.92 15.67 15.29L16.76 16.38C16.59 16.72 16.5 17.1 16.5 17.5C16.5 18.88 17.62 20 19 20V18.5L21.25 20.75L19 23M4 3H18C19.11 3 20 3.9 20 5V11L19.5 11C17.66 11 16 11.77 14.81 13H12V17H13L13 17.5C13 18 13.06 18.5 13.17 19H4C2.9 19 2 18.11 2 17V5C2 3.9 2.9 3 4 3M4 7V11H10V7H4M12 7V11H18V7H12M4 13V17H10V13H4Z";
var mdiTableTennis = "M18.5,14C19.9,14 21,15.1 21,16.5C21,17.9 19.9,19 18.5,19C17.1,19 16,17.9 16,16.5C16,15.1 17.1,14 18.5,14M7,15C7,15 8,16 8,17V20.5C8,21.3 8.7,22 9.5,22C10.3,22 11,21.3 11,20.5V17C11,16 12,15 12,15H7M8,14H11C11,14 16,14 16,9C16,4 12,2 9.5,2C7,2 3,4 3,9C3,14 8,14 8,14Z";
var mdiTablet = "M19,18H5V6H19M21,4H3C1.89,4 1,4.89 1,6V18A2,2 0 0,0 3,20H21A2,2 0 0,0 23,18V6C23,4.89 22.1,4 21,4Z";
var mdiTabletCellphone = "M3,4H20A2,2 0 0,1 22,6V8H18V6H5V18H14V20H3A2,2 0 0,1 1,18V6A2,2 0 0,1 3,4M17,10H23A1,1 0 0,1 24,11V21A1,1 0 0,1 23,22H17A1,1 0 0,1 16,21V11A1,1 0 0,1 17,10M18,12V19H22V12H18Z";
var mdiTabletDashboard = "M19,18H5V6H19M21,4H3C1.89,4 1,4.89 1,6V18A2,2 0 0,0 3,20H21A2,2 0 0,0 23,18V6C23,4.89 22.1,4 21,4M7,8H13V13H7V8M14,8H17V10H14V8M17,11V16H14V11H17M7,14H13V16H7V14Z";
var mdiTaco = "M19,18H5A4,4 0 0,1 1,14A8,8 0 0,1 9,6C10.06,6 11.07,6.21 12,6.58C12.93,6.21 13.94,6 15,6A8,8 0 0,1 23,14A4,4 0 0,1 19,18M3,14A2,2 0 0,0 5,16A2,2 0 0,0 7,14C7,11.63 8.03,9.5 9.67,8.04L9,8A6,6 0 0,0 3,14M19,16A2,2 0 0,0 21,14A6,6 0 0,0 15,8A6,6 0 0,0 9,14C9,14.73 8.81,15.41 8.46,16H19Z";
var mdiTag = "M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M21.41,11.58L12.41,2.58C12.05,2.22 11.55,2 11,2H4C2.89,2 2,2.89 2,4V11C2,11.55 2.22,12.05 2.59,12.41L11.58,21.41C11.95,21.77 12.45,22 13,22C13.55,22 14.05,21.77 14.41,21.41L21.41,14.41C21.78,14.05 22,13.55 22,13C22,12.44 21.77,11.94 21.41,11.58Z";
var mdiTagArrowDown = "M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.41L3 12.81C3.9 12.27 4.94 12 6 12C9.31 12 12 14.69 12 18C12 19.06 11.72 20.09 11.18 21L11.58 21.4C11.95 21.78 12.47 22 13 22S14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13S21.79 11.96 21.41 11.58M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7M7 19V15H5V19H3L6 22L9 19H7Z";
var mdiTagArrowDownOutline = "M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.42L3 12.82C3.64 12.44 4.35 12.19 5.08 12.08L4 11V4H11L20 13L13 20L11.92 18.92C11.82 19.66 11.56 20.36 11.18 21L11.59 21.41C11.96 21.79 12.47 22 13 22C13.53 22 14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13C22 12.47 21.79 11.96 21.41 11.58M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M8 18V14H6V18H4L7 21L10 18H8Z";
var mdiTagArrowLeft = "M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.41L3 12.81C3.9 12.27 4.94 12 6 12C9.31 12 12 14.69 12 18C12 19.06 11.72 20.09 11.18 21L11.58 21.4C11.95 21.78 12.47 22 13 22S14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13S21.79 11.96 21.41 11.58M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7M5 19H9V17H5V15L2 18L5 21V19Z";
var mdiTagArrowLeftOutline = "M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.42L3 12.82C3.64 12.44 4.35 12.19 5.08 12.08L4 11V4H11L20 13L13 20L11.92 18.92C11.82 19.66 11.56 20.36 11.18 21L11.59 21.41C11.96 21.79 12.47 22 13 22C13.53 22 14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13C22 12.47 21.79 11.96 21.41 11.58M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M5 19H9V17H5V15L2 18L5 21V19Z";
var mdiTagArrowRight = "M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.41L3 12.81C3.9 12.27 4.94 12 6 12C9.31 12 12 14.69 12 18C12 19.06 11.72 20.09 11.18 21L11.58 21.4C11.95 21.78 12.47 22 13 22S14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13S21.79 11.96 21.41 11.58M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7M6 17H2V19H6V21L9 18L6 15V17Z";
var mdiTagArrowRightOutline = "M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.42L3 12.82C3.64 12.44 4.35 12.19 5.08 12.08L4 11V4H11L20 13L13 20L11.92 18.92C11.82 19.66 11.56 20.36 11.18 21L11.59 21.41C11.96 21.79 12.47 22 13 22C13.53 22 14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13C22 12.47 21.79 11.96 21.41 11.58M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M6 17H2V19H6V21L9 18L6 15V17Z";
var mdiTagArrowUp = "M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.41L3 12.81C3.9 12.27 4.94 12 6 12C9.31 12 12 14.69 12 18C12 19.06 11.72 20.09 11.18 21L11.58 21.4C11.95 21.78 12.47 22 13 22S14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13S21.79 11.96 21.41 11.58M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7M5 17V21H7V17H9L6 14L3 17H5Z";
var mdiTagArrowUpOutline = "M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.42L3 12.82C3.64 12.44 4.35 12.19 5.08 12.08L4 11V4H11L20 13L13 20L11.92 18.92C11.82 19.66 11.56 20.36 11.18 21L11.59 21.41C11.96 21.79 12.47 22 13 22C13.53 22 14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13C22 12.47 21.79 11.96 21.41 11.58M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M6 17V21H8V17H10L7 14L4 17H6Z";
var mdiTagCheck = "M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.41L3 12.81C3.9 12.27 4.94 12 6 12C9.31 12 12 14.69 12 18C12 19.06 11.72 20.09 11.18 21L11.58 21.4C11.95 21.78 12.47 22 13 22S14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13S21.79 11.96 21.41 11.58M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7M8.63 14.27L4.76 18.17L3.41 16.8L2 18.22L4.75 21L10.03 15.68L8.63 14.27";
var mdiTagCheckOutline = "M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.42L3 12.82C3.64 12.44 4.35 12.19 5.08 12.08L4 11V4H11L20 13L13 20L11.92 18.92C11.82 19.66 11.56 20.36 11.18 21L11.59 21.41C11.96 21.79 12.47 22 13 22C13.53 22 14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13C22 12.47 21.79 11.96 21.41 11.58M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M8.63 14.27L4.76 18.17L3.41 16.8L2 18.22L4.75 21L10.03 15.68L8.63 14.27";
var mdiTagEdit = "M12.41 2.58L21.41 11.58C21.77 11.94 22 12.44 22 13C22 13.55 21.78 14.05 21.41 14.41L14.41 21.41C14.05 21.77 13.55 22 13 22C12.45 22 11.95 21.77 11.58 21.41L9.45 19.28L10.7 18.03L10.7 18.04L13.11 15.62C14.11 14.63 14.11 13 13.11 12L11.83 10.74C10.84 9.75 9.23 9.75 8.24 10.74L8.07 10.91L8.06 10.91L4.57 14.4L2.59 12.41C2.22 12.05 2 11.55 2 11V4C2 2.89 2.89 2 4 2H11C11.55 2 12.05 2.22 12.41 2.58M4.44 6.56C4.72 6.84 5.1 7 5.5 7C5.9 7 6.28 6.84 6.56 6.56C6.84 6.28 7 5.9 7 5.5C7 5.1 6.84 4.72 6.56 4.44C6.28 4.16 5.9 4 5.5 4C5.1 4 4.72 4.16 4.44 4.44C4.16 4.72 4 5.1 4 5.5C4 5.9 4.16 6.28 4.44 6.56M10.7 15.35L11.7 14.35C11.91 14.14 11.91 13.79 11.7 13.58L10.42 12.3C10.21 12.09 9.86 12.09 9.65 12.3L8.65 13.3L10.7 15.35M8.06 13.88L2 19.94V22H4.06L10.11 15.93L8.06 13.88Z";
var mdiTagEditOutline = "M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C3.47 2 2.96 2.21 2.59 2.59C2.21 2.96 2 3.47 2 4V11C2 11.26 2.05 11.53 2.15 11.77C2.25 12 2.4 12.23 2.59 12.42L4.57 14.4L6 13L4 11V4H11L20 13L13 20L10.87 17.87L10.7 18.04L10.7 18.03L9.45 19.28L11.59 21.42C11.97 21.79 12.47 22 13 22C13.53 22 14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13C22 12.74 21.95 12.5 21.85 12.23C21.75 12 21.6 11.77 21.41 11.58M6.5 5C6.8 5 7.09 5.09 7.33 5.25C7.58 5.42 7.77 5.65 7.89 5.93C8 6.2 8.03 6.5 7.97 6.79C7.91 7.08 7.77 7.35 7.56 7.56C7.35 7.77 7.08 7.91 6.79 7.97C6.5 8.03 6.2 8 5.93 7.89C5.65 7.77 5.42 7.58 5.25 7.33C5.09 7.09 5 6.8 5 6.5C5 6.1 5.16 5.72 5.44 5.44C5.72 5.16 6.1 5 6.5 5M10.7 15.35L11.7 14.35C11.91 14.14 11.91 13.79 11.7 13.58L10.42 12.3C10.21 12.09 9.86 12.09 9.65 12.3L8.65 13.3L10.7 15.35M8.06 13.88L2 19.94V22H4.06L10.11 15.93L8.06 13.88Z";
var mdiTagFaces = "M15,18C11.68,18 9,15.31 9,12C9,8.68 11.68,6 15,6A6,6 0 0,1 21,12A6,6 0 0,1 15,18M4,13A1,1 0 0,1 3,12A1,1 0 0,1 4,11A1,1 0 0,1 5,12A1,1 0 0,1 4,13M22,3H7.63C6.97,3 6.38,3.32 6,3.81L0,12L6,20.18C6.38,20.68 6.97,21 7.63,21H22A2,2 0 0,0 24,19V5C24,3.89 23.1,3 22,3M13,11A1,1 0 0,0 14,10A1,1 0 0,0 13,9A1,1 0 0,0 12,10A1,1 0 0,0 13,11M15,16C16.86,16 18.35,14.72 18.8,13H11.2C11.65,14.72 13.14,16 15,16M17,11A1,1 0 0,0 18,10A1,1 0 0,0 17,9A1,1 0 0,0 16,10A1,1 0 0,0 17,11Z";
var mdiTagHeart = "M21.41,11.58L12.41,2.58C12.05,2.22 11.55,2 11,2H4A2,2 0 0,0 2,4V11C2,11.55 2.22,12.05 2.59,12.42L11.59,21.42C11.95,21.78 12.45,22 13,22C13.55,22 14.05,21.78 14.41,21.41L21.41,14.41C21.78,14.05 22,13.55 22,13C22,12.45 21.77,11.94 21.41,11.58M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M17.27,15.27L13,19.54L8.73,15.27C8.28,14.81 8,14.19 8,13.5A2.5,2.5 0 0,1 10.5,11C11.19,11 11.82,11.28 12.27,11.74L13,12.46L13.73,11.73C14.18,11.28 14.81,11 15.5,11A2.5,2.5 0 0,1 18,13.5C18,14.19 17.72,14.82 17.27,15.27Z";
var mdiTagHeartOutline = "M4,2A2,2 0 0,0 2,4V11C2,11.55 2.22,12.05 2.59,12.42L11.59,21.42C11.95,21.78 12.45,22 13,22C13.55,22 14.05,21.78 14.41,21.41L21.41,14.41C21.78,14.05 22,13.55 22,13C22,12.45 21.77,11.94 21.41,11.58L12.41,2.58C12.05,2.22 11.55,2 11,2H4V2M11,4L20,13L13,20L4,11V4H11V4H11M6.5,5A1.5,1.5 0 0,0 5,6.5A1.5,1.5 0 0,0 6.5,8A1.5,1.5 0 0,0 8,6.5A1.5,1.5 0 0,0 6.5,5M10.95,10.5C9.82,10.5 8.9,11.42 8.9,12.55C8.9,13.12 9.13,13.62 9.5,14L13,17.5L16.5,14C16.87,13.63 17.1,13.11 17.1,12.55A2.05,2.05 0 0,0 15.05,10.5C14.5,10.5 13.97,10.73 13.6,11.1L13,11.7L12.4,11.11C12.03,10.73 11.5,10.5 10.95,10.5Z";
var mdiTagHidden = "M13.64 3.81L12.41 2.58C12.04 2.21 11.53 2 11 2H10V4H11L12.23 5.23L13.64 3.81M12.93 5.93L14.35 4.5L16.47 6.64L15.05 8.05L12.93 5.93M4 11L5.23 12.23L3.81 13.64L2.59 12.42C2.4 12.23 2.25 12 2.15 11.77C2.05 11.53 2 11.26 2 11V10H4V11M4.5 14.35L5.93 12.93L8.05 15.05L6.64 16.47L4.5 14.35M9.47 19.3L7.35 17.18L8.76 15.76L10.88 17.88L9.47 19.3M15.76 8.76L17.88 10.88L19.3 9.47L17.18 7.35L15.76 8.76M18.59 11.59L20 10.17L21.41 11.58C21.6 11.77 21.75 12 21.85 12.23C21.95 12.5 22 12.74 22 13C22 13.53 21.79 14.04 21.41 14.41L18.59 11.59M20.7 15.12L19.29 13.71L16.85 16.15L18.26 17.56L20.7 15.12M16.15 16.85L17.56 18.26L15.12 20.7L13.71 19.29L16.15 16.85M14.41 21.41L11.59 18.59L10.17 20L11.59 21.42C11.97 21.79 12.47 22 13 22C13.53 22 14.04 21.79 14.41 21.41M4 9H2V6H4V9M2 5H4V4H5V2H4C3.47 2 2.96 2.21 2.59 2.59C2.21 2.96 2 3.47 2 4V5M6 4V2H9V4H6M6.5 8C7.33 8 8 7.33 8 6.5C8 5.67 7.33 5 6.5 5C5.67 5 5 5.67 5 6.5C5 7.33 5.67 8 6.5 8Z";
var mdiTagMinus = "M21.41,11.58L12.41,2.58C12.04,2.21 11.53,2 11,2H4A2,2 0 0,0 2,4V11C2,11.53 2.21,12.04 2.59,12.41L3,12.81C3.9,12.27 4.94,12 6,12A6,6 0 0,1 12,18C12,19.06 11.72,20.09 11.18,21L11.58,21.4C11.95,21.78 12.47,22 13,22C13.53,22 14.04,21.79 14.41,21.41L21.41,14.41C21.79,14.04 22,13.53 22,13C22,12.47 21.79,11.96 21.41,11.58M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M10,19H2V17H10V19Z";
var mdiTagMinusOutline = "M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.53 2.21 12.04 2.59 12.42L3 12.82C3.64 12.44 4.35 12.19 5.08 12.08L4 11V4H11L20 13L13 20L11.92 18.92C11.82 19.66 11.56 20.36 11.18 21L11.59 21.41C11.96 21.79 12.47 22 13 22C13.53 22 14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13C22 12.47 21.79 11.96 21.41 11.58M6.5 5C5.67 5 5 5.67 5 6.5S5.67 8 6.5 8 8 7.33 8 6.5 7.33 5 6.5 5M10 19H2V17H10V19Z";
var mdiTagMultiple = "M5.5,9A1.5,1.5 0 0,0 7,7.5A1.5,1.5 0 0,0 5.5,6A1.5,1.5 0 0,0 4,7.5A1.5,1.5 0 0,0 5.5,9M17.41,11.58C17.77,11.94 18,12.44 18,13C18,13.55 17.78,14.05 17.41,14.41L12.41,19.41C12.05,19.77 11.55,20 11,20C10.45,20 9.95,19.78 9.58,19.41L2.59,12.42C2.22,12.05 2,11.55 2,11V6C2,4.89 2.89,4 4,4H9C9.55,4 10.05,4.22 10.41,4.58L17.41,11.58M13.54,5.71L14.54,4.71L21.41,11.58C21.78,11.94 22,12.45 22,13C22,13.55 21.78,14.05 21.42,14.41L16.04,19.79L15.04,18.79L20.75,13L13.54,5.71Z";
var mdiTagMultipleOutline = "M6.5 10C7.3 10 8 9.3 8 8.5S7.3 7 6.5 7 5 7.7 5 8.5 5.7 10 6.5 10M9 6L16 13L11 18L4 11V6H9M9 4H4C2.9 4 2 4.9 2 6V11C2 11.6 2.2 12.1 2.6 12.4L9.6 19.4C9.9 19.8 10.4 20 11 20S12.1 19.8 12.4 19.4L17.4 14.4C17.8 14 18 13.5 18 13C18 12.4 17.8 11.9 17.4 11.6L10.4 4.6C10.1 4.2 9.6 4 9 4M13.5 5.7L14.5 4.7L21.4 11.6C21.8 12 22 12.5 22 13S21.8 14.1 21.4 14.4L16 19.8L15 18.8L20.7 13L13.5 5.7Z";
var mdiTagOff = "M18.33 8.5L22.92 3.92L21.5 2.5L2.5 21.5L3.92 22.92L8.5 18.33L11.58 21.41A2 2 0 0 0 13 22A2 2 0 0 0 14.41 21.41L21.41 14.41A2 2 0 0 0 22 13A2 2 0 0 0 21.41 11.58M5.61 15.43L15.47 5.65L12.41 2.58A2 2 0 0 0 11 2H4A2 2 0 0 0 2 4V11A2 2 0 0 0 2.59 12.41M5.5 4A1.5 1.5 0 1 1 4 5.5A1.5 1.5 0 0 1 5.5 4Z";
var mdiTagOffOutline = "M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5M18.33 8.5L22.92 3.92L21.5 2.5L2.5 21.5L3.92 22.92L8.5 18.33L11.59 21.42A2 2 0 0 0 13 22A2 2 0 0 0 14.41 21.41L21.41 14.41A2 2 0 0 0 22 13A2 2 0 0 0 21.41 11.58M13 20L9.92 16.92L16.92 9.92L20 13M5.61 15.43L7 14L4 11V4H11L14.06 7.06L15.47 5.66L12.41 2.58A2 2 0 0 0 11 2H4A2 2 0 0 0 2 4V11A2 2 0 0 0 2.59 12.42M5 6.5A1.5 1.5 0 1 0 6.5 5A1.5 1.5 0 0 0 5 6.5Z";
var mdiTagOutline = "M21.41 11.58L12.41 2.58A2 2 0 0 0 11 2H4A2 2 0 0 0 2 4V11A2 2 0 0 0 2.59 12.42L11.59 21.42A2 2 0 0 0 13 22A2 2 0 0 0 14.41 21.41L21.41 14.41A2 2 0 0 0 22 13A2 2 0 0 0 21.41 11.58M13 20L4 11V4H11L20 13M6.5 5A1.5 1.5 0 1 1 5 6.5A1.5 1.5 0 0 1 6.5 5Z";
var mdiTagPlus = "M21.41,11.58L12.41,2.58C12.04,2.21 11.53,2 11,2H4A2,2 0 0,0 2,4V11C2,11.53 2.21,12.04 2.59,12.41L3,12.81C3.9,12.27 4.94,12 6,12A6,6 0 0,1 12,18C12,19.06 11.72,20.09 11.18,21L11.58,21.4C11.95,21.78 12.47,22 13,22C13.53,22 14.04,21.79 14.41,21.41L21.41,14.41C21.79,14.04 22,13.53 22,13C22,12.47 21.79,11.96 21.41,11.58M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M10,19H7V22H5V19H2V17H5V14H7V17H10V19Z";
var mdiTagPlusOutline = "M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5M21.41 11.58L12.41 2.58A2 2 0 0 0 11 2H4A2 2 0 0 0 2 4V11A2 2 0 0 0 2.59 12.42L3 12.82A5.62 5.62 0 0 1 5.08 12.08L4 11V4H11L20 13L13 20L11.92 18.92A5.57 5.57 0 0 1 11.18 21L11.59 21.41A2 2 0 0 0 13 22A2 2 0 0 0 14.41 21.41L21.41 14.41A2 2 0 0 0 22 13A2 2 0 0 0 21.41 11.58M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5M10 19H7V22H5V19H2V17H5V14H7V17H10Z";
var mdiTagRemove = "M21.41,11.58L12.41,2.58C12.04,2.21 11.53,2 11,2H4A2,2 0 0,0 2,4V11C2,11.53 2.21,12.04 2.59,12.41L3,12.81C3.9,12.27 4.94,12 6,12A6,6 0 0,1 12,18C12,19.06 11.72,20.09 11.18,21L11.58,21.4C11.95,21.78 12.47,22 13,22C13.53,22 14.04,21.79 14.41,21.41L21.41,14.41C21.79,14.04 22,13.53 22,13C22,12.47 21.79,11.96 21.41,11.58M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M8.12,21.54L6,19.41L3.88,21.54L2.46,20.12L4.59,18L2.46,15.88L3.87,14.47L6,16.59L8.12,14.47L9.53,15.88L7.41,18L9.53,20.12L8.12,21.54Z";
var mdiTagRemoveOutline = "M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5M21.41 11.58L12.41 2.58A2 2 0 0 0 11 2H4A2 2 0 0 0 2 4V11A2 2 0 0 0 2.59 12.42L3 12.82A5.62 5.62 0 0 1 5.08 12.08L4 11V4H11L20 13L13 20L11.92 18.92A5.57 5.57 0 0 1 11.18 21L11.59 21.41A2 2 0 0 0 13 22A2 2 0 0 0 14.41 21.41L21.41 14.41A2 2 0 0 0 22 13A2 2 0 0 0 21.41 11.58M6.5 5A1.5 1.5 0 1 0 8 6.5A1.5 1.5 0 0 0 6.5 5M8.12 21.54L6 19.41L3.88 21.54L2.46 20.12L4.59 18L2.46 15.88L3.88 14.46L6 16.59L8.12 14.46L9.54 15.88L7.41 18L9.54 20.12Z";
var mdiTagSearch = "M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.89 2 2 2.89 2 4V11C2 11.55 2.22 12.05 2.59 12.41L11.58 21.41C11.95 21.77 12.45 22 13 22S14.05 21.77 14.41 21.41L14.83 21C11.6 20.9 9 18.26 9 15C9 11.69 11.69 9 15 9C18.26 9 20.9 11.6 21 14.83L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.44 21.77 11.94 21.41 11.58M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7M15.11 10.61C17.61 10.61 19.61 12.61 19.61 15.11C19.61 16 19.36 16.82 18.92 17.5L22 20.61L20.61 22L17.5 18.93C16.8 19.36 16 19.61 15.11 19.61C12.61 19.61 10.61 17.61 10.61 15.11S12.61 10.61 15.11 10.61M15.11 12.61C13.73 12.61 12.61 13.73 12.61 15.11S13.73 17.61 15.11 17.61 17.61 16.5 17.61 15.11 16.5 12.61 15.11 12.61";
var mdiTagSearchOutline = "M22 13C22 13.53 21.79 14.04 21.41 14.41L21 14.83C20.91 11.97 18.84 9.62 16.11 9.11L11 4H4V11L9.11 16.11C9.62 18.84 11.97 20.91 14.83 21L14.41 21.41C14.04 21.79 13.53 22 13 22C12.47 22 11.97 21.79 11.59 21.42L2.59 12.42C2.21 12.04 2 11.53 2 11V4C2 2.9 2.9 2 4 2H11C11.53 2 12.04 2.21 12.41 2.58L21.41 11.58C21.79 11.96 22 12.47 22 13M5 6.5C5 7.33 5.67 8 6.5 8S8 7.33 8 6.5 7.33 5 6.5 5 5 5.67 5 6.5M15.11 10.61C12.61 10.61 10.61 12.61 10.61 15.11S12.61 19.61 15.11 19.61C16 19.61 16.8 19.36 17.5 18.93L20.61 22L22 20.61L18.92 17.5C19.36 16.82 19.61 16 19.61 15.11C19.61 12.61 17.61 10.61 15.11 10.61M15.11 12.61C16.5 12.61 17.61 13.73 17.61 15.11S16.5 17.61 15.11 17.61 12.61 16.5 12.61 15.11 13.73 12.61 15.11 12.61";
var mdiTagText = "M21.41 11.58L12.41 2.58A2 2 0 0 0 11 2H4A2 2 0 0 0 2 4V11A2 2 0 0 0 2.59 12.41L11.59 21.41A2 2 0 0 0 13 22A2 2 0 0 0 14.41 21.41L21.41 14.41A2 2 0 0 0 22 13A2 2 0 0 0 21.41 11.58M6.5 8A1.5 1.5 0 1 1 8 6.5A1.5 1.5 0 0 1 6.5 8M11.59 15.41L7.59 11.41L9 10L13 14M15.59 14.41L10.09 8.91L11.5 7.5L17 13Z";
var mdiTagTextOutline = "M21.4 11.6L12.4 2.6C12 2.2 11.5 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.5 2.2 12 2.6 12.4L11.6 21.4C12 21.8 12.5 22 13 22C13.5 22 14 21.8 14.4 21.4L21.4 14.4C21.8 14 22 13.5 22 13C22 12.5 21.8 12 21.4 11.6M13 20L4 11V4H11L20 13M6.5 5C7.3 5 8 5.7 8 6.5S7.3 8 6.5 8 5 7.3 5 6.5 5.7 5 6.5 5M10.1 8.9L11.5 7.5L17 13L15.6 14.4L10.1 8.9M7.6 11.4L9 10L13 14L11.6 15.4L7.6 11.4Z";
var mdiTailwind = "M12 6C9.33 6 7.67 7.33 7 10C8 8.67 9.17 8.17 10.5 8.5C11.26 8.69 11.81 9.24 12.41 9.85C13.39 10.85 14.5 12 17 12C19.67 12 21.33 10.67 22 8C21 9.33 19.83 9.83 18.5 9.5C17.74 9.31 17.2 8.76 16.59 8.15C15.61 7.15 14.5 6 12 6M7 12C4.33 12 2.67 13.33 2 16C3 14.67 4.17 14.17 5.5 14.5C6.26 14.69 6.8 15.24 7.41 15.85C8.39 16.85 9.5 18 12 18C14.67 18 16.33 16.67 17 14C16 15.33 14.83 15.83 13.5 15.5C12.74 15.31 12.2 14.76 11.59 14.15C10.61 13.15 9.5 12 7 12Z";
var mdiTallyMark1 = "M13 19H11V5H13V19Z";
var mdiTallyMark2 = "M11 19H9V5H11V19M15 5H13V19H15V5Z";
var mdiTallyMark3 = "M9 19H7V5H9V19M13 5H11V19H13V5M17 5H15V19H17V5Z";
var mdiTallyMark4 = "M7 19H5V5H7V19M11 5H9V19H11V5M15 5H13V19H15V5M19 5H17V19H19V5Z";
var mdiTallyMark5 = "M19 10.73V19H17V11.36L15 12V19H13V12.62L11 13.26V19H9V13.89L7 14.5V19H5V15.15L2.57 15.92L2 14L5 13.05V5H7V12.42L9 11.79V5H11V11.16L13 10.53V5H15V9.9L17 9.26V5H19V8.63L21 8L21.57 9.92L19 10.73Z";
var mdiTangram = "M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M18.59 4L12 10.59L5.41 4H18.59M13.41 12L16.5 8.91L19.59 12L16.5 15.09L13.41 12M14.59 16H9.41L12 13.41L14.59 16M4 5.41L10.59 12L4 18.59V5.41M11.59 20H5.41L7.41 18H13.59L11.59 20M20 20H14.41L20 14.41V20M20 9.59L17.91 7.5L20 5.41V9.59Z";
var mdiTank = "M20,12H4V11H6L7,6H12L13,11H20V12M13.22,7L13.62,9H22V7H13.22M22,16A3,3 0 0,1 19,19H5A3,3 0 0,1 2,16A3,3 0 0,1 5,13H19A3,3 0 0,1 22,16M6,16A1,1 0 0,0 5,15A1,1 0 0,0 4,16A1,1 0 0,0 5,17A1,1 0 0,0 6,16M13,16A1,1 0 0,0 12,15A1,1 0 0,0 11,16A1,1 0 0,0 12,17A1,1 0 0,0 13,16M20,16A1,1 0 0,0 19,15A1,1 0 0,0 18,16A1,1 0 0,0 19,17A1,1 0 0,0 20,16Z";
var mdiTankerTruck = "M20 8H15V14H2V17H3C3 18.7 4.3 20 6 20S9 18.7 9 17H15C15 18.7 16.3 20 18 20S21 18.7 21 17H23V12L20 8M6 18.5C5.2 18.5 4.5 17.8 4.5 17S5.2 15.5 6 15.5 7.5 16.2 7.5 17 6.8 18.5 6 18.5M18 18.5C17.2 18.5 16.5 17.8 16.5 17S17.2 15.5 18 15.5 19.5 16.2 19.5 17 18.8 18.5 18 18.5M17 12V9.5H19.5L21.5 12H17M14 9.5C14 11.4 12.4 13 10.5 13H4.5C2.6 13 1 11.4 1 9.5S2.6 6 4.5 6H5V5H4V4H8V5H7V6H10.5C12.4 6 14 7.6 14 9.5Z";
var mdiTapeDrive = "M12 10C13.11 10 14 10.9 14 12C14 13.11 13.11 14 12 14C10.9 14 10 13.11 10 12C10 10.9 10.9 10 12 10M5 3H19C20.11 3 21 3.9 21 5V17H16.9C18.2 15.73 19 13.96 19 12C19 8.13 15.87 5 12 5C8.13 5 5 8.13 5 12C5 15.87 8.13 19 12 19H21C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3Z";
var mdiTapeMeasure = "M9,5A7,7 0 0,1 16,12H17V15H16V19H9A7,7 0 0,1 2,12A7,7 0 0,1 9,5M9,8A4,4 0 0,0 5,12A4,4 0 0,0 9,16A4,4 0 0,0 13,12A4,4 0 0,0 9,8M17,17H22V19L22,21H20V19H17V17Z";
var mdiTarget = "M11,2V4.07C7.38,4.53 4.53,7.38 4.07,11H2V13H4.07C4.53,16.62 7.38,19.47 11,19.93V22H13V19.93C16.62,19.47 19.47,16.62 19.93,13H22V11H19.93C19.47,7.38 16.62,4.53 13,4.07V2M11,6.08V8H13V6.09C15.5,6.5 17.5,8.5 17.92,11H16V13H17.91C17.5,15.5 15.5,17.5 13,17.92V16H11V17.91C8.5,17.5 6.5,15.5 6.08,13H8V11H6.09C6.5,8.5 8.5,6.5 11,6.08M12,11A1,1 0 0,0 11,12A1,1 0 0,0 12,13A1,1 0 0,0 13,12A1,1 0 0,0 12,11Z";
var mdiTargetAccount = "M20.95,11H22.5V13H20.95C20.5,17.17 17.17,20.5 13,20.95V22.5H11V20.95C6.83,20.5 3.5,17.17 3.05,13H1.5V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1.5H13V3.05C17.17,3.5 20.5,6.83 20.95,11M5.07,11H6.5V13H5.07C5.5,16.07 7.93,18.5 11,18.93V17.5H13V18.93C16.07,18.5 18.5,16.07 18.93,13H17.5V11H18.93C18.5,7.93 16.07,5.5 13,5.07V6.5H11V5.07C7.93,5.5 5.5,7.93 5.07,11M16,16H8V15C8,13.67 10.67,13 12,13C13.33,13 16,13.67 16,15V16M12,8A2,2 0 0,1 14,10A2,2 0 0,1 12,12A2,2 0 0,1 10,10A2,2 0 0,1 12,8Z";
var mdiTargetVariant = "M22.08,11.04H20.08V4H13.05V2H11.04V4H4V11.04H2V13.05H4V20.08H11.04V22.08H13.05V20.08H20.08V13.05H22.08V11.04M18.07,18.07H13.05V16.06H11.04V18.07H6V13.05H8.03V11.04H6V6H11.04V8.03H13.05V6H18.07V11.04H16.06V13.05H18.07V18.07M13.05,12.05A1,1 0 0,1 12.05,13.05C11.5,13.05 11.04,12.6 11.04,12.05C11.04,11.5 11.5,11.04 12.05,11.04C12.6,11.04 13.05,11.5 13.05,12.05Z";
var mdiTaxi = "M5,11L6.5,6.5H17.5L19,11M17.5,16A1.5,1.5 0 0,1 16,14.5A1.5,1.5 0 0,1 17.5,13A1.5,1.5 0 0,1 19,14.5A1.5,1.5 0 0,1 17.5,16M6.5,16A1.5,1.5 0 0,1 5,14.5A1.5,1.5 0 0,1 6.5,13A1.5,1.5 0 0,1 8,14.5A1.5,1.5 0 0,1 6.5,16M18.92,6C18.72,5.42 18.16,5 17.5,5H15V3H9V5H6.5C5.84,5 5.28,5.42 5.08,6L3,12V20A1,1 0 0,0 4,21H5A1,1 0 0,0 6,20V19H18V20A1,1 0 0,0 19,21H20A1,1 0 0,0 21,20V12L18.92,6Z";
var mdiTea = "M4,19H20V21H4V19M20,8V5H18V8H20M20,3C20.6,3 21,3.2 21.4,3.6C21.8,4 22,4.5 22,5V8C22,8.6 21.8,9 21.4,9.4C21,9.8 20.6,10 20,10H18V13C18,14.1 17.6,15 16.8,15.8C16,16.6 15.1,17 14,17H8C6.9,17 6,16.6 5.2,15.8C4.4,15 4,14.1 4,13V3H9V5.4L7.2,6.8C7.1,6.9 7,7.1 7,7.2V11.5C7,11.8 7.2,12 7.5,12H11.5C11.8,12 12,11.8 12,11.5V7.2C12,7 11.9,6.9 11.8,6.8L10,5.4V3H20Z";
var mdiTeaOutline = "M4,19H20V21H4V19M21.4,3.6C21,3.2 20.6,3 20,3H4V13C4,14.1 4.4,15 5.2,15.8C6,16.6 6.9,17 8,17H14C15.1,17 16,16.6 16.8,15.8C17.6,15 18,14.1 18,13V10H20C20.6,10 21,9.8 21.4,9.4C21.8,9 22,8.6 22,8V5C22,4.5 21.8,4 21.4,3.6M16,5V8L16,10V13C16,13.6 15.8,14 15.4,14.4C15,14.8 14.6,15 14,15H8C7.4,15 7,14.8 6.6,14.4C6.2,14 6,13.5 6,13V5H10V6.4L8.2,7.8C8,7.9 8,8.1 8,8.2V12.5C8,12.8 8.2,13 8.5,13H12.5C12.8,13 13,12.8 13,12.5V8.2C13,8 12.9,7.9 12.8,7.8L11,6.4V5H16M20,8H18V5H20V8Z";
var mdiTeamviewer = "M10.04 9.2L9.3 11H14.75L14 9.2L19.55 12L14 14.8L14.75 13H9.3L10.04 14.8L4.5 12L10.04 9.2M20.83 22H3.17C2.53 22 2 21.5 2 20.83V3.17C2 2.53 2.53 2 3.17 2H20.83C21.5 2 22 2.53 22 3.17V20.83C22 21.47 21.5 22 20.83 22M11.93 3.76C7.41 3.82 3.78 7.5 3.76 12C3.72 16.5 7.35 20.2 11.86 20.24H12C16.53 20.18 20.18 16.53 20.24 12C20.31 7.5 16.74 3.83 12.26 3.76C12.15 3.75 12.04 3.76 11.93 3.76Z";
var mdiTeddyBear = "M15.75 19.13C14.92 19.13 14.25 18.29 14.25 17.25C14.25 16.22 14.92 15.38 15.75 15.38C16.58 15.38 17.25 16.22 17.25 17.25C17.25 18.29 16.58 19.13 15.75 19.13M12 11.25C10.76 11.25 9.75 10.41 9.75 9.38C9.75 8.34 10.76 7.5 12 7.5C13.24 7.5 14.25 8.34 14.25 9.38C14.25 10.41 13.24 11.25 12 11.25M8.25 19.13C7.42 19.13 6.75 18.29 6.75 17.25C6.75 16.22 7.42 15.38 8.25 15.38C9.08 15.38 9.75 16.22 9.75 17.25C9.75 18.29 9.08 19.13 8.25 19.13M12 8.25C12.41 8.25 12.75 8.59 12.75 9C12.75 9.41 12.41 9.75 12 9.75C11.59 9.75 11.25 9.41 11.25 9C11.25 8.59 11.59 8.25 12 8.25M18.75 12C18.43 12 18.12 12.07 17.84 12.2C17.36 11.59 16.71 11.07 15.93 10.67C16.5 9.87 16.84 8.9 16.84 7.85C16.84 7.83 16.84 7.81 16.84 7.79C17.93 7.56 18.75 6.59 18.75 5.42C18.75 4.09 17.66 3 16.33 3C15.64 3 15 3.29 14.58 3.75C13.83 3.28 12.95 3 12 3C11.05 3 10.16 3.28 9.42 3.75C9 3.29 8.36 3 7.67 3C6.34 3 5.25 4.09 5.25 5.42C5.25 6.58 6.07 7.55 7.15 7.79C7.15 7.81 7.15 7.83 7.15 7.85C7.15 8.9 7.5 9.88 8.06 10.67C7.29 11.07 6.64 11.59 6.16 12.2C5.88 12.07 5.57 12 5.25 12C4 12 3 13 3 14.25C3 15.5 4 16.5 5.25 16.5C5.27 16.5 5.29 16.5 5.31 16.5C5.27 16.74 5.25 17 5.25 17.25C5.25 19.32 6.59 21 8.25 21C9.26 21 10.15 20.37 10.7 19.41C11.12 19.47 11.55 19.5 12 19.5C12.45 19.5 12.88 19.47 13.3 19.41C13.85 20.37 14.74 21 15.75 21C17.41 21 18.75 19.32 18.75 17.25C18.75 17 18.73 16.74 18.69 16.5C18.71 16.5 18.73 16.5 18.75 16.5C20 16.5 21 15.5 21 14.25C21 13 20 12 18.75 12";
var mdiTelescope = "M21.9,8.9L20.2,9.9L16.2,3L17.9,2L21.9,8.9M9.8,7.9L12.8,13.1L18.9,9.6L15.9,4.4L9.8,7.9M11.4,12.7L9.4,9.2L5.1,11.7L7.1,15.2L11.4,12.7M2.1,14.6L3.1,16.3L5.7,14.8L4.7,13.1L2.1,14.6M12.1,14L11.8,13.6L7.5,16.1L7.8,16.5C8,16.8 8.3,17.1 8.6,17.3L7,22H9L10.4,17.7H10.5L12,22H14L12.1,16.4C12.6,15.7 12.6,14.8 12.1,14Z";
var mdiTelevision = "M21,17H3V5H21M21,3H3A2,2 0 0,0 1,5V17A2,2 0 0,0 3,19H8V21H16V19H21A2,2 0 0,0 23,17V5A2,2 0 0,0 21,3Z";
var mdiTelevisionAmbientLight = "M3 11H0V9H3V11M3 14H0V16H3V14M5 5.12L2.88 3L1.46 4.41L3.59 6.54L5 5.12M10 5V2H8V5H10M24 9H21V11H24V9M16 5V2H14V5H16M20.41 6.54L22.54 4.42L21.12 3L19 5.12L20.41 6.54M24 14H21V16H24V14M19 9V16C19 17.1 18.1 18 17 18H15V20H9V18H7C5.9 18 5 17.1 5 16V9C5 7.9 5.9 7 7 7H17C18.1 7 19 7.9 19 9M17 9H7V16H17V9M19 19.88L21.12 22L22.54 20.59L20.41 18.47L19 19.88M3.59 18.46L1.47 20.59L2.88 22L5 19.88L3.59 18.46Z";
var mdiTelevisionBox = "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M16,16L19,8H16.5L15,12.5L13.5,8H5V10H8V16H10V10H11.77L14,16H16Z";
var mdiTelevisionClassic = "M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9A1,1 0 0,1 20.5,10A1,1 0 0,1 19.5,11A1,1 0 0,1 18.5,10A1,1 0 0,1 19.5,9M19.5,12A1,1 0 0,1 20.5,13A1,1 0 0,1 19.5,14A1,1 0 0,1 18.5,13A1,1 0 0,1 19.5,12Z";
var mdiTelevisionClassicOff = "M2,5.27L3.28,4L21,21.72L19.73,23L17.73,21H4C2.89,21 2,20.11 2,19V9C2,8 2.76,7.14 3.75,7L2,5.27M8.16,3L12,6.84L15.84,3L17.25,4.41L14.66,7H20C21.11,7 22,7.89 22,9V19C22,19.34 21.92,19.66 21.77,19.94L17,15.18V9H10.82L8.82,7H9.34L6.75,4.41L8.16,3M4,9V19H15.73L5.73,9H4M19.5,9A1,1 0 0,0 18.5,10A1,1 0 0,0 19.5,11A1,1 0 0,0 20.5,10A1,1 0 0,0 19.5,9M19.5,12A1,1 0 0,0 18.5,13A1,1 0 0,0 19.5,14A1,1 0 0,0 20.5,13A1,1 0 0,0 19.5,12Z";
var mdiTelevisionGuide = "M21,17V5H3V17H21M21,3A2,2 0 0,1 23,5V17A2,2 0 0,1 21,19H16V21H8V19H3A2,2 0 0,1 1,17V5A2,2 0 0,1 3,3H21M5,7H11V11H5V7M5,13H11V15H5V13M13,7H19V9H13V7M13,11H19V15H13V11Z";
var mdiTelevisionOff = "M0.5,2.77L1.78,1.5L21,20.72L19.73,22L16.73,19H16V21H8V19H3A2,2 0 0,1 1,17V5C1,4.5 1.17,4.07 1.46,3.73L0.5,2.77M21,17V5H7.82L5.82,3H21A2,2 0 0,1 23,5V17C23,17.85 22.45,18.59 21.7,18.87L19.82,17H21M3,17H14.73L3,5.27V17Z";
var mdiTelevisionPause = "M3 3C1.89 3 1 3.89 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.89 22.1 3 21 3M3 5H21V17H3M9 8V14H11V8M13 8V14H15V8";
var mdiTelevisionPlay = "M21,3H3C1.89,3 1,3.89 1,5V17A2,2 0 0,0 3,19H8V21H16V19H21A2,2 0 0,0 23,17V5C23,3.89 22.1,3 21,3M21,17H3V5H21M16,11L9,15V7";
var mdiTelevisionShimmer = "M21 17H3V5H21M21 3H3C1.9 3 1 3.9 1 5V17C1 18.11 1.9 19 3 19H8V21H16V19H21C22.11 19 23 18.11 23 17V5C23 3.9 22.11 3 21 3M15 6.5L14.38 7.87L13 8.5L14.38 9.13L15 10.5L15.63 9.13L17 8.5L15.63 7.87L15 6.5M10.5 8.5L9.41 10.91L7 12L9.41 13.09L10.5 15.5L11.6 13.09L14 12L11.6 10.91L10.5 8.5";
var mdiTelevisionSpeaker = "M3 3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H12V17H3V5H21V7H23V5C23 3.9 22.1 3 21 3H3M21 9H16C14.9 9 14 9.9 14 11V20C14 21.1 14.9 22 16 22H21C22.1 22 23 21.1 23 20V11C23 9.9 22.1 9 21 9M18.5 10.5C19.3 10.5 20 11.2 20 12S19.3 13.5 18.5 13.5 17 12.8 17 12 17.7 10.5 18.5 10.5M18.5 20.5C16.8 20.5 15.5 19.2 15.5 17.5C15.5 15.9 16.8 14.5 18.4 14.5H18.5C20.2 14.5 21.5 15.8 21.5 17.5S20.2 20.5 18.5 20.5M18.5 16C17.7 16 17 16.7 17 17.5S17.7 19 18.5 19 20 18.3 20 17.5 19.3 16 18.5 16Z";
var mdiTelevisionSpeakerOff = "M21 9H16C15 9 14.1 9.8 14 10.8L17.8 14.6C18 14.5 18.2 14.5 18.5 14.5H18.6C20.3 14.5 21.6 15.8 21.6 17.5C21.6 17.7 21.6 18 21.5 18.2L23.1 19.8V11C23 9.9 22.1 9 21 9M18.5 13.5C17.7 13.5 17 12.8 17 12S17.7 10.5 18.5 10.5 20 11.2 20 12 19.3 13.5 18.5 13.5M23 5V7H21V5H8.2L6.2 3H21C22.1 3 23 3.9 23 5M2.4 1.7L1.1 3L1.6 3.5C1.3 3.9 1 4.4 1 5V17C1 18.1 1.9 19 3 19H8V21H12V17H3V5H3.1L14 15.9V20C14 21.1 14.9 22 16 22H20.1L20.8 22.7L22.2 21.5L2.4 1.7M18.5 20.5C16.8 20.5 15.5 19.2 15.5 17.5V17.4L18.6 20.5H18.5Z";
var mdiTelevisionStop = "M3 3H21C22.1 3 23 3.89 23 5V17C23 18.1 22.1 19 21 19H16V21H8V19H3C1.9 19 1 18.1 1 17V5C1 3.89 1.89 3 3 3M3 5V17H21V5H3M9 8H15V14H9V8Z";
var mdiTemperatureCelsius = "M16.5,5C18.05,5 19.5,5.47 20.69,6.28L19.53,9.17C18.73,8.44 17.67,8 16.5,8C14,8 12,10 12,12.5C12,15 14,17 16.5,17C17.53,17 18.47,16.66 19.23,16.08L20.37,18.93C19.24,19.61 17.92,20 16.5,20A7.5,7.5 0 0,1 9,12.5A7.5,7.5 0 0,1 16.5,5M6,3A3,3 0 0,1 9,6A3,3 0 0,1 6,9A3,3 0 0,1 3,6A3,3 0 0,1 6,3M6,5A1,1 0 0,0 5,6A1,1 0 0,0 6,7A1,1 0 0,0 7,6A1,1 0 0,0 6,5Z";
var mdiTemperatureFahrenheit = "M11,20V5H20V8H14V11H19V14H14V20H11M6,3A3,3 0 0,1 9,6A3,3 0 0,1 6,9A3,3 0 0,1 3,6A3,3 0 0,1 6,3M6,5A1,1 0 0,0 5,6A1,1 0 0,0 6,7A1,1 0 0,0 7,6A1,1 0 0,0 6,5Z";
var mdiTemperatureKelvin = "M7,5H10V11L15,5H19L13.88,10.78L19,20H15.38L11.76,13.17L10,15.15V20H7V5Z";
var mdiTempleBuddhist = "M21 9C21 10.1 20.1 11 19 11H5C3.9 11 3 10.1 3 9H1C1 10.9 2.3 12.4 4 12.8V22H10V19C10 17.9 10.9 17 12 17S14 17.9 14 19V22H20V12.9C20.5 12.8 23 11.9 23 9H21M6 8.9V10H18V8.9C18.5 8.8 21 7.9 21 5H19C19 6.1 18.1 7 17 7H7C5.9 7 5 6.1 5 5H3C3 6.9 4.3 8.4 6 8.9M12 1L8.2 6H15.7L12 1Z";
var mdiTempleBuddhistOutline = "M21 9C21 10.1 20.1 11 19 11H18V8.9C19.7 8.5 21 6.9 21 5.1H19C19 6.2 18.1 7.1 17 7.1H16.5L12 1L7.5 7H7C5.9 7 5 6.1 5 5H3C3 6.9 4.3 8.4 6 8.8V11H5C3.9 11 3 10.1 3 9H1C1 10.9 2.3 12.4 4 12.8V22H11V18C11 17.5 11.4 17 12 17S13 17.5 13 18V22H20V12.9C21.7 12.5 23 10.9 23 9.1L21 9M12 4.3L14 7H10L12 4.3M8 9H16V11H8V9M18 20H15V18C15 16.4 13.6 15 12 15S9 16.4 9 18V20H6V13H18V20Z";
var mdiTempleHindu = "M6.6 11H17.4L16.5 8H7.5L6.6 11M20 11V13H4V11H2V22H10V17H14V22H22V11H20M15.9 6L15 3V1H13V3H11V1H9V3.1L8.1 6H15.9Z";
var mdiTempleHinduOutline = "M20 11V13H18L15 3V1H13V3H11V1H9V3.1L6 13H4V11H2V22H11V17H13V22H22V11H20M15.3 11H8.7L9.3 9H14.7L15.3 11M14.1 7H9.9L10.5 5H13.5L14.1 7M20 20H15V15H9V20H4V15H7.5L8.1 13H15.9L16.5 15H20V20Z";
var mdiTennis = "M18,15A4,4 0 0,1 22,19A4,4 0 0,1 18,23A4,4 0 0,1 14,19A4,4 0 0,1 18,15M18,17A2,2 0 0,0 16,19A2,2 0 0,0 18,21A2,2 0 0,0 20,19A2,2 0 0,0 18,17M6.05,14.54C6.05,14.54 7.46,13.12 7.47,10.3C7.11,8.11 7.97,5.54 9.94,3.58C12.87,0.65 17.14,0.17 19.5,2.5C21.83,4.86 21.35,9.13 18.42,12.06C16.46,14.03 13.89,14.89 11.7,14.53C8.88,14.54 7.46,15.95 7.46,15.95L3.22,20.19L1.81,18.78L6.05,14.54M18.07,3.93C16.5,2.37 13.5,2.84 11.35,5C9.21,7.14 8.73,10.15 10.29,11.71C11.86,13.27 14.86,12.79 17,10.65C19.16,8.5 19.63,5.5 18.07,3.93Z";
var mdiTennisBall = "M12,2C14.5,2 16.75,2.9 18.5,4.4C16.36,6.23 15,8.96 15,12C15,15.04 16.36,17.77 18.5,19.6C16.75,21.1 14.5,22 12,22C9.5,22 7.25,21.1 5.5,19.6C7.64,17.77 9,15.04 9,12C9,8.96 7.64,6.23 5.5,4.4C7.25,2.9 9.5,2 12,2M22,12C22,14.32 21.21,16.45 19.88,18.15C18.12,16.68 17,14.47 17,12C17,9.53 18.12,7.32 19.88,5.85C21.21,7.55 22,9.68 22,12M2,12C2,9.68 2.79,7.55 4.12,5.85C5.88,7.32 7,9.53 7,12C7,14.47 5.88,16.68 4.12,18.15C2.79,16.45 2,14.32 2,12Z";
var mdiTennisBallOutline = "M8.17 2.76C9.39 2.26 10.69 2 12 2C13.31 2 14.61 2.26 15.83 2.76C17.04 3.26 18.14 4 19.07 4.93C20 5.86 20.74 6.96 21.24 8.17C21.74 9.39 22 10.69 22 12C22 14.65 20.95 17.2 19.07 19.07C17.2 20.95 14.65 22 12 22C10.69 22 9.39 21.74 8.17 21.24C6.96 20.74 5.86 20 4.93 19.07C3.05 17.2 2 14.65 2 12C2 9.35 3.05 6.8 4.93 4.93C5.86 4 6.96 3.26 8.17 2.76M6.89 18.15C8.32 19.34 10.12 20 12 20C13.88 20 15.68 19.34 17.11 18.15C15.79 16.46 15 14.32 15 12C15 9.68 15.79 7.55 17.11 5.85C15.69 4.66 13.88 4 12 4C10.12 4 8.32 4.66 6.89 5.85C8.21 7.55 9 9.68 9 12C9 14.32 8.21 16.46 6.89 18.15M5.5 16.67C6.44 15.35 7 13.74 7 12C7 10.26 6.44 8.65 5.5 7.34C4.53 8.69 4 10.32 4 12C4 13.68 4.53 15.31 5.5 16.67M18.5 7.34C17.56 8.65 17 10.26 17 12C17 13.74 17.56 15.35 18.5 16.67C19.47 15.31 20 13.69 20 12C20 10.32 19.47 8.69 18.5 7.34Z";
var mdiTent = "M4,6C4,7.19 4.39,8.27 5,9A3,3 0 0,1 2,6A3,3 0 0,1 5,3C4.39,3.73 4,4.81 4,6M2,21V19H4.76L12,4.78L19.24,19H22V21H2M12,9.19L7,19H17L12,9.19Z";
var mdiTerraform = "M21 5.4V11.8L15.4 15V8.7L21 5.4M14.8 8.7V15L9.2 11.8V5.4L14.8 8.7M14.8 15.7V22.1L9.2 18.9V12.5L14.8 15.7M8.6 5.1V11.5L3 8.3V1.9L8.6 5.1Z";
var mdiTerrain = "M14,6L10.25,11L13.1,14.8L11.5,16C9.81,13.75 7,10 7,10L1,18H23L14,6Z";
var mdiTestTube = "M7,2V4H8V18A4,4 0 0,0 12,22A4,4 0 0,0 16,18V4H17V2H7M11,16C10.4,16 10,15.6 10,15C10,14.4 10.4,14 11,14C11.6,14 12,14.4 12,15C12,15.6 11.6,16 11,16M13,12C12.4,12 12,11.6 12,11C12,10.4 12.4,10 13,10C13.6,10 14,10.4 14,11C14,11.6 13.6,12 13,12M14,7H10V4H14V7Z";
var mdiTestTubeEmpty = "M7,2H17V4H16V18A4,4 0 0,1 12,22A4,4 0 0,1 8,18V4H7V2M14,4H10V18A2,2 0 0,0 12,20A2,2 0 0,0 14,18V4Z";
var mdiTestTubeOff = "M2,5.27L3.28,4L20,20.72L18.73,22L15.84,19.11C15.36,20.77 13.82,22 12,22A4,4 0 0,1 8,18V11.27L2,5.27M7,2H17V4H16V14.18L13.63,11.81C13.86,11.63 14,11.35 14,11C14,10.4 13.6,10 13,10C12.65,10 12.37,10.14 12.19,10.37L8,6.18V4H7V2M11,16C11.5,16 11.88,15.71 12,15.24L10.76,14C10.29,14.12 10,14.5 10,15C10,15.6 10.4,16 11,16M14,7V4H10V7H14Z";
var mdiText = "M21,6V8H3V6H21M3,18H12V16H3V18M3,13H21V11H3V13Z";
var mdiTextAccount = "M21 5V7H3V5H21M3 17H12V15H3V17M3 12H21V10H3V12M18 14C19.11 14 20 14.9 20 16S19.11 18 18 18 16 17.11 16 16 16.9 14 18 14M14 22V21C14 19.9 15.79 19 18 19S22 19.9 22 21V22H14Z";
var mdiTextBox = "M14,17H7V15H14M17,13H7V11H17M17,9H7V7H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiTextBoxCheck = "M17,21L14.25,18L15.41,16.84L17,18.43L20.59,14.84L21.75,16.25M12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21M12,15H7V17H12M17,7H7V9H17";
var mdiTextBoxCheckOutline = "M17,21L14.25,18L15.41,16.84L17,18.43L20.59,14.84L21.75,16.25M12.8,21H5C3.89,21 3,20.11 3,19V5C3,3.89 3.89,3 5,3H19C20.11,3 21,3.89 21,5V12.8C20.39,12.45 19.72,12.2 19,12.08V5H5V19H12.08C12.2,19.72 12.45,20.39 12.8,21M12,17H7V15H12M14.68,13H7V11H17V12.08C16.15,12.22 15.37,12.54 14.68,13M17,9H7V7H17";
var mdiTextBoxEdit = "M10 19.11L12.11 17H7V15H14V15.12L16.12 13H7V11H17V12.12L18.24 10.89C18.72 10.41 19.35 10.14 20.04 10.14C20.37 10.14 20.7 10.21 21 10.33V5C21 3.89 20.1 3 19 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H10V19.11M7 7H17V9H7V7M21.7 14.35L20.7 15.35L18.65 13.3L19.65 12.3C19.86 12.09 20.21 12.09 20.42 12.3L21.7 13.58C21.91 13.79 21.91 14.14 21.7 14.35M12 19.94L18.06 13.88L20.11 15.93L14.06 22H12V19.94Z";
var mdiTextBoxEditOutline = "M10 21H5C3.89 21 3 20.11 3 19V5C3 3.89 3.89 3 5 3H19C20.11 3 21 3.89 21 5V10.33C20.7 10.21 20.37 10.14 20.04 10.14C19.67 10.14 19.32 10.22 19 10.37V5H5V19H10.11L10 19.11V21M7 9H17V7H7V9M7 17H12.11L14 15.12V15H7V17M7 13H16.12L17 12.12V11H7V13M21.7 13.58L20.42 12.3C20.21 12.09 19.86 12.09 19.65 12.3L18.65 13.3L20.7 15.35L21.7 14.35C21.91 14.14 21.91 13.79 21.7 13.58M12 22H14.06L20.11 15.93L18.06 13.88L12 19.94V22Z";
var mdiTextBoxMinus = "M22,17V19H14V17H22M12,17V15H7V17H12M17,11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11M17,9V7H7V9H17Z";
var mdiTextBoxMinusOutline = "M22,17V19H14V17H22M5,3H19C20.11,3 21,3.89 21,5V12.8C20.39,12.45 19.72,12.2 19,12.08V5H5V19H12.08C12.2,19.72 12.45,20.39 12.8,21H5C3.89,21 3,20.11 3,19V5C3,3.89 3.89,3 5,3M7,7H17V9H7V7M7,11H17V12.08C16.15,12.22 15.37,12.54 14.68,13H7V11M7,15H12V17H7V15Z";
var mdiTextBoxMultiple = "M16,15H9V13H16M19,11H9V9H19M19,7H9V5H19M21,1H7C5.89,1 5,1.89 5,3V17C5,18.11 5.9,19 7,19H21C22.11,19 23,18.11 23,17V3C23,1.89 22.1,1 21,1M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3Z";
var mdiTextBoxMultipleOutline = "M16,15H9V13H16V15M19,11H9V9H19V11M19,7H9V5H19V7M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M21,1A2,2 0 0,1 23,3V17C23,18.11 22.11,19 21,19H7A2,2 0 0,1 5,17V3C5,1.89 5.89,1 7,1H21M7,3V17H21V3H7Z";
var mdiTextBoxOutline = "M5,3C3.89,3 3,3.89 3,5V19C3,20.11 3.89,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.89 20.11,3 19,3H5M5,5H19V19H5V5M7,7V9H17V7H7M7,11V13H17V11H7M7,15V17H14V15H7Z";
var mdiTextBoxPlus = "M17,14H19V17H22V19H19V22H17V19H14V17H17V14M12,17V15H7V17H12M17,11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11M17,9V7H7V9H17Z";
var mdiTextBoxPlusOutline = "M17,14H19V17H22V19H19V22H17V19H14V17H17V14M5,3H19C20.11,3 21,3.89 21,5V12.8C20.39,12.45 19.72,12.2 19,12.08V5H5V19H12.08C12.2,19.72 12.45,20.39 12.8,21H5C3.89,21 3,20.11 3,19V5C3,3.89 3.89,3 5,3M7,7H17V9H7V7M7,11H17V12.08C16.15,12.22 15.37,12.54 14.68,13H7V11M7,15H12V17H7V15Z";
var mdiTextBoxRemove = "M14.46,15.88L15.88,14.46L18,16.59L20.12,14.46L21.54,15.88L19.41,18L21.54,20.12L20.12,21.54L18,19.41L15.88,21.54L14.46,20.12L16.59,18L14.46,15.88M12,17V15H7V17H12M17,11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11M17,9V7H7V9H17Z";
var mdiTextBoxRemoveOutline = "M14.46,15.88L15.88,14.46L18,16.59L20.12,14.46L21.54,15.88L19.41,18L21.54,20.12L20.12,21.54L18,19.41L15.88,21.54L14.46,20.12L16.59,18L14.46,15.88M5,3H19C20.11,3 21,3.89 21,5V12.8C20.39,12.45 19.72,12.2 19,12.08V5H5V19H12.08C12.2,19.72 12.45,20.39 12.8,21H5C3.89,21 3,20.11 3,19V5C3,3.89 3.89,3 5,3M7,7H17V9H7V7M7,11H17V12.08C16.15,12.22 15.37,12.54 14.68,13H7V11M7,15H12V17H7V15Z";
var mdiTextBoxSearch = "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14M7,15V17H9C9.14,18.55 9.8,19.94 10.81,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V13.03C19.85,11.21 17.82,10 15.5,10C14.23,10 13.04,10.37 12.04,11H7V13H10C9.64,13.6 9.34,14.28 9.17,15H7M17,9V7H7V9H17Z";
var mdiTextBoxSearchOutline = "M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14M5,3H19C20.11,3 21,3.89 21,5V13.03C20.5,12.23 19.81,11.54 19,11V5H5V19H9.5C9.81,19.75 10.26,20.42 10.81,21H5C3.89,21 3,20.11 3,19V5C3,3.89 3.89,3 5,3M7,7H17V9H7V7M7,11H12.03C11.23,11.5 10.54,12.19 10,13H7V11M7,15H9.17C9.06,15.5 9,16 9,16.5V17H7V15Z";
var mdiTextLong = "M4,5H20V7H4V5M4,9H20V11H4V9M4,13H20V15H4V13M4,17H14V19H4V17Z";
var mdiTextRecognition = "M2 4C2 2.9 2.9 2 4 2H8V4H4V8H2V4M22 20C22 21.11 21.11 22 20 22H16V20H20V16H22V20M4 22C2.9 22 2 21.11 2 20V16H4V20H8V22H4M20 2C21.11 2 22 2.9 22 4V8H20V4H16V2H20M9 7V9H11V17H13V9H15V7H9Z";
var mdiTextSearch = "M19.31 18.9L22.39 22L21 23.39L17.88 20.32C17.19 20.75 16.37 21 15.5 21C13 21 11 19 11 16.5C11 14 13 12 15.5 12C18 12 20 14 20 16.5C20 17.38 19.75 18.21 19.31 18.9M15.5 19C16.88 19 18 17.88 18 16.5C18 15.12 16.88 14 15.5 14C14.12 14 13 15.12 13 16.5C13 17.88 14.12 19 15.5 19M21 4V6H3V4H21M3 16V14H9V16H3M3 11V9H21V11H18.97C17.96 10.37 16.77 10 15.5 10C14.23 10 13.04 10.37 12.03 11H3Z";
var mdiTextSearchVariant = "M9 6V8H2V6H9M9 11V13H2V11H9M18 16V18H2V16H18M19.31 11.5C19.75 10.82 20 10 20 9.11C20 6.61 18 4.61 15.5 4.61S11 6.61 11 9.11 13 13.61 15.5 13.61C16.37 13.61 17.19 13.36 17.88 12.93L21 16L22.39 14.61L19.31 11.5M15.5 11.61C14.12 11.61 13 10.5 13 9.11S14.12 6.61 15.5 6.61 18 7.73 18 9.11 16.88 11.61 15.5 11.61Z";
var mdiTextShadow = "M3,3H16V6H11V18H8V6H3V3M12,7H14V9H12V7M15,7H17V9H15V7M18,7H20V9H18V7M12,10H14V12H12V10M12,13H14V15H12V13M12,16H14V18H12V16M12,19H14V21H12V19Z";
var mdiTextShort = "M4,9H20V11H4V9M4,13H14V15H4V13Z";
var mdiTexture = "M9.29,21H12.12L21,12.12V9.29M19,21C19.55,21 20.05,20.78 20.41,20.41C20.78,20.05 21,19.55 21,19V17L17,21M5,3A2,2 0 0,0 3,5V7L7,3M11.88,3L3,11.88V14.71L14.71,3M19.5,3.08L3.08,19.5C3.17,19.85 3.35,20.16 3.59,20.41C3.84,20.65 4.15,20.83 4.5,20.92L20.93,4.5C20.74,3.8 20.2,3.26 19.5,3.08Z";
var mdiTextureBox = "M20 2H4C2.9 2 2 2.9 2 4V20C2 21.11 2.9 22 4 22H20C21.11 22 22 21.11 22 20V4C22 2.9 21.11 2 20 2M4 6L6 4H10.9L4 10.9V6M4 13.7L13.7 4H18.6L4 18.6V13.7M20 18L18 20H13.1L20 13.1V18M20 10.3L10.3 20H5.4L20 5.4V10.3Z";
var mdiTheater = "M4,15H6A2,2 0 0,1 8,17V19H9V17A2,2 0 0,1 11,15H13A2,2 0 0,1 15,17V19H16V17A2,2 0 0,1 18,15H20A2,2 0 0,1 22,17V19H23V22H1V19H2V17A2,2 0 0,1 4,15M11,7L15,10L11,13V7M4,2H20A2,2 0 0,1 22,4V13.54C21.41,13.19 20.73,13 20,13V4H4V13C3.27,13 2.59,13.19 2,13.54V4A2,2 0 0,1 4,2Z";
var mdiThemeLightDark = "M7.5,2C5.71,3.15 4.5,5.18 4.5,7.5C4.5,9.82 5.71,11.85 7.53,13C4.46,13 2,10.54 2,7.5A5.5,5.5 0 0,1 7.5,2M19.07,3.5L20.5,4.93L4.93,20.5L3.5,19.07L19.07,3.5M12.89,5.93L11.41,5L9.97,6L10.39,4.3L9,3.24L10.75,3.12L11.33,1.47L12,3.1L13.73,3.13L12.38,4.26L12.89,5.93M9.59,9.54L8.43,8.81L7.31,9.59L7.65,8.27L6.56,7.44L7.92,7.35L8.37,6.06L8.88,7.33L10.24,7.36L9.19,8.23L9.59,9.54M19,13.5A5.5,5.5 0 0,1 13.5,19C12.28,19 11.15,18.6 10.24,17.93L17.93,10.24C18.6,11.15 19,12.28 19,13.5M14.6,20.08L17.37,18.93L17.13,22.28L14.6,20.08M18.93,17.38L20.08,14.61L22.28,17.15L18.93,17.38M20.08,12.42L18.94,9.64L22.28,9.88L20.08,12.42M9.63,18.93L12.4,20.08L9.87,22.27L9.63,18.93Z";
var mdiThermometer = "M15 13V5A3 3 0 0 0 9 5V13A5 5 0 1 0 15 13M12 4A1 1 0 0 1 13 5V8H11V5A1 1 0 0 1 12 4Z";
var mdiThermometerAlert = "M17 13V7H19V13H17M17 17V15H19V17H17M13 13V5C13 3.3 11.7 2 10 2S7 3.3 7 5V13C4.8 14.7 4.3 17.8 6 20S10.8 22.7 13 21 15.7 16.2 14 14C13.7 13.6 13.4 13.3 13 13M10 4C10.6 4 11 4.4 11 5V8H9V5C9 4.4 9.4 4 10 4Z";
var mdiThermometerAuto = "M12 14C11.7 13.6 11.4 13.3 11 13V5C11 3.3 9.7 2 8 2S5 3.3 5 5V13C2.8 14.7 2.3 17.8 4 20S8.8 22.7 11 21 13.7 16.2 12 14M9 8H7V5C7 4.5 7.5 4 8 4S9 4.5 9 5V8M18 3H16L12.8 12H14.7L15.4 10H18.6L19.3 12H21.2L18 3M15.8 8.7L17 5L18.2 8.7H15.8Z";
var mdiThermometerBluetooth = "M11 13V5C11 3.34 9.66 2 8 2S5 3.34 5 5V13C2.79 14.66 2.34 17.79 4 20S8.79 22.66 11 21 13.66 16.21 12 14C11.72 13.62 11.38 13.28 11 13M8 4C8.55 4 9 4.45 9 5V8H7V5C7 4.45 7.45 4 8 4M18 8V11.79L15.71 9.5L15 10.21L17.79 13L15 15.79L15.71 16.5L18 14.21V18H18.5L21.35 15.14L19.21 13L21.35 10.85L18.5 8H18M19 9.91L19.94 10.85L19 11.79V9.91M19 14.21L19.94 15.14L19 16.08V14.21Z";
var mdiThermometerCheck = "M10 13V5C10 3.34 8.66 2 7 2S4 3.34 4 5V13C1.79 14.66 1.34 17.79 3 20S7.79 22.66 10 21 12.66 16.21 11 14C10.72 13.62 10.38 13.28 10 13M7 4C7.55 4 8 4.45 8 5V8H6V5C6 4.45 6.45 4 7 4M16.25 15.16L13.5 12.16L14.66 11L16.25 12.59L19.84 9L21 10.41L16.25 15.16";
var mdiThermometerChevronDown = "M17.41 12.17L14.24 9L12.83 10.41L17.41 15L22 10.41L20.58 9M10 13V5C10 3.34 8.66 2 7 2S4 3.34 4 5V13C1.79 14.66 1.34 17.79 3 20S7.79 22.66 10 21 12.66 16.21 11 14C10.72 13.62 10.38 13.28 10 13M7 4C7.55 4 8 4.45 8 5V8H6V5C6 4.45 6.45 4 7 4Z";
var mdiThermometerChevronUp = "M17.41 11.83L20.58 15L22 13.59L17.41 9L12.82 13.59L14.24 15L17.41 11.83M10 13V5C10 3.34 8.66 2 7 2S4 3.34 4 5V13C1.79 14.66 1.34 17.79 3 20S7.79 22.66 10 21 12.66 16.21 11 14C10.72 13.62 10.38 13.28 10 13M7 4C7.55 4 8 4.45 8 5V8H6V5C6 4.45 6.45 4 7 4Z";
var mdiThermometerHigh = "M15 13V5A3 3 0 0 0 9 5V13A5 5 0 1 0 15 13M12 4A1 1 0 0 1 13 5H11A1 1 0 0 1 12 4Z";
var mdiThermometerLines = "M17 3H21V5H17V3M17 7H21V9H17V7M17 11H21V13H17.75L17 12.1V11M21 15V17H19C19 16.31 18.9 15.63 18.71 15H21M7 3V5H3V3H7M7 7V9H3V7H7M7 11V12.1L6.25 13H3V11H7M3 15H5.29C5.1 15.63 5 16.31 5 17H3V15M15 13V5C15 3.34 13.66 2 12 2S9 3.34 9 5V13C6.79 14.66 6.34 17.79 8 20S12.79 22.66 15 21 17.66 16.21 16 14C15.72 13.62 15.38 13.28 15 13M12 4C12.55 4 13 4.45 13 5V8H11V5C11 4.45 11.45 4 12 4Z";
var mdiThermometerLow = "M15 13V5A3 3 0 0 0 9 5V13A5 5 0 1 0 15 13M12 4A1 1 0 0 1 13 5V12H11V5A1 1 0 0 1 12 4Z";
var mdiThermometerMinus = "M22 11H14V13H22V11M11 13V5C11 3.34 9.66 2 8 2S5 3.34 5 5V13C2.79 14.66 2.34 17.79 4 20S8.79 22.66 11 21 13.66 16.21 12 14C11.72 13.62 11.38 13.28 11 13M8 4C8.55 4 9 4.45 9 5V8H7V5C7 4.45 7.45 4 8 4Z";
var mdiThermometerOff = "M11 7.8L9 5.8V5C9 3.34 10.34 2 12 2S15 3.34 15 5V11.8L11.2 8H13V5C13 4.45 12.55 4 12 4S11 4.45 11 5V7.8M22.11 21.46L2.39 1.73L1.11 3L9 10.89V13C6.79 14.66 6.34 17.79 8 20C9.66 22.21 12.79 22.66 15 21C15.84 20.37 16.4 19.5 16.71 18.6L20.84 22.73L22.11 21.46Z";
var mdiThermometerPlus = "M19 11V8H17V11H14V13H17V16H19V13H22V11M11 13V5C11 3.34 9.66 2 8 2S5 3.34 5 5V13C2.79 14.66 2.34 17.79 4 20S8.79 22.66 11 21 13.66 16.21 12 14C11.72 13.62 11.38 13.28 11 13M8 4C8.55 4 9 4.45 9 5V8H7V5C7 4.45 7.45 4 8 4Z";
var mdiThermometerProbe = "M19.47 3.47L13.47 9.47L10.53 10C10.22 10.03 9.94 10.18 9.72 10.4L2.81 17.31C1.74 18.38 1.74 20.12 2.81 21.2C3.88 22.27 5.62 22.27 6.7 21.2L13.61 14.29C13.83 14.07 14 13.79 14.03 13.5L14.54 10.54L20.54 4.54L22 2L19.47 3.47M11 14.38C10.24 14.38 9.62 13.76 9.62 13S10.24 11.62 11 11.62 12.38 12.24 12.38 13C12.37 13.76 11.76 14.38 11 14.38Z";
var mdiThermometerProbeOff = "M2 3.64L9.24 10.88L2.81 17.31C1.74 18.38 1.74 20.12 2.81 21.2C3.88 22.27 5.62 22.27 6.7 21.2L13.13 14.77L20.73 22.37L22 21.1L3.27 2.37L2 3.64M10.23 11.86L12.14 13.77C11.89 14.14 11.47 14.38 11 14.38C10.24 14.38 9.62 13.76 9.62 13C9.62 12.53 9.86 12.11 10.23 11.86M14.46 11L13 9.55L13.47 9.47L19.47 3.47L22 2L20.54 4.54L14.54 10.54L14.46 11Z";
var mdiThermometerWater = "M10 13V5C10 3.34 8.66 2 7 2S4 3.34 4 5V13C1.79 14.66 1.34 17.79 3 20S7.79 22.66 10 21 12.66 16.21 11 14C10.72 13.62 10.38 13.28 10 13M7 4C7.55 4 8 4.45 8 5V8H6V5C6 4.45 6.45 4 7 4M18 7C18 7 14 11.34 14 14.07C14 19.31 22 19.31 22 14.07C22 11.34 18 7 18 7Z";
var mdiThermostat = "M16.95,16.95L14.83,14.83C15.55,14.1 16,13.1 16,12C16,11.26 15.79,10.57 15.43,10L17.6,7.81C18.5,9 19,10.43 19,12C19,13.93 18.22,15.68 16.95,16.95M12,5C13.57,5 15,5.5 16.19,6.4L14,8.56C13.43,8.21 12.74,8 12,8A4,4 0 0,0 8,12C8,13.1 8.45,14.1 9.17,14.83L7.05,16.95C5.78,15.68 5,13.93 5,12A7,7 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z";
var mdiThermostatAuto = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22C12.4 22 12.7 22 13.1 21.9L15.4 15.3L14.8 14.7C15.5 14 16 13 16 11.9C16 11.2 15.8 10.5 15.4 9.9L17.6 7.7C18.5 9 19 10.4 19 12H20C20.3 12 20.6 12.1 20.8 12.2C20.8 12.2 20.9 12.2 20.9 12.3C21.3 12.5 21.7 12.9 21.9 13.4C22 12.9 22 12.5 22 12C22 6.5 17.5 2 12 2M14 8.6C13.4 8.2 12.7 8 12 8C9.8 8 8 9.8 8 12C8 13.1 8.4 14.1 9.2 14.8L7.1 16.9C5.8 15.7 5 13.9 5 12C5 8.1 8.1 5 12 5C13.6 5 15 5.5 16.2 6.4L14 8.6M20 14H18L14.8 23H16.7L17.4 21H20.6L21.3 23H23.2L20 14M17.8 19.7L19 16L20.2 19.7H17.8Z";
var mdiThermostatBox = "M5,3A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H5M12,5C13.57,5 15,5.5 16.19,6.4L14,8.56C13.43,8.21 12.74,8 12,8A4,4 0 0,0 8,12C8,13.1 8.45,14.1 9.17,14.83L7.05,16.95C5.78,15.68 5,13.93 5,12A7,7 0 0,1 12,5M17.6,7.81C18.5,9 19,10.43 19,12C19,13.93 18.22,15.68 16.95,16.95L14.83,14.83C15.55,14.1 16,13.1 16,12C16,11.26 15.79,10.57 15.43,10L17.6,7.81Z";
var mdiThermostatBoxAuto = "M20 14H18L14.8 23H16.7L17.4 21H20.6L21.3 23H23.2L20 14M17.8 19.7L19 16L20.2 19.7H17.8M15.4 15.4L14.8 14.8C15.5 14.1 16 13.1 16 12C16 11.3 15.8 10.6 15.4 10L17.6 7.8C18.5 9 19 10.4 19 12H21V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H13.4L15.4 15.4M9.2 14.8L7 17C5.7 15.7 5 14 5 12C5 8.1 8.1 5 12 5C13.6 5 15 5.5 16.2 6.4L14 8.6C13.4 8.2 12.7 8 12 8C9.8 8 8 9.8 8 12C8 13.1 8.5 14.1 9.2 14.8Z";
var mdiThermostatCog = "M22 12.66C21.07 12.24 20.07 12 19 12C19 10.43 18.5 9 17.6 7.81L15.43 10C15.79 10.57 16 11.26 16 12C16 12.24 16 12.5 15.94 12.7C13.61 13.84 12 16.23 12 19C12 20.07 12.24 21.07 12.66 22C12.44 22 12.22 22 12 22C10.69 22 9.39 21.74 8.17 21.24C6.96 20.74 5.86 20 4.93 19.07C3.05 17.2 2 14.65 2 12C2 9.35 3.05 6.8 4.93 4.93C5.86 4 6.96 3.26 8.17 2.76C9.39 2.26 10.69 2 12 2C17.5 2 22 6.47 22 12C22 12.22 22 12.44 22 12.66M12 5C10.14 5 8.36 5.74 7.05 7.05C5.74 8.36 5 10.14 5 12C5 13.93 5.78 15.68 7.05 16.95L9.17 14.83C8.45 14.1 8 13.1 8 12C8 10.94 8.42 9.92 9.17 9.17C9.92 8.42 10.94 8 12 8C12.74 8 13.43 8.21 14 8.56L16.19 6.4C15 5.5 13.57 5 12 5M23.83 20.64C23.89 20.53 23.87 20.39 23.77 20.32L22.72 19.5C22.74 19.33 22.75 19.16 22.75 19C22.75 18.84 22.74 18.67 22.72 18.5L23.77 17.68C23.87 17.61 23.89 17.5 23.83 17.36L22.83 15.64C22.77 15.53 22.64 15.5 22.53 15.53L21.28 16L21.14 15.91C20.91 15.77 20.7 15.64 20.44 15.54L20.25 14.21C20.23 14.09 20.13 14 20 14H18C17.88 14 17.77 14.09 17.75 14.21L17.57 15.54C17.3 15.64 17.09 15.78 16.86 15.92L16.72 16L15.5 15.53C15.37 15.5 15.23 15.53 15.17 15.64L14.17 17.36C14.11 17.5 14.14 17.61 14.23 17.68L15.29 18.5L15.29 18.53C15.27 18.69 15.25 18.84 15.25 19C15.25 19.16 15.27 19.31 15.29 19.47C15.29 19.5 15.29 19.5 15.29 19.5L14.23 20.32C14.14 20.39 14.11 20.53 14.17 20.64L15.17 22.37C15.23 22.5 15.37 22.5 15.5 22.5L16.72 21.97C17 22.17 17.25 22.34 17.57 22.47L17.75 23.79C17.77 23.91 17.88 24 18 24H20C20.13 24 20.23 23.91 20.25 23.79L20.44 22.47C20.75 22.34 21 22.17 21.28 21.97L22.53 22.5C22.64 22.5 22.77 22.5 22.83 22.37L23.83 20.64M19 17.25C19.97 17.25 20.75 18.03 20.75 19C20.75 19.97 19.96 20.75 19 20.75C18.04 20.75 17.25 19.97 17.25 19C17.25 18.03 18.03 17.25 19 17.25Z";
var mdiThoughtBubble = "M3.5,19A1.5,1.5 0 0,1 5,20.5A1.5,1.5 0 0,1 3.5,22A1.5,1.5 0 0,1 2,20.5A1.5,1.5 0 0,1 3.5,19M8.5,16A2.5,2.5 0 0,1 11,18.5A2.5,2.5 0 0,1 8.5,21A2.5,2.5 0 0,1 6,18.5A2.5,2.5 0 0,1 8.5,16M14.5,15C13.31,15 12.23,14.5 11.5,13.65C10.77,14.5 9.69,15 8.5,15C6.54,15 4.91,13.59 4.57,11.74C3.07,11.16 2,9.7 2,8A4,4 0 0,1 6,4C6.26,4 6.5,4.03 6.77,4.07C7.5,3.41 8.45,3 9.5,3C10.69,3 11.77,3.5 12.5,4.35C13.23,3.5 14.31,3 15.5,3C17.46,3 19.09,4.41 19.43,6.26C20.93,6.84 22,8.3 22,10A4,4 0 0,1 18,14L17.23,13.93C16.5,14.59 15.55,15 14.5,15Z";
var mdiThoughtBubbleOutline = "M3.5,19A1.5,1.5 0 0,1 5,20.5A1.5,1.5 0 0,1 3.5,22A1.5,1.5 0 0,1 2,20.5A1.5,1.5 0 0,1 3.5,19M8.5,16A2.5,2.5 0 0,1 11,18.5A2.5,2.5 0 0,1 8.5,21A2.5,2.5 0 0,1 6,18.5A2.5,2.5 0 0,1 8.5,16M14.5,15C13.31,15 12.23,14.5 11.5,13.65C10.77,14.5 9.69,15 8.5,15C6.54,15 4.91,13.59 4.57,11.74C3.07,11.16 2,9.7 2,8A4,4 0 0,1 6,4L6.77,4.07C7.5,3.41 8.45,3 9.5,3C10.69,3 11.77,3.5 12.5,4.35C13.23,3.5 14.31,3 15.5,3C17.46,3 19.09,4.41 19.43,6.26C20.93,6.84 22,8.3 22,10A4,4 0 0,1 18,14L17.23,13.93C16.5,14.59 15.55,15 14.5,15M6,6A2,2 0 0,0 4,8A2,2 0 0,0 6,10C6.33,10 6.64,9.92 6.92,9.78C6.66,10.12 6.5,10.54 6.5,11A2,2 0 0,0 8.5,13C9.1,13 9.64,12.73 10,12.31V12.31L11.47,10.63L13,12.34V12.34C13.38,12.74 13.91,13 14.5,13C15.5,13 16.33,12.26 16.5,11.3C16.84,11.73 17.39,12 18,12A2,2 0 0,0 20,10A2,2 0 0,0 18,8C17.67,8 17.36,8.08 17.08,8.22C17.34,7.88 17.5,7.46 17.5,7A2,2 0 0,0 15.5,5C14.91,5 14.38,5.26 14,5.66L12.47,7.37L11,5.69V5.69C10.64,5.27 10.1,5 9.5,5C8.5,5 7.67,5.74 7.5,6.7C7.16,6.27 6.61,6 6,6M8.5,17.5A1,1 0 0,0 7.5,18.5A1,1 0 0,0 8.5,19.5A1,1 0 0,0 9.5,18.5A1,1 0 0,0 8.5,17.5Z";
var mdiThumbDown = "M19,15H23V3H19M15,3H6C5.17,3 4.46,3.5 4.16,4.22L1.14,11.27C1.05,11.5 1,11.74 1,12V14A2,2 0 0,0 3,16H9.31L8.36,20.57C8.34,20.67 8.33,20.77 8.33,20.88C8.33,21.3 8.5,21.67 8.77,21.94L9.83,23L16.41,16.41C16.78,16.05 17,15.55 17,15V5C17,3.89 16.1,3 15,3Z";
var mdiThumbDownOutline = "M19,15V3H23V15H19M15,3A2,2 0 0,1 17,5V15C17,15.55 16.78,16.05 16.41,16.41L9.83,23L8.77,21.94C8.5,21.67 8.33,21.3 8.33,20.88L8.36,20.57L9.31,16H3C1.89,16 1,15.1 1,14V12C1,11.74 1.05,11.5 1.14,11.27L4.16,4.22C4.46,3.5 5.17,3 6,3H15M15,5H5.97L3,12V14H11.78L10.65,19.32L15,14.97V5Z";
var mdiThumbUp = "M23,10C23,8.89 22.1,8 21,8H14.68L15.64,3.43C15.66,3.33 15.67,3.22 15.67,3.11C15.67,2.7 15.5,2.32 15.23,2.05L14.17,1L7.59,7.58C7.22,7.95 7,8.45 7,9V19A2,2 0 0,0 9,21H18C18.83,21 19.54,20.5 19.84,19.78L22.86,12.73C22.95,12.5 23,12.26 23,12V10M1,21H5V9H1V21Z";
var mdiThumbUpOutline = "M5,9V21H1V9H5M9,21A2,2 0 0,1 7,19V9C7,8.45 7.22,7.95 7.59,7.59L14.17,1L15.23,2.06C15.5,2.33 15.67,2.7 15.67,3.11L15.64,3.43L14.69,8H21C22.11,8 23,8.9 23,10V12C23,12.26 22.95,12.5 22.86,12.73L19.84,19.78C19.54,20.5 18.83,21 18,21H9M9,19H18.03L21,12V10H12.21L13.34,4.68L9,9.03V19Z";
var mdiThumbsUpDown = "M22.5,10H15.75C15.13,10 14.6,10.38 14.37,10.91L12.11,16.2C12.04,16.37 12,16.56 12,16.75V18A1,1 0 0,0 13,19H18.18L17.5,22.18V22.42C17.5,22.73 17.63,23 17.83,23.22L18.62,24L23.56,19.06C23.83,18.79 24,18.41 24,18V11.5A1.5,1.5 0 0,0 22.5,10M12,6A1,1 0 0,0 11,5H5.82L6.5,1.82V1.59C6.5,1.28 6.37,1 6.17,0.79L5.38,0L0.44,4.94C0.17,5.21 0,5.59 0,6V12.5A1.5,1.5 0 0,0 1.5,14H8.25C8.87,14 9.4,13.62 9.63,13.09L11.89,7.8C11.96,7.63 12,7.44 12,7.25V6Z";
var mdiThumbsUpDownOutline = "M12 6C12 5.45 11.55 5 11 5H5.82L6.5 1.82L6.5 1.59C6.5 1.28 6.37 1 6.17 .79L5.38 0L.44 4.94C.17 5.21 0 5.59 0 6V12.5C0 13.33 .67 14 1.5 14H8.25C8.87 14 9.4 13.62 9.63 13.09L11.89 7.8C11.96 7.63 12 7.44 12 7.25V6M10 7.13L7.92 12H2V6.21L3.93 4.28L3.36 7H10V7.13M22.5 10H15.75C15.13 10 14.6 10.38 14.37 10.91L12.11 16.2C12.04 16.37 12 16.56 12 16.75V18C12 18.55 12.45 19 13 19H18.18L17.5 22.18L17.5 22.42C17.5 22.73 17.63 23 17.83 23.22L18.62 24L23.56 19.06C23.83 18.79 24 18.41 24 18V11.5C24 10.67 23.33 10 22.5 10M22 17.79L20.07 19.72L20.64 17H14V16.87L16.08 12H22V17.79Z";
var mdiTicket = "M15.58,16.8L12,14.5L8.42,16.8L9.5,12.68L6.21,10L10.46,9.74L12,5.8L13.54,9.74L17.79,10L14.5,12.68M20,12C20,10.89 20.9,10 22,10V6C22,4.89 21.1,4 20,4H4A2,2 0 0,0 2,6V10C3.11,10 4,10.9 4,12A2,2 0 0,1 2,14V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V14A2,2 0 0,1 20,12Z";
var mdiTicketAccount = "M20,12A2,2 0 0,0 22,14V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V14C3.11,14 4,13.1 4,12A2,2 0 0,0 2,10V6C2,4.89 2.9,4 4,4H20A2,2 0 0,1 22,6V10A2,2 0 0,0 20,12M16.5,16.25C16.5,14.75 13.5,14 12,14C10.5,14 7.5,14.75 7.5,16.25V17H16.5V16.25M12,12.25A2.25,2.25 0 0,0 14.25,10A2.25,2.25 0 0,0 12,7.75A2.25,2.25 0 0,0 9.75,10A2.25,2.25 0 0,0 12,12.25Z";
var mdiTicketConfirmation = "M13,8.5H11V6.5H13V8.5M13,13H11V11H13V13M13,17.5H11V15.5H13V17.5M22,10V6C22,4.89 21.1,4 20,4H4A2,2 0 0,0 2,6V10C3.11,10 4,10.9 4,12A2,2 0 0,1 2,14V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V14A2,2 0 0,1 20,12A2,2 0 0,1 22,10Z";
var mdiTicketConfirmationOutline = "M22 10V6C22 4.89 21.1 4 20 4H4C2.9 4 2 4.89 2 6V10C3.11 10 4 10.9 4 12S3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12S20.9 10 22 10M20 8.54C18.81 9.23 18 10.53 18 12S18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.5 5.2 9.23 4 8.54L4 6H20V8.54M11 15H13V17H11M11 11H13V13H11M11 7H13V9H11Z";
var mdiTicketOutline = "M4,4A2,2 0 0,0 2,6V10A2,2 0 0,1 4,12A2,2 0 0,1 2,14V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V14A2,2 0 0,1 20,12A2,2 0 0,1 22,10V6A2,2 0 0,0 20,4H4M4,6H20V8.54C18.76,9.25 18,10.57 18,12C18,13.43 18.76,14.75 20,15.46V18H4V15.46C5.24,14.75 6,13.43 6,12C6,10.57 5.24,9.25 4,8.54V6Z";
var mdiTicketPercent = "M4,4A2,2 0 0,0 2,6V10C3.11,10 4,10.9 4,12A2,2 0 0,1 2,14V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V14A2,2 0 0,1 20,12C20,10.89 20.9,10 22,10V6C22,4.89 21.1,4 20,4H4M15.5,7L17,8.5L8.5,17L7,15.5L15.5,7M8.81,7.04C9.79,7.04 10.58,7.83 10.58,8.81A1.77,1.77 0 0,1 8.81,10.58C7.83,10.58 7.04,9.79 7.04,8.81A1.77,1.77 0 0,1 8.81,7.04M15.19,13.42C16.17,13.42 16.96,14.21 16.96,15.19A1.77,1.77 0 0,1 15.19,16.96C14.21,16.96 13.42,16.17 13.42,15.19A1.77,1.77 0 0,1 15.19,13.42Z";
var mdiTicketPercentOutline = "M14.8 8L16 9.2L9.2 16L8 14.8L14.8 8M4 4H20C21.11 4 22 4.89 22 6V10C20.9 10 20 10.9 20 12C20 13.11 20.9 14 22 14V18C22 19.11 21.11 20 20 20H4C2.9 20 2 19.11 2 18V14C3.11 14 4 13.11 4 12C4 10.9 3.11 10 2 10V6C2 4.89 2.9 4 4 4M4 6V8.54C5.24 9.26 6 10.57 6 12C6 13.43 5.24 14.75 4 15.46V18H20V15.46C18.76 14.75 18 13.43 18 12C18 10.57 18.76 9.26 20 8.54V6H4M9.5 8C10.33 8 11 8.67 11 9.5C11 10.33 10.33 11 9.5 11C8.67 11 8 10.33 8 9.5C8 8.67 8.67 8 9.5 8M14.5 13C15.33 13 16 13.67 16 14.5C16 15.33 15.33 16 14.5 16C13.67 16 13 15.33 13 14.5C13 13.67 13.67 13 14.5 13Z";
var mdiTie = "M6,2L10,6L7,17L12,22L17,17L14,6L18,2Z";
var mdiTilde = "M2,15C2,15 2,9 8,9C12,9 12.5,12.5 15.5,12.5C19.5,12.5 19.5,9 19.5,9H22C22,9 22,15 16,15C12,15 10.5,11.5 8.5,11.5C4.5,11.5 4.5,15 4.5,15H2";
var mdiTildeOff = "M20.84 22.73L10.78 12.67C10 12.03 9.27 11.5 8.5 11.5C4.5 11.5 4.5 15 4.5 15H2C2 15 2 9.59 7.16 9.05L1.11 3L2.39 1.73L10.03 9.37L10.03 9.37L15.64 15L15.63 15L22.11 21.46L20.84 22.73M22 9H19.5C19.5 9 19.5 12.38 15.69 12.5L17.95 14.75C22 13.62 22 9 22 9Z";
var mdiTimelapse = "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.24,7.76C15.07,6.58 13.53,6 12,6V12L7.76,16.24C10.1,18.58 13.9,18.58 16.24,16.24C18.59,13.9 18.59,10.1 16.24,7.76Z";
var mdiTimeline = "M4 2V8H2V2H4M2 22V16H4V22H2M5 12C5 13.11 4.11 14 3 14C1.9 14 1 13.11 1 12C1 10.9 1.9 10 3 10C4.11 10 5 10.9 5 12M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6Z";
var mdiTimelineAlert = "M4 2V8H2V2H4M2 22V16H4V22H2M5 12C5 13.11 4.11 14 3 14C1.9 14 1 13.11 1 12C1 10.9 1.9 10 3 10C4.11 10 5 10.9 5 12M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M15 7V13H17V7H15M15 15V17H17V15H15Z";
var mdiTimelineAlertOutline = "M4 2V8H2V2H4M2 22V16H4V22H2M5 12C5 13.11 4.11 14 3 14C1.9 14 1 13.11 1 12C1 10.9 1.9 10 3 10C4.11 10 5 10.9 5 12M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M10 6V18H22V6H10M15 7H17V13H15V7M15 15H17V17H15V15Z";
var mdiTimelineCheck = "M4 8H2V2H4V8M2 22H4V16H2V22M3 10C1.9 10 1 10.9 1 12C1 13.11 1.9 14 3 14C4.11 14 5 13.11 5 12C5 10.9 4.11 10 3 10M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M19.75 10.33L18.59 8.92L15 12.5L13.41 10.92L12.25 12.08L15 15.08L19.75 10.33Z";
var mdiTimelineCheckOutline = "M22 4H10C8.9 4 8 4.89 8 6V10L6 12L8 14V18C8 19.11 8.9 20 10 20H22C23.11 20 24 19.11 24 18V6C24 4.89 23.11 4 22 4M22 18H10V6H22V18M4 8H2V2H4V8M2 16H4V22H2V16M5 12C5 13.11 4.11 14 3 14C1.9 14 1 13.11 1 12C1 10.9 1.9 10 3 10C4.11 10 5 10.9 5 12M15 15.08L12.25 12.08L13.41 10.92L15 12.5L18.59 8.92L19.75 10.33L15 15.08Z";
var mdiTimelineClock = "M4 2V8H2V2H4M2 22V16H4V22H2M5 12C5 13.11 4.11 14 3 14C1.9 14 1 13.11 1 12C1 10.9 1.9 10 3 10C4.11 10 5 10.9 5 12M16 4C20.42 4 24 7.58 24 12C24 16.42 20.42 20 16 20C12.4 20 9.36 17.62 8.35 14.35L6 12L8.35 9.65C9.36 6.38 12.4 4 16 4M15 13L19.53 15.79L20.33 14.5L16.5 12.2V7H15V13Z";
var mdiTimelineClockOutline = "M4 2V8H2V2H4M2 22V16H4V22H2M5 12C5 13.11 4.11 14 3 14C1.9 14 1 13.11 1 12C1 10.9 1.9 10 3 10C4.11 10 5 10.9 5 12M16 4C20.42 4 24 7.58 24 12C24 16.42 20.42 20 16 20C12.4 20 9.36 17.62 8.35 14.35L6 12L8.35 9.65C9.36 6.38 12.4 4 16 4M16 6C12.69 6 10 8.69 10 12C10 15.31 12.69 18 16 18C19.31 18 22 15.31 22 12C22 8.69 19.31 6 16 6M15 13V8H16.5V12.2L19.5 14L18.68 15.26L15 13Z";
var mdiTimelineMinus = "M4 8H2V2H4V8M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M20 11H12V13H20V11M2 22H4V16H2V22M3 10C1.9 10 1 10.9 1 12C1 13.11 1.9 14 3 14C4.11 14 5 13.11 5 12C5 10.9 4.11 10 3 10Z";
var mdiTimelineMinusOutline = "M2 16H4V22H2V16M4 2H2V8H4V2M20 11H12V13H20V11M3 10C1.9 10 1 10.9 1 12C1 13.11 1.9 14 3 14C4.11 14 5 13.11 5 12C5 10.9 4.11 10 3 10M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M22 6H10V18H22V6Z";
var mdiTimelineOutline = "M4 2V8H2V2H4M2 22V16H4V22H2M5 12C5 13.11 4.11 14 3 14C1.9 14 1 13.11 1 12C1 10.9 1.9 10 3 10C4.11 10 5 10.9 5 12M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M10 6V18H22V6H10Z";
var mdiTimelinePlus = "M4 2V8H2V2H4M2 22V16H4V22H2M5 12C5 13.11 4.11 14 3 14C1.9 14 1 13.11 1 12C1 10.9 1.9 10 3 10C4.11 10 5 10.9 5 12M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M20 11H17V8H15V11H12V13H15V16H17V13H20V11Z";
var mdiTimelinePlusOutline = "M4 2V8H2V2H4M2 22V16H4V22H2M5 12C5 13.11 4.11 14 3 14C1.9 14 1 13.11 1 12C1 10.9 1.9 10 3 10C4.11 10 5 10.9 5 12M20 11V13H17V16H15V13H12V11H15V8H17V11H20M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M10 6V18H22V6H10Z";
var mdiTimelineQuestion = "M4 2V8H2V2H4M2 22V16H4V22H2M5 12C5 13.11 4.11 14 3 14C1.9 14 1 13.11 1 12C1 10.9 1.9 10 3 10C4.11 10 5 10.9 5 12M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M16.5 15.5H15V17H16.5V15.5M14.5 10.5V10C14.5 9.17 15.17 8.5 16 8.5C16.83 8.5 17.5 9.18 17.5 10C17.5 10.47 17.27 10.9 16.88 11.16L16.59 11.35C15.6 12 15 13.11 15 14.3V14.5H16.5V14.3C16.5 13.62 16.84 13 17.41 12.6L17.71 12.41C18.5 11.88 19 10.97 19 10C19 8.34 17.66 7 16 7C14.34 7 13 8.34 13 10V10.5H14.5Z";
var mdiTimelineQuestionOutline = "M5 12C5 13.11 4.11 14 3 14C1.9 14 1 13.11 1 12C1 10.9 1.9 10 3 10C4.11 10 5 10.9 5 12M4 2V8H2V2H4M2 22V16H4V22H2M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M22 6H10V10.83L8.83 12L10 13.17V18H22V6M16.5 15.5V17H15V15.5H16.5M14.5 10.5H13V10C13 8.34 14.34 7 16 7C17.66 7 19 8.34 19 10C19 10.97 18.5 11.88 17.71 12.41L17.41 12.6C16.84 13 16.5 13.62 16.5 14.3V14.5H15V14.3C15 13.11 15.6 12 16.59 11.35L16.88 11.16C17.27 10.9 17.5 10.47 17.5 10C17.5 9.18 16.83 8.5 16 8.5C15.17 8.5 14.5 9.17 14.5 10V10.5Z";
var mdiTimelineRemove = "M4 8H2V2H4V8M2 22H4V16H2V22M3 10C1.9 10 1 10.9 1 12C1 13.11 1.9 14 3 14C4.11 14 5 13.11 5 12C5 10.9 4.11 10 3 10M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M17.41 12L19.53 9.88L18.12 8.47L16 10.59L13.88 8.47L12.47 9.88L14.59 12L12.47 14.12L13.88 15.53L16 13.41L18.12 15.53L19.53 14.12L17.41 12Z";
var mdiTimelineRemoveOutline = "M4 8H2V2H4V8M2 22H4V16H2V22M3 10C1.9 10 1 10.9 1 12C1 13.11 1.9 14 3 14C4.11 14 5 13.11 5 12C5 10.9 4.11 10 3 10M13.88 15.54L16 13.41L18.12 15.53L19.53 14.12L17.41 12L19.53 9.88L18.12 8.47L16 10.59L13.88 8.47L12.47 9.88L14.59 12L12.47 14.12L13.88 15.54M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M22 6H10V18H22V6Z";
var mdiTimelineText = "M4 2V8H2V2H4M2 22H4V16H2V22M5 12C5 10.9 4.11 10 3 10C1.9 10 1 10.9 1 12C1 13.11 1.9 14 3 14C4.11 14 5 13.11 5 12M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M19 13H11V15H19V13M21 9H11V11H21V9Z";
var mdiTimelineTextOutline = "M5 12C5 13.11 4.11 14 3 14C1.9 14 1 13.11 1 12C1 10.9 1.9 10 3 10C4.11 10 5 10.9 5 12M4 2V8H2V2H4M2 22V16H4V22H2M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M22 6H10V10.83L8.83 12L10 13.17V18H22V6M12 9H20V11H12V9M12 13H18V15H12V13Z";
var mdiTimer = "M19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C17 22 21 17.97 21 13C21 10.88 20.26 8.93 19.03 7.39M13 14H11V7H13V14M15 1H9V3H15V1Z";
var mdiTimer10 = "M12.9,13.22C12.9,13.82 12.86,14.33 12.78,14.75C12.7,15.17 12.58,15.5 12.42,15.77C12.26,16.03 12.06,16.22 11.83,16.34C11.6,16.46 11.32,16.5 11,16.5C10.71,16.5 10.43,16.46 10.19,16.34C9.95,16.22 9.75,16.03 9.59,15.77C9.43,15.5 9.3,15.17 9.21,14.75C9.12,14.33 9.08,13.82 9.08,13.22V10.72C9.08,10.12 9.12,9.61 9.21,9.2C9.3,8.79 9.42,8.46 9.59,8.2C9.75,7.95 9.95,7.77 10.19,7.65C10.43,7.54 10.7,7.5 11,7.5C11.31,7.5 11.58,7.54 11.81,7.65C12.05,7.76 12.25,7.94 12.41,8.2C12.57,8.45 12.7,8.78 12.78,9.19C12.86,9.6 12.91,10.11 12.91,10.71V13.22M13.82,7.05C13.5,6.65 13.07,6.35 12.59,6.17C12.12,6 11.58,5.9 11,5.9C10.42,5.9 9.89,6 9.41,6.17C8.93,6.35 8.5,6.64 8.18,7.05C7.84,7.46 7.58,8 7.39,8.64C7.21,9.29 7.11,10.09 7.11,11.03V12.95C7.11,13.89 7.2,14.69 7.39,15.34C7.58,16 7.84,16.53 8.19,16.94C8.53,17.35 8.94,17.65 9.42,17.83C9.9,18 10.43,18.11 11,18.11C11.6,18.11 12.13,18 12.6,17.83C13.08,17.65 13.5,17.35 13.82,16.94C14.16,16.53 14.42,16 14.6,15.34C14.78,14.69 14.88,13.89 14.88,12.95V11.03C14.88,10.09 14.79,9.29 14.6,8.64C14.42,8 14.16,7.45 13.82,7.05M23.78,14.37C23.64,14.09 23.43,13.84 23.15,13.63C22.87,13.42 22.54,13.24 22.14,13.1C21.74,12.96 21.29,12.83 20.79,12.72C20.44,12.65 20.15,12.57 19.92,12.5C19.69,12.41 19.5,12.33 19.37,12.24C19.23,12.15 19.14,12.05 19.09,11.94C19.04,11.83 19,11.7 19,11.55C19,11.41 19.04,11.27 19.1,11.14C19.16,11 19.25,10.89 19.37,10.8C19.5,10.7 19.64,10.62 19.82,10.56C20,10.5 20.22,10.47 20.46,10.47C20.71,10.47 20.93,10.5 21.12,10.58C21.31,10.65 21.47,10.75 21.6,10.87C21.73,11 21.82,11.13 21.89,11.29C21.95,11.45 22,11.61 22,11.78H23.94C23.94,11.39 23.86,11.03 23.7,10.69C23.54,10.35 23.31,10.06 23,9.81C22.71,9.56 22.35,9.37 21.92,9.22C21.5,9.07 21,9 20.46,9C19.95,9 19.5,9.07 19.07,9.21C18.66,9.35 18.3,9.54 18,9.78C17.72,10 17.5,10.3 17.34,10.62C17.18,10.94 17.11,11.27 17.11,11.63C17.11,12 17.19,12.32 17.34,12.59C17.5,12.87 17.7,13.11 18,13.32C18.25,13.53 18.58,13.7 18.96,13.85C19.34,14 19.77,14.11 20.23,14.21C20.62,14.29 20.94,14.38 21.18,14.47C21.42,14.56 21.61,14.66 21.75,14.76C21.88,14.86 21.97,15 22,15.1C22.07,15.22 22.09,15.35 22.09,15.5C22.09,15.81 21.96,16.06 21.69,16.26C21.42,16.46 21.03,16.55 20.5,16.55C20.3,16.55 20.09,16.53 19.88,16.47C19.67,16.42 19.5,16.34 19.32,16.23C19.15,16.12 19,15.97 18.91,15.79C18.8,15.61 18.74,15.38 18.73,15.12H16.84C16.84,15.5 16.92,15.83 17.08,16.17C17.24,16.5 17.47,16.82 17.78,17.1C18.09,17.37 18.47,17.59 18.93,17.76C19.39,17.93 19.91,18 20.5,18C21.04,18 21.5,17.95 21.95,17.82C22.38,17.69 22.75,17.5 23.06,17.28C23.37,17.05 23.6,16.77 23.77,16.45C23.94,16.13 24,15.78 24,15.39C24,15 23.93,14.65 23.78,14.37M0,7.72V9.4L3,8.4V18H5V6H4.75L0,7.72Z";
var mdiTimer3 = "M20.87,14.37C20.73,14.09 20.5,13.84 20.24,13.63C19.96,13.42 19.63,13.24 19.23,13.1C18.83,12.96 18.38,12.83 17.88,12.72C17.53,12.65 17.24,12.57 17,12.5C16.78,12.41 16.6,12.33 16.46,12.24C16.32,12.15 16.23,12.05 16.18,11.94C16.13,11.83 16.1,11.7 16.1,11.55C16.1,11.4 16.13,11.27 16.19,11.14C16.25,11 16.34,10.89 16.46,10.8C16.58,10.7 16.73,10.62 16.91,10.56C17.09,10.5 17.31,10.47 17.55,10.47C17.8,10.47 18,10.5 18.21,10.58C18.4,10.65 18.56,10.75 18.69,10.87C18.82,11 18.91,11.13 19,11.29C19.04,11.45 19.08,11.61 19.08,11.78H21.03C21.03,11.39 20.95,11.03 20.79,10.69C20.63,10.35 20.4,10.06 20.1,9.81C19.8,9.56 19.44,9.37 19,9.22C18.58,9.07 18.09,9 17.55,9C17.04,9 16.57,9.07 16.16,9.21C15.75,9.35 15.39,9.54 15.1,9.78C14.81,10 14.59,10.3 14.43,10.62C14.27,10.94 14.2,11.27 14.2,11.63C14.2,12 14.28,12.31 14.43,12.59C14.58,12.87 14.8,13.11 15.07,13.32C15.34,13.53 15.67,13.7 16.05,13.85C16.43,14 16.86,14.11 17.32,14.21C17.71,14.29 18.03,14.38 18.27,14.47C18.5,14.56 18.7,14.66 18.84,14.76C18.97,14.86 19.06,15 19.11,15.1C19.16,15.22 19.18,15.35 19.18,15.5C19.18,15.81 19.05,16.06 18.78,16.26C18.5,16.46 18.12,16.55 17.61,16.55C17.39,16.55 17.18,16.53 16.97,16.47C16.76,16.42 16.57,16.34 16.41,16.23C16.24,16.12 16.11,15.97 16,15.79C15.89,15.61 15.83,15.38 15.82,15.12H13.93C13.93,15.5 14,15.83 14.17,16.17C14.33,16.5 14.56,16.82 14.87,17.1C15.18,17.37 15.56,17.59 16,17.76C16.5,17.93 17,18 17.6,18C18.13,18 18.61,17.95 19.04,17.82C19.47,17.69 19.84,17.5 20.15,17.28C20.46,17.05 20.69,16.77 20.86,16.45C21.03,16.13 21.11,15.78 21.11,15.39C21.09,15 21,14.65 20.87,14.37M11.61,12.97C11.45,12.73 11.25,12.5 11,12.32C10.74,12.13 10.43,11.97 10.06,11.84C10.36,11.7 10.63,11.54 10.86,11.34C11.09,11.14 11.28,10.93 11.43,10.7C11.58,10.47 11.7,10.24 11.77,10C11.85,9.75 11.88,9.5 11.88,9.26C11.88,8.71 11.79,8.22 11.6,7.8C11.42,7.38 11.16,7.03 10.82,6.74C10.5,6.46 10.09,6.24 9.62,6.1C9.17,5.97 8.65,5.9 8.09,5.9C7.54,5.9 7.03,6 6.57,6.14C6.1,6.31 5.7,6.54 5.37,6.83C5.04,7.12 4.77,7.46 4.59,7.86C4.39,8.25 4.3,8.69 4.3,9.15H6.28C6.28,8.89 6.33,8.66 6.42,8.46C6.5,8.26 6.64,8.08 6.8,7.94C6.97,7.8 7.16,7.69 7.38,7.61C7.6,7.53 7.84,7.5 8.11,7.5C8.72,7.5 9.17,7.65 9.47,7.96C9.77,8.27 9.91,8.71 9.91,9.28C9.91,9.55 9.87,9.8 9.79,10C9.71,10.24 9.58,10.43 9.41,10.59C9.24,10.75 9.03,10.87 8.78,10.96C8.53,11.05 8.23,11.09 7.89,11.09H6.72V12.66H7.9C8.24,12.66 8.54,12.7 8.81,12.77C9.08,12.85 9.31,12.96 9.5,13.12C9.69,13.28 9.84,13.5 9.94,13.73C10.04,13.97 10.1,14.27 10.1,14.6C10.1,15.22 9.92,15.69 9.57,16C9.22,16.35 8.73,16.5 8.12,16.5C7.83,16.5 7.56,16.47 7.32,16.38C7.08,16.3 6.88,16.18 6.71,16C6.54,15.86 6.41,15.68 6.32,15.46C6.23,15.24 6.18,15 6.18,14.74H4.19C4.19,15.29 4.3,15.77 4.5,16.19C4.72,16.61 5,16.96 5.37,17.24C5.73,17.5 6.14,17.73 6.61,17.87C7.08,18 7.57,18.08 8.09,18.08C8.66,18.08 9.18,18 9.67,17.85C10.16,17.7 10.58,17.47 10.93,17.17C11.29,16.87 11.57,16.5 11.77,16.07C11.97,15.64 12.07,15.14 12.07,14.59C12.07,14.3 12.03,14 11.96,13.73C11.88,13.5 11.77,13.22 11.61,12.97Z";
var mdiTimerAlert = "M18.45 5.97C18 5.46 17.55 5 17.04 4.56L15.62 6C14.07 4.74 12.12 4 10 4C5.03 4 1 8.03 1 13S5.03 22 10 22C15 22 19 17.97 19 13C19 10.88 18.26 8.93 17.03 7.39L18.45 5.97M11 14H9V7H11V14M13 3H7V1H13V3M23 7V13H21V7H23M21 15H23V17H21V15Z";
var mdiTimerAlertOutline = "M9 8H11V14H9V8M13 1H7V3H13V1M17.03 7.39C18.26 8.93 19 10.88 19 13C19 17.97 15 22 10 22C5.03 22 1 17.97 1 13S5.03 4 10 4C12.12 4 14.07 4.74 15.62 6L17.04 4.56C17.55 5 18 5.46 18.45 5.97L17.03 7.39M17 13C17 9.13 13.87 6 10 6S3 9.13 3 13 6.13 20 10 20 17 16.87 17 13M21 7V13H23V7H21M21 17H23V15H21V17Z";
var mdiTimerCancel = "M15 3H9V1H15V3M12 18.5C12 19.77 12.37 20.94 13 21.94C12.67 22 12.34 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C20.16 8.81 20.87 10.57 21 12.5C20.22 12.18 19.38 12 18.5 12C14.91 12 12 14.91 12 18.5M13 7H11V14H13V7M23 18.5C23 21 21 23 18.5 23S14 21 14 18.5 16 14 18.5 14 23 16 23 18.5M20 21.08L15.92 17C15.65 17.42 15.5 17.94 15.5 18.5C15.5 20.16 16.84 21.5 18.5 21.5C19.06 21.5 19.58 21.35 20 21.08M21.5 18.5C21.5 16.84 20.16 15.5 18.5 15.5C17.94 15.5 17.42 15.65 17 15.92L21.08 20C21.35 19.58 21.5 19.06 21.5 18.5Z";
var mdiTimerCancelOutline = "M11 8H13V14H11V8M15 1H9V3H15V1M12 20C8.13 20 5 16.87 5 13S8.13 6 12 6C15.54 6 18.45 8.62 18.93 12.03C19.65 12.08 20.34 12.23 21 12.5C20.87 10.57 20.16 8.81 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.34 22 12.67 22 13 21.94C12.63 21.35 12.35 20.69 12.18 20C12.12 20 12.06 20 12 20M23 18.5C23 21 21 23 18.5 23S14 21 14 18.5 16 14 18.5 14 23 16 23 18.5M20 21.08L15.92 17C15.65 17.42 15.5 17.94 15.5 18.5C15.5 20.16 16.84 21.5 18.5 21.5C19.06 21.5 19.58 21.35 20 21.08M21.5 18.5C21.5 16.84 20.16 15.5 18.5 15.5C17.94 15.5 17.42 15.65 17 15.92L21.08 20C21.35 19.58 21.5 19.06 21.5 18.5Z";
var mdiTimerCheck = "M15 3H9V1H15V3M13 19C13 20.03 13.26 21 13.71 21.83C13.16 21.94 12.59 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C20.26 8.93 21 10.88 21 13C21 13.12 21 13.23 21 13.35C20.36 13.13 19.7 13 19 13C15.69 13 13 15.69 13 19M13 7H11V14H13V7M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiTimerCheckOutline = "M11 8H13V14H11V8M15 1H9V3H15V1M12 20C8.13 20 5 16.87 5 13S8.13 6 12 6 19 9.13 19 13C19.7 13 20.36 13.13 21 13.35C21 13.23 21 13.12 21 13C21 10.88 20.26 8.93 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.59 22 13.16 21.94 13.71 21.83C13.4 21.25 13.18 20.6 13.08 19.91C12.72 19.96 12.37 20 12 20M21.34 15.84L17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84Z";
var mdiTimerCog = "M22.8 19.4C22.9 19.4 22.9 19.5 22.8 19.6L21.8 21.3C21.7 21.4 21.6 21.4 21.5 21.4L20.3 21C20 21.2 19.8 21.3 19.5 21.5L19.3 22.8C19.3 22.9 19.2 23 19.1 23H17.1C17 23 16.9 22.9 16.8 22.8L16.6 21.5C16.3 21.4 16 21.2 15.8 21L14.6 21.5C14.5 21.5 14.4 21.5 14.3 21.4L13.3 19.7C13.2 19.6 13.3 19.5 13.4 19.4L14.5 18.6V17.6L13.4 16.8C13.3 16.7 13.3 16.6 13.3 16.5L14.3 14.8C14.4 14.7 14.5 14.7 14.6 14.7L15.8 15.2C16.1 15 16.3 14.9 16.6 14.7L16.8 13.4C16.8 13.3 16.9 13.2 17.1 13.2H19.1C19.2 13.2 19.3 13.3 19.3 13.4L19.5 14.7C19.8 14.8 20.1 15 20.4 15.2L21.6 14.7C21.7 14.7 21.9 14.7 21.9 14.8L22.9 16.5C23 16.6 22.9 16.7 22.8 16.8L21.7 17.6V18.6L22.8 19.4M19.5 18C19.5 17.2 18.8 16.5 18 16.5S16.5 17.2 16.5 18 17.2 19.5 18 19.5 19.5 18.8 19.5 18M11 18C11 16.5 11.5 15.1 12.3 14H11V7H13V13.1C14.3 11.8 16 11 18 11C19 11 20 11.2 20.9 11.6C20.6 10 20 8.6 19 7.4L20.5 6C20 5.5 19.5 5 19 4.6L17.6 6C16.1 4.7 14.1 4 12 4C7 4 3 8 3 13S7 22 12 22H12.3C11.5 20.9 11 19.5 11 18M15 1H9V3H15V1Z";
var mdiTimerCogOutline = "M22.8 19.4C22.9 19.4 22.9 19.5 22.8 19.6L21.8 21.3C21.7 21.4 21.6 21.4 21.5 21.4L20.3 21C20 21.2 19.8 21.3 19.5 21.5L19.3 22.8C19.3 22.9 19.2 23 19.1 23H17.1C17 23 16.9 22.9 16.8 22.8L16.6 21.5C16.3 21.4 16 21.2 15.8 21L14.6 21.5C14.5 21.5 14.4 21.5 14.3 21.4L13.3 19.7C13.2 19.6 13.3 19.5 13.4 19.4L14.5 18.6V17.6L13.4 16.8C13.3 16.7 13.3 16.6 13.3 16.5L14.3 14.8C14.4 14.7 14.5 14.7 14.6 14.7L15.8 15.2C16.1 15 16.3 14.9 16.6 14.7L16.8 13.4C16.8 13.3 16.9 13.2 17.1 13.2H19.1C19.2 13.2 19.3 13.3 19.3 13.4L19.5 14.7C19.8 14.8 20.1 15 20.4 15.2L21.6 14.7C21.7 14.7 21.9 14.7 21.9 14.8L22.9 16.5C23 16.6 22.9 16.7 22.8 16.8L21.7 17.6V18.6L22.8 19.4M19.5 18C19.5 17.2 18.8 16.5 18 16.5S16.5 17.2 16.5 18 17.2 19.5 18 19.5 19.5 18.8 19.5 18M13 14V8H11V14M15 1H9V3H15V1M11.3 20C7.8 19.6 5 16.6 5 13C5 9.1 8.1 6 12 6C15.2 6 17.9 8.1 18.7 11C19.5 11.1 20.2 11.3 20.9 11.6C20.6 10 20 8.6 19 7.4L20.5 6C20 5.5 19.5 5 19 4.6L17.6 6C16.1 4.7 14.1 4 12 4C7 4 3 8 3 13S7 22 12 22H12.3C11.8 21.4 11.5 20.7 11.3 20Z";
var mdiTimerEdit = "M15 3H9V1H15V3M19.39 10.74L11 19.13V21.94C6.5 21.44 3 17.63 3 13C3 8.03 7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C19.67 8.19 20.17 9.11 20.5 10.1C20.1 10.21 19.71 10.42 19.39 10.74M13 7H11V14H13V7M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47Z";
var mdiTimerEditOutline = "M13 14H11V8H13V14M15 1H9V3H15V1M5 13C5 9.13 8.13 6 12 6C15.29 6 18.05 8.28 18.79 11.34L19.39 10.74C19.71 10.42 20.1 10.21 20.5 10.1C20.18 9.11 19.67 8.19 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13C3 17.63 6.5 21.44 11 21.94V19.92C7.61 19.43 5 16.53 5 13M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47Z";
var mdiTimerLock = "M15 3H9V1H15V3M14.2 14.5V14.74C13.5 15.34 13 16.24 13 17.2V20.7C13 21.12 13.09 21.53 13.24 21.91C12.83 21.96 12.42 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C19.71 8.24 20.23 9.22 20.57 10.28C20.07 10.11 19.55 10 19 10C16.4 10 14.2 12.06 14.2 14.5M13 7H11V14H13V7M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiTimerLockOpen = "M15 3H9V1H15V3M14.2 13.5V14.74C13.5 15.34 13 16.24 13 17.2V20.7C13 21.12 13.09 21.53 13.24 21.91C12.83 21.96 12.42 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C19.46 7.93 19.82 8.5 20.12 9.14C19.76 9.06 19.39 9 19 9C16.4 9 14.2 11.06 14.2 13.5M13 7H11V14H13V7M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiTimerLockOpenOutline = "M11 8H13V14H11V8M13 19.92C12.67 19.97 12.34 20 12 20C8.13 20 5 16.87 5 13S8.13 6 12 6C14.44 6 16.59 7.26 17.85 9.15C18.22 9.06 18.6 9 19 9C19.39 9 19.76 9.06 20.12 9.14C19.82 8.5 19.46 7.93 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.42 22 12.83 21.96 13.24 21.91C13.09 21.53 13 21.12 13 20.7V19.92M15 1H9V3H15V1M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiTimerLockOutline = "M11 8H13V14H11V8M13 19.92C12.67 19.97 12.34 20 12 20C8.13 20 5 16.87 5 13S8.13 6 12 6C14.82 6 17.24 7.67 18.35 10.06C18.56 10.04 18.78 10 19 10C19.55 10 20.07 10.11 20.57 10.28C20.23 9.22 19.71 8.24 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.42 22 12.83 21.96 13.24 21.91C13.09 21.53 13 21.12 13 20.7V19.92M15 1H9V3H15V1M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiTimerMarker = "M15 3H9V1H15V3M13 15.5C13 17.5 14.28 19.73 15.42 21.33C14.37 21.76 13.21 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C19.74 8.28 20.29 9.32 20.62 10.44C19.97 10.16 19.25 10 18.5 10C15.5 10 13 12.5 13 15.5M13 14V7H11V14H13M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiTimerMarkerOutline = "M11 8H13V14H11V8M15 1H9V3H15V1M12 20C8.13 20 5 16.87 5 13S8.13 6 12 6C14.79 6 17.2 7.64 18.32 10C18.38 10 18.44 10 18.5 10C19.25 10 19.97 10.16 20.62 10.44C20.29 9.32 19.74 8.28 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C13.21 22 14.37 21.76 15.42 21.33C15.05 20.81 14.67 20.22 14.32 19.6C13.59 19.85 12.81 20 12 20M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiTimerMinus = "M19 13C19.7 13 20.36 13.13 21 13.35C21 13.23 21 13.12 21 13C21 10.88 20.26 8.93 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.59 22 13.16 21.94 13.71 21.83C13.26 21 13 20.03 13 19C13 15.69 15.69 13 19 13M13 14H11V7H13V14M15 3H9V1H15V3M23 18V20H15V18H23Z";
var mdiTimerMinusOutline = "M11 8H13V14H11V8M15 1H9V3H15V1M12 20C8.13 20 5 16.87 5 13S8.13 6 12 6 19 9.13 19 13C19.7 13 20.36 13.13 21 13.35C21 13.23 21 13.12 21 13C21 10.88 20.26 8.93 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.59 22 13.16 21.94 13.71 21.83C13.4 21.25 13.18 20.6 13.08 19.91C12.72 19.96 12.37 20 12 20M15 18V20H23V18H15Z";
var mdiTimerMusic = "M16.5 16.11V11H20.77C20.46 9.66 19.86 8.43 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.42 22 12.83 21.96 13.24 21.91C13.09 21.46 13 21 13 20.5C13 18.36 14.5 16.57 16.5 16.11M13 14H11V7H13V14M15 3H9V1H15V3M22 13V15H20V20.5C20 21.88 18.88 23 17.5 23S15 21.88 15 20.5 16.12 18 17.5 18C17.86 18 18.19 18.07 18.5 18.21V13H22Z";
var mdiTimerMusicOutline = "M15 3H9V1H15V3M11 14H13V8H11V14M13.05 19.91C12.71 19.97 12.36 20 12 20C8.13 20 5 16.87 5 13S8.13 6 12 6C15.17 6 17.85 8.11 18.71 11H20.77C20.46 9.66 19.86 8.43 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.42 22 12.83 21.96 13.24 21.91C13.09 21.46 13 21 13 20.5C13 20.3 13.03 20.11 13.05 19.91M18.5 13V18.21C18.19 18.07 17.86 18 17.5 18C16.12 18 15 19.12 15 20.5S16.12 23 17.5 23 20 21.88 20 20.5V15H22V13H18.5Z";
var mdiTimerOff = "M3 4L1.75 5.27L4.5 8.03C3.55 9.45 3 11.16 3 13C3 17.97 7.03 22 12 22C13.84 22 15.55 21.45 17 20.5L19.5 23L20.75 21.73L13.04 14L3 4M15 1H9V3H15M21 13C21 14.83 20.45 16.53 19.5 17.94L13 11.45V7H11V9.45L7.05 5.5C8.47 4.55 10.17 4 12 4C14.12 4 16.07 4.74 17.62 5.97L19.04 4.55L20.45 5.97L19.03 7.39C20.26 8.93 21 10.88 21 13Z";
var mdiTimerOffOutline = "M12,20A7,7 0 0,1 5,13C5,11.72 5.35,10.5 5.95,9.5L15.5,19.04C14.5,19.65 13.28,20 12,20M3,4L1.75,5.27L4.5,8.03C3.55,9.45 3,11.16 3,13A9,9 0 0,0 12,22C13.84,22 15.55,21.45 17,20.5L19.5,23L20.75,21.73L13.04,14L3,4M11,9.44L13,11.44V8H11M15,1H9V3H15M19.04,4.55L17.62,5.97C16.07,4.74 14.12,4 12,4C10.17,4 8.47,4.55 7.05,5.5L8.5,6.94C9.53,6.35 10.73,6 12,6A7,7 0 0,1 19,13C19,14.27 18.65,15.47 18.06,16.5L19.5,17.94C20.45,16.53 21,14.83 21,13C21,10.88 20.26,8.93 19.03,7.39L20.45,5.97L19.04,4.55Z";
var mdiTimerOutline = "M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M19.03,7.39L20.45,5.97C20,5.46 19.55,5 19.04,4.56L17.62,6C16.07,4.74 14.12,4 12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22C17,22 21,17.97 21,13C21,10.88 20.26,8.93 19.03,7.39M11,14H13V8H11M15,1H9V3H15V1Z";
var mdiTimerPause = "M16.5 16.5H18.38V21.5H16.5V16.5M19.63 16.5V21.5H21.5V16.5H19.63M15 1H9V3H15V1M21 13.35C20.36 13.13 19.7 13 19 13C15.69 13 13 15.69 13 19C13 20.03 13.26 21 13.71 21.83C13.16 21.94 12.59 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C20.26 8.93 21 10.88 21 13C21 13.12 21 13.23 21 13.35M13 7H11V14H13V7Z";
var mdiTimerPauseOutline = "M21 13.35C20.36 13.13 19.7 13 19 13C19 9.13 15.87 6 12 6S5 9.13 5 13 8.13 20 12 20C12.37 20 12.72 19.96 13.08 19.91C13.18 20.6 13.4 21.25 13.71 21.83C13.16 21.94 12.59 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C20.26 8.93 21 10.88 21 13C21 13.12 21 13.23 21 13.35M11 14H13V8H11V14M15 1H9V3H15V1M19.63 16.5V21.5H21.5V16.5H19.63M16.5 21.5H18.38V16.5H16.5V21.5Z";
var mdiTimerPlay = "M15 3H9V1H15V3M13 19C13 20.03 13.26 21 13.71 21.83C13.16 21.94 12.59 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C20.26 8.93 21 10.88 21 13C21 13.12 21 13.23 21 13.35C20.36 13.13 19.7 13 19 13C15.69 13 13 15.69 13 19M13 7H11V14H13V7M17 16V22L22 19L17 16Z";
var mdiTimerPlayOutline = "M15 3H9V1H15V3M11 14H13V8H11V14M19 13C19.7 13 20.36 13.13 21 13.35C21 13.23 21 13.12 21 13C21 10.88 20.26 8.93 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.59 22 13.16 21.94 13.71 21.83C13.4 21.25 13.18 20.6 13.08 19.91C12.72 19.96 12.37 20 12 20C8.13 20 5 16.87 5 13S8.13 6 12 6 19 9.13 19 13M17 16V22L22 19L17 16Z";
var mdiTimerPlus = "M15 3H9V1H15V3M13 19C13 20.03 13.26 21 13.71 21.83C13.16 21.94 12.59 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C20.26 8.93 21 10.88 21 13C21 13.12 21 13.23 21 13.35C20.36 13.13 19.7 13 19 13C15.69 13 13 15.69 13 19M13 7H11V14H13V7M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiTimerPlusOutline = "M11 8H13V14H11V8M15 1H9V3H15V1M12 20C8.13 20 5 16.87 5 13S8.13 6 12 6 19 9.13 19 13C19.7 13 20.36 13.13 21 13.35C21 13.23 21 13.12 21 13C21 10.88 20.26 8.93 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.59 22 13.16 21.94 13.71 21.83C13.4 21.25 13.18 20.6 13.08 19.91C12.72 19.96 12.37 20 12 20M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiTimerRefresh = "M15 3H9V1H15V3M12 18.5C12 19.77 12.37 20.94 13 21.94C12.67 22 12.34 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C20.16 8.81 20.87 10.57 21 12.5C20.22 12.18 19.38 12 18.5 12C14.91 12 12 14.91 12 18.5M13 7H11V14H13V7M22 18.5V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22Z";
var mdiTimerRefreshOutline = "M11 8H13V14H11V8M15 1H9V3H15V1M12 20C8.13 20 5 16.87 5 13S8.13 6 12 6C15.54 6 18.45 8.62 18.93 12.03C19.65 12.08 20.34 12.23 21 12.5C20.87 10.57 20.16 8.81 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.34 22 12.67 22 13 21.94C12.63 21.35 12.35 20.69 12.18 20C12.12 20 12.06 20 12 20M22 18.5V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22Z";
var mdiTimerRemove = "M15 3H9V1H15V3M13 19C13 20.03 13.26 21 13.71 21.83C13.16 21.94 12.59 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C20.26 8.93 21 10.88 21 13C21 13.12 21 13.23 21 13.35C20.36 13.13 19.7 13 19 13C15.69 13 13 15.69 13 19M13 7H11V14H13V7M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiTimerRemoveOutline = "M13.08 19.91C13.18 20.6 13.4 21.25 13.71 21.83C13.16 21.94 12.59 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C20.26 8.93 21 10.88 21 13C21 13.12 21 13.23 21 13.35C20.36 13.13 19.7 13 19 13C19 9.13 15.87 6 12 6S5 9.13 5 13 8.13 20 12 20C12.37 20 12.72 19.96 13.08 19.91M11 14H13V8H11V14M15 1H9V3H15V1M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88Z";
var mdiTimerSand = "M6,2H18V8H18V8L14,12L18,16V16H18V22H6V16H6V16L10,12L6,8V8H6V2M16,16.5L12,12.5L8,16.5V20H16V16.5M12,11.5L16,7.5V4H8V7.5L12,11.5M10,6H14V6.75L12,8.75L10,6.75V6Z";
var mdiTimerSandComplete = "M18 22H6V16L10 12L6 8V2H18V8L14 12L18 16M8 7.5L12 11.5L16 7.5V4H8M12 12.5L8 16.5V20H16V16.5M14 18H10V17.2L12 15.2L14 17.2Z";
var mdiTimerSandEmpty = "M6,2V8H6V8L10,12L6,16V16H6V22H18V16H18V16L14,12L18,8V8H18V2H6M16,16.5V20H8V16.5L12,12.5L16,16.5M12,11.5L8,7.5V4H16V7.5L12,11.5Z";
var mdiTimerSandFull = "M6,2V8H6V8L10,12L6,16V16H6V22H18V16H18V16L14,12L18,8V8H18V2H6Z";
var mdiTimerSandPaused = "M22 6V18H16L12 14L8 18H2V6H8L12 10L16 6M7.5 16L11.5 12L7.5 8H4V16M12.5 12L16.5 16H20V8H16.5M18 12V14H17.2L15.2 12M8.8 12L6.8 14H6V12Z";
var mdiTimerSettings = "M19 6.4L20.5 5C20 4.5 19.5 4 19 3.6L17.6 5C16 3.7 14.1 3 12 3C7 3 3 7 3 12S7 21 12 21C17 21 21 17 21 12C21 9.9 20.3 7.9 19 6.4M13 13H11V6H13V13M15 0H9V2H15V0M13 24H11V22H13V24M17 24H15V22H17V24M9 24H7V22H9V24Z";
var mdiTimerSettingsOutline = "M12 19C8.1 19 5 15.9 5 12S8.1 5 12 5 19 8.1 19 12 15.9 19 12 19M19 6.4L20.5 5C20 4.5 19.5 4 19 3.6L17.6 5C16 3.7 14.1 3 12 3C7 3 3 7 3 12S7 21 12 21C17 21 21 17 21 12C21 9.9 20.3 7.9 19 6.4M11 13H13V7H11M15 0H9V2H15V0M13 22H11V24H13V22M17 22H15V24H17V22M9 22H7V24H9V22Z";
var mdiTimerStar = "M15 3H9V1H15V3M13 19C13 20.03 13.26 21 13.71 21.83C13.16 21.94 12.59 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C20.26 8.93 21 10.88 21 13C21 13.12 21 13.23 21 13.35C20.36 13.13 19.7 13 19 13C15.69 13 13 15.69 13 19M13 7H11V14H13V7M23 17.89L20.11 17.64L19 15L17.87 17.64L15 17.89L17.18 19.77L16.5 22.58L19 21.09L21.45 22.58L20.8 19.77L23 17.89Z";
var mdiTimerStarOutline = "M11 8H13V14H11V8M15 1H9V3H15V1M12 20C8.13 20 5 16.87 5 13S8.13 6 12 6 19 9.13 19 13C19.7 13 20.36 13.13 21 13.35C21 13.23 21 13.12 21 13C21 10.88 20.26 8.93 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.59 22 13.16 21.94 13.71 21.83C13.4 21.25 13.18 20.6 13.08 19.91C12.72 19.96 12.37 20 12 20M23 17.89L20.11 17.64L19 15L17.87 17.64L15 17.89L17.18 19.77L16.5 22.58L19 21.09L21.45 22.58L20.8 19.77L23 17.89Z";
var mdiTimerStop = "M19 13C19.7 13 20.36 13.13 21 13.35C21 13.23 21 13.12 21 13C21 10.88 20.26 8.93 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.59 22 13.16 21.94 13.71 21.83C13.26 21 13 20.03 13 19C13 15.69 15.69 13 19 13M13 14H11V7H13V14M15 3H9V1H15V3M21.5 16.5V21.5H16.5V16.5H21.5Z";
var mdiTimerStopOutline = "M11 8H13V14H11V8M12 20C8.13 20 5 16.87 5 13S8.13 6 12 6 19 9.13 19 13C19.7 13 20.36 13.13 21 13.35C21 13.23 21 13.12 21 13C21 10.88 20.26 8.93 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.59 22 13.16 21.94 13.71 21.83C13.4 21.25 13.18 20.6 13.08 19.91C12.72 19.96 12.37 20 12 20M15 1H9V3H15V1M16.5 16.5V21.5H21.5V16.5H16.5Z";
var mdiTimerSync = "M15 3H9V1H15V3M13 17.5C13 19.08 13.56 20.5 14.5 21.65C13.7 21.87 12.87 22 12 22C7.03 22 3 17.97 3 13S7.03 4 12 4C14.12 4 16.07 4.74 17.62 6L19.04 4.56C19.55 5 20 5.46 20.45 5.97L19.03 7.39C19.89 8.46 20.5 9.74 20.8 11.13C20.38 11.05 19.94 11 19.5 11C15.91 11 13 13.91 13 17.5M13 7H11V14H13V7M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20Z";
var mdiTimerSyncOutline = "M11 8H13V14H11V8M12 20C8.13 20 5 16.87 5 13S8.13 6 12 6C15.19 6 17.88 8.14 18.72 11.05C19 11 19.24 11 19.5 11C19.94 11 20.38 11.05 20.8 11.13C20.5 9.74 19.89 8.46 19.03 7.39L20.45 5.97C20 5.46 19.55 5 19.04 4.56L17.62 6C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13S7.03 22 12 22C12.87 22 13.7 21.87 14.5 21.65C14.05 21.11 13.7 20.5 13.45 19.85C13 19.95 12.5 20 12 20M15 1H9V3H15V1M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20Z";
var mdiTimetable = "M14,12H15.5V14.82L17.94,16.23L17.19,17.53L14,15.69V12M4,2H18A2,2 0 0,1 20,4V10.1C21.24,11.36 22,13.09 22,15A7,7 0 0,1 15,22C13.09,22 11.36,21.24 10.1,20H4A2,2 0 0,1 2,18V4A2,2 0 0,1 4,2M4,15V18H8.67C8.24,17.09 8,16.07 8,15H4M4,8H10V5H4V8M18,8V5H12V8H18M4,13H8.29C8.63,11.85 9.26,10.82 10.1,10H4V13M15,10.15A4.85,4.85 0 0,0 10.15,15C10.15,17.68 12.32,19.85 15,19.85A4.85,4.85 0 0,0 19.85,15C19.85,12.32 17.68,10.15 15,10.15Z";
var mdiTire = "M19.66 9.64L19.3 8.7L21.16 8C20.24 5.88 18.6 4.18 16.54 3.14L15.74 4.92L14.82 4.5L15.62 2.7C14.5 2.26 13.28 2 12 2C10.94 2 9.92 2.22 8.96 2.5L9.64 4.34L8.7 4.7L8 2.84C5.88 3.76 4.18 5.4 3.14 7.46L4.92 8.26L4.5 9.18L2.7 8.38C2.26 9.5 2 10.72 2 12C2 13.06 2.22 14.08 2.5 15.04L4.34 14.36L4.7 15.3L2.84 16C3.76 18.12 5.4 19.82 7.46 20.86L8.26 19.08L9.18 19.5L8.38 21.3C9.5 21.74 10.72 22 12 22C13.06 22 14.08 21.78 15.04 21.5L14.36 19.66L15.3 19.3L16 21.16C18.12 20.24 19.82 18.6 20.86 16.54L19.08 15.74L19.5 14.82L21.3 15.62C21.74 14.5 22 13.28 22 12C22 10.94 21.78 9.92 21.5 8.96L19.66 9.64M14.3 17.54C11.24 18.8 7.72 17.36 6.46 14.3S6.64 7.72 9.7 6.46 16.28 6.64 17.54 9.7C18.82 12.76 17.36 16.28 14.3 17.54Z";
var mdiToaster = "M21 11A2 2 0 0 0 19 9H5A2 2 0 0 0 3 11H2V13H3V20H21V13H22V11M17 15A2 2 0 1 1 19 13A2 2 0 0 1 17 15M18 8H6C6.33 5.75 8.88 4 12 4S17.63 5.75 18 8Z";
var mdiToasterOff = "M20.8 22.7L18.1 20H3V13H2V11H3C3 9.9 3.9 9 5 9H7.1L1.1 3L2.4 1.7L22.1 21.4L20.8 22.7M15.3 12.1C15.6 11.5 16.3 11 17 11C18.1 11 19 11.9 19 13C19 13.8 18.6 14.4 17.9 14.7L21 17.8V13H22V11H21C21 9.9 20.1 9 19 9H12.2L15.3 12.1M18 8C17.6 5.8 15.1 4 12 4C10.6 4 9.2 4.4 8.2 5L11.2 8H18Z";
var mdiToasterOven = "M4,5A2,2 0 0,0 2,7V17A2,2 0 0,0 4,19H20A2,2 0 0,0 22,17V7A2,2 0 0,0 20,5H4M4,7H16V17H4V7M19,7A1,1 0 0,1 20,8A1,1 0 0,1 19,9A1,1 0 0,1 18,8A1,1 0 0,1 19,7M6,9V11H14V9H6M19,11A1,1 0 0,1 20,12A1,1 0 0,1 19,13A1,1 0 0,1 18,12A1,1 0 0,1 19,11Z";
var mdiToggleSwitch = "M17,7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7M17,15A3,3 0 0,1 14,12A3,3 0 0,1 17,9A3,3 0 0,1 20,12A3,3 0 0,1 17,15Z";
var mdiToggleSwitchOff = "M17,7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7M7,15A3,3 0 0,1 4,12A3,3 0 0,1 7,9A3,3 0 0,1 10,12A3,3 0 0,1 7,15Z";
var mdiToggleSwitchOffOutline = "M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zM7 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z";
var mdiToggleSwitchOutline = "M17 6H7C3.69 6 1 8.69 1 12S3.69 18 7 18H17C20.31 18 23 15.31 23 12S20.31 6 17 6M17 16H7C4.79 16 3 14.21 3 12S4.79 8 7 8H17C19.21 8 21 9.79 21 12S19.21 16 17 16M17 9C15.34 9 14 10.34 14 12S15.34 15 17 15 20 13.66 20 12 18.66 9 17 9Z";
var mdiToggleSwitchVariant = "M18.4 1.6C18 1.2 17.5 1 17 1H7C6.5 1 6 1.2 5.6 1.6C5.2 2 5 2.5 5 3V21C5 21.5 5.2 22 5.6 22.4C6 22.8 6.5 23 7 23H17C17.5 23 18 22.8 18.4 22.4C18.8 22 19 21.5 19 21V3C19 2.5 18.8 2 18.4 1.6M16 7C16 7.6 15.6 8 15 8H9C8.4 8 8 7.6 8 7V5C8 4.4 8.4 4 9 4H15C15.6 4 16 4.4 16 5V7Z";
var mdiToggleSwitchVariantOff = "M5.6 1.6C6 1.2 6.5 1 7 1H17C17.5 1 18 1.2 18.4 1.6C18.8 2 19 2.5 19 3V21C19 21.5 18.8 22 18.4 22.4C18 22.8 17.5 23 17 23H7C6.5 23 6 22.8 5.6 22.4C5.2 22 5 21.5 5 21V3C5 2.5 5.2 2 5.6 1.6M8 3C7.4 3 7 3.4 7 4V20C7 20.6 7.4 21 8 21H16C16.6 21 17 20.6 17 20V4C17 3.4 16.6 3 16 3H8M8 17C8 16.4 8.4 16 9 16H15C15.6 16 16 16.4 16 17V19C16 19.6 15.6 20 15 20H9C8.4 20 8 19.6 8 19V17Z";
var mdiToilet = "M9,22H17V19.5C19.41,17.87 21,15.12 21,12V4A2,2 0 0,0 19,2H15C13.89,2 13,2.9 13,4V12H3C3,15.09 5,18 9,19.5V22M5.29,14H18.71C18.14,15.91 16.77,17.5 15,18.33V20H11V18.33C9,18 5.86,15.91 5.29,14M15,4H19V12H15V4M16,5V8H18V5H16Z";
var mdiToolbox = "M18 16H16V15H8V16H6V15H2V20H22V15H18V16M20 8H17V6C17 4.9 16.1 4 15 4H9C7.9 4 7 4.9 7 6V8H4C2.9 8 2 8.9 2 10V14H6V12H8V14H16V12H18V14H22V10C22 8.9 21.1 8 20 8M15 8H9V6H15V8Z";
var mdiToolboxOutline = "M20 8H17V6C17 4.9 16.1 4 15 4H9C7.9 4 7 4.9 7 6V8H4C2.9 8 2 8.9 2 10V20H22V10C22 8.9 21.1 8 20 8M9 6H15V8H9V6M20 18H4V15H6V16H8V15H16V16H18V15H20V18M18 13V12H16V13H8V12H6V13H4V10H20V13H18Z";
var mdiTools = "M21.71 20.29L20.29 21.71A1 1 0 0 1 18.88 21.71L7 9.85A3.81 3.81 0 0 1 6 10A4 4 0 0 1 2.22 4.7L4.76 7.24L5.29 6.71L6.71 5.29L7.24 4.76L4.7 2.22A4 4 0 0 1 10 6A3.81 3.81 0 0 1 9.85 7L21.71 18.88A1 1 0 0 1 21.71 20.29M2.29 18.88A1 1 0 0 0 2.29 20.29L3.71 21.71A1 1 0 0 0 5.12 21.71L10.59 16.25L7.76 13.42M20 2L16 4V6L13.83 8.17L15.83 10.17L18 8H20L22 4Z";
var mdiTooltip = "M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H16L12,22L8,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2Z";
var mdiTooltipAccount = "M20,2H4A2,2 0 0,0 2,4V16A2,2 0 0,0 4,18H8L12,22L16,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M12,4.3C13.5,4.3 14.7,5.5 14.7,7C14.7,8.5 13.5,9.7 12,9.7C10.5,9.7 9.3,8.5 9.3,7C9.3,5.5 10.5,4.3 12,4.3M18,15H6V14.1C6,12.1 10,11 12,11C14,11 18,12.1 18,14.1V15Z";
var mdiTooltipCellphone = "M9 6H15V14H9V6M22 4V16C22 17.11 21.11 18 20 18H16L12 22L8 18H4C2.9 18 2 17.11 2 16V4C2 2.9 2.9 2 4 2H20C21.11 2 22 2.9 22 4M16 5.09C16 4.5 15.5 4 14.86 4H9.14C8.5 4 8 4.5 8 5.09V14.91C8 15.5 8.5 16 9.14 16H14.86C15.5 16 16 15.5 16 14.91V5.09Z";
var mdiTooltipCheck = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.11 2.9 18 4 18H8L12 22L16 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M10.46 14L6.96 10.5L8.37 9.08L10.46 11.17L15.64 6L17.05 7.41L10.46 14Z";
var mdiTooltipCheckOutline = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.11 2.9 18 4 18H8L12 22L16 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M20 16H15.17L12 19.17L8.83 16H4V4H20V16M10.75 13.71L7.25 10.21L8.66 8.79L10.75 10.88L15.34 6.3L16.75 7.71L10.75 13.71Z";
var mdiTooltipEdit = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.11 2.9 18 4 18H8L12 22L16 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M9.08 15H7V12.91L13.17 6.72L15.24 8.8L9.08 15M16.84 7.2L15.83 8.21L13.76 6.18L14.77 5.16C14.97 4.95 15.31 4.94 15.55 5.16L16.84 6.41C17.05 6.62 17.06 6.96 16.84 7.2Z";
var mdiTooltipEditOutline = "M4 2H20C21.11 2 22 2.9 22 4V16C22 17.11 21.11 18 20 18H16L12 22L8 18H4C2.9 18 2 17.11 2 16V4C2 2.9 2.9 2 4 2M4 4V16H8.83L12 19.17L15.17 16H20V4H4M15.84 8.2L14.83 9.21L12.76 7.18L13.77 6.16C13.97 5.95 14.31 5.94 14.55 6.16L15.84 7.41C16.05 7.62 16.06 7.96 15.84 8.2M8 11.91L12.17 7.72L14.24 9.8L10.08 14H8V11.91Z";
var mdiTooltipImage = "M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H16L12,22L8,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M19,15V7L15,11L13,9L7,15H19M7,5A2,2 0 0,0 5,7A2,2 0 0,0 7,9A2,2 0 0,0 9,7A2,2 0 0,0 7,5Z";
var mdiTooltipImageOutline = "M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H16L12,22L8,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M4,4V16H8.83L12,19.17L15.17,16H20V4H4M7.5,6A1.5,1.5 0 0,1 9,7.5A1.5,1.5 0 0,1 7.5,9A1.5,1.5 0 0,1 6,7.5A1.5,1.5 0 0,1 7.5,6M6,14L11,9L13,11L18,6V14H6Z";
var mdiTooltipMinus = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.11 2.9 18 4 18H8L12 22L16 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M16 11H8V9H16V11Z";
var mdiTooltipMinusOutline = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.11 2.9 18 4 18H8L12 22L16 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M20 16H15.17L12 19.17L8.83 16H4V4H20V16M16 11H8V9H16V11Z";
var mdiTooltipOutline = "M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H16L12,22L8,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M4,4V16H8.83L12,19.17L15.17,16H20V4H4Z";
var mdiTooltipPlus = "M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H16L12,22L8,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M11,6V9H8V11H11V14H13V11H16V9H13V6H11Z";
var mdiTooltipPlusOutline = "M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H16L12,22L8,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M4,4V16H8.83L12,19.17L15.17,16H20V4H4M11,6H13V9H16V11H13V14H11V11H8V9H11V6Z";
var mdiTooltipQuestion = "M20 2H4C3.47 2 2.96 2.21 2.59 2.59C2.21 2.96 2 3.47 2 4V16C2 16.53 2.21 17.04 2.59 17.41C2.96 17.79 3.47 18 4 18H8L12 22L16 18H20C20.53 18 21.04 17.79 21.41 17.41S22 16.53 22 16V4C22 3.47 21.79 2.96 21.41 2.59C21.04 2.21 20.53 2 20 2M10.05 6.04C10.59 5.68 11.3 5.5 12.19 5.5C13.13 5.5 13.88 5.71 14.42 6.12C14.96 6.54 15.23 7.1 15.23 7.8C15.23 8.24 15.08 8.63 14.79 9C14.5 9.36 14.12 9.64 13.66 9.85C13.4 10 13.23 10.15 13.14 10.32C13.05 10.5 13 10.72 13 11H11C11 10.5 11.1 10.16 11.29 9.92C11.5 9.68 11.84 9.4 12.36 9.08C12.62 8.94 12.83 8.76 13 8.54C13.14 8.33 13.22 8.08 13.22 7.8C13.22 7.5 13.13 7.28 12.95 7.11C12.77 6.93 12.5 6.85 12.19 6.85C11.92 6.85 11.7 6.92 11.5 7.06C11.34 7.2 11.24 7.41 11.24 7.69H9.27C9.22 7 9.5 6.4 10.05 6.04M11 14V12H13V14Z";
var mdiTooltipQuestionOutline = "M20 2H4C3.47 2 2.96 2.21 2.59 2.59C2.21 2.96 2 3.47 2 4V16C2 16.53 2.21 17.04 2.59 17.41C2.96 17.79 3.47 18 4 18H8L12 22L16 18H20C20.53 18 21.04 17.79 21.41 17.41S22 16.53 22 16V4C22 3.47 21.79 2.96 21.41 2.59C21.04 2.21 20.53 2 20 2M4 16V4H20V16H15.17L12 19.17L8.83 16M10.05 6.04C10.59 5.68 11.3 5.5 12.19 5.5C13.13 5.5 13.88 5.71 14.42 6.12C14.96 6.54 15.23 7.1 15.23 7.8C15.23 8.24 15.08 8.63 14.79 9C14.5 9.36 14.12 9.64 13.66 9.85C13.4 10 13.23 10.15 13.14 10.32C13.05 10.5 13 10.72 13 11H11C11 10.5 11.1 10.16 11.29 9.92C11.5 9.68 11.84 9.4 12.36 9.08C12.62 8.94 12.83 8.76 13 8.54C13.14 8.33 13.22 8.08 13.22 7.8C13.22 7.5 13.13 7.28 12.95 7.11C12.77 6.93 12.5 6.85 12.19 6.85C11.92 6.85 11.7 6.92 11.5 7.06C11.34 7.2 11.24 7.41 11.24 7.69H9.27C9.22 7 9.5 6.4 10.05 6.04M11 14V12H13V14Z";
var mdiTooltipRemove = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.11 2.9 18 4 18H8L12 22L16 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M15.54 12.12L14.12 13.54L12 11.41L9.88 13.54L8.47 12.12L10.59 10L8.46 7.88L9.88 6.47L12 8.59L14.12 6.47L15.54 7.88L13.41 10L15.54 12.12Z";
var mdiTooltipRemoveOutline = "M20 2H4C2.9 2 2 2.9 2 4V16C2 17.11 2.9 18 4 18H8L12 22L16 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M20 16H15.17L12 19.17L8.83 16H4V4H20V16M8.46 12.12L10.59 10L8.46 7.88L9.88 6.47L12 8.59L14.12 6.47L15.54 7.88L13.41 10L15.54 12.12L14.12 13.54L12 11.41L9.88 13.54L8.46 12.12Z";
var mdiTooltipText = "M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H16L12,22L8,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M5,5V7H19V5H5M5,9V11H15V9H5M5,13V15H17V13H5Z";
var mdiTooltipTextOutline = "M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H16L12,22L8,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M4,4V16H8.83L12,19.17L15.17,16H20V4H4M6,7H18V9H6V7M6,11H16V13H6V11Z";
var mdiTooth = "M7,2C4,2 2,5 2,8C2,10.11 3,13 4,14C5,15 6,22 8,22C12.54,22 10,15 12,15C14,15 11.46,22 16,22C18,22 19,15 20,14C21,13 22,10.11 22,8C22,5 20,2 17,2C14,2 14,3 12,3C10,3 10,2 7,2Z";
var mdiToothOutline = "M7,2C4,2 2,5 2,8C2,10.11 3,13 4,14C5,15 6,22 8,22C12.54,22 10,15 12,15C14,15 11.46,22 16,22C18,22 19,15 20,14C21,13 22,10.11 22,8C22,5 20,2 17,2C14,2 14,3 12,3C10,3 10,2 7,2M7,4C9,4 10,5 12,5C14,5 15,4 17,4C18.67,4 20,6 20,8C20,9.75 19.14,12.11 18.19,13.06C17.33,13.92 16.06,19.94 15.5,19.94C15.29,19.94 15,18.88 15,17.59C15,15.55 14.43,13 12,13C9.57,13 9,15.55 9,17.59C9,18.88 8.71,19.94 8.5,19.94C7.94,19.94 6.67,13.92 5.81,13.06C4.86,12.11 4,9.75 4,8C4,6 5.33,4 7,4Z";
var mdiToothbrush = "M12.91 6.43L15.03 8.55L16.09 7.5L15.03 6.43L17.86 3.6L18.92 4.66L20 3.6L17.86 1.5M3 20.57L4.43 22L14.5 11.9L16.63 11.19L21.4 6.43C22.18 5.65 22.18 4.38 21.4 3.6L15.55 9.44L13.43 10.15Z";
var mdiToothbrushElectric = "M12 1.5V14C10.34 14 9 15.34 9 17V22H17V17C17 15.34 15.66 14 14 14V3.5C14 2.4 13.11 1.5 12 1.5M7.5 2V9H11V7.5H9V3.5H11V2H7.5M13 17.5C13.83 17.5 14.5 18.17 14.5 19C14.5 19.83 13.83 20.5 13 20.5C12.17 20.5 11.5 19.83 11.5 19C11.5 18.17 12.17 17.5 13 17.5Z";
var mdiToothbrushPaste = "M17.86 1.5L12.91 6.43L15.03 8.55L16.09 7.5L15.03 6.43L17.86 3.6L18.92 4.66L20 3.6M21.4 3.6L15.56 9.44L13.43 10.15L3 20.57L4.43 22L10.08 16.33L14.33 20.57L18.57 16.33L14.33 12.09L14.5 11.9L16.63 11.19L21.4 6.43C22.18 5.65 22.18 4.38 21.4 3.6M6.55 4.31L2.31 8.55L7.26 13.5L11.5 9.26M18.22 18.1L16.09 20.22L17.5 21.63L19.63 19.5Z";
var mdiTorch = "M8.6 9.6C9 10.2 9.5 10.7 10.2 11H14.2C14.5 10.9 14.7 10.7 14.9 10.5C15.9 9.5 16.3 8 15.8 6.7L15.7 6.5C15.6 6.2 15.4 6 15.2 5.8C15.1 5.6 14.9 5.5 14.8 5.3C14.4 5 14 4.7 13.6 4.3C12.7 3.4 12.6 2 13.1 1C12.6 1.1 12.1 1.4 11.7 1.8C10.2 3 9.6 5.1 10.3 7V7.2C10.3 7.3 10.2 7.4 10.1 7.5C10 7.6 9.8 7.5 9.7 7.4L9.6 7.3C9 6.5 8.9 5.3 9.3 4.3C8.4 5.1 7.9 6.4 8 7.7C8 8 8.1 8.3 8.2 8.6C8.2 8.9 8.4 9.3 8.6 9.6M12.3 8.1C12.4 7.6 12.2 7.2 12.1 6.8C12 6.4 12 6 12.2 5.6L12.5 6.2C12.9 6.8 13.6 7 13.8 7.8V8.1C13.8 8.6 13.6 9.1 13.3 9.4C13.1 9.5 12.9 9.7 12.7 9.7C12.1 9.9 11.4 9.6 11 9.2C11.8 9.2 12.2 8.6 12.3 8.1M15 12V14H14L13 22H11L10 14H9V12H15Z";
var mdiTortoise = "M19.31,5.6C18.09,5.56 16.88,6.5 16.5,8C16,10 16,10 15,11C13,13 10,14 4,15C3,15.16 2.5,15.5 2,16C4,16 6,16 4.5,17.5L3,19H6L8,17C10,18 11.33,18 13.33,17L14,19H17L16,16C16,16 17,12 18,11C19,10 19,11 20,11C21,11 22,10 22,8.5C22,8 22,7 20.5,6C20.15,5.76 19.74,5.62 19.31,5.6M9,6A6,6 0 0,0 3,12C3,12.6 3.13,13.08 3.23,13.6C9.15,12.62 12.29,11.59 13.93,9.94L14.43,9.44C13.44,7.34 11.32,6 9,6Z";
var mdiToslink = "M20 10V7L17 4H7L4 7V10C2.9 10 2 10.9 2 12S2.9 14 4 14V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V14C21.11 14 22 13.11 22 12S21.11 10 20 10M12 16C9.79 16 8 14.21 8 12S9.79 8 12 8 16 9.79 16 12 14.21 16 12 16M14 12C14 13.11 13.11 14 12 14S10 13.11 10 12 10.9 10 12 10 14 10.9 14 12Z";
var mdiTouchTextOutline = "M7 7H17V9H7V7M12.69 15.81H13.2V15H7V17H10.38L10.71 16.65C11.18 16.13 11.92 15.81 12.69 15.81M9 19H5V5H19V13.56L21 14.45V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H11.33L9 19M7 13H13.2V11.73C13.2 11.5 13.25 11.24 13.31 11H7V13M15.2 19.07L12.85 17.81H12.69C12.5 17.81 12.29 17.89 12.15 18.04L11.61 18.61L15.2 21.69C15.39 21.89 15.66 22 15.93 22H20.7C21.3 22 21.78 21.5 21.8 20.9V17.7C21.8 17.28 21.57 16.89 21.18 16.71L17.55 15.11L16.67 15V11.73C16.67 11.33 16.34 11 15.93 11C15.53 11 15.2 11.33 15.2 11.73V19.07Z";
var mdiTournament = "M2,2V4H7V8H2V10H7C8.11,10 9,9.11 9,8V7H14V17H9V16C9,14.89 8.11,14 7,14H2V16H7V20H2V22H7C8.11,22 9,21.11 9,20V19H14C15.11,19 16,18.11 16,17V13H22V11H16V7C16,5.89 15.11,5 14,5H9V4C9,2.89 8.11,2 7,2H2Z";
var mdiTowTruck = "M15,10H20.39L17.06,6H15V10M17.5,18.5C17.89,18.5 18.24,18.37 18.54,18.07C18.84,17.77 19,17.42 19,17C19,16.61 18.84,16.26 18.54,15.96C18.24,15.66 17.89,15.5 17.5,15.5C17.08,15.5 16.73,15.66 16.43,15.96C16.13,16.26 16,16.61 16,17C16,17.42 16.13,17.77 16.43,18.07C16.73,18.37 17.08,18.5 17.5,18.5M6,18.5C6.44,18.5 6.8,18.37 7.08,18.07C7.36,17.77 7.5,17.42 7.5,17C7.5,16.61 7.36,16.26 7.08,15.96C6.8,15.66 6.44,15.5 6,15.5C5.56,15.5 5.2,15.66 4.92,15.96C4.64,16.26 4.5,16.61 4.5,17C4.5,17.42 4.64,17.77 4.92,18.07C5.2,18.37 5.56,18.5 6,18.5M18,4L23,10V17H20.5C20.5,17.83 20.19,18.53 19.59,19.13C19,19.72 18.3,20 17.5,20C16.67,20 15.97,19.72 15.38,19.13C14.78,18.53 14.5,17.83 14.5,17H9C9,17.83 8.7,18.53 8.11,19.13C7.5,19.72 6.81,20 6,20C5.19,20 4.5,19.72 3.89,19.13C3.3,18.53 3,17.83 3,17H1V13H9.19L3,8.11V11H1V5H2L13,11.06V4H18Z";
var mdiTowerBeach = "M17,4V8H18V10H17.64L21,23H18.93L18.37,20.83L12,17.15L5.63,20.83L5.07,23H3L6.36,10H6V8H7V4H6V3L18,1V4H17M7.28,14.43L6.33,18.12L10,16L7.28,14.43M15.57,10H8.43L7.8,12.42L12,14.85L16.2,12.42L15.57,10M17.67,18.12L16.72,14.43L14,16L17.67,18.12Z";
var mdiTowerFire = "M17,4V8H18V10H17.64L21,23H18.93L18.37,20.83L12,17.15L5.63,20.83L5.07,23H3L6.36,10H6V8H7V4H6V3L12,1L18,3V4H17M7.28,14.43L6.33,18.12L10,16L7.28,14.43M15.57,10H8.43L7.8,12.42L12,14.85L16.2,12.42L15.57,10M17.67,18.12L16.72,14.43L14,16L17.67,18.12Z";
var mdiTownHall = "M21 10H17V8L12.5 6.2V4H15V2H11.5V6.2L7 8V10H3C2.45 10 2 10.45 2 11V22H10V17H14V22H22V11C22 10.45 21.55 10 21 10M8 20H4V17H8V20M8 15H4V12H8V15M12 8C12.55 8 13 8.45 13 9S12.55 10 12 10 11 9.55 11 9 11.45 8 12 8M14 15H10V12H14V15M20 20H16V17H20V20M20 15H16V12H20V15Z";
var mdiToyBrick = "M19 6V5A2 2 0 0 0 17 3H15A2 2 0 0 0 13 5V6H11V5A2 2 0 0 0 9 3H7A2 2 0 0 0 5 5V6H3V20H21V6Z";
var mdiToyBrickMarker = "M19 6V5A2 2 0 0 0 17 3H15A2 2 0 0 0 13 5V6H11V5A2 2 0 0 0 9 3H7A2 2 0 0 0 5 5V6H3V20H14.54A9.55 9.55 0 0 1 13 15.5A5.58 5.58 0 0 1 18.5 10A5.3 5.3 0 0 1 21 10.63V6M18.5 12A3.54 3.54 0 0 0 15 15.5C15 18.1 18.5 22 18.5 22S22 18.1 22 15.5A3.54 3.54 0 0 0 18.5 12M18.5 16.8A1.2 1.2 0 1 1 18.5 14.4A1.29 1.29 0 0 1 19.7 15.6A1.15 1.15 0 0 1 18.5 16.8Z";
var mdiToyBrickMarkerOutline = "M18.5 12A3.54 3.54 0 0 0 15 15.5C15 18.1 18.5 22 18.5 22S22 18.1 22 15.5A3.54 3.54 0 0 0 18.5 12M18.5 16.8A1.2 1.2 0 1 1 18.5 14.4A1.29 1.29 0 0 1 19.7 15.6A1.15 1.15 0 0 1 18.5 16.8M19 6V5A2 2 0 0 0 17 3H15A2 2 0 0 0 13 5V6H11V5A2 2 0 0 0 9 3H7A2 2 0 0 0 5 5V6H3V20H14.54A15.55 15.55 0 0 1 13.54 18H5V8H19V10A5.11 5.11 0 0 1 21 10.6V6Z";
var mdiToyBrickMinus = "M23 20H15V18H23V20M13 19C13 15.69 15.69 13 19 13C19.7 13 20.37 13.13 21 13.35V6H19V5C19 3.9 18.11 3 17 3H15C13.9 3 13 3.9 13 5V6H11V5C11 3.9 10.11 3 9 3H7C5.9 3 5 3.9 5 5V6H3V20H13.09C13.04 19.67 13 19.34 13 19Z";
var mdiToyBrickMinusOutline = "M13.09 20H3V6H5V5C5 3.9 5.9 3 7 3H9C10.11 3 11 3.9 11 5V6H13V5C13 3.9 13.9 3 15 3H17C18.11 3 19 3.9 19 5V6H21V13.35C20.37 13.13 19.7 13 19 13V8H5V18H13.09C13.04 18.33 13 18.66 13 19S13.04 19.67 13.09 20M23 18H15V20H23V18Z";
var mdiToyBrickOutline = "M19 6V5A2 2 0 0 0 17 3H15A2 2 0 0 0 13 5V6H11V5A2 2 0 0 0 9 3H7A2 2 0 0 0 5 5V6H3V20H21V6M19 18H5V8H19Z";
var mdiToyBrickPlus = "M19 6V5A2 2 0 0 0 17 3H15A2 2 0 0 0 13 5V6H11V5A2 2 0 0 0 9 3H7A2 2 0 0 0 5 5V6H3V20H13.09A5.47 5.47 0 0 1 13 19A6 6 0 0 1 21 13.34V6M20 15V18H23V20H20V23H18V20H15V18H18V15Z";
var mdiToyBrickPlusOutline = "M19 6V5A2 2 0 0 0 17 3H15A2 2 0 0 0 13 5V6H11V5A2 2 0 0 0 9 3H7A2 2 0 0 0 5 5V6H3V20H14V18H5V8H19V13H21V6M21 15V18H24V20H21V23H19V20H16V18H19V15Z";
var mdiToyBrickRemove = "M19 6V5A2 2 0 0 0 17 3H15A2 2 0 0 0 13 5V6H11V5A2 2 0 0 0 9 3H7A2 2 0 0 0 5 5V6H3V20H13.09A5.47 5.47 0 0 1 13 19A6 6 0 0 1 21 13.34V6M22.54 16.88L20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.46 21.12L17.59 19L15.46 16.88L16.88 15.46L19 17.59L21.12 15.46Z";
var mdiToyBrickRemoveOutline = "M19 6V5C19 3.9 18.1 3 17 3H15C13.9 3 13 3.9 13 5V6H11V5C11 3.9 10.1 3 9 3H7C5.9 3 5 3.9 5 5V6H3V20H14V18H5V8H19V13H21V6M17.88 15.46L20 17.59L22.12 15.47L23.54 16.88L21.41 19L23.54 21.12L22.12 22.54L20 20.41L17.88 22.54L16.46 21.12L18.59 19L16.47 16.88";
var mdiToyBrickSearch = "M19 6V5A2 2 0 0 0 17 3H15A2 2 0 0 0 13 5V6H11V5A2 2 0 0 0 9 3H7A2 2 0 0 0 5 5V6H3V20H11.81A6.5 6.5 0 0 1 21 10.81V6M20.31 17.9A4.5 4.5 0 1 0 18.88 19.32L22 22.39L23.39 21M16.5 18A2.5 2.5 0 1 1 19 15.5A2.5 2.5 0 0 1 16.5 18Z";
var mdiToyBrickSearchOutline = "M19 6V5A2 2 0 0 0 17 3H15A2 2 0 0 0 13 5V6H11V5A2 2 0 0 0 9 3H7A2 2 0 0 0 5 5V6H3V20H11.81A6.59 6.59 0 0 1 10.5 18H5V8H19V9.5A6.59 6.59 0 0 1 21 10.81V6M20.31 17.9A4.5 4.5 0 1 0 18.88 19.32L22 22.39L23.39 21M16.5 18A2.5 2.5 0 1 1 19 15.5A2.5 2.5 0 0 1 16.5 18Z";
var mdiTrackLight = "M6,1V3H9V6.4L4.11,4.38L1.43,10.84L6.97,13.14L11.94,16.82L13.79,17.59L17.62,8.35L15.77,7.58L11,6.87V3H14V1H6M21.81,6.29L19.5,7.25L20.26,9.1L22.57,8.14L21.81,6.29M19.78,13.57L19,15.42L21.79,16.57L22.55,14.72L19.78,13.57M16.19,18.93L14.34,19.69L15.3,22L17.15,21.23L16.19,18.93Z";
var mdiTrackLightOff = "M19.78 13.57L22.55 14.72L21.79 16.57L19 15.42L19.78 13.57M22.57 8.14L21.81 6.29L19.5 7.25L20.26 9.1L22.57 8.14M14.34 19.69L15.3 22L17.15 21.23L16.19 18.93L14.34 19.69M2.39 1.73L1.11 3L3.64 5.53L1.43 10.84L6.97 13.14L11.94 16.82L13.79 17.59L14.35 16.24L20.84 22.73L22.11 21.46L2.39 1.73M6.2 3L6 2.8V1H14V3H11V6.87L15.77 7.58L17.62 8.35L15.84 12.64L9 5.8V3H6.2Z";
var mdiTrackpad = "M4,3H20A2,2 0 0,1 22,5V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V5A2,2 0 0,1 4,3M4,5V13H20V5H4M4,19H11V15H4V19M20,19V15H13V19H20Z";
var mdiTrackpadLock = "M3,1C1.89,1 1,1.89 1,3V17C1,18.11 1.89,19 3,19H14V17H12V13H16.68C17.5,12.35 18.47,12 19.5,12C20,12 20.5,12.09 21,12.26V3C21,1.89 20.11,1 19,1H3M3,3H19V11H3V3M3,13H10V17H3V13M19.5,14A2.5,2.5 0 0,0 17,16.5V17A1,1 0 0,0 16,18V22A1,1 0 0,0 17,23H22A1,1 0 0,0 23,22V18A1,1 0 0,0 22,17V16.5A2.5,2.5 0 0,0 19.5,14M19.5,15A1.5,1.5 0 0,1 21,16.5V17H18V16.5A1.5,1.5 0 0,1 19.5,15Z";
var mdiTractor = "M5,4V11.26C3.2,11.9 2,13.6 2,15.5C2,18 4,20 6.5,20C8.79,20 10.71,18.28 10.97,16H15.17C15.06,16.32 15,16.66 15,17A3,3 0 0,0 18,20A3,3 0 0,0 21,17C21,16.66 20.94,16.32 20.82,16H22V13C22,11.89 21.11,11 20,11H15.04L13.65,4H5M7,6H12L13,11V14H10.74C10.16,12.38 8.71,11.23 7,11.03V6M6.5,13.25A2.25,2.25 0 0,1 8.75,15.5A2.25,2.25 0 0,1 6.5,17.75A2.25,2.25 0 0,1 4.25,15.5A2.25,2.25 0 0,1 6.5,13.25M18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5Z";
var mdiTractorVariant = "M13.3 2.79L9.8 6.29L10.5 7L11.9 5.61L13 6.71V9C13 10.11 12.11 11 11 11H10.46A6 6 0 0 1 12 15A6 6 0 0 1 11.91 16H15.03A4.5 4.5 0 0 1 19.5 12A4.5 4.5 0 0 1 22 12.76V8C22 6.89 21.11 6 20 6H13.71L12.61 4.9L14 3.5L13.3 2.79M4 7C3.45 7 3 7.45 3 8C3 8.55 3.45 9 4 9H9C9 7.9 8.11 7 7 7H4M6 10A5 5 0 0 0 4.44 10.25L4.8 11.18L4.33 11.36L4 10.43A5 5 0 0 0 1.54 12.74L2.45 13.15L2.24 13.6L1.34 13.2A5 5 0 0 0 1 15A5 5 0 0 0 1.25 16.56L2.18 16.2L2.36 16.67L1.43 17A5 5 0 0 0 3.74 19.46L4.14 18.55L4.6 18.76L4.2 19.66A5 5 0 0 0 6 20A5 5 0 0 0 7.56 19.75L7.2 18.82L7.67 18.64L8 19.57A5 5 0 0 0 10.46 17.26L9.55 16.86L9.76 16.4L10.66 16.8A5 5 0 0 0 11 15A5 5 0 0 0 10.75 13.44L9.82 13.8L9.64 13.33L10.57 13A5 5 0 0 0 8.26 10.54L7.86 11.45L7.4 11.24L7.8 10.34A5 5 0 0 0 6 10M6 12A3 3 0 0 1 9 15A3 3 0 0 1 6 18A3 3 0 0 1 3 15A3 3 0 0 1 6 12M19.5 13A3.5 3.5 0 0 0 16 16.5A3.5 3.5 0 0 0 19.5 20A3.5 3.5 0 0 0 23 16.5A3.5 3.5 0 0 0 19.5 13M19.5 15A1.5 1.5 0 0 1 21 16.5A1.5 1.5 0 0 1 19.5 18A1.5 1.5 0 0 1 18 16.5A1.5 1.5 0 0 1 19.5 15Z";
var mdiTrademark = "M9.8,8.44H6.87V16H4.89V8.44H2V7H9.8V8.44M13.5,7L15.96,13.5L18.41,7H21V16H19V13.5L19.22,9.24L16.63,16H15.28L12.7,9.25L12.9,13.5V16H10.93V7H13.5Z";
var mdiTrafficCone = "M17 15L18 19H21V22H3V19H6L7 15H17M15 8L16 12H8L9 8H15M13 1L14 5H10L11 1H13Z";
var mdiTrafficLight = "M12,9A2,2 0 0,1 10,7C10,5.89 10.9,5 12,5C13.11,5 14,5.89 14,7A2,2 0 0,1 12,9M12,14A2,2 0 0,1 10,12C10,10.89 10.9,10 12,10C13.11,10 14,10.89 14,12A2,2 0 0,1 12,14M12,19A2,2 0 0,1 10,17C10,15.89 10.9,15 12,15C13.11,15 14,15.89 14,17A2,2 0 0,1 12,19M20,10H17V8.86C18.72,8.41 20,6.86 20,5H17V4A1,1 0 0,0 16,3H8A1,1 0 0,0 7,4V5H4C4,6.86 5.28,8.41 7,8.86V10H4C4,11.86 5.28,13.41 7,13.86V15H4C4,16.86 5.28,18.41 7,18.86V20A1,1 0 0,0 8,21H16A1,1 0 0,0 17,20V18.86C18.72,18.41 20,16.86 20,15H17V13.86C18.72,13.41 20,11.86 20,10Z";
var mdiTrafficLightOutline = "M20 10H17V8.86C18.72 8.41 20 6.86 20 5H17V4C17 3.45 16.55 3 16 3H8C7.45 3 7 3.45 7 4V5H4C4 6.86 5.28 8.41 7 8.86V10H4C4 11.86 5.28 13.41 7 13.86V15H4C4 16.86 5.28 18.41 7 18.86V20C7 20.55 7.45 21 8 21H16C16.55 21 17 20.55 17 20V18.86C18.72 18.41 20 16.86 20 15H17V13.86C18.72 13.41 20 11.86 20 10M15 19H9V5H15V19M12 18C12.83 18 13.5 17.33 13.5 16.5S12.83 15 12 15 10.5 15.67 10.5 16.5 11.17 18 12 18M12 13.5C12.83 13.5 13.5 12.83 13.5 12S12.83 10.5 12 10.5 10.5 11.17 10.5 12 11.17 13.5 12 13.5M12 9C12.83 9 13.5 8.33 13.5 7.5S12.83 6 12 6 10.5 6.67 10.5 7.5 11.17 9 12 9Z";
var mdiTrain = "M12,2C8,2 4,2.5 4,6V15.5A3.5,3.5 0 0,0 7.5,19L6,20.5V21H8.23L10.23,19H14L16,21H18V20.5L16.5,19A3.5,3.5 0 0,0 20,15.5V6C20,2.5 16.42,2 12,2M7.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,14A1.5,1.5 0 0,1 9,15.5A1.5,1.5 0 0,1 7.5,17M11,10H6V6H11V10M13,10V6H18V10H13M16.5,17A1.5,1.5 0 0,1 15,15.5A1.5,1.5 0 0,1 16.5,14A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 16.5,17Z";
var mdiTrainBus = "M5 2H12C12.8 2 13.56 2.32 14.12 2.88C14.68 3.44 15 4.2 15 5V6H13V4H4V11H9V16H8L5 19H4V17L5 16C4.2 16 3.44 15.68 2.88 15.12C2.32 14.56 2 13.8 2 13V5C2 4.2 2.32 3.44 2.88 2.88C3.44 2.32 4.2 2 5 2M5.71 12.29C5.5 12.11 5.27 12 5 12C4.74 12 4.5 12.11 4.29 12.29C4.11 12.5 4 12.74 4 13C4 13.27 4.11 13.5 4.29 13.71C4.5 13.9 4.74 14 5 14C5.27 14 5.5 13.9 5.71 13.71C5.9 13.5 6 13.27 6 13C6 12.74 5.9 12.5 5.71 12.29M11 11C11 9.34 12 8 15 8H18C21 8 22 9.34 22 11V18C22 18.74 21.6 19.39 21 19.73V21C21 21.55 20.55 22 20 22C19.45 22 19 21.55 19 21V20H14V21C14 21.55 13.55 22 13 22C12.45 22 12 21.55 12 21V19.73C11.4 19.39 11 18.74 11 18V11M13 10V14H20V10H13M14 18C14.55 18 15 17.55 15 17C15 16.45 14.55 16 14 16C13.45 16 13 16.45 13 17C13 17.55 13.45 18 14 18M20 17C20 16.45 19.55 16 19 16C18.45 16 18 16.45 18 17C18 17.55 18.45 18 19 18C19.55 18 20 17.55 20 17Z";
var mdiTrainCar = "M12,4H5A3,3 0 0,0 2,7V15A3,3 0 0,0 5,18L4,19V20H5L7,17.97L9,18V13H4V6H13V8H15V7A3,3 0 0,0 12,4M5,14A1,1 0 0,1 6,15A1,1 0 0,1 5,16A1,1 0 0,1 4,15A1,1 0 0,1 5,14M20.57,9.66C20.43,9.26 20.05,9 19.6,9H12.41C11.95,9 11.58,9.26 11.43,9.66L10,13.77V19.28C10,19.66 10.32,20 10.7,20H11.32C11.7,20 12,19.62 12,19.24V18H20V19.24C20,19.62 20.31,20 20.69,20H21.3C21.68,20 22,19.66 22,19.28V17.91L22,13.77L20.57,9.66M12.41,10H19.6L20.63,13H11.38L12.41,10M12,16A1,1 0 0,1 11,15A1,1 0 0,1 12,14A1,1 0 0,1 13,15A1,1 0 0,1 12,16M20,16A1,1 0 0,1 19,15A1,1 0 0,1 20,14A1,1 0 0,1 21,15A1,1 0 0,1 20,16Z";
var mdiTrainCarAutorack = "M21 6H3C1.9 6 1 6.9 1 8V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V8C23 6.9 22.11 6 21 6M7.58 12.18C8.19 12.18 8.68 12.68 8.68 13.29S8.19 14.39 7.58 14.39C6.97 14.39 6.47 13.9 6.47 13.29S6.97 12.18 7.58 12.18M7.03 11.08L8.68 9.61H11.63L14.58 11.08H7.03M9.66 14.03H14.34C14.5 14.42 14.74 14.75 15.05 15H8.95C9.26 14.75 9.5 14.42 9.66 14.03M15.32 13.29C15.32 12.68 15.81 12.18 16.42 12.18C17.03 12.18 17.53 12.68 17.53 13.29S17.03 14.39 16.42 14.39C15.81 14.4 15.32 13.9 15.32 13.29M17.79 15C18.11 14.75 18.36 14.42 18.5 14.03H20.11V13.29C20.11 12.47 19.35 12.21 18.63 11.82L12 8.5H8.32L6.11 10.34H5.37C4.55 10.34 3.89 11 3.89 11.82V14.03H5.5C5.64 14.42 5.89 14.75 6.21 15H3V8H21V15H17.79Z";
var mdiTrainCarBox = "M1 7V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V7H1Z";
var mdiTrainCarBoxFull = "M1 7V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V7H1M16 16H14V11H10V16H8V9H16V16Z";
var mdiTrainCarBoxOpen = "M1 7V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V7H1M16 16H8V9H16V16Z";
var mdiTrainCarCaboose = "M23 9V7H15V6H16V4H8V6H9V7H1V9H2V15H1V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V15H22V9H23M4 15H3V9H4V15M11 12H6V9H11V12M18 12H13V9H18V12M21 15H20V9H21V15Z";
var mdiTrainCarCenterbeam = "M23 6V17H22C22 18.11 21.11 19 20 19S18 18.11 18 17H6C6 18.11 5.11 19 4 19S2 18.11 2 17H1V6H3V15H21V6H23Z";
var mdiTrainCarCenterbeamFull = "M23 6V17H22C22 18.11 21.11 19 20 19S18 18.11 18 17H6C6 18.11 5.11 19 4 19S2 18.11 2 17H1V6H3V15H21V6H23M8 12H4V14H8V12M15 12H9V14H15V12M20 12H16V14H20V12M8 9H4V11H8V9M15 9H9V11H15V9M20 9H16V11H20V9M8 6H4V8H8V6M15 6H9V8H15V6M20 6H16V8H20V6Z";
var mdiTrainCarContainer = "M1 6V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V6H1M21 15H19V9H17V15H15V9H13V15H11V9H9V15H7V9H5V15H3V8H21V15Z";
var mdiTrainCarFlatbed = "M23 15V17H22C22 18.11 21.11 19 20 19S18 18.11 18 17H6C6 18.11 5.11 19 4 19S2 18.11 2 17H1V15H23Z";
var mdiTrainCarFlatbedCar = "M23 13V10C23 8.89 22.11 8 21 8H19L16 4H6L3 8C1.89 8 1 8.89 1 10V13H3C3 13.77 3.3 14.47 3.78 15H1V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V15H20.22C20.7 14.47 21 13.77 21 13H23M19.5 13C19.5 13.83 18.83 14.5 18 14.5S16.5 13.83 16.5 13 17.17 11.5 18 11.5 19.5 12.17 19.5 13M12 5.5H15.25L17.14 8H12V5.5M15.78 15H8.22C8.7 14.47 9 13.77 9 13H15C15 13.77 15.3 14.47 15.78 15M6.75 5.5H10.5V8H4.86L6.75 5.5M6 11.5C6.83 11.5 7.5 12.17 7.5 13S6.83 14.5 6 14.5 4.5 13.83 4.5 13 5.17 11.5 6 11.5Z";
var mdiTrainCarFlatbedTank = "M21.22 15C21.7 14.47 22 13.77 22 13C22 11.34 20.66 10 19 10H5C3.34 10 2 11.34 2 13C2 13.77 2.3 14.47 2.78 15H1V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V15H21.22M19 12C19.55 12 20 12.45 20 13S19.55 14 19 14 18 13.55 18 13 18.45 12 19 12M12 12C12.55 12 13 12.45 13 13S12.55 14 12 14 11 13.55 11 13 11.45 12 12 12M5 12C5.55 12 6 12.45 6 13S5.55 14 5 14 4 13.55 4 13 4.45 12 5 12M13.62 6L13.22 4H22V6H13.62M20 9H4V8H6L7 3H12L13 8H20V9Z";
var mdiTrainCarGondola = "M1 10V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V10H1M21 15H19V13H17V15H15V13H13V15H11V13H9V15H7V13H5V15H3V12H21V15Z";
var mdiTrainCarGondolaFull = "M21 10C19.04 8.19 15.74 7 12 7S4.96 8.19 3 10H1V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V10H21M21 15H19V13H17V15H15V13H13V15H11V13H9V15H7V13H5V15H3V12H21V15Z";
var mdiTrainCarHopper = "M1 8V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V8H1M13 15V11H11V15H8V11H6V15H3V10H21V15H18V11H16V15H13Z";
var mdiTrainCarHopperCovered = "M23 9V7H1V9L2 10.33V15H1V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H10L11 18H13L14 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V15H22V10.33L23 9M4 15V13L5.5 15H4M5 10V9H19V10H5M20 15H18.5L20 13V15Z";
var mdiTrainCarHopperFull = "M21 8C19.04 6.19 15.74 5 12 5S4.96 6.19 3 8H1V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V8H21M13 15V11H11V15H8V11H6V15H3V10H21V15H18V11H16V15H13Z";
var mdiTrainCarIntermodal = "M21 15V11H3V15H1V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V15H21M16 14H8V13H16V14M21 5H3V10H21V5M16 8H8V7H16V8Z";
var mdiTrainCarPassenger = "M21 7H3C1.9 7 1 7.9 1 9V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V9C23 7.9 22.11 7 21 7M7 12H3V9H7V12M15 12H9V9H15V12M21 12H17V9H21V12Z";
var mdiTrainCarPassengerDoor = "M21 7H3C1.9 7 1 7.9 1 9V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V9C23 7.9 22.11 7 21 7M7 12H3V9H7V12M11 16H9V9H11V16M15 16H13V9H15V16M21 12H17V9H21V12Z";
var mdiTrainCarPassengerDoorOpen = "M21 7H3C1.9 7 1 7.9 1 9V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V9C23 7.9 22.11 7 21 7M8 12H3V9H8V12M14 16H10V9H14V16M21 12H16V9H21V12Z";
var mdiTrainCarPassengerVariant = "M21 7H3C1.9 7 1 7.9 1 9V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V9C23 7.9 22.11 7 21 7M11 12H3V9H11V12M21 12H13V9H21V12Z";
var mdiTrainCarTank = "M23 15V17H22C22 18.11 21.11 19 20 19S18 18.11 18 17H6C6 18.11 5.11 19 4 19S2 18.11 2 17H1V15H23M21 8H15V7H9V8H3C1.9 8 1 8.9 1 10V12C1 13.11 1.9 14 3 14H21C22.11 14 23 13.11 23 12V10C23 8.9 22.11 8 21 8Z";
var mdiTrainVariant = "M18,10H6V5H18M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M4,15.5A3.5,3.5 0 0,0 7.5,19L6,20.5V21H18V20.5L16.5,19A3.5,3.5 0 0,0 20,15.5V5C20,1.5 16.42,1 12,1C7.58,1 4,1.5 4,5V15.5Z";
var mdiTram = "M19,16.94V8.5C19,5.71 16.39,5.1 13,5L13.75,3.5H17V2H7V3.5H11.75L11,5C7.86,5.11 5,5.73 5,8.5V16.94C5,18.39 6.19,19.6 7.59,19.91L6,21.5V22H8.23L10.23,20H14L16,22H18V21.5L16.5,20H16.42C18.11,20 19,18.63 19,16.94M12,18.5A1.5,1.5 0 0,1 10.5,17A1.5,1.5 0 0,1 12,15.5A1.5,1.5 0 0,1 13.5,17A1.5,1.5 0 0,1 12,18.5M17,14H7V9H17V14Z";
var mdiTramSide = "M9 1L5 4L7.5 6H5C5 6 2 6 2 9V19H7C7 19 7 17 9 17H22V14H18V8H22V6H10.5L13 4L9 1M4 8H9V14H4V8M11 8H16V14H11V8M4 16H5V18H4V16M9 19V19.5C9 20.88 10.12 22 11.5 22C12.5 22 13.39 21.41 13.79 20.5H15.21C15.61 21.41 16.5 22 17.5 22C18.88 22 20 20.88 20 19.5V19H9Z";
var mdiTranscribe = "M20,5A2,2 0 0,1 22,7V17A2,2 0 0,1 20,19H4C2.89,19 2,18.1 2,17V7C2,5.89 2.89,5 4,5H20M18,17V15H12.5L10.5,17H18M6,17H8.5L15.35,10.12C15.55,9.93 15.55,9.61 15.35,9.41L13.59,7.65C13.39,7.45 13.07,7.45 12.88,7.65L6,14.53V17Z";
var mdiTranscribeClose = "M12,23L8,19H16L12,23M20,3A2,2 0 0,1 22,5V15A2,2 0 0,1 20,17H4A2,2 0 0,1 2,15V5A2,2 0 0,1 4,3H20M18,15V13H12.5L10.5,15H18M6,15H8.5L15.35,8.12C15.55,7.93 15.55,7.61 15.35,7.42L13.59,5.65C13.39,5.45 13.07,5.45 12.88,5.65L6,12.53V15Z";
var mdiTransfer = "M8 4A2 2 0 0 0 6 6V10H8V6H16V9H13.5L17 12.5L20.5 9H18V6A2 2 0 0 0 16 4H8M3 12V14H11V12H3M3 15V17H11V15H3M13 15V17H21V15H13M3 18V20H11V18H3M13 18V20H21V18H13Z";
var mdiTransferDown = "M16,3V5H8V3H16M16,7V9H8V7H16M16,11V13H8V11H16M5,15H19L12,22L5,15Z";
var mdiTransferLeft = "M21,16H19V8H21V16M17,16H15V8H17V16M13,16H11V8H13V16M9,5V19L2,12L9,5Z";
var mdiTransferRight = "M3,8H5V16H3V8M7,8H9V16H7V8M11,8H13V16H11V8M15,19.25V4.75L22.25,12L15,19.25Z";
var mdiTransferUp = "M8,21V19H16V21H8M8,17V15H16V17H8M8,13V11H16V13H8M19,9H5L12,2L19,9Z";
var mdiTransitConnection = "M15,12C15,10.7 14.16,9.6 13,9.18V6.82C14.16,6.4 15,5.3 15,4A3,3 0 0,0 12,1A3,3 0 0,0 9,4C9,5.3 9.84,6.4 11,6.82V9.19C9.84,9.6 9,10.7 9,12C9,13.3 9.84,14.4 11,14.82V17.18C9.84,17.6 9,18.7 9,20A3,3 0 0,0 12,23A3,3 0 0,0 15,20C15,18.7 14.16,17.6 13,17.18V14.82C14.16,14.4 15,13.3 15,12M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M12,21A1,1 0 0,1 11,20A1,1 0 0,1 12,19A1,1 0 0,1 13,20A1,1 0 0,1 12,21Z";
var mdiTransitConnectionHorizontal = "M12 9C10.7 9 9.6 9.8 9.2 11H6.8C6.4 9.8 5.3 9 4 9C2.3 9 1 10.3 1 12S2.3 15 4 15C5.3 15 6.4 14.2 6.8 13H9.2C9.6 14.2 10.7 15 12 15S14.4 14.2 14.8 13H17.2C17.6 14.2 18.7 15 20 15C21.7 15 23 13.7 23 12S21.7 9 20 9C18.7 9 17.6 9.8 17.2 11H14.8C14.4 9.8 13.3 9 12 9M3 12C3 11.4 3.4 11 4 11S5 11.4 5 12 4.6 13 4 13 3 12.6 3 12M21 12C21 12.6 20.6 13 20 13S19 12.6 19 12 19.4 11 20 11 21 11.4 21 12Z";
var mdiTransitConnectionVariant = "M18,11H14.82C14.4,9.84 13.3,9 12,9C10.7,9 9.6,9.84 9.18,11H6C5.67,11 4,10.9 4,9V8C4,6.17 5.54,6 6,6H16.18C16.6,7.16 17.7,8 19,8A3,3 0 0,0 22,5A3,3 0 0,0 19,2C17.7,2 16.6,2.84 16.18,4H6C4.39,4 2,5.06 2,8V9C2,11.94 4.39,13 6,13H9.18C9.6,14.16 10.7,15 12,15C13.3,15 14.4,14.16 14.82,13H18C18.33,13 20,13.1 20,15V16C20,17.83 18.46,18 18,18H7.82C7.4,16.84 6.3,16 5,16A3,3 0 0,0 2,19A3,3 0 0,0 5,22C6.3,22 7.4,21.16 7.82,20H18C19.61,20 22,18.93 22,16V15C22,12.07 19.61,11 18,11M19,4A1,1 0 0,1 20,5A1,1 0 0,1 19,6A1,1 0 0,1 18,5A1,1 0 0,1 19,4M5,20A1,1 0 0,1 4,19A1,1 0 0,1 5,18A1,1 0 0,1 6,19A1,1 0 0,1 5,20Z";
var mdiTransitDetour = "M19 3A3 3 0 0 0 16.61 4.21A11.5 11.5 0 0 0 13.75 4L13.88 6A9.47 9.47 0 0 1 16 6.13A3 3 0 1 0 19 3M19 7A1 1 0 1 1 20 6A1 1 0 0 1 19 7M8.86 7.86L7.67 6.25A11.5 11.5 0 0 1 11.6 4.37L12.1 6.31A9.5 9.5 0 0 0 8.86 7.86M21 18A3 3 0 1 1 15.69 16.11A9.47 9.47 0 0 0 8.59 13.46C8.37 13.47 8.16 13.5 7.94 13.54A3 3 0 1 1 4.39 10.06A11.54 11.54 0 0 1 6.04 7.7L7.5 9.06A9.34 9.34 0 0 0 6.5 10.41A3.04 3.04 0 0 1 7.62 11.56C7.91 11.5 8.19 11.5 8.5 11.46A11.47 11.47 0 0 1 17.46 15.05A2.96 2.96 0 0 1 18 15A3 3 0 0 1 21 18Z";
var mdiTransitSkip = "M21 12C21 8 18.5 4.7 15 3.5C14.7 2.1 13.5 1 12 1C10.3 1 9 2.3 9 4S10.3 7 12 7C13.1 7 14.1 6.4 14.6 5.5C17.2 6.5 19 9 19 12C19 14.9 17.2 17.5 14.6 18.5C14.1 17.6 13.1 17 12 17C10.3 17 9 18.3 9 20S10.3 23 12 23C13.5 23 14.7 21.9 15 20.5C18.5 19.3 21 15.9 21 12M12 5C11.4 5 11 4.6 11 4S11.4 3 12 3 13 3.4 13 4 12.6 5 12 5M12 21C11.4 21 11 20.6 11 20S11.4 19 12 19 13 19.4 13 20 12.6 21 12 21M12 9C13.7 9 15 10.3 15 12S13.7 15 12 15 9 13.7 9 12 10.3 9 12 9Z";
var mdiTransitTransfer = "M16.5,15.5H22V17H16.5V18.75L14,16.25L16.5,13.75V15.5M19.5,19.75V18L22,20.5L19.5,23V21.25H14V19.75H19.5M9.5,5.5A2,2 0 0,1 7.5,3.5A2,2 0 0,1 9.5,1.5A2,2 0 0,1 11.5,3.5A2,2 0 0,1 9.5,5.5M5.75,8.9L4,9.65V13H2V8.3L7.25,6.15C7.5,6.05 7.75,6 8,6C8.7,6 9.35,6.35 9.7,6.95L10.65,8.55C11.55,10 13.15,11 15,11V13C12.8,13 10.85,12 9.55,10.4L8.95,13.4L11,15.45V23H9V17L6.85,15L5.1,23H3L5.75,8.9Z";
var mdiTransition = "M15,2A7,7 0 0,1 22,9C22,11.71 20.46,14.05 18.22,15.22C17.55,16.5 16.5,17.55 15.22,18.22C14.05,20.46 11.71,22 9,22A7,7 0 0,1 2,15C2,12.29 3.54,9.95 5.78,8.78C6.45,7.5 7.5,6.45 8.78,5.78C9.95,3.54 12.29,2 15,2M12,19A7,7 0 0,1 5,12C4.37,12.84 4,13.87 4,15A5,5 0 0,0 9,20C10.13,20 11.16,19.63 12,19M15,16A7,7 0 0,1 8,9H8C7.37,9.84 7,10.87 7,12A5,5 0 0,0 12,17C13.13,17 14.16,16.63 15,16V16M15,4C13.87,4 12.84,4.37 12,5V5A7,7 0 0,1 19,12H19C19.63,11.16 20,10.13 20,9A5,5 0 0,0 15,4M10,9A5,5 0 0,0 15,14C15.6,14 16.17,13.9 16.7,13.7C16.9,13.17 17,12.6 17,12A5,5 0 0,0 12,7C11.4,7 10.83,7.1 10.3,7.3C10.1,7.83 10,8.4 10,9Z";
var mdiTransitionMasked = "M15,2C16.94,2 18.59,2.7 19.95,4.05C21.3,5.41 22,7.06 22,9C22,10.56 21.5,11.96 20.58,13.2C19.64,14.43 18.44,15.27 16.97,15.7L17,15.38V15C17,12.81 16.23,10.93 14.65,9.35C13.07,7.77 11.19,7 9,7H8.63L8.3,7.03C8.73,5.56 9.57,4.36 10.8,3.42C12.04,2.5 13.44,2 15,2M9,8A7,7 0 0,1 16,15A7,7 0 0,1 9,22A7,7 0 0,1 2,15A7,7 0 0,1 9,8M9,10A5,5 0 0,0 4,15A5,5 0 0,0 9,20A5,5 0 0,0 14,15A5,5 0 0,0 9,10Z";
var mdiTranslate = "M12.87,15.07L10.33,12.56L10.36,12.53C12.1,10.59 13.34,8.36 14.07,6H17V4H10V2H8V4H1V6H12.17C11.5,7.92 10.44,9.75 9,11.35C8.07,10.32 7.3,9.19 6.69,8H4.69C5.42,9.63 6.42,11.17 7.67,12.56L2.58,17.58L4,19L9,14L12.11,17.11L12.87,15.07M18.5,10H16.5L12,22H14L15.12,19H19.87L21,22H23L18.5,10M15.88,17L17.5,12.67L19.12,17H15.88Z";
var mdiTranslateOff = "M12.17,5.81C11.87,6.69 11.47,7.55 11,8.39L12.35,9.74C13.11,8.5 13.71,7.18 14.13,5.81H17.16V3.75H9.94V1.69H7.87V3.75H6.37L8.43,5.81H12.17M15.53,12.91L17.03,14.41L17.67,12.69L19.08,16.47L22.39,19.77L18.7,9.94H16.64L15.53,12.91M1.31,1.31L0,2.62L1.13,3.75H0.65V5.81H3.19L5.26,7.88H4.46C5.21,9.56 6.24,11.15 7.53,12.58L2.28,17.76L3.75,19.22L8.91,14.07L12.11,17.27L12.8,15.43L14.1,16.72L12,22.31H14.06L15.22,19.22H16.6L21.38,24L22.69,22.69L1.31,1.31Z";
var mdiTranslateVariant = "M11 1H3C1.9 1 1 1.9 1 3V15L4 12H9V11C9 8.8 10.79 7 13 7V3C13 1.9 12.1 1 11 1M11 4L9.5 4C9.16 5.19 8.54 6.3 7.68 7.26L7.66 7.28L8.92 8.53L8.55 9.54L7 8L4.5 10.5L3.81 9.77L6.34 7.28C5.72 6.59 5.22 5.82 4.86 5H5.85C6.16 5.6 6.54 6.17 7 6.68C7.72 5.88 8.24 4.97 8.57 4L3 4V3H6.5V2H7.5V3H11V4M21 9H13C11.9 9 11 9.9 11 11V18C11 19.1 11.9 20 13 20H20L23 23V11C23 9.9 22.1 9 21 9M19.63 19L18.78 16.75H15.22L14.38 19H12.88L16.25 10H17.75L21.13 19H19.63M17 12L18.22 15.25H15.79L17 12Z";
var mdiTransmissionTower = "M8.28,5.45L6.5,4.55L7.76,2H16.23L17.5,4.55L15.72,5.44L15,4H9L8.28,5.45M18.62,8H14.09L13.3,5H10.7L9.91,8H5.38L4.1,10.55L5.89,11.44L6.62,10H17.38L18.1,11.45L19.89,10.56L18.62,8M17.77,22H15.7L15.46,21.1L12,15.9L8.53,21.1L8.3,22H6.23L9.12,11H11.19L10.83,12.35L12,14.1L13.16,12.35L12.81,11H14.88L17.77,22M11.4,15L10.5,13.65L9.32,18.13L11.4,15M14.68,18.12L13.5,13.64L12.6,15L14.68,18.12Z";
var mdiTransmissionTowerExport = "M5.18 5.45L3.4 4.55L4.66 2H13.13L14.4 4.55L12.62 5.44L11.9 4H5.9L5.18 5.45M15.5 8H11L10.2 5H7.6L6.81 8H2.28L1 10.55L2.79 11.44L3.5 10H14.28L15 11.45L16.79 10.56L15.5 8M14.67 22H12.6L12.36 21.1L8.9 15.9L5.43 21.1L5.2 22H3.13L6 11H8.09L7.73 12.35L8.9 14.1L10.06 12.35L9.71 11H11.78L14.67 22M8.3 15L7.4 13.65L6.22 18.13L8.3 15M11.58 18.12L10.4 13.64L9.5 15L11.58 18.12M23 16L19 12V15H15V17H19V20L23 16Z";
var mdiTransmissionTowerImport = "M11.39 5.45L9.61 4.55L10.87 2H19.34L20.61 4.55L18.83 5.44L18.11 4H12.11L11.39 5.45M21.73 8H17.2L16.41 5H13.81L13 8H8.5L7.21 10.55L9 11.44L9.73 10H20.5L21.21 11.45L23 10.56L21.73 8M20.88 22H18.81L18.57 21.1L15.11 15.9L11.64 21.1L11.41 22H9.34L12.23 11H14.3L13.94 12.35L15.11 14.1L16.27 12.35L15.92 11H18L20.88 22M14.5 15L13.61 13.65L12.43 18.13L14.5 15M17.79 18.12L16.61 13.64L15.71 15L17.79 18.12M9 16L5 12V15H1V17H5V20L9 16Z";
var mdiTransmissionTowerOff = "M22.1 21.5L2.4 1.7L1.1 3L6.1 8H5.4L4.1 10.5L5.9 11.4L6.6 10H8.1L9.1 11L6.2 22H8.3L8.5 21.1L12 15.9L15.5 21.1L15.7 22H17.8L17 18.8L20.9 22.7L22.1 21.5M9.3 18.1L10.5 13.6L11.4 14.9L9.3 18.1M14.7 18.1L12.6 15L12.8 14.7L14.1 16L14.7 18.1M14.2 11H14.9L15.1 11.9L14.2 11M14.1 8H18.6L19.9 10.6L18.1 11.5L17.4 10H13.2L10.2 7L10.7 5H13.3L14.1 8M8.4 5.2L6.9 3.7L7.8 2H16.3L17.6 4.5L15.8 5.4L15 4H9L8.4 5.2Z";
var mdiTrashCan = "M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M9,8H11V17H9V8M13,8H15V17H13V8Z";
var mdiTrashCanOutline = "M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z";
var mdiTray = "M2 12H4V17H20V12H22V17A2 2 0 0 1 20 19H4A2 2 0 0 1 2 17Z";
var mdiTrayAlert = "M2 12H4V17H20V12H22V17A2 2 0 0 1 20 19H4A2 2 0 0 1 2 17M13 12H11V14H13M13 4H11V10H13Z";
var mdiTrayArrowDown = "M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z";
var mdiTrayArrowUp = "M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z";
var mdiTrayFull = "M18 5H6V7H18M6 9H18V11H6M2 12H4V17H20V12H22V17A2 2 0 0 1 20 19H4A2 2 0 0 1 2 17M18 13H6V15H18Z";
var mdiTrayMinus = "M16 10H8V8H16M2 17A2 2 0 0 0 4 19H20A2 2 0 0 0 22 17V12H20V17H4V12H2Z";
var mdiTrayPlus = "M2 12H4V17H20V12H22V17A2 2 0 0 1 20 19H4A2 2 0 0 1 2 17M11 5H13V8H16V10H13V13H11V10H8V8H11Z";
var mdiTrayRemove = "M2 17A2 2 0 0 0 4 19H20A2 2 0 0 0 22 17V12H20V17H4V12H2M14.12 5.46L15.54 6.88L13.41 9L15.54 11.12L14.12 12.54L12 10.41L9.88 12.54L8.46 11.12L10.59 9L8.46 6.88L9.88 5.46L12 7.59Z";
var mdiTreasureChest = "M5,4H19A3,3 0 0,1 22,7V11H15V10H9V11H2V7A3,3 0 0,1 5,4M11,11H13V13H11V11M2,12H9V13L11,15H13L15,13V12H22V20H2V12Z";
var mdiTreasureChestOutline = "M2 20H22V7C22 6.2 21.68 5.44 21.12 4.88C20.56 4.32 19.8 4 19 4H5C4.2 4 3.44 4.32 2.88 4.88C2.32 5.44 2 6.2 2 7V20M20 11H15V9H9V11H4V7C4 6.74 4.11 6.5 4.29 6.29C4.5 6.11 4.74 6 5 6H19C19.27 6 19.5 6.11 19.71 6.29C19.9 6.5 20 6.74 20 7V11M15 13H20V18H4V13H9L11 15H13L15 13M11 11H13V13H11V11Z";
var mdiTree = "M11,21V16.74C10.53,16.91 10.03,17 9.5,17C7,17 5,15 5,12.5C5,11.23 5.5,10.09 6.36,9.27C6.13,8.73 6,8.13 6,7.5C6,5 8,3 10.5,3C12.06,3 13.44,3.8 14.25,5C14.33,5 14.41,5 14.5,5A5.5,5.5 0 0,1 20,10.5A5.5,5.5 0 0,1 14.5,16C14,16 13.5,15.93 13,15.79V21H11Z";
var mdiTreeOutline = "M10.5,3C8,3 6,5 6,7.5C6,8.11 6.13,8.71 6.37,9.27C5.5,10.12 5,11.28 5,12.5C5,15 7,17 9.5,17C10,17 10.5,16.89 11,16.72V21H13V15.77C13.5,15.91 14,16 14.5,16A5.5,5.5 0 0,0 20,10.5A5.5,5.5 0 0,0 14.5,5C14.41,5 14.33,5 14.24,5C13.41,3.76 12,3 10.5,3M10.5,5C11.82,5 12.91,6.03 13,7.35C13.46,7.12 14,7 14.5,7A3.5,3.5 0 0,1 18,10.5A3.5,3.5 0 0,1 14.5,14C13.54,14 12.63,13.61 11.96,12.91C11.76,14.12 10.72,15 9.5,15A2.5,2.5 0 0,1 7,12.5C7,11.12 7.8,10.54 9,9.79C8.2,8.76 8,8.16 8,7.5A2.5,2.5 0 0,1 10.5,5Z";
var mdiTrello = "M19.5,2H4.5A2.5,2.5 0 0,0 2,4.5V19.5A2.5,2.5 0 0,0 4.5,22H19.5A2.5,2.5 0 0,0 22,19.5V4.5A2.5,2.5 0 0,0 19.5,2M10.7,17.2A1.2,1.2 0 0,1 9.5,18.4H5.8C5.14,18.4 4.6,17.86 4.6,17.2V5.8A1.2,1.2 0 0,1 5.8,4.6H9.5C10.16,4.6 10.7,5.14 10.7,5.8V17.2M19.4,12.2C19.4,12.86 18.86,13.4 18.2,13.4H14.5C13.84,13.4 13.3,12.86 13.3,12.2V5.8C13.3,5.14 13.84,4.6 14.5,4.6H18.2C18.86,4.6 19.4,5.14 19.4,5.8V12.2Z";
var mdiTrendingDown = "M16,18L18.29,15.71L13.41,10.83L9.41,14.83L2,7.41L3.41,6L9.41,12L13.41,8L19.71,14.29L22,12V18H16Z";
var mdiTrendingNeutral = "M22,12L18,8V11H3V13H18V16L22,12Z";
var mdiTrendingUp = "M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z";
var mdiTriangle = "M1,21H23L12,2";
var mdiTriangleDown = "M1 3H23L12 22";
var mdiTriangleDownOutline = "M12 22L1 3H23M12 18L19.53 5H4.47";
var mdiTriangleOutline = "M12,2L1,21H23M12,6L19.53,19H4.47";
var mdiTriangleSmallDown = "M8 9H16L12 16";
var mdiTriangleSmallUp = "M8 15H16L12 8";
var mdiTriangleWave = "M22 12L17 22L7.1 6.04L4.24 12H2L7 2L16.9 17.96L19.76 12H22Z";
var mdiTriforce = "M1.5,21L12,3.5L22.5,21H1.5M12,21L17,12H7L12,21Z";
var mdiTrophy = "M18 2C17.1 2 16 3 16 4H8C8 3 6.9 2 6 2H2V11C2 12 3 13 4 13H6.2C6.6 15 7.9 16.7 11 17V19.08C8 19.54 8 22 8 22H16C16 22 16 19.54 13 19.08V17C16.1 16.7 17.4 15 17.8 13H20C21 13 22 12 22 11V2H18M6 11H4V4H6V11M20 11H18V4H20V11Z";
var mdiTrophyAward = "M15.2 10.7L16.6 16L12 12.2L7.4 16L8.8 10.8L4.6 7.3L10 7L12 2L14 7L19.4 7.3L15.2 10.7M14 19H13V16L12 15L11 16V19H10C8.9 19 8 19.9 8 21V22H16V21C16 19.9 15.11 19 14 19Z";
var mdiTrophyBroken = "M6.2 13C6.6 14.8 7.6 16.3 10 16.8V19.34C8 20.12 8 22 8 22H13.2L10.2 15L14.2 10L10.7 4H8C8 3 6.9 2 6 2H2V11C2 12 3 13 4 13H6.2M6 11H4V4H6V11M17.8 13H20C21 13 22 12 22 11V2H18C17.1 2 16 3 16 4H13.9L16.7 10L12.2 15L13.2 22H16C16 22 16 20.12 14 19.34L14 16.85C16.39 16.35 17.5 14.7 17.8 13M20 11H18V4H20V11Z";
var mdiTrophyOutline = "M18 2C17.1 2 16 3 16 4H8C8 3 6.9 2 6 2H2V11C2 12 3 13 4 13H6.2C6.6 15 7.9 16.7 11 17V19.08C8 19.54 8 22 8 22H16C16 22 16 19.54 13 19.08V17C16.1 16.7 17.4 15 17.8 13H20C21 13 22 12 22 11V2H18M6 11H4V4H6V11M16 11.5C16 13.43 15.42 15 12 15C8.59 15 8 13.43 8 11.5V6H16V11.5M20 11H18V4H20V11Z";
var mdiTrophyVariant = "M17 4V2H7V4H2V11C2 12.1 2.9 13 4 13H7.1C7.5 14.96 9.04 16.5 11 16.9V19.08C8 19.54 8 22 8 22H16C16 22 16 19.54 13 19.08V16.9C14.96 16.5 16.5 14.96 16.9 13H20C21.1 13 22 12.1 22 11V4H17M4 11V6H7V11L4 11M20 11L17 11V6H20L20 11Z";
var mdiTrophyVariantOutline = "M17 4V2H7V4H2V11C2 12.1 2.9 13 4 13H7.1C7.5 14.96 9.04 16.5 11 16.9V19.08C8 19.54 8 22 8 22H16C16 22 16 19.54 13 19.08V16.9C14.96 16.5 16.5 14.96 16.9 13H20C21.1 13 22 12.1 22 11V4H17M4 11V6H7V11L4 11M15 12C15 13.65 13.65 15 12 15S9 13.65 9 12V4H15V12M20 11L17 11V6H20L20 11Z";
var mdiTruck = "M18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5M19.5,9.5L21.46,12H17V9.5M6,18.5A1.5,1.5 0 0,1 4.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,17A1.5,1.5 0 0,1 6,18.5M20,8H17V4H3C1.89,4 1,4.89 1,6V17H3A3,3 0 0,0 6,20A3,3 0 0,0 9,17H15A3,3 0 0,0 18,20A3,3 0 0,0 21,17H23V12L20,8Z";
var mdiTruckAlert = "M3 4C1.9 4 1 4.9 1 6V17H3C3 18.7 4.3 20 6 20S9 18.7 9 17H15C15 18.7 16.3 20 18 20S21 18.7 21 17H23V12L20 8H17V4H3M8 6H10V10H8V6M17 9.5H19.5L21.5 12H17V9.5M8 12H10V14H8V12M6 15.5C6.8 15.5 7.5 16.2 7.5 17S6.8 18.5 6 18.5 4.5 17.8 4.5 17 5.2 15.5 6 15.5M18 15.5C18.8 15.5 19.5 16.2 19.5 17S18.8 18.5 18 18.5 16.5 17.8 16.5 17 17.2 15.5 18 15.5Z";
var mdiTruckAlertOutline = "M8 12H10V14H8V12M8 7H10V11H8V7M18 18.5C18.8 18.5 19.5 17.8 19.5 17S18.8 15.5 18 15.5 16.5 16.2 16.5 17 17.2 18.5 18 18.5M19.5 9.5H17V12H21.5L19.5 9.5M6 18.5C6.8 18.5 7.5 17.8 7.5 17S6.8 15.5 6 15.5 4.5 16.2 4.5 17 5.2 18.5 6 18.5M20 8L23 12V17H21C21 18.7 19.7 20 18 20S15 18.7 15 17H9C9 18.7 7.7 20 6 20S3 18.7 3 17H1V6C1 4.9 1.9 4 3 4H17V8H20M3 6V15H3.8C4.3 14.4 5.2 14 6 14S7.7 14.4 8.2 15H15V6H3Z";
var mdiTruckCargoContainer = "M20 8H17V4H1V17H3C3 18.66 4.34 20 6 20S9 18.66 9 17H15C15 18.66 16.34 20 18 20S21 18.66 21 17H23V12L20 8M6 18.5C5.17 18.5 4.5 17.83 4.5 17S5.17 15.5 6 15.5 7.5 16.17 7.5 17 6.83 18.5 6 18.5M15 7H13V14H11V7H9V14H7V7H5V14H3V6H15V7M18 18.5C17.17 18.5 16.5 17.83 16.5 17S17.17 15.5 18 15.5 19.5 16.17 19.5 17 18.83 18.5 18 18.5M17 12V9.5H19.5L21.46 12H17Z";
var mdiTruckCheck = "M3,4H17V8H20L23,12V17H21A3,3 0 0,1 18,20A3,3 0 0,1 15,17H9A3,3 0 0,1 6,20A3,3 0 0,1 3,17H1V6C1,4.89 1.9,4 3,4M17,9.5V12H21.47L19.5,9.5H17M6,15.5A1.5,1.5 0 0,0 4.5,17A1.5,1.5 0 0,0 6,18.5A1.5,1.5 0 0,0 7.5,17A1.5,1.5 0 0,0 6,15.5M18,15.5A1.5,1.5 0 0,0 16.5,17A1.5,1.5 0 0,0 18,18.5A1.5,1.5 0 0,0 19.5,17A1.5,1.5 0 0,0 18,15.5M8,14L14,8L12.59,6.58L8,11.17L5.91,9.08L4.5,10.5L8,14Z";
var mdiTruckCheckOutline = "M18 18.5C18.83 18.5 19.5 17.83 19.5 17C19.5 16.17 18.83 15.5 18 15.5C17.17 15.5 16.5 16.17 16.5 17C16.5 17.83 17.17 18.5 18 18.5M19.5 9.5H17V12H21.46L19.5 9.5M6 18.5C6.83 18.5 7.5 17.83 7.5 17C7.5 16.17 6.83 15.5 6 15.5C5.17 15.5 4.5 16.17 4.5 17C4.5 17.83 5.17 18.5 6 18.5M20 8L23 12V17H21C21 18.66 19.66 20 18 20C16.34 20 15 18.66 15 17H9C9 18.66 7.66 20 6 20C4.34 20 3 18.66 3 17H1V6C1 4.89 1.89 4 3 4H17V8H20M3 6V15H3.76C4.31 14.39 5.11 14 6 14C6.89 14 7.69 14.39 8.24 15H15V6H3M5 10.5L6.5 9L8 10.5L11.5 7L13 8.5L8 13.5L5 10.5Z";
var mdiTruckDelivery = "M3,4A2,2 0 0,0 1,6V17H3A3,3 0 0,0 6,20A3,3 0 0,0 9,17H15A3,3 0 0,0 18,20A3,3 0 0,0 21,17H23V12L20,8H17V4M10,6L14,10L10,14V11H4V9H10M17,9.5H19.5L21.47,12H17M6,15.5A1.5,1.5 0 0,1 7.5,17A1.5,1.5 0 0,1 6,18.5A1.5,1.5 0 0,1 4.5,17A1.5,1.5 0 0,1 6,15.5M18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5Z";
var mdiTruckDeliveryOutline = "M18 18.5C18.83 18.5 19.5 17.83 19.5 17C19.5 16.17 18.83 15.5 18 15.5C17.17 15.5 16.5 16.17 16.5 17C16.5 17.83 17.17 18.5 18 18.5M19.5 9.5H17V12H21.46L19.5 9.5M6 18.5C6.83 18.5 7.5 17.83 7.5 17C7.5 16.17 6.83 15.5 6 15.5C5.17 15.5 4.5 16.17 4.5 17C4.5 17.83 5.17 18.5 6 18.5M20 8L23 12V17H21C21 18.66 19.66 20 18 20C16.34 20 15 18.66 15 17H9C9 18.66 7.66 20 6 20C4.34 20 3 18.66 3 17H1V6C1 4.89 1.89 4 3 4H17V8H20M3 6V15H3.76C4.31 14.39 5.11 14 6 14C6.89 14 7.69 14.39 8.24 15H15V6H3M10 7L13.5 10.5L10 14V11.5H5V9.5H10V7Z";
var mdiTruckFast = "M3,13.5L2.25,12H7.5L6.9,10.5H2L1.25,9H9.05L8.45,7.5H1.11L0.25,6H4A2,2 0 0,1 6,4H18V8H21L24,12V17H22A3,3 0 0,1 19,20A3,3 0 0,1 16,17H12A3,3 0 0,1 9,20A3,3 0 0,1 6,17H4V13.5H3M19,18.5A1.5,1.5 0 0,0 20.5,17A1.5,1.5 0 0,0 19,15.5A1.5,1.5 0 0,0 17.5,17A1.5,1.5 0 0,0 19,18.5M20.5,9.5H18V12H22.46L20.5,9.5M9,18.5A1.5,1.5 0 0,0 10.5,17A1.5,1.5 0 0,0 9,15.5A1.5,1.5 0 0,0 7.5,17A1.5,1.5 0 0,0 9,18.5Z";
var mdiTruckFastOutline = "M.75 7.5H10.5L11.25 9H1.5L.75 7.5M1.75 10.5H11.5L12.25 12H2.5L1.75 10.5M18 18.5C18.83 18.5 19.5 17.83 19.5 17C19.5 16.17 18.83 15.5 18 15.5C17.17 15.5 16.5 16.17 16.5 17C16.5 17.83 17.17 18.5 18 18.5M19.5 9.5H17V12H21.46L19.5 9.5M8 18.5C8.83 18.5 9.5 17.83 9.5 17C9.5 16.17 8.83 15.5 8 15.5C7.17 15.5 6.5 16.17 6.5 17C6.5 17.83 7.17 18.5 8 18.5M20 8L23 12V17H21C21 18.66 19.66 20 18 20C16.34 20 15 18.66 15 17H11C11 18.66 9.65 20 8 20C6.34 20 5 18.66 5 17H3V13.5 13.5H5V15H5.76C6.31 14.39 7.11 14 8 14C8.89 14 9.69 14.39 10.24 15H15V6H3V6C3 4.89 3.89 4 5 4H17V8H20Z";
var mdiTruckFlatbed = "M18 4H13V13H1V17H3C3 17.83 3.3 18.53 3.89 19.13C4.5 19.72 5.19 20 6 20S7.5 19.72 8.11 19.13C8.7 18.53 9 17.83 9 17H14.5C14.5 17.83 14.78 18.53 15.38 19.13C15.97 19.72 16.67 20 17.5 20C18.3 20 19 19.72 19.59 19.13C20.19 18.53 20.5 17.83 20.5 17H23V10L18 4M7.08 18.07C6.8 18.37 6.44 18.5 6 18.5S5.2 18.37 4.92 18.07C4.64 17.77 4.5 17.42 4.5 17C4.5 16.61 4.64 16.26 4.92 15.96C5.2 15.66 5.56 15.5 6 15.5S6.8 15.66 7.08 15.96C7.36 16.26 7.5 16.61 7.5 17C7.5 17.42 7.36 17.77 7.08 18.07M18.54 18.07C18.24 18.37 17.89 18.5 17.5 18.5C17.08 18.5 16.73 18.37 16.43 18.07S16 17.42 16 17C16 16.61 16.13 16.26 16.43 15.96C16.73 15.66 17.08 15.5 17.5 15.5C17.89 15.5 18.24 15.66 18.54 15.96C18.84 16.26 19 16.61 19 17C19 17.42 18.84 17.77 18.54 18.07M15 10V6H17.06L20.39 10H15Z";
var mdiTruckMinus = "M20 8H17V4H3C1.89 4 1 4.89 1 6V17H3C3 18.66 4.34 20 6 20S9 18.66 9 17H15C15 18.66 16.34 20 18 20S21 18.66 21 17H23V12L20 8M6 18.5C5.17 18.5 4.5 17.83 4.5 17S5.17 15.5 6 15.5 7.5 16.17 7.5 17 6.83 18.5 6 18.5M13 11H5V9H13V11M18 18.5C17.17 18.5 16.5 17.83 16.5 17S17.17 15.5 18 15.5 19.5 16.17 19.5 17 18.83 18.5 18 18.5M17 12V9.5H19.5L21.46 12H17";
var mdiTruckMinusOutline = "M20 8H17V4H3C1.9 4 1 4.9 1 6V17H3C3 18.7 4.3 20 6 20S9 18.7 9 17H15C15 18.7 16.3 20 18 20S21 18.7 21 17H23V12L20 8M6 18.5C5.2 18.5 4.5 17.8 4.5 17S5.2 15.5 6 15.5 7.5 16.2 7.5 17 6.8 18.5 6 18.5M15 15H8.2C7.7 14.4 6.9 14 6 14S4.3 14.4 3.8 15H3V6H15V15M18 18.5C17.2 18.5 16.5 17.8 16.5 17S17.2 15.5 18 15.5 19.5 16.2 19.5 17 18.8 18.5 18 18.5M17 12V9.5H19.5L21.5 12H17M6 11V9H12V11H6Z";
var mdiTruckOffRoad = "M14.81 3.4L9.39 4.36L10.09 8.3L.733 9.95L1.6 14.87L3.57 14.53C3.71 15.31 4.15 16 4.81 16.46C5.46 16.92 6.26 17.1 7.05 16.96C7.83 16.82 8.53 16.38 9 15.73C9.44 15.07 9.62 14.27 9.5 13.5L15.39 12.44C15.53 13.23 15.97 13.92 16.62 14.38C17.27 14.83 18.08 15 18.86 14.88C19.65 14.74 20.34 14.29 20.8 13.64C21.26 13 21.44 12.18 21.3 11.4L23.27 11.05L22.75 8.1C22.55 7 21.5 6.28 20.43 6.5L18.46 6.82L14.81 3.4M11.13 5.58L14.58 4.97L16.94 7.09L11.57 8.04L11.13 5.58M6.27 12.53C6.66 12.46 7.06 12.55 7.39 12.78C7.71 13 7.93 13.35 8 13.74C8.07 14.14 8 14.54 7.75 14.86C7.53 15.19 7.18 15.41 6.79 15.5C6.39 15.55 6 15.46 5.67 15.23C5.34 15 5.12 14.66 5.05 14.26C5 13.87 5.07 13.47 5.3 13.14C5.53 12.82 5.87 12.6 6.27 12.53M18.08 10.44C18.47 10.37 18.88 10.46 19.2 10.69C19.53 10.92 19.75 11.27 19.82 11.66C19.89 12.05 19.8 12.46 19.57 12.78C19.34 13.11 19 13.33 18.6 13.4C18.21 13.47 17.81 13.38 17.5 13.15C17.16 12.92 16.93 12.57 16.87 12.18C16.8 11.79 16.89 11.39 17.11 11.06C17.34 10.73 17.69 10.5 18.08 10.44M2.83 19.17L2 20V22H22V16H16.62C15.55 16 14.5 16.17 13.46 16.5L12.08 16.97C10.04 17.65 7.9 18 5.75 18H5.66C4.6 18 3.58 18.42 2.83 19.17Z";
var mdiTruckOffRoadOff = "M2.39 1.73L1.11 3L6.96 8.85L.733 9.95L1.6 14.87L3.57 14.53C3.71 15.31 4.15 16 4.81 16.46C5.46 16.92 6.26 17.1 7.05 16.96C7.83 16.82 8.53 16.38 9 15.73C9.44 15.07 9.62 14.27 9.5 13.5L11.28 13.17L14.37 16.26C14.06 16.33 13.76 16.41 13.46 16.5L12.08 16.97C10.04 17.65 7.9 18 5.75 18H5.66C4.6 18 3.58 18.42 2.83 19.17L2 20V22H20.11L20.84 22.73L21.57 22H22V21.57L22.11 21.46L22 21.35V21.35L2.39 1.73M7.39 12.78C7.71 13 7.93 13.35 8 13.74C8.07 14.14 8 14.54 7.75 14.86C7.53 15.19 7.18 15.41 6.79 15.5C6.39 15.55 6 15.46 5.67 15.23C5.34 15 5.12 14.66 5.05 14.26C5 13.87 5.07 13.47 5.3 13.14C5.53 12.82 5.87 12.6 6.27 12.53C6.66 12.46 7.06 12.55 7.39 12.78M22 18.5L19.5 16H22V18.5M18.4 14.92C18.56 14.92 18.71 14.9 18.86 14.88C19.65 14.74 20.34 14.29 20.8 13.64C21.26 13 21.44 12.18 21.3 11.4L23.27 11.05L22.75 8.1C22.55 7 21.5 6.28 20.43 6.5L18.46 6.82L14.81 3.4L9.39 4.36L9.73 6.24L18.4 14.92M11.13 5.58L14.58 4.97L16.94 7.09L11.57 8.04L11.13 5.58M18.08 10.44C18.47 10.37 18.88 10.46 19.2 10.69C19.53 10.92 19.75 11.27 19.82 11.66C19.89 12.05 19.8 12.46 19.57 12.78C19.34 13.11 19 13.33 18.6 13.4C18.21 13.47 17.81 13.38 17.5 13.15C17.16 12.92 16.93 12.57 16.87 12.18C16.8 11.79 16.89 11.39 17.11 11.06C17.34 10.73 17.69 10.5 18.08 10.44Z";
var mdiTruckOutline = "M18 18.5C18.83 18.5 19.5 17.83 19.5 17C19.5 16.17 18.83 15.5 18 15.5C17.17 15.5 16.5 16.17 16.5 17C16.5 17.83 17.17 18.5 18 18.5M19.5 9.5H17V12H21.46L19.5 9.5M6 18.5C6.83 18.5 7.5 17.83 7.5 17C7.5 16.17 6.83 15.5 6 15.5C5.17 15.5 4.5 16.17 4.5 17C4.5 17.83 5.17 18.5 6 18.5M20 8L23 12V17H21C21 18.66 19.66 20 18 20C16.34 20 15 18.66 15 17H9C9 18.66 7.66 20 6 20C4.34 20 3 18.66 3 17H1V6C1 4.89 1.89 4 3 4H17V8H20M3 6V15H3.76C4.31 14.39 5.11 14 6 14C6.89 14 7.69 14.39 8.24 15H15V6H3Z";
var mdiTruckPlus = "M18 18.5C18.83 18.5 19.5 17.83 19.5 17S18.83 15.5 18 15.5 16.5 16.17 16.5 17 17.17 18.5 18 18.5M19.5 9.5H17V12H21.46L19.5 9.5M6 18.5C6.83 18.5 7.5 17.83 7.5 17S6.83 15.5 6 15.5 4.5 16.17 4.5 17 5.17 18.5 6 18.5M20 8L23 12V17H21C21 18.66 19.66 20 18 20S15 18.66 15 17H9C9 18.66 7.66 20 6 20S3 18.66 3 17H1V6C1 4.89 1.89 4 3 4H17V8H20M8 6V9H5V11H8V14H10V11H13V9H10V6H8Z";
var mdiTruckPlusOutline = "M20 8H17V4H3C1.9 4 1 4.9 1 6V17H3C3 18.7 4.3 20 6 20S9 18.7 9 17H15C15 18.7 16.3 20 18 20S21 18.7 21 17H23V12L20 8M6 18.5C5.2 18.5 4.5 17.8 4.5 17S5.2 15.5 6 15.5 7.5 16.2 7.5 17 6.8 18.5 6 18.5M15 15H8.2C7.7 14.4 6.9 14 6 14S4.3 14.4 3.8 15H3V6H15V15M18 18.5C17.2 18.5 16.5 17.8 16.5 17S17.2 15.5 18 15.5 19.5 16.2 19.5 17 18.8 18.5 18 18.5M17 12V9.5H19.5L21.5 12H17M8 11H6V9H8V7H10V9H12V11H10V13H8V11Z";
var mdiTruckRemove = "M20 8H17V4H3C1.89 4 1 4.89 1 6V17H3C3 18.66 4.34 20 6 20S9 18.66 9 17H15C15 18.66 16.34 20 18 20S21 18.66 21 17H23V12L20 8M6 18.5C5.17 18.5 4.5 17.83 4.5 17S5.17 15.5 6 15.5 7.5 16.17 7.5 17 6.83 18.5 6 18.5M12.54 12.12L11.12 13.54L9 11.41L6.88 13.54L5.47 12.12L7.59 10L5.46 7.88L6.88 6.47L9 8.59L11.12 6.47L12.54 7.88L10.41 10L12.54 12.12M18 18.5C17.17 18.5 16.5 17.83 16.5 17S17.17 15.5 18 15.5 19.5 16.17 19.5 17 18.83 18.5 18 18.5M17 12V9.5H19.5L21.46 12H17Z";
var mdiTruckRemoveOutline = "M20 8H17V4H3C1.89 4 1 4.89 1 6V17H3C3 18.66 4.34 20 6 20S9 18.66 9 17H15C15 18.66 16.34 20 18 20S21 18.66 21 17H23V12L20 8M6 18.5C5.17 18.5 4.5 17.83 4.5 17S5.17 15.5 6 15.5 7.5 16.17 7.5 17 6.83 18.5 6 18.5M15 15H8.24C7.69 14.39 6.89 14 6 14S4.31 14.39 3.76 15H3V6H15V15M18 18.5C17.17 18.5 16.5 17.83 16.5 17S17.17 15.5 18 15.5 19.5 16.17 19.5 17 18.83 18.5 18 18.5M17 12V9.5H19.5L21.46 12H17M5.82 11.77L7.59 10L5.82 8.23L7.23 6.82L9 8.59L10.77 6.82L12.18 8.23L10.41 10L12.18 11.77L10.77 13.18L9 11.41L7.23 13.18L5.82 11.77Z";
var mdiTruckSnowflake = "M17 4H3C1.9 4 1 4.9 1 6V17H3C3 18.7 4.3 20 6 20S9 18.7 9 17H15C15 18.7 16.3 20 18 20S21 18.7 21 17H23V12L20 8H17V4M10.2 5.3H10.5C11 5.4 11.3 5.9 11.2 6.4L10.7 8.4L12.7 7.9C13.2 7.8 13.7 8.1 13.8 8.6C13.9 9.1 13.6 9.6 13.2 9.7L11.2 10.2L12.6 11.6C13 11.9 13 12.5 12.6 12.9C12.3 13.3 11.7 13.3 11.3 12.9L9.8 11.5L9.3 13.5C9.2 14 8.7 14.3 8.2 14.1C7.7 14 7.4 13.5 7.6 13L8.1 11L6.1 11.5C5.6 11.6 5.1 11.3 5 10.9C4.9 10.4 5.2 9.9 5.6 9.8L7.6 9.3L6.2 7.7C5.9 7.4 5.9 6.8 6.2 6.4C6.5 6.1 7.1 6.1 7.5 6.4L8.9 7.8L9.4 5.8C9.5 5.6 9.8 5.3 10.2 5.3M17 9.5H19.5L21.5 12H17V9.5M6 15.5C6.8 15.5 7.5 16.2 7.5 17S6.8 18.5 6 18.5 4.5 17.8 4.5 17 5.2 15.5 6 15.5M18 15.5C18.8 15.5 19.5 16.2 19.5 17S18.8 18.5 18 18.5 16.5 17.8 16.5 17 17.2 15.5 18 15.5Z";
var mdiTruckTrailer = "M22,15V17H10A3,3 0 0,1 7,20A3,3 0 0,1 4,17H2V6A2,2 0 0,1 4,4H17A2,2 0 0,1 19,6V15H22M7,16A1,1 0 0,0 6,17A1,1 0 0,0 7,18A1,1 0 0,0 8,17A1,1 0 0,0 7,16Z";
var mdiTrumpet = "M22 6C21 11 15 11 15 11H4C3 11 2 10 2 10H1V14H2C2 14 3 13 4 13H4.3C4.1 13.3 4 13.6 4 14V16C4 17.1 4.9 18 6 18H7V19H9V18H10V19H12V18H13V19H15V18H16C17.1 18 18 17.1 18 16V14C18 13.9 18 13.7 17.9 13.6C19.6 14.2 21.4 15.4 22 18H23V6H22M6 16.5C5.7 16.5 5.5 16.3 5.5 16V14C5.5 13.7 5.7 13.5 6 13.5H7V16.5H6M9 16.5V13.5H10V16.5H9M12 16.5V13.5H13V16.5H12M16.5 16C16.5 16.3 16.3 16.5 16 16.5H15V13.5H16C16.3 13.5 16.5 13.7 16.5 14V16M9 10H7V9H9V10M12 10H10V9H12V10M15 10H13V9H15V10Z";
var mdiTshirtCrew = "M16,21H8A1,1 0 0,1 7,20V12.07L5.7,13.07C5.31,13.46 4.68,13.46 4.29,13.07L1.46,10.29C1.07,9.9 1.07,9.27 1.46,8.88L7.34,3H9C9,4.1 10.34,5 12,5C13.66,5 15,4.1 15,3H16.66L22.54,8.88C22.93,9.27 22.93,9.9 22.54,10.29L19.71,13.12C19.32,13.5 18.69,13.5 18.3,13.12L17,12.12V20A1,1 0 0,1 16,21";
var mdiTshirtCrewOutline = "M16,21H8A1,1 0 0,1 7,20V12.07L5.7,13.12C5.31,13.5 4.68,13.5 4.29,13.12L1.46,10.29C1.07,9.9 1.07,9.27 1.46,8.88L7.34,3H9C9,4.1 10.34,5 12,5C13.66,5 15,4.1 15,3H16.66L22.54,8.88C22.93,9.27 22.93,9.9 22.54,10.29L19.71,13.12C19.32,13.5 18.69,13.5 18.3,13.12L17,12.07V20A1,1 0 0,1 16,21M20.42,9.58L16.11,5.28C15.8,5.63 15.43,5.94 15,6.2C14.16,6.7 13.13,7 12,7C10.3,7 8.79,6.32 7.89,5.28L3.58,9.58L5,11L8,9H9V19H15V9H16L19,11L20.42,9.58Z";
var mdiTshirtV = "M16,21H8A1,1 0 0,1 7,20V12.07L5.7,13.07C5.31,13.46 4.68,13.46 4.29,13.07L1.46,10.29C1.07,9.9 1.07,9.27 1.46,8.88L7.34,3H9C9.29,4.8 10.4,6.37 12,7.25C13.6,6.37 14.71,4.8 15,3H16.66L22.54,8.88C22.93,9.27 22.93,9.9 22.54,10.29L19.71,13.12C19.32,13.5 18.69,13.5 18.3,13.12L17,12.12V20A1,1 0 0,1 16,21";
var mdiTshirtVOutline = "M16,21H8A1,1 0 0,1 7,20V12.07L5.7,13.12C5.31,13.5 4.68,13.5 4.29,13.12L1.46,10.29C1.07,9.9 1.07,9.27 1.46,8.88L7.34,3H9C9,4.1 10,6 12,7.25C14,6 15,4.1 15,3H16.66L22.54,8.88C22.93,9.27 22.93,9.9 22.54,10.29L19.71,13.12C19.32,13.5 18.69,13.5 18.3,13.12L17,12.07V20A1,1 0 0,1 16,21M20.42,9.58L16.11,5.28C15,7 14,8.25 12,9.25C10,8.25 9,7 7.89,5.28L3.58,9.58L5,11L8,9H9V19H15V9H16L19,11L20.42,9.58Z";
var mdiTsunami = "M18.67 17.63C14.87 20.43 12.55 18.03 12 17.63C11.34 18.12 9.08 20.39 5.33 17.63C3.43 19.03 2.65 19 2 19V21C3.16 21 4.3 20.68 5.33 20.07C7.39 21.29 9.94 21.29 12 20.07C14.06 21.29 16.61 21.29 18.67 20.07C19.7 20.68 20.84 21 22 21V19C21.34 19 20.5 19 18.67 17.63M19.33 12H22V10H19.33C17.5 10 16 8.5 16 6.67C16 5.65 16.38 4.93 17.09 3.33C15.72 3.12 15.09 3 14 3C7.36 3 2.15 8.03 2 14.5L2 16.5C3.16 16.5 4.3 16.18 5.33 15.57C7.39 16.79 9.94 16.79 12 15.57C14.06 16.79 16.61 16.79 18.67 15.57C19.7 16.18 20.84 16.5 22 16.5V14.5C21.34 14.5 20.5 14.5 18.67 13.13C14.87 15.93 12.55 13.53 12 13.13C11.1 13.8 11.46 13.54 11.09 13.76C10.39 12.82 10 11.7 10 10.5C10 7.92 11.77 5.76 14.21 5.17C14.08 5.68 14 6.19 14 6.67C14 9.61 16.39 12 19.33 12Z";
var mdiTumbleDryer = "M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M7,4A1,1 0 0,0 6,5A1,1 0 0,0 7,6A1,1 0 0,0 8,5A1,1 0 0,0 7,4M10,4A1,1 0 0,0 9,5A1,1 0 0,0 10,6A1,1 0 0,0 11,5A1,1 0 0,0 10,4M12,8A6,6 0 0,0 6,14A6,6 0 0,0 12,20A6,6 0 0,0 18,14A6,6 0 0,0 12,8M8.11,10.5H10C9.76,11.88 10,12.67 10.58,13.29C11.68,14.36 12.16,15.71 11.89,17.5H10C10.24,16.12 10,15.33 9.42,14.71C8.32,13.64 7.85,12.29 8.11,10.5M12.11,10.5H14C13.76,11.88 14,12.67 14.58,13.29C15.68,14.36 16.16,15.71 15.89,17.5H14C14.24,16.12 14,15.33 13.42,14.71C12.32,13.64 11.85,12.29 12.11,10.5Z";
var mdiTumbleDryerAlert = "M4 2H16C17.11 2 18 2.9 18 4V20C18 21.11 17.11 22 16 22H4C2.9 22 2 21.11 2 20V4C2 2.9 2.9 2 4 2M5 4C4.45 4 4 4.45 4 5S4.45 6 5 6 6 5.55 6 5 5.55 4 5 4M8 4C7.45 4 7 4.45 7 5S7.45 6 8 6 9 5.55 9 5 8.55 4 8 4M10 8C6.69 8 4 10.69 4 14S6.69 20 10 20 16 17.31 16 14 13.31 8 10 8M6.11 10.5H8C7.76 11.88 8 12.67 8.58 13.29C9.68 14.36 10.16 15.71 9.89 17.5H8C8.24 16.12 8 15.33 7.42 14.71C6.32 13.64 5.85 12.29 6.11 10.5M10.11 10.5H12C11.76 11.88 12 12.67 12.58 13.29C13.68 14.36 14.16 15.71 13.89 17.5H12C12.24 16.12 12 15.33 11.42 14.71C10.32 13.64 9.85 12.29 10.11 10.5M20 15H22V17H20V15M20 7H22V13H20V7Z";
var mdiTumbleDryerOff = "M22.11 21.46L2.39 1.73L1.11 3L4 5.89V20C4 21.11 4.89 22 6 22H18C18.58 22 19.1 21.75 19.46 21.35L20.84 22.73L22.11 21.46M12 20C8.69 20 6 17.31 6 14C6 12.32 6.7 10.8 7.82 9.71L8.61 10.5H8.11C7.85 12.29 8.32 13.64 9.42 14.71C10 15.33 10.24 16.12 10 17.5H11.89C12.16 15.71 11.68 14.36 10.58 13.29C10.22 12.91 10 12.44 9.95 11.84L14.03 15.92C14.11 16.35 14.11 16.86 14 17.5H15.61L16.29 18.18C15.2 19.3 13.69 20 12 20M11.25 8.05C11.5 8 11.75 8 12 8C15.31 8 18 10.69 18 14C18 14.25 18 14.5 17.95 14.75L20 16.8V4C20 2.9 19.11 2 18 2H6C5.76 2 5.54 2.05 5.33 2.13L11.25 8.05M10 4C10.55 4 11 4.45 11 5S10.55 6 10 6 9 5.55 9 5 9.45 4 10 4Z";
var mdiTune = "M3,17V19H9V17H3M3,5V7H13V5H3M13,21V19H21V17H13V15H11V21H13M7,9V11H3V13H7V15H9V9H7M21,13V11H11V13H21M15,9H17V7H21V5H17V3H15V9Z";
var mdiTuneVariant = "M8 13C6.14 13 4.59 14.28 4.14 16H2V18H4.14C4.59 19.72 6.14 21 8 21S11.41 19.72 11.86 18H22V16H11.86C11.41 14.28 9.86 13 8 13M8 19C6.9 19 6 18.1 6 17C6 15.9 6.9 15 8 15S10 15.9 10 17C10 18.1 9.1 19 8 19M19.86 6C19.41 4.28 17.86 3 16 3S12.59 4.28 12.14 6H2V8H12.14C12.59 9.72 14.14 11 16 11S19.41 9.72 19.86 8H22V6H19.86M16 9C14.9 9 14 8.1 14 7C14 5.9 14.9 5 16 5S18 5.9 18 7C18 8.1 17.1 9 16 9Z";
var mdiTuneVertical = "M7 3H5V9H7V3M19 3H17V13H19V3M3 13H5V21H7V13H9V11H3V13M15 7H13V3H11V7H9V9H15V7M11 21H13V11H11V21M15 15V17H17V21H19V17H21V15H15Z";
var mdiTuneVerticalVariant = "M8 12.14V2H6V12.14C4.28 12.59 3 14.14 3 16S4.28 19.41 6 19.86V22H8V19.86C9.72 19.41 11 17.86 11 16S9.72 12.59 8 12.14M7 14C8.1 14 9 14.9 9 16S8.1 18 7 18C5.9 18 5 17.1 5 16S5.9 14 7 14M18 2H16V4.14C14.28 4.59 13 6.14 13 8S14.28 11.41 16 11.86V22H18V11.86C19.72 11.41 21 9.86 21 8S19.72 4.59 18 4.14V2M17 6C18.1 6 19 6.9 19 8S18.1 10 17 10C15.9 10 15 9.1 15 8S15.9 6 17 6Z";
var mdiTunnel = "M12 2C6.5 2 2 6.5 2 12V22H22V12C22 6.5 17.5 2 12 2M7.1 5.69C8.21 4.83 9.54 4.25 11 4.07V6.09C10.09 6.24 9.25 6.6 8.53 7.11L7.1 5.69M15.47 7.11C14.75 6.6 13.91 6.24 13 6.09V4.07C14.46 4.25 15.79 4.83 16.9 5.69L15.47 7.11M5.69 7.1L7.11 8.53C6.6 9.25 6.24 10.09 6.09 11H4.07C4.25 9.54 4.83 8.21 5.69 7.1M6 13V15.5H4V13H6M4 20V17.5H6V20H4M16.89 8.53L18.31 7.1C19.17 8.21 19.75 9.54 19.93 11H17.91C17.76 10.09 17.4 9.25 16.89 8.53M18 13H20V15.5H18V13M18 20V17.5H20V20H18Z";
var mdiTunnelOutline = "M12 2C6.5 2 2 6.5 2 12V22H22V12C22 6.5 17.5 2 12 2M15.47 7.11C14.75 6.6 13.91 6.24 13 6.09V4.07C14.46 4.25 15.79 4.83 16.9 5.69L15.47 7.11M8.53 7.11L7.1 5.69C8.21 4.83 9.54 4.25 11 4.07V6.09C10.09 6.24 9.25 6.6 8.53 7.11M5.69 7.1L7.11 8.53C6.6 9.25 6.24 10.09 6.09 11H4.07C4.25 9.54 4.83 8.21 5.69 7.1M6 13V15.5H4V13H6M4 20V17.5H6V20H4M16 20H8V12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12V20M16.89 8.53L18.31 7.1C19.17 8.21 19.75 9.54 19.93 11H17.91C17.76 10.09 17.4 9.25 16.89 8.53M18 13H20V15.5H18V13M18 20V17.5H20V20H18Z";
var mdiTurbine = "M2 12C2 17.5 6.5 22 12 22S22 17.5 22 12 17.5 2 12 2 2 6.5 2 12M20 12C20 16.4 16.4 20 12 20S4 16.4 4 12 7.6 4 12 4 20 7.6 20 12M12.5 7L12.2 8.3L11.3 5C10.3 5.3 9.7 6.3 9.9 7.4L10.2 8.7L7.9 6.3C7.2 7 7.2 8.3 7.9 9L8.9 10L5.6 9.1C5.3 10.1 5.9 11.2 7 11.5L8.3 11.8L5 12.7C5.3 13.7 6.3 14.3 7.4 14.1L8.7 13.8L6.3 16.2C7.1 16.9 8.3 16.9 9 16.2L9.9 15.3L9 18.6C10 18.9 11.1 18.3 11.4 17.2L11.7 15.9L12.6 19.2C13.6 18.9 14.2 17.9 14 16.8L13.7 15.5L16.1 17.9C16.8 17.1 16.8 15.9 16.1 15.2L15.1 14L18.4 14.9C18.7 13.9 18.1 12.8 17 12.5L15.7 12.2L19 11.3C18.7 10.3 17.7 9.7 16.6 9.9L15.3 10.2L17.7 7.8C16.9 7.1 15.7 7.1 15 7.8L14.1 8.8L15 5.5C13.9 5.3 12.8 5.9 12.5 7M13.5 12C13.5 12.8 12.8 13.5 12 13.5S10.5 12.8 10.5 12 11.2 10.5 12 10.5 13.5 11.2 13.5 12Z";
var mdiTurkey = "M10.5 19.44C9.75 19.8 8.9 20 8 20C4.69 20 2 17.31 2 14V9C2 5.69 4.69 3 8 3L10.5 7.58C8.1 8.81 6.5 11 6.5 13.5C6.5 16 8.11 18.2 10.5 19.44M16 18.94V20H17C17.55 20 18 20.45 18 21S17.55 22 17 22H14C13.45 22 13 21.55 13 21S13.45 20 14 20V18.94C10.61 18.56 8 16.27 8 13.5C8 10.46 11.13 8 15 8C15.19 8 15.37 8 15.56 8C14.84 6.63 14 5.23 14 4C14 2.9 14.9 2 16 2C18.21 2 20 3.79 20 6H18C18 6 22 9 22 13.5C22 16.27 19.39 18.56 16 18.94M16 4C16 4.55 16.45 5 17 5S18 4.55 18 4 17.55 3 17 3 16 3.45 16 4M17 12C17 10.9 16.11 10 15 10C12.79 10 11 11.79 11 14H15C16.11 14 17 13.11 17 12Z";
var mdiTurnstile = "M22,22H16V11L10,5V2H22V22M9.17,6.17C8.42,6.92 8,7.94 8,9H2V11H8.55C8.9,11.6 9.4,12.1 10,12.45V19H12V13C13.06,13 14.08,12.58 14.83,11.83L9.17,6.17Z";
var mdiTurnstileOutline = "M13.41,10.41C13.04,10.79 12.53,11 12,11A2,2 0 0,1 10,9C10,8.47 10.21,7.96 10.59,7.59L9.17,6.17C8.42,6.92 8,7.94 8,9H2V11H8.55C8.9,11.6 9.4,12.1 10,12.45V19H12V13C13.06,13 14.08,12.58 14.83,11.83L13.41,10.41M10,2V5L16,11V22H22V2H10M20,20H18V10.17L12,4.17V4H20V20Z";
var mdiTurtle = "M8.47,5.95C8.95,5.67 9.47,5.44 10,5.28V4C10,2.9 10.87,2 11.97,1.97C13.13,2 14,2.9 14,4V5.28C14.53,5.45 15.05,5.67 15.53,5.95L13.93,8.07H10.07L8.47,5.95M19,12C19,12.5 18.95,12.95 18.86,13.4L16.33,12.62L15.14,8.96L16.74,6.85C17.17,7.25 17.55,7.7 17.88,8.2C18.67,8.13 19.43,8.25 20.11,8.59C21.14,9.12 21.84,10.13 22,11.28L19,11.64C19,11.76 19,11.88 19,12M5,12C5,11.88 5,11.76 5,11.65L2,11.28C2.16,10.13 2.86,9.12 3.89,8.59C4.57,8.25 5.34,8.13 6.08,8.26C6.41,7.75 6.79,7.28 7.24,6.87L8.86,8.95L7.67,12.62L5.14,13.4C5.05,12.95 5,12.5 5,12M10.24,9.57H13.76L14.85,12.93L12,15L9.15,12.93L10.24,9.57M8.13,14.05L11.25,16.31V18.96C10.68,18.9 10.13,18.77 9.62,18.58L8.39,21.34C7.33,20.87 6.57,19.9 6.37,18.76C6.23,18 6.35,17.24 6.69,16.56C6.24,16.04 5.87,15.46 5.59,14.82L8.13,14.05M15.87,14.05L18.41,14.82C18.13,15.46 17.76,16.04 17.31,16.56C17.65,17.24 17.77,18 17.64,18.76C17.43,19.9 16.67,20.87 15.61,21.34L14.39,18.58C13.86,18.77 13.33,18.94 12.75,19V16.31L15.87,14.05Z";
var mdiTwitch = "M11.64 5.93H13.07V10.21H11.64M15.57 5.93H17V10.21H15.57M7 2L3.43 5.57V18.43H7.71V22L11.29 18.43H14.14L20.57 12V2M19.14 11.29L16.29 14.14H13.43L10.93 16.64V14.14H7.71V3.43H19.14Z";
var mdiTwitter = "M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z";
var mdiTwoFactorAuthentication = "M2,7V9H6V11H4A2,2 0 0,0 2,13V17H8V15H4V13H6A2,2 0 0,0 8,11V9C8,7.89 7.1,7 6,7H2M9,7V17H11V13H14V11H11V9H15V7H9M18,7A2,2 0 0,0 16,9V17H18V14H20V17H22V9A2,2 0 0,0 20,7H18M18,9H20V12H18V9Z";
var mdiTypewriter = "M20 13H16C16 14.1 15.1 15 14 15H10C8.9 15 8 14.1 8 13H4L2 18V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V18M6 20C5.11 20 4.66 18.92 5.29 18.29C5.92 17.66 7 18.11 7 19C7 19.55 6.55 20 6 20M10 20C9.11 20 8.66 18.92 9.29 18.29C9.92 17.66 11 18.11 11 19C11 19.55 10.55 20 10 20M14 20C13.11 20 12.66 18.92 13.29 18.29C13.92 17.66 15 18.11 15 19C15 19.55 14.55 20 14 20M18 20C17.11 20 16.66 18.92 17.29 18.29C17.92 17.66 19 18.11 19 19C19 19.55 18.55 20 18 20M18 10V3H6V10H3V12H21V10M8 5H16V6H8M8 7H14V8H8";
var mdiUbisoft = "M11.41,2C5.21,2 2.53,7.53 2.53,7.53L3.32,8.09C3.32,8.09 2.33,10 2.35,12.4C2.35,17.34 6.29,22 12.07,22C17.33,22 21.67,17.71 21.67,12.41C21.67,5.5 16.31,2 11.41,2M11.47,3.69C16.31,3.69 20.07,7.6 20.07,12.14C20.07,16.95 16.45,20.3 12.23,20.3C9.13,20.3 6.33,17.94 6.33,14.7C6.33,12.82 7.32,11.5 8.44,10.82L8.6,11C8.3,11.24 7.43,12.64 7.43,14C7.43,16.56 9.43,18.33 11.95,18.33C15.16,18.33 17.3,15.59 17.3,12.41C17.3,8.71 14.03,5.57 10.1,5.57C7.93,5.57 6.09,6.5 5.03,7.33L4.86,7.18C6.25,5.04 8.65,3.69 11.47,3.69M10,7.23C12.53,7.23 14.97,8.89 15.59,11.25L15.36,11.33C14.27,9.88 12.47,8.68 10.35,8.68C6.44,8.68 4.39,12.23 4.69,15.19L4.46,15.28C4.46,15.28 4.03,14.33 4.03,13.2C4.03,9.93 6.71,7.23 10,7.23M11.68,11.33C12.86,11.33 13.81,12.3 13.81,13.44C13.81,14.38 13.21,14.94 13.21,14.94L13.92,15.45C13.92,15.45 13.21,16.57 11.76,16.57C10.37,16.57 9.13,15.44 9.13,13.93C9.13,12.38 10.47,11.33 11.68,11.33Z";
var mdiUbuntu = "M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M14.34,7.74C14.92,8.07 15.65,7.87 16,7.3C16.31,6.73 16.12,6 15.54,5.66C14.97,5.33 14.23,5.5 13.9,6.1C13.57,6.67 13.77,7.41 14.34,7.74M11.88,15.5C11.35,15.5 10.85,15.39 10.41,15.18L9.57,16.68C10.27,17 11.05,17.22 11.88,17.22C12.37,17.22 12.83,17.15 13.28,17.03C13.36,16.54 13.64,16.1 14.1,15.84C14.56,15.57 15.08,15.55 15.54,15.72C16.43,14.85 17,13.66 17.09,12.33L15.38,12.31C15.22,14.1 13.72,15.5 11.88,15.5M11.88,8.5C13.72,8.5 15.22,9.89 15.38,11.69L17.09,11.66C17,10.34 16.43,9.15 15.54,8.28C15.08,8.45 14.55,8.42 14.1,8.16C13.64,7.9 13.36,7.45 13.28,6.97C12.83,6.85 12.37,6.78 11.88,6.78C11.05,6.78 10.27,6.97 9.57,7.32L10.41,8.82C10.85,8.61 11.35,8.5 11.88,8.5M8.37,12C8.37,10.81 8.96,9.76 9.86,9.13L9,7.65C7.94,8.36 7.15,9.43 6.83,10.69C7.21,11 7.45,11.47 7.45,12C7.45,12.53 7.21,13 6.83,13.31C7.15,14.56 7.94,15.64 9,16.34L9.86,14.87C8.96,14.24 8.37,13.19 8.37,12M14.34,16.26C13.77,16.59 13.57,17.32 13.9,17.9C14.23,18.47 14.97,18.67 15.54,18.34C16.12,18 16.31,17.27 16,16.7C15.65,16.12 14.92,15.93 14.34,16.26M5.76,10.8C5.1,10.8 4.56,11.34 4.56,12C4.56,12.66 5.1,13.2 5.76,13.2C6.43,13.2 6.96,12.66 6.96,12C6.96,11.34 6.43,10.8 5.76,10.8Z";
var mdiUfo = "M15.94 10.28C15.66 7.87 14 6 12 6S8.34 7.87 8.06 10.28C4.5 10.82 2 12.06 2 13.5C2 15.43 6.5 17 12 17S22 15.43 22 13.5C22 12.06 19.5 10.82 15.94 10.28Z";
var mdiUfoOutline = "M17 10.54C16.78 7.44 14.63 5 12 5S7.22 7.44 7 10.54C4 11.23 2 12.5 2 14C2 16.21 6.5 18 12 18S22 16.21 22 14C22 12.5 20 11.23 17 10.54M14.93 11.84C13.03 12.05 10.97 12.05 9.07 11.84C9.03 11.56 9 11.28 9 11C9 8.8 10.35 7 12 7S15 8.8 15 11C15 11.28 15 11.56 14.93 11.84Z";
var mdiUltraHighDefinition = "M9,7H11V11H13V7H15V17H13V13H11V17H9V7M17,7H20A3,3 0 0,1 23,10V14A3,3 0 0,1 20,17H17V7M20,15A1,1 0 0,0 21,14V10A1,1 0 0,0 20,9H19V15H20M7,14A3,3 0 0,1 4,17A3,3 0 0,1 1,14V7H3V14A1,1 0 0,0 4,15A1,1 0 0,0 5,14V7H7V14Z";
var mdiUmbraco = "M8.6,8.6L7.17,8.38C6.5,11.67 6.46,14.24 7.61,15.5C8.6,16.61 11.89,16.61 11.89,16.61C11.89,16.61 15.29,16.61 16.28,15.5C17.43,14.24 17.38,11.67 16.72,8.38L15.29,8.6C15.29,8.6 16.54,13.88 14.69,14.69C13.81,15.07 11.89,15.07 11.89,15.07C11.89,15.07 10.08,15.07 9.2,14.69C7.35,13.88 8.6,8.6 8.6,8.6M12,3A9,9 0 0,1 21,12A9,9 0 0,1 12,21A9,9 0 0,1 3,12A9,9 0 0,1 12,3Z";
var mdiUmbrella = "M12,2A9,9 0 0,1 21,11H13V19A3,3 0 0,1 10,22A3,3 0 0,1 7,19V18H9V19A1,1 0 0,0 10,20A1,1 0 0,0 11,19V11H3A9,9 0 0,1 12,2Z";
var mdiUmbrellaBeach = "M13.13 14.56L14.56 13.13L21 19.57L19.57 21L13.13 14.56M17.42 8.83L20.28 5.97C16.33 2 9.93 2 6 5.95C9.91 4.65 14.29 5.7 17.42 8.83M5.95 6C2 9.93 2 16.33 5.97 20.28L8.83 17.42C5.7 14.29 4.65 9.91 5.95 6M5.97 5.96L5.96 5.97C5.58 9 7.13 12.85 10.26 16L16 10.26C12.86 7.13 9 5.58 5.97 5.96Z";
var mdiUmbrellaBeachOutline = "M21 19.57L19.57 21L13.13 14.56L14.56 13.13L21 19.57M13.12 3C10.54 3 7.96 4 6 5.95L5.97 5.96C2 9.91 2 16.32 5.97 20.27L20.27 5.96C18.3 4 15.71 3 13.12 3M6.14 17.27C5.4 16.03 5 14.61 5 13.12C5 12.19 5.16 11.3 5.46 10.45C5.65 12.36 6.35 14.24 7.53 15.89L6.14 17.27M9 14.43C7.63 12.38 7.12 9.93 7.6 7.6C8.18 7.5 8.76 7.42 9.35 7.42C11.15 7.42 12.9 7.97 14.43 9L9 14.43M10.45 5.46C11.3 5.16 12.19 5 13.12 5C14.61 5 16.03 5.4 17.27 6.14L15.88 7.53C14.23 6.35 12.36 5.65 10.45 5.46Z";
var mdiUmbrellaClosed = "M12 2C11.6 2 11.3 2.2 11.1 2.6L6.5 15H11V19C11 19.6 10.6 20 10 20C9.4 20 9 19.6 9 19V18H7V19C7 20.7 8.3 22 10 22S13 20.7 13 19V15H17.5L12.9 2.6C12.7 2.2 12.4 2 12 2Z";
var mdiUmbrellaClosedOutline = "M12 2C12.4 2 12.8 2.2 12.9 2.6L17.5 15H13V19C13 20.7 11.7 22 10 22S7 20.7 7 19V18H9V19C9 19.6 9.4 20 10 20C10.6 20 11 19.6 11 19V15H6.5L11.1 2.6C11.2 2.2 11.6 2 12 2M12 5.9L9.4 13H14.7L12 5.9Z";
var mdiUmbrellaClosedVariant = "M15 7L13 6V3.5C13 3.2 13.2 3 13.5 3S14 3.2 14 3.5V4H16V3.5C16 2.1 14.9 1 13.5 1S11 2.1 11 3.5V6L9 7L6 6L11.1 21.3C11.4 22.2 12.7 22.2 13 21.3C14.6 16.2 18 6 18 6L15 7M11 15L9 8.9L9.7 9.1L11 8.1V15M13 8.1L14.3 9.1L15 8.9L13 15V8.1Z";
var mdiUmbrellaOutline = "M12,4C8.9,4 6.18,6.03 5.3,9H18.7C17.82,6.04 15.09,4 12,4M12,2A9,9 0 0,1 21,11H13V19A3,3 0 0,1 10,22A3,3 0 0,1 7,19V18H9V19A1,1 0 0,0 10,20A1,1 0 0,0 11,19V11H3A9,9 0 0,1 12,2Z";
var mdiUnderwearOutline = "M3 4C2.45 4 2 4.45 2 5V10C2 15.5 6.5 20 12 20C17.5 20 22 15.5 22 10V5C22 4.45 21.55 4 21 4H3M20 6V8H4V6H20M4 10H20C20 10.34 20 10.67 19.94 11C16.12 11.03 13.03 14.12 13 17.94C12.67 18 12.34 18 12 18C11.66 18 11.33 18 11 17.94C10.97 14.12 7.88 11.03 4.06 11C4 10.67 4 10.34 4 10M15.04 17.4C15.31 15.12 17.12 13.31 19.41 13.04C18.59 15 17 16.59 15.03 17.41M4.6 13.04C6.88 13.31 8.7 15.12 8.97 17.41C7 16.59 5.41 15 4.6 13.03Z";
var mdiUndo = "M12.5,8C9.85,8 7.45,9 5.6,10.6L2,7V16H11L7.38,12.38C8.77,11.22 10.54,10.5 12.5,10.5C16.04,10.5 19.05,12.81 20.1,16L22.47,15.22C21.08,11.03 17.15,8 12.5,8Z";
var mdiUndoVariant = "M13.5,7A6.5,6.5 0 0,1 20,13.5A6.5,6.5 0 0,1 13.5,20H10V18H13.5C16,18 18,16 18,13.5C18,11 16,9 13.5,9H7.83L10.91,12.09L9.5,13.5L4,8L9.5,2.5L10.92,3.91L7.83,7H13.5M6,18H8V20H6V18Z";
var mdiUnfoldLessHorizontal = "M16.59,5.41L15.17,4L12,7.17L8.83,4L7.41,5.41L12,10M7.41,18.59L8.83,20L12,16.83L15.17,20L16.58,18.59L12,14L7.41,18.59Z";
var mdiUnfoldLessVertical = "M5.41,7.41L10,12L5.41,16.59L4,15.17L7.17,12L4,8.83L5.41,7.41M18.59,16.59L14,12L18.59,7.42L20,8.83L16.83,12L20,15.17L18.59,16.59Z";
var mdiUnfoldMoreHorizontal = "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z";
var mdiUnfoldMoreVertical = "M18.17,12L15,8.83L16.41,7.41L21,12L16.41,16.58L15,15.17L18.17,12M5.83,12L9,15.17L7.59,16.59L3,12L7.59,7.42L9,8.83L5.83,12Z";
var mdiUngroup = "M2,2H6V3H13V2H17V6H16V9H18V8H22V12H21V18H22V22H18V21H12V22H8V18H9V16H6V17H2V13H3V6H2V2M18,12V11H16V13H17V17H13V16H11V18H12V19H18V18H19V12H18M13,6V5H6V6H5V13H6V14H9V12H8V8H12V9H14V6H13M12,12H11V14H13V13H14V11H12V12Z";
var mdiUnicode = "M22 6A1.46 1.46 0 0 1 20.54 7.44A1.46 1.46 0 0 1 19.09 6A1.46 1.46 0 0 1 20.54 4.5A1.46 1.46 0 0 1 22 6M21.56 8.86H19.53C19.4 8.85 19.34 8.91 19.34 9V12.59C19.34 13.08 19.34 13.5 19.35 13.86L19.37 14.76C19.38 15 19.39 15.21 19.39 15.39C19.4 15.56 19.4 15.72 19.4 15.86H19.38C19.26 15.6 19.07 15.22 18.82 14.74C18.58 14.27 18.29 13.72 17.97 13.11C17.64 12.5 17.29 11.84 16.92 11.15C16.55 10.47 16.18 9.78 15.81 9.11C15.45 8.43 15.09 7.78 14.75 7.16C14.4 6.54 14.1 6 13.85 5.54C13.82 5.5 13.79 5.44 13.77 5.42C13.74 5.4 13.68 5.39 13.6 5.39H10.62C10.5 5.39 10.47 5.44 10.47 5.54H10.5C10.47 5.56 10.47 5.57 10.47 5.58V13.84C10.47 14.5 10.4 15 10.25 15.45C10.1 15.88 9.9 16.23 9.64 16.5C9.38 16.75 9.07 16.93 8.72 17.05C8.36 17.16 8 17.22 7.56 17.22C6.54 17.22 5.79 16.91 5.3 16.31C4.8 15.7 4.56 14.89 4.56 13.88V5.56C4.56 5.45 4.5 5.39 4.39 5.39H2.17C2.06 5.39 2 5.45 2 5.58V14.07C2 15 2.13 15.78 2.38 16.46C2.63 17.13 3 17.69 3.5 18.14C3.96 18.58 4.53 18.92 5.21 19.14C5.89 19.36 6.64 19.5 7.47 19.5C8.24 19.5 8.97 19.38 9.65 19.17C10.34 18.97 10.93 18.64 11.42 18.2C11.91 17.75 12.3 17.18 12.59 16.5C12.88 15.79 13.03 14.95 13.03 13.96V8.62C13.14 8.86 13.28 9.15 13.44 9.47C13.73 10.05 14.05 10.68 14.42 11.38C14.79 12.08 15.17 12.8 15.58 13.56C16 14.32 16.39 15.06 16.77 15.76C17.16 16.46 17.5 17.11 17.83 17.7C18.15 18.29 18.4 18.76 18.58 19.12C18.63 19.22 18.73 19.27 18.85 19.27H21.54C21.68 19.27 21.75 19.2 21.75 19.08V9.05C21.75 8.92 21.68 8.85 21.56 8.85Z";
var mdiUnicorn = "M22 5L21.11 6.34C21.65 6.7 22 7.31 22 8V11.5L20.5 12L18.96 9.54C18.83 9.33 18.5 9.42 18.5 9.67V13.25C18.5 14.23 18.11 15.11 17.5 15.78V22H15V17C14.92 17 14.84 17 14.75 17C14.54 17 14.33 16.97 14.13 16.94L9.45 16.16L8.57 18.12L9.54 22H6.96L6.04 18.3C5.97 18.03 6 17.74 6.11 17.5L7 15.5C6.12 14.92 5.53 13.94 5.5 12.81C5.46 12.96 5.44 13.18 5.47 13.5C5.5 13.94 5.61 14.59 5.54 15.31C5.5 16.03 5.18 16.77 4.76 17.26C4.32 17.75 3.85 18.09 3.35 18.35L2.65 17.65C2.84 17.18 3.03 16.76 3.07 16.37C3.13 16 3.06 15.7 2.95 15.43L2.42 14.3C2.21 13.79 1.95 13.05 2 12.18C2.03 11.33 2.5 10.22 3.39 9.61C4.29 9 5.26 8.91 6.05 9.08C6.55 9.18 7.06 9.42 7.5 9.76C7.87 9.59 8.3 9.5 8.75 9.5H14.5V9C14.5 6.79 16.29 5 18.5 5L22 2L21 5H22Z";
var mdiUnicornVariant = "M20 12V19L17 20L14 15.33C13.71 14.89 13 15.14 13.08 15.67L14 23L4 18L4.96 12.75C5.56 9.42 8.46 7 11.84 7H13L19 1L17 7H20L18.42 9.37C19.36 9.88 20 10.86 20 12Z";
var mdiUnicycle = "M13 9.09V5H14C14.55 5 15 4.55 15 4S14.55 3 14 3H10C9.45 3 9 3.45 9 4S9.45 5 10 5H11V9.09C8.16 9.57 6 12.03 6 15C6 18.31 8.69 21 12 21S18 18.31 18 15C18 12.03 15.84 9.57 13 9.09M12 19C9.79 19 8 17.21 8 15C8 13.14 9.28 11.59 11 11.14V16H13V11.14C14.72 11.59 16 13.14 16 15C16 17.21 14.21 19 12 19Z";
var mdiUnity = "M10.11,17H7.5L2.59,12L7.5,7H10.11L11.42,4.74L18.21,3L20.08,9.74L18.77,12L20.08,14.26L18.21,21L11.42,19.26L10.11,17M10.25,16.75L15.38,18.13L12.42,13H6.5L10.25,16.75M17.12,17.13L18.5,12L17.12,6.87L14.15,12L17.12,17.13M10.25,7.25L6.5,11H12.42L15.38,5.87L10.25,7.25Z";
var mdiUnreal = "M2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2A10,10 0 0,0 2,12M5.24,18.76C3.43,16.95 2.44,14.55 2.44,12C2.44,9.45 3.43,7.05 5.24,5.24C7.05,3.43 9.45,2.44 12,2.44C14.55,2.44 16.95,3.43 18.76,5.24C20.57,7.05 21.56,9.45 21.56,12C21.56,14.55 20.57,16.95 18.76,18.76C16.95,20.57 14.55,21.56 12,21.56C9.45,21.56 7.05,20.57 5.24,18.76M6.35,9.5C4.34,11.79 4.73,13.68 4.73,13.68C4.73,13.68 5.28,12.38 6.61,11C7.25,10.37 7.72,10.15 8.04,10.15C8.4,10.15 8.57,10.41 8.57,10.65V15.29C8.57,15.75 8.27,15.85 8,15.84C7.77,15.84 7.55,15.76 7.55,15.76C8.92,17.73 12.19,18 12.19,18L13.63,16.5H13.67L15,17.63C17.39,16.21 18.55,13.58 18.55,13.58C17.5,14.7 16.79,14.97 16.39,14.96C16.03,14.96 15.88,14.75 15.88,14.75C15.87,14.65 15.82,8.9 15.89,8.9C16.31,8.13 17.63,6.56 17.63,6.56C15.16,7.05 13.81,8.66 13.81,8.66C13.41,8.35 12.59,8.4 12.59,8.4C12.97,8.61 13.35,9.21 13.35,9.72V14.65C13.35,14.65 12.5,15.38 11.88,15.38C11.5,15.38 11.27,15.17 11.14,15C11.05,14.88 11,14.79 11,14.79V8.69C10.93,8.75 10.82,8.8 10.71,8.8C10.57,8.79 10.43,8.73 10.34,8.53C10.26,8.38 10.22,8.15 10.22,7.83C10.22,6.7 11.5,5.96 11.5,5.96C9.87,6.39 8.36,7.22 6.35,9.5";
var mdiUpdate = "M21,10.12H14.22L16.96,7.3C14.23,4.6 9.81,4.5 7.08,7.2C4.35,9.91 4.35,14.28 7.08,17C9.81,19.7 14.23,19.7 16.96,17C18.32,15.65 19,14.08 19,12.1H21C21,14.08 20.12,16.65 18.36,18.39C14.85,21.87 9.15,21.87 5.64,18.39C2.14,14.92 2.11,9.28 5.62,5.81C9.13,2.34 14.76,2.34 18.27,5.81L21,3V10.12M12.5,8V12.25L16,14.33L15.28,15.54L11,13V8H12.5Z";
var mdiUpload = "M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z";
var mdiUploadBox = "M5 3H19C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3M16 17V15H8V17H16M16 11L12 7L8 11H10.5V14H13.5V11H16Z";
var mdiUploadBoxOutline = "M8 17V15H16V17H8M16 11L12 7L8 11H10.5V14H13.5V11H16M5 3H19C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3M5 5V19H19V5H5Z";
var mdiUploadCircle = "M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2ZM16 17V15H8V17H16ZM16 10L12 6L8 10H10.5V14H13.5V10H16Z";
var mdiUploadCircleOutline = "M8 17V15H16V17H8M16 10L12 6L8 10H10.5V14H13.5V10H16M12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4Z";
var mdiUploadLock = "M22 22H17C16.5 22 16 21.5 16 21V17C16 16.5 16.5 16 17 16V14.5C17 13.1 18.1 12 19.5 12C20.9 12 22 13.1 22 14.5V16C22.5 16 23 16.5 23 17V21C23 21.5 22.5 22 22 22M14 20H5V18H14V20M21 16V14.5C21 13.7 20.3 13 19.5 13C18.7 13 18 13.7 18 14.5V16H21M15 16H9V10H5L12 3L19 10H15V16Z";
var mdiUploadLockOutline = "M22 22H17C16.5 22 16 21.5 16 21V17C16 16.5 16.5 16 17 16V14.5C17 13.1 18.1 12 19.5 12C20.9 12 22 13.1 22 14.5V16C22.5 16 23 16.5 23 17V21C23 21.5 22.5 22 22 22M5 18H14V20H5V18M21 16V14.5C21 13.7 20.3 13 19.5 13C18.7 13 18 13.7 18 14.5V16H21M9 16V10H5L12 3L19 10H15V16H9M9.83 8H11V14H13V8H14.17L12 5.83L9.83 8Z";
var mdiUploadMultiple = "M9,14V8H5L12,1L19,8H15V14H9M5,18V16H19V18H5M19,20H5V22H19V20Z";
var mdiUploadMultipleOutline = "M19 8H15V14H9V8H5L12 1L19 8M14.17 6L12 3.83L9.83 6H11V12H13V6H14.17M5 16V18H19V16H5M19 20V22H5V20H19Z";
var mdiUploadNetwork = "M17,3A2,2 0 0,1 19,5V15A2,2 0 0,1 17,17H13V19H14A1,1 0 0,1 15,20H22V22H15A1,1 0 0,1 14,23H10A1,1 0 0,1 9,22H2V20H9A1,1 0 0,1 10,19H11V17H7C5.89,17 5,16.1 5,15V5A2,2 0 0,1 7,3H17M12,5.5L7.5,10H11V14H13V10H16.5L12,5.5Z";
var mdiUploadNetworkOutline = "M15,20A1,1 0 0,0 14,19H13V17H17A2,2 0 0,0 19,15V5A2,2 0 0,0 17,3H7A2,2 0 0,0 5,5V15A2,2 0 0,0 7,17H11V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15M7,15V5H17V15H7M12,6L8,10H11V14H13V10H16L12,6Z";
var mdiUploadOff = "M22.11 21.46L2.39 1.73L1.11 3L6.56 8.45L5 10H8.11L9 10.89V16H14.11L16.11 18H5V20H18.11L20.84 22.73L22.11 21.46M15 10H19L12 3L9.1 5.9L15 11.8V10Z";
var mdiUploadOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L6.56 8.45L5 10H8.11L9 10.89V16H14.11L16.11 18H5V20H18.11L20.84 22.73L22.11 21.46M11 14V12.89L12.11 14H11M12 5.8L14.2 8H13V9.8L15 11.8V10H19L12 3L9.1 5.9L10.5 7.3L12 5.8Z";
var mdiUploadOutline = "M9,10V16H15V10H19L12,3L5,10H9M12,5.8L14.2,8H13V14H11V8H9.8L12,5.8M19,18H5V20H19V18Z";
var mdiUsb = "M15,7V11H16V13H13V5H15L12,1L9,5H11V13H8V10.93C8.7,10.56 9.2,9.85 9.2,9C9.2,7.78 8.21,6.8 7,6.8C5.78,6.8 4.8,7.78 4.8,9C4.8,9.85 5.3,10.56 6,10.93V13A2,2 0 0,0 8,15H11V18.05C10.29,18.41 9.8,19.15 9.8,20A2.2,2.2 0 0,0 12,22.2A2.2,2.2 0 0,0 14.2,20C14.2,19.15 13.71,18.41 13,18.05V15H16A2,2 0 0,0 18,13V11H19V7H15Z";
var mdiUsbCPort = "M6 12H18C18.55 12 19 12.45 19 13C19 13.55 18.55 14 18 14H6C5.45 14 5 13.55 5 13C5 12.45 5.45 12 6 12M6 10C4.34 10 3 11.34 3 13C3 14.66 4.34 16 6 16H18C19.66 16 21 14.66 21 13C21 11.34 19.66 10 18 10H6M6 8H18C20.76 8 23 10.24 23 13C23 15.76 20.76 18 18 18H6C3.24 18 1 15.76 1 13C1 10.24 3.24 8 6 8Z";
var mdiUsbFlashDrive = "M8 15C8.55 15 9 15.45 9 16C9 16.55 8.55 17 8 17C7.45 17 7 16.55 7 16C7 15.45 7.45 15 8 15M15.07 4.69L16.5 6.1L15.07 7.5L13.66 6.1L15.07 4.69M17.9 7.5L19.31 8.93L17.9 10.34L16.5 8.93L17.9 7.5M8 13C6.34 13 5 14.34 5 16C5 17.66 6.34 19 8 19C9.66 19 11 17.66 11 16C11 14.34 9.66 13 8 13M9.77 4.33L10.5 5.08L14.29 1.29C14.47 1.11 14.72 1 15 1C15.28 1 15.53 1.11 15.71 1.29L22.78 8.36L22.78 8.37C22.92 8.54 23 8.76 23 9C23 9.3 22.87 9.57 22.66 9.76L22.66 9.76L18.93 13.5L19.67 14.23L12.95 20.95C11.68 22.22 9.93 23 8 23C4.13 23 1 19.87 1 16C1 14.07 1.78 12.32 3.05 11.05L9.77 4.33M20.59 9L15 3.41L11.93 6.5L17.5 12.08L20.59 9Z";
var mdiUsbFlashDriveOutline = "M8 13C9.66 13 11 14.34 11 16C11 17.66 9.66 19 8 19C6.34 19 5 17.66 5 16C5 14.34 6.34 13 8 13M8 15C7.45 15 7 15.45 7 16C7 16.55 7.45 17 8 17C8.55 17 9 16.55 9 16C9 15.45 8.55 15 8 15M9.77 4.33L10.5 5.08L14.29 1.29C14.47 1.11 14.72 1 15 1C15.28 1 15.53 1.11 15.71 1.29L22.78 8.36L22.78 8.37C22.92 8.54 23 8.76 23 9C23 9.3 22.87 9.57 22.66 9.76L22.66 9.76L18.93 13.5L19.67 14.23L12.95 20.95C11.68 22.22 9.93 23 8 23C4.13 23 1 19.87 1 16C1 14.07 1.78 12.32 3.05 11.05L9.77 4.33M11.54 19.54L16.84 14.23L9.77 7.16L4.46 12.46C3.56 13.37 3 14.62 3 16C3 18.76 5.24 21 8 21C9.38 21 10.63 20.44 11.54 19.54M15.07 4.69L16.5 6.1L15.07 7.5L13.66 6.1L15.07 4.69M17.9 7.5L19.31 8.93L17.9 10.34L16.5 8.93L17.9 7.5M20.59 9L15 3.41L11.93 6.5L17.5 12.08L20.59 9Z";
var mdiUsbPort = "M8 2C6.9 2 6 2.9 6 4V12H5V16L9 20V22H15V20L19 16V12H18V4C18 2.9 17.11 2 16 2M8 4H16V12H8M9 7V9H11V7M13 7V9H15V7Z";
var mdiVacuum = "M23 20V22H16L16 20H18.46L12 4.61C11.81 4.14 11.5 3.76 11.06 3.46S10.14 3 9.61 3C8.9 3 8.28 3.27 7.76 3.79S7 4.92 7 5.64L7 9H8C10.21 9 12 10.79 12 13V22H8C8.61 21.16 9 20.13 9 19C9 16.24 6.76 14 4 14C3.29 14 2.61 14.15 2 14.42V9H5V5.64C5 4.8 5.23 4 5.63 3.32C6.04 2.62 6.59 2.06 7.3 1.63C8 1.21 8.77 1 9.61 1C10.55 1 11.4 1.26 12.16 1.77S13.5 2.97 13.87 3.81L20.66 20H23M7 19C7 20.66 5.66 22 4 22S1 20.66 1 19 2.34 16 4 16 7 17.34 7 19M5 19C5 18.45 4.55 18 4 18S3 18.45 3 19 3.45 20 4 20 5 19.55 5 19Z";
var mdiVacuumOutline = "M20.66 20L13.87 3.81C13.5 2.97 12.93 2.29 12.16 1.77C11.4 1.26 10.55 1 9.61 1C8.77 1 8 1.21 7.3 1.63S6.04 2.62 5.63 3.32 5 4.8 5 5.64L5.03 9H2.03V14.45C2.65 14.17 3.31 14.03 4 14.03V11.03H9C9.57 11.03 10.04 11.23 10.43 11.62C10.82 12 11 12.47 11 13V20.03H8.91C8.76 20.75 8.44 21.41 7.97 22H13V13C13 12.28 12.8 11.62 12.45 11S11.61 9.91 11 9.56C10.42 9.2 9.75 9 9 9H7V5.64C7 4.92 7.25 4.31 7.76 3.79S8.89 3 9.61 3C10.14 3 10.63 3.16 11.06 3.46S11.81 4.14 12 4.61L18.46 20L16 20.03V22H23V20.03L20.66 20M4 18C4.55 18 5 18.45 5 19S4.55 20 4 20 3 19.55 3 19 3.45 18 4 18M4 16C2.34 16 1 17.34 1 19S2.34 22 4 22 7 20.66 7 19 5.66 16 4 16Z";
var mdiValve = "M4 22H2V2H4M22 2H20V22H22M17.24 5.34L13.24 9.34A3 3 0 0 0 9.24 13.34L5.24 17.34L6.66 18.76L10.66 14.76A3 3 0 0 0 14.66 10.76L18.66 6.76Z";
var mdiValveClosed = "M22 2V22H20V13H14.82A3 3 0 0 1 9.18 13H4V22H2V2H4V11H9.18A3 3 0 0 1 14.82 11H20V2Z";
var mdiValveOpen = "M4 22H2V2H4M22 2H20V22H22M11 4V9.18A3 3 0 0 0 11 14.82V20H13V14.82A3 3 0 0 0 13 9.18V4Z";
var mdiVanPassenger = "M3,7C1.89,7 1,7.89 1,9V17H3A3,3 0 0,0 6,20A3,3 0 0,0 9,17H15A3,3 0 0,0 18,20A3,3 0 0,0 21,17H23V13C23,11.89 22.11,11 21,11L18,7H3M3,8.5H7V11H3V8.5M9,8.5H13V11H9V8.5M15,8.5H17.5L19.46,11H15V8.5M6,15.5A1.5,1.5 0 0,1 7.5,17A1.5,1.5 0 0,1 6,18.5A1.5,1.5 0 0,1 4.5,17A1.5,1.5 0 0,1 6,15.5M18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5Z";
var mdiVanUtility = "M3,7C1.89,7 1,7.89 1,9V17H3A3,3 0 0,0 6,20A3,3 0 0,0 9,17H15A3,3 0 0,0 18,20A3,3 0 0,0 21,17H23V13C23,11.89 22.11,11 21,11L18,7H3M15,8.5H17.5L19.46,11H15V8.5M6,15.5A1.5,1.5 0 0,1 7.5,17A1.5,1.5 0 0,1 6,18.5A1.5,1.5 0 0,1 4.5,17A1.5,1.5 0 0,1 6,15.5M18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5Z";
var mdiVanish = "M16,13V11H21V13H16M14.83,7.76L17.66,4.93L19.07,6.34L16.24,9.17L14.83,7.76M11,16H13V21H11V16M11,3H13V8H11V3M4.93,17.66L7.76,14.83L9.17,16.24L6.34,19.07L4.93,17.66M4.93,6.34L6.34,4.93L9.17,7.76L7.76,9.17L4.93,6.34M8,13H3V11H8V13M19.07,17.66L17.66,19.07L14.83,16.24L16.24,14.83L19.07,17.66Z";
var mdiVanishQuarter = "M11 3H13V8H11V3M4.9 6.3L6.3 4.9L9.1 7.7L7.8 9.2L4.9 6.3M8 13H3V11H8V13";
var mdiVanityLight = "M22 20H16C16 18.34 17.34 13 19 13S22 18.34 22 20M12 13C10.34 13 9 18.34 9 20H15C15 18.34 13.66 13 12 13M5 13C3.34 13 2 18.34 2 20H8C8 18.34 6.66 13 5 13M14.82 6C14.26 4.44 12.53 3.64 11 4.2C10.14 4.5 9.5 5.17 9.18 6H2V8H4V12H6V8H9.18C9.5 8.85 10.15 9.5 11 9.82V12H13V9.82C13.85 9.5 14.5 8.85 14.82 8H18V12H20V8H22V6H14.82Z";
var mdiVariable = "M20.41,3C21.8,5.71 22.35,8.84 22,12C21.8,15.16 20.7,18.29 18.83,21L17.3,20C18.91,17.57 19.85,14.8 20,12C20.34,9.2 19.89,6.43 18.7,4L20.41,3M5.17,3L6.7,4C5.09,6.43 4.15,9.2 4,12C3.66,14.8 4.12,17.57 5.3,20L3.61,21C2.21,18.29 1.65,15.17 2,12C2.2,8.84 3.3,5.71 5.17,3M12.08,10.68L14.4,7.45H16.93L13.15,12.45L15.35,17.37H13.09L11.71,14L9.28,17.33H6.76L10.66,12.21L8.53,7.45H10.8L12.08,10.68Z";
var mdiVariableBox = "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M7.4 18C5.9 16.5 5 14.3 5 12S5.9 7.5 7.4 6L9 6.7C7.7 7.9 7 9.9 7 12S7.7 16.1 9 17.3L7.4 18M12.7 15L11.9 13L10.5 15H9L11.3 11.9L10 9H11.3L12.1 11L13.5 9H15L12.8 12L14.1 15H12.7M16.6 18L15 17.3C16.3 16 17 14.1 17 12S16.3 7.9 15 6.7L16.6 6C18.1 7.5 19 9.7 19 12S18.1 16.5 16.6 18Z";
var mdiVectorArrangeAbove = "M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16C6.67,16 10.33,16 14,16C15.11,16 16,15.11 16,14C16,10.33 16,6.67 16,3C16,1.89 15.11,1 14,1H3M3,3H14V14H3V3M18,7V9H20V20H9V18H7V20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7H18Z";
var mdiVectorArrangeBelow = "M20,22C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7C16.33,7 12.67,7 9,7C7.89,7 7,7.89 7,9C7,12.67 7,16.33 7,20C7,21.11 7.89,22 9,22H20M20,20H9V9H20V20M5,16V14H3V3H14V5H16V3C16,1.89 15.11,1 14,1H3C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16H5Z";
var mdiVectorBezier = "M7.5,4A1.5,1.5 0 0,0 6,5.5A1.5,1.5 0 0,0 7.5,7C8.13,7 8.7,6.6 8.91,6H13C13.67,5.33 14.33,5 15,5H8.91C8.7,4.4 8.13,4 7.5,4M19,5C8,5 14,17 5,17V19C16,19 10,7 19,7V5M16.5,17C15.87,17 15.3,17.4 15.09,18H11C10.33,18.67 9.67,19 9,19H15.09C15.3,19.6 15.87,20 16.5,20A1.5,1.5 0 0,0 18,18.5A1.5,1.5 0 0,0 16.5,17Z";
var mdiVectorCircle = "M9,2V4.06C6.72,4.92 4.92,6.72 4.05,9H2V15H4.06C4.92,17.28 6.72,19.09 9,19.95V22H15V19.94C17.28,19.08 19.09,17.28 19.95,15H22V9H19.94C19.08,6.72 17.28,4.92 15,4.05V2M11,4H13V6H11M9,6.25V8H15V6.25C16.18,6.86 17.14,7.82 17.75,9H16V15H17.75C17.14,16.18 16.18,17.14 15,17.75V16H9V17.75C7.82,17.14 6.86,16.18 6.25,15H8V9H6.25C6.86,7.82 7.82,6.86 9,6.25M4,11H6V13H4M18,11H20V13H18M11,18H13V20H11";
var mdiVectorCircleVariant = "M22,9H19.97C18.7,5.41 15.31,3 11.5,3A9,9 0 0,0 2.5,12C2.5,17 6.53,21 11.5,21C15.31,21 18.7,18.6 20,15H22M20,11V13H18V11M17.82,15C16.66,17.44 14.2,19 11.5,19C7.64,19 4.5,15.87 4.5,12C4.5,8.14 7.64,5 11.5,5C14.2,5 16.66,6.57 17.81,9H16V15";
var mdiVectorCombine = "M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16C4.33,16 7,16 7,16C7,16 7,18.67 7,20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7C18.67,7 16,7 16,7C16,7 16,4.33 16,3C16,1.89 15.11,1 14,1H3M3,3H14C14,4.33 14,7 14,7H9C7.89,7 7,7.89 7,9V14C7,14 4.33,14 3,14V3M9,9H14V14H9V9M16,9C16,9 18.67,9 20,9V20H9C9,18.67 9,16 9,16H14C15.11,16 16,15.11 16,14V9Z";
var mdiVectorCurve = "M18.5,2A1.5,1.5 0 0,1 20,3.5A1.5,1.5 0 0,1 18.5,5C18.27,5 18.05,4.95 17.85,4.85L14.16,8.55L14.5,9C16.69,7.74 19.26,7 22,7L23,7.03V9.04L22,9C19.42,9 17,9.75 15,11.04A3.96,3.96 0 0,1 11.04,15C9.75,17 9,19.42 9,22L9.04,23H7.03L7,22C7,19.26 7.74,16.69 9,14.5L8.55,14.16L4.85,17.85C4.95,18.05 5,18.27 5,18.5A1.5,1.5 0 0,1 3.5,20A1.5,1.5 0 0,1 2,18.5A1.5,1.5 0 0,1 3.5,17C3.73,17 3.95,17.05 4.15,17.15L7.84,13.45C7.31,12.78 7,11.92 7,11A4,4 0 0,1 11,7C11.92,7 12.78,7.31 13.45,7.84L17.15,4.15C17.05,3.95 17,3.73 17,3.5A1.5,1.5 0 0,1 18.5,2M11,9A2,2 0 0,0 9,11A2,2 0 0,0 11,13A2,2 0 0,0 13,11A2,2 0 0,0 11,9Z";
var mdiVectorDifference = "M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16H5V14H3V3H14V5H16V3C16,1.89 15.11,1 14,1H3M9,7C7.89,7 7,7.89 7,9V11H9V9H11V7H9M13,7V9H14V10H16V7H13M18,7V9H20V20H9V18H7V20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7H18M14,12V14H12V16H14C15.11,16 16,15.11 16,14V12H14M7,13V16H10V14H9V13H7Z";
var mdiVectorDifferenceAb = "M3,1C1.89,1 1,1.89 1,3V5H3V3H5V1H3M7,1V3H10V1H7M12,1V3H14V5H16V3C16,1.89 15.11,1 14,1H12M1,7V10H3V7H1M14,7C14,7 14,11.67 14,14C11.67,14 7,14 7,14C7,14 7,18 7,20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7C18,7 14,7 14,7M16,9H20V20H9V16H14C15.11,16 16,15.11 16,14V9M1,12V14C1,15.11 1.89,16 3,16H5V14H3V12H1Z";
var mdiVectorDifferenceBa = "M20,22C21.11,22 22,21.11 22,20V18H20V20H18V22H20M16,22V20H13V22H16M11,22V20H9V18H7V20C7,21.11 7.89,22 9,22H11M22,16V13H20V16H22M9,16C9,16 9,11.33 9,9C11.33,9 16,9 16,9C16,9 16,5 16,3C16,1.89 15.11,1 14,1H3C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16C5,16 9,16 9,16M7,14H3V3H14V7H9C7.89,7 7,7.89 7,9V14M22,11V9C22,7.89 21.11,7 20,7H18V9H20V11H22Z";
var mdiVectorEllipse = "M23,9V15H20.35C19.38,17.12 17.43,18.78 15,19.54V22H9V19.54C5.5,18.45 3,15.5 3,12C3,7.58 7.03,4 12,4C15.78,4 19,6.07 20.35,9H23M17,15V9H18.06C16.85,7.21 14.59,6 12,6C8.13,6 5,8.69 5,12C5,14.39 6.64,16.46 9,17.42V16H15V17.42C16.29,16.9 17.35,16.05 18.06,15H17M19,13H21V11H19V13M11,20H13V18H11V20Z";
var mdiVectorIntersection = "M3.14,1A2.14,2.14 0 0,0 1,3.14V5H3V3H5V1H3.14M7,1V3H10V1H7M12,1V3H14V5H16V3.14C16,1.96 15.04,1 13.86,1H12M1,7V10H3V7H1M9,7C7.89,7 7,7.89 7,9C7,11.33 7,16 7,16C7,16 11.57,16 13.86,16A2.14,2.14 0 0,0 16,13.86C16,11.57 16,7 16,7C16,7 11.33,7 9,7M18,7V9H20V11H22V9C22,7.89 21.11,7 20,7H18M9,9H14V14H9V9M1,12V13.86C1,15.04 1.96,16 3.14,16H5V14H3V12H1M20,13V16H22V13H20M7,18V20C7,21.11 7.89,22 9,22H11V20H9V18H7M20,18V20H18V22H20C21.11,22 22,21.11 22,20V18H20M13,20V22H16V20H13Z";
var mdiVectorLine = "M15,3V7.59L7.59,15H3V21H9V16.42L16.42,9H21V3M17,5H19V7H17M5,17H7V19H5";
var mdiVectorLink = "M3 1C1.89 1 1 1.89 1 3V14C1 15.11 1.89 16 3 16H14C15.11 16 16 15.11 16 14V11H14V14H3V3H14V5H16V3C16 1.89 15.11 1 14 1M9 7C7.89 7 7 7.89 7 9V12H9V9H20V20H9V18H7V20C7 21.11 7.89 22 9 22H20C21.11 22 22 21.11 22 20V9C22 7.89 21.11 7 20 7H9";
var mdiVectorPoint = "M9 9V15H15V9H9M11 11H13V13H11V11Z";
var mdiVectorPointEdit = "M9 9V15H15V9H9M11 11H13V13H11V11M21.2 13C21.1 13 20.9 13.1 20.8 13.2L19.8 14.2L21.9 16.3L22.9 15.3C23.1 15.1 23.1 14.7 22.9 14.5L21.6 13.2C21.4 13.1 21.3 13 21.2 13M19.1 14.8L13 20.9V23H15.1L21.2 16.8L19.1 14.8Z";
var mdiVectorPointMinus = "M9 9V15H15V9H9M11 11H13V13H11V11M15 18V20H23V18H15Z";
var mdiVectorPointPlus = "M9 9V15H15V9H9M11 11H13V13H11V11M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z";
var mdiVectorPointSelect = "M12,20L7,22L12,11L17,22L12,20M8,2H16V5H22V7H16V10H8V7H2V5H8V2M10,4V8H14V4H10Z";
var mdiVectorPolygon = "M2,2V8H4.28L5.57,16H4V22H10V20.06L15,20.05V22H21V16H19.17L20,9H22V3H16V6.53L14.8,8H9.59L8,5.82V2M4,4H6V6H4M18,5H20V7H18M6.31,8H7.11L9,10.59V14H15V10.91L16.57,9H18L17.16,16H15V18.06H10V16H7.6M11,10H13V12H11M6,18H8V20H6M17,18H19V20H17";
var mdiVectorPolygonVariant = "M22 8V2H16V5.8L14.4 8H9.6L8 5.8V2H2V8H4V16H2V22H8V20H16V22H22V16H20V8H22M11 10H13V12H11V10M4 4H6V6H4V4M6 20H4V18H6V20M16 18H8V16H6V8H7.1L9 10.6V14H15V10.6L16.9 8H18V16H16V18M20 20H18V18H20V20M18 6V4H20V6H18Z";
var mdiVectorPolyline = "M2 3V9H4.95L6.95 15H6V21H12V16.41L17.41 11H22V5H16V9.57L10.59 15H9.06L7.06 9H8V3M4 5H6V7H4M18 7H20V9H18M8 17H10V19H8Z";
var mdiVectorPolylineEdit = "M2 3V9H4.95L6.95 15H6V21H12V16.41L17.41 11H22V5H16V9.57L10.59 15H9.06L7.06 9H8V3H2M4 5H6V7H4V5M18 7H20V9H18V7M21.15 13C21 13 20.87 13.05 20.76 13.16L19.75 14.18L21.82 16.25L22.84 15.24C23.05 15.03 23.05 14.67 22.84 14.46L21.54 13.16C21.43 13.05 21.29 13 21.15 13M19.15 14.76L13 20.91V23H15.09L21.23 16.84L19.15 14.76M8 17H10V19H8V17Z";
var mdiVectorPolylineMinus = "M2 3V9H4.95L6.95 15H6V21H12V16.41L17.41 11H22V5H16V9.57L10.59 15H9.06L7.06 9H8V3H2M4 5H6V7H4V5M18 7H20V9H18V7M8 17H10V19H8V17M15 18V20H23V18H15Z";
var mdiVectorPolylinePlus = "M2 3V9H4.95L6.95 15H6V21H12V16.41L17.41 11H22V5H16V9.57L10.59 15H9.06L7.06 9H8V3H2M4 5H6V7H4V5M18 7H20V9H18V7M18 15V18H15V20H18V23H20V20H23V18H20V15H18M8 17H10V19H8V17Z";
var mdiVectorPolylineRemove = "M21.1 15.5L19 17.6L16.9 15.5L15.5 16.9L17.6 19L15.5 21.1L16.9 22.5L19 20.4L21.1 22.5L22.5 21.1L20.4 19L22.5 16.9L21.1 15.5M16 5V9.6L10.6 15H9.1L7.1 9H8V3H2V9H5L7 15H6V21H12V16.4L17.4 11H22V5H16M6 7H4V5H6V7M10 19H8V17H10V19M20 9H18V7H20V9";
var mdiVectorRadius = "M2,4H4V2H10V4A10,10 0 0,1 20,14H22V20H20V22H18V20H16V14H18A8,8 0 0,0 10,6V8H4V6H2V4M18,16V18H20V16H18M6,4V6H8V4H6Z";
var mdiVectorRectangle = "M2,4H8V6H16V4H22V10H20V14H22V20H16V18H8V20H2V14H4V10H2V4M16,10V8H8V10H6V14H8V16H16V14H18V10H16M4,6V8H6V6H4M18,6V8H20V6H18M4,16V18H6V16H4M18,16V18H20V16H18Z";
var mdiVectorSelection = "M3,1H5V3H3V5H1V3A2,2 0 0,1 3,1M14,1A2,2 0 0,1 16,3V5H14V3H12V1H14M20,7A2,2 0 0,1 22,9V11H20V9H18V7H20M22,20A2,2 0 0,1 20,22H18V20H20V18H22V20M20,13H22V16H20V13M13,9V7H16V10H14V9H13M13,22V20H16V22H13M9,22A2,2 0 0,1 7,20V18H9V20H11V22H9M7,16V13H9V14H10V16H7M7,3V1H10V3H7M3,16A2,2 0 0,1 1,14V12H3V14H5V16H3M1,7H3V10H1V7M9,7H11V9H9V11H7V9A2,2 0 0,1 9,7M16,14A2,2 0 0,1 14,16H12V14H14V12H16V14Z";
var mdiVectorSquare = "M2,2H8V4H16V2H22V8H20V16H22V22H16V20H8V22H2V16H4V8H2V2M16,8V6H8V8H6V16H8V18H16V16H18V8H16M4,4V6H6V4H4M18,4V6H20V4H18M4,18V20H6V18H4M18,18V20H20V18H18Z";
var mdiVectorSquareClose = "M4 4H6V6H4V4M6 20H4V18H6V20M18 8V16H16V18H8V16H6V8H8V2H2V8H4V16H2V22H8V20H16V22H22V16H20V8H22V2H16V8H18M20 20H18V18H20V20M18 6V4H20V6H18M14 6H10V4H14V6Z";
var mdiVectorSquareEdit = "M22.7 14.4L21.7 15.4L19.6 13.3L20.6 12.3C20.8 12.1 21.2 12.1 21.4 12.3L22.7 13.6C22.9 13.8 22.9 14.1 22.7 14.4M13 19.9L19.1 13.8L21.2 15.9L15.1 22H13V19.9M11 19.9V19.1L11.6 18.5L12.1 18H8V16H6V8H8V6H16V8H18V12.1L19.1 11L19.3 10.8C19.5 10.6 19.8 10.4 20.1 10.3V8H22.1V2H16.1V4H8V2H2V8H4V16H2V22H8V20L11 19.9M18 4H20V6H18V4M4 4H6V6H4V4M6 20H4V18H6V20Z";
var mdiVectorSquareMinus = "M13 19C13 18.7 13 18.3 13.1 18H8V16H6V8H8V6H16V8H18V13.1C18.3 13 18.7 13 19 13C19.3 13 19.7 13 20 13.1V8H22V2H16V4H8V2H2V8H4V16H2V22H8V20H13.1C13 19.7 13 19.3 13 19M18 4H20V6H18V4M4 4H6V6H4V4M6 20H4V18H6V20M23 18V20H15V18H23Z";
var mdiVectorSquareOpen = "M4 4H6V6H4V4M6 20H4V18H6V20M18 8V16H16V18H8V16H6V8H8V2H2V8H4V16H2V22H8V20H16V22H22V16H20V8H22V2H16V8H18M20 20H18V18H20V20M18 6V4H20V6H18Z";
var mdiVectorSquarePlus = "M13 19C13 18.7 13 18.3 13.1 18H8V16H6V8H8V6H16V8H18V13.1C18.3 13 18.7 13 19 13C19.3 13 19.7 13 20 13.1V8H22V2H16V4H8V2H2V8H4V16H2V22H8V20H13.1C13 19.7 13 19.3 13 19M18 4H20V6H18V4M4 4H6V6H4V4M6 20H4V18H6V20M20 15V18H23V20H20V23H18V20H15V18H18V15H20Z";
var mdiVectorSquareRemove = "M13 19C13 18.7 13 18.3 13.1 18H8V16H6V8H8V6H16V8H18V13.1C18.3 13 18.7 13 19 13C19.3 13 19.7 13 20 13.1V8H22V2H16V4H8V2H2V8H4V16H2V22H8V20H13.1C13 19.7 13 19.3 13 19M18 4H20V6H18V4M4 4H6V6H4V4M6 20H4V18H6V20M22.5 16.9L20.4 19L22.5 21.1L21.1 22.5L19 20.4L16.9 22.5L15.5 21.1L17.6 19L15.5 16.9L16.9 15.5L19 17.6L21.1 15.5L22.5 16.9Z";
var mdiVectorTriangle = "M9,3V9H9.73L5.79,16H2V22H8V20H16V22H22V16H18.21L14.27,9H15V3M11,5H13V7H11M12,9.04L16,16.15V18H8V16.15M4,18H6V20H4M18,18H20V20H18";
var mdiVectorUnion = "M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16H7V20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7H16V3C16,1.89 15.11,1 14,1H3M3,3H14V9H20V20H9V14H3V3Z";
var mdiVhs = "M4,6A2,2 0 0,0 2,8V16A2,2 0 0,0 4,18H20A2,2 0 0,0 22,16V8A2,2 0 0,0 20,6H4M4.54,10H7V14H4.54C4.19,13.39 4,12.7 4,12C4,11.3 4.19,10.61 4.54,10M9,10H15V14H9V10M17,10H19.46C19.81,10.61 20,11.3 20,12C20,12.7 19.81,13.39 19.46,14H17V10Z";
var mdiVibrate = "M16,19H8V5H16M16.5,3H7.5A1.5,1.5 0 0,0 6,4.5V19.5A1.5,1.5 0 0,0 7.5,21H16.5A1.5,1.5 0 0,0 18,19.5V4.5A1.5,1.5 0 0,0 16.5,3M19,17H21V7H19M22,9V15H24V9M3,17H5V7H3M0,15H2V9H0V15Z";
var mdiVibrateOff = "M8.2,5L6.55,3.35C6.81,3.12 7.15,3 7.5,3H16.5A1.5,1.5 0 0,1 18,4.5V14.8L16,12.8V5H8.2M0,15H2V9H0V15M21,17V7H19V15.8L20.2,17H21M3,17H5V7H3V17M18,17.35L22.11,21.46L20.84,22.73L18,19.85C17.83,20.54 17.21,21 16.5,21H7.5A1.5,1.5 0 0,1 6,19.5V7.89L1.11,3L2.39,1.73L6.09,5.44L8,7.34L16,15.34L18,17.34V17.35M16,17.89L8,9.89V19H16V17.89M22,9V15H24V9H22Z";
var mdiVideo = "M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z";
var mdiVideo2d = "M13 7H16C17.66 7 19 8.34 19 10V14C19 15.66 17.66 17 16 17H13V7M16 15C16.55 15 17 14.55 17 14V10C17 9.45 16.55 9 16 9H15V15H16M5 7H9C10.11 7 11 7.9 11 9V11C11 12.11 10.11 13 9 13H7V15H11V17H5V13C5 11.9 5.9 11 7 11H9V9H5V7Z";
var mdiVideo3d = "M5,7H9A2,2 0 0,1 11,9V15A2,2 0 0,1 9,17H5V15H9V13H6V11H9V9H5V7M13,7H16A3,3 0 0,1 19,10V14A3,3 0 0,1 16,17H13V7M16,15A1,1 0 0,0 17,14V10A1,1 0 0,0 16,9H15V15H16Z";
var mdiVideo3dOff = "M2.61 2L21.35 20.74L19.94 22.15L14.8 17H13V15.2L11 13.23V15.21C10.93 15.68 10.74 16.08 10.41 16.41C10.08 16.73 9.68 16.93 9.21 17H5V15H9V13H6V11H8.8L6.79 9H5V7.23L1.2 3.41L2.61 2M16 7H16.22C17 7.07 17.63 7.36 18.14 7.88C18.65 8.39 18.93 9 19 9.76V14.24C18.95 14.63 18.87 15 18.72 15.3L17 13.6V9.85C16.95 9.63 16.84 9.44 16.69 9.28C16.53 9.13 16.34 9.03 16.12 9H15V11.59L13 9.57V7H16Z";
var mdiVideo3dVariant = "M14,10V14A0.5,0.5 0 0,1 13.5,14.5H12.5V9.5H13.5A0.5,0.5 0 0,1 14,10M21,6.5V17.5L17,13.5V17A1,1 0 0,1 16,18H4A1,1 0 0,1 3,17V7A1,1 0 0,1 4,6H16A1,1 0 0,1 17,7V10.5M9.5,9.5A1.5,1.5 0 0,0 8,8H4.5V9.5H8V11.25H5.5V12.75H8V14.5H4.5V16H8A1.5,1.5 0 0,0 9.5,14.5M15.5,9.5A1.5,1.5 0 0,0 14,8H11V16H14A1.5,1.5 0 0,0 15.5,14.5";
var mdiVideo4kBox = "M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,13.5H11V15H9.5V13.5H6.5V9H8V12H9.5V9H11V12H12V13.5M18,15H16.2L14.4,12.8V15H13V9H14.5V11.2L16.2,9H18L15.8,12L18,15Z";
var mdiVideoAccount = "M17,10.5L21,6.5V17.5L17,13.5V17A1,1 0 0,1 16,18H4A1,1 0 0,1 3,17V7A1,1 0 0,1 4,6H16A1,1 0 0,1 17,7V10.5M14,16V15C14,13.67 11.33,13 10,13C8.67,13 6,13.67 6,15V16H14M10,8A2,2 0 0,0 8,10A2,2 0 0,0 10,12A2,2 0 0,0 12,10A2,2 0 0,0 10,8Z";
var mdiVideoBox = "M18,16L14,12.8V16H6V8H14V11.2L18,8M20,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z";
var mdiVideoBoxOff = "M6,8H6.73L14,15.27V16H6M2.27,1L1,2.27L3,4.28C2.41,4.62 2,5.26 2,6V18A2,2 0 0,0 4,20H18.73L20.73,22L22,20.73M20,4H7.82L11.82,8H14V10.18L14.57,10.75L18,8V14.18L22,18.17C22,18.11 22,18.06 22,18V6A2,2 0 0,0 20,4Z";
var mdiVideoCheck = "M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5M8.93 15L6 11.8L7.24 10.56L8.93 12.26L12.76 8.43L14 9.93L8.93 15Z";
var mdiVideoCheckOutline = "M15 8V16H5V8H15M16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.45 16.55 6 16 6M6.35 12.08L7.5 10.95L9 12.5L12.5 9L13.65 10.37L9 15L6.35 12.08Z";
var mdiVideoHighDefinition = "M14 10V14C14 14.3 13.8 14.5 13.5 14.5H12.5V9.5H13.5C13.8 9.5 14 9.7 14 10M17 10.5V7C17 6.4 16.6 6 16 6H4C3.4 6 3 6.4 3 7V17C3 17.6 3.4 18 4 18H16C16.6 18 17 17.6 17 17V13.5L21 17.5V6.5L17 10.5M9.5 16H8V12.8H6V16H4.5V8H6V11.2H8V8H9.5V16M15.5 14.5C15.5 15.3 14.8 16 14 16H11V8H14C14.8 8 15.5 8.7 15.5 9.5V14.5Z";
var mdiVideoImage = "M17,10.5L21,6.5V17.5L17,13.5V17A1,1 0 0,1 16,18H4A1,1 0 0,1 3,17V7A1,1 0 0,1 4,6H16A1,1 0 0,1 17,7V10.5M10.91,9.55L9.2,11.82L10.5,13.55L9.77,14.09L7.73,11.36L5,15H15L10.91,9.55Z";
var mdiVideoInputAntenna = "M12,5A7,7 0 0,0 5,12H7A5,5 0 0,1 12,7A5,5 0 0,1 17,12H19A7,7 0 0,0 12,5M13,14.29C13.88,13.9 14.5,13.03 14.5,12A2.5,2.5 0 0,0 12,9.5A2.5,2.5 0 0,0 9.5,12C9.5,13 10.12,13.9 11,14.29V17.59L7.59,21L9,22.41L12,19.41L15,22.41L16.41,21L13,17.59V14.29M12,1A11,11 0 0,0 1,12H3A9,9 0 0,1 12,3A9,9 0 0,1 21,12H23A11,11 0 0,0 12,1Z";
var mdiVideoInputComponent = "M5,2A1,1 0 0,0 4,1A1,1 0 0,0 3,2V6H1V12H7V6H5V2M9,16C9,17.3 9.84,18.4 11,18.82V23H13V18.82C14.16,18.41 15,17.31 15,16V14H9V16M1,16C1,17.3 1.84,18.4 3,18.82V23H5V18.82C6.16,18.4 7,17.3 7,16V14H1V16M21,6V2A1,1 0 0,0 20,1A1,1 0 0,0 19,2V6H17V12H23V6H21M13,2A1,1 0 0,0 12,1A1,1 0 0,0 11,2V6H9V12H15V6H13V2M17,16C17,17.3 17.84,18.4 19,18.82V23H21V18.82C22.16,18.41 23,17.31 23,16V14H17V16Z";
var mdiVideoInputHdmi = "M18,7V4A2,2 0 0,0 16,2H8A2,2 0 0,0 6,4V7H5V13L8,19V22H16V19L19,13V7H18M8,4H16V7H14V5H13V7H11V5H10V7H8V4Z";
var mdiVideoInputScart = "M20.6 2.2L17.3 2.4L13.8 4.4L13.3 3.5L2 10V17H3V19C3 20.1 3.9 21 5 21H15C16.1 21 17 20.1 17 19V17H18V10H17L16.8 9.6L20.3 7.6L22.1 4.8L20.6 2.2M15 17V19H5V17H15Z";
var mdiVideoInputSvideo = "M8,11.5A1.5,1.5 0 0,0 6.5,10A1.5,1.5 0 0,0 5,11.5A1.5,1.5 0 0,0 6.5,13A1.5,1.5 0 0,0 8,11.5M15,6.5A1.5,1.5 0 0,0 13.5,5H10.5A1.5,1.5 0 0,0 9,6.5A1.5,1.5 0 0,0 10.5,8H13.5A1.5,1.5 0 0,0 15,6.5M8.5,15A1.5,1.5 0 0,0 7,16.5A1.5,1.5 0 0,0 8.5,18A1.5,1.5 0 0,0 10,16.5A1.5,1.5 0 0,0 8.5,15M12,1A11,11 0 0,0 1,12A11,11 0 0,0 12,23A11,11 0 0,0 23,12A11,11 0 0,0 12,1M12,21C7.04,21 3,16.96 3,12C3,7.04 7.04,3 12,3C16.96,3 21,7.04 21,12C21,16.96 16.96,21 12,21M17.5,10A1.5,1.5 0 0,0 16,11.5A1.5,1.5 0 0,0 17.5,13A1.5,1.5 0 0,0 19,11.5A1.5,1.5 0 0,0 17.5,10M15.5,15A1.5,1.5 0 0,0 14,16.5A1.5,1.5 0 0,0 15.5,18A1.5,1.5 0 0,0 17,16.5A1.5,1.5 0 0,0 15.5,15Z";
var mdiVideoMarker = "M5.5 16.8C4.8 16.8 4.3 16.2 4.3 15.6C4.3 14.9 4.9 14.4 5.5 14.4S6.7 15 6.7 15.6C6.8 16.2 6.2 16.8 5.5 16.8M5.5 12C3.6 12 2 13.6 2 15.5C2 18.1 5.5 22 5.5 22S9 18.1 9 15.5C9 13.6 7.4 12 5.5 12M4 6C3.4 6 3 6.4 3 7V10.6C3.8 10.2 4.6 10 5.5 10C8.5 10 11 12.5 11 15.5C11 16.4 10.8 17.2 10.5 18H16C16.6 18 17 17.6 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.4 16.6 6 16 6H4Z";
var mdiVideoMarkerOutline = "M5.5 16.8C4.8 16.8 4.3 16.2 4.3 15.6C4.3 14.9 4.9 14.4 5.5 14.4S6.7 15 6.7 15.6C6.8 16.2 6.2 16.8 5.5 16.8M5.5 12C3.6 12 2 13.6 2 15.5C2 18.1 5.5 22 5.5 22S9 18.1 9 15.5C9 13.6 7.4 12 5.5 12M4 6C3.4 6 3 6.4 3 7V10.6C3.6 10.3 4.3 10.1 5 10V8H15V16H11C10.9 16.7 10.8 17.4 10.5 18H16C16.6 18 17 17.6 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.4 16.6 6 16 6H4Z";
var mdiVideoMinus = "M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5M14,13H6V11H14V13Z";
var mdiVideoMinusOutline = "M15 8V16H5V8H15M16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.45 16.55 6 16 6M13 13H7V11H13V13Z";
var mdiVideoOff = "M3.27,2L2,3.27L4.73,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16C16.2,18 16.39,17.92 16.54,17.82L19.73,21L21,19.73M21,6.5L17,10.5V7A1,1 0 0,0 16,6H9.82L21,17.18V6.5Z";
var mdiVideoOffOutline = "M3.41,1.86L2,3.27L4.73,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16C16.21,18 16.39,17.92 16.55,17.82L19.73,21L21.14,19.59L12.28,10.73L3.41,1.86M5,16V8H6.73L14.73,16H5M15,8V10.61L21,16.61V6.5L17,10.5V7A1,1 0 0,0 16,6H10.39L12.39,8H15Z";
var mdiVideoOutline = "M15,8V16H5V8H15M16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5V7A1,1 0 0,0 16,6Z";
var mdiVideoPlus = "M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5M14,13H11V16H9V13H6V11H9V8H11V11H14V13Z";
var mdiVideoPlusOutline = "M15 8V16H5V8H15M16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.45 16.55 6 16 6M13 13H11V15H9V13H7V11H9V9H11V11H13V13Z";
var mdiVideoStabilization = "M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M4,6V18H20V6H4M7.24,6.58L18.83,9.69L16.76,17.42L5.17,14.31L7.24,6.58Z";
var mdiVideoStandardDefinition = "M14 14V10C14 9.7 13.8 9.5 13.5 9.5H12.5V14.5H13.5C13.8 14.5 14 14.3 14 14M17 7V10.5L21 6.5V17.5L17 13.5V17C17 17.6 16.6 18 16 18H4C3.4 18 3 17.6 3 17V7C3 6.4 3.4 6 4 6H16C16.6 6 17 6.4 17 7M14 16C14.8 16 15.5 15.3 15.5 14.5V9.5C15.5 8.7 14.8 8 14 8H11V16H14M9 8H5.5C4.67 8 4 8.67 4 9.5V11C4 11.83 4.67 12.5 5.5 12.5H7.5V14.5H4V16H7.5C8.33 16 9 15.33 9 14.5V12.5C9 11.67 8.33 11 7.5 11H5.5V9.5H9V8Z";
var mdiVideoSwitch = "M13,15.5V13H7V15.5L3.5,12L7,8.5V11H13V8.5L16.5,12M18,9.5V6A1,1 0 0,0 17,5H3A1,1 0 0,0 2,6V18A1,1 0 0,0 3,19H17A1,1 0 0,0 18,18V14.5L22,18.5V5.5L18,9.5Z";
var mdiVideoSwitchOutline = "M8 13H12V15L15 12L12 9V11H8V9L5 12L8 15V13M18 9.5V6C18 5.4 17.5 5 17 5H3C2.5 5 2 5.4 2 6V18C2 18.5 2.5 19 3 19H17C17.5 19 18 18.5 18 18V14.5L22 18.5V5.5L18 9.5M16 17H4V7H16V17Z";
var mdiVideoVintage = "M18,14.5V11A1,1 0 0,0 17,10H16C18.24,8.39 18.76,5.27 17.15,3C15.54,0.78 12.42,0.26 10.17,1.87C9.5,2.35 8.96,3 8.6,3.73C6.25,2.28 3.17,3 1.72,5.37C0.28,7.72 1,10.8 3.36,12.25C3.57,12.37 3.78,12.5 4,12.58V21A1,1 0 0,0 5,22H17A1,1 0 0,0 18,21V17.5L22,21.5V10.5L18,14.5M13,4A2,2 0 0,1 15,6A2,2 0 0,1 13,8A2,2 0 0,1 11,6A2,2 0 0,1 13,4M6,6A2,2 0 0,1 8,8A2,2 0 0,1 6,10A2,2 0 0,1 4,8A2,2 0 0,1 6,6Z";
var mdiVideoWireless = "M17,14.5V11A1,1 0 0,0 16,10H4A1,1 0 0,0 3,11V21A1,1 0 0,0 4,22H16A1,1 0 0,0 17,21V17.5L21,21.5V10.5M3,3.86L4.4,5.24C7.5,2.19 12.5,2.19 15.6,5.24L17,3.86C13.14,0.05 6.87,0.05 3,3.86M5.8,6.62L7.2,8C8.75,6.5 11.25,6.5 12.8,8L14.2,6.62C11.88,4.34 8.12,4.34 5.8,6.62Z";
var mdiVideoWirelessOutline = "M15,12V20H5V12H15M16,10H4A1,1 0 0,0 3,11V21A1,1 0 0,0 4,22H16A1,1 0 0,0 17,21V17.5L21,21.5V10.5L17,14.5V11A1,1 0 0,0 16,10M3,3.86L4.4,5.24C7.5,2.19 12.5,2.19 15.6,5.24L17,3.86C13.14,0.05 6.87,0.05 3,3.86M5.8,6.63L7.2,8C8.75,6.5 11.25,6.5 12.8,8L14.2,6.63C11.88,4.34 8.12,4.34 5.8,6.63Z";
var mdiViewAgenda = "M21 3H3C2.4 3 2 3.4 2 4V10C2 10.6 2.4 11 3 11H21C21.6 11 22 10.6 22 10V4C22 3.4 21.6 3 21 3M21 13H3C2.4 13 2 13.4 2 14V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20V14C22 13.4 21.6 13 21 13Z";
var mdiViewAgendaOutline = "M21 13H3A1 1 0 0 0 2 14V20A1 1 0 0 0 3 21H21A1 1 0 0 0 22 20V14A1 1 0 0 0 21 13M20 19H4V15H20M21 3H3A1 1 0 0 0 2 4V10A1 1 0 0 0 3 11H21A1 1 0 0 0 22 10V4A1 1 0 0 0 21 3M20 9H4V5H20Z";
var mdiViewArray = "M8,18H17V5H8M18,5V18H21V5M4,18H7V5H4V18Z";
var mdiViewArrayOutline = "M15 7V16H10V7H15M21 5H18V18H21V5M17 5H8V18H17V5M7 5H4V18H7V5Z";
var mdiViewCarousel = "M18,6V17H22V6M2,17H6V6H2M7,19H17V4H7V19Z";
var mdiViewCarouselOutline = "M2 6H6V17H2V6M7 19H17V4H7V19M9 6H15V17H9V6M18 6H22V17H18V6Z";
var mdiViewColumn = "M16,5V18H21V5M4,18H9V5H4M10,18H15V5H10V18Z";
var mdiViewColumnOutline = "M4 5V18H21V5H4M14 7V16H11V7H14M6 7H9V16H6V7M19 16H16V7H19V16Z";
var mdiViewComfy = "M3,9H7V5H3V9M3,14H7V10H3V14M8,14H12V10H8V14M13,14H17V10H13V14M8,9H12V5H8V9M13,5V9H17V5H13M18,14H22V10H18V14M3,19H7V15H3V19M8,19H12V15H8V19M13,19H17V15H13V19M18,19H22V15H18V19M18,5V9H22V5H18Z";
var mdiViewComfyOutline = "M3 5V19H22V5H3M20 9H17.75V7H20V9M9.25 11H11.5V13H9.25V11M7.25 13H5V11H7.25V13M11.5 9H9.25V7H11.5V9M13.5 7H15.75V9H13.5V7M11.5 15V17H9.25V15H11.5M13.5 15H15.75V17H13.5V15M13.5 13V11H15.75V13H13.5M17.75 11H20V13H17.75V11M7.25 7V9H5V7H7.25M5 15H7.25V17H5V15M17.75 17V15H20V17H17.75Z";
var mdiViewCompact = "M3,19H9V12H3V19M10,19H22V12H10V19M3,5V11H22V5H3Z";
var mdiViewCompactOutline = "M3,5V19H22V5H3M5,7H20V11H5V7M5,17V13H9V17H5M11,17V13H20V17H11Z";
var mdiViewDashboard = "M13,3V9H21V3M13,21H21V11H13M3,21H11V15H3M3,13H11V3H3V13Z";
var mdiViewDashboardEdit = "M21 13.1C20.9 13.1 20.7 13.2 20.6 13.3L19.6 14.3L21.7 16.4L22.7 15.4C22.9 15.2 22.9 14.8 22.7 14.6L21.4 13.3C21.3 13.2 21.2 13.1 21 13.1M19.1 14.9L13 20.9V23H15.1L21.2 16.9L19.1 14.9M21 9H13V3H21V9M13 18.06V11H21V11.1C20.24 11.1 19.57 11.5 19.19 11.89L13 18.06M11 13H3V3H11V13M11 21H3V15H11V21Z";
var mdiViewDashboardEditOutline = "M21 13.1C20.9 13.1 20.7 13.2 20.6 13.3L19.6 14.3L21.7 16.4L22.7 15.4C22.9 15.2 22.9 14.8 22.7 14.6L21.4 13.3C21.3 13.2 21.2 13.1 21 13.1M19.1 14.9L13 20.9V23H15.1L21.2 16.9L19.1 14.9M21 3H13V9H21V3M19 7H15V5H19V7M13 18.06V11H21V11.1C20.24 11.1 19.57 11.5 19.19 11.89L18.07 13H15V16.07L13 18.06M11 3H3V13H11V3M9 11H5V5H9V11M11 20.06V15H3V21H11V20.06M9 19H5V17H9V19Z";
var mdiViewDashboardOutline = "M19,5V7H15V5H19M9,5V11H5V5H9M19,13V19H15V13H19M9,17V19H5V17H9M21,3H13V9H21V3M11,3H3V13H11V3M21,11H13V21H21V11M11,15H3V21H11V15Z";
var mdiViewDashboardVariant = "M2,5V19H8V5H2M9,5V10H15V5H9M16,5V14H22V5H16M9,11V19H15V11H9M16,15V19H22V15H16Z";
var mdiViewDashboardVariantOutline = "M2 5V19H22V5H2M20 12H16V7H20V12M14 10H10V7H14V10M10 12H14V17H10V12M4 7H8V17H4V7M16 17V14H20V17H16Z";
var mdiViewDay = "M2,3V6H21V3M20,8H3A1,1 0 0,0 2,9V15A1,1 0 0,0 3,16H20A1,1 0 0,0 21,15V9A1,1 0 0,0 20,8M2,21H21V18H2V21Z";
var mdiViewDayOutline = "M21 18H2V20H21V18M19 10V14H4V10H19M20 8H3C2.45 8 2 8.45 2 9V15C2 15.55 2.45 16 3 16H20C20.55 16 21 15.55 21 15V9C21 8.45 20.55 8 20 8M21 4H2V6H21V4Z";
var mdiViewGallery = "M21 3H2V16H21V3M2 17H6V21H2V17M7 17H11V21H7V17M12 17H16V21H12V17M17 17H21V21H17V17Z";
var mdiViewGalleryOutline = "M1 3V21H23V3H1M21 5V14H3V5H21M11 16V19H8V16H11M3 16H6V19H3V16M13 19V16H16V19H13M18 19V16H21V19H18Z";
var mdiViewGrid = "M3,11H11V3H3M3,21H11V13H3M13,21H21V13H13M13,3V11H21V3";
var mdiViewGridCompact = "M2 5H4V7H2V5M5 5H7V7H5V5M8 5H10V7H8V5M11 5H13V7H11V5M14 5H16V7H14V5M17 5H19V7H17V5M20 5H22V7H20V5M2 8H4V10H2V8M5 8H7V10H5V8M8 8H10V10H8V8M11 8H13V10H11V8M14 8H16V10H14V8M17 8H19V10H17V8M20 8H22V10H20V8M2 11H4V13H2V11M5 11H7V13H5V11M8 11H10V13H8V11M11 11H13V13H11V11M14 11H16V13H14V11M17 11H19V13H17V11M20 11H22V13H20V11M2 14H4V16H2V14M5 14H7V16H5V14M8 14H10V16H8V14M11 14H13V16H11V14M14 14H16V16H14V14M17 14H19V16H17V14M20 14H22V16H20V14M2 17H4V19H2V17M5 17H7V19H5V17M8 17H10V19H8V17M11 17H13V19H11V17M14 17H16V19H14V17M17 17H19V19H17V17M20 17H22V19H20V17";
var mdiViewGridOutline = "M3 11H11V3H3M5 5H9V9H5M13 21H21V13H13M15 15H19V19H15M3 21H11V13H3M5 15H9V19H5M13 3V11H21V3M19 9H15V5H19Z";
var mdiViewGridPlus = "M13 3V11H21V3H13M3 21H11V13H3V21M3 3V11H11V3H3M13 16H16V13H18V16H21V18H18V21H16V18H13V16Z";
var mdiViewGridPlusOutline = "M3 21H11V13H3M5 15H9V19H5M3 11H11V3H3M5 5H9V9H5M13 3V11H21V3M19 9H15V5H19M18 16H21V18H18V21H16V18H13V16H16V13H18Z";
var mdiViewHeadline = "M4,5V7H21V5M4,11H21V9H4M4,19H21V17H4M4,15H21V13H4V15Z";
var mdiViewList = "M9,5V9H21V5M9,19H21V15H9M9,14H21V10H9M4,9H8V5H4M4,19H8V15H4M4,14H8V10H4V14Z";
var mdiViewListOutline = "M3 5V19H20V5H3M7 7V9H5V7H7M5 13V11H7V13H5M5 15H7V17H5V15M18 17H9V15H18V17M18 13H9V11H18V13M18 9H9V7H18V9Z";
var mdiViewModule = "M16,5V11H21V5M10,11H15V5H10M16,18H21V12H16M10,18H15V12H10M4,18H9V12H4M4,11H9V5H4V11Z";
var mdiViewModuleOutline = "M4 5V18H21V5H4M14 7V10.5H11V7H14M6 7H9V10.5H6V7M6 16V12.5H9V16H6M11 16V12.5H14V16H11M19 16H16V12.5H19V16M16 10.5V7H19V10.5H16Z";
var mdiViewParallel = "M19 3V21H15V3H19M14 3V21H10V3H14M9 3V21H5V3H9Z";
var mdiViewParallelOutline = "M19 3H5V21H19V3M17 19H15V5H17V19M13 19H11V5H13V19M7 5H9V19H7V5Z";
var mdiViewQuilt = "M10,5V11H21V5M16,18H21V12H16M4,18H9V5H4M10,18H15V12H10V18Z";
var mdiViewQuiltOutline = "M4 5V18H21V5H4M6 16V7H9V16H6M11 16V12.5H14V16H11M19 16H16V12.5H19V16M11 10.5V7H19V10.5H11Z";
var mdiViewSequential = "M3 5H21V9H3V5M3 10H21V14H3V10M3 15H21V19H3V15Z";
var mdiViewSequentialOutline = "M3 5V19H21V5H3M19 7V9H5V7H19M19 11V13H5V11H19M5 17V15H19V17H5Z";
var mdiViewSplitHorizontal = "M3,5H21V7H3V5M3,11V9H21V11H3M3,19V13H21V19H3Z";
var mdiViewSplitVertical = "M13,5H21V19H13V5M3,5H11V7H3V5M3,11V9H11V11H3M3,19V17H11V19H3M3,15V13H11V15H3Z";
var mdiViewStream = "M4,5V11H21V5M4,18H21V12H4V18Z";
var mdiViewStreamOutline = "M4 6V18H21V6H4M19 16H6V13H19V16M6 11V8H19V11H6Z";
var mdiViewWeek = "M13,5H10A1,1 0 0,0 9,6V18A1,1 0 0,0 10,19H13A1,1 0 0,0 14,18V6A1,1 0 0,0 13,5M20,5H17A1,1 0 0,0 16,6V18A1,1 0 0,0 17,19H20A1,1 0 0,0 21,18V6A1,1 0 0,0 20,5M6,5H3A1,1 0 0,0 2,6V18A1,1 0 0,0 3,19H6A1,1 0 0,0 7,18V6A1,1 0 0,0 6,5Z";
var mdiViewWeekOutline = "M21 4H3C2.45 4 2 4.45 2 5V19C2 19.55 2.45 20 3 20H21C21.55 20 22 19.55 22 19V5C22 4.45 21.55 4 21 4M8 18H4V6H8V18M14 18H10V6H14V18M20 18H16V6H20V18Z";
var mdiVimeo = "M22,7.42C21.91,9.37 20.55,12.04 17.92,15.44C15.2,19 12.9,20.75 11,20.75C9.85,20.75 8.86,19.67 8.05,17.5C7.5,15.54 7,13.56 6.44,11.58C5.84,9.42 5.2,8.34 4.5,8.34C4.36,8.34 3.84,8.66 2.94,9.29L2,8.07C3,7.2 3.96,6.33 4.92,5.46C6.24,4.32 7.23,3.72 7.88,3.66C9.44,3.5 10.4,4.58 10.76,6.86C11.15,9.33 11.42,10.86 11.57,11.46C12,13.5 12.5,14.5 13.05,14.5C13.47,14.5 14.1,13.86 14.94,12.53C15.78,11.21 16.23,10.2 16.29,9.5C16.41,8.36 15.96,7.79 14.94,7.79C14.46,7.79 13.97,7.9 13.46,8.12C14.44,4.89 16.32,3.32 19.09,3.41C21.15,3.47 22.12,4.81 22,7.42Z";
var mdiViolin = "M11,2A1,1 0 0,0 10,3V5L10,9A0.5,0.5 0 0,0 10.5,9.5H12A0.5,0.5 0 0,1 12.5,10A0.5,0.5 0 0,1 12,10.5H10.5C9.73,10.5 9,9.77 9,9V5.16C7.27,5.6 6,7.13 6,9V10.5A2.5,2.5 0 0,1 8.5,13A2.5,2.5 0 0,1 6,15.5V17C6,19.77 8.23,22 11,22H13C15.77,22 18,19.77 18,17V15.5A2.5,2.5 0 0,1 15.5,13A2.5,2.5 0 0,1 18,10.5V9C18,6.78 16.22,5 14,5V3A1,1 0 0,0 13,2H11M10.75,16.5H13.25L12.75,20H11.25L10.75,16.5Z";
var mdiVirtualReality = "M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5M6,9H7.5L8.5,12.43L9.5,9H11L9.25,15H7.75L6,9M13,9H16.5C17.35,9 18,9.65 18,10.5V11.5C18,12.1 17.6,12.65 17.1,12.9L18,15H16.5L15.65,13H14.5V15H13V9M14.5,10.5V11.5H16.5V10.5H14.5Z";
var mdiVirus = "M19.82 14C20.13 14.45 20.66 14.75 21.25 14.75C22.22 14.75 23 13.97 23 13S22.22 11.25 21.25 11.25C20.66 11.25 20.13 11.55 19.82 12H19C19 10.43 18.5 9 17.6 7.81L18.94 6.47C19.5 6.57 20.07 6.41 20.5 6C21.17 5.31 21.17 4.2 20.5 3.5C19.81 2.83 18.7 2.83 18 3.5C17.59 3.93 17.43 4.5 17.53 5.06L16.19 6.4C15.27 5.71 14.19 5.25 13 5.08V3.68C13.45 3.37 13.75 2.84 13.75 2.25C13.75 1.28 12.97 .5 12 .5S10.25 1.28 10.25 2.25C10.25 2.84 10.55 3.37 11 3.68V5.08C10.1 5.21 9.26 5.5 8.5 5.94L7.39 4.35C7.58 3.83 7.53 3.23 7.19 2.75C6.63 1.96 5.54 1.76 4.75 2.32C3.96 2.87 3.76 3.96 4.32 4.75C4.66 5.24 5.2 5.5 5.75 5.5L6.93 7.18C6.5 7.61 6.16 8.09 5.87 8.62C5.25 8.38 4.5 8.5 4 9C3.33 9.7 3.33 10.8 4 11.5C4.29 11.77 4.64 11.93 5 12L5 12C5 12.54 5.07 13.06 5.18 13.56L3.87 13.91C3.45 13.56 2.87 13.41 2.29 13.56C1.36 13.81 .808 14.77 1.06 15.71C1.31 16.64 2.28 17.19 3.21 16.94C3.78 16.78 4.21 16.36 4.39 15.84L5.9 15.43C6.35 16.22 6.95 16.92 7.65 17.5L6.55 19.5C6 19.58 5.5 19.89 5.21 20.42C4.75 21.27 5.07 22.33 5.92 22.79C6.77 23.25 7.83 22.93 8.29 22.08C8.57 21.56 8.56 20.96 8.31 20.47L9.38 18.5C10.19 18.82 11.07 19 12 19C12.06 19 12.12 19 12.18 19C12.05 19.26 12 19.56 12 19.88C12.08 20.85 12.92 21.57 13.88 21.5S15.57 20.58 15.5 19.62C15.46 19.12 15.21 18.68 14.85 18.39C15.32 18.18 15.77 17.91 16.19 17.6L18.53 19.94C18.43 20.5 18.59 21.07 19 21.5C19.7 22.17 20.8 22.17 21.5 21.5S22.17 19.7 21.5 19C21.07 18.59 20.5 18.43 19.94 18.53L17.6 16.19C18.09 15.54 18.47 14.8 18.71 14H19.82M10.5 12C9.67 12 9 11.33 9 10.5S9.67 9 10.5 9 12 9.67 12 10.5 11.33 12 10.5 12M14 15C13.45 15 13 14.55 13 14C13 13.45 13.45 13 14 13S15 13.45 15 14C15 14.55 14.55 15 14 15Z";
var mdiVirusOff = "M7.42 4.22L5.28 2.08C5.97 1.88 6.75 2.12 7.19 2.75C7.5 3.19 7.56 3.73 7.42 4.22M21.25 11.25C20.66 11.25 20.13 11.55 19.82 12H19C19 10.43 18.5 9 17.6 7.81L18.94 6.47C19.5 6.57 20.07 6.41 20.5 6C21.17 5.31 21.17 4.2 20.5 3.5C19.81 2.83 18.7 2.83 18 3.5C17.59 3.93 17.43 4.5 17.53 5.06L16.19 6.4C15.27 5.71 14.19 5.25 13 5.08V3.68C13.45 3.37 13.75 2.84 13.75 2.25C13.75 1.28 12.97 .5 12 .5S10.25 1.28 10.25 2.25C10.25 2.84 10.55 3.37 11 3.68V5.08C10.26 5.19 9.57 5.41 8.92 5.72L18.28 15.08C18.45 14.73 18.6 14.38 18.71 14H19.82C20.13 14.45 20.66 14.75 21.25 14.75C22.22 14.75 23 13.97 23 13S22.22 11.25 21.25 11.25M22.11 21.46L20.84 22.73L20.1 22C19.7 21.96 19.31 21.8 19 21.5C18.7 21.19 18.54 20.8 18.5 20.4L15.9 17.79C15.57 18 15.22 18.23 14.85 18.39C15.21 18.68 15.46 19.12 15.5 19.62C15.57 20.58 14.84 21.43 13.88 21.5S12.08 20.85 12 19.88C12 19.56 12.05 19.26 12.18 19H12C11.07 19 10.19 18.82 9.38 18.5L8.31 20.47C8.56 20.96 8.57 21.56 8.29 22.08C7.83 22.93 6.77 23.25 5.92 22.79C5.07 22.33 4.75 21.27 5.21 20.42C5.5 19.89 6 19.58 6.55 19.5L7.65 17.5C6.95 16.92 6.35 16.22 5.9 15.43L4.39 15.84C4.21 16.36 3.78 16.78 3.21 16.94C2.28 17.19 1.31 16.64 1.06 15.71C.808 14.77 1.36 13.81 2.29 13.56C2.87 13.41 3.45 13.56 3.87 13.91L5.18 13.56C5.07 13.06 5 12.54 5 12C4.64 11.93 4.29 11.77 4 11.5C3.33 10.8 3.33 9.7 4 9C4.5 8.5 5.25 8.38 5.87 8.62C5.97 8.44 6.09 8.27 6.2 8.09L1.11 3L2.39 1.73L22.11 21.46Z";
var mdiVirusOffOutline = "M23 13C23 13.97 22.22 14.75 21.25 14.75C20.66 14.75 20.13 14.45 19.82 14H18.71C18.6 14.38 18.45 14.73 18.28 15.08L16.73 13.53C16.89 13.05 17 12.54 17 12C17 9.24 14.76 7 12 7C11.46 7 10.95 7.11 10.47 7.27L8.92 5.72C9.57 5.41 10.26 5.19 11 5.08V3.68C10.55 3.37 10.25 2.84 10.25 2.25C10.25 1.28 11.03 .5 12 .5S13.75 1.28 13.75 2.25C13.75 2.84 13.45 3.37 13 3.68V5.08C14.19 5.25 15.27 5.71 16.19 6.4L17.53 5.06C17.43 4.5 17.59 3.93 18 3.5C18.35 3.17 18.8 3 19.25 3S20.15 3.17 20.5 3.5C21.17 4.2 21.17 5.31 20.5 6C20.15 6.33 19.7 6.5 19.25 6.5C19.15 6.5 19.05 6.5 18.94 6.47L17.6 7.81C18.5 9 19 10.43 19 12H19.82C20.13 11.55 20.66 11.25 21.25 11.25C22.22 11.25 23 12.03 23 13M22.11 21.46L20.84 22.73L20.1 22C19.7 21.95 19.31 21.79 19 21.5C18.7 21.19 18.54 20.8 18.5 20.4L15.9 17.79C15.57 18 15.22 18.23 14.85 18.39C15.21 18.68 15.46 19.12 15.5 19.62C15.57 20.58 14.85 21.42 13.88 21.5H13.75C12.84 21.5 12.08 20.8 12 19.88C12 19.56 12.05 19.26 12.18 19H12C11.07 19 10.19 18.82 9.38 18.5L8.31 20.47C8.56 20.96 8.57 21.56 8.29 22.08C7.97 22.67 7.37 23 6.75 23C6.47 23 6.18 22.93 5.92 22.79C5.07 22.33 4.75 21.27 5.21 20.42C5.5 19.89 6 19.58 6.55 19.5L7.65 17.5C6.95 16.92 6.35 16.22 5.9 15.43L4.39 15.84C4.21 16.36 3.78 16.78 3.21 16.94C3.05 17 2.9 17 2.75 17C2 17 1.27 16.5 1.06 15.71C.809 14.77 1.36 13.81 2.29 13.56C2.44 13.5 2.6 13.5 2.75 13.5C3.16 13.5 3.56 13.65 3.87 13.91L5.18 13.56C5.07 13.06 5 12.54 5 12C4.64 11.92 4.29 11.77 4 11.5C3.33 10.8 3.33 9.7 4 9C4.35 8.67 4.8 8.5 5.25 8.5C5.46 8.5 5.67 8.54 5.87 8.62C5.97 8.44 6.09 8.27 6.2 8.09L1.11 3L2.39 1.73L22.11 21.46M14.45 16.34L7.66 9.55C7.25 10.28 7 11.11 7 12C7 14.76 9.24 17 12 17C12.9 17 13.73 16.75 14.45 16.34M7.19 2.75C6.84 2.26 6.3 2 5.75 2C5.59 2 5.43 2.03 5.27 2.07L7.42 4.22C7.56 3.73 7.5 3.19 7.19 2.75Z";
var mdiVirusOutline = "M12 .5C11.03 .5 10.25 1.28 10.25 2.25C10.25 2.84 10.55 3.37 11 3.68V5.08C10.1 5.21 9.26 5.5 8.5 5.94L7.39 4.35C7.58 3.83 7.53 3.23 7.19 2.75C6.84 2.26 6.3 2 5.75 2C5.4 2 5.05 2.1 4.75 2.32C3.96 2.87 3.76 3.96 4.32 4.75C4.66 5.24 5.2 5.5 5.75 5.5L6.93 7.18C6.5 7.61 6.16 8.09 5.87 8.62C5.67 8.54 5.46 8.5 5.25 8.5C4.8 8.5 4.35 8.67 4 9C3.33 9.7 3.33 10.8 4 11.5C4.29 11.77 4.64 11.92 5 12L5 12C5 12.54 5.07 13.06 5.18 13.56L3.87 13.91C3.56 13.65 3.16 13.5 2.75 13.5C2.6 13.5 2.44 13.5 2.29 13.56C1.36 13.81 .809 14.77 1.06 15.71C1.27 16.5 2 17 2.75 17C2.9 17 3.05 17 3.21 16.94C3.78 16.78 4.21 16.36 4.39 15.84L5.9 15.43C6.35 16.22 6.95 16.92 7.65 17.5L6.55 19.5C6 19.58 5.5 19.89 5.21 20.42C4.75 21.27 5.07 22.33 5.92 22.79C6.18 22.93 6.47 23 6.75 23C7.37 23 7.97 22.67 8.29 22.08C8.57 21.56 8.56 20.96 8.31 20.47L9.38 18.5C10.19 18.82 11.07 19 12 19C12.06 19 12.12 19 12.18 19C12.05 19.26 12 19.56 12 19.88C12.08 20.8 12.84 21.5 13.75 21.5C13.79 21.5 13.84 21.5 13.88 21.5C14.85 21.42 15.57 20.58 15.5 19.62C15.46 19.12 15.21 18.68 14.85 18.39C15.32 18.18 15.77 17.91 16.19 17.6L18.53 19.94C18.43 20.5 18.59 21.07 19 21.5C19.35 21.83 19.8 22 20.25 22S21.15 21.83 21.5 21.5C22.17 20.8 22.17 19.7 21.5 19C21.15 18.67 20.7 18.5 20.25 18.5C20.15 18.5 20.05 18.5 19.94 18.53L17.6 16.19C18.09 15.54 18.47 14.8 18.71 14H19.82C20.13 14.45 20.66 14.75 21.25 14.75C22.22 14.75 23 13.97 23 13S22.22 11.25 21.25 11.25C20.66 11.25 20.13 11.55 19.82 12H19C19 10.43 18.5 9 17.6 7.81L18.94 6.47C19.05 6.5 19.15 6.5 19.25 6.5C19.7 6.5 20.15 6.33 20.5 6C21.17 5.31 21.17 4.2 20.5 3.5C20.15 3.17 19.7 3 19.25 3S18.35 3.17 18 3.5C17.59 3.93 17.43 4.5 17.53 5.06L16.19 6.4C15.27 5.71 14.19 5.25 13 5.08V3.68C13.45 3.37 13.75 2.84 13.75 2.25C13.75 1.28 12.97 .5 12 .5M12 17C9.24 17 7 14.76 7 12S9.24 7 12 7 17 9.24 17 12 14.76 17 12 17M10.5 9C9.67 9 9 9.67 9 10.5S9.67 12 10.5 12 12 11.33 12 10.5 11.33 9 10.5 9M14 13C13.45 13 13 13.45 13 14C13 14.55 13.45 15 14 15C14.55 15 15 14.55 15 14C15 13.45 14.55 13 14 13Z";
var mdiVlc = "M12,1C11.58,1 11.19,1.23 11,1.75L9.88,4.88C10.36,5.4 11.28,5.5 12,5.5C12.72,5.5 13.64,5.4 14.13,4.88L13,1.75C12.82,1.25 12.42,1 12,1M8.44,8.91L7,12.91C8.07,14.27 10.26,14.5 12,14.5C13.74,14.5 15.93,14.27 17,12.91L15.56,8.91C14.76,9.83 13.24,10 12,10C10.76,10 9.24,9.83 8.44,8.91M5.44,15C4.62,15 3.76,15.65 3.53,16.44L2.06,21.56C1.84,22.35 2.3,23 3.13,23H20.88C21.7,23 22.16,22.35 21.94,21.56L20.47,16.44C20.24,15.65 19.38,15 18.56,15H17.75L18.09,15.97C18.21,16.29 18.29,16.69 18.09,16.97C16.84,18.7 14.14,19 12,19C9.86,19 7.16,18.7 5.91,16.97C5.71,16.69 5.79,16.29 5.91,15.97L6.25,15H5.44Z";
var mdiVoicemail = "M18.5,15A3.5,3.5 0 0,1 15,11.5A3.5,3.5 0 0,1 18.5,8A3.5,3.5 0 0,1 22,11.5A3.5,3.5 0 0,1 18.5,15M5.5,15A3.5,3.5 0 0,1 2,11.5A3.5,3.5 0 0,1 5.5,8A3.5,3.5 0 0,1 9,11.5A3.5,3.5 0 0,1 5.5,15M18.5,6A5.5,5.5 0 0,0 13,11.5C13,12.83 13.47,14.05 14.26,15H9.74C10.53,14.05 11,12.83 11,11.5A5.5,5.5 0 0,0 5.5,6A5.5,5.5 0 0,0 0,11.5A5.5,5.5 0 0,0 5.5,17H18.5A5.5,5.5 0 0,0 24,11.5A5.5,5.5 0 0,0 18.5,6Z";
var mdiVolcano = "M18 8H11L9 13H6L2 22H22L18 8M13 1H15V5H13V1M16.12 5.47L18.95 2.64L20.36 4.05L17.54 6.88L16.12 5.47M7.64 4.05L9.05 2.64L11.88 5.46L10.47 6.88L7.64 4.05Z";
var mdiVolcanoOutline = "M18 8H11L9 13H6L2 22H22L18 8M7.3 15H10.35L10.85 13.74L12.35 10H16.5L19.35 20H5.08L7.3 15M13 1H15V5H13V1M16.12 5.47L18.95 2.64L20.36 4.05L17.54 6.88L16.12 5.47M7.64 4.05L9.05 2.64L11.88 5.46L10.47 6.88L7.64 4.05Z";
var mdiVolleyball = "M19.04 4.85C17.34 3.2 15.33 2.25 13 2V5.62L22 10.8C21.72 8.5 20.73 6.5 19.04 4.85M12 22C15.44 22 18.16 20.62 20.17 17.86L17.06 16L8.07 21.2C9.32 21.73 10.64 22 12 22M13 11.41L21.15 16.07C21.59 15.13 21.88 14.14 22 13.11L13 7.93V11.41M3.88 17.81C4.54 18.72 5.26 19.46 6.05 20L15.04 14.9L12 13.15L3.88 17.81M11.04 2C10 2.09 9 2.36 8 2.8V13.15L11.04 11.41V2M2 12C2 13.39 2.3 14.77 2.89 16.12L6 14.28V4C3.33 6 2 8.65 2 12Z";
var mdiVolumeEqual = "M3 9H7L12 4V20L7 15H3V9M14 13H22V15H14M14 9H22V11H14Z";
var mdiVolumeHigh = "M14,3.23V5.29C16.89,6.15 19,8.83 19,12C19,15.17 16.89,17.84 14,18.7V20.77C18,19.86 21,16.28 21,12C21,7.72 18,4.14 14,3.23M16.5,12C16.5,10.23 15.5,8.71 14,7.97V16C15.5,15.29 16.5,13.76 16.5,12M3,9V15H7L12,20V4L7,9H3Z";
var mdiVolumeLow = "M7,9V15H11L16,20V4L11,9H7Z";
var mdiVolumeMedium = "M5,9V15H9L14,20V4L9,9M18.5,12C18.5,10.23 17.5,8.71 16,7.97V16C17.5,15.29 18.5,13.76 18.5,12Z";
var mdiVolumeMinus = "M3,9H7L12,4V20L7,15H3V9M14,11H22V13H14V11Z";
var mdiVolumeMute = "M3,9H7L12,4V20L7,15H3V9M16.59,12L14,9.41L15.41,8L18,10.59L20.59,8L22,9.41L19.41,12L22,14.59L20.59,16L18,13.41L15.41,16L14,14.59L16.59,12Z";
var mdiVolumeOff = "M12,4L9.91,6.09L12,8.18M4.27,3L3,4.27L7.73,9H3V15H7L12,20V13.27L16.25,17.53C15.58,18.04 14.83,18.46 14,18.7V20.77C15.38,20.45 16.63,19.82 17.68,18.96L19.73,21L21,19.73L12,10.73M19,12C19,12.94 18.8,13.82 18.46,14.64L19.97,16.15C20.62,14.91 21,13.5 21,12C21,7.72 18,4.14 14,3.23V5.29C16.89,6.15 19,8.83 19,12M16.5,12C16.5,10.23 15.5,8.71 14,7.97V10.18L16.45,12.63C16.5,12.43 16.5,12.21 16.5,12Z";
var mdiVolumePlus = "M3,9H7L12,4V20L7,15H3V9M14,11H17V8H19V11H22V13H19V16H17V13H14V11Z";
var mdiVolumeSource = "M3 9V15H7L12 20V4L7 9H3M16 15H14V9H16V15M20 19H18V5H20V19Z";
var mdiVolumeVariantOff = "M5.64,3.64L21.36,19.36L19.95,20.78L16,16.83V20L11,15H7V9H8.17L4.22,5.05L5.64,3.64M16,4V11.17L12.41,7.58L16,4Z";
var mdiVolumeVibrate = "M4 9V15H8L13 20V4L8 9H4M16.55 2.47L15.5 3.53L17.93 6L15 9L17.93 12L15 15L17.93 18L15.5 20.47L16.55 21.53L20 18L17.07 15L20 12L17.07 9L20 6L16.55 2.47Z";
var mdiVote = "M18,13H17.32L15.32,15H17.23L19,17H5L6.78,15H8.83L6.83,13H6L3,16V20A2,2 0 0,0 5,22H19A2,2 0 0,0 21,20V16L18,13M17,7.95L12.05,12.9L8.5,9.36L13.46,4.41L17,7.95M12.76,2.29L6.39,8.66C6,9.05 6,9.68 6.39,10.07L11.34,15C11.73,15.41 12.36,15.41 12.75,15L19.11,8.66C19.5,8.27 19.5,7.64 19.11,7.25L14.16,2.3C13.78,1.9 13.15,1.9 12.76,2.29Z";
var mdiVoteOutline = "M18,13L21,16V20C21,21.11 20.1,22 19,22H5C3.89,22 3,21.1 3,20V16L6,13H6.83L8.83,15H6.78L5,17H19L17.23,15H15.32L17.32,13H18M19,20V19H5V20H19M11.34,15L6.39,10.07C6,9.68 6,9.05 6.39,8.66L12.76,2.29C13.15,1.9 13.78,1.9 14.16,2.3L19.11,7.25C19.5,7.64 19.5,8.27 19.11,8.66L12.75,15C12.36,15.41 11.73,15.41 11.34,15M13.46,4.41L8.5,9.36L12.05,12.9L17,7.95L13.46,4.41Z";
var mdiVpn = "M9,5H15L12,8L9,5M10.5,14.66C10.2,15 10,15.5 10,16A2,2 0 0,0 12,18A2,2 0 0,0 14,16C14,15.45 13.78,14.95 13.41,14.59L14.83,13.17C15.55,13.9 16,14.9 16,16A4,4 0 0,1 12,20A4,4 0 0,1 8,16C8,14.93 8.42,13.96 9.1,13.25L9.09,13.24L16.17,6.17V6.17C16.89,5.45 17.89,5 19,5A4,4 0 0,1 23,9A4,4 0 0,1 19,13C17.9,13 16.9,12.55 16.17,11.83L17.59,10.41C17.95,10.78 18.45,11 19,11A2,2 0 0,0 21,9A2,2 0 0,0 19,7C18.45,7 17.95,7.22 17.59,7.59L10.5,14.66M6.41,7.59C6.05,7.22 5.55,7 5,7A2,2 0 0,0 3,9A2,2 0 0,0 5,11C5.55,11 6.05,10.78 6.41,10.41L7.83,11.83C7.1,12.55 6.1,13 5,13A4,4 0 0,1 1,9A4,4 0 0,1 5,5C6.11,5 7.11,5.45 7.83,6.17V6.17L10.59,8.93L9.17,10.35L6.41,7.59Z";
var mdiVuejs = "M2,3H5.5L12,15L18.5,3H22L12,21L2,3M6.5,3H9.5L12,7.58L14.5,3H17.5L12,13.08L6.5,3Z";
var mdiVuetify = "M12,11.64L7.92,2H16.08L12,11.64M12,21.95L3.27,4.91H7.84L12,14.47L16.16,4.91H20.73L12,21.95Z";
var mdiWalk = "M14.12,10H19V8.2H15.38L13.38,4.87C13.08,4.37 12.54,4.03 11.92,4.03C11.74,4.03 11.58,4.06 11.42,4.11L6,5.8V11H7.8V7.33L9.91,6.67L6,22H7.8L10.67,13.89L13,17V22H14.8V15.59L12.31,11.05L13.04,8.18M14,3.8C15,3.8 15.8,3 15.8,2C15.8,1 15,0.2 14,0.2C13,0.2 12.2,1 12.2,2C12.2,3 13,3.8 14,3.8Z";
var mdiWall = "M3,16H12V21H3V16M2,10H8V15H2V10M9,10H15V15H9V10M16,10H22V15H16V10M13,16H21V21H13V16M3,4H11V9H3V4M12,4H21V9H12V4Z";
var mdiWallFire = "M22.14 15.34L22.12 15.35C22.35 15.63 22.55 15.94 22.7 16.27L22.79 16.46C23.5 18.15 23 20.1 21.69 21.32C20.5 22.41 18.84 22.7 17.3 22.5C15.84 22.32 14.5 21.4 13.73 20.13C13.5 19.74 13.3 19.3 13.2 18.85C13.07 18.5 13.03 18.12 13 17.75C12.91 16.15 13.55 14.45 14.76 13.45C14.21 14.66 14.34 16.17 15.15 17.22L15.26 17.35C15.4 17.47 15.57 17.5 15.73 17.44C15.88 17.38 16 17.23 16 17.07L15.93 16.83C15.05 14.5 15.79 11.8 17.66 10.27C18.17 9.85 18.8 9.47 19.46 9.3C18.78 10.66 19 12.44 20.09 13.5C20.55 14 21.11 14.29 21.58 14.73L22.14 15.34M19.86 20L19.85 19.97C20.3 19.58 20.55 18.91 20.53 18.31L20.5 18C20.3 17 19.43 16.66 18.87 15.93L18.44 15.15C18.22 15.65 18.2 16.12 18.29 16.66C18.39 17.23 18.61 17.72 18.5 18.31C18.34 18.96 17.83 19.61 16.94 19.82C17.44 20.31 18.25 20.7 19.06 20.42C19.32 20.35 19.65 20.16 19.86 20M3 16H11.06L11 17C11 18.41 11.36 19.73 12 20.88V21H3V16M2 10H8V15H2V10M9 10H15V10.07C13.17 11.13 11.79 12.9 11.25 15H9V10M3 4H11V9H3V4M12 4H21V9H12V4Z";
var mdiWallSconce = "M11,4L7,13H19L15,4H11M4,14V22H6V19H14V14H12V17H6V14H4Z";
var mdiWallSconceFlat = "M5,5V11H19V5H5M5.27,13.32L3.5,15.09L4.91,16.5L6.68,14.73L5.27,13.32M18.73,13.32L17.32,14.73L19.09,16.5L20.5,15.09L18.73,13.32M11,16V19H13V16H11Z";
var mdiWallSconceFlatOutline = "M5 5V11H19V5H5M17 9H7V7H17V9M5.27 13.32L3.5 15.09L4.91 16.5L6.68 14.73L5.27 13.32M18.73 13.32L17.32 14.73L19.09 16.5L20.5 15.09L18.73 13.32M11 16V19H13V16H11Z";
var mdiWallSconceFlatVariant = "M19 19V13H5V19H19M18.73 10.68L20.5 8.91L19.09 7.5L17.32 9.27L18.73 10.68M5.27 10.68L6.68 9.27L4.91 7.5L3.5 8.91L5.27 10.68M13 8V5H11V8H13Z";
var mdiWallSconceFlatVariantOutline = "M5 13V19H19V13H5M17 17H7V15H17V17M18.73 10.68L20.5 8.91L19.09 7.5L17.32 9.27L18.73 10.68M5.27 10.68L6.68 9.27L4.91 7.5L3.5 8.91L5.27 10.68M13 8V5H11V8H13Z";
var mdiWallSconceOutline = "M13.7 6L15.92 11H10.08L12.3 6H13.7M15 4H11L7 13H19L15 4M4 14V22H6V19H14V14H12V17H6V14H4Z";
var mdiWallSconceRound = "M13 19V16H11V19H13M19.09 16.5L20.5 15.09L18.73 13.32L17.32 14.73L19.09 16.5M4.91 16.5L6.68 14.73L5.27 13.32L3.5 15.09L4.91 16.5M20 12C20 9.14 18.5 6.5 16 5.07S10.5 3.64 8 5.07 4 9.14 4 12H20Z";
var mdiWallSconceRoundOutline = "M13 19V16H11V19H13M19.09 16.5L20.5 15.09L18.73 13.32L17.32 14.73L19.09 16.5M4.91 16.5L6.68 14.73L5.27 13.32L3.5 15.09L4.91 16.5M12 6C13.04 6 14.08 6.28 15 6.81C16.26 7.5 17.19 8.67 17.66 10H6.34C6.81 8.67 7.74 7.5 9 6.81C9.92 6.28 10.96 6 12 6M12 4C10.63 4 9.25 4.36 8 5.07C5.5 6.5 4 9.14 4 12H20C20 9.14 18.5 6.5 16 5.07C14.75 4.36 13.38 4 12 4Z";
var mdiWallSconceRoundVariant = "M11 5V8H13V5H11M4.91 7.5L3.5 8.91L5.27 10.68L6.68 9.27L4.91 7.5M19.09 7.5L17.32 9.27L18.73 10.68L20.5 8.91L19.09 7.5M4 12C4 14.86 5.5 17.5 8 18.93S13.5 20.36 16 18.93 20 14.86 20 12H4Z";
var mdiWallSconceRoundVariantOutline = "M11 5V8H13V5H11M4.91 7.5L3.5 8.91L5.27 10.68L6.68 9.27L4.91 7.5M19.09 7.5L17.32 9.27L18.73 10.68L20.5 8.91L19.09 7.5M17.66 14C17.19 15.33 16.26 16.5 15 17.19C14.08 17.72 13.04 18 12 18S9.92 17.72 9 17.19C7.74 16.5 6.81 15.33 6.34 14H17.66M20 12H4C4 14.86 5.5 17.5 8 18.93C9.25 19.65 10.63 20 12 20S14.75 19.65 16 18.93C18.5 17.5 20 14.86 20 12Z";
var mdiWallet = "M21,18V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V6H12C10.89,6 10,6.9 10,8V16A2,2 0 0,0 12,18M12,16H22V8H12M16,13.5A1.5,1.5 0 0,1 14.5,12A1.5,1.5 0 0,1 16,10.5A1.5,1.5 0 0,1 17.5,12A1.5,1.5 0 0,1 16,13.5Z";
var mdiWalletBifold = "M17 3H7C4.79 3 3 4.79 3 7V17C3 19.21 4.79 21 7 21H19C20.11 21 21 20.11 21 19V9C21 7.9 20.11 7 19 7V5C19 3.9 18.11 3 17 3M17 5V7H7C6.27 7 5.59 7.2 5 7.54V7C5 5.9 5.9 5 7 5M15.5 15.5C14.67 15.5 14 14.83 14 14S14.67 12.5 15.5 12.5 17 13.17 17 14 16.33 15.5 15.5 15.5Z";
var mdiWalletBifoldOutline = "M15.5 15.5C16.33 15.5 17 14.83 17 14C17 13.17 16.33 12.5 15.5 12.5C14.67 12.5 14 13.17 14 14C14 14.83 14.67 15.5 15.5 15.5M7 3H17C18.11 3 19 3.9 19 5V7C20.11 7 21 7.9 21 9V19C21 20.11 20.11 21 19 21H7C4.79 21 3 19.21 3 17V7C3 4.79 4.79 3 7 3M17 7V5H7C5.9 5 5 5.9 5 7V7.54C5.59 7.2 6.27 7 7 7H17M5 17C5 18.11 5.9 19 7 19H19V9H7C5.9 9 5 9.9 5 11V17Z";
var mdiWalletGiftcard = "M20,14H4V8H9.08L7,10.83L8.62,12L11,8.76L12,7.4L13,8.76L15.38,12L17,10.83L14.92,8H20M20,19H4V17H20M9,4A1,1 0 0,1 10,5A1,1 0 0,1 9,6A1,1 0 0,1 8,5A1,1 0 0,1 9,4M15,4A1,1 0 0,1 16,5A1,1 0 0,1 15,6A1,1 0 0,1 14,5A1,1 0 0,1 15,4M20,6H17.82C17.93,5.69 18,5.35 18,5A3,3 0 0,0 15,2C13.95,2 13.04,2.54 12.5,3.35L12,4L11.5,3.34C10.96,2.54 10.05,2 9,2A3,3 0 0,0 6,5C6,5.35 6.07,5.69 6.18,6H4C2.89,6 2,6.89 2,8V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V8C22,6.89 21.11,6 20,6Z";
var mdiWalletMembership = "M20,10H4V4H20M20,15H4V13H20M20,2H4C2.89,2 2,2.89 2,4V15C2,16.11 2.89,17 4,17H8V22L12,20L16,22V17H20C21.11,17 22,16.11 22,15V4C22,2.89 21.11,2 20,2Z";
var mdiWalletOutline = "M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V16.72C21.59,16.37 22,15.74 22,15V9C22,8.26 21.59,7.63 21,7.28V5A2,2 0 0,0 19,3H5M5,5H19V7H13A2,2 0 0,0 11,9V15A2,2 0 0,0 13,17H19V19H5V5M13,9H20V15H13V9M16,10.5A1.5,1.5 0 0,0 14.5,12A1.5,1.5 0 0,0 16,13.5A1.5,1.5 0 0,0 17.5,12A1.5,1.5 0 0,0 16,10.5Z";
var mdiWalletPlus = "M3 0V3H0V5H3V8H5V5H8V3H5V0H3M9 3V6H6V9H3V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.11 21 19V18H12C10.9 18 10 17.11 10 16V8C10 6.9 10.89 6 12 6H21V5C21 3.9 20.11 3 19 3H9M12 8V16H22V8H12M16 10.5C16.83 10.5 17.5 11.17 17.5 12C17.5 12.83 16.83 13.5 16 13.5C15.17 13.5 14.5 12.83 14.5 12C14.5 11.17 15.17 10.5 16 10.5Z";
var mdiWalletPlusOutline = "M3 0V3H0V5H3V8H5V5H8V3H5V0H3M10 3V5H19V7H13C11.9 7 11 7.9 11 9V15C11 16.1 11.9 17 13 17H19V19H5V10H3V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V16.72C21.59 16.37 22 15.74 22 15V9C22 8.26 21.59 7.63 21 7.28V5C21 3.9 20.1 3 19 3H10M13 9H20V15H13V9M16 10.5A1.5 1.5 0 0 0 14.5 12A1.5 1.5 0 0 0 16 13.5A1.5 1.5 0 0 0 17.5 12A1.5 1.5 0 0 0 16 10.5Z";
var mdiWalletTravel = "M20,14H4V8H7V10H9V8H15V10H17V8H20M20,19H4V17H20M9,4H15V6H9M20,6H17V4C17,2.89 16.11,2 15,2H9C7.89,2 7,2.89 7,4V6H4C2.89,6 2,6.89 2,8V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V8C22,6.89 21.11,6 20,6Z";
var mdiWallpaper = "M4,4H11V2H4A2,2 0 0,0 2,4V11H4V4M10,13L6,18H18L15,14L12.97,16.71L10,13M17,8.5A1.5,1.5 0 0,0 15.5,7A1.5,1.5 0 0,0 14,8.5A1.5,1.5 0 0,0 15.5,10A1.5,1.5 0 0,0 17,8.5M20,2H13V4H20V11H22V4A2,2 0 0,0 20,2M20,20H13V22H20A2,2 0 0,0 22,20V13H20V20M4,13H2V20A2,2 0 0,0 4,22H11V20H4V13Z";
var mdiWan = "M12,2A8,8 0 0,0 4,10C4,14.03 7,17.42 11,17.93V19H10A1,1 0 0,0 9,20H2V22H9A1,1 0 0,0 10,23H14A1,1 0 0,0 15,22H22V20H15A1,1 0 0,0 14,19H13V17.93C17,17.43 20,14.03 20,10A8,8 0 0,0 12,2M12,4C12,4 12.74,5.28 13.26,7H10.74C11.26,5.28 12,4 12,4M9.77,4.43C9.5,4.93 9.09,5.84 8.74,7H6.81C7.5,5.84 8.5,4.93 9.77,4.43M14.23,4.44C15.5,4.94 16.5,5.84 17.19,7H15.26C14.91,5.84 14.5,4.93 14.23,4.44M6.09,9H8.32C8.28,9.33 8.25,9.66 8.25,10C8.25,10.34 8.28,10.67 8.32,11H6.09C6.03,10.67 6,10.34 6,10C6,9.66 6.03,9.33 6.09,9M10.32,9H13.68C13.72,9.33 13.75,9.66 13.75,10C13.75,10.34 13.72,10.67 13.68,11H10.32C10.28,10.67 10.25,10.34 10.25,10C10.25,9.66 10.28,9.33 10.32,9M15.68,9H17.91C17.97,9.33 18,9.66 18,10C18,10.34 17.97,10.67 17.91,11H15.68C15.72,10.67 15.75,10.34 15.75,10C15.75,9.66 15.72,9.33 15.68,9M6.81,13H8.74C9.09,14.16 9.5,15.07 9.77,15.56C8.5,15.06 7.5,14.16 6.81,13M10.74,13H13.26C12.74,14.72 12,16 12,16C12,16 11.26,14.72 10.74,13M15.26,13H17.19C16.5,14.16 15.5,15.07 14.23,15.57C14.5,15.07 14.91,14.16 15.26,13Z";
var mdiWardrobe = "M4 4V19C4 20.1 4.9 21 6 21V22H8V21H11.5V2H6C4.9 2 4 2.9 4 4M8 10H10V13H8V10M18 2H12.5V21H16V22H18V21C19.1 21 20 20.1 20 19V4C20 2.9 19.1 2 18 2M16 13H14V10H16V13Z";
var mdiWardrobeOutline = "M6 2C4.89 2 4 2.9 4 4V19C4 20.11 4.89 21 6 21V22H8V21H16V22H18V21C19.11 21 20 20.11 20 19V4C20 2.9 19.11 2 18 2H6M6 4H11V19H6V4M13 4H18V19H13V4M8 10V13H10V10H8M14 10V13H16V10H14Z";
var mdiWarehouse = "M6 19H8V21H6V19M12 3L2 8V21H4V13H20V21H22V8L12 3M8 11H4V9H8V11M14 11H10V9H14V11M20 11H16V9H20V11M6 15H8V17H6V15M10 15H12V17H10V15M10 19H12V21H10V19M14 19H16V21H14V19Z";
var mdiWashingMachine = "M14.83,11.17C16.39,12.73 16.39,15.27 14.83,16.83C13.27,18.39 10.73,18.39 9.17,16.83L14.83,11.17M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M7,4A1,1 0 0,0 6,5A1,1 0 0,0 7,6A1,1 0 0,0 8,5A1,1 0 0,0 7,4M10,4A1,1 0 0,0 9,5A1,1 0 0,0 10,6A1,1 0 0,0 11,5A1,1 0 0,0 10,4M12,8A6,6 0 0,0 6,14A6,6 0 0,0 12,20A6,6 0 0,0 18,14A6,6 0 0,0 12,8Z";
var mdiWashingMachineAlert = "M12.83 11.17C14.39 12.73 14.39 15.27 12.83 16.83S8.73 18.39 7.17 16.83L12.83 11.17M4 2H16C17.11 2 18 2.9 18 4V20C18 21.11 17.11 22 16 22H4C2.9 22 2 21.11 2 20V4C2 2.9 2.9 2 4 2M5 4C4.45 4 4 4.45 4 5S4.45 6 5 6 6 5.55 6 5 5.55 4 5 4M8 4C7.45 4 7 4.45 7 5S7.45 6 8 6 9 5.55 9 5 8.55 4 8 4M10 8C6.69 8 4 10.69 4 14S6.69 20 10 20 16 17.31 16 14 13.31 8 10 8M20 15H22V17H20V15M20 7H22V13H20V7Z";
var mdiWashingMachineOff = "M22.11 21.46L2.39 1.73L1.11 3L4 5.89V20C4 21.11 4.89 22 6 22H18C18.58 22 19.1 21.75 19.46 21.35L20.84 22.73L22.11 21.46M12 20C8.69 20 6 17.31 6 14C6 12.32 6.7 10.8 7.82 9.71L12.06 13.95L9.17 16.83C10.73 18.39 13.27 18.39 14.83 16.83C14.85 16.81 14.86 16.79 14.88 16.77L16.29 18.18C15.2 19.3 13.69 20 12 20M11.25 8.05C11.5 8 11.75 8 12 8C15.31 8 18 10.69 18 14C18 14.25 18 14.5 17.95 14.75L20 16.8V4C20 2.9 19.11 2 18 2H6C5.76 2 5.54 2.05 5.33 2.13L11.25 8.05M10 4C10.55 4 11 4.45 11 5S10.55 6 10 6 9 5.55 9 5 9.45 4 10 4Z";
var mdiWatch = "M6,12A6,6 0 0,1 12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12M20,12C20,9.45 18.81,7.19 16.95,5.73L16,0H8L7.05,5.73C5.19,7.19 4,9.45 4,12C4,14.54 5.19,16.81 7.05,18.27L8,24H16L16.95,18.27C18.81,16.81 20,14.54 20,12Z";
var mdiWatchExport = "M14,11H19L16.5,8.5L17.92,7.08L22.84,12L17.92,16.92L16.5,15.5L19,13H14V11M12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.4,6 14.69,6.5 15.71,7.29L17.13,5.87L16.95,5.73L16,0H8L7.05,5.73C5.19,7.19 4,9.46 4,12C4,14.55 5.19,16.81 7.05,18.27L8,24H16L16.95,18.27L17.13,18.13L15.71,16.71C14.69,17.5 13.4,18 12,18Z";
var mdiWatchExportVariant = "M14,11H19L16.5,8.5L17.92,7.08L22.84,12L17.92,16.92L16.5,15.5L19,13H14V11M8,0H16L16.83,5H17C17.28,5 17.54,5.06 17.78,5.16L15.94,7H7V17H15.94L17.78,18.84C17.54,18.94 17.28,19 17,19H16.83L16,24H8L7.17,19H7A2,2 0 0,1 5,17V7C5,5.89 5.9,5 7,5H7.17L8,0Z";
var mdiWatchImport = "M2,11H7L4.5,8.5L5.92,7.08L10.84,12L5.92,16.92L4.5,15.5L7,13H2V11M12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6C10.6,6 9.31,6.5 8.29,7.29L6.87,5.87L7.05,5.73L8,0H16L16.95,5.73C18.81,7.19 20,9.45 20,12C20,14.54 18.81,16.81 16.95,18.27L16,24H8L7.05,18.27L6.87,18.13L8.29,16.71C9.31,17.5 10.6,18 12,18Z";
var mdiWatchImportVariant = "M1,11H6L3.5,8.5L4.92,7.08L9.84,12L4.92,16.92L3.5,15.5L6,13H1V11M8,0H16L16.83,5H17A2,2 0 0,1 19,7V17C19,18.11 18.1,19 17,19H16.83L16,24H8L7.17,19H7C6.46,19 6,18.79 5.62,18.44L7.06,17H17V7H7.06L5.62,5.56C6,5.21 6.46,5 7,5H7.17L8,0Z";
var mdiWatchVariant = "M8,0L7.17,5H7A2,2 0 0,0 5,7V17C5,18.11 5.9,19 7,19H7.17L8,24H16L16.83,19H17A2,2 0 0,0 19,17V7C19,5.89 18.1,5 17,5H16.83L16,0H8M7,7H17V17H7V7Z";
var mdiWatchVibrate = "M3,17V7H5V17H3M19,17V7H21V17H19M22,9H24V15H22V9M0,15V9H2V15H0M17.96,11.97C17.96,13.87 17.07,15.57 15.68,16.67L14.97,20.95H9L8.27,16.67C6.88,15.57 6,13.87 6,11.97C6,10.07 6.88,8.37 8.27,7.28L9,3H14.97L15.68,7.28C17.07,8.37 17.96,10.07 17.96,11.97M7.5,11.97C7.5,14.45 9.5,16.46 11.97,16.46A4.5,4.5 0 0,0 16.46,11.97C16.46,9.5 14.45,7.5 11.97,7.5A4.47,4.47 0 0,0 7.5,11.97Z";
var mdiWatchVibrateOff = "M0,9H2V15H0V9M12,7.5C14.47,7.5 16.47,9.53 16.46,12C16.45,12.38 16.4,12.76 16.3,13.13L17.5,14.31C17.81,13.58 18,12.8 18,12C18,10.17 17.16,8.44 15.72,7.31L15,3H9L8.59,5.39L10.86,7.66C11.23,7.55 11.61,7.5 12,7.5M21,17V7H19V15.8L20.2,17H21M16.5,15.86L22.11,21.46L20.84,22.73L15.55,17.44L15,21H9L8.27,16.72C5.85,14.82 5.27,11.4 6.91,8.8L1.11,3L2.39,1.73L8.09,7.44L9.17,8.5L15.44,14.79L16.5,15.86M14.05,15.94L8.05,9.94C7.7,10.57 7.5,11.28 7.5,12C7.5,14.47 9.53,16.47 12,16.46C12.72,16.46 13.42,16.28 14.05,15.94M22,9V15H24V9H22M3,17H5V7H3V17Z";
var mdiWater = "M12,20A6,6 0 0,1 6,14C6,10 12,3.25 12,3.25C12,3.25 18,10 18,14A6,6 0 0,1 12,20Z";
var mdiWaterAlert = "M10 3.25C10 3.25 16 10 16 14C16 17.31 13.31 20 10 20S4 17.31 4 14C4 10 10 3.25 10 3.25M20 7V13H18V7H20M18 17H20V15H18V17Z";
var mdiWaterAlertOutline = "M10 3.25C10 3.25 4 10 4 14C4 17.31 6.69 20 10 20S16 17.31 16 14C16 10 10 3.25 10 3.25M10 18C7.79 18 6 16.21 6 14C6 12.23 8 8.96 10 6.39C12 8.95 14 12.23 14 14C14 16.21 12.21 18 10 18M20 7V13H18V7H20M18 17H20V15H18V17Z";
var mdiWaterBoiler = "M8 2C6.89 2 6 2.89 6 4V16C6 17.11 6.89 18 8 18H9V20H6V22H9C10.11 22 11 21.11 11 20V18H13V20C13 21.11 13.89 22 15 22H18V20H15V18H16C17.11 18 18 17.11 18 16V4C18 2.89 17.11 2 16 2H8M12 4.97A2 2 0 0 1 14 6.97A2 2 0 0 1 12 8.97A2 2 0 0 1 10 6.97A2 2 0 0 1 12 4.97M10 14.5H14V16H10V14.5Z";
var mdiWaterBoilerAlert = "M6 2C4.89 2 4 2.89 4 4V16C4 17.11 4.89 18 6 18H7V20H4V22H7C8.11 22 9 21.11 9 20V18H11V20C11 21.11 11.89 22 13 22H16V20H13V18H14C15.11 18 16 17.11 16 16V4C16 2.89 15.11 2 14 2H6M10 4.97C11.11 4.97 12 5.87 12 6.97S11.11 8.97 10 8.97C8.9 8.97 8 8.07 8 6.97C8 5.87 8.9 4.97 10 4.97M8 14.5H12V16H8V14.5M18 15H20V17H18V15M18 7H20V13H18V7Z";
var mdiWaterBoilerAuto = "M4 2C2.89 2 2 2.89 2 4V16C2 17.11 2.89 18 4 18H5V20H2V22H5C6.11 22 7 21.11 7 20V18H9V20C9 21.11 9.89 22 11 22H13L13.75 20H11V18H12C13.11 18 14 17.11 14 16V4C14 2.89 13.11 2 12 2H4M8 4.97C9.11 4.97 10 5.87 10 6.97S9.11 8.97 8 8.97C6.9 8.97 6 8.07 6 6.97C6 5.87 6.9 4.97 8 4.97M6 14.5H10V16H6V14.5M19.8 13H17.8L14.6 22H16.5L17.2 20H20.4L21.1 22H23L19.8 13M17.6 18.7L18.8 15L20 18.7H17.6Z";
var mdiWaterBoilerOff = "M10 6.82L6.25 3.05C6.59 2.42 7.24 2 8 2H16C17.11 2 18 2.89 18 4V14.8L12.16 8.96C13.19 8.87 14 8 14 6.97C14 5.87 13.11 4.97 12 4.97C10.95 4.97 10.1 5.78 10 6.82M15 18V20H18V22H15C13.89 22 13 21.11 13 20V18H11V20C11 21.11 10.11 22 9 22H6V20H9V18H8C6.89 18 6 17.11 6 16V7.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73L16.1 18C16.06 18 16.03 18 16 18H15M14 16V15.89L12.61 14.5H10V16H14Z";
var mdiWaterCheck = "M21.75 16.25L17 21L14.25 18L15.41 16.84L17 18.43L20.59 14.84L21.75 16.25M17.62 12C16.31 8.1 12 3.25 12 3.25S6 10 6 14C6 17.31 8.69 20 12 20H12.34C12.12 19.36 12 18.7 12 18C12 14.82 14.5 12.22 17.62 12Z";
var mdiWaterCheckOutline = "M21.75 16.25L17 21L14.25 18L15.41 16.84L17 18.43L20.59 14.84L21.75 16.25M8 14C8 12.23 10 8.96 12 6.39C13.5 8.33 15 10.67 15.67 12.47C16.27 12.21 16.93 12.06 17.62 12C16.31 8.1 12 3.25 12 3.25S6 10 6 14C6 17.31 8.69 20 12 20C12.12 20 12.23 20 12.34 20C12.12 19.36 12 18.7 12 18C9.79 18 8 16.21 8 14Z";
var mdiWaterCircle = "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 19C9.24 19 7 16.76 7 14C7 10.67 12 5.04 12 5.04S17 10.67 17 14C17 16.76 14.76 19 12 19Z";
var mdiWaterMinus = "M22 17V19H14V17H22M17.62 12C16.31 8.1 12 3.25 12 3.25S6 10 6 14C6 17.31 8.69 20 12 20C12.12 20 12.23 20 12.34 20C12.12 19.36 12 18.7 12 18C12 14.82 14.5 12.22 17.62 12Z";
var mdiWaterMinusOutline = "M22 17V19H14V17H22M8 14C8 12.23 10 8.96 12 6.39C13.5 8.33 15 10.67 15.67 12.47C16.27 12.21 16.93 12.06 17.62 12C16.31 8.1 12 3.25 12 3.25S6 10 6 14C6 17.31 8.69 20 12 20C12.12 20 12.23 20 12.34 20C12.12 19.36 12 18.7 12 18C9.79 18 8 16.21 8 14Z";
var mdiWaterOff = "M20.84 22.73L16.29 18.18C15.2 19.3 13.69 20 12 20C8.69 20 6 17.31 6 14C6 12.67 6.67 11.03 7.55 9.44L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M18 14C18 10 12 3.25 12 3.25S10.84 4.55 9.55 6.35L17.95 14.75C18 14.5 18 14.25 18 14Z";
var mdiWaterOffOutline = "M22.11 21.46L2.39 1.73L1.11 3L7.65 9.54C6.74 11.03 6 12.65 6 14.23C6 17.54 8.69 20.23 12 20.23C13.74 20.23 15.3 19.5 16.4 18.29L20.84 22.73L22.11 21.46M12 18.23C9.78 18.23 8 16.45 8 14.23C8 13.5 8.5 12.27 9.14 11.03L15 16.88C14.26 17.71 13.2 18.23 12 18.23M11.14 7.94L9.71 6.5C10.57 5.38 11.25 4.61 11.25 4.61L12 3.77L12.75 4.61C12.75 4.61 14.03 6.06 15.32 7.94S18 12.07 18 14.23C18 14.41 18 14.59 17.97 14.77L15.46 12.26C15 11.23 14.37 10.07 13.68 9.07C12.84 7.85 12.44 7.42 12 6.9C11.73 7.21 11.5 7.5 11.14 7.94Z";
var mdiWaterOpacity = "M16 14V12H17.61C17.85 12.71 18 13.39 18 14H16M15.58 8C15.12 7.29 14.65 6.61 14.2 6H14V8H15.58M16 12V10H14V12H16M16 8.68V10H16.74C16.5 9.56 16.26 9.11 16 8.68M12 16V14H14V12H12V10H14V8H12V6H14V5.73C12.9 4.26 12 3.25 12 3.25S6 10 6 14C6 17.31 8.69 20 12 20V18H14V16H12M14 19.65C14.75 19.39 15.42 19 16 18.46V18H14V19.65M14 16H16V14H14V16M16 18H16.46C17 17.42 17.39 16.75 17.65 16H16V18Z";
var mdiWaterOutline = "M12,3.77L11.25,4.61C11.25,4.61 9.97,6.06 8.68,7.94C7.39,9.82 6,12.07 6,14.23A6,6 0 0,0 12,20.23A6,6 0 0,0 18,14.23C18,12.07 16.61,9.82 15.32,7.94C14.03,6.06 12.75,4.61 12.75,4.61L12,3.77M12,6.9C12.44,7.42 12.84,7.85 13.68,9.07C14.89,10.83 16,13.07 16,14.23C16,16.45 14.22,18.23 12,18.23C9.78,18.23 8,16.45 8,14.23C8,13.07 9.11,10.83 10.32,9.07C11.16,7.85 11.56,7.42 12,6.9Z";
var mdiWaterPercent = "M12,3.25C12,3.25 6,10 6,14C6,17.32 8.69,20 12,20A6,6 0 0,0 18,14C18,10 12,3.25 12,3.25M14.47,9.97L15.53,11.03L9.53,17.03L8.47,15.97M9.75,10A1.25,1.25 0 0,1 11,11.25A1.25,1.25 0 0,1 9.75,12.5A1.25,1.25 0 0,1 8.5,11.25A1.25,1.25 0 0,1 9.75,10M14.25,14.5A1.25,1.25 0 0,1 15.5,15.75A1.25,1.25 0 0,1 14.25,17A1.25,1.25 0 0,1 13,15.75A1.25,1.25 0 0,1 14.25,14.5Z";
var mdiWaterPercentAlert = "M20 7V13H18V7H20M18 17H20V15H18V17M10 3.25C10 3.25 4 10 4 14C4 17.32 6.69 20 10 20S16 17.31 16 14C16 10 10 3.25 10 3.25M7.75 10C8.44 10 9 10.56 9 11.25S8.44 12.5 7.75 12.5 6.5 11.94 6.5 11.25 7.06 10 7.75 10M12.25 17C11.56 17 11 16.44 11 15.75S11.56 14.5 12.25 14.5 13.5 15.06 13.5 15.75 12.94 17 12.25 17M7.53 17.03L6.47 15.97L12.47 9.97L13.53 11.03L7.53 17.03Z";
var mdiWaterPlus = "M12 18C12 18.7 12.12 19.36 12.34 20C12.23 20 12.12 20 12 20C8.69 20 6 17.31 6 14C6 10 12 3.25 12 3.25S16.31 8.1 17.62 12C14.5 12.22 12 14.82 12 18M19 17V14H17V17H14V19H17V22H19V19H22V17H19Z";
var mdiWaterPlusOutline = "M12 18C12 18.7 12.12 19.36 12.34 20C12.23 20 12.12 20 12 20C8.69 20 6 17.31 6 14C6 10 12 3.25 12 3.25S16.31 8.1 17.62 12C16.93 12.06 16.28 12.22 15.67 12.47C15 10.68 13.5 8.33 12 6.39C10 8.96 8 12.23 8 14C8 16.21 9.79 18 12 18M19 17V14H17V17H14V19H17V22H19V19H22V17H19Z";
var mdiWaterPolo = "M20 16H22V18H20C18.6 18 17.2 17.6 16 17C13.5 18.3 10.5 18.3 8 17C6.8 17.6 5.4 18 4 18H2V16H4C5.4 16 6.8 15.5 8 14.7C10.4 16.4 13.6 16.4 16 14.7C17.2 15.5 18.6 16 20 16M13 10.6C13.6 10.3 14.3 10 15 9.9V10.2C15.3 11.2 15.3 12.1 15.2 13.1C14.3 13.6 13.2 13.9 12.2 13.9C12.7 12.9 13 11.7 13 10.6M12.9 3.6C11.5 4 10.3 4.7 9.3 5.7C8.9 4.7 8.7 3.7 8.7 2.7C10.9 1.7 13.4 1.8 15.6 2.9C15.9 3 16.2 3.1 16.4 3.3C15.2 3.2 14 3.3 12.9 3.6M6.8 13.3C6.2 13.6 5.6 13.8 5 13.9C4.3 12.6 4 11.2 4 9.8C4.5 10.8 5.2 11.8 6 12.6C6.3 12.8 6.5 13.1 6.8 13.3M19 13.9C18.4 13.8 17.8 13.6 17.3 13.4C17.5 12.2 17.4 11 17.1 9.8C18.2 9.9 19.2 10.2 20.1 10.8C20 11.8 19.7 12.7 19.2 13.6L19 13.9M7.4 11.2C6.2 10.1 5.5 8.5 5.2 6.9L5.1 6C5.6 5.2 6.1 4.6 6.8 4C6.9 5.4 7.4 6.7 8.2 7.8C8.9 8.9 9.9 9.9 11 10.5C11 11.3 10.8 12.1 10.5 12.9C9.3 12.6 8.3 12 7.4 11.2M13.5 5.5C15 5.1 16.7 5.2 18.2 5.7L19 6.1C19.4 6.8 19.6 7.6 19.8 8.4C17.3 7.3 14.4 7.5 12 8.8C11.3 8.5 10.8 8 10.3 7.4L10.4 7.3C11.3 6.5 12.3 5.8 13.5 5.5M16 18.7C17.2 19.5 18.6 20 20 20H22V22H20C18.6 22 17.2 21.6 16 21C13.5 22.3 10.5 22.3 8 21C6.8 21.6 5.4 22 4 22H2V20H4C5.4 20 6.8 19.5 8 18.7C10.4 20.4 13.6 20.4 16 18.7Z";
var mdiWaterPump = "M19,14.5C19,14.5 21,16.67 21,18A2,2 0 0,1 19,20A2,2 0 0,1 17,18C17,16.67 19,14.5 19,14.5M5,18V9A2,2 0 0,1 3,7A2,2 0 0,1 5,5V4A2,2 0 0,1 7,2H9A2,2 0 0,1 11,4V5H19A2,2 0 0,1 21,7V9L21,11A1,1 0 0,1 22,12A1,1 0 0,1 21,13H17A1,1 0 0,1 16,12A1,1 0 0,1 17,11V9H11V18H12A2,2 0 0,1 14,20V22H2V20A2,2 0 0,1 4,18H5Z";
var mdiWaterPumpOff = "M5.7 2.5A2 2 0 0 1 7 2H9A2 2 0 0 1 11 4V5H19A2 2 0 0 1 21 7V11A1 1 0 0 1 21 13H17A1 1 0 0 1 17 11V9H12.2M20.84 22.73L22.11 21.46L11 10.34L2.39 1.73L1.11 3L3.65 5.54A2 2 0 0 0 5 9V18H4A2 2 0 0 0 2 20V22H14V20A2 2 0 0 0 12 18H11V12.89Z";
var mdiWaterRemove = "M12 18C12 18.7 12.12 19.36 12.34 20C12.23 20 12.12 20 12 20C8.69 20 6 17.31 6 14C6 10 12 3.25 12 3.25S16.31 8.1 17.62 12C14.5 12.22 12 14.82 12 18M21.54 15.88L20.13 14.47L18 16.59L15.88 14.47L14.47 15.88L16.59 18L14.47 20.12L15.88 21.53L18 19.41L20.12 21.53L21.53 20.12L19.41 18L21.54 15.88Z";
var mdiWaterRemoveOutline = "M12 18C12 18.7 12.12 19.36 12.34 20C12.23 20 12.12 20 12 20C8.69 20 6 17.31 6 14C6 10 12 3.25 12 3.25S16.31 8.1 17.62 12C16.93 12.06 16.28 12.22 15.67 12.47C15 10.68 13.5 8.33 12 6.39C10 8.96 8 12.23 8 14C8 16.21 9.79 18 12 18M21.54 15.88L20.13 14.47L18 16.59L15.88 14.47L14.47 15.88L16.59 18L14.47 20.12L15.88 21.53L18 19.41L20.12 21.53L21.53 20.12L19.41 18L21.54 15.88Z";
var mdiWaterSync = "M12 3.2C12 3.2 6 10 6 14C6 17.3 8.7 20 12 20S18 17.3 18 14C18 10 12 3.2 12 3.2M12 8.5V10C14.2 10 16 11.8 16 14C16 14.8 15.8 15.6 15.3 16.2L14.2 15.1C14.4 14.8 14.5 14.4 14.5 14C14.5 12.6 13.4 11.5 12 11.5V13L9.8 10.8L12 8.5M8.7 11.8L9.8 12.9C9.6 13.2 9.5 13.6 9.5 14C9.5 15.4 10.6 16.5 12 16.5V15L14.2 17.2L12 19.5V18C9.8 18 8 16.2 8 14C8 13.2 8.2 12.4 8.7 11.8Z";
var mdiWaterThermometer = "M19 5C17.89 5 17 5.89 17 7V13.76C16.36 14.33 16 15.15 16 16C16 17.66 17.34 19 19 19S22 17.66 22 16C22 15.15 21.64 14.33 21 13.77V7C21 5.89 20.11 5 19 5M19 6C19.55 6 20 6.45 20 7V8H18V7C18 6.45 18.45 6 19 6M8 20C4.69 20 2 17.31 2 14C2 10 8 3.25 8 3.25S14 10 14 14C14 17.31 11.31 20 8 20Z";
var mdiWaterThermometerOutline = "M19 5C17.89 5 17 5.89 17 7V13.76C16.36 14.33 16 15.15 16 16C16 17.66 17.34 19 19 19S22 17.66 22 16C22 15.15 21.64 14.33 21 13.77V7C21 5.89 20.11 5 19 5M19 6C19.55 6 20 6.45 20 7V8H18V7C18 6.45 18.45 6 19 6M8 3.54L7.25 4.38C7.25 4.38 5.97 5.83 4.68 7.71S2 11.84 2 14C2 17.31 4.69 20 8 20S14 17.31 14 14C14 11.84 12.61 9.59 11.32 7.71S8.75 4.38 8.75 4.38L8 3.54M8 6.67C8.44 7.19 8.84 7.62 9.68 8.84C10.89 10.6 12 12.84 12 14C12 16.22 10.22 18 8 18S4 16.22 4 14C4 12.84 5.11 10.6 6.32 8.84C7.16 7.62 7.56 7.19 8 6.67Z";
var mdiWaterWell = "M22 16H2V18H4V22H20V18H22V16M10.44 15C10.19 15 10 14.81 9.95 14.56L9.57 11.56C9.57 11.54 9.57 11.5 9.57 11.5C9.57 11.22 9.79 11 10.07 11H13.93C13.95 11 13.97 11 14 11C14.27 11.04 14.46 11.29 14.43 11.56L14.05 14.56C14 14.81 13.81 15 13.56 15H10.44M19 2L21.56 6.68C21.6 6.78 21.61 6.89 21.61 7C21.61 7.56 21.16 8 20.61 8H19V15H17V8H13V10H11V8H7V15H5V8H3.62C3.46 8 3.31 7.96 3.16 7.89C2.67 7.64 2.47 7.04 2.72 6.55L5 2H19Z";
var mdiWaterWellOutline = "M3.62 8H5V15H7V8H11V10H13V8H17V15H19V8H20.61C21.16 8 21.61 7.56 21.61 7C21.61 6.89 21.6 6.78 21.56 6.68L19 2H5L2.72 6.55C2.47 7.04 2.67 7.64 3.16 7.89C3.31 7.96 3.46 8 3.62 8M6.24 4H17.76L18.76 6H5.24L6.24 4M2 16V18H4V22H20V18H22V16H2M18 20H6V18H18V20M13.93 11C14.21 11 14.43 11.22 14.43 11.5C14.43 11.5 14.43 11.54 14.43 11.56L14.05 14.56C14 14.81 13.81 15 13.56 15H10.44C10.19 15 10 14.81 9.95 14.56L9.57 11.56C9.54 11.29 9.73 11.04 10 11C10.03 11 10.05 11 10.07 11H13.93Z";
var mdiWaterfall = "M20 20C18.61 20 17.22 19.53 16 18.67C13.56 20.38 10.44 20.38 8 18.67C6.78 19.53 5.39 20 4 20H2V22H4C5.37 22 6.74 21.65 8 21C10.5 22.3 13.5 22.3 16 21C17.26 21.65 18.62 22 20 22H22V20M20 16C18.61 16 17.22 15.53 16 14.67C13.56 16.38 10.44 16.38 8 14.67C6.78 15.53 5.39 16 4 16H2V18H4C5.37 18 6.74 17.65 8 17C10.5 18.3 13.5 18.3 16 17C17.26 17.65 18.62 18 20 18H22V16M22 2H2V4H6V16H18V4H22M9 4H11V10H9M13 8H15V14H13Z";
var mdiWateringCan = "M18.5 7.47C17.76 8.2 17.57 9.25 17.92 10.15L15 13.07V11C15 10.45 14.55 10 14 10H12.97C13 9.83 13 9.67 13 9.5C13 6.46 10.54 4 7.5 4S2 6.46 2 9.5C2 11.21 2.78 12.73 4 13.74V20C4 20.55 4.45 21 5 21H14C14.55 21 15 20.55 15 20V15.89L19.33 11.56C20.23 11.91 21.28 11.73 22 11L18.5 7.47M4.05 10C4.03 9.83 4 9.67 4 9.5C4 7.57 5.57 6 7.5 6S11 7.57 11 9.5C11 9.67 10.97 9.83 10.95 10H4.05Z";
var mdiWateringCanOutline = "M18.5 7.47C17.76 8.2 17.57 9.25 17.92 10.15L15 13.07V11C15 10.45 14.55 10 14 10H12.97C13 9.83 13 9.67 13 9.5C13 6.46 10.54 4 7.5 4S2 6.46 2 9.5C2 11.21 2.78 12.73 4 13.74V20C4 20.55 4.45 21 5 21H14C14.55 21 15 20.55 15 20V15.89L19.33 11.56C20.23 11.91 21.28 11.73 22 11L18.5 7.47M4.05 10C4.03 9.83 4 9.67 4 9.5C4 7.57 5.57 6 7.5 6S11 7.57 11 9.5C11 9.67 10.97 9.83 10.95 10M13 19H6V12H13V19Z";
var mdiWatermark = "M21,3H3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V5A2,2 0 0,0 21,3M21,19H12V13H21V19Z";
var mdiWave = "M20,12C18.61,12 17.22,11.53 16,10.67C13.56,12.38 10.44,12.38 8,10.67C6.78,11.53 5.39,12 4,12H2V14H4C5.37,14 6.74,13.65 8,13C10.5,14.3 13.5,14.3 16,13C17.26,13.65 18.62,14 20,14H22V12";
var mdiWaveArrowDown = "M20 7H22V9H20C18.62 9 17.26 8.65 16 8C13.5 9.3 10.5 9.3 8 8C6.74 8.65 5.37 9 4 9H2V7H4C5.39 7 6.78 6.53 8 5.67C10.44 7.38 13.56 7.38 16 5.67C17.22 6.53 18.61 7 20 7M12 22L8 18H11V11H13V18H16L12 22Z";
var mdiWaveArrowUp = "M20 7H22V9H20C18.62 9 17.26 8.65 16 8C13.5 9.3 10.5 9.3 8 8C6.74 8.65 5.37 9 4 9H2V7H4C5.39 7 6.78 6.53 8 5.67C10.44 7.38 13.56 7.38 16 5.67C17.22 6.53 18.61 7 20 7M12 11L16 15H13V22H11V15H8L12 11Z";
var mdiWaveUndercurrent = "M20 7H22V9H20C18.62 9 17.26 8.65 16 8C13.5 9.3 10.5 9.3 8 8C6.74 8.65 5.37 9 4 9H2V7H4C5.39 7 6.78 6.53 8 5.67C10.44 7.38 13.56 7.38 16 5.67C17.22 6.53 18.61 7 20 7M12 12.5C14.21 12.5 16 14.29 16 16.5C16 17.32 15.75 18.08 15.33 18.71L14.24 17.62C14.41 17.28 14.5 16.9 14.5 16.5C14.5 15.12 13.38 14 12 14V15.5L9.75 13.25L12 11V12.5M12 19V17.5L14.25 19.75L12 22V20.5C9.79 20.5 8 18.71 8 16.5C8 15.68 8.25 14.92 8.67 14.29L9.76 15.38C9.59 15.72 9.5 16.1 9.5 16.5C9.5 17.88 10.62 19 12 19Z";
var mdiWaveform = "M22 12L20 13L19 14L18 13L17 16L16 13L15 21L14 13L13 15L12 13L11 17L10 13L9 22L8 13L7 19L6 13L5 14L4 13L2 12L4 11L5 10L6 11L7 5L8 11L9 2L10 11L11 7L12 11L13 9L14 11L15 3L16 11L17 8L18 11L19 10L20 11L22 12Z";
var mdiWaves = "M20,12H22V14H20C18.62,14 17.26,13.65 16,13C13.5,14.3 10.5,14.3 8,13C6.74,13.65 5.37,14 4,14H2V12H4C5.39,12 6.78,11.53 8,10.67C10.44,12.38 13.56,12.38 16,10.67C17.22,11.53 18.61,12 20,12M20,6H22V8H20C18.62,8 17.26,7.65 16,7C13.5,8.3 10.5,8.3 8,7C6.74,7.65 5.37,8 4,8H2V6H4C5.39,6 6.78,5.53 8,4.67C10.44,6.38 13.56,6.38 16,4.67C17.22,5.53 18.61,6 20,6M20,18H22V20H20C18.62,20 17.26,19.65 16,19C13.5,20.3 10.5,20.3 8,19C6.74,19.65 5.37,20 4,20H2V18H4C5.39,18 6.78,17.53 8,16.67C10.44,18.38 13.56,18.38 16,16.67C17.22,17.53 18.61,18 20,18Z";
var mdiWavesArrowLeft = "M4 14C5.39 14 6.78 13.53 8 12.67C10.44 14.38 13.56 14.38 16 12.67C17.22 13.53 18.61 14 20 14H22V16H20C18.63 16 17.26 15.65 16 15C13.5 16.3 10.5 16.3 8 15C6.74 15.65 5.38 16 4 16H2V14H4M8 18.67C10.44 20.38 13.56 20.38 16 18.67C17.22 19.53 18.61 20 20 20H22V22H20C18.63 22 17.26 21.65 16 21C13.5 22.3 10.5 22.3 8 21C6.74 21.65 5.38 22 4 22H2V20H4C5.39 20 6.78 19.53 8 18.67M6 10V7H11V5H6V2L2 6";
var mdiWavesArrowRight = "M20 14H22V16H20C18.62 16 17.26 15.65 16 15C13.5 16.3 10.5 16.3 8 15C6.74 15.65 5.37 16 4 16H2V14H4C5.39 14 6.78 13.53 8 12.67C10.44 14.38 13.56 14.38 16 12.67C17.22 13.53 18.61 14 20 14M20 20H22V22H20C18.62 22 17.26 21.65 16 21C13.5 22.3 10.5 22.3 8 21C6.74 21.65 5.37 22 4 22H2V20H4C5.39 20 6.78 19.53 8 18.67C10.44 20.38 13.56 20.38 16 18.67C17.22 19.53 18.61 20 20 20M22 6L18 2V5H13V7H18V10";
var mdiWavesArrowUp = "M20 14H22V16H20C18.62 16 17.26 15.65 16 15C13.5 16.3 10.5 16.3 8 15C6.74 15.65 5.37 16 4 16H2V14H4C5.39 14 6.78 13.53 8 12.67C10.44 14.38 13.56 14.38 16 12.67C17.22 13.53 18.61 14 20 14M20 20H22V22H20C18.62 22 17.26 21.65 16 21C13.5 22.3 10.5 22.3 8 21C6.74 21.65 5.37 22 4 22H2V20H4C5.39 20 6.78 19.53 8 18.67C10.44 20.38 13.56 20.38 16 18.67C17.22 19.53 18.61 20 20 20M7 2L3 6H6V11H8V6H11M17 2L13 6H16V11H18V6H21";
var mdiWaze = "M20.54,6.63C21.23,7.57 21.69,8.67 21.89,9.82C22.1,11.07 22,12.34 21.58,13.54C21.18,14.71 20.5,15.76 19.58,16.6C18.91,17.24 18.15,17.77 17.32,18.18C17.73,19.25 17.19,20.45 16.12,20.86C15.88,20.95 15.63,21 15.38,21C14.27,21 13.35,20.11 13.31,19C13.05,19 10.73,19 10.24,19C10.13,20.14 9.11,21 7.97,20.87C6.91,20.77 6.11,19.89 6.09,18.83C6.1,18.64 6.13,18.44 6.19,18.26C4.6,17.73 3.21,16.74 2.19,15.41C1.86,14.97 1.96,14.34 2.42,14C2.6,13.86 2.82,13.78 3.05,13.78C3.77,13.78 4.05,13.53 4.22,13.15C4.46,12.43 4.6,11.68 4.61,10.92C4.64,10.39 4.7,9.87 4.78,9.35C5.13,7.62 6.1,6.07 7.5,5C9.16,3.7 11.19,3 13.29,3C14.72,3 16.13,3.35 17.4,4C18.64,4.62 19.71,5.5 20.54,6.63M16.72,17.31C18.5,16.5 19.9,15.04 20.59,13.21C22.21,8.27 18,4.05 13.29,4.05C12.94,4.05 12.58,4.07 12.23,4.12C9.36,4.5 6.4,6.5 5.81,9.5C5.43,11.5 6,14.79 3.05,14.79C4,16 5.32,16.93 6.81,17.37C7.66,16.61 8.97,16.69 9.74,17.55C9.85,17.67 9.94,17.8 10,17.94C10.59,17.94 13.2,17.94 13.55,17.94C14.07,16.92 15.33,16.5 16.35,17.04C16.5,17.12 16.6,17.21 16.72,17.31M10.97,10.31C10.39,10.34 9.88,9.9 9.85,9.31C9.82,8.73 10.27,8.23 10.85,8.19C11.43,8.16 11.94,8.61 11.97,9.25C12,9.8 11.56,10.27 11,10.29L10.97,10.31M15.66,10.31C15.08,10.34 14.57,9.9 14.54,9.31C14.5,8.73 14.96,8.23 15.54,8.19C16.12,8.16 16.63,8.61 16.66,9.25C16.68,9.8 16.25,10.27 15.66,10.29V10.31M9.71,12.07C9.65,11.79 9.84,11.5 10.12,11.45C10.4,11.4 10.68,11.58 10.74,11.86V11.86C11.09,12.97 12.16,13.69 13.32,13.6C14.46,13.66 15.5,12.96 15.89,11.88C16.03,11.62 16.35,11.5 16.6,11.65C16.78,11.75 16.89,11.92 16.89,12.12C16.7,12.83 16.26,13.45 15.66,13.88C14.97,14.36 14.16,14.63 13.32,14.64H13.21C11.58,14.71 10.11,13.64 9.68,12.06L9.71,12.07Z";
var mdiWeatherCloudy = "M6,19A5,5 0 0,1 1,14A5,5 0 0,1 6,9C7,6.65 9.3,5 12,5C15.43,5 18.24,7.66 18.5,11.03L19,11A4,4 0 0,1 23,15A4,4 0 0,1 19,19H6M19,13H17V12A5,5 0 0,0 12,7C9.5,7 7.45,8.82 7.06,11.19C6.73,11.07 6.37,11 6,11A3,3 0 0,0 3,14A3,3 0 0,0 6,17H19A2,2 0 0,0 21,15A2,2 0 0,0 19,13Z";
var mdiWeatherCloudyAlert = "M6,19A5,5 0 0,1 1,14A5,5 0 0,1 6,9C7,6.65 9.3,5 12,5C15.43,5 18.24,7.66 18.5,11.03L19,11A4,4 0 0,1 23,15A4,4 0 0,1 19,19H6M19,13H17V12A5,5 0 0,0 12,7C9.5,7 7.45,8.82 7.06,11.19C6.73,11.07 6.37,11 6,11A3,3 0 0,0 3,14A3,3 0 0,0 6,17H19A2,2 0 0,0 21,15A2,2 0 0,0 19,13M13,12H11V8H13V12M13,16H11V14H13";
var mdiWeatherCloudyArrowRight = "M6,7L6.69,7.06C7.32,4.72 9.46,3 12,3A5.5,5.5 0 0,1 17.5,8.5L17.42,9.45C17.88,9.16 18.42,9 19,9A3,3 0 0,1 22,12A3,3 0 0,1 19,15H6A4,4 0 0,1 2,11A4,4 0 0,1 6,7M6,9A2,2 0 0,0 4,11A2,2 0 0,0 6,13H19A1,1 0 0,0 20,12A1,1 0 0,0 19,11H15.5V8.5A3.5,3.5 0 0,0 12,5A3.5,3.5 0 0,0 8.5,8.5V9H6M22,19L19,22V20H2V18H19V16L22,19";
var mdiWeatherCloudyClock = "M15 13H16.5V15.82L18.94 17.23L18.19 18.53L15 16.69V13M18.13 9.33C17.23 6.81 14.83 5 12 5C9.3 5 7 6.65 6 9C3.24 9 1 11.24 1 14S3.24 19 6 19H9.68C10.81 21.36 13.21 23 16 23C19.87 23 23 19.87 23 16C23 12.88 20.96 10.24 18.13 9.33M6 17C4.34 17 3 15.66 3 14S4.34 11 6 11C6.37 11 6.73 11.07 7.06 11.19C7.45 8.82 9.5 7 12 7C13.63 7 15.07 7.79 16 9C12.12 9 9 12.14 9 16C9 16.34 9.03 16.67 9.08 17H6M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21Z";
var mdiWeatherDust = "M3 5C3 4.4 3.4 4 4 4H5C5.6 4 6 4.4 6 5S5.6 6 5 6H4C3.4 6 3 5.6 3 5M4 13C4 12.4 4.4 12 5 12H6C6.6 12 7 12.4 7 13S6.6 14 6 14H5C4.4 14 4 13.6 4 13M4 16C3.4 16 3 16.4 3 17S3.4 18 4 18H9C9.6 18 10 17.6 10 17S9.6 16 9 16H4M18 5C18 4.4 18.4 4 19 4H21C21.6 4 22 4.4 22 5S21.6 6 21 6H19C18.4 6 18 5.6 18 5M7 20C6.4 20 6 20.4 6 21S6.4 22 7 22H11C11.6 22 12 21.6 12 21S11.6 20 11 20H7M3 10C2.4 10 2 9.6 2 9S2.4 8 3 8H12C13.1 8 14 7.1 14 6S13.1 4 12 4C11.4 4 10.9 4.2 10.6 4.6C10.2 5 9.6 5 9.2 4.6C8.8 4.2 8.8 3.6 9.2 3.2C9.9 2.5 10.9 2 12 2C14.2 2 16 3.8 16 6S14.2 10 12 10H3M19 12C19.6 12 20 11.6 20 11S19.6 10 19 10C18.7 10 18.5 10.1 18.3 10.3C17.9 10.7 17.3 10.7 16.9 10.3C16.5 9.9 16.5 9.3 16.9 8.9C17.4 8.3 18.2 8 19 8C20.7 8 22 9.3 22 11S20.7 14 19 14H10C9.4 14 9 13.6 9 13S9.4 12 10 12H19M18 18H13C12.4 18 12 17.6 12 17S12.4 16 13 16H18C19.7 16 21 17.3 21 19S19.7 22 18 22C17.2 22 16.4 21.7 15.9 21.1C15.5 20.7 15.5 20.1 15.9 19.7C16.3 19.3 16.9 19.3 17.3 19.7C17.5 19.9 17.7 20 18 20C18.6 20 19 19.6 19 19S18.6 18 18 18Z";
var mdiWeatherFog = "M3,15H13A1,1 0 0,1 14,16A1,1 0 0,1 13,17H3A1,1 0 0,1 2,16A1,1 0 0,1 3,15M16,15H21A1,1 0 0,1 22,16A1,1 0 0,1 21,17H16A1,1 0 0,1 15,16A1,1 0 0,1 16,15M1,12A5,5 0 0,1 6,7C7,4.65 9.3,3 12,3C15.43,3 18.24,5.66 18.5,9.03L19,9C21.19,9 22.97,10.76 23,13H21A2,2 0 0,0 19,11H17V10A5,5 0 0,0 12,5C9.5,5 7.45,6.82 7.06,9.19C6.73,9.07 6.37,9 6,9A3,3 0 0,0 3,12C3,12.35 3.06,12.69 3.17,13H1.1L1,12M3,19H5A1,1 0 0,1 6,20A1,1 0 0,1 5,21H3A1,1 0 0,1 2,20A1,1 0 0,1 3,19M8,19H21A1,1 0 0,1 22,20A1,1 0 0,1 21,21H8A1,1 0 0,1 7,20A1,1 0 0,1 8,19Z";
var mdiWeatherHail = "M6,14A1,1 0 0,1 7,15A1,1 0 0,1 6,16A5,5 0 0,1 1,11A5,5 0 0,1 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8A4,4 0 0,1 23,12A4,4 0 0,1 19,16H18A1,1 0 0,1 17,15A1,1 0 0,1 18,14H19A2,2 0 0,0 21,12A2,2 0 0,0 19,10H17V9A5,5 0 0,0 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8A3,3 0 0,0 3,11A3,3 0 0,0 6,14M10,18A2,2 0 0,1 12,20A2,2 0 0,1 10,22A2,2 0 0,1 8,20A2,2 0 0,1 10,18M14.5,16A1.5,1.5 0 0,1 16,17.5A1.5,1.5 0 0,1 14.5,19A1.5,1.5 0 0,1 13,17.5A1.5,1.5 0 0,1 14.5,16M10.5,12A1.5,1.5 0 0,1 12,13.5A1.5,1.5 0 0,1 10.5,15A1.5,1.5 0 0,1 9,13.5A1.5,1.5 0 0,1 10.5,12Z";
var mdiWeatherHazy = "M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64M14,15A1,1 0 0,0 13,14H3A1,1 0 0,0 2,15A1,1 0 0,0 3,16H13A1,1 0 0,0 14,15M22,15A1,1 0 0,0 21,14H17A1,1 0 0,0 16,15A1,1 0 0,0 17,16H21A1,1 0 0,0 22,15M10,19A1,1 0 0,0 11,20H20A1,1 0 0,0 21,19A1,1 0 0,0 20,18H11A1,1 0 0,0 10,19M3,19A1,1 0 0,0 4,20H7A1,1 0 0,0 8,19A1,1 0 0,0 7,18H4A1,1 0 0,0 3,19M12,9A3,3 0 0,1 15,12H17A5,5 0 0,0 12,7A5,5 0 0,0 7,12H9A3,3 0 0,1 12,9Z";
var mdiWeatherHurricane = "M15,6.79C16.86,7.86 18,9.85 18,12C18,22 6,22 6,22C7.25,21.06 8.38,19.95 9.34,18.71C9.38,18.66 9.41,18.61 9.44,18.55C9.69,18.06 9.5,17.46 9,17.21C7.14,16.14 6,14.15 6,12C6,2 18,2 18,2C16.75,2.94 15.62,4.05 14.66,5.29C14.62,5.34 14.59,5.39 14.56,5.45C14.31,5.94 14.5,6.54 15,6.79M12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14Z";
var mdiWeatherHurricaneOutline = "M12 14C13.11 14 14 13.11 14 12C14 10.9 13.11 10 12 10C10.9 10 10 10.9 10 12C10 13.11 10.9 14 12 14M18 2C17.1 2.68 16.26 3.45 15.5 4.29C15.21 4.61 14.93 4.95 14.66 5.29C14.62 5.34 14.59 5.39 14.56 5.45C14.31 5.94 14.5 6.54 15 6.79C16.86 7.86 18 9.85 18 12C18 18.41 13.08 20.71 9.54 21.54C7.55 22 6 22 6 22C6.9 21.32 7.74 20.55 8.5 19.71C8.79 19.39 9.07 19.05 9.34 18.71C9.38 18.66 9.41 18.61 9.44 18.55C9.69 18.06 9.5 17.46 9 17.21C7.14 16.14 6 14.15 6 12C6 5.59 10.93 3.29 14.47 2.46C16.45 2 18 2 18 2M9.44 7.47C8.61 8.5 8 9.93 8 12C8 13.43 8.75 14.74 9.96 15.46C11.2 16.12 11.78 17.5 11.47 18.8C12.67 18.27 13.76 17.54 14.56 16.53C15.39 15.5 16 14.07 16 12C16 10.57 15.25 9.26 14.04 8.54C12.8 7.88 12.22 6.5 12.54 5.2C11.33 5.73 10.24 6.47 9.44 7.47Z";
var mdiWeatherLightning = "M6,16A5,5 0 0,1 1,11A5,5 0 0,1 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8A4,4 0 0,1 23,12A4,4 0 0,1 19,16H18A1,1 0 0,1 17,15A1,1 0 0,1 18,14H19A2,2 0 0,0 21,12A2,2 0 0,0 19,10H17V9A5,5 0 0,0 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8A3,3 0 0,0 3,11A3,3 0 0,0 6,14H7A1,1 0 0,1 8,15A1,1 0 0,1 7,16H6M12,11H15L13,15H15L11.25,22L12,17H9.5L12,11Z";
var mdiWeatherLightningRainy = "M4.5,13.59C5,13.87 5.14,14.5 4.87,14.96C4.59,15.44 4,15.6 3.5,15.33V15.33C2,14.47 1,12.85 1,11A5,5 0 0,1 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8A4,4 0 0,1 23,12A4,4 0 0,1 19,16A1,1 0 0,1 18,15A1,1 0 0,1 19,14A2,2 0 0,0 21,12A2,2 0 0,0 19,10H17V9A5,5 0 0,0 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8A3,3 0 0,0 3,11C3,12.11 3.6,13.08 4.5,13.6V13.59M9.5,11H12.5L10.5,15H12.5L8.75,22L9.5,17H7L9.5,11M17.5,18.67C17.5,19.96 16.5,21 15.25,21C14,21 13,19.96 13,18.67C13,17.12 15.25,14.5 15.25,14.5C15.25,14.5 17.5,17.12 17.5,18.67Z";
var mdiWeatherMoonset = "M3 12H7C7 10.67 7.53 9.4 8.46 8.46C9.4 7.53 10.67 7 12 7C13.33 7 14.6 7.53 15.54 8.46C16.47 9.4 17 10.67 17 12H21C21.27 12 21.5 12.11 21.71 12.29C21.9 12.5 22 12.74 22 13C22 13.27 21.9 13.5 21.71 13.71C21.5 13.9 21.27 14 21 14H3C2.74 14 2.5 13.9 2.29 13.71C2.11 13.5 2 13.27 2 13C2 12.74 2.11 12.5 2.29 12.29C2.5 12.11 2.74 12 3 12M5 16H19C19.27 16 19.5 16.11 19.71 16.29C19.9 16.5 20 16.74 20 17C20 17.27 19.9 17.5 19.71 17.71C19.5 17.9 19.27 18 19 18H5C4.74 18 4.5 17.9 4.29 17.71C4.11 17.5 4 17.27 4 17C4 16.74 4.11 16.5 4.29 16.29C4.5 16.11 4.74 16 5 16M17 20C17.27 20 17.5 20.11 17.71 20.29C17.9 20.5 18 20.74 18 21C18 21.27 17.9 21.5 17.71 21.71C17.5 21.9 17.27 22 17 22H7C6.74 22 6.5 21.9 6.29 21.71C6.11 21.5 6 21.27 6 21C6 20.74 6.11 20.5 6.29 20.29C6.5 20.11 6.74 20 7 20H17Z";
var mdiWeatherMoonsetDown = "M3 12H7C7 10.67 7.53 9.4 8.46 8.46C9.4 7.53 10.67 7 12 7C13.33 7 14.6 7.53 15.54 8.46C16.47 9.4 17 10.67 17 12H21C21.27 12 21.5 12.11 21.71 12.29C21.9 12.5 22 12.74 22 13C22 13.27 21.9 13.5 21.71 13.71C21.5 13.9 21.27 14 21 14H3C2.74 14 2.5 13.9 2.29 13.71C2.11 13.5 2 13.27 2 13C2 12.74 2.11 12.5 2.29 12.29C2.5 12.11 2.74 12 3 12M12.71 20.71L15.82 17.6C16.21 17.21 16.21 16.57 15.82 16.18C15.43 15.79 14.8 15.79 14.41 16.18L12 18.59L9.59 16.18C9.2 15.79 8.57 15.79 8.18 16.18C7.79 16.57 7.79 17.21 8.18 17.6L11.29 20.71C11.5 20.9 11.74 21 12 21C12.26 21 12.5 20.9 12.71 20.71Z";
var mdiWeatherMoonsetUp = "M3 12H7C7 10.67 7.53 9.4 8.46 8.46C9.4 7.53 10.67 7 12 7C13.33 7 14.6 7.53 15.54 8.46C16.47 9.4 17 10.67 17 12H21C21.27 12 21.5 12.11 21.71 12.29C21.9 12.5 22 12.74 22 13C22 13.27 21.9 13.5 21.71 13.71C21.5 13.9 21.27 14 21 14H3C2.74 14 2.5 13.9 2.29 13.71C2.11 13.5 2 13.27 2 13C2 12.74 2.11 12.5 2.29 12.29C2.5 12.11 2.74 12 3 12M12.71 16.3L15.82 19.41C16.21 19.8 16.21 20.43 15.82 20.82C15.43 21.21 14.8 21.21 14.41 20.82L12 18.41L9.59 20.82C9.2 21.21 8.57 21.21 8.18 20.82C7.79 20.43 7.79 19.8 8.18 19.41L11.29 16.3C11.5 16.1 11.74 16 12 16C12.26 16 12.5 16.1 12.71 16.3Z";
var mdiWeatherNight = "M17.75,4.09L15.22,6.03L16.13,9.09L13.5,7.28L10.87,9.09L11.78,6.03L9.25,4.09L12.44,4L13.5,1L14.56,4L17.75,4.09M21.25,11L19.61,12.25L20.2,14.23L18.5,13.06L16.8,14.23L17.39,12.25L15.75,11L17.81,10.95L18.5,9L19.19,10.95L21.25,11M18.97,15.95C19.8,15.87 20.69,17.05 20.16,17.8C19.84,18.25 19.5,18.67 19.08,19.07C15.17,23 8.84,23 4.94,19.07C1.03,15.17 1.03,8.83 4.94,4.93C5.34,4.53 5.76,4.17 6.21,3.85C6.96,3.32 8.14,4.21 8.06,5.04C7.79,7.9 8.75,10.87 10.95,13.06C13.14,15.26 16.1,16.22 18.97,15.95M17.33,17.97C14.5,17.81 11.7,16.64 9.53,14.5C7.36,12.31 6.2,9.5 6.04,6.68C3.23,9.82 3.34,14.64 6.35,17.66C9.37,20.67 14.19,20.78 17.33,17.97Z";
var mdiWeatherNightPartlyCloudy = "M22,10.28C21.74,10.3 21.5,10.31 21.26,10.31C19.32,10.31 17.39,9.57 15.91,8.09C14.25,6.44 13.5,4.19 13.72,2C13.77,1.53 13.22,1 12.71,1C12.57,1 12.44,1.04 12.32,1.12C12,1.36 11.66,1.64 11.36,1.94C9.05,4.24 8.55,7.66 9.84,10.46C8.31,11.11 7.13,12.43 6.69,14.06L6,14A4,4 0 0,0 2,18A4,4 0 0,0 6,22H19A3,3 0 0,0 22,19A3,3 0 0,0 19,16C18.42,16 17.88,16.16 17.42,16.45L17.5,15.5C17.5,15.28 17.5,15.05 17.46,14.83C19.14,14.67 20.77,13.94 22.06,12.64C22.38,12.34 22.64,12 22.88,11.68C23.27,11.13 22.65,10.28 22.04,10.28M19,18A1,1 0 0,1 20,19A1,1 0 0,1 19,20H6A2,2 0 0,1 4,18A2,2 0 0,1 6,16H8.5V15.5C8.5,13.94 9.53,12.64 10.94,12.18C11.1,12.13 11.26,12.09 11.43,12.06C11.61,12.03 11.8,12 12,12C12.23,12 12.45,12.03 12.66,12.07C12.73,12.08 12.8,12.1 12.87,12.13C13,12.16 13.15,12.2 13.28,12.25C13.36,12.28 13.44,12.32 13.5,12.36C13.63,12.41 13.74,12.47 13.84,12.54C13.92,12.59 14,12.64 14.07,12.7C14.17,12.77 14.25,12.84 14.34,12.92C14.41,13 14.5,13.05 14.55,13.12C14.63,13.2 14.69,13.29 14.76,13.37C14.82,13.45 14.89,13.53 14.94,13.62C15,13.71 15.04,13.8 15.09,13.9C15.14,14 15.2,14.08 15.24,14.18C15.41,14.59 15.5,15.03 15.5,15.5V18M16.83,12.86C15.9,11.16 14.08,10 12,10H11.87C11.41,9.19 11.14,8.26 11.14,7.29C11.14,6.31 11.39,5.37 11.86,4.55C12.21,6.41 13.12,8.14 14.5,9.5C15.86,10.88 17.58,11.79 19.45,12.14C18.66,12.6 17.76,12.84 16.83,12.86Z";
var mdiWeatherPartlyCloudy = "M12.74,5.47C15.1,6.5 16.35,9.03 15.92,11.46C17.19,12.56 18,14.19 18,16V16.17C18.31,16.06 18.65,16 19,16A3,3 0 0,1 22,19A3,3 0 0,1 19,22H6A4,4 0 0,1 2,18A4,4 0 0,1 6,14H6.27C5,12.45 4.6,10.24 5.5,8.26C6.72,5.5 9.97,4.24 12.74,5.47M11.93,7.3C10.16,6.5 8.09,7.31 7.31,9.07C6.85,10.09 6.93,11.22 7.41,12.13C8.5,10.83 10.16,10 12,10C12.7,10 13.38,10.12 14,10.34C13.94,9.06 13.18,7.86 11.93,7.3M13.55,3.64C13,3.4 12.45,3.23 11.88,3.12L14.37,1.82L15.27,4.71C14.76,4.29 14.19,3.93 13.55,3.64M6.09,4.44C5.6,4.79 5.17,5.19 4.8,5.63L4.91,2.82L7.87,3.5C7.25,3.71 6.65,4.03 6.09,4.44M18,9.71C17.91,9.12 17.78,8.55 17.59,8L19.97,9.5L17.92,11.73C18.03,11.08 18.05,10.4 18,9.71M3.04,11.3C3.11,11.9 3.24,12.47 3.43,13L1.06,11.5L3.1,9.28C3,9.93 2.97,10.61 3.04,11.3M19,18H16V16A4,4 0 0,0 12,12A4,4 0 0,0 8,16H6A2,2 0 0,0 4,18A2,2 0 0,0 6,20H19A1,1 0 0,0 20,19A1,1 0 0,0 19,18Z";
var mdiWeatherPartlyLightning = "M19,15C18.65,15 18.31,15.06 18,15.17V15C18,13.19 17.19,11.56 15.92,10.46C16.35,8.03 15.1,5.5 12.75,4.47C9.97,3.24 6.72,4.5 5.5,7.25C4.6,9.24 5,11.45 6.27,13H6A4,4 0 0,0 2,17A4,4 0 0,0 6,21H7C7,21 8,21 8,20C8,19 7,19 7,19H6A2,2 0 0,1 4,17A2,2 0 0,1 6,15H8A4,4 0 0,1 12,11A4,4 0 0,1 16,15V17H19A1,1 0 0,1 20,18A1,1 0 0,1 19,19H17C17,19 16,19 16,20C16,21 17,21 17,21H19A3,3 0 0,0 22,18A3,3 0 0,0 19,15M12,9C10.16,9 8.5,9.83 7.41,11.13C6.93,10.22 6.85,9.09 7.31,8.07C8.09,6.31 10.16,5.5 11.93,6.3C13.18,6.86 13.94,8.06 14,9.34C13.38,9.12 12.7,9 12,9M13.55,2.63C13,2.4 12.45,2.23 11.88,2.12L14.37,0.82L15.27,3.71C14.76,3.29 14.19,2.93 13.55,2.63M6.09,3.44C5.6,3.79 5.17,4.19 4.8,4.63L4.91,1.82L7.87,2.5C7.25,2.71 6.65,3.03 6.09,3.44M18,8.71C17.91,8.12 17.78,7.55 17.59,7L19.97,8.5L17.92,10.73C18.03,10.08 18.05,9.4 18,8.71M3.04,10.3C3.11,10.9 3.25,11.47 3.43,12L1.06,10.5L3.1,8.28C3,8.93 2.97,9.61 3.04,10.3M11.8,15H14.25L12.61,18.27H14.25L11.18,24L11.8,19.91H9.75";
var mdiWeatherPartlyRainy = "M12.75,4.47C15.1,5.5 16.35,8.03 15.92,10.46C17.19,11.56 18,13.19 18,15V15.17C18.31,15.06 18.65,15 19,15A3,3 0 0,1 22,18A3,3 0 0,1 19,21H17C17,21 16,21 16,20C16,19 17,19 17,19H19A1,1 0 0,0 20,18A1,1 0 0,0 19,17H16V15A4,4 0 0,0 12,11A4,4 0 0,0 8,15H6A2,2 0 0,0 4,17A2,2 0 0,0 6,19H7C7,19 8,19 8,20C8,21 7,21 7,21H6A4,4 0 0,1 2,17A4,4 0 0,1 6,13H6.27C5,11.45 4.6,9.24 5.5,7.25C6.72,4.5 9.97,3.24 12.75,4.47M11.93,6.3C10.16,5.5 8.09,6.31 7.31,8.07C6.85,9.09 6.93,10.22 7.41,11.13C8.5,9.83 10.16,9 12,9C12.7,9 13.38,9.12 14,9.34C13.94,8.06 13.18,6.86 11.93,6.3M13.55,2.63C13,2.4 12.45,2.23 11.88,2.12L14.37,0.82L15.27,3.71C14.76,3.29 14.19,2.93 13.55,2.63M6.09,3.44C5.6,3.79 5.17,4.19 4.8,4.63L4.91,1.82L7.87,2.5C7.25,2.71 6.65,3.03 6.09,3.44M18,8.71C17.91,8.12 17.78,7.55 17.59,7L19.97,8.5L17.92,10.73C18.03,10.08 18.05,9.4 18,8.71M3.04,10.3C3.11,10.9 3.25,11.47 3.43,12L1.06,10.5L3.1,8.28C3,8.93 2.97,9.61 3.04,10.3M12,18.91C12.59,19.82 13,20.63 13,21A1,1 0 0,1 12,22A1,1 0 0,1 11,21C11,20.63 11.41,19.82 12,18.91M12,15.62C12,15.62 9,19 9,21A3,3 0 0,0 12,24A3,3 0 0,0 15,21C15,19 12,15.62 12,15.62Z";
var mdiWeatherPartlySnowy = "M6,19.03A2,2 0 0,1 4,17.03C4,15.92 4.9,15.03 6,15.03H8C8,12.81 9.79,11.03 12,11.03A4,4 0 0,1 16,15.03V17.03H19A1,1 0 0,1 20,18.03C20,18.57 19.55,19.03 19,19.03H17C17,19.03 16,19.03 16,20.03C16,21.03 17,21.03 17,21.03H19A3,3 0 0,0 22,18.03C22,16.37 20.66,15.03 19,15.03C18.65,15.03 18.31,15.08 18,15.19V15.03C18,13.21 17.19,11.58 15.92,10.5C16.35,8.05 15.1,5.53 12.75,4.5C9.97,3.27 6.72,4.53 5.5,7.28C4.6,9.27 5,11.47 6.27,13.03H6C3.79,13.03 2,14.81 2,17.03A4,4 0 0,0 6,21.03C6,21.03 7,21.03 7,20.03C7,19.03 6,19.03 6,19.03M12,9.03C10.16,9.03 8.5,9.85 7.41,11.16C6.93,10.25 6.85,9.11 7.31,8.09C8.09,6.33 10.16,5.53 11.93,6.32C13.18,6.89 13.94,8.08 14,9.37C13.38,9.15 12.7,9.03 12,9.03M13.55,2.66C13,2.42 12.45,2.26 11.88,2.15L14.37,0.84L15.27,3.73C14.76,3.31 14.19,2.95 13.55,2.66M6.09,3.46C5.6,3.81 5.17,4.21 4.8,4.66L4.91,1.84L7.87,2.53C7.25,2.73 6.65,3.05 6.09,3.46M18,8.73C17.91,8.15 17.78,7.57 17.59,7.03L19.97,8.53L17.92,10.76C18.03,10.1 18.05,9.42 18,8.73M3.04,10.32C3.11,10.92 3.25,11.5 3.43,12.03L1.06,10.53L3.1,8.3C3,8.95 2.97,9.64 3.04,10.32M8.03,21.45C8.13,21.84 8.53,22.06 8.91,21.96L10.5,21.54L10.06,23.11C9.96,23.5 10.19,23.9 10.57,24C10.95,24.1 11.35,23.87 11.45,23.5L11.87,21.91L13.03,23.07C13.3,23.35 13.77,23.35 14.05,23.07C14.33,22.79 14.33,22.32 14.05,22.05L12.89,20.88L14.47,20.47C14.85,20.37 15.08,19.97 15,19.59C14.88,19.21 14.5,19 14.09,19.08L12.5,19.5L12.94,17.93C13.04,17.54 12.82,17.15 12.43,17.05C12.05,16.95 11.66,17.17 11.55,17.56L11.14,19.14L10,17.97C9.7,17.69 9.23,17.69 8.95,17.97C8.68,18.27 8.68,18.72 8.95,19L10.11,20.16L8.54,20.57C8.15,20.68 7.93,21.07 8.03,21.45Z";
var mdiWeatherPartlySnowyRainy = "M13.55,2.66C13,2.42 12.45,2.26 11.88,2.15L14.37,0.84L15.27,3.73C14.76,3.31 14.19,2.95 13.55,2.66M6.09,3.46C5.6,3.81 5.17,4.21 4.8,4.66L4.91,1.84L7.87,2.53C7.25,2.73 6.65,3.05 6.09,3.46M18,8.73C17.91,8.15 17.78,7.57 17.59,7.03L19.97,8.53L17.92,10.76C18.03,10.1 18.05,9.42 18,8.73M3.04,10.32C3.11,10.92 3.25,11.5 3.43,12.03L1.06,10.53L3.1,8.3C3,8.95 2.97,9.64 3.04,10.32M16.68,22.21C16.68,23.2 15.91,24 14.95,24C14,24 13.23,23.2 13.23,22.21C13.23,21.03 14.95,19.03 14.95,19.03C14.95,19.03 16.68,21.03 16.68,22.21M6.03,21.45C5.93,21.07 6.15,20.68 6.54,20.58L8.13,20.15L6.96,19C6.68,18.72 6.68,18.27 6.96,18C7.23,17.7 7.7,17.7 8,18L9.14,19.14L9.55,17.56C9.65,17.17 10.05,16.94 10.43,17.05C10.82,17.15 11.05,17.55 10.93,17.93L10.5,19.5L12.1,19.1C12.5,19 12.88,19.21 13,19.6C13.08,19.97 12.86,20.37 12.47,20.47L10.89,20.89L12.05,22.05C12.33,22.32 12.33,22.79 12.05,23.07C11.77,23.35 11.31,23.35 11.03,23.07L9.87,21.9L9.45,23.5C9.35,23.88 8.95,24.1 8.57,24C8.18,23.9 7.97,23.5 8.06,23.12L8.5,21.55L6.91,21.96C6.5,22.06 6.13,21.84 6.03,21.45M19,15.03C18.65,15.03 18.31,15.08 18,15.19V15.03C18,13.21 17.19,11.58 15.92,10.5C16.35,8.05 15.1,5.53 12.75,4.5C9.97,3.27 6.72,4.53 5.5,7.28C4.6,9.27 5,11.47 6.27,13.03H6C3.79,13.03 2,14.81 2,17.03C2,18.17 2.5,19.2 3.27,19.93V19.93C3.27,19.93 3.97,20.64 4.68,19.93C5.39,19.22 4.68,18.5 4.68,18.5C4.27,18.15 4,17.62 4,17.03C4,15.92 4.9,15.03 6,15.03H8C8,12.81 9.79,11.03 12,11.03A4,4 0 0,1 16,15.03V17.03H19A1,1 0 0,1 20,18.03C20,18.57 19.55,19.03 19,19.03H18C18,19.03 17,19.03 17,20.03C17,21.03 18,21.03 18,21.03H19A3,3 0 0,0 22,18.03C22,16.37 20.66,15.03 19,15.03M12,9.03C10.16,9.03 8.5,9.85 7.41,11.16C6.93,10.25 6.85,9.11 7.31,8.09C8.09,6.33 10.16,5.53 11.93,6.32C13.18,6.89 13.94,8.08 14,9.37C13.38,9.15 12.7,9.03 12,9.03Z";
var mdiWeatherPouring = "M9,12C9.53,12.14 9.85,12.69 9.71,13.22L8.41,18.05C8.27,18.59 7.72,18.9 7.19,18.76C6.65,18.62 6.34,18.07 6.5,17.54L7.78,12.71C7.92,12.17 8.47,11.86 9,12M13,12C13.53,12.14 13.85,12.69 13.71,13.22L11.64,20.95C11.5,21.5 10.95,21.8 10.41,21.66C9.88,21.5 9.56,20.97 9.7,20.43L11.78,12.71C11.92,12.17 12.47,11.86 13,12M17,12C17.53,12.14 17.85,12.69 17.71,13.22L16.41,18.05C16.27,18.59 15.72,18.9 15.19,18.76C14.65,18.62 14.34,18.07 14.5,17.54L15.78,12.71C15.92,12.17 16.47,11.86 17,12M17,10V9A5,5 0 0,0 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8A3,3 0 0,0 3,11C3,12.11 3.6,13.08 4.5,13.6V13.59C5,13.87 5.14,14.5 4.87,14.96C4.59,15.43 4,15.6 3.5,15.32V15.33C2,14.47 1,12.85 1,11A5,5 0 0,1 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8A4,4 0 0,1 23,12C23,13.5 22.2,14.77 21,15.46V15.46C20.5,15.73 19.91,15.57 19.63,15.09C19.36,14.61 19.5,14 20,13.72V13.73C20.6,13.39 21,12.74 21,12A2,2 0 0,0 19,10H17Z";
var mdiWeatherRainy = "M6,14.03A1,1 0 0,1 7,15.03C7,15.58 6.55,16.03 6,16.03C3.24,16.03 1,13.79 1,11.03C1,8.27 3.24,6.03 6,6.03C7,3.68 9.3,2.03 12,2.03C15.43,2.03 18.24,4.69 18.5,8.06L19,8.03A4,4 0 0,1 23,12.03C23,14.23 21.21,16.03 19,16.03H18C17.45,16.03 17,15.58 17,15.03C17,14.47 17.45,14.03 18,14.03H19A2,2 0 0,0 21,12.03A2,2 0 0,0 19,10.03H17V9.03C17,6.27 14.76,4.03 12,4.03C9.5,4.03 7.45,5.84 7.06,8.21C6.73,8.09 6.37,8.03 6,8.03A3,3 0 0,0 3,11.03A3,3 0 0,0 6,14.03M12,14.15C12.18,14.39 12.37,14.66 12.56,14.94C13,15.56 14,17.03 14,18C14,19.11 13.1,20 12,20A2,2 0 0,1 10,18C10,17.03 11,15.56 11.44,14.94C11.63,14.66 11.82,14.4 12,14.15M12,11.03L11.5,11.59C11.5,11.59 10.65,12.55 9.79,13.81C8.93,15.06 8,16.56 8,18A4,4 0 0,0 12,22A4,4 0 0,0 16,18C16,16.56 15.07,15.06 14.21,13.81C13.35,12.55 12.5,11.59 12.5,11.59";
var mdiWeatherSnowy = "M6,14A1,1 0 0,1 7,15A1,1 0 0,1 6,16A5,5 0 0,1 1,11A5,5 0 0,1 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8A4,4 0 0,1 23,12A4,4 0 0,1 19,16H18A1,1 0 0,1 17,15A1,1 0 0,1 18,14H19A2,2 0 0,0 21,12A2,2 0 0,0 19,10H17V9A5,5 0 0,0 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8A3,3 0 0,0 3,11A3,3 0 0,0 6,14M7.88,18.07L10.07,17.5L8.46,15.88C8.07,15.5 8.07,14.86 8.46,14.46C8.85,14.07 9.5,14.07 9.88,14.46L11.5,16.07L12.07,13.88C12.21,13.34 12.76,13.03 13.29,13.17C13.83,13.31 14.14,13.86 14,14.4L13.41,16.59L15.6,16C16.14,15.86 16.69,16.17 16.83,16.71C16.97,17.24 16.66,17.79 16.12,17.93L13.93,18.5L15.54,20.12C15.93,20.5 15.93,21.15 15.54,21.54C15.15,21.93 14.5,21.93 14.12,21.54L12.5,19.93L11.93,22.12C11.79,22.66 11.24,22.97 10.71,22.83C10.17,22.69 9.86,22.14 10,21.6L10.59,19.41L8.4,20C7.86,20.14 7.31,19.83 7.17,19.29C7.03,18.76 7.34,18.21 7.88,18.07Z";
var mdiWeatherSnowyHeavy = "M4,16.36C3.86,15.82 4.18,15.25 4.73,15.11L7,14.5L5.33,12.86C4.93,12.46 4.93,11.81 5.33,11.4C5.73,11 6.4,11 6.79,11.4L8.45,13.05L9.04,10.8C9.18,10.24 9.75,9.92 10.29,10.07C10.85,10.21 11.17,10.78 11,11.33L10.42,13.58L12.67,13C13.22,12.83 13.79,13.15 13.93,13.71C14.08,14.25 13.76,14.82 13.2,14.96L10.95,15.55L12.6,17.21C13,17.6 13,18.27 12.6,18.67C12.2,19.07 11.54,19.07 11.15,18.67L9.5,17L8.89,19.27C8.75,19.83 8.18,20.14 7.64,20C7.08,19.86 6.77,19.29 6.91,18.74L7.5,16.5L5.26,17.09C4.71,17.23 4.14,16.92 4,16.36M1,10A5,5 0 0,1 6,5C7,2.65 9.3,1 12,1C15.43,1 18.24,3.66 18.5,7.03L19,7A4,4 0 0,1 23,11A4,4 0 0,1 19,15A1,1 0 0,1 18,14A1,1 0 0,1 19,13A2,2 0 0,0 21,11A2,2 0 0,0 19,9H17V8A5,5 0 0,0 12,3C9.5,3 7.45,4.82 7.06,7.19C6.73,7.07 6.37,7 6,7A3,3 0 0,0 3,10C3,10.85 3.35,11.61 3.91,12.16C4.27,12.55 4.26,13.16 3.88,13.54C3.5,13.93 2.85,13.93 2.47,13.54C1.56,12.63 1,11.38 1,10M14.03,20.43C14.13,20.82 14.5,21.04 14.91,20.94L16.5,20.5L16.06,22.09C15.96,22.5 16.18,22.87 16.57,22.97C16.95,23.08 17.35,22.85 17.45,22.46L17.86,20.89L19.03,22.05C19.3,22.33 19.77,22.33 20.05,22.05C20.33,21.77 20.33,21.3 20.05,21.03L18.89,19.86L20.46,19.45C20.85,19.35 21.08,18.95 20.97,18.57C20.87,18.18 20.5,17.96 20.09,18.06L18.5,18.5L18.94,16.91C19.04,16.5 18.82,16.13 18.43,16.03C18.05,15.92 17.65,16.15 17.55,16.54L17.14,18.11L15.97,16.95C15.7,16.67 15.23,16.67 14.95,16.95C14.67,17.24 14.67,17.7 14.95,17.97L16.11,19.14L14.54,19.55C14.15,19.65 13.92,20.05 14.03,20.43Z";
var mdiWeatherSnowyRainy = "M18.5,18.67C18.5,19.96 17.5,21 16.25,21C15,21 14,19.96 14,18.67C14,17.12 16.25,14.5 16.25,14.5C16.25,14.5 18.5,17.12 18.5,18.67M4,17.36C3.86,16.82 4.18,16.25 4.73,16.11L7,15.5L5.33,13.86C4.93,13.46 4.93,12.81 5.33,12.4C5.73,12 6.4,12 6.79,12.4L8.45,14.05L9.04,11.8C9.18,11.24 9.75,10.92 10.29,11.07C10.85,11.21 11.17,11.78 11,12.33L10.42,14.58L12.67,14C13.22,13.83 13.79,14.15 13.93,14.71C14.08,15.25 13.76,15.82 13.2,15.96L10.95,16.55L12.6,18.21C13,18.6 13,19.27 12.6,19.67C12.2,20.07 11.54,20.07 11.15,19.67L9.5,18L8.89,20.27C8.75,20.83 8.18,21.14 7.64,21C7.08,20.86 6.77,20.29 6.91,19.74L7.5,17.5L5.26,18.09C4.71,18.23 4.14,17.92 4,17.36M1,11A5,5 0 0,1 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8A4,4 0 0,1 23,12A4,4 0 0,1 19,16A1,1 0 0,1 18,15A1,1 0 0,1 19,14A2,2 0 0,0 21,12A2,2 0 0,0 19,10H17V9A5,5 0 0,0 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8A3,3 0 0,0 3,11C3,11.85 3.35,12.61 3.91,13.16C4.27,13.55 4.26,14.16 3.88,14.54C3.5,14.93 2.85,14.93 2.47,14.54C1.56,13.63 1,12.38 1,11Z";
var mdiWeatherSunny = "M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M3.36,17L5.12,13.23C5.26,14 5.53,14.78 5.95,15.5C6.37,16.24 6.91,16.86 7.5,17.37L3.36,17M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M20.64,17L16.5,17.36C17.09,16.85 17.62,16.22 18.04,15.5C18.46,14.77 18.73,14 18.87,13.21L20.64,17M12,22L9.59,18.56C10.33,18.83 11.14,19 12,19C12.82,19 13.63,18.83 14.37,18.56L12,22Z";
var mdiWeatherSunnyAlert = "M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M3.36,17L5.12,13.23C5.26,14 5.53,14.78 5.95,15.5C6.37,16.24 6.91,16.86 7.5,17.37L3.36,17M12,22L9.59,18.56C10.33,18.83 11.14,19 12,19C12.82,19 13.63,18.83 14.37,18.56M19,13V7H21V13H19M19,17V15H21V17";
var mdiWeatherSunnyOff = "M22.11 21.46L2.39 1.73L1.11 3L4.97 6.86L3.34 7L5.11 10.79C5.25 10 5.5 9.24 5.94 8.5C6 8.36 6.13 8.24 6.22 8.11L7.66 9.55C7.25 10.27 7 11.11 7 12C7 14.76 9.24 17 12 17C12.9 17 13.73 16.75 14.45 16.34L20.84 22.73L22.11 21.46M12 15C10.34 15 9 13.66 9 12C9 11.67 9.07 11.36 9.17 11.06L12.94 14.83C12.64 14.93 12.33 15 12 15M18.05 8.5C17.63 7.78 17.1 7.15 16.5 6.64L20.65 7L18.88 10.79C18.74 10 18.47 9.23 18.05 8.5M12 7C14.76 7 17 9.24 17 12C17 12.54 16.89 13.05 16.74 13.54L15 11.78C14.87 10.3 13.7 9.13 12.22 9L10.47 7.27C10.95 7.11 11.46 7 12 7M12 5C11.16 5 10.35 5.15 9.61 5.42L12 2L14.39 5.42C13.65 5.15 12.84 5 12 5M18.87 13.21L20.64 17L20.24 17.04L18.25 15.05C18.54 14.45 18.76 13.84 18.87 13.21M12 19C12.82 19 13.63 18.83 14.37 18.56L12 22L9.59 18.56C10.33 18.83 11.14 19 12 19M5.95 15.5C6.37 16.24 6.91 16.86 7.5 17.37L3.36 17L5.12 13.23C5.26 14 5.53 14.78 5.95 15.5Z";
var mdiWeatherSunset = "M3,12H7A5,5 0 0,1 12,7A5,5 0 0,1 17,12H21A1,1 0 0,1 22,13A1,1 0 0,1 21,14H3A1,1 0 0,1 2,13A1,1 0 0,1 3,12M5,16H19A1,1 0 0,1 20,17A1,1 0 0,1 19,18H5A1,1 0 0,1 4,17A1,1 0 0,1 5,16M17,20A1,1 0 0,1 18,21A1,1 0 0,1 17,22H7A1,1 0 0,1 6,21A1,1 0 0,1 7,20H17M15,12A3,3 0 0,0 12,9A3,3 0 0,0 9,12H15M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7Z";
var mdiWeatherSunsetDown = "M3,12H7A5,5 0 0,1 12,7A5,5 0 0,1 17,12H21A1,1 0 0,1 22,13A1,1 0 0,1 21,14H3A1,1 0 0,1 2,13A1,1 0 0,1 3,12M15,12A3,3 0 0,0 12,9A3,3 0 0,0 9,12H15M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M12.71,20.71L15.82,17.6C16.21,17.21 16.21,16.57 15.82,16.18C15.43,15.79 14.8,15.79 14.41,16.18L12,18.59L9.59,16.18C9.2,15.79 8.57,15.79 8.18,16.18C7.79,16.57 7.79,17.21 8.18,17.6L11.29,20.71C11.5,20.9 11.74,21 12,21C12.26,21 12.5,20.9 12.71,20.71Z";
var mdiWeatherSunsetUp = "M3,12H7A5,5 0 0,1 12,7A5,5 0 0,1 17,12H21A1,1 0 0,1 22,13A1,1 0 0,1 21,14H3A1,1 0 0,1 2,13A1,1 0 0,1 3,12M15,12A3,3 0 0,0 12,9A3,3 0 0,0 9,12H15M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M12.71,16.3L15.82,19.41C16.21,19.8 16.21,20.43 15.82,20.82C15.43,21.21 14.8,21.21 14.41,20.82L12,18.41L9.59,20.82C9.2,21.21 8.57,21.21 8.18,20.82C7.79,20.43 7.79,19.8 8.18,19.41L11.29,16.3C11.5,16.1 11.74,16 12,16C12.26,16 12.5,16.1 12.71,16.3Z";
var mdiWeatherTornado = "M21,5H3A1,1 0 0,1 2,4A1,1 0 0,1 3,3H21A1,1 0 0,1 22,4A1,1 0 0,1 21,5M20,8A1,1 0 0,0 19,7H5A1,1 0 0,0 4,8A1,1 0 0,0 5,9H19A1,1 0 0,0 20,8M21,12A1,1 0 0,0 20,11H10A1,1 0 0,0 9,12A1,1 0 0,0 10,13H20A1,1 0 0,0 21,12M16,16A1,1 0 0,0 15,15H9A1,1 0 0,0 8,16A1,1 0 0,0 9,17H15A1,1 0 0,0 16,16M13,20A1,1 0 0,0 12,19H10A1,1 0 0,0 9,20A1,1 0 0,0 10,21H12A1,1 0 0,0 13,20Z";
var mdiWeatherWindy = "M4,10A1,1 0 0,1 3,9A1,1 0 0,1 4,8H12A2,2 0 0,0 14,6A2,2 0 0,0 12,4C11.45,4 10.95,4.22 10.59,4.59C10.2,5 9.56,5 9.17,4.59C8.78,4.2 8.78,3.56 9.17,3.17C9.9,2.45 10.9,2 12,2A4,4 0 0,1 16,6A4,4 0 0,1 12,10H4M19,12A1,1 0 0,0 20,11A1,1 0 0,0 19,10C18.72,10 18.47,10.11 18.29,10.29C17.9,10.68 17.27,10.68 16.88,10.29C16.5,9.9 16.5,9.27 16.88,8.88C17.42,8.34 18.17,8 19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14H5A1,1 0 0,1 4,13A1,1 0 0,1 5,12H19M18,18H4A1,1 0 0,1 3,17A1,1 0 0,1 4,16H18A3,3 0 0,1 21,19A3,3 0 0,1 18,22C17.17,22 16.42,21.66 15.88,21.12C15.5,20.73 15.5,20.1 15.88,19.71C16.27,19.32 16.9,19.32 17.29,19.71C17.47,19.89 17.72,20 18,20A1,1 0 0,0 19,19A1,1 0 0,0 18,18Z";
var mdiWeatherWindyVariant = "M6,6L6.69,6.06C7.32,3.72 9.46,2 12,2A5.5,5.5 0 0,1 17.5,7.5L17.42,8.45C17.88,8.16 18.42,8 19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14H6A4,4 0 0,1 2,10A4,4 0 0,1 6,6M6,8A2,2 0 0,0 4,10A2,2 0 0,0 6,12H19A1,1 0 0,0 20,11A1,1 0 0,0 19,10H15.5V7.5A3.5,3.5 0 0,0 12,4A3.5,3.5 0 0,0 8.5,7.5V8H6M18,18H4A1,1 0 0,1 3,17A1,1 0 0,1 4,16H18A3,3 0 0,1 21,19A3,3 0 0,1 18,22C17.17,22 16.42,21.66 15.88,21.12C15.5,20.73 15.5,20.1 15.88,19.71C16.27,19.32 16.9,19.32 17.29,19.71C17.47,19.89 17.72,20 18,20A1,1 0 0,0 19,19A1,1 0 0,0 18,18Z";
var mdiWeb = "M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
var mdiWebBox = "M8.95 13.4H6.58A5.5 5.5 0 0 1 6.58 10.6H8.95A11.56 11.56 0 0 0 8.85 12A11.56 11.56 0 0 0 8.95 13.4M7.16 9.2H9.2A12.06 12.06 0 0 1 10.18 6.71A5.55 5.55 0 0 0 7.16 9.2M16.84 9.2A5.59 5.59 0 0 0 13.81 6.71A10.95 10.95 0 0 1 14.78 9.2M12 17.57A9.5 9.5 0 0 0 13.34 14.8H10.66A9.5 9.5 0 0 0 12 17.57M12 6.42A9.53 9.53 0 0 0 10.66 9.2H13.34A9.53 9.53 0 0 0 12 6.42M7.16 14.8A5.61 5.61 0 0 0 10.18 17.29A12.06 12.06 0 0 1 9.2 14.8M21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19A2 2 0 0 1 21 5M19 12A7 7 0 1 0 12 19A7 7 0 0 0 19 12M15.15 12A11.56 11.56 0 0 1 15.05 13.4H17.42A5.5 5.5 0 0 0 17.42 10.6H15.05A11.56 11.56 0 0 1 15.15 12M13.81 17.29A5.62 5.62 0 0 0 16.84 14.8H14.78A10.95 10.95 0 0 1 13.81 17.29M10.36 10.6A8.81 8.81 0 0 0 10.36 13.4H13.64A10.3 10.3 0 0 0 13.75 12A10.21 10.21 0 0 0 13.64 10.6Z";
var mdiWebCancel = "M13.82 14H9.66C9.56 13.34 9.5 12.68 9.5 12S9.56 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.5 14.46 13 14.4 13.46C15 12.96 15.72 12.57 16.5 12.32C16.5 12.21 16.5 12.11 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.06 20 12.12 20 12.18C20.7 12.35 21.35 12.63 21.95 13C22 12.68 22 12.34 22 12C22 6.5 17.5 2 12 2C6.47 2 2 6.5 2 12C2 17.5 6.5 22 12 22C12.34 22 12.68 22 13 21.95C12.59 21.29 12.29 20.55 12.13 19.75C12.09 19.82 12.05 19.89 12 19.96C11.17 18.76 10.5 17.43 10.09 16H12.5C12.81 15.25 13.26 14.58 13.82 14M18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.34 18.92 8M12 4.03C12.83 5.23 13.5 6.57 13.91 8H10.09C10.5 6.57 11.17 5.23 12 4.03M4.26 14C4.1 13.36 4 12.69 4 12S4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12S7.56 13.34 7.64 14H4.26M5.08 16H8C8.35 17.25 8.8 18.45 9.4 19.56C7.57 18.93 6.03 17.65 5.08 16M8 8H5.08C6.03 6.34 7.57 5.06 9.4 4.44C8.8 5.55 8.35 6.75 8 8M18.5 14C16 14 14 16 14 18.5S16 23 18.5 23 23 21 23 18.5 21 14 18.5 14M18.5 21.5C16.84 21.5 15.5 20.16 15.5 18.5C15.5 17.94 15.65 17.42 15.92 17L20 21.08C19.58 21.35 19.06 21.5 18.5 21.5M21.08 20L17 15.92C17.42 15.65 17.94 15.5 18.5 15.5C20.16 15.5 21.5 16.84 21.5 18.5C21.5 19.06 21.35 19.58 21.08 20Z";
var mdiWebCheck = "M16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.37 19.97 12.73 19.92 13.08C20.61 13.18 21.25 13.4 21.84 13.72C21.94 13.16 22 12.59 22 12C22 6.5 17.5 2 12 2C6.47 2 2 6.5 2 12C2 17.5 6.5 22 12 22C12.59 22 13.16 21.94 13.72 21.84C13.26 21 13 20.03 13 19C13 18.71 13.03 18.43 13.07 18.15C12.75 18.78 12.4 19.39 12 19.96C11.17 18.76 10.5 17.43 10.09 16H13.81C14.41 14.96 15.31 14.12 16.4 13.6C16.46 13.07 16.5 12.54 16.5 12M12 4.03C12.83 5.23 13.5 6.57 13.91 8H10.09C10.5 6.57 11.17 5.23 12 4.03M4.26 14C4.1 13.36 4 12.69 4 12S4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12S7.56 13.34 7.64 14H4.26M5.08 16H8C8.35 17.25 8.8 18.45 9.4 19.56C7.57 18.93 6.03 17.65 5.08 16M8 8H5.08C6.03 6.34 7.57 5.06 9.4 4.44C8.8 5.55 8.35 6.75 8 8M14.34 14H9.66C9.56 13.34 9.5 12.68 9.5 12S9.56 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12S14.43 13.34 14.34 14M14.59 4.44C16.43 5.07 17.96 6.34 18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44M22.5 17.25L17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25Z";
var mdiWebClock = "M15 12.5V16.5L18 18.5L18.75 17.25L16.5 15.75V12.5H15M22 12.39C22 12.26 22 12.13 22 12C22 6.5 17.5 2 12 2C6.47 2 2 6.5 2 12C2 17.5 6.5 22 12 22C12.13 22 12.24 22 12.37 21.97C13.43 22.62 14.67 23 16 23C19.86 23 23 19.86 23 16C23 14.68 22.62 13.44 22 12.39M19.76 10.11C19.7 10.07 19.65 10.04 19.59 10H19.74C19.75 10.03 19.75 10.07 19.76 10.11M18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.34 18.92 8M12 4.03C12.83 5.23 13.5 6.57 13.91 8H10.09C10.5 6.57 11.17 5.23 12 4.03M9.66 10H12.41C11.16 10.75 10.15 11.88 9.57 13.24C9.53 12.83 9.5 12.42 9.5 12C9.5 11.32 9.56 10.65 9.66 10M9.4 4.44C8.8 5.55 8.35 6.75 8 8H5.08C6.03 6.34 7.57 5.06 9.4 4.44M4.26 14C4.1 13.36 4 12.69 4 12S4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12S7.56 13.34 7.64 14H4.26M5.08 16H8C8.35 17.25 8.8 18.45 9.4 19.56C7.57 18.93 6.03 17.65 5.08 16M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21Z";
var mdiWebMinus = "M16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.37 19.97 12.73 19.92 13.08C20.61 13.18 21.25 13.4 21.84 13.72C21.94 13.16 22 12.59 22 12C22 6.5 17.5 2 12 2C6.47 2 2 6.5 2 12C2 17.5 6.5 22 12 22C12.59 22 13.16 21.94 13.72 21.84C13.26 21 13 20.03 13 19C13 18.71 13.03 18.43 13.07 18.15C12.75 18.78 12.4 19.39 12 19.96C11.17 18.76 10.5 17.43 10.09 16H13.81C14.41 14.96 15.31 14.12 16.4 13.6C16.46 13.07 16.5 12.54 16.5 12M12 4.03C12.83 5.23 13.5 6.57 13.91 8H10.09C10.5 6.57 11.17 5.23 12 4.03M4.26 14C4.1 13.36 4 12.69 4 12S4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12S7.56 13.34 7.64 14H4.26M5.08 16H8C8.35 17.25 8.8 18.45 9.4 19.56C7.57 18.93 6.03 17.65 5.08 16M8 8H5.08C6.03 6.34 7.57 5.06 9.4 4.44C8.8 5.55 8.35 6.75 8 8M14.34 14H9.66C9.56 13.34 9.5 12.68 9.5 12S9.56 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12S14.43 13.34 14.34 14M14.59 4.44C16.43 5.07 17.96 6.34 18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44M23 18V20H15V18H23Z";
var mdiWebOff = "M9.4 4.44C9.19 4.83 9 5.23 8.84 5.64L10.37 7.17C10.78 6.05 11.33 5 12 4.03C12.83 5.23 13.5 6.57 13.91 8H11.2L13.2 10H14.34C14.4 10.41 14.44 10.84 14.47 11.27L16.44 13.24C16.47 12.83 16.5 12.42 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12S19.9 13.36 19.74 14H17.2L20.5 17.28C21.44 15.75 22 13.94 22 12C22 6.5 17.5 2 12 2C10.06 2 8.25 2.56 6.72 3.5L8.18 5C8.57 4.77 9 4.58 9.4 4.44M18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.34 18.92 8M2.39 1.73L1.11 3L4.06 5.95C2.77 7.63 2 9.73 2 12C2 17.5 6.5 22 12 22C14.28 22 16.37 21.23 18.06 19.95L20.84 22.73L22.11 21.46L2.39 1.73M5.5 7.37L6.11 8H5.08C5.2 7.78 5.34 7.58 5.5 7.37M4.26 14C4.1 13.36 4 12.69 4 12S4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12S7.56 13.34 7.64 14H4.26M5.08 16H8C8.35 17.25 8.8 18.45 9.4 19.56C7.57 18.93 6.03 17.65 5.08 16M9.5 12C9.5 11.8 9.5 11.61 9.53 11.42L12.11 14H9.66C9.56 13.34 9.5 12.68 9.5 12M12 19.96C11.17 18.76 10.5 17.43 10.09 16H13.91C13.5 17.43 12.83 18.76 12 19.96M14.59 19.56C14.96 18.88 15.26 18.15 15.5 17.41L16.62 18.5C16 18.95 15.32 19.31 14.59 19.56Z";
var mdiWebPlus = "M16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.37 19.97 12.73 19.92 13.08C20.61 13.18 21.25 13.4 21.84 13.72C21.94 13.16 22 12.59 22 12C22 6.5 17.5 2 12 2C6.47 2 2 6.5 2 12C2 17.5 6.5 22 12 22C12.59 22 13.16 21.94 13.72 21.84C13.26 21 13 20.03 13 19C13 18.71 13.03 18.43 13.07 18.15C12.75 18.78 12.4 19.39 12 19.96C11.17 18.76 10.5 17.43 10.09 16H13.81C14.41 14.96 15.31 14.12 16.4 13.6C16.46 13.07 16.5 12.54 16.5 12M12 4.03C12.83 5.23 13.5 6.57 13.91 8H10.09C10.5 6.57 11.17 5.23 12 4.03M4.26 14C4.1 13.36 4 12.69 4 12S4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12S7.56 13.34 7.64 14H4.26M5.08 16H8C8.35 17.25 8.8 18.45 9.4 19.56C7.57 18.93 6.03 17.65 5.08 16M8 8H5.08C6.03 6.34 7.57 5.06 9.4 4.44C8.8 5.55 8.35 6.75 8 8M14.34 14H9.66C9.56 13.34 9.5 12.68 9.5 12S9.56 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12S14.43 13.34 14.34 14M14.59 4.44C16.43 5.07 17.96 6.34 18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44M23 18V20H20V23H18V20H15V18H18V15H20V18H23Z";
var mdiWebRefresh = "M13.82 14H9.66C9.56 13.34 9.5 12.68 9.5 12S9.56 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.5 14.46 13 14.4 13.46C15 12.96 15.72 12.57 16.5 12.32C16.5 12.21 16.5 12.11 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.06 20 12.12 20 12.18C20.7 12.35 21.35 12.63 21.95 13C22 12.68 22 12.34 22 12C22 6.5 17.5 2 12 2C6.47 2 2 6.5 2 12C2 17.5 6.5 22 12 22C12.34 22 12.68 22 13 21.95C12.59 21.29 12.29 20.55 12.13 19.75C12.09 19.82 12.05 19.89 12 19.96C11.17 18.76 10.5 17.43 10.09 16H12.5C12.81 15.25 13.26 14.58 13.82 14M18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.34 18.92 8M12 4.03C12.83 5.23 13.5 6.57 13.91 8H10.09C10.5 6.57 11.17 5.23 12 4.03M4.26 14C4.1 13.36 4 12.69 4 12S4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12S7.56 13.34 7.64 14H4.26M5.08 16H8C8.35 17.25 8.8 18.45 9.4 19.56C7.57 18.93 6.03 17.65 5.08 16M8 8H5.08C6.03 6.34 7.57 5.06 9.4 4.44C8.8 5.55 8.35 6.75 8 8M20.83 15.67L22 14.5V18.5H18L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5S16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5S15.79 14.5 18 14.5C19.11 14.5 20.11 14.95 20.83 15.67Z";
var mdiWebRemove = "M16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.37 19.97 12.73 19.92 13.08C20.61 13.18 21.25 13.4 21.84 13.72C21.94 13.16 22 12.59 22 12C22 6.5 17.5 2 12 2C6.47 2 2 6.5 2 12C2 17.5 6.5 22 12 22C12.59 22 13.16 21.94 13.72 21.84C13.26 21 13 20.03 13 19C13 18.71 13.03 18.43 13.07 18.15C12.75 18.78 12.4 19.39 12 19.96C11.17 18.76 10.5 17.43 10.09 16H13.81C14.41 14.96 15.31 14.12 16.4 13.6C16.46 13.07 16.5 12.54 16.5 12M12 4.03C12.83 5.23 13.5 6.57 13.91 8H10.09C10.5 6.57 11.17 5.23 12 4.03M4.26 14C4.1 13.36 4 12.69 4 12S4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12S7.56 13.34 7.64 14H4.26M5.08 16H8C8.35 17.25 8.8 18.45 9.4 19.56C7.57 18.93 6.03 17.65 5.08 16M8 8H5.08C6.03 6.34 7.57 5.06 9.4 4.44C8.8 5.55 8.35 6.75 8 8M14.34 14H9.66C9.56 13.34 9.5 12.68 9.5 12S9.56 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12S14.43 13.34 14.34 14M14.59 4.44C16.43 5.07 17.96 6.34 18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44M20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19Z";
var mdiWebSync = "M16.5 11.74C16.5 11.15 16.43 10.58 16.36 10H19.74C19.82 10.33 19.89 10.67 19.93 11C20.65 11.07 21.34 11.23 22 11.5C21.71 6.21 17.35 2 12 2C6.47 2 2 6.5 2 12C2 17.5 6.5 22 12 22C12.87 22 13.71 21.88 14.5 21.67C13.71 20.71 13.18 19.5 13.04 18.2C12.73 18.81 12.39 19.4 12 19.96C11.17 18.76 10.5 17.43 10.09 16H13.18C13.35 15.28 13.64 14.61 14.03 14H9.66C9.56 13.34 9.5 12.68 9.5 12S9.56 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.5 14.46 13 14.4 13.5C14.97 12.76 15.68 12.17 16.5 11.74M4.26 14C4.1 13.36 4 12.69 4 12S4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12S7.56 13.34 7.64 14H4.26M5.08 16H8C8.35 17.25 8.8 18.45 9.4 19.56C7.57 18.93 6.03 17.65 5.08 16M8 8H5.08C6.03 6.34 7.57 5.06 9.4 4.44C8.8 5.55 8.35 6.75 8 8M10.09 8C10.5 6.57 11.17 5.23 12 4.03C12.83 5.23 13.5 6.57 13.91 8H10.09M18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.34 18.92 8M23 17.5C23 18.32 22.75 19.08 22.33 19.71L21.24 18.62C21.41 18.28 21.5 17.9 21.5 17.5C21.5 16.12 20.38 15 19 15V16.5L16.75 14.25L19 12V13.5C21.21 13.5 23 15.29 23 17.5M19 18.5L21.25 20.75L19 23V21.5C16.79 21.5 15 19.71 15 17.5C15 16.68 15.25 15.92 15.67 15.29L16.76 16.38C16.59 16.72 16.5 17.1 16.5 17.5C16.5 18.88 17.62 20 19 20V18.5Z";
var mdiWebcam = "M12,2A7,7 0 0,1 19,9A7,7 0 0,1 12,16A7,7 0 0,1 5,9A7,7 0 0,1 12,2M12,4A5,5 0 0,0 7,9A5,5 0 0,0 12,14A5,5 0 0,0 17,9A5,5 0 0,0 12,4M12,6A3,3 0 0,1 15,9A3,3 0 0,1 12,12A3,3 0 0,1 9,9A3,3 0 0,1 12,6M6,22A2,2 0 0,1 4,20C4,19.62 4.1,19.27 4.29,18.97L6.11,15.81C7.69,17.17 9.75,18 12,18C14.25,18 16.31,17.17 17.89,15.81L19.71,18.97C19.9,19.27 20,19.62 20,20A2,2 0 0,1 18,22H6Z";
var mdiWebcamOff = "M12 6C13.66 6 15 7.34 15 9C15 9.78 14.7 10.5 14.21 11L10 6.79C10.5 6.3 11.22 6 12 6M12 4C14.76 4 17 6.24 17 9C17 10.33 16.47 11.53 15.62 12.42L17.04 13.84C18.25 12.59 19 10.88 19 9C19 5.13 15.87 2 12 2C10.12 2 8.41 2.75 7.16 3.96L8.58 5.38C9.47 4.53 10.67 4 12 4M22.11 21.46L20.84 22.73L19.46 21.35C19.1 21.75 18.58 22 18 22H6C4.89 22 4 21.11 4 20C4 19.62 4.1 19.27 4.29 18.97L6.11 15.81C7.69 17.17 9.75 18 12 18C13.21 18 14.37 17.75 15.43 17.32L13.85 15.74C13.26 15.91 12.64 16 12 16C8.13 16 5 12.87 5 9C5 8.36 5.09 7.74 5.26 7.15L1.11 3L2.39 1.73L22.11 21.46M12.1 14L7 8.9C7 8.93 7 8.97 7 9C7 11.76 9.24 14 12 14C12.03 14 12.07 14 12.1 14Z";
var mdiWebhook = "M10.46,19C9,21.07 6.15,21.59 4.09,20.15C2.04,18.71 1.56,15.84 3,13.75C3.87,12.5 5.21,11.83 6.58,11.77L6.63,13.2C5.72,13.27 4.84,13.74 4.27,14.56C3.27,16 3.58,17.94 4.95,18.91C6.33,19.87 8.26,19.5 9.26,18.07C9.57,17.62 9.75,17.13 9.82,16.63V15.62L15.4,15.58L15.47,15.47C16,14.55 17.15,14.23 18.05,14.75C18.95,15.27 19.26,16.43 18.73,17.35C18.2,18.26 17.04,18.58 16.14,18.06C15.73,17.83 15.44,17.46 15.31,17.04L11.24,17.06C11.13,17.73 10.87,18.38 10.46,19M17.74,11.86C20.27,12.17 22.07,14.44 21.76,16.93C21.45,19.43 19.15,21.2 16.62,20.89C15.13,20.71 13.9,19.86 13.19,18.68L14.43,17.96C14.92,18.73 15.75,19.28 16.75,19.41C18.5,19.62 20.05,18.43 20.26,16.76C20.47,15.09 19.23,13.56 17.5,13.35C16.96,13.29 16.44,13.36 15.97,13.53L15.12,13.97L12.54,9.2H12.32C11.26,9.16 10.44,8.29 10.47,7.25C10.5,6.21 11.4,5.4 12.45,5.44C13.5,5.5 14.33,6.35 14.3,7.39C14.28,7.83 14.11,8.23 13.84,8.54L15.74,12.05C16.36,11.85 17.04,11.78 17.74,11.86M8.25,9.14C7.25,6.79 8.31,4.1 10.62,3.12C12.94,2.14 15.62,3.25 16.62,5.6C17.21,6.97 17.09,8.47 16.42,9.67L15.18,8.95C15.6,8.14 15.67,7.15 15.27,6.22C14.59,4.62 12.78,3.85 11.23,4.5C9.67,5.16 8.97,7 9.65,8.6C9.93,9.26 10.4,9.77 10.97,10.11L11.36,10.32L8.29,15.31C8.32,15.36 8.36,15.42 8.39,15.5C8.88,16.41 8.54,17.56 7.62,18.05C6.71,18.54 5.56,18.18 5.06,17.24C4.57,16.31 4.91,15.16 5.83,14.67C6.22,14.46 6.65,14.41 7.06,14.5L9.37,10.73C8.9,10.3 8.5,9.76 8.25,9.14Z";
var mdiWebpack = "M20.45 17.39L12.36 21.97V18.4L17.4 15.63L20.45 17.39M21 16.89V7.31L18.04 9V15.18L21 16.89M3.55 17.39L11.64 21.96V18.4L6.6 15.63L3.55 17.39M3 16.89V7.31L5.96 9V15.18L3 16.89M3.35 6.69L11.64 2V5.45L6.33 8.37L6.28 8.39L3.35 6.69M20.65 6.69L12.36 2V5.45L17.67 8.38L17.71 8.4L20.65 6.69M11.64 17.59L6.67 14.85V9.44L11.64 12.31V17.59M12.36 17.59L17.33 14.86V9.44L12.36 12.31V17.59M7 8.81L12 6.06L17 8.81L12 11.69L7 8.81Z";
var mdiWebrtc = "M12 2C14.44 2 16.5 3.75 16.91 6.07L17.75 6C20.5 6 22.75 8.24 22.75 11C22.75 12.89 21.7 14.53 20.16 15.38C20.54 16.09 20.75 16.89 20.75 17.75C20.75 20.5 18.5 22.75 15.75 22.75C14.26 22.75 12.92 22.1 12 21.06C11.08 22.1 9.74 22.75 8.25 22.75C5.5 22.75 3.25 20.5 3.25 17.75C3.25 16.89 3.47 16.09 3.84 15.38C2.3 14.53 1.25 12.89 1.25 11C1.25 8.24 3.5 6 6.25 6L7.09 6.07C7.5 3.75 9.56 2 12 2M6.75 20.25L13.66 17H17C17.55 17 18 16.55 18 16V9C18 8.45 17.55 8 17 8H7C6.45 8 6 8.45 6 9V16C6 16.55 6.45 17 7 17H7.77L6.75 20.25Z";
var mdiWechat = "M9.5,4C5.36,4 2,6.69 2,10C2,11.89 3.08,13.56 4.78,14.66L4,17L6.5,15.5C7.39,15.81 8.37,16 9.41,16C9.15,15.37 9,14.7 9,14C9,10.69 12.13,8 16,8C16.19,8 16.38,8 16.56,8.03C15.54,5.69 12.78,4 9.5,4M6.5,6.5A1,1 0 0,1 7.5,7.5A1,1 0 0,1 6.5,8.5A1,1 0 0,1 5.5,7.5A1,1 0 0,1 6.5,6.5M11.5,6.5A1,1 0 0,1 12.5,7.5A1,1 0 0,1 11.5,8.5A1,1 0 0,1 10.5,7.5A1,1 0 0,1 11.5,6.5M16,9C12.69,9 10,11.24 10,14C10,16.76 12.69,19 16,19C16.67,19 17.31,18.92 17.91,18.75L20,20L19.38,18.13C20.95,17.22 22,15.71 22,14C22,11.24 19.31,9 16,9M14,11.5A1,1 0 0,1 15,12.5A1,1 0 0,1 14,13.5A1,1 0 0,1 13,12.5A1,1 0 0,1 14,11.5M18,11.5A1,1 0 0,1 19,12.5A1,1 0 0,1 18,13.5A1,1 0 0,1 17,12.5A1,1 0 0,1 18,11.5Z";
var mdiWeight = "M12,3A4,4 0 0,1 16,7C16,7.73 15.81,8.41 15.46,9H18C18.95,9 19.75,9.67 19.95,10.56C21.96,18.57 22,18.78 22,19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19C2,18.78 2.04,18.57 4.05,10.56C4.25,9.67 5.05,9 6,9H8.54C8.19,8.41 8,7.73 8,7A4,4 0 0,1 12,3M12,5A2,2 0 0,0 10,7A2,2 0 0,0 12,9A2,2 0 0,0 14,7A2,2 0 0,0 12,5Z";
var mdiWeightGram = "M19.95,10.56C19.75,9.67 18.95,9 18,9H15.46C15.81,8.41 16,7.73 16,7A4,4 0 0,0 12,3A4,4 0 0,0 8,7C8,7.73 8.19,8.41 8.54,9H6C5.05,9 4.25,9.67 4.05,10.56C2.04,18.57 2,18.78 2,19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19C22,18.78 21.96,18.57 19.95,10.56M12,5A2,2 0 0,1 14,7A2,2 0 0,1 12,9A2,2 0 0,1 10,7A2,2 0 0,1 12,5M15,13H11V17H13V14H15V19H11C9.89,19 9,18.11 9,17V13C9,11.89 9.89,11 11,11H15V13Z";
var mdiWeightKilogram = "M12,3A4,4 0 0,1 16,7C16,7.73 15.81,8.41 15.46,9H18C18.95,9 19.75,9.67 19.95,10.56C21.96,18.57 22,18.78 22,19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19C2,18.78 2.04,18.57 4.05,10.56C4.25,9.67 5.05,9 6,9H8.54C8.19,8.41 8,7.73 8,7A4,4 0 0,1 12,3M12,5A2,2 0 0,0 10,7A2,2 0 0,0 12,9A2,2 0 0,0 14,7A2,2 0 0,0 12,5M6,11V19H8V16.5L9,17.5V19H11V17L9,15L11,13V11H9V12.5L8,13.5V11H6M15,11C13.89,11 13,11.89 13,13V17C13,18.11 13.89,19 15,19H18V14H16V17H15V13H18V11H15Z";
var mdiWeightLifter = "M12 5C10.89 5 10 5.89 10 7S10.89 9 12 9 14 8.11 14 7 13.11 5 12 5M22 1V6H20V4H4V6H2V1H4V3H20V1H22M15 11.26V23H13V18H11V23H9V11.26C6.93 10.17 5.5 8 5.5 5.5L5.5 5H7.5L7.5 5.5C7.5 8 9.5 10 12 10S16.5 8 16.5 5.5L16.5 5H18.5L18.5 5.5C18.5 8 17.07 10.17 15 11.26Z";
var mdiWeightPound = "M12,3A4,4 0 0,1 16,7C16,7.73 15.81,8.41 15.46,9H18C18.95,9 19.75,9.67 19.95,10.56C21.96,18.57 22,18.78 22,19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19C2,18.78 2.04,18.57 4.05,10.56C4.25,9.67 5.05,9 6,9H8.54C8.19,8.41 8,7.73 8,7A4,4 0 0,1 12,3M12,5A2,2 0 0,0 10,7A2,2 0 0,0 12,9A2,2 0 0,0 14,7A2,2 0 0,0 12,5M6,11V19H11V17H8V11H6M13,11V19H16C17.11,19 18,18.11 18,17V16.5C18,15.93 17.75,15.38 17.32,15C17.75,14.62 18,14.07 18,13.5V13C18,11.89 17.11,11 16,11H13M15,13H16V14H15V13M15,16H16V17H15V16Z";
var mdiWhatsapp = "M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M8.53 7.33C8.37 7.33 8.1 7.39 7.87 7.64C7.65 7.89 7 8.5 7 9.71C7 10.93 7.89 12.1 8 12.27C8.14 12.44 9.76 14.94 12.25 16C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.68 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.04 14.27C16.97 14.17 16.81 14.11 16.56 14C16.31 13.86 15.09 13.26 14.87 13.18C14.64 13.1 14.5 13.06 14.31 13.3C14.15 13.55 13.67 14.11 13.53 14.27C13.38 14.44 13.24 14.46 13 14.34C12.74 14.21 11.94 13.95 11 13.11C10.26 12.45 9.77 11.64 9.62 11.39C9.5 11.15 9.61 11 9.73 10.89C9.84 10.78 10 10.6 10.1 10.45C10.23 10.31 10.27 10.2 10.35 10.04C10.43 9.87 10.39 9.73 10.33 9.61C10.27 9.5 9.77 8.26 9.56 7.77C9.36 7.29 9.16 7.35 9 7.34C8.86 7.34 8.7 7.33 8.53 7.33Z";
var mdiWheelBarrow = "M18 15.5C18.83 15.5 19.5 16.17 19.5 17S18.83 18.5 18 18.5 16.5 17.83 16.5 17 17.17 15.5 18 15.5M18 14C16.34 14 15 15.34 15 17S16.34 20 18 20C19.66 20 21 18.66 21 17S19.66 14 18 14M7 8L5 5H2V7H5.13L8 11.3V20H10L12.57 15H14.55C15.25 13.81 16.5 13 18 13C18.88 13 19.69 13.29 20.35 13.78L22 8H7M9.39 19H9V12.8L9.87 14.11C10.23 14.64 10.82 14.96 11.45 15L9.39 19Z";
var mdiWheelchair = "M14 16L15.32 17.76C14.32 19.68 12.31 21 10 21C6.69 21 4 18.31 4 15C4 12.57 5.46 10.5 7.55 9.55L7.76 11.72C6.71 12.44 6 13.63 6 15C6 17.21 7.79 19 10 19C11.86 19 13.41 17.72 13.86 16H14M19.55 16.11L18.3 16.73L15.5 13H10.91L10.71 11H14V9H10.5L10.2 6C11.21 5.88 12 5.04 12 4C12 2.9 11.11 2 10 2S8 2.9 8 4C8 4.03 8 4.07 8 4.1H8L9.1 15H14.5L17.7 19.27L20.45 17.9L19.55 16.11Z";
var mdiWheelchairAccessibility = "M18.4,11.2L14.3,11.4L16.6,8.8C16.8,8.5 16.9,8 16.8,7.5C16.7,7.2 16.6,6.9 16.3,6.7L10.9,3.5C10.5,3.2 9.9,3.3 9.5,3.6L6.8,6.1C6.3,6.6 6.2,7.3 6.7,7.8C7.1,8.3 7.9,8.3 8.4,7.9L10.4,6.1L12.3,7.2L8.1,11.5C8,11.6 8,11.7 7.9,11.7C7.4,11.9 6.9,12.1 6.5,12.4L8,13.9C8.5,13.7 9,13.5 9.5,13.5C11.4,13.5 13,15.1 13,17C13,17.6 12.9,18.1 12.6,18.5L14.1,20C14.7,19.1 15,18.1 15,17C15,15.8 14.6,14.6 13.9,13.7L17.2,13.4L17,18.2C16.9,18.9 17.4,19.4 18.1,19.5H18.2C18.8,19.5 19.3,19 19.4,18.4L19.6,12.5C19.6,12.2 19.5,11.8 19.3,11.6C19,11.3 18.7,11.2 18.4,11.2M18,5.5A2,2 0 0,0 20,3.5A2,2 0 0,0 18,1.5A2,2 0 0,0 16,3.5A2,2 0 0,0 18,5.5M12.5,21.6C11.6,22.2 10.6,22.5 9.5,22.5C6.5,22.5 4,20 4,17C4,15.9 4.3,14.9 4.9,14L6.4,15.5C6.2,16 6,16.5 6,17C6,18.9 7.6,20.5 9.5,20.5C10.1,20.5 10.6,20.4 11,20.1L12.5,21.6Z";
var mdiWhistle = "M8.5,9A6.5,6.5 0 0,0 2,15.5A6.5,6.5 0 0,0 8.5,22A6.5,6.5 0 0,0 15,15.5V13.91L22,12V9H11V11H9V9H8.5M11,2V7H9V2H11M6.35,7.28C5.68,7.44 5.04,7.68 4.43,8L2.14,4.88L3.76,3.7L6.35,7.28M17.86,4.88L16.32,7H13.85L16.24,3.7L17.86,4.88Z";
var mdiWhistleOutline = "M3.76 3.7L2.14 4.88L4.43 8A8.23 8.23 0 0 1 6.35 7.28M11 9V11H18V11.29L13 12.71V15.5A4.5 4.5 0 1 1 8.5 11H9V9H8.5A6.5 6.5 0 1 0 15 15.5V13.91L22 12V9M16.24 3.7L13.85 7H16.32L17.86 4.88M9 2V7H11V2Z";
var mdiWhiteBalanceAuto = "M10.3,16L9.6,14H6.4L5.7,16H3.8L7,7H9L12.2,16M22,7L20.8,13.29L19.3,7H17.7L16.21,13.29L15,7H14.24C12.77,5.17 10.5,4 8,4A8,8 0 0,0 0,12A8,8 0 0,0 8,20C11.13,20 13.84,18.19 15.15,15.57L15.25,16H17L18.5,9.9L20,16H21.75L23.8,7M6.85,12.65H9.15L8,9L6.85,12.65Z";
var mdiWhiteBalanceIncandescent = "M17.24,18.15L19.04,19.95L20.45,18.53L18.66,16.74M20,12.5H23V10.5H20M15,6.31V1.5H9V6.31C7.21,7.35 6,9.28 6,11.5A6,6 0 0,0 12,17.5A6,6 0 0,0 18,11.5C18,9.28 16.79,7.35 15,6.31M4,10.5H1V12.5H4M11,22.45C11.32,22.45 13,22.45 13,22.45V19.5H11M3.55,18.53L4.96,19.95L6.76,18.15L5.34,16.74L3.55,18.53Z";
var mdiWhiteBalanceIridescent = "M4.96,19.95L6.76,18.15L5.34,16.74L3.55,18.53M3.55,4.46L5.34,6.26L6.76,4.84L4.96,3.05M20.45,18.53L18.66,16.74L17.24,18.15L19.04,19.95M13,22.45V19.5H11V22.45C11.32,22.45 13,22.45 13,22.45M19.04,3.05L17.24,4.84L18.66,6.26L20.45,4.46M11,3.5H13V0.55H11M5,14.5H19V8.5H5V14.5Z";
var mdiWhiteBalanceSunny = "M3.55 19.09L4.96 20.5L6.76 18.71L5.34 17.29M12 6C8.69 6 6 8.69 6 12S8.69 18 12 18 18 15.31 18 12C18 8.68 15.31 6 12 6M20 13H23V11H20M17.24 18.71L19.04 20.5L20.45 19.09L18.66 17.29M20.45 5L19.04 3.6L17.24 5.39L18.66 6.81M13 1H11V4H13M6.76 5.39L4.96 3.6L3.55 5L5.34 6.81L6.76 5.39M1 13H4V11H1M13 20H11V23H13";
var mdiWidgets = "M3,3H11V7.34L16.66,1.69L22.31,7.34L16.66,13H21V21H13V13H16.66L11,7.34V11H3V3M3,13H11V21H3V13Z";
var mdiWidgetsOutline = "M16.7 4.5L19.5 7.3L16.7 10.1L13.9 7.3L16.7 4.5M9 5V9H5V5H9M19 15V19H15V15H19M16.7 1.7L11 7.3L16.7 13H13V21H21V13H16.7L22.3 7.3L16.7 1.7M11 3H3V11H11V3M9 15V19H5V15H9M11 13H3V21H11V13Z";
var mdiWifi = "M12,21L15.6,16.2C14.6,15.45 13.35,15 12,15C10.65,15 9.4,15.45 8.4,16.2L12,21M12,3C7.95,3 4.21,4.34 1.2,6.6L3,9C5.5,7.12 8.62,6 12,6C15.38,6 18.5,7.12 21,9L22.8,6.6C19.79,4.34 16.05,3 12,3M12,9C9.3,9 6.81,9.89 4.8,11.4L6.6,13.8C8.1,12.67 9.97,12 12,12C14.03,12 15.9,12.67 17.4,13.8L19.2,11.4C17.19,9.89 14.7,9 12,9Z";
var mdiWifiAlert = "M20.24 5H18V7.25C16.16 6.45 14.13 6 12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3C14.97 3 17.77 3.73 20.24 5M8.4 16.2L12 21L15.6 16.2C14.6 15.45 13.35 15 12 15S9.4 15.45 8.4 16.2M4.8 11.4L6.6 13.8C8.1 12.67 9.97 12 12 12S15.9 12.67 17.4 13.8L18 13V10.62C16.23 9.59 14.19 9 12 9C9.3 9 6.81 9.89 4.8 11.4M20 17H22V15H20V17M20 7V13H22V7H20Z";
var mdiWifiArrowDown = "M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3S19.79 4.34 22.8 6.6L21 9C18.5 7.12 15.38 6 12 6M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L13.04 19.61C13 19.41 13 19.21 13 19C13 17.66 13.44 16.43 14.19 15.43C13.5 15.16 12.77 15 12 15M16.84 13.41C17.18 13.27 17.55 13.17 17.92 13.1L19.2 11.4C17.19 9.89 14.7 9 12 9S6.81 9.89 4.8 11.4L6.6 13.8C8.1 12.67 9.97 12 12 12C13.78 12 15.44 12.5 16.84 13.41M20 16H18V20H16L19 23L22 20H20V16Z";
var mdiWifiArrowLeft = "M12 12C9.97 12 8.1 12.67 6.6 13.8L4.8 11.4C6.81 9.89 9.3 9 12 9S17.19 9.89 19.2 11.4L17.92 13.1C17.55 13.17 17.18 13.27 16.84 13.41C15.44 12.5 13.78 12 12 12M21 9L22.8 6.6C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9C5.5 7.12 8.62 6 12 6S18.5 7.12 21 9M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L13.04 19.61C13 19.41 13 19.21 13 19C13 17.66 13.44 16.43 14.19 15.43C13.5 15.16 12.77 15 12 15M18 16L15 19L18 22V20H22V18H18V16Z";
var mdiWifiArrowLeftRight = "M12 12C9.97 12 8.1 12.67 6.6 13.8L4.8 11.4C6.81 9.89 9.3 9 12 9S17.19 9.89 19.2 11.4L17.92 13.1C17.55 13.17 17.18 13.27 16.84 13.41C15.44 12.5 13.78 12 12 12M21 9L22.8 6.6C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9C5.5 7.12 8.62 6 12 6S18.5 7.12 21 9M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L13.04 19.61C13 19.41 13 19.21 13 19C13 17.66 13.44 16.43 14.19 15.43C13.5 15.16 12.77 15 12 15M18 18.5L15 21L18 23.5V22H22V20H18V18.5M23 17L20 14.5V16H16V18H20V19.5L23 17Z";
var mdiWifiArrowRight = "M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3S19.79 4.34 22.8 6.6L21 9C18.5 7.12 15.38 6 12 6M16.84 13.41C17.18 13.27 17.55 13.17 17.92 13.1L19.2 11.4C17.19 9.89 14.7 9 12 9S6.81 9.89 4.8 11.4L6.6 13.8C8.1 12.67 9.97 12 12 12C13.78 12 15.44 12.5 16.84 13.41M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L13.04 19.61C13 19.41 13 19.21 13 19C13 17.66 13.44 16.43 14.19 15.43C13.5 15.16 12.77 15 12 15M23 19L20 16V18H16V20H20V22L23 19Z";
var mdiWifiArrowUp = "M12 12C9.97 12 8.1 12.67 6.6 13.8L4.8 11.4C6.81 9.89 9.3 9 12 9S17.19 9.89 19.2 11.4L17.92 13.1C17.55 13.17 17.18 13.27 16.84 13.41C15.44 12.5 13.78 12 12 12M21 9L22.8 6.6C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9C5.5 7.12 8.62 6 12 6S18.5 7.12 21 9M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L13.04 19.61C13 19.41 13 19.21 13 19C13 17.66 13.44 16.43 14.19 15.43C13.5 15.16 12.77 15 12 15M16 18H18V22H20V18H22L19 15L16 18Z";
var mdiWifiArrowUpDown = "M12 12C9.97 12 8.1 12.67 6.6 13.8L4.8 11.4C6.81 9.89 9.3 9 12 9S17.19 9.89 19.2 11.4L17.92 13.1C17.55 13.17 17.18 13.27 16.84 13.41C15.44 12.5 13.78 12 12 12M21 9L22.8 6.6C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9C5.5 7.12 8.62 6 12 6S18.5 7.12 21 9M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L13.04 19.61C13 19.41 13 19.21 13 19C13 17.66 13.44 16.43 14.19 15.43C13.5 15.16 12.77 15 12 15M17 15L14.5 18H16V22H18V18H19.5L17 15M22 20V16H20V20H18.5L21 23L23.5 20H22Z";
var mdiWifiCancel = "M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3S19.79 4.34 22.8 6.6L21 9C18.5 7.12 15.38 6 12 6M15.53 12.72C16.42 12.26 17.43 12 18.5 12C18.58 12 18.66 12 18.74 12L19.2 11.4C17.19 9.89 14.7 9 12 9S6.81 9.89 4.8 11.4L6.6 13.8C8.1 12.67 9.97 12 12 12C13.26 12 14.45 12.26 15.53 12.72M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L12.34 20.54C12.13 19.9 12 19.22 12 18.5C12 17.24 12.36 16.08 13 15.08C12.66 15.03 12.33 15 12 15M23 18.5C23 21 21 23 18.5 23S14 21 14 18.5 16 14 18.5 14 23 16 23 18.5M20 21.08L15.92 17C15.65 17.42 15.5 17.94 15.5 18.5C15.5 20.16 16.84 21.5 18.5 21.5C19.06 21.5 19.58 21.35 20 21.08M21.5 18.5C21.5 16.84 20.16 15.5 18.5 15.5C17.94 15.5 17.42 15.65 17 15.92L21.08 20C21.35 19.58 21.5 19.06 21.5 18.5Z";
var mdiWifiCheck = "M12 12C9.97 12 8.1 12.67 6.6 13.8L4.8 11.4C6.81 9.89 9.3 9 12 9S17.19 9.89 19.2 11.4L17.92 13.1C17.55 13.17 17.18 13.27 16.84 13.41C15.44 12.5 13.78 12 12 12M21 9L22.8 6.6C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9C5.5 7.12 8.62 6 12 6S18.5 7.12 21 9M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L13.04 19.61C13 19.41 13 19.21 13 19C13 17.66 13.44 16.43 14.19 15.43C13.5 15.16 12.77 15 12 15M17.75 19.43L16.16 17.84L15 19L17.75 22L22.5 17.25L21.34 15.84L17.75 19.43Z";
var mdiWifiCog = "M12 12C9.97 12 8.1 12.67 6.6 13.8L4.8 11.4C6.81 9.89 9.3 9 12 9S17.19 9.89 19.2 11.4L18.74 12C17.66 12.05 16.63 12.33 15.73 12.81C14.6 12.29 13.33 12 12 12M21 9L22.8 6.6C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9C5.5 7.12 8.62 6 12 6S18.5 7.12 21 9M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L12.22 20.71C12.08 20.16 12 19.59 12 19C12 17.57 12.43 16.24 13.17 15.13C12.79 15.05 12.4 15 12 15M23.8 20.4C23.9 20.4 23.9 20.5 23.8 20.6L22.8 22.3C22.7 22.4 22.6 22.4 22.5 22.4L21.3 22C21 22.2 20.8 22.3 20.5 22.5L20.3 23.8C20.3 23.9 20.2 24 20.1 24H18.1C18 24 17.9 23.9 17.8 23.8L17.6 22.5C17.3 22.4 17 22.2 16.8 22L15.6 22.5C15.5 22.5 15.4 22.5 15.3 22.4L14.3 20.7C14.2 20.6 14.3 20.5 14.4 20.4L15.5 19.6V18.6L14.4 17.8C14.3 17.7 14.3 17.6 14.3 17.5L15.3 15.8C15.4 15.7 15.5 15.7 15.6 15.7L16.8 16.2C17.1 16 17.3 15.9 17.6 15.7L17.8 14.4C17.8 14.3 17.9 14.2 18.1 14.2H20.1C20.2 14.2 20.3 14.3 20.3 14.4L20.5 15.7C20.8 15.8 21.1 16 21.4 16.2L22.6 15.7C22.7 15.7 22.9 15.7 22.9 15.8L23.9 17.5C24 17.6 23.9 17.7 23.8 17.8L22.7 18.6V19.6L23.8 20.4M20.5 19C20.5 18.2 19.8 17.5 19 17.5S17.5 18.2 17.5 19 18.2 20.5 19 20.5 20.5 19.8 20.5 19Z";
var mdiWifiLock = "M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3S19.79 4.34 22.8 6.6L21 9C18.5 7.12 15.38 6 12 6M17.4 10.29C15.77 9.47 13.94 9 12 9C9.3 9 6.81 9.89 4.8 11.4L6.6 13.8C8.1 12.67 9.97 12 12 12C12.97 12 13.9 12.16 14.78 12.44C15.34 11.45 16.27 10.68 17.4 10.29M8.4 16.2L12 21L13 19.67V17.2C13 16.5 13.27 15.81 13.7 15.26C13.16 15.1 12.59 15 12 15C10.65 15 9.4 15.45 8.4 16.2M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiWifiLockOpen = "M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3S19.79 4.34 22.8 6.6L21 9C18.5 7.12 15.38 6 12 6M16.31 9.81C14.97 9.29 13.5 9 12 9C9.3 9 6.81 9.89 4.8 11.4L6.6 13.8C8.1 12.67 9.97 12 12 12C12.83 12 13.63 12.12 14.39 12.33C14.7 11.3 15.38 10.41 16.31 9.81M8.4 16.2L12 21L13 19.67V17.2C13 16.5 13.27 15.81 13.7 15.26C13.16 15.1 12.59 15 12 15C10.65 15 9.4 15.45 8.4 16.2M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiWifiMarker = "M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3S19.79 4.34 22.8 6.6L21 9C18.5 7.12 15.38 6 12 6M13 15.09C12.69 15.03 12.35 15 12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L13.8 18.6C13.33 17.58 13 16.5 13 15.5C13 15.36 13 15.23 13 15.09M12 9C9.3 9 6.81 9.89 4.8 11.4L6.6 13.8C8.1 12.67 9.97 12 12 12C12.73 12 13.43 12.09 14.1 12.25C14.86 11.25 15.93 10.5 17.17 10.18C15.6 9.43 13.85 9 12 9M22 15.5C22 18.1 18.5 22 18.5 22S15 18.1 15 15.5C15 13.6 16.6 12 18.5 12S22 13.6 22 15.5M19.7 15.6C19.7 15 19.1 14.4 18.5 14.4S17.3 14.9 17.3 15.6C17.3 16.2 17.8 16.8 18.5 16.8S19.8 16.2 19.7 15.6Z";
var mdiWifiMinus = "M12 12C9.97 12 8.1 12.67 6.6 13.8L4.8 11.4C6.81 9.89 9.3 9 12 9S17.19 9.89 19.2 11.4L17.92 13.1C17.55 13.17 17.18 13.27 16.84 13.41C15.44 12.5 13.78 12 12 12M21 9L22.8 6.6C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9C5.5 7.12 8.62 6 12 6S18.5 7.12 21 9M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L13.04 19.61C13 19.41 13 19.21 13 19C13 17.66 13.44 16.43 14.19 15.43C13.5 15.16 12.77 15 12 15M15 18V20H23V18H15Z";
var mdiWifiOff = "M2.28,3L1,4.27L2.47,5.74C2.04,6 1.61,6.29 1.2,6.6L3,9C3.53,8.6 4.08,8.25 4.66,7.93L6.89,10.16C6.15,10.5 5.44,10.91 4.8,11.4L6.6,13.8C7.38,13.22 8.26,12.77 9.2,12.47L11.75,15C10.5,15.07 9.34,15.5 8.4,16.2L12,21L14.46,17.73L17.74,21L19,19.72M12,3C9.85,3 7.8,3.38 5.9,4.07L8.29,6.47C9.5,6.16 10.72,6 12,6C15.38,6 18.5,7.11 21,9L22.8,6.6C19.79,4.34 16.06,3 12,3M12,9C11.62,9 11.25,9 10.88,9.05L14.07,12.25C15.29,12.53 16.43,13.07 17.4,13.8L19.2,11.4C17.2,9.89 14.7,9 12,9Z";
var mdiWifiPlus = "M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3S19.79 4.34 22.8 6.6L21 9C18.5 7.12 15.38 6 12 6M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L13.04 19.61C13 19.41 13 19.21 13 19C13 17.66 13.44 16.43 14.19 15.43C13.5 15.16 12.77 15 12 15M16.84 13.41C17.18 13.27 17.55 13.17 17.92 13.1L19.2 11.4C17.19 9.89 14.7 9 12 9S6.81 9.89 4.8 11.4L6.6 13.8C8.1 12.67 9.97 12 12 12C13.78 12 15.44 12.5 16.84 13.41M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z";
var mdiWifiRefresh = "M12 12C9.97 12 8.1 12.67 6.6 13.8L4.8 11.4C6.81 9.89 9.3 9 12 9S17.19 9.89 19.2 11.4L18.74 12C18.66 12 18.58 12 18.5 12C17.43 12 16.42 12.26 15.53 12.72C14.45 12.26 13.26 12 12 12M21 9L22.8 6.6C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9C5.5 7.12 8.62 6 12 6S18.5 7.12 21 9M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L12.34 20.54C12.13 19.9 12 19.22 12 18.5C12 17.24 12.36 16.08 13 15.08C12.66 15.03 12.33 15 12 15M18 14.5C15.79 14.5 14 16.29 14 18.5S15.79 22.5 18 22.5C19.68 22.5 21.12 21.47 21.71 20H20C19.54 20.61 18.82 21 18 21C16.62 21 15.5 19.88 15.5 18.5S16.62 16 18 16C18.69 16 19.32 16.28 19.77 16.73L18 18.5H22V14.5L20.83 15.67C20.11 14.95 19.11 14.5 18 14.5Z";
var mdiWifiRemove = "M12 12C9.97 12 8.1 12.67 6.6 13.8L4.8 11.4C6.81 9.89 9.3 9 12 9S17.19 9.89 19.2 11.4L17.92 13.1C17.55 13.17 17.18 13.27 16.84 13.41C15.44 12.5 13.78 12 12 12M21 9L22.8 6.6C19.79 4.34 16.05 3 12 3S4.21 4.34 1.2 6.6L3 9C5.5 7.12 8.62 6 12 6S18.5 7.12 21 9M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L13.04 19.61C13 19.41 13 19.21 13 19C13 17.66 13.44 16.43 14.19 15.43C13.5 15.16 12.77 15 12 15M21.12 15.46L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88L21.12 15.46Z";
var mdiWifiSettings = "M12 20L8.4 15.2C9.4 14.45 10.65 14 12 14S14.6 14.45 15.6 15.2L12 20M4.8 10.4L6.6 12.8C8.1 11.67 9.97 11 12 11S15.9 11.67 17.4 12.8L19.2 10.4C17.19 8.89 14.7 8 12 8S6.81 8.89 4.8 10.4M12 2C7.95 2 4.21 3.34 1.2 5.6L3 8C5.5 6.12 8.62 5 12 5S18.5 6.12 21 8L22.8 5.6C19.79 3.34 16.05 2 12 2M7 24H9V22H7V24M15 24H17V22H15V24M11 24H13V22H11V24Z";
var mdiWifiStar = "M12,6C8.6,6 5.5,7.1 3,9L1.2,6.6C4.2,4.3 8,3 12,3C16,3 19.8,4.3 22.8,6.6L21,9C18.5,7.1 15.4,6 12,6M13,19C13,17.7 13.4,16.4 14.2,15.4C13.5,15.2 12.8,15 12,15C10.7,15 9.4,15.5 8.4,16.2L12,21L13,19.6C13,19.4 13,19.2 13,19M16.8,13.4C17.1,13.3 17.5,13.2 17.9,13.1L19.2,11.4C17.2,9.9 14.7,9 12,9C9.3,9 6.8,9.9 4.8,11.4L6.6,13.8C8.1,12.7 10,12 12,12C13.8,12 15.4,12.5 16.8,13.4M16.5,22.6L17.2,19.8L15,17.9L17.9,17.7L19,15L20.1,17.6L23,17.8L20.8,19.7L21.5,22.5L19,21.1L16.5,22.6Z";
var mdiWifiStrength1 = "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L15.61,13.81C14.5,13.28 13.25,13 12,13C10.75,13 9.5,13.28 8.39,13.8L3.27,7.44C5.91,5.85 8.93,5 12,5Z";
var mdiWifiStrength1Alert = "M12 3C7.8 3 3.7 4.4 .4 7C4.4 12.1 7.9 16.4 12 21.5C14.4 18.5 16.7 15.7 19 12.8V9.6L15.6 13.8C14.5 13.3 13.2 13 12 13S9.5 13.3 8.4 13.8L3.3 7.4C5.9 5.8 8.9 5 12 5S18.1 5.9 20.7 7.4L20.3 8H22.9C23.1 7.7 23.5 7.3 23.7 7C20.3 4.4 16.2 3 12 3M21 10V16H23V10M21 18V20H23V18";
var mdiWifiStrength1Lock = "M12 13C12.8 13 13.61 13.13 14.38 13.36C14.28 13.73 14.2 14.11 14.2 14.5V14.74C13.5 15.34 13 16.24 13 17.2V20.24L12 21.5C7.88 16.37 4.39 12.06 .365 7C3.69 4.41 7.78 3 12 3C16.2 3 20.31 4.41 23.64 7L20.91 10.39C20.32 10.14 19.68 10 19 10C18.87 10 18.75 10.03 18.62 10.04L20.7 7.45C18.08 5.86 15.06 5 12 5S5.9 5.85 3.26 7.44L8.38 13.8C9.5 13.28 10.74 13 12 13M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiWifiStrength1LockOpen = "M12 13C12.74 13 13.5 13.12 14.22 13.31C14.22 13.38 14.2 13.44 14.2 13.5V14.74C13.5 15.34 13 16.24 13 17.2V20.24L12 21.5C7.88 16.37 4.39 12.06 .365 7C3.69 4.41 7.78 3 12 3C16.2 3 20.31 4.41 23.64 7L21.5 9.69C20.86 9.33 20.16 9.11 19.42 9.04L20.7 7.45C18.08 5.86 15.06 5 12 5S5.9 5.85 3.26 7.44L8.38 13.8C9.5 13.28 10.74 13 12 13M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiWifiStrength2 = "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L17.5,11.43C16.26,10.74 14.37,10 12,10C9.62,10 7.74,10.75 6.5,11.43L3.27,7.44C5.91,5.85 8.93,5 12,5Z";
var mdiWifiStrength2Alert = "M12 3C7.8 3 3.7 4.4 .4 7C4.4 12.1 7.9 16.4 12 21.5C14.4 18.5 16.7 15.7 19 12.8V9.6L17.5 11.4C16.3 10.7 14.4 10 12 10C9.6 10 7.7 10.8 6.5 11.4L3.3 7.4C5.9 5.8 8.9 5 12 5S18.1 5.9 20.7 7.4L20.3 8H22.9C23.1 7.7 23.5 7.3 23.7 7C20.3 4.4 16.2 3 12 3M21 10V16H23V10M21 18V20H23V18";
var mdiWifiStrength2Lock = "M14.2 14.5V14.74C13.5 15.34 13 16.24 13 17.2V20.24L12 21.5C7.88 16.37 4.39 12.06 .365 7C3.69 4.41 7.78 3 12 3C16.2 3 20.31 4.41 23.64 7L20.91 10.39C20.32 10.14 19.68 10 19 10C18.87 10 18.74 10.03 18.61 10.04L20.7 7.45C18.08 5.86 15.06 5 12 5S5.9 5.85 3.26 7.44L6.5 11.43C7.73 10.75 9.61 10 12 10C13.68 10 15.12 10.38 16.26 10.84C15.03 11.67 14.2 13 14.2 14.5M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiWifiStrength2LockOpen = "M15.44 10.55C14.68 11.35 14.2 12.38 14.2 13.5V14.74C13.5 15.34 13 16.24 13 17.2V20.24L12 21.5C7.88 16.37 4.39 12.06 .365 7C3.69 4.41 7.78 3 12 3C16.2 3 20.31 4.41 23.64 7L21.5 9.69C20.86 9.33 20.16 9.1 19.41 9.04L20.7 7.45C18.08 5.86 15.06 5 12 5S5.9 5.85 3.26 7.44L6.5 11.43C7.73 10.75 9.61 10 12 10C13.29 10 14.45 10.23 15.44 10.55M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiWifiStrength3 = "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L18.77,9.88C17.26,9 14.88,8 12,8C9,8 6.68,9 5.21,9.84L3.27,7.44C5.91,5.85 8.93,5 12,5Z";
var mdiWifiStrength3Alert = "M12 3C7.8 3 3.7 4.4 .4 7C4.4 12.1 7.9 16.4 12 21.5C14.4 18.5 16.7 15.7 19 12.8V9.6L18.8 9.9C17.3 9 14.9 8 12 8C9 8 6.7 9 5.2 9.8L3.3 7.4C5.9 5.8 8.9 5 12 5S18.1 5.9 20.7 7.4L20.3 8H22.9C23.1 7.7 23.5 7.3 23.7 7C20.3 4.4 16.2 3 12 3M21 10V16H23V10M21 18V20H23V18";
var mdiWifiStrength3Lock = "M19 10C19.68 10 20.32 10.14 20.91 10.39L23.64 7C20.31 4.41 16.2 3 12 3C7.78 3 3.69 4.41 .365 7C4.39 12.06 7.88 16.37 12 21.5L13 20.24V17.2C13 16.24 13.5 15.34 14.2 14.74V14.5C14.2 12.06 16.4 10 19 10M12 8C9 8 6.67 9 5.2 9.84L3.26 7.44C5.9 5.85 8.91 5 12 5S18.08 5.86 20.7 7.45L18.76 9.88C17.25 9 14.87 8 12 8M21.8 16V14.5C21.8 13.1 20.4 12 19 12S16.2 13.1 16.2 14.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16M20.5 16H17.5V14.5C17.5 13.7 18.2 13.2 19 13.2S20.5 13.7 20.5 14.5V16Z";
var mdiWifiStrength3LockOpen = "M14.2 13.5V14.74C13.5 15.34 13 16.24 13 17.2V20.24L12 21.5C7.88 16.37 4.39 12.06 .365 7C3.69 4.41 7.78 3 12 3C16.2 3 20.31 4.41 23.64 7L21.5 9.69C20.86 9.33 20.17 9.11 19.42 9.04L20.7 7.45C18.08 5.86 15.06 5 12 5S5.9 5.85 3.26 7.44L5.2 9.84C6.67 9 9 8 12 8C14.18 8 16.08 8.58 17.53 9.25C15.63 9.85 14.2 11.54 14.2 13.5M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiWifiStrength4 = "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3Z";
var mdiWifiStrength4Alert = "M12 3C7.8 3 3.7 4.4 .4 7C4.4 12.1 7.9 16.4 12 21.5C14.4 18.5 16.7 15.7 19 12.8V8H22.8C23 7.7 23.4 7.3 23.6 7C20.3 4.4 16.2 3 12 3M21 10V16H23V10M21 18V20H23V18";
var mdiWifiStrength4Lock = "M14.2 14.5V14.74C13.5 15.34 13 16.24 13 17.2V20.24L12 21.5C7.88 16.37 4.39 12.06 .365 7C3.69 4.41 7.78 3 12 3C16.2 3 20.31 4.41 23.64 7L20.91 10.39C20.32 10.14 19.68 10 19 10C16.4 10 14.2 12.06 14.2 14.5M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiWifiStrength4LockOpen = "M14.2 13.5V14.74C13.5 15.34 13 16.24 13 17.2V20.24L12 21.5C7.88 16.37 4.39 12.06 .365 7C3.69 4.41 7.78 3 12 3C16.2 3 20.31 4.41 23.64 7L21.5 9.69C20.75 9.26 19.9 9 19 9C16.4 9 14.2 11.06 14.2 13.5M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiWifiStrengthAlertOutline = "M12 3C7.8 3 3.7 4.4 .4 7C4.3 11.8 8.2 16.7 12 21.5C14.3 18.6 16.7 15.7 19 12.8V9.6L12 18.3L3.3 7.4C5.9 5.8 8.9 5 12 5C15.1 5 18.1 5.9 20.7 7.4L20.3 8H22.9C23.2 7.7 23.4 7.3 23.7 7C20.3 4.4 16.2 3 12 3M21 10V16H23V10M21 18V20H23V18";
var mdiWifiStrengthLockOpenOutline = "M23.65 7H23.64C22.92 7.9 22.2 8.79 21.5 9.69C20.87 9.33 20.17 9.11 19.43 9.04L20.71 7.45C18.09 5.86 15.07 5 12 5C8.91 5 5.9 5.85 3.27 7.44L12 18.3L13 17C13 17.08 13 17.14 13 17.2V20.25L12 21.5C8.13 16.66 4.24 11.83 .355 7H.375C3.7 4.41 7.79 3 12 3C16.22 3 20.32 4.41 23.65 7M21.8 16H17.5V13.5C17.5 12.7 18.2 12.2 19 12.2S20.5 12.7 20.5 13.5V14H21.8V13.5C21.8 12.1 20.4 11 19 11S16.2 12.1 16.2 13.5V16C15.6 16 15 16.6 15 17.2V20.7C15 21.4 15.6 22 16.2 22H21.7C22.4 22 23 21.4 23 20.8V17.3C23 16.6 22.4 16 21.8 16Z";
var mdiWifiStrengthLockOutline = "M23.65 7H23.64L20.91 10.39C20.32 10.14 19.68 10 19 10C18.87 10 18.75 10.03 18.63 10.04L20.71 7.45C18.09 5.86 15.07 5 12 5C8.91 5 5.9 5.85 3.27 7.44L12 18.3L13 17C13 17.08 13 17.14 13 17.2V20.25L12 21.5C8.13 16.66 4.24 11.83 .355 7H.375C3.7 4.41 7.79 3 12 3C16.22 3 20.32 4.41 23.65 7M23 17.3V20.8C23 21.4 22.4 22 21.7 22H16.2C15.6 22 15 21.4 15 20.7V17.2C15 16.6 15.6 16 16.2 16V14.5C16.2 13.1 17.6 12 19 12S21.8 13.1 21.8 14.5V16C22.4 16 23 16.6 23 17.3M20.5 14.5C20.5 13.7 19.8 13.2 19 13.2S17.5 13.7 17.5 14.5V16H20.5V14.5Z";
var mdiWifiStrengthOff = "M3.27,1.44L2,2.72L4.05,4.77C2.75,5.37 1.5,6.11 0.38,7C4.41,12.06 12,21.5 12,21.5L15.91,16.63L19.23,19.95L20.5,18.68M12,3C10.6,3 9.21,3.17 7.86,3.5L18.18,13.81C20,11.5 22.05,9 23.65,7C20.32,4.41 16.22,3 12,3Z";
var mdiWifiStrengthOffOutline = "M3.27,1.44L2,2.72L4.05,4.77C2.75,5.37 1.5,6.11 0.38,7C4.2,11.8 8.14,16.67 12,21.5L15.91,16.63L19.23,19.95L20.5,18.68C14.87,13.04 3.27,1.44 3.27,1.44M12,3C10.6,3 9.21,3.17 7.86,3.5L9.56,5.19C10.37,5.07 11.18,5 12,5C15.07,5 18.09,5.86 20.71,7.45L16.76,12.38L18.18,13.8C20.08,11.43 22,9 23.65,7C20.32,4.41 16.22,3 12,3M5.57,6.29L14.5,15.21L12,18.3L3.27,7.44C4,7 4.78,6.61 5.57,6.29Z";
var mdiWifiStrengthOutline = "M12,3C7.79,3 3.7,4.41 0.38,7H0.36C4.24,11.83 8.13,16.66 12,21.5C15.89,16.66 19.77,11.83 23.64,7H23.65C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L12,18.3L3.27,7.44C5.9,5.85 8.92,5 12,5Z";
var mdiWifiSync = "M12 6C8.62 6 5.5 7.12 3 9L1.2 6.6C4.21 4.34 7.95 3 12 3S19.79 4.34 22.8 6.6L21 9C18.5 7.12 15.38 6 12 6M12 15C10.65 15 9.4 15.45 8.4 16.2L12 21L13.26 19.32C13.1 18.74 13 18.13 13 17.5C13 16.69 13.16 15.91 13.43 15.19C12.97 15.08 12.5 15 12 15M15.23 12.61C16.19 11.77 17.38 11.22 18.7 11.05C16.78 9.76 14.5 9 12 9C9.3 9 6.81 9.89 4.8 11.4L6.6 13.8C8.1 12.67 9.97 12 12 12C13.14 12 14.23 12.22 15.23 12.61M19 20C17.62 20 16.5 18.88 16.5 17.5C16.5 17.1 16.59 16.72 16.76 16.38L15.67 15.29C15.25 15.92 15 16.68 15 17.5C15 19.71 16.79 21.5 19 21.5V23L21.25 20.75L19 18.5V20M19 13.5V12L16.75 14.25L19 16.5V15C20.38 15 21.5 16.12 21.5 17.5C21.5 17.9 21.41 18.28 21.24 18.62L22.33 19.71C22.75 19.08 23 18.32 23 17.5C23 15.29 21.21 13.5 19 13.5Z";
var mdiWikipedia = "M14.97,18.95L12.41,12.92C11.39,14.91 10.27,17 9.31,18.95C9.3,18.96 8.84,18.95 8.84,18.95C7.37,15.5 5.85,12.1 4.37,8.68C4.03,7.84 2.83,6.5 2,6.5C2,6.4 2,6.18 2,6.05H7.06V6.5C6.46,6.5 5.44,6.9 5.7,7.55C6.42,9.09 8.94,15.06 9.63,16.58C10.1,15.64 11.43,13.16 12,12.11C11.55,11.23 10.13,7.93 9.71,7.11C9.39,6.57 8.58,6.5 7.96,6.5C7.96,6.35 7.97,6.25 7.96,6.06L12.42,6.07V6.47C11.81,6.5 11.24,6.71 11.5,7.29C12.1,8.53 12.45,9.42 13,10.57C13.17,10.23 14.07,8.38 14.5,7.41C14.76,6.76 14.37,6.5 13.29,6.5C13.3,6.38 13.3,6.17 13.3,6.07C14.69,6.06 16.78,6.06 17.15,6.05V6.47C16.44,6.5 15.71,6.88 15.33,7.46L13.5,11.3C13.68,11.81 15.46,15.76 15.65,16.2L19.5,7.37C19.2,6.65 18.34,6.5 18,6.5C18,6.37 18,6.2 18,6.05L22,6.08V6.1L22,6.5C21.12,6.5 20.57,7 20.25,7.75C19.45,9.54 17,15.24 15.4,18.95C15.4,18.95 14.97,18.95 14.97,18.95Z";
var mdiWindPower = "M4 3H10V5H4V3M1 7H6V9H1V7M3 19H8V21H3V19M13.73 10.61C14.5 10.84 15.03 11.39 15.3 12.07L19.57 4.96C20.22 3.88 19.87 2.5 18.79 1.83C17.92 1.31 16.8 1.42 16.06 2.12L12.63 5.33C12.23 5.7 12 6.23 12 6.78V10.71C12.36 10.56 13 10.38 13.73 10.61M10.61 12.27C10.77 11.75 11.09 11.31 11.5 11H3.28C2 11 1 12 1 13.28C1 14.3 1.67 15.19 2.65 15.47L7.16 16.76C7.69 16.91 8.26 16.84 8.74 16.55L11.43 14.94C10.66 14.32 10.3 13.27 10.61 12.27M22.21 18.61L19.93 14.5C19.66 14.03 19.2 13.68 18.67 13.54L15.5 12.74C15.5 13.06 15.5 13.4 15.39 13.73C15.07 14.79 14.11 15.5 13 15.5C12.39 15.5 12 15.28 12 15.28V21C10.9 21 10 21.9 10 23H16C16 21.9 15.1 21 14 21V16.72L18.61 21.33C19.5 22.22 20.94 22.22 21.83 21.33C22.55 20.61 22.71 19.5 22.21 18.61M12.56 14.43C13.35 14.67 14.19 14.23 14.43 13.43C14.67 12.64 14.23 11.8 13.43 11.56C12.64 11.32 11.8 11.76 11.56 12.56C11.32 13.35 11.77 14.19 12.56 14.43Z";
var mdiWindPowerOutline = "M4 3H10V5H4V3M1 7H6V9H1V7M3 19H8V21H3V19M22.21 18.61L19.93 14.5C19.66 14.03 19.2 13.68 18.67 13.54L16 12.87C15.96 12.4 15.84 11.95 15.61 11.54L19.57 4.95C20.22 3.87 19.87 2.47 18.79 1.82C18.43 1.6 18 1.5 17.62 1.5C17.06 1.5 16.5 1.71 16.06 2.12L12.63 5.33C12.23 5.7 12 6.23 12 6.78V10.18C11.53 10.35 11.11 10.63 10.77 11H3.28C2 11 1 12 1 13.28C1 14.3 1.67 15.19 2.65 15.47L7.16 16.76C7.34 16.81 7.53 16.84 7.71 16.84C8.07 16.84 8.43 16.74 8.74 16.55L11 15.21C11.27 15.47 11.61 15.68 12 15.82V21C10.9 21 10 21.9 10 23H16C16 21.9 15.1 21 14 21V16.72L18.61 21.33C19.06 21.78 19.64 22 20.22 22S21.39 21.78 21.83 21.33C22.55 20.61 22.71 19.5 22.21 18.61M7.72 14.84L3.2 13.55C3.08 13.5 3 13.4 3 13.28C3 13.13 3.13 13 3.28 13H10C10 13.15 10 13.3 10.04 13.44L7.72 14.84M13 14C12.45 14 12 13.55 12 13S12.45 12 13 12 14 12.45 14 13 13.55 14 13 14M14 10.14V6.78L17.43 3.57C17.5 3.5 17.62 3.45 17.77 3.53C17.9 3.61 17.95 3.78 17.87 3.91L14.13 10.15L14 10.14M20.42 19.92C20.37 19.97 20.18 20.08 20 19.92L15.17 15.07C15.25 15 15.33 14.89 15.41 14.79L18.19 15.5L20.47 19.58C20.53 19.69 20.5 19.83 20.42 19.92Z";
var mdiWindTurbine = "M13.33,11.67L16.21,14.58C17.62,13.16 16.21,11.75 16.21,11.75L14.72,10.24C14.9,9.86 15,9.44 15,9C15,7.95 14.46,7.03 13.64,6.5L15,2.11C13.09,1.53 12.5,3.44 12.5,3.44L11.69,6.03C10.46,6.16 9.46,7 9.13,8.18L4.67,9.63C5.31,11.53 7.2,10.9 7.2,10.9L9.27,10.23C9.61,10.97 10.23,11.54 11,11.82V19C11,19 9,19 9,21C9,21.5 9,21.81 9,22H15V21C15,21 15,19 13,19V11.82C13.12,11.78 13.23,11.72 13.33,11.67M10.5,9A1.5,1.5 0 0,1 12,7.5A1.5,1.5 0 0,1 13.5,9A1.5,1.5 0 0,1 12,10.5A1.5,1.5 0 0,1 10.5,9Z";
var mdiWindTurbineAlert = "M12.33 11.67L15.21 14.58C16.62 13.16 15.21 11.75 15.21 11.75L13.72 10.24C13.9 9.86 14 9.44 14 9C14 7.95 13.46 7.03 12.64 6.5L14 2.11C12.09 1.53 11.5 3.44 11.5 3.44L10.69 6.03C9.46 6.16 8.46 7 8.13 8.18L3.67 9.63C4.31 11.53 6.2 10.9 6.2 10.9L8.27 10.23C8.61 10.97 9.23 11.54 10 11.82V19C10 19 8 19 8 21V22H14V21C14 21 14 19 12 19V11.82C12.12 11.78 12.23 11.72 12.33 11.67M9.5 9C9.5 8.17 10.17 7.5 11 7.5S12.5 8.17 12.5 9 11.83 10.5 11 10.5 9.5 9.83 9.5 9M18 12V7H20V13H18M18 17V15H20V17H18Z";
var mdiWindTurbineCheck = "M11.33 11.67L14.21 14.58C15.62 13.16 14.21 11.75 14.21 11.75L12.72 10.24C12.9 9.86 13 9.44 13 9C13 7.95 12.46 7.03 11.64 6.5L13 2.11C11.09 1.53 10.5 3.44 10.5 3.44L9.69 6.03C8.46 6.16 7.46 7 7.13 8.18L2.67 9.63C3.31 11.53 5.2 10.9 5.2 10.9L7.27 10.23C7.61 10.97 8.23 11.54 9 11.82V19C9 19 7 19 7 21V22H13V21C13 21 13 19 11 19V11.82C11.12 11.78 11.23 11.72 11.33 11.67M8.5 9C8.5 8.17 9.17 7.5 10 7.5S11.5 8.17 11.5 9 10.83 10.5 10 10.5 8.5 9.83 8.5 9M16.75 21.16L14 18.16L15.16 17L16.75 18.59L20.34 15L21.5 16.41L16.75 21.16";
var mdiWindowClose = "M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z";
var mdiWindowClosed = "M6,11H10V9H14V11H18V4H6V11M18,13H6V20H18V13M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2Z";
var mdiWindowClosedVariant = "M21 20V2H3V20H1V23H23V20M19 4V11H13V4M5 4H11V11H5M5 20V13H11V20M13 20V13H19V20Z";
var mdiWindowMaximize = "M4,4H20V20H4V4M6,8V18H18V8H6Z";
var mdiWindowMinimize = "M20,14H4V10H20";
var mdiWindowOpen = "M6,8H10V6H14V8H18V4H6V8M18,10H6V15H18V10M6,20H18V17H6V20M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2Z";
var mdiWindowOpenVariant = "M21 20V2H3V20H1V23H23V20M19 4V11H17V4M5 4H7V11H5M5 20V13H7V20M9 20V4H15V20M17 20V13H19V20Z";
var mdiWindowRestore = "M4,8H8V4H20V16H16V20H4V8M16,8V14H18V6H10V8H16M6,12V18H14V12H6Z";
var mdiWindowShutter = "M3 4H21V8H19V20H17V8H7V20H5V8H3V4M8 9H16V11H8V9M8 12H16V14H8V12M8 15H16V17H8V15M8 18H16V20H8V18Z";
var mdiWindowShutterAlert = "M2 4H20V8H18V20H16V8H6V20H4V8H2V4M7 9H15V11H7V9M7 12H15V14H7V12M20 19V17H22V19H20M20 15V10H22V15H20Z";
var mdiWindowShutterAuto = "M20 14H18L14.8 23H16.7L17.4 21H20.6L21.3 23H23.2L20 14M17.8 19.7L19 16L20.2 19.7H17.8M7 9H15V11H7V9M7 12H15V14H7V12M7 15H15V16.5L14.8 17H7V15M13.7 20H7V18H14.5L13.7 20M16 8H6V20H4V8H2V4H20V8H18V12H16.6L16.1 13.3L16 13.7V8Z";
var mdiWindowShutterCog = "M21.7 18.6V17.6L22.8 16.8C22.9 16.7 23 16.6 22.9 16.5L21.9 14.8C21.9 14.7 21.7 14.7 21.6 14.7L20.4 15.2C20.1 15 19.8 14.8 19.5 14.7L19.3 13.4C19.3 13.3 19.2 13.2 19.1 13.2H17.1C16.9 13.2 16.8 13.3 16.8 13.4L16.6 14.7C16.3 14.9 16.1 15 15.8 15.2L14.6 14.7C14.5 14.7 14.4 14.7 14.3 14.8L13.3 16.5C13.3 16.6 13.3 16.7 13.4 16.8L14.5 17.6V18.6L13.4 19.4C13.3 19.5 13.2 19.6 13.3 19.7L14.3 21.4C14.4 21.5 14.5 21.5 14.6 21.5L15.8 21C16 21.2 16.3 21.4 16.6 21.5L16.8 22.8C16.9 22.9 17 23 17.1 23H19.1C19.2 23 19.3 22.9 19.3 22.8L19.5 21.5C19.8 21.3 20 21.2 20.3 21L21.5 21.4C21.6 21.4 21.7 21.4 21.8 21.3L22.8 19.6C22.9 19.5 22.9 19.4 22.8 19.4L21.7 18.6M18 19.5C17.2 19.5 16.5 18.8 16.5 18S17.2 16.5 18 16.5 19.5 17.2 19.5 18 18.8 19.5 18 19.5M8 9H16V11H8V9M17 8H7V20H5V8H3V4H21V8H19V11.1C18.7 11.1 18.3 11 18 11S17.3 11 17 11.1V8M11.3 20H8V18H11C11 18.7 11.1 19.4 11.3 20M8 12H14.4C13.6 12.5 12.8 13.2 12.3 14H8V12M8 15H11.7C11.4 15.6 11.2 16.3 11.1 17H8V15Z";
var mdiWindowShutterOpen = "M3 4H21V8H19V20H17V8H7V20H5V8H3V4M8 9H16V11H8V9Z";
var mdiWindowShutterSettings = "M3 4H21V8H19V20H17V8H7V20H5V8H3V4M8 9H16V11H8V9M8 12H16V14H8V12M8 15H16V17H8V15M8 18H16V20H8V18M13 22H11V24H13V22M17 22H15V24H17V22M9 22H7V24H9V22Z";
var mdiWindsock = "M7 5V13L22 11V7L7 5M10 6.91L13 7.31V10.69L10 11.09V6.91M16 7.71L19 8.11V9.89L16 10.29V7.71M5 10V11H6V12H5V21H3V4C3 3.45 3.45 3 4 3S5 3.45 5 4V6H6V7H5V10Z";
var mdiWiper = "M12,4C5,4 2,9 2,9L9,16C9,16 9.5,15.1 10.4,14.5L10.7,16.5C10.3,16.8 10,17.4 10,18A2,2 0 0,0 12,20A2,2 0 0,0 14,18C14,17.1 13.5,16.4 12.7,16.1L12.3,14C14.1,14.2 15,16 15,16L22,9C22,9 19,4 12,4M15.1,13.1C14.3,12.5 13.3,12 12,12L11,6.1C11.3,6 11.7,6 12,6C15.7,6 18.1,7.7 19.3,8.9L15.1,13.1M8.9,13.1L4.7,8.9C5.5,8 7,7 9,6.4L10,12.4C9.6,12.6 9.2,12.8 8.9,13.1Z";
var mdiWiperWash = "M13,6C13,5.7 13.1,4.6 13.8,3.8L12,2.4L10.2,3.9C10.9,4.6 11,5.7 11,6C4.7,6.4 2,11 2,11L9,18C9,18 9.7,16.7 11,16.2V18.3C10.4,18.6 10,19.3 10,20A2,2 0 0,0 12,22A2,2 0 0,0 14,20C14,19.3 13.6,18.6 13,18.3V16.2C14.3,16.7 15,18 15,18L22,11C22,11 19.3,6.5 13,6M11,14.1C10.2,14.3 9.5,14.6 8.9,15.1L4.7,10.9C5.8,9.8 7.8,8.3 11,8.1V14.1M15.1,15.1C14.5,14.7 13.8,14.3 13,14.1V8.1C16.2,8.4 18.2,9.8 19.3,10.9L15.1,15.1M18,1.3L17.3,3.2C16.6,2.9 15.5,2.9 14.7,3.2L14,1.3C15.2,0.9 16.8,0.9 18,1.3M21,6H19C19,6 19,4.7 18.2,3.9L19.7,2.6C21,4 21,5.9 21,6M4.2,2.6L5.7,3.9C5,4.7 5,6 5,6H3C3,5.9 3,4 4.2,2.6M10,1.3L9.3,3.2C8.6,2.9 7.5,2.9 6.7,3.2L6,1.3C7.2,0.9 8.8,0.9 10,1.3Z";
var mdiWiperWashAlert = "M11 6C11 5.7 11.1 4.6 11.8 3.8L10 2.4L8.2 3.9C8.9 4.6 9 5.7 9 6C2.7 6.4 0 11 0 11L7 18C7 18 7.7 16.7 9 16.2V18.3C8.4 18.6 8 19.3 8 20C8 21.11 8.9 22 10 22S12 21.11 12 20C12 19.3 11.6 18.6 11 18.3V16.2C12.3 16.7 13 18 13 18L20 11C20 11 17.3 6.5 11 6M9 14.1C8.2 14.3 7.5 14.6 6.9 15.1L2.7 10.9C3.8 9.8 5.8 8.3 9 8.1V14.1M13.1 15.1C12.5 14.7 11.8 14.3 11 14.1V8.1C14.2 8.4 16.2 9.8 17.3 10.9L13.1 15.1M16 1.3L15.3 3.2C14.6 2.9 13.5 2.9 12.7 3.2L12 1.3C13.2 .9 14.8 .9 16 1.3M19 6H17C17 6 17 4.7 16.2 3.9L17.7 2.6C19 4 19 5.9 19 6M2.2 2.6L3.7 3.9C3 4.7 3 6 3 6H1C1 5.9 1 4 2.2 2.6M8 1.3L7.3 3.2C6.6 2.9 5.5 2.9 4.7 3.2L4 1.3C5.2 .9 6.8 .9 8 1.3M22 12V7H24V13H22M22 17H24V15H22";
var mdiWizardHat = "M21 22H3V20H21V22M19 19H5L11.1 2.6C11.3 2.2 11.6 2 12 2L18 5H13.9L19 19M10 7.5L11.04 7.97L11.5 9L11.97 7.97L13 7.5L11.97 7.03L11.5 6L11.04 7.03L10 7.5M13 15L10.94 14.07L10 12L9.07 14.07L7 15L9.07 15.93L10 18L10.94 15.93L13 15M13.97 11.97L15 11.5L13.97 11.03L13.5 10L13.04 11.03L12 11.5L13.04 11.97L13.5 13L13.97 11.97M15.97 15.97L17 15.5L15.97 15.03L15.5 14L15.04 15.03L14 15.5L15.04 15.97L15.5 17L15.97 15.97Z";
var mdiWordpress = "M3.42,12C3.42,10.76 3.69,9.58 4.16,8.5L8.26,19.72C5.39,18.33 3.42,15.4 3.42,12M17.79,11.57C17.79,12.3 17.5,13.15 17.14,14.34L16.28,17.2L13.18,8L14.16,7.9C14.63,7.84 14.57,7.16 14.11,7.19C14.11,7.19 12.72,7.3 11.82,7.3L9.56,7.19C9.1,7.16 9.05,7.87 9.5,7.9L10.41,8L11.75,11.64L9.87,17.27L6.74,8L7.73,7.9C8.19,7.84 8.13,7.16 7.67,7.19C7.67,7.19 6.28,7.3 5.38,7.3L4.83,7.29C6.37,4.96 9,3.42 12,3.42C14.23,3.42 16.27,4.28 17.79,5.67H17.68C16.84,5.67 16.24,6.4 16.24,7.19C16.24,7.9 16.65,8.5 17.08,9.2C17.41,9.77 17.79,10.5 17.79,11.57M12.15,12.75L14.79,19.97L14.85,20.09C13.96,20.41 13,20.58 12,20.58C11.16,20.58 10.35,20.46 9.58,20.23L12.15,12.75M19.53,7.88C20.2,9.11 20.58,10.5 20.58,12C20.58,15.16 18.86,17.93 16.31,19.41L18.93,11.84C19.42,10.62 19.59,9.64 19.59,8.77L19.53,7.88M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,21.54C17.26,21.54 21.54,17.26 21.54,12C21.54,6.74 17.26,2.46 12,2.46C6.74,2.46 2.46,6.74 2.46,12C2.46,17.26 6.74,21.54 12,21.54Z";
var mdiWrap = "M21,5H3V7H21V5M3,19H10V17H3V19M3,13H18C19,13 20,13.43 20,15C20,16.57 19,17 18,17H16V15L12,18L16,21V19H18C20.95,19 22,17.73 22,15C22,12.28 21,11 18,11H3V13Z";
var mdiWrapDisabled = "M16,7H3V5H16V7M3,19H16V17H3V19M22,12L18,9V11H3V13H18V15L22,12Z";
var mdiWrench = "M22.7,19L13.6,9.9C14.5,7.6 14,4.9 12.1,3C10.1,1 7.1,0.6 4.7,1.7L9,6L6,9L1.6,4.7C0.4,7.1 0.9,10.1 2.9,12.1C4.8,14 7.5,14.5 9.8,13.6L18.9,22.7C19.3,23.1 19.9,23.1 20.3,22.7L22.6,20.4C23.1,20 23.1,19.3 22.7,19Z";
var mdiWrenchCheck = "M9 2C10.8 2.6 12 4.3 12 6.2C12 8.2 10.8 9.9 9 10.5V21.5C9 21.8 8.8 22 8.5 22H6.5C6.2 22 6 21.8 6 21.4V10.4C4.2 9.8 3 8.1 3 6.2S4.2 2.6 6 2V5.7H9V2M20.6 13L22 14.41L15.47 21L12 17.5L13.4 16.09L15.47 18.17L20.6 13";
var mdiWrenchCheckOutline = "M9 1.09V6H7V1.09C4.16 1.57 2 4.03 2 7C2 9.22 3.21 11.15 5 12.19V21C5 21.55 5.45 22 6 22H10C10.55 22 11 21.55 11 21V12.19C12.79 11.15 14 9.22 14 7C14 4.03 11.84 1.57 9 1.09M10 10.46L9 11.04V20H7V11.04L6 10.46C4.77 9.74 4 8.42 4 7C4 6 4.37 5.06 5 4.35V8H11V4.35C11.63 5.06 12 6 12 7C12 8.42 11.23 9.74 10 10.46M21.6 13L23 14.41L16.47 21L13 17.5L14.4 16.09L16.47 18.17L21.6 13";
var mdiWrenchClock = "M10 6.2C10 4.3 8.8 2.6 7 2V5.7H4V2C2.2 2.6 1 4.3 1 6.2C1 8.1 2.2 9.8 4 10.4V21.4C4 21.8 4.2 22 4.5 22H6.5C6.8 22 7 21.8 7 21.5V10.5C8.8 9.9 10 8.2 10 6.2M16 8C16 8 15.9 8 16 8C12.1 8.1 9 11.2 9 15C9 18.9 12.1 22 16 22S23 18.9 23 15 19.9 8 16 8M16 20C13.2 20 11 17.8 11 15S13.2 10 16 10 21 12.2 21 15 18.8 20 16 20M15 11V16L18.6 18.2L19.4 17L16.5 15.3V11H15Z";
var mdiWrenchClockOutline = "M16 8C14.8 8.03 13.67 8.35 12.68 8.89C12.88 8.29 13 7.66 13 7C13 4.03 10.84 1.57 8 1.09V6H6V1.09C3.16 1.57 1 4.03 1 7C1 9.22 2.21 11.15 4 12.19V21C4 21.55 4.45 22 5 22H9C9.55 22 10 21.55 10 21V18.62C11.22 20.65 13.43 22 16 22C19.9 22 23 18.9 23 15S19.9 8 16 8M8 11.04V20H6V11.04L5 10.46C3.77 9.74 3 8.42 3 7C3 6 3.37 5.06 4 4.35V8H10V4.35C10.63 5.06 11 6 11 7C11 8.42 10.23 9.74 9 10.46L8 11.04M16 20C13.2 20 11 17.8 11 15S13.2 10 16 10 21 12.2 21 15 18.8 20 16 20M16.5 15.3L19.4 17L18.6 18.2L15 16V11H16.5V15.3Z";
var mdiWrenchCog = "M19.94 17.94C19.96 17.79 19.97 17.65 19.97 17.5S19.96 17.2 19.94 17.05L20.91 16.32C21 16.25 21.03 16.13 20.97 16.03L20.05 14.47C20 14.37 19.86 14.33 19.76 14.37L18.61 14.82C18.37 14.65 18.12 14.5 17.83 14.38L17.66 13.19C17.64 13.08 17.54 13 17.43 13H15.58C15.46 13 15.36 13.08 15.34 13.19L15.17 14.38C14.88 14.5 14.63 14.65 14.39 14.82L13.24 14.37C13.14 14.33 13 14.37 12.96 14.47L12.03 16.03C11.97 16.13 12 16.25 12.09 16.32L13.06 17.05C13.05 17.2 13.03 17.35 13.03 17.5S13.05 17.79 13.06 17.94L12.09 18.68C12 18.75 11.97 18.87 12.03 18.97L12.96 20.53C13 20.63 13.14 20.66 13.24 20.63L14.39 20.17C14.63 20.35 14.88 20.5 15.17 20.62L15.34 21.81C15.36 21.92 15.46 22 15.58 22H17.43C17.54 22 17.64 21.92 17.66 21.81L17.83 20.62C18.12 20.5 18.37 20.35 18.61 20.17L19.76 20.63C19.86 20.66 20 20.63 20.05 20.53L20.97 18.97C21.03 18.87 21 18.75 20.91 18.68L19.94 17.94M16.5 19C15.67 19 15 18.33 15 17.5S15.67 16 16.5 16 18 16.67 18 17.5 17.33 19 16.5 19M9 2C10.8 2.6 12 4.3 12 6.2C12 8.2 10.8 9.9 9 10.5V21.5C9 21.8 8.8 22 8.5 22H6.5C6.2 22 6 21.8 6 21.4V10.4C4.2 9.8 3 8.1 3 6.2S4.2 2.6 6 2V5.7H9V2Z";
var mdiWrenchCogOutline = "M9 1.09V6H7V1.09C4.16 1.57 2 4.03 2 7C2 9.22 3.21 11.15 5 12.19V21C5 21.55 5.45 22 6 22H10C10.55 22 11 21.55 11 21V12.19C12.79 11.15 14 9.22 14 7C14 4.03 11.84 1.57 9 1.09M10 10.46L9 11.04V20H7V11.04L6 10.46C4.77 9.74 4 8.42 4 7C4 6 4.37 5.06 5 4.35V8H11V4.35C11.63 5.06 12 6 12 7C12 8.42 11.23 9.74 10 10.46M20.94 17.94C20.96 17.79 20.97 17.65 20.97 17.5S20.96 17.2 20.94 17.05L21.91 16.32C22 16.25 22.03 16.13 21.97 16.03L21.05 14.47C21 14.37 20.87 14.33 20.76 14.37L19.61 14.82C19.37 14.65 19.12 14.5 18.83 14.38L18.66 13.19C18.64 13.08 18.54 13 18.43 13H16.58C16.46 13 16.36 13.08 16.34 13.19L16.17 14.38C15.88 14.5 15.63 14.65 15.39 14.82L14.24 14.37C14.14 14.33 14 14.37 13.96 14.47L13.03 16.03C12.97 16.13 13 16.25 13.09 16.32L14.06 17.05C14.05 17.2 14.03 17.35 14.03 17.5S14.05 17.79 14.06 17.94L13.09 18.68C13 18.75 12.97 18.87 13.03 18.97L13.96 20.53C14 20.63 14.14 20.66 14.24 20.63L15.39 20.17C15.63 20.35 15.88 20.5 16.17 20.62L16.34 21.81C16.36 21.92 16.46 22 16.58 22H18.43C18.54 22 18.64 21.92 18.66 21.81L18.83 20.62C19.12 20.5 19.37 20.35 19.61 20.17L20.76 20.63C20.87 20.66 21 20.63 21.05 20.53L21.97 18.97C22.03 18.87 22 18.75 21.91 18.68L20.94 17.94M17.5 19C16.67 19 16 18.33 16 17.5S16.67 16 17.5 16 19 16.67 19 17.5 18.33 19 17.5 19Z";
var mdiWrenchOutline = "M22.61,19L13.53,9.91C14.46,7.57 14,4.81 12.09,2.91C9.79,0.61 6.21,0.4 3.66,2.26L7.5,6.11L6.08,7.5L2.25,3.69C0.39,6.23 0.6,9.82 2.9,12.11C4.76,13.97 7.47,14.46 9.79,13.59L18.9,22.7C19.29,23.09 19.92,23.09 20.31,22.7L22.61,20.4C23,20 23,19.39 22.61,19M19.61,20.59L10.15,11.13C9.54,11.58 8.86,11.85 8.15,11.95C6.79,12.15 5.36,11.74 4.32,10.7C3.37,9.76 2.93,8.5 3,7.26L6.09,10.35L10.33,6.11L7.24,3C8.5,2.95 9.73,3.39 10.68,4.33C11.76,5.41 12.17,6.9 11.92,8.29C11.8,9 11.5,9.66 11.04,10.25L20.5,19.7L19.61,20.59Z";
var mdiXamarin = "M22.75,11.07C22.91,11.35 23,11.67 23,12C23,12.33 22.91,12.65 22.75,12.93L18.08,21C17.72,21.62 17.06,22 16.35,22H7.65C6.94,22 6.28,21.62 5.92,21L1.25,12.93C1.09,12.65 1,12.33 1,12C1,11.67 1.09,11.35 1.25,11.07L5.92,3C6.28,2.38 6.94,2 7.65,2H16.35C17.06,2 17.72,2.38 18.08,3L22.75,11.07M12,12V11.9L9.42,7.1L9.25,7H7.66L7.5,7.1V7.3L10,12L7.5,16.7V16.9L7.66,17H9.25L9.42,16.9L12,12.1V12L12.03,12.1L14.58,16.9L14.75,17H16.34L16.5,16.9V16.7L14,12L16.5,7.3V7.1L16.34,7H14.75L14.58,7.1L12.03,11.9L12,12Z";
var mdiXml = "M12.89,3L14.85,3.4L11.11,21L9.15,20.6L12.89,3M19.59,12L16,8.41V5.58L22.42,12L16,18.41V15.58L19.59,12M1.58,12L8,5.58V8.41L4.41,12L8,15.58V18.41L1.58,12Z";
var mdiXmpp = "M12,15.4C9.75,13.09 8,9.54 8,6C2,4 8,6 2,4C2,9.65 6.33,14.11 10.55,16.66C9.38,17.5 8.15,18 7,18C7,19 7,18 7,19C8.2,19 10.03,18.46 12,17.46C13.97,18.46 15.8,19 17,19C17,18 17,19 17,18C15.85,18 14.62,17.5 13.45,16.66C17.66,14.11 22,9.65 22,4C16,6 22,4 16,6C16,9.54 14.25,13.09 12,15.4Z";
var mdiYahoo = "M10.5 7.59L8.16 13.2L5.85 7.59H2L6.29 17.23L4.75 20.7H8.5L14.24 7.59H10.5M15 12.73C13.63 12.73 12.59 13.77 12.59 15C12.59 16.17 13.59 17.16 14.93 17.16C16.32 17.16 17.36 16.13 17.36 14.9C17.36 13.69 16.36 12.73 15 12.73M17.72 3.3L13.89 11.89H18.17L22 3.3H17.72Z";
var mdiYeast = "M18,14A4,4 0 0,1 22,18A4,4 0 0,1 18,22A4,4 0 0,1 14,18L14.09,17.15C14.05,16.45 13.92,15.84 13.55,15.5C13.35,15.3 13.07,15.19 12.75,15.13C11.79,15.68 10.68,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3A6.5,6.5 0 0,1 16,9.5C16,10.68 15.68,11.79 15.13,12.75C15.19,13.07 15.3,13.35 15.5,13.55C15.84,13.92 16.45,14.05 17.15,14.09L18,14M7.5,10A1.5,1.5 0 0,1 9,11.5A1.5,1.5 0 0,1 7.5,13A1.5,1.5 0 0,1 6,11.5A1.5,1.5 0 0,1 7.5,10M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z";
var mdiYinYang = "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A4,4 0 0,1 8,16A4,4 0 0,1 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,6.5A1.5,1.5 0 0,1 13.5,8A1.5,1.5 0 0,1 12,9.5A1.5,1.5 0 0,1 10.5,8A1.5,1.5 0 0,1 12,6.5M12,14.5A1.5,1.5 0 0,0 10.5,16A1.5,1.5 0 0,0 12,17.5A1.5,1.5 0 0,0 13.5,16A1.5,1.5 0 0,0 12,14.5Z";
var mdiYoga = "M13 2C11.9 2 11 2.9 11 4C11 5.11 11.9 6 13 6C14.11 6 15 5.11 15 4C15 2.9 14.11 2 13 2M4 7V9H10V15L4.93 20.07L6.34 21.5L13.06 14.77L17 17.13V21H19V16.57C19 16.21 18.82 15.89 18.5 15.71L15 13.6V9H21V7H4Z";
var mdiYoutube = "M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z";
var mdiYoutubeGaming = "M22 13V8L17 5L12 8L7 5L2 8V13L12 19L22 13M9 11H7V13H6V11H4V10H6V8H7V10H9V11M15 13C14.45 13 14 12.55 14 12S14.45 11 15 11 16 11.45 16 12 15.55 13 15 13M18 11C17.45 11 17 10.55 17 10S17.45 9 18 9 19 9.45 19 10 18.55 11 18 11Z";
var mdiYoutubeStudio = "M10,15L15,12L10,9V15M19.45,13L21.56,14.63C21.78,14.78 21.81,15 21.66,15.28L19.64,18.75C19.5,18.97 19.31,19.03 19.03,18.94L16.55,17.95C15.89,18.42 15.33,18.75 14.86,18.94L14.5,21.56C14.42,21.84 14.27,22 14,22H10C9.73,22 9.58,21.84 9.5,21.56L9.14,18.94C8.55,18.69 8,18.36 7.45,17.95L4.97,18.94C4.69,19.03 4.5,18.97 4.36,18.75L2.34,15.28C2.19,15 2.22,14.78 2.44,14.63L4.55,13C4.5,12.77 4.5,12.44 4.5,12C4.5,11.56 4.5,11.23 4.55,11L2.44,9.38C2.22,9.22 2.19,9 2.34,8.72L4.36,5.25C4.5,5.03 4.69,4.97 4.97,5.06L7.45,6.05C8.11,5.58 8.67,5.25 9.14,5.06L9.5,2.44C9.58,2.16 9.73,2 10,2H14C14.27,2 14.42,2.16 14.5,2.44L14.86,5.06C15.45,5.31 16,5.64 16.55,6.05L19.03,5.06C19.31,4.97 19.5,5.03 19.64,5.25L21.66,8.72C21.81,9 21.78,9.22 21.56,9.38L19.45,11C19.5,11.23 19.5,11.56 19.5,12C19.5,12.44 19.5,12.77 19.45,13Z";
var mdiYoutubeSubscription = "M20,8H4V6H20V8M18,2H6V4H18V2M22,12V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V12A2,2 0 0,1 4,10H20A2,2 0 0,1 22,12M16,16L10,12.73V19.26L16,16Z";
var mdiYoutubeTv = "M2.5,4.5H21.5C22.34,4.5 23,5.15 23,6V17.5C23,18.35 22.34,19 21.5,19H2.5C1.65,19 1,18.35 1,17.5V6C1,5.15 1.65,4.5 2.5,4.5M9.71,8.5V15L15.42,11.7L9.71,8.5M17.25,21H6.65C6.35,21 6.15,20.8 6.15,20.5C6.15,20.2 6.35,20 6.65,20H17.35C17.65,20 17.85,20.2 17.85,20.5C17.85,20.8 17.55,21 17.25,21Z";
var mdiYurt = "M22 14.87V22H14V16H10V22H2V14.87C2 14.33 2.29 13.83 2.76 13.57L8.66 10.2C8.88 10.07 9.14 10 9.4 10H12.5V9H14V10H14.59C14.85 10 15.11 10.07 15.33 10.2L21.23 13.57C21.71 13.84 22 14.33 22 14.87M7.86 6.25H9.4C10.73 6.25 11.92 6.95 12.5 8H14C13.6 6.2 12 4.85 10.1 4.85V3.35C11.1 3.35 11.95 2.5 11.95 1.5V1H7.86V2.5C6.86 2.5 6 3.23 6 4.25S6.86 6.25 7.86 6.25Z";
var mdiZWave = "M16.3,10.58C13.14,10.58 10.6,13.13 10.6,16.28C10.6,19.43 13.15,22 16.3,22C19.45,22 22,19.43 22,16.28C22,13.13 19.45,10.58 16.3,10.58M18,19.08H13.19L15.81,15H13.31L14.4,13.23H19.18L16.63,17.28H19.18L18,19.08M16.3,3.93V2C8.41,2 2,8.42 2,16.31H3.92C3.94,9.46 9.5,3.93 16.3,3.93M16.3,7.74V5.82C10.5,5.82 5.81,10.53 5.81,16.31H7.73C7.75,11.58 11.59,7.74 16.3,7.74";
var mdiZend = "M11.28,9.81C11.28,9.81 11.28,7 14.09,7H22.5C22.5,7 22.5,9.81 19.71,9.81H11.28M11.28,13.41C11.28,13.41 11.28,10.6 14.09,10.6H18.31C18.31,10.6 18.31,13.41 15.5,13.41H11.28M11.28,17C11.28,17 11.28,14.19 14.09,14.19H15.5C15.5,14.19 15.5,17 12.68,17H11.28M10.46,14.8V17H1.58L7.3,9.21H2.4V7H11.66L5.96,14.8H10.46Z";
var mdiZigbee = "M4.06,6.15C3.97,6.17 3.88,6.22 3.8,6.28C2.66,7.9 2,9.87 2,12A10,10 0 0,0 12,22C15,22 17.68,20.68 19.5,18.6L17,18.85C14.25,19.15 11.45,19.19 8.66,18.96C7.95,18.94 7.24,18.76 6.59,18.45C5.73,18.06 5.15,17.23 5.07,16.29C5.06,16.13 5.12,16 5.23,15.87L7.42,13.6L15.03,5.7V5.6H10.84C8.57,5.64 6.31,5.82 4.06,6.15M20.17,17.5C20.26,17.47 20.35,17.44 20.43,17.39C21.42,15.83 22,14 22,12A10,10 0 0,0 12,2C9.22,2 6.7,3.13 4.89,4.97H5.17C8.28,4.57 11.43,4.47 14.56,4.65C15.5,4.64 16.45,4.82 17.33,5.17C18.25,5.53 18.89,6.38 19,7.37C19,7.53 18.93,7.7 18.82,7.82L9.71,17.19L9,17.95V18.06H13.14C15.5,18 17.84,17.81 20.17,17.5Z";
var mdiZipBox = "M14,17H12V15H10V13H12V15H14M14,9H12V11H14V13H12V11H10V9H12V7H10V5H12V7H14M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z";
var mdiZipBoxOutline = "M12 17V15H14V17H12M14 13V11H12V13H14M14 9V7H12V9H14M10 11H12V9H10V11M10 15H12V13H10V15M21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5M19 5H12V7H10V5H5V19H19V5Z";
var mdiZipDisk = "M7,3L3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5L17,3V5A1,1 0 0,1 16,6H10A1,1 0 0,1 9,5V3H7M8,10H16A1,1 0 0,1 17,11V19H7V11A1,1 0 0,1 8,10Z";
var mdiZodiacAquarius = "M15,12.41L12,9.41L9,12.41L6,9.41L3.71,11.71L2.29,10.29L6,6.59L9,9.59L12,6.59L15,9.59L18,6.59L21.71,10.29L20.29,11.71L18,9.41L15,12.41M18,15.41L20.29,17.71L21.71,16.29L18,12.59L15,15.59L12,12.59L9,15.59L6,12.59L2.29,16.29L3.71,17.71L6,15.41L9,18.41L12,15.41L15,18.41L18,15.41Z";
var mdiZodiacAries = "M16,2C14.95,2 13.91,2.27 13,2.81C12.64,3 12.3,3.26 12,3.54C11.7,3.26 11.36,3 11,2.81C10.09,2.27 9.05,2 8,2A6,6 0 0,0 2,8A6,6 0 0,0 8,14V12A4,4 0 0,1 4,8A4,4 0 0,1 8,4C9,4 10,4.39 10.75,5.1C10.84,5.18 10.92,5.27 11,5.36V22H13V5.36C13.08,5.27 13.16,5.18 13.25,5.1C14.85,3.58 17.38,3.64 18.91,5.25C20.43,6.85 20.36,9.38 18.76,10.9C18,11.61 17.03,12 16,12V14A6,6 0 0,0 22,8A6,6 0 0,0 16,2Z";
var mdiZodiacCancer = "M12,4C6.5,4 2,7.58 2,12C2,14.12 3.65,15.87 5.76,16H6A4,4 0 0,0 10,12A4,4 0 0,0 6,8H5.76C7.44,6.41 9.69,5.55 12,5.6C13.77,5.58 15.5,6.07 17,7L18.25,5.75C16.38,4.58 14.21,3.97 12,4M6,10A2,2 0 0,1 8,12C8,13.11 7.08,14 6,14C4.96,14 4.1,13.22 4,12.2C4,12.07 4,11.93 4,11.8C4.1,10.77 4.97,10 6,10M18.24,8H18A4,4 0 0,0 14,12A4,4 0 0,0 18,16H18.24C16.56,17.59 14.31,18.45 12,18.4C10.23,18.42 8.5,17.93 7,17L5.76,18.24C7.63,19.41 9.79,20 12,20C17.5,20 22,16.42 22,12C22,9.88 20.35,8.13 18.24,8M18,14A2,2 0 0,1 16,12C16,10.89 16.92,10 18,10C19.04,10 19.9,10.78 20,11.8C20,11.93 20,12.07 20,12.2C19.9,13.23 19.03,14 18,14Z";
var mdiZodiacCapricorn = "M15,13C14.3,13 13.61,13.19 13,13.55V6A3,3 0 0,0 10,3C9.25,3 8.55,3.29 8,3.78C7.45,3.28 6.74,3 6,3V5A1,1 0 0,1 7,6V16H9V6A1,1 0 0,1 10,5A1,1 0 0,1 11,6V17A2,2 0 0,1 9,19V21C10.15,21 11.25,20.5 12,19.62C13.45,21.29 15.97,21.47 17.64,20C19.31,18.58 19.5,16.05 18.04,14.38C17.28,13.5 16.17,13 15,13M15,19A2,2 0 0,1 13,17A2,2 0 0,1 15,15A2,2 0 0,1 17,17A2,2 0 0,1 15,19Z";
var mdiZodiacGemini = "M18,5.3C19.35,4.97 20.66,4.54 21.94,4L21.18,2.14C18.27,3.36 15.15,4 12,4C8.85,4 5.73,3.38 2.82,2.17L2.06,4C3.34,4.54 4.65,4.97 6,5.3V18.7C4.65,19.03 3.34,19.46 2.06,20L2.82,21.86C8.7,19.42 15.3,19.42 21.18,21.86L21.94,20C20.66,19.46 19.35,19.03 18,18.7V5.3M8,18.3V5.69C9.32,5.89 10.66,6 12,6C13.34,6 14.68,5.89 16,5.69V18.31C13.35,17.9 10.65,17.9 8,18.31V18.3Z";
var mdiZodiacLeo = "M20,17A3,3 0 0,1 17,20C15.38,19.92 14.08,18.62 14,17C14.16,15.39 14.5,13.8 15,12.26C15.54,10.55 15.87,8.79 16,7C15.93,4.27 13.73,2.07 11,2C8.27,2.07 6.07,4.27 6,7C6.15,8.53 6.5,10.03 7,11.5L7.21,12.2C5.1,11.53 2.86,12.7 2.19,14.8C1.5,16.91 2.68,19.16 4.79,19.83C6.9,20.5 9.14,19.33 9.81,17.22C9.94,16.83 10,16.41 10,16C9.84,14.27 9.5,12.56 8.91,10.92C8.47,9.65 8.16,8.34 8,7C8.08,5.38 9.38,4.08 11,4C12.62,4.08 13.92,5.38 14,7C13.84,8.61 13.5,10.2 13,11.74C12.46,13.45 12.13,15.21 12,17C12.07,19.73 14.27,21.93 17,22A5,5 0 0,0 22,17H20M6,18A2,2 0 0,1 4,16A2,2 0 0,1 6,14A2,2 0 0,1 8,16A2,2 0 0,1 6,18Z";
var mdiZodiacLibra = "M20,16V18H13V15.91C16,15.36 17.96,12.5 17.41,9.5C16.86,6.5 14,4.54 11,5.09C8,5.65 6.04,8.5 6.59,11.5C7,13.74 8.76,15.5 11,15.91V18H4V16H6.92C5.37,14.59 4.5,12.59 4.5,10.5A7.5,7.5 0 0,1 12,3A7.5,7.5 0 0,1 19.5,10.5C19.5,12.59 18.63,14.59 17.08,16H20M20,19H4V21H20V19Z";
var mdiZodiacPisces = "M20,11H18C18.11,8.19 18.73,5.42 19.81,2.82L18,2.06C16.81,4.9 16.13,7.92 16,11H8C7.87,7.92 7.19,4.9 6,2.06L4.14,2.82C5.24,5.41 5.87,8.18 6,11H4V13H6C5.89,15.81 5.27,18.58 4.19,21.18L6,21.94C7.19,19.1 7.87,16.08 8,13H16C16.13,16.08 16.81,19.1 18,21.94L19.86,21.18C18.76,18.59 18.13,15.82 18,13H20V11Z";
var mdiZodiacSagittarius = "M22,2V12H20V5.41L10.41,15L12.71,17.29L11.29,18.71L9,16.41L3.71,21.71L2.29,20.29L7.59,15L5.29,12.71L6.71,11.29L9,13.59L18.59,4H12V2H22Z";
var mdiZodiacScorpio = "M17.71,15.29L16.29,16.71L17.59,18H16A2,2 0 0,1 14,16V6A3,3 0 0,0 11,3C10.25,3 9.55,3.29 9,3.78C7.86,2.76 6.14,2.76 5,3.78C4.45,3.28 3.74,3 3,3V5A1,1 0 0,1 4,6V16H6V6A1,1 0 0,1 7,5A1,1 0 0,1 8,6V16H10V6A1,1 0 0,1 11,5A1,1 0 0,1 12,6V16A4,4 0 0,0 16,20H17.59L16.29,21.29L17.71,22.71L21.41,19L17.71,15.29Z";
var mdiZodiacTaurus = "M15.59,9C17.7,7.74 19,5.46 19,3H17A5,5 0 0,1 12,8A5,5 0 0,1 7,3H5C5,5.46 6.3,7.74 8.41,9C5.09,11 4,15.28 6,18.6C7.97,21.92 12.27,23 15.59,21C18.91,19.04 20,14.74 18,11.42C17.42,10.43 16.58,9.59 15.59,9M12,20A5,5 0 0,1 7,15A5,5 0 0,1 12,10A5,5 0 0,1 17,15A5,5 0 0,1 12,20Z";
var mdiZodiacVirgo = "M18.5,19.13C20,17.77 20,15.18 20,14A4,4 0 0,0 16,10C15.3,10 14.6,10.2 14,10.56V6A3,3 0 0,0 11,3C10.25,3 9.55,3.29 9,3.78C7.86,2.76 6.14,2.76 5,3.78C4.45,3.28 3.74,3 3,3V5A1,1 0 0,1 4,6V16H6V6A1,1 0 0,1 7,5A1,1 0 0,1 8,6V16H10V6A1,1 0 0,1 11,5A1,1 0 0,1 12,6V14C12,15.18 12,17.77 13.5,19.13C12.72,19.54 11.88,19.84 11,20V22C12.29,22 14.84,20.74 16,20.13C17.16,20.74 19.71,22 21,22V20C20.12,19.84 19.28,19.54 18.5,19.13M16,12A2,2 0 0,1 18,14C18,16.92 17.46,18 16,18C14.54,18 14,16.92 14,14A2,2 0 0,1 16,12Z";
const icons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  mdiAbTesting,
  mdiAbacus,
  mdiAbjadArabic,
  mdiAbjadHebrew,
  mdiAbugidaDevanagari,
  mdiAbugidaThai,
  mdiAccessPoint,
  mdiAccessPointCheck,
  mdiAccessPointMinus,
  mdiAccessPointNetwork,
  mdiAccessPointNetworkOff,
  mdiAccessPointOff,
  mdiAccessPointPlus,
  mdiAccessPointRemove,
  mdiAccount,
  mdiAccountAlert,
  mdiAccountAlertOutline,
  mdiAccountArrowDown,
  mdiAccountArrowDownOutline,
  mdiAccountArrowLeft,
  mdiAccountArrowLeftOutline,
  mdiAccountArrowRight,
  mdiAccountArrowRightOutline,
  mdiAccountArrowUp,
  mdiAccountArrowUpOutline,
  mdiAccountBadge,
  mdiAccountBadgeOutline,
  mdiAccountBox,
  mdiAccountBoxEditOutline,
  mdiAccountBoxMinusOutline,
  mdiAccountBoxMultiple,
  mdiAccountBoxMultipleOutline,
  mdiAccountBoxOutline,
  mdiAccountBoxPlusOutline,
  mdiAccountCancel,
  mdiAccountCancelOutline,
  mdiAccountCard,
  mdiAccountCardOutline,
  mdiAccountCash,
  mdiAccountCashOutline,
  mdiAccountCheck,
  mdiAccountCheckOutline,
  mdiAccountChild,
  mdiAccountChildCircle,
  mdiAccountChildOutline,
  mdiAccountCircle,
  mdiAccountCircleOutline,
  mdiAccountClock,
  mdiAccountClockOutline,
  mdiAccountCog,
  mdiAccountCogOutline,
  mdiAccountConvert,
  mdiAccountConvertOutline,
  mdiAccountCowboyHat,
  mdiAccountCowboyHatOutline,
  mdiAccountCreditCard,
  mdiAccountCreditCardOutline,
  mdiAccountDetails,
  mdiAccountDetailsOutline,
  mdiAccountEdit,
  mdiAccountEditOutline,
  mdiAccountEye,
  mdiAccountEyeOutline,
  mdiAccountFile,
  mdiAccountFileOutline,
  mdiAccountFileText,
  mdiAccountFileTextOutline,
  mdiAccountFilter,
  mdiAccountFilterOutline,
  mdiAccountGroup,
  mdiAccountGroupOutline,
  mdiAccountHardHat,
  mdiAccountHardHatOutline,
  mdiAccountHeart,
  mdiAccountHeartOutline,
  mdiAccountInjury,
  mdiAccountInjuryOutline,
  mdiAccountKey,
  mdiAccountKeyOutline,
  mdiAccountLock,
  mdiAccountLockOpen,
  mdiAccountLockOpenOutline,
  mdiAccountLockOutline,
  mdiAccountMinus,
  mdiAccountMinusOutline,
  mdiAccountMultiple,
  mdiAccountMultipleCheck,
  mdiAccountMultipleCheckOutline,
  mdiAccountMultipleMinus,
  mdiAccountMultipleMinusOutline,
  mdiAccountMultipleOutline,
  mdiAccountMultiplePlus,
  mdiAccountMultiplePlusOutline,
  mdiAccountMultipleRemove,
  mdiAccountMultipleRemoveOutline,
  mdiAccountMusic,
  mdiAccountMusicOutline,
  mdiAccountNetwork,
  mdiAccountNetworkOff,
  mdiAccountNetworkOffOutline,
  mdiAccountNetworkOutline,
  mdiAccountOff,
  mdiAccountOffOutline,
  mdiAccountOutline,
  mdiAccountPlus,
  mdiAccountPlusOutline,
  mdiAccountQuestion,
  mdiAccountQuestionOutline,
  mdiAccountReactivate,
  mdiAccountReactivateOutline,
  mdiAccountRemove,
  mdiAccountRemoveOutline,
  mdiAccountSchool,
  mdiAccountSchoolOutline,
  mdiAccountSearch,
  mdiAccountSearchOutline,
  mdiAccountSettings,
  mdiAccountSettingsOutline,
  mdiAccountStar,
  mdiAccountStarOutline,
  mdiAccountSupervisor,
  mdiAccountSupervisorCircle,
  mdiAccountSupervisorCircleOutline,
  mdiAccountSupervisorOutline,
  mdiAccountSwitch,
  mdiAccountSwitchOutline,
  mdiAccountSync,
  mdiAccountSyncOutline,
  mdiAccountTag,
  mdiAccountTagOutline,
  mdiAccountTie,
  mdiAccountTieHat,
  mdiAccountTieHatOutline,
  mdiAccountTieOutline,
  mdiAccountTieVoice,
  mdiAccountTieVoiceOff,
  mdiAccountTieVoiceOffOutline,
  mdiAccountTieVoiceOutline,
  mdiAccountTieWoman,
  mdiAccountVoice,
  mdiAccountVoiceOff,
  mdiAccountWrench,
  mdiAccountWrenchOutline,
  mdiAdjust,
  mdiAdvertisements,
  mdiAdvertisementsOff,
  mdiAirConditioner,
  mdiAirFilter,
  mdiAirHorn,
  mdiAirHumidifier,
  mdiAirHumidifierOff,
  mdiAirPurifier,
  mdiAirPurifierOff,
  mdiAirbag,
  mdiAirballoon,
  mdiAirballoonOutline,
  mdiAirplane,
  mdiAirplaneAlert,
  mdiAirplaneCheck,
  mdiAirplaneClock,
  mdiAirplaneCog,
  mdiAirplaneEdit,
  mdiAirplaneLanding,
  mdiAirplaneMarker,
  mdiAirplaneMinus,
  mdiAirplaneOff,
  mdiAirplanePlus,
  mdiAirplaneRemove,
  mdiAirplaneSearch,
  mdiAirplaneSettings,
  mdiAirplaneTakeoff,
  mdiAirport,
  mdiAlarm,
  mdiAlarmBell,
  mdiAlarmCheck,
  mdiAlarmLight,
  mdiAlarmLightOff,
  mdiAlarmLightOffOutline,
  mdiAlarmLightOutline,
  mdiAlarmMultiple,
  mdiAlarmNote,
  mdiAlarmNoteOff,
  mdiAlarmOff,
  mdiAlarmPanel,
  mdiAlarmPanelOutline,
  mdiAlarmPlus,
  mdiAlarmSnooze,
  mdiAlbum,
  mdiAlert,
  mdiAlertBox,
  mdiAlertBoxOutline,
  mdiAlertCircle,
  mdiAlertCircleCheck,
  mdiAlertCircleCheckOutline,
  mdiAlertCircleOutline,
  mdiAlertDecagram,
  mdiAlertDecagramOutline,
  mdiAlertMinus,
  mdiAlertMinusOutline,
  mdiAlertOctagon,
  mdiAlertOctagonOutline,
  mdiAlertOctagram,
  mdiAlertOctagramOutline,
  mdiAlertOutline,
  mdiAlertPlus,
  mdiAlertPlusOutline,
  mdiAlertRemove,
  mdiAlertRemoveOutline,
  mdiAlertRhombus,
  mdiAlertRhombusOutline,
  mdiAlien,
  mdiAlienOutline,
  mdiAlignHorizontalCenter,
  mdiAlignHorizontalDistribute,
  mdiAlignHorizontalLeft,
  mdiAlignHorizontalRight,
  mdiAlignVerticalBottom,
  mdiAlignVerticalCenter,
  mdiAlignVerticalDistribute,
  mdiAlignVerticalTop,
  mdiAllInclusive,
  mdiAllInclusiveBox,
  mdiAllInclusiveBoxOutline,
  mdiAllergy,
  mdiAlpha,
  mdiAlphaA,
  mdiAlphaABox,
  mdiAlphaABoxOutline,
  mdiAlphaACircle,
  mdiAlphaACircleOutline,
  mdiAlphaB,
  mdiAlphaBBox,
  mdiAlphaBBoxOutline,
  mdiAlphaBCircle,
  mdiAlphaBCircleOutline,
  mdiAlphaC,
  mdiAlphaCBox,
  mdiAlphaCBoxOutline,
  mdiAlphaCCircle,
  mdiAlphaCCircleOutline,
  mdiAlphaD,
  mdiAlphaDBox,
  mdiAlphaDBoxOutline,
  mdiAlphaDCircle,
  mdiAlphaDCircleOutline,
  mdiAlphaE,
  mdiAlphaEBox,
  mdiAlphaEBoxOutline,
  mdiAlphaECircle,
  mdiAlphaECircleOutline,
  mdiAlphaF,
  mdiAlphaFBox,
  mdiAlphaFBoxOutline,
  mdiAlphaFCircle,
  mdiAlphaFCircleOutline,
  mdiAlphaG,
  mdiAlphaGBox,
  mdiAlphaGBoxOutline,
  mdiAlphaGCircle,
  mdiAlphaGCircleOutline,
  mdiAlphaH,
  mdiAlphaHBox,
  mdiAlphaHBoxOutline,
  mdiAlphaHCircle,
  mdiAlphaHCircleOutline,
  mdiAlphaI,
  mdiAlphaIBox,
  mdiAlphaIBoxOutline,
  mdiAlphaICircle,
  mdiAlphaICircleOutline,
  mdiAlphaJ,
  mdiAlphaJBox,
  mdiAlphaJBoxOutline,
  mdiAlphaJCircle,
  mdiAlphaJCircleOutline,
  mdiAlphaK,
  mdiAlphaKBox,
  mdiAlphaKBoxOutline,
  mdiAlphaKCircle,
  mdiAlphaKCircleOutline,
  mdiAlphaL,
  mdiAlphaLBox,
  mdiAlphaLBoxOutline,
  mdiAlphaLCircle,
  mdiAlphaLCircleOutline,
  mdiAlphaM,
  mdiAlphaMBox,
  mdiAlphaMBoxOutline,
  mdiAlphaMCircle,
  mdiAlphaMCircleOutline,
  mdiAlphaN,
  mdiAlphaNBox,
  mdiAlphaNBoxOutline,
  mdiAlphaNCircle,
  mdiAlphaNCircleOutline,
  mdiAlphaO,
  mdiAlphaOBox,
  mdiAlphaOBoxOutline,
  mdiAlphaOCircle,
  mdiAlphaOCircleOutline,
  mdiAlphaP,
  mdiAlphaPBox,
  mdiAlphaPBoxOutline,
  mdiAlphaPCircle,
  mdiAlphaPCircleOutline,
  mdiAlphaQ,
  mdiAlphaQBox,
  mdiAlphaQBoxOutline,
  mdiAlphaQCircle,
  mdiAlphaQCircleOutline,
  mdiAlphaR,
  mdiAlphaRBox,
  mdiAlphaRBoxOutline,
  mdiAlphaRCircle,
  mdiAlphaRCircleOutline,
  mdiAlphaS,
  mdiAlphaSBox,
  mdiAlphaSBoxOutline,
  mdiAlphaSCircle,
  mdiAlphaSCircleOutline,
  mdiAlphaT,
  mdiAlphaTBox,
  mdiAlphaTBoxOutline,
  mdiAlphaTCircle,
  mdiAlphaTCircleOutline,
  mdiAlphaU,
  mdiAlphaUBox,
  mdiAlphaUBoxOutline,
  mdiAlphaUCircle,
  mdiAlphaUCircleOutline,
  mdiAlphaV,
  mdiAlphaVBox,
  mdiAlphaVBoxOutline,
  mdiAlphaVCircle,
  mdiAlphaVCircleOutline,
  mdiAlphaW,
  mdiAlphaWBox,
  mdiAlphaWBoxOutline,
  mdiAlphaWCircle,
  mdiAlphaWCircleOutline,
  mdiAlphaX,
  mdiAlphaXBox,
  mdiAlphaXBoxOutline,
  mdiAlphaXCircle,
  mdiAlphaXCircleOutline,
  mdiAlphaY,
  mdiAlphaYBox,
  mdiAlphaYBoxOutline,
  mdiAlphaYCircle,
  mdiAlphaYCircleOutline,
  mdiAlphaZ,
  mdiAlphaZBox,
  mdiAlphaZBoxOutline,
  mdiAlphaZCircle,
  mdiAlphaZCircleOutline,
  mdiAlphabetAurebesh,
  mdiAlphabetCyrillic,
  mdiAlphabetGreek,
  mdiAlphabetLatin,
  mdiAlphabetPiqad,
  mdiAlphabetTengwar,
  mdiAlphabetical,
  mdiAlphabeticalOff,
  mdiAlphabeticalVariant,
  mdiAlphabeticalVariantOff,
  mdiAltimeter,
  mdiAmbulance,
  mdiAmmunition,
  mdiAmpersand,
  mdiAmplifier,
  mdiAmplifierOff,
  mdiAnchor,
  mdiAndroid,
  mdiAndroidStudio,
  mdiAngleAcute,
  mdiAngleObtuse,
  mdiAngleRight,
  mdiAngular,
  mdiAngularjs,
  mdiAnimation,
  mdiAnimationOutline,
  mdiAnimationPlay,
  mdiAnimationPlayOutline,
  mdiAnsible,
  mdiAntenna,
  mdiAnvil,
  mdiApacheKafka,
  mdiApi,
  mdiApiOff,
  mdiApple,
  mdiAppleFinder,
  mdiAppleIcloud,
  mdiAppleIos,
  mdiAppleKeyboardCaps,
  mdiAppleKeyboardCommand,
  mdiAppleKeyboardControl,
  mdiAppleKeyboardOption,
  mdiAppleKeyboardShift,
  mdiAppleSafari,
  mdiApplication,
  mdiApplicationArray,
  mdiApplicationArrayOutline,
  mdiApplicationBraces,
  mdiApplicationBracesOutline,
  mdiApplicationBrackets,
  mdiApplicationBracketsOutline,
  mdiApplicationCog,
  mdiApplicationCogOutline,
  mdiApplicationEdit,
  mdiApplicationEditOutline,
  mdiApplicationExport,
  mdiApplicationImport,
  mdiApplicationOutline,
  mdiApplicationParentheses,
  mdiApplicationParenthesesOutline,
  mdiApplicationSettings,
  mdiApplicationSettingsOutline,
  mdiApplicationVariable,
  mdiApplicationVariableOutline,
  mdiApproximatelyEqual,
  mdiApproximatelyEqualBox,
  mdiApps,
  mdiAppsBox,
  mdiArch,
  mdiArchive,
  mdiArchiveAlert,
  mdiArchiveAlertOutline,
  mdiArchiveArrowDown,
  mdiArchiveArrowDownOutline,
  mdiArchiveArrowUp,
  mdiArchiveArrowUpOutline,
  mdiArchiveCancel,
  mdiArchiveCancelOutline,
  mdiArchiveCheck,
  mdiArchiveCheckOutline,
  mdiArchiveClock,
  mdiArchiveClockOutline,
  mdiArchiveCog,
  mdiArchiveCogOutline,
  mdiArchiveEdit,
  mdiArchiveEditOutline,
  mdiArchiveEye,
  mdiArchiveEyeOutline,
  mdiArchiveLock,
  mdiArchiveLockOpen,
  mdiArchiveLockOpenOutline,
  mdiArchiveLockOutline,
  mdiArchiveMarker,
  mdiArchiveMarkerOutline,
  mdiArchiveMinus,
  mdiArchiveMinusOutline,
  mdiArchiveMusic,
  mdiArchiveMusicOutline,
  mdiArchiveOff,
  mdiArchiveOffOutline,
  mdiArchiveOutline,
  mdiArchivePlus,
  mdiArchivePlusOutline,
  mdiArchiveRefresh,
  mdiArchiveRefreshOutline,
  mdiArchiveRemove,
  mdiArchiveRemoveOutline,
  mdiArchiveSearch,
  mdiArchiveSearchOutline,
  mdiArchiveSettings,
  mdiArchiveSettingsOutline,
  mdiArchiveStar,
  mdiArchiveStarOutline,
  mdiArchiveSync,
  mdiArchiveSyncOutline,
  mdiArmFlex,
  mdiArmFlexOutline,
  mdiArrangeBringForward,
  mdiArrangeBringToFront,
  mdiArrangeSendBackward,
  mdiArrangeSendToBack,
  mdiArrowAll,
  mdiArrowBottomLeft,
  mdiArrowBottomLeftBoldBox,
  mdiArrowBottomLeftBoldBoxOutline,
  mdiArrowBottomLeftBoldOutline,
  mdiArrowBottomLeftThick,
  mdiArrowBottomLeftThin,
  mdiArrowBottomLeftThinCircleOutline,
  mdiArrowBottomRight,
  mdiArrowBottomRightBoldBox,
  mdiArrowBottomRightBoldBoxOutline,
  mdiArrowBottomRightBoldOutline,
  mdiArrowBottomRightThick,
  mdiArrowBottomRightThin,
  mdiArrowBottomRightThinCircleOutline,
  mdiArrowCollapse,
  mdiArrowCollapseAll,
  mdiArrowCollapseDown,
  mdiArrowCollapseHorizontal,
  mdiArrowCollapseLeft,
  mdiArrowCollapseRight,
  mdiArrowCollapseUp,
  mdiArrowCollapseVertical,
  mdiArrowDecision,
  mdiArrowDecisionAuto,
  mdiArrowDecisionAutoOutline,
  mdiArrowDecisionOutline,
  mdiArrowDown,
  mdiArrowDownBold,
  mdiArrowDownBoldBox,
  mdiArrowDownBoldBoxOutline,
  mdiArrowDownBoldCircle,
  mdiArrowDownBoldCircleOutline,
  mdiArrowDownBoldHexagonOutline,
  mdiArrowDownBoldOutline,
  mdiArrowDownBox,
  mdiArrowDownCircle,
  mdiArrowDownCircleOutline,
  mdiArrowDownDropCircle,
  mdiArrowDownDropCircleOutline,
  mdiArrowDownLeft,
  mdiArrowDownLeftBold,
  mdiArrowDownRight,
  mdiArrowDownRightBold,
  mdiArrowDownThick,
  mdiArrowDownThin,
  mdiArrowDownThinCircleOutline,
  mdiArrowExpand,
  mdiArrowExpandAll,
  mdiArrowExpandDown,
  mdiArrowExpandHorizontal,
  mdiArrowExpandLeft,
  mdiArrowExpandRight,
  mdiArrowExpandUp,
  mdiArrowExpandVertical,
  mdiArrowHorizontalLock,
  mdiArrowLeft,
  mdiArrowLeftBold,
  mdiArrowLeftBoldBox,
  mdiArrowLeftBoldBoxOutline,
  mdiArrowLeftBoldCircle,
  mdiArrowLeftBoldCircleOutline,
  mdiArrowLeftBoldHexagonOutline,
  mdiArrowLeftBoldOutline,
  mdiArrowLeftBottom,
  mdiArrowLeftBottomBold,
  mdiArrowLeftBox,
  mdiArrowLeftCircle,
  mdiArrowLeftCircleOutline,
  mdiArrowLeftDropCircle,
  mdiArrowLeftDropCircleOutline,
  mdiArrowLeftRight,
  mdiArrowLeftRightBold,
  mdiArrowLeftRightBoldOutline,
  mdiArrowLeftThick,
  mdiArrowLeftThin,
  mdiArrowLeftThinCircleOutline,
  mdiArrowLeftTop,
  mdiArrowLeftTopBold,
  mdiArrowOscillating,
  mdiArrowOscillatingOff,
  mdiArrowProjectile,
  mdiArrowProjectileMultiple,
  mdiArrowRight,
  mdiArrowRightBold,
  mdiArrowRightBoldBox,
  mdiArrowRightBoldBoxOutline,
  mdiArrowRightBoldCircle,
  mdiArrowRightBoldCircleOutline,
  mdiArrowRightBoldHexagonOutline,
  mdiArrowRightBoldOutline,
  mdiArrowRightBottom,
  mdiArrowRightBottomBold,
  mdiArrowRightBox,
  mdiArrowRightCircle,
  mdiArrowRightCircleOutline,
  mdiArrowRightDropCircle,
  mdiArrowRightDropCircleOutline,
  mdiArrowRightThick,
  mdiArrowRightThin,
  mdiArrowRightThinCircleOutline,
  mdiArrowRightTop,
  mdiArrowRightTopBold,
  mdiArrowSplitHorizontal,
  mdiArrowSplitVertical,
  mdiArrowTopLeft,
  mdiArrowTopLeftBoldBox,
  mdiArrowTopLeftBoldBoxOutline,
  mdiArrowTopLeftBoldOutline,
  mdiArrowTopLeftBottomRight,
  mdiArrowTopLeftBottomRightBold,
  mdiArrowTopLeftThick,
  mdiArrowTopLeftThin,
  mdiArrowTopLeftThinCircleOutline,
  mdiArrowTopRight,
  mdiArrowTopRightBoldBox,
  mdiArrowTopRightBoldBoxOutline,
  mdiArrowTopRightBoldOutline,
  mdiArrowTopRightBottomLeft,
  mdiArrowTopRightBottomLeftBold,
  mdiArrowTopRightThick,
  mdiArrowTopRightThin,
  mdiArrowTopRightThinCircleOutline,
  mdiArrowUDownLeft,
  mdiArrowUDownLeftBold,
  mdiArrowUDownRight,
  mdiArrowUDownRightBold,
  mdiArrowULeftBottom,
  mdiArrowULeftBottomBold,
  mdiArrowULeftTop,
  mdiArrowULeftTopBold,
  mdiArrowURightBottom,
  mdiArrowURightBottomBold,
  mdiArrowURightTop,
  mdiArrowURightTopBold,
  mdiArrowUUpLeft,
  mdiArrowUUpLeftBold,
  mdiArrowUUpRight,
  mdiArrowUUpRightBold,
  mdiArrowUp,
  mdiArrowUpBold,
  mdiArrowUpBoldBox,
  mdiArrowUpBoldBoxOutline,
  mdiArrowUpBoldCircle,
  mdiArrowUpBoldCircleOutline,
  mdiArrowUpBoldHexagonOutline,
  mdiArrowUpBoldOutline,
  mdiArrowUpBox,
  mdiArrowUpCircle,
  mdiArrowUpCircleOutline,
  mdiArrowUpDown,
  mdiArrowUpDownBold,
  mdiArrowUpDownBoldOutline,
  mdiArrowUpDropCircle,
  mdiArrowUpDropCircleOutline,
  mdiArrowUpLeft,
  mdiArrowUpLeftBold,
  mdiArrowUpRight,
  mdiArrowUpRightBold,
  mdiArrowUpThick,
  mdiArrowUpThin,
  mdiArrowUpThinCircleOutline,
  mdiArrowVerticalLock,
  mdiArtboard,
  mdiArtstation,
  mdiAspectRatio,
  mdiAssistant,
  mdiAsterisk,
  mdiAsteriskCircleOutline,
  mdiAt,
  mdiAtlassian,
  mdiAtm,
  mdiAtom,
  mdiAtomVariant,
  mdiAttachment,
  mdiAttachmentCheck,
  mdiAttachmentLock,
  mdiAttachmentMinus,
  mdiAttachmentOff,
  mdiAttachmentPlus,
  mdiAttachmentRemove,
  mdiAtv,
  mdiAudioInputRca,
  mdiAudioInputStereoMinijack,
  mdiAudioInputXlr,
  mdiAudioVideo,
  mdiAudioVideoOff,
  mdiAugmentedReality,
  mdiAurora,
  mdiAutoDownload,
  mdiAutoFix,
  mdiAutoMode,
  mdiAutoUpload,
  mdiAutorenew,
  mdiAutorenewOff,
  mdiAvTimer,
  mdiAwning,
  mdiAwningOutline,
  mdiAws,
  mdiAxe,
  mdiAxeBattle,
  mdiAxis,
  mdiAxisArrow,
  mdiAxisArrowInfo,
  mdiAxisArrowLock,
  mdiAxisLock,
  mdiAxisXArrow,
  mdiAxisXArrowLock,
  mdiAxisXRotateClockwise,
  mdiAxisXRotateCounterclockwise,
  mdiAxisXYArrowLock,
  mdiAxisYArrow,
  mdiAxisYArrowLock,
  mdiAxisYRotateClockwise,
  mdiAxisYRotateCounterclockwise,
  mdiAxisZArrow,
  mdiAxisZArrowLock,
  mdiAxisZRotateClockwise,
  mdiAxisZRotateCounterclockwise,
  mdiBabel,
  mdiBaby,
  mdiBabyBottle,
  mdiBabyBottleOutline,
  mdiBabyBuggy,
  mdiBabyBuggyOff,
  mdiBabyCarriage,
  mdiBabyCarriageOff,
  mdiBabyFace,
  mdiBabyFaceOutline,
  mdiBackburger,
  mdiBackspace,
  mdiBackspaceOutline,
  mdiBackspaceReverse,
  mdiBackspaceReverseOutline,
  mdiBackupRestore,
  mdiBacteria,
  mdiBacteriaOutline,
  mdiBadgeAccount,
  mdiBadgeAccountAlert,
  mdiBadgeAccountAlertOutline,
  mdiBadgeAccountHorizontal,
  mdiBadgeAccountHorizontalOutline,
  mdiBadgeAccountOutline,
  mdiBadminton,
  mdiBagCarryOn,
  mdiBagCarryOnCheck,
  mdiBagCarryOnOff,
  mdiBagChecked,
  mdiBagPersonal,
  mdiBagPersonalOff,
  mdiBagPersonalOffOutline,
  mdiBagPersonalOutline,
  mdiBagPersonalPlus,
  mdiBagPersonalPlusOutline,
  mdiBagPersonalTag,
  mdiBagPersonalTagOutline,
  mdiBagSuitcase,
  mdiBagSuitcaseOff,
  mdiBagSuitcaseOffOutline,
  mdiBagSuitcaseOutline,
  mdiBaguette,
  mdiBalcony,
  mdiBalloon,
  mdiBallot,
  mdiBallotOutline,
  mdiBallotRecount,
  mdiBallotRecountOutline,
  mdiBandage,
  mdiBank,
  mdiBankCheck,
  mdiBankCircle,
  mdiBankCircleOutline,
  mdiBankMinus,
  mdiBankOff,
  mdiBankOffOutline,
  mdiBankOutline,
  mdiBankPlus,
  mdiBankRemove,
  mdiBankTransfer,
  mdiBankTransferIn,
  mdiBankTransferOut,
  mdiBarcode,
  mdiBarcodeOff,
  mdiBarcodeScan,
  mdiBarley,
  mdiBarleyOff,
  mdiBarn,
  mdiBarrel,
  mdiBarrelOutline,
  mdiBaseball,
  mdiBaseballBat,
  mdiBaseballDiamond,
  mdiBaseballDiamondOutline,
  mdiBaseballOutline,
  mdiBash,
  mdiBasket,
  mdiBasketCheck,
  mdiBasketCheckOutline,
  mdiBasketFill,
  mdiBasketMinus,
  mdiBasketMinusOutline,
  mdiBasketOff,
  mdiBasketOffOutline,
  mdiBasketOutline,
  mdiBasketPlus,
  mdiBasketPlusOutline,
  mdiBasketRemove,
  mdiBasketRemoveOutline,
  mdiBasketUnfill,
  mdiBasketball,
  mdiBasketballHoop,
  mdiBasketballHoopOutline,
  mdiBat,
  mdiBathtub,
  mdiBathtubOutline,
  mdiBattery,
  mdiBattery10,
  mdiBattery10Bluetooth,
  mdiBattery20,
  mdiBattery20Bluetooth,
  mdiBattery30,
  mdiBattery30Bluetooth,
  mdiBattery40,
  mdiBattery40Bluetooth,
  mdiBattery50,
  mdiBattery50Bluetooth,
  mdiBattery60,
  mdiBattery60Bluetooth,
  mdiBattery70,
  mdiBattery70Bluetooth,
  mdiBattery80,
  mdiBattery80Bluetooth,
  mdiBattery90,
  mdiBattery90Bluetooth,
  mdiBatteryAlert,
  mdiBatteryAlertBluetooth,
  mdiBatteryAlertVariant,
  mdiBatteryAlertVariantOutline,
  mdiBatteryArrowDown,
  mdiBatteryArrowDownOutline,
  mdiBatteryArrowUp,
  mdiBatteryArrowUpOutline,
  mdiBatteryBluetooth,
  mdiBatteryBluetoothVariant,
  mdiBatteryCharging,
  mdiBatteryCharging10,
  mdiBatteryCharging100,
  mdiBatteryCharging20,
  mdiBatteryCharging30,
  mdiBatteryCharging40,
  mdiBatteryCharging50,
  mdiBatteryCharging60,
  mdiBatteryCharging70,
  mdiBatteryCharging80,
  mdiBatteryCharging90,
  mdiBatteryChargingHigh,
  mdiBatteryChargingLow,
  mdiBatteryChargingMedium,
  mdiBatteryChargingOutline,
  mdiBatteryChargingWireless,
  mdiBatteryChargingWireless10,
  mdiBatteryChargingWireless20,
  mdiBatteryChargingWireless30,
  mdiBatteryChargingWireless40,
  mdiBatteryChargingWireless50,
  mdiBatteryChargingWireless60,
  mdiBatteryChargingWireless70,
  mdiBatteryChargingWireless80,
  mdiBatteryChargingWireless90,
  mdiBatteryChargingWirelessAlert,
  mdiBatteryChargingWirelessOutline,
  mdiBatteryCheck,
  mdiBatteryCheckOutline,
  mdiBatteryClock,
  mdiBatteryClockOutline,
  mdiBatteryHeart,
  mdiBatteryHeartOutline,
  mdiBatteryHeartVariant,
  mdiBatteryHigh,
  mdiBatteryLock,
  mdiBatteryLockOpen,
  mdiBatteryLow,
  mdiBatteryMedium,
  mdiBatteryMinus,
  mdiBatteryMinusOutline,
  mdiBatteryMinusVariant,
  mdiBatteryNegative,
  mdiBatteryOff,
  mdiBatteryOffOutline,
  mdiBatteryOutline,
  mdiBatteryPlus,
  mdiBatteryPlusOutline,
  mdiBatteryPlusVariant,
  mdiBatteryPositive,
  mdiBatteryRemove,
  mdiBatteryRemoveOutline,
  mdiBatterySync,
  mdiBatterySyncOutline,
  mdiBatteryUnknown,
  mdiBatteryUnknownBluetooth,
  mdiBeach,
  mdiBeaker,
  mdiBeakerAlert,
  mdiBeakerAlertOutline,
  mdiBeakerCheck,
  mdiBeakerCheckOutline,
  mdiBeakerMinus,
  mdiBeakerMinusOutline,
  mdiBeakerOutline,
  mdiBeakerPlus,
  mdiBeakerPlusOutline,
  mdiBeakerQuestion,
  mdiBeakerQuestionOutline,
  mdiBeakerRemove,
  mdiBeakerRemoveOutline,
  mdiBed,
  mdiBedClock,
  mdiBedDouble,
  mdiBedDoubleOutline,
  mdiBedEmpty,
  mdiBedKing,
  mdiBedKingOutline,
  mdiBedOutline,
  mdiBedQueen,
  mdiBedQueenOutline,
  mdiBedSingle,
  mdiBedSingleOutline,
  mdiBee,
  mdiBeeFlower,
  mdiBeehiveOffOutline,
  mdiBeehiveOutline,
  mdiBeekeeper,
  mdiBeer,
  mdiBeerOutline,
  mdiBell,
  mdiBellAlert,
  mdiBellAlertOutline,
  mdiBellBadge,
  mdiBellBadgeOutline,
  mdiBellCancel,
  mdiBellCancelOutline,
  mdiBellCheck,
  mdiBellCheckOutline,
  mdiBellCircle,
  mdiBellCircleOutline,
  mdiBellCog,
  mdiBellCogOutline,
  mdiBellMinus,
  mdiBellMinusOutline,
  mdiBellOff,
  mdiBellOffOutline,
  mdiBellOutline,
  mdiBellPlus,
  mdiBellPlusOutline,
  mdiBellRemove,
  mdiBellRemoveOutline,
  mdiBellRing,
  mdiBellRingOutline,
  mdiBellSleep,
  mdiBellSleepOutline,
  mdiBench,
  mdiBenchBack,
  mdiBeta,
  mdiBetamax,
  mdiBiathlon,
  mdiBicycle,
  mdiBicycleBasket,
  mdiBicycleCargo,
  mdiBicycleElectric,
  mdiBicyclePennyFarthing,
  mdiBike,
  mdiBikeFast,
  mdiBikePedal,
  mdiBikePedalClipless,
  mdiBikePedalMountain,
  mdiBillboard,
  mdiBilliards,
  mdiBilliardsRack,
  mdiBinoculars,
  mdiBio,
  mdiBiohazard,
  mdiBird,
  mdiBitbucket,
  mdiBitcoin,
  mdiBlackMesa,
  mdiBlender,
  mdiBlenderOutline,
  mdiBlenderSoftware,
  mdiBlinds,
  mdiBlindsHorizontal,
  mdiBlindsHorizontalClosed,
  mdiBlindsOpen,
  mdiBlindsVertical,
  mdiBlindsVerticalClosed,
  mdiBlockHelper,
  mdiBloodBag,
  mdiBluetooth,
  mdiBluetoothAudio,
  mdiBluetoothConnect,
  mdiBluetoothOff,
  mdiBluetoothSettings,
  mdiBluetoothTransfer,
  mdiBlur,
  mdiBlurLinear,
  mdiBlurOff,
  mdiBlurRadial,
  mdiBolt,
  mdiBomb,
  mdiBombOff,
  mdiBone,
  mdiBoneOff,
  mdiBook,
  mdiBookAccount,
  mdiBookAccountOutline,
  mdiBookAlert,
  mdiBookAlertOutline,
  mdiBookAlphabet,
  mdiBookArrowDown,
  mdiBookArrowDownOutline,
  mdiBookArrowLeft,
  mdiBookArrowLeftOutline,
  mdiBookArrowRight,
  mdiBookArrowRightOutline,
  mdiBookArrowUp,
  mdiBookArrowUpOutline,
  mdiBookCancel,
  mdiBookCancelOutline,
  mdiBookCheck,
  mdiBookCheckOutline,
  mdiBookClock,
  mdiBookClockOutline,
  mdiBookCog,
  mdiBookCogOutline,
  mdiBookCross,
  mdiBookEdit,
  mdiBookEditOutline,
  mdiBookEducation,
  mdiBookEducationOutline,
  mdiBookHeart,
  mdiBookHeartOutline,
  mdiBookInformationVariant,
  mdiBookLock,
  mdiBookLockOpen,
  mdiBookLockOpenOutline,
  mdiBookLockOutline,
  mdiBookMarker,
  mdiBookMarkerOutline,
  mdiBookMinus,
  mdiBookMinusMultiple,
  mdiBookMinusMultipleOutline,
  mdiBookMinusOutline,
  mdiBookMultiple,
  mdiBookMultipleOutline,
  mdiBookMusic,
  mdiBookMusicOutline,
  mdiBookOff,
  mdiBookOffOutline,
  mdiBookOpen,
  mdiBookOpenBlankVariant,
  mdiBookOpenBlankVariantOutline,
  mdiBookOpenOutline,
  mdiBookOpenPageVariant,
  mdiBookOpenPageVariantOutline,
  mdiBookOpenVariant,
  mdiBookOpenVariantOutline,
  mdiBookOutline,
  mdiBookPlay,
  mdiBookPlayOutline,
  mdiBookPlus,
  mdiBookPlusMultiple,
  mdiBookPlusMultipleOutline,
  mdiBookPlusOutline,
  mdiBookRefresh,
  mdiBookRefreshOutline,
  mdiBookRemove,
  mdiBookRemoveMultiple,
  mdiBookRemoveMultipleOutline,
  mdiBookRemoveOutline,
  mdiBookSearch,
  mdiBookSearchOutline,
  mdiBookSettings,
  mdiBookSettingsOutline,
  mdiBookSync,
  mdiBookSyncOutline,
  mdiBookVariant,
  mdiBookmark,
  mdiBookmarkBox,
  mdiBookmarkBoxMultiple,
  mdiBookmarkBoxMultipleOutline,
  mdiBookmarkBoxOutline,
  mdiBookmarkCheck,
  mdiBookmarkCheckOutline,
  mdiBookmarkMinus,
  mdiBookmarkMinusOutline,
  mdiBookmarkMultiple,
  mdiBookmarkMultipleOutline,
  mdiBookmarkMusic,
  mdiBookmarkMusicOutline,
  mdiBookmarkOff,
  mdiBookmarkOffOutline,
  mdiBookmarkOutline,
  mdiBookmarkPlus,
  mdiBookmarkPlusOutline,
  mdiBookmarkRemove,
  mdiBookmarkRemoveOutline,
  mdiBookshelf,
  mdiBoomGate,
  mdiBoomGateAlert,
  mdiBoomGateAlertOutline,
  mdiBoomGateArrowDown,
  mdiBoomGateArrowDownOutline,
  mdiBoomGateArrowUp,
  mdiBoomGateArrowUpOutline,
  mdiBoomGateOutline,
  mdiBoomGateUp,
  mdiBoomGateUpOutline,
  mdiBoombox,
  mdiBoomerang,
  mdiBootstrap,
  mdiBorderAll,
  mdiBorderAllVariant,
  mdiBorderBottom,
  mdiBorderBottomVariant,
  mdiBorderColor,
  mdiBorderHorizontal,
  mdiBorderInside,
  mdiBorderLeft,
  mdiBorderLeftVariant,
  mdiBorderNone,
  mdiBorderNoneVariant,
  mdiBorderOutside,
  mdiBorderRadius,
  mdiBorderRight,
  mdiBorderRightVariant,
  mdiBorderStyle,
  mdiBorderTop,
  mdiBorderTopVariant,
  mdiBorderVertical,
  mdiBottleSoda,
  mdiBottleSodaClassic,
  mdiBottleSodaClassicOutline,
  mdiBottleSodaOutline,
  mdiBottleTonic,
  mdiBottleTonicOutline,
  mdiBottleTonicPlus,
  mdiBottleTonicPlusOutline,
  mdiBottleTonicSkull,
  mdiBottleTonicSkullOutline,
  mdiBottleWine,
  mdiBottleWineOutline,
  mdiBowArrow,
  mdiBowTie,
  mdiBowl,
  mdiBowlMix,
  mdiBowlMixOutline,
  mdiBowlOutline,
  mdiBowling,
  mdiBox,
  mdiBoxCutter,
  mdiBoxCutterOff,
  mdiBoxShadow,
  mdiBoxingGlove,
  mdiBraille,
  mdiBrain,
  mdiBreadSlice,
  mdiBreadSliceOutline,
  mdiBridge,
  mdiBriefcase,
  mdiBriefcaseAccount,
  mdiBriefcaseAccountOutline,
  mdiBriefcaseArrowLeftRight,
  mdiBriefcaseArrowLeftRightOutline,
  mdiBriefcaseArrowUpDown,
  mdiBriefcaseArrowUpDownOutline,
  mdiBriefcaseCheck,
  mdiBriefcaseCheckOutline,
  mdiBriefcaseClock,
  mdiBriefcaseClockOutline,
  mdiBriefcaseDownload,
  mdiBriefcaseDownloadOutline,
  mdiBriefcaseEdit,
  mdiBriefcaseEditOutline,
  mdiBriefcaseEye,
  mdiBriefcaseEyeOutline,
  mdiBriefcaseMinus,
  mdiBriefcaseMinusOutline,
  mdiBriefcaseOff,
  mdiBriefcaseOffOutline,
  mdiBriefcaseOutline,
  mdiBriefcasePlus,
  mdiBriefcasePlusOutline,
  mdiBriefcaseRemove,
  mdiBriefcaseRemoveOutline,
  mdiBriefcaseSearch,
  mdiBriefcaseSearchOutline,
  mdiBriefcaseUpload,
  mdiBriefcaseUploadOutline,
  mdiBriefcaseVariant,
  mdiBriefcaseVariantOff,
  mdiBriefcaseVariantOffOutline,
  mdiBriefcaseVariantOutline,
  mdiBrightness1,
  mdiBrightness2,
  mdiBrightness3,
  mdiBrightness4,
  mdiBrightness5,
  mdiBrightness6,
  mdiBrightness7,
  mdiBrightnessAuto,
  mdiBrightnessPercent,
  mdiBroadcast,
  mdiBroadcastOff,
  mdiBroom,
  mdiBrush,
  mdiBrushOff,
  mdiBrushOutline,
  mdiBrushVariant,
  mdiBucket,
  mdiBucketOutline,
  mdiBuffet,
  mdiBug,
  mdiBugCheck,
  mdiBugCheckOutline,
  mdiBugOutline,
  mdiBugPause,
  mdiBugPauseOutline,
  mdiBugPlay,
  mdiBugPlayOutline,
  mdiBugStop,
  mdiBugStopOutline,
  mdiBugle,
  mdiBulkheadLight,
  mdiBulldozer,
  mdiBullet,
  mdiBulletinBoard,
  mdiBullhorn,
  mdiBullhornOutline,
  mdiBullhornVariant,
  mdiBullhornVariantOutline,
  mdiBullseye,
  mdiBullseyeArrow,
  mdiBulma,
  mdiBunkBed,
  mdiBunkBedOutline,
  mdiBus,
  mdiBusAlert,
  mdiBusArticulatedEnd,
  mdiBusArticulatedFront,
  mdiBusClock,
  mdiBusDoubleDecker,
  mdiBusElectric,
  mdiBusMarker,
  mdiBusMultiple,
  mdiBusSchool,
  mdiBusSide,
  mdiBusSign,
  mdiBusStop,
  mdiBusStopCovered,
  mdiBusStopUncovered,
  mdiBusWrench,
  mdiButterfly,
  mdiButterflyOutline,
  mdiButtonCursor,
  mdiButtonPointer,
  mdiCabinAFrame,
  mdiCableData,
  mdiCached,
  mdiCactus,
  mdiCake,
  mdiCakeLayered,
  mdiCakeVariant,
  mdiCakeVariantOutline,
  mdiCalculator,
  mdiCalculatorVariant,
  mdiCalculatorVariantOutline,
  mdiCalendar,
  mdiCalendarAccount,
  mdiCalendarAccountOutline,
  mdiCalendarAlert,
  mdiCalendarAlertOutline,
  mdiCalendarArrowLeft,
  mdiCalendarArrowRight,
  mdiCalendarBadge,
  mdiCalendarBadgeOutline,
  mdiCalendarBlank,
  mdiCalendarBlankMultiple,
  mdiCalendarBlankOutline,
  mdiCalendarCheck,
  mdiCalendarCheckOutline,
  mdiCalendarClock,
  mdiCalendarClockOutline,
  mdiCalendarCollapseHorizontal,
  mdiCalendarCollapseHorizontalOutline,
  mdiCalendarCursor,
  mdiCalendarCursorOutline,
  mdiCalendarEdit,
  mdiCalendarEditOutline,
  mdiCalendarEnd,
  mdiCalendarEndOutline,
  mdiCalendarExpandHorizontal,
  mdiCalendarExpandHorizontalOutline,
  mdiCalendarExport,
  mdiCalendarExportOutline,
  mdiCalendarFilter,
  mdiCalendarFilterOutline,
  mdiCalendarHeart,
  mdiCalendarHeartOutline,
  mdiCalendarImport,
  mdiCalendarImportOutline,
  mdiCalendarLock,
  mdiCalendarLockOpen,
  mdiCalendarLockOpenOutline,
  mdiCalendarLockOutline,
  mdiCalendarMinus,
  mdiCalendarMinusOutline,
  mdiCalendarMonth,
  mdiCalendarMonthOutline,
  mdiCalendarMultiple,
  mdiCalendarMultipleCheck,
  mdiCalendarMultiselect,
  mdiCalendarMultiselectOutline,
  mdiCalendarOutline,
  mdiCalendarPlus,
  mdiCalendarPlusOutline,
  mdiCalendarQuestion,
  mdiCalendarQuestionOutline,
  mdiCalendarRange,
  mdiCalendarRangeOutline,
  mdiCalendarRefresh,
  mdiCalendarRefreshOutline,
  mdiCalendarRemove,
  mdiCalendarRemoveOutline,
  mdiCalendarSearch,
  mdiCalendarSearchOutline,
  mdiCalendarStar,
  mdiCalendarStarFourPoints,
  mdiCalendarStarOutline,
  mdiCalendarStart,
  mdiCalendarStartOutline,
  mdiCalendarSync,
  mdiCalendarSyncOutline,
  mdiCalendarText,
  mdiCalendarTextOutline,
  mdiCalendarToday,
  mdiCalendarTodayOutline,
  mdiCalendarWeek,
  mdiCalendarWeekBegin,
  mdiCalendarWeekBeginOutline,
  mdiCalendarWeekOutline,
  mdiCalendarWeekend,
  mdiCalendarWeekendOutline,
  mdiCallMade,
  mdiCallMerge,
  mdiCallMissed,
  mdiCallReceived,
  mdiCallSplit,
  mdiCamcorder,
  mdiCamcorderOff,
  mdiCamera,
  mdiCameraAccount,
  mdiCameraBurst,
  mdiCameraControl,
  mdiCameraDocument,
  mdiCameraDocumentOff,
  mdiCameraEnhance,
  mdiCameraEnhanceOutline,
  mdiCameraFlip,
  mdiCameraFlipOutline,
  mdiCameraFront,
  mdiCameraFrontVariant,
  mdiCameraGopro,
  mdiCameraImage,
  mdiCameraIris,
  mdiCameraLock,
  mdiCameraLockOpen,
  mdiCameraLockOpenOutline,
  mdiCameraLockOutline,
  mdiCameraMarker,
  mdiCameraMarkerOutline,
  mdiCameraMeteringCenter,
  mdiCameraMeteringMatrix,
  mdiCameraMeteringPartial,
  mdiCameraMeteringSpot,
  mdiCameraOff,
  mdiCameraOffOutline,
  mdiCameraOutline,
  mdiCameraPartyMode,
  mdiCameraPlus,
  mdiCameraPlusOutline,
  mdiCameraRear,
  mdiCameraRearVariant,
  mdiCameraRetake,
  mdiCameraRetakeOutline,
  mdiCameraSwitch,
  mdiCameraSwitchOutline,
  mdiCameraTimer,
  mdiCameraWireless,
  mdiCameraWirelessOutline,
  mdiCampfire,
  mdiCancel,
  mdiCandelabra,
  mdiCandelabraFire,
  mdiCandle,
  mdiCandy,
  mdiCandyOff,
  mdiCandyOffOutline,
  mdiCandyOutline,
  mdiCandycane,
  mdiCannabis,
  mdiCannabisOff,
  mdiCapsLock,
  mdiCar,
  mdiCar2Plus,
  mdiCar3Plus,
  mdiCarArrowLeft,
  mdiCarArrowRight,
  mdiCarBack,
  mdiCarBattery,
  mdiCarBrakeAbs,
  mdiCarBrakeAlert,
  mdiCarBrakeFluidLevel,
  mdiCarBrakeHold,
  mdiCarBrakeLowPressure,
  mdiCarBrakeParking,
  mdiCarBrakeRetarder,
  mdiCarBrakeTemperature,
  mdiCarBrakeWornLinings,
  mdiCarChildSeat,
  mdiCarClock,
  mdiCarClutch,
  mdiCarCog,
  mdiCarConnected,
  mdiCarConvertible,
  mdiCarCoolantLevel,
  mdiCarCruiseControl,
  mdiCarDefrostFront,
  mdiCarDefrostRear,
  mdiCarDoor,
  mdiCarDoorLock,
  mdiCarDoorLockOpen,
  mdiCarElectric,
  mdiCarElectricOutline,
  mdiCarEmergency,
  mdiCarEsp,
  mdiCarEstate,
  mdiCarHatchback,
  mdiCarInfo,
  mdiCarKey,
  mdiCarLiftedPickup,
  mdiCarLightAlert,
  mdiCarLightDimmed,
  mdiCarLightFog,
  mdiCarLightHigh,
  mdiCarLimousine,
  mdiCarMultiple,
  mdiCarOff,
  mdiCarOutline,
  mdiCarParkingLights,
  mdiCarPickup,
  mdiCarSearch,
  mdiCarSearchOutline,
  mdiCarSeat,
  mdiCarSeatCooler,
  mdiCarSeatHeater,
  mdiCarSelect,
  mdiCarSettings,
  mdiCarShiftPattern,
  mdiCarSide,
  mdiCarSpeedLimiter,
  mdiCarSports,
  mdiCarTireAlert,
  mdiCarTractionControl,
  mdiCarTurbocharger,
  mdiCarWash,
  mdiCarWindshield,
  mdiCarWindshieldOutline,
  mdiCarWireless,
  mdiCarWrench,
  mdiCarabiner,
  mdiCaravan,
  mdiCard,
  mdiCardAccountDetails,
  mdiCardAccountDetailsOutline,
  mdiCardAccountDetailsStar,
  mdiCardAccountDetailsStarOutline,
  mdiCardAccountMail,
  mdiCardAccountMailOutline,
  mdiCardAccountPhone,
  mdiCardAccountPhoneOutline,
  mdiCardBulleted,
  mdiCardBulletedOff,
  mdiCardBulletedOffOutline,
  mdiCardBulletedOutline,
  mdiCardBulletedSettings,
  mdiCardBulletedSettingsOutline,
  mdiCardMinus,
  mdiCardMinusOutline,
  mdiCardMultiple,
  mdiCardMultipleOutline,
  mdiCardOff,
  mdiCardOffOutline,
  mdiCardOutline,
  mdiCardPlus,
  mdiCardPlusOutline,
  mdiCardRemove,
  mdiCardRemoveOutline,
  mdiCardSearch,
  mdiCardSearchOutline,
  mdiCardText,
  mdiCardTextOutline,
  mdiCards,
  mdiCardsClub,
  mdiCardsClubOutline,
  mdiCardsDiamond,
  mdiCardsDiamondOutline,
  mdiCardsHeart,
  mdiCardsHeartOutline,
  mdiCardsOutline,
  mdiCardsPlaying,
  mdiCardsPlayingClub,
  mdiCardsPlayingClubMultiple,
  mdiCardsPlayingClubMultipleOutline,
  mdiCardsPlayingClubOutline,
  mdiCardsPlayingDiamond,
  mdiCardsPlayingDiamondMultiple,
  mdiCardsPlayingDiamondMultipleOutline,
  mdiCardsPlayingDiamondOutline,
  mdiCardsPlayingHeart,
  mdiCardsPlayingHeartMultiple,
  mdiCardsPlayingHeartMultipleOutline,
  mdiCardsPlayingHeartOutline,
  mdiCardsPlayingOutline,
  mdiCardsPlayingSpade,
  mdiCardsPlayingSpadeMultiple,
  mdiCardsPlayingSpadeMultipleOutline,
  mdiCardsPlayingSpadeOutline,
  mdiCardsSpade,
  mdiCardsSpadeOutline,
  mdiCardsVariant,
  mdiCarrot,
  mdiCart,
  mdiCartArrowDown,
  mdiCartArrowRight,
  mdiCartArrowUp,
  mdiCartCheck,
  mdiCartHeart,
  mdiCartMinus,
  mdiCartOff,
  mdiCartOutline,
  mdiCartPercent,
  mdiCartPlus,
  mdiCartRemove,
  mdiCartVariant,
  mdiCaseSensitiveAlt,
  mdiCash,
  mdiCash100,
  mdiCashCheck,
  mdiCashClock,
  mdiCashEdit,
  mdiCashFast,
  mdiCashLock,
  mdiCashLockOpen,
  mdiCashMarker,
  mdiCashMinus,
  mdiCashMultiple,
  mdiCashOff,
  mdiCashPlus,
  mdiCashRefund,
  mdiCashRegister,
  mdiCashRemove,
  mdiCashSync,
  mdiCassette,
  mdiCast,
  mdiCastAudio,
  mdiCastAudioVariant,
  mdiCastConnected,
  mdiCastEducation,
  mdiCastOff,
  mdiCastVariant,
  mdiCastle,
  mdiCat,
  mdiCctv,
  mdiCctvOff,
  mdiCeilingFan,
  mdiCeilingFanLight,
  mdiCeilingLight,
  mdiCeilingLightMultiple,
  mdiCeilingLightMultipleOutline,
  mdiCeilingLightOutline,
  mdiCellphone,
  mdiCellphoneArrowDown,
  mdiCellphoneArrowDownVariant,
  mdiCellphoneBasic,
  mdiCellphoneCharging,
  mdiCellphoneCheck,
  mdiCellphoneCog,
  mdiCellphoneDock,
  mdiCellphoneInformation,
  mdiCellphoneKey,
  mdiCellphoneLink,
  mdiCellphoneLinkOff,
  mdiCellphoneLock,
  mdiCellphoneMarker,
  mdiCellphoneMessage,
  mdiCellphoneMessageOff,
  mdiCellphoneNfc,
  mdiCellphoneNfcOff,
  mdiCellphoneOff,
  mdiCellphonePlay,
  mdiCellphoneRemove,
  mdiCellphoneScreenshot,
  mdiCellphoneSettings,
  mdiCellphoneSound,
  mdiCellphoneText,
  mdiCellphoneWireless,
  mdiCentos,
  mdiCertificate,
  mdiCertificateOutline,
  mdiChairRolling,
  mdiChairSchool,
  mdiChandelier,
  mdiCharity,
  mdiCharitySearch,
  mdiChartArc,
  mdiChartAreaspline,
  mdiChartAreasplineVariant,
  mdiChartBar,
  mdiChartBarStacked,
  mdiChartBellCurve,
  mdiChartBellCurveCumulative,
  mdiChartBox,
  mdiChartBoxMultiple,
  mdiChartBoxMultipleOutline,
  mdiChartBoxOutline,
  mdiChartBoxPlusOutline,
  mdiChartBubble,
  mdiChartDonut,
  mdiChartDonutVariant,
  mdiChartGantt,
  mdiChartHistogram,
  mdiChartLine,
  mdiChartLineStacked,
  mdiChartLineVariant,
  mdiChartMultiline,
  mdiChartMultiple,
  mdiChartPie,
  mdiChartPieOutline,
  mdiChartPpf,
  mdiChartSankey,
  mdiChartSankeyVariant,
  mdiChartScatterPlot,
  mdiChartScatterPlotHexbin,
  mdiChartTimeline,
  mdiChartTimelineVariant,
  mdiChartTimelineVariantShimmer,
  mdiChartTree,
  mdiChartWaterfall,
  mdiChat,
  mdiChatAlert,
  mdiChatAlertOutline,
  mdiChatMinus,
  mdiChatMinusOutline,
  mdiChatOutline,
  mdiChatPlus,
  mdiChatPlusOutline,
  mdiChatProcessing,
  mdiChatProcessingOutline,
  mdiChatQuestion,
  mdiChatQuestionOutline,
  mdiChatRemove,
  mdiChatRemoveOutline,
  mdiChatSleep,
  mdiChatSleepOutline,
  mdiCheck,
  mdiCheckAll,
  mdiCheckBold,
  mdiCheckCircle,
  mdiCheckCircleOutline,
  mdiCheckDecagram,
  mdiCheckDecagramOutline,
  mdiCheckNetwork,
  mdiCheckNetworkOutline,
  mdiCheckOutline,
  mdiCheckUnderline,
  mdiCheckUnderlineCircle,
  mdiCheckUnderlineCircleOutline,
  mdiCheckbook,
  mdiCheckbookArrowLeft,
  mdiCheckbookArrowRight,
  mdiCheckboxBlank,
  mdiCheckboxBlankBadge,
  mdiCheckboxBlankBadgeOutline,
  mdiCheckboxBlankCircle,
  mdiCheckboxBlankCircleOutline,
  mdiCheckboxBlankOff,
  mdiCheckboxBlankOffOutline,
  mdiCheckboxBlankOutline,
  mdiCheckboxIntermediate,
  mdiCheckboxIntermediateVariant,
  mdiCheckboxMarked,
  mdiCheckboxMarkedCircle,
  mdiCheckboxMarkedCircleAutoOutline,
  mdiCheckboxMarkedCircleMinusOutline,
  mdiCheckboxMarkedCircleOutline,
  mdiCheckboxMarkedCirclePlusOutline,
  mdiCheckboxMarkedOutline,
  mdiCheckboxMultipleBlank,
  mdiCheckboxMultipleBlankCircle,
  mdiCheckboxMultipleBlankCircleOutline,
  mdiCheckboxMultipleBlankOutline,
  mdiCheckboxMultipleMarked,
  mdiCheckboxMultipleMarkedCircle,
  mdiCheckboxMultipleMarkedCircleOutline,
  mdiCheckboxMultipleMarkedOutline,
  mdiCheckboxMultipleOutline,
  mdiCheckboxOutline,
  mdiCheckerboard,
  mdiCheckerboardMinus,
  mdiCheckerboardPlus,
  mdiCheckerboardRemove,
  mdiCheese,
  mdiCheeseOff,
  mdiChefHat,
  mdiChemicalWeapon,
  mdiChessBishop,
  mdiChessKing,
  mdiChessKnight,
  mdiChessPawn,
  mdiChessQueen,
  mdiChessRook,
  mdiChevronDoubleDown,
  mdiChevronDoubleLeft,
  mdiChevronDoubleRight,
  mdiChevronDoubleUp,
  mdiChevronDown,
  mdiChevronDownBox,
  mdiChevronDownBoxOutline,
  mdiChevronDownCircle,
  mdiChevronDownCircleOutline,
  mdiChevronLeft,
  mdiChevronLeftBox,
  mdiChevronLeftBoxOutline,
  mdiChevronLeftCircle,
  mdiChevronLeftCircleOutline,
  mdiChevronRight,
  mdiChevronRightBox,
  mdiChevronRightBoxOutline,
  mdiChevronRightCircle,
  mdiChevronRightCircleOutline,
  mdiChevronTripleDown,
  mdiChevronTripleLeft,
  mdiChevronTripleRight,
  mdiChevronTripleUp,
  mdiChevronUp,
  mdiChevronUpBox,
  mdiChevronUpBoxOutline,
  mdiChevronUpCircle,
  mdiChevronUpCircleOutline,
  mdiChiliAlert,
  mdiChiliAlertOutline,
  mdiChiliHot,
  mdiChiliHotOutline,
  mdiChiliMedium,
  mdiChiliMediumOutline,
  mdiChiliMild,
  mdiChiliMildOutline,
  mdiChiliOff,
  mdiChiliOffOutline,
  mdiChip,
  mdiChurch,
  mdiChurchOutline,
  mdiCigar,
  mdiCigarOff,
  mdiCircle,
  mdiCircleBox,
  mdiCircleBoxOutline,
  mdiCircleDouble,
  mdiCircleEditOutline,
  mdiCircleExpand,
  mdiCircleHalf,
  mdiCircleHalfFull,
  mdiCircleMedium,
  mdiCircleMultiple,
  mdiCircleMultipleOutline,
  mdiCircleOffOutline,
  mdiCircleOpacity,
  mdiCircleOutline,
  mdiCircleSlice1,
  mdiCircleSlice2,
  mdiCircleSlice3,
  mdiCircleSlice4,
  mdiCircleSlice5,
  mdiCircleSlice6,
  mdiCircleSlice7,
  mdiCircleSlice8,
  mdiCircleSmall,
  mdiCircularSaw,
  mdiCity,
  mdiCitySwitch,
  mdiCityVariant,
  mdiCityVariantOutline,
  mdiClipboard,
  mdiClipboardAccount,
  mdiClipboardAccountOutline,
  mdiClipboardAlert,
  mdiClipboardAlertOutline,
  mdiClipboardArrowDown,
  mdiClipboardArrowDownOutline,
  mdiClipboardArrowLeft,
  mdiClipboardArrowLeftOutline,
  mdiClipboardArrowRight,
  mdiClipboardArrowRightOutline,
  mdiClipboardArrowUp,
  mdiClipboardArrowUpOutline,
  mdiClipboardCheck,
  mdiClipboardCheckMultiple,
  mdiClipboardCheckMultipleOutline,
  mdiClipboardCheckOutline,
  mdiClipboardClock,
  mdiClipboardClockOutline,
  mdiClipboardEdit,
  mdiClipboardEditOutline,
  mdiClipboardFile,
  mdiClipboardFileOutline,
  mdiClipboardFlow,
  mdiClipboardFlowOutline,
  mdiClipboardList,
  mdiClipboardListOutline,
  mdiClipboardMinus,
  mdiClipboardMinusOutline,
  mdiClipboardMultiple,
  mdiClipboardMultipleOutline,
  mdiClipboardOff,
  mdiClipboardOffOutline,
  mdiClipboardOutline,
  mdiClipboardPlay,
  mdiClipboardPlayMultiple,
  mdiClipboardPlayMultipleOutline,
  mdiClipboardPlayOutline,
  mdiClipboardPlus,
  mdiClipboardPlusOutline,
  mdiClipboardPulse,
  mdiClipboardPulseOutline,
  mdiClipboardRemove,
  mdiClipboardRemoveOutline,
  mdiClipboardSearch,
  mdiClipboardSearchOutline,
  mdiClipboardText,
  mdiClipboardTextClock,
  mdiClipboardTextClockOutline,
  mdiClipboardTextMultiple,
  mdiClipboardTextMultipleOutline,
  mdiClipboardTextOff,
  mdiClipboardTextOffOutline,
  mdiClipboardTextOutline,
  mdiClipboardTextPlay,
  mdiClipboardTextPlayOutline,
  mdiClipboardTextSearch,
  mdiClipboardTextSearchOutline,
  mdiClippy,
  mdiClock,
  mdiClockAlert,
  mdiClockAlertOutline,
  mdiClockCheck,
  mdiClockCheckOutline,
  mdiClockDigital,
  mdiClockEdit,
  mdiClockEditOutline,
  mdiClockEnd,
  mdiClockFast,
  mdiClockIn,
  mdiClockMinus,
  mdiClockMinusOutline,
  mdiClockOut,
  mdiClockOutline,
  mdiClockPlus,
  mdiClockPlusOutline,
  mdiClockRemove,
  mdiClockRemoveOutline,
  mdiClockStarFourPoints,
  mdiClockStarFourPointsOutline,
  mdiClockStart,
  mdiClockTimeEight,
  mdiClockTimeEightOutline,
  mdiClockTimeEleven,
  mdiClockTimeElevenOutline,
  mdiClockTimeFive,
  mdiClockTimeFiveOutline,
  mdiClockTimeFour,
  mdiClockTimeFourOutline,
  mdiClockTimeNine,
  mdiClockTimeNineOutline,
  mdiClockTimeOne,
  mdiClockTimeOneOutline,
  mdiClockTimeSeven,
  mdiClockTimeSevenOutline,
  mdiClockTimeSix,
  mdiClockTimeSixOutline,
  mdiClockTimeTen,
  mdiClockTimeTenOutline,
  mdiClockTimeThree,
  mdiClockTimeThreeOutline,
  mdiClockTimeTwelve,
  mdiClockTimeTwelveOutline,
  mdiClockTimeTwo,
  mdiClockTimeTwoOutline,
  mdiClose,
  mdiCloseBox,
  mdiCloseBoxMultiple,
  mdiCloseBoxMultipleOutline,
  mdiCloseBoxOutline,
  mdiCloseCircle,
  mdiCloseCircleMultiple,
  mdiCloseCircleMultipleOutline,
  mdiCloseCircleOutline,
  mdiCloseNetwork,
  mdiCloseNetworkOutline,
  mdiCloseOctagon,
  mdiCloseOctagonOutline,
  mdiCloseOutline,
  mdiCloseThick,
  mdiClosedCaption,
  mdiClosedCaptionOutline,
  mdiCloud,
  mdiCloudAlert,
  mdiCloudAlertOutline,
  mdiCloudArrowDown,
  mdiCloudArrowDownOutline,
  mdiCloudArrowLeft,
  mdiCloudArrowLeftOutline,
  mdiCloudArrowRight,
  mdiCloudArrowRightOutline,
  mdiCloudArrowUp,
  mdiCloudArrowUpOutline,
  mdiCloudBraces,
  mdiCloudCancel,
  mdiCloudCancelOutline,
  mdiCloudCheck,
  mdiCloudCheckOutline,
  mdiCloudCheckVariant,
  mdiCloudCheckVariantOutline,
  mdiCloudCircle,
  mdiCloudCircleOutline,
  mdiCloudClock,
  mdiCloudClockOutline,
  mdiCloudCog,
  mdiCloudCogOutline,
  mdiCloudDownload,
  mdiCloudDownloadOutline,
  mdiCloudKey,
  mdiCloudKeyOutline,
  mdiCloudLock,
  mdiCloudLockOpen,
  mdiCloudLockOpenOutline,
  mdiCloudLockOutline,
  mdiCloudMinus,
  mdiCloudMinusOutline,
  mdiCloudOff,
  mdiCloudOffOutline,
  mdiCloudOutline,
  mdiCloudPercent,
  mdiCloudPercentOutline,
  mdiCloudPlus,
  mdiCloudPlusOutline,
  mdiCloudPrint,
  mdiCloudPrintOutline,
  mdiCloudQuestion,
  mdiCloudQuestionOutline,
  mdiCloudRefresh,
  mdiCloudRefreshOutline,
  mdiCloudRefreshVariant,
  mdiCloudRefreshVariantOutline,
  mdiCloudRemove,
  mdiCloudRemoveOutline,
  mdiCloudSearch,
  mdiCloudSearchOutline,
  mdiCloudSync,
  mdiCloudSyncOutline,
  mdiCloudTags,
  mdiCloudUpload,
  mdiCloudUploadOutline,
  mdiClouds,
  mdiClover,
  mdiCloverOutline,
  mdiCoachLamp,
  mdiCoachLampVariant,
  mdiCoatRack,
  mdiCodeArray,
  mdiCodeBlockBraces,
  mdiCodeBlockBrackets,
  mdiCodeBlockParentheses,
  mdiCodeBlockTags,
  mdiCodeBraces,
  mdiCodeBracesBox,
  mdiCodeBrackets,
  mdiCodeEqual,
  mdiCodeGreaterThan,
  mdiCodeGreaterThanOrEqual,
  mdiCodeJson,
  mdiCodeLessThan,
  mdiCodeLessThanOrEqual,
  mdiCodeNotEqual,
  mdiCodeNotEqualVariant,
  mdiCodeParentheses,
  mdiCodeParenthesesBox,
  mdiCodeString,
  mdiCodeTags,
  mdiCodeTagsCheck,
  mdiCodepen,
  mdiCoffee,
  mdiCoffeeMaker,
  mdiCoffeeMakerCheck,
  mdiCoffeeMakerCheckOutline,
  mdiCoffeeMakerOutline,
  mdiCoffeeOff,
  mdiCoffeeOffOutline,
  mdiCoffeeOutline,
  mdiCoffeeToGo,
  mdiCoffeeToGoOutline,
  mdiCoffin,
  mdiCog,
  mdiCogBox,
  mdiCogClockwise,
  mdiCogCounterclockwise,
  mdiCogOff,
  mdiCogOffOutline,
  mdiCogOutline,
  mdiCogPause,
  mdiCogPauseOutline,
  mdiCogPlay,
  mdiCogPlayOutline,
  mdiCogRefresh,
  mdiCogRefreshOutline,
  mdiCogStop,
  mdiCogStopOutline,
  mdiCogSync,
  mdiCogSyncOutline,
  mdiCogTransfer,
  mdiCogTransferOutline,
  mdiCogs,
  mdiCollage,
  mdiCollapseAll,
  mdiCollapseAllOutline,
  mdiColorHelper,
  mdiComma,
  mdiCommaBox,
  mdiCommaBoxOutline,
  mdiCommaCircle,
  mdiCommaCircleOutline,
  mdiComment,
  mdiCommentAccount,
  mdiCommentAccountOutline,
  mdiCommentAlert,
  mdiCommentAlertOutline,
  mdiCommentArrowLeft,
  mdiCommentArrowLeftOutline,
  mdiCommentArrowRight,
  mdiCommentArrowRightOutline,
  mdiCommentBookmark,
  mdiCommentBookmarkOutline,
  mdiCommentCheck,
  mdiCommentCheckOutline,
  mdiCommentEdit,
  mdiCommentEditOutline,
  mdiCommentEye,
  mdiCommentEyeOutline,
  mdiCommentFlash,
  mdiCommentFlashOutline,
  mdiCommentMinus,
  mdiCommentMinusOutline,
  mdiCommentMultiple,
  mdiCommentMultipleOutline,
  mdiCommentOff,
  mdiCommentOffOutline,
  mdiCommentOutline,
  mdiCommentPlus,
  mdiCommentPlusOutline,
  mdiCommentProcessing,
  mdiCommentProcessingOutline,
  mdiCommentQuestion,
  mdiCommentQuestionOutline,
  mdiCommentQuote,
  mdiCommentQuoteOutline,
  mdiCommentRemove,
  mdiCommentRemoveOutline,
  mdiCommentSearch,
  mdiCommentSearchOutline,
  mdiCommentText,
  mdiCommentTextMultiple,
  mdiCommentTextMultipleOutline,
  mdiCommentTextOutline,
  mdiCompare,
  mdiCompareHorizontal,
  mdiCompareRemove,
  mdiCompareVertical,
  mdiCompass,
  mdiCompassOff,
  mdiCompassOffOutline,
  mdiCompassOutline,
  mdiCompassRose,
  mdiCompost,
  mdiCone,
  mdiConeOff,
  mdiConnection,
  mdiConsole,
  mdiConsoleLine,
  mdiConsoleNetwork,
  mdiConsoleNetworkOutline,
  mdiConsolidate,
  mdiContactlessPayment,
  mdiContactlessPaymentCircle,
  mdiContactlessPaymentCircleOutline,
  mdiContacts,
  mdiContactsOutline,
  mdiContain,
  mdiContainEnd,
  mdiContainStart,
  mdiContentCopy,
  mdiContentCut,
  mdiContentDuplicate,
  mdiContentPaste,
  mdiContentSave,
  mdiContentSaveAlert,
  mdiContentSaveAlertOutline,
  mdiContentSaveAll,
  mdiContentSaveAllOutline,
  mdiContentSaveCheck,
  mdiContentSaveCheckOutline,
  mdiContentSaveCog,
  mdiContentSaveCogOutline,
  mdiContentSaveEdit,
  mdiContentSaveEditOutline,
  mdiContentSaveMinus,
  mdiContentSaveMinusOutline,
  mdiContentSaveMove,
  mdiContentSaveMoveOutline,
  mdiContentSaveOff,
  mdiContentSaveOffOutline,
  mdiContentSaveOutline,
  mdiContentSavePlus,
  mdiContentSavePlusOutline,
  mdiContentSaveSettings,
  mdiContentSaveSettingsOutline,
  mdiContrast,
  mdiContrastBox,
  mdiContrastCircle,
  mdiController,
  mdiControllerClassic,
  mdiControllerClassicOutline,
  mdiControllerOff,
  mdiCookie,
  mdiCookieAlert,
  mdiCookieAlertOutline,
  mdiCookieCheck,
  mdiCookieCheckOutline,
  mdiCookieClock,
  mdiCookieClockOutline,
  mdiCookieCog,
  mdiCookieCogOutline,
  mdiCookieEdit,
  mdiCookieEditOutline,
  mdiCookieLock,
  mdiCookieLockOutline,
  mdiCookieMinus,
  mdiCookieMinusOutline,
  mdiCookieOff,
  mdiCookieOffOutline,
  mdiCookieOutline,
  mdiCookiePlus,
  mdiCookiePlusOutline,
  mdiCookieRefresh,
  mdiCookieRefreshOutline,
  mdiCookieRemove,
  mdiCookieRemoveOutline,
  mdiCookieSettings,
  mdiCookieSettingsOutline,
  mdiCoolantTemperature,
  mdiCopyleft,
  mdiCopyright,
  mdiCordova,
  mdiCorn,
  mdiCornOff,
  mdiCosineWave,
  mdiCounter,
  mdiCountertop,
  mdiCountertopOutline,
  mdiCow,
  mdiCowOff,
  mdiCpu32Bit,
  mdiCpu64Bit,
  mdiCradle,
  mdiCradleOutline,
  mdiCrane,
  mdiCreation,
  mdiCreationOutline,
  mdiCreativeCommons,
  mdiCreditCard,
  mdiCreditCardCheck,
  mdiCreditCardCheckOutline,
  mdiCreditCardChip,
  mdiCreditCardChipOutline,
  mdiCreditCardClock,
  mdiCreditCardClockOutline,
  mdiCreditCardEdit,
  mdiCreditCardEditOutline,
  mdiCreditCardFast,
  mdiCreditCardFastOutline,
  mdiCreditCardLock,
  mdiCreditCardLockOutline,
  mdiCreditCardMarker,
  mdiCreditCardMarkerOutline,
  mdiCreditCardMinus,
  mdiCreditCardMinusOutline,
  mdiCreditCardMultiple,
  mdiCreditCardMultipleOutline,
  mdiCreditCardOff,
  mdiCreditCardOffOutline,
  mdiCreditCardOutline,
  mdiCreditCardPlus,
  mdiCreditCardPlusOutline,
  mdiCreditCardRefresh,
  mdiCreditCardRefreshOutline,
  mdiCreditCardRefund,
  mdiCreditCardRefundOutline,
  mdiCreditCardRemove,
  mdiCreditCardRemoveOutline,
  mdiCreditCardScan,
  mdiCreditCardScanOutline,
  mdiCreditCardSearch,
  mdiCreditCardSearchOutline,
  mdiCreditCardSettings,
  mdiCreditCardSettingsOutline,
  mdiCreditCardSync,
  mdiCreditCardSyncOutline,
  mdiCreditCardWireless,
  mdiCreditCardWirelessOff,
  mdiCreditCardWirelessOffOutline,
  mdiCreditCardWirelessOutline,
  mdiCricket,
  mdiCrop,
  mdiCropFree,
  mdiCropLandscape,
  mdiCropPortrait,
  mdiCropRotate,
  mdiCropSquare,
  mdiCross,
  mdiCrossBolnisi,
  mdiCrossCeltic,
  mdiCrossOutline,
  mdiCrosshairs,
  mdiCrosshairsGps,
  mdiCrosshairsOff,
  mdiCrosshairsQuestion,
  mdiCrowd,
  mdiCrown,
  mdiCrownCircle,
  mdiCrownCircleOutline,
  mdiCrownOutline,
  mdiCryengine,
  mdiCrystalBall,
  mdiCube,
  mdiCubeOff,
  mdiCubeOffOutline,
  mdiCubeOutline,
  mdiCubeScan,
  mdiCubeSend,
  mdiCubeUnfolded,
  mdiCup,
  mdiCupOff,
  mdiCupOffOutline,
  mdiCupOutline,
  mdiCupWater,
  mdiCupboard,
  mdiCupboardOutline,
  mdiCupcake,
  mdiCurling,
  mdiCurrencyBdt,
  mdiCurrencyBrl,
  mdiCurrencyBtc,
  mdiCurrencyCny,
  mdiCurrencyEth,
  mdiCurrencyEur,
  mdiCurrencyEurOff,
  mdiCurrencyFra,
  mdiCurrencyGbp,
  mdiCurrencyIls,
  mdiCurrencyInr,
  mdiCurrencyJpy,
  mdiCurrencyKrw,
  mdiCurrencyKzt,
  mdiCurrencyMnt,
  mdiCurrencyNgn,
  mdiCurrencyPhp,
  mdiCurrencyRial,
  mdiCurrencyRub,
  mdiCurrencyRupee,
  mdiCurrencySign,
  mdiCurrencyThb,
  mdiCurrencyTry,
  mdiCurrencyTwd,
  mdiCurrencyUah,
  mdiCurrencyUsd,
  mdiCurrencyUsdOff,
  mdiCurrentAc,
  mdiCurrentDc,
  mdiCursorDefault,
  mdiCursorDefaultClick,
  mdiCursorDefaultClickOutline,
  mdiCursorDefaultGesture,
  mdiCursorDefaultGestureOutline,
  mdiCursorDefaultOutline,
  mdiCursorMove,
  mdiCursorPointer,
  mdiCursorText,
  mdiCurtains,
  mdiCurtainsClosed,
  mdiCylinder,
  mdiCylinderOff,
  mdiDanceBallroom,
  mdiDancePole,
  mdiDataMatrix,
  mdiDataMatrixEdit,
  mdiDataMatrixMinus,
  mdiDataMatrixPlus,
  mdiDataMatrixRemove,
  mdiDataMatrixScan,
  mdiDatabase,
  mdiDatabaseAlert,
  mdiDatabaseAlertOutline,
  mdiDatabaseArrowDown,
  mdiDatabaseArrowDownOutline,
  mdiDatabaseArrowLeft,
  mdiDatabaseArrowLeftOutline,
  mdiDatabaseArrowRight,
  mdiDatabaseArrowRightOutline,
  mdiDatabaseArrowUp,
  mdiDatabaseArrowUpOutline,
  mdiDatabaseCheck,
  mdiDatabaseCheckOutline,
  mdiDatabaseClock,
  mdiDatabaseClockOutline,
  mdiDatabaseCog,
  mdiDatabaseCogOutline,
  mdiDatabaseEdit,
  mdiDatabaseEditOutline,
  mdiDatabaseExport,
  mdiDatabaseExportOutline,
  mdiDatabaseEye,
  mdiDatabaseEyeOff,
  mdiDatabaseEyeOffOutline,
  mdiDatabaseEyeOutline,
  mdiDatabaseImport,
  mdiDatabaseImportOutline,
  mdiDatabaseLock,
  mdiDatabaseLockOutline,
  mdiDatabaseMarker,
  mdiDatabaseMarkerOutline,
  mdiDatabaseMinus,
  mdiDatabaseMinusOutline,
  mdiDatabaseOff,
  mdiDatabaseOffOutline,
  mdiDatabaseOutline,
  mdiDatabasePlus,
  mdiDatabasePlusOutline,
  mdiDatabaseRefresh,
  mdiDatabaseRefreshOutline,
  mdiDatabaseRemove,
  mdiDatabaseRemoveOutline,
  mdiDatabaseSearch,
  mdiDatabaseSearchOutline,
  mdiDatabaseSettings,
  mdiDatabaseSettingsOutline,
  mdiDatabaseSync,
  mdiDatabaseSyncOutline,
  mdiDeathStar,
  mdiDeathStarVariant,
  mdiDeathlyHallows,
  mdiDebian,
  mdiDebugStepInto,
  mdiDebugStepOut,
  mdiDebugStepOver,
  mdiDecagram,
  mdiDecagramOutline,
  mdiDecimal,
  mdiDecimalComma,
  mdiDecimalCommaDecrease,
  mdiDecimalCommaIncrease,
  mdiDecimalDecrease,
  mdiDecimalIncrease,
  mdiDelete,
  mdiDeleteAlert,
  mdiDeleteAlertOutline,
  mdiDeleteCircle,
  mdiDeleteCircleOutline,
  mdiDeleteClock,
  mdiDeleteClockOutline,
  mdiDeleteEmpty,
  mdiDeleteEmptyOutline,
  mdiDeleteForever,
  mdiDeleteForeverOutline,
  mdiDeleteOff,
  mdiDeleteOffOutline,
  mdiDeleteOutline,
  mdiDeleteRestore,
  mdiDeleteSweep,
  mdiDeleteSweepOutline,
  mdiDeleteVariant,
  mdiDelta,
  mdiDesk,
  mdiDeskLamp,
  mdiDeskLampOff,
  mdiDeskLampOn,
  mdiDeskphone,
  mdiDesktopClassic,
  mdiDesktopTower,
  mdiDesktopTowerMonitor,
  mdiDetails,
  mdiDevTo,
  mdiDeveloperBoard,
  mdiDeviantart,
  mdiDevices,
  mdiDharmachakra,
  mdiDiabetes,
  mdiDialpad,
  mdiDiameter,
  mdiDiameterOutline,
  mdiDiameterVariant,
  mdiDiamond,
  mdiDiamondOutline,
  mdiDiamondStone,
  mdiDiaperOutline,
  mdiDice1,
  mdiDice1Outline,
  mdiDice2,
  mdiDice2Outline,
  mdiDice3,
  mdiDice3Outline,
  mdiDice4,
  mdiDice4Outline,
  mdiDice5,
  mdiDice5Outline,
  mdiDice6,
  mdiDice6Outline,
  mdiDiceD10,
  mdiDiceD10Outline,
  mdiDiceD12,
  mdiDiceD12Outline,
  mdiDiceD20,
  mdiDiceD20Outline,
  mdiDiceD4,
  mdiDiceD4Outline,
  mdiDiceD6,
  mdiDiceD6Outline,
  mdiDiceD8,
  mdiDiceD8Outline,
  mdiDiceMultiple,
  mdiDiceMultipleOutline,
  mdiDigitalOcean,
  mdiDipSwitch,
  mdiDirections,
  mdiDirectionsFork,
  mdiDisc,
  mdiDiscAlert,
  mdiDiscPlayer,
  mdiDishwasher,
  mdiDishwasherAlert,
  mdiDishwasherOff,
  mdiDisqus,
  mdiDistributeHorizontalCenter,
  mdiDistributeHorizontalLeft,
  mdiDistributeHorizontalRight,
  mdiDistributeVerticalBottom,
  mdiDistributeVerticalCenter,
  mdiDistributeVerticalTop,
  mdiDiversify,
  mdiDiving,
  mdiDivingFlippers,
  mdiDivingHelmet,
  mdiDivingScuba,
  mdiDivingScubaFlag,
  mdiDivingScubaMask,
  mdiDivingScubaTank,
  mdiDivingScubaTankMultiple,
  mdiDivingSnorkel,
  mdiDivision,
  mdiDivisionBox,
  mdiDlna,
  mdiDna,
  mdiDns,
  mdiDnsOutline,
  mdiDockBottom,
  mdiDockLeft,
  mdiDockRight,
  mdiDockTop,
  mdiDockWindow,
  mdiDocker,
  mdiDoctor,
  mdiDog,
  mdiDogService,
  mdiDogSide,
  mdiDogSideOff,
  mdiDolby,
  mdiDolly,
  mdiDolphin,
  mdiDomain,
  mdiDomainOff,
  mdiDomainPlus,
  mdiDomainRemove,
  mdiDomainSwitch,
  mdiDomeLight,
  mdiDominoMask,
  mdiDonkey,
  mdiDoor,
  mdiDoorClosed,
  mdiDoorClosedCancel,
  mdiDoorClosedLock,
  mdiDoorOpen,
  mdiDoorSliding,
  mdiDoorSlidingLock,
  mdiDoorSlidingOpen,
  mdiDoorbell,
  mdiDoorbellVideo,
  mdiDotNet,
  mdiDotsCircle,
  mdiDotsGrid,
  mdiDotsHexagon,
  mdiDotsHorizontal,
  mdiDotsHorizontalCircle,
  mdiDotsHorizontalCircleOutline,
  mdiDotsSquare,
  mdiDotsTriangle,
  mdiDotsVertical,
  mdiDotsVerticalCircle,
  mdiDotsVerticalCircleOutline,
  mdiDownload,
  mdiDownloadBox,
  mdiDownloadBoxOutline,
  mdiDownloadCircle,
  mdiDownloadCircleOutline,
  mdiDownloadLock,
  mdiDownloadLockOutline,
  mdiDownloadMultiple,
  mdiDownloadMultipleOutline,
  mdiDownloadNetwork,
  mdiDownloadNetworkOutline,
  mdiDownloadOff,
  mdiDownloadOffOutline,
  mdiDownloadOutline,
  mdiDrag,
  mdiDragHorizontal,
  mdiDragHorizontalVariant,
  mdiDragVariant,
  mdiDragVertical,
  mdiDragVerticalVariant,
  mdiDramaMasks,
  mdiDraw,
  mdiDrawPen,
  mdiDrawing,
  mdiDrawingBox,
  mdiDresser,
  mdiDresserOutline,
  mdiDrone,
  mdiDropbox,
  mdiDrupal,
  mdiDuck,
  mdiDumbbell,
  mdiDumpTruck,
  mdiEarHearing,
  mdiEarHearingLoop,
  mdiEarHearingOff,
  mdiEarbuds,
  mdiEarbudsOff,
  mdiEarbudsOffOutline,
  mdiEarbudsOutline,
  mdiEarth,
  mdiEarthArrowDown,
  mdiEarthArrowLeft,
  mdiEarthArrowRight,
  mdiEarthArrowUp,
  mdiEarthBox,
  mdiEarthBoxMinus,
  mdiEarthBoxOff,
  mdiEarthBoxPlus,
  mdiEarthBoxRemove,
  mdiEarthMinus,
  mdiEarthOff,
  mdiEarthPlus,
  mdiEarthRemove,
  mdiEgg,
  mdiEggEaster,
  mdiEggFried,
  mdiEggOff,
  mdiEggOffOutline,
  mdiEggOutline,
  mdiEiffelTower,
  mdiEightTrack,
  mdiEject,
  mdiEjectCircle,
  mdiEjectCircleOutline,
  mdiEjectOutline,
  mdiElectricSwitch,
  mdiElectricSwitchClosed,
  mdiElectronFramework,
  mdiElephant,
  mdiElevationDecline,
  mdiElevationRise,
  mdiElevator,
  mdiElevatorDown,
  mdiElevatorPassenger,
  mdiElevatorPassengerOff,
  mdiElevatorPassengerOffOutline,
  mdiElevatorPassengerOutline,
  mdiElevatorUp,
  mdiEllipse,
  mdiEllipseOutline,
  mdiEmail,
  mdiEmailAlert,
  mdiEmailAlertOutline,
  mdiEmailArrowLeft,
  mdiEmailArrowLeftOutline,
  mdiEmailArrowRight,
  mdiEmailArrowRightOutline,
  mdiEmailBox,
  mdiEmailCheck,
  mdiEmailCheckOutline,
  mdiEmailEdit,
  mdiEmailEditOutline,
  mdiEmailFast,
  mdiEmailFastOutline,
  mdiEmailHeartOutline,
  mdiEmailLock,
  mdiEmailLockOutline,
  mdiEmailMarkAsUnread,
  mdiEmailMinus,
  mdiEmailMinusOutline,
  mdiEmailMultiple,
  mdiEmailMultipleOutline,
  mdiEmailNewsletter,
  mdiEmailOff,
  mdiEmailOffOutline,
  mdiEmailOpen,
  mdiEmailOpenHeartOutline,
  mdiEmailOpenMultiple,
  mdiEmailOpenMultipleOutline,
  mdiEmailOpenOutline,
  mdiEmailOutline,
  mdiEmailPlus,
  mdiEmailPlusOutline,
  mdiEmailRemove,
  mdiEmailRemoveOutline,
  mdiEmailSeal,
  mdiEmailSealOutline,
  mdiEmailSearch,
  mdiEmailSearchOutline,
  mdiEmailSync,
  mdiEmailSyncOutline,
  mdiEmailVariant,
  mdiEmber,
  mdiEmby,
  mdiEmoticon,
  mdiEmoticonAngry,
  mdiEmoticonAngryOutline,
  mdiEmoticonConfused,
  mdiEmoticonConfusedOutline,
  mdiEmoticonCool,
  mdiEmoticonCoolOutline,
  mdiEmoticonCry,
  mdiEmoticonCryOutline,
  mdiEmoticonDead,
  mdiEmoticonDeadOutline,
  mdiEmoticonDevil,
  mdiEmoticonDevilOutline,
  mdiEmoticonExcited,
  mdiEmoticonExcitedOutline,
  mdiEmoticonFrown,
  mdiEmoticonFrownOutline,
  mdiEmoticonHappy,
  mdiEmoticonHappyOutline,
  mdiEmoticonKiss,
  mdiEmoticonKissOutline,
  mdiEmoticonLol,
  mdiEmoticonLolOutline,
  mdiEmoticonMinus,
  mdiEmoticonMinusOutline,
  mdiEmoticonNeutral,
  mdiEmoticonNeutralOutline,
  mdiEmoticonOutline,
  mdiEmoticonPlus,
  mdiEmoticonPlusOutline,
  mdiEmoticonPoop,
  mdiEmoticonPoopOutline,
  mdiEmoticonRemove,
  mdiEmoticonRemoveOutline,
  mdiEmoticonSad,
  mdiEmoticonSadOutline,
  mdiEmoticonSick,
  mdiEmoticonSickOutline,
  mdiEmoticonTongue,
  mdiEmoticonTongueOutline,
  mdiEmoticonWink,
  mdiEmoticonWinkOutline,
  mdiEngine,
  mdiEngineOff,
  mdiEngineOffOutline,
  mdiEngineOutline,
  mdiEpsilon,
  mdiEqual,
  mdiEqualBox,
  mdiEqualizer,
  mdiEqualizerOutline,
  mdiEraser,
  mdiEraserVariant,
  mdiEscalator,
  mdiEscalatorBox,
  mdiEscalatorDown,
  mdiEscalatorUp,
  mdiEslint,
  mdiEt,
  mdiEthereum,
  mdiEthernet,
  mdiEthernetCable,
  mdiEthernetCableOff,
  mdiEthernetOff,
  mdiEvPlugCcs1,
  mdiEvPlugCcs2,
  mdiEvPlugChademo,
  mdiEvPlugTesla,
  mdiEvPlugType1,
  mdiEvPlugType2,
  mdiEvStation,
  mdiEvernote,
  mdiExcavator,
  mdiExclamation,
  mdiExclamationThick,
  mdiExitRun,
  mdiExitToApp,
  mdiExpandAll,
  mdiExpandAllOutline,
  mdiExpansionCard,
  mdiExpansionCardVariant,
  mdiExponent,
  mdiExponentBox,
  mdiExport,
  mdiExportVariant,
  mdiEye,
  mdiEyeArrowLeft,
  mdiEyeArrowLeftOutline,
  mdiEyeArrowRight,
  mdiEyeArrowRightOutline,
  mdiEyeCheck,
  mdiEyeCheckOutline,
  mdiEyeCircle,
  mdiEyeCircleOutline,
  mdiEyeClosed,
  mdiEyeLock,
  mdiEyeLockOpen,
  mdiEyeLockOpenOutline,
  mdiEyeLockOutline,
  mdiEyeMinus,
  mdiEyeMinusOutline,
  mdiEyeOff,
  mdiEyeOffOutline,
  mdiEyeOutline,
  mdiEyePlus,
  mdiEyePlusOutline,
  mdiEyeRefresh,
  mdiEyeRefreshOutline,
  mdiEyeRemove,
  mdiEyeRemoveOutline,
  mdiEyeSettings,
  mdiEyeSettingsOutline,
  mdiEyedropper,
  mdiEyedropperMinus,
  mdiEyedropperOff,
  mdiEyedropperPlus,
  mdiEyedropperRemove,
  mdiEyedropperVariant,
  mdiFaceAgent,
  mdiFaceMan,
  mdiFaceManOutline,
  mdiFaceManProfile,
  mdiFaceManShimmer,
  mdiFaceManShimmerOutline,
  mdiFaceMask,
  mdiFaceMaskOutline,
  mdiFaceRecognition,
  mdiFaceWoman,
  mdiFaceWomanOutline,
  mdiFaceWomanProfile,
  mdiFaceWomanShimmer,
  mdiFaceWomanShimmerOutline,
  mdiFacebook,
  mdiFacebookGaming,
  mdiFacebookMessenger,
  mdiFacebookWorkplace,
  mdiFactory,
  mdiFamilyTree,
  mdiFan,
  mdiFanAlert,
  mdiFanAuto,
  mdiFanChevronDown,
  mdiFanChevronUp,
  mdiFanClock,
  mdiFanMinus,
  mdiFanOff,
  mdiFanPlus,
  mdiFanRemove,
  mdiFanSpeed1,
  mdiFanSpeed2,
  mdiFanSpeed3,
  mdiFastForward,
  mdiFastForward10,
  mdiFastForward15,
  mdiFastForward30,
  mdiFastForward45,
  mdiFastForward5,
  mdiFastForward60,
  mdiFastForwardOutline,
  mdiFaucet,
  mdiFaucetVariant,
  mdiFax,
  mdiFeather,
  mdiFeatureSearch,
  mdiFeatureSearchOutline,
  mdiFedora,
  mdiFence,
  mdiFenceElectric,
  mdiFencing,
  mdiFerrisWheel,
  mdiFerry,
  mdiFile,
  mdiFileAccount,
  mdiFileAccountOutline,
  mdiFileAlert,
  mdiFileAlertOutline,
  mdiFileArrowLeftRight,
  mdiFileArrowLeftRightOutline,
  mdiFileArrowUpDown,
  mdiFileArrowUpDownOutline,
  mdiFileCabinet,
  mdiFileCad,
  mdiFileCadBox,
  mdiFileCancel,
  mdiFileCancelOutline,
  mdiFileCertificate,
  mdiFileCertificateOutline,
  mdiFileChart,
  mdiFileChartCheck,
  mdiFileChartCheckOutline,
  mdiFileChartOutline,
  mdiFileCheck,
  mdiFileCheckOutline,
  mdiFileClock,
  mdiFileClockOutline,
  mdiFileCloud,
  mdiFileCloudOutline,
  mdiFileCode,
  mdiFileCodeOutline,
  mdiFileCog,
  mdiFileCogOutline,
  mdiFileCompare,
  mdiFileDelimited,
  mdiFileDelimitedOutline,
  mdiFileDocument,
  mdiFileDocumentAlert,
  mdiFileDocumentAlertOutline,
  mdiFileDocumentArrowRight,
  mdiFileDocumentArrowRightOutline,
  mdiFileDocumentCheck,
  mdiFileDocumentCheckOutline,
  mdiFileDocumentEdit,
  mdiFileDocumentEditOutline,
  mdiFileDocumentMinus,
  mdiFileDocumentMinusOutline,
  mdiFileDocumentMultiple,
  mdiFileDocumentMultipleOutline,
  mdiFileDocumentOutline,
  mdiFileDocumentPlus,
  mdiFileDocumentPlusOutline,
  mdiFileDocumentRefresh,
  mdiFileDocumentRefreshOutline,
  mdiFileDocumentRemove,
  mdiFileDocumentRemoveOutline,
  mdiFileDownload,
  mdiFileDownloadOutline,
  mdiFileEdit,
  mdiFileEditOutline,
  mdiFileExcel,
  mdiFileExcelBox,
  mdiFileExcelBoxOutline,
  mdiFileExcelOutline,
  mdiFileExport,
  mdiFileExportOutline,
  mdiFileEye,
  mdiFileEyeOutline,
  mdiFileFind,
  mdiFileFindOutline,
  mdiFileGifBox,
  mdiFileHidden,
  mdiFileImage,
  mdiFileImageMarker,
  mdiFileImageMarkerOutline,
  mdiFileImageMinus,
  mdiFileImageMinusOutline,
  mdiFileImageOutline,
  mdiFileImagePlus,
  mdiFileImagePlusOutline,
  mdiFileImageRemove,
  mdiFileImageRemoveOutline,
  mdiFileImport,
  mdiFileImportOutline,
  mdiFileJpgBox,
  mdiFileKey,
  mdiFileKeyOutline,
  mdiFileLink,
  mdiFileLinkOutline,
  mdiFileLock,
  mdiFileLockOpen,
  mdiFileLockOpenOutline,
  mdiFileLockOutline,
  mdiFileMarker,
  mdiFileMarkerOutline,
  mdiFileMinus,
  mdiFileMinusOutline,
  mdiFileMove,
  mdiFileMoveOutline,
  mdiFileMultiple,
  mdiFileMultipleOutline,
  mdiFileMusic,
  mdiFileMusicOutline,
  mdiFileOutline,
  mdiFilePdfBox,
  mdiFilePercent,
  mdiFilePercentOutline,
  mdiFilePhone,
  mdiFilePhoneOutline,
  mdiFilePlus,
  mdiFilePlusOutline,
  mdiFilePngBox,
  mdiFilePowerpoint,
  mdiFilePowerpointBox,
  mdiFilePowerpointBoxOutline,
  mdiFilePowerpointOutline,
  mdiFilePresentationBox,
  mdiFileQuestion,
  mdiFileQuestionOutline,
  mdiFileRefresh,
  mdiFileRefreshOutline,
  mdiFileRemove,
  mdiFileRemoveOutline,
  mdiFileReplace,
  mdiFileReplaceOutline,
  mdiFileRestore,
  mdiFileRestoreOutline,
  mdiFileRotateLeft,
  mdiFileRotateLeftOutline,
  mdiFileRotateRight,
  mdiFileRotateRightOutline,
  mdiFileSearch,
  mdiFileSearchOutline,
  mdiFileSend,
  mdiFileSendOutline,
  mdiFileSettings,
  mdiFileSettingsOutline,
  mdiFileSign,
  mdiFileStar,
  mdiFileStarFourPoints,
  mdiFileStarFourPointsOutline,
  mdiFileStarOutline,
  mdiFileSwap,
  mdiFileSwapOutline,
  mdiFileSync,
  mdiFileSyncOutline,
  mdiFileTable,
  mdiFileTableBox,
  mdiFileTableBoxMultiple,
  mdiFileTableBoxMultipleOutline,
  mdiFileTableBoxOutline,
  mdiFileTableOutline,
  mdiFileTree,
  mdiFileTreeOutline,
  mdiFileUndo,
  mdiFileUndoOutline,
  mdiFileUpload,
  mdiFileUploadOutline,
  mdiFileVideo,
  mdiFileVideoOutline,
  mdiFileWord,
  mdiFileWordBox,
  mdiFileWordBoxOutline,
  mdiFileWordOutline,
  mdiFileXmlBox,
  mdiFilm,
  mdiFilmstrip,
  mdiFilmstripBox,
  mdiFilmstripBoxMultiple,
  mdiFilmstripOff,
  mdiFilter,
  mdiFilterCheck,
  mdiFilterCheckOutline,
  mdiFilterCog,
  mdiFilterCogOutline,
  mdiFilterMenu,
  mdiFilterMenuOutline,
  mdiFilterMinus,
  mdiFilterMinusOutline,
  mdiFilterMultiple,
  mdiFilterMultipleOutline,
  mdiFilterOff,
  mdiFilterOffOutline,
  mdiFilterOutline,
  mdiFilterPlus,
  mdiFilterPlusOutline,
  mdiFilterRemove,
  mdiFilterRemoveOutline,
  mdiFilterSettings,
  mdiFilterSettingsOutline,
  mdiFilterVariant,
  mdiFilterVariantMinus,
  mdiFilterVariantPlus,
  mdiFilterVariantRemove,
  mdiFinance,
  mdiFindReplace,
  mdiFingerprint,
  mdiFingerprintOff,
  mdiFire,
  mdiFireAlert,
  mdiFireCircle,
  mdiFireExtinguisher,
  mdiFireHydrant,
  mdiFireHydrantAlert,
  mdiFireHydrantOff,
  mdiFireOff,
  mdiFireStation,
  mdiFireTruck,
  mdiFirebase,
  mdiFirefox,
  mdiFireplace,
  mdiFireplaceOff,
  mdiFirewire,
  mdiFirework,
  mdiFireworkOff,
  mdiFish,
  mdiFishOff,
  mdiFishbowl,
  mdiFishbowlOutline,
  mdiFitToPage,
  mdiFitToPageOutline,
  mdiFitToScreen,
  mdiFitToScreenOutline,
  mdiFlag,
  mdiFlagCheckered,
  mdiFlagMinus,
  mdiFlagMinusOutline,
  mdiFlagOff,
  mdiFlagOffOutline,
  mdiFlagOutline,
  mdiFlagPlus,
  mdiFlagPlusOutline,
  mdiFlagRemove,
  mdiFlagRemoveOutline,
  mdiFlagTriangle,
  mdiFlagVariant,
  mdiFlagVariantMinus,
  mdiFlagVariantMinusOutline,
  mdiFlagVariantOff,
  mdiFlagVariantOffOutline,
  mdiFlagVariantOutline,
  mdiFlagVariantPlus,
  mdiFlagVariantPlusOutline,
  mdiFlagVariantRemove,
  mdiFlagVariantRemoveOutline,
  mdiFlare,
  mdiFlash,
  mdiFlashAlert,
  mdiFlashAlertOutline,
  mdiFlashAuto,
  mdiFlashOff,
  mdiFlashOffOutline,
  mdiFlashOutline,
  mdiFlashRedEye,
  mdiFlashTriangle,
  mdiFlashTriangleOutline,
  mdiFlashlight,
  mdiFlashlightOff,
  mdiFlask,
  mdiFlaskEmpty,
  mdiFlaskEmptyMinus,
  mdiFlaskEmptyMinusOutline,
  mdiFlaskEmptyOff,
  mdiFlaskEmptyOffOutline,
  mdiFlaskEmptyOutline,
  mdiFlaskEmptyPlus,
  mdiFlaskEmptyPlusOutline,
  mdiFlaskEmptyRemove,
  mdiFlaskEmptyRemoveOutline,
  mdiFlaskMinus,
  mdiFlaskMinusOutline,
  mdiFlaskOff,
  mdiFlaskOffOutline,
  mdiFlaskOutline,
  mdiFlaskPlus,
  mdiFlaskPlusOutline,
  mdiFlaskRemove,
  mdiFlaskRemoveOutline,
  mdiFlaskRoundBottom,
  mdiFlaskRoundBottomEmpty,
  mdiFlaskRoundBottomEmptyOutline,
  mdiFlaskRoundBottomOutline,
  mdiFleurDeLis,
  mdiFlipHorizontal,
  mdiFlipToBack,
  mdiFlipToFront,
  mdiFlipVertical,
  mdiFloorLamp,
  mdiFloorLampDual,
  mdiFloorLampDualOutline,
  mdiFloorLampOutline,
  mdiFloorLampTorchiere,
  mdiFloorLampTorchiereOutline,
  mdiFloorLampTorchiereVariant,
  mdiFloorLampTorchiereVariantOutline,
  mdiFloorPlan,
  mdiFloppy,
  mdiFloppyVariant,
  mdiFlower,
  mdiFlowerOutline,
  mdiFlowerPollen,
  mdiFlowerPollenOutline,
  mdiFlowerPoppy,
  mdiFlowerTulip,
  mdiFlowerTulipOutline,
  mdiFocusAuto,
  mdiFocusField,
  mdiFocusFieldHorizontal,
  mdiFocusFieldVertical,
  mdiFolder,
  mdiFolderAccount,
  mdiFolderAccountOutline,
  mdiFolderAlert,
  mdiFolderAlertOutline,
  mdiFolderArrowDown,
  mdiFolderArrowDownOutline,
  mdiFolderArrowLeft,
  mdiFolderArrowLeftOutline,
  mdiFolderArrowLeftRight,
  mdiFolderArrowLeftRightOutline,
  mdiFolderArrowRight,
  mdiFolderArrowRightOutline,
  mdiFolderArrowUp,
  mdiFolderArrowUpDown,
  mdiFolderArrowUpDownOutline,
  mdiFolderArrowUpOutline,
  mdiFolderCancel,
  mdiFolderCancelOutline,
  mdiFolderCheck,
  mdiFolderCheckOutline,
  mdiFolderClock,
  mdiFolderClockOutline,
  mdiFolderCog,
  mdiFolderCogOutline,
  mdiFolderDownload,
  mdiFolderDownloadOutline,
  mdiFolderEdit,
  mdiFolderEditOutline,
  mdiFolderEye,
  mdiFolderEyeOutline,
  mdiFolderFile,
  mdiFolderFileOutline,
  mdiFolderGoogleDrive,
  mdiFolderHeart,
  mdiFolderHeartOutline,
  mdiFolderHidden,
  mdiFolderHome,
  mdiFolderHomeOutline,
  mdiFolderImage,
  mdiFolderInformation,
  mdiFolderInformationOutline,
  mdiFolderKey,
  mdiFolderKeyNetwork,
  mdiFolderKeyNetworkOutline,
  mdiFolderKeyOutline,
  mdiFolderLock,
  mdiFolderLockOpen,
  mdiFolderLockOpenOutline,
  mdiFolderLockOutline,
  mdiFolderMarker,
  mdiFolderMarkerOutline,
  mdiFolderMinus,
  mdiFolderMinusOutline,
  mdiFolderMove,
  mdiFolderMoveOutline,
  mdiFolderMultiple,
  mdiFolderMultipleImage,
  mdiFolderMultipleOutline,
  mdiFolderMultiplePlus,
  mdiFolderMultiplePlusOutline,
  mdiFolderMusic,
  mdiFolderMusicOutline,
  mdiFolderNetwork,
  mdiFolderNetworkOutline,
  mdiFolderOff,
  mdiFolderOffOutline,
  mdiFolderOpen,
  mdiFolderOpenOutline,
  mdiFolderOutline,
  mdiFolderPlay,
  mdiFolderPlayOutline,
  mdiFolderPlus,
  mdiFolderPlusOutline,
  mdiFolderPound,
  mdiFolderPoundOutline,
  mdiFolderQuestion,
  mdiFolderQuestionOutline,
  mdiFolderRefresh,
  mdiFolderRefreshOutline,
  mdiFolderRemove,
  mdiFolderRemoveOutline,
  mdiFolderSearch,
  mdiFolderSearchOutline,
  mdiFolderSettings,
  mdiFolderSettingsOutline,
  mdiFolderStar,
  mdiFolderStarMultiple,
  mdiFolderStarMultipleOutline,
  mdiFolderStarOutline,
  mdiFolderSwap,
  mdiFolderSwapOutline,
  mdiFolderSync,
  mdiFolderSyncOutline,
  mdiFolderTable,
  mdiFolderTableOutline,
  mdiFolderText,
  mdiFolderTextOutline,
  mdiFolderUpload,
  mdiFolderUploadOutline,
  mdiFolderWrench,
  mdiFolderWrenchOutline,
  mdiFolderZip,
  mdiFolderZipOutline,
  mdiFontAwesome,
  mdiFood,
  mdiFoodApple,
  mdiFoodAppleOutline,
  mdiFoodCroissant,
  mdiFoodDrumstick,
  mdiFoodDrumstickOff,
  mdiFoodDrumstickOffOutline,
  mdiFoodDrumstickOutline,
  mdiFoodForkDrink,
  mdiFoodHalal,
  mdiFoodHotDog,
  mdiFoodKosher,
  mdiFoodOff,
  mdiFoodOffOutline,
  mdiFoodOutline,
  mdiFoodSteak,
  mdiFoodSteakOff,
  mdiFoodTakeoutBox,
  mdiFoodTakeoutBoxOutline,
  mdiFoodTurkey,
  mdiFoodVariant,
  mdiFoodVariantOff,
  mdiFootPrint,
  mdiFootball,
  mdiFootballAustralian,
  mdiFootballHelmet,
  mdiForest,
  mdiForestOutline,
  mdiForklift,
  mdiFormDropdown,
  mdiFormSelect,
  mdiFormTextarea,
  mdiFormTextbox,
  mdiFormTextboxLock,
  mdiFormTextboxPassword,
  mdiFormatAlignBottom,
  mdiFormatAlignCenter,
  mdiFormatAlignJustify,
  mdiFormatAlignLeft,
  mdiFormatAlignMiddle,
  mdiFormatAlignRight,
  mdiFormatAlignTop,
  mdiFormatAnnotationMinus,
  mdiFormatAnnotationPlus,
  mdiFormatBold,
  mdiFormatClear,
  mdiFormatColorFill,
  mdiFormatColorHighlight,
  mdiFormatColorMarkerCancel,
  mdiFormatColorText,
  mdiFormatColumns,
  mdiFormatFloatCenter,
  mdiFormatFloatLeft,
  mdiFormatFloatNone,
  mdiFormatFloatRight,
  mdiFormatFont,
  mdiFormatFontSizeDecrease,
  mdiFormatFontSizeIncrease,
  mdiFormatHeader1,
  mdiFormatHeader2,
  mdiFormatHeader3,
  mdiFormatHeader4,
  mdiFormatHeader5,
  mdiFormatHeader6,
  mdiFormatHeaderDecrease,
  mdiFormatHeaderEqual,
  mdiFormatHeaderIncrease,
  mdiFormatHeaderPound,
  mdiFormatHorizontalAlignCenter,
  mdiFormatHorizontalAlignLeft,
  mdiFormatHorizontalAlignRight,
  mdiFormatIndentDecrease,
  mdiFormatIndentIncrease,
  mdiFormatItalic,
  mdiFormatLetterCase,
  mdiFormatLetterCaseLower,
  mdiFormatLetterCaseUpper,
  mdiFormatLetterEndsWith,
  mdiFormatLetterMatches,
  mdiFormatLetterSpacing,
  mdiFormatLetterSpacingVariant,
  mdiFormatLetterStartsWith,
  mdiFormatLineHeight,
  mdiFormatLineSpacing,
  mdiFormatLineStyle,
  mdiFormatLineWeight,
  mdiFormatListBulleted,
  mdiFormatListBulletedSquare,
  mdiFormatListBulletedTriangle,
  mdiFormatListBulletedType,
  mdiFormatListCheckbox,
  mdiFormatListChecks,
  mdiFormatListGroup,
  mdiFormatListGroupPlus,
  mdiFormatListNumbered,
  mdiFormatListNumberedRtl,
  mdiFormatListText,
  mdiFormatOverline,
  mdiFormatPageBreak,
  mdiFormatPageSplit,
  mdiFormatPaint,
  mdiFormatParagraph,
  mdiFormatParagraphSpacing,
  mdiFormatPilcrow,
  mdiFormatPilcrowArrowLeft,
  mdiFormatPilcrowArrowRight,
  mdiFormatQuoteClose,
  mdiFormatQuoteCloseOutline,
  mdiFormatQuoteOpen,
  mdiFormatQuoteOpenOutline,
  mdiFormatRotate90,
  mdiFormatSection,
  mdiFormatSize,
  mdiFormatStrikethrough,
  mdiFormatStrikethroughVariant,
  mdiFormatSubscript,
  mdiFormatSuperscript,
  mdiFormatText,
  mdiFormatTextRotationAngleDown,
  mdiFormatTextRotationAngleUp,
  mdiFormatTextRotationDown,
  mdiFormatTextRotationDownVertical,
  mdiFormatTextRotationNone,
  mdiFormatTextRotationUp,
  mdiFormatTextRotationVertical,
  mdiFormatTextVariant,
  mdiFormatTextVariantOutline,
  mdiFormatTextWrappingClip,
  mdiFormatTextWrappingOverflow,
  mdiFormatTextWrappingWrap,
  mdiFormatTextbox,
  mdiFormatTitle,
  mdiFormatUnderline,
  mdiFormatUnderlineWavy,
  mdiFormatVerticalAlignBottom,
  mdiFormatVerticalAlignCenter,
  mdiFormatVerticalAlignTop,
  mdiFormatWrapInline,
  mdiFormatWrapSquare,
  mdiFormatWrapTight,
  mdiFormatWrapTopBottom,
  mdiForum,
  mdiForumMinus,
  mdiForumMinusOutline,
  mdiForumOutline,
  mdiForumPlus,
  mdiForumPlusOutline,
  mdiForumRemove,
  mdiForumRemoveOutline,
  mdiForward,
  mdiForwardburger,
  mdiFountain,
  mdiFountainPen,
  mdiFountainPenTip,
  mdiFractionOneHalf,
  mdiFreebsd,
  mdiFrenchFries,
  mdiFrequentlyAskedQuestions,
  mdiFridge,
  mdiFridgeAlert,
  mdiFridgeAlertOutline,
  mdiFridgeBottom,
  mdiFridgeIndustrial,
  mdiFridgeIndustrialAlert,
  mdiFridgeIndustrialAlertOutline,
  mdiFridgeIndustrialOff,
  mdiFridgeIndustrialOffOutline,
  mdiFridgeIndustrialOutline,
  mdiFridgeOff,
  mdiFridgeOffOutline,
  mdiFridgeOutline,
  mdiFridgeTop,
  mdiFridgeVariant,
  mdiFridgeVariantAlert,
  mdiFridgeVariantAlertOutline,
  mdiFridgeVariantOff,
  mdiFridgeVariantOffOutline,
  mdiFridgeVariantOutline,
  mdiFruitCherries,
  mdiFruitCherriesOff,
  mdiFruitCitrus,
  mdiFruitCitrusOff,
  mdiFruitGrapes,
  mdiFruitGrapesOutline,
  mdiFruitPear,
  mdiFruitPineapple,
  mdiFruitWatermelon,
  mdiFuel,
  mdiFuelCell,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiFunction,
  mdiFunctionVariant,
  mdiFuriganaHorizontal,
  mdiFuriganaVertical,
  mdiFuse,
  mdiFuseAlert,
  mdiFuseBlade,
  mdiFuseOff,
  mdiGamepad,
  mdiGamepadCircle,
  mdiGamepadCircleDown,
  mdiGamepadCircleLeft,
  mdiGamepadCircleOutline,
  mdiGamepadCircleRight,
  mdiGamepadCircleUp,
  mdiGamepadDown,
  mdiGamepadLeft,
  mdiGamepadOutline,
  mdiGamepadRight,
  mdiGamepadRound,
  mdiGamepadRoundDown,
  mdiGamepadRoundLeft,
  mdiGamepadRoundOutline,
  mdiGamepadRoundRight,
  mdiGamepadRoundUp,
  mdiGamepadSquare,
  mdiGamepadSquareOutline,
  mdiGamepadUp,
  mdiGamepadVariant,
  mdiGamepadVariantOutline,
  mdiGamma,
  mdiGantryCrane,
  mdiGarage,
  mdiGarageAlert,
  mdiGarageAlertVariant,
  mdiGarageLock,
  mdiGarageOpen,
  mdiGarageOpenVariant,
  mdiGarageVariant,
  mdiGarageVariantLock,
  mdiGasBurner,
  mdiGasCylinder,
  mdiGasStation,
  mdiGasStationInUse,
  mdiGasStationInUseOutline,
  mdiGasStationOff,
  mdiGasStationOffOutline,
  mdiGasStationOutline,
  mdiGate,
  mdiGateAlert,
  mdiGateAnd,
  mdiGateArrowLeft,
  mdiGateArrowRight,
  mdiGateBuffer,
  mdiGateNand,
  mdiGateNor,
  mdiGateNot,
  mdiGateOpen,
  mdiGateOr,
  mdiGateXnor,
  mdiGateXor,
  mdiGatsby,
  mdiGauge,
  mdiGaugeEmpty,
  mdiGaugeFull,
  mdiGaugeLow,
  mdiGavel,
  mdiGenderFemale,
  mdiGenderMale,
  mdiGenderMaleFemale,
  mdiGenderMaleFemaleVariant,
  mdiGenderNonBinary,
  mdiGenderTransgender,
  mdiGeneratorMobile,
  mdiGeneratorPortable,
  mdiGeneratorStationary,
  mdiGentoo,
  mdiGesture,
  mdiGestureDoubleTap,
  mdiGesturePinch,
  mdiGestureSpread,
  mdiGestureSwipe,
  mdiGestureSwipeDown,
  mdiGestureSwipeHorizontal,
  mdiGestureSwipeLeft,
  mdiGestureSwipeRight,
  mdiGestureSwipeUp,
  mdiGestureSwipeVertical,
  mdiGestureTap,
  mdiGestureTapBox,
  mdiGestureTapButton,
  mdiGestureTapHold,
  mdiGestureTwoDoubleTap,
  mdiGestureTwoTap,
  mdiGhost,
  mdiGhostOff,
  mdiGhostOffOutline,
  mdiGhostOutline,
  mdiGift,
  mdiGiftOff,
  mdiGiftOffOutline,
  mdiGiftOpen,
  mdiGiftOpenOutline,
  mdiGiftOutline,
  mdiGit,
  mdiGithub,
  mdiGitlab,
  mdiGlassCocktail,
  mdiGlassCocktailOff,
  mdiGlassFlute,
  mdiGlassFragile,
  mdiGlassMug,
  mdiGlassMugOff,
  mdiGlassMugVariant,
  mdiGlassMugVariantOff,
  mdiGlassPintOutline,
  mdiGlassStange,
  mdiGlassTulip,
  mdiGlassWine,
  mdiGlasses,
  mdiGlobeLight,
  mdiGlobeLightOutline,
  mdiGlobeModel,
  mdiGmail,
  mdiGnome,
  mdiGoKart,
  mdiGoKartTrack,
  mdiGog,
  mdiGold,
  mdiGolf,
  mdiGolfCart,
  mdiGolfTee,
  mdiGondola,
  mdiGoodreads,
  mdiGoogle,
  mdiGoogleAds,
  mdiGoogleAnalytics,
  mdiGoogleAssistant,
  mdiGoogleCardboard,
  mdiGoogleChrome,
  mdiGoogleCircles,
  mdiGoogleCirclesCommunities,
  mdiGoogleCirclesExtended,
  mdiGoogleCirclesGroup,
  mdiGoogleClassroom,
  mdiGoogleCloud,
  mdiGoogleDownasaur,
  mdiGoogleDrive,
  mdiGoogleEarth,
  mdiGoogleFit,
  mdiGoogleGlass,
  mdiGoogleHangouts,
  mdiGoogleKeep,
  mdiGoogleLens,
  mdiGoogleMaps,
  mdiGoogleMyBusiness,
  mdiGoogleNearby,
  mdiGooglePlay,
  mdiGooglePlus,
  mdiGooglePodcast,
  mdiGoogleSpreadsheet,
  mdiGoogleStreetView,
  mdiGoogleTranslate,
  mdiGradientHorizontal,
  mdiGradientVertical,
  mdiGrain,
  mdiGraph,
  mdiGraphOutline,
  mdiGraphql,
  mdiGrass,
  mdiGraveStone,
  mdiGreasePencil,
  mdiGreaterThan,
  mdiGreaterThanOrEqual,
  mdiGreenhouse,
  mdiGrid,
  mdiGridLarge,
  mdiGridOff,
  mdiGrill,
  mdiGrillOutline,
  mdiGroup,
  mdiGuitarAcoustic,
  mdiGuitarElectric,
  mdiGuitarPick,
  mdiGuitarPickOutline,
  mdiGuyFawkesMask,
  mdiGymnastics,
  mdiHail,
  mdiHairDryer,
  mdiHairDryerOutline,
  mdiHalloween,
  mdiHamburger,
  mdiHamburgerCheck,
  mdiHamburgerMinus,
  mdiHamburgerOff,
  mdiHamburgerPlus,
  mdiHamburgerRemove,
  mdiHammer,
  mdiHammerScrewdriver,
  mdiHammerSickle,
  mdiHammerWrench,
  mdiHandBackLeft,
  mdiHandBackLeftOff,
  mdiHandBackLeftOffOutline,
  mdiHandBackLeftOutline,
  mdiHandBackRight,
  mdiHandBackRightOff,
  mdiHandBackRightOffOutline,
  mdiHandBackRightOutline,
  mdiHandClap,
  mdiHandClapOff,
  mdiHandCoin,
  mdiHandCoinOutline,
  mdiHandCycle,
  mdiHandExtended,
  mdiHandExtendedOutline,
  mdiHandFrontLeft,
  mdiHandFrontLeftOutline,
  mdiHandFrontRight,
  mdiHandFrontRightOutline,
  mdiHandHeart,
  mdiHandHeartOutline,
  mdiHandOkay,
  mdiHandPeace,
  mdiHandPeaceVariant,
  mdiHandPointingDown,
  mdiHandPointingLeft,
  mdiHandPointingRight,
  mdiHandPointingUp,
  mdiHandSaw,
  mdiHandWash,
  mdiHandWashOutline,
  mdiHandWater,
  mdiHandWave,
  mdiHandWaveOutline,
  mdiHandball,
  mdiHandcuffs,
  mdiHandsPray,
  mdiHandshake,
  mdiHandshakeOutline,
  mdiHanger,
  mdiHardHat,
  mdiHarddisk,
  mdiHarddiskPlus,
  mdiHarddiskRemove,
  mdiHatFedora,
  mdiHazardLights,
  mdiHdmiPort,
  mdiHdr,
  mdiHdrOff,
  mdiHead,
  mdiHeadAlert,
  mdiHeadAlertOutline,
  mdiHeadCheck,
  mdiHeadCheckOutline,
  mdiHeadCog,
  mdiHeadCogOutline,
  mdiHeadDotsHorizontal,
  mdiHeadDotsHorizontalOutline,
  mdiHeadFlash,
  mdiHeadFlashOutline,
  mdiHeadHeart,
  mdiHeadHeartOutline,
  mdiHeadLightbulb,
  mdiHeadLightbulbOutline,
  mdiHeadMinus,
  mdiHeadMinusOutline,
  mdiHeadOutline,
  mdiHeadPlus,
  mdiHeadPlusOutline,
  mdiHeadQuestion,
  mdiHeadQuestionOutline,
  mdiHeadRemove,
  mdiHeadRemoveOutline,
  mdiHeadSnowflake,
  mdiHeadSnowflakeOutline,
  mdiHeadSync,
  mdiHeadSyncOutline,
  mdiHeadphones,
  mdiHeadphonesBluetooth,
  mdiHeadphonesBox,
  mdiHeadphonesOff,
  mdiHeadphonesSettings,
  mdiHeadset,
  mdiHeadsetDock,
  mdiHeadsetOff,
  mdiHeart,
  mdiHeartBox,
  mdiHeartBoxOutline,
  mdiHeartBroken,
  mdiHeartBrokenOutline,
  mdiHeartCircle,
  mdiHeartCircleOutline,
  mdiHeartCog,
  mdiHeartCogOutline,
  mdiHeartFlash,
  mdiHeartHalf,
  mdiHeartHalfFull,
  mdiHeartHalfOutline,
  mdiHeartMinus,
  mdiHeartMinusOutline,
  mdiHeartMultiple,
  mdiHeartMultipleOutline,
  mdiHeartOff,
  mdiHeartOffOutline,
  mdiHeartOutline,
  mdiHeartPlus,
  mdiHeartPlusOutline,
  mdiHeartPulse,
  mdiHeartRemove,
  mdiHeartRemoveOutline,
  mdiHeartSearch,
  mdiHeartSettings,
  mdiHeartSettingsOutline,
  mdiHeatPump,
  mdiHeatPumpOutline,
  mdiHeatWave,
  mdiHeatingCoil,
  mdiHelicopter,
  mdiHelp,
  mdiHelpBox,
  mdiHelpBoxMultiple,
  mdiHelpBoxMultipleOutline,
  mdiHelpBoxOutline,
  mdiHelpCircle,
  mdiHelpCircleOutline,
  mdiHelpNetwork,
  mdiHelpNetworkOutline,
  mdiHelpRhombus,
  mdiHelpRhombusOutline,
  mdiHexadecimal,
  mdiHexagon,
  mdiHexagonMultiple,
  mdiHexagonMultipleOutline,
  mdiHexagonOutline,
  mdiHexagonSlice1,
  mdiHexagonSlice2,
  mdiHexagonSlice3,
  mdiHexagonSlice4,
  mdiHexagonSlice5,
  mdiHexagonSlice6,
  mdiHexagram,
  mdiHexagramOutline,
  mdiHighDefinition,
  mdiHighDefinitionBox,
  mdiHighway,
  mdiHiking,
  mdiHistory,
  mdiHockeyPuck,
  mdiHockeySticks,
  mdiHololens,
  mdiHome,
  mdiHomeAccount,
  mdiHomeAlert,
  mdiHomeAlertOutline,
  mdiHomeAnalytics,
  mdiHomeAssistant,
  mdiHomeAutomation,
  mdiHomeBattery,
  mdiHomeBatteryOutline,
  mdiHomeCircle,
  mdiHomeCircleOutline,
  mdiHomeCity,
  mdiHomeCityOutline,
  mdiHomeClock,
  mdiHomeClockOutline,
  mdiHomeEdit,
  mdiHomeEditOutline,
  mdiHomeExportOutline,
  mdiHomeFlood,
  mdiHomeFloor0,
  mdiHomeFloor1,
  mdiHomeFloor2,
  mdiHomeFloor3,
  mdiHomeFloorA,
  mdiHomeFloorB,
  mdiHomeFloorG,
  mdiHomeFloorL,
  mdiHomeFloorNegative1,
  mdiHomeGroup,
  mdiHomeGroupMinus,
  mdiHomeGroupPlus,
  mdiHomeGroupRemove,
  mdiHomeHeart,
  mdiHomeImportOutline,
  mdiHomeLightbulb,
  mdiHomeLightbulbOutline,
  mdiHomeLightningBolt,
  mdiHomeLightningBoltOutline,
  mdiHomeLock,
  mdiHomeLockOpen,
  mdiHomeMapMarker,
  mdiHomeMinus,
  mdiHomeMinusOutline,
  mdiHomeModern,
  mdiHomeOff,
  mdiHomeOffOutline,
  mdiHomeOutline,
  mdiHomePercent,
  mdiHomePercentOutline,
  mdiHomePlus,
  mdiHomePlusOutline,
  mdiHomeRemove,
  mdiHomeRemoveOutline,
  mdiHomeRoof,
  mdiHomeSearch,
  mdiHomeSearchOutline,
  mdiHomeSilo,
  mdiHomeSiloOutline,
  mdiHomeSoundIn,
  mdiHomeSoundInOutline,
  mdiHomeSoundOut,
  mdiHomeSoundOutOutline,
  mdiHomeSwitch,
  mdiHomeSwitchOutline,
  mdiHomeThermometer,
  mdiHomeThermometerOutline,
  mdiHomeVariant,
  mdiHomeVariantOutline,
  mdiHook,
  mdiHookOff,
  mdiHoopHouse,
  mdiHops,
  mdiHorizontalRotateClockwise,
  mdiHorizontalRotateCounterclockwise,
  mdiHorse,
  mdiHorseHuman,
  mdiHorseVariant,
  mdiHorseVariantFast,
  mdiHorseshoe,
  mdiHospital,
  mdiHospitalBox,
  mdiHospitalBoxOutline,
  mdiHospitalBuilding,
  mdiHospitalMarker,
  mdiHotTub,
  mdiHours12,
  mdiHours24,
  mdiHub,
  mdiHubOutline,
  mdiHubspot,
  mdiHulu,
  mdiHuman,
  mdiHumanBabyChangingTable,
  mdiHumanCane,
  mdiHumanCapacityDecrease,
  mdiHumanCapacityIncrease,
  mdiHumanChild,
  mdiHumanDolly,
  mdiHumanEdit,
  mdiHumanFemale,
  mdiHumanFemaleBoy,
  mdiHumanFemaleDance,
  mdiHumanFemaleFemale,
  mdiHumanFemaleFemaleChild,
  mdiHumanFemaleGirl,
  mdiHumanGreeting,
  mdiHumanGreetingProximity,
  mdiHumanGreetingVariant,
  mdiHumanHandsdown,
  mdiHumanHandsup,
  mdiHumanMale,
  mdiHumanMaleBoard,
  mdiHumanMaleBoardPoll,
  mdiHumanMaleBoy,
  mdiHumanMaleChild,
  mdiHumanMaleFemale,
  mdiHumanMaleFemaleChild,
  mdiHumanMaleGirl,
  mdiHumanMaleHeight,
  mdiHumanMaleHeightVariant,
  mdiHumanMaleMale,
  mdiHumanMaleMaleChild,
  mdiHumanNonBinary,
  mdiHumanPregnant,
  mdiHumanQueue,
  mdiHumanScooter,
  mdiHumanWalker,
  mdiHumanWheelchair,
  mdiHumanWhiteCane,
  mdiHumbleBundle,
  mdiHvac,
  mdiHvacOff,
  mdiHydraulicOilLevel,
  mdiHydraulicOilTemperature,
  mdiHydroPower,
  mdiHydrogenStation,
  mdiIceCream,
  mdiIceCreamOff,
  mdiIcePop,
  mdiIdCard,
  mdiIdentifier,
  mdiIdeogramCjk,
  mdiIdeogramCjkVariant,
  mdiImage,
  mdiImageAlbum,
  mdiImageArea,
  mdiImageAreaClose,
  mdiImageAutoAdjust,
  mdiImageBroken,
  mdiImageBrokenVariant,
  mdiImageCheck,
  mdiImageCheckOutline,
  mdiImageEdit,
  mdiImageEditOutline,
  mdiImageFilterBlackWhite,
  mdiImageFilterCenterFocus,
  mdiImageFilterCenterFocusStrong,
  mdiImageFilterCenterFocusStrongOutline,
  mdiImageFilterCenterFocusWeak,
  mdiImageFilterDrama,
  mdiImageFilterDramaOutline,
  mdiImageFilterFrames,
  mdiImageFilterHdr,
  mdiImageFilterHdrOutline,
  mdiImageFilterNone,
  mdiImageFilterTiltShift,
  mdiImageFilterVintage,
  mdiImageFrame,
  mdiImageLock,
  mdiImageLockOutline,
  mdiImageMarker,
  mdiImageMarkerOutline,
  mdiImageMinus,
  mdiImageMinusOutline,
  mdiImageMove,
  mdiImageMultiple,
  mdiImageMultipleOutline,
  mdiImageOff,
  mdiImageOffOutline,
  mdiImageOutline,
  mdiImagePlus,
  mdiImagePlusOutline,
  mdiImageRefresh,
  mdiImageRefreshOutline,
  mdiImageRemove,
  mdiImageRemoveOutline,
  mdiImageSearch,
  mdiImageSearchOutline,
  mdiImageSizeSelectActual,
  mdiImageSizeSelectLarge,
  mdiImageSizeSelectSmall,
  mdiImageSync,
  mdiImageSyncOutline,
  mdiImageText,
  mdiImport,
  mdiInbox,
  mdiInboxArrowDown,
  mdiInboxArrowDownOutline,
  mdiInboxArrowUp,
  mdiInboxArrowUpOutline,
  mdiInboxFull,
  mdiInboxFullOutline,
  mdiInboxMultiple,
  mdiInboxMultipleOutline,
  mdiInboxOutline,
  mdiInboxRemove,
  mdiInboxRemoveOutline,
  mdiIncognito,
  mdiIncognitoCircle,
  mdiIncognitoCircleOff,
  mdiIncognitoOff,
  mdiInduction,
  mdiInfinity,
  mdiInformation,
  mdiInformationBox,
  mdiInformationBoxOutline,
  mdiInformationOff,
  mdiInformationOffOutline,
  mdiInformationOutline,
  mdiInformationSlabBox,
  mdiInformationSlabBoxOutline,
  mdiInformationSlabCircle,
  mdiInformationSlabCircleOutline,
  mdiInformationSlabSymbol,
  mdiInformationSymbol,
  mdiInformationVariant,
  mdiInformationVariantBox,
  mdiInformationVariantBoxOutline,
  mdiInformationVariantCircle,
  mdiInformationVariantCircleOutline,
  mdiInstagram,
  mdiInstrumentTriangle,
  mdiIntegratedCircuitChip,
  mdiInvertColors,
  mdiInvertColorsOff,
  mdiInvoice,
  mdiInvoiceArrowLeft,
  mdiInvoiceArrowLeftOutline,
  mdiInvoiceArrowRight,
  mdiInvoiceArrowRightOutline,
  mdiInvoiceCheck,
  mdiInvoiceCheckOutline,
  mdiInvoiceClock,
  mdiInvoiceClockOutline,
  mdiInvoiceEdit,
  mdiInvoiceEditOutline,
  mdiInvoiceExportOutline,
  mdiInvoiceFast,
  mdiInvoiceFastOutline,
  mdiInvoiceImport,
  mdiInvoiceImportOutline,
  mdiInvoiceList,
  mdiInvoiceListOutline,
  mdiInvoiceMinus,
  mdiInvoiceMinusOutline,
  mdiInvoiceMultiple,
  mdiInvoiceMultipleOutline,
  mdiInvoiceOutline,
  mdiInvoicePlus,
  mdiInvoicePlusOutline,
  mdiInvoiceRemove,
  mdiInvoiceRemoveOutline,
  mdiInvoiceSend,
  mdiInvoiceSendOutline,
  mdiInvoiceText,
  mdiInvoiceTextArrowLeft,
  mdiInvoiceTextArrowLeftOutline,
  mdiInvoiceTextArrowRight,
  mdiInvoiceTextArrowRightOutline,
  mdiInvoiceTextCheck,
  mdiInvoiceTextCheckOutline,
  mdiInvoiceTextClock,
  mdiInvoiceTextClockOutline,
  mdiInvoiceTextEdit,
  mdiInvoiceTextEditOutline,
  mdiInvoiceTextFast,
  mdiInvoiceTextFastOutline,
  mdiInvoiceTextMinus,
  mdiInvoiceTextMinusOutline,
  mdiInvoiceTextMultiple,
  mdiInvoiceTextMultipleOutline,
  mdiInvoiceTextOutline,
  mdiInvoiceTextPlus,
  mdiInvoiceTextPlusOutline,
  mdiInvoiceTextRemove,
  mdiInvoiceTextRemoveOutline,
  mdiInvoiceTextSend,
  mdiInvoiceTextSendOutline,
  mdiIobroker,
  mdiIp,
  mdiIpNetwork,
  mdiIpNetworkOutline,
  mdiIpOutline,
  mdiIpod,
  mdiIron,
  mdiIronBoard,
  mdiIronOutline,
  mdiIsland,
  mdiIslandVariant,
  mdiIvBag,
  mdiJabber,
  mdiJeepney,
  mdiJellyfish,
  mdiJellyfishOutline,
  mdiJira,
  mdiJquery,
  mdiJsfiddle,
  mdiJumpRope,
  mdiKabaddi,
  mdiKangaroo,
  mdiKarate,
  mdiKayaking,
  mdiKeg,
  mdiKettle,
  mdiKettleAlert,
  mdiKettleAlertOutline,
  mdiKettleOff,
  mdiKettleOffOutline,
  mdiKettleOutline,
  mdiKettlePourOver,
  mdiKettleSteam,
  mdiKettleSteamOutline,
  mdiKettlebell,
  mdiKey,
  mdiKeyAlert,
  mdiKeyAlertOutline,
  mdiKeyArrowRight,
  mdiKeyChain,
  mdiKeyChainVariant,
  mdiKeyChange,
  mdiKeyLink,
  mdiKeyMinus,
  mdiKeyOutline,
  mdiKeyPlus,
  mdiKeyRemove,
  mdiKeyStar,
  mdiKeyVariant,
  mdiKeyWireless,
  mdiKeyboard,
  mdiKeyboardBackspace,
  mdiKeyboardCaps,
  mdiKeyboardClose,
  mdiKeyboardCloseOutline,
  mdiKeyboardEsc,
  mdiKeyboardF1,
  mdiKeyboardF10,
  mdiKeyboardF11,
  mdiKeyboardF12,
  mdiKeyboardF2,
  mdiKeyboardF3,
  mdiKeyboardF4,
  mdiKeyboardF5,
  mdiKeyboardF6,
  mdiKeyboardF7,
  mdiKeyboardF8,
  mdiKeyboardF9,
  mdiKeyboardOff,
  mdiKeyboardOffOutline,
  mdiKeyboardOutline,
  mdiKeyboardReturn,
  mdiKeyboardSettings,
  mdiKeyboardSettingsOutline,
  mdiKeyboardSpace,
  mdiKeyboardTab,
  mdiKeyboardTabReverse,
  mdiKeyboardVariant,
  mdiKhanda,
  mdiKickstarter,
  mdiKite,
  mdiKiteOutline,
  mdiKitesurfing,
  mdiKlingon,
  mdiKnife,
  mdiKnifeMilitary,
  mdiKnob,
  mdiKoala,
  mdiKodi,
  mdiKubernetes,
  mdiLabel,
  mdiLabelMultiple,
  mdiLabelMultipleOutline,
  mdiLabelOff,
  mdiLabelOffOutline,
  mdiLabelOutline,
  mdiLabelPercent,
  mdiLabelPercentOutline,
  mdiLabelVariant,
  mdiLabelVariantOutline,
  mdiLadder,
  mdiLadybug,
  mdiLambda,
  mdiLamp,
  mdiLampOutline,
  mdiLamps,
  mdiLampsOutline,
  mdiLan,
  mdiLanCheck,
  mdiLanConnect,
  mdiLanDisconnect,
  mdiLanPending,
  mdiLandFields,
  mdiLandPlots,
  mdiLandPlotsCircle,
  mdiLandPlotsCircleVariant,
  mdiLandPlotsMarker,
  mdiLandRowsHorizontal,
  mdiLandRowsVertical,
  mdiLandslide,
  mdiLandslideOutline,
  mdiLanguageC,
  mdiLanguageCpp,
  mdiLanguageCsharp,
  mdiLanguageCss3,
  mdiLanguageFortran,
  mdiLanguageGo,
  mdiLanguageHaskell,
  mdiLanguageHtml5,
  mdiLanguageJava,
  mdiLanguageJavascript,
  mdiLanguageKotlin,
  mdiLanguageLua,
  mdiLanguageMarkdown,
  mdiLanguageMarkdownOutline,
  mdiLanguagePhp,
  mdiLanguagePython,
  mdiLanguageR,
  mdiLanguageRuby,
  mdiLanguageRubyOnRails,
  mdiLanguageRust,
  mdiLanguageSwift,
  mdiLanguageTypescript,
  mdiLanguageXaml,
  mdiLaptop,
  mdiLaptopAccount,
  mdiLaptopOff,
  mdiLaravel,
  mdiLaserPointer,
  mdiLasso,
  mdiLastpass,
  mdiLatitude,
  mdiLaunch,
  mdiLavaLamp,
  mdiLayers,
  mdiLayersEdit,
  mdiLayersMinus,
  mdiLayersOff,
  mdiLayersOffOutline,
  mdiLayersOutline,
  mdiLayersPlus,
  mdiLayersRemove,
  mdiLayersSearch,
  mdiLayersSearchOutline,
  mdiLayersTriple,
  mdiLayersTripleOutline,
  mdiLeadPencil,
  mdiLeaf,
  mdiLeafCircle,
  mdiLeafCircleOutline,
  mdiLeafMaple,
  mdiLeafMapleOff,
  mdiLeafOff,
  mdiLeak,
  mdiLeakOff,
  mdiLectern,
  mdiLedOff,
  mdiLedOn,
  mdiLedOutline,
  mdiLedStrip,
  mdiLedStripVariant,
  mdiLedStripVariantOff,
  mdiLedVariantOff,
  mdiLedVariantOn,
  mdiLedVariantOutline,
  mdiLeek,
  mdiLessThan,
  mdiLessThanOrEqual,
  mdiLibrary,
  mdiLibraryOutline,
  mdiLibraryShelves,
  mdiLicense,
  mdiLifebuoy,
  mdiLightFloodDown,
  mdiLightFloodUp,
  mdiLightRecessed,
  mdiLightSwitch,
  mdiLightSwitchOff,
  mdiLightbulb,
  mdiLightbulbAlert,
  mdiLightbulbAlertOutline,
  mdiLightbulbAuto,
  mdiLightbulbAutoOutline,
  mdiLightbulbCfl,
  mdiLightbulbCflOff,
  mdiLightbulbCflSpiral,
  mdiLightbulbCflSpiralOff,
  mdiLightbulbFluorescentTube,
  mdiLightbulbFluorescentTubeOutline,
  mdiLightbulbGroup,
  mdiLightbulbGroupOff,
  mdiLightbulbGroupOffOutline,
  mdiLightbulbGroupOutline,
  mdiLightbulbMultiple,
  mdiLightbulbMultipleOff,
  mdiLightbulbMultipleOffOutline,
  mdiLightbulbMultipleOutline,
  mdiLightbulbNight,
  mdiLightbulbNightOutline,
  mdiLightbulbOff,
  mdiLightbulbOffOutline,
  mdiLightbulbOn,
  mdiLightbulbOn10,
  mdiLightbulbOn20,
  mdiLightbulbOn30,
  mdiLightbulbOn40,
  mdiLightbulbOn50,
  mdiLightbulbOn60,
  mdiLightbulbOn70,
  mdiLightbulbOn80,
  mdiLightbulbOn90,
  mdiLightbulbOnOutline,
  mdiLightbulbOutline,
  mdiLightbulbQuestion,
  mdiLightbulbQuestionOutline,
  mdiLightbulbSpot,
  mdiLightbulbSpotOff,
  mdiLightbulbVariant,
  mdiLightbulbVariantOutline,
  mdiLighthouse,
  mdiLighthouseOn,
  mdiLightningBolt,
  mdiLightningBoltCircle,
  mdiLightningBoltOutline,
  mdiLineScan,
  mdiLingerie,
  mdiLink,
  mdiLinkBox,
  mdiLinkBoxOutline,
  mdiLinkBoxVariant,
  mdiLinkBoxVariantOutline,
  mdiLinkCircle,
  mdiLinkCircleOutline,
  mdiLinkEdit,
  mdiLinkLock,
  mdiLinkOff,
  mdiLinkPlus,
  mdiLinkVariant,
  mdiLinkVariantMinus,
  mdiLinkVariantOff,
  mdiLinkVariantPlus,
  mdiLinkVariantRemove,
  mdiLinkedin,
  mdiLinux,
  mdiLinuxMint,
  mdiLipstick,
  mdiLiquidSpot,
  mdiLiquor,
  mdiListBox,
  mdiListBoxOutline,
  mdiListStatus,
  mdiLitecoin,
  mdiLoading,
  mdiLocationEnter,
  mdiLocationExit,
  mdiLock,
  mdiLockAlert,
  mdiLockAlertOutline,
  mdiLockCheck,
  mdiLockCheckOutline,
  mdiLockClock,
  mdiLockMinus,
  mdiLockMinusOutline,
  mdiLockOff,
  mdiLockOffOutline,
  mdiLockOpen,
  mdiLockOpenAlert,
  mdiLockOpenAlertOutline,
  mdiLockOpenCheck,
  mdiLockOpenCheckOutline,
  mdiLockOpenMinus,
  mdiLockOpenMinusOutline,
  mdiLockOpenOutline,
  mdiLockOpenPlus,
  mdiLockOpenPlusOutline,
  mdiLockOpenRemove,
  mdiLockOpenRemoveOutline,
  mdiLockOpenVariant,
  mdiLockOpenVariantOutline,
  mdiLockOutline,
  mdiLockPattern,
  mdiLockPercent,
  mdiLockPercentOpen,
  mdiLockPercentOpenOutline,
  mdiLockPercentOpenVariant,
  mdiLockPercentOpenVariantOutline,
  mdiLockPercentOutline,
  mdiLockPlus,
  mdiLockPlusOutline,
  mdiLockQuestion,
  mdiLockRemove,
  mdiLockRemoveOutline,
  mdiLockReset,
  mdiLockSmart,
  mdiLocker,
  mdiLockerMultiple,
  mdiLogin,
  mdiLoginVariant,
  mdiLogout,
  mdiLogoutVariant,
  mdiLongitude,
  mdiLooks,
  mdiLotion,
  mdiLotionOutline,
  mdiLotionPlus,
  mdiLotionPlusOutline,
  mdiLoupe,
  mdiLumx,
  mdiLungs,
  mdiMace,
  mdiMagazinePistol,
  mdiMagazineRifle,
  mdiMagicStaff,
  mdiMagnet,
  mdiMagnetOn,
  mdiMagnify,
  mdiMagnifyClose,
  mdiMagnifyExpand,
  mdiMagnifyMinus,
  mdiMagnifyMinusCursor,
  mdiMagnifyMinusOutline,
  mdiMagnifyPlus,
  mdiMagnifyPlusCursor,
  mdiMagnifyPlusOutline,
  mdiMagnifyRemoveCursor,
  mdiMagnifyRemoveOutline,
  mdiMagnifyScan,
  mdiMail,
  mdiMailbox,
  mdiMailboxOpen,
  mdiMailboxOpenOutline,
  mdiMailboxOpenUp,
  mdiMailboxOpenUpOutline,
  mdiMailboxOutline,
  mdiMailboxUp,
  mdiMailboxUpOutline,
  mdiManjaro,
  mdiMap,
  mdiMapCheck,
  mdiMapCheckOutline,
  mdiMapClock,
  mdiMapClockOutline,
  mdiMapLegend,
  mdiMapMarker,
  mdiMapMarkerAccount,
  mdiMapMarkerAccountOutline,
  mdiMapMarkerAlert,
  mdiMapMarkerAlertOutline,
  mdiMapMarkerCheck,
  mdiMapMarkerCheckOutline,
  mdiMapMarkerCircle,
  mdiMapMarkerDistance,
  mdiMapMarkerDown,
  mdiMapMarkerLeft,
  mdiMapMarkerLeftOutline,
  mdiMapMarkerMinus,
  mdiMapMarkerMinusOutline,
  mdiMapMarkerMultiple,
  mdiMapMarkerMultipleOutline,
  mdiMapMarkerOff,
  mdiMapMarkerOffOutline,
  mdiMapMarkerOutline,
  mdiMapMarkerPath,
  mdiMapMarkerPlus,
  mdiMapMarkerPlusOutline,
  mdiMapMarkerQuestion,
  mdiMapMarkerQuestionOutline,
  mdiMapMarkerRadius,
  mdiMapMarkerRadiusOutline,
  mdiMapMarkerRemove,
  mdiMapMarkerRemoveOutline,
  mdiMapMarkerRemoveVariant,
  mdiMapMarkerRight,
  mdiMapMarkerRightOutline,
  mdiMapMarkerStar,
  mdiMapMarkerStarOutline,
  mdiMapMarkerUp,
  mdiMapMinus,
  mdiMapOutline,
  mdiMapPlus,
  mdiMapSearch,
  mdiMapSearchOutline,
  mdiMapbox,
  mdiMargin,
  mdiMarker,
  mdiMarkerCancel,
  mdiMarkerCheck,
  mdiMastodon,
  mdiMaterialDesign,
  mdiMaterialUi,
  mdiMathCompass,
  mdiMathCos,
  mdiMathIntegral,
  mdiMathIntegralBox,
  mdiMathLog,
  mdiMathNorm,
  mdiMathNormBox,
  mdiMathSin,
  mdiMathTan,
  mdiMatrix,
  mdiMedal,
  mdiMedalOutline,
  mdiMedicalBag,
  mdiMedicalCottonSwab,
  mdiMedication,
  mdiMedicationOutline,
  mdiMeditation,
  mdiMemory,
  mdiMemoryArrowDown,
  mdiMenorah,
  mdiMenorahFire,
  mdiMenu,
  mdiMenuClose,
  mdiMenuDown,
  mdiMenuDownOutline,
  mdiMenuLeft,
  mdiMenuLeftOutline,
  mdiMenuOpen,
  mdiMenuRight,
  mdiMenuRightOutline,
  mdiMenuSwap,
  mdiMenuSwapOutline,
  mdiMenuUp,
  mdiMenuUpOutline,
  mdiMerge,
  mdiMessage,
  mdiMessageAlert,
  mdiMessageAlertOutline,
  mdiMessageArrowLeft,
  mdiMessageArrowLeftOutline,
  mdiMessageArrowRight,
  mdiMessageArrowRightOutline,
  mdiMessageBadge,
  mdiMessageBadgeOutline,
  mdiMessageBookmark,
  mdiMessageBookmarkOutline,
  mdiMessageBulleted,
  mdiMessageBulletedOff,
  mdiMessageCheck,
  mdiMessageCheckOutline,
  mdiMessageCog,
  mdiMessageCogOutline,
  mdiMessageDraw,
  mdiMessageFast,
  mdiMessageFastOutline,
  mdiMessageFlash,
  mdiMessageFlashOutline,
  mdiMessageImage,
  mdiMessageImageOutline,
  mdiMessageLock,
  mdiMessageLockOutline,
  mdiMessageMinus,
  mdiMessageMinusOutline,
  mdiMessageOff,
  mdiMessageOffOutline,
  mdiMessageOutline,
  mdiMessagePlus,
  mdiMessagePlusOutline,
  mdiMessageProcessing,
  mdiMessageProcessingOutline,
  mdiMessageQuestion,
  mdiMessageQuestionOutline,
  mdiMessageReply,
  mdiMessageReplyOutline,
  mdiMessageReplyText,
  mdiMessageReplyTextOutline,
  mdiMessageSettings,
  mdiMessageSettingsOutline,
  mdiMessageStar,
  mdiMessageStarOutline,
  mdiMessageText,
  mdiMessageTextClock,
  mdiMessageTextClockOutline,
  mdiMessageTextFast,
  mdiMessageTextFastOutline,
  mdiMessageTextLock,
  mdiMessageTextLockOutline,
  mdiMessageTextOutline,
  mdiMessageVideo,
  mdiMeteor,
  mdiMeterElectric,
  mdiMeterElectricOutline,
  mdiMeterGas,
  mdiMeterGasOutline,
  mdiMetronome,
  mdiMetronomeTick,
  mdiMicroSd,
  mdiMicrophone,
  mdiMicrophoneMessage,
  mdiMicrophoneMessageOff,
  mdiMicrophoneMinus,
  mdiMicrophoneOff,
  mdiMicrophoneOutline,
  mdiMicrophonePlus,
  mdiMicrophoneQuestion,
  mdiMicrophoneQuestionOutline,
  mdiMicrophoneSettings,
  mdiMicrophoneVariant,
  mdiMicrophoneVariantOff,
  mdiMicroscope,
  mdiMicrosoft,
  mdiMicrosoftAccess,
  mdiMicrosoftAzure,
  mdiMicrosoftAzureDevops,
  mdiMicrosoftBing,
  mdiMicrosoftDynamics365,
  mdiMicrosoftEdge,
  mdiMicrosoftExcel,
  mdiMicrosoftInternetExplorer,
  mdiMicrosoftOffice,
  mdiMicrosoftOnedrive,
  mdiMicrosoftOnenote,
  mdiMicrosoftOutlook,
  mdiMicrosoftPowerpoint,
  mdiMicrosoftSharepoint,
  mdiMicrosoftTeams,
  mdiMicrosoftVisualStudio,
  mdiMicrosoftVisualStudioCode,
  mdiMicrosoftWindows,
  mdiMicrosoftWindowsClassic,
  mdiMicrosoftWord,
  mdiMicrosoftXbox,
  mdiMicrosoftXboxController,
  mdiMicrosoftXboxControllerBatteryAlert,
  mdiMicrosoftXboxControllerBatteryCharging,
  mdiMicrosoftXboxControllerBatteryEmpty,
  mdiMicrosoftXboxControllerBatteryFull,
  mdiMicrosoftXboxControllerBatteryLow,
  mdiMicrosoftXboxControllerBatteryMedium,
  mdiMicrosoftXboxControllerBatteryUnknown,
  mdiMicrosoftXboxControllerMenu,
  mdiMicrosoftXboxControllerOff,
  mdiMicrosoftXboxControllerView,
  mdiMicrowave,
  mdiMicrowaveOff,
  mdiMiddleware,
  mdiMiddlewareOutline,
  mdiMidi,
  mdiMidiPort,
  mdiMine,
  mdiMinecraft,
  mdiMiniSd,
  mdiMinidisc,
  mdiMinus,
  mdiMinusBox,
  mdiMinusBoxMultiple,
  mdiMinusBoxMultipleOutline,
  mdiMinusBoxOutline,
  mdiMinusCircle,
  mdiMinusCircleMultiple,
  mdiMinusCircleMultipleOutline,
  mdiMinusCircleOff,
  mdiMinusCircleOffOutline,
  mdiMinusCircleOutline,
  mdiMinusNetwork,
  mdiMinusNetworkOutline,
  mdiMinusThick,
  mdiMirror,
  mdiMirrorRectangle,
  mdiMirrorVariant,
  mdiMixedMartialArts,
  mdiMixedReality,
  mdiMolecule,
  mdiMoleculeCo,
  mdiMoleculeCo2,
  mdiMonitor,
  mdiMonitorAccount,
  mdiMonitorArrowDown,
  mdiMonitorArrowDownVariant,
  mdiMonitorCellphone,
  mdiMonitorCellphoneStar,
  mdiMonitorDashboard,
  mdiMonitorEdit,
  mdiMonitorEye,
  mdiMonitorLock,
  mdiMonitorMultiple,
  mdiMonitorOff,
  mdiMonitorScreenshot,
  mdiMonitorShare,
  mdiMonitorShimmer,
  mdiMonitorSmall,
  mdiMonitorSpeaker,
  mdiMonitorSpeakerOff,
  mdiMonitorStar,
  mdiMonitorVertical,
  mdiMoonFirstQuarter,
  mdiMoonFull,
  mdiMoonLastQuarter,
  mdiMoonNew,
  mdiMoonWaningCrescent,
  mdiMoonWaningGibbous,
  mdiMoonWaxingCrescent,
  mdiMoonWaxingGibbous,
  mdiMoped,
  mdiMopedElectric,
  mdiMopedElectricOutline,
  mdiMopedOutline,
  mdiMore,
  mdiMortarPestle,
  mdiMortarPestlePlus,
  mdiMosque,
  mdiMosqueOutline,
  mdiMotherHeart,
  mdiMotherNurse,
  mdiMotion,
  mdiMotionOutline,
  mdiMotionPause,
  mdiMotionPauseOutline,
  mdiMotionPlay,
  mdiMotionPlayOutline,
  mdiMotionSensor,
  mdiMotionSensorOff,
  mdiMotorbike,
  mdiMotorbikeElectric,
  mdiMotorbikeOff,
  mdiMouse,
  mdiMouseBluetooth,
  mdiMouseLeftClick,
  mdiMouseLeftClickOutline,
  mdiMouseMoveDown,
  mdiMouseMoveUp,
  mdiMouseMoveVertical,
  mdiMouseOff,
  mdiMouseOutline,
  mdiMouseRightClick,
  mdiMouseRightClickOutline,
  mdiMouseScrollWheel,
  mdiMouseVariant,
  mdiMouseVariantOff,
  mdiMoveResize,
  mdiMoveResizeVariant,
  mdiMovie,
  mdiMovieCheck,
  mdiMovieCheckOutline,
  mdiMovieCog,
  mdiMovieCogOutline,
  mdiMovieEdit,
  mdiMovieEditOutline,
  mdiMovieFilter,
  mdiMovieFilterOutline,
  mdiMovieMinus,
  mdiMovieMinusOutline,
  mdiMovieOff,
  mdiMovieOffOutline,
  mdiMovieOpen,
  mdiMovieOpenCheck,
  mdiMovieOpenCheckOutline,
  mdiMovieOpenCog,
  mdiMovieOpenCogOutline,
  mdiMovieOpenEdit,
  mdiMovieOpenEditOutline,
  mdiMovieOpenMinus,
  mdiMovieOpenMinusOutline,
  mdiMovieOpenOff,
  mdiMovieOpenOffOutline,
  mdiMovieOpenOutline,
  mdiMovieOpenPlay,
  mdiMovieOpenPlayOutline,
  mdiMovieOpenPlus,
  mdiMovieOpenPlusOutline,
  mdiMovieOpenRemove,
  mdiMovieOpenRemoveOutline,
  mdiMovieOpenSettings,
  mdiMovieOpenSettingsOutline,
  mdiMovieOpenStar,
  mdiMovieOpenStarOutline,
  mdiMovieOutline,
  mdiMoviePlay,
  mdiMoviePlayOutline,
  mdiMoviePlus,
  mdiMoviePlusOutline,
  mdiMovieRemove,
  mdiMovieRemoveOutline,
  mdiMovieRoll,
  mdiMovieSearch,
  mdiMovieSearchOutline,
  mdiMovieSettings,
  mdiMovieSettingsOutline,
  mdiMovieStar,
  mdiMovieStarOutline,
  mdiMower,
  mdiMowerBag,
  mdiMowerBagOn,
  mdiMowerOn,
  mdiMuffin,
  mdiMulticast,
  mdiMultimedia,
  mdiMultiplication,
  mdiMultiplicationBox,
  mdiMushroom,
  mdiMushroomOff,
  mdiMushroomOffOutline,
  mdiMushroomOutline,
  mdiMusic,
  mdiMusicAccidentalDoubleFlat,
  mdiMusicAccidentalDoubleSharp,
  mdiMusicAccidentalFlat,
  mdiMusicAccidentalNatural,
  mdiMusicAccidentalSharp,
  mdiMusicBox,
  mdiMusicBoxMultiple,
  mdiMusicBoxMultipleOutline,
  mdiMusicBoxOutline,
  mdiMusicCircle,
  mdiMusicCircleOutline,
  mdiMusicClefAlto,
  mdiMusicClefBass,
  mdiMusicClefTreble,
  mdiMusicNote,
  mdiMusicNoteBluetooth,
  mdiMusicNoteBluetoothOff,
  mdiMusicNoteEighth,
  mdiMusicNoteEighthDotted,
  mdiMusicNoteHalf,
  mdiMusicNoteHalfDotted,
  mdiMusicNoteMinus,
  mdiMusicNoteOff,
  mdiMusicNoteOffOutline,
  mdiMusicNoteOutline,
  mdiMusicNotePlus,
  mdiMusicNoteQuarter,
  mdiMusicNoteQuarterDotted,
  mdiMusicNoteSixteenth,
  mdiMusicNoteSixteenthDotted,
  mdiMusicNoteWhole,
  mdiMusicNoteWholeDotted,
  mdiMusicOff,
  mdiMusicRestEighth,
  mdiMusicRestHalf,
  mdiMusicRestQuarter,
  mdiMusicRestSixteenth,
  mdiMusicRestWhole,
  mdiMustache,
  mdiNail,
  mdiNas,
  mdiNativescript,
  mdiNature,
  mdiNatureOutline,
  mdiNaturePeople,
  mdiNaturePeopleOutline,
  mdiNavigation,
  mdiNavigationOutline,
  mdiNavigationVariant,
  mdiNavigationVariantOutline,
  mdiNearMe,
  mdiNecklace,
  mdiNeedle,
  mdiNeedleOff,
  mdiNetflix,
  mdiNetwork,
  mdiNetworkOff,
  mdiNetworkOffOutline,
  mdiNetworkOutline,
  mdiNetworkPos,
  mdiNetworkStrength1,
  mdiNetworkStrength1Alert,
  mdiNetworkStrength2,
  mdiNetworkStrength2Alert,
  mdiNetworkStrength3,
  mdiNetworkStrength3Alert,
  mdiNetworkStrength4,
  mdiNetworkStrength4Alert,
  mdiNetworkStrength4Cog,
  mdiNetworkStrengthOff,
  mdiNetworkStrengthOffOutline,
  mdiNetworkStrengthOutline,
  mdiNewBox,
  mdiNewspaper,
  mdiNewspaperCheck,
  mdiNewspaperMinus,
  mdiNewspaperPlus,
  mdiNewspaperRemove,
  mdiNewspaperVariant,
  mdiNewspaperVariantMultiple,
  mdiNewspaperVariantMultipleOutline,
  mdiNewspaperVariantOutline,
  mdiNfc,
  mdiNfcSearchVariant,
  mdiNfcTap,
  mdiNfcVariant,
  mdiNfcVariantOff,
  mdiNinja,
  mdiNintendoGameBoy,
  mdiNintendoSwitch,
  mdiNintendoWii,
  mdiNintendoWiiu,
  mdiNix,
  mdiNodejs,
  mdiNoodles,
  mdiNotEqual,
  mdiNotEqualVariant,
  mdiNote,
  mdiNoteAlert,
  mdiNoteAlertOutline,
  mdiNoteCheck,
  mdiNoteCheckOutline,
  mdiNoteEdit,
  mdiNoteEditOutline,
  mdiNoteMinus,
  mdiNoteMinusOutline,
  mdiNoteMultiple,
  mdiNoteMultipleOutline,
  mdiNoteOff,
  mdiNoteOffOutline,
  mdiNoteOutline,
  mdiNotePlus,
  mdiNotePlusOutline,
  mdiNoteRemove,
  mdiNoteRemoveOutline,
  mdiNoteSearch,
  mdiNoteSearchOutline,
  mdiNoteText,
  mdiNoteTextOutline,
  mdiNotebook,
  mdiNotebookCheck,
  mdiNotebookCheckOutline,
  mdiNotebookEdit,
  mdiNotebookEditOutline,
  mdiNotebookHeart,
  mdiNotebookHeartOutline,
  mdiNotebookMinus,
  mdiNotebookMinusOutline,
  mdiNotebookMultiple,
  mdiNotebookOutline,
  mdiNotebookPlus,
  mdiNotebookPlusOutline,
  mdiNotebookRemove,
  mdiNotebookRemoveOutline,
  mdiNotificationClearAll,
  mdiNpm,
  mdiNuke,
  mdiNull,
  mdiNumeric,
  mdiNumeric0,
  mdiNumeric0Box,
  mdiNumeric0BoxMultiple,
  mdiNumeric0BoxMultipleOutline,
  mdiNumeric0BoxOutline,
  mdiNumeric0Circle,
  mdiNumeric0CircleOutline,
  mdiNumeric1,
  mdiNumeric10,
  mdiNumeric10Box,
  mdiNumeric10BoxMultiple,
  mdiNumeric10BoxMultipleOutline,
  mdiNumeric10BoxOutline,
  mdiNumeric10Circle,
  mdiNumeric10CircleOutline,
  mdiNumeric1Box,
  mdiNumeric1BoxMultiple,
  mdiNumeric1BoxMultipleOutline,
  mdiNumeric1BoxOutline,
  mdiNumeric1Circle,
  mdiNumeric1CircleOutline,
  mdiNumeric2,
  mdiNumeric2Box,
  mdiNumeric2BoxMultiple,
  mdiNumeric2BoxMultipleOutline,
  mdiNumeric2BoxOutline,
  mdiNumeric2Circle,
  mdiNumeric2CircleOutline,
  mdiNumeric3,
  mdiNumeric3Box,
  mdiNumeric3BoxMultiple,
  mdiNumeric3BoxMultipleOutline,
  mdiNumeric3BoxOutline,
  mdiNumeric3Circle,
  mdiNumeric3CircleOutline,
  mdiNumeric4,
  mdiNumeric4Box,
  mdiNumeric4BoxMultiple,
  mdiNumeric4BoxMultipleOutline,
  mdiNumeric4BoxOutline,
  mdiNumeric4Circle,
  mdiNumeric4CircleOutline,
  mdiNumeric5,
  mdiNumeric5Box,
  mdiNumeric5BoxMultiple,
  mdiNumeric5BoxMultipleOutline,
  mdiNumeric5BoxOutline,
  mdiNumeric5Circle,
  mdiNumeric5CircleOutline,
  mdiNumeric6,
  mdiNumeric6Box,
  mdiNumeric6BoxMultiple,
  mdiNumeric6BoxMultipleOutline,
  mdiNumeric6BoxOutline,
  mdiNumeric6Circle,
  mdiNumeric6CircleOutline,
  mdiNumeric7,
  mdiNumeric7Box,
  mdiNumeric7BoxMultiple,
  mdiNumeric7BoxMultipleOutline,
  mdiNumeric7BoxOutline,
  mdiNumeric7Circle,
  mdiNumeric7CircleOutline,
  mdiNumeric8,
  mdiNumeric8Box,
  mdiNumeric8BoxMultiple,
  mdiNumeric8BoxMultipleOutline,
  mdiNumeric8BoxOutline,
  mdiNumeric8Circle,
  mdiNumeric8CircleOutline,
  mdiNumeric9,
  mdiNumeric9Box,
  mdiNumeric9BoxMultiple,
  mdiNumeric9BoxMultipleOutline,
  mdiNumeric9BoxOutline,
  mdiNumeric9Circle,
  mdiNumeric9CircleOutline,
  mdiNumeric9Plus,
  mdiNumeric9PlusBox,
  mdiNumeric9PlusBoxMultiple,
  mdiNumeric9PlusBoxMultipleOutline,
  mdiNumeric9PlusBoxOutline,
  mdiNumeric9PlusCircle,
  mdiNumeric9PlusCircleOutline,
  mdiNumericNegative1,
  mdiNumericOff,
  mdiNumericPositive1,
  mdiNut,
  mdiNutrition,
  mdiNuxt,
  mdiOar,
  mdiOcarina,
  mdiOci,
  mdiOcr,
  mdiOctagon,
  mdiOctagonOutline,
  mdiOctagram,
  mdiOctagramEdit,
  mdiOctagramEditOutline,
  mdiOctagramMinus,
  mdiOctagramMinusOutline,
  mdiOctagramOutline,
  mdiOctagramPlus,
  mdiOctagramPlusOutline,
  mdiOctahedron,
  mdiOctahedronOff,
  mdiOdnoklassniki,
  mdiOffer,
  mdiOfficeBuilding,
  mdiOfficeBuildingCog,
  mdiOfficeBuildingCogOutline,
  mdiOfficeBuildingMarker,
  mdiOfficeBuildingMarkerOutline,
  mdiOfficeBuildingMinus,
  mdiOfficeBuildingMinusOutline,
  mdiOfficeBuildingOutline,
  mdiOfficeBuildingPlus,
  mdiOfficeBuildingPlusOutline,
  mdiOfficeBuildingRemove,
  mdiOfficeBuildingRemoveOutline,
  mdiOil,
  mdiOilLamp,
  mdiOilLevel,
  mdiOilTemperature,
  mdiOm,
  mdiOmega,
  mdiOneUp,
  mdiOnepassword,
  mdiOpacity,
  mdiOpenInApp,
  mdiOpenInNew,
  mdiOpenSourceInitiative,
  mdiOpenid,
  mdiOpera,
  mdiOrbit,
  mdiOrbitVariant,
  mdiOrderAlphabeticalAscending,
  mdiOrderAlphabeticalDescending,
  mdiOrderBoolAscending,
  mdiOrderBoolAscendingVariant,
  mdiOrderBoolDescending,
  mdiOrderBoolDescendingVariant,
  mdiOrderNumericAscending,
  mdiOrderNumericDescending,
  mdiOrigin,
  mdiOrnament,
  mdiOrnamentVariant,
  mdiOutdoorLamp,
  mdiOverscan,
  mdiOwl,
  mdiPacMan,
  mdiPackage,
  mdiPackageCheck,
  mdiPackageDown,
  mdiPackageUp,
  mdiPackageVariant,
  mdiPackageVariantClosed,
  mdiPackageVariantClosedCheck,
  mdiPackageVariantClosedMinus,
  mdiPackageVariantClosedPlus,
  mdiPackageVariantClosedRemove,
  mdiPackageVariantMinus,
  mdiPackageVariantPlus,
  mdiPackageVariantRemove,
  mdiPageFirst,
  mdiPageLast,
  mdiPageLayoutBody,
  mdiPageLayoutFooter,
  mdiPageLayoutHeader,
  mdiPageLayoutHeaderFooter,
  mdiPageLayoutSidebarLeft,
  mdiPageLayoutSidebarRight,
  mdiPageNext,
  mdiPageNextOutline,
  mdiPagePrevious,
  mdiPagePreviousOutline,
  mdiPail,
  mdiPailMinus,
  mdiPailMinusOutline,
  mdiPailOff,
  mdiPailOffOutline,
  mdiPailOutline,
  mdiPailPlus,
  mdiPailPlusOutline,
  mdiPailRemove,
  mdiPailRemoveOutline,
  mdiPalette,
  mdiPaletteAdvanced,
  mdiPaletteOutline,
  mdiPaletteSwatch,
  mdiPaletteSwatchOutline,
  mdiPaletteSwatchVariant,
  mdiPalmTree,
  mdiPan,
  mdiPanBottomLeft,
  mdiPanBottomRight,
  mdiPanDown,
  mdiPanHorizontal,
  mdiPanLeft,
  mdiPanRight,
  mdiPanTopLeft,
  mdiPanTopRight,
  mdiPanUp,
  mdiPanVertical,
  mdiPanda,
  mdiPandora,
  mdiPanorama,
  mdiPanoramaFisheye,
  mdiPanoramaHorizontal,
  mdiPanoramaHorizontalOutline,
  mdiPanoramaOutline,
  mdiPanoramaSphere,
  mdiPanoramaSphereOutline,
  mdiPanoramaVariant,
  mdiPanoramaVariantOutline,
  mdiPanoramaVertical,
  mdiPanoramaVerticalOutline,
  mdiPanoramaWideAngle,
  mdiPanoramaWideAngleOutline,
  mdiPaperCutVertical,
  mdiPaperRoll,
  mdiPaperRollOutline,
  mdiPaperclip,
  mdiPaperclipCheck,
  mdiPaperclipLock,
  mdiPaperclipMinus,
  mdiPaperclipOff,
  mdiPaperclipPlus,
  mdiPaperclipRemove,
  mdiParachute,
  mdiParachuteOutline,
  mdiParagliding,
  mdiParking,
  mdiPartyPopper,
  mdiPassport,
  mdiPassportAlert,
  mdiPassportBiometric,
  mdiPassportCancel,
  mdiPassportCheck,
  mdiPassportMinus,
  mdiPassportPlus,
  mdiPassportRemove,
  mdiPasta,
  mdiPatioHeater,
  mdiPatreon,
  mdiPause,
  mdiPauseBox,
  mdiPauseBoxOutline,
  mdiPauseCircle,
  mdiPauseCircleOutline,
  mdiPauseOctagon,
  mdiPauseOctagonOutline,
  mdiPaw,
  mdiPawOff,
  mdiPawOffOutline,
  mdiPawOutline,
  mdiPeace,
  mdiPeanut,
  mdiPeanutOff,
  mdiPeanutOffOutline,
  mdiPeanutOutline,
  mdiPen,
  mdiPenLock,
  mdiPenMinus,
  mdiPenOff,
  mdiPenPlus,
  mdiPenRemove,
  mdiPencil,
  mdiPencilBox,
  mdiPencilBoxMultiple,
  mdiPencilBoxMultipleOutline,
  mdiPencilBoxOutline,
  mdiPencilCircle,
  mdiPencilCircleOutline,
  mdiPencilLock,
  mdiPencilLockOutline,
  mdiPencilMinus,
  mdiPencilMinusOutline,
  mdiPencilOff,
  mdiPencilOffOutline,
  mdiPencilOutline,
  mdiPencilPlus,
  mdiPencilPlusOutline,
  mdiPencilRemove,
  mdiPencilRemoveOutline,
  mdiPencilRuler,
  mdiPencilRulerOutline,
  mdiPenguin,
  mdiPentagon,
  mdiPentagonOutline,
  mdiPentagram,
  mdiPercent,
  mdiPercentBox,
  mdiPercentBoxOutline,
  mdiPercentCircle,
  mdiPercentCircleOutline,
  mdiPercentOutline,
  mdiPeriodicTable,
  mdiPerspectiveLess,
  mdiPerspectiveMore,
  mdiPh,
  mdiPhone,
  mdiPhoneAlert,
  mdiPhoneAlertOutline,
  mdiPhoneBluetooth,
  mdiPhoneBluetoothOutline,
  mdiPhoneCancel,
  mdiPhoneCancelOutline,
  mdiPhoneCheck,
  mdiPhoneCheckOutline,
  mdiPhoneClassic,
  mdiPhoneClassicOff,
  mdiPhoneClock,
  mdiPhoneDial,
  mdiPhoneDialOutline,
  mdiPhoneForward,
  mdiPhoneForwardOutline,
  mdiPhoneHangup,
  mdiPhoneHangupOutline,
  mdiPhoneInTalk,
  mdiPhoneInTalkOutline,
  mdiPhoneIncoming,
  mdiPhoneIncomingOutgoing,
  mdiPhoneIncomingOutgoingOutline,
  mdiPhoneIncomingOutline,
  mdiPhoneLock,
  mdiPhoneLockOutline,
  mdiPhoneLog,
  mdiPhoneLogOutline,
  mdiPhoneMessage,
  mdiPhoneMessageOutline,
  mdiPhoneMinus,
  mdiPhoneMinusOutline,
  mdiPhoneMissed,
  mdiPhoneMissedOutline,
  mdiPhoneOff,
  mdiPhoneOffOutline,
  mdiPhoneOutgoing,
  mdiPhoneOutgoingOutline,
  mdiPhoneOutline,
  mdiPhonePaused,
  mdiPhonePausedOutline,
  mdiPhonePlus,
  mdiPhonePlusOutline,
  mdiPhoneRefresh,
  mdiPhoneRefreshOutline,
  mdiPhoneRemove,
  mdiPhoneRemoveOutline,
  mdiPhoneReturn,
  mdiPhoneReturnOutline,
  mdiPhoneRing,
  mdiPhoneRingOutline,
  mdiPhoneRotateLandscape,
  mdiPhoneRotatePortrait,
  mdiPhoneSettings,
  mdiPhoneSettingsOutline,
  mdiPhoneSync,
  mdiPhoneSyncOutline,
  mdiPhoneVoip,
  mdiPi,
  mdiPiBox,
  mdiPiHole,
  mdiPiano,
  mdiPianoOff,
  mdiPickaxe,
  mdiPictureInPictureBottomRight,
  mdiPictureInPictureBottomRightOutline,
  mdiPictureInPictureTopRight,
  mdiPictureInPictureTopRightOutline,
  mdiPier,
  mdiPierCrane,
  mdiPig,
  mdiPigVariant,
  mdiPigVariantOutline,
  mdiPiggyBank,
  mdiPiggyBankOutline,
  mdiPill,
  mdiPillMultiple,
  mdiPillOff,
  mdiPillar,
  mdiPin,
  mdiPinOff,
  mdiPinOffOutline,
  mdiPinOutline,
  mdiPineTree,
  mdiPineTreeBox,
  mdiPineTreeFire,
  mdiPineTreeVariant,
  mdiPineTreeVariantOutline,
  mdiPinterest,
  mdiPinwheel,
  mdiPinwheelOutline,
  mdiPipe,
  mdiPipeDisconnected,
  mdiPipeLeak,
  mdiPipeValve,
  mdiPipeWrench,
  mdiPirate,
  mdiPistol,
  mdiPiston,
  mdiPitchfork,
  mdiPizza,
  mdiPlaneCar,
  mdiPlaneTrain,
  mdiPlay,
  mdiPlayBox,
  mdiPlayBoxEditOutline,
  mdiPlayBoxLock,
  mdiPlayBoxLockOpen,
  mdiPlayBoxLockOpenOutline,
  mdiPlayBoxLockOutline,
  mdiPlayBoxMultiple,
  mdiPlayBoxMultipleOutline,
  mdiPlayBoxOutline,
  mdiPlayCircle,
  mdiPlayCircleOutline,
  mdiPlayNetwork,
  mdiPlayNetworkOutline,
  mdiPlayOutline,
  mdiPlayPause,
  mdiPlayProtectedContent,
  mdiPlaySpeed,
  mdiPlaylistCheck,
  mdiPlaylistEdit,
  mdiPlaylistMinus,
  mdiPlaylistMusic,
  mdiPlaylistMusicOutline,
  mdiPlaylistPlay,
  mdiPlaylistPlus,
  mdiPlaylistRemove,
  mdiPlaylistStar,
  mdiPlex,
  mdiPliers,
  mdiPlus,
  mdiPlusBox,
  mdiPlusBoxMultiple,
  mdiPlusBoxMultipleOutline,
  mdiPlusBoxOutline,
  mdiPlusCircle,
  mdiPlusCircleMultiple,
  mdiPlusCircleMultipleOutline,
  mdiPlusCircleOutline,
  mdiPlusLock,
  mdiPlusLockOpen,
  mdiPlusMinus,
  mdiPlusMinusBox,
  mdiPlusMinusVariant,
  mdiPlusNetwork,
  mdiPlusNetworkOutline,
  mdiPlusOutline,
  mdiPlusThick,
  mdiPocket,
  mdiPodcast,
  mdiPodium,
  mdiPodiumBronze,
  mdiPodiumGold,
  mdiPodiumSilver,
  mdiPointOfSale,
  mdiPokeball,
  mdiPokemonGo,
  mdiPokerChip,
  mdiPolaroid,
  mdiPoliceBadge,
  mdiPoliceBadgeOutline,
  mdiPoliceStation,
  mdiPoll,
  mdiPolo,
  mdiPolymer,
  mdiPool,
  mdiPoolThermometer,
  mdiPopcorn,
  mdiPost,
  mdiPostLamp,
  mdiPostOutline,
  mdiPostageStamp,
  mdiPot,
  mdiPotMix,
  mdiPotMixOutline,
  mdiPotOutline,
  mdiPotSteam,
  mdiPotSteamOutline,
  mdiPound,
  mdiPoundBox,
  mdiPoundBoxOutline,
  mdiPower,
  mdiPowerCycle,
  mdiPowerOff,
  mdiPowerOn,
  mdiPowerPlug,
  mdiPowerPlugBattery,
  mdiPowerPlugBatteryOutline,
  mdiPowerPlugOff,
  mdiPowerPlugOffOutline,
  mdiPowerPlugOutline,
  mdiPowerSettings,
  mdiPowerSleep,
  mdiPowerSocket,
  mdiPowerSocketAu,
  mdiPowerSocketCh,
  mdiPowerSocketDe,
  mdiPowerSocketEu,
  mdiPowerSocketFr,
  mdiPowerSocketIt,
  mdiPowerSocketJp,
  mdiPowerSocketUk,
  mdiPowerSocketUs,
  mdiPowerStandby,
  mdiPowershell,
  mdiPrescription,
  mdiPresentation,
  mdiPresentationPlay,
  mdiPretzel,
  mdiPrinter,
  mdiPrinter3d,
  mdiPrinter3dNozzle,
  mdiPrinter3dNozzleAlert,
  mdiPrinter3dNozzleAlertOutline,
  mdiPrinter3dNozzleHeat,
  mdiPrinter3dNozzleHeatOutline,
  mdiPrinter3dNozzleOff,
  mdiPrinter3dNozzleOffOutline,
  mdiPrinter3dNozzleOutline,
  mdiPrinter3dOff,
  mdiPrinterAlert,
  mdiPrinterCheck,
  mdiPrinterEye,
  mdiPrinterOff,
  mdiPrinterOffOutline,
  mdiPrinterOutline,
  mdiPrinterPos,
  mdiPrinterPosAlert,
  mdiPrinterPosAlertOutline,
  mdiPrinterPosCancel,
  mdiPrinterPosCancelOutline,
  mdiPrinterPosCheck,
  mdiPrinterPosCheckOutline,
  mdiPrinterPosCog,
  mdiPrinterPosCogOutline,
  mdiPrinterPosEdit,
  mdiPrinterPosEditOutline,
  mdiPrinterPosMinus,
  mdiPrinterPosMinusOutline,
  mdiPrinterPosNetwork,
  mdiPrinterPosNetworkOutline,
  mdiPrinterPosOff,
  mdiPrinterPosOffOutline,
  mdiPrinterPosOutline,
  mdiPrinterPosPause,
  mdiPrinterPosPauseOutline,
  mdiPrinterPosPlay,
  mdiPrinterPosPlayOutline,
  mdiPrinterPosPlus,
  mdiPrinterPosPlusOutline,
  mdiPrinterPosRefresh,
  mdiPrinterPosRefreshOutline,
  mdiPrinterPosRemove,
  mdiPrinterPosRemoveOutline,
  mdiPrinterPosStar,
  mdiPrinterPosStarOutline,
  mdiPrinterPosStop,
  mdiPrinterPosStopOutline,
  mdiPrinterPosSync,
  mdiPrinterPosSyncOutline,
  mdiPrinterPosWrench,
  mdiPrinterPosWrenchOutline,
  mdiPrinterSearch,
  mdiPrinterSettings,
  mdiPrinterWireless,
  mdiPriorityHigh,
  mdiPriorityLow,
  mdiProfessionalHexagon,
  mdiProgressAlert,
  mdiProgressCheck,
  mdiProgressClock,
  mdiProgressClose,
  mdiProgressDownload,
  mdiProgressHelper,
  mdiProgressPencil,
  mdiProgressQuestion,
  mdiProgressStar,
  mdiProgressStarFourPoints,
  mdiProgressTag,
  mdiProgressUpload,
  mdiProgressWrench,
  mdiProjector,
  mdiProjectorOff,
  mdiProjectorScreen,
  mdiProjectorScreenOff,
  mdiProjectorScreenOffOutline,
  mdiProjectorScreenOutline,
  mdiProjectorScreenVariant,
  mdiProjectorScreenVariantOff,
  mdiProjectorScreenVariantOffOutline,
  mdiProjectorScreenVariantOutline,
  mdiPropaneTank,
  mdiPropaneTankOutline,
  mdiProtocol,
  mdiPublish,
  mdiPublishOff,
  mdiPulse,
  mdiPump,
  mdiPumpOff,
  mdiPumpkin,
  mdiPurse,
  mdiPurseOutline,
  mdiPuzzle,
  mdiPuzzleCheck,
  mdiPuzzleCheckOutline,
  mdiPuzzleEdit,
  mdiPuzzleEditOutline,
  mdiPuzzleHeart,
  mdiPuzzleHeartOutline,
  mdiPuzzleMinus,
  mdiPuzzleMinusOutline,
  mdiPuzzleOutline,
  mdiPuzzlePlus,
  mdiPuzzlePlusOutline,
  mdiPuzzleRemove,
  mdiPuzzleRemoveOutline,
  mdiPuzzleStar,
  mdiPuzzleStarOutline,
  mdiPyramid,
  mdiPyramidOff,
  mdiQi,
  mdiQqchat,
  mdiQrcode,
  mdiQrcodeEdit,
  mdiQrcodeMinus,
  mdiQrcodePlus,
  mdiQrcodeRemove,
  mdiQrcodeScan,
  mdiQuadcopter,
  mdiQualityHigh,
  mdiQualityLow,
  mdiQualityMedium,
  mdiQueueFirstInLastOut,
  mdiQuora,
  mdiRabbit,
  mdiRabbitVariant,
  mdiRabbitVariantOutline,
  mdiRacingHelmet,
  mdiRacquetball,
  mdiRadar,
  mdiRadiator,
  mdiRadiatorDisabled,
  mdiRadiatorOff,
  mdiRadio,
  mdiRadioAm,
  mdiRadioFm,
  mdiRadioHandheld,
  mdiRadioOff,
  mdiRadioTower,
  mdiRadioactive,
  mdiRadioactiveCircle,
  mdiRadioactiveCircleOutline,
  mdiRadioactiveOff,
  mdiRadioboxBlank,
  mdiRadioboxIndeterminateVariant,
  mdiRadioboxMarked,
  mdiRadiologyBox,
  mdiRadiologyBoxOutline,
  mdiRadius,
  mdiRadiusOutline,
  mdiRailroadLight,
  mdiRake,
  mdiRaspberryPi,
  mdiRaw,
  mdiRawOff,
  mdiRayEnd,
  mdiRayEndArrow,
  mdiRayStart,
  mdiRayStartArrow,
  mdiRayStartEnd,
  mdiRayStartVertexEnd,
  mdiRayVertex,
  mdiRazorDoubleEdge,
  mdiRazorSingleEdge,
  mdiReact,
  mdiRead,
  mdiReceipt,
  mdiReceiptClock,
  mdiReceiptClockOutline,
  mdiReceiptOutline,
  mdiReceiptSend,
  mdiReceiptSendOutline,
  mdiReceiptText,
  mdiReceiptTextArrowLeft,
  mdiReceiptTextArrowLeftOutline,
  mdiReceiptTextArrowRight,
  mdiReceiptTextArrowRightOutline,
  mdiReceiptTextCheck,
  mdiReceiptTextCheckOutline,
  mdiReceiptTextClock,
  mdiReceiptTextClockOutline,
  mdiReceiptTextEdit,
  mdiReceiptTextEditOutline,
  mdiReceiptTextMinus,
  mdiReceiptTextMinusOutline,
  mdiReceiptTextOutline,
  mdiReceiptTextPlus,
  mdiReceiptTextPlusOutline,
  mdiReceiptTextRemove,
  mdiReceiptTextRemoveOutline,
  mdiReceiptTextSend,
  mdiReceiptTextSendOutline,
  mdiRecord,
  mdiRecordCircle,
  mdiRecordCircleOutline,
  mdiRecordPlayer,
  mdiRecordRec,
  mdiRectangle,
  mdiRectangleOutline,
  mdiRecycle,
  mdiRecycleVariant,
  mdiReddit,
  mdiRedhat,
  mdiRedo,
  mdiRedoVariant,
  mdiReflectHorizontal,
  mdiReflectVertical,
  mdiRefresh,
  mdiRefreshAuto,
  mdiRefreshCircle,
  mdiRegex,
  mdiRegisteredTrademark,
  mdiReiterate,
  mdiRelationManyToMany,
  mdiRelationManyToOne,
  mdiRelationManyToOneOrMany,
  mdiRelationManyToOnlyOne,
  mdiRelationManyToZeroOrMany,
  mdiRelationManyToZeroOrOne,
  mdiRelationOneOrManyToMany,
  mdiRelationOneOrManyToOne,
  mdiRelationOneOrManyToOneOrMany,
  mdiRelationOneOrManyToOnlyOne,
  mdiRelationOneOrManyToZeroOrMany,
  mdiRelationOneOrManyToZeroOrOne,
  mdiRelationOneToMany,
  mdiRelationOneToOne,
  mdiRelationOneToOneOrMany,
  mdiRelationOneToOnlyOne,
  mdiRelationOneToZeroOrMany,
  mdiRelationOneToZeroOrOne,
  mdiRelationOnlyOneToMany,
  mdiRelationOnlyOneToOne,
  mdiRelationOnlyOneToOneOrMany,
  mdiRelationOnlyOneToOnlyOne,
  mdiRelationOnlyOneToZeroOrMany,
  mdiRelationOnlyOneToZeroOrOne,
  mdiRelationZeroOrManyToMany,
  mdiRelationZeroOrManyToOne,
  mdiRelationZeroOrManyToOneOrMany,
  mdiRelationZeroOrManyToOnlyOne,
  mdiRelationZeroOrManyToZeroOrMany,
  mdiRelationZeroOrManyToZeroOrOne,
  mdiRelationZeroOrOneToMany,
  mdiRelationZeroOrOneToOne,
  mdiRelationZeroOrOneToOneOrMany,
  mdiRelationZeroOrOneToOnlyOne,
  mdiRelationZeroOrOneToZeroOrMany,
  mdiRelationZeroOrOneToZeroOrOne,
  mdiRelativeScale,
  mdiReload,
  mdiReloadAlert,
  mdiReminder,
  mdiRemote,
  mdiRemoteDesktop,
  mdiRemoteOff,
  mdiRemoteTv,
  mdiRemoteTvOff,
  mdiRename,
  mdiRenameBox,
  mdiRenameBoxOutline,
  mdiRenameOutline,
  mdiReorderHorizontal,
  mdiReorderVertical,
  mdiRepeat,
  mdiRepeatOff,
  mdiRepeatOnce,
  mdiRepeatVariant,
  mdiReplay,
  mdiReply,
  mdiReplyAll,
  mdiReplyAllOutline,
  mdiReplyCircle,
  mdiReplyOutline,
  mdiReproduction,
  mdiResistor,
  mdiResistorNodes,
  mdiResize,
  mdiResizeBottomRight,
  mdiResponsive,
  mdiRestart,
  mdiRestartAlert,
  mdiRestartOff,
  mdiRestore,
  mdiRestoreAlert,
  mdiRewind,
  mdiRewind10,
  mdiRewind15,
  mdiRewind30,
  mdiRewind45,
  mdiRewind5,
  mdiRewind60,
  mdiRewindOutline,
  mdiRhombus,
  mdiRhombusMedium,
  mdiRhombusMediumOutline,
  mdiRhombusOutline,
  mdiRhombusSplit,
  mdiRhombusSplitOutline,
  mdiRibbon,
  mdiRice,
  mdiRickshaw,
  mdiRickshawElectric,
  mdiRing,
  mdiRivet,
  mdiRoad,
  mdiRoadVariant,
  mdiRobber,
  mdiRobot,
  mdiRobotAngry,
  mdiRobotAngryOutline,
  mdiRobotConfused,
  mdiRobotConfusedOutline,
  mdiRobotDead,
  mdiRobotDeadOutline,
  mdiRobotExcited,
  mdiRobotExcitedOutline,
  mdiRobotHappy,
  mdiRobotHappyOutline,
  mdiRobotIndustrial,
  mdiRobotIndustrialOutline,
  mdiRobotLove,
  mdiRobotLoveOutline,
  mdiRobotMower,
  mdiRobotMowerOutline,
  mdiRobotOff,
  mdiRobotOffOutline,
  mdiRobotOutline,
  mdiRobotVacuum,
  mdiRobotVacuumAlert,
  mdiRobotVacuumOff,
  mdiRobotVacuumVariant,
  mdiRobotVacuumVariantAlert,
  mdiRobotVacuumVariantOff,
  mdiRocket,
  mdiRocketLaunch,
  mdiRocketLaunchOutline,
  mdiRocketOutline,
  mdiRodent,
  mdiRollerShade,
  mdiRollerShadeClosed,
  mdiRollerSkate,
  mdiRollerSkateOff,
  mdiRollerblade,
  mdiRollerbladeOff,
  mdiRollupjs,
  mdiRolodex,
  mdiRolodexOutline,
  mdiRomanNumeral1,
  mdiRomanNumeral10,
  mdiRomanNumeral2,
  mdiRomanNumeral3,
  mdiRomanNumeral4,
  mdiRomanNumeral5,
  mdiRomanNumeral6,
  mdiRomanNumeral7,
  mdiRomanNumeral8,
  mdiRomanNumeral9,
  mdiRoomService,
  mdiRoomServiceOutline,
  mdiRotate360,
  mdiRotate3d,
  mdiRotate3dVariant,
  mdiRotateLeft,
  mdiRotateLeftVariant,
  mdiRotateOrbit,
  mdiRotateRight,
  mdiRotateRightVariant,
  mdiRoundedCorner,
  mdiRouter,
  mdiRouterNetwork,
  mdiRouterNetworkWireless,
  mdiRouterWireless,
  mdiRouterWirelessOff,
  mdiRouterWirelessSettings,
  mdiRoutes,
  mdiRoutesClock,
  mdiRowing,
  mdiRss,
  mdiRssBox,
  mdiRssOff,
  mdiRug,
  mdiRugby,
  mdiRuler,
  mdiRulerSquare,
  mdiRulerSquareCompass,
  mdiRun,
  mdiRunFast,
  mdiRvTruck,
  mdiSack,
  mdiSackOutline,
  mdiSackPercent,
  mdiSafe,
  mdiSafeSquare,
  mdiSafeSquareOutline,
  mdiSafetyGoggles,
  mdiSailBoat,
  mdiSailBoatSink,
  mdiSale,
  mdiSaleOutline,
  mdiSalesforce,
  mdiSass,
  mdiSatellite,
  mdiSatelliteUplink,
  mdiSatelliteVariant,
  mdiSausage,
  mdiSausageOff,
  mdiSawBlade,
  mdiSawtoothWave,
  mdiSaxophone,
  mdiScale,
  mdiScaleBalance,
  mdiScaleBathroom,
  mdiScaleOff,
  mdiScaleUnbalanced,
  mdiScanHelper,
  mdiScanner,
  mdiScannerOff,
  mdiScatterPlot,
  mdiScatterPlotOutline,
  mdiScent,
  mdiScentOff,
  mdiSchool,
  mdiSchoolOutline,
  mdiScissorsCutting,
  mdiScooter,
  mdiScooterElectric,
  mdiScoreboard,
  mdiScoreboardOutline,
  mdiScreenRotation,
  mdiScreenRotationLock,
  mdiScrewFlatTop,
  mdiScrewLag,
  mdiScrewMachineFlatTop,
  mdiScrewMachineRoundTop,
  mdiScrewRoundTop,
  mdiScrewdriver,
  mdiScript,
  mdiScriptOutline,
  mdiScriptText,
  mdiScriptTextKey,
  mdiScriptTextKeyOutline,
  mdiScriptTextOutline,
  mdiScriptTextPlay,
  mdiScriptTextPlayOutline,
  mdiSd,
  mdiSeal,
  mdiSealVariant,
  mdiSearchWeb,
  mdiSeat,
  mdiSeatFlat,
  mdiSeatFlatAngled,
  mdiSeatIndividualSuite,
  mdiSeatLegroomExtra,
  mdiSeatLegroomNormal,
  mdiSeatLegroomReduced,
  mdiSeatOutline,
  mdiSeatPassenger,
  mdiSeatReclineExtra,
  mdiSeatReclineNormal,
  mdiSeatbelt,
  mdiSecurity,
  mdiSecurityNetwork,
  mdiSeed,
  mdiSeedOff,
  mdiSeedOffOutline,
  mdiSeedOutline,
  mdiSeedPlus,
  mdiSeedPlusOutline,
  mdiSeesaw,
  mdiSegment,
  mdiSelect,
  mdiSelectAll,
  mdiSelectArrowDown,
  mdiSelectArrowUp,
  mdiSelectColor,
  mdiSelectCompare,
  mdiSelectDrag,
  mdiSelectGroup,
  mdiSelectInverse,
  mdiSelectMarker,
  mdiSelectMultiple,
  mdiSelectMultipleMarker,
  mdiSelectOff,
  mdiSelectPlace,
  mdiSelectRemove,
  mdiSelectSearch,
  mdiSelection,
  mdiSelectionDrag,
  mdiSelectionEllipse,
  mdiSelectionEllipseArrowInside,
  mdiSelectionEllipseRemove,
  mdiSelectionMarker,
  mdiSelectionMultiple,
  mdiSelectionMultipleMarker,
  mdiSelectionOff,
  mdiSelectionRemove,
  mdiSelectionSearch,
  mdiSemanticWeb,
  mdiSend,
  mdiSendCheck,
  mdiSendCheckOutline,
  mdiSendCircle,
  mdiSendCircleOutline,
  mdiSendClock,
  mdiSendClockOutline,
  mdiSendLock,
  mdiSendLockOutline,
  mdiSendOutline,
  mdiSendVariant,
  mdiSendVariantClock,
  mdiSendVariantClockOutline,
  mdiSendVariantOutline,
  mdiSerialPort,
  mdiServer,
  mdiServerMinus,
  mdiServerMinusOutline,
  mdiServerNetwork,
  mdiServerNetworkOff,
  mdiServerNetworkOutline,
  mdiServerOff,
  mdiServerOutline,
  mdiServerPlus,
  mdiServerPlusOutline,
  mdiServerRemove,
  mdiServerSecurity,
  mdiSetAll,
  mdiSetCenter,
  mdiSetCenterRight,
  mdiSetLeft,
  mdiSetLeftCenter,
  mdiSetLeftRight,
  mdiSetMerge,
  mdiSetNone,
  mdiSetRight,
  mdiSetSplit,
  mdiSetSquare,
  mdiSetTopBox,
  mdiSettingsHelper,
  mdiShaker,
  mdiShakerOutline,
  mdiShape,
  mdiShapeCirclePlus,
  mdiShapeOutline,
  mdiShapeOvalPlus,
  mdiShapePlus,
  mdiShapePlusOutline,
  mdiShapePolygonPlus,
  mdiShapeRectanglePlus,
  mdiShapeSquarePlus,
  mdiShapeSquareRoundedPlus,
  mdiShare,
  mdiShareAll,
  mdiShareAllOutline,
  mdiShareCircle,
  mdiShareOff,
  mdiShareOffOutline,
  mdiShareOutline,
  mdiShareVariant,
  mdiShareVariantOutline,
  mdiShark,
  mdiSharkFin,
  mdiSharkFinOutline,
  mdiSharkOff,
  mdiSheep,
  mdiShield,
  mdiShieldAccount,
  mdiShieldAccountOutline,
  mdiShieldAccountVariant,
  mdiShieldAccountVariantOutline,
  mdiShieldAirplane,
  mdiShieldAirplaneOutline,
  mdiShieldAlert,
  mdiShieldAlertOutline,
  mdiShieldBug,
  mdiShieldBugOutline,
  mdiShieldCar,
  mdiShieldCheck,
  mdiShieldCheckOutline,
  mdiShieldCross,
  mdiShieldCrossOutline,
  mdiShieldCrown,
  mdiShieldCrownOutline,
  mdiShieldEdit,
  mdiShieldEditOutline,
  mdiShieldHalf,
  mdiShieldHalfFull,
  mdiShieldHome,
  mdiShieldHomeOutline,
  mdiShieldKey,
  mdiShieldKeyOutline,
  mdiShieldLinkVariant,
  mdiShieldLinkVariantOutline,
  mdiShieldLock,
  mdiShieldLockOpen,
  mdiShieldLockOpenOutline,
  mdiShieldLockOutline,
  mdiShieldMoon,
  mdiShieldMoonOutline,
  mdiShieldOff,
  mdiShieldOffOutline,
  mdiShieldOutline,
  mdiShieldPlus,
  mdiShieldPlusOutline,
  mdiShieldRefresh,
  mdiShieldRefreshOutline,
  mdiShieldRemove,
  mdiShieldRemoveOutline,
  mdiShieldSearch,
  mdiShieldStar,
  mdiShieldStarOutline,
  mdiShieldSun,
  mdiShieldSunOutline,
  mdiShieldSword,
  mdiShieldSwordOutline,
  mdiShieldSync,
  mdiShieldSyncOutline,
  mdiShimmer,
  mdiShipWheel,
  mdiShippingPallet,
  mdiShoeBallet,
  mdiShoeCleat,
  mdiShoeFormal,
  mdiShoeHeel,
  mdiShoePrint,
  mdiShoeSneaker,
  mdiShopping,
  mdiShoppingMusic,
  mdiShoppingOutline,
  mdiShoppingSearch,
  mdiShoppingSearchOutline,
  mdiShore,
  mdiShovel,
  mdiShovelOff,
  mdiShower,
  mdiShowerHead,
  mdiShredder,
  mdiShuffle,
  mdiShuffleDisabled,
  mdiShuffleVariant,
  mdiShuriken,
  mdiSickle,
  mdiSigma,
  mdiSigmaLower,
  mdiSignCaution,
  mdiSignDirection,
  mdiSignDirectionMinus,
  mdiSignDirectionPlus,
  mdiSignDirectionRemove,
  mdiSignLanguage,
  mdiSignLanguageOutline,
  mdiSignPole,
  mdiSignRealEstate,
  mdiSignText,
  mdiSignYield,
  mdiSignal,
  mdiSignal2g,
  mdiSignal3g,
  mdiSignal4g,
  mdiSignal5g,
  mdiSignalCellular1,
  mdiSignalCellular2,
  mdiSignalCellular3,
  mdiSignalCellularOutline,
  mdiSignalDistanceVariant,
  mdiSignalHspa,
  mdiSignalHspaPlus,
  mdiSignalOff,
  mdiSignalVariant,
  mdiSignature,
  mdiSignatureFreehand,
  mdiSignatureImage,
  mdiSignatureText,
  mdiSilo,
  mdiSiloOutline,
  mdiSilverware,
  mdiSilverwareClean,
  mdiSilverwareFork,
  mdiSilverwareForkKnife,
  mdiSilverwareSpoon,
  mdiSilverwareVariant,
  mdiSim,
  mdiSimAlert,
  mdiSimAlertOutline,
  mdiSimOff,
  mdiSimOffOutline,
  mdiSimOutline,
  mdiSimpleIcons,
  mdiSinaWeibo,
  mdiSineWave,
  mdiSitemap,
  mdiSitemapOutline,
  mdiSizeL,
  mdiSizeM,
  mdiSizeS,
  mdiSizeXl,
  mdiSizeXs,
  mdiSizeXxl,
  mdiSizeXxs,
  mdiSizeXxxl,
  mdiSkate,
  mdiSkateOff,
  mdiSkateboard,
  mdiSkateboarding,
  mdiSkewLess,
  mdiSkewMore,
  mdiSki,
  mdiSkiCrossCountry,
  mdiSkiWater,
  mdiSkipBackward,
  mdiSkipBackwardOutline,
  mdiSkipForward,
  mdiSkipForwardOutline,
  mdiSkipNext,
  mdiSkipNextCircle,
  mdiSkipNextCircleOutline,
  mdiSkipNextOutline,
  mdiSkipPrevious,
  mdiSkipPreviousCircle,
  mdiSkipPreviousCircleOutline,
  mdiSkipPreviousOutline,
  mdiSkull,
  mdiSkullCrossbones,
  mdiSkullCrossbonesOutline,
  mdiSkullOutline,
  mdiSkullScan,
  mdiSkullScanOutline,
  mdiSkype,
  mdiSkypeBusiness,
  mdiSlack,
  mdiSlashForward,
  mdiSlashForwardBox,
  mdiSledding,
  mdiSleep,
  mdiSleepOff,
  mdiSlide,
  mdiSlopeDownhill,
  mdiSlopeUphill,
  mdiSlotMachine,
  mdiSlotMachineOutline,
  mdiSmartCard,
  mdiSmartCardOff,
  mdiSmartCardOffOutline,
  mdiSmartCardOutline,
  mdiSmartCardReader,
  mdiSmartCardReaderOutline,
  mdiSmog,
  mdiSmoke,
  mdiSmokeDetector,
  mdiSmokeDetectorAlert,
  mdiSmokeDetectorAlertOutline,
  mdiSmokeDetectorOff,
  mdiSmokeDetectorOffOutline,
  mdiSmokeDetectorOutline,
  mdiSmokeDetectorVariant,
  mdiSmokeDetectorVariantAlert,
  mdiSmokeDetectorVariantOff,
  mdiSmoking,
  mdiSmokingOff,
  mdiSmokingPipe,
  mdiSmokingPipeOff,
  mdiSnail,
  mdiSnake,
  mdiSnapchat,
  mdiSnowboard,
  mdiSnowflake,
  mdiSnowflakeAlert,
  mdiSnowflakeCheck,
  mdiSnowflakeMelt,
  mdiSnowflakeOff,
  mdiSnowflakeThermometer,
  mdiSnowflakeVariant,
  mdiSnowman,
  mdiSnowmobile,
  mdiSnowshoeing,
  mdiSoccer,
  mdiSoccerField,
  mdiSocialDistance2Meters,
  mdiSocialDistance6Feet,
  mdiSofa,
  mdiSofaOutline,
  mdiSofaSingle,
  mdiSofaSingleOutline,
  mdiSolarPanel,
  mdiSolarPanelLarge,
  mdiSolarPower,
  mdiSolarPowerVariant,
  mdiSolarPowerVariantOutline,
  mdiSolderingIron,
  mdiSolid,
  mdiSonyPlaystation,
  mdiSort,
  mdiSortAlphabeticalAscending,
  mdiSortAlphabeticalAscendingVariant,
  mdiSortAlphabeticalDescending,
  mdiSortAlphabeticalDescendingVariant,
  mdiSortAlphabeticalVariant,
  mdiSortAscending,
  mdiSortBoolAscending,
  mdiSortBoolAscendingVariant,
  mdiSortBoolDescending,
  mdiSortBoolDescendingVariant,
  mdiSortCalendarAscending,
  mdiSortCalendarDescending,
  mdiSortClockAscending,
  mdiSortClockAscendingOutline,
  mdiSortClockDescending,
  mdiSortClockDescendingOutline,
  mdiSortDescending,
  mdiSortNumericAscending,
  mdiSortNumericAscendingVariant,
  mdiSortNumericDescending,
  mdiSortNumericDescendingVariant,
  mdiSortNumericVariant,
  mdiSortReverseVariant,
  mdiSortVariant,
  mdiSortVariantLock,
  mdiSortVariantLockOpen,
  mdiSortVariantOff,
  mdiSortVariantRemove,
  mdiSoundbar,
  mdiSoundcloud,
  mdiSourceBranch,
  mdiSourceBranchCheck,
  mdiSourceBranchMinus,
  mdiSourceBranchPlus,
  mdiSourceBranchRefresh,
  mdiSourceBranchRemove,
  mdiSourceBranchSync,
  mdiSourceCommit,
  mdiSourceCommitEnd,
  mdiSourceCommitEndLocal,
  mdiSourceCommitLocal,
  mdiSourceCommitNextLocal,
  mdiSourceCommitStart,
  mdiSourceCommitStartNextLocal,
  mdiSourceFork,
  mdiSourceMerge,
  mdiSourcePull,
  mdiSourceRepository,
  mdiSourceRepositoryMultiple,
  mdiSoySauce,
  mdiSoySauceOff,
  mdiSpa,
  mdiSpaOutline,
  mdiSpaceInvaders,
  mdiSpaceStation,
  mdiSpade,
  mdiSpeaker,
  mdiSpeakerBluetooth,
  mdiSpeakerMessage,
  mdiSpeakerMultiple,
  mdiSpeakerOff,
  mdiSpeakerPause,
  mdiSpeakerPlay,
  mdiSpeakerStop,
  mdiSpeakerWireless,
  mdiSpear,
  mdiSpeedometer,
  mdiSpeedometerMedium,
  mdiSpeedometerSlow,
  mdiSpellcheck,
  mdiSphere,
  mdiSphereOff,
  mdiSpider,
  mdiSpiderOutline,
  mdiSpiderThread,
  mdiSpiderWeb,
  mdiSpiritLevel,
  mdiSpoonSugar,
  mdiSpotify,
  mdiSpotlight,
  mdiSpotlightBeam,
  mdiSpray,
  mdiSprayBottle,
  mdiSprinkler,
  mdiSprinklerFire,
  mdiSprinklerVariant,
  mdiSprout,
  mdiSproutOutline,
  mdiSquare,
  mdiSquareCircle,
  mdiSquareCircleOutline,
  mdiSquareEditOutline,
  mdiSquareMedium,
  mdiSquareMediumOutline,
  mdiSquareOff,
  mdiSquareOffOutline,
  mdiSquareOpacity,
  mdiSquareOutline,
  mdiSquareRoot,
  mdiSquareRootBox,
  mdiSquareRounded,
  mdiSquareRoundedBadge,
  mdiSquareRoundedBadgeOutline,
  mdiSquareRoundedOutline,
  mdiSquareSmall,
  mdiSquareWave,
  mdiSqueegee,
  mdiSsh,
  mdiStackExchange,
  mdiStackOverflow,
  mdiStackpath,
  mdiStadium,
  mdiStadiumOutline,
  mdiStadiumVariant,
  mdiStairs,
  mdiStairsBox,
  mdiStairsDown,
  mdiStairsUp,
  mdiStamper,
  mdiStandardDefinition,
  mdiStar,
  mdiStarBox,
  mdiStarBoxMultiple,
  mdiStarBoxMultipleOutline,
  mdiStarBoxOutline,
  mdiStarCheck,
  mdiStarCheckOutline,
  mdiStarCircle,
  mdiStarCircleOutline,
  mdiStarCog,
  mdiStarCogOutline,
  mdiStarCrescent,
  mdiStarDavid,
  mdiStarFace,
  mdiStarFourPoints,
  mdiStarFourPointsBox,
  mdiStarFourPointsBoxOutline,
  mdiStarFourPointsCircle,
  mdiStarFourPointsCircleOutline,
  mdiStarFourPointsOutline,
  mdiStarFourPointsSmall,
  mdiStarHalf,
  mdiStarHalfFull,
  mdiStarMinus,
  mdiStarMinusOutline,
  mdiStarOff,
  mdiStarOffOutline,
  mdiStarOutline,
  mdiStarPlus,
  mdiStarPlusOutline,
  mdiStarRemove,
  mdiStarRemoveOutline,
  mdiStarSettings,
  mdiStarSettingsOutline,
  mdiStarShooting,
  mdiStarShootingOutline,
  mdiStarThreePoints,
  mdiStarThreePointsOutline,
  mdiStateMachine,
  mdiSteam,
  mdiSteering,
  mdiSteeringOff,
  mdiStepBackward,
  mdiStepBackward2,
  mdiStepForward,
  mdiStepForward2,
  mdiStethoscope,
  mdiSticker,
  mdiStickerAlert,
  mdiStickerAlertOutline,
  mdiStickerCheck,
  mdiStickerCheckOutline,
  mdiStickerCircleOutline,
  mdiStickerEmoji,
  mdiStickerMinus,
  mdiStickerMinusOutline,
  mdiStickerOutline,
  mdiStickerPlus,
  mdiStickerPlusOutline,
  mdiStickerRemove,
  mdiStickerRemoveOutline,
  mdiStickerText,
  mdiStickerTextOutline,
  mdiStocking,
  mdiStomach,
  mdiStool,
  mdiStoolOutline,
  mdiStop,
  mdiStopCircle,
  mdiStopCircleOutline,
  mdiStorageTank,
  mdiStorageTankOutline,
  mdiStore,
  mdiStore24Hour,
  mdiStoreAlert,
  mdiStoreAlertOutline,
  mdiStoreCheck,
  mdiStoreCheckOutline,
  mdiStoreClock,
  mdiStoreClockOutline,
  mdiStoreCog,
  mdiStoreCogOutline,
  mdiStoreEdit,
  mdiStoreEditOutline,
  mdiStoreMarker,
  mdiStoreMarkerOutline,
  mdiStoreMinus,
  mdiStoreMinusOutline,
  mdiStoreOff,
  mdiStoreOffOutline,
  mdiStoreOutline,
  mdiStorePlus,
  mdiStorePlusOutline,
  mdiStoreRemove,
  mdiStoreRemoveOutline,
  mdiStoreSearch,
  mdiStoreSearchOutline,
  mdiStoreSettings,
  mdiStoreSettingsOutline,
  mdiStorefront,
  mdiStorefrontCheck,
  mdiStorefrontCheckOutline,
  mdiStorefrontEdit,
  mdiStorefrontEditOutline,
  mdiStorefrontMinus,
  mdiStorefrontMinusOutline,
  mdiStorefrontOutline,
  mdiStorefrontPlus,
  mdiStorefrontPlusOutline,
  mdiStorefrontRemove,
  mdiStorefrontRemoveOutline,
  mdiStove,
  mdiStrategy,
  mdiStretchToPage,
  mdiStretchToPageOutline,
  mdiStringLights,
  mdiStringLightsOff,
  mdiSubdirectoryArrowLeft,
  mdiSubdirectoryArrowRight,
  mdiSubmarine,
  mdiSubtitles,
  mdiSubtitlesOutline,
  mdiSubway,
  mdiSubwayAlertVariant,
  mdiSubwayVariant,
  mdiSummit,
  mdiSunAngle,
  mdiSunAngleOutline,
  mdiSunClock,
  mdiSunClockOutline,
  mdiSunCompass,
  mdiSunSnowflake,
  mdiSunSnowflakeVariant,
  mdiSunThermometer,
  mdiSunThermometerOutline,
  mdiSunWireless,
  mdiSunWirelessOutline,
  mdiSunglasses,
  mdiSurfing,
  mdiSurroundSound,
  mdiSurroundSound20,
  mdiSurroundSound21,
  mdiSurroundSound31,
  mdiSurroundSound51,
  mdiSurroundSound512,
  mdiSurroundSound71,
  mdiSvg,
  mdiSwapHorizontal,
  mdiSwapHorizontalBold,
  mdiSwapHorizontalCircle,
  mdiSwapHorizontalCircleOutline,
  mdiSwapHorizontalHidden,
  mdiSwapHorizontalVariant,
  mdiSwapVertical,
  mdiSwapVerticalBold,
  mdiSwapVerticalCircle,
  mdiSwapVerticalCircleOutline,
  mdiSwapVerticalVariant,
  mdiSwim,
  mdiSwitch,
  mdiSword,
  mdiSwordCross,
  mdiSyllabaryHangul,
  mdiSyllabaryHiragana,
  mdiSyllabaryKatakana,
  mdiSyllabaryKatakanaHalfwidth,
  mdiSymbol,
  mdiSymfony,
  mdiSynagogue,
  mdiSynagogueOutline,
  mdiSync,
  mdiSyncAlert,
  mdiSyncCircle,
  mdiSyncOff,
  mdiTab,
  mdiTabMinus,
  mdiTabPlus,
  mdiTabRemove,
  mdiTabSearch,
  mdiTabUnselected,
  mdiTable,
  mdiTableAccount,
  mdiTableAlert,
  mdiTableArrowDown,
  mdiTableArrowLeft,
  mdiTableArrowRight,
  mdiTableArrowUp,
  mdiTableBorder,
  mdiTableCancel,
  mdiTableChair,
  mdiTableCheck,
  mdiTableClock,
  mdiTableCog,
  mdiTableColumn,
  mdiTableColumnPlusAfter,
  mdiTableColumnPlusBefore,
  mdiTableColumnRemove,
  mdiTableColumnWidth,
  mdiTableEdit,
  mdiTableEye,
  mdiTableEyeOff,
  mdiTableFilter,
  mdiTableFurniture,
  mdiTableHeadersEye,
  mdiTableHeadersEyeOff,
  mdiTableHeart,
  mdiTableKey,
  mdiTableLarge,
  mdiTableLargePlus,
  mdiTableLargeRemove,
  mdiTableLock,
  mdiTableMergeCells,
  mdiTableMinus,
  mdiTableMultiple,
  mdiTableNetwork,
  mdiTableOfContents,
  mdiTableOff,
  mdiTablePicnic,
  mdiTablePivot,
  mdiTablePlus,
  mdiTableQuestion,
  mdiTableRefresh,
  mdiTableRemove,
  mdiTableRow,
  mdiTableRowHeight,
  mdiTableRowPlusAfter,
  mdiTableRowPlusBefore,
  mdiTableRowRemove,
  mdiTableSearch,
  mdiTableSettings,
  mdiTableSplitCell,
  mdiTableStar,
  mdiTableSync,
  mdiTableTennis,
  mdiTablet,
  mdiTabletCellphone,
  mdiTabletDashboard,
  mdiTaco,
  mdiTag,
  mdiTagArrowDown,
  mdiTagArrowDownOutline,
  mdiTagArrowLeft,
  mdiTagArrowLeftOutline,
  mdiTagArrowRight,
  mdiTagArrowRightOutline,
  mdiTagArrowUp,
  mdiTagArrowUpOutline,
  mdiTagCheck,
  mdiTagCheckOutline,
  mdiTagEdit,
  mdiTagEditOutline,
  mdiTagFaces,
  mdiTagHeart,
  mdiTagHeartOutline,
  mdiTagHidden,
  mdiTagMinus,
  mdiTagMinusOutline,
  mdiTagMultiple,
  mdiTagMultipleOutline,
  mdiTagOff,
  mdiTagOffOutline,
  mdiTagOutline,
  mdiTagPlus,
  mdiTagPlusOutline,
  mdiTagRemove,
  mdiTagRemoveOutline,
  mdiTagSearch,
  mdiTagSearchOutline,
  mdiTagText,
  mdiTagTextOutline,
  mdiTailwind,
  mdiTallyMark1,
  mdiTallyMark2,
  mdiTallyMark3,
  mdiTallyMark4,
  mdiTallyMark5,
  mdiTangram,
  mdiTank,
  mdiTankerTruck,
  mdiTapeDrive,
  mdiTapeMeasure,
  mdiTarget,
  mdiTargetAccount,
  mdiTargetVariant,
  mdiTaxi,
  mdiTea,
  mdiTeaOutline,
  mdiTeamviewer,
  mdiTeddyBear,
  mdiTelescope,
  mdiTelevision,
  mdiTelevisionAmbientLight,
  mdiTelevisionBox,
  mdiTelevisionClassic,
  mdiTelevisionClassicOff,
  mdiTelevisionGuide,
  mdiTelevisionOff,
  mdiTelevisionPause,
  mdiTelevisionPlay,
  mdiTelevisionShimmer,
  mdiTelevisionSpeaker,
  mdiTelevisionSpeakerOff,
  mdiTelevisionStop,
  mdiTemperatureCelsius,
  mdiTemperatureFahrenheit,
  mdiTemperatureKelvin,
  mdiTempleBuddhist,
  mdiTempleBuddhistOutline,
  mdiTempleHindu,
  mdiTempleHinduOutline,
  mdiTennis,
  mdiTennisBall,
  mdiTennisBallOutline,
  mdiTent,
  mdiTerraform,
  mdiTerrain,
  mdiTestTube,
  mdiTestTubeEmpty,
  mdiTestTubeOff,
  mdiText,
  mdiTextAccount,
  mdiTextBox,
  mdiTextBoxCheck,
  mdiTextBoxCheckOutline,
  mdiTextBoxEdit,
  mdiTextBoxEditOutline,
  mdiTextBoxMinus,
  mdiTextBoxMinusOutline,
  mdiTextBoxMultiple,
  mdiTextBoxMultipleOutline,
  mdiTextBoxOutline,
  mdiTextBoxPlus,
  mdiTextBoxPlusOutline,
  mdiTextBoxRemove,
  mdiTextBoxRemoveOutline,
  mdiTextBoxSearch,
  mdiTextBoxSearchOutline,
  mdiTextLong,
  mdiTextRecognition,
  mdiTextSearch,
  mdiTextSearchVariant,
  mdiTextShadow,
  mdiTextShort,
  mdiTexture,
  mdiTextureBox,
  mdiTheater,
  mdiThemeLightDark,
  mdiThermometer,
  mdiThermometerAlert,
  mdiThermometerAuto,
  mdiThermometerBluetooth,
  mdiThermometerCheck,
  mdiThermometerChevronDown,
  mdiThermometerChevronUp,
  mdiThermometerHigh,
  mdiThermometerLines,
  mdiThermometerLow,
  mdiThermometerMinus,
  mdiThermometerOff,
  mdiThermometerPlus,
  mdiThermometerProbe,
  mdiThermometerProbeOff,
  mdiThermometerWater,
  mdiThermostat,
  mdiThermostatAuto,
  mdiThermostatBox,
  mdiThermostatBoxAuto,
  mdiThermostatCog,
  mdiThoughtBubble,
  mdiThoughtBubbleOutline,
  mdiThumbDown,
  mdiThumbDownOutline,
  mdiThumbUp,
  mdiThumbUpOutline,
  mdiThumbsUpDown,
  mdiThumbsUpDownOutline,
  mdiTicket,
  mdiTicketAccount,
  mdiTicketConfirmation,
  mdiTicketConfirmationOutline,
  mdiTicketOutline,
  mdiTicketPercent,
  mdiTicketPercentOutline,
  mdiTie,
  mdiTilde,
  mdiTildeOff,
  mdiTimelapse,
  mdiTimeline,
  mdiTimelineAlert,
  mdiTimelineAlertOutline,
  mdiTimelineCheck,
  mdiTimelineCheckOutline,
  mdiTimelineClock,
  mdiTimelineClockOutline,
  mdiTimelineMinus,
  mdiTimelineMinusOutline,
  mdiTimelineOutline,
  mdiTimelinePlus,
  mdiTimelinePlusOutline,
  mdiTimelineQuestion,
  mdiTimelineQuestionOutline,
  mdiTimelineRemove,
  mdiTimelineRemoveOutline,
  mdiTimelineText,
  mdiTimelineTextOutline,
  mdiTimer,
  mdiTimer10,
  mdiTimer3,
  mdiTimerAlert,
  mdiTimerAlertOutline,
  mdiTimerCancel,
  mdiTimerCancelOutline,
  mdiTimerCheck,
  mdiTimerCheckOutline,
  mdiTimerCog,
  mdiTimerCogOutline,
  mdiTimerEdit,
  mdiTimerEditOutline,
  mdiTimerLock,
  mdiTimerLockOpen,
  mdiTimerLockOpenOutline,
  mdiTimerLockOutline,
  mdiTimerMarker,
  mdiTimerMarkerOutline,
  mdiTimerMinus,
  mdiTimerMinusOutline,
  mdiTimerMusic,
  mdiTimerMusicOutline,
  mdiTimerOff,
  mdiTimerOffOutline,
  mdiTimerOutline,
  mdiTimerPause,
  mdiTimerPauseOutline,
  mdiTimerPlay,
  mdiTimerPlayOutline,
  mdiTimerPlus,
  mdiTimerPlusOutline,
  mdiTimerRefresh,
  mdiTimerRefreshOutline,
  mdiTimerRemove,
  mdiTimerRemoveOutline,
  mdiTimerSand,
  mdiTimerSandComplete,
  mdiTimerSandEmpty,
  mdiTimerSandFull,
  mdiTimerSandPaused,
  mdiTimerSettings,
  mdiTimerSettingsOutline,
  mdiTimerStar,
  mdiTimerStarOutline,
  mdiTimerStop,
  mdiTimerStopOutline,
  mdiTimerSync,
  mdiTimerSyncOutline,
  mdiTimetable,
  mdiTire,
  mdiToaster,
  mdiToasterOff,
  mdiToasterOven,
  mdiToggleSwitch,
  mdiToggleSwitchOff,
  mdiToggleSwitchOffOutline,
  mdiToggleSwitchOutline,
  mdiToggleSwitchVariant,
  mdiToggleSwitchVariantOff,
  mdiToilet,
  mdiToolbox,
  mdiToolboxOutline,
  mdiTools,
  mdiTooltip,
  mdiTooltipAccount,
  mdiTooltipCellphone,
  mdiTooltipCheck,
  mdiTooltipCheckOutline,
  mdiTooltipEdit,
  mdiTooltipEditOutline,
  mdiTooltipImage,
  mdiTooltipImageOutline,
  mdiTooltipMinus,
  mdiTooltipMinusOutline,
  mdiTooltipOutline,
  mdiTooltipPlus,
  mdiTooltipPlusOutline,
  mdiTooltipQuestion,
  mdiTooltipQuestionOutline,
  mdiTooltipRemove,
  mdiTooltipRemoveOutline,
  mdiTooltipText,
  mdiTooltipTextOutline,
  mdiTooth,
  mdiToothOutline,
  mdiToothbrush,
  mdiToothbrushElectric,
  mdiToothbrushPaste,
  mdiTorch,
  mdiTortoise,
  mdiToslink,
  mdiTouchTextOutline,
  mdiTournament,
  mdiTowTruck,
  mdiTowerBeach,
  mdiTowerFire,
  mdiTownHall,
  mdiToyBrick,
  mdiToyBrickMarker,
  mdiToyBrickMarkerOutline,
  mdiToyBrickMinus,
  mdiToyBrickMinusOutline,
  mdiToyBrickOutline,
  mdiToyBrickPlus,
  mdiToyBrickPlusOutline,
  mdiToyBrickRemove,
  mdiToyBrickRemoveOutline,
  mdiToyBrickSearch,
  mdiToyBrickSearchOutline,
  mdiTrackLight,
  mdiTrackLightOff,
  mdiTrackpad,
  mdiTrackpadLock,
  mdiTractor,
  mdiTractorVariant,
  mdiTrademark,
  mdiTrafficCone,
  mdiTrafficLight,
  mdiTrafficLightOutline,
  mdiTrain,
  mdiTrainBus,
  mdiTrainCar,
  mdiTrainCarAutorack,
  mdiTrainCarBox,
  mdiTrainCarBoxFull,
  mdiTrainCarBoxOpen,
  mdiTrainCarCaboose,
  mdiTrainCarCenterbeam,
  mdiTrainCarCenterbeamFull,
  mdiTrainCarContainer,
  mdiTrainCarFlatbed,
  mdiTrainCarFlatbedCar,
  mdiTrainCarFlatbedTank,
  mdiTrainCarGondola,
  mdiTrainCarGondolaFull,
  mdiTrainCarHopper,
  mdiTrainCarHopperCovered,
  mdiTrainCarHopperFull,
  mdiTrainCarIntermodal,
  mdiTrainCarPassenger,
  mdiTrainCarPassengerDoor,
  mdiTrainCarPassengerDoorOpen,
  mdiTrainCarPassengerVariant,
  mdiTrainCarTank,
  mdiTrainVariant,
  mdiTram,
  mdiTramSide,
  mdiTranscribe,
  mdiTranscribeClose,
  mdiTransfer,
  mdiTransferDown,
  mdiTransferLeft,
  mdiTransferRight,
  mdiTransferUp,
  mdiTransitConnection,
  mdiTransitConnectionHorizontal,
  mdiTransitConnectionVariant,
  mdiTransitDetour,
  mdiTransitSkip,
  mdiTransitTransfer,
  mdiTransition,
  mdiTransitionMasked,
  mdiTranslate,
  mdiTranslateOff,
  mdiTranslateVariant,
  mdiTransmissionTower,
  mdiTransmissionTowerExport,
  mdiTransmissionTowerImport,
  mdiTransmissionTowerOff,
  mdiTrashCan,
  mdiTrashCanOutline,
  mdiTray,
  mdiTrayAlert,
  mdiTrayArrowDown,
  mdiTrayArrowUp,
  mdiTrayFull,
  mdiTrayMinus,
  mdiTrayPlus,
  mdiTrayRemove,
  mdiTreasureChest,
  mdiTreasureChestOutline,
  mdiTree,
  mdiTreeOutline,
  mdiTrello,
  mdiTrendingDown,
  mdiTrendingNeutral,
  mdiTrendingUp,
  mdiTriangle,
  mdiTriangleDown,
  mdiTriangleDownOutline,
  mdiTriangleOutline,
  mdiTriangleSmallDown,
  mdiTriangleSmallUp,
  mdiTriangleWave,
  mdiTriforce,
  mdiTrophy,
  mdiTrophyAward,
  mdiTrophyBroken,
  mdiTrophyOutline,
  mdiTrophyVariant,
  mdiTrophyVariantOutline,
  mdiTruck,
  mdiTruckAlert,
  mdiTruckAlertOutline,
  mdiTruckCargoContainer,
  mdiTruckCheck,
  mdiTruckCheckOutline,
  mdiTruckDelivery,
  mdiTruckDeliveryOutline,
  mdiTruckFast,
  mdiTruckFastOutline,
  mdiTruckFlatbed,
  mdiTruckMinus,
  mdiTruckMinusOutline,
  mdiTruckOffRoad,
  mdiTruckOffRoadOff,
  mdiTruckOutline,
  mdiTruckPlus,
  mdiTruckPlusOutline,
  mdiTruckRemove,
  mdiTruckRemoveOutline,
  mdiTruckSnowflake,
  mdiTruckTrailer,
  mdiTrumpet,
  mdiTshirtCrew,
  mdiTshirtCrewOutline,
  mdiTshirtV,
  mdiTshirtVOutline,
  mdiTsunami,
  mdiTumbleDryer,
  mdiTumbleDryerAlert,
  mdiTumbleDryerOff,
  mdiTune,
  mdiTuneVariant,
  mdiTuneVertical,
  mdiTuneVerticalVariant,
  mdiTunnel,
  mdiTunnelOutline,
  mdiTurbine,
  mdiTurkey,
  mdiTurnstile,
  mdiTurnstileOutline,
  mdiTurtle,
  mdiTwitch,
  mdiTwitter,
  mdiTwoFactorAuthentication,
  mdiTypewriter,
  mdiUbisoft,
  mdiUbuntu,
  mdiUfo,
  mdiUfoOutline,
  mdiUltraHighDefinition,
  mdiUmbraco,
  mdiUmbrella,
  mdiUmbrellaBeach,
  mdiUmbrellaBeachOutline,
  mdiUmbrellaClosed,
  mdiUmbrellaClosedOutline,
  mdiUmbrellaClosedVariant,
  mdiUmbrellaOutline,
  mdiUnderwearOutline,
  mdiUndo,
  mdiUndoVariant,
  mdiUnfoldLessHorizontal,
  mdiUnfoldLessVertical,
  mdiUnfoldMoreHorizontal,
  mdiUnfoldMoreVertical,
  mdiUngroup,
  mdiUnicode,
  mdiUnicorn,
  mdiUnicornVariant,
  mdiUnicycle,
  mdiUnity,
  mdiUnreal,
  mdiUpdate,
  mdiUpload,
  mdiUploadBox,
  mdiUploadBoxOutline,
  mdiUploadCircle,
  mdiUploadCircleOutline,
  mdiUploadLock,
  mdiUploadLockOutline,
  mdiUploadMultiple,
  mdiUploadMultipleOutline,
  mdiUploadNetwork,
  mdiUploadNetworkOutline,
  mdiUploadOff,
  mdiUploadOffOutline,
  mdiUploadOutline,
  mdiUsb,
  mdiUsbCPort,
  mdiUsbFlashDrive,
  mdiUsbFlashDriveOutline,
  mdiUsbPort,
  mdiVacuum,
  mdiVacuumOutline,
  mdiValve,
  mdiValveClosed,
  mdiValveOpen,
  mdiVanPassenger,
  mdiVanUtility,
  mdiVanish,
  mdiVanishQuarter,
  mdiVanityLight,
  mdiVariable,
  mdiVariableBox,
  mdiVectorArrangeAbove,
  mdiVectorArrangeBelow,
  mdiVectorBezier,
  mdiVectorCircle,
  mdiVectorCircleVariant,
  mdiVectorCombine,
  mdiVectorCurve,
  mdiVectorDifference,
  mdiVectorDifferenceAb,
  mdiVectorDifferenceBa,
  mdiVectorEllipse,
  mdiVectorIntersection,
  mdiVectorLine,
  mdiVectorLink,
  mdiVectorPoint,
  mdiVectorPointEdit,
  mdiVectorPointMinus,
  mdiVectorPointPlus,
  mdiVectorPointSelect,
  mdiVectorPolygon,
  mdiVectorPolygonVariant,
  mdiVectorPolyline,
  mdiVectorPolylineEdit,
  mdiVectorPolylineMinus,
  mdiVectorPolylinePlus,
  mdiVectorPolylineRemove,
  mdiVectorRadius,
  mdiVectorRectangle,
  mdiVectorSelection,
  mdiVectorSquare,
  mdiVectorSquareClose,
  mdiVectorSquareEdit,
  mdiVectorSquareMinus,
  mdiVectorSquareOpen,
  mdiVectorSquarePlus,
  mdiVectorSquareRemove,
  mdiVectorTriangle,
  mdiVectorUnion,
  mdiVhs,
  mdiVibrate,
  mdiVibrateOff,
  mdiVideo,
  mdiVideo2d,
  mdiVideo3d,
  mdiVideo3dOff,
  mdiVideo3dVariant,
  mdiVideo4kBox,
  mdiVideoAccount,
  mdiVideoBox,
  mdiVideoBoxOff,
  mdiVideoCheck,
  mdiVideoCheckOutline,
  mdiVideoHighDefinition,
  mdiVideoImage,
  mdiVideoInputAntenna,
  mdiVideoInputComponent,
  mdiVideoInputHdmi,
  mdiVideoInputScart,
  mdiVideoInputSvideo,
  mdiVideoMarker,
  mdiVideoMarkerOutline,
  mdiVideoMinus,
  mdiVideoMinusOutline,
  mdiVideoOff,
  mdiVideoOffOutline,
  mdiVideoOutline,
  mdiVideoPlus,
  mdiVideoPlusOutline,
  mdiVideoStabilization,
  mdiVideoStandardDefinition,
  mdiVideoSwitch,
  mdiVideoSwitchOutline,
  mdiVideoVintage,
  mdiVideoWireless,
  mdiVideoWirelessOutline,
  mdiViewAgenda,
  mdiViewAgendaOutline,
  mdiViewArray,
  mdiViewArrayOutline,
  mdiViewCarousel,
  mdiViewCarouselOutline,
  mdiViewColumn,
  mdiViewColumnOutline,
  mdiViewComfy,
  mdiViewComfyOutline,
  mdiViewCompact,
  mdiViewCompactOutline,
  mdiViewDashboard,
  mdiViewDashboardEdit,
  mdiViewDashboardEditOutline,
  mdiViewDashboardOutline,
  mdiViewDashboardVariant,
  mdiViewDashboardVariantOutline,
  mdiViewDay,
  mdiViewDayOutline,
  mdiViewGallery,
  mdiViewGalleryOutline,
  mdiViewGrid,
  mdiViewGridCompact,
  mdiViewGridOutline,
  mdiViewGridPlus,
  mdiViewGridPlusOutline,
  mdiViewHeadline,
  mdiViewList,
  mdiViewListOutline,
  mdiViewModule,
  mdiViewModuleOutline,
  mdiViewParallel,
  mdiViewParallelOutline,
  mdiViewQuilt,
  mdiViewQuiltOutline,
  mdiViewSequential,
  mdiViewSequentialOutline,
  mdiViewSplitHorizontal,
  mdiViewSplitVertical,
  mdiViewStream,
  mdiViewStreamOutline,
  mdiViewWeek,
  mdiViewWeekOutline,
  mdiVimeo,
  mdiViolin,
  mdiVirtualReality,
  mdiVirus,
  mdiVirusOff,
  mdiVirusOffOutline,
  mdiVirusOutline,
  mdiVlc,
  mdiVoicemail,
  mdiVolcano,
  mdiVolcanoOutline,
  mdiVolleyball,
  mdiVolumeEqual,
  mdiVolumeHigh,
  mdiVolumeLow,
  mdiVolumeMedium,
  mdiVolumeMinus,
  mdiVolumeMute,
  mdiVolumeOff,
  mdiVolumePlus,
  mdiVolumeSource,
  mdiVolumeVariantOff,
  mdiVolumeVibrate,
  mdiVote,
  mdiVoteOutline,
  mdiVpn,
  mdiVuejs,
  mdiVuetify,
  mdiWalk,
  mdiWall,
  mdiWallFire,
  mdiWallSconce,
  mdiWallSconceFlat,
  mdiWallSconceFlatOutline,
  mdiWallSconceFlatVariant,
  mdiWallSconceFlatVariantOutline,
  mdiWallSconceOutline,
  mdiWallSconceRound,
  mdiWallSconceRoundOutline,
  mdiWallSconceRoundVariant,
  mdiWallSconceRoundVariantOutline,
  mdiWallet,
  mdiWalletBifold,
  mdiWalletBifoldOutline,
  mdiWalletGiftcard,
  mdiWalletMembership,
  mdiWalletOutline,
  mdiWalletPlus,
  mdiWalletPlusOutline,
  mdiWalletTravel,
  mdiWallpaper,
  mdiWan,
  mdiWardrobe,
  mdiWardrobeOutline,
  mdiWarehouse,
  mdiWashingMachine,
  mdiWashingMachineAlert,
  mdiWashingMachineOff,
  mdiWatch,
  mdiWatchExport,
  mdiWatchExportVariant,
  mdiWatchImport,
  mdiWatchImportVariant,
  mdiWatchVariant,
  mdiWatchVibrate,
  mdiWatchVibrateOff,
  mdiWater,
  mdiWaterAlert,
  mdiWaterAlertOutline,
  mdiWaterBoiler,
  mdiWaterBoilerAlert,
  mdiWaterBoilerAuto,
  mdiWaterBoilerOff,
  mdiWaterCheck,
  mdiWaterCheckOutline,
  mdiWaterCircle,
  mdiWaterMinus,
  mdiWaterMinusOutline,
  mdiWaterOff,
  mdiWaterOffOutline,
  mdiWaterOpacity,
  mdiWaterOutline,
  mdiWaterPercent,
  mdiWaterPercentAlert,
  mdiWaterPlus,
  mdiWaterPlusOutline,
  mdiWaterPolo,
  mdiWaterPump,
  mdiWaterPumpOff,
  mdiWaterRemove,
  mdiWaterRemoveOutline,
  mdiWaterSync,
  mdiWaterThermometer,
  mdiWaterThermometerOutline,
  mdiWaterWell,
  mdiWaterWellOutline,
  mdiWaterfall,
  mdiWateringCan,
  mdiWateringCanOutline,
  mdiWatermark,
  mdiWave,
  mdiWaveArrowDown,
  mdiWaveArrowUp,
  mdiWaveUndercurrent,
  mdiWaveform,
  mdiWaves,
  mdiWavesArrowLeft,
  mdiWavesArrowRight,
  mdiWavesArrowUp,
  mdiWaze,
  mdiWeatherCloudy,
  mdiWeatherCloudyAlert,
  mdiWeatherCloudyArrowRight,
  mdiWeatherCloudyClock,
  mdiWeatherDust,
  mdiWeatherFog,
  mdiWeatherHail,
  mdiWeatherHazy,
  mdiWeatherHurricane,
  mdiWeatherHurricaneOutline,
  mdiWeatherLightning,
  mdiWeatherLightningRainy,
  mdiWeatherMoonset,
  mdiWeatherMoonsetDown,
  mdiWeatherMoonsetUp,
  mdiWeatherNight,
  mdiWeatherNightPartlyCloudy,
  mdiWeatherPartlyCloudy,
  mdiWeatherPartlyLightning,
  mdiWeatherPartlyRainy,
  mdiWeatherPartlySnowy,
  mdiWeatherPartlySnowyRainy,
  mdiWeatherPouring,
  mdiWeatherRainy,
  mdiWeatherSnowy,
  mdiWeatherSnowyHeavy,
  mdiWeatherSnowyRainy,
  mdiWeatherSunny,
  mdiWeatherSunnyAlert,
  mdiWeatherSunnyOff,
  mdiWeatherSunset,
  mdiWeatherSunsetDown,
  mdiWeatherSunsetUp,
  mdiWeatherTornado,
  mdiWeatherWindy,
  mdiWeatherWindyVariant,
  mdiWeb,
  mdiWebBox,
  mdiWebCancel,
  mdiWebCheck,
  mdiWebClock,
  mdiWebMinus,
  mdiWebOff,
  mdiWebPlus,
  mdiWebRefresh,
  mdiWebRemove,
  mdiWebSync,
  mdiWebcam,
  mdiWebcamOff,
  mdiWebhook,
  mdiWebpack,
  mdiWebrtc,
  mdiWechat,
  mdiWeight,
  mdiWeightGram,
  mdiWeightKilogram,
  mdiWeightLifter,
  mdiWeightPound,
  mdiWhatsapp,
  mdiWheelBarrow,
  mdiWheelchair,
  mdiWheelchairAccessibility,
  mdiWhistle,
  mdiWhistleOutline,
  mdiWhiteBalanceAuto,
  mdiWhiteBalanceIncandescent,
  mdiWhiteBalanceIridescent,
  mdiWhiteBalanceSunny,
  mdiWidgets,
  mdiWidgetsOutline,
  mdiWifi,
  mdiWifiAlert,
  mdiWifiArrowDown,
  mdiWifiArrowLeft,
  mdiWifiArrowLeftRight,
  mdiWifiArrowRight,
  mdiWifiArrowUp,
  mdiWifiArrowUpDown,
  mdiWifiCancel,
  mdiWifiCheck,
  mdiWifiCog,
  mdiWifiLock,
  mdiWifiLockOpen,
  mdiWifiMarker,
  mdiWifiMinus,
  mdiWifiOff,
  mdiWifiPlus,
  mdiWifiRefresh,
  mdiWifiRemove,
  mdiWifiSettings,
  mdiWifiStar,
  mdiWifiStrength1,
  mdiWifiStrength1Alert,
  mdiWifiStrength1Lock,
  mdiWifiStrength1LockOpen,
  mdiWifiStrength2,
  mdiWifiStrength2Alert,
  mdiWifiStrength2Lock,
  mdiWifiStrength2LockOpen,
  mdiWifiStrength3,
  mdiWifiStrength3Alert,
  mdiWifiStrength3Lock,
  mdiWifiStrength3LockOpen,
  mdiWifiStrength4,
  mdiWifiStrength4Alert,
  mdiWifiStrength4Lock,
  mdiWifiStrength4LockOpen,
  mdiWifiStrengthAlertOutline,
  mdiWifiStrengthLockOpenOutline,
  mdiWifiStrengthLockOutline,
  mdiWifiStrengthOff,
  mdiWifiStrengthOffOutline,
  mdiWifiStrengthOutline,
  mdiWifiSync,
  mdiWikipedia,
  mdiWindPower,
  mdiWindPowerOutline,
  mdiWindTurbine,
  mdiWindTurbineAlert,
  mdiWindTurbineCheck,
  mdiWindowClose,
  mdiWindowClosed,
  mdiWindowClosedVariant,
  mdiWindowMaximize,
  mdiWindowMinimize,
  mdiWindowOpen,
  mdiWindowOpenVariant,
  mdiWindowRestore,
  mdiWindowShutter,
  mdiWindowShutterAlert,
  mdiWindowShutterAuto,
  mdiWindowShutterCog,
  mdiWindowShutterOpen,
  mdiWindowShutterSettings,
  mdiWindsock,
  mdiWiper,
  mdiWiperWash,
  mdiWiperWashAlert,
  mdiWizardHat,
  mdiWordpress,
  mdiWrap,
  mdiWrapDisabled,
  mdiWrench,
  mdiWrenchCheck,
  mdiWrenchCheckOutline,
  mdiWrenchClock,
  mdiWrenchClockOutline,
  mdiWrenchCog,
  mdiWrenchCogOutline,
  mdiWrenchOutline,
  mdiXamarin,
  mdiXml,
  mdiXmpp,
  mdiYahoo,
  mdiYeast,
  mdiYinYang,
  mdiYoga,
  mdiYoutube,
  mdiYoutubeGaming,
  mdiYoutubeStudio,
  mdiYoutubeSubscription,
  mdiYoutubeTv,
  mdiYurt,
  mdiZWave,
  mdiZend,
  mdiZigbee,
  mdiZipBox,
  mdiZipBoxOutline,
  mdiZipDisk,
  mdiZodiacAquarius,
  mdiZodiacAries,
  mdiZodiacCancer,
  mdiZodiacCapricorn,
  mdiZodiacGemini,
  mdiZodiacLeo,
  mdiZodiacLibra,
  mdiZodiacPisces,
  mdiZodiacSagittarius,
  mdiZodiacScorpio,
  mdiZodiacTaurus,
  mdiZodiacVirgo
}, Symbol.toStringTag, { value: "Module" }));
function createBackground(type, color2 = "#FFFFFF", scale = 1) {
  switch (type) {
    case "circle":
      return `<circle cx='${12 * scale}' cy='${12 * scale}' r='${11.5 * scale}' fill='${color2}' />`;
    case "rect":
      return `<rect x='${1 * scale}' y='${1 * scale}' width='${22 * scale}' height='${22 * scale}' fill='${color2}' />`;
    case "triangle":
      return `<polygon points='${12 * scale},${1 * scale} ${23 * scale},${23 * scale} ${1 * scale},${23 * scale}' style='fill:${color2}' />`;
    case "invertedTriangle":
      return `<polygon points='${1 * scale},${1 * scale} ${23 * scale},${1 * scale} ${12 * scale},${23 * scale}' style='fill:${color2}' />`;
    case "rhombus":
      return `<polygon points='${12 * scale},${1 * scale} ${23 * scale},${12 * scale} ${12 * scale},${23 * scale} ${1 * scale},${12 * scale}' style='fill:${color2}' />`;
    default:
      return "";
  }
}
function createSvgTag(iconId, scale = 1, overrideColorHex) {
  let iconParams = iconId.split("-");
  if (overrideColorHex) {
    iconParams[1] = overrideColorHex;
  }
  return `<svg width="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${24 * scale} ${24 * scale}">
    ${createBackground(iconParams[2] || "", iconParams[3] || "#FFFFFF", scale)}
    ${scale !== 1 ? "<g transform='scale(" + scale + ")'>" : ""}
    <path fill='${iconParams[1]}' d="${icons[iconParams[0]]}"></path>
    ${scale !== 1 ? "</g>" : ""}
  </svg>`;
}
function createDefaultSvgTag(color2, scale = 1) {
  return `<svg width="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${40 * scale} ${40 * scale}">
    <circle cx='${20 * scale}' cy='${20 * scale}' r='${20 * scale}' fill='white' />
    <circle cx='${20 * scale}' cy='${20 * scale}' r='${13 * scale}' stroke='${color2}' stroke-width='${9 * scale}px' fill='white' />
  </svg>`;
}
function createSweepSvgTag(icon, bgColor, scale = 1) {
  const iconTag = icon ? `<path fill='${icon.color}' d="${icons[icon.id]}"></path>` : "";
  return `<svg width="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${24 * scale} ${24 * scale}">
    <circle cx='${12 * scale}' cy='${12 * scale}' r='${12 * scale}' fill='${bgColor}' />
    ${scale !== 1 ? "<g transform='scale(" + scale + ")'>" : ""}
    ${iconTag}
    ${scale !== 1 ? "</g>" : ""}
  </svg>`;
}
function createDefaultSweepSvgTag(scale = 1) {
  return `<svg width="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${40 * scale} ${40 * scale}">
    <circle cx='${20 * scale}' cy='${20 * scale}' r='${17 * scale}' stroke='#FFFFFF77' stroke-width='${6 * scale}px' fill='transparent' />
  </svg>`;
}
const SVG = { createDefaultSvgTag, createDefaultSweepSvgTag, createSvgTag, createSweepSvgTag };
function applyData(sdk) {
  return __async(this, null, function* () {
    var _a2, _b2, _c, _d2, _e;
    const store = useDpmStore();
    const enableExtension = store.global.enableExtensions.mattertag;
    for (const tag of store.SED.mattertags) {
      (_a2 = tag.stemVector) != null ? _a2 : tag.stemVector = { x: 0, y: 0, z: 0 };
      (_b2 = tag.stemHeight) != null ? _b2 : tag.stemHeight = 0.3;
      (_c = tag.stemVisible) != null ? _c : tag.stemVisible = true;
      if (tag.anchorPosition && !Object.keys(store.global.mattertags).includes(tag.sid)) {
        if (tag.hasOwnProperty("notes") && document.getElementById("showcase").dataset.showNotes !== "true") {
          continue;
        }
        if (store.global.displayedMattertagSids.includes(tag.sid)) {
          yield sdk.Tag.editPosition(tag.sid, {
            anchorPosition: tag.anchorPosition,
            stemVector: tag.stemVector
          });
        } else {
          yield sdk.Tag.add({
            id: tag.sid,
            label: tag.label,
            description: tag.description,
            anchorPosition: tag.anchorPosition,
            stemVector: tag.stemVector,
            color: tag.icon.color
          }).catch((_err) => console.error("DPM: add tag error", _err));
        }
        yield sdk.Tag.editStem(tag.sid, { stemHeight: tag.stemHeight, stemVisible: tag.stemVisible });
      } else if (tag.anchorPosition && Object.keys(store.global.mattertags).includes(tag.sid)) {
        yield sdk.Tag.editPosition(tag.sid, {
          anchorPosition: tag.anchorPosition,
          stemVector: tag.stemVector
        });
        if (tag.stemHeight) {
          yield sdk.Tag.editStem(tag.sid, { stemHeight: tag.stemHeight, stemVisible: tag.stemVisible });
        }
      }
    }
    if (enableExtension && store.SED.mattertags) {
      for (let data of store.SED.mattertags) {
        if (data.description || data.label) {
          yield sdk.Tag.editBillboard(data.sid, {
            description: data.description || ((_d2 = store.global.mattertags[data.sid]) == null ? void 0 : _d2.description) || "",
            label: data.label || ((_e = store.global.mattertags[data.sid]) == null ? void 0 : _e.label) || ""
          }).catch((_err) => console.error("DPM: edit billboard error", _err));
        }
      }
    }
    yield Promise.all(
      Object.keys(store.global.mattertags).map(
        (sid) => applyTag(sdk, store, sid)
      )
    );
    yield Promise.all(
      store.SED.mattertags.filter((mattertag) => !store.global.mattertags[mattertag.sid]).map(
        (mattertag) => applyTag(sdk, store, mattertag.sid)
      )
    );
  });
}
function registerIconWithUrl(sdk, store, sid, data) {
  return __async(this, null, function* () {
    var _a2;
    let url = data.url;
    if (url.indexOf("active_storage") !== -1) {
      const res = yield store.getMediaUrl("mattertag_icon_images", url.split(":")[1]);
      if ((_a2 = res == null ? void 0 : res.data) == null ? void 0 : _a2.url) {
        url = res.data.url;
      }
    }
    yield sdk.Asset.registerTexture(data.id, url).catch((_err) => {
      console.error("DPM: register icon error", _err);
    });
    yield sdk.Tag.editIcon(sid, data.id).catch((_err) => {
      console.error("DPM: edit icon error", _err);
    });
  });
}
function registerIcon(sdk, store, sid, data, customColor) {
  return __async(this, null, function* () {
    let svg = null;
    if (store.isOverride(sid, data.id.split("-"))) {
      svg = yield svgToPng(SVG.createSvgTag(data.id, 1, toHex(customColor)));
    } else {
      svg = yield svgToPng(SVG.createSvgTag(data.id));
    }
    const timestamp = Date.now();
    yield sdk.Asset.registerTexture(`${data.id}-${timestamp}`, svg).catch((_err) => {
      console.error("DPM: register icon error", _err);
    });
    yield sdk.Tag.editIcon(sid, `${data.id}-${timestamp}`).catch((_err) => {
      console.error("DPM: edit icon error", _err);
    });
  });
}
function applyTag(sdk, store, sid) {
  return __async(this, null, function* () {
    var _a2;
    const customIconData = (_a2 = store.SED.mattertags.find((data) => data.sid === sid)) == null ? void 0 : _a2.icon;
    const customColor = store.getCustomColor(sid, customIconData);
    const style2 = store.determineTagStyle(sid, customIconData, customColor);
    switch (style2.type) {
      case "groupUrl":
        yield registerIconWithUrl(sdk, store, sid, style2.target);
        break;
      case "groupId":
        yield registerIcon(sdk, store, sid, style2.target, customColor);
        break;
      case "customUrl":
        yield registerIconWithUrl(sdk, store, sid, style2.target);
        break;
      case "customId":
        yield registerIcon(sdk, store, sid, style2.target, customColor);
        break;
      case "groupColor":
      case "fallbackColor":
        yield sdk.Tag.editColor(sid, customColor).catch((_err) => {
        });
        break;
    }
  });
}
function svgToPng(svgText, width = 150, height = 150) {
  return __async(this, null, function* () {
    const svgBlob = new Blob([svgText], { type: "image/svg+xml" });
    const url = URL.createObjectURL(svgBlob);
    const img = new Image();
    img.src = url;
    yield img.decode();
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);
    URL.revokeObjectURL(url);
    return canvas.toDataURL("image/png");
  });
}
const editShowcase = { applyData };
const getMediaHtml = (_0, _1, ..._2) => __async(void 0, [_0, _1, ..._2], function* (url, type, options = { autoPlay: false, miniPlayer: false }) {
  const wrapIframeHtml = (src, height2, style2 = "") => {
    return `<iframe width="100%" height="${height2}" scrolling="no" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" src="${src}" ${style2}></iframe>`;
  };
  let height = options.miniPlayer ? "100" : "200";
  switch (true) {
    case /youtu\.be|youtube\.com/.test(url):
      let id = "";
      let match = url.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^\/\?&]{10,12})/);
      if (match) {
        id = match[1];
      } else {
        match = url.match(/[&?]v=([a-z0-9_]+)/i);
        if (match) {
          id = match[1];
        } else {
          return { error: "対応していないメディアURLです。URLを確認・変更するか開発者に連絡をしてください。" };
        }
      }
      return { html: wrapIframeHtml(`https://www.youtube.com/embed/${id}?autoplay=${options.autoPlay}`, height), type: "html-iframe-youtube" };
    case /vimeo\.com/.test(url):
      return { html: wrapIframeHtml(`https://player.vimeo.com/video/${url.split("/").slice(-1)[0]}?autoplay=${options.autoPlay}`, height), type: "html-iframe-vimeo" };
    case /soundcloud\.com/.test(url):
      return { html: wrapIframeHtml(`https://w.soundcloud.com/player/?url=${url}&auto_play=${options.autoPlay}&hide_related=true&visual=${!options.miniPlayer}`, height), type: "html-iframe-soundcloud" };
    default:
      switch (type) {
        case "tag.attachment.video":
          return { html: `<video class='w-100' src='${url}' controls ${options.autoPlay ? "autoplay" : ""}></video>`, type: "html-video" };
        case "video":
          return { html: `<video class='w-100' src='${url}' controls ${options.autoPlay ? "autoplay" : ""}></video>`, type: "html-video" };
        case "tag.attachment.audio":
          return { html: `<audio class='w-100' src='${url}' loop controls ${options.autoPlay ? "autoplay" : ""}></audio>`, type: "html-audio" };
        case "audio":
          return { html: `<audio class='' src='${url}' loop controls ${options.autoPlay ? "autoplay" : ""}></audio>`, type: "html-audio" };
        default:
          if (/\.pdf/.test(url)) {
            return {
              html: wrapIframeHtml(
                `/pdfjs-2.13.216-dist/web/viewer.html?file=${encodeURIComponent(decodeURIComponent(url))}`,
                "404",
                'style="min-width:320px; border: #00000017 1px solid; border-radius: 6px;"'
              ),
              type: "html-iframe-pdf"
            };
          } else {
            return { html: wrapIframeHtml(url, height), type: "html-iframe-unknown" };
          }
      }
  }
});
const saveJsonToFile = (data, filename = "scene.json") => {
  const blob = new Blob([data], { type: "text/plain;charset=utf-8" });
  saveBlob(blob, filename);
};
function saveBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}
var lib$5 = {};
var Parser$5 = {};
var Tokenizer$3 = {};
var decode = {};
var decodeDataHtml = {};
Object.defineProperty(decodeDataHtml, "__esModule", { value: true });
decodeDataHtml.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(c) {
    return c.charCodeAt(0);
  })
);
var decodeDataXml = {};
Object.defineProperty(decodeDataXml, "__esModule", { value: true });
decodeDataXml.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(c) {
    return c.charCodeAt(0);
  })
);
var decode_codepoint = {};
(function(exports) {
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.replaceCodePoint = exports.fromCodePoint = void 0;
  var decodeMap = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (_a2 = String.fromCodePoint) !== null && _a2 !== void 0 ? _a2 : function(codePoint) {
    var output = "";
    if (codePoint > 65535) {
      codePoint -= 65536;
      output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
      codePoint = 56320 | codePoint & 1023;
    }
    output += String.fromCharCode(codePoint);
    return output;
  };
  function replaceCodePoint(codePoint) {
    var _a3;
    if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
      return 65533;
    }
    return (_a3 = decodeMap.get(codePoint)) !== null && _a3 !== void 0 ? _a3 : codePoint;
  }
  exports.replaceCodePoint = replaceCodePoint;
  function decodeCodePoint(codePoint) {
    return (0, exports.fromCodePoint)(replaceCodePoint(codePoint));
  }
  exports.default = decodeCodePoint;
})(decode_codepoint);
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod) {
    if (mod && mod.__esModule)
      return mod;
    var result2 = {};
    if (mod != null) {
      for (var k in mod)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding2(result2, mod, k);
    }
    __setModuleDefault2(result2, mod);
    return result2;
  };
  var __importDefault2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.decodeXML = exports.decodeHTMLStrict = exports.decodeHTMLAttribute = exports.decodeHTML = exports.determineBranch = exports.EntityDecoder = exports.DecodingMode = exports.BinTrieFlags = exports.fromCodePoint = exports.replaceCodePoint = exports.decodeCodePoint = exports.xmlDecodeTree = exports.htmlDecodeTree = void 0;
  var decode_data_html_js_1 = __importDefault2(decodeDataHtml);
  exports.htmlDecodeTree = decode_data_html_js_1.default;
  var decode_data_xml_js_1 = __importDefault2(decodeDataXml);
  exports.xmlDecodeTree = decode_data_xml_js_1.default;
  var decode_codepoint_js_1 = __importStar2(decode_codepoint);
  exports.decodeCodePoint = decode_codepoint_js_1.default;
  var decode_codepoint_js_2 = decode_codepoint;
  Object.defineProperty(exports, "replaceCodePoint", { enumerable: true, get: function() {
    return decode_codepoint_js_2.replaceCodePoint;
  } });
  Object.defineProperty(exports, "fromCodePoint", { enumerable: true, get: function() {
    return decode_codepoint_js_2.fromCodePoint;
  } });
  var CharCodes;
  (function(CharCodes2) {
    CharCodes2[CharCodes2["NUM"] = 35] = "NUM";
    CharCodes2[CharCodes2["SEMI"] = 59] = "SEMI";
    CharCodes2[CharCodes2["EQUALS"] = 61] = "EQUALS";
    CharCodes2[CharCodes2["ZERO"] = 48] = "ZERO";
    CharCodes2[CharCodes2["NINE"] = 57] = "NINE";
    CharCodes2[CharCodes2["LOWER_A"] = 97] = "LOWER_A";
    CharCodes2[CharCodes2["LOWER_F"] = 102] = "LOWER_F";
    CharCodes2[CharCodes2["LOWER_X"] = 120] = "LOWER_X";
    CharCodes2[CharCodes2["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes2[CharCodes2["UPPER_A"] = 65] = "UPPER_A";
    CharCodes2[CharCodes2["UPPER_F"] = 70] = "UPPER_F";
    CharCodes2[CharCodes2["UPPER_Z"] = 90] = "UPPER_Z";
  })(CharCodes || (CharCodes = {}));
  var TO_LOWER_BIT = 32;
  var BinTrieFlags;
  (function(BinTrieFlags2) {
    BinTrieFlags2[BinTrieFlags2["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags2[BinTrieFlags2["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags2[BinTrieFlags2["JUMP_TABLE"] = 127] = "JUMP_TABLE";
  })(BinTrieFlags = exports.BinTrieFlags || (exports.BinTrieFlags = {}));
  function isNumber2(code) {
    return code >= CharCodes.ZERO && code <= CharCodes.NINE;
  }
  function isHexadecimalCharacter(code) {
    return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_F || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_F;
  }
  function isAsciiAlphaNumeric(code) {
    return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_Z || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_Z || isNumber2(code);
  }
  function isEntityInAttributeInvalidEnd(code) {
    return code === CharCodes.EQUALS || isAsciiAlphaNumeric(code);
  }
  var EntityDecoderState;
  (function(EntityDecoderState2) {
    EntityDecoderState2[EntityDecoderState2["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState2[EntityDecoderState2["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState2[EntityDecoderState2["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState2[EntityDecoderState2["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState2[EntityDecoderState2["NamedEntity"] = 4] = "NamedEntity";
  })(EntityDecoderState || (EntityDecoderState = {}));
  var DecodingMode;
  (function(DecodingMode2) {
    DecodingMode2[DecodingMode2["Legacy"] = 0] = "Legacy";
    DecodingMode2[DecodingMode2["Strict"] = 1] = "Strict";
    DecodingMode2[DecodingMode2["Attribute"] = 2] = "Attribute";
  })(DecodingMode = exports.DecodingMode || (exports.DecodingMode = {}));
  var EntityDecoder = (
    /** @class */
    function() {
      function EntityDecoder2(decodeTree, emitCodePoint, errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        this.state = EntityDecoderState.EntityStart;
        this.consumed = 1;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.decodeMode = DecodingMode.Strict;
      }
      EntityDecoder2.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
      };
      EntityDecoder2.prototype.write = function(str, offset2) {
        switch (this.state) {
          case EntityDecoderState.EntityStart: {
            if (str.charCodeAt(offset2) === CharCodes.NUM) {
              this.state = EntityDecoderState.NumericStart;
              this.consumed += 1;
              return this.stateNumericStart(str, offset2 + 1);
            }
            this.state = EntityDecoderState.NamedEntity;
            return this.stateNamedEntity(str, offset2);
          }
          case EntityDecoderState.NumericStart: {
            return this.stateNumericStart(str, offset2);
          }
          case EntityDecoderState.NumericDecimal: {
            return this.stateNumericDecimal(str, offset2);
          }
          case EntityDecoderState.NumericHex: {
            return this.stateNumericHex(str, offset2);
          }
          case EntityDecoderState.NamedEntity: {
            return this.stateNamedEntity(str, offset2);
          }
        }
      };
      EntityDecoder2.prototype.stateNumericStart = function(str, offset2) {
        if (offset2 >= str.length) {
          return -1;
        }
        if ((str.charCodeAt(offset2) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
          this.state = EntityDecoderState.NumericHex;
          this.consumed += 1;
          return this.stateNumericHex(str, offset2 + 1);
        }
        this.state = EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset2);
      };
      EntityDecoder2.prototype.addToNumericResult = function(str, start, end, base) {
        if (start !== end) {
          var digitCount = end - start;
          this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
          this.consumed += digitCount;
        }
      };
      EntityDecoder2.prototype.stateNumericHex = function(str, offset2) {
        var startIdx = offset2;
        while (offset2 < str.length) {
          var char = str.charCodeAt(offset2);
          if (isNumber2(char) || isHexadecimalCharacter(char)) {
            offset2 += 1;
          } else {
            this.addToNumericResult(str, startIdx, offset2, 16);
            return this.emitNumericEntity(char, 3);
          }
        }
        this.addToNumericResult(str, startIdx, offset2, 16);
        return -1;
      };
      EntityDecoder2.prototype.stateNumericDecimal = function(str, offset2) {
        var startIdx = offset2;
        while (offset2 < str.length) {
          var char = str.charCodeAt(offset2);
          if (isNumber2(char)) {
            offset2 += 1;
          } else {
            this.addToNumericResult(str, startIdx, offset2, 10);
            return this.emitNumericEntity(char, 2);
          }
        }
        this.addToNumericResult(str, startIdx, offset2, 10);
        return -1;
      };
      EntityDecoder2.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a2;
        if (this.consumed <= expectedLength) {
          (_a2 = this.errors) === null || _a2 === void 0 ? void 0 : _a2.absenceOfDigitsInNumericCharacterReference(this.consumed);
          return 0;
        }
        if (lastCp === CharCodes.SEMI) {
          this.consumed += 1;
        } else if (this.decodeMode === DecodingMode.Strict) {
          return 0;
        }
        this.emitCodePoint((0, decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
          if (lastCp !== CharCodes.SEMI) {
            this.errors.missingSemicolonAfterCharacterReference();
          }
          this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
      };
      EntityDecoder2.prototype.stateNamedEntity = function(str, offset2) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        var valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
        for (; offset2 < str.length; offset2++, this.excess++) {
          var char = str.charCodeAt(offset2);
          this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
          if (this.treeIndex < 0) {
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
          }
          current = decodeTree[this.treeIndex];
          valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
          if (valueLength !== 0) {
            if (char === CharCodes.SEMI) {
              return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
            }
            if (this.decodeMode !== DecodingMode.Strict) {
              this.result = this.treeIndex;
              this.consumed += this.excess;
              this.excess = 0;
            }
          }
        }
        return -1;
      };
      EntityDecoder2.prototype.emitNotTerminatedNamedEntity = function() {
        var _a2;
        var _b2 = this, result2 = _b2.result, decodeTree = _b2.decodeTree;
        var valueLength = (decodeTree[result2] & BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result2, valueLength, this.consumed);
        (_a2 = this.errors) === null || _a2 === void 0 ? void 0 : _a2.missingSemicolonAfterCharacterReference();
        return this.consumed;
      };
      EntityDecoder2.prototype.emitNamedEntityData = function(result2, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result2] & ~BinTrieFlags.VALUE_LENGTH : decodeTree[result2 + 1], consumed);
        if (valueLength === 3) {
          this.emitCodePoint(decodeTree[result2 + 2], consumed);
        }
        return consumed;
      };
      EntityDecoder2.prototype.end = function() {
        var _a2;
        switch (this.state) {
          case EntityDecoderState.NamedEntity: {
            return this.result !== 0 && (this.decodeMode !== DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          }
          case EntityDecoderState.NumericDecimal: {
            return this.emitNumericEntity(0, 2);
          }
          case EntityDecoderState.NumericHex: {
            return this.emitNumericEntity(0, 3);
          }
          case EntityDecoderState.NumericStart: {
            (_a2 = this.errors) === null || _a2 === void 0 ? void 0 : _a2.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
          }
          case EntityDecoderState.EntityStart: {
            return 0;
          }
        }
      };
      return EntityDecoder2;
    }()
  );
  exports.EntityDecoder = EntityDecoder;
  function getDecoder(decodeTree) {
    var ret = "";
    var decoder = new EntityDecoder(decodeTree, function(str) {
      return ret += (0, decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
      var lastIndex = 0;
      var offset2 = 0;
      while ((offset2 = str.indexOf("&", offset2)) >= 0) {
        ret += str.slice(lastIndex, offset2);
        decoder.startEntity(decodeMode);
        var len = decoder.write(
          str,
          // Skip the "&"
          offset2 + 1
        );
        if (len < 0) {
          lastIndex = offset2 + decoder.end();
          break;
        }
        lastIndex = offset2 + len;
        offset2 = len === 0 ? lastIndex + 1 : lastIndex;
      }
      var result2 = ret + str.slice(lastIndex);
      ret = "";
      return result2;
    };
  }
  function determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & BinTrieFlags.JUMP_TABLE;
    if (branchCount === 0) {
      return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    }
    if (jumpOffset) {
      var value = char - jumpOffset;
      return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while (lo <= hi) {
      var mid = lo + hi >>> 1;
      var midVal = decodeTree[mid];
      if (midVal < char) {
        lo = mid + 1;
      } else if (midVal > char) {
        hi = mid - 1;
      } else {
        return decodeTree[mid + branchCount];
      }
    }
    return -1;
  }
  exports.determineBranch = determineBranch;
  var htmlDecoder = getDecoder(decode_data_html_js_1.default);
  var xmlDecoder = getDecoder(decode_data_xml_js_1.default);
  function decodeHTML(str, mode) {
    if (mode === void 0) {
      mode = DecodingMode.Legacy;
    }
    return htmlDecoder(str, mode);
  }
  exports.decodeHTML = decodeHTML;
  function decodeHTMLAttribute(str) {
    return htmlDecoder(str, DecodingMode.Attribute);
  }
  exports.decodeHTMLAttribute = decodeHTMLAttribute;
  function decodeHTMLStrict(str) {
    return htmlDecoder(str, DecodingMode.Strict);
  }
  exports.decodeHTMLStrict = decodeHTMLStrict;
  function decodeXML(str) {
    return xmlDecoder(str, DecodingMode.Strict);
  }
  exports.decodeXML = decodeXML;
})(decode);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.QuoteType = void 0;
  var decode_js_12 = decode;
  var CharCodes;
  (function(CharCodes2) {
    CharCodes2[CharCodes2["Tab"] = 9] = "Tab";
    CharCodes2[CharCodes2["NewLine"] = 10] = "NewLine";
    CharCodes2[CharCodes2["FormFeed"] = 12] = "FormFeed";
    CharCodes2[CharCodes2["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes2[CharCodes2["Space"] = 32] = "Space";
    CharCodes2[CharCodes2["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes2[CharCodes2["Number"] = 35] = "Number";
    CharCodes2[CharCodes2["Amp"] = 38] = "Amp";
    CharCodes2[CharCodes2["SingleQuote"] = 39] = "SingleQuote";
    CharCodes2[CharCodes2["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes2[CharCodes2["Dash"] = 45] = "Dash";
    CharCodes2[CharCodes2["Slash"] = 47] = "Slash";
    CharCodes2[CharCodes2["Zero"] = 48] = "Zero";
    CharCodes2[CharCodes2["Nine"] = 57] = "Nine";
    CharCodes2[CharCodes2["Semi"] = 59] = "Semi";
    CharCodes2[CharCodes2["Lt"] = 60] = "Lt";
    CharCodes2[CharCodes2["Eq"] = 61] = "Eq";
    CharCodes2[CharCodes2["Gt"] = 62] = "Gt";
    CharCodes2[CharCodes2["Questionmark"] = 63] = "Questionmark";
    CharCodes2[CharCodes2["UpperA"] = 65] = "UpperA";
    CharCodes2[CharCodes2["LowerA"] = 97] = "LowerA";
    CharCodes2[CharCodes2["UpperF"] = 70] = "UpperF";
    CharCodes2[CharCodes2["LowerF"] = 102] = "LowerF";
    CharCodes2[CharCodes2["UpperZ"] = 90] = "UpperZ";
    CharCodes2[CharCodes2["LowerZ"] = 122] = "LowerZ";
    CharCodes2[CharCodes2["LowerX"] = 120] = "LowerX";
    CharCodes2[CharCodes2["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
  })(CharCodes || (CharCodes = {}));
  var State;
  (function(State2) {
    State2[State2["Text"] = 1] = "Text";
    State2[State2["BeforeTagName"] = 2] = "BeforeTagName";
    State2[State2["InTagName"] = 3] = "InTagName";
    State2[State2["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State2[State2["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State2[State2["InClosingTagName"] = 6] = "InClosingTagName";
    State2[State2["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    State2[State2["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State2[State2["InAttributeName"] = 9] = "InAttributeName";
    State2[State2["AfterAttributeName"] = 10] = "AfterAttributeName";
    State2[State2["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State2[State2["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State2[State2["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State2[State2["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    State2[State2["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State2[State2["InDeclaration"] = 16] = "InDeclaration";
    State2[State2["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    State2[State2["BeforeComment"] = 18] = "BeforeComment";
    State2[State2["CDATASequence"] = 19] = "CDATASequence";
    State2[State2["InSpecialComment"] = 20] = "InSpecialComment";
    State2[State2["InCommentLike"] = 21] = "InCommentLike";
    State2[State2["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State2[State2["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State2[State2["InSpecialTag"] = 24] = "InSpecialTag";
    State2[State2["BeforeEntity"] = 25] = "BeforeEntity";
    State2[State2["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State2[State2["InNamedEntity"] = 27] = "InNamedEntity";
    State2[State2["InNumericEntity"] = 28] = "InNumericEntity";
    State2[State2["InHexEntity"] = 29] = "InHexEntity";
  })(State || (State = {}));
  function isWhitespace2(c) {
    return c === CharCodes.Space || c === CharCodes.NewLine || c === CharCodes.Tab || c === CharCodes.FormFeed || c === CharCodes.CarriageReturn;
  }
  function isEndOfTagSection(c) {
    return c === CharCodes.Slash || c === CharCodes.Gt || isWhitespace2(c);
  }
  function isNumber2(c) {
    return c >= CharCodes.Zero && c <= CharCodes.Nine;
  }
  function isASCIIAlpha(c) {
    return c >= CharCodes.LowerA && c <= CharCodes.LowerZ || c >= CharCodes.UpperA && c <= CharCodes.UpperZ;
  }
  function isHexDigit(c) {
    return c >= CharCodes.UpperA && c <= CharCodes.UpperF || c >= CharCodes.LowerA && c <= CharCodes.LowerF;
  }
  var QuoteType;
  (function(QuoteType2) {
    QuoteType2[QuoteType2["NoValue"] = 0] = "NoValue";
    QuoteType2[QuoteType2["Unquoted"] = 1] = "Unquoted";
    QuoteType2[QuoteType2["Single"] = 2] = "Single";
    QuoteType2[QuoteType2["Double"] = 3] = "Double";
  })(QuoteType = exports.QuoteType || (exports.QuoteType = {}));
  var Sequences = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  };
  var Tokenizer3 = (
    /** @class */
    function() {
      function Tokenizer4(_a2, cbs) {
        var _b2 = _a2.xmlMode, xmlMode = _b2 === void 0 ? false : _b2, _c = _a2.decodeEntities, decodeEntities = _c === void 0 ? true : _c;
        this.cbs = cbs;
        this.state = State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = State.Text;
        this.isSpecial = false;
        this.running = true;
        this.offset = 0;
        this.currentSequence = void 0;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? decode_js_12.xmlDecodeTree : decode_js_12.htmlDecodeTree;
      }
      Tokenizer4.prototype.reset = function() {
        this.state = State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = State.Text;
        this.currentSequence = void 0;
        this.running = true;
        this.offset = 0;
      };
      Tokenizer4.prototype.write = function(chunk2) {
        this.offset += this.buffer.length;
        this.buffer = chunk2;
        this.parse();
      };
      Tokenizer4.prototype.end = function() {
        if (this.running)
          this.finish();
      };
      Tokenizer4.prototype.pause = function() {
        this.running = false;
      };
      Tokenizer4.prototype.resume = function() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) {
          this.parse();
        }
      };
      Tokenizer4.prototype.getIndex = function() {
        return this.index;
      };
      Tokenizer4.prototype.getSectionStart = function() {
        return this.sectionStart;
      };
      Tokenizer4.prototype.stateText = function(c) {
        if (c === CharCodes.Lt || !this.decodeEntities && this.fastForwardTo(CharCodes.Lt)) {
          if (this.index > this.sectionStart) {
            this.cbs.ontext(this.sectionStart, this.index);
          }
          this.state = State.BeforeTagName;
          this.sectionStart = this.index;
        } else if (this.decodeEntities && c === CharCodes.Amp) {
          this.state = State.BeforeEntity;
        }
      };
      Tokenizer4.prototype.stateSpecialStartSequence = function(c) {
        var isEnd = this.sequenceIndex === this.currentSequence.length;
        var isMatch = isEnd ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          isEndOfTagSection(c)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (c | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!isMatch) {
          this.isSpecial = false;
        } else if (!isEnd) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0;
        this.state = State.InTagName;
        this.stateInTagName(c);
      };
      Tokenizer4.prototype.stateInSpecialTag = function(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (c === CharCodes.Gt || isWhitespace2(c)) {
            var endOfText = this.index - this.currentSequence.length;
            if (this.sectionStart < endOfText) {
              var actualIndex = this.index;
              this.index = endOfText;
              this.cbs.ontext(this.sectionStart, endOfText);
              this.index = actualIndex;
            }
            this.isSpecial = false;
            this.sectionStart = endOfText + 2;
            this.stateInClosingTagName(c);
            return;
          }
          this.sequenceIndex = 0;
        }
        if ((c | 32) === this.currentSequence[this.sequenceIndex]) {
          this.sequenceIndex += 1;
        } else if (this.sequenceIndex === 0) {
          if (this.currentSequence === Sequences.TitleEnd) {
            if (this.decodeEntities && c === CharCodes.Amp) {
              this.state = State.BeforeEntity;
            }
          } else if (this.fastForwardTo(CharCodes.Lt)) {
            this.sequenceIndex = 1;
          }
        } else {
          this.sequenceIndex = Number(c === CharCodes.Lt);
        }
      };
      Tokenizer4.prototype.stateCDATASequence = function(c) {
        if (c === Sequences.Cdata[this.sequenceIndex]) {
          if (++this.sequenceIndex === Sequences.Cdata.length) {
            this.state = State.InCommentLike;
            this.currentSequence = Sequences.CdataEnd;
            this.sequenceIndex = 0;
            this.sectionStart = this.index + 1;
          }
        } else {
          this.sequenceIndex = 0;
          this.state = State.InDeclaration;
          this.stateInDeclaration(c);
        }
      };
      Tokenizer4.prototype.fastForwardTo = function(c) {
        while (++this.index < this.buffer.length + this.offset) {
          if (this.buffer.charCodeAt(this.index - this.offset) === c) {
            return true;
          }
        }
        this.index = this.buffer.length + this.offset - 1;
        return false;
      };
      Tokenizer4.prototype.stateInCommentLike = function(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
          if (++this.sequenceIndex === this.currentSequence.length) {
            if (this.currentSequence === Sequences.CdataEnd) {
              this.cbs.oncdata(this.sectionStart, this.index, 2);
            } else {
              this.cbs.oncomment(this.sectionStart, this.index, 2);
            }
            this.sequenceIndex = 0;
            this.sectionStart = this.index + 1;
            this.state = State.Text;
          }
        } else if (this.sequenceIndex === 0) {
          if (this.fastForwardTo(this.currentSequence[0])) {
            this.sequenceIndex = 1;
          }
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
          this.sequenceIndex = 0;
        }
      };
      Tokenizer4.prototype.isTagStartChar = function(c) {
        return this.xmlMode ? !isEndOfTagSection(c) : isASCIIAlpha(c);
      };
      Tokenizer4.prototype.startSpecial = function(sequence, offset2) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset2;
        this.state = State.SpecialStartSequence;
      };
      Tokenizer4.prototype.stateBeforeTagName = function(c) {
        if (c === CharCodes.ExclamationMark) {
          this.state = State.BeforeDeclaration;
          this.sectionStart = this.index + 1;
        } else if (c === CharCodes.Questionmark) {
          this.state = State.InProcessingInstruction;
          this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
          var lower = c | 32;
          this.sectionStart = this.index;
          if (!this.xmlMode && lower === Sequences.TitleEnd[2]) {
            this.startSpecial(Sequences.TitleEnd, 3);
          } else {
            this.state = !this.xmlMode && lower === Sequences.ScriptEnd[2] ? State.BeforeSpecialS : State.InTagName;
          }
        } else if (c === CharCodes.Slash) {
          this.state = State.BeforeClosingTagName;
        } else {
          this.state = State.Text;
          this.stateText(c);
        }
      };
      Tokenizer4.prototype.stateInTagName = function(c) {
        if (isEndOfTagSection(c)) {
          this.cbs.onopentagname(this.sectionStart, this.index);
          this.sectionStart = -1;
          this.state = State.BeforeAttributeName;
          this.stateBeforeAttributeName(c);
        }
      };
      Tokenizer4.prototype.stateBeforeClosingTagName = function(c) {
        if (isWhitespace2(c))
          ;
        else if (c === CharCodes.Gt) {
          this.state = State.Text;
        } else {
          this.state = this.isTagStartChar(c) ? State.InClosingTagName : State.InSpecialComment;
          this.sectionStart = this.index;
        }
      };
      Tokenizer4.prototype.stateInClosingTagName = function(c) {
        if (c === CharCodes.Gt || isWhitespace2(c)) {
          this.cbs.onclosetag(this.sectionStart, this.index);
          this.sectionStart = -1;
          this.state = State.AfterClosingTagName;
          this.stateAfterClosingTagName(c);
        }
      };
      Tokenizer4.prototype.stateAfterClosingTagName = function(c) {
        if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
          this.state = State.Text;
          this.baseState = State.Text;
          this.sectionStart = this.index + 1;
        }
      };
      Tokenizer4.prototype.stateBeforeAttributeName = function(c) {
        if (c === CharCodes.Gt) {
          this.cbs.onopentagend(this.index);
          if (this.isSpecial) {
            this.state = State.InSpecialTag;
            this.sequenceIndex = 0;
          } else {
            this.state = State.Text;
          }
          this.baseState = this.state;
          this.sectionStart = this.index + 1;
        } else if (c === CharCodes.Slash) {
          this.state = State.InSelfClosingTag;
        } else if (!isWhitespace2(c)) {
          this.state = State.InAttributeName;
          this.sectionStart = this.index;
        }
      };
      Tokenizer4.prototype.stateInSelfClosingTag = function(c) {
        if (c === CharCodes.Gt) {
          this.cbs.onselfclosingtag(this.index);
          this.state = State.Text;
          this.baseState = State.Text;
          this.sectionStart = this.index + 1;
          this.isSpecial = false;
        } else if (!isWhitespace2(c)) {
          this.state = State.BeforeAttributeName;
          this.stateBeforeAttributeName(c);
        }
      };
      Tokenizer4.prototype.stateInAttributeName = function(c) {
        if (c === CharCodes.Eq || isEndOfTagSection(c)) {
          this.cbs.onattribname(this.sectionStart, this.index);
          this.sectionStart = -1;
          this.state = State.AfterAttributeName;
          this.stateAfterAttributeName(c);
        }
      };
      Tokenizer4.prototype.stateAfterAttributeName = function(c) {
        if (c === CharCodes.Eq) {
          this.state = State.BeforeAttributeValue;
        } else if (c === CharCodes.Slash || c === CharCodes.Gt) {
          this.cbs.onattribend(QuoteType.NoValue, this.index);
          this.state = State.BeforeAttributeName;
          this.stateBeforeAttributeName(c);
        } else if (!isWhitespace2(c)) {
          this.cbs.onattribend(QuoteType.NoValue, this.index);
          this.state = State.InAttributeName;
          this.sectionStart = this.index;
        }
      };
      Tokenizer4.prototype.stateBeforeAttributeValue = function(c) {
        if (c === CharCodes.DoubleQuote) {
          this.state = State.InAttributeValueDq;
          this.sectionStart = this.index + 1;
        } else if (c === CharCodes.SingleQuote) {
          this.state = State.InAttributeValueSq;
          this.sectionStart = this.index + 1;
        } else if (!isWhitespace2(c)) {
          this.sectionStart = this.index;
          this.state = State.InAttributeValueNq;
          this.stateInAttributeValueNoQuotes(c);
        }
      };
      Tokenizer4.prototype.handleInAttributeValue = function(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
          this.cbs.onattribdata(this.sectionStart, this.index);
          this.sectionStart = -1;
          this.cbs.onattribend(quote === CharCodes.DoubleQuote ? QuoteType.Double : QuoteType.Single, this.index);
          this.state = State.BeforeAttributeName;
        } else if (this.decodeEntities && c === CharCodes.Amp) {
          this.baseState = this.state;
          this.state = State.BeforeEntity;
        }
      };
      Tokenizer4.prototype.stateInAttributeValueDoubleQuotes = function(c) {
        this.handleInAttributeValue(c, CharCodes.DoubleQuote);
      };
      Tokenizer4.prototype.stateInAttributeValueSingleQuotes = function(c) {
        this.handleInAttributeValue(c, CharCodes.SingleQuote);
      };
      Tokenizer4.prototype.stateInAttributeValueNoQuotes = function(c) {
        if (isWhitespace2(c) || c === CharCodes.Gt) {
          this.cbs.onattribdata(this.sectionStart, this.index);
          this.sectionStart = -1;
          this.cbs.onattribend(QuoteType.Unquoted, this.index);
          this.state = State.BeforeAttributeName;
          this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === CharCodes.Amp) {
          this.baseState = this.state;
          this.state = State.BeforeEntity;
        }
      };
      Tokenizer4.prototype.stateBeforeDeclaration = function(c) {
        if (c === CharCodes.OpeningSquareBracket) {
          this.state = State.CDATASequence;
          this.sequenceIndex = 0;
        } else {
          this.state = c === CharCodes.Dash ? State.BeforeComment : State.InDeclaration;
        }
      };
      Tokenizer4.prototype.stateInDeclaration = function(c) {
        if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
          this.cbs.ondeclaration(this.sectionStart, this.index);
          this.state = State.Text;
          this.sectionStart = this.index + 1;
        }
      };
      Tokenizer4.prototype.stateInProcessingInstruction = function(c) {
        if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
          this.cbs.onprocessinginstruction(this.sectionStart, this.index);
          this.state = State.Text;
          this.sectionStart = this.index + 1;
        }
      };
      Tokenizer4.prototype.stateBeforeComment = function(c) {
        if (c === CharCodes.Dash) {
          this.state = State.InCommentLike;
          this.currentSequence = Sequences.CommentEnd;
          this.sequenceIndex = 2;
          this.sectionStart = this.index + 1;
        } else {
          this.state = State.InDeclaration;
        }
      };
      Tokenizer4.prototype.stateInSpecialComment = function(c) {
        if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
          this.cbs.oncomment(this.sectionStart, this.index, 0);
          this.state = State.Text;
          this.sectionStart = this.index + 1;
        }
      };
      Tokenizer4.prototype.stateBeforeSpecialS = function(c) {
        var lower = c | 32;
        if (lower === Sequences.ScriptEnd[3]) {
          this.startSpecial(Sequences.ScriptEnd, 4);
        } else if (lower === Sequences.StyleEnd[3]) {
          this.startSpecial(Sequences.StyleEnd, 4);
        } else {
          this.state = State.InTagName;
          this.stateInTagName(c);
        }
      };
      Tokenizer4.prototype.stateBeforeEntity = function(c) {
        this.entityExcess = 1;
        this.entityResult = 0;
        if (c === CharCodes.Number) {
          this.state = State.BeforeNumericEntity;
        } else if (c === CharCodes.Amp)
          ;
        else {
          this.trieIndex = 0;
          this.trieCurrent = this.entityTrie[0];
          this.state = State.InNamedEntity;
          this.stateInNamedEntity(c);
        }
      };
      Tokenizer4.prototype.stateInNamedEntity = function(c) {
        this.entityExcess += 1;
        this.trieIndex = (0, decode_js_12.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
        if (this.trieIndex < 0) {
          this.emitNamedEntity();
          this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var masked = this.trieCurrent & decode_js_12.BinTrieFlags.VALUE_LENGTH;
        if (masked) {
          var valueLength = (masked >> 14) - 1;
          if (!this.allowLegacyEntity() && c !== CharCodes.Semi) {
            this.trieIndex += valueLength;
          } else {
            var entityStart = this.index - this.entityExcess + 1;
            if (entityStart > this.sectionStart) {
              this.emitPartial(this.sectionStart, entityStart);
            }
            this.entityResult = this.trieIndex;
            this.trieIndex += valueLength;
            this.entityExcess = 0;
            this.sectionStart = this.index + 1;
            if (valueLength === 0) {
              this.emitNamedEntity();
            }
          }
        }
      };
      Tokenizer4.prototype.emitNamedEntity = function() {
        this.state = this.baseState;
        if (this.entityResult === 0) {
          return;
        }
        var valueLength = (this.entityTrie[this.entityResult] & decode_js_12.BinTrieFlags.VALUE_LENGTH) >> 14;
        switch (valueLength) {
          case 1: {
            this.emitCodePoint(this.entityTrie[this.entityResult] & ~decode_js_12.BinTrieFlags.VALUE_LENGTH);
            break;
          }
          case 2: {
            this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
            break;
          }
          case 3: {
            this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
            this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      };
      Tokenizer4.prototype.stateBeforeNumericEntity = function(c) {
        if ((c | 32) === CharCodes.LowerX) {
          this.entityExcess++;
          this.state = State.InHexEntity;
        } else {
          this.state = State.InNumericEntity;
          this.stateInNumericEntity(c);
        }
      };
      Tokenizer4.prototype.emitNumericEntity = function(strict) {
        var entityStart = this.index - this.entityExcess - 1;
        var numberStart = entityStart + 2 + Number(this.state === State.InHexEntity);
        if (numberStart !== this.index) {
          if (entityStart > this.sectionStart) {
            this.emitPartial(this.sectionStart, entityStart);
          }
          this.sectionStart = this.index + Number(strict);
          this.emitCodePoint((0, decode_js_12.replaceCodePoint)(this.entityResult));
        }
        this.state = this.baseState;
      };
      Tokenizer4.prototype.stateInNumericEntity = function(c) {
        if (c === CharCodes.Semi) {
          this.emitNumericEntity(true);
        } else if (isNumber2(c)) {
          this.entityResult = this.entityResult * 10 + (c - CharCodes.Zero);
          this.entityExcess++;
        } else {
          if (this.allowLegacyEntity()) {
            this.emitNumericEntity(false);
          } else {
            this.state = this.baseState;
          }
          this.index--;
        }
      };
      Tokenizer4.prototype.stateInHexEntity = function(c) {
        if (c === CharCodes.Semi) {
          this.emitNumericEntity(true);
        } else if (isNumber2(c)) {
          this.entityResult = this.entityResult * 16 + (c - CharCodes.Zero);
          this.entityExcess++;
        } else if (isHexDigit(c)) {
          this.entityResult = this.entityResult * 16 + ((c | 32) - CharCodes.LowerA + 10);
          this.entityExcess++;
        } else {
          if (this.allowLegacyEntity()) {
            this.emitNumericEntity(false);
          } else {
            this.state = this.baseState;
          }
          this.index--;
        }
      };
      Tokenizer4.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === State.Text || this.baseState === State.InSpecialTag);
      };
      Tokenizer4.prototype.cleanup = function() {
        if (this.running && this.sectionStart !== this.index) {
          if (this.state === State.Text || this.state === State.InSpecialTag && this.sequenceIndex === 0) {
            this.cbs.ontext(this.sectionStart, this.index);
            this.sectionStart = this.index;
          } else if (this.state === State.InAttributeValueDq || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueNq) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = this.index;
          }
        }
      };
      Tokenizer4.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      };
      Tokenizer4.prototype.parse = function() {
        while (this.shouldContinue()) {
          var c = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case State.Text: {
              this.stateText(c);
              break;
            }
            case State.SpecialStartSequence: {
              this.stateSpecialStartSequence(c);
              break;
            }
            case State.InSpecialTag: {
              this.stateInSpecialTag(c);
              break;
            }
            case State.CDATASequence: {
              this.stateCDATASequence(c);
              break;
            }
            case State.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(c);
              break;
            }
            case State.InAttributeName: {
              this.stateInAttributeName(c);
              break;
            }
            case State.InCommentLike: {
              this.stateInCommentLike(c);
              break;
            }
            case State.InSpecialComment: {
              this.stateInSpecialComment(c);
              break;
            }
            case State.BeforeAttributeName: {
              this.stateBeforeAttributeName(c);
              break;
            }
            case State.InTagName: {
              this.stateInTagName(c);
              break;
            }
            case State.InClosingTagName: {
              this.stateInClosingTagName(c);
              break;
            }
            case State.BeforeTagName: {
              this.stateBeforeTagName(c);
              break;
            }
            case State.AfterAttributeName: {
              this.stateAfterAttributeName(c);
              break;
            }
            case State.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(c);
              break;
            }
            case State.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(c);
              break;
            }
            case State.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(c);
              break;
            }
            case State.AfterClosingTagName: {
              this.stateAfterClosingTagName(c);
              break;
            }
            case State.BeforeSpecialS: {
              this.stateBeforeSpecialS(c);
              break;
            }
            case State.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(c);
              break;
            }
            case State.InSelfClosingTag: {
              this.stateInSelfClosingTag(c);
              break;
            }
            case State.InDeclaration: {
              this.stateInDeclaration(c);
              break;
            }
            case State.BeforeDeclaration: {
              this.stateBeforeDeclaration(c);
              break;
            }
            case State.BeforeComment: {
              this.stateBeforeComment(c);
              break;
            }
            case State.InProcessingInstruction: {
              this.stateInProcessingInstruction(c);
              break;
            }
            case State.InNamedEntity: {
              this.stateInNamedEntity(c);
              break;
            }
            case State.BeforeEntity: {
              this.stateBeforeEntity(c);
              break;
            }
            case State.InHexEntity: {
              this.stateInHexEntity(c);
              break;
            }
            case State.InNumericEntity: {
              this.stateInNumericEntity(c);
              break;
            }
            default: {
              this.stateBeforeNumericEntity(c);
            }
          }
          this.index++;
        }
        this.cleanup();
      };
      Tokenizer4.prototype.finish = function() {
        if (this.state === State.InNamedEntity) {
          this.emitNamedEntity();
        }
        if (this.sectionStart < this.index) {
          this.handleTrailingData();
        }
        this.cbs.onend();
      };
      Tokenizer4.prototype.handleTrailingData = function() {
        var endIndex = this.buffer.length + this.offset;
        if (this.state === State.InCommentLike) {
          if (this.currentSequence === Sequences.CdataEnd) {
            this.cbs.oncdata(this.sectionStart, endIndex, 0);
          } else {
            this.cbs.oncomment(this.sectionStart, endIndex, 0);
          }
        } else if (this.state === State.InNumericEntity && this.allowLegacyEntity()) {
          this.emitNumericEntity(false);
        } else if (this.state === State.InHexEntity && this.allowLegacyEntity()) {
          this.emitNumericEntity(false);
        } else if (this.state === State.InTagName || this.state === State.BeforeAttributeName || this.state === State.BeforeAttributeValue || this.state === State.AfterAttributeName || this.state === State.InAttributeName || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueDq || this.state === State.InAttributeValueNq || this.state === State.InClosingTagName)
          ;
        else {
          this.cbs.ontext(this.sectionStart, endIndex);
        }
      };
      Tokenizer4.prototype.emitPartial = function(start, endIndex) {
        if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
          this.cbs.onattribdata(start, endIndex);
        } else {
          this.cbs.ontext(start, endIndex);
        }
      };
      Tokenizer4.prototype.emitCodePoint = function(cp) {
        if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
          this.cbs.onattribentity(cp);
        } else {
          this.cbs.ontextentity(cp);
        }
      };
      return Tokenizer4;
    }()
  );
  exports.default = Tokenizer3;
})(Tokenizer$3);
var __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = { enumerable: true, get: function() {
      return m[k];
    } };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
} : function(o, v) {
  o["default"] = v;
});
var __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function(mod) {
  if (mod && mod.__esModule)
    return mod;
  var result2 = {};
  if (mod != null) {
    for (var k in mod)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
        __createBinding$1(result2, mod, k);
  }
  __setModuleDefault$1(result2, mod);
  return result2;
};
Object.defineProperty(Parser$5, "__esModule", { value: true });
Parser$5.Parser = void 0;
var Tokenizer_js_1 = __importStar$1(Tokenizer$3);
var decode_js_1 = decode;
var formTags = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]);
var pTag = /* @__PURE__ */ new Set(["p"]);
var tableSectionTags = /* @__PURE__ */ new Set(["thead", "tbody"]);
var ddtTags = /* @__PURE__ */ new Set(["dd", "dt"]);
var rtpTags = /* @__PURE__ */ new Set(["rt", "rp"]);
var openImpliesClose = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", pTag],
  ["h1", pTag],
  ["h2", pTag],
  ["h3", pTag],
  ["h4", pTag],
  ["h5", pTag],
  ["h6", pTag],
  ["select", formTags],
  ["input", formTags],
  ["output", formTags],
  ["button", formTags],
  ["datalist", formTags],
  ["textarea", formTags],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", ddtTags],
  ["dt", ddtTags],
  ["address", pTag],
  ["article", pTag],
  ["aside", pTag],
  ["blockquote", pTag],
  ["details", pTag],
  ["div", pTag],
  ["dl", pTag],
  ["fieldset", pTag],
  ["figcaption", pTag],
  ["figure", pTag],
  ["footer", pTag],
  ["form", pTag],
  ["header", pTag],
  ["hr", pTag],
  ["main", pTag],
  ["nav", pTag],
  ["ol", pTag],
  ["pre", pTag],
  ["section", pTag],
  ["table", pTag],
  ["ul", pTag],
  ["rt", rtpTags],
  ["rp", rtpTags],
  ["tbody", tableSectionTags],
  ["tfoot", tableSectionTags]
]);
var voidElements = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
var foreignContextElements = /* @__PURE__ */ new Set(["math", "svg"]);
var htmlIntegrationElements = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]);
var reNameEnd = /\s|\//;
var Parser$4 = (
  /** @class */
  function() {
    function Parser4(cbs, options) {
      if (options === void 0) {
        options = {};
      }
      var _a2, _b2, _c, _d2, _e;
      this.options = options;
      this.startIndex = 0;
      this.endIndex = 0;
      this.openTagStart = 0;
      this.tagname = "";
      this.attribname = "";
      this.attribvalue = "";
      this.attribs = null;
      this.stack = [];
      this.foreignContext = [];
      this.buffers = [];
      this.bufferOffset = 0;
      this.writeIndex = 0;
      this.ended = false;
      this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
      this.lowerCaseTagNames = (_a2 = options.lowerCaseTags) !== null && _a2 !== void 0 ? _a2 : !options.xmlMode;
      this.lowerCaseAttributeNames = (_b2 = options.lowerCaseAttributeNames) !== null && _b2 !== void 0 ? _b2 : !options.xmlMode;
      this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_js_1.default)(this.options, this);
      (_e = (_d2 = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d2, this);
    }
    Parser4.prototype.ontext = function(start, endIndex) {
      var _a2, _b2;
      var data = this.getSlice(start, endIndex);
      this.endIndex = endIndex - 1;
      (_b2 = (_a2 = this.cbs).ontext) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, data);
      this.startIndex = endIndex;
    };
    Parser4.prototype.ontextentity = function(cp) {
      var _a2, _b2;
      var index2 = this.tokenizer.getSectionStart();
      this.endIndex = index2 - 1;
      (_b2 = (_a2 = this.cbs).ontext) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, (0, decode_js_1.fromCodePoint)(cp));
      this.startIndex = index2;
    };
    Parser4.prototype.isVoidElement = function(name) {
      return !this.options.xmlMode && voidElements.has(name);
    };
    Parser4.prototype.onopentagname = function(start, endIndex) {
      this.endIndex = endIndex;
      var name = this.getSlice(start, endIndex);
      if (this.lowerCaseTagNames) {
        name = name.toLowerCase();
      }
      this.emitOpenTag(name);
    };
    Parser4.prototype.emitOpenTag = function(name) {
      var _a2, _b2, _c, _d2;
      this.openTagStart = this.startIndex;
      this.tagname = name;
      var impliesClose = !this.options.xmlMode && openImpliesClose.get(name);
      if (impliesClose) {
        while (this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])) {
          var element = this.stack.pop();
          (_b2 = (_a2 = this.cbs).onclosetag) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, element, true);
        }
      }
      if (!this.isVoidElement(name)) {
        this.stack.push(name);
        if (foreignContextElements.has(name)) {
          this.foreignContext.push(true);
        } else if (htmlIntegrationElements.has(name)) {
          this.foreignContext.push(false);
        }
      }
      (_d2 = (_c = this.cbs).onopentagname) === null || _d2 === void 0 ? void 0 : _d2.call(_c, name);
      if (this.cbs.onopentag)
        this.attribs = {};
    };
    Parser4.prototype.endOpenTag = function(isImplied) {
      var _a2, _b2;
      this.startIndex = this.openTagStart;
      if (this.attribs) {
        (_b2 = (_a2 = this.cbs).onopentag) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, this.tagname, this.attribs, isImplied);
        this.attribs = null;
      }
      if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
        this.cbs.onclosetag(this.tagname, true);
      }
      this.tagname = "";
    };
    Parser4.prototype.onopentagend = function(endIndex) {
      this.endIndex = endIndex;
      this.endOpenTag(false);
      this.startIndex = endIndex + 1;
    };
    Parser4.prototype.onclosetag = function(start, endIndex) {
      var _a2, _b2, _c, _d2, _e, _f;
      this.endIndex = endIndex;
      var name = this.getSlice(start, endIndex);
      if (this.lowerCaseTagNames) {
        name = name.toLowerCase();
      }
      if (foreignContextElements.has(name) || htmlIntegrationElements.has(name)) {
        this.foreignContext.pop();
      }
      if (!this.isVoidElement(name)) {
        var pos = this.stack.lastIndexOf(name);
        if (pos !== -1) {
          if (this.cbs.onclosetag) {
            var count = this.stack.length - pos;
            while (count--) {
              this.cbs.onclosetag(this.stack.pop(), count !== 0);
            }
          } else
            this.stack.length = pos;
        } else if (!this.options.xmlMode && name === "p") {
          this.emitOpenTag("p");
          this.closeCurrentTag(true);
        }
      } else if (!this.options.xmlMode && name === "br") {
        (_b2 = (_a2 = this.cbs).onopentagname) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, "br");
        (_d2 = (_c = this.cbs).onopentag) === null || _d2 === void 0 ? void 0 : _d2.call(_c, "br", {}, true);
        (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e, "br", false);
      }
      this.startIndex = endIndex + 1;
    };
    Parser4.prototype.onselfclosingtag = function(endIndex) {
      this.endIndex = endIndex;
      if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
        this.closeCurrentTag(false);
        this.startIndex = endIndex + 1;
      } else {
        this.onopentagend(endIndex);
      }
    };
    Parser4.prototype.closeCurrentTag = function(isOpenImplied) {
      var _a2, _b2;
      var name = this.tagname;
      this.endOpenTag(isOpenImplied);
      if (this.stack[this.stack.length - 1] === name) {
        (_b2 = (_a2 = this.cbs).onclosetag) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, name, !isOpenImplied);
        this.stack.pop();
      }
    };
    Parser4.prototype.onattribname = function(start, endIndex) {
      this.startIndex = start;
      var name = this.getSlice(start, endIndex);
      this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    };
    Parser4.prototype.onattribdata = function(start, endIndex) {
      this.attribvalue += this.getSlice(start, endIndex);
    };
    Parser4.prototype.onattribentity = function(cp) {
      this.attribvalue += (0, decode_js_1.fromCodePoint)(cp);
    };
    Parser4.prototype.onattribend = function(quote, endIndex) {
      var _a2, _b2;
      this.endIndex = endIndex;
      (_b2 = (_a2 = this.cbs).onattribute) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, this.attribname, this.attribvalue, quote === Tokenizer_js_1.QuoteType.Double ? '"' : quote === Tokenizer_js_1.QuoteType.Single ? "'" : quote === Tokenizer_js_1.QuoteType.NoValue ? void 0 : null);
      if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
        this.attribs[this.attribname] = this.attribvalue;
      }
      this.attribvalue = "";
    };
    Parser4.prototype.getInstructionName = function(value) {
      var index2 = value.search(reNameEnd);
      var name = index2 < 0 ? value : value.substr(0, index2);
      if (this.lowerCaseTagNames) {
        name = name.toLowerCase();
      }
      return name;
    };
    Parser4.prototype.ondeclaration = function(start, endIndex) {
      this.endIndex = endIndex;
      var value = this.getSlice(start, endIndex);
      if (this.cbs.onprocessinginstruction) {
        var name = this.getInstructionName(value);
        this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
      }
      this.startIndex = endIndex + 1;
    };
    Parser4.prototype.onprocessinginstruction = function(start, endIndex) {
      this.endIndex = endIndex;
      var value = this.getSlice(start, endIndex);
      if (this.cbs.onprocessinginstruction) {
        var name = this.getInstructionName(value);
        this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
      }
      this.startIndex = endIndex + 1;
    };
    Parser4.prototype.oncomment = function(start, endIndex, offset2) {
      var _a2, _b2, _c, _d2;
      this.endIndex = endIndex;
      (_b2 = (_a2 = this.cbs).oncomment) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, this.getSlice(start, endIndex - offset2));
      (_d2 = (_c = this.cbs).oncommentend) === null || _d2 === void 0 ? void 0 : _d2.call(_c);
      this.startIndex = endIndex + 1;
    };
    Parser4.prototype.oncdata = function(start, endIndex, offset2) {
      var _a2, _b2, _c, _d2, _e, _f, _g, _h, _j, _k;
      this.endIndex = endIndex;
      var value = this.getSlice(start, endIndex - offset2);
      if (this.options.xmlMode || this.options.recognizeCDATA) {
        (_b2 = (_a2 = this.cbs).oncdatastart) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
        (_d2 = (_c = this.cbs).ontext) === null || _d2 === void 0 ? void 0 : _d2.call(_c, value);
        (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
      } else {
        (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, "[CDATA[".concat(value, "]]"));
        (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
      }
      this.startIndex = endIndex + 1;
    };
    Parser4.prototype.onend = function() {
      var _a2, _b2;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var index2 = this.stack.length; index2 > 0; this.cbs.onclosetag(this.stack[--index2], true))
          ;
      }
      (_b2 = (_a2 = this.cbs).onend) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
    };
    Parser4.prototype.reset = function() {
      var _a2, _b2, _c, _d2;
      (_b2 = (_a2 = this.cbs).onreset) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
      this.tokenizer.reset();
      this.tagname = "";
      this.attribname = "";
      this.attribs = null;
      this.stack.length = 0;
      this.startIndex = 0;
      this.endIndex = 0;
      (_d2 = (_c = this.cbs).onparserinit) === null || _d2 === void 0 ? void 0 : _d2.call(_c, this);
      this.buffers.length = 0;
      this.bufferOffset = 0;
      this.writeIndex = 0;
      this.ended = false;
    };
    Parser4.prototype.parseComplete = function(data) {
      this.reset();
      this.end(data);
    };
    Parser4.prototype.getSlice = function(start, end) {
      while (start - this.bufferOffset >= this.buffers[0].length) {
        this.shiftBuffer();
      }
      var slice2 = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
      while (end - this.bufferOffset > this.buffers[0].length) {
        this.shiftBuffer();
        slice2 += this.buffers[0].slice(0, end - this.bufferOffset);
      }
      return slice2;
    };
    Parser4.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length;
      this.writeIndex--;
      this.buffers.shift();
    };
    Parser4.prototype.write = function(chunk2) {
      var _a2, _b2;
      if (this.ended) {
        (_b2 = (_a2 = this.cbs).onerror) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(chunk2);
      if (this.tokenizer.running) {
        this.tokenizer.write(chunk2);
        this.writeIndex++;
      }
    };
    Parser4.prototype.end = function(chunk2) {
      var _a2, _b2;
      if (this.ended) {
        (_b2 = (_a2 = this.cbs).onerror) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, new Error(".end() after done!"));
        return;
      }
      if (chunk2)
        this.write(chunk2);
      this.ended = true;
      this.tokenizer.end();
    };
    Parser4.prototype.pause = function() {
      this.tokenizer.pause();
    };
    Parser4.prototype.resume = function() {
      this.tokenizer.resume();
      while (this.tokenizer.running && this.writeIndex < this.buffers.length) {
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      }
      if (this.ended)
        this.tokenizer.end();
    };
    Parser4.prototype.parseChunk = function(chunk2) {
      this.write(chunk2);
    };
    Parser4.prototype.done = function(chunk2) {
      this.end(chunk2);
    };
    return Parser4;
  }()
);
Parser$5.Parser = Parser$4;
var lib$4 = {};
var lib$3 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
  var ElementType2;
  (function(ElementType3) {
    ElementType3["Root"] = "root";
    ElementType3["Text"] = "text";
    ElementType3["Directive"] = "directive";
    ElementType3["Comment"] = "comment";
    ElementType3["Script"] = "script";
    ElementType3["Style"] = "style";
    ElementType3["Tag"] = "tag";
    ElementType3["CDATA"] = "cdata";
    ElementType3["Doctype"] = "doctype";
  })(ElementType2 = exports.ElementType || (exports.ElementType = {}));
  function isTag2(elem) {
    return elem.type === ElementType2.Tag || elem.type === ElementType2.Script || elem.type === ElementType2.Style;
  }
  exports.isTag = isTag2;
  exports.Root = ElementType2.Root;
  exports.Text = ElementType2.Text;
  exports.Directive = ElementType2.Directive;
  exports.Comment = ElementType2.Comment;
  exports.Script = ElementType2.Script;
  exports.Style = ElementType2.Style;
  exports.Tag = ElementType2.Tag;
  exports.CDATA = ElementType2.CDATA;
  exports.Doctype = ElementType2.Doctype;
})(lib$3);
var node$1 = {};
var __extends$2 = commonjsGlobal && commonjsGlobal.__extends || function() {
  var extendStatics2 = function(d2, b) {
    extendStatics2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b2) {
      d3.__proto__ = b2;
    } || function(d3, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d3[p] = b2[p];
    };
    return extendStatics2(d2, b);
  };
  return function(d2, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics2(d2, b);
    function __() {
      this.constructor = d2;
    }
    d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign$1 = Object.assign || function(t3) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p))
          t3[p] = s2[p];
    }
    return t3;
  };
  return __assign$1.apply(this, arguments);
};
Object.defineProperty(node$1, "__esModule", { value: true });
node$1.cloneNode = node$1.hasChildren = node$1.isDocument = node$1.isDirective = node$1.isComment = node$1.isText = node$1.isCDATA = node$1.isTag = node$1.Element = node$1.Document = node$1.CDATA = node$1.NodeWithChildren = node$1.ProcessingInstruction = node$1.Comment = node$1.Text = node$1.DataNode = node$1.Node = void 0;
var domelementtype_1$1 = lib$3;
var Node$6 = (
  /** @class */
  function() {
    function Node3() {
      this.parent = null;
      this.prev = null;
      this.next = null;
      this.startIndex = null;
      this.endIndex = null;
    }
    Object.defineProperty(Node3.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(parent2) {
        this.parent = parent2;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Node3.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(prev) {
        this.prev = prev;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Node3.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(next) {
        this.next = next;
      },
      enumerable: false,
      configurable: true
    });
    Node3.prototype.cloneNode = function(recursive) {
      if (recursive === void 0) {
        recursive = false;
      }
      return cloneNode$1(this, recursive);
    };
    return Node3;
  }()
);
node$1.Node = Node$6;
var DataNode = (
  /** @class */
  function(_super) {
    __extends$2(DataNode2, _super);
    function DataNode2(data) {
      var _this2 = _super.call(this) || this;
      _this2.data = data;
      return _this2;
    }
    Object.defineProperty(DataNode2.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(data) {
        this.data = data;
      },
      enumerable: false,
      configurable: true
    });
    return DataNode2;
  }(Node$6)
);
node$1.DataNode = DataNode;
var Text = (
  /** @class */
  function(_super) {
    __extends$2(Text2, _super);
    function Text2() {
      var _this2 = _super !== null && _super.apply(this, arguments) || this;
      _this2.type = domelementtype_1$1.ElementType.Text;
      return _this2;
    }
    Object.defineProperty(Text2.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: false,
      configurable: true
    });
    return Text2;
  }(DataNode)
);
node$1.Text = Text;
var Comment$5 = (
  /** @class */
  function(_super) {
    __extends$2(Comment3, _super);
    function Comment3() {
      var _this2 = _super !== null && _super.apply(this, arguments) || this;
      _this2.type = domelementtype_1$1.ElementType.Comment;
      return _this2;
    }
    Object.defineProperty(Comment3.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: false,
      configurable: true
    });
    return Comment3;
  }(DataNode)
);
node$1.Comment = Comment$5;
var ProcessingInstruction = (
  /** @class */
  function(_super) {
    __extends$2(ProcessingInstruction2, _super);
    function ProcessingInstruction2(name, data) {
      var _this2 = _super.call(this, data) || this;
      _this2.name = name;
      _this2.type = domelementtype_1$1.ElementType.Directive;
      return _this2;
    }
    Object.defineProperty(ProcessingInstruction2.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: false,
      configurable: true
    });
    return ProcessingInstruction2;
  }(DataNode)
);
node$1.ProcessingInstruction = ProcessingInstruction;
var NodeWithChildren = (
  /** @class */
  function(_super) {
    __extends$2(NodeWithChildren2, _super);
    function NodeWithChildren2(children) {
      var _this2 = _super.call(this) || this;
      _this2.children = children;
      return _this2;
    }
    Object.defineProperty(NodeWithChildren2.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var _a2;
        return (_a2 = this.children[0]) !== null && _a2 !== void 0 ? _a2 : null;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NodeWithChildren2.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NodeWithChildren2.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(children) {
        this.children = children;
      },
      enumerable: false,
      configurable: true
    });
    return NodeWithChildren2;
  }(Node$6)
);
node$1.NodeWithChildren = NodeWithChildren;
var CDATA = (
  /** @class */
  function(_super) {
    __extends$2(CDATA2, _super);
    function CDATA2() {
      var _this2 = _super !== null && _super.apply(this, arguments) || this;
      _this2.type = domelementtype_1$1.ElementType.CDATA;
      return _this2;
    }
    Object.defineProperty(CDATA2.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: false,
      configurable: true
    });
    return CDATA2;
  }(NodeWithChildren)
);
node$1.CDATA = CDATA;
var Document$4 = (
  /** @class */
  function(_super) {
    __extends$2(Document3, _super);
    function Document3() {
      var _this2 = _super !== null && _super.apply(this, arguments) || this;
      _this2.type = domelementtype_1$1.ElementType.Root;
      return _this2;
    }
    Object.defineProperty(Document3.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: false,
      configurable: true
    });
    return Document3;
  }(NodeWithChildren)
);
node$1.Document = Document$4;
var Element$1 = (
  /** @class */
  function(_super) {
    __extends$2(Element2, _super);
    function Element2(name, attribs, children, type) {
      if (children === void 0) {
        children = [];
      }
      if (type === void 0) {
        type = name === "script" ? domelementtype_1$1.ElementType.Script : name === "style" ? domelementtype_1$1.ElementType.Style : domelementtype_1$1.ElementType.Tag;
      }
      var _this2 = _super.call(this, children) || this;
      _this2.name = name;
      _this2.attribs = attribs;
      _this2.type = type;
      return _this2;
    }
    Object.defineProperty(Element2.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Element2.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(name) {
        this.name = name;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Element2.prototype, "attributes", {
      get: function() {
        var _this2 = this;
        return Object.keys(this.attribs).map(function(name) {
          var _a2, _b2;
          return {
            name,
            value: _this2.attribs[name],
            namespace: (_a2 = _this2["x-attribsNamespace"]) === null || _a2 === void 0 ? void 0 : _a2[name],
            prefix: (_b2 = _this2["x-attribsPrefix"]) === null || _b2 === void 0 ? void 0 : _b2[name]
          };
        });
      },
      enumerable: false,
      configurable: true
    });
    return Element2;
  }(NodeWithChildren)
);
node$1.Element = Element$1;
function isTag(node2) {
  return (0, domelementtype_1$1.isTag)(node2);
}
node$1.isTag = isTag;
function isCDATA(node2) {
  return node2.type === domelementtype_1$1.ElementType.CDATA;
}
node$1.isCDATA = isCDATA;
function isText(node2) {
  return node2.type === domelementtype_1$1.ElementType.Text;
}
node$1.isText = isText;
function isComment(node2) {
  return node2.type === domelementtype_1$1.ElementType.Comment;
}
node$1.isComment = isComment;
function isDirective(node2) {
  return node2.type === domelementtype_1$1.ElementType.Directive;
}
node$1.isDirective = isDirective;
function isDocument(node2) {
  return node2.type === domelementtype_1$1.ElementType.Root;
}
node$1.isDocument = isDocument;
function hasChildren(node2) {
  return Object.prototype.hasOwnProperty.call(node2, "children");
}
node$1.hasChildren = hasChildren;
function cloneNode$1(node2, recursive) {
  if (recursive === void 0) {
    recursive = false;
  }
  var result2;
  if (isText(node2)) {
    result2 = new Text(node2.data);
  } else if (isComment(node2)) {
    result2 = new Comment$5(node2.data);
  } else if (isTag(node2)) {
    var children = recursive ? cloneChildren(node2.children) : [];
    var clone_12 = new Element$1(node2.name, __assign$1({}, node2.attribs), children);
    children.forEach(function(child) {
      return child.parent = clone_12;
    });
    if (node2.namespace != null) {
      clone_12.namespace = node2.namespace;
    }
    if (node2["x-attribsNamespace"]) {
      clone_12["x-attribsNamespace"] = __assign$1({}, node2["x-attribsNamespace"]);
    }
    if (node2["x-attribsPrefix"]) {
      clone_12["x-attribsPrefix"] = __assign$1({}, node2["x-attribsPrefix"]);
    }
    result2 = clone_12;
  } else if (isCDATA(node2)) {
    var children = recursive ? cloneChildren(node2.children) : [];
    var clone_2 = new CDATA(children);
    children.forEach(function(child) {
      return child.parent = clone_2;
    });
    result2 = clone_2;
  } else if (isDocument(node2)) {
    var children = recursive ? cloneChildren(node2.children) : [];
    var clone_3 = new Document$4(children);
    children.forEach(function(child) {
      return child.parent = clone_3;
    });
    if (node2["x-mode"]) {
      clone_3["x-mode"] = node2["x-mode"];
    }
    result2 = clone_3;
  } else if (isDirective(node2)) {
    var instruction = new ProcessingInstruction(node2.name, node2.data);
    if (node2["x-name"] != null) {
      instruction["x-name"] = node2["x-name"];
      instruction["x-publicId"] = node2["x-publicId"];
      instruction["x-systemId"] = node2["x-systemId"];
    }
    result2 = instruction;
  } else {
    throw new Error("Not implemented yet: ".concat(node2.type));
  }
  result2.startIndex = node2.startIndex;
  result2.endIndex = node2.endIndex;
  if (node2.sourceCodeLocation != null) {
    result2.sourceCodeLocation = node2.sourceCodeLocation;
  }
  return result2;
}
node$1.cloneNode = cloneNode$1;
function cloneChildren(childs) {
  var children = childs.map(function(child) {
    return cloneNode$1(child, true);
  });
  for (var i2 = 1; i2 < children.length; i2++) {
    children[i2].prev = children[i2 - 1];
    children[i2 - 1].next = children[i2];
  }
  return children;
}
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m, exports2) {
    for (var p in m)
      if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p))
        __createBinding2(exports2, m, p);
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.DomHandler = void 0;
  var domelementtype_12 = lib$3;
  var node_js_1 = node$1;
  __exportStar(node$1, exports);
  var defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
  };
  var DomHandler = (
    /** @class */
    function() {
      function DomHandler2(callback, options, elementCB) {
        this.dom = [];
        this.root = new node_js_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
        if (typeof options === "function") {
          elementCB = options;
          options = defaultOpts;
        }
        if (typeof callback === "object") {
          options = callback;
          callback = void 0;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
      }
      DomHandler2.prototype.onparserinit = function(parser2) {
        this.parser = parser2;
      };
      DomHandler2.prototype.onreset = function() {
        this.dom = [];
        this.root = new node_js_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
      };
      DomHandler2.prototype.onend = function() {
        if (this.done)
          return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
      };
      DomHandler2.prototype.onerror = function(error2) {
        this.handleCallback(error2);
      };
      DomHandler2.prototype.onclosetag = function() {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
          elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
          this.elementCB(elem);
      };
      DomHandler2.prototype.onopentag = function(name, attribs) {
        var type = this.options.xmlMode ? domelementtype_12.ElementType.Tag : void 0;
        var element = new node_js_1.Element(name, attribs, void 0, type);
        this.addNode(element);
        this.tagStack.push(element);
      };
      DomHandler2.prototype.ontext = function(data) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_12.ElementType.Text) {
          lastNode.data += data;
          if (this.options.withEndIndices) {
            lastNode.endIndex = this.parser.endIndex;
          }
        } else {
          var node2 = new node_js_1.Text(data);
          this.addNode(node2);
          this.lastNode = node2;
        }
      };
      DomHandler2.prototype.oncomment = function(data) {
        if (this.lastNode && this.lastNode.type === domelementtype_12.ElementType.Comment) {
          this.lastNode.data += data;
          return;
        }
        var node2 = new node_js_1.Comment(data);
        this.addNode(node2);
        this.lastNode = node2;
      };
      DomHandler2.prototype.oncommentend = function() {
        this.lastNode = null;
      };
      DomHandler2.prototype.oncdatastart = function() {
        var text2 = new node_js_1.Text("");
        var node2 = new node_js_1.CDATA([text2]);
        this.addNode(node2);
        text2.parent = node2;
        this.lastNode = text2;
      };
      DomHandler2.prototype.oncdataend = function() {
        this.lastNode = null;
      };
      DomHandler2.prototype.onprocessinginstruction = function(name, data) {
        var node2 = new node_js_1.ProcessingInstruction(name, data);
        this.addNode(node2);
      };
      DomHandler2.prototype.handleCallback = function(error2) {
        if (typeof this.callback === "function") {
          this.callback(error2, this.dom);
        } else if (error2) {
          throw error2;
        }
      };
      DomHandler2.prototype.addNode = function(node2) {
        var parent2 = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent2.children[parent2.children.length - 1];
        if (this.options.withStartIndices) {
          node2.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
          node2.endIndex = this.parser.endIndex;
        }
        parent2.children.push(node2);
        if (previousSibling) {
          node2.prev = previousSibling;
          previousSibling.next = node2;
        }
        node2.parent = parent2;
        this.lastNode = null;
      };
      return DomHandler2;
    }()
  );
  exports.DomHandler = DomHandler;
  exports.default = DomHandler;
})(lib$4);
var lib$2 = {};
var stringify$5 = {};
var lib$1 = {};
var lib = {};
var encode = {};
var encodeHtml = {};
Object.defineProperty(encodeHtml, "__esModule", { value: true });
function restoreDiff(arr) {
  for (var i2 = 1; i2 < arr.length; i2++) {
    arr[i2][0] += arr[i2 - 1][0] + 1;
  }
  return arr;
}
encodeHtml.default = new Map(/* @__PURE__ */ restoreDiff([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ restoreDiff([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var _escape = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.getCodePoint = exports.xmlReplacer = void 0;
  exports.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var xmlCodeMap = /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"]
  ]);
  exports.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? function(str, index2) {
    return str.codePointAt(index2);
  } : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(c, index2) {
      return (c.charCodeAt(index2) & 64512) === 55296 ? (c.charCodeAt(index2) - 55296) * 1024 + c.charCodeAt(index2 + 1) - 56320 + 65536 : c.charCodeAt(index2);
    }
  );
  function encodeXML(str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while ((match = exports.xmlReplacer.exec(str)) !== null) {
      var i2 = match.index;
      var char = str.charCodeAt(i2);
      var next = xmlCodeMap.get(char);
      if (next !== void 0) {
        ret += str.substring(lastIdx, i2) + next;
        lastIdx = i2 + 1;
      } else {
        ret += "".concat(str.substring(lastIdx, i2), "&#x").concat((0, exports.getCodePoint)(str, i2).toString(16), ";");
        lastIdx = exports.xmlReplacer.lastIndex += Number((char & 64512) === 55296);
      }
    }
    return ret + str.substr(lastIdx);
  }
  exports.encodeXML = encodeXML;
  exports.escape = encodeXML;
  function getEscaper(regex, map) {
    return function escape2(data) {
      var match;
      var lastIdx = 0;
      var result2 = "";
      while (match = regex.exec(data)) {
        if (lastIdx !== match.index) {
          result2 += data.substring(lastIdx, match.index);
        }
        result2 += map.get(match[0].charCodeAt(0));
        lastIdx = match.index + 1;
      }
      return result2 + data.substring(lastIdx);
    };
  }
  exports.escapeUTF8 = getEscaper(/[&<>'"]/g, xmlCodeMap);
  exports.escapeAttribute = getEscaper(/["&\u00A0]/g, /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"]
  ]));
  exports.escapeText = getEscaper(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"]
  ]));
})(_escape);
var __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(encode, "__esModule", { value: true });
encode.encodeNonAsciiHTML = encode.encodeHTML = void 0;
var encode_html_js_1 = __importDefault$1(encodeHtml);
var escape_js_1 = _escape;
var htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function encodeHTML(data) {
  return encodeHTMLTrieRe(htmlReplacer, data);
}
encode.encodeHTML = encodeHTML;
function encodeNonAsciiHTML(data) {
  return encodeHTMLTrieRe(escape_js_1.xmlReplacer, data);
}
encode.encodeNonAsciiHTML = encodeNonAsciiHTML;
function encodeHTMLTrieRe(regExp, str) {
  var ret = "";
  var lastIdx = 0;
  var match;
  while ((match = regExp.exec(str)) !== null) {
    var i2 = match.index;
    ret += str.substring(lastIdx, i2);
    var char = str.charCodeAt(i2);
    var next = encode_html_js_1.default.get(char);
    if (typeof next === "object") {
      if (i2 + 1 < str.length) {
        var nextChar = str.charCodeAt(i2 + 1);
        var value = typeof next.n === "number" ? next.n === nextChar ? next.o : void 0 : next.n.get(nextChar);
        if (value !== void 0) {
          ret += value;
          lastIdx = regExp.lastIndex += 1;
          continue;
        }
      }
      next = next.v;
    }
    if (next !== void 0) {
      ret += next;
      lastIdx = i2 + 1;
    } else {
      var cp = (0, escape_js_1.getCodePoint)(str, i2);
      ret += "&#x".concat(cp.toString(16), ";");
      lastIdx = regExp.lastIndex += Number(cp !== char);
    }
  }
  return ret + str.substr(lastIdx);
}
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLAttribute = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.DecodingMode = exports.EntityDecoder = exports.encodeHTML5 = exports.encodeHTML4 = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = exports.EncodingMode = exports.EntityLevel = void 0;
  var decode_js_12 = decode;
  var encode_js_1 = encode;
  var escape_js_12 = _escape;
  var EntityLevel;
  (function(EntityLevel2) {
    EntityLevel2[EntityLevel2["XML"] = 0] = "XML";
    EntityLevel2[EntityLevel2["HTML"] = 1] = "HTML";
  })(EntityLevel = exports.EntityLevel || (exports.EntityLevel = {}));
  var EncodingMode;
  (function(EncodingMode2) {
    EncodingMode2[EncodingMode2["UTF8"] = 0] = "UTF8";
    EncodingMode2[EncodingMode2["ASCII"] = 1] = "ASCII";
    EncodingMode2[EncodingMode2["Extensive"] = 2] = "Extensive";
    EncodingMode2[EncodingMode2["Attribute"] = 3] = "Attribute";
    EncodingMode2[EncodingMode2["Text"] = 4] = "Text";
  })(EncodingMode = exports.EncodingMode || (exports.EncodingMode = {}));
  function decode$1(data, options) {
    if (options === void 0) {
      options = EntityLevel.XML;
    }
    var level = typeof options === "number" ? options : options.level;
    if (level === EntityLevel.HTML) {
      var mode = typeof options === "object" ? options.mode : void 0;
      return (0, decode_js_12.decodeHTML)(data, mode);
    }
    return (0, decode_js_12.decodeXML)(data);
  }
  exports.decode = decode$1;
  function decodeStrict(data, options) {
    var _a2;
    if (options === void 0) {
      options = EntityLevel.XML;
    }
    var opts = typeof options === "number" ? { level: options } : options;
    (_a2 = opts.mode) !== null && _a2 !== void 0 ? _a2 : opts.mode = decode_js_12.DecodingMode.Strict;
    return decode$1(data, opts);
  }
  exports.decodeStrict = decodeStrict;
  function encode$12(data, options) {
    if (options === void 0) {
      options = EntityLevel.XML;
    }
    var opts = typeof options === "number" ? { level: options } : options;
    if (opts.mode === EncodingMode.UTF8)
      return (0, escape_js_12.escapeUTF8)(data);
    if (opts.mode === EncodingMode.Attribute)
      return (0, escape_js_12.escapeAttribute)(data);
    if (opts.mode === EncodingMode.Text)
      return (0, escape_js_12.escapeText)(data);
    if (opts.level === EntityLevel.HTML) {
      if (opts.mode === EncodingMode.ASCII) {
        return (0, encode_js_1.encodeNonAsciiHTML)(data);
      }
      return (0, encode_js_1.encodeHTML)(data);
    }
    return (0, escape_js_12.encodeXML)(data);
  }
  exports.encode = encode$12;
  var escape_js_2 = _escape;
  Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function() {
    return escape_js_2.encodeXML;
  } });
  Object.defineProperty(exports, "escape", { enumerable: true, get: function() {
    return escape_js_2.escape;
  } });
  Object.defineProperty(exports, "escapeUTF8", { enumerable: true, get: function() {
    return escape_js_2.escapeUTF8;
  } });
  Object.defineProperty(exports, "escapeAttribute", { enumerable: true, get: function() {
    return escape_js_2.escapeAttribute;
  } });
  Object.defineProperty(exports, "escapeText", { enumerable: true, get: function() {
    return escape_js_2.escapeText;
  } });
  var encode_js_2 = encode;
  Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function() {
    return encode_js_2.encodeHTML;
  } });
  Object.defineProperty(exports, "encodeNonAsciiHTML", { enumerable: true, get: function() {
    return encode_js_2.encodeNonAsciiHTML;
  } });
  Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function() {
    return encode_js_2.encodeHTML;
  } });
  Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function() {
    return encode_js_2.encodeHTML;
  } });
  var decode_js_2 = decode;
  Object.defineProperty(exports, "EntityDecoder", { enumerable: true, get: function() {
    return decode_js_2.EntityDecoder;
  } });
  Object.defineProperty(exports, "DecodingMode", { enumerable: true, get: function() {
    return decode_js_2.DecodingMode;
  } });
  Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function() {
    return decode_js_2.decodeXML;
  } });
  Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function() {
    return decode_js_2.decodeHTML;
  } });
  Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function() {
    return decode_js_2.decodeHTMLStrict;
  } });
  Object.defineProperty(exports, "decodeHTMLAttribute", { enumerable: true, get: function() {
    return decode_js_2.decodeHTMLAttribute;
  } });
  Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function() {
    return decode_js_2.decodeHTML;
  } });
  Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function() {
    return decode_js_2.decodeHTML;
  } });
  Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function() {
    return decode_js_2.decodeHTMLStrict;
  } });
  Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function() {
    return decode_js_2.decodeHTMLStrict;
  } });
  Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function() {
    return decode_js_2.decodeXML;
  } });
})(lib);
var foreignNames = {};
Object.defineProperty(foreignNames, "__esModule", { value: true });
foreignNames.attributeNames = foreignNames.elementNames = void 0;
foreignNames.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(val) {
  return [val.toLowerCase(), val];
}));
foreignNames.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(val) {
  return [val.toLowerCase(), val];
}));
var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign = Object.assign || function(t3) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p))
          t3[p] = s2[p];
    }
    return t3;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = { enumerable: true, get: function() {
      return m[k];
    } };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
} : function(o, v) {
  o["default"] = v;
});
var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(mod) {
  if (mod && mod.__esModule)
    return mod;
  var result2 = {};
  if (mod != null) {
    for (var k in mod)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
        __createBinding(result2, mod, k);
  }
  __setModuleDefault(result2, mod);
  return result2;
};
Object.defineProperty(lib$1, "__esModule", { value: true });
lib$1.render = void 0;
var ElementType = __importStar(lib$3);
var entities_1 = lib;
var foreignNames_js_1 = foreignNames;
var unencodedElements = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function replaceQuotes(value) {
  return value.replace(/"/g, "&quot;");
}
function formatAttributes(attributes2, opts) {
  var _a2;
  if (!attributes2)
    return;
  var encode2 = ((_a2 = opts.encodeEntities) !== null && _a2 !== void 0 ? _a2 : opts.decodeEntities) === false ? replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? entities_1.encodeXML : entities_1.escapeAttribute;
  return Object.keys(attributes2).map(function(key) {
    var _a3, _b2;
    var value = (_a3 = attributes2[key]) !== null && _a3 !== void 0 ? _a3 : "";
    if (opts.xmlMode === "foreign") {
      key = (_b2 = foreignNames_js_1.attributeNames.get(key)) !== null && _b2 !== void 0 ? _b2 : key;
    }
    if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
      return key;
    }
    return "".concat(key, '="').concat(encode2(value), '"');
  }).join(" ");
}
var singleTag = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function render$C(node2, options) {
  if (options === void 0) {
    options = {};
  }
  var nodes = "length" in node2 ? node2 : [node2];
  var output = "";
  for (var i2 = 0; i2 < nodes.length; i2++) {
    output += renderNode(nodes[i2], options);
  }
  return output;
}
lib$1.render = render$C;
lib$1.default = render$C;
function renderNode(node2, options) {
  switch (node2.type) {
    case ElementType.Root:
      return render$C(node2.children, options);
    case ElementType.Doctype:
    case ElementType.Directive:
      return renderDirective(node2);
    case ElementType.Comment:
      return renderComment(node2);
    case ElementType.CDATA:
      return renderCdata(node2);
    case ElementType.Script:
    case ElementType.Style:
    case ElementType.Tag:
      return renderTag(node2, options);
    case ElementType.Text:
      return renderText(node2, options);
  }
}
var foreignModeIntegrationPoints = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]);
var foreignElements = /* @__PURE__ */ new Set(["svg", "math"]);
function renderTag(elem, opts) {
  var _a2;
  if (opts.xmlMode === "foreign") {
    elem.name = (_a2 = foreignNames_js_1.elementNames.get(elem.name)) !== null && _a2 !== void 0 ? _a2 : elem.name;
    if (elem.parent && foreignModeIntegrationPoints.has(elem.parent.name)) {
      opts = __assign(__assign({}, opts), { xmlMode: false });
    }
  }
  if (!opts.xmlMode && foreignElements.has(elem.name)) {
    opts = __assign(__assign({}, opts), { xmlMode: "foreign" });
  }
  var tag = "<".concat(elem.name);
  var attribs = formatAttributes(elem.attribs, opts);
  if (attribs) {
    tag += " ".concat(attribs);
  }
  if (elem.children.length === 0 && (opts.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    opts.selfClosingTags !== false
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    opts.selfClosingTags && singleTag.has(elem.name)
  ))) {
    if (!opts.xmlMode)
      tag += " ";
    tag += "/>";
  } else {
    tag += ">";
    if (elem.children.length > 0) {
      tag += render$C(elem.children, opts);
    }
    if (opts.xmlMode || !singleTag.has(elem.name)) {
      tag += "</".concat(elem.name, ">");
    }
  }
  return tag;
}
function renderDirective(elem) {
  return "<".concat(elem.data, ">");
}
function renderText(elem, opts) {
  var _a2;
  var data = elem.data || "";
  if (((_a2 = opts.encodeEntities) !== null && _a2 !== void 0 ? _a2 : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && unencodedElements.has(elem.parent.name))) {
    data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, entities_1.encodeXML)(data) : (0, entities_1.escapeText)(data);
  }
  return data;
}
function renderCdata(elem) {
  return "<![CDATA[".concat(elem.children[0].data, "]]>");
}
function renderComment(elem) {
  return "<!--".concat(elem.data, "-->");
}
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(stringify$5, "__esModule", { value: true });
stringify$5.getOuterHTML = getOuterHTML;
stringify$5.getInnerHTML = getInnerHTML;
stringify$5.getText = getText;
stringify$5.textContent = textContent;
stringify$5.innerText = innerText;
var domhandler_1$4 = lib$4;
var dom_serializer_1 = __importDefault(lib$1);
var domelementtype_1 = lib$3;
function getOuterHTML(node2, options) {
  return (0, dom_serializer_1.default)(node2, options);
}
function getInnerHTML(node2, options) {
  return (0, domhandler_1$4.hasChildren)(node2) ? node2.children.map(function(node3) {
    return getOuterHTML(node3, options);
  }).join("") : "";
}
function getText(node2) {
  if (Array.isArray(node2))
    return node2.map(getText).join("");
  if ((0, domhandler_1$4.isTag)(node2))
    return node2.name === "br" ? "\n" : getText(node2.children);
  if ((0, domhandler_1$4.isCDATA)(node2))
    return getText(node2.children);
  if ((0, domhandler_1$4.isText)(node2))
    return node2.data;
  return "";
}
function textContent(node2) {
  if (Array.isArray(node2))
    return node2.map(textContent).join("");
  if ((0, domhandler_1$4.hasChildren)(node2) && !(0, domhandler_1$4.isComment)(node2)) {
    return textContent(node2.children);
  }
  if ((0, domhandler_1$4.isText)(node2))
    return node2.data;
  return "";
}
function innerText(node2) {
  if (Array.isArray(node2))
    return node2.map(innerText).join("");
  if ((0, domhandler_1$4.hasChildren)(node2) && (node2.type === domelementtype_1.ElementType.Tag || (0, domhandler_1$4.isCDATA)(node2))) {
    return innerText(node2.children);
  }
  if ((0, domhandler_1$4.isText)(node2))
    return node2.data;
  return "";
}
var traversal = {};
Object.defineProperty(traversal, "__esModule", { value: true });
traversal.getChildren = getChildren;
traversal.getParent = getParent;
traversal.getSiblings = getSiblings;
traversal.getAttributeValue = getAttributeValue;
traversal.hasAttrib = hasAttrib;
traversal.getName = getName;
traversal.nextElementSibling = nextElementSibling;
traversal.prevElementSibling = prevElementSibling;
var domhandler_1$3 = lib$4;
function getChildren(elem) {
  return (0, domhandler_1$3.hasChildren)(elem) ? elem.children : [];
}
function getParent(elem) {
  return elem.parent || null;
}
function getSiblings(elem) {
  var _a2, _b2;
  var parent2 = getParent(elem);
  if (parent2 != null)
    return getChildren(parent2);
  var siblings = [elem];
  var prev = elem.prev, next = elem.next;
  while (prev != null) {
    siblings.unshift(prev);
    _a2 = prev, prev = _a2.prev;
  }
  while (next != null) {
    siblings.push(next);
    _b2 = next, next = _b2.next;
  }
  return siblings;
}
function getAttributeValue(elem, name) {
  var _a2;
  return (_a2 = elem.attribs) === null || _a2 === void 0 ? void 0 : _a2[name];
}
function hasAttrib(elem, name) {
  return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
function getName(elem) {
  return elem.name;
}
function nextElementSibling(elem) {
  var _a2;
  var next = elem.next;
  while (next !== null && !(0, domhandler_1$3.isTag)(next))
    _a2 = next, next = _a2.next;
  return next;
}
function prevElementSibling(elem) {
  var _a2;
  var prev = elem.prev;
  while (prev !== null && !(0, domhandler_1$3.isTag)(prev))
    _a2 = prev, prev = _a2.prev;
  return prev;
}
var manipulation = {};
Object.defineProperty(manipulation, "__esModule", { value: true });
manipulation.removeElement = removeElement;
manipulation.replaceElement = replaceElement;
manipulation.appendChild = appendChild;
manipulation.append = append;
manipulation.prependChild = prependChild;
manipulation.prepend = prepend;
function removeElement(elem) {
  if (elem.prev)
    elem.prev.next = elem.next;
  if (elem.next)
    elem.next.prev = elem.prev;
  if (elem.parent) {
    var childs = elem.parent.children;
    var childsIndex = childs.lastIndexOf(elem);
    if (childsIndex >= 0) {
      childs.splice(childsIndex, 1);
    }
  }
  elem.next = null;
  elem.prev = null;
  elem.parent = null;
}
function replaceElement(elem, replacement) {
  var prev = replacement.prev = elem.prev;
  if (prev) {
    prev.next = replacement;
  }
  var next = replacement.next = elem.next;
  if (next) {
    next.prev = replacement;
  }
  var parent2 = replacement.parent = elem.parent;
  if (parent2) {
    var childs = parent2.children;
    childs[childs.lastIndexOf(elem)] = replacement;
    elem.parent = null;
  }
}
function appendChild(parent2, child) {
  removeElement(child);
  child.next = null;
  child.parent = parent2;
  if (parent2.children.push(child) > 1) {
    var sibling = parent2.children[parent2.children.length - 2];
    sibling.next = child;
    child.prev = sibling;
  } else {
    child.prev = null;
  }
}
function append(elem, next) {
  removeElement(next);
  var parent2 = elem.parent;
  var currNext = elem.next;
  next.next = currNext;
  next.prev = elem;
  elem.next = next;
  next.parent = parent2;
  if (currNext) {
    currNext.prev = next;
    if (parent2) {
      var childs = parent2.children;
      childs.splice(childs.lastIndexOf(currNext), 0, next);
    }
  } else if (parent2) {
    parent2.children.push(next);
  }
}
function prependChild(parent2, child) {
  removeElement(child);
  child.parent = parent2;
  child.prev = null;
  if (parent2.children.unshift(child) !== 1) {
    var sibling = parent2.children[1];
    sibling.prev = child;
    child.next = sibling;
  } else {
    child.next = null;
  }
}
function prepend(elem, prev) {
  removeElement(prev);
  var parent2 = elem.parent;
  if (parent2) {
    var childs = parent2.children;
    childs.splice(childs.indexOf(elem), 0, prev);
  }
  if (elem.prev) {
    elem.prev.next = prev;
  }
  prev.parent = parent2;
  prev.prev = elem.prev;
  prev.next = elem;
  elem.prev = prev;
}
var querying = {};
Object.defineProperty(querying, "__esModule", { value: true });
querying.filter = filter$1;
querying.find = find$1;
querying.findOneChild = findOneChild;
querying.findOne = findOne;
querying.existsOne = existsOne;
querying.findAll = findAll;
var domhandler_1$2 = lib$4;
function filter$1(test, node2, recurse, limit) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (limit === void 0) {
    limit = Infinity;
  }
  return find$1(test, Array.isArray(node2) ? node2 : [node2], recurse, limit);
}
function find$1(test, nodes, recurse, limit) {
  var result2 = [];
  var nodeStack = [Array.isArray(nodes) ? nodes : [nodes]];
  var indexStack = [0];
  for (; ; ) {
    if (indexStack[0] >= nodeStack[0].length) {
      if (indexStack.length === 1) {
        return result2;
      }
      nodeStack.shift();
      indexStack.shift();
      continue;
    }
    var elem = nodeStack[0][indexStack[0]++];
    if (test(elem)) {
      result2.push(elem);
      if (--limit <= 0)
        return result2;
    }
    if (recurse && (0, domhandler_1$2.hasChildren)(elem) && elem.children.length > 0) {
      indexStack.unshift(0);
      nodeStack.unshift(elem.children);
    }
  }
}
function findOneChild(test, nodes) {
  return nodes.find(test);
}
function findOne(test, nodes, recurse) {
  if (recurse === void 0) {
    recurse = true;
  }
  var searchedNodes = Array.isArray(nodes) ? nodes : [nodes];
  for (var i2 = 0; i2 < searchedNodes.length; i2++) {
    var node2 = searchedNodes[i2];
    if ((0, domhandler_1$2.isTag)(node2) && test(node2)) {
      return node2;
    }
    if (recurse && (0, domhandler_1$2.hasChildren)(node2) && node2.children.length > 0) {
      var found = findOne(test, node2.children, true);
      if (found)
        return found;
    }
  }
  return null;
}
function existsOne(test, nodes) {
  return (Array.isArray(nodes) ? nodes : [nodes]).some(function(node2) {
    return (0, domhandler_1$2.isTag)(node2) && test(node2) || (0, domhandler_1$2.hasChildren)(node2) && existsOne(test, node2.children);
  });
}
function findAll(test, nodes) {
  var result2 = [];
  var nodeStack = [Array.isArray(nodes) ? nodes : [nodes]];
  var indexStack = [0];
  for (; ; ) {
    if (indexStack[0] >= nodeStack[0].length) {
      if (nodeStack.length === 1) {
        return result2;
      }
      nodeStack.shift();
      indexStack.shift();
      continue;
    }
    var elem = nodeStack[0][indexStack[0]++];
    if ((0, domhandler_1$2.isTag)(elem) && test(elem))
      result2.push(elem);
    if ((0, domhandler_1$2.hasChildren)(elem) && elem.children.length > 0) {
      indexStack.unshift(0);
      nodeStack.unshift(elem.children);
    }
  }
}
var legacy = {};
Object.defineProperty(legacy, "__esModule", { value: true });
legacy.testElement = testElement;
legacy.getElements = getElements;
legacy.getElementById = getElementById;
legacy.getElementsByTagName = getElementsByTagName;
legacy.getElementsByClassName = getElementsByClassName;
legacy.getElementsByTagType = getElementsByTagType;
var domhandler_1$1 = lib$4;
var querying_js_1 = querying;
var Checks = {
  tag_name: function(name) {
    if (typeof name === "function") {
      return function(elem) {
        return (0, domhandler_1$1.isTag)(elem) && name(elem.name);
      };
    } else if (name === "*") {
      return domhandler_1$1.isTag;
    }
    return function(elem) {
      return (0, domhandler_1$1.isTag)(elem) && elem.name === name;
    };
  },
  tag_type: function(type) {
    if (typeof type === "function") {
      return function(elem) {
        return type(elem.type);
      };
    }
    return function(elem) {
      return elem.type === type;
    };
  },
  tag_contains: function(data) {
    if (typeof data === "function") {
      return function(elem) {
        return (0, domhandler_1$1.isText)(elem) && data(elem.data);
      };
    }
    return function(elem) {
      return (0, domhandler_1$1.isText)(elem) && elem.data === data;
    };
  }
};
function getAttribCheck(attrib, value) {
  if (typeof value === "function") {
    return function(elem) {
      return (0, domhandler_1$1.isTag)(elem) && value(elem.attribs[attrib]);
    };
  }
  return function(elem) {
    return (0, domhandler_1$1.isTag)(elem) && elem.attribs[attrib] === value;
  };
}
function combineFuncs(a, b) {
  return function(elem) {
    return a(elem) || b(elem);
  };
}
function compileTest(options) {
  var funcs = Object.keys(options).map(function(key) {
    var value = options[key];
    return Object.prototype.hasOwnProperty.call(Checks, key) ? Checks[key](value) : getAttribCheck(key, value);
  });
  return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
}
function testElement(options, node2) {
  var test = compileTest(options);
  return test ? test(node2) : true;
}
function getElements(options, nodes, recurse, limit) {
  if (limit === void 0) {
    limit = Infinity;
  }
  var test = compileTest(options);
  return test ? (0, querying_js_1.filter)(test, nodes, recurse, limit) : [];
}
function getElementById(id, nodes, recurse) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (!Array.isArray(nodes))
    nodes = [nodes];
  return (0, querying_js_1.findOne)(getAttribCheck("id", id), nodes, recurse);
}
function getElementsByTagName(tagName2, nodes, recurse, limit) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (limit === void 0) {
    limit = Infinity;
  }
  return (0, querying_js_1.filter)(Checks["tag_name"](tagName2), nodes, recurse, limit);
}
function getElementsByClassName(className, nodes, recurse, limit) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (limit === void 0) {
    limit = Infinity;
  }
  return (0, querying_js_1.filter)(getAttribCheck("class", className), nodes, recurse, limit);
}
function getElementsByTagType(type, nodes, recurse, limit) {
  if (recurse === void 0) {
    recurse = true;
  }
  if (limit === void 0) {
    limit = Infinity;
  }
  return (0, querying_js_1.filter)(Checks["tag_type"](type), nodes, recurse, limit);
}
var helpers$1 = {};
Object.defineProperty(helpers$1, "__esModule", { value: true });
helpers$1.DocumentPosition = void 0;
helpers$1.removeSubsets = removeSubsets;
helpers$1.compareDocumentPosition = compareDocumentPosition;
helpers$1.uniqueSort = uniqueSort;
var domhandler_1 = lib$4;
function removeSubsets(nodes) {
  var idx = nodes.length;
  while (--idx >= 0) {
    var node2 = nodes[idx];
    if (idx > 0 && nodes.lastIndexOf(node2, idx - 1) >= 0) {
      nodes.splice(idx, 1);
      continue;
    }
    for (var ancestor = node2.parent; ancestor; ancestor = ancestor.parent) {
      if (nodes.includes(ancestor)) {
        nodes.splice(idx, 1);
        break;
      }
    }
  }
  return nodes;
}
var DocumentPosition;
(function(DocumentPosition2) {
  DocumentPosition2[DocumentPosition2["DISCONNECTED"] = 1] = "DISCONNECTED";
  DocumentPosition2[DocumentPosition2["PRECEDING"] = 2] = "PRECEDING";
  DocumentPosition2[DocumentPosition2["FOLLOWING"] = 4] = "FOLLOWING";
  DocumentPosition2[DocumentPosition2["CONTAINS"] = 8] = "CONTAINS";
  DocumentPosition2[DocumentPosition2["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})(DocumentPosition || (helpers$1.DocumentPosition = DocumentPosition = {}));
function compareDocumentPosition(nodeA, nodeB) {
  var aParents = [];
  var bParents = [];
  if (nodeA === nodeB) {
    return 0;
  }
  var current = (0, domhandler_1.hasChildren)(nodeA) ? nodeA : nodeA.parent;
  while (current) {
    aParents.unshift(current);
    current = current.parent;
  }
  current = (0, domhandler_1.hasChildren)(nodeB) ? nodeB : nodeB.parent;
  while (current) {
    bParents.unshift(current);
    current = current.parent;
  }
  var maxIdx = Math.min(aParents.length, bParents.length);
  var idx = 0;
  while (idx < maxIdx && aParents[idx] === bParents[idx]) {
    idx++;
  }
  if (idx === 0) {
    return DocumentPosition.DISCONNECTED;
  }
  var sharedParent = aParents[idx - 1];
  var siblings = sharedParent.children;
  var aSibling = aParents[idx];
  var bSibling = bParents[idx];
  if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
    if (sharedParent === nodeB) {
      return DocumentPosition.FOLLOWING | DocumentPosition.CONTAINED_BY;
    }
    return DocumentPosition.FOLLOWING;
  }
  if (sharedParent === nodeA) {
    return DocumentPosition.PRECEDING | DocumentPosition.CONTAINS;
  }
  return DocumentPosition.PRECEDING;
}
function uniqueSort(nodes) {
  nodes = nodes.filter(function(node2, i2, arr) {
    return !arr.includes(node2, i2 + 1);
  });
  nodes.sort(function(a, b) {
    var relative2 = compareDocumentPosition(a, b);
    if (relative2 & DocumentPosition.PRECEDING) {
      return -1;
    } else if (relative2 & DocumentPosition.FOLLOWING) {
      return 1;
    }
    return 0;
  });
  return nodes;
}
var feeds = {};
Object.defineProperty(feeds, "__esModule", { value: true });
feeds.getFeed = getFeed;
var stringify_js_1 = stringify$5;
var legacy_js_1 = legacy;
function getFeed(doc) {
  var feedRoot = getOneElement(isValidFeed, doc);
  return !feedRoot ? null : feedRoot.name === "feed" ? getAtomFeed(feedRoot) : getRssFeed(feedRoot);
}
function getAtomFeed(feedRoot) {
  var _a2;
  var childs = feedRoot.children;
  var feed = {
    type: "atom",
    items: (0, legacy_js_1.getElementsByTagName)("entry", childs).map(function(item) {
      var _a3;
      var children = item.children;
      var entry = { media: getMediaElements(children) };
      addConditionally(entry, "id", "id", children);
      addConditionally(entry, "title", "title", children);
      var href2 = (_a3 = getOneElement("link", children)) === null || _a3 === void 0 ? void 0 : _a3.attribs["href"];
      if (href2) {
        entry.link = href2;
      }
      var description2 = fetch$1("summary", children) || fetch$1("content", children);
      if (description2) {
        entry.description = description2;
      }
      var pubDate = fetch$1("updated", children);
      if (pubDate) {
        entry.pubDate = new Date(pubDate);
      }
      return entry;
    })
  };
  addConditionally(feed, "id", "id", childs);
  addConditionally(feed, "title", "title", childs);
  var href = (_a2 = getOneElement("link", childs)) === null || _a2 === void 0 ? void 0 : _a2.attribs["href"];
  if (href) {
    feed.link = href;
  }
  addConditionally(feed, "description", "subtitle", childs);
  var updated3 = fetch$1("updated", childs);
  if (updated3) {
    feed.updated = new Date(updated3);
  }
  addConditionally(feed, "author", "email", childs, true);
  return feed;
}
function getRssFeed(feedRoot) {
  var _a2, _b2;
  var childs = (_b2 = (_a2 = getOneElement("channel", feedRoot.children)) === null || _a2 === void 0 ? void 0 : _a2.children) !== null && _b2 !== void 0 ? _b2 : [];
  var feed = {
    type: feedRoot.name.substr(0, 3),
    id: "",
    items: (0, legacy_js_1.getElementsByTagName)("item", feedRoot.children).map(function(item) {
      var children = item.children;
      var entry = { media: getMediaElements(children) };
      addConditionally(entry, "id", "guid", children);
      addConditionally(entry, "title", "title", children);
      addConditionally(entry, "link", "link", children);
      addConditionally(entry, "description", "description", children);
      var pubDate = fetch$1("pubDate", children) || fetch$1("dc:date", children);
      if (pubDate)
        entry.pubDate = new Date(pubDate);
      return entry;
    })
  };
  addConditionally(feed, "title", "title", childs);
  addConditionally(feed, "link", "link", childs);
  addConditionally(feed, "description", "description", childs);
  var updated3 = fetch$1("lastBuildDate", childs);
  if (updated3) {
    feed.updated = new Date(updated3);
  }
  addConditionally(feed, "author", "managingEditor", childs, true);
  return feed;
}
var MEDIA_KEYS_STRING = ["url", "type", "lang"];
var MEDIA_KEYS_INT = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function getMediaElements(where) {
  return (0, legacy_js_1.getElementsByTagName)("media:content", where).map(function(elem) {
    var attribs = elem.attribs;
    var media = {
      medium: attribs["medium"],
      isDefault: !!attribs["isDefault"]
    };
    for (var _i2 = 0, MEDIA_KEYS_STRING_1 = MEDIA_KEYS_STRING; _i2 < MEDIA_KEYS_STRING_1.length; _i2++) {
      var attrib = MEDIA_KEYS_STRING_1[_i2];
      if (attribs[attrib]) {
        media[attrib] = attribs[attrib];
      }
    }
    for (var _a2 = 0, MEDIA_KEYS_INT_1 = MEDIA_KEYS_INT; _a2 < MEDIA_KEYS_INT_1.length; _a2++) {
      var attrib = MEDIA_KEYS_INT_1[_a2];
      if (attribs[attrib]) {
        media[attrib] = parseInt(attribs[attrib], 10);
      }
    }
    if (attribs["expression"]) {
      media.expression = attribs["expression"];
    }
    return media;
  });
}
function getOneElement(tagName2, node2) {
  return (0, legacy_js_1.getElementsByTagName)(tagName2, node2, true, 1)[0];
}
function fetch$1(tagName2, where, recurse) {
  if (recurse === void 0) {
    recurse = false;
  }
  return (0, stringify_js_1.textContent)((0, legacy_js_1.getElementsByTagName)(tagName2, where, recurse, 1)).trim();
}
function addConditionally(obj, prop, tagName2, where, recurse) {
  if (recurse === void 0) {
    recurse = false;
  }
  var val = fetch$1(tagName2, where, recurse);
  if (val)
    obj[prop] = val;
}
function isValidFeed(value) {
  return value === "rss" || value === "feed" || value === "rdf:RDF";
}
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m, exports2) {
    for (var p in m)
      if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p))
        __createBinding2(exports2, m, p);
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.hasChildren = exports.isDocument = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = void 0;
  __exportStar(stringify$5, exports);
  __exportStar(traversal, exports);
  __exportStar(manipulation, exports);
  __exportStar(querying, exports);
  __exportStar(legacy, exports);
  __exportStar(helpers$1, exports);
  __exportStar(feeds, exports);
  var domhandler_12 = lib$4;
  Object.defineProperty(exports, "isTag", { enumerable: true, get: function() {
    return domhandler_12.isTag;
  } });
  Object.defineProperty(exports, "isCDATA", { enumerable: true, get: function() {
    return domhandler_12.isCDATA;
  } });
  Object.defineProperty(exports, "isText", { enumerable: true, get: function() {
    return domhandler_12.isText;
  } });
  Object.defineProperty(exports, "isComment", { enumerable: true, get: function() {
    return domhandler_12.isComment;
  } });
  Object.defineProperty(exports, "isDocument", { enumerable: true, get: function() {
    return domhandler_12.isDocument;
  } });
  Object.defineProperty(exports, "hasChildren", { enumerable: true, get: function() {
    return domhandler_12.hasChildren;
  } });
})(lib$2);
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod) {
    if (mod && mod.__esModule)
      return mod;
    var result2 = {};
    if (mod != null) {
      for (var k in mod)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding2(result2, mod, k);
    }
    __setModuleDefault2(result2, mod);
    return result2;
  };
  var __importDefault2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.DomUtils = exports.parseFeed = exports.getFeed = exports.ElementType = exports.Tokenizer = exports.createDomStream = exports.parseDOM = exports.parseDocument = exports.DefaultHandler = exports.DomHandler = exports.Parser = void 0;
  var Parser_js_1 = Parser$5;
  var Parser_js_2 = Parser$5;
  Object.defineProperty(exports, "Parser", { enumerable: true, get: function() {
    return Parser_js_2.Parser;
  } });
  var domhandler_12 = lib$4;
  var domhandler_2 = lib$4;
  Object.defineProperty(exports, "DomHandler", { enumerable: true, get: function() {
    return domhandler_2.DomHandler;
  } });
  Object.defineProperty(exports, "DefaultHandler", { enumerable: true, get: function() {
    return domhandler_2.DomHandler;
  } });
  function parseDocument(data, options) {
    var handler = new domhandler_12.DomHandler(void 0, options);
    new Parser_js_1.Parser(handler, options).end(data);
    return handler.root;
  }
  exports.parseDocument = parseDocument;
  function parseDOM(data, options) {
    return parseDocument(data, options).children;
  }
  exports.parseDOM = parseDOM;
  function createDomStream(callback, options, elementCallback) {
    var handler = new domhandler_12.DomHandler(callback, options, elementCallback);
    return new Parser_js_1.Parser(handler, options);
  }
  exports.createDomStream = createDomStream;
  var Tokenizer_js_12 = Tokenizer$3;
  Object.defineProperty(exports, "Tokenizer", { enumerable: true, get: function() {
    return __importDefault2(Tokenizer_js_12).default;
  } });
  exports.ElementType = __importStar2(lib$3);
  var domutils_1 = lib$2;
  var domutils_2 = lib$2;
  Object.defineProperty(exports, "getFeed", { enumerable: true, get: function() {
    return domutils_2.getFeed;
  } });
  var parseFeedDefaultOptions = { xmlMode: true };
  function parseFeed(feed, options) {
    if (options === void 0) {
      options = parseFeedDefaultOptions;
    }
    return (0, domutils_1.getFeed)(parseDOM(feed, options));
  }
  exports.parseFeed = parseFeed;
  exports.DomUtils = __importStar2(lib$2);
})(lib$5);
var escapeStringRegexp$1 = (string) => {
  if (typeof string !== "string") {
    throw new TypeError("Expected a string");
  }
  return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
var isPlainObject$3 = {};
Object.defineProperty(isPlainObject$3, "__esModule", { value: true });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function isObject$2(o) {
  return Object.prototype.toString.call(o) === "[object Object]";
}
function isPlainObject$2(o) {
  var ctor, prot;
  if (isObject$2(o) === false)
    return false;
  ctor = o.constructor;
  if (ctor === void 0)
    return true;
  prot = ctor.prototype;
  if (isObject$2(prot) === false)
    return false;
  if (prot.hasOwnProperty("isPrototypeOf") === false) {
    return false;
  }
  return true;
}
isPlainObject$3.isPlainObject = isPlainObject$2;
var isMergeableObject = function isMergeableObject2(value) {
  return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
  return !!value && typeof value === "object";
}
function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
}
var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge$1(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target2, source, options) {
  return target2.concat(source).map(function(element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}
function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge$1;
  }
  var customMerge = options.customMerge(key);
  return typeof customMerge === "function" ? customMerge : deepmerge$1;
}
function getEnumerableOwnPropertySymbols(target2) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target2).filter(function(symbol) {
    return Object.propertyIsEnumerable.call(target2, symbol);
  }) : [];
}
function getKeys(target2) {
  return Object.keys(target2).concat(getEnumerableOwnPropertySymbols(target2));
}
function propertyIsOnObject(object, property2) {
  try {
    return property2 in object;
  } catch (_) {
    return false;
  }
}
function propertyIsUnsafe(target2, key) {
  return propertyIsOnObject(target2, key) && !(Object.hasOwnProperty.call(target2, key) && Object.propertyIsEnumerable.call(target2, key));
}
function mergeObject(target2, source, options) {
  var destination = {};
  if (options.isMergeableObject(target2)) {
    getKeys(target2).forEach(function(key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target2[key], options);
    });
  }
  getKeys(source).forEach(function(key) {
    if (propertyIsUnsafe(target2, key)) {
      return;
    }
    if (propertyIsOnObject(target2, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target2[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}
function deepmerge$1(target2, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target2);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target2, source, options);
  } else {
    return mergeObject(target2, source, options);
  }
}
deepmerge$1.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error("first argument should be an array");
  }
  return array.reduce(function(prev, next) {
    return deepmerge$1(prev, next, options);
  }, {});
};
var deepmerge_1 = deepmerge$1;
var cjs = deepmerge_1;
var parseSrcset$1 = { exports: {} };
(function(module) {
  (function(root2, factory) {
    if (module.exports) {
      module.exports = factory();
    } else {
      root2.parseSrcset = factory();
    }
  })(commonjsGlobal, function() {
    return function(input2) {
      function isSpace(c2) {
        return c2 === " " || // space
        c2 === "	" || // horizontal tab
        c2 === "\n" || // new line
        c2 === "\f" || // form feed
        c2 === "\r";
      }
      function collectCharacters(regEx) {
        var chars, match = regEx.exec(input2.substring(pos));
        if (match) {
          chars = match[0];
          pos += chars.length;
          return chars;
        }
      }
      var inputLength = input2.length, regexLeadingSpaces = /^[ \t\n\r\u000c]+/, regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/, regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/, regexTrailingCommas = /[,]+$/, regexNonNegativeInteger = /^\d+$/, regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, url, descriptors, currentDescriptor, state, c, pos = 0, candidates = [];
      while (true) {
        collectCharacters(regexLeadingCommasOrSpaces);
        if (pos >= inputLength) {
          return candidates;
        }
        url = collectCharacters(regexLeadingNotSpaces);
        descriptors = [];
        if (url.slice(-1) === ",") {
          url = url.replace(regexTrailingCommas, "");
          parseDescriptors();
        } else {
          tokenize2();
        }
      }
      function tokenize2() {
        collectCharacters(regexLeadingSpaces);
        currentDescriptor = "";
        state = "in descriptor";
        while (true) {
          c = input2.charAt(pos);
          if (state === "in descriptor") {
            if (isSpace(c)) {
              if (currentDescriptor) {
                descriptors.push(currentDescriptor);
                currentDescriptor = "";
                state = "after descriptor";
              }
            } else if (c === ",") {
              pos += 1;
              if (currentDescriptor) {
                descriptors.push(currentDescriptor);
              }
              parseDescriptors();
              return;
            } else if (c === "(") {
              currentDescriptor = currentDescriptor + c;
              state = "in parens";
            } else if (c === "") {
              if (currentDescriptor) {
                descriptors.push(currentDescriptor);
              }
              parseDescriptors();
              return;
            } else {
              currentDescriptor = currentDescriptor + c;
            }
          } else if (state === "in parens") {
            if (c === ")") {
              currentDescriptor = currentDescriptor + c;
              state = "in descriptor";
            } else if (c === "") {
              descriptors.push(currentDescriptor);
              parseDescriptors();
              return;
            } else {
              currentDescriptor = currentDescriptor + c;
            }
          } else if (state === "after descriptor") {
            if (isSpace(c))
              ;
            else if (c === "") {
              parseDescriptors();
              return;
            } else {
              state = "in descriptor";
              pos -= 1;
            }
          }
          pos += 1;
        }
      }
      function parseDescriptors() {
        var pError = false, w, d2, h, i2, candidate = {}, desc, lastChar, value, intVal, floatVal;
        for (i2 = 0; i2 < descriptors.length; i2++) {
          desc = descriptors[i2];
          lastChar = desc[desc.length - 1];
          value = desc.substring(0, desc.length - 1);
          intVal = parseInt(value, 10);
          floatVal = parseFloat(value);
          if (regexNonNegativeInteger.test(value) && lastChar === "w") {
            if (w || d2) {
              pError = true;
            }
            if (intVal === 0) {
              pError = true;
            } else {
              w = intVal;
            }
          } else if (regexFloatingPoint.test(value) && lastChar === "x") {
            if (w || d2 || h) {
              pError = true;
            }
            if (floatVal < 0) {
              pError = true;
            } else {
              d2 = floatVal;
            }
          } else if (regexNonNegativeInteger.test(value) && lastChar === "h") {
            if (h || d2) {
              pError = true;
            }
            if (intVal === 0) {
              pError = true;
            } else {
              h = intVal;
            }
          } else {
            pError = true;
          }
        }
        if (!pError) {
          candidate.url = url;
          if (w) {
            candidate.w = w;
          }
          if (d2) {
            candidate.d = d2;
          }
          if (h) {
            candidate.h = h;
          }
          candidates.push(candidate);
        } else if (console && console.log) {
          console.log("Invalid srcset descriptor found in '" + input2 + "' at '" + desc + "'.");
        }
      }
    };
  });
})(parseSrcset$1);
var parseSrcsetExports = parseSrcset$1.exports;
var picocolors_browser = { exports: {} };
var x = String;
var create3 = function() {
  return { isColorSupported: false, reset: x, bold: x, dim: x, italic: x, underline: x, inverse: x, hidden: x, strikethrough: x, black: x, red: x, green: x, yellow: x, blue: x, magenta: x, cyan: x, white: x, gray: x, bgBlack: x, bgRed: x, bgGreen: x, bgYellow: x, bgBlue: x, bgMagenta: x, bgCyan: x, bgWhite: x, blackBright: x, redBright: x, greenBright: x, yellowBright: x, blueBright: x, magentaBright: x, cyanBright: x, whiteBright: x, bgBlackBright: x, bgRedBright: x, bgGreenBright: x, bgYellowBright: x, bgBlueBright: x, bgMagentaBright: x, bgCyanBright: x, bgWhiteBright: x };
};
picocolors_browser.exports = create3();
picocolors_browser.exports.createColors = create3;
var picocolors_browserExports = picocolors_browser.exports;
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
let pico = picocolors_browserExports;
let terminalHighlight$1 = require$$2;
let CssSyntaxError$3 = class CssSyntaxError extends Error {
  constructor(message, line, column, source, file, plugin3) {
    super(message);
    this.name = "CssSyntaxError";
    this.reason = message;
    if (file) {
      this.file = file;
    }
    if (source) {
      this.source = source;
    }
    if (plugin3) {
      this.plugin = plugin3;
    }
    if (typeof line !== "undefined" && typeof column !== "undefined") {
      if (typeof line === "number") {
        this.line = line;
        this.column = column;
      } else {
        this.line = line.line;
        this.column = line.column;
        this.endLine = column.line;
        this.endColumn = column.column;
      }
    }
    this.setMessage();
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CssSyntaxError);
    }
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "";
    this.message += this.file ? this.file : "<css input>";
    if (typeof this.line !== "undefined") {
      this.message += ":" + this.line + ":" + this.column;
    }
    this.message += ": " + this.reason;
  }
  showSourceCode(color2) {
    if (!this.source)
      return "";
    let css2 = this.source;
    if (color2 == null)
      color2 = pico.isColorSupported;
    let aside = (text2) => text2;
    let mark = (text2) => text2;
    let highlight = (text2) => text2;
    if (color2) {
      let { bold, gray, red } = pico.createColors(true);
      mark = (text2) => bold(red(text2));
      aside = (text2) => gray(text2);
      if (terminalHighlight$1) {
        highlight = (text2) => terminalHighlight$1(text2);
      }
    }
    let lines = css2.split(/\r?\n/);
    let start = Math.max(this.line - 3, 0);
    let end = Math.min(this.line + 2, lines.length);
    let maxWidth = String(end).length;
    return lines.slice(start, end).map((line, index2) => {
      let number = start + 1 + index2;
      let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
      if (number === this.line) {
        if (line.length > 160) {
          let padding = 20;
          let subLineStart = Math.max(0, this.column - padding);
          let subLineEnd = Math.max(
            this.column + padding,
            this.endColumn + padding
          );
          let subLine = line.slice(subLineStart, subLineEnd);
          let spacing2 = aside(gutter.replace(/\d/g, " ")) + line.slice(0, Math.min(this.column - 1, padding - 1)).replace(/[^\t]/g, " ");
          return mark(">") + aside(gutter) + highlight(subLine) + "\n " + spacing2 + mark("^");
        }
        let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return mark(">") + aside(gutter) + highlight(line) + "\n " + spacing + mark("^");
      }
      return " " + aside(gutter) + highlight(line);
    }).join("\n");
  }
  toString() {
    let code = this.showSourceCode();
    if (code) {
      code = "\n\n" + code + "\n";
    }
    return this.name + ": " + this.message + code;
  }
};
var cssSyntaxError = CssSyntaxError$3;
CssSyntaxError$3.default = CssSyntaxError$3;
const DEFAULT_RAW = {
  after: "\n",
  beforeClose: "\n",
  beforeComment: "\n",
  beforeDecl: "\n",
  beforeOpen: " ",
  beforeRule: "\n",
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: false
};
function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
}
let Stringifier$2 = class Stringifier {
  constructor(builder) {
    this.builder = builder;
  }
  atrule(node2, semicolon) {
    let name = "@" + node2.name;
    let params = node2.params ? this.rawValue(node2, "params") : "";
    if (typeof node2.raws.afterName !== "undefined") {
      name += node2.raws.afterName;
    } else if (params) {
      name += " ";
    }
    if (node2.nodes) {
      this.block(node2, name + params);
    } else {
      let end = (node2.raws.between || "") + (semicolon ? ";" : "");
      this.builder(name + params + end, node2);
    }
  }
  beforeAfter(node2, detect) {
    let value;
    if (node2.type === "decl") {
      value = this.raw(node2, null, "beforeDecl");
    } else if (node2.type === "comment") {
      value = this.raw(node2, null, "beforeComment");
    } else if (detect === "before") {
      value = this.raw(node2, null, "beforeRule");
    } else {
      value = this.raw(node2, null, "beforeClose");
    }
    let buf = node2.parent;
    let depth = 0;
    while (buf && buf.type !== "root") {
      depth += 1;
      buf = buf.parent;
    }
    if (value.includes("\n")) {
      let indent = this.raw(node2, null, "indent");
      if (indent.length) {
        for (let step = 0; step < depth; step++)
          value += indent;
      }
    }
    return value;
  }
  block(node2, start) {
    let between = this.raw(node2, "between", "beforeOpen");
    this.builder(start + between + "{", node2, "start");
    let after;
    if (node2.nodes && node2.nodes.length) {
      this.body(node2);
      after = this.raw(node2, "after");
    } else {
      after = this.raw(node2, "after", "emptyBody");
    }
    if (after)
      this.builder(after);
    this.builder("}", node2, "end");
  }
  body(node2) {
    let last2 = node2.nodes.length - 1;
    while (last2 > 0) {
      if (node2.nodes[last2].type !== "comment")
        break;
      last2 -= 1;
    }
    let semicolon = this.raw(node2, "semicolon");
    for (let i2 = 0; i2 < node2.nodes.length; i2++) {
      let child = node2.nodes[i2];
      let before = this.raw(child, "before");
      if (before)
        this.builder(before);
      this.stringify(child, last2 !== i2 || semicolon);
    }
  }
  comment(node2) {
    let left = this.raw(node2, "left", "commentLeft");
    let right = this.raw(node2, "right", "commentRight");
    this.builder("/*" + left + node2.text + right + "*/", node2);
  }
  decl(node2, semicolon) {
    let between = this.raw(node2, "between", "colon");
    let string = node2.prop + between + this.rawValue(node2, "value");
    if (node2.important) {
      string += node2.raws.important || " !important";
    }
    if (semicolon)
      string += ";";
    this.builder(string, node2);
  }
  document(node2) {
    this.body(node2);
  }
  raw(node2, own, detect) {
    let value;
    if (!detect)
      detect = own;
    if (own) {
      value = node2.raws[own];
      if (typeof value !== "undefined")
        return value;
    }
    let parent2 = node2.parent;
    if (detect === "before") {
      if (!parent2 || parent2.type === "root" && parent2.first === node2) {
        return "";
      }
      if (parent2 && parent2.type === "document") {
        return "";
      }
    }
    if (!parent2)
      return DEFAULT_RAW[detect];
    let root2 = node2.root();
    if (!root2.rawCache)
      root2.rawCache = {};
    if (typeof root2.rawCache[detect] !== "undefined") {
      return root2.rawCache[detect];
    }
    if (detect === "before" || detect === "after") {
      return this.beforeAfter(node2, detect);
    } else {
      let method = "raw" + capitalize(detect);
      if (this[method]) {
        value = this[method](root2, node2);
      } else {
        root2.walk((i2) => {
          value = i2.raws[own];
          if (typeof value !== "undefined")
            return false;
        });
      }
    }
    if (typeof value === "undefined")
      value = DEFAULT_RAW[detect];
    root2.rawCache[detect] = value;
    return value;
  }
  rawBeforeClose(root2) {
    let value;
    root2.walk((i2) => {
      if (i2.nodes && i2.nodes.length > 0) {
        if (typeof i2.raws.after !== "undefined") {
          value = i2.raws.after;
          if (value.includes("\n")) {
            value = value.replace(/[^\n]+$/, "");
          }
          return false;
        }
      }
    });
    if (value)
      value = value.replace(/\S/g, "");
    return value;
  }
  rawBeforeComment(root2, node2) {
    let value;
    root2.walkComments((i2) => {
      if (typeof i2.raws.before !== "undefined") {
        value = i2.raws.before;
        if (value.includes("\n")) {
          value = value.replace(/[^\n]+$/, "");
        }
        return false;
      }
    });
    if (typeof value === "undefined") {
      value = this.raw(node2, null, "beforeDecl");
    } else if (value) {
      value = value.replace(/\S/g, "");
    }
    return value;
  }
  rawBeforeDecl(root2, node2) {
    let value;
    root2.walkDecls((i2) => {
      if (typeof i2.raws.before !== "undefined") {
        value = i2.raws.before;
        if (value.includes("\n")) {
          value = value.replace(/[^\n]+$/, "");
        }
        return false;
      }
    });
    if (typeof value === "undefined") {
      value = this.raw(node2, null, "beforeRule");
    } else if (value) {
      value = value.replace(/\S/g, "");
    }
    return value;
  }
  rawBeforeOpen(root2) {
    let value;
    root2.walk((i2) => {
      if (i2.type !== "decl") {
        value = i2.raws.between;
        if (typeof value !== "undefined")
          return false;
      }
    });
    return value;
  }
  rawBeforeRule(root2) {
    let value;
    root2.walk((i2) => {
      if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
        if (typeof i2.raws.before !== "undefined") {
          value = i2.raws.before;
          if (value.includes("\n")) {
            value = value.replace(/[^\n]+$/, "");
          }
          return false;
        }
      }
    });
    if (value)
      value = value.replace(/\S/g, "");
    return value;
  }
  rawColon(root2) {
    let value;
    root2.walkDecls((i2) => {
      if (typeof i2.raws.between !== "undefined") {
        value = i2.raws.between.replace(/[^\s:]/g, "");
        return false;
      }
    });
    return value;
  }
  rawEmptyBody(root2) {
    let value;
    root2.walk((i2) => {
      if (i2.nodes && i2.nodes.length === 0) {
        value = i2.raws.after;
        if (typeof value !== "undefined")
          return false;
      }
    });
    return value;
  }
  rawIndent(root2) {
    if (root2.raws.indent)
      return root2.raws.indent;
    let value;
    root2.walk((i2) => {
      let p = i2.parent;
      if (p && p !== root2 && p.parent && p.parent === root2) {
        if (typeof i2.raws.before !== "undefined") {
          let parts = i2.raws.before.split("\n");
          value = parts[parts.length - 1];
          value = value.replace(/\S/g, "");
          return false;
        }
      }
    });
    return value;
  }
  rawSemicolon(root2) {
    let value;
    root2.walk((i2) => {
      if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
        value = i2.raws.semicolon;
        if (typeof value !== "undefined")
          return false;
      }
    });
    return value;
  }
  rawValue(node2, prop) {
    let value = node2[prop];
    let raw = node2.raws[prop];
    if (raw && raw.value === value) {
      return raw.raw;
    }
    return value;
  }
  root(node2) {
    this.body(node2);
    if (node2.raws.after)
      this.builder(node2.raws.after);
  }
  rule(node2) {
    this.block(node2, this.rawValue(node2, "selector"));
    if (node2.raws.ownSemicolon) {
      this.builder(node2.raws.ownSemicolon, node2, "end");
    }
  }
  stringify(node2, semicolon) {
    if (!this[node2.type]) {
      throw new Error(
        "Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier."
      );
    }
    this[node2.type](node2, semicolon);
  }
};
var stringifier = Stringifier$2;
Stringifier$2.default = Stringifier$2;
let Stringifier$1 = stringifier;
function stringify$4(node2, builder) {
  let str = new Stringifier$1(builder);
  str.stringify(node2);
}
var stringify_1 = stringify$4;
stringify$4.default = stringify$4;
var symbols = {};
symbols.isClean = Symbol("isClean");
symbols.my = Symbol("my");
let CssSyntaxError$2 = cssSyntaxError;
let Stringifier2 = stringifier;
let stringify$3 = stringify_1;
let { isClean: isClean$2, my: my$2 } = symbols;
function cloneNode(obj, parent2) {
  let cloned = new obj.constructor();
  for (let i2 in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, i2)) {
      continue;
    }
    if (i2 === "proxyCache")
      continue;
    let value = obj[i2];
    let type = typeof value;
    if (i2 === "parent" && type === "object") {
      if (parent2)
        cloned[i2] = parent2;
    } else if (i2 === "source") {
      cloned[i2] = value;
    } else if (Array.isArray(value)) {
      cloned[i2] = value.map((j) => cloneNode(j, cloned));
    } else {
      if (type === "object" && value !== null)
        value = cloneNode(value);
      cloned[i2] = value;
    }
  }
  return cloned;
}
function sourceOffset(inputCSS, position) {
  if (position && typeof position.offset !== "undefined") {
    return position.offset;
  }
  let column = 1;
  let line = 1;
  let offset2 = 0;
  for (let i2 = 0; i2 < inputCSS.length; i2++) {
    if (line === position.line && column === position.column) {
      offset2 = i2;
      break;
    }
    if (inputCSS[i2] === "\n") {
      column = 1;
      line += 1;
    } else {
      column += 1;
    }
  }
  return offset2;
}
let Node$5 = class Node2 {
  get proxyOf() {
    return this;
  }
  constructor(defaults2 = {}) {
    this.raws = {};
    this[isClean$2] = false;
    this[my$2] = true;
    for (let name in defaults2) {
      if (name === "nodes") {
        this.nodes = [];
        for (let node2 of defaults2[name]) {
          if (typeof node2.clone === "function") {
            this.append(node2.clone());
          } else {
            this.append(node2);
          }
        }
      } else {
        this[name] = defaults2[name];
      }
    }
  }
  addToError(error2) {
    error2.postcssNode = this;
    if (error2.stack && this.source && /\n\s{4}at /.test(error2.stack)) {
      let s2 = this.source;
      error2.stack = error2.stack.replace(
        /\n\s{4}at /,
        `$&${s2.input.from}:${s2.start.line}:${s2.start.column}$&`
      );
    }
    return error2;
  }
  after(add2) {
    this.parent.insertAfter(this, add2);
    return this;
  }
  assign(overrides = {}) {
    for (let name in overrides) {
      this[name] = overrides[name];
    }
    return this;
  }
  before(add2) {
    this.parent.insertBefore(this, add2);
    return this;
  }
  cleanRaws(keepBetween) {
    delete this.raws.before;
    delete this.raws.after;
    if (!keepBetween)
      delete this.raws.between;
  }
  clone(overrides = {}) {
    let cloned = cloneNode(this);
    for (let name in overrides) {
      cloned[name] = overrides[name];
    }
    return cloned;
  }
  cloneAfter(overrides = {}) {
    let cloned = this.clone(overrides);
    this.parent.insertAfter(this, cloned);
    return cloned;
  }
  cloneBefore(overrides = {}) {
    let cloned = this.clone(overrides);
    this.parent.insertBefore(this, cloned);
    return cloned;
  }
  error(message, opts = {}) {
    if (this.source) {
      let { end, start } = this.rangeBy(opts);
      return this.source.input.error(
        message,
        { column: start.column, line: start.line },
        { column: end.column, line: end.line },
        opts
      );
    }
    return new CssSyntaxError$2(message);
  }
  getProxyProcessor() {
    return {
      get(node2, prop) {
        if (prop === "proxyOf") {
          return node2;
        } else if (prop === "root") {
          return () => node2.root().toProxy();
        } else {
          return node2[prop];
        }
      },
      set(node2, prop, value) {
        if (node2[prop] === value)
          return true;
        node2[prop] = value;
        if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */
        prop === "text") {
          node2.markDirty();
        }
        return true;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[isClean$2] = true;
  }
  markDirty() {
    if (this[isClean$2]) {
      this[isClean$2] = false;
      let next = this;
      while (next = next.parent) {
        next[isClean$2] = false;
      }
    }
  }
  next() {
    if (!this.parent)
      return void 0;
    let index2 = this.parent.index(this);
    return this.parent.nodes[index2 + 1];
  }
  positionBy(opts) {
    let pos = this.source.start;
    if (opts.index) {
      pos = this.positionInside(opts.index);
    } else if (opts.word) {
      let inputString = "document" in this.source.input ? this.source.input.document : this.source.input.css;
      let stringRepresentation = inputString.slice(
        sourceOffset(inputString, this.source.start),
        sourceOffset(inputString, this.source.end)
      );
      let index2 = stringRepresentation.indexOf(opts.word);
      if (index2 !== -1)
        pos = this.positionInside(index2);
    }
    return pos;
  }
  positionInside(index2) {
    let column = this.source.start.column;
    let line = this.source.start.line;
    let inputString = "document" in this.source.input ? this.source.input.document : this.source.input.css;
    let offset2 = sourceOffset(inputString, this.source.start);
    let end = offset2 + index2;
    for (let i2 = offset2; i2 < end; i2++) {
      if (inputString[i2] === "\n") {
        column = 1;
        line += 1;
      } else {
        column += 1;
      }
    }
    return { column, line };
  }
  prev() {
    if (!this.parent)
      return void 0;
    let index2 = this.parent.index(this);
    return this.parent.nodes[index2 - 1];
  }
  rangeBy(opts) {
    let start = {
      column: this.source.start.column,
      line: this.source.start.line
    };
    let end = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: start.column + 1,
      line: start.line
    };
    if (opts.word) {
      let inputString = "document" in this.source.input ? this.source.input.document : this.source.input.css;
      let stringRepresentation = inputString.slice(
        sourceOffset(inputString, this.source.start),
        sourceOffset(inputString, this.source.end)
      );
      let index2 = stringRepresentation.indexOf(opts.word);
      if (index2 !== -1) {
        start = this.positionInside(index2);
        end = this.positionInside(
          index2 + opts.word.length
        );
      }
    } else {
      if (opts.start) {
        start = {
          column: opts.start.column,
          line: opts.start.line
        };
      } else if (opts.index) {
        start = this.positionInside(opts.index);
      }
      if (opts.end) {
        end = {
          column: opts.end.column,
          line: opts.end.line
        };
      } else if (typeof opts.endIndex === "number") {
        end = this.positionInside(opts.endIndex);
      } else if (opts.index) {
        end = this.positionInside(opts.index + 1);
      }
    }
    if (end.line < start.line || end.line === start.line && end.column <= start.column) {
      end = { column: start.column + 1, line: start.line };
    }
    return { end, start };
  }
  raw(prop, defaultType) {
    let str = new Stringifier2();
    return str.raw(this, prop, defaultType);
  }
  remove() {
    if (this.parent) {
      this.parent.removeChild(this);
    }
    this.parent = void 0;
    return this;
  }
  replaceWith(...nodes) {
    if (this.parent) {
      let bookmark = this;
      let foundSelf = false;
      for (let node2 of nodes) {
        if (node2 === this) {
          foundSelf = true;
        } else if (foundSelf) {
          this.parent.insertAfter(bookmark, node2);
          bookmark = node2;
        } else {
          this.parent.insertBefore(bookmark, node2);
        }
      }
      if (!foundSelf) {
        this.remove();
      }
    }
    return this;
  }
  root() {
    let result2 = this;
    while (result2.parent && result2.parent.type !== "document") {
      result2 = result2.parent;
    }
    return result2;
  }
  toJSON(_, inputs) {
    let fixed = {};
    let emitInputs = inputs == null;
    inputs = inputs || /* @__PURE__ */ new Map();
    let inputsNextIndex = 0;
    for (let name in this) {
      if (!Object.prototype.hasOwnProperty.call(this, name)) {
        continue;
      }
      if (name === "parent" || name === "proxyCache")
        continue;
      let value = this[name];
      if (Array.isArray(value)) {
        fixed[name] = value.map((i2) => {
          if (typeof i2 === "object" && i2.toJSON) {
            return i2.toJSON(null, inputs);
          } else {
            return i2;
          }
        });
      } else if (typeof value === "object" && value.toJSON) {
        fixed[name] = value.toJSON(null, inputs);
      } else if (name === "source") {
        let inputId = inputs.get(value.input);
        if (inputId == null) {
          inputId = inputsNextIndex;
          inputs.set(value.input, inputsNextIndex);
          inputsNextIndex++;
        }
        fixed[name] = {
          end: value.end,
          inputId,
          start: value.start
        };
      } else {
        fixed[name] = value;
      }
    }
    if (emitInputs) {
      fixed.inputs = [...inputs.keys()].map((input2) => input2.toJSON());
    }
    return fixed;
  }
  toProxy() {
    if (!this.proxyCache) {
      this.proxyCache = new Proxy(this, this.getProxyProcessor());
    }
    return this.proxyCache;
  }
  toString(stringifier2 = stringify$3) {
    if (stringifier2.stringify)
      stringifier2 = stringifier2.stringify;
    let result2 = "";
    stringifier2(this, (i2) => {
      result2 += i2;
    });
    return result2;
  }
  warn(result2, text2, opts) {
    let data = { node: this };
    for (let i2 in opts)
      data[i2] = opts[i2];
    return result2.warn(text2, data);
  }
};
var node = Node$5;
Node$5.default = Node$5;
let Node$4 = node;
let Comment$4 = class Comment extends Node$4 {
  constructor(defaults2) {
    super(defaults2);
    this.type = "comment";
  }
};
var comment = Comment$4;
Comment$4.default = Comment$4;
let Node$3 = node;
let Declaration$4 = class Declaration extends Node$3 {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(defaults2) {
    if (defaults2 && typeof defaults2.value !== "undefined" && typeof defaults2.value !== "string") {
      defaults2 = __spreadProps(__spreadValues({}, defaults2), { value: String(defaults2.value) });
    }
    super(defaults2);
    this.type = "decl";
  }
};
var declaration = Declaration$4;
Declaration$4.default = Declaration$4;
let Comment$3 = comment;
let Declaration$3 = declaration;
let Node$2 = node;
let { isClean: isClean$1, my: my$1 } = symbols;
let AtRule$4, parse$6, Root$6, Rule$4;
function cleanSource(nodes) {
  return nodes.map((i2) => {
    if (i2.nodes)
      i2.nodes = cleanSource(i2.nodes);
    delete i2.source;
    return i2;
  });
}
function markTreeDirty(node2) {
  node2[isClean$1] = false;
  if (node2.proxyOf.nodes) {
    for (let i2 of node2.proxyOf.nodes) {
      markTreeDirty(i2);
    }
  }
}
let Container$7 = class Container extends Node$2 {
  get first() {
    if (!this.proxyOf.nodes)
      return void 0;
    return this.proxyOf.nodes[0];
  }
  get last() {
    if (!this.proxyOf.nodes)
      return void 0;
    return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...children) {
    for (let child of children) {
      let nodes = this.normalize(child, this.last);
      for (let node2 of nodes)
        this.proxyOf.nodes.push(node2);
    }
    this.markDirty();
    return this;
  }
  cleanRaws(keepBetween) {
    super.cleanRaws(keepBetween);
    if (this.nodes) {
      for (let node2 of this.nodes)
        node2.cleanRaws(keepBetween);
    }
  }
  each(callback) {
    if (!this.proxyOf.nodes)
      return void 0;
    let iterator = this.getIterator();
    let index2, result2;
    while (this.indexes[iterator] < this.proxyOf.nodes.length) {
      index2 = this.indexes[iterator];
      result2 = callback(this.proxyOf.nodes[index2], index2);
      if (result2 === false)
        break;
      this.indexes[iterator] += 1;
    }
    delete this.indexes[iterator];
    return result2;
  }
  every(condition) {
    return this.nodes.every(condition);
  }
  getIterator() {
    if (!this.lastEach)
      this.lastEach = 0;
    if (!this.indexes)
      this.indexes = {};
    this.lastEach += 1;
    let iterator = this.lastEach;
    this.indexes[iterator] = 0;
    return iterator;
  }
  getProxyProcessor() {
    return {
      get(node2, prop) {
        if (prop === "proxyOf") {
          return node2;
        } else if (!node2[prop]) {
          return node2[prop];
        } else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) {
          return (...args) => {
            return node2[prop](
              ...args.map((i2) => {
                if (typeof i2 === "function") {
                  return (child, index2) => i2(child.toProxy(), index2);
                } else {
                  return i2;
                }
              })
            );
          };
        } else if (prop === "every" || prop === "some") {
          return (cb) => {
            return node2[prop](
              (child, ...other) => cb(child.toProxy(), ...other)
            );
          };
        } else if (prop === "root") {
          return () => node2.root().toProxy();
        } else if (prop === "nodes") {
          return node2.nodes.map((i2) => i2.toProxy());
        } else if (prop === "first" || prop === "last") {
          return node2[prop].toProxy();
        } else {
          return node2[prop];
        }
      },
      set(node2, prop, value) {
        if (node2[prop] === value)
          return true;
        node2[prop] = value;
        if (prop === "name" || prop === "params" || prop === "selector") {
          node2.markDirty();
        }
        return true;
      }
    };
  }
  index(child) {
    if (typeof child === "number")
      return child;
    if (child.proxyOf)
      child = child.proxyOf;
    return this.proxyOf.nodes.indexOf(child);
  }
  insertAfter(exist, add2) {
    let existIndex = this.index(exist);
    let nodes = this.normalize(add2, this.proxyOf.nodes[existIndex]).reverse();
    existIndex = this.index(exist);
    for (let node2 of nodes)
      this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
    let index2;
    for (let id in this.indexes) {
      index2 = this.indexes[id];
      if (existIndex < index2) {
        this.indexes[id] = index2 + nodes.length;
      }
    }
    this.markDirty();
    return this;
  }
  insertBefore(exist, add2) {
    let existIndex = this.index(exist);
    let type = existIndex === 0 ? "prepend" : false;
    let nodes = this.normalize(
      add2,
      this.proxyOf.nodes[existIndex],
      type
    ).reverse();
    existIndex = this.index(exist);
    for (let node2 of nodes)
      this.proxyOf.nodes.splice(existIndex, 0, node2);
    let index2;
    for (let id in this.indexes) {
      index2 = this.indexes[id];
      if (existIndex <= index2) {
        this.indexes[id] = index2 + nodes.length;
      }
    }
    this.markDirty();
    return this;
  }
  normalize(nodes, sample) {
    if (typeof nodes === "string") {
      nodes = cleanSource(parse$6(nodes).nodes);
    } else if (typeof nodes === "undefined") {
      nodes = [];
    } else if (Array.isArray(nodes)) {
      nodes = nodes.slice(0);
      for (let i2 of nodes) {
        if (i2.parent)
          i2.parent.removeChild(i2, "ignore");
      }
    } else if (nodes.type === "root" && this.type !== "document") {
      nodes = nodes.nodes.slice(0);
      for (let i2 of nodes) {
        if (i2.parent)
          i2.parent.removeChild(i2, "ignore");
      }
    } else if (nodes.type) {
      nodes = [nodes];
    } else if (nodes.prop) {
      if (typeof nodes.value === "undefined") {
        throw new Error("Value field is missed in node creation");
      } else if (typeof nodes.value !== "string") {
        nodes.value = String(nodes.value);
      }
      nodes = [new Declaration$3(nodes)];
    } else if (nodes.selector || nodes.selectors) {
      nodes = [new Rule$4(nodes)];
    } else if (nodes.name) {
      nodes = [new AtRule$4(nodes)];
    } else if (nodes.text) {
      nodes = [new Comment$3(nodes)];
    } else {
      throw new Error("Unknown node type in node creation");
    }
    let processed = nodes.map((i2) => {
      if (!i2[my$1])
        Container.rebuild(i2);
      i2 = i2.proxyOf;
      if (i2.parent)
        i2.parent.removeChild(i2);
      if (i2[isClean$1])
        markTreeDirty(i2);
      if (!i2.raws)
        i2.raws = {};
      if (typeof i2.raws.before === "undefined") {
        if (sample && typeof sample.raws.before !== "undefined") {
          i2.raws.before = sample.raws.before.replace(/\S/g, "");
        }
      }
      i2.parent = this.proxyOf;
      return i2;
    });
    return processed;
  }
  prepend(...children) {
    children = children.reverse();
    for (let child of children) {
      let nodes = this.normalize(child, this.first, "prepend").reverse();
      for (let node2 of nodes)
        this.proxyOf.nodes.unshift(node2);
      for (let id in this.indexes) {
        this.indexes[id] = this.indexes[id] + nodes.length;
      }
    }
    this.markDirty();
    return this;
  }
  push(child) {
    child.parent = this;
    this.proxyOf.nodes.push(child);
    return this;
  }
  removeAll() {
    for (let node2 of this.proxyOf.nodes)
      node2.parent = void 0;
    this.proxyOf.nodes = [];
    this.markDirty();
    return this;
  }
  removeChild(child) {
    child = this.index(child);
    this.proxyOf.nodes[child].parent = void 0;
    this.proxyOf.nodes.splice(child, 1);
    let index2;
    for (let id in this.indexes) {
      index2 = this.indexes[id];
      if (index2 >= child) {
        this.indexes[id] = index2 - 1;
      }
    }
    this.markDirty();
    return this;
  }
  replaceValues(pattern, opts, callback) {
    if (!callback) {
      callback = opts;
      opts = {};
    }
    this.walkDecls((decl) => {
      if (opts.props && !opts.props.includes(decl.prop))
        return;
      if (opts.fast && !decl.value.includes(opts.fast))
        return;
      decl.value = decl.value.replace(pattern, callback);
    });
    this.markDirty();
    return this;
  }
  some(condition) {
    return this.nodes.some(condition);
  }
  walk(callback) {
    return this.each((child, i2) => {
      let result2;
      try {
        result2 = callback(child, i2);
      } catch (e) {
        throw child.addToError(e);
      }
      if (result2 !== false && child.walk) {
        result2 = child.walk(callback);
      }
      return result2;
    });
  }
  walkAtRules(name, callback) {
    if (!callback) {
      callback = name;
      return this.walk((child, i2) => {
        if (child.type === "atrule") {
          return callback(child, i2);
        }
      });
    }
    if (name instanceof RegExp) {
      return this.walk((child, i2) => {
        if (child.type === "atrule" && name.test(child.name)) {
          return callback(child, i2);
        }
      });
    }
    return this.walk((child, i2) => {
      if (child.type === "atrule" && child.name === name) {
        return callback(child, i2);
      }
    });
  }
  walkComments(callback) {
    return this.walk((child, i2) => {
      if (child.type === "comment") {
        return callback(child, i2);
      }
    });
  }
  walkDecls(prop, callback) {
    if (!callback) {
      callback = prop;
      return this.walk((child, i2) => {
        if (child.type === "decl") {
          return callback(child, i2);
        }
      });
    }
    if (prop instanceof RegExp) {
      return this.walk((child, i2) => {
        if (child.type === "decl" && prop.test(child.prop)) {
          return callback(child, i2);
        }
      });
    }
    return this.walk((child, i2) => {
      if (child.type === "decl" && child.prop === prop) {
        return callback(child, i2);
      }
    });
  }
  walkRules(selector, callback) {
    if (!callback) {
      callback = selector;
      return this.walk((child, i2) => {
        if (child.type === "rule") {
          return callback(child, i2);
        }
      });
    }
    if (selector instanceof RegExp) {
      return this.walk((child, i2) => {
        if (child.type === "rule" && selector.test(child.selector)) {
          return callback(child, i2);
        }
      });
    }
    return this.walk((child, i2) => {
      if (child.type === "rule" && child.selector === selector) {
        return callback(child, i2);
      }
    });
  }
};
Container$7.registerParse = (dependant) => {
  parse$6 = dependant;
};
Container$7.registerRule = (dependant) => {
  Rule$4 = dependant;
};
Container$7.registerAtRule = (dependant) => {
  AtRule$4 = dependant;
};
Container$7.registerRoot = (dependant) => {
  Root$6 = dependant;
};
var container = Container$7;
Container$7.default = Container$7;
Container$7.rebuild = (node2) => {
  if (node2.type === "atrule") {
    Object.setPrototypeOf(node2, AtRule$4.prototype);
  } else if (node2.type === "rule") {
    Object.setPrototypeOf(node2, Rule$4.prototype);
  } else if (node2.type === "decl") {
    Object.setPrototypeOf(node2, Declaration$3.prototype);
  } else if (node2.type === "comment") {
    Object.setPrototypeOf(node2, Comment$3.prototype);
  } else if (node2.type === "root") {
    Object.setPrototypeOf(node2, Root$6.prototype);
  }
  node2[my$1] = true;
  if (node2.nodes) {
    node2.nodes.forEach((child) => {
      Container$7.rebuild(child);
    });
  }
};
let Container$6 = container;
let AtRule$3 = class AtRule extends Container$6 {
  constructor(defaults2) {
    super(defaults2);
    this.type = "atrule";
  }
  append(...children) {
    if (!this.proxyOf.nodes)
      this.nodes = [];
    return super.append(...children);
  }
  prepend(...children) {
    if (!this.proxyOf.nodes)
      this.nodes = [];
    return super.prepend(...children);
  }
};
var atRule = AtRule$3;
AtRule$3.default = AtRule$3;
Container$6.registerAtRule(AtRule$3);
let Container$5 = container;
let LazyResult$4, Processor$3;
let Document$3 = class Document extends Container$5 {
  constructor(defaults2) {
    super(__spreadValues({ type: "document" }, defaults2));
    if (!this.nodes) {
      this.nodes = [];
    }
  }
  toResult(opts = {}) {
    let lazy = new LazyResult$4(new Processor$3(), this, opts);
    return lazy.stringify();
  }
};
Document$3.registerLazyResult = (dependant) => {
  LazyResult$4 = dependant;
};
Document$3.registerProcessor = (dependant) => {
  Processor$3 = dependant;
};
var document$1 = Document$3;
Document$3.default = Document$3;
let urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let customAlphabet = (alphabet, defaultSize = 21) => {
  return (size = defaultSize) => {
    let id = "";
    let i2 = size | 0;
    while (i2--) {
      id += alphabet[Math.random() * alphabet.length | 0];
    }
    return id;
  };
};
let nanoid$1 = (size = 21) => {
  let id = "";
  let i2 = size | 0;
  while (i2--) {
    id += urlAlphabet[Math.random() * 64 | 0];
  }
  return id;
};
var nonSecure = { nanoid: nanoid$1, customAlphabet };
let { existsSync, readFileSync } = require$$2;
let { dirname: dirname$1, join } = require$$2;
let { SourceMapConsumer: SourceMapConsumer$2, SourceMapGenerator: SourceMapGenerator$2 } = require$$2;
function fromBase64(str) {
  if (Buffer) {
    return Buffer.from(str, "base64").toString();
  } else {
    return window.atob(str);
  }
}
let PreviousMap$2 = class PreviousMap {
  constructor(css2, opts) {
    if (opts.map === false)
      return;
    this.loadAnnotation(css2);
    this.inline = this.startWith(this.annotation, "data:");
    let prev = opts.map ? opts.map.prev : void 0;
    let text2 = this.loadMap(opts.from, prev);
    if (!this.mapFile && opts.from) {
      this.mapFile = opts.from;
    }
    if (this.mapFile)
      this.root = dirname$1(this.mapFile);
    if (text2)
      this.text = text2;
  }
  consumer() {
    if (!this.consumerCache) {
      this.consumerCache = new SourceMapConsumer$2(this.text);
    }
    return this.consumerCache;
  }
  decodeInline(text2) {
    let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
    let baseUri = /^data:application\/json;base64,/;
    let charsetUri = /^data:application\/json;charset=utf-?8,/;
    let uri = /^data:application\/json,/;
    let uriMatch = text2.match(charsetUri) || text2.match(uri);
    if (uriMatch) {
      return decodeURIComponent(text2.substr(uriMatch[0].length));
    }
    let baseUriMatch = text2.match(baseCharsetUri) || text2.match(baseUri);
    if (baseUriMatch) {
      return fromBase64(text2.substr(baseUriMatch[0].length));
    }
    let encoding = text2.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + encoding);
  }
  getAnnotationURL(sourceMapString) {
    return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(map) {
    if (typeof map !== "object")
      return false;
    return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
  }
  loadAnnotation(css2) {
    let comments = css2.match(/\/\*\s*# sourceMappingURL=/g);
    if (!comments)
      return;
    let start = css2.lastIndexOf(comments.pop());
    let end = css2.indexOf("*/", start);
    if (start > -1 && end > -1) {
      this.annotation = this.getAnnotationURL(css2.substring(start, end));
    }
  }
  loadFile(path) {
    this.root = dirname$1(path);
    if (existsSync(path)) {
      this.mapFile = path;
      return readFileSync(path, "utf-8").toString().trim();
    }
  }
  loadMap(file, prev) {
    if (prev === false)
      return false;
    if (prev) {
      if (typeof prev === "string") {
        return prev;
      } else if (typeof prev === "function") {
        let prevPath = prev(file);
        if (prevPath) {
          let map = this.loadFile(prevPath);
          if (!map) {
            throw new Error(
              "Unable to load previous source map: " + prevPath.toString()
            );
          }
          return map;
        }
      } else if (prev instanceof SourceMapConsumer$2) {
        return SourceMapGenerator$2.fromSourceMap(prev).toString();
      } else if (prev instanceof SourceMapGenerator$2) {
        return prev.toString();
      } else if (this.isMap(prev)) {
        return JSON.stringify(prev);
      } else {
        throw new Error(
          "Unsupported previous source map format: " + prev.toString()
        );
      }
    } else if (this.inline) {
      return this.decodeInline(this.annotation);
    } else if (this.annotation) {
      let map = this.annotation;
      if (file)
        map = join(dirname$1(file), map);
      return this.loadFile(map);
    }
  }
  startWith(string, start) {
    if (!string)
      return false;
    return string.substr(0, start.length) === start;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var previousMap = PreviousMap$2;
PreviousMap$2.default = PreviousMap$2;
let { nanoid } = nonSecure;
let { isAbsolute, resolve: resolve$1 } = require$$2;
let { SourceMapConsumer: SourceMapConsumer$1, SourceMapGenerator: SourceMapGenerator$1 } = require$$2;
let { fileURLToPath, pathToFileURL: pathToFileURL$1 } = require$$2;
let CssSyntaxError$1 = cssSyntaxError;
let PreviousMap$1 = previousMap;
let terminalHighlight = require$$2;
let fromOffsetCache = Symbol("fromOffsetCache");
let sourceMapAvailable$1 = Boolean(SourceMapConsumer$1 && SourceMapGenerator$1);
let pathAvailable$1 = Boolean(resolve$1 && isAbsolute);
let Input$4 = class Input {
  get from() {
    return this.file || this.id;
  }
  constructor(css2, opts = {}) {
    if (css2 === null || typeof css2 === "undefined" || typeof css2 === "object" && !css2.toString) {
      throw new Error(`PostCSS received ${css2} instead of CSS string`);
    }
    this.css = css2.toString();
    if (this.css[0] === "\uFEFF" || this.css[0] === "￾") {
      this.hasBOM = true;
      this.css = this.css.slice(1);
    } else {
      this.hasBOM = false;
    }
    this.document = this.css;
    if (opts.document)
      this.document = opts.document.toString();
    if (opts.from) {
      if (!pathAvailable$1 || /^\w+:\/\//.test(opts.from) || isAbsolute(opts.from)) {
        this.file = opts.from;
      } else {
        this.file = resolve$1(opts.from);
      }
    }
    if (pathAvailable$1 && sourceMapAvailable$1) {
      let map = new PreviousMap$1(this.css, opts);
      if (map.text) {
        this.map = map;
        let file = map.consumer().file;
        if (!this.file && file)
          this.file = this.mapResolve(file);
      }
    }
    if (!this.file) {
      this.id = "<input css " + nanoid(6) + ">";
    }
    if (this.map)
      this.map.file = this.from;
  }
  error(message, line, column, opts = {}) {
    let endColumn, endLine, result2;
    if (line && typeof line === "object") {
      let start = line;
      let end = column;
      if (typeof start.offset === "number") {
        let pos = this.fromOffset(start.offset);
        line = pos.line;
        column = pos.col;
      } else {
        line = start.line;
        column = start.column;
      }
      if (typeof end.offset === "number") {
        let pos = this.fromOffset(end.offset);
        endLine = pos.line;
        endColumn = pos.col;
      } else {
        endLine = end.line;
        endColumn = end.column;
      }
    } else if (!column) {
      let pos = this.fromOffset(line);
      line = pos.line;
      column = pos.col;
    }
    let origin = this.origin(line, column, endLine, endColumn);
    if (origin) {
      result2 = new CssSyntaxError$1(
        message,
        origin.endLine === void 0 ? origin.line : { column: origin.column, line: origin.line },
        origin.endLine === void 0 ? origin.column : { column: origin.endColumn, line: origin.endLine },
        origin.source,
        origin.file,
        opts.plugin
      );
    } else {
      result2 = new CssSyntaxError$1(
        message,
        endLine === void 0 ? line : { column, line },
        endLine === void 0 ? column : { column: endColumn, line: endLine },
        this.css,
        this.file,
        opts.plugin
      );
    }
    result2.input = { column, endColumn, endLine, line, source: this.css };
    if (this.file) {
      if (pathToFileURL$1) {
        result2.input.url = pathToFileURL$1(this.file).toString();
      }
      result2.input.file = this.file;
    }
    return result2;
  }
  fromOffset(offset2) {
    let lastLine, lineToIndex;
    if (!this[fromOffsetCache]) {
      let lines = this.css.split("\n");
      lineToIndex = new Array(lines.length);
      let prevIndex = 0;
      for (let i2 = 0, l = lines.length; i2 < l; i2++) {
        lineToIndex[i2] = prevIndex;
        prevIndex += lines[i2].length + 1;
      }
      this[fromOffsetCache] = lineToIndex;
    } else {
      lineToIndex = this[fromOffsetCache];
    }
    lastLine = lineToIndex[lineToIndex.length - 1];
    let min2 = 0;
    if (offset2 >= lastLine) {
      min2 = lineToIndex.length - 1;
    } else {
      let max2 = lineToIndex.length - 2;
      let mid;
      while (min2 < max2) {
        mid = min2 + (max2 - min2 >> 1);
        if (offset2 < lineToIndex[mid]) {
          max2 = mid - 1;
        } else if (offset2 >= lineToIndex[mid + 1]) {
          min2 = mid + 1;
        } else {
          min2 = mid;
          break;
        }
      }
    }
    return {
      col: offset2 - lineToIndex[min2] + 1,
      line: min2 + 1
    };
  }
  mapResolve(file) {
    if (/^\w+:\/\//.test(file)) {
      return file;
    }
    return resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
  }
  origin(line, column, endLine, endColumn) {
    if (!this.map)
      return false;
    let consumer = this.map.consumer();
    let from = consumer.originalPositionFor({ column, line });
    if (!from.source)
      return false;
    let to;
    if (typeof endLine === "number") {
      to = consumer.originalPositionFor({ column: endColumn, line: endLine });
    }
    let fromUrl;
    if (isAbsolute(from.source)) {
      fromUrl = pathToFileURL$1(from.source);
    } else {
      fromUrl = new URL(
        from.source,
        this.map.consumer().sourceRoot || pathToFileURL$1(this.map.mapFile)
      );
    }
    let result2 = {
      column: from.column,
      endColumn: to && to.column,
      endLine: to && to.line,
      line: from.line,
      url: fromUrl.toString()
    };
    if (fromUrl.protocol === "file:") {
      if (fileURLToPath) {
        result2.file = fileURLToPath(fromUrl);
      } else {
        throw new Error(`file: protocol is not available in this PostCSS build`);
      }
    }
    let source = consumer.sourceContentFor(from.source);
    if (source)
      result2.source = source;
    return result2;
  }
  toJSON() {
    let json = {};
    for (let name of ["hasBOM", "css", "file", "id"]) {
      if (this[name] != null) {
        json[name] = this[name];
      }
    }
    if (this.map) {
      json.map = __spreadValues({}, this.map);
      if (json.map.consumerCache) {
        json.map.consumerCache = void 0;
      }
    }
    return json;
  }
};
var input = Input$4;
Input$4.default = Input$4;
if (terminalHighlight && terminalHighlight.registerInput) {
  terminalHighlight.registerInput(Input$4);
}
let Container$4 = container;
let LazyResult$3, Processor$2;
let Root$5 = class Root extends Container$4 {
  constructor(defaults2) {
    super(defaults2);
    this.type = "root";
    if (!this.nodes)
      this.nodes = [];
  }
  normalize(child, sample, type) {
    let nodes = super.normalize(child);
    if (sample) {
      if (type === "prepend") {
        if (this.nodes.length > 1) {
          sample.raws.before = this.nodes[1].raws.before;
        } else {
          delete sample.raws.before;
        }
      } else if (this.first !== sample) {
        for (let node2 of nodes) {
          node2.raws.before = sample.raws.before;
        }
      }
    }
    return nodes;
  }
  removeChild(child, ignore) {
    let index2 = this.index(child);
    if (!ignore && index2 === 0 && this.nodes.length > 1) {
      this.nodes[1].raws.before = this.nodes[index2].raws.before;
    }
    return super.removeChild(child);
  }
  toResult(opts = {}) {
    let lazy = new LazyResult$3(new Processor$2(), this, opts);
    return lazy.stringify();
  }
};
Root$5.registerLazyResult = (dependant) => {
  LazyResult$3 = dependant;
};
Root$5.registerProcessor = (dependant) => {
  Processor$2 = dependant;
};
var root = Root$5;
Root$5.default = Root$5;
Container$4.registerRoot(Root$5);
let list$2 = {
  comma(string) {
    return list$2.split(string, [","], true);
  },
  space(string) {
    let spaces = [" ", "\n", "	"];
    return list$2.split(string, spaces);
  },
  split(string, separators, last2) {
    let array = [];
    let current = "";
    let split = false;
    let func = 0;
    let inQuote = false;
    let prevQuote = "";
    let escape2 = false;
    for (let letter of string) {
      if (escape2) {
        escape2 = false;
      } else if (letter === "\\") {
        escape2 = true;
      } else if (inQuote) {
        if (letter === prevQuote) {
          inQuote = false;
        }
      } else if (letter === '"' || letter === "'") {
        inQuote = true;
        prevQuote = letter;
      } else if (letter === "(") {
        func += 1;
      } else if (letter === ")") {
        if (func > 0)
          func -= 1;
      } else if (func === 0) {
        if (separators.includes(letter))
          split = true;
      }
      if (split) {
        if (current !== "")
          array.push(current.trim());
        current = "";
        split = false;
      } else {
        current += letter;
      }
    }
    if (last2 || current !== "")
      array.push(current.trim());
    return array;
  }
};
var list_1 = list$2;
list$2.default = list$2;
let Container$3 = container;
let list$1 = list_1;
let Rule$3 = class Rule extends Container$3 {
  get selectors() {
    return list$1.comma(this.selector);
  }
  set selectors(values2) {
    let match = this.selector ? this.selector.match(/,\s*/) : null;
    let sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
    this.selector = values2.join(sep2);
  }
  constructor(defaults2) {
    super(defaults2);
    this.type = "rule";
    if (!this.nodes)
      this.nodes = [];
  }
};
var rule = Rule$3;
Rule$3.default = Rule$3;
Container$3.registerRule(Rule$3);
let AtRule$2 = atRule;
let Comment$2 = comment;
let Declaration$2 = declaration;
let Input$3 = input;
let PreviousMap2 = previousMap;
let Root$4 = root;
let Rule$2 = rule;
function fromJSON$1(json, inputs) {
  if (Array.isArray(json))
    return json.map((n2) => fromJSON$1(n2));
  let _a2 = json, { inputs: ownInputs } = _a2, defaults2 = __objRest(_a2, ["inputs"]);
  if (ownInputs) {
    inputs = [];
    for (let input2 of ownInputs) {
      let inputHydrated = __spreadProps(__spreadValues({}, input2), { __proto__: Input$3.prototype });
      if (inputHydrated.map) {
        inputHydrated.map = __spreadProps(__spreadValues({}, inputHydrated.map), {
          __proto__: PreviousMap2.prototype
        });
      }
      inputs.push(inputHydrated);
    }
  }
  if (defaults2.nodes) {
    defaults2.nodes = json.nodes.map((n2) => fromJSON$1(n2, inputs));
  }
  if (defaults2.source) {
    let _b2 = defaults2.source, { inputId } = _b2, source = __objRest(_b2, ["inputId"]);
    defaults2.source = source;
    if (inputId != null) {
      defaults2.source.input = inputs[inputId];
    }
  }
  if (defaults2.type === "root") {
    return new Root$4(defaults2);
  } else if (defaults2.type === "decl") {
    return new Declaration$2(defaults2);
  } else if (defaults2.type === "rule") {
    return new Rule$2(defaults2);
  } else if (defaults2.type === "comment") {
    return new Comment$2(defaults2);
  } else if (defaults2.type === "atrule") {
    return new AtRule$2(defaults2);
  } else {
    throw new Error("Unknown node type: " + json.type);
  }
}
var fromJSON_1 = fromJSON$1;
fromJSON$1.default = fromJSON$1;
let { dirname, relative, resolve, sep } = require$$2;
let { SourceMapConsumer, SourceMapGenerator } = require$$2;
let { pathToFileURL } = require$$2;
let Input$2 = input;
let sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
let pathAvailable = Boolean(dirname && resolve && relative && sep);
let MapGenerator$2 = class MapGenerator {
  constructor(stringify2, root2, opts, cssString) {
    this.stringify = stringify2;
    this.mapOpts = opts.map || {};
    this.root = root2;
    this.opts = opts;
    this.css = cssString;
    this.originalCSS = cssString;
    this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
    this.memoizedFileURLs = /* @__PURE__ */ new Map();
    this.memoizedPaths = /* @__PURE__ */ new Map();
    this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let content;
    if (this.isInline()) {
      content = "data:application/json;base64," + this.toBase64(this.map.toString());
    } else if (typeof this.mapOpts.annotation === "string") {
      content = this.mapOpts.annotation;
    } else if (typeof this.mapOpts.annotation === "function") {
      content = this.mapOpts.annotation(this.opts.to, this.root);
    } else {
      content = this.outputFile() + ".map";
    }
    let eol = "\n";
    if (this.css.includes("\r\n"))
      eol = "\r\n";
    this.css += eol + "/*# sourceMappingURL=" + content + " */";
  }
  applyPrevMaps() {
    for (let prev of this.previous()) {
      let from = this.toUrl(this.path(prev.file));
      let root2 = prev.root || dirname(prev.file);
      let map;
      if (this.mapOpts.sourcesContent === false) {
        map = new SourceMapConsumer(prev.text);
        if (map.sourcesContent) {
          map.sourcesContent = null;
        }
      } else {
        map = prev.consumer();
      }
      this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation === false)
      return;
    if (this.root) {
      let node2;
      for (let i2 = this.root.nodes.length - 1; i2 >= 0; i2--) {
        node2 = this.root.nodes[i2];
        if (node2.type !== "comment")
          continue;
        if (node2.text.startsWith("# sourceMappingURL=")) {
          this.root.removeChild(i2);
        }
      }
    } else if (this.css) {
      this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, "");
    }
  }
  generate() {
    this.clearAnnotation();
    if (pathAvailable && sourceMapAvailable && this.isMap()) {
      return this.generateMap();
    } else {
      let result2 = "";
      this.stringify(this.root, (i2) => {
        result2 += i2;
      });
      return [result2];
    }
  }
  generateMap() {
    if (this.root) {
      this.generateString();
    } else if (this.previous().length === 1) {
      let prev = this.previous()[0].consumer();
      prev.file = this.outputFile();
      this.map = SourceMapGenerator.fromSourceMap(prev, {
        ignoreInvalidMapping: true
      });
    } else {
      this.map = new SourceMapGenerator({
        file: this.outputFile(),
        ignoreInvalidMapping: true
      });
      this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    }
    if (this.isSourcesContent())
      this.setSourcesContent();
    if (this.root && this.previous().length > 0)
      this.applyPrevMaps();
    if (this.isAnnotation())
      this.addAnnotation();
    if (this.isInline()) {
      return [this.css];
    } else {
      return [this.css, this.map];
    }
  }
  generateString() {
    this.css = "";
    this.map = new SourceMapGenerator({
      file: this.outputFile(),
      ignoreInvalidMapping: true
    });
    let line = 1;
    let column = 1;
    let noSource = "<no source>";
    let mapping = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    };
    let last2, lines;
    this.stringify(this.root, (str, node2, type) => {
      this.css += str;
      if (node2 && type !== "end") {
        mapping.generated.line = line;
        mapping.generated.column = column - 1;
        if (node2.source && node2.source.start) {
          mapping.source = this.sourcePath(node2);
          mapping.original.line = node2.source.start.line;
          mapping.original.column = node2.source.start.column - 1;
          this.map.addMapping(mapping);
        } else {
          mapping.source = noSource;
          mapping.original.line = 1;
          mapping.original.column = 0;
          this.map.addMapping(mapping);
        }
      }
      lines = str.match(/\n/g);
      if (lines) {
        line += lines.length;
        last2 = str.lastIndexOf("\n");
        column = str.length - last2;
      } else {
        column += str.length;
      }
      if (node2 && type !== "start") {
        let p = node2.parent || { raws: {} };
        let childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
        if (!childless || node2 !== p.last || p.raws.semicolon) {
          if (node2.source && node2.source.end) {
            mapping.source = this.sourcePath(node2);
            mapping.original.line = node2.source.end.line;
            mapping.original.column = node2.source.end.column - 1;
            mapping.generated.line = line;
            mapping.generated.column = column - 2;
            this.map.addMapping(mapping);
          } else {
            mapping.source = noSource;
            mapping.original.line = 1;
            mapping.original.column = 0;
            mapping.generated.line = line;
            mapping.generated.column = column - 1;
            this.map.addMapping(mapping);
          }
        }
      }
    });
  }
  isAnnotation() {
    if (this.isInline()) {
      return true;
    }
    if (typeof this.mapOpts.annotation !== "undefined") {
      return this.mapOpts.annotation;
    }
    if (this.previous().length) {
      return this.previous().some((i2) => i2.annotation);
    }
    return true;
  }
  isInline() {
    if (typeof this.mapOpts.inline !== "undefined") {
      return this.mapOpts.inline;
    }
    let annotation = this.mapOpts.annotation;
    if (typeof annotation !== "undefined" && annotation !== true) {
      return false;
    }
    if (this.previous().length) {
      return this.previous().some((i2) => i2.inline);
    }
    return true;
  }
  isMap() {
    if (typeof this.opts.map !== "undefined") {
      return !!this.opts.map;
    }
    return this.previous().length > 0;
  }
  isSourcesContent() {
    if (typeof this.mapOpts.sourcesContent !== "undefined") {
      return this.mapOpts.sourcesContent;
    }
    if (this.previous().length) {
      return this.previous().some((i2) => i2.withContent());
    }
    return true;
  }
  outputFile() {
    if (this.opts.to) {
      return this.path(this.opts.to);
    } else if (this.opts.from) {
      return this.path(this.opts.from);
    } else {
      return "to.css";
    }
  }
  path(file) {
    if (this.mapOpts.absolute)
      return file;
    if (file.charCodeAt(0) === 60)
      return file;
    if (/^\w+:\/\//.test(file))
      return file;
    let cached2 = this.memoizedPaths.get(file);
    if (cached2)
      return cached2;
    let from = this.opts.to ? dirname(this.opts.to) : ".";
    if (typeof this.mapOpts.annotation === "string") {
      from = dirname(resolve(from, this.mapOpts.annotation));
    }
    let path = relative(from, file);
    this.memoizedPaths.set(file, path);
    return path;
  }
  previous() {
    if (!this.previousMaps) {
      this.previousMaps = [];
      if (this.root) {
        this.root.walk((node2) => {
          if (node2.source && node2.source.input.map) {
            let map = node2.source.input.map;
            if (!this.previousMaps.includes(map)) {
              this.previousMaps.push(map);
            }
          }
        });
      } else {
        let input2 = new Input$2(this.originalCSS, this.opts);
        if (input2.map)
          this.previousMaps.push(input2.map);
      }
    }
    return this.previousMaps;
  }
  setSourcesContent() {
    let already = {};
    if (this.root) {
      this.root.walk((node2) => {
        if (node2.source) {
          let from = node2.source.input.from;
          if (from && !already[from]) {
            already[from] = true;
            let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
            this.map.setSourceContent(fromUrl, node2.source.input.css);
          }
        }
      });
    } else if (this.css) {
      let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(from, this.css);
    }
  }
  sourcePath(node2) {
    if (this.mapOpts.from) {
      return this.toUrl(this.mapOpts.from);
    } else if (this.usesFileUrls) {
      return this.toFileUrl(node2.source.input.from);
    } else {
      return this.toUrl(this.path(node2.source.input.from));
    }
  }
  toBase64(str) {
    if (Buffer) {
      return Buffer.from(str).toString("base64");
    } else {
      return window.btoa(unescape(encodeURIComponent(str)));
    }
  }
  toFileUrl(path) {
    let cached2 = this.memoizedFileURLs.get(path);
    if (cached2)
      return cached2;
    if (pathToFileURL) {
      let fileURL = pathToFileURL(path).toString();
      this.memoizedFileURLs.set(path, fileURL);
      return fileURL;
    } else {
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
    }
  }
  toUrl(path) {
    let cached2 = this.memoizedURLs.get(path);
    if (cached2)
      return cached2;
    if (sep === "\\") {
      path = path.replace(/\\/g, "/");
    }
    let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
    this.memoizedURLs.set(path, url);
    return url;
  }
};
var mapGenerator = MapGenerator$2;
const SINGLE_QUOTE = "'".charCodeAt(0);
const DOUBLE_QUOTE = '"'.charCodeAt(0);
const BACKSLASH = "\\".charCodeAt(0);
const SLASH = "/".charCodeAt(0);
const NEWLINE = "\n".charCodeAt(0);
const SPACE = " ".charCodeAt(0);
const FEED = "\f".charCodeAt(0);
const TAB = "	".charCodeAt(0);
const CR = "\r".charCodeAt(0);
const OPEN_SQUARE = "[".charCodeAt(0);
const CLOSE_SQUARE = "]".charCodeAt(0);
const OPEN_PARENTHESES = "(".charCodeAt(0);
const CLOSE_PARENTHESES = ")".charCodeAt(0);
const OPEN_CURLY = "{".charCodeAt(0);
const CLOSE_CURLY = "}".charCodeAt(0);
const SEMICOLON = ";".charCodeAt(0);
const ASTERISK = "*".charCodeAt(0);
const COLON = ":".charCodeAt(0);
const AT = "@".charCodeAt(0);
const RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
const RE_HEX_ESCAPE = /[\da-f]/i;
var tokenize = function tokenizer(input2, options = {}) {
  let css2 = input2.css.valueOf();
  let ignore = options.ignoreErrors;
  let code, content, escape2, next, quote;
  let currentToken, escaped, escapePos, n2, prev;
  let length = css2.length;
  let pos = 0;
  let buffer = [];
  let returned = [];
  function position() {
    return pos;
  }
  function unclosed(what) {
    throw input2.error("Unclosed " + what, pos);
  }
  function endOfFile() {
    return returned.length === 0 && pos >= length;
  }
  function nextToken(opts) {
    if (returned.length)
      return returned.pop();
    if (pos >= length)
      return;
    let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
    code = css2.charCodeAt(pos);
    switch (code) {
      case NEWLINE:
      case SPACE:
      case TAB:
      case CR:
      case FEED: {
        next = pos;
        do {
          next += 1;
          code = css2.charCodeAt(next);
        } while (code === SPACE || code === NEWLINE || code === TAB || code === CR || code === FEED);
        currentToken = ["space", css2.slice(pos, next)];
        pos = next - 1;
        break;
      }
      case OPEN_SQUARE:
      case CLOSE_SQUARE:
      case OPEN_CURLY:
      case CLOSE_CURLY:
      case COLON:
      case SEMICOLON:
      case CLOSE_PARENTHESES: {
        let controlChar = String.fromCharCode(code);
        currentToken = [controlChar, controlChar, pos];
        break;
      }
      case OPEN_PARENTHESES: {
        prev = buffer.length ? buffer.pop()[1] : "";
        n2 = css2.charCodeAt(pos + 1);
        if (prev === "url" && n2 !== SINGLE_QUOTE && n2 !== DOUBLE_QUOTE && n2 !== SPACE && n2 !== NEWLINE && n2 !== TAB && n2 !== FEED && n2 !== CR) {
          next = pos;
          do {
            escaped = false;
            next = css2.indexOf(")", next + 1);
            if (next === -1) {
              if (ignore || ignoreUnclosed) {
                next = pos;
                break;
              } else {
                unclosed("bracket");
              }
            }
            escapePos = next;
            while (css2.charCodeAt(escapePos - 1) === BACKSLASH) {
              escapePos -= 1;
              escaped = !escaped;
            }
          } while (escaped);
          currentToken = ["brackets", css2.slice(pos, next + 1), pos, next];
          pos = next;
        } else {
          next = css2.indexOf(")", pos + 1);
          content = css2.slice(pos, next + 1);
          if (next === -1 || RE_BAD_BRACKET.test(content)) {
            currentToken = ["(", "(", pos];
          } else {
            currentToken = ["brackets", content, pos, next];
            pos = next;
          }
        }
        break;
      }
      case SINGLE_QUOTE:
      case DOUBLE_QUOTE: {
        quote = code === SINGLE_QUOTE ? "'" : '"';
        next = pos;
        do {
          escaped = false;
          next = css2.indexOf(quote, next + 1);
          if (next === -1) {
            if (ignore || ignoreUnclosed) {
              next = pos + 1;
              break;
            } else {
              unclosed("string");
            }
          }
          escapePos = next;
          while (css2.charCodeAt(escapePos - 1) === BACKSLASH) {
            escapePos -= 1;
            escaped = !escaped;
          }
        } while (escaped);
        currentToken = ["string", css2.slice(pos, next + 1), pos, next];
        pos = next;
        break;
      }
      case AT: {
        RE_AT_END.lastIndex = pos + 1;
        RE_AT_END.test(css2);
        if (RE_AT_END.lastIndex === 0) {
          next = css2.length - 1;
        } else {
          next = RE_AT_END.lastIndex - 2;
        }
        currentToken = ["at-word", css2.slice(pos, next + 1), pos, next];
        pos = next;
        break;
      }
      case BACKSLASH: {
        next = pos;
        escape2 = true;
        while (css2.charCodeAt(next + 1) === BACKSLASH) {
          next += 1;
          escape2 = !escape2;
        }
        code = css2.charCodeAt(next + 1);
        if (escape2 && code !== SLASH && code !== SPACE && code !== NEWLINE && code !== TAB && code !== CR && code !== FEED) {
          next += 1;
          if (RE_HEX_ESCAPE.test(css2.charAt(next))) {
            while (RE_HEX_ESCAPE.test(css2.charAt(next + 1))) {
              next += 1;
            }
            if (css2.charCodeAt(next + 1) === SPACE) {
              next += 1;
            }
          }
        }
        currentToken = ["word", css2.slice(pos, next + 1), pos, next];
        pos = next;
        break;
      }
      default: {
        if (code === SLASH && css2.charCodeAt(pos + 1) === ASTERISK) {
          next = css2.indexOf("*/", pos + 2) + 1;
          if (next === 0) {
            if (ignore || ignoreUnclosed) {
              next = css2.length;
            } else {
              unclosed("comment");
            }
          }
          currentToken = ["comment", css2.slice(pos, next + 1), pos, next];
          pos = next;
        } else {
          RE_WORD_END.lastIndex = pos + 1;
          RE_WORD_END.test(css2);
          if (RE_WORD_END.lastIndex === 0) {
            next = css2.length - 1;
          } else {
            next = RE_WORD_END.lastIndex - 2;
          }
          currentToken = ["word", css2.slice(pos, next + 1), pos, next];
          buffer.push(currentToken);
          pos = next;
        }
        break;
      }
    }
    pos++;
    return currentToken;
  }
  function back(token) {
    returned.push(token);
  }
  return {
    back,
    endOfFile,
    nextToken,
    position
  };
};
let AtRule$1 = atRule;
let Comment$1 = comment;
let Declaration$1 = declaration;
let Root$3 = root;
let Rule$1 = rule;
let tokenizer2 = tokenize;
const SAFE_COMMENT_NEIGHBOR = {
  empty: true,
  space: true
};
function findLastWithPosition(tokens) {
  for (let i2 = tokens.length - 1; i2 >= 0; i2--) {
    let token = tokens[i2];
    let pos = token[3] || token[2];
    if (pos)
      return pos;
  }
}
let Parser$3 = class Parser {
  constructor(input2) {
    this.input = input2;
    this.root = new Root$3();
    this.current = this.root;
    this.spaces = "";
    this.semicolon = false;
    this.createTokenizer();
    this.root.source = { input: input2, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(token) {
    let node2 = new AtRule$1();
    node2.name = token[1].slice(1);
    if (node2.name === "") {
      this.unnamedAtrule(node2, token);
    }
    this.init(node2, token[2]);
    let type;
    let prev;
    let shift2;
    let last2 = false;
    let open2 = false;
    let params = [];
    let brackets = [];
    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();
      type = token[0];
      if (type === "(" || type === "[") {
        brackets.push(type === "(" ? ")" : "]");
      } else if (type === "{" && brackets.length > 0) {
        brackets.push("}");
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
      }
      if (brackets.length === 0) {
        if (type === ";") {
          node2.source.end = this.getPosition(token[2]);
          node2.source.end.offset++;
          this.semicolon = true;
          break;
        } else if (type === "{") {
          open2 = true;
          break;
        } else if (type === "}") {
          if (params.length > 0) {
            shift2 = params.length - 1;
            prev = params[shift2];
            while (prev && prev[0] === "space") {
              prev = params[--shift2];
            }
            if (prev) {
              node2.source.end = this.getPosition(prev[3] || prev[2]);
              node2.source.end.offset++;
            }
          }
          this.end(token);
          break;
        } else {
          params.push(token);
        }
      } else {
        params.push(token);
      }
      if (this.tokenizer.endOfFile()) {
        last2 = true;
        break;
      }
    }
    node2.raws.between = this.spacesAndCommentsFromEnd(params);
    if (params.length) {
      node2.raws.afterName = this.spacesAndCommentsFromStart(params);
      this.raw(node2, "params", params);
      if (last2) {
        token = params[params.length - 1];
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        this.spaces = node2.raws.between;
        node2.raws.between = "";
      }
    } else {
      node2.raws.afterName = "";
      node2.params = "";
    }
    if (open2) {
      node2.nodes = [];
      this.current = node2;
    }
  }
  checkMissedSemicolon(tokens) {
    let colon = this.colon(tokens);
    if (colon === false)
      return;
    let founded = 0;
    let token;
    for (let j = colon - 1; j >= 0; j--) {
      token = tokens[j];
      if (token[0] !== "space") {
        founded += 1;
        if (founded === 2)
          break;
      }
    }
    throw this.input.error(
      "Missed semicolon",
      token[0] === "word" ? token[3] + 1 : token[2]
    );
  }
  colon(tokens) {
    let brackets = 0;
    let prev, token, type;
    for (let [i2, element] of tokens.entries()) {
      token = element;
      type = token[0];
      if (type === "(") {
        brackets += 1;
      }
      if (type === ")") {
        brackets -= 1;
      }
      if (brackets === 0 && type === ":") {
        if (!prev) {
          this.doubleColon(token);
        } else if (prev[0] === "word" && prev[1] === "progid") {
          continue;
        } else {
          return i2;
        }
      }
      prev = token;
    }
    return false;
  }
  comment(token) {
    let node2 = new Comment$1();
    this.init(node2, token[2]);
    node2.source.end = this.getPosition(token[3] || token[2]);
    node2.source.end.offset++;
    let text2 = token[1].slice(2, -2);
    if (/^\s*$/.test(text2)) {
      node2.text = "";
      node2.raws.left = text2;
      node2.raws.right = "";
    } else {
      let match = text2.match(/^(\s*)([^]*\S)(\s*)$/);
      node2.text = match[2];
      node2.raws.left = match[1];
      node2.raws.right = match[3];
    }
  }
  createTokenizer() {
    this.tokenizer = tokenizer2(this.input);
  }
  decl(tokens, customProperty) {
    let node2 = new Declaration$1();
    this.init(node2, tokens[0][2]);
    let last2 = tokens[tokens.length - 1];
    if (last2[0] === ";") {
      this.semicolon = true;
      tokens.pop();
    }
    node2.source.end = this.getPosition(
      last2[3] || last2[2] || findLastWithPosition(tokens)
    );
    node2.source.end.offset++;
    while (tokens[0][0] !== "word") {
      if (tokens.length === 1)
        this.unknownWord(tokens);
      node2.raws.before += tokens.shift()[1];
    }
    node2.source.start = this.getPosition(tokens[0][2]);
    node2.prop = "";
    while (tokens.length) {
      let type = tokens[0][0];
      if (type === ":" || type === "space" || type === "comment") {
        break;
      }
      node2.prop += tokens.shift()[1];
    }
    node2.raws.between = "";
    let token;
    while (tokens.length) {
      token = tokens.shift();
      if (token[0] === ":") {
        node2.raws.between += token[1];
        break;
      } else {
        if (token[0] === "word" && /\w/.test(token[1])) {
          this.unknownWord([token]);
        }
        node2.raws.between += token[1];
      }
    }
    if (node2.prop[0] === "_" || node2.prop[0] === "*") {
      node2.raws.before += node2.prop[0];
      node2.prop = node2.prop.slice(1);
    }
    let firstSpaces = [];
    let next;
    while (tokens.length) {
      next = tokens[0][0];
      if (next !== "space" && next !== "comment")
        break;
      firstSpaces.push(tokens.shift());
    }
    this.precheckMissedSemicolon(tokens);
    for (let i2 = tokens.length - 1; i2 >= 0; i2--) {
      token = tokens[i2];
      if (token[1].toLowerCase() === "!important") {
        node2.important = true;
        let string = this.stringFrom(tokens, i2);
        string = this.spacesFromEnd(tokens) + string;
        if (string !== " !important")
          node2.raws.important = string;
        break;
      } else if (token[1].toLowerCase() === "important") {
        let cache = tokens.slice(0);
        let str = "";
        for (let j = i2; j > 0; j--) {
          let type = cache[j][0];
          if (str.trim().startsWith("!") && type !== "space") {
            break;
          }
          str = cache.pop()[1] + str;
        }
        if (str.trim().startsWith("!")) {
          node2.important = true;
          node2.raws.important = str;
          tokens = cache;
        }
      }
      if (token[0] !== "space" && token[0] !== "comment") {
        break;
      }
    }
    let hasWord = tokens.some((i2) => i2[0] !== "space" && i2[0] !== "comment");
    if (hasWord) {
      node2.raws.between += firstSpaces.map((i2) => i2[1]).join("");
      firstSpaces = [];
    }
    this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
    if (node2.value.includes(":") && !customProperty) {
      this.checkMissedSemicolon(tokens);
    }
  }
  doubleColon(token) {
    throw this.input.error(
      "Double colon",
      { offset: token[2] },
      { offset: token[2] + token[1].length }
    );
  }
  emptyRule(token) {
    let node2 = new Rule$1();
    this.init(node2, token[2]);
    node2.selector = "";
    node2.raws.between = "";
    this.current = node2;
  }
  end(token) {
    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }
    this.semicolon = false;
    this.current.raws.after = (this.current.raws.after || "") + this.spaces;
    this.spaces = "";
    if (this.current.parent) {
      this.current.source.end = this.getPosition(token[2]);
      this.current.source.end.offset++;
      this.current = this.current.parent;
    } else {
      this.unexpectedClose(token);
    }
  }
  endFile() {
    if (this.current.parent)
      this.unclosedBlock();
    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }
    this.current.raws.after = (this.current.raws.after || "") + this.spaces;
    this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(token) {
    this.spaces += token[1];
    if (this.current.nodes) {
      let prev = this.current.nodes[this.current.nodes.length - 1];
      if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
        prev.raws.ownSemicolon = this.spaces;
        this.spaces = "";
        prev.source.end = this.getPosition(token[2]);
        prev.source.end.offset += prev.raws.ownSemicolon.length;
      }
    }
  }
  // Helpers
  getPosition(offset2) {
    let pos = this.input.fromOffset(offset2);
    return {
      column: pos.col,
      line: pos.line,
      offset: offset2
    };
  }
  init(node2, offset2) {
    this.current.push(node2);
    node2.source = {
      input: this.input,
      start: this.getPosition(offset2)
    };
    node2.raws.before = this.spaces;
    this.spaces = "";
    if (node2.type !== "comment")
      this.semicolon = false;
  }
  other(start) {
    let end = false;
    let type = null;
    let colon = false;
    let bracket = null;
    let brackets = [];
    let customProperty = start[1].startsWith("--");
    let tokens = [];
    let token = start;
    while (token) {
      type = token[0];
      tokens.push(token);
      if (type === "(" || type === "[") {
        if (!bracket)
          bracket = token;
        brackets.push(type === "(" ? ")" : "]");
      } else if (customProperty && colon && type === "{") {
        if (!bracket)
          bracket = token;
        brackets.push("}");
      } else if (brackets.length === 0) {
        if (type === ";") {
          if (colon) {
            this.decl(tokens, customProperty);
            return;
          } else {
            break;
          }
        } else if (type === "{") {
          this.rule(tokens);
          return;
        } else if (type === "}") {
          this.tokenizer.back(tokens.pop());
          end = true;
          break;
        } else if (type === ":") {
          colon = true;
        }
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
        if (brackets.length === 0)
          bracket = null;
      }
      token = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile())
      end = true;
    if (brackets.length > 0)
      this.unclosedBracket(bracket);
    if (end && colon) {
      if (!customProperty) {
        while (tokens.length) {
          token = tokens[tokens.length - 1][0];
          if (token !== "space" && token !== "comment")
            break;
          this.tokenizer.back(tokens.pop());
        }
      }
      this.decl(tokens, customProperty);
    } else {
      this.unknownWord(tokens);
    }
  }
  parse() {
    let token;
    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();
      switch (token[0]) {
        case "space":
          this.spaces += token[1];
          break;
        case ";":
          this.freeSemicolon(token);
          break;
        case "}":
          this.end(token);
          break;
        case "comment":
          this.comment(token);
          break;
        case "at-word":
          this.atrule(token);
          break;
        case "{":
          this.emptyRule(token);
          break;
        default:
          this.other(token);
          break;
      }
    }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(node2, prop, tokens, customProperty) {
    let token, type;
    let length = tokens.length;
    let value = "";
    let clean = true;
    let next, prev;
    for (let i2 = 0; i2 < length; i2 += 1) {
      token = tokens[i2];
      type = token[0];
      if (type === "space" && i2 === length - 1 && !customProperty) {
        clean = false;
      } else if (type === "comment") {
        prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
        next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
        if (!SAFE_COMMENT_NEIGHBOR[prev] && !SAFE_COMMENT_NEIGHBOR[next]) {
          if (value.slice(-1) === ",") {
            clean = false;
          } else {
            value += token[1];
          }
        } else {
          clean = false;
        }
      } else {
        value += token[1];
      }
    }
    if (!clean) {
      let raw = tokens.reduce((all2, i2) => all2 + i2[1], "");
      node2.raws[prop] = { raw, value };
    }
    node2[prop] = value;
  }
  rule(tokens) {
    tokens.pop();
    let node2 = new Rule$1();
    this.init(node2, tokens[0][2]);
    node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
    this.raw(node2, "selector", tokens);
    this.current = node2;
  }
  spacesAndCommentsFromEnd(tokens) {
    let lastTokenType;
    let spaces = "";
    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== "space" && lastTokenType !== "comment")
        break;
      spaces = tokens.pop()[1] + spaces;
    }
    return spaces;
  }
  // Errors
  spacesAndCommentsFromStart(tokens) {
    let next;
    let spaces = "";
    while (tokens.length) {
      next = tokens[0][0];
      if (next !== "space" && next !== "comment")
        break;
      spaces += tokens.shift()[1];
    }
    return spaces;
  }
  spacesFromEnd(tokens) {
    let lastTokenType;
    let spaces = "";
    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== "space")
        break;
      spaces = tokens.pop()[1] + spaces;
    }
    return spaces;
  }
  stringFrom(tokens, from) {
    let result2 = "";
    for (let i2 = from; i2 < tokens.length; i2++) {
      result2 += tokens[i2][1];
    }
    tokens.splice(from, tokens.length - from);
    return result2;
  }
  unclosedBlock() {
    let pos = this.current.source.start;
    throw this.input.error("Unclosed block", pos.line, pos.column);
  }
  unclosedBracket(bracket) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: bracket[2] },
      { offset: bracket[2] + 1 }
    );
  }
  unexpectedClose(token) {
    throw this.input.error(
      "Unexpected }",
      { offset: token[2] },
      { offset: token[2] + 1 }
    );
  }
  unknownWord(tokens) {
    throw this.input.error(
      "Unknown word " + tokens[0][1],
      { offset: tokens[0][2] },
      { offset: tokens[0][2] + tokens[0][1].length }
    );
  }
  unnamedAtrule(node2, token) {
    throw this.input.error(
      "At-rule without name",
      { offset: token[2] },
      { offset: token[2] + token[1].length }
    );
  }
};
var parser = Parser$3;
let Container$2 = container;
let Input$1 = input;
let Parser$2 = parser;
function parse$5(css2, opts) {
  let input2 = new Input$1(css2, opts);
  let parser2 = new Parser$2(input2);
  try {
    parser2.parse();
  } catch (e) {
    throw e;
  }
  return parser2.root;
}
var parse_1 = parse$5;
parse$5.default = parse$5;
Container$2.registerParse(parse$5);
let Warning$2 = class Warning {
  constructor(text2, opts = {}) {
    this.type = "warning";
    this.text = text2;
    if (opts.node && opts.node.source) {
      let range = opts.node.rangeBy(opts);
      this.line = range.start.line;
      this.column = range.start.column;
      this.endLine = range.end.line;
      this.endColumn = range.end.column;
    }
    for (let opt in opts)
      this[opt] = opts[opt];
  }
  toString() {
    if (this.node) {
      return this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message;
    }
    if (this.plugin) {
      return this.plugin + ": " + this.text;
    }
    return this.text;
  }
};
var warning = Warning$2;
Warning$2.default = Warning$2;
let Warning$1 = warning;
let Result$3 = class Result {
  get content() {
    return this.css;
  }
  constructor(processor2, root2, opts) {
    this.processor = processor2;
    this.messages = [];
    this.root = root2;
    this.opts = opts;
    this.css = void 0;
    this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(text2, opts = {}) {
    if (!opts.plugin) {
      if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
        opts.plugin = this.lastPlugin.postcssPlugin;
      }
    }
    let warning2 = new Warning$1(text2, opts);
    this.messages.push(warning2);
    return warning2;
  }
  warnings() {
    return this.messages.filter((i2) => i2.type === "warning");
  }
};
var result = Result$3;
Result$3.default = Result$3;
let Container$1 = container;
let Document$2 = document$1;
let MapGenerator$1 = mapGenerator;
let parse$4 = parse_1;
let Result$2 = result;
let Root$2 = root;
let stringify$2 = stringify_1;
let { isClean, my } = symbols;
const TYPE_TO_CLASS_NAME = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
};
const PLUGIN_PROPS = {
  AtRule: true,
  AtRuleExit: true,
  Comment: true,
  CommentExit: true,
  Declaration: true,
  DeclarationExit: true,
  Document: true,
  DocumentExit: true,
  Once: true,
  OnceExit: true,
  postcssPlugin: true,
  prepare: true,
  Root: true,
  RootExit: true,
  Rule: true,
  RuleExit: true
};
const NOT_VISITORS = {
  Once: true,
  postcssPlugin: true,
  prepare: true
};
const CHILDREN = 0;
function isPromise(obj) {
  return typeof obj === "object" && typeof obj.then === "function";
}
function getEvents(node2) {
  let key = false;
  let type = TYPE_TO_CLASS_NAME[node2.type];
  if (node2.type === "decl") {
    key = node2.prop.toLowerCase();
  } else if (node2.type === "atrule") {
    key = node2.name.toLowerCase();
  }
  if (key && node2.append) {
    return [
      type,
      type + "-" + key,
      CHILDREN,
      type + "Exit",
      type + "Exit-" + key
    ];
  } else if (key) {
    return [type, type + "-" + key, type + "Exit", type + "Exit-" + key];
  } else if (node2.append) {
    return [type, CHILDREN, type + "Exit"];
  } else {
    return [type, type + "Exit"];
  }
}
function toStack(node2) {
  let events2;
  if (node2.type === "document") {
    events2 = ["Document", CHILDREN, "DocumentExit"];
  } else if (node2.type === "root") {
    events2 = ["Root", CHILDREN, "RootExit"];
  } else {
    events2 = getEvents(node2);
  }
  return {
    eventIndex: 0,
    events: events2,
    iterator: 0,
    node: node2,
    visitorIndex: 0,
    visitors: []
  };
}
function cleanMarks(node2) {
  node2[isClean] = false;
  if (node2.nodes)
    node2.nodes.forEach((i2) => cleanMarks(i2));
  return node2;
}
let postcss$1 = {};
let LazyResult$2 = class LazyResult {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(processor2, css2, opts) {
    this.stringified = false;
    this.processed = false;
    let root2;
    if (typeof css2 === "object" && css2 !== null && (css2.type === "root" || css2.type === "document")) {
      root2 = cleanMarks(css2);
    } else if (css2 instanceof LazyResult || css2 instanceof Result$2) {
      root2 = cleanMarks(css2.root);
      if (css2.map) {
        if (typeof opts.map === "undefined")
          opts.map = {};
        if (!opts.map.inline)
          opts.map.inline = false;
        opts.map.prev = css2.map;
      }
    } else {
      let parser2 = parse$4;
      if (opts.syntax)
        parser2 = opts.syntax.parse;
      if (opts.parser)
        parser2 = opts.parser;
      if (parser2.parse)
        parser2 = parser2.parse;
      try {
        root2 = parser2(css2, opts);
      } catch (error2) {
        this.processed = true;
        this.error = error2;
      }
      if (root2 && !root2[my]) {
        Container$1.rebuild(root2);
      }
    }
    this.result = new Result$2(processor2, root2, opts);
    this.helpers = __spreadProps(__spreadValues({}, postcss$1), { postcss: postcss$1, result: this.result });
    this.plugins = this.processor.plugins.map((plugin3) => {
      if (typeof plugin3 === "object" && plugin3.prepare) {
        return __spreadValues(__spreadValues({}, plugin3), plugin3.prepare(this.result));
      } else {
        return plugin3;
      }
    });
  }
  async() {
    if (this.error)
      return Promise.reject(this.error);
    if (this.processed)
      return Promise.resolve(this.result);
    if (!this.processing) {
      this.processing = this.runAsync();
    }
    return this.processing;
  }
  catch(onRejected) {
    return this.async().catch(onRejected);
  }
  finally(onFinally) {
    return this.async().then(onFinally, onFinally);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(error2, node2) {
    let plugin3 = this.result.lastPlugin;
    try {
      if (node2)
        node2.addToError(error2);
      this.error = error2;
      if (error2.name === "CssSyntaxError" && !error2.plugin) {
        error2.plugin = plugin3.postcssPlugin;
        error2.setMessage();
      } else if (plugin3.postcssVersion) {
        if (false)
          ;
      }
    } catch (err2) {
      if (console && console.error)
        console.error(err2);
    }
    return error2;
  }
  prepareVisitors() {
    this.listeners = {};
    let add2 = (plugin3, type, cb) => {
      if (!this.listeners[type])
        this.listeners[type] = [];
      this.listeners[type].push([plugin3, cb]);
    };
    for (let plugin3 of this.plugins) {
      if (typeof plugin3 === "object") {
        for (let event in plugin3) {
          if (!PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) {
            throw new Error(
              `Unknown event ${event} in ${plugin3.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          }
          if (!NOT_VISITORS[event]) {
            if (typeof plugin3[event] === "object") {
              for (let filter2 in plugin3[event]) {
                if (filter2 === "*") {
                  add2(plugin3, event, plugin3[event][filter2]);
                } else {
                  add2(
                    plugin3,
                    event + "-" + filter2.toLowerCase(),
                    plugin3[event][filter2]
                  );
                }
              }
            } else if (typeof plugin3[event] === "function") {
              add2(plugin3, event, plugin3[event]);
            }
          }
        }
      }
    }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  runAsync() {
    return __async(this, null, function* () {
      this.plugin = 0;
      for (let i2 = 0; i2 < this.plugins.length; i2++) {
        let plugin3 = this.plugins[i2];
        let promise = this.runOnRoot(plugin3);
        if (isPromise(promise)) {
          try {
            yield promise;
          } catch (error2) {
            throw this.handleError(error2);
          }
        }
      }
      this.prepareVisitors();
      if (this.hasListener) {
        let root2 = this.result.root;
        while (!root2[isClean]) {
          root2[isClean] = true;
          let stack = [toStack(root2)];
          while (stack.length > 0) {
            let promise = this.visitTick(stack);
            if (isPromise(promise)) {
              try {
                yield promise;
              } catch (e) {
                let node2 = stack[stack.length - 1].node;
                throw this.handleError(e, node2);
              }
            }
          }
        }
        if (this.listeners.OnceExit) {
          for (let [plugin3, visitor] of this.listeners.OnceExit) {
            this.result.lastPlugin = plugin3;
            try {
              if (root2.type === "document") {
                let roots = root2.nodes.map(
                  (subRoot) => visitor(subRoot, this.helpers)
                );
                yield Promise.all(roots);
              } else {
                yield visitor(root2, this.helpers);
              }
            } catch (e) {
              throw this.handleError(e);
            }
          }
        }
      }
      this.processed = true;
      return this.stringify();
    });
  }
  runOnRoot(plugin3) {
    this.result.lastPlugin = plugin3;
    try {
      if (typeof plugin3 === "object" && plugin3.Once) {
        if (this.result.root.type === "document") {
          let roots = this.result.root.nodes.map(
            (root2) => plugin3.Once(root2, this.helpers)
          );
          if (isPromise(roots[0])) {
            return Promise.all(roots);
          }
          return roots;
        }
        return plugin3.Once(this.result.root, this.helpers);
      } else if (typeof plugin3 === "function") {
        return plugin3(this.result.root, this.result);
      }
    } catch (error2) {
      throw this.handleError(error2);
    }
  }
  stringify() {
    if (this.error)
      throw this.error;
    if (this.stringified)
      return this.result;
    this.stringified = true;
    this.sync();
    let opts = this.result.opts;
    let str = stringify$2;
    if (opts.syntax)
      str = opts.syntax.stringify;
    if (opts.stringifier)
      str = opts.stringifier;
    if (str.stringify)
      str = str.stringify;
    let map = new MapGenerator$1(str, this.result.root, this.result.opts);
    let data = map.generate();
    this.result.css = data[0];
    this.result.map = data[1];
    return this.result;
  }
  sync() {
    if (this.error)
      throw this.error;
    if (this.processed)
      return this.result;
    this.processed = true;
    if (this.processing) {
      throw this.getAsyncError();
    }
    for (let plugin3 of this.plugins) {
      let promise = this.runOnRoot(plugin3);
      if (isPromise(promise)) {
        throw this.getAsyncError();
      }
    }
    this.prepareVisitors();
    if (this.hasListener) {
      let root2 = this.result.root;
      while (!root2[isClean]) {
        root2[isClean] = true;
        this.walkSync(root2);
      }
      if (this.listeners.OnceExit) {
        if (root2.type === "document") {
          for (let subRoot of root2.nodes) {
            this.visitSync(this.listeners.OnceExit, subRoot);
          }
        } else {
          this.visitSync(this.listeners.OnceExit, root2);
        }
      }
    }
    return this.result;
  }
  then(onFulfilled, onRejected) {
    return this.async().then(onFulfilled, onRejected);
  }
  toString() {
    return this.css;
  }
  visitSync(visitors, node2) {
    for (let [plugin3, visitor] of visitors) {
      this.result.lastPlugin = plugin3;
      let promise;
      try {
        promise = visitor(node2, this.helpers);
      } catch (e) {
        throw this.handleError(e, node2.proxyOf);
      }
      if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
        return true;
      }
      if (isPromise(promise)) {
        throw this.getAsyncError();
      }
    }
  }
  visitTick(stack) {
    let visit = stack[stack.length - 1];
    let { node: node2, visitors } = visit;
    if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
      stack.pop();
      return;
    }
    if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
      let [plugin3, visitor] = visitors[visit.visitorIndex];
      visit.visitorIndex += 1;
      if (visit.visitorIndex === visitors.length) {
        visit.visitors = [];
        visit.visitorIndex = 0;
      }
      this.result.lastPlugin = plugin3;
      try {
        return visitor(node2.toProxy(), this.helpers);
      } catch (e) {
        throw this.handleError(e, node2);
      }
    }
    if (visit.iterator !== 0) {
      let iterator = visit.iterator;
      let child;
      while (child = node2.nodes[node2.indexes[iterator]]) {
        node2.indexes[iterator] += 1;
        if (!child[isClean]) {
          child[isClean] = true;
          stack.push(toStack(child));
          return;
        }
      }
      visit.iterator = 0;
      delete node2.indexes[iterator];
    }
    let events2 = visit.events;
    while (visit.eventIndex < events2.length) {
      let event = events2[visit.eventIndex];
      visit.eventIndex += 1;
      if (event === CHILDREN) {
        if (node2.nodes && node2.nodes.length) {
          node2[isClean] = true;
          visit.iterator = node2.getIterator();
        }
        return;
      } else if (this.listeners[event]) {
        visit.visitors = this.listeners[event];
        return;
      }
    }
    stack.pop();
  }
  walkSync(node2) {
    node2[isClean] = true;
    let events2 = getEvents(node2);
    for (let event of events2) {
      if (event === CHILDREN) {
        if (node2.nodes) {
          node2.each((child) => {
            if (!child[isClean])
              this.walkSync(child);
          });
        }
      } else {
        let visitors = this.listeners[event];
        if (visitors) {
          if (this.visitSync(visitors, node2.toProxy()))
            return;
        }
      }
    }
  }
  warnings() {
    return this.sync().warnings();
  }
};
LazyResult$2.registerPostcss = (dependant) => {
  postcss$1 = dependant;
};
var lazyResult = LazyResult$2;
LazyResult$2.default = LazyResult$2;
Root$2.registerLazyResult(LazyResult$2);
Document$2.registerLazyResult(LazyResult$2);
let MapGenerator2 = mapGenerator;
let parse$3 = parse_1;
const Result$1 = result;
let stringify$1 = stringify_1;
let NoWorkResult$1 = class NoWorkResult {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root) {
      return this._root;
    }
    let root2;
    let parser2 = parse$3;
    try {
      root2 = parser2(this._css, this._opts);
    } catch (error2) {
      this.error = error2;
    }
    if (this.error) {
      throw this.error;
    } else {
      this._root = root2;
      return root2;
    }
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(processor2, css2, opts) {
    css2 = css2.toString();
    this.stringified = false;
    this._processor = processor2;
    this._css = css2;
    this._opts = opts;
    this._map = void 0;
    let root2;
    let str = stringify$1;
    this.result = new Result$1(this._processor, root2, this._opts);
    this.result.css = css2;
    let self2 = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return self2.root;
      }
    });
    let map = new MapGenerator2(str, root2, this._opts, css2);
    if (map.isMap()) {
      let [generatedCSS, generatedMap] = map.generate();
      if (generatedCSS) {
        this.result.css = generatedCSS;
      }
      if (generatedMap) {
        this.result.map = generatedMap;
      }
    } else {
      map.clearAnnotation();
      this.result.css = map.css;
    }
  }
  async() {
    if (this.error)
      return Promise.reject(this.error);
    return Promise.resolve(this.result);
  }
  catch(onRejected) {
    return this.async().catch(onRejected);
  }
  finally(onFinally) {
    return this.async().then(onFinally, onFinally);
  }
  sync() {
    if (this.error)
      throw this.error;
    return this.result;
  }
  then(onFulfilled, onRejected) {
    return this.async().then(onFulfilled, onRejected);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var noWorkResult = NoWorkResult$1;
NoWorkResult$1.default = NoWorkResult$1;
let Document$1 = document$1;
let LazyResult$1 = lazyResult;
let NoWorkResult2 = noWorkResult;
let Root$1 = root;
let Processor$1 = class Processor {
  constructor(plugins2 = []) {
    this.version = "8.5.3";
    this.plugins = this.normalize(plugins2);
  }
  normalize(plugins2) {
    let normalized = [];
    for (let i2 of plugins2) {
      if (i2.postcss === true) {
        i2 = i2();
      } else if (i2.postcss) {
        i2 = i2.postcss;
      }
      if (typeof i2 === "object" && Array.isArray(i2.plugins)) {
        normalized = normalized.concat(i2.plugins);
      } else if (typeof i2 === "object" && i2.postcssPlugin) {
        normalized.push(i2);
      } else if (typeof i2 === "function") {
        normalized.push(i2);
      } else if (typeof i2 === "object" && (i2.parse || i2.stringify))
        ;
      else {
        throw new Error(i2 + " is not a PostCSS plugin");
      }
    }
    return normalized;
  }
  process(css2, opts = {}) {
    if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) {
      return new NoWorkResult2(this, css2, opts);
    } else {
      return new LazyResult$1(this, css2, opts);
    }
  }
  use(plugin3) {
    this.plugins = this.plugins.concat(this.normalize([plugin3]));
    return this;
  }
};
var processor = Processor$1;
Processor$1.default = Processor$1;
Root$1.registerProcessor(Processor$1);
Document$1.registerProcessor(Processor$1);
let AtRule2 = atRule;
let Comment2 = comment;
let Container2 = container;
let CssSyntaxError2 = cssSyntaxError;
let Declaration2 = declaration;
let Document2 = document$1;
let fromJSON = fromJSON_1;
let Input2 = input;
let LazyResult2 = lazyResult;
let list = list_1;
let Node$1 = node;
let parse$2 = parse_1;
let Processor2 = processor;
let Result2 = result;
let Root2 = root;
let Rule2 = rule;
let stringify = stringify_1;
let Warning2 = warning;
function postcss(...plugins2) {
  if (plugins2.length === 1 && Array.isArray(plugins2[0])) {
    plugins2 = plugins2[0];
  }
  return new Processor2(plugins2);
}
postcss.plugin = function plugin(name, initializer) {
  let warningPrinted = false;
  function creator(...args) {
    if (console && console.warn && !warningPrinted) {
      warningPrinted = true;
      console.warn(
        name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration"
      );
      if (process.env.LANG && process.env.LANG.startsWith("cn")) {
        console.warn(
          name + ": 里面 postcss.plugin 被弃用. 迁移指南:\nhttps://www.w3ctech.com/topic/2226"
        );
      }
    }
    let transformer = initializer(...args);
    transformer.postcssPlugin = name;
    transformer.postcssVersion = new Processor2().version;
    return transformer;
  }
  let cache;
  Object.defineProperty(creator, "postcss", {
    get() {
      if (!cache)
        cache = creator();
      return cache;
    }
  });
  creator.process = function(css2, processOpts, pluginOpts) {
    return postcss([creator(pluginOpts)]).process(css2, processOpts);
  };
  return creator;
};
postcss.stringify = stringify;
postcss.parse = parse$2;
postcss.fromJSON = fromJSON;
postcss.list = list;
postcss.comment = (defaults2) => new Comment2(defaults2);
postcss.atRule = (defaults2) => new AtRule2(defaults2);
postcss.decl = (defaults2) => new Declaration2(defaults2);
postcss.rule = (defaults2) => new Rule2(defaults2);
postcss.root = (defaults2) => new Root2(defaults2);
postcss.document = (defaults2) => new Document2(defaults2);
postcss.CssSyntaxError = CssSyntaxError2;
postcss.Declaration = Declaration2;
postcss.Container = Container2;
postcss.Processor = Processor2;
postcss.Document = Document2;
postcss.Comment = Comment2;
postcss.Warning = Warning2;
postcss.AtRule = AtRule2;
postcss.Result = Result2;
postcss.Input = Input2;
postcss.Rule = Rule2;
postcss.Root = Root2;
postcss.Node = Node$1;
LazyResult2.registerPostcss(postcss);
var postcss_1 = postcss;
postcss.default = postcss;
const htmlparser = lib$5;
const escapeStringRegexp = escapeStringRegexp$1;
const { isPlainObject: isPlainObject$1 } = isPlainObject$3;
const deepmerge = cjs;
const parseSrcset = parseSrcsetExports;
const { parse: postcssParse } = postcss_1;
const mediaTags = [
  "img",
  "audio",
  "video",
  "picture",
  "svg",
  "object",
  "map",
  "iframe",
  "embed"
];
const vulnerableTags = ["script", "style"];
function each(obj, cb) {
  if (obj) {
    Object.keys(obj).forEach(function(key) {
      cb(obj[key], key);
    });
  }
}
function has(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function filter(a, cb) {
  const n2 = [];
  each(a, function(v) {
    if (cb(v)) {
      n2.push(v);
    }
  });
  return n2;
}
function isEmptyObject(obj) {
  for (const key in obj) {
    if (has(obj, key)) {
      return false;
    }
  }
  return true;
}
function stringifySrcset(parsedSrcset) {
  return parsedSrcset.map(function(part) {
    if (!part.url) {
      throw new Error("URL missing");
    }
    return part.url + (part.w ? ` ${part.w}w` : "") + (part.h ? ` ${part.h}h` : "") + (part.d ? ` ${part.d}x` : "");
  }).join(", ");
}
var sanitizeHtml_1 = sanitizeHtml;
const VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;
function sanitizeHtml(html, options, _recursing) {
  if (html == null) {
    return "";
  }
  if (typeof html === "number") {
    html = html.toString();
  }
  let result2 = "";
  let tempResult = "";
  function Frame(tag, attribs) {
    const that = this;
    this.tag = tag;
    this.attribs = attribs || {};
    this.tagPosition = result2.length;
    this.text = "";
    this.mediaChildren = [];
    this.updateParentNodeText = function() {
      if (stack.length) {
        const parentFrame = stack[stack.length - 1];
        parentFrame.text += that.text;
      }
    };
    this.updateParentNodeMediaChildren = function() {
      if (stack.length && mediaTags.includes(this.tag)) {
        const parentFrame = stack[stack.length - 1];
        parentFrame.mediaChildren.push(this.tag);
      }
    };
  }
  options = Object.assign({}, sanitizeHtml.defaults, options);
  options.parser = Object.assign({}, htmlParserDefaults, options.parser);
  const tagAllowed = function(name) {
    return options.allowedTags === false || (options.allowedTags || []).indexOf(name) > -1;
  };
  vulnerableTags.forEach(function(tag) {
    if (tagAllowed(tag) && !options.allowVulnerableTags) {
      console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${tag}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
    }
  });
  const nonTextTagsArray = options.nonTextTags || [
    "script",
    "style",
    "textarea",
    "option"
  ];
  let allowedAttributesMap;
  let allowedAttributesGlobMap;
  if (options.allowedAttributes) {
    allowedAttributesMap = {};
    allowedAttributesGlobMap = {};
    each(options.allowedAttributes, function(attributes2, tag) {
      allowedAttributesMap[tag] = [];
      const globRegex = [];
      attributes2.forEach(function(obj) {
        if (typeof obj === "string" && obj.indexOf("*") >= 0) {
          globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, ".*"));
        } else {
          allowedAttributesMap[tag].push(obj);
        }
      });
      if (globRegex.length) {
        allowedAttributesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
      }
    });
  }
  const allowedClassesMap = {};
  const allowedClassesGlobMap = {};
  const allowedClassesRegexMap = {};
  each(options.allowedClasses, function(classes, tag) {
    if (allowedAttributesMap) {
      if (!has(allowedAttributesMap, tag)) {
        allowedAttributesMap[tag] = [];
      }
      allowedAttributesMap[tag].push("class");
    }
    allowedClassesMap[tag] = classes;
    if (Array.isArray(classes)) {
      const globRegex = [];
      allowedClassesMap[tag] = [];
      allowedClassesRegexMap[tag] = [];
      classes.forEach(function(obj) {
        if (typeof obj === "string" && obj.indexOf("*") >= 0) {
          globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, ".*"));
        } else if (obj instanceof RegExp) {
          allowedClassesRegexMap[tag].push(obj);
        } else {
          allowedClassesMap[tag].push(obj);
        }
      });
      if (globRegex.length) {
        allowedClassesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
      }
    }
  });
  const transformTagsMap = {};
  let transformTagsAll;
  each(options.transformTags, function(transform, tag) {
    let transFun;
    if (typeof transform === "function") {
      transFun = transform;
    } else if (typeof transform === "string") {
      transFun = sanitizeHtml.simpleTransform(transform);
    }
    if (tag === "*") {
      transformTagsAll = transFun;
    } else {
      transformTagsMap[tag] = transFun;
    }
  });
  let depth;
  let stack;
  let skipMap;
  let transformMap;
  let skipText;
  let skipTextDepth;
  let addedText = false;
  initializeState();
  const parser2 = new htmlparser.Parser({
    onopentag: function(name, attribs) {
      if (options.enforceHtmlBoundary && name === "html") {
        initializeState();
      }
      if (skipText) {
        skipTextDepth++;
        return;
      }
      const frame = new Frame(name, attribs);
      stack.push(frame);
      let skip = false;
      const hasText = !!frame.text;
      let transformedTag;
      if (has(transformTagsMap, name)) {
        transformedTag = transformTagsMap[name](name, attribs);
        frame.attribs = attribs = transformedTag.attribs;
        if (transformedTag.text !== void 0) {
          frame.innerText = transformedTag.text;
        }
        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }
      if (transformTagsAll) {
        transformedTag = transformTagsAll(name, attribs);
        frame.attribs = attribs = transformedTag.attribs;
        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }
      if (!tagAllowed(name) || options.disallowedTagsMode === "recursiveEscape" && !isEmptyObject(skipMap) || options.nestingLimit != null && depth >= options.nestingLimit) {
        skip = true;
        skipMap[depth] = true;
        if (options.disallowedTagsMode === "discard" || options.disallowedTagsMode === "completelyDiscard") {
          if (nonTextTagsArray.indexOf(name) !== -1) {
            skipText = true;
            skipTextDepth = 1;
          }
        }
        skipMap[depth] = true;
      }
      depth++;
      if (skip) {
        if (options.disallowedTagsMode === "discard" || options.disallowedTagsMode === "completelyDiscard") {
          if (frame.innerText && !hasText) {
            const escaped = escapeHtml2(frame.innerText);
            if (options.textFilter) {
              result2 += options.textFilter(escaped, name);
            } else {
              result2 += escapeHtml2(frame.innerText);
            }
            addedText = true;
          }
          return;
        }
        tempResult = result2;
        result2 = "";
      }
      result2 += "<" + name;
      if (name === "script") {
        if (options.allowedScriptHostnames || options.allowedScriptDomains) {
          frame.innerText = "";
        }
      }
      if (!allowedAttributesMap || has(allowedAttributesMap, name) || allowedAttributesMap["*"]) {
        each(attribs, function(value, a) {
          if (!VALID_HTML_ATTRIBUTE_NAME.test(a)) {
            delete frame.attribs[a];
            return;
          }
          if (value === "" && !options.allowedEmptyAttributes.includes(a) && (options.nonBooleanAttributes.includes(a) || options.nonBooleanAttributes.includes("*"))) {
            delete frame.attribs[a];
            return;
          }
          let passedAllowedAttributesMapCheck = false;
          if (!allowedAttributesMap || has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 || allowedAttributesMap["*"] && allowedAttributesMap["*"].indexOf(a) !== -1 || has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a) || allowedAttributesGlobMap["*"] && allowedAttributesGlobMap["*"].test(a)) {
            passedAllowedAttributesMapCheck = true;
          } else if (allowedAttributesMap && allowedAttributesMap[name]) {
            for (const o of allowedAttributesMap[name]) {
              if (isPlainObject$1(o) && o.name && o.name === a) {
                passedAllowedAttributesMapCheck = true;
                let newValue = "";
                if (o.multiple === true) {
                  const splitStrArray = value.split(" ");
                  for (const s2 of splitStrArray) {
                    if (o.values.indexOf(s2) !== -1) {
                      if (newValue === "") {
                        newValue = s2;
                      } else {
                        newValue += " " + s2;
                      }
                    }
                  }
                } else if (o.values.indexOf(value) >= 0) {
                  newValue = value;
                }
                value = newValue;
              }
            }
          }
          if (passedAllowedAttributesMapCheck) {
            if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
              if (naughtyHref(name, value)) {
                delete frame.attribs[a];
                return;
              }
            }
            if (name === "script" && a === "src") {
              let allowed = true;
              try {
                const parsed = parseUrl(value);
                if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                  const allowedHostname = (options.allowedScriptHostnames || []).find(function(hostname) {
                    return hostname === parsed.url.hostname;
                  });
                  const allowedDomain = (options.allowedScriptDomains || []).find(function(domain2) {
                    return parsed.url.hostname === domain2 || parsed.url.hostname.endsWith(`.${domain2}`);
                  });
                  allowed = allowedHostname || allowedDomain;
                }
              } catch (e) {
                allowed = false;
              }
              if (!allowed) {
                delete frame.attribs[a];
                return;
              }
            }
            if (name === "iframe" && a === "src") {
              let allowed = true;
              try {
                const parsed = parseUrl(value);
                if (parsed.isRelativeUrl) {
                  allowed = has(options, "allowIframeRelativeUrls") ? options.allowIframeRelativeUrls : !options.allowedIframeHostnames && !options.allowedIframeDomains;
                } else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
                  const allowedHostname = (options.allowedIframeHostnames || []).find(function(hostname) {
                    return hostname === parsed.url.hostname;
                  });
                  const allowedDomain = (options.allowedIframeDomains || []).find(function(domain2) {
                    return parsed.url.hostname === domain2 || parsed.url.hostname.endsWith(`.${domain2}`);
                  });
                  allowed = allowedHostname || allowedDomain;
                }
              } catch (e) {
                allowed = false;
              }
              if (!allowed) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === "srcset") {
              try {
                let parsed = parseSrcset(value);
                parsed.forEach(function(value2) {
                  if (naughtyHref("srcset", value2.url)) {
                    value2.evil = true;
                  }
                });
                parsed = filter(parsed, function(v) {
                  return !v.evil;
                });
                if (!parsed.length) {
                  delete frame.attribs[a];
                  return;
                } else {
                  value = stringifySrcset(filter(parsed, function(v) {
                    return !v.evil;
                  }));
                  frame.attribs[a] = value;
                }
              } catch (e) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === "class") {
              const allowedSpecificClasses = allowedClassesMap[name];
              const allowedWildcardClasses = allowedClassesMap["*"];
              const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
              const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
              const allowedWildcardClassesRegex = allowedClassesRegexMap["*"];
              const allowedWildcardClassesGlob = allowedClassesGlobMap["*"];
              const allowedClassesGlobs = [
                allowedSpecificClassesGlob,
                allowedWildcardClassesGlob
              ].concat(allowedSpecificClassesRegex, allowedWildcardClassesRegex).filter(function(t3) {
                return t3;
              });
              if (allowedSpecificClasses && allowedWildcardClasses) {
                value = filterClasses(value, deepmerge(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
              } else {
                value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
              }
              if (!value.length) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === "style") {
              if (options.parseStyleAttributes) {
                try {
                  const abstractSyntaxTree = postcssParse(name + " {" + value + "}", { map: false });
                  const filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);
                  value = stringifyStyleAttributes(filteredAST);
                  if (value.length === 0) {
                    delete frame.attribs[a];
                    return;
                  }
                } catch (e) {
                  if (typeof window !== "undefined") {
                    console.warn('Failed to parse "' + name + " {" + value + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`);
                  }
                  delete frame.attribs[a];
                  return;
                }
              } else if (options.allowedStyles) {
                throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
              }
            }
            result2 += " " + a;
            if (value && value.length) {
              result2 += '="' + escapeHtml2(value, true) + '"';
            } else if (options.allowedEmptyAttributes.includes(a)) {
              result2 += '=""';
            }
          } else {
            delete frame.attribs[a];
          }
        });
      }
      if (options.selfClosing.indexOf(name) !== -1) {
        result2 += " />";
      } else {
        result2 += ">";
        if (frame.innerText && !hasText && !options.textFilter) {
          result2 += escapeHtml2(frame.innerText);
          addedText = true;
        }
      }
      if (skip) {
        result2 = tempResult + escapeHtml2(result2);
        tempResult = "";
      }
    },
    ontext: function(text2) {
      if (skipText) {
        return;
      }
      const lastFrame = stack[stack.length - 1];
      let tag;
      if (lastFrame) {
        tag = lastFrame.tag;
        text2 = lastFrame.innerText !== void 0 ? lastFrame.innerText : text2;
      }
      if (options.disallowedTagsMode === "completelyDiscard" && !tagAllowed(tag)) {
        text2 = "";
      } else if ((options.disallowedTagsMode === "discard" || options.disallowedTagsMode === "completelyDiscard") && (tag === "script" || tag === "style")) {
        result2 += text2;
      } else {
        const escaped = escapeHtml2(text2, false);
        if (options.textFilter && !addedText) {
          result2 += options.textFilter(escaped, tag);
        } else if (!addedText) {
          result2 += escaped;
        }
      }
      if (stack.length) {
        const frame = stack[stack.length - 1];
        frame.text += text2;
      }
    },
    onclosetag: function(name, isImplied) {
      if (skipText) {
        skipTextDepth--;
        if (!skipTextDepth) {
          skipText = false;
        } else {
          return;
        }
      }
      const frame = stack.pop();
      if (!frame) {
        return;
      }
      if (frame.tag !== name) {
        stack.push(frame);
        return;
      }
      skipText = options.enforceHtmlBoundary ? name === "html" : false;
      depth--;
      const skip = skipMap[depth];
      if (skip) {
        delete skipMap[depth];
        if (options.disallowedTagsMode === "discard" || options.disallowedTagsMode === "completelyDiscard") {
          frame.updateParentNodeText();
          return;
        }
        tempResult = result2;
        result2 = "";
      }
      if (transformMap[depth]) {
        name = transformMap[depth];
        delete transformMap[depth];
      }
      if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
        result2 = result2.substr(0, frame.tagPosition);
        return;
      }
      frame.updateParentNodeMediaChildren();
      frame.updateParentNodeText();
      if (
        // Already output />
        options.selfClosing.indexOf(name) !== -1 || // Escaped tag, closing tag is implied
        isImplied && !tagAllowed(name) && ["escape", "recursiveEscape"].indexOf(options.disallowedTagsMode) >= 0
      ) {
        if (skip) {
          result2 = tempResult;
          tempResult = "";
        }
        return;
      }
      result2 += "</" + name + ">";
      if (skip) {
        result2 = tempResult + escapeHtml2(result2);
        tempResult = "";
      }
      addedText = false;
    }
  }, options.parser);
  parser2.write(html);
  parser2.end();
  return result2;
  function initializeState() {
    result2 = "";
    depth = 0;
    stack = [];
    skipMap = {};
    transformMap = {};
    skipText = false;
    skipTextDepth = 0;
  }
  function escapeHtml2(s2, quote) {
    if (typeof s2 !== "string") {
      s2 = s2 + "";
    }
    if (options.parser.decodeEntities) {
      s2 = s2.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      if (quote) {
        s2 = s2.replace(/"/g, "&quot;");
      }
    }
    s2 = s2.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    if (quote) {
      s2 = s2.replace(/"/g, "&quot;");
    }
    return s2;
  }
  function naughtyHref(name, href) {
    href = href.replace(/[\x00-\x20]+/g, "");
    while (true) {
      const firstIndex = href.indexOf("<!--");
      if (firstIndex === -1) {
        break;
      }
      const lastIndex = href.indexOf("-->", firstIndex + 4);
      if (lastIndex === -1) {
        break;
      }
      href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
    }
    const matches2 = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!matches2) {
      if (href.match(/^[/\\]{2}/)) {
        return !options.allowProtocolRelative;
      }
      return false;
    }
    const scheme = matches2[1].toLowerCase();
    if (has(options.allowedSchemesByTag, name)) {
      return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
    }
    return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
  }
  function parseUrl(value) {
    value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//");
    if (value.startsWith("relative:")) {
      throw new Error("relative: exploit attempt");
    }
    let base = "relative://relative-site";
    for (let i2 = 0; i2 < 100; i2++) {
      base += `/${i2}`;
    }
    const parsed = new URL(value, base);
    const isRelativeUrl = parsed && parsed.hostname === "relative-site" && parsed.protocol === "relative:";
    return {
      isRelativeUrl,
      url: parsed
    };
  }
  function filterCss(abstractSyntaxTree, allowedStyles) {
    if (!allowedStyles) {
      return abstractSyntaxTree;
    }
    const astRules = abstractSyntaxTree.nodes[0];
    let selectedRule;
    if (allowedStyles[astRules.selector] && allowedStyles["*"]) {
      selectedRule = deepmerge(
        allowedStyles[astRules.selector],
        allowedStyles["*"]
      );
    } else {
      selectedRule = allowedStyles[astRules.selector] || allowedStyles["*"];
    }
    if (selectedRule) {
      abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
    }
    return abstractSyntaxTree;
  }
  function stringifyStyleAttributes(filteredAST) {
    return filteredAST.nodes[0].nodes.reduce(function(extractedAttributes, attrObject) {
      extractedAttributes.push(
        `${attrObject.prop}:${attrObject.value}${attrObject.important ? " !important" : ""}`
      );
      return extractedAttributes;
    }, []).join(";");
  }
  function filterDeclarations(selectedRule) {
    return function(allowedDeclarationsList, attributeObject) {
      if (has(selectedRule, attributeObject.prop)) {
        const matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
          return regularExpression.test(attributeObject.value);
        });
        if (matchesRegex) {
          allowedDeclarationsList.push(attributeObject);
        }
      }
      return allowedDeclarationsList;
    };
  }
  function filterClasses(classes, allowed, allowedGlobs) {
    if (!allowed) {
      return classes;
    }
    classes = classes.split(/\s+/);
    return classes.filter(function(clss) {
      return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
        return glob.test(clss);
      });
    }).join(" ");
  }
}
const htmlParserDefaults = {
  decodeEntities: true
};
sanitizeHtml.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    // Text content
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "main",
    "ol",
    "p",
    "pre",
    "ul",
    // Inline text semantics
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Table content
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    "abbr",
    "accept",
    "accept-charset",
    "accesskey",
    "action",
    "allow",
    "alt",
    "as",
    "autocapitalize",
    "autocomplete",
    "blocking",
    "charset",
    "cite",
    "class",
    "color",
    "cols",
    "colspan",
    "content",
    "contenteditable",
    "coords",
    "crossorigin",
    "data",
    "datetime",
    "decoding",
    "dir",
    "dirname",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "fetchpriority",
    "for",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formtarget",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "http-equiv",
    "id",
    "imagesizes",
    "imagesrcset",
    "inputmode",
    "integrity",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemtype",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "name",
    "nonce",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "referrerpolicy",
    "rel",
    "rows",
    "rowspan",
    "sandbox",
    "scope",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "spellcheck",
    "src",
    "srcdoc",
    "srclang",
    "srcset",
    "start",
    "step",
    "style",
    "tabindex",
    "target",
    "title",
    "translate",
    "type",
    "usemap",
    "value",
    "width",
    "wrap",
    // Event handlers
    "onauxclick",
    "onafterprint",
    "onbeforematch",
    "onbeforeprint",
    "onbeforeunload",
    "onbeforetoggle",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextlost",
    "oncontextmenu",
    "oncontextrestored",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "onformdata",
    "onhashchange",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlanguagechange",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmessageerror",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onoffline",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreset",
    "onresize",
    "onrejectionhandled",
    "onscroll",
    "onscrollend",
    "onsecuritypolicyviolation",
    "onseeked",
    "onseeking",
    "onselect",
    "onslotchange",
    "onstalled",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "ontoggle",
    "onunhandledrejection",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onwheel"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
  },
  allowedEmptyAttributes: [
    "alt"
  ],
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: true,
  enforceHtmlBoundary: false,
  parseStyleAttributes: true
};
sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge2) {
  merge2 = merge2 === void 0 ? true : merge2;
  newAttribs = newAttribs || {};
  return function(tagName2, attribs) {
    let attrib;
    if (merge2) {
      for (attrib in newAttribs) {
        attribs[attrib] = newAttribs[attrib];
      }
    } else {
      attribs = newAttribs;
    }
    return {
      tagName: newTagName,
      attribs
    };
  };
};
const sanitizeHtml$1 = /* @__PURE__ */ getDefaultExportFromCjs(sanitizeHtml_1);
function addBrTag(text2) {
  return sanitizeHtml$1(text2.replace(/\n|\r/g, "<br>"));
}
const text = { addBrTag, sanitizeHtml: sanitizeHtml$1 };
const Utils = { editShowcase, getMediaHtml, saveJsonToFile, SVG, toHex, text };
const useDpmStore = /* @__PURE__ */ defineStore("dpm", {
  state: () => ({
    global: {
      activeSweepExtension: true,
      attachments: null,
      attachmentType: null,
      bgm: { autoPlay: false, url: null, isPlaying: false, beforeState: false },
      displayedMattertagSids: [],
      enableExtensions: { mattertag: false, sweep: false, minimap: false, cilbee: false },
      groupListDrawer: { display: false, expand: true },
      floors: [],
      labels: [],
      // FIXME?: origin data. $globalに移した方が良い？ --------
      minimap: {
        data: [],
        menu: { expand: true, mattertag: true, sweep: true, label: true }
      },
      mattertags: null,
      modelSid: null,
      objectListDrawer: { display: false, expand: false },
      organizationListDrawer: { display: false, expand: false, data: null },
      rooms: null,
      scan: { text: null, result: null },
      scene: null,
      showCilbee: false,
      showSharedLink: false,
      showShowcaseEditor: false,
      showTrimmingEditor: false,
      showVirtualStaging: false,
      standalone: false,
      sweeps: null
    },
    current: {
      extension: null,
      floor: null,
      mattertagSid: null,
      mode: null,
      pose: null,
      sweep: null,
      sweepSid: null,
      mattertagGroupList: []
      // NOTE: 最初は空だが、prepareMattertagsForGroupListでicon等表示に最低限必要なデータがセットされて、Attachmentのデータ挿入はsdk.Tag.attachments.subscribeで行う
    },
    sweepEditor: {
      visible: false,
      activeGroupIndex: void 0,
      activeTab: void 0,
      // NOTE: 0: group, 1: single
      groupEditorVisible: false,
      singleEditorVisible: false,
      selectedSweep: null
    },
    cilbeeEditor: {
      visible: false,
      selectedSweep: null,
      rootSweep: null
    },
    mattertagEditor: {
      currentEditGroupIndex: null,
      editDialogVisible: false,
      groupDialogVisible: false,
      errorText: "",
      useBy: null,
      selectedIcon: {
        activeStorageId: null,
        item: null,
        url: null
      },
      tagChanged: false
    },
    uiEditor: {
      minimapModal: false,
      tagListTitleModal: false
    },
    showcaseEditorData: {
      mattertags: [],
      mattertag_groups: [],
      sweeps: [],
      sweep_groups: [],
      objects: "",
      minimap_images: [],
      minimap_rotate: 0,
      cilbee: {
        arrivedText: {
          "en-US": "",
          en: "",
          ja: "",
          ko: "",
          "zh-CN": "",
          "zh-TW": ""
        },
        arrivedForm: "",
        noResultText: {
          "en-US": "",
          en: "",
          ja: "",
          ko: "",
          "zh-CN": "",
          "zh-TW": ""
        },
        passableAreas: [],
        privacyPolicy: ""
      },
      ui: {
        default: {
          minimap: {
            mattertag: {
              switch: "Tag",
              help: ""
            },
            sweep: {
              switch: "Sweep",
              help: ""
            },
            label: {
              switch: "Label",
              help: ""
            }
          },
          group_list_title: { bg_color: "#FFFFFF", image: { active_storage_id: "", url: "" }, text: "Tags" }
        }
      }
    },
    sharedExperience: {
      isHost: false,
      userId: null,
      name: "",
      num: 0,
      subscription: null,
      room: "",
      avatarUrl: ""
    },
    virtualStaging: {
      selectedComponent: null,
      assets: [],
      useMeasurementPrimitive: false
    }
  }),
  getters: {
    filterMattertagsForGroupList(state) {
      return (query2) => {
        let returnMattertags = [];
        if (query2.groupChipIds.includes(0)) {
          returnMattertags = state.current.mattertagGroupList;
        } else {
          returnMattertags = state.current.mattertagGroupList.filter((mattertag) => query2.groupChipIds.includes(mattertag.group.index + 1));
        }
        if (query2.keyword) {
          if (query2.titleOnly) {
            returnMattertags = returnMattertags.filter((mattertag) => mattertag.label.toLowerCase().includes(query2.keyword.toLowerCase()));
          } else {
            returnMattertags = returnMattertags.filter((mattertag) => mattertag.label.toLowerCase().includes(query2.keyword.toLowerCase()) || mattertag.description.toLowerCase().includes(query2.keyword.toLowerCase()));
          }
        }
        return returnMattertags;
      };
    },
    currentEditSweep: (state) => state.showcaseEditorData.sweeps.find((sweep) => state.sweepEditor.selectedSweep && sweep.sid === state.sweepEditor.selectedSweep.sid),
    currentEditSweepGroup: (state) => state.showcaseEditorData.sweep_groups[state.sweepEditor.activeGroupIndex],
    currentSweepGroup: (state) => state.showcaseEditorData.sweep_groups.filter((sweepGroup) => sweepGroup.sweeps.includes(state.current.sweepSid))[0],
    currentSweepGroupIndex: (state) => state.showcaseEditorData.sweep_groups.findIndex((sweepGroup) => sweepGroup.sweeps.includes(state.current.sweepSid)),
    currentOriginMattertag: (state) => state.global.mattertags[state.current.mattertagSid],
    currentEditMattertag: (state) => state.showcaseEditorData.mattertags.find((mattertag) => mattertag.sid === state.current.mattertagSid),
    currentEditData() {
      return (useBy) => {
        if (useBy === "mattertag") {
          return this.currentEditMattertag;
        } else {
          return this.currentEditSweepGroup;
        }
      };
    },
    currentEditIconData() {
      return this.mattertagEditor.useBy === "mattertag" ? this.currentEditMattertag.icon : this.currentEditGroup;
    },
    currentEditGroup: (state) => state.showcaseEditorData.mattertag_groups[state.mattertagEditor.currentEditGroupIndex],
    determineTagStyle(state) {
      return (sid, customIconData, customColor) => {
        var _a2;
        for (const group of state.SED.mattertag_groups) {
          if (!group.topPriority)
            continue;
          for (const mattertag of group.mattertags) {
            if (mattertag.sid === sid) {
              return { type: group.url ? "groupUrl" : group.id ? "groupId" : "groupColor", target: group };
            }
          }
        }
        if (((_a2 = state.global.enableExtensions) == null ? void 0 : _a2.mattertag) && (customIconData == null ? void 0 : customIconData.id)) {
          return { type: customIconData.url ? "customUrl" : "customId", target: customIconData };
        }
        for (const group of state.SED.mattertag_groups) {
          if (!group.id)
            continue;
          for (const mattertag of group.mattertags) {
            if (mattertag.sid === sid) {
              return { type: group.url ? "groupUrl" : group.id ? "groupId" : "groupColor", target: group };
            }
          }
        }
        if (customColor) {
          return { type: "fallbackColor", target: null };
        }
        return { type: "none", target: null };
      };
    },
    getClosestSweepSid(state) {
      return (position) => {
        let closestDistance = Infinity;
        let closestSweep = null;
        Object.keys(state.global.sweeps).forEach((key) => {
          const distance = position.distanceTo(state.global.sweeps[key].position);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestSweep = state.global.sweeps[key];
          }
        });
        return closestSweep.sid;
      };
    },
    getCustomColor(state) {
      return (sid, customIconData) => {
        let customColor = null;
        if (state.global.enableExtensions.mattertag && (customIconData == null ? void 0 : customIconData.color)) {
          customColor = customIconData.color;
        }
        if (state.SED.mattertag_groups.length) {
          const groupedMattertagSids = state.SED.mattertag_groups.map((group) => {
            return group.mattertags.map((mattertag) => mattertag.sid);
          }).flat();
          const duplicateGroupedMattertagSids = groupedMattertagSids.filter((x2, i2, self2) => {
            return self2.indexOf(x2) === i2 && i2 !== self2.lastIndexOf(x2);
          });
          if (duplicateGroupedMattertagSids.includes(sid)) {
            customColor = null;
          } else {
            state.SED.mattertag_groups.forEach((group) => {
              if (group.mattertags.find((mattertag) => mattertag.sid === sid) && !group.useCustomColor && !group.colorless && group.color) {
                customColor = group.color;
              }
            });
          }
        }
        return customColor;
      };
    },
    getFloorByMattertag(state) {
      return (mattertag) => {
        var _a2, _b2, _c;
        if (mattertag.floorId) {
          return state.global.floors[mattertag.floorId];
        } else if (mattertag.roomId) {
          return state.global.floors[state.global.rooms[mattertag.roomId].floorInfo.id];
        } else if (((_a2 = state.global.mattertags[mattertag.sid]) == null ? void 0 : _a2.roomId) === void 0) {
          return state.global.floors[(_b2 = state.global.rooms[this.calcCurrentRoomId(new Vector3(mattertag.anchorPosition.x, mattertag.anchorPosition.y, mattertag.anchorPosition.z), null, mattertag)]) == null ? void 0 : _b2.floorInfo.id];
        } else if (mattertag.sid) {
          return state.global.floors[(_c = state.global.rooms[state.global.mattertags[mattertag.sid].roomId]) == null ? void 0 : _c.floorInfo.id];
        }
      };
    },
    getLabel(state) {
      return (sid) => {
        var _a2;
        const sed = state.SED.mattertags.find((mattertag) => mattertag.sid === sid);
        if (sed == null ? void 0 : sed.label) {
          return sed.label;
        }
        return ((_a2 = state.global.mattertags[sid]) == null ? void 0 : _a2.label) || sid;
      };
    },
    getMattertagBySid(state) {
      return (sid) => {
        const mattertag = state.showcaseEditorData.mattertags.find((mattertag2) => mattertag2.sid === sid);
        if (mattertag) {
          return mattertag;
        } else {
          return state.global.mattertags[sid];
        }
      };
    },
    getUngroupedGroup(state) {
      return state.SED.mattertag_groups.find((group) => group.uneditable);
    },
    isAddedMattertag(state) {
      return (sid) => state.global.mattertags[sid] === void 0;
    },
    isOverride(state) {
      return (sid, iconParams) => {
        return state.global.mattertags[sid] && iconParams[1].toUpperCase() === Utils.toHex(state.global.mattertags[sid].color).toUpperCase();
      };
    },
    SED: (state) => state.showcaseEditorData,
    mergedGlobalSed: (state) => {
      return {
        mattertags: _values(_merge({}, state.global.mattertags, _keyBy(state.SED.mattertags, "sid")))
      };
    }
  },
  actions: {
    calcCurrentRoomId(position, originData, data) {
      var _a2;
      let tagPosition;
      if (originData) {
        const direction = new Vector3(originData.stemVector.x, originData.stemVector.y, originData.stemVector.z);
        tagPosition = position.clone().add(direction);
      } else {
        (_a2 = data.stemVector) != null ? _a2 : data.stemVector = { x: 0, y: 0, z: 0 };
        const direction = new Vector3(data.stemVector.x, data.stemVector.y, data.stemVector.z);
        tagPosition = position.clone().add(direction);
      }
      const matchedRoomIds = Object.keys(this.global.rooms).filter((roomId) => {
        const room = this.global.rooms[roomId];
        return room.bounds.min.x < tagPosition.x && tagPosition.x < room.bounds.max.x && (room.bounds.min.y < tagPosition.y && tagPosition.y < room.bounds.max.y) && (room.bounds.min.z < tagPosition.z && tagPosition.z < room.bounds.max.z);
      });
      if (matchedRoomIds.length === 1) {
        return matchedRoomIds[0];
      }
      if (matchedRoomIds.includes(originData == null ? void 0 : originData.roomId)) {
        return originData.roomId;
      }
      if (matchedRoomIds.includes(data == null ? void 0 : data.roomId)) {
        return data.roomId;
      }
      let closestRoomId = null;
      const setClosestRoomId = (roomIds) => {
        let minDistanceSq = Infinity;
        roomIds.forEach((roomId) => {
          const room = this.global.rooms[roomId];
          const centerX = (room.bounds.min.x + room.bounds.max.x) / 2;
          const centerY = (room.bounds.min.y + room.bounds.max.y) / 2;
          const centerZ = (room.bounds.min.z + room.bounds.max.z) / 2;
          const dx = tagPosition.x - centerX;
          const dy = tagPosition.y - centerY;
          const dz = tagPosition.z - centerZ;
          const distanceSq = dx * dx + dy * dy + dz * dz;
          if (distanceSq < minDistanceSq) {
            minDistanceSq = distanceSq;
            closestRoomId = roomId;
          }
        });
      };
      setClosestRoomId(matchedRoomIds);
      if (!closestRoomId) {
        setClosestRoomId(Object.keys(this.global.rooms));
      }
      return closestRoomId;
    },
    setUngroupedMattertags() {
      if (!this.getUngroupedGroup) {
        this.SED.mattertag_groups.unshift({ label: "ungrouped", color: "", mattertags: [], colorless: true, useCustomColor: false, uneditable: true });
      }
      const groupedMattertagSids = this.SED.mattertag_groups.flatMap((group) => group.mattertags.map((mattertag) => mattertag.sid));
      const ungroupedMattertagSids = [];
      for (const key in this.global.mattertags) {
        if (!groupedMattertagSids.includes(key)) {
          ungroupedMattertagSids.push(key);
        }
      }
      this.SED.mattertags.forEach((mattertag) => {
        if (!groupedMattertagSids.includes(mattertag.sid)) {
          ungroupedMattertagSids.push(mattertag.sid);
        }
      });
      const uniqueUngroupedMattertagSids = [...new Set(ungroupedMattertagSids)];
      uniqueUngroupedMattertagSids.forEach((sid) => {
        this.getUngroupedGroup.mattertags.push({ sid, visible: true });
      });
    },
    setAttachmentsData(_0) {
      return __async(this, arguments, function* (mattertag, options = { autoPlay: false }) {
        if (!mattertag.attachments) {
          return;
        }
        yield Promise.all(mattertag.attachments.map((attachmentId) => __async(this, null, function* () {
          const attachment = this.global.attachments[attachmentId];
          if ([
            this.global.attachmentType.APPLICATION,
            this.global.attachmentType.TEXT,
            this.global.attachmentType.UNKNOWN,
            this.global.attachmentType.ZIP
          ].includes(attachment.type)) {
            mattertag.attachmentDownloadLinks.push({
              fileName: attachment.src.split("?")[0].substring(attachment.src.lastIndexOf("/") + 1),
              url: attachment.src
            });
          } else {
            const getMediaHtmlSource = (attachment2) => __async(this, null, function* () {
              const mediaHtml = yield Utils.getMediaHtml(attachment2.src, attachment2.type, options);
              if (mediaHtml.error) {
                return { src: `<span class='text-danger'>${mediaHtml.error || "エラーが発生しました"}</span>`, type: "error" };
              } else {
                return { src: mediaHtml.html, type: mediaHtml.type };
              }
            });
            switch (attachment.type) {
              case this.global.attachmentType.IMAGE:
                mattertag.carouselItems.push({ src: attachment.src, type: "image" });
                break;
              default:
                mattertag.carouselItems.push(yield getMediaHtmlSource(attachment));
                break;
            }
          }
        })));
        if (mattertag.carouselItems.length && /youtube|vimeo|soundcloud|pdf|unknown/.test(mattertag.carouselItems.slice(-1)[0].type)) {
          mattertag.carouselItems = [...mattertag.carouselItems.slice(-1), ...mattertag.carouselItems.slice(0, -1)];
        }
      });
    },
    getDefaultSweepIconData(sweepSid) {
      return {
        sid: sweepSid,
        icon: {
          color: "#FFFFFFFF",
          id: null,
          url: null
        },
        bgColor: "#CCCCCCFF",
        colorless: true,
        degree: 0
      };
    },
    checkSweepIconChenged(sweepSid) {
      return !_isEqual(this.showcaseEditorData.sweeps.find((sweep) => sweep.sid === sweepSid), this.getDefaultSweepIconData(sweepSid));
    },
    createIcon(apiUrl, sid, option1 = "", option2 = "") {
      return __async(this, null, function* () {
        var _a2;
        const customIconData = (_a2 = this.SED.mattertags.find((data) => data.sid === sid)) == null ? void 0 : _a2.icon;
        const customColor = this.getCustomColor(sid, customIconData);
        const style2 = this.determineTagStyle(sid, customIconData, customColor);
        switch (style2.type) {
          case "groupUrl":
            return yield this.createIconWithUrl(style2.target.url, option1, option2);
          case "groupId":
            return this.createIconWithId(sid, style2.target.id, customColor);
          case "customUrl":
            return yield this.createIconWithUrl(style2.target.url, option1, option2);
          case "customId":
            return this.createIconWithId(sid, style2.target.id, customColor);
          case "groupColor":
          case "fallbackColor":
            return Utils.SVG.createDefaultSvgTag(Utils.toHex(customColor));
          default:
            return Utils.SVG.createDefaultSvgTag(Utils.toHex(this.global.mattertags[sid].color));
        }
      });
    },
    createIconWithId(sid, id, customColor) {
      if (this.isOverride(sid, id.split("-"))) {
        return Utils.SVG.createSvgTag(id, 1.2, Utils.toHex(customColor));
      } else {
        return Utils.SVG.createSvgTag(id, 1.2);
      }
    },
    createIconWithUrl(url, option1 = null, option2 = null) {
      return __async(this, null, function* () {
        var _a2;
        if (url.indexOf("active_storage") !== -1) {
          const res = yield this.getMediaUrl("mattertag_icon_images", url.split(":")[1]);
          if ((_a2 = res == null ? void 0 : res.data) == null ? void 0 : _a2.url) {
            return `<img src='${res.data.url}' ${option1} />`;
          }
        } else {
          return `<img src='${url}' ${option2} />`;
        }
      });
    },
    getMediaUrl(type, id) {
      return __async(this, null, function* () {
        var _a2, _b2;
        try {
          const response = yield axios$1.get(`${Vue$1.prototype.$global.apiUrl}/get_media_url?type=${type}&file_id=${id}`);
          return { data: response.data };
        } catch (err2) {
          console.error("DPM: get media url error", err2);
          return { error: ((_b2 = (_a2 = err2 == null ? void 0 : err2.response) == null ? void 0 : _a2.data) == null ? void 0 : _b2.error) || err2 };
        }
      });
    },
    prepareMattertagsForGroupList(svgOptions) {
      return __async(this, null, function* () {
        const getMattertagsArrayWithIcon = (_0, ..._1) => __async(this, [_0, ..._1], function* (mattertagIds, group = { color: "", colorless: false, label: "ungrouped", index: 0 }) {
          return yield Promise.all(mattertagIds.map((id) => __async(this, null, function* () {
            let mattertag = this.SED.mattertags.find((mattertag2) => mattertag2.sid === id) || {};
            mattertag = _omit(mattertag, ["extension"]);
            if (Vue$1.prototype.$global.mattertags[id]) {
              mattertag = __spreadValues(__spreadValues({}, Vue$1.prototype.$global.mattertags[id]), mattertag);
            }
            return __spreadProps(__spreadValues({}, mattertag), {
              group,
              icon: yield this.createIcon(this.global.apiUrl, id),
              key: `${Math.random().toString(36).substring(2, 9)}`,
              label: this.getLabel(id),
              sid: id
              // FIXME: 公式タグにsidが無いのでここで追加しているが、Matterport的にidのみなったので、いつかidに統一したいがやるならまとめてやった方が良さそうなので一旦保留
            });
          })));
        });
        if (this.SED.mattertag_groups.length) {
          this.current.mattertagGroupList = (yield Promise.all(this.SED.mattertag_groups.map((group, index2) => __async(this, null, function* () {
            return yield getMattertagsArrayWithIcon(group.mattertags.map((mattertag) => mattertag.sid), __spreadProps(__spreadValues({}, _omit(group, ["mattertags"])), { index: index2 }));
          })))).flat();
        } else {
          this.current.mattertagGroupList = yield getMattertagsArrayWithIcon(Object.keys(Vue$1.prototype.$global.mattertags));
        }
      });
    },
    replaceIconId(target2, newValue, index2) {
      const splitedId = target2.split("-");
      splitedId[index2] = newValue;
      return splitedId.join("-");
    }
  }
});
/*!
 * vue-i18n v8.28.2 
 * (c) 2022 kazuya kawaguchi
 * Released under the MIT License.
 */
var numberFormatKeys = [
  "compactDisplay",
  "currency",
  "currencyDisplay",
  "currencySign",
  "localeMatcher",
  "notation",
  "numberingSystem",
  "signDisplay",
  "style",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits"
];
var dateTimeFormatKeys = [
  "dateStyle",
  "timeStyle",
  "calendar",
  "localeMatcher",
  "hour12",
  "hourCycle",
  "timeZone",
  "formatMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName"
];
function warn(msg, err2) {
  if (typeof console !== "undefined") {
    console.warn("[vue-i18n] " + msg);
    if (err2) {
      console.warn(err2.stack);
    }
  }
}
function error(msg, err2) {
  if (typeof console !== "undefined") {
    console.error("[vue-i18n] " + msg);
    if (err2) {
      console.error(err2.stack);
    }
  }
}
var isArray = Array.isArray;
function isObject$1(obj) {
  return obj !== null && typeof obj === "object";
}
function isBoolean(val) {
  return typeof val === "boolean";
}
function isString(val) {
  return typeof val === "string";
}
var toString = Object.prototype.toString;
var OBJECT_STRING = "[object Object]";
function isPlainObject(obj) {
  return toString.call(obj) === OBJECT_STRING;
}
function isNull(val) {
  return val === null || val === void 0;
}
function isFunction(val) {
  return typeof val === "function";
}
function parseArgs() {
  var args = [], len = arguments.length;
  while (len--)
    args[len] = arguments[len];
  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (isObject$1(args[0]) || isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === "string") {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === "string") {
      locale = args[0];
    }
    if (isObject$1(args[1]) || isArray(args[1])) {
      params = args[1];
    }
  }
  return { locale, params };
}
function looseClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}
function remove(arr, item) {
  if (arr.delete(item)) {
    return arr;
  }
}
function arrayFrom(arr) {
  var ret = [];
  arr.forEach(function(a) {
    return ret.push(a);
  });
  return ret;
}
function includes(arr, item) {
  return !!~arr.indexOf(item);
}
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
  return hasOwnProperty$1.call(obj, key);
}
function merge$3(target2) {
  var arguments$1 = arguments;
  var output = Object(target2);
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments$1[i2];
    if (source !== void 0 && source !== null) {
      var key = void 0;
      for (key in source) {
        if (hasOwn(source, key)) {
          if (isObject$1(source[key])) {
            output[key] = merge$3(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output;
}
function looseEqual(a, b) {
  if (a === b) {
    return true;
  }
  var isObjectA = isObject$1(a);
  var isObjectB = isObject$1(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = isArray(a);
      var isArrayB = isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function(e, i2) {
          return looseEqual(e, b[i2]);
        });
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function(key) {
          return looseEqual(a[key], b[key]);
        });
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
}
function escapeHtml(rawText) {
  return rawText.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
function escapeParams(params) {
  if (params != null) {
    Object.keys(params).forEach(function(key) {
      if (typeof params[key] == "string") {
        params[key] = escapeHtml(params[key]);
      }
    });
  }
  return params;
}
function extend$2(Vue2) {
  if (!Vue2.prototype.hasOwnProperty("$i18n")) {
    Object.defineProperty(Vue2.prototype, "$i18n", {
      get: function get5() {
        return this._i18n;
      }
    });
  }
  Vue2.prototype.$t = function(key) {
    var values2 = [], len = arguments.length - 1;
    while (len-- > 0)
      values2[len] = arguments[len + 1];
    var i18n = this.$i18n;
    return i18n._t.apply(i18n, [key, i18n.locale, i18n._getMessages(), this].concat(values2));
  };
  Vue2.prototype.$tc = function(key, choice) {
    var values2 = [], len = arguments.length - 2;
    while (len-- > 0)
      values2[len] = arguments[len + 2];
    var i18n = this.$i18n;
    return i18n._tc.apply(i18n, [key, i18n.locale, i18n._getMessages(), this, choice].concat(values2));
  };
  Vue2.prototype.$te = function(key, locale) {
    var i18n = this.$i18n;
    return i18n._te(key, i18n.locale, i18n._getMessages(), locale);
  };
  Vue2.prototype.$d = function(value) {
    var ref2;
    var args = [], len = arguments.length - 1;
    while (len-- > 0)
      args[len] = arguments[len + 1];
    return (ref2 = this.$i18n).d.apply(ref2, [value].concat(args));
  };
  Vue2.prototype.$n = function(value) {
    var ref2;
    var args = [], len = arguments.length - 1;
    while (len-- > 0)
      args[len] = arguments[len + 1];
    return (ref2 = this.$i18n).n.apply(ref2, [value].concat(args));
  };
}
function defineMixin(bridge) {
  if (bridge === void 0)
    bridge = false;
  function mounted3() {
    if (this !== this.$root && this.$options.__INTLIFY_META__ && this.$el) {
      this.$el.setAttribute("data-intlify", this.$options.__INTLIFY_META__);
    }
  }
  return bridge ? { mounted: mounted3 } : {
    // regulary 
    beforeCreate: function beforeCreate() {
      var options = this.$options;
      options.i18n = options.i18n || (options.__i18nBridge || options.__i18n ? {} : null);
      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          if (options.__i18nBridge || options.__i18n) {
            try {
              var localeMessages = options.i18n && options.i18n.messages ? options.i18n.messages : {};
              var _i18n = options.__i18nBridge || options.__i18n;
              _i18n.forEach(function(resource) {
                localeMessages = merge$3(localeMessages, JSON.parse(resource));
              });
              Object.keys(localeMessages).forEach(function(locale) {
                options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
              });
            } catch (e) {
            }
          }
          this._i18n = options.i18n;
          this._i18nWatcher = this._i18n.watchI18nData();
        } else if (isPlainObject(options.i18n)) {
          var rootI18n = this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n ? this.$root.$i18n : null;
          if (rootI18n) {
            options.i18n.root = this.$root;
            options.i18n.formatter = rootI18n.formatter;
            options.i18n.fallbackLocale = rootI18n.fallbackLocale;
            options.i18n.formatFallbackMessages = rootI18n.formatFallbackMessages;
            options.i18n.silentTranslationWarn = rootI18n.silentTranslationWarn;
            options.i18n.silentFallbackWarn = rootI18n.silentFallbackWarn;
            options.i18n.pluralizationRules = rootI18n.pluralizationRules;
            options.i18n.preserveDirectiveContent = rootI18n.preserveDirectiveContent;
          }
          if (options.__i18nBridge || options.__i18n) {
            try {
              var localeMessages$1 = options.i18n && options.i18n.messages ? options.i18n.messages : {};
              var _i18n$1 = options.__i18nBridge || options.__i18n;
              _i18n$1.forEach(function(resource) {
                localeMessages$1 = merge$3(localeMessages$1, JSON.parse(resource));
              });
              options.i18n.messages = localeMessages$1;
            } catch (e) {
            }
          }
          var ref2 = options.i18n;
          var sharedMessages = ref2.sharedMessages;
          if (sharedMessages && isPlainObject(sharedMessages)) {
            options.i18n.messages = merge$3(options.i18n.messages, sharedMessages);
          }
          this._i18n = new VueI18n(options.i18n);
          this._i18nWatcher = this._i18n.watchI18nData();
          if (options.i18n.sync === void 0 || !!options.i18n.sync) {
            this._localeWatcher = this.$i18n.watchLocale();
          }
          if (rootI18n) {
            rootI18n.onComponentInstanceCreated(this._i18n);
          }
        } else
          ;
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        this._i18n = this.$root.$i18n;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        this._i18n = options.parent.$i18n;
      }
    },
    beforeMount: function beforeMount2() {
      var options = this.$options;
      options.i18n = options.i18n || (options.__i18nBridge || options.__i18n ? {} : null);
      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else if (isPlainObject(options.i18n)) {
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else
          ;
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      }
    },
    mounted: mounted3,
    beforeDestroy: function beforeDestroy2() {
      if (!this._i18n) {
        return;
      }
      var self2 = this;
      this.$nextTick(function() {
        if (self2._subscribing) {
          self2._i18n.unsubscribeDataChanging(self2);
          delete self2._subscribing;
        }
        if (self2._i18nWatcher) {
          self2._i18nWatcher();
          self2._i18n.destroyVM();
          delete self2._i18nWatcher;
        }
        if (self2._localeWatcher) {
          self2._localeWatcher();
          delete self2._localeWatcher;
        }
      });
    }
  };
}
var interpolationComponent = {
  name: "i18n",
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: "span"
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render4(h, ref2) {
    var data = ref2.data;
    var parent2 = ref2.parent;
    var props2 = ref2.props;
    var slots = ref2.slots;
    var $i18n = parent2.$i18n;
    if (!$i18n) {
      return;
    }
    var path = props2.path;
    var locale = props2.locale;
    var places = props2.places;
    var params = slots();
    var children = $i18n.i(
      path,
      locale,
      onlyHasDefaultPlace(params) || places ? useLegacyPlaces(params.default, places) : params
    );
    var tag = !!props2.tag && props2.tag !== true || props2.tag === false ? props2.tag : "span";
    return tag ? h(tag, data, children) : children;
  }
};
function onlyHasDefaultPlace(params) {
  var prop;
  for (prop in params) {
    if (prop !== "default") {
      return false;
    }
  }
  return Boolean(prop);
}
function useLegacyPlaces(children, places) {
  var params = places ? createParamsFromPlaces(places) : {};
  if (!children) {
    return params;
  }
  children = children.filter(function(child) {
    return child.tag || child.text.trim() !== "";
  });
  var everyPlace = children.every(vnodeHasPlaceAttribute);
  return children.reduce(
    everyPlace ? assignChildPlace : assignChildIndex,
    params
  );
}
function createParamsFromPlaces(places) {
  return Array.isArray(places) ? places.reduce(assignChildIndex, {}) : Object.assign({}, places);
}
function assignChildPlace(params, child) {
  if (child.data && child.data.attrs && child.data.attrs.place) {
    params[child.data.attrs.place] = child;
  }
  return params;
}
function assignChildIndex(params, child, index2) {
  params[index2] = child;
  return params;
}
function vnodeHasPlaceAttribute(vnode) {
  return Boolean(vnode.data && vnode.data.attrs && vnode.data.attrs.place);
}
var numberComponent = {
  name: "i18n-n",
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: "span"
    },
    value: {
      type: Number,
      required: true
    },
    format: {
      type: [String, Object]
    },
    locale: {
      type: String
    }
  },
  render: function render5(h, ref2) {
    var props2 = ref2.props;
    var parent2 = ref2.parent;
    var data = ref2.data;
    var i18n = parent2.$i18n;
    if (!i18n) {
      return null;
    }
    var key = null;
    var options = null;
    if (isString(props2.format)) {
      key = props2.format;
    } else if (isObject$1(props2.format)) {
      if (props2.format.key) {
        key = props2.format.key;
      }
      options = Object.keys(props2.format).reduce(function(acc, prop) {
        var obj;
        if (includes(numberFormatKeys, prop)) {
          return Object.assign({}, acc, (obj = {}, obj[prop] = props2.format[prop], obj));
        }
        return acc;
      }, null);
    }
    var locale = props2.locale || i18n.locale;
    var parts = i18n._ntp(props2.value, locale, key, options);
    var values2 = parts.map(function(part, index2) {
      var obj;
      var slot = data.scopedSlots && data.scopedSlots[part.type];
      return slot ? slot((obj = {}, obj[part.type] = part.value, obj.index = index2, obj.parts = parts, obj)) : part.value;
    });
    var tag = !!props2.tag && props2.tag !== true || props2.tag === false ? props2.tag : "span";
    return tag ? h(tag, {
      attrs: data.attrs,
      "class": data["class"],
      staticClass: data.staticClass
    }, values2) : values2;
  }
};
function bind$1(el, binding, vnode) {
  if (!assert(el, vnode)) {
    return;
  }
  t(el, binding, vnode);
}
function update$1(el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) {
    return;
  }
  var i18n = vnode.context.$i18n;
  if (localeEqual(el, vnode) && (looseEqual(binding.value, binding.oldValue) && looseEqual(el._localeMessage, i18n.getLocaleMessage(i18n.locale)))) {
    return;
  }
  t(el, binding, vnode);
}
function unbind$1(el, binding, vnode, oldVNode) {
  var vm = vnode.context;
  if (!vm) {
    warn("Vue instance does not exists in VNode context");
    return;
  }
  var i18n = vnode.context.$i18n || {};
  if (!binding.modifiers.preserve && !i18n.preserveDirectiveContent) {
    el.textContent = "";
  }
  el._vt = void 0;
  delete el["_vt"];
  el._locale = void 0;
  delete el["_locale"];
  el._localeMessage = void 0;
  delete el["_localeMessage"];
}
function assert(el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    warn("Vue instance does not exists in VNode context");
    return false;
  }
  if (!vm.$i18n) {
    warn("VueI18n instance does not exists in Vue instance");
    return false;
  }
  return true;
}
function localeEqual(el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale;
}
function t(el, binding, vnode) {
  var ref$12, ref$2;
  var value = binding.value;
  var ref2 = parseValue(value);
  var path = ref2.path;
  var locale = ref2.locale;
  var args = ref2.args;
  var choice = ref2.choice;
  if (!path && !locale && !args) {
    warn("value type not supported");
    return;
  }
  if (!path) {
    warn("`path` is required in v-t directive");
    return;
  }
  var vm = vnode.context;
  if (choice != null) {
    el._vt = el.textContent = (ref$12 = vm.$i18n).tc.apply(ref$12, [path, choice].concat(makeParams(locale, args)));
  } else {
    el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [path].concat(makeParams(locale, args)));
  }
  el._locale = vm.$i18n.locale;
  el._localeMessage = vm.$i18n.getLocaleMessage(vm.$i18n.locale);
}
function parseValue(value) {
  var path;
  var locale;
  var args;
  var choice;
  if (isString(value)) {
    path = value;
  } else if (isPlainObject(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
    choice = value.choice;
  }
  return { path, locale, args, choice };
}
function makeParams(locale, args) {
  var params = [];
  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject(args))) {
    params.push(args);
  }
  return params;
}
var Vue;
function install$3(_Vue, options) {
  if (options === void 0)
    options = { bridge: false };
  install$3.installed = true;
  Vue = _Vue;
  Vue.version && Number(Vue.version.split(".")[0]) || -1;
  extend$2(Vue);
  Vue.mixin(defineMixin(options.bridge));
  Vue.directive("t", { bind: bind$1, update: update$1, unbind: unbind$1 });
  Vue.component(interpolationComponent.name, interpolationComponent);
  Vue.component(numberComponent.name, numberComponent);
  var strats2 = Vue.config.optionMergeStrategies;
  strats2.i18n = function(parentVal, childVal) {
    return childVal === void 0 ? parentVal : childVal;
  };
}
var BaseFormatter = function BaseFormatter2() {
  this._caches = /* @__PURE__ */ Object.create(null);
};
BaseFormatter.prototype.interpolate = function interpolate(message, values2) {
  if (!values2) {
    return [message];
  }
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values2);
};
var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;
function parse(format) {
  var tokens = [];
  var position = 0;
  var text2 = "";
  while (position < format.length) {
    var char = format[position++];
    if (char === "{") {
      if (text2) {
        tokens.push({ type: "text", value: text2 });
      }
      text2 = "";
      var sub = "";
      char = format[position++];
      while (char !== void 0 && char !== "}") {
        sub += char;
        char = format[position++];
      }
      var isClosed = char === "}";
      var type = RE_TOKEN_LIST_VALUE.test(sub) ? "list" : isClosed && RE_TOKEN_NAMED_VALUE.test(sub) ? "named" : "unknown";
      tokens.push({ value: sub, type });
    } else if (char === "%") {
      if (format[position] !== "{") {
        text2 += char;
      }
    } else {
      text2 += char;
    }
  }
  text2 && tokens.push({ type: "text", value: text2 });
  return tokens;
}
function compile(tokens, values2) {
  var compiled = [];
  var index2 = 0;
  var mode = Array.isArray(values2) ? "list" : isObject$1(values2) ? "named" : "unknown";
  if (mode === "unknown") {
    return compiled;
  }
  while (index2 < tokens.length) {
    var token = tokens[index2];
    switch (token.type) {
      case "text":
        compiled.push(token.value);
        break;
      case "list":
        compiled.push(values2[parseInt(token.value, 10)]);
        break;
      case "named":
        if (mode === "named") {
          compiled.push(values2[token.value]);
        }
        break;
    }
    index2++;
  }
  return compiled;
}
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;
var pathStateMachine = [];
pathStateMachine[BEFORE_PATH] = {
  "ws": [BEFORE_PATH],
  "ident": [IN_IDENT, APPEND],
  "[": [IN_SUB_PATH],
  "eof": [AFTER_PATH]
};
pathStateMachine[IN_PATH] = {
  "ws": [IN_PATH],
  ".": [BEFORE_IDENT],
  "[": [IN_SUB_PATH],
  "eof": [AFTER_PATH]
};
pathStateMachine[BEFORE_IDENT] = {
  "ws": [BEFORE_IDENT],
  "ident": [IN_IDENT, APPEND],
  "0": [IN_IDENT, APPEND],
  "number": [IN_IDENT, APPEND]
};
pathStateMachine[IN_IDENT] = {
  "ident": [IN_IDENT, APPEND],
  "0": [IN_IDENT, APPEND],
  "number": [IN_IDENT, APPEND],
  "ws": [IN_PATH, PUSH],
  ".": [BEFORE_IDENT, PUSH],
  "[": [IN_SUB_PATH, PUSH],
  "eof": [AFTER_PATH, PUSH]
};
pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  "[": [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  "]": [IN_PATH, PUSH_SUB_PATH],
  "eof": ERROR,
  "else": [IN_SUB_PATH, APPEND]
};
pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  "eof": ERROR,
  "else": [IN_SINGLE_QUOTE, APPEND]
};
pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  "eof": ERROR,
  "else": [IN_DOUBLE_QUOTE, APPEND]
};
var literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral(exp) {
  return literalValueRE.test(exp);
}
function stripQuotes(str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 34 || a === 39) ? str.slice(1, -1) : str;
}
function getPathCharType(ch) {
  if (ch === void 0 || ch === null) {
    return "eof";
  }
  var code = ch.charCodeAt(0);
  switch (code) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return ch;
    case 95:
    case 36:
    case 45:
      return "ident";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "ws";
  }
  return "ident";
}
function formatSubPath(path) {
  var trimmed = path.trim();
  if (path.charAt(0) === "0" && isNaN(path)) {
    return false;
  }
  return isLiteral(trimmed) ? stripQuotes(trimmed) : "*" + trimmed;
}
function parse$1(path) {
  var keys2 = [];
  var index2 = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition2;
  var action;
  var typeMap;
  var actions = [];
  actions[PUSH] = function() {
    if (key !== void 0) {
      keys2.push(key);
      key = void 0;
    }
  };
  actions[APPEND] = function() {
    if (key === void 0) {
      key = newChar;
    } else {
      key += newChar;
    }
  };
  actions[INC_SUB_PATH_DEPTH] = function() {
    actions[APPEND]();
    subPathDepth++;
  };
  actions[PUSH_SUB_PATH] = function() {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      if (key === void 0) {
        return false;
      }
      key = formatSubPath(key);
      if (key === false) {
        return false;
      } else {
        actions[PUSH]();
      }
    }
  };
  function maybeUnescapeQuote() {
    var nextChar = path[index2 + 1];
    if (mode === IN_SINGLE_QUOTE && nextChar === "'" || mode === IN_DOUBLE_QUOTE && nextChar === '"') {
      index2++;
      newChar = "\\" + nextChar;
      actions[APPEND]();
      return true;
    }
  }
  while (mode !== null) {
    index2++;
    c = path[index2];
    if (c === "\\" && maybeUnescapeQuote()) {
      continue;
    }
    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition2 = typeMap[type] || typeMap["else"] || ERROR;
    if (transition2 === ERROR) {
      return;
    }
    mode = transition2[0];
    action = actions[transition2[1]];
    if (action) {
      newChar = transition2[2];
      newChar = newChar === void 0 ? c : newChar;
      if (action() === false) {
        return;
      }
    }
    if (mode === AFTER_PATH) {
      return keys2;
    }
  }
}
var I18nPath = function I18nPath2() {
  this._cache = /* @__PURE__ */ Object.create(null);
};
I18nPath.prototype.parsePath = function parsePath2(path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || [];
};
I18nPath.prototype.getPathValue = function getPathValue(obj, path) {
  if (!isObject$1(obj)) {
    return null;
  }
  var paths = this.parsePath(path);
  if (paths.length === 0) {
    return null;
  } else {
    var length = paths.length;
    var last2 = obj;
    var i2 = 0;
    while (i2 < length) {
      var value = last2[paths[i2]];
      if (value === void 0 || value === null) {
        return null;
      }
      last2 = value;
      i2++;
    }
    return last2;
  }
};
var htmlTagMatcher = /<\/?[\w\s="/.':;#-\/]+>/;
var linkKeyMatcher = /(?:@(?:\.[a-zA-Z]+)?:(?:[\w\-_|./]+|\([\w\-_:|./]+\)))/g;
var linkKeyPrefixMatcher = /^@(?:\.([a-zA-Z]+))?:/;
var bracketsMatcher = /[()]/g;
var defaultModifiers = {
  "upper": function(str) {
    return str.toLocaleUpperCase();
  },
  "lower": function(str) {
    return str.toLocaleLowerCase();
  },
  "capitalize": function(str) {
    return "" + str.charAt(0).toLocaleUpperCase() + str.substr(1);
  }
};
var defaultFormatter = new BaseFormatter();
var VueI18n = function VueI18n2(options) {
  var this$1$1 = this;
  if (options === void 0)
    options = {};
  if (!Vue && typeof window !== "undefined" && window.Vue) {
    install$3(window.Vue);
  }
  var locale = options.locale || "en-US";
  var fallbackLocale = options.fallbackLocale === false ? false : options.fallbackLocale || "en-US";
  var messages2 = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || options.datetimeFormats || {};
  var numberFormats = options.numberFormats || {};
  this._vm = null;
  this._formatter = options.formatter || defaultFormatter;
  this._modifiers = options.modifiers || {};
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === void 0 ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === void 0 ? true : !!options.fallbackRoot;
  this._fallbackRootWithEmptyString = options.fallbackRootWithEmptyString === void 0 ? true : !!options.fallbackRootWithEmptyString;
  this._formatFallbackMessages = options.formatFallbackMessages === void 0 ? false : !!options.formatFallbackMessages;
  this._silentTranslationWarn = options.silentTranslationWarn === void 0 ? false : options.silentTranslationWarn;
  this._silentFallbackWarn = options.silentFallbackWarn === void 0 ? false : !!options.silentFallbackWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = /* @__PURE__ */ new Set();
  this._componentInstanceCreatedListener = options.componentInstanceCreatedListener || null;
  this._preserveDirectiveContent = options.preserveDirectiveContent === void 0 ? false : !!options.preserveDirectiveContent;
  this.pluralizationRules = options.pluralizationRules || {};
  this._warnHtmlInMessage = options.warnHtmlInMessage || "off";
  this._postTranslation = options.postTranslation || null;
  this._escapeParameterHtml = options.escapeParameterHtml || false;
  if ("__VUE_I18N_BRIDGE__" in options) {
    this.__VUE_I18N_BRIDGE__ = options.__VUE_I18N_BRIDGE__;
  }
  this.getChoiceIndex = function(choice, choicesLength) {
    var thisPrototype = Object.getPrototypeOf(this$1$1);
    if (thisPrototype && thisPrototype.getChoiceIndex) {
      var prototypeGetChoiceIndex = thisPrototype.getChoiceIndex;
      return prototypeGetChoiceIndex.call(this$1$1, choice, choicesLength);
    }
    var defaultImpl = function(_choice, _choicesLength) {
      _choice = Math.abs(_choice);
      if (_choicesLength === 2) {
        return _choice ? _choice > 1 ? 1 : 0 : 1;
      }
      return _choice ? Math.min(_choice, 2) : 0;
    };
    if (this$1$1.locale in this$1$1.pluralizationRules) {
      return this$1$1.pluralizationRules[this$1$1.locale].apply(this$1$1, [choice, choicesLength]);
    } else {
      return defaultImpl(choice, choicesLength);
    }
  };
  this._exist = function(message, key) {
    if (!message || !key) {
      return false;
    }
    if (!isNull(this$1$1._path.getPathValue(message, key))) {
      return true;
    }
    if (message[key]) {
      return true;
    }
    return false;
  };
  if (this._warnHtmlInMessage === "warn" || this._warnHtmlInMessage === "error") {
    Object.keys(messages2).forEach(function(locale2) {
      this$1$1._checkLocaleMessage(locale2, this$1$1._warnHtmlInMessage, messages2[locale2]);
    });
  }
  this._initVM({
    locale,
    fallbackLocale,
    messages: messages2,
    dateTimeFormats,
    numberFormats
  });
};
var prototypeAccessors = { vm: { configurable: true }, messages: { configurable: true }, dateTimeFormats: { configurable: true }, numberFormats: { configurable: true }, availableLocales: { configurable: true }, locale: { configurable: true }, fallbackLocale: { configurable: true }, formatFallbackMessages: { configurable: true }, missing: { configurable: true }, formatter: { configurable: true }, silentTranslationWarn: { configurable: true }, silentFallbackWarn: { configurable: true }, preserveDirectiveContent: { configurable: true }, warnHtmlInMessage: { configurable: true }, postTranslation: { configurable: true }, sync: { configurable: true } };
VueI18n.prototype._checkLocaleMessage = function _checkLocaleMessage(locale, level, message) {
  var paths = [];
  var fn = function(level2, locale2, message2, paths2) {
    if (isPlainObject(message2)) {
      Object.keys(message2).forEach(function(key) {
        var val = message2[key];
        if (isPlainObject(val)) {
          paths2.push(key);
          paths2.push(".");
          fn(level2, locale2, val, paths2);
          paths2.pop();
          paths2.pop();
        } else {
          paths2.push(key);
          fn(level2, locale2, val, paths2);
          paths2.pop();
        }
      });
    } else if (isArray(message2)) {
      message2.forEach(function(item, index2) {
        if (isPlainObject(item)) {
          paths2.push("[" + index2 + "]");
          paths2.push(".");
          fn(level2, locale2, item, paths2);
          paths2.pop();
          paths2.pop();
        } else {
          paths2.push("[" + index2 + "]");
          fn(level2, locale2, item, paths2);
          paths2.pop();
        }
      });
    } else if (isString(message2)) {
      var ret = htmlTagMatcher.test(message2);
      if (ret) {
        var msg = "Detected HTML in message '" + message2 + "' of keypath '" + paths2.join("") + "' at '" + locale2 + "'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";
        if (level2 === "warn") {
          warn(msg);
        } else if (level2 === "error") {
          error(msg);
        }
      }
    }
  };
  fn(level, locale, message, paths);
};
VueI18n.prototype._initVM = function _initVM(data) {
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  this._vm = new Vue({ data, __VUE18N__INSTANCE__: true });
  Vue.config.silent = silent;
};
VueI18n.prototype.destroyVM = function destroyVM() {
  this._vm.$destroy();
};
VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging(vm) {
  this._dataListeners.add(vm);
};
VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging(vm) {
  remove(this._dataListeners, vm);
};
VueI18n.prototype.watchI18nData = function watchI18nData() {
  var this$1$1 = this;
  return this._vm.$watch("$data", function() {
    var listeners = arrayFrom(this$1$1._dataListeners);
    var i2 = listeners.length;
    while (i2--) {
      Vue.nextTick(function() {
        listeners[i2] && listeners[i2].$forceUpdate();
      });
    }
  }, { deep: true });
};
VueI18n.prototype.watchLocale = function watchLocale(composer) {
  if (!composer) {
    if (!this._sync || !this._root) {
      return null;
    }
    var target2 = this._vm;
    return this._root.$i18n.vm.$watch("locale", function(val) {
      target2.$set(target2, "locale", val);
      target2.$forceUpdate();
    }, { immediate: true });
  } else {
    if (!this.__VUE_I18N_BRIDGE__) {
      return null;
    }
    var self2 = this;
    var target$12 = this._vm;
    return this.vm.$watch("locale", function(val) {
      target$12.$set(target$12, "locale", val);
      if (self2.__VUE_I18N_BRIDGE__ && composer) {
        composer.locale.value = val;
      }
      target$12.$forceUpdate();
    }, { immediate: true });
  }
};
VueI18n.prototype.onComponentInstanceCreated = function onComponentInstanceCreated(newI18n) {
  if (this._componentInstanceCreatedListener) {
    this._componentInstanceCreatedListener(newI18n, this);
  }
};
prototypeAccessors.vm.get = function() {
  return this._vm;
};
prototypeAccessors.messages.get = function() {
  return looseClone(this._getMessages());
};
prototypeAccessors.dateTimeFormats.get = function() {
  return looseClone(this._getDateTimeFormats());
};
prototypeAccessors.numberFormats.get = function() {
  return looseClone(this._getNumberFormats());
};
prototypeAccessors.availableLocales.get = function() {
  return Object.keys(this.messages).sort();
};
prototypeAccessors.locale.get = function() {
  return this._vm.locale;
};
prototypeAccessors.locale.set = function(locale) {
  this._vm.$set(this._vm, "locale", locale);
};
prototypeAccessors.fallbackLocale.get = function() {
  return this._vm.fallbackLocale;
};
prototypeAccessors.fallbackLocale.set = function(locale) {
  this._localeChainCache = {};
  this._vm.$set(this._vm, "fallbackLocale", locale);
};
prototypeAccessors.formatFallbackMessages.get = function() {
  return this._formatFallbackMessages;
};
prototypeAccessors.formatFallbackMessages.set = function(fallback) {
  this._formatFallbackMessages = fallback;
};
prototypeAccessors.missing.get = function() {
  return this._missing;
};
prototypeAccessors.missing.set = function(handler) {
  this._missing = handler;
};
prototypeAccessors.formatter.get = function() {
  return this._formatter;
};
prototypeAccessors.formatter.set = function(formatter) {
  this._formatter = formatter;
};
prototypeAccessors.silentTranslationWarn.get = function() {
  return this._silentTranslationWarn;
};
prototypeAccessors.silentTranslationWarn.set = function(silent) {
  this._silentTranslationWarn = silent;
};
prototypeAccessors.silentFallbackWarn.get = function() {
  return this._silentFallbackWarn;
};
prototypeAccessors.silentFallbackWarn.set = function(silent) {
  this._silentFallbackWarn = silent;
};
prototypeAccessors.preserveDirectiveContent.get = function() {
  return this._preserveDirectiveContent;
};
prototypeAccessors.preserveDirectiveContent.set = function(preserve) {
  this._preserveDirectiveContent = preserve;
};
prototypeAccessors.warnHtmlInMessage.get = function() {
  return this._warnHtmlInMessage;
};
prototypeAccessors.warnHtmlInMessage.set = function(level) {
  var this$1$1 = this;
  var orgLevel = this._warnHtmlInMessage;
  this._warnHtmlInMessage = level;
  if (orgLevel !== level && (level === "warn" || level === "error")) {
    var messages2 = this._getMessages();
    Object.keys(messages2).forEach(function(locale) {
      this$1$1._checkLocaleMessage(locale, this$1$1._warnHtmlInMessage, messages2[locale]);
    });
  }
};
prototypeAccessors.postTranslation.get = function() {
  return this._postTranslation;
};
prototypeAccessors.postTranslation.set = function(handler) {
  this._postTranslation = handler;
};
prototypeAccessors.sync.get = function() {
  return this._sync;
};
prototypeAccessors.sync.set = function(val) {
  this._sync = val;
};
VueI18n.prototype._getMessages = function _getMessages() {
  return this._vm.messages;
};
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats() {
  return this._vm.dateTimeFormats;
};
VueI18n.prototype._getNumberFormats = function _getNumberFormats() {
  return this._vm.numberFormats;
};
VueI18n.prototype._warnDefault = function _warnDefault(locale, key, result2, vm, values2, interpolateMode) {
  if (!isNull(result2)) {
    return result2;
  }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values2]);
    if (isString(missingRet)) {
      return missingRet;
    }
  }
  if (this._formatFallbackMessages) {
    var parsedArgs = parseArgs.apply(void 0, values2);
    return this._render(key, interpolateMode, parsedArgs.params, key);
  } else {
    return key;
  }
};
VueI18n.prototype._isFallbackRoot = function _isFallbackRoot(val) {
  return (this._fallbackRootWithEmptyString ? !val : isNull(val)) && !isNull(this._root) && this._fallbackRoot;
};
VueI18n.prototype._isSilentFallbackWarn = function _isSilentFallbackWarn(key) {
  return this._silentFallbackWarn instanceof RegExp ? this._silentFallbackWarn.test(key) : this._silentFallbackWarn;
};
VueI18n.prototype._isSilentFallback = function _isSilentFallback(locale, key) {
  return this._isSilentFallbackWarn(key) && (this._isFallbackRoot() || locale !== this.fallbackLocale);
};
VueI18n.prototype._isSilentTranslationWarn = function _isSilentTranslationWarn(key) {
  return this._silentTranslationWarn instanceof RegExp ? this._silentTranslationWarn.test(key) : this._silentTranslationWarn;
};
VueI18n.prototype._interpolate = function _interpolate(locale, message, key, host, interpolateMode, values2, visitedLinkStack) {
  if (!message) {
    return null;
  }
  var pathRet = this._path.getPathValue(message, key);
  if (isArray(pathRet) || isPlainObject(pathRet)) {
    return pathRet;
  }
  var ret;
  if (isNull(pathRet)) {
    if (isPlainObject(message)) {
      ret = message[key];
      if (!(isString(ret) || isFunction(ret))) {
        return null;
      }
    } else {
      return null;
    }
  } else {
    if (isString(pathRet) || isFunction(pathRet)) {
      ret = pathRet;
    } else {
      return null;
    }
  }
  if (isString(ret) && (ret.indexOf("@:") >= 0 || ret.indexOf("@.") >= 0)) {
    ret = this._link(locale, message, ret, host, "raw", values2, visitedLinkStack);
  }
  return this._render(ret, interpolateMode, values2, key);
};
VueI18n.prototype._link = function _link(locale, message, str, host, interpolateMode, values2, visitedLinkStack) {
  var ret = str;
  var matches2 = ret.match(linkKeyMatcher);
  for (var idx in matches2) {
    if (!matches2.hasOwnProperty(idx)) {
      continue;
    }
    var link2 = matches2[idx];
    var linkKeyPrefixMatches = link2.match(linkKeyPrefixMatcher);
    var linkPrefix = linkKeyPrefixMatches[0];
    var formatterName = linkKeyPrefixMatches[1];
    var linkPlaceholder = link2.replace(linkPrefix, "").replace(bracketsMatcher, "");
    if (includes(visitedLinkStack, linkPlaceholder)) {
      return ret;
    }
    visitedLinkStack.push(linkPlaceholder);
    var translated = this._interpolate(
      locale,
      message,
      linkPlaceholder,
      host,
      interpolateMode === "raw" ? "string" : interpolateMode,
      interpolateMode === "raw" ? void 0 : values2,
      visitedLinkStack
    );
    if (this._isFallbackRoot(translated)) {
      if (!this._root) {
        throw Error("unexpected error");
      }
      var root2 = this._root.$i18n;
      translated = root2._translate(
        root2._getMessages(),
        root2.locale,
        root2.fallbackLocale,
        linkPlaceholder,
        host,
        interpolateMode,
        values2
      );
    }
    translated = this._warnDefault(
      locale,
      linkPlaceholder,
      translated,
      host,
      isArray(values2) ? values2 : [values2],
      interpolateMode
    );
    if (this._modifiers.hasOwnProperty(formatterName)) {
      translated = this._modifiers[formatterName](translated);
    } else if (defaultModifiers.hasOwnProperty(formatterName)) {
      translated = defaultModifiers[formatterName](translated);
    }
    visitedLinkStack.pop();
    ret = !translated ? ret : ret.replace(link2, translated);
  }
  return ret;
};
VueI18n.prototype._createMessageContext = function _createMessageContext(values2, formatter, path, interpolateMode) {
  var this$1$1 = this;
  var _list = isArray(values2) ? values2 : [];
  var _named = isObject$1(values2) ? values2 : {};
  var list2 = function(index2) {
    return _list[index2];
  };
  var named = function(key) {
    return _named[key];
  };
  var messages2 = this._getMessages();
  var locale = this.locale;
  return {
    list: list2,
    named,
    values: values2,
    formatter,
    path,
    messages: messages2,
    locale,
    linked: function(linkedKey) {
      return this$1$1._interpolate(locale, messages2[locale] || {}, linkedKey, null, interpolateMode, void 0, [linkedKey]);
    }
  };
};
VueI18n.prototype._render = function _render(message, interpolateMode, values2, path) {
  if (isFunction(message)) {
    return message(
      this._createMessageContext(values2, this._formatter || defaultFormatter, path, interpolateMode)
    );
  }
  var ret = this._formatter.interpolate(message, values2, path);
  if (!ret) {
    ret = defaultFormatter.interpolate(message, values2, path);
  }
  return interpolateMode === "string" && !isString(ret) ? ret.join("") : ret;
};
VueI18n.prototype._appendItemToChain = function _appendItemToChain(chain, item, blocks) {
  var follow = false;
  if (!includes(chain, item)) {
    follow = true;
    if (item) {
      follow = item[item.length - 1] !== "!";
      item = item.replace(/!/g, "");
      chain.push(item);
      if (blocks && blocks[item]) {
        follow = blocks[item];
      }
    }
  }
  return follow;
};
VueI18n.prototype._appendLocaleToChain = function _appendLocaleToChain(chain, locale, blocks) {
  var follow;
  var tokens = locale.split("-");
  do {
    var item = tokens.join("-");
    follow = this._appendItemToChain(chain, item, blocks);
    tokens.splice(-1, 1);
  } while (tokens.length && follow === true);
  return follow;
};
VueI18n.prototype._appendBlockToChain = function _appendBlockToChain(chain, block2, blocks) {
  var follow = true;
  for (var i2 = 0; i2 < block2.length && isBoolean(follow); i2++) {
    var locale = block2[i2];
    if (isString(locale)) {
      follow = this._appendLocaleToChain(chain, locale, blocks);
    }
  }
  return follow;
};
VueI18n.prototype._getLocaleChain = function _getLocaleChain(start, fallbackLocale) {
  if (start === "") {
    return [];
  }
  if (!this._localeChainCache) {
    this._localeChainCache = {};
  }
  var chain = this._localeChainCache[start];
  if (!chain) {
    if (!fallbackLocale) {
      fallbackLocale = this.fallbackLocale;
    }
    chain = [];
    var block2 = [start];
    while (isArray(block2)) {
      block2 = this._appendBlockToChain(
        chain,
        block2,
        fallbackLocale
      );
    }
    var defaults2;
    if (isArray(fallbackLocale)) {
      defaults2 = fallbackLocale;
    } else if (isObject$1(fallbackLocale)) {
      if (fallbackLocale["default"]) {
        defaults2 = fallbackLocale["default"];
      } else {
        defaults2 = null;
      }
    } else {
      defaults2 = fallbackLocale;
    }
    if (isString(defaults2)) {
      block2 = [defaults2];
    } else {
      block2 = defaults2;
    }
    if (block2) {
      this._appendBlockToChain(
        chain,
        block2,
        null
      );
    }
    this._localeChainCache[start] = chain;
  }
  return chain;
};
VueI18n.prototype._translate = function _translate(messages2, locale, fallback, key, host, interpolateMode, args) {
  var chain = this._getLocaleChain(locale, fallback);
  var res;
  for (var i2 = 0; i2 < chain.length; i2++) {
    var step = chain[i2];
    res = this._interpolate(step, messages2[step], key, host, interpolateMode, args, [key]);
    if (!isNull(res)) {
      if (step !== locale && false) {
        warn("Fall back to translate the keypath '" + key + "' with '" + step + "' locale.");
      }
      return res;
    }
  }
  return null;
};
VueI18n.prototype._t = function _t(key, _locale, messages2, host) {
  var ref2;
  var values2 = [], len = arguments.length - 4;
  while (len-- > 0)
    values2[len] = arguments[len + 4];
  if (!key) {
    return "";
  }
  var parsedArgs = parseArgs.apply(void 0, values2);
  if (this._escapeParameterHtml) {
    parsedArgs.params = escapeParams(parsedArgs.params);
  }
  var locale = parsedArgs.locale || _locale;
  var ret = this._translate(
    messages2,
    locale,
    this.fallbackLocale,
    key,
    host,
    "string",
    parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    if (!this._root) {
      throw Error("unexpected error");
    }
    return (ref2 = this._root).$t.apply(ref2, [key].concat(values2));
  } else {
    ret = this._warnDefault(locale, key, ret, host, values2, "string");
    if (this._postTranslation && ret !== null && ret !== void 0) {
      ret = this._postTranslation(ret, key);
    }
    return ret;
  }
};
VueI18n.prototype.t = function t2(key) {
  var ref2;
  var values2 = [], len = arguments.length - 1;
  while (len-- > 0)
    values2[len] = arguments[len + 1];
  return (ref2 = this)._t.apply(ref2, [key, this.locale, this._getMessages(), null].concat(values2));
};
VueI18n.prototype._i = function _i(key, locale, messages2, host, values2) {
  var ret = this._translate(messages2, locale, this.fallbackLocale, key, host, "raw", values2);
  if (this._isFallbackRoot(ret)) {
    if (!this._root) {
      throw Error("unexpected error");
    }
    return this._root.$i18n.i(key, locale, values2);
  } else {
    return this._warnDefault(locale, key, ret, host, [values2], "raw");
  }
};
VueI18n.prototype.i = function i(key, locale, values2) {
  if (!key) {
    return "";
  }
  if (!isString(locale)) {
    locale = this.locale;
  }
  return this._i(key, locale, this._getMessages(), null, values2);
};
VueI18n.prototype._tc = function _tc(key, _locale, messages2, host, choice) {
  var ref2;
  var values2 = [], len = arguments.length - 5;
  while (len-- > 0)
    values2[len] = arguments[len + 5];
  if (!key) {
    return "";
  }
  if (choice === void 0) {
    choice = 1;
  }
  var predefined = { "count": choice, "n": choice };
  var parsedArgs = parseArgs.apply(void 0, values2);
  parsedArgs.params = Object.assign(predefined, parsedArgs.params);
  values2 = parsedArgs.locale === null ? [parsedArgs.params] : [parsedArgs.locale, parsedArgs.params];
  return this.fetchChoice((ref2 = this)._t.apply(ref2, [key, _locale, messages2, host].concat(values2)), choice);
};
VueI18n.prototype.fetchChoice = function fetchChoice(message, choice) {
  if (!message || !isString(message)) {
    return null;
  }
  var choices = message.split("|");
  choice = this.getChoiceIndex(choice, choices.length);
  if (!choices[choice]) {
    return message;
  }
  return choices[choice].trim();
};
VueI18n.prototype.tc = function tc(key, choice) {
  var ref2;
  var values2 = [], len = arguments.length - 2;
  while (len-- > 0)
    values2[len] = arguments[len + 2];
  return (ref2 = this)._tc.apply(ref2, [key, this.locale, this._getMessages(), null, choice].concat(values2));
};
VueI18n.prototype._te = function _te(key, locale, messages2) {
  var args = [], len = arguments.length - 3;
  while (len-- > 0)
    args[len] = arguments[len + 3];
  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages2[_locale], key);
};
VueI18n.prototype.te = function te(key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale);
};
VueI18n.prototype.getLocaleMessage = function getLocaleMessage(locale) {
  return looseClone(this._vm.messages[locale] || {});
};
VueI18n.prototype.setLocaleMessage = function setLocaleMessage(locale, message) {
  if (this._warnHtmlInMessage === "warn" || this._warnHtmlInMessage === "error") {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, message);
};
VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage(locale, message) {
  if (this._warnHtmlInMessage === "warn" || this._warnHtmlInMessage === "error") {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, merge$3(
    typeof this._vm.messages[locale] !== "undefined" && Object.keys(this._vm.messages[locale]).length ? Object.assign({}, this._vm.messages[locale]) : {},
    message
  ));
};
VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat(locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {});
};
VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat(locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, format);
  this._clearDateTimeFormat(locale, format);
};
VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat(locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, merge$3(this._vm.dateTimeFormats[locale] || {}, format));
  this._clearDateTimeFormat(locale, format);
};
VueI18n.prototype._clearDateTimeFormat = function _clearDateTimeFormat(locale, format) {
  for (var key in format) {
    var id = locale + "__" + key;
    if (!this._dateTimeFormatters.hasOwnProperty(id)) {
      continue;
    }
    delete this._dateTimeFormatters[id];
  }
};
VueI18n.prototype._localizeDateTime = function _localizeDateTime(value, locale, fallback, dateTimeFormats, key, options) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];
  var chain = this._getLocaleChain(locale, fallback);
  for (var i2 = 0; i2 < chain.length; i2++) {
    var current = _locale;
    var step = chain[i2];
    formats = dateTimeFormats[step];
    _locale = step;
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && false) {
        warn("Fall back to '" + step + "' datetime formats from '" + current + "' datetime formats.");
      }
    } else {
      break;
    }
  }
  if (isNull(formats) || isNull(formats[key])) {
    return null;
  } else {
    var format = formats[key];
    var formatter;
    if (options) {
      formatter = new Intl.DateTimeFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._dateTimeFormatters[id];
      if (!formatter) {
        formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
      }
    }
    return formatter.format(value);
  }
};
VueI18n.prototype._d = function _d(value, locale, key, options) {
  if (!key) {
    var dtf = !options ? new Intl.DateTimeFormat(locale) : new Intl.DateTimeFormat(locale, options);
    return dtf.format(value);
  }
  var ret = this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key, options);
  if (this._isFallbackRoot(ret)) {
    if (!this._root) {
      throw Error("unexpected error");
    }
    return this._root.$i18n.d(value, key, locale);
  } else {
    return ret || "";
  }
};
VueI18n.prototype.d = function d(value) {
  var args = [], len = arguments.length - 1;
  while (len-- > 0)
    args[len] = arguments[len + 1];
  var locale = this.locale;
  var key = null;
  var options = null;
  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject$1(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }
    options = Object.keys(args[0]).reduce(function(acc, key2) {
      var obj;
      if (includes(dateTimeFormatKeys, key2)) {
        return Object.assign({}, acc, (obj = {}, obj[key2] = args[0][key2], obj));
      }
      return acc;
    }, null);
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }
  return this._d(value, locale, key, options);
};
VueI18n.prototype.getNumberFormat = function getNumberFormat(locale) {
  return looseClone(this._vm.numberFormats[locale] || {});
};
VueI18n.prototype.setNumberFormat = function setNumberFormat(locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, format);
  this._clearNumberFormat(locale, format);
};
VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat(locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, merge$3(this._vm.numberFormats[locale] || {}, format));
  this._clearNumberFormat(locale, format);
};
VueI18n.prototype._clearNumberFormat = function _clearNumberFormat(locale, format) {
  for (var key in format) {
    var id = locale + "__" + key;
    if (!this._numberFormatters.hasOwnProperty(id)) {
      continue;
    }
    delete this._numberFormatters[id];
  }
};
VueI18n.prototype._getNumberFormatter = function _getNumberFormatter(value, locale, fallback, numberFormats, key, options) {
  var _locale = locale;
  var formats = numberFormats[_locale];
  var chain = this._getLocaleChain(locale, fallback);
  for (var i2 = 0; i2 < chain.length; i2++) {
    var current = _locale;
    var step = chain[i2];
    formats = numberFormats[step];
    _locale = step;
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && false) {
        warn("Fall back to '" + step + "' number formats from '" + current + "' number formats.");
      }
    } else {
      break;
    }
  }
  if (isNull(formats) || isNull(formats[key])) {
    return null;
  } else {
    var format = formats[key];
    var formatter;
    if (options) {
      formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
    }
    return formatter;
  }
};
VueI18n.prototype._n = function _n(value, locale, key, options) {
  if (!VueI18n.availabilities.numberFormat) {
    return "";
  }
  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.format(value);
  }
  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.format(value);
  if (this._isFallbackRoot(ret)) {
    if (!this._root) {
      throw Error("unexpected error");
    }
    return this._root.$i18n.n(value, Object.assign({}, { key, locale }, options));
  } else {
    return ret || "";
  }
};
VueI18n.prototype.n = function n(value) {
  var args = [], len = arguments.length - 1;
  while (len-- > 0)
    args[len] = arguments[len + 1];
  var locale = this.locale;
  var key = null;
  var options = null;
  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject$1(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
      options = Object.keys(args[0]).reduce(function(acc, key2) {
        var obj;
        if (includes(numberFormatKeys, key2)) {
          return Object.assign({}, acc, (obj = {}, obj[key2] = args[0][key2], obj));
        }
        return acc;
      }, null);
    }
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }
  return this._n(value, locale, key, options);
};
VueI18n.prototype._ntp = function _ntp(value, locale, key, options) {
  if (!VueI18n.availabilities.numberFormat) {
    return [];
  }
  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.formatToParts(value);
  }
  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.formatToParts(value);
  if (this._isFallbackRoot(ret)) {
    if (!this._root) {
      throw Error("unexpected error");
    }
    return this._root.$i18n._ntp(value, locale, key, options);
  } else {
    return ret || [];
  }
};
Object.defineProperties(VueI18n.prototype, prototypeAccessors);
var availabilities;
Object.defineProperty(VueI18n, "availabilities", {
  get: function get4() {
    if (!availabilities) {
      var intlDefined = typeof Intl !== "undefined";
      availabilities = {
        dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== "undefined",
        numberFormat: intlDefined && typeof Intl.NumberFormat !== "undefined"
      };
    }
    return availabilities;
  }
});
VueI18n.install = install$3;
VueI18n.version = "8.28.2";
const VueI18n$1 = VueI18n;
function getInternetExplorerVersion() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  if (msie > 0) {
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  }
  var trident = ua.indexOf("Trident/");
  if (trident > 0) {
    var rv = ua.indexOf("rv:");
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
  }
  var edge = ua.indexOf("Edge/");
  if (edge > 0) {
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
  }
  return -1;
}
var isIE = void 0;
function initCompat() {
  if (!initCompat.init) {
    initCompat.init = true;
    isIE = getInternetExplorerVersion() !== -1;
  }
}
var ResizeObserver$1 = {
  render: function render6() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "resize-observer", attrs: { "tabindex": "-1" } });
  },
  staticRenderFns: [],
  _scopeId: "data-v-b329ee4c",
  name: "resize-observer",
  methods: {
    compareAndNotify: function compareAndNotify() {
      if (this._w !== this.$el.offsetWidth || this._h !== this.$el.offsetHeight) {
        this._w = this.$el.offsetWidth;
        this._h = this.$el.offsetHeight;
        this.$emit("notify");
      }
    },
    addResizeHandlers: function addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify);
      this.compareAndNotify();
    },
    removeResizeHandlers: function removeResizeHandlers() {
      if (this._resizeObject && this._resizeObject.onload) {
        if (!isIE && this._resizeObject.contentDocument) {
          this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify);
        }
        delete this._resizeObject.onload;
      }
    }
  },
  mounted: function mounted2() {
    var _this2 = this;
    initCompat();
    this.$nextTick(function() {
      _this2._w = _this2.$el.offsetWidth;
      _this2._h = _this2.$el.offsetHeight;
    });
    var object = document.createElement("object");
    this._resizeObject = object;
    object.setAttribute("aria-hidden", "true");
    object.setAttribute("tabindex", -1);
    object.onload = this.addResizeHandlers;
    object.type = "text/html";
    if (isIE) {
      this.$el.appendChild(object);
    }
    object.data = "about:blank";
    if (!isIE) {
      this.$el.appendChild(object);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeResizeHandlers();
  }
};
function install$2(Vue2) {
  Vue2.component("resize-observer", ResizeObserver$1);
  Vue2.component("ResizeObserver", ResizeObserver$1);
}
var plugin$3 = {
  // eslint-disable-next-line no-undef
  version: "0.4.5",
  install: install$2
};
var GlobalVue$3 = null;
if (typeof window !== "undefined") {
  GlobalVue$3 = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue$3 = global.Vue;
}
if (GlobalVue$3) {
  GlobalVue$3.use(plugin$3);
}
function _typeof$1(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$1 = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$1(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target2, props2) {
  for (var i2 = 0; i2 < props2.length; i2++) {
    var descriptor = props2[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target2, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1();
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) {
    for (var i2 = 0, arr2 = new Array(arr.length); i2 < arr.length; i2++)
      arr2[i2] = arr[i2];
    return arr2;
  }
}
function _iterableToArray$1(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]")
    return Array.from(iter);
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function processOptions(value) {
  var options;
  if (typeof value === "function") {
    options = {
      callback: value
    };
  } else {
    options = value;
  }
  return options;
}
function throttle$1(callback, delay) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var timeout;
  var lastState;
  var currentArgs;
  var throttled = function throttled2(state) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    currentArgs = args;
    if (timeout && state === lastState)
      return;
    var leading = options.leading;
    if (typeof leading === "function") {
      leading = leading(state, lastState);
    }
    if ((!timeout || state !== lastState) && leading) {
      callback.apply(void 0, [state].concat(_toConsumableArray$2(currentArgs)));
    }
    lastState = state;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      callback.apply(void 0, [state].concat(_toConsumableArray$2(currentArgs)));
      timeout = 0;
    }, delay);
  };
  throttled._clear = function() {
    clearTimeout(timeout);
    timeout = null;
  };
  return throttled;
}
function deepEqual(val1, val2) {
  if (val1 === val2)
    return true;
  if (_typeof$1(val1) === "object") {
    for (var key in val1) {
      if (!deepEqual(val1[key], val2[key])) {
        return false;
      }
    }
    return true;
  }
  return false;
}
var VisibilityState = /* @__PURE__ */ function() {
  function VisibilityState2(el, options, vnode) {
    _classCallCheck(this, VisibilityState2);
    this.el = el;
    this.observer = null;
    this.frozen = false;
    this.createObserver(options, vnode);
  }
  _createClass(VisibilityState2, [{
    key: "createObserver",
    value: function createObserver2(options, vnode) {
      var _this2 = this;
      if (this.observer) {
        this.destroyObserver();
      }
      if (this.frozen)
        return;
      this.options = processOptions(options);
      this.callback = function(result2, entry) {
        _this2.options.callback(result2, entry);
        if (result2 && _this2.options.once) {
          _this2.frozen = true;
          _this2.destroyObserver();
        }
      };
      if (this.callback && this.options.throttle) {
        var _ref = this.options.throttleOptions || {}, _leading = _ref.leading;
        this.callback = throttle$1(this.callback, this.options.throttle, {
          leading: function leading(state) {
            return _leading === "both" || _leading === "visible" && state || _leading === "hidden" && !state;
          }
        });
      }
      this.oldResult = void 0;
      this.observer = new IntersectionObserver(function(entries) {
        var entry = entries[0];
        if (entries.length > 1) {
          var intersectingEntry = entries.find(function(e) {
            return e.isIntersecting;
          });
          if (intersectingEntry) {
            entry = intersectingEntry;
          }
        }
        if (_this2.callback) {
          var result2 = entry.isIntersecting && entry.intersectionRatio >= _this2.threshold;
          if (result2 === _this2.oldResult)
            return;
          _this2.oldResult = result2;
          _this2.callback(result2, entry);
        }
      }, this.options.intersection);
      vnode.context.$nextTick(function() {
        if (_this2.observer) {
          _this2.observer.observe(_this2.el);
        }
      });
    }
  }, {
    key: "destroyObserver",
    value: function destroyObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.callback && this.callback._clear) {
        this.callback._clear();
        this.callback = null;
      }
    }
  }, {
    key: "threshold",
    get: function get5() {
      return this.options.intersection && this.options.intersection.threshold || 0;
    }
  }]);
  return VisibilityState2;
}();
function bind3(el, _ref2, vnode) {
  var value = _ref2.value;
  if (!value)
    return;
  if (typeof IntersectionObserver === "undefined") {
    console.warn("[vue-observe-visibility] IntersectionObserver API is not available in your browser. Please install this polyfill: https://github.com/w3c/IntersectionObserver/tree/master/polyfill");
  } else {
    var state = new VisibilityState(el, value, vnode);
    el._vue_visibilityState = state;
  }
}
function update4(el, _ref3, vnode) {
  var value = _ref3.value, oldValue = _ref3.oldValue;
  if (deepEqual(value, oldValue))
    return;
  var state = el._vue_visibilityState;
  if (!value) {
    unbind2(el);
    return;
  }
  if (state) {
    state.createObserver(value, vnode);
  } else {
    bind3(el, {
      value
    }, vnode);
  }
}
function unbind2(el) {
  var state = el._vue_visibilityState;
  if (state) {
    state.destroyObserver();
    delete el._vue_visibilityState;
  }
}
var ObserveVisibility = {
  bind: bind3,
  update: update4,
  unbind: unbind2
};
function install$1(Vue2) {
  Vue2.directive("observe-visibility", ObserveVisibility);
}
var plugin$2 = {
  // eslint-disable-next-line no-undef
  version: "0.4.6",
  install: install$1
};
var GlobalVue$2 = null;
if (typeof window !== "undefined") {
  GlobalVue$2 = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue$2 = global.Vue;
}
if (GlobalVue$2) {
  GlobalVue$2.use(plugin$2);
}
var scrollparent = { exports: {} };
(function(module) {
  (function(root2, factory) {
    if (module.exports) {
      module.exports = factory();
    } else {
      root2.Scrollparent = factory();
    }
  })(commonjsGlobal, function() {
    function isScrolling(node2) {
      var overflow = getComputedStyle(node2, null).getPropertyValue("overflow");
      return overflow.indexOf("scroll") > -1 || overflow.indexOf("auto") > -1;
    }
    function scrollParent(node2) {
      if (!(node2 instanceof HTMLElement || node2 instanceof SVGElement)) {
        return void 0;
      }
      var current = node2.parentNode;
      while (current.parentNode) {
        if (isScrolling(current)) {
          return current;
        }
        current = current.parentNode;
      }
      return document.scrollingElement || document.documentElement;
    }
    return scrollParent;
  });
})(scrollparent);
var scrollparentExports = scrollparent.exports;
const ScrollParent = /* @__PURE__ */ getDefaultExportFromCjs(scrollparentExports);
var config = {
  itemsLimit: 1e3
};
const props = {
  items: {
    type: Array,
    required: true
  },
  keyField: {
    type: String,
    default: "id"
  },
  direction: {
    type: String,
    default: "vertical",
    validator: (value) => ["vertical", "horizontal"].includes(value)
  },
  listTag: {
    type: String,
    default: "div"
  },
  itemTag: {
    type: String,
    default: "div"
  }
};
function simpleArray() {
  return this.items.length && typeof this.items[0] !== "object";
}
let supportsPassive = false;
if (typeof window !== "undefined") {
  supportsPassive = false;
  try {
    var opts = Object.defineProperty({}, "passive", {
      get() {
        supportsPassive = true;
      }
    });
    window.addEventListener("test", null, opts);
  } catch (e) {
  }
}
let uid = 0;
var script$2 = {
  name: "RecycleScroller",
  components: {
    ResizeObserver: ResizeObserver$1
  },
  directives: {
    ObserveVisibility
  },
  props: __spreadProps(__spreadValues({}, props), {
    itemSize: {
      type: Number,
      default: null
    },
    gridItems: {
      type: Number,
      default: void 0
    },
    itemSecondarySize: {
      type: Number,
      default: void 0
    },
    minItemSize: {
      type: [Number, String],
      default: null
    },
    sizeField: {
      type: String,
      default: "size"
    },
    typeField: {
      type: String,
      default: "type"
    },
    buffer: {
      type: Number,
      default: 200
    },
    pageMode: {
      type: Boolean,
      default: false
    },
    prerender: {
      type: Number,
      default: 0
    },
    emitUpdate: {
      type: Boolean,
      default: false
    },
    skipHover: {
      type: Boolean,
      default: false
    },
    listTag: {
      type: String,
      default: "div"
    },
    itemTag: {
      type: String,
      default: "div"
    },
    listClass: {
      type: [String, Object, Array],
      default: ""
    },
    itemClass: {
      type: [String, Object, Array],
      default: ""
    }
  }),
  data() {
    return {
      pool: [],
      totalSize: 0,
      ready: false,
      hoverKey: null
    };
  },
  computed: {
    sizes() {
      if (this.itemSize === null) {
        const sizes = {
          "-1": {
            accumulator: 0
          }
        };
        const items = this.items;
        const field = this.sizeField;
        const minItemSize = this.minItemSize;
        let computedMinSize = 1e4;
        let accumulator = 0;
        let current;
        for (let i2 = 0, l = items.length; i2 < l; i2++) {
          current = items[i2][field] || minItemSize;
          if (current < computedMinSize) {
            computedMinSize = current;
          }
          accumulator += current;
          sizes[i2] = {
            accumulator,
            size: current
          };
        }
        this.$_computedMinItemSize = computedMinSize;
        return sizes;
      }
      return [];
    },
    simpleArray
  },
  watch: {
    items() {
      this.updateVisibleItems(true);
    },
    pageMode() {
      this.applyPageMode();
      this.updateVisibleItems(false);
    },
    sizes: {
      handler() {
        this.updateVisibleItems(false);
      },
      deep: true
    },
    gridItems() {
      this.updateVisibleItems(true);
    },
    itemSecondarySize() {
      this.updateVisibleItems(true);
    }
  },
  created() {
    this.$_startIndex = 0;
    this.$_endIndex = 0;
    this.$_views = /* @__PURE__ */ new Map();
    this.$_unusedViews = /* @__PURE__ */ new Map();
    this.$_scrollDirty = false;
    this.$_lastUpdateScrollPosition = 0;
    if (this.prerender) {
      this.$_prerender = true;
      this.updateVisibleItems(false);
    }
    if (this.gridItems && !this.itemSize) {
      console.error("[vue-recycle-scroller] You must provide an itemSize when using gridItems");
    }
  },
  mounted() {
    this.applyPageMode();
    this.$nextTick(() => {
      this.$_prerender = false;
      this.updateVisibleItems(true);
      this.ready = true;
    });
  },
  activated() {
    const lastPosition = this.$_lastUpdateScrollPosition;
    if (typeof lastPosition === "number") {
      this.$nextTick(() => {
        this.scrollToPosition(lastPosition);
      });
    }
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    addView(pool, index2, item, key, type) {
      const view = {
        item,
        position: 0
      };
      const nonReactive = {
        id: uid++,
        index: index2,
        used: true,
        key,
        type
      };
      Object.defineProperty(view, "nr", {
        configurable: false,
        value: nonReactive
      });
      pool.push(view);
      return view;
    },
    unuseView(view, fake = false) {
      const unusedViews = this.$_unusedViews;
      const type = view.nr.type;
      let unusedPool = unusedViews.get(type);
      if (!unusedPool) {
        unusedPool = [];
        unusedViews.set(type, unusedPool);
      }
      unusedPool.push(view);
      if (!fake) {
        view.nr.used = false;
        view.position = -9999;
        this.$_views.delete(view.nr.key);
      }
    },
    handleResize() {
      this.$emit("resize");
      if (this.ready)
        this.updateVisibleItems(false);
    },
    handleScroll(event) {
      if (!this.$_scrollDirty) {
        this.$_scrollDirty = true;
        requestAnimationFrame(() => {
          this.$_scrollDirty = false;
          const {
            continuous
          } = this.updateVisibleItems(false, true);
          if (!continuous) {
            clearTimeout(this.$_refreshTimout);
            this.$_refreshTimout = setTimeout(this.handleScroll, 100);
          }
        });
      }
    },
    handleVisibilityChange(isVisible, entry) {
      if (this.ready) {
        if (isVisible || entry.boundingClientRect.width !== 0 || entry.boundingClientRect.height !== 0) {
          this.$emit("visible");
          requestAnimationFrame(() => {
            this.updateVisibleItems(false);
          });
        } else {
          this.$emit("hidden");
        }
      }
    },
    updateVisibleItems(checkItem, checkPositionDiff = false) {
      const itemSize = this.itemSize;
      const gridItems = this.gridItems || 1;
      const itemSecondarySize = this.itemSecondarySize || itemSize;
      const minItemSize = this.$_computedMinItemSize;
      const typeField = this.typeField;
      const keyField = this.simpleArray ? null : this.keyField;
      const items = this.items;
      const count = items.length;
      const sizes = this.sizes;
      const views = this.$_views;
      const unusedViews = this.$_unusedViews;
      const pool = this.pool;
      let startIndex, endIndex;
      let totalSize;
      let visibleStartIndex, visibleEndIndex;
      if (!count) {
        startIndex = endIndex = visibleStartIndex = visibleEndIndex = totalSize = 0;
      } else if (this.$_prerender) {
        startIndex = visibleStartIndex = 0;
        endIndex = visibleEndIndex = Math.min(this.prerender, items.length);
        totalSize = null;
      } else {
        const scroll = this.getScroll();
        if (checkPositionDiff) {
          let positionDiff = scroll.start - this.$_lastUpdateScrollPosition;
          if (positionDiff < 0)
            positionDiff = -positionDiff;
          if (itemSize === null && positionDiff < minItemSize || positionDiff < itemSize) {
            return {
              continuous: true
            };
          }
        }
        this.$_lastUpdateScrollPosition = scroll.start;
        const buffer = this.buffer;
        scroll.start -= buffer;
        scroll.end += buffer;
        let beforeSize = 0;
        if (this.$refs.before) {
          beforeSize = this.$refs.before.scrollHeight;
          scroll.start -= beforeSize;
        }
        if (this.$refs.after) {
          const afterSize = this.$refs.after.scrollHeight;
          scroll.end += afterSize;
        }
        if (itemSize === null) {
          let h;
          let a = 0;
          let b = count - 1;
          let i2 = ~~(count / 2);
          let oldI;
          do {
            oldI = i2;
            h = sizes[i2].accumulator;
            if (h < scroll.start) {
              a = i2;
            } else if (i2 < count - 1 && sizes[i2 + 1].accumulator > scroll.start) {
              b = i2;
            }
            i2 = ~~((a + b) / 2);
          } while (i2 !== oldI);
          i2 < 0 && (i2 = 0);
          startIndex = i2;
          totalSize = sizes[count - 1].accumulator;
          for (endIndex = i2; endIndex < count && sizes[endIndex].accumulator < scroll.end; endIndex++)
            ;
          if (endIndex === -1) {
            endIndex = items.length - 1;
          } else {
            endIndex++;
            endIndex > count && (endIndex = count);
          }
          for (visibleStartIndex = startIndex; visibleStartIndex < count && beforeSize + sizes[visibleStartIndex].accumulator < scroll.start; visibleStartIndex++)
            ;
          for (visibleEndIndex = visibleStartIndex; visibleEndIndex < count && beforeSize + sizes[visibleEndIndex].accumulator < scroll.end; visibleEndIndex++)
            ;
        } else {
          startIndex = ~~(scroll.start / itemSize * gridItems);
          const remainer = startIndex % gridItems;
          startIndex -= remainer;
          endIndex = Math.ceil(scroll.end / itemSize * gridItems);
          visibleStartIndex = Math.max(0, Math.floor((scroll.start - beforeSize) / itemSize * gridItems));
          visibleEndIndex = Math.floor((scroll.end - beforeSize) / itemSize * gridItems);
          startIndex < 0 && (startIndex = 0);
          endIndex > count && (endIndex = count);
          visibleStartIndex < 0 && (visibleStartIndex = 0);
          visibleEndIndex > count && (visibleEndIndex = count);
          totalSize = Math.ceil(count / gridItems) * itemSize;
        }
      }
      if (endIndex - startIndex > config.itemsLimit) {
        this.itemsLimitError();
      }
      this.totalSize = totalSize;
      let view;
      const continuous = startIndex <= this.$_endIndex && endIndex >= this.$_startIndex;
      if (this.$_continuous !== continuous) {
        if (continuous) {
          views.clear();
          unusedViews.clear();
          for (let i2 = 0, l = pool.length; i2 < l; i2++) {
            view = pool[i2];
            this.unuseView(view);
          }
        }
        this.$_continuous = continuous;
      } else if (continuous) {
        for (let i2 = 0, l = pool.length; i2 < l; i2++) {
          view = pool[i2];
          if (view.nr.used) {
            if (checkItem) {
              view.nr.index = items.indexOf(view.item);
            }
            if (view.nr.index === -1 || view.nr.index < startIndex || view.nr.index >= endIndex) {
              this.unuseView(view);
            }
          }
        }
      }
      const unusedIndex = continuous ? null : /* @__PURE__ */ new Map();
      let item, type, unusedPool;
      let v;
      for (let i2 = startIndex; i2 < endIndex; i2++) {
        item = items[i2];
        const key = keyField ? item[keyField] : item;
        if (key == null) {
          throw new Error(`Key is ${key} on item (keyField is '${keyField}')`);
        }
        view = views.get(key);
        if (!itemSize && !sizes[i2].size) {
          if (view)
            this.unuseView(view);
          continue;
        }
        if (!view) {
          if (i2 === items.length - 1)
            this.$emit("scroll-end");
          if (i2 === 0)
            this.$emit("scroll-start");
          type = item[typeField];
          unusedPool = unusedViews.get(type);
          if (continuous) {
            if (unusedPool && unusedPool.length) {
              view = unusedPool.pop();
              view.item = item;
              view.nr.used = true;
              view.nr.index = i2;
              view.nr.key = key;
              view.nr.type = type;
            } else {
              view = this.addView(pool, i2, item, key, type);
            }
          } else {
            v = unusedIndex.get(type) || 0;
            if (!unusedPool || v >= unusedPool.length) {
              view = this.addView(pool, i2, item, key, type);
              this.unuseView(view, true);
              unusedPool = unusedViews.get(type);
            }
            view = unusedPool[v];
            view.item = item;
            view.nr.used = true;
            view.nr.index = i2;
            view.nr.key = key;
            view.nr.type = type;
            unusedIndex.set(type, v + 1);
            v++;
          }
          views.set(key, view);
        } else {
          view.nr.used = true;
          view.item = item;
        }
        if (itemSize === null) {
          view.position = sizes[i2 - 1].accumulator;
          view.offset = 0;
        } else {
          view.position = Math.floor(i2 / gridItems) * itemSize;
          view.offset = i2 % gridItems * itemSecondarySize;
        }
      }
      this.$_startIndex = startIndex;
      this.$_endIndex = endIndex;
      if (this.emitUpdate)
        this.$emit("update", startIndex, endIndex, visibleStartIndex, visibleEndIndex);
      clearTimeout(this.$_sortTimer);
      this.$_sortTimer = setTimeout(this.sortViews, 300);
      return {
        continuous
      };
    },
    getListenerTarget() {
      let target2 = ScrollParent(this.$el);
      if (window.document && (target2 === window.document.documentElement || target2 === window.document.body)) {
        target2 = window;
      }
      return target2;
    },
    getScroll() {
      const {
        $el: el,
        direction
      } = this;
      const isVertical = direction === "vertical";
      let scrollState;
      if (this.pageMode) {
        const bounds = el.getBoundingClientRect();
        const boundsSize = isVertical ? bounds.height : bounds.width;
        let start = -(isVertical ? bounds.top : bounds.left);
        let size = isVertical ? window.innerHeight : window.innerWidth;
        if (start < 0) {
          size += start;
          start = 0;
        }
        if (start + size > boundsSize) {
          size = boundsSize - start;
        }
        scrollState = {
          start,
          end: start + size
        };
      } else if (isVertical) {
        scrollState = {
          start: el.scrollTop,
          end: el.scrollTop + el.clientHeight
        };
      } else {
        scrollState = {
          start: el.scrollLeft,
          end: el.scrollLeft + el.clientWidth
        };
      }
      return scrollState;
    },
    applyPageMode() {
      if (this.pageMode) {
        this.addListeners();
      } else {
        this.removeListeners();
      }
    },
    addListeners() {
      this.listenerTarget = this.getListenerTarget();
      this.listenerTarget.addEventListener("scroll", this.handleScroll, supportsPassive ? {
        passive: true
      } : false);
      this.listenerTarget.addEventListener("resize", this.handleResize);
    },
    removeListeners() {
      if (!this.listenerTarget) {
        return;
      }
      this.listenerTarget.removeEventListener("scroll", this.handleScroll);
      this.listenerTarget.removeEventListener("resize", this.handleResize);
      this.listenerTarget = null;
    },
    scrollToItem(index2) {
      let scroll;
      if (this.itemSize === null) {
        scroll = index2 > 0 ? this.sizes[index2 - 1].accumulator : 0;
      } else {
        scroll = Math.floor(index2 / this.gridItems) * this.itemSize;
      }
      this.scrollToPosition(scroll);
    },
    scrollToPosition(position) {
      const direction = this.direction === "vertical" ? {
        scroll: "scrollTop",
        start: "top"
      } : {
        scroll: "scrollLeft",
        start: "left"
      };
      let viewport;
      let scrollDirection;
      let scrollDistance;
      if (this.pageMode) {
        const viewportEl = ScrollParent(this.$el);
        const scrollTop = viewportEl.tagName === "HTML" ? 0 : viewportEl[direction.scroll];
        const bounds = viewportEl.getBoundingClientRect();
        const scroller = this.$el.getBoundingClientRect();
        const scrollerPosition = scroller[direction.start] - bounds[direction.start];
        viewport = viewportEl;
        scrollDirection = direction.scroll;
        scrollDistance = position + scrollTop + scrollerPosition;
      } else {
        viewport = this.$el;
        scrollDirection = direction.scroll;
        scrollDistance = position;
      }
      viewport[scrollDirection] = scrollDistance;
    },
    itemsLimitError() {
      setTimeout(() => {
        console.log("It seems the scroller element isn't scrolling, so it tries to render all the items at once.", "Scroller:", this.$el);
        console.log("Make sure the scroller has a fixed height (or width) and 'overflow-y' (or 'overflow-x') set to 'auto' so it can scroll correctly and only render the items visible in the scroll viewport.");
      });
      throw new Error("Rendered items limit reached");
    },
    sortViews() {
      this.pool.sort((viewA, viewB) => viewA.nr.index - viewB.nr.index);
    }
  }
};
function normalizeComponent(template, style2, script2, scopeId, isFunctionalTemplate, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== "boolean") {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  }
  const options = typeof script2 === "function" ? script2.options : script2;
  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true;
    if (isFunctionalTemplate) {
      options.functional = true;
    }
  }
  if (scopeId) {
    options._scopeId = scopeId;
  }
  let hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (style2) {
        style2.call(this, createInjectorSSR(context));
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (style2) {
    hook = shadowMode ? function(context) {
      style2.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function(context) {
      style2.call(this, createInjector(context));
    };
  }
  if (hook) {
    if (options.functional) {
      const originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      const existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return script2;
}
const __vue_script__$2 = script$2;
var __vue_render__$1 = function() {
  var _obj, _obj$1;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: _vm.handleVisibilityChange,
          expression: "handleVisibilityChange"
        }
      ],
      staticClass: "vue-recycle-scroller",
      class: (_obj = {
        ready: _vm.ready,
        "page-mode": _vm.pageMode
      }, _obj["direction-" + _vm.direction] = true, _obj),
      on: {
        "&scroll": function($event) {
          return _vm.handleScroll.apply(null, arguments);
        }
      }
    },
    [
      _vm.$slots.before ? _c(
        "div",
        { ref: "before", staticClass: "vue-recycle-scroller__slot" },
        [_vm._t("before")],
        2
      ) : _vm._e(),
      _vm._v(" "),
      _c(
        _vm.listTag,
        {
          ref: "wrapper",
          tag: "component",
          staticClass: "vue-recycle-scroller__item-wrapper",
          class: _vm.listClass,
          style: (_obj$1 = {}, _obj$1[_vm.direction === "vertical" ? "minHeight" : "minWidth"] = _vm.totalSize + "px", _obj$1)
        },
        [
          _vm._l(_vm.pool, function(view) {
            return _c(
              _vm.itemTag,
              _vm._g(
                {
                  key: view.nr.id,
                  tag: "component",
                  staticClass: "vue-recycle-scroller__item-view",
                  class: [
                    _vm.itemClass,
                    {
                      hover: !_vm.skipHover && _vm.hoverKey === view.nr.key
                    }
                  ],
                  style: _vm.ready ? {
                    transform: "translate" + (_vm.direction === "vertical" ? "Y" : "X") + "(" + view.position + "px) translate" + (_vm.direction === "vertical" ? "X" : "Y") + "(" + view.offset + "px)",
                    width: _vm.gridItems ? (_vm.direction === "vertical" ? _vm.itemSecondarySize || _vm.itemSize : _vm.itemSize) + "px" : void 0,
                    height: _vm.gridItems ? (_vm.direction === "horizontal" ? _vm.itemSecondarySize || _vm.itemSize : _vm.itemSize) + "px" : void 0
                  } : null
                },
                _vm.skipHover ? {} : {
                  mouseenter: function() {
                    _vm.hoverKey = view.nr.key;
                  },
                  mouseleave: function() {
                    _vm.hoverKey = null;
                  }
                }
              ),
              [
                _vm._t("default", null, {
                  item: view.item,
                  index: view.nr.index,
                  active: view.nr.used
                })
              ],
              2
            );
          }),
          _vm._v(" "),
          _vm._t("empty")
        ],
        2
      ),
      _vm._v(" "),
      _vm.$slots.after ? _c(
        "div",
        { ref: "after", staticClass: "vue-recycle-scroller__slot" },
        [_vm._t("after")],
        2
      ) : _vm._e(),
      _vm._v(" "),
      _c("ResizeObserver", { on: { notify: _vm.handleResize } })
    ],
    1
  );
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;
const __vue_inject_styles__$2 = void 0;
const __vue_scope_id__$2 = void 0;
const __vue_module_identifier__$2 = void 0;
const __vue_is_functional_template__$2 = false;
const __vue_component__$2 = /* @__PURE__ */ normalizeComponent(
  { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
  __vue_inject_styles__$2,
  __vue_script__$2,
  __vue_scope_id__$2,
  __vue_is_functional_template__$2,
  __vue_module_identifier__$2,
  false,
  void 0,
  void 0,
  void 0
);
var script$1 = {
  name: "DynamicScroller",
  components: {
    RecycleScroller: __vue_component__$2
  },
  provide() {
    if (typeof ResizeObserver !== "undefined") {
      this.$_resizeObserver = new ResizeObserver((entries) => {
        requestAnimationFrame(() => {
          if (!Array.isArray(entries)) {
            return;
          }
          for (const entry of entries) {
            if (entry.target) {
              const event = new CustomEvent("resize", {
                detail: {
                  contentRect: entry.contentRect
                }
              });
              entry.target.dispatchEvent(event);
            }
          }
        });
      });
    }
    return {
      vscrollData: this.vscrollData,
      vscrollParent: this,
      vscrollResizeObserver: this.$_resizeObserver
    };
  },
  inheritAttrs: false,
  props: __spreadProps(__spreadValues({}, props), {
    minItemSize: {
      type: [Number, String],
      required: true
    }
  }),
  data() {
    return {
      vscrollData: {
        active: true,
        sizes: {},
        validSizes: {},
        keyField: this.keyField,
        simpleArray: false
      }
    };
  },
  computed: {
    simpleArray,
    itemsWithSize() {
      const result2 = [];
      const {
        items,
        keyField,
        simpleArray: simpleArray2
      } = this;
      const sizes = this.vscrollData.sizes;
      const l = items.length;
      for (let i2 = 0; i2 < l; i2++) {
        const item = items[i2];
        const id = simpleArray2 ? i2 : item[keyField];
        let size = sizes[id];
        if (typeof size === "undefined" && !this.$_undefinedMap[id]) {
          size = 0;
        }
        result2.push({
          item,
          id,
          size
        });
      }
      return result2;
    },
    listeners() {
      const listeners = {};
      for (const key in this.$listeners) {
        if (key !== "resize" && key !== "visible") {
          listeners[key] = this.$listeners[key];
        }
      }
      return listeners;
    }
  },
  watch: {
    items() {
      this.forceUpdate(false);
    },
    simpleArray: {
      handler(value) {
        this.vscrollData.simpleArray = value;
      },
      immediate: true
    },
    direction(value) {
      this.forceUpdate(true);
    },
    itemsWithSize(next, prev) {
      const scrollTop = this.$el.scrollTop;
      let prevActiveTop = 0;
      let activeTop = 0;
      const length = Math.min(next.length, prev.length);
      for (let i2 = 0; i2 < length; i2++) {
        if (prevActiveTop >= scrollTop) {
          break;
        }
        prevActiveTop += prev[i2].size || this.minItemSize;
        activeTop += next[i2].size || this.minItemSize;
      }
      const offset2 = activeTop - prevActiveTop;
      if (offset2 === 0) {
        return;
      }
      this.$el.scrollTop += offset2;
    }
  },
  beforeCreate() {
    this.$_updates = [];
    this.$_undefinedSizes = 0;
    this.$_undefinedMap = {};
  },
  activated() {
    this.vscrollData.active = true;
  },
  deactivated() {
    this.vscrollData.active = false;
  },
  methods: {
    onScrollerResize() {
      const scroller = this.$refs.scroller;
      if (scroller) {
        this.forceUpdate();
      }
      this.$emit("resize");
    },
    onScrollerVisible() {
      this.$emit("vscroll:update", {
        force: false
      });
      this.$emit("visible");
    },
    forceUpdate(clear = true) {
      if (clear || this.simpleArray) {
        this.vscrollData.validSizes = {};
      }
      this.$emit("vscroll:update", {
        force: true
      });
    },
    scrollToItem(index2) {
      const scroller = this.$refs.scroller;
      if (scroller)
        scroller.scrollToItem(index2);
    },
    getItemSize(item, index2 = void 0) {
      const id = this.simpleArray ? index2 != null ? index2 : this.items.indexOf(item) : item[this.keyField];
      return this.vscrollData.sizes[id] || 0;
    },
    scrollToBottom() {
      if (this.$_scrollingToBottom)
        return;
      this.$_scrollingToBottom = true;
      const el = this.$el;
      this.$nextTick(() => {
        el.scrollTop = el.scrollHeight + 5e3;
        const cb = () => {
          el.scrollTop = el.scrollHeight + 5e3;
          requestAnimationFrame(() => {
            el.scrollTop = el.scrollHeight + 5e3;
            if (this.$_undefinedSizes === 0) {
              this.$_scrollingToBottom = false;
            } else {
              requestAnimationFrame(cb);
            }
          });
        };
        requestAnimationFrame(cb);
      });
    }
  }
};
const __vue_script__$1 = script$1;
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "RecycleScroller",
    _vm._g(
      _vm._b(
        {
          ref: "scroller",
          attrs: {
            items: _vm.itemsWithSize,
            "min-item-size": _vm.minItemSize,
            direction: _vm.direction,
            "key-field": "id",
            "list-tag": _vm.listTag,
            "item-tag": _vm.itemTag
          },
          on: { resize: _vm.onScrollerResize, visible: _vm.onScrollerVisible },
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function(ref2) {
                  var itemWithSize = ref2.item;
                  var index2 = ref2.index;
                  var active = ref2.active;
                  return [
                    _vm._t("default", null, null, {
                      item: itemWithSize.item,
                      index: index2,
                      active,
                      itemWithSize
                    })
                  ];
                }
              }
            ],
            null,
            true
          )
        },
        "RecycleScroller",
        _vm.$attrs,
        false
      ),
      _vm.listeners
    ),
    [
      _vm._v(" "),
      _c("template", { slot: "before" }, [_vm._t("before")], 2),
      _vm._v(" "),
      _c("template", { slot: "after" }, [_vm._t("after")], 2),
      _vm._v(" "),
      _c("template", { slot: "empty" }, [_vm._t("empty")], 2)
    ],
    2
  );
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
const __vue_inject_styles__$1 = void 0;
const __vue_scope_id__$1 = void 0;
const __vue_module_identifier__$1 = void 0;
const __vue_is_functional_template__$1 = false;
const __vue_component__$1 = /* @__PURE__ */ normalizeComponent(
  { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
  __vue_inject_styles__$1,
  __vue_script__$1,
  __vue_scope_id__$1,
  __vue_is_functional_template__$1,
  __vue_module_identifier__$1,
  false,
  void 0,
  void 0,
  void 0
);
var script = {
  name: "DynamicScrollerItem",
  inject: ["vscrollData", "vscrollParent", "vscrollResizeObserver"],
  props: {
    // eslint-disable-next-line vue/require-prop-types
    item: {
      required: true
    },
    watchData: {
      type: Boolean,
      default: false
    },
    /**
     * Indicates if the view is actively used to display an item.
     */
    active: {
      type: Boolean,
      required: true
    },
    index: {
      type: Number,
      default: void 0
    },
    sizeDependencies: {
      type: [Array, Object],
      default: null
    },
    emitResize: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  computed: {
    id() {
      if (this.vscrollData.simpleArray)
        return this.index;
      if (this.item.hasOwnProperty(this.vscrollData.keyField))
        return this.item[this.vscrollData.keyField];
      throw new Error(`keyField '${this.vscrollData.keyField}' not found in your item. You should set a valid keyField prop on your Scroller`);
    },
    size() {
      return this.vscrollData.validSizes[this.id] && this.vscrollData.sizes[this.id] || 0;
    },
    finalActive() {
      return this.active && this.vscrollData.active;
    }
  },
  watch: {
    watchData: "updateWatchData",
    id() {
      if (!this.size) {
        this.onDataUpdate();
      }
    },
    finalActive(value) {
      if (!this.size) {
        if (value) {
          if (!this.vscrollParent.$_undefinedMap[this.id]) {
            this.vscrollParent.$_undefinedSizes++;
            this.vscrollParent.$_undefinedMap[this.id] = true;
          }
        } else {
          if (this.vscrollParent.$_undefinedMap[this.id]) {
            this.vscrollParent.$_undefinedSizes--;
            this.vscrollParent.$_undefinedMap[this.id] = false;
          }
        }
      }
      if (this.vscrollResizeObserver) {
        if (value) {
          this.observeSize();
        } else {
          this.unobserveSize();
        }
      } else if (value && this.$_pendingVScrollUpdate === this.id) {
        this.updateSize();
      }
    }
  },
  created() {
    if (this.$isServer)
      return;
    this.$_forceNextVScrollUpdate = null;
    this.updateWatchData();
    if (!this.vscrollResizeObserver) {
      for (const k in this.sizeDependencies) {
        this.$watch(() => this.sizeDependencies[k], this.onDataUpdate);
      }
      this.vscrollParent.$on("vscroll:update", this.onVscrollUpdate);
      this.vscrollParent.$on("vscroll:update-size", this.onVscrollUpdateSize);
    }
  },
  mounted() {
    if (this.vscrollData.active) {
      this.updateSize();
      this.observeSize();
    }
  },
  beforeDestroy() {
    this.vscrollParent.$off("vscroll:update", this.onVscrollUpdate);
    this.vscrollParent.$off("vscroll:update-size", this.onVscrollUpdateSize);
    this.unobserveSize();
  },
  methods: {
    updateSize() {
      if (this.finalActive) {
        if (this.$_pendingSizeUpdate !== this.id) {
          this.$_pendingSizeUpdate = this.id;
          this.$_forceNextVScrollUpdate = null;
          this.$_pendingVScrollUpdate = null;
          this.computeSize(this.id);
        }
      } else {
        this.$_forceNextVScrollUpdate = this.id;
      }
    },
    updateWatchData() {
      if (this.watchData && !this.vscrollResizeObserver) {
        this.$_watchData = this.$watch("item", () => {
          this.onDataUpdate();
        }, {
          deep: true
        });
      } else if (this.$_watchData) {
        this.$_watchData();
        this.$_watchData = null;
      }
    },
    onVscrollUpdate({
      force
    }) {
      if (!this.finalActive && force) {
        this.$_pendingVScrollUpdate = this.id;
      }
      if (this.$_forceNextVScrollUpdate === this.id || force || !this.size) {
        this.updateSize();
      }
    },
    onDataUpdate() {
      this.updateSize();
    },
    computeSize(id) {
      this.$nextTick(() => {
        if (this.id === id) {
          const width = this.$el.offsetWidth;
          const height = this.$el.offsetHeight;
          this.applySize(width, height);
        }
        this.$_pendingSizeUpdate = null;
      });
    },
    applySize(width, height) {
      const size = ~~(this.vscrollParent.direction === "vertical" ? height : width);
      if (size && this.size !== size) {
        if (this.vscrollParent.$_undefinedMap[this.id]) {
          this.vscrollParent.$_undefinedSizes--;
          this.vscrollParent.$_undefinedMap[this.id] = void 0;
        }
        this.$set(this.vscrollData.sizes, this.id, size);
        this.$set(this.vscrollData.validSizes, this.id, true);
        if (this.emitResize)
          this.$emit("resize", this.id);
      }
    },
    observeSize() {
      if (!this.vscrollResizeObserver || !this.$el.parentNode)
        return;
      this.vscrollResizeObserver.observe(this.$el.parentNode);
      this.$el.parentNode.addEventListener("resize", this.onResize);
    },
    unobserveSize() {
      if (!this.vscrollResizeObserver)
        return;
      this.vscrollResizeObserver.unobserve(this.$el.parentNode);
      this.$el.parentNode.removeEventListener("resize", this.onResize);
    },
    onResize(event) {
      const {
        width,
        height
      } = event.detail.contentRect;
      this.applySize(width, height);
    }
  },
  render(h) {
    return h(this.tag, this.$slots.default);
  }
};
const __vue_script__ = script;
const __vue_inject_styles__ = void 0;
const __vue_scope_id__ = void 0;
const __vue_module_identifier__ = void 0;
const __vue_is_functional_template__ = void 0;
const __vue_component__ = /* @__PURE__ */ normalizeComponent(
  {},
  __vue_inject_styles__,
  __vue_script__,
  __vue_scope_id__,
  __vue_is_functional_template__,
  __vue_module_identifier__,
  false,
  void 0,
  void 0,
  void 0
);
function registerComponents(Vue2, prefix) {
  Vue2.component(`${prefix}recycle-scroller`, __vue_component__$2);
  Vue2.component(`${prefix}RecycleScroller`, __vue_component__$2);
  Vue2.component(`${prefix}dynamic-scroller`, __vue_component__$1);
  Vue2.component(`${prefix}DynamicScroller`, __vue_component__$1);
  Vue2.component(`${prefix}dynamic-scroller-item`, __vue_component__);
  Vue2.component(`${prefix}DynamicScrollerItem`, __vue_component__);
}
const plugin$1 = {
  // eslint-disable-next-line no-undef
  version: "1.1.2",
  install(Vue2, options) {
    const finalOptions = Object.assign({}, {
      installComponents: true,
      componentsPrefix: ""
    }, options);
    for (const key in finalOptions) {
      if (typeof finalOptions[key] !== "undefined") {
        config[key] = finalOptions[key];
      }
    }
    if (finalOptions.installComponents) {
      registerComponents(Vue2, finalOptions.componentsPrefix);
    }
  }
};
let GlobalVue$1 = null;
if (typeof window !== "undefined") {
  GlobalVue$1 = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue$1 = global.Vue;
}
if (GlobalVue$1) {
  GlobalVue$1.use(plugin$1);
}
const en = {
  cilbee: {
    add: "Add",
    addDestination: "Add this destination?",
    arrived: "Arrived at destination!",
    back: "Back",
    cancel: "Cancel",
    change: "Change",
    changeStartPoint: "Change starting point",
    changeStartPointConfirm: "Would you like to change your starting point to this location?",
    currentTotal: "Current / Total",
    delete: "Delete",
    deleteDestination: "This destination has been added. Delete?",
    destination: "Destination",
    destinationList: "Destination list",
    editDestination: "Edit destination",
    go: "Go",
    guidanceStart: "Guidance start",
    keywordSearch: "Keyword search",
    no: "No",
    noResult: "Route could not be set.\nPlease check your current location, destination, and passage type. Or please speak to the staff of the facility.",
    play: "Play",
    preview: "Preview",
    privacyPolicy: "Privacy policy",
    replay: "Replay",
    returnToPreviousPoint: "Return to previous point",
    scan: "Scan your destination with a QR code",
    scanError: "This QR code does not support",
    searchDestinationAgain: "Search destination again",
    seeRoute: "See route",
    startModalTitle0: "Please select a start point.",
    startModalTitle1: "Cilbee will guide you.",
    startModalTitle2: "Please select a destination.",
    startPoint: "Start point",
    stop: "Stop",
    thankYou: "Thank You!",
    titleOnly: "Title only",
    yes: "Yes"
  }
};
const ja = {
  cilbee: {
    add: "追加",
    addDestination: "この目的地を追加しますか？",
    arrived: "目的地に到着しました！",
    back: "戻る",
    cancel: "キャンセル",
    change: "変更する",
    changeStartPoint: "開始地点を変更",
    changeStartPointConfirm: "開始地点をこの場所に変更しますか？",
    currentTotal: "現在地 / 総距離",
    delete: "削除",
    deleteDestination: "この目的地は追加済です。削除しますか？",
    destination: "目的地",
    destinationList: "目的地リスト",
    editDestination: "目的地編集",
    go: "進む",
    guidanceStart: "案内開始",
    keywordSearch: "キーワード検索",
    no: "いいえ",
    noResult: "経路設定が出来ませんでした。\n現在地と目的地、通路タイプをご確認ください。または施設の係員までお声がけ下さい。",
    play: "再生",
    preview: "経路確認",
    privacyPolicy: "プライバシーポリシー",
    replay: "リプレイ",
    returnToPreviousPoint: "直前の地点へ戻る",
    scan: "目的地をQRコードでスキャンする",
    scanError: "このQRコードは対応していません",
    searchDestinationAgain: "目的地を再検索する",
    seeRoute: "経路を見る",
    startModalTitle0: "開始地点を選択して下さい。",
    startModalTitle1: "目的地を選択して下さい。",
    startModalTitle2: "※複数選択も可能です。",
    startPoint: "開始地点",
    stop: "停止",
    thankYou: "Thank You!",
    titleOnly: "タイトルのみ",
    yes: "はい"
  }
};
const ko = {
  cilbee: {
    add: "추가",
    addDestination: "이 목적지를 추가하시겠습니까?",
    arrived: "목적지에 도착했습니다!",
    back: "돌아가기",
    cancel: "취소",
    change: "변화",
    changeStartPoint: "출발지 변경",
    changeStartPointConfirm: "출발지를 이 위치로 변경하시겠습니까?",
    currentTotal: "현재 위치 / 총 거리",
    delete: "삭제",
    deleteDestination: "이 목적지는 추가되었습니다. 삭제하시겠습니까?",
    destination: "목적지",
    destinationList: "목적지 목록",
    editDestination: "목적지 편집",
    go: "진행",
    guidanceStart: "안내 시작",
    keywordSearch: "키워드 검색",
    no: "아니요",
    noResult: "경로 설정을 할 수 없습니다.\n현재 위치와 목적지, 통로 유형을 확인해 주십시오. 또는 시설의 직원에게 문의해 주시기 바랍니다.",
    play: "재생",
    preview: "미리보기",
    privacyPolicy: "개인 정보 보호 정책",
    replay: "리플레이",
    returnToPreviousPoint: "직전 지점으로 돌아가기",
    scan: "목적지를 QR 코드로 스캔",
    scanError: "이 QR 코드는 지원되지 않습니다",
    searchDestinationAgain: "목적지 재검색하기",
    seeRoute: "경로 보기",
    startModalTitle0: "시작 지점을 선택하십시오",
    startModalTitle1: "Cilbee가 길을 안내합니다",
    startModalTitle2: "목적지를 선택하세요",
    startPoint: "시작점",
    stop: "정지",
    thankYou: "감사합니다!",
    titleOnly: "제목만",
    yes: "예"
  }
};
const zhCN = {
  cilbee: {
    add: "添加",
    addDestination: "您想添加这个目的地吗？",
    arrived: "目的地！",
    back: "返回",
    cancel: "取消",
    change: "改变",
    changeStartPoint: "改变起点",
    changeStartPointConfirm: "您想将起点更改为该位置吗？",
    currentTotal: "当前位置 / 总距离",
    delete: "删除",
    deleteDestination: "此目的地已添加。 要删除吗？",
    destination: "目的地",
    destinationList: "目的地列表",
    editDestination: "编辑目的地",
    go: "前进",
    guidanceStart: "开始指导",
    keywordSearch: "关键词搜索",
    no: "不",
    noResult: "无法设置路线。\n请检查您当前的位置、目的地和路径类型。 或者，请与设施内的工作人员联系。",
    play: "再生",
    preview: "预展",
    privacyPolicy: "隐私政策",
    replay: "重放",
    returnToPreviousPoint: "返回上一点",
    scan: "使用二维码扫描您的目的地",
    scanError: "此二维码不支持",
    searchDestinationAgain: "重新搜索目的地",
    seeRoute: "查看路线",
    startModalTitle0: "选择您的起点",
    startModalTitle1: "Cilbee 将为你指明方向",
    startModalTitle2: "选择目的地",
    startPoint: "起始点",
    stop: "停乐停舞",
    thankYou: "谢谢你",
    titleOnly: "仅有标题",
    yes: "是"
  }
};
const zhTW = {
  cilbee: {
    add: "添加",
    addDestination: "添加這個目的地？",
    arrived: "您已到達目的地！",
    back: "返回",
    cancel: "取消",
    change: "改變",
    changeStartPoint: "改變起點",
    changeStartPointConfirm: "您想將起點變更為該位置嗎？",
    currentTotal: "當前位置 / 總距離",
    delete: "刪除",
    deleteDestination: "該目的地已添加。 刪除？",
    destination: "目的地",
    destinationList: "目的地列表",
    editDestination: "編輯目的地",
    go: "繼續前行",
    guidanceStart: "指導開始",
    keywordSearch: "關鍵詞搜索",
    no: "不",
    noResult: "無法設置路線。 \n請檢查您當前的位置、目的地和通道類型。 或者請諮詢該設施的工作人員。",
    play: "再生產",
    preview: "預覽",
    privacyPolicy: "隱私政策",
    replay: "重播",
    returnToPreviousPoint: "返回上一點",
    scan: "使用二維碼掃描您的目的地",
    scanError: "此二維碼不支持",
    searchDestinationAgain: "再次搜索目的地",
    seeRoute: "查看路線",
    startModalTitle0: "選擇您的起點",
    startModalTitle1: "Cilbee 會指導你",
    startModalTitle2: "請選擇目的地",
    startPoint: "初始點",
    stop: "停止",
    thankYou: "謝謝你！",
    titleOnly: "僅標題",
    yes: "是的"
  }
};
const messages = {
  "en-US": en,
  en,
  ja,
  ko,
  "zh-CN": zhCN,
  "zh-TW": zhTW
};
const matterportStore = /* @__PURE__ */ defineStore("matterport", {
  state: () => ({
    attachmentOpen: null,
    // Mattertagのアタッチメントモーダル
    dockOpen: null,
    // Mattertagの詳細表示UI
    reelOpen: null,
    // ツアーのリールUI
    modalOpen: null,
    // 公式UIのモーダル系（ヘルプ・利用規約）
    measurementsOpen: null,
    // 計測ツールの表示
    iframeSize: null
  }),
  getters: {
    hideDpm(state) {
      return state.modalOpen || state.measurementsOpen || state.attachmentOpen;
    }
  }
});
var render$B = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "d-flex justify-content-end",
    attrs: {
      "id": "dpm-bottom-ui",
      "reel-open": _vm.matterportStore.reelOpen
    }
  }, [_vm.checkShowFullscreenButton && !_vm.dpmStore.global.showVirtualStaging ? _c("div", {
    staticClass: "fullscreen",
    on: {
      "click": _vm.toggleFullScreen
    }
  }, [_vm.fullscreen ? _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiFullscreenExit))]) : _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiFullscreen))])], 1) : _vm._e(), _vm.useMeasurementPrimitive ? _c("div", {
    staticClass: "show-label",
    on: {
      "click": _vm.toggleLabel
    }
  }, [_vm.showLabel ? _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiNumeric))]) : _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiNumericOff))])], 1) : _vm._e()]);
};
var staticRenderFns$B = [];
const __vue2_script$B = {
  data() {
    return {
      fullscreen: false,
      showLabel: true
    };
  },
  created() {
    return __async(this, null, function* () {
      this.fullscreen = location.href.indexOf("fullscreenFrom=1") !== -1;
      document.documentElement.addEventListener("fullscreenchange", (_event) => {
        this.fullscreen = document.fullscreenElement;
      });
    });
  },
  methods: {
    addMarginForOfficialBottomUi() {
      if (this.checkShowFullscreenButton && this.dpmStore.virtualStaging.useMeasurementPrimitive) {
        document.querySelector("iframe#showcase").contentWindow.document.querySelector("#bottom-ui .collapsible-list-items").classList.add("margin-icon-2");
      }
    },
    toggleFullScreen() {
      if (location.href.indexOf("fullscreenFrom=1") !== -1) {
        history.back();
        return;
      }
      if (document.fullscreenEnabled) {
        if (!document.fullscreenElement) {
          document.documentElement.requestFullscreen();
        } else {
          document.exitFullscreen();
        }
      } else {
        if (!this.fullscreen) {
          window.parent.location.href = `${location.href}${location.href.indexOf("?") !== -1 ? "&" : "?"}fullscreenFrom=1&play=1&qs=1`;
        }
      }
    },
    toggleLabel() {
      this.showLabel = !this.showLabel;
      const parentElement = document.querySelector(".css-2d-object-label").parentElement;
      if (this.showLabel) {
        parentElement.style.display = "";
      } else {
        parentElement.style.display = "none";
      }
    }
  },
  computed: __spreadProps(__spreadValues(__spreadValues({}, mapState(useDpmStore, {
    useMeasurementPrimitive: (state) => state.virtualStaging.useMeasurementPrimitive
  })), mapStores(useDpmStore, matterportStore)), {
    checkShowFullscreenButton() {
      return document.fullscreenEnabled || location.href.indexOf("iframe=true") !== -1;
    }
  }),
  watch: {
    useMeasurementPrimitive(newValue, _oldValue) {
      this.addMarginForOfficialBottomUi();
    }
  }
};
const __cssModules$B = {};
var __component__$B = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$B,
  render$B,
  staticRenderFns$B,
  false,
  __vue2_injectStyles$B,
  null,
  null,
  null
);
function __vue2_injectStyles$B(context) {
  for (let o in __cssModules$B) {
    this[o] = __cssModules$B[o];
  }
}
const BottomUi = /* @__PURE__ */ function() {
  return __component__$B.exports;
}();
var baseClone$1 = _baseClone;
var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG$1 = 4;
function cloneDeep(value) {
  return baseClone$1(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG$1);
}
var cloneDeep_1 = cloneDeep;
const _clone$1 = /* @__PURE__ */ getDefaultExportFromCjs(cloneDeep_1);
class SceneComponentPrivate {
}
class SceneComponent extends SceneComponentPrivate {
  constructor() {
    super(...arguments);
    /**
     * An optional dictionary of properties that affects the behavior of the component.
     * The properties can be changed by an external source at any time. It is up to the component to respond appropriately to the changes.
     * The input properties can also be bind targets to another observable source, e.g. the output property of another component.
     */
    __publicField(this, "inputs");
    /**
     * @reserved
     * A dictionary of events that will be handled by this component's `onEvent`. Every component is guaranteed to have all of the `InteractionSelection` keys:
     *  `events[InteractionSelection.CLICK]`, `events[InteractionSelection.HOVER]`, `events[InteractionSelection.DRAG]`
     * Note: registering to receive `InteractionSelection.HOVER` will produce both `InteractionType.HOVER` and `InteractionType.UNHOVER` in `onEvent`.
     */
    // events: Record<string, boolean>;
    /**
     * @reserved
     * A dictionary of events that will be emitted by this component.
     */
    __publicField(this, "emits");
  }
}
var ComponentInteractionType = /* @__PURE__ */ ((ComponentInteractionType2) => {
  ComponentInteractionType2["CLICK"] = "INTERACTION.CLICK";
  ComponentInteractionType2["HOVER"] = "INTERACTION.HOVER";
  ComponentInteractionType2["DRAG"] = "INTERACTION.DRAG";
  ComponentInteractionType2["DRAG_BEGIN"] = "INTERACTION.DRAG_BEGIN";
  ComponentInteractionType2["DRAG_END"] = "INTERACTION.DRAG_END";
  ComponentInteractionType2["POINTER_MOVE"] = "INTERACTION.POINTER_MOVE";
  ComponentInteractionType2["POINTER_BUTTON"] = "INTERACTION.POINTER_BUTTON";
  ComponentInteractionType2["SCROLL"] = "INTERACTION.SCROLL";
  ComponentInteractionType2["KEY"] = "INTERACTION.KEY";
  ComponentInteractionType2["LONG_PRESS_START"] = "INTERACTION.LONG_PRESS_START";
  ComponentInteractionType2["LONG_PRESS_END"] = "INTERACTION.LONG_PRESS_END";
  ComponentInteractionType2["MULTI_SWIPE"] = "INTERACTION.MULTI_SWIPE";
  ComponentInteractionType2["MULTI_SWIPE_END"] = "INTERACTION.MULTI_SWIPE_END";
  ComponentInteractionType2["PINCH"] = "INTERACTION.PINCH";
  ComponentInteractionType2["PINCH_END"] = "INTERACTION.PINCH_END";
  ComponentInteractionType2["ROTATE"] = "INTERACTION.ROTATE";
  ComponentInteractionType2["ROTATE_END"] = "INTERACTION.ROTATE_END";
  return ComponentInteractionType2;
})(ComponentInteractionType || {});
class BalloonComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "geometry");
    __publicField(this, "material");
    __publicField(this, "mesh");
    __publicField(this, "root");
    __publicField(this, "texture");
    __publicField(this, "THREE");
    __publicField(this, "inputs", {
      position: { x: 0, y: 0, z: 0 },
      store: null,
      text: ""
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    return __async(this, null, function* () {
      this.THREE = this.context.three;
      this.root = new this.THREE.Object3D();
      this.outputs.objectRoot = this.root;
      this.outputs.collider = this.root;
      const res = yield fetch("../../../../showcase_assets/cilbee/balloon.svg");
      const data = yield res.text();
      const svgDataURL = "data:image/svg+xml; charset=utf8, " + encodeURIComponent(data);
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = 512;
        canvas.height = 512;
        const ctx = canvas.getContext("2d");
        const fontSize = 40;
        ctx.drawImage(img, 0, 0);
        ctx.font = `${fontSize}px sans-serif`;
        ctx.lineWidth = 10;
        ctx.fillStyle = "#000000";
        const multiText = this.inputs.text.split("\n");
        for (let i2 = 0; i2 < multiText.length; i2++) {
          ctx.fillText(multiText[i2], 50, 100 + fontSize * i2 + fontSize / 2);
        }
        this.texture = new this.THREE.Texture(canvas);
        this.texture.minFilter = this.THREE.LinearFilter;
        this.texture.needsUpdate = true;
        this.geometry = new this.THREE.PlaneGeometry(1, 1);
        this.material = new this.THREE.MeshBasicMaterial({
          depthWrite: false,
          map: this.texture,
          opacity: 1,
          side: this.THREE.DoubleSide,
          transparent: true
        });
        this.mesh = new this.THREE.Mesh(this.geometry, this.material);
        this.root.add(this.mesh);
        this.root.position.set(this.inputs.position.x, this.inputs.position.y, this.inputs.position.z);
        this.context.scene.add(this.root);
      };
      img.src = svgDataURL;
    });
  }
  onTick(_tickDelta) {
    var _a2, _b2;
    if (this.mesh) {
      this.mesh.rotation.setFromRotationMatrix(this.context.camera.matrix);
      if ((_a2 = this.mesh.geometry) == null ? void 0 : _a2.boundingSphere) {
        this.mesh.position.set(-this.mesh.geometry.boundingSphere.center.x, -0.75, 0);
      }
    }
    if ((_b2 = this.inputs.store) == null ? void 0 : _b2.beePosition) {
      if (this.inputs.store.currentMode === "mode.inside") {
        this.root.position.set(this.inputs.store.beePosition.x, this.inputs.store.beePosition.y + 0.225, this.inputs.store.beePosition.z);
        this.root.scale.set(0.15, 0.15, 0.15);
      } else {
        this.root.position.set(this.inputs.store.beePosition.x, this.inputs.store.beePosition.y + 4, this.inputs.store.beePosition.z);
        this.root.scale.set(2.25, 2.25, 2.25);
      }
    }
  }
  onDestroy() {
    this.geometry.dispose();
    this.material.dispose();
    this.texture.dispose();
    this.root.remove(this.mesh);
    this.root.parent.remove(this.root);
  }
  setPosition(position) {
    this.root.position.set(position.x, position.y, position.z);
  }
  setVisibility(visible) {
    this.root.visible = visible;
  }
  updateText(text2) {
  }
}
const balloonType = "dpm.balloon";
const balloonFactory = () => {
  return new BalloonComponent();
};
class CilbeeBeeComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "clips");
    __publicField(this, "light");
    __publicField(this, "lookBackAction");
    __publicField(this, "mixer");
    __publicField(this, "moveAction");
    __publicField(this, "root");
    __publicField(this, "scene");
    __publicField(this, "beeHeight", 1.3);
    __publicField(this, "currentIndex", 0);
    __publicField(this, "distance");
    __publicField(this, "forward", true);
    __publicField(this, "lookBackTimerId");
    __publicField(this, "movingToForward", false);
    __publicField(this, "movingToSweep", false);
    __publicField(this, "previewMode", true);
    __publicField(this, "radian", 0);
    __publicField(this, "rotateClockwise", false);
    __publicField(this, "speed", 1);
    __publicField(this, "timerId", null);
    __publicField(this, "inputs", {
      callback: null,
      passingPoints: [],
      positions: [{ x: 0, y: 0, z: 0 }],
      scale: { x: 0.015, y: 0.015, z: 0.015 },
      store: null
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    return __async(this, null, function* () {
      const sdkThree = this.context.three;
      this.calcRadian();
      this.root = new sdkThree.Object3D();
      this.root.rotation.set(0, this.radian, 0);
      this.root.position.set(this.forwardXPos(), this.inputs.positions[0].y + this.beeHeight, this.forwardZPos());
      this.root.scale.set(this.inputs.scale.x, this.inputs.scale.y, this.inputs.scale.z);
      this.light = new sdkThree.SpotLight(16777215, 0.01, 10, Math.PI / 3, 1, 2);
      this.light.position.set(0, 5, 0);
      this.root.add(this.light);
      this.context.scene.add(this.root);
      this.outputs.objectRoot = this.root;
      this.outputs.collider = this.root;
      new sdkThree.GLTFLoader().load("/showcase_assets/cilbee/bee.glb", (gltf) => {
        this.scene = gltf.scene || gltf.scenes[0];
        this.clips = gltf.animations || [];
        this.light.target = this.scene;
        this.mixer = new AnimationMixer(this.scene);
        this.lookBackAction = this.mixer.clipAction(this.clips[0]);
        this.lookBackAction.setLoop(sdkThree.LoopOnce);
        this.moveAction = this.mixer.clipAction(this.clips[1]);
        this.moveAction.reset().play();
        this.setLookBackTimer();
        this.root.add(this.scene);
      });
    });
  }
  calcDistance(toSweep = true) {
    const nextIndex = this.forward ? this.currentIndex + 1 : this.currentIndex - 1;
    const distination = toSweep ? this.inputs.positions[nextIndex] : { x: this.forwardXPos(), y: this.inputs.positions[this.currentIndex].y, z: this.forwardZPos() };
    const distance = Math.sqrt(
      Math.pow(distination.x - this.root.position.x, 2) + Math.pow(distination.y + this.beeHeight - this.root.position.y, 2) + Math.pow(distination.z - this.root.position.z, 2)
    );
    this.distance = {
      x: (distination.x - this.root.position.x) / (distance * 950),
      y: (distination.y + this.beeHeight - this.root.position.y) / (distance * 950),
      z: (distination.z - this.root.position.z) / (distance * 950)
    };
  }
  calcRadian() {
    if (this.checkStartOrLast()) {
      return;
    }
    this.normalizedAngle();
    if (this.root) {
      this.root.rotation.y = this.radian;
    }
    const oldRadian = this.radian;
    const nextIndex = this.forward ? this.currentIndex + 1 : this.currentIndex - 1;
    this.radian = Math.atan2(
      -(this.inputs.positions[nextIndex].z - this.inputs.positions[this.currentIndex].z),
      this.inputs.positions[nextIndex].x - this.inputs.positions[this.currentIndex].x
    );
    this.normalizedAngle();
    this.rotateClockwise = oldRadian > this.radian;
    if (Math.abs(oldRadian - this.radian) > Math.PI) {
      if (this.radian > 0) {
        this.radian -= 2 * Math.PI;
      } else {
        this.radian += 2 * Math.PI;
      }
      this.rotateClockwise = !this.rotateClockwise;
    }
  }
  checkStartOrLast() {
    return this.forward && this.currentIndex + 1 >= this.inputs.positions.length || !this.forward && this.currentIndex === 0;
  }
  // 蜂はユーザー(sweep)より進行方向に向けて少しだけ前方に位置する
  forwardXPos() {
    return 0.3 * Math.cos(this.radian) + this.inputs.positions[this.currentIndex].x;
  }
  forwardZPos() {
    return -0.3 * Math.sin(this.radian) + this.inputs.positions[this.currentIndex].z;
  }
  getPosition() {
    return this.root.position;
  }
  getRotationY() {
    return MathUtils.radToDeg(this.radian) - 90;
  }
  go(forward, previewMode) {
    this.forward = forward;
    if (this.forward && this.currentIndex + 1 >= this.inputs.positions.length || !this.forward && this.currentIndex === 0) {
      return;
    }
    clearInterval(this.lookBackTimerId);
    this.previewMode = previewMode;
    this.calcRadian();
    this.calcDistance();
    this.movingToSweep = true;
  }
  goToIndex(index2) {
    this.currentIndex = index2;
    this.calcRadian();
    this.root.position.set(this.forwardXPos(), this.inputs.positions[this.currentIndex].y + this.beeHeight, this.forwardZPos());
    if (this.currentIndex === this.inputs.positions.length - 1) {
      this.radian += Math.PI;
      if (this.radian > 2 * Math.PI) {
        this.radian -= 2 * Math.PI;
        this.root.rotation.y -= 2 * Math.PI;
      }
      this.root.rotation.y = this.radian;
      this.inputs.callback.beeArrivedAtSweep(this.currentIndex, true);
    }
  }
  isMoving() {
    return this.movingToSweep || this.movingToForward;
  }
  lookback() {
    if (this.timerId) {
      return;
    }
    this.lookBackAction.reset().play().fadeIn(1);
    this.moveAction.fadeOut(1);
    this.timerId = setTimeout(() => {
      this.moveAction.reset().play().fadeIn(1);
      this.timerId = null;
    }, 4e3);
  }
  normalizedAngle() {
    let tmp = (MathUtils.radToDeg(this.radian) + 180) % 360 - 180;
    if (tmp < -180) {
      tmp += 360;
    }
    this.radian = MathUtils.degToRad(tmp);
  }
  setDirection(forward) {
    this.forward = forward;
    this.calcRadian();
  }
  setLookBackTimer() {
    this.lookBackTimerId = setInterval(() => {
      if (!this.isMoving()) {
        this.lookback();
      }
    }, 1e4);
  }
  setScale(scale) {
    this.root.scale.set(scale, scale, scale);
  }
  reset() {
    this.previewMode = false;
    this.currentIndex = 0;
    this.forward = true;
    this.movingToForward = false;
    this.movingToSweep = false;
    this.radian = 0;
    this.calcRadian();
    this.root.rotation.set(0, this.radian, 0);
    this.root.position.set(this.forwardXPos(), this.inputs.positions[0].y + this.beeHeight, this.forwardZPos());
  }
  setSpeed(speed) {
    this.speed = speed;
  }
  onEvent(type, _data) {
    if (type === ComponentInteractionType.CLICK && !this.isMoving()) {
      this.lookback();
    }
  }
  onTick(tickDelta) {
    if (this.mixer) {
      this.mixer.update(tickDelta / 1e3);
    }
    if (this.isMoving()) {
      this.root.position.x += this.distance.x * this.speed * tickDelta;
      this.root.position.y += this.distance.y * this.speed * tickDelta;
      this.root.position.z += this.distance.z * this.speed * tickDelta;
    }
    if (this.movingToSweep) {
      const nextIndex = this.forward ? this.currentIndex + 1 : this.currentIndex - 1;
      if (this.distance.x >= 0 && this.root.position.x > this.inputs.positions[nextIndex].x || this.distance.x < 0 && this.root.position.x < this.inputs.positions[nextIndex].x) {
        this.root.position.set(this.inputs.positions[nextIndex].x, this.inputs.positions[nextIndex].y + this.beeHeight, this.inputs.positions[nextIndex].z);
        this.root.rotation.y = this.radian;
        this.currentIndex = nextIndex;
        this.movingToSweep = false;
        this.calcRadian();
        this.calcDistance(false);
        this.movingToForward = true;
      }
    }
    if (this.movingToForward) {
      if (this.distance.x >= 0 && this.root.position.x > this.forwardXPos() || this.distance.x < 0 && this.root.position.x < this.forwardXPos()) {
        this.root.position.set(this.forwardXPos(), this.inputs.positions[this.currentIndex].y + this.beeHeight, this.forwardZPos());
        this.movingToForward = false;
        this.calcRadian();
        if (this.checkStartOrLast()) {
          this.radian += Math.PI;
          if (this.radian > 2 * Math.PI) {
            this.radian -= 2 * Math.PI;
            this.root.rotation.y -= 2 * Math.PI;
          }
          if (this.previewMode) {
            this.inputs.callback.beeArrivedAtSweepInPreview(this.currentIndex, true);
          } else {
            if (this.currentIndex === this.inputs.positions.length - 1) {
              this.inputs.callback.beeArrivedAtSweep(this.currentIndex, true);
            } else {
              this.inputs.callback.beeArrivedAtSweep(this.currentIndex, false);
            }
          }
        } else {
          if (this.previewMode) {
            if (this.inputs.passingPoints.includes(this.currentIndex)) {
              if (this.rotateClockwise) {
                this.radian -= 4 * Math.PI;
              } else {
                this.radian += 4 * Math.PI;
              }
              this.inputs.callback.beeArrivedAtSweepInPreview(this.currentIndex, false);
              setTimeout(() => {
                this.calcDistance();
                this.movingToSweep = true;
              }, 3e3);
            } else {
              this.calcDistance();
              this.movingToSweep = true;
              this.inputs.callback.beeArrivedAtSweepInPreview(this.currentIndex, false);
            }
          } else {
            this.setLookBackTimer();
            this.inputs.callback.beeArrivedAtSweep(this.currentIndex, false);
          }
        }
      }
    }
    if (this.rotateClockwise) {
      if (this.root.rotation.y > this.radian) {
        this.root.rotation.y -= 5e-3 * tickDelta;
        if (this.root.rotation.y < this.radian) {
          this.root.rotation.y = this.radian;
        }
      }
    } else {
      if (this.root.rotation.y < this.radian) {
        this.root.rotation.y += 5e-3 * tickDelta;
        if (this.root.rotation.y > this.radian) {
          this.root.rotation.y = this.radian;
        }
      }
    }
    this.inputs.store.beePosition = this.root.position;
  }
  onDestroy() {
    var _a2;
    this.light.dispose();
    this.root.remove(this.light);
    this.root.remove(this.scene);
    (_a2 = this.root.parent) == null ? void 0 : _a2.remove(this.root);
  }
}
const cilbeeBeeType = "dpm.cilbeeBee";
const cilbeeBeeFactory = () => {
  return new CilbeeBeeComponent();
};
var colorString$1 = { exports: {} };
var colorName = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};
var simpleSwizzle = { exports: {} };
var isArrayish$1 = function isArrayish(obj) {
  if (!obj || typeof obj === "string") {
    return false;
  }
  return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};
var isArrayish2 = isArrayish$1;
var concat = Array.prototype.concat;
var slice = Array.prototype.slice;
var swizzle$1 = simpleSwizzle.exports = function swizzle(args) {
  var results = [];
  for (var i2 = 0, len = args.length; i2 < len; i2++) {
    var arg = args[i2];
    if (isArrayish2(arg)) {
      results = concat.call(results, slice.call(arg));
    } else {
      results.push(arg);
    }
  }
  return results;
};
swizzle$1.wrap = function(fn) {
  return function() {
    return fn(swizzle$1(arguments));
  };
};
var simpleSwizzleExports = simpleSwizzle.exports;
var colorNames = colorName;
var swizzle2 = simpleSwizzleExports;
var hasOwnProperty = Object.hasOwnProperty;
var reverseNames = /* @__PURE__ */ Object.create(null);
for (var name in colorNames) {
  if (hasOwnProperty.call(colorNames, name)) {
    reverseNames[colorNames[name]] = name;
  }
}
var cs = colorString$1.exports = {
  to: {},
  get: {}
};
cs.get = function(string) {
  var prefix = string.substring(0, 3).toLowerCase();
  var val;
  var model;
  switch (prefix) {
    case "hsl":
      val = cs.get.hsl(string);
      model = "hsl";
      break;
    case "hwb":
      val = cs.get.hwb(string);
      model = "hwb";
      break;
    default:
      val = cs.get.rgb(string);
      model = "rgb";
      break;
  }
  if (!val) {
    return null;
  }
  return { model, value: val };
};
cs.get.rgb = function(string) {
  if (!string) {
    return null;
  }
  var abbr = /^#([a-f0-9]{3,4})$/i;
  var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
  var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
  var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
  var keyword = /^(\w+)$/;
  var rgb = [0, 0, 0, 1];
  var match;
  var i2;
  var hexAlpha;
  if (match = string.match(hex)) {
    hexAlpha = match[2];
    match = match[1];
    for (i2 = 0; i2 < 3; i2++) {
      var i22 = i2 * 2;
      rgb[i2] = parseInt(match.slice(i22, i22 + 2), 16);
    }
    if (hexAlpha) {
      rgb[3] = parseInt(hexAlpha, 16) / 255;
    }
  } else if (match = string.match(abbr)) {
    match = match[1];
    hexAlpha = match[3];
    for (i2 = 0; i2 < 3; i2++) {
      rgb[i2] = parseInt(match[i2] + match[i2], 16);
    }
    if (hexAlpha) {
      rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    }
  } else if (match = string.match(rgba)) {
    for (i2 = 0; i2 < 3; i2++) {
      rgb[i2] = parseInt(match[i2 + 1], 0);
    }
    if (match[4]) {
      if (match[5]) {
        rgb[3] = parseFloat(match[4]) * 0.01;
      } else {
        rgb[3] = parseFloat(match[4]);
      }
    }
  } else if (match = string.match(per)) {
    for (i2 = 0; i2 < 3; i2++) {
      rgb[i2] = Math.round(parseFloat(match[i2 + 1]) * 2.55);
    }
    if (match[4]) {
      if (match[5]) {
        rgb[3] = parseFloat(match[4]) * 0.01;
      } else {
        rgb[3] = parseFloat(match[4]);
      }
    }
  } else if (match = string.match(keyword)) {
    if (match[1] === "transparent") {
      return [0, 0, 0, 0];
    }
    if (!hasOwnProperty.call(colorNames, match[1])) {
      return null;
    }
    rgb = colorNames[match[1]];
    rgb[3] = 1;
    return rgb;
  } else {
    return null;
  }
  for (i2 = 0; i2 < 3; i2++) {
    rgb[i2] = clamp$1(rgb[i2], 0, 255);
  }
  rgb[3] = clamp$1(rgb[3], 0, 1);
  return rgb;
};
cs.get.hsl = function(string) {
  if (!string) {
    return null;
  }
  var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
  var match = string.match(hsl);
  if (match) {
    var alpha = parseFloat(match[4]);
    var h = (parseFloat(match[1]) % 360 + 360) % 360;
    var s2 = clamp$1(parseFloat(match[2]), 0, 100);
    var l = clamp$1(parseFloat(match[3]), 0, 100);
    var a = clamp$1(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, s2, l, a];
  }
  return null;
};
cs.get.hwb = function(string) {
  if (!string) {
    return null;
  }
  var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
  var match = string.match(hwb);
  if (match) {
    var alpha = parseFloat(match[4]);
    var h = (parseFloat(match[1]) % 360 + 360) % 360;
    var w = clamp$1(parseFloat(match[2]), 0, 100);
    var b = clamp$1(parseFloat(match[3]), 0, 100);
    var a = clamp$1(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, w, b, a];
  }
  return null;
};
cs.to.hex = function() {
  var rgba = swizzle2(arguments);
  return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : "");
};
cs.to.rgb = function() {
  var rgba = swizzle2(arguments);
  return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
cs.to.rgb.percent = function() {
  var rgba = swizzle2(arguments);
  var r = Math.round(rgba[0] / 255 * 100);
  var g = Math.round(rgba[1] / 255 * 100);
  var b = Math.round(rgba[2] / 255 * 100);
  return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
cs.to.hsl = function() {
  var hsla = swizzle2(arguments);
  return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
cs.to.hwb = function() {
  var hwba = swizzle2(arguments);
  var a = "";
  if (hwba.length >= 4 && hwba[3] !== 1) {
    a = ", " + hwba[3];
  }
  return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
cs.to.keyword = function(rgb) {
  return reverseNames[rgb.slice(0, 3)];
};
function clamp$1(num, min2, max2) {
  return Math.min(Math.max(min2, num), max2);
}
function hexDouble(num) {
  var str = Math.round(num).toString(16).toUpperCase();
  return str.length < 2 ? "0" + str : str;
}
var colorStringExports = colorString$1.exports;
const cssKeywords = colorName;
const reverseKeywords = {};
for (const key of Object.keys(cssKeywords)) {
  reverseKeywords[cssKeywords[key]] = key;
}
const convert$2 = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
var conversions$2 = convert$2;
for (const model of Object.keys(convert$2)) {
  if (!("channels" in convert$2[model])) {
    throw new Error("missing channels property: " + model);
  }
  if (!("labels" in convert$2[model])) {
    throw new Error("missing channel labels property: " + model);
  }
  if (convert$2[model].labels.length !== convert$2[model].channels) {
    throw new Error("channel and label counts mismatch: " + model);
  }
  const { channels, labels } = convert$2[model];
  delete convert$2[model].channels;
  delete convert$2[model].labels;
  Object.defineProperty(convert$2[model], "channels", { value: channels });
  Object.defineProperty(convert$2[model], "labels", { value: labels });
}
convert$2.rgb.hsl = function(rgb) {
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const min2 = Math.min(r, g, b);
  const max2 = Math.max(r, g, b);
  const delta = max2 - min2;
  let h;
  let s2;
  if (max2 === min2) {
    h = 0;
  } else if (r === max2) {
    h = (g - b) / delta;
  } else if (g === max2) {
    h = 2 + (b - r) / delta;
  } else if (b === max2) {
    h = 4 + (r - g) / delta;
  }
  h = Math.min(h * 60, 360);
  if (h < 0) {
    h += 360;
  }
  const l = (min2 + max2) / 2;
  if (max2 === min2) {
    s2 = 0;
  } else if (l <= 0.5) {
    s2 = delta / (max2 + min2);
  } else {
    s2 = delta / (2 - max2 - min2);
  }
  return [h, s2 * 100, l * 100];
};
convert$2.rgb.hsv = function(rgb) {
  let rdif;
  let gdif;
  let bdif;
  let h;
  let s2;
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const v = Math.max(r, g, b);
  const diff = v - Math.min(r, g, b);
  const diffc = function(c) {
    return (v - c) / 6 / diff + 1 / 2;
  };
  if (diff === 0) {
    h = 0;
    s2 = 0;
  } else {
    s2 = diff / v;
    rdif = diffc(r);
    gdif = diffc(g);
    bdif = diffc(b);
    if (r === v) {
      h = bdif - gdif;
    } else if (g === v) {
      h = 1 / 3 + rdif - bdif;
    } else if (b === v) {
      h = 2 / 3 + gdif - rdif;
    }
    if (h < 0) {
      h += 1;
    } else if (h > 1) {
      h -= 1;
    }
  }
  return [
    h * 360,
    s2 * 100,
    v * 100
  ];
};
convert$2.rgb.hwb = function(rgb) {
  const r = rgb[0];
  const g = rgb[1];
  let b = rgb[2];
  const h = convert$2.rgb.hsl(rgb)[0];
  const w = 1 / 255 * Math.min(r, Math.min(g, b));
  b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
  return [h, w * 100, b * 100];
};
convert$2.rgb.cmyk = function(rgb) {
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const k = Math.min(1 - r, 1 - g, 1 - b);
  const c = (1 - r - k) / (1 - k) || 0;
  const m = (1 - g - k) / (1 - k) || 0;
  const y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
};
function comparativeDistance(x2, y) {
  return __pow(x2[0] - y[0], 2) + __pow(x2[1] - y[1], 2) + __pow(x2[2] - y[2], 2);
}
convert$2.rgb.keyword = function(rgb) {
  const reversed = reverseKeywords[rgb];
  if (reversed) {
    return reversed;
  }
  let currentClosestDistance = Infinity;
  let currentClosestKeyword;
  for (const keyword of Object.keys(cssKeywords)) {
    const value = cssKeywords[keyword];
    const distance = comparativeDistance(rgb, value);
    if (distance < currentClosestDistance) {
      currentClosestDistance = distance;
      currentClosestKeyword = keyword;
    }
  }
  return currentClosestKeyword;
};
convert$2.keyword.rgb = function(keyword) {
  return cssKeywords[keyword];
};
convert$2.rgb.xyz = function(rgb) {
  let r = rgb[0] / 255;
  let g = rgb[1] / 255;
  let b = rgb[2] / 255;
  r = r > 0.04045 ? __pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
  g = g > 0.04045 ? __pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
  b = b > 0.04045 ? __pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
  const x2 = r * 0.4124 + g * 0.3576 + b * 0.1805;
  const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
  const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
  return [x2 * 100, y * 100, z * 100];
};
convert$2.rgb.lab = function(rgb) {
  const xyz = convert$2.rgb.xyz(rgb);
  let x2 = xyz[0];
  let y = xyz[1];
  let z = xyz[2];
  x2 /= 95.047;
  y /= 100;
  z /= 108.883;
  x2 = x2 > 8856e-6 ? __pow(x2, 1 / 3) : 7.787 * x2 + 16 / 116;
  y = y > 8856e-6 ? __pow(y, 1 / 3) : 7.787 * y + 16 / 116;
  z = z > 8856e-6 ? __pow(z, 1 / 3) : 7.787 * z + 16 / 116;
  const l = 116 * y - 16;
  const a = 500 * (x2 - y);
  const b = 200 * (y - z);
  return [l, a, b];
};
convert$2.hsl.rgb = function(hsl) {
  const h = hsl[0] / 360;
  const s2 = hsl[1] / 100;
  const l = hsl[2] / 100;
  let t22;
  let t3;
  let val;
  if (s2 === 0) {
    val = l * 255;
    return [val, val, val];
  }
  if (l < 0.5) {
    t22 = l * (1 + s2);
  } else {
    t22 = l + s2 - l * s2;
  }
  const t1 = 2 * l - t22;
  const rgb = [0, 0, 0];
  for (let i2 = 0; i2 < 3; i2++) {
    t3 = h + 1 / 3 * -(i2 - 1);
    if (t3 < 0) {
      t3++;
    }
    if (t3 > 1) {
      t3--;
    }
    if (6 * t3 < 1) {
      val = t1 + (t22 - t1) * 6 * t3;
    } else if (2 * t3 < 1) {
      val = t22;
    } else if (3 * t3 < 2) {
      val = t1 + (t22 - t1) * (2 / 3 - t3) * 6;
    } else {
      val = t1;
    }
    rgb[i2] = val * 255;
  }
  return rgb;
};
convert$2.hsl.hsv = function(hsl) {
  const h = hsl[0];
  let s2 = hsl[1] / 100;
  let l = hsl[2] / 100;
  let smin = s2;
  const lmin = Math.max(l, 0.01);
  l *= 2;
  s2 *= l <= 1 ? l : 2 - l;
  smin *= lmin <= 1 ? lmin : 2 - lmin;
  const v = (l + s2) / 2;
  const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s2 / (l + s2);
  return [h, sv * 100, v * 100];
};
convert$2.hsv.rgb = function(hsv) {
  const h = hsv[0] / 60;
  const s2 = hsv[1] / 100;
  let v = hsv[2] / 100;
  const hi = Math.floor(h) % 6;
  const f = h - Math.floor(h);
  const p = 255 * v * (1 - s2);
  const q = 255 * v * (1 - s2 * f);
  const t3 = 255 * v * (1 - s2 * (1 - f));
  v *= 255;
  switch (hi) {
    case 0:
      return [v, t3, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t3];
    case 3:
      return [p, q, v];
    case 4:
      return [t3, p, v];
    case 5:
      return [v, p, q];
  }
};
convert$2.hsv.hsl = function(hsv) {
  const h = hsv[0];
  const s2 = hsv[1] / 100;
  const v = hsv[2] / 100;
  const vmin = Math.max(v, 0.01);
  let sl;
  let l;
  l = (2 - s2) * v;
  const lmin = (2 - s2) * vmin;
  sl = s2 * vmin;
  sl /= lmin <= 1 ? lmin : 2 - lmin;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
};
convert$2.hwb.rgb = function(hwb) {
  const h = hwb[0] / 360;
  let wh = hwb[1] / 100;
  let bl = hwb[2] / 100;
  const ratio = wh + bl;
  let f;
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }
  const i2 = Math.floor(6 * h);
  const v = 1 - bl;
  f = 6 * h - i2;
  if ((i2 & 1) !== 0) {
    f = 1 - f;
  }
  const n2 = wh + f * (v - wh);
  let r;
  let g;
  let b;
  switch (i2) {
    default:
    case 6:
    case 0:
      r = v;
      g = n2;
      b = wh;
      break;
    case 1:
      r = n2;
      g = v;
      b = wh;
      break;
    case 2:
      r = wh;
      g = v;
      b = n2;
      break;
    case 3:
      r = wh;
      g = n2;
      b = v;
      break;
    case 4:
      r = n2;
      g = wh;
      b = v;
      break;
    case 5:
      r = v;
      g = wh;
      b = n2;
      break;
  }
  return [r * 255, g * 255, b * 255];
};
convert$2.cmyk.rgb = function(cmyk) {
  const c = cmyk[0] / 100;
  const m = cmyk[1] / 100;
  const y = cmyk[2] / 100;
  const k = cmyk[3] / 100;
  const r = 1 - Math.min(1, c * (1 - k) + k);
  const g = 1 - Math.min(1, m * (1 - k) + k);
  const b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
};
convert$2.xyz.rgb = function(xyz) {
  const x2 = xyz[0] / 100;
  const y = xyz[1] / 100;
  const z = xyz[2] / 100;
  let r;
  let g;
  let b;
  r = x2 * 3.2406 + y * -1.5372 + z * -0.4986;
  g = x2 * -0.9689 + y * 1.8758 + z * 0.0415;
  b = x2 * 0.0557 + y * -0.204 + z * 1.057;
  r = r > 31308e-7 ? 1.055 * __pow(r, 1 / 2.4) - 0.055 : r * 12.92;
  g = g > 31308e-7 ? 1.055 * __pow(g, 1 / 2.4) - 0.055 : g * 12.92;
  b = b > 31308e-7 ? 1.055 * __pow(b, 1 / 2.4) - 0.055 : b * 12.92;
  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);
  return [r * 255, g * 255, b * 255];
};
convert$2.xyz.lab = function(xyz) {
  let x2 = xyz[0];
  let y = xyz[1];
  let z = xyz[2];
  x2 /= 95.047;
  y /= 100;
  z /= 108.883;
  x2 = x2 > 8856e-6 ? __pow(x2, 1 / 3) : 7.787 * x2 + 16 / 116;
  y = y > 8856e-6 ? __pow(y, 1 / 3) : 7.787 * y + 16 / 116;
  z = z > 8856e-6 ? __pow(z, 1 / 3) : 7.787 * z + 16 / 116;
  const l = 116 * y - 16;
  const a = 500 * (x2 - y);
  const b = 200 * (y - z);
  return [l, a, b];
};
convert$2.lab.xyz = function(lab) {
  const l = lab[0];
  const a = lab[1];
  const b = lab[2];
  let x2;
  let y;
  let z;
  y = (l + 16) / 116;
  x2 = a / 500 + y;
  z = y - b / 200;
  const y2 = __pow(y, 3);
  const x22 = __pow(x2, 3);
  const z2 = __pow(z, 3);
  y = y2 > 8856e-6 ? y2 : (y - 16 / 116) / 7.787;
  x2 = x22 > 8856e-6 ? x22 : (x2 - 16 / 116) / 7.787;
  z = z2 > 8856e-6 ? z2 : (z - 16 / 116) / 7.787;
  x2 *= 95.047;
  y *= 100;
  z *= 108.883;
  return [x2, y, z];
};
convert$2.lab.lch = function(lab) {
  const l = lab[0];
  const a = lab[1];
  const b = lab[2];
  let h;
  const hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  const c = Math.sqrt(a * a + b * b);
  return [l, c, h];
};
convert$2.lch.lab = function(lch) {
  const l = lch[0];
  const c = lch[1];
  const h = lch[2];
  const hr = h / 360 * 2 * Math.PI;
  const a = c * Math.cos(hr);
  const b = c * Math.sin(hr);
  return [l, a, b];
};
convert$2.rgb.ansi16 = function(args, saturation = null) {
  const [r, g, b] = args;
  let value = saturation === null ? convert$2.rgb.hsv(args)[2] : saturation;
  value = Math.round(value / 50);
  if (value === 0) {
    return 30;
  }
  let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
  if (value === 2) {
    ansi += 60;
  }
  return ansi;
};
convert$2.hsv.ansi16 = function(args) {
  return convert$2.rgb.ansi16(convert$2.hsv.rgb(args), args[2]);
};
convert$2.rgb.ansi256 = function(args) {
  const r = args[0];
  const g = args[1];
  const b = args[2];
  if (r === g && g === b) {
    if (r < 8) {
      return 16;
    }
    if (r > 248) {
      return 231;
    }
    return Math.round((r - 8) / 247 * 24) + 232;
  }
  const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
  return ansi;
};
convert$2.ansi16.rgb = function(args) {
  let color2 = args % 10;
  if (color2 === 0 || color2 === 7) {
    if (args > 50) {
      color2 += 3.5;
    }
    color2 = color2 / 10.5 * 255;
    return [color2, color2, color2];
  }
  const mult = (~~(args > 50) + 1) * 0.5;
  const r = (color2 & 1) * mult * 255;
  const g = (color2 >> 1 & 1) * mult * 255;
  const b = (color2 >> 2 & 1) * mult * 255;
  return [r, g, b];
};
convert$2.ansi256.rgb = function(args) {
  if (args >= 232) {
    const c = (args - 232) * 10 + 8;
    return [c, c, c];
  }
  args -= 16;
  let rem;
  const r = Math.floor(args / 36) / 5 * 255;
  const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
  const b = rem % 6 / 5 * 255;
  return [r, g, b];
};
convert$2.rgb.hex = function(args) {
  const integer = ((Math.round(args[0]) & 255) << 16) + ((Math.round(args[1]) & 255) << 8) + (Math.round(args[2]) & 255);
  const string = integer.toString(16).toUpperCase();
  return "000000".substring(string.length) + string;
};
convert$2.hex.rgb = function(args) {
  const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!match) {
    return [0, 0, 0];
  }
  let colorString2 = match[0];
  if (match[0].length === 3) {
    colorString2 = colorString2.split("").map((char) => {
      return char + char;
    }).join("");
  }
  const integer = parseInt(colorString2, 16);
  const r = integer >> 16 & 255;
  const g = integer >> 8 & 255;
  const b = integer & 255;
  return [r, g, b];
};
convert$2.rgb.hcg = function(rgb) {
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const max2 = Math.max(Math.max(r, g), b);
  const min2 = Math.min(Math.min(r, g), b);
  const chroma = max2 - min2;
  let grayscale;
  let hue;
  if (chroma < 1) {
    grayscale = min2 / (1 - chroma);
  } else {
    grayscale = 0;
  }
  if (chroma <= 0) {
    hue = 0;
  } else if (max2 === r) {
    hue = (g - b) / chroma % 6;
  } else if (max2 === g) {
    hue = 2 + (b - r) / chroma;
  } else {
    hue = 4 + (r - g) / chroma;
  }
  hue /= 6;
  hue %= 1;
  return [hue * 360, chroma * 100, grayscale * 100];
};
convert$2.hsl.hcg = function(hsl) {
  const s2 = hsl[1] / 100;
  const l = hsl[2] / 100;
  const c = l < 0.5 ? 2 * s2 * l : 2 * s2 * (1 - l);
  let f = 0;
  if (c < 1) {
    f = (l - 0.5 * c) / (1 - c);
  }
  return [hsl[0], c * 100, f * 100];
};
convert$2.hsv.hcg = function(hsv) {
  const s2 = hsv[1] / 100;
  const v = hsv[2] / 100;
  const c = s2 * v;
  let f = 0;
  if (c < 1) {
    f = (v - c) / (1 - c);
  }
  return [hsv[0], c * 100, f * 100];
};
convert$2.hcg.rgb = function(hcg) {
  const h = hcg[0] / 360;
  const c = hcg[1] / 100;
  const g = hcg[2] / 100;
  if (c === 0) {
    return [g * 255, g * 255, g * 255];
  }
  const pure = [0, 0, 0];
  const hi = h % 1 * 6;
  const v = hi % 1;
  const w = 1 - v;
  let mg = 0;
  switch (Math.floor(hi)) {
    case 0:
      pure[0] = 1;
      pure[1] = v;
      pure[2] = 0;
      break;
    case 1:
      pure[0] = w;
      pure[1] = 1;
      pure[2] = 0;
      break;
    case 2:
      pure[0] = 0;
      pure[1] = 1;
      pure[2] = v;
      break;
    case 3:
      pure[0] = 0;
      pure[1] = w;
      pure[2] = 1;
      break;
    case 4:
      pure[0] = v;
      pure[1] = 0;
      pure[2] = 1;
      break;
    default:
      pure[0] = 1;
      pure[1] = 0;
      pure[2] = w;
  }
  mg = (1 - c) * g;
  return [
    (c * pure[0] + mg) * 255,
    (c * pure[1] + mg) * 255,
    (c * pure[2] + mg) * 255
  ];
};
convert$2.hcg.hsv = function(hcg) {
  const c = hcg[1] / 100;
  const g = hcg[2] / 100;
  const v = c + g * (1 - c);
  let f = 0;
  if (v > 0) {
    f = c / v;
  }
  return [hcg[0], f * 100, v * 100];
};
convert$2.hcg.hsl = function(hcg) {
  const c = hcg[1] / 100;
  const g = hcg[2] / 100;
  const l = g * (1 - c) + 0.5 * c;
  let s2 = 0;
  if (l > 0 && l < 0.5) {
    s2 = c / (2 * l);
  } else if (l >= 0.5 && l < 1) {
    s2 = c / (2 * (1 - l));
  }
  return [hcg[0], s2 * 100, l * 100];
};
convert$2.hcg.hwb = function(hcg) {
  const c = hcg[1] / 100;
  const g = hcg[2] / 100;
  const v = c + g * (1 - c);
  return [hcg[0], (v - c) * 100, (1 - v) * 100];
};
convert$2.hwb.hcg = function(hwb) {
  const w = hwb[1] / 100;
  const b = hwb[2] / 100;
  const v = 1 - b;
  const c = v - w;
  let g = 0;
  if (c < 1) {
    g = (v - c) / (1 - c);
  }
  return [hwb[0], c * 100, g * 100];
};
convert$2.apple.rgb = function(apple) {
  return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
};
convert$2.rgb.apple = function(rgb) {
  return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
};
convert$2.gray.rgb = function(args) {
  return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};
convert$2.gray.hsl = function(args) {
  return [0, 0, args[0]];
};
convert$2.gray.hsv = convert$2.gray.hsl;
convert$2.gray.hwb = function(gray) {
  return [0, 100, gray[0]];
};
convert$2.gray.cmyk = function(gray) {
  return [0, 0, 0, gray[0]];
};
convert$2.gray.lab = function(gray) {
  return [gray[0], 0, 0];
};
convert$2.gray.hex = function(gray) {
  const val = Math.round(gray[0] / 100 * 255) & 255;
  const integer = (val << 16) + (val << 8) + val;
  const string = integer.toString(16).toUpperCase();
  return "000000".substring(string.length) + string;
};
convert$2.rgb.gray = function(rgb) {
  const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
  return [val / 255 * 100];
};
const conversions$1 = conversions$2;
function buildGraph() {
  const graph = {};
  const models2 = Object.keys(conversions$1);
  for (let len = models2.length, i2 = 0; i2 < len; i2++) {
    graph[models2[i2]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  }
  return graph;
}
function deriveBFS(fromModel) {
  const graph = buildGraph();
  const queue2 = [fromModel];
  graph[fromModel].distance = 0;
  while (queue2.length) {
    const current = queue2.pop();
    const adjacents = Object.keys(conversions$1[current]);
    for (let len = adjacents.length, i2 = 0; i2 < len; i2++) {
      const adjacent = adjacents[i2];
      const node2 = graph[adjacent];
      if (node2.distance === -1) {
        node2.distance = graph[current].distance + 1;
        node2.parent = current;
        queue2.unshift(adjacent);
      }
    }
  }
  return graph;
}
function link(from, to) {
  return function(args) {
    return to(from(args));
  };
}
function wrapConversion(toModel, graph) {
  const path = [graph[toModel].parent, toModel];
  let fn = conversions$1[graph[toModel].parent][toModel];
  let cur = graph[toModel].parent;
  while (graph[cur].parent) {
    path.unshift(graph[cur].parent);
    fn = link(conversions$1[graph[cur].parent][cur], fn);
    cur = graph[cur].parent;
  }
  fn.conversion = path;
  return fn;
}
var route$1 = function(fromModel) {
  const graph = deriveBFS(fromModel);
  const conversion = {};
  const models2 = Object.keys(graph);
  for (let len = models2.length, i2 = 0; i2 < len; i2++) {
    const toModel = models2[i2];
    const node2 = graph[toModel];
    if (node2.parent === null) {
      continue;
    }
    conversion[toModel] = wrapConversion(toModel, graph);
  }
  return conversion;
};
const conversions = conversions$2;
const route = route$1;
const convert$1 = {};
const models = Object.keys(conversions);
function wrapRaw(fn) {
  const wrappedFn = function(...args) {
    const arg0 = args[0];
    if (arg0 === void 0 || arg0 === null) {
      return arg0;
    }
    if (arg0.length > 1) {
      args = arg0;
    }
    return fn(args);
  };
  if ("conversion" in fn) {
    wrappedFn.conversion = fn.conversion;
  }
  return wrappedFn;
}
function wrapRounded(fn) {
  const wrappedFn = function(...args) {
    const arg0 = args[0];
    if (arg0 === void 0 || arg0 === null) {
      return arg0;
    }
    if (arg0.length > 1) {
      args = arg0;
    }
    const result2 = fn(args);
    if (typeof result2 === "object") {
      for (let len = result2.length, i2 = 0; i2 < len; i2++) {
        result2[i2] = Math.round(result2[i2]);
      }
    }
    return result2;
  };
  if ("conversion" in fn) {
    wrappedFn.conversion = fn.conversion;
  }
  return wrappedFn;
}
models.forEach((fromModel) => {
  convert$1[fromModel] = {};
  Object.defineProperty(convert$1[fromModel], "channels", { value: conversions[fromModel].channels });
  Object.defineProperty(convert$1[fromModel], "labels", { value: conversions[fromModel].labels });
  const routes = route(fromModel);
  const routeModels = Object.keys(routes);
  routeModels.forEach((toModel) => {
    const fn = routes[toModel];
    convert$1[fromModel][toModel] = wrapRounded(fn);
    convert$1[fromModel][toModel].raw = wrapRaw(fn);
  });
});
var colorConvert = convert$1;
const colorString = colorStringExports;
const convert = colorConvert;
const skippedModels = [
  // To be honest, I don't really feel like keyword belongs in color convert, but eh.
  "keyword",
  // Gray conflicts with some method names, and has its own method defined.
  "gray",
  // Shouldn't really be in color-convert either...
  "hex"
];
const hashedModelKeys = {};
for (const model of Object.keys(convert)) {
  hashedModelKeys[[...convert[model].labels].sort().join("")] = model;
}
const limiters = {};
function Color2(object, model) {
  if (!(this instanceof Color2)) {
    return new Color2(object, model);
  }
  if (model && model in skippedModels) {
    model = null;
  }
  if (model && !(model in convert)) {
    throw new Error("Unknown model: " + model);
  }
  let i2;
  let channels;
  if (object == null) {
    this.model = "rgb";
    this.color = [0, 0, 0];
    this.valpha = 1;
  } else if (object instanceof Color2) {
    this.model = object.model;
    this.color = [...object.color];
    this.valpha = object.valpha;
  } else if (typeof object === "string") {
    const result2 = colorString.get(object);
    if (result2 === null) {
      throw new Error("Unable to parse color from string: " + object);
    }
    this.model = result2.model;
    channels = convert[this.model].channels;
    this.color = result2.value.slice(0, channels);
    this.valpha = typeof result2.value[channels] === "number" ? result2.value[channels] : 1;
  } else if (object.length > 0) {
    this.model = model || "rgb";
    channels = convert[this.model].channels;
    const newArray = Array.prototype.slice.call(object, 0, channels);
    this.color = zeroArray(newArray, channels);
    this.valpha = typeof object[channels] === "number" ? object[channels] : 1;
  } else if (typeof object === "number") {
    this.model = "rgb";
    this.color = [
      object >> 16 & 255,
      object >> 8 & 255,
      object & 255
    ];
    this.valpha = 1;
  } else {
    this.valpha = 1;
    const keys2 = Object.keys(object);
    if ("alpha" in object) {
      keys2.splice(keys2.indexOf("alpha"), 1);
      this.valpha = typeof object.alpha === "number" ? object.alpha : 0;
    }
    const hashedKeys = keys2.sort().join("");
    if (!(hashedKeys in hashedModelKeys)) {
      throw new Error("Unable to parse color from object: " + JSON.stringify(object));
    }
    this.model = hashedModelKeys[hashedKeys];
    const { labels } = convert[this.model];
    const color2 = [];
    for (i2 = 0; i2 < labels.length; i2++) {
      color2.push(object[labels[i2]]);
    }
    this.color = zeroArray(color2);
  }
  if (limiters[this.model]) {
    channels = convert[this.model].channels;
    for (i2 = 0; i2 < channels; i2++) {
      const limit = limiters[this.model][i2];
      if (limit) {
        this.color[i2] = limit(this.color[i2]);
      }
    }
  }
  this.valpha = Math.max(0, Math.min(1, this.valpha));
  if (Object.freeze) {
    Object.freeze(this);
  }
}
Color2.prototype = {
  toString() {
    return this.string();
  },
  toJSON() {
    return this[this.model]();
  },
  string(places) {
    let self2 = this.model in colorString.to ? this : this.rgb();
    self2 = self2.round(typeof places === "number" ? places : 1);
    const args = self2.valpha === 1 ? self2.color : [...self2.color, this.valpha];
    return colorString.to[self2.model](args);
  },
  percentString(places) {
    const self2 = this.rgb().round(typeof places === "number" ? places : 1);
    const args = self2.valpha === 1 ? self2.color : [...self2.color, this.valpha];
    return colorString.to.rgb.percent(args);
  },
  array() {
    return this.valpha === 1 ? [...this.color] : [...this.color, this.valpha];
  },
  object() {
    const result2 = {};
    const { channels } = convert[this.model];
    const { labels } = convert[this.model];
    for (let i2 = 0; i2 < channels; i2++) {
      result2[labels[i2]] = this.color[i2];
    }
    if (this.valpha !== 1) {
      result2.alpha = this.valpha;
    }
    return result2;
  },
  unitArray() {
    const rgb = this.rgb().color;
    rgb[0] /= 255;
    rgb[1] /= 255;
    rgb[2] /= 255;
    if (this.valpha !== 1) {
      rgb.push(this.valpha);
    }
    return rgb;
  },
  unitObject() {
    const rgb = this.rgb().object();
    rgb.r /= 255;
    rgb.g /= 255;
    rgb.b /= 255;
    if (this.valpha !== 1) {
      rgb.alpha = this.valpha;
    }
    return rgb;
  },
  round(places) {
    places = Math.max(places || 0, 0);
    return new Color2([...this.color.map(roundToPlace(places)), this.valpha], this.model);
  },
  alpha(value) {
    if (value !== void 0) {
      return new Color2([...this.color, Math.max(0, Math.min(1, value))], this.model);
    }
    return this.valpha;
  },
  // Rgb
  red: getset("rgb", 0, maxfn(255)),
  green: getset("rgb", 1, maxfn(255)),
  blue: getset("rgb", 2, maxfn(255)),
  hue: getset(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, (value) => (value % 360 + 360) % 360),
  saturationl: getset("hsl", 1, maxfn(100)),
  lightness: getset("hsl", 2, maxfn(100)),
  saturationv: getset("hsv", 1, maxfn(100)),
  value: getset("hsv", 2, maxfn(100)),
  chroma: getset("hcg", 1, maxfn(100)),
  gray: getset("hcg", 2, maxfn(100)),
  white: getset("hwb", 1, maxfn(100)),
  wblack: getset("hwb", 2, maxfn(100)),
  cyan: getset("cmyk", 0, maxfn(100)),
  magenta: getset("cmyk", 1, maxfn(100)),
  yellow: getset("cmyk", 2, maxfn(100)),
  black: getset("cmyk", 3, maxfn(100)),
  x: getset("xyz", 0, maxfn(95.047)),
  y: getset("xyz", 1, maxfn(100)),
  z: getset("xyz", 2, maxfn(108.833)),
  l: getset("lab", 0, maxfn(100)),
  a: getset("lab", 1),
  b: getset("lab", 2),
  keyword(value) {
    if (value !== void 0) {
      return new Color2(value);
    }
    return convert[this.model].keyword(this.color);
  },
  hex(value) {
    if (value !== void 0) {
      return new Color2(value);
    }
    return colorString.to.hex(this.rgb().round().color);
  },
  hexa(value) {
    if (value !== void 0) {
      return new Color2(value);
    }
    const rgbArray = this.rgb().round().color;
    let alphaHex = Math.round(this.valpha * 255).toString(16).toUpperCase();
    if (alphaHex.length === 1) {
      alphaHex = "0" + alphaHex;
    }
    return colorString.to.hex(rgbArray) + alphaHex;
  },
  rgbNumber() {
    const rgb = this.rgb().color;
    return (rgb[0] & 255) << 16 | (rgb[1] & 255) << 8 | rgb[2] & 255;
  },
  luminosity() {
    const rgb = this.rgb().color;
    const lum = [];
    for (const [i2, element] of rgb.entries()) {
      const chan = element / 255;
      lum[i2] = chan <= 0.04045 ? chan / 12.92 : __pow((chan + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
  },
  contrast(color2) {
    const lum1 = this.luminosity();
    const lum2 = color2.luminosity();
    if (lum1 > lum2) {
      return (lum1 + 0.05) / (lum2 + 0.05);
    }
    return (lum2 + 0.05) / (lum1 + 0.05);
  },
  level(color2) {
    const contrastRatio = this.contrast(color2);
    if (contrastRatio >= 7) {
      return "AAA";
    }
    return contrastRatio >= 4.5 ? "AA" : "";
  },
  isDark() {
    const rgb = this.rgb().color;
    const yiq = (rgb[0] * 2126 + rgb[1] * 7152 + rgb[2] * 722) / 1e4;
    return yiq < 128;
  },
  isLight() {
    return !this.isDark();
  },
  negate() {
    const rgb = this.rgb();
    for (let i2 = 0; i2 < 3; i2++) {
      rgb.color[i2] = 255 - rgb.color[i2];
    }
    return rgb;
  },
  lighten(ratio) {
    const hsl = this.hsl();
    hsl.color[2] += hsl.color[2] * ratio;
    return hsl;
  },
  darken(ratio) {
    const hsl = this.hsl();
    hsl.color[2] -= hsl.color[2] * ratio;
    return hsl;
  },
  saturate(ratio) {
    const hsl = this.hsl();
    hsl.color[1] += hsl.color[1] * ratio;
    return hsl;
  },
  desaturate(ratio) {
    const hsl = this.hsl();
    hsl.color[1] -= hsl.color[1] * ratio;
    return hsl;
  },
  whiten(ratio) {
    const hwb = this.hwb();
    hwb.color[1] += hwb.color[1] * ratio;
    return hwb;
  },
  blacken(ratio) {
    const hwb = this.hwb();
    hwb.color[2] += hwb.color[2] * ratio;
    return hwb;
  },
  grayscale() {
    const rgb = this.rgb().color;
    const value = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
    return Color2.rgb(value, value, value);
  },
  fade(ratio) {
    return this.alpha(this.valpha - this.valpha * ratio);
  },
  opaquer(ratio) {
    return this.alpha(this.valpha + this.valpha * ratio);
  },
  rotate(degrees) {
    const hsl = this.hsl();
    let hue = hsl.color[0];
    hue = (hue + degrees) % 360;
    hue = hue < 0 ? 360 + hue : hue;
    hsl.color[0] = hue;
    return hsl;
  },
  mix(mixinColor, weight) {
    if (!mixinColor || !mixinColor.rgb) {
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
    }
    const color1 = mixinColor.rgb();
    const color2 = this.rgb();
    const p = weight === void 0 ? 0.5 : weight;
    const w = 2 * p - 1;
    const a = color1.alpha() - color2.alpha();
    const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
    const w2 = 1 - w1;
    return Color2.rgb(
      w1 * color1.red() + w2 * color2.red(),
      w1 * color1.green() + w2 * color2.green(),
      w1 * color1.blue() + w2 * color2.blue(),
      color1.alpha() * p + color2.alpha() * (1 - p)
    );
  }
};
for (const model of Object.keys(convert)) {
  if (skippedModels.includes(model)) {
    continue;
  }
  const { channels } = convert[model];
  Color2.prototype[model] = function(...args) {
    if (this.model === model) {
      return new Color2(this);
    }
    if (args.length > 0) {
      return new Color2(args, model);
    }
    return new Color2([...assertArray(convert[this.model][model].raw(this.color)), this.valpha], model);
  };
  Color2[model] = function(...args) {
    let color2 = args[0];
    if (typeof color2 === "number") {
      color2 = zeroArray(args, channels);
    }
    return new Color2(color2, model);
  };
}
function roundTo(number, places) {
  return Number(number.toFixed(places));
}
function roundToPlace(places) {
  return function(number) {
    return roundTo(number, places);
  };
}
function getset(model, channel, modifier) {
  model = Array.isArray(model) ? model : [model];
  for (const m of model) {
    (limiters[m] || (limiters[m] = []))[channel] = modifier;
  }
  model = model[0];
  return function(value) {
    let result2;
    if (value !== void 0) {
      if (modifier) {
        value = modifier(value);
      }
      result2 = this[model]();
      result2.color[channel] = value;
      return result2;
    }
    result2 = this[model]().color[channel];
    if (modifier) {
      result2 = modifier(result2);
    }
    return result2;
  };
}
function maxfn(max2) {
  return function(v) {
    return Math.max(0, Math.min(max2, v));
  };
}
function assertArray(value) {
  return Array.isArray(value) ? value : [value];
}
function zeroArray(array, length) {
  for (let i2 = 0; i2 < length; i2++) {
    if (typeof array[i2] !== "number") {
      array[i2] = 0;
    }
  }
  return array;
}
var color = Color2;
const Color$1 = /* @__PURE__ */ getDefaultExportFromCjs(color);
const createTextMesh = (THREE, txt, hWorldTxt, hWorldAll, hPxTxt, fontColor = "#ffffff", borderColor = "#778899") => {
  const kPxToWorld = hWorldTxt / hPxTxt;
  const hPxAll = Math.ceil(hWorldAll / kPxToWorld);
  const txtcanvas = document.createElement("canvas");
  const ctx = txtcanvas.getContext("2d");
  ctx.font = `${hPxTxt}px sans-serif`;
  const wPxTxt = ctx.measureText(txt).width;
  const wWorldTxt = wPxTxt * kPxToWorld;
  const wWorldAll = wWorldTxt + (hWorldAll - hWorldTxt);
  const wPxAll = Math.ceil(wWorldAll / kPxToWorld);
  txtcanvas.width = wPxAll;
  txtcanvas.height = hPxAll;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.font = `${hPxTxt}px sans-serif`;
  ctx.lineWidth = 10;
  ctx.fillStyle = borderColor;
  ctx.strokeText(txt, wPxAll / 2, hPxAll / 2);
  ctx.fillStyle = fontColor;
  ctx.fillText(txt, wPxAll / 2, hPxAll / 2);
  const texture = new THREE.Texture(txtcanvas);
  texture.minFilter = THREE.LinearFilter;
  texture.needsUpdate = true;
  const geometry = new THREE.PlaneGeometry(wWorldAll, hWorldAll);
  const material = new THREE.MeshBasicMaterial({
    depthWrite: false,
    map: texture,
    opacity: 1,
    side: THREE.DoubleSide,
    transparent: true
  });
  const mesh = new THREE.Mesh(geometry, material);
  return mesh;
};
class CilbeeDestinationComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "count", 0);
    __publicField(this, "geometories", []);
    __publicField(this, "labelMesh");
    __publicField(this, "materials", []);
    __publicField(this, "meshes", []);
    __publicField(this, "root");
    // FIXME: src/types/Three.d.tsにちゃんと書けば動きそうだけどdistでエラーが出るのでanyを入れている…
    // private svgGroup: THREE.Group
    __publicField(this, "svgGroup");
    __publicField(this, "THREE");
    __publicField(this, "inputs", {
      floor: 0,
      label: "",
      position: { x: 0, y: 0, z: 0 },
      svg: ""
    });
  }
  onInit() {
    this.THREE = this.context.three;
    this.root = new this.THREE.Object3D();
    this.outputs.objectRoot = this.root;
    this.outputs.collider = this.root;
    const svgLoader = new this.THREE.SVGLoader();
    const svgData = svgLoader.parse(this.inputs.svg);
    this.svgGroup = new this.THREE.Group();
    svgData.paths.forEach((path, _i2) => {
      const shapes = this.THREE.SVGLoader.createShapes(path);
      const fillColor = Color$1(path.userData.style.fill);
      shapes.forEach((shape, _j) => {
        const material = new this.THREE.MeshBasicMaterial({
          color: new this.THREE.Color().setStyle(fillColor.hex()),
          opacity: fillColor.valpha,
          side: this.THREE.DoubleSide,
          depthWrite: false,
          transparent: true
        });
        const geometry = new this.THREE.ShapeGeometry(shape);
        const mesh = new this.THREE.Mesh(geometry, material);
        mesh.renderOrder = 1;
        this.meshes.push(mesh);
        this.geometories.push(geometry);
        this.materials.push(material);
        this.svgGroup.add(mesh);
      });
    });
    this.svgGroup.scale.set(0.05, 0.05, 0.05);
    this.svgGroup.rotation.set(0, Math.PI, Math.PI);
    this.root.position.set(this.inputs.position.x, this.inputs.position.y + 2, this.inputs.position.z);
    this.root.add(this.svgGroup);
    this.labelMesh = createTextMesh(this.THREE, this.inputs.label, 0.2, 0.25, 100);
    this.root.add(this.labelMesh);
    this.context.scene.add(this.root);
  }
  onTick(_tickDelta) {
    var _a2, _b2;
    this.root.rotation.setFromRotationMatrix(this.context.camera.matrix);
    if ((_b2 = (_a2 = this.labelMesh) == null ? void 0 : _a2.geometry) == null ? void 0 : _b2.boundingSphere) {
      this.labelMesh.position.set(-this.labelMesh.geometry.boundingSphere.center.x, 0.2, 0);
    }
    if (this.svgGroup) {
      this.svgGroup.children.forEach((childMesh) => {
        var _a3, _b3;
        childMesh.position.set(-((_b3 = (_a3 = childMesh.geometry) == null ? void 0 : _a3.boundingSphere) == null ? void 0 : _b3.center.x) || 0, Math.sin(MathUtils.degToRad(this.count)) * 3, 0);
      });
      this.count += 3;
      if (this.count >= 360) {
        this.count = 0;
      }
    }
  }
  onDestroy() {
    this.labelMesh.material.dispose();
    this.labelMesh.geometry.dispose();
    this.geometories.forEach((geometory) => geometory.dispose());
    this.materials.forEach((material) => material.dispose());
    this.root.remove(this.labelMesh);
    this.root.remove(this.svgGroup);
    this.root.parent.remove(this.root);
  }
  setScale(scale) {
    this.root.scale.set(scale, scale, scale);
    this.root.position.set(this.inputs.position.x, this.inputs.position.y + scale + 1, this.inputs.position.z);
  }
  setOpacity(floor) {
    if (floor === this.inputs.floor) {
      this.labelMesh.material.opacity = 1;
      this.materials.forEach((material) => material.opacity = 1);
    } else {
      this.labelMesh.material.opacity = 0.15;
      this.materials.forEach((material) => material.opacity = 0.15);
    }
  }
}
const cilbeeDestinationType = "dpm.cilbeeDestination";
const cilbeeDestinationFactory = () => {
  return new CilbeeDestinationComponent();
};
class CilbeeRouteLineComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "THREE", null);
    __publicField(this, "root", null);
    __publicField(this, "geometries", []);
    __publicField(this, "baseMaterials", []);
    __publicField(this, "materials", []);
    __publicField(this, "meshes", []);
    __publicField(this, "baseTextures", []);
    __publicField(this, "textures", []);
    __publicField(this, "time", 0);
    __publicField(this, "inputs", {
      colorIndex: 0,
      endIndex: 0,
      startIndex: 0,
      sweeps: [{
        floor: 0,
        position: { x: 0, y: 0, z: 0 }
      }]
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    return __async(this, null, function* () {
      this.THREE = this.context.three;
      this.root = new this.THREE.Object3D();
      this.context.scene.add(this.root);
      this.outputs.objectRoot = this.root;
      this.outputs.collider = this.root;
      const lineHeight = 0;
      const indices = [0, 1, 2, 2, 1, 3];
      const colorNames2 = ["red", "blue", "green", "cyan", "magenta", "yellow", "pink", "lime", "indigo", "gray", "goldenrod", "brown"];
      const colorName2 = this.inputs.colorIndex < 12 ? colorNames2[this.inputs.colorIndex] : colorNames2[this.inputs.colorIndex % 12];
      const color2 = new this.THREE.Color(colorName2);
      const margin = 0.15;
      for (let i2 = 0; i2 < this.inputs.sweeps.length - 1; i2++) {
        const current = this.inputs.sweeps[i2].position;
        const target2 = this.inputs.sweeps[i2 + 1].position;
        const distance = Math.sqrt(
          Math.pow(Math.abs(target2.z - current.z), 2) + Math.pow(Math.abs(target2.x - current.x), 2) + Math.pow(Math.abs(target2.y - current.y), 2)
        );
        const ratio = margin / distance;
        const baseContext = document.createElement("canvas").getContext("2d");
        baseContext.canvas.width = 128;
        baseContext.canvas.height = 128;
        const gradient = baseContext.createLinearGradient(0, 0, 128, 0);
        gradient.addColorStop(0, `rgba(${color2.r * 255}, ${color2.g * 255}, ${color2.b * 255}, 0)`);
        gradient.addColorStop(ratio, `rgba(${color2.r * 255}, ${color2.g * 255}, ${color2.b * 255}, 1)`);
        gradient.addColorStop(1 - ratio, `rgba(${color2.r * 255}, ${color2.g * 255}, ${color2.b * 255}, 1)`);
        gradient.addColorStop(1, `rgba(${color2.r * 255}, ${color2.g * 255}, ${color2.b * 255}, 0)`);
        baseContext.fillStyle = gradient;
        baseContext.fillRect(0, 0, 128, 128);
        const baseTexture = new this.THREE.CanvasTexture(baseContext.canvas);
        baseTexture.wrapS = this.THREE.RepeatWrapping;
        baseTexture.wrapT = this.THREE.RepeatWrapping;
        this.baseTextures.push(baseTexture);
        const baseMaterial = new this.THREE.MeshBasicMaterial({
          map: baseTexture,
          opacity: 0.5,
          side: this.THREE.DoubleSide,
          transparent: true
        });
        this.baseMaterials.push(baseMaterial);
        const arrowContext = document.createElement("canvas").getContext("2d");
        arrowContext.canvas.width = 128;
        arrowContext.canvas.height = 128;
        arrowContext.translate(64, 64);
        arrowContext.fillStyle = "white";
        arrowContext.textAlign = "center";
        arrowContext.textBaseline = "middle";
        arrowContext.font = "96px sans-serif";
        arrowContext.fillText("➡︎", 0, 0);
        const arrowTexture = new this.THREE.CanvasTexture(arrowContext.canvas);
        arrowTexture.wrapS = this.THREE.RepeatWrapping;
        arrowTexture.wrapT = this.THREE.RepeatWrapping;
        arrowTexture.repeat.x = (distance - margin * 2) * 2;
        arrowTexture.repeat.y = 1;
        this.textures.push(arrowTexture);
        const arrowMaterial = new this.THREE.MeshBasicMaterial({
          map: arrowTexture,
          opacity: 0.5,
          side: this.THREE.DoubleSide,
          transparent: true
        });
        this.materials.push(arrowMaterial);
        const geometry = new this.THREE.PlaneGeometry();
        geometry.setFromPoints(this.createVertices(distance - margin * 2));
        geometry.setIndex(indices);
        const radian = Math.atan2(-(target2.z - current.z), target2.x - current.x);
        this.geometries.push(geometry);
        const baseMesh = new this.THREE.Mesh(geometry, baseMaterial);
        baseMesh.frustumCulled = false;
        baseMesh.position.set(margin * Math.cos(radian) + current.x, current.y + lineHeight, -margin * Math.sin(radian) + current.z);
        baseMesh.lookAt(target2.x, target2.y + lineHeight, target2.z);
        this.root.add(baseMesh);
        this.meshes.push(baseMesh);
        const arrowMesh = new this.THREE.Mesh(geometry, arrowMaterial);
        arrowMesh.frustumCulled = false;
        arrowMesh.position.set(margin * Math.cos(radian) + current.x, current.y + lineHeight + 0.01, -margin * Math.sin(radian) + current.z);
        arrowMesh.lookAt(target2.x, target2.y + lineHeight, target2.z);
        this.root.add(arrowMesh);
        this.meshes.push(arrowMesh);
      }
    });
  }
  createVertices(distance) {
    const startSize = 0.2;
    return [
      new this.THREE.Vector3(-startSize, 0, 0),
      new this.THREE.Vector3(-startSize, 0, distance),
      new this.THREE.Vector3(startSize, 0, 0),
      new this.THREE.Vector3(startSize, 0, distance)
    ];
  }
  setOpacity(floor, passing) {
    for (let i2 = 0; i2 < this.inputs.sweeps.length - 1; i2++) {
      if (this.inputs.sweeps[i2].floor === floor && passing) {
        this.baseMaterials[i2].opacity = 0.75;
        this.materials[i2].opacity = 0.75;
      } else {
        this.baseMaterials[i2].opacity = 0.1;
        this.materials[i2].opacity = 0.1;
      }
    }
  }
  onTick(tickDelta) {
    this.time -= tickDelta;
    this.textures.forEach((texture) => {
      texture.offset.x = this.time / 1e3 % 1;
    });
  }
  onDestroy() {
    this.meshes.forEach((mesh) => this.root.remove(mesh));
    this.geometries.forEach((geometry) => geometry.dispose());
    this.baseMaterials.forEach((material) => material.dispose());
    this.materials.forEach((material) => material.dispose());
    this.baseTextures.forEach((texture) => texture.dispose());
    this.textures.forEach((texture) => texture.dispose());
    this.root.parent.remove(this.root);
  }
}
const cilbeeRouteLineType = "dpm.cilbeeRouteLine";
const cilbeeRouteLineFactory = () => {
  return new CilbeeRouteLineComponent();
};
class LabelComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "labelMesh");
    __publicField(this, "root");
    __publicField(this, "THREE");
    __publicField(this, "inputs", {
      label: "",
      position: { x: 0, y: 0, z: 0 }
    });
  }
  onInit() {
    this.THREE = this.context.three;
    this.root = new this.THREE.Object3D();
    this.outputs.objectRoot = this.root;
    this.outputs.collider = this.root;
    this.labelMesh = createTextMesh(this.THREE, this.inputs.label || "目的地", 0.05, 0.075, 100);
    this.root.add(this.labelMesh);
    this.root.position.set(this.inputs.position.x, this.inputs.position.y, this.inputs.position.z);
    this.context.scene.add(this.root);
  }
  onTick(_tickDelta) {
    var _a2, _b2;
    this.root.rotation.setFromRotationMatrix(this.context.camera.matrix);
    if ((_b2 = (_a2 = this.labelMesh) == null ? void 0 : _a2.geometry) == null ? void 0 : _b2.boundingSphere) {
      this.labelMesh.position.set(-this.labelMesh.geometry.boundingSphere.center.x, 0, 0);
    }
  }
  onDestroy() {
    this.labelMesh.geometry.dispose();
    this.root.remove(this.labelMesh);
    this.root.parent.remove(this.root);
  }
}
const labelType = "dpm.label";
const labelFactory = () => {
  return new LabelComponent();
};
var esmEntry$1 = { exports: {} };
var defaults$5 = { exports: {} };
function getDefaults$1() {
  return {
    baseUrl: null,
    breaks: false,
    extensions: null,
    gfm: true,
    headerIds: true,
    headerPrefix: "",
    highlight: null,
    langPrefix: "language-",
    mangle: true,
    pedantic: false,
    renderer: null,
    sanitize: false,
    sanitizer: null,
    silent: false,
    smartLists: false,
    smartypants: false,
    tokenizer: null,
    walkTokens: null,
    xhtml: false
  };
}
function changeDefaults$1(newDefaults) {
  defaults$5.exports.defaults = newDefaults;
}
defaults$5.exports = {
  defaults: getDefaults$1(),
  getDefaults: getDefaults$1,
  changeDefaults: changeDefaults$1
};
const escapeTest = /[&<>"']/;
const escapeReplace = /[&<>"']/g;
const escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
const escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;
const escapeReplacements = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
const getEscapeReplacement = (ch) => escapeReplacements[ch];
function escape$3(html, encode2) {
  if (encode2) {
    if (escapeTest.test(html)) {
      return html.replace(escapeReplace, getEscapeReplacement);
    }
  } else {
    if (escapeTestNoEncode.test(html)) {
      return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
    }
  }
  return html;
}
const unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function unescape$1(html) {
  return html.replace(unescapeTest, (_, n2) => {
    n2 = n2.toLowerCase();
    if (n2 === "colon")
      return ":";
    if (n2.charAt(0) === "#") {
      return n2.charAt(1) === "x" ? String.fromCharCode(parseInt(n2.substring(2), 16)) : String.fromCharCode(+n2.substring(1));
    }
    return "";
  });
}
const caret = /(^|[^\[])\^/g;
function edit$1(regex, opt) {
  regex = regex.source || regex;
  opt = opt || "";
  const obj = {
    replace: (name, val) => {
      val = val.source || val;
      val = val.replace(caret, "$1");
      regex = regex.replace(name, val);
      return obj;
    },
    getRegex: () => {
      return new RegExp(regex, opt);
    }
  };
  return obj;
}
const nonWordAndColonTest = /[^\w:]/g;
const originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
function cleanUrl$1(sanitize, base, href) {
  if (sanitize) {
    let prot;
    try {
      prot = decodeURIComponent(unescape$1(href)).replace(nonWordAndColonTest, "").toLowerCase();
    } catch (e) {
      return null;
    }
    if (prot.indexOf("javascript:") === 0 || prot.indexOf("vbscript:") === 0 || prot.indexOf("data:") === 0) {
      return null;
    }
  }
  if (base && !originIndependentUrl.test(href)) {
    href = resolveUrl(base, href);
  }
  try {
    href = encodeURI(href).replace(/%25/g, "%");
  } catch (e) {
    return null;
  }
  return href;
}
const baseUrls = {};
const justDomain = /^[^:]+:\/*[^/]*$/;
const protocol = /^([^:]+:)[\s\S]*$/;
const domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
function resolveUrl(base, href) {
  if (!baseUrls[" " + base]) {
    if (justDomain.test(base)) {
      baseUrls[" " + base] = base + "/";
    } else {
      baseUrls[" " + base] = rtrim$1(base, "/", true);
    }
  }
  base = baseUrls[" " + base];
  const relativeBase = base.indexOf(":") === -1;
  if (href.substring(0, 2) === "//") {
    if (relativeBase) {
      return href;
    }
    return base.replace(protocol, "$1") + href;
  } else if (href.charAt(0) === "/") {
    if (relativeBase) {
      return href;
    }
    return base.replace(domain, "$1") + href;
  } else {
    return base + href;
  }
}
const noopTest$1 = { exec: function noopTest() {
} };
function merge$2(obj) {
  let i2 = 1, target2, key;
  for (; i2 < arguments.length; i2++) {
    target2 = arguments[i2];
    for (key in target2) {
      if (Object.prototype.hasOwnProperty.call(target2, key)) {
        obj[key] = target2[key];
      }
    }
  }
  return obj;
}
function splitCells$1(tableRow, count) {
  const row = tableRow.replace(/\|/g, (match, offset2, str) => {
    let escaped = false, curr = offset2;
    while (--curr >= 0 && str[curr] === "\\")
      escaped = !escaped;
    if (escaped) {
      return "|";
    } else {
      return " |";
    }
  }), cells = row.split(/ \|/);
  let i2 = 0;
  if (!cells[0].trim()) {
    cells.shift();
  }
  if (!cells[cells.length - 1].trim()) {
    cells.pop();
  }
  if (cells.length > count) {
    cells.splice(count);
  } else {
    while (cells.length < count)
      cells.push("");
  }
  for (; i2 < cells.length; i2++) {
    cells[i2] = cells[i2].trim().replace(/\\\|/g, "|");
  }
  return cells;
}
function rtrim$1(str, c, invert) {
  const l = str.length;
  if (l === 0) {
    return "";
  }
  let suffLen = 0;
  while (suffLen < l) {
    const currChar = str.charAt(l - suffLen - 1);
    if (currChar === c && !invert) {
      suffLen++;
    } else if (currChar !== c && invert) {
      suffLen++;
    } else {
      break;
    }
  }
  return str.substr(0, l - suffLen);
}
function findClosingBracket$1(str, b) {
  if (str.indexOf(b[1]) === -1) {
    return -1;
  }
  const l = str.length;
  let level = 0, i2 = 0;
  for (; i2 < l; i2++) {
    if (str[i2] === "\\") {
      i2++;
    } else if (str[i2] === b[0]) {
      level++;
    } else if (str[i2] === b[1]) {
      level--;
      if (level < 0) {
        return i2;
      }
    }
  }
  return -1;
}
function checkSanitizeDeprecation$1(opt) {
  if (opt && opt.sanitize && !opt.silent) {
    console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
  }
}
function repeatString$1(pattern, count) {
  if (count < 1) {
    return "";
  }
  let result2 = "";
  while (count > 1) {
    if (count & 1) {
      result2 += pattern;
    }
    count >>= 1;
    pattern += pattern;
  }
  return result2 + pattern;
}
var helpers = {
  escape: escape$3,
  unescape: unescape$1,
  edit: edit$1,
  cleanUrl: cleanUrl$1,
  resolveUrl,
  noopTest: noopTest$1,
  merge: merge$2,
  splitCells: splitCells$1,
  rtrim: rtrim$1,
  findClosingBracket: findClosingBracket$1,
  checkSanitizeDeprecation: checkSanitizeDeprecation$1,
  repeatString: repeatString$1
};
const { defaults: defaults$4 } = defaults$5.exports;
const {
  rtrim,
  splitCells,
  escape: escape$2,
  findClosingBracket
} = helpers;
function outputLink(cap, link2, raw, lexer) {
  const href = link2.href;
  const title = link2.title ? escape$2(link2.title) : null;
  const text2 = cap[1].replace(/\\([\[\]])/g, "$1");
  if (cap[0].charAt(0) !== "!") {
    lexer.state.inLink = true;
    const token = {
      type: "link",
      raw,
      href,
      title,
      text: text2,
      tokens: lexer.inlineTokens(text2, [])
    };
    lexer.state.inLink = false;
    return token;
  } else {
    return {
      type: "image",
      raw,
      href,
      title,
      text: escape$2(text2)
    };
  }
}
function indentCodeCompensation(raw, text2) {
  const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
  if (matchIndentToCode === null) {
    return text2;
  }
  const indentToCode = matchIndentToCode[1];
  return text2.split("\n").map((node2) => {
    const matchIndentInNode = node2.match(/^\s+/);
    if (matchIndentInNode === null) {
      return node2;
    }
    const [indentInNode] = matchIndentInNode;
    if (indentInNode.length >= indentToCode.length) {
      return node2.slice(indentToCode.length);
    }
    return node2;
  }).join("\n");
}
var Tokenizer_1$1 = class Tokenizer {
  constructor(options) {
    this.options = options || defaults$4;
  }
  space(src) {
    const cap = this.rules.block.newline.exec(src);
    if (cap) {
      if (cap[0].length > 1) {
        return {
          type: "space",
          raw: cap[0]
        };
      }
      return { raw: "\n" };
    }
  }
  code(src) {
    const cap = this.rules.block.code.exec(src);
    if (cap) {
      const text2 = cap[0].replace(/^ {1,4}/gm, "");
      return {
        type: "code",
        raw: cap[0],
        codeBlockStyle: "indented",
        text: !this.options.pedantic ? rtrim(text2, "\n") : text2
      };
    }
  }
  fences(src) {
    const cap = this.rules.block.fences.exec(src);
    if (cap) {
      const raw = cap[0];
      const text2 = indentCodeCompensation(raw, cap[3] || "");
      return {
        type: "code",
        raw,
        lang: cap[2] ? cap[2].trim() : cap[2],
        text: text2
      };
    }
  }
  heading(src) {
    const cap = this.rules.block.heading.exec(src);
    if (cap) {
      let text2 = cap[2].trim();
      if (/#$/.test(text2)) {
        const trimmed = rtrim(text2, "#");
        if (this.options.pedantic) {
          text2 = trimmed.trim();
        } else if (!trimmed || / $/.test(trimmed)) {
          text2 = trimmed.trim();
        }
      }
      const token = {
        type: "heading",
        raw: cap[0],
        depth: cap[1].length,
        text: text2,
        tokens: []
      };
      this.lexer.inline(token.text, token.tokens);
      return token;
    }
  }
  hr(src) {
    const cap = this.rules.block.hr.exec(src);
    if (cap) {
      return {
        type: "hr",
        raw: cap[0]
      };
    }
  }
  blockquote(src) {
    const cap = this.rules.block.blockquote.exec(src);
    if (cap) {
      const text2 = cap[0].replace(/^ *> ?/gm, "");
      return {
        type: "blockquote",
        raw: cap[0],
        tokens: this.lexer.blockTokens(text2, []),
        text: text2
      };
    }
  }
  list(src) {
    let cap = this.rules.block.list.exec(src);
    if (cap) {
      let raw, istask, ischecked, indent, i2, blankLine, endsWithBlankLine, line, lines, itemContents;
      let bull = cap[1].trim();
      const isordered = bull.length > 1;
      const list2 = {
        type: "list",
        raw: "",
        ordered: isordered,
        start: isordered ? +bull.slice(0, -1) : "",
        loose: false,
        items: []
      };
      bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
      if (this.options.pedantic) {
        bull = isordered ? bull : "[*+-]";
      }
      const itemRegex = new RegExp(`^( {0,3}${bull})((?: [^\\n]*| *)(?:\\n[^\\n]*)*(?:\\n|$))`);
      while (src) {
        if (this.rules.block.hr.test(src)) {
          break;
        }
        if (!(cap = itemRegex.exec(src))) {
          break;
        }
        lines = cap[2].split("\n");
        if (this.options.pedantic) {
          indent = 2;
          itemContents = lines[0].trimLeft();
        } else {
          indent = cap[2].search(/[^ ]/);
          indent = cap[1].length + (indent > 4 ? 1 : indent);
          itemContents = lines[0].slice(indent - cap[1].length);
        }
        blankLine = false;
        raw = cap[0];
        if (!lines[0] && /^ *$/.test(lines[1])) {
          raw = cap[1] + lines.slice(0, 2).join("\n") + "\n";
          list2.loose = true;
          lines = [];
        }
        const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])`);
        for (i2 = 1; i2 < lines.length; i2++) {
          line = lines[i2];
          if (this.options.pedantic) {
            line = line.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
          }
          if (nextBulletRegex.test(line)) {
            raw = cap[1] + lines.slice(0, i2).join("\n") + "\n";
            break;
          }
          if (!blankLine) {
            if (!line.trim()) {
              blankLine = true;
            }
            if (line.search(/[^ ]/) >= indent) {
              itemContents += "\n" + line.slice(indent);
            } else {
              itemContents += "\n" + line;
            }
            continue;
          }
          if (line.search(/[^ ]/) >= indent || !line.trim()) {
            itemContents += "\n" + line.slice(indent);
            continue;
          } else {
            raw = cap[1] + lines.slice(0, i2).join("\n") + "\n";
            break;
          }
        }
        if (!list2.loose) {
          if (endsWithBlankLine) {
            list2.loose = true;
          } else if (/\n *\n *$/.test(raw)) {
            endsWithBlankLine = true;
          }
        }
        if (this.options.gfm) {
          istask = /^\[[ xX]\] /.exec(itemContents);
          if (istask) {
            ischecked = istask[0] !== "[ ] ";
            itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
          }
        }
        list2.items.push({
          type: "list_item",
          raw,
          task: !!istask,
          checked: ischecked,
          loose: false,
          text: itemContents
        });
        list2.raw += raw;
        src = src.slice(raw.length);
      }
      list2.items[list2.items.length - 1].raw = raw.trimRight();
      list2.items[list2.items.length - 1].text = itemContents.trimRight();
      list2.raw = list2.raw.trimRight();
      const l = list2.items.length;
      for (i2 = 0; i2 < l; i2++) {
        this.lexer.state.top = false;
        list2.items[i2].tokens = this.lexer.blockTokens(list2.items[i2].text, []);
        if (list2.items[i2].tokens.some((t3) => t3.type === "space")) {
          list2.loose = true;
          list2.items[i2].loose = true;
        }
      }
      return list2;
    }
  }
  html(src) {
    const cap = this.rules.block.html.exec(src);
    if (cap) {
      const token = {
        type: "html",
        raw: cap[0],
        pre: !this.options.sanitizer && (cap[1] === "pre" || cap[1] === "script" || cap[1] === "style"),
        text: cap[0]
      };
      if (this.options.sanitize) {
        token.type = "paragraph";
        token.text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape$2(cap[0]);
        token.tokens = [];
        this.lexer.inline(token.text, token.tokens);
      }
      return token;
    }
  }
  def(src) {
    const cap = this.rules.block.def.exec(src);
    if (cap) {
      if (cap[3])
        cap[3] = cap[3].substring(1, cap[3].length - 1);
      const tag = cap[1].toLowerCase().replace(/\s+/g, " ");
      return {
        type: "def",
        tag,
        raw: cap[0],
        href: cap[2],
        title: cap[3]
      };
    }
  }
  table(src) {
    const cap = this.rules.block.table.exec(src);
    if (cap) {
      const item = {
        type: "table",
        header: splitCells(cap[1]).map((c) => {
          return { text: c };
        }),
        align: cap[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
        rows: cap[3] ? cap[3].replace(/\n$/, "").split("\n") : []
      };
      if (item.header.length === item.align.length) {
        item.raw = cap[0];
        let l = item.align.length;
        let i2, j, k, row;
        for (i2 = 0; i2 < l; i2++) {
          if (/^ *-+: *$/.test(item.align[i2])) {
            item.align[i2] = "right";
          } else if (/^ *:-+: *$/.test(item.align[i2])) {
            item.align[i2] = "center";
          } else if (/^ *:-+ *$/.test(item.align[i2])) {
            item.align[i2] = "left";
          } else {
            item.align[i2] = null;
          }
        }
        l = item.rows.length;
        for (i2 = 0; i2 < l; i2++) {
          item.rows[i2] = splitCells(item.rows[i2], item.header.length).map((c) => {
            return { text: c };
          });
        }
        l = item.header.length;
        for (j = 0; j < l; j++) {
          item.header[j].tokens = [];
          this.lexer.inlineTokens(item.header[j].text, item.header[j].tokens);
        }
        l = item.rows.length;
        for (j = 0; j < l; j++) {
          row = item.rows[j];
          for (k = 0; k < row.length; k++) {
            row[k].tokens = [];
            this.lexer.inlineTokens(row[k].text, row[k].tokens);
          }
        }
        return item;
      }
    }
  }
  lheading(src) {
    const cap = this.rules.block.lheading.exec(src);
    if (cap) {
      const token = {
        type: "heading",
        raw: cap[0],
        depth: cap[2].charAt(0) === "=" ? 1 : 2,
        text: cap[1],
        tokens: []
      };
      this.lexer.inline(token.text, token.tokens);
      return token;
    }
  }
  paragraph(src) {
    const cap = this.rules.block.paragraph.exec(src);
    if (cap) {
      const token = {
        type: "paragraph",
        raw: cap[0],
        text: cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1],
        tokens: []
      };
      this.lexer.inline(token.text, token.tokens);
      return token;
    }
  }
  text(src) {
    const cap = this.rules.block.text.exec(src);
    if (cap) {
      const token = {
        type: "text",
        raw: cap[0],
        text: cap[0],
        tokens: []
      };
      this.lexer.inline(token.text, token.tokens);
      return token;
    }
  }
  escape(src) {
    const cap = this.rules.inline.escape.exec(src);
    if (cap) {
      return {
        type: "escape",
        raw: cap[0],
        text: escape$2(cap[1])
      };
    }
  }
  tag(src) {
    const cap = this.rules.inline.tag.exec(src);
    if (cap) {
      if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
        this.lexer.state.inLink = true;
      } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
        this.lexer.state.inLink = false;
      }
      if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.lexer.state.inRawBlock = true;
      } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.lexer.state.inRawBlock = false;
      }
      return {
        type: this.options.sanitize ? "text" : "html",
        raw: cap[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape$2(cap[0]) : cap[0]
      };
    }
  }
  link(src) {
    const cap = this.rules.inline.link.exec(src);
    if (cap) {
      const trimmedUrl = cap[2].trim();
      if (!this.options.pedantic && /^</.test(trimmedUrl)) {
        if (!/>$/.test(trimmedUrl)) {
          return;
        }
        const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
        if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
          return;
        }
      } else {
        const lastParenIndex = findClosingBracket(cap[2], "()");
        if (lastParenIndex > -1) {
          const start = cap[0].indexOf("!") === 0 ? 5 : 4;
          const linkLen = start + cap[1].length + lastParenIndex;
          cap[2] = cap[2].substring(0, lastParenIndex);
          cap[0] = cap[0].substring(0, linkLen).trim();
          cap[3] = "";
        }
      }
      let href = cap[2];
      let title = "";
      if (this.options.pedantic) {
        const link2 = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
        if (link2) {
          href = link2[1];
          title = link2[3];
        }
      } else {
        title = cap[3] ? cap[3].slice(1, -1) : "";
      }
      href = href.trim();
      if (/^</.test(href)) {
        if (this.options.pedantic && !/>$/.test(trimmedUrl)) {
          href = href.slice(1);
        } else {
          href = href.slice(1, -1);
        }
      }
      return outputLink(cap, {
        href: href ? href.replace(this.rules.inline._escapes, "$1") : href,
        title: title ? title.replace(this.rules.inline._escapes, "$1") : title
      }, cap[0], this.lexer);
    }
  }
  reflink(src, links) {
    let cap;
    if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
      let link2 = (cap[2] || cap[1]).replace(/\s+/g, " ");
      link2 = links[link2.toLowerCase()];
      if (!link2 || !link2.href) {
        const text2 = cap[0].charAt(0);
        return {
          type: "text",
          raw: text2,
          text: text2
        };
      }
      return outputLink(cap, link2, cap[0], this.lexer);
    }
  }
  emStrong(src, maskedSrc, prevChar = "") {
    let match = this.rules.inline.emStrong.lDelim.exec(src);
    if (!match)
      return;
    if (match[3] && prevChar.match(/[\p{L}\p{N}]/u))
      return;
    const nextChar = match[1] || match[2] || "";
    if (!nextChar || nextChar && (prevChar === "" || this.rules.inline.punctuation.exec(prevChar))) {
      const lLength = match[0].length - 1;
      let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
      const endReg = match[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      endReg.lastIndex = 0;
      maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
      while ((match = endReg.exec(maskedSrc)) != null) {
        rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
        if (!rDelim)
          continue;
        rLength = rDelim.length;
        if (match[3] || match[4]) {
          delimTotal += rLength;
          continue;
        } else if (match[5] || match[6]) {
          if (lLength % 3 && !((lLength + rLength) % 3)) {
            midDelimTotal += rLength;
            continue;
          }
        }
        delimTotal -= rLength;
        if (delimTotal > 0)
          continue;
        rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
        if (Math.min(lLength, rLength) % 2) {
          const text3 = src.slice(1, lLength + match.index + rLength);
          return {
            type: "em",
            raw: src.slice(0, lLength + match.index + rLength + 1),
            text: text3,
            tokens: this.lexer.inlineTokens(text3, [])
          };
        }
        const text2 = src.slice(2, lLength + match.index + rLength - 1);
        return {
          type: "strong",
          raw: src.slice(0, lLength + match.index + rLength + 1),
          text: text2,
          tokens: this.lexer.inlineTokens(text2, [])
        };
      }
    }
  }
  codespan(src) {
    const cap = this.rules.inline.code.exec(src);
    if (cap) {
      let text2 = cap[2].replace(/\n/g, " ");
      const hasNonSpaceChars = /[^ ]/.test(text2);
      const hasSpaceCharsOnBothEnds = /^ /.test(text2) && / $/.test(text2);
      if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
        text2 = text2.substring(1, text2.length - 1);
      }
      text2 = escape$2(text2, true);
      return {
        type: "codespan",
        raw: cap[0],
        text: text2
      };
    }
  }
  br(src) {
    const cap = this.rules.inline.br.exec(src);
    if (cap) {
      return {
        type: "br",
        raw: cap[0]
      };
    }
  }
  del(src) {
    const cap = this.rules.inline.del.exec(src);
    if (cap) {
      return {
        type: "del",
        raw: cap[0],
        text: cap[2],
        tokens: this.lexer.inlineTokens(cap[2], [])
      };
    }
  }
  autolink(src, mangle2) {
    const cap = this.rules.inline.autolink.exec(src);
    if (cap) {
      let text2, href;
      if (cap[2] === "@") {
        text2 = escape$2(this.options.mangle ? mangle2(cap[1]) : cap[1]);
        href = "mailto:" + text2;
      } else {
        text2 = escape$2(cap[1]);
        href = text2;
      }
      return {
        type: "link",
        raw: cap[0],
        text: text2,
        href,
        tokens: [
          {
            type: "text",
            raw: text2,
            text: text2
          }
        ]
      };
    }
  }
  url(src, mangle2) {
    let cap;
    if (cap = this.rules.inline.url.exec(src)) {
      let text2, href;
      if (cap[2] === "@") {
        text2 = escape$2(this.options.mangle ? mangle2(cap[0]) : cap[0]);
        href = "mailto:" + text2;
      } else {
        let prevCapZero;
        do {
          prevCapZero = cap[0];
          cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
        } while (prevCapZero !== cap[0]);
        text2 = escape$2(cap[0]);
        if (cap[1] === "www.") {
          href = "http://" + text2;
        } else {
          href = text2;
        }
      }
      return {
        type: "link",
        raw: cap[0],
        text: text2,
        href,
        tokens: [
          {
            type: "text",
            raw: text2,
            text: text2
          }
        ]
      };
    }
  }
  inlineText(src, smartypants2) {
    const cap = this.rules.inline.text.exec(src);
    if (cap) {
      let text2;
      if (this.lexer.state.inRawBlock) {
        text2 = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape$2(cap[0]) : cap[0];
      } else {
        text2 = escape$2(this.options.smartypants ? smartypants2(cap[0]) : cap[0]);
      }
      return {
        type: "text",
        raw: cap[0],
        text: text2
      };
    }
  }
};
const {
  noopTest: noopTest2,
  edit,
  merge: merge$1
} = helpers;
const block$1 = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)( [^\n]+?)?(?:\n|$)/,
  html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
  def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
  table: noopTest2,
  lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};
block$1._label = /(?!\s*\])(?:\\[\[\]]|[^\[\]])+/;
block$1._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
block$1.def = edit(block$1.def).replace("label", block$1._label).replace("title", block$1._title).getRegex();
block$1.bullet = /(?:[*+-]|\d{1,9}[.)])/;
block$1.listItemStart = edit(/^( *)(bull) */).replace("bull", block$1.bullet).getRegex();
block$1.list = edit(block$1.list).replace(/bull/g, block$1.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + block$1.def.source + ")").getRegex();
block$1._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
block$1._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
block$1.html = edit(block$1.html, "i").replace("comment", block$1._comment).replace("tag", block$1._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
block$1.paragraph = edit(block$1._paragraph).replace("hr", block$1.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block$1._tag).getRegex();
block$1.blockquote = edit(block$1.blockquote).replace("paragraph", block$1.paragraph).getRegex();
block$1.normal = merge$1({}, block$1);
block$1.gfm = merge$1({}, block$1.normal, {
  table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
  // Cells
});
block$1.gfm.table = edit(block$1.gfm.table).replace("hr", block$1.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block$1._tag).getRegex();
block$1.pedantic = merge$1({}, block$1.normal, {
  html: edit(
    `^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`
  ).replace("comment", block$1._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: noopTest2,
  // fences not supported
  paragraph: edit(block$1.normal._paragraph).replace("hr", block$1.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", block$1.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
});
const inline$1 = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: noopTest2,
  tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
  // CDATA section
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,
  nolink: /^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,
  reflinkSearch: "reflink|nolink(?!\\()",
  emStrong: {
    lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
    //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //        () Skip orphan delim inside strong    (1) #***                (2) a***#, a***                   (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
    rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
    rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/
    // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: noopTest2,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^([\spunctuation])/
};
inline$1._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~";
inline$1.punctuation = edit(inline$1.punctuation).replace(/punctuation/g, inline$1._punctuation).getRegex();
inline$1.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
inline$1.escapedEmSt = /\\\*|\\_/g;
inline$1._comment = edit(block$1._comment).replace("(?:-->|$)", "-->").getRegex();
inline$1.emStrong.lDelim = edit(inline$1.emStrong.lDelim).replace(/punct/g, inline$1._punctuation).getRegex();
inline$1.emStrong.rDelimAst = edit(inline$1.emStrong.rDelimAst, "g").replace(/punct/g, inline$1._punctuation).getRegex();
inline$1.emStrong.rDelimUnd = edit(inline$1.emStrong.rDelimUnd, "g").replace(/punct/g, inline$1._punctuation).getRegex();
inline$1._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
inline$1._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
inline$1._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
inline$1.autolink = edit(inline$1.autolink).replace("scheme", inline$1._scheme).replace("email", inline$1._email).getRegex();
inline$1._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
inline$1.tag = edit(inline$1.tag).replace("comment", inline$1._comment).replace("attribute", inline$1._attribute).getRegex();
inline$1._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
inline$1._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
inline$1._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
inline$1.link = edit(inline$1.link).replace("label", inline$1._label).replace("href", inline$1._href).replace("title", inline$1._title).getRegex();
inline$1.reflink = edit(inline$1.reflink).replace("label", inline$1._label).getRegex();
inline$1.reflinkSearch = edit(inline$1.reflinkSearch, "g").replace("reflink", inline$1.reflink).replace("nolink", inline$1.nolink).getRegex();
inline$1.normal = merge$1({}, inline$1);
inline$1.pedantic = merge$1({}, inline$1.normal, {
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", inline$1._label).getRegex(),
  reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", inline$1._label).getRegex()
});
inline$1.gfm = merge$1({}, inline$1.normal, {
  escape: edit(inline$1.escape).replace("])", "~|])").getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
});
inline$1.gfm.url = edit(inline$1.gfm.url, "i").replace("email", inline$1.gfm._extended_email).getRegex();
inline$1.breaks = merge$1({}, inline$1.gfm, {
  br: edit(inline$1.br).replace("{2,}", "*").getRegex(),
  text: edit(inline$1.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
});
var rules = {
  block: block$1,
  inline: inline$1
};
const Tokenizer$2 = Tokenizer_1$1;
const { defaults: defaults$3 } = defaults$5.exports;
const { block, inline } = rules;
const { repeatString } = helpers;
function smartypants(text2) {
  return text2.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
}
function mangle(text2) {
  let out = "", i2, ch;
  const l = text2.length;
  for (i2 = 0; i2 < l; i2++) {
    ch = text2.charCodeAt(i2);
    if (Math.random() > 0.5) {
      ch = "x" + ch.toString(16);
    }
    out += "&#" + ch + ";";
  }
  return out;
}
var Lexer_1$1 = class Lexer {
  constructor(options) {
    this.tokens = [];
    this.tokens.links = /* @__PURE__ */ Object.create(null);
    this.options = options || defaults$3;
    this.options.tokenizer = this.options.tokenizer || new Tokenizer$2();
    this.tokenizer = this.options.tokenizer;
    this.tokenizer.options = this.options;
    this.tokenizer.lexer = this;
    this.inlineQueue = [];
    this.state = {
      inLink: false,
      inRawBlock: false,
      top: true
    };
    const rules2 = {
      block: block.normal,
      inline: inline.normal
    };
    if (this.options.pedantic) {
      rules2.block = block.pedantic;
      rules2.inline = inline.pedantic;
    } else if (this.options.gfm) {
      rules2.block = block.gfm;
      if (this.options.breaks) {
        rules2.inline = inline.breaks;
      } else {
        rules2.inline = inline.gfm;
      }
    }
    this.tokenizer.rules = rules2;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block,
      inline
    };
  }
  /**
   * Static Lex Method
   */
  static lex(src, options) {
    const lexer = new Lexer(options);
    return lexer.lex(src);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(src, options) {
    const lexer = new Lexer(options);
    return lexer.inlineTokens(src);
  }
  /**
   * Preprocessing
   */
  lex(src) {
    src = src.replace(/\r\n|\r/g, "\n").replace(/\t/g, "    ");
    this.blockTokens(src, this.tokens);
    let next;
    while (next = this.inlineQueue.shift()) {
      this.inlineTokens(next.src, next.tokens);
    }
    return this.tokens;
  }
  /**
   * Lexing
   */
  blockTokens(src, tokens = []) {
    if (this.options.pedantic) {
      src = src.replace(/^ +$/gm, "");
    }
    let token, lastToken, cutSrc, lastParagraphClipped;
    while (src) {
      if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((extTokenizer) => {
        if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return true;
        }
        return false;
      })) {
        continue;
      }
      if (token = this.tokenizer.space(src)) {
        src = src.substring(token.raw.length);
        if (token.type) {
          tokens.push(token);
        }
        continue;
      }
      if (token = this.tokenizer.code(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
          lastToken.raw += "\n" + token.raw;
          lastToken.text += "\n" + token.text;
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token);
        }
        continue;
      }
      if (token = this.tokenizer.fences(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.heading(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.hr(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.blockquote(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.list(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.html(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.def(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
          lastToken.raw += "\n" + token.raw;
          lastToken.text += "\n" + token.raw;
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else if (!this.tokens.links[token.tag]) {
          this.tokens.links[token.tag] = {
            href: token.href,
            title: token.title
          };
        }
        continue;
      }
      if (token = this.tokenizer.table(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.lheading(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      cutSrc = src;
      if (this.options.extensions && this.options.extensions.startBlock) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startBlock.forEach(function(getStartIndex) {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === "number" && tempStart >= 0) {
            startIndex = Math.min(startIndex, tempStart);
          }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
        lastToken = tokens[tokens.length - 1];
        if (lastParagraphClipped && lastToken.type === "paragraph") {
          lastToken.raw += "\n" + token.raw;
          lastToken.text += "\n" + token.text;
          this.inlineQueue.pop();
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token);
        }
        lastParagraphClipped = cutSrc.length !== src.length;
        src = src.substring(token.raw.length);
        continue;
      }
      if (token = this.tokenizer.text(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && lastToken.type === "text") {
          lastToken.raw += "\n" + token.raw;
          lastToken.text += "\n" + token.text;
          this.inlineQueue.pop();
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token);
        }
        continue;
      }
      if (src) {
        const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }
    this.state.top = true;
    return tokens;
  }
  inline(src, tokens) {
    this.inlineQueue.push({ src, tokens });
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(src, tokens = []) {
    let token, lastToken, cutSrc;
    let maskedSrc = src;
    let match;
    let keepPrevChar, prevChar;
    if (this.tokens.links) {
      const links = Object.keys(this.tokens.links);
      if (links.length > 0) {
        while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
          if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) {
            maskedSrc = maskedSrc.slice(0, match.index) + "[" + repeatString("a", match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
          }
        }
      }
    }
    while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match.index) + "[" + repeatString("a", match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    }
    while ((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
    }
    while (src) {
      if (!keepPrevChar) {
        prevChar = "";
      }
      keepPrevChar = false;
      if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((extTokenizer) => {
        if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return true;
        }
        return false;
      })) {
        continue;
      }
      if (token = this.tokenizer.escape(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.tag(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && token.type === "text" && lastToken.type === "text") {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }
      if (token = this.tokenizer.link(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.reflink(src, this.tokens.links)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && token.type === "text" && lastToken.type === "text") {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }
      if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.codespan(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.br(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.del(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (token = this.tokenizer.autolink(src, mangle)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }
      cutSrc = src;
      if (this.options.extensions && this.options.extensions.startInline) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startInline.forEach(function(getStartIndex) {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === "number" && tempStart >= 0) {
            startIndex = Math.min(startIndex, tempStart);
          }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
        src = src.substring(token.raw.length);
        if (token.raw.slice(-1) !== "_") {
          prevChar = token.raw.slice(-1);
        }
        keepPrevChar = true;
        lastToken = tokens[tokens.length - 1];
        if (lastToken && lastToken.type === "text") {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }
      if (src) {
        const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }
    return tokens;
  }
};
const { defaults: defaults$2 } = defaults$5.exports;
const {
  cleanUrl,
  escape: escape$1
} = helpers;
var Renderer_1$1 = class Renderer {
  constructor(options) {
    this.options = options || defaults$2;
  }
  code(code, infostring, escaped) {
    const lang = (infostring || "").match(/\S*/)[0];
    if (this.options.highlight) {
      const out = this.options.highlight(code, lang);
      if (out != null && out !== code) {
        escaped = true;
        code = out;
      }
    }
    code = code.replace(/\n$/, "") + "\n";
    if (!lang) {
      return "<pre><code>" + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
    }
    return '<pre><code class="' + this.options.langPrefix + escape$1(lang, true) + '">' + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
  }
  blockquote(quote) {
    return "<blockquote>\n" + quote + "</blockquote>\n";
  }
  html(html) {
    return html;
  }
  heading(text2, level, raw, slugger) {
    if (this.options.headerIds) {
      return "<h" + level + ' id="' + this.options.headerPrefix + slugger.slug(raw) + '">' + text2 + "</h" + level + ">\n";
    }
    return "<h" + level + ">" + text2 + "</h" + level + ">\n";
  }
  hr() {
    return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
  }
  list(body, ordered, start) {
    const type = ordered ? "ol" : "ul", startatt = ordered && start !== 1 ? ' start="' + start + '"' : "";
    return "<" + type + startatt + ">\n" + body + "</" + type + ">\n";
  }
  listitem(text2) {
    return "<li>" + text2 + "</li>\n";
  }
  checkbox(checked) {
    return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
  }
  paragraph(text2) {
    return "<p>" + text2 + "</p>\n";
  }
  table(header, body) {
    if (body)
      body = "<tbody>" + body + "</tbody>";
    return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
  }
  tablerow(content) {
    return "<tr>\n" + content + "</tr>\n";
  }
  tablecell(content, flags) {
    const type = flags.header ? "th" : "td";
    const tag = flags.align ? "<" + type + ' align="' + flags.align + '">' : "<" + type + ">";
    return tag + content + "</" + type + ">\n";
  }
  // span level renderer
  strong(text2) {
    return "<strong>" + text2 + "</strong>";
  }
  em(text2) {
    return "<em>" + text2 + "</em>";
  }
  codespan(text2) {
    return "<code>" + text2 + "</code>";
  }
  br() {
    return this.options.xhtml ? "<br/>" : "<br>";
  }
  del(text2) {
    return "<del>" + text2 + "</del>";
  }
  link(href, title, text2) {
    href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
    if (href === null) {
      return text2;
    }
    let out = '<a href="' + escape$1(href) + '"';
    if (title) {
      out += ' title="' + title + '"';
    }
    out += ">" + text2 + "</a>";
    return out;
  }
  image(href, title, text2) {
    href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
    if (href === null) {
      return text2;
    }
    let out = '<img src="' + href + '" alt="' + text2 + '"';
    if (title) {
      out += ' title="' + title + '"';
    }
    out += this.options.xhtml ? "/>" : ">";
    return out;
  }
  text(text2) {
    return text2;
  }
};
var TextRenderer_1$1 = class TextRenderer {
  // no need for block level renderers
  strong(text2) {
    return text2;
  }
  em(text2) {
    return text2;
  }
  codespan(text2) {
    return text2;
  }
  del(text2) {
    return text2;
  }
  html(text2) {
    return text2;
  }
  text(text2) {
    return text2;
  }
  link(href, title, text2) {
    return "" + text2;
  }
  image(href, title, text2) {
    return "" + text2;
  }
  br() {
    return "";
  }
};
var Slugger_1$1 = class Slugger {
  constructor() {
    this.seen = {};
  }
  serialize(value) {
    return value.toLowerCase().trim().replace(/<[!\/a-z].*?>/ig, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
  }
  /**
   * Finds the next safe (unique) slug to use
   */
  getNextSafeSlug(originalSlug, isDryRun) {
    let slug = originalSlug;
    let occurenceAccumulator = 0;
    if (this.seen.hasOwnProperty(slug)) {
      occurenceAccumulator = this.seen[originalSlug];
      do {
        occurenceAccumulator++;
        slug = originalSlug + "-" + occurenceAccumulator;
      } while (this.seen.hasOwnProperty(slug));
    }
    if (!isDryRun) {
      this.seen[originalSlug] = occurenceAccumulator;
      this.seen[slug] = 0;
    }
    return slug;
  }
  /**
   * Convert string to unique id
   * @param {object} options
   * @param {boolean} options.dryrun Generates the next unique slug without updating the internal accumulator.
   */
  slug(value, options = {}) {
    const slug = this.serialize(value);
    return this.getNextSafeSlug(slug, options.dryrun);
  }
};
const Renderer$2 = Renderer_1$1;
const TextRenderer$2 = TextRenderer_1$1;
const Slugger$2 = Slugger_1$1;
const { defaults: defaults$1 } = defaults$5.exports;
const {
  unescape: unescape$2
} = helpers;
var Parser_1$1 = class Parser2 {
  constructor(options) {
    this.options = options || defaults$1;
    this.options.renderer = this.options.renderer || new Renderer$2();
    this.renderer = this.options.renderer;
    this.renderer.options = this.options;
    this.textRenderer = new TextRenderer$2();
    this.slugger = new Slugger$2();
  }
  /**
   * Static Parse Method
   */
  static parse(tokens, options) {
    const parser2 = new Parser2(options);
    return parser2.parse(tokens);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(tokens, options) {
    const parser2 = new Parser2(options);
    return parser2.parseInline(tokens);
  }
  /**
   * Parse Loop
   */
  parse(tokens, top = true) {
    let out = "", i2, j, k, l2, l3, row, cell, header, body, token, ordered, start, loose, itemBody, item, checked, task, checkbox, ret;
    const l = tokens.length;
    for (i2 = 0; i2 < l; i2++) {
      token = tokens[i2];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
        ret = this.options.extensions.renderers[token.type].call({ parser: this }, token);
        if (ret !== false || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(token.type)) {
          out += ret || "";
          continue;
        }
      }
      switch (token.type) {
        case "space": {
          continue;
        }
        case "hr": {
          out += this.renderer.hr();
          continue;
        }
        case "heading": {
          out += this.renderer.heading(
            this.parseInline(token.tokens),
            token.depth,
            unescape$2(this.parseInline(token.tokens, this.textRenderer)),
            this.slugger
          );
          continue;
        }
        case "code": {
          out += this.renderer.code(
            token.text,
            token.lang,
            token.escaped
          );
          continue;
        }
        case "table": {
          header = "";
          cell = "";
          l2 = token.header.length;
          for (j = 0; j < l2; j++) {
            cell += this.renderer.tablecell(
              this.parseInline(token.header[j].tokens),
              { header: true, align: token.align[j] }
            );
          }
          header += this.renderer.tablerow(cell);
          body = "";
          l2 = token.rows.length;
          for (j = 0; j < l2; j++) {
            row = token.rows[j];
            cell = "";
            l3 = row.length;
            for (k = 0; k < l3; k++) {
              cell += this.renderer.tablecell(
                this.parseInline(row[k].tokens),
                { header: false, align: token.align[k] }
              );
            }
            body += this.renderer.tablerow(cell);
          }
          out += this.renderer.table(header, body);
          continue;
        }
        case "blockquote": {
          body = this.parse(token.tokens);
          out += this.renderer.blockquote(body);
          continue;
        }
        case "list": {
          ordered = token.ordered;
          start = token.start;
          loose = token.loose;
          l2 = token.items.length;
          body = "";
          for (j = 0; j < l2; j++) {
            item = token.items[j];
            checked = item.checked;
            task = item.task;
            itemBody = "";
            if (item.task) {
              checkbox = this.renderer.checkbox(checked);
              if (loose) {
                if (item.tokens.length > 0 && item.tokens[0].type === "paragraph") {
                  item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                  if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
                    item.tokens[0].tokens[0].text = checkbox + " " + item.tokens[0].tokens[0].text;
                  }
                } else {
                  item.tokens.unshift({
                    type: "text",
                    text: checkbox
                  });
                }
              } else {
                itemBody += checkbox;
              }
            }
            itemBody += this.parse(item.tokens, loose);
            body += this.renderer.listitem(itemBody, task, checked);
          }
          out += this.renderer.list(body, ordered, start);
          continue;
        }
        case "html": {
          out += this.renderer.html(token.text);
          continue;
        }
        case "paragraph": {
          out += this.renderer.paragraph(this.parseInline(token.tokens));
          continue;
        }
        case "text": {
          body = token.tokens ? this.parseInline(token.tokens) : token.text;
          while (i2 + 1 < l && tokens[i2 + 1].type === "text") {
            token = tokens[++i2];
            body += "\n" + (token.tokens ? this.parseInline(token.tokens) : token.text);
          }
          out += top ? this.renderer.paragraph(body) : body;
          continue;
        }
        default: {
          const errMsg = 'Token with "' + token.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return;
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }
    return out;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(tokens, renderer) {
    renderer = renderer || this.renderer;
    let out = "", i2, token, ret;
    const l = tokens.length;
    for (i2 = 0; i2 < l; i2++) {
      token = tokens[i2];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
        ret = this.options.extensions.renderers[token.type].call({ parser: this }, token);
        if (ret !== false || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(token.type)) {
          out += ret || "";
          continue;
        }
      }
      switch (token.type) {
        case "escape": {
          out += renderer.text(token.text);
          break;
        }
        case "html": {
          out += renderer.html(token.text);
          break;
        }
        case "link": {
          out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
          break;
        }
        case "image": {
          out += renderer.image(token.href, token.title, token.text);
          break;
        }
        case "strong": {
          out += renderer.strong(this.parseInline(token.tokens, renderer));
          break;
        }
        case "em": {
          out += renderer.em(this.parseInline(token.tokens, renderer));
          break;
        }
        case "codespan": {
          out += renderer.codespan(token.text);
          break;
        }
        case "br": {
          out += renderer.br();
          break;
        }
        case "del": {
          out += renderer.del(this.parseInline(token.tokens, renderer));
          break;
        }
        case "text": {
          out += renderer.text(token.text);
          break;
        }
        default: {
          const errMsg = 'Token with "' + token.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return;
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }
    return out;
  }
};
const Lexer$1 = Lexer_1$1;
const Parser$1 = Parser_1$1;
const Tokenizer$1 = Tokenizer_1$1;
const Renderer$1 = Renderer_1$1;
const TextRenderer$1 = TextRenderer_1$1;
const Slugger$1 = Slugger_1$1;
const {
  merge,
  checkSanitizeDeprecation,
  escape: escape$4
} = helpers;
const {
  getDefaults,
  changeDefaults,
  defaults: defaults$6
} = defaults$5.exports;
function marked$1(src, opt, callback) {
  if (typeof src === "undefined" || src === null) {
    throw new Error("marked(): input parameter is undefined or null");
  }
  if (typeof src !== "string") {
    throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected");
  }
  if (typeof opt === "function") {
    callback = opt;
    opt = null;
  }
  opt = merge({}, marked$1.defaults, opt || {});
  checkSanitizeDeprecation(opt);
  if (callback) {
    const highlight = opt.highlight;
    let tokens;
    try {
      tokens = Lexer$1.lex(src, opt);
    } catch (e) {
      return callback(e);
    }
    const done = function(err2) {
      let out;
      if (!err2) {
        try {
          if (opt.walkTokens) {
            marked$1.walkTokens(tokens, opt.walkTokens);
          }
          out = Parser$1.parse(tokens, opt);
        } catch (e) {
          err2 = e;
        }
      }
      opt.highlight = highlight;
      return err2 ? callback(err2) : callback(null, out);
    };
    if (!highlight || highlight.length < 3) {
      return done();
    }
    delete opt.highlight;
    if (!tokens.length)
      return done();
    let pending2 = 0;
    marked$1.walkTokens(tokens, function(token) {
      if (token.type === "code") {
        pending2++;
        setTimeout(() => {
          highlight(token.text, token.lang, function(err2, code) {
            if (err2) {
              return done(err2);
            }
            if (code != null && code !== token.text) {
              token.text = code;
              token.escaped = true;
            }
            pending2--;
            if (pending2 === 0) {
              done();
            }
          });
        }, 0);
      }
    });
    if (pending2 === 0) {
      done();
    }
    return;
  }
  try {
    const tokens = Lexer$1.lex(src, opt);
    if (opt.walkTokens) {
      marked$1.walkTokens(tokens, opt.walkTokens);
    }
    return Parser$1.parse(tokens, opt);
  } catch (e) {
    e.message += "\nPlease report this to https://github.com/markedjs/marked.";
    if (opt.silent) {
      return "<p>An error occurred:</p><pre>" + escape$4(e.message + "", true) + "</pre>";
    }
    throw e;
  }
}
marked$1.options = marked$1.setOptions = function(opt) {
  merge(marked$1.defaults, opt);
  changeDefaults(marked$1.defaults);
  return marked$1;
};
marked$1.getDefaults = getDefaults;
marked$1.defaults = defaults$6;
marked$1.use = function(...args) {
  const opts = merge({}, ...args);
  const extensions = marked$1.defaults.extensions || { renderers: {}, childTokens: {} };
  let hasExtensions;
  args.forEach((pack) => {
    if (pack.extensions) {
      hasExtensions = true;
      pack.extensions.forEach((ext) => {
        if (!ext.name) {
          throw new Error("extension name required");
        }
        if (ext.renderer) {
          const prevRenderer = extensions.renderers ? extensions.renderers[ext.name] : null;
          if (prevRenderer) {
            extensions.renderers[ext.name] = function(...args2) {
              let ret = ext.renderer.apply(this, args2);
              if (ret === false) {
                ret = prevRenderer.apply(this, args2);
              }
              return ret;
            };
          } else {
            extensions.renderers[ext.name] = ext.renderer;
          }
        }
        if (ext.tokenizer) {
          if (!ext.level || ext.level !== "block" && ext.level !== "inline") {
            throw new Error("extension level must be 'block' or 'inline'");
          }
          if (extensions[ext.level]) {
            extensions[ext.level].unshift(ext.tokenizer);
          } else {
            extensions[ext.level] = [ext.tokenizer];
          }
          if (ext.start) {
            if (ext.level === "block") {
              if (extensions.startBlock) {
                extensions.startBlock.push(ext.start);
              } else {
                extensions.startBlock = [ext.start];
              }
            } else if (ext.level === "inline") {
              if (extensions.startInline) {
                extensions.startInline.push(ext.start);
              } else {
                extensions.startInline = [ext.start];
              }
            }
          }
        }
        if (ext.childTokens) {
          extensions.childTokens[ext.name] = ext.childTokens;
        }
      });
    }
    if (pack.renderer) {
      const renderer = marked$1.defaults.renderer || new Renderer$1();
      for (const prop in pack.renderer) {
        const prevRenderer = renderer[prop];
        renderer[prop] = (...args2) => {
          let ret = pack.renderer[prop].apply(renderer, args2);
          if (ret === false) {
            ret = prevRenderer.apply(renderer, args2);
          }
          return ret;
        };
      }
      opts.renderer = renderer;
    }
    if (pack.tokenizer) {
      const tokenizer3 = marked$1.defaults.tokenizer || new Tokenizer$1();
      for (const prop in pack.tokenizer) {
        const prevTokenizer = tokenizer3[prop];
        tokenizer3[prop] = (...args2) => {
          let ret = pack.tokenizer[prop].apply(tokenizer3, args2);
          if (ret === false) {
            ret = prevTokenizer.apply(tokenizer3, args2);
          }
          return ret;
        };
      }
      opts.tokenizer = tokenizer3;
    }
    if (pack.walkTokens) {
      const walkTokens = marked$1.defaults.walkTokens;
      opts.walkTokens = function(token) {
        pack.walkTokens.call(this, token);
        if (walkTokens) {
          walkTokens.call(this, token);
        }
      };
    }
    if (hasExtensions) {
      opts.extensions = extensions;
    }
    marked$1.setOptions(opts);
  });
};
marked$1.walkTokens = function(tokens, callback) {
  for (const token of tokens) {
    callback.call(marked$1, token);
    switch (token.type) {
      case "table": {
        for (const cell of token.header) {
          marked$1.walkTokens(cell.tokens, callback);
        }
        for (const row of token.rows) {
          for (const cell of row) {
            marked$1.walkTokens(cell.tokens, callback);
          }
        }
        break;
      }
      case "list": {
        marked$1.walkTokens(token.items, callback);
        break;
      }
      default: {
        if (marked$1.defaults.extensions && marked$1.defaults.extensions.childTokens && marked$1.defaults.extensions.childTokens[token.type]) {
          marked$1.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
            marked$1.walkTokens(token[childTokens], callback);
          });
        } else if (token.tokens) {
          marked$1.walkTokens(token.tokens, callback);
        }
      }
    }
  }
};
marked$1.parseInline = function(src, opt) {
  if (typeof src === "undefined" || src === null) {
    throw new Error("marked.parseInline(): input parameter is undefined or null");
  }
  if (typeof src !== "string") {
    throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected");
  }
  opt = merge({}, marked$1.defaults, opt || {});
  checkSanitizeDeprecation(opt);
  try {
    const tokens = Lexer$1.lexInline(src, opt);
    if (opt.walkTokens) {
      marked$1.walkTokens(tokens, opt.walkTokens);
    }
    return Parser$1.parseInline(tokens, opt);
  } catch (e) {
    e.message += "\nPlease report this to https://github.com/markedjs/marked.";
    if (opt.silent) {
      return "<p>An error occurred:</p><pre>" + escape$4(e.message + "", true) + "</pre>";
    }
    throw e;
  }
};
marked$1.Parser = Parser$1;
marked$1.parser = Parser$1.parse;
marked$1.Renderer = Renderer$1;
marked$1.TextRenderer = TextRenderer$1;
marked$1.Lexer = Lexer$1;
marked$1.lexer = Lexer$1.lex;
marked$1.Tokenizer = Tokenizer$1;
marked$1.Slugger = Slugger$1;
marked$1.parse = marked$1;
var marked_1 = marked$1;
const marked = marked_1;
const Lexer2 = Lexer_1$1;
const Parser3 = Parser_1$1;
const Tokenizer2 = Tokenizer_1$1;
const Renderer2 = Renderer_1$1;
const TextRenderer2 = TextRenderer_1$1;
const Slugger2 = Slugger_1$1;
esmEntry$1.exports = marked;
esmEntry$1.exports.parse = marked;
esmEntry$1.exports.Parser = Parser3;
esmEntry$1.exports.parser = Parser3.parse;
esmEntry$1.exports.Renderer = Renderer2;
esmEntry$1.exports.TextRenderer = TextRenderer2;
esmEntry$1.exports.Lexer = Lexer2;
esmEntry$1.exports.lexer = Lexer2.lex;
esmEntry$1.exports.Tokenizer = Tokenizer2;
esmEntry$1.exports.Slugger = Slugger2;
var esmEntry = esmEntry$1.exports;
const attributes = ["media", "srcset", "sizes", "src"];
const LazyLoadDirective = {
  inserted: (el) => {
    function loadImage2() {
      const imageElement = findChild(el, "img");
      const pictureElement = findChild(el, "picture");
      if (imageElement) {
        setLoadListeners(imageElement);
        swapAttributes(imageElement);
      } else if (pictureElement) {
        const pictureImg = findChild(pictureElement, "img");
        const pictureSources = Array.from(pictureElement.children).filter(
          (child) => child.nodeName === "SOURCE"
        );
        if (pictureImg) {
          setLoadListeners(pictureImg);
          if (pictureSources.length) {
            pictureSources.forEach((source) => {
              swapAttributes(source);
            });
          }
          swapAttributes(pictureImg);
        }
      }
    }
    function handleIntersect(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadImage2();
          observer.unobserve(el);
        }
      });
    }
    function createObserver2() {
      const options = {
        root: null,
        threshold: "0"
      };
      const observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(el);
    }
    if (window["IntersectionObserver"]) {
      createObserver2();
    } else {
      loadImage2();
    }
  }
};
function swapAttributes(el) {
  attributes.forEach((attribute) => {
    const dataAttribute = el.dataset[attribute];
    if (dataAttribute) {
      el[attribute] = dataAttribute;
      el.removeAttribute(`data-${attribute}`);
    }
  });
}
function setLoadListeners(el) {
  el.addEventListener("load", () => {
    setTimeout(() => el.classList.add("loaded"), 100);
  });
  el.addEventListener("error", () => console.log("error"));
}
function findChild(parent2, nodeName) {
  return Array.from(parent2.children).find(
    (el) => el.nodeName === nodeName.toUpperCase()
  );
}
const AutoplayObserver = {
  inserted: (el) => {
    function isYoutubeVideo(url) {
      const youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      const ytId = url.match(youtubeRegex) ? RegExp.$1 : false;
      if (ytId) {
        return true;
      }
      return false;
    }
    function autoplayVideo() {
      const tagName2 = el.tagName;
      const autoplay = el.dataset.autoplay;
      if (autoplay) {
        if (tagName2 === "VIDEO") {
          el.muted = true;
          el.autoplay = true;
          return;
        }
        if (tagName2 === "IFRAME") {
          var url = new URL(el.src);
          let muted = "muted";
          if (isYoutubeVideo(el.src)) {
            muted = "mute";
          }
          url.searchParams.append(muted, 1);
          url.searchParams.append("autoplay", 1);
          el.src = url.href;
        }
      }
    }
    function handleIntersect(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          autoplayVideo();
          observer.unobserve(el);
        }
      });
    }
    function createObserver2() {
      const options = {
        root: null,
        threshold: "0"
      };
      const observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(el);
    }
    if (window["IntersectionObserver"]) {
      createObserver2();
    } else {
      loadImage();
    }
  }
};
function _toConsumableArray$1(arr) {
  if (Array.isArray(arr)) {
    for (var i2 = 0, arr2 = Array(arr.length); i2 < arr.length; i2++) {
      arr2[i2] = arr[i2];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
var hasPassiveEvents = false;
if (typeof window !== "undefined") {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return void 0;
    }
  };
  window.addEventListener("testPassive", null, passiveTestOptions);
  window.removeEventListener("testPassive", null, passiveTestOptions);
}
var isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPaddingRight = void 0;
var allowTouchMove = function allowTouchMove2(el) {
  return locks.some(function(lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }
    return false;
  });
};
var preventDefault = function preventDefault2(rawEvent) {
  var e = rawEvent || window.event;
  if (allowTouchMove(e.target)) {
    return true;
  }
  if (e.touches.length > 1)
    return true;
  if (e.preventDefault)
    e.preventDefault();
  return false;
};
var setOverflowHidden = function setOverflowHidden2(options) {
  if (previousBodyPaddingRight === void 0) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
    if (_reserveScrollBarGap && scrollBarGap > 0) {
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollBarGap + "px";
    }
  }
  if (previousBodyOverflowSetting === void 0) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
};
var restoreOverflowSetting = function restoreOverflowSetting2() {
  if (previousBodyPaddingRight !== void 0) {
    document.body.style.paddingRight = previousBodyPaddingRight;
    previousBodyPaddingRight = void 0;
  }
  if (previousBodyOverflowSetting !== void 0) {
    document.body.style.overflow = previousBodyOverflowSetting;
    previousBodyOverflowSetting = void 0;
  }
};
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled2(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var handleScroll = function handleScroll2(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;
  if (allowTouchMove(event.target)) {
    return false;
  }
  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    return preventDefault(event);
  }
  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    return preventDefault(event);
  }
  event.stopPropagation();
  return true;
};
var disableBodyScroll = function disableBodyScroll2(targetElement, options) {
  if (!targetElement) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (locks.some(function(lock2) {
    return lock2.targetElement === targetElement;
  })) {
    return;
  }
  var lock = {
    targetElement,
    options: options || {}
  };
  locks = [].concat(_toConsumableArray$1(locks), [lock]);
  if (isIosDevice) {
    targetElement.ontouchstart = function(event) {
      if (event.targetTouches.length === 1) {
        initialClientY = event.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function(event) {
      if (event.targetTouches.length === 1) {
        handleScroll(event, targetElement);
      }
    };
    if (!documentListenerAdded) {
      document.addEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: false } : void 0);
      documentListenerAdded = true;
    }
  } else {
    setOverflowHidden(options);
  }
};
var enableBodyScroll = function enableBodyScroll2(targetElement) {
  if (!targetElement) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  locks = locks.filter(function(lock) {
    return lock.targetElement !== targetElement;
  });
  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;
    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: false } : void 0);
      documentListenerAdded = false;
    }
  } else if (!locks.length) {
    restoreOverflowSetting();
  }
};
var render$A = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", {
    attrs: {
      "name": "cool-lightbox-modal"
    }
  }, [_vm.isVisible ? _c("div", {
    ref: "coolLightbox",
    staticClass: "cool-lightbox",
    class: _vm.lightboxClasses,
    style: _vm.lightboxStyles,
    on: {
      "click": _vm.closeModal
    }
  }, [_vm.gallery ? _c("div", {
    staticClass: "cool-lightbox-thumbs"
  }, [_c("div", {
    staticClass: "cool-lightbox-thumbs__list"
  }, _vm._l(_vm.items, function(item, itemIndex) {
    return _c("button", {
      key: itemIndex,
      staticClass: "cool-lightbox__thumb",
      class: {
        active: itemIndex === _vm.imgIndex,
        "is-video": _vm.getMediaType(itemIndex) === "video"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.imgIndex = itemIndex;
        }
      }
    }, [_vm.getMediaType(itemIndex) === "video" || _vm.getMediaType(itemIndex) === "html" ? _c("svg", {
      staticClass: "cool-lightbox__thumb__icon",
      staticStyle: {
        "color": "rgba(256, 256, 256, 0.5)",
        "width": "50px",
        "height": "50px"
      },
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }
    }, [_c("title", [_vm._v("monitor-dashboard")]), _c("path", {
      attrs: {
        "d": "M21,16V4H3V16H21M21,2A2,2 0 0,1 23,4V16A2,2 0 0,1 21,18H14V20H16V22H8V20H10V18H3C1.89,18 1,17.1 1,16V4C1,2.89 1.89,2 3,2H21M5,6H14V11H5V6M15,6H19V8H15V6M19,9V14H15V9H19M5,12H9V14H5V12M10,12H14V14H10V12Z"
      }
    })]) : _vm._e(), !(_vm.getMediaType(itemIndex) === "video" || _vm.getMediaType(itemIndex) === "html") ? _c("img", {
      attrs: {
        "src": _vm.itemThumb(_vm.getItemSrc(itemIndex), itemIndex),
        "alt": ""
      }
    }) : _vm._e()]);
  }), 0)]) : _vm._e(), _c("div", {
    staticClass: "cool-lightbox__inner",
    style: _vm.innerStyles,
    on: {
      "mousedown": _vm.startSwipe,
      "mousemove": _vm.continueSwipe,
      "mouseup": _vm.endSwipe,
      "touchstart": _vm.startSwipe,
      "touchmove": _vm.continueSwipe,
      "touchend": _vm.endSwipe
    }
  }, [_c("div", {
    staticClass: "cool-lightbox__progressbar",
    style: _vm.stylesInterval
  }), _c("div", {
    staticClass: "cool-lightbox__navigation"
  }, [_c("button", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPreviousButton || _vm.loopData) && _vm.items.length > 1,
      expression: "(hasPreviousButton || loopData) && items.length > 1"
    }],
    staticClass: "cool-lightbox-button cool-lightbox-button--prev",
    class: _vm.buttonsClasses,
    attrs: {
      "type": "button",
      "title": "Previous"
    },
    on: {
      "click": _vm.onPrevClick
    }
  }, [_vm._t("icon-previous", function() {
    return [_c("div", {
      staticClass: "cool-lightbox-button__icon"
    }, [_c("svg", {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }
    }, [_c("path", {
      attrs: {
        "d": "M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"
      }
    })])])];
  })], 2), _c("button", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasNextButton || _vm.loopData) && _vm.items.length > 1,
      expression: "(hasNextButton || loopData) && items.length > 1"
    }],
    staticClass: "cool-lightbox-button cool-lightbox-button--next",
    class: _vm.buttonsClasses,
    attrs: {
      "type": "button",
      "title": "Next"
    },
    on: {
      "click": function($event) {
        return _vm.onNextClick(false);
      }
    }
  }, [_vm._t("icon-next", function() {
    return [_c("div", {
      staticClass: "cool-lightbox-button__icon"
    }, [_c("svg", {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }
    }, [_c("path", {
      attrs: {
        "d": "M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"
      }
    })])])];
  })], 2)]), _vm.effect === "swipe" ? _c("div", {
    staticClass: "cool-lightbox__wrapper cool-lightbox__wrapper--swipe",
    style: {
      transform: "translate3d(" + _vm.xSwipeWrapper + "px, " + _vm.ySwipeWrapper + "px, 0)",
      transition: _vm.swipeAnimation
    }
  }, _vm._l(_vm.items, function(item, itemIndex) {
    return _c("div", {
      key: itemIndex,
      ref: "items",
      refInFor: true,
      staticClass: "cool-lightbox__slide",
      class: {
        "cool-lightbox__slide--current": itemIndex === _vm.imgIndex
      }
    }, [_vm.getMediaType(itemIndex) === "image" ? _c("div", {
      directives: [{
        name: "lazyload",
        rawName: "v-lazyload"
      }],
      key: "image",
      staticClass: "cool-lightbox__slide__img",
      style: _vm.imgWrapperStyle
    }, [!_vm.isItemPicture(itemIndex) ? _c("img", {
      key: itemIndex,
      attrs: {
        "data-src": _vm.getItemSrc(itemIndex),
        "data-srcset": _vm.getItemSrcSet(itemIndex),
        "data-sizes": _vm.getItemSizes(itemIndex),
        "draggable": "false",
        "alt": _vm.getItemAlt(itemIndex)
      },
      on: {
        "load": _vm.imageLoaded,
        "click": function($event) {
          return _vm.zoomImage(itemIndex);
        },
        "mousedown": function($event) {
          return _vm.handleMouseDown($event);
        },
        "mouseup": function($event) {
          return _vm.handleMouseUp($event);
        },
        "mousemove": function($event) {
          return _vm.handleMouseMove($event);
        },
        "touchstart": function($event) {
          return _vm.handleMouseDown($event);
        },
        "touchmove": function($event) {
          return _vm.handleMouseMove($event);
        },
        "touchend": function($event) {
          return _vm.handleMouseUp($event);
        }
      }
    }) : _c("picture", {
      key: itemIndex
    }, [_vm._l(_vm.getPictureSources(itemIndex), function(source, sourceIndex) {
      return _c("source", {
        key: `source-${_vm.imgIndex}-${sourceIndex}`,
        attrs: {
          "data-srcset": source.srcset,
          "data-media": source.media,
          "type": source.type,
          "data-sizes": source.sizes || _vm.getItemSizes(_vm.imgIndex)
        }
      });
    }), _c("img", {
      attrs: {
        "data-src": _vm.getItemSrc(itemIndex),
        "data-srcset": _vm.getItemSrcSet(itemIndex),
        "data-sizes": _vm.getItemSizes(itemIndex),
        "draggable": "false",
        "alt": _vm.getItemAlt(itemIndex)
      },
      on: {
        "load": _vm.imageLoaded,
        "click": function($event) {
          return _vm.zoomImage(itemIndex);
        },
        "mousedown": function($event) {
          return _vm.handleMouseDown($event);
        },
        "mouseup": function($event) {
          return _vm.handleMouseUp($event);
        },
        "mousemove": function($event) {
          return _vm.handleMouseMove($event);
        },
        "touchstart": function($event) {
          return _vm.handleMouseDown($event);
        },
        "touchmove": function($event) {
          return _vm.handleMouseMove($event);
        },
        "touchend": function($event) {
          return _vm.handleMouseUp($event);
        }
      }
    })], 2), _c("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.imageLoading,
        expression: "imageLoading"
      }],
      staticClass: "cool-lightbox-loading-wrapper"
    }, [_vm._t("loading", function() {
      return [_c("div", {
        staticClass: "cool-lightbox-loading"
      })];
    })], 2)]) : _vm._e(), _vm.getMediaType(_vm.imgIndex) === "html" ? _c("div", {
      staticClass: "cool-lightbox-html",
      style: _vm.imgWrapperStyle,
      domProps: {
        "innerHTML": _vm._s(_vm.getItemSrc(itemIndex))
      }
    }) : _c("div", {
      key: "video",
      staticClass: "cool-lightbox__iframe"
    }, [!_vm.checkIsMp4(_vm.getItemSrc(itemIndex)) && _vm.getMediaType(itemIndex) === "video" ? _c("iframe", {
      directives: [{
        name: "autoplayObserver",
        rawName: "v-autoplayObserver"
      }],
      key: itemIndex,
      staticClass: "cool-lightbox-video",
      style: _vm.aspectRatioVideo,
      attrs: {
        "data-autoplay": _vm.setAutoplay(itemIndex),
        "src": _vm.getVideoUrl(_vm.getItemSrc(itemIndex)),
        "frameborder": "0",
        "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
        "allowfullscreen": ""
      }
    }) : _vm._e(), _vm.getMediaType(itemIndex) === "iframe" || _vm.getPDFurl(_vm.getItemSrc(itemIndex)) ? _c("iframe", {
      key: itemIndex,
      staticClass: "cool-lightbox-pdf",
      attrs: {
        "src": _vm.getItemSrc(itemIndex),
        "frameborder": "0",
        "allowfullscreen": ""
      }
    }) : _vm._e(), _vm.checkIsMp4(_vm.getItemSrc(itemIndex)) || _vm.getMediaType(itemIndex) === "webVideo" ? _c("video", {
      directives: [{
        name: "autoplayObserver",
        rawName: "v-autoplayObserver"
      }],
      key: _vm.checkIsMp4(_vm.getItemSrc(itemIndex)),
      staticClass: "cool-lightbox-video",
      style: _vm.aspectRatioVideo,
      attrs: {
        "data-autoplay": _vm.setAutoplay(itemIndex),
        "controls": "",
        "controlslist": "nodownload",
        "l": "",
        "poster": require("")
      }
    }, [_c("source", {
      attrs: {
        "src": _vm.checkIsMp4(_vm.getItemSrc(itemIndex)),
        "type": "video/" + (_vm.getVideoExt(_vm.getItemSrc(itemIndex)) ? _vm.getVideoExt(_vm.getItemSrc(itemIndex)) : _vm.getExtFromItem(itemIndex))
      }
    }), _vm._v(" Sorry, your browser doesn't support embedded videos ")]) : _vm._e()])]);
  }), 0) : _vm._e(), _vm.effect === "fade" ? _c("div", {
    staticClass: "cool-lightbox__wrapper"
  }, [_c("div", {
    ref: "items",
    staticClass: "cool-lightbox__slide cool-lightbox__slide--current"
  }, [_c("transition", {
    attrs: {
      "name": "cool-lightbox-slide-change",
      "mode": "out-in"
    }
  }, [_vm.getMediaType(_vm.imgIndex) === "image" ? _c("div", {
    key: "image",
    staticClass: "cool-lightbox__slide__img",
    style: _vm.imgWrapperStyle
  }, [!_vm.isItemPicture(_vm.imgIndex) ? _c("transition", {
    attrs: {
      "name": "cool-lightbox-slide-change",
      "mode": "out-in"
    }
  }, [_c("img", {
    key: _vm.imgIndex,
    attrs: {
      "src": _vm.getItemSrc(_vm.imgIndex),
      "srcset": _vm.getItemSrcSet(_vm.imgIndex),
      "sizes": _vm.getItemSizes(_vm.imgIndex),
      "draggable": "false",
      "alt": _vm.getItemAlt(_vm.imgIndex)
    },
    on: {
      "load": _vm.imageLoaded,
      "click": _vm.zoomImage,
      "mousedown": function($event) {
        return _vm.handleMouseDown($event);
      },
      "mouseup": function($event) {
        return _vm.handleMouseUp($event);
      },
      "mousemove": function($event) {
        return _vm.handleMouseMove($event);
      }
    }
  })]) : _c("transition", {
    attrs: {
      "name": "cool-lightbox-slide-change",
      "mode": "out-in"
    }
  }, [_c("picture", {
    key: _vm.imgIndex
  }, [_vm._l(_vm.getPictureSources(_vm.imgIndex), function(source, sourceIndex) {
    return _c("source", {
      key: `source-${_vm.imgIndex}-${sourceIndex}`,
      attrs: {
        "srcset": source.srcset,
        "type": source.type,
        "media": source.media,
        "sizes": source.sizes || _vm.getItemSizes(_vm.imgIndex)
      }
    });
  }), _c("img", {
    attrs: {
      "src": _vm.getItemSrc(_vm.imgIndex),
      "srcset": _vm.getItemSrcSet(_vm.imgIndex),
      "sizes": _vm.getItemSizes(_vm.imgIndex),
      "draggable": "false",
      "alt": _vm.getItemAlt(_vm.imgIndex)
    },
    on: {
      "load": _vm.imageLoaded,
      "click": function($event) {
        return _vm.zoomImage(_vm.imgIndex);
      },
      "mousedown": function($event) {
        return _vm.handleMouseDown($event);
      },
      "mouseup": function($event) {
        return _vm.handleMouseUp($event);
      },
      "mousemove": function($event) {
        return _vm.handleMouseMove($event);
      }
    }
  })], 2)]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.imageLoading,
      expression: "imageLoading"
    }],
    staticClass: "cool-lightbox-loading-wrapper"
  }, [_vm._t("loading", function() {
    return [_c("div", {
      staticClass: "cool-lightbox-loading"
    })];
  })], 2)], 1) : _c("div", {
    key: "html",
    staticClass: "cool-lightbox__iframe"
  }, [_c("transition", {
    attrs: {
      "name": "cool-lightbox-slide-change",
      "mode": "out-in"
    }
  }, [_vm.getMediaType(_vm.imgIndex) === "html" ? _c("div", {
    staticClass: "cool-lightbox-html",
    style: _vm.imgWrapperStyle,
    domProps: {
      "innerHTML": _vm._s(_vm.getItemSrc(_vm.itemIndex))
    }
  }) : _vm._e()])], 1)])], 1)]) : _vm._e(), _c("transition", {
    attrs: {
      "name": "cool-lightbox-modal"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.checkIfIsObject(_vm.imgIndex) && (_vm.items[_vm.imgIndex].title || _vm.items[_vm.imgIndex].description),
      expression: "checkIfIsObject(imgIndex) && (items[imgIndex].title || items[imgIndex].description)"
    }],
    key: "caption-block",
    staticClass: "cool-lightbox-caption"
  }, [_c("transition", {
    attrs: {
      "name": "cool-lightbox-slide-change",
      "mode": "out-in"
    }
  }, [_vm.checkIfIsObject(_vm.imgIndex) && _vm.items[_vm.imgIndex].title ? _c("h6", {
    key: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.items[_vm.imgIndex].title)
    }
  }) : _vm._e()]), _c("transition", {
    attrs: {
      "name": "cool-lightbox-slide-change",
      "mode": "out-in"
    }
  }, [_vm.checkIfIsObject(_vm.imgIndex) && _vm.items[_vm.imgIndex].description ? _c("p", {
    key: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.$global.utils.text.sanitizeHtml(_vm.items[_vm.imgIndex].description.replace(/\n|\r/g, "<br>")))
    }
  }) : _vm._e()])], 1)]), _c("div", {
    staticClass: "cool-lightbox-toolbar",
    class: _vm.buttonsClasses
  }, [this.slideshow && _vm.items.length > 1 ? _c("button", {
    staticClass: "cool-lightbox-toolbar__btn",
    attrs: {
      "type": "button",
      "title": "Play slideshow"
    },
    on: {
      "click": _vm.togglePlaySlideshow
    }
  }, [!_vm.isPlayingSlideShow ? _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c("path", {
    attrs: {
      "d": "M6.5 5.4v13.2l11-6.6z"
    }
  })]) : _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c("g", [_c("rect", {
    attrs: {
      "id": "svg_4",
      "height": "11.97529",
      "width": "11.728392",
      "y": "6.030873",
      "x": "6.259265",
      "stroke-width": "1.5",
      "stroke": "#000",
      "fill": "#000000"
    }
  })])])]) : _vm._e(), _vm.items.length > 1 && _vm.gallery ? _c("button", {
    staticClass: "cool-lightbox-toolbar__btn",
    attrs: {
      "type": "button",
      "title": "Show thumbnails"
    },
    on: {
      "click": function($event) {
        _vm.showThumbs = !_vm.showThumbs;
      }
    }
  }, [_c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c("path", {
    attrs: {
      "d": "M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47\n            0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47\n            0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47\n            0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"
    }
  })])]) : _vm._e(), _vm.fullScreen ? _c("button", {
    staticClass: "cool-lightbox-toolbar__btn",
    attrs: {
      "type": "button",
      "title": "Fullscreen"
    },
    on: {
      "click": _vm.toggleFullScreenMode
    }
  }, [_c("svg", {
    attrs: {
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 18 18",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c("path", {
    attrs: {
      "d": "M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z"
    }
  })])]) : _vm._e(), _vm.showCloseButton ? _c("button", {
    staticClass: "cool-lightbox-toolbar__btn",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._t("close", function() {
    return [_c("svg", {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }
    }, [_c("path", {
      attrs: {
        "d": "M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"
      }
    })])];
  })], 2) : _vm._e()])], 1), _c("transition", {
    attrs: {
      "name": "cool-lightbox-modal"
    }
  }, [_vm.isZooming && _vm.useZoomBar ? _c("div", {
    staticClass: "cool-lightbox-zoom"
  }, [_c("svg", {
    staticClass: "cool-lightbox-zoom__icon",
    attrs: {
      "height": "469pt",
      "viewBox": "0 -192 469.33333 469",
      "width": "469pt",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c("path", {
    attrs: {
      "d": "m437.332031.167969h-405.332031c-17.664062\n          0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938\n          32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"
    }
  })]), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.zoomBar,
      expression: "zoomBar"
    }],
    attrs: {
      "type": "range",
      "name": "points",
      "min": "0",
      "max": "50"
    },
    domProps: {
      "value": _vm.zoomBar
    },
    on: {
      "__r": function($event) {
        _vm.zoomBar = $event.target.value;
      }
    }
  }), _c("svg", {
    staticClass: "cool-lightbox-zoom__icon",
    attrs: {
      "height": "426.66667pt",
      "viewBox": "0 0 426.66667 426.66667",
      "width": "426.66667pt",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c("path", {
    attrs: {
      "d": "m405.332031 192h-170.664062v-170.667969c0-11.773437-9.558594-21.332031-21.335938-21.332031-11.773437 0-21.332031\n          9.558594-21.332031 21.332031v170.667969h-170.667969c-11.773437 0-21.332031 9.558594-21.332031 21.332031 0\n          11.777344 9.558594 21.335938 21.332031 21.335938h170.667969v170.664062c0 11.777344 9.558594 21.335938 21.332031\n          21.335938 11.777344 0 21.335938-9.558594 21.335938-21.335938v-170.664062h170.664062c11.777344 0 21.335938-9.558594\n          21.335938-21.335938 0-11.773437-9.558594-21.332031-21.335938-21.332031zm0 0"
    }
  })])]) : _vm._e()])], 1) : _vm._e()]);
};
var staticRenderFns$A = [];
const CoolLightBox_vue_vue_type_style_index_0_lang = "";
const __vue2_script$A = {
  directives: {
    lazyload: LazyLoadDirective,
    autoplayObserver: AutoplayObserver
  },
  data() {
    return {
      // swipe data
      initialMouseX: 0,
      initialMouseY: 0,
      endMouseX: 0,
      endMouseY: 0,
      swipeType: null,
      IsSwipping: false,
      isDraggingSwipe: false,
      // use for mouse wheel
      prevTime: 0,
      // swipe effect
      xSwipeWrapper: 0,
      ySwipeWrapper: 0,
      swipeAnimation: null,
      swipeInterval: null,
      lightboxInnerWidth: null,
      // styles data
      imgIndex: this.index,
      isVisible: false,
      paddingBottom: false,
      imageLoading: false,
      showThumbs: true,
      isFullScreenMode: false,
      // aspect ratio videos
      aspectRatioVideo: {
        width: "auto",
        height: "auto"
      },
      // props to bind styles
      buttonsVisible: true,
      scale: 1,
      top: 0,
      left: 0,
      lastX: 0,
      lastY: 0,
      isDraging: false,
      canZoom: true,
      isZooming: false,
      transition: "all .3s ease",
      zoomBar: 0,
      // slideshow playing data
      isPlayingSlideShow: false,
      intervalProgress: null,
      loopData: false,
      stylesInterval: {
        "display": "block"
      }
    };
  },
  props: {
    index: {
      required: true
    },
    effect: {
      type: String,
      default: "swipe"
    },
    items: {
      type: Array,
      required: true
    },
    loop: {
      type: Boolean,
      default: true
    },
    slideshow: {
      type: Boolean,
      default: true
    },
    slideshowColorBar: {
      type: String,
      default: "#9785fc"
    },
    slideshowDuration: {
      type: Number,
      default: 3e3
    },
    useZoomBar: {
      type: Boolean,
      default: false
    },
    closeOnClickOutsideMobile: {
      type: Boolean,
      default: false
    },
    srcName: {
      type: String,
      default: "src"
    },
    srcSetName: {
      type: String,
      default: "srcset"
    },
    srcThumb: {
      type: String,
      default: "thumb"
    },
    srcMediaType: {
      type: String,
      default: "mediaType"
    },
    overlayColor: {
      type: String,
      default: "rgba(30, 30, 30, .5)"
    },
    zIndex: {
      type: Number,
      default: 9999
    },
    gallery: {
      type: Boolean,
      default: true
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    thumbsPosition: {
      type: String,
      default: "right"
    },
    youtubeCookies: {
      type: Boolean,
      default: true
    },
    enableWheelEvent: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    disableZoom: {
      type: Boolean,
      default: false
    },
    dir: {
      type: String,
      default: "ltr"
    },
    enableScrollLock: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    zoomBar(newVal, prevVal) {
      let item;
      if (this.isZooming) {
        if (this.effect == "swipe") {
          item = this.$refs.items[this.imgIndex].childNodes[0];
        } else {
          item = this.$refs.items.childNodes[0];
        }
        const newZoom = 1.6 + newVal / 10;
        item.style.transform = "translate3d(calc(-50% + " + this.left + "px), calc(-50% + " + this.top + "px), 0px) scale3d(" + newZoom + ", " + newZoom + ", " + newZoom + ")";
      }
    },
    showThumbs(prev, val) {
      let widthGalleryBlock = 212;
      let swipeAnimation = "all .3s ease";
      if (window.innerWidth < 767) {
        widthGalleryBlock = 102;
        swipeAnimation = null;
      }
      if (this.thumbsPosition === "bottom") {
        widthGalleryBlock = 0;
      }
      const self2 = this;
      this.swipeAnimation = swipeAnimation;
      if (prev) {
        if (this.dir === "rtl") {
          this.xSwipeWrapper = this.imgIndex * (window.innerWidth - widthGalleryBlock) + 30 * this.imgIndex;
        } else {
          this.xSwipeWrapper = -this.imgIndex * (window.innerWidth - widthGalleryBlock) - 30 * this.imgIndex;
        }
      } else {
        if (this.dir === "rtl") {
          this.xSwipeWrapper = this.imgIndex * window.innerWidth + 30 * this.imgIndex;
        } else {
          this.xSwipeWrapper = -this.imgIndex * window.innerWidth - 30 * this.imgIndex;
        }
      }
      setTimeout(function() {
        self2.swipeAnimation = null;
      }, 300);
    },
    index(prev, val) {
      const self2 = this;
      document.querySelector("body");
      if (prev !== null) {
        this.swipeType = null;
        this.initialMouseY = 0;
        this.ySwipeWrapper = 0;
        this.loopData = this.loop;
        if (this.effect === "swipe") {
          this.loopData = false;
          window.addEventListener("resize", this.xPositionOnResize);
        }
        this.imgIndex = prev;
        this.isVisible = true;
        window.addEventListener("keydown", this.eventListener);
        if (this.enableWheelEvent) {
          window.addEventListener("wheel", this.wheelEvent);
        }
        if (window.innerWidth < 700) {
          setTimeout(function() {
            window.addEventListener("click", self2.showButtons);
          }, 200);
        }
        if (this.enableScrollLock) {
          setTimeout(function() {
            self2.setCompensateForScrollbar();
            disableBodyScroll(self2.$refs.coolLightbox);
          }, 50);
        }
      } else {
        this.isVisible = false;
        this.stopSlideShow();
        this.startsX = 0;
        this.initialMouseY = 0;
        this.swipeType = null;
        clearInterval(this.swipeInterval);
        this.swipeAnimation = null;
        this.isDraggingSwipe = false;
        this.isZooming = true;
        window.removeEventListener("keydown", this.eventListener);
        if (this.enableScrollLock) {
          self2.removeCompensateForScrollbar();
          enableBodyScroll(self2.$refs.coolLightbox);
        }
        window.removeEventListener("click", this.showButtons);
        window.removeEventListener("resize", this.xPositionOnResize);
        if (this.enableWheelEvent) {
          window.removeEventListener("wheel", this.wheelEvent);
        }
      }
    },
    imgIndex(prev, val) {
      this.$nextTick(() => {
        if (this.effect === "swipe") {
          this.setLightboxInnerWidth();
          this.setXPosition(prev);
        }
        if (prev !== null & val === null) {
          this.$emit("on-open", prev);
        }
        if (prev !== null) {
          if (prev !== val) {
            if (!this.getYoutubeUrl(this.getItemSrc(prev)) && !this.getVimeoUrl(this.getItemSrc(prev))) {
              this.stopVideos();
            }
          }
          if (!this.getVideoUrl(this.getItemSrc(prev))) {
            if (!this.is_cached(this.getItemSrc(prev))) {
              this.imageLoading = true;
            }
          }
          this.addCaptionPadding();
          if (this.effect === "swipe") {
            this.setAspectRatioVideo();
          } else {
            if (this.getVideoUrl(this.getItemSrc(prev))) {
              this.setAspectRatioVideo();
            }
          }
        }
        this.resetZoom();
        this.swipeType = null;
        this.ySwipeWrapper = 0;
      });
    }
  },
  beforeDestroy() {
    if (this.enableScrollLock) {
      this.removeCompensateForScrollbar();
      if (this.$refs.coolLightbox) {
        enableBodyScroll(this.$refs.coolLightbox);
      }
    }
  },
  methods: {
    getExtFromItem(imgIndex) {
      if (imgIndex === null) {
        return false;
      }
      if (this.checkIfIsObject(imgIndex)) {
        const item = this.items[imgIndex];
        if (item["ext"]) {
          return item["ext"];
        }
        return "mp4";
      }
    },
    stopVideos() {
      const videos = document.getElementsByClassName("cool-lightbox-video");
      const isVideoPlaying = (video) => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
      if (videos.length > 0) {
        Array.prototype.forEach.call(videos, (video) => {
          const type = video.tagName;
          if (type === "IFRAME") {
            var iframeSrc = video.src;
            return video.src = iframeSrc;
          }
          if (isVideoPlaying(video)) {
            return video.pause();
          }
        });
      }
    },
    removeCompensateForScrollbar() {
      document.body.classList.remove("compensate-for-scrollbar");
      const noscrollStyle = document.getElementById("coollightbox-style-noscroll");
      if (noscrollStyle !== null) {
        document.getElementById("coollightbox-style-noscroll").remove();
      }
    },
    setCompensateForScrollbar() {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (!isMobile && document.body.scrollHeight > window.innerHeight) {
        document.getElementsByTagName("head")[0].insertAdjacentHTML(
          "beforeend",
          '<style id="coollightbox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' + (window.innerWidth - document.documentElement.clientWidth) + "px;}</style>"
        );
        document.body.classList.add("compensate-for-scrollbar");
      }
    },
    setAutoplay(itemIndex) {
      if (this.checkIfIsObject(itemIndex) && this.items[itemIndex].hasOwnProperty("autoplay") && this.items[itemIndex].autoplay) {
        return true;
      }
      return false;
    },
    toggleFullScreenMode() {
      if (this.isFullScreenMode) {
        this.closeFullscreen();
      } else {
        this.fullScreenMode();
      }
      this.isFullScreenMode = !this.isFullScreenMode;
    },
    closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    fullScreenMode() {
      var elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    },
    // check if event is arrow button or toolbar button
    checkIfIsButton(event) {
      var elements = ".cool-lightbox__iframe *, .cool-lightbox-button, .cool-lightbox-button *, .cool-lightbox-toolbar__btn, .cool-lightbox-toolbar__btn *, .cool-lightbox-caption h6, .cool-lightbox-caption p, .cool-lightbox-caption a";
      if (event.target.matches(elements)) {
        return true;
      }
      return false;
    },
    // start swipe event
    startSwipe(event) {
      if (this.isZooming) {
        return false;
      }
      if (this.checkIfIsButton(event)) {
        return false;
      }
      clearInterval(this.swipeInterval);
      this.swipeAnimation = null;
      this.isDraggingSwipe = true;
      this.initialMouseX = this.getMouseXPosFromEvent(event);
      this.initialMouseY = this.getMouseYPosFromEvent(event);
    },
    // continue swipe event
    continueSwipe(event) {
      if (this.isDraggingSwipe) {
        this.IsSwipping = true;
        const currentPosX = this.getMouseXPosFromEvent(event);
        const currentPosY = this.getMouseYPosFromEvent(event);
        const windowWidth = this.lightboxInnerWidth;
        const diffX = Math.abs(currentPosX - this.initialMouseX);
        const diffY = Math.abs(currentPosY - this.initialMouseY);
        if (this.swipeType == null) {
          if (diffY > 5 || diffX > 5) {
            if (diffY > diffX) {
              this.swipeType = "v";
            } else {
              this.swipeType = "h";
            }
          }
        }
        if (this.swipeType == "h") {
          if (this.dir === "rtl") {
            this.xSwipeWrapper = windowWidth * this.imgIndex + currentPosX - this.initialMouseX + 30 * this.imgIndex;
          } else {
            this.xSwipeWrapper = -(windowWidth * this.imgIndex) + currentPosX - this.initialMouseX - 30 * this.imgIndex;
          }
        } else {
          this.ySwipeWrapper = currentPosY - this.initialMouseY;
        }
        if (event.type === "touchmove") {
          this.endMouseX = this.getMouseXPosFromEvent(event);
          this.endMouseY = this.getMouseYPosFromEvent(event);
        }
      }
    },
    // end swipe event
    endSwipe(event) {
      if (this.checkIfIsButton(event) && this.initialMouseX === 0) {
        return false;
      }
      const self2 = this;
      const swipeType = this.swipeType;
      this.isDraggingSwipe = false;
      if (this.initialMouseX === 0 && swipeType == "h") {
        return false;
      }
      if (event.type !== "touchend") {
        this.endMouseX = this.getMouseXPosFromEvent(event);
        this.endMouseY = this.getMouseYPosFromEvent(event);
      } else {
        if (this.endMouseX === 0) {
          return;
        }
      }
      if (this.endMouseX - this.initialMouseX === 0 && swipeType == "h" || this.isZooming || this.endMouseY - this.initialMouseY === 0 && swipeType == "v") {
        return;
      }
      this.setSwipeAnimation();
      setTimeout(function() {
        self2.IsSwipping = false;
        self2.initialMouseX = 0;
        self2.endMouseX = 0;
      }, 10);
      if (this.swipeType === "h") {
        if (this.endMouseX - this.initialMouseX < -40) {
          if (this.dir === "rtl") {
            return this.swipeToLeft();
          }
          return this.swipeToRight();
        }
        if (this.endMouseX - this.initialMouseX > 40) {
          if (this.dir === "rtl") {
            return this.swipeToRight();
          }
          return this.swipeToLeft();
        }
      }
      if (this.swipeType === "v") {
        const diffY = Math.abs(this.endMouseY - this.initialMouseY);
        if (diffY >= 90) {
          this.close();
        } else {
          this.ySwipeWrapper = 0;
        }
      }
      this.swipeType = null;
      const windowWidth = this.lightboxInnerWidth;
      if (this.dir === "rtl") {
        this.xSwipeWrapper = this.imgIndex * windowWidth + 30 * this.imgIndex;
        return;
      }
      this.xSwipeWrapper = -this.imgIndex * windowWidth - 30 * this.imgIndex;
    },
    // swipe to left effect
    swipeToLeft() {
      if (!this.hasPrevious && this.effect === "swipe") {
        if (this.dir === "rtl") {
          return this.xSwipeWrapper = this.imgIndex * this.lightboxInnerWidth + 30 * this.imgIndex;
        }
        return this.xSwipeWrapper = -this.imgIndex * this.lightboxInnerWidth - 30 * this.imgIndex;
      }
      this.changeIndexToPrev();
    },
    // swipe to right effect
    swipeToRight() {
      if (!this.hasNext && this.effect === "swipe") {
        if (this.dir === "rtl") {
          return this.xSwipeWrapper = this.imgIndex * this.lightboxInnerWidth + 30 * this.imgIndex;
        }
        return this.xSwipeWrapper = -this.imgIndex * this.lightboxInnerWidth - 30 * this.imgIndex;
      }
      this.changeIndexToNext();
    },
    // function that return x position from event
    getMouseXPosFromEvent(event) {
      if (event.type.indexOf("mouse") !== -1) {
        return event.clientX;
      }
      return event.touches[0].clientX;
    },
    // function that return Y position from event
    getMouseYPosFromEvent(event) {
      if (event.type.indexOf("mouse") !== -1) {
        return event.clientY;
      }
      return event.touches[0].clientY;
    },
    // check if the image is cached
    is_cached(src) {
      var image = new Image();
      image.src = src;
      return image.complete;
    },
    // image loaded event
    imageLoaded() {
      this.imageLoading = false;
    },
    // get video url
    itemThumb(itemUrl, itemIndex) {
      var thumb = this.getItemThumb(itemIndex);
      if (thumb) {
        return thumb;
      }
      var youtubeID = this.getYoutubeID(itemUrl);
      if (youtubeID) {
        return "https://img.youtube.com/vi/" + youtubeID + "/mqdefault.jpg";
      }
      var vimeoID = this.getVimeoID(itemUrl);
      if (vimeoID) {
        return false;
      }
      return itemUrl;
    },
    isItemPicture(imgIndex) {
      if (imgIndex === null) {
        return false;
      }
      const item = this.items[imgIndex];
      if (this.checkIfIsObject(imgIndex)) {
        return item.picture;
      }
      return false;
    },
    getPictureSources(imgIndex) {
      if (imgIndex === null) {
        return false;
      }
      const picture = this.items[imgIndex].picture;
      return picture.sources ? picture.sources : [];
    },
    // get item src
    getItemSrc(imgIndex) {
      if (imgIndex === null) {
        return false;
      }
      const item = this.items[imgIndex];
      if (this.checkIfIsObject(imgIndex)) {
        return item[this.srcName];
      }
      return item;
    },
    getItemSrcSet(imgIndex) {
      if (imgIndex === null) {
        return false;
      }
      const item = this.items[imgIndex];
      if (this.checkIfIsObject(imgIndex)) {
        return item[this.srcSetName];
      }
      return null;
    },
    getItemSizes(imgIndex) {
      if (imgIndex === null) {
        return false;
      }
      const item = this.items[imgIndex];
      if (this.checkIfIsObject(imgIndex)) {
        return item.sizes;
      }
      return null;
    },
    getItemAlt(imgIndex) {
      if (imgIndex === null) {
        return false;
      }
      const item = this.items[imgIndex];
      if (this.checkIfIsObject(imgIndex)) {
        return item.alt;
      }
      return null;
    },
    getItemThumb(imgIndex) {
      if (imgIndex === null) {
        return false;
      }
      const item = this.items[imgIndex];
      if (this.checkIfIsObject(imgIndex)) {
        return item[this.srcThumb];
      }
      if (this.getVideoUrl(item)) {
        return false;
      }
      return item;
    },
    // get item media type
    getMediaType(imgIndex) {
      if (imgIndex === null) {
        return false;
      }
      if (this.checkIfIsObject(imgIndex)) {
        const item = this.items[imgIndex];
        if (item[this.srcMediaType]) {
          return item[this.srcMediaType];
        }
      }
      if (/<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/.test(this.getItemSrc(imgIndex))) {
        return "html";
      } else if (this.getVideoUrl(this.getItemSrc(imgIndex))) {
        return "video";
      } else if (this.getPDFurl(this.getItemSrc(imgIndex))) {
        return "iframe";
      } else {
        return "image";
      }
    },
    // toggle play slideshow event
    togglePlaySlideshow() {
      if (!this.slideshow) {
        return false;
      }
      if (!this.hasNext && !this.loopData) {
        return false;
      }
      this.isPlayingSlideShow = !this.isPlayingSlideShow;
      if (this.isPlayingSlideShow) {
        this.move();
      } else {
        this.stopSlideShow();
      }
    },
    // stop slideshow
    stopSlideShow() {
      this.isPlayingSlideShow = false;
      clearInterval(this.intervalProgress);
      this.stylesInterval = {
        "transform": "scaleX(0)",
        "transition": "none"
      };
    },
    // move event in zoom
    move() {
      const self2 = this;
      this.progressWidth = 100;
      this.intervalProgress = setInterval(frame, this.slideshowDuration + 90);
      self2.stylesInterval = {
        "transform": "scaleX(1)",
        "background": this.slideshowColorBar,
        "transition-duration": this.slideshowDuration + "ms"
      };
      function frame() {
        self2.stylesInterval = {
          "transform": "scaleX(0)",
          "transition": "none"
        };
        if (self2.dir === "rtl") {
          self2.onPrevClick(true);
        } else {
          self2.onNextClick(true);
        }
        if (!self2.hasNext && !self2.loopData) {
          self2.stopSlideShow();
        } else {
          setTimeout(function() {
            self2.stylesInterval = {
              "transform": "scaleX(1)",
              "background": self2.slideshowColorBar,
              "transition-duration": self2.slideshowDuration + "ms"
            };
          }, 50);
        }
      }
    },
    // show buttons event
    showButtons(event) {
      if (!this.checkIfIsButton(event)) {
        const self2 = this;
        setTimeout(function() {
          self2.buttonsVisible = !self2.buttonsVisible;
        }, 100);
      }
    },
    // check if is allowed to drag
    checkMouseEventPropButton(button) {
      if (!this.isZooming)
        return false;
      return button === 0;
    },
    // handle mouse down event
    handleMouseDown(e) {
      if (!this.checkMouseEventPropButton(e.button))
        return;
      this.lastX = e.clientX;
      this.lastY = e.clientY;
      this.isDraging = true;
      e.stopPropagation();
    },
    // handle mouse up event
    handleMouseUp(e) {
      if (!this.checkMouseEventPropButton(e.button))
        return;
      this.isDraging = false;
      this.lastX = this.lastY = 0;
      const thisContext = this;
      setTimeout(function() {
        thisContext.canZoom = true;
      }, 100);
    },
    // handle mouse move event
    handleMouseMove(e) {
      if (!this.checkMouseEventPropButton(e.button))
        return;
      if (this.isDraging) {
        this.top = this.top - this.lastY + e.clientY;
        this.left = this.left - this.lastX + e.clientX;
        this.lastX = e.clientX;
        this.lastY = e.clientY;
        this.canZoom = false;
        const item = e.target.parentNode.nodeName === "PICTURE" ? e.target.parentNode.parentNode : e.target.parentNode;
        const newZoom = 1.6 + this.zoomBar / 10;
        item.style.transform = "translate3d(calc(-50% + " + this.left + "px), calc(-50% + " + this.top + "px), 0px) scale3d(" + newZoom + ", " + newZoom + ", " + newZoom + ")";
      }
      e.stopPropagation();
    },
    // zoom image event
    zoomImage(indexImage) {
      if (this.disableZoom) {
        return false;
      }
      if (window.innerWidth < 700) {
        return false;
      }
      if (!this.canZoom) {
        return false;
      }
      if (this.IsSwipping) {
        return false;
      }
      let item;
      if (this.effect == "swipe") {
        item = this.$refs.items[this.imgIndex].childNodes[0];
      } else {
        item = this.$refs.items.childNodes[0];
      }
      const isZooming = this.isZooming;
      const thisContext = this;
      if (isZooming) {
        if (!this.isDraging) {
          this.isZooming = false;
          this.zoomBar = 0;
        }
      } else {
        this.isZooming = true;
      }
      if (this.isZooming) {
        this.stopSlideShow();
        item.style.transform = "translate3d(calc(-50%), calc(-50%), 0px) scale3d(1.6, 1.6, 1.6)";
        this.buttonsVisible = false;
        setTimeout(function() {
          thisContext.transition = "all .0s ease";
        }, 100);
      } else {
        this.buttonsVisible = true;
        this.resetZoom();
      }
    },
    // Reset zoom data
    resetZoom() {
      this.scale = 1;
      this.left = 0;
      this.top = 0;
      this.zoomBar = 0;
      this.isZooming = false;
      this.swipeType = null;
      this.transition = "all .3s ease";
      if (this.imgIndex != null) {
        let item;
        if (this.effect == "swipe") {
          item = this.$refs.items[this.imgIndex].childNodes[0];
        } else {
          item = this.$refs.items.childNodes[0];
        }
        if (item.nodeType !== 8) {
          if (this.disableZoom) {
            item.style.transform = "translate3d(calc(-50% + " + this.left + "px), calc(-50% + " + this.top + "px), 0px)";
          } else {
            item.style.transform = "translate3d(calc(-50% + " + this.left + "px), calc(-50% + " + this.top + "px), 0px) scale3d(1, 1, 1)";
          }
        }
        this.initialMouseX = 0;
        if (window.innerWidth >= 700) {
          this.buttonsVisible = true;
        }
      }
    },
    // Aspect Ratio responsive video
    setAspectRatioVideo() {
      const thisContext = this;
      let el = document.getElementsByClassName("cool-lightbox__inner");
      el = el[0];
      let computedStyle = getComputedStyle(el);
      if (window.innerWidth < 1440) {
        let width = el.clientWidth;
        let height = Math.round(width / 16 * 9);
        this.aspectRatioVideo.height = height + "px";
        this.aspectRatioVideo.width = width + "px";
      } else {
        setTimeout(function() {
          let height = el.clientHeight;
          height -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
          let width = height / 9 * 16;
          thisContext.aspectRatioVideo.height = height + "px";
          thisContext.aspectRatioVideo.width = width + "px";
        }, 150);
      }
    },
    // close event
    close() {
      this.stopSlideShow();
      this.swipeType = null;
      this.$emit("close", this.imgIndex);
      this.showThumbs = true;
      this.imgIndex = null;
    },
    wheelEvent(event) {
      const delay = 350;
      const currentTime = (/* @__PURE__ */ new Date()).getTime();
      let direction = event.deltaY > 0 ? "top" : "down";
      if (currentTime - this.prevTime < delay)
        return;
      this.prevTime = currentTime;
      switch (direction) {
        case "top":
          return this.changeIndexToPrev();
        case "down":
          return this.changeIndexToNext();
      }
    },
    // close event click outside
    closeModal(event) {
      if (!this.closeOnClickOutsideMobile) {
        if (window.innerWidth < 700) {
          return false;
        }
      }
      if (this.IsSwipping) {
        return false;
      }
      var elements = ".cool-lightbox__iframe, .cool-lightbox__iframe *, .cool-lightbox-zoom, .cool-lightbox-zoom *, .cool-lightbox-thumbs, svg, path, rect, .cool-lightbox-thumbs *, .cool-lightbox-button, .cool-lightbox-toolbar__btn, .cool-lightbox-toolbar__btn *, .cool-lightbox-button *, .cool-lightbox__slide__img *, .cool-lightbox-video, .cool-lightbox-caption h6, .cool-lightbox-caption p, .cool-lightbox-caption a";
      if (!event.target.matches(elements)) {
        this.close();
      }
    },
    // set swipe animation
    setSwipeAnimation() {
      const self2 = this;
      clearInterval(this.swipeInterval);
      this.swipeAnimation = null;
      this.swipeAnimation = "all .3s ease";
      this.swipeInterval = setInterval(interval, 330);
      function interval() {
        self2.swipeAnimation = null;
      }
    },
    // next slide event
    onNextClick(isFromSlideshow = false) {
      if (this.isZooming) {
        return false;
      }
      if (!isFromSlideshow) {
        this.stopSlideShow();
      }
      this.setSwipeAnimation();
      if (this.dir === "rtl") {
        return this.changeIndexToPrev();
      }
      this.changeIndexToNext();
    },
    // prev slide event
    onPrevClick(isFromSlideshow = false) {
      if (this.isZooming) {
        return false;
      }
      if (!isFromSlideshow) {
        this.stopSlideShow();
      }
      this.setSwipeAnimation();
      if (this.dir === "rtl") {
        return this.changeIndexToNext();
      }
      this.changeIndexToPrev();
    },
    // change to next index
    changeIndexToNext() {
      if (this.hasNext) {
        this.onIndexChange(this.imgIndex + 1);
      } else {
        if (this.loopData) {
          this.onIndexChange(0);
        }
      }
    },
    // change to prev index
    changeIndexToPrev() {
      if (this.hasPrevious) {
        this.onIndexChange(this.imgIndex - 1);
      } else {
        if (this.loopData) {
          this.onIndexChange(this.items.length - 1);
        }
      }
    },
    // set lightbox inner width
    setLightboxInnerWidth() {
      let el = document.getElementsByClassName("cool-lightbox__inner");
      let width = el[0].clientWidth;
      this.lightboxInnerWidth = width;
    },
    // x position on resize event
    xPositionOnResize() {
      this.setLightboxInnerWidth();
      const index2 = this.imgIndex;
      if (this.dir === "rtl") {
        this.xSwipeWrapper = index2 * this.lightboxInnerWidth + 30 * index2;
        return;
      }
      this.xSwipeWrapper = -index2 * this.lightboxInnerWidth - 30 * index2;
    },
    // set x position by img index
    setXPosition(index2) {
      if (this.dir === "rtl") {
        this.xSwipeWrapper = index2 * this.lightboxInnerWidth + 30 * index2;
        return;
      }
      this.xSwipeWrapper = -index2 * this.lightboxInnerWidth - 30 * index2;
      return;
    },
    // index change
    onIndexChange(index2) {
      const self2 = this;
      this.imgIndex = index2;
      this.$emit("on-change", index2);
      setTimeout(function() {
        self2.$emit("on-change-end", index2);
      }, 400);
    },
    // caption size
    addCaptionPadding() {
      if (this.checkIfIsObject(this.imgIndex) && (this.items[this.imgIndex].title || this.items[this.imgIndex].descripcion)) {
        const el = document.getElementsByClassName("cool-lightbox-caption");
        if (el.length > 0) {
          this.paddingBottom = el[0].offsetHeight;
        }
      } else {
        this.paddingBottom = 60;
      }
    },
    getPDFurl(url) {
      if (this.imgIndex === null) {
        return false;
      }
      const str = new String(url);
      if (str.endsWith(".pdf")) {
        return url;
      }
      return false;
    },
    // check if is video
    getVideoUrl(itemSrc) {
      const youtubeUrl = this.getYoutubeUrl(itemSrc);
      const vimeoUrl = this.getVimeoUrl(itemSrc);
      const mp4Url = this.checkIsMp4(itemSrc);
      if (youtubeUrl) {
        return youtubeUrl;
      }
      if (vimeoUrl) {
        return vimeoUrl;
      }
      if (mp4Url) {
        return mp4Url;
      }
      return false;
    },
    // getYoutube ID
    getYoutubeID(url) {
      const youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      const ytId = url.match(youtubeRegex) ? RegExp.$1 : false;
      if (ytId) {
        return ytId;
      }
      return false;
    },
    // get youtube url
    getYoutubeUrl(url) {
      const ytId = this.getYoutubeID(url);
      if (ytId) {
        if (this.youtubeCookies) {
          return "https://www.youtube.com/embed/" + ytId;
        }
        return "https://www.youtube-nocookie.com/embed/" + ytId;
      }
      return false;
    },
    // vimeo ID
    getVimeoID(url) {
      const result2 = url.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i);
      if (result2 !== null) {
        return result2[1];
      }
      return false;
    },
    // get vimeo url
    getVimeoUrl(url) {
      const result2 = url.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i);
      if (result2 !== null) {
        return "//player.vimeo.com/video/" + result2[1] + "?hd=1&show_title=1&show_byline=1&show_portrait=0&fullscreen=1";
      }
      return false;
    },
    // check if video is mp4
    checkIsMp4(url) {
      if (this.imgIndex === null) {
        return false;
      }
      const str = new String(url);
      if (str.indexOf(".mp4") !== -1 || str.indexOf(".mov") !== -1 || str.indexOf(".webm") !== -1 || str.indexOf(".ogg") !== -1 || str.indexOf(".avi") !== -1) {
        return url;
      }
      return false;
    },
    // if is video get extension
    getVideoExt(url) {
      if (this.imgIndex === null) {
        return false;
      }
      const str = new String(url);
      if (str.indexOf(".mp4") !== -1 || str.indexOf(".mov") !== -1) {
        return "mp4";
      }
      if (str.indexOf(".webm") !== -1) {
        return "webm";
      }
      if (str.indexOf(".ogg") !== -1) {
        return "ogg";
      }
      if (str.indexOf(".avi") !== -1) {
        return "avi";
      }
      return false;
    },
    // check if item is object
    checkIfIsObject(itemIndex) {
      const item = this.items[itemIndex];
      if (typeof item === "object" && item !== null) {
        return true;
      }
      return false;
    },
    // arrows and escape events
    eventListener(e) {
      switch (e.keyCode) {
        case 39:
          return this.onNextClick();
        case 37:
          return this.onPrevClick();
        case 38:
        case 40:
        case " ":
          return e.preventDefault();
        case 27:
          return this.close();
      }
    }
  },
  computed: {
    // Images wrapper styles to use drag and zoom
    imgWrapperStyle() {
      return {
        top: `50%`,
        left: `50%`,
        transition: this.transition
      };
    },
    // lightbox styles
    lightboxStyles() {
      return {
        "z-index": this.zIndex,
        "background-color": this.overlayColor
      };
    },
    innerStyles() {
      return {
        "padding-bottom": this.paddingBottom + "px"
      };
    },
    // get item src
    itemSrc() {
      if (this.imgIndex === null) {
        return false;
      }
      const item = this.items[this.imgIndex];
      if (this.checkIfIsObject(this.imgIndex)) {
        return item[this.srcName];
      }
      return item;
    },
    // Lightbox classes
    lightboxClasses() {
      let classesReturn = [
        { "cool-lightbox--can-zoom": this.canZoom && !this.disableZoom },
        { "cool-lightbox--zoom-disabled": this.disableZoom },
        { "cool-lightbox--is-zooming": this.isZooming },
        { "cool-lightbox--show-thumbs": this.showThumbs },
        { "cool-lightbox--is-swipping": this.isDraggingSwipe }
      ];
      let classString = "cool-lightbox--thumbs-" + this.thumbsPosition;
      classesReturn.push(classString);
      return classesReturn;
    },
    // Buttons classes
    buttonsClasses() {
      return {
        "hidden": !this.buttonsVisible
      };
    },
    // check if the slide has next element
    hasNextButton() {
      if (this.dir === "rtl") {
        return this.imgIndex - 1 >= 0;
      }
      return this.imgIndex + 1 < this.items.length;
    },
    // check if the slide has previous element
    hasPreviousButton() {
      if (this.dir === "rtl") {
        return this.imgIndex + 1 < this.items.length;
      }
      return this.imgIndex - 1 >= 0;
    },
    // check if the slide has next element
    hasNext() {
      return this.imgIndex + 1 < this.items.length;
    },
    // check if the slide has previous element
    hasPrevious() {
      return this.imgIndex - 1 >= 0;
    }
  }
};
const __cssModules$A = {};
var __component__$A = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$A,
  render$A,
  staticRenderFns$A,
  false,
  __vue2_injectStyles$A,
  null,
  null,
  null
);
function __vue2_injectStyles$A(context) {
  for (let o in __cssModules$A) {
    this[o] = __cssModules$A[o];
  }
}
const CoolLightBox = /* @__PURE__ */ function() {
  return __component__$A.exports;
}();
function install(Vue2) {
  if (install.installed)
    return;
  install.installed = true;
  Vue2.component("CoolLightBox", CoolLightBox);
}
const plugin2 = {
  install
};
let GlobalVue = null;
if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue = global.vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin2);
}
CoolLightBox.install = install;
var render$z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    ref: "htmlContainer",
    staticClass: "mt-2",
    style: _vm.htmlHeight ? {
      height: `${_vm.htmlHeight}px`
    } : false,
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  });
};
var staticRenderFns$z = [];
const __vue2_script$z = {
  data() {
    return {
      resizeObserver: null,
      htmlHeight: null
    };
  },
  props: {
    html: {
      type: String,
      required: false
    }
  },
  mounted() {
    if (this.$refs.htmlContainer) {
      this.resizeObserver = new ResizeObserver(() => {
        var _a2;
        if ((_a2 = this.$refs.htmlContainer) == null ? void 0 : _a2.offsetHeight) {
          this.htmlHeight = this.$refs.htmlContainer.offsetHeight;
        }
      });
      this.resizeObserver.observe(this.$refs.htmlContainer);
    }
  },
  beforeDestroy() {
    var _a2;
    (_a2 = this.resizeObserver) == null ? void 0 : _a2.disconnect();
    this.resizeObserver = null;
  }
};
const __cssModules$z = {};
var __component__$z = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$z,
  render$z,
  staticRenderFns$z,
  false,
  __vue2_injectStyles$z,
  null,
  null,
  null
);
function __vue2_injectStyles$z(context) {
  for (let o in __cssModules$z) {
    this[o] = __cssModules$z[o];
  }
}
const groupListHtml = /* @__PURE__ */ function() {
  return __component__$z.exports;
}();
var render$y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.dpmStore.current.mattertagGroupList.length ? _c("div", {
    staticClass: "list-group df flex-column flex-grow-1"
  }, [_c("v-expansion-panels", {
    attrs: {
      "flat": ""
    }
  }, [_c("v-expansion-panel", [_c("v-expansion-panel-header", {
    staticClass: "py-0 px-3"
  }, [_c("v-text-field", {
    attrs: {
      "label": _vm.$t("cilbee.keywordSearch"),
      "clearable": "",
      "hide-details": "",
      "prepend-inner-icon": _vm.$global.icons.mdiMagnify,
      "dense": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    },
    model: {
      value: _vm.keywordText,
      callback: function($$v) {
        _vm.keywordText = $$v;
      },
      expression: "keywordText"
    }
  })], 1), _c("v-expansion-panel-content", [_c("v-checkbox", {
    attrs: {
      "label": _vm.$t("cilbee.titleOnly"),
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.titleOnly,
      callback: function($$v) {
        _vm.titleOnly = $$v;
      },
      expression: "titleOnly"
    }
  })], 1)], 1)], 1), _c("v-chip-group", {
    staticClass: "my-2 mx-3",
    attrs: {
      "active-class": "primary--text",
      "column": "",
      "multiple": ""
    },
    on: {
      "change": _vm.changeGroup
    },
    model: {
      value: _vm.filteredGroups,
      callback: function($$v) {
        _vm.filteredGroups = $$v;
      },
      expression: "filteredGroups"
    }
  }, [_vm.dpmStore.SED.mattertag_groups.length > 1 ? _c("v-chip", {
    attrs: {
      "filter": "",
      "filter-icon": _vm.$global.icons.mdiEye,
      "color": "black",
      "text-color": "black",
      "outlined": ""
    }
  }, [_vm._v("ALL")]) : _vm._e(), _vm._l(_vm.dpmStore.SED.mattertag_groups, function(group, i2) {
    return [_c("v-chip", {
      key: `v-chip-${i2}-${_vm.useBy}`,
      class: {
        "d-none": group.uneditable
      },
      attrs: {
        "filter": "",
        "filter-icon": _vm.$global.icons.mdiEye,
        "color": group.colorless ? "black" : _vm.$global.utils.toHex(group.color),
        "text-color": group.colorless ? "black" : "white",
        "outlined": group.colorless
      }
    }, [_vm._v(_vm._s(group.label))])];
  })], 2), _c("v-divider"), _c("div", {
    staticClass: "list-scroll-wrapper flex-grow-1"
  }, [_c("DynamicScroller", {
    staticClass: "h-100 ds-main",
    attrs: {
      "items": _vm.dpmStore.filterMattertagsForGroupList(_vm.filterQuery),
      "min-item-size": 76,
      "buffer": 1080,
      "key-field": "key",
      "item-class": "ds-item"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(_ref) {
        var _item$carouselItems;
        var item = _ref.item;
        _ref.index;
        var active = _ref.active;
        return [_c("DynamicScrollerItem", {
          attrs: {
            "item": item,
            "active": active
          }
        }, [_c("div", {
          staticClass: "ds-item-content p-3"
        }, [_c("div", {
          staticClass: "df align-items-center ds-item-title"
        }, [_vm.useBy === "cilbee" ? [_vm.cilbeeStore.destinations.find(function(dest) {
          return dest.mattertagSid === item.sid;
        }) ? _c("v-icon", {
          staticClass: "mx-1",
          attrs: {
            "color": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$global.icons.mdiCheckCircle))]) : _vm._e()] : _vm._e(), item.group.color ? _c("v-tooltip", {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(_ref2) {
              var on2 = _ref2.on, attrs2 = _ref2.attrs;
              return [_c("v-chip", _vm._g(_vm._b({
                staticClass: "me-2",
                attrs: {
                  "color": item.group.colorless ? "black" : _vm.$global.utils.toHex(item.group.color),
                  "text-color": item.group.colorless ? "black" : "white",
                  "outlined": item.group.colorless
                }
              }, "v-chip", attrs2, false), on2))];
            }
          }], null, true)
        }, [_c("span", [_vm._v(_vm._s(item.group.label))])]) : _vm._e(), _c("span", {
          staticClass: "mattertag-icon me-1",
          domProps: {
            "innerHTML": _vm._s(item.icon)
          }
        }), _c("v-btn", {
          staticClass: "ms-1 flex-grow-1 justify-space-between",
          attrs: {
            "plain": ""
          },
          on: {
            "click": function($event) {
              return _vm.navigateToTag(item.sid, false);
            }
          }
        }, [_c("span", {
          staticClass: "text-wrap black--text"
        }, [_vm._v(_vm._s(item.label))]), _vm.useBy === "drawer" ? _c("v-icon", {
          staticClass: "mx-1"
        }, [_vm._v(_vm._s(_vm.$global.icons.mdiShareCircle))]) : _vm._e()], 1)], 2), _vm.useBy === "drawer" && item.sid ? _c("div", [(_item$carouselItems = item.carouselItems) !== null && _item$carouselItems !== void 0 && _item$carouselItems.length ? _c("div", {
          staticClass: "carousel-wrapper w-100 mt-2"
        }, [_c("v-carousel", {
          attrs: {
            "show-arrows-on-hover": "",
            "hide-delimiter-background": "",
            "height": "200",
            "hide-delimiters": item.carouselItems.length === 1,
            "show-arrows": item.carouselItems.length !== 1
          }
        }, _vm._l(item.carouselItems, function(item2, i2) {
          return _c("v-carousel-item", {
            key: `v-carousel-item-${item2.groupIndex}-${_vm.useBy}-${item2.src}`
          }, [item2.type === "image" ? _c("div", {
            staticClass: "carousel-image flex-grow-1",
            style: `background-image: url(${item2.src})`
          }) : _vm._e(), item2.type.includes("html") ? _c("div", {
            staticClass: "carousel-html d-flex justify-center align-center flex-grow-1",
            class: {
              "flex-column": item2.type.includes("audio")
            }
          }, [item2.type.includes("audio") ? _c("v-icon", {
            staticClass: "mx-1 flex-grow-1"
          }, [_vm._v(_vm._s(_vm.$global.icons.mdiFileMusicOutline))]) : _vm._e(), _c("div", {
            staticClass: "d-flex w-100",
            domProps: {
              "innerHTML": _vm._s(item2.src)
            }
          })], 1) : _vm._e()]);
        }), 1)], 1) : _vm._e(), item.html ? _c("groupListHtml", {
          key: `groupListHtml-${item.key}`,
          attrs: {
            "html": item.html
          }
        }) : _vm._e(), item.description ? _c("div", {
          staticClass: "description-container mt-2",
          domProps: {
            "innerHTML": _vm._s(item.markedDescription)
          }
        }) : _vm._e(), item.attachmentDownloadLinks && item.attachmentDownloadLinks.length ? _c("div", _vm._l(item.attachmentDownloadLinks, function(link2) {
          return _c("v-btn", {
            key: link2.url,
            staticClass: "mt-3",
            attrs: {
              "block": "",
              "download": "",
              "href": link2.url
            }
          }, [_c("v-icon", {
            staticClass: "me-1"
          }, [_vm._v(_vm._s(_vm.$global.icons.mdiDownload))]), _vm._v(_vm._s(link2.fileName))], 1);
        }), 1) : _vm._e(), item.hasModalTypeExtension ? _c("div", {
          staticClass: "mt-2"
        }, [_c("v-btn", {
          attrs: {
            "block": ""
          },
          on: {
            "click": function($event) {
              return _vm.navigateToTag(item.sid, true);
            }
          }
        }, [_vm._v("詳しくはこちら")])], 1) : _vm._e()], 1) : _vm._e()])])];
      }
    }], null, false, 4043345551)
  })], 1)], 1) : _vm._e();
};
var staticRenderFns$y = [];
const __vue2_script$y = {
  components: { CoolLightBox, groupListHtml },
  props: ["useBy"],
  data() {
    return {
      errorText: "エラーが発生しました",
      filteredGroups: [0],
      initialized: false,
      listItems: [],
      keywordText: "",
      selectedLanguage: "default",
      // TODO: 独自UIを作成の時に多言語対応するかもしれないけれど、今はdefaultを使用する。
      titleOnly: false,
      index: 0
    };
  },
  computed: __spreadProps(__spreadValues({}, mapStores(useDpmStore, useCilbeeStore)), {
    filterQuery() {
      return {
        groupChipIds: this.filteredGroups,
        keyword: this.keywordText,
        titleOnly: this.titleOnly
      };
    }
  }),
  created() {
    return __async(this, null, function* () {
      if (this.useBy === "drawer" && this.dpmStore.global.groupListDrawer.display || this.useBy === "cilbee") {
        yield this.initialize();
      }
      if (this.useBy === "drawer" && this.dpmStore.global.groupListDrawer.display && this.dpmStore.global.showShowcaseEditor) {
        this.dpmStore.$subscribe((mutation, _state) => __async(this, null, function* () {
          var _a2, _b2;
          if (mutation.type.includes("patch") && ((_b2 = (_a2 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _a2.mattertagEditor) == null ? void 0 : _b2.tagChanged)) {
            this.dpmStore.mattertagEditor.tagChanged = false;
            this.initialized = false;
            yield this.initialize();
            yield Promise.all(this.dpmStore.current.mattertagGroupList.map((mattertag) => __async(this, null, function* () {
              yield this.getContent(mattertag);
            })));
          }
        }));
      }
      this.$global.sdk.Tag.attachments.subscribe({
        onCollectionUpdated: (collection) => __async(this, null, function* () {
          this.dpmStore.global.attachments = _clone$1(collection);
          yield Promise.all(this.dpmStore.current.mattertagGroupList.map((mattertag) => __async(this, null, function* () {
            yield this.getContent(mattertag);
          })));
        })
      });
    });
  },
  methods: {
    initialize() {
      return __async(this, null, function* () {
        if (this.initialized) {
          return;
        }
        yield this.dpmStore.prepareMattertagsForGroupList();
        this.initialized = true;
      });
    },
    changeGroup(a, b) {
      return __async(this, null, function* () {
        if (this.filteredGroups.length === 0) {
          this.filteredGroups = [0];
        } else {
          if (this.filteredGroups[this.filteredGroups.length - 1] === 0) {
            this.filteredGroups = [0];
          } else {
            this.filteredGroups = this.filteredGroups.filter((group) => group !== 0);
          }
        }
        this.dpmStore.filterMattertagsForGroupList(this.filterQuery).forEach((mattertag) => __async(this, null, function* () {
          yield this.$global.sdk.Tag.editOpacity(mattertag.sid, 1);
        }));
        this.dpmStore.current.mattertagGroupList.filter((mattertag) => !this.dpmStore.filterMattertagsForGroupList(this.filterQuery).some((filteredMattertag) => filteredMattertag.sid === mattertag.sid)).forEach((mattertag) => __async(this, null, function* () {
          yield this.$global.sdk.Tag.editOpacity(mattertag.sid, 0);
        }));
      });
    },
    getContent(mattertag) {
      return __async(this, null, function* () {
        var _a2, _b2, _c, _d2, _e, _f;
        if (((_a2 = mattertag.carouselItems) == null ? void 0 : _a2.length) || ((_b2 = mattertag.attachmentDownloadLinks) == null ? void 0 : _b2.length) || ((_c = mattertag.html) == null ? void 0 : _c.length)) {
          mattertag.carouselItems = [];
          mattertag.attachmentDownloadLinks = [];
          mattertag.html = "";
        } else {
          this.$set(mattertag, "carouselItems", []);
          this.$set(mattertag, "attachmentDownloadLinks", []);
          this.$set(mattertag, "html", "");
        }
        const customData = this.dpmStore.SED.mattertags.find((tag) => tag.sid === mattertag.sid);
        if (((_d2 = this.dpmStore.global.enableExtensions) == null ? void 0 : _d2.mattertag) && (customData == null ? void 0 : customData.extension) && ((_e = customData == null ? void 0 : customData.extension) == null ? void 0 : _e.type) !== "none") {
          const extension = customData.extension;
          mattertag.hasModalTypeExtension = true;
          switch (extension.type) {
            case "iframe":
              break;
            case "images":
              for (let image of extension.data.images) {
                if (image.src.indexOf("active_storage") !== -1) {
                  const res2 = yield this.getMediaUrl("mattertag_images", image.src.split(":")[1]);
                  if (res2) {
                    mattertag.carouselItems.push({ src: res2, type: "image" });
                  }
                } else {
                  mattertag.carouselItems.push({ src: image.src, type: "image" });
                }
              }
              break;
            case "video":
              if (extension.data.video.indexOf("active_storage") !== -1) {
                const res2 = yield this.getMediaUrl("mattertag_videos", extension.data.video.split(":")[1]);
                if (res2) {
                  mattertag.html = `<video class='w-100' src='${res2}' controls></video>`;
                }
              } else {
                mattertag.html = yield this.getMedia(extension.data.video, "video");
              }
              break;
            case "audio":
              if (extension.data.audio.indexOf("active_storage") !== -1) {
                const res2 = yield this.getMediaUrl("mattertag_audios", extension.data.audio.split(":")[1]);
                if (res2) {
                  mattertag.html = `<audio class='w-100' src='${res2}' loop controls></audio>`;
                }
              } else {
                mattertag.html = yield this.getMedia(extension.data.audio, "audio");
              }
              break;
            case "link":
              mattertag.hasModalTypeExtension = false;
              mattertag.html = `<a href='${extension.data.linkAddress}' target='_blank'>${extension.data.linkAddress}</a>`;
              break;
            case "html":
              break;
            case "pdf":
              const res = yield this.getMediaUrl("mattertag_images", extension.data.pdf.split(":")[1]);
              if (res) {
                mattertag.html = yield this.getMedia(res, "pdf");
              }
              break;
          }
        }
        yield this.dpmStore.setAttachmentsData(mattertag);
        if (mattertag.description) {
          mattertag.markedDescription = esmEntry(mattertag.description).replace(/<a\s+href=/gi, '<a target="_blank" href=');
        }
        if (((_f = this.dpmStore.global.enableExtensions) == null ? void 0 : _f.mattertag) && (customData == null ? void 0 : customData.description)) {
          mattertag.markedDescription = esmEntry(customData.description).replace(/<a\s+href=/gi, '<a target="_blank" href=');
        }
      });
    },
    getMedia(src, type) {
      return __async(this, null, function* () {
        const res = yield this.$global.utils.getMediaHtml(src, type);
        if (res.error) {
          return `<span class='text-danger'>${res.error || this.errorText}</span>`;
        }
        return res.html;
      });
    },
    getMediaUrl(type, id) {
      return __async(this, null, function* () {
        const res = yield axios$1.get(`${this.$global.apiUrl}/get_media_url?type=${type}&file_id=${id}`);
        if (!res || res.data.status === 404) {
          return this.errorText;
        }
        return res.data.url;
      });
    },
    navigateToTag(sid, openModal) {
      return __async(this, null, function* () {
        window.focusedTagSid = sid;
        if (this.useBy === "cilbee") {
          this.cilbeeStore.$patch({
            phase: 2,
            targetMattertagSid: sid
          });
        }
        if (this.dpmStore.sharedExperience.subscription) {
          this.dpmStore.sharedExperience.subscription.clickTag(sid, openModal);
        }
        const targetCustomData = this.dpmStore.SED.mattertags.find((data) => data.sid === sid);
        if (openModal && targetCustomData) {
          this.dpmStore.$patch({ current: { extension: targetCustomData.extension } });
        } else {
          yield this.$global.sdk.Mattertag.navigateToTag(sid, this.$global.sdk.Mattertag.Transition.FADEOUT, true);
        }
      });
    }
  }
};
const __cssModules$y = {};
var __component__$y = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$y,
  render$y,
  staticRenderFns$y,
  false,
  __vue2_injectStyles$y,
  null,
  null,
  null
);
function __vue2_injectStyles$y(context) {
  for (let o in __cssModules$y) {
    this[o] = __cssModules$y[o];
  }
}
const GroupList = /* @__PURE__ */ function() {
  return __component__$y.exports;
}();
class CilbeePoint {
  constructor() {
    /// このポイントのID(SweepのIDと一致)。
    __publicField(this, "id", "");
    /// パスにおける親ポイント。
    /**
     * パス内において、このポイントの前にあるポイントを指す。
     * 未定/初期が空のインスタンスとなるので、parent.idが''などの場合は
     * 「無い/未定」を意味する。
     */
    __publicField(this, "parent");
    /// このポイントが置かれている階。
    __publicField(this, "floor", "");
    /// このポイントが階段やエレベーターなどの階間移動可能なポイント。
    __publicField(this, "floorTransitionPoint", false);
    /// このポイントから移動可能な別の階のリスト。
    __publicField(this, "transitionFloors", []);
    /// X座標(横)。
    __publicField(this, "x", 0);
    /// Y座標(縦)。
    __publicField(this, "y", 0);
    /// Z座標(横)。
    __publicField(this, "z", 0);
    /// destポイントまでの絶対距離とstartポイントからの絶対距離の合計。
    __publicField(this, "f", Number.MAX_VALUE);
    /// startポイントからの絶対距離。
    __publicField(this, "g", Number.MAX_VALUE);
    /// destポイントまでの絶対距離。
    __publicField(this, "h", Number.MAX_VALUE);
    /// 経路探索調整様に足される重さ。
    __publicField(this, "weight", 0);
    /// 隣接ポイントのレファレンス。
    __publicField(this, "neighbors", []);
  }
  /// ポイントデータ初期化。
  clear() {
    this.id = "";
    this.parent = new CilbeePoint();
    this.floor = "";
    this.floorTransitionPoint = false;
    this.transitionFloors = [];
    this.x = 0;
    this.y = 0;
    this.z = 0;
    this.f = Number.MAX_VALUE;
    this.g = Number.MAX_VALUE;
    this.h = Number.MAX_VALUE;
    this.weight = 0;
    this.neighbors = [];
  }
}
class CilbeePathFinder {
  /// 引数を渡すと初期化を一括出来るコンストラクター。
  constructor(connectedPointMap = {}, mpSweepData = {}) {
    /// データがロードされていて経路探索が可能な状態かどうか。
    __publicField(this, "ready", false);
    /// 隣接(繋がり合っている)ポイントデータ。
    __publicField(this, "connections");
    /// ポイントに足される重さ。
    __publicField(this, "weights", {});
    /// Sweep Pointデータ元へのレファレンス。
    __publicField(this, "sweeps", {});
    /// 出発ポイント。
    __publicField(this, "start", new CilbeePoint());
    /// 目的ポイント。
    __publicField(this, "dest", new CilbeePoint());
    /// 探索が成功したかどうか。
    __publicField(this, "found", false);
    /// 通行可能な経路。
    __publicField(this, "path", []);
    if (Object.keys(connectedPointMap).length > 0 && Object.keys(mpSweepData).length > 0) {
      this.load(connectedPointMap, mpSweepData);
    }
  }
  /// 初期化(再利用/再探索用)。
  reset() {
    this.start.clear();
    this.dest.clear();
    this.path = [];
    this.found = false;
  }
  /// 隣接ポイントのハッシュマップをクラス内にクローンする。
  load(connectedPointMap, mpSweepData = {}) {
    this.connections = __spreadValues({}, connectedPointMap);
    this.sweeps = mpSweepData;
    this.ready = true;
  }
  /// 指定されたポイントを経路データから除く。
  /**
   * 元の経路データを編集せずに例外的にポイントを除くことが可能。
   * 例えば工事の為通路が閉鎖されるや通したくない経路があった場合。
   */
  removePoint(deletionPoint) {
    for (const floor of Object.keys(this.connections)) {
      for (const point of Object.keys(this.connections[floor])) {
        const matchIndex = this.connections[floor][point].indexOf(deletionPoint);
        if (matchIndex > -1) {
          this.connections[floor][point].splice(matchIndex, 1);
        }
        if (point === deletionPoint) {
          delete this.connections[floor][point];
        }
      }
    }
    if (this.found && this.findPointInArrayByID(deletionPoint, this.path) !== -1) {
      this.found = false;
    }
  }
  /// 指定されたポイントIDに足される重さを出す。
  getPointWeight(pointID) {
    if (pointID in this.weights) {
      return this.weights[pointID];
    }
    return 0;
  }
  /// 全ポイントに設けられている重さを出す。
  getPointWeights() {
    return this.weights;
  }
  /// 指定されたポイントIDに足される重さを設定する。
  setPointWeigth(pointID, weight) {
    this.weights[pointID] = weight;
  }
  /// 指定されたポイントIDに対して足される重さを調整する。
  adjustPointWeight(pointID, weightDelta) {
    this.weights[pointID] += weightDelta;
  }
  /// 複数のポイントIDに対して設けられる重さを設定する。
  setPointWeights(pointWeights) {
    for (const pointID of Object.keys(pointWeights)) {
      this.weights[pointID] = pointWeights[pointID];
    }
  }
  /// 複数のポイントIDに対して設けられる重さを調整する。
  adjustPointWeights(pointWeightDeltas) {
    for (const pointID of Object.keys(pointWeightDeltas)) {
      this.weights[pointID] += pointWeightDeltas[pointID];
    }
  }
  /// 指定のポイントが何階にあるかを調べる。
  findPointFloor(pointID) {
    if (!this.ready) {
      return "";
    }
    for (const floor of Object.keys(this.connections)) {
      if (pointID in this.connections[floor]) {
        return floor;
      }
    }
    return "";
  }
  /// ポイント情報を元sweepデータから輸出する。
  getPointData(pointID) {
    const point = new CilbeePoint();
    point.id = pointID;
    if (!this.ready) {
      return point;
    }
    point.floor = this.findPointFloor(pointID);
    if (pointID in this.sweeps) {
      point.x = this.sweeps[pointID].position.x;
      point.y = this.sweeps[pointID].position.y;
      point.z = this.sweeps[pointID].position.z;
    }
    if (pointID in this.weights) {
      point.weight = this.weights[pointID];
    }
    return point;
  }
  /// ポイント配列内のポイントの位置をIDで探す。
  findPointInArrayByID(pointID, arr) {
    for (let i2 = 0; i2 < arr.length; i2++) {
      if (pointID === arr[i2].id) {
        return i2;
      }
    }
    return -1;
  }
  /// ポイント配列内のポイントの位置を探す。
  findPointInArray(point, arr) {
    return this.findPointInArrayByID(point.id, arr);
  }
  /// (接点リストによる)周囲ポイントを埋める且つ周囲ポイントの配列を返す。
  getNeighbors(point) {
    if (!this.ready) {
      return [];
    }
    point.neighbors = [];
    if (point.floor in this.connections && point.id in this.connections[point.floor]) {
      for (const neighbor of this.connections[point.floor][point.id]) {
        const newNeighbor = this.getPointData(neighbor);
        if (point.floor !== newNeighbor.floor) {
          point.floorTransitionPoint = true;
          point.transitionFloors.push(newNeighbor.floor);
          newNeighbor.floorTransitionPoint = true;
          newNeighbor.transitionFloors.push(point.floor);
        }
        point.neighbors.push(newNeighbor);
      }
    }
    return point.neighbors;
  }
  /// 絶対的な距離(障害無視)の計算。
  getFlightDistance(point, compPoint) {
    return Math.sqrt(
      Math.pow(compPoint.x - point.x, 2) + Math.pow(compPoint.y - point.y, 2) + Math.pow(compPoint.z - point.z, 2)
    );
  }
  /// 経路配列内の2点のポイント同士の絶対的な距離の計算。
  getPathFlightDistanceBetweenIndex(startI, endI) {
    return this.getFlightDistance(this.path[startI], this.path[endI]);
  }
  /// 出発ポイントからの絶対的な距離の値。
  _findGCost(compPoint) {
    const dist = this.getFlightDistance(this.start, compPoint);
    compPoint.g = dist;
    return dist;
  }
  /// 目的ポイントまでの絶対的な距離の値。
  _findHCost(compPoint) {
    const dist = this.getFlightDistance(compPoint, this.dest);
    compPoint.h = dist;
    return dist;
  }
  _findFCost(compPoint) {
    const dist = this._findGCost(compPoint) + this._findHCost(compPoint);
    compPoint.f = dist;
    return dist;
  }
  // parentリンクをたどりdestからstartまでの配列を作る。
  _buildPathFromParents(point) {
    while (point.id !== this.start.id) {
      this.path.unshift(point);
      point = point.parent;
    }
    this.path.unshift(point);
  }
  /// 配列中の最もコストが安い/目的ポイントに近い要素を指摘する。
  _identifyClosest(points, ignoreWeight = false) {
    if (points.length <= 1) {
      return 0;
    }
    let closest2 = 0;
    let weight = 0;
    let weightClosest = 0;
    for (let i2 = 1; i2 < points.length; i2++) {
      if (!ignoreWeight) {
        weight = points[i2].weight;
        weightClosest = points[closest2].weight;
      }
      if (points[i2].f + weight < points[closest2].f + weightClosest) {
        closest2 = i2;
      } else if (points[i2].f === points[closest2].f) {
        if (points[i2].h < points[closest2].h) {
          closest2 = i2;
        }
      }
    }
    return closest2;
  }
  /// 指定された点から[残っている隣接点]データから目的ポイントまでに経路探索。
  /**
   * \p force trueにすると強制的に再検索。
   *    falseなら検索済みの場合にそのままtrueが返される。
   */
  findPath(force = false) {
    const open2 = [];
    this._findFCost(this.start);
    open2.push(this.start);
    const closed = [];
    if (force) {
      this.found = false;
    }
    if (this.found) {
      return true;
    }
    while (!this.found && !(open2.length === 0)) {
      const closest2 = this._identifyClosest(open2);
      if (open2[closest2].id === this.dest.id) {
        this._buildPathFromParents(open2[closest2]);
        this.found = true;
      } else {
        const current = open2[closest2];
        closed.push(open2[closest2]);
        open2.splice(closest2, 1);
        this.getNeighbors(current);
        for (const neighbor of current.neighbors) {
          if (this.findPointInArray(neighbor, closed) < 0 && this.findPointInArray(neighbor, open2) < 0) {
            neighbor.parent = current;
            open2.push(neighbor);
          }
        }
      }
    }
    return this.found;
  }
  /// 経路探索。
  route(startPoint, destPoints) {
    if (!this.ready) {
      return [];
    }
    const resultPaths = [];
    const dests = [];
    while (destPoints.length) {
      const results = destPoints.map((sweepSid) => {
        this.reset();
        this.start = this.getPointData(startPoint);
        this.dest = this.getPointData(sweepSid);
        this.findPath();
        if (this.found) {
          return { sid: sweepSid, dist: this.getPathLength(), path: this.getPath() };
        } else {
          return { sid: sweepSid, dist: 0, path: this.getPath() };
        }
      });
      results.sort((r1, r2) => r1.dist - r2.dist);
      startPoint = results[0].sid;
      dests.push([...results[0].path]);
      if (resultPaths.length) {
        results[0].path.shift();
      }
      resultPaths.push(...results[0].path);
      destPoints.splice(destPoints.indexOf(results[0].sid), 1);
    }
    this.path = resultPaths.map((sweepSid) => this.getPointData(sweepSid));
    return { route: resultPaths, byDest: dests };
  }
  /// CilbeePoint型の経路を出す。
  getPathPoints() {
    if (this.found) {
      return this.path;
    }
    return [];
  }
  /// IDハッシュ値の文字列の入った配列の経路を出す。
  getPath() {
    if (this.found) {
      const pathIDs = [];
      for (const point of this.path) {
        pathIDs.push(point.id);
      }
      return pathIDs;
    }
    return [];
  }
  /// 経路の総距離計算。
  getPathLength(fromIndex = 0, toIndex = 0) {
    if (!this.found) {
      return 0;
    }
    if (toIndex === 0) {
      toIndex = this.path.length - 1;
    }
    let length = 0;
    for (let i2 = fromIndex; i2 < toIndex; i2++) {
      length += this.getFlightDistance(this.path[i2], this.path[i2 + 1]);
    }
    return length;
  }
  /// 出発点から現在地までの距離から逆算した現在地から一番近いポイントのインデックスを割り出す。
  /**
   * \p progressionDistance 出発点から現在地まで進んだ総距離。
   */
  getClosestIndexFromProgression(progressionDistance) {
    let length = 0;
    const sumDistances = [0];
    for (let i2 = 0; i2 < this.path.length - 1; i2++) {
      length += this.getFlightDistance(this.path[i2], this.path[i2 + 1]);
      sumDistances.push(length);
    }
    const diff = [];
    let index2 = 0;
    sumDistances.forEach((totalPosition, i2) => {
      diff[i2] = Math.abs(progressionDistance - totalPosition);
      index2 = diff[index2] < diff[i2] ? index2 : i2;
    });
    return { index: index2, distance: sumDistances[index2] };
  }
}
function dotsWrapperHtmlString() {
  const dotsWrapper = document.createElement("div");
  dotsWrapper.classList.add("tg-dialog-dots");
  dotsWrapper.id = "tg-dialog-dots";
  return dotsWrapper.outerHTML;
}
const computeDots = (tgInstance) => {
  let dotsHtml = "";
  if (tgInstance.tourSteps.length)
    tgInstance.tourSteps.forEach((_, i2) => {
      const dotSpan = document.createElement("span");
      dotSpan.classList.add("tg-dot");
      if (i2 === tgInstance.activeStep)
        dotSpan.classList.add("tg-dot-active");
      dotsHtml += dotSpan.outerHTML;
    });
  return dotsHtml;
};
const sides = ["top", "right", "bottom", "left"];
const alignments = ["start", "end"];
const placements = /* @__PURE__ */ sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const createCoords = (v) => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate2(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return __spreadValues({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, padding);
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x2,
    right: x2 + width,
    bottom: y + height,
    x: x2,
    y
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = (reference, floating, config2) => __async(void 0, null, function* () {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config2;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(floating);
  let rects = yield platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i2 = 0; i2 < validMiddleware.length; i2++) {
    const {
      name,
      fn
    } = validMiddleware[i2];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = yield fn({
      x: x2,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y = nextY != null ? nextY : y;
    middlewareData = __spreadProps(__spreadValues({}, middlewareData), {
      [name]: __spreadValues(__spreadValues({}, middlewareData[name]), data)
    });
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? yield platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i2 = -1;
    }
  }
  return {
    x: x2,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
});
function detectOverflow(state, options) {
  return __async(this, null, function* () {
    var _await$platform$isEle;
    if (options === void 0) {
      options = {};
    }
    const {
      x: x2,
      y,
      platform: platform2,
      rects,
      elements,
      strategy
    } = state;
    const {
      boundary = "clippingAncestors",
      rootBoundary = "viewport",
      elementContext = "floating",
      altBoundary = false,
      padding = 0
    } = evaluate2(options, state);
    const paddingObject = getPaddingObject(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = rectToClientRect(yield platform2.getClippingRect({
      element: ((_await$platform$isEle = yield platform2.isElement == null ? void 0 : platform2.isElement(element)) != null ? _await$platform$isEle : true) ? element : element.contextElement || (yield platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
      boundary,
      rootBoundary,
      strategy
    }));
    const rect = elementContext === "floating" ? {
      x: x2,
      y,
      width: rects.floating.width,
      height: rects.floating.height
    } : rects.reference;
    const offsetParent = yield platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating);
    const offsetScale = (yield platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? (yield platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
      x: 1,
      y: 1
    } : {
      x: 1,
      y: 1
    };
    const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? yield platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
      elements,
      rect,
      offsetParent,
      strategy
    }) : rect);
    return {
      top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
      bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
      left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
      right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
  });
}
const arrow$1 = (options) => ({
  name: "arrow",
  options,
  fn(state) {
    return __async(this, null, function* () {
      const {
        x: x2,
        y,
        placement,
        rects,
        platform: platform2,
        elements,
        middlewareData
      } = state;
      const {
        element,
        padding = 0
      } = evaluate2(options, state) || {};
      if (element == null) {
        return {};
      }
      const paddingObject = getPaddingObject(padding);
      const coords = {
        x: x2,
        y
      };
      const axis = getAlignmentAxis(placement);
      const length = getAxisLength(axis);
      const arrowDimensions = yield platform2.getDimensions(element);
      const isYAxis = axis === "y";
      const minProp = isYAxis ? "top" : "left";
      const maxProp = isYAxis ? "bottom" : "right";
      const clientProp = isYAxis ? "clientHeight" : "clientWidth";
      const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
      const startDiff = coords[axis] - rects.reference[axis];
      const arrowOffsetParent = yield platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element);
      let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
      if (!clientSize || !(yield platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
        clientSize = elements.floating[clientProp] || rects.floating[length];
      }
      const centerToReference = endDiff / 2 - startDiff / 2;
      const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
      const minPadding = min(paddingObject[minProp], largestPossiblePadding);
      const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
      const min$1 = minPadding;
      const max2 = clientSize - arrowDimensions[length] - maxPadding;
      const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
      const offset2 = clamp(min$1, center, max2);
      const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset2 && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
      const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max2 : 0;
      return {
        [axis]: coords[axis] + alignmentOffset,
        data: __spreadValues({
          [axis]: offset2,
          centerOffset: center - offset2 - alignmentOffset
        }, shouldAddOffset && {
          alignmentOffset
        }),
        reset: shouldAddOffset
      };
    });
  }
});
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter((placement) => getAlignment(placement) === alignment), ...allowedPlacements.filter((placement) => getAlignment(placement) !== alignment)] : allowedPlacements.filter((placement) => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter((placement) => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
const autoPlacement$1 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "autoPlacement",
    options,
    fn(state) {
      return __async(this, null, function* () {
        var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
        const {
          rects,
          middlewareData,
          placement,
          platform: platform2,
          elements
        } = state;
        const _a3 = evaluate2(options, state), {
          crossAxis = false,
          alignment,
          allowedPlacements = placements,
          autoAlignment = true
        } = _a3, detectOverflowOptions = __objRest(_a3, [
          "crossAxis",
          "alignment",
          "allowedPlacements",
          "autoAlignment"
        ]);
        const placements$1 = alignment !== void 0 || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
        const overflow = yield detectOverflow(state, detectOverflowOptions);
        const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
        const currentPlacement = placements$1[currentIndex];
        if (currentPlacement == null) {
          return {};
        }
        const alignmentSides = getAlignmentSides(currentPlacement, rects, yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
        if (placement !== currentPlacement) {
          return {
            reset: {
              placement: placements$1[0]
            }
          };
        }
        const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
        const allOverflows = [...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [], {
          placement: currentPlacement,
          overflows: currentOverflows
        }];
        const nextPlacement = placements$1[currentIndex + 1];
        if (nextPlacement) {
          return {
            data: {
              index: currentIndex + 1,
              overflows: allOverflows
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        const placementsSortedByMostSpace = allOverflows.map((d2) => {
          const alignment2 = getAlignment(d2.placement);
          return [d2.placement, alignment2 && crossAxis ? (
            // Check along the mainAxis and main crossAxis side.
            d2.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0)
          ) : (
            // Check only the mainAxis.
            d2.overflows[0]
          ), d2.overflows];
        }).sort((a, b) => a[1] - b[1]);
        const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d2) => d2[2].slice(
          0,
          // Aligned placements should not check their opposite crossAxis
          // side.
          getAlignment(d2[0]) ? 2 : 3
        ).every((v) => v <= 0));
        const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
        if (resetPlacement !== placement) {
          return {
            data: {
              index: currentIndex + 1,
              overflows: allOverflows
            },
            reset: {
              placement: resetPlacement
            }
          };
        }
        return {};
      });
    }
  };
};
function convertValueToCoords(state, options) {
  return __async(this, null, function* () {
    const {
      placement,
      platform: platform2,
      elements
    } = state;
    const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating);
    const side = getSide(placement);
    const alignment = getAlignment(placement);
    const isVertical = getSideAxis(placement) === "y";
    const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = evaluate2(options, state);
    let {
      mainAxis,
      crossAxis,
      alignmentAxis
    } = typeof rawValue === "number" ? {
      mainAxis: rawValue,
      crossAxis: 0,
      alignmentAxis: null
    } : {
      mainAxis: rawValue.mainAxis || 0,
      crossAxis: rawValue.crossAxis || 0,
      alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") {
      crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    }
    return isVertical ? {
      x: crossAxis * crossAxisMulti,
      y: mainAxis * mainAxisMulti
    } : {
      x: mainAxis * mainAxisMulti,
      y: crossAxis * crossAxisMulti
    };
  });
}
const offset$1 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    fn(state) {
      return __async(this, null, function* () {
        var _middlewareData$offse, _middlewareData$arrow;
        const {
          x: x2,
          y,
          placement,
          middlewareData
        } = state;
        const diffCoords = yield convertValueToCoords(state, options);
        if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
          return {};
        }
        return {
          x: x2 + diffCoords.x,
          y: y + diffCoords.y,
          data: __spreadProps(__spreadValues({}, diffCoords), {
            placement
          })
        };
      });
    }
  };
};
const shift$1 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    fn(state) {
      return __async(this, null, function* () {
        const {
          x: x2,
          y,
          placement
        } = state;
        const _a3 = evaluate2(options, state), {
          mainAxis: checkMainAxis = true,
          crossAxis: checkCrossAxis = false,
          limiter = {
            fn: (_ref) => {
              let {
                x: x3,
                y: y2
              } = _ref;
              return {
                x: x3,
                y: y2
              };
            }
          }
        } = _a3, detectOverflowOptions = __objRest(_a3, [
          "mainAxis",
          "crossAxis",
          "limiter"
        ]);
        const coords = {
          x: x2,
          y
        };
        const overflow = yield detectOverflow(state, detectOverflowOptions);
        const crossAxis = getSideAxis(getSide(placement));
        const mainAxis = getOppositeAxis(crossAxis);
        let mainAxisCoord = coords[mainAxis];
        let crossAxisCoord = coords[crossAxis];
        if (checkMainAxis) {
          const minSide = mainAxis === "y" ? "top" : "left";
          const maxSide = mainAxis === "y" ? "bottom" : "right";
          const min2 = mainAxisCoord + overflow[minSide];
          const max2 = mainAxisCoord - overflow[maxSide];
          mainAxisCoord = clamp(min2, mainAxisCoord, max2);
        }
        if (checkCrossAxis) {
          const minSide = crossAxis === "y" ? "top" : "left";
          const maxSide = crossAxis === "y" ? "bottom" : "right";
          const min2 = crossAxisCoord + overflow[minSide];
          const max2 = crossAxisCoord - overflow[maxSide];
          crossAxisCoord = clamp(min2, crossAxisCoord, max2);
        }
        const limitedCoords = limiter.fn(__spreadProps(__spreadValues({}, state), {
          [mainAxis]: mainAxisCoord,
          [crossAxis]: crossAxisCoord
        }));
        return __spreadProps(__spreadValues({}, limitedCoords), {
          data: {
            x: limitedCoords.x - x2,
            y: limitedCoords.y - y,
            enabled: {
              [mainAxis]: checkMainAxis,
              [crossAxis]: checkCrossAxis
            }
          }
        });
      });
    }
  };
};
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node2) {
  if (isNode(node2)) {
    return (node2.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node2) {
  var _node$ownerDocument;
  return (node2 == null || (_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node2) {
  var _ref;
  return (_ref = (isNode(node2) ? node2.ownerDocument : node2.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [":popover-open", ":modal"].some((selector) => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css2 = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((value) => css2[value] ? css2[value] !== "none" : false) || (css2.containerType ? css2.containerType !== "normal" : false) || !webkit && (css2.backdropFilter ? css2.backdropFilter !== "none" : false) || !webkit && (css2.filter ? css2.filter !== "none" : false) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((value) => (css2.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css2.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports)
    return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node2) {
  return ["html", "body", "#document"].includes(getNodeName(node2));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node2) {
  if (getNodeName(node2) === "html") {
    return node2;
  }
  const result2 = (
    // Step into the shadow DOM of the parent of a slotted node.
    node2.assignedSlot || // DOM Element detected.
    node2.parentNode || // ShadowRoot detected.
    isShadowRoot(node2) && node2.host || // Fallback.
    getDocumentElement(node2)
  );
  return isShadowRoot(result2) ? result2.host : result2;
}
function getNearestOverflowAncestor(node2) {
  const parentNode2 = getParentNode(node2);
  if (isLastTraversableNode(parentNode2)) {
    return node2.ownerDocument ? node2.ownerDocument.body : node2.body;
  }
  if (isHTMLElement(parentNode2) && isOverflowElement(parentNode2)) {
    return parentNode2;
  }
  return getNearestOverflowAncestor(parentNode2);
}
function getOverflowAncestors(node2, list2, traverseIframes) {
  var _node$ownerDocument2;
  if (list2 === void 0) {
    list2 = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node2);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node2.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list2.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list2.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element) {
  const css2 = getComputedStyle$1(element);
  let width = parseFloat(css2.width) || 0;
  let height = parseFloat(css2.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x2 = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x: x2,
    y
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x2 = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css2 = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css2.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css2.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x2 += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x: x2,
    y
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x2 = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : (
    // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect)
  ));
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x: x2,
    y
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x2 += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x: x2,
    y
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x2 = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x2,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x2 = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x: x2,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode2 = getParentNode(element);
  if (parentNode2 === stopNode || !isElement(parentNode2) || isLastTraversableNode(parentNode2)) {
    return false;
  }
  return getComputedStyle$1(parentNode2).position === "fixed" || hasFixedPositionAncestor(parentNode2, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result2 = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result2 = result2.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result2);
  return result2;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x2 = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x: x2,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle$1(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = function(data) {
  return __async(this, null, function* () {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = yield getDimensionsFn(data.floating);
    return {
      reference: getRectRelativeToOffsetParent(data.reference, yield getOffsetParentFn(data.floating), data.strategy),
      floating: {
        x: 0,
        y: 0,
        width: floatingDimensions.width,
        height: floatingDimensions.height
      }
    };
  });
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
const offset = offset$1;
const autoPlacement = autoPlacement$1;
const shift = shift$1;
const arrow = arrow$1;
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = __spreadValues({
    platform
  }, options);
  const platformWithCache = __spreadProps(__spreadValues({}, mergedOptions.platform), {
    _c: cache
  });
  return computePosition$1(reference, floating, __spreadProps(__spreadValues({}, mergedOptions), {
    platform: platformWithCache
  }));
};
function createTourGuideDialog() {
  return __async(this, null, function* () {
    this.dialog = document.createElement("div");
    this.dialog.classList.add("tg-dialog");
    yield renderDialogHtml(this).then((html) => {
      this.dialog.innerHTML = html;
    });
    document.body.append(this.dialog);
    return true;
  });
}
function renderDialogHtml(tgInstance) {
  return __async(this, null, function* () {
    if (tgInstance.options.dialogClass)
      tgInstance.dialog.classList.add(tgInstance.options.dialogClass);
    if (tgInstance.options.dialogZ)
      tgInstance.dialog.style.zIndex = String(tgInstance.options.dialogZ);
    tgInstance.dialog.style.width = tgInstance.options.dialogWidth ? tgInstance.options.dialogWidth + "px" : "auto";
    if (tgInstance.options.dialogMaxWidth)
      tgInstance.dialog.style.maxWidth = tgInstance.options.dialogMaxWidth + "px";
    let htmlRes = "";
    htmlRes += `<div class='tg-dialog-header'>`;
    htmlRes += `<div class="tg-dialog-title" id="tg-dialog-title"><!-- JS rendered --></div>`;
    if (tgInstance.options.closeButton) {
      htmlRes += `<div class="tg-dialog-close-btn" id="tg-dialog-close-btn">`;
      htmlRes += ` <svg width="12px" height="12px" id="Layer_1" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"/></svg>`;
      htmlRes += `</div>`;
    }
    htmlRes += `</div>`;
    if (tgInstance.options.progressBar) {
      htmlRes += `<div class="tg-dialog-progress-bar"><span class="tg-bar" id="tg-dialog-progbar"></span></div>`;
    }
    htmlRes += `<div class="tg-dialog-body" id="tg-dialog-body"><!-- JS rendered --></div>`;
    if (tgInstance.options.showStepDots && tgInstance.options.stepDotsPlacement === "body") {
      const dotsWrapperHtml = dotsWrapperHtmlString();
      if (dotsWrapperHtml)
        htmlRes += dotsWrapperHtml;
    }
    htmlRes += `<div class="tg-dialog-footer">`;
    let prevBtnClass = "tg-dialog-btn";
    let prevDisabled = "false";
    if (tgInstance.activeStep === 0) {
      prevDisabled = "true";
      prevBtnClass += " disabled";
    }
    if (tgInstance.options.showButtons && !tgInstance.options.hidePrev)
      htmlRes += `<button type="button" class="` + prevBtnClass + `" id="tg-dialog-prev-btn" disabled="` + prevDisabled + `">${tgInstance.options.prevLabel}</button>`;
    htmlRes += '<div class="tg-dialog-footer-sup">';
    if (tgInstance.options.showStepDots && tgInstance.options.stepDotsPlacement === "footer") {
      const dotsWrapperHtml = dotsWrapperHtmlString();
      if (dotsWrapperHtml)
        htmlRes += dotsWrapperHtml;
    }
    if (tgInstance.options.showStepProgress)
      htmlRes += `<span class="tg-step-progress" id="tg-step-progress"><!-- JS rendered --></span>`;
    htmlRes += "</div>";
    if (tgInstance.options.showButtons && !tgInstance.options.hideNext)
      htmlRes += `<button type="button" class="tg-dialog-btn" id="tg-dialog-next-btn">${tgInstance.options.nextLabel}</button>`;
    htmlRes += `</div>`;
    htmlRes += `<div id="tg-arrow" class="tg-arrow"></div><!-- end tour arrow -->`;
    return htmlRes;
  });
}
function updateDialogHtml(tgInstance) {
  return new Promise((resolve2, reject) => {
    const stepData = tgInstance.tourSteps[tgInstance.activeStep];
    if (!stepData)
      reject("No active step data");
    const tgTitle = document.getElementById("tg-dialog-title");
    if (tgTitle)
      tgTitle.innerHTML = stepData.title ? stepData.title : "";
    const tgBody = document.getElementById("tg-dialog-body");
    if (tgBody && stepData) {
      if (typeof stepData.content === "string") {
        tgBody.innerHTML = stepData.content ? stepData.content : "";
      } else {
        tgBody.innerHTML = "";
        tgBody.append(stepData.content);
      }
    }
    const tgDots = document.getElementById("tg-dialog-dots");
    if (tgDots && tgInstance.options.showStepDots && computeDots(tgInstance))
      tgDots.innerHTML = computeDots(tgInstance);
    const backBtn = document.getElementById("tg-dialog-prev-btn");
    if (backBtn) {
      if (tgInstance.activeStep === 0) {
        backBtn.classList.add("disabled");
        backBtn.setAttribute("disabled", "true");
      } else {
        backBtn.classList.remove("disabled");
        backBtn.removeAttribute("disabled");
      }
    }
    const nextBtn = document.getElementById("tg-dialog-next-btn");
    if (nextBtn)
      nextBtn.innerHTML = tgInstance.activeStep + 1 >= tgInstance.tourSteps.length ? tgInstance.options.finishLabel : tgInstance.options.nextLabel;
    const tgProgress = document.getElementById("tg-step-progress");
    if (tgProgress)
      tgProgress.innerHTML = tgInstance.activeStep + 1 + "/" + tgInstance.tourSteps.length;
    const tgProgBar = document.getElementById("tg-dialog-progbar");
    if (tgProgBar) {
      if (tgInstance.options.progressBar)
        tgProgBar.style.backgroundColor = tgInstance.options.progressBar;
      tgProgBar.style.width = (tgInstance.activeStep + 1) / tgInstance.tourSteps.length * 100 + "%";
    }
    resolve2(true);
  });
}
function computeDialogPosition(tgInstance) {
  return new Promise((resolve2) => __async(this, null, function* () {
    const arrowElement = document.querySelector("#tg-arrow");
    let targetElem = tgInstance.tourSteps[tgInstance.activeStep].target;
    if (targetElem === document.body) {
      Object.assign(tgInstance.dialog.style, {
        top: `${window.innerHeight / 2.25 - tgInstance.dialog.clientHeight / 2}px`,
        left: `${window.innerWidth / 2 - tgInstance.dialog.clientWidth / 2}px`,
        position: "fixed"
      });
      tgInstance.dialog.classList.add("tg-dialog-fixed");
      if (arrowElement)
        arrowElement.style.display = "none";
      return resolve2(true);
    }
    tgInstance.dialog.style.position = "absolute";
    tgInstance.dialog.classList.remove("tg-dialog-fixed");
    if (arrowElement)
      arrowElement.style.display = "inline-block";
    computePosition(targetElem, tgInstance.dialog, {
      placement: tgInstance.options.dialogPlacement,
      middleware: [
        autoPlacement({
          autoAlignment: true,
          padding: 5
        }),
        shift({ padding: 15 }),
        arrow({ element: arrowElement }),
        offset(20)
      ]
    }).then(({ x: x2, y, placement, middlewareData }) => {
      Object.assign(tgInstance.dialog.style, {
        left: `${x2}px`,
        top: `${y}px`
      });
      if (middlewareData.arrow) {
        const arrowX = middlewareData.arrow.x;
        const arrowY = middlewareData.arrow.y;
        const staticSide = {
          top: "bottom",
          right: "left",
          bottom: "top",
          left: "right"
        }[placement.split("-")[0]];
        if (arrowElement)
          Object.assign(arrowElement.style, {
            left: arrowX != null ? `${arrowX}px` : "",
            top: arrowY != null ? `${arrowY}px` : "",
            [staticSide]: "-4px"
          });
      }
      return resolve2(true);
    });
  }));
}
function createTourGuideBackdrop() {
  this.backdrop = document.createElement("div");
  this.computeBackdropAttributes();
  document.body.append(this.backdrop);
}
function computeBackdropAttributes() {
  if (!this.options)
    return;
  this.backdrop.className = "tg-backdrop";
  this.backdrop.style.boxShadow = this.options.backdropColor + " 0 0 1px 2px, " + this.options.backdropColor + " 0 0 0 1000vh";
  if (this.options.backdropClass)
    this.backdrop.classList.add(this.options.backdropClass);
  if (this.options.dialogAnimate)
    this.backdrop.classList.add("tg-backdrop-animate");
}
function computeBackdropPosition(tgInstance) {
  return new Promise((resolve2, reject) => __async(this, null, function* () {
    if (typeof tgInstance.options.targetPadding === "undefined")
      return reject("Options failed to initialize");
    if (!tgInstance.backdrop)
      return reject("No backdrop element initialized");
    const stepData = tgInstance.tourSteps[tgInstance.activeStep];
    const targetElem = stepData.target;
    const targetElemRect = targetElem.getBoundingClientRect();
    const isOverflow = targetElemRect.width + tgInstance.options.targetPadding > document.documentElement.clientWidth;
    if (targetElem === document.body) {
      const centeredOverlaySize = 0;
      targetElemRect.width = centeredOverlaySize;
      targetElemRect.height = centeredOverlaySize;
      tgInstance.backdrop.style.position = "fixed";
      tgInstance.backdrop.style.top = window.innerHeight / 2.5 + "px";
      tgInstance.backdrop.style.left = window.innerWidth / 2 + "px";
    } else if (stepData.fixed) {
      tgInstance.backdrop.style.position = "fixed";
      tgInstance.backdrop.style.top = targetElemRect.top - tgInstance.options.targetPadding / 2 + "px";
      tgInstance.backdrop.style.left = (isOverflow ? targetElemRect.x : targetElemRect.x - tgInstance.options.targetPadding / 2) + "px";
    } else {
      tgInstance.backdrop.style.position = "absolute";
      tgInstance.backdrop.style.top = window.scrollY + targetElemRect.top - tgInstance.options.targetPadding / 2 + "px";
      tgInstance.backdrop.style.left = (isOverflow ? targetElemRect.x : targetElemRect.x - tgInstance.options.targetPadding / 2) + "px";
    }
    tgInstance.backdrop.style.width = (isOverflow ? targetElemRect.width : targetElemRect.width + tgInstance.options.targetPadding) + "px";
    tgInstance.backdrop.style.height = (targetElemRect.height ? targetElemRect.height + tgInstance.options.targetPadding : targetElemRect.height) + "px";
    resolve2(true);
  }));
}
function computeTourPositions() {
  return new Promise((resolve2) => __async(this, null, function* () {
    this.backdrop.style.display = "block";
    yield computeBackdropPosition(this);
    this.dialog.style.display = "block";
    if (this.options.dialogAnimate && this.isVisible)
      this.dialog.classList.add("animate-position");
    yield computeDialogPosition(this);
    if (this.options.dialogAnimate)
      setTimeout(() => {
        this.dialog.classList.remove("animate-position");
      }, 300);
    this.isVisible = true;
    if (!window.onresize)
      window.onresize = () => {
        computeBackdropPosition(this);
        computeDialogPosition(this);
      };
    if (!window.onscroll)
      window.onscroll = () => {
        computeDialogPosition(this);
      };
    yield setTimeout(() => {
      return resolve2(true);
    }, 300);
  }));
}
function handleOnFinish(providedCallback) {
  if (typeof providedCallback === "function") {
    this._globalFinishCallback = providedCallback;
  } else {
    throw new Error(
      "Provided callback for onFinish was not a function"
    );
  }
}
function handleOnBeforeExit(providedCallback) {
  if (typeof providedCallback === "function") {
    this._globalBeforeExitCallback = providedCallback;
  } else {
    throw new Error("Provided callback for onBeforeExit was not a function");
  }
}
function handleOnAfterExit(providedCallback) {
  if (typeof providedCallback === "function") {
    this._globalAfterExitCallback = providedCallback;
  } else {
    throw new Error("Provided callback for onAfterExit was not a function");
  }
}
function handleOnBeforeStepChange(providedCallback) {
  if (typeof providedCallback === "function") {
    this._globalBeforeChangeCallback = providedCallback;
  } else {
    throw new Error("Provided callback for onBeforeStepChange was not a function");
  }
}
function handleOnAfterStepChange(providedCallback) {
  if (typeof providedCallback === "function") {
    this._globalAfterChangeCallback = providedCallback;
  } else {
    throw new Error("Provided callback for onAfterStepChange was not a function");
  }
}
const clickOutsideHandler = function(event) {
  return __async(this, null, function* () {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (!(event.target instanceof Element))
      return;
    const backdropRect = this.backdrop.getBoundingClientRect();
    if (event.clientX >= backdropRect.x && event.clientX <= backdropRect.x + backdropRect.width && event.clientY >= backdropRect.y && event.clientY <= backdropRect.y + backdropRect.height)
      return;
    const dialogRect = this.dialog.getBoundingClientRect();
    if (event.clientX >= dialogRect.x && event.clientX <= dialogRect.x + dialogRect.width && event.clientY >= dialogRect.y && event.clientY <= dialogRect.y + dialogRect.height)
      return;
    if (this.dialog.contains(event.target))
      return;
    yield this.exit();
  });
};
const keyPressHandler = function(event) {
  return __async(this, null, function* () {
    if (event.key === "Escape" && this.options.exitOnEscape) {
      event.preventDefault();
      yield this.exit();
      return;
    }
    if (event.key === "ArrowRight" && this.options.keyboardControls) {
      event.preventDefault();
      this.visitStep("next").catch((e) => {
        if (this.options.debug)
          console.warn(e);
      });
      return;
    }
    if (event.key === "ArrowLeft" && this.options.keyboardControls) {
      event.preventDefault();
      this.visitStep("prev").catch((e) => {
        if (this.options.debug)
          console.warn(e);
      });
      return;
    }
  });
};
function handleInitListeners() {
  const initNextBtnListener = () => {
    let nextBtn = document.getElementById("tg-dialog-next-btn");
    if (!nextBtn || this._trackedEvents["nextBtnClickEvent"].initialized)
      return;
    nextBtn.addEventListener("click", this._trackedEvents.nextBtnClickEvent.fn);
    this._trackedEvents["nextBtnClickEvent"].initialized = true;
  };
  const initPrevBtnListener = () => {
    let prevBtn = document.getElementById("tg-dialog-prev-btn");
    if (!prevBtn || this._trackedEvents["prevBtnClickEvent"].initialized)
      return;
    prevBtn.addEventListener("click", this._trackedEvents.prevBtnClickEvent.fn);
    this._trackedEvents["prevBtnClickEvent"].initialized = true;
  };
  const initCloseBtnListener = () => {
    let closeBtn = document.getElementById("tg-dialog-close-btn");
    if (!closeBtn || this._trackedEvents["closeBtnClickEvent"].initialized)
      return;
    closeBtn.addEventListener("click", this._trackedEvents.closeBtnClickEvent.fn, false);
    this._trackedEvents["closeBtnClickEvent"].initialized = true;
  };
  const initClickOutsideListener = () => {
    if (this._trackedEvents["outsideClickEvent"].initialized)
      return;
    document.body.addEventListener("click", this._trackedEvents.outsideClickEvent.fn, false);
    this._trackedEvents["outsideClickEvent"].initialized = true;
  };
  const initKeysListener = () => {
    if (this._trackedEvents["keyPressEvent"].initialized)
      return;
    window.addEventListener("keydown", this._trackedEvents.keyPressEvent.fn, false);
    this._trackedEvents["keyPressEvent"].initialized = true;
  };
  return new Promise((resolve2) => {
    if (this.options.showButtons)
      initNextBtnListener();
    if (this.options.showButtons)
      initPrevBtnListener();
    if (this.options.closeButton)
      initCloseBtnListener();
    if (this.options.exitOnClickOutside)
      initClickOutsideListener();
    if (this.options.keyboardControls || this.options.exitOnEscape)
      initKeysListener();
    return resolve2(true);
  });
}
function handleDestroyListeners() {
  const destroyNextBtnListener = () => {
    let nextBtn = document.getElementById("tg-dialog-next-btn");
    if (nextBtn) {
      nextBtn.removeEventListener("click", this._trackedEvents.nextBtnClickEvent.fn);
      this._trackedEvents["nextBtnClickEvent"].initialized = false;
    }
  };
  const destroyPrevBtnListener = () => {
    let prevBtn = document.getElementById("tg-dialog-prev-btn");
    if (prevBtn) {
      prevBtn.removeEventListener("click", this._trackedEvents.prevBtnClickEvent.fn);
      this._trackedEvents["prevBtnClickEvent"].initialized = false;
    }
  };
  const destroyCloseBtnListener = () => {
    let closeBtn = document.getElementById("tg-dialog-close-btn");
    if (closeBtn) {
      closeBtn.removeEventListener("click", this._trackedEvents.closeBtnClickEvent.fn, false);
      this._trackedEvents["closeBtnClickEvent"].initialized = false;
    }
  };
  const destroyClickOutsideListener = () => {
    document.body.removeEventListener("click", this._trackedEvents.outsideClickEvent.fn, false);
    this._trackedEvents["outsideClickEvent"].initialized = false;
  };
  const destroyKeysListener = () => {
    window.removeEventListener("keydown", this._trackedEvents.keyPressEvent.fn, false);
    this._trackedEvents["keyPressEvent"].initialized = false;
  };
  return new Promise((resolve2) => {
    if (this.options.showButtons)
      destroyNextBtnListener();
    if (this.options.showButtons)
      destroyPrevBtnListener();
    if (this.options.closeButton)
      destroyCloseBtnListener();
    if (this.options.exitOnClickOutside)
      destroyClickOutsideListener();
    if (this.options.keyboardControls || this.options.exitOnEscape)
      destroyKeysListener();
    return resolve2(true);
  });
}
const scrollToTarget = (tgInstance, targetElem) => {
  targetElem.scrollIntoView({ behavior: tgInstance.options.autoScrollSmooth ? "smooth" : "auto", block: "end", inline: "nearest" });
};
function handleVisitStep(stepIndex) {
  return __async(this, null, function* () {
    return new Promise((resolve2, reject) => __async(this, null, function* () {
      if (typeof stepIndex === "string") {
        if (stepIndex === "next")
          stepIndex = this.activeStep + 1;
        else
          stepIndex = this.activeStep - 1;
      }
      if (stepIndex >= this.tourSteps.length) {
        yield this.finishTour(true, this.group);
        return;
      }
      yield goToStep(this, stepIndex).catch((e) => {
        return reject(e);
      });
      return resolve2(true);
    }));
  });
}
function handleVisitNextStep() {
  return __async(this, null, function* () {
    return new Promise((resolve2, reject) => __async(this, null, function* () {
      const stepIndex = this.activeStep + 1;
      try {
        yield this.visitStep(stepIndex);
      } catch (e) {
        return reject(e);
      }
      return resolve2(true);
    }));
  });
}
function handleVisitPrevStep() {
  return __async(this, null, function* () {
    return new Promise((resolve2, reject) => __async(this, null, function* () {
      const stepIndex = this.activeStep - 1;
      try {
        yield this.visitStep(stepIndex);
      } catch (e) {
        return reject(e);
      }
      return resolve2(true);
    }));
  });
}
function goToStep(tgInstance, stepIndex) {
  return new Promise((resolve2, bail) => __async(this, null, function* () {
    if (stepIndex >= tgInstance.tourSteps.length) {
      return bail("End of tour steps");
    }
    if (stepIndex < 0) {
      return bail("Start of tour steps");
    }
    const currentStepIndex = tgInstance.activeStep;
    const currentStep = tgInstance.tourSteps[currentStepIndex];
    const nextStep = tgInstance.tourSteps[stepIndex];
    if (!nextStep || !currentStep)
      return bail("Step not found by index");
    if (tgInstance._globalBeforeChangeCallback && stepIndex !== currentStepIndex) {
      try {
        yield tgInstance._globalBeforeChangeCallback();
      } catch (e) {
        return bail(e);
      }
    }
    if (currentStep.beforeLeave) {
      try {
        yield currentStep.beforeLeave(currentStep, nextStep);
      } catch (e) {
        return bail(e);
      }
    }
    if (nextStep.beforeEnter) {
      try {
        yield nextStep.beforeEnter(currentStep, nextStep);
      } catch (e) {
        return bail(e);
      }
    }
    if (typeof nextStep.target === "string")
      tgInstance.tourSteps[stepIndex].target = document.querySelector(nextStep.target);
    if (!nextStep.target || !tgInstance.tourSteps[stepIndex].target)
      tgInstance.tourSteps[stepIndex].target = document.body;
    tgInstance.activeStep = Number(stepIndex);
    yield updateDialogHtml(tgInstance).catch((e) => {
      if (tgInstance.options.debug)
        console.warn(e);
      bail(e);
    });
    if (tgInstance.options.autoScroll && nextStep.target !== document.body)
      yield scrollToTarget(tgInstance, nextStep.target);
    yield tgInstance.updatePositions();
    if (currentStep.afterLeave)
      yield currentStep.afterLeave(currentStep, nextStep);
    if (nextStep.afterEnter)
      yield nextStep.afterEnter(currentStep, nextStep);
    if (tgInstance._globalAfterChangeCallback && stepIndex !== currentStepIndex)
      yield tgInstance._globalAfterChangeCallback();
    return resolve2(true);
  }));
}
function computeTourSteps(tgInstance) {
  return __async(this, null, function* () {
    return new Promise((resolve2, reject) => __async(this, null, function* () {
      let computedSteps = [];
      if (tgInstance.options.steps && tgInstance.options.steps.length) {
        computedSteps = tgInstance.options.steps.map((t3) => {
          if (typeof t3.target === "string")
            t3.target = document.querySelector(t3.target);
          if (!t3.target)
            t3.target = document.body;
          return t3;
        });
      }
      const tourElements = document.querySelectorAll("[data-tg-tour]");
      if (tourElements)
        tourElements.forEach((tourElem) => {
          const stepTitle = tourElem.getAttribute("data-tg-title");
          const stepContent = tourElem.getAttribute("data-tg-tour");
          const stepGroup = tourElem.getAttribute("data-tg-group");
          const stepOrder = tourElem.getAttribute("data-tg-order");
          const stepFixed = tourElem.getAttribute("data-tg-fixed");
          const scrollMargin = tourElem.getAttribute("data-tg-margin");
          if (tgInstance.options.targetPadding && tgInstance.options.autoScrollOffset) {
            tourElem.style.scrollMargin = (scrollMargin ? scrollMargin + tgInstance.options.targetPadding : tgInstance.options.autoScrollOffset + tgInstance.options.targetPadding) + "px 0";
          } else {
            tourElem.style.scrollMargin = (scrollMargin ? scrollMargin : "30") + "px 0";
          }
          computedSteps.push({
            title: stepTitle ? stepTitle : void 0,
            order: stepOrder ? Number(stepOrder) : 999,
            target: tourElem,
            content: stepContent ? stepContent : void 0,
            fixed: stepFixed !== null && stepFixed !== "false",
            group: stepGroup ? stepGroup : void 0
            // TODO: Support events from data attributes
          });
        });
      if (tgInstance.group)
        computedSteps = computedSteps.filter((step) => {
          return step.group === tgInstance.group;
        });
      computedSteps.sort(function(a, b) {
        const keyA = new Date(a.order), keyB = new Date(b.order);
        return keyA < keyB ? -1 : 1;
      });
      tgInstance.tourSteps = computedSteps;
      if (!tgInstance.tourSteps.length)
        return reject("No tour steps detected" + (tgInstance.group ? " in group: " + tgInstance.group : ""));
      return resolve2(true);
    }));
  });
}
function waitForElm(selector) {
  return new Promise((resolve2) => {
    if (document.querySelector(selector)) {
      return resolve2(document.querySelector(selector));
    }
    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve2(document.querySelector(selector));
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}
function handleAddStep(newSteps) {
  return __async(this, null, function* () {
    if (!this.options.steps)
      return;
    this.options.steps.push(...newSteps);
    yield computeTourSteps(this);
    if (this.isVisible)
      yield updateDialogHtml(this).catch((e) => {
        if (this.options.debug)
          console.warn(e);
      });
    if (this.isVisible)
      this.updatePositions().catch((e) => {
        if (this.options.debug)
          console.warn(e);
      });
    if (this.isVisible)
      yield waitForElm(".tg-dialog").then(() => __async(this, null, function* () {
        yield this.destroyListeners();
        yield this.initListeners();
        return true;
      }));
  });
}
function handleTourStart(group) {
  return __async(this, null, function* () {
    return new Promise((resolve2, reject) => __async(this, null, function* () {
      if (this.isVisible) {
        if (this.options.debug)
          console.warn("Tour already active");
        return reject("Tour already active");
      }
      if (group)
        this.group = group;
      if (this.options.debug)
        console.info("Start tour");
      const tgInstance = this;
      try {
        yield computeTourSteps(tgInstance);
      } catch (e) {
        if (this.options.debug)
          console.warn(e);
        return reject(e);
      }
      yield tgInstance.visitStep(this.activeStep).catch((e) => {
        if (this.options.debug)
          console.warn(e);
        return reject(e);
      });
      yield waitForElm(".tg-dialog").then(() => __async(this, null, function* () {
        yield this.initListeners();
        if (this.options.dialogAnimate)
          this.dialog.classList.add("animate-position");
      }));
      return resolve2(true);
    }));
  });
}
function handleSetOptions(options) {
  return __async(this, null, function* () {
    if (!options)
      return;
    Object.assign(this.options, options);
    this.computeBackdropAttributes();
    yield renderDialogHtml(this).then((htmlResp) => {
      if (htmlResp)
        this.dialog.innerHTML = htmlResp;
    }).catch((e) => {
      if (this.options.debug)
        console.warn(e);
    });
    yield updateDialogHtml(this).catch((e) => {
      if (this.options.debug)
        console.warn(e);
    });
    if (this.isVisible)
      yield waitForElm(".tg-dialog").then(() => __async(this, null, function* () {
        yield this.destroyListeners();
        yield this.initListeners();
        return true;
      }));
    return this;
  });
}
function handleClose() {
  return __async(this, null, function* () {
    if (this._globalBeforeExitCallback)
      try {
        yield this._globalBeforeExitCallback();
      } catch (e) {
        return;
      }
    this.dialog.style.display = "none";
    this.backdrop.style.display = "none";
    this.isVisible = false;
    if (!this.options.rememberStep)
      this.activeStep = 0;
    if (this.options.debug)
      console.info("Tour exited");
    yield this.destroyListeners();
    setTimeout(() => {
      if (this._globalAfterExitCallback)
        this._globalAfterExitCallback();
    }, 0);
    return;
  });
}
function handleRefreshTour() {
  return __async(this, null, function* () {
    return new Promise((resolve2, reject) => __async(this, null, function* () {
      yield computeTourSteps(this).catch((e) => {
        return reject(e);
      });
      this.computeBackdropAttributes();
      yield this.refreshDialog().catch((e) => {
        return reject(e);
      });
      return resolve2(true);
    }));
  });
}
function handleRefreshDialog() {
  return __async(this, null, function* () {
    return new Promise((resolve2, reject) => __async(this, null, function* () {
      yield renderDialogHtml(this).then((htmlResp) => {
        if (htmlResp)
          this.dialog.innerHTML = htmlResp;
      }).catch((e) => {
        if (this.options.debug)
          console.warn(e);
      });
      yield updateDialogHtml(this).catch((e) => {
        if (this.options.debug)
          console.warn(e);
        reject(e);
      });
      yield this.updatePositions();
      if (this.isVisible)
        yield waitForElm(".tg-dialog").then(() => __async(this, null, function* () {
          yield this.destroyListeners();
          yield this.initListeners();
          return true;
        }));
      return resolve2(true);
    }));
  });
}
function handleFinishTour(exit = true, tourGroup = "tour") {
  return __async(this, null, function* () {
    if (this._globalFinishCallback)
      try {
        yield this._globalFinishCallback();
      } catch (e) {
        return false;
      }
    if (this.options.completeOnFinish) {
      if (!localStorage.tg_tours_complete) {
        localStorage.tg_tours_complete = [tourGroup];
        if (exit)
          yield this.exit();
        this.activeStep = 0;
        return;
      }
      const storageTours = localStorage.tg_tours_complete.split(",");
      storageTours.push(tourGroup);
      localStorage.tg_tours_complete = storageTours;
    }
    if (exit)
      yield this.exit();
    this.activeStep = 0;
    return true;
  });
}
function getIsFinished(tourGroup = "tour") {
  const storageTours = localStorage.tg_tours_complete.split(",");
  return storageTours.includes(tourGroup);
}
function delFinishedTour(tourGroup = "tour") {
  if (tourGroup === "all") {
    localStorage.tg_tours_complete = null;
    return;
  }
  const storageTours = localStorage.tg_tours_complete.split(",");
  localStorage.tg_tours_complete = storageTours.filter((x2) => {
    return x2 !== tourGroup;
  });
}
const defaultOptions = {
  nextLabel: "Next",
  prevLabel: "Back",
  finishLabel: "Finish",
  hidePrev: false,
  hideNext: false,
  dialogClass: "",
  dialogZ: 999,
  dialogWidth: 0,
  dialogMaxWidth: 340,
  dialogAnimate: true,
  dialogPlacement: void 0,
  backdropClass: "",
  backdropColor: "rgba(20,20,21,0.84)",
  backdropAnimate: true,
  targetPadding: 30,
  completeOnFinish: true,
  showStepDots: true,
  stepDotsPlacement: "footer",
  showButtons: true,
  showStepProgress: true,
  progressBar: "",
  keyboardControls: true,
  exitOnEscape: true,
  exitOnClickOutside: true,
  autoScroll: true,
  autoScrollSmooth: true,
  autoScrollOffset: 20,
  closeButton: true,
  rememberStep: false,
  debug: true,
  steps: []
};
class TourGuideClient {
  /**
   * Constructor
   * @param options
   */
  constructor(options) {
    /**
     * Primary elements
     */
    __publicField(this, "backdrop");
    __publicField(this, "dialog");
    /**
     * Default Attributes
     */
    __publicField(this, "group", "");
    __publicField(this, "isVisible", false);
    __publicField(this, "activeStep", 0);
    __publicField(this, "tourSteps", []);
    __publicField(this, "options", defaultOptions);
    __publicField(this, "isFinished", getIsFinished);
    /**
     * Backdrop / Target highlighter
     */
    __publicField(this, "createTourGuideBackdrop", createTourGuideBackdrop);
    __publicField(this, "computeBackdropAttributes", computeBackdropAttributes);
    /**
     * Dialog
     */
    __publicField(this, "createTourGuideDialog", createTourGuideDialog);
    /**
     * Methods
      */
    __publicField(this, "start", handleTourStart);
    // Start the tour - compute steps -> goToStep (checks -> update dialog html, dialog & backdrop) -> initListeners()
    __publicField(this, "visitStep", handleVisitStep);
    // visit step by stepIndex or `next` | `prev`
    __publicField(this, "addSteps", handleAddStep);
    // Push new steps to the tour
    __publicField(this, "nextStep", handleVisitNextStep);
    // navigate to next step - also handles calling finishTour() on final step
    __publicField(this, "prevStep", handleVisitPrevStep);
    // navigate to previous step
    __publicField(this, "exit", handleClose);
    // exit the tour
    __publicField(this, "refresh", handleRefreshTour);
    // Recompute everything including tour guide steps
    __publicField(this, "refreshDialog", handleRefreshDialog);
    // Recompute the dialog content & backdrop only
    __publicField(this, "finishTour", handleFinishTour);
    // Set tour as complete in localStorage & exit - pass group key
    __publicField(this, "updatePositions", computeTourPositions);
    // Set tour as complete in localStorage & exit - pass group key
    __publicField(this, "deleteFinishedTour", delFinishedTour);
    // Remove a completed tour from localStorage. Pass group key or `all` to clear.
    __publicField(this, "setOptions", handleSetOptions);
    // Update tour options & refresh dialog + backdrop
    /**
     * Listeners
     */
    // Init
    __publicField(this, "initListeners", handleInitListeners);
    // Destroy
    __publicField(this, "destroyListeners", handleDestroyListeners);
    // Track initialised eventListeners
    __publicField(this, "_trackedEvents", {
      nextBtnClickEvent: {
        initialized: false,
        fn: this.nextStep.bind(this)
      },
      prevBtnClickEvent: {
        initialized: false,
        fn: this.prevStep.bind(this)
      },
      closeBtnClickEvent: {
        initialized: false,
        fn: this.exit.bind(this)
      },
      keyPressEvent: {
        initialized: false,
        fn: keyPressHandler.bind(this)
      },
      outsideClickEvent: {
        initialized: false,
        fn: clickOutsideHandler.bind(this)
      }
    });
    /**
     * Callbacks
     */
    __publicField(this, "_globalFinishCallback");
    __publicField(this, "_globalBeforeExitCallback");
    __publicField(this, "_globalAfterExitCallback");
    __publicField(this, "_globalBeforeChangeCallback");
    __publicField(this, "_globalAfterChangeCallback");
    // FINISH
    __publicField(this, "onFinish", handleOnFinish);
    // EXIT
    __publicField(this, "onBeforeExit", handleOnBeforeExit);
    __publicField(this, "onAfterExit", handleOnAfterExit);
    // STEP CHANGE
    __publicField(this, "onBeforeStepChange", handleOnBeforeStepChange);
    __publicField(this, "onAfterStepChange", handleOnAfterStepChange);
    this.dialog = document.createElement("div");
    this.backdrop = document.createElement("div");
    this.options = defaultOptions;
    if (options)
      Object.assign(this.options, options);
    this.createTourGuideDialog().catch((e) => {
      if (this.options.debug)
        console.warn(e);
    });
    this.createTourGuideBackdrop();
  }
}
var render$x = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  _vm._self._c || _h;
  return _vm._m(0);
};
var staticRenderFns$x = [function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "d-none"
  }, [_c("div", {
    attrs: {
      "data-tg-tour": "Step 1",
      "data-tg-title": "Example heading 1",
      "data-tg-order": "1"
    }
  }, [_c("h5", {
    staticClass: "font-bold block mb-5"
  }, [_vm._v("Example heading 1")]), _c("p", [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias consequuntur cumque deserunt doloribus eos esse ipsam ipsum nam neque nisi odio officiis, pariatur sit tenetur voluptatum. Deserunt facilis quos tempora?")])]), _c("div", {
    attrs: {
      "data-tg-tour": "Step 2",
      "data-tg-title": "Example heading 2",
      "data-tg-order": "2"
    }
  }, [_c("h5", {
    staticClass: "font-bold block mb-5"
  }, [_vm._v("Example heading 2")]), _c("p", [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias consequuntur cumque deserunt doloribus eos esse ipsam ipsum nam neque nisi odio officiis, pariatur sit tenetur voluptatum. Deserunt facilis quos tempora?")])]), _c("div", {
    attrs: {
      "data-tg-tour": "Step 3",
      "data-tg-title": "Example heading 3",
      "data-tg-order": "3"
    }
  }, [_c("h5", {
    staticClass: "font-bold block mb-5"
  }, [_vm._v("Example heading 3")]), _c("p", [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias consequuntur cumque deserunt doloribus eos esse ipsam ipsum nam neque nisi odio officiis, pariatur sit tenetur voluptatum. Deserunt facilis quos tempora?")])])]);
}];
const __vue2_script$x = {
  data() {
    return {};
  },
  created() {
    const tg = new TourGuideClient();
    setTimeout(() => {
      tg.start();
    }, 3e3);
  }
};
const __cssModules$x = {};
var __component__$x = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$x,
  render$x,
  staticRenderFns$x,
  false,
  __vue2_injectStyles$x,
  null,
  null,
  null
);
function __vue2_injectStyles$x(context) {
  for (let o in __cssModules$x) {
    this[o] = __cssModules$x[o];
  }
}
const Tour = /* @__PURE__ */ function() {
  return __component__$x.exports;
}();
var Html5QrcodeSupportedFormats;
(function(Html5QrcodeSupportedFormats2) {
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["QR_CODE"] = 0] = "QR_CODE";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["AZTEC"] = 1] = "AZTEC";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["CODABAR"] = 2] = "CODABAR";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["CODE_39"] = 3] = "CODE_39";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["CODE_93"] = 4] = "CODE_93";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["CODE_128"] = 5] = "CODE_128";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["DATA_MATRIX"] = 6] = "DATA_MATRIX";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["MAXICODE"] = 7] = "MAXICODE";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["ITF"] = 8] = "ITF";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["EAN_13"] = 9] = "EAN_13";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["EAN_8"] = 10] = "EAN_8";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["PDF_417"] = 11] = "PDF_417";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["RSS_14"] = 12] = "RSS_14";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["UPC_A"] = 14] = "UPC_A";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["UPC_E"] = 15] = "UPC_E";
  Html5QrcodeSupportedFormats2[Html5QrcodeSupportedFormats2["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
})(Html5QrcodeSupportedFormats || (Html5QrcodeSupportedFormats = {}));
var html5QrcodeSupportedFormatsTextMap = /* @__PURE__ */ new Map([
  [Html5QrcodeSupportedFormats.QR_CODE, "QR_CODE"],
  [Html5QrcodeSupportedFormats.AZTEC, "AZTEC"],
  [Html5QrcodeSupportedFormats.CODABAR, "CODABAR"],
  [Html5QrcodeSupportedFormats.CODE_39, "CODE_39"],
  [Html5QrcodeSupportedFormats.CODE_93, "CODE_93"],
  [Html5QrcodeSupportedFormats.CODE_128, "CODE_128"],
  [Html5QrcodeSupportedFormats.DATA_MATRIX, "DATA_MATRIX"],
  [Html5QrcodeSupportedFormats.MAXICODE, "MAXICODE"],
  [Html5QrcodeSupportedFormats.ITF, "ITF"],
  [Html5QrcodeSupportedFormats.EAN_13, "EAN_13"],
  [Html5QrcodeSupportedFormats.EAN_8, "EAN_8"],
  [Html5QrcodeSupportedFormats.PDF_417, "PDF_417"],
  [Html5QrcodeSupportedFormats.RSS_14, "RSS_14"],
  [Html5QrcodeSupportedFormats.RSS_EXPANDED, "RSS_EXPANDED"],
  [Html5QrcodeSupportedFormats.UPC_A, "UPC_A"],
  [Html5QrcodeSupportedFormats.UPC_E, "UPC_E"],
  [Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION, "UPC_EAN_EXTENSION"]
]);
var DecodedTextType;
(function(DecodedTextType2) {
  DecodedTextType2[DecodedTextType2["UNKNOWN"] = 0] = "UNKNOWN";
  DecodedTextType2[DecodedTextType2["URL"] = 1] = "URL";
})(DecodedTextType || (DecodedTextType = {}));
function isValidHtml5QrcodeSupportedFormats(format) {
  return Object.values(Html5QrcodeSupportedFormats).includes(format);
}
var Html5QrcodeScanType;
(function(Html5QrcodeScanType2) {
  Html5QrcodeScanType2[Html5QrcodeScanType2["SCAN_TYPE_CAMERA"] = 0] = "SCAN_TYPE_CAMERA";
  Html5QrcodeScanType2[Html5QrcodeScanType2["SCAN_TYPE_FILE"] = 1] = "SCAN_TYPE_FILE";
})(Html5QrcodeScanType || (Html5QrcodeScanType = {}));
var Html5QrcodeConstants = function() {
  function Html5QrcodeConstants2() {
  }
  Html5QrcodeConstants2.GITHUB_PROJECT_URL = "https://github.com/mebjas/html5-qrcode";
  Html5QrcodeConstants2.SCAN_DEFAULT_FPS = 2;
  Html5QrcodeConstants2.DEFAULT_DISABLE_FLIP = false;
  Html5QrcodeConstants2.DEFAULT_REMEMBER_LAST_CAMERA_USED = true;
  Html5QrcodeConstants2.DEFAULT_SUPPORTED_SCAN_TYPE = [
    Html5QrcodeScanType.SCAN_TYPE_CAMERA,
    Html5QrcodeScanType.SCAN_TYPE_FILE
  ];
  return Html5QrcodeConstants2;
}();
var QrcodeResultFormat = function() {
  function QrcodeResultFormat2(format, formatName) {
    this.format = format;
    this.formatName = formatName;
  }
  QrcodeResultFormat2.prototype.toString = function() {
    return this.formatName;
  };
  QrcodeResultFormat2.create = function(format) {
    if (!html5QrcodeSupportedFormatsTextMap.has(format)) {
      throw "".concat(format, " not in html5QrcodeSupportedFormatsTextMap");
    }
    return new QrcodeResultFormat2(format, html5QrcodeSupportedFormatsTextMap.get(format));
  };
  return QrcodeResultFormat2;
}();
var Html5QrcodeResultFactory = function() {
  function Html5QrcodeResultFactory2() {
  }
  Html5QrcodeResultFactory2.createFromText = function(decodedText) {
    var qrcodeResult = {
      text: decodedText
    };
    return {
      decodedText,
      result: qrcodeResult
    };
  };
  Html5QrcodeResultFactory2.createFromQrcodeResult = function(qrcodeResult) {
    return {
      decodedText: qrcodeResult.text,
      result: qrcodeResult
    };
  };
  return Html5QrcodeResultFactory2;
}();
var Html5QrcodeErrorTypes;
(function(Html5QrcodeErrorTypes2) {
  Html5QrcodeErrorTypes2[Html5QrcodeErrorTypes2["UNKWOWN_ERROR"] = 0] = "UNKWOWN_ERROR";
  Html5QrcodeErrorTypes2[Html5QrcodeErrorTypes2["IMPLEMENTATION_ERROR"] = 1] = "IMPLEMENTATION_ERROR";
  Html5QrcodeErrorTypes2[Html5QrcodeErrorTypes2["NO_CODE_FOUND_ERROR"] = 2] = "NO_CODE_FOUND_ERROR";
})(Html5QrcodeErrorTypes || (Html5QrcodeErrorTypes = {}));
var Html5QrcodeErrorFactory = function() {
  function Html5QrcodeErrorFactory2() {
  }
  Html5QrcodeErrorFactory2.createFrom = function(error2) {
    return {
      errorMessage: error2,
      type: Html5QrcodeErrorTypes.UNKWOWN_ERROR
    };
  };
  return Html5QrcodeErrorFactory2;
}();
var BaseLoggger = function() {
  function BaseLoggger2(verbose) {
    this.verbose = verbose;
  }
  BaseLoggger2.prototype.log = function(message) {
    if (this.verbose) {
      console.log(message);
    }
  };
  BaseLoggger2.prototype.warn = function(message) {
    if (this.verbose) {
      console.warn(message);
    }
  };
  BaseLoggger2.prototype.logError = function(message, isExperimental) {
    if (this.verbose || isExperimental === true) {
      console.error(message);
    }
  };
  BaseLoggger2.prototype.logErrors = function(errors) {
    if (errors.length === 0) {
      throw "Logger#logError called without arguments";
    }
    if (this.verbose) {
      console.error(errors);
    }
  };
  return BaseLoggger2;
}();
function isNullOrUndefined(obj) {
  return typeof obj === "undefined" || obj === null;
}
function clip(value, minValue, maxValue) {
  if (value > maxValue) {
    return maxValue;
  }
  if (value < minValue) {
    return minValue;
  }
  return value;
}
var Html5QrcodeStrings = function() {
  function Html5QrcodeStrings2() {
  }
  Html5QrcodeStrings2.codeParseError = function(exception) {
    return "QR code parse error, error = ".concat(exception);
  };
  Html5QrcodeStrings2.errorGettingUserMedia = function(error2) {
    return "Error getting userMedia, error = ".concat(error2);
  };
  Html5QrcodeStrings2.onlyDeviceSupportedError = function() {
    return "The device doesn't support navigator.mediaDevices , only supported cameraIdOrConfig in this case is deviceId parameter (string).";
  };
  Html5QrcodeStrings2.cameraStreamingNotSupported = function() {
    return "Camera streaming not supported by the browser.";
  };
  Html5QrcodeStrings2.unableToQuerySupportedDevices = function() {
    return "Unable to query supported devices, unknown error.";
  };
  Html5QrcodeStrings2.insecureContextCameraQueryError = function() {
    return "Camera access is only supported in secure context like https or localhost.";
  };
  Html5QrcodeStrings2.scannerPaused = function() {
    return "Scanner paused";
  };
  return Html5QrcodeStrings2;
}();
var Html5QrcodeScannerStrings = function() {
  function Html5QrcodeScannerStrings2() {
  }
  Html5QrcodeScannerStrings2.scanningStatus = function() {
    return "Scanning";
  };
  Html5QrcodeScannerStrings2.idleStatus = function() {
    return "Idle";
  };
  Html5QrcodeScannerStrings2.errorStatus = function() {
    return "Error";
  };
  Html5QrcodeScannerStrings2.permissionStatus = function() {
    return "Permission";
  };
  Html5QrcodeScannerStrings2.noCameraFoundErrorStatus = function() {
    return "No Cameras";
  };
  Html5QrcodeScannerStrings2.lastMatch = function(decodedText) {
    return "Last Match: ".concat(decodedText);
  };
  Html5QrcodeScannerStrings2.codeScannerTitle = function() {
    return "Code Scanner";
  };
  Html5QrcodeScannerStrings2.cameraPermissionTitle = function() {
    return "Request Camera Permissions";
  };
  Html5QrcodeScannerStrings2.cameraPermissionRequesting = function() {
    return "Requesting camera permissions...";
  };
  Html5QrcodeScannerStrings2.noCameraFound = function() {
    return "No camera found";
  };
  Html5QrcodeScannerStrings2.scanButtonStopScanningText = function() {
    return "Stop Scanning";
  };
  Html5QrcodeScannerStrings2.scanButtonStartScanningText = function() {
    return "Start Scanning";
  };
  Html5QrcodeScannerStrings2.torchOnButton = function() {
    return "Switch On Torch";
  };
  Html5QrcodeScannerStrings2.torchOffButton = function() {
    return "Switch Off Torch";
  };
  Html5QrcodeScannerStrings2.torchOnFailedMessage = function() {
    return "Failed to turn on torch";
  };
  Html5QrcodeScannerStrings2.torchOffFailedMessage = function() {
    return "Failed to turn off torch";
  };
  Html5QrcodeScannerStrings2.scanButtonScanningStarting = function() {
    return "Launching Camera...";
  };
  Html5QrcodeScannerStrings2.textIfCameraScanSelected = function() {
    return "Scan an Image File";
  };
  Html5QrcodeScannerStrings2.textIfFileScanSelected = function() {
    return "Scan using camera directly";
  };
  Html5QrcodeScannerStrings2.selectCamera = function() {
    return "Select Camera";
  };
  Html5QrcodeScannerStrings2.fileSelectionChooseImage = function() {
    return "Choose Image";
  };
  Html5QrcodeScannerStrings2.fileSelectionChooseAnother = function() {
    return "Choose Another";
  };
  Html5QrcodeScannerStrings2.fileSelectionNoImageSelected = function() {
    return "No image choosen";
  };
  Html5QrcodeScannerStrings2.anonymousCameraPrefix = function() {
    return "Anonymous Camera";
  };
  Html5QrcodeScannerStrings2.dragAndDropMessage = function() {
    return "Or drop an image to scan";
  };
  Html5QrcodeScannerStrings2.dragAndDropMessageOnlyImages = function() {
    return "Or drop an image to scan (other files not supported)";
  };
  Html5QrcodeScannerStrings2.zoom = function() {
    return "zoom";
  };
  Html5QrcodeScannerStrings2.loadingImage = function() {
    return "Loading image...";
  };
  Html5QrcodeScannerStrings2.cameraScanAltText = function() {
    return "Camera based scan";
  };
  Html5QrcodeScannerStrings2.fileScanAltText = function() {
    return "Fule based scan";
  };
  return Html5QrcodeScannerStrings2;
}();
var LibraryInfoStrings = function() {
  function LibraryInfoStrings2() {
  }
  LibraryInfoStrings2.poweredBy = function() {
    return "Powered by ";
  };
  LibraryInfoStrings2.reportIssues = function() {
    return "Report issues";
  };
  return LibraryInfoStrings2;
}();
var VideoConstraintsUtil = function() {
  function VideoConstraintsUtil2() {
  }
  VideoConstraintsUtil2.isMediaStreamConstraintsValid = function(videoConstraints, logger2) {
    if (typeof videoConstraints !== "object") {
      var typeofVideoConstraints = typeof videoConstraints;
      logger2.logError("videoConstraints should be of type object, the " + "object passed is of type ".concat(typeofVideoConstraints, "."), true);
      return false;
    }
    var bannedKeys = [
      "autoGainControl",
      "channelCount",
      "echoCancellation",
      "latency",
      "noiseSuppression",
      "sampleRate",
      "sampleSize",
      "volume"
    ];
    var bannedkeysSet = new Set(bannedKeys);
    var keysInVideoConstraints = Object.keys(videoConstraints);
    for (var _i2 = 0, keysInVideoConstraints_1 = keysInVideoConstraints; _i2 < keysInVideoConstraints_1.length; _i2++) {
      var key = keysInVideoConstraints_1[_i2];
      if (bannedkeysSet.has(key)) {
        logger2.logError("".concat(key, " is not supported videoConstaints."), true);
        return false;
      }
    }
    return true;
  };
  return VideoConstraintsUtil2;
}();
var zxingJs_umd$1 = { exports: {} };
(function(module, exports) {
  (function(global2, factory) {
    factory(exports);
  })(commonjsGlobal, function(exports2) {
    function isNullOrUndefined2(obj) {
      return obj === null || obj === void 0;
    }
    var extendStatics2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b) {
      d2.__proto__ = b;
    } || function(d2, b) {
      for (var p in b)
        if (b.hasOwnProperty(p))
          d2[p] = b[p];
    };
    function __extends2(d2, b) {
      extendStatics2(d2, b);
      function __() {
        this.constructor = d2;
      }
      d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    function fixProto(target2, prototype) {
      var setPrototypeOf = Object.setPrototypeOf;
      setPrototypeOf ? setPrototypeOf(target2, prototype) : target2.__proto__ = prototype;
    }
    function fixStack(target2, fn) {
      if (fn === void 0) {
        fn = target2.constructor;
      }
      var captureStackTrace = Error.captureStackTrace;
      captureStackTrace && captureStackTrace(target2, fn);
    }
    var CustomError = function(_super) {
      __extends2(CustomError2, _super);
      function CustomError2(message) {
        var _newTarget = this.constructor;
        var _this2 = _super.call(this, message) || this;
        Object.defineProperty(_this2, "name", {
          value: _newTarget.name,
          enumerable: false
        });
        fixProto(_this2, _newTarget.prototype);
        fixStack(_this2);
        return _this2;
      }
      return CustomError2;
    }(Error);
    class Exception extends CustomError {
      /**
       * Allows Exception to be constructed directly
       * with some message and prototype definition.
       */
      constructor(message = void 0) {
        super(message);
        this.message = message;
      }
      getKind() {
        const ex = this.constructor;
        return ex.kind;
      }
    }
    Exception.kind = "Exception";
    class ArgumentException extends Exception {
    }
    ArgumentException.kind = "ArgumentException";
    class IllegalArgumentException extends Exception {
    }
    IllegalArgumentException.kind = "IllegalArgumentException";
    class BinaryBitmap {
      constructor(binarizer) {
        this.binarizer = binarizer;
        if (binarizer === null) {
          throw new IllegalArgumentException("Binarizer must be non-null.");
        }
      }
      /**
       * @return The width of the bitmap.
       */
      getWidth() {
        return this.binarizer.getWidth();
      }
      /**
       * @return The height of the bitmap.
       */
      getHeight() {
        return this.binarizer.getHeight();
      }
      /**
       * Converts one row of luminance data to 1 bit data. May actually do the conversion, or return
       * cached data. Callers should assume this method is expensive and call it as seldom as possible.
       * This method is intended for decoding 1D barcodes and may choose to apply sharpening.
       *
       * @param y The row to fetch, which must be in [0, bitmap height)
       * @param row An optional preallocated array. If null or too small, it will be ignored.
       *            If used, the Binarizer will call BitArray.clear(). Always use the returned object.
       * @return The array of bits for this row (true means black).
       * @throws NotFoundException if row can't be binarized
       */
      getBlackRow(y, row) {
        return this.binarizer.getBlackRow(y, row);
      }
      /**
       * Converts a 2D array of luminance data to 1 bit. As above, assume this method is expensive
       * and do not call it repeatedly. This method is intended for decoding 2D barcodes and may or
       * may not apply sharpening. Therefore, a row from this matrix may not be identical to one
       * fetched using getBlackRow(), so don't mix and match between them.
       *
       * @return The 2D array of bits for the image (true means black).
       * @throws NotFoundException if image can't be binarized to make a matrix
       */
      getBlackMatrix() {
        if (this.matrix === null || this.matrix === void 0) {
          this.matrix = this.binarizer.getBlackMatrix();
        }
        return this.matrix;
      }
      /**
       * @return Whether this bitmap can be cropped.
       */
      isCropSupported() {
        return this.binarizer.getLuminanceSource().isCropSupported();
      }
      /**
       * Returns a new object with cropped image data. Implementations may keep a reference to the
       * original data rather than a copy. Only callable if isCropSupported() is true.
       *
       * @param left The left coordinate, which must be in [0,getWidth())
       * @param top The top coordinate, which must be in [0,getHeight())
       * @param width The width of the rectangle to crop.
       * @param height The height of the rectangle to crop.
       * @return A cropped version of this object.
       */
      crop(left, top, width, height) {
        const newSource = this.binarizer.getLuminanceSource().crop(left, top, width, height);
        return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
      }
      /**
       * @return Whether this bitmap supports counter-clockwise rotation.
       */
      isRotateSupported() {
        return this.binarizer.getLuminanceSource().isRotateSupported();
      }
      /**
       * Returns a new object with rotated image data by 90 degrees counterclockwise.
       * Only callable if {@link #isRotateSupported()} is true.
       *
       * @return A rotated version of this object.
       */
      rotateCounterClockwise() {
        const newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise();
        return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
      }
      /**
       * Returns a new object with rotated image data by 45 degrees counterclockwise.
       * Only callable if {@link #isRotateSupported()} is true.
       *
       * @return A rotated version of this object.
       */
      rotateCounterClockwise45() {
        const newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
        return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
      }
      /*@Override*/
      toString() {
        try {
          return this.getBlackMatrix().toString();
        } catch (e) {
          return "";
        }
      }
    }
    class ChecksumException extends Exception {
      static getChecksumInstance() {
        return new ChecksumException();
      }
    }
    ChecksumException.kind = "ChecksumException";
    class Binarizer {
      constructor(source) {
        this.source = source;
      }
      getLuminanceSource() {
        return this.source;
      }
      getWidth() {
        return this.source.getWidth();
      }
      getHeight() {
        return this.source.getHeight();
      }
    }
    class System {
      // public static void arraycopy(Object src, int srcPos, Object dest, int destPos, int length)
      /**
       * Makes a copy of a array.
       */
      static arraycopy(src, srcPos, dest, destPos, length) {
        while (length--) {
          dest[destPos++] = src[srcPos++];
        }
      }
      /**
       * Returns the current time in milliseconds.
       */
      static currentTimeMillis() {
        return Date.now();
      }
    }
    class IndexOutOfBoundsException extends Exception {
    }
    IndexOutOfBoundsException.kind = "IndexOutOfBoundsException";
    class ArrayIndexOutOfBoundsException extends IndexOutOfBoundsException {
      constructor(index2 = void 0, message = void 0) {
        super(message);
        this.index = index2;
        this.message = message;
      }
    }
    ArrayIndexOutOfBoundsException.kind = "ArrayIndexOutOfBoundsException";
    class Arrays {
      /**
       * Assigns the specified int value to each element of the specified array
       * of ints.
       *
       * @param a the array to be filled
       * @param val the value to be stored in all elements of the array
       */
      static fill(a, val) {
        for (let i2 = 0, len = a.length; i2 < len; i2++)
          a[i2] = val;
      }
      /**
       * Assigns the specified int value to each element of the specified
       * range of the specified array of ints.  The range to be filled
       * extends from index {@code fromIndex}, inclusive, to index
       * {@code toIndex}, exclusive.  (If {@code fromIndex==toIndex}, the
       * range to be filled is empty.)
       *
       * @param a the array to be filled
       * @param fromIndex the index of the first element (inclusive) to be
       *        filled with the specified value
       * @param toIndex the index of the last element (exclusive) to be
       *        filled with the specified value
       * @param val the value to be stored in all elements of the array
       * @throws IllegalArgumentException if {@code fromIndex > toIndex}
       * @throws ArrayIndexOutOfBoundsException if {@code fromIndex < 0} or
       *         {@code toIndex > a.length}
       */
      static fillWithin(a, fromIndex, toIndex, val) {
        Arrays.rangeCheck(a.length, fromIndex, toIndex);
        for (let i2 = fromIndex; i2 < toIndex; i2++)
          a[i2] = val;
      }
      /**
       * Checks that {@code fromIndex} and {@code toIndex} are in
       * the range and throws an exception if they aren't.
       */
      static rangeCheck(arrayLength, fromIndex, toIndex) {
        if (fromIndex > toIndex) {
          throw new IllegalArgumentException("fromIndex(" + fromIndex + ") > toIndex(" + toIndex + ")");
        }
        if (fromIndex < 0) {
          throw new ArrayIndexOutOfBoundsException(fromIndex);
        }
        if (toIndex > arrayLength) {
          throw new ArrayIndexOutOfBoundsException(toIndex);
        }
      }
      static asList(...args) {
        return args;
      }
      static create(rows, cols, value) {
        let arr = Array.from({ length: rows });
        return arr.map((x2) => Array.from({ length: cols }).fill(value));
      }
      static createInt32Array(rows, cols, value) {
        let arr = Array.from({ length: rows });
        return arr.map((x2) => Int32Array.from({ length: cols }).fill(value));
      }
      static equals(first, second) {
        if (!first) {
          return false;
        }
        if (!second) {
          return false;
        }
        if (!first.length) {
          return false;
        }
        if (!second.length) {
          return false;
        }
        if (first.length !== second.length) {
          return false;
        }
        for (let i2 = 0, length = first.length; i2 < length; i2++) {
          if (first[i2] !== second[i2]) {
            return false;
          }
        }
        return true;
      }
      static hashCode(a) {
        if (a === null) {
          return 0;
        }
        let result2 = 1;
        for (const element of a) {
          result2 = 31 * result2 + element;
        }
        return result2;
      }
      static fillUint8Array(a, value) {
        for (let i2 = 0; i2 !== a.length; i2++) {
          a[i2] = value;
        }
      }
      static copyOf(original, newLength) {
        return original.slice(0, newLength);
      }
      static copyOfUint8Array(original, newLength) {
        if (original.length <= newLength) {
          const newArray = new Uint8Array(newLength);
          newArray.set(original);
          return newArray;
        }
        return original.slice(0, newLength);
      }
      static copyOfRange(original, from, to) {
        const newLength = to - from;
        const copy = new Int32Array(newLength);
        System.arraycopy(original, from, copy, 0, newLength);
        return copy;
      }
      /*
      * Returns the index of of the element in a sorted array or (-n-1) where n is the insertion point
      * for the new element.
      * Parameters:
      *     ar - A sorted array
      *     el - An element to search for
      *     comparator - A comparator function. The function takes two arguments: (a, b) and returns:
      *        a negative number  if a is less than b;
      *        0 if a is equal to b;
      *        a positive number of a is greater than b.
      * The array may contain duplicate elements. If there are more than one equal elements in the array,
      * the returned value can be the index of any one of the equal elements.
      *
      * http://jsfiddle.net/aryzhov/pkfst550/
      */
      static binarySearch(ar, el, comparator) {
        if (void 0 === comparator) {
          comparator = Arrays.numberComparator;
        }
        let m = 0;
        let n2 = ar.length - 1;
        while (m <= n2) {
          const k = n2 + m >> 1;
          const cmp = comparator(el, ar[k]);
          if (cmp > 0) {
            m = k + 1;
          } else if (cmp < 0) {
            n2 = k - 1;
          } else {
            return k;
          }
        }
        return -m - 1;
      }
      static numberComparator(a, b) {
        return a - b;
      }
    }
    class Integer {
      static numberOfTrailingZeros(i2) {
        let y;
        if (i2 === 0)
          return 32;
        let n2 = 31;
        y = i2 << 16;
        if (y !== 0) {
          n2 -= 16;
          i2 = y;
        }
        y = i2 << 8;
        if (y !== 0) {
          n2 -= 8;
          i2 = y;
        }
        y = i2 << 4;
        if (y !== 0) {
          n2 -= 4;
          i2 = y;
        }
        y = i2 << 2;
        if (y !== 0) {
          n2 -= 2;
          i2 = y;
        }
        return n2 - (i2 << 1 >>> 31);
      }
      static numberOfLeadingZeros(i2) {
        if (i2 === 0) {
          return 32;
        }
        let n2 = 1;
        if (i2 >>> 16 === 0) {
          n2 += 16;
          i2 <<= 16;
        }
        if (i2 >>> 24 === 0) {
          n2 += 8;
          i2 <<= 8;
        }
        if (i2 >>> 28 === 0) {
          n2 += 4;
          i2 <<= 4;
        }
        if (i2 >>> 30 === 0) {
          n2 += 2;
          i2 <<= 2;
        }
        n2 -= i2 >>> 31;
        return n2;
      }
      static toHexString(i2) {
        return i2.toString(16);
      }
      static toBinaryString(intNumber) {
        return String(parseInt(String(intNumber), 2));
      }
      // Returns the number of one-bits in the two's complement binary representation of the specified int value. This function is sometimes referred to as the population count.
      // Returns:
      // the number of one-bits in the two's complement binary representation of the specified int value.
      static bitCount(i2) {
        i2 = i2 - (i2 >>> 1 & 1431655765);
        i2 = (i2 & 858993459) + (i2 >>> 2 & 858993459);
        i2 = i2 + (i2 >>> 4) & 252645135;
        i2 = i2 + (i2 >>> 8);
        i2 = i2 + (i2 >>> 16);
        return i2 & 63;
      }
      static truncDivision(dividend, divisor) {
        return Math.trunc(dividend / divisor);
      }
      /**
       * Converts A string to an integer.
       * @param s A string to convert into a number.
       * @param radix A value between 2 and 36 that specifies the base of the number in numString. If this argument is not supplied, strings with a prefix of '0x' are considered hexadecimal. All other strings are considered decimal.
       */
      static parseInt(num, radix = void 0) {
        return parseInt(num, radix);
      }
    }
    Integer.MIN_VALUE_32_BITS = -2147483648;
    Integer.MAX_VALUE = Number.MAX_SAFE_INTEGER;
    class BitArray {
      // For testing only
      constructor(size, bits) {
        if (void 0 === size) {
          this.size = 0;
          this.bits = new Int32Array(1);
        } else {
          this.size = size;
          if (void 0 === bits || null === bits) {
            this.bits = BitArray.makeArray(size);
          } else {
            this.bits = bits;
          }
        }
      }
      getSize() {
        return this.size;
      }
      getSizeInBytes() {
        return Math.floor((this.size + 7) / 8);
      }
      ensureCapacity(size) {
        if (size > this.bits.length * 32) {
          const newBits = BitArray.makeArray(size);
          System.arraycopy(this.bits, 0, newBits, 0, this.bits.length);
          this.bits = newBits;
        }
      }
      /**
       * @param i bit to get
       * @return true iff bit i is set
       */
      get(i2) {
        return (this.bits[Math.floor(i2 / 32)] & 1 << (i2 & 31)) !== 0;
      }
      /**
       * Sets bit i.
       *
       * @param i bit to set
       */
      set(i2) {
        this.bits[Math.floor(i2 / 32)] |= 1 << (i2 & 31);
      }
      /**
       * Flips bit i.
       *
       * @param i bit to set
       */
      flip(i2) {
        this.bits[Math.floor(i2 / 32)] ^= 1 << (i2 & 31);
      }
      /**
       * @param from first bit to check
       * @return index of first bit that is set, starting from the given index, or size if none are set
       *  at or beyond this given index
       * @see #getNextUnset(int)
       */
      getNextSet(from) {
        const size = this.size;
        if (from >= size) {
          return size;
        }
        const bits = this.bits;
        let bitsOffset = Math.floor(from / 32);
        let currentBits = bits[bitsOffset];
        currentBits &= ~((1 << (from & 31)) - 1);
        const length = bits.length;
        while (currentBits === 0) {
          if (++bitsOffset === length) {
            return size;
          }
          currentBits = bits[bitsOffset];
        }
        const result2 = bitsOffset * 32 + Integer.numberOfTrailingZeros(currentBits);
        return result2 > size ? size : result2;
      }
      /**
       * @param from index to start looking for unset bit
       * @return index of next unset bit, or {@code size} if none are unset until the end
       * @see #getNextSet(int)
       */
      getNextUnset(from) {
        const size = this.size;
        if (from >= size) {
          return size;
        }
        const bits = this.bits;
        let bitsOffset = Math.floor(from / 32);
        let currentBits = ~bits[bitsOffset];
        currentBits &= ~((1 << (from & 31)) - 1);
        const length = bits.length;
        while (currentBits === 0) {
          if (++bitsOffset === length) {
            return size;
          }
          currentBits = ~bits[bitsOffset];
        }
        const result2 = bitsOffset * 32 + Integer.numberOfTrailingZeros(currentBits);
        return result2 > size ? size : result2;
      }
      /**
       * Sets a block of 32 bits, starting at bit i.
       *
       * @param i first bit to set
       * @param newBits the new value of the next 32 bits. Note again that the least-significant bit
       * corresponds to bit i, the next-least-significant to i+1, and so on.
       */
      setBulk(i2, newBits) {
        this.bits[Math.floor(i2 / 32)] = newBits;
      }
      /**
       * Sets a range of bits.
       *
       * @param start start of range, inclusive.
       * @param end end of range, exclusive
       */
      setRange(start, end) {
        if (end < start || start < 0 || end > this.size) {
          throw new IllegalArgumentException();
        }
        if (end === start) {
          return;
        }
        end--;
        const firstInt = Math.floor(start / 32);
        const lastInt = Math.floor(end / 32);
        const bits = this.bits;
        for (let i2 = firstInt; i2 <= lastInt; i2++) {
          const firstBit = i2 > firstInt ? 0 : start & 31;
          const lastBit = i2 < lastInt ? 31 : end & 31;
          const mask = (2 << lastBit) - (1 << firstBit);
          bits[i2] |= mask;
        }
      }
      /**
       * Clears all bits (sets to false).
       */
      clear() {
        const max2 = this.bits.length;
        const bits = this.bits;
        for (let i2 = 0; i2 < max2; i2++) {
          bits[i2] = 0;
        }
      }
      /**
       * Efficient method to check if a range of bits is set, or not set.
       *
       * @param start start of range, inclusive.
       * @param end end of range, exclusive
       * @param value if true, checks that bits in range are set, otherwise checks that they are not set
       * 
       * @return true iff all bits are set or not set in range, according to value argument
       * @throws IllegalArgumentException if end is less than start or the range is not contained in the array
       */
      isRange(start, end, value) {
        if (end < start || start < 0 || end > this.size) {
          throw new IllegalArgumentException();
        }
        if (end === start) {
          return true;
        }
        end--;
        const firstInt = Math.floor(start / 32);
        const lastInt = Math.floor(end / 32);
        const bits = this.bits;
        for (let i2 = firstInt; i2 <= lastInt; i2++) {
          const firstBit = i2 > firstInt ? 0 : start & 31;
          const lastBit = i2 < lastInt ? 31 : end & 31;
          const mask = (2 << lastBit) - (1 << firstBit) & 4294967295;
          if ((bits[i2] & mask) !== (value ? mask : 0)) {
            return false;
          }
        }
        return true;
      }
      appendBit(bit) {
        this.ensureCapacity(this.size + 1);
        if (bit) {
          this.bits[Math.floor(this.size / 32)] |= 1 << (this.size & 31);
        }
        this.size++;
      }
      /**
       * Appends the least-significant bits, from value, in order from most-significant to
       * least-significant. For example, appending 6 bits from 0x000001E will append the bits
       * 0, 1, 1, 1, 1, 0 in that order.
       *
       * @param value {@code int} containing bits to append
       * @param numBits bits from value to append
       */
      appendBits(value, numBits) {
        if (numBits < 0 || numBits > 32) {
          throw new IllegalArgumentException("Num bits must be between 0 and 32");
        }
        this.ensureCapacity(this.size + numBits);
        for (let numBitsLeft = numBits; numBitsLeft > 0; numBitsLeft--) {
          this.appendBit((value >> numBitsLeft - 1 & 1) === 1);
        }
      }
      appendBitArray(other) {
        const otherSize = other.size;
        this.ensureCapacity(this.size + otherSize);
        for (let i2 = 0; i2 < otherSize; i2++) {
          this.appendBit(other.get(i2));
        }
      }
      xor(other) {
        if (this.size !== other.size) {
          throw new IllegalArgumentException("Sizes don't match");
        }
        const bits = this.bits;
        for (let i2 = 0, length = bits.length; i2 < length; i2++) {
          bits[i2] ^= other.bits[i2];
        }
      }
      /**
       *
       * @param bitOffset first bit to start writing
       * @param array array to write into. Bytes are written most-significant byte first. This is the opposite
       *  of the internal representation, which is exposed by {@link #getBitArray()}
       * @param offset position in array to start writing
       * @param numBytes how many bytes to write
       */
      toBytes(bitOffset, array, offset2, numBytes) {
        for (let i2 = 0; i2 < numBytes; i2++) {
          let theByte = 0;
          for (let j = 0; j < 8; j++) {
            if (this.get(bitOffset)) {
              theByte |= 1 << 7 - j;
            }
            bitOffset++;
          }
          array[offset2 + i2] = /*(byte)*/
          theByte;
        }
      }
      /**
       * @return underlying array of ints. The first element holds the first 32 bits, and the least
       *         significant bit is bit 0.
       */
      getBitArray() {
        return this.bits;
      }
      /**
       * Reverses all bits in the array.
       */
      reverse() {
        const newBits = new Int32Array(this.bits.length);
        const len = Math.floor((this.size - 1) / 32);
        const oldBitsLen = len + 1;
        const bits = this.bits;
        for (let i2 = 0; i2 < oldBitsLen; i2++) {
          let x2 = bits[i2];
          x2 = x2 >> 1 & 1431655765 | (x2 & 1431655765) << 1;
          x2 = x2 >> 2 & 858993459 | (x2 & 858993459) << 2;
          x2 = x2 >> 4 & 252645135 | (x2 & 252645135) << 4;
          x2 = x2 >> 8 & 16711935 | (x2 & 16711935) << 8;
          x2 = x2 >> 16 & 65535 | (x2 & 65535) << 16;
          newBits[len - i2] = /*(int)*/
          x2;
        }
        if (this.size !== oldBitsLen * 32) {
          const leftOffset = oldBitsLen * 32 - this.size;
          let currentInt = newBits[0] >>> leftOffset;
          for (let i2 = 1; i2 < oldBitsLen; i2++) {
            const nextInt = newBits[i2];
            currentInt |= nextInt << 32 - leftOffset;
            newBits[i2 - 1] = currentInt;
            currentInt = nextInt >>> leftOffset;
          }
          newBits[oldBitsLen - 1] = currentInt;
        }
        this.bits = newBits;
      }
      static makeArray(size) {
        return new Int32Array(Math.floor((size + 31) / 32));
      }
      /*@Override*/
      equals(o) {
        if (!(o instanceof BitArray)) {
          return false;
        }
        const other = o;
        return this.size === other.size && Arrays.equals(this.bits, other.bits);
      }
      /*@Override*/
      hashCode() {
        return 31 * this.size + Arrays.hashCode(this.bits);
      }
      /*@Override*/
      toString() {
        let result2 = "";
        for (let i2 = 0, size = this.size; i2 < size; i2++) {
          if ((i2 & 7) === 0) {
            result2 += " ";
          }
          result2 += this.get(i2) ? "X" : ".";
        }
        return result2;
      }
      /*@Override*/
      clone() {
        return new BitArray(this.size, this.bits.slice());
      }
    }
    var DecodeHintType;
    (function(DecodeHintType2) {
      DecodeHintType2[DecodeHintType2["OTHER"] = 0] = "OTHER";
      DecodeHintType2[DecodeHintType2["PURE_BARCODE"] = 1] = "PURE_BARCODE";
      DecodeHintType2[DecodeHintType2["POSSIBLE_FORMATS"] = 2] = "POSSIBLE_FORMATS";
      DecodeHintType2[DecodeHintType2["TRY_HARDER"] = 3] = "TRY_HARDER";
      DecodeHintType2[DecodeHintType2["CHARACTER_SET"] = 4] = "CHARACTER_SET";
      DecodeHintType2[DecodeHintType2["ALLOWED_LENGTHS"] = 5] = "ALLOWED_LENGTHS";
      DecodeHintType2[DecodeHintType2["ASSUME_CODE_39_CHECK_DIGIT"] = 6] = "ASSUME_CODE_39_CHECK_DIGIT";
      DecodeHintType2[DecodeHintType2["ASSUME_GS1"] = 7] = "ASSUME_GS1";
      DecodeHintType2[DecodeHintType2["RETURN_CODABAR_START_END"] = 8] = "RETURN_CODABAR_START_END";
      DecodeHintType2[DecodeHintType2["NEED_RESULT_POINT_CALLBACK"] = 9] = "NEED_RESULT_POINT_CALLBACK";
      DecodeHintType2[DecodeHintType2["ALLOWED_EAN_EXTENSIONS"] = 10] = "ALLOWED_EAN_EXTENSIONS";
    })(DecodeHintType || (DecodeHintType = {}));
    var DecodeHintType$1 = DecodeHintType;
    class FormatException extends Exception {
      static getFormatInstance() {
        return new FormatException();
      }
    }
    FormatException.kind = "FormatException";
    var CharacterSetValueIdentifiers;
    (function(CharacterSetValueIdentifiers2) {
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["Cp437"] = 0] = "Cp437";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_1"] = 1] = "ISO8859_1";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_2"] = 2] = "ISO8859_2";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_3"] = 3] = "ISO8859_3";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_4"] = 4] = "ISO8859_4";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_5"] = 5] = "ISO8859_5";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_6"] = 6] = "ISO8859_6";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_7"] = 7] = "ISO8859_7";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_8"] = 8] = "ISO8859_8";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_9"] = 9] = "ISO8859_9";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_10"] = 10] = "ISO8859_10";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_11"] = 11] = "ISO8859_11";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_13"] = 12] = "ISO8859_13";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_14"] = 13] = "ISO8859_14";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_15"] = 14] = "ISO8859_15";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ISO8859_16"] = 15] = "ISO8859_16";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["SJIS"] = 16] = "SJIS";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["Cp1250"] = 17] = "Cp1250";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["Cp1251"] = 18] = "Cp1251";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["Cp1252"] = 19] = "Cp1252";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["Cp1256"] = 20] = "Cp1256";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["UnicodeBigUnmarked"] = 21] = "UnicodeBigUnmarked";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["UTF8"] = 22] = "UTF8";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["ASCII"] = 23] = "ASCII";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["Big5"] = 24] = "Big5";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["GB18030"] = 25] = "GB18030";
      CharacterSetValueIdentifiers2[CharacterSetValueIdentifiers2["EUC_KR"] = 26] = "EUC_KR";
    })(CharacterSetValueIdentifiers || (CharacterSetValueIdentifiers = {}));
    class CharacterSetECI {
      constructor(valueIdentifier, valuesParam, name, ...otherEncodingNames) {
        this.valueIdentifier = valueIdentifier;
        this.name = name;
        if (typeof valuesParam === "number") {
          this.values = Int32Array.from([valuesParam]);
        } else {
          this.values = valuesParam;
        }
        this.otherEncodingNames = otherEncodingNames;
        CharacterSetECI.VALUE_IDENTIFIER_TO_ECI.set(valueIdentifier, this);
        CharacterSetECI.NAME_TO_ECI.set(name, this);
        const values2 = this.values;
        for (let i2 = 0, length = values2.length; i2 !== length; i2++) {
          const v = values2[i2];
          CharacterSetECI.VALUES_TO_ECI.set(v, this);
        }
        for (const otherName of otherEncodingNames) {
          CharacterSetECI.NAME_TO_ECI.set(otherName, this);
        }
      }
      // CharacterSetECI(value: number /*int*/) {
      //   this(new Int32Array {value})
      // }
      // CharacterSetECI(value: number /*int*/, String... otherEncodingNames) {
      //   this.values = new Int32Array {value}
      //   this.otherEncodingNames = otherEncodingNames
      // }
      // CharacterSetECI(values: Int32Array, String... otherEncodingNames) {
      //   this.values = values
      //   this.otherEncodingNames = otherEncodingNames
      // }
      getValueIdentifier() {
        return this.valueIdentifier;
      }
      getName() {
        return this.name;
      }
      getValue() {
        return this.values[0];
      }
      /**
       * @param value character set ECI value
       * @return {@code CharacterSetECI} representing ECI of given value, or null if it is legal but
       *   unsupported
       * @throws FormatException if ECI value is invalid
       */
      static getCharacterSetECIByValue(value) {
        if (value < 0 || value >= 900) {
          throw new FormatException("incorect value");
        }
        const characterSet = CharacterSetECI.VALUES_TO_ECI.get(value);
        if (void 0 === characterSet) {
          throw new FormatException("incorect value");
        }
        return characterSet;
      }
      /**
       * @param name character set ECI encoding name
       * @return CharacterSetECI representing ECI for character encoding, or null if it is legal
       *   but unsupported
       */
      static getCharacterSetECIByName(name) {
        const characterSet = CharacterSetECI.NAME_TO_ECI.get(name);
        if (void 0 === characterSet) {
          throw new FormatException("incorect value");
        }
        return characterSet;
      }
      equals(o) {
        if (!(o instanceof CharacterSetECI)) {
          return false;
        }
        const other = o;
        return this.getName() === other.getName();
      }
    }
    CharacterSetECI.VALUE_IDENTIFIER_TO_ECI = /* @__PURE__ */ new Map();
    CharacterSetECI.VALUES_TO_ECI = /* @__PURE__ */ new Map();
    CharacterSetECI.NAME_TO_ECI = /* @__PURE__ */ new Map();
    CharacterSetECI.Cp437 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp437, Int32Array.from([0, 2]), "Cp437");
    CharacterSetECI.ISO8859_1 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_1, Int32Array.from([1, 3]), "ISO-8859-1", "ISO88591", "ISO8859_1");
    CharacterSetECI.ISO8859_2 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_2, 4, "ISO-8859-2", "ISO88592", "ISO8859_2");
    CharacterSetECI.ISO8859_3 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_3, 5, "ISO-8859-3", "ISO88593", "ISO8859_3");
    CharacterSetECI.ISO8859_4 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_4, 6, "ISO-8859-4", "ISO88594", "ISO8859_4");
    CharacterSetECI.ISO8859_5 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_5, 7, "ISO-8859-5", "ISO88595", "ISO8859_5");
    CharacterSetECI.ISO8859_6 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_6, 8, "ISO-8859-6", "ISO88596", "ISO8859_6");
    CharacterSetECI.ISO8859_7 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_7, 9, "ISO-8859-7", "ISO88597", "ISO8859_7");
    CharacterSetECI.ISO8859_8 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_8, 10, "ISO-8859-8", "ISO88598", "ISO8859_8");
    CharacterSetECI.ISO8859_9 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_9, 11, "ISO-8859-9", "ISO88599", "ISO8859_9");
    CharacterSetECI.ISO8859_10 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_10, 12, "ISO-8859-10", "ISO885910", "ISO8859_10");
    CharacterSetECI.ISO8859_11 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_11, 13, "ISO-8859-11", "ISO885911", "ISO8859_11");
    CharacterSetECI.ISO8859_13 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_13, 15, "ISO-8859-13", "ISO885913", "ISO8859_13");
    CharacterSetECI.ISO8859_14 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_14, 16, "ISO-8859-14", "ISO885914", "ISO8859_14");
    CharacterSetECI.ISO8859_15 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_15, 17, "ISO-8859-15", "ISO885915", "ISO8859_15");
    CharacterSetECI.ISO8859_16 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_16, 18, "ISO-8859-16", "ISO885916", "ISO8859_16");
    CharacterSetECI.SJIS = new CharacterSetECI(CharacterSetValueIdentifiers.SJIS, 20, "SJIS", "Shift_JIS");
    CharacterSetECI.Cp1250 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1250, 21, "Cp1250", "windows-1250");
    CharacterSetECI.Cp1251 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1251, 22, "Cp1251", "windows-1251");
    CharacterSetECI.Cp1252 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1252, 23, "Cp1252", "windows-1252");
    CharacterSetECI.Cp1256 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1256, 24, "Cp1256", "windows-1256");
    CharacterSetECI.UnicodeBigUnmarked = new CharacterSetECI(CharacterSetValueIdentifiers.UnicodeBigUnmarked, 25, "UnicodeBigUnmarked", "UTF-16BE", "UnicodeBig");
    CharacterSetECI.UTF8 = new CharacterSetECI(CharacterSetValueIdentifiers.UTF8, 26, "UTF8", "UTF-8");
    CharacterSetECI.ASCII = new CharacterSetECI(CharacterSetValueIdentifiers.ASCII, Int32Array.from([27, 170]), "ASCII", "US-ASCII");
    CharacterSetECI.Big5 = new CharacterSetECI(CharacterSetValueIdentifiers.Big5, 28, "Big5");
    CharacterSetECI.GB18030 = new CharacterSetECI(CharacterSetValueIdentifiers.GB18030, 29, "GB18030", "GB2312", "EUC_CN", "GBK");
    CharacterSetECI.EUC_KR = new CharacterSetECI(CharacterSetValueIdentifiers.EUC_KR, 30, "EUC_KR", "EUC-KR");
    class UnsupportedOperationException extends Exception {
    }
    UnsupportedOperationException.kind = "UnsupportedOperationException";
    class StringEncoding {
      /**
       * Decodes some Uint8Array to a string format.
       */
      static decode(bytes, encoding) {
        const encodingName = this.encodingName(encoding);
        if (this.customDecoder) {
          return this.customDecoder(bytes, encodingName);
        }
        if (typeof TextDecoder === "undefined" || this.shouldDecodeOnFallback(encodingName)) {
          return this.decodeFallback(bytes, encodingName);
        }
        return new TextDecoder(encodingName).decode(bytes);
      }
      /**
       * Checks if the decoding method should use the fallback for decoding
       * once Node TextDecoder doesn't support all encoding formats.
       *
       * @param encodingName
       */
      static shouldDecodeOnFallback(encodingName) {
        return !StringEncoding.isBrowser() && encodingName === "ISO-8859-1";
      }
      /**
       * Encodes some string into a Uint8Array.
       */
      static encode(s2, encoding) {
        const encodingName = this.encodingName(encoding);
        if (this.customEncoder) {
          return this.customEncoder(s2, encodingName);
        }
        if (typeof TextEncoder === "undefined") {
          return this.encodeFallback(s2);
        }
        return new TextEncoder().encode(s2);
      }
      static isBrowser() {
        return typeof window !== "undefined" && {}.toString.call(window) === "[object Window]";
      }
      /**
       * Returns the string value from some encoding character set.
       */
      static encodingName(encoding) {
        return typeof encoding === "string" ? encoding : encoding.getName();
      }
      /**
       * Returns character set from some encoding character set.
       */
      static encodingCharacterSet(encoding) {
        if (encoding instanceof CharacterSetECI) {
          return encoding;
        }
        return CharacterSetECI.getCharacterSetECIByName(encoding);
      }
      /**
       * Runs a fallback for the native decoding funcion.
       */
      static decodeFallback(bytes, encoding) {
        const characterSet = this.encodingCharacterSet(encoding);
        if (StringEncoding.isDecodeFallbackSupported(characterSet)) {
          let s2 = "";
          for (let i2 = 0, length = bytes.length; i2 < length; i2++) {
            let h = bytes[i2].toString(16);
            if (h.length < 2) {
              h = "0" + h;
            }
            s2 += "%" + h;
          }
          return decodeURIComponent(s2);
        }
        if (characterSet.equals(CharacterSetECI.UnicodeBigUnmarked)) {
          return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
        }
        throw new UnsupportedOperationException(`Encoding ${this.encodingName(encoding)} not supported by fallback.`);
      }
      static isDecodeFallbackSupported(characterSet) {
        return characterSet.equals(CharacterSetECI.UTF8) || characterSet.equals(CharacterSetECI.ISO8859_1) || characterSet.equals(CharacterSetECI.ASCII);
      }
      /**
       * Runs a fallback for the native encoding funcion.
       *
       * @see https://stackoverflow.com/a/17192845/4367683
       */
      static encodeFallback(s2) {
        const encodedURIstring = btoa(unescape(encodeURIComponent(s2)));
        const charList = encodedURIstring.split("");
        const uintArray = [];
        for (let i2 = 0; i2 < charList.length; i2++) {
          uintArray.push(charList[i2].charCodeAt(0));
        }
        return new Uint8Array(uintArray);
      }
    }
    class StringUtils {
      // SHIFT_JIS.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING) ||
      // EUC_JP.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING);
      static castAsNonUtf8Char(code, encoding = null) {
        const e = encoding ? encoding.getName() : this.ISO88591;
        return StringEncoding.decode(new Uint8Array([code]), e);
      }
      /**
       * @param bytes bytes encoding a string, whose encoding should be guessed
       * @param hints decode hints if applicable
       * @return name of guessed encoding; at the moment will only guess one of:
       *  {@link #SHIFT_JIS}, {@link #UTF8}, {@link #ISO88591}, or the platform
       *  default encoding if none of these can possibly be correct
       */
      static guessEncoding(bytes, hints) {
        if (hints !== null && hints !== void 0 && void 0 !== hints.get(DecodeHintType$1.CHARACTER_SET)) {
          return hints.get(DecodeHintType$1.CHARACTER_SET).toString();
        }
        const length = bytes.length;
        let canBeISO88591 = true;
        let canBeShiftJIS = true;
        let canBeUTF8 = true;
        let utf8BytesLeft = 0;
        let utf2BytesChars = 0;
        let utf3BytesChars = 0;
        let utf4BytesChars = 0;
        let sjisBytesLeft = 0;
        let sjisKatakanaChars = 0;
        let sjisCurKatakanaWordLength = 0;
        let sjisCurDoubleBytesWordLength = 0;
        let sjisMaxKatakanaWordLength = 0;
        let sjisMaxDoubleBytesWordLength = 0;
        let isoHighOther = 0;
        const utf8bom = bytes.length > 3 && bytes[0] === /*(byte) */
        239 && bytes[1] === /*(byte) */
        187 && bytes[2] === /*(byte) */
        191;
        for (let i2 = 0; i2 < length && (canBeISO88591 || canBeShiftJIS || canBeUTF8); i2++) {
          const value = bytes[i2] & 255;
          if (canBeUTF8) {
            if (utf8BytesLeft > 0) {
              if ((value & 128) === 0) {
                canBeUTF8 = false;
              } else {
                utf8BytesLeft--;
              }
            } else if ((value & 128) !== 0) {
              if ((value & 64) === 0) {
                canBeUTF8 = false;
              } else {
                utf8BytesLeft++;
                if ((value & 32) === 0) {
                  utf2BytesChars++;
                } else {
                  utf8BytesLeft++;
                  if ((value & 16) === 0) {
                    utf3BytesChars++;
                  } else {
                    utf8BytesLeft++;
                    if ((value & 8) === 0) {
                      utf4BytesChars++;
                    } else {
                      canBeUTF8 = false;
                    }
                  }
                }
              }
            }
          }
          if (canBeISO88591) {
            if (value > 127 && value < 160) {
              canBeISO88591 = false;
            } else if (value > 159) {
              if (value < 192 || value === 215 || value === 247) {
                isoHighOther++;
              }
            }
          }
          if (canBeShiftJIS) {
            if (sjisBytesLeft > 0) {
              if (value < 64 || value === 127 || value > 252) {
                canBeShiftJIS = false;
              } else {
                sjisBytesLeft--;
              }
            } else if (value === 128 || value === 160 || value > 239) {
              canBeShiftJIS = false;
            } else if (value > 160 && value < 224) {
              sjisKatakanaChars++;
              sjisCurDoubleBytesWordLength = 0;
              sjisCurKatakanaWordLength++;
              if (sjisCurKatakanaWordLength > sjisMaxKatakanaWordLength) {
                sjisMaxKatakanaWordLength = sjisCurKatakanaWordLength;
              }
            } else if (value > 127) {
              sjisBytesLeft++;
              sjisCurKatakanaWordLength = 0;
              sjisCurDoubleBytesWordLength++;
              if (sjisCurDoubleBytesWordLength > sjisMaxDoubleBytesWordLength) {
                sjisMaxDoubleBytesWordLength = sjisCurDoubleBytesWordLength;
              }
            } else {
              sjisCurKatakanaWordLength = 0;
              sjisCurDoubleBytesWordLength = 0;
            }
          }
        }
        if (canBeUTF8 && utf8BytesLeft > 0) {
          canBeUTF8 = false;
        }
        if (canBeShiftJIS && sjisBytesLeft > 0) {
          canBeShiftJIS = false;
        }
        if (canBeUTF8 && (utf8bom || utf2BytesChars + utf3BytesChars + utf4BytesChars > 0)) {
          return StringUtils.UTF8;
        }
        if (canBeShiftJIS && (StringUtils.ASSUME_SHIFT_JIS || sjisMaxKatakanaWordLength >= 3 || sjisMaxDoubleBytesWordLength >= 3)) {
          return StringUtils.SHIFT_JIS;
        }
        if (canBeISO88591 && canBeShiftJIS) {
          return sjisMaxKatakanaWordLength === 2 && sjisKatakanaChars === 2 || isoHighOther * 10 >= length ? StringUtils.SHIFT_JIS : StringUtils.ISO88591;
        }
        if (canBeISO88591) {
          return StringUtils.ISO88591;
        }
        if (canBeShiftJIS) {
          return StringUtils.SHIFT_JIS;
        }
        if (canBeUTF8) {
          return StringUtils.UTF8;
        }
        return StringUtils.PLATFORM_DEFAULT_ENCODING;
      }
      /**
       *
       * @see https://stackoverflow.com/a/13439711/4367683
       *
       * @param append The new string to append.
       * @param args Argumets values to be formated.
       */
      static format(append2, ...args) {
        let i2 = -1;
        function callback(exp, p0, p1, p2, p3, p4) {
          if (exp === "%%")
            return "%";
          if (args[++i2] === void 0)
            return void 0;
          exp = p2 ? parseInt(p2.substr(1)) : void 0;
          let base = p3 ? parseInt(p3.substr(1)) : void 0;
          let val;
          switch (p4) {
            case "s":
              val = args[i2];
              break;
            case "c":
              val = args[i2][0];
              break;
            case "f":
              val = parseFloat(args[i2]).toFixed(exp);
              break;
            case "p":
              val = parseFloat(args[i2]).toPrecision(exp);
              break;
            case "e":
              val = parseFloat(args[i2]).toExponential(exp);
              break;
            case "x":
              val = parseInt(args[i2]).toString(base ? base : 16);
              break;
            case "d":
              val = parseFloat(parseInt(args[i2], base ? base : 10).toPrecision(exp)).toFixed(0);
              break;
          }
          val = typeof val === "object" ? JSON.stringify(val) : (+val).toString(base);
          let size = parseInt(p1);
          let ch = p1 && p1[0] + "" === "0" ? "0" : " ";
          while (val.length < size)
            val = p0 !== void 0 ? val + ch : ch + val;
          return val;
        }
        let regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
        return append2.replace(regex, callback);
      }
      /**
       *
       */
      static getBytes(str, encoding) {
        return StringEncoding.encode(str, encoding);
      }
      /**
       * Returns the charcode at the specified index or at index zero.
       */
      static getCharCode(str, index2 = 0) {
        return str.charCodeAt(index2);
      }
      /**
       * Returns char for given charcode
       */
      static getCharAt(charCode) {
        return String.fromCharCode(charCode);
      }
    }
    StringUtils.SHIFT_JIS = CharacterSetECI.SJIS.getName();
    StringUtils.GB2312 = "GB2312";
    StringUtils.ISO88591 = CharacterSetECI.ISO8859_1.getName();
    StringUtils.EUC_JP = "EUC_JP";
    StringUtils.UTF8 = CharacterSetECI.UTF8.getName();
    StringUtils.PLATFORM_DEFAULT_ENCODING = StringUtils.UTF8;
    StringUtils.ASSUME_SHIFT_JIS = false;
    class StringBuilder {
      constructor(value = "") {
        this.value = value;
      }
      enableDecoding(encoding) {
        this.encoding = encoding;
        return this;
      }
      append(s2) {
        if (typeof s2 === "string") {
          this.value += s2.toString();
        } else if (this.encoding) {
          this.value += StringUtils.castAsNonUtf8Char(s2, this.encoding);
        } else {
          this.value += String.fromCharCode(s2);
        }
        return this;
      }
      appendChars(str, offset2, len) {
        for (let i2 = offset2; offset2 < offset2 + len; i2++) {
          this.append(str[i2]);
        }
        return this;
      }
      length() {
        return this.value.length;
      }
      charAt(n2) {
        return this.value.charAt(n2);
      }
      deleteCharAt(n2) {
        this.value = this.value.substr(0, n2) + this.value.substring(n2 + 1);
      }
      setCharAt(n2, c) {
        this.value = this.value.substr(0, n2) + c + this.value.substr(n2 + 1);
      }
      substring(start, end) {
        return this.value.substring(start, end);
      }
      /**
       * @note helper method for RSS Expanded
       */
      setLengthToZero() {
        this.value = "";
      }
      toString() {
        return this.value;
      }
      insert(n2, c) {
        this.value = this.value.substr(0, n2) + c + this.value.substr(n2 + c.length);
      }
    }
    class BitMatrix {
      /**
       * Creates an empty square {@link BitMatrix}.
       *
       * @param dimension height and width
       */
      // public constructor(dimension: number /*int*/) {
      //   this(dimension, dimension)
      // }
      /**
       * Creates an empty {@link BitMatrix}.
       *
       * @param width bit matrix width
       * @param height bit matrix height
       */
      // public constructor(width: number /*int*/, height: number /*int*/) {
      //   if (width < 1 || height < 1) {
      //     throw new IllegalArgumentException("Both dimensions must be greater than 0")
      //   }
      //   this.width = width
      //   this.height = height
      //   this.rowSize = (width + 31) / 32
      //   bits = new int[rowSize * height];
      // }
      constructor(width, height, rowSize, bits) {
        this.width = width;
        this.height = height;
        this.rowSize = rowSize;
        this.bits = bits;
        if (void 0 === height || null === height) {
          height = width;
        }
        this.height = height;
        if (width < 1 || height < 1) {
          throw new IllegalArgumentException("Both dimensions must be greater than 0");
        }
        if (void 0 === rowSize || null === rowSize) {
          rowSize = Math.floor((width + 31) / 32);
        }
        this.rowSize = rowSize;
        if (void 0 === bits || null === bits) {
          this.bits = new Int32Array(this.rowSize * this.height);
        }
      }
      /**
       * Interprets a 2D array of booleans as a {@link BitMatrix}, where "true" means an "on" bit.
       *
       * @function parse
       * @param image bits of the image, as a row-major 2D array. Elements are arrays representing rows
       * @return {@link BitMatrix} representation of image
       */
      static parseFromBooleanArray(image) {
        const height = image.length;
        const width = image[0].length;
        const bits = new BitMatrix(width, height);
        for (let i2 = 0; i2 < height; i2++) {
          const imageI = image[i2];
          for (let j = 0; j < width; j++) {
            if (imageI[j]) {
              bits.set(j, i2);
            }
          }
        }
        return bits;
      }
      /**
       *
       * @function parse
       * @param stringRepresentation
       * @param setString
       * @param unsetString
       */
      static parseFromString(stringRepresentation, setString, unsetString) {
        if (stringRepresentation === null) {
          throw new IllegalArgumentException("stringRepresentation cannot be null");
        }
        const bits = new Array(stringRepresentation.length);
        let bitsPos = 0;
        let rowStartPos = 0;
        let rowLength = -1;
        let nRows = 0;
        let pos = 0;
        while (pos < stringRepresentation.length) {
          if (stringRepresentation.charAt(pos) === "\n" || stringRepresentation.charAt(pos) === "\r") {
            if (bitsPos > rowStartPos) {
              if (rowLength === -1) {
                rowLength = bitsPos - rowStartPos;
              } else if (bitsPos - rowStartPos !== rowLength) {
                throw new IllegalArgumentException("row lengths do not match");
              }
              rowStartPos = bitsPos;
              nRows++;
            }
            pos++;
          } else if (stringRepresentation.substring(pos, pos + setString.length) === setString) {
            pos += setString.length;
            bits[bitsPos] = true;
            bitsPos++;
          } else if (stringRepresentation.substring(pos, pos + unsetString.length) === unsetString) {
            pos += unsetString.length;
            bits[bitsPos] = false;
            bitsPos++;
          } else {
            throw new IllegalArgumentException("illegal character encountered: " + stringRepresentation.substring(pos));
          }
        }
        if (bitsPos > rowStartPos) {
          if (rowLength === -1) {
            rowLength = bitsPos - rowStartPos;
          } else if (bitsPos - rowStartPos !== rowLength) {
            throw new IllegalArgumentException("row lengths do not match");
          }
          nRows++;
        }
        const matrix2 = new BitMatrix(rowLength, nRows);
        for (let i2 = 0; i2 < bitsPos; i2++) {
          if (bits[i2]) {
            matrix2.set(Math.floor(i2 % rowLength), Math.floor(i2 / rowLength));
          }
        }
        return matrix2;
      }
      /**
       * <p>Gets the requested bit, where true means black.</p>
       *
       * @param x The horizontal component (i.e. which column)
       * @param y The vertical component (i.e. which row)
       * @return value of given bit in matrix
       */
      get(x2, y) {
        const offset2 = y * this.rowSize + Math.floor(x2 / 32);
        return (this.bits[offset2] >>> (x2 & 31) & 1) !== 0;
      }
      /**
       * <p>Sets the given bit to true.</p>
       *
       * @param x The horizontal component (i.e. which column)
       * @param y The vertical component (i.e. which row)
       */
      set(x2, y) {
        const offset2 = y * this.rowSize + Math.floor(x2 / 32);
        this.bits[offset2] |= 1 << (x2 & 31) & 4294967295;
      }
      unset(x2, y) {
        const offset2 = y * this.rowSize + Math.floor(x2 / 32);
        this.bits[offset2] &= ~(1 << (x2 & 31) & 4294967295);
      }
      /**
       * <p>Flips the given bit.</p>
       *
       * @param x The horizontal component (i.e. which column)
       * @param y The vertical component (i.e. which row)
       */
      flip(x2, y) {
        const offset2 = y * this.rowSize + Math.floor(x2 / 32);
        this.bits[offset2] ^= 1 << (x2 & 31) & 4294967295;
      }
      /**
       * Exclusive-or (XOR): Flip the bit in this {@code BitMatrix} if the corresponding
       * mask bit is set.
       *
       * @param mask XOR mask
       */
      xor(mask) {
        if (this.width !== mask.getWidth() || this.height !== mask.getHeight() || this.rowSize !== mask.getRowSize()) {
          throw new IllegalArgumentException("input matrix dimensions do not match");
        }
        const rowArray = new BitArray(Math.floor(this.width / 32) + 1);
        const rowSize = this.rowSize;
        const bits = this.bits;
        for (let y = 0, height = this.height; y < height; y++) {
          const offset2 = y * rowSize;
          const row = mask.getRow(y, rowArray).getBitArray();
          for (let x2 = 0; x2 < rowSize; x2++) {
            bits[offset2 + x2] ^= row[x2];
          }
        }
      }
      /**
       * Clears all bits (sets to false).
       */
      clear() {
        const bits = this.bits;
        const max2 = bits.length;
        for (let i2 = 0; i2 < max2; i2++) {
          bits[i2] = 0;
        }
      }
      /**
       * <p>Sets a square region of the bit matrix to true.</p>
       *
       * @param left The horizontal position to begin at (inclusive)
       * @param top The vertical position to begin at (inclusive)
       * @param width The width of the region
       * @param height The height of the region
       */
      setRegion(left, top, width, height) {
        if (top < 0 || left < 0) {
          throw new IllegalArgumentException("Left and top must be nonnegative");
        }
        if (height < 1 || width < 1) {
          throw new IllegalArgumentException("Height and width must be at least 1");
        }
        const right = left + width;
        const bottom = top + height;
        if (bottom > this.height || right > this.width) {
          throw new IllegalArgumentException("The region must fit inside the matrix");
        }
        const rowSize = this.rowSize;
        const bits = this.bits;
        for (let y = top; y < bottom; y++) {
          const offset2 = y * rowSize;
          for (let x2 = left; x2 < right; x2++) {
            bits[offset2 + Math.floor(x2 / 32)] |= 1 << (x2 & 31) & 4294967295;
          }
        }
      }
      /**
       * A fast method to retrieve one row of data from the matrix as a BitArray.
       *
       * @param y The row to retrieve
       * @param row An optional caller-allocated BitArray, will be allocated if null or too small
       * @return The resulting BitArray - this reference should always be used even when passing
       *         your own row
       */
      getRow(y, row) {
        if (row === null || row === void 0 || row.getSize() < this.width) {
          row = new BitArray(this.width);
        } else {
          row.clear();
        }
        const rowSize = this.rowSize;
        const bits = this.bits;
        const offset2 = y * rowSize;
        for (let x2 = 0; x2 < rowSize; x2++) {
          row.setBulk(x2 * 32, bits[offset2 + x2]);
        }
        return row;
      }
      /**
       * @param y row to set
       * @param row {@link BitArray} to copy from
       */
      setRow(y, row) {
        System.arraycopy(row.getBitArray(), 0, this.bits, y * this.rowSize, this.rowSize);
      }
      /**
       * Modifies this {@code BitMatrix} to represent the same but rotated 180 degrees
       */
      rotate180() {
        const width = this.getWidth();
        const height = this.getHeight();
        let topRow = new BitArray(width);
        let bottomRow = new BitArray(width);
        for (let i2 = 0, length = Math.floor((height + 1) / 2); i2 < length; i2++) {
          topRow = this.getRow(i2, topRow);
          bottomRow = this.getRow(height - 1 - i2, bottomRow);
          topRow.reverse();
          bottomRow.reverse();
          this.setRow(i2, bottomRow);
          this.setRow(height - 1 - i2, topRow);
        }
      }
      /**
       * This is useful in detecting the enclosing rectangle of a 'pure' barcode.
       *
       * @return {@code left,top,width,height} enclosing rectangle of all 1 bits, or null if it is all white
       */
      getEnclosingRectangle() {
        const width = this.width;
        const height = this.height;
        const rowSize = this.rowSize;
        const bits = this.bits;
        let left = width;
        let top = height;
        let right = -1;
        let bottom = -1;
        for (let y = 0; y < height; y++) {
          for (let x32 = 0; x32 < rowSize; x32++) {
            const theBits = bits[y * rowSize + x32];
            if (theBits !== 0) {
              if (y < top) {
                top = y;
              }
              if (y > bottom) {
                bottom = y;
              }
              if (x32 * 32 < left) {
                let bit = 0;
                while ((theBits << 31 - bit & 4294967295) === 0) {
                  bit++;
                }
                if (x32 * 32 + bit < left) {
                  left = x32 * 32 + bit;
                }
              }
              if (x32 * 32 + 31 > right) {
                let bit = 31;
                while (theBits >>> bit === 0) {
                  bit--;
                }
                if (x32 * 32 + bit > right) {
                  right = x32 * 32 + bit;
                }
              }
            }
          }
        }
        if (right < left || bottom < top) {
          return null;
        }
        return Int32Array.from([left, top, right - left + 1, bottom - top + 1]);
      }
      /**
       * This is useful in detecting a corner of a 'pure' barcode.
       *
       * @return {@code x,y} coordinate of top-left-most 1 bit, or null if it is all white
       */
      getTopLeftOnBit() {
        const rowSize = this.rowSize;
        const bits = this.bits;
        let bitsOffset = 0;
        while (bitsOffset < bits.length && bits[bitsOffset] === 0) {
          bitsOffset++;
        }
        if (bitsOffset === bits.length) {
          return null;
        }
        const y = bitsOffset / rowSize;
        let x2 = bitsOffset % rowSize * 32;
        const theBits = bits[bitsOffset];
        let bit = 0;
        while ((theBits << 31 - bit & 4294967295) === 0) {
          bit++;
        }
        x2 += bit;
        return Int32Array.from([x2, y]);
      }
      getBottomRightOnBit() {
        const rowSize = this.rowSize;
        const bits = this.bits;
        let bitsOffset = bits.length - 1;
        while (bitsOffset >= 0 && bits[bitsOffset] === 0) {
          bitsOffset--;
        }
        if (bitsOffset < 0) {
          return null;
        }
        const y = Math.floor(bitsOffset / rowSize);
        let x2 = Math.floor(bitsOffset % rowSize) * 32;
        const theBits = bits[bitsOffset];
        let bit = 31;
        while (theBits >>> bit === 0) {
          bit--;
        }
        x2 += bit;
        return Int32Array.from([x2, y]);
      }
      /**
       * @return The width of the matrix
       */
      getWidth() {
        return this.width;
      }
      /**
       * @return The height of the matrix
       */
      getHeight() {
        return this.height;
      }
      /**
       * @return The row size of the matrix
       */
      getRowSize() {
        return this.rowSize;
      }
      /*@Override*/
      equals(o) {
        if (!(o instanceof BitMatrix)) {
          return false;
        }
        const other = o;
        return this.width === other.width && this.height === other.height && this.rowSize === other.rowSize && Arrays.equals(this.bits, other.bits);
      }
      /*@Override*/
      hashCode() {
        let hash = this.width;
        hash = 31 * hash + this.width;
        hash = 31 * hash + this.height;
        hash = 31 * hash + this.rowSize;
        hash = 31 * hash + Arrays.hashCode(this.bits);
        return hash;
      }
      /**
       * @return string representation using "X" for set and " " for unset bits
       */
      /*@Override*/
      // public toString(): string {
      //   return toString(": "X, "  ")
      // }
      /**
       * @param setString representation of a set bit
       * @param unsetString representation of an unset bit
       * @return string representation of entire matrix utilizing given strings
       */
      // public toString(setString: string = "X ", unsetString: string = "  "): string {
      //   return this.buildToString(setString, unsetString, "\n")
      // }
      /**
       * @param setString representation of a set bit
       * @param unsetString representation of an unset bit
       * @param lineSeparator newline character in string representation
       * @return string representation of entire matrix utilizing given strings and line separator
       * @deprecated call {@link #toString(String,String)} only, which uses \n line separator always
       */
      // @Deprecated
      toString(setString = "X ", unsetString = "  ", lineSeparator = "\n") {
        return this.buildToString(setString, unsetString, lineSeparator);
      }
      buildToString(setString, unsetString, lineSeparator) {
        let result2 = new StringBuilder();
        for (let y = 0, height = this.height; y < height; y++) {
          for (let x2 = 0, width = this.width; x2 < width; x2++) {
            result2.append(this.get(x2, y) ? setString : unsetString);
          }
          result2.append(lineSeparator);
        }
        return result2.toString();
      }
      /*@Override*/
      clone() {
        return new BitMatrix(this.width, this.height, this.rowSize, this.bits.slice());
      }
    }
    class NotFoundException extends Exception {
      static getNotFoundInstance() {
        return new NotFoundException();
      }
    }
    NotFoundException.kind = "NotFoundException";
    class GlobalHistogramBinarizer extends Binarizer {
      constructor(source) {
        super(source);
        this.luminances = GlobalHistogramBinarizer.EMPTY;
        this.buckets = new Int32Array(GlobalHistogramBinarizer.LUMINANCE_BUCKETS);
      }
      // Applies simple sharpening to the row data to improve performance of the 1D Readers.
      /*@Override*/
      getBlackRow(y, row) {
        const source = this.getLuminanceSource();
        const width = source.getWidth();
        if (row === void 0 || row === null || row.getSize() < width) {
          row = new BitArray(width);
        } else {
          row.clear();
        }
        this.initArrays(width);
        const localLuminances = source.getRow(y, this.luminances);
        const localBuckets = this.buckets;
        for (let x2 = 0; x2 < width; x2++) {
          localBuckets[(localLuminances[x2] & 255) >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
        }
        const blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
        if (width < 3) {
          for (let x2 = 0; x2 < width; x2++) {
            if ((localLuminances[x2] & 255) < blackPoint) {
              row.set(x2);
            }
          }
        } else {
          let left = localLuminances[0] & 255;
          let center = localLuminances[1] & 255;
          for (let x2 = 1; x2 < width - 1; x2++) {
            const right = localLuminances[x2 + 1] & 255;
            if ((center * 4 - left - right) / 2 < blackPoint) {
              row.set(x2);
            }
            left = center;
            center = right;
          }
        }
        return row;
      }
      // Does not sharpen the data, as this call is intended to only be used by 2D Readers.
      /*@Override*/
      getBlackMatrix() {
        const source = this.getLuminanceSource();
        const width = source.getWidth();
        const height = source.getHeight();
        const matrix2 = new BitMatrix(width, height);
        this.initArrays(width);
        const localBuckets = this.buckets;
        for (let y = 1; y < 5; y++) {
          const row = Math.floor(height * y / 5);
          const localLuminances2 = source.getRow(row, this.luminances);
          const right = Math.floor(width * 4 / 5);
          for (let x2 = Math.floor(width / 5); x2 < right; x2++) {
            const pixel = localLuminances2[x2] & 255;
            localBuckets[pixel >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
          }
        }
        const blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
        const localLuminances = source.getMatrix();
        for (let y = 0; y < height; y++) {
          const offset2 = y * width;
          for (let x2 = 0; x2 < width; x2++) {
            const pixel = localLuminances[offset2 + x2] & 255;
            if (pixel < blackPoint) {
              matrix2.set(x2, y);
            }
          }
        }
        return matrix2;
      }
      /*@Override*/
      createBinarizer(source) {
        return new GlobalHistogramBinarizer(source);
      }
      initArrays(luminanceSize) {
        if (this.luminances.length < luminanceSize) {
          this.luminances = new Uint8ClampedArray(luminanceSize);
        }
        const buckets = this.buckets;
        for (let x2 = 0; x2 < GlobalHistogramBinarizer.LUMINANCE_BUCKETS; x2++) {
          buckets[x2] = 0;
        }
      }
      static estimateBlackPoint(buckets) {
        const numBuckets = buckets.length;
        let maxBucketCount = 0;
        let firstPeak = 0;
        let firstPeakSize = 0;
        for (let x2 = 0; x2 < numBuckets; x2++) {
          if (buckets[x2] > firstPeakSize) {
            firstPeak = x2;
            firstPeakSize = buckets[x2];
          }
          if (buckets[x2] > maxBucketCount) {
            maxBucketCount = buckets[x2];
          }
        }
        let secondPeak = 0;
        let secondPeakScore = 0;
        for (let x2 = 0; x2 < numBuckets; x2++) {
          const distanceToBiggest = x2 - firstPeak;
          const score = buckets[x2] * distanceToBiggest * distanceToBiggest;
          if (score > secondPeakScore) {
            secondPeak = x2;
            secondPeakScore = score;
          }
        }
        if (firstPeak > secondPeak) {
          const temp = firstPeak;
          firstPeak = secondPeak;
          secondPeak = temp;
        }
        if (secondPeak - firstPeak <= numBuckets / 16) {
          throw new NotFoundException();
        }
        let bestValley = secondPeak - 1;
        let bestValleyScore = -1;
        for (let x2 = secondPeak - 1; x2 > firstPeak; x2--) {
          const fromFirst = x2 - firstPeak;
          const score = fromFirst * fromFirst * (secondPeak - x2) * (maxBucketCount - buckets[x2]);
          if (score > bestValleyScore) {
            bestValley = x2;
            bestValleyScore = score;
          }
        }
        return bestValley << GlobalHistogramBinarizer.LUMINANCE_SHIFT;
      }
    }
    GlobalHistogramBinarizer.LUMINANCE_BITS = 5;
    GlobalHistogramBinarizer.LUMINANCE_SHIFT = 8 - GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.LUMINANCE_BUCKETS = 1 << GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.EMPTY = Uint8ClampedArray.from([0]);
    class HybridBinarizer extends GlobalHistogramBinarizer {
      constructor(source) {
        super(source);
        this.matrix = null;
      }
      /**
       * Calculates the final BitMatrix once for all requests. This could be called once from the
       * constructor instead, but there are some advantages to doing it lazily, such as making
       * profiling easier, and not doing heavy lifting when callers don't expect it.
       */
      /*@Override*/
      getBlackMatrix() {
        if (this.matrix !== null) {
          return this.matrix;
        }
        const source = this.getLuminanceSource();
        const width = source.getWidth();
        const height = source.getHeight();
        if (width >= HybridBinarizer.MINIMUM_DIMENSION && height >= HybridBinarizer.MINIMUM_DIMENSION) {
          const luminances = source.getMatrix();
          let subWidth = width >> HybridBinarizer.BLOCK_SIZE_POWER;
          if ((width & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) {
            subWidth++;
          }
          let subHeight = height >> HybridBinarizer.BLOCK_SIZE_POWER;
          if ((height & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) {
            subHeight++;
          }
          const blackPoints = HybridBinarizer.calculateBlackPoints(luminances, subWidth, subHeight, width, height);
          const newMatrix = new BitMatrix(width, height);
          HybridBinarizer.calculateThresholdForBlock(luminances, subWidth, subHeight, width, height, blackPoints, newMatrix);
          this.matrix = newMatrix;
        } else {
          this.matrix = super.getBlackMatrix();
        }
        return this.matrix;
      }
      /*@Override*/
      createBinarizer(source) {
        return new HybridBinarizer(source);
      }
      /**
       * For each block in the image, calculate the average black point using a 5x5 grid
       * of the blocks around it. Also handles the corner cases (fractional blocks are computed based
       * on the last pixels in the row/column which are also used in the previous block).
       */
      static calculateThresholdForBlock(luminances, subWidth, subHeight, width, height, blackPoints, matrix2) {
        const maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
        const maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
        for (let y = 0; y < subHeight; y++) {
          let yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
          if (yoffset > maxYOffset) {
            yoffset = maxYOffset;
          }
          const top = HybridBinarizer.cap(y, 2, subHeight - 3);
          for (let x2 = 0; x2 < subWidth; x2++) {
            let xoffset = x2 << HybridBinarizer.BLOCK_SIZE_POWER;
            if (xoffset > maxXOffset) {
              xoffset = maxXOffset;
            }
            const left = HybridBinarizer.cap(x2, 2, subWidth - 3);
            let sum = 0;
            for (let z = -2; z <= 2; z++) {
              const blackRow = blackPoints[top + z];
              sum += blackRow[left - 2] + blackRow[left - 1] + blackRow[left] + blackRow[left + 1] + blackRow[left + 2];
            }
            const average = sum / 25;
            HybridBinarizer.thresholdBlock(luminances, xoffset, yoffset, average, width, matrix2);
          }
        }
      }
      static cap(value, min2, max2) {
        return value < min2 ? min2 : value > max2 ? max2 : value;
      }
      /**
       * Applies a single threshold to a block of pixels.
       */
      static thresholdBlock(luminances, xoffset, yoffset, threshold, stride, matrix2) {
        for (let y = 0, offset2 = yoffset * stride + xoffset; y < HybridBinarizer.BLOCK_SIZE; y++, offset2 += stride) {
          for (let x2 = 0; x2 < HybridBinarizer.BLOCK_SIZE; x2++) {
            if ((luminances[offset2 + x2] & 255) <= threshold) {
              matrix2.set(xoffset + x2, yoffset + y);
            }
          }
        }
      }
      /**
       * Calculates a single black point for each block of pixels and saves it away.
       * See the following thread for a discussion of this algorithm:
       *  http://groups.google.com/group/zxing/browse_thread/thread/d06efa2c35a7ddc0
       */
      static calculateBlackPoints(luminances, subWidth, subHeight, width, height) {
        const maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
        const maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
        const blackPoints = new Array(subHeight);
        for (let y = 0; y < subHeight; y++) {
          blackPoints[y] = new Int32Array(subWidth);
          let yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
          if (yoffset > maxYOffset) {
            yoffset = maxYOffset;
          }
          for (let x2 = 0; x2 < subWidth; x2++) {
            let xoffset = x2 << HybridBinarizer.BLOCK_SIZE_POWER;
            if (xoffset > maxXOffset) {
              xoffset = maxXOffset;
            }
            let sum = 0;
            let min2 = 255;
            let max2 = 0;
            for (let yy = 0, offset2 = yoffset * width + xoffset; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset2 += width) {
              for (let xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++) {
                const pixel = luminances[offset2 + xx] & 255;
                sum += pixel;
                if (pixel < min2) {
                  min2 = pixel;
                }
                if (pixel > max2) {
                  max2 = pixel;
                }
              }
              if (max2 - min2 > HybridBinarizer.MIN_DYNAMIC_RANGE) {
                for (yy++, offset2 += width; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset2 += width) {
                  for (let xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++) {
                    sum += luminances[offset2 + xx] & 255;
                  }
                }
              }
            }
            let average = sum >> HybridBinarizer.BLOCK_SIZE_POWER * 2;
            if (max2 - min2 <= HybridBinarizer.MIN_DYNAMIC_RANGE) {
              average = min2 / 2;
              if (y > 0 && x2 > 0) {
                const averageNeighborBlackPoint = (blackPoints[y - 1][x2] + 2 * blackPoints[y][x2 - 1] + blackPoints[y - 1][x2 - 1]) / 4;
                if (min2 < averageNeighborBlackPoint) {
                  average = averageNeighborBlackPoint;
                }
              }
            }
            blackPoints[y][x2] = average;
          }
        }
        return blackPoints;
      }
    }
    HybridBinarizer.BLOCK_SIZE_POWER = 3;
    HybridBinarizer.BLOCK_SIZE = 1 << HybridBinarizer.BLOCK_SIZE_POWER;
    HybridBinarizer.BLOCK_SIZE_MASK = HybridBinarizer.BLOCK_SIZE - 1;
    HybridBinarizer.MINIMUM_DIMENSION = HybridBinarizer.BLOCK_SIZE * 5;
    HybridBinarizer.MIN_DYNAMIC_RANGE = 24;
    class LuminanceSource {
      constructor(width, height) {
        this.width = width;
        this.height = height;
      }
      /**
       * @return The width of the bitmap.
       */
      getWidth() {
        return this.width;
      }
      /**
       * @return The height of the bitmap.
       */
      getHeight() {
        return this.height;
      }
      /**
       * @return Whether this subclass supports cropping.
       */
      isCropSupported() {
        return false;
      }
      /**
       * Returns a new object with cropped image data. Implementations may keep a reference to the
       * original data rather than a copy. Only callable if isCropSupported() is true.
       *
       * @param left The left coordinate, which must be in [0,getWidth())
       * @param top The top coordinate, which must be in [0,getHeight())
       * @param width The width of the rectangle to crop.
       * @param height The height of the rectangle to crop.
       * @return A cropped version of this object.
       */
      crop(left, top, width, height) {
        throw new UnsupportedOperationException("This luminance source does not support cropping.");
      }
      /**
       * @return Whether this subclass supports counter-clockwise rotation.
       */
      isRotateSupported() {
        return false;
      }
      /**
       * Returns a new object with rotated image data by 90 degrees counterclockwise.
       * Only callable if {@link #isRotateSupported()} is true.
       *
       * @return A rotated version of this object.
       */
      rotateCounterClockwise() {
        throw new UnsupportedOperationException("This luminance source does not support rotation by 90 degrees.");
      }
      /**
       * Returns a new object with rotated image data by 45 degrees counterclockwise.
       * Only callable if {@link #isRotateSupported()} is true.
       *
       * @return A rotated version of this object.
       */
      rotateCounterClockwise45() {
        throw new UnsupportedOperationException("This luminance source does not support rotation by 45 degrees.");
      }
      /*@Override*/
      toString() {
        const row = new Uint8ClampedArray(this.width);
        let result2 = new StringBuilder();
        for (let y = 0; y < this.height; y++) {
          const sourceRow = this.getRow(y, row);
          for (let x2 = 0; x2 < this.width; x2++) {
            const luminance = sourceRow[x2] & 255;
            let c;
            if (luminance < 64) {
              c = "#";
            } else if (luminance < 128) {
              c = "+";
            } else if (luminance < 192) {
              c = ".";
            } else {
              c = " ";
            }
            result2.append(c);
          }
          result2.append("\n");
        }
        return result2.toString();
      }
    }
    class InvertedLuminanceSource extends LuminanceSource {
      constructor(delegate) {
        super(delegate.getWidth(), delegate.getHeight());
        this.delegate = delegate;
      }
      /*@Override*/
      getRow(y, row) {
        const sourceRow = this.delegate.getRow(y, row);
        const width = this.getWidth();
        for (let i2 = 0; i2 < width; i2++) {
          sourceRow[i2] = /*(byte)*/
          255 - (sourceRow[i2] & 255);
        }
        return sourceRow;
      }
      /*@Override*/
      getMatrix() {
        const matrix2 = this.delegate.getMatrix();
        const length = this.getWidth() * this.getHeight();
        const invertedMatrix = new Uint8ClampedArray(length);
        for (let i2 = 0; i2 < length; i2++) {
          invertedMatrix[i2] = /*(byte)*/
          255 - (matrix2[i2] & 255);
        }
        return invertedMatrix;
      }
      /*@Override*/
      isCropSupported() {
        return this.delegate.isCropSupported();
      }
      /*@Override*/
      crop(left, top, width, height) {
        return new InvertedLuminanceSource(this.delegate.crop(left, top, width, height));
      }
      /*@Override*/
      isRotateSupported() {
        return this.delegate.isRotateSupported();
      }
      /**
       * @return original delegate {@link LuminanceSource} since invert undoes itself
       */
      /*@Override*/
      invert() {
        return this.delegate;
      }
      /*@Override*/
      rotateCounterClockwise() {
        return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise());
      }
      /*@Override*/
      rotateCounterClockwise45() {
        return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise45());
      }
    }
    class HTMLCanvasElementLuminanceSource extends LuminanceSource {
      constructor(canvas) {
        super(canvas.width, canvas.height);
        this.canvas = canvas;
        this.tempCanvasElement = null;
        this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(canvas);
      }
      static makeBufferFromCanvasImageData(canvas) {
        const imageData = canvas.getContext("2d").getImageData(0, 0, canvas.width, canvas.height);
        return HTMLCanvasElementLuminanceSource.toGrayscaleBuffer(imageData.data, canvas.width, canvas.height);
      }
      static toGrayscaleBuffer(imageBuffer, width, height) {
        const grayscaleBuffer = new Uint8ClampedArray(width * height);
        for (let i2 = 0, j = 0, length = imageBuffer.length; i2 < length; i2 += 4, j++) {
          let gray;
          const alpha = imageBuffer[i2 + 3];
          if (alpha === 0) {
            gray = 255;
          } else {
            const pixelR = imageBuffer[i2];
            const pixelG = imageBuffer[i2 + 1];
            const pixelB = imageBuffer[i2 + 2];
            gray = 306 * pixelR + 601 * pixelG + 117 * pixelB + 512 >> 10;
          }
          grayscaleBuffer[j] = gray;
        }
        return grayscaleBuffer;
      }
      getRow(y, row) {
        if (y < 0 || y >= this.getHeight()) {
          throw new IllegalArgumentException("Requested row is outside the image: " + y);
        }
        const width = this.getWidth();
        const start = y * width;
        if (row === null) {
          row = this.buffer.slice(start, start + width);
        } else {
          if (row.length < width) {
            row = new Uint8ClampedArray(width);
          }
          row.set(this.buffer.slice(start, start + width));
        }
        return row;
      }
      getMatrix() {
        return this.buffer;
      }
      isCropSupported() {
        return true;
      }
      crop(left, top, width, height) {
        super.crop(left, top, width, height);
        return this;
      }
      /**
       * This is always true, since the image is a gray-scale image.
       *
       * @return true
       */
      isRotateSupported() {
        return true;
      }
      rotateCounterClockwise() {
        this.rotate(-90);
        return this;
      }
      rotateCounterClockwise45() {
        this.rotate(-45);
        return this;
      }
      getTempCanvasElement() {
        if (null === this.tempCanvasElement) {
          const tempCanvasElement = this.canvas.ownerDocument.createElement("canvas");
          tempCanvasElement.width = this.canvas.width;
          tempCanvasElement.height = this.canvas.height;
          this.tempCanvasElement = tempCanvasElement;
        }
        return this.tempCanvasElement;
      }
      rotate(angle) {
        const tempCanvasElement = this.getTempCanvasElement();
        const tempContext = tempCanvasElement.getContext("2d");
        const angleRadians = angle * HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS;
        const width = this.canvas.width;
        const height = this.canvas.height;
        const newWidth = Math.ceil(Math.abs(Math.cos(angleRadians)) * width + Math.abs(Math.sin(angleRadians)) * height);
        const newHeight = Math.ceil(Math.abs(Math.sin(angleRadians)) * width + Math.abs(Math.cos(angleRadians)) * height);
        tempCanvasElement.width = newWidth;
        tempCanvasElement.height = newHeight;
        tempContext.translate(newWidth / 2, newHeight / 2);
        tempContext.rotate(angleRadians);
        tempContext.drawImage(this.canvas, width / -2, height / -2);
        this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(tempCanvasElement);
        return this;
      }
      invert() {
        return new InvertedLuminanceSource(this);
      }
    }
    HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS = Math.PI / 180;
    class VideoInputDevice {
      /**
       * Creates an instance of VideoInputDevice.
       *
       * @param {string} deviceId the video input device id
       * @param {string} label the label of the device if available
       */
      constructor(deviceId, label, groupId) {
        this.deviceId = deviceId;
        this.label = label;
        this.kind = "videoinput";
        this.groupId = groupId || void 0;
      }
      /** @inheritdoc */
      toJSON() {
        return {
          kind: this.kind,
          groupId: this.groupId,
          deviceId: this.deviceId,
          label: this.label
        };
      }
    }
    var __awaiter2 = (globalThis || commonjsGlobal || self || window || void 0) && (globalThis || commonjsGlobal || self || window || void 0).__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P || (P = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result2) {
          result2.done ? resolve2(result2.value) : adopt(result2.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    class BrowserCodeReader {
      /**
       * Creates an instance of BrowserCodeReader.
       * @param {Reader} reader The reader instance to decode the barcode
       * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent successful decode tries
       *
       * @memberOf BrowserCodeReader
       */
      constructor(reader, timeBetweenScansMillis = 500, _hints) {
        this.reader = reader;
        this.timeBetweenScansMillis = timeBetweenScansMillis;
        this._hints = _hints;
        this._stopContinuousDecode = false;
        this._stopAsyncDecode = false;
        this._timeBetweenDecodingAttempts = 0;
      }
      /**
       * If navigator is present.
       */
      get hasNavigator() {
        return typeof navigator !== "undefined";
      }
      /**
       * If mediaDevices under navigator is supported.
       */
      get isMediaDevicesSuported() {
        return this.hasNavigator && !!navigator.mediaDevices;
      }
      /**
       * If enumerateDevices under navigator is supported.
       */
      get canEnumerateDevices() {
        return !!(this.isMediaDevicesSuported && navigator.mediaDevices.enumerateDevices);
      }
      /** Time between two decoding tries in milli seconds. */
      get timeBetweenDecodingAttempts() {
        return this._timeBetweenDecodingAttempts;
      }
      /**
       * Change the time span the decoder waits between two decoding tries.
       *
       * @param {number} millis Time between two decoding tries in milli seconds.
       */
      set timeBetweenDecodingAttempts(millis) {
        this._timeBetweenDecodingAttempts = millis < 0 ? 0 : millis;
      }
      /**
       * Sets the hints.
       */
      set hints(hints) {
        this._hints = hints || null;
      }
      /**
       * Sets the hints.
       */
      get hints() {
        return this._hints;
      }
      /**
       * Lists all the available video input devices.
       */
      listVideoInputDevices() {
        return __awaiter2(this, void 0, void 0, function* () {
          if (!this.hasNavigator) {
            throw new Error("Can't enumerate devices, navigator is not present.");
          }
          if (!this.canEnumerateDevices) {
            throw new Error("Can't enumerate devices, method not supported.");
          }
          const devices = yield navigator.mediaDevices.enumerateDevices();
          const videoDevices = [];
          for (const device of devices) {
            const kind = device.kind === "video" ? "videoinput" : device.kind;
            if (kind !== "videoinput") {
              continue;
            }
            const deviceId = device.deviceId || device.id;
            const label = device.label || `Video device ${videoDevices.length + 1}`;
            const groupId = device.groupId;
            const videoDevice = { deviceId, label, kind, groupId };
            videoDevices.push(videoDevice);
          }
          return videoDevices;
        });
      }
      /**
       * Obtain the list of available devices with type 'videoinput'.
       *
       * @returns {Promise<VideoInputDevice[]>} an array of available video input devices
       *
       * @memberOf BrowserCodeReader
       *
       * @deprecated Use `listVideoInputDevices` instead.
       */
      getVideoInputDevices() {
        return __awaiter2(this, void 0, void 0, function* () {
          const devices = yield this.listVideoInputDevices();
          return devices.map((d2) => new VideoInputDevice(d2.deviceId, d2.label));
        });
      }
      /**
       * Let's you find a device using it's Id.
       */
      findDeviceById(deviceId) {
        return __awaiter2(this, void 0, void 0, function* () {
          const devices = yield this.listVideoInputDevices();
          if (!devices) {
            return null;
          }
          return devices.find((x2) => x2.deviceId === deviceId);
        });
      }
      /**
       * Decodes the barcode from the device specified by deviceId while showing the video in the specified video element.
       *
       * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
       * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
       * @returns The decoding result.
       *
       * @memberOf BrowserCodeReader
       *
       * @deprecated Use `decodeOnceFromVideoDevice` instead.
       */
      decodeFromInputVideoDevice(deviceId, videoSource) {
        return __awaiter2(this, void 0, void 0, function* () {
          return yield this.decodeOnceFromVideoDevice(deviceId, videoSource);
        });
      }
      /**
       * In one attempt, tries to decode the barcode from the device specified by deviceId while showing the video in the specified video element.
       *
       * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
       * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
       * @returns The decoding result.
       *
       * @memberOf BrowserCodeReader
       */
      decodeOnceFromVideoDevice(deviceId, videoSource) {
        return __awaiter2(this, void 0, void 0, function* () {
          this.reset();
          let videoConstraints;
          if (!deviceId) {
            videoConstraints = { facingMode: "environment" };
          } else {
            videoConstraints = { deviceId: { exact: deviceId } };
          }
          const constraints = { video: videoConstraints };
          return yield this.decodeOnceFromConstraints(constraints, videoSource);
        });
      }
      /**
       * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
       *
       * @param constraints the media stream constraints to get s valid media stream to decode from
       * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
       * @returns The decoding result.
       *
       * @memberOf BrowserCodeReader
       */
      decodeOnceFromConstraints(constraints, videoSource) {
        return __awaiter2(this, void 0, void 0, function* () {
          const stream = yield navigator.mediaDevices.getUserMedia(constraints);
          return yield this.decodeOnceFromStream(stream, videoSource);
        });
      }
      /**
       * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
       *
       * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
       * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
       * @returns {Promise<Result>} The decoding result.
       *
       * @memberOf BrowserCodeReader
       */
      decodeOnceFromStream(stream, videoSource) {
        return __awaiter2(this, void 0, void 0, function* () {
          this.reset();
          const video = yield this.attachStreamToVideo(stream, videoSource);
          const result2 = yield this.decodeOnce(video);
          return result2;
        });
      }
      /**
       * Continuously decodes the barcode from the device specified by device while showing the video in the specified video element.
       *
       * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
       * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
       * @returns {Promise<void>}
       *
       * @memberOf BrowserCodeReader
       *
       * @deprecated Use `decodeFromVideoDevice` instead.
       */
      decodeFromInputVideoDeviceContinuously(deviceId, videoSource, callbackFn) {
        return __awaiter2(this, void 0, void 0, function* () {
          return yield this.decodeFromVideoDevice(deviceId, videoSource, callbackFn);
        });
      }
      /**
       * Continuously tries to decode the barcode from the device specified by device while showing the video in the specified video element.
       *
       * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
       * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
       * @returns {Promise<void>}
       *
       * @memberOf BrowserCodeReader
       */
      decodeFromVideoDevice(deviceId, videoSource, callbackFn) {
        return __awaiter2(this, void 0, void 0, function* () {
          let videoConstraints;
          if (!deviceId) {
            videoConstraints = { facingMode: "environment" };
          } else {
            videoConstraints = { deviceId: { exact: deviceId } };
          }
          const constraints = { video: videoConstraints };
          return yield this.decodeFromConstraints(constraints, videoSource, callbackFn);
        });
      }
      /**
       * Continuously tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
       *
       * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
       * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
       * @returns {Promise<Result>} The decoding result.
       *
       * @memberOf BrowserCodeReader
       */
      decodeFromConstraints(constraints, videoSource, callbackFn) {
        return __awaiter2(this, void 0, void 0, function* () {
          const stream = yield navigator.mediaDevices.getUserMedia(constraints);
          return yield this.decodeFromStream(stream, videoSource, callbackFn);
        });
      }
      /**
       * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
       *
       * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
       * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
       * @returns {Promise<Result>} The decoding result.
       *
       * @memberOf BrowserCodeReader
       */
      decodeFromStream(stream, videoSource, callbackFn) {
        return __awaiter2(this, void 0, void 0, function* () {
          this.reset();
          const video = yield this.attachStreamToVideo(stream, videoSource);
          return yield this.decodeContinuously(video, callbackFn);
        });
      }
      /**
       * Breaks the decoding loop.
       */
      stopAsyncDecode() {
        this._stopAsyncDecode = true;
      }
      /**
       * Breaks the decoding loop.
       */
      stopContinuousDecode() {
        this._stopContinuousDecode = true;
      }
      /**
       * Sets the new stream and request a new decoding-with-delay.
       *
       * @param stream The stream to be shown in the video element.
       * @param decodeFn A callback for the decode method.
       */
      attachStreamToVideo(stream, videoSource) {
        return __awaiter2(this, void 0, void 0, function* () {
          const videoElement = this.prepareVideoElement(videoSource);
          this.addVideoSource(videoElement, stream);
          this.videoElement = videoElement;
          this.stream = stream;
          yield this.playVideoOnLoadAsync(videoElement);
          return videoElement;
        });
      }
      /**
       *
       * @param videoElement
       */
      playVideoOnLoadAsync(videoElement) {
        return new Promise((resolve2, reject) => this.playVideoOnLoad(videoElement, () => resolve2()));
      }
      /**
       * Binds listeners and callbacks to the videoElement.
       *
       * @param element
       * @param callbackFn
       */
      playVideoOnLoad(element, callbackFn) {
        this.videoEndedListener = () => this.stopStreams();
        this.videoCanPlayListener = () => this.tryPlayVideo(element);
        element.addEventListener("ended", this.videoEndedListener);
        element.addEventListener("canplay", this.videoCanPlayListener);
        element.addEventListener("playing", callbackFn);
        this.tryPlayVideo(element);
      }
      /**
       * Checks if the given video element is currently playing.
       */
      isVideoPlaying(video) {
        return video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
      }
      /**
       * Just tries to play the video and logs any errors.
       * The play call is only made is the video is not already playing.
       */
      tryPlayVideo(videoElement) {
        return __awaiter2(this, void 0, void 0, function* () {
          if (this.isVideoPlaying(videoElement)) {
            console.warn("Trying to play video that is already playing.");
            return;
          }
          try {
            yield videoElement.play();
          } catch (_a2) {
            console.warn("It was not possible to play the video.");
          }
        });
      }
      /**
       * Searches and validates a media element.
       */
      getMediaElement(mediaElementId, type) {
        const mediaElement = document.getElementById(mediaElementId);
        if (!mediaElement) {
          throw new ArgumentException(`element with id '${mediaElementId}' not found`);
        }
        if (mediaElement.nodeName.toLowerCase() !== type.toLowerCase()) {
          throw new ArgumentException(`element with id '${mediaElementId}' must be an ${type} element`);
        }
        return mediaElement;
      }
      /**
       * Decodes the barcode from an image.
       *
       * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
       * @param {string} [url]
       * @returns {Promise<Result>} The decoding result.
       *
       * @memberOf BrowserCodeReader
       */
      decodeFromImage(source, url) {
        if (!source && !url) {
          throw new ArgumentException("either imageElement with a src set or an url must be provided");
        }
        if (url && !source) {
          return this.decodeFromImageUrl(url);
        }
        return this.decodeFromImageElement(source);
      }
      /**
       * Decodes the barcode from a video.
       *
       * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
       * @param {string} [url]
       * @returns {Promise<Result>} The decoding result.
       *
       * @memberOf BrowserCodeReader
       */
      decodeFromVideo(source, url) {
        if (!source && !url) {
          throw new ArgumentException("Either an element with a src set or an URL must be provided");
        }
        if (url && !source) {
          return this.decodeFromVideoUrl(url);
        }
        return this.decodeFromVideoElement(source);
      }
      /**
       * Decodes continuously the barcode from a video.
       *
       * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
       * @param {string} [url]
       * @returns {Promise<Result>} The decoding result.
       *
       * @memberOf BrowserCodeReader
       *
       * @experimental
       */
      decodeFromVideoContinuously(source, url, callbackFn) {
        if (void 0 === source && void 0 === url) {
          throw new ArgumentException("Either an element with a src set or an URL must be provided");
        }
        if (url && !source) {
          return this.decodeFromVideoUrlContinuously(url, callbackFn);
        }
        return this.decodeFromVideoElementContinuously(source, callbackFn);
      }
      /**
       * Decodes something from an image HTML element.
       */
      decodeFromImageElement(source) {
        if (!source) {
          throw new ArgumentException("An image element must be provided.");
        }
        this.reset();
        const element = this.prepareImageElement(source);
        this.imageElement = element;
        let task;
        if (this.isImageLoaded(element)) {
          task = this.decodeOnce(element, false, true);
        } else {
          task = this._decodeOnLoadImage(element);
        }
        return task;
      }
      /**
       * Decodes something from an image HTML element.
       */
      decodeFromVideoElement(source) {
        const element = this._decodeFromVideoElementSetup(source);
        return this._decodeOnLoadVideo(element);
      }
      /**
       * Decodes something from an image HTML element.
       */
      decodeFromVideoElementContinuously(source, callbackFn) {
        const element = this._decodeFromVideoElementSetup(source);
        return this._decodeOnLoadVideoContinuously(element, callbackFn);
      }
      /**
       * Sets up the video source so it can be decoded when loaded.
       *
       * @param source The video source element.
       */
      _decodeFromVideoElementSetup(source) {
        if (!source) {
          throw new ArgumentException("A video element must be provided.");
        }
        this.reset();
        const element = this.prepareVideoElement(source);
        this.videoElement = element;
        return element;
      }
      /**
       * Decodes an image from a URL.
       */
      decodeFromImageUrl(url) {
        if (!url) {
          throw new ArgumentException("An URL must be provided.");
        }
        this.reset();
        const element = this.prepareImageElement();
        this.imageElement = element;
        const decodeTask = this._decodeOnLoadImage(element);
        element.src = url;
        return decodeTask;
      }
      /**
       * Decodes an image from a URL.
       */
      decodeFromVideoUrl(url) {
        if (!url) {
          throw new ArgumentException("An URL must be provided.");
        }
        this.reset();
        const element = this.prepareVideoElement();
        const decodeTask = this.decodeFromVideoElement(element);
        element.src = url;
        return decodeTask;
      }
      /**
       * Decodes an image from a URL.
       *
       * @experimental
       */
      decodeFromVideoUrlContinuously(url, callbackFn) {
        if (!url) {
          throw new ArgumentException("An URL must be provided.");
        }
        this.reset();
        const element = this.prepareVideoElement();
        const decodeTask = this.decodeFromVideoElementContinuously(element, callbackFn);
        element.src = url;
        return decodeTask;
      }
      _decodeOnLoadImage(element) {
        return new Promise((resolve2, reject) => {
          this.imageLoadedListener = () => this.decodeOnce(element, false, true).then(resolve2, reject);
          element.addEventListener("load", this.imageLoadedListener);
        });
      }
      _decodeOnLoadVideo(videoElement) {
        return __awaiter2(this, void 0, void 0, function* () {
          yield this.playVideoOnLoadAsync(videoElement);
          return yield this.decodeOnce(videoElement);
        });
      }
      _decodeOnLoadVideoContinuously(videoElement, callbackFn) {
        return __awaiter2(this, void 0, void 0, function* () {
          yield this.playVideoOnLoadAsync(videoElement);
          this.decodeContinuously(videoElement, callbackFn);
        });
      }
      isImageLoaded(img) {
        if (!img.complete) {
          return false;
        }
        if (img.naturalWidth === 0) {
          return false;
        }
        return true;
      }
      prepareImageElement(imageSource) {
        let imageElement;
        if (typeof imageSource === "undefined") {
          imageElement = document.createElement("img");
          imageElement.width = 200;
          imageElement.height = 200;
        }
        if (typeof imageSource === "string") {
          imageElement = this.getMediaElement(imageSource, "img");
        }
        if (imageSource instanceof HTMLImageElement) {
          imageElement = imageSource;
        }
        return imageElement;
      }
      /**
       * Sets a HTMLVideoElement for scanning or creates a new one.
       *
       * @param videoSource The HTMLVideoElement to be set.
       */
      prepareVideoElement(videoSource) {
        let videoElement;
        if (!videoSource && typeof document !== "undefined") {
          videoElement = document.createElement("video");
          videoElement.width = 200;
          videoElement.height = 200;
        }
        if (typeof videoSource === "string") {
          videoElement = this.getMediaElement(videoSource, "video");
        }
        if (videoSource instanceof HTMLVideoElement) {
          videoElement = videoSource;
        }
        videoElement.setAttribute("autoplay", "true");
        videoElement.setAttribute("muted", "true");
        videoElement.setAttribute("playsinline", "true");
        return videoElement;
      }
      /**
       * Tries to decode from the video input until it finds some value.
       */
      decodeOnce(element, retryIfNotFound = true, retryIfChecksumOrFormatError = true) {
        this._stopAsyncDecode = false;
        const loop = (resolve2, reject) => {
          if (this._stopAsyncDecode) {
            reject(new NotFoundException("Video stream has ended before any code could be detected."));
            this._stopAsyncDecode = void 0;
            return;
          }
          try {
            const result2 = this.decode(element);
            resolve2(result2);
          } catch (e) {
            const ifNotFound = retryIfNotFound && e instanceof NotFoundException;
            const isChecksumOrFormatError = e instanceof ChecksumException || e instanceof FormatException;
            const ifChecksumOrFormat = isChecksumOrFormatError && retryIfChecksumOrFormatError;
            if (ifNotFound || ifChecksumOrFormat) {
              return setTimeout(loop, this._timeBetweenDecodingAttempts, resolve2, reject);
            }
            reject(e);
          }
        };
        return new Promise((resolve2, reject) => loop(resolve2, reject));
      }
      /**
       * Continuously decodes from video input.
       */
      decodeContinuously(element, callbackFn) {
        this._stopContinuousDecode = false;
        const loop = () => {
          if (this._stopContinuousDecode) {
            this._stopContinuousDecode = void 0;
            return;
          }
          try {
            const result2 = this.decode(element);
            callbackFn(result2, null);
            setTimeout(loop, this.timeBetweenScansMillis);
          } catch (e) {
            callbackFn(null, e);
            const isChecksumOrFormatError = e instanceof ChecksumException || e instanceof FormatException;
            const isNotFound = e instanceof NotFoundException;
            if (isChecksumOrFormatError || isNotFound) {
              setTimeout(loop, this._timeBetweenDecodingAttempts);
            }
          }
        };
        loop();
      }
      /**
       * Gets the BinaryBitmap for ya! (and decodes it)
       */
      decode(element) {
        const binaryBitmap = this.createBinaryBitmap(element);
        return this.decodeBitmap(binaryBitmap);
      }
      /**
       * Returns true if media element is indeed a {@link HtmlVideoElement}.
       */
      _isHTMLVideoElement(mediaElement) {
        const potentialVideo = mediaElement;
        return potentialVideo.videoWidth !== 0;
      }
      /**
       * Overwriting this allows you to manipulate the next frame in anyway
       * you want before decode.
       */
      drawFrameOnCanvas(srcElement, dimensions, canvasElementContext) {
        if (!dimensions) {
          dimensions = {
            sx: 0,
            sy: 0,
            sWidth: srcElement.videoWidth,
            sHeight: srcElement.videoHeight,
            dx: 0,
            dy: 0,
            dWidth: srcElement.videoWidth,
            dHeight: srcElement.videoHeight
          };
        }
        if (!canvasElementContext) {
          canvasElementContext = this.captureCanvasContext;
        }
        canvasElementContext.drawImage(
          srcElement,
          dimensions.sx,
          dimensions.sy,
          dimensions.sWidth,
          dimensions.sHeight,
          dimensions.dx,
          dimensions.dy,
          dimensions.dWidth,
          dimensions.dHeight
        );
      }
      /**
       * Ovewriting this allows you to manipulate the snapshot image in anyway
       *  you want before decode.
       */
      drawImageOnCanvas(srcElement, dimensions, canvasElementContext = this.captureCanvasContext) {
        if (!dimensions) {
          dimensions = {
            sx: 0,
            sy: 0,
            sWidth: srcElement.naturalWidth,
            sHeight: srcElement.naturalHeight,
            dx: 0,
            dy: 0,
            dWidth: srcElement.naturalWidth,
            dHeight: srcElement.naturalHeight
          };
        }
        if (!canvasElementContext) {
          canvasElementContext = this.captureCanvasContext;
        }
        canvasElementContext.drawImage(
          srcElement,
          dimensions.sx,
          dimensions.sy,
          dimensions.sWidth,
          dimensions.sHeight,
          dimensions.dx,
          dimensions.dy,
          dimensions.dWidth,
          dimensions.dHeight
        );
      }
      /**
       * Creates a binaryBitmap based in some image source.
       *
       * @param mediaElement HTML element containing drawable image source.
       */
      createBinaryBitmap(mediaElement) {
        this.getCaptureCanvasContext(mediaElement);
        if (this._isHTMLVideoElement(mediaElement)) {
          this.drawFrameOnCanvas(mediaElement);
        } else {
          this.drawImageOnCanvas(mediaElement);
        }
        const canvas = this.getCaptureCanvas(mediaElement);
        const luminanceSource = new HTMLCanvasElementLuminanceSource(canvas);
        const hybridBinarizer = new HybridBinarizer(luminanceSource);
        return new BinaryBitmap(hybridBinarizer);
      }
      getCaptureCanvasContext(mediaElement) {
        if (!this.captureCanvasContext) {
          const elem = this.getCaptureCanvas(mediaElement);
          const ctx = elem.getContext("2d");
          this.captureCanvasContext = ctx;
        }
        return this.captureCanvasContext;
      }
      getCaptureCanvas(mediaElement) {
        if (!this.captureCanvas) {
          const elem = this.createCaptureCanvas(mediaElement);
          this.captureCanvas = elem;
        }
        return this.captureCanvas;
      }
      /**
       * Call the encapsulated readers decode
       */
      decodeBitmap(binaryBitmap) {
        return this.reader.decode(binaryBitmap, this._hints);
      }
      /**
       * 🖌 Prepares the canvas for capture and scan frames.
       */
      createCaptureCanvas(mediaElement) {
        if (typeof document === "undefined") {
          this._destroyCaptureCanvas();
          return null;
        }
        const canvasElement = document.createElement("canvas");
        let width;
        let height;
        if (typeof mediaElement !== "undefined") {
          if (mediaElement instanceof HTMLVideoElement) {
            width = mediaElement.videoWidth;
            height = mediaElement.videoHeight;
          } else if (mediaElement instanceof HTMLImageElement) {
            width = mediaElement.naturalWidth || mediaElement.width;
            height = mediaElement.naturalHeight || mediaElement.height;
          }
        }
        canvasElement.style.width = width + "px";
        canvasElement.style.height = height + "px";
        canvasElement.width = width;
        canvasElement.height = height;
        return canvasElement;
      }
      /**
       * Stops the continuous scan and cleans the stream.
       */
      stopStreams() {
        if (this.stream) {
          this.stream.getVideoTracks().forEach((t3) => t3.stop());
          this.stream = void 0;
        }
        if (this._stopAsyncDecode === false) {
          this.stopAsyncDecode();
        }
        if (this._stopContinuousDecode === false) {
          this.stopContinuousDecode();
        }
      }
      /**
       * Resets the code reader to the initial state. Cancels any ongoing barcode scanning from video or camera.
       *
       * @memberOf BrowserCodeReader
       */
      reset() {
        this.stopStreams();
        this._destroyVideoElement();
        this._destroyImageElement();
        this._destroyCaptureCanvas();
      }
      _destroyVideoElement() {
        if (!this.videoElement) {
          return;
        }
        if (typeof this.videoEndedListener !== "undefined") {
          this.videoElement.removeEventListener("ended", this.videoEndedListener);
        }
        if (typeof this.videoPlayingEventListener !== "undefined") {
          this.videoElement.removeEventListener("playing", this.videoPlayingEventListener);
        }
        if (typeof this.videoCanPlayListener !== "undefined") {
          this.videoElement.removeEventListener("loadedmetadata", this.videoCanPlayListener);
        }
        this.cleanVideoSource(this.videoElement);
        this.videoElement = void 0;
      }
      _destroyImageElement() {
        if (!this.imageElement) {
          return;
        }
        if (void 0 !== this.imageLoadedListener) {
          this.imageElement.removeEventListener("load", this.imageLoadedListener);
        }
        this.imageElement.src = void 0;
        this.imageElement.removeAttribute("src");
        this.imageElement = void 0;
      }
      /**
       * Cleans canvas references 🖌
       */
      _destroyCaptureCanvas() {
        this.captureCanvasContext = void 0;
        this.captureCanvas = void 0;
      }
      /**
       * Defines what the videoElement src will be.
       *
       * @param videoElement
       * @param stream
       */
      addVideoSource(videoElement, stream) {
        try {
          videoElement.srcObject = stream;
        } catch (err2) {
          videoElement.src = URL.createObjectURL(stream);
        }
      }
      /**
       * Unbinds a HTML video src property.
       *
       * @param videoElement
       */
      cleanVideoSource(videoElement) {
        try {
          videoElement.srcObject = null;
        } catch (err2) {
          videoElement.src = "";
        }
        this.videoElement.removeAttribute("src");
      }
    }
    class Result3 {
      // public constructor(private text: string,
      //               Uint8Array rawBytes,
      //               ResultPoconst resultPoints: Int32Array,
      //               BarcodeFormat format) {
      //   this(text, rawBytes, resultPoints, format, System.currentTimeMillis())
      // }
      // public constructor(text: string,
      //               Uint8Array rawBytes,
      //               ResultPoconst resultPoints: Int32Array,
      //               BarcodeFormat format,
      //               long timestamp) {
      //   this(text, rawBytes, rawBytes == null ? 0 : 8 * rawBytes.length,
      //        resultPoints, format, timestamp)
      // }
      constructor(text2, rawBytes, numBits = rawBytes == null ? 0 : 8 * rawBytes.length, resultPoints, format, timestamp = System.currentTimeMillis()) {
        this.text = text2;
        this.rawBytes = rawBytes;
        this.numBits = numBits;
        this.resultPoints = resultPoints;
        this.format = format;
        this.timestamp = timestamp;
        this.text = text2;
        this.rawBytes = rawBytes;
        if (void 0 === numBits || null === numBits) {
          this.numBits = rawBytes === null || rawBytes === void 0 ? 0 : 8 * rawBytes.length;
        } else {
          this.numBits = numBits;
        }
        this.resultPoints = resultPoints;
        this.format = format;
        this.resultMetadata = null;
        if (void 0 === timestamp || null === timestamp) {
          this.timestamp = System.currentTimeMillis();
        } else {
          this.timestamp = timestamp;
        }
      }
      /**
       * @return raw text encoded by the barcode
       */
      getText() {
        return this.text;
      }
      /**
       * @return raw bytes encoded by the barcode, if applicable, otherwise {@code null}
       */
      getRawBytes() {
        return this.rawBytes;
      }
      /**
       * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
       * @since 3.3.0
       */
      getNumBits() {
        return this.numBits;
      }
      /**
       * @return points related to the barcode in the image. These are typically points
       *         identifying finder patterns or the corners of the barcode. The exact meaning is
       *         specific to the type of barcode that was decoded.
       */
      getResultPoints() {
        return this.resultPoints;
      }
      /**
       * @return {@link BarcodeFormat} representing the format of the barcode that was decoded
       */
      getBarcodeFormat() {
        return this.format;
      }
      /**
       * @return {@link Map} mapping {@link ResultMetadataType} keys to values. May be
       *   {@code null}. This contains optional metadata about what was detected about the barcode,
       *   like orientation.
       */
      getResultMetadata() {
        return this.resultMetadata;
      }
      putMetadata(type, value) {
        if (this.resultMetadata === null) {
          this.resultMetadata = /* @__PURE__ */ new Map();
        }
        this.resultMetadata.set(type, value);
      }
      putAllMetadata(metadata) {
        if (metadata !== null) {
          if (this.resultMetadata === null) {
            this.resultMetadata = metadata;
          } else {
            this.resultMetadata = new Map(metadata);
          }
        }
      }
      addResultPoints(newPoints) {
        const oldPoints = this.resultPoints;
        if (oldPoints === null) {
          this.resultPoints = newPoints;
        } else if (newPoints !== null && newPoints.length > 0) {
          const allPoints = new Array(oldPoints.length + newPoints.length);
          System.arraycopy(oldPoints, 0, allPoints, 0, oldPoints.length);
          System.arraycopy(newPoints, 0, allPoints, oldPoints.length, newPoints.length);
          this.resultPoints = allPoints;
        }
      }
      getTimestamp() {
        return this.timestamp;
      }
      /*@Override*/
      toString() {
        return this.text;
      }
    }
    var BarcodeFormat;
    (function(BarcodeFormat2) {
      BarcodeFormat2[BarcodeFormat2["AZTEC"] = 0] = "AZTEC";
      BarcodeFormat2[BarcodeFormat2["CODABAR"] = 1] = "CODABAR";
      BarcodeFormat2[BarcodeFormat2["CODE_39"] = 2] = "CODE_39";
      BarcodeFormat2[BarcodeFormat2["CODE_93"] = 3] = "CODE_93";
      BarcodeFormat2[BarcodeFormat2["CODE_128"] = 4] = "CODE_128";
      BarcodeFormat2[BarcodeFormat2["DATA_MATRIX"] = 5] = "DATA_MATRIX";
      BarcodeFormat2[BarcodeFormat2["EAN_8"] = 6] = "EAN_8";
      BarcodeFormat2[BarcodeFormat2["EAN_13"] = 7] = "EAN_13";
      BarcodeFormat2[BarcodeFormat2["ITF"] = 8] = "ITF";
      BarcodeFormat2[BarcodeFormat2["MAXICODE"] = 9] = "MAXICODE";
      BarcodeFormat2[BarcodeFormat2["PDF_417"] = 10] = "PDF_417";
      BarcodeFormat2[BarcodeFormat2["QR_CODE"] = 11] = "QR_CODE";
      BarcodeFormat2[BarcodeFormat2["RSS_14"] = 12] = "RSS_14";
      BarcodeFormat2[BarcodeFormat2["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
      BarcodeFormat2[BarcodeFormat2["UPC_A"] = 14] = "UPC_A";
      BarcodeFormat2[BarcodeFormat2["UPC_E"] = 15] = "UPC_E";
      BarcodeFormat2[BarcodeFormat2["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
    })(BarcodeFormat || (BarcodeFormat = {}));
    var BarcodeFormat$1 = BarcodeFormat;
    var ResultMetadataType;
    (function(ResultMetadataType2) {
      ResultMetadataType2[ResultMetadataType2["OTHER"] = 0] = "OTHER";
      ResultMetadataType2[ResultMetadataType2["ORIENTATION"] = 1] = "ORIENTATION";
      ResultMetadataType2[ResultMetadataType2["BYTE_SEGMENTS"] = 2] = "BYTE_SEGMENTS";
      ResultMetadataType2[ResultMetadataType2["ERROR_CORRECTION_LEVEL"] = 3] = "ERROR_CORRECTION_LEVEL";
      ResultMetadataType2[ResultMetadataType2["ISSUE_NUMBER"] = 4] = "ISSUE_NUMBER";
      ResultMetadataType2[ResultMetadataType2["SUGGESTED_PRICE"] = 5] = "SUGGESTED_PRICE";
      ResultMetadataType2[ResultMetadataType2["POSSIBLE_COUNTRY"] = 6] = "POSSIBLE_COUNTRY";
      ResultMetadataType2[ResultMetadataType2["UPC_EAN_EXTENSION"] = 7] = "UPC_EAN_EXTENSION";
      ResultMetadataType2[ResultMetadataType2["PDF417_EXTRA_METADATA"] = 8] = "PDF417_EXTRA_METADATA";
      ResultMetadataType2[ResultMetadataType2["STRUCTURED_APPEND_SEQUENCE"] = 9] = "STRUCTURED_APPEND_SEQUENCE";
      ResultMetadataType2[ResultMetadataType2["STRUCTURED_APPEND_PARITY"] = 10] = "STRUCTURED_APPEND_PARITY";
    })(ResultMetadataType || (ResultMetadataType = {}));
    var ResultMetadataType$1 = ResultMetadataType;
    class DecoderResult {
      // public constructor(rawBytes: Uint8Array,
      //                      text: string,
      //                      List<Uint8Array> byteSegments,
      //                      String ecLevel) {
      //   this(rawBytes, text, byteSegments, ecLevel, -1, -1)
      // }
      constructor(rawBytes, text2, byteSegments, ecLevel, structuredAppendSequenceNumber = -1, structuredAppendParity = -1) {
        this.rawBytes = rawBytes;
        this.text = text2;
        this.byteSegments = byteSegments;
        this.ecLevel = ecLevel;
        this.structuredAppendSequenceNumber = structuredAppendSequenceNumber;
        this.structuredAppendParity = structuredAppendParity;
        this.numBits = rawBytes === void 0 || rawBytes === null ? 0 : 8 * rawBytes.length;
      }
      /**
       * @return raw bytes representing the result, or {@code null} if not applicable
       */
      getRawBytes() {
        return this.rawBytes;
      }
      /**
       * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
       * @since 3.3.0
       */
      getNumBits() {
        return this.numBits;
      }
      /**
       * @param numBits overrides the number of bits that are valid in {@link #getRawBytes()}
       * @since 3.3.0
       */
      setNumBits(numBits) {
        this.numBits = numBits;
      }
      /**
       * @return text representation of the result
       */
      getText() {
        return this.text;
      }
      /**
       * @return list of byte segments in the result, or {@code null} if not applicable
       */
      getByteSegments() {
        return this.byteSegments;
      }
      /**
       * @return name of error correction level used, or {@code null} if not applicable
       */
      getECLevel() {
        return this.ecLevel;
      }
      /**
       * @return number of errors corrected, or {@code null} if not applicable
       */
      getErrorsCorrected() {
        return this.errorsCorrected;
      }
      setErrorsCorrected(errorsCorrected) {
        this.errorsCorrected = errorsCorrected;
      }
      /**
       * @return number of erasures corrected, or {@code null} if not applicable
       */
      getErasures() {
        return this.erasures;
      }
      setErasures(erasures) {
        this.erasures = erasures;
      }
      /**
       * @return arbitrary additional metadata
       */
      getOther() {
        return this.other;
      }
      setOther(other) {
        this.other = other;
      }
      hasStructuredAppend() {
        return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
      }
      getStructuredAppendParity() {
        return this.structuredAppendParity;
      }
      getStructuredAppendSequenceNumber() {
        return this.structuredAppendSequenceNumber;
      }
    }
    class AbstractGenericGF {
      /**
       * @return 2 to the power of a in GF(size)
       */
      exp(a) {
        return this.expTable[a];
      }
      /**
       * @return base 2 log of a in GF(size)
       */
      log(a) {
        if (a === 0) {
          throw new IllegalArgumentException();
        }
        return this.logTable[a];
      }
      /**
       * Implements both addition and subtraction -- they are the same in GF(size).
       *
       * @return sum/difference of a and b
       */
      static addOrSubtract(a, b) {
        return a ^ b;
      }
    }
    class GenericGFPoly {
      /**
       * @param field the {@link GenericGF} instance representing the field to use
       * to perform computations
       * @param coefficients coefficients as ints representing elements of GF(size), arranged
       * from most significant (highest-power term) coefficient to least significant
       * @throws IllegalArgumentException if argument is null or empty,
       * or if leading coefficient is 0 and this is not a
       * constant polynomial (that is, it is not the monomial "0")
       */
      constructor(field, coefficients) {
        if (coefficients.length === 0) {
          throw new IllegalArgumentException();
        }
        this.field = field;
        const coefficientsLength = coefficients.length;
        if (coefficientsLength > 1 && coefficients[0] === 0) {
          let firstNonZero = 1;
          while (firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0) {
            firstNonZero++;
          }
          if (firstNonZero === coefficientsLength) {
            this.coefficients = Int32Array.from([0]);
          } else {
            this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
            System.arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
          }
        } else {
          this.coefficients = coefficients;
        }
      }
      getCoefficients() {
        return this.coefficients;
      }
      /**
       * @return degree of this polynomial
       */
      getDegree() {
        return this.coefficients.length - 1;
      }
      /**
       * @return true iff this polynomial is the monomial "0"
       */
      isZero() {
        return this.coefficients[0] === 0;
      }
      /**
       * @return coefficient of x^degree term in this polynomial
       */
      getCoefficient(degree) {
        return this.coefficients[this.coefficients.length - 1 - degree];
      }
      /**
       * @return evaluation of this polynomial at a given point
       */
      evaluateAt(a) {
        if (a === 0) {
          return this.getCoefficient(0);
        }
        const coefficients = this.coefficients;
        let result2;
        if (a === 1) {
          result2 = 0;
          for (let i2 = 0, length = coefficients.length; i2 !== length; i2++) {
            const coefficient = coefficients[i2];
            result2 = AbstractGenericGF.addOrSubtract(result2, coefficient);
          }
          return result2;
        }
        result2 = coefficients[0];
        const size = coefficients.length;
        const field = this.field;
        for (let i2 = 1; i2 < size; i2++) {
          result2 = AbstractGenericGF.addOrSubtract(field.multiply(a, result2), coefficients[i2]);
        }
        return result2;
      }
      addOrSubtract(other) {
        if (!this.field.equals(other.field)) {
          throw new IllegalArgumentException("GenericGFPolys do not have same GenericGF field");
        }
        if (this.isZero()) {
          return other;
        }
        if (other.isZero()) {
          return this;
        }
        let smallerCoefficients = this.coefficients;
        let largerCoefficients = other.coefficients;
        if (smallerCoefficients.length > largerCoefficients.length) {
          const temp = smallerCoefficients;
          smallerCoefficients = largerCoefficients;
          largerCoefficients = temp;
        }
        let sumDiff = new Int32Array(largerCoefficients.length);
        const lengthDiff = largerCoefficients.length - smallerCoefficients.length;
        System.arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
        for (let i2 = lengthDiff; i2 < largerCoefficients.length; i2++) {
          sumDiff[i2] = AbstractGenericGF.addOrSubtract(smallerCoefficients[i2 - lengthDiff], largerCoefficients[i2]);
        }
        return new GenericGFPoly(this.field, sumDiff);
      }
      multiply(other) {
        if (!this.field.equals(other.field)) {
          throw new IllegalArgumentException("GenericGFPolys do not have same GenericGF field");
        }
        if (this.isZero() || other.isZero()) {
          return this.field.getZero();
        }
        const aCoefficients = this.coefficients;
        const aLength = aCoefficients.length;
        const bCoefficients = other.coefficients;
        const bLength = bCoefficients.length;
        const product = new Int32Array(aLength + bLength - 1);
        const field = this.field;
        for (let i2 = 0; i2 < aLength; i2++) {
          const aCoeff = aCoefficients[i2];
          for (let j = 0; j < bLength; j++) {
            product[i2 + j] = AbstractGenericGF.addOrSubtract(product[i2 + j], field.multiply(aCoeff, bCoefficients[j]));
          }
        }
        return new GenericGFPoly(field, product);
      }
      multiplyScalar(scalar) {
        if (scalar === 0) {
          return this.field.getZero();
        }
        if (scalar === 1) {
          return this;
        }
        const size = this.coefficients.length;
        const field = this.field;
        const product = new Int32Array(size);
        const coefficients = this.coefficients;
        for (let i2 = 0; i2 < size; i2++) {
          product[i2] = field.multiply(coefficients[i2], scalar);
        }
        return new GenericGFPoly(field, product);
      }
      multiplyByMonomial(degree, coefficient) {
        if (degree < 0) {
          throw new IllegalArgumentException();
        }
        if (coefficient === 0) {
          return this.field.getZero();
        }
        const coefficients = this.coefficients;
        const size = coefficients.length;
        const product = new Int32Array(size + degree);
        const field = this.field;
        for (let i2 = 0; i2 < size; i2++) {
          product[i2] = field.multiply(coefficients[i2], coefficient);
        }
        return new GenericGFPoly(field, product);
      }
      divide(other) {
        if (!this.field.equals(other.field)) {
          throw new IllegalArgumentException("GenericGFPolys do not have same GenericGF field");
        }
        if (other.isZero()) {
          throw new IllegalArgumentException("Divide by 0");
        }
        const field = this.field;
        let quotient = field.getZero();
        let remainder = this;
        const denominatorLeadingTerm = other.getCoefficient(other.getDegree());
        const inverseDenominatorLeadingTerm = field.inverse(denominatorLeadingTerm);
        while (remainder.getDegree() >= other.getDegree() && !remainder.isZero()) {
          const degreeDifference = remainder.getDegree() - other.getDegree();
          const scale = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
          const term = other.multiplyByMonomial(degreeDifference, scale);
          const iterationQuotient = field.buildMonomial(degreeDifference, scale);
          quotient = quotient.addOrSubtract(iterationQuotient);
          remainder = remainder.addOrSubtract(term);
        }
        return [quotient, remainder];
      }
      /*@Override*/
      toString() {
        let result2 = "";
        for (let degree = this.getDegree(); degree >= 0; degree--) {
          let coefficient = this.getCoefficient(degree);
          if (coefficient !== 0) {
            if (coefficient < 0) {
              result2 += " - ";
              coefficient = -coefficient;
            } else {
              if (result2.length > 0) {
                result2 += " + ";
              }
            }
            if (degree === 0 || coefficient !== 1) {
              const alphaPower = this.field.log(coefficient);
              if (alphaPower === 0) {
                result2 += "1";
              } else if (alphaPower === 1) {
                result2 += "a";
              } else {
                result2 += "a^";
                result2 += alphaPower;
              }
            }
            if (degree !== 0) {
              if (degree === 1) {
                result2 += "x";
              } else {
                result2 += "x^";
                result2 += degree;
              }
            }
          }
        }
        return result2;
      }
    }
    class ArithmeticException extends Exception {
    }
    ArithmeticException.kind = "ArithmeticException";
    class GenericGF extends AbstractGenericGF {
      /**
       * Create a representation of GF(size) using the given primitive polynomial.
       *
       * @param primitive irreducible polynomial whose coefficients are represented by
       *  the bits of an int, where the least-significant bit represents the constant
       *  coefficient
       * @param size the size of the field
       * @param b the factor b in the generator polynomial can be 0- or 1-based
       *  (g(x) = (x+a^b)(x+a^(b+1))...(x+a^(b+2t-1))).
       *  In most cases it should be 1, but for QR code it is 0.
       */
      constructor(primitive, size, generatorBase) {
        super();
        this.primitive = primitive;
        this.size = size;
        this.generatorBase = generatorBase;
        const expTable = new Int32Array(size);
        let x2 = 1;
        for (let i2 = 0; i2 < size; i2++) {
          expTable[i2] = x2;
          x2 *= 2;
          if (x2 >= size) {
            x2 ^= primitive;
            x2 &= size - 1;
          }
        }
        this.expTable = expTable;
        const logTable = new Int32Array(size);
        for (let i2 = 0; i2 < size - 1; i2++) {
          logTable[expTable[i2]] = i2;
        }
        this.logTable = logTable;
        this.zero = new GenericGFPoly(this, Int32Array.from([0]));
        this.one = new GenericGFPoly(this, Int32Array.from([1]));
      }
      getZero() {
        return this.zero;
      }
      getOne() {
        return this.one;
      }
      /**
       * @return the monomial representing coefficient * x^degree
       */
      buildMonomial(degree, coefficient) {
        if (degree < 0) {
          throw new IllegalArgumentException();
        }
        if (coefficient === 0) {
          return this.zero;
        }
        const coefficients = new Int32Array(degree + 1);
        coefficients[0] = coefficient;
        return new GenericGFPoly(this, coefficients);
      }
      /**
       * @return multiplicative inverse of a
       */
      inverse(a) {
        if (a === 0) {
          throw new ArithmeticException();
        }
        return this.expTable[this.size - this.logTable[a] - 1];
      }
      /**
       * @return product of a and b in GF(size)
       */
      multiply(a, b) {
        if (a === 0 || b === 0) {
          return 0;
        }
        return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.size - 1)];
      }
      getSize() {
        return this.size;
      }
      getGeneratorBase() {
        return this.generatorBase;
      }
      /*@Override*/
      toString() {
        return "GF(0x" + Integer.toHexString(this.primitive) + "," + this.size + ")";
      }
      equals(o) {
        return o === this;
      }
    }
    GenericGF.AZTEC_DATA_12 = new GenericGF(4201, 4096, 1);
    GenericGF.AZTEC_DATA_10 = new GenericGF(1033, 1024, 1);
    GenericGF.AZTEC_DATA_6 = new GenericGF(67, 64, 1);
    GenericGF.AZTEC_PARAM = new GenericGF(19, 16, 1);
    GenericGF.QR_CODE_FIELD_256 = new GenericGF(285, 256, 0);
    GenericGF.DATA_MATRIX_FIELD_256 = new GenericGF(301, 256, 1);
    GenericGF.AZTEC_DATA_8 = GenericGF.DATA_MATRIX_FIELD_256;
    GenericGF.MAXICODE_FIELD_64 = GenericGF.AZTEC_DATA_6;
    class ReedSolomonException extends Exception {
    }
    ReedSolomonException.kind = "ReedSolomonException";
    class IllegalStateException extends Exception {
    }
    IllegalStateException.kind = "IllegalStateException";
    class ReedSolomonDecoder {
      constructor(field) {
        this.field = field;
      }
      /**
       * <p>Decodes given set of received codewords, which include both data and error-correction
       * codewords. Really, this means it uses Reed-Solomon to detect and correct errors, in-place,
       * in the input.</p>
       *
       * @param received data and error-correction codewords
       * @param twoS number of error-correction codewords available
       * @throws ReedSolomonException if decoding fails for any reason
       */
      decode(received, twoS) {
        const field = this.field;
        const poly = new GenericGFPoly(field, received);
        const syndromeCoefficients = new Int32Array(twoS);
        let noError = true;
        for (let i2 = 0; i2 < twoS; i2++) {
          const evalResult = poly.evaluateAt(field.exp(i2 + field.getGeneratorBase()));
          syndromeCoefficients[syndromeCoefficients.length - 1 - i2] = evalResult;
          if (evalResult !== 0) {
            noError = false;
          }
        }
        if (noError) {
          return;
        }
        const syndrome = new GenericGFPoly(field, syndromeCoefficients);
        const sigmaOmega = this.runEuclideanAlgorithm(field.buildMonomial(twoS, 1), syndrome, twoS);
        const sigma = sigmaOmega[0];
        const omega = sigmaOmega[1];
        const errorLocations = this.findErrorLocations(sigma);
        const errorMagnitudes = this.findErrorMagnitudes(omega, errorLocations);
        for (let i2 = 0; i2 < errorLocations.length; i2++) {
          const position = received.length - 1 - field.log(errorLocations[i2]);
          if (position < 0) {
            throw new ReedSolomonException("Bad error location");
          }
          received[position] = GenericGF.addOrSubtract(received[position], errorMagnitudes[i2]);
        }
      }
      runEuclideanAlgorithm(a, b, R) {
        if (a.getDegree() < b.getDegree()) {
          const temp = a;
          a = b;
          b = temp;
        }
        const field = this.field;
        let rLast = a;
        let r = b;
        let tLast = field.getZero();
        let t3 = field.getOne();
        while (r.getDegree() >= (R / 2 | 0)) {
          let rLastLast = rLast;
          let tLastLast = tLast;
          rLast = r;
          tLast = t3;
          if (rLast.isZero()) {
            throw new ReedSolomonException("r_{i-1} was zero");
          }
          r = rLastLast;
          let q = field.getZero();
          const denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
          const dltInverse = field.inverse(denominatorLeadingTerm);
          while (r.getDegree() >= rLast.getDegree() && !r.isZero()) {
            const degreeDiff = r.getDegree() - rLast.getDegree();
            const scale = field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
            q = q.addOrSubtract(field.buildMonomial(degreeDiff, scale));
            r = r.addOrSubtract(rLast.multiplyByMonomial(degreeDiff, scale));
          }
          t3 = q.multiply(tLast).addOrSubtract(tLastLast);
          if (r.getDegree() >= rLast.getDegree()) {
            throw new IllegalStateException("Division algorithm failed to reduce polynomial?");
          }
        }
        const sigmaTildeAtZero = t3.getCoefficient(0);
        if (sigmaTildeAtZero === 0) {
          throw new ReedSolomonException("sigmaTilde(0) was zero");
        }
        const inverse = field.inverse(sigmaTildeAtZero);
        const sigma = t3.multiplyScalar(inverse);
        const omega = r.multiplyScalar(inverse);
        return [sigma, omega];
      }
      findErrorLocations(errorLocator) {
        const numErrors = errorLocator.getDegree();
        if (numErrors === 1) {
          return Int32Array.from([errorLocator.getCoefficient(1)]);
        }
        const result2 = new Int32Array(numErrors);
        let e = 0;
        const field = this.field;
        for (let i2 = 1; i2 < field.getSize() && e < numErrors; i2++) {
          if (errorLocator.evaluateAt(i2) === 0) {
            result2[e] = field.inverse(i2);
            e++;
          }
        }
        if (e !== numErrors) {
          throw new ReedSolomonException("Error locator degree does not match number of roots");
        }
        return result2;
      }
      findErrorMagnitudes(errorEvaluator, errorLocations) {
        const s2 = errorLocations.length;
        const result2 = new Int32Array(s2);
        const field = this.field;
        for (let i2 = 0; i2 < s2; i2++) {
          const xiInverse = field.inverse(errorLocations[i2]);
          let denominator = 1;
          for (let j = 0; j < s2; j++) {
            if (i2 !== j) {
              const term = field.multiply(errorLocations[j], xiInverse);
              const termPlus1 = (term & 1) === 0 ? term | 1 : term & ~1;
              denominator = field.multiply(denominator, termPlus1);
            }
          }
          result2[i2] = field.multiply(errorEvaluator.evaluateAt(xiInverse), field.inverse(denominator));
          if (field.getGeneratorBase() !== 0) {
            result2[i2] = field.multiply(result2[i2], xiInverse);
          }
        }
        return result2;
      }
    }
    var Table;
    (function(Table2) {
      Table2[Table2["UPPER"] = 0] = "UPPER";
      Table2[Table2["LOWER"] = 1] = "LOWER";
      Table2[Table2["MIXED"] = 2] = "MIXED";
      Table2[Table2["DIGIT"] = 3] = "DIGIT";
      Table2[Table2["PUNCT"] = 4] = "PUNCT";
      Table2[Table2["BINARY"] = 5] = "BINARY";
    })(Table || (Table = {}));
    class Decoder {
      decode(detectorResult) {
        this.ddata = detectorResult;
        let matrix2 = detectorResult.getBits();
        let rawbits = this.extractBits(matrix2);
        let correctedBits = this.correctBits(rawbits);
        let rawBytes = Decoder.convertBoolArrayToByteArray(correctedBits);
        let result2 = Decoder.getEncodedData(correctedBits);
        let decoderResult = new DecoderResult(rawBytes, result2, null, null);
        decoderResult.setNumBits(correctedBits.length);
        return decoderResult;
      }
      // This method is used for testing the high-level encoder
      static highLevelDecode(correctedBits) {
        return this.getEncodedData(correctedBits);
      }
      /**
       * Gets the string encoded in the aztec code bits
       *
       * @return the decoded string
       */
      static getEncodedData(correctedBits) {
        let endIndex = correctedBits.length;
        let latchTable = Table.UPPER;
        let shiftTable = Table.UPPER;
        let result2 = "";
        let index2 = 0;
        while (index2 < endIndex) {
          if (shiftTable === Table.BINARY) {
            if (endIndex - index2 < 5) {
              break;
            }
            let length = Decoder.readCode(correctedBits, index2, 5);
            index2 += 5;
            if (length === 0) {
              if (endIndex - index2 < 11) {
                break;
              }
              length = Decoder.readCode(correctedBits, index2, 11) + 31;
              index2 += 11;
            }
            for (let charCount = 0; charCount < length; charCount++) {
              if (endIndex - index2 < 8) {
                index2 = endIndex;
                break;
              }
              const code = Decoder.readCode(correctedBits, index2, 8);
              result2 += /*(char)*/
              StringUtils.castAsNonUtf8Char(code);
              index2 += 8;
            }
            shiftTable = latchTable;
          } else {
            let size = shiftTable === Table.DIGIT ? 4 : 5;
            if (endIndex - index2 < size) {
              break;
            }
            let code = Decoder.readCode(correctedBits, index2, size);
            index2 += size;
            let str = Decoder.getCharacter(shiftTable, code);
            if (str.startsWith("CTRL_")) {
              latchTable = shiftTable;
              shiftTable = Decoder.getTable(str.charAt(5));
              if (str.charAt(6) === "L") {
                latchTable = shiftTable;
              }
            } else {
              result2 += str;
              shiftTable = latchTable;
            }
          }
        }
        return result2;
      }
      /**
       * gets the table corresponding to the char passed
       */
      static getTable(t3) {
        switch (t3) {
          case "L":
            return Table.LOWER;
          case "P":
            return Table.PUNCT;
          case "M":
            return Table.MIXED;
          case "D":
            return Table.DIGIT;
          case "B":
            return Table.BINARY;
          case "U":
          default:
            return Table.UPPER;
        }
      }
      /**
       * Gets the character (or string) corresponding to the passed code in the given table
       *
       * @param table the table used
       * @param code the code of the character
       */
      static getCharacter(table, code) {
        switch (table) {
          case Table.UPPER:
            return Decoder.UPPER_TABLE[code];
          case Table.LOWER:
            return Decoder.LOWER_TABLE[code];
          case Table.MIXED:
            return Decoder.MIXED_TABLE[code];
          case Table.PUNCT:
            return Decoder.PUNCT_TABLE[code];
          case Table.DIGIT:
            return Decoder.DIGIT_TABLE[code];
          default:
            throw new IllegalStateException("Bad table");
        }
      }
      /**
       * <p>Performs RS error correction on an array of bits.</p>
       *
       * @return the corrected array
       * @throws FormatException if the input contains too many errors
       */
      correctBits(rawbits) {
        let gf;
        let codewordSize;
        if (this.ddata.getNbLayers() <= 2) {
          codewordSize = 6;
          gf = GenericGF.AZTEC_DATA_6;
        } else if (this.ddata.getNbLayers() <= 8) {
          codewordSize = 8;
          gf = GenericGF.AZTEC_DATA_8;
        } else if (this.ddata.getNbLayers() <= 22) {
          codewordSize = 10;
          gf = GenericGF.AZTEC_DATA_10;
        } else {
          codewordSize = 12;
          gf = GenericGF.AZTEC_DATA_12;
        }
        let numDataCodewords = this.ddata.getNbDatablocks();
        let numCodewords = rawbits.length / codewordSize;
        if (numCodewords < numDataCodewords) {
          throw new FormatException();
        }
        let offset2 = rawbits.length % codewordSize;
        let dataWords = new Int32Array(numCodewords);
        for (let i2 = 0; i2 < numCodewords; i2++, offset2 += codewordSize) {
          dataWords[i2] = Decoder.readCode(rawbits, offset2, codewordSize);
        }
        try {
          let rsDecoder = new ReedSolomonDecoder(gf);
          rsDecoder.decode(dataWords, numCodewords - numDataCodewords);
        } catch (ex) {
          throw new FormatException(ex);
        }
        let mask = (1 << codewordSize) - 1;
        let stuffedBits = 0;
        for (let i2 = 0; i2 < numDataCodewords; i2++) {
          let dataWord = dataWords[i2];
          if (dataWord === 0 || dataWord === mask) {
            throw new FormatException();
          } else if (dataWord === 1 || dataWord === mask - 1) {
            stuffedBits++;
          }
        }
        let correctedBits = new Array(numDataCodewords * codewordSize - stuffedBits);
        let index2 = 0;
        for (let i2 = 0; i2 < numDataCodewords; i2++) {
          let dataWord = dataWords[i2];
          if (dataWord === 1 || dataWord === mask - 1) {
            correctedBits.fill(dataWord > 1, index2, index2 + codewordSize - 1);
            index2 += codewordSize - 1;
          } else {
            for (let bit = codewordSize - 1; bit >= 0; --bit) {
              correctedBits[index2++] = (dataWord & 1 << bit) !== 0;
            }
          }
        }
        return correctedBits;
      }
      /**
       * Gets the array of bits from an Aztec Code matrix
       *
       * @return the array of bits
       */
      extractBits(matrix2) {
        let compact = this.ddata.isCompact();
        let layers = this.ddata.getNbLayers();
        let baseMatrixSize = (compact ? 11 : 14) + layers * 4;
        let alignmentMap = new Int32Array(baseMatrixSize);
        let rawbits = new Array(this.totalBitsInLayer(layers, compact));
        if (compact) {
          for (let i2 = 0; i2 < alignmentMap.length; i2++) {
            alignmentMap[i2] = i2;
          }
        } else {
          let matrixSize = baseMatrixSize + 1 + 2 * Integer.truncDivision(Integer.truncDivision(baseMatrixSize, 2) - 1, 15);
          let origCenter = baseMatrixSize / 2;
          let center = Integer.truncDivision(matrixSize, 2);
          for (let i2 = 0; i2 < origCenter; i2++) {
            let newOffset = i2 + Integer.truncDivision(i2, 15);
            alignmentMap[origCenter - i2 - 1] = center - newOffset - 1;
            alignmentMap[origCenter + i2] = center + newOffset + 1;
          }
        }
        for (let i2 = 0, rowOffset = 0; i2 < layers; i2++) {
          let rowSize = (layers - i2) * 4 + (compact ? 9 : 12);
          let low = i2 * 2;
          let high = baseMatrixSize - 1 - low;
          for (let j = 0; j < rowSize; j++) {
            let columnOffset = j * 2;
            for (let k = 0; k < 2; k++) {
              rawbits[rowOffset + columnOffset + k] = matrix2.get(alignmentMap[low + k], alignmentMap[low + j]);
              rawbits[rowOffset + 2 * rowSize + columnOffset + k] = matrix2.get(alignmentMap[low + j], alignmentMap[high - k]);
              rawbits[rowOffset + 4 * rowSize + columnOffset + k] = matrix2.get(alignmentMap[high - k], alignmentMap[high - j]);
              rawbits[rowOffset + 6 * rowSize + columnOffset + k] = matrix2.get(alignmentMap[high - j], alignmentMap[low + k]);
            }
          }
          rowOffset += rowSize * 8;
        }
        return rawbits;
      }
      /**
       * Reads a code of given length and at given index in an array of bits
       */
      static readCode(rawbits, startIndex, length) {
        let res = 0;
        for (let i2 = startIndex; i2 < startIndex + length; i2++) {
          res <<= 1;
          if (rawbits[i2]) {
            res |= 1;
          }
        }
        return res;
      }
      /**
       * Reads a code of length 8 in an array of bits, padding with zeros
       */
      static readByte(rawbits, startIndex) {
        let n2 = rawbits.length - startIndex;
        if (n2 >= 8) {
          return Decoder.readCode(rawbits, startIndex, 8);
        }
        return Decoder.readCode(rawbits, startIndex, n2) << 8 - n2;
      }
      /**
       * Packs a bit array into bytes, most significant bit first
       */
      static convertBoolArrayToByteArray(boolArr) {
        let byteArr = new Uint8Array((boolArr.length + 7) / 8);
        for (let i2 = 0; i2 < byteArr.length; i2++) {
          byteArr[i2] = Decoder.readByte(boolArr, 8 * i2);
        }
        return byteArr;
      }
      totalBitsInLayer(layers, compact) {
        return ((compact ? 88 : 112) + 16 * layers) * layers;
      }
    }
    Decoder.UPPER_TABLE = [
      "CTRL_PS",
      " ",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "CTRL_LL",
      "CTRL_ML",
      "CTRL_DL",
      "CTRL_BS"
    ];
    Decoder.LOWER_TABLE = [
      "CTRL_PS",
      " ",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
      "CTRL_US",
      "CTRL_ML",
      "CTRL_DL",
      "CTRL_BS"
    ];
    Decoder.MIXED_TABLE = [
      // Module parse failed: Octal literal in strict mode (50:29)
      // so number string were scaped
      "CTRL_PS",
      " ",
      "\\1",
      "\\2",
      "\\3",
      "\\4",
      "\\5",
      "\\6",
      "\\7",
      "\b",
      "	",
      "\n",
      "\\13",
      "\f",
      "\r",
      "\\33",
      "\\34",
      "\\35",
      "\\36",
      "\\37",
      "@",
      "\\",
      "^",
      "_",
      "`",
      "|",
      "~",
      "\\177",
      "CTRL_LL",
      "CTRL_UL",
      "CTRL_PL",
      "CTRL_BS"
    ];
    Decoder.PUNCT_TABLE = [
      "",
      "\r",
      "\r\n",
      ". ",
      ", ",
      ": ",
      "!",
      '"',
      "#",
      "$",
      "%",
      "&",
      "'",
      "(",
      ")",
      "*",
      "+",
      ",",
      "-",
      ".",
      "/",
      ":",
      ";",
      "<",
      "=",
      ">",
      "?",
      "[",
      "]",
      "{",
      "}",
      "CTRL_UL"
    ];
    Decoder.DIGIT_TABLE = [
      "CTRL_PS",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ",",
      ".",
      "CTRL_UL",
      "CTRL_US"
    ];
    class MathUtils2 {
      constructor() {
      }
      /**
       * Ends up being a bit faster than {@link Math#round(float)}. This merely rounds its
       * argument to the nearest int, where x.5 rounds up to x+1. Semantics of this shortcut
       * differ slightly from {@link Math#round(float)} in that half rounds down for negative
       * values. -2.5 rounds to -3, not -2. For purposes here it makes no difference.
       *
       * @param d real value to round
       * @return nearest {@code int}
       */
      static round(d2) {
        if (NaN === d2)
          return 0;
        if (d2 <= Number.MIN_SAFE_INTEGER)
          return Number.MIN_SAFE_INTEGER;
        if (d2 >= Number.MAX_SAFE_INTEGER)
          return Number.MAX_SAFE_INTEGER;
        return (
          /*(int) */
          d2 + (d2 < 0 ? -0.5 : 0.5) | 0
        );
      }
      // TYPESCRIPTPORT: maybe remove round method and call directly Math.round, it looks like it doesn't make sense for js
      /**
       * @param aX point A x coordinate
       * @param aY point A y coordinate
       * @param bX point B x coordinate
       * @param bY point B y coordinate
       * @return Euclidean distance between points A and B
       */
      static distance(aX, aY, bX, bY) {
        const xDiff = aX - bX;
        const yDiff = aY - bY;
        return (
          /*(float) */
          Math.sqrt(xDiff * xDiff + yDiff * yDiff)
        );
      }
      /**
       * @param aX point A x coordinate
       * @param aY point A y coordinate
       * @param bX point B x coordinate
       * @param bY point B y coordinate
       * @return Euclidean distance between points A and B
       */
      // public static distance(aX: number /*int*/, aY: number /*int*/, bX: number /*int*/, bY: number /*int*/): float {
      //   const xDiff = aX - bX
      //   const yDiff = aY - bY
      //   return (float) Math.sqrt(xDiff * xDiff + yDiff * yDiff);
      // }
      /**
       * @param array values to sum
       * @return sum of values in array
       */
      static sum(array) {
        let count = 0;
        for (let i2 = 0, length = array.length; i2 !== length; i2++) {
          const a = array[i2];
          count += a;
        }
        return count;
      }
    }
    class Float {
      /**
       * SincTS has no difference between int and float, there's all numbers,
       * this is used only to polyfill Java code.
       */
      static floatToIntBits(f) {
        return f;
      }
    }
    Float.MAX_VALUE = Number.MAX_SAFE_INTEGER;
    class ResultPoint {
      constructor(x2, y) {
        this.x = x2;
        this.y = y;
      }
      getX() {
        return this.x;
      }
      getY() {
        return this.y;
      }
      /*@Override*/
      equals(other) {
        if (other instanceof ResultPoint) {
          const otherPoint = other;
          return this.x === otherPoint.x && this.y === otherPoint.y;
        }
        return false;
      }
      /*@Override*/
      hashCode() {
        return 31 * Float.floatToIntBits(this.x) + Float.floatToIntBits(this.y);
      }
      /*@Override*/
      toString() {
        return "(" + this.x + "," + this.y + ")";
      }
      /**
       * Orders an array of three ResultPoints in an order [A,B,C] such that AB is less than AC
       * and BC is less than AC, and the angle between BC and BA is less than 180 degrees.
       *
       * @param patterns array of three {@code ResultPoint} to order
       */
      static orderBestPatterns(patterns) {
        const zeroOneDistance = this.distance(patterns[0], patterns[1]);
        const oneTwoDistance = this.distance(patterns[1], patterns[2]);
        const zeroTwoDistance = this.distance(patterns[0], patterns[2]);
        let pointA;
        let pointB;
        let pointC;
        if (oneTwoDistance >= zeroOneDistance && oneTwoDistance >= zeroTwoDistance) {
          pointB = patterns[0];
          pointA = patterns[1];
          pointC = patterns[2];
        } else if (zeroTwoDistance >= oneTwoDistance && zeroTwoDistance >= zeroOneDistance) {
          pointB = patterns[1];
          pointA = patterns[0];
          pointC = patterns[2];
        } else {
          pointB = patterns[2];
          pointA = patterns[0];
          pointC = patterns[1];
        }
        if (this.crossProductZ(pointA, pointB, pointC) < 0) {
          const temp = pointA;
          pointA = pointC;
          pointC = temp;
        }
        patterns[0] = pointA;
        patterns[1] = pointB;
        patterns[2] = pointC;
      }
      /**
       * @param pattern1 first pattern
       * @param pattern2 second pattern
       * @return distance between two points
       */
      static distance(pattern1, pattern2) {
        return MathUtils2.distance(pattern1.x, pattern1.y, pattern2.x, pattern2.y);
      }
      /**
       * Returns the z component of the cross product between vectors BC and BA.
       */
      static crossProductZ(pointA, pointB, pointC) {
        const bX = pointB.x;
        const bY = pointB.y;
        return (pointC.x - bX) * (pointA.y - bY) - (pointC.y - bY) * (pointA.x - bX);
      }
    }
    class DetectorResult {
      constructor(bits, points) {
        this.bits = bits;
        this.points = points;
      }
      getBits() {
        return this.bits;
      }
      getPoints() {
        return this.points;
      }
    }
    class AztecDetectorResult extends DetectorResult {
      constructor(bits, points, compact, nbDatablocks, nbLayers) {
        super(bits, points);
        this.compact = compact;
        this.nbDatablocks = nbDatablocks;
        this.nbLayers = nbLayers;
      }
      getNbLayers() {
        return this.nbLayers;
      }
      getNbDatablocks() {
        return this.nbDatablocks;
      }
      isCompact() {
        return this.compact;
      }
    }
    class WhiteRectangleDetector {
      // public constructor(private image: BitMatrix) /*throws NotFoundException*/ {
      //   this(image, INIT_SIZE, image.getWidth() / 2, image.getHeight() / 2)
      // }
      /**
       * @param image barcode image to find a rectangle in
       * @param initSize initial size of search area around center
       * @param x x position of search center
       * @param y y position of search center
       * @throws NotFoundException if image is too small to accommodate {@code initSize}
       */
      constructor(image, initSize, x2, y) {
        this.image = image;
        this.height = image.getHeight();
        this.width = image.getWidth();
        if (void 0 === initSize || null === initSize) {
          initSize = WhiteRectangleDetector.INIT_SIZE;
        }
        if (void 0 === x2 || null === x2) {
          x2 = image.getWidth() / 2 | 0;
        }
        if (void 0 === y || null === y) {
          y = image.getHeight() / 2 | 0;
        }
        const halfsize = initSize / 2 | 0;
        this.leftInit = x2 - halfsize;
        this.rightInit = x2 + halfsize;
        this.upInit = y - halfsize;
        this.downInit = y + halfsize;
        if (this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width) {
          throw new NotFoundException();
        }
      }
      /**
       * <p>
       * Detects a candidate barcode-like rectangular region within an image. It
       * starts around the center of the image, increases the size of the candidate
       * region until it finds a white rectangular region.
       * </p>
       *
       * @return {@link ResultPoint}[] describing the corners of the rectangular
       *         region. The first and last points are opposed on the diagonal, as
       *         are the second and third. The first point will be the topmost
       *         point and the last, the bottommost. The second point will be
       *         leftmost and the third, the rightmost
       * @throws NotFoundException if no Data Matrix Code can be found
       */
      detect() {
        let left = this.leftInit;
        let right = this.rightInit;
        let up = this.upInit;
        let down = this.downInit;
        let sizeExceeded = false;
        let aBlackPointFoundOnBorder = true;
        let atLeastOneBlackPointFoundOnBorder = false;
        let atLeastOneBlackPointFoundOnRight = false;
        let atLeastOneBlackPointFoundOnBottom = false;
        let atLeastOneBlackPointFoundOnLeft = false;
        let atLeastOneBlackPointFoundOnTop = false;
        const width = this.width;
        const height = this.height;
        while (aBlackPointFoundOnBorder) {
          aBlackPointFoundOnBorder = false;
          let rightBorderNotWhite = true;
          while ((rightBorderNotWhite || !atLeastOneBlackPointFoundOnRight) && right < width) {
            rightBorderNotWhite = this.containsBlackPoint(up, down, right, false);
            if (rightBorderNotWhite) {
              right++;
              aBlackPointFoundOnBorder = true;
              atLeastOneBlackPointFoundOnRight = true;
            } else if (!atLeastOneBlackPointFoundOnRight) {
              right++;
            }
          }
          if (right >= width) {
            sizeExceeded = true;
            break;
          }
          let bottomBorderNotWhite = true;
          while ((bottomBorderNotWhite || !atLeastOneBlackPointFoundOnBottom) && down < height) {
            bottomBorderNotWhite = this.containsBlackPoint(left, right, down, true);
            if (bottomBorderNotWhite) {
              down++;
              aBlackPointFoundOnBorder = true;
              atLeastOneBlackPointFoundOnBottom = true;
            } else if (!atLeastOneBlackPointFoundOnBottom) {
              down++;
            }
          }
          if (down >= height) {
            sizeExceeded = true;
            break;
          }
          let leftBorderNotWhite = true;
          while ((leftBorderNotWhite || !atLeastOneBlackPointFoundOnLeft) && left >= 0) {
            leftBorderNotWhite = this.containsBlackPoint(up, down, left, false);
            if (leftBorderNotWhite) {
              left--;
              aBlackPointFoundOnBorder = true;
              atLeastOneBlackPointFoundOnLeft = true;
            } else if (!atLeastOneBlackPointFoundOnLeft) {
              left--;
            }
          }
          if (left < 0) {
            sizeExceeded = true;
            break;
          }
          let topBorderNotWhite = true;
          while ((topBorderNotWhite || !atLeastOneBlackPointFoundOnTop) && up >= 0) {
            topBorderNotWhite = this.containsBlackPoint(left, right, up, true);
            if (topBorderNotWhite) {
              up--;
              aBlackPointFoundOnBorder = true;
              atLeastOneBlackPointFoundOnTop = true;
            } else if (!atLeastOneBlackPointFoundOnTop) {
              up--;
            }
          }
          if (up < 0) {
            sizeExceeded = true;
            break;
          }
          if (aBlackPointFoundOnBorder) {
            atLeastOneBlackPointFoundOnBorder = true;
          }
        }
        if (!sizeExceeded && atLeastOneBlackPointFoundOnBorder) {
          const maxSize = right - left;
          let z = null;
          for (let i2 = 1; z === null && i2 < maxSize; i2++) {
            z = this.getBlackPointOnSegment(left, down - i2, left + i2, down);
          }
          if (z == null) {
            throw new NotFoundException();
          }
          let t3 = null;
          for (let i2 = 1; t3 === null && i2 < maxSize; i2++) {
            t3 = this.getBlackPointOnSegment(left, up + i2, left + i2, up);
          }
          if (t3 == null) {
            throw new NotFoundException();
          }
          let x2 = null;
          for (let i2 = 1; x2 === null && i2 < maxSize; i2++) {
            x2 = this.getBlackPointOnSegment(right, up + i2, right - i2, up);
          }
          if (x2 == null) {
            throw new NotFoundException();
          }
          let y = null;
          for (let i2 = 1; y === null && i2 < maxSize; i2++) {
            y = this.getBlackPointOnSegment(right, down - i2, right - i2, down);
          }
          if (y == null) {
            throw new NotFoundException();
          }
          return this.centerEdges(y, z, x2, t3);
        } else {
          throw new NotFoundException();
        }
      }
      getBlackPointOnSegment(aX, aY, bX, bY) {
        const dist = MathUtils2.round(MathUtils2.distance(aX, aY, bX, bY));
        const xStep = (bX - aX) / dist;
        const yStep = (bY - aY) / dist;
        const image = this.image;
        for (let i2 = 0; i2 < dist; i2++) {
          const x2 = MathUtils2.round(aX + i2 * xStep);
          const y = MathUtils2.round(aY + i2 * yStep);
          if (image.get(x2, y)) {
            return new ResultPoint(x2, y);
          }
        }
        return null;
      }
      /**
       * recenters the points of a constant distance towards the center
       *
       * @param y bottom most point
       * @param z left most point
       * @param x right most point
       * @param t top most point
       * @return {@link ResultPoint}[] describing the corners of the rectangular
       *         region. The first and last points are opposed on the diagonal, as
       *         are the second and third. The first point will be the topmost
       *         point and the last, the bottommost. The second point will be
       *         leftmost and the third, the rightmost
       */
      centerEdges(y, z, x2, t3) {
        const yi = y.getX();
        const yj = y.getY();
        const zi = z.getX();
        const zj = z.getY();
        const xi = x2.getX();
        const xj = x2.getY();
        const ti = t3.getX();
        const tj = t3.getY();
        const CORR = WhiteRectangleDetector.CORR;
        if (yi < this.width / 2) {
          return [
            new ResultPoint(ti - CORR, tj + CORR),
            new ResultPoint(zi + CORR, zj + CORR),
            new ResultPoint(xi - CORR, xj - CORR),
            new ResultPoint(yi + CORR, yj - CORR)
          ];
        } else {
          return [
            new ResultPoint(ti + CORR, tj + CORR),
            new ResultPoint(zi + CORR, zj - CORR),
            new ResultPoint(xi - CORR, xj + CORR),
            new ResultPoint(yi - CORR, yj - CORR)
          ];
        }
      }
      /**
       * Determines whether a segment contains a black point
       *
       * @param a          min value of the scanned coordinate
       * @param b          max value of the scanned coordinate
       * @param fixed      value of fixed coordinate
       * @param horizontal set to true if scan must be horizontal, false if vertical
       * @return true if a black point has been found, else false.
       */
      containsBlackPoint(a, b, fixed, horizontal) {
        const image = this.image;
        if (horizontal) {
          for (let x2 = a; x2 <= b; x2++) {
            if (image.get(x2, fixed)) {
              return true;
            }
          }
        } else {
          for (let y = a; y <= b; y++) {
            if (image.get(fixed, y)) {
              return true;
            }
          }
        }
        return false;
      }
    }
    WhiteRectangleDetector.INIT_SIZE = 10;
    WhiteRectangleDetector.CORR = 1;
    class GridSampler {
      /**
       * <p>Checks a set of points that have been transformed to sample points on an image against
       * the image's dimensions to see if the point are even within the image.</p>
       *
       * <p>This method will actually "nudge" the endpoints back onto the image if they are found to be
       * barely (less than 1 pixel) off the image. This accounts for imperfect detection of finder
       * patterns in an image where the QR Code runs all the way to the image border.</p>
       *
       * <p>For efficiency, the method will check points from either end of the line until one is found
       * to be within the image. Because the set of points are assumed to be linear, this is valid.</p>
       *
       * @param image image into which the points should map
       * @param points actual points in x1,y1,...,xn,yn form
       * @throws NotFoundException if an endpoint is lies outside the image boundaries
       */
      static checkAndNudgePoints(image, points) {
        const width = image.getWidth();
        const height = image.getHeight();
        let nudged = true;
        for (let offset2 = 0; offset2 < points.length && nudged; offset2 += 2) {
          const x2 = Math.floor(points[offset2]);
          const y = Math.floor(points[offset2 + 1]);
          if (x2 < -1 || x2 > width || y < -1 || y > height) {
            throw new NotFoundException();
          }
          nudged = false;
          if (x2 === -1) {
            points[offset2] = 0;
            nudged = true;
          } else if (x2 === width) {
            points[offset2] = width - 1;
            nudged = true;
          }
          if (y === -1) {
            points[offset2 + 1] = 0;
            nudged = true;
          } else if (y === height) {
            points[offset2 + 1] = height - 1;
            nudged = true;
          }
        }
        nudged = true;
        for (let offset2 = points.length - 2; offset2 >= 0 && nudged; offset2 -= 2) {
          const x2 = Math.floor(points[offset2]);
          const y = Math.floor(points[offset2 + 1]);
          if (x2 < -1 || x2 > width || y < -1 || y > height) {
            throw new NotFoundException();
          }
          nudged = false;
          if (x2 === -1) {
            points[offset2] = 0;
            nudged = true;
          } else if (x2 === width) {
            points[offset2] = width - 1;
            nudged = true;
          }
          if (y === -1) {
            points[offset2 + 1] = 0;
            nudged = true;
          } else if (y === height) {
            points[offset2 + 1] = height - 1;
            nudged = true;
          }
        }
      }
    }
    class PerspectiveTransform {
      constructor(a11, a21, a31, a12, a22, a32, a13, a23, a33) {
        this.a11 = a11;
        this.a21 = a21;
        this.a31 = a31;
        this.a12 = a12;
        this.a22 = a22;
        this.a32 = a32;
        this.a13 = a13;
        this.a23 = a23;
        this.a33 = a33;
      }
      static quadrilateralToQuadrilateral(x0, y0, x1, y1, x2, y2, x3, y3, x0p, y0p, x1p, y1p, x2p, y2p, x3p, y3p) {
        const qToS = PerspectiveTransform.quadrilateralToSquare(x0, y0, x1, y1, x2, y2, x3, y3);
        const sToQ = PerspectiveTransform.squareToQuadrilateral(x0p, y0p, x1p, y1p, x2p, y2p, x3p, y3p);
        return sToQ.times(qToS);
      }
      transformPoints(points) {
        const max2 = points.length;
        const a11 = this.a11;
        const a12 = this.a12;
        const a13 = this.a13;
        const a21 = this.a21;
        const a22 = this.a22;
        const a23 = this.a23;
        const a31 = this.a31;
        const a32 = this.a32;
        const a33 = this.a33;
        for (let i2 = 0; i2 < max2; i2 += 2) {
          const x2 = points[i2];
          const y = points[i2 + 1];
          const denominator = a13 * x2 + a23 * y + a33;
          points[i2] = (a11 * x2 + a21 * y + a31) / denominator;
          points[i2 + 1] = (a12 * x2 + a22 * y + a32) / denominator;
        }
      }
      transformPointsWithValues(xValues, yValues) {
        const a11 = this.a11;
        const a12 = this.a12;
        const a13 = this.a13;
        const a21 = this.a21;
        const a22 = this.a22;
        const a23 = this.a23;
        const a31 = this.a31;
        const a32 = this.a32;
        const a33 = this.a33;
        const n2 = xValues.length;
        for (let i2 = 0; i2 < n2; i2++) {
          const x2 = xValues[i2];
          const y = yValues[i2];
          const denominator = a13 * x2 + a23 * y + a33;
          xValues[i2] = (a11 * x2 + a21 * y + a31) / denominator;
          yValues[i2] = (a12 * x2 + a22 * y + a32) / denominator;
        }
      }
      static squareToQuadrilateral(x0, y0, x1, y1, x2, y2, x3, y3) {
        const dx3 = x0 - x1 + x2 - x3;
        const dy3 = y0 - y1 + y2 - y3;
        if (dx3 === 0 && dy3 === 0) {
          return new PerspectiveTransform(x1 - x0, x2 - x1, x0, y1 - y0, y2 - y1, y0, 0, 0, 1);
        } else {
          const dx1 = x1 - x2;
          const dx2 = x3 - x2;
          const dy1 = y1 - y2;
          const dy2 = y3 - y2;
          const denominator = dx1 * dy2 - dx2 * dy1;
          const a13 = (dx3 * dy2 - dx2 * dy3) / denominator;
          const a23 = (dx1 * dy3 - dx3 * dy1) / denominator;
          return new PerspectiveTransform(x1 - x0 + a13 * x1, x3 - x0 + a23 * x3, x0, y1 - y0 + a13 * y1, y3 - y0 + a23 * y3, y0, a13, a23, 1);
        }
      }
      static quadrilateralToSquare(x0, y0, x1, y1, x2, y2, x3, y3) {
        return PerspectiveTransform.squareToQuadrilateral(x0, y0, x1, y1, x2, y2, x3, y3).buildAdjoint();
      }
      buildAdjoint() {
        return new PerspectiveTransform(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
      }
      times(other) {
        return new PerspectiveTransform(this.a11 * other.a11 + this.a21 * other.a12 + this.a31 * other.a13, this.a11 * other.a21 + this.a21 * other.a22 + this.a31 * other.a23, this.a11 * other.a31 + this.a21 * other.a32 + this.a31 * other.a33, this.a12 * other.a11 + this.a22 * other.a12 + this.a32 * other.a13, this.a12 * other.a21 + this.a22 * other.a22 + this.a32 * other.a23, this.a12 * other.a31 + this.a22 * other.a32 + this.a32 * other.a33, this.a13 * other.a11 + this.a23 * other.a12 + this.a33 * other.a13, this.a13 * other.a21 + this.a23 * other.a22 + this.a33 * other.a23, this.a13 * other.a31 + this.a23 * other.a32 + this.a33 * other.a33);
      }
    }
    class DefaultGridSampler extends GridSampler {
      /*@Override*/
      sampleGrid(image, dimensionX, dimensionY, p1ToX, p1ToY, p2ToX, p2ToY, p3ToX, p3ToY, p4ToX, p4ToY, p1FromX, p1FromY, p2FromX, p2FromY, p3FromX, p3FromY, p4FromX, p4FromY) {
        const transform = PerspectiveTransform.quadrilateralToQuadrilateral(p1ToX, p1ToY, p2ToX, p2ToY, p3ToX, p3ToY, p4ToX, p4ToY, p1FromX, p1FromY, p2FromX, p2FromY, p3FromX, p3FromY, p4FromX, p4FromY);
        return this.sampleGridWithTransform(image, dimensionX, dimensionY, transform);
      }
      /*@Override*/
      sampleGridWithTransform(image, dimensionX, dimensionY, transform) {
        if (dimensionX <= 0 || dimensionY <= 0) {
          throw new NotFoundException();
        }
        const bits = new BitMatrix(dimensionX, dimensionY);
        const points = new Float32Array(2 * dimensionX);
        for (let y = 0; y < dimensionY; y++) {
          const max2 = points.length;
          const iValue = y + 0.5;
          for (let x2 = 0; x2 < max2; x2 += 2) {
            points[x2] = x2 / 2 + 0.5;
            points[x2 + 1] = iValue;
          }
          transform.transformPoints(points);
          GridSampler.checkAndNudgePoints(image, points);
          try {
            for (let x2 = 0; x2 < max2; x2 += 2) {
              if (image.get(Math.floor(points[x2]), Math.floor(points[x2 + 1]))) {
                bits.set(x2 / 2, y);
              }
            }
          } catch (aioobe) {
            throw new NotFoundException();
          }
        }
        return bits;
      }
    }
    class GridSamplerInstance {
      /**
       * Sets the implementation of GridSampler used by the library. One global
       * instance is stored, which may sound problematic. But, the implementation provided
       * ought to be appropriate for the entire platform, and all uses of this library
       * in the whole lifetime of the JVM. For instance, an Android activity can swap in
       * an implementation that takes advantage of native platform libraries.
       *
       * @param newGridSampler The platform-specific object to install.
       */
      static setGridSampler(newGridSampler) {
        GridSamplerInstance.gridSampler = newGridSampler;
      }
      /**
       * @return the current implementation of GridSampler
       */
      static getInstance() {
        return GridSamplerInstance.gridSampler;
      }
    }
    GridSamplerInstance.gridSampler = new DefaultGridSampler();
    class Point {
      constructor(x2, y) {
        this.x = x2;
        this.y = y;
      }
      toResultPoint() {
        return new ResultPoint(this.getX(), this.getY());
      }
      getX() {
        return this.x;
      }
      getY() {
        return this.y;
      }
    }
    class Detector {
      constructor(image) {
        this.EXPECTED_CORNER_BITS = new Int32Array([
          3808,
          476,
          2107,
          1799
        ]);
        this.image = image;
      }
      detect() {
        return this.detectMirror(false);
      }
      /**
       * Detects an Aztec Code in an image.
       *
       * @param isMirror if true, image is a mirror-image of original
       * @return {@link AztecDetectorResult} encapsulating results of detecting an Aztec Code
       * @throws NotFoundException if no Aztec Code can be found
       */
      detectMirror(isMirror) {
        let pCenter = this.getMatrixCenter();
        let bullsEyeCorners = this.getBullsEyeCorners(pCenter);
        if (isMirror) {
          let temp = bullsEyeCorners[0];
          bullsEyeCorners[0] = bullsEyeCorners[2];
          bullsEyeCorners[2] = temp;
        }
        this.extractParameters(bullsEyeCorners);
        let bits = this.sampleGrid(this.image, bullsEyeCorners[this.shift % 4], bullsEyeCorners[(this.shift + 1) % 4], bullsEyeCorners[(this.shift + 2) % 4], bullsEyeCorners[(this.shift + 3) % 4]);
        let corners = this.getMatrixCornerPoints(bullsEyeCorners);
        return new AztecDetectorResult(bits, corners, this.compact, this.nbDataBlocks, this.nbLayers);
      }
      /**
       * Extracts the number of data layers and data blocks from the layer around the bull's eye.
       *
       * @param bullsEyeCorners the array of bull's eye corners
       * @throws NotFoundException in case of too many errors or invalid parameters
       */
      extractParameters(bullsEyeCorners) {
        if (!this.isValidPoint(bullsEyeCorners[0]) || !this.isValidPoint(bullsEyeCorners[1]) || !this.isValidPoint(bullsEyeCorners[2]) || !this.isValidPoint(bullsEyeCorners[3])) {
          throw new NotFoundException();
        }
        let length = 2 * this.nbCenterLayers;
        let sides2 = new Int32Array([
          this.sampleLine(bullsEyeCorners[0], bullsEyeCorners[1], length),
          this.sampleLine(bullsEyeCorners[1], bullsEyeCorners[2], length),
          this.sampleLine(bullsEyeCorners[2], bullsEyeCorners[3], length),
          this.sampleLine(bullsEyeCorners[3], bullsEyeCorners[0], length)
          // Top
        ]);
        this.shift = this.getRotation(sides2, length);
        let parameterData = 0;
        for (let i2 = 0; i2 < 4; i2++) {
          let side = sides2[(this.shift + i2) % 4];
          if (this.compact) {
            parameterData <<= 7;
            parameterData += side >> 1 & 127;
          } else {
            parameterData <<= 10;
            parameterData += (side >> 2 & 31 << 5) + (side >> 1 & 31);
          }
        }
        let correctedData = this.getCorrectedParameterData(parameterData, this.compact);
        if (this.compact) {
          this.nbLayers = (correctedData >> 6) + 1;
          this.nbDataBlocks = (correctedData & 63) + 1;
        } else {
          this.nbLayers = (correctedData >> 11) + 1;
          this.nbDataBlocks = (correctedData & 2047) + 1;
        }
      }
      getRotation(sides2, length) {
        let cornerBits = 0;
        sides2.forEach((side, idx, arr) => {
          let t3 = (side >> length - 2 << 1) + (side & 1);
          cornerBits = (cornerBits << 3) + t3;
        });
        cornerBits = ((cornerBits & 1) << 11) + (cornerBits >> 1);
        for (let shift2 = 0; shift2 < 4; shift2++) {
          if (Integer.bitCount(cornerBits ^ this.EXPECTED_CORNER_BITS[shift2]) <= 2) {
            return shift2;
          }
        }
        throw new NotFoundException();
      }
      /**
       * Corrects the parameter bits using Reed-Solomon algorithm.
       *
       * @param parameterData parameter bits
       * @param compact true if this is a compact Aztec code
       * @throws NotFoundException if the array contains too many errors
       */
      getCorrectedParameterData(parameterData, compact) {
        let numCodewords;
        let numDataCodewords;
        if (compact) {
          numCodewords = 7;
          numDataCodewords = 2;
        } else {
          numCodewords = 10;
          numDataCodewords = 4;
        }
        let numECCodewords = numCodewords - numDataCodewords;
        let parameterWords = new Int32Array(numCodewords);
        for (let i2 = numCodewords - 1; i2 >= 0; --i2) {
          parameterWords[i2] = parameterData & 15;
          parameterData >>= 4;
        }
        try {
          let rsDecoder = new ReedSolomonDecoder(GenericGF.AZTEC_PARAM);
          rsDecoder.decode(parameterWords, numECCodewords);
        } catch (ignored) {
          throw new NotFoundException();
        }
        let result2 = 0;
        for (let i2 = 0; i2 < numDataCodewords; i2++) {
          result2 = (result2 << 4) + parameterWords[i2];
        }
        return result2;
      }
      /**
       * Finds the corners of a bull-eye centered on the passed point.
       * This returns the centers of the diagonal points just outside the bull's eye
       * Returns [topRight, bottomRight, bottomLeft, topLeft]
       *
       * @param pCenter Center point
       * @return The corners of the bull-eye
       * @throws NotFoundException If no valid bull-eye can be found
       */
      getBullsEyeCorners(pCenter) {
        let pina = pCenter;
        let pinb = pCenter;
        let pinc = pCenter;
        let pind = pCenter;
        let color2 = true;
        for (this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++) {
          let pouta = this.getFirstDifferent(pina, color2, 1, -1);
          let poutb = this.getFirstDifferent(pinb, color2, 1, 1);
          let poutc = this.getFirstDifferent(pinc, color2, -1, 1);
          let poutd = this.getFirstDifferent(pind, color2, -1, -1);
          if (this.nbCenterLayers > 2) {
            let q = this.distancePoint(poutd, pouta) * this.nbCenterLayers / (this.distancePoint(pind, pina) * (this.nbCenterLayers + 2));
            if (q < 0.75 || q > 1.25 || !this.isWhiteOrBlackRectangle(pouta, poutb, poutc, poutd)) {
              break;
            }
          }
          pina = pouta;
          pinb = poutb;
          pinc = poutc;
          pind = poutd;
          color2 = !color2;
        }
        if (this.nbCenterLayers !== 5 && this.nbCenterLayers !== 7) {
          throw new NotFoundException();
        }
        this.compact = this.nbCenterLayers === 5;
        let pinax = new ResultPoint(pina.getX() + 0.5, pina.getY() - 0.5);
        let pinbx = new ResultPoint(pinb.getX() + 0.5, pinb.getY() + 0.5);
        let pincx = new ResultPoint(pinc.getX() - 0.5, pinc.getY() + 0.5);
        let pindx = new ResultPoint(pind.getX() - 0.5, pind.getY() - 0.5);
        return this.expandSquare([pinax, pinbx, pincx, pindx], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
      }
      /**
       * Finds a candidate center point of an Aztec code from an image
       *
       * @return the center point
       */
      getMatrixCenter() {
        let pointA;
        let pointB;
        let pointC;
        let pointD;
        try {
          let cornerPoints = new WhiteRectangleDetector(this.image).detect();
          pointA = cornerPoints[0];
          pointB = cornerPoints[1];
          pointC = cornerPoints[2];
          pointD = cornerPoints[3];
        } catch (e) {
          let cx2 = this.image.getWidth() / 2;
          let cy2 = this.image.getHeight() / 2;
          pointA = this.getFirstDifferent(new Point(cx2 + 7, cy2 - 7), false, 1, -1).toResultPoint();
          pointB = this.getFirstDifferent(new Point(cx2 + 7, cy2 + 7), false, 1, 1).toResultPoint();
          pointC = this.getFirstDifferent(new Point(cx2 - 7, cy2 + 7), false, -1, 1).toResultPoint();
          pointD = this.getFirstDifferent(new Point(cx2 - 7, cy2 - 7), false, -1, -1).toResultPoint();
        }
        let cx = MathUtils2.round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4);
        let cy = MathUtils2.round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4);
        try {
          let cornerPoints = new WhiteRectangleDetector(this.image, 15, cx, cy).detect();
          pointA = cornerPoints[0];
          pointB = cornerPoints[1];
          pointC = cornerPoints[2];
          pointD = cornerPoints[3];
        } catch (e) {
          pointA = this.getFirstDifferent(new Point(cx + 7, cy - 7), false, 1, -1).toResultPoint();
          pointB = this.getFirstDifferent(new Point(cx + 7, cy + 7), false, 1, 1).toResultPoint();
          pointC = this.getFirstDifferent(new Point(cx - 7, cy + 7), false, -1, 1).toResultPoint();
          pointD = this.getFirstDifferent(new Point(cx - 7, cy - 7), false, -1, -1).toResultPoint();
        }
        cx = MathUtils2.round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4);
        cy = MathUtils2.round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4);
        return new Point(cx, cy);
      }
      /**
       * Gets the Aztec code corners from the bull's eye corners and the parameters.
       *
       * @param bullsEyeCorners the array of bull's eye corners
       * @return the array of aztec code corners
       */
      getMatrixCornerPoints(bullsEyeCorners) {
        return this.expandSquare(bullsEyeCorners, 2 * this.nbCenterLayers, this.getDimension());
      }
      /**
       * Creates a BitMatrix by sampling the provided image.
       * topLeft, topRight, bottomRight, and bottomLeft are the centers of the squares on the
       * diagonal just outside the bull's eye.
       */
      sampleGrid(image, topLeft, topRight, bottomRight, bottomLeft) {
        let sampler = GridSamplerInstance.getInstance();
        let dimension = this.getDimension();
        let low = dimension / 2 - this.nbCenterLayers;
        let high = dimension / 2 + this.nbCenterLayers;
        return sampler.sampleGrid(
          image,
          dimension,
          dimension,
          low,
          low,
          // topleft
          high,
          low,
          // topright
          high,
          high,
          // bottomright
          low,
          high,
          // bottomleft
          topLeft.getX(),
          topLeft.getY(),
          topRight.getX(),
          topRight.getY(),
          bottomRight.getX(),
          bottomRight.getY(),
          bottomLeft.getX(),
          bottomLeft.getY()
        );
      }
      /**
       * Samples a line.
       *
       * @param p1   start point (inclusive)
       * @param p2   end point (exclusive)
       * @param size number of bits
       * @return the array of bits as an int (first bit is high-order bit of result)
       */
      sampleLine(p1, p2, size) {
        let result2 = 0;
        let d2 = this.distanceResultPoint(p1, p2);
        let moduleSize = d2 / size;
        let px = p1.getX();
        let py = p1.getY();
        let dx = moduleSize * (p2.getX() - p1.getX()) / d2;
        let dy = moduleSize * (p2.getY() - p1.getY()) / d2;
        for (let i2 = 0; i2 < size; i2++) {
          if (this.image.get(MathUtils2.round(px + i2 * dx), MathUtils2.round(py + i2 * dy))) {
            result2 |= 1 << size - i2 - 1;
          }
        }
        return result2;
      }
      /**
       * @return true if the border of the rectangle passed in parameter is compound of white points only
       *         or black points only
       */
      isWhiteOrBlackRectangle(p1, p2, p3, p4) {
        let corr = 3;
        p1 = new Point(p1.getX() - corr, p1.getY() + corr);
        p2 = new Point(p2.getX() - corr, p2.getY() - corr);
        p3 = new Point(p3.getX() + corr, p3.getY() - corr);
        p4 = new Point(p4.getX() + corr, p4.getY() + corr);
        let cInit = this.getColor(p4, p1);
        if (cInit === 0) {
          return false;
        }
        let c = this.getColor(p1, p2);
        if (c !== cInit) {
          return false;
        }
        c = this.getColor(p2, p3);
        if (c !== cInit) {
          return false;
        }
        c = this.getColor(p3, p4);
        return c === cInit;
      }
      /**
       * Gets the color of a segment
       *
       * @return 1 if segment more than 90% black, -1 if segment is more than 90% white, 0 else
       */
      getColor(p1, p2) {
        let d2 = this.distancePoint(p1, p2);
        let dx = (p2.getX() - p1.getX()) / d2;
        let dy = (p2.getY() - p1.getY()) / d2;
        let error2 = 0;
        let px = p1.getX();
        let py = p1.getY();
        let colorModel = this.image.get(p1.getX(), p1.getY());
        let iMax = Math.ceil(d2);
        for (let i2 = 0; i2 < iMax; i2++) {
          px += dx;
          py += dy;
          if (this.image.get(MathUtils2.round(px), MathUtils2.round(py)) !== colorModel) {
            error2++;
          }
        }
        let errRatio = error2 / d2;
        if (errRatio > 0.1 && errRatio < 0.9) {
          return 0;
        }
        return errRatio <= 0.1 === colorModel ? 1 : -1;
      }
      /**
       * Gets the coordinate of the first point with a different color in the given direction
       */
      getFirstDifferent(init2, color2, dx, dy) {
        let x2 = init2.getX() + dx;
        let y = init2.getY() + dy;
        while (this.isValid(x2, y) && this.image.get(x2, y) === color2) {
          x2 += dx;
          y += dy;
        }
        x2 -= dx;
        y -= dy;
        while (this.isValid(x2, y) && this.image.get(x2, y) === color2) {
          x2 += dx;
        }
        x2 -= dx;
        while (this.isValid(x2, y) && this.image.get(x2, y) === color2) {
          y += dy;
        }
        y -= dy;
        return new Point(x2, y);
      }
      /**
       * Expand the square represented by the corner points by pushing out equally in all directions
       *
       * @param cornerPoints the corners of the square, which has the bull's eye at its center
       * @param oldSide the original length of the side of the square in the target bit matrix
       * @param newSide the new length of the size of the square in the target bit matrix
       * @return the corners of the expanded square
       */
      expandSquare(cornerPoints, oldSide, newSide) {
        let ratio = newSide / (2 * oldSide);
        let dx = cornerPoints[0].getX() - cornerPoints[2].getX();
        let dy = cornerPoints[0].getY() - cornerPoints[2].getY();
        let centerx = (cornerPoints[0].getX() + cornerPoints[2].getX()) / 2;
        let centery = (cornerPoints[0].getY() + cornerPoints[2].getY()) / 2;
        let result0 = new ResultPoint(centerx + ratio * dx, centery + ratio * dy);
        let result2 = new ResultPoint(centerx - ratio * dx, centery - ratio * dy);
        dx = cornerPoints[1].getX() - cornerPoints[3].getX();
        dy = cornerPoints[1].getY() - cornerPoints[3].getY();
        centerx = (cornerPoints[1].getX() + cornerPoints[3].getX()) / 2;
        centery = (cornerPoints[1].getY() + cornerPoints[3].getY()) / 2;
        let result1 = new ResultPoint(centerx + ratio * dx, centery + ratio * dy);
        let result3 = new ResultPoint(centerx - ratio * dx, centery - ratio * dy);
        let results = [result0, result1, result2, result3];
        return results;
      }
      isValid(x2, y) {
        return x2 >= 0 && x2 < this.image.getWidth() && y > 0 && y < this.image.getHeight();
      }
      isValidPoint(point) {
        let x2 = MathUtils2.round(point.getX());
        let y = MathUtils2.round(point.getY());
        return this.isValid(x2, y);
      }
      distancePoint(a, b) {
        return MathUtils2.distance(a.getX(), a.getY(), b.getX(), b.getY());
      }
      distanceResultPoint(a, b) {
        return MathUtils2.distance(a.getX(), a.getY(), b.getX(), b.getY());
      }
      getDimension() {
        if (this.compact) {
          return 4 * this.nbLayers + 11;
        }
        if (this.nbLayers <= 4) {
          return 4 * this.nbLayers + 15;
        }
        return 4 * this.nbLayers + 2 * (Integer.truncDivision(this.nbLayers - 4, 8) + 1) + 15;
      }
    }
    class AztecReader {
      /**
       * Locates and decodes a Data Matrix code in an image.
       *
       * @return a String representing the content encoded by the Data Matrix code
       * @throws NotFoundException if a Data Matrix code cannot be found
       * @throws FormatException if a Data Matrix code cannot be decoded
       */
      decode(image, hints = null) {
        let exception = null;
        let detector = new Detector(image.getBlackMatrix());
        let points = null;
        let decoderResult = null;
        try {
          let detectorResult = detector.detectMirror(false);
          points = detectorResult.getPoints();
          this.reportFoundResultPoints(hints, points);
          decoderResult = new Decoder().decode(detectorResult);
        } catch (e) {
          exception = e;
        }
        if (decoderResult == null) {
          try {
            let detectorResult = detector.detectMirror(true);
            points = detectorResult.getPoints();
            this.reportFoundResultPoints(hints, points);
            decoderResult = new Decoder().decode(detectorResult);
          } catch (e) {
            if (exception != null) {
              throw exception;
            }
            throw e;
          }
        }
        let result2 = new Result3(decoderResult.getText(), decoderResult.getRawBytes(), decoderResult.getNumBits(), points, BarcodeFormat$1.AZTEC, System.currentTimeMillis());
        let byteSegments = decoderResult.getByteSegments();
        if (byteSegments != null) {
          result2.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
        }
        let ecLevel = decoderResult.getECLevel();
        if (ecLevel != null) {
          result2.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
        }
        return result2;
      }
      reportFoundResultPoints(hints, points) {
        if (hints != null) {
          let rpcb = hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
          if (rpcb != null) {
            points.forEach((point, idx, arr) => {
              rpcb.foundPossibleResultPoint(point);
            });
          }
        }
      }
      // @Override
      reset() {
      }
    }
    class BrowserAztecCodeReader extends BrowserCodeReader {
      /**
       * Creates an instance of BrowserAztecCodeReader.
       * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
       *
       * @memberOf BrowserAztecCodeReader
       */
      constructor(timeBetweenScansMillis = 500) {
        super(new AztecReader(), timeBetweenScansMillis);
      }
    }
    class OneDReader {
      /*
      @Override
      public Result decode(BinaryBitmap image) throws NotFoundException, FormatException {
        return decode(image, null);
      }
      */
      // Note that we don't try rotation without the try harder flag, even if rotation was supported.
      // @Override
      decode(image, hints) {
        try {
          return this.doDecode(image, hints);
        } catch (nfe) {
          const tryHarder = hints && hints.get(DecodeHintType$1.TRY_HARDER) === true;
          if (tryHarder && image.isRotateSupported()) {
            const rotatedImage = image.rotateCounterClockwise();
            const result2 = this.doDecode(rotatedImage, hints);
            const metadata = result2.getResultMetadata();
            let orientation = 270;
            if (metadata !== null && metadata.get(ResultMetadataType$1.ORIENTATION) === true) {
              orientation = orientation + metadata.get(ResultMetadataType$1.ORIENTATION) % 360;
            }
            result2.putMetadata(ResultMetadataType$1.ORIENTATION, orientation);
            const points = result2.getResultPoints();
            if (points !== null) {
              const height = rotatedImage.getHeight();
              for (let i2 = 0; i2 < points.length; i2++) {
                points[i2] = new ResultPoint(height - points[i2].getY() - 1, points[i2].getX());
              }
            }
            return result2;
          } else {
            throw new NotFoundException();
          }
        }
      }
      // @Override
      reset() {
      }
      /**
       * We're going to examine rows from the middle outward, searching alternately above and below the
       * middle, and farther out each time. rowStep is the number of rows between each successive
       * attempt above and below the middle. So we'd scan row middle, then middle - rowStep, then
       * middle + rowStep, then middle - (2 * rowStep), etc.
       * rowStep is bigger as the image is taller, but is always at least 1. We've somewhat arbitrarily
       * decided that moving up and down by about 1/16 of the image is pretty good; we try more of the
       * image if "trying harder".
       *
       * @param image The image to decode
       * @param hints Any hints that were requested
       * @return The contents of the decoded barcode
       * @throws NotFoundException Any spontaneous errors which occur
       */
      doDecode(image, hints) {
        const width = image.getWidth();
        const height = image.getHeight();
        let row = new BitArray(width);
        const tryHarder = hints && hints.get(DecodeHintType$1.TRY_HARDER) === true;
        const rowStep = Math.max(1, height >> (tryHarder ? 8 : 5));
        let maxLines;
        if (tryHarder) {
          maxLines = height;
        } else {
          maxLines = 15;
        }
        const middle = Math.trunc(height / 2);
        for (let x2 = 0; x2 < maxLines; x2++) {
          const rowStepsAboveOrBelow = Math.trunc((x2 + 1) / 2);
          const isAbove = (x2 & 1) === 0;
          const rowNumber = middle + rowStep * (isAbove ? rowStepsAboveOrBelow : -rowStepsAboveOrBelow);
          if (rowNumber < 0 || rowNumber >= height) {
            break;
          }
          try {
            row = image.getBlackRow(rowNumber, row);
          } catch (ignored) {
            continue;
          }
          for (let attempt = 0; attempt < 2; attempt++) {
            if (attempt === 1) {
              row.reverse();
              if (hints && hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK) === true) {
                const newHints = /* @__PURE__ */ new Map();
                hints.forEach((hint, key) => newHints.set(key, hint));
                newHints.delete(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                hints = newHints;
              }
            }
            try {
              const result2 = this.decodeRow(rowNumber, row, hints);
              if (attempt === 1) {
                result2.putMetadata(ResultMetadataType$1.ORIENTATION, 180);
                const points = result2.getResultPoints();
                if (points !== null) {
                  points[0] = new ResultPoint(width - points[0].getX() - 1, points[0].getY());
                  points[1] = new ResultPoint(width - points[1].getX() - 1, points[1].getY());
                }
              }
              return result2;
            } catch (re) {
            }
          }
        }
        throw new NotFoundException();
      }
      /**
       * Records the size of successive runs of white and black pixels in a row, starting at a given point.
       * The values are recorded in the given array, and the number of runs recorded is equal to the size
       * of the array. If the row starts on a white pixel at the given start point, then the first count
       * recorded is the run of white pixels starting from that point; likewise it is the count of a run
       * of black pixels if the row begin on a black pixels at that point.
       *
       * @param row row to count from
       * @param start offset into row to start at
       * @param counters array into which to record counts
       * @throws NotFoundException if counters cannot be filled entirely from row before running out
       *  of pixels
       */
      static recordPattern(row, start, counters) {
        const numCounters = counters.length;
        for (let index2 = 0; index2 < numCounters; index2++)
          counters[index2] = 0;
        const end = row.getSize();
        if (start >= end) {
          throw new NotFoundException();
        }
        let isWhite = !row.get(start);
        let counterPosition = 0;
        let i2 = start;
        while (i2 < end) {
          if (row.get(i2) !== isWhite) {
            counters[counterPosition]++;
          } else {
            if (++counterPosition === numCounters) {
              break;
            } else {
              counters[counterPosition] = 1;
              isWhite = !isWhite;
            }
          }
          i2++;
        }
        if (!(counterPosition === numCounters || counterPosition === numCounters - 1 && i2 === end)) {
          throw new NotFoundException();
        }
      }
      static recordPatternInReverse(row, start, counters) {
        let numTransitionsLeft = counters.length;
        let last2 = row.get(start);
        while (start > 0 && numTransitionsLeft >= 0) {
          if (row.get(--start) !== last2) {
            numTransitionsLeft--;
            last2 = !last2;
          }
        }
        if (numTransitionsLeft >= 0) {
          throw new NotFoundException();
        }
        OneDReader.recordPattern(row, start + 1, counters);
      }
      /**
       * Determines how closely a set of observed counts of runs of black/white values matches a given
       * target pattern. This is reported as the ratio of the total variance from the expected pattern
       * proportions across all pattern elements, to the length of the pattern.
       *
       * @param counters observed counters
       * @param pattern expected pattern
       * @param maxIndividualVariance The most any counter can differ before we give up
       * @return ratio of total variance between counters and pattern compared to total pattern size
       */
      static patternMatchVariance(counters, pattern, maxIndividualVariance) {
        const numCounters = counters.length;
        let total = 0;
        let patternLength = 0;
        for (let i2 = 0; i2 < numCounters; i2++) {
          total += counters[i2];
          patternLength += pattern[i2];
        }
        if (total < patternLength) {
          return Number.POSITIVE_INFINITY;
        }
        const unitBarWidth = total / patternLength;
        maxIndividualVariance *= unitBarWidth;
        let totalVariance = 0;
        for (let x2 = 0; x2 < numCounters; x2++) {
          const counter = counters[x2];
          const scaledPattern = pattern[x2] * unitBarWidth;
          const variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
          if (variance > maxIndividualVariance) {
            return Number.POSITIVE_INFINITY;
          }
          totalVariance += variance;
        }
        return totalVariance / total;
      }
    }
    class Code128Reader extends OneDReader {
      static findStartPattern(row) {
        const width = row.getSize();
        const rowOffset = row.getNextSet(0);
        let counterPosition = 0;
        let counters = Int32Array.from([0, 0, 0, 0, 0, 0]);
        let patternStart = rowOffset;
        let isWhite = false;
        const patternLength = 6;
        for (let i2 = rowOffset; i2 < width; i2++) {
          if (row.get(i2) !== isWhite) {
            counters[counterPosition]++;
          } else {
            if (counterPosition === patternLength - 1) {
              let bestVariance = Code128Reader.MAX_AVG_VARIANCE;
              let bestMatch = -1;
              for (let startCode = Code128Reader.CODE_START_A; startCode <= Code128Reader.CODE_START_C; startCode++) {
                const variance = OneDReader.patternMatchVariance(counters, Code128Reader.CODE_PATTERNS[startCode], Code128Reader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                  bestVariance = variance;
                  bestMatch = startCode;
                }
              }
              if (bestMatch >= 0 && row.isRange(Math.max(0, patternStart - (i2 - patternStart) / 2), patternStart, false)) {
                return Int32Array.from([patternStart, i2, bestMatch]);
              }
              patternStart += counters[0] + counters[1];
              counters = counters.slice(2, counters.length - 1);
              counters[counterPosition - 1] = 0;
              counters[counterPosition] = 0;
              counterPosition--;
            } else {
              counterPosition++;
            }
            counters[counterPosition] = 1;
            isWhite = !isWhite;
          }
        }
        throw new NotFoundException();
      }
      static decodeCode(row, counters, rowOffset) {
        OneDReader.recordPattern(row, rowOffset, counters);
        let bestVariance = Code128Reader.MAX_AVG_VARIANCE;
        let bestMatch = -1;
        for (let d2 = 0; d2 < Code128Reader.CODE_PATTERNS.length; d2++) {
          const pattern = Code128Reader.CODE_PATTERNS[d2];
          const variance = this.patternMatchVariance(counters, pattern, Code128Reader.MAX_INDIVIDUAL_VARIANCE);
          if (variance < bestVariance) {
            bestVariance = variance;
            bestMatch = d2;
          }
        }
        if (bestMatch >= 0) {
          return bestMatch;
        } else {
          throw new NotFoundException();
        }
      }
      decodeRow(rowNumber, row, hints) {
        const convertFNC1 = hints && hints.get(DecodeHintType$1.ASSUME_GS1) === true;
        const startPatternInfo = Code128Reader.findStartPattern(row);
        const startCode = startPatternInfo[2];
        let currentRawCodesIndex = 0;
        const rawCodes = new Uint8Array(20);
        rawCodes[currentRawCodesIndex++] = startCode;
        let codeSet;
        switch (startCode) {
          case Code128Reader.CODE_START_A:
            codeSet = Code128Reader.CODE_CODE_A;
            break;
          case Code128Reader.CODE_START_B:
            codeSet = Code128Reader.CODE_CODE_B;
            break;
          case Code128Reader.CODE_START_C:
            codeSet = Code128Reader.CODE_CODE_C;
            break;
          default:
            throw new FormatException();
        }
        let done = false;
        let isNextShifted = false;
        let result2 = "";
        let lastStart = startPatternInfo[0];
        let nextStart = startPatternInfo[1];
        const counters = Int32Array.from([0, 0, 0, 0, 0, 0]);
        let lastCode = 0;
        let code = 0;
        let checksumTotal = startCode;
        let multiplier = 0;
        let lastCharacterWasPrintable = true;
        let upperMode = false;
        let shiftUpperMode = false;
        while (!done) {
          const unshift = isNextShifted;
          isNextShifted = false;
          lastCode = code;
          code = Code128Reader.decodeCode(row, counters, nextStart);
          rawCodes[currentRawCodesIndex++] = code;
          if (code !== Code128Reader.CODE_STOP) {
            lastCharacterWasPrintable = true;
          }
          if (code !== Code128Reader.CODE_STOP) {
            multiplier++;
            checksumTotal += multiplier * code;
          }
          lastStart = nextStart;
          nextStart += counters.reduce((previous, current) => previous + current, 0);
          switch (code) {
            case Code128Reader.CODE_START_A:
            case Code128Reader.CODE_START_B:
            case Code128Reader.CODE_START_C:
              throw new FormatException();
          }
          switch (codeSet) {
            case Code128Reader.CODE_CODE_A:
              if (code < 64) {
                if (shiftUpperMode === upperMode) {
                  result2 += String.fromCharCode(" ".charCodeAt(0) + code);
                } else {
                  result2 += String.fromCharCode(" ".charCodeAt(0) + code + 128);
                }
                shiftUpperMode = false;
              } else if (code < 96) {
                if (shiftUpperMode === upperMode) {
                  result2 += String.fromCharCode(code - 64);
                } else {
                  result2 += String.fromCharCode(code + 64);
                }
                shiftUpperMode = false;
              } else {
                if (code !== Code128Reader.CODE_STOP) {
                  lastCharacterWasPrintable = false;
                }
                switch (code) {
                  case Code128Reader.CODE_FNC_1:
                    if (convertFNC1) {
                      if (result2.length === 0) {
                        result2 += "]C1";
                      } else {
                        result2 += String.fromCharCode(29);
                      }
                    }
                    break;
                  case Code128Reader.CODE_FNC_2:
                  case Code128Reader.CODE_FNC_3:
                    break;
                  case Code128Reader.CODE_FNC_4_A:
                    if (!upperMode && shiftUpperMode) {
                      upperMode = true;
                      shiftUpperMode = false;
                    } else if (upperMode && shiftUpperMode) {
                      upperMode = false;
                      shiftUpperMode = false;
                    } else {
                      shiftUpperMode = true;
                    }
                    break;
                  case Code128Reader.CODE_SHIFT:
                    isNextShifted = true;
                    codeSet = Code128Reader.CODE_CODE_B;
                    break;
                  case Code128Reader.CODE_CODE_B:
                    codeSet = Code128Reader.CODE_CODE_B;
                    break;
                  case Code128Reader.CODE_CODE_C:
                    codeSet = Code128Reader.CODE_CODE_C;
                    break;
                  case Code128Reader.CODE_STOP:
                    done = true;
                    break;
                }
              }
              break;
            case Code128Reader.CODE_CODE_B:
              if (code < 96) {
                if (shiftUpperMode === upperMode) {
                  result2 += String.fromCharCode(" ".charCodeAt(0) + code);
                } else {
                  result2 += String.fromCharCode(" ".charCodeAt(0) + code + 128);
                }
                shiftUpperMode = false;
              } else {
                if (code !== Code128Reader.CODE_STOP) {
                  lastCharacterWasPrintable = false;
                }
                switch (code) {
                  case Code128Reader.CODE_FNC_1:
                    if (convertFNC1) {
                      if (result2.length === 0) {
                        result2 += "]C1";
                      } else {
                        result2 += String.fromCharCode(29);
                      }
                    }
                    break;
                  case Code128Reader.CODE_FNC_2:
                  case Code128Reader.CODE_FNC_3:
                    break;
                  case Code128Reader.CODE_FNC_4_B:
                    if (!upperMode && shiftUpperMode) {
                      upperMode = true;
                      shiftUpperMode = false;
                    } else if (upperMode && shiftUpperMode) {
                      upperMode = false;
                      shiftUpperMode = false;
                    } else {
                      shiftUpperMode = true;
                    }
                    break;
                  case Code128Reader.CODE_SHIFT:
                    isNextShifted = true;
                    codeSet = Code128Reader.CODE_CODE_A;
                    break;
                  case Code128Reader.CODE_CODE_A:
                    codeSet = Code128Reader.CODE_CODE_A;
                    break;
                  case Code128Reader.CODE_CODE_C:
                    codeSet = Code128Reader.CODE_CODE_C;
                    break;
                  case Code128Reader.CODE_STOP:
                    done = true;
                    break;
                }
              }
              break;
            case Code128Reader.CODE_CODE_C:
              if (code < 100) {
                if (code < 10) {
                  result2 += "0";
                }
                result2 += code;
              } else {
                if (code !== Code128Reader.CODE_STOP) {
                  lastCharacterWasPrintable = false;
                }
                switch (code) {
                  case Code128Reader.CODE_FNC_1:
                    if (convertFNC1) {
                      if (result2.length === 0) {
                        result2 += "]C1";
                      } else {
                        result2 += String.fromCharCode(29);
                      }
                    }
                    break;
                  case Code128Reader.CODE_CODE_A:
                    codeSet = Code128Reader.CODE_CODE_A;
                    break;
                  case Code128Reader.CODE_CODE_B:
                    codeSet = Code128Reader.CODE_CODE_B;
                    break;
                  case Code128Reader.CODE_STOP:
                    done = true;
                    break;
                }
              }
              break;
          }
          if (unshift) {
            codeSet = codeSet === Code128Reader.CODE_CODE_A ? Code128Reader.CODE_CODE_B : Code128Reader.CODE_CODE_A;
          }
        }
        const lastPatternSize = nextStart - lastStart;
        nextStart = row.getNextUnset(nextStart);
        if (!row.isRange(nextStart, Math.min(row.getSize(), nextStart + (nextStart - lastStart) / 2), false)) {
          throw new NotFoundException();
        }
        checksumTotal -= multiplier * lastCode;
        if (checksumTotal % 103 !== lastCode) {
          throw new ChecksumException();
        }
        const resultLength = result2.length;
        if (resultLength === 0) {
          throw new NotFoundException();
        }
        if (resultLength > 0 && lastCharacterWasPrintable) {
          if (codeSet === Code128Reader.CODE_CODE_C) {
            result2 = result2.substring(0, resultLength - 2);
          } else {
            result2 = result2.substring(0, resultLength - 1);
          }
        }
        const left = (startPatternInfo[1] + startPatternInfo[0]) / 2;
        const right = lastStart + lastPatternSize / 2;
        const rawCodesSize = rawCodes.length;
        const rawBytes = new Uint8Array(rawCodesSize);
        for (let i2 = 0; i2 < rawCodesSize; i2++) {
          rawBytes[i2] = rawCodes[i2];
        }
        const points = [new ResultPoint(left, rowNumber), new ResultPoint(right, rowNumber)];
        return new Result3(result2, rawBytes, 0, points, BarcodeFormat$1.CODE_128, (/* @__PURE__ */ new Date()).getTime());
      }
    }
    Code128Reader.CODE_PATTERNS = [
      Int32Array.from([2, 1, 2, 2, 2, 2]),
      Int32Array.from([2, 2, 2, 1, 2, 2]),
      Int32Array.from([2, 2, 2, 2, 2, 1]),
      Int32Array.from([1, 2, 1, 2, 2, 3]),
      Int32Array.from([1, 2, 1, 3, 2, 2]),
      Int32Array.from([1, 3, 1, 2, 2, 2]),
      Int32Array.from([1, 2, 2, 2, 1, 3]),
      Int32Array.from([1, 2, 2, 3, 1, 2]),
      Int32Array.from([1, 3, 2, 2, 1, 2]),
      Int32Array.from([2, 2, 1, 2, 1, 3]),
      Int32Array.from([2, 2, 1, 3, 1, 2]),
      Int32Array.from([2, 3, 1, 2, 1, 2]),
      Int32Array.from([1, 1, 2, 2, 3, 2]),
      Int32Array.from([1, 2, 2, 1, 3, 2]),
      Int32Array.from([1, 2, 2, 2, 3, 1]),
      Int32Array.from([1, 1, 3, 2, 2, 2]),
      Int32Array.from([1, 2, 3, 1, 2, 2]),
      Int32Array.from([1, 2, 3, 2, 2, 1]),
      Int32Array.from([2, 2, 3, 2, 1, 1]),
      Int32Array.from([2, 2, 1, 1, 3, 2]),
      Int32Array.from([2, 2, 1, 2, 3, 1]),
      Int32Array.from([2, 1, 3, 2, 1, 2]),
      Int32Array.from([2, 2, 3, 1, 1, 2]),
      Int32Array.from([3, 1, 2, 1, 3, 1]),
      Int32Array.from([3, 1, 1, 2, 2, 2]),
      Int32Array.from([3, 2, 1, 1, 2, 2]),
      Int32Array.from([3, 2, 1, 2, 2, 1]),
      Int32Array.from([3, 1, 2, 2, 1, 2]),
      Int32Array.from([3, 2, 2, 1, 1, 2]),
      Int32Array.from([3, 2, 2, 2, 1, 1]),
      Int32Array.from([2, 1, 2, 1, 2, 3]),
      Int32Array.from([2, 1, 2, 3, 2, 1]),
      Int32Array.from([2, 3, 2, 1, 2, 1]),
      Int32Array.from([1, 1, 1, 3, 2, 3]),
      Int32Array.from([1, 3, 1, 1, 2, 3]),
      Int32Array.from([1, 3, 1, 3, 2, 1]),
      Int32Array.from([1, 1, 2, 3, 1, 3]),
      Int32Array.from([1, 3, 2, 1, 1, 3]),
      Int32Array.from([1, 3, 2, 3, 1, 1]),
      Int32Array.from([2, 1, 1, 3, 1, 3]),
      Int32Array.from([2, 3, 1, 1, 1, 3]),
      Int32Array.from([2, 3, 1, 3, 1, 1]),
      Int32Array.from([1, 1, 2, 1, 3, 3]),
      Int32Array.from([1, 1, 2, 3, 3, 1]),
      Int32Array.from([1, 3, 2, 1, 3, 1]),
      Int32Array.from([1, 1, 3, 1, 2, 3]),
      Int32Array.from([1, 1, 3, 3, 2, 1]),
      Int32Array.from([1, 3, 3, 1, 2, 1]),
      Int32Array.from([3, 1, 3, 1, 2, 1]),
      Int32Array.from([2, 1, 1, 3, 3, 1]),
      Int32Array.from([2, 3, 1, 1, 3, 1]),
      Int32Array.from([2, 1, 3, 1, 1, 3]),
      Int32Array.from([2, 1, 3, 3, 1, 1]),
      Int32Array.from([2, 1, 3, 1, 3, 1]),
      Int32Array.from([3, 1, 1, 1, 2, 3]),
      Int32Array.from([3, 1, 1, 3, 2, 1]),
      Int32Array.from([3, 3, 1, 1, 2, 1]),
      Int32Array.from([3, 1, 2, 1, 1, 3]),
      Int32Array.from([3, 1, 2, 3, 1, 1]),
      Int32Array.from([3, 3, 2, 1, 1, 1]),
      Int32Array.from([3, 1, 4, 1, 1, 1]),
      Int32Array.from([2, 2, 1, 4, 1, 1]),
      Int32Array.from([4, 3, 1, 1, 1, 1]),
      Int32Array.from([1, 1, 1, 2, 2, 4]),
      Int32Array.from([1, 1, 1, 4, 2, 2]),
      Int32Array.from([1, 2, 1, 1, 2, 4]),
      Int32Array.from([1, 2, 1, 4, 2, 1]),
      Int32Array.from([1, 4, 1, 1, 2, 2]),
      Int32Array.from([1, 4, 1, 2, 2, 1]),
      Int32Array.from([1, 1, 2, 2, 1, 4]),
      Int32Array.from([1, 1, 2, 4, 1, 2]),
      Int32Array.from([1, 2, 2, 1, 1, 4]),
      Int32Array.from([1, 2, 2, 4, 1, 1]),
      Int32Array.from([1, 4, 2, 1, 1, 2]),
      Int32Array.from([1, 4, 2, 2, 1, 1]),
      Int32Array.from([2, 4, 1, 2, 1, 1]),
      Int32Array.from([2, 2, 1, 1, 1, 4]),
      Int32Array.from([4, 1, 3, 1, 1, 1]),
      Int32Array.from([2, 4, 1, 1, 1, 2]),
      Int32Array.from([1, 3, 4, 1, 1, 1]),
      Int32Array.from([1, 1, 1, 2, 4, 2]),
      Int32Array.from([1, 2, 1, 1, 4, 2]),
      Int32Array.from([1, 2, 1, 2, 4, 1]),
      Int32Array.from([1, 1, 4, 2, 1, 2]),
      Int32Array.from([1, 2, 4, 1, 1, 2]),
      Int32Array.from([1, 2, 4, 2, 1, 1]),
      Int32Array.from([4, 1, 1, 2, 1, 2]),
      Int32Array.from([4, 2, 1, 1, 1, 2]),
      Int32Array.from([4, 2, 1, 2, 1, 1]),
      Int32Array.from([2, 1, 2, 1, 4, 1]),
      Int32Array.from([2, 1, 4, 1, 2, 1]),
      Int32Array.from([4, 1, 2, 1, 2, 1]),
      Int32Array.from([1, 1, 1, 1, 4, 3]),
      Int32Array.from([1, 1, 1, 3, 4, 1]),
      Int32Array.from([1, 3, 1, 1, 4, 1]),
      Int32Array.from([1, 1, 4, 1, 1, 3]),
      Int32Array.from([1, 1, 4, 3, 1, 1]),
      Int32Array.from([4, 1, 1, 1, 1, 3]),
      Int32Array.from([4, 1, 1, 3, 1, 1]),
      Int32Array.from([1, 1, 3, 1, 4, 1]),
      Int32Array.from([1, 1, 4, 1, 3, 1]),
      Int32Array.from([3, 1, 1, 1, 4, 1]),
      Int32Array.from([4, 1, 1, 1, 3, 1]),
      Int32Array.from([2, 1, 1, 4, 1, 2]),
      Int32Array.from([2, 1, 1, 2, 1, 4]),
      Int32Array.from([2, 1, 1, 2, 3, 2]),
      Int32Array.from([2, 3, 3, 1, 1, 1, 2])
    ];
    Code128Reader.MAX_AVG_VARIANCE = 0.25;
    Code128Reader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    Code128Reader.CODE_SHIFT = 98;
    Code128Reader.CODE_CODE_C = 99;
    Code128Reader.CODE_CODE_B = 100;
    Code128Reader.CODE_CODE_A = 101;
    Code128Reader.CODE_FNC_1 = 102;
    Code128Reader.CODE_FNC_2 = 97;
    Code128Reader.CODE_FNC_3 = 96;
    Code128Reader.CODE_FNC_4_A = 101;
    Code128Reader.CODE_FNC_4_B = 100;
    Code128Reader.CODE_START_A = 103;
    Code128Reader.CODE_START_B = 104;
    Code128Reader.CODE_START_C = 105;
    Code128Reader.CODE_STOP = 106;
    class Code39Reader extends OneDReader {
      /**
       * Creates a reader that assumes all encoded data is data, and does not treat the final
       * character as a check digit. It will not decoded "extended Code 39" sequences.
       */
      // public Code39Reader() {
      //   this(false);
      // }
      /**
       * Creates a reader that can be configured to check the last character as a check digit.
       * It will not decoded "extended Code 39" sequences.
       *
       * @param usingCheckDigit if true, treat the last data character as a check digit, not
       * data, and verify that the checksum passes.
       */
      // public Code39Reader(boolean usingCheckDigit) {
      //   this(usingCheckDigit, false);
      // }
      /**
       * Creates a reader that can be configured to check the last character as a check digit,
       * or optionally attempt to decode "extended Code 39" sequences that are used to encode
       * the full ASCII character set.
       *
       * @param usingCheckDigit if true, treat the last data character as a check digit, not
       * data, and verify that the checksum passes.
       * @param extendedMode if true, will attempt to decode extended Code 39 sequences in the
       * text.
       */
      constructor(usingCheckDigit = false, extendedMode = false) {
        super();
        this.usingCheckDigit = usingCheckDigit;
        this.extendedMode = extendedMode;
        this.decodeRowResult = "";
        this.counters = new Int32Array(9);
      }
      decodeRow(rowNumber, row, hints) {
        let theCounters = this.counters;
        theCounters.fill(0);
        this.decodeRowResult = "";
        let start = Code39Reader.findAsteriskPattern(row, theCounters);
        let nextStart = row.getNextSet(start[1]);
        let end = row.getSize();
        let decodedChar;
        let lastStart;
        do {
          Code39Reader.recordPattern(row, nextStart, theCounters);
          let pattern = Code39Reader.toNarrowWidePattern(theCounters);
          if (pattern < 0) {
            throw new NotFoundException();
          }
          decodedChar = Code39Reader.patternToChar(pattern);
          this.decodeRowResult += decodedChar;
          lastStart = nextStart;
          for (let counter of theCounters) {
            nextStart += counter;
          }
          nextStart = row.getNextSet(nextStart);
        } while (decodedChar !== "*");
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
        let lastPatternSize = 0;
        for (let counter of theCounters) {
          lastPatternSize += counter;
        }
        let whiteSpaceAfterEnd = nextStart - lastStart - lastPatternSize;
        if (nextStart !== end && whiteSpaceAfterEnd * 2 < lastPatternSize) {
          throw new NotFoundException();
        }
        if (this.usingCheckDigit) {
          let max2 = this.decodeRowResult.length - 1;
          let total = 0;
          for (let i2 = 0; i2 < max2; i2++) {
            total += Code39Reader.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(i2));
          }
          if (this.decodeRowResult.charAt(max2) !== Code39Reader.ALPHABET_STRING.charAt(total % 43)) {
            throw new ChecksumException();
          }
          this.decodeRowResult = this.decodeRowResult.substring(0, max2);
        }
        if (this.decodeRowResult.length === 0) {
          throw new NotFoundException();
        }
        let resultString;
        if (this.extendedMode) {
          resultString = Code39Reader.decodeExtended(this.decodeRowResult);
        } else {
          resultString = this.decodeRowResult;
        }
        let left = (start[1] + start[0]) / 2;
        let right = lastStart + lastPatternSize / 2;
        return new Result3(resultString, null, 0, [new ResultPoint(left, rowNumber), new ResultPoint(right, rowNumber)], BarcodeFormat$1.CODE_39, (/* @__PURE__ */ new Date()).getTime());
      }
      static findAsteriskPattern(row, counters) {
        let width = row.getSize();
        let rowOffset = row.getNextSet(0);
        let counterPosition = 0;
        let patternStart = rowOffset;
        let isWhite = false;
        let patternLength = counters.length;
        for (let i2 = rowOffset; i2 < width; i2++) {
          if (row.get(i2) !== isWhite) {
            counters[counterPosition]++;
          } else {
            if (counterPosition === patternLength - 1) {
              if (this.toNarrowWidePattern(counters) === Code39Reader.ASTERISK_ENCODING && row.isRange(Math.max(0, patternStart - Math.floor((i2 - patternStart) / 2)), patternStart, false)) {
                return [patternStart, i2];
              }
              patternStart += counters[0] + counters[1];
              counters.copyWithin(0, 2, 2 + counterPosition - 1);
              counters[counterPosition - 1] = 0;
              counters[counterPosition] = 0;
              counterPosition--;
            } else {
              counterPosition++;
            }
            counters[counterPosition] = 1;
            isWhite = !isWhite;
          }
        }
        throw new NotFoundException();
      }
      // For efficiency, returns -1 on failure. Not throwing here saved as many as 700 exceptions
      // per image when using some of our blackbox images.
      static toNarrowWidePattern(counters) {
        let numCounters = counters.length;
        let maxNarrowCounter = 0;
        let wideCounters;
        do {
          let minCounter = 2147483647;
          for (let counter of counters) {
            if (counter < minCounter && counter > maxNarrowCounter) {
              minCounter = counter;
            }
          }
          maxNarrowCounter = minCounter;
          wideCounters = 0;
          let totalWideCountersWidth = 0;
          let pattern = 0;
          for (let i2 = 0; i2 < numCounters; i2++) {
            let counter = counters[i2];
            if (counter > maxNarrowCounter) {
              pattern |= 1 << numCounters - 1 - i2;
              wideCounters++;
              totalWideCountersWidth += counter;
            }
          }
          if (wideCounters === 3) {
            for (let i2 = 0; i2 < numCounters && wideCounters > 0; i2++) {
              let counter = counters[i2];
              if (counter > maxNarrowCounter) {
                wideCounters--;
                if (counter * 2 >= totalWideCountersWidth) {
                  return -1;
                }
              }
            }
            return pattern;
          }
        } while (wideCounters > 3);
        return -1;
      }
      static patternToChar(pattern) {
        for (let i2 = 0; i2 < Code39Reader.CHARACTER_ENCODINGS.length; i2++) {
          if (Code39Reader.CHARACTER_ENCODINGS[i2] === pattern) {
            return Code39Reader.ALPHABET_STRING.charAt(i2);
          }
        }
        if (pattern === Code39Reader.ASTERISK_ENCODING) {
          return "*";
        }
        throw new NotFoundException();
      }
      static decodeExtended(encoded) {
        let length = encoded.length;
        let decoded = "";
        for (let i2 = 0; i2 < length; i2++) {
          let c = encoded.charAt(i2);
          if (c === "+" || c === "$" || c === "%" || c === "/") {
            let next = encoded.charAt(i2 + 1);
            let decodedChar = "\0";
            switch (c) {
              case "+":
                if (next >= "A" && next <= "Z") {
                  decodedChar = String.fromCharCode(next.charCodeAt(0) + 32);
                } else {
                  throw new FormatException();
                }
                break;
              case "$":
                if (next >= "A" && next <= "Z") {
                  decodedChar = String.fromCharCode(next.charCodeAt(0) - 64);
                } else {
                  throw new FormatException();
                }
                break;
              case "%":
                if (next >= "A" && next <= "E") {
                  decodedChar = String.fromCharCode(next.charCodeAt(0) - 38);
                } else if (next >= "F" && next <= "J") {
                  decodedChar = String.fromCharCode(next.charCodeAt(0) - 11);
                } else if (next >= "K" && next <= "O") {
                  decodedChar = String.fromCharCode(next.charCodeAt(0) + 16);
                } else if (next >= "P" && next <= "T") {
                  decodedChar = String.fromCharCode(next.charCodeAt(0) + 43);
                } else if (next === "U") {
                  decodedChar = "\0";
                } else if (next === "V") {
                  decodedChar = "@";
                } else if (next === "W") {
                  decodedChar = "`";
                } else if (next === "X" || next === "Y" || next === "Z") {
                  decodedChar = "";
                } else {
                  throw new FormatException();
                }
                break;
              case "/":
                if (next >= "A" && next <= "O") {
                  decodedChar = String.fromCharCode(next.charCodeAt(0) - 32);
                } else if (next === "Z") {
                  decodedChar = ":";
                } else {
                  throw new FormatException();
                }
                break;
            }
            decoded += decodedChar;
            i2++;
          } else {
            decoded += c;
          }
        }
        return decoded;
      }
    }
    Code39Reader.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%";
    Code39Reader.CHARACTER_ENCODINGS = [
      52,
      289,
      97,
      352,
      49,
      304,
      112,
      37,
      292,
      100,
      265,
      73,
      328,
      25,
      280,
      88,
      13,
      268,
      76,
      28,
      259,
      67,
      322,
      19,
      274,
      82,
      7,
      262,
      70,
      22,
      385,
      193,
      448,
      145,
      400,
      208,
      133,
      388,
      196,
      168,
      162,
      138,
      42
      // /-%
    ];
    Code39Reader.ASTERISK_ENCODING = 148;
    class ITFReader extends OneDReader {
      constructor() {
        super(...arguments);
        this.narrowLineWidth = -1;
      }
      // See ITFWriter.PATTERNS
      /*
      
        /!**
         * Patterns of Wide / Narrow lines to indicate each digit
         *!/
        */
      decodeRow(rowNumber, row, hints) {
        let startRange = this.decodeStart(row);
        let endRange = this.decodeEnd(row);
        let result2 = new StringBuilder();
        ITFReader.decodeMiddle(row, startRange[1], endRange[0], result2);
        let resultString = result2.toString();
        let allowedLengths = null;
        if (hints != null) {
          allowedLengths = hints.get(DecodeHintType$1.ALLOWED_LENGTHS);
        }
        if (allowedLengths == null) {
          allowedLengths = ITFReader.DEFAULT_ALLOWED_LENGTHS;
        }
        let length = resultString.length;
        let lengthOK = false;
        let maxAllowedLength = 0;
        for (let value of allowedLengths) {
          if (length === value) {
            lengthOK = true;
            break;
          }
          if (value > maxAllowedLength) {
            maxAllowedLength = value;
          }
        }
        if (!lengthOK && length > maxAllowedLength) {
          lengthOK = true;
        }
        if (!lengthOK) {
          throw new FormatException();
        }
        const points = [new ResultPoint(startRange[1], rowNumber), new ResultPoint(endRange[0], rowNumber)];
        let resultReturn = new Result3(
          resultString,
          null,
          // no natural byte representation for these barcodes
          0,
          points,
          BarcodeFormat$1.ITF,
          (/* @__PURE__ */ new Date()).getTime()
        );
        return resultReturn;
      }
      /*
      /!**
       * @param row          row of black/white values to search
       * @param payloadStart offset of start pattern
       * @param resultString {@link StringBuilder} to append decoded chars to
       * @throws NotFoundException if decoding could not complete successfully
       *!/*/
      static decodeMiddle(row, payloadStart, payloadEnd, resultString) {
        let counterDigitPair = new Int32Array(10);
        let counterBlack = new Int32Array(5);
        let counterWhite = new Int32Array(5);
        counterDigitPair.fill(0);
        counterBlack.fill(0);
        counterWhite.fill(0);
        while (payloadStart < payloadEnd) {
          OneDReader.recordPattern(row, payloadStart, counterDigitPair);
          for (let k = 0; k < 5; k++) {
            let twoK = 2 * k;
            counterBlack[k] = counterDigitPair[twoK];
            counterWhite[k] = counterDigitPair[twoK + 1];
          }
          let bestMatch = ITFReader.decodeDigit(counterBlack);
          resultString.append(bestMatch.toString());
          bestMatch = this.decodeDigit(counterWhite);
          resultString.append(bestMatch.toString());
          counterDigitPair.forEach(function(counterDigit) {
            payloadStart += counterDigit;
          });
        }
      }
      /*/!**
       * Identify where the start of the middle / payload section starts.
       *
       * @param row row of black/white values to search
       * @return Array, containing index of start of 'start block' and end of
       *         'start block'
       *!/*/
      decodeStart(row) {
        let endStart = ITFReader.skipWhiteSpace(row);
        let startPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.START_PATTERN);
        this.narrowLineWidth = (startPattern[1] - startPattern[0]) / 4;
        this.validateQuietZone(row, startPattern[0]);
        return startPattern;
      }
      /*/!**
       * The start & end patterns must be pre/post fixed by a quiet zone. This
       * zone must be at least 10 times the width of a narrow line.  Scan back until
       * we either get to the start of the barcode or match the necessary number of
       * quiet zone pixels.
       *
       * Note: Its assumed the row is reversed when using this method to find
       * quiet zone after the end pattern.
       *
       * ref: http://www.barcode-1.net/i25code.html
       *
       * @param row bit array representing the scanned barcode.
       * @param startPattern index into row of the start or end pattern.
       * @throws NotFoundException if the quiet zone cannot be found
       *!/*/
      validateQuietZone(row, startPattern) {
        let quietCount = this.narrowLineWidth * 10;
        quietCount = quietCount < startPattern ? quietCount : startPattern;
        for (let i2 = startPattern - 1; quietCount > 0 && i2 >= 0; i2--) {
          if (row.get(i2)) {
            break;
          }
          quietCount--;
        }
        if (quietCount !== 0) {
          throw new NotFoundException();
        }
      }
      /*
      /!**
       * Skip all whitespace until we get to the first black line.
       *
       * @param row row of black/white values to search
       * @return index of the first black line.
       * @throws NotFoundException Throws exception if no black lines are found in the row
       *!/*/
      static skipWhiteSpace(row) {
        const width = row.getSize();
        const endStart = row.getNextSet(0);
        if (endStart === width) {
          throw new NotFoundException();
        }
        return endStart;
      }
      /*/!**
       * Identify where the end of the middle / payload section ends.
       *
       * @param row row of black/white values to search
       * @return Array, containing index of start of 'end block' and end of 'end
       *         block'
       *!/*/
      decodeEnd(row) {
        row.reverse();
        try {
          let endStart = ITFReader.skipWhiteSpace(row);
          let endPattern;
          try {
            endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[0]);
          } catch (error2) {
            if (error2 instanceof NotFoundException) {
              endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[1]);
            }
          }
          this.validateQuietZone(row, endPattern[0]);
          let temp = endPattern[0];
          endPattern[0] = row.getSize() - endPattern[1];
          endPattern[1] = row.getSize() - temp;
          return endPattern;
        } finally {
          row.reverse();
        }
      }
      /*
      /!**
       * @param row       row of black/white values to search
       * @param rowOffset position to start search
       * @param pattern   pattern of counts of number of black and white pixels that are
       *                  being searched for as a pattern
       * @return start/end horizontal offset of guard pattern, as an array of two
       *         ints
       * @throws NotFoundException if pattern is not found
       *!/*/
      static findGuardPattern(row, rowOffset, pattern) {
        let patternLength = pattern.length;
        let counters = new Int32Array(patternLength);
        let width = row.getSize();
        let isWhite = false;
        let counterPosition = 0;
        let patternStart = rowOffset;
        counters.fill(0);
        for (let x2 = rowOffset; x2 < width; x2++) {
          if (row.get(x2) !== isWhite) {
            counters[counterPosition]++;
          } else {
            if (counterPosition === patternLength - 1) {
              if (OneDReader.patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE) < ITFReader.MAX_AVG_VARIANCE) {
                return [patternStart, x2];
              }
              patternStart += counters[0] + counters[1];
              System.arraycopy(counters, 2, counters, 0, counterPosition - 1);
              counters[counterPosition - 1] = 0;
              counters[counterPosition] = 0;
              counterPosition--;
            } else {
              counterPosition++;
            }
            counters[counterPosition] = 1;
            isWhite = !isWhite;
          }
        }
        throw new NotFoundException();
      }
      /*/!**
       * Attempts to decode a sequence of ITF black/white lines into single
       * digit.
       *
       * @param counters the counts of runs of observed black/white/black/... values
       * @return The decoded digit
       * @throws NotFoundException if digit cannot be decoded
       *!/*/
      static decodeDigit(counters) {
        let bestVariance = ITFReader.MAX_AVG_VARIANCE;
        let bestMatch = -1;
        let max2 = ITFReader.PATTERNS.length;
        for (let i2 = 0; i2 < max2; i2++) {
          let pattern = ITFReader.PATTERNS[i2];
          let variance = OneDReader.patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE);
          if (variance < bestVariance) {
            bestVariance = variance;
            bestMatch = i2;
          } else if (variance === bestVariance) {
            bestMatch = -1;
          }
        }
        if (bestMatch >= 0) {
          return bestMatch % 10;
        } else {
          throw new NotFoundException();
        }
      }
    }
    ITFReader.PATTERNS = [
      Int32Array.from([1, 1, 2, 2, 1]),
      Int32Array.from([2, 1, 1, 1, 2]),
      Int32Array.from([1, 2, 1, 1, 2]),
      Int32Array.from([2, 2, 1, 1, 1]),
      Int32Array.from([1, 1, 2, 1, 2]),
      Int32Array.from([2, 1, 2, 1, 1]),
      Int32Array.from([1, 2, 2, 1, 1]),
      Int32Array.from([1, 1, 1, 2, 2]),
      Int32Array.from([2, 1, 1, 2, 1]),
      Int32Array.from([1, 2, 1, 2, 1]),
      Int32Array.from([1, 1, 3, 3, 1]),
      Int32Array.from([3, 1, 1, 1, 3]),
      Int32Array.from([1, 3, 1, 1, 3]),
      Int32Array.from([3, 3, 1, 1, 1]),
      Int32Array.from([1, 1, 3, 1, 3]),
      Int32Array.from([3, 1, 3, 1, 1]),
      Int32Array.from([1, 3, 3, 1, 1]),
      Int32Array.from([1, 1, 1, 3, 3]),
      Int32Array.from([3, 1, 1, 3, 1]),
      Int32Array.from([1, 3, 1, 3, 1])
      // 9
    ];
    ITFReader.MAX_AVG_VARIANCE = 0.38;
    ITFReader.MAX_INDIVIDUAL_VARIANCE = 0.5;
    ITFReader.DEFAULT_ALLOWED_LENGTHS = [6, 8, 10, 12, 14];
    ITFReader.START_PATTERN = Int32Array.from([1, 1, 1, 1]);
    ITFReader.END_PATTERN_REVERSED = [
      Int32Array.from([1, 1, 2]),
      Int32Array.from([1, 1, 3])
      // 3x
    ];
    class AbstractUPCEANReader extends OneDReader {
      constructor() {
        super(...arguments);
        this.decodeRowStringBuffer = "";
      }
      static findStartGuardPattern(row) {
        let foundStart = false;
        let startRange;
        let nextStart = 0;
        let counters = Int32Array.from([0, 0, 0]);
        while (!foundStart) {
          counters = Int32Array.from([0, 0, 0]);
          startRange = AbstractUPCEANReader.findGuardPattern(row, nextStart, false, this.START_END_PATTERN, counters);
          let start = startRange[0];
          nextStart = startRange[1];
          let quietStart = start - (nextStart - start);
          if (quietStart >= 0) {
            foundStart = row.isRange(quietStart, start, false);
          }
        }
        return startRange;
      }
      static checkChecksum(s2) {
        return AbstractUPCEANReader.checkStandardUPCEANChecksum(s2);
      }
      static checkStandardUPCEANChecksum(s2) {
        let length = s2.length;
        if (length === 0)
          return false;
        let check = parseInt(s2.charAt(length - 1), 10);
        return AbstractUPCEANReader.getStandardUPCEANChecksum(s2.substring(0, length - 1)) === check;
      }
      static getStandardUPCEANChecksum(s2) {
        let length = s2.length;
        let sum = 0;
        for (let i2 = length - 1; i2 >= 0; i2 -= 2) {
          let digit = s2.charAt(i2).charCodeAt(0) - "0".charCodeAt(0);
          if (digit < 0 || digit > 9) {
            throw new FormatException();
          }
          sum += digit;
        }
        sum *= 3;
        for (let i2 = length - 2; i2 >= 0; i2 -= 2) {
          let digit = s2.charAt(i2).charCodeAt(0) - "0".charCodeAt(0);
          if (digit < 0 || digit > 9) {
            throw new FormatException();
          }
          sum += digit;
        }
        return (1e3 - sum) % 10;
      }
      static decodeEnd(row, endStart) {
        return AbstractUPCEANReader.findGuardPattern(row, endStart, false, AbstractUPCEANReader.START_END_PATTERN, new Int32Array(AbstractUPCEANReader.START_END_PATTERN.length).fill(0));
      }
      /**
       * @throws NotFoundException
       */
      static findGuardPatternWithoutCounters(row, rowOffset, whiteFirst, pattern) {
        return this.findGuardPattern(row, rowOffset, whiteFirst, pattern, new Int32Array(pattern.length));
      }
      /**
       * @param row row of black/white values to search
       * @param rowOffset position to start search
       * @param whiteFirst if true, indicates that the pattern specifies white/black/white/...
       * pixel counts, otherwise, it is interpreted as black/white/black/...
       * @param pattern pattern of counts of number of black and white pixels that are being
       * searched for as a pattern
       * @param counters array of counters, as long as pattern, to re-use
       * @return start/end horizontal offset of guard pattern, as an array of two ints
       * @throws NotFoundException if pattern is not found
       */
      static findGuardPattern(row, rowOffset, whiteFirst, pattern, counters) {
        let width = row.getSize();
        rowOffset = whiteFirst ? row.getNextUnset(rowOffset) : row.getNextSet(rowOffset);
        let counterPosition = 0;
        let patternStart = rowOffset;
        let patternLength = pattern.length;
        let isWhite = whiteFirst;
        for (let x2 = rowOffset; x2 < width; x2++) {
          if (row.get(x2) !== isWhite) {
            counters[counterPosition]++;
          } else {
            if (counterPosition === patternLength - 1) {
              if (OneDReader.patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE) < AbstractUPCEANReader.MAX_AVG_VARIANCE) {
                return Int32Array.from([patternStart, x2]);
              }
              patternStart += counters[0] + counters[1];
              let slice2 = counters.slice(2, counters.length - 1);
              for (let i2 = 0; i2 < counterPosition - 1; i2++) {
                counters[i2] = slice2[i2];
              }
              counters[counterPosition - 1] = 0;
              counters[counterPosition] = 0;
              counterPosition--;
            } else {
              counterPosition++;
            }
            counters[counterPosition] = 1;
            isWhite = !isWhite;
          }
        }
        throw new NotFoundException();
      }
      static decodeDigit(row, counters, rowOffset, patterns) {
        this.recordPattern(row, rowOffset, counters);
        let bestVariance = this.MAX_AVG_VARIANCE;
        let bestMatch = -1;
        let max2 = patterns.length;
        for (let i2 = 0; i2 < max2; i2++) {
          let pattern = patterns[i2];
          let variance = OneDReader.patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE);
          if (variance < bestVariance) {
            bestVariance = variance;
            bestMatch = i2;
          }
        }
        if (bestMatch >= 0) {
          return bestMatch;
        } else {
          throw new NotFoundException();
        }
      }
    }
    AbstractUPCEANReader.MAX_AVG_VARIANCE = 0.48;
    AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    AbstractUPCEANReader.START_END_PATTERN = Int32Array.from([1, 1, 1]);
    AbstractUPCEANReader.MIDDLE_PATTERN = Int32Array.from([1, 1, 1, 1, 1]);
    AbstractUPCEANReader.END_PATTERN = Int32Array.from([1, 1, 1, 1, 1, 1]);
    AbstractUPCEANReader.L_PATTERNS = [
      Int32Array.from([3, 2, 1, 1]),
      Int32Array.from([2, 2, 2, 1]),
      Int32Array.from([2, 1, 2, 2]),
      Int32Array.from([1, 4, 1, 1]),
      Int32Array.from([1, 1, 3, 2]),
      Int32Array.from([1, 2, 3, 1]),
      Int32Array.from([1, 1, 1, 4]),
      Int32Array.from([1, 3, 1, 2]),
      Int32Array.from([1, 2, 1, 3]),
      Int32Array.from([3, 1, 1, 2])
    ];
    class UPCEANExtension5Support {
      constructor() {
        this.CHECK_DIGIT_ENCODINGS = [24, 20, 18, 17, 12, 6, 3, 10, 9, 5];
        this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]);
        this.decodeRowStringBuffer = "";
      }
      decodeRow(rowNumber, row, extensionStartRange) {
        let result2 = this.decodeRowStringBuffer;
        let end = this.decodeMiddle(row, extensionStartRange, result2);
        let resultString = result2.toString();
        let extensionData = UPCEANExtension5Support.parseExtensionString(resultString);
        let resultPoints = [
          new ResultPoint((extensionStartRange[0] + extensionStartRange[1]) / 2, rowNumber),
          new ResultPoint(end, rowNumber)
        ];
        let extensionResult = new Result3(resultString, null, 0, resultPoints, BarcodeFormat$1.UPC_EAN_EXTENSION, (/* @__PURE__ */ new Date()).getTime());
        if (extensionData != null) {
          extensionResult.putAllMetadata(extensionData);
        }
        return extensionResult;
      }
      decodeMiddle(row, startRange, resultString) {
        let counters = this.decodeMiddleCounters;
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        let end = row.getSize();
        let rowOffset = startRange[1];
        let lgPatternFound = 0;
        for (let x2 = 0; x2 < 5 && rowOffset < end; x2++) {
          let bestMatch = AbstractUPCEANReader.decodeDigit(
            row,
            counters,
            rowOffset,
            AbstractUPCEANReader.L_AND_G_PATTERNS
          );
          resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch % 10);
          for (let counter of counters) {
            rowOffset += counter;
          }
          if (bestMatch >= 10) {
            lgPatternFound |= 1 << 4 - x2;
          }
          if (x2 !== 4) {
            rowOffset = row.getNextSet(rowOffset);
            rowOffset = row.getNextUnset(rowOffset);
          }
        }
        if (resultString.length !== 5) {
          throw new NotFoundException();
        }
        let checkDigit = this.determineCheckDigit(lgPatternFound);
        if (UPCEANExtension5Support.extensionChecksum(resultString.toString()) !== checkDigit) {
          throw new NotFoundException();
        }
        return rowOffset;
      }
      static extensionChecksum(s2) {
        let length = s2.length;
        let sum = 0;
        for (let i2 = length - 2; i2 >= 0; i2 -= 2) {
          sum += s2.charAt(i2).charCodeAt(0) - "0".charCodeAt(0);
        }
        sum *= 3;
        for (let i2 = length - 1; i2 >= 0; i2 -= 2) {
          sum += s2.charAt(i2).charCodeAt(0) - "0".charCodeAt(0);
        }
        sum *= 3;
        return sum % 10;
      }
      determineCheckDigit(lgPatternFound) {
        for (let d2 = 0; d2 < 10; d2++) {
          if (lgPatternFound === this.CHECK_DIGIT_ENCODINGS[d2]) {
            return d2;
          }
        }
        throw new NotFoundException();
      }
      static parseExtensionString(raw) {
        if (raw.length !== 5) {
          return null;
        }
        let value = UPCEANExtension5Support.parseExtension5String(raw);
        if (value == null) {
          return null;
        }
        return /* @__PURE__ */ new Map([[ResultMetadataType$1.SUGGESTED_PRICE, value]]);
      }
      static parseExtension5String(raw) {
        let currency;
        switch (raw.charAt(0)) {
          case "0":
            currency = "£";
            break;
          case "5":
            currency = "$";
            break;
          case "9":
            switch (raw) {
              case "90000":
                return null;
              case "99991":
                return "0.00";
              case "99990":
                return "Used";
            }
            currency = "";
            break;
          default:
            currency = "";
            break;
        }
        let rawAmount = parseInt(raw.substring(1));
        let unitsString = (rawAmount / 100).toString();
        let hundredths = rawAmount % 100;
        let hundredthsString = hundredths < 10 ? "0" + hundredths : hundredths.toString();
        return currency + unitsString + "." + hundredthsString;
      }
    }
    class UPCEANExtension2Support {
      constructor() {
        this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]);
        this.decodeRowStringBuffer = "";
      }
      decodeRow(rowNumber, row, extensionStartRange) {
        let result2 = this.decodeRowStringBuffer;
        let end = this.decodeMiddle(row, extensionStartRange, result2);
        let resultString = result2.toString();
        let extensionData = UPCEANExtension2Support.parseExtensionString(resultString);
        let resultPoints = [
          new ResultPoint((extensionStartRange[0] + extensionStartRange[1]) / 2, rowNumber),
          new ResultPoint(end, rowNumber)
        ];
        let extensionResult = new Result3(resultString, null, 0, resultPoints, BarcodeFormat$1.UPC_EAN_EXTENSION, (/* @__PURE__ */ new Date()).getTime());
        if (extensionData != null) {
          extensionResult.putAllMetadata(extensionData);
        }
        return extensionResult;
      }
      decodeMiddle(row, startRange, resultString) {
        let counters = this.decodeMiddleCounters;
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        let end = row.getSize();
        let rowOffset = startRange[1];
        let checkParity = 0;
        for (let x2 = 0; x2 < 2 && rowOffset < end; x2++) {
          let bestMatch = AbstractUPCEANReader.decodeDigit(row, counters, rowOffset, AbstractUPCEANReader.L_AND_G_PATTERNS);
          resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch % 10);
          for (let counter of counters) {
            rowOffset += counter;
          }
          if (bestMatch >= 10) {
            checkParity |= 1 << 1 - x2;
          }
          if (x2 !== 1) {
            rowOffset = row.getNextSet(rowOffset);
            rowOffset = row.getNextUnset(rowOffset);
          }
        }
        if (resultString.length !== 2) {
          throw new NotFoundException();
        }
        if (parseInt(resultString.toString()) % 4 !== checkParity) {
          throw new NotFoundException();
        }
        return rowOffset;
      }
      static parseExtensionString(raw) {
        if (raw.length !== 2) {
          return null;
        }
        return /* @__PURE__ */ new Map([[ResultMetadataType$1.ISSUE_NUMBER, parseInt(raw)]]);
      }
    }
    class UPCEANExtensionSupport {
      static decodeRow(rowNumber, row, rowOffset) {
        let extensionStartRange = AbstractUPCEANReader.findGuardPattern(
          row,
          rowOffset,
          false,
          this.EXTENSION_START_PATTERN,
          new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0)
        );
        try {
          let fiveSupport = new UPCEANExtension5Support();
          return fiveSupport.decodeRow(rowNumber, row, extensionStartRange);
        } catch (err2) {
          let twoSupport = new UPCEANExtension2Support();
          return twoSupport.decodeRow(rowNumber, row, extensionStartRange);
        }
      }
    }
    UPCEANExtensionSupport.EXTENSION_START_PATTERN = Int32Array.from([1, 1, 2]);
    class UPCEANReader extends AbstractUPCEANReader {
      constructor() {
        super();
        this.decodeRowStringBuffer = "";
        UPCEANReader.L_AND_G_PATTERNS = UPCEANReader.L_PATTERNS.map((arr) => Int32Array.from(arr));
        for (let i2 = 10; i2 < 20; i2++) {
          let widths = UPCEANReader.L_PATTERNS[i2 - 10];
          let reversedWidths = new Int32Array(widths.length);
          for (let j = 0; j < widths.length; j++) {
            reversedWidths[j] = widths[widths.length - j - 1];
          }
          UPCEANReader.L_AND_G_PATTERNS[i2] = reversedWidths;
        }
      }
      decodeRow(rowNumber, row, hints) {
        let startGuardRange = UPCEANReader.findStartGuardPattern(row);
        let resultPointCallback = hints == null ? null : hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
        if (resultPointCallback != null) {
          const resultPoint2 = new ResultPoint((startGuardRange[0] + startGuardRange[1]) / 2, rowNumber);
          resultPointCallback.foundPossibleResultPoint(resultPoint2);
        }
        let budello = this.decodeMiddle(row, startGuardRange, this.decodeRowStringBuffer);
        let endStart = budello.rowOffset;
        let result2 = budello.resultString;
        if (resultPointCallback != null) {
          const resultPoint2 = new ResultPoint(endStart, rowNumber);
          resultPointCallback.foundPossibleResultPoint(resultPoint2);
        }
        let endRange = this.decodeEnd(row, endStart);
        if (resultPointCallback != null) {
          const resultPoint2 = new ResultPoint((endRange[0] + endRange[1]) / 2, rowNumber);
          resultPointCallback.foundPossibleResultPoint(resultPoint2);
        }
        let end = endRange[1];
        let quietEnd = end + (end - endRange[0]);
        if (quietEnd >= row.getSize() || !row.isRange(end, quietEnd, false)) {
          throw new NotFoundException();
        }
        let resultString = result2.toString();
        if (resultString.length < 8) {
          throw new FormatException();
        }
        if (!UPCEANReader.checkChecksum(resultString)) {
          throw new ChecksumException();
        }
        let left = (startGuardRange[1] + startGuardRange[0]) / 2;
        let right = (endRange[1] + endRange[0]) / 2;
        let format = this.getBarcodeFormat();
        let resultPoint = [new ResultPoint(left, rowNumber), new ResultPoint(right, rowNumber)];
        let decodeResult = new Result3(resultString, null, 0, resultPoint, format, (/* @__PURE__ */ new Date()).getTime());
        let extensionLength = 0;
        try {
          let extensionResult = UPCEANExtensionSupport.decodeRow(rowNumber, row, endRange[1]);
          decodeResult.putMetadata(ResultMetadataType$1.UPC_EAN_EXTENSION, extensionResult.getText());
          decodeResult.putAllMetadata(extensionResult.getResultMetadata());
          decodeResult.addResultPoints(extensionResult.getResultPoints());
          extensionLength = extensionResult.getText().length;
        } catch (ignoreError) {
        }
        let allowedExtensions = hints == null ? null : hints.get(DecodeHintType$1.ALLOWED_EAN_EXTENSIONS);
        if (allowedExtensions != null) {
          let valid = false;
          for (let length in allowedExtensions) {
            if (extensionLength.toString() === length) {
              valid = true;
              break;
            }
          }
          if (!valid) {
            throw new NotFoundException();
          }
        }
        return decodeResult;
      }
      decodeEnd(row, endStart) {
        return UPCEANReader.findGuardPattern(
          row,
          endStart,
          false,
          UPCEANReader.START_END_PATTERN,
          new Int32Array(UPCEANReader.START_END_PATTERN.length).fill(0)
        );
      }
      static checkChecksum(s2) {
        return UPCEANReader.checkStandardUPCEANChecksum(s2);
      }
      static checkStandardUPCEANChecksum(s2) {
        let length = s2.length;
        if (length === 0)
          return false;
        let check = parseInt(s2.charAt(length - 1), 10);
        return UPCEANReader.getStandardUPCEANChecksum(s2.substring(0, length - 1)) === check;
      }
      static getStandardUPCEANChecksum(s2) {
        let length = s2.length;
        let sum = 0;
        for (let i2 = length - 1; i2 >= 0; i2 -= 2) {
          let digit = s2.charAt(i2).charCodeAt(0) - "0".charCodeAt(0);
          if (digit < 0 || digit > 9) {
            throw new FormatException();
          }
          sum += digit;
        }
        sum *= 3;
        for (let i2 = length - 2; i2 >= 0; i2 -= 2) {
          let digit = s2.charAt(i2).charCodeAt(0) - "0".charCodeAt(0);
          if (digit < 0 || digit > 9) {
            throw new FormatException();
          }
          sum += digit;
        }
        return (1e3 - sum) % 10;
      }
    }
    class EAN13Reader extends UPCEANReader {
      constructor() {
        super();
        this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]);
      }
      decodeMiddle(row, startRange, resultString) {
        let counters = this.decodeMiddleCounters;
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        let end = row.getSize();
        let rowOffset = startRange[1];
        let lgPatternFound = 0;
        for (let x2 = 0; x2 < 6 && rowOffset < end; x2++) {
          let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_AND_G_PATTERNS);
          resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch % 10);
          for (let counter of counters) {
            rowOffset += counter;
          }
          if (bestMatch >= 10) {
            lgPatternFound |= 1 << 5 - x2;
          }
        }
        resultString = EAN13Reader.determineFirstDigit(resultString, lgPatternFound);
        let middleRange = UPCEANReader.findGuardPattern(
          row,
          rowOffset,
          true,
          UPCEANReader.MIDDLE_PATTERN,
          new Int32Array(UPCEANReader.MIDDLE_PATTERN.length).fill(0)
        );
        rowOffset = middleRange[1];
        for (let x2 = 0; x2 < 6 && rowOffset < end; x2++) {
          let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
          resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch);
          for (let counter of counters) {
            rowOffset += counter;
          }
        }
        return { rowOffset, resultString };
      }
      getBarcodeFormat() {
        return BarcodeFormat$1.EAN_13;
      }
      static determineFirstDigit(resultString, lgPatternFound) {
        for (let d2 = 0; d2 < 10; d2++) {
          if (lgPatternFound === this.FIRST_DIGIT_ENCODINGS[d2]) {
            resultString = String.fromCharCode("0".charCodeAt(0) + d2) + resultString;
            return resultString;
          }
        }
        throw new NotFoundException();
      }
    }
    EAN13Reader.FIRST_DIGIT_ENCODINGS = [0, 11, 13, 14, 19, 25, 28, 21, 22, 26];
    class EAN8Reader extends UPCEANReader {
      constructor() {
        super();
        this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]);
      }
      decodeMiddle(row, startRange, resultString) {
        const counters = this.decodeMiddleCounters;
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        let end = row.getSize();
        let rowOffset = startRange[1];
        for (let x2 = 0; x2 < 4 && rowOffset < end; x2++) {
          let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
          resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch);
          for (let counter of counters) {
            rowOffset += counter;
          }
        }
        let middleRange = UPCEANReader.findGuardPattern(row, rowOffset, true, UPCEANReader.MIDDLE_PATTERN, new Int32Array(UPCEANReader.MIDDLE_PATTERN.length).fill(0));
        rowOffset = middleRange[1];
        for (let x2 = 0; x2 < 4 && rowOffset < end; x2++) {
          let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
          resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch);
          for (let counter of counters) {
            rowOffset += counter;
          }
        }
        return { rowOffset, resultString };
      }
      getBarcodeFormat() {
        return BarcodeFormat$1.EAN_8;
      }
    }
    class UPCAReader extends UPCEANReader {
      constructor() {
        super(...arguments);
        this.ean13Reader = new EAN13Reader();
      }
      // @Override
      getBarcodeFormat() {
        return BarcodeFormat$1.UPC_A;
      }
      // Note that we don't try rotation without the try harder flag, even if rotation was supported.
      // @Override
      decode(image, hints) {
        return this.maybeReturnResult(this.ean13Reader.decode(image));
      }
      // @Override
      decodeRow(rowNumber, row, hints) {
        return this.maybeReturnResult(this.ean13Reader.decodeRow(rowNumber, row, hints));
      }
      // @Override
      decodeMiddle(row, startRange, resultString) {
        return this.ean13Reader.decodeMiddle(row, startRange, resultString);
      }
      maybeReturnResult(result2) {
        let text2 = result2.getText();
        if (text2.charAt(0) === "0") {
          let upcaResult = new Result3(text2.substring(1), null, null, result2.getResultPoints(), BarcodeFormat$1.UPC_A);
          if (result2.getResultMetadata() != null) {
            upcaResult.putAllMetadata(result2.getResultMetadata());
          }
          return upcaResult;
        } else {
          throw new NotFoundException();
        }
      }
      reset() {
        this.ean13Reader.reset();
      }
    }
    class UPCEReader extends UPCEANReader {
      constructor() {
        super();
        this.decodeMiddleCounters = new Int32Array(4);
      }
      /**
       * @throws NotFoundException
       */
      // @Override
      decodeMiddle(row, startRange, result2) {
        const counters = this.decodeMiddleCounters.map((x2) => x2);
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        const end = row.getSize();
        let rowOffset = startRange[1];
        let lgPatternFound = 0;
        for (let x2 = 0; x2 < 6 && rowOffset < end; x2++) {
          const bestMatch = UPCEReader.decodeDigit(
            row,
            counters,
            rowOffset,
            UPCEReader.L_AND_G_PATTERNS
          );
          result2 += String.fromCharCode("0".charCodeAt(0) + bestMatch % 10);
          for (let counter of counters) {
            rowOffset += counter;
          }
          if (bestMatch >= 10) {
            lgPatternFound |= 1 << 5 - x2;
          }
        }
        let resultString = UPCEReader.determineNumSysAndCheckDigit(
          result2,
          lgPatternFound
        );
        return { rowOffset, resultString };
      }
      /**
       * @throws NotFoundException
       */
      // @Override
      decodeEnd(row, endStart) {
        return UPCEReader.findGuardPatternWithoutCounters(
          row,
          endStart,
          true,
          UPCEReader.MIDDLE_END_PATTERN
        );
      }
      /**
       * @throws FormatException
       */
      // @Override
      checkChecksum(s2) {
        return UPCEANReader.checkChecksum(UPCEReader.convertUPCEtoUPCA(s2));
      }
      /**
       * @throws NotFoundException
       */
      static determineNumSysAndCheckDigit(resultString, lgPatternFound) {
        for (let numSys = 0; numSys <= 1; numSys++) {
          for (let d2 = 0; d2 < 10; d2++) {
            if (lgPatternFound === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[numSys][d2]) {
              let prefix = String.fromCharCode("0".charCodeAt(0) + numSys);
              let suffix = String.fromCharCode("0".charCodeAt(0) + d2);
              return prefix + resultString + suffix;
            }
          }
        }
        throw NotFoundException.getNotFoundInstance();
      }
      // @Override
      getBarcodeFormat() {
        return BarcodeFormat$1.UPC_E;
      }
      /**
       * Expands a UPC-E value back into its full, equivalent UPC-A code value.
       *
       * @param upce UPC-E code as string of digits
       * @return equivalent UPC-A code as string of digits
       */
      static convertUPCEtoUPCA(upce) {
        const upceChars = upce.slice(1, 7).split("").map((x2) => x2.charCodeAt(0));
        const result2 = new StringBuilder(
          /*12*/
        );
        result2.append(upce.charAt(0));
        let lastChar = upceChars[5];
        switch (lastChar) {
          case 0:
          case 1:
          case 2:
            result2.appendChars(upceChars, 0, 2);
            result2.append(lastChar);
            result2.append("0000");
            result2.appendChars(upceChars, 2, 3);
            break;
          case 3:
            result2.appendChars(upceChars, 0, 3);
            result2.append("00000");
            result2.appendChars(upceChars, 3, 2);
            break;
          case 4:
            result2.appendChars(upceChars, 0, 4);
            result2.append("00000");
            result2.append(upceChars[4]);
            break;
          default:
            result2.appendChars(upceChars, 0, 5);
            result2.append("0000");
            result2.append(lastChar);
            break;
        }
        if (upce.length >= 8) {
          result2.append(upce.charAt(7));
        }
        return result2.toString();
      }
    }
    UPCEReader.MIDDLE_END_PATTERN = Int32Array.from([1, 1, 1, 1, 1, 1]);
    UPCEReader.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
      Int32Array.from([56, 52, 50, 49, 44, 38, 35, 42, 41, 37]),
      Int32Array.from([7, 11, 13, 14, 19, 25, 28, 21, 22, 26])
    ];
    class MultiFormatUPCEANReader extends OneDReader {
      constructor(hints) {
        super();
        let possibleFormats = hints == null ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
        let readers = [];
        if (!isNullOrUndefined2(possibleFormats)) {
          if (possibleFormats.indexOf(BarcodeFormat$1.EAN_13) > -1) {
            readers.push(new EAN13Reader());
          }
          if (possibleFormats.indexOf(BarcodeFormat$1.UPC_A) > -1) {
            readers.push(new UPCAReader());
          }
          if (possibleFormats.indexOf(BarcodeFormat$1.EAN_8) > -1) {
            readers.push(new EAN8Reader());
          }
          if (possibleFormats.indexOf(BarcodeFormat$1.UPC_E) > -1) {
            readers.push(new UPCEReader());
          }
        } else {
          readers.push(new EAN13Reader());
          readers.push(new UPCAReader());
          readers.push(new EAN8Reader());
          readers.push(new UPCEReader());
        }
        this.readers = readers;
      }
      decodeRow(rowNumber, row, hints) {
        for (let reader of this.readers) {
          try {
            const result2 = reader.decodeRow(rowNumber, row, hints);
            const ean13MayBeUPCA = result2.getBarcodeFormat() === BarcodeFormat$1.EAN_13 && result2.getText().charAt(0) === "0";
            const possibleFormats = hints == null ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            const canReturnUPCA = possibleFormats == null || possibleFormats.includes(BarcodeFormat$1.UPC_A);
            if (ean13MayBeUPCA && canReturnUPCA) {
              const rawBytes = result2.getRawBytes();
              const resultUPCA = new Result3(
                result2.getText().substring(1),
                rawBytes,
                rawBytes ? rawBytes.length : null,
                result2.getResultPoints(),
                BarcodeFormat$1.UPC_A
              );
              resultUPCA.putAllMetadata(result2.getResultMetadata());
              return resultUPCA;
            }
            return result2;
          } catch (err2) {
          }
        }
        throw new NotFoundException();
      }
      reset() {
        for (let reader of this.readers) {
          reader.reset();
        }
      }
    }
    class AbstractRSSReader extends OneDReader {
      constructor() {
        super();
        this.decodeFinderCounters = new Int32Array(4);
        this.dataCharacterCounters = new Int32Array(8);
        this.oddRoundingErrors = new Array(4);
        this.evenRoundingErrors = new Array(4);
        this.oddCounts = new Array(this.dataCharacterCounters.length / 2);
        this.evenCounts = new Array(this.dataCharacterCounters.length / 2);
      }
      getDecodeFinderCounters() {
        return this.decodeFinderCounters;
      }
      getDataCharacterCounters() {
        return this.dataCharacterCounters;
      }
      getOddRoundingErrors() {
        return this.oddRoundingErrors;
      }
      getEvenRoundingErrors() {
        return this.evenRoundingErrors;
      }
      getOddCounts() {
        return this.oddCounts;
      }
      getEvenCounts() {
        return this.evenCounts;
      }
      parseFinderValue(counters, finderPatterns) {
        for (let value = 0; value < finderPatterns.length; value++) {
          if (OneDReader.patternMatchVariance(counters, finderPatterns[value], AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE) < AbstractRSSReader.MAX_AVG_VARIANCE) {
            return value;
          }
        }
        throw new NotFoundException();
      }
      /**
       * @param array values to sum
       * @return sum of values
       * @deprecated call {@link MathUtils#sum(int[])}
       */
      static count(array) {
        return MathUtils2.sum(new Int32Array(array));
      }
      static increment(array, errors) {
        let index2 = 0;
        let biggestError = errors[0];
        for (let i2 = 1; i2 < array.length; i2++) {
          if (errors[i2] > biggestError) {
            biggestError = errors[i2];
            index2 = i2;
          }
        }
        array[index2]++;
      }
      static decrement(array, errors) {
        let index2 = 0;
        let biggestError = errors[0];
        for (let i2 = 1; i2 < array.length; i2++) {
          if (errors[i2] < biggestError) {
            biggestError = errors[i2];
            index2 = i2;
          }
        }
        array[index2]--;
      }
      static isFinderPattern(counters) {
        let firstTwoSum = counters[0] + counters[1];
        let sum = firstTwoSum + counters[2] + counters[3];
        let ratio = firstTwoSum / sum;
        if (ratio >= AbstractRSSReader.MIN_FINDER_PATTERN_RATIO && ratio <= AbstractRSSReader.MAX_FINDER_PATTERN_RATIO) {
          let minCounter = Number.MAX_SAFE_INTEGER;
          let maxCounter = Number.MIN_SAFE_INTEGER;
          for (let counter of counters) {
            if (counter > maxCounter) {
              maxCounter = counter;
            }
            if (counter < minCounter) {
              minCounter = counter;
            }
          }
          return maxCounter < 10 * minCounter;
        }
        return false;
      }
    }
    AbstractRSSReader.MAX_AVG_VARIANCE = 0.2;
    AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE = 0.45;
    AbstractRSSReader.MIN_FINDER_PATTERN_RATIO = 9.5 / 12;
    AbstractRSSReader.MAX_FINDER_PATTERN_RATIO = 12.5 / 14;
    class DataCharacter {
      constructor(value, checksumPortion) {
        this.value = value;
        this.checksumPortion = checksumPortion;
      }
      getValue() {
        return this.value;
      }
      getChecksumPortion() {
        return this.checksumPortion;
      }
      toString() {
        return this.value + "(" + this.checksumPortion + ")";
      }
      equals(o) {
        if (!(o instanceof DataCharacter)) {
          return false;
        }
        const that = o;
        return this.value === that.value && this.checksumPortion === that.checksumPortion;
      }
      hashCode() {
        return this.value ^ this.checksumPortion;
      }
    }
    class FinderPattern {
      constructor(value, startEnd, start, end, rowNumber) {
        this.value = value;
        this.startEnd = startEnd;
        this.value = value;
        this.startEnd = startEnd;
        this.resultPoints = new Array();
        this.resultPoints.push(new ResultPoint(start, rowNumber));
        this.resultPoints.push(new ResultPoint(end, rowNumber));
      }
      getValue() {
        return this.value;
      }
      getStartEnd() {
        return this.startEnd;
      }
      getResultPoints() {
        return this.resultPoints;
      }
      equals(o) {
        if (!(o instanceof FinderPattern)) {
          return false;
        }
        const that = o;
        return this.value === that.value;
      }
      hashCode() {
        return this.value;
      }
    }
    class RSSUtils {
      constructor() {
      }
      static getRSSvalue(widths, maxWidth, noNarrow) {
        let n2 = 0;
        for (let width of widths) {
          n2 += width;
        }
        let val = 0;
        let narrowMask = 0;
        let elements = widths.length;
        for (let bar = 0; bar < elements - 1; bar++) {
          let elmWidth;
          for (elmWidth = 1, narrowMask |= 1 << bar; elmWidth < widths[bar]; elmWidth++, narrowMask &= ~(1 << bar)) {
            let subVal = RSSUtils.combins(n2 - elmWidth - 1, elements - bar - 2);
            if (noNarrow && narrowMask === 0 && n2 - elmWidth - (elements - bar - 1) >= elements - bar - 1) {
              subVal -= RSSUtils.combins(n2 - elmWidth - (elements - bar), elements - bar - 2);
            }
            if (elements - bar - 1 > 1) {
              let lessVal = 0;
              for (let mxwElement = n2 - elmWidth - (elements - bar - 2); mxwElement > maxWidth; mxwElement--) {
                lessVal += RSSUtils.combins(n2 - elmWidth - mxwElement - 1, elements - bar - 3);
              }
              subVal -= lessVal * (elements - 1 - bar);
            } else if (n2 - elmWidth > maxWidth) {
              subVal--;
            }
            val += subVal;
          }
          n2 -= elmWidth;
        }
        return val;
      }
      static combins(n2, r) {
        let maxDenom;
        let minDenom;
        if (n2 - r > r) {
          minDenom = r;
          maxDenom = n2 - r;
        } else {
          minDenom = n2 - r;
          maxDenom = r;
        }
        let val = 1;
        let j = 1;
        for (let i2 = n2; i2 > maxDenom; i2--) {
          val *= i2;
          if (j <= minDenom) {
            val /= j;
            j++;
          }
        }
        while (j <= minDenom) {
          val /= j;
          j++;
        }
        return val;
      }
    }
    class BitArrayBuilder {
      static buildBitArray(pairs) {
        let charNumber = pairs.length * 2 - 1;
        if (pairs[pairs.length - 1].getRightChar() == null) {
          charNumber -= 1;
        }
        let size = 12 * charNumber;
        let binary = new BitArray(size);
        let accPos = 0;
        let firstPair = pairs[0];
        let firstValue = firstPair.getRightChar().getValue();
        for (let i2 = 11; i2 >= 0; --i2) {
          if ((firstValue & 1 << i2) != 0) {
            binary.set(accPos);
          }
          accPos++;
        }
        for (let i2 = 1; i2 < pairs.length; ++i2) {
          let currentPair = pairs[i2];
          let leftValue = currentPair.getLeftChar().getValue();
          for (let j = 11; j >= 0; --j) {
            if ((leftValue & 1 << j) != 0) {
              binary.set(accPos);
            }
            accPos++;
          }
          if (currentPair.getRightChar() != null) {
            let rightValue = currentPair.getRightChar().getValue();
            for (let j = 11; j >= 0; --j) {
              if ((rightValue & 1 << j) != 0) {
                binary.set(accPos);
              }
              accPos++;
            }
          }
        }
        return binary;
      }
    }
    class BlockParsedResult {
      constructor(finished, decodedInformation) {
        if (decodedInformation) {
          this.decodedInformation = null;
        } else {
          this.finished = finished;
          this.decodedInformation = decodedInformation;
        }
      }
      getDecodedInformation() {
        return this.decodedInformation;
      }
      isFinished() {
        return this.finished;
      }
    }
    class DecodedObject {
      constructor(newPosition) {
        this.newPosition = newPosition;
      }
      getNewPosition() {
        return this.newPosition;
      }
    }
    class DecodedChar extends DecodedObject {
      constructor(newPosition, value) {
        super(newPosition);
        this.value = value;
      }
      getValue() {
        return this.value;
      }
      isFNC1() {
        return this.value === DecodedChar.FNC1;
      }
    }
    DecodedChar.FNC1 = "$";
    class DecodedInformation extends DecodedObject {
      constructor(newPosition, newString, remainingValue) {
        super(newPosition);
        if (remainingValue) {
          this.remaining = true;
          this.remainingValue = this.remainingValue;
        } else {
          this.remaining = false;
          this.remainingValue = 0;
        }
        this.newString = newString;
      }
      getNewString() {
        return this.newString;
      }
      isRemaining() {
        return this.remaining;
      }
      getRemainingValue() {
        return this.remainingValue;
      }
    }
    class DecodedNumeric extends DecodedObject {
      constructor(newPosition, firstDigit, secondDigit) {
        super(newPosition);
        if (firstDigit < 0 || firstDigit > 10 || secondDigit < 0 || secondDigit > 10) {
          throw new FormatException();
        }
        this.firstDigit = firstDigit;
        this.secondDigit = secondDigit;
      }
      getFirstDigit() {
        return this.firstDigit;
      }
      getSecondDigit() {
        return this.secondDigit;
      }
      getValue() {
        return this.firstDigit * 10 + this.secondDigit;
      }
      isFirstDigitFNC1() {
        return this.firstDigit === DecodedNumeric.FNC1;
      }
      isSecondDigitFNC1() {
        return this.secondDigit === DecodedNumeric.FNC1;
      }
      isAnyFNC1() {
        return this.firstDigit === DecodedNumeric.FNC1 || this.secondDigit === DecodedNumeric.FNC1;
      }
    }
    DecodedNumeric.FNC1 = 10;
    class FieldParser {
      constructor() {
      }
      static parseFieldsInGeneralPurpose(rawInformation) {
        if (!rawInformation) {
          return null;
        }
        if (rawInformation.length < 2) {
          throw new NotFoundException();
        }
        let firstTwoDigits = rawInformation.substring(0, 2);
        for (let dataLength of FieldParser.TWO_DIGIT_DATA_LENGTH) {
          if (dataLength[0] === firstTwoDigits) {
            if (dataLength[1] === FieldParser.VARIABLE_LENGTH) {
              return FieldParser.processVariableAI(2, dataLength[2], rawInformation);
            }
            return FieldParser.processFixedAI(2, dataLength[1], rawInformation);
          }
        }
        if (rawInformation.length < 3) {
          throw new NotFoundException();
        }
        let firstThreeDigits = rawInformation.substring(0, 3);
        for (let dataLength of FieldParser.THREE_DIGIT_DATA_LENGTH) {
          if (dataLength[0] === firstThreeDigits) {
            if (dataLength[1] === FieldParser.VARIABLE_LENGTH) {
              return FieldParser.processVariableAI(3, dataLength[2], rawInformation);
            }
            return FieldParser.processFixedAI(3, dataLength[1], rawInformation);
          }
        }
        for (let dataLength of FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH) {
          if (dataLength[0] === firstThreeDigits) {
            if (dataLength[1] === FieldParser.VARIABLE_LENGTH) {
              return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
            }
            return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
          }
        }
        if (rawInformation.length < 4) {
          throw new NotFoundException();
        }
        let firstFourDigits = rawInformation.substring(0, 4);
        for (let dataLength of FieldParser.FOUR_DIGIT_DATA_LENGTH) {
          if (dataLength[0] === firstFourDigits) {
            if (dataLength[1] === FieldParser.VARIABLE_LENGTH) {
              return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
            }
            return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
          }
        }
        throw new NotFoundException();
      }
      static processFixedAI(aiSize, fieldSize, rawInformation) {
        if (rawInformation.length < aiSize) {
          throw new NotFoundException();
        }
        let ai = rawInformation.substring(0, aiSize);
        if (rawInformation.length < aiSize + fieldSize) {
          throw new NotFoundException();
        }
        let field = rawInformation.substring(aiSize, aiSize + fieldSize);
        let remaining = rawInformation.substring(aiSize + fieldSize);
        let result2 = "(" + ai + ")" + field;
        let parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
        return parsedAI == null ? result2 : result2 + parsedAI;
      }
      static processVariableAI(aiSize, variableFieldSize, rawInformation) {
        let ai = rawInformation.substring(0, aiSize);
        let maxSize;
        if (rawInformation.length < aiSize + variableFieldSize) {
          maxSize = rawInformation.length;
        } else {
          maxSize = aiSize + variableFieldSize;
        }
        let field = rawInformation.substring(aiSize, maxSize);
        let remaining = rawInformation.substring(maxSize);
        let result2 = "(" + ai + ")" + field;
        let parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
        return parsedAI == null ? result2 : result2 + parsedAI;
      }
    }
    FieldParser.VARIABLE_LENGTH = [];
    FieldParser.TWO_DIGIT_DATA_LENGTH = [
      ["00", 18],
      ["01", 14],
      ["02", 14],
      ["10", FieldParser.VARIABLE_LENGTH, 20],
      ["11", 6],
      ["12", 6],
      ["13", 6],
      ["15", 6],
      ["17", 6],
      ["20", 2],
      ["21", FieldParser.VARIABLE_LENGTH, 20],
      ["22", FieldParser.VARIABLE_LENGTH, 29],
      ["30", FieldParser.VARIABLE_LENGTH, 8],
      ["37", FieldParser.VARIABLE_LENGTH, 8],
      // internal company codes
      ["90", FieldParser.VARIABLE_LENGTH, 30],
      ["91", FieldParser.VARIABLE_LENGTH, 30],
      ["92", FieldParser.VARIABLE_LENGTH, 30],
      ["93", FieldParser.VARIABLE_LENGTH, 30],
      ["94", FieldParser.VARIABLE_LENGTH, 30],
      ["95", FieldParser.VARIABLE_LENGTH, 30],
      ["96", FieldParser.VARIABLE_LENGTH, 30],
      ["97", FieldParser.VARIABLE_LENGTH, 3],
      ["98", FieldParser.VARIABLE_LENGTH, 30],
      ["99", FieldParser.VARIABLE_LENGTH, 30]
    ];
    FieldParser.THREE_DIGIT_DATA_LENGTH = [
      // Same format as above
      ["240", FieldParser.VARIABLE_LENGTH, 30],
      ["241", FieldParser.VARIABLE_LENGTH, 30],
      ["242", FieldParser.VARIABLE_LENGTH, 6],
      ["250", FieldParser.VARIABLE_LENGTH, 30],
      ["251", FieldParser.VARIABLE_LENGTH, 30],
      ["253", FieldParser.VARIABLE_LENGTH, 17],
      ["254", FieldParser.VARIABLE_LENGTH, 20],
      ["400", FieldParser.VARIABLE_LENGTH, 30],
      ["401", FieldParser.VARIABLE_LENGTH, 30],
      ["402", 17],
      ["403", FieldParser.VARIABLE_LENGTH, 30],
      ["410", 13],
      ["411", 13],
      ["412", 13],
      ["413", 13],
      ["414", 13],
      ["420", FieldParser.VARIABLE_LENGTH, 20],
      ["421", FieldParser.VARIABLE_LENGTH, 15],
      ["422", 3],
      ["423", FieldParser.VARIABLE_LENGTH, 15],
      ["424", 3],
      ["425", 3],
      ["426", 3]
    ];
    FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
      // Same format as above
      ["310", 6],
      ["311", 6],
      ["312", 6],
      ["313", 6],
      ["314", 6],
      ["315", 6],
      ["316", 6],
      ["320", 6],
      ["321", 6],
      ["322", 6],
      ["323", 6],
      ["324", 6],
      ["325", 6],
      ["326", 6],
      ["327", 6],
      ["328", 6],
      ["329", 6],
      ["330", 6],
      ["331", 6],
      ["332", 6],
      ["333", 6],
      ["334", 6],
      ["335", 6],
      ["336", 6],
      ["340", 6],
      ["341", 6],
      ["342", 6],
      ["343", 6],
      ["344", 6],
      ["345", 6],
      ["346", 6],
      ["347", 6],
      ["348", 6],
      ["349", 6],
      ["350", 6],
      ["351", 6],
      ["352", 6],
      ["353", 6],
      ["354", 6],
      ["355", 6],
      ["356", 6],
      ["357", 6],
      ["360", 6],
      ["361", 6],
      ["362", 6],
      ["363", 6],
      ["364", 6],
      ["365", 6],
      ["366", 6],
      ["367", 6],
      ["368", 6],
      ["369", 6],
      ["390", FieldParser.VARIABLE_LENGTH, 15],
      ["391", FieldParser.VARIABLE_LENGTH, 18],
      ["392", FieldParser.VARIABLE_LENGTH, 15],
      ["393", FieldParser.VARIABLE_LENGTH, 18],
      ["703", FieldParser.VARIABLE_LENGTH, 30]
    ];
    FieldParser.FOUR_DIGIT_DATA_LENGTH = [
      // Same format as above
      ["7001", 13],
      ["7002", FieldParser.VARIABLE_LENGTH, 30],
      ["7003", 10],
      ["8001", 14],
      ["8002", FieldParser.VARIABLE_LENGTH, 20],
      ["8003", FieldParser.VARIABLE_LENGTH, 30],
      ["8004", FieldParser.VARIABLE_LENGTH, 30],
      ["8005", 6],
      ["8006", 18],
      ["8007", FieldParser.VARIABLE_LENGTH, 30],
      ["8008", FieldParser.VARIABLE_LENGTH, 12],
      ["8018", 18],
      ["8020", FieldParser.VARIABLE_LENGTH, 25],
      ["8100", 6],
      ["8101", 10],
      ["8102", 2],
      ["8110", FieldParser.VARIABLE_LENGTH, 70],
      ["8200", FieldParser.VARIABLE_LENGTH, 70]
    ];
    class GeneralAppIdDecoder {
      constructor(information) {
        this.buffer = new StringBuilder();
        this.information = information;
      }
      decodeAllCodes(buff, initialPosition) {
        let currentPosition = initialPosition;
        let remaining = null;
        do {
          let info = this.decodeGeneralPurposeField(currentPosition, remaining);
          let parsedFields = FieldParser.parseFieldsInGeneralPurpose(info.getNewString());
          if (parsedFields != null) {
            buff.append(parsedFields);
          }
          if (info.isRemaining()) {
            remaining = "" + info.getRemainingValue();
          } else {
            remaining = null;
          }
          if (currentPosition === info.getNewPosition()) {
            break;
          }
          currentPosition = info.getNewPosition();
        } while (true);
        return buff.toString();
      }
      isStillNumeric(pos) {
        if (pos + 7 > this.information.getSize()) {
          return pos + 4 <= this.information.getSize();
        }
        for (let i2 = pos; i2 < pos + 3; ++i2) {
          if (this.information.get(i2)) {
            return true;
          }
        }
        return this.information.get(pos + 3);
      }
      decodeNumeric(pos) {
        if (pos + 7 > this.information.getSize()) {
          let numeric2 = this.extractNumericValueFromBitArray(pos, 4);
          if (numeric2 === 0) {
            return new DecodedNumeric(this.information.getSize(), DecodedNumeric.FNC1, DecodedNumeric.FNC1);
          }
          return new DecodedNumeric(this.information.getSize(), numeric2 - 1, DecodedNumeric.FNC1);
        }
        let numeric = this.extractNumericValueFromBitArray(pos, 7);
        let digit1 = (numeric - 8) / 11;
        let digit2 = (numeric - 8) % 11;
        return new DecodedNumeric(pos + 7, digit1, digit2);
      }
      extractNumericValueFromBitArray(pos, bits) {
        return GeneralAppIdDecoder.extractNumericValueFromBitArray(this.information, pos, bits);
      }
      static extractNumericValueFromBitArray(information, pos, bits) {
        let value = 0;
        for (let i2 = 0; i2 < bits; ++i2) {
          if (information.get(pos + i2)) {
            value |= 1 << bits - i2 - 1;
          }
        }
        return value;
      }
      decodeGeneralPurposeField(pos, remaining) {
        this.buffer.setLengthToZero();
        if (remaining != null) {
          this.buffer.append(remaining);
        }
        this.current.setPosition(pos);
        let lastDecoded = this.parseBlocks();
        if (lastDecoded != null && lastDecoded.isRemaining()) {
          return new DecodedInformation(this.current.getPosition(), this.buffer.toString(), lastDecoded.getRemainingValue());
        }
        return new DecodedInformation(this.current.getPosition(), this.buffer.toString());
      }
      parseBlocks() {
        let isFinished;
        let result2;
        do {
          let initialPosition = this.current.getPosition();
          if (this.current.isAlpha()) {
            result2 = this.parseAlphaBlock();
            isFinished = result2.isFinished();
          } else if (this.current.isIsoIec646()) {
            result2 = this.parseIsoIec646Block();
            isFinished = result2.isFinished();
          } else {
            result2 = this.parseNumericBlock();
            isFinished = result2.isFinished();
          }
          let positionChanged = initialPosition !== this.current.getPosition();
          if (!positionChanged && !isFinished) {
            break;
          }
        } while (!isFinished);
        return result2.getDecodedInformation();
      }
      parseNumericBlock() {
        while (this.isStillNumeric(this.current.getPosition())) {
          let numeric = this.decodeNumeric(this.current.getPosition());
          this.current.setPosition(numeric.getNewPosition());
          if (numeric.isFirstDigitFNC1()) {
            let information;
            if (numeric.isSecondDigitFNC1()) {
              information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
            } else {
              information = new DecodedInformation(this.current.getPosition(), this.buffer.toString(), numeric.getSecondDigit());
            }
            return new BlockParsedResult(true, information);
          }
          this.buffer.append(numeric.getFirstDigit());
          if (numeric.isSecondDigitFNC1()) {
            let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
            return new BlockParsedResult(true, information);
          }
          this.buffer.append(numeric.getSecondDigit());
        }
        if (this.isNumericToAlphaNumericLatch(this.current.getPosition())) {
          this.current.setAlpha();
          this.current.incrementPosition(4);
        }
        return new BlockParsedResult(false);
      }
      parseIsoIec646Block() {
        while (this.isStillIsoIec646(this.current.getPosition())) {
          let iso = this.decodeIsoIec646(this.current.getPosition());
          this.current.setPosition(iso.getNewPosition());
          if (iso.isFNC1()) {
            let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
            return new BlockParsedResult(true, information);
          }
          this.buffer.append(iso.getValue());
        }
        if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
          this.current.incrementPosition(3);
          this.current.setNumeric();
        } else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
          if (this.current.getPosition() + 5 < this.information.getSize()) {
            this.current.incrementPosition(5);
          } else {
            this.current.setPosition(this.information.getSize());
          }
          this.current.setAlpha();
        }
        return new BlockParsedResult(false);
      }
      parseAlphaBlock() {
        while (this.isStillAlpha(this.current.getPosition())) {
          let alpha = this.decodeAlphanumeric(this.current.getPosition());
          this.current.setPosition(alpha.getNewPosition());
          if (alpha.isFNC1()) {
            let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
            return new BlockParsedResult(true, information);
          }
          this.buffer.append(alpha.getValue());
        }
        if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
          this.current.incrementPosition(3);
          this.current.setNumeric();
        } else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
          if (this.current.getPosition() + 5 < this.information.getSize()) {
            this.current.incrementPosition(5);
          } else {
            this.current.setPosition(this.information.getSize());
          }
          this.current.setIsoIec646();
        }
        return new BlockParsedResult(false);
      }
      isStillIsoIec646(pos) {
        if (pos + 5 > this.information.getSize()) {
          return false;
        }
        let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
        if (fiveBitValue >= 5 && fiveBitValue < 16) {
          return true;
        }
        if (pos + 7 > this.information.getSize()) {
          return false;
        }
        let sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
        if (sevenBitValue >= 64 && sevenBitValue < 116) {
          return true;
        }
        if (pos + 8 > this.information.getSize()) {
          return false;
        }
        let eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
        return eightBitValue >= 232 && eightBitValue < 253;
      }
      decodeIsoIec646(pos) {
        let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
        if (fiveBitValue === 15) {
          return new DecodedChar(pos + 5, DecodedChar.FNC1);
        }
        if (fiveBitValue >= 5 && fiveBitValue < 15) {
          return new DecodedChar(pos + 5, "0" + (fiveBitValue - 5));
        }
        let sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
        if (sevenBitValue >= 64 && sevenBitValue < 90) {
          return new DecodedChar(pos + 7, "" + (sevenBitValue + 1));
        }
        if (sevenBitValue >= 90 && sevenBitValue < 116) {
          return new DecodedChar(pos + 7, "" + (sevenBitValue + 7));
        }
        let eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
        let c;
        switch (eightBitValue) {
          case 232:
            c = "!";
            break;
          case 233:
            c = '"';
            break;
          case 234:
            c = "%";
            break;
          case 235:
            c = "&";
            break;
          case 236:
            c = "'";
            break;
          case 237:
            c = "(";
            break;
          case 238:
            c = ")";
            break;
          case 239:
            c = "*";
            break;
          case 240:
            c = "+";
            break;
          case 241:
            c = ",";
            break;
          case 242:
            c = "-";
            break;
          case 243:
            c = ".";
            break;
          case 244:
            c = "/";
            break;
          case 245:
            c = ":";
            break;
          case 246:
            c = ";";
            break;
          case 247:
            c = "<";
            break;
          case 248:
            c = "=";
            break;
          case 249:
            c = ">";
            break;
          case 250:
            c = "?";
            break;
          case 251:
            c = "_";
            break;
          case 252:
            c = " ";
            break;
          default:
            throw new FormatException();
        }
        return new DecodedChar(pos + 8, c);
      }
      isStillAlpha(pos) {
        if (pos + 5 > this.information.getSize()) {
          return false;
        }
        let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
        if (fiveBitValue >= 5 && fiveBitValue < 16) {
          return true;
        }
        if (pos + 6 > this.information.getSize()) {
          return false;
        }
        let sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
        return sixBitValue >= 16 && sixBitValue < 63;
      }
      decodeAlphanumeric(pos) {
        let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
        if (fiveBitValue === 15) {
          return new DecodedChar(pos + 5, DecodedChar.FNC1);
        }
        if (fiveBitValue >= 5 && fiveBitValue < 15) {
          return new DecodedChar(pos + 5, "0" + (fiveBitValue - 5));
        }
        let sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
        if (sixBitValue >= 32 && sixBitValue < 58) {
          return new DecodedChar(pos + 6, "" + (sixBitValue + 33));
        }
        let c;
        switch (sixBitValue) {
          case 58:
            c = "*";
            break;
          case 59:
            c = ",";
            break;
          case 60:
            c = "-";
            break;
          case 61:
            c = ".";
            break;
          case 62:
            c = "/";
            break;
          default:
            throw new IllegalStateException("Decoding invalid alphanumeric value: " + sixBitValue);
        }
        return new DecodedChar(pos + 6, c);
      }
      isAlphaTo646ToAlphaLatch(pos) {
        if (pos + 1 > this.information.getSize()) {
          return false;
        }
        for (let i2 = 0; i2 < 5 && i2 + pos < this.information.getSize(); ++i2) {
          if (i2 === 2) {
            if (!this.information.get(pos + 2)) {
              return false;
            }
          } else if (this.information.get(pos + i2)) {
            return false;
          }
        }
        return true;
      }
      isAlphaOr646ToNumericLatch(pos) {
        if (pos + 3 > this.information.getSize()) {
          return false;
        }
        for (let i2 = pos; i2 < pos + 3; ++i2) {
          if (this.information.get(i2)) {
            return false;
          }
        }
        return true;
      }
      isNumericToAlphaNumericLatch(pos) {
        if (pos + 1 > this.information.getSize()) {
          return false;
        }
        for (let i2 = 0; i2 < 4 && i2 + pos < this.information.getSize(); ++i2) {
          if (this.information.get(pos + i2)) {
            return false;
          }
        }
        return true;
      }
    }
    class AbstractExpandedDecoder {
      constructor(information) {
        this.information = information;
        this.generalDecoder = new GeneralAppIdDecoder(information);
      }
      getInformation() {
        return this.information;
      }
      getGeneralDecoder() {
        return this.generalDecoder;
      }
    }
    class AI01decoder extends AbstractExpandedDecoder {
      constructor(information) {
        super(information);
      }
      encodeCompressedGtin(buf, currentPos) {
        buf.append("(01)");
        let initialPosition = buf.length();
        buf.append("9");
        this.encodeCompressedGtinWithoutAI(buf, currentPos, initialPosition);
      }
      encodeCompressedGtinWithoutAI(buf, currentPos, initialBufferPosition) {
        for (let i2 = 0; i2 < 4; ++i2) {
          let currentBlock = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos + 10 * i2, 10);
          if (currentBlock / 100 === 0) {
            buf.append("0");
          }
          if (currentBlock / 10 === 0) {
            buf.append("0");
          }
          buf.append(currentBlock);
        }
        AI01decoder.appendCheckDigit(buf, initialBufferPosition);
      }
      static appendCheckDigit(buf, currentPos) {
        let checkDigit = 0;
        for (let i2 = 0; i2 < 13; i2++) {
          let digit = buf.charAt(i2 + currentPos).charCodeAt(0) - "0".charCodeAt(0);
          checkDigit += (i2 & 1) === 0 ? 3 * digit : digit;
        }
        checkDigit = 10 - checkDigit % 10;
        if (checkDigit === 10) {
          checkDigit = 0;
        }
        buf.append(checkDigit);
      }
    }
    AI01decoder.GTIN_SIZE = 40;
    class AI01AndOtherAIs extends AI01decoder {
      // the second one is the encodation method, and the other two are for the variable length
      constructor(information) {
        super(information);
      }
      parseInformation() {
        let buff = new StringBuilder();
        buff.append("(01)");
        let initialGtinPosition = buff.length();
        let firstGtinDigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01AndOtherAIs.HEADER_SIZE, 4);
        buff.append(firstGtinDigit);
        this.encodeCompressedGtinWithoutAI(buff, AI01AndOtherAIs.HEADER_SIZE + 4, initialGtinPosition);
        return this.getGeneralDecoder().decodeAllCodes(buff, AI01AndOtherAIs.HEADER_SIZE + 44);
      }
    }
    AI01AndOtherAIs.HEADER_SIZE = 1 + 1 + 2;
    class AnyAIDecoder extends AbstractExpandedDecoder {
      constructor(information) {
        super(information);
      }
      parseInformation() {
        let buf = new StringBuilder();
        return this.getGeneralDecoder().decodeAllCodes(buf, AnyAIDecoder.HEADER_SIZE);
      }
    }
    AnyAIDecoder.HEADER_SIZE = 2 + 1 + 2;
    class AI01weightDecoder extends AI01decoder {
      constructor(information) {
        super(information);
      }
      encodeCompressedWeight(buf, currentPos, weightSize) {
        let originalWeightNumeric = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, weightSize);
        this.addWeightCode(buf, originalWeightNumeric);
        let weightNumeric = this.checkWeight(originalWeightNumeric);
        let currentDivisor = 1e5;
        for (let i2 = 0; i2 < 5; ++i2) {
          if (weightNumeric / currentDivisor === 0) {
            buf.append("0");
          }
          currentDivisor /= 10;
        }
        buf.append(weightNumeric);
      }
    }
    class AI013x0xDecoder extends AI01weightDecoder {
      constructor(information) {
        super(information);
      }
      parseInformation() {
        if (this.getInformation().getSize() != AI013x0xDecoder.HEADER_SIZE + AI01weightDecoder.GTIN_SIZE + AI013x0xDecoder.WEIGHT_SIZE) {
          throw new NotFoundException();
        }
        let buf = new StringBuilder();
        this.encodeCompressedGtin(buf, AI013x0xDecoder.HEADER_SIZE);
        this.encodeCompressedWeight(buf, AI013x0xDecoder.HEADER_SIZE + AI01weightDecoder.GTIN_SIZE, AI013x0xDecoder.WEIGHT_SIZE);
        return buf.toString();
      }
    }
    AI013x0xDecoder.HEADER_SIZE = 4 + 1;
    AI013x0xDecoder.WEIGHT_SIZE = 15;
    class AI013103decoder extends AI013x0xDecoder {
      constructor(information) {
        super(information);
      }
      addWeightCode(buf, weight) {
        buf.append("(3103)");
      }
      checkWeight(weight) {
        return weight;
      }
    }
    class AI01320xDecoder extends AI013x0xDecoder {
      constructor(information) {
        super(information);
      }
      addWeightCode(buf, weight) {
        if (weight < 1e4) {
          buf.append("(3202)");
        } else {
          buf.append("(3203)");
        }
      }
      checkWeight(weight) {
        if (weight < 1e4) {
          return weight;
        }
        return weight - 1e4;
      }
    }
    class AI01392xDecoder extends AI01decoder {
      constructor(information) {
        super(information);
      }
      parseInformation() {
        if (this.getInformation().getSize() < AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE) {
          throw new NotFoundException();
        }
        let buf = new StringBuilder();
        this.encodeCompressedGtin(buf, AI01392xDecoder.HEADER_SIZE);
        let lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE, AI01392xDecoder.LAST_DIGIT_SIZE);
        buf.append("(392");
        buf.append(lastAIdigit);
        buf.append(")");
        let decodedInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01392xDecoder.LAST_DIGIT_SIZE, null);
        buf.append(decodedInformation.getNewString());
        return buf.toString();
      }
    }
    AI01392xDecoder.HEADER_SIZE = 5 + 1 + 2;
    AI01392xDecoder.LAST_DIGIT_SIZE = 2;
    class AI01393xDecoder extends AI01decoder {
      constructor(information) {
        super(information);
      }
      parseInformation() {
        if (this.getInformation().getSize() < AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE) {
          throw new NotFoundException();
        }
        let buf = new StringBuilder();
        this.encodeCompressedGtin(buf, AI01393xDecoder.HEADER_SIZE);
        let lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE, AI01393xDecoder.LAST_DIGIT_SIZE);
        buf.append("(393");
        buf.append(lastAIdigit);
        buf.append(")");
        let firstThreeDigits = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE, AI01393xDecoder.FIRST_THREE_DIGITS_SIZE);
        if (firstThreeDigits / 100 == 0) {
          buf.append("0");
        }
        if (firstThreeDigits / 10 == 0) {
          buf.append("0");
        }
        buf.append(firstThreeDigits);
        let generalInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE + AI01393xDecoder.FIRST_THREE_DIGITS_SIZE, null);
        buf.append(generalInformation.getNewString());
        return buf.toString();
      }
    }
    AI01393xDecoder.HEADER_SIZE = 5 + 1 + 2;
    AI01393xDecoder.LAST_DIGIT_SIZE = 2;
    AI01393xDecoder.FIRST_THREE_DIGITS_SIZE = 10;
    class AI013x0x1xDecoder extends AI01weightDecoder {
      constructor(information, firstAIdigits, dateCode) {
        super(information);
        this.dateCode = dateCode;
        this.firstAIdigits = firstAIdigits;
      }
      parseInformation() {
        if (this.getInformation().getSize() != AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE + AI013x0x1xDecoder.DATE_SIZE) {
          throw new NotFoundException();
        }
        let buf = new StringBuilder();
        this.encodeCompressedGtin(buf, AI013x0x1xDecoder.HEADER_SIZE);
        this.encodeCompressedWeight(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE, AI013x0x1xDecoder.WEIGHT_SIZE);
        this.encodeCompressedDate(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE);
        return buf.toString();
      }
      encodeCompressedDate(buf, currentPos) {
        let numericDate = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, AI013x0x1xDecoder.DATE_SIZE);
        if (numericDate == 38400) {
          return;
        }
        buf.append("(");
        buf.append(this.dateCode);
        buf.append(")");
        let day = numericDate % 32;
        numericDate /= 32;
        let month = numericDate % 12 + 1;
        numericDate /= 12;
        let year = numericDate;
        if (year / 10 == 0) {
          buf.append("0");
        }
        buf.append(year);
        if (month / 10 == 0) {
          buf.append("0");
        }
        buf.append(month);
        if (day / 10 == 0) {
          buf.append("0");
        }
        buf.append(day);
      }
      addWeightCode(buf, weight) {
        buf.append("(");
        buf.append(this.firstAIdigits);
        buf.append(weight / 1e5);
        buf.append(")");
      }
      checkWeight(weight) {
        return weight % 1e5;
      }
    }
    AI013x0x1xDecoder.HEADER_SIZE = 7 + 1;
    AI013x0x1xDecoder.WEIGHT_SIZE = 20;
    AI013x0x1xDecoder.DATE_SIZE = 16;
    function createDecoder(information) {
      try {
        if (information.get(1)) {
          return new AI01AndOtherAIs(information);
        }
        if (!information.get(2)) {
          return new AnyAIDecoder(information);
        }
        let fourBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 4);
        switch (fourBitEncodationMethod) {
          case 4:
            return new AI013103decoder(information);
          case 5:
            return new AI01320xDecoder(information);
        }
        let fiveBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 5);
        switch (fiveBitEncodationMethod) {
          case 12:
            return new AI01392xDecoder(information);
          case 13:
            return new AI01393xDecoder(information);
        }
        let sevenBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 7);
        switch (sevenBitEncodationMethod) {
          case 56:
            return new AI013x0x1xDecoder(information, "310", "11");
          case 57:
            return new AI013x0x1xDecoder(information, "320", "11");
          case 58:
            return new AI013x0x1xDecoder(information, "310", "13");
          case 59:
            return new AI013x0x1xDecoder(information, "320", "13");
          case 60:
            return new AI013x0x1xDecoder(information, "310", "15");
          case 61:
            return new AI013x0x1xDecoder(information, "320", "15");
          case 62:
            return new AI013x0x1xDecoder(information, "310", "17");
          case 63:
            return new AI013x0x1xDecoder(information, "320", "17");
        }
      } catch (e) {
        console.log(e);
        throw new IllegalStateException("unknown decoder: " + information);
      }
    }
    class ExpandedPair {
      constructor(leftChar, rightChar, finderPatter, mayBeLast) {
        this.leftchar = leftChar;
        this.rightchar = rightChar;
        this.finderpattern = finderPatter;
        this.maybeLast = mayBeLast;
      }
      mayBeLast() {
        return this.maybeLast;
      }
      getLeftChar() {
        return this.leftchar;
      }
      getRightChar() {
        return this.rightchar;
      }
      getFinderPattern() {
        return this.finderpattern;
      }
      mustBeLast() {
        return this.rightchar == null;
      }
      toString() {
        return "[ " + this.leftchar + ", " + this.rightchar + " : " + (this.finderpattern == null ? "null" : this.finderpattern.getValue()) + " ]";
      }
      static equals(o1, o2) {
        if (!(o1 instanceof ExpandedPair)) {
          return false;
        }
        return ExpandedPair.equalsOrNull(o1.leftchar, o2.leftchar) && ExpandedPair.equalsOrNull(o1.rightchar, o2.rightchar) && ExpandedPair.equalsOrNull(o1.finderpattern, o2.finderpattern);
      }
      static equalsOrNull(o1, o2) {
        return o1 === null ? o2 === null : ExpandedPair.equals(o1, o2);
      }
      hashCode() {
        let value = this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
        return value;
      }
    }
    class ExpandedRow {
      constructor(pairs, rowNumber, wasReversed) {
        this.pairs = pairs;
        this.rowNumber = rowNumber;
        this.wasReversed = wasReversed;
      }
      getPairs() {
        return this.pairs;
      }
      getRowNumber() {
        return this.rowNumber;
      }
      isReversed() {
        return this.wasReversed;
      }
      // check implementation
      isEquivalent(otherPairs) {
        return this.checkEqualitity(this, otherPairs);
      }
      // @Override
      toString() {
        return "{ " + this.pairs + " }";
      }
      /**
       * Two rows are equal if they contain the same pairs in the same order.
       */
      // @Override
      // check implementation
      equals(o1, o2) {
        if (!(o1 instanceof ExpandedRow)) {
          return false;
        }
        return this.checkEqualitity(o1, o2) && o1.wasReversed === o2.wasReversed;
      }
      checkEqualitity(pair1, pair2) {
        if (!pair1 || !pair2)
          return;
        let result2;
        pair1.forEach((e1, i2) => {
          pair2.forEach((e2) => {
            if (e1.getLeftChar().getValue() === e2.getLeftChar().getValue() && e1.getRightChar().getValue() === e2.getRightChar().getValue() && e1.getFinderPatter().getValue() === e2.getFinderPatter().getValue()) {
              result2 = true;
            }
          });
        });
        return result2;
      }
    }
    class RSSExpandedReader extends AbstractRSSReader {
      constructor(verbose) {
        super(...arguments);
        this.pairs = new Array(RSSExpandedReader.MAX_PAIRS);
        this.rows = new Array();
        this.startEnd = [2];
        this.verbose = verbose === true;
      }
      decodeRow(rowNumber, row, hints) {
        this.pairs.length = 0;
        this.startFromEven = false;
        try {
          return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
        } catch (e) {
          if (this.verbose) {
            console.log(e);
          }
        }
        this.pairs.length = 0;
        this.startFromEven = true;
        return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
      }
      reset() {
        this.pairs.length = 0;
        this.rows.length = 0;
      }
      // Not private for testing
      decodeRow2pairs(rowNumber, row) {
        let done = false;
        while (!done) {
          try {
            this.pairs.push(this.retrieveNextPair(row, this.pairs, rowNumber));
          } catch (error2) {
            if (error2 instanceof NotFoundException) {
              if (!this.pairs.length) {
                throw new NotFoundException();
              }
              done = true;
            }
          }
        }
        if (this.checkChecksum()) {
          return this.pairs;
        }
        let tryStackedDecode;
        if (this.rows.length) {
          tryStackedDecode = true;
        } else {
          tryStackedDecode = false;
        }
        this.storeRow(rowNumber, false);
        if (tryStackedDecode) {
          let ps = this.checkRowsBoolean(false);
          if (ps != null) {
            return ps;
          }
          ps = this.checkRowsBoolean(true);
          if (ps != null) {
            return ps;
          }
        }
        throw new NotFoundException();
      }
      // Need to Verify
      checkRowsBoolean(reverse) {
        if (this.rows.length > 25) {
          this.rows.length = 0;
          return null;
        }
        this.pairs.length = 0;
        if (reverse) {
          this.rows = this.rows.reverse();
        }
        let ps = null;
        try {
          ps = this.checkRows(new Array(), 0);
        } catch (e) {
          if (this.verbose) {
            console.log(e);
          }
        }
        if (reverse) {
          this.rows = this.rows.reverse();
        }
        return ps;
      }
      // Try to construct a valid rows sequence
      // Recursion is used to implement backtracking
      checkRows(collectedRows, currentRow) {
        for (let i2 = currentRow; i2 < this.rows.length; i2++) {
          let row = this.rows[i2];
          this.pairs.length = 0;
          for (let collectedRow of collectedRows) {
            this.pairs.push(collectedRow.getPairs());
          }
          this.pairs.push(row.getPairs());
          if (!RSSExpandedReader.isValidSequence(this.pairs)) {
            continue;
          }
          if (this.checkChecksum()) {
            return this.pairs;
          }
          let rs = new Array(collectedRows);
          rs.push(row);
          try {
            return this.checkRows(rs, i2 + 1);
          } catch (e) {
            if (this.verbose) {
              console.log(e);
            }
          }
        }
        throw new NotFoundException();
      }
      // Whether the pairs form a valid find pattern sequence,
      // either complete or a prefix
      static isValidSequence(pairs) {
        for (let sequence of RSSExpandedReader.FINDER_PATTERN_SEQUENCES) {
          if (pairs.length > sequence.length) {
            continue;
          }
          let stop = true;
          for (let j = 0; j < pairs.length; j++) {
            if (pairs[j].getFinderPattern().getValue() != sequence[j]) {
              stop = false;
              break;
            }
          }
          if (stop) {
            return true;
          }
        }
        return false;
      }
      storeRow(rowNumber, wasReversed) {
        let insertPos = 0;
        let prevIsSame = false;
        let nextIsSame = false;
        while (insertPos < this.rows.length) {
          let erow = this.rows[insertPos];
          if (erow.getRowNumber() > rowNumber) {
            nextIsSame = erow.isEquivalent(this.pairs);
            break;
          }
          prevIsSame = erow.isEquivalent(this.pairs);
          insertPos++;
        }
        if (nextIsSame || prevIsSame) {
          return;
        }
        if (RSSExpandedReader.isPartialRow(this.pairs, this.rows)) {
          return;
        }
        this.rows.push(insertPos, new ExpandedRow(this.pairs, rowNumber, wasReversed));
        this.removePartialRows(this.pairs, this.rows);
      }
      // Remove all the rows that contains only specified pairs
      removePartialRows(pairs, rows) {
        for (let row of rows) {
          if (row.getPairs().length === pairs.length) {
            continue;
          }
          for (let p of row.getPairs()) {
            for (let pp of pairs) {
              if (ExpandedPair.equals(p, pp)) {
                break;
              }
            }
          }
        }
      }
      // Returns true when one of the rows already contains all the pairs
      static isPartialRow(pairs, rows) {
        for (let r of rows) {
          let allFound = true;
          for (let p of pairs) {
            let found = false;
            for (let pp of r.getPairs()) {
              if (p.equals(pp)) {
                found = true;
                break;
              }
            }
            if (!found) {
              allFound = false;
              break;
            }
          }
          if (allFound) {
            return true;
          }
        }
        return false;
      }
      // Only used for unit testing
      getRows() {
        return this.rows;
      }
      // Not private for unit testing
      static constructResult(pairs) {
        let binary = BitArrayBuilder.buildBitArray(pairs);
        let decoder = createDecoder(binary);
        let resultingString = decoder.parseInformation();
        let firstPoints = pairs[0].getFinderPattern().getResultPoints();
        let lastPoints = pairs[pairs.length - 1].getFinderPattern().getResultPoints();
        let points = [firstPoints[0], firstPoints[1], lastPoints[0], lastPoints[1]];
        return new Result3(resultingString, null, null, points, BarcodeFormat$1.RSS_EXPANDED, null);
      }
      checkChecksum() {
        let firstPair = this.pairs.get(0);
        let checkCharacter = firstPair.getLeftChar();
        let firstCharacter = firstPair.getRightChar();
        if (firstCharacter == null) {
          return false;
        }
        let checksum = firstCharacter.getChecksumPortion();
        let s2 = 2;
        for (let i2 = 1; i2 < this.pairs.size(); ++i2) {
          let currentPair = this.pairs.get(i2);
          checksum += currentPair.getLeftChar().getChecksumPortion();
          s2++;
          let currentRightChar = currentPair.getRightChar();
          if (currentRightChar != null) {
            checksum += currentRightChar.getChecksumPortion();
            s2++;
          }
        }
        checksum %= 211;
        let checkCharacterValue = 211 * (s2 - 4) + checksum;
        return checkCharacterValue == checkCharacter.getValue();
      }
      static getNextSecondBar(row, initialPos) {
        let currentPos;
        if (row.get(initialPos)) {
          currentPos = row.getNextUnset(initialPos);
          currentPos = row.getNextSet(currentPos);
        } else {
          currentPos = row.getNextSet(initialPos);
          currentPos = row.getNextUnset(currentPos);
        }
        return currentPos;
      }
      // not private for testing
      retrieveNextPair(row, previousPairs, rowNumber) {
        let isOddPattern = previousPairs.length % 2 == 0;
        if (this.startFromEven) {
          isOddPattern = !isOddPattern;
        }
        let pattern;
        let keepFinding = true;
        let forcedOffset = -1;
        do {
          this.findNextPair(row, previousPairs, forcedOffset);
          pattern = this.parseFoundFinderPattern(row, rowNumber, isOddPattern);
          if (pattern == null) {
            forcedOffset = RSSExpandedReader.getNextSecondBar(row, this.startEnd[0]);
          } else {
            keepFinding = false;
          }
        } while (keepFinding);
        let leftChar = this.decodeDataCharacter(row, pattern, isOddPattern, true);
        if (!this.isEmptyPair(previousPairs) && previousPairs[previousPairs.length - 1].mustBeLast()) {
          throw new NotFoundException();
        }
        let rightChar;
        try {
          rightChar = this.decodeDataCharacter(row, pattern, isOddPattern, false);
        } catch (e) {
          rightChar = null;
          if (this.verbose) {
            console.log(e);
          }
        }
        return new ExpandedPair(leftChar, rightChar, pattern, true);
      }
      isEmptyPair(pairs) {
        if (pairs.length === 0) {
          return true;
        }
        return false;
      }
      findNextPair(row, previousPairs, forcedOffset) {
        let counters = this.getDecodeFinderCounters();
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        let width = row.getSize();
        let rowOffset;
        if (forcedOffset >= 0) {
          rowOffset = forcedOffset;
        } else if (this.isEmptyPair(previousPairs)) {
          rowOffset = 0;
        } else {
          let lastPair = previousPairs[previousPairs.length - 1];
          rowOffset = lastPair.getFinderPattern().getStartEnd()[1];
        }
        let searchingEvenPair = previousPairs.length % 2 != 0;
        if (this.startFromEven) {
          searchingEvenPair = !searchingEvenPair;
        }
        let isWhite = false;
        while (rowOffset < width) {
          isWhite = !row.get(rowOffset);
          if (!isWhite) {
            break;
          }
          rowOffset++;
        }
        let counterPosition = 0;
        let patternStart = rowOffset;
        for (let x2 = rowOffset; x2 < width; x2++) {
          if (row.get(x2) != isWhite) {
            counters[counterPosition]++;
          } else {
            if (counterPosition == 3) {
              if (searchingEvenPair) {
                RSSExpandedReader.reverseCounters(counters);
              }
              if (RSSExpandedReader.isFinderPattern(counters)) {
                this.startEnd[0] = patternStart;
                this.startEnd[1] = x2;
                return;
              }
              if (searchingEvenPair) {
                RSSExpandedReader.reverseCounters(counters);
              }
              patternStart += counters[0] + counters[1];
              counters[0] = counters[2];
              counters[1] = counters[3];
              counters[2] = 0;
              counters[3] = 0;
              counterPosition--;
            } else {
              counterPosition++;
            }
            counters[counterPosition] = 1;
            isWhite = !isWhite;
          }
        }
        throw new NotFoundException();
      }
      static reverseCounters(counters) {
        let length = counters.length;
        for (let i2 = 0; i2 < length / 2; ++i2) {
          let tmp = counters[i2];
          counters[i2] = counters[length - i2 - 1];
          counters[length - i2 - 1] = tmp;
        }
      }
      parseFoundFinderPattern(row, rowNumber, oddPattern) {
        let firstCounter;
        let start;
        let end;
        if (oddPattern) {
          let firstElementStart = this.startEnd[0] - 1;
          while (firstElementStart >= 0 && !row.get(firstElementStart)) {
            firstElementStart--;
          }
          firstElementStart++;
          firstCounter = this.startEnd[0] - firstElementStart;
          start = firstElementStart;
          end = this.startEnd[1];
        } else {
          start = this.startEnd[0];
          end = row.getNextUnset(this.startEnd[1] + 1);
          firstCounter = end - this.startEnd[1];
        }
        let counters = this.getDecodeFinderCounters();
        System.arraycopy(counters, 0, counters, 1, counters.length - 1);
        counters[0] = firstCounter;
        let value;
        try {
          value = this.parseFinderValue(counters, RSSExpandedReader.FINDER_PATTERNS);
        } catch (e) {
          return null;
        }
        return new FinderPattern(value, [start, end], start, end, rowNumber);
      }
      decodeDataCharacter(row, pattern, isOddPattern, leftChar) {
        let counters = this.getDataCharacterCounters();
        for (let x2 = 0; x2 < counters.length; x2++) {
          counters[x2] = 0;
        }
        if (leftChar) {
          RSSExpandedReader.recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
        } else {
          RSSExpandedReader.recordPattern(row, pattern.getStartEnd()[1], counters);
          for (let i2 = 0, j = counters.length - 1; i2 < j; i2++, j--) {
            let temp = counters[i2];
            counters[i2] = counters[j];
            counters[j] = temp;
          }
        }
        let numModules = 17;
        let elementWidth = MathUtils2.sum(new Int32Array(counters)) / numModules;
        let expectedElementWidth = (pattern.getStartEnd()[1] - pattern.getStartEnd()[0]) / 15;
        if (Math.abs(elementWidth - expectedElementWidth) / expectedElementWidth > 0.3) {
          throw new NotFoundException();
        }
        let oddCounts = this.getOddCounts();
        let evenCounts = this.getEvenCounts();
        let oddRoundingErrors = this.getOddRoundingErrors();
        let evenRoundingErrors = this.getEvenRoundingErrors();
        for (let i2 = 0; i2 < counters.length; i2++) {
          let value2 = 1 * counters[i2] / elementWidth;
          let count = value2 + 0.5;
          if (count < 1) {
            if (value2 < 0.3) {
              throw new NotFoundException();
            }
            count = 1;
          } else if (count > 8) {
            if (value2 > 8.7) {
              throw new NotFoundException();
            }
            count = 8;
          }
          let offset2 = i2 / 2;
          if ((i2 & 1) == 0) {
            oddCounts[offset2] = count;
            oddRoundingErrors[offset2] = value2 - count;
          } else {
            evenCounts[offset2] = count;
            evenRoundingErrors[offset2] = value2 - count;
          }
        }
        this.adjustOddEvenCounts(numModules);
        let weightRowNumber = 4 * pattern.getValue() + (isOddPattern ? 0 : 2) + (leftChar ? 0 : 1) - 1;
        let oddSum = 0;
        let oddChecksumPortion = 0;
        for (let i2 = oddCounts.length - 1; i2 >= 0; i2--) {
          if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
            let weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i2];
            oddChecksumPortion += oddCounts[i2] * weight;
          }
          oddSum += oddCounts[i2];
        }
        let evenChecksumPortion = 0;
        for (let i2 = evenCounts.length - 1; i2 >= 0; i2--) {
          if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
            let weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i2 + 1];
            evenChecksumPortion += evenCounts[i2] * weight;
          }
        }
        let checksumPortion = oddChecksumPortion + evenChecksumPortion;
        if ((oddSum & 1) != 0 || oddSum > 13 || oddSum < 4) {
          throw new NotFoundException();
        }
        let group = (13 - oddSum) / 2;
        let oddWidest = RSSExpandedReader.SYMBOL_WIDEST[group];
        let evenWidest = 9 - oddWidest;
        let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, true);
        let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, false);
        let tEven = RSSExpandedReader.EVEN_TOTAL_SUBSET[group];
        let gSum = RSSExpandedReader.GSUM[group];
        let value = vOdd * tEven + vEven + gSum;
        return new DataCharacter(value, checksumPortion);
      }
      static isNotA1left(pattern, isOddPattern, leftChar) {
        return !(pattern.getValue() == 0 && isOddPattern && leftChar);
      }
      adjustOddEvenCounts(numModules) {
        let oddSum = MathUtils2.sum(new Int32Array(this.getOddCounts()));
        let evenSum = MathUtils2.sum(new Int32Array(this.getEvenCounts()));
        let incrementOdd = false;
        let decrementOdd = false;
        if (oddSum > 13) {
          decrementOdd = true;
        } else if (oddSum < 4) {
          incrementOdd = true;
        }
        let incrementEven = false;
        let decrementEven = false;
        if (evenSum > 13) {
          decrementEven = true;
        } else if (evenSum < 4) {
          incrementEven = true;
        }
        let mismatch = oddSum + evenSum - numModules;
        let oddParityBad = (oddSum & 1) == 1;
        let evenParityBad = (evenSum & 1) == 0;
        if (mismatch == 1) {
          if (oddParityBad) {
            if (evenParityBad) {
              throw new NotFoundException();
            }
            decrementOdd = true;
          } else {
            if (!evenParityBad) {
              throw new NotFoundException();
            }
            decrementEven = true;
          }
        } else if (mismatch == -1) {
          if (oddParityBad) {
            if (evenParityBad) {
              throw new NotFoundException();
            }
            incrementOdd = true;
          } else {
            if (!evenParityBad) {
              throw new NotFoundException();
            }
            incrementEven = true;
          }
        } else if (mismatch == 0) {
          if (oddParityBad) {
            if (!evenParityBad) {
              throw new NotFoundException();
            }
            if (oddSum < evenSum) {
              incrementOdd = true;
              decrementEven = true;
            } else {
              decrementOdd = true;
              incrementEven = true;
            }
          } else {
            if (evenParityBad) {
              throw new NotFoundException();
            }
          }
        } else {
          throw new NotFoundException();
        }
        if (incrementOdd) {
          if (decrementOdd) {
            throw new NotFoundException();
          }
          RSSExpandedReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (decrementOdd) {
          RSSExpandedReader.decrement(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (incrementEven) {
          if (decrementEven) {
            throw new NotFoundException();
          }
          RSSExpandedReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        if (decrementEven) {
          RSSExpandedReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
        }
      }
    }
    RSSExpandedReader.SYMBOL_WIDEST = [7, 5, 4, 3, 1];
    RSSExpandedReader.EVEN_TOTAL_SUBSET = [4, 20, 52, 104, 204];
    RSSExpandedReader.GSUM = [0, 348, 1388, 2948, 3988];
    RSSExpandedReader.FINDER_PATTERNS = [
      Int32Array.from([1, 8, 4, 1]),
      Int32Array.from([3, 6, 4, 1]),
      Int32Array.from([3, 4, 6, 1]),
      Int32Array.from([3, 2, 8, 1]),
      Int32Array.from([2, 6, 5, 1]),
      Int32Array.from([2, 2, 9, 1])
      // F
    ];
    RSSExpandedReader.WEIGHTS = [
      [1, 3, 9, 27, 81, 32, 96, 77],
      [20, 60, 180, 118, 143, 7, 21, 63],
      [189, 145, 13, 39, 117, 140, 209, 205],
      [193, 157, 49, 147, 19, 57, 171, 91],
      [62, 186, 136, 197, 169, 85, 44, 132],
      [185, 133, 188, 142, 4, 12, 36, 108],
      [113, 128, 173, 97, 80, 29, 87, 50],
      [150, 28, 84, 41, 123, 158, 52, 156],
      [46, 138, 203, 187, 139, 206, 196, 166],
      [76, 17, 51, 153, 37, 111, 122, 155],
      [43, 129, 176, 106, 107, 110, 119, 146],
      [16, 48, 144, 10, 30, 90, 59, 177],
      [109, 116, 137, 200, 178, 112, 125, 164],
      [70, 210, 208, 202, 184, 130, 179, 115],
      [134, 191, 151, 31, 93, 68, 204, 190],
      [148, 22, 66, 198, 172, 94, 71, 2],
      [6, 18, 54, 162, 64, 192, 154, 40],
      [120, 149, 25, 75, 14, 42, 126, 167],
      [79, 26, 78, 23, 69, 207, 199, 175],
      [103, 98, 83, 38, 114, 131, 182, 124],
      [161, 61, 183, 127, 170, 88, 53, 159],
      [55, 165, 73, 8, 24, 72, 5, 15],
      [45, 135, 194, 160, 58, 174, 100, 89]
    ];
    RSSExpandedReader.FINDER_PAT_A = 0;
    RSSExpandedReader.FINDER_PAT_B = 1;
    RSSExpandedReader.FINDER_PAT_C = 2;
    RSSExpandedReader.FINDER_PAT_D = 3;
    RSSExpandedReader.FINDER_PAT_E = 4;
    RSSExpandedReader.FINDER_PAT_F = 5;
    RSSExpandedReader.FINDER_PATTERN_SEQUENCES = [
      [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_A],
      [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_B],
      [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_D],
      [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_C],
      [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_F],
      [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_F, RSSExpandedReader.FINDER_PAT_F],
      [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_D],
      [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_E],
      [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_F, RSSExpandedReader.FINDER_PAT_F],
      [RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_A, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_B, RSSExpandedReader.FINDER_PAT_C, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_D, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_E, RSSExpandedReader.FINDER_PAT_F, RSSExpandedReader.FINDER_PAT_F]
    ];
    RSSExpandedReader.MAX_PAIRS = 11;
    class Pair extends DataCharacter {
      constructor(value, checksumPortion, finderPattern) {
        super(value, checksumPortion);
        this.count = 0;
        this.finderPattern = finderPattern;
      }
      getFinderPattern() {
        return this.finderPattern;
      }
      getCount() {
        return this.count;
      }
      incrementCount() {
        this.count++;
      }
    }
    class RSS14Reader extends AbstractRSSReader {
      constructor() {
        super(...arguments);
        this.possibleLeftPairs = [];
        this.possibleRightPairs = [];
      }
      decodeRow(rowNumber, row, hints) {
        const leftPair = this.decodePair(row, false, rowNumber, hints);
        RSS14Reader.addOrTally(this.possibleLeftPairs, leftPair);
        row.reverse();
        let rightPair = this.decodePair(row, true, rowNumber, hints);
        RSS14Reader.addOrTally(this.possibleRightPairs, rightPair);
        row.reverse();
        for (let left of this.possibleLeftPairs) {
          if (left.getCount() > 1) {
            for (let right of this.possibleRightPairs) {
              if (right.getCount() > 1 && RSS14Reader.checkChecksum(left, right)) {
                return RSS14Reader.constructResult(left, right);
              }
            }
          }
        }
        throw new NotFoundException();
      }
      static addOrTally(possiblePairs, pair) {
        if (pair == null) {
          return;
        }
        let found = false;
        for (let other of possiblePairs) {
          if (other.getValue() === pair.getValue()) {
            other.incrementCount();
            found = true;
            break;
          }
        }
        if (!found) {
          possiblePairs.push(pair);
        }
      }
      reset() {
        this.possibleLeftPairs.length = 0;
        this.possibleRightPairs.length = 0;
      }
      static constructResult(leftPair, rightPair) {
        let symbolValue = 4537077 * leftPair.getValue() + rightPair.getValue();
        let text2 = new String(symbolValue).toString();
        let buffer = new StringBuilder();
        for (let i2 = 13 - text2.length; i2 > 0; i2--) {
          buffer.append("0");
        }
        buffer.append(text2);
        let checkDigit = 0;
        for (let i2 = 0; i2 < 13; i2++) {
          let digit = buffer.charAt(i2).charCodeAt(0) - "0".charCodeAt(0);
          checkDigit += (i2 & 1) === 0 ? 3 * digit : digit;
        }
        checkDigit = 10 - checkDigit % 10;
        if (checkDigit === 10) {
          checkDigit = 0;
        }
        buffer.append(checkDigit.toString());
        let leftPoints = leftPair.getFinderPattern().getResultPoints();
        let rightPoints = rightPair.getFinderPattern().getResultPoints();
        return new Result3(buffer.toString(), null, 0, [leftPoints[0], leftPoints[1], rightPoints[0], rightPoints[1]], BarcodeFormat$1.RSS_14, (/* @__PURE__ */ new Date()).getTime());
      }
      static checkChecksum(leftPair, rightPair) {
        let checkValue = (leftPair.getChecksumPortion() + 16 * rightPair.getChecksumPortion()) % 79;
        let targetCheckValue = 9 * leftPair.getFinderPattern().getValue() + rightPair.getFinderPattern().getValue();
        if (targetCheckValue > 72) {
          targetCheckValue--;
        }
        if (targetCheckValue > 8) {
          targetCheckValue--;
        }
        return checkValue === targetCheckValue;
      }
      decodePair(row, right, rowNumber, hints) {
        try {
          let startEnd = this.findFinderPattern(row, right);
          let pattern = this.parseFoundFinderPattern(row, rowNumber, right, startEnd);
          let resultPointCallback = hints == null ? null : hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
          if (resultPointCallback != null) {
            let center = (startEnd[0] + startEnd[1]) / 2;
            if (right) {
              center = row.getSize() - 1 - center;
            }
            resultPointCallback.foundPossibleResultPoint(new ResultPoint(center, rowNumber));
          }
          let outside = this.decodeDataCharacter(row, pattern, true);
          let inside = this.decodeDataCharacter(row, pattern, false);
          return new Pair(1597 * outside.getValue() + inside.getValue(), outside.getChecksumPortion() + 4 * inside.getChecksumPortion(), pattern);
        } catch (err2) {
          return null;
        }
      }
      decodeDataCharacter(row, pattern, outsideChar) {
        let counters = this.getDataCharacterCounters();
        for (let x2 = 0; x2 < counters.length; x2++) {
          counters[x2] = 0;
        }
        if (outsideChar) {
          OneDReader.recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
        } else {
          OneDReader.recordPattern(row, pattern.getStartEnd()[1] + 1, counters);
          for (let i2 = 0, j = counters.length - 1; i2 < j; i2++, j--) {
            let temp = counters[i2];
            counters[i2] = counters[j];
            counters[j] = temp;
          }
        }
        let numModules = outsideChar ? 16 : 15;
        let elementWidth = MathUtils2.sum(new Int32Array(counters)) / numModules;
        let oddCounts = this.getOddCounts();
        let evenCounts = this.getEvenCounts();
        let oddRoundingErrors = this.getOddRoundingErrors();
        let evenRoundingErrors = this.getEvenRoundingErrors();
        for (let i2 = 0; i2 < counters.length; i2++) {
          let value = counters[i2] / elementWidth;
          let count = Math.floor(value + 0.5);
          if (count < 1) {
            count = 1;
          } else if (count > 8) {
            count = 8;
          }
          let offset2 = Math.floor(i2 / 2);
          if ((i2 & 1) === 0) {
            oddCounts[offset2] = count;
            oddRoundingErrors[offset2] = value - count;
          } else {
            evenCounts[offset2] = count;
            evenRoundingErrors[offset2] = value - count;
          }
        }
        this.adjustOddEvenCounts(outsideChar, numModules);
        let oddSum = 0;
        let oddChecksumPortion = 0;
        for (let i2 = oddCounts.length - 1; i2 >= 0; i2--) {
          oddChecksumPortion *= 9;
          oddChecksumPortion += oddCounts[i2];
          oddSum += oddCounts[i2];
        }
        let evenChecksumPortion = 0;
        let evenSum = 0;
        for (let i2 = evenCounts.length - 1; i2 >= 0; i2--) {
          evenChecksumPortion *= 9;
          evenChecksumPortion += evenCounts[i2];
          evenSum += evenCounts[i2];
        }
        let checksumPortion = oddChecksumPortion + 3 * evenChecksumPortion;
        if (outsideChar) {
          if ((oddSum & 1) !== 0 || oddSum > 12 || oddSum < 4) {
            throw new NotFoundException();
          }
          let group = (12 - oddSum) / 2;
          let oddWidest = RSS14Reader.OUTSIDE_ODD_WIDEST[group];
          let evenWidest = 9 - oddWidest;
          let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, false);
          let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, true);
          let tEven = RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET[group];
          let gSum = RSS14Reader.OUTSIDE_GSUM[group];
          return new DataCharacter(vOdd * tEven + vEven + gSum, checksumPortion);
        } else {
          if ((evenSum & 1) !== 0 || evenSum > 10 || evenSum < 4) {
            throw new NotFoundException();
          }
          let group = (10 - evenSum) / 2;
          let oddWidest = RSS14Reader.INSIDE_ODD_WIDEST[group];
          let evenWidest = 9 - oddWidest;
          let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, true);
          let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, false);
          let tOdd = RSS14Reader.INSIDE_ODD_TOTAL_SUBSET[group];
          let gSum = RSS14Reader.INSIDE_GSUM[group];
          return new DataCharacter(vEven * tOdd + vOdd + gSum, checksumPortion);
        }
      }
      findFinderPattern(row, rightFinderPattern) {
        let counters = this.getDecodeFinderCounters();
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        let width = row.getSize();
        let isWhite = false;
        let rowOffset = 0;
        while (rowOffset < width) {
          isWhite = !row.get(rowOffset);
          if (rightFinderPattern === isWhite) {
            break;
          }
          rowOffset++;
        }
        let counterPosition = 0;
        let patternStart = rowOffset;
        for (let x2 = rowOffset; x2 < width; x2++) {
          if (row.get(x2) !== isWhite) {
            counters[counterPosition]++;
          } else {
            if (counterPosition === 3) {
              if (AbstractRSSReader.isFinderPattern(counters)) {
                return [patternStart, x2];
              }
              patternStart += counters[0] + counters[1];
              counters[0] = counters[2];
              counters[1] = counters[3];
              counters[2] = 0;
              counters[3] = 0;
              counterPosition--;
            } else {
              counterPosition++;
            }
            counters[counterPosition] = 1;
            isWhite = !isWhite;
          }
        }
        throw new NotFoundException();
      }
      parseFoundFinderPattern(row, rowNumber, right, startEnd) {
        let firstIsBlack = row.get(startEnd[0]);
        let firstElementStart = startEnd[0] - 1;
        while (firstElementStart >= 0 && firstIsBlack !== row.get(firstElementStart)) {
          firstElementStart--;
        }
        firstElementStart++;
        const firstCounter = startEnd[0] - firstElementStart;
        const counters = this.getDecodeFinderCounters();
        const copy = new Int32Array(counters.length);
        System.arraycopy(counters, 0, copy, 1, counters.length - 1);
        copy[0] = firstCounter;
        const value = this.parseFinderValue(copy, RSS14Reader.FINDER_PATTERNS);
        let start = firstElementStart;
        let end = startEnd[1];
        if (right) {
          start = row.getSize() - 1 - start;
          end = row.getSize() - 1 - end;
        }
        return new FinderPattern(value, [firstElementStart, startEnd[1]], start, end, rowNumber);
      }
      adjustOddEvenCounts(outsideChar, numModules) {
        let oddSum = MathUtils2.sum(new Int32Array(this.getOddCounts()));
        let evenSum = MathUtils2.sum(new Int32Array(this.getEvenCounts()));
        let incrementOdd = false;
        let decrementOdd = false;
        let incrementEven = false;
        let decrementEven = false;
        if (outsideChar) {
          if (oddSum > 12) {
            decrementOdd = true;
          } else if (oddSum < 4) {
            incrementOdd = true;
          }
          if (evenSum > 12) {
            decrementEven = true;
          } else if (evenSum < 4) {
            incrementEven = true;
          }
        } else {
          if (oddSum > 11) {
            decrementOdd = true;
          } else if (oddSum < 5) {
            incrementOdd = true;
          }
          if (evenSum > 10) {
            decrementEven = true;
          } else if (evenSum < 4) {
            incrementEven = true;
          }
        }
        let mismatch = oddSum + evenSum - numModules;
        let oddParityBad = (oddSum & 1) === (outsideChar ? 1 : 0);
        let evenParityBad = (evenSum & 1) === 1;
        if (mismatch === 1) {
          if (oddParityBad) {
            if (evenParityBad) {
              throw new NotFoundException();
            }
            decrementOdd = true;
          } else {
            if (!evenParityBad) {
              throw new NotFoundException();
            }
            decrementEven = true;
          }
        } else if (mismatch === -1) {
          if (oddParityBad) {
            if (evenParityBad) {
              throw new NotFoundException();
            }
            incrementOdd = true;
          } else {
            if (!evenParityBad) {
              throw new NotFoundException();
            }
            incrementEven = true;
          }
        } else if (mismatch === 0) {
          if (oddParityBad) {
            if (!evenParityBad) {
              throw new NotFoundException();
            }
            if (oddSum < evenSum) {
              incrementOdd = true;
              decrementEven = true;
            } else {
              decrementOdd = true;
              incrementEven = true;
            }
          } else {
            if (evenParityBad) {
              throw new NotFoundException();
            }
          }
        } else {
          throw new NotFoundException();
        }
        if (incrementOdd) {
          if (decrementOdd) {
            throw new NotFoundException();
          }
          AbstractRSSReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (decrementOdd) {
          AbstractRSSReader.decrement(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (incrementEven) {
          if (decrementEven) {
            throw new NotFoundException();
          }
          AbstractRSSReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        if (decrementEven) {
          AbstractRSSReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
        }
      }
    }
    RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET = [1, 10, 34, 70, 126];
    RSS14Reader.INSIDE_ODD_TOTAL_SUBSET = [4, 20, 48, 81];
    RSS14Reader.OUTSIDE_GSUM = [0, 161, 961, 2015, 2715];
    RSS14Reader.INSIDE_GSUM = [0, 336, 1036, 1516];
    RSS14Reader.OUTSIDE_ODD_WIDEST = [8, 6, 4, 3, 1];
    RSS14Reader.INSIDE_ODD_WIDEST = [2, 4, 6, 8];
    RSS14Reader.FINDER_PATTERNS = [
      Int32Array.from([3, 8, 2, 1]),
      Int32Array.from([3, 5, 5, 1]),
      Int32Array.from([3, 3, 7, 1]),
      Int32Array.from([3, 1, 9, 1]),
      Int32Array.from([2, 7, 4, 1]),
      Int32Array.from([2, 5, 6, 1]),
      Int32Array.from([2, 3, 8, 1]),
      Int32Array.from([1, 5, 7, 1]),
      Int32Array.from([1, 3, 9, 1])
    ];
    class MultiFormatOneDReader extends OneDReader {
      constructor(hints, verbose) {
        super();
        this.readers = [];
        this.verbose = verbose === true;
        const possibleFormats = !hints ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
        const useCode39CheckDigit = hints && hints.get(DecodeHintType$1.ASSUME_CODE_39_CHECK_DIGIT) !== void 0;
        if (possibleFormats) {
          if (possibleFormats.includes(BarcodeFormat$1.EAN_13) || possibleFormats.includes(BarcodeFormat$1.UPC_A) || possibleFormats.includes(BarcodeFormat$1.EAN_8) || possibleFormats.includes(BarcodeFormat$1.UPC_E)) {
            this.readers.push(new MultiFormatUPCEANReader(hints));
          }
          if (possibleFormats.includes(BarcodeFormat$1.CODE_39)) {
            this.readers.push(new Code39Reader(useCode39CheckDigit));
          }
          if (possibleFormats.includes(BarcodeFormat$1.CODE_128)) {
            this.readers.push(new Code128Reader());
          }
          if (possibleFormats.includes(BarcodeFormat$1.ITF)) {
            this.readers.push(new ITFReader());
          }
          if (possibleFormats.includes(BarcodeFormat$1.RSS_14)) {
            this.readers.push(new RSS14Reader());
          }
          if (possibleFormats.includes(BarcodeFormat$1.RSS_EXPANDED)) {
            this.readers.push(new RSSExpandedReader(this.verbose));
          }
        } else {
          this.readers.push(new MultiFormatUPCEANReader(hints));
          this.readers.push(new Code39Reader());
          this.readers.push(new MultiFormatUPCEANReader(hints));
          this.readers.push(new Code128Reader());
          this.readers.push(new ITFReader());
          this.readers.push(new RSS14Reader());
          this.readers.push(new RSSExpandedReader(this.verbose));
        }
      }
      // @Override
      decodeRow(rowNumber, row, hints) {
        for (let i2 = 0; i2 < this.readers.length; i2++) {
          try {
            return this.readers[i2].decodeRow(rowNumber, row, hints);
          } catch (re) {
          }
        }
        throw new NotFoundException();
      }
      // @Override
      reset() {
        this.readers.forEach((reader) => reader.reset());
      }
    }
    class BrowserBarcodeReader extends BrowserCodeReader {
      /**
       * Creates an instance of BrowserBarcodeReader.
       * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
       * @param {Map<DecodeHintType, any>} hints
       */
      constructor(timeBetweenScansMillis = 500, hints) {
        super(new MultiFormatOneDReader(hints), timeBetweenScansMillis, hints);
      }
    }
    class ECBlocks {
      constructor(ecCodewords, ecBlocks1, ecBlocks2) {
        this.ecCodewords = ecCodewords;
        this.ecBlocks = [ecBlocks1];
        ecBlocks2 && this.ecBlocks.push(ecBlocks2);
      }
      getECCodewords() {
        return this.ecCodewords;
      }
      getECBlocks() {
        return this.ecBlocks;
      }
    }
    class ECB {
      constructor(count, dataCodewords) {
        this.count = count;
        this.dataCodewords = dataCodewords;
      }
      getCount() {
        return this.count;
      }
      getDataCodewords() {
        return this.dataCodewords;
      }
    }
    class Version {
      constructor(versionNumber, symbolSizeRows, symbolSizeColumns, dataRegionSizeRows, dataRegionSizeColumns, ecBlocks) {
        this.versionNumber = versionNumber;
        this.symbolSizeRows = symbolSizeRows;
        this.symbolSizeColumns = symbolSizeColumns;
        this.dataRegionSizeRows = dataRegionSizeRows;
        this.dataRegionSizeColumns = dataRegionSizeColumns;
        this.ecBlocks = ecBlocks;
        let total = 0;
        const ecCodewords = ecBlocks.getECCodewords();
        const ecbArray = ecBlocks.getECBlocks();
        for (let ecBlock of ecbArray) {
          total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
        }
        this.totalCodewords = total;
      }
      getVersionNumber() {
        return this.versionNumber;
      }
      getSymbolSizeRows() {
        return this.symbolSizeRows;
      }
      getSymbolSizeColumns() {
        return this.symbolSizeColumns;
      }
      getDataRegionSizeRows() {
        return this.dataRegionSizeRows;
      }
      getDataRegionSizeColumns() {
        return this.dataRegionSizeColumns;
      }
      getTotalCodewords() {
        return this.totalCodewords;
      }
      getECBlocks() {
        return this.ecBlocks;
      }
      /**
       * <p>Deduces version information from Data Matrix dimensions.</p>
       *
       * @param numRows Number of rows in modules
       * @param numColumns Number of columns in modules
       * @return Version for a Data Matrix Code of those dimensions
       * @throws FormatException if dimensions do correspond to a valid Data Matrix size
       */
      static getVersionForDimensions(numRows, numColumns) {
        if ((numRows & 1) !== 0 || (numColumns & 1) !== 0) {
          throw new FormatException();
        }
        for (let version2 of Version.VERSIONS) {
          if (version2.symbolSizeRows === numRows && version2.symbolSizeColumns === numColumns) {
            return version2;
          }
        }
        throw new FormatException();
      }
      //  @Override
      toString() {
        return "" + this.versionNumber;
      }
      /**
       * See ISO 16022:2006 5.5.1 Table 7
       */
      static buildVersions() {
        return [
          new Version(1, 10, 10, 8, 8, new ECBlocks(5, new ECB(1, 3))),
          new Version(2, 12, 12, 10, 10, new ECBlocks(7, new ECB(1, 5))),
          new Version(3, 14, 14, 12, 12, new ECBlocks(10, new ECB(1, 8))),
          new Version(4, 16, 16, 14, 14, new ECBlocks(12, new ECB(1, 12))),
          new Version(5, 18, 18, 16, 16, new ECBlocks(14, new ECB(1, 18))),
          new Version(6, 20, 20, 18, 18, new ECBlocks(18, new ECB(1, 22))),
          new Version(7, 22, 22, 20, 20, new ECBlocks(20, new ECB(1, 30))),
          new Version(8, 24, 24, 22, 22, new ECBlocks(24, new ECB(1, 36))),
          new Version(9, 26, 26, 24, 24, new ECBlocks(28, new ECB(1, 44))),
          new Version(10, 32, 32, 14, 14, new ECBlocks(36, new ECB(1, 62))),
          new Version(11, 36, 36, 16, 16, new ECBlocks(42, new ECB(1, 86))),
          new Version(12, 40, 40, 18, 18, new ECBlocks(48, new ECB(1, 114))),
          new Version(13, 44, 44, 20, 20, new ECBlocks(56, new ECB(1, 144))),
          new Version(14, 48, 48, 22, 22, new ECBlocks(68, new ECB(1, 174))),
          new Version(15, 52, 52, 24, 24, new ECBlocks(42, new ECB(2, 102))),
          new Version(16, 64, 64, 14, 14, new ECBlocks(56, new ECB(2, 140))),
          new Version(17, 72, 72, 16, 16, new ECBlocks(36, new ECB(4, 92))),
          new Version(18, 80, 80, 18, 18, new ECBlocks(48, new ECB(4, 114))),
          new Version(19, 88, 88, 20, 20, new ECBlocks(56, new ECB(4, 144))),
          new Version(20, 96, 96, 22, 22, new ECBlocks(68, new ECB(4, 174))),
          new Version(21, 104, 104, 24, 24, new ECBlocks(56, new ECB(6, 136))),
          new Version(22, 120, 120, 18, 18, new ECBlocks(68, new ECB(6, 175))),
          new Version(23, 132, 132, 20, 20, new ECBlocks(62, new ECB(8, 163))),
          new Version(24, 144, 144, 22, 22, new ECBlocks(62, new ECB(8, 156), new ECB(2, 155))),
          new Version(25, 8, 18, 6, 16, new ECBlocks(7, new ECB(1, 5))),
          new Version(26, 8, 32, 6, 14, new ECBlocks(11, new ECB(1, 10))),
          new Version(27, 12, 26, 10, 24, new ECBlocks(14, new ECB(1, 16))),
          new Version(28, 12, 36, 10, 16, new ECBlocks(18, new ECB(1, 22))),
          new Version(29, 16, 36, 14, 16, new ECBlocks(24, new ECB(1, 32))),
          new Version(30, 16, 48, 14, 22, new ECBlocks(28, new ECB(1, 49)))
        ];
      }
    }
    Version.VERSIONS = Version.buildVersions();
    class BitMatrixParser {
      /**
       * @param bitMatrix {@link BitMatrix} to parse
       * @throws FormatException if dimension is < 8 or > 144 or not 0 mod 2
       */
      constructor(bitMatrix) {
        const dimension = bitMatrix.getHeight();
        if (dimension < 8 || dimension > 144 || (dimension & 1) !== 0) {
          throw new FormatException();
        }
        this.version = BitMatrixParser.readVersion(bitMatrix);
        this.mappingBitMatrix = this.extractDataRegion(bitMatrix);
        this.readMappingMatrix = new BitMatrix(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
      }
      getVersion() {
        return this.version;
      }
      /**
       * <p>Creates the version object based on the dimension of the original bit matrix from
       * the datamatrix code.</p>
       *
       * <p>See ISO 16022:2006 Table 7 - ECC 200 symbol attributes</p>
       *
       * @param bitMatrix Original {@link BitMatrix} including alignment patterns
       * @return {@link Version} encapsulating the Data Matrix Code's "version"
       * @throws FormatException if the dimensions of the mapping matrix are not valid
       * Data Matrix dimensions.
       */
      static readVersion(bitMatrix) {
        const numRows = bitMatrix.getHeight();
        const numColumns = bitMatrix.getWidth();
        return Version.getVersionForDimensions(numRows, numColumns);
      }
      /**
       * <p>Reads the bits in the {@link BitMatrix} representing the mapping matrix (No alignment patterns)
       * in the correct order in order to reconstitute the codewords bytes contained within the
       * Data Matrix Code.</p>
       *
       * @return bytes encoded within the Data Matrix Code
       * @throws FormatException if the exact number of bytes expected is not read
       */
      readCodewords() {
        const result2 = new Int8Array(this.version.getTotalCodewords());
        let resultOffset = 0;
        let row = 4;
        let column = 0;
        const numRows = this.mappingBitMatrix.getHeight();
        const numColumns = this.mappingBitMatrix.getWidth();
        let corner1Read = false;
        let corner2Read = false;
        let corner3Read = false;
        let corner4Read = false;
        do {
          if (row === numRows && column === 0 && !corner1Read) {
            result2[resultOffset++] = this.readCorner1(numRows, numColumns) & 255;
            row -= 2;
            column += 2;
            corner1Read = true;
          } else if (row === numRows - 2 && column === 0 && (numColumns & 3) !== 0 && !corner2Read) {
            result2[resultOffset++] = this.readCorner2(numRows, numColumns) & 255;
            row -= 2;
            column += 2;
            corner2Read = true;
          } else if (row === numRows + 4 && column === 2 && (numColumns & 7) === 0 && !corner3Read) {
            result2[resultOffset++] = this.readCorner3(numRows, numColumns) & 255;
            row -= 2;
            column += 2;
            corner3Read = true;
          } else if (row === numRows - 2 && column === 0 && (numColumns & 7) === 4 && !corner4Read) {
            result2[resultOffset++] = this.readCorner4(numRows, numColumns) & 255;
            row -= 2;
            column += 2;
            corner4Read = true;
          } else {
            do {
              if (row < numRows && column >= 0 && !this.readMappingMatrix.get(column, row)) {
                result2[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 255;
              }
              row -= 2;
              column += 2;
            } while (row >= 0 && column < numColumns);
            row += 1;
            column += 3;
            do {
              if (row >= 0 && column < numColumns && !this.readMappingMatrix.get(column, row)) {
                result2[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 255;
              }
              row += 2;
              column -= 2;
            } while (row < numRows && column >= 0);
            row += 3;
            column += 1;
          }
        } while (row < numRows || column < numColumns);
        if (resultOffset !== this.version.getTotalCodewords()) {
          throw new FormatException();
        }
        return result2;
      }
      /**
       * <p>Reads a bit of the mapping matrix accounting for boundary wrapping.</p>
       *
       * @param row Row to read in the mapping matrix
       * @param column Column to read in the mapping matrix
       * @param numRows Number of rows in the mapping matrix
       * @param numColumns Number of columns in the mapping matrix
       * @return value of the given bit in the mapping matrix
       */
      readModule(row, column, numRows, numColumns) {
        if (row < 0) {
          row += numRows;
          column += 4 - (numRows + 4 & 7);
        }
        if (column < 0) {
          column += numColumns;
          row += 4 - (numColumns + 4 & 7);
        }
        this.readMappingMatrix.set(column, row);
        return this.mappingBitMatrix.get(column, row);
      }
      /**
       * <p>Reads the 8 bits of the standard Utah-shaped pattern.</p>
       *
       * <p>See ISO 16022:2006, 5.8.1 Figure 6</p>
       *
       * @param row Current row in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
       * @param column Current column in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
       * @param numRows Number of rows in the mapping matrix
       * @param numColumns Number of columns in the mapping matrix
       * @return byte from the utah shape
       */
      readUtah(row, column, numRows, numColumns) {
        let currentByte = 0;
        if (this.readModule(row - 2, column - 2, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(row - 2, column - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(row - 1, column - 2, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(row - 1, column - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(row - 1, column, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(row, column - 2, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(row, column - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(row, column, numRows, numColumns)) {
          currentByte |= 1;
        }
        return currentByte;
      }
      /**
       * <p>Reads the 8 bits of the special corner condition 1.</p>
       *
       * <p>See ISO 16022:2006, Figure F.3</p>
       *
       * @param numRows Number of rows in the mapping matrix
       * @param numColumns Number of columns in the mapping matrix
       * @return byte from the Corner condition 1
       */
      readCorner1(numRows, numColumns) {
        let currentByte = 0;
        if (this.readModule(numRows - 1, 0, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(numRows - 1, 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(numRows - 1, 2, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 2, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(2, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(3, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        return currentByte;
      }
      /**
       * <p>Reads the 8 bits of the special corner condition 2.</p>
       *
       * <p>See ISO 16022:2006, Figure F.4</p>
       *
       * @param numRows Number of rows in the mapping matrix
       * @param numColumns Number of columns in the mapping matrix
       * @return byte from the Corner condition 2
       */
      readCorner2(numRows, numColumns) {
        let currentByte = 0;
        if (this.readModule(numRows - 3, 0, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(numRows - 2, 0, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(numRows - 1, 0, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 4, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 3, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 2, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        return currentByte;
      }
      /**
       * <p>Reads the 8 bits of the special corner condition 3.</p>
       *
       * <p>See ISO 16022:2006, Figure F.5</p>
       *
       * @param numRows Number of rows in the mapping matrix
       * @param numColumns Number of columns in the mapping matrix
       * @return byte from the Corner condition 3
       */
      readCorner3(numRows, numColumns) {
        let currentByte = 0;
        if (this.readModule(numRows - 1, 0, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(numRows - 1, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 3, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 2, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 3, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 2, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        return currentByte;
      }
      /**
       * <p>Reads the 8 bits of the special corner condition 4.</p>
       *
       * <p>See ISO 16022:2006, Figure F.6</p>
       *
       * @param numRows Number of rows in the mapping matrix
       * @param numColumns Number of columns in the mapping matrix
       * @return byte from the Corner condition 4
       */
      readCorner4(numRows, numColumns) {
        let currentByte = 0;
        if (this.readModule(numRows - 3, 0, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(numRows - 2, 0, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(numRows - 1, 0, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 2, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(2, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        currentByte <<= 1;
        if (this.readModule(3, numColumns - 1, numRows, numColumns)) {
          currentByte |= 1;
        }
        return currentByte;
      }
      /**
       * <p>Extracts the data region from a {@link BitMatrix} that contains
       * alignment patterns.</p>
       *
       * @param bitMatrix Original {@link BitMatrix} with alignment patterns
       * @return BitMatrix that has the alignment patterns removed
       */
      extractDataRegion(bitMatrix) {
        const symbolSizeRows = this.version.getSymbolSizeRows();
        const symbolSizeColumns = this.version.getSymbolSizeColumns();
        if (bitMatrix.getHeight() !== symbolSizeRows) {
          throw new IllegalArgumentException("Dimension of bitMatrix must match the version size");
        }
        const dataRegionSizeRows = this.version.getDataRegionSizeRows();
        const dataRegionSizeColumns = this.version.getDataRegionSizeColumns();
        const numDataRegionsRow = symbolSizeRows / dataRegionSizeRows | 0;
        const numDataRegionsColumn = symbolSizeColumns / dataRegionSizeColumns | 0;
        const sizeDataRegionRow = numDataRegionsRow * dataRegionSizeRows;
        const sizeDataRegionColumn = numDataRegionsColumn * dataRegionSizeColumns;
        const bitMatrixWithoutAlignment = new BitMatrix(sizeDataRegionColumn, sizeDataRegionRow);
        for (let dataRegionRow = 0; dataRegionRow < numDataRegionsRow; ++dataRegionRow) {
          const dataRegionRowOffset = dataRegionRow * dataRegionSizeRows;
          for (let dataRegionColumn = 0; dataRegionColumn < numDataRegionsColumn; ++dataRegionColumn) {
            const dataRegionColumnOffset = dataRegionColumn * dataRegionSizeColumns;
            for (let i2 = 0; i2 < dataRegionSizeRows; ++i2) {
              const readRowOffset = dataRegionRow * (dataRegionSizeRows + 2) + 1 + i2;
              const writeRowOffset = dataRegionRowOffset + i2;
              for (let j = 0; j < dataRegionSizeColumns; ++j) {
                const readColumnOffset = dataRegionColumn * (dataRegionSizeColumns + 2) + 1 + j;
                if (bitMatrix.get(readColumnOffset, readRowOffset)) {
                  const writeColumnOffset = dataRegionColumnOffset + j;
                  bitMatrixWithoutAlignment.set(writeColumnOffset, writeRowOffset);
                }
              }
            }
          }
        }
        return bitMatrixWithoutAlignment;
      }
    }
    class DataBlock {
      constructor(numDataCodewords, codewords) {
        this.numDataCodewords = numDataCodewords;
        this.codewords = codewords;
      }
      /**
       * <p>When Data Matrix Codes use multiple data blocks, they actually interleave the bytes of each of them.
       * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
       * method will separate the data into original blocks.</p>
       *
       * @param rawCodewords bytes as read directly from the Data Matrix Code
       * @param version version of the Data Matrix Code
       * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
       *         Data Matrix Code
       */
      static getDataBlocks(rawCodewords, version2) {
        const ecBlocks = version2.getECBlocks();
        let totalBlocks = 0;
        const ecBlockArray = ecBlocks.getECBlocks();
        for (let ecBlock of ecBlockArray) {
          totalBlocks += ecBlock.getCount();
        }
        const result2 = new Array(totalBlocks);
        let numResultBlocks = 0;
        for (let ecBlock of ecBlockArray) {
          for (let i2 = 0; i2 < ecBlock.getCount(); i2++) {
            const numDataCodewords = ecBlock.getDataCodewords();
            const numBlockCodewords = ecBlocks.getECCodewords() + numDataCodewords;
            result2[numResultBlocks++] = new DataBlock(numDataCodewords, new Uint8Array(numBlockCodewords));
          }
        }
        const longerBlocksTotalCodewords = result2[0].codewords.length;
        const longerBlocksNumDataCodewords = longerBlocksTotalCodewords - ecBlocks.getECCodewords();
        const shorterBlocksNumDataCodewords = longerBlocksNumDataCodewords - 1;
        let rawCodewordsOffset = 0;
        for (let i2 = 0; i2 < shorterBlocksNumDataCodewords; i2++) {
          for (let j = 0; j < numResultBlocks; j++) {
            result2[j].codewords[i2] = rawCodewords[rawCodewordsOffset++];
          }
        }
        const specialVersion = version2.getVersionNumber() === 24;
        const numLongerBlocks = specialVersion ? 8 : numResultBlocks;
        for (let j = 0; j < numLongerBlocks; j++) {
          result2[j].codewords[longerBlocksNumDataCodewords - 1] = rawCodewords[rawCodewordsOffset++];
        }
        const max2 = result2[0].codewords.length;
        for (let i2 = longerBlocksNumDataCodewords; i2 < max2; i2++) {
          for (let j = 0; j < numResultBlocks; j++) {
            const jOffset = specialVersion ? (j + 8) % numResultBlocks : j;
            const iOffset = specialVersion && jOffset > 7 ? i2 - 1 : i2;
            result2[jOffset].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
          }
        }
        if (rawCodewordsOffset !== rawCodewords.length) {
          throw new IllegalArgumentException();
        }
        return result2;
      }
      getNumDataCodewords() {
        return this.numDataCodewords;
      }
      getCodewords() {
        return this.codewords;
      }
    }
    class BitSource {
      /**
       * @param bytes bytes from which this will read bits. Bits will be read from the first byte first.
       * Bits are read within a byte from most-significant to least-significant bit.
       */
      constructor(bytes) {
        this.bytes = bytes;
        this.byteOffset = 0;
        this.bitOffset = 0;
      }
      /**
       * @return index of next bit in current byte which would be read by the next call to {@link #readBits(int)}.
       */
      getBitOffset() {
        return this.bitOffset;
      }
      /**
       * @return index of next byte in input byte array which would be read by the next call to {@link #readBits(int)}.
       */
      getByteOffset() {
        return this.byteOffset;
      }
      /**
       * @param numBits number of bits to read
       * @return int representing the bits read. The bits will appear as the least-significant
       *         bits of the int
       * @throws IllegalArgumentException if numBits isn't in [1,32] or more than is available
       */
      readBits(numBits) {
        if (numBits < 1 || numBits > 32 || numBits > this.available()) {
          throw new IllegalArgumentException("" + numBits);
        }
        let result2 = 0;
        let bitOffset = this.bitOffset;
        let byteOffset = this.byteOffset;
        const bytes = this.bytes;
        if (bitOffset > 0) {
          const bitsLeft = 8 - bitOffset;
          const toRead = numBits < bitsLeft ? numBits : bitsLeft;
          const bitsToNotRead = bitsLeft - toRead;
          const mask = 255 >> 8 - toRead << bitsToNotRead;
          result2 = (bytes[byteOffset] & mask) >> bitsToNotRead;
          numBits -= toRead;
          bitOffset += toRead;
          if (bitOffset === 8) {
            bitOffset = 0;
            byteOffset++;
          }
        }
        if (numBits > 0) {
          while (numBits >= 8) {
            result2 = result2 << 8 | bytes[byteOffset] & 255;
            byteOffset++;
            numBits -= 8;
          }
          if (numBits > 0) {
            const bitsToNotRead = 8 - numBits;
            const mask = 255 >> bitsToNotRead << bitsToNotRead;
            result2 = result2 << numBits | (bytes[byteOffset] & mask) >> bitsToNotRead;
            bitOffset += numBits;
          }
        }
        this.bitOffset = bitOffset;
        this.byteOffset = byteOffset;
        return result2;
      }
      /**
       * @return number of bits that can be read successfully
       */
      available() {
        return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
      }
    }
    var Mode;
    (function(Mode2) {
      Mode2[Mode2["PAD_ENCODE"] = 0] = "PAD_ENCODE";
      Mode2[Mode2["ASCII_ENCODE"] = 1] = "ASCII_ENCODE";
      Mode2[Mode2["C40_ENCODE"] = 2] = "C40_ENCODE";
      Mode2[Mode2["TEXT_ENCODE"] = 3] = "TEXT_ENCODE";
      Mode2[Mode2["ANSIX12_ENCODE"] = 4] = "ANSIX12_ENCODE";
      Mode2[Mode2["EDIFACT_ENCODE"] = 5] = "EDIFACT_ENCODE";
      Mode2[Mode2["BASE256_ENCODE"] = 6] = "BASE256_ENCODE";
    })(Mode || (Mode = {}));
    class DecodedBitStreamParser {
      static decode(bytes) {
        const bits = new BitSource(bytes);
        const result2 = new StringBuilder();
        const resultTrailer = new StringBuilder();
        const byteSegments = new Array();
        let mode = Mode.ASCII_ENCODE;
        do {
          if (mode === Mode.ASCII_ENCODE) {
            mode = this.decodeAsciiSegment(bits, result2, resultTrailer);
          } else {
            switch (mode) {
              case Mode.C40_ENCODE:
                this.decodeC40Segment(bits, result2);
                break;
              case Mode.TEXT_ENCODE:
                this.decodeTextSegment(bits, result2);
                break;
              case Mode.ANSIX12_ENCODE:
                this.decodeAnsiX12Segment(bits, result2);
                break;
              case Mode.EDIFACT_ENCODE:
                this.decodeEdifactSegment(bits, result2);
                break;
              case Mode.BASE256_ENCODE:
                this.decodeBase256Segment(bits, result2, byteSegments);
                break;
              default:
                throw new FormatException();
            }
            mode = Mode.ASCII_ENCODE;
          }
        } while (mode !== Mode.PAD_ENCODE && bits.available() > 0);
        if (resultTrailer.length() > 0) {
          result2.append(resultTrailer.toString());
        }
        return new DecoderResult(bytes, result2.toString(), byteSegments.length === 0 ? null : byteSegments, null);
      }
      /**
       * See ISO 16022:2006, 5.2.3 and Annex C, Table C.2
       */
      static decodeAsciiSegment(bits, result2, resultTrailer) {
        let upperShift = false;
        do {
          let oneByte = bits.readBits(8);
          if (oneByte === 0) {
            throw new FormatException();
          } else if (oneByte <= 128) {
            if (upperShift) {
              oneByte += 128;
            }
            result2.append(String.fromCharCode(oneByte - 1));
            return Mode.ASCII_ENCODE;
          } else if (oneByte === 129) {
            return Mode.PAD_ENCODE;
          } else if (oneByte <= 229) {
            const value = oneByte - 130;
            if (value < 10) {
              result2.append("0");
            }
            result2.append("" + value);
          } else {
            switch (oneByte) {
              case 230:
                return Mode.C40_ENCODE;
              case 231:
                return Mode.BASE256_ENCODE;
              case 232:
                result2.append(String.fromCharCode(29));
                break;
              case 233:
              case 234:
                break;
              case 235:
                upperShift = true;
                break;
              case 236:
                result2.append("[)>05");
                resultTrailer.insert(0, "");
                break;
              case 237:
                result2.append("[)>06");
                resultTrailer.insert(0, "");
                break;
              case 238:
                return Mode.ANSIX12_ENCODE;
              case 239:
                return Mode.TEXT_ENCODE;
              case 240:
                return Mode.EDIFACT_ENCODE;
              case 241:
                break;
              default:
                if (oneByte !== 254 || bits.available() !== 0) {
                  throw new FormatException();
                }
                break;
            }
          }
        } while (bits.available() > 0);
        return Mode.ASCII_ENCODE;
      }
      /**
       * See ISO 16022:2006, 5.2.5 and Annex C, Table C.1
       */
      static decodeC40Segment(bits, result2) {
        let upperShift = false;
        const cValues = [];
        let shift2 = 0;
        do {
          if (bits.available() === 8) {
            return;
          }
          const firstByte = bits.readBits(8);
          if (firstByte === 254) {
            return;
          }
          this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
          for (let i2 = 0; i2 < 3; i2++) {
            const cValue = cValues[i2];
            switch (shift2) {
              case 0:
                if (cValue < 3) {
                  shift2 = cValue + 1;
                } else if (cValue < this.C40_BASIC_SET_CHARS.length) {
                  const c40char = this.C40_BASIC_SET_CHARS[cValue];
                  if (upperShift) {
                    result2.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                    upperShift = false;
                  } else {
                    result2.append(c40char);
                  }
                } else {
                  throw new FormatException();
                }
                break;
              case 1:
                if (upperShift) {
                  result2.append(String.fromCharCode(cValue + 128));
                  upperShift = false;
                } else {
                  result2.append(String.fromCharCode(cValue));
                }
                shift2 = 0;
                break;
              case 2:
                if (cValue < this.C40_SHIFT2_SET_CHARS.length) {
                  const c40char = this.C40_SHIFT2_SET_CHARS[cValue];
                  if (upperShift) {
                    result2.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                    upperShift = false;
                  } else {
                    result2.append(c40char);
                  }
                } else {
                  switch (cValue) {
                    case 27:
                      result2.append(String.fromCharCode(29));
                      break;
                    case 30:
                      upperShift = true;
                      break;
                    default:
                      throw new FormatException();
                  }
                }
                shift2 = 0;
                break;
              case 3:
                if (upperShift) {
                  result2.append(String.fromCharCode(cValue + 224));
                  upperShift = false;
                } else {
                  result2.append(String.fromCharCode(cValue + 96));
                }
                shift2 = 0;
                break;
              default:
                throw new FormatException();
            }
          }
        } while (bits.available() > 0);
      }
      /**
       * See ISO 16022:2006, 5.2.6 and Annex C, Table C.2
       */
      static decodeTextSegment(bits, result2) {
        let upperShift = false;
        let cValues = [];
        let shift2 = 0;
        do {
          if (bits.available() === 8) {
            return;
          }
          const firstByte = bits.readBits(8);
          if (firstByte === 254) {
            return;
          }
          this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
          for (let i2 = 0; i2 < 3; i2++) {
            const cValue = cValues[i2];
            switch (shift2) {
              case 0:
                if (cValue < 3) {
                  shift2 = cValue + 1;
                } else if (cValue < this.TEXT_BASIC_SET_CHARS.length) {
                  const textChar = this.TEXT_BASIC_SET_CHARS[cValue];
                  if (upperShift) {
                    result2.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                    upperShift = false;
                  } else {
                    result2.append(textChar);
                  }
                } else {
                  throw new FormatException();
                }
                break;
              case 1:
                if (upperShift) {
                  result2.append(String.fromCharCode(cValue + 128));
                  upperShift = false;
                } else {
                  result2.append(String.fromCharCode(cValue));
                }
                shift2 = 0;
                break;
              case 2:
                if (cValue < this.TEXT_SHIFT2_SET_CHARS.length) {
                  const textChar = this.TEXT_SHIFT2_SET_CHARS[cValue];
                  if (upperShift) {
                    result2.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                    upperShift = false;
                  } else {
                    result2.append(textChar);
                  }
                } else {
                  switch (cValue) {
                    case 27:
                      result2.append(String.fromCharCode(29));
                      break;
                    case 30:
                      upperShift = true;
                      break;
                    default:
                      throw new FormatException();
                  }
                }
                shift2 = 0;
                break;
              case 3:
                if (cValue < this.TEXT_SHIFT3_SET_CHARS.length) {
                  const textChar = this.TEXT_SHIFT3_SET_CHARS[cValue];
                  if (upperShift) {
                    result2.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                    upperShift = false;
                  } else {
                    result2.append(textChar);
                  }
                  shift2 = 0;
                } else {
                  throw new FormatException();
                }
                break;
              default:
                throw new FormatException();
            }
          }
        } while (bits.available() > 0);
      }
      /**
       * See ISO 16022:2006, 5.2.7
       */
      static decodeAnsiX12Segment(bits, result2) {
        const cValues = [];
        do {
          if (bits.available() === 8) {
            return;
          }
          const firstByte = bits.readBits(8);
          if (firstByte === 254) {
            return;
          }
          this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
          for (let i2 = 0; i2 < 3; i2++) {
            const cValue = cValues[i2];
            switch (cValue) {
              case 0:
                result2.append("\r");
                break;
              case 1:
                result2.append("*");
                break;
              case 2:
                result2.append(">");
                break;
              case 3:
                result2.append(" ");
                break;
              default:
                if (cValue < 14) {
                  result2.append(String.fromCharCode(cValue + 44));
                } else if (cValue < 40) {
                  result2.append(String.fromCharCode(cValue + 51));
                } else {
                  throw new FormatException();
                }
                break;
            }
          }
        } while (bits.available() > 0);
      }
      static parseTwoBytes(firstByte, secondByte, result2) {
        let fullBitValue = (firstByte << 8) + secondByte - 1;
        let temp = Math.floor(fullBitValue / 1600);
        result2[0] = temp;
        fullBitValue -= temp * 1600;
        temp = Math.floor(fullBitValue / 40);
        result2[1] = temp;
        result2[2] = fullBitValue - temp * 40;
      }
      /**
       * See ISO 16022:2006, 5.2.8 and Annex C Table C.3
       */
      static decodeEdifactSegment(bits, result2) {
        do {
          if (bits.available() <= 16) {
            return;
          }
          for (let i2 = 0; i2 < 4; i2++) {
            let edifactValue = bits.readBits(6);
            if (edifactValue === 31) {
              const bitsLeft = 8 - bits.getBitOffset();
              if (bitsLeft !== 8) {
                bits.readBits(bitsLeft);
              }
              return;
            }
            if ((edifactValue & 32) === 0) {
              edifactValue |= 64;
            }
            result2.append(String.fromCharCode(edifactValue));
          }
        } while (bits.available() > 0);
      }
      /**
       * See ISO 16022:2006, 5.2.9 and Annex B, B.2
       */
      static decodeBase256Segment(bits, result2, byteSegments) {
        let codewordPosition = 1 + bits.getByteOffset();
        const d1 = this.unrandomize255State(bits.readBits(8), codewordPosition++);
        let count;
        if (d1 === 0) {
          count = bits.available() / 8 | 0;
        } else if (d1 < 250) {
          count = d1;
        } else {
          count = 250 * (d1 - 249) + this.unrandomize255State(bits.readBits(8), codewordPosition++);
        }
        if (count < 0) {
          throw new FormatException();
        }
        const bytes = new Uint8Array(count);
        for (let i2 = 0; i2 < count; i2++) {
          if (bits.available() < 8) {
            throw new FormatException();
          }
          bytes[i2] = this.unrandomize255State(bits.readBits(8), codewordPosition++);
        }
        byteSegments.push(bytes);
        try {
          result2.append(StringEncoding.decode(bytes, StringUtils.ISO88591));
        } catch (uee) {
          throw new IllegalStateException("Platform does not support required encoding: " + uee.message);
        }
      }
      /**
       * See ISO 16022:2006, Annex B, B.2
       */
      static unrandomize255State(randomizedBase256Codeword, base256CodewordPosition) {
        const pseudoRandomNumber = 149 * base256CodewordPosition % 255 + 1;
        const tempVariable = randomizedBase256Codeword - pseudoRandomNumber;
        return tempVariable >= 0 ? tempVariable : tempVariable + 256;
      }
    }
    DecodedBitStreamParser.C40_BASIC_SET_CHARS = [
      "*",
      "*",
      "*",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z"
    ];
    DecodedBitStreamParser.C40_SHIFT2_SET_CHARS = [
      "!",
      '"',
      "#",
      "$",
      "%",
      "&",
      "'",
      "(",
      ")",
      "*",
      "+",
      ",",
      "-",
      ".",
      "/",
      ":",
      ";",
      "<",
      "=",
      ">",
      "?",
      "@",
      "[",
      "\\",
      "]",
      "^",
      "_"
    ];
    DecodedBitStreamParser.TEXT_BASIC_SET_CHARS = [
      "*",
      "*",
      "*",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z"
    ];
    DecodedBitStreamParser.TEXT_SHIFT2_SET_CHARS = DecodedBitStreamParser.C40_SHIFT2_SET_CHARS;
    DecodedBitStreamParser.TEXT_SHIFT3_SET_CHARS = [
      "`",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "{",
      "|",
      "}",
      "~",
      String.fromCharCode(127)
    ];
    class Decoder$1 {
      constructor() {
        this.rsDecoder = new ReedSolomonDecoder(GenericGF.DATA_MATRIX_FIELD_256);
      }
      /**
       * <p>Decodes a Data Matrix Code represented as a {@link BitMatrix}. A 1 or "true" is taken
       * to mean a black module.</p>
       *
       * @param bits booleans representing white/black Data Matrix Code modules
       * @return text and bytes encoded within the Data Matrix Code
       * @throws FormatException if the Data Matrix Code cannot be decoded
       * @throws ChecksumException if error correction fails
       */
      decode(bits) {
        const parser2 = new BitMatrixParser(bits);
        const version2 = parser2.getVersion();
        const codewords = parser2.readCodewords();
        const dataBlocks = DataBlock.getDataBlocks(codewords, version2);
        let totalBytes = 0;
        for (let db of dataBlocks) {
          totalBytes += db.getNumDataCodewords();
        }
        const resultBytes = new Uint8Array(totalBytes);
        const dataBlocksCount = dataBlocks.length;
        for (let j = 0; j < dataBlocksCount; j++) {
          const dataBlock = dataBlocks[j];
          const codewordBytes = dataBlock.getCodewords();
          const numDataCodewords = dataBlock.getNumDataCodewords();
          this.correctErrors(codewordBytes, numDataCodewords);
          for (let i2 = 0; i2 < numDataCodewords; i2++) {
            resultBytes[i2 * dataBlocksCount + j] = codewordBytes[i2];
          }
        }
        return DecodedBitStreamParser.decode(resultBytes);
      }
      /**
       * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
       * correct the errors in-place using Reed-Solomon error correction.</p>
       *
       * @param codewordBytes data and error correction codewords
       * @param numDataCodewords number of codewords that are data bytes
       * @throws ChecksumException if error correction fails
       */
      correctErrors(codewordBytes, numDataCodewords) {
        const codewordsInts = new Int32Array(codewordBytes);
        try {
          this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
        } catch (ignored) {
          throw new ChecksumException();
        }
        for (let i2 = 0; i2 < numDataCodewords; i2++) {
          codewordBytes[i2] = codewordsInts[i2];
        }
      }
    }
    class Detector$1 {
      constructor(image) {
        this.image = image;
        this.rectangleDetector = new WhiteRectangleDetector(this.image);
      }
      /**
       * <p>Detects a Data Matrix Code in an image.</p>
       *
       * @return {@link DetectorResult} encapsulating results of detecting a Data Matrix Code
       * @throws NotFoundException if no Data Matrix Code can be found
       */
      detect() {
        const cornerPoints = this.rectangleDetector.detect();
        let points = this.detectSolid1(cornerPoints);
        points = this.detectSolid2(points);
        points[3] = this.correctTopRight(points);
        if (!points[3]) {
          throw new NotFoundException();
        }
        points = this.shiftToModuleCenter(points);
        const topLeft = points[0];
        const bottomLeft = points[1];
        const bottomRight = points[2];
        const topRight = points[3];
        let dimensionTop = this.transitionsBetween(topLeft, topRight) + 1;
        let dimensionRight = this.transitionsBetween(bottomRight, topRight) + 1;
        if ((dimensionTop & 1) === 1) {
          dimensionTop += 1;
        }
        if ((dimensionRight & 1) === 1) {
          dimensionRight += 1;
        }
        if (4 * dimensionTop < 7 * dimensionRight && 4 * dimensionRight < 7 * dimensionTop) {
          dimensionTop = dimensionRight = Math.max(dimensionTop, dimensionRight);
        }
        let bits = Detector$1.sampleGrid(this.image, topLeft, bottomLeft, bottomRight, topRight, dimensionTop, dimensionRight);
        return new DetectorResult(bits, [topLeft, bottomLeft, bottomRight, topRight]);
      }
      static shiftPoint(point, to, div) {
        let x2 = (to.getX() - point.getX()) / (div + 1);
        let y = (to.getY() - point.getY()) / (div + 1);
        return new ResultPoint(point.getX() + x2, point.getY() + y);
      }
      static moveAway(point, fromX, fromY) {
        let x2 = point.getX();
        let y = point.getY();
        if (x2 < fromX) {
          x2 -= 1;
        } else {
          x2 += 1;
        }
        if (y < fromY) {
          y -= 1;
        } else {
          y += 1;
        }
        return new ResultPoint(x2, y);
      }
      /**
       * Detect a solid side which has minimum transition.
       */
      detectSolid1(cornerPoints) {
        let pointA = cornerPoints[0];
        let pointB = cornerPoints[1];
        let pointC = cornerPoints[3];
        let pointD = cornerPoints[2];
        let trAB = this.transitionsBetween(pointA, pointB);
        let trBC = this.transitionsBetween(pointB, pointC);
        let trCD = this.transitionsBetween(pointC, pointD);
        let trDA = this.transitionsBetween(pointD, pointA);
        let min2 = trAB;
        let points = [pointD, pointA, pointB, pointC];
        if (min2 > trBC) {
          min2 = trBC;
          points[0] = pointA;
          points[1] = pointB;
          points[2] = pointC;
          points[3] = pointD;
        }
        if (min2 > trCD) {
          min2 = trCD;
          points[0] = pointB;
          points[1] = pointC;
          points[2] = pointD;
          points[3] = pointA;
        }
        if (min2 > trDA) {
          points[0] = pointC;
          points[1] = pointD;
          points[2] = pointA;
          points[3] = pointB;
        }
        return points;
      }
      /**
       * Detect a second solid side next to first solid side.
       */
      detectSolid2(points) {
        let pointA = points[0];
        let pointB = points[1];
        let pointC = points[2];
        let pointD = points[3];
        let tr = this.transitionsBetween(pointA, pointD);
        let pointBs = Detector$1.shiftPoint(pointB, pointC, (tr + 1) * 4);
        let pointCs = Detector$1.shiftPoint(pointC, pointB, (tr + 1) * 4);
        let trBA = this.transitionsBetween(pointBs, pointA);
        let trCD = this.transitionsBetween(pointCs, pointD);
        if (trBA < trCD) {
          points[0] = pointA;
          points[1] = pointB;
          points[2] = pointC;
          points[3] = pointD;
        } else {
          points[0] = pointB;
          points[1] = pointC;
          points[2] = pointD;
          points[3] = pointA;
        }
        return points;
      }
      /**
       * Calculates the corner position of the white top right module.
       */
      correctTopRight(points) {
        let pointA = points[0];
        let pointB = points[1];
        let pointC = points[2];
        let pointD = points[3];
        let trTop = this.transitionsBetween(pointA, pointD);
        let trRight = this.transitionsBetween(pointB, pointD);
        let pointAs = Detector$1.shiftPoint(pointA, pointB, (trRight + 1) * 4);
        let pointCs = Detector$1.shiftPoint(pointC, pointB, (trTop + 1) * 4);
        trTop = this.transitionsBetween(pointAs, pointD);
        trRight = this.transitionsBetween(pointCs, pointD);
        let candidate1 = new ResultPoint(pointD.getX() + (pointC.getX() - pointB.getX()) / (trTop + 1), pointD.getY() + (pointC.getY() - pointB.getY()) / (trTop + 1));
        let candidate2 = new ResultPoint(pointD.getX() + (pointA.getX() - pointB.getX()) / (trRight + 1), pointD.getY() + (pointA.getY() - pointB.getY()) / (trRight + 1));
        if (!this.isValid(candidate1)) {
          if (this.isValid(candidate2)) {
            return candidate2;
          }
          return null;
        }
        if (!this.isValid(candidate2)) {
          return candidate1;
        }
        let sumc1 = this.transitionsBetween(pointAs, candidate1) + this.transitionsBetween(pointCs, candidate1);
        let sumc2 = this.transitionsBetween(pointAs, candidate2) + this.transitionsBetween(pointCs, candidate2);
        if (sumc1 > sumc2) {
          return candidate1;
        } else {
          return candidate2;
        }
      }
      /**
       * Shift the edge points to the module center.
       */
      shiftToModuleCenter(points) {
        let pointA = points[0];
        let pointB = points[1];
        let pointC = points[2];
        let pointD = points[3];
        let dimH = this.transitionsBetween(pointA, pointD) + 1;
        let dimV = this.transitionsBetween(pointC, pointD) + 1;
        let pointAs = Detector$1.shiftPoint(pointA, pointB, dimV * 4);
        let pointCs = Detector$1.shiftPoint(pointC, pointB, dimH * 4);
        dimH = this.transitionsBetween(pointAs, pointD) + 1;
        dimV = this.transitionsBetween(pointCs, pointD) + 1;
        if ((dimH & 1) === 1) {
          dimH += 1;
        }
        if ((dimV & 1) === 1) {
          dimV += 1;
        }
        let centerX = (pointA.getX() + pointB.getX() + pointC.getX() + pointD.getX()) / 4;
        let centerY = (pointA.getY() + pointB.getY() + pointC.getY() + pointD.getY()) / 4;
        pointA = Detector$1.moveAway(pointA, centerX, centerY);
        pointB = Detector$1.moveAway(pointB, centerX, centerY);
        pointC = Detector$1.moveAway(pointC, centerX, centerY);
        pointD = Detector$1.moveAway(pointD, centerX, centerY);
        let pointBs;
        let pointDs;
        pointAs = Detector$1.shiftPoint(pointA, pointB, dimV * 4);
        pointAs = Detector$1.shiftPoint(pointAs, pointD, dimH * 4);
        pointBs = Detector$1.shiftPoint(pointB, pointA, dimV * 4);
        pointBs = Detector$1.shiftPoint(pointBs, pointC, dimH * 4);
        pointCs = Detector$1.shiftPoint(pointC, pointD, dimV * 4);
        pointCs = Detector$1.shiftPoint(pointCs, pointB, dimH * 4);
        pointDs = Detector$1.shiftPoint(pointD, pointC, dimV * 4);
        pointDs = Detector$1.shiftPoint(pointDs, pointA, dimH * 4);
        return [pointAs, pointBs, pointCs, pointDs];
      }
      isValid(p) {
        return p.getX() >= 0 && p.getX() < this.image.getWidth() && p.getY() > 0 && p.getY() < this.image.getHeight();
      }
      static sampleGrid(image, topLeft, bottomLeft, bottomRight, topRight, dimensionX, dimensionY) {
        const sampler = GridSamplerInstance.getInstance();
        return sampler.sampleGrid(image, dimensionX, dimensionY, 0.5, 0.5, dimensionX - 0.5, 0.5, dimensionX - 0.5, dimensionY - 0.5, 0.5, dimensionY - 0.5, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
      }
      /**
       * Counts the number of black/white transitions between two points, using something like Bresenham's algorithm.
       */
      transitionsBetween(from, to) {
        let fromX = Math.trunc(from.getX());
        let fromY = Math.trunc(from.getY());
        let toX = Math.trunc(to.getX());
        let toY = Math.trunc(to.getY());
        let steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
        if (steep) {
          let temp = fromX;
          fromX = fromY;
          fromY = temp;
          temp = toX;
          toX = toY;
          toY = temp;
        }
        let dx = Math.abs(toX - fromX);
        let dy = Math.abs(toY - fromY);
        let error2 = -dx / 2;
        let ystep = fromY < toY ? 1 : -1;
        let xstep = fromX < toX ? 1 : -1;
        let transitions = 0;
        let inBlack = this.image.get(steep ? fromY : fromX, steep ? fromX : fromY);
        for (let x2 = fromX, y = fromY; x2 !== toX; x2 += xstep) {
          let isBlack = this.image.get(steep ? y : x2, steep ? x2 : y);
          if (isBlack !== inBlack) {
            transitions++;
            inBlack = isBlack;
          }
          error2 += dy;
          if (error2 > 0) {
            if (y === toY) {
              break;
            }
            y += ystep;
            error2 -= dx;
          }
        }
        return transitions;
      }
    }
    class DataMatrixReader {
      constructor() {
        this.decoder = new Decoder$1();
      }
      /**
       * Locates and decodes a Data Matrix code in an image.
       *
       * @return a String representing the content encoded by the Data Matrix code
       * @throws NotFoundException if a Data Matrix code cannot be found
       * @throws FormatException if a Data Matrix code cannot be decoded
       * @throws ChecksumException if error correction fails
       */
      // @Override
      // public Result decode(BinaryBitmap image) throws NotFoundException, ChecksumException, FormatException {
      //   return decode(image, null);
      // }
      // @Override
      decode(image, hints = null) {
        let decoderResult;
        let points;
        if (hints != null && hints.has(DecodeHintType$1.PURE_BARCODE)) {
          const bits = DataMatrixReader.extractPureBits(image.getBlackMatrix());
          decoderResult = this.decoder.decode(bits);
          points = DataMatrixReader.NO_POINTS;
        } else {
          const detectorResult = new Detector$1(image.getBlackMatrix()).detect();
          decoderResult = this.decoder.decode(detectorResult.getBits());
          points = detectorResult.getPoints();
        }
        const rawBytes = decoderResult.getRawBytes();
        const result2 = new Result3(decoderResult.getText(), rawBytes, 8 * rawBytes.length, points, BarcodeFormat$1.DATA_MATRIX, System.currentTimeMillis());
        const byteSegments = decoderResult.getByteSegments();
        if (byteSegments != null) {
          result2.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
        }
        const ecLevel = decoderResult.getECLevel();
        if (ecLevel != null) {
          result2.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
        }
        return result2;
      }
      // @Override
      reset() {
      }
      /**
       * This method detects a code in a "pure" image -- that is, pure monochrome image
       * which contains only an unrotated, unskewed, image of a code, with some white border
       * around it. This is a specialized method that works exceptionally fast in this special
       * case.
       *
       * @see com.google.zxing.qrcode.QRCodeReader#extractPureBits(BitMatrix)
       */
      static extractPureBits(image) {
        const leftTopBlack = image.getTopLeftOnBit();
        const rightBottomBlack = image.getBottomRightOnBit();
        if (leftTopBlack == null || rightBottomBlack == null) {
          throw new NotFoundException();
        }
        const moduleSize = this.moduleSize(leftTopBlack, image);
        let top = leftTopBlack[1];
        const bottom = rightBottomBlack[1];
        let left = leftTopBlack[0];
        const right = rightBottomBlack[0];
        const matrixWidth = (right - left + 1) / moduleSize;
        const matrixHeight = (bottom - top + 1) / moduleSize;
        if (matrixWidth <= 0 || matrixHeight <= 0) {
          throw new NotFoundException();
        }
        const nudge = moduleSize / 2;
        top += nudge;
        left += nudge;
        const bits = new BitMatrix(matrixWidth, matrixHeight);
        for (let y = 0; y < matrixHeight; y++) {
          const iOffset = top + y * moduleSize;
          for (let x2 = 0; x2 < matrixWidth; x2++) {
            if (image.get(left + x2 * moduleSize, iOffset)) {
              bits.set(x2, y);
            }
          }
        }
        return bits;
      }
      static moduleSize(leftTopBlack, image) {
        const width = image.getWidth();
        let x2 = leftTopBlack[0];
        const y = leftTopBlack[1];
        while (x2 < width && image.get(x2, y)) {
          x2++;
        }
        if (x2 === width) {
          throw new NotFoundException();
        }
        const moduleSize = x2 - leftTopBlack[0];
        if (moduleSize === 0) {
          throw new NotFoundException();
        }
        return moduleSize;
      }
    }
    DataMatrixReader.NO_POINTS = [];
    class BrowserDatamatrixCodeReader extends BrowserCodeReader {
      /**
       * Creates an instance of BrowserQRCodeReader.
       * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
       */
      constructor(timeBetweenScansMillis = 500) {
        super(new DataMatrixReader(), timeBetweenScansMillis);
      }
    }
    var ErrorCorrectionLevelValues;
    (function(ErrorCorrectionLevelValues2) {
      ErrorCorrectionLevelValues2[ErrorCorrectionLevelValues2["L"] = 0] = "L";
      ErrorCorrectionLevelValues2[ErrorCorrectionLevelValues2["M"] = 1] = "M";
      ErrorCorrectionLevelValues2[ErrorCorrectionLevelValues2["Q"] = 2] = "Q";
      ErrorCorrectionLevelValues2[ErrorCorrectionLevelValues2["H"] = 3] = "H";
    })(ErrorCorrectionLevelValues || (ErrorCorrectionLevelValues = {}));
    class ErrorCorrectionLevel {
      constructor(value, stringValue, bits) {
        this.value = value;
        this.stringValue = stringValue;
        this.bits = bits;
        ErrorCorrectionLevel.FOR_BITS.set(bits, this);
        ErrorCorrectionLevel.FOR_VALUE.set(value, this);
      }
      getValue() {
        return this.value;
      }
      getBits() {
        return this.bits;
      }
      static fromString(s2) {
        switch (s2) {
          case "L":
            return ErrorCorrectionLevel.L;
          case "M":
            return ErrorCorrectionLevel.M;
          case "Q":
            return ErrorCorrectionLevel.Q;
          case "H":
            return ErrorCorrectionLevel.H;
          default:
            throw new ArgumentException(s2 + "not available");
        }
      }
      toString() {
        return this.stringValue;
      }
      equals(o) {
        if (!(o instanceof ErrorCorrectionLevel)) {
          return false;
        }
        const other = o;
        return this.value === other.value;
      }
      /**
       * @param bits int containing the two bits encoding a QR Code's error correction level
       * @return ErrorCorrectionLevel representing the encoded error correction level
       */
      static forBits(bits) {
        if (bits < 0 || bits >= ErrorCorrectionLevel.FOR_BITS.size) {
          throw new IllegalArgumentException();
        }
        return ErrorCorrectionLevel.FOR_BITS.get(bits);
      }
    }
    ErrorCorrectionLevel.FOR_BITS = /* @__PURE__ */ new Map();
    ErrorCorrectionLevel.FOR_VALUE = /* @__PURE__ */ new Map();
    ErrorCorrectionLevel.L = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.L, "L", 1);
    ErrorCorrectionLevel.M = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.M, "M", 0);
    ErrorCorrectionLevel.Q = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.Q, "Q", 3);
    ErrorCorrectionLevel.H = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.H, "H", 2);
    class FormatInformation {
      constructor(formatInfo) {
        this.errorCorrectionLevel = ErrorCorrectionLevel.forBits(formatInfo >> 3 & 3);
        this.dataMask = /*(byte) */
        formatInfo & 7;
      }
      static numBitsDiffering(a, b) {
        return Integer.bitCount(a ^ b);
      }
      /**
       * @param maskedFormatInfo1 format info indicator, with mask still applied
       * @param maskedFormatInfo2 second copy of same info; both are checked at the same time
       *  to establish best match
       * @return information about the format it specifies, or {@code null}
       *  if doesn't seem to match any known pattern
       */
      static decodeFormatInformation(maskedFormatInfo1, maskedFormatInfo2) {
        const formatInfo = FormatInformation.doDecodeFormatInformation(maskedFormatInfo1, maskedFormatInfo2);
        if (formatInfo !== null) {
          return formatInfo;
        }
        return FormatInformation.doDecodeFormatInformation(maskedFormatInfo1 ^ FormatInformation.FORMAT_INFO_MASK_QR, maskedFormatInfo2 ^ FormatInformation.FORMAT_INFO_MASK_QR);
      }
      static doDecodeFormatInformation(maskedFormatInfo1, maskedFormatInfo2) {
        let bestDifference = Number.MAX_SAFE_INTEGER;
        let bestFormatInfo = 0;
        for (const decodeInfo of FormatInformation.FORMAT_INFO_DECODE_LOOKUP) {
          const targetInfo = decodeInfo[0];
          if (targetInfo === maskedFormatInfo1 || targetInfo === maskedFormatInfo2) {
            return new FormatInformation(decodeInfo[1]);
          }
          let bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo1, targetInfo);
          if (bitsDifference < bestDifference) {
            bestFormatInfo = decodeInfo[1];
            bestDifference = bitsDifference;
          }
          if (maskedFormatInfo1 !== maskedFormatInfo2) {
            bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo2, targetInfo);
            if (bitsDifference < bestDifference) {
              bestFormatInfo = decodeInfo[1];
              bestDifference = bitsDifference;
            }
          }
        }
        if (bestDifference <= 3) {
          return new FormatInformation(bestFormatInfo);
        }
        return null;
      }
      getErrorCorrectionLevel() {
        return this.errorCorrectionLevel;
      }
      getDataMask() {
        return this.dataMask;
      }
      /*@Override*/
      hashCode() {
        return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
      }
      /*@Override*/
      equals(o) {
        if (!(o instanceof FormatInformation)) {
          return false;
        }
        const other = o;
        return this.errorCorrectionLevel === other.errorCorrectionLevel && this.dataMask === other.dataMask;
      }
    }
    FormatInformation.FORMAT_INFO_MASK_QR = 21522;
    FormatInformation.FORMAT_INFO_DECODE_LOOKUP = [
      Int32Array.from([21522, 0]),
      Int32Array.from([20773, 1]),
      Int32Array.from([24188, 2]),
      Int32Array.from([23371, 3]),
      Int32Array.from([17913, 4]),
      Int32Array.from([16590, 5]),
      Int32Array.from([20375, 6]),
      Int32Array.from([19104, 7]),
      Int32Array.from([30660, 8]),
      Int32Array.from([29427, 9]),
      Int32Array.from([32170, 10]),
      Int32Array.from([30877, 11]),
      Int32Array.from([26159, 12]),
      Int32Array.from([25368, 13]),
      Int32Array.from([27713, 14]),
      Int32Array.from([26998, 15]),
      Int32Array.from([5769, 16]),
      Int32Array.from([5054, 17]),
      Int32Array.from([7399, 18]),
      Int32Array.from([6608, 19]),
      Int32Array.from([1890, 20]),
      Int32Array.from([597, 21]),
      Int32Array.from([3340, 22]),
      Int32Array.from([2107, 23]),
      Int32Array.from([13663, 24]),
      Int32Array.from([12392, 25]),
      Int32Array.from([16177, 26]),
      Int32Array.from([14854, 27]),
      Int32Array.from([9396, 28]),
      Int32Array.from([8579, 29]),
      Int32Array.from([11994, 30]),
      Int32Array.from([11245, 31])
    ];
    class ECBlocks$1 {
      constructor(ecCodewordsPerBlock, ...ecBlocks) {
        this.ecCodewordsPerBlock = ecCodewordsPerBlock;
        this.ecBlocks = ecBlocks;
      }
      getECCodewordsPerBlock() {
        return this.ecCodewordsPerBlock;
      }
      getNumBlocks() {
        let total = 0;
        const ecBlocks = this.ecBlocks;
        for (const ecBlock of ecBlocks) {
          total += ecBlock.getCount();
        }
        return total;
      }
      getTotalECCodewords() {
        return this.ecCodewordsPerBlock * this.getNumBlocks();
      }
      getECBlocks() {
        return this.ecBlocks;
      }
    }
    class ECB$1 {
      constructor(count, dataCodewords) {
        this.count = count;
        this.dataCodewords = dataCodewords;
      }
      getCount() {
        return this.count;
      }
      getDataCodewords() {
        return this.dataCodewords;
      }
    }
    class Version$1 {
      constructor(versionNumber, alignmentPatternCenters, ...ecBlocks) {
        this.versionNumber = versionNumber;
        this.alignmentPatternCenters = alignmentPatternCenters;
        this.ecBlocks = ecBlocks;
        let total = 0;
        const ecCodewords = ecBlocks[0].getECCodewordsPerBlock();
        const ecbArray = ecBlocks[0].getECBlocks();
        for (const ecBlock of ecbArray) {
          total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
        }
        this.totalCodewords = total;
      }
      getVersionNumber() {
        return this.versionNumber;
      }
      getAlignmentPatternCenters() {
        return this.alignmentPatternCenters;
      }
      getTotalCodewords() {
        return this.totalCodewords;
      }
      getDimensionForVersion() {
        return 17 + 4 * this.versionNumber;
      }
      getECBlocksForLevel(ecLevel) {
        return this.ecBlocks[ecLevel.getValue()];
      }
      /**
       * <p>Deduces version information purely from QR Code dimensions.</p>
       *
       * @param dimension dimension in modules
       * @return Version for a QR Code of that dimension
       * @throws FormatException if dimension is not 1 mod 4
       */
      static getProvisionalVersionForDimension(dimension) {
        if (dimension % 4 !== 1) {
          throw new FormatException();
        }
        try {
          return this.getVersionForNumber((dimension - 17) / 4);
        } catch (ignored) {
          throw new FormatException();
        }
      }
      static getVersionForNumber(versionNumber) {
        if (versionNumber < 1 || versionNumber > 40) {
          throw new IllegalArgumentException();
        }
        return Version$1.VERSIONS[versionNumber - 1];
      }
      static decodeVersionInformation(versionBits) {
        let bestDifference = Number.MAX_SAFE_INTEGER;
        let bestVersion = 0;
        for (let i2 = 0; i2 < Version$1.VERSION_DECODE_INFO.length; i2++) {
          const targetVersion = Version$1.VERSION_DECODE_INFO[i2];
          if (targetVersion === versionBits) {
            return Version$1.getVersionForNumber(i2 + 7);
          }
          const bitsDifference = FormatInformation.numBitsDiffering(versionBits, targetVersion);
          if (bitsDifference < bestDifference) {
            bestVersion = i2 + 7;
            bestDifference = bitsDifference;
          }
        }
        if (bestDifference <= 3) {
          return Version$1.getVersionForNumber(bestVersion);
        }
        return null;
      }
      /**
       * See ISO 18004:2006 Annex E
       */
      buildFunctionPattern() {
        const dimension = this.getDimensionForVersion();
        const bitMatrix = new BitMatrix(dimension);
        bitMatrix.setRegion(0, 0, 9, 9);
        bitMatrix.setRegion(dimension - 8, 0, 8, 9);
        bitMatrix.setRegion(0, dimension - 8, 9, 8);
        const max2 = this.alignmentPatternCenters.length;
        for (let x2 = 0; x2 < max2; x2++) {
          const i2 = this.alignmentPatternCenters[x2] - 2;
          for (let y = 0; y < max2; y++) {
            if (x2 === 0 && (y === 0 || y === max2 - 1) || x2 === max2 - 1 && y === 0) {
              continue;
            }
            bitMatrix.setRegion(this.alignmentPatternCenters[y] - 2, i2, 5, 5);
          }
        }
        bitMatrix.setRegion(6, 9, 1, dimension - 17);
        bitMatrix.setRegion(9, 6, dimension - 17, 1);
        if (this.versionNumber > 6) {
          bitMatrix.setRegion(dimension - 11, 0, 3, 6);
          bitMatrix.setRegion(0, dimension - 11, 6, 3);
        }
        return bitMatrix;
      }
      /*@Override*/
      toString() {
        return "" + this.versionNumber;
      }
    }
    Version$1.VERSION_DECODE_INFO = Int32Array.from([
      31892,
      34236,
      39577,
      42195,
      48118,
      51042,
      55367,
      58893,
      63784,
      68472,
      70749,
      76311,
      79154,
      84390,
      87683,
      92361,
      96236,
      102084,
      102881,
      110507,
      110734,
      117786,
      119615,
      126325,
      127568,
      133589,
      136944,
      141498,
      145311,
      150283,
      152622,
      158308,
      161089,
      167017
    ]);
    Version$1.VERSIONS = [
      new Version$1(1, new Int32Array(0), new ECBlocks$1(7, new ECB$1(1, 19)), new ECBlocks$1(10, new ECB$1(1, 16)), new ECBlocks$1(13, new ECB$1(1, 13)), new ECBlocks$1(17, new ECB$1(1, 9))),
      new Version$1(2, Int32Array.from([6, 18]), new ECBlocks$1(10, new ECB$1(1, 34)), new ECBlocks$1(16, new ECB$1(1, 28)), new ECBlocks$1(22, new ECB$1(1, 22)), new ECBlocks$1(28, new ECB$1(1, 16))),
      new Version$1(3, Int32Array.from([6, 22]), new ECBlocks$1(15, new ECB$1(1, 55)), new ECBlocks$1(26, new ECB$1(1, 44)), new ECBlocks$1(18, new ECB$1(2, 17)), new ECBlocks$1(22, new ECB$1(2, 13))),
      new Version$1(4, Int32Array.from([6, 26]), new ECBlocks$1(20, new ECB$1(1, 80)), new ECBlocks$1(18, new ECB$1(2, 32)), new ECBlocks$1(26, new ECB$1(2, 24)), new ECBlocks$1(16, new ECB$1(4, 9))),
      new Version$1(5, Int32Array.from([6, 30]), new ECBlocks$1(26, new ECB$1(1, 108)), new ECBlocks$1(24, new ECB$1(2, 43)), new ECBlocks$1(18, new ECB$1(2, 15), new ECB$1(2, 16)), new ECBlocks$1(22, new ECB$1(2, 11), new ECB$1(2, 12))),
      new Version$1(6, Int32Array.from([6, 34]), new ECBlocks$1(18, new ECB$1(2, 68)), new ECBlocks$1(16, new ECB$1(4, 27)), new ECBlocks$1(24, new ECB$1(4, 19)), new ECBlocks$1(28, new ECB$1(4, 15))),
      new Version$1(7, Int32Array.from([6, 22, 38]), new ECBlocks$1(20, new ECB$1(2, 78)), new ECBlocks$1(18, new ECB$1(4, 31)), new ECBlocks$1(18, new ECB$1(2, 14), new ECB$1(4, 15)), new ECBlocks$1(26, new ECB$1(4, 13), new ECB$1(1, 14))),
      new Version$1(8, Int32Array.from([6, 24, 42]), new ECBlocks$1(24, new ECB$1(2, 97)), new ECBlocks$1(22, new ECB$1(2, 38), new ECB$1(2, 39)), new ECBlocks$1(22, new ECB$1(4, 18), new ECB$1(2, 19)), new ECBlocks$1(26, new ECB$1(4, 14), new ECB$1(2, 15))),
      new Version$1(9, Int32Array.from([6, 26, 46]), new ECBlocks$1(30, new ECB$1(2, 116)), new ECBlocks$1(22, new ECB$1(3, 36), new ECB$1(2, 37)), new ECBlocks$1(20, new ECB$1(4, 16), new ECB$1(4, 17)), new ECBlocks$1(24, new ECB$1(4, 12), new ECB$1(4, 13))),
      new Version$1(10, Int32Array.from([6, 28, 50]), new ECBlocks$1(18, new ECB$1(2, 68), new ECB$1(2, 69)), new ECBlocks$1(26, new ECB$1(4, 43), new ECB$1(1, 44)), new ECBlocks$1(24, new ECB$1(6, 19), new ECB$1(2, 20)), new ECBlocks$1(28, new ECB$1(6, 15), new ECB$1(2, 16))),
      new Version$1(11, Int32Array.from([6, 30, 54]), new ECBlocks$1(20, new ECB$1(4, 81)), new ECBlocks$1(30, new ECB$1(1, 50), new ECB$1(4, 51)), new ECBlocks$1(28, new ECB$1(4, 22), new ECB$1(4, 23)), new ECBlocks$1(24, new ECB$1(3, 12), new ECB$1(8, 13))),
      new Version$1(12, Int32Array.from([6, 32, 58]), new ECBlocks$1(24, new ECB$1(2, 92), new ECB$1(2, 93)), new ECBlocks$1(22, new ECB$1(6, 36), new ECB$1(2, 37)), new ECBlocks$1(26, new ECB$1(4, 20), new ECB$1(6, 21)), new ECBlocks$1(28, new ECB$1(7, 14), new ECB$1(4, 15))),
      new Version$1(13, Int32Array.from([6, 34, 62]), new ECBlocks$1(26, new ECB$1(4, 107)), new ECBlocks$1(22, new ECB$1(8, 37), new ECB$1(1, 38)), new ECBlocks$1(24, new ECB$1(8, 20), new ECB$1(4, 21)), new ECBlocks$1(22, new ECB$1(12, 11), new ECB$1(4, 12))),
      new Version$1(14, Int32Array.from([6, 26, 46, 66]), new ECBlocks$1(30, new ECB$1(3, 115), new ECB$1(1, 116)), new ECBlocks$1(24, new ECB$1(4, 40), new ECB$1(5, 41)), new ECBlocks$1(20, new ECB$1(11, 16), new ECB$1(5, 17)), new ECBlocks$1(24, new ECB$1(11, 12), new ECB$1(5, 13))),
      new Version$1(15, Int32Array.from([6, 26, 48, 70]), new ECBlocks$1(22, new ECB$1(5, 87), new ECB$1(1, 88)), new ECBlocks$1(24, new ECB$1(5, 41), new ECB$1(5, 42)), new ECBlocks$1(30, new ECB$1(5, 24), new ECB$1(7, 25)), new ECBlocks$1(24, new ECB$1(11, 12), new ECB$1(7, 13))),
      new Version$1(16, Int32Array.from([6, 26, 50, 74]), new ECBlocks$1(24, new ECB$1(5, 98), new ECB$1(1, 99)), new ECBlocks$1(28, new ECB$1(7, 45), new ECB$1(3, 46)), new ECBlocks$1(24, new ECB$1(15, 19), new ECB$1(2, 20)), new ECBlocks$1(30, new ECB$1(3, 15), new ECB$1(13, 16))),
      new Version$1(17, Int32Array.from([6, 30, 54, 78]), new ECBlocks$1(28, new ECB$1(1, 107), new ECB$1(5, 108)), new ECBlocks$1(28, new ECB$1(10, 46), new ECB$1(1, 47)), new ECBlocks$1(28, new ECB$1(1, 22), new ECB$1(15, 23)), new ECBlocks$1(28, new ECB$1(2, 14), new ECB$1(17, 15))),
      new Version$1(18, Int32Array.from([6, 30, 56, 82]), new ECBlocks$1(30, new ECB$1(5, 120), new ECB$1(1, 121)), new ECBlocks$1(26, new ECB$1(9, 43), new ECB$1(4, 44)), new ECBlocks$1(28, new ECB$1(17, 22), new ECB$1(1, 23)), new ECBlocks$1(28, new ECB$1(2, 14), new ECB$1(19, 15))),
      new Version$1(19, Int32Array.from([6, 30, 58, 86]), new ECBlocks$1(28, new ECB$1(3, 113), new ECB$1(4, 114)), new ECBlocks$1(26, new ECB$1(3, 44), new ECB$1(11, 45)), new ECBlocks$1(26, new ECB$1(17, 21), new ECB$1(4, 22)), new ECBlocks$1(26, new ECB$1(9, 13), new ECB$1(16, 14))),
      new Version$1(20, Int32Array.from([6, 34, 62, 90]), new ECBlocks$1(28, new ECB$1(3, 107), new ECB$1(5, 108)), new ECBlocks$1(26, new ECB$1(3, 41), new ECB$1(13, 42)), new ECBlocks$1(30, new ECB$1(15, 24), new ECB$1(5, 25)), new ECBlocks$1(28, new ECB$1(15, 15), new ECB$1(10, 16))),
      new Version$1(21, Int32Array.from([6, 28, 50, 72, 94]), new ECBlocks$1(28, new ECB$1(4, 116), new ECB$1(4, 117)), new ECBlocks$1(26, new ECB$1(17, 42)), new ECBlocks$1(28, new ECB$1(17, 22), new ECB$1(6, 23)), new ECBlocks$1(30, new ECB$1(19, 16), new ECB$1(6, 17))),
      new Version$1(22, Int32Array.from([6, 26, 50, 74, 98]), new ECBlocks$1(28, new ECB$1(2, 111), new ECB$1(7, 112)), new ECBlocks$1(28, new ECB$1(17, 46)), new ECBlocks$1(30, new ECB$1(7, 24), new ECB$1(16, 25)), new ECBlocks$1(24, new ECB$1(34, 13))),
      new Version$1(23, Int32Array.from([6, 30, 54, 78, 102]), new ECBlocks$1(30, new ECB$1(4, 121), new ECB$1(5, 122)), new ECBlocks$1(28, new ECB$1(4, 47), new ECB$1(14, 48)), new ECBlocks$1(30, new ECB$1(11, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(16, 15), new ECB$1(14, 16))),
      new Version$1(24, Int32Array.from([6, 28, 54, 80, 106]), new ECBlocks$1(30, new ECB$1(6, 117), new ECB$1(4, 118)), new ECBlocks$1(28, new ECB$1(6, 45), new ECB$1(14, 46)), new ECBlocks$1(30, new ECB$1(11, 24), new ECB$1(16, 25)), new ECBlocks$1(30, new ECB$1(30, 16), new ECB$1(2, 17))),
      new Version$1(25, Int32Array.from([6, 32, 58, 84, 110]), new ECBlocks$1(26, new ECB$1(8, 106), new ECB$1(4, 107)), new ECBlocks$1(28, new ECB$1(8, 47), new ECB$1(13, 48)), new ECBlocks$1(30, new ECB$1(7, 24), new ECB$1(22, 25)), new ECBlocks$1(30, new ECB$1(22, 15), new ECB$1(13, 16))),
      new Version$1(26, Int32Array.from([6, 30, 58, 86, 114]), new ECBlocks$1(28, new ECB$1(10, 114), new ECB$1(2, 115)), new ECBlocks$1(28, new ECB$1(19, 46), new ECB$1(4, 47)), new ECBlocks$1(28, new ECB$1(28, 22), new ECB$1(6, 23)), new ECBlocks$1(30, new ECB$1(33, 16), new ECB$1(4, 17))),
      new Version$1(27, Int32Array.from([6, 34, 62, 90, 118]), new ECBlocks$1(30, new ECB$1(8, 122), new ECB$1(4, 123)), new ECBlocks$1(28, new ECB$1(22, 45), new ECB$1(3, 46)), new ECBlocks$1(30, new ECB$1(8, 23), new ECB$1(26, 24)), new ECBlocks$1(30, new ECB$1(12, 15), new ECB$1(28, 16))),
      new Version$1(28, Int32Array.from([6, 26, 50, 74, 98, 122]), new ECBlocks$1(30, new ECB$1(3, 117), new ECB$1(10, 118)), new ECBlocks$1(28, new ECB$1(3, 45), new ECB$1(23, 46)), new ECBlocks$1(30, new ECB$1(4, 24), new ECB$1(31, 25)), new ECBlocks$1(30, new ECB$1(11, 15), new ECB$1(31, 16))),
      new Version$1(29, Int32Array.from([6, 30, 54, 78, 102, 126]), new ECBlocks$1(30, new ECB$1(7, 116), new ECB$1(7, 117)), new ECBlocks$1(28, new ECB$1(21, 45), new ECB$1(7, 46)), new ECBlocks$1(30, new ECB$1(1, 23), new ECB$1(37, 24)), new ECBlocks$1(30, new ECB$1(19, 15), new ECB$1(26, 16))),
      new Version$1(30, Int32Array.from([6, 26, 52, 78, 104, 130]), new ECBlocks$1(30, new ECB$1(5, 115), new ECB$1(10, 116)), new ECBlocks$1(28, new ECB$1(19, 47), new ECB$1(10, 48)), new ECBlocks$1(30, new ECB$1(15, 24), new ECB$1(25, 25)), new ECBlocks$1(30, new ECB$1(23, 15), new ECB$1(25, 16))),
      new Version$1(31, Int32Array.from([6, 30, 56, 82, 108, 134]), new ECBlocks$1(30, new ECB$1(13, 115), new ECB$1(3, 116)), new ECBlocks$1(28, new ECB$1(2, 46), new ECB$1(29, 47)), new ECBlocks$1(30, new ECB$1(42, 24), new ECB$1(1, 25)), new ECBlocks$1(30, new ECB$1(23, 15), new ECB$1(28, 16))),
      new Version$1(32, Int32Array.from([6, 34, 60, 86, 112, 138]), new ECBlocks$1(30, new ECB$1(17, 115)), new ECBlocks$1(28, new ECB$1(10, 46), new ECB$1(23, 47)), new ECBlocks$1(30, new ECB$1(10, 24), new ECB$1(35, 25)), new ECBlocks$1(30, new ECB$1(19, 15), new ECB$1(35, 16))),
      new Version$1(33, Int32Array.from([6, 30, 58, 86, 114, 142]), new ECBlocks$1(30, new ECB$1(17, 115), new ECB$1(1, 116)), new ECBlocks$1(28, new ECB$1(14, 46), new ECB$1(21, 47)), new ECBlocks$1(30, new ECB$1(29, 24), new ECB$1(19, 25)), new ECBlocks$1(30, new ECB$1(11, 15), new ECB$1(46, 16))),
      new Version$1(34, Int32Array.from([6, 34, 62, 90, 118, 146]), new ECBlocks$1(30, new ECB$1(13, 115), new ECB$1(6, 116)), new ECBlocks$1(28, new ECB$1(14, 46), new ECB$1(23, 47)), new ECBlocks$1(30, new ECB$1(44, 24), new ECB$1(7, 25)), new ECBlocks$1(30, new ECB$1(59, 16), new ECB$1(1, 17))),
      new Version$1(35, Int32Array.from([6, 30, 54, 78, 102, 126, 150]), new ECBlocks$1(30, new ECB$1(12, 121), new ECB$1(7, 122)), new ECBlocks$1(28, new ECB$1(12, 47), new ECB$1(26, 48)), new ECBlocks$1(30, new ECB$1(39, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(22, 15), new ECB$1(41, 16))),
      new Version$1(36, Int32Array.from([6, 24, 50, 76, 102, 128, 154]), new ECBlocks$1(30, new ECB$1(6, 121), new ECB$1(14, 122)), new ECBlocks$1(28, new ECB$1(6, 47), new ECB$1(34, 48)), new ECBlocks$1(30, new ECB$1(46, 24), new ECB$1(10, 25)), new ECBlocks$1(30, new ECB$1(2, 15), new ECB$1(64, 16))),
      new Version$1(37, Int32Array.from([6, 28, 54, 80, 106, 132, 158]), new ECBlocks$1(30, new ECB$1(17, 122), new ECB$1(4, 123)), new ECBlocks$1(28, new ECB$1(29, 46), new ECB$1(14, 47)), new ECBlocks$1(30, new ECB$1(49, 24), new ECB$1(10, 25)), new ECBlocks$1(30, new ECB$1(24, 15), new ECB$1(46, 16))),
      new Version$1(38, Int32Array.from([6, 32, 58, 84, 110, 136, 162]), new ECBlocks$1(30, new ECB$1(4, 122), new ECB$1(18, 123)), new ECBlocks$1(28, new ECB$1(13, 46), new ECB$1(32, 47)), new ECBlocks$1(30, new ECB$1(48, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(42, 15), new ECB$1(32, 16))),
      new Version$1(39, Int32Array.from([6, 26, 54, 82, 110, 138, 166]), new ECBlocks$1(30, new ECB$1(20, 117), new ECB$1(4, 118)), new ECBlocks$1(28, new ECB$1(40, 47), new ECB$1(7, 48)), new ECBlocks$1(30, new ECB$1(43, 24), new ECB$1(22, 25)), new ECBlocks$1(30, new ECB$1(10, 15), new ECB$1(67, 16))),
      new Version$1(40, Int32Array.from([6, 30, 58, 86, 114, 142, 170]), new ECBlocks$1(30, new ECB$1(19, 118), new ECB$1(6, 119)), new ECBlocks$1(28, new ECB$1(18, 47), new ECB$1(31, 48)), new ECBlocks$1(30, new ECB$1(34, 24), new ECB$1(34, 25)), new ECBlocks$1(30, new ECB$1(20, 15), new ECB$1(61, 16)))
    ];
    var DataMaskValues;
    (function(DataMaskValues2) {
      DataMaskValues2[DataMaskValues2["DATA_MASK_000"] = 0] = "DATA_MASK_000";
      DataMaskValues2[DataMaskValues2["DATA_MASK_001"] = 1] = "DATA_MASK_001";
      DataMaskValues2[DataMaskValues2["DATA_MASK_010"] = 2] = "DATA_MASK_010";
      DataMaskValues2[DataMaskValues2["DATA_MASK_011"] = 3] = "DATA_MASK_011";
      DataMaskValues2[DataMaskValues2["DATA_MASK_100"] = 4] = "DATA_MASK_100";
      DataMaskValues2[DataMaskValues2["DATA_MASK_101"] = 5] = "DATA_MASK_101";
      DataMaskValues2[DataMaskValues2["DATA_MASK_110"] = 6] = "DATA_MASK_110";
      DataMaskValues2[DataMaskValues2["DATA_MASK_111"] = 7] = "DATA_MASK_111";
    })(DataMaskValues || (DataMaskValues = {}));
    class DataMask {
      // See ISO 18004:2006 6.8.1
      constructor(value, isMasked2) {
        this.value = value;
        this.isMasked = isMasked2;
      }
      // End of enum constants.
      /**
       * <p>Implementations of this method reverse the data masking process applied to a QR Code and
       * make its bits ready to read.</p>
       *
       * @param bits representation of QR Code bits
       * @param dimension dimension of QR Code, represented by bits, being unmasked
       */
      unmaskBitMatrix(bits, dimension) {
        for (let i2 = 0; i2 < dimension; i2++) {
          for (let j = 0; j < dimension; j++) {
            if (this.isMasked(i2, j)) {
              bits.flip(j, i2);
            }
          }
        }
      }
    }
    DataMask.values = /* @__PURE__ */ new Map([
      /**
       * 000: mask bits for which (x + y) mod 2 == 0
       */
      [DataMaskValues.DATA_MASK_000, new DataMask(DataMaskValues.DATA_MASK_000, (i2, j) => {
        return (i2 + j & 1) === 0;
      })],
      /**
       * 001: mask bits for which x mod 2 == 0
       */
      [DataMaskValues.DATA_MASK_001, new DataMask(DataMaskValues.DATA_MASK_001, (i2, j) => {
        return (i2 & 1) === 0;
      })],
      /**
       * 010: mask bits for which y mod 3 == 0
       */
      [DataMaskValues.DATA_MASK_010, new DataMask(DataMaskValues.DATA_MASK_010, (i2, j) => {
        return j % 3 === 0;
      })],
      /**
       * 011: mask bits for which (x + y) mod 3 == 0
       */
      [DataMaskValues.DATA_MASK_011, new DataMask(DataMaskValues.DATA_MASK_011, (i2, j) => {
        return (i2 + j) % 3 === 0;
      })],
      /**
       * 100: mask bits for which (x/2 + y/3) mod 2 == 0
       */
      [DataMaskValues.DATA_MASK_100, new DataMask(DataMaskValues.DATA_MASK_100, (i2, j) => {
        return (Math.floor(i2 / 2) + Math.floor(j / 3) & 1) === 0;
      })],
      /**
       * 101: mask bits for which xy mod 2 + xy mod 3 == 0
       * equivalently, such that xy mod 6 == 0
       */
      [DataMaskValues.DATA_MASK_101, new DataMask(DataMaskValues.DATA_MASK_101, (i2, j) => {
        return i2 * j % 6 === 0;
      })],
      /**
       * 110: mask bits for which (xy mod 2 + xy mod 3) mod 2 == 0
       * equivalently, such that xy mod 6 < 3
       */
      [DataMaskValues.DATA_MASK_110, new DataMask(DataMaskValues.DATA_MASK_110, (i2, j) => {
        return i2 * j % 6 < 3;
      })],
      /**
       * 111: mask bits for which ((x+y)mod 2 + xy mod 3) mod 2 == 0
       * equivalently, such that (x + y + xy mod 3) mod 2 == 0
       */
      [DataMaskValues.DATA_MASK_111, new DataMask(DataMaskValues.DATA_MASK_111, (i2, j) => {
        return (i2 + j + i2 * j % 3 & 1) === 0;
      })]
    ]);
    class BitMatrixParser$1 {
      /**
       * @param bitMatrix {@link BitMatrix} to parse
       * @throws FormatException if dimension is not >= 21 and 1 mod 4
       */
      constructor(bitMatrix) {
        const dimension = bitMatrix.getHeight();
        if (dimension < 21 || (dimension & 3) !== 1) {
          throw new FormatException();
        }
        this.bitMatrix = bitMatrix;
      }
      /**
       * <p>Reads format information from one of its two locations within the QR Code.</p>
       *
       * @return {@link FormatInformation} encapsulating the QR Code's format info
       * @throws FormatException if both format information locations cannot be parsed as
       * the valid encoding of format information
       */
      readFormatInformation() {
        if (this.parsedFormatInfo !== null && this.parsedFormatInfo !== void 0) {
          return this.parsedFormatInfo;
        }
        let formatInfoBits1 = 0;
        for (let i2 = 0; i2 < 6; i2++) {
          formatInfoBits1 = this.copyBit(i2, 8, formatInfoBits1);
        }
        formatInfoBits1 = this.copyBit(7, 8, formatInfoBits1);
        formatInfoBits1 = this.copyBit(8, 8, formatInfoBits1);
        formatInfoBits1 = this.copyBit(8, 7, formatInfoBits1);
        for (let j = 5; j >= 0; j--) {
          formatInfoBits1 = this.copyBit(8, j, formatInfoBits1);
        }
        const dimension = this.bitMatrix.getHeight();
        let formatInfoBits2 = 0;
        const jMin = dimension - 7;
        for (let j = dimension - 1; j >= jMin; j--) {
          formatInfoBits2 = this.copyBit(8, j, formatInfoBits2);
        }
        for (let i2 = dimension - 8; i2 < dimension; i2++) {
          formatInfoBits2 = this.copyBit(i2, 8, formatInfoBits2);
        }
        this.parsedFormatInfo = FormatInformation.decodeFormatInformation(formatInfoBits1, formatInfoBits2);
        if (this.parsedFormatInfo !== null) {
          return this.parsedFormatInfo;
        }
        throw new FormatException();
      }
      /**
       * <p>Reads version information from one of its two locations within the QR Code.</p>
       *
       * @return {@link Version} encapsulating the QR Code's version
       * @throws FormatException if both version information locations cannot be parsed as
       * the valid encoding of version information
       */
      readVersion() {
        if (this.parsedVersion !== null && this.parsedVersion !== void 0) {
          return this.parsedVersion;
        }
        const dimension = this.bitMatrix.getHeight();
        const provisionalVersion = Math.floor((dimension - 17) / 4);
        if (provisionalVersion <= 6) {
          return Version$1.getVersionForNumber(provisionalVersion);
        }
        let versionBits = 0;
        const ijMin = dimension - 11;
        for (let j = 5; j >= 0; j--) {
          for (let i2 = dimension - 9; i2 >= ijMin; i2--) {
            versionBits = this.copyBit(i2, j, versionBits);
          }
        }
        let theParsedVersion = Version$1.decodeVersionInformation(versionBits);
        if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
          this.parsedVersion = theParsedVersion;
          return theParsedVersion;
        }
        versionBits = 0;
        for (let i2 = 5; i2 >= 0; i2--) {
          for (let j = dimension - 9; j >= ijMin; j--) {
            versionBits = this.copyBit(i2, j, versionBits);
          }
        }
        theParsedVersion = Version$1.decodeVersionInformation(versionBits);
        if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
          this.parsedVersion = theParsedVersion;
          return theParsedVersion;
        }
        throw new FormatException();
      }
      copyBit(i2, j, versionBits) {
        const bit = this.isMirror ? this.bitMatrix.get(j, i2) : this.bitMatrix.get(i2, j);
        return bit ? versionBits << 1 | 1 : versionBits << 1;
      }
      /**
       * <p>Reads the bits in the {@link BitMatrix} representing the finder pattern in the
       * correct order in order to reconstruct the codewords bytes contained within the
       * QR Code.</p>
       *
       * @return bytes encoded within the QR Code
       * @throws FormatException if the exact number of bytes expected is not read
       */
      readCodewords() {
        const formatInfo = this.readFormatInformation();
        const version2 = this.readVersion();
        const dataMask = DataMask.values.get(formatInfo.getDataMask());
        const dimension = this.bitMatrix.getHeight();
        dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
        const functionPattern = version2.buildFunctionPattern();
        let readingUp = true;
        const result2 = new Uint8Array(version2.getTotalCodewords());
        let resultOffset = 0;
        let currentByte = 0;
        let bitsRead = 0;
        for (let j = dimension - 1; j > 0; j -= 2) {
          if (j === 6) {
            j--;
          }
          for (let count = 0; count < dimension; count++) {
            const i2 = readingUp ? dimension - 1 - count : count;
            for (let col = 0; col < 2; col++) {
              if (!functionPattern.get(j - col, i2)) {
                bitsRead++;
                currentByte <<= 1;
                if (this.bitMatrix.get(j - col, i2)) {
                  currentByte |= 1;
                }
                if (bitsRead === 8) {
                  result2[resultOffset++] = /*(byte) */
                  currentByte;
                  bitsRead = 0;
                  currentByte = 0;
                }
              }
            }
          }
          readingUp = !readingUp;
        }
        if (resultOffset !== version2.getTotalCodewords()) {
          throw new FormatException();
        }
        return result2;
      }
      /**
       * Revert the mask removal done while reading the code words. The bit matrix should revert to its original state.
       */
      remask() {
        if (this.parsedFormatInfo === null) {
          return;
        }
        const dataMask = DataMask.values[this.parsedFormatInfo.getDataMask()];
        const dimension = this.bitMatrix.getHeight();
        dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
      }
      /**
       * Prepare the parser for a mirrored operation.
       * This flag has effect only on the {@link #readFormatInformation()} and the
       * {@link #readVersion()}. Before proceeding with {@link #readCodewords()} the
       * {@link #mirror()} method should be called.
       *
       * @param mirror Whether to read version and format information mirrored.
       */
      setMirror(isMirror) {
        this.parsedVersion = null;
        this.parsedFormatInfo = null;
        this.isMirror = isMirror;
      }
      /** Mirror the bit matrix in order to attempt a second reading. */
      mirror() {
        const bitMatrix = this.bitMatrix;
        for (let x2 = 0, width = bitMatrix.getWidth(); x2 < width; x2++) {
          for (let y = x2 + 1, height = bitMatrix.getHeight(); y < height; y++) {
            if (bitMatrix.get(x2, y) !== bitMatrix.get(y, x2)) {
              bitMatrix.flip(y, x2);
              bitMatrix.flip(x2, y);
            }
          }
        }
      }
    }
    class DataBlock$1 {
      constructor(numDataCodewords, codewords) {
        this.numDataCodewords = numDataCodewords;
        this.codewords = codewords;
      }
      /**
       * <p>When QR Codes use multiple data blocks, they are actually interleaved.
       * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
       * method will separate the data into original blocks.</p>
       *
       * @param rawCodewords bytes as read directly from the QR Code
       * @param version version of the QR Code
       * @param ecLevel error-correction level of the QR Code
       * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
       *         QR Code
       */
      static getDataBlocks(rawCodewords, version2, ecLevel) {
        if (rawCodewords.length !== version2.getTotalCodewords()) {
          throw new IllegalArgumentException();
        }
        const ecBlocks = version2.getECBlocksForLevel(ecLevel);
        let totalBlocks = 0;
        const ecBlockArray = ecBlocks.getECBlocks();
        for (const ecBlock of ecBlockArray) {
          totalBlocks += ecBlock.getCount();
        }
        const result2 = new Array(totalBlocks);
        let numResultBlocks = 0;
        for (const ecBlock of ecBlockArray) {
          for (let i2 = 0; i2 < ecBlock.getCount(); i2++) {
            const numDataCodewords = ecBlock.getDataCodewords();
            const numBlockCodewords = ecBlocks.getECCodewordsPerBlock() + numDataCodewords;
            result2[numResultBlocks++] = new DataBlock$1(numDataCodewords, new Uint8Array(numBlockCodewords));
          }
        }
        const shorterBlocksTotalCodewords = result2[0].codewords.length;
        let longerBlocksStartAt = result2.length - 1;
        while (longerBlocksStartAt >= 0) {
          const numCodewords = result2[longerBlocksStartAt].codewords.length;
          if (numCodewords === shorterBlocksTotalCodewords) {
            break;
          }
          longerBlocksStartAt--;
        }
        longerBlocksStartAt++;
        const shorterBlocksNumDataCodewords = shorterBlocksTotalCodewords - ecBlocks.getECCodewordsPerBlock();
        let rawCodewordsOffset = 0;
        for (let i2 = 0; i2 < shorterBlocksNumDataCodewords; i2++) {
          for (let j = 0; j < numResultBlocks; j++) {
            result2[j].codewords[i2] = rawCodewords[rawCodewordsOffset++];
          }
        }
        for (let j = longerBlocksStartAt; j < numResultBlocks; j++) {
          result2[j].codewords[shorterBlocksNumDataCodewords] = rawCodewords[rawCodewordsOffset++];
        }
        const max2 = result2[0].codewords.length;
        for (let i2 = shorterBlocksNumDataCodewords; i2 < max2; i2++) {
          for (let j = 0; j < numResultBlocks; j++) {
            const iOffset = j < longerBlocksStartAt ? i2 : i2 + 1;
            result2[j].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
          }
        }
        return result2;
      }
      getNumDataCodewords() {
        return this.numDataCodewords;
      }
      getCodewords() {
        return this.codewords;
      }
    }
    var ModeValues;
    (function(ModeValues2) {
      ModeValues2[ModeValues2["TERMINATOR"] = 0] = "TERMINATOR";
      ModeValues2[ModeValues2["NUMERIC"] = 1] = "NUMERIC";
      ModeValues2[ModeValues2["ALPHANUMERIC"] = 2] = "ALPHANUMERIC";
      ModeValues2[ModeValues2["STRUCTURED_APPEND"] = 3] = "STRUCTURED_APPEND";
      ModeValues2[ModeValues2["BYTE"] = 4] = "BYTE";
      ModeValues2[ModeValues2["ECI"] = 5] = "ECI";
      ModeValues2[ModeValues2["KANJI"] = 6] = "KANJI";
      ModeValues2[ModeValues2["FNC1_FIRST_POSITION"] = 7] = "FNC1_FIRST_POSITION";
      ModeValues2[ModeValues2["FNC1_SECOND_POSITION"] = 8] = "FNC1_SECOND_POSITION";
      ModeValues2[ModeValues2["HANZI"] = 9] = "HANZI";
    })(ModeValues || (ModeValues = {}));
    class Mode$1 {
      constructor(value, stringValue, characterCountBitsForVersions, bits) {
        this.value = value;
        this.stringValue = stringValue;
        this.characterCountBitsForVersions = characterCountBitsForVersions;
        this.bits = bits;
        Mode$1.FOR_BITS.set(bits, this);
        Mode$1.FOR_VALUE.set(value, this);
      }
      /**
       * @param bits four bits encoding a QR Code data mode
       * @return Mode encoded by these bits
       * @throws IllegalArgumentException if bits do not correspond to a known mode
       */
      static forBits(bits) {
        const mode = Mode$1.FOR_BITS.get(bits);
        if (void 0 === mode) {
          throw new IllegalArgumentException();
        }
        return mode;
      }
      /**
       * @param version version in question
       * @return number of bits used, in this QR Code symbol {@link Version}, to encode the
       *         count of characters that will follow encoded in this Mode
       */
      getCharacterCountBits(version2) {
        const versionNumber = version2.getVersionNumber();
        let offset2;
        if (versionNumber <= 9) {
          offset2 = 0;
        } else if (versionNumber <= 26) {
          offset2 = 1;
        } else {
          offset2 = 2;
        }
        return this.characterCountBitsForVersions[offset2];
      }
      getValue() {
        return this.value;
      }
      getBits() {
        return this.bits;
      }
      equals(o) {
        if (!(o instanceof Mode$1)) {
          return false;
        }
        const other = o;
        return this.value === other.value;
      }
      toString() {
        return this.stringValue;
      }
    }
    Mode$1.FOR_BITS = /* @__PURE__ */ new Map();
    Mode$1.FOR_VALUE = /* @__PURE__ */ new Map();
    Mode$1.TERMINATOR = new Mode$1(ModeValues.TERMINATOR, "TERMINATOR", Int32Array.from([0, 0, 0]), 0);
    Mode$1.NUMERIC = new Mode$1(ModeValues.NUMERIC, "NUMERIC", Int32Array.from([10, 12, 14]), 1);
    Mode$1.ALPHANUMERIC = new Mode$1(ModeValues.ALPHANUMERIC, "ALPHANUMERIC", Int32Array.from([9, 11, 13]), 2);
    Mode$1.STRUCTURED_APPEND = new Mode$1(ModeValues.STRUCTURED_APPEND, "STRUCTURED_APPEND", Int32Array.from([0, 0, 0]), 3);
    Mode$1.BYTE = new Mode$1(ModeValues.BYTE, "BYTE", Int32Array.from([8, 16, 16]), 4);
    Mode$1.ECI = new Mode$1(ModeValues.ECI, "ECI", Int32Array.from([0, 0, 0]), 7);
    Mode$1.KANJI = new Mode$1(ModeValues.KANJI, "KANJI", Int32Array.from([8, 10, 12]), 8);
    Mode$1.FNC1_FIRST_POSITION = new Mode$1(ModeValues.FNC1_FIRST_POSITION, "FNC1_FIRST_POSITION", Int32Array.from([0, 0, 0]), 5);
    Mode$1.FNC1_SECOND_POSITION = new Mode$1(ModeValues.FNC1_SECOND_POSITION, "FNC1_SECOND_POSITION", Int32Array.from([0, 0, 0]), 9);
    Mode$1.HANZI = new Mode$1(ModeValues.HANZI, "HANZI", Int32Array.from([8, 10, 12]), 13);
    class DecodedBitStreamParser$1 {
      static decode(bytes, version2, ecLevel, hints) {
        const bits = new BitSource(bytes);
        let result2 = new StringBuilder();
        const byteSegments = new Array();
        let symbolSequence = -1;
        let parityData = -1;
        try {
          let currentCharacterSetECI = null;
          let fc1InEffect = false;
          let mode;
          do {
            if (bits.available() < 4) {
              mode = Mode$1.TERMINATOR;
            } else {
              const modeBits = bits.readBits(4);
              mode = Mode$1.forBits(modeBits);
            }
            switch (mode) {
              case Mode$1.TERMINATOR:
                break;
              case Mode$1.FNC1_FIRST_POSITION:
              case Mode$1.FNC1_SECOND_POSITION:
                fc1InEffect = true;
                break;
              case Mode$1.STRUCTURED_APPEND:
                if (bits.available() < 16) {
                  throw new FormatException();
                }
                symbolSequence = bits.readBits(8);
                parityData = bits.readBits(8);
                break;
              case Mode$1.ECI:
                const value = DecodedBitStreamParser$1.parseECIValue(bits);
                currentCharacterSetECI = CharacterSetECI.getCharacterSetECIByValue(value);
                if (currentCharacterSetECI === null) {
                  throw new FormatException();
                }
                break;
              case Mode$1.HANZI:
                const subset = bits.readBits(4);
                const countHanzi = bits.readBits(mode.getCharacterCountBits(version2));
                if (subset === DecodedBitStreamParser$1.GB2312_SUBSET) {
                  DecodedBitStreamParser$1.decodeHanziSegment(bits, result2, countHanzi);
                }
                break;
              default:
                const count = bits.readBits(mode.getCharacterCountBits(version2));
                switch (mode) {
                  case Mode$1.NUMERIC:
                    DecodedBitStreamParser$1.decodeNumericSegment(bits, result2, count);
                    break;
                  case Mode$1.ALPHANUMERIC:
                    DecodedBitStreamParser$1.decodeAlphanumericSegment(bits, result2, count, fc1InEffect);
                    break;
                  case Mode$1.BYTE:
                    DecodedBitStreamParser$1.decodeByteSegment(bits, result2, count, currentCharacterSetECI, byteSegments, hints);
                    break;
                  case Mode$1.KANJI:
                    DecodedBitStreamParser$1.decodeKanjiSegment(bits, result2, count);
                    break;
                  default:
                    throw new FormatException();
                }
                break;
            }
          } while (mode !== Mode$1.TERMINATOR);
        } catch (iae) {
          throw new FormatException();
        }
        return new DecoderResult(bytes, result2.toString(), byteSegments.length === 0 ? null : byteSegments, ecLevel === null ? null : ecLevel.toString(), symbolSequence, parityData);
      }
      /**
       * See specification GBT 18284-2000
       */
      static decodeHanziSegment(bits, result2, count) {
        if (count * 13 > bits.available()) {
          throw new FormatException();
        }
        const buffer = new Uint8Array(2 * count);
        let offset2 = 0;
        while (count > 0) {
          const twoBytes = bits.readBits(13);
          let assembledTwoBytes = twoBytes / 96 << 8 & 4294967295 | twoBytes % 96;
          if (assembledTwoBytes < 959) {
            assembledTwoBytes += 41377;
          } else {
            assembledTwoBytes += 42657;
          }
          buffer[offset2] = /*(byte) */
          assembledTwoBytes >> 8 & 255;
          buffer[offset2 + 1] = /*(byte) */
          assembledTwoBytes & 255;
          offset2 += 2;
          count--;
        }
        try {
          result2.append(StringEncoding.decode(buffer, StringUtils.GB2312));
        } catch (ignored) {
          throw new FormatException(ignored);
        }
      }
      static decodeKanjiSegment(bits, result2, count) {
        if (count * 13 > bits.available()) {
          throw new FormatException();
        }
        const buffer = new Uint8Array(2 * count);
        let offset2 = 0;
        while (count > 0) {
          const twoBytes = bits.readBits(13);
          let assembledTwoBytes = twoBytes / 192 << 8 & 4294967295 | twoBytes % 192;
          if (assembledTwoBytes < 7936) {
            assembledTwoBytes += 33088;
          } else {
            assembledTwoBytes += 49472;
          }
          buffer[offset2] = /*(byte) */
          assembledTwoBytes >> 8;
          buffer[offset2 + 1] = /*(byte) */
          assembledTwoBytes;
          offset2 += 2;
          count--;
        }
        try {
          result2.append(StringEncoding.decode(buffer, StringUtils.SHIFT_JIS));
        } catch (ignored) {
          throw new FormatException(ignored);
        }
      }
      static decodeByteSegment(bits, result2, count, currentCharacterSetECI, byteSegments, hints) {
        if (8 * count > bits.available()) {
          throw new FormatException();
        }
        const readBytes = new Uint8Array(count);
        for (let i2 = 0; i2 < count; i2++) {
          readBytes[i2] = /*(byte) */
          bits.readBits(8);
        }
        let encoding;
        if (currentCharacterSetECI === null) {
          encoding = StringUtils.guessEncoding(readBytes, hints);
        } else {
          encoding = currentCharacterSetECI.getName();
        }
        try {
          result2.append(StringEncoding.decode(readBytes, encoding));
        } catch (ignored) {
          throw new FormatException(ignored);
        }
        byteSegments.push(readBytes);
      }
      static toAlphaNumericChar(value) {
        if (value >= DecodedBitStreamParser$1.ALPHANUMERIC_CHARS.length) {
          throw new FormatException();
        }
        return DecodedBitStreamParser$1.ALPHANUMERIC_CHARS[value];
      }
      static decodeAlphanumericSegment(bits, result2, count, fc1InEffect) {
        const start = result2.length();
        while (count > 1) {
          if (bits.available() < 11) {
            throw new FormatException();
          }
          const nextTwoCharsBits = bits.readBits(11);
          result2.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(nextTwoCharsBits / 45)));
          result2.append(DecodedBitStreamParser$1.toAlphaNumericChar(nextTwoCharsBits % 45));
          count -= 2;
        }
        if (count === 1) {
          if (bits.available() < 6) {
            throw new FormatException();
          }
          result2.append(DecodedBitStreamParser$1.toAlphaNumericChar(bits.readBits(6)));
        }
        if (fc1InEffect) {
          for (let i2 = start; i2 < result2.length(); i2++) {
            if (result2.charAt(i2) === "%") {
              if (i2 < result2.length() - 1 && result2.charAt(i2 + 1) === "%") {
                result2.deleteCharAt(i2 + 1);
              } else {
                result2.setCharAt(i2, String.fromCharCode(29));
              }
            }
          }
        }
      }
      static decodeNumericSegment(bits, result2, count) {
        while (count >= 3) {
          if (bits.available() < 10) {
            throw new FormatException();
          }
          const threeDigitsBits = bits.readBits(10);
          if (threeDigitsBits >= 1e3) {
            throw new FormatException();
          }
          result2.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(threeDigitsBits / 100)));
          result2.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(threeDigitsBits / 10) % 10));
          result2.append(DecodedBitStreamParser$1.toAlphaNumericChar(threeDigitsBits % 10));
          count -= 3;
        }
        if (count === 2) {
          if (bits.available() < 7) {
            throw new FormatException();
          }
          const twoDigitsBits = bits.readBits(7);
          if (twoDigitsBits >= 100) {
            throw new FormatException();
          }
          result2.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(twoDigitsBits / 10)));
          result2.append(DecodedBitStreamParser$1.toAlphaNumericChar(twoDigitsBits % 10));
        } else if (count === 1) {
          if (bits.available() < 4) {
            throw new FormatException();
          }
          const digitBits = bits.readBits(4);
          if (digitBits >= 10) {
            throw new FormatException();
          }
          result2.append(DecodedBitStreamParser$1.toAlphaNumericChar(digitBits));
        }
      }
      static parseECIValue(bits) {
        const firstByte = bits.readBits(8);
        if ((firstByte & 128) === 0) {
          return firstByte & 127;
        }
        if ((firstByte & 192) === 128) {
          const secondByte = bits.readBits(8);
          return (firstByte & 63) << 8 & 4294967295 | secondByte;
        }
        if ((firstByte & 224) === 192) {
          const secondThirdBytes = bits.readBits(16);
          return (firstByte & 31) << 16 & 4294967295 | secondThirdBytes;
        }
        throw new FormatException();
      }
    }
    DecodedBitStreamParser$1.ALPHANUMERIC_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    DecodedBitStreamParser$1.GB2312_SUBSET = 1;
    class QRCodeDecoderMetaData {
      constructor(mirrored) {
        this.mirrored = mirrored;
      }
      /**
       * @return true if the QR Code was mirrored.
       */
      isMirrored() {
        return this.mirrored;
      }
      /**
       * Apply the result points' order correction due to mirroring.
       *
       * @param points Array of points to apply mirror correction to.
       */
      applyMirroredCorrection(points) {
        if (!this.mirrored || points === null || points.length < 3) {
          return;
        }
        const bottomLeft = points[0];
        points[0] = points[2];
        points[2] = bottomLeft;
      }
    }
    class Decoder$2 {
      constructor() {
        this.rsDecoder = new ReedSolomonDecoder(GenericGF.QR_CODE_FIELD_256);
      }
      // public decode(image: boolean[][]): DecoderResult /*throws ChecksumException, FormatException*/ {
      //   return decode(image, null)
      // }
      /**
       * <p>Convenience method that can decode a QR Code represented as a 2D array of booleans.
       * "true" is taken to mean a black module.</p>
       *
       * @param image booleans representing white/black QR Code modules
       * @param hints decoding hints that should be used to influence decoding
       * @return text and bytes encoded within the QR Code
       * @throws FormatException if the QR Code cannot be decoded
       * @throws ChecksumException if error correction fails
       */
      decodeBooleanArray(image, hints) {
        return this.decodeBitMatrix(BitMatrix.parseFromBooleanArray(image), hints);
      }
      // public decodeBitMatrix(bits: BitMatrix): DecoderResult /*throws ChecksumException, FormatException*/ {
      //   return decode(bits, null)
      // }
      /**
       * <p>Decodes a QR Code represented as a {@link BitMatrix}. A 1 or "true" is taken to mean a black module.</p>
       *
       * @param bits booleans representing white/black QR Code modules
       * @param hints decoding hints that should be used to influence decoding
       * @return text and bytes encoded within the QR Code
       * @throws FormatException if the QR Code cannot be decoded
       * @throws ChecksumException if error correction fails
       */
      decodeBitMatrix(bits, hints) {
        const parser2 = new BitMatrixParser$1(bits);
        let ex = null;
        try {
          return this.decodeBitMatrixParser(parser2, hints);
        } catch (e) {
          ex = e;
        }
        try {
          parser2.remask();
          parser2.setMirror(true);
          parser2.readVersion();
          parser2.readFormatInformation();
          parser2.mirror();
          const result2 = this.decodeBitMatrixParser(parser2, hints);
          result2.setOther(new QRCodeDecoderMetaData(true));
          return result2;
        } catch (e) {
          if (ex !== null) {
            throw ex;
          }
          throw e;
        }
      }
      decodeBitMatrixParser(parser2, hints) {
        const version2 = parser2.readVersion();
        const ecLevel = parser2.readFormatInformation().getErrorCorrectionLevel();
        const codewords = parser2.readCodewords();
        const dataBlocks = DataBlock$1.getDataBlocks(codewords, version2, ecLevel);
        let totalBytes = 0;
        for (const dataBlock of dataBlocks) {
          totalBytes += dataBlock.getNumDataCodewords();
        }
        const resultBytes = new Uint8Array(totalBytes);
        let resultOffset = 0;
        for (const dataBlock of dataBlocks) {
          const codewordBytes = dataBlock.getCodewords();
          const numDataCodewords = dataBlock.getNumDataCodewords();
          this.correctErrors(codewordBytes, numDataCodewords);
          for (let i2 = 0; i2 < numDataCodewords; i2++) {
            resultBytes[resultOffset++] = codewordBytes[i2];
          }
        }
        return DecodedBitStreamParser$1.decode(resultBytes, version2, ecLevel, hints);
      }
      /**
       * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
       * correct the errors in-place using Reed-Solomon error correction.</p>
       *
       * @param codewordBytes data and error correction codewords
       * @param numDataCodewords number of codewords that are data bytes
       * @throws ChecksumException if error correction fails
       */
      correctErrors(codewordBytes, numDataCodewords) {
        const codewordsInts = new Int32Array(codewordBytes);
        try {
          this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
        } catch (ignored) {
          throw new ChecksumException();
        }
        for (let i2 = 0; i2 < numDataCodewords; i2++) {
          codewordBytes[i2] = /*(byte) */
          codewordsInts[i2];
        }
      }
    }
    class AlignmentPattern extends ResultPoint {
      constructor(posX, posY, estimatedModuleSize) {
        super(posX, posY);
        this.estimatedModuleSize = estimatedModuleSize;
      }
      /**
       * <p>Determines if this alignment pattern "about equals" an alignment pattern at the stated
       * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
       */
      aboutEquals(moduleSize, i2, j) {
        if (Math.abs(i2 - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
          const moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
          return moduleSizeDiff <= 1 || moduleSizeDiff <= this.estimatedModuleSize;
        }
        return false;
      }
      /**
       * Combines this object's current estimate of a finder pattern position and module size
       * with a new estimate. It returns a new {@code FinderPattern} containing an average of the two.
       */
      combineEstimate(i2, j, newModuleSize) {
        const combinedX = (this.getX() + j) / 2;
        const combinedY = (this.getY() + i2) / 2;
        const combinedModuleSize = (this.estimatedModuleSize + newModuleSize) / 2;
        return new AlignmentPattern(combinedX, combinedY, combinedModuleSize);
      }
    }
    class AlignmentPatternFinder {
      /**
       * <p>Creates a finder that will look in a portion of the whole image.</p>
       *
       * @param image image to search
       * @param startX left column from which to start searching
       * @param startY top row from which to start searching
       * @param width width of region to search
       * @param height height of region to search
       * @param moduleSize estimated module size so far
       */
      constructor(image, startX, startY, width, height, moduleSize, resultPointCallback) {
        this.image = image;
        this.startX = startX;
        this.startY = startY;
        this.width = width;
        this.height = height;
        this.moduleSize = moduleSize;
        this.resultPointCallback = resultPointCallback;
        this.possibleCenters = [];
        this.crossCheckStateCount = new Int32Array(3);
      }
      /**
       * <p>This method attempts to find the bottom-right alignment pattern in the image. It is a bit messy since
       * it's pretty performance-critical and so is written to be fast foremost.</p>
       *
       * @return {@link AlignmentPattern} if found
       * @throws NotFoundException if not found
       */
      find() {
        const startX = this.startX;
        const height = this.height;
        const width = this.width;
        const maxJ = startX + width;
        const middleI = this.startY + height / 2;
        const stateCount = new Int32Array(3);
        const image = this.image;
        for (let iGen = 0; iGen < height; iGen++) {
          const i2 = middleI + ((iGen & 1) === 0 ? Math.floor((iGen + 1) / 2) : -Math.floor((iGen + 1) / 2));
          stateCount[0] = 0;
          stateCount[1] = 0;
          stateCount[2] = 0;
          let j = startX;
          while (j < maxJ && !image.get(j, i2)) {
            j++;
          }
          let currentState = 0;
          while (j < maxJ) {
            if (image.get(j, i2)) {
              if (currentState === 1) {
                stateCount[1]++;
              } else {
                if (currentState === 2) {
                  if (this.foundPatternCross(stateCount)) {
                    const confirmed = this.handlePossibleCenter(stateCount, i2, j);
                    if (confirmed !== null) {
                      return confirmed;
                    }
                  }
                  stateCount[0] = stateCount[2];
                  stateCount[1] = 1;
                  stateCount[2] = 0;
                  currentState = 1;
                } else {
                  stateCount[++currentState]++;
                }
              }
            } else {
              if (currentState === 1) {
                currentState++;
              }
              stateCount[currentState]++;
            }
            j++;
          }
          if (this.foundPatternCross(stateCount)) {
            const confirmed = this.handlePossibleCenter(stateCount, i2, maxJ);
            if (confirmed !== null) {
              return confirmed;
            }
          }
        }
        if (this.possibleCenters.length !== 0) {
          return this.possibleCenters[0];
        }
        throw new NotFoundException();
      }
      /**
       * Given a count of black/white/black pixels just seen and an end position,
       * figures the location of the center of this black/white/black run.
       */
      static centerFromEnd(stateCount, end) {
        return end - stateCount[2] - stateCount[1] / 2;
      }
      /**
       * @param stateCount count of black/white/black pixels just read
       * @return true iff the proportions of the counts is close enough to the 1/1/1 ratios
       *         used by alignment patterns to be considered a match
       */
      foundPatternCross(stateCount) {
        const moduleSize = this.moduleSize;
        const maxVariance = moduleSize / 2;
        for (let i2 = 0; i2 < 3; i2++) {
          if (Math.abs(moduleSize - stateCount[i2]) >= maxVariance) {
            return false;
          }
        }
        return true;
      }
      /**
       * <p>After a horizontal scan finds a potential alignment pattern, this method
       * "cross-checks" by scanning down vertically through the center of the possible
       * alignment pattern to see if the same proportion is detected.</p>
       *
       * @param startI row where an alignment pattern was detected
       * @param centerJ center of the section that appears to cross an alignment pattern
       * @param maxCount maximum reasonable number of modules that should be
       * observed in any reading state, based on the results of the horizontal scan
       * @return vertical center of alignment pattern, or {@link Float#NaN} if not found
       */
      crossCheckVertical(startI, centerJ, maxCount, originalStateCountTotal) {
        const image = this.image;
        const maxI = image.getHeight();
        const stateCount = this.crossCheckStateCount;
        stateCount[0] = 0;
        stateCount[1] = 0;
        stateCount[2] = 0;
        let i2 = startI;
        while (i2 >= 0 && image.get(centerJ, i2) && stateCount[1] <= maxCount) {
          stateCount[1]++;
          i2--;
        }
        if (i2 < 0 || stateCount[1] > maxCount) {
          return NaN;
        }
        while (i2 >= 0 && !image.get(centerJ, i2) && stateCount[0] <= maxCount) {
          stateCount[0]++;
          i2--;
        }
        if (stateCount[0] > maxCount) {
          return NaN;
        }
        i2 = startI + 1;
        while (i2 < maxI && image.get(centerJ, i2) && stateCount[1] <= maxCount) {
          stateCount[1]++;
          i2++;
        }
        if (i2 === maxI || stateCount[1] > maxCount) {
          return NaN;
        }
        while (i2 < maxI && !image.get(centerJ, i2) && stateCount[2] <= maxCount) {
          stateCount[2]++;
          i2++;
        }
        if (stateCount[2] > maxCount) {
          return NaN;
        }
        const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
        if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) {
          return NaN;
        }
        return this.foundPatternCross(stateCount) ? AlignmentPatternFinder.centerFromEnd(stateCount, i2) : NaN;
      }
      /**
       * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
       * cross check with a vertical scan, and if successful, will see if this pattern had been
       * found on a previous horizontal scan. If so, we consider it confirmed and conclude we have
       * found the alignment pattern.</p>
       *
       * @param stateCount reading state module counts from horizontal scan
       * @param i row where alignment pattern may be found
       * @param j end of possible alignment pattern in row
       * @return {@link AlignmentPattern} if we have found the same pattern twice, or null if not
       */
      handlePossibleCenter(stateCount, i2, j) {
        const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
        const centerJ = AlignmentPatternFinder.centerFromEnd(stateCount, j);
        const centerI = this.crossCheckVertical(
          i2,
          /*(int) */
          centerJ,
          2 * stateCount[1],
          stateCountTotal
        );
        if (!isNaN(centerI)) {
          const estimatedModuleSize = (stateCount[0] + stateCount[1] + stateCount[2]) / 3;
          for (const center of this.possibleCenters) {
            if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) {
              return center.combineEstimate(centerI, centerJ, estimatedModuleSize);
            }
          }
          const point = new AlignmentPattern(centerJ, centerI, estimatedModuleSize);
          this.possibleCenters.push(point);
          if (this.resultPointCallback !== null && this.resultPointCallback !== void 0) {
            this.resultPointCallback.foundPossibleResultPoint(point);
          }
        }
        return null;
      }
    }
    class FinderPattern$1 extends ResultPoint {
      // FinderPattern(posX: number/*float*/, posY: number/*float*/, estimatedModuleSize: number/*float*/) {
      //   this(posX, posY, estimatedModuleSize, 1)
      // }
      constructor(posX, posY, estimatedModuleSize, count) {
        super(posX, posY);
        this.estimatedModuleSize = estimatedModuleSize;
        this.count = count;
        if (void 0 === count) {
          this.count = 1;
        }
      }
      getEstimatedModuleSize() {
        return this.estimatedModuleSize;
      }
      getCount() {
        return this.count;
      }
      /*
      void incrementCount() {
        this.count++
      }
       */
      /**
       * <p>Determines if this finder pattern "about equals" a finder pattern at the stated
       * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
       */
      aboutEquals(moduleSize, i2, j) {
        if (Math.abs(i2 - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
          const moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
          return moduleSizeDiff <= 1 || moduleSizeDiff <= this.estimatedModuleSize;
        }
        return false;
      }
      /**
       * Combines this object's current estimate of a finder pattern position and module size
       * with a new estimate. It returns a new {@code FinderPattern} containing a weighted average
       * based on count.
       */
      combineEstimate(i2, j, newModuleSize) {
        const combinedCount = this.count + 1;
        const combinedX = (this.count * this.getX() + j) / combinedCount;
        const combinedY = (this.count * this.getY() + i2) / combinedCount;
        const combinedModuleSize = (this.count * this.estimatedModuleSize + newModuleSize) / combinedCount;
        return new FinderPattern$1(combinedX, combinedY, combinedModuleSize, combinedCount);
      }
    }
    class FinderPatternInfo {
      constructor(patternCenters) {
        this.bottomLeft = patternCenters[0];
        this.topLeft = patternCenters[1];
        this.topRight = patternCenters[2];
      }
      getBottomLeft() {
        return this.bottomLeft;
      }
      getTopLeft() {
        return this.topLeft;
      }
      getTopRight() {
        return this.topRight;
      }
    }
    class FinderPatternFinder {
      /**
       * <p>Creates a finder that will search the image for three finder patterns.</p>
       *
       * @param image image to search
       */
      // public constructor(image: BitMatrix) {
      //   this(image, null)
      // }
      constructor(image, resultPointCallback) {
        this.image = image;
        this.resultPointCallback = resultPointCallback;
        this.possibleCenters = [];
        this.crossCheckStateCount = new Int32Array(5);
        this.resultPointCallback = resultPointCallback;
      }
      getImage() {
        return this.image;
      }
      getPossibleCenters() {
        return this.possibleCenters;
      }
      find(hints) {
        const tryHarder = hints !== null && hints !== void 0 && void 0 !== hints.get(DecodeHintType$1.TRY_HARDER);
        const pureBarcode = hints !== null && hints !== void 0 && void 0 !== hints.get(DecodeHintType$1.PURE_BARCODE);
        const image = this.image;
        const maxI = image.getHeight();
        const maxJ = image.getWidth();
        let iSkip = Math.floor(3 * maxI / (4 * FinderPatternFinder.MAX_MODULES));
        if (iSkip < FinderPatternFinder.MIN_SKIP || tryHarder) {
          iSkip = FinderPatternFinder.MIN_SKIP;
        }
        let done = false;
        const stateCount = new Int32Array(5);
        for (let i2 = iSkip - 1; i2 < maxI && !done; i2 += iSkip) {
          stateCount[0] = 0;
          stateCount[1] = 0;
          stateCount[2] = 0;
          stateCount[3] = 0;
          stateCount[4] = 0;
          let currentState = 0;
          for (let j = 0; j < maxJ; j++) {
            if (image.get(j, i2)) {
              if ((currentState & 1) === 1) {
                currentState++;
              }
              stateCount[currentState]++;
            } else {
              if ((currentState & 1) === 0) {
                if (currentState === 4) {
                  if (FinderPatternFinder.foundPatternCross(stateCount)) {
                    const confirmed = this.handlePossibleCenter(stateCount, i2, j, pureBarcode);
                    if (confirmed === true) {
                      iSkip = 2;
                      if (this.hasSkipped === true) {
                        done = this.haveMultiplyConfirmedCenters();
                      } else {
                        const rowSkip = this.findRowSkip();
                        if (rowSkip > stateCount[2]) {
                          i2 += rowSkip - stateCount[2] - iSkip;
                          j = maxJ - 1;
                        }
                      }
                    } else {
                      stateCount[0] = stateCount[2];
                      stateCount[1] = stateCount[3];
                      stateCount[2] = stateCount[4];
                      stateCount[3] = 1;
                      stateCount[4] = 0;
                      currentState = 3;
                      continue;
                    }
                    currentState = 0;
                    stateCount[0] = 0;
                    stateCount[1] = 0;
                    stateCount[2] = 0;
                    stateCount[3] = 0;
                    stateCount[4] = 0;
                  } else {
                    stateCount[0] = stateCount[2];
                    stateCount[1] = stateCount[3];
                    stateCount[2] = stateCount[4];
                    stateCount[3] = 1;
                    stateCount[4] = 0;
                    currentState = 3;
                  }
                } else {
                  stateCount[++currentState]++;
                }
              } else {
                stateCount[currentState]++;
              }
            }
          }
          if (FinderPatternFinder.foundPatternCross(stateCount)) {
            const confirmed = this.handlePossibleCenter(stateCount, i2, maxJ, pureBarcode);
            if (confirmed === true) {
              iSkip = stateCount[0];
              if (this.hasSkipped) {
                done = this.haveMultiplyConfirmedCenters();
              }
            }
          }
        }
        const patternInfo = this.selectBestPatterns();
        ResultPoint.orderBestPatterns(patternInfo);
        return new FinderPatternInfo(patternInfo);
      }
      /**
       * Given a count of black/white/black/white/black pixels just seen and an end position,
       * figures the location of the center of this run.
       */
      static centerFromEnd(stateCount, end) {
        return end - stateCount[4] - stateCount[3] - stateCount[2] / 2;
      }
      /**
       * @param stateCount count of black/white/black/white/black pixels just read
       * @return true iff the proportions of the counts is close enough to the 1/1/3/1/1 ratios
       *         used by finder patterns to be considered a match
       */
      static foundPatternCross(stateCount) {
        let totalModuleSize = 0;
        for (let i2 = 0; i2 < 5; i2++) {
          const count = stateCount[i2];
          if (count === 0) {
            return false;
          }
          totalModuleSize += count;
        }
        if (totalModuleSize < 7) {
          return false;
        }
        const moduleSize = totalModuleSize / 7;
        const maxVariance = moduleSize / 2;
        return Math.abs(moduleSize - stateCount[0]) < maxVariance && Math.abs(moduleSize - stateCount[1]) < maxVariance && Math.abs(3 * moduleSize - stateCount[2]) < 3 * maxVariance && Math.abs(moduleSize - stateCount[3]) < maxVariance && Math.abs(moduleSize - stateCount[4]) < maxVariance;
      }
      getCrossCheckStateCount() {
        const crossCheckStateCount = this.crossCheckStateCount;
        crossCheckStateCount[0] = 0;
        crossCheckStateCount[1] = 0;
        crossCheckStateCount[2] = 0;
        crossCheckStateCount[3] = 0;
        crossCheckStateCount[4] = 0;
        return crossCheckStateCount;
      }
      /**
       * After a vertical and horizontal scan finds a potential finder pattern, this method
       * "cross-cross-cross-checks" by scanning down diagonally through the center of the possible
       * finder pattern to see if the same proportion is detected.
       *
       * @param startI row where a finder pattern was detected
       * @param centerJ center of the section that appears to cross a finder pattern
       * @param maxCount maximum reasonable number of modules that should be
       *  observed in any reading state, based on the results of the horizontal scan
       * @param originalStateCountTotal The original state count total.
       * @return true if proportions are withing expected limits
       */
      crossCheckDiagonal(startI, centerJ, maxCount, originalStateCountTotal) {
        const stateCount = this.getCrossCheckStateCount();
        let i2 = 0;
        const image = this.image;
        while (startI >= i2 && centerJ >= i2 && image.get(centerJ - i2, startI - i2)) {
          stateCount[2]++;
          i2++;
        }
        if (startI < i2 || centerJ < i2) {
          return false;
        }
        while (startI >= i2 && centerJ >= i2 && !image.get(centerJ - i2, startI - i2) && stateCount[1] <= maxCount) {
          stateCount[1]++;
          i2++;
        }
        if (startI < i2 || centerJ < i2 || stateCount[1] > maxCount) {
          return false;
        }
        while (startI >= i2 && centerJ >= i2 && image.get(centerJ - i2, startI - i2) && stateCount[0] <= maxCount) {
          stateCount[0]++;
          i2++;
        }
        if (stateCount[0] > maxCount) {
          return false;
        }
        const maxI = image.getHeight();
        const maxJ = image.getWidth();
        i2 = 1;
        while (startI + i2 < maxI && centerJ + i2 < maxJ && image.get(centerJ + i2, startI + i2)) {
          stateCount[2]++;
          i2++;
        }
        if (startI + i2 >= maxI || centerJ + i2 >= maxJ) {
          return false;
        }
        while (startI + i2 < maxI && centerJ + i2 < maxJ && !image.get(centerJ + i2, startI + i2) && stateCount[3] < maxCount) {
          stateCount[3]++;
          i2++;
        }
        if (startI + i2 >= maxI || centerJ + i2 >= maxJ || stateCount[3] >= maxCount) {
          return false;
        }
        while (startI + i2 < maxI && centerJ + i2 < maxJ && image.get(centerJ + i2, startI + i2) && stateCount[4] < maxCount) {
          stateCount[4]++;
          i2++;
        }
        if (stateCount[4] >= maxCount) {
          return false;
        }
        const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
        return Math.abs(stateCountTotal - originalStateCountTotal) < 2 * originalStateCountTotal && FinderPatternFinder.foundPatternCross(stateCount);
      }
      /**
       * <p>After a horizontal scan finds a potential finder pattern, this method
       * "cross-checks" by scanning down vertically through the center of the possible
       * finder pattern to see if the same proportion is detected.</p>
       *
       * @param startI row where a finder pattern was detected
       * @param centerJ center of the section that appears to cross a finder pattern
       * @param maxCount maximum reasonable number of modules that should be
       * observed in any reading state, based on the results of the horizontal scan
       * @return vertical center of finder pattern, or {@link Float#NaN} if not found
       */
      crossCheckVertical(startI, centerJ, maxCount, originalStateCountTotal) {
        const image = this.image;
        const maxI = image.getHeight();
        const stateCount = this.getCrossCheckStateCount();
        let i2 = startI;
        while (i2 >= 0 && image.get(centerJ, i2)) {
          stateCount[2]++;
          i2--;
        }
        if (i2 < 0) {
          return NaN;
        }
        while (i2 >= 0 && !image.get(centerJ, i2) && stateCount[1] <= maxCount) {
          stateCount[1]++;
          i2--;
        }
        if (i2 < 0 || stateCount[1] > maxCount) {
          return NaN;
        }
        while (i2 >= 0 && image.get(centerJ, i2) && stateCount[0] <= maxCount) {
          stateCount[0]++;
          i2--;
        }
        if (stateCount[0] > maxCount) {
          return NaN;
        }
        i2 = startI + 1;
        while (i2 < maxI && image.get(centerJ, i2)) {
          stateCount[2]++;
          i2++;
        }
        if (i2 === maxI) {
          return NaN;
        }
        while (i2 < maxI && !image.get(centerJ, i2) && stateCount[3] < maxCount) {
          stateCount[3]++;
          i2++;
        }
        if (i2 === maxI || stateCount[3] >= maxCount) {
          return NaN;
        }
        while (i2 < maxI && image.get(centerJ, i2) && stateCount[4] < maxCount) {
          stateCount[4]++;
          i2++;
        }
        if (stateCount[4] >= maxCount) {
          return NaN;
        }
        const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
        if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) {
          return NaN;
        }
        return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, i2) : NaN;
      }
      /**
       * <p>Like {@link #crossCheckVertical(int, int, int, int)}, and in fact is basically identical,
       * except it reads horizontally instead of vertically. This is used to cross-cross
       * check a vertical cross check and locate the real center of the alignment pattern.</p>
       */
      crossCheckHorizontal(startJ, centerI, maxCount, originalStateCountTotal) {
        const image = this.image;
        const maxJ = image.getWidth();
        const stateCount = this.getCrossCheckStateCount();
        let j = startJ;
        while (j >= 0 && image.get(j, centerI)) {
          stateCount[2]++;
          j--;
        }
        if (j < 0) {
          return NaN;
        }
        while (j >= 0 && !image.get(j, centerI) && stateCount[1] <= maxCount) {
          stateCount[1]++;
          j--;
        }
        if (j < 0 || stateCount[1] > maxCount) {
          return NaN;
        }
        while (j >= 0 && image.get(j, centerI) && stateCount[0] <= maxCount) {
          stateCount[0]++;
          j--;
        }
        if (stateCount[0] > maxCount) {
          return NaN;
        }
        j = startJ + 1;
        while (j < maxJ && image.get(j, centerI)) {
          stateCount[2]++;
          j++;
        }
        if (j === maxJ) {
          return NaN;
        }
        while (j < maxJ && !image.get(j, centerI) && stateCount[3] < maxCount) {
          stateCount[3]++;
          j++;
        }
        if (j === maxJ || stateCount[3] >= maxCount) {
          return NaN;
        }
        while (j < maxJ && image.get(j, centerI) && stateCount[4] < maxCount) {
          stateCount[4]++;
          j++;
        }
        if (stateCount[4] >= maxCount) {
          return NaN;
        }
        const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
        if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= originalStateCountTotal) {
          return NaN;
        }
        return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, j) : NaN;
      }
      /**
       * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
       * cross check with a vertical scan, and if successful, will, ah, cross-cross-check
       * with another horizontal scan. This is needed primarily to locate the real horizontal
       * center of the pattern in cases of extreme skew.
       * And then we cross-cross-cross check with another diagonal scan.</p>
       *
       * <p>If that succeeds the finder pattern location is added to a list that tracks
       * the number of times each location has been nearly-matched as a finder pattern.
       * Each additional find is more evidence that the location is in fact a finder
       * pattern center
       *
       * @param stateCount reading state module counts from horizontal scan
       * @param i row where finder pattern may be found
       * @param j end of possible finder pattern in row
       * @param pureBarcode true if in "pure barcode" mode
       * @return true if a finder pattern candidate was found this time
       */
      handlePossibleCenter(stateCount, i2, j, pureBarcode) {
        const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
        let centerJ = FinderPatternFinder.centerFromEnd(stateCount, j);
        let centerI = this.crossCheckVertical(
          i2,
          /*(int) */
          Math.floor(centerJ),
          stateCount[2],
          stateCountTotal
        );
        if (!isNaN(centerI)) {
          centerJ = this.crossCheckHorizontal(
            /*(int) */
            Math.floor(centerJ),
            /*(int) */
            Math.floor(centerI),
            stateCount[2],
            stateCountTotal
          );
          if (!isNaN(centerJ) && (!pureBarcode || this.crossCheckDiagonal(
            /*(int) */
            Math.floor(centerI),
            /*(int) */
            Math.floor(centerJ),
            stateCount[2],
            stateCountTotal
          ))) {
            const estimatedModuleSize = stateCountTotal / 7;
            let found = false;
            const possibleCenters = this.possibleCenters;
            for (let index2 = 0, length = possibleCenters.length; index2 < length; index2++) {
              const center = possibleCenters[index2];
              if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) {
                possibleCenters[index2] = center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                found = true;
                break;
              }
            }
            if (!found) {
              const point = new FinderPattern$1(centerJ, centerI, estimatedModuleSize);
              possibleCenters.push(point);
              if (this.resultPointCallback !== null && this.resultPointCallback !== void 0) {
                this.resultPointCallback.foundPossibleResultPoint(point);
              }
            }
            return true;
          }
        }
        return false;
      }
      /**
       * @return number of rows we could safely skip during scanning, based on the first
       *         two finder patterns that have been located. In some cases their position will
       *         allow us to infer that the third pattern must lie below a certain point farther
       *         down in the image.
       */
      findRowSkip() {
        const max2 = this.possibleCenters.length;
        if (max2 <= 1) {
          return 0;
        }
        let firstConfirmedCenter = null;
        for (const center of this.possibleCenters) {
          if (center.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
            if (firstConfirmedCenter == null) {
              firstConfirmedCenter = center;
            } else {
              this.hasSkipped = true;
              return (
                /*(int) */
                Math.floor((Math.abs(firstConfirmedCenter.getX() - center.getX()) - Math.abs(firstConfirmedCenter.getY() - center.getY())) / 2)
              );
            }
          }
        }
        return 0;
      }
      /**
       * @return true iff we have found at least 3 finder patterns that have been detected
       *         at least {@link #CENTER_QUORUM} times each, and, the estimated module size of the
       *         candidates is "pretty similar"
       */
      haveMultiplyConfirmedCenters() {
        let confirmedCount = 0;
        let totalModuleSize = 0;
        const max2 = this.possibleCenters.length;
        for (const pattern of this.possibleCenters) {
          if (pattern.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
            confirmedCount++;
            totalModuleSize += pattern.getEstimatedModuleSize();
          }
        }
        if (confirmedCount < 3) {
          return false;
        }
        const average = totalModuleSize / max2;
        let totalDeviation = 0;
        for (const pattern of this.possibleCenters) {
          totalDeviation += Math.abs(pattern.getEstimatedModuleSize() - average);
        }
        return totalDeviation <= 0.05 * totalModuleSize;
      }
      /**
       * @return the 3 best {@link FinderPattern}s from our list of candidates. The "best" are
       *         those that have been detected at least {@link #CENTER_QUORUM} times, and whose module
       *         size differs from the average among those patterns the least
       * @throws NotFoundException if 3 such finder patterns do not exist
       */
      selectBestPatterns() {
        const startSize = this.possibleCenters.length;
        if (startSize < 3) {
          throw new NotFoundException();
        }
        const possibleCenters = this.possibleCenters;
        let average;
        if (startSize > 3) {
          let totalModuleSize = 0;
          let square = 0;
          for (const center of this.possibleCenters) {
            const size = center.getEstimatedModuleSize();
            totalModuleSize += size;
            square += size * size;
          }
          average = totalModuleSize / startSize;
          let stdDev = Math.sqrt(square / startSize - average * average);
          possibleCenters.sort(
            /**
             * <p>Orders by furthest from average</p>
             */
            // FurthestFromAverageComparator implements Comparator<FinderPattern>
            (center1, center2) => {
              const dA = Math.abs(center2.getEstimatedModuleSize() - average);
              const dB = Math.abs(center1.getEstimatedModuleSize() - average);
              return dA < dB ? -1 : dA > dB ? 1 : 0;
            }
          );
          const limit = Math.max(0.2 * average, stdDev);
          for (let i2 = 0; i2 < possibleCenters.length && possibleCenters.length > 3; i2++) {
            const pattern = possibleCenters[i2];
            if (Math.abs(pattern.getEstimatedModuleSize() - average) > limit) {
              possibleCenters.splice(i2, 1);
              i2--;
            }
          }
        }
        if (possibleCenters.length > 3) {
          let totalModuleSize = 0;
          for (const possibleCenter of possibleCenters) {
            totalModuleSize += possibleCenter.getEstimatedModuleSize();
          }
          average = totalModuleSize / possibleCenters.length;
          possibleCenters.sort(
            /**
             * <p>Orders by {@link FinderPattern#getCount()}, descending.</p>
             */
            // CenterComparator implements Comparator<FinderPattern>
            (center1, center2) => {
              if (center2.getCount() === center1.getCount()) {
                const dA = Math.abs(center2.getEstimatedModuleSize() - average);
                const dB = Math.abs(center1.getEstimatedModuleSize() - average);
                return dA < dB ? 1 : dA > dB ? -1 : 0;
              } else {
                return center2.getCount() - center1.getCount();
              }
            }
          );
          possibleCenters.splice(3);
        }
        return [
          possibleCenters[0],
          possibleCenters[1],
          possibleCenters[2]
        ];
      }
    }
    FinderPatternFinder.CENTER_QUORUM = 2;
    FinderPatternFinder.MIN_SKIP = 3;
    FinderPatternFinder.MAX_MODULES = 57;
    class Detector$2 {
      constructor(image) {
        this.image = image;
      }
      getImage() {
        return this.image;
      }
      getResultPointCallback() {
        return this.resultPointCallback;
      }
      /**
       * <p>Detects a QR Code in an image.</p>
       *
       * @return {@link DetectorResult} encapsulating results of detecting a QR Code
       * @throws NotFoundException if QR Code cannot be found
       * @throws FormatException if a QR Code cannot be decoded
       */
      // public detect(): DetectorResult /*throws NotFoundException, FormatException*/ {
      //   return detect(null)
      // }
      /**
       * <p>Detects a QR Code in an image.</p>
       *
       * @param hints optional hints to detector
       * @return {@link DetectorResult} encapsulating results of detecting a QR Code
       * @throws NotFoundException if QR Code cannot be found
       * @throws FormatException if a QR Code cannot be decoded
       */
      detect(hints) {
        this.resultPointCallback = hints === null || hints === void 0 ? null : (
          /*(ResultPointCallback) */
          hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK)
        );
        const finder = new FinderPatternFinder(this.image, this.resultPointCallback);
        const info = finder.find(hints);
        return this.processFinderPatternInfo(info);
      }
      processFinderPatternInfo(info) {
        const topLeft = info.getTopLeft();
        const topRight = info.getTopRight();
        const bottomLeft = info.getBottomLeft();
        const moduleSize = this.calculateModuleSize(topLeft, topRight, bottomLeft);
        if (moduleSize < 1) {
          throw new NotFoundException("No pattern found in proccess finder.");
        }
        const dimension = Detector$2.computeDimension(topLeft, topRight, bottomLeft, moduleSize);
        const provisionalVersion = Version$1.getProvisionalVersionForDimension(dimension);
        const modulesBetweenFPCenters = provisionalVersion.getDimensionForVersion() - 7;
        let alignmentPattern = null;
        if (provisionalVersion.getAlignmentPatternCenters().length > 0) {
          const bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
          const bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
          const correctionToTopLeft = 1 - 3 / modulesBetweenFPCenters;
          const estAlignmentX = (
            /*(int) */
            Math.floor(topLeft.getX() + correctionToTopLeft * (bottomRightX - topLeft.getX()))
          );
          const estAlignmentY = (
            /*(int) */
            Math.floor(topLeft.getY() + correctionToTopLeft * (bottomRightY - topLeft.getY()))
          );
          for (let i2 = 4; i2 <= 16; i2 <<= 1) {
            try {
              alignmentPattern = this.findAlignmentInRegion(moduleSize, estAlignmentX, estAlignmentY, i2);
              break;
            } catch (re) {
              if (!(re instanceof NotFoundException)) {
                throw re;
              }
            }
          }
        }
        const transform = Detector$2.createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension);
        const bits = Detector$2.sampleGrid(this.image, transform, dimension);
        let points;
        if (alignmentPattern === null) {
          points = [bottomLeft, topLeft, topRight];
        } else {
          points = [bottomLeft, topLeft, topRight, alignmentPattern];
        }
        return new DetectorResult(bits, points);
      }
      static createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension) {
        const dimMinusThree = dimension - 3.5;
        let bottomRightX;
        let bottomRightY;
        let sourceBottomRightX;
        let sourceBottomRightY;
        if (alignmentPattern !== null) {
          bottomRightX = alignmentPattern.getX();
          bottomRightY = alignmentPattern.getY();
          sourceBottomRightX = dimMinusThree - 3;
          sourceBottomRightY = sourceBottomRightX;
        } else {
          bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
          bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
          sourceBottomRightX = dimMinusThree;
          sourceBottomRightY = dimMinusThree;
        }
        return PerspectiveTransform.quadrilateralToQuadrilateral(3.5, 3.5, dimMinusThree, 3.5, sourceBottomRightX, sourceBottomRightY, 3.5, dimMinusThree, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRightX, bottomRightY, bottomLeft.getX(), bottomLeft.getY());
      }
      static sampleGrid(image, transform, dimension) {
        const sampler = GridSamplerInstance.getInstance();
        return sampler.sampleGridWithTransform(image, dimension, dimension, transform);
      }
      /**
       * <p>Computes the dimension (number of modules on a size) of the QR Code based on the position
       * of the finder patterns and estimated module size.</p>
       */
      static computeDimension(topLeft, topRight, bottomLeft, moduleSize) {
        const tltrCentersDimension = MathUtils2.round(ResultPoint.distance(topLeft, topRight) / moduleSize);
        const tlblCentersDimension = MathUtils2.round(ResultPoint.distance(topLeft, bottomLeft) / moduleSize);
        let dimension = Math.floor((tltrCentersDimension + tlblCentersDimension) / 2) + 7;
        switch (dimension & 3) {
          case 0:
            dimension++;
            break;
          case 2:
            dimension--;
            break;
          case 3:
            throw new NotFoundException("Dimensions could be not found.");
        }
        return dimension;
      }
      /**
       * <p>Computes an average estimated module size based on estimated derived from the positions
       * of the three finder patterns.</p>
       *
       * @param topLeft detected top-left finder pattern center
       * @param topRight detected top-right finder pattern center
       * @param bottomLeft detected bottom-left finder pattern center
       * @return estimated module size
       */
      calculateModuleSize(topLeft, topRight, bottomLeft) {
        return (this.calculateModuleSizeOneWay(topLeft, topRight) + this.calculateModuleSizeOneWay(topLeft, bottomLeft)) / 2;
      }
      /**
       * <p>Estimates module size based on two finder patterns -- it uses
       * {@link #sizeOfBlackWhiteBlackRunBothWays(int, int, int, int)} to figure the
       * width of each, measuring along the axis between their centers.</p>
       */
      calculateModuleSizeOneWay(pattern, otherPattern) {
        const moduleSizeEst1 = this.sizeOfBlackWhiteBlackRunBothWays(
          /*(int) */
          Math.floor(pattern.getX()),
          /*(int) */
          Math.floor(pattern.getY()),
          /*(int) */
          Math.floor(otherPattern.getX()),
          /*(int) */
          Math.floor(otherPattern.getY())
        );
        const moduleSizeEst2 = this.sizeOfBlackWhiteBlackRunBothWays(
          /*(int) */
          Math.floor(otherPattern.getX()),
          /*(int) */
          Math.floor(otherPattern.getY()),
          /*(int) */
          Math.floor(pattern.getX()),
          /*(int) */
          Math.floor(pattern.getY())
        );
        if (isNaN(moduleSizeEst1)) {
          return moduleSizeEst2 / 7;
        }
        if (isNaN(moduleSizeEst2)) {
          return moduleSizeEst1 / 7;
        }
        return (moduleSizeEst1 + moduleSizeEst2) / 14;
      }
      /**
       * See {@link #sizeOfBlackWhiteBlackRun(int, int, int, int)}; computes the total width of
       * a finder pattern by looking for a black-white-black run from the center in the direction
       * of another point (another finder pattern center), and in the opposite direction too.
       */
      sizeOfBlackWhiteBlackRunBothWays(fromX, fromY, toX, toY) {
        let result2 = this.sizeOfBlackWhiteBlackRun(fromX, fromY, toX, toY);
        let scale = 1;
        let otherToX = fromX - (toX - fromX);
        if (otherToX < 0) {
          scale = fromX / /*(float) */
          (fromX - otherToX);
          otherToX = 0;
        } else if (otherToX >= this.image.getWidth()) {
          scale = (this.image.getWidth() - 1 - fromX) / /*(float) */
          (otherToX - fromX);
          otherToX = this.image.getWidth() - 1;
        }
        let otherToY = (
          /*(int) */
          Math.floor(fromY - (toY - fromY) * scale)
        );
        scale = 1;
        if (otherToY < 0) {
          scale = fromY / /*(float) */
          (fromY - otherToY);
          otherToY = 0;
        } else if (otherToY >= this.image.getHeight()) {
          scale = (this.image.getHeight() - 1 - fromY) / /*(float) */
          (otherToY - fromY);
          otherToY = this.image.getHeight() - 1;
        }
        otherToX = /*(int) */
        Math.floor(fromX + (otherToX - fromX) * scale);
        result2 += this.sizeOfBlackWhiteBlackRun(fromX, fromY, otherToX, otherToY);
        return result2 - 1;
      }
      /**
       * <p>This method traces a line from a point in the image, in the direction towards another point.
       * It begins in a black region, and keeps going until it finds white, then black, then white again.
       * It reports the distance from the start to this point.</p>
       *
       * <p>This is used when figuring out how wide a finder pattern is, when the finder pattern
       * may be skewed or rotated.</p>
       */
      sizeOfBlackWhiteBlackRun(fromX, fromY, toX, toY) {
        const steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
        if (steep) {
          let temp = fromX;
          fromX = fromY;
          fromY = temp;
          temp = toX;
          toX = toY;
          toY = temp;
        }
        const dx = Math.abs(toX - fromX);
        const dy = Math.abs(toY - fromY);
        let error2 = -dx / 2;
        const xstep = fromX < toX ? 1 : -1;
        const ystep = fromY < toY ? 1 : -1;
        let state = 0;
        const xLimit = toX + xstep;
        for (let x2 = fromX, y = fromY; x2 !== xLimit; x2 += xstep) {
          const realX = steep ? y : x2;
          const realY = steep ? x2 : y;
          if (state === 1 === this.image.get(realX, realY)) {
            if (state === 2) {
              return MathUtils2.distance(x2, y, fromX, fromY);
            }
            state++;
          }
          error2 += dy;
          if (error2 > 0) {
            if (y === toY) {
              break;
            }
            y += ystep;
            error2 -= dx;
          }
        }
        if (state === 2) {
          return MathUtils2.distance(toX + xstep, toY, fromX, fromY);
        }
        return NaN;
      }
      /**
       * <p>Attempts to locate an alignment pattern in a limited region of the image, which is
       * guessed to contain it. This method uses {@link AlignmentPattern}.</p>
       *
       * @param overallEstModuleSize estimated module size so far
       * @param estAlignmentX x coordinate of center of area probably containing alignment pattern
       * @param estAlignmentY y coordinate of above
       * @param allowanceFactor number of pixels in all directions to search from the center
       * @return {@link AlignmentPattern} if found, or null otherwise
       * @throws NotFoundException if an unexpected error occurs during detection
       */
      findAlignmentInRegion(overallEstModuleSize, estAlignmentX, estAlignmentY, allowanceFactor) {
        const allowance = (
          /*(int) */
          Math.floor(allowanceFactor * overallEstModuleSize)
        );
        const alignmentAreaLeftX = Math.max(0, estAlignmentX - allowance);
        const alignmentAreaRightX = Math.min(this.image.getWidth() - 1, estAlignmentX + allowance);
        if (alignmentAreaRightX - alignmentAreaLeftX < overallEstModuleSize * 3) {
          throw new NotFoundException("Alignment top exceeds estimated module size.");
        }
        const alignmentAreaTopY = Math.max(0, estAlignmentY - allowance);
        const alignmentAreaBottomY = Math.min(this.image.getHeight() - 1, estAlignmentY + allowance);
        if (alignmentAreaBottomY - alignmentAreaTopY < overallEstModuleSize * 3) {
          throw new NotFoundException("Alignment bottom exceeds estimated module size.");
        }
        const alignmentFinder = new AlignmentPatternFinder(this.image, alignmentAreaLeftX, alignmentAreaTopY, alignmentAreaRightX - alignmentAreaLeftX, alignmentAreaBottomY - alignmentAreaTopY, overallEstModuleSize, this.resultPointCallback);
        return alignmentFinder.find();
      }
    }
    class QRCodeReader {
      constructor() {
        this.decoder = new Decoder$2();
      }
      getDecoder() {
        return this.decoder;
      }
      /**
       * Locates and decodes a QR code in an image.
       *
       * @return a representing: string the content encoded by the QR code
       * @throws NotFoundException if a QR code cannot be found
       * @throws FormatException if a QR code cannot be decoded
       * @throws ChecksumException if error correction fails
       */
      /*@Override*/
      // public decode(image: BinaryBitmap): Result /*throws NotFoundException, ChecksumException, FormatException */ {
      //   return this.decode(image, null)
      // }
      /*@Override*/
      decode(image, hints) {
        let decoderResult;
        let points;
        if (hints !== void 0 && hints !== null && void 0 !== hints.get(DecodeHintType$1.PURE_BARCODE)) {
          const bits = QRCodeReader.extractPureBits(image.getBlackMatrix());
          decoderResult = this.decoder.decodeBitMatrix(bits, hints);
          points = QRCodeReader.NO_POINTS;
        } else {
          const detectorResult = new Detector$2(image.getBlackMatrix()).detect(hints);
          decoderResult = this.decoder.decodeBitMatrix(detectorResult.getBits(), hints);
          points = detectorResult.getPoints();
        }
        if (decoderResult.getOther() instanceof QRCodeDecoderMetaData) {
          decoderResult.getOther().applyMirroredCorrection(points);
        }
        const result2 = new Result3(decoderResult.getText(), decoderResult.getRawBytes(), void 0, points, BarcodeFormat$1.QR_CODE, void 0);
        const byteSegments = decoderResult.getByteSegments();
        if (byteSegments !== null) {
          result2.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
        }
        const ecLevel = decoderResult.getECLevel();
        if (ecLevel !== null) {
          result2.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
        }
        if (decoderResult.hasStructuredAppend()) {
          result2.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_SEQUENCE, decoderResult.getStructuredAppendSequenceNumber());
          result2.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_PARITY, decoderResult.getStructuredAppendParity());
        }
        return result2;
      }
      /*@Override*/
      reset() {
      }
      /**
       * This method detects a code in a "pure" image -- that is, pure monochrome image
       * which contains only an unrotated, unskewed, image of a code, with some white border
       * around it. This is a specialized method that works exceptionally fast in this special
       * case.
       *
       * @see com.google.zxing.datamatrix.DataMatrixReader#extractPureBits(BitMatrix)
       */
      static extractPureBits(image) {
        const leftTopBlack = image.getTopLeftOnBit();
        const rightBottomBlack = image.getBottomRightOnBit();
        if (leftTopBlack === null || rightBottomBlack === null) {
          throw new NotFoundException();
        }
        const moduleSize = this.moduleSize(leftTopBlack, image);
        let top = leftTopBlack[1];
        let bottom = rightBottomBlack[1];
        let left = leftTopBlack[0];
        let right = rightBottomBlack[0];
        if (left >= right || top >= bottom) {
          throw new NotFoundException();
        }
        if (bottom - top !== right - left) {
          right = left + (bottom - top);
          if (right >= image.getWidth()) {
            throw new NotFoundException();
          }
        }
        const matrixWidth = Math.round((right - left + 1) / moduleSize);
        const matrixHeight = Math.round((bottom - top + 1) / moduleSize);
        if (matrixWidth <= 0 || matrixHeight <= 0) {
          throw new NotFoundException();
        }
        if (matrixHeight !== matrixWidth) {
          throw new NotFoundException();
        }
        const nudge = (
          /*(int) */
          Math.floor(moduleSize / 2)
        );
        top += nudge;
        left += nudge;
        const nudgedTooFarRight = left + /*(int) */
        Math.floor((matrixWidth - 1) * moduleSize) - right;
        if (nudgedTooFarRight > 0) {
          if (nudgedTooFarRight > nudge) {
            throw new NotFoundException();
          }
          left -= nudgedTooFarRight;
        }
        const nudgedTooFarDown = top + /*(int) */
        Math.floor((matrixHeight - 1) * moduleSize) - bottom;
        if (nudgedTooFarDown > 0) {
          if (nudgedTooFarDown > nudge) {
            throw new NotFoundException();
          }
          top -= nudgedTooFarDown;
        }
        const bits = new BitMatrix(matrixWidth, matrixHeight);
        for (let y = 0; y < matrixHeight; y++) {
          const iOffset = top + /*(int) */
          Math.floor(y * moduleSize);
          for (let x2 = 0; x2 < matrixWidth; x2++) {
            if (image.get(left + /*(int) */
            Math.floor(x2 * moduleSize), iOffset)) {
              bits.set(x2, y);
            }
          }
        }
        return bits;
      }
      static moduleSize(leftTopBlack, image) {
        const height = image.getHeight();
        const width = image.getWidth();
        let x2 = leftTopBlack[0];
        let y = leftTopBlack[1];
        let inBlack = true;
        let transitions = 0;
        while (x2 < width && y < height) {
          if (inBlack !== image.get(x2, y)) {
            if (++transitions === 5) {
              break;
            }
            inBlack = !inBlack;
          }
          x2++;
          y++;
        }
        if (x2 === width || y === height) {
          throw new NotFoundException();
        }
        return (x2 - leftTopBlack[0]) / 7;
      }
    }
    QRCodeReader.NO_POINTS = new Array();
    class PDF417Common {
      PDF417Common() {
      }
      /**
       * @param moduleBitCount values to sum
       * @return sum of values
       * @deprecated call {@link MathUtils#sum(int[])}
       */
      // @Deprecated
      static getBitCountSum(moduleBitCount) {
        return MathUtils2.sum(moduleBitCount);
      }
      static toIntArray(list2) {
        if (list2 == null || !list2.length) {
          return PDF417Common.EMPTY_INT_ARRAY;
        }
        const result2 = new Int32Array(list2.length);
        let i2 = 0;
        for (const integer of list2) {
          result2[i2++] = integer;
        }
        return result2;
      }
      /**
       * @param symbol encoded symbol to translate to a codeword
       * @return the codeword corresponding to the symbol.
       */
      static getCodeword(symbol) {
        const i2 = Arrays.binarySearch(PDF417Common.SYMBOL_TABLE, symbol & 262143);
        if (i2 < 0) {
          return -1;
        }
        return (PDF417Common.CODEWORD_TABLE[i2] - 1) % PDF417Common.NUMBER_OF_CODEWORDS;
      }
    }
    PDF417Common.NUMBER_OF_CODEWORDS = 929;
    PDF417Common.MAX_CODEWORDS_IN_BARCODE = PDF417Common.NUMBER_OF_CODEWORDS - 1;
    PDF417Common.MIN_ROWS_IN_BARCODE = 3;
    PDF417Common.MAX_ROWS_IN_BARCODE = 90;
    PDF417Common.MODULES_IN_CODEWORD = 17;
    PDF417Common.MODULES_IN_STOP_PATTERN = 18;
    PDF417Common.BARS_IN_MODULE = 8;
    PDF417Common.EMPTY_INT_ARRAY = new Int32Array([]);
    PDF417Common.SYMBOL_TABLE = Int32Array.from([
      66142,
      66170,
      66206,
      66236,
      66290,
      66292,
      66350,
      66382,
      66396,
      66454,
      66470,
      66476,
      66594,
      66600,
      66614,
      66626,
      66628,
      66632,
      66640,
      66654,
      66662,
      66668,
      66682,
      66690,
      66718,
      66720,
      66748,
      66758,
      66776,
      66798,
      66802,
      66804,
      66820,
      66824,
      66832,
      66846,
      66848,
      66876,
      66880,
      66936,
      66950,
      66956,
      66968,
      66992,
      67006,
      67022,
      67036,
      67042,
      67044,
      67048,
      67062,
      67118,
      67150,
      67164,
      67214,
      67228,
      67256,
      67294,
      67322,
      67350,
      67366,
      67372,
      67398,
      67404,
      67416,
      67438,
      67474,
      67476,
      67490,
      67492,
      67496,
      67510,
      67618,
      67624,
      67650,
      67656,
      67664,
      67678,
      67686,
      67692,
      67706,
      67714,
      67716,
      67728,
      67742,
      67744,
      67772,
      67782,
      67788,
      67800,
      67822,
      67826,
      67828,
      67842,
      67848,
      67870,
      67872,
      67900,
      67904,
      67960,
      67974,
      67992,
      68016,
      68030,
      68046,
      68060,
      68066,
      68068,
      68072,
      68086,
      68104,
      68112,
      68126,
      68128,
      68156,
      68160,
      68216,
      68336,
      68358,
      68364,
      68376,
      68400,
      68414,
      68448,
      68476,
      68494,
      68508,
      68536,
      68546,
      68548,
      68552,
      68560,
      68574,
      68582,
      68588,
      68654,
      68686,
      68700,
      68706,
      68708,
      68712,
      68726,
      68750,
      68764,
      68792,
      68802,
      68804,
      68808,
      68816,
      68830,
      68838,
      68844,
      68858,
      68878,
      68892,
      68920,
      68976,
      68990,
      68994,
      68996,
      69e3,
      69008,
      69022,
      69024,
      69052,
      69062,
      69068,
      69080,
      69102,
      69106,
      69108,
      69142,
      69158,
      69164,
      69190,
      69208,
      69230,
      69254,
      69260,
      69272,
      69296,
      69310,
      69326,
      69340,
      69386,
      69394,
      69396,
      69410,
      69416,
      69430,
      69442,
      69444,
      69448,
      69456,
      69470,
      69478,
      69484,
      69554,
      69556,
      69666,
      69672,
      69698,
      69704,
      69712,
      69726,
      69754,
      69762,
      69764,
      69776,
      69790,
      69792,
      69820,
      69830,
      69836,
      69848,
      69870,
      69874,
      69876,
      69890,
      69918,
      69920,
      69948,
      69952,
      70008,
      70022,
      70040,
      70064,
      70078,
      70094,
      70108,
      70114,
      70116,
      70120,
      70134,
      70152,
      70174,
      70176,
      70264,
      70384,
      70412,
      70448,
      70462,
      70496,
      70524,
      70542,
      70556,
      70584,
      70594,
      70600,
      70608,
      70622,
      70630,
      70636,
      70664,
      70672,
      70686,
      70688,
      70716,
      70720,
      70776,
      70896,
      71136,
      71180,
      71192,
      71216,
      71230,
      71264,
      71292,
      71360,
      71416,
      71452,
      71480,
      71536,
      71550,
      71554,
      71556,
      71560,
      71568,
      71582,
      71584,
      71612,
      71622,
      71628,
      71640,
      71662,
      71726,
      71732,
      71758,
      71772,
      71778,
      71780,
      71784,
      71798,
      71822,
      71836,
      71864,
      71874,
      71880,
      71888,
      71902,
      71910,
      71916,
      71930,
      71950,
      71964,
      71992,
      72048,
      72062,
      72066,
      72068,
      72080,
      72094,
      72096,
      72124,
      72134,
      72140,
      72152,
      72174,
      72178,
      72180,
      72206,
      72220,
      72248,
      72304,
      72318,
      72416,
      72444,
      72456,
      72464,
      72478,
      72480,
      72508,
      72512,
      72568,
      72588,
      72600,
      72624,
      72638,
      72654,
      72668,
      72674,
      72676,
      72680,
      72694,
      72726,
      72742,
      72748,
      72774,
      72780,
      72792,
      72814,
      72838,
      72856,
      72880,
      72894,
      72910,
      72924,
      72930,
      72932,
      72936,
      72950,
      72966,
      72972,
      72984,
      73008,
      73022,
      73056,
      73084,
      73102,
      73116,
      73144,
      73156,
      73160,
      73168,
      73182,
      73190,
      73196,
      73210,
      73226,
      73234,
      73236,
      73250,
      73252,
      73256,
      73270,
      73282,
      73284,
      73296,
      73310,
      73318,
      73324,
      73346,
      73348,
      73352,
      73360,
      73374,
      73376,
      73404,
      73414,
      73420,
      73432,
      73454,
      73498,
      73518,
      73522,
      73524,
      73550,
      73564,
      73570,
      73572,
      73576,
      73590,
      73800,
      73822,
      73858,
      73860,
      73872,
      73886,
      73888,
      73916,
      73944,
      73970,
      73972,
      73992,
      74014,
      74016,
      74044,
      74048,
      74104,
      74118,
      74136,
      74160,
      74174,
      74210,
      74212,
      74216,
      74230,
      74244,
      74256,
      74270,
      74272,
      74360,
      74480,
      74502,
      74508,
      74544,
      74558,
      74592,
      74620,
      74638,
      74652,
      74680,
      74690,
      74696,
      74704,
      74726,
      74732,
      74782,
      74784,
      74812,
      74992,
      75232,
      75288,
      75326,
      75360,
      75388,
      75456,
      75512,
      75576,
      75632,
      75646,
      75650,
      75652,
      75664,
      75678,
      75680,
      75708,
      75718,
      75724,
      75736,
      75758,
      75808,
      75836,
      75840,
      75896,
      76016,
      76256,
      76736,
      76824,
      76848,
      76862,
      76896,
      76924,
      76992,
      77048,
      77296,
      77340,
      77368,
      77424,
      77438,
      77536,
      77564,
      77572,
      77576,
      77584,
      77600,
      77628,
      77632,
      77688,
      77702,
      77708,
      77720,
      77744,
      77758,
      77774,
      77788,
      77870,
      77902,
      77916,
      77922,
      77928,
      77966,
      77980,
      78008,
      78018,
      78024,
      78032,
      78046,
      78060,
      78074,
      78094,
      78136,
      78192,
      78206,
      78210,
      78212,
      78224,
      78238,
      78240,
      78268,
      78278,
      78284,
      78296,
      78322,
      78324,
      78350,
      78364,
      78448,
      78462,
      78560,
      78588,
      78600,
      78622,
      78624,
      78652,
      78656,
      78712,
      78726,
      78744,
      78768,
      78782,
      78798,
      78812,
      78818,
      78820,
      78824,
      78838,
      78862,
      78876,
      78904,
      78960,
      78974,
      79072,
      79100,
      79296,
      79352,
      79368,
      79376,
      79390,
      79392,
      79420,
      79424,
      79480,
      79600,
      79628,
      79640,
      79664,
      79678,
      79712,
      79740,
      79772,
      79800,
      79810,
      79812,
      79816,
      79824,
      79838,
      79846,
      79852,
      79894,
      79910,
      79916,
      79942,
      79948,
      79960,
      79982,
      79988,
      80006,
      80024,
      80048,
      80062,
      80078,
      80092,
      80098,
      80100,
      80104,
      80134,
      80140,
      80176,
      80190,
      80224,
      80252,
      80270,
      80284,
      80312,
      80328,
      80336,
      80350,
      80358,
      80364,
      80378,
      80390,
      80396,
      80408,
      80432,
      80446,
      80480,
      80508,
      80576,
      80632,
      80654,
      80668,
      80696,
      80752,
      80766,
      80776,
      80784,
      80798,
      80800,
      80828,
      80844,
      80856,
      80878,
      80882,
      80884,
      80914,
      80916,
      80930,
      80932,
      80936,
      80950,
      80962,
      80968,
      80976,
      80990,
      80998,
      81004,
      81026,
      81028,
      81040,
      81054,
      81056,
      81084,
      81094,
      81100,
      81112,
      81134,
      81154,
      81156,
      81160,
      81168,
      81182,
      81184,
      81212,
      81216,
      81272,
      81286,
      81292,
      81304,
      81328,
      81342,
      81358,
      81372,
      81380,
      81384,
      81398,
      81434,
      81454,
      81458,
      81460,
      81486,
      81500,
      81506,
      81508,
      81512,
      81526,
      81550,
      81564,
      81592,
      81602,
      81604,
      81608,
      81616,
      81630,
      81638,
      81644,
      81702,
      81708,
      81722,
      81734,
      81740,
      81752,
      81774,
      81778,
      81780,
      82050,
      82078,
      82080,
      82108,
      82180,
      82184,
      82192,
      82206,
      82208,
      82236,
      82240,
      82296,
      82316,
      82328,
      82352,
      82366,
      82402,
      82404,
      82408,
      82440,
      82448,
      82462,
      82464,
      82492,
      82496,
      82552,
      82672,
      82694,
      82700,
      82712,
      82736,
      82750,
      82784,
      82812,
      82830,
      82882,
      82884,
      82888,
      82896,
      82918,
      82924,
      82952,
      82960,
      82974,
      82976,
      83004,
      83008,
      83064,
      83184,
      83424,
      83468,
      83480,
      83504,
      83518,
      83552,
      83580,
      83648,
      83704,
      83740,
      83768,
      83824,
      83838,
      83842,
      83844,
      83848,
      83856,
      83872,
      83900,
      83910,
      83916,
      83928,
      83950,
      83984,
      84e3,
      84028,
      84032,
      84088,
      84208,
      84448,
      84928,
      85040,
      85054,
      85088,
      85116,
      85184,
      85240,
      85488,
      85560,
      85616,
      85630,
      85728,
      85756,
      85764,
      85768,
      85776,
      85790,
      85792,
      85820,
      85824,
      85880,
      85894,
      85900,
      85912,
      85936,
      85966,
      85980,
      86048,
      86080,
      86136,
      86256,
      86496,
      86976,
      88160,
      88188,
      88256,
      88312,
      88560,
      89056,
      89200,
      89214,
      89312,
      89340,
      89536,
      89592,
      89608,
      89616,
      89632,
      89664,
      89720,
      89840,
      89868,
      89880,
      89904,
      89952,
      89980,
      89998,
      90012,
      90040,
      90190,
      90204,
      90254,
      90268,
      90296,
      90306,
      90308,
      90312,
      90334,
      90382,
      90396,
      90424,
      90480,
      90494,
      90500,
      90504,
      90512,
      90526,
      90528,
      90556,
      90566,
      90572,
      90584,
      90610,
      90612,
      90638,
      90652,
      90680,
      90736,
      90750,
      90848,
      90876,
      90884,
      90888,
      90896,
      90910,
      90912,
      90940,
      90944,
      91e3,
      91014,
      91020,
      91032,
      91056,
      91070,
      91086,
      91100,
      91106,
      91108,
      91112,
      91126,
      91150,
      91164,
      91192,
      91248,
      91262,
      91360,
      91388,
      91584,
      91640,
      91664,
      91678,
      91680,
      91708,
      91712,
      91768,
      91888,
      91928,
      91952,
      91966,
      92e3,
      92028,
      92046,
      92060,
      92088,
      92098,
      92100,
      92104,
      92112,
      92126,
      92134,
      92140,
      92188,
      92216,
      92272,
      92384,
      92412,
      92608,
      92664,
      93168,
      93200,
      93214,
      93216,
      93244,
      93248,
      93304,
      93424,
      93664,
      93720,
      93744,
      93758,
      93792,
      93820,
      93888,
      93944,
      93980,
      94008,
      94064,
      94078,
      94084,
      94088,
      94096,
      94110,
      94112,
      94140,
      94150,
      94156,
      94168,
      94246,
      94252,
      94278,
      94284,
      94296,
      94318,
      94342,
      94348,
      94360,
      94384,
      94398,
      94414,
      94428,
      94440,
      94470,
      94476,
      94488,
      94512,
      94526,
      94560,
      94588,
      94606,
      94620,
      94648,
      94658,
      94660,
      94664,
      94672,
      94686,
      94694,
      94700,
      94714,
      94726,
      94732,
      94744,
      94768,
      94782,
      94816,
      94844,
      94912,
      94968,
      94990,
      95004,
      95032,
      95088,
      95102,
      95112,
      95120,
      95134,
      95136,
      95164,
      95180,
      95192,
      95214,
      95218,
      95220,
      95244,
      95256,
      95280,
      95294,
      95328,
      95356,
      95424,
      95480,
      95728,
      95758,
      95772,
      95800,
      95856,
      95870,
      95968,
      95996,
      96008,
      96016,
      96030,
      96032,
      96060,
      96064,
      96120,
      96152,
      96176,
      96190,
      96220,
      96226,
      96228,
      96232,
      96290,
      96292,
      96296,
      96310,
      96322,
      96324,
      96328,
      96336,
      96350,
      96358,
      96364,
      96386,
      96388,
      96392,
      96400,
      96414,
      96416,
      96444,
      96454,
      96460,
      96472,
      96494,
      96498,
      96500,
      96514,
      96516,
      96520,
      96528,
      96542,
      96544,
      96572,
      96576,
      96632,
      96646,
      96652,
      96664,
      96688,
      96702,
      96718,
      96732,
      96738,
      96740,
      96744,
      96758,
      96772,
      96776,
      96784,
      96798,
      96800,
      96828,
      96832,
      96888,
      97008,
      97030,
      97036,
      97048,
      97072,
      97086,
      97120,
      97148,
      97166,
      97180,
      97208,
      97220,
      97224,
      97232,
      97246,
      97254,
      97260,
      97326,
      97330,
      97332,
      97358,
      97372,
      97378,
      97380,
      97384,
      97398,
      97422,
      97436,
      97464,
      97474,
      97476,
      97480,
      97488,
      97502,
      97510,
      97516,
      97550,
      97564,
      97592,
      97648,
      97666,
      97668,
      97672,
      97680,
      97694,
      97696,
      97724,
      97734,
      97740,
      97752,
      97774,
      97830,
      97836,
      97850,
      97862,
      97868,
      97880,
      97902,
      97906,
      97908,
      97926,
      97932,
      97944,
      97968,
      97998,
      98012,
      98018,
      98020,
      98024,
      98038,
      98618,
      98674,
      98676,
      98838,
      98854,
      98874,
      98892,
      98904,
      98926,
      98930,
      98932,
      98968,
      99006,
      99042,
      99044,
      99048,
      99062,
      99166,
      99194,
      99246,
      99286,
      99350,
      99366,
      99372,
      99386,
      99398,
      99416,
      99438,
      99442,
      99444,
      99462,
      99504,
      99518,
      99534,
      99548,
      99554,
      99556,
      99560,
      99574,
      99590,
      99596,
      99608,
      99632,
      99646,
      99680,
      99708,
      99726,
      99740,
      99768,
      99778,
      99780,
      99784,
      99792,
      99806,
      99814,
      99820,
      99834,
      99858,
      99860,
      99874,
      99880,
      99894,
      99906,
      99920,
      99934,
      99962,
      99970,
      99972,
      99976,
      99984,
      99998,
      1e5,
      100028,
      100038,
      100044,
      100056,
      100078,
      100082,
      100084,
      100142,
      100174,
      100188,
      100246,
      100262,
      100268,
      100306,
      100308,
      100390,
      100396,
      100410,
      100422,
      100428,
      100440,
      100462,
      100466,
      100468,
      100486,
      100504,
      100528,
      100542,
      100558,
      100572,
      100578,
      100580,
      100584,
      100598,
      100620,
      100656,
      100670,
      100704,
      100732,
      100750,
      100792,
      100802,
      100808,
      100816,
      100830,
      100838,
      100844,
      100858,
      100888,
      100912,
      100926,
      100960,
      100988,
      101056,
      101112,
      101148,
      101176,
      101232,
      101246,
      101250,
      101252,
      101256,
      101264,
      101278,
      101280,
      101308,
      101318,
      101324,
      101336,
      101358,
      101362,
      101364,
      101410,
      101412,
      101416,
      101430,
      101442,
      101448,
      101456,
      101470,
      101478,
      101498,
      101506,
      101508,
      101520,
      101534,
      101536,
      101564,
      101580,
      101618,
      101620,
      101636,
      101640,
      101648,
      101662,
      101664,
      101692,
      101696,
      101752,
      101766,
      101784,
      101838,
      101858,
      101860,
      101864,
      101934,
      101938,
      101940,
      101966,
      101980,
      101986,
      101988,
      101992,
      102030,
      102044,
      102072,
      102082,
      102084,
      102088,
      102096,
      102138,
      102166,
      102182,
      102188,
      102214,
      102220,
      102232,
      102254,
      102282,
      102290,
      102292,
      102306,
      102308,
      102312,
      102326,
      102444,
      102458,
      102470,
      102476,
      102488,
      102514,
      102516,
      102534,
      102552,
      102576,
      102590,
      102606,
      102620,
      102626,
      102632,
      102646,
      102662,
      102668,
      102704,
      102718,
      102752,
      102780,
      102798,
      102812,
      102840,
      102850,
      102856,
      102864,
      102878,
      102886,
      102892,
      102906,
      102936,
      102974,
      103008,
      103036,
      103104,
      103160,
      103224,
      103280,
      103294,
      103298,
      103300,
      103312,
      103326,
      103328,
      103356,
      103366,
      103372,
      103384,
      103406,
      103410,
      103412,
      103472,
      103486,
      103520,
      103548,
      103616,
      103672,
      103920,
      103992,
      104048,
      104062,
      104160,
      104188,
      104194,
      104196,
      104200,
      104208,
      104224,
      104252,
      104256,
      104312,
      104326,
      104332,
      104344,
      104368,
      104382,
      104398,
      104412,
      104418,
      104420,
      104424,
      104482,
      104484,
      104514,
      104520,
      104528,
      104542,
      104550,
      104570,
      104578,
      104580,
      104592,
      104606,
      104608,
      104636,
      104652,
      104690,
      104692,
      104706,
      104712,
      104734,
      104736,
      104764,
      104768,
      104824,
      104838,
      104856,
      104910,
      104930,
      104932,
      104936,
      104968,
      104976,
      104990,
      104992,
      105020,
      105024,
      105080,
      105200,
      105240,
      105278,
      105312,
      105372,
      105410,
      105412,
      105416,
      105424,
      105446,
      105518,
      105524,
      105550,
      105564,
      105570,
      105572,
      105576,
      105614,
      105628,
      105656,
      105666,
      105672,
      105680,
      105702,
      105722,
      105742,
      105756,
      105784,
      105840,
      105854,
      105858,
      105860,
      105864,
      105872,
      105888,
      105932,
      105970,
      105972,
      106006,
      106022,
      106028,
      106054,
      106060,
      106072,
      106100,
      106118,
      106124,
      106136,
      106160,
      106174,
      106190,
      106210,
      106212,
      106216,
      106250,
      106258,
      106260,
      106274,
      106276,
      106280,
      106306,
      106308,
      106312,
      106320,
      106334,
      106348,
      106394,
      106414,
      106418,
      106420,
      106566,
      106572,
      106610,
      106612,
      106630,
      106636,
      106648,
      106672,
      106686,
      106722,
      106724,
      106728,
      106742,
      106758,
      106764,
      106776,
      106800,
      106814,
      106848,
      106876,
      106894,
      106908,
      106936,
      106946,
      106948,
      106952,
      106960,
      106974,
      106982,
      106988,
      107032,
      107056,
      107070,
      107104,
      107132,
      107200,
      107256,
      107292,
      107320,
      107376,
      107390,
      107394,
      107396,
      107400,
      107408,
      107422,
      107424,
      107452,
      107462,
      107468,
      107480,
      107502,
      107506,
      107508,
      107544,
      107568,
      107582,
      107616,
      107644,
      107712,
      107768,
      108016,
      108060,
      108088,
      108144,
      108158,
      108256,
      108284,
      108290,
      108292,
      108296,
      108304,
      108318,
      108320,
      108348,
      108352,
      108408,
      108422,
      108428,
      108440,
      108464,
      108478,
      108494,
      108508,
      108514,
      108516,
      108520,
      108592,
      108640,
      108668,
      108736,
      108792,
      109040,
      109536,
      109680,
      109694,
      109792,
      109820,
      110016,
      110072,
      110084,
      110088,
      110096,
      110112,
      110140,
      110144,
      110200,
      110320,
      110342,
      110348,
      110360,
      110384,
      110398,
      110432,
      110460,
      110478,
      110492,
      110520,
      110532,
      110536,
      110544,
      110558,
      110658,
      110686,
      110714,
      110722,
      110724,
      110728,
      110736,
      110750,
      110752,
      110780,
      110796,
      110834,
      110836,
      110850,
      110852,
      110856,
      110864,
      110878,
      110880,
      110908,
      110912,
      110968,
      110982,
      111e3,
      111054,
      111074,
      111076,
      111080,
      111108,
      111112,
      111120,
      111134,
      111136,
      111164,
      111168,
      111224,
      111344,
      111372,
      111422,
      111456,
      111516,
      111554,
      111556,
      111560,
      111568,
      111590,
      111632,
      111646,
      111648,
      111676,
      111680,
      111736,
      111856,
      112096,
      112152,
      112224,
      112252,
      112320,
      112440,
      112514,
      112516,
      112520,
      112528,
      112542,
      112544,
      112588,
      112686,
      112718,
      112732,
      112782,
      112796,
      112824,
      112834,
      112836,
      112840,
      112848,
      112870,
      112890,
      112910,
      112924,
      112952,
      113008,
      113022,
      113026,
      113028,
      113032,
      113040,
      113054,
      113056,
      113100,
      113138,
      113140,
      113166,
      113180,
      113208,
      113264,
      113278,
      113376,
      113404,
      113416,
      113424,
      113440,
      113468,
      113472,
      113560,
      113614,
      113634,
      113636,
      113640,
      113686,
      113702,
      113708,
      113734,
      113740,
      113752,
      113778,
      113780,
      113798,
      113804,
      113816,
      113840,
      113854,
      113870,
      113890,
      113892,
      113896,
      113926,
      113932,
      113944,
      113968,
      113982,
      114016,
      114044,
      114076,
      114114,
      114116,
      114120,
      114128,
      114150,
      114170,
      114194,
      114196,
      114210,
      114212,
      114216,
      114242,
      114244,
      114248,
      114256,
      114270,
      114278,
      114306,
      114308,
      114312,
      114320,
      114334,
      114336,
      114364,
      114380,
      114420,
      114458,
      114478,
      114482,
      114484,
      114510,
      114524,
      114530,
      114532,
      114536,
      114842,
      114866,
      114868,
      114970,
      114994,
      114996,
      115042,
      115044,
      115048,
      115062,
      115130,
      115226,
      115250,
      115252,
      115278,
      115292,
      115298,
      115300,
      115304,
      115318,
      115342,
      115394,
      115396,
      115400,
      115408,
      115422,
      115430,
      115436,
      115450,
      115478,
      115494,
      115514,
      115526,
      115532,
      115570,
      115572,
      115738,
      115758,
      115762,
      115764,
      115790,
      115804,
      115810,
      115812,
      115816,
      115830,
      115854,
      115868,
      115896,
      115906,
      115912,
      115920,
      115934,
      115942,
      115948,
      115962,
      115996,
      116024,
      116080,
      116094,
      116098,
      116100,
      116104,
      116112,
      116126,
      116128,
      116156,
      116166,
      116172,
      116184,
      116206,
      116210,
      116212,
      116246,
      116262,
      116268,
      116282,
      116294,
      116300,
      116312,
      116334,
      116338,
      116340,
      116358,
      116364,
      116376,
      116400,
      116414,
      116430,
      116444,
      116450,
      116452,
      116456,
      116498,
      116500,
      116514,
      116520,
      116534,
      116546,
      116548,
      116552,
      116560,
      116574,
      116582,
      116588,
      116602,
      116654,
      116694,
      116714,
      116762,
      116782,
      116786,
      116788,
      116814,
      116828,
      116834,
      116836,
      116840,
      116854,
      116878,
      116892,
      116920,
      116930,
      116936,
      116944,
      116958,
      116966,
      116972,
      116986,
      117006,
      117048,
      117104,
      117118,
      117122,
      117124,
      117136,
      117150,
      117152,
      117180,
      117190,
      117196,
      117208,
      117230,
      117234,
      117236,
      117304,
      117360,
      117374,
      117472,
      117500,
      117506,
      117508,
      117512,
      117520,
      117536,
      117564,
      117568,
      117624,
      117638,
      117644,
      117656,
      117680,
      117694,
      117710,
      117724,
      117730,
      117732,
      117736,
      117750,
      117782,
      117798,
      117804,
      117818,
      117830,
      117848,
      117874,
      117876,
      117894,
      117936,
      117950,
      117966,
      117986,
      117988,
      117992,
      118022,
      118028,
      118040,
      118064,
      118078,
      118112,
      118140,
      118172,
      118210,
      118212,
      118216,
      118224,
      118238,
      118246,
      118266,
      118306,
      118312,
      118338,
      118352,
      118366,
      118374,
      118394,
      118402,
      118404,
      118408,
      118416,
      118430,
      118432,
      118460,
      118476,
      118514,
      118516,
      118574,
      118578,
      118580,
      118606,
      118620,
      118626,
      118628,
      118632,
      118678,
      118694,
      118700,
      118730,
      118738,
      118740,
      118830,
      118834,
      118836,
      118862,
      118876,
      118882,
      118884,
      118888,
      118902,
      118926,
      118940,
      118968,
      118978,
      118980,
      118984,
      118992,
      119006,
      119014,
      119020,
      119034,
      119068,
      119096,
      119152,
      119166,
      119170,
      119172,
      119176,
      119184,
      119198,
      119200,
      119228,
      119238,
      119244,
      119256,
      119278,
      119282,
      119284,
      119324,
      119352,
      119408,
      119422,
      119520,
      119548,
      119554,
      119556,
      119560,
      119568,
      119582,
      119584,
      119612,
      119616,
      119672,
      119686,
      119692,
      119704,
      119728,
      119742,
      119758,
      119772,
      119778,
      119780,
      119784,
      119798,
      119920,
      119934,
      120032,
      120060,
      120256,
      120312,
      120324,
      120328,
      120336,
      120352,
      120384,
      120440,
      120560,
      120582,
      120588,
      120600,
      120624,
      120638,
      120672,
      120700,
      120718,
      120732,
      120760,
      120770,
      120772,
      120776,
      120784,
      120798,
      120806,
      120812,
      120870,
      120876,
      120890,
      120902,
      120908,
      120920,
      120946,
      120948,
      120966,
      120972,
      120984,
      121008,
      121022,
      121038,
      121058,
      121060,
      121064,
      121078,
      121100,
      121112,
      121136,
      121150,
      121184,
      121212,
      121244,
      121282,
      121284,
      121288,
      121296,
      121318,
      121338,
      121356,
      121368,
      121392,
      121406,
      121440,
      121468,
      121536,
      121592,
      121656,
      121730,
      121732,
      121736,
      121744,
      121758,
      121760,
      121804,
      121842,
      121844,
      121890,
      121922,
      121924,
      121928,
      121936,
      121950,
      121958,
      121978,
      121986,
      121988,
      121992,
      122e3,
      122014,
      122016,
      122044,
      122060,
      122098,
      122100,
      122116,
      122120,
      122128,
      122142,
      122144,
      122172,
      122176,
      122232,
      122246,
      122264,
      122318,
      122338,
      122340,
      122344,
      122414,
      122418,
      122420,
      122446,
      122460,
      122466,
      122468,
      122472,
      122510,
      122524,
      122552,
      122562,
      122564,
      122568,
      122576,
      122598,
      122618,
      122646,
      122662,
      122668,
      122694,
      122700,
      122712,
      122738,
      122740,
      122762,
      122770,
      122772,
      122786,
      122788,
      122792,
      123018,
      123026,
      123028,
      123042,
      123044,
      123048,
      123062,
      123098,
      123146,
      123154,
      123156,
      123170,
      123172,
      123176,
      123190,
      123202,
      123204,
      123208,
      123216,
      123238,
      123244,
      123258,
      123290,
      123314,
      123316,
      123402,
      123410,
      123412,
      123426,
      123428,
      123432,
      123446,
      123458,
      123464,
      123472,
      123486,
      123494,
      123500,
      123514,
      123522,
      123524,
      123528,
      123536,
      123552,
      123580,
      123590,
      123596,
      123608,
      123630,
      123634,
      123636,
      123674,
      123698,
      123700,
      123740,
      123746,
      123748,
      123752,
      123834,
      123914,
      123922,
      123924,
      123938,
      123944,
      123958,
      123970,
      123976,
      123984,
      123998,
      124006,
      124012,
      124026,
      124034,
      124036,
      124048,
      124062,
      124064,
      124092,
      124102,
      124108,
      124120,
      124142,
      124146,
      124148,
      124162,
      124164,
      124168,
      124176,
      124190,
      124192,
      124220,
      124224,
      124280,
      124294,
      124300,
      124312,
      124336,
      124350,
      124366,
      124380,
      124386,
      124388,
      124392,
      124406,
      124442,
      124462,
      124466,
      124468,
      124494,
      124508,
      124514,
      124520,
      124558,
      124572,
      124600,
      124610,
      124612,
      124616,
      124624,
      124646,
      124666,
      124694,
      124710,
      124716,
      124730,
      124742,
      124748,
      124760,
      124786,
      124788,
      124818,
      124820,
      124834,
      124836,
      124840,
      124854,
      124946,
      124948,
      124962,
      124964,
      124968,
      124982,
      124994,
      124996,
      125e3,
      125008,
      125022,
      125030,
      125036,
      125050,
      125058,
      125060,
      125064,
      125072,
      125086,
      125088,
      125116,
      125126,
      125132,
      125144,
      125166,
      125170,
      125172,
      125186,
      125188,
      125192,
      125200,
      125216,
      125244,
      125248,
      125304,
      125318,
      125324,
      125336,
      125360,
      125374,
      125390,
      125404,
      125410,
      125412,
      125416,
      125430,
      125444,
      125448,
      125456,
      125472,
      125504,
      125560,
      125680,
      125702,
      125708,
      125720,
      125744,
      125758,
      125792,
      125820,
      125838,
      125852,
      125880,
      125890,
      125892,
      125896,
      125904,
      125918,
      125926,
      125932,
      125978,
      125998,
      126002,
      126004,
      126030,
      126044,
      126050,
      126052,
      126056,
      126094,
      126108,
      126136,
      126146,
      126148,
      126152,
      126160,
      126182,
      126202,
      126222,
      126236,
      126264,
      126320,
      126334,
      126338,
      126340,
      126344,
      126352,
      126366,
      126368,
      126412,
      126450,
      126452,
      126486,
      126502,
      126508,
      126522,
      126534,
      126540,
      126552,
      126574,
      126578,
      126580,
      126598,
      126604,
      126616,
      126640,
      126654,
      126670,
      126684,
      126690,
      126692,
      126696,
      126738,
      126754,
      126756,
      126760,
      126774,
      126786,
      126788,
      126792,
      126800,
      126814,
      126822,
      126828,
      126842,
      126894,
      126898,
      126900,
      126934,
      127126,
      127142,
      127148,
      127162,
      127178,
      127186,
      127188,
      127254,
      127270,
      127276,
      127290,
      127302,
      127308,
      127320,
      127342,
      127346,
      127348,
      127370,
      127378,
      127380,
      127394,
      127396,
      127400,
      127450,
      127510,
      127526,
      127532,
      127546,
      127558,
      127576,
      127598,
      127602,
      127604,
      127622,
      127628,
      127640,
      127664,
      127678,
      127694,
      127708,
      127714,
      127716,
      127720,
      127734,
      127754,
      127762,
      127764,
      127778,
      127784,
      127810,
      127812,
      127816,
      127824,
      127838,
      127846,
      127866,
      127898,
      127918,
      127922,
      127924,
      128022,
      128038,
      128044,
      128058,
      128070,
      128076,
      128088,
      128110,
      128114,
      128116,
      128134,
      128140,
      128152,
      128176,
      128190,
      128206,
      128220,
      128226,
      128228,
      128232,
      128246,
      128262,
      128268,
      128280,
      128304,
      128318,
      128352,
      128380,
      128398,
      128412,
      128440,
      128450,
      128452,
      128456,
      128464,
      128478,
      128486,
      128492,
      128506,
      128522,
      128530,
      128532,
      128546,
      128548,
      128552,
      128566,
      128578,
      128580,
      128584,
      128592,
      128606,
      128614,
      128634,
      128642,
      128644,
      128648,
      128656,
      128670,
      128672,
      128700,
      128716,
      128754,
      128756,
      128794,
      128814,
      128818,
      128820,
      128846,
      128860,
      128866,
      128868,
      128872,
      128886,
      128918,
      128934,
      128940,
      128954,
      128978,
      128980,
      129178,
      129198,
      129202,
      129204,
      129238,
      129258,
      129306,
      129326,
      129330,
      129332,
      129358,
      129372,
      129378,
      129380,
      129384,
      129398,
      129430,
      129446,
      129452,
      129466,
      129482,
      129490,
      129492,
      129562,
      129582,
      129586,
      129588,
      129614,
      129628,
      129634,
      129636,
      129640,
      129654,
      129678,
      129692,
      129720,
      129730,
      129732,
      129736,
      129744,
      129758,
      129766,
      129772,
      129814,
      129830,
      129836,
      129850,
      129862,
      129868,
      129880,
      129902,
      129906,
      129908,
      129930,
      129938,
      129940,
      129954,
      129956,
      129960,
      129974,
      130010
    ]);
    PDF417Common.CODEWORD_TABLE = Int32Array.from([
      2627,
      1819,
      2622,
      2621,
      1813,
      1812,
      2729,
      2724,
      2723,
      2779,
      2774,
      2773,
      902,
      896,
      908,
      868,
      865,
      861,
      859,
      2511,
      873,
      871,
      1780,
      835,
      2493,
      825,
      2491,
      842,
      837,
      844,
      1764,
      1762,
      811,
      810,
      809,
      2483,
      807,
      2482,
      806,
      2480,
      815,
      814,
      813,
      812,
      2484,
      817,
      816,
      1745,
      1744,
      1742,
      1746,
      2655,
      2637,
      2635,
      2626,
      2625,
      2623,
      2628,
      1820,
      2752,
      2739,
      2737,
      2728,
      2727,
      2725,
      2730,
      2785,
      2783,
      2778,
      2777,
      2775,
      2780,
      787,
      781,
      747,
      739,
      736,
      2413,
      754,
      752,
      1719,
      692,
      689,
      681,
      2371,
      678,
      2369,
      700,
      697,
      694,
      703,
      1688,
      1686,
      642,
      638,
      2343,
      631,
      2341,
      627,
      2338,
      651,
      646,
      643,
      2345,
      654,
      652,
      1652,
      1650,
      1647,
      1654,
      601,
      599,
      2322,
      596,
      2321,
      594,
      2319,
      2317,
      611,
      610,
      608,
      606,
      2324,
      603,
      2323,
      615,
      614,
      612,
      1617,
      1616,
      1614,
      1612,
      616,
      1619,
      1618,
      2575,
      2538,
      2536,
      905,
      901,
      898,
      909,
      2509,
      2507,
      2504,
      870,
      867,
      864,
      860,
      2512,
      875,
      872,
      1781,
      2490,
      2489,
      2487,
      2485,
      1748,
      836,
      834,
      832,
      830,
      2494,
      827,
      2492,
      843,
      841,
      839,
      845,
      1765,
      1763,
      2701,
      2676,
      2674,
      2653,
      2648,
      2656,
      2634,
      2633,
      2631,
      2629,
      1821,
      2638,
      2636,
      2770,
      2763,
      2761,
      2750,
      2745,
      2753,
      2736,
      2735,
      2733,
      2731,
      1848,
      2740,
      2738,
      2786,
      2784,
      591,
      588,
      576,
      569,
      566,
      2296,
      1590,
      537,
      534,
      526,
      2276,
      522,
      2274,
      545,
      542,
      539,
      548,
      1572,
      1570,
      481,
      2245,
      466,
      2242,
      462,
      2239,
      492,
      485,
      482,
      2249,
      496,
      494,
      1534,
      1531,
      1528,
      1538,
      413,
      2196,
      406,
      2191,
      2188,
      425,
      419,
      2202,
      415,
      2199,
      432,
      430,
      427,
      1472,
      1467,
      1464,
      433,
      1476,
      1474,
      368,
      367,
      2160,
      365,
      2159,
      362,
      2157,
      2155,
      2152,
      378,
      377,
      375,
      2166,
      372,
      2165,
      369,
      2162,
      383,
      381,
      379,
      2168,
      1419,
      1418,
      1416,
      1414,
      385,
      1411,
      384,
      1423,
      1422,
      1420,
      1424,
      2461,
      802,
      2441,
      2439,
      790,
      786,
      783,
      794,
      2409,
      2406,
      2403,
      750,
      742,
      738,
      2414,
      756,
      753,
      1720,
      2367,
      2365,
      2362,
      2359,
      1663,
      693,
      691,
      684,
      2373,
      680,
      2370,
      702,
      699,
      696,
      704,
      1690,
      1687,
      2337,
      2336,
      2334,
      2332,
      1624,
      2329,
      1622,
      640,
      637,
      2344,
      634,
      2342,
      630,
      2340,
      650,
      648,
      645,
      2346,
      655,
      653,
      1653,
      1651,
      1649,
      1655,
      2612,
      2597,
      2595,
      2571,
      2568,
      2565,
      2576,
      2534,
      2529,
      2526,
      1787,
      2540,
      2537,
      907,
      904,
      900,
      910,
      2503,
      2502,
      2500,
      2498,
      1768,
      2495,
      1767,
      2510,
      2508,
      2506,
      869,
      866,
      863,
      2513,
      876,
      874,
      1782,
      2720,
      2713,
      2711,
      2697,
      2694,
      2691,
      2702,
      2672,
      2670,
      2664,
      1828,
      2678,
      2675,
      2647,
      2646,
      2644,
      2642,
      1823,
      2639,
      1822,
      2654,
      2652,
      2650,
      2657,
      2771,
      1855,
      2765,
      2762,
      1850,
      1849,
      2751,
      2749,
      2747,
      2754,
      353,
      2148,
      344,
      342,
      336,
      2142,
      332,
      2140,
      345,
      1375,
      1373,
      306,
      2130,
      299,
      2128,
      295,
      2125,
      319,
      314,
      311,
      2132,
      1354,
      1352,
      1349,
      1356,
      262,
      257,
      2101,
      253,
      2096,
      2093,
      274,
      273,
      267,
      2107,
      263,
      2104,
      280,
      278,
      275,
      1316,
      1311,
      1308,
      1320,
      1318,
      2052,
      202,
      2050,
      2044,
      2040,
      219,
      2063,
      212,
      2060,
      208,
      2055,
      224,
      221,
      2066,
      1260,
      1258,
      1252,
      231,
      1248,
      229,
      1266,
      1264,
      1261,
      1268,
      155,
      1998,
      153,
      1996,
      1994,
      1991,
      1988,
      165,
      164,
      2007,
      162,
      2006,
      159,
      2003,
      2e3,
      172,
      171,
      169,
      2012,
      166,
      2010,
      1186,
      1184,
      1182,
      1179,
      175,
      1176,
      173,
      1192,
      1191,
      1189,
      1187,
      176,
      1194,
      1193,
      2313,
      2307,
      2305,
      592,
      589,
      2294,
      2292,
      2289,
      578,
      572,
      568,
      2297,
      580,
      1591,
      2272,
      2267,
      2264,
      1547,
      538,
      536,
      529,
      2278,
      525,
      2275,
      547,
      544,
      541,
      1574,
      1571,
      2237,
      2235,
      2229,
      1493,
      2225,
      1489,
      478,
      2247,
      470,
      2244,
      465,
      2241,
      493,
      488,
      484,
      2250,
      498,
      495,
      1536,
      1533,
      1530,
      1539,
      2187,
      2186,
      2184,
      2182,
      1432,
      2179,
      1430,
      2176,
      1427,
      414,
      412,
      2197,
      409,
      2195,
      405,
      2193,
      2190,
      426,
      424,
      421,
      2203,
      418,
      2201,
      431,
      429,
      1473,
      1471,
      1469,
      1466,
      434,
      1477,
      1475,
      2478,
      2472,
      2470,
      2459,
      2457,
      2454,
      2462,
      803,
      2437,
      2432,
      2429,
      1726,
      2443,
      2440,
      792,
      789,
      785,
      2401,
      2399,
      2393,
      1702,
      2389,
      1699,
      2411,
      2408,
      2405,
      745,
      741,
      2415,
      758,
      755,
      1721,
      2358,
      2357,
      2355,
      2353,
      1661,
      2350,
      1660,
      2347,
      1657,
      2368,
      2366,
      2364,
      2361,
      1666,
      690,
      687,
      2374,
      683,
      2372,
      701,
      698,
      705,
      1691,
      1689,
      2619,
      2617,
      2610,
      2608,
      2605,
      2613,
      2593,
      2588,
      2585,
      1803,
      2599,
      2596,
      2563,
      2561,
      2555,
      1797,
      2551,
      1795,
      2573,
      2570,
      2567,
      2577,
      2525,
      2524,
      2522,
      2520,
      1786,
      2517,
      1785,
      2514,
      1783,
      2535,
      2533,
      2531,
      2528,
      1788,
      2541,
      2539,
      906,
      903,
      911,
      2721,
      1844,
      2715,
      2712,
      1838,
      1836,
      2699,
      2696,
      2693,
      2703,
      1827,
      1826,
      1824,
      2673,
      2671,
      2669,
      2666,
      1829,
      2679,
      2677,
      1858,
      1857,
      2772,
      1854,
      1853,
      1851,
      1856,
      2766,
      2764,
      143,
      1987,
      139,
      1986,
      135,
      133,
      131,
      1984,
      128,
      1983,
      125,
      1981,
      138,
      137,
      136,
      1985,
      1133,
      1132,
      1130,
      112,
      110,
      1974,
      107,
      1973,
      104,
      1971,
      1969,
      122,
      121,
      119,
      117,
      1977,
      114,
      1976,
      124,
      1115,
      1114,
      1112,
      1110,
      1117,
      1116,
      84,
      83,
      1953,
      81,
      1952,
      78,
      1950,
      1948,
      1945,
      94,
      93,
      91,
      1959,
      88,
      1958,
      85,
      1955,
      99,
      97,
      95,
      1961,
      1086,
      1085,
      1083,
      1081,
      1078,
      100,
      1090,
      1089,
      1087,
      1091,
      49,
      47,
      1917,
      44,
      1915,
      1913,
      1910,
      1907,
      59,
      1926,
      56,
      1925,
      53,
      1922,
      1919,
      66,
      64,
      1931,
      61,
      1929,
      1042,
      1040,
      1038,
      71,
      1035,
      70,
      1032,
      68,
      1048,
      1047,
      1045,
      1043,
      1050,
      1049,
      12,
      10,
      1869,
      1867,
      1864,
      1861,
      21,
      1880,
      19,
      1877,
      1874,
      1871,
      28,
      1888,
      25,
      1886,
      22,
      1883,
      982,
      980,
      977,
      974,
      32,
      30,
      991,
      989,
      987,
      984,
      34,
      995,
      994,
      992,
      2151,
      2150,
      2147,
      2146,
      2144,
      356,
      355,
      354,
      2149,
      2139,
      2138,
      2136,
      2134,
      1359,
      343,
      341,
      338,
      2143,
      335,
      2141,
      348,
      347,
      346,
      1376,
      1374,
      2124,
      2123,
      2121,
      2119,
      1326,
      2116,
      1324,
      310,
      308,
      305,
      2131,
      302,
      2129,
      298,
      2127,
      320,
      318,
      316,
      313,
      2133,
      322,
      321,
      1355,
      1353,
      1351,
      1357,
      2092,
      2091,
      2089,
      2087,
      1276,
      2084,
      1274,
      2081,
      1271,
      259,
      2102,
      256,
      2100,
      252,
      2098,
      2095,
      272,
      269,
      2108,
      266,
      2106,
      281,
      279,
      277,
      1317,
      1315,
      1313,
      1310,
      282,
      1321,
      1319,
      2039,
      2037,
      2035,
      2032,
      1203,
      2029,
      1200,
      1197,
      207,
      2053,
      205,
      2051,
      201,
      2049,
      2046,
      2043,
      220,
      218,
      2064,
      215,
      2062,
      211,
      2059,
      228,
      226,
      223,
      2069,
      1259,
      1257,
      1254,
      232,
      1251,
      230,
      1267,
      1265,
      1263,
      2316,
      2315,
      2312,
      2311,
      2309,
      2314,
      2304,
      2303,
      2301,
      2299,
      1593,
      2308,
      2306,
      590,
      2288,
      2287,
      2285,
      2283,
      1578,
      2280,
      1577,
      2295,
      2293,
      2291,
      579,
      577,
      574,
      571,
      2298,
      582,
      581,
      1592,
      2263,
      2262,
      2260,
      2258,
      1545,
      2255,
      1544,
      2252,
      1541,
      2273,
      2271,
      2269,
      2266,
      1550,
      535,
      532,
      2279,
      528,
      2277,
      546,
      543,
      549,
      1575,
      1573,
      2224,
      2222,
      2220,
      1486,
      2217,
      1485,
      2214,
      1482,
      1479,
      2238,
      2236,
      2234,
      2231,
      1496,
      2228,
      1492,
      480,
      477,
      2248,
      473,
      2246,
      469,
      2243,
      490,
      487,
      2251,
      497,
      1537,
      1535,
      1532,
      2477,
      2476,
      2474,
      2479,
      2469,
      2468,
      2466,
      2464,
      1730,
      2473,
      2471,
      2453,
      2452,
      2450,
      2448,
      1729,
      2445,
      1728,
      2460,
      2458,
      2456,
      2463,
      805,
      804,
      2428,
      2427,
      2425,
      2423,
      1725,
      2420,
      1724,
      2417,
      1722,
      2438,
      2436,
      2434,
      2431,
      1727,
      2444,
      2442,
      793,
      791,
      788,
      795,
      2388,
      2386,
      2384,
      1697,
      2381,
      1696,
      2378,
      1694,
      1692,
      2402,
      2400,
      2398,
      2395,
      1703,
      2392,
      1701,
      2412,
      2410,
      2407,
      751,
      748,
      744,
      2416,
      759,
      757,
      1807,
      2620,
      2618,
      1806,
      1805,
      2611,
      2609,
      2607,
      2614,
      1802,
      1801,
      1799,
      2594,
      2592,
      2590,
      2587,
      1804,
      2600,
      2598,
      1794,
      1793,
      1791,
      1789,
      2564,
      2562,
      2560,
      2557,
      1798,
      2554,
      1796,
      2574,
      2572,
      2569,
      2578,
      1847,
      1846,
      2722,
      1843,
      1842,
      1840,
      1845,
      2716,
      2714,
      1835,
      1834,
      1832,
      1830,
      1839,
      1837,
      2700,
      2698,
      2695,
      2704,
      1817,
      1811,
      1810,
      897,
      862,
      1777,
      829,
      826,
      838,
      1760,
      1758,
      808,
      2481,
      1741,
      1740,
      1738,
      1743,
      2624,
      1818,
      2726,
      2776,
      782,
      740,
      737,
      1715,
      686,
      679,
      695,
      1682,
      1680,
      639,
      628,
      2339,
      647,
      644,
      1645,
      1643,
      1640,
      1648,
      602,
      600,
      597,
      595,
      2320,
      593,
      2318,
      609,
      607,
      604,
      1611,
      1610,
      1608,
      1606,
      613,
      1615,
      1613,
      2328,
      926,
      924,
      892,
      886,
      899,
      857,
      850,
      2505,
      1778,
      824,
      823,
      821,
      819,
      2488,
      818,
      2486,
      833,
      831,
      828,
      840,
      1761,
      1759,
      2649,
      2632,
      2630,
      2746,
      2734,
      2732,
      2782,
      2781,
      570,
      567,
      1587,
      531,
      527,
      523,
      540,
      1566,
      1564,
      476,
      467,
      463,
      2240,
      486,
      483,
      1524,
      1521,
      1518,
      1529,
      411,
      403,
      2192,
      399,
      2189,
      423,
      416,
      1462,
      1457,
      1454,
      428,
      1468,
      1465,
      2210,
      366,
      363,
      2158,
      360,
      2156,
      357,
      2153,
      376,
      373,
      370,
      2163,
      1410,
      1409,
      1407,
      1405,
      382,
      1402,
      380,
      1417,
      1415,
      1412,
      1421,
      2175,
      2174,
      777,
      774,
      771,
      784,
      732,
      725,
      722,
      2404,
      743,
      1716,
      676,
      674,
      668,
      2363,
      665,
      2360,
      685,
      1684,
      1681,
      626,
      624,
      622,
      2335,
      620,
      2333,
      617,
      2330,
      641,
      635,
      649,
      1646,
      1644,
      1642,
      2566,
      928,
      925,
      2530,
      2527,
      894,
      891,
      888,
      2501,
      2499,
      2496,
      858,
      856,
      854,
      851,
      1779,
      2692,
      2668,
      2665,
      2645,
      2643,
      2640,
      2651,
      2768,
      2759,
      2757,
      2744,
      2743,
      2741,
      2748,
      352,
      1382,
      340,
      337,
      333,
      1371,
      1369,
      307,
      300,
      296,
      2126,
      315,
      312,
      1347,
      1342,
      1350,
      261,
      258,
      250,
      2097,
      246,
      2094,
      271,
      268,
      264,
      1306,
      1301,
      1298,
      276,
      1312,
      1309,
      2115,
      203,
      2048,
      195,
      2045,
      191,
      2041,
      213,
      209,
      2056,
      1246,
      1244,
      1238,
      225,
      1234,
      222,
      1256,
      1253,
      1249,
      1262,
      2080,
      2079,
      154,
      1997,
      150,
      1995,
      147,
      1992,
      1989,
      163,
      160,
      2004,
      156,
      2001,
      1175,
      1174,
      1172,
      1170,
      1167,
      170,
      1164,
      167,
      1185,
      1183,
      1180,
      1177,
      174,
      1190,
      1188,
      2025,
      2024,
      2022,
      587,
      586,
      564,
      559,
      556,
      2290,
      573,
      1588,
      520,
      518,
      512,
      2268,
      508,
      2265,
      530,
      1568,
      1565,
      461,
      457,
      2233,
      450,
      2230,
      446,
      2226,
      479,
      471,
      489,
      1526,
      1523,
      1520,
      397,
      395,
      2185,
      392,
      2183,
      389,
      2180,
      2177,
      410,
      2194,
      402,
      422,
      1463,
      1461,
      1459,
      1456,
      1470,
      2455,
      799,
      2433,
      2430,
      779,
      776,
      773,
      2397,
      2394,
      2390,
      734,
      728,
      724,
      746,
      1717,
      2356,
      2354,
      2351,
      2348,
      1658,
      677,
      675,
      673,
      670,
      667,
      688,
      1685,
      1683,
      2606,
      2589,
      2586,
      2559,
      2556,
      2552,
      927,
      2523,
      2521,
      2518,
      2515,
      1784,
      2532,
      895,
      893,
      890,
      2718,
      2709,
      2707,
      2689,
      2687,
      2684,
      2663,
      2662,
      2660,
      2658,
      1825,
      2667,
      2769,
      1852,
      2760,
      2758,
      142,
      141,
      1139,
      1138,
      134,
      132,
      129,
      126,
      1982,
      1129,
      1128,
      1126,
      1131,
      113,
      111,
      108,
      105,
      1972,
      101,
      1970,
      120,
      118,
      115,
      1109,
      1108,
      1106,
      1104,
      123,
      1113,
      1111,
      82,
      79,
      1951,
      75,
      1949,
      72,
      1946,
      92,
      89,
      86,
      1956,
      1077,
      1076,
      1074,
      1072,
      98,
      1069,
      96,
      1084,
      1082,
      1079,
      1088,
      1968,
      1967,
      48,
      45,
      1916,
      42,
      1914,
      39,
      1911,
      1908,
      60,
      57,
      54,
      1923,
      50,
      1920,
      1031,
      1030,
      1028,
      1026,
      67,
      1023,
      65,
      1020,
      62,
      1041,
      1039,
      1036,
      1033,
      69,
      1046,
      1044,
      1944,
      1943,
      1941,
      11,
      9,
      1868,
      7,
      1865,
      1862,
      1859,
      20,
      1878,
      16,
      1875,
      13,
      1872,
      970,
      968,
      966,
      963,
      29,
      960,
      26,
      23,
      983,
      981,
      978,
      975,
      33,
      971,
      31,
      990,
      988,
      985,
      1906,
      1904,
      1902,
      993,
      351,
      2145,
      1383,
      331,
      330,
      328,
      326,
      2137,
      323,
      2135,
      339,
      1372,
      1370,
      294,
      293,
      291,
      289,
      2122,
      286,
      2120,
      283,
      2117,
      309,
      303,
      317,
      1348,
      1346,
      1344,
      245,
      244,
      242,
      2090,
      239,
      2088,
      236,
      2085,
      2082,
      260,
      2099,
      249,
      270,
      1307,
      1305,
      1303,
      1300,
      1314,
      189,
      2038,
      186,
      2036,
      183,
      2033,
      2030,
      2026,
      206,
      198,
      2047,
      194,
      216,
      1247,
      1245,
      1243,
      1240,
      227,
      1237,
      1255,
      2310,
      2302,
      2300,
      2286,
      2284,
      2281,
      565,
      563,
      561,
      558,
      575,
      1589,
      2261,
      2259,
      2256,
      2253,
      1542,
      521,
      519,
      517,
      514,
      2270,
      511,
      533,
      1569,
      1567,
      2223,
      2221,
      2218,
      2215,
      1483,
      2211,
      1480,
      459,
      456,
      453,
      2232,
      449,
      474,
      491,
      1527,
      1525,
      1522,
      2475,
      2467,
      2465,
      2451,
      2449,
      2446,
      801,
      800,
      2426,
      2424,
      2421,
      2418,
      1723,
      2435,
      780,
      778,
      775,
      2387,
      2385,
      2382,
      2379,
      1695,
      2375,
      1693,
      2396,
      735,
      733,
      730,
      727,
      749,
      1718,
      2616,
      2615,
      2604,
      2603,
      2601,
      2584,
      2583,
      2581,
      2579,
      1800,
      2591,
      2550,
      2549,
      2547,
      2545,
      1792,
      2542,
      1790,
      2558,
      929,
      2719,
      1841,
      2710,
      2708,
      1833,
      1831,
      2690,
      2688,
      2686,
      1815,
      1809,
      1808,
      1774,
      1756,
      1754,
      1737,
      1736,
      1734,
      1739,
      1816,
      1711,
      1676,
      1674,
      633,
      629,
      1638,
      1636,
      1633,
      1641,
      598,
      1605,
      1604,
      1602,
      1600,
      605,
      1609,
      1607,
      2327,
      887,
      853,
      1775,
      822,
      820,
      1757,
      1755,
      1584,
      524,
      1560,
      1558,
      468,
      464,
      1514,
      1511,
      1508,
      1519,
      408,
      404,
      400,
      1452,
      1447,
      1444,
      417,
      1458,
      1455,
      2208,
      364,
      361,
      358,
      2154,
      1401,
      1400,
      1398,
      1396,
      374,
      1393,
      371,
      1408,
      1406,
      1403,
      1413,
      2173,
      2172,
      772,
      726,
      723,
      1712,
      672,
      669,
      666,
      682,
      1678,
      1675,
      625,
      623,
      621,
      618,
      2331,
      636,
      632,
      1639,
      1637,
      1635,
      920,
      918,
      884,
      880,
      889,
      849,
      848,
      847,
      846,
      2497,
      855,
      852,
      1776,
      2641,
      2742,
      2787,
      1380,
      334,
      1367,
      1365,
      301,
      297,
      1340,
      1338,
      1335,
      1343,
      255,
      251,
      247,
      1296,
      1291,
      1288,
      265,
      1302,
      1299,
      2113,
      204,
      196,
      192,
      2042,
      1232,
      1230,
      1224,
      214,
      1220,
      210,
      1242,
      1239,
      1235,
      1250,
      2077,
      2075,
      151,
      148,
      1993,
      144,
      1990,
      1163,
      1162,
      1160,
      1158,
      1155,
      161,
      1152,
      157,
      1173,
      1171,
      1168,
      1165,
      168,
      1181,
      1178,
      2021,
      2020,
      2018,
      2023,
      585,
      560,
      557,
      1585,
      516,
      509,
      1562,
      1559,
      458,
      447,
      2227,
      472,
      1516,
      1513,
      1510,
      398,
      396,
      393,
      390,
      2181,
      386,
      2178,
      407,
      1453,
      1451,
      1449,
      1446,
      420,
      1460,
      2209,
      769,
      764,
      720,
      712,
      2391,
      729,
      1713,
      664,
      663,
      661,
      659,
      2352,
      656,
      2349,
      671,
      1679,
      1677,
      2553,
      922,
      919,
      2519,
      2516,
      885,
      883,
      881,
      2685,
      2661,
      2659,
      2767,
      2756,
      2755,
      140,
      1137,
      1136,
      130,
      127,
      1125,
      1124,
      1122,
      1127,
      109,
      106,
      102,
      1103,
      1102,
      1100,
      1098,
      116,
      1107,
      1105,
      1980,
      80,
      76,
      73,
      1947,
      1068,
      1067,
      1065,
      1063,
      90,
      1060,
      87,
      1075,
      1073,
      1070,
      1080,
      1966,
      1965,
      46,
      43,
      40,
      1912,
      36,
      1909,
      1019,
      1018,
      1016,
      1014,
      58,
      1011,
      55,
      1008,
      51,
      1029,
      1027,
      1024,
      1021,
      63,
      1037,
      1034,
      1940,
      1939,
      1937,
      1942,
      8,
      1866,
      4,
      1863,
      1,
      1860,
      956,
      954,
      952,
      949,
      946,
      17,
      14,
      969,
      967,
      964,
      961,
      27,
      957,
      24,
      979,
      976,
      972,
      1901,
      1900,
      1898,
      1896,
      986,
      1905,
      1903,
      350,
      349,
      1381,
      329,
      327,
      324,
      1368,
      1366,
      292,
      290,
      287,
      284,
      2118,
      304,
      1341,
      1339,
      1337,
      1345,
      243,
      240,
      237,
      2086,
      233,
      2083,
      254,
      1297,
      1295,
      1293,
      1290,
      1304,
      2114,
      190,
      187,
      184,
      2034,
      180,
      2031,
      177,
      2027,
      199,
      1233,
      1231,
      1229,
      1226,
      217,
      1223,
      1241,
      2078,
      2076,
      584,
      555,
      554,
      552,
      550,
      2282,
      562,
      1586,
      507,
      506,
      504,
      502,
      2257,
      499,
      2254,
      515,
      1563,
      1561,
      445,
      443,
      441,
      2219,
      438,
      2216,
      435,
      2212,
      460,
      454,
      475,
      1517,
      1515,
      1512,
      2447,
      798,
      797,
      2422,
      2419,
      770,
      768,
      766,
      2383,
      2380,
      2376,
      721,
      719,
      717,
      714,
      731,
      1714,
      2602,
      2582,
      2580,
      2548,
      2546,
      2543,
      923,
      921,
      2717,
      2706,
      2705,
      2683,
      2682,
      2680,
      1771,
      1752,
      1750,
      1733,
      1732,
      1731,
      1735,
      1814,
      1707,
      1670,
      1668,
      1631,
      1629,
      1626,
      1634,
      1599,
      1598,
      1596,
      1594,
      1603,
      1601,
      2326,
      1772,
      1753,
      1751,
      1581,
      1554,
      1552,
      1504,
      1501,
      1498,
      1509,
      1442,
      1437,
      1434,
      401,
      1448,
      1445,
      2206,
      1392,
      1391,
      1389,
      1387,
      1384,
      359,
      1399,
      1397,
      1394,
      1404,
      2171,
      2170,
      1708,
      1672,
      1669,
      619,
      1632,
      1630,
      1628,
      1773,
      1378,
      1363,
      1361,
      1333,
      1328,
      1336,
      1286,
      1281,
      1278,
      248,
      1292,
      1289,
      2111,
      1218,
      1216,
      1210,
      197,
      1206,
      193,
      1228,
      1225,
      1221,
      1236,
      2073,
      2071,
      1151,
      1150,
      1148,
      1146,
      152,
      1143,
      149,
      1140,
      145,
      1161,
      1159,
      1156,
      1153,
      158,
      1169,
      1166,
      2017,
      2016,
      2014,
      2019,
      1582,
      510,
      1556,
      1553,
      452,
      448,
      1506,
      1500,
      394,
      391,
      387,
      1443,
      1441,
      1439,
      1436,
      1450,
      2207,
      765,
      716,
      713,
      1709,
      662,
      660,
      657,
      1673,
      1671,
      916,
      914,
      879,
      878,
      877,
      882,
      1135,
      1134,
      1121,
      1120,
      1118,
      1123,
      1097,
      1096,
      1094,
      1092,
      103,
      1101,
      1099,
      1979,
      1059,
      1058,
      1056,
      1054,
      77,
      1051,
      74,
      1066,
      1064,
      1061,
      1071,
      1964,
      1963,
      1007,
      1006,
      1004,
      1002,
      999,
      41,
      996,
      37,
      1017,
      1015,
      1012,
      1009,
      52,
      1025,
      1022,
      1936,
      1935,
      1933,
      1938,
      942,
      940,
      938,
      935,
      932,
      5,
      2,
      955,
      953,
      950,
      947,
      18,
      943,
      15,
      965,
      962,
      958,
      1895,
      1894,
      1892,
      1890,
      973,
      1899,
      1897,
      1379,
      325,
      1364,
      1362,
      288,
      285,
      1334,
      1332,
      1330,
      241,
      238,
      234,
      1287,
      1285,
      1283,
      1280,
      1294,
      2112,
      188,
      185,
      181,
      178,
      2028,
      1219,
      1217,
      1215,
      1212,
      200,
      1209,
      1227,
      2074,
      2072,
      583,
      553,
      551,
      1583,
      505,
      503,
      500,
      513,
      1557,
      1555,
      444,
      442,
      439,
      436,
      2213,
      455,
      451,
      1507,
      1505,
      1502,
      796,
      763,
      762,
      760,
      767,
      711,
      710,
      708,
      706,
      2377,
      718,
      715,
      1710,
      2544,
      917,
      915,
      2681,
      1627,
      1597,
      1595,
      2325,
      1769,
      1749,
      1747,
      1499,
      1438,
      1435,
      2204,
      1390,
      1388,
      1385,
      1395,
      2169,
      2167,
      1704,
      1665,
      1662,
      1625,
      1623,
      1620,
      1770,
      1329,
      1282,
      1279,
      2109,
      1214,
      1207,
      1222,
      2068,
      2065,
      1149,
      1147,
      1144,
      1141,
      146,
      1157,
      1154,
      2013,
      2011,
      2008,
      2015,
      1579,
      1549,
      1546,
      1495,
      1487,
      1433,
      1431,
      1428,
      1425,
      388,
      1440,
      2205,
      1705,
      658,
      1667,
      1664,
      1119,
      1095,
      1093,
      1978,
      1057,
      1055,
      1052,
      1062,
      1962,
      1960,
      1005,
      1003,
      1e3,
      997,
      38,
      1013,
      1010,
      1932,
      1930,
      1927,
      1934,
      941,
      939,
      936,
      933,
      6,
      930,
      3,
      951,
      948,
      944,
      1889,
      1887,
      1884,
      1881,
      959,
      1893,
      1891,
      35,
      1377,
      1360,
      1358,
      1327,
      1325,
      1322,
      1331,
      1277,
      1275,
      1272,
      1269,
      235,
      1284,
      2110,
      1205,
      1204,
      1201,
      1198,
      182,
      1195,
      179,
      1213,
      2070,
      2067,
      1580,
      501,
      1551,
      1548,
      440,
      437,
      1497,
      1494,
      1490,
      1503,
      761,
      709,
      707,
      1706,
      913,
      912,
      2198,
      1386,
      2164,
      2161,
      1621,
      1766,
      2103,
      1208,
      2058,
      2054,
      1145,
      1142,
      2005,
      2002,
      1999,
      2009,
      1488,
      1429,
      1426,
      2200,
      1698,
      1659,
      1656,
      1975,
      1053,
      1957,
      1954,
      1001,
      998,
      1924,
      1921,
      1918,
      1928,
      937,
      934,
      931,
      1879,
      1876,
      1873,
      1870,
      945,
      1885,
      1882,
      1323,
      1273,
      1270,
      2105,
      1202,
      1199,
      1196,
      1211,
      2061,
      2057,
      1576,
      1543,
      1540,
      1484,
      1481,
      1478,
      1491,
      1700
    ]);
    class PDF417DetectorResult {
      constructor(bits, points) {
        this.bits = bits;
        this.points = points;
      }
      getBits() {
        return this.bits;
      }
      getPoints() {
        return this.points;
      }
    }
    class Detector$3 {
      /**
       * <p>Detects a PDF417 Code in an image. Only checks 0 and 180 degree rotations.</p>
       *
       * @param image barcode image to decode
       * @param hints optional hints to detector
       * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
       * be found and returned
       * @return {@link PDF417DetectorResult} encapsulating results of detecting a PDF417 code
       * @throws NotFoundException if no PDF417 Code can be found
       */
      static detectMultiple(image, hints, multiple) {
        let bitMatrix = image.getBlackMatrix();
        let barcodeCoordinates = Detector$3.detect(multiple, bitMatrix);
        if (!barcodeCoordinates.length) {
          bitMatrix = bitMatrix.clone();
          bitMatrix.rotate180();
          barcodeCoordinates = Detector$3.detect(multiple, bitMatrix);
        }
        return new PDF417DetectorResult(bitMatrix, barcodeCoordinates);
      }
      /**
       * Detects PDF417 codes in an image. Only checks 0 degree rotation
       * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
       * be found and returned
       * @param bitMatrix bit matrix to detect barcodes in
       * @return List of ResultPoint arrays containing the coordinates of found barcodes
       */
      static detect(multiple, bitMatrix) {
        const barcodeCoordinates = new Array();
        let row = 0;
        let column = 0;
        let foundBarcodeInRow = false;
        while (row < bitMatrix.getHeight()) {
          const vertices = Detector$3.findVertices(bitMatrix, row, column);
          if (vertices[0] == null && vertices[3] == null) {
            if (!foundBarcodeInRow) {
              break;
            }
            foundBarcodeInRow = false;
            column = 0;
            for (const barcodeCoordinate of barcodeCoordinates) {
              if (barcodeCoordinate[1] != null) {
                row = Math.trunc(Math.max(row, barcodeCoordinate[1].getY()));
              }
              if (barcodeCoordinate[3] != null) {
                row = Math.max(row, Math.trunc(barcodeCoordinate[3].getY()));
              }
            }
            row += Detector$3.ROW_STEP;
            continue;
          }
          foundBarcodeInRow = true;
          barcodeCoordinates.push(vertices);
          if (!multiple) {
            break;
          }
          if (vertices[2] != null) {
            column = Math.trunc(vertices[2].getX());
            row = Math.trunc(vertices[2].getY());
          } else {
            column = Math.trunc(vertices[4].getX());
            row = Math.trunc(vertices[4].getY());
          }
        }
        return barcodeCoordinates;
      }
      /**
       * Locate the vertices and the codewords area of a black blob using the Start
       * and Stop patterns as locators.
       *
       * @param matrix the scanned barcode image.
       * @return an array containing the vertices:
       *           vertices[0] x, y top left barcode
       *           vertices[1] x, y bottom left barcode
       *           vertices[2] x, y top right barcode
       *           vertices[3] x, y bottom right barcode
       *           vertices[4] x, y top left codeword area
       *           vertices[5] x, y bottom left codeword area
       *           vertices[6] x, y top right codeword area
       *           vertices[7] x, y bottom right codeword area
       */
      static findVertices(matrix2, startRow, startColumn) {
        const height = matrix2.getHeight();
        const width = matrix2.getWidth();
        const result2 = new Array(8);
        Detector$3.copyToResult(result2, Detector$3.findRowsWithPattern(matrix2, height, width, startRow, startColumn, Detector$3.START_PATTERN), Detector$3.INDEXES_START_PATTERN);
        if (result2[4] != null) {
          startColumn = Math.trunc(result2[4].getX());
          startRow = Math.trunc(result2[4].getY());
        }
        Detector$3.copyToResult(result2, Detector$3.findRowsWithPattern(matrix2, height, width, startRow, startColumn, Detector$3.STOP_PATTERN), Detector$3.INDEXES_STOP_PATTERN);
        return result2;
      }
      static copyToResult(result2, tmpResult, destinationIndexes) {
        for (let i2 = 0; i2 < destinationIndexes.length; i2++) {
          result2[destinationIndexes[i2]] = tmpResult[i2];
        }
      }
      static findRowsWithPattern(matrix2, height, width, startRow, startColumn, pattern) {
        const result2 = new Array(4);
        let found = false;
        const counters = new Int32Array(pattern.length);
        for (; startRow < height; startRow += Detector$3.ROW_STEP) {
          let loc = Detector$3.findGuardPattern(matrix2, startColumn, startRow, width, false, pattern, counters);
          if (loc != null) {
            while (startRow > 0) {
              const previousRowLoc = Detector$3.findGuardPattern(matrix2, startColumn, --startRow, width, false, pattern, counters);
              if (previousRowLoc != null) {
                loc = previousRowLoc;
              } else {
                startRow++;
                break;
              }
            }
            result2[0] = new ResultPoint(loc[0], startRow);
            result2[1] = new ResultPoint(loc[1], startRow);
            found = true;
            break;
          }
        }
        let stopRow = startRow + 1;
        if (found) {
          let skippedRowCount = 0;
          let previousRowLoc = Int32Array.from([Math.trunc(result2[0].getX()), Math.trunc(result2[1].getX())]);
          for (; stopRow < height; stopRow++) {
            const loc = Detector$3.findGuardPattern(matrix2, previousRowLoc[0], stopRow, width, false, pattern, counters);
            if (loc != null && Math.abs(previousRowLoc[0] - loc[0]) < Detector$3.MAX_PATTERN_DRIFT && Math.abs(previousRowLoc[1] - loc[1]) < Detector$3.MAX_PATTERN_DRIFT) {
              previousRowLoc = loc;
              skippedRowCount = 0;
            } else {
              if (skippedRowCount > Detector$3.SKIPPED_ROW_COUNT_MAX) {
                break;
              } else {
                skippedRowCount++;
              }
            }
          }
          stopRow -= skippedRowCount + 1;
          result2[2] = new ResultPoint(previousRowLoc[0], stopRow);
          result2[3] = new ResultPoint(previousRowLoc[1], stopRow);
        }
        if (stopRow - startRow < Detector$3.BARCODE_MIN_HEIGHT) {
          Arrays.fill(result2, null);
        }
        return result2;
      }
      /**
       * @param matrix row of black/white values to search
       * @param column x position to start search
       * @param row y position to start search
       * @param width the number of pixels to search on this row
       * @param pattern pattern of counts of number of black and white pixels that are
       *                 being searched for as a pattern
       * @param counters array of counters, as long as pattern, to re-use
       * @return start/end horizontal offset of guard pattern, as an array of two ints.
       */
      static findGuardPattern(matrix2, column, row, width, whiteFirst, pattern, counters) {
        Arrays.fillWithin(counters, 0, counters.length, 0);
        let patternStart = column;
        let pixelDrift = 0;
        while (matrix2.get(patternStart, row) && patternStart > 0 && pixelDrift++ < Detector$3.MAX_PIXEL_DRIFT) {
          patternStart--;
        }
        let x2 = patternStart;
        let counterPosition = 0;
        let patternLength = pattern.length;
        for (let isWhite = whiteFirst; x2 < width; x2++) {
          let pixel = matrix2.get(x2, row);
          if (pixel !== isWhite) {
            counters[counterPosition]++;
          } else {
            if (counterPosition === patternLength - 1) {
              if (Detector$3.patternMatchVariance(counters, pattern, Detector$3.MAX_INDIVIDUAL_VARIANCE) < Detector$3.MAX_AVG_VARIANCE) {
                return new Int32Array([patternStart, x2]);
              }
              patternStart += counters[0] + counters[1];
              System.arraycopy(counters, 2, counters, 0, counterPosition - 1);
              counters[counterPosition - 1] = 0;
              counters[counterPosition] = 0;
              counterPosition--;
            } else {
              counterPosition++;
            }
            counters[counterPosition] = 1;
            isWhite = !isWhite;
          }
        }
        if (counterPosition === patternLength - 1 && Detector$3.patternMatchVariance(counters, pattern, Detector$3.MAX_INDIVIDUAL_VARIANCE) < Detector$3.MAX_AVG_VARIANCE) {
          return new Int32Array([patternStart, x2 - 1]);
        }
        return null;
      }
      /**
       * Determines how closely a set of observed counts of runs of black/white
       * values matches a given target pattern. This is reported as the ratio of
       * the total variance from the expected pattern proportions across all
       * pattern elements, to the length of the pattern.
       *
       * @param counters observed counters
       * @param pattern expected pattern
       * @param maxIndividualVariance The most any counter can differ before we give up
       * @return ratio of total variance between counters and pattern compared to total pattern size
       */
      static patternMatchVariance(counters, pattern, maxIndividualVariance) {
        let numCounters = counters.length;
        let total = 0;
        let patternLength = 0;
        for (let i2 = 0; i2 < numCounters; i2++) {
          total += counters[i2];
          patternLength += pattern[i2];
        }
        if (total < patternLength) {
          return (
            /*Float.POSITIVE_INFINITY*/
            Infinity
          );
        }
        let unitBarWidth = total / patternLength;
        maxIndividualVariance *= unitBarWidth;
        let totalVariance = 0;
        for (let x2 = 0; x2 < numCounters; x2++) {
          let counter = counters[x2];
          let scaledPattern = pattern[x2] * unitBarWidth;
          let variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
          if (variance > maxIndividualVariance) {
            return (
              /*Float.POSITIVE_INFINITY*/
              Infinity
            );
          }
          totalVariance += variance;
        }
        return totalVariance / total;
      }
    }
    Detector$3.INDEXES_START_PATTERN = Int32Array.from([0, 4, 1, 5]);
    Detector$3.INDEXES_STOP_PATTERN = Int32Array.from([6, 2, 7, 3]);
    Detector$3.MAX_AVG_VARIANCE = 0.42;
    Detector$3.MAX_INDIVIDUAL_VARIANCE = 0.8;
    Detector$3.START_PATTERN = Int32Array.from([8, 1, 1, 1, 1, 1, 1, 3]);
    Detector$3.STOP_PATTERN = Int32Array.from([7, 1, 1, 3, 1, 1, 1, 2, 1]);
    Detector$3.MAX_PIXEL_DRIFT = 3;
    Detector$3.MAX_PATTERN_DRIFT = 5;
    Detector$3.SKIPPED_ROW_COUNT_MAX = 25;
    Detector$3.ROW_STEP = 5;
    Detector$3.BARCODE_MIN_HEIGHT = 10;
    class ModulusPoly {
      constructor(field, coefficients) {
        if (coefficients.length === 0) {
          throw new IllegalArgumentException();
        }
        this.field = field;
        let coefficientsLength = (
          /*int*/
          coefficients.length
        );
        if (coefficientsLength > 1 && coefficients[0] === 0) {
          let firstNonZero = (
            /*int*/
            1
          );
          while (firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0) {
            firstNonZero++;
          }
          if (firstNonZero === coefficientsLength) {
            this.coefficients = new Int32Array([0]);
          } else {
            this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
            System.arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
          }
        } else {
          this.coefficients = coefficients;
        }
      }
      getCoefficients() {
        return this.coefficients;
      }
      /**
       * @return degree of this polynomial
       */
      getDegree() {
        return this.coefficients.length - 1;
      }
      /**
       * @return true iff this polynomial is the monomial "0"
       */
      isZero() {
        return this.coefficients[0] === 0;
      }
      /**
       * @return coefficient of x^degree term in this polynomial
       */
      getCoefficient(degree) {
        return this.coefficients[this.coefficients.length - 1 - degree];
      }
      /**
       * @return evaluation of this polynomial at a given point
       */
      evaluateAt(a) {
        if (a === 0) {
          return this.getCoefficient(0);
        }
        if (a === 1) {
          let sum = (
            /*int*/
            0
          );
          for (let coefficient of this.coefficients) {
            sum = this.field.add(sum, coefficient);
          }
          return sum;
        }
        let result2 = (
          /*int*/
          this.coefficients[0]
        );
        let size = (
          /*int*/
          this.coefficients.length
        );
        for (let i2 = 1; i2 < size; i2++) {
          result2 = this.field.add(this.field.multiply(a, result2), this.coefficients[i2]);
        }
        return result2;
      }
      add(other) {
        if (!this.field.equals(other.field)) {
          throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
        }
        if (this.isZero()) {
          return other;
        }
        if (other.isZero()) {
          return this;
        }
        let smallerCoefficients = this.coefficients;
        let largerCoefficients = other.coefficients;
        if (smallerCoefficients.length > largerCoefficients.length) {
          let temp = smallerCoefficients;
          smallerCoefficients = largerCoefficients;
          largerCoefficients = temp;
        }
        let sumDiff = new Int32Array(largerCoefficients.length);
        let lengthDiff = (
          /*int*/
          largerCoefficients.length - smallerCoefficients.length
        );
        System.arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
        for (let i2 = lengthDiff; i2 < largerCoefficients.length; i2++) {
          sumDiff[i2] = this.field.add(smallerCoefficients[i2 - lengthDiff], largerCoefficients[i2]);
        }
        return new ModulusPoly(this.field, sumDiff);
      }
      subtract(other) {
        if (!this.field.equals(other.field)) {
          throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
        }
        if (other.isZero()) {
          return this;
        }
        return this.add(other.negative());
      }
      multiply(other) {
        if (other instanceof ModulusPoly) {
          return this.multiplyOther(other);
        }
        return this.multiplyScalar(other);
      }
      multiplyOther(other) {
        if (!this.field.equals(other.field)) {
          throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
        }
        if (this.isZero() || other.isZero()) {
          return new ModulusPoly(this.field, new Int32Array([0]));
        }
        let aCoefficients = this.coefficients;
        let aLength = (
          /*int*/
          aCoefficients.length
        );
        let bCoefficients = other.coefficients;
        let bLength = (
          /*int*/
          bCoefficients.length
        );
        let product = new Int32Array(aLength + bLength - 1);
        for (let i2 = 0; i2 < aLength; i2++) {
          let aCoeff = (
            /*int*/
            aCoefficients[i2]
          );
          for (let j = 0; j < bLength; j++) {
            product[i2 + j] = this.field.add(product[i2 + j], this.field.multiply(aCoeff, bCoefficients[j]));
          }
        }
        return new ModulusPoly(this.field, product);
      }
      negative() {
        let size = (
          /*int*/
          this.coefficients.length
        );
        let negativeCoefficients = new Int32Array(size);
        for (let i2 = 0; i2 < size; i2++) {
          negativeCoefficients[i2] = this.field.subtract(0, this.coefficients[i2]);
        }
        return new ModulusPoly(this.field, negativeCoefficients);
      }
      multiplyScalar(scalar) {
        if (scalar === 0) {
          return new ModulusPoly(this.field, new Int32Array([0]));
        }
        if (scalar === 1) {
          return this;
        }
        let size = (
          /*int*/
          this.coefficients.length
        );
        let product = new Int32Array(size);
        for (let i2 = 0; i2 < size; i2++) {
          product[i2] = this.field.multiply(this.coefficients[i2], scalar);
        }
        return new ModulusPoly(this.field, product);
      }
      multiplyByMonomial(degree, coefficient) {
        if (degree < 0) {
          throw new IllegalArgumentException();
        }
        if (coefficient === 0) {
          return new ModulusPoly(this.field, new Int32Array([0]));
        }
        let size = (
          /*int*/
          this.coefficients.length
        );
        let product = new Int32Array(size + degree);
        for (let i2 = 0; i2 < size; i2++) {
          product[i2] = this.field.multiply(this.coefficients[i2], coefficient);
        }
        return new ModulusPoly(this.field, product);
      }
      /*
        ModulusPoly[] divide(other: ModulusPoly) {
          if (!field.equals(other.field)) {
            throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
          }
          if (other.isZero()) {
            throw new IllegalArgumentException("Divide by 0");
          }
      
          let quotient: ModulusPoly = field.getZero();
          let remainder: ModulusPoly = this;
      
          let denominatorLeadingTerm: /*int/ number = other.getCoefficient(other.getDegree());
          let inverseDenominatorLeadingTerm: /*int/ number = field.inverse(denominatorLeadingTerm);
      
          while (remainder.getDegree() >= other.getDegree() && !remainder.isZero()) {
            let degreeDifference: /*int/ number = remainder.getDegree() - other.getDegree();
            let scale: /*int/ number = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
            let term: ModulusPoly = other.multiplyByMonomial(degreeDifference, scale);
            let iterationQuotient: ModulusPoly = field.buildMonomial(degreeDifference, scale);
            quotient = quotient.add(iterationQuotient);
            remainder = remainder.subtract(term);
          }
      
          return new ModulusPoly[] { quotient, remainder };
        }
        */
      // @Override
      toString() {
        let result2 = new StringBuilder(
          /*8 * this.getDegree()*/
        );
        for (let degree = this.getDegree(); degree >= 0; degree--) {
          let coefficient = (
            /*int*/
            this.getCoefficient(degree)
          );
          if (coefficient !== 0) {
            if (coefficient < 0) {
              result2.append(" - ");
              coefficient = -coefficient;
            } else {
              if (result2.length() > 0) {
                result2.append(" + ");
              }
            }
            if (degree === 0 || coefficient !== 1) {
              result2.append(coefficient);
            }
            if (degree !== 0) {
              if (degree === 1) {
                result2.append("x");
              } else {
                result2.append("x^");
                result2.append(degree);
              }
            }
          }
        }
        return result2.toString();
      }
    }
    class ModulusBase {
      add(a, b) {
        return (a + b) % this.modulus;
      }
      subtract(a, b) {
        return (this.modulus + a - b) % this.modulus;
      }
      exp(a) {
        return this.expTable[a];
      }
      log(a) {
        if (a === 0) {
          throw new IllegalArgumentException();
        }
        return this.logTable[a];
      }
      inverse(a) {
        if (a === 0) {
          throw new ArithmeticException();
        }
        return this.expTable[this.modulus - this.logTable[a] - 1];
      }
      multiply(a, b) {
        if (a === 0 || b === 0) {
          return 0;
        }
        return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.modulus - 1)];
      }
      getSize() {
        return this.modulus;
      }
      equals(o) {
        return o === this;
      }
    }
    class ModulusGF extends ModulusBase {
      // private /*final*/ modulus: /*int*/ number;
      constructor(modulus, generator) {
        super();
        this.modulus = modulus;
        this.expTable = new Int32Array(modulus);
        this.logTable = new Int32Array(modulus);
        let x2 = (
          /*int*/
          1
        );
        for (let i2 = 0; i2 < modulus; i2++) {
          this.expTable[i2] = x2;
          x2 = x2 * generator % modulus;
        }
        for (let i2 = 0; i2 < modulus - 1; i2++) {
          this.logTable[this.expTable[i2]] = i2;
        }
        this.zero = new ModulusPoly(this, new Int32Array([0]));
        this.one = new ModulusPoly(this, new Int32Array([1]));
      }
      getZero() {
        return this.zero;
      }
      getOne() {
        return this.one;
      }
      buildMonomial(degree, coefficient) {
        if (degree < 0) {
          throw new IllegalArgumentException();
        }
        if (coefficient === 0) {
          return this.zero;
        }
        let coefficients = new Int32Array(degree + 1);
        coefficients[0] = coefficient;
        return new ModulusPoly(this, coefficients);
      }
    }
    ModulusGF.PDF417_GF = new ModulusGF(PDF417Common.NUMBER_OF_CODEWORDS, 3);
    class ErrorCorrection {
      constructor() {
        this.field = ModulusGF.PDF417_GF;
      }
      /**
       * @param received received codewords
       * @param numECCodewords number of those codewords used for EC
       * @param erasures location of erasures
       * @return number of errors
       * @throws ChecksumException if errors cannot be corrected, maybe because of too many errors
       */
      decode(received, numECCodewords, erasures) {
        let poly = new ModulusPoly(this.field, received);
        let S = new Int32Array(numECCodewords);
        let error2 = false;
        for (let i2 = numECCodewords; i2 > 0; i2--) {
          let evaluation = poly.evaluateAt(this.field.exp(i2));
          S[numECCodewords - i2] = evaluation;
          if (evaluation !== 0) {
            error2 = true;
          }
        }
        if (!error2) {
          return 0;
        }
        let knownErrors = this.field.getOne();
        if (erasures != null) {
          for (const erasure of erasures) {
            let b = this.field.exp(received.length - 1 - erasure);
            let term = new ModulusPoly(this.field, new Int32Array([this.field.subtract(0, b), 1]));
            knownErrors = knownErrors.multiply(term);
          }
        }
        let syndrome = new ModulusPoly(this.field, S);
        let sigmaOmega = this.runEuclideanAlgorithm(this.field.buildMonomial(numECCodewords, 1), syndrome, numECCodewords);
        let sigma = sigmaOmega[0];
        let omega = sigmaOmega[1];
        let errorLocations = this.findErrorLocations(sigma);
        let errorMagnitudes = this.findErrorMagnitudes(omega, sigma, errorLocations);
        for (let i2 = 0; i2 < errorLocations.length; i2++) {
          let position = received.length - 1 - this.field.log(errorLocations[i2]);
          if (position < 0) {
            throw ChecksumException.getChecksumInstance();
          }
          received[position] = this.field.subtract(received[position], errorMagnitudes[i2]);
        }
        return errorLocations.length;
      }
      /**
       *
       * @param ModulusPoly
       * @param a
       * @param ModulusPoly
       * @param b
       * @param int
       * @param R
       * @throws ChecksumException
       */
      runEuclideanAlgorithm(a, b, R) {
        if (a.getDegree() < b.getDegree()) {
          let temp = a;
          a = b;
          b = temp;
        }
        let rLast = a;
        let r = b;
        let tLast = this.field.getZero();
        let t3 = this.field.getOne();
        while (r.getDegree() >= Math.round(R / 2)) {
          let rLastLast = rLast;
          let tLastLast = tLast;
          rLast = r;
          tLast = t3;
          if (rLast.isZero()) {
            throw ChecksumException.getChecksumInstance();
          }
          r = rLastLast;
          let q = this.field.getZero();
          let denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
          let dltInverse = this.field.inverse(denominatorLeadingTerm);
          while (r.getDegree() >= rLast.getDegree() && !r.isZero()) {
            let degreeDiff = r.getDegree() - rLast.getDegree();
            let scale = this.field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
            q = q.add(this.field.buildMonomial(degreeDiff, scale));
            r = r.subtract(rLast.multiplyByMonomial(degreeDiff, scale));
          }
          t3 = q.multiply(tLast).subtract(tLastLast).negative();
        }
        let sigmaTildeAtZero = t3.getCoefficient(0);
        if (sigmaTildeAtZero === 0) {
          throw ChecksumException.getChecksumInstance();
        }
        let inverse = this.field.inverse(sigmaTildeAtZero);
        let sigma = t3.multiply(inverse);
        let omega = r.multiply(inverse);
        return [sigma, omega];
      }
      /**
       *
       * @param errorLocator
       * @throws ChecksumException
       */
      findErrorLocations(errorLocator) {
        let numErrors = errorLocator.getDegree();
        let result2 = new Int32Array(numErrors);
        let e = 0;
        for (let i2 = 1; i2 < this.field.getSize() && e < numErrors; i2++) {
          if (errorLocator.evaluateAt(i2) === 0) {
            result2[e] = this.field.inverse(i2);
            e++;
          }
        }
        if (e !== numErrors) {
          throw ChecksumException.getChecksumInstance();
        }
        return result2;
      }
      findErrorMagnitudes(errorEvaluator, errorLocator, errorLocations) {
        let errorLocatorDegree = errorLocator.getDegree();
        let formalDerivativeCoefficients = new Int32Array(errorLocatorDegree);
        for (let i2 = 1; i2 <= errorLocatorDegree; i2++) {
          formalDerivativeCoefficients[errorLocatorDegree - i2] = this.field.multiply(i2, errorLocator.getCoefficient(i2));
        }
        let formalDerivative = new ModulusPoly(this.field, formalDerivativeCoefficients);
        let s2 = errorLocations.length;
        let result2 = new Int32Array(s2);
        for (let i2 = 0; i2 < s2; i2++) {
          let xiInverse = this.field.inverse(errorLocations[i2]);
          let numerator = this.field.subtract(0, errorEvaluator.evaluateAt(xiInverse));
          let denominator = this.field.inverse(formalDerivative.evaluateAt(xiInverse));
          result2[i2] = this.field.multiply(numerator, denominator);
        }
        return result2;
      }
    }
    class BoundingBox {
      constructor(image, topLeft, bottomLeft, topRight, bottomRight) {
        if (image instanceof BoundingBox) {
          this.constructor_2(image);
        } else {
          this.constructor_1(image, topLeft, bottomLeft, topRight, bottomRight);
        }
      }
      /**
       *
       * @param image
       * @param topLeft
       * @param bottomLeft
       * @param topRight
       * @param bottomRight
       *
       * @throws NotFoundException
       */
      constructor_1(image, topLeft, bottomLeft, topRight, bottomRight) {
        const leftUnspecified = topLeft == null || bottomLeft == null;
        const rightUnspecified = topRight == null || bottomRight == null;
        if (leftUnspecified && rightUnspecified) {
          throw new NotFoundException();
        }
        if (leftUnspecified) {
          topLeft = new ResultPoint(0, topRight.getY());
          bottomLeft = new ResultPoint(0, bottomRight.getY());
        } else if (rightUnspecified) {
          topRight = new ResultPoint(image.getWidth() - 1, topLeft.getY());
          bottomRight = new ResultPoint(image.getWidth() - 1, bottomLeft.getY());
        }
        this.image = image;
        this.topLeft = topLeft;
        this.bottomLeft = bottomLeft;
        this.topRight = topRight;
        this.bottomRight = bottomRight;
        this.minX = Math.trunc(Math.min(topLeft.getX(), bottomLeft.getX()));
        this.maxX = Math.trunc(Math.max(topRight.getX(), bottomRight.getX()));
        this.minY = Math.trunc(Math.min(topLeft.getY(), topRight.getY()));
        this.maxY = Math.trunc(Math.max(bottomLeft.getY(), bottomRight.getY()));
      }
      constructor_2(boundingBox) {
        this.image = boundingBox.image;
        this.topLeft = boundingBox.getTopLeft();
        this.bottomLeft = boundingBox.getBottomLeft();
        this.topRight = boundingBox.getTopRight();
        this.bottomRight = boundingBox.getBottomRight();
        this.minX = boundingBox.getMinX();
        this.maxX = boundingBox.getMaxX();
        this.minY = boundingBox.getMinY();
        this.maxY = boundingBox.getMaxY();
      }
      /**
       * @throws NotFoundException
       */
      static merge(leftBox, rightBox) {
        if (leftBox == null) {
          return rightBox;
        }
        if (rightBox == null) {
          return leftBox;
        }
        return new BoundingBox(leftBox.image, leftBox.topLeft, leftBox.bottomLeft, rightBox.topRight, rightBox.bottomRight);
      }
      /**
       * @throws NotFoundException
       */
      addMissingRows(missingStartRows, missingEndRows, isLeft) {
        let newTopLeft = this.topLeft;
        let newBottomLeft = this.bottomLeft;
        let newTopRight = this.topRight;
        let newBottomRight = this.bottomRight;
        if (missingStartRows > 0) {
          let top = isLeft ? this.topLeft : this.topRight;
          let newMinY = Math.trunc(top.getY() - missingStartRows);
          if (newMinY < 0) {
            newMinY = 0;
          }
          let newTop = new ResultPoint(top.getX(), newMinY);
          if (isLeft) {
            newTopLeft = newTop;
          } else {
            newTopRight = newTop;
          }
        }
        if (missingEndRows > 0) {
          let bottom = isLeft ? this.bottomLeft : this.bottomRight;
          let newMaxY = Math.trunc(bottom.getY() + missingEndRows);
          if (newMaxY >= this.image.getHeight()) {
            newMaxY = this.image.getHeight() - 1;
          }
          let newBottom = new ResultPoint(bottom.getX(), newMaxY);
          if (isLeft) {
            newBottomLeft = newBottom;
          } else {
            newBottomRight = newBottom;
          }
        }
        return new BoundingBox(this.image, newTopLeft, newBottomLeft, newTopRight, newBottomRight);
      }
      getMinX() {
        return this.minX;
      }
      getMaxX() {
        return this.maxX;
      }
      getMinY() {
        return this.minY;
      }
      getMaxY() {
        return this.maxY;
      }
      getTopLeft() {
        return this.topLeft;
      }
      getTopRight() {
        return this.topRight;
      }
      getBottomLeft() {
        return this.bottomLeft;
      }
      getBottomRight() {
        return this.bottomRight;
      }
    }
    class BarcodeMetadata {
      constructor(columnCount, rowCountUpperPart, rowCountLowerPart, errorCorrectionLevel) {
        this.columnCount = columnCount;
        this.errorCorrectionLevel = errorCorrectionLevel;
        this.rowCountUpperPart = rowCountUpperPart;
        this.rowCountLowerPart = rowCountLowerPart;
        this.rowCount = rowCountUpperPart + rowCountLowerPart;
      }
      getColumnCount() {
        return this.columnCount;
      }
      getErrorCorrectionLevel() {
        return this.errorCorrectionLevel;
      }
      getRowCount() {
        return this.rowCount;
      }
      getRowCountUpperPart() {
        return this.rowCountUpperPart;
      }
      getRowCountLowerPart() {
        return this.rowCountLowerPart;
      }
    }
    class Formatter {
      constructor() {
        this.buffer = "";
      }
      /**
       *
       * @see https://stackoverflow.com/a/13439711/4367683
       *
       * @param str
       * @param arr
       */
      static form(str, arr) {
        let i2 = -1;
        function callback(exp, p0, p1, p2, p3, p4) {
          if (exp === "%%")
            return "%";
          if (arr[++i2] === void 0)
            return void 0;
          exp = p2 ? parseInt(p2.substr(1)) : void 0;
          let base = p3 ? parseInt(p3.substr(1)) : void 0;
          let val;
          switch (p4) {
            case "s":
              val = arr[i2];
              break;
            case "c":
              val = arr[i2][0];
              break;
            case "f":
              val = parseFloat(arr[i2]).toFixed(exp);
              break;
            case "p":
              val = parseFloat(arr[i2]).toPrecision(exp);
              break;
            case "e":
              val = parseFloat(arr[i2]).toExponential(exp);
              break;
            case "x":
              val = parseInt(arr[i2]).toString(base ? base : 16);
              break;
            case "d":
              val = parseFloat(parseInt(arr[i2], base ? base : 10).toPrecision(exp)).toFixed(0);
              break;
          }
          val = typeof val === "object" ? JSON.stringify(val) : (+val).toString(base);
          let size = parseInt(p1);
          let ch = p1 && p1[0] + "" === "0" ? "0" : " ";
          while (val.length < size)
            val = p0 !== void 0 ? val + ch : ch + val;
          return val;
        }
        let regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
        return str.replace(regex, callback);
      }
      /**
       *
       * @param append The new string to append.
       * @param args Argumets values to be formated.
       */
      format(append2, ...args) {
        this.buffer += Formatter.form(append2, args);
      }
      /**
       * Returns the Formatter string value.
       */
      toString() {
        return this.buffer;
      }
    }
    class DetectionResultColumn {
      constructor(boundingBox) {
        this.boundingBox = new BoundingBox(boundingBox);
        this.codewords = new Array(boundingBox.getMaxY() - boundingBox.getMinY() + 1);
      }
      /*final*/
      getCodewordNearby(imageRow) {
        let codeword = this.getCodeword(imageRow);
        if (codeword != null) {
          return codeword;
        }
        for (let i2 = 1; i2 < DetectionResultColumn.MAX_NEARBY_DISTANCE; i2++) {
          let nearImageRow = this.imageRowToCodewordIndex(imageRow) - i2;
          if (nearImageRow >= 0) {
            codeword = this.codewords[nearImageRow];
            if (codeword != null) {
              return codeword;
            }
          }
          nearImageRow = this.imageRowToCodewordIndex(imageRow) + i2;
          if (nearImageRow < this.codewords.length) {
            codeword = this.codewords[nearImageRow];
            if (codeword != null) {
              return codeword;
            }
          }
        }
        return null;
      }
      /*final int*/
      imageRowToCodewordIndex(imageRow) {
        return imageRow - this.boundingBox.getMinY();
      }
      /*final void*/
      setCodeword(imageRow, codeword) {
        this.codewords[this.imageRowToCodewordIndex(imageRow)] = codeword;
      }
      /*final*/
      getCodeword(imageRow) {
        return this.codewords[this.imageRowToCodewordIndex(imageRow)];
      }
      /*final*/
      getBoundingBox() {
        return this.boundingBox;
      }
      /*final*/
      getCodewords() {
        return this.codewords;
      }
      // @Override
      toString() {
        const formatter = new Formatter();
        let row = 0;
        for (const codeword of this.codewords) {
          if (codeword == null) {
            formatter.format("%3d:    |   %n", row++);
            continue;
          }
          formatter.format("%3d: %3d|%3d%n", row++, codeword.getRowNumber(), codeword.getValue());
        }
        return formatter.toString();
      }
    }
    DetectionResultColumn.MAX_NEARBY_DISTANCE = 5;
    class BarcodeValue {
      constructor() {
        this.values = /* @__PURE__ */ new Map();
      }
      /**
       * Add an occurrence of a value
       */
      setValue(value) {
        value = Math.trunc(value);
        let confidence = this.values.get(value);
        if (confidence == null) {
          confidence = 0;
        }
        confidence++;
        this.values.set(value, confidence);
      }
      /**
       * Determines the maximum occurrence of a set value and returns all values which were set with this occurrence.
       * @return an array of int, containing the values with the highest occurrence, or null, if no value was set
       */
      getValue() {
        let maxConfidence = -1;
        let result2 = new Array();
        for (const [key, value] of this.values.entries()) {
          const entry = {
            getKey: () => key,
            getValue: () => value
          };
          if (entry.getValue() > maxConfidence) {
            maxConfidence = entry.getValue();
            result2 = [];
            result2.push(entry.getKey());
          } else if (entry.getValue() === maxConfidence) {
            result2.push(entry.getKey());
          }
        }
        return PDF417Common.toIntArray(result2);
      }
      getConfidence(value) {
        return this.values.get(value);
      }
    }
    class DetectionResultRowIndicatorColumn extends DetectionResultColumn {
      constructor(boundingBox, isLeft) {
        super(boundingBox);
        this._isLeft = isLeft;
      }
      setRowNumbers() {
        for (let codeword of this.getCodewords()) {
          if (codeword != null) {
            codeword.setRowNumberAsRowIndicatorColumn();
          }
        }
      }
      // TODO implement properly
      // TODO maybe we should add missing codewords to store the correct row number to make
      // finding row numbers for other columns easier
      // use row height count to make detection of invalid row numbers more reliable
      adjustCompleteIndicatorColumnRowNumbers(barcodeMetadata) {
        let codewords = this.getCodewords();
        this.setRowNumbers();
        this.removeIncorrectCodewords(codewords, barcodeMetadata);
        let boundingBox = this.getBoundingBox();
        let top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
        let bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
        let firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
        let lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
        let barcodeRow = -1;
        let maxRowHeight = 1;
        let currentRowHeight = 0;
        for (let codewordsRow = firstRow; codewordsRow < lastRow; codewordsRow++) {
          if (codewords[codewordsRow] == null) {
            continue;
          }
          let codeword = codewords[codewordsRow];
          let rowDifference = codeword.getRowNumber() - barcodeRow;
          if (rowDifference === 0) {
            currentRowHeight++;
          } else if (rowDifference === 1) {
            maxRowHeight = Math.max(maxRowHeight, currentRowHeight);
            currentRowHeight = 1;
            barcodeRow = codeword.getRowNumber();
          } else if (rowDifference < 0 || codeword.getRowNumber() >= barcodeMetadata.getRowCount() || rowDifference > codewordsRow) {
            codewords[codewordsRow] = null;
          } else {
            let checkedRows;
            if (maxRowHeight > 2) {
              checkedRows = (maxRowHeight - 2) * rowDifference;
            } else {
              checkedRows = rowDifference;
            }
            let closePreviousCodewordFound = checkedRows >= codewordsRow;
            for (let i2 = 1; i2 <= checkedRows && !closePreviousCodewordFound; i2++) {
              closePreviousCodewordFound = codewords[codewordsRow - i2] != null;
            }
            if (closePreviousCodewordFound) {
              codewords[codewordsRow] = null;
            } else {
              barcodeRow = codeword.getRowNumber();
              currentRowHeight = 1;
            }
          }
        }
      }
      getRowHeights() {
        let barcodeMetadata = this.getBarcodeMetadata();
        if (barcodeMetadata == null) {
          return null;
        }
        this.adjustIncompleteIndicatorColumnRowNumbers(barcodeMetadata);
        let result2 = new Int32Array(barcodeMetadata.getRowCount());
        for (let codeword of this.getCodewords()) {
          if (codeword != null) {
            let rowNumber = codeword.getRowNumber();
            if (rowNumber >= result2.length) {
              continue;
            }
            result2[rowNumber]++;
          }
        }
        return result2;
      }
      // TODO maybe we should add missing codewords to store the correct row number to make
      // finding row numbers for other columns easier
      // use row height count to make detection of invalid row numbers more reliable
      adjustIncompleteIndicatorColumnRowNumbers(barcodeMetadata) {
        let boundingBox = this.getBoundingBox();
        let top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
        let bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
        let firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
        let lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
        let codewords = this.getCodewords();
        let barcodeRow = -1;
        for (let codewordsRow = firstRow; codewordsRow < lastRow; codewordsRow++) {
          if (codewords[codewordsRow] == null) {
            continue;
          }
          let codeword = codewords[codewordsRow];
          codeword.setRowNumberAsRowIndicatorColumn();
          let rowDifference = codeword.getRowNumber() - barcodeRow;
          if (rowDifference === 0)
            ;
          else if (rowDifference === 1) {
            barcodeRow = codeword.getRowNumber();
          } else if (codeword.getRowNumber() >= barcodeMetadata.getRowCount()) {
            codewords[codewordsRow] = null;
          } else {
            barcodeRow = codeword.getRowNumber();
          }
        }
      }
      getBarcodeMetadata() {
        let codewords = this.getCodewords();
        let barcodeColumnCount = new BarcodeValue();
        let barcodeRowCountUpperPart = new BarcodeValue();
        let barcodeRowCountLowerPart = new BarcodeValue();
        let barcodeECLevel = new BarcodeValue();
        for (let codeword of codewords) {
          if (codeword == null) {
            continue;
          }
          codeword.setRowNumberAsRowIndicatorColumn();
          let rowIndicatorValue = codeword.getValue() % 30;
          let codewordRowNumber = codeword.getRowNumber();
          if (!this._isLeft) {
            codewordRowNumber += 2;
          }
          switch (codewordRowNumber % 3) {
            case 0:
              barcodeRowCountUpperPart.setValue(rowIndicatorValue * 3 + 1);
              break;
            case 1:
              barcodeECLevel.setValue(rowIndicatorValue / 3);
              barcodeRowCountLowerPart.setValue(rowIndicatorValue % 3);
              break;
            case 2:
              barcodeColumnCount.setValue(rowIndicatorValue + 1);
              break;
          }
        }
        if (barcodeColumnCount.getValue().length === 0 || barcodeRowCountUpperPart.getValue().length === 0 || barcodeRowCountLowerPart.getValue().length === 0 || barcodeECLevel.getValue().length === 0 || barcodeColumnCount.getValue()[0] < 1 || barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] < PDF417Common.MIN_ROWS_IN_BARCODE || barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] > PDF417Common.MAX_ROWS_IN_BARCODE) {
          return null;
        }
        let barcodeMetadata = new BarcodeMetadata(barcodeColumnCount.getValue()[0], barcodeRowCountUpperPart.getValue()[0], barcodeRowCountLowerPart.getValue()[0], barcodeECLevel.getValue()[0]);
        this.removeIncorrectCodewords(codewords, barcodeMetadata);
        return barcodeMetadata;
      }
      removeIncorrectCodewords(codewords, barcodeMetadata) {
        for (let codewordRow = 0; codewordRow < codewords.length; codewordRow++) {
          let codeword = codewords[codewordRow];
          if (codewords[codewordRow] == null) {
            continue;
          }
          let rowIndicatorValue = codeword.getValue() % 30;
          let codewordRowNumber = codeword.getRowNumber();
          if (codewordRowNumber > barcodeMetadata.getRowCount()) {
            codewords[codewordRow] = null;
            continue;
          }
          if (!this._isLeft) {
            codewordRowNumber += 2;
          }
          switch (codewordRowNumber % 3) {
            case 0:
              if (rowIndicatorValue * 3 + 1 !== barcodeMetadata.getRowCountUpperPart()) {
                codewords[codewordRow] = null;
              }
              break;
            case 1:
              if (Math.trunc(rowIndicatorValue / 3) !== barcodeMetadata.getErrorCorrectionLevel() || rowIndicatorValue % 3 !== barcodeMetadata.getRowCountLowerPart()) {
                codewords[codewordRow] = null;
              }
              break;
            case 2:
              if (rowIndicatorValue + 1 !== barcodeMetadata.getColumnCount()) {
                codewords[codewordRow] = null;
              }
              break;
          }
        }
      }
      isLeft() {
        return this._isLeft;
      }
      // @Override
      toString() {
        return "IsLeft: " + this._isLeft + "\n" + super.toString();
      }
    }
    class DetectionResult {
      constructor(barcodeMetadata, boundingBox) {
        this.ADJUST_ROW_NUMBER_SKIP = 2;
        this.barcodeMetadata = barcodeMetadata;
        this.barcodeColumnCount = barcodeMetadata.getColumnCount();
        this.boundingBox = boundingBox;
        this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
      }
      getDetectionResultColumns() {
        this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]);
        this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
        let unadjustedCodewordCount = PDF417Common.MAX_CODEWORDS_IN_BARCODE;
        let previousUnadjustedCount;
        do {
          previousUnadjustedCount = unadjustedCodewordCount;
          unadjustedCodewordCount = this.adjustRowNumbersAndGetCount();
        } while (unadjustedCodewordCount > 0 && unadjustedCodewordCount < previousUnadjustedCount);
        return this.detectionResultColumns;
      }
      adjustIndicatorColumnRowNumbers(detectionResultColumn) {
        if (detectionResultColumn != null) {
          detectionResultColumn.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
        }
      }
      // TODO ensure that no detected codewords with unknown row number are left
      // we should be able to estimate the row height and use it as a hint for the row number
      // we should also fill the rows top to bottom and bottom to top
      /**
       * @return number of codewords which don't have a valid row number. Note that the count is not accurate as codewords
       * will be counted several times. It just serves as an indicator to see when we can stop adjusting row numbers
       */
      adjustRowNumbersAndGetCount() {
        let unadjustedCount = this.adjustRowNumbersByRow();
        if (unadjustedCount === 0) {
          return 0;
        }
        for (let barcodeColumn = 1; barcodeColumn < this.barcodeColumnCount + 1; barcodeColumn++) {
          let codewords = this.detectionResultColumns[barcodeColumn].getCodewords();
          for (let codewordsRow = 0; codewordsRow < codewords.length; codewordsRow++) {
            if (codewords[codewordsRow] == null) {
              continue;
            }
            if (!codewords[codewordsRow].hasValidRowNumber()) {
              this.adjustRowNumbers(barcodeColumn, codewordsRow, codewords);
            }
          }
        }
        return unadjustedCount;
      }
      adjustRowNumbersByRow() {
        this.adjustRowNumbersFromBothRI();
        let unadjustedCount = this.adjustRowNumbersFromLRI();
        return unadjustedCount + this.adjustRowNumbersFromRRI();
      }
      adjustRowNumbersFromBothRI() {
        if (this.detectionResultColumns[0] == null || this.detectionResultColumns[this.barcodeColumnCount + 1] == null) {
          return;
        }
        let LRIcodewords = this.detectionResultColumns[0].getCodewords();
        let RRIcodewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
        for (let codewordsRow = 0; codewordsRow < LRIcodewords.length; codewordsRow++) {
          if (LRIcodewords[codewordsRow] != null && RRIcodewords[codewordsRow] != null && LRIcodewords[codewordsRow].getRowNumber() === RRIcodewords[codewordsRow].getRowNumber()) {
            for (let barcodeColumn = 1; barcodeColumn <= this.barcodeColumnCount; barcodeColumn++) {
              let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
              if (codeword == null) {
                continue;
              }
              codeword.setRowNumber(LRIcodewords[codewordsRow].getRowNumber());
              if (!codeword.hasValidRowNumber()) {
                this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow] = null;
              }
            }
          }
        }
      }
      adjustRowNumbersFromRRI() {
        if (this.detectionResultColumns[this.barcodeColumnCount + 1] == null) {
          return 0;
        }
        let unadjustedCount = 0;
        let codewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
        for (let codewordsRow = 0; codewordsRow < codewords.length; codewordsRow++) {
          if (codewords[codewordsRow] == null) {
            continue;
          }
          let rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
          let invalidRowCounts = 0;
          for (let barcodeColumn = this.barcodeColumnCount + 1; barcodeColumn > 0 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn--) {
            let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
            if (codeword != null) {
              invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
              if (!codeword.hasValidRowNumber()) {
                unadjustedCount++;
              }
            }
          }
        }
        return unadjustedCount;
      }
      adjustRowNumbersFromLRI() {
        if (this.detectionResultColumns[0] == null) {
          return 0;
        }
        let unadjustedCount = 0;
        let codewords = this.detectionResultColumns[0].getCodewords();
        for (let codewordsRow = 0; codewordsRow < codewords.length; codewordsRow++) {
          if (codewords[codewordsRow] == null) {
            continue;
          }
          let rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
          let invalidRowCounts = 0;
          for (let barcodeColumn = 1; barcodeColumn < this.barcodeColumnCount + 1 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn++) {
            let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
            if (codeword != null) {
              invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
              if (!codeword.hasValidRowNumber()) {
                unadjustedCount++;
              }
            }
          }
        }
        return unadjustedCount;
      }
      static adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword) {
        if (codeword == null) {
          return invalidRowCounts;
        }
        if (!codeword.hasValidRowNumber()) {
          if (codeword.isValidRowNumber(rowIndicatorRowNumber)) {
            codeword.setRowNumber(rowIndicatorRowNumber);
            invalidRowCounts = 0;
          } else {
            ++invalidRowCounts;
          }
        }
        return invalidRowCounts;
      }
      adjustRowNumbers(barcodeColumn, codewordsRow, codewords) {
        if (!this.detectionResultColumns[barcodeColumn - 1]) {
          return;
        }
        let codeword = codewords[codewordsRow];
        let previousColumnCodewords = this.detectionResultColumns[barcodeColumn - 1].getCodewords();
        let nextColumnCodewords = previousColumnCodewords;
        if (this.detectionResultColumns[barcodeColumn + 1] != null) {
          nextColumnCodewords = this.detectionResultColumns[barcodeColumn + 1].getCodewords();
        }
        let otherCodewords = new Array(14);
        otherCodewords[2] = previousColumnCodewords[codewordsRow];
        otherCodewords[3] = nextColumnCodewords[codewordsRow];
        if (codewordsRow > 0) {
          otherCodewords[0] = codewords[codewordsRow - 1];
          otherCodewords[4] = previousColumnCodewords[codewordsRow - 1];
          otherCodewords[5] = nextColumnCodewords[codewordsRow - 1];
        }
        if (codewordsRow > 1) {
          otherCodewords[8] = codewords[codewordsRow - 2];
          otherCodewords[10] = previousColumnCodewords[codewordsRow - 2];
          otherCodewords[11] = nextColumnCodewords[codewordsRow - 2];
        }
        if (codewordsRow < codewords.length - 1) {
          otherCodewords[1] = codewords[codewordsRow + 1];
          otherCodewords[6] = previousColumnCodewords[codewordsRow + 1];
          otherCodewords[7] = nextColumnCodewords[codewordsRow + 1];
        }
        if (codewordsRow < codewords.length - 2) {
          otherCodewords[9] = codewords[codewordsRow + 2];
          otherCodewords[12] = previousColumnCodewords[codewordsRow + 2];
          otherCodewords[13] = nextColumnCodewords[codewordsRow + 2];
        }
        for (let otherCodeword of otherCodewords) {
          if (DetectionResult.adjustRowNumber(codeword, otherCodeword)) {
            return;
          }
        }
      }
      /**
       * @return true, if row number was adjusted, false otherwise
       */
      static adjustRowNumber(codeword, otherCodeword) {
        if (otherCodeword == null) {
          return false;
        }
        if (otherCodeword.hasValidRowNumber() && otherCodeword.getBucket() === codeword.getBucket()) {
          codeword.setRowNumber(otherCodeword.getRowNumber());
          return true;
        }
        return false;
      }
      getBarcodeColumnCount() {
        return this.barcodeColumnCount;
      }
      getBarcodeRowCount() {
        return this.barcodeMetadata.getRowCount();
      }
      getBarcodeECLevel() {
        return this.barcodeMetadata.getErrorCorrectionLevel();
      }
      setBoundingBox(boundingBox) {
        this.boundingBox = boundingBox;
      }
      getBoundingBox() {
        return this.boundingBox;
      }
      setDetectionResultColumn(barcodeColumn, detectionResultColumn) {
        this.detectionResultColumns[barcodeColumn] = detectionResultColumn;
      }
      getDetectionResultColumn(barcodeColumn) {
        return this.detectionResultColumns[barcodeColumn];
      }
      // @Override
      toString() {
        let rowIndicatorColumn = this.detectionResultColumns[0];
        if (rowIndicatorColumn == null) {
          rowIndicatorColumn = this.detectionResultColumns[this.barcodeColumnCount + 1];
        }
        let formatter = new Formatter();
        for (let codewordsRow = 0; codewordsRow < rowIndicatorColumn.getCodewords().length; codewordsRow++) {
          formatter.format("CW %3d:", codewordsRow);
          for (let barcodeColumn = 0; barcodeColumn < this.barcodeColumnCount + 2; barcodeColumn++) {
            if (this.detectionResultColumns[barcodeColumn] == null) {
              formatter.format("    |   ");
              continue;
            }
            let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
            if (codeword == null) {
              formatter.format("    |   ");
              continue;
            }
            formatter.format(" %3d|%3d", codeword.getRowNumber(), codeword.getValue());
          }
          formatter.format("%n");
        }
        return formatter.toString();
      }
    }
    class Codeword {
      constructor(startX, endX, bucket, value) {
        this.rowNumber = Codeword.BARCODE_ROW_UNKNOWN;
        this.startX = Math.trunc(startX);
        this.endX = Math.trunc(endX);
        this.bucket = Math.trunc(bucket);
        this.value = Math.trunc(value);
      }
      hasValidRowNumber() {
        return this.isValidRowNumber(this.rowNumber);
      }
      isValidRowNumber(rowNumber) {
        return rowNumber !== Codeword.BARCODE_ROW_UNKNOWN && this.bucket === rowNumber % 3 * 3;
      }
      setRowNumberAsRowIndicatorColumn() {
        this.rowNumber = Math.trunc(Math.trunc(this.value / 30) * 3 + Math.trunc(this.bucket / 3));
      }
      getWidth() {
        return this.endX - this.startX;
      }
      getStartX() {
        return this.startX;
      }
      getEndX() {
        return this.endX;
      }
      getBucket() {
        return this.bucket;
      }
      getValue() {
        return this.value;
      }
      getRowNumber() {
        return this.rowNumber;
      }
      setRowNumber(rowNumber) {
        this.rowNumber = rowNumber;
      }
      //   @Override
      toString() {
        return this.rowNumber + "|" + this.value;
      }
    }
    Codeword.BARCODE_ROW_UNKNOWN = -1;
    class PDF417CodewordDecoder {
      /* @note
       * this action have to be performed before first use of class
       * - static constructor
       * working with 32bit float (based from Java logic)
      */
      static initialize() {
        for (let i2 = 0; i2 < PDF417Common.SYMBOL_TABLE.length; i2++) {
          let currentSymbol = PDF417Common.SYMBOL_TABLE[i2];
          let currentBit = currentSymbol & 1;
          for (let j = 0; j < PDF417Common.BARS_IN_MODULE; j++) {
            let size = 0;
            while ((currentSymbol & 1) === currentBit) {
              size += 1;
              currentSymbol >>= 1;
            }
            currentBit = currentSymbol & 1;
            if (!PDF417CodewordDecoder.RATIOS_TABLE[i2]) {
              PDF417CodewordDecoder.RATIOS_TABLE[i2] = new Array(PDF417Common.BARS_IN_MODULE);
            }
            PDF417CodewordDecoder.RATIOS_TABLE[i2][PDF417Common.BARS_IN_MODULE - j - 1] = Math.fround(size / PDF417Common.MODULES_IN_CODEWORD);
          }
        }
        this.bSymbolTableReady = true;
      }
      static getDecodedValue(moduleBitCount) {
        let decodedValue = PDF417CodewordDecoder.getDecodedCodewordValue(PDF417CodewordDecoder.sampleBitCounts(moduleBitCount));
        if (decodedValue !== -1) {
          return decodedValue;
        }
        return PDF417CodewordDecoder.getClosestDecodedValue(moduleBitCount);
      }
      static sampleBitCounts(moduleBitCount) {
        let bitCountSum = MathUtils2.sum(moduleBitCount);
        let result2 = new Int32Array(PDF417Common.BARS_IN_MODULE);
        let bitCountIndex = 0;
        let sumPreviousBits = 0;
        for (let i2 = 0; i2 < PDF417Common.MODULES_IN_CODEWORD; i2++) {
          let sampleIndex = bitCountSum / (2 * PDF417Common.MODULES_IN_CODEWORD) + i2 * bitCountSum / PDF417Common.MODULES_IN_CODEWORD;
          if (sumPreviousBits + moduleBitCount[bitCountIndex] <= sampleIndex) {
            sumPreviousBits += moduleBitCount[bitCountIndex];
            bitCountIndex++;
          }
          result2[bitCountIndex]++;
        }
        return result2;
      }
      static getDecodedCodewordValue(moduleBitCount) {
        let decodedValue = PDF417CodewordDecoder.getBitValue(moduleBitCount);
        return PDF417Common.getCodeword(decodedValue) === -1 ? -1 : decodedValue;
      }
      static getBitValue(moduleBitCount) {
        let result2 = (
          /*long*/
          0
        );
        for (let i2 = 0; i2 < moduleBitCount.length; i2++) {
          for (let bit = 0; bit < moduleBitCount[i2]; bit++) {
            result2 = result2 << 1 | (i2 % 2 === 0 ? 1 : 0);
          }
        }
        return Math.trunc(result2);
      }
      // working with 32bit float (as in Java)
      static getClosestDecodedValue(moduleBitCount) {
        let bitCountSum = MathUtils2.sum(moduleBitCount);
        let bitCountRatios = new Array(PDF417Common.BARS_IN_MODULE);
        if (bitCountSum > 1) {
          for (let i2 = 0; i2 < bitCountRatios.length; i2++) {
            bitCountRatios[i2] = Math.fround(moduleBitCount[i2] / bitCountSum);
          }
        }
        let bestMatchError = Float.MAX_VALUE;
        let bestMatch = -1;
        if (!this.bSymbolTableReady) {
          PDF417CodewordDecoder.initialize();
        }
        for (let j = 0; j < PDF417CodewordDecoder.RATIOS_TABLE.length; j++) {
          let error2 = 0;
          let ratioTableRow = PDF417CodewordDecoder.RATIOS_TABLE[j];
          for (let k = 0; k < PDF417Common.BARS_IN_MODULE; k++) {
            let diff = Math.fround(ratioTableRow[k] - bitCountRatios[k]);
            error2 += Math.fround(diff * diff);
            if (error2 >= bestMatchError) {
              break;
            }
          }
          if (error2 < bestMatchError) {
            bestMatchError = error2;
            bestMatch = PDF417Common.SYMBOL_TABLE[j];
          }
        }
        return bestMatch;
      }
    }
    PDF417CodewordDecoder.bSymbolTableReady = false;
    PDF417CodewordDecoder.RATIOS_TABLE = new Array(PDF417Common.SYMBOL_TABLE.length).map((x2) => new Array(PDF417Common.BARS_IN_MODULE));
    class PDF417ResultMetadata {
      constructor() {
        this.segmentCount = -1;
        this.fileSize = -1;
        this.timestamp = -1;
        this.checksum = -1;
      }
      /**
       * The Segment ID represents the segment of the whole file distributed over different symbols.
       *
       * @return File segment index
       */
      getSegmentIndex() {
        return this.segmentIndex;
      }
      setSegmentIndex(segmentIndex) {
        this.segmentIndex = segmentIndex;
      }
      /**
       * Is the same for each related PDF417 symbol
       *
       * @return File ID
       */
      getFileId() {
        return this.fileId;
      }
      setFileId(fileId) {
        this.fileId = fileId;
      }
      /**
       * @return always null
       * @deprecated use dedicated already parsed fields
       */
      //   @Deprecated
      getOptionalData() {
        return this.optionalData;
      }
      /**
       * @param optionalData old optional data format as int array
       * @deprecated parse and use new fields
       */
      //   @Deprecated
      setOptionalData(optionalData) {
        this.optionalData = optionalData;
      }
      /**
       * @return true if it is the last segment
       */
      isLastSegment() {
        return this.lastSegment;
      }
      setLastSegment(lastSegment) {
        this.lastSegment = lastSegment;
      }
      /**
       * @return count of segments, -1 if not set
       */
      getSegmentCount() {
        return this.segmentCount;
      }
      setSegmentCount(segmentCount) {
        this.segmentCount = segmentCount;
      }
      getSender() {
        return this.sender || null;
      }
      setSender(sender) {
        this.sender = sender;
      }
      getAddressee() {
        return this.addressee || null;
      }
      setAddressee(addressee) {
        this.addressee = addressee;
      }
      /**
       * Filename of the encoded file
       *
       * @return filename
       */
      getFileName() {
        return this.fileName;
      }
      setFileName(fileName) {
        this.fileName = fileName;
      }
      /**
       * filesize in bytes of the encoded file
       *
       * @return filesize in bytes, -1 if not set
       */
      getFileSize() {
        return this.fileSize;
      }
      setFileSize(fileSize) {
        this.fileSize = fileSize;
      }
      /**
       * 16-bit CRC checksum using CCITT-16
       *
       * @return crc checksum, -1 if not set
       */
      getChecksum() {
        return this.checksum;
      }
      setChecksum(checksum) {
        this.checksum = checksum;
      }
      /**
       * unix epock timestamp, elapsed seconds since 1970-01-01
       *
       * @return elapsed seconds, -1 if not set
       */
      getTimestamp() {
        return this.timestamp;
      }
      setTimestamp(timestamp) {
        this.timestamp = timestamp;
      }
    }
    class Long {
      /**
       * Parses a string to a number, since JS has no really Int64.
       *
       * @param num Numeric string.
       * @param radix Destination radix.
       */
      static parseLong(num, radix = void 0) {
        return parseInt(num, radix);
      }
    }
    class NullPointerException extends Exception {
    }
    NullPointerException.kind = "NullPointerException";
    class OutputStream {
      /**
       * Writes <code>b.length</code> bytes from the specified byte array
       * to this output stream. The general contract for <code>write(b)</code>
       * is that it should have exactly the same effect as the call
       * <code>write(b, 0, b.length)</code>.
       *
       * @param      b   the data.
       * @exception  IOException  if an I/O error occurs.
       * @see        java.io.OutputStream#write(byte[], int, int)
       */
      writeBytes(b) {
        this.writeBytesOffset(b, 0, b.length);
      }
      /**
       * Writes <code>len</code> bytes from the specified byte array
       * starting at offset <code>off</code> to this output stream.
       * The general contract for <code>write(b, off, len)</code> is that
       * some of the bytes in the array <code>b</code> are written to the
       * output stream in order; element <code>b[off]</code> is the first
       * byte written and <code>b[off+len-1]</code> is the last byte written
       * by this operation.
       * <p>
       * The <code>write</code> method of <code>OutputStream</code> calls
       * the write method of one argument on each of the bytes to be
       * written out. Subclasses are encouraged to override this method and
       * provide a more efficient implementation.
       * <p>
       * If <code>b</code> is <code>null</code>, a
       * <code>NullPointerException</code> is thrown.
       * <p>
       * If <code>off</code> is negative, or <code>len</code> is negative, or
       * <code>off+len</code> is greater than the length of the array
       * <code>b</code>, then an <tt>IndexOutOfBoundsException</tt> is thrown.
       *
       * @param      b     the data.
       * @param      off   the start offset in the data.
       * @param      len   the number of bytes to write.
       * @exception  IOException  if an I/O error occurs. In particular,
       *             an <code>IOException</code> is thrown if the output
       *             stream is closed.
       */
      writeBytesOffset(b, off2, len) {
        if (b == null) {
          throw new NullPointerException();
        } else if (off2 < 0 || off2 > b.length || len < 0 || off2 + len > b.length || off2 + len < 0) {
          throw new IndexOutOfBoundsException();
        } else if (len === 0) {
          return;
        }
        for (let i2 = 0; i2 < len; i2++) {
          this.write(b[off2 + i2]);
        }
      }
      /**
       * Flushes this output stream and forces any buffered output bytes
       * to be written out. The general contract of <code>flush</code> is
       * that calling it is an indication that, if any bytes previously
       * written have been buffered by the implementation of the output
       * stream, such bytes should immediately be written to their
       * intended destination.
       * <p>
       * If the intended destination of this stream is an abstraction provided by
       * the underlying operating system, for example a file, then flushing the
       * stream guarantees only that bytes previously written to the stream are
       * passed to the operating system for writing; it does not guarantee that
       * they are actually written to a physical device such as a disk drive.
       * <p>
       * The <code>flush</code> method of <code>OutputStream</code> does nothing.
       *
       * @exception  IOException  if an I/O error occurs.
       */
      flush() {
      }
      /**
       * Closes this output stream and releases any system resources
       * associated with this stream. The general contract of <code>close</code>
       * is that it closes the output stream. A closed stream cannot perform
       * output operations and cannot be reopened.
       * <p>
       * The <code>close</code> method of <code>OutputStream</code> does nothing.
       *
       * @exception  IOException  if an I/O error occurs.
       */
      close() {
      }
    }
    class OutOfMemoryError extends Exception {
    }
    class ByteArrayOutputStream extends OutputStream {
      /**
       * Creates a new byte array output stream. The buffer capacity is
       * initially 32 bytes, though its size increases if necessary.
       */
      // public constructor() {
      //     this(32);
      // }
      /**
       * Creates a new byte array output stream, with a buffer capacity of
       * the specified size, in bytes.
       *
       * @param   size   the initial size.
       * @exception  IllegalArgumentException if size is negative.
       */
      constructor(size = 32) {
        super();
        this.count = 0;
        if (size < 0) {
          throw new IllegalArgumentException("Negative initial size: " + size);
        }
        this.buf = new Uint8Array(size);
      }
      /**
       * Increases the capacity if necessary to ensure that it can hold
       * at least the number of elements specified by the minimum
       * capacity argument.
       *
       * @param minCapacity the desired minimum capacity
       * @throws OutOfMemoryError if {@code minCapacity < 0}.  This is
       * interpreted as a request for the unsatisfiably large capacity
       * {@code (long) Integer.MAX_VALUE + (minCapacity - Integer.MAX_VALUE)}.
       */
      ensureCapacity(minCapacity) {
        if (minCapacity - this.buf.length > 0)
          this.grow(minCapacity);
      }
      /**
       * Increases the capacity to ensure that it can hold at least the
       * number of elements specified by the minimum capacity argument.
       *
       * @param minCapacity the desired minimum capacity
       */
      grow(minCapacity) {
        let oldCapacity = this.buf.length;
        let newCapacity = oldCapacity << 1;
        if (newCapacity - minCapacity < 0)
          newCapacity = minCapacity;
        if (newCapacity < 0) {
          if (minCapacity < 0)
            throw new OutOfMemoryError();
          newCapacity = Integer.MAX_VALUE;
        }
        this.buf = Arrays.copyOfUint8Array(this.buf, newCapacity);
      }
      /**
       * Writes the specified byte to this byte array output stream.
       *
       * @param   b   the byte to be written.
       */
      write(b) {
        this.ensureCapacity(this.count + 1);
        this.buf[this.count] = /*(byte)*/
        b;
        this.count += 1;
      }
      /**
       * Writes <code>len</code> bytes from the specified byte array
       * starting at offset <code>off</code> to this byte array output stream.
       *
       * @param   b     the data.
       * @param   off   the start offset in the data.
       * @param   len   the number of bytes to write.
       */
      writeBytesOffset(b, off2, len) {
        if (off2 < 0 || off2 > b.length || len < 0 || off2 + len - b.length > 0) {
          throw new IndexOutOfBoundsException();
        }
        this.ensureCapacity(this.count + len);
        System.arraycopy(b, off2, this.buf, this.count, len);
        this.count += len;
      }
      /**
       * Writes the complete contents of this byte array output stream to
       * the specified output stream argument, as if by calling the output
       * stream's write method using <code>out.write(buf, 0, count)</code>.
       *
       * @param      out   the output stream to which to write the data.
       * @exception  IOException  if an I/O error occurs.
       */
      writeTo(out) {
        out.writeBytesOffset(this.buf, 0, this.count);
      }
      /**
       * Resets the <code>count</code> field of this byte array output
       * stream to zero, so that all currently accumulated output in the
       * output stream is discarded. The output stream can be used again,
       * reusing the already allocated buffer space.
       *
       * @see     java.io.ByteArrayInputStream#count
       */
      reset() {
        this.count = 0;
      }
      /**
       * Creates a newly allocated byte array. Its size is the current
       * size of this output stream and the valid contents of the buffer
       * have been copied into it.
       *
       * @return  the current contents of this output stream, as a byte array.
       * @see     java.io.ByteArrayOutputStream#size()
       */
      toByteArray() {
        return Arrays.copyOfUint8Array(this.buf, this.count);
      }
      /**
       * Returns the current size of the buffer.
       *
       * @return  the value of the <code>count</code> field, which is the number
       *          of valid bytes in this output stream.
       * @see     java.io.ByteArrayOutputStream#count
       */
      size() {
        return this.count;
      }
      toString(param) {
        if (!param) {
          return this.toString_void();
        }
        if (typeof param === "string") {
          return this.toString_string(param);
        }
        return this.toString_number(param);
      }
      /**
       * Converts the buffer's contents into a string decoding bytes using the
       * platform's default character set. The length of the new <tt>String</tt>
       * is a function of the character set, and hence may not be equal to the
       * size of the buffer.
       *
       * <p> This method always replaces malformed-input and unmappable-character
       * sequences with the default replacement string for the platform's
       * default character set. The {@linkplain java.nio.charset.CharsetDecoder}
       * class should be used when more control over the decoding process is
       * required.
       *
       * @return String decoded from the buffer's contents.
       * @since  JDK1.1
       */
      toString_void() {
        return new String(
          this.buf
          /*, 0, this.count*/
        ).toString();
      }
      /**
       * Converts the buffer's contents into a string by decoding the bytes using
       * the specified {@link java.nio.charset.Charset charsetName}. The length of
       * the new <tt>String</tt> is a function of the charset, and hence may not be
       * equal to the length of the byte array.
       *
       * <p> This method always replaces malformed-input and unmappable-character
       * sequences with this charset's default replacement string. The {@link
       * java.nio.charset.CharsetDecoder} class should be used when more control
       * over the decoding process is required.
       *
       * @param  charsetName  the name of a supported
       *              {@linkplain java.nio.charset.Charset </code>charset<code>}
       * @return String decoded from the buffer's contents.
       * @exception  UnsupportedEncodingException
       *             If the named charset is not supported
       * @since   JDK1.1
       */
      toString_string(charsetName) {
        return new String(
          this.buf
          /*, 0, this.count, charsetName*/
        ).toString();
      }
      /**
       * Creates a newly allocated string. Its size is the current size of
       * the output stream and the valid contents of the buffer have been
       * copied into it. Each character <i>c</i> in the resulting string is
       * constructed from the corresponding element <i>b</i> in the byte
       * array such that:
       * <blockquote><pre>
       *     c == (char)(((hibyte &amp; 0xff) &lt;&lt; 8) | (b &amp; 0xff))
       * </pre></blockquote>
       *
       * @deprecated This method does not properly convert bytes into characters.
       * As of JDK&nbsp;1.1, the preferred way to do this is via the
       * <code>toString(String enc)</code> method, which takes an encoding-name
       * argument, or the <code>toString()</code> method, which uses the
       * platform's default character encoding.
       *
       * @param      hibyte    the high byte of each resulting Unicode character.
       * @return     the current contents of the output stream, as a string.
       * @see        java.io.ByteArrayOutputStream#size()
       * @see        java.io.ByteArrayOutputStream#toString(String)
       * @see        java.io.ByteArrayOutputStream#toString()
       */
      // @Deprecated
      toString_number(hibyte) {
        return new String(
          this.buf
          /*, hibyte, 0, this.count*/
        ).toString();
      }
      /**
       * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
       * this class can be called after the stream has been closed without
       * generating an <tt>IOException</tt>.
       * <p>
       *
       * @throws IOException
       */
      close() {
      }
    }
    var Mode$2;
    (function(Mode2) {
      Mode2[Mode2["ALPHA"] = 0] = "ALPHA";
      Mode2[Mode2["LOWER"] = 1] = "LOWER";
      Mode2[Mode2["MIXED"] = 2] = "MIXED";
      Mode2[Mode2["PUNCT"] = 3] = "PUNCT";
      Mode2[Mode2["ALPHA_SHIFT"] = 4] = "ALPHA_SHIFT";
      Mode2[Mode2["PUNCT_SHIFT"] = 5] = "PUNCT_SHIFT";
    })(Mode$2 || (Mode$2 = {}));
    function getBigIntConstructor() {
      if (typeof window !== "undefined") {
        return window["BigInt"] || null;
      }
      if (typeof commonjsGlobal !== "undefined") {
        return commonjsGlobal["BigInt"] || null;
      }
      if (typeof self !== "undefined") {
        return self["BigInt"] || null;
      }
      throw new Error("Can't search globals for BigInt!");
    }
    let BigInteger;
    function createBigInt(num) {
      if (typeof BigInteger === "undefined") {
        BigInteger = getBigIntConstructor();
      }
      if (BigInteger === null) {
        throw new Error("BigInt is not supported!");
      }
      return BigInteger(num);
    }
    function getEXP900() {
      let EXP900 = [];
      EXP900[0] = createBigInt(1);
      let nineHundred = createBigInt(900);
      EXP900[1] = nineHundred;
      for (let i2 = 2; i2 < 16; i2++) {
        EXP900[i2] = EXP900[i2 - 1] * nineHundred;
      }
      return EXP900;
    }
    class DecodedBitStreamParser$2 {
      //   private DecodedBitStreamParser() {
      // }
      /**
       *
       * @param codewords
       * @param ecLevel
       *
       * @throws FormatException
       */
      static decode(codewords, ecLevel) {
        let result2 = new StringBuilder("");
        let encoding = CharacterSetECI.ISO8859_1;
        result2.enableDecoding(encoding);
        let codeIndex = 1;
        let code = codewords[codeIndex++];
        let resultMetadata = new PDF417ResultMetadata();
        while (codeIndex < codewords[0]) {
          switch (code) {
            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
              codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, result2);
              break;
            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
              codeIndex = DecodedBitStreamParser$2.byteCompaction(code, codewords, encoding, codeIndex, result2);
              break;
            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
              result2.append(
                /*(char)*/
                codewords[codeIndex++]
              );
              break;
            case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
              codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex, result2);
              break;
            case DecodedBitStreamParser$2.ECI_CHARSET:
              CharacterSetECI.getCharacterSetECIByValue(codewords[codeIndex++]);
              break;
            case DecodedBitStreamParser$2.ECI_GENERAL_PURPOSE:
              codeIndex += 2;
              break;
            case DecodedBitStreamParser$2.ECI_USER_DEFINED:
              codeIndex++;
              break;
            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
              codeIndex = DecodedBitStreamParser$2.decodeMacroBlock(codewords, codeIndex, resultMetadata);
              break;
            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
            case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
              throw new FormatException();
            default:
              codeIndex--;
              codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, result2);
              break;
          }
          if (codeIndex < codewords.length) {
            code = codewords[codeIndex++];
          } else {
            throw FormatException.getFormatInstance();
          }
        }
        if (result2.length() === 0) {
          throw FormatException.getFormatInstance();
        }
        let decoderResult = new DecoderResult(null, result2.toString(), null, ecLevel);
        decoderResult.setOther(resultMetadata);
        return decoderResult;
      }
      /**
       *
       * @param int
       * @param param1
       * @param codewords
       * @param int
       * @param codeIndex
       * @param PDF417ResultMetadata
       * @param resultMetadata
       *
       * @throws FormatException
       */
      // @SuppressWarnings("deprecation")
      static decodeMacroBlock(codewords, codeIndex, resultMetadata) {
        if (codeIndex + DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS > codewords[0]) {
          throw FormatException.getFormatInstance();
        }
        let segmentIndexArray = new Int32Array(DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS);
        for (let i2 = 0; i2 < DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS; i2++, codeIndex++) {
          segmentIndexArray[i2] = codewords[codeIndex];
        }
        resultMetadata.setSegmentIndex(Integer.parseInt(DecodedBitStreamParser$2.decodeBase900toBase10(segmentIndexArray, DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS)));
        let fileId = new StringBuilder();
        codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, fileId);
        resultMetadata.setFileId(fileId.toString());
        let optionalFieldsStart = -1;
        if (codewords[codeIndex] === DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD) {
          optionalFieldsStart = codeIndex + 1;
        }
        while (codeIndex < codewords[0]) {
          switch (codewords[codeIndex]) {
            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
              codeIndex++;
              switch (codewords[codeIndex]) {
                case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                  let fileName = new StringBuilder();
                  codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, fileName);
                  resultMetadata.setFileName(fileName.toString());
                  break;
                case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                  let sender = new StringBuilder();
                  codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, sender);
                  resultMetadata.setSender(sender.toString());
                  break;
                case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                  let addressee = new StringBuilder();
                  codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, addressee);
                  resultMetadata.setAddressee(addressee.toString());
                  break;
                case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                  let segmentCount = new StringBuilder();
                  codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, segmentCount);
                  resultMetadata.setSegmentCount(Integer.parseInt(segmentCount.toString()));
                  break;
                case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                  let timestamp = new StringBuilder();
                  codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, timestamp);
                  resultMetadata.setTimestamp(Long.parseLong(timestamp.toString()));
                  break;
                case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                  let checksum = new StringBuilder();
                  codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, checksum);
                  resultMetadata.setChecksum(Integer.parseInt(checksum.toString()));
                  break;
                case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                  let fileSize = new StringBuilder();
                  codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, fileSize);
                  resultMetadata.setFileSize(Long.parseLong(fileSize.toString()));
                  break;
                default:
                  throw FormatException.getFormatInstance();
              }
              break;
            case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
              codeIndex++;
              resultMetadata.setLastSegment(true);
              break;
            default:
              throw FormatException.getFormatInstance();
          }
        }
        if (optionalFieldsStart !== -1) {
          let optionalFieldsLength = codeIndex - optionalFieldsStart;
          if (resultMetadata.isLastSegment()) {
            optionalFieldsLength--;
          }
          resultMetadata.setOptionalData(Arrays.copyOfRange(codewords, optionalFieldsStart, optionalFieldsStart + optionalFieldsLength));
        }
        return codeIndex;
      }
      /**
       * Text Compaction mode (see 5.4.1.5) permits all printable ASCII characters to be
       * encoded, i.e. values 32 - 126 inclusive in accordance with ISO/IEC 646 (IRV), as
       * well as selected control characters.
       *
       * @param codewords The array of codewords (data + error)
       * @param codeIndex The current index into the codeword array.
       * @param result    The decoded data is appended to the result.
       * @return The next index into the codeword array.
       */
      static textCompaction(codewords, codeIndex, result2) {
        let textCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
        let byteCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
        let index2 = 0;
        let end = false;
        while (codeIndex < codewords[0] && !end) {
          let code = codewords[codeIndex++];
          if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
            textCompactionData[index2] = code / 30;
            textCompactionData[index2 + 1] = code % 30;
            index2 += 2;
          } else {
            switch (code) {
              case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                textCompactionData[index2++] = DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH;
                break;
              case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
              case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
              case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
              case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
              case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
              case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                codeIndex--;
                end = true;
                break;
              case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                textCompactionData[index2] = DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE;
                code = codewords[codeIndex++];
                byteCompactionData[index2] = code;
                index2++;
                break;
            }
          }
        }
        DecodedBitStreamParser$2.decodeTextCompaction(textCompactionData, byteCompactionData, index2, result2);
        return codeIndex;
      }
      /**
       * The Text Compaction mode includes all the printable ASCII characters
       * (i.e. values from 32 to 126) and three ASCII control characters: HT or tab
       * (9: e), LF or line feed (10: e), and CR or carriage
       * return (13: e). The Text Compaction mode also includes various latch
       * and shift characters which are used exclusively within the mode. The Text
       * Compaction mode encodes up to 2 characters per codeword. The compaction rules
       * for converting data into PDF417 codewords are defined in 5.4.2.2. The sub-mode
       * switches are defined in 5.4.2.3.
       *
       * @param textCompactionData The text compaction data.
       * @param byteCompactionData The byte compaction data if there
       *                           was a mode shift.
       * @param length             The size of the text compaction and byte compaction data.
       * @param result             The decoded data is appended to the result.
       */
      static decodeTextCompaction(textCompactionData, byteCompactionData, length, result2) {
        let subMode = Mode$2.ALPHA;
        let priorToShiftMode = Mode$2.ALPHA;
        let i2 = 0;
        while (i2 < length) {
          let subModeCh = textCompactionData[i2];
          let ch = (
            /*char*/
            ""
          );
          switch (subMode) {
            case Mode$2.ALPHA:
              if (subModeCh < 26) {
                ch = /*(char)('A' + subModeCh) */
                String.fromCharCode(65 + subModeCh);
              } else {
                switch (subModeCh) {
                  case 26:
                    ch = " ";
                    break;
                  case DecodedBitStreamParser$2.LL:
                    subMode = Mode$2.LOWER;
                    break;
                  case DecodedBitStreamParser$2.ML:
                    subMode = Mode$2.MIXED;
                    break;
                  case DecodedBitStreamParser$2.PS:
                    priorToShiftMode = subMode;
                    subMode = Mode$2.PUNCT_SHIFT;
                    break;
                  case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    result2.append(
                      /*(char)*/
                      byteCompactionData[i2]
                    );
                    break;
                  case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                    subMode = Mode$2.ALPHA;
                    break;
                }
              }
              break;
            case Mode$2.LOWER:
              if (subModeCh < 26) {
                ch = /*(char)('a' + subModeCh)*/
                String.fromCharCode(97 + subModeCh);
              } else {
                switch (subModeCh) {
                  case 26:
                    ch = " ";
                    break;
                  case DecodedBitStreamParser$2.AS:
                    priorToShiftMode = subMode;
                    subMode = Mode$2.ALPHA_SHIFT;
                    break;
                  case DecodedBitStreamParser$2.ML:
                    subMode = Mode$2.MIXED;
                    break;
                  case DecodedBitStreamParser$2.PS:
                    priorToShiftMode = subMode;
                    subMode = Mode$2.PUNCT_SHIFT;
                    break;
                  case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    result2.append(
                      /*(char)*/
                      byteCompactionData[i2]
                    );
                    break;
                  case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                    subMode = Mode$2.ALPHA;
                    break;
                }
              }
              break;
            case Mode$2.MIXED:
              if (subModeCh < DecodedBitStreamParser$2.PL) {
                ch = DecodedBitStreamParser$2.MIXED_CHARS[subModeCh];
              } else {
                switch (subModeCh) {
                  case DecodedBitStreamParser$2.PL:
                    subMode = Mode$2.PUNCT;
                    break;
                  case 26:
                    ch = " ";
                    break;
                  case DecodedBitStreamParser$2.LL:
                    subMode = Mode$2.LOWER;
                    break;
                  case DecodedBitStreamParser$2.AL:
                    subMode = Mode$2.ALPHA;
                    break;
                  case DecodedBitStreamParser$2.PS:
                    priorToShiftMode = subMode;
                    subMode = Mode$2.PUNCT_SHIFT;
                    break;
                  case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    result2.append(
                      /*(char)*/
                      byteCompactionData[i2]
                    );
                    break;
                  case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                    subMode = Mode$2.ALPHA;
                    break;
                }
              }
              break;
            case Mode$2.PUNCT:
              if (subModeCh < DecodedBitStreamParser$2.PAL) {
                ch = DecodedBitStreamParser$2.PUNCT_CHARS[subModeCh];
              } else {
                switch (subModeCh) {
                  case DecodedBitStreamParser$2.PAL:
                    subMode = Mode$2.ALPHA;
                    break;
                  case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    result2.append(
                      /*(char)*/
                      byteCompactionData[i2]
                    );
                    break;
                  case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                    subMode = Mode$2.ALPHA;
                    break;
                }
              }
              break;
            case Mode$2.ALPHA_SHIFT:
              subMode = priorToShiftMode;
              if (subModeCh < 26) {
                ch = /*(char)('A' + subModeCh)*/
                String.fromCharCode(65 + subModeCh);
              } else {
                switch (subModeCh) {
                  case 26:
                    ch = " ";
                    break;
                  case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                    subMode = Mode$2.ALPHA;
                    break;
                }
              }
              break;
            case Mode$2.PUNCT_SHIFT:
              subMode = priorToShiftMode;
              if (subModeCh < DecodedBitStreamParser$2.PAL) {
                ch = DecodedBitStreamParser$2.PUNCT_CHARS[subModeCh];
              } else {
                switch (subModeCh) {
                  case DecodedBitStreamParser$2.PAL:
                    subMode = Mode$2.ALPHA;
                    break;
                  case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    result2.append(
                      /*(char)*/
                      byteCompactionData[i2]
                    );
                    break;
                  case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                    subMode = Mode$2.ALPHA;
                    break;
                }
              }
              break;
          }
          if (ch !== "") {
            result2.append(ch);
          }
          i2++;
        }
      }
      /**
       * Byte Compaction mode (see 5.4.3) permits all 256 possible 8-bit byte values to be encoded.
       * This includes all ASCII characters value 0 to 127 inclusive and provides for international
       * character set support.
       *
       * @param mode      The byte compaction mode i.e. 901 or 924
       * @param codewords The array of codewords (data + error)
       * @param encoding  Currently active character encoding
       * @param codeIndex The current index into the codeword array.
       * @param result    The decoded data is appended to the result.
       * @return The next index into the codeword array.
       */
      static byteCompaction(mode, codewords, encoding, codeIndex, result2) {
        let decodedBytes = new ByteArrayOutputStream();
        let count = 0;
        let value = (
          /*long*/
          0
        );
        let end = false;
        switch (mode) {
          case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
            let byteCompactedCodewords = new Int32Array(6);
            let nextCode = codewords[codeIndex++];
            while (codeIndex < codewords[0] && !end) {
              byteCompactedCodewords[count++] = nextCode;
              value = 900 * value + nextCode;
              nextCode = codewords[codeIndex++];
              switch (nextCode) {
                case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                  codeIndex--;
                  end = true;
                  break;
                default:
                  if (count % 5 === 0 && count > 0) {
                    for (let j = 0; j < 6; ++j) {
                      decodedBytes.write(
                        /*(byte)*/
                        Number(createBigInt(value) >> createBigInt(8 * (5 - j)))
                      );
                    }
                    value = 0;
                    count = 0;
                  }
                  break;
              }
            }
            if (codeIndex === codewords[0] && nextCode < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
              byteCompactedCodewords[count++] = nextCode;
            }
            for (let i2 = 0; i2 < count; i2++) {
              decodedBytes.write(
                /*(byte)*/
                byteCompactedCodewords[i2]
              );
            }
            break;
          case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
            while (codeIndex < codewords[0] && !end) {
              let code = codewords[codeIndex++];
              if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                count++;
                value = 900 * value + code;
              } else {
                switch (code) {
                  case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                  case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                  case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                  case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                  case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                  case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                  case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                    codeIndex--;
                    end = true;
                    break;
                }
              }
              if (count % 5 === 0 && count > 0) {
                for (let j = 0; j < 6; ++j) {
                  decodedBytes.write(
                    /*(byte)*/
                    Number(createBigInt(value) >> createBigInt(8 * (5 - j)))
                  );
                }
                value = 0;
                count = 0;
              }
            }
            break;
        }
        result2.append(StringEncoding.decode(decodedBytes.toByteArray(), encoding));
        return codeIndex;
      }
      /**
       * Numeric Compaction mode (see 5.4.4) permits efficient encoding of numeric data strings.
       *
       * @param codewords The array of codewords (data + error)
       * @param codeIndex The current index into the codeword array.
       * @param result    The decoded data is appended to the result.
       * @return The next index into the codeword array.
       *
       * @throws FormatException
       */
      static numericCompaction(codewords, codeIndex, result2) {
        let count = 0;
        let end = false;
        let numericCodewords = new Int32Array(DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS);
        while (codeIndex < codewords[0] && !end) {
          let code = codewords[codeIndex++];
          if (codeIndex === codewords[0]) {
            end = true;
          }
          if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
            numericCodewords[count] = code;
            count++;
          } else {
            switch (code) {
              case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
              case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
              case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
              case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
              case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
              case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                codeIndex--;
                end = true;
                break;
            }
          }
          if ((count % DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS === 0 || code === DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH || end) && count > 0) {
            result2.append(DecodedBitStreamParser$2.decodeBase900toBase10(numericCodewords, count));
            count = 0;
          }
        }
        return codeIndex;
      }
      /**
       * Convert a list of Numeric Compacted codewords from Base 900 to Base 10.
       *
       * @param codewords The array of codewords
       * @param count     The number of codewords
       * @return The decoded string representing the Numeric data.
       *
       * EXAMPLE
       * Encode the fifteen digit numeric string 000213298174000
       * Prefix the numeric string with a 1 and set the initial value of
       * t = 1 000 213 298 174 000
       * Calculate codeword 0
       * d0 = 1 000 213 298 174 000 mod 900 = 200
       *
       * t = 1 000 213 298 174 000 div 900 = 1 111 348 109 082
       * Calculate codeword 1
       * d1 = 1 111 348 109 082 mod 900 = 282
       *
       * t = 1 111 348 109 082 div 900 = 1 234 831 232
       * Calculate codeword 2
       * d2 = 1 234 831 232 mod 900 = 632
       *
       * t = 1 234 831 232 div 900 = 1 372 034
       * Calculate codeword 3
       * d3 = 1 372 034 mod 900 = 434
       *
       * t = 1 372 034 div 900 = 1 524
       * Calculate codeword 4
       * d4 = 1 524 mod 900 = 624
       *
       * t = 1 524 div 900 = 1
       * Calculate codeword 5
       * d5 = 1 mod 900 = 1
       * t = 1 div 900 = 0
       * Codeword sequence is: 1, 624, 434, 632, 282, 200
       *
       * Decode the above codewords involves
       *   1 x 900 power of 5 + 624 x 900 power of 4 + 434 x 900 power of 3 +
       * 632 x 900 power of 2 + 282 x 900 power of 1 + 200 x 900 power of 0 = 1000213298174000
       *
       * Remove leading 1 =>  Result is 000213298174000
       *
       * @throws FormatException
       */
      static decodeBase900toBase10(codewords, count) {
        let result2 = createBigInt(0);
        for (let i2 = 0; i2 < count; i2++) {
          result2 += DecodedBitStreamParser$2.EXP900[count - i2 - 1] * createBigInt(codewords[i2]);
        }
        let resultString = result2.toString();
        if (resultString.charAt(0) !== "1") {
          throw new FormatException();
        }
        return resultString.substring(1);
      }
    }
    DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH = 900;
    DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH = 901;
    DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH = 902;
    DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6 = 924;
    DecodedBitStreamParser$2.ECI_USER_DEFINED = 925;
    DecodedBitStreamParser$2.ECI_GENERAL_PURPOSE = 926;
    DecodedBitStreamParser$2.ECI_CHARSET = 927;
    DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928;
    DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923;
    DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR = 922;
    DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913;
    DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS = 15;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6;
    DecodedBitStreamParser$2.PL = 25;
    DecodedBitStreamParser$2.LL = 27;
    DecodedBitStreamParser$2.AS = 27;
    DecodedBitStreamParser$2.ML = 28;
    DecodedBitStreamParser$2.AL = 28;
    DecodedBitStreamParser$2.PS = 29;
    DecodedBitStreamParser$2.PAL = 29;
    DecodedBitStreamParser$2.PUNCT_CHARS = ";<>@[\\]_`~!\r	,:\n-.$/\"|*()?{}'";
    DecodedBitStreamParser$2.MIXED_CHARS = "0123456789&\r	,:#-.$/+%*=^";
    DecodedBitStreamParser$2.EXP900 = getBigIntConstructor() ? getEXP900() : [];
    DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS = 2;
    class PDF417ScanningDecoder {
      constructor() {
      }
      /**
       * @TODO don't pass in minCodewordWidth and maxCodewordWidth, pass in barcode columns for start and stop pattern
       *
       * columns. That way width can be deducted from the pattern column.
       * This approach also allows to detect more details about the barcode, e.g. if a bar type (white or black) is wider
       * than it should be. This can happen if the scanner used a bad blackpoint.
       *
       * @param BitMatrix
       * @param image
       * @param ResultPoint
       * @param imageTopLeft
       * @param ResultPoint
       * @param imageBottomLeft
       * @param ResultPoint
       * @param imageTopRight
       * @param ResultPoint
       * @param imageBottomRight
       * @param int
       * @param minCodewordWidth
       * @param int
       * @param maxCodewordWidth
       *
       * @throws NotFoundException
       * @throws FormatException
       * @throws ChecksumException
       */
      static decode(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight, minCodewordWidth, maxCodewordWidth) {
        let boundingBox = new BoundingBox(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight);
        let leftRowIndicatorColumn = null;
        let rightRowIndicatorColumn = null;
        let detectionResult;
        for (let firstPass = true; ; firstPass = false) {
          if (imageTopLeft != null) {
            leftRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopLeft, true, minCodewordWidth, maxCodewordWidth);
          }
          if (imageTopRight != null) {
            rightRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopRight, false, minCodewordWidth, maxCodewordWidth);
          }
          detectionResult = PDF417ScanningDecoder.merge(leftRowIndicatorColumn, rightRowIndicatorColumn);
          if (detectionResult == null) {
            throw NotFoundException.getNotFoundInstance();
          }
          let resultBox = detectionResult.getBoundingBox();
          if (firstPass && resultBox != null && (resultBox.getMinY() < boundingBox.getMinY() || resultBox.getMaxY() > boundingBox.getMaxY())) {
            boundingBox = resultBox;
          } else {
            break;
          }
        }
        detectionResult.setBoundingBox(boundingBox);
        let maxBarcodeColumn = detectionResult.getBarcodeColumnCount() + 1;
        detectionResult.setDetectionResultColumn(0, leftRowIndicatorColumn);
        detectionResult.setDetectionResultColumn(maxBarcodeColumn, rightRowIndicatorColumn);
        let leftToRight = leftRowIndicatorColumn != null;
        for (let barcodeColumnCount = 1; barcodeColumnCount <= maxBarcodeColumn; barcodeColumnCount++) {
          let barcodeColumn = leftToRight ? barcodeColumnCount : maxBarcodeColumn - barcodeColumnCount;
          if (detectionResult.getDetectionResultColumn(barcodeColumn) !== /* null */
          void 0) {
            continue;
          }
          let detectionResultColumn;
          if (barcodeColumn === 0 || barcodeColumn === maxBarcodeColumn) {
            detectionResultColumn = new DetectionResultRowIndicatorColumn(boundingBox, barcodeColumn === 0);
          } else {
            detectionResultColumn = new DetectionResultColumn(boundingBox);
          }
          detectionResult.setDetectionResultColumn(barcodeColumn, detectionResultColumn);
          let startColumn = -1;
          let previousStartColumn = startColumn;
          for (let imageRow = boundingBox.getMinY(); imageRow <= boundingBox.getMaxY(); imageRow++) {
            startColumn = PDF417ScanningDecoder.getStartColumn(detectionResult, barcodeColumn, imageRow, leftToRight);
            if (startColumn < 0 || startColumn > boundingBox.getMaxX()) {
              if (previousStartColumn === -1) {
                continue;
              }
              startColumn = previousStartColumn;
            }
            let codeword = PDF417ScanningDecoder.detectCodeword(image, boundingBox.getMinX(), boundingBox.getMaxX(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
            if (codeword != null) {
              detectionResultColumn.setCodeword(imageRow, codeword);
              previousStartColumn = startColumn;
              minCodewordWidth = Math.min(minCodewordWidth, codeword.getWidth());
              maxCodewordWidth = Math.max(maxCodewordWidth, codeword.getWidth());
            }
          }
        }
        return PDF417ScanningDecoder.createDecoderResult(detectionResult);
      }
      /**
       *
       * @param leftRowIndicatorColumn
       * @param rightRowIndicatorColumn
       *
       * @throws NotFoundException
       */
      static merge(leftRowIndicatorColumn, rightRowIndicatorColumn) {
        if (leftRowIndicatorColumn == null && rightRowIndicatorColumn == null) {
          return null;
        }
        let barcodeMetadata = PDF417ScanningDecoder.getBarcodeMetadata(leftRowIndicatorColumn, rightRowIndicatorColumn);
        if (barcodeMetadata == null) {
          return null;
        }
        let boundingBox = BoundingBox.merge(PDF417ScanningDecoder.adjustBoundingBox(leftRowIndicatorColumn), PDF417ScanningDecoder.adjustBoundingBox(rightRowIndicatorColumn));
        return new DetectionResult(barcodeMetadata, boundingBox);
      }
      /**
       *
       * @param rowIndicatorColumn
       *
       * @throws NotFoundException
       */
      static adjustBoundingBox(rowIndicatorColumn) {
        if (rowIndicatorColumn == null) {
          return null;
        }
        let rowHeights = rowIndicatorColumn.getRowHeights();
        if (rowHeights == null) {
          return null;
        }
        let maxRowHeight = PDF417ScanningDecoder.getMax(rowHeights);
        let missingStartRows = 0;
        for (let rowHeight of rowHeights) {
          missingStartRows += maxRowHeight - rowHeight;
          if (rowHeight > 0) {
            break;
          }
        }
        let codewords = rowIndicatorColumn.getCodewords();
        for (let row = 0; missingStartRows > 0 && codewords[row] == null; row++) {
          missingStartRows--;
        }
        let missingEndRows = 0;
        for (let row = rowHeights.length - 1; row >= 0; row--) {
          missingEndRows += maxRowHeight - rowHeights[row];
          if (rowHeights[row] > 0) {
            break;
          }
        }
        for (let row = codewords.length - 1; missingEndRows > 0 && codewords[row] == null; row--) {
          missingEndRows--;
        }
        return rowIndicatorColumn.getBoundingBox().addMissingRows(missingStartRows, missingEndRows, rowIndicatorColumn.isLeft());
      }
      static getMax(values2) {
        let maxValue = -1;
        for (let value of values2) {
          maxValue = Math.max(maxValue, value);
        }
        return maxValue;
      }
      static getBarcodeMetadata(leftRowIndicatorColumn, rightRowIndicatorColumn) {
        let leftBarcodeMetadata;
        if (leftRowIndicatorColumn == null || (leftBarcodeMetadata = leftRowIndicatorColumn.getBarcodeMetadata()) == null) {
          return rightRowIndicatorColumn == null ? null : rightRowIndicatorColumn.getBarcodeMetadata();
        }
        let rightBarcodeMetadata;
        if (rightRowIndicatorColumn == null || (rightBarcodeMetadata = rightRowIndicatorColumn.getBarcodeMetadata()) == null) {
          return leftBarcodeMetadata;
        }
        if (leftBarcodeMetadata.getColumnCount() !== rightBarcodeMetadata.getColumnCount() && leftBarcodeMetadata.getErrorCorrectionLevel() !== rightBarcodeMetadata.getErrorCorrectionLevel() && leftBarcodeMetadata.getRowCount() !== rightBarcodeMetadata.getRowCount()) {
          return null;
        }
        return leftBarcodeMetadata;
      }
      static getRowIndicatorColumn(image, boundingBox, startPoint, leftToRight, minCodewordWidth, maxCodewordWidth) {
        let rowIndicatorColumn = new DetectionResultRowIndicatorColumn(boundingBox, leftToRight);
        for (let i2 = 0; i2 < 2; i2++) {
          let increment = i2 === 0 ? 1 : -1;
          let startColumn = Math.trunc(Math.trunc(startPoint.getX()));
          for (let imageRow = Math.trunc(Math.trunc(startPoint.getY())); imageRow <= boundingBox.getMaxY() && imageRow >= boundingBox.getMinY(); imageRow += increment) {
            let codeword = PDF417ScanningDecoder.detectCodeword(image, 0, image.getWidth(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
            if (codeword != null) {
              rowIndicatorColumn.setCodeword(imageRow, codeword);
              if (leftToRight) {
                startColumn = codeword.getStartX();
              } else {
                startColumn = codeword.getEndX();
              }
            }
          }
        }
        return rowIndicatorColumn;
      }
      /**
       *
       * @param detectionResult
       * @param BarcodeValue
       * @param param2
       * @param param3
       * @param barcodeMatrix
       *
       * @throws NotFoundException
       */
      static adjustCodewordCount(detectionResult, barcodeMatrix) {
        let barcodeMatrix01 = barcodeMatrix[0][1];
        let numberOfCodewords = barcodeMatrix01.getValue();
        let calculatedNumberOfCodewords = detectionResult.getBarcodeColumnCount() * detectionResult.getBarcodeRowCount() - PDF417ScanningDecoder.getNumberOfECCodeWords(detectionResult.getBarcodeECLevel());
        if (numberOfCodewords.length === 0) {
          if (calculatedNumberOfCodewords < 1 || calculatedNumberOfCodewords > PDF417Common.MAX_CODEWORDS_IN_BARCODE) {
            throw NotFoundException.getNotFoundInstance();
          }
          barcodeMatrix01.setValue(calculatedNumberOfCodewords);
        } else if (numberOfCodewords[0] !== calculatedNumberOfCodewords) {
          barcodeMatrix01.setValue(calculatedNumberOfCodewords);
        }
      }
      /**
       *
       * @param detectionResult
       *
       * @throws FormatException
       * @throws ChecksumException
       * @throws NotFoundException
       */
      static createDecoderResult(detectionResult) {
        let barcodeMatrix = PDF417ScanningDecoder.createBarcodeMatrix(detectionResult);
        PDF417ScanningDecoder.adjustCodewordCount(detectionResult, barcodeMatrix);
        let erasures = new Array();
        let codewords = new Int32Array(detectionResult.getBarcodeRowCount() * detectionResult.getBarcodeColumnCount());
        let ambiguousIndexValuesList = (
          /*List<int[]>*/
          []
        );
        let ambiguousIndexesList = (
          /*Collection<Integer>*/
          new Array()
        );
        for (let row = 0; row < detectionResult.getBarcodeRowCount(); row++) {
          for (let column = 0; column < detectionResult.getBarcodeColumnCount(); column++) {
            let values2 = barcodeMatrix[row][column + 1].getValue();
            let codewordIndex = row * detectionResult.getBarcodeColumnCount() + column;
            if (values2.length === 0) {
              erasures.push(codewordIndex);
            } else if (values2.length === 1) {
              codewords[codewordIndex] = values2[0];
            } else {
              ambiguousIndexesList.push(codewordIndex);
              ambiguousIndexValuesList.push(values2);
            }
          }
        }
        let ambiguousIndexValues = new Array(ambiguousIndexValuesList.length);
        for (let i2 = 0; i2 < ambiguousIndexValues.length; i2++) {
          ambiguousIndexValues[i2] = ambiguousIndexValuesList[i2];
        }
        return PDF417ScanningDecoder.createDecoderResultFromAmbiguousValues(detectionResult.getBarcodeECLevel(), codewords, PDF417Common.toIntArray(erasures), PDF417Common.toIntArray(ambiguousIndexesList), ambiguousIndexValues);
      }
      /**
       * This method deals with the fact, that the decoding process doesn't always yield a single most likely value. The
       * current error correction implementation doesn't deal with erasures very well, so it's better to provide a value
       * for these ambiguous codewords instead of treating it as an erasure. The problem is that we don't know which of
       * the ambiguous values to choose. We try decode using the first value, and if that fails, we use another of the
       * ambiguous values and try to decode again. This usually only happens on very hard to read and decode barcodes,
       * so decoding the normal barcodes is not affected by this.
       *
       * @param erasureArray contains the indexes of erasures
       * @param ambiguousIndexes array with the indexes that have more than one most likely value
       * @param ambiguousIndexValues two dimensional array that contains the ambiguous values. The first dimension must
       * be the same length as the ambiguousIndexes array
       *
       * @throws FormatException
       * @throws ChecksumException
       */
      static createDecoderResultFromAmbiguousValues(ecLevel, codewords, erasureArray, ambiguousIndexes, ambiguousIndexValues) {
        let ambiguousIndexCount = new Int32Array(ambiguousIndexes.length);
        let tries = 100;
        while (tries-- > 0) {
          for (let i2 = 0; i2 < ambiguousIndexCount.length; i2++) {
            codewords[ambiguousIndexes[i2]] = ambiguousIndexValues[i2][ambiguousIndexCount[i2]];
          }
          try {
            return PDF417ScanningDecoder.decodeCodewords(codewords, ecLevel, erasureArray);
          } catch (err2) {
            let ignored = err2 instanceof ChecksumException;
            if (!ignored) {
              throw err2;
            }
          }
          if (ambiguousIndexCount.length === 0) {
            throw ChecksumException.getChecksumInstance();
          }
          for (let i2 = 0; i2 < ambiguousIndexCount.length; i2++) {
            if (ambiguousIndexCount[i2] < ambiguousIndexValues[i2].length - 1) {
              ambiguousIndexCount[i2]++;
              break;
            } else {
              ambiguousIndexCount[i2] = 0;
              if (i2 === ambiguousIndexCount.length - 1) {
                throw ChecksumException.getChecksumInstance();
              }
            }
          }
        }
        throw ChecksumException.getChecksumInstance();
      }
      static createBarcodeMatrix(detectionResult) {
        let barcodeMatrix = Array.from({ length: detectionResult.getBarcodeRowCount() }, () => new Array(detectionResult.getBarcodeColumnCount() + 2));
        for (let row = 0; row < barcodeMatrix.length; row++) {
          for (let column2 = 0; column2 < barcodeMatrix[row].length; column2++) {
            barcodeMatrix[row][column2] = new BarcodeValue();
          }
        }
        let column = 0;
        for (let detectionResultColumn of detectionResult.getDetectionResultColumns()) {
          if (detectionResultColumn != null) {
            for (let codeword of detectionResultColumn.getCodewords()) {
              if (codeword != null) {
                let rowNumber = codeword.getRowNumber();
                if (rowNumber >= 0) {
                  if (rowNumber >= barcodeMatrix.length) {
                    continue;
                  }
                  barcodeMatrix[rowNumber][column].setValue(codeword.getValue());
                }
              }
            }
          }
          column++;
        }
        return barcodeMatrix;
      }
      static isValidBarcodeColumn(detectionResult, barcodeColumn) {
        return barcodeColumn >= 0 && barcodeColumn <= detectionResult.getBarcodeColumnCount() + 1;
      }
      static getStartColumn(detectionResult, barcodeColumn, imageRow, leftToRight) {
        let offset2 = leftToRight ? 1 : -1;
        let codeword = null;
        if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset2)) {
          codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset2).getCodeword(imageRow);
        }
        if (codeword != null) {
          return leftToRight ? codeword.getEndX() : codeword.getStartX();
        }
        codeword = detectionResult.getDetectionResultColumn(barcodeColumn).getCodewordNearby(imageRow);
        if (codeword != null) {
          return leftToRight ? codeword.getStartX() : codeword.getEndX();
        }
        if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset2)) {
          codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset2).getCodewordNearby(imageRow);
        }
        if (codeword != null) {
          return leftToRight ? codeword.getEndX() : codeword.getStartX();
        }
        let skippedColumns = 0;
        while (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset2)) {
          barcodeColumn -= offset2;
          for (let previousRowCodeword of detectionResult.getDetectionResultColumn(barcodeColumn).getCodewords()) {
            if (previousRowCodeword != null) {
              return (leftToRight ? previousRowCodeword.getEndX() : previousRowCodeword.getStartX()) + offset2 * skippedColumns * (previousRowCodeword.getEndX() - previousRowCodeword.getStartX());
            }
          }
          skippedColumns++;
        }
        return leftToRight ? detectionResult.getBoundingBox().getMinX() : detectionResult.getBoundingBox().getMaxX();
      }
      static detectCodeword(image, minColumn, maxColumn, leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth) {
        startColumn = PDF417ScanningDecoder.adjustCodewordStartColumn(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
        let moduleBitCount = PDF417ScanningDecoder.getModuleBitCount(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
        if (moduleBitCount == null) {
          return null;
        }
        let endColumn;
        let codewordBitCount = MathUtils2.sum(moduleBitCount);
        if (leftToRight) {
          endColumn = startColumn + codewordBitCount;
        } else {
          for (let i2 = 0; i2 < moduleBitCount.length / 2; i2++) {
            let tmpCount = moduleBitCount[i2];
            moduleBitCount[i2] = moduleBitCount[moduleBitCount.length - 1 - i2];
            moduleBitCount[moduleBitCount.length - 1 - i2] = tmpCount;
          }
          endColumn = startColumn;
          startColumn = endColumn - codewordBitCount;
        }
        if (!PDF417ScanningDecoder.checkCodewordSkew(codewordBitCount, minCodewordWidth, maxCodewordWidth)) {
          return null;
        }
        let decodedValue = PDF417CodewordDecoder.getDecodedValue(moduleBitCount);
        let codeword = PDF417Common.getCodeword(decodedValue);
        if (codeword === -1) {
          return null;
        }
        return new Codeword(startColumn, endColumn, PDF417ScanningDecoder.getCodewordBucketNumber(decodedValue), codeword);
      }
      static getModuleBitCount(image, minColumn, maxColumn, leftToRight, startColumn, imageRow) {
        let imageColumn = startColumn;
        let moduleBitCount = new Int32Array(8);
        let moduleNumber = 0;
        let increment = leftToRight ? 1 : -1;
        let previousPixelValue = leftToRight;
        while ((leftToRight ? imageColumn < maxColumn : imageColumn >= minColumn) && moduleNumber < moduleBitCount.length) {
          if (image.get(imageColumn, imageRow) === previousPixelValue) {
            moduleBitCount[moduleNumber]++;
            imageColumn += increment;
          } else {
            moduleNumber++;
            previousPixelValue = !previousPixelValue;
          }
        }
        if (moduleNumber === moduleBitCount.length || imageColumn === (leftToRight ? maxColumn : minColumn) && moduleNumber === moduleBitCount.length - 1) {
          return moduleBitCount;
        }
        return null;
      }
      static getNumberOfECCodeWords(barcodeECLevel) {
        return 2 << barcodeECLevel;
      }
      static adjustCodewordStartColumn(image, minColumn, maxColumn, leftToRight, codewordStartColumn, imageRow) {
        let correctedStartColumn = codewordStartColumn;
        let increment = leftToRight ? -1 : 1;
        for (let i2 = 0; i2 < 2; i2++) {
          while ((leftToRight ? correctedStartColumn >= minColumn : correctedStartColumn < maxColumn) && leftToRight === image.get(correctedStartColumn, imageRow)) {
            if (Math.abs(codewordStartColumn - correctedStartColumn) > PDF417ScanningDecoder.CODEWORD_SKEW_SIZE) {
              return codewordStartColumn;
            }
            correctedStartColumn += increment;
          }
          increment = -increment;
          leftToRight = !leftToRight;
        }
        return correctedStartColumn;
      }
      static checkCodewordSkew(codewordSize, minCodewordWidth, maxCodewordWidth) {
        return minCodewordWidth - PDF417ScanningDecoder.CODEWORD_SKEW_SIZE <= codewordSize && codewordSize <= maxCodewordWidth + PDF417ScanningDecoder.CODEWORD_SKEW_SIZE;
      }
      /**
       * @throws FormatException,
       * @throws ChecksumException
       */
      static decodeCodewords(codewords, ecLevel, erasures) {
        if (codewords.length === 0) {
          throw FormatException.getFormatInstance();
        }
        let numECCodewords = 1 << ecLevel + 1;
        let correctedErrorsCount = PDF417ScanningDecoder.correctErrors(codewords, erasures, numECCodewords);
        PDF417ScanningDecoder.verifyCodewordCount(codewords, numECCodewords);
        let decoderResult = DecodedBitStreamParser$2.decode(codewords, "" + ecLevel);
        decoderResult.setErrorsCorrected(correctedErrorsCount);
        decoderResult.setErasures(erasures.length);
        return decoderResult;
      }
      /**
       * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
       * correct the errors in-place.</p>
       *
       * @param codewords   data and error correction codewords
       * @param erasures positions of any known erasures
       * @param numECCodewords number of error correction codewords that are available in codewords
       * @throws ChecksumException if error correction fails
       */
      static correctErrors(codewords, erasures, numECCodewords) {
        if (erasures != null && erasures.length > numECCodewords / 2 + PDF417ScanningDecoder.MAX_ERRORS || numECCodewords < 0 || numECCodewords > PDF417ScanningDecoder.MAX_EC_CODEWORDS) {
          throw ChecksumException.getChecksumInstance();
        }
        return PDF417ScanningDecoder.errorCorrection.decode(codewords, numECCodewords, erasures);
      }
      /**
       * Verify that all is OK with the codeword array.
       * @throws FormatException
       */
      static verifyCodewordCount(codewords, numECCodewords) {
        if (codewords.length < 4) {
          throw FormatException.getFormatInstance();
        }
        let numberOfCodewords = codewords[0];
        if (numberOfCodewords > codewords.length) {
          throw FormatException.getFormatInstance();
        }
        if (numberOfCodewords === 0) {
          if (numECCodewords < codewords.length) {
            codewords[0] = codewords.length - numECCodewords;
          } else {
            throw FormatException.getFormatInstance();
          }
        }
      }
      static getBitCountForCodeword(codeword) {
        let result2 = new Int32Array(8);
        let previousValue = 0;
        let i2 = result2.length - 1;
        while (true) {
          if ((codeword & 1) !== previousValue) {
            previousValue = codeword & 1;
            i2--;
            if (i2 < 0) {
              break;
            }
          }
          result2[i2]++;
          codeword >>= 1;
        }
        return result2;
      }
      static getCodewordBucketNumber(codeword) {
        if (codeword instanceof Int32Array) {
          return this.getCodewordBucketNumber_Int32Array(codeword);
        }
        return this.getCodewordBucketNumber_number(codeword);
      }
      static getCodewordBucketNumber_number(codeword) {
        return PDF417ScanningDecoder.getCodewordBucketNumber(PDF417ScanningDecoder.getBitCountForCodeword(codeword));
      }
      static getCodewordBucketNumber_Int32Array(moduleBitCount) {
        return (moduleBitCount[0] - moduleBitCount[2] + moduleBitCount[4] - moduleBitCount[6] + 9) % 9;
      }
      static toString(barcodeMatrix) {
        let formatter = new Formatter();
        for (let row = 0; row < barcodeMatrix.length; row++) {
          formatter.format("Row %2d: ", row);
          for (let column = 0; column < barcodeMatrix[row].length; column++) {
            let barcodeValue = barcodeMatrix[row][column];
            if (barcodeValue.getValue().length === 0) {
              formatter.format("        ", null);
            } else {
              formatter.format("%4d(%2d)", barcodeValue.getValue()[0], barcodeValue.getConfidence(barcodeValue.getValue()[0]));
            }
          }
          formatter.format("%n");
        }
        return formatter.toString();
      }
    }
    PDF417ScanningDecoder.CODEWORD_SKEW_SIZE = 2;
    PDF417ScanningDecoder.MAX_ERRORS = 3;
    PDF417ScanningDecoder.MAX_EC_CODEWORDS = 512;
    PDF417ScanningDecoder.errorCorrection = new ErrorCorrection();
    class PDF417Reader {
      // private static /*final Result[]*/ EMPTY_RESULT_ARRAY: Result[] = new Result([0]);
      /**
       * Locates and decodes a PDF417 code in an image.
       *
       * @return a String representing the content encoded by the PDF417 code
       * @throws NotFoundException if a PDF417 code cannot be found,
       * @throws FormatException if a PDF417 cannot be decoded
       * @throws ChecksumException
       */
      // @Override
      decode(image, hints = null) {
        let result2 = PDF417Reader.decode(image, hints, false);
        if (result2 == null || result2.length === 0 || result2[0] == null) {
          throw NotFoundException.getNotFoundInstance();
        }
        return result2[0];
      }
      /**
       *
       * @param BinaryBitmap
       * @param image
       * @throws NotFoundException
       */
      //   @Override
      decodeMultiple(image, hints = null) {
        try {
          return PDF417Reader.decode(image, hints, true);
        } catch (ignored) {
          if (ignored instanceof FormatException || ignored instanceof ChecksumException) {
            throw NotFoundException.getNotFoundInstance();
          }
          throw ignored;
        }
      }
      /**
       *
       * @param image
       * @param hints
       * @param multiple
       *
       * @throws NotFoundException
       * @throws FormatExceptionß
       * @throws ChecksumException
       */
      static decode(image, hints, multiple) {
        const results = new Array();
        const detectorResult = Detector$3.detectMultiple(image, hints, multiple);
        for (const points of detectorResult.getPoints()) {
          const decoderResult = PDF417ScanningDecoder.decode(detectorResult.getBits(), points[4], points[5], points[6], points[7], PDF417Reader.getMinCodewordWidth(points), PDF417Reader.getMaxCodewordWidth(points));
          const result2 = new Result3(decoderResult.getText(), decoderResult.getRawBytes(), void 0, points, BarcodeFormat$1.PDF_417);
          result2.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, decoderResult.getECLevel());
          const pdf417ResultMetadata = decoderResult.getOther();
          if (pdf417ResultMetadata != null) {
            result2.putMetadata(ResultMetadataType$1.PDF417_EXTRA_METADATA, pdf417ResultMetadata);
          }
          results.push(result2);
        }
        return results.map((x2) => x2);
      }
      static getMaxWidth(p1, p2) {
        if (p1 == null || p2 == null) {
          return 0;
        }
        return Math.trunc(Math.abs(p1.getX() - p2.getX()));
      }
      static getMinWidth(p1, p2) {
        if (p1 == null || p2 == null) {
          return Integer.MAX_VALUE;
        }
        return Math.trunc(Math.abs(p1.getX() - p2.getX()));
      }
      static getMaxCodewordWidth(p) {
        return Math.floor(Math.max(Math.max(PDF417Reader.getMaxWidth(p[0], p[4]), PDF417Reader.getMaxWidth(p[6], p[2]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN), Math.max(PDF417Reader.getMaxWidth(p[1], p[5]), PDF417Reader.getMaxWidth(p[7], p[3]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN)));
      }
      static getMinCodewordWidth(p) {
        return Math.floor(Math.min(Math.min(PDF417Reader.getMinWidth(p[0], p[4]), PDF417Reader.getMinWidth(p[6], p[2]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN), Math.min(PDF417Reader.getMinWidth(p[1], p[5]), PDF417Reader.getMinWidth(p[7], p[3]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN)));
      }
      // @Override
      reset() {
      }
    }
    class ReaderException extends Exception {
    }
    ReaderException.kind = "ReaderException";
    class MultiFormatReader {
      /**
       * Creates an instance of this class
       * 
       * @param {Boolean} verbose if 'true' logs will be dumped to console, otherwise hidden.
       * @param hints The hints to use, clearing the previous state.
       */
      constructor(verbose, hints) {
        this.verbose = verbose === true;
        if (hints) {
          this.setHints(hints);
        }
      }
      /**
       * This version of decode honors the intent of Reader.decode(BinaryBitmap) in that it
       * passes null as a hint to the decoders. However, that makes it inefficient to call repeatedly.
       * Use setHints() followed by decodeWithState() for continuous scan applications.
       *
       * @param image The pixel data to decode
       * @return The contents of the image
       *
       * @throws NotFoundException Any errors which occurred
       */
      /*@Override*/
      // public decode(image: BinaryBitmap): Result {
      //   setHints(null)
      //   return decodeInternal(image)
      // }
      /**
       * Decode an image using the hints provided. Does not honor existing state.
       *
       * @param image The pixel data to decode
       * @param hints The hints to use, clearing the previous state.
       * @return The contents of the image
       *
       * @throws NotFoundException Any errors which occurred
       */
      /*@Override*/
      decode(image, hints) {
        if (hints) {
          this.setHints(hints);
        }
        return this.decodeInternal(image);
      }
      /**
       * Decode an image using the state set up by calling setHints() previously. Continuous scan
       * clients will get a <b>large</b> speed increase by using this instead of decode().
       *
       * @param image The pixel data to decode
       * @return The contents of the image
       *
       * @throws NotFoundException Any errors which occurred
       */
      decodeWithState(image) {
        if (this.readers === null || this.readers === void 0) {
          this.setHints(null);
        }
        return this.decodeInternal(image);
      }
      /**
       * This method adds state to the MultiFormatReader. By setting the hints once, subsequent calls
       * to decodeWithState(image) can reuse the same set of readers without reallocating memory. This
       * is important for performance in continuous scan clients.
       *
       * @param hints The set of hints to use for subsequent calls to decode(image)
       */
      setHints(hints) {
        this.hints = hints;
        const tryHarder = !isNullOrUndefined2(hints) && hints.get(DecodeHintType$1.TRY_HARDER) === true;
        const formats = isNullOrUndefined2(hints) ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
        const readers = new Array();
        if (!isNullOrUndefined2(formats)) {
          const addOneDReader = formats.some((f) => {
            return f === BarcodeFormat$1.UPC_A || f === BarcodeFormat$1.UPC_E || f === BarcodeFormat$1.EAN_13 || f === BarcodeFormat$1.EAN_8 || f === BarcodeFormat$1.CODABAR || f === BarcodeFormat$1.CODE_39 || f === BarcodeFormat$1.CODE_93 || f === BarcodeFormat$1.CODE_128 || f === BarcodeFormat$1.ITF || f === BarcodeFormat$1.RSS_14 || f === BarcodeFormat$1.RSS_EXPANDED;
          });
          if (addOneDReader && !tryHarder) {
            readers.push(new MultiFormatOneDReader(hints, this.verbose));
          }
          if (formats.includes(BarcodeFormat$1.QR_CODE)) {
            readers.push(new QRCodeReader());
          }
          if (formats.includes(BarcodeFormat$1.DATA_MATRIX)) {
            readers.push(new DataMatrixReader());
          }
          if (formats.includes(BarcodeFormat$1.AZTEC)) {
            readers.push(new AztecReader());
          }
          if (formats.includes(BarcodeFormat$1.PDF_417)) {
            readers.push(new PDF417Reader());
          }
          if (addOneDReader && tryHarder) {
            readers.push(new MultiFormatOneDReader(hints, this.verbose));
          }
        }
        if (readers.length === 0) {
          if (!tryHarder) {
            readers.push(new MultiFormatOneDReader(hints, this.verbose));
          }
          readers.push(new QRCodeReader());
          readers.push(new DataMatrixReader());
          readers.push(new AztecReader());
          readers.push(new PDF417Reader());
          if (tryHarder) {
            readers.push(new MultiFormatOneDReader(hints, this.verbose));
          }
        }
        this.readers = readers;
      }
      /*@Override*/
      reset() {
        if (this.readers !== null) {
          for (const reader of this.readers) {
            reader.reset();
          }
        }
      }
      /**
       * @throws NotFoundException
       */
      decodeInternal(image) {
        if (this.readers === null) {
          throw new ReaderException("No readers where selected, nothing can be read.");
        }
        for (const reader of this.readers) {
          try {
            return reader.decode(image, this.hints);
          } catch (ex) {
            if (ex instanceof ReaderException) {
              continue;
            }
          }
        }
        throw new NotFoundException("No MultiFormat Readers were able to detect the code.");
      }
    }
    class BrowserMultiFormatReader extends BrowserCodeReader {
      constructor(hints = null, timeBetweenScansMillis = 500) {
        const reader = new MultiFormatReader();
        reader.setHints(hints);
        super(reader, timeBetweenScansMillis);
      }
      /**
       * Overwrite decodeBitmap to call decodeWithState, which will pay
       * attention to the hints set in the constructor function
       */
      decodeBitmap(binaryBitmap) {
        return this.reader.decodeWithState(binaryBitmap);
      }
    }
    class BrowserPDF417Reader extends BrowserCodeReader {
      /**
       * Creates an instance of BrowserPDF417Reader.
       * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
       */
      constructor(timeBetweenScansMillis = 500) {
        super(new PDF417Reader(), timeBetweenScansMillis);
      }
    }
    class BrowserQRCodeReader extends BrowserCodeReader {
      /**
       * Creates an instance of BrowserQRCodeReader.
       * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
       */
      constructor(timeBetweenScansMillis = 500) {
        super(new QRCodeReader(), timeBetweenScansMillis);
      }
    }
    var EncodeHintType;
    (function(EncodeHintType2) {
      EncodeHintType2[EncodeHintType2["ERROR_CORRECTION"] = 0] = "ERROR_CORRECTION";
      EncodeHintType2[EncodeHintType2["CHARACTER_SET"] = 1] = "CHARACTER_SET";
      EncodeHintType2[EncodeHintType2["DATA_MATRIX_SHAPE"] = 2] = "DATA_MATRIX_SHAPE";
      EncodeHintType2[EncodeHintType2["MIN_SIZE"] = 3] = "MIN_SIZE";
      EncodeHintType2[EncodeHintType2["MAX_SIZE"] = 4] = "MAX_SIZE";
      EncodeHintType2[EncodeHintType2["MARGIN"] = 5] = "MARGIN";
      EncodeHintType2[EncodeHintType2["PDF417_COMPACT"] = 6] = "PDF417_COMPACT";
      EncodeHintType2[EncodeHintType2["PDF417_COMPACTION"] = 7] = "PDF417_COMPACTION";
      EncodeHintType2[EncodeHintType2["PDF417_DIMENSIONS"] = 8] = "PDF417_DIMENSIONS";
      EncodeHintType2[EncodeHintType2["AZTEC_LAYERS"] = 9] = "AZTEC_LAYERS";
      EncodeHintType2[EncodeHintType2["QR_VERSION"] = 10] = "QR_VERSION";
    })(EncodeHintType || (EncodeHintType = {}));
    var EncodeHintType$1 = EncodeHintType;
    class ReedSolomonEncoder {
      /**
       * A reed solomon error-correcting encoding constructor is created by
       * passing as Galois Field with of size equal to the number of code
       * words (symbols) in the alphabet (the number of values in each
       * element of arrays that are encoded/decoded).
       * @param field A galois field with a number of elements equal to the size
       * of the alphabet of symbols to encode.
       */
      constructor(field) {
        this.field = field;
        this.cachedGenerators = [];
        this.cachedGenerators.push(new GenericGFPoly(field, Int32Array.from([1])));
      }
      buildGenerator(degree) {
        const cachedGenerators = this.cachedGenerators;
        if (degree >= cachedGenerators.length) {
          let lastGenerator = cachedGenerators[cachedGenerators.length - 1];
          const field = this.field;
          for (let d2 = cachedGenerators.length; d2 <= degree; d2++) {
            const nextGenerator = lastGenerator.multiply(new GenericGFPoly(field, Int32Array.from([1, field.exp(d2 - 1 + field.getGeneratorBase())])));
            cachedGenerators.push(nextGenerator);
            lastGenerator = nextGenerator;
          }
        }
        return cachedGenerators[degree];
      }
      /**
       * <p>Encode a sequence of code words (symbols) using Reed-Solomon to allow decoders
       * to detect and correct errors that may have been introduced when the resulting
       * data is stored or transmitted.</p>
       *
       * @param toEncode array used for both and output. Caller initializes the array with
       * the code words (symbols) to be encoded followed by empty elements allocated to make
       * space for error-correction code words in the encoded output. The array contains
       * the encdoded output when encode returns. Code words are encoded as numbers from
       * 0 to n-1, where n is the number of possible code words (symbols), as determined
       * by the size of the Galois Field passed in the constructor of this object.
       * @param ecBytes the number of elements reserved in the array (first parameter)
       * to store error-correction code words. Thus, the number of code words (symbols)
       * to encode in the first parameter is thus toEncode.length - ecBytes.
       * Note, the use of "bytes" in the name of this parameter is misleading, as there may
       * be more or fewer than 256 symbols being encoded, as determined by the number of
       * elements in the Galois Field passed as a constructor to this object.
       * @throws IllegalArgumentException thrown in response to validation errros.
       */
      encode(toEncode, ecBytes) {
        if (ecBytes === 0) {
          throw new IllegalArgumentException("No error correction bytes");
        }
        const dataBytes = toEncode.length - ecBytes;
        if (dataBytes <= 0) {
          throw new IllegalArgumentException("No data bytes provided");
        }
        const generator = this.buildGenerator(ecBytes);
        const infoCoefficients = new Int32Array(dataBytes);
        System.arraycopy(toEncode, 0, infoCoefficients, 0, dataBytes);
        let info = new GenericGFPoly(this.field, infoCoefficients);
        info = info.multiplyByMonomial(ecBytes, 1);
        const remainder = info.divide(generator)[1];
        const coefficients = remainder.getCoefficients();
        const numZeroCoefficients = ecBytes - coefficients.length;
        for (let i2 = 0; i2 < numZeroCoefficients; i2++) {
          toEncode[dataBytes + i2] = 0;
        }
        System.arraycopy(coefficients, 0, toEncode, dataBytes + numZeroCoefficients, coefficients.length);
      }
    }
    class MaskUtil {
      constructor() {
      }
      /**
       * Apply mask penalty rule 1 and return the penalty. Find repetitive cells with the same color and
       * give penalty to them. Example: 00000 or 11111.
       */
      static applyMaskPenaltyRule1(matrix2) {
        return MaskUtil.applyMaskPenaltyRule1Internal(matrix2, true) + MaskUtil.applyMaskPenaltyRule1Internal(matrix2, false);
      }
      /**
       * Apply mask penalty rule 2 and return the penalty. Find 2x2 blocks with the same color and give
       * penalty to them. This is actually equivalent to the spec's rule, which is to find MxN blocks and give a
       * penalty proportional to (M-1)x(N-1), because this is the number of 2x2 blocks inside such a block.
       */
      static applyMaskPenaltyRule2(matrix2) {
        let penalty = 0;
        const array = matrix2.getArray();
        const width = matrix2.getWidth();
        const height = matrix2.getHeight();
        for (let y = 0; y < height - 1; y++) {
          const arrayY = array[y];
          for (let x2 = 0; x2 < width - 1; x2++) {
            const value = arrayY[x2];
            if (value === arrayY[x2 + 1] && value === array[y + 1][x2] && value === array[y + 1][x2 + 1]) {
              penalty++;
            }
          }
        }
        return MaskUtil.N2 * penalty;
      }
      /**
       * Apply mask penalty rule 3 and return the penalty. Find consecutive runs of 1:1:3:1:1:4
       * starting with black, or 4:1:1:3:1:1 starting with white, and give penalty to them.  If we
       * find patterns like 000010111010000, we give penalty once.
       */
      static applyMaskPenaltyRule3(matrix2) {
        let numPenalties = 0;
        const array = matrix2.getArray();
        const width = matrix2.getWidth();
        const height = matrix2.getHeight();
        for (let y = 0; y < height; y++) {
          for (let x2 = 0; x2 < width; x2++) {
            const arrayY = array[y];
            if (x2 + 6 < width && arrayY[x2] === 1 && arrayY[x2 + 1] === 0 && arrayY[x2 + 2] === 1 && arrayY[x2 + 3] === 1 && arrayY[x2 + 4] === 1 && arrayY[x2 + 5] === 0 && arrayY[x2 + 6] === 1 && (MaskUtil.isWhiteHorizontal(arrayY, x2 - 4, x2) || MaskUtil.isWhiteHorizontal(arrayY, x2 + 7, x2 + 11))) {
              numPenalties++;
            }
            if (y + 6 < height && array[y][x2] === 1 && array[y + 1][x2] === 0 && array[y + 2][x2] === 1 && array[y + 3][x2] === 1 && array[y + 4][x2] === 1 && array[y + 5][x2] === 0 && array[y + 6][x2] === 1 && (MaskUtil.isWhiteVertical(array, x2, y - 4, y) || MaskUtil.isWhiteVertical(array, x2, y + 7, y + 11))) {
              numPenalties++;
            }
          }
        }
        return numPenalties * MaskUtil.N3;
      }
      static isWhiteHorizontal(rowArray, from, to) {
        from = Math.max(from, 0);
        to = Math.min(to, rowArray.length);
        for (let i2 = from; i2 < to; i2++) {
          if (rowArray[i2] === 1) {
            return false;
          }
        }
        return true;
      }
      static isWhiteVertical(array, col, from, to) {
        from = Math.max(from, 0);
        to = Math.min(to, array.length);
        for (let i2 = from; i2 < to; i2++) {
          if (array[i2][col] === 1) {
            return false;
          }
        }
        return true;
      }
      /**
       * Apply mask penalty rule 4 and return the penalty. Calculate the ratio of dark cells and give
       * penalty if the ratio is far from 50%. It gives 10 penalty for 5% distance.
       */
      static applyMaskPenaltyRule4(matrix2) {
        let numDarkCells = 0;
        const array = matrix2.getArray();
        const width = matrix2.getWidth();
        const height = matrix2.getHeight();
        for (let y = 0; y < height; y++) {
          const arrayY = array[y];
          for (let x2 = 0; x2 < width; x2++) {
            if (arrayY[x2] === 1) {
              numDarkCells++;
            }
          }
        }
        const numTotalCells = matrix2.getHeight() * matrix2.getWidth();
        const fivePercentVariances = Math.floor(Math.abs(numDarkCells * 2 - numTotalCells) * 10 / numTotalCells);
        return fivePercentVariances * MaskUtil.N4;
      }
      /**
       * Return the mask bit for "getMaskPattern" at "x" and "y". See 8.8 of JISX0510:2004 for mask
       * pattern conditions.
       */
      static getDataMaskBit(maskPattern, x2, y) {
        let intermediate;
        let temp;
        switch (maskPattern) {
          case 0:
            intermediate = y + x2 & 1;
            break;
          case 1:
            intermediate = y & 1;
            break;
          case 2:
            intermediate = x2 % 3;
            break;
          case 3:
            intermediate = (y + x2) % 3;
            break;
          case 4:
            intermediate = Math.floor(y / 2) + Math.floor(x2 / 3) & 1;
            break;
          case 5:
            temp = y * x2;
            intermediate = (temp & 1) + temp % 3;
            break;
          case 6:
            temp = y * x2;
            intermediate = (temp & 1) + temp % 3 & 1;
            break;
          case 7:
            temp = y * x2;
            intermediate = temp % 3 + (y + x2 & 1) & 1;
            break;
          default:
            throw new IllegalArgumentException("Invalid mask pattern: " + maskPattern);
        }
        return intermediate === 0;
      }
      /**
       * Helper function for applyMaskPenaltyRule1. We need this for doing this calculation in both
       * vertical and horizontal orders respectively.
       */
      static applyMaskPenaltyRule1Internal(matrix2, isHorizontal) {
        let penalty = 0;
        const iLimit = isHorizontal ? matrix2.getHeight() : matrix2.getWidth();
        const jLimit = isHorizontal ? matrix2.getWidth() : matrix2.getHeight();
        const array = matrix2.getArray();
        for (let i2 = 0; i2 < iLimit; i2++) {
          let numSameBitCells = 0;
          let prevBit = -1;
          for (let j = 0; j < jLimit; j++) {
            const bit = isHorizontal ? array[i2][j] : array[j][i2];
            if (bit === prevBit) {
              numSameBitCells++;
            } else {
              if (numSameBitCells >= 5) {
                penalty += MaskUtil.N1 + (numSameBitCells - 5);
              }
              numSameBitCells = 1;
              prevBit = bit;
            }
          }
          if (numSameBitCells >= 5) {
            penalty += MaskUtil.N1 + (numSameBitCells - 5);
          }
        }
        return penalty;
      }
    }
    MaskUtil.N1 = 3;
    MaskUtil.N2 = 3;
    MaskUtil.N3 = 40;
    MaskUtil.N4 = 10;
    class ByteMatrix {
      constructor(width, height) {
        this.width = width;
        this.height = height;
        const bytes = new Array(height);
        for (let i2 = 0; i2 !== height; i2++) {
          bytes[i2] = new Uint8Array(width);
        }
        this.bytes = bytes;
      }
      getHeight() {
        return this.height;
      }
      getWidth() {
        return this.width;
      }
      get(x2, y) {
        return this.bytes[y][x2];
      }
      /**
       * @return an internal representation as bytes, in row-major order. array[y][x] represents point (x,y)
       */
      getArray() {
        return this.bytes;
      }
      // TYPESCRIPTPORT: preffer to let two methods instead of override to avoid type comparison inside
      setNumber(x2, y, value) {
        this.bytes[y][x2] = value;
      }
      // public set(x: number /*int*/, y: number /*int*/, value: number /*int*/): void {
      //   bytes[y][x] = (byte) value
      // }
      setBoolean(x2, y, value) {
        this.bytes[y][x2] = /*(byte) */
        value ? 1 : 0;
      }
      clear(value) {
        for (const aByte of this.bytes) {
          Arrays.fill(aByte, value);
        }
      }
      equals(o) {
        if (!(o instanceof ByteMatrix)) {
          return false;
        }
        const other = o;
        if (this.width !== other.width) {
          return false;
        }
        if (this.height !== other.height) {
          return false;
        }
        for (let y = 0, height = this.height; y < height; ++y) {
          const bytesY = this.bytes[y];
          const otherBytesY = other.bytes[y];
          for (let x2 = 0, width = this.width; x2 < width; ++x2) {
            if (bytesY[x2] !== otherBytesY[x2]) {
              return false;
            }
          }
        }
        return true;
      }
      /*@Override*/
      toString() {
        const result2 = new StringBuilder();
        for (let y = 0, height = this.height; y < height; ++y) {
          const bytesY = this.bytes[y];
          for (let x2 = 0, width = this.width; x2 < width; ++x2) {
            switch (bytesY[x2]) {
              case 0:
                result2.append(" 0");
                break;
              case 1:
                result2.append(" 1");
                break;
              default:
                result2.append("  ");
                break;
            }
          }
          result2.append("\n");
        }
        return result2.toString();
      }
    }
    class QRCode {
      constructor() {
        this.maskPattern = -1;
      }
      getMode() {
        return this.mode;
      }
      getECLevel() {
        return this.ecLevel;
      }
      getVersion() {
        return this.version;
      }
      getMaskPattern() {
        return this.maskPattern;
      }
      getMatrix() {
        return this.matrix;
      }
      /*@Override*/
      toString() {
        const result2 = new StringBuilder();
        result2.append("<<\n");
        result2.append(" mode: ");
        result2.append(this.mode ? this.mode.toString() : "null");
        result2.append("\n ecLevel: ");
        result2.append(this.ecLevel ? this.ecLevel.toString() : "null");
        result2.append("\n version: ");
        result2.append(this.version ? this.version.toString() : "null");
        result2.append("\n maskPattern: ");
        result2.append(this.maskPattern.toString());
        if (this.matrix) {
          result2.append("\n matrix:\n");
          result2.append(this.matrix.toString());
        } else {
          result2.append("\n matrix: null\n");
        }
        result2.append(">>\n");
        return result2.toString();
      }
      setMode(value) {
        this.mode = value;
      }
      setECLevel(value) {
        this.ecLevel = value;
      }
      setVersion(version2) {
        this.version = version2;
      }
      setMaskPattern(value) {
        this.maskPattern = value;
      }
      setMatrix(value) {
        this.matrix = value;
      }
      // Check if "mask_pattern" is valid.
      static isValidMaskPattern(maskPattern) {
        return maskPattern >= 0 && maskPattern < QRCode.NUM_MASK_PATTERNS;
      }
    }
    QRCode.NUM_MASK_PATTERNS = 8;
    class WriterException extends Exception {
    }
    WriterException.kind = "WriterException";
    class MatrixUtil {
      constructor() {
      }
      // Set all cells to -1 (TYPESCRIPTPORT: 255).  -1 (TYPESCRIPTPORT: 255) means that the cell is empty (not set yet).
      //
      // JAVAPORT: We shouldn't need to do this at all. The code should be rewritten to begin encoding
      // with the ByteMatrix initialized all to zero.
      static clearMatrix(matrix2) {
        matrix2.clear(
          /*(byte) */
          /*-1*/
          255
        );
      }
      // Build 2D matrix of QR Code from "dataBits" with "ecLevel", "version" and "getMaskPattern". On
      // success, store the result in "matrix" and return true.
      static buildMatrix(dataBits, ecLevel, version2, maskPattern, matrix2) {
        MatrixUtil.clearMatrix(matrix2);
        MatrixUtil.embedBasicPatterns(version2, matrix2);
        MatrixUtil.embedTypeInfo(ecLevel, maskPattern, matrix2);
        MatrixUtil.maybeEmbedVersionInfo(version2, matrix2);
        MatrixUtil.embedDataBits(dataBits, maskPattern, matrix2);
      }
      // Embed basic patterns. On success, modify the matrix and return true.
      // The basic patterns are:
      // - Position detection patterns
      // - Timing patterns
      // - Dark dot at the left bottom corner
      // - Position adjustment patterns, if need be
      static embedBasicPatterns(version2, matrix2) {
        MatrixUtil.embedPositionDetectionPatternsAndSeparators(matrix2);
        MatrixUtil.embedDarkDotAtLeftBottomCorner(matrix2);
        MatrixUtil.maybeEmbedPositionAdjustmentPatterns(version2, matrix2);
        MatrixUtil.embedTimingPatterns(matrix2);
      }
      // Embed type information. On success, modify the matrix.
      static embedTypeInfo(ecLevel, maskPattern, matrix2) {
        const typeInfoBits = new BitArray();
        MatrixUtil.makeTypeInfoBits(ecLevel, maskPattern, typeInfoBits);
        for (let i2 = 0, size = typeInfoBits.getSize(); i2 < size; ++i2) {
          const bit = typeInfoBits.get(typeInfoBits.getSize() - 1 - i2);
          const coordinates = MatrixUtil.TYPE_INFO_COORDINATES[i2];
          const x1 = coordinates[0];
          const y1 = coordinates[1];
          matrix2.setBoolean(x1, y1, bit);
          if (i2 < 8) {
            const x2 = matrix2.getWidth() - i2 - 1;
            const y2 = 8;
            matrix2.setBoolean(x2, y2, bit);
          } else {
            const x2 = 8;
            const y2 = matrix2.getHeight() - 7 + (i2 - 8);
            matrix2.setBoolean(x2, y2, bit);
          }
        }
      }
      // Embed version information if need be. On success, modify the matrix and return true.
      // See 8.10 of JISX0510:2004 (p.47) for how to embed version information.
      static maybeEmbedVersionInfo(version2, matrix2) {
        if (version2.getVersionNumber() < 7) {
          return;
        }
        const versionInfoBits = new BitArray();
        MatrixUtil.makeVersionInfoBits(version2, versionInfoBits);
        let bitIndex = 6 * 3 - 1;
        for (let i2 = 0; i2 < 6; ++i2) {
          for (let j = 0; j < 3; ++j) {
            const bit = versionInfoBits.get(bitIndex);
            bitIndex--;
            matrix2.setBoolean(i2, matrix2.getHeight() - 11 + j, bit);
            matrix2.setBoolean(matrix2.getHeight() - 11 + j, i2, bit);
          }
        }
      }
      // Embed "dataBits" using "getMaskPattern". On success, modify the matrix and return true.
      // For debugging purposes, it skips masking process if "getMaskPattern" is -1(TYPESCRIPTPORT: 255).
      // See 8.7 of JISX0510:2004 (p.38) for how to embed data bits.
      static embedDataBits(dataBits, maskPattern, matrix2) {
        let bitIndex = 0;
        let direction = -1;
        let x2 = matrix2.getWidth() - 1;
        let y = matrix2.getHeight() - 1;
        while (x2 > 0) {
          if (x2 === 6) {
            x2 -= 1;
          }
          while (y >= 0 && y < matrix2.getHeight()) {
            for (let i2 = 0; i2 < 2; ++i2) {
              const xx = x2 - i2;
              if (!MatrixUtil.isEmpty(matrix2.get(xx, y))) {
                continue;
              }
              let bit;
              if (bitIndex < dataBits.getSize()) {
                bit = dataBits.get(bitIndex);
                ++bitIndex;
              } else {
                bit = false;
              }
              if (maskPattern !== 255 && MaskUtil.getDataMaskBit(maskPattern, xx, y)) {
                bit = !bit;
              }
              matrix2.setBoolean(xx, y, bit);
            }
            y += direction;
          }
          direction = -direction;
          y += direction;
          x2 -= 2;
        }
        if (bitIndex !== dataBits.getSize()) {
          throw new WriterException("Not all bits consumed: " + bitIndex + "/" + dataBits.getSize());
        }
      }
      // Return the position of the most significant bit set (one: to) in the "value". The most
      // significant bit is position 32. If there is no bit set, return 0. Examples:
      // - findMSBSet(0) => 0
      // - findMSBSet(1) => 1
      // - findMSBSet(255) => 8
      static findMSBSet(value) {
        return 32 - Integer.numberOfLeadingZeros(value);
      }
      // Calculate BCH (Bose-Chaudhuri-Hocquenghem) code for "value" using polynomial "poly". The BCH
      // code is used for encoding type information and version information.
      // Example: Calculation of version information of 7.
      // f(x) is created from 7.
      //   - 7 = 000111 in 6 bits
      //   - f(x) = x^2 + x^1 + x^0
      // g(x) is given by the standard (p. 67)
      //   - g(x) = x^12 + x^11 + x^10 + x^9 + x^8 + x^5 + x^2 + 1
      // Multiply f(x) by x^(18 - 6)
      //   - f'(x) = f(x) * x^(18 - 6)
      //   - f'(x) = x^14 + x^13 + x^12
      // Calculate the remainder of f'(x) / g(x)
      //         x^2
      //         __________________________________________________
      //   g(x) )x^14 + x^13 + x^12
      //         x^14 + x^13 + x^12 + x^11 + x^10 + x^7 + x^4 + x^2
      //         --------------------------------------------------
      //                              x^11 + x^10 + x^7 + x^4 + x^2
      //
      // The remainder is x^11 + x^10 + x^7 + x^4 + x^2
      // Encode it in binary: 110010010100
      // The return value is 0xc94 (1100 1001 0100)
      //
      // Since all coefficients in the polynomials are 1 or 0, we can do the calculation by bit
      // operations. We don't care if coefficients are positive or negative.
      static calculateBCHCode(value, poly) {
        if (poly === 0) {
          throw new IllegalArgumentException("0 polynomial");
        }
        const msbSetInPoly = MatrixUtil.findMSBSet(poly);
        value <<= msbSetInPoly - 1;
        while (MatrixUtil.findMSBSet(value) >= msbSetInPoly) {
          value ^= poly << MatrixUtil.findMSBSet(value) - msbSetInPoly;
        }
        return value;
      }
      // Make bit vector of type information. On success, store the result in "bits" and return true.
      // Encode error correction level and mask pattern. See 8.9 of
      // JISX0510:2004 (p.45) for details.
      static makeTypeInfoBits(ecLevel, maskPattern, bits) {
        if (!QRCode.isValidMaskPattern(maskPattern)) {
          throw new WriterException("Invalid mask pattern");
        }
        const typeInfo = ecLevel.getBits() << 3 | maskPattern;
        bits.appendBits(typeInfo, 5);
        const bchCode = MatrixUtil.calculateBCHCode(typeInfo, MatrixUtil.TYPE_INFO_POLY);
        bits.appendBits(bchCode, 10);
        const maskBits = new BitArray();
        maskBits.appendBits(MatrixUtil.TYPE_INFO_MASK_PATTERN, 15);
        bits.xor(maskBits);
        if (bits.getSize() !== 15) {
          throw new WriterException("should not happen but we got: " + bits.getSize());
        }
      }
      // Make bit vector of version information. On success, store the result in "bits" and return true.
      // See 8.10 of JISX0510:2004 (p.45) for details.
      static makeVersionInfoBits(version2, bits) {
        bits.appendBits(version2.getVersionNumber(), 6);
        const bchCode = MatrixUtil.calculateBCHCode(version2.getVersionNumber(), MatrixUtil.VERSION_INFO_POLY);
        bits.appendBits(bchCode, 12);
        if (bits.getSize() !== 18) {
          throw new WriterException("should not happen but we got: " + bits.getSize());
        }
      }
      // Check if "value" is empty.
      static isEmpty(value) {
        return value === 255;
      }
      static embedTimingPatterns(matrix2) {
        for (let i2 = 8; i2 < matrix2.getWidth() - 8; ++i2) {
          const bit = (i2 + 1) % 2;
          if (MatrixUtil.isEmpty(matrix2.get(i2, 6))) {
            matrix2.setNumber(i2, 6, bit);
          }
          if (MatrixUtil.isEmpty(matrix2.get(6, i2))) {
            matrix2.setNumber(6, i2, bit);
          }
        }
      }
      // Embed the lonely dark dot at left bottom corner. JISX0510:2004 (p.46)
      static embedDarkDotAtLeftBottomCorner(matrix2) {
        if (matrix2.get(8, matrix2.getHeight() - 8) === 0) {
          throw new WriterException();
        }
        matrix2.setNumber(8, matrix2.getHeight() - 8, 1);
      }
      static embedHorizontalSeparationPattern(xStart, yStart, matrix2) {
        for (let x2 = 0; x2 < 8; ++x2) {
          if (!MatrixUtil.isEmpty(matrix2.get(xStart + x2, yStart))) {
            throw new WriterException();
          }
          matrix2.setNumber(xStart + x2, yStart, 0);
        }
      }
      static embedVerticalSeparationPattern(xStart, yStart, matrix2) {
        for (let y = 0; y < 7; ++y) {
          if (!MatrixUtil.isEmpty(matrix2.get(xStart, yStart + y))) {
            throw new WriterException();
          }
          matrix2.setNumber(xStart, yStart + y, 0);
        }
      }
      static embedPositionAdjustmentPattern(xStart, yStart, matrix2) {
        for (let y = 0; y < 5; ++y) {
          const patternY = MatrixUtil.POSITION_ADJUSTMENT_PATTERN[y];
          for (let x2 = 0; x2 < 5; ++x2) {
            matrix2.setNumber(xStart + x2, yStart + y, patternY[x2]);
          }
        }
      }
      static embedPositionDetectionPattern(xStart, yStart, matrix2) {
        for (let y = 0; y < 7; ++y) {
          const patternY = MatrixUtil.POSITION_DETECTION_PATTERN[y];
          for (let x2 = 0; x2 < 7; ++x2) {
            matrix2.setNumber(xStart + x2, yStart + y, patternY[x2]);
          }
        }
      }
      // Embed position detection patterns and surrounding vertical/horizontal separators.
      static embedPositionDetectionPatternsAndSeparators(matrix2) {
        const pdpWidth = MatrixUtil.POSITION_DETECTION_PATTERN[0].length;
        MatrixUtil.embedPositionDetectionPattern(0, 0, matrix2);
        MatrixUtil.embedPositionDetectionPattern(matrix2.getWidth() - pdpWidth, 0, matrix2);
        MatrixUtil.embedPositionDetectionPattern(0, matrix2.getWidth() - pdpWidth, matrix2);
        const hspWidth = 8;
        MatrixUtil.embedHorizontalSeparationPattern(0, hspWidth - 1, matrix2);
        MatrixUtil.embedHorizontalSeparationPattern(matrix2.getWidth() - hspWidth, hspWidth - 1, matrix2);
        MatrixUtil.embedHorizontalSeparationPattern(0, matrix2.getWidth() - hspWidth, matrix2);
        const vspSize = 7;
        MatrixUtil.embedVerticalSeparationPattern(vspSize, 0, matrix2);
        MatrixUtil.embedVerticalSeparationPattern(matrix2.getHeight() - vspSize - 1, 0, matrix2);
        MatrixUtil.embedVerticalSeparationPattern(vspSize, matrix2.getHeight() - vspSize, matrix2);
      }
      // Embed position adjustment patterns if need be.
      static maybeEmbedPositionAdjustmentPatterns(version2, matrix2) {
        if (version2.getVersionNumber() < 2) {
          return;
        }
        const index2 = version2.getVersionNumber() - 1;
        const coordinates = MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[index2];
        for (let i2 = 0, length = coordinates.length; i2 !== length; i2++) {
          const y = coordinates[i2];
          if (y >= 0) {
            for (let j = 0; j !== length; j++) {
              const x2 = coordinates[j];
              if (x2 >= 0 && MatrixUtil.isEmpty(matrix2.get(x2, y))) {
                MatrixUtil.embedPositionAdjustmentPattern(x2 - 2, y - 2, matrix2);
              }
            }
          }
        }
      }
    }
    MatrixUtil.POSITION_DETECTION_PATTERN = Array.from([
      Int32Array.from([1, 1, 1, 1, 1, 1, 1]),
      Int32Array.from([1, 0, 0, 0, 0, 0, 1]),
      Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
      Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
      Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
      Int32Array.from([1, 0, 0, 0, 0, 0, 1]),
      Int32Array.from([1, 1, 1, 1, 1, 1, 1])
    ]);
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN = Array.from([
      Int32Array.from([1, 1, 1, 1, 1]),
      Int32Array.from([1, 0, 0, 0, 1]),
      Int32Array.from([1, 0, 1, 0, 1]),
      Int32Array.from([1, 0, 0, 0, 1]),
      Int32Array.from([1, 1, 1, 1, 1])
    ]);
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
      Int32Array.from([-1, -1, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 18, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 22, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 26, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 30, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 34, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 22, 38, -1, -1, -1, -1]),
      Int32Array.from([6, 24, 42, -1, -1, -1, -1]),
      Int32Array.from([6, 26, 46, -1, -1, -1, -1]),
      Int32Array.from([6, 28, 50, -1, -1, -1, -1]),
      Int32Array.from([6, 30, 54, -1, -1, -1, -1]),
      Int32Array.from([6, 32, 58, -1, -1, -1, -1]),
      Int32Array.from([6, 34, 62, -1, -1, -1, -1]),
      Int32Array.from([6, 26, 46, 66, -1, -1, -1]),
      Int32Array.from([6, 26, 48, 70, -1, -1, -1]),
      Int32Array.from([6, 26, 50, 74, -1, -1, -1]),
      Int32Array.from([6, 30, 54, 78, -1, -1, -1]),
      Int32Array.from([6, 30, 56, 82, -1, -1, -1]),
      Int32Array.from([6, 30, 58, 86, -1, -1, -1]),
      Int32Array.from([6, 34, 62, 90, -1, -1, -1]),
      Int32Array.from([6, 28, 50, 72, 94, -1, -1]),
      Int32Array.from([6, 26, 50, 74, 98, -1, -1]),
      Int32Array.from([6, 30, 54, 78, 102, -1, -1]),
      Int32Array.from([6, 28, 54, 80, 106, -1, -1]),
      Int32Array.from([6, 32, 58, 84, 110, -1, -1]),
      Int32Array.from([6, 30, 58, 86, 114, -1, -1]),
      Int32Array.from([6, 34, 62, 90, 118, -1, -1]),
      Int32Array.from([6, 26, 50, 74, 98, 122, -1]),
      Int32Array.from([6, 30, 54, 78, 102, 126, -1]),
      Int32Array.from([6, 26, 52, 78, 104, 130, -1]),
      Int32Array.from([6, 30, 56, 82, 108, 134, -1]),
      Int32Array.from([6, 34, 60, 86, 112, 138, -1]),
      Int32Array.from([6, 30, 58, 86, 114, 142, -1]),
      Int32Array.from([6, 34, 62, 90, 118, 146, -1]),
      Int32Array.from([6, 30, 54, 78, 102, 126, 150]),
      Int32Array.from([6, 24, 50, 76, 102, 128, 154]),
      Int32Array.from([6, 28, 54, 80, 106, 132, 158]),
      Int32Array.from([6, 32, 58, 84, 110, 136, 162]),
      Int32Array.from([6, 26, 54, 82, 110, 138, 166]),
      Int32Array.from([6, 30, 58, 86, 114, 142, 170])
    ]);
    MatrixUtil.TYPE_INFO_COORDINATES = Array.from([
      Int32Array.from([8, 0]),
      Int32Array.from([8, 1]),
      Int32Array.from([8, 2]),
      Int32Array.from([8, 3]),
      Int32Array.from([8, 4]),
      Int32Array.from([8, 5]),
      Int32Array.from([8, 7]),
      Int32Array.from([8, 8]),
      Int32Array.from([7, 8]),
      Int32Array.from([5, 8]),
      Int32Array.from([4, 8]),
      Int32Array.from([3, 8]),
      Int32Array.from([2, 8]),
      Int32Array.from([1, 8]),
      Int32Array.from([0, 8])
    ]);
    MatrixUtil.VERSION_INFO_POLY = 7973;
    MatrixUtil.TYPE_INFO_POLY = 1335;
    MatrixUtil.TYPE_INFO_MASK_PATTERN = 21522;
    class BlockPair {
      constructor(dataBytes, errorCorrectionBytes) {
        this.dataBytes = dataBytes;
        this.errorCorrectionBytes = errorCorrectionBytes;
      }
      getDataBytes() {
        return this.dataBytes;
      }
      getErrorCorrectionBytes() {
        return this.errorCorrectionBytes;
      }
    }
    class Encoder {
      // TYPESCRIPTPORT: changed to UTF8, the default for js
      constructor() {
      }
      // The mask penalty calculation is complicated.  See Table 21 of JISX0510:2004 (p.45) for details.
      // Basically it applies four rules and summate all penalties.
      static calculateMaskPenalty(matrix2) {
        return MaskUtil.applyMaskPenaltyRule1(matrix2) + MaskUtil.applyMaskPenaltyRule2(matrix2) + MaskUtil.applyMaskPenaltyRule3(matrix2) + MaskUtil.applyMaskPenaltyRule4(matrix2);
      }
      /**
       * @param content text to encode
       * @param ecLevel error correction level to use
       * @return {@link QRCode} representing the encoded QR code
       * @throws WriterException if encoding can't succeed, because of for example invalid content
       *   or configuration
       */
      // public static encode(content: string, ecLevel: ErrorCorrectionLevel): QRCode /*throws WriterException*/ {
      //   return encode(content, ecLevel, null)
      // }
      static encode(content, ecLevel, hints = null) {
        let encoding = Encoder.DEFAULT_BYTE_MODE_ENCODING;
        const hasEncodingHint = hints !== null && void 0 !== hints.get(EncodeHintType$1.CHARACTER_SET);
        if (hasEncodingHint) {
          encoding = hints.get(EncodeHintType$1.CHARACTER_SET).toString();
        }
        const mode = this.chooseMode(content, encoding);
        const headerBits = new BitArray();
        if (mode === Mode$1.BYTE && (hasEncodingHint || Encoder.DEFAULT_BYTE_MODE_ENCODING !== encoding)) {
          const eci = CharacterSetECI.getCharacterSetECIByName(encoding);
          if (eci !== void 0) {
            this.appendECI(eci, headerBits);
          }
        }
        this.appendModeInfo(mode, headerBits);
        const dataBits = new BitArray();
        this.appendBytes(content, mode, dataBits, encoding);
        let version2;
        if (hints !== null && void 0 !== hints.get(EncodeHintType$1.QR_VERSION)) {
          const versionNumber = Number.parseInt(hints.get(EncodeHintType$1.QR_VERSION).toString(), 10);
          version2 = Version$1.getVersionForNumber(versionNumber);
          const bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, version2);
          if (!this.willFit(bitsNeeded, version2, ecLevel)) {
            throw new WriterException("Data too big for requested version");
          }
        } else {
          version2 = this.recommendVersion(ecLevel, mode, headerBits, dataBits);
        }
        const headerAndDataBits = new BitArray();
        headerAndDataBits.appendBitArray(headerBits);
        const numLetters = mode === Mode$1.BYTE ? dataBits.getSizeInBytes() : content.length;
        this.appendLengthInfo(numLetters, version2, mode, headerAndDataBits);
        headerAndDataBits.appendBitArray(dataBits);
        const ecBlocks = version2.getECBlocksForLevel(ecLevel);
        const numDataBytes = version2.getTotalCodewords() - ecBlocks.getTotalECCodewords();
        this.terminateBits(numDataBytes, headerAndDataBits);
        const finalBits = this.interleaveWithECBytes(headerAndDataBits, version2.getTotalCodewords(), numDataBytes, ecBlocks.getNumBlocks());
        const qrCode = new QRCode();
        qrCode.setECLevel(ecLevel);
        qrCode.setMode(mode);
        qrCode.setVersion(version2);
        const dimension = version2.getDimensionForVersion();
        const matrix2 = new ByteMatrix(dimension, dimension);
        const maskPattern = this.chooseMaskPattern(finalBits, ecLevel, version2, matrix2);
        qrCode.setMaskPattern(maskPattern);
        MatrixUtil.buildMatrix(finalBits, ecLevel, version2, maskPattern, matrix2);
        qrCode.setMatrix(matrix2);
        return qrCode;
      }
      /**
       * Decides the smallest version of QR code that will contain all of the provided data.
       *
       * @throws WriterException if the data cannot fit in any version
       */
      static recommendVersion(ecLevel, mode, headerBits, dataBits) {
        const provisionalBitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, Version$1.getVersionForNumber(1));
        const provisionalVersion = this.chooseVersion(provisionalBitsNeeded, ecLevel);
        const bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, provisionalVersion);
        return this.chooseVersion(bitsNeeded, ecLevel);
      }
      static calculateBitsNeeded(mode, headerBits, dataBits, version2) {
        return headerBits.getSize() + mode.getCharacterCountBits(version2) + dataBits.getSize();
      }
      /**
       * @return the code point of the table used in alphanumeric mode or
       *  -1 if there is no corresponding code in the table.
       */
      static getAlphanumericCode(code) {
        if (code < Encoder.ALPHANUMERIC_TABLE.length) {
          return Encoder.ALPHANUMERIC_TABLE[code];
        }
        return -1;
      }
      // public static chooseMode(content: string): Mode {
      //   return chooseMode(content, null);
      // }
      /**
       * Choose the best mode by examining the content. Note that 'encoding' is used as a hint;
       * if it is Shift_JIS, and the input is only double-byte Kanji, then we return {@link Mode#KANJI}.
       */
      static chooseMode(content, encoding = null) {
        if (CharacterSetECI.SJIS.getName() === encoding && this.isOnlyDoubleByteKanji(content)) {
          return Mode$1.KANJI;
        }
        let hasNumeric = false;
        let hasAlphanumeric = false;
        for (let i2 = 0, length = content.length; i2 < length; ++i2) {
          const c = content.charAt(i2);
          if (Encoder.isDigit(c)) {
            hasNumeric = true;
          } else if (this.getAlphanumericCode(c.charCodeAt(0)) !== -1) {
            hasAlphanumeric = true;
          } else {
            return Mode$1.BYTE;
          }
        }
        if (hasAlphanumeric) {
          return Mode$1.ALPHANUMERIC;
        }
        if (hasNumeric) {
          return Mode$1.NUMERIC;
        }
        return Mode$1.BYTE;
      }
      static isOnlyDoubleByteKanji(content) {
        let bytes;
        try {
          bytes = StringEncoding.encode(content, CharacterSetECI.SJIS);
        } catch (ignored) {
          return false;
        }
        const length = bytes.length;
        if (length % 2 !== 0) {
          return false;
        }
        for (let i2 = 0; i2 < length; i2 += 2) {
          const byte1 = bytes[i2] & 255;
          if ((byte1 < 129 || byte1 > 159) && (byte1 < 224 || byte1 > 235)) {
            return false;
          }
        }
        return true;
      }
      static chooseMaskPattern(bits, ecLevel, version2, matrix2) {
        let minPenalty = Number.MAX_SAFE_INTEGER;
        let bestMaskPattern = -1;
        for (let maskPattern = 0; maskPattern < QRCode.NUM_MASK_PATTERNS; maskPattern++) {
          MatrixUtil.buildMatrix(bits, ecLevel, version2, maskPattern, matrix2);
          let penalty = this.calculateMaskPenalty(matrix2);
          if (penalty < minPenalty) {
            minPenalty = penalty;
            bestMaskPattern = maskPattern;
          }
        }
        return bestMaskPattern;
      }
      static chooseVersion(numInputBits, ecLevel) {
        for (let versionNum = 1; versionNum <= 40; versionNum++) {
          const version2 = Version$1.getVersionForNumber(versionNum);
          if (Encoder.willFit(numInputBits, version2, ecLevel)) {
            return version2;
          }
        }
        throw new WriterException("Data too big");
      }
      /**
       * @return true if the number of input bits will fit in a code with the specified version and
       * error correction level.
       */
      static willFit(numInputBits, version2, ecLevel) {
        const numBytes = version2.getTotalCodewords();
        const ecBlocks = version2.getECBlocksForLevel(ecLevel);
        const numEcBytes = ecBlocks.getTotalECCodewords();
        const numDataBytes = numBytes - numEcBytes;
        const totalInputBytes = (numInputBits + 7) / 8;
        return numDataBytes >= totalInputBytes;
      }
      /**
       * Terminate bits as described in 8.4.8 and 8.4.9 of JISX0510:2004 (p.24).
       */
      static terminateBits(numDataBytes, bits) {
        const capacity = numDataBytes * 8;
        if (bits.getSize() > capacity) {
          throw new WriterException("data bits cannot fit in the QR Code" + bits.getSize() + " > " + capacity);
        }
        for (let i2 = 0; i2 < 4 && bits.getSize() < capacity; ++i2) {
          bits.appendBit(false);
        }
        const numBitsInLastByte = bits.getSize() & 7;
        if (numBitsInLastByte > 0) {
          for (let i2 = numBitsInLastByte; i2 < 8; i2++) {
            bits.appendBit(false);
          }
        }
        const numPaddingBytes = numDataBytes - bits.getSizeInBytes();
        for (let i2 = 0; i2 < numPaddingBytes; ++i2) {
          bits.appendBits((i2 & 1) === 0 ? 236 : 17, 8);
        }
        if (bits.getSize() !== capacity) {
          throw new WriterException("Bits size does not equal capacity");
        }
      }
      /**
       * Get number of data bytes and number of error correction bytes for block id "blockID". Store
       * the result in "numDataBytesInBlock", and "numECBytesInBlock". See table 12 in 8.5.1 of
       * JISX0510:2004 (p.30)
       */
      static getNumDataBytesAndNumECBytesForBlockID(numTotalBytes, numDataBytes, numRSBlocks, blockID, numDataBytesInBlock, numECBytesInBlock) {
        if (blockID >= numRSBlocks) {
          throw new WriterException("Block ID too large");
        }
        const numRsBlocksInGroup2 = numTotalBytes % numRSBlocks;
        const numRsBlocksInGroup1 = numRSBlocks - numRsBlocksInGroup2;
        const numTotalBytesInGroup1 = Math.floor(numTotalBytes / numRSBlocks);
        const numTotalBytesInGroup2 = numTotalBytesInGroup1 + 1;
        const numDataBytesInGroup1 = Math.floor(numDataBytes / numRSBlocks);
        const numDataBytesInGroup2 = numDataBytesInGroup1 + 1;
        const numEcBytesInGroup1 = numTotalBytesInGroup1 - numDataBytesInGroup1;
        const numEcBytesInGroup2 = numTotalBytesInGroup2 - numDataBytesInGroup2;
        if (numEcBytesInGroup1 !== numEcBytesInGroup2) {
          throw new WriterException("EC bytes mismatch");
        }
        if (numRSBlocks !== numRsBlocksInGroup1 + numRsBlocksInGroup2) {
          throw new WriterException("RS blocks mismatch");
        }
        if (numTotalBytes !== (numDataBytesInGroup1 + numEcBytesInGroup1) * numRsBlocksInGroup1 + (numDataBytesInGroup2 + numEcBytesInGroup2) * numRsBlocksInGroup2) {
          throw new WriterException("Total bytes mismatch");
        }
        if (blockID < numRsBlocksInGroup1) {
          numDataBytesInBlock[0] = numDataBytesInGroup1;
          numECBytesInBlock[0] = numEcBytesInGroup1;
        } else {
          numDataBytesInBlock[0] = numDataBytesInGroup2;
          numECBytesInBlock[0] = numEcBytesInGroup2;
        }
      }
      /**
       * Interleave "bits" with corresponding error correction bytes. On success, store the result in
       * "result". The interleave rule is complicated. See 8.6 of JISX0510:2004 (p.37) for details.
       */
      static interleaveWithECBytes(bits, numTotalBytes, numDataBytes, numRSBlocks) {
        if (bits.getSizeInBytes() !== numDataBytes) {
          throw new WriterException("Number of bits and data bytes does not match");
        }
        let dataBytesOffset = 0;
        let maxNumDataBytes = 0;
        let maxNumEcBytes = 0;
        const blocks = new Array();
        for (let i2 = 0; i2 < numRSBlocks; ++i2) {
          const numDataBytesInBlock = new Int32Array(1);
          const numEcBytesInBlock = new Int32Array(1);
          Encoder.getNumDataBytesAndNumECBytesForBlockID(numTotalBytes, numDataBytes, numRSBlocks, i2, numDataBytesInBlock, numEcBytesInBlock);
          const size = numDataBytesInBlock[0];
          const dataBytes = new Uint8Array(size);
          bits.toBytes(8 * dataBytesOffset, dataBytes, 0, size);
          const ecBytes = Encoder.generateECBytes(dataBytes, numEcBytesInBlock[0]);
          blocks.push(new BlockPair(dataBytes, ecBytes));
          maxNumDataBytes = Math.max(maxNumDataBytes, size);
          maxNumEcBytes = Math.max(maxNumEcBytes, ecBytes.length);
          dataBytesOffset += numDataBytesInBlock[0];
        }
        if (numDataBytes !== dataBytesOffset) {
          throw new WriterException("Data bytes does not match offset");
        }
        const result2 = new BitArray();
        for (let i2 = 0; i2 < maxNumDataBytes; ++i2) {
          for (const block2 of blocks) {
            const dataBytes = block2.getDataBytes();
            if (i2 < dataBytes.length) {
              result2.appendBits(dataBytes[i2], 8);
            }
          }
        }
        for (let i2 = 0; i2 < maxNumEcBytes; ++i2) {
          for (const block2 of blocks) {
            const ecBytes = block2.getErrorCorrectionBytes();
            if (i2 < ecBytes.length) {
              result2.appendBits(ecBytes[i2], 8);
            }
          }
        }
        if (numTotalBytes !== result2.getSizeInBytes()) {
          throw new WriterException("Interleaving error: " + numTotalBytes + " and " + result2.getSizeInBytes() + " differ.");
        }
        return result2;
      }
      static generateECBytes(dataBytes, numEcBytesInBlock) {
        const numDataBytes = dataBytes.length;
        const toEncode = new Int32Array(numDataBytes + numEcBytesInBlock);
        for (let i2 = 0; i2 < numDataBytes; i2++) {
          toEncode[i2] = dataBytes[i2] & 255;
        }
        new ReedSolomonEncoder(GenericGF.QR_CODE_FIELD_256).encode(toEncode, numEcBytesInBlock);
        const ecBytes = new Uint8Array(numEcBytesInBlock);
        for (let i2 = 0; i2 < numEcBytesInBlock; i2++) {
          ecBytes[i2] = /*(byte) */
          toEncode[numDataBytes + i2];
        }
        return ecBytes;
      }
      /**
       * Append mode info. On success, store the result in "bits".
       */
      static appendModeInfo(mode, bits) {
        bits.appendBits(mode.getBits(), 4);
      }
      /**
       * Append length info. On success, store the result in "bits".
       */
      static appendLengthInfo(numLetters, version2, mode, bits) {
        const numBits = mode.getCharacterCountBits(version2);
        if (numLetters >= 1 << numBits) {
          throw new WriterException(numLetters + " is bigger than " + ((1 << numBits) - 1));
        }
        bits.appendBits(numLetters, numBits);
      }
      /**
       * Append "bytes" in "mode" mode (encoding) into "bits". On success, store the result in "bits".
       */
      static appendBytes(content, mode, bits, encoding) {
        switch (mode) {
          case Mode$1.NUMERIC:
            Encoder.appendNumericBytes(content, bits);
            break;
          case Mode$1.ALPHANUMERIC:
            Encoder.appendAlphanumericBytes(content, bits);
            break;
          case Mode$1.BYTE:
            Encoder.append8BitBytes(content, bits, encoding);
            break;
          case Mode$1.KANJI:
            Encoder.appendKanjiBytes(content, bits);
            break;
          default:
            throw new WriterException("Invalid mode: " + mode);
        }
      }
      static getDigit(singleCharacter) {
        return singleCharacter.charCodeAt(0) - 48;
      }
      static isDigit(singleCharacter) {
        const cn = Encoder.getDigit(singleCharacter);
        return cn >= 0 && cn <= 9;
      }
      static appendNumericBytes(content, bits) {
        const length = content.length;
        let i2 = 0;
        while (i2 < length) {
          const num1 = Encoder.getDigit(content.charAt(i2));
          if (i2 + 2 < length) {
            const num2 = Encoder.getDigit(content.charAt(i2 + 1));
            const num3 = Encoder.getDigit(content.charAt(i2 + 2));
            bits.appendBits(num1 * 100 + num2 * 10 + num3, 10);
            i2 += 3;
          } else if (i2 + 1 < length) {
            const num2 = Encoder.getDigit(content.charAt(i2 + 1));
            bits.appendBits(num1 * 10 + num2, 7);
            i2 += 2;
          } else {
            bits.appendBits(num1, 4);
            i2++;
          }
        }
      }
      static appendAlphanumericBytes(content, bits) {
        const length = content.length;
        let i2 = 0;
        while (i2 < length) {
          const code1 = Encoder.getAlphanumericCode(content.charCodeAt(i2));
          if (code1 === -1) {
            throw new WriterException();
          }
          if (i2 + 1 < length) {
            const code2 = Encoder.getAlphanumericCode(content.charCodeAt(i2 + 1));
            if (code2 === -1) {
              throw new WriterException();
            }
            bits.appendBits(code1 * 45 + code2, 11);
            i2 += 2;
          } else {
            bits.appendBits(code1, 6);
            i2++;
          }
        }
      }
      static append8BitBytes(content, bits, encoding) {
        let bytes;
        try {
          bytes = StringEncoding.encode(content, encoding);
        } catch (uee) {
          throw new WriterException(uee);
        }
        for (let i2 = 0, length = bytes.length; i2 !== length; i2++) {
          const b = bytes[i2];
          bits.appendBits(b, 8);
        }
      }
      /**
       * @throws WriterException
       */
      static appendKanjiBytes(content, bits) {
        let bytes;
        try {
          bytes = StringEncoding.encode(content, CharacterSetECI.SJIS);
        } catch (uee) {
          throw new WriterException(uee);
        }
        const length = bytes.length;
        for (let i2 = 0; i2 < length; i2 += 2) {
          const byte1 = bytes[i2] & 255;
          const byte2 = bytes[i2 + 1] & 255;
          const code = byte1 << 8 & 4294967295 | byte2;
          let subtracted = -1;
          if (code >= 33088 && code <= 40956) {
            subtracted = code - 33088;
          } else if (code >= 57408 && code <= 60351) {
            subtracted = code - 49472;
          }
          if (subtracted === -1) {
            throw new WriterException("Invalid byte sequence");
          }
          const encoded = (subtracted >> 8) * 192 + (subtracted & 255);
          bits.appendBits(encoded, 13);
        }
      }
      static appendECI(eci, bits) {
        bits.appendBits(Mode$1.ECI.getBits(), 4);
        bits.appendBits(eci.getValue(), 8);
      }
    }
    Encoder.ALPHANUMERIC_TABLE = Int32Array.from([
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      36,
      -1,
      -1,
      -1,
      37,
      38,
      -1,
      -1,
      -1,
      -1,
      39,
      40,
      -1,
      41,
      42,
      43,
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      44,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      -1,
      -1,
      -1,
      -1,
      -1
    ]);
    Encoder.DEFAULT_BYTE_MODE_ENCODING = CharacterSetECI.UTF8.getName();
    class BrowserQRCodeSvgWriter {
      /**
       * Writes and renders a QRCode SVG element.
       *
       * @param contents
       * @param width
       * @param height
       * @param hints
       */
      write(contents, width, height, hints = null) {
        if (contents.length === 0) {
          throw new IllegalArgumentException("Found empty contents");
        }
        if (width < 0 || height < 0) {
          throw new IllegalArgumentException("Requested dimensions are too small: " + width + "x" + height);
        }
        let errorCorrectionLevel = ErrorCorrectionLevel.L;
        let quietZone = BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE;
        if (hints !== null) {
          if (void 0 !== hints.get(EncodeHintType$1.ERROR_CORRECTION)) {
            errorCorrectionLevel = ErrorCorrectionLevel.fromString(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
          }
          if (void 0 !== hints.get(EncodeHintType$1.MARGIN)) {
            quietZone = Number.parseInt(hints.get(EncodeHintType$1.MARGIN).toString(), 10);
          }
        }
        const code = Encoder.encode(contents, errorCorrectionLevel, hints);
        return this.renderResult(code, width, height, quietZone);
      }
      /**
       * Renders the result and then appends it to the DOM.
       */
      writeToDom(containerElement, contents, width, height, hints = null) {
        if (typeof containerElement === "string") {
          containerElement = document.querySelector(containerElement);
        }
        const svgElement = this.write(contents, width, height, hints);
        if (containerElement)
          containerElement.appendChild(svgElement);
      }
      /**
       * Note that the input matrix uses 0 == white, 1 == black.
       * The output matrix uses 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
       */
      renderResult(code, width, height, quietZone) {
        const input2 = code.getMatrix();
        if (input2 === null) {
          throw new IllegalStateException();
        }
        const inputWidth = input2.getWidth();
        const inputHeight = input2.getHeight();
        const qrWidth = inputWidth + quietZone * 2;
        const qrHeight = inputHeight + quietZone * 2;
        const outputWidth = Math.max(width, qrWidth);
        const outputHeight = Math.max(height, qrHeight);
        const multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
        const leftPadding = Math.floor((outputWidth - inputWidth * multiple) / 2);
        const topPadding = Math.floor((outputHeight - inputHeight * multiple) / 2);
        const svgElement = this.createSVGElement(outputWidth, outputHeight);
        for (let inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple) {
          for (let inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple) {
            if (input2.get(inputX, inputY) === 1) {
              const svgRectElement = this.createSvgRectElement(outputX, outputY, multiple, multiple);
              svgElement.appendChild(svgRectElement);
            }
          }
        }
        return svgElement;
      }
      /**
       * Creates a SVG element.
       *
       * @param w SVG's width attribute
       * @param h SVG's height attribute
       */
      createSVGElement(w, h) {
        const svgElement = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, "svg");
        svgElement.setAttributeNS(null, "height", w.toString());
        svgElement.setAttributeNS(null, "width", h.toString());
        return svgElement;
      }
      /**
       * Creates a SVG rect element.
       *
       * @param x Element's x coordinate
       * @param y Element's y coordinate
       * @param w Element's width attribute
       * @param h Element's height attribute
       */
      createSvgRectElement(x2, y, w, h) {
        const rect = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, "rect");
        rect.setAttributeNS(null, "x", x2.toString());
        rect.setAttributeNS(null, "y", y.toString());
        rect.setAttributeNS(null, "height", w.toString());
        rect.setAttributeNS(null, "width", h.toString());
        rect.setAttributeNS(null, "fill", "#000000");
        return rect;
      }
    }
    BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE = 4;
    BrowserQRCodeSvgWriter.SVG_NS = "http://www.w3.org/2000/svg";
    class QRCodeWriter {
      /*@Override*/
      // public encode(contents: string, format: BarcodeFormat, width: number /*int*/, height: number /*int*/): BitMatrix
      //     /*throws WriterException */ {
      //   return encode(contents, format, width, height, null)
      // }
      /*@Override*/
      encode(contents, format, width, height, hints) {
        if (contents.length === 0) {
          throw new IllegalArgumentException("Found empty contents");
        }
        if (format !== BarcodeFormat$1.QR_CODE) {
          throw new IllegalArgumentException("Can only encode QR_CODE, but got " + format);
        }
        if (width < 0 || height < 0) {
          throw new IllegalArgumentException(`Requested dimensions are too small: ${width}x${height}`);
        }
        let errorCorrectionLevel = ErrorCorrectionLevel.L;
        let quietZone = QRCodeWriter.QUIET_ZONE_SIZE;
        if (hints !== null) {
          if (void 0 !== hints.get(EncodeHintType$1.ERROR_CORRECTION)) {
            errorCorrectionLevel = ErrorCorrectionLevel.fromString(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
          }
          if (void 0 !== hints.get(EncodeHintType$1.MARGIN)) {
            quietZone = Number.parseInt(hints.get(EncodeHintType$1.MARGIN).toString(), 10);
          }
        }
        const code = Encoder.encode(contents, errorCorrectionLevel, hints);
        return QRCodeWriter.renderResult(code, width, height, quietZone);
      }
      // Note that the input matrix uses 0 == white, 1 == black, while the output matrix uses
      // 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
      static renderResult(code, width, height, quietZone) {
        const input2 = code.getMatrix();
        if (input2 === null) {
          throw new IllegalStateException();
        }
        const inputWidth = input2.getWidth();
        const inputHeight = input2.getHeight();
        const qrWidth = inputWidth + quietZone * 2;
        const qrHeight = inputHeight + quietZone * 2;
        const outputWidth = Math.max(width, qrWidth);
        const outputHeight = Math.max(height, qrHeight);
        const multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
        const leftPadding = Math.floor((outputWidth - inputWidth * multiple) / 2);
        const topPadding = Math.floor((outputHeight - inputHeight * multiple) / 2);
        const output = new BitMatrix(outputWidth, outputHeight);
        for (let inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple) {
          for (let inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple) {
            if (input2.get(inputX, inputY) === 1) {
              output.setRegion(outputX, outputY, multiple, multiple);
            }
          }
        }
        return output;
      }
    }
    QRCodeWriter.QUIET_ZONE_SIZE = 4;
    class MultiFormatWriter {
      /*@Override*/
      // public encode(contents: string,
      //                         format: BarcodeFormat,
      //                         width: number /*int*/,
      //                         height: number /*int*/): BitMatrix /*throws WriterException */ {
      //   return encode(contents, format, width, height, null)
      // }
      /*@Override*/
      encode(contents, format, width, height, hints) {
        let writer;
        switch (format) {
          case BarcodeFormat$1.QR_CODE:
            writer = new QRCodeWriter();
            break;
          default:
            throw new IllegalArgumentException("No encoder available for format " + format);
        }
        return writer.encode(contents, format, width, height, hints);
      }
    }
    class PlanarYUVLuminanceSource extends LuminanceSource {
      constructor(yuvData, dataWidth, dataHeight, left, top, width, height, reverseHorizontal) {
        super(width, height);
        this.yuvData = yuvData;
        this.dataWidth = dataWidth;
        this.dataHeight = dataHeight;
        this.left = left;
        this.top = top;
        if (left + width > dataWidth || top + height > dataHeight) {
          throw new IllegalArgumentException("Crop rectangle does not fit within image data.");
        }
        if (reverseHorizontal) {
          this.reverseHorizontal(width, height);
        }
      }
      /*@Override*/
      getRow(y, row) {
        if (y < 0 || y >= this.getHeight()) {
          throw new IllegalArgumentException("Requested row is outside the image: " + y);
        }
        const width = this.getWidth();
        if (row === null || row === void 0 || row.length < width) {
          row = new Uint8ClampedArray(width);
        }
        const offset2 = (y + this.top) * this.dataWidth + this.left;
        System.arraycopy(this.yuvData, offset2, row, 0, width);
        return row;
      }
      /*@Override*/
      getMatrix() {
        const width = this.getWidth();
        const height = this.getHeight();
        if (width === this.dataWidth && height === this.dataHeight) {
          return this.yuvData;
        }
        const area = width * height;
        const matrix2 = new Uint8ClampedArray(area);
        let inputOffset = this.top * this.dataWidth + this.left;
        if (width === this.dataWidth) {
          System.arraycopy(this.yuvData, inputOffset, matrix2, 0, area);
          return matrix2;
        }
        for (let y = 0; y < height; y++) {
          const outputOffset = y * width;
          System.arraycopy(this.yuvData, inputOffset, matrix2, outputOffset, width);
          inputOffset += this.dataWidth;
        }
        return matrix2;
      }
      /*@Override*/
      isCropSupported() {
        return true;
      }
      /*@Override*/
      crop(left, top, width, height) {
        return new PlanarYUVLuminanceSource(this.yuvData, this.dataWidth, this.dataHeight, this.left + left, this.top + top, width, height, false);
      }
      renderThumbnail() {
        const width = this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        const height = this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        const pixels = new Int32Array(width * height);
        const yuv = this.yuvData;
        let inputOffset = this.top * this.dataWidth + this.left;
        for (let y = 0; y < height; y++) {
          const outputOffset = y * width;
          for (let x2 = 0; x2 < width; x2++) {
            const grey = yuv[inputOffset + x2 * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR] & 255;
            pixels[outputOffset + x2] = 4278190080 | grey * 65793;
          }
          inputOffset += this.dataWidth * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        }
        return pixels;
      }
      /**
       * @return width of image from {@link #renderThumbnail()}
       */
      getThumbnailWidth() {
        return this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
      }
      /**
       * @return height of image from {@link #renderThumbnail()}
       */
      getThumbnailHeight() {
        return this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
      }
      reverseHorizontal(width, height) {
        const yuvData = this.yuvData;
        for (let y = 0, rowStart = this.top * this.dataWidth + this.left; y < height; y++, rowStart += this.dataWidth) {
          const middle = rowStart + width / 2;
          for (let x1 = rowStart, x2 = rowStart + width - 1; x1 < middle; x1++, x2--) {
            const temp = yuvData[x1];
            yuvData[x1] = yuvData[x2];
            yuvData[x2] = temp;
          }
        }
      }
      invert() {
        return new InvertedLuminanceSource(this);
      }
    }
    PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR = 2;
    class RGBLuminanceSource extends LuminanceSource {
      constructor(luminances, width, height, dataWidth, dataHeight, left, top) {
        super(width, height);
        this.dataWidth = dataWidth;
        this.dataHeight = dataHeight;
        this.left = left;
        this.top = top;
        if (luminances.BYTES_PER_ELEMENT === 4) {
          const size = width * height;
          const luminancesUint8Array = new Uint8ClampedArray(size);
          for (let offset2 = 0; offset2 < size; offset2++) {
            const pixel = luminances[offset2];
            const r = pixel >> 16 & 255;
            const g2 = pixel >> 7 & 510;
            const b = pixel & 255;
            luminancesUint8Array[offset2] = /*(byte) */
            (r + g2 + b) / 4 & 255;
          }
          this.luminances = luminancesUint8Array;
        } else {
          this.luminances = luminances;
        }
        if (void 0 === dataWidth) {
          this.dataWidth = width;
        }
        if (void 0 === dataHeight) {
          this.dataHeight = height;
        }
        if (void 0 === left) {
          this.left = 0;
        }
        if (void 0 === top) {
          this.top = 0;
        }
        if (this.left + width > this.dataWidth || this.top + height > this.dataHeight) {
          throw new IllegalArgumentException("Crop rectangle does not fit within image data.");
        }
      }
      /*@Override*/
      getRow(y, row) {
        if (y < 0 || y >= this.getHeight()) {
          throw new IllegalArgumentException("Requested row is outside the image: " + y);
        }
        const width = this.getWidth();
        if (row === null || row === void 0 || row.length < width) {
          row = new Uint8ClampedArray(width);
        }
        const offset2 = (y + this.top) * this.dataWidth + this.left;
        System.arraycopy(this.luminances, offset2, row, 0, width);
        return row;
      }
      /*@Override*/
      getMatrix() {
        const width = this.getWidth();
        const height = this.getHeight();
        if (width === this.dataWidth && height === this.dataHeight) {
          return this.luminances;
        }
        const area = width * height;
        const matrix2 = new Uint8ClampedArray(area);
        let inputOffset = this.top * this.dataWidth + this.left;
        if (width === this.dataWidth) {
          System.arraycopy(this.luminances, inputOffset, matrix2, 0, area);
          return matrix2;
        }
        for (let y = 0; y < height; y++) {
          const outputOffset = y * width;
          System.arraycopy(this.luminances, inputOffset, matrix2, outputOffset, width);
          inputOffset += this.dataWidth;
        }
        return matrix2;
      }
      /*@Override*/
      isCropSupported() {
        return true;
      }
      /*@Override*/
      crop(left, top, width, height) {
        return new RGBLuminanceSource(this.luminances, width, height, this.dataWidth, this.dataHeight, this.left + left, this.top + top);
      }
      invert() {
        return new InvertedLuminanceSource(this);
      }
    }
    class Charset extends CharacterSetECI {
      static forName(name) {
        return this.getCharacterSetECIByName(name);
      }
    }
    class StandardCharsets {
    }
    StandardCharsets.ISO_8859_1 = CharacterSetECI.ISO8859_1;
    class AztecCode {
      /**
       * @return {@code true} if compact instead of full mode
       */
      isCompact() {
        return this.compact;
      }
      setCompact(compact) {
        this.compact = compact;
      }
      /**
       * @return size in pixels (width and height)
       */
      getSize() {
        return this.size;
      }
      setSize(size) {
        this.size = size;
      }
      /**
       * @return number of levels
       */
      getLayers() {
        return this.layers;
      }
      setLayers(layers) {
        this.layers = layers;
      }
      /**
       * @return number of data codewords
       */
      getCodeWords() {
        return this.codeWords;
      }
      setCodeWords(codeWords) {
        this.codeWords = codeWords;
      }
      /**
       * @return the symbol image
       */
      getMatrix() {
        return this.matrix;
      }
      setMatrix(matrix2) {
        this.matrix = matrix2;
      }
    }
    class Collections {
      /**
       * The singletonList(T) method is used to return an immutable list containing only the specified object.
       */
      static singletonList(item) {
        return [item];
      }
      /**
       * The min(Collection<? extends T>, Comparator<? super T>) method is used to return the minimum element of the given collection, according to the order induced by the specified comparator.
       */
      static min(collection, comparator) {
        return collection.sort(comparator)[0];
      }
    }
    class Token {
      constructor(previous) {
        this.previous = previous;
      }
      getPrevious() {
        return this.previous;
      }
    }
    class SimpleToken extends Token {
      constructor(previous, value, bitCount) {
        super(previous);
        this.value = value;
        this.bitCount = bitCount;
      }
      /**
       * @Override
       */
      appendTo(bitArray, text2) {
        bitArray.appendBits(this.value, this.bitCount);
      }
      add(value, bitCount) {
        return new SimpleToken(this, value, bitCount);
      }
      addBinaryShift(start, byteCount) {
        console.warn("addBinaryShift on SimpleToken, this simply returns a copy of this token");
        return new SimpleToken(this, start, byteCount);
      }
      /**
       * @Override
       */
      toString() {
        let value = this.value & (1 << this.bitCount) - 1;
        value |= 1 << this.bitCount;
        return "<" + Integer.toBinaryString(value | 1 << this.bitCount).substring(1) + ">";
      }
    }
    class BinaryShiftToken extends SimpleToken {
      constructor(previous, binaryShiftStart, binaryShiftByteCount) {
        super(previous, 0, 0);
        this.binaryShiftStart = binaryShiftStart;
        this.binaryShiftByteCount = binaryShiftByteCount;
      }
      /**
       * @Override
       */
      appendTo(bitArray, text2) {
        for (let i2 = 0; i2 < this.binaryShiftByteCount; i2++) {
          if (i2 === 0 || i2 === 31 && this.binaryShiftByteCount <= 62) {
            bitArray.appendBits(31, 5);
            if (this.binaryShiftByteCount > 62) {
              bitArray.appendBits(this.binaryShiftByteCount - 31, 16);
            } else if (i2 === 0) {
              bitArray.appendBits(Math.min(this.binaryShiftByteCount, 31), 5);
            } else {
              bitArray.appendBits(this.binaryShiftByteCount - 31, 5);
            }
          }
          bitArray.appendBits(text2[this.binaryShiftStart + i2], 8);
        }
      }
      addBinaryShift(start, byteCount) {
        return new BinaryShiftToken(this, start, byteCount);
      }
      /**
       * @Override
       */
      toString() {
        return "<" + this.binaryShiftStart + "::" + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + ">";
      }
    }
    function addBinaryShift(token, start, byteCount) {
      return new BinaryShiftToken(token, start, byteCount);
    }
    function add2(token, value, bitCount) {
      return new SimpleToken(token, value, bitCount);
    }
    const MODE_NAMES = [
      "UPPER",
      "LOWER",
      "DIGIT",
      "MIXED",
      "PUNCT"
    ];
    const MODE_UPPER = 0;
    const MODE_LOWER = 1;
    const MODE_DIGIT = 2;
    const MODE_MIXED = 3;
    const MODE_PUNCT = 4;
    const EMPTY_TOKEN = new SimpleToken(null, 0, 0);
    const LATCH_TABLE = [
      Int32Array.from([
        0,
        (5 << 16) + 28,
        (5 << 16) + 30,
        (5 << 16) + 29,
        (10 << 16) + (29 << 5) + 30
        // UPPER -> MIXED -> PUNCT
      ]),
      Int32Array.from([
        (9 << 16) + (30 << 4) + 14,
        0,
        (5 << 16) + 30,
        (5 << 16) + 29,
        (10 << 16) + (29 << 5) + 30
        // LOWER -> MIXED -> PUNCT
      ]),
      Int32Array.from([
        (4 << 16) + 14,
        (9 << 16) + (14 << 5) + 28,
        0,
        (9 << 16) + (14 << 5) + 29,
        (14 << 16) + (14 << 10) + (29 << 5) + 30
        // DIGIT -> UPPER -> MIXED -> PUNCT
      ]),
      Int32Array.from([
        (5 << 16) + 29,
        (5 << 16) + 28,
        (10 << 16) + (29 << 5) + 30,
        0,
        (5 << 16) + 30
        // MIXED -> PUNCT
      ]),
      Int32Array.from([
        (5 << 16) + 31,
        (10 << 16) + (31 << 5) + 28,
        (10 << 16) + (31 << 5) + 30,
        (10 << 16) + (31 << 5) + 29,
        0
      ])
    ];
    function static_SHIFT_TABLE(SHIFT_TABLE2) {
      for (let table of SHIFT_TABLE2) {
        Arrays.fill(table, -1);
      }
      SHIFT_TABLE2[MODE_UPPER][MODE_PUNCT] = 0;
      SHIFT_TABLE2[MODE_LOWER][MODE_PUNCT] = 0;
      SHIFT_TABLE2[MODE_LOWER][MODE_UPPER] = 28;
      SHIFT_TABLE2[MODE_MIXED][MODE_PUNCT] = 0;
      SHIFT_TABLE2[MODE_DIGIT][MODE_PUNCT] = 0;
      SHIFT_TABLE2[MODE_DIGIT][MODE_UPPER] = 15;
      return SHIFT_TABLE2;
    }
    const SHIFT_TABLE = static_SHIFT_TABLE(Arrays.createInt32Array(6, 6));
    class State {
      constructor(token, mode, binaryBytes, bitCount) {
        this.token = token;
        this.mode = mode;
        this.binaryShiftByteCount = binaryBytes;
        this.bitCount = bitCount;
      }
      getMode() {
        return this.mode;
      }
      getToken() {
        return this.token;
      }
      getBinaryShiftByteCount() {
        return this.binaryShiftByteCount;
      }
      getBitCount() {
        return this.bitCount;
      }
      // Create a new state representing this state with a latch to a (not
      // necessary different) mode, and then a code.
      latchAndAppend(mode, value) {
        let bitCount = this.bitCount;
        let token = this.token;
        if (mode !== this.mode) {
          let latch = LATCH_TABLE[this.mode][mode];
          token = add2(token, latch & 65535, latch >> 16);
          bitCount += latch >> 16;
        }
        let latchModeBitCount = mode === MODE_DIGIT ? 4 : 5;
        token = add2(token, value, latchModeBitCount);
        return new State(token, mode, 0, bitCount + latchModeBitCount);
      }
      // Create a new state representing this state, with a temporary shift
      // to a different mode to output a single value.
      shiftAndAppend(mode, value) {
        let token = this.token;
        let thisModeBitCount = this.mode === MODE_DIGIT ? 4 : 5;
        token = add2(token, SHIFT_TABLE[this.mode][mode], thisModeBitCount);
        token = add2(token, value, 5);
        return new State(token, this.mode, 0, this.bitCount + thisModeBitCount + 5);
      }
      // Create a new state representing this state, but an additional character
      // output in Binary Shift mode.
      addBinaryShiftChar(index2) {
        let token = this.token;
        let mode = this.mode;
        let bitCount = this.bitCount;
        if (this.mode === MODE_PUNCT || this.mode === MODE_DIGIT) {
          let latch = LATCH_TABLE[mode][MODE_UPPER];
          token = add2(token, latch & 65535, latch >> 16);
          bitCount += latch >> 16;
          mode = MODE_UPPER;
        }
        let deltaBitCount = this.binaryShiftByteCount === 0 || this.binaryShiftByteCount === 31 ? 18 : this.binaryShiftByteCount === 62 ? 9 : 8;
        let result2 = new State(token, mode, this.binaryShiftByteCount + 1, bitCount + deltaBitCount);
        if (result2.binaryShiftByteCount === 2047 + 31) {
          result2 = result2.endBinaryShift(index2 + 1);
        }
        return result2;
      }
      // Create the state identical to this one, but we are no longer in
      // Binary Shift mode.
      endBinaryShift(index2) {
        if (this.binaryShiftByteCount === 0) {
          return this;
        }
        let token = this.token;
        token = addBinaryShift(token, index2 - this.binaryShiftByteCount, this.binaryShiftByteCount);
        return new State(token, this.mode, 0, this.bitCount);
      }
      // Returns true if "this" state is better (equal: or) to be in than "that"
      // state under all possible circumstances.
      isBetterThanOrEqualTo(other) {
        let newModeBitCount = this.bitCount + (LATCH_TABLE[this.mode][other.mode] >> 16);
        if (this.binaryShiftByteCount < other.binaryShiftByteCount) {
          newModeBitCount += State.calculateBinaryShiftCost(other) - State.calculateBinaryShiftCost(this);
        } else if (this.binaryShiftByteCount > other.binaryShiftByteCount && other.binaryShiftByteCount > 0) {
          newModeBitCount += 10;
        }
        return newModeBitCount <= other.bitCount;
      }
      toBitArray(text2) {
        let symbols2 = [];
        for (let token = this.endBinaryShift(text2.length).token; token !== null; token = token.getPrevious()) {
          symbols2.unshift(token);
        }
        let bitArray = new BitArray();
        for (const symbol of symbols2) {
          symbol.appendTo(bitArray, text2);
        }
        return bitArray;
      }
      /**
       * @Override
       */
      toString() {
        return StringUtils.format("%s bits=%d bytes=%d", MODE_NAMES[this.mode], this.bitCount, this.binaryShiftByteCount);
      }
      static calculateBinaryShiftCost(state) {
        if (state.binaryShiftByteCount > 62) {
          return 21;
        }
        if (state.binaryShiftByteCount > 31) {
          return 20;
        }
        if (state.binaryShiftByteCount > 0) {
          return 10;
        }
        return 0;
      }
    }
    State.INITIAL_STATE = new State(EMPTY_TOKEN, MODE_UPPER, 0, 0);
    function static_CHAR_MAP(CHAR_MAP2) {
      const spaceCharCode = StringUtils.getCharCode(" ");
      const pointCharCode = StringUtils.getCharCode(".");
      const commaCharCode = StringUtils.getCharCode(",");
      CHAR_MAP2[MODE_UPPER][spaceCharCode] = 1;
      const zUpperCharCode = StringUtils.getCharCode("Z");
      const aUpperCharCode = StringUtils.getCharCode("A");
      for (let c = aUpperCharCode; c <= zUpperCharCode; c++) {
        CHAR_MAP2[MODE_UPPER][c] = c - aUpperCharCode + 2;
      }
      CHAR_MAP2[MODE_LOWER][spaceCharCode] = 1;
      const zLowerCharCode = StringUtils.getCharCode("z");
      const aLowerCharCode = StringUtils.getCharCode("a");
      for (let c = aLowerCharCode; c <= zLowerCharCode; c++) {
        CHAR_MAP2[MODE_LOWER][c] = c - aLowerCharCode + 2;
      }
      CHAR_MAP2[MODE_DIGIT][spaceCharCode] = 1;
      const nineCharCode = StringUtils.getCharCode("9");
      const zeroCharCode = StringUtils.getCharCode("0");
      for (let c = zeroCharCode; c <= nineCharCode; c++) {
        CHAR_MAP2[MODE_DIGIT][c] = c - zeroCharCode + 2;
      }
      CHAR_MAP2[MODE_DIGIT][commaCharCode] = 12;
      CHAR_MAP2[MODE_DIGIT][pointCharCode] = 13;
      const mixedTable = [
        "\0",
        " ",
        "",
        "",
        "",
        "",
        "",
        "",
        "\x07",
        "\b",
        "	",
        "\n",
        "\v",
        "\f",
        "\r",
        "\x1B",
        "",
        "",
        "",
        "",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        ""
      ];
      for (let i2 = 0; i2 < mixedTable.length; i2++) {
        CHAR_MAP2[MODE_MIXED][StringUtils.getCharCode(mixedTable[i2])] = i2;
      }
      const punctTable = [
        "\0",
        "\r",
        "\0",
        "\0",
        "\0",
        "\0",
        "!",
        "'",
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}"
      ];
      for (let i2 = 0; i2 < punctTable.length; i2++) {
        if (StringUtils.getCharCode(punctTable[i2]) > 0) {
          CHAR_MAP2[MODE_PUNCT][StringUtils.getCharCode(punctTable[i2])] = i2;
        }
      }
      return CHAR_MAP2;
    }
    const CHAR_MAP = static_CHAR_MAP(Arrays.createInt32Array(5, 256));
    class HighLevelEncoder {
      constructor(text2) {
        this.text = text2;
      }
      /**
       * @return text represented by this encoder encoded as a {@link BitArray}
       */
      encode() {
        const spaceCharCode = StringUtils.getCharCode(" ");
        const lineBreakCharCode = StringUtils.getCharCode("\n");
        let states = Collections.singletonList(State.INITIAL_STATE);
        for (let index2 = 0; index2 < this.text.length; index2++) {
          let pairCode;
          let nextChar = index2 + 1 < this.text.length ? this.text[index2 + 1] : 0;
          switch (this.text[index2]) {
            case StringUtils.getCharCode("\r"):
              pairCode = nextChar === lineBreakCharCode ? 2 : 0;
              break;
            case StringUtils.getCharCode("."):
              pairCode = nextChar === spaceCharCode ? 3 : 0;
              break;
            case StringUtils.getCharCode(","):
              pairCode = nextChar === spaceCharCode ? 4 : 0;
              break;
            case StringUtils.getCharCode(":"):
              pairCode = nextChar === spaceCharCode ? 5 : 0;
              break;
            default:
              pairCode = 0;
          }
          if (pairCode > 0) {
            states = HighLevelEncoder.updateStateListForPair(states, index2, pairCode);
            index2++;
          } else {
            states = this.updateStateListForChar(states, index2);
          }
        }
        const minState = Collections.min(states, (a, b) => {
          return a.getBitCount() - b.getBitCount();
        });
        return minState.toBitArray(this.text);
      }
      // We update a set of states for a new character by updating each state
      // for the new character, merging the results, and then removing the
      // non-optimal states.
      updateStateListForChar(states, index2) {
        const result2 = [];
        for (let state of states) {
          this.updateStateForChar(state, index2, result2);
        }
        return HighLevelEncoder.simplifyStates(result2);
      }
      // Return a set of states that represent the possible ways of updating this
      // state for the next character.  The resulting set of states are added to
      // the "result" list.
      updateStateForChar(state, index2, result2) {
        let ch = this.text[index2] & 255;
        let charInCurrentTable = CHAR_MAP[state.getMode()][ch] > 0;
        let stateNoBinary = null;
        for (let mode = 0; mode <= MODE_PUNCT; mode++) {
          let charInMode = CHAR_MAP[mode][ch];
          if (charInMode > 0) {
            if (stateNoBinary == null) {
              stateNoBinary = state.endBinaryShift(index2);
            }
            if (!charInCurrentTable || mode === state.getMode() || mode === MODE_DIGIT) {
              const latchState = stateNoBinary.latchAndAppend(mode, charInMode);
              result2.push(latchState);
            }
            if (!charInCurrentTable && SHIFT_TABLE[state.getMode()][mode] >= 0) {
              const shiftState = stateNoBinary.shiftAndAppend(mode, charInMode);
              result2.push(shiftState);
            }
          }
        }
        if (state.getBinaryShiftByteCount() > 0 || CHAR_MAP[state.getMode()][ch] === 0) {
          let binaryState = state.addBinaryShiftChar(index2);
          result2.push(binaryState);
        }
      }
      static updateStateListForPair(states, index2, pairCode) {
        const result2 = [];
        for (let state of states) {
          this.updateStateForPair(state, index2, pairCode, result2);
        }
        return this.simplifyStates(result2);
      }
      static updateStateForPair(state, index2, pairCode, result2) {
        let stateNoBinary = state.endBinaryShift(index2);
        result2.push(stateNoBinary.latchAndAppend(MODE_PUNCT, pairCode));
        if (state.getMode() !== MODE_PUNCT) {
          result2.push(stateNoBinary.shiftAndAppend(MODE_PUNCT, pairCode));
        }
        if (pairCode === 3 || pairCode === 4) {
          let digitState = stateNoBinary.latchAndAppend(MODE_DIGIT, 16 - pairCode).latchAndAppend(MODE_DIGIT, 1);
          result2.push(digitState);
        }
        if (state.getBinaryShiftByteCount() > 0) {
          let binaryState = state.addBinaryShiftChar(index2).addBinaryShiftChar(index2 + 1);
          result2.push(binaryState);
        }
      }
      static simplifyStates(states) {
        let result2 = [];
        for (const newState of states) {
          let add3 = true;
          for (const oldState of result2) {
            if (oldState.isBetterThanOrEqualTo(newState)) {
              add3 = false;
              break;
            }
            if (newState.isBetterThanOrEqualTo(oldState)) {
              result2 = result2.filter((x2) => x2 !== oldState);
            }
          }
          if (add3) {
            result2.push(newState);
          }
        }
        return result2;
      }
    }
    class Encoder$1 {
      constructor() {
      }
      /**
       * Encodes the given binary content as an Aztec symbol
       *
       * @param data input data string
       * @return Aztec symbol matrix with metadata
       */
      static encodeBytes(data) {
        return Encoder$1.encode(data, Encoder$1.DEFAULT_EC_PERCENT, Encoder$1.DEFAULT_AZTEC_LAYERS);
      }
      /**
       * Encodes the given binary content as an Aztec symbol
       *
       * @param data input data string
       * @param minECCPercent minimal percentage of error check words (According to ISO/IEC 24778:2008,
       *                      a minimum of 23% + 3 words is recommended)
       * @param userSpecifiedLayers if non-zero, a user-specified value for the number of layers
       * @return Aztec symbol matrix with metadata
       */
      static encode(data, minECCPercent, userSpecifiedLayers) {
        let bits = new HighLevelEncoder(data).encode();
        let eccBits = Integer.truncDivision(bits.getSize() * minECCPercent, 100) + 11;
        let totalSizeBits = bits.getSize() + eccBits;
        let compact;
        let layers;
        let totalBitsInLayer;
        let wordSize;
        let stuffedBits;
        if (userSpecifiedLayers !== Encoder$1.DEFAULT_AZTEC_LAYERS) {
          compact = userSpecifiedLayers < 0;
          layers = Math.abs(userSpecifiedLayers);
          if (layers > (compact ? Encoder$1.MAX_NB_BITS_COMPACT : Encoder$1.MAX_NB_BITS)) {
            throw new IllegalArgumentException(StringUtils.format("Illegal value %s for layers", userSpecifiedLayers));
          }
          totalBitsInLayer = Encoder$1.totalBitsInLayer(layers, compact);
          wordSize = Encoder$1.WORD_SIZE[layers];
          let usableBitsInLayers = totalBitsInLayer - totalBitsInLayer % wordSize;
          stuffedBits = Encoder$1.stuffBits(bits, wordSize);
          if (stuffedBits.getSize() + eccBits > usableBitsInLayers) {
            throw new IllegalArgumentException("Data to large for user specified layer");
          }
          if (compact && stuffedBits.getSize() > wordSize * 64) {
            throw new IllegalArgumentException("Data to large for user specified layer");
          }
        } else {
          wordSize = 0;
          stuffedBits = null;
          for (let i2 = 0; ; i2++) {
            if (i2 > Encoder$1.MAX_NB_BITS) {
              throw new IllegalArgumentException("Data too large for an Aztec code");
            }
            compact = i2 <= 3;
            layers = compact ? i2 + 1 : i2;
            totalBitsInLayer = Encoder$1.totalBitsInLayer(layers, compact);
            if (totalSizeBits > totalBitsInLayer) {
              continue;
            }
            if (stuffedBits == null || wordSize !== Encoder$1.WORD_SIZE[layers]) {
              wordSize = Encoder$1.WORD_SIZE[layers];
              stuffedBits = Encoder$1.stuffBits(bits, wordSize);
            }
            let usableBitsInLayers = totalBitsInLayer - totalBitsInLayer % wordSize;
            if (compact && stuffedBits.getSize() > wordSize * 64) {
              continue;
            }
            if (stuffedBits.getSize() + eccBits <= usableBitsInLayers) {
              break;
            }
          }
        }
        let messageBits = Encoder$1.generateCheckWords(stuffedBits, totalBitsInLayer, wordSize);
        let messageSizeInWords = stuffedBits.getSize() / wordSize;
        let modeMessage = Encoder$1.generateModeMessage(compact, layers, messageSizeInWords);
        let baseMatrixSize = (compact ? 11 : 14) + layers * 4;
        let alignmentMap = new Int32Array(baseMatrixSize);
        let matrixSize;
        if (compact) {
          matrixSize = baseMatrixSize;
          for (let i2 = 0; i2 < alignmentMap.length; i2++) {
            alignmentMap[i2] = i2;
          }
        } else {
          matrixSize = baseMatrixSize + 1 + 2 * Integer.truncDivision(Integer.truncDivision(baseMatrixSize, 2) - 1, 15);
          let origCenter = Integer.truncDivision(baseMatrixSize, 2);
          let center = Integer.truncDivision(matrixSize, 2);
          for (let i2 = 0; i2 < origCenter; i2++) {
            let newOffset = i2 + Integer.truncDivision(i2, 15);
            alignmentMap[origCenter - i2 - 1] = center - newOffset - 1;
            alignmentMap[origCenter + i2] = center + newOffset + 1;
          }
        }
        let matrix2 = new BitMatrix(matrixSize);
        for (let i2 = 0, rowOffset = 0; i2 < layers; i2++) {
          let rowSize = (layers - i2) * 4 + (compact ? 9 : 12);
          for (let j = 0; j < rowSize; j++) {
            let columnOffset = j * 2;
            for (let k = 0; k < 2; k++) {
              if (messageBits.get(rowOffset + columnOffset + k)) {
                matrix2.set(alignmentMap[i2 * 2 + k], alignmentMap[i2 * 2 + j]);
              }
              if (messageBits.get(rowOffset + rowSize * 2 + columnOffset + k)) {
                matrix2.set(alignmentMap[i2 * 2 + j], alignmentMap[baseMatrixSize - 1 - i2 * 2 - k]);
              }
              if (messageBits.get(rowOffset + rowSize * 4 + columnOffset + k)) {
                matrix2.set(alignmentMap[baseMatrixSize - 1 - i2 * 2 - k], alignmentMap[baseMatrixSize - 1 - i2 * 2 - j]);
              }
              if (messageBits.get(rowOffset + rowSize * 6 + columnOffset + k)) {
                matrix2.set(alignmentMap[baseMatrixSize - 1 - i2 * 2 - j], alignmentMap[i2 * 2 + k]);
              }
            }
          }
          rowOffset += rowSize * 8;
        }
        Encoder$1.drawModeMessage(matrix2, compact, matrixSize, modeMessage);
        if (compact) {
          Encoder$1.drawBullsEye(matrix2, Integer.truncDivision(matrixSize, 2), 5);
        } else {
          Encoder$1.drawBullsEye(matrix2, Integer.truncDivision(matrixSize, 2), 7);
          for (let i2 = 0, j = 0; i2 < Integer.truncDivision(baseMatrixSize, 2) - 1; i2 += 15, j += 16) {
            for (let k = Integer.truncDivision(matrixSize, 2) & 1; k < matrixSize; k += 2) {
              matrix2.set(Integer.truncDivision(matrixSize, 2) - j, k);
              matrix2.set(Integer.truncDivision(matrixSize, 2) + j, k);
              matrix2.set(k, Integer.truncDivision(matrixSize, 2) - j);
              matrix2.set(k, Integer.truncDivision(matrixSize, 2) + j);
            }
          }
        }
        let aztec = new AztecCode();
        aztec.setCompact(compact);
        aztec.setSize(matrixSize);
        aztec.setLayers(layers);
        aztec.setCodeWords(messageSizeInWords);
        aztec.setMatrix(matrix2);
        return aztec;
      }
      static drawBullsEye(matrix2, center, size) {
        for (let i2 = 0; i2 < size; i2 += 2) {
          for (let j = center - i2; j <= center + i2; j++) {
            matrix2.set(j, center - i2);
            matrix2.set(j, center + i2);
            matrix2.set(center - i2, j);
            matrix2.set(center + i2, j);
          }
        }
        matrix2.set(center - size, center - size);
        matrix2.set(center - size + 1, center - size);
        matrix2.set(center - size, center - size + 1);
        matrix2.set(center + size, center - size);
        matrix2.set(center + size, center - size + 1);
        matrix2.set(center + size, center + size - 1);
      }
      static generateModeMessage(compact, layers, messageSizeInWords) {
        let modeMessage = new BitArray();
        if (compact) {
          modeMessage.appendBits(layers - 1, 2);
          modeMessage.appendBits(messageSizeInWords - 1, 6);
          modeMessage = Encoder$1.generateCheckWords(modeMessage, 28, 4);
        } else {
          modeMessage.appendBits(layers - 1, 5);
          modeMessage.appendBits(messageSizeInWords - 1, 11);
          modeMessage = Encoder$1.generateCheckWords(modeMessage, 40, 4);
        }
        return modeMessage;
      }
      static drawModeMessage(matrix2, compact, matrixSize, modeMessage) {
        let center = Integer.truncDivision(matrixSize, 2);
        if (compact) {
          for (let i2 = 0; i2 < 7; i2++) {
            let offset2 = center - 3 + i2;
            if (modeMessage.get(i2)) {
              matrix2.set(offset2, center - 5);
            }
            if (modeMessage.get(i2 + 7)) {
              matrix2.set(center + 5, offset2);
            }
            if (modeMessage.get(20 - i2)) {
              matrix2.set(offset2, center + 5);
            }
            if (modeMessage.get(27 - i2)) {
              matrix2.set(center - 5, offset2);
            }
          }
        } else {
          for (let i2 = 0; i2 < 10; i2++) {
            let offset2 = center - 5 + i2 + Integer.truncDivision(i2, 5);
            if (modeMessage.get(i2)) {
              matrix2.set(offset2, center - 7);
            }
            if (modeMessage.get(i2 + 10)) {
              matrix2.set(center + 7, offset2);
            }
            if (modeMessage.get(29 - i2)) {
              matrix2.set(offset2, center + 7);
            }
            if (modeMessage.get(39 - i2)) {
              matrix2.set(center - 7, offset2);
            }
          }
        }
      }
      static generateCheckWords(bitArray, totalBits, wordSize) {
        let messageSizeInWords = bitArray.getSize() / wordSize;
        let rs = new ReedSolomonEncoder(Encoder$1.getGF(wordSize));
        let totalWords = Integer.truncDivision(totalBits, wordSize);
        let messageWords = Encoder$1.bitsToWords(bitArray, wordSize, totalWords);
        rs.encode(messageWords, totalWords - messageSizeInWords);
        let startPad = totalBits % wordSize;
        let messageBits = new BitArray();
        messageBits.appendBits(0, startPad);
        for (const messageWord of Array.from(messageWords)) {
          messageBits.appendBits(messageWord, wordSize);
        }
        return messageBits;
      }
      static bitsToWords(stuffedBits, wordSize, totalWords) {
        let message = new Int32Array(totalWords);
        let i2;
        let n2;
        for (i2 = 0, n2 = stuffedBits.getSize() / wordSize; i2 < n2; i2++) {
          let value = 0;
          for (let j = 0; j < wordSize; j++) {
            value |= stuffedBits.get(i2 * wordSize + j) ? 1 << wordSize - j - 1 : 0;
          }
          message[i2] = value;
        }
        return message;
      }
      static getGF(wordSize) {
        switch (wordSize) {
          case 4:
            return GenericGF.AZTEC_PARAM;
          case 6:
            return GenericGF.AZTEC_DATA_6;
          case 8:
            return GenericGF.AZTEC_DATA_8;
          case 10:
            return GenericGF.AZTEC_DATA_10;
          case 12:
            return GenericGF.AZTEC_DATA_12;
          default:
            throw new IllegalArgumentException("Unsupported word size " + wordSize);
        }
      }
      static stuffBits(bits, wordSize) {
        let out = new BitArray();
        let n2 = bits.getSize();
        let mask = (1 << wordSize) - 2;
        for (let i2 = 0; i2 < n2; i2 += wordSize) {
          let word = 0;
          for (let j = 0; j < wordSize; j++) {
            if (i2 + j >= n2 || bits.get(i2 + j)) {
              word |= 1 << wordSize - 1 - j;
            }
          }
          if ((word & mask) === mask) {
            out.appendBits(word & mask, wordSize);
            i2--;
          } else if ((word & mask) === 0) {
            out.appendBits(word | 1, wordSize);
            i2--;
          } else {
            out.appendBits(word, wordSize);
          }
        }
        return out;
      }
      static totalBitsInLayer(layers, compact) {
        return ((compact ? 88 : 112) + 16 * layers) * layers;
      }
    }
    Encoder$1.DEFAULT_EC_PERCENT = 33;
    Encoder$1.DEFAULT_AZTEC_LAYERS = 0;
    Encoder$1.MAX_NB_BITS = 32;
    Encoder$1.MAX_NB_BITS_COMPACT = 4;
    Encoder$1.WORD_SIZE = Int32Array.from([
      4,
      6,
      6,
      8,
      8,
      8,
      8,
      8,
      8,
      10,
      10,
      10,
      10,
      10,
      10,
      10,
      10,
      10,
      10,
      10,
      10,
      10,
      10,
      12,
      12,
      12,
      12,
      12,
      12,
      12,
      12,
      12,
      12
    ]);
    class AztecWriter {
      // @Override
      encode(contents, format, width, height) {
        return this.encodeWithHints(contents, format, width, height, null);
      }
      // @Override
      encodeWithHints(contents, format, width, height, hints) {
        let charset = StandardCharsets.ISO_8859_1;
        let eccPercent = Encoder$1.DEFAULT_EC_PERCENT;
        let layers = Encoder$1.DEFAULT_AZTEC_LAYERS;
        if (hints != null) {
          if (hints.has(EncodeHintType$1.CHARACTER_SET)) {
            charset = Charset.forName(hints.get(EncodeHintType$1.CHARACTER_SET).toString());
          }
          if (hints.has(EncodeHintType$1.ERROR_CORRECTION)) {
            eccPercent = Integer.parseInt(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
          }
          if (hints.has(EncodeHintType$1.AZTEC_LAYERS)) {
            layers = Integer.parseInt(hints.get(EncodeHintType$1.AZTEC_LAYERS).toString());
          }
        }
        return AztecWriter.encodeLayers(contents, format, width, height, charset, eccPercent, layers);
      }
      static encodeLayers(contents, format, width, height, charset, eccPercent, layers) {
        if (format !== BarcodeFormat$1.AZTEC) {
          throw new IllegalArgumentException("Can only encode AZTEC, but got " + format);
        }
        let aztec = Encoder$1.encode(StringUtils.getBytes(contents, charset), eccPercent, layers);
        return AztecWriter.renderResult(aztec, width, height);
      }
      static renderResult(code, width, height) {
        let input2 = code.getMatrix();
        if (input2 == null) {
          throw new IllegalStateException();
        }
        let inputWidth = input2.getWidth();
        let inputHeight = input2.getHeight();
        let outputWidth = Math.max(width, inputWidth);
        let outputHeight = Math.max(height, inputHeight);
        let multiple = Math.min(outputWidth / inputWidth, outputHeight / inputHeight);
        let leftPadding = (outputWidth - inputWidth * multiple) / 2;
        let topPadding = (outputHeight - inputHeight * multiple) / 2;
        let output = new BitMatrix(outputWidth, outputHeight);
        for (let inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple) {
          for (let inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple) {
            if (input2.get(inputX, inputY)) {
              output.setRegion(outputX, outputY, multiple, multiple);
            }
          }
        }
        return output;
      }
    }
    exports2.AbstractExpandedDecoder = AbstractExpandedDecoder;
    exports2.ArgumentException = ArgumentException;
    exports2.ArithmeticException = ArithmeticException;
    exports2.AztecCode = AztecCode;
    exports2.AztecCodeReader = AztecReader;
    exports2.AztecCodeWriter = AztecWriter;
    exports2.AztecDecoder = Decoder;
    exports2.AztecDetector = Detector;
    exports2.AztecDetectorResult = AztecDetectorResult;
    exports2.AztecEncoder = Encoder$1;
    exports2.AztecHighLevelEncoder = HighLevelEncoder;
    exports2.AztecPoint = Point;
    exports2.BarcodeFormat = BarcodeFormat$1;
    exports2.Binarizer = Binarizer;
    exports2.BinaryBitmap = BinaryBitmap;
    exports2.BitArray = BitArray;
    exports2.BitMatrix = BitMatrix;
    exports2.BitSource = BitSource;
    exports2.BrowserAztecCodeReader = BrowserAztecCodeReader;
    exports2.BrowserBarcodeReader = BrowserBarcodeReader;
    exports2.BrowserCodeReader = BrowserCodeReader;
    exports2.BrowserDatamatrixCodeReader = BrowserDatamatrixCodeReader;
    exports2.BrowserMultiFormatReader = BrowserMultiFormatReader;
    exports2.BrowserPDF417Reader = BrowserPDF417Reader;
    exports2.BrowserQRCodeReader = BrowserQRCodeReader;
    exports2.BrowserQRCodeSvgWriter = BrowserQRCodeSvgWriter;
    exports2.CharacterSetECI = CharacterSetECI;
    exports2.ChecksumException = ChecksumException;
    exports2.Code128Reader = Code128Reader;
    exports2.Code39Reader = Code39Reader;
    exports2.DataMatrixDecodedBitStreamParser = DecodedBitStreamParser;
    exports2.DataMatrixReader = DataMatrixReader;
    exports2.DecodeHintType = DecodeHintType$1;
    exports2.DecoderResult = DecoderResult;
    exports2.DefaultGridSampler = DefaultGridSampler;
    exports2.DetectorResult = DetectorResult;
    exports2.EAN13Reader = EAN13Reader;
    exports2.EncodeHintType = EncodeHintType$1;
    exports2.Exception = Exception;
    exports2.FormatException = FormatException;
    exports2.GenericGF = GenericGF;
    exports2.GenericGFPoly = GenericGFPoly;
    exports2.GlobalHistogramBinarizer = GlobalHistogramBinarizer;
    exports2.GridSampler = GridSampler;
    exports2.GridSamplerInstance = GridSamplerInstance;
    exports2.HTMLCanvasElementLuminanceSource = HTMLCanvasElementLuminanceSource;
    exports2.HybridBinarizer = HybridBinarizer;
    exports2.ITFReader = ITFReader;
    exports2.IllegalArgumentException = IllegalArgumentException;
    exports2.IllegalStateException = IllegalStateException;
    exports2.InvertedLuminanceSource = InvertedLuminanceSource;
    exports2.LuminanceSource = LuminanceSource;
    exports2.MathUtils = MathUtils2;
    exports2.MultiFormatOneDReader = MultiFormatOneDReader;
    exports2.MultiFormatReader = MultiFormatReader;
    exports2.MultiFormatWriter = MultiFormatWriter;
    exports2.NotFoundException = NotFoundException;
    exports2.OneDReader = OneDReader;
    exports2.PDF417DecodedBitStreamParser = DecodedBitStreamParser$2;
    exports2.PDF417DecoderErrorCorrection = ErrorCorrection;
    exports2.PDF417Reader = PDF417Reader;
    exports2.PDF417ResultMetadata = PDF417ResultMetadata;
    exports2.PerspectiveTransform = PerspectiveTransform;
    exports2.PlanarYUVLuminanceSource = PlanarYUVLuminanceSource;
    exports2.QRCodeByteMatrix = ByteMatrix;
    exports2.QRCodeDataMask = DataMask;
    exports2.QRCodeDecodedBitStreamParser = DecodedBitStreamParser$1;
    exports2.QRCodeDecoderErrorCorrectionLevel = ErrorCorrectionLevel;
    exports2.QRCodeDecoderFormatInformation = FormatInformation;
    exports2.QRCodeEncoder = Encoder;
    exports2.QRCodeEncoderQRCode = QRCode;
    exports2.QRCodeMaskUtil = MaskUtil;
    exports2.QRCodeMatrixUtil = MatrixUtil;
    exports2.QRCodeMode = Mode$1;
    exports2.QRCodeReader = QRCodeReader;
    exports2.QRCodeVersion = Version$1;
    exports2.QRCodeWriter = QRCodeWriter;
    exports2.RGBLuminanceSource = RGBLuminanceSource;
    exports2.RSS14Reader = RSS14Reader;
    exports2.RSSExpandedReader = RSSExpandedReader;
    exports2.ReaderException = ReaderException;
    exports2.ReedSolomonDecoder = ReedSolomonDecoder;
    exports2.ReedSolomonEncoder = ReedSolomonEncoder;
    exports2.ReedSolomonException = ReedSolomonException;
    exports2.Result = Result3;
    exports2.ResultMetadataType = ResultMetadataType$1;
    exports2.ResultPoint = ResultPoint;
    exports2.StringUtils = StringUtils;
    exports2.UnsupportedOperationException = UnsupportedOperationException;
    exports2.VideoInputDevice = VideoInputDevice;
    exports2.WhiteRectangleDetector = WhiteRectangleDetector;
    exports2.WriterException = WriterException;
    exports2.ZXingArrays = Arrays;
    exports2.ZXingCharset = Charset;
    exports2.ZXingInteger = Integer;
    exports2.ZXingStandardCharsets = StandardCharsets;
    exports2.ZXingStringBuilder = StringBuilder;
    exports2.ZXingStringEncoding = StringEncoding;
    exports2.ZXingSystem = System;
    exports2.createAbstractExpandedDecoder = createDecoder;
    Object.defineProperty(exports2, "__esModule", { value: true });
  });
})(zxingJs_umd$1, zxingJs_umd$1.exports);
var zxingJs_umdExports = zxingJs_umd$1.exports;
const zxingJs_umd = /* @__PURE__ */ getDefaultExportFromCjs(zxingJs_umdExports);
const ZXing = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: zxingJs_umd
}, [zxingJs_umdExports]);
var ZXingHtml5QrcodeDecoder = function() {
  function ZXingHtml5QrcodeDecoder2(requestedFormats, verbose, logger2) {
    this.formatMap = /* @__PURE__ */ new Map([
      [Html5QrcodeSupportedFormats.QR_CODE, zxingJs_umdExports.BarcodeFormat.QR_CODE],
      [Html5QrcodeSupportedFormats.AZTEC, zxingJs_umdExports.BarcodeFormat.AZTEC],
      [Html5QrcodeSupportedFormats.CODABAR, zxingJs_umdExports.BarcodeFormat.CODABAR],
      [Html5QrcodeSupportedFormats.CODE_39, zxingJs_umdExports.BarcodeFormat.CODE_39],
      [Html5QrcodeSupportedFormats.CODE_93, zxingJs_umdExports.BarcodeFormat.CODE_93],
      [
        Html5QrcodeSupportedFormats.CODE_128,
        zxingJs_umdExports.BarcodeFormat.CODE_128
      ],
      [
        Html5QrcodeSupportedFormats.DATA_MATRIX,
        zxingJs_umdExports.BarcodeFormat.DATA_MATRIX
      ],
      [
        Html5QrcodeSupportedFormats.MAXICODE,
        zxingJs_umdExports.BarcodeFormat.MAXICODE
      ],
      [Html5QrcodeSupportedFormats.ITF, zxingJs_umdExports.BarcodeFormat.ITF],
      [Html5QrcodeSupportedFormats.EAN_13, zxingJs_umdExports.BarcodeFormat.EAN_13],
      [Html5QrcodeSupportedFormats.EAN_8, zxingJs_umdExports.BarcodeFormat.EAN_8],
      [Html5QrcodeSupportedFormats.PDF_417, zxingJs_umdExports.BarcodeFormat.PDF_417],
      [Html5QrcodeSupportedFormats.RSS_14, zxingJs_umdExports.BarcodeFormat.RSS_14],
      [
        Html5QrcodeSupportedFormats.RSS_EXPANDED,
        zxingJs_umdExports.BarcodeFormat.RSS_EXPANDED
      ],
      [Html5QrcodeSupportedFormats.UPC_A, zxingJs_umdExports.BarcodeFormat.UPC_A],
      [Html5QrcodeSupportedFormats.UPC_E, zxingJs_umdExports.BarcodeFormat.UPC_E],
      [
        Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION,
        zxingJs_umdExports.BarcodeFormat.UPC_EAN_EXTENSION
      ]
    ]);
    this.reverseFormatMap = this.createReverseFormatMap();
    if (!ZXing) {
      throw "Use html5qrcode.min.js without edit, ZXing not found.";
    }
    this.verbose = verbose;
    this.logger = logger2;
    var formats = this.createZXingFormats(requestedFormats);
    var hints = /* @__PURE__ */ new Map();
    hints.set(zxingJs_umdExports.DecodeHintType.POSSIBLE_FORMATS, formats);
    hints.set(zxingJs_umdExports.DecodeHintType.TRY_HARDER, false);
    this.hints = hints;
  }
  ZXingHtml5QrcodeDecoder2.prototype.decodeAsync = function(canvas) {
    var _this2 = this;
    return new Promise(function(resolve2, reject) {
      try {
        resolve2(_this2.decode(canvas));
      } catch (error2) {
        reject(error2);
      }
    });
  };
  ZXingHtml5QrcodeDecoder2.prototype.decode = function(canvas) {
    var zxingDecoder = new zxingJs_umdExports.MultiFormatReader(this.verbose, this.hints);
    var luminanceSource = new zxingJs_umdExports.HTMLCanvasElementLuminanceSource(canvas);
    var binaryBitmap = new zxingJs_umdExports.BinaryBitmap(new zxingJs_umdExports.HybridBinarizer(luminanceSource));
    var result2 = zxingDecoder.decode(binaryBitmap);
    return {
      text: result2.text,
      format: QrcodeResultFormat.create(this.toHtml5QrcodeSupportedFormats(result2.format)),
      debugData: this.createDebugData()
    };
  };
  ZXingHtml5QrcodeDecoder2.prototype.createReverseFormatMap = function() {
    var result2 = /* @__PURE__ */ new Map();
    this.formatMap.forEach(function(value, key, _) {
      result2.set(value, key);
    });
    return result2;
  };
  ZXingHtml5QrcodeDecoder2.prototype.toHtml5QrcodeSupportedFormats = function(zxingFormat) {
    if (!this.reverseFormatMap.has(zxingFormat)) {
      throw "reverseFormatMap doesn't have ".concat(zxingFormat);
    }
    return this.reverseFormatMap.get(zxingFormat);
  };
  ZXingHtml5QrcodeDecoder2.prototype.createZXingFormats = function(requestedFormats) {
    var zxingFormats = [];
    for (var _i2 = 0, requestedFormats_1 = requestedFormats; _i2 < requestedFormats_1.length; _i2++) {
      var requestedFormat = requestedFormats_1[_i2];
      if (this.formatMap.has(requestedFormat)) {
        zxingFormats.push(this.formatMap.get(requestedFormat));
      } else {
        this.logger.logError("".concat(requestedFormat, " is not supported by") + "ZXingHtml5QrcodeShim");
      }
    }
    return zxingFormats;
  };
  ZXingHtml5QrcodeDecoder2.prototype.createDebugData = function() {
    return { decoderName: "zxing-js" };
  };
  return ZXingHtml5QrcodeDecoder2;
}();
var __awaiter$6 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result2) {
      result2.done ? resolve2(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$6 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t3[0] & 1)
      throw t3[1];
    return t3[1];
  }, trys: [], ops: [] }, f, y, t3, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v) {
      return step([n2, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t3 = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t3 = y["return"]) && t3.call(y), 0) : y.next) && !(t3 = t3.call(y, op[1])).done)
          return t3;
        if (y = 0, t3)
          op = [op[0] & 2, t3.value];
        switch (op[0]) {
          case 0:
          case 1:
            t3 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t3 = _.trys, t3 = t3.length > 0 && t3[t3.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t3 || op[1] > t3[0] && op[1] < t3[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t3[1]) {
              _.label = t3[1];
              t3 = op;
              break;
            }
            if (t3 && _.label < t3[2]) {
              _.label = t3[2];
              _.ops.push(op);
              break;
            }
            if (t3[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t3 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var BarcodeDetectorDelegate = function() {
  function BarcodeDetectorDelegate2(requestedFormats, verbose, logger2) {
    this.formatMap = /* @__PURE__ */ new Map([
      [Html5QrcodeSupportedFormats.QR_CODE, "qr_code"],
      [Html5QrcodeSupportedFormats.AZTEC, "aztec"],
      [Html5QrcodeSupportedFormats.CODABAR, "codabar"],
      [Html5QrcodeSupportedFormats.CODE_39, "code_39"],
      [Html5QrcodeSupportedFormats.CODE_93, "code_93"],
      [Html5QrcodeSupportedFormats.CODE_128, "code_128"],
      [Html5QrcodeSupportedFormats.DATA_MATRIX, "data_matrix"],
      [Html5QrcodeSupportedFormats.ITF, "itf"],
      [Html5QrcodeSupportedFormats.EAN_13, "ean_13"],
      [Html5QrcodeSupportedFormats.EAN_8, "ean_8"],
      [Html5QrcodeSupportedFormats.PDF_417, "pdf417"],
      [Html5QrcodeSupportedFormats.UPC_A, "upc_a"],
      [Html5QrcodeSupportedFormats.UPC_E, "upc_e"]
    ]);
    this.reverseFormatMap = this.createReverseFormatMap();
    if (!BarcodeDetectorDelegate2.isSupported()) {
      throw "Use html5qrcode.min.js without edit, Use BarcodeDetectorDelegate only if it isSupported();";
    }
    this.verbose = verbose;
    this.logger = logger2;
    var formats = this.createBarcodeDetectorFormats(requestedFormats);
    this.detector = new BarcodeDetector(formats);
    if (!this.detector) {
      throw "BarcodeDetector detector not supported";
    }
  }
  BarcodeDetectorDelegate2.isSupported = function() {
    if (!("BarcodeDetector" in window)) {
      return false;
    }
    var dummyDetector = new BarcodeDetector({ formats: ["qr_code"] });
    return typeof dummyDetector !== "undefined";
  };
  BarcodeDetectorDelegate2.prototype.decodeAsync = function(canvas) {
    return __awaiter$6(this, void 0, void 0, function() {
      var barcodes, largestBarcode;
      return __generator$6(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, this.detector.detect(canvas)];
          case 1:
            barcodes = _a2.sent();
            if (!barcodes || barcodes.length === 0) {
              throw "No barcode or QR code detected.";
            }
            largestBarcode = this.selectLargestBarcode(barcodes);
            return [2, {
              text: largestBarcode.rawValue,
              format: QrcodeResultFormat.create(this.toHtml5QrcodeSupportedFormats(largestBarcode.format)),
              debugData: this.createDebugData()
            }];
        }
      });
    });
  };
  BarcodeDetectorDelegate2.prototype.selectLargestBarcode = function(barcodes) {
    var largestBarcode = null;
    var maxArea = 0;
    for (var _i2 = 0, barcodes_1 = barcodes; _i2 < barcodes_1.length; _i2++) {
      var barcode = barcodes_1[_i2];
      var area = barcode.boundingBox.width * barcode.boundingBox.height;
      if (area > maxArea) {
        maxArea = area;
        largestBarcode = barcode;
      }
    }
    if (!largestBarcode) {
      throw "No largest barcode found";
    }
    return largestBarcode;
  };
  BarcodeDetectorDelegate2.prototype.createBarcodeDetectorFormats = function(requestedFormats) {
    var formats = [];
    for (var _i2 = 0, requestedFormats_1 = requestedFormats; _i2 < requestedFormats_1.length; _i2++) {
      var requestedFormat = requestedFormats_1[_i2];
      if (this.formatMap.has(requestedFormat)) {
        formats.push(this.formatMap.get(requestedFormat));
      } else {
        this.logger.warn("".concat(requestedFormat, " is not supported by") + "BarcodeDetectorDelegate");
      }
    }
    return { formats };
  };
  BarcodeDetectorDelegate2.prototype.toHtml5QrcodeSupportedFormats = function(barcodeDetectorFormat) {
    if (!this.reverseFormatMap.has(barcodeDetectorFormat)) {
      throw "reverseFormatMap doesn't have ".concat(barcodeDetectorFormat);
    }
    return this.reverseFormatMap.get(barcodeDetectorFormat);
  };
  BarcodeDetectorDelegate2.prototype.createReverseFormatMap = function() {
    var result2 = /* @__PURE__ */ new Map();
    this.formatMap.forEach(function(value, key, _) {
      result2.set(value, key);
    });
    return result2;
  };
  BarcodeDetectorDelegate2.prototype.createDebugData = function() {
    return { decoderName: "BarcodeDetector" };
  };
  return BarcodeDetectorDelegate2;
}();
var __awaiter$5 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result2) {
      result2.done ? resolve2(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$5 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t3[0] & 1)
      throw t3[1];
    return t3[1];
  }, trys: [], ops: [] }, f, y, t3, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v) {
      return step([n2, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t3 = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t3 = y["return"]) && t3.call(y), 0) : y.next) && !(t3 = t3.call(y, op[1])).done)
          return t3;
        if (y = 0, t3)
          op = [op[0] & 2, t3.value];
        switch (op[0]) {
          case 0:
          case 1:
            t3 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t3 = _.trys, t3 = t3.length > 0 && t3[t3.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t3 || op[1] > t3[0] && op[1] < t3[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t3[1]) {
              _.label = t3[1];
              t3 = op;
              break;
            }
            if (t3 && _.label < t3[2]) {
              _.label = t3[2];
              _.ops.push(op);
              break;
            }
            if (t3[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t3 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var Html5QrcodeShim = function() {
  function Html5QrcodeShim2(requestedFormats, useBarCodeDetectorIfSupported, verbose, logger2) {
    this.EXECUTIONS_TO_REPORT_PERFORMANCE = 100;
    this.executions = 0;
    this.executionResults = [];
    this.wasPrimaryDecoderUsedInLastDecode = false;
    this.verbose = verbose;
    if (useBarCodeDetectorIfSupported && BarcodeDetectorDelegate.isSupported()) {
      this.primaryDecoder = new BarcodeDetectorDelegate(requestedFormats, verbose, logger2);
      this.secondaryDecoder = new ZXingHtml5QrcodeDecoder(requestedFormats, verbose, logger2);
    } else {
      this.primaryDecoder = new ZXingHtml5QrcodeDecoder(requestedFormats, verbose, logger2);
    }
  }
  Html5QrcodeShim2.prototype.decodeAsync = function(canvas) {
    return __awaiter$5(this, void 0, void 0, function() {
      var startTime;
      return __generator$5(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            startTime = performance.now();
            _a2.label = 1;
          case 1:
            _a2.trys.push([1, , 3, 4]);
            return [4, this.getDecoder().decodeAsync(canvas)];
          case 2:
            return [2, _a2.sent()];
          case 3:
            this.possiblyLogPerformance(startTime);
            return [7];
          case 4:
            return [2];
        }
      });
    });
  };
  Html5QrcodeShim2.prototype.decodeRobustlyAsync = function(canvas) {
    return __awaiter$5(this, void 0, void 0, function() {
      var startTime, error_1;
      return __generator$5(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            startTime = performance.now();
            _a2.label = 1;
          case 1:
            _a2.trys.push([1, 3, 4, 5]);
            return [4, this.primaryDecoder.decodeAsync(canvas)];
          case 2:
            return [2, _a2.sent()];
          case 3:
            error_1 = _a2.sent();
            if (this.secondaryDecoder) {
              return [2, this.secondaryDecoder.decodeAsync(canvas)];
            }
            throw error_1;
          case 4:
            this.possiblyLogPerformance(startTime);
            return [7];
          case 5:
            return [2];
        }
      });
    });
  };
  Html5QrcodeShim2.prototype.getDecoder = function() {
    if (!this.secondaryDecoder) {
      return this.primaryDecoder;
    }
    if (this.wasPrimaryDecoderUsedInLastDecode === false) {
      this.wasPrimaryDecoderUsedInLastDecode = true;
      return this.primaryDecoder;
    }
    this.wasPrimaryDecoderUsedInLastDecode = false;
    return this.secondaryDecoder;
  };
  Html5QrcodeShim2.prototype.possiblyLogPerformance = function(startTime) {
    if (!this.verbose) {
      return;
    }
    var executionTime = performance.now() - startTime;
    this.executionResults.push(executionTime);
    this.executions++;
    this.possiblyFlushPerformanceReport();
  };
  Html5QrcodeShim2.prototype.possiblyFlushPerformanceReport = function() {
    if (this.executions < this.EXECUTIONS_TO_REPORT_PERFORMANCE) {
      return;
    }
    var sum = 0;
    for (var _i2 = 0, _a2 = this.executionResults; _i2 < _a2.length; _i2++) {
      var executionTime = _a2[_i2];
      sum += executionTime;
    }
    var mean = sum / this.executionResults.length;
    console.log("".concat(mean, " ms for ").concat(this.executionResults.length, " last runs."));
    this.executions = 0;
    this.executionResults = [];
  };
  return Html5QrcodeShim2;
}();
var __extends$1 = globalThis && globalThis.__extends || function() {
  var extendStatics2 = function(d2, b) {
    extendStatics2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b2) {
      d3.__proto__ = b2;
    } || function(d3, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d3[p] = b2[p];
    };
    return extendStatics2(d2, b);
  };
  return function(d2, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics2(d2, b);
    function __() {
      this.constructor = d2;
    }
    d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter$4 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result2) {
      result2.done ? resolve2(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$4 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t3[0] & 1)
      throw t3[1];
    return t3[1];
  }, trys: [], ops: [] }, f, y, t3, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v) {
      return step([n2, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t3 = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t3 = y["return"]) && t3.call(y), 0) : y.next) && !(t3 = t3.call(y, op[1])).done)
          return t3;
        if (y = 0, t3)
          op = [op[0] & 2, t3.value];
        switch (op[0]) {
          case 0:
          case 1:
            t3 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t3 = _.trys, t3 = t3.length > 0 && t3[t3.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t3 || op[1] > t3[0] && op[1] < t3[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t3[1]) {
              _.label = t3[1];
              t3 = op;
              break;
            }
            if (t3 && _.label < t3[2]) {
              _.label = t3[2];
              _.ops.push(op);
              break;
            }
            if (t3[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t3 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var AbstractCameraCapability = function() {
  function AbstractCameraCapability2(name, track) {
    this.name = name;
    this.track = track;
  }
  AbstractCameraCapability2.prototype.isSupported = function() {
    if (!this.track.getCapabilities) {
      return false;
    }
    return this.name in this.track.getCapabilities();
  };
  AbstractCameraCapability2.prototype.apply = function(value) {
    var constraint = {};
    constraint[this.name] = value;
    var constraints = { advanced: [constraint] };
    return this.track.applyConstraints(constraints);
  };
  AbstractCameraCapability2.prototype.value = function() {
    var settings = this.track.getSettings();
    if (this.name in settings) {
      var settingValue = settings[this.name];
      return settingValue;
    }
    return null;
  };
  return AbstractCameraCapability2;
}();
var AbstractRangeCameraCapability = function(_super) {
  __extends$1(AbstractRangeCameraCapability2, _super);
  function AbstractRangeCameraCapability2(name, track) {
    return _super.call(this, name, track) || this;
  }
  AbstractRangeCameraCapability2.prototype.min = function() {
    return this.getCapabilities().min;
  };
  AbstractRangeCameraCapability2.prototype.max = function() {
    return this.getCapabilities().max;
  };
  AbstractRangeCameraCapability2.prototype.step = function() {
    return this.getCapabilities().step;
  };
  AbstractRangeCameraCapability2.prototype.apply = function(value) {
    var constraint = {};
    constraint[this.name] = value;
    var constraints = { advanced: [constraint] };
    return this.track.applyConstraints(constraints);
  };
  AbstractRangeCameraCapability2.prototype.getCapabilities = function() {
    this.failIfNotSupported();
    var capabilities = this.track.getCapabilities();
    var capability = capabilities[this.name];
    return {
      min: capability.min,
      max: capability.max,
      step: capability.step
    };
  };
  AbstractRangeCameraCapability2.prototype.failIfNotSupported = function() {
    if (!this.isSupported()) {
      throw new Error("".concat(this.name, " capability not supported"));
    }
  };
  return AbstractRangeCameraCapability2;
}(AbstractCameraCapability);
var ZoomFeatureImpl = function(_super) {
  __extends$1(ZoomFeatureImpl2, _super);
  function ZoomFeatureImpl2(track) {
    return _super.call(this, "zoom", track) || this;
  }
  return ZoomFeatureImpl2;
}(AbstractRangeCameraCapability);
var TorchFeatureImpl = function(_super) {
  __extends$1(TorchFeatureImpl2, _super);
  function TorchFeatureImpl2(track) {
    return _super.call(this, "torch", track) || this;
  }
  return TorchFeatureImpl2;
}(AbstractCameraCapability);
var CameraCapabilitiesImpl = function() {
  function CameraCapabilitiesImpl2(track) {
    this.track = track;
  }
  CameraCapabilitiesImpl2.prototype.zoomFeature = function() {
    return new ZoomFeatureImpl(this.track);
  };
  CameraCapabilitiesImpl2.prototype.torchFeature = function() {
    return new TorchFeatureImpl(this.track);
  };
  return CameraCapabilitiesImpl2;
}();
var RenderedCameraImpl = function() {
  function RenderedCameraImpl2(parentElement, mediaStream, callbacks2) {
    this.isClosed = false;
    this.parentElement = parentElement;
    this.mediaStream = mediaStream;
    this.callbacks = callbacks2;
    this.surface = this.createVideoElement(this.parentElement.clientWidth);
    parentElement.append(this.surface);
  }
  RenderedCameraImpl2.prototype.createVideoElement = function(width) {
    var videoElement = document.createElement("video");
    videoElement.style.width = "".concat(width, "px");
    videoElement.style.display = "block";
    videoElement.muted = true;
    videoElement.setAttribute("muted", "true");
    videoElement.playsInline = true;
    return videoElement;
  };
  RenderedCameraImpl2.prototype.setupSurface = function() {
    var _this2 = this;
    this.surface.onabort = function() {
      throw "RenderedCameraImpl video surface onabort() called";
    };
    this.surface.onerror = function() {
      throw "RenderedCameraImpl video surface onerror() called";
    };
    var onVideoStart = function() {
      var videoWidth = _this2.surface.clientWidth;
      var videoHeight = _this2.surface.clientHeight;
      _this2.callbacks.onRenderSurfaceReady(videoWidth, videoHeight);
      _this2.surface.removeEventListener("playing", onVideoStart);
    };
    this.surface.addEventListener("playing", onVideoStart);
    this.surface.srcObject = this.mediaStream;
    this.surface.play();
  };
  RenderedCameraImpl2.create = function(parentElement, mediaStream, options, callbacks2) {
    return __awaiter$4(this, void 0, void 0, function() {
      var renderedCamera, aspectRatioConstraint;
      return __generator$4(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            renderedCamera = new RenderedCameraImpl2(parentElement, mediaStream, callbacks2);
            if (!options.aspectRatio)
              return [3, 2];
            aspectRatioConstraint = {
              aspectRatio: options.aspectRatio
            };
            return [4, renderedCamera.getFirstTrackOrFail().applyConstraints(aspectRatioConstraint)];
          case 1:
            _a2.sent();
            _a2.label = 2;
          case 2:
            renderedCamera.setupSurface();
            return [2, renderedCamera];
        }
      });
    });
  };
  RenderedCameraImpl2.prototype.failIfClosed = function() {
    if (this.isClosed) {
      throw "The RenderedCamera has already been closed.";
    }
  };
  RenderedCameraImpl2.prototype.getFirstTrackOrFail = function() {
    this.failIfClosed();
    if (this.mediaStream.getVideoTracks().length === 0) {
      throw "No video tracks found";
    }
    return this.mediaStream.getVideoTracks()[0];
  };
  RenderedCameraImpl2.prototype.pause = function() {
    this.failIfClosed();
    this.surface.pause();
  };
  RenderedCameraImpl2.prototype.resume = function(onResumeCallback) {
    this.failIfClosed();
    var $this = this;
    var onVideoResume = function() {
      setTimeout(onResumeCallback, 200);
      $this.surface.removeEventListener("playing", onVideoResume);
    };
    this.surface.addEventListener("playing", onVideoResume);
    this.surface.play();
  };
  RenderedCameraImpl2.prototype.isPaused = function() {
    this.failIfClosed();
    return this.surface.paused;
  };
  RenderedCameraImpl2.prototype.getSurface = function() {
    this.failIfClosed();
    return this.surface;
  };
  RenderedCameraImpl2.prototype.getRunningTrackCapabilities = function() {
    return this.getFirstTrackOrFail().getCapabilities();
  };
  RenderedCameraImpl2.prototype.getRunningTrackSettings = function() {
    return this.getFirstTrackOrFail().getSettings();
  };
  RenderedCameraImpl2.prototype.applyVideoConstraints = function(constraints) {
    return __awaiter$4(this, void 0, void 0, function() {
      return __generator$4(this, function(_a2) {
        if ("aspectRatio" in constraints) {
          throw "Changing 'aspectRatio' in run-time is not yet supported.";
        }
        return [2, this.getFirstTrackOrFail().applyConstraints(constraints)];
      });
    });
  };
  RenderedCameraImpl2.prototype.close = function() {
    if (this.isClosed) {
      return Promise.resolve();
    }
    var $this = this;
    return new Promise(function(resolve2, _) {
      var tracks = $this.mediaStream.getVideoTracks();
      var tracksToClose = tracks.length;
      var tracksClosed = 0;
      $this.mediaStream.getVideoTracks().forEach(function(videoTrack) {
        $this.mediaStream.removeTrack(videoTrack);
        videoTrack.stop();
        ++tracksClosed;
        if (tracksClosed >= tracksToClose) {
          $this.isClosed = true;
          $this.parentElement.removeChild($this.surface);
          resolve2();
        }
      });
    });
  };
  RenderedCameraImpl2.prototype.getCapabilities = function() {
    return new CameraCapabilitiesImpl(this.getFirstTrackOrFail());
  };
  return RenderedCameraImpl2;
}();
var CameraImpl = function() {
  function CameraImpl2(mediaStream) {
    this.mediaStream = mediaStream;
  }
  CameraImpl2.prototype.render = function(parentElement, options, callbacks2) {
    return __awaiter$4(this, void 0, void 0, function() {
      return __generator$4(this, function(_a2) {
        return [2, RenderedCameraImpl.create(parentElement, this.mediaStream, options, callbacks2)];
      });
    });
  };
  CameraImpl2.create = function(videoConstraints) {
    return __awaiter$4(this, void 0, void 0, function() {
      var constraints, mediaStream;
      return __generator$4(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!navigator.mediaDevices) {
              throw "navigator.mediaDevices not supported";
            }
            constraints = {
              audio: false,
              video: videoConstraints
            };
            return [4, navigator.mediaDevices.getUserMedia(constraints)];
          case 1:
            mediaStream = _a2.sent();
            return [2, new CameraImpl2(mediaStream)];
        }
      });
    });
  };
  return CameraImpl2;
}();
var __awaiter$3 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result2) {
      result2.done ? resolve2(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$3 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t3[0] & 1)
      throw t3[1];
    return t3[1];
  }, trys: [], ops: [] }, f, y, t3, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v) {
      return step([n2, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t3 = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t3 = y["return"]) && t3.call(y), 0) : y.next) && !(t3 = t3.call(y, op[1])).done)
          return t3;
        if (y = 0, t3)
          op = [op[0] & 2, t3.value];
        switch (op[0]) {
          case 0:
          case 1:
            t3 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t3 = _.trys, t3 = t3.length > 0 && t3[t3.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t3 || op[1] > t3[0] && op[1] < t3[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t3[1]) {
              _.label = t3[1];
              t3 = op;
              break;
            }
            if (t3 && _.label < t3[2]) {
              _.label = t3[2];
              _.ops.push(op);
              break;
            }
            if (t3[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t3 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var CameraFactory = function() {
  function CameraFactory2() {
  }
  CameraFactory2.failIfNotSupported = function() {
    return __awaiter$3(this, void 0, void 0, function() {
      return __generator$3(this, function(_a2) {
        if (!navigator.mediaDevices) {
          throw "navigator.mediaDevices not supported";
        }
        return [2, new CameraFactory2()];
      });
    });
  };
  CameraFactory2.prototype.create = function(videoConstraints) {
    return __awaiter$3(this, void 0, void 0, function() {
      return __generator$3(this, function(_a2) {
        return [2, CameraImpl.create(videoConstraints)];
      });
    });
  };
  return CameraFactory2;
}();
var __awaiter$2 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result2) {
      result2.done ? resolve2(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$2 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t3[0] & 1)
      throw t3[1];
    return t3[1];
  }, trys: [], ops: [] }, f, y, t3, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v) {
      return step([n2, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t3 = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t3 = y["return"]) && t3.call(y), 0) : y.next) && !(t3 = t3.call(y, op[1])).done)
          return t3;
        if (y = 0, t3)
          op = [op[0] & 2, t3.value];
        switch (op[0]) {
          case 0:
          case 1:
            t3 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t3 = _.trys, t3 = t3.length > 0 && t3[t3.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t3 || op[1] > t3[0] && op[1] < t3[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t3[1]) {
              _.label = t3[1];
              t3 = op;
              break;
            }
            if (t3 && _.label < t3[2]) {
              _.label = t3[2];
              _.ops.push(op);
              break;
            }
            if (t3[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t3 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var CameraRetriever = function() {
  function CameraRetriever2() {
  }
  CameraRetriever2.retrieve = function() {
    if (navigator.mediaDevices) {
      return CameraRetriever2.getCamerasFromMediaDevices();
    }
    var mst = MediaStreamTrack;
    if (MediaStreamTrack && mst.getSources) {
      return CameraRetriever2.getCamerasFromMediaStreamTrack();
    }
    return CameraRetriever2.rejectWithError();
  };
  CameraRetriever2.rejectWithError = function() {
    var errorMessage = Html5QrcodeStrings.unableToQuerySupportedDevices();
    if (!CameraRetriever2.isHttpsOrLocalhost()) {
      errorMessage = Html5QrcodeStrings.insecureContextCameraQueryError();
    }
    return Promise.reject(errorMessage);
  };
  CameraRetriever2.isHttpsOrLocalhost = function() {
    if (location.protocol === "https:") {
      return true;
    }
    var host = location.host.split(":")[0];
    return host === "127.0.0.1" || host === "localhost";
  };
  CameraRetriever2.getCamerasFromMediaDevices = function() {
    return __awaiter$2(this, void 0, void 0, function() {
      var closeActiveStreams, mediaStream, devices, results, _i2, devices_1, device;
      return __generator$2(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            closeActiveStreams = function(stream) {
              var tracks = stream.getVideoTracks();
              for (var _i3 = 0, tracks_1 = tracks; _i3 < tracks_1.length; _i3++) {
                var track = tracks_1[_i3];
                track.enabled = false;
                track.stop();
                stream.removeTrack(track);
              }
            };
            return [4, navigator.mediaDevices.getUserMedia({ audio: false, video: true })];
          case 1:
            mediaStream = _a2.sent();
            return [4, navigator.mediaDevices.enumerateDevices()];
          case 2:
            devices = _a2.sent();
            results = [];
            for (_i2 = 0, devices_1 = devices; _i2 < devices_1.length; _i2++) {
              device = devices_1[_i2];
              if (device.kind === "videoinput") {
                results.push({
                  id: device.deviceId,
                  label: device.label
                });
              }
            }
            closeActiveStreams(mediaStream);
            return [2, results];
        }
      });
    });
  };
  CameraRetriever2.getCamerasFromMediaStreamTrack = function() {
    return new Promise(function(resolve2, _) {
      var callback = function(sourceInfos) {
        var results = [];
        for (var _i2 = 0, sourceInfos_1 = sourceInfos; _i2 < sourceInfos_1.length; _i2++) {
          var sourceInfo = sourceInfos_1[_i2];
          if (sourceInfo.kind === "video") {
            results.push({
              id: sourceInfo.id,
              label: sourceInfo.label
            });
          }
        }
        resolve2(results);
      };
      var mst = MediaStreamTrack;
      mst.getSources(callback);
    });
  };
  return CameraRetriever2;
}();
var Html5QrcodeScannerState;
(function(Html5QrcodeScannerState2) {
  Html5QrcodeScannerState2[Html5QrcodeScannerState2["UNKNOWN"] = 0] = "UNKNOWN";
  Html5QrcodeScannerState2[Html5QrcodeScannerState2["NOT_STARTED"] = 1] = "NOT_STARTED";
  Html5QrcodeScannerState2[Html5QrcodeScannerState2["SCANNING"] = 2] = "SCANNING";
  Html5QrcodeScannerState2[Html5QrcodeScannerState2["PAUSED"] = 3] = "PAUSED";
})(Html5QrcodeScannerState || (Html5QrcodeScannerState = {}));
var StateManagerImpl = function() {
  function StateManagerImpl2() {
    this.state = Html5QrcodeScannerState.NOT_STARTED;
    this.onGoingTransactionNewState = Html5QrcodeScannerState.UNKNOWN;
  }
  StateManagerImpl2.prototype.directTransition = function(newState) {
    this.failIfTransitionOngoing();
    this.validateTransition(newState);
    this.state = newState;
  };
  StateManagerImpl2.prototype.startTransition = function(newState) {
    this.failIfTransitionOngoing();
    this.validateTransition(newState);
    this.onGoingTransactionNewState = newState;
    return this;
  };
  StateManagerImpl2.prototype.execute = function() {
    if (this.onGoingTransactionNewState === Html5QrcodeScannerState.UNKNOWN) {
      throw "Transaction is already cancelled, cannot execute().";
    }
    var tempNewState = this.onGoingTransactionNewState;
    this.onGoingTransactionNewState = Html5QrcodeScannerState.UNKNOWN;
    this.directTransition(tempNewState);
  };
  StateManagerImpl2.prototype.cancel = function() {
    if (this.onGoingTransactionNewState === Html5QrcodeScannerState.UNKNOWN) {
      throw "Transaction is already cancelled, cannot cancel().";
    }
    this.onGoingTransactionNewState = Html5QrcodeScannerState.UNKNOWN;
  };
  StateManagerImpl2.prototype.getState = function() {
    return this.state;
  };
  StateManagerImpl2.prototype.failIfTransitionOngoing = function() {
    if (this.onGoingTransactionNewState !== Html5QrcodeScannerState.UNKNOWN) {
      throw "Cannot transition to a new state, already under transition";
    }
  };
  StateManagerImpl2.prototype.validateTransition = function(newState) {
    switch (this.state) {
      case Html5QrcodeScannerState.UNKNOWN:
        throw "Transition from unknown is not allowed";
      case Html5QrcodeScannerState.NOT_STARTED:
        this.failIfNewStateIs(newState, [Html5QrcodeScannerState.PAUSED]);
        break;
      case Html5QrcodeScannerState.SCANNING:
        break;
      case Html5QrcodeScannerState.PAUSED:
        break;
    }
  };
  StateManagerImpl2.prototype.failIfNewStateIs = function(newState, disallowedStatesToTransition) {
    for (var _i2 = 0, disallowedStatesToTransition_1 = disallowedStatesToTransition; _i2 < disallowedStatesToTransition_1.length; _i2++) {
      var disallowedState = disallowedStatesToTransition_1[_i2];
      if (newState === disallowedState) {
        throw "Cannot transition from ".concat(this.state, " to ").concat(newState);
      }
    }
  };
  return StateManagerImpl2;
}();
var StateManagerProxy = function() {
  function StateManagerProxy2(stateManager) {
    this.stateManager = stateManager;
  }
  StateManagerProxy2.prototype.startTransition = function(newState) {
    return this.stateManager.startTransition(newState);
  };
  StateManagerProxy2.prototype.directTransition = function(newState) {
    this.stateManager.directTransition(newState);
  };
  StateManagerProxy2.prototype.getState = function() {
    return this.stateManager.getState();
  };
  StateManagerProxy2.prototype.canScanFile = function() {
    return this.stateManager.getState() === Html5QrcodeScannerState.NOT_STARTED;
  };
  StateManagerProxy2.prototype.isScanning = function() {
    return this.stateManager.getState() !== Html5QrcodeScannerState.NOT_STARTED;
  };
  StateManagerProxy2.prototype.isStrictlyScanning = function() {
    return this.stateManager.getState() === Html5QrcodeScannerState.SCANNING;
  };
  StateManagerProxy2.prototype.isPaused = function() {
    return this.stateManager.getState() === Html5QrcodeScannerState.PAUSED;
  };
  return StateManagerProxy2;
}();
var StateManagerFactory = function() {
  function StateManagerFactory2() {
  }
  StateManagerFactory2.create = function() {
    return new StateManagerProxy(new StateManagerImpl());
  };
  return StateManagerFactory2;
}();
var __extends = globalThis && globalThis.__extends || function() {
  var extendStatics2 = function(d2, b) {
    extendStatics2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b2) {
      d3.__proto__ = b2;
    } || function(d3, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d3[p] = b2[p];
    };
    return extendStatics2(d2, b);
  };
  return function(d2, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics2(d2, b);
    function __() {
      this.constructor = d2;
    }
    d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Constants = function(_super) {
  __extends(Constants2, _super);
  function Constants2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Constants2.DEFAULT_WIDTH = 300;
  Constants2.DEFAULT_WIDTH_OFFSET = 2;
  Constants2.FILE_SCAN_MIN_HEIGHT = 300;
  Constants2.FILE_SCAN_HIDDEN_CANVAS_PADDING = 100;
  Constants2.MIN_QR_BOX_SIZE = 50;
  Constants2.SHADED_LEFT = 1;
  Constants2.SHADED_RIGHT = 2;
  Constants2.SHADED_TOP = 3;
  Constants2.SHADED_BOTTOM = 4;
  Constants2.SHADED_REGION_ELEMENT_ID = "qr-shaded-region";
  Constants2.VERBOSE = false;
  Constants2.BORDER_SHADER_DEFAULT_COLOR = "#ffffff";
  Constants2.BORDER_SHADER_MATCH_COLOR = "rgb(90, 193, 56)";
  return Constants2;
}(Html5QrcodeConstants);
var InternalHtml5QrcodeConfig = function() {
  function InternalHtml5QrcodeConfig2(config2, logger2) {
    this.logger = logger2;
    this.fps = Constants.SCAN_DEFAULT_FPS;
    if (!config2) {
      this.disableFlip = Constants.DEFAULT_DISABLE_FLIP;
    } else {
      if (config2.fps) {
        this.fps = config2.fps;
      }
      this.disableFlip = config2.disableFlip === true;
      this.qrbox = config2.qrbox;
      this.aspectRatio = config2.aspectRatio;
      this.videoConstraints = config2.videoConstraints;
    }
  }
  InternalHtml5QrcodeConfig2.prototype.isMediaStreamConstraintsValid = function() {
    if (!this.videoConstraints) {
      this.logger.logError("Empty videoConstraints", true);
      return false;
    }
    return VideoConstraintsUtil.isMediaStreamConstraintsValid(this.videoConstraints, this.logger);
  };
  InternalHtml5QrcodeConfig2.prototype.isShadedBoxEnabled = function() {
    return !isNullOrUndefined(this.qrbox);
  };
  InternalHtml5QrcodeConfig2.create = function(config2, logger2) {
    return new InternalHtml5QrcodeConfig2(config2, logger2);
  };
  return InternalHtml5QrcodeConfig2;
}();
var Html5Qrcode = function() {
  function Html5Qrcode2(elementId, configOrVerbosityFlag) {
    this.element = null;
    this.canvasElement = null;
    this.scannerPausedUiElement = null;
    this.hasBorderShaders = null;
    this.borderShaders = null;
    this.qrMatch = null;
    this.renderedCamera = null;
    this.qrRegion = null;
    this.context = null;
    this.lastScanImageFile = null;
    this.isScanning = false;
    if (!document.getElementById(elementId)) {
      throw "HTML Element with id=".concat(elementId, " not found");
    }
    this.elementId = elementId;
    this.verbose = false;
    var configObject;
    if (typeof configOrVerbosityFlag == "boolean") {
      this.verbose = configOrVerbosityFlag === true;
    } else if (configOrVerbosityFlag) {
      configObject = configOrVerbosityFlag;
      this.verbose = configObject.verbose === true;
      configObject.experimentalFeatures;
    }
    this.logger = new BaseLoggger(this.verbose);
    this.qrcode = new Html5QrcodeShim(this.getSupportedFormats(configOrVerbosityFlag), this.getUseBarCodeDetectorIfSupported(configObject), this.verbose, this.logger);
    this.foreverScanTimeout;
    this.shouldScan = true;
    this.stateManagerProxy = StateManagerFactory.create();
  }
  Html5Qrcode2.prototype.start = function(cameraIdOrConfig, configuration, qrCodeSuccessCallback, qrCodeErrorCallback) {
    var _this2 = this;
    if (!cameraIdOrConfig) {
      throw "cameraIdOrConfig is required";
    }
    if (!qrCodeSuccessCallback || typeof qrCodeSuccessCallback != "function") {
      throw "qrCodeSuccessCallback is required and should be a function.";
    }
    var qrCodeErrorCallbackInternal;
    if (qrCodeErrorCallback) {
      qrCodeErrorCallbackInternal = qrCodeErrorCallback;
    } else {
      qrCodeErrorCallbackInternal = this.verbose ? this.logger.log : function() {
      };
    }
    var internalConfig = InternalHtml5QrcodeConfig.create(configuration, this.logger);
    this.clearElement();
    var videoConstraintsAvailableAndValid = false;
    if (internalConfig.videoConstraints) {
      if (!internalConfig.isMediaStreamConstraintsValid()) {
        this.logger.logError("'videoConstraints' is not valid 'MediaStreamConstraints, it will be ignored.'", true);
      } else {
        videoConstraintsAvailableAndValid = true;
      }
    }
    var areVideoConstraintsEnabled = videoConstraintsAvailableAndValid;
    var element = document.getElementById(this.elementId);
    element.clientWidth ? element.clientWidth : Constants.DEFAULT_WIDTH;
    element.style.position = "relative";
    this.shouldScan = true;
    this.element = element;
    var $this = this;
    var toScanningStateChangeTransaction = this.stateManagerProxy.startTransition(Html5QrcodeScannerState.SCANNING);
    return new Promise(function(resolve2, reject) {
      var videoConstraints = areVideoConstraintsEnabled ? internalConfig.videoConstraints : $this.createVideoConstraints(cameraIdOrConfig);
      if (!videoConstraints) {
        toScanningStateChangeTransaction.cancel();
        reject("videoConstraints should be defined");
        return;
      }
      var cameraRenderingOptions = {};
      if (!areVideoConstraintsEnabled || internalConfig.aspectRatio) {
        cameraRenderingOptions.aspectRatio = internalConfig.aspectRatio;
      }
      var renderingCallbacks = {
        onRenderSurfaceReady: function(viewfinderWidth, viewfinderHeight) {
          $this.setupUi(viewfinderWidth, viewfinderHeight, internalConfig);
          $this.isScanning = true;
          $this.foreverScan(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallbackInternal);
        }
      };
      CameraFactory.failIfNotSupported().then(function(factory) {
        factory.create(videoConstraints).then(function(camera2) {
          return camera2.render(_this2.element, cameraRenderingOptions, renderingCallbacks).then(function(renderedCamera) {
            $this.renderedCamera = renderedCamera;
            toScanningStateChangeTransaction.execute();
            resolve2(null);
          }).catch(function(error2) {
            toScanningStateChangeTransaction.cancel();
            reject(error2);
          });
        }).catch(function(error2) {
          toScanningStateChangeTransaction.cancel();
          reject(Html5QrcodeStrings.errorGettingUserMedia(error2));
        });
      }).catch(function(_) {
        toScanningStateChangeTransaction.cancel();
        reject(Html5QrcodeStrings.cameraStreamingNotSupported());
      });
    });
  };
  Html5Qrcode2.prototype.pause = function(shouldPauseVideo) {
    if (!this.stateManagerProxy.isStrictlyScanning()) {
      throw "Cannot pause, scanner is not scanning.";
    }
    this.stateManagerProxy.directTransition(Html5QrcodeScannerState.PAUSED);
    this.showPausedState();
    if (isNullOrUndefined(shouldPauseVideo) || shouldPauseVideo !== true) {
      shouldPauseVideo = false;
    }
    if (shouldPauseVideo && this.renderedCamera) {
      this.renderedCamera.pause();
    }
  };
  Html5Qrcode2.prototype.resume = function() {
    if (!this.stateManagerProxy.isPaused()) {
      throw "Cannot result, scanner is not paused.";
    }
    if (!this.renderedCamera) {
      throw "renderedCamera doesn't exist while trying resume()";
    }
    var $this = this;
    var transitionToScanning = function() {
      $this.stateManagerProxy.directTransition(Html5QrcodeScannerState.SCANNING);
      $this.hidePausedState();
    };
    if (!this.renderedCamera.isPaused()) {
      transitionToScanning();
      return;
    }
    this.renderedCamera.resume(function() {
      transitionToScanning();
    });
  };
  Html5Qrcode2.prototype.getState = function() {
    return this.stateManagerProxy.getState();
  };
  Html5Qrcode2.prototype.stop = function() {
    var _this2 = this;
    if (!this.stateManagerProxy.isScanning()) {
      throw "Cannot stop, scanner is not running or paused.";
    }
    var toStoppedStateTransaction = this.stateManagerProxy.startTransition(Html5QrcodeScannerState.NOT_STARTED);
    this.shouldScan = false;
    if (this.foreverScanTimeout) {
      clearTimeout(this.foreverScanTimeout);
    }
    var removeQrRegion = function() {
      if (!_this2.element) {
        return;
      }
      var childElement = document.getElementById(Constants.SHADED_REGION_ELEMENT_ID);
      if (childElement) {
        _this2.element.removeChild(childElement);
      }
    };
    var $this = this;
    return this.renderedCamera.close().then(function() {
      $this.renderedCamera = null;
      if ($this.element) {
        $this.element.removeChild($this.canvasElement);
        $this.canvasElement = null;
      }
      removeQrRegion();
      if ($this.qrRegion) {
        $this.qrRegion = null;
      }
      if ($this.context) {
        $this.context = null;
      }
      toStoppedStateTransaction.execute();
      $this.hidePausedState();
      $this.isScanning = false;
      return Promise.resolve();
    });
  };
  Html5Qrcode2.prototype.scanFile = function(imageFile, showImage) {
    return this.scanFileV2(imageFile, showImage).then(function(html5qrcodeResult) {
      return html5qrcodeResult.decodedText;
    });
  };
  Html5Qrcode2.prototype.scanFileV2 = function(imageFile, showImage) {
    var _this2 = this;
    if (!imageFile || !(imageFile instanceof File)) {
      throw "imageFile argument is mandatory and should be instance of File. Use 'event.target.files[0]'.";
    }
    if (isNullOrUndefined(showImage)) {
      showImage = true;
    }
    if (!this.stateManagerProxy.canScanFile()) {
      throw "Cannot start file scan - ongoing camera scan";
    }
    return new Promise(function(resolve2, reject) {
      _this2.possiblyCloseLastScanImageFile();
      _this2.clearElement();
      _this2.lastScanImageFile = URL.createObjectURL(imageFile);
      var inputImage = new Image();
      inputImage.onload = function() {
        var imageWidth = inputImage.width;
        var imageHeight = inputImage.height;
        var element = document.getElementById(_this2.elementId);
        var containerWidth = element.clientWidth ? element.clientWidth : Constants.DEFAULT_WIDTH;
        var containerHeight = Math.max(element.clientHeight ? element.clientHeight : imageHeight, Constants.FILE_SCAN_MIN_HEIGHT);
        var config2 = _this2.computeCanvasDrawConfig(imageWidth, imageHeight, containerWidth, containerHeight);
        if (showImage) {
          var visibleCanvas = _this2.createCanvasElement(containerWidth, containerHeight, "qr-canvas-visible");
          visibleCanvas.style.display = "inline-block";
          element.appendChild(visibleCanvas);
          var context_1 = visibleCanvas.getContext("2d");
          if (!context_1) {
            throw "Unable to get 2d context from canvas";
          }
          context_1.canvas.width = containerWidth;
          context_1.canvas.height = containerHeight;
          context_1.drawImage(inputImage, 0, 0, imageWidth, imageHeight, config2.x, config2.y, config2.width, config2.height);
        }
        var padding = Constants.FILE_SCAN_HIDDEN_CANVAS_PADDING;
        var hiddenImageWidth = Math.max(inputImage.width, config2.width);
        var hiddenImageHeight = Math.max(inputImage.height, config2.height);
        var hiddenCanvasWidth = hiddenImageWidth + 2 * padding;
        var hiddenCanvasHeight = hiddenImageHeight + 2 * padding;
        var hiddenCanvas = _this2.createCanvasElement(hiddenCanvasWidth, hiddenCanvasHeight);
        element.appendChild(hiddenCanvas);
        var context = hiddenCanvas.getContext("2d");
        if (!context) {
          throw "Unable to get 2d context from canvas";
        }
        context.canvas.width = hiddenCanvasWidth;
        context.canvas.height = hiddenCanvasHeight;
        context.drawImage(inputImage, 0, 0, imageWidth, imageHeight, padding, padding, hiddenImageWidth, hiddenImageHeight);
        try {
          _this2.qrcode.decodeRobustlyAsync(hiddenCanvas).then(function(result2) {
            resolve2(Html5QrcodeResultFactory.createFromQrcodeResult(result2));
          }).catch(reject);
        } catch (exception) {
          reject("QR code parse error, error = ".concat(exception));
        }
      };
      inputImage.onerror = reject;
      inputImage.onabort = reject;
      inputImage.onstalled = reject;
      inputImage.onsuspend = reject;
      inputImage.src = URL.createObjectURL(imageFile);
    });
  };
  Html5Qrcode2.prototype.clear = function() {
    this.clearElement();
  };
  Html5Qrcode2.getCameras = function() {
    return CameraRetriever.retrieve();
  };
  Html5Qrcode2.prototype.getRunningTrackCapabilities = function() {
    return this.getRenderedCameraOrFail().getRunningTrackCapabilities();
  };
  Html5Qrcode2.prototype.getRunningTrackSettings = function() {
    return this.getRenderedCameraOrFail().getRunningTrackSettings();
  };
  Html5Qrcode2.prototype.getRunningTrackCameraCapabilities = function() {
    return this.getRenderedCameraOrFail().getCapabilities();
  };
  Html5Qrcode2.prototype.applyVideoConstraints = function(videoConstaints) {
    if (!videoConstaints) {
      throw "videoConstaints is required argument.";
    } else if (!VideoConstraintsUtil.isMediaStreamConstraintsValid(videoConstaints, this.logger)) {
      throw "invalid videoConstaints passed, check logs for more details";
    }
    return this.getRenderedCameraOrFail().applyVideoConstraints(videoConstaints);
  };
  Html5Qrcode2.prototype.getRenderedCameraOrFail = function() {
    if (this.renderedCamera == null) {
      throw "Scanning is not in running state, call this API only when QR code scanning using camera is in running state.";
    }
    return this.renderedCamera;
  };
  Html5Qrcode2.prototype.getSupportedFormats = function(configOrVerbosityFlag) {
    var allFormats = [
      Html5QrcodeSupportedFormats.QR_CODE,
      Html5QrcodeSupportedFormats.AZTEC,
      Html5QrcodeSupportedFormats.CODABAR,
      Html5QrcodeSupportedFormats.CODE_39,
      Html5QrcodeSupportedFormats.CODE_93,
      Html5QrcodeSupportedFormats.CODE_128,
      Html5QrcodeSupportedFormats.DATA_MATRIX,
      Html5QrcodeSupportedFormats.MAXICODE,
      Html5QrcodeSupportedFormats.ITF,
      Html5QrcodeSupportedFormats.EAN_13,
      Html5QrcodeSupportedFormats.EAN_8,
      Html5QrcodeSupportedFormats.PDF_417,
      Html5QrcodeSupportedFormats.RSS_14,
      Html5QrcodeSupportedFormats.RSS_EXPANDED,
      Html5QrcodeSupportedFormats.UPC_A,
      Html5QrcodeSupportedFormats.UPC_E,
      Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION
    ];
    if (!configOrVerbosityFlag || typeof configOrVerbosityFlag == "boolean") {
      return allFormats;
    }
    if (!configOrVerbosityFlag.formatsToSupport) {
      return allFormats;
    }
    if (!Array.isArray(configOrVerbosityFlag.formatsToSupport)) {
      throw "configOrVerbosityFlag.formatsToSupport should be undefined or an array.";
    }
    if (configOrVerbosityFlag.formatsToSupport.length === 0) {
      throw "Atleast 1 formatsToSupport is needed.";
    }
    var supportedFormats = [];
    for (var _i2 = 0, _a2 = configOrVerbosityFlag.formatsToSupport; _i2 < _a2.length; _i2++) {
      var format = _a2[_i2];
      if (isValidHtml5QrcodeSupportedFormats(format)) {
        supportedFormats.push(format);
      } else {
        this.logger.warn("Invalid format: ".concat(format, " passed in config, ignoring."));
      }
    }
    if (supportedFormats.length === 0) {
      throw "None of formatsToSupport match supported values.";
    }
    return supportedFormats;
  };
  Html5Qrcode2.prototype.getUseBarCodeDetectorIfSupported = function(config2) {
    if (isNullOrUndefined(config2)) {
      return true;
    }
    if (!isNullOrUndefined(config2.useBarCodeDetectorIfSupported)) {
      return config2.useBarCodeDetectorIfSupported !== false;
    }
    if (isNullOrUndefined(config2.experimentalFeatures)) {
      return true;
    }
    var experimentalFeatures = config2.experimentalFeatures;
    if (isNullOrUndefined(experimentalFeatures.useBarCodeDetectorIfSupported)) {
      return true;
    }
    return experimentalFeatures.useBarCodeDetectorIfSupported !== false;
  };
  Html5Qrcode2.prototype.validateQrboxSize = function(viewfinderWidth, viewfinderHeight, internalConfig) {
    var _this2 = this;
    var qrboxSize = internalConfig.qrbox;
    this.validateQrboxConfig(qrboxSize);
    var qrDimensions = this.toQrdimensions(viewfinderWidth, viewfinderHeight, qrboxSize);
    var validateMinSize = function(size) {
      if (size < Constants.MIN_QR_BOX_SIZE) {
        throw "minimum size of 'config.qrbox' dimension value is" + " ".concat(Constants.MIN_QR_BOX_SIZE, "px.");
      }
    };
    var correctWidthBasedOnRootElementSize = function(configWidth) {
      if (configWidth > viewfinderWidth) {
        _this2.logger.warn("`qrbox.width` or `qrbox` is larger than the width of the root element. The width will be truncated to the width of root element.");
        configWidth = viewfinderWidth;
      }
      return configWidth;
    };
    validateMinSize(qrDimensions.width);
    validateMinSize(qrDimensions.height);
    qrDimensions.width = correctWidthBasedOnRootElementSize(qrDimensions.width);
  };
  Html5Qrcode2.prototype.validateQrboxConfig = function(qrboxSize) {
    if (typeof qrboxSize === "number") {
      return;
    }
    if (typeof qrboxSize === "function") {
      return;
    }
    if (qrboxSize.width === void 0 || qrboxSize.height === void 0) {
      throw "Invalid instance of QrDimensions passed for 'config.qrbox'. Both 'width' and 'height' should be set.";
    }
  };
  Html5Qrcode2.prototype.toQrdimensions = function(viewfinderWidth, viewfinderHeight, qrboxSize) {
    if (typeof qrboxSize === "number") {
      return { width: qrboxSize, height: qrboxSize };
    } else if (typeof qrboxSize === "function") {
      try {
        return qrboxSize(viewfinderWidth, viewfinderHeight);
      } catch (error2) {
        throw new Error("qrbox config was passed as a function but it failed with unknown error" + error2);
      }
    }
    return qrboxSize;
  };
  Html5Qrcode2.prototype.setupUi = function(viewfinderWidth, viewfinderHeight, internalConfig) {
    if (internalConfig.isShadedBoxEnabled()) {
      this.validateQrboxSize(viewfinderWidth, viewfinderHeight, internalConfig);
    }
    var qrboxSize = isNullOrUndefined(internalConfig.qrbox) ? { width: viewfinderWidth, height: viewfinderHeight } : internalConfig.qrbox;
    this.validateQrboxConfig(qrboxSize);
    var qrDimensions = this.toQrdimensions(viewfinderWidth, viewfinderHeight, qrboxSize);
    if (qrDimensions.height > viewfinderHeight) {
      this.logger.warn("[Html5Qrcode] config.qrbox has height that isgreater than the height of the video stream. Shading will be ignored");
    }
    var shouldShadingBeApplied = internalConfig.isShadedBoxEnabled() && qrDimensions.height <= viewfinderHeight;
    var defaultQrRegion = {
      x: 0,
      y: 0,
      width: viewfinderWidth,
      height: viewfinderHeight
    };
    var qrRegion = shouldShadingBeApplied ? this.getShadedRegionBounds(viewfinderWidth, viewfinderHeight, qrDimensions) : defaultQrRegion;
    var canvasElement = this.createCanvasElement(qrRegion.width, qrRegion.height);
    var contextAttributes = { willReadFrequently: true };
    var context = canvasElement.getContext("2d", contextAttributes);
    context.canvas.width = qrRegion.width;
    context.canvas.height = qrRegion.height;
    this.element.append(canvasElement);
    if (shouldShadingBeApplied) {
      this.possiblyInsertShadingElement(this.element, viewfinderWidth, viewfinderHeight, qrDimensions);
    }
    this.createScannerPausedUiElement(this.element);
    this.qrRegion = qrRegion;
    this.context = context;
    this.canvasElement = canvasElement;
  };
  Html5Qrcode2.prototype.createScannerPausedUiElement = function(rootElement) {
    var scannerPausedUiElement = document.createElement("div");
    scannerPausedUiElement.innerText = Html5QrcodeStrings.scannerPaused();
    scannerPausedUiElement.style.display = "none";
    scannerPausedUiElement.style.position = "absolute";
    scannerPausedUiElement.style.top = "0px";
    scannerPausedUiElement.style.zIndex = "1";
    scannerPausedUiElement.style.background = "rgba(9, 9, 9, 0.46)";
    scannerPausedUiElement.style.color = "#FFECEC";
    scannerPausedUiElement.style.textAlign = "center";
    scannerPausedUiElement.style.width = "100%";
    rootElement.appendChild(scannerPausedUiElement);
    this.scannerPausedUiElement = scannerPausedUiElement;
  };
  Html5Qrcode2.prototype.scanContext = function(qrCodeSuccessCallback, qrCodeErrorCallback) {
    var _this2 = this;
    if (this.stateManagerProxy.isPaused()) {
      return Promise.resolve(false);
    }
    return this.qrcode.decodeAsync(this.canvasElement).then(function(result2) {
      qrCodeSuccessCallback(result2.text, Html5QrcodeResultFactory.createFromQrcodeResult(result2));
      _this2.possiblyUpdateShaders(true);
      return true;
    }).catch(function(error2) {
      _this2.possiblyUpdateShaders(false);
      var errorMessage = Html5QrcodeStrings.codeParseError(error2);
      qrCodeErrorCallback(errorMessage, Html5QrcodeErrorFactory.createFrom(errorMessage));
      return false;
    });
  };
  Html5Qrcode2.prototype.foreverScan = function(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallback) {
    var _this2 = this;
    if (!this.shouldScan) {
      return;
    }
    if (!this.renderedCamera) {
      return;
    }
    var videoElement = this.renderedCamera.getSurface();
    var widthRatio = videoElement.videoWidth / videoElement.clientWidth;
    var heightRatio = videoElement.videoHeight / videoElement.clientHeight;
    if (!this.qrRegion) {
      throw "qrRegion undefined when localMediaStream is ready.";
    }
    var sWidthOffset = this.qrRegion.width * widthRatio;
    var sHeightOffset = this.qrRegion.height * heightRatio;
    var sxOffset = this.qrRegion.x * widthRatio;
    var syOffset = this.qrRegion.y * heightRatio;
    this.context.drawImage(videoElement, sxOffset, syOffset, sWidthOffset, sHeightOffset, 0, 0, this.qrRegion.width, this.qrRegion.height);
    var triggerNextScan = function() {
      _this2.foreverScanTimeout = setTimeout(function() {
        _this2.foreverScan(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallback);
      }, _this2.getTimeoutFps(internalConfig.fps));
    };
    this.scanContext(qrCodeSuccessCallback, qrCodeErrorCallback).then(function(isSuccessfull) {
      if (!isSuccessfull && internalConfig.disableFlip !== true) {
        _this2.context.translate(_this2.context.canvas.width, 0);
        _this2.context.scale(-1, 1);
        _this2.scanContext(qrCodeSuccessCallback, qrCodeErrorCallback).finally(function() {
          triggerNextScan();
        });
      } else {
        triggerNextScan();
      }
    }).catch(function(error2) {
      _this2.logger.logError("Error happend while scanning context", error2);
      triggerNextScan();
    });
  };
  Html5Qrcode2.prototype.createVideoConstraints = function(cameraIdOrConfig) {
    if (typeof cameraIdOrConfig == "string") {
      return { deviceId: { exact: cameraIdOrConfig } };
    } else if (typeof cameraIdOrConfig == "object") {
      var facingModeKey = "facingMode";
      var deviceIdKey = "deviceId";
      var allowedFacingModeValues_1 = { "user": true, "environment": true };
      var exactKey = "exact";
      var isValidFacingModeValue = function(value) {
        if (value in allowedFacingModeValues_1) {
          return true;
        } else {
          throw "config has invalid 'facingMode' value = " + "'".concat(value, "'");
        }
      };
      var keys2 = Object.keys(cameraIdOrConfig);
      if (keys2.length !== 1) {
        throw "'cameraIdOrConfig' object should have exactly 1 key," + " if passed as an object, found ".concat(keys2.length, " keys");
      }
      var key = Object.keys(cameraIdOrConfig)[0];
      if (key !== facingModeKey && key !== deviceIdKey) {
        throw "Only '".concat(facingModeKey, "' and '").concat(deviceIdKey, "' ") + " are supported for 'cameraIdOrConfig'";
      }
      if (key === facingModeKey) {
        var facingMode = cameraIdOrConfig.facingMode;
        if (typeof facingMode == "string") {
          if (isValidFacingModeValue(facingMode)) {
            return { facingMode };
          }
        } else if (typeof facingMode == "object") {
          if (exactKey in facingMode) {
            if (isValidFacingModeValue(facingMode["".concat(exactKey)])) {
              return {
                facingMode: {
                  exact: facingMode["".concat(exactKey)]
                }
              };
            }
          } else {
            throw "'facingMode' should be string or object with" + " ".concat(exactKey, " as key.");
          }
        } else {
          var type_1 = typeof facingMode;
          throw "Invalid type of 'facingMode' = ".concat(type_1);
        }
      } else {
        var deviceId = cameraIdOrConfig.deviceId;
        if (typeof deviceId == "string") {
          return { deviceId };
        } else if (typeof deviceId == "object") {
          if (exactKey in deviceId) {
            return {
              deviceId: { exact: deviceId["".concat(exactKey)] }
            };
          } else {
            throw "'deviceId' should be string or object with" + " ".concat(exactKey, " as key.");
          }
        } else {
          var type_2 = typeof deviceId;
          throw "Invalid type of 'deviceId' = ".concat(type_2);
        }
      }
    }
    var type = typeof cameraIdOrConfig;
    throw "Invalid type of 'cameraIdOrConfig' = ".concat(type);
  };
  Html5Qrcode2.prototype.computeCanvasDrawConfig = function(imageWidth, imageHeight, containerWidth, containerHeight) {
    if (imageWidth <= containerWidth && imageHeight <= containerHeight) {
      var xoffset = (containerWidth - imageWidth) / 2;
      var yoffset = (containerHeight - imageHeight) / 2;
      return {
        x: xoffset,
        y: yoffset,
        width: imageWidth,
        height: imageHeight
      };
    } else {
      var formerImageWidth = imageWidth;
      var formerImageHeight = imageHeight;
      if (imageWidth > containerWidth) {
        imageHeight = containerWidth / imageWidth * imageHeight;
        imageWidth = containerWidth;
      }
      if (imageHeight > containerHeight) {
        imageWidth = containerHeight / imageHeight * imageWidth;
        imageHeight = containerHeight;
      }
      this.logger.log("Image downsampled from " + "".concat(formerImageWidth, "X").concat(formerImageHeight) + " to ".concat(imageWidth, "X").concat(imageHeight, "."));
      return this.computeCanvasDrawConfig(imageWidth, imageHeight, containerWidth, containerHeight);
    }
  };
  Html5Qrcode2.prototype.clearElement = function() {
    if (this.stateManagerProxy.isScanning()) {
      throw "Cannot clear while scan is ongoing, close it first.";
    }
    var element = document.getElementById(this.elementId);
    if (element) {
      element.innerHTML = "";
    }
  };
  Html5Qrcode2.prototype.possiblyUpdateShaders = function(qrMatch) {
    if (this.qrMatch === qrMatch) {
      return;
    }
    if (this.hasBorderShaders && this.borderShaders && this.borderShaders.length) {
      this.borderShaders.forEach(function(shader) {
        shader.style.backgroundColor = qrMatch ? Constants.BORDER_SHADER_MATCH_COLOR : Constants.BORDER_SHADER_DEFAULT_COLOR;
      });
    }
    this.qrMatch = qrMatch;
  };
  Html5Qrcode2.prototype.possiblyCloseLastScanImageFile = function() {
    if (this.lastScanImageFile) {
      URL.revokeObjectURL(this.lastScanImageFile);
      this.lastScanImageFile = null;
    }
  };
  Html5Qrcode2.prototype.createCanvasElement = function(width, height, customId) {
    var canvasWidth = width;
    var canvasHeight = height;
    var canvasElement = document.createElement("canvas");
    canvasElement.style.width = "".concat(canvasWidth, "px");
    canvasElement.style.height = "".concat(canvasHeight, "px");
    canvasElement.style.display = "none";
    canvasElement.id = isNullOrUndefined(customId) ? "qr-canvas" : customId;
    return canvasElement;
  };
  Html5Qrcode2.prototype.getShadedRegionBounds = function(width, height, qrboxSize) {
    if (qrboxSize.width > width || qrboxSize.height > height) {
      throw "'config.qrbox' dimensions should not be greater than the dimensions of the root HTML element.";
    }
    return {
      x: (width - qrboxSize.width) / 2,
      y: (height - qrboxSize.height) / 2,
      width: qrboxSize.width,
      height: qrboxSize.height
    };
  };
  Html5Qrcode2.prototype.possiblyInsertShadingElement = function(element, width, height, qrboxSize) {
    if (width - qrboxSize.width < 1 || height - qrboxSize.height < 1) {
      return;
    }
    var shadingElement = document.createElement("div");
    shadingElement.style.position = "absolute";
    var rightLeftBorderSize = (width - qrboxSize.width) / 2;
    var topBottomBorderSize = (height - qrboxSize.height) / 2;
    shadingElement.style.borderLeft = "".concat(rightLeftBorderSize, "px solid rgba(0, 0, 0, 0.48)");
    shadingElement.style.borderRight = "".concat(rightLeftBorderSize, "px solid rgba(0, 0, 0, 0.48)");
    shadingElement.style.borderTop = "".concat(topBottomBorderSize, "px solid rgba(0, 0, 0, 0.48)");
    shadingElement.style.borderBottom = "".concat(topBottomBorderSize, "px solid rgba(0, 0, 0, 0.48)");
    shadingElement.style.boxSizing = "border-box";
    shadingElement.style.top = "0px";
    shadingElement.style.bottom = "0px";
    shadingElement.style.left = "0px";
    shadingElement.style.right = "0px";
    shadingElement.id = "".concat(Constants.SHADED_REGION_ELEMENT_ID);
    if (width - qrboxSize.width < 11 || height - qrboxSize.height < 11) {
      this.hasBorderShaders = false;
    } else {
      var smallSize = 5;
      var largeSize = 40;
      this.insertShaderBorders(shadingElement, largeSize, smallSize, -smallSize, null, 0, true);
      this.insertShaderBorders(shadingElement, largeSize, smallSize, -smallSize, null, 0, false);
      this.insertShaderBorders(shadingElement, largeSize, smallSize, null, -smallSize, 0, true);
      this.insertShaderBorders(shadingElement, largeSize, smallSize, null, -smallSize, 0, false);
      this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, -smallSize, null, -smallSize, true);
      this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, null, -smallSize, -smallSize, true);
      this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, -smallSize, null, -smallSize, false);
      this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, null, -smallSize, -smallSize, false);
      this.hasBorderShaders = true;
    }
    element.append(shadingElement);
  };
  Html5Qrcode2.prototype.insertShaderBorders = function(shaderElem, width, height, top, bottom, side, isLeft) {
    var elem = document.createElement("div");
    elem.style.position = "absolute";
    elem.style.backgroundColor = Constants.BORDER_SHADER_DEFAULT_COLOR;
    elem.style.width = "".concat(width, "px");
    elem.style.height = "".concat(height, "px");
    if (top !== null) {
      elem.style.top = "".concat(top, "px");
    }
    if (bottom !== null) {
      elem.style.bottom = "".concat(bottom, "px");
    }
    if (isLeft) {
      elem.style.left = "".concat(side, "px");
    } else {
      elem.style.right = "".concat(side, "px");
    }
    if (!this.borderShaders) {
      this.borderShaders = [];
    }
    this.borderShaders.push(elem);
    shaderElem.appendChild(elem);
  };
  Html5Qrcode2.prototype.showPausedState = function() {
    if (!this.scannerPausedUiElement) {
      throw "[internal error] scanner paused UI element not found";
    }
    this.scannerPausedUiElement.style.display = "block";
  };
  Html5Qrcode2.prototype.hidePausedState = function() {
    if (!this.scannerPausedUiElement) {
      throw "[internal error] scanner paused UI element not found";
    }
    this.scannerPausedUiElement.style.display = "none";
  };
  Html5Qrcode2.prototype.getTimeoutFps = function(fps) {
    return 1e3 / fps;
  };
  return Html5Qrcode2;
}();
var SVG_XML_PREFIX = "data:image/svg+xml;base64,";
var ASSET_CAMERA_SCAN = SVG_XML_PREFIX + "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";
var ASSET_FILE_SCAN = SVG_XML_PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1OS4wMTggNTkuMDE4IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1OS4wMTggNTkuMDE4IiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJtNTguNzQxIDU0LjgwOS01Ljk2OS02LjI0NGExMC43NCAxMC43NCAwIDAgMCAyLjgyLTcuMjVjMC01Ljk1My00Ljg0My0xMC43OTYtMTAuNzk2LTEwLjc5NlMzNCAzNS4zNjEgMzQgNDEuMzE0IDM4Ljg0MyA1Mi4xMSA0NC43OTYgNTIuMTFjMi40NDEgMCA0LjY4OC0uODI0IDYuNDk5LTIuMTk2bDYuMDAxIDYuMjc3YS45OTguOTk4IDAgMCAwIDEuNDE0LjAzMiAxIDEgMCAwIDAgLjAzMS0xLjQxNHpNMzYgNDEuMzE0YzAtNC44NSAzLjk0Ni04Ljc5NiA4Ljc5Ni04Ljc5NnM4Ljc5NiAzLjk0NiA4Ljc5NiA4Ljc5Ni0zLjk0NiA4Ljc5Ni04Ljc5NiA4Ljc5NlMzNiA0Ni4xNjQgMzYgNDEuMzE0ek0xMC40MzEgMTYuMDg4YzAgMy4wNyAyLjQ5OCA1LjU2OCA1LjU2OSA1LjU2OHM1LjU2OS0yLjQ5OCA1LjU2OS01LjU2OGMwLTMuMDcxLTIuNDk4LTUuNTY5LTUuNTY5LTUuNTY5cy01LjU2OSAyLjQ5OC01LjU2OSA1LjU2OXptOS4xMzggMGMwIDEuOTY4LTEuNjAyIDMuNTY4LTMuNTY5IDMuNTY4cy0zLjU2OS0xLjYwMS0zLjU2OS0zLjU2OCAxLjYwMi0zLjU2OSAzLjU2OS0zLjU2OSAzLjU2OSAxLjYwMSAzLjU2OSAzLjU2OXoiLz48cGF0aCBkPSJtMzAuODgyIDI4Ljk4NyA5LjE4LTEwLjA1NCAxMS4yNjIgMTAuMzIzYTEgMSAwIDAgMCAxLjM1MS0xLjQ3NWwtMTItMTFhMSAxIDAgMCAwLTEuNDE0LjA2M2wtOS43OTQgMTAuNzI3LTQuNzQzLTQuNzQzYTEuMDAzIDEuMDAzIDAgMCAwLTEuMzY4LS4wNDRMNi4zMzkgMzcuNzY4YTEgMSAwIDEgMCAxLjMyMiAxLjUwMWwxNi4zMTMtMTQuMzYyIDcuMzE5IDcuMzE4YS45OTkuOTk5IDAgMSAwIDEuNDE0LTEuNDE0bC0xLjgyNS0xLjgyNHoiLz48cGF0aCBkPSJNMzAgNDYuNTE4SDJ2LTQyaDU0djI4YTEgMSAwIDEgMCAyIDB2LTI5YTEgMSAwIDAgMC0xLTFIMWExIDEgMCAwIDAtMSAxdjQ0YTEgMSAwIDAgMCAxIDFoMjlhMSAxIDAgMSAwIDAtMnoiLz48L3N2Zz4=";
var ASSET_INFO_ICON_16PX = SVG_XML_PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NjAgNDYwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NjAgNDYwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNMjMwIDBDMTAyLjk3NSAwIDAgMTAyLjk3NSAwIDIzMHMxMDIuOTc1IDIzMCAyMzAgMjMwIDIzMC0xMDIuOTc0IDIzMC0yMzBTMzU3LjAyNSAwIDIzMCAwem0zOC4zMzMgMzc3LjM2YzAgOC42NzYtNy4wMzQgMTUuNzEtMTUuNzEgMTUuNzFoLTQzLjEwMWMtOC42NzYgMC0xNS43MS03LjAzNC0xNS43MS0xNS43MVYyMDIuNDc3YzAtOC42NzYgNy4wMzMtMTUuNzEgMTUuNzEtMTUuNzFoNDMuMTAxYzguNjc2IDAgMTUuNzEgNy4wMzMgMTUuNzEgMTUuNzFWMzc3LjM2ek0yMzAgMTU3Yy0yMS41MzkgMC0zOS0xNy40NjEtMzktMzlzMTcuNDYxLTM5IDM5LTM5IDM5IDE3LjQ2MSAzOSAzOS0xNy40NjEgMzktMzkgMzl6Ii8+PC9zdmc+";
var ASSET_CLOSE_ICON_16PX = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAQgAAAEIBarqQRAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAE1SURBVDiNfdI7S0NBEAXgLya1otFgpbYSbISAgpXYi6CmiH9KCAiChaVga6OiWPgfRDQ+0itaGVNosXtluWwcuMzePfM4M3sq8lbHBubwg1dc4m1E/J/N4ghDPOIsfk/4xiEao5KX0McFljN4C9d4QTPXuY99jP3DsIoDPGM6BY5i5yI5R7O4q+ImFkJY2DCh3cAH2klyB+9J1xUMMAG7eCh1a+Mr+k48b5diXrFVwwLuS+BJ9MfR7+G0FHOHhTHhnXNWS87VDF4pcnfQK4Ep7XScNLmPTZgURNKKYENYWDpzW1BhscS1WHS8CDgURFJQrWcoF3c13KKbgg1BYQfy8xZWEzTTw1QZbAoKu8FqJnktdu5hcVSHmchiILzzuaDQvjBzV2m8yohCE1jHfPx/xhU+y4G/D75ELlRJsSYAAAAASUVORK5CYII=";
var PersistedDataFactory = function() {
  function PersistedDataFactory2() {
  }
  PersistedDataFactory2.createDefault = function() {
    return {
      hasPermission: false,
      lastUsedCameraId: null
    };
  };
  return PersistedDataFactory2;
}();
var PersistedDataManager = function() {
  function PersistedDataManager2() {
    this.data = PersistedDataFactory.createDefault();
    var data = localStorage.getItem(PersistedDataManager2.LOCAL_STORAGE_KEY);
    if (!data) {
      this.reset();
    } else {
      this.data = JSON.parse(data);
    }
  }
  PersistedDataManager2.prototype.hasCameraPermissions = function() {
    return this.data.hasPermission;
  };
  PersistedDataManager2.prototype.getLastUsedCameraId = function() {
    return this.data.lastUsedCameraId;
  };
  PersistedDataManager2.prototype.setHasPermission = function(hasPermission) {
    this.data.hasPermission = hasPermission;
    this.flush();
  };
  PersistedDataManager2.prototype.setLastUsedCameraId = function(lastUsedCameraId) {
    this.data.lastUsedCameraId = lastUsedCameraId;
    this.flush();
  };
  PersistedDataManager2.prototype.resetLastUsedCameraId = function() {
    this.data.lastUsedCameraId = null;
    this.flush();
  };
  PersistedDataManager2.prototype.reset = function() {
    this.data = PersistedDataFactory.createDefault();
    this.flush();
  };
  PersistedDataManager2.prototype.flush = function() {
    localStorage.setItem(PersistedDataManager2.LOCAL_STORAGE_KEY, JSON.stringify(this.data));
  };
  PersistedDataManager2.LOCAL_STORAGE_KEY = "HTML5_QRCODE_DATA";
  return PersistedDataManager2;
}();
var LibraryInfoDiv = function() {
  function LibraryInfoDiv2() {
    this.infoDiv = document.createElement("div");
  }
  LibraryInfoDiv2.prototype.renderInto = function(parent2) {
    this.infoDiv.style.position = "absolute";
    this.infoDiv.style.top = "10px";
    this.infoDiv.style.right = "10px";
    this.infoDiv.style.zIndex = "2";
    this.infoDiv.style.display = "none";
    this.infoDiv.style.padding = "5pt";
    this.infoDiv.style.border = "1px solid #171717";
    this.infoDiv.style.fontSize = "10pt";
    this.infoDiv.style.background = "rgb(0 0 0 / 69%)";
    this.infoDiv.style.borderRadius = "5px";
    this.infoDiv.style.textAlign = "center";
    this.infoDiv.style.fontWeight = "400";
    this.infoDiv.style.color = "white";
    this.infoDiv.innerText = LibraryInfoStrings.poweredBy();
    var projectLink = document.createElement("a");
    projectLink.innerText = "ScanApp";
    projectLink.href = "https://scanapp.org";
    projectLink.target = "new";
    projectLink.style.color = "white";
    this.infoDiv.appendChild(projectLink);
    var breakElemFirst = document.createElement("br");
    var breakElemSecond = document.createElement("br");
    this.infoDiv.appendChild(breakElemFirst);
    this.infoDiv.appendChild(breakElemSecond);
    var reportIssueLink = document.createElement("a");
    reportIssueLink.innerText = LibraryInfoStrings.reportIssues();
    reportIssueLink.href = "https://github.com/mebjas/html5-qrcode/issues";
    reportIssueLink.target = "new";
    reportIssueLink.style.color = "white";
    this.infoDiv.appendChild(reportIssueLink);
    parent2.appendChild(this.infoDiv);
  };
  LibraryInfoDiv2.prototype.show = function() {
    this.infoDiv.style.display = "block";
  };
  LibraryInfoDiv2.prototype.hide = function() {
    this.infoDiv.style.display = "none";
  };
  return LibraryInfoDiv2;
}();
var LibraryInfoIcon = function() {
  function LibraryInfoIcon2(onTapIn, onTapOut) {
    this.isShowingInfoIcon = true;
    this.onTapIn = onTapIn;
    this.onTapOut = onTapOut;
    this.infoIcon = document.createElement("img");
  }
  LibraryInfoIcon2.prototype.renderInto = function(parent2) {
    var _this2 = this;
    this.infoIcon.alt = "Info icon";
    this.infoIcon.src = ASSET_INFO_ICON_16PX;
    this.infoIcon.style.position = "absolute";
    this.infoIcon.style.top = "4px";
    this.infoIcon.style.right = "4px";
    this.infoIcon.style.opacity = "0.6";
    this.infoIcon.style.cursor = "pointer";
    this.infoIcon.style.zIndex = "2";
    this.infoIcon.style.width = "16px";
    this.infoIcon.style.height = "16px";
    this.infoIcon.onmouseover = function(_) {
      return _this2.onHoverIn();
    };
    this.infoIcon.onmouseout = function(_) {
      return _this2.onHoverOut();
    };
    this.infoIcon.onclick = function(_) {
      return _this2.onClick();
    };
    parent2.appendChild(this.infoIcon);
  };
  LibraryInfoIcon2.prototype.onHoverIn = function() {
    if (this.isShowingInfoIcon) {
      this.infoIcon.style.opacity = "1";
    }
  };
  LibraryInfoIcon2.prototype.onHoverOut = function() {
    if (this.isShowingInfoIcon) {
      this.infoIcon.style.opacity = "0.6";
    }
  };
  LibraryInfoIcon2.prototype.onClick = function() {
    if (this.isShowingInfoIcon) {
      this.isShowingInfoIcon = false;
      this.onTapIn();
      this.infoIcon.src = ASSET_CLOSE_ICON_16PX;
      this.infoIcon.style.opacity = "1";
    } else {
      this.isShowingInfoIcon = true;
      this.onTapOut();
      this.infoIcon.src = ASSET_INFO_ICON_16PX;
      this.infoIcon.style.opacity = "0.6";
    }
  };
  return LibraryInfoIcon2;
}();
var LibraryInfoContainer = function() {
  function LibraryInfoContainer2() {
    var _this2 = this;
    this.infoDiv = new LibraryInfoDiv();
    this.infoIcon = new LibraryInfoIcon(function() {
      _this2.infoDiv.show();
    }, function() {
      _this2.infoDiv.hide();
    });
  }
  LibraryInfoContainer2.prototype.renderInto = function(parent2) {
    this.infoDiv.renderInto(parent2);
    this.infoIcon.renderInto(parent2);
  };
  return LibraryInfoContainer2;
}();
var __awaiter$1 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result2) {
      result2.done ? resolve2(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$1 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t3[0] & 1)
      throw t3[1];
    return t3[1];
  }, trys: [], ops: [] }, f, y, t3, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v) {
      return step([n2, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t3 = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t3 = y["return"]) && t3.call(y), 0) : y.next) && !(t3 = t3.call(y, op[1])).done)
          return t3;
        if (y = 0, t3)
          op = [op[0] & 2, t3.value];
        switch (op[0]) {
          case 0:
          case 1:
            t3 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t3 = _.trys, t3 = t3.length > 0 && t3[t3.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t3 || op[1] > t3[0] && op[1] < t3[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t3[1]) {
              _.label = t3[1];
              t3 = op;
              break;
            }
            if (t3 && _.label < t3[2]) {
              _.label = t3[2];
              _.ops.push(op);
              break;
            }
            if (t3[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t3 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var CameraPermissions = function() {
  function CameraPermissions2() {
  }
  CameraPermissions2.hasPermissions = function() {
    return __awaiter$1(this, void 0, void 0, function() {
      var devices, _i2, devices_1, device;
      return __generator$1(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, navigator.mediaDevices.enumerateDevices()];
          case 1:
            devices = _a2.sent();
            for (_i2 = 0, devices_1 = devices; _i2 < devices_1.length; _i2++) {
              device = devices_1[_i2];
              if (device.kind === "videoinput" && device.label) {
                return [2, true];
              }
            }
            return [2, false];
        }
      });
    });
  };
  return CameraPermissions2;
}();
var ScanTypeSelector = function() {
  function ScanTypeSelector2(supportedScanTypes) {
    this.supportedScanTypes = this.validateAndReturnScanTypes(supportedScanTypes);
  }
  ScanTypeSelector2.prototype.getDefaultScanType = function() {
    return this.supportedScanTypes[0];
  };
  ScanTypeSelector2.prototype.hasMoreThanOneScanType = function() {
    return this.supportedScanTypes.length > 1;
  };
  ScanTypeSelector2.prototype.isCameraScanRequired = function() {
    for (var _i2 = 0, _a2 = this.supportedScanTypes; _i2 < _a2.length; _i2++) {
      var scanType = _a2[_i2];
      if (ScanTypeSelector2.isCameraScanType(scanType)) {
        return true;
      }
    }
    return false;
  };
  ScanTypeSelector2.isCameraScanType = function(scanType) {
    return scanType === Html5QrcodeScanType.SCAN_TYPE_CAMERA;
  };
  ScanTypeSelector2.isFileScanType = function(scanType) {
    return scanType === Html5QrcodeScanType.SCAN_TYPE_FILE;
  };
  ScanTypeSelector2.prototype.validateAndReturnScanTypes = function(supportedScanTypes) {
    if (!supportedScanTypes || supportedScanTypes.length === 0) {
      return Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE;
    }
    var maxExpectedValues = Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE.length;
    if (supportedScanTypes.length > maxExpectedValues) {
      throw "Max ".concat(maxExpectedValues, " values expected for ") + "supportedScanTypes";
    }
    for (var _i2 = 0, supportedScanTypes_1 = supportedScanTypes; _i2 < supportedScanTypes_1.length; _i2++) {
      var scanType = supportedScanTypes_1[_i2];
      if (!Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE.includes(scanType)) {
        throw "Unsupported scan type ".concat(scanType);
      }
    }
    return supportedScanTypes;
  };
  return ScanTypeSelector2;
}();
var PublicUiElementIdAndClasses = function() {
  function PublicUiElementIdAndClasses2() {
  }
  PublicUiElementIdAndClasses2.ALL_ELEMENT_CLASS = "html5-qrcode-element";
  PublicUiElementIdAndClasses2.CAMERA_PERMISSION_BUTTON_ID = "html5-qrcode-button-camera-permission";
  PublicUiElementIdAndClasses2.CAMERA_START_BUTTON_ID = "html5-qrcode-button-camera-start";
  PublicUiElementIdAndClasses2.CAMERA_STOP_BUTTON_ID = "html5-qrcode-button-camera-stop";
  PublicUiElementIdAndClasses2.TORCH_BUTTON_ID = "html5-qrcode-button-torch";
  PublicUiElementIdAndClasses2.CAMERA_SELECTION_SELECT_ID = "html5-qrcode-select-camera";
  PublicUiElementIdAndClasses2.FILE_SELECTION_BUTTON_ID = "html5-qrcode-button-file-selection";
  PublicUiElementIdAndClasses2.ZOOM_SLIDER_ID = "html5-qrcode-input-range-zoom";
  PublicUiElementIdAndClasses2.SCAN_TYPE_CHANGE_ANCHOR_ID = "html5-qrcode-anchor-scan-type-change";
  PublicUiElementIdAndClasses2.TORCH_BUTTON_CLASS_TORCH_ON = "html5-qrcode-button-torch-on";
  PublicUiElementIdAndClasses2.TORCH_BUTTON_CLASS_TORCH_OFF = "html5-qrcode-button-torch-off";
  return PublicUiElementIdAndClasses2;
}();
var BaseUiElementFactory = function() {
  function BaseUiElementFactory2() {
  }
  BaseUiElementFactory2.createElement = function(elementType, elementId) {
    var element = document.createElement(elementType);
    element.id = elementId;
    element.classList.add(PublicUiElementIdAndClasses.ALL_ELEMENT_CLASS);
    if (elementType === "button") {
      element.setAttribute("type", "button");
    }
    return element;
  };
  return BaseUiElementFactory2;
}();
var __awaiter = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result2) {
      result2.done ? resolve2(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t3[0] & 1)
      throw t3[1];
    return t3[1];
  }, trys: [], ops: [] }, f, y, t3, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v) {
      return step([n2, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _)
      try {
        if (f = 1, y && (t3 = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t3 = y["return"]) && t3.call(y), 0) : y.next) && !(t3 = t3.call(y, op[1])).done)
          return t3;
        if (y = 0, t3)
          op = [op[0] & 2, t3.value];
        switch (op[0]) {
          case 0:
          case 1:
            t3 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t3 = _.trys, t3 = t3.length > 0 && t3[t3.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t3 || op[1] > t3[0] && op[1] < t3[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t3[1]) {
              _.label = t3[1];
              t3 = op;
              break;
            }
            if (t3 && _.label < t3[2]) {
              _.label = t3[2];
              _.ops.push(op);
              break;
            }
            if (t3[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t3 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var TorchController = function() {
  function TorchController2(torchCapability, buttonController, onTorchActionFailureCallback) {
    this.isTorchOn = false;
    this.torchCapability = torchCapability;
    this.buttonController = buttonController;
    this.onTorchActionFailureCallback = onTorchActionFailureCallback;
  }
  TorchController2.prototype.isTorchEnabled = function() {
    return this.isTorchOn;
  };
  TorchController2.prototype.flipState = function() {
    return __awaiter(this, void 0, void 0, function() {
      var isTorchOnExpected, error_1;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            this.buttonController.disable();
            isTorchOnExpected = !this.isTorchOn;
            _a2.label = 1;
          case 1:
            _a2.trys.push([1, 3, , 4]);
            return [4, this.torchCapability.apply(isTorchOnExpected)];
          case 2:
            _a2.sent();
            this.updateUiBasedOnLatestSettings(this.torchCapability.value(), isTorchOnExpected);
            return [3, 4];
          case 3:
            error_1 = _a2.sent();
            this.propagateFailure(isTorchOnExpected, error_1);
            this.buttonController.enable();
            return [3, 4];
          case 4:
            return [2];
        }
      });
    });
  };
  TorchController2.prototype.updateUiBasedOnLatestSettings = function(isTorchOn, isTorchOnExpected) {
    if (isTorchOn === isTorchOnExpected) {
      this.buttonController.setText(isTorchOnExpected ? Html5QrcodeScannerStrings.torchOffButton() : Html5QrcodeScannerStrings.torchOnButton());
      this.isTorchOn = isTorchOnExpected;
    } else {
      this.propagateFailure(isTorchOnExpected);
    }
    this.buttonController.enable();
  };
  TorchController2.prototype.propagateFailure = function(isTorchOnExpected, error2) {
    var errorMessage = isTorchOnExpected ? Html5QrcodeScannerStrings.torchOnFailedMessage() : Html5QrcodeScannerStrings.torchOffFailedMessage();
    if (error2) {
      errorMessage += "; Error = " + error2;
    }
    this.onTorchActionFailureCallback(errorMessage);
  };
  TorchController2.prototype.reset = function() {
    this.isTorchOn = false;
  };
  return TorchController2;
}();
var TorchButton = function() {
  function TorchButton2(torchCapability, onTorchActionFailureCallback) {
    this.onTorchActionFailureCallback = onTorchActionFailureCallback;
    this.torchButton = BaseUiElementFactory.createElement("button", PublicUiElementIdAndClasses.TORCH_BUTTON_ID);
    this.torchController = new TorchController(torchCapability, this, onTorchActionFailureCallback);
  }
  TorchButton2.prototype.render = function(parentElement, torchButtonOptions) {
    var _this2 = this;
    this.torchButton.innerText = Html5QrcodeScannerStrings.torchOnButton();
    this.torchButton.style.display = torchButtonOptions.display;
    this.torchButton.style.marginLeft = torchButtonOptions.marginLeft;
    var $this = this;
    this.torchButton.addEventListener("click", function(_) {
      return __awaiter(_this2, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              return [4, $this.torchController.flipState()];
            case 1:
              _a2.sent();
              if ($this.torchController.isTorchEnabled()) {
                $this.torchButton.classList.remove(PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_OFF);
                $this.torchButton.classList.add(PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_ON);
              } else {
                $this.torchButton.classList.remove(PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_ON);
                $this.torchButton.classList.add(PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_OFF);
              }
              return [2];
          }
        });
      });
    });
    parentElement.appendChild(this.torchButton);
  };
  TorchButton2.prototype.updateTorchCapability = function(torchCapability) {
    this.torchController = new TorchController(torchCapability, this, this.onTorchActionFailureCallback);
  };
  TorchButton2.prototype.getTorchButton = function() {
    return this.torchButton;
  };
  TorchButton2.prototype.hide = function() {
    this.torchButton.style.display = "none";
  };
  TorchButton2.prototype.show = function() {
    this.torchButton.style.display = "inline-block";
  };
  TorchButton2.prototype.disable = function() {
    this.torchButton.disabled = true;
  };
  TorchButton2.prototype.enable = function() {
    this.torchButton.disabled = false;
  };
  TorchButton2.prototype.setText = function(text2) {
    this.torchButton.innerText = text2;
  };
  TorchButton2.prototype.reset = function() {
    this.torchButton.innerText = Html5QrcodeScannerStrings.torchOnButton();
    this.torchController.reset();
  };
  TorchButton2.create = function(parentElement, torchCapability, torchButtonOptions, onTorchActionFailureCallback) {
    var button = new TorchButton2(torchCapability, onTorchActionFailureCallback);
    button.render(parentElement, torchButtonOptions);
    return button;
  };
  return TorchButton2;
}();
var FileSelectionUi = function() {
  function FileSelectionUi2(parentElement, showOnRender, onFileSelected) {
    this.fileBasedScanRegion = this.createFileBasedScanRegion();
    this.fileBasedScanRegion.style.display = showOnRender ? "block" : "none";
    parentElement.appendChild(this.fileBasedScanRegion);
    var fileScanLabel = document.createElement("label");
    fileScanLabel.setAttribute("for", this.getFileScanInputId());
    fileScanLabel.style.display = "inline-block";
    this.fileBasedScanRegion.appendChild(fileScanLabel);
    this.fileSelectionButton = BaseUiElementFactory.createElement("button", PublicUiElementIdAndClasses.FILE_SELECTION_BUTTON_ID);
    this.setInitialValueToButton();
    this.fileSelectionButton.addEventListener("click", function(_) {
      fileScanLabel.click();
    });
    fileScanLabel.append(this.fileSelectionButton);
    this.fileScanInput = BaseUiElementFactory.createElement("input", this.getFileScanInputId());
    this.fileScanInput.type = "file";
    this.fileScanInput.accept = "image/*";
    this.fileScanInput.style.display = "none";
    fileScanLabel.appendChild(this.fileScanInput);
    var $this = this;
    this.fileScanInput.addEventListener("change", function(e) {
      if (e == null || e.target == null) {
        return;
      }
      var target2 = e.target;
      if (target2.files && target2.files.length === 0) {
        return;
      }
      var fileList = target2.files;
      var file = fileList[0];
      var fileName = file.name;
      $this.setImageNameToButton(fileName);
      onFileSelected(file);
    });
    var dragAndDropMessage = this.createDragAndDropMessage();
    this.fileBasedScanRegion.appendChild(dragAndDropMessage);
    this.fileBasedScanRegion.addEventListener("dragenter", function(event) {
      $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionActiveBorder();
      event.stopPropagation();
      event.preventDefault();
    });
    this.fileBasedScanRegion.addEventListener("dragleave", function(event) {
      $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionDefaultBorder();
      event.stopPropagation();
      event.preventDefault();
    });
    this.fileBasedScanRegion.addEventListener("dragover", function(event) {
      $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionActiveBorder();
      event.stopPropagation();
      event.preventDefault();
    });
    this.fileBasedScanRegion.addEventListener("drop", function(event) {
      event.stopPropagation();
      event.preventDefault();
      $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionDefaultBorder();
      var dataTransfer = event.dataTransfer;
      if (dataTransfer) {
        var files = dataTransfer.files;
        if (!files || files.length === 0) {
          return;
        }
        var isAnyFileImage = false;
        for (var i2 = 0; i2 < files.length; ++i2) {
          var file = files.item(i2);
          if (!file) {
            continue;
          }
          var imageType = /image.*/;
          if (!file.type.match(imageType)) {
            continue;
          }
          isAnyFileImage = true;
          var fileName = file.name;
          $this.setImageNameToButton(fileName);
          onFileSelected(file);
          dragAndDropMessage.innerText = Html5QrcodeScannerStrings.dragAndDropMessage();
          break;
        }
        if (!isAnyFileImage) {
          dragAndDropMessage.innerText = Html5QrcodeScannerStrings.dragAndDropMessageOnlyImages();
        }
      }
    });
  }
  FileSelectionUi2.prototype.hide = function() {
    this.fileBasedScanRegion.style.display = "none";
    this.fileScanInput.disabled = true;
  };
  FileSelectionUi2.prototype.show = function() {
    this.fileBasedScanRegion.style.display = "block";
    this.fileScanInput.disabled = false;
  };
  FileSelectionUi2.prototype.isShowing = function() {
    return this.fileBasedScanRegion.style.display === "block";
  };
  FileSelectionUi2.prototype.resetValue = function() {
    this.fileScanInput.value = "";
    this.setInitialValueToButton();
  };
  FileSelectionUi2.prototype.createFileBasedScanRegion = function() {
    var fileBasedScanRegion = document.createElement("div");
    fileBasedScanRegion.style.textAlign = "center";
    fileBasedScanRegion.style.margin = "auto";
    fileBasedScanRegion.style.width = "80%";
    fileBasedScanRegion.style.maxWidth = "600px";
    fileBasedScanRegion.style.border = this.fileBasedScanRegionDefaultBorder();
    fileBasedScanRegion.style.padding = "10px";
    fileBasedScanRegion.style.marginBottom = "10px";
    return fileBasedScanRegion;
  };
  FileSelectionUi2.prototype.fileBasedScanRegionDefaultBorder = function() {
    return "6px dashed #ebebeb";
  };
  FileSelectionUi2.prototype.fileBasedScanRegionActiveBorder = function() {
    return "6px dashed rgb(153 151 151)";
  };
  FileSelectionUi2.prototype.createDragAndDropMessage = function() {
    var dragAndDropMessage = document.createElement("div");
    dragAndDropMessage.innerText = Html5QrcodeScannerStrings.dragAndDropMessage();
    dragAndDropMessage.style.fontWeight = "400";
    return dragAndDropMessage;
  };
  FileSelectionUi2.prototype.setImageNameToButton = function(imageFileName) {
    var MAX_CHARS = 20;
    if (imageFileName.length > MAX_CHARS) {
      var start8Chars = imageFileName.substring(0, 8);
      var length_1 = imageFileName.length;
      var last8Chars = imageFileName.substring(length_1 - 8, length_1);
      imageFileName = "".concat(start8Chars, "....").concat(last8Chars);
    }
    var newText = Html5QrcodeScannerStrings.fileSelectionChooseAnother() + " - " + imageFileName;
    this.fileSelectionButton.innerText = newText;
  };
  FileSelectionUi2.prototype.setInitialValueToButton = function() {
    var initialText = Html5QrcodeScannerStrings.fileSelectionChooseImage() + " - " + Html5QrcodeScannerStrings.fileSelectionNoImageSelected();
    this.fileSelectionButton.innerText = initialText;
  };
  FileSelectionUi2.prototype.getFileScanInputId = function() {
    return "html5-qrcode-private-filescan-input";
  };
  FileSelectionUi2.create = function(parentElement, showOnRender, onFileSelected) {
    var button = new FileSelectionUi2(parentElement, showOnRender, onFileSelected);
    return button;
  };
  return FileSelectionUi2;
}();
var CameraSelectionUi = function() {
  function CameraSelectionUi2(cameras) {
    this.selectElement = BaseUiElementFactory.createElement("select", PublicUiElementIdAndClasses.CAMERA_SELECTION_SELECT_ID);
    this.cameras = cameras;
    this.options = [];
  }
  CameraSelectionUi2.prototype.render = function(parentElement) {
    var cameraSelectionContainer = document.createElement("span");
    cameraSelectionContainer.style.marginRight = "10px";
    var numCameras = this.cameras.length;
    if (numCameras === 0) {
      throw new Error("No cameras found");
    }
    if (numCameras === 1) {
      cameraSelectionContainer.style.display = "none";
    } else {
      var selectCameraString = Html5QrcodeScannerStrings.selectCamera();
      cameraSelectionContainer.innerText = "".concat(selectCameraString, " (").concat(this.cameras.length, ")  ");
    }
    var anonymousCameraId = 1;
    for (var _i2 = 0, _a2 = this.cameras; _i2 < _a2.length; _i2++) {
      var camera2 = _a2[_i2];
      var value = camera2.id;
      var name_1 = camera2.label == null ? value : camera2.label;
      if (!name_1 || name_1 === "") {
        name_1 = [
          Html5QrcodeScannerStrings.anonymousCameraPrefix(),
          anonymousCameraId++
        ].join(" ");
      }
      var option2 = document.createElement("option");
      option2.value = value;
      option2.innerText = name_1;
      this.options.push(option2);
      this.selectElement.appendChild(option2);
    }
    cameraSelectionContainer.appendChild(this.selectElement);
    parentElement.appendChild(cameraSelectionContainer);
  };
  CameraSelectionUi2.prototype.disable = function() {
    this.selectElement.disabled = true;
  };
  CameraSelectionUi2.prototype.isDisabled = function() {
    return this.selectElement.disabled === true;
  };
  CameraSelectionUi2.prototype.enable = function() {
    this.selectElement.disabled = false;
  };
  CameraSelectionUi2.prototype.getValue = function() {
    return this.selectElement.value;
  };
  CameraSelectionUi2.prototype.hasValue = function(value) {
    for (var _i2 = 0, _a2 = this.options; _i2 < _a2.length; _i2++) {
      var option2 = _a2[_i2];
      if (option2.value === value) {
        return true;
      }
    }
    return false;
  };
  CameraSelectionUi2.prototype.setValue = function(value) {
    if (!this.hasValue(value)) {
      throw new Error("".concat(value, " is not present in the camera list."));
    }
    this.selectElement.value = value;
  };
  CameraSelectionUi2.prototype.hasSingleItem = function() {
    return this.cameras.length === 1;
  };
  CameraSelectionUi2.prototype.numCameras = function() {
    return this.cameras.length;
  };
  CameraSelectionUi2.create = function(parentElement, cameras) {
    var cameraSelectUi = new CameraSelectionUi2(cameras);
    cameraSelectUi.render(parentElement);
    return cameraSelectUi;
  };
  return CameraSelectionUi2;
}();
var CameraZoomUi = function() {
  function CameraZoomUi2() {
    this.onChangeCallback = null;
    this.zoomElementContainer = document.createElement("div");
    this.rangeInput = BaseUiElementFactory.createElement("input", PublicUiElementIdAndClasses.ZOOM_SLIDER_ID);
    this.rangeInput.type = "range";
    this.rangeText = document.createElement("span");
    this.rangeInput.min = "1";
    this.rangeInput.max = "5";
    this.rangeInput.value = "1";
    this.rangeInput.step = "0.1";
  }
  CameraZoomUi2.prototype.render = function(parentElement, renderOnCreate) {
    this.zoomElementContainer.style.display = renderOnCreate ? "block" : "none";
    this.zoomElementContainer.style.padding = "5px 10px";
    this.zoomElementContainer.style.textAlign = "center";
    parentElement.appendChild(this.zoomElementContainer);
    this.rangeInput.style.display = "inline-block";
    this.rangeInput.style.width = "50%";
    this.rangeInput.style.height = "5px";
    this.rangeInput.style.background = "#d3d3d3";
    this.rangeInput.style.outline = "none";
    this.rangeInput.style.opacity = "0.7";
    var zoomString = Html5QrcodeScannerStrings.zoom();
    this.rangeText.innerText = "".concat(this.rangeInput.value, "x ").concat(zoomString);
    this.rangeText.style.marginRight = "10px";
    var $this = this;
    this.rangeInput.addEventListener("input", function() {
      return $this.onValueChange();
    });
    this.rangeInput.addEventListener("change", function() {
      return $this.onValueChange();
    });
    this.zoomElementContainer.appendChild(this.rangeInput);
    this.zoomElementContainer.appendChild(this.rangeText);
  };
  CameraZoomUi2.prototype.onValueChange = function() {
    var zoomString = Html5QrcodeScannerStrings.zoom();
    this.rangeText.innerText = "".concat(this.rangeInput.value, "x ").concat(zoomString);
    if (this.onChangeCallback) {
      this.onChangeCallback(parseFloat(this.rangeInput.value));
    }
  };
  CameraZoomUi2.prototype.setValues = function(minValue, maxValue, defaultValue, step) {
    this.rangeInput.min = minValue.toString();
    this.rangeInput.max = maxValue.toString();
    this.rangeInput.step = step.toString();
    this.rangeInput.value = defaultValue.toString();
    this.onValueChange();
  };
  CameraZoomUi2.prototype.show = function() {
    this.zoomElementContainer.style.display = "block";
  };
  CameraZoomUi2.prototype.hide = function() {
    this.zoomElementContainer.style.display = "none";
  };
  CameraZoomUi2.prototype.setOnCameraZoomValueChangeCallback = function(onChangeCallback) {
    this.onChangeCallback = onChangeCallback;
  };
  CameraZoomUi2.prototype.removeOnCameraZoomValueChangeCallback = function() {
    this.onChangeCallback = null;
  };
  CameraZoomUi2.create = function(parentElement, renderOnCreate) {
    var cameraZoomUi = new CameraZoomUi2();
    cameraZoomUi.render(parentElement, renderOnCreate);
    return cameraZoomUi;
  };
  return CameraZoomUi2;
}();
var Html5QrcodeScannerStatus;
(function(Html5QrcodeScannerStatus2) {
  Html5QrcodeScannerStatus2[Html5QrcodeScannerStatus2["STATUS_DEFAULT"] = 0] = "STATUS_DEFAULT";
  Html5QrcodeScannerStatus2[Html5QrcodeScannerStatus2["STATUS_SUCCESS"] = 1] = "STATUS_SUCCESS";
  Html5QrcodeScannerStatus2[Html5QrcodeScannerStatus2["STATUS_WARNING"] = 2] = "STATUS_WARNING";
  Html5QrcodeScannerStatus2[Html5QrcodeScannerStatus2["STATUS_REQUESTING_PERMISSION"] = 3] = "STATUS_REQUESTING_PERMISSION";
})(Html5QrcodeScannerStatus || (Html5QrcodeScannerStatus = {}));
function toHtml5QrcodeCameraScanConfig(config2) {
  return {
    fps: config2.fps,
    qrbox: config2.qrbox,
    aspectRatio: config2.aspectRatio,
    disableFlip: config2.disableFlip,
    videoConstraints: config2.videoConstraints
  };
}
function toHtml5QrcodeFullConfig(config2, verbose) {
  return {
    formatsToSupport: config2.formatsToSupport,
    useBarCodeDetectorIfSupported: config2.useBarCodeDetectorIfSupported,
    experimentalFeatures: config2.experimentalFeatures,
    verbose
  };
}
var Html5QrcodeScanner = function() {
  function Html5QrcodeScanner2(elementId, config2, verbose) {
    this.lastMatchFound = null;
    this.cameraScanImage = null;
    this.fileScanImage = null;
    this.fileSelectionUi = null;
    this.elementId = elementId;
    this.config = this.createConfig(config2);
    this.verbose = verbose === true;
    if (!document.getElementById(elementId)) {
      throw "HTML Element with id=".concat(elementId, " not found");
    }
    this.scanTypeSelector = new ScanTypeSelector(this.config.supportedScanTypes);
    this.currentScanType = this.scanTypeSelector.getDefaultScanType();
    this.sectionSwapAllowed = true;
    this.logger = new BaseLoggger(this.verbose);
    this.persistedDataManager = new PersistedDataManager();
    if (config2.rememberLastUsedCamera !== true) {
      this.persistedDataManager.reset();
    }
  }
  Html5QrcodeScanner2.prototype.render = function(qrCodeSuccessCallback, qrCodeErrorCallback) {
    var _this2 = this;
    this.lastMatchFound = null;
    this.qrCodeSuccessCallback = function(decodedText, result2) {
      if (qrCodeSuccessCallback) {
        qrCodeSuccessCallback(decodedText, result2);
      } else {
        if (_this2.lastMatchFound === decodedText) {
          return;
        }
        _this2.lastMatchFound = decodedText;
        _this2.setHeaderMessage(Html5QrcodeScannerStrings.lastMatch(decodedText), Html5QrcodeScannerStatus.STATUS_SUCCESS);
      }
    };
    this.qrCodeErrorCallback = function(errorMessage, error2) {
      if (qrCodeErrorCallback) {
        qrCodeErrorCallback(errorMessage, error2);
      }
    };
    var container2 = document.getElementById(this.elementId);
    if (!container2) {
      throw "HTML Element with id=".concat(this.elementId, " not found");
    }
    container2.innerHTML = "";
    this.createBasicLayout(container2);
    this.html5Qrcode = new Html5Qrcode(this.getScanRegionId(), toHtml5QrcodeFullConfig(this.config, this.verbose));
  };
  Html5QrcodeScanner2.prototype.pause = function(shouldPauseVideo) {
    if (isNullOrUndefined(shouldPauseVideo) || shouldPauseVideo !== true) {
      shouldPauseVideo = false;
    }
    this.getHtml5QrcodeOrFail().pause(shouldPauseVideo);
  };
  Html5QrcodeScanner2.prototype.resume = function() {
    this.getHtml5QrcodeOrFail().resume();
  };
  Html5QrcodeScanner2.prototype.getState = function() {
    return this.getHtml5QrcodeOrFail().getState();
  };
  Html5QrcodeScanner2.prototype.clear = function() {
    var _this2 = this;
    var emptyHtmlContainer = function() {
      var mainContainer = document.getElementById(_this2.elementId);
      if (mainContainer) {
        mainContainer.innerHTML = "";
        _this2.resetBasicLayout(mainContainer);
      }
    };
    if (this.html5Qrcode) {
      return new Promise(function(resolve2, reject) {
        if (!_this2.html5Qrcode) {
          resolve2();
          return;
        }
        if (_this2.html5Qrcode.isScanning) {
          _this2.html5Qrcode.stop().then(function(_) {
            if (!_this2.html5Qrcode) {
              resolve2();
              return;
            }
            _this2.html5Qrcode.clear();
            emptyHtmlContainer();
            resolve2();
          }).catch(function(error2) {
            if (_this2.verbose) {
              _this2.logger.logError("Unable to stop qrcode scanner", error2);
            }
            reject(error2);
          });
        } else {
          _this2.html5Qrcode.clear();
          emptyHtmlContainer();
          resolve2();
        }
      });
    }
    return Promise.resolve();
  };
  Html5QrcodeScanner2.prototype.getRunningTrackCapabilities = function() {
    return this.getHtml5QrcodeOrFail().getRunningTrackCapabilities();
  };
  Html5QrcodeScanner2.prototype.getRunningTrackSettings = function() {
    return this.getHtml5QrcodeOrFail().getRunningTrackSettings();
  };
  Html5QrcodeScanner2.prototype.applyVideoConstraints = function(videoConstaints) {
    return this.getHtml5QrcodeOrFail().applyVideoConstraints(videoConstaints);
  };
  Html5QrcodeScanner2.prototype.getHtml5QrcodeOrFail = function() {
    if (!this.html5Qrcode) {
      throw "Code scanner not initialized.";
    }
    return this.html5Qrcode;
  };
  Html5QrcodeScanner2.prototype.createConfig = function(config2) {
    if (config2) {
      if (!config2.fps) {
        config2.fps = Html5QrcodeConstants.SCAN_DEFAULT_FPS;
      }
      if (config2.rememberLastUsedCamera !== !Html5QrcodeConstants.DEFAULT_REMEMBER_LAST_CAMERA_USED) {
        config2.rememberLastUsedCamera = Html5QrcodeConstants.DEFAULT_REMEMBER_LAST_CAMERA_USED;
      }
      if (!config2.supportedScanTypes) {
        config2.supportedScanTypes = Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE;
      }
      return config2;
    }
    return {
      fps: Html5QrcodeConstants.SCAN_DEFAULT_FPS,
      rememberLastUsedCamera: Html5QrcodeConstants.DEFAULT_REMEMBER_LAST_CAMERA_USED,
      supportedScanTypes: Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE
    };
  };
  Html5QrcodeScanner2.prototype.createBasicLayout = function(parent2) {
    parent2.style.position = "relative";
    parent2.style.padding = "0px";
    parent2.style.border = "1px solid silver";
    this.createHeader(parent2);
    var qrCodeScanRegion = document.createElement("div");
    var scanRegionId = this.getScanRegionId();
    qrCodeScanRegion.id = scanRegionId;
    qrCodeScanRegion.style.width = "100%";
    qrCodeScanRegion.style.minHeight = "100px";
    qrCodeScanRegion.style.textAlign = "center";
    parent2.appendChild(qrCodeScanRegion);
    if (ScanTypeSelector.isCameraScanType(this.currentScanType)) {
      this.insertCameraScanImageToScanRegion();
    } else {
      this.insertFileScanImageToScanRegion();
    }
    var qrCodeDashboard = document.createElement("div");
    var dashboardId = this.getDashboardId();
    qrCodeDashboard.id = dashboardId;
    qrCodeDashboard.style.width = "100%";
    parent2.appendChild(qrCodeDashboard);
    this.setupInitialDashboard(qrCodeDashboard);
  };
  Html5QrcodeScanner2.prototype.resetBasicLayout = function(mainContainer) {
    mainContainer.style.border = "none";
  };
  Html5QrcodeScanner2.prototype.setupInitialDashboard = function(dashboard) {
    this.createSection(dashboard);
    this.createSectionControlPanel();
    if (this.scanTypeSelector.hasMoreThanOneScanType()) {
      this.createSectionSwap();
    }
  };
  Html5QrcodeScanner2.prototype.createHeader = function(dashboard) {
    var header = document.createElement("div");
    header.style.textAlign = "left";
    header.style.margin = "0px";
    dashboard.appendChild(header);
    var libraryInfo = new LibraryInfoContainer();
    libraryInfo.renderInto(header);
    var headerMessageContainer = document.createElement("div");
    headerMessageContainer.id = this.getHeaderMessageContainerId();
    headerMessageContainer.style.display = "none";
    headerMessageContainer.style.textAlign = "center";
    headerMessageContainer.style.fontSize = "14px";
    headerMessageContainer.style.padding = "2px 10px";
    headerMessageContainer.style.margin = "4px";
    headerMessageContainer.style.borderTop = "1px solid #f6f6f6";
    header.appendChild(headerMessageContainer);
  };
  Html5QrcodeScanner2.prototype.createSection = function(dashboard) {
    var section = document.createElement("div");
    section.id = this.getDashboardSectionId();
    section.style.width = "100%";
    section.style.padding = "10px 0px 10px 0px";
    section.style.textAlign = "left";
    dashboard.appendChild(section);
  };
  Html5QrcodeScanner2.prototype.createCameraListUi = function(scpCameraScanRegion, requestPermissionContainer, requestPermissionButton) {
    var $this = this;
    $this.showHideScanTypeSwapLink(false);
    $this.setHeaderMessage(Html5QrcodeScannerStrings.cameraPermissionRequesting());
    var createPermissionButtonIfNotExists = function() {
      if (!requestPermissionButton) {
        $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
      }
    };
    Html5Qrcode.getCameras().then(function(cameras) {
      $this.persistedDataManager.setHasPermission(true);
      $this.showHideScanTypeSwapLink(true);
      $this.resetHeaderMessage();
      if (cameras && cameras.length > 0) {
        scpCameraScanRegion.removeChild(requestPermissionContainer);
        $this.renderCameraSelection(cameras);
      } else {
        $this.setHeaderMessage(Html5QrcodeScannerStrings.noCameraFound(), Html5QrcodeScannerStatus.STATUS_WARNING);
        createPermissionButtonIfNotExists();
      }
    }).catch(function(error2) {
      $this.persistedDataManager.setHasPermission(false);
      if (requestPermissionButton) {
        requestPermissionButton.disabled = false;
      } else {
        createPermissionButtonIfNotExists();
      }
      $this.setHeaderMessage(error2, Html5QrcodeScannerStatus.STATUS_WARNING);
      $this.showHideScanTypeSwapLink(true);
    });
  };
  Html5QrcodeScanner2.prototype.createPermissionButton = function(scpCameraScanRegion, requestPermissionContainer) {
    var $this = this;
    var requestPermissionButton = BaseUiElementFactory.createElement("button", this.getCameraPermissionButtonId());
    requestPermissionButton.innerText = Html5QrcodeScannerStrings.cameraPermissionTitle();
    requestPermissionButton.addEventListener("click", function() {
      requestPermissionButton.disabled = true;
      $this.createCameraListUi(scpCameraScanRegion, requestPermissionContainer, requestPermissionButton);
    });
    requestPermissionContainer.appendChild(requestPermissionButton);
  };
  Html5QrcodeScanner2.prototype.createPermissionsUi = function(scpCameraScanRegion, requestPermissionContainer) {
    var $this = this;
    if (ScanTypeSelector.isCameraScanType(this.currentScanType) && this.persistedDataManager.hasCameraPermissions()) {
      CameraPermissions.hasPermissions().then(function(hasPermissions) {
        if (hasPermissions) {
          $this.createCameraListUi(scpCameraScanRegion, requestPermissionContainer);
        } else {
          $this.persistedDataManager.setHasPermission(false);
          $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
        }
      }).catch(function(_) {
        $this.persistedDataManager.setHasPermission(false);
        $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
      });
      return;
    }
    this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
  };
  Html5QrcodeScanner2.prototype.createSectionControlPanel = function() {
    var section = document.getElementById(this.getDashboardSectionId());
    var sectionControlPanel = document.createElement("div");
    section.appendChild(sectionControlPanel);
    var scpCameraScanRegion = document.createElement("div");
    scpCameraScanRegion.id = this.getDashboardSectionCameraScanRegionId();
    scpCameraScanRegion.style.display = ScanTypeSelector.isCameraScanType(this.currentScanType) ? "block" : "none";
    sectionControlPanel.appendChild(scpCameraScanRegion);
    var requestPermissionContainer = document.createElement("div");
    requestPermissionContainer.style.textAlign = "center";
    scpCameraScanRegion.appendChild(requestPermissionContainer);
    if (this.scanTypeSelector.isCameraScanRequired()) {
      this.createPermissionsUi(scpCameraScanRegion, requestPermissionContainer);
    }
    this.renderFileScanUi(sectionControlPanel);
  };
  Html5QrcodeScanner2.prototype.renderFileScanUi = function(parent2) {
    var showOnRender = ScanTypeSelector.isFileScanType(this.currentScanType);
    var $this = this;
    var onFileSelected = function(file) {
      if (!$this.html5Qrcode) {
        throw "html5Qrcode not defined";
      }
      if (!ScanTypeSelector.isFileScanType($this.currentScanType)) {
        return;
      }
      $this.setHeaderMessage(Html5QrcodeScannerStrings.loadingImage());
      $this.html5Qrcode.scanFileV2(file, true).then(function(html5qrcodeResult) {
        $this.resetHeaderMessage();
        $this.qrCodeSuccessCallback(html5qrcodeResult.decodedText, html5qrcodeResult);
      }).catch(function(error2) {
        $this.setHeaderMessage(error2, Html5QrcodeScannerStatus.STATUS_WARNING);
        $this.qrCodeErrorCallback(error2, Html5QrcodeErrorFactory.createFrom(error2));
      });
    };
    this.fileSelectionUi = FileSelectionUi.create(parent2, showOnRender, onFileSelected);
  };
  Html5QrcodeScanner2.prototype.renderCameraSelection = function(cameras) {
    var _this2 = this;
    var $this = this;
    var scpCameraScanRegion = document.getElementById(this.getDashboardSectionCameraScanRegionId());
    scpCameraScanRegion.style.textAlign = "center";
    var cameraZoomUi = CameraZoomUi.create(scpCameraScanRegion, false);
    var renderCameraZoomUiIfSupported = function(cameraCapabilities) {
      var zoomCapability = cameraCapabilities.zoomFeature();
      if (!zoomCapability.isSupported()) {
        return;
      }
      cameraZoomUi.setOnCameraZoomValueChangeCallback(function(zoomValue) {
        zoomCapability.apply(zoomValue);
      });
      var defaultZoom = 1;
      if (_this2.config.defaultZoomValueIfSupported) {
        defaultZoom = _this2.config.defaultZoomValueIfSupported;
      }
      defaultZoom = clip(defaultZoom, zoomCapability.min(), zoomCapability.max());
      cameraZoomUi.setValues(zoomCapability.min(), zoomCapability.max(), defaultZoom, zoomCapability.step());
      cameraZoomUi.show();
    };
    var cameraSelectUi = CameraSelectionUi.create(scpCameraScanRegion, cameras);
    var cameraActionContainer = document.createElement("span");
    var cameraActionStartButton = BaseUiElementFactory.createElement("button", PublicUiElementIdAndClasses.CAMERA_START_BUTTON_ID);
    cameraActionStartButton.innerText = Html5QrcodeScannerStrings.scanButtonStartScanningText();
    cameraActionContainer.appendChild(cameraActionStartButton);
    var cameraActionStopButton = BaseUiElementFactory.createElement("button", PublicUiElementIdAndClasses.CAMERA_STOP_BUTTON_ID);
    cameraActionStopButton.innerText = Html5QrcodeScannerStrings.scanButtonStopScanningText();
    cameraActionStopButton.style.display = "none";
    cameraActionStopButton.disabled = true;
    cameraActionContainer.appendChild(cameraActionStopButton);
    var torchButton;
    var createAndShowTorchButtonIfSupported = function(cameraCapabilities) {
      if (!cameraCapabilities.torchFeature().isSupported()) {
        if (torchButton) {
          torchButton.hide();
        }
        return;
      }
      if (!torchButton) {
        torchButton = TorchButton.create(cameraActionContainer, cameraCapabilities.torchFeature(), { display: "none", marginLeft: "5px" }, function(errorMessage) {
          $this.setHeaderMessage(errorMessage, Html5QrcodeScannerStatus.STATUS_WARNING);
        });
      } else {
        torchButton.updateTorchCapability(cameraCapabilities.torchFeature());
      }
      torchButton.show();
    };
    scpCameraScanRegion.appendChild(cameraActionContainer);
    var resetCameraActionStartButton = function(shouldShow) {
      if (!shouldShow) {
        cameraActionStartButton.style.display = "none";
      }
      cameraActionStartButton.innerText = Html5QrcodeScannerStrings.scanButtonStartScanningText();
      cameraActionStartButton.style.opacity = "1";
      cameraActionStartButton.disabled = false;
      if (shouldShow) {
        cameraActionStartButton.style.display = "inline-block";
      }
    };
    cameraActionStartButton.addEventListener("click", function(_) {
      cameraActionStartButton.innerText = Html5QrcodeScannerStrings.scanButtonScanningStarting();
      cameraSelectUi.disable();
      cameraActionStartButton.disabled = true;
      cameraActionStartButton.style.opacity = "0.5";
      if (_this2.scanTypeSelector.hasMoreThanOneScanType()) {
        $this.showHideScanTypeSwapLink(false);
      }
      $this.resetHeaderMessage();
      var cameraId2 = cameraSelectUi.getValue();
      $this.persistedDataManager.setLastUsedCameraId(cameraId2);
      $this.html5Qrcode.start(cameraId2, toHtml5QrcodeCameraScanConfig($this.config), $this.qrCodeSuccessCallback, $this.qrCodeErrorCallback).then(function(_2) {
        cameraActionStopButton.disabled = false;
        cameraActionStopButton.style.display = "inline-block";
        resetCameraActionStartButton(false);
        var cameraCapabilities = $this.html5Qrcode.getRunningTrackCameraCapabilities();
        if (_this2.config.showTorchButtonIfSupported === true) {
          createAndShowTorchButtonIfSupported(cameraCapabilities);
        }
        if (_this2.config.showZoomSliderIfSupported === true) {
          renderCameraZoomUiIfSupported(cameraCapabilities);
        }
      }).catch(function(error2) {
        $this.showHideScanTypeSwapLink(true);
        cameraSelectUi.enable();
        resetCameraActionStartButton(true);
        $this.setHeaderMessage(error2, Html5QrcodeScannerStatus.STATUS_WARNING);
      });
    });
    if (cameraSelectUi.hasSingleItem()) {
      cameraActionStartButton.click();
    }
    cameraActionStopButton.addEventListener("click", function(_) {
      if (!$this.html5Qrcode) {
        throw "html5Qrcode not defined";
      }
      cameraActionStopButton.disabled = true;
      $this.html5Qrcode.stop().then(function(_2) {
        if (_this2.scanTypeSelector.hasMoreThanOneScanType()) {
          $this.showHideScanTypeSwapLink(true);
        }
        cameraSelectUi.enable();
        cameraActionStartButton.disabled = false;
        cameraActionStopButton.style.display = "none";
        cameraActionStartButton.style.display = "inline-block";
        if (torchButton) {
          torchButton.reset();
          torchButton.hide();
        }
        cameraZoomUi.removeOnCameraZoomValueChangeCallback();
        cameraZoomUi.hide();
        $this.insertCameraScanImageToScanRegion();
      }).catch(function(error2) {
        cameraActionStopButton.disabled = false;
        $this.setHeaderMessage(error2, Html5QrcodeScannerStatus.STATUS_WARNING);
      });
    });
    if ($this.persistedDataManager.getLastUsedCameraId()) {
      var cameraId = $this.persistedDataManager.getLastUsedCameraId();
      if (cameraSelectUi.hasValue(cameraId)) {
        cameraSelectUi.setValue(cameraId);
        cameraActionStartButton.click();
      } else {
        $this.persistedDataManager.resetLastUsedCameraId();
      }
    }
  };
  Html5QrcodeScanner2.prototype.createSectionSwap = function() {
    var $this = this;
    var TEXT_IF_CAMERA_SCAN_SELECTED = Html5QrcodeScannerStrings.textIfCameraScanSelected();
    var TEXT_IF_FILE_SCAN_SELECTED = Html5QrcodeScannerStrings.textIfFileScanSelected();
    var section = document.getElementById(this.getDashboardSectionId());
    var switchContainer = document.createElement("div");
    switchContainer.style.textAlign = "center";
    var switchScanTypeLink = BaseUiElementFactory.createElement("span", this.getDashboardSectionSwapLinkId());
    switchScanTypeLink.style.textDecoration = "underline";
    switchScanTypeLink.style.cursor = "pointer";
    switchScanTypeLink.innerText = ScanTypeSelector.isCameraScanType(this.currentScanType) ? TEXT_IF_CAMERA_SCAN_SELECTED : TEXT_IF_FILE_SCAN_SELECTED;
    switchScanTypeLink.addEventListener("click", function() {
      if (!$this.sectionSwapAllowed) {
        if ($this.verbose) {
          $this.logger.logError("Section swap called when not allowed");
        }
        return;
      }
      $this.resetHeaderMessage();
      $this.fileSelectionUi.resetValue();
      $this.sectionSwapAllowed = false;
      if (ScanTypeSelector.isCameraScanType($this.currentScanType)) {
        $this.clearScanRegion();
        $this.getCameraScanRegion().style.display = "none";
        $this.fileSelectionUi.show();
        switchScanTypeLink.innerText = TEXT_IF_FILE_SCAN_SELECTED;
        $this.currentScanType = Html5QrcodeScanType.SCAN_TYPE_FILE;
        $this.insertFileScanImageToScanRegion();
      } else {
        $this.clearScanRegion();
        $this.getCameraScanRegion().style.display = "block";
        $this.fileSelectionUi.hide();
        switchScanTypeLink.innerText = TEXT_IF_CAMERA_SCAN_SELECTED;
        $this.currentScanType = Html5QrcodeScanType.SCAN_TYPE_CAMERA;
        $this.insertCameraScanImageToScanRegion();
        $this.startCameraScanIfPermissionExistsOnSwap();
      }
      $this.sectionSwapAllowed = true;
    });
    switchContainer.appendChild(switchScanTypeLink);
    section.appendChild(switchContainer);
  };
  Html5QrcodeScanner2.prototype.startCameraScanIfPermissionExistsOnSwap = function() {
    var _this2 = this;
    var $this = this;
    if (this.persistedDataManager.hasCameraPermissions()) {
      CameraPermissions.hasPermissions().then(function(hasPermissions) {
        if (hasPermissions) {
          var permissionButton = document.getElementById($this.getCameraPermissionButtonId());
          if (!permissionButton) {
            _this2.logger.logError("Permission button not found, fail;");
            throw "Permission button not found";
          }
          permissionButton.click();
        } else {
          $this.persistedDataManager.setHasPermission(false);
        }
      }).catch(function(_) {
        $this.persistedDataManager.setHasPermission(false);
      });
      return;
    }
  };
  Html5QrcodeScanner2.prototype.resetHeaderMessage = function() {
    var messageDiv = document.getElementById(this.getHeaderMessageContainerId());
    messageDiv.style.display = "none";
  };
  Html5QrcodeScanner2.prototype.setHeaderMessage = function(messageText, scannerStatus) {
    if (!scannerStatus) {
      scannerStatus = Html5QrcodeScannerStatus.STATUS_DEFAULT;
    }
    var messageDiv = this.getHeaderMessageDiv();
    messageDiv.innerText = messageText;
    messageDiv.style.display = "block";
    switch (scannerStatus) {
      case Html5QrcodeScannerStatus.STATUS_SUCCESS:
        messageDiv.style.background = "rgba(106, 175, 80, 0.26)";
        messageDiv.style.color = "#477735";
        break;
      case Html5QrcodeScannerStatus.STATUS_WARNING:
        messageDiv.style.background = "rgba(203, 36, 49, 0.14)";
        messageDiv.style.color = "#cb2431";
        break;
      case Html5QrcodeScannerStatus.STATUS_DEFAULT:
      default:
        messageDiv.style.background = "rgba(0, 0, 0, 0)";
        messageDiv.style.color = "rgb(17, 17, 17)";
        break;
    }
  };
  Html5QrcodeScanner2.prototype.showHideScanTypeSwapLink = function(shouldDisplay) {
    if (this.scanTypeSelector.hasMoreThanOneScanType()) {
      if (shouldDisplay !== true) {
        shouldDisplay = false;
      }
      this.sectionSwapAllowed = shouldDisplay;
      this.getDashboardSectionSwapLink().style.display = shouldDisplay ? "inline-block" : "none";
    }
  };
  Html5QrcodeScanner2.prototype.insertCameraScanImageToScanRegion = function() {
    var $this = this;
    var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
    if (this.cameraScanImage) {
      qrCodeScanRegion.innerHTML = "<br>";
      qrCodeScanRegion.appendChild(this.cameraScanImage);
      return;
    }
    this.cameraScanImage = new Image();
    this.cameraScanImage.onload = function(_) {
      qrCodeScanRegion.innerHTML = "<br>";
      qrCodeScanRegion.appendChild($this.cameraScanImage);
    };
    this.cameraScanImage.width = 64;
    this.cameraScanImage.style.opacity = "0.8";
    this.cameraScanImage.src = ASSET_CAMERA_SCAN;
    this.cameraScanImage.alt = Html5QrcodeScannerStrings.cameraScanAltText();
  };
  Html5QrcodeScanner2.prototype.insertFileScanImageToScanRegion = function() {
    var $this = this;
    var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
    if (this.fileScanImage) {
      qrCodeScanRegion.innerHTML = "<br>";
      qrCodeScanRegion.appendChild(this.fileScanImage);
      return;
    }
    this.fileScanImage = new Image();
    this.fileScanImage.onload = function(_) {
      qrCodeScanRegion.innerHTML = "<br>";
      qrCodeScanRegion.appendChild($this.fileScanImage);
    };
    this.fileScanImage.width = 64;
    this.fileScanImage.style.opacity = "0.8";
    this.fileScanImage.src = ASSET_FILE_SCAN;
    this.fileScanImage.alt = Html5QrcodeScannerStrings.fileScanAltText();
  };
  Html5QrcodeScanner2.prototype.clearScanRegion = function() {
    var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
    qrCodeScanRegion.innerHTML = "";
  };
  Html5QrcodeScanner2.prototype.getDashboardSectionId = function() {
    return "".concat(this.elementId, "__dashboard_section");
  };
  Html5QrcodeScanner2.prototype.getDashboardSectionCameraScanRegionId = function() {
    return "".concat(this.elementId, "__dashboard_section_csr");
  };
  Html5QrcodeScanner2.prototype.getDashboardSectionSwapLinkId = function() {
    return PublicUiElementIdAndClasses.SCAN_TYPE_CHANGE_ANCHOR_ID;
  };
  Html5QrcodeScanner2.prototype.getScanRegionId = function() {
    return "".concat(this.elementId, "__scan_region");
  };
  Html5QrcodeScanner2.prototype.getDashboardId = function() {
    return "".concat(this.elementId, "__dashboard");
  };
  Html5QrcodeScanner2.prototype.getHeaderMessageContainerId = function() {
    return "".concat(this.elementId, "__header_message");
  };
  Html5QrcodeScanner2.prototype.getCameraPermissionButtonId = function() {
    return PublicUiElementIdAndClasses.CAMERA_PERMISSION_BUTTON_ID;
  };
  Html5QrcodeScanner2.prototype.getCameraScanRegion = function() {
    return document.getElementById(this.getDashboardSectionCameraScanRegionId());
  };
  Html5QrcodeScanner2.prototype.getDashboardSectionSwapLink = function() {
    return document.getElementById(this.getDashboardSectionSwapLinkId());
  };
  Html5QrcodeScanner2.prototype.getHeaderMessageDiv = function() {
    return document.getElementById(this.getHeaderMessageContainerId());
  };
  return Html5QrcodeScanner2;
}();
var render$w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    attrs: {
      "id": "qr-code-full-region"
    }
  });
};
var staticRenderFns$w = [];
const __vue2_script$w = {
  props: ["qrbox", "fps"],
  data() {
    return {
      html5QrcodeScanner: null
    };
  },
  computed: __spreadValues({}, mapStores(useDpmStore)),
  created() {
  },
  methods: {
    onScanSuccess(decodedText, decodedResult) {
      this.dpmStore.$patch({ global: { scan: {
        text: decodedText,
        result: decodedResult
      } } });
    },
    init() {
      return __async(this, null, function* () {
        if (this.html5QrcodeScanner) {
          yield this.html5QrcodeScanner.clear();
          this.html5QrcodeScanner.createBasicLayout(document.getElementById("qr-code-full-region"));
        } else {
          this.html5QrcodeScanner = new Html5QrcodeScanner("qr-code-full-region", { fps: this.fps, qrbox: this.qrbox });
          this.html5QrcodeScanner.render(this.onScanSuccess);
        }
      });
    }
  },
  mounted() {
    this.init();
  }
};
const __cssModules$w = {};
var __component__$w = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$w,
  render$w,
  staticRenderFns$w,
  false,
  __vue2_injectStyles$w,
  null,
  null,
  null
);
function __vue2_injectStyles$w(context) {
  for (let o in __cssModules$w) {
    this[o] = __cssModules$w[o];
  }
}
const QrcodeScanner = /* @__PURE__ */ function() {
  return __component__$w.exports;
}();
var render$v = function() {
  var _vm$cilbeeStore$start, _vm$cilbeeStore$start2, _vm$cilbeeStore$start3;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "cilbee-app p-3 df flex-grow-1 justify-space-between align-center flex-column"
  }, [_c("v-dialog", {
    attrs: {
      "content-class": "dpm-cilbee-modal",
      "width": "90%",
      "persistent": ""
    },
    model: {
      value: _vm.cilbeeStore.phase === 1 && !_vm.showDestinationList,
      callback: function($$v) {
        _vm.$set(_vm.cilbeeStore, "phase === 1 && !showDestinationList", $$v);
      },
      expression: "cilbeeStore.phase === 1 && !showDestinationList"
    }
  }, [_c("v-card", {
    staticClass: "df flex-column"
  }, [_c("div", {
    staticClass: "m-2 mb-0 d-block text-center"
  }, [_vm.cilbeeStore.startSweep && _vm.cilbeeStore.startSweep.sid ? _c("div", {
    staticClass: "text-h6 caption mb-0"
  }, [_vm._v(_vm._s(_vm.$t("cilbee.startModalTitle1"))), _c("div", {
    staticClass: "text-subtitle-1 caption font-weight-thin mb-0"
  }, [_vm._v(_vm._s(_vm.$t("cilbee.startModalTitle2")))])]) : _c("div", {
    staticClass: "text-h6 caption mb-0"
  }, [_vm._v(_vm._s(_vm.$t("cilbee.startModalTitle0")))])]), _c("v-card-text", {
    staticClass: "p-0 df flex-grow-1"
  }, [_vm.cilbeeStore.phase === 1 ? _c("GroupList", {
    attrs: {
      "useBy": "cilbee"
    }
  }) : _vm._e()], 1), _vm.cilbeeStore.destinations.length ? _c("v-card-actions", [_c("div", {
    staticClass: "df w-100"
  }, [_c("v-btn", {
    staticClass: "flex-grow-1 text-adjust",
    on: {
      "click": _vm.showDestinationListModal
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiFormatListBulleted))]), _vm._v(_vm._s(_vm.$t("cilbee.destinationList")))], 1), _c("v-btn", {
    staticClass: "ms-2 flex-grow-1 text-adjust",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cilbeeStore.$patch({
          phase: 4
        });
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiEye))]), _vm._v(_vm._s(_vm.$t("cilbee.seeRoute")))], 1)], 1)]) : _vm._e()], 1)], 1), _c("div", {
    staticClass: "df w-100 pe-auto"
  }, [_vm.cilbeeStore.destinations.length && (_vm.cilbeeStore.phase === 2 || _vm.cilbeeStore.phase === 3) ? _c("v-btn", {
    staticClass: "flex-grow-1 text-adjust",
    on: {
      "click": _vm.showDestinationListModal
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiFormatListBulleted))]), _vm._v(_vm._s(_vm.$t("cilbee.destinationList")))], 1) : _vm._e(), (_vm.cilbeeStore.phase === 2 || _vm.cilbeeStore.phase === 3) && _vm.cilbeeStore.startSweep && _vm.cilbeeStore.startSweep.sid ? _c("v-btn", {
    staticClass: "ms-2 p-0 flex-grow-1 text-adjust",
    on: {
      "click": function($event) {
        _vm.showConfirmModal = true;
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiMapMarker))]), _vm._v(_vm._s(_vm.$t("cilbee.changeStartPoint")))], 1) : _vm._e()], 1), _vm.cilbeeStore.phase >= 2 && _vm.cilbeeStore.phase <= 4 && !_vm.matterportStore.dockOpen ? _c("div", {
    staticClass: "before-navigation df flex-column m-3 w-100 pe-auto"
  }, [_vm.showError ? _c("v-alert", {
    attrs: {
      "type": "warning",
      "border": "left"
    }
  }, [_c("span", {
    domProps: {
      "innerHTML": _vm._s(_vm.dpmStore.SED.cilbee.noResultText[_vm._i18n.locale] || _vm.$global.utils.text.addBrTag(_vm.$t("cilbee.noResult")))
    }
  })]) : _vm._e(), _vm.cilbeeStore.phase === 2 && _vm.dpmStore.current.mode === _vm.$global.sdk.Mode.Mode.INSIDE ? _c("v-card", [_c("v-card-text", {
    staticClass: "text-center"
  }, [(_vm$cilbeeStore$start = _vm.cilbeeStore.startSweep) !== null && _vm$cilbeeStore$start !== void 0 && _vm$cilbeeStore$start.sid ? [_vm.checkAdded() === -1 ? _c("div", [!_vm.dpmStore.current.sweep.sid || _vm.dpmStore.current.sweep.sid === _vm.cilbeeStore.startSweep.sid ? _c("div", [_vm._v("目的地と開始地点が同じです、キャンセルして違う目的地を選択して下さい。")]) : _c("div", [_vm._v(_vm._s(_vm.$t("cilbee.addDestination")))])]) : _c("div", [_vm._v(_vm._s(_vm.$t("cilbee.deleteDestination")))])] : [_c("div", [_vm._v("ここを開始地点にしますか？")])]], 2)], 1) : _vm._e(), _vm.cilbeeStore.phase === 4 && _vm.cilbeeStore.passableAreas.length > 1 ? _c("div", {
    staticClass: "passable-area-selector"
  }, [_c("v-card", [_c("v-card-text", {
    staticClass: "text-center"
  }, [_vm._v("経路パターンを選択して下さい")])], 1), _c("div", {
    staticClass: "selectable-passable-areas mt-2"
  }, _vm._l(_vm.cilbeeStore.passableAreas, function(passableArea, i2) {
    return passableArea.visible ? _c("v-btn", {
      staticClass: "me-2 mb-2",
      class: {
        primary: _vm.selectedPassableAreaIndex == i2
      },
      on: {
        "click": function($event) {
          return _vm.changePassableArea(i2);
        }
      }
    }, [_vm._v(_vm._s(passableArea.name))]) : _vm._e();
  }), 1)], 1) : _vm._e(), _c("div", {
    staticClass: "df mt-3"
  }, [_vm.checkAdded() === -1 ? [_vm.cilbeeStore.phase === 2 && _vm.dpmStore.current.mode === _vm.$global.sdk.Mode.Mode.INSIDE ? _c("v-btn", {
    staticClass: "flex-basis-130",
    on: {
      "click": _vm.cancelEditDestination
    }
  }, [_vm._v(_vm._s(_vm.$t("cilbee.cancel")))]) : _vm._e(), _vm.cilbeeStore.phase === 2 && _vm.dpmStore.current.mode === _vm.$global.sdk.Mode.Mode.INSIDE ? [!_vm.dpmStore.current.sweep.sid ? _c("v-btn", {
    staticClass: "ms-2 flex-grow-2",
    attrs: {
      "color": "primary",
      "loading": ""
    }
  }) : _vm.dpmStore.current.sweep.sid === ((_vm$cilbeeStore$start2 = _vm.cilbeeStore.startSweep) === null || _vm$cilbeeStore$start2 === void 0 ? void 0 : _vm$cilbeeStore$start2.sid) ? _c("v-btn", {
    staticClass: "ms-2 flex-grow-2",
    attrs: {
      "color": "error"
    }
  }, [_vm._v("開始地点と同じです")]) : _c("v-btn", {
    staticClass: "ms-2 flex-grow-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editDestinations();
      }
    }
  }, [_vm.cilbeeStore.startSweep && (_vm$cilbeeStore$start3 = _vm.cilbeeStore.startSweep) !== null && _vm$cilbeeStore$start3 !== void 0 && _vm$cilbeeStore$start3.sid ? _c("span", [_vm._v(_vm._s(_vm.$t("cilbee.add")))]) : _c("span", [_vm._v("開始地点にする")])])] : _vm._e()] : [_vm.cilbeeStore.phase === 2 && _vm.dpmStore.current.mode === _vm.$global.sdk.Mode.Mode.INSIDE ? _c("v-btn", {
    staticClass: "text-white flex-basis-130",
    attrs: {
      "color": "orange darken-1"
    },
    on: {
      "click": function($event) {
        return _vm.editDestinations();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("cilbee.delete")))]) : _vm._e(), _vm.cilbeeStore.phase === 2 && _vm.dpmStore.current.mode === _vm.$global.sdk.Mode.Mode.INSIDE ? _c("v-btn", {
    staticClass: "ms-2 flex-grow-2",
    on: {
      "click": _vm.cancelEditDestination
    }
  }, [_vm._v(_vm._s(_vm.$t("cilbee.cancel")))]) : _vm._e()], _vm.cilbeeStore.phase === 2 && _vm.dpmStore.current.mode !== _vm.$global.sdk.Mode.Mode.INSIDE ? _c("v-btn", {
    staticClass: "ms-2 flex-grow-2",
    on: {
      "click": function($event) {
        return _vm.$global.sdk.Mode.moveTo(_vm.$global.sdk.Mode.Mode.INSIDE);
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiKeyboardReturn))]), _vm._v(_vm._s(_vm.$t("cilbee.returnToPreviousPoint")))], 1) : _vm._e(), _vm.cilbeeStore.phase === 3 || _vm.cilbeeStore.phase === 4 ? _c("v-btn", {
    staticClass: "text-adjust flex-basis-130",
    on: {
      "click": function($event) {
        return _vm.cilbeeStore.$patch({
          phase: 1
        });
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiMagnify))]), _vm._v(_vm._s(_vm.$t("cilbee.editDestination")))], 1) : _vm._e(), _vm.cilbeeStore.phase === 3 ? _c("v-btn", {
    staticClass: "ms-2 flex-grow-2 text-adjust",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cilbeeStore.$patch({
          phase: 4
        });
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiEye))]), _vm._v(_vm._s(_vm.$t("cilbee.seeRoute")))], 1) : _vm._e(), _vm.cilbeeStore.phase === 4 && !_vm.showError ? _c("v-btn", {
    staticClass: "ms-2 flex-grow-2 text-adjust",
    attrs: {
      "loading": !_vm.navigationStartable,
      "color": "primary"
    },
    on: {
      "click": _vm.startGuidance
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPlay))]), _vm._v(_vm._s(_vm.$t("cilbee.guidanceStart")))], 1) : _vm._e()], 2)], 1) : _vm._e(), _vm.cilbeeStore.phase >= 5 && _vm.cilbeeStore.phase <= 7 ? _c("div", {
    staticClass: "navigation df flex-column justify-space-between w-100"
  }, [_c("div", {
    staticClass: "top-ui mt-2 p-0 pe-auto"
  }, [_c("div", {
    staticClass: "area-1 w-100 df"
  }, [_vm.cilbeeStore.phase === 5 || _vm.cilbeeStore.phase === 6 ? _c("v-btn", {
    staticClass: "with-mini-text me-3 flex-1",
    attrs: {
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        return _vm.cilbeeStore.$patch({
          phase: 4
        });
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiSwapHorizontalVariant))]), _c("div", {
    staticClass: "mini-text"
  }, [_vm._v(_vm._s(_vm.$t("cilbee.preview")))])], 1) : _vm._e(), _vm.cilbeeStore.phase === 5 || _vm.cilbeeStore.phase === 6 ? _c("v-btn", {
    staticClass: "with-mini-text flex-1",
    attrs: {
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        return _vm.cilbeeStore.$patch({
          phase: 1
        });
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiMapSearchOutline))]), _c("div", {
    staticClass: "mini-text"
  }, [_vm._v(_vm._s(_vm.$t("cilbee.editDestination")))])], 1) : _vm._e(), _vm.cilbeeStore.phase === 7 ? _c("v-btn", {
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.cilbeeStore.$patch({
          phase: 1
        });
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiMagnify))]), _vm._v(_vm._s(_vm.$t("cilbee.searchDestinationAgain")))], 1) : _vm._e()], 1), _c("div", {
    staticClass: "area-2 mp-ui-control mt-3"
  }, [!["mode.inside", "mode.transitioning"].includes(_vm.dpmStore.current.mode) ? _c("v-btn", {
    attrs: {
      "fab": "",
      "color": _vm.cilbeeStore.matterportUiVisibleFlags.label ? "primary" : "white"
    },
    on: {
      "click": _vm.toggleLabelVisible
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiLabel))])], 1) : _vm._e()], 1)]), _vm.cilbeeStore.phase === 5 || _vm.cilbeeStore.phase === 6 ? _c("div", {
    staticClass: "bottom-ui df flex-column w-100 pe-auto"
  }, [_c("div", {
    staticClass: "move-controls"
  }, [_c("v-btn", {
    staticClass: "with-text mb-2",
    attrs: {
      "fab": "",
      "elevation": "0",
      "disabled": _vm.moving || _vm.guidanceProgressIndex >= _vm.routeSearchResult.length - 1
    },
    on: {
      "click": _vm.next
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiChevronUp))]), _c("div", [_vm._v(_vm._s(_vm.$t("cilbee.go")))])], 1), _c("v-btn", {
    staticClass: "with-text",
    attrs: {
      "fab": "",
      "elevation": "0",
      "disabled": _vm.moving || _vm.guidanceProgressIndex === 0
    },
    on: {
      "click": _vm.back
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiChevronDown))]), _c("div", [_vm._v(_vm._s(_vm.$t("cilbee.back")))])], 1)], 1), _vm.pathFinder ? _c("div", {
    staticClass: "progress-ui pa-2 my-2"
  }, [_c("div", {
    staticClass: "top-control"
  }, [_c("div", {
    staticClass: "operation-button"
  }, [!_vm.moving || !_vm.toEnd ? _c("v-btn", {
    staticClass: "with-text",
    attrs: {
      "small": "",
      "fab": "",
      "elevation": "0",
      "disabled": _vm.guidanceProgressIndex === this.routeSearchResult.length - 1 || _vm.moving && !_vm.toEnd
    },
    on: {
      "click": _vm.play
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPlay))])], 1) : _c("v-btn", {
    staticClass: "with-text",
    attrs: {
      "small": "",
      "fab": "",
      "elevation": "0"
    },
    on: {
      "click": _vm.pause
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPause))])], 1)], 1), _c("v-slider", {
    attrs: {
      "min": "0",
      "max": _vm.pathFinder.getPathLength(0, _vm.routeSearchResult.length - 1),
      "step": "0.1",
      "disabled": _vm.moving
    },
    on: {
      "change": _vm.onChangeSlider
    },
    model: {
      value: _vm.currentPosition,
      callback: function($$v) {
        _vm.currentPosition = $$v;
      },
      expression: "currentPosition"
    }
  })], 1), _c("div", {
    staticClass: "bottom-control"
  }, [_c("div", {
    staticClass: "caption font-weight-bold ms-2"
  }, [_vm._v(_vm._s(`${_vm.currentPosition.toFixed(1)}m / ${_vm.pathFinder.getPathLength(0, _vm.routeSearchResult.length - 1).toFixed(1)}m`))]), _vm.nextDestinationLabel !== "案内終了" ? _c("div", {
    staticClass: "caption ms-1"
  }, [_vm._v("次の目的地: " + _vm._s(_vm.nextDestinationLabel))]) : _c("div", {
    staticClass: "caption ms-1"
  }, [_vm._v(_vm._s(_vm.nextDestinationLabel))])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _c("v-dialog", {
    attrs: {
      "content-class": "dpm-cilbee-arrived-destination-modal",
      "width": "90%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: _vm.showArrivedDestinationModal,
      callback: function($$v) {
        _vm.showArrivedDestinationModal = $$v;
      },
      expression: "showArrivedDestinationModal"
    }
  }, [_c("v-card", [_c("v-card-text", {
    staticClass: "p-3"
  }, [_vm._v("「" + _vm._s(_vm.previousDestinationLabel) + "」に到着しました。 「" + _vm._s(_vm.nextDestinationLabel) + "」への案内を開始する場合は、下記ボタンをタップして下さい。")]), _c("v-card-actions", {
    staticClass: "p-3 pt-0"
  }, [_c("v-btn", {
    attrs: {
      "color": "primary",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.showArrivedDestinationModal = false;
        _vm.play();
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPlay))]), _vm._v("次の目的地への案内を開始")], 1)], 1)], 1)], 1), _c("v-dialog", {
    attrs: {
      "content-class": "dpm-cilbee-Floor-change-modal",
      "width": "90%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: _vm.showFloorChangeModal,
      callback: function($$v) {
        _vm.showFloorChangeModal = $$v;
      },
      expression: "showFloorChangeModal"
    }
  }, [_vm.showFloorChangeModal ? _c("v-card", [_c("v-card-text", {
    staticClass: "p-3"
  }, [_vm._v("「" + _vm._s(_vm.dpmStore.global.floors[_vm.dpmStore.global.sweeps[_vm.routeSearchResult[_vm.guidanceProgressIndex + 1]].floorInfo.id].name) + "」へ移動をして下さい。 フロア移動後、下記ボタンをタップして案内を再開して下さい。")]), _c("v-card-actions", {
    staticClass: "p-3 pt-0"
  }, [_c("v-btn", {
    attrs: {
      "color": "primary",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.showFloorChangeModal = false;
        _vm.play();
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPlay))]), _vm._v("案内を再開")], 1)], 1)], 1) : _vm._e()], 1), _c("v-dialog", {
    attrs: {
      "content-class": "dpm-cilbee-arrived-modal",
      "width": "90%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: _vm.cilbeeStore.phase === 6,
      callback: function($$v) {
        _vm.$set(_vm.cilbeeStore, "phase === 6", $$v);
      },
      expression: "cilbeeStore.phase === 6"
    }
  }, [_c("v-card", [_c("v-card-title"), _c("v-card-text", [_c("div", {
    staticClass: "mb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.dpmStore.SED.cilbee.arrivedText[_vm._i18n.locale] || _vm.$global.utils.text.addBrTag(_vm.$t("cilbee.arrived")))
    }
  }), _vm.formFields ? _c("div", {
    staticClass: "dpm-cilbee-form"
  }) : _vm._e(), _vm.privacyPolicy && !_vm.sendForm ? _c("div", {
    staticClass: "privacy-policy text-right"
  }, [_c("v-btn", {
    staticClass: "privacy-policy-toggle-button transparent",
    attrs: {
      "text": "",
      "x-small": ""
    },
    on: {
      "click": function($event) {
        _vm.expand = !_vm.expand;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("cilbee.privacyPolicy")))]), _c("v-expand-transition", [_vm.expand ? _c("v-card", {
    staticClass: "overflow-y-auto",
    attrs: {
      "height": "200",
      "width": "100%"
    }
  }, [_c("v-card-text", {
    staticClass: "text-left",
    domProps: {
      "innerHTML": _vm._s(_vm.privacyPolicy)
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm.sendForm ? _c("div", {
    staticClass: "mt-3 text-center"
  }, [_vm._v(_vm._s(_vm.$t("cilbee.thankYou")))]) : _vm._e()]), _c("v-card-actions", [_c("v-btn", {
    staticClass: "my-3",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.cilbeeStore.$patch({
          phase: 1
        });
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiMagnify))]), _vm._v(_vm._s(_vm.$t("cilbee.searchDestinationAgain")))], 1)], 1)], 1), _c("v-btn", {
    staticClass: "modal-close",
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.cilbeeStore.$patch({
          phase: 7
        });
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))])], 1)], 1), _c("v-dialog", {
    attrs: {
      "content-class": "dpm-cilbee-destination-modal",
      "width": "90%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: _vm.showDestinationList,
      callback: function($$v) {
        _vm.showDestinationList = $$v;
      },
      expression: "showDestinationList"
    }
  }, [_c("v-card", [_c("div", {
    staticClass: "subtitle-2 m-2 d-block text-center"
  }, [_vm._v(_vm._s(_vm.$t("cilbee.destinationList")))]), _c("v-divider"), _c("v-card-text", {
    staticClass: "p-0"
  }, [_c("v-list", {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.cilbeeStore.destinations, function(destination) {
    return _c("v-list-item", {
      key: `cilbee-destination-${destination.sweep.sid}`,
      staticClass: "mx-0 px-0"
    }, [_c("v-list-item-content", [_c("v-list-item-title", {
      staticClass: "df align-items-center"
    }, [_c("v-btn", {
      staticClass: "ms-1",
      attrs: {
        "icon": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.closeModalAndMoveToDestination(destination.sweep.sid);
        }
      }
    }, [_c("v-icon", {
      staticClass: "mx-1"
    }, [_vm._v(_vm._s(_vm.$global.icons.mdiTrashCan))])], 1), _vm.mattertagIcons[destination.mattertagSid] ? _c("span", {
      staticClass: "mattertag-icon me-1",
      domProps: {
        "innerHTML": _vm._s(_vm.mattertagIcons[destination.mattertagSid])
      }
    }) : _vm._e(), _c("span", {
      staticClass: "ms-1 text-wrap"
    }, [_vm._v(_vm._s(_vm.dpmStore.getMattertagBySid(destination.mattertagSid).label || destination.sweep.sid))])], 1)], 1)], 1);
  }), 1)], 1)], 1), _c("v-btn", {
    staticClass: "modal-close",
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showDestinationList = false;
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))])], 1)], 1), _c("v-dialog", {
    attrs: {
      "content-class": "dpm-cilbee-confirm-modal",
      "width": "90%",
      "persistent": ""
    },
    model: {
      value: _vm.showConfirmModal,
      callback: function($$v) {
        _vm.showConfirmModal = $$v;
      },
      expression: "showConfirmModal"
    }
  }, [_c("v-card", [_c("v-card-title", {
    staticClass: "d-block text-center text-break"
  }, [_vm._v(_vm._s(_vm.$t("cilbee.changeStartPointConfirm")))]), _c("v-divider"), _c("v-card-actions", [_c("div", {
    staticClass: "df w-100"
  }, [_c("v-btn", {
    staticClass: "flex-grow-1",
    on: {
      "click": function($event) {
        _vm.showConfirmModal = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("cilbee.cancel")))]), _c("v-btn", {
    staticClass: "ms-2 flex-grow-1",
    attrs: {
      "color": "warning"
    },
    on: {
      "click": _vm.changeStartPoint
    }
  }, [_vm._v(_vm._s(_vm.$t("cilbee.change")))])], 1)])], 1)], 1), _c("v-dialog", {
    attrs: {
      "content-class": "dpm-scan-modal",
      "width": "90%",
      "persistent": ""
    },
    model: {
      value: _vm.cilbeeStore.phase === 8,
      callback: function($$v) {
        _vm.$set(_vm.cilbeeStore, "phase === 8", $$v);
      },
      expression: "cilbeeStore.phase === 8"
    }
  }, [_c("v-card", [_c("v-card-title"), _c("v-card-text", [_c("div", {
    staticClass: "qrcode-scanner df align-items-center flex-column"
  }, [_c("QrcodeScanner", {
    ref: "qr",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "qrbox": 250,
      "fps": 10
    }
  }), _c("div", {
    staticClass: "qrcode-result mt-3 w-100"
  }, [_vm.scanData.mattertag && _vm.scanData.sweep ? _c("v-sheet", {
    staticClass: "text-center"
  }, [_c("h5", {
    staticClass: "my-3"
  }, [_vm._v(_vm._s(_vm.dpmStore.getMattertagBySid(_vm.scanData.mattertag).label || _vm.dpmStore.getMattertagBySid(_vm.scanData.mattertag).sid))]), _vm.checkAdded(_vm.scanData.sweep.sid) === -1 ? _c("span", [_vm._v(_vm._s(_vm.$t("cilbee.addDestination")))]) : _c("span", [_vm._v(_vm._s(_vm.$t("cilbee.deleteDestination")))]), _c("div", {
    staticClass: "df mt-3"
  }, [_vm.checkAdded(_vm.scanData.sweep.sid) === -1 ? [_c("v-btn", {
    staticClass: "flex-basis-80",
    on: {
      "click": function($event) {
        return _vm.resetQr();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("cilbee.cancel")))]), _c("v-btn", {
    staticClass: "ms-2 flex-grow-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editDestinations(_vm.scanData.mattertag, _vm.scanData.sweep, true);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("cilbee.add")))])] : [_c("v-btn", {
    staticClass: "flex-basis-80",
    attrs: {
      "color": "orange darken-1"
    },
    on: {
      "click": function($event) {
        return _vm.editDestinations(_vm.scanData.mattertag, _vm.scanData.sweep, true);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("cilbee.delete")))]), _c("v-btn", {
    staticClass: "ms-2 flex-grow-2",
    on: {
      "click": function($event) {
        return _vm.resetQr();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("cilbee.cancel")))])]], 2)]) : _vm._e(), _vm.scanError ? _c("span", {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t("cilbee.scanError")))]) : _vm._e()], 1)], 1)]), _c("v-card-actions", [_c("div", {
    staticClass: "df w-100"
  }, [_c("v-btn", {
    staticClass: "flex-grow-1",
    on: {
      "click": _vm.endQr
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiKeyboardReturn))]), _vm._v(_vm._s(_vm.$t("cilbee.back")))], 1), _vm.cilbeeStore.destinations.length ? _c("v-btn", {
    staticClass: "ms-2 flex-grow-1",
    on: {
      "click": function($event) {
        return _vm.cilbeeStore.$patch({
          phase: 4
        });
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiEye))]), _vm._v(_vm._s(_vm.$t("cilbee.seeRoute")))], 1) : _vm._e()], 1)])], 1)], 1)], 1);
};
var staticRenderFns$v = [];
const __vue2_script$v = {
  components: { GroupList, Tour, QrcodeScanner },
  data() {
    return {
      arrivedDialog: false,
      bee: null,
      beeArrivedAtSweep: false,
      beeId: null,
      beforeDestinationList: false,
      beforePhase: 1,
      colorNames: ["red", "blue", "green", "cyan", "magenta", "yellow", "pink", "lime", "indigo", "white", "goldenrod", "brown"],
      guidanceProgressIndex: 0,
      currentPosition: 0,
      customMattertagSids: [],
      debug: {
        visible: true,
        // TODO: vueのコンパイルタイプを取ってきてproductionの時はfalseにしたい
        sweepSid: "wkpy7iin9te4fy5erihhysk5c"
      },
      // defaultSelect: { text: '普通', value: 1 },
      expand: false,
      formFields: "",
      mattertagIcons: {},
      moving: false,
      navigationStartable: false,
      node: null,
      pathFinder: null,
      privacyPolicy: null,
      repeatTimerId: null,
      resolution: 100,
      routeSearchResult: [],
      scanData: { mattertag: null, sweep: null },
      scanError: false,
      sendForm: false,
      // selectableItems: [{ text: '速い', value: 2 }, { text: '普通', value: 1 }, { text: 'ゆっくり', value: 0.5 }],
      selectedPassableAreaIndex: 0,
      showcaseDataset: null,
      showConfirmModal: false,
      showDestinationList: false,
      showError: false,
      speed: 1,
      toEnd: false,
      showArrivedDestinationModal: false,
      showFloorChangeModal: false,
      trimIntervalId: null
    };
  },
  created() {
    return __async(this, null, function* () {
      var _a2, _b2, _c;
      this.sweepPucks = [];
      let initMode = null;
      this.$global.sdk.Mode.current.subscribe((mode) => __async(this, null, function* () {
        initMode = initMode || mode;
        if (this.sweepPucks.length === 0 && mode === this.$global.sdk.Mode.Mode.INSIDE) {
          const tmpNode = (yield this.$global.sdk.Scene.createObjects(1))[0].addNode();
          tmpNode.start();
          tmpNode.obj3D.parent.parent.children[3].traverse((node2) => {
            if (node2.sweep) {
              this.sweepPucks.push({ name: node2.name, position: node2.position });
            }
          });
          if (!this.cilbeeStore.startSweep && initMode === this.$global.sdk.Mode.Mode.INSIDE) {
            this.cilbeeStore.startSweep = _clone$1(this.dpmStore.current.sweep);
            this.cilbeeStore.currentBeeSweep = _clone$1(this.dpmStore.current.sweep);
            const deepLink = yield this.$global.sdk.Link.createDeepLink();
            this.cilbeeStore.ss = new URL(deepLink).searchParams.get("ss");
          }
        }
      }));
      this.debug.visible = false;
      this.showcaseDataset = document.querySelector("#showcase").dataset;
      if (this.showcaseDataset.cilbeeForm) {
        this.formFields = JSON.parse(this.showcaseDataset.cilbeeForm);
      }
      if (this.showcaseDataset.privacyPolicy) {
        this.privacyPolicy = this.showcaseDataset.privacyPolicy;
      }
      if (this.dpmStore.global.enableExtensions.mattertag) {
        (_a2 = this.dpmStore.showcaseEditorData) == null ? void 0 : _a2.mattertags.forEach((mattertag) => {
          if (mattertag.extension && mattertag.extension.type !== "none") {
            this.customMattertagSids.push(mattertag.sid);
          }
        });
      }
      if ((_b2 = this.dpmStore.global.minimap) == null ? void 0 : _b2.data[0].resolution) {
        this.resolution = this.dpmStore.global.minimap.data[0].resolution;
      } else {
        const res = yield axios$1.get(`${this.showcaseDataset.apiUrl}/get_resolution.json`);
        if ((_c = res == null ? void 0 : res.data) == null ? void 0 : _c.resolution) {
          this.resolution = res.data.resolution;
        }
      }
      for (const key in this.dpmStore.global.mattertags) {
        this.mattertagIcons[key] = yield this.dpmStore.createIcon(this.$global.apiUrl, key, `style='width:1.5rem; height:1.5rem; object-fit:contain'`, `style='width: 1.5rem; height: 1.5rem'`);
        this.$global.sdk.Tag.allowAction(key, {
          opening: false,
          navigating: true,
          docking: true
        });
      }
      this.record({ type: "cilbee launch" });
      this.cilbeeStore.$subscribe((mutation, _state) => __async(this, null, function* () {
        var _a3, _b3, _c2;
        if (mutation.type.includes("patch") && ((_a3 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _a3.phase)) {
          switch (mutation.payload.phase) {
            case 1:
              for (const key in this.dpmStore.global.mattertags) {
                this.$global.sdk.Tag.close(key);
                this.$global.sdk.Tag.editOpacity(key, 1);
                this.$global.sdk.Tag.allowAction(key, {
                  opening: false,
                  navigating: true
                });
              }
              this.clearRepeat();
              this.end();
              this.sendForm = false;
              this.beforeDestinationList = false;
              this.beforePhase = 1;
              break;
            case 2:
              break;
            case 3:
              break;
            case 4:
              for (const key in this.dpmStore.global.mattertags) {
                this.$global.sdk.Tag.close(key);
                this.$global.sdk.Tag.editOpacity(key, 0);
                this.$global.sdk.Tag.allowAction(key, {
                  opening: false
                });
              }
              this.cilbeeStore.destinations.forEach((destination) => {
                this.$global.sdk.Tag.editOpacity(destination.mattertagSid, 1);
                this.$global.sdk.Tag.allowAction(destination.mattertagSid, {
                  navigating: false
                });
              });
              this.record({ type: "cilbee preview", start: this.cilbeeStore.startSweep.sid, dests: this.cilbeeStore.destinationSids(), route: this.selectedPassableAreaIndex });
              this.end();
              this.node = yield this.dpmStore.global.scene.sceneObject.addNode();
              this.node.name = "CilbeeNode";
              this.cilbeeStore.minimapRouteLines = [];
              const result2 = this.pathFinder.route(this.cilbeeStore.startSweep.sid, this.cilbeeStore.destinationSids());
              this.routeSearchResult = result2.route;
              let tempRoutes = _clone$1(this.routeSearchResult);
              this.cilbeeStore.destinationRanges = this.cilbeeStore.destinations.map((destination, i2) => {
                return {
                  mattertag: this.dpmStore.getMattertagBySid(destination.mattertagSid),
                  sweeps: this.cilbeeStore.destinations.length - 1 === i2 ? tempRoutes.splice(0, tempRoutes.indexOf(destination.sweep.sid) + 1) : tempRoutes.splice(0, tempRoutes.indexOf(destination.sweep.sid))
                };
              });
              if (this.routeSearchResult.length <= 1) {
                this.showError = true;
                return;
              }
              this.node.addComponent(cilbeeDestinationType, {
                floor: this.cilbeeStore.startSweep.floorInfo.sequence,
                label: this.$t("cilbee.startPoint"),
                position: this.sweepPucks.find((sweepPuck) => sweepPuck.name === this.cilbeeStore.startSweep.sid).position,
                svg: this.$global.utils.SVG.createSvgTag(`mdiMapMarker-#${new Color$2(this.colorNames[0]).getHexString()}`)
              });
              let startIndex = 0;
              let endIndex = 0;
              const passingPoints = [];
              for (let i2 = 0; i2 < result2.byDest.length; i2++) {
                endIndex += result2.byDest[i2].length - 1;
                if (i2 !== result2.byDest.length - 1) {
                  passingPoints.push(endIndex);
                } else {
                  endIndex++;
                }
                const sweeps = [];
                for (let j = 0; j < result2.byDest[i2].length; j++) {
                  sweeps.push({
                    floor: this.dpmStore.global.sweeps[result2.byDest[i2][j]].floorInfo.sequence,
                    position: this.sweepPucks.find((sweepPuck) => sweepPuck.name === result2.byDest[i2][j]).position
                  });
                }
                this.node.addComponent(cilbeeRouteLineType, {
                  colorIndex: i2 + 1,
                  endIndex,
                  startIndex,
                  sweeps
                });
                const destSid = result2.byDest[i2][result2.byDest[i2].length - 1];
                const iconName = i2 === result2.byDest.length - 1 ? "mdiFlagCheckered" : "mdiFlag";
                const color2 = `#${new Color$2(this.colorNames[(i2 + 1) % 12]).getHexString()}`;
                const targetDestination = this.cilbeeStore.destinations.find((destination) => destination.sweep.sid === destSid);
                targetDestination.color = color2;
                targetDestination.icon = iconName;
                this.node.addComponent(cilbeeDestinationType, {
                  floor: this.dpmStore.global.sweeps[destSid].floorInfo.sequence,
                  label: ((_b3 = this.dpmStore.getMattertagBySid(this.cilbeeStore.destinations.find((dest) => dest.sweep.sid === destSid).mattertagSid)) == null ? void 0 : _b3.label) || this.$t("cilbee.destination"),
                  position: this.sweepPucks.find((sweepPuck) => sweepPuck.name === destSid).position,
                  svg: this.$global.utils.SVG.createSvgTag(`${iconName}-${color2}`)
                });
                this.cilbeeStore.minimapRouteLines.push({ sids: result2.byDest[i2], color: `#${new Color$2(this.colorNames[(i2 + 1) % 12]).getHexString()}` });
                startIndex = endIndex;
              }
              const beePositions = [];
              for (let i2 = 0; i2 < this.routeSearchResult.length; i2++) {
                beePositions.push(this.sweepPucks.find((sweepPuck) => sweepPuck.name === this.routeSearchResult[i2]).position);
              }
              this.node.addComponent(balloonType, {
                position: beePositions[0],
                store: this.cilbeeStore,
                text: "目的地に到着しました\n次の目的地への案内を\n開始する場合は\n再生ボタンを\nタップして下さい"
              });
              const callback = {
                // 蜂がsweepに到着
                beeArrivedAtSweep: (guidanceProgressIndex, last2) => {
                  var _a4;
                  if (last2) {
                    this.cilbeeStore.$patch({ phase: 6 });
                  }
                  this.cilbeeStore.currentBeeSweep = this.dpmStore.global.sweeps[this.routeSearchResult[guidanceProgressIndex]];
                  this.guidanceProgressIndex = guidanceProgressIndex;
                  this.beeArrivedAtSweep = true;
                  if (this.cilbeeStore.phase === 5 && this.dpmStore.current.mode !== this.$global.sdk.Mode.Mode.INSIDE && this.cilbeeStore.currentBeeSweep.floorInfo.sequence !== ((_a4 = this.dpmStore.current.floor) == null ? void 0 : _a4.sequence)) {
                    this.$global.sdk.Floor.moveTo(this.cilbeeStore.currentBeeSweep.floorInfo.sequence);
                  }
                  this.setObjectOpacity();
                },
                // 蜂のプレビュー
                beeArrivedAtSweepInPreview: (guidanceProgressIndex, last2) => {
                  var _a4;
                  if (last2) {
                    this.repeatTimerId = setTimeout(() => {
                      if (this.cilbeeStore.phase === 4) {
                        this.$global.sdk.Floor.moveTo(this.cilbeeStore.startSweep.floorInfo.sequence).then(() => {
                          this.preview();
                        });
                      }
                    }, 3e3);
                  }
                  this.cilbeeStore.currentBeeSweep = this.dpmStore.global.sweeps[this.routeSearchResult[guidanceProgressIndex]];
                  this.guidanceProgressIndex = guidanceProgressIndex;
                  if (this.cilbeeStore.currentBeeSweep.floorInfo.sequence !== ((_a4 = this.dpmStore.current.floor) == null ? void 0 : _a4.sequence)) {
                    this.$global.sdk.Floor.moveTo(this.cilbeeStore.currentBeeSweep.floorInfo.sequence);
                  }
                  this.setObjectOpacity();
                }
              };
              const beeNode = this.node.addComponent(cilbeeBeeType, { positions: beePositions, callback, passingPoints, store: this.cilbeeStore });
              this.beeId = `cilbee - ${Math.random().toString(32).substring(2)}`;
              beeNode.name = this.beeId;
              this.node.start();
              this.setBalloonVisibility(false);
              this.navigationStartable = false;
              this.$global.sdk.Sweep.moveTo(this.dpmStore.global.sweeps[this.routeSearchResult[0]].sid, {
                transition: this.$global.sdk.Sweep.Transition.INSTANT
              }).then(() => {
                this.$global.sdk.Mode.moveTo(this.$global.sdk.Mode.Mode.DOLLHOUSE, {
                  transition: this.$global.sdk.Sweep.Transition.FLY,
                  transitionTime: 1e3
                }).then(() => {
                  this.$global.sdk.Floor.moveTo(this.cilbeeStore.startSweep.floorInfo.sequence).then(() => {
                    this.preview();
                    this.navigationStartable = true;
                  });
                });
              });
              break;
            case 5:
              this.record({ type: "cilbee guide", start: this.cilbeeStore.startSweep.sid, dests: this.cilbeeStore.destinationSids(), route: this.selectedPassableAreaIndex });
              this.clearRepeat();
              this.reset(true);
              (_c2 = this.getBeeComponent()) == null ? void 0 : _c2.setSpeed(this.speed);
              this.cilbeeStore.currentBeeSweep = this.dpmStore.global.sweeps[this.routeSearchResult[0]];
              break;
            case 6:
              this.toEnd = false;
              this.cilbeeStore.startSweep = this.dpmStore.global.sweeps[this.routeSearchResult[this.routeSearchResult.length - 1]];
              this.cilbeeStore.destinations = [];
              this.cilbeeStore.minimapRouteLines = [];
              if (this.formFields) {
                const intervalId = setInterval(() => __async(this, null, function* () {
                  if (document.querySelector(".dpm-cilbee-form")) {
                    clearInterval(intervalId);
                    document.querySelector(".dpm-cilbee-form").classList.remove("d-none");
                    const form = yield Formio.createForm(document.querySelector(".dpm-cilbee-form"), this.formFields);
                    form.on("submit", (submission) => __async(this, null, function* () {
                      submission.data.cilbee = true;
                      yield axios$1.post(`${this.showcaseDataset.apiUrl}/guestbooks.json`, {
                        guestbook: { form_answer: JSON.stringify(submission.data), showcase_id: this.showcaseDataset.showcaseId },
                        recording_id: this.showcaseDataset.recordingId
                      });
                      document.querySelector(".dpm-cilbee-form").classList.add("d-none");
                      this.sendForm = true;
                    }));
                  }
                }), 100);
              }
              break;
            case 7:
              this.end();
              Object.keys(this.dpmStore.global.mattertags).forEach((sid) => {
                this.$global.sdk.Tag.allowAction(sid, {
                  opening: true,
                  navigating: this.customMattertagSids.includes(sid) ? false : true,
                  docking: true
                });
              });
              break;
            case 8:
              this.dpmStore.$patch({ global: { scan: { text: null, result: null } } });
              this.scanError = false;
              break;
          }
        }
      }));
      this.dpmStore.$subscribe((mutation, _state) => {
        var _a3, _b3, _c2, _d2, _e, _f, _g, _h, _i2, _j, _k, _l;
        if (mutation.type.includes("patch") && ((_b3 = (_a3 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _a3.current) == null ? void 0 : _b3.floor)) {
          this.setObjectOpacity(mutation.payload.current.floor.sequence);
        }
        if (mutation.type.includes("patch") && ((_d2 = (_c2 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _c2.current) == null ? void 0 : _d2.pose)) {
          if (this.getBeeComponent() && (this.dpmStore.current.mode === this.$global.sdk.Mode.Mode.DOLLHOUSE || this.dpmStore.current.mode === this.$global.sdk.Mode.Mode.FLOORPLAN)) {
            const beePosition = this.getBeeComponent().getPosition();
            const beePositionVector = new Vector3(beePosition.x, beePosition.y, beePosition.z);
            const cameraPositionVector = new Vector3(mutation.payload.current.pose.position.x, mutation.payload.current.pose.position.y, mutation.payload.current.pose.position.z);
            const distance = beePositionVector.distanceTo(cameraPositionVector);
            let beeScale = 0.6;
            if (distance > 150) {
              beeScale = 3;
            } else if (distance < 15) {
              beeScale = 0.6;
            } else {
              beeScale = 0.6 + (distance - 15) / (150 - 15) * (3 - 0.6);
            }
            (_e = this.getBeeComponent()) == null ? void 0 : _e.setScale(beeScale);
            this.getDestinationComponents().forEach((dest) => {
              dest.setScale(beeScale * 2);
            });
          }
        }
        if (mutation.type.includes("patch") && ((_g = (_f = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _f.current) == null ? void 0 : _g.mode)) {
          this.cilbeeStore.currentMode = mutation.payload.current.mode;
          const destinations = this.getDestinationComponents();
          if (mutation.payload.current.mode === this.$global.sdk.Mode.Mode.DOLLHOUSE || mutation.payload.current.mode === this.$global.sdk.Mode.Mode.FLOORPLAN) {
            (_h = this.getBeeComponent()) == null ? void 0 : _h.setScale(0.5 * (100 / this.resolution * 0.9));
            destinations.forEach((dest) => {
              dest.setScale(100 / this.resolution);
            });
          } else {
            (_i2 = this.getBeeComponent()) == null ? void 0 : _i2.setScale(0.015);
            destinations.forEach((dest) => {
              dest.setScale(1);
            });
          }
          if ((mutation.payload.current.mode === this.$global.sdk.Mode.Mode.DOLLHOUSE || mutation.payload.current.mode === this.$global.sdk.Mode.Mode.FLOORPLAN) && (this.cilbeeStore.phase === 4 || this.cilbeeStore.phase === 5)) {
            if (this.trimIntervalId) {
              clearInterval(this.trimIntervalId);
            }
            this.trimIntervalId = setInterval(() => {
              this.$global.sdk.Settings.update("Trim floor by(%)", 50);
            }, 1e3);
          } else {
            if (this.trimIntervalId) {
              clearInterval(this.trimIntervalId);
            }
            this.$global.sdk.Settings.update("Trim floor by(%)", 0);
          }
          if (this.cilbeeStore.phase === 5) {
            if (mutation.payload.current.mode === this.$global.sdk.Mode.Mode.INSIDE) {
              this.setCameraRotationToRouteAngle();
            } else {
              this.toEnd = false;
            }
          }
        }
        if (mutation.type.includes("patch") && ((_l = (_k = (_j = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _j.global) == null ? void 0 : _k.scan) == null ? void 0 : _l.text)) {
          if (!this.cilbeeStore.startSweep) {
            this.cilbeeStore.startSweep = _clone$1(this.dpmStore.current.sweep);
          }
          const params = new URL(mutation.payload.global.scan.text).searchParams;
          this.scanData.mattertag = params.get("mattertag");
          this.scanData.sweep = this.dpmStore.global.sweeps[params.get("sweep")];
          this.scanError = !this.scanData.mattertag || !this.scanData.sweep;
        }
      });
      const url = new URL(window.location.href).searchParams;
      const sweepSid = url.get("sweep");
      const mattertagSid = url.get("mattertag");
      if (sweepSid && mattertagSid) {
        const setIntervalId = setInterval(() => {
          if (this.dpmStore.current.sweep) {
            clearInterval(setIntervalId);
            this.cilbeeStore.startSweep = _clone$1(this.dpmStore.current.sweep);
            this.cilbeeStore.currentBeeSweep = _clone$1(this.dpmStore.current.sweep);
            this.cilbeeStore.destinations.push({
              mattertagSid,
              sweep: _clone$1(this.dpmStore.global.sweeps[sweepSid]),
              color: "#00FF00",
              icon: "mdiFlag"
            });
            this.cilbeeStore.$patch({ phase: 4 });
          }
        }, 100);
      }
    });
  },
  mounted() {
    this.cilbeeStore.$patch({ phase: 1 });
    this.pathFinder = new CilbeePathFinder(this.cilbeeStore.currentPassableArea.area, this.dpmStore.global.sweeps);
  },
  methods: {
    startGuidance() {
      return __async(this, null, function* () {
        this.cilbeeStore.$patch({ phase: 5 });
        yield new Promise((resolve2) => {
          let waitInterval = setInterval(() => {
            if (!["mode.dollhouse", "mode.transitioning"].includes(this.dpmStore.current.mode)) {
              clearInterval(waitInterval);
              setTimeout(() => {
                resolve2(true);
              }, 250);
            }
          }, 100);
        });
        this.play();
      });
    },
    toggleLabelVisible() {
      this.cilbeeStore.matterportUiVisibleFlags.label = !this.cilbeeStore.matterportUiVisibleFlags.label;
      this.$global.sdk.Settings.update("features/labels", this.cilbeeStore.matterportUiVisibleFlags.label);
    },
    toggleMattertagVisible() {
      this.cilbeeStore.matterportUiVisibleFlags.tag = !this.cilbeeStore.matterportUiVisibleFlags.tag;
      this.$global.sdk.Settings.update("features/mattertags", this.cilbeeStore.matterportUiVisibleFlags.tag);
    },
    back() {
      var _a2;
      this.beeArrivedAtSweep = false;
      this.moving = true;
      this.toEnd = false;
      (_a2 = this.getBeeComponent()) == null ? void 0 : _a2.setDirection(false);
      const distance = this.pathFinder.getPathFlightDistanceBetweenIndex(this.guidanceProgressIndex, this.guidanceProgressIndex - 1);
      const next = () => {
        var _a3;
        (_a3 = this.getBeeComponent()) == null ? void 0 : _a3.go(false, false);
        this.guidanceProgressIndex--;
        this.moveToSweep(this.routeSearchResult[this.guidanceProgressIndex], distance);
      };
      if (this.dpmStore.current.mode === this.$global.sdk.Mode.Mode.INSIDE) {
        this.setCameraRotationToRouteAngle().then(() => {
          next();
        });
      } else {
        next();
      }
    },
    cancelEditDestination() {
      if (this.beforeDestinationList) {
        this.beforeDestinationList = false;
        this.showDestinationList = true;
        if (this.cilbeeStore.phase !== this.beforePhase) {
          this.cilbeeStore.$patch({ phase: this.beforePhase });
          this.beforePhase = this.cilbeeStore.phase;
        }
      } else {
        this.cilbeeStore.$patch({ phase: 1 });
      }
    },
    changeStartPoint() {
      this.cilbeeStore.startSweep = _clone$1(this.dpmStore.current.sweep);
      this.showConfirmModal = false;
      this.cilbeeStore.$patch({ phase: 1 });
    },
    clearRepeat() {
      if (this.repeatTimerId) {
        clearTimeout(this.repeatTimerId);
        this.repeatTimerId = null;
      }
    },
    closeModalAndMoveToDestination(sid) {
      this.showDestinationList = false;
      this.beforeDestinationList = true;
      this.$global.sdk.Sweep.moveTo(sid);
      this.cilbeeStore.$patch({ phase: 2 });
    },
    changePassableArea(index2) {
      this.selectedPassableAreaIndex = index2;
      this.clearRepeat();
      this.pathFinder = new CilbeePathFinder(this.cilbeeStore.passableAreas[index2].area, this.dpmStore.global.sweeps);
      this.cilbeeStore.$patch({ phase: 4 });
    },
    createLabel() {
      return __async(this, null, function* () {
        var _a2, _b2;
        const target2 = _clone$1(this.dpmStore.getMattertagBySid(this.cilbeeStore.targetMattertagSid));
        if (!target2.anchorPosition && ((_a2 = this.dpmStore.global.mattertags[this.cilbeeStore.targetMattertagSid]) == null ? void 0 : _a2.anchorPosition)) {
          target2.anchorPosition = _clone$1(this.dpmStore.global.mattertags[this.cilbeeStore.targetMattertagSid].anchorPosition);
        }
        if (!target2.stemVector && ((_b2 = this.dpmStore.global.mattertags[this.cilbeeStore.targetMattertagSid]) == null ? void 0 : _b2.stemVector)) {
          target2.stemVector = _clone$1(this.dpmStore.global.mattertags[this.cilbeeStore.targetMattertagSid].stemVector);
        }
        target2.anchorPosition.y += target2.stemVector.y + 0.15;
        this.node = yield this.dpmStore.global.scene.sceneObject.addNode();
        this.node.name = "CilbeeNode";
        this.node.addComponent(labelType, { label: target2.label || this.$t("cilbee.destination"), position: target2.anchorPosition });
        this.node.start();
      });
    },
    debugNavigateToSweep() {
      if (!this.cilbeeStore.startSweep) {
        this.cilbeeStore.startSweep = _clone$1(this.dpmStore.current.sweep);
        this.cilbeeStore.currentBeeSweep = _clone$1(this.dpmStore.current.sweep);
      }
      this.$global.sdk.Sweep.moveTo(this.debug.sweepSid);
      this.cilbeeStore.$patch({ phase: 2 });
    },
    editDestinations(mattertagSid = this.cilbeeStore.targetMattertagSid, sweep = this.dpmStore.current.sweep, fromQr = false) {
      var _a2;
      if (!((_a2 = this.cilbeeStore.startSweep) == null ? void 0 : _a2.sid)) {
        this.cilbeeStore.startSweep = _clone$1(this.dpmStore.current.sweep);
        this.cilbeeStore.$patch({ phase: 1 });
        return;
      }
      const index2 = this.checkAdded(sweep.sid);
      if (index2 === -1) {
        this.cilbeeStore.destinations.push({
          mattertagSid,
          sweep: _clone$1(sweep),
          color: "#00FF00",
          icon: "mdiFlag"
        });
        if (!fromQr) {
          this.cilbeeStore.$patch({ phase: 4 });
        }
      } else {
        this.cilbeeStore.destinations.splice(index2, 1);
        if (!fromQr) {
          this.cilbeeStore.$patch({ phase: 1 });
        }
      }
      if (fromQr) {
        this.resetQr();
      }
    },
    end() {
      var _a2;
      this.showError = false;
      this.reset(false);
      (_a2 = this.node) == null ? void 0 : _a2.stop();
    },
    endQr() {
      this.resetQr();
      this.cilbeeStore.$patch({ phase: 1 });
    },
    getBalloonComponent() {
      if (this.node) {
        for (const component of this.node.componentIterator()) {
          if (component.componentType === balloonType) {
            return component;
          }
        }
      }
      return null;
    },
    getBeeComponent() {
      if (this.node) {
        for (const component of this.node.componentIterator()) {
          if (component.name === this.beeId) {
            return component;
          }
        }
      }
      return null;
    },
    getClosestSweepSid(mattertagSid) {
      const mattertag = this.dpmStore.getMattertagBySid(mattertagSid);
      const targetFloorSweepSids = Object.keys(this.dpmStore.global.sweeps).filter((key) => this.dpmStore.global.sweeps[key].floorInfo.sequence === this.dpmStore.getFloorByMattertag(mattertag).sequence);
      const distances = targetFloorSweepSids.map((key) => {
        const sweepPosition = this.dpmStore.global.sweeps[key].position;
        return Math.sqrt(
          Math.pow(sweepPosition.x - mattertag.anchorPosition.x, 2) + Math.pow(sweepPosition.y - mattertag.anchorPosition.y, 2) + Math.pow(sweepPosition.z - mattertag.anchorPosition.z, 2)
        );
      });
      return targetFloorSweepSids[distances.indexOf(Math.min(...distances))];
    },
    getDestinationComponents() {
      const components = [];
      if (this.node) {
        for (const component of this.node.componentIterator()) {
          if (component.componentType === cilbeeDestinationType) {
            components.push(component);
          }
        }
      }
      return components;
    },
    go() {
      var _a2;
      this.setBalloonVisibility(false);
      this.beeArrivedAtSweep = false;
      this.moving = true;
      (_a2 = this.getBeeComponent()) == null ? void 0 : _a2.setDirection(true);
      const distance = this.pathFinder.getPathFlightDistanceBetweenIndex(this.guidanceProgressIndex, this.guidanceProgressIndex + 1);
      const next = () => {
        var _a3;
        (_a3 = this.getBeeComponent()) == null ? void 0 : _a3.go(true, false);
        this.guidanceProgressIndex++;
        this.moveToSweep(this.routeSearchResult[this.guidanceProgressIndex], distance);
      };
      if (this.dpmStore.current.mode === this.$global.sdk.Mode.Mode.INSIDE) {
        this.setCameraRotationToRouteAngle().then(() => {
          next();
        });
      } else {
        next();
      }
    },
    setCameraRotationToRouteAngle() {
      return __async(this, null, function* () {
        var _a2, _b2;
        const deg = this.dpmStore.current.pose.rotation.y - ((_a2 = this.getBeeComponent()) == null ? void 0 : _a2.getRotationY());
        return this.$global.sdk.Sweep.moveTo(this.routeSearchResult[this.guidanceProgressIndex], {
          rotation: { x: 0, y: ((_b2 = this.getBeeComponent()) == null ? void 0 : _b2.getRotationY()) || 0 },
          transition: this.$global.sdk.Sweep.Transition.FLY,
          transitionTime: Math.abs(deg > 180 ? deg - 360 : deg < -180 ? deg + 360 : deg) * (2e3 / 180)
          // NOTE: 最大角の180度を何ミリ秒で回転するかを基準に時間を求めている
        });
      });
    },
    moveToSweep(sid, distance) {
      const next = () => {
        this.currentPosition = this.guidanceProgressIndex === 0 ? 0 : this.pathFinder.getPathLength(0, this.guidanceProgressIndex);
        const setIntervalId = setInterval(() => {
          if (this.beeArrivedAtSweep) {
            clearInterval(setIntervalId);
            this.moveToSweepNext();
          }
        }, 100);
      };
      if (this.dpmStore.current.mode === this.$global.sdk.Mode.Mode.INSIDE) {
        this.$global.sdk.Sweep.moveTo(sid, {
          transition: this.$global.sdk.Sweep.Transition.FLY,
          transitionTime: distance * 1e3 / this.speed
        }).then(() => {
          next();
        });
      } else {
        next();
      }
    },
    moveToSweepNext() {
      if (this.toEnd && this.guidanceProgressIndex !== this.routeSearchResult.length - 1 && this.guidanceProgressIndex !== 0 && !this.cilbeeStore.destinationSids().includes(this.routeSearchResult[this.guidanceProgressIndex])) {
        if (this.routeSearchResult[this.guidanceProgressIndex + 1] && this.dpmStore.global.sweeps[this.routeSearchResult[this.guidanceProgressIndex]].floorInfo.id !== this.dpmStore.global.sweeps[this.routeSearchResult[this.guidanceProgressIndex + 1]].floorInfo.id) {
          this.setCameraRotationToRouteAngle().then(() => {
            this.moving = false;
            this.showFloorChangeModal = true;
          });
        } else {
          this.go();
        }
      } else if (this.guidanceProgressIndex !== this.routeSearchResult.length - 1 && this.guidanceProgressIndex !== 0 && this.dpmStore.current.mode === this.$global.sdk.Mode.Mode.INSIDE) {
        this.setCameraRotationToRouteAngle().then(() => {
          this.moving = false;
          this.cilbeeStore.destinationRanges.forEach((range) => {
            if (this.dpmStore.current.sweep.sid === range.sweeps[0]) {
              this.showArrivedDestinationModal = true;
            }
          });
        });
      } else {
        this.moving = false;
      }
    },
    next() {
      this.toEnd = false;
      this.go();
    },
    onChangeSlider(val) {
      var _a2;
      const result2 = this.pathFinder.getClosestIndexFromProgression(val);
      this.currentPosition = result2.distance;
      this.guidanceProgressIndex = result2.index;
      this.cilbeeStore.currentBeeSweep = this.dpmStore.global.sweeps[this.routeSearchResult[this.guidanceProgressIndex]];
      (_a2 = this.getBeeComponent()) == null ? void 0 : _a2.goToIndex(this.guidanceProgressIndex);
      if (this.dpmStore.current.mode === this.$global.sdk.Mode.Mode.INSIDE) {
        this.$global.sdk.Sweep.moveTo(this.routeSearchResult[this.guidanceProgressIndex], {
          transition: this.$global.sdk.Sweep.Transition.INSTANT,
          transitionTime: 500
        }).then(() => {
          this.moveToSweepNext();
        });
      } else {
        if (this.cilbeeStore.currentBeeSweep.floorInfo.sequence !== this.dpmStore.current.floor.sequence) {
          this.$global.sdk.Floor.moveTo(this.cilbeeStore.currentBeeSweep.floorInfo.sequence);
        }
        this.moveToSweepNext();
      }
    },
    pause() {
      this.toEnd = false;
    },
    play() {
      this.toEnd = true;
      this.go();
    },
    preview() {
      var _a2, _b2;
      this.reset(false);
      this.cilbeeStore.currentBeeSweep = this.dpmStore.global.sweeps[this.routeSearchResult[0]];
      (_a2 = this.getBeeComponent()) == null ? void 0 : _a2.setSpeed(this.speed * (100 / this.resolution));
      (_b2 = this.getBeeComponent()) == null ? void 0 : _b2.go(true, true);
    },
    record(data) {
      if (this.showcaseDataset.apiUrl && this.showcaseDataset.recordingId) {
        axios$1.post(`${this.showcaseDataset.apiUrl}/recordings/${this.showcaseDataset.recordingId}/events.json`, {
          event: { recording_id: this.showcaseDataset.recordingId, data: JSON.stringify({ cilbee: data }) }
        });
      }
    },
    replay() {
      if (this.dpmStore.current.mode === this.$global.sdk.Mode.Mode.INSIDE) {
        this.reset(true);
      } else {
        this.reset(false);
      }
    },
    reset(move) {
      var _a2;
      this.currentPosition = 0;
      this.beeArrivedAtSweep = false;
      this.moving = false;
      this.cilbeeStore.currentBeeSweep = null;
      this.guidanceProgressIndex = 0;
      this.toEnd = false;
      (_a2 = this.getBeeComponent()) == null ? void 0 : _a2.reset();
      this.setObjectOpacity();
      if (move) {
        this.setCameraRotationToRouteAngle();
      }
    },
    resetQr() {
      this.scanData.mattertag = null;
      this.scanData.sweep = null;
      this.$refs.qr.init();
    },
    // selectSpeed(data) {
    //   this.speed = data
    //   this.getBeeComponent()?.setSpeed(data)
    // },
    setBalloonText(text2) {
      var _a2;
      (_a2 = this.getBalloonComponent()) == null ? void 0 : _a2.updateText(text2);
    },
    setBalloonVisibility(visible) {
      var _a2;
      (_a2 = this.getBalloonComponent()) == null ? void 0 : _a2.setVisibility(visible);
    },
    setObjectOpacity(floor = ((_i2) => (_i2 = this.dpmStore.current.floor) == null ? void 0 : _i2.sequence)()) {
      if (floor === void 0) {
        return;
      }
      if (this.node) {
        for (const component of this.node.componentIterator()) {
          if (component.componentType === cilbeeRouteLineType) {
            component.setOpacity(floor, component.inputs.startIndex <= this.guidanceProgressIndex && this.guidanceProgressIndex <= component.inputs.endIndex - 1);
          }
          if (component.componentType === cilbeeDestinationType) {
            component.setOpacity(floor);
          }
        }
      }
    },
    showDestinationListModal() {
      this.beforePhase = this.cilbeeStore.phase;
      this.showDestinationList = true;
    }
  },
  computed: __spreadProps(__spreadValues({}, mapStores(useDpmStore, useCilbeeStore, matterportStore)), {
    nextDestinationLabel() {
      if (this.cilbeeStore.destinationRanges.length && this.cilbeeStore.currentBeeSweep) {
        if (this.routeSearchResult[0] === this.cilbeeStore.currentBeeSweep) {
          return this.cilbeeStore.destinationRanges[0].mattertag.label;
        } else if (this.routeSearchResult[this.routeSearchResult.length - 1] === this.cilbeeStore.currentBeeSweep.sid) {
          return "案内終了";
        } else {
          return this.cilbeeStore.destinationRanges.find((destinationRange) => destinationRange.sweeps.includes(this.cilbeeStore.currentBeeSweep.sid)).mattertag.label;
        }
      } else {
        return "";
      }
    },
    previousDestinationLabel() {
      if (this.nextDestinationLabel && this.nextDestinationLabel !== "案内終了") {
        let currentDestinationRangeIndex = this.cilbeeStore.destinationRanges.findIndex((destinationRange) => destinationRange.mattertag.label === this.nextDestinationLabel);
        if (currentDestinationRangeIndex) {
          return this.cilbeeStore.destinationRanges[currentDestinationRangeIndex - 1].mattertag.label;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    checkAdded() {
      return (sid = this.dpmStore.current.sweep.sid) => {
        return this.cilbeeStore.destinations.findIndex((destination) => destination.sweep.sid === sid);
      };
    },
    selectablePassableAreas() {
      const visiblePassableAreas = [];
      for (let i2 = 0; i2 < this.cilbeeStore.passableAreas.length; i2++) {
        const pa = this.cilbeeStore.passableAreas[i2];
        if (pa.visible) {
          visiblePassableAreas.push({ text: pa.name, value: i2 });
        }
      }
      return visiblePassableAreas;
    }
  })
};
const __cssModules$v = {};
var __component__$v = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$v,
  render$v,
  staticRenderFns$v,
  false,
  __vue2_injectStyles$v,
  null,
  null,
  null
);
function __vue2_injectStyles$v(context) {
  for (let o in __cssModules$v) {
    this[o] = __cssModules$v[o];
  }
}
const CilbeeApp = /* @__PURE__ */ function() {
  return __component__$v.exports;
}();
var render$u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.dpmStore.current.extension ? _c("div", [_vm.dpmStore.current.extension.type !== "images" && _vm.dpmStore.current.extension.type !== "audio" && !_vm.dpmStore.current.extension.data.floatingPosition ? _c("v-dialog", {
    attrs: {
      "scrollable": "",
      "content-class": `m-3 dpm-extension-modal ${_vm.useFullHeight ? "h-100" : ""}`,
      "max-width": `${_vm.useMaxWidth ? _vm.dpmStore.current.extension.maxWidth : ""}`,
      "eager": ""
    },
    model: {
      value: _vm.dialog,
      callback: function($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c("v-card", [_c("v-card-text", {
    staticClass: "p-3"
  }, [_vm.mediaHtml ? _c("div", {
    staticClass: "media-wrapper",
    class: {
      "h-100": _vm.useFullHeight
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mediaHtml)
    }
  }) : _vm._e(), _vm.useHtml ? _c("div", {
    staticClass: "quill-editor-wrapper"
  }, [_c("div", {
    staticClass: "ql-container ql-snow border-0",
    attrs: {
      "id": "quill-editor"
    }
  }, [_c("div", {
    staticClass: "ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.dpmStore.current.extension.data.htmlText)
    }
  })])]) : _vm._e(), _vm.dpmStore.current.extension && _vm.dpmStore.current.extension.type === "pdf" ? _c("div", {
    staticClass: "iframe-wrapper"
  }, [_c("iframe", {
    staticClass: "pdf",
    attrs: {
      "src": _vm.pdfSrc,
      "height": "100%",
      "scrolling": "no",
      "frameborder": "0",
      "allow": "fullscreen; picture-in-picture"
    }
  })]) : _vm._e(), _vm.dpmStore.current.extension && _vm.dpmStore.current.extension.type === "panorama" ? _c("div", {
    staticClass: "panorama-wrapper",
    class: {
      "is-fake-fullscreen": _vm.panoramaFullscreen
    }
  }, [_c("div", {
    staticClass: "media-wrapper"
  }, [_c("iframe", {
    ref: "iframePanoramaRef",
    staticClass: "panorama",
    attrs: {
      "src": _vm.panoramaSrc,
      "height": "100%",
      "scrolling": "no",
      "frameborder": "0",
      "allow": "fullscreen"
    },
    on: {
      "load": _vm.startObserving
    }
  })])]) : _vm._e(), _vm.errorText ? _c("div", [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()])], 1), _c("div", {
    staticClass: "dialog-operations d-flex flex-md-column w-auto mt-2 mt-md-0"
  }, [_c("v-btn", {
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false;
      }
    }
  }, [_c("v-icon", {
    attrs: {
      "color": "white"
    }
  }, [_vm._v(" " + _vm._s(_vm.$global.icons.mdiClose))])], 1), _vm.dpmStore.current.extension && _vm.dpmStore.current.extension.type === "panorama" ? _c("v-btn", {
    staticClass: "mt-0 mt-md-2",
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": _vm.openPanoramaTab
    }
  }, [_c("v-icon", {
    attrs: {
      "color": "white"
    }
  }, [_vm._v(" " + _vm._s(_vm.$global.icons.mdiOpenInNew))])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm.bgmHtml ? _c("div", {
    staticClass: "floating-bgm-content"
  }, [_c("div", {
    staticClass: "content-wrapper"
  }, [_c("div", {
    staticClass: "media-wrapper",
    domProps: {
      "innerHTML": _vm._s(_vm.bgmHtml)
    }
  })])]) : _vm._e(), _vm.dpmStore.current.extension.data.floatingPosition || _vm.dpmStore.current.extension.type === "audio" ? _c("div", {
    staticClass: "floating-content",
    style: _vm.floationgStyle
  }, [_c("div", {
    staticClass: "content-wrapper"
  }, [_c("div", {
    staticClass: "media-wrapper mb-1",
    style: _vm.floationgMediaWrapperStyle,
    domProps: {
      "innerHTML": _vm._s(_vm.mediaHtml)
    }
  }), _c("v-btn", {
    style: _vm.activeStorageVideo ? _vm.floationgButtonStyle : false,
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": _vm.closeExtension
    }
  }, [_c("v-icon", {
    attrs: {
      "color": "white"
    }
  }, [_vm._v(" " + _vm._s(_vm.$global.icons.mdiClose))])], 1)], 1)]) : _vm._e(), _c("CoolLightBox", {
    attrs: {
      "items": _vm.imageUrls,
      "index": _vm.lightboxIndex,
      "useZoomBar": true,
      "thumbsPosition": "bottom",
      "showThumbs": true
    },
    on: {
      "close": _vm.closeExtension
    }
  })], 1) : _vm._e();
};
var staticRenderFns$u = [];
const __vue2_script$u = {
  components: { CoolLightBox },
  data() {
    return initialState$4();
  },
  created() {
    this.observer = null;
    this.$global.sdk.on(this.$global.sdk.Mattertag.Event.CLICK, (tagSid) => {
      var _a2;
      this.dpmStore.$patch({ current: { mattertagSid: tagSid } });
      if (((_a2 = this.dpmStore.currentEditMattertag) == null ? void 0 : _a2.extension) && this.dpmStore.currentEditMattertag.extension.type !== "none") {
        this.dpmStore.$patch({ current: { extension: this.dpmStore.currentEditMattertag.extension } });
      } else {
        this.closeExtension();
      }
    });
    this.$global.sdk.on(this.$global.sdk.Sweep.Event.ENTER, (oldSweepSid, newSweepSid) => {
      var _a2, _b2;
      if (oldSweepSid === newSweepSid) {
        return;
      }
      const oldGroupIndex = this.dpmStore.currentSweepGroupIndex;
      this.dpmStore.$patch({ current: { sweepSid: newSweepSid } });
      if (this.dpmStore.global.activeSweepExtension && ((_a2 = this.dpmStore.currentSweepGroup) == null ? void 0 : _a2.extension) && ((_b2 = this.dpmStore.currentSweepGroup) == null ? void 0 : _b2.extension.type) !== "none") {
        if (oldGroupIndex === -1 || oldGroupIndex !== this.dpmStore.currentSweepGroupIndex) {
          this.dpmStore.$patch({ current: { extension: this.dpmStore.currentSweepGroup.extension } });
        }
      } else {
        this.closeExtension();
      }
    });
    this.$global.sdk.on(this.$global.sdk.Sweep.Event.EXIT, (_fromSweep, _toSweep) => {
      if (this.dpmStore.current.mattertagSid) {
        this.closeExtension();
      }
    });
    this.dpmStore.$subscribe((mutation, _state) => __async(this, null, function* () {
      var _a2, _b2, _c, _d2, _e;
      if (mutation.type.includes("patch") && ((_b2 = (_a2 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _a2.current) == null ? void 0 : _b2.extension)) {
        Object.assign(this.$data, initialState$4());
        const data = this.dpmStore.current.extension.data;
        switch (this.dpmStore.current.extension.type) {
          case "iframe":
            this.mediaHtml = `<iframe src='${data.iframeSrc}'></iframe>`;
            break;
          case "video":
            if (data.video.indexOf("active_storage") !== -1) {
              this.activeStorageVideo = true;
              const res2 = yield this.getMediaUrl("mattertag_videos", data.video.split(":")[1]);
              if (res2) {
                this.mediaHtml = `<video src='${res2}' controls ${data.autoPlayVideo ? "autoplay" : ""}></video>`;
              }
            } else {
              this.activeStorageVideo = false;
              this.mediaHtml = yield this.getMediaElement(data.video, data.autoPlayVideo, false, "video");
            }
            this.stopBgm();
            break;
          case "audio":
            this.mediaHtml = yield this.getAudioElement(data.audio, data.autoPlayAudio);
            this.stopBgm();
            break;
          case "link":
            window.open(this.dpmStore.current.extension.data.linkAddress, "_blank").focus();
            return;
          case "panorama":
            this.panoramaSrc = `${this.$global.apiUrl}/show_panorama?file_id=${data.panorama.split(":")[1]}`;
            break;
          case "images":
            this.imageUrls = yield this.getExtensionImageUrls();
            this.lightboxIndex = 0;
            break;
          case "pdf":
            const res = yield this.getMediaUrl("mattertag_images", data.pdf.split(":")[1]);
            this.pdfSrc = `/pdfjs-2.13.216-dist/web/viewer.html?file=${res}`;
            break;
        }
        if (data.useAsBgm && this.dpmStore.current.extension.type !== "video" && this.dpmStore.current.extension.type !== "audio") {
          this.bgmHtml = yield this.getAudioElement(data.audio, data.autoPlayAudio);
          this.stopBgm();
        }
        if (mutation.payload.current.extension.type !== "images" && mutation.payload.current.extension.type !== "audio" && !((_c = mutation.payload.current.extension.data) == null ? void 0 : _c.floatingPosition)) {
          this.dialog = true;
        }
      }
      if (mutation.type.includes("patch") && ((_e = (_d2 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _d2.current) == null ? void 0 : _e.extension) === null) {
        Object.assign(this.$data, initialState$4());
      }
    }));
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  computed: __spreadProps(__spreadValues({}, mapStores(useDpmStore)), {
    useFullHeight() {
      return this.dpmStore.current.extension && this.dpmStore.current.extension.type === "iframe";
    },
    useMaxWidth() {
      return !this.useFullHeight && this.dpmStore.current.extension && this.dpmStore.current.extension.maxWidth;
    },
    useHtml() {
      return this.dpmStore.current.extension && this.dpmStore.current.extension.type === "html";
    },
    floationgButtonStyle() {
      var _a2;
      return `margin-top: ${((_a2 = this.dpmStore.current.extension) == null ? void 0 : _a2.maxHeight) ? this.dpmStore.current.extension.maxHeight / this.floationgContentWidth * 100 : 56.25}%`;
    },
    floationgContentWidth() {
      var _a2;
      return ((_a2 = this.dpmStore.current.extension) == null ? void 0 : _a2.maxWidth) ? this.dpmStore.current.extension.maxWidth : 320;
    },
    floationgMediaWrapperStyle() {
      var _a2;
      return `padding-top: ${this.activeStorageVideo ? 0 : ((_a2 = this.dpmStore.current.extension) == null ? void 0 : _a2.maxHeight) ? this.dpmStore.current.extension.maxHeight / this.floationgContentWidth * 100 : 56.25}%`;
    },
    floationgStyle() {
      const getFlexStyle = (justify, align) => {
        return `justify-content: ${justify}; align-items: ${align}`;
      };
      if (this.dpmStore.current.extension.type === "audio" || this.bgmHtml) {
        return getFlexStyle("left", "end");
      }
      switch (this.dpmStore.current.extension.data.floatingPosition) {
        case "upperLeft":
          return getFlexStyle("left", "start");
        case "upperCenter":
          return getFlexStyle("center", "start");
        case "upperRight":
          return getFlexStyle("right", "start");
        case "left":
          return getFlexStyle("left", "center");
        case "center":
          return getFlexStyle("center", "center");
        case "right":
          return getFlexStyle("right", "center");
        case "lowerLeft":
          return getFlexStyle("left", "end");
        case "lowerCenter":
          return getFlexStyle("center", "end");
        case "lowerRight":
          return getFlexStyle("right", "end");
      }
    }
  }),
  watch: {
    dialog(visible) {
      if (!visible) {
        this.closeExtension();
      }
    }
  },
  methods: {
    startObserving() {
      const iframe = this.$refs.iframePanoramaRef;
      if (!iframe)
        return;
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      const iframeBody = iframeDoc.body;
      this.checkClass(iframeBody);
      if (this.observer) {
        this.observer.disconnect();
      }
      this.observer = new MutationObserver(() => {
        this.checkClass(iframeBody);
      });
      this.observer.observe(iframeBody, {
        attributes: true,
        attributeFilter: ["class"]
      });
    },
    checkClass(el) {
      this.panoramaFullscreen = el.classList.contains("is-fake-fullscreen");
    },
    stopBgm() {
      this.dpmStore.$patch({ global: { bgm: { isPlaying: false, beforeState: this.dpmStore.global.bgm.isPlaying } } });
    },
    closeExtension() {
      this.dpmStore.$patch({
        current: { extension: null },
        global: { bgm: { isPlaying: this.dpmStore.global.bgm.beforeState } }
      });
      Object.assign(this.$data, initialState$4());
    },
    getAudioElement(src, autoPlay) {
      return __async(this, null, function* () {
        let element = null;
        if (src.indexOf("active_storage") !== -1) {
          const res = yield this.getMediaUrl("mattertag_audios", src.split(":")[1]);
          if (res) {
            element = `<audio class='w-100' src='${res}' loop controls ${autoPlay ? "autoplay" : ""}></audio>`;
          }
        } else {
          element = yield this.getMediaElement(src, autoPlay, true, "audio");
        }
        return `${element}`;
      });
    },
    getMediaElement(src, autoPlay, miniPlayer, type) {
      return __async(this, null, function* () {
        const res = yield this.$global.utils.getMediaHtml(src, type, { autoPlay, miniPlayer });
        if (res.error) {
          this.errorText = res.error;
          return null;
        }
        return res.html;
      });
    },
    getMediaUrl(type, id) {
      return __async(this, null, function* () {
        this.errorText = null;
        return axios$1.get(
          `${this.$global.apiUrl}/get_media_url?type=${type}&file_id=${id}`
        ).then((res) => {
          return res.data.url;
        }).catch((err2) => {
          this.errorText = err2.response.data.error || err2;
        });
      });
    },
    getExtensionImageUrls() {
      return __async(this, null, function* () {
        let urls = yield Promise.all(this.dpmStore.current.extension.data.images.map((image) => __async(this, null, function* () {
          if (image.src.indexOf("active_storage") !== -1) {
            const res = yield this.getMediaUrl("mattertag_images", image.src.split(":")[1]);
            if (res) {
              return { title: image.title, description: image.description, src: res };
            }
          } else {
            return image;
          }
        })));
        return urls;
      });
    },
    openPanoramaTab() {
      window.open(`${this.$global.apiUrl}/show_panorama?file_id=${this.dpmStore.current.extension.data.panorama.split(":")[1]}`, "_blank").focus();
    }
  }
};
const initialState$4 = () => {
  return {
    activeStorageVideo: false,
    bgmHtml: null,
    dialog: false,
    errorText: null,
    imageUrls: [],
    lightboxIndex: null,
    mediaHtml: null,
    panoramaFullscreen: false,
    panoramaSrc: null,
    pdfSrc: null
  };
};
const __cssModules$u = {};
var __component__$u = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$u,
  render$u,
  staticRenderFns$u,
  false,
  __vue2_injectStyles$u,
  null,
  null,
  null
);
function __vue2_injectStyles$u(context) {
  for (let o in __cssModules$u) {
    this[o] = __cssModules$u[o];
  }
}
const DpmExtensions = /* @__PURE__ */ function() {
  return __component__$u.exports;
}();
var render$t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.matterportStore.dockOpen ? _c("div", {
    staticClass: "pe-auto",
    attrs: {
      "id": "dpm-mattertag-group-list-drawer"
    }
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref) {
        var on2 = _ref.on;
        return [_c("v-btn", _vm._g({
          staticClass: "dpm-mattertag-group-list-drawer-button",
          attrs: {
            "fab": "",
            "small": "",
            "elevation": "0",
            "color": "white"
          },
          on: {
            "click": _vm.changeDrawer
          }
        }, on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiFormatListText))])], 1)];
      }
    }], null, false, 2553170195)
  }, [_c("span", [_vm._v("タグリスト")])]), _c("v-navigation-drawer", {
    attrs: {
      "width": "400px",
      "absolute": "",
      "right": !_vm.isBottom,
      "bottom": _vm.isBottom,
      "hide-overlay": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function() {
        return [_c("v-list-item", {
          staticClass: "ps-4 pe-2 py-2",
          style: `background-color:${_vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title.bg_color}`
        }, [_c("v-list-item-content", {
          staticClass: "p-0"
        }, [_c("v-list-item-title", [_vm.hasGroupListTitleImage ? _c("v-img", {
          attrs: {
            "src": _vm.groupListTitle,
            "contain": "",
            "position": "center left",
            "max-width": "316",
            "max-height": "50"
          }
        }) : _c("span", [_vm._v(_vm._s(_vm.groupListTitle))])], 1)], 1), _c("v-list-item-action", [_c("v-btn", {
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.changeDrawer
          }
        }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))])], 1)], 1)], 1)];
      },
      proxy: true
    }], null, false, 2218242336),
    model: {
      value: _vm.dpmStore.global.groupListDrawer.expand,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.global.groupListDrawer, "expand", $$v);
      },
      expression: "dpmStore.global.groupListDrawer.expand"
    }
  }, [_c("GroupList", {
    attrs: {
      "useBy": "drawer"
    }
  })], 1)], 1) : _vm._e();
};
var staticRenderFns$t = [];
const __vue2_script$t = {
  components: { GroupList },
  data() {
    return {
      errorText: "エラーが発生しました。",
      groupListTitle: "Tags",
      isBottom: false,
      selectedLanguage: "default"
      // TODO: 独自UIを作成の時に多言語対応するかもしれないけれど、今はdefaultを使用する。
    };
  },
  computed: __spreadProps(__spreadValues({}, mapStores(useDpmStore, matterportStore)), {
    hasGroupListTitleImage() {
      return this.dpmStore.SED.ui[this.selectedLanguage].group_list_title && this.dpmStore.SED.ui[this.selectedLanguage].group_list_title.image && (this.dpmStore.SED.ui[this.selectedLanguage].group_list_title.image.active_storage_id || this.dpmStore.SED.ui[this.selectedLanguage].group_list_title.image.url);
    }
  }),
  created() {
    return __async(this, null, function* () {
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
      const title = this.dpmStore.SED.ui[this.selectedLanguage].group_list_title;
      if (title) {
        if (this.hasGroupListTitleImage) {
          if (title.image.active_storage_id) {
            const src = yield this.getGroupListTitleImageUrl(title.image.active_storage_id);
            if (src) {
              this.groupListTitle = src;
            }
          } else {
            this.groupListTitle = title.image.url;
          }
        } else {
          this.groupListTitle = title.text ? title.text : "Tags";
        }
      }
      if (this.matterportStore.iframeSize.width <= 487 || this.dpmStore.global.showCilbee && !this.dpmStore.global.showShowcaseEditor) {
        this.dpmStore.global.groupListDrawer.expand = false;
      }
    });
  },
  methods: {
    changeDrawer() {
      this.dpmStore.$patch({ global: { groupListDrawer: { expand: !this.dpmStore.global.groupListDrawer.expand } } });
    },
    getGroupListTitleImageUrl(id) {
      return __async(this, null, function* () {
        const res = yield axios$1.get(`${this.$global.apiUrl}/get_media_url?type=group_list_title_image&file_id=${id}`);
        if (!res || res.data.status === 404) {
          this.groupListTitle.innerHTML = `<span class='text-danger'>${res.error || this.errorText}</span>`;
          return null;
        }
        return res.data.url;
      });
    },
    handleResize() {
      this.isBottom = this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    }
  }
};
const __cssModules$t = {};
var __component__$t = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$t,
  render$t,
  staticRenderFns$t,
  false,
  __vue2_injectStyles$t,
  null,
  null,
  null
);
function __vue2_injectStyles$t(context) {
  for (let o in __cssModules$t) {
    this[o] = __cssModules$t[o];
  }
}
const MattertagGroupListDrawer = /* @__PURE__ */ function() {
  return __component__$t.exports;
}();
const createRouteLine = (width, point1, point2, color2) => {
  const line = {};
  const p1 = {
    x: width - point1.right,
    y: point1.top
  };
  const p2 = {
    x: width - point2.right,
    y: point2.top
  };
  const a = p1.x - p2.x;
  const b = p1.y - p2.y;
  const length = Math.sqrt(a * a + b * b);
  const angleDeg = Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI;
  line.width = length;
  line.left = p1.x;
  line.top = p1.y;
  line.degree = angleDeg;
  line.id = `${point1.sid}-${point2.sid}`;
  line.color = color2;
  return line;
};
var render$s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !(_vm.matterportStore.dockOpen || _vm.matterportStore.hideDpm) ? _c("div", {
    staticClass: "dpm-minimap-component pe-none"
  }, [_c("div", {
    staticClass: "df align-items-end pe-auto",
    attrs: {
      "id": "minimap-always-show-area"
    }
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref) {
        var on2 = _ref.on;
        return [_c("v-btn", _vm._g({
          attrs: {
            "id": "minimap-toggle-btn",
            "fab": "",
            "small": "",
            "elevation": "0",
            "color": "white"
          },
          on: {
            "click": _vm.toggleMinimap
          }
        }, on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiMapOutline))])], 1)];
      }
    }], null, false, 112380096)
  }, [_c("span", [_vm._v(_vm._s(_vm.dpmStore.global.minimap.menu.expand ? "閉じる" : "開く"))])])], 1), _c("v-slide-x-reverse-transition", {
    on: {
      "enter": function($event) {
        return _vm.setImageMargin(true, true);
      },
      "after-enter": function($event) {
      }
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dpmStore.global.minimap.menu.expand,
      expression: "dpmStore.global.minimap.menu.expand"
    }],
    staticClass: "minimap-content df mt-2"
  }, [_c("div", {
    staticClass: "map-area"
  }, [_vm.currentFloorData ? _c("div", {
    staticClass: "floor-name-wrapper position-absolute"
  }, [_c("div", {
    staticClass: "floor-name p-2"
  }, [_vm._v(_vm._s(_vm.currentFloorData.name))])]) : _vm._e(), _c("div", {
    ref: "imageContainer",
    staticClass: "info-wrapper pe-auto",
    style: `width: ${_vm.width + _vm.wrapperPadding * 2}px; height: ${_vm.height + _vm.wrapperPadding * 2}px;`,
    attrs: {
      "dragging": _vm.dragging
    }
  }, [_c("img", {
    staticClass: "d-none",
    attrs: {
      "src": _vm.dpmStore.global.minimap.data[_vm.currentFloor] ? _vm.dpmStore.global.minimap.data[_vm.currentFloor].url : ""
    },
    on: {
      "error": _vm.getMinimapData
    }
  }), _c("div", {
    ref: "minimapInfo",
    staticClass: "minimap-info",
    style: `width: ${_vm.width}px; height: ${_vm.height}px; background-image: url(${_vm.dpmStore.global.minimap.data[_vm.currentFloor] ? _vm.dpmStore.global.minimap.data[_vm.currentFloor].url : ""}); transform-origin: center; transform: scale(${_vm.currentZoomLevel}) rotate(${_vm.dpmStore.showcaseEditorData.minimap_rotate}deg); margin: ${_vm.imageMargin.y}px ${_vm.imageMargin.x}px`
  }, [_c("div", {
    staticClass: "cilbee-route"
  }, _vm._l(_vm.routeLines, function(line, i2) {
    return _c("div", {
      key: `minimap-line-${line.id}-${line.color}`,
      staticClass: "line",
      style: `width: ${line.width}px; left: ${line.left}px; top: ${line.top}px; transform: rotate(${line.degree}deg);  background-color: ${line.color};`
    });
  }), 0), _c("div", {
    staticClass: "sweep-info",
    style: `opacity: ${_vm.dpmStore.global.minimap.menu.sweep ? "100%" : "0%"}`
  }, [_c("div", {
    staticClass: "sweeps",
    staticStyle: {
      "opacity": "50%"
    }
  }, [_vm._l(_vm.defaultSweeps, function(sweep) {
    return [!_vm.dpmStore.current.sweep || sweep.sid !== _vm.dpmStore.current.sweep.sid ? _c("div", {
      key: sweep.sid,
      staticClass: "minimap-sweep-button position-absolute",
      style: `width: ${_vm.sweepButtonSize}px; height: ${_vm.sweepButtonSize}px; right: ${sweep.right - _vm.sweepButtonSize / 2}px; top: ${sweep.top - _vm.sweepButtonSize / 2}px; border: ${_vm.sweepButtonSize * 0.1}px solid #fff`,
      on: {
        "click": function($event) {
          return _vm.onClickSweep(sweep.sid);
        }
      }
    }) : _vm._e()];
  })], 2), _vm.dpmStore.global.enableExtensions && _vm.dpmStore.global.enableExtensions.sweep ? _c("div", {
    staticClass: "grouped-sweeps"
  }, [_vm._l(_vm.currentFloorGroupedSweeps, function(sweepGroup, i2) {
    return _vm._l(sweepGroup, function(sweep) {
      return _c("v-btn", {
        key: `${sweep.sid}-active`,
        staticClass: "position-absolute",
        style: `right: ${sweep.right - _vm.highlightPointSize / 2}px; top: ${sweep.top - _vm.highlightPointSize / 2}px`,
        attrs: {
          "fab": "",
          "dark": "",
          "x-small": "",
          "elevation": "0",
          "width": _vm.highlightPointSize,
          "height": _vm.highlightPointSize,
          "color": _vm.dpmStore.SED.sweep_groups[i2].colorless ? "transparent" : _vm.dpmStore.SED.sweep_groups[i2].color
        },
        on: {
          "click": function($event) {
            return _vm.onClickSweep(sweep.sid);
          }
        }
      }, [_c("v-icon", {
        style: `border: ${_vm.highlightPointSize * 0.1}px white solid; border-radius: 50%`,
        attrs: {
          "color": _vm.dpmStore.SED.sweep_groups[i2].colorless ? "transparent" : _vm.dpmStore.SED.sweep_groups[i2].color,
          "size": _vm.highlightPointSize
        }
      }, [_vm._v(_vm._s(_vm.$global.icons.mdiCircle))])], 1);
    });
  })], 2) : _vm._e(), _vm.dpmStore.global.enableExtensions && _vm.dpmStore.global.enableExtensions.sweep ? _c("div", {
    staticClass: "edited-sweeps"
  }, [_vm._l(_vm.currentFloorSweeps, function(sweep) {
    return [(_vm.extensionData = _vm.dpmStore.SED.sweeps.find(function(s2) {
      return s2.sid === sweep.sid;
    })) ? _c("v-btn", {
      key: `${sweep.sid}-edited`,
      staticClass: "position-absolute",
      style: `right: ${sweep.right - _vm.highlightPointSize / 2}px; top: ${sweep.top - _vm.highlightPointSize / 2}px; transform: rotate(${_vm.extensionData.degree}deg);`,
      attrs: {
        "fab": "",
        "dark": "",
        "x-small": "",
        "elevation": "0",
        "width": _vm.highlightPointSize,
        "height": _vm.highlightPointSize,
        "color": _vm.extensionData.colorless ? "transparent" : _vm.extensionData.bgColor
      },
      on: {
        "click": function($event) {
          return _vm.onClickSweep(sweep.sid);
        }
      }
    }, [_c("v-icon", {
      style: `border: ${_vm.highlightPointSize * 0.1}px white solid; border-radius: 50%`,
      attrs: {
        "color": _vm.extensionData.icon.color,
        "size": _vm.highlightPointSize
      }
    }, [_vm._v(_vm._s(_vm.$global.icons[_vm.extensionData.icon.id]))])], 1) : _vm._e()];
  })], 2) : _vm._e()]), _c("div", {
    staticClass: "mattertags",
    style: `opacity: ${_vm.dpmStore.global.minimap.menu.mattertag ? "100%" : "0%"}`
  }, _vm._l(_vm.currentFloorMattertags, function(mattertag) {
    return _c("v-tooltip", {
      key: mattertag.sid,
      attrs: {
        "bottom": "",
        "disabled": mattertag.label === ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(_ref2) {
          var on2 = _ref2.on;
          return [_c("div", _vm._g({
            staticClass: "minimap-mattertag-button position-absolute",
            style: `width: ${_vm.highlightPointSize}px; height: ${_vm.highlightPointSize}px; right: ${mattertag.right - _vm.highlightPointSize / 2}px; top: ${mattertag.top - _vm.highlightPointSize / 2}px; transform: rotate(-${_vm.dpmStore.showcaseEditorData.minimap_rotate}deg); background-image: url("${mattertag.icon}");`,
            on: {
              "click": function($event) {
                return _vm.onClickMattertag(mattertag.sid);
              }
            }
          }, on2))];
        }
      }], null, true)
    }, [_c("span", [_vm._v(_vm._s(mattertag.label))])]);
  }), 1), _c("v-fade-transition", [_vm.dpmStore.global.minimap.menu.label ? _c("div", {
    staticClass: "labels"
  }, _vm._l(_vm.currentFloorLabels, function(label) {
    return _c("div", {
      key: `label-${label.sid}`,
      staticClass: "label-wrapper position-absolute pe-none df align-items-center justify-content-center",
      style: `right: ${label.right - 64}px; top: ${label.top}px; transform: rotate(-${_vm.dpmStore.showcaseEditorData.minimap_rotate}deg);`
    }, [_c("div", {
      staticClass: "label-text"
    }, [_vm._v(_vm._s(label.text))])]);
  }), 0) : _vm._e()]), _c("div", {
    staticClass: "current-point"
  }, [_vm._l(_vm.currentFloorSweeps, function(sweep) {
    return [_vm.dpmStore.current.sweep && _vm.dpmStore.current.sweep.sid === sweep.sid ? _c("v-btn", {
      key: `${sweep.sid}-active`,
      staticClass: "position-absolute",
      style: `right: ${sweep.right - _vm.highlightPointSize / 2}px; top: ${sweep.top - _vm.highlightPointSize / 2}px; transform: rotate(${-_vm.dpmStore.current.pose.rotation.y}deg);`,
      attrs: {
        "fab": "",
        "dark": "",
        "x-small": "",
        "elevation": "0",
        "width": _vm.highlightPointSize,
        "height": _vm.highlightPointSize,
        "color": "white"
      },
      on: {
        "click": function($event) {
          return _vm.onClickSweep(sweep.sid);
        }
      }
    }, [_c("v-icon", {
      attrs: {
        "dark": "",
        "size": _vm.highlightPointSize,
        "color": "error"
      }
    }, [_vm._v(_vm._s(_vm.$global.icons.mdiArrowUpCircle))])], 1) : _vm._e()];
  })], 2), _vm.cilbeeStore.startSweep && _vm.cilbeeStore.phase < 7 ? _c("div", {
    staticClass: "cilbee-points"
  }, [_vm._l(_vm.currentFloorSweeps, function(sweep) {
    return [sweep.sid === _vm.cilbeeStore.startSweep.sid ? _c("v-btn", {
      key: `${sweep.sid}-cilbee-start-point`,
      staticClass: "position-absolute",
      style: `right: ${sweep.right - _vm.cilbeeHighlightPointSize / 2}px; top: ${sweep.top - _vm.cilbeeHighlightPointSize / 2}px; transform: rotate(-${_vm.dpmStore.showcaseEditorData.minimap_rotate}deg);`,
      attrs: {
        "fab": "",
        "x-small": "",
        "elevation": "0",
        "width": _vm.cilbeeHighlightPointSize,
        "height": _vm.cilbeeHighlightPointSize,
        "color": "transparent"
      },
      on: {
        "click": function($event) {
          return _vm.onClickSweep(sweep.sid);
        }
      }
    }, [_c("v-icon", {
      attrs: {
        "size": _vm.cilbeeHighlightPointSize,
        "color": "error"
      }
    }, [_vm._v(_vm._s(_vm.$global.icons.mdiMapMarker))])], 1) : _vm._e(), _vm.cilbeeDestination(sweep.sid) ? _c("v-btn", {
      key: `${sweep.sid}-cilbee-destination-points`,
      staticClass: "position-absolute",
      style: `right: ${sweep.right - _vm.cilbeeHighlightPointSize / 2}px; top: ${sweep.top - _vm.cilbeeHighlightPointSize / 2}px; transform: rotate(-${_vm.dpmStore.showcaseEditorData.minimap_rotate}deg);`,
      attrs: {
        "fab": "",
        "x-small": "",
        "elevation": "0",
        "width": _vm.cilbeeHighlightPointSize,
        "height": _vm.cilbeeHighlightPointSize,
        "color": "transparent"
      },
      on: {
        "click": function($event) {
          return _vm.onClickSweep(sweep.sid);
        }
      }
    }, [_c("v-icon", {
      attrs: {
        "size": _vm.cilbeeHighlightPointSize,
        "color": _vm.cilbeeDestination(sweep.sid).color
      }
    }, [_vm._v(_vm._s(_vm.cilbeeDestination(sweep.sid).icon === "mdiFlag" ? _vm.$global.icons.mdiFlag : _vm.$global.icons.mdiFlagCheckered))])], 1) : _vm._e()];
  }), _vm.cilbeeStore.currentBeeSweep && _vm.cilbeeStore.currentBeeSweep.floorInfo.sequence === _vm.dpmStore.current.floor.sequence ? _c("div", {
    key: "cilbee-bee-image",
    staticClass: "minimap-bee-image position-absolute",
    style: `width: ${_vm.cilbeeHighlightPointSize}px; height: ${_vm.cilbeeHighlightPointSize}px; right: ${_vm.getXPos(_vm.cilbeeStore.currentBeeSweep.position.x) - _vm.cilbeeHighlightPointSize / 2}px; top: ${_vm.getZPos(_vm.cilbeeStore.currentBeeSweep.position.z) - _vm.cilbeeHighlightPointSize / 2}px; transform: rotate(-${_vm.dpmStore.showcaseEditorData.minimap_rotate}deg);`
  }) : _vm._e()], 2) : _vm._e()], 1)])]), _c("div", {
    staticClass: "menu-container df pe-auto"
  }, [_c("div", {
    staticClass: "menu df"
  }, [_c("div", {
    staticClass: "menu-item"
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": "",
      "attach": ".dpm-minimap-component .menu-container",
      "disabled": !_vm.dpmStore.SED.ui.default.minimap.label.help
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref3) {
        var on2 = _ref3.on;
        return [_c("div", _vm._g({}, on2), [_c("v-switch", {
          staticClass: "mt-0 pt-0",
          attrs: {
            "flat": "",
            "hide-details": ""
          },
          scopedSlots: _vm._u([{
            key: "label",
            fn: function() {
              return [_c("span", {
                domProps: {
                  "innerHTML": _vm._s(_vm.$global.utils.text.addBrTag(_vm.dpmStore.SED.ui.default.minimap.label.switch))
                }
              })];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.dpmStore.global.minimap.menu.label,
            callback: function($$v) {
              _vm.$set(_vm.dpmStore.global.minimap.menu, "label", $$v);
            },
            expression: "dpmStore.global.minimap.menu.label"
          }
        })], 1)];
      }
    }], null, false, 1149699087)
  }, [_c("span", {
    domProps: {
      "innerHTML": _vm._s(_vm.$global.utils.text.addBrTag(_vm.dpmStore.SED.ui.default.minimap.label.help))
    }
  })])], 1), _c("div", {
    staticClass: "menu-item"
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": "",
      "attach": ".dpm-minimap-component .menu-container",
      "disabled": !_vm.dpmStore.SED.ui.default.minimap.mattertag.help
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref4) {
        var on2 = _ref4.on;
        return [_c("div", _vm._g({}, on2), [_c("v-switch", {
          staticClass: "mt-0 pt-0",
          attrs: {
            "flat": "",
            "hide-details": ""
          },
          scopedSlots: _vm._u([{
            key: "label",
            fn: function() {
              return [_c("span", {
                domProps: {
                  "innerHTML": _vm._s(_vm.$global.utils.text.addBrTag(_vm.dpmStore.SED.ui.default.minimap.mattertag.switch))
                }
              })];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.dpmStore.global.minimap.menu.mattertag,
            callback: function($$v) {
              _vm.$set(_vm.dpmStore.global.minimap.menu, "mattertag", $$v);
            },
            expression: "dpmStore.global.minimap.menu.mattertag"
          }
        })], 1)];
      }
    }], null, false, 1539272399)
  }, [_c("span", {
    domProps: {
      "innerHTML": _vm._s(_vm.$global.utils.text.addBrTag(_vm.dpmStore.SED.ui.default.minimap.mattertag.help))
    }
  })])], 1), _c("div", {
    staticClass: "menu-item"
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": "",
      "attach": ".dpm-minimap-component .menu-container",
      "disabled": !_vm.dpmStore.SED.ui.default.minimap.sweep.help
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref5) {
        var on2 = _ref5.on;
        return [_c("div", _vm._g({}, on2), [_c("v-switch", {
          staticClass: "mt-0 pt-0",
          attrs: {
            "flat": "",
            "hide-details": ""
          },
          scopedSlots: _vm._u([{
            key: "label",
            fn: function() {
              return [_c("span", {
                domProps: {
                  "innerHTML": _vm._s(_vm.$global.utils.text.addBrTag(_vm.dpmStore.SED.ui.default.minimap.sweep.switch))
                }
              })];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.dpmStore.global.minimap.menu.sweep,
            callback: function($$v) {
              _vm.$set(_vm.dpmStore.global.minimap.menu, "sweep", $$v);
            },
            expression: "dpmStore.global.minimap.menu.sweep"
          }
        })], 1)];
      }
    }], null, false, 2613044367)
  }, [_c("span", {
    domProps: {
      "innerHTML": _vm._s(_vm.$global.utils.text.addBrTag(_vm.dpmStore.SED.ui.default.minimap.sweep.help))
    }
  })])], 1), _c("div", {
    staticClass: "menu-item"
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": "",
      "attach": ".dpm-minimap-component .menu-container"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref6) {
        var on2 = _ref6.on;
        return [_c("v-btn", _vm._g({
          attrs: {
            "outlined": "",
            "fab": "",
            "small": "",
            "elevation": "0",
            "color": "white"
          },
          on: {
            "click": function($event) {
              return _vm.onZoomClick(0.5);
            }
          }
        }, on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiMagnifyPlusOutline))])], 1)];
      }
    }], null, false, 991712817)
  }, [_c("span", [_vm._v("拡大")])])], 1), _c("div", {
    staticClass: "menu-item"
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": "",
      "attach": ".dpm-minimap-component .menu-container"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref7) {
        var on2 = _ref7.on;
        return [_c("v-btn", _vm._g({
          attrs: {
            "outlined": "",
            "fab": "",
            "small": "",
            "elevation": "0",
            "color": "white"
          },
          on: {
            "click": function($event) {
              return _vm.onZoomClick(-0.5);
            }
          }
        }, on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiMagnifyMinusOutline))])], 1)];
      }
    }], null, false, 1494548746)
  }, [_c("span", [_vm._v("縮小")])])], 1), _c("div", {
    staticClass: "menu-item"
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": "",
      "attach": ".dpm-minimap-component .menu-container"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref8) {
        var on2 = _ref8.on;
        return [_c("v-btn", _vm._g({
          attrs: {
            "outlined": "",
            "fab": "",
            "small": "",
            "elevation": "0",
            "color": "white"
          },
          on: {
            "click": function($event) {
              _vm.fullScreen = !_vm.fullScreen;
            }
          }
        }, on2), [_vm.fullScreen ? _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiFullscreenExit))]) : _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiFullscreen))])], 1)];
      }
    }], null, false, 4108705682)
  }, [_vm.fullScreen ? _c("span", [_vm._v("最小化")]) : _c("span", [_vm._v("最大化")])])], 1)])])])])], 1) : _vm._e();
};
var staticRenderFns$s = [];
const __vue2_script$s = {
  props: [],
  data() {
    return {
      aspect: 1,
      currentFloor: 0,
      currentFloorLabels: [],
      currentFloorMattertags: [],
      currentFloorSweeps: [],
      currentZoomLevel: 1,
      dragging: false,
      wrapperPadding: 8,
      fullScreen: false,
      fullScreenZoomLevel: 1,
      width: 100,
      height: 100,
      imageMargin: { x: 0, y: 0 },
      labelData: {},
      mattertagData: {},
      originMinimpData: {},
      reductionRate: 0.2,
      // iframeの20%に縮小
      rotatedImageMagnification: { x: null, y: null },
      sweepData: {},
      xsWidthSize: 487
    };
  },
  created() {
    this.originMinimpData = JSON.parse(JSON.stringify(this.dpmStore.global.minimap.data));
    this.setDataByFloorId(_keyBy(this.dpmStore.mergedGlobalSed.mattertags, "sid"), this.mattertagData, true);
    this.setDataByFloorId(this.dpmStore.global.sweeps, this.sweepData);
    this.setDataByFloorId(this.dpmStore.global.labels, this.labelData);
    if (this.dpmStore.current.floor && this.dpmStore.current.floor.sequence >= 0) {
      this.currentFloor = this.dpmStore.current.floor.sequence;
    }
    this.updateCurrentMinimapInfo();
    this.aspect = this.dpmStore.global.minimap.data[0].width / this.dpmStore.global.minimap.data[0].height;
    this.calcDefaultSize();
    this.updateMinimapImage();
    if (this.matterportStore.iframeSize.width <= this.xsWidthSize) {
      this.dpmStore.$patch({ global: { minimap: { menu: { expand: false } } } });
    }
    this.dpmStore.$subscribe((mutation, _state) => {
      var _a2, _b2, _c, _d2, _e, _f, _g, _h;
      if (mutation.type.includes("patch") && ((_b2 = (_a2 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _a2.mattertagEditor) == null ? void 0 : _b2.tagChanged)) {
        Object.keys(this.mattertagData).forEach((key) => delete this.mattertagData[key]);
        this.setDataByFloorId(_keyBy(this.dpmStore.mergedGlobalSed.mattertags, "sid"), this.mattertagData, true);
        this.updateCurrentFloorMattertags();
        this.dpmStore.mattertagEditor.tagChanged = false;
      }
      let needUpdateMinimap = false;
      if (mutation.type.includes("patch") && ((_d2 = (_c = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _c.current) == null ? void 0 : _d2.floor)) {
        if (mutation.payload.current.floor.sequence === -1 || mutation.payload.current.floor.sequence === void 0) {
          return;
        }
        this.currentZoomLevel = 1;
        this.currentFloor = mutation.payload.current.floor.sequence;
        needUpdateMinimap = true;
      }
      if (mutation.type.includes("patch") && ((_f = (_e = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _e.current) == null ? void 0 : _f.sweep)) {
        const sweep = mutation.payload.current.sweep;
        if (sweep.sid && sweep.floorInfo.sequence !== this.currentFloor) {
          this.currentFloor = sweep.floorInfo.sequence;
          needUpdateMinimap = true;
        }
      }
      if (mutation.type.includes("patch") && ((_h = (_g = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _g.showcaseEditorData) == null ? void 0 : _h.minimap_images)) {
        this.updateMinimapImage();
      }
      if (needUpdateMinimap) {
        this.updateCurrentMinimapInfo();
      }
    });
  },
  mounted() {
    return __async(this, null, function* () {
      let previousEvent = null;
      const onPointerMove = (e) => {
        this.$refs.imageContainer.scrollTop -= e.screenY - previousEvent.screenY;
        this.$refs.imageContainer.scrollLeft -= e.screenX - previousEvent.screenX;
        previousEvent = e;
      };
      this.$refs.imageContainer.addEventListener("pointerup", (_e) => {
        this.dragging = false;
        this.$refs.imageContainer.removeEventListener("pointermove", onPointerMove);
      });
      this.$refs.imageContainer.addEventListener("pointerdown", (e) => {
        this.dragging = true;
        previousEvent = e;
        this.$refs.imageContainer.addEventListener("pointermove", onPointerMove);
      });
      this.$refs.imageContainer.addEventListener("wheel", (e) => {
        e.preventDefault();
        e.deltaY < 0 ? this.onZoomClick(0.25) : this.onZoomClick(-0.25);
      });
      yield this.$nextTick();
      this.updateCurrentMinimapInfo();
    });
  },
  methods: {
    setDataByFloorId(collections, target2, isMattertags = false) {
      for (const key in this.dpmStore.global.floors) {
        const floorSequence = this.dpmStore.global.floors[key].sequence;
        target2[floorSequence] = Object.values(collections).filter((collection) => {
          var _a2, _b2;
          if (isMattertags) {
            return ((_a2 = this.dpmStore.getFloorByMattertag(collection)) == null ? void 0 : _a2.sequence) === floorSequence ? true : false;
          } else {
            return ((_b2 = collection == null ? void 0 : collection.floorInfo) == null ? void 0 : _b2.sequence) === floorSequence;
          }
        });
      }
    },
    calcDefaultSize() {
      this.width = this.matterportStore.iframeSize.width * this.reductionRate;
      if (this.width < 184) {
        this.width = 184;
      }
      this.height = this.width / this.aspect;
    },
    onClickMattertag(mattertagSid) {
      return __async(this, null, function* () {
        window.focusedTagSid = mattertagSid;
        yield this.$global.sdk.Mattertag.navigateToTag(mattertagSid, this.$global.sdk.Mattertag.Transition.FADEOUT);
        yield this.$global.sdk.Tag.open(mattertagSid, { force: true });
        const targetCustomData = this.dpmStore.SED.mattertags.find((data) => data.sid === mattertagSid);
        if (targetCustomData) {
          this.dpmStore.$patch({ current: { extension: targetCustomData.extension } });
        }
        if (this.dpmStore.sharedExperience.subscription) {
          this.dpmStore.sharedExperience.subscription.clickTag(mattertagSid);
        }
      });
    },
    onClickSweep(sweepSid) {
      this.$global.sdk.Sweep.moveTo(sweepSid, { transition: this.$global.sdk.Sweep.Transition.FADEOUT, transitionTime: 1e3 });
    },
    onZoomClick(param) {
      let changed = true;
      this.currentZoomLevel += param;
      if (this.currentZoomLevel < 1) {
        this.currentZoomLevel = 1;
        changed = false;
      }
      if (this.currentZoomLevel > 5) {
        this.currentZoomLevel = 5;
        changed = false;
      }
      if (changed) {
        this.updateCurrentMinimapInfo();
        this.setImageMargin(false);
      }
    },
    createLabels() {
      const labels = this.labelData[this.currentFloor];
      if (labels) {
        this.currentFloorLabels = labels.map((label) => {
          return {
            sid: label.sid,
            top: this.getZPos(label.position.z),
            right: this.getXPos(label.position.x),
            text: label.text
          };
        });
      }
    },
    updateCurrentFloorMattertags() {
      return __async(this, null, function* () {
        var _a2, _b2;
        const mattertags = this.mattertagData[this.currentFloor];
        if (mattertags) {
          const customIcons = {};
          if (this.dpmStore.global.enableExtensions.mattertag) {
            for (const customMattertag of this.dpmStore.SED.mattertags) {
              if ((_a2 = customMattertag == null ? void 0 : customMattertag.icon) == null ? void 0 : _a2.color) {
                customIcons[customMattertag.sid] = `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.$global.utils.SVG.createDefaultSvgTag(this.$global.utils.toHex(customMattertag.icon.color)))}`;
              }
            }
          }
          for (const group of this.dpmStore.SED.mattertag_groups) {
            if (!group.useCustomColor && !group.colorless && group.color) {
              for (const mattertag of group.mattertags) {
                customIcons[mattertag.sid] = `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.$global.utils.SVG.createDefaultSvgTag(this.$global.utils.toHex(group.color)))}`;
              }
            }
          }
          if (this.dpmStore.global.enableExtensions.mattertag) {
            for (const customMattertag of this.dpmStore.SED.mattertags) {
              if ((_b2 = customMattertag == null ? void 0 : customMattertag.icon) == null ? void 0 : _b2.id) {
                if (customMattertag.icon.url) {
                  if (customMattertag.icon.url.indexOf("active_storage") !== -1) {
                    const res = yield axios$1.get(`${this.$global.apiUrl}/get_media_url?type=mattertag_icon_images&file_id=${customMattertag.icon.url.split(":")[1]}`);
                    if (res) {
                      customIcons[customMattertag.sid] = res.data.url;
                    }
                  } else {
                    customIcons[customMattertag.sid] = customMattertag.icon.url;
                  }
                } else {
                  customIcons[customMattertag.sid] = `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.$global.utils.SVG.createSvgTag(customMattertag.icon.id))}`;
                }
              }
            }
          }
          this.currentFloorMattertags = mattertags.map((mattertag) => {
            const icon = customIcons[mattertag.sid] ? customIcons[mattertag.sid] : `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.$global.utils.SVG.createDefaultSvgTag(this.$global.utils.toHex(mattertag.color)))}`;
            return {
              sid: mattertag.sid,
              label: mattertag.label,
              top: this.getZPos(mattertag.anchorPosition.z),
              right: this.getXPos(mattertag.anchorPosition.x),
              icon
            };
          });
        }
      });
    },
    createSweeps() {
      const sweeps = this.sweepData[this.currentFloor];
      if (sweeps) {
        this.currentFloorSweeps = sweeps.map((sweep) => {
          return {
            sid: sweep.sid,
            top: this.getZPos(sweep.position.z),
            right: this.getXPos(sweep.position.x)
          };
        });
      }
    },
    getMinimapData() {
      return __async(this, null, function* () {
        const res = yield axios$1.get(`${this.$global.apiUrl}/get_minimap_data.json`);
        this.dpmStore.$patch({ global: { minimap: { data: res.data.minimaps } } });
      });
    },
    getZPos(targetZ) {
      return this.height + (targetZ + this.dpmStore.global.minimap.data[0].origin.y) * this.dpmStore.global.minimap.data[0].resolution * this.height / this.dpmStore.global.minimap.data[0].height;
    },
    getXPos(targetX) {
      return this.width - (targetX - this.dpmStore.global.minimap.data[0].origin.x) * this.dpmStore.global.minimap.data[0].resolution * this.width / this.dpmStore.global.minimap.data[0].width;
    },
    updateMinimapImage() {
      return __async(this, null, function* () {
        if (this.dpmStore.SED.minimap_images) {
          for (let i2 = 0; i2 < this.dpmStore.SED.minimap_images.length; i2++) {
            const data = this.dpmStore.SED.minimap_images[i2];
            if (data.indexOf("active_storage") !== -1) {
              const res = yield axios$1.get(`${this.$global.apiUrl}/get_media_url?type=minimap_images&file_id=${data.split(":")[1]}`).catch((_err) => {
              });
              if (res && res.data) {
                this.dpmStore.global.minimap.data[i2].url = res.data.url;
              }
            } else {
              this.dpmStore.global.minimap.data[i2].url = this.originMinimpData[i2].url;
            }
          }
        }
      });
    },
    toggleMinimap() {
      this.fullScreen = false;
      this.dpmStore.$patch({ global: { minimap: { menu: { expand: !this.dpmStore.global.minimap.menu.expand } } } });
    },
    updateCurrentMinimapInfo() {
      this.createLabels();
      this.updateCurrentFloorMattertags();
      this.createSweeps();
    },
    setImageMargin(needScrollTo = false, rotate = false) {
      if (this.rotatedImageMagnification.x === null || this.rotatedImageMagnification.x === 0) {
        this.calcMagnification();
      }
      if (rotate) {
        const rect = this.$refs.minimapInfo.getBoundingClientRect();
        this.imageMargin.x = (rect.width - this.width) / 2 + 8;
        this.imageMargin.y = (rect.height - this.height) / 2 + 8;
      } else {
        const parentRect = this.$refs.imageContainer.getBoundingClientRect();
        this.imageMargin.x = (this.width * this.currentZoomLevel * this.rotatedImageMagnification.x - parentRect.width) / 2 + 8;
        this.imageMargin.y = (this.height * this.currentZoomLevel * this.rotatedImageMagnification.y - parentRect.height) / 2 + 8;
      }
      if (needScrollTo) {
        this.$refs.imageContainer.scrollTo(this.imageMargin.x, this.imageMargin.y);
      }
    },
    calcMagnification() {
      const rect = this.$refs.minimapInfo.getBoundingClientRect();
      this.rotatedImageMagnification.x = rect.width / this.width;
      this.rotatedImageMagnification.y = rect.height / this.height;
    }
  },
  watch: {
    fullScreen(toggle) {
      this.currentZoomLevel = 1;
      if (toggle) {
        this.fullScreenZoomLevel = this.matterportStore.iframeSize.width / this.width / 2;
        if (this.matterportStore.iframeSize.width <= this.xsWidthSize) {
          this.width = this.matterportStore.iframeSize.width - 40;
          this.height = this.width / this.aspect;
          if (this.height > this.matterportStore.iframeSize.height - 331) {
            this.height = this.matterportStore.iframeSize.height - 331;
            this.width = this.height * this.aspect;
          }
        } else {
          this.width = this.matterportStore.iframeSize.width - 172;
          this.height = this.width / this.aspect;
          if (this.height > this.matterportStore.iframeSize.height - 221) {
            this.height = this.matterportStore.iframeSize.height - 221;
            this.width = this.height * this.aspect;
          }
        }
      } else {
        this.fullScreenZoomLevel = 1;
        this.calcDefaultSize();
      }
      this.updateCurrentMinimapInfo();
      setTimeout(() => {
        this.setImageMargin(true);
      }, 500);
    }
  },
  computed: __spreadProps(__spreadValues({}, mapStores(matterportStore, useDpmStore, useCilbeeStore)), {
    defaultSweeps() {
      const customedSweepSids = [
        ...this.dpmStore.SED.sweeps.filter((sweep) => sweep.icon && sweep.icon.id).map((sweep) => sweep.sid),
        ...this.dpmStore.SED.sweep_groups.filter((sweepGroup) => sweepGroup.sweeps.length).flatMap((sweepGroup) => sweepGroup.sweeps)
      ];
      if (customedSweepSids.length) {
        return this.currentFloorSweeps.filter((sweep) => !customedSweepSids.includes(sweep.sid));
      } else {
        return this.currentFloorSweeps;
      }
    },
    currentFloorData() {
      return this.dpmStore.global.floors[Object.keys(this.dpmStore.global.floors).find((key) => this.dpmStore.global.floors[key].sequence === this.currentFloor)];
    },
    currentFloorGroupedSweeps() {
      return this.dpmStore.SED.sweep_groups.map((sweepGroup) => {
        return this.currentFloorSweeps.filter((sweep) => sweepGroup.sweeps.includes(sweep.sid));
      });
    },
    mattertagButtonSize() {
      return 12 * this.fullScreenZoomLevel;
    },
    sweepButtonSize() {
      var _a2, _b2, _c;
      let rate = 1;
      if ((_b2 = (_a2 = this.dpmStore.global.minimap) == null ? void 0 : _a2.data[this.currentFloor]) == null ? void 0 : _b2.resolution) {
        rate = ((_c = this.dpmStore.global.minimap) == null ? void 0 : _c.data[this.currentFloor].resolution) / 100;
        if (rate < 0.4) {
          rate = 0.4;
        }
      }
      let size = this.mattertagButtonSize * 0.75 * rate;
      if (size < 6) {
        size = 6;
      }
      return size;
    },
    highlightPointSize() {
      return this.sweepButtonSize / 0.75 * 1.2;
    },
    cilbeeDestination() {
      return (sid) => {
        return this.cilbeeStore.destinations.find((destination) => destination.sweep.sid === sid);
      };
    },
    cilbeeHighlightPointSize() {
      return this.highlightPointSize * 1.5;
    },
    routeLines() {
      const routeLines = [];
      this.cilbeeStore.minimapRouteLines.forEach((minimapRouteLine) => {
        for (let i2 = 0; i2 < minimapRouteLine.sids.length - 1; i2++) {
          const point1 = this.currentFloorSweeps.find((sweep) => sweep.sid === minimapRouteLine.sids[i2]);
          const point2 = this.currentFloorSweeps.find((sweep) => sweep.sid === minimapRouteLine.sids[i2 + 1]);
          if (!point1 || !point2) {
            continue;
          }
          routeLines.push(createRouteLine(this.width, point1, point2, minimapRouteLine.color));
        }
      });
      return routeLines;
    }
  })
};
const __cssModules$s = {};
var __component__$s = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$s,
  render$s,
  staticRenderFns$s,
  false,
  __vue2_injectStyles$s,
  null,
  null,
  null
);
function __vue2_injectStyles$s(context) {
  for (let o in __cssModules$s) {
    this[o] = __cssModules$s[o];
  }
}
const Minimap = /* @__PURE__ */ function() {
  return __component__$s.exports;
}();
var render$r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("v-dialog", {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "content-class": "m-3 dpm-note-modal dpm-modal"
    },
    model: {
      value: _vm.showNotes,
      callback: function($$v) {
        _vm.showNotes = $$v;
      },
      expression: "showNotes"
    }
  }, [_c("v-card", [_c("v-card-title", [_vm._v(_vm._s(_vm.dpmStore.currentEditMattertag && _vm.dpmStore.currentEditMattertag.label ? _vm.dpmStore.currentEditMattertag.label : "Chats")), _c("v-btn", {
    staticClass: "ml-auto",
    on: {
      "click": _vm.closeNoteDialog
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))]), _vm._v("閉じる")], 1)], 1), _c("v-divider"), _c("v-card-text", {
    staticClass: "p-3"
  }, [_c("v-list", {
    staticClass: "notes-list",
    attrs: {
      "subheader": "",
      "three-line": ""
    }
  }, [_vm.dpmStore.currentEditMattertag && _vm.dpmStore.currentEditMattertag.notes ? [_vm._l(_vm.dpmStore.currentEditMattertag.notes, function(note, i2) {
    return [_c("v-list-item", [_c("v-list-item-content", [_c("v-list-item-title", {
      staticClass: "d-flex align-center"
    }, [_vm._v(_vm._s(note.name)), _c("v-list-item-subtitle", {
      staticClass: "ms-2"
    }, [_vm._v(_vm._s(_vm.formatDate(note.timestamp)))]), note.mentions.length ? _c("v-chip", {
      staticClass: "d-table",
      on: {
        "click": function($event) {
          return _vm.openMentionUsersDialog(note.mentions);
        }
      }
    }, [_vm._v(_vm._s(`${note.mentions.length}名にメンションしました`))]) : _vm._e()], 1), _c("v-list-item-subtitle", [_c("div", {
      staticClass: "d-flex flex-column pt-2"
    }, [note.attachment && note.attachmentType === "image" ? [_c("v-img", {
      attrs: {
        "src": _vm.attachmentList[i2],
        "height": "200",
        "contain": ""
      },
      on: {
        "click": function($event) {
          return _vm.showCoolLightBox(i2);
        }
      }
    })] : note.attachment ? [_c("div", {
      domProps: {
        "innerHTML": _vm._s(_vm.attachmentList[i2])
      }
    })] : _vm._e(), _c("span", {
      staticClass: "pt-2"
    }, [_vm._v(_vm._s(note.comment))])], 2)])], 1)], 1), i2 !== _vm.dpmStore.currentEditMattertag.notes.length - 1 ? _c("v-divider") : _vm._e()];
  })] : _vm._e()], 2)], 1), _c("v-divider"), _c("v-card-actions", [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("v-row", [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("v-textarea", {
    staticClass: "message-area",
    attrs: {
      "label": "コメント",
      "rows": "1",
      "solo": "",
      "auto-grow": "",
      "hide-details": ""
    },
    model: {
      value: _vm.comment,
      callback: function($$v) {
        _vm.comment = $$v;
      },
      expression: "comment"
    }
  })], 1)], 1), _c("v-row", {
    staticClass: "d-flex justify-content-between"
  }, [_c("v-col", {
    staticClass: "align-center",
    attrs: {
      "cols": "4"
    }
  }, [_c("v-btn", {
    staticClass: "ml-auto",
    on: {
      "click": _vm.openUserSelectDialog
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiAt))]), _vm._v("メンション先を選択"), _vm.selectedUsers.length ? _c("span", {
    staticClass: "ms-1",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(`(${_vm.selectedUsers.length})`))]) : _vm._e()], 1)], 1), _c("v-col", {
    staticClass: "d-flex justify-content-between align-center",
    attrs: {
      "cols": "8"
    }
  }, [_c("div", {
    staticClass: "d-flex align-center"
  }, [_c("v-file-input", {
    staticClass: "m-0 p-0",
    attrs: {
      "dense": "",
      "cleable": "",
      "accept": ".jpeg, .jpg, .png, .gif, .pdf",
      "messages": "jpg, png, gif, pdfがアップロード可能です"
    },
    model: {
      value: _vm.uploadedFile,
      callback: function($$v) {
        _vm.uploadedFile = $$v;
      },
      expression: "uploadedFile"
    }
  })], 1), _c("v-btn", {
    attrs: {
      "disabled": !_vm.comment,
      "color": "primary"
    },
    on: {
      "click": _vm.sendComment
    }
  }, [_vm._v("投稿")])], 1), _vm.errorText ? _c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("span", {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorText))])]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _c("v-dialog", {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "content-class": "m-3 dpm-note-selectable-modal dpm-modal"
    },
    model: {
      value: _vm.showUserSelectDialog,
      callback: function($$v) {
        _vm.showUserSelectDialog = $$v;
      },
      expression: "showUserSelectDialog"
    }
  }, [_c("v-card", [_c("v-card-title", [_vm._v("メンション先")]), _c("v-divider"), _c("v-card-text", {
    staticClass: "p-3"
  }, [_c("v-text-field", {
    attrs: {
      "label": "検索",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: _vm.search,
      callback: function($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c("v-treeview", {
    attrs: {
      "selectable": "",
      "search": _vm.search,
      "items": _vm.treeViewItems
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function(_ref) {
        var item = _ref.item;
        return [item.email ? _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiAccount))]) : _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiOfficeBuilding))])];
      }
    }, {
      key: "label",
      fn: function(_ref2) {
        var item = _ref2.item;
        return [item.email ? _c("span", [_vm._v(_vm._s(item.name))]) : _c("span", [_vm._v(_vm._s(item.children.length ? item.name : `${item.name}: この組織はメンバーが登録されていません`))])];
      }
    }]),
    model: {
      value: _vm.selectedUsers,
      callback: function($$v) {
        _vm.selectedUsers = $$v;
      },
      expression: "selectedUsers"
    }
  })], 1), _c("v-divider"), _c("v-card-actions", {
    staticClass: "justify-content-end"
  }, [_c("v-btn", {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showUserSelectDialog = false;
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))]), _vm._v("閉じる")], 1)], 1)], 1)], 1), _c("v-dialog", {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "content-class": "m-3 dpm-note-selected-modal dpm-modal"
    },
    model: {
      value: _vm.showMentionUsersDialog,
      callback: function($$v) {
        _vm.showMentionUsersDialog = $$v;
      },
      expression: "showMentionUsersDialog"
    }
  }, [_c("v-card", [_c("v-card-title", [_vm._v("メンション先")]), _c("v-divider"), _c("v-card-text", {
    staticClass: "p-3"
  }, [_c("v-list", {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.mensionUsers, function(user, i2) {
    return _c("v-list-item", [_c("v-list-item-content", [_c("v-list-item-title", [_vm._v(_vm._s(user))])], 1)], 1);
  }), 1)], 1), _c("v-divider"), _c("v-card-actions", {
    staticClass: "justify-content-end"
  }, [_c("v-btn", {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showMentionUsersDialog = false;
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))]), _vm._v("閉じる")], 1)], 1)], 1)], 1), _c("CoolLightBox", {
    attrs: {
      "items": _vm.lightboxImageTarget,
      "index": _vm.lightboxIndex,
      "useZoomBar": true,
      "gallery": false
    },
    on: {
      "close": function($event) {
        _vm.lightboxIndex = null;
      }
    }
  })], 1);
};
var staticRenderFns$r = [];
const __vue2_script$r = {
  components: { CoolLightBox },
  data() {
    return {
      comment: "",
      errorText: null,
      attachmentList: [],
      intervalId: null,
      lightboxImageTarget: [],
      lightboxIndex: null,
      mensionUsers: [],
      search: null,
      selectedUsers: [],
      showMentionUsersDialog: false,
      showNotes: false,
      showUserSelectDialog: false,
      treeViewItems: [],
      uploadedFile: null
    };
  },
  created() {
    return __async(this, null, function* () {
      this.dpmStore.$subscribe((mutation, _state) => __async(this, null, function* () {
        var _a2, _b2, _c, _d2, _e;
        if (mutation.type.includes("patch") && !((_b2 = (_a2 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _a2.mattertagEditor) == null ? void 0 : _b2.editDialogVisible) && ((_d2 = (_c = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _c.current) == null ? void 0 : _d2.mattertagSid)) {
          this.showNotes = (_e = this.dpmStore.currentEditMattertag) == null ? void 0 : _e.notes;
          if (this.showNotes) {
            yield this.getLatestNotes();
            this.intervalId = setInterval(() => this.getLatestNotes(), 1e4);
          }
        }
      }));
    });
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const noteTagSid = params.get("noteTagSid");
    if (noteTagSid) {
      this.dpmStore.$patch({ current: { mattertagSid: noteTagSid } });
    }
  },
  computed: __spreadValues({}, mapStores(useDpmStore)),
  methods: {
    closeNoteDialog() {
      this.showNotes = false;
      clearInterval(this.intervalId);
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      const hours = `0${date.getHours()}`.slice(-2);
      const minutes = `0${date.getMinutes()}`.slice(-2);
      const seconds = `0${date.getSeconds()}`.slice(-2);
      return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    },
    setLatestData(notes) {
      return __async(this, null, function* () {
        if (this.attachmentList.length === notes.length) {
          return;
        }
        for (let i2 = this.attachmentList.length; i2 < notes.length; i2++) {
          if (notes[i2].attachment) {
            const res = yield axios$1.get(`${this.$global.apiUrl}/get_media_url?type=note_files&file_id=${notes[i2].attachment.split(":")[1]}`);
            if (!res || res.data.status === 404) {
              this.attachmentList.push("");
              return this.errorText;
            }
            if (notes[i2].attachmentType === "image") {
              this.attachmentList.push(res.data.url);
            } else {
              const r = yield this.$global.utils.getMediaHtml(res.data.url, "pdf");
              this.attachmentList.push(r.html);
            }
          } else {
            this.attachmentList.push("");
          }
        }
        for (let i2 = this.dpmStore.currentEditMattertag.notes.length; i2 < notes.length; i2++) {
          this.dpmStore.currentEditMattertag.notes.push(notes[i2]);
        }
      });
    },
    getLatestNotes() {
      return __async(this, null, function* () {
        const res = yield axios$1.get(`${this.$global.apiUrl}/get_latest_mattertag_notes?mattertag_sid=${this.dpmStore.currentEditMattertag.sid}`, {
          headers: this.$global.csrfHeader
          // withCredentials: true // NOTE: 開発用
        });
        if (!res || res.data.status === 404) {
          return this.errorText;
        }
        yield this.setLatestData(res.data.notes);
      });
    },
    openMentionUsersDialog(mentions) {
      return __async(this, null, function* () {
        const userIdsString = mentions.map((id) => `user_ids[]=${id}`).join("&");
        const res = yield axios$1.get(`/members/get_mention_user_names?${userIdsString}`, {
          headers: this.$global.csrfHeader
          // withCredentials: true // NOTE: 開発用
        });
        this.mensionUsers = res.data.user_names;
        this.showMentionUsersDialog = true;
      });
    },
    openUserSelectDialog() {
      return __async(this, null, function* () {
        yield axios$1.get(`/organizations/get_organization_tree.json`, {
          headers: this.$global.csrfHeader,
          params: {
            showcase_id: Number(this.$global.apiUrl.split("/").pop())
          }
          // withCredentials: true // NOTE: 開発用
        }).then((res) => {
          this.treeViewItems = res.data;
        }).catch((err2) => {
          console.error(err2);
        });
        this.showUserSelectDialog = true;
      });
    },
    sendComment() {
      return __async(this, null, function* () {
        this.errorText = null;
        const mentions = this.selectedUsers.map((user) => user.split("-")[1]);
        this.dpmStore.currentEditMattertag.notes.push({
          name: this.dpmStore.global.userName,
          comment: this.comment,
          timestamp: (/* @__PURE__ */ new Date()).getTime(),
          attachment: null,
          attachmentType: null,
          mentions
        });
        this.comment = "";
        this.selectedUsers.splice(0, this.selectedUsers.length);
        if (this.uploadedFile) {
          const params = new FormData();
          params.append("file", this.uploadedFile);
          yield axios$1.post(`${this.$global.apiUrl}/upload_media?type=note_files`, params, {
            headers: __spreadProps(__spreadValues({}, this.$global.csrfHeader), {
              "Content-Type": "multipart/form-data"
            })
          }).then((res) => __async(this, null, function* () {
            this.dpmStore.currentEditMattertag.notes[this.dpmStore.currentEditMattertag.notes.length - 1].attachment = `active_storage:${res.data.id}`;
            this.dpmStore.currentEditMattertag.notes[this.dpmStore.currentEditMattertag.notes.length - 1].attachmentType = this.uploadedFile.type.includes("image") ? "image" : "pdf";
            this.uploadedFile = null;
            yield this.createNotes();
          })).catch((err2) => {
            var _a2, _b2;
            this.dpmStore.currentEditMattertag.notes.pop();
            this.errorText = ((_b2 = (_a2 = err2.response) == null ? void 0 : _a2.data) == null ? void 0 : _b2.error) || err2;
          });
        } else {
          yield this.createNotes();
        }
      });
    },
    showCoolLightBox(index2) {
      this.lightboxIndex = 0;
      this.lightboxImageTarget = [this.attachmentList[index2]];
    },
    createNotes() {
      return __async(this, null, function* () {
        const deepLink = yield this.$global.sdk.Link.createDeepLink();
        const linkParams = { noteTagSid: this.dpmStore.currentEditMattertag.sid };
        new URL(deepLink).searchParams.forEach((value, key) => {
          if (!["useLegacyIds", "applicationKey", "newtags", "m"].includes(key)) {
            linkParams[key] = value;
          }
        });
        const url = `${new URL(deepLink).origin}${this.$global.apiUrl}?${Object.keys(linkParams).map((key) => `${key}=${linkParams[key]}`).join("&")}`;
        const res = yield axios$1.post(`${this.$global.apiUrl}/create_mattertag_notes`, {
          showcase: {
            mattertag_sid: this.dpmStore.currentEditMattertag.sid,
            mattertag_notes: JSON.stringify(this.dpmStore.currentEditMattertag.notes[this.dpmStore.currentEditMattertag.notes.length - 1]),
            note_url: url
          }
        }, {
          headers: this.$global.csrfHeader
          // withCredentials: true // NOTE: 開発用
        });
        yield this.setLatestData(res.data.notes);
      });
    }
  }
};
const __cssModules$r = {};
var __component__$r = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$r,
  render$r,
  staticRenderFns$r,
  false,
  __vue2_injectStyles$r,
  null,
  null,
  null
);
function __vue2_injectStyles$r(context) {
  for (let o in __cssModules$r) {
    this[o] = __cssModules$r[o];
  }
}
const Note = /* @__PURE__ */ function() {
  return __component__$r.exports;
}();
var render$q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.matterportStore.dockOpen ? _c("div", {
    staticClass: "pe-auto",
    attrs: {
      "id": "dpm-object-list-drawer"
    }
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref) {
        var on2 = _ref.on;
        return [_c("v-btn", _vm._g({
          staticClass: "dpm-object-list-drawer-button",
          attrs: {
            "fab": "",
            "small": "",
            "elevation": "0",
            "color": "white"
          },
          on: {
            "click": _vm.changeDrawer
          }
        }, on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiFormatListBulletedType))])], 1)];
      }
    }], null, false, 2473225695)
  }, [_c("span", [_vm._v("オブジェクトリスト")])]), _c("v-navigation-drawer", {
    attrs: {
      "width": "400px",
      "absolute": "",
      "right": !_vm.isBottom,
      "bottom": _vm.isBottom,
      "hide-overlay": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function() {
        return [_c("v-list-item", {
          staticClass: "ps-4 pe-2 py-2"
        }, [_c("v-list-item-content", {
          staticClass: "p-0"
        }, [_c("v-list-item-title", [_vm._v("Objects")])], 1), _c("v-list-item-action", [_c("v-btn", {
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.changeDrawer
          }
        }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))])], 1)], 1)], 1)];
      },
      proxy: true
    }], null, false, 2795851482),
    model: {
      value: _vm.dpmStore.global.objectListDrawer.expand,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.global.objectListDrawer, "expand", $$v);
      },
      expression: "dpmStore.global.objectListDrawer.expand"
    }
  }, [_c("v-expansion-panels", {
    attrs: {
      "flat": ""
    }
  }, [_c("v-expansion-panel", [_c("v-expansion-panel-header", {
    staticClass: "py-0 px-3"
  }, [_c("v-text-field", {
    attrs: {
      "label": "キーワード検索",
      "clearable": "",
      "hide-details": "",
      "prepend-inner-icon": _vm.$global.icons.mdiMagnify,
      "dense": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    },
    model: {
      value: _vm.keyword,
      callback: function($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  })], 1), _c("v-expansion-panel-content", [_c("v-radio-group", {
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.selectedRadio,
      callback: function($$v) {
        _vm.selectedRadio = $$v;
      },
      expression: "selectedRadio"
    }
  }, _vm._l(_vm.radioGroup, function(radio) {
    return _c("v-radio", {
      key: radio.key,
      attrs: {
        "label": radio.label,
        "value": radio.key
      }
    });
  }), 1)], 1)], 1)], 1), _c("v-divider", {
    staticClass: "mt-4"
  }), _c("div", {
    staticClass: "list-scroll-wrapper flex-grow-1"
  }, [_c("DynamicScroller", {
    staticClass: "h-100 ds-main",
    attrs: {
      "items": _vm.filteredList,
      "min-item-size": 48,
      "buffer": 1080,
      "key-field": "key",
      "item-class": "ds-item"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(_ref2) {
        var item = _ref2.item;
        _ref2.index;
        var active = _ref2.active;
        return [_c("DynamicScrollerItem", {
          attrs: {
            "item": item,
            "active": active
          }
        }, [_c("div", {
          staticClass: "ds-item-content py-2 px-4"
        }, [_c("div", {
          staticClass: "df align-items-center ds-item-title"
        }, [item.deleted ? _c("v-tooltip", {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(_ref3) {
              var on2 = _ref3.on, attrs2 = _ref3.attrs;
              return [_c("v-icon", _vm._g(_vm._b({
                staticClass: "mr-2",
                attrs: {
                  "color": "error"
                }
              }, "v-icon", attrs2, false), on2), [_vm._v(_vm._s(_vm.$global.icons.mdiAlertDecagram))])];
            }
          }], null, true)
        }, [_c("div", [_c("p", {
          staticClass: "mb-0"
        }, [_vm._v("配置されたオブジェクトのアセット（ID: " + _vm._s(item.assetFileId) + "）は削除されているので表示できません")])])]) : _vm._e(), _c("span", {
          staticClass: "text-wrap black--text"
        }, [_vm._v(_vm._s(item.name) + " " + _vm._s(item.deleted ? "（削除済み）" : ""))]), _c("div", {
          staticClass: "ms-auto d-flex"
        }, [item.categoryName ? _c("div", [_c("v-tooltip", {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(_ref4) {
              var on2 = _ref4.on, attrs2 = _ref4.attrs;
              return [_c("v-btn", _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                }
              }, "v-btn", attrs2, false), on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiInformation))])], 1)];
            }
          }], null, true)
        }, [_c("div", [_c("p", {
          staticClass: "mb-0"
        }, [_vm._v("カテゴリ名: " + _vm._s(item.categoryName))]), _c("p", {
          staticClass: "mb-0"
        }, [_vm._v("アセット名: " + _vm._s(item.assetName))])])])], 1) : _vm._e(), _c("v-btn", {
          staticClass: "p-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.navigateToSweep(item.position);
            }
          }
        }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiShareCircle))])], 1)], 1)], 1)])])];
      }
    }], null, false, 466789425)
  })], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns$q = [];
const __vue2_script$q = {
  data() {
    return {
      isBottom: false,
      listItems: [],
      keyword: "",
      radioGroup: [
        { key: "all", label: "全て" },
        { key: "categoryName", label: "カテゴリー名" },
        { key: "assetName", label: "アセット名" },
        { key: "assetFileId", label: "アセットID" },
        { key: "displayName", label: "配置名" }
      ],
      selectedRadio: "all"
    };
  },
  computed: __spreadProps(__spreadValues({}, mapStores(useDpmStore, matterportStore)), {
    filteredList() {
      if (!this.keyword) {
        return this.listItems;
      } else {
        const keyword = this.keyword.toLowerCase();
        switch (this.selectedRadio) {
          case "all":
            return this.listItems.filter((item) => {
              var _a2, _b2, _c;
              return ((_a2 = item.categoryName) == null ? void 0 : _a2.toLowerCase().includes(keyword)) || ((_b2 = item.assetName) == null ? void 0 : _b2.toLowerCase().includes(keyword)) || item.assetFileId && item.assetFileId == keyword || ((_c = item.name) == null ? void 0 : _c.toLowerCase().includes(keyword));
            });
          case "categoryName":
            return this.listItems.filter((item) => {
              var _a2;
              return (_a2 = item.categoryName) == null ? void 0 : _a2.toLowerCase().includes(keyword);
            });
          case "assetName":
            return this.listItems.filter((item) => {
              var _a2;
              return (_a2 = item.assetName) == null ? void 0 : _a2.toLowerCase().includes(keyword);
            });
          case "assetFileId":
            return this.listItems.filter((item) => item.assetFileId && item.assetFileId == keyword);
          case "displayName":
            return this.listItems.filter((item) => item.name.toLowerCase().includes(keyword));
        }
      }
    }
  }),
  created() {
    return __async(this, null, function* () {
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
      let assetInfo = null;
      const assetFileIds = [];
      this.dpmStore.SED.objects.payload.objects.forEach((obj) => assetFileIds.push(obj.assetFileId));
      const uniqueAssetFileIds = [...new Set(assetFileIds.filter(Boolean))];
      if (uniqueAssetFileIds.length) {
        const res = yield axios$1.get(
          "/asset_files/get_assets_info.json",
          { params: { file_ids: uniqueAssetFileIds } }
        );
        assetInfo = res.data;
      }
      this.dpmStore.SED.objects.payload.objects.forEach((obj) => {
        if (obj.name === "Ambient Light") {
          return;
        }
        const data = { key: obj.id, name: obj.name, position: new Vector3(obj.position.x, obj.position.y, obj.position.z) };
        if (obj.assetFileId) {
          const info = assetInfo[obj.assetFileId];
          Object.assign(data, info ? { categoryName: info.category_name, assetName: info.name, assetFileId: obj.assetFileId } : { deleted: true, assetFileId: obj.assetFileId });
        }
        this.listItems.push(data);
      });
    });
  },
  methods: {
    changeDrawer() {
      this.dpmStore.$patch({ global: { objectListDrawer: { expand: !this.dpmStore.global.objectListDrawer.expand } } });
    },
    handleResize() {
      this.isBottom = this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    navigateToSweep(position) {
      return __async(this, null, function* () {
        yield this.$global.sdk.Sweep.moveTo(this.dpmStore.getClosestSweepSid(position));
      });
    }
  }
};
const __cssModules$q = {};
var __component__$q = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$q,
  render$q,
  staticRenderFns$q,
  false,
  __vue2_injectStyles$q,
  null,
  null,
  null
);
function __vue2_injectStyles$q(context) {
  for (let o in __cssModules$q) {
    this[o] = __cssModules$q[o];
  }
}
const ObjectListDrawer = /* @__PURE__ */ function() {
  return __component__$q.exports;
}();
var render$p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.matterportStore.dockOpen ? _c("div", {
    staticClass: "pe-auto",
    attrs: {
      "id": "dpm-organization-list-drawer"
    }
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref) {
        var on2 = _ref.on;
        return [_c("v-btn", _vm._g({
          staticClass: "dpm-mattertag-group-list-drawer-button",
          attrs: {
            "fab": "",
            "small": "",
            "elevation": "0",
            "color": "white"
          },
          on: {
            "click": _vm.changeDrawer
          }
        }, on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiOfficeBuilding))])], 1)];
      }
    }], null, false, 3865780185)
  }, [_c("span", [_vm._v("組織リスト")])]), _c("v-navigation-drawer", {
    attrs: {
      "width": "400px",
      "absolute": "",
      "right": !_vm.isBottom,
      "bottom": _vm.isBottom,
      "hide-overlay": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function() {
        return [_c("v-list-item", {
          staticClass: "ps-4 pe-2 py-2"
        }, [_c("v-list-item-content", {
          staticClass: "p-0"
        }, [_c("v-list-item-title", [_vm._v("組織リスト")])], 1), _c("v-list-item-action", [_c("v-btn", {
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.changeDrawer
          }
        }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))])], 1)], 1)], 1)];
      },
      proxy: true
    }], null, false, 3096547287),
    model: {
      value: _vm.dpmStore.global.organizationListDrawer.expand,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.global.organizationListDrawer, "expand", $$v);
      },
      expression: "dpmStore.global.organizationListDrawer.expand"
    }
  }, [_c("v-list", _vm._l(_vm.dpmStore.global.organizationListDrawer.data, function(item, index2) {
    return _c("v-list-item", {
      key: index2
    }, [_c("v-tooltip", {
      attrs: {
        "bottom": "",
        "content-class": "responsive-tooltip"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(_ref2) {
          var on2 = _ref2.on, attrs2 = _ref2.attrs;
          return [_c("v-list-item-content", _vm._g(_vm._b({}, "v-list-item-content", attrs2, false), on2), [_c("v-list-item-title", [_vm._v(_vm._s(item.name))])], 1)];
        }
      }], null, true)
    }, [_c("span", {
      staticClass: "text-tooltip"
    }, [_vm._v(_vm._s(item.path))])])], 1);
  }), 1)], 1)], 1) : _vm._e();
};
var staticRenderFns$p = [];
const organizationListDrawer_vue_vue_type_style_index_0_lang = "";
const __vue2_script$p = {
  data() {
    return {
      isBottom: false,
      items: []
    };
  },
  created() {
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    changeDrawer() {
      this.dpmStore.$patch({ global: { organizationListDrawer: { expand: !this.dpmStore.global.organizationListDrawer.expand } } });
    },
    handleResize() {
      this.isBottom = this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    }
  },
  computed: __spreadValues({}, mapStores(useDpmStore, matterportStore))
};
const __cssModules$p = {};
var __component__$p = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$p,
  render$p,
  staticRenderFns$p,
  false,
  __vue2_injectStyles$p,
  null,
  null,
  null
);
function __vue2_injectStyles$p(context) {
  for (let o in __cssModules$p) {
    this[o] = __cssModules$p[o];
  }
}
const OrganizationListDrawer = /* @__PURE__ */ function() {
  return __component__$p.exports;
}();
var adapters = {
  logger: typeof console !== "undefined" ? console : void 0,
  WebSocket: typeof WebSocket !== "undefined" ? WebSocket : void 0
};
var logger = {
  log(...messages2) {
    if (this.enabled) {
      messages2.push(Date.now());
      adapters.logger.log("[ActionCable]", ...messages2);
    }
  }
};
const now = () => (/* @__PURE__ */ new Date()).getTime();
const secondsSince = (time) => (now() - time) / 1e3;
class ConnectionMonitor {
  constructor(connection) {
    this.visibilityDidChange = this.visibilityDidChange.bind(this);
    this.connection = connection;
    this.reconnectAttempts = 0;
  }
  start() {
    if (!this.isRunning()) {
      this.startedAt = now();
      delete this.stoppedAt;
      this.startPolling();
      addEventListener("visibilitychange", this.visibilityDidChange);
      logger.log(`ConnectionMonitor started. stale threshold = ${this.constructor.staleThreshold} s`);
    }
  }
  stop() {
    if (this.isRunning()) {
      this.stoppedAt = now();
      this.stopPolling();
      removeEventListener("visibilitychange", this.visibilityDidChange);
      logger.log("ConnectionMonitor stopped");
    }
  }
  isRunning() {
    return this.startedAt && !this.stoppedAt;
  }
  recordMessage() {
    this.pingedAt = now();
  }
  recordConnect() {
    this.reconnectAttempts = 0;
    delete this.disconnectedAt;
    logger.log("ConnectionMonitor recorded connect");
  }
  recordDisconnect() {
    this.disconnectedAt = now();
    logger.log("ConnectionMonitor recorded disconnect");
  }
  startPolling() {
    this.stopPolling();
    this.poll();
  }
  stopPolling() {
    clearTimeout(this.pollTimeout);
  }
  poll() {
    this.pollTimeout = setTimeout(() => {
      this.reconnectIfStale();
      this.poll();
    }, this.getPollInterval());
  }
  getPollInterval() {
    const { staleThreshold, reconnectionBackoffRate } = this.constructor;
    const backoff = Math.pow(1 + reconnectionBackoffRate, Math.min(this.reconnectAttempts, 10));
    const jitterMax = this.reconnectAttempts === 0 ? 1 : reconnectionBackoffRate;
    const jitter = jitterMax * Math.random();
    return staleThreshold * 1e3 * backoff * (1 + jitter);
  }
  reconnectIfStale() {
    if (this.connectionIsStale()) {
      logger.log(`ConnectionMonitor detected stale connection. reconnectAttempts = ${this.reconnectAttempts}, time stale = ${secondsSince(this.refreshedAt)} s, stale threshold = ${this.constructor.staleThreshold} s`);
      this.reconnectAttempts++;
      if (this.disconnectedRecently()) {
        logger.log(`ConnectionMonitor skipping reopening recent disconnect. time disconnected = ${secondsSince(this.disconnectedAt)} s`);
      } else {
        logger.log("ConnectionMonitor reopening");
        this.connection.reopen();
      }
    }
  }
  get refreshedAt() {
    return this.pingedAt ? this.pingedAt : this.startedAt;
  }
  connectionIsStale() {
    return secondsSince(this.refreshedAt) > this.constructor.staleThreshold;
  }
  disconnectedRecently() {
    return this.disconnectedAt && secondsSince(this.disconnectedAt) < this.constructor.staleThreshold;
  }
  visibilityDidChange() {
    if (document.visibilityState === "visible") {
      setTimeout(() => {
        if (this.connectionIsStale() || !this.connection.isOpen()) {
          logger.log(`ConnectionMonitor reopening stale connection on visibilitychange. visibilityState = ${document.visibilityState}`);
          this.connection.reopen();
        }
      }, 200);
    }
  }
}
ConnectionMonitor.staleThreshold = 6;
ConnectionMonitor.reconnectionBackoffRate = 0.15;
var INTERNAL = {
  message_types: {
    welcome: "welcome",
    disconnect: "disconnect",
    ping: "ping",
    confirmation: "confirm_subscription",
    rejection: "reject_subscription"
  },
  disconnect_reasons: {
    unauthorized: "unauthorized",
    invalid_request: "invalid_request",
    server_restart: "server_restart",
    remote: "remote"
  },
  default_mount_path: "/cable",
  protocols: ["actioncable-v1-json", "actioncable-unsupported"]
};
const { message_types, protocols } = INTERNAL;
const supportedProtocols = protocols.slice(0, protocols.length - 1);
const indexOf = [].indexOf;
class Connection {
  constructor(consumer) {
    this.open = this.open.bind(this);
    this.consumer = consumer;
    this.subscriptions = this.consumer.subscriptions;
    this.monitor = new ConnectionMonitor(this);
    this.disconnected = true;
  }
  send(data) {
    if (this.isOpen()) {
      this.webSocket.send(JSON.stringify(data));
      return true;
    } else {
      return false;
    }
  }
  open() {
    if (this.isActive()) {
      logger.log(`Attempted to open WebSocket, but existing socket is ${this.getState()}`);
      return false;
    } else {
      const socketProtocols = [...protocols, ...this.consumer.subprotocols || []];
      logger.log(`Opening WebSocket, current state is ${this.getState()}, subprotocols: ${socketProtocols}`);
      if (this.webSocket) {
        this.uninstallEventHandlers();
      }
      this.webSocket = new adapters.WebSocket(this.consumer.url, socketProtocols);
      this.installEventHandlers();
      this.monitor.start();
      return true;
    }
  }
  close({ allowReconnect } = {
    allowReconnect: true
  }) {
    if (!allowReconnect) {
      this.monitor.stop();
    }
    if (this.isOpen()) {
      return this.webSocket.close();
    }
  }
  reopen() {
    logger.log(`Reopening WebSocket, current state is ${this.getState()}`);
    if (this.isActive()) {
      try {
        return this.close();
      } catch (error2) {
        logger.log("Failed to reopen WebSocket", error2);
      } finally {
        logger.log(`Reopening WebSocket in ${this.constructor.reopenDelay}ms`);
        setTimeout(this.open, this.constructor.reopenDelay);
      }
    } else {
      return this.open();
    }
  }
  getProtocol() {
    if (this.webSocket) {
      return this.webSocket.protocol;
    }
  }
  isOpen() {
    return this.isState("open");
  }
  isActive() {
    return this.isState("open", "connecting");
  }
  triedToReconnect() {
    return this.monitor.reconnectAttempts > 0;
  }
  isProtocolSupported() {
    return indexOf.call(supportedProtocols, this.getProtocol()) >= 0;
  }
  isState(...states) {
    return indexOf.call(states, this.getState()) >= 0;
  }
  getState() {
    if (this.webSocket) {
      for (let state in adapters.WebSocket) {
        if (adapters.WebSocket[state] === this.webSocket.readyState) {
          return state.toLowerCase();
        }
      }
    }
    return null;
  }
  installEventHandlers() {
    for (let eventName in this.events) {
      const handler = this.events[eventName].bind(this);
      this.webSocket[`on${eventName}`] = handler;
    }
  }
  uninstallEventHandlers() {
    for (let eventName in this.events) {
      this.webSocket[`on${eventName}`] = function() {
      };
    }
  }
}
Connection.reopenDelay = 500;
Connection.prototype.events = {
  message(event) {
    if (!this.isProtocolSupported()) {
      return;
    }
    const { identifier, message, reason, reconnect, type } = JSON.parse(event.data);
    this.monitor.recordMessage();
    switch (type) {
      case message_types.welcome:
        if (this.triedToReconnect()) {
          this.reconnectAttempted = true;
        }
        this.monitor.recordConnect();
        return this.subscriptions.reload();
      case message_types.disconnect:
        logger.log(`Disconnecting. Reason: ${reason}`);
        return this.close({
          allowReconnect: reconnect
        });
      case message_types.ping:
        return null;
      case message_types.confirmation:
        this.subscriptions.confirmSubscription(identifier);
        if (this.reconnectAttempted) {
          this.reconnectAttempted = false;
          return this.subscriptions.notify(identifier, "connected", {
            reconnected: true
          });
        } else {
          return this.subscriptions.notify(identifier, "connected", {
            reconnected: false
          });
        }
      case message_types.rejection:
        return this.subscriptions.reject(identifier);
      default:
        return this.subscriptions.notify(identifier, "received", message);
    }
  },
  open() {
    logger.log(`WebSocket onopen event, using '${this.getProtocol()}' subprotocol`);
    this.disconnected = false;
    if (!this.isProtocolSupported()) {
      logger.log("Protocol is unsupported. Stopping monitor and disconnecting.");
      return this.close({
        allowReconnect: false
      });
    }
  },
  close(event) {
    logger.log("WebSocket onclose event");
    if (this.disconnected) {
      return;
    }
    this.disconnected = true;
    this.monitor.recordDisconnect();
    return this.subscriptions.notifyAll("disconnected", {
      willAttemptReconnect: this.monitor.isRunning()
    });
  },
  error() {
    logger.log("WebSocket onerror event");
  }
};
const extend$1 = function(object, properties) {
  if (properties != null) {
    for (let key in properties) {
      const value = properties[key];
      object[key] = value;
    }
  }
  return object;
};
class Subscription {
  constructor(consumer, params = {}, mixin2) {
    this.consumer = consumer;
    this.identifier = JSON.stringify(params);
    extend$1(this, mixin2);
  }
  perform(action, data = {}) {
    data.action = action;
    return this.send(data);
  }
  send(data) {
    return this.consumer.send({
      command: "message",
      identifier: this.identifier,
      data: JSON.stringify(data)
    });
  }
  unsubscribe() {
    return this.consumer.subscriptions.remove(this);
  }
}
class SubscriptionGuarantor {
  constructor(subscriptions) {
    this.subscriptions = subscriptions;
    this.pendingSubscriptions = [];
  }
  guarantee(subscription) {
    if (this.pendingSubscriptions.indexOf(subscription) == -1) {
      logger.log(`SubscriptionGuarantor guaranteeing ${subscription.identifier}`);
      this.pendingSubscriptions.push(subscription);
    } else {
      logger.log(`SubscriptionGuarantor already guaranteeing ${subscription.identifier}`);
    }
    this.startGuaranteeing();
  }
  forget(subscription) {
    logger.log(`SubscriptionGuarantor forgetting ${subscription.identifier}`);
    this.pendingSubscriptions = this.pendingSubscriptions.filter((s2) => s2 !== subscription);
  }
  startGuaranteeing() {
    this.stopGuaranteeing();
    this.retrySubscribing();
  }
  stopGuaranteeing() {
    clearTimeout(this.retryTimeout);
  }
  retrySubscribing() {
    this.retryTimeout = setTimeout(() => {
      if (this.subscriptions && typeof this.subscriptions.subscribe === "function") {
        this.pendingSubscriptions.map((subscription) => {
          logger.log(`SubscriptionGuarantor resubscribing ${subscription.identifier}`);
          this.subscriptions.subscribe(subscription);
        });
      }
    }, 500);
  }
}
class Subscriptions {
  constructor(consumer) {
    this.consumer = consumer;
    this.guarantor = new SubscriptionGuarantor(this);
    this.subscriptions = [];
  }
  create(channelName, mixin2) {
    const channel = channelName;
    const params = typeof channel === "object" ? channel : {
      channel
    };
    const subscription = new Subscription(this.consumer, params, mixin2);
    return this.add(subscription);
  }
  add(subscription) {
    this.subscriptions.push(subscription);
    this.consumer.ensureActiveConnection();
    this.notify(subscription, "initialized");
    this.subscribe(subscription);
    return subscription;
  }
  remove(subscription) {
    this.forget(subscription);
    if (!this.findAll(subscription.identifier).length) {
      this.sendCommand(subscription, "unsubscribe");
    }
    return subscription;
  }
  reject(identifier) {
    return this.findAll(identifier).map((subscription) => {
      this.forget(subscription);
      this.notify(subscription, "rejected");
      return subscription;
    });
  }
  forget(subscription) {
    this.guarantor.forget(subscription);
    this.subscriptions = this.subscriptions.filter((s2) => s2 !== subscription);
    return subscription;
  }
  findAll(identifier) {
    return this.subscriptions.filter((s2) => s2.identifier === identifier);
  }
  reload() {
    return this.subscriptions.map((subscription) => this.subscribe(subscription));
  }
  notifyAll(callbackName, ...args) {
    return this.subscriptions.map((subscription) => this.notify(subscription, callbackName, ...args));
  }
  notify(subscription, callbackName, ...args) {
    let subscriptions;
    if (typeof subscription === "string") {
      subscriptions = this.findAll(subscription);
    } else {
      subscriptions = [subscription];
    }
    return subscriptions.map((subscription2) => typeof subscription2[callbackName] === "function" ? subscription2[callbackName](...args) : void 0);
  }
  subscribe(subscription) {
    if (this.sendCommand(subscription, "subscribe")) {
      this.guarantor.guarantee(subscription);
    }
  }
  confirmSubscription(identifier) {
    logger.log(`Subscription confirmed ${identifier}`);
    this.findAll(identifier).map((subscription) => this.guarantor.forget(subscription));
  }
  sendCommand(subscription, command) {
    const { identifier } = subscription;
    return this.consumer.send({
      command,
      identifier
    });
  }
}
class Consumer {
  constructor(url) {
    this._url = url;
    this.subscriptions = new Subscriptions(this);
    this.connection = new Connection(this);
    this.subprotocols = [];
  }
  get url() {
    return createWebSocketURL(this._url);
  }
  send(data) {
    return this.connection.send(data);
  }
  connect() {
    return this.connection.open();
  }
  disconnect() {
    return this.connection.close({
      allowReconnect: false
    });
  }
  ensureActiveConnection() {
    if (!this.connection.isActive()) {
      return this.connection.open();
    }
  }
  addSubProtocol(subprotocol) {
    this.subprotocols = [...this.subprotocols, subprotocol];
  }
}
function createWebSocketURL(url) {
  if (typeof url === "function") {
    url = url();
  }
  if (url && !/^wss?:/i.test(url)) {
    const a = document.createElement("a");
    a.href = url;
    a.href = a.href;
    a.protocol = a.protocol.replace("http", "ws");
    return a.href;
  } else {
    return url;
  }
}
function createConsumer(url = getConfig("url") || INTERNAL.default_mount_path) {
  return new Consumer(url);
}
function getConfig(name) {
  const element = document.head.querySelector(`meta[name='action-cable-${name}']`);
  if (element) {
    return element.getAttribute("content");
  }
}
var createjs$1 = { exports: {} };
createjs$1.exports;
(function(module, exports) {
  var createjs2 = commonjsGlobal.createjs = commonjsGlobal.createjs || {};
  /*!
  * CreateJS
  * Visit http://createjs.com/ for documentation, updates and examples.
  *
  * Copyright (c) 2010 gskinner.com, inc.
  *
  * Permission is hereby granted, free of charge, to any person
  * obtaining a copy of this software and associated documentation
  * files (the "Software"), to deal in the Software without
  * restriction, including without limitation the rights to use,
  * copy, modify, merge, publish, distribute, sublicense, and/or sell
  * copies of the Software, and to permit persons to whom the
  * Software is furnished to do so, subject to the following
  * conditions:
  *
  * The above copyright notice and this permission notice shall be
  * included in all copies or substantial portions of the Software.
  *
  * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
  * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
  * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
  * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
  * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
  * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
  * OTHER DEALINGS IN THE SOFTWARE.
  */
  commonjsGlobal.createjs = commonjsGlobal.createjs || {};
  createjs2.extend = function(subclass, superclass) {
    function o() {
      this.constructor = subclass;
    }
    o.prototype = superclass.prototype;
    return subclass.prototype = new o();
  };
  createjs2.promote = function(subclass, prefix) {
    var subP = subclass.prototype, supP = Object.getPrototypeOf && Object.getPrototypeOf(subP) || subP.__proto__;
    if (supP) {
      subP[(prefix += "_") + "constructor"] = supP.constructor;
      for (var n2 in supP) {
        if (subP.hasOwnProperty(n2) && typeof supP[n2] == "function") {
          subP[prefix + n2] = supP[n2];
        }
      }
    }
    return subclass;
  };
  createjs2.indexOf = function(array, searchElement) {
    for (var i2 = 0, l = array.length; i2 < l; i2++) {
      if (searchElement === array[i2]) {
        return i2;
      }
    }
    return -1;
  };
  (function() {
    function Event2(type, bubbles, cancelable) {
      this.type = type;
      this.target = null;
      this.currentTarget = null;
      this.eventPhase = 0;
      this.bubbles = !!bubbles;
      this.cancelable = !!cancelable;
      this.timeStamp = (/* @__PURE__ */ new Date()).getTime();
      this.defaultPrevented = false;
      this.propagationStopped = false;
      this.immediatePropagationStopped = false;
      this.removed = false;
    }
    var p = Event2.prototype;
    p.preventDefault = function() {
      this.defaultPrevented = this.cancelable && true;
    };
    p.stopPropagation = function() {
      this.propagationStopped = true;
    };
    p.stopImmediatePropagation = function() {
      this.immediatePropagationStopped = this.propagationStopped = true;
    };
    p.remove = function() {
      this.removed = true;
    };
    p.clone = function() {
      return new Event2(this.type, this.bubbles, this.cancelable);
    };
    p.set = function(props2) {
      for (var n2 in props2) {
        this[n2] = props2[n2];
      }
      return this;
    };
    p.toString = function() {
      return "[Event (type=" + this.type + ")]";
    };
    createjs2.Event = Event2;
  })();
  (function() {
    function EventDispatcher2() {
      this._listeners = null;
      this._captureListeners = null;
    }
    var p = EventDispatcher2.prototype;
    EventDispatcher2.initialize = function(target2) {
      target2.addEventListener = p.addEventListener;
      target2.on = p.on;
      target2.removeEventListener = target2.off = p.removeEventListener;
      target2.removeAllEventListeners = p.removeAllEventListeners;
      target2.hasEventListener = p.hasEventListener;
      target2.dispatchEvent = p.dispatchEvent;
      target2._dispatchEvent = p._dispatchEvent;
      target2.willTrigger = p.willTrigger;
    };
    p.addEventListener = function(type, listener, useCapture) {
      var listeners;
      if (useCapture) {
        listeners = this._captureListeners = this._captureListeners || {};
      } else {
        listeners = this._listeners = this._listeners || {};
      }
      var arr = listeners[type];
      if (arr) {
        this.removeEventListener(type, listener, useCapture);
      }
      arr = listeners[type];
      if (!arr) {
        listeners[type] = [listener];
      } else {
        arr.push(listener);
      }
      return listener;
    };
    p.on = function(type, listener, scope, once2, data, useCapture) {
      if (listener.handleEvent) {
        scope = scope || listener;
        listener = listener.handleEvent;
      }
      scope = scope || this;
      return this.addEventListener(type, function(evt) {
        listener.call(scope, evt, data);
        once2 && evt.remove();
      }, useCapture);
    };
    p.removeEventListener = function(type, listener, useCapture) {
      var listeners = useCapture ? this._captureListeners : this._listeners;
      if (!listeners) {
        return;
      }
      var arr = listeners[type];
      if (!arr) {
        return;
      }
      for (var i2 = 0, l = arr.length; i2 < l; i2++) {
        if (arr[i2] == listener) {
          if (l == 1) {
            delete listeners[type];
          } else {
            arr.splice(i2, 1);
          }
          break;
        }
      }
    };
    p.off = p.removeEventListener;
    p.removeAllEventListeners = function(type) {
      if (!type) {
        this._listeners = this._captureListeners = null;
      } else {
        if (this._listeners) {
          delete this._listeners[type];
        }
        if (this._captureListeners) {
          delete this._captureListeners[type];
        }
      }
    };
    p.dispatchEvent = function(eventObj, bubbles, cancelable) {
      if (typeof eventObj == "string") {
        var listeners = this._listeners;
        if (!bubbles && (!listeners || !listeners[eventObj])) {
          return true;
        }
        eventObj = new createjs2.Event(eventObj, bubbles, cancelable);
      } else if (eventObj.target && eventObj.clone) {
        eventObj = eventObj.clone();
      }
      try {
        eventObj.target = this;
      } catch (e) {
      }
      if (!eventObj.bubbles || !this.parent) {
        this._dispatchEvent(eventObj, 2);
      } else {
        var top = this, list2 = [top];
        while (top.parent) {
          list2.push(top = top.parent);
        }
        var i2, l = list2.length;
        for (i2 = l - 1; i2 >= 0 && !eventObj.propagationStopped; i2--) {
          list2[i2]._dispatchEvent(eventObj, 1 + (i2 == 0));
        }
        for (i2 = 1; i2 < l && !eventObj.propagationStopped; i2++) {
          list2[i2]._dispatchEvent(eventObj, 3);
        }
      }
      return !eventObj.defaultPrevented;
    };
    p.hasEventListener = function(type) {
      var listeners = this._listeners, captureListeners = this._captureListeners;
      return !!(listeners && listeners[type] || captureListeners && captureListeners[type]);
    };
    p.willTrigger = function(type) {
      var o = this;
      while (o) {
        if (o.hasEventListener(type)) {
          return true;
        }
        o = o.parent;
      }
      return false;
    };
    p.toString = function() {
      return "[EventDispatcher]";
    };
    p._dispatchEvent = function(eventObj, eventPhase) {
      var l, listeners = eventPhase == 1 ? this._captureListeners : this._listeners;
      if (eventObj && listeners) {
        var arr = listeners[eventObj.type];
        if (!arr || !(l = arr.length)) {
          return;
        }
        try {
          eventObj.currentTarget = this;
        } catch (e) {
        }
        try {
          eventObj.eventPhase = eventPhase;
        } catch (e) {
        }
        eventObj.removed = false;
        arr = arr.slice();
        for (var i2 = 0; i2 < l && !eventObj.immediatePropagationStopped; i2++) {
          var o = arr[i2];
          if (o.handleEvent) {
            o.handleEvent(eventObj);
          } else {
            o(eventObj);
          }
          if (eventObj.removed) {
            this.off(eventObj.type, o, eventPhase == 1);
            eventObj.removed = false;
          }
        }
      }
    };
    createjs2.EventDispatcher = EventDispatcher2;
  })();
  (function() {
    function Ticker() {
      throw "Ticker cannot be instantiated.";
    }
    Ticker.RAF_SYNCHED = "synched";
    Ticker.RAF = "raf";
    Ticker.TIMEOUT = "timeout";
    Ticker.useRAF = false;
    Ticker.timingMode = null;
    Ticker.maxDelta = 0;
    Ticker.paused = false;
    Ticker.removeEventListener = null;
    Ticker.removeAllEventListeners = null;
    Ticker.dispatchEvent = null;
    Ticker.hasEventListener = null;
    Ticker._listeners = null;
    createjs2.EventDispatcher.initialize(Ticker);
    Ticker._addEventListener = Ticker.addEventListener;
    Ticker.addEventListener = function() {
      !Ticker._inited && Ticker.init();
      return Ticker._addEventListener.apply(Ticker, arguments);
    };
    Ticker._inited = false;
    Ticker._startTime = 0;
    Ticker._pausedTime = 0;
    Ticker._ticks = 0;
    Ticker._pausedTicks = 0;
    Ticker._interval = 50;
    Ticker._lastTime = 0;
    Ticker._times = null;
    Ticker._tickTimes = null;
    Ticker._timerId = null;
    Ticker._raf = true;
    Ticker.setInterval = function(interval) {
      Ticker._interval = interval;
      if (!Ticker._inited) {
        return;
      }
      Ticker._setupTick();
    };
    Ticker.getInterval = function() {
      return Ticker._interval;
    };
    Ticker.setFPS = function(value) {
      Ticker.setInterval(1e3 / value);
    };
    Ticker.getFPS = function() {
      return 1e3 / Ticker._interval;
    };
    try {
      Object.defineProperties(Ticker, {
        interval: { get: Ticker.getInterval, set: Ticker.setInterval },
        framerate: { get: Ticker.getFPS, set: Ticker.setFPS }
      });
    } catch (e) {
      console.log(e);
    }
    Ticker.init = function() {
      if (Ticker._inited) {
        return;
      }
      Ticker._inited = true;
      Ticker._times = [];
      Ticker._tickTimes = [];
      Ticker._startTime = Ticker._getTime();
      Ticker._times.push(Ticker._lastTime = 0);
      Ticker.interval = Ticker._interval;
    };
    Ticker.reset = function() {
      if (Ticker._raf) {
        var f = window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.oCancelAnimationFrame || window.msCancelAnimationFrame;
        f && f(Ticker._timerId);
      } else {
        clearTimeout(Ticker._timerId);
      }
      Ticker.removeAllEventListeners("tick");
      Ticker._timerId = Ticker._times = Ticker._tickTimes = null;
      Ticker._startTime = Ticker._lastTime = Ticker._ticks = 0;
      Ticker._inited = false;
    };
    Ticker.getMeasuredTickTime = function(ticks) {
      var ttl = 0, times = Ticker._tickTimes;
      if (!times || times.length < 1) {
        return -1;
      }
      ticks = Math.min(times.length, ticks || Ticker.getFPS() | 0);
      for (var i2 = 0; i2 < ticks; i2++) {
        ttl += times[i2];
      }
      return ttl / ticks;
    };
    Ticker.getMeasuredFPS = function(ticks) {
      var times = Ticker._times;
      if (!times || times.length < 2) {
        return -1;
      }
      ticks = Math.min(times.length - 1, ticks || Ticker.getFPS() | 0);
      return 1e3 / ((times[0] - times[ticks]) / ticks);
    };
    Ticker.setPaused = function(value) {
      Ticker.paused = value;
    };
    Ticker.getPaused = function() {
      return Ticker.paused;
    };
    Ticker.getTime = function(runTime) {
      return Ticker._startTime ? Ticker._getTime() - (runTime ? Ticker._pausedTime : 0) : -1;
    };
    Ticker.getEventTime = function(runTime) {
      return Ticker._startTime ? (Ticker._lastTime || Ticker._startTime) - (runTime ? Ticker._pausedTime : 0) : -1;
    };
    Ticker.getTicks = function(pauseable) {
      return Ticker._ticks - (pauseable ? Ticker._pausedTicks : 0);
    };
    Ticker._handleSynch = function() {
      Ticker._timerId = null;
      Ticker._setupTick();
      if (Ticker._getTime() - Ticker._lastTime >= (Ticker._interval - 1) * 0.97) {
        Ticker._tick();
      }
    };
    Ticker._handleRAF = function() {
      Ticker._timerId = null;
      Ticker._setupTick();
      Ticker._tick();
    };
    Ticker._handleTimeout = function() {
      Ticker._timerId = null;
      Ticker._setupTick();
      Ticker._tick();
    };
    Ticker._setupTick = function() {
      if (Ticker._timerId != null) {
        return;
      }
      var mode = Ticker.timingMode || Ticker.useRAF && Ticker.RAF_SYNCHED;
      if (mode == Ticker.RAF_SYNCHED || mode == Ticker.RAF) {
        var f = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame;
        if (f) {
          Ticker._timerId = f(mode == Ticker.RAF ? Ticker._handleRAF : Ticker._handleSynch);
          Ticker._raf = true;
          return;
        }
      }
      Ticker._raf = false;
      Ticker._timerId = setTimeout(Ticker._handleTimeout, Ticker._interval);
    };
    Ticker._tick = function() {
      var paused = Ticker.paused;
      var time = Ticker._getTime();
      var elapsedTime = time - Ticker._lastTime;
      Ticker._lastTime = time;
      Ticker._ticks++;
      if (paused) {
        Ticker._pausedTicks++;
        Ticker._pausedTime += elapsedTime;
      }
      if (Ticker.hasEventListener("tick")) {
        var event = new createjs2.Event("tick");
        var maxDelta = Ticker.maxDelta;
        event.delta = maxDelta && elapsedTime > maxDelta ? maxDelta : elapsedTime;
        event.paused = paused;
        event.time = time;
        event.runTime = time - Ticker._pausedTime;
        Ticker.dispatchEvent(event);
      }
      Ticker._tickTimes.unshift(Ticker._getTime() - time);
      while (Ticker._tickTimes.length > 100) {
        Ticker._tickTimes.pop();
      }
      Ticker._times.unshift(time);
      while (Ticker._times.length > 100) {
        Ticker._times.pop();
      }
    };
    var now2 = window.performance && (performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow);
    Ticker._getTime = function() {
      return (now2 && now2.call(performance) || (/* @__PURE__ */ new Date()).getTime()) - Ticker._startTime;
    };
    createjs2.Ticker = Ticker;
  })();
  (function() {
    function UID() {
      throw "UID cannot be instantiated";
    }
    UID._nextID = 0;
    UID.get = function() {
      return UID._nextID++;
    };
    createjs2.UID = UID;
  })();
  (function() {
    function MouseEvent2(type, bubbles, cancelable, stageX, stageY, nativeEvent, pointerID, primary, rawX, rawY, relatedTarget) {
      this.Event_constructor(type, bubbles, cancelable);
      this.stageX = stageX;
      this.stageY = stageY;
      this.rawX = rawX == null ? stageX : rawX;
      this.rawY = rawY == null ? stageY : rawY;
      this.nativeEvent = nativeEvent;
      this.pointerID = pointerID;
      this.primary = !!primary;
      this.relatedTarget = relatedTarget;
    }
    var p = createjs2.extend(MouseEvent2, createjs2.Event);
    p._get_localX = function() {
      return this.currentTarget.globalToLocal(this.rawX, this.rawY).x;
    };
    p._get_localY = function() {
      return this.currentTarget.globalToLocal(this.rawX, this.rawY).y;
    };
    p._get_isTouch = function() {
      return this.pointerID !== -1;
    };
    try {
      Object.defineProperties(p, {
        localX: { get: p._get_localX },
        localY: { get: p._get_localY },
        isTouch: { get: p._get_isTouch }
      });
    } catch (e) {
    }
    p.clone = function() {
      return new MouseEvent2(this.type, this.bubbles, this.cancelable, this.stageX, this.stageY, this.nativeEvent, this.pointerID, this.primary, this.rawX, this.rawY);
    };
    p.toString = function() {
      return "[MouseEvent (type=" + this.type + " stageX=" + this.stageX + " stageY=" + this.stageY + ")]";
    };
    createjs2.MouseEvent = createjs2.promote(MouseEvent2, "Event");
  })();
  (function() {
    function Matrix2D(a, b, c, d2, tx, ty) {
      this.setValues(a, b, c, d2, tx, ty);
    }
    var p = Matrix2D.prototype;
    Matrix2D.DEG_TO_RAD = Math.PI / 180;
    Matrix2D.identity = null;
    p.setValues = function(a, b, c, d2, tx, ty) {
      this.a = a == null ? 1 : a;
      this.b = b || 0;
      this.c = c || 0;
      this.d = d2 == null ? 1 : d2;
      this.tx = tx || 0;
      this.ty = ty || 0;
      return this;
    };
    p.append = function(a, b, c, d2, tx, ty) {
      var a1 = this.a;
      var b1 = this.b;
      var c1 = this.c;
      var d1 = this.d;
      if (a != 1 || b != 0 || c != 0 || d2 != 1) {
        this.a = a1 * a + c1 * b;
        this.b = b1 * a + d1 * b;
        this.c = a1 * c + c1 * d2;
        this.d = b1 * c + d1 * d2;
      }
      this.tx = a1 * tx + c1 * ty + this.tx;
      this.ty = b1 * tx + d1 * ty + this.ty;
      return this;
    };
    p.prepend = function(a, b, c, d2, tx, ty) {
      var a1 = this.a;
      var c1 = this.c;
      var tx1 = this.tx;
      this.a = a * a1 + c * this.b;
      this.b = b * a1 + d2 * this.b;
      this.c = a * c1 + c * this.d;
      this.d = b * c1 + d2 * this.d;
      this.tx = a * tx1 + c * this.ty + tx;
      this.ty = b * tx1 + d2 * this.ty + ty;
      return this;
    };
    p.appendMatrix = function(matrix2) {
      return this.append(matrix2.a, matrix2.b, matrix2.c, matrix2.d, matrix2.tx, matrix2.ty);
    };
    p.prependMatrix = function(matrix2) {
      return this.prepend(matrix2.a, matrix2.b, matrix2.c, matrix2.d, matrix2.tx, matrix2.ty);
    };
    p.appendTransform = function(x2, y, scaleX, scaleY, rotation, skewX, skewY, regX, regY) {
      if (rotation % 360) {
        var r = rotation * Matrix2D.DEG_TO_RAD;
        var cos = Math.cos(r);
        var sin = Math.sin(r);
      } else {
        cos = 1;
        sin = 0;
      }
      if (skewX || skewY) {
        skewX *= Matrix2D.DEG_TO_RAD;
        skewY *= Matrix2D.DEG_TO_RAD;
        this.append(Math.cos(skewY), Math.sin(skewY), -Math.sin(skewX), Math.cos(skewX), x2, y);
        this.append(cos * scaleX, sin * scaleX, -sin * scaleY, cos * scaleY, 0, 0);
      } else {
        this.append(cos * scaleX, sin * scaleX, -sin * scaleY, cos * scaleY, x2, y);
      }
      if (regX || regY) {
        this.tx -= regX * this.a + regY * this.c;
        this.ty -= regX * this.b + regY * this.d;
      }
      return this;
    };
    p.prependTransform = function(x2, y, scaleX, scaleY, rotation, skewX, skewY, regX, regY) {
      if (rotation % 360) {
        var r = rotation * Matrix2D.DEG_TO_RAD;
        var cos = Math.cos(r);
        var sin = Math.sin(r);
      } else {
        cos = 1;
        sin = 0;
      }
      if (regX || regY) {
        this.tx -= regX;
        this.ty -= regY;
      }
      if (skewX || skewY) {
        skewX *= Matrix2D.DEG_TO_RAD;
        skewY *= Matrix2D.DEG_TO_RAD;
        this.prepend(cos * scaleX, sin * scaleX, -sin * scaleY, cos * scaleY, 0, 0);
        this.prepend(Math.cos(skewY), Math.sin(skewY), -Math.sin(skewX), Math.cos(skewX), x2, y);
      } else {
        this.prepend(cos * scaleX, sin * scaleX, -sin * scaleY, cos * scaleY, x2, y);
      }
      return this;
    };
    p.rotate = function(angle) {
      angle = angle * Matrix2D.DEG_TO_RAD;
      var cos = Math.cos(angle);
      var sin = Math.sin(angle);
      var a1 = this.a;
      var b1 = this.b;
      this.a = a1 * cos + this.c * sin;
      this.b = b1 * cos + this.d * sin;
      this.c = -a1 * sin + this.c * cos;
      this.d = -b1 * sin + this.d * cos;
      return this;
    };
    p.skew = function(skewX, skewY) {
      skewX = skewX * Matrix2D.DEG_TO_RAD;
      skewY = skewY * Matrix2D.DEG_TO_RAD;
      this.append(Math.cos(skewY), Math.sin(skewY), -Math.sin(skewX), Math.cos(skewX), 0, 0);
      return this;
    };
    p.scale = function(x2, y) {
      this.a *= x2;
      this.b *= x2;
      this.c *= y;
      this.d *= y;
      return this;
    };
    p.translate = function(x2, y) {
      this.tx += this.a * x2 + this.c * y;
      this.ty += this.b * x2 + this.d * y;
      return this;
    };
    p.identity = function() {
      this.a = this.d = 1;
      this.b = this.c = this.tx = this.ty = 0;
      return this;
    };
    p.invert = function() {
      var a1 = this.a;
      var b1 = this.b;
      var c1 = this.c;
      var d1 = this.d;
      var tx1 = this.tx;
      var n2 = a1 * d1 - b1 * c1;
      this.a = d1 / n2;
      this.b = -b1 / n2;
      this.c = -c1 / n2;
      this.d = a1 / n2;
      this.tx = (c1 * this.ty - d1 * tx1) / n2;
      this.ty = -(a1 * this.ty - b1 * tx1) / n2;
      return this;
    };
    p.isIdentity = function() {
      return this.tx === 0 && this.ty === 0 && this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1;
    };
    p.equals = function(matrix2) {
      return this.tx === matrix2.tx && this.ty === matrix2.ty && this.a === matrix2.a && this.b === matrix2.b && this.c === matrix2.c && this.d === matrix2.d;
    };
    p.transformPoint = function(x2, y, pt) {
      pt = pt || {};
      pt.x = x2 * this.a + y * this.c + this.tx;
      pt.y = x2 * this.b + y * this.d + this.ty;
      return pt;
    };
    p.decompose = function(target2) {
      if (target2 == null) {
        target2 = {};
      }
      target2.x = this.tx;
      target2.y = this.ty;
      target2.scaleX = Math.sqrt(this.a * this.a + this.b * this.b);
      target2.scaleY = Math.sqrt(this.c * this.c + this.d * this.d);
      var skewX = Math.atan2(-this.c, this.d);
      var skewY = Math.atan2(this.b, this.a);
      var delta = Math.abs(1 - skewX / skewY);
      if (delta < 1e-5) {
        target2.rotation = skewY / Matrix2D.DEG_TO_RAD;
        if (this.a < 0 && this.d >= 0) {
          target2.rotation += target2.rotation <= 0 ? 180 : -180;
        }
        target2.skewX = target2.skewY = 0;
      } else {
        target2.skewX = skewX / Matrix2D.DEG_TO_RAD;
        target2.skewY = skewY / Matrix2D.DEG_TO_RAD;
      }
      return target2;
    };
    p.copy = function(matrix2) {
      return this.setValues(matrix2.a, matrix2.b, matrix2.c, matrix2.d, matrix2.tx, matrix2.ty);
    };
    p.clone = function() {
      return new Matrix2D(this.a, this.b, this.c, this.d, this.tx, this.ty);
    };
    p.toString = function() {
      return "[Matrix2D (a=" + this.a + " b=" + this.b + " c=" + this.c + " d=" + this.d + " tx=" + this.tx + " ty=" + this.ty + ")]";
    };
    Matrix2D.identity = new Matrix2D();
    createjs2.Matrix2D = Matrix2D;
  })();
  (function() {
    function DisplayProps(visible, alpha, shadow, compositeOperation, matrix2) {
      this.setValues(visible, alpha, shadow, compositeOperation, matrix2);
    }
    var p = DisplayProps.prototype;
    p.setValues = function(visible, alpha, shadow, compositeOperation, matrix2) {
      this.visible = visible == null ? true : !!visible;
      this.alpha = alpha == null ? 1 : alpha;
      this.shadow = shadow;
      this.compositeOperation = compositeOperation;
      this.matrix = matrix2 || this.matrix && this.matrix.identity() || new createjs2.Matrix2D();
      return this;
    };
    p.append = function(visible, alpha, shadow, compositeOperation, matrix2) {
      this.alpha *= alpha;
      this.shadow = shadow || this.shadow;
      this.compositeOperation = compositeOperation || this.compositeOperation;
      this.visible = this.visible && visible;
      matrix2 && this.matrix.appendMatrix(matrix2);
      return this;
    };
    p.prepend = function(visible, alpha, shadow, compositeOperation, matrix2) {
      this.alpha *= alpha;
      this.shadow = this.shadow || shadow;
      this.compositeOperation = this.compositeOperation || compositeOperation;
      this.visible = this.visible && visible;
      matrix2 && this.matrix.prependMatrix(matrix2);
      return this;
    };
    p.identity = function() {
      this.visible = true;
      this.alpha = 1;
      this.shadow = this.compositeOperation = null;
      this.matrix.identity();
      return this;
    };
    p.clone = function() {
      return new DisplayProps(this.alpha, this.shadow, this.compositeOperation, this.visible, this.matrix.clone());
    };
    createjs2.DisplayProps = DisplayProps;
  })();
  (function() {
    function Point(x2, y) {
      this.setValues(x2, y);
    }
    var p = Point.prototype;
    p.setValues = function(x2, y) {
      this.x = x2 || 0;
      this.y = y || 0;
      return this;
    };
    p.copy = function(point) {
      this.x = point.x;
      this.y = point.y;
      return this;
    };
    p.clone = function() {
      return new Point(this.x, this.y);
    };
    p.toString = function() {
      return "[Point (x=" + this.x + " y=" + this.y + ")]";
    };
    createjs2.Point = Point;
  })();
  (function() {
    function Rectangle(x2, y, width, height) {
      this.setValues(x2, y, width, height);
    }
    var p = Rectangle.prototype;
    p.setValues = function(x2, y, width, height) {
      this.x = x2 || 0;
      this.y = y || 0;
      this.width = width || 0;
      this.height = height || 0;
      return this;
    };
    p.extend = function(x2, y, width, height) {
      width = width || 0;
      height = height || 0;
      if (x2 + width > this.x + this.width) {
        this.width = x2 + width - this.x;
      }
      if (y + height > this.y + this.height) {
        this.height = y + height - this.y;
      }
      if (x2 < this.x) {
        this.width += this.x - x2;
        this.x = x2;
      }
      if (y < this.y) {
        this.height += this.y - y;
        this.y = y;
      }
      return this;
    };
    p.pad = function(top, left, bottom, right) {
      this.x -= left;
      this.y -= top;
      this.width += left + right;
      this.height += top + bottom;
      return this;
    };
    p.copy = function(rectangle) {
      return this.setValues(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    p.contains = function(x2, y, width, height) {
      width = width || 0;
      height = height || 0;
      return x2 >= this.x && x2 + width <= this.x + this.width && y >= this.y && y + height <= this.y + this.height;
    };
    p.union = function(rect) {
      return this.clone().extend(rect.x, rect.y, rect.width, rect.height);
    };
    p.intersection = function(rect) {
      var x1 = rect.x, y1 = rect.y, x2 = x1 + rect.width, y2 = y1 + rect.height;
      if (this.x > x1) {
        x1 = this.x;
      }
      if (this.y > y1) {
        y1 = this.y;
      }
      if (this.x + this.width < x2) {
        x2 = this.x + this.width;
      }
      if (this.y + this.height < y2) {
        y2 = this.y + this.height;
      }
      return x2 <= x1 || y2 <= y1 ? null : new Rectangle(x1, y1, x2 - x1, y2 - y1);
    };
    p.intersects = function(rect) {
      return rect.x <= this.x + this.width && this.x <= rect.x + rect.width && rect.y <= this.y + this.height && this.y <= rect.y + rect.height;
    };
    p.isEmpty = function() {
      return this.width <= 0 || this.height <= 0;
    };
    p.clone = function() {
      return new Rectangle(this.x, this.y, this.width, this.height);
    };
    p.toString = function() {
      return "[Rectangle (x=" + this.x + " y=" + this.y + " width=" + this.width + " height=" + this.height + ")]";
    };
    createjs2.Rectangle = Rectangle;
  })();
  (function() {
    function ButtonHelper(target2, outLabel, overLabel, downLabel, play, hitArea, hitLabel) {
      if (!target2.addEventListener) {
        return;
      }
      this.target = target2;
      this.overLabel = overLabel == null ? "over" : overLabel;
      this.outLabel = outLabel == null ? "out" : outLabel;
      this.downLabel = downLabel == null ? "down" : downLabel;
      this.play = play;
      this._isPressed = false;
      this._isOver = false;
      this._enabled = false;
      target2.mouseChildren = false;
      this.enabled = true;
      this.handleEvent({});
      if (hitArea) {
        if (hitLabel) {
          hitArea.actionsEnabled = false;
          hitArea.gotoAndStop && hitArea.gotoAndStop(hitLabel);
        }
        target2.hitArea = hitArea;
      }
    }
    var p = ButtonHelper.prototype;
    p.setEnabled = function(value) {
      if (value == this._enabled) {
        return;
      }
      var o = this.target;
      this._enabled = value;
      if (value) {
        o.cursor = "pointer";
        o.addEventListener("rollover", this);
        o.addEventListener("rollout", this);
        o.addEventListener("mousedown", this);
        o.addEventListener("pressup", this);
        if (o._reset) {
          o.__reset = o._reset;
          o._reset = this._reset;
        }
      } else {
        o.cursor = null;
        o.removeEventListener("rollover", this);
        o.removeEventListener("rollout", this);
        o.removeEventListener("mousedown", this);
        o.removeEventListener("pressup", this);
        if (o.__reset) {
          o._reset = o.__reset;
          delete o.__reset;
        }
      }
    };
    p.getEnabled = function() {
      return this._enabled;
    };
    try {
      Object.defineProperties(p, {
        enabled: { get: p.getEnabled, set: p.setEnabled }
      });
    } catch (e) {
    }
    p.toString = function() {
      return "[ButtonHelper]";
    };
    p.handleEvent = function(evt) {
      var label, t3 = this.target, type = evt.type;
      if (type == "mousedown") {
        this._isPressed = true;
        label = this.downLabel;
      } else if (type == "pressup") {
        this._isPressed = false;
        label = this._isOver ? this.overLabel : this.outLabel;
      } else if (type == "rollover") {
        this._isOver = true;
        label = this._isPressed ? this.downLabel : this.overLabel;
      } else {
        this._isOver = false;
        label = this._isPressed ? this.overLabel : this.outLabel;
      }
      if (this.play) {
        t3.gotoAndPlay && t3.gotoAndPlay(label);
      } else {
        t3.gotoAndStop && t3.gotoAndStop(label);
      }
    };
    p._reset = function() {
      var p2 = this.paused;
      this.__reset();
      this.paused = p2;
    };
    createjs2.ButtonHelper = ButtonHelper;
  })();
  (function() {
    function Shadow2(color2, offsetX, offsetY, blur) {
      this.color = color2 || "black";
      this.offsetX = offsetX || 0;
      this.offsetY = offsetY || 0;
      this.blur = blur || 0;
    }
    var p = Shadow2.prototype;
    Shadow2.identity = new Shadow2("transparent", 0, 0, 0);
    p.toString = function() {
      return "[Shadow]";
    };
    p.clone = function() {
      return new Shadow2(this.color, this.offsetX, this.offsetY, this.blur);
    };
    createjs2.Shadow = Shadow2;
  })();
  (function() {
    function SpriteSheet(data) {
      this.EventDispatcher_constructor();
      this.complete = true;
      this.framerate = 0;
      this._animations = null;
      this._frames = null;
      this._images = null;
      this._data = null;
      this._loadCount = 0;
      this._frameHeight = 0;
      this._frameWidth = 0;
      this._numFrames = 0;
      this._regX = 0;
      this._regY = 0;
      this._spacing = 0;
      this._margin = 0;
      this._parseData(data);
    }
    var p = createjs2.extend(SpriteSheet, createjs2.EventDispatcher);
    p.getAnimations = function() {
      return this._animations.slice();
    };
    try {
      Object.defineProperties(p, {
        animations: { get: p.getAnimations }
      });
    } catch (e) {
    }
    p.getNumFrames = function(animation) {
      if (animation == null) {
        return this._frames ? this._frames.length : this._numFrames || 0;
      } else {
        var data = this._data[animation];
        if (data == null) {
          return 0;
        } else {
          return data.frames.length;
        }
      }
    };
    p.getAnimation = function(name) {
      return this._data[name];
    };
    p.getFrame = function(frameIndex) {
      var frame;
      if (this._frames && (frame = this._frames[frameIndex])) {
        return frame;
      }
      return null;
    };
    p.getFrameBounds = function(frameIndex, rectangle) {
      var frame = this.getFrame(frameIndex);
      return frame ? (rectangle || new createjs2.Rectangle()).setValues(-frame.regX, -frame.regY, frame.rect.width, frame.rect.height) : null;
    };
    p.toString = function() {
      return "[SpriteSheet]";
    };
    p.clone = function() {
      throw "SpriteSheet cannot be cloned.";
    };
    p._parseData = function(data) {
      var i2, l, o, a;
      if (data == null) {
        return;
      }
      this.framerate = data.framerate || 0;
      if (data.images && (l = data.images.length) > 0) {
        a = this._images = [];
        for (i2 = 0; i2 < l; i2++) {
          var img = data.images[i2];
          if (typeof img == "string") {
            var src = img;
            img = document.createElement("img");
            img.src = src;
          }
          a.push(img);
          if (!img.getContext && !img.naturalWidth) {
            this._loadCount++;
            this.complete = false;
            (function(o2, src2) {
              img.onload = function() {
                o2._handleImageLoad(src2);
              };
            })(this, src);
            (function(o2, src2) {
              img.onerror = function() {
                o2._handleImageError(src2);
              };
            })(this, src);
          }
        }
      }
      if (data.frames == null)
        ;
      else if (Array.isArray(data.frames)) {
        this._frames = [];
        a = data.frames;
        for (i2 = 0, l = a.length; i2 < l; i2++) {
          var arr = a[i2];
          this._frames.push({ image: this._images[arr[4] ? arr[4] : 0], rect: new createjs2.Rectangle(arr[0], arr[1], arr[2], arr[3]), regX: arr[5] || 0, regY: arr[6] || 0 });
        }
      } else {
        o = data.frames;
        this._frameWidth = o.width;
        this._frameHeight = o.height;
        this._regX = o.regX || 0;
        this._regY = o.regY || 0;
        this._spacing = o.spacing || 0;
        this._margin = o.margin || 0;
        this._numFrames = o.count;
        if (this._loadCount == 0) {
          this._calculateFrames();
        }
      }
      this._animations = [];
      if ((o = data.animations) != null) {
        this._data = {};
        var name;
        for (name in o) {
          var anim = { name };
          var obj = o[name];
          if (typeof obj == "number") {
            a = anim.frames = [obj];
          } else if (Array.isArray(obj)) {
            if (obj.length == 1) {
              anim.frames = [obj[0]];
            } else {
              anim.speed = obj[3];
              anim.next = obj[2];
              a = anim.frames = [];
              for (i2 = obj[0]; i2 <= obj[1]; i2++) {
                a.push(i2);
              }
            }
          } else {
            anim.speed = obj.speed;
            anim.next = obj.next;
            var frames = obj.frames;
            a = anim.frames = typeof frames == "number" ? [frames] : frames.slice(0);
          }
          if (anim.next === true || anim.next === void 0) {
            anim.next = name;
          }
          if (anim.next === false || a.length < 2 && anim.next == name) {
            anim.next = null;
          }
          if (!anim.speed) {
            anim.speed = 1;
          }
          this._animations.push(name);
          this._data[name] = anim;
        }
      }
    };
    p._handleImageLoad = function(src) {
      if (--this._loadCount == 0) {
        this._calculateFrames();
        this.complete = true;
        this.dispatchEvent("complete");
      }
    };
    p._handleImageError = function(src) {
      var errorEvent = new createjs2.Event("error");
      errorEvent.src = src;
      this.dispatchEvent(errorEvent);
      if (--this._loadCount == 0) {
        this.dispatchEvent("complete");
      }
    };
    p._calculateFrames = function() {
      if (this._frames || this._frameWidth == 0) {
        return;
      }
      this._frames = [];
      var maxFrames = this._numFrames || 1e5;
      var frameCount = 0, frameWidth = this._frameWidth, frameHeight = this._frameHeight;
      var spacing = this._spacing, margin = this._margin;
      imgLoop:
        for (var i2 = 0, imgs = this._images; i2 < imgs.length; i2++) {
          var img = imgs[i2], imgW = img.width, imgH = img.height;
          var y = margin;
          while (y <= imgH - margin - frameHeight) {
            var x2 = margin;
            while (x2 <= imgW - margin - frameWidth) {
              if (frameCount >= maxFrames) {
                break imgLoop;
              }
              frameCount++;
              this._frames.push({
                image: img,
                rect: new createjs2.Rectangle(x2, y, frameWidth, frameHeight),
                regX: this._regX,
                regY: this._regY
              });
              x2 += frameWidth + spacing;
            }
            y += frameHeight + spacing;
          }
        }
      this._numFrames = frameCount;
    };
    createjs2.SpriteSheet = createjs2.promote(SpriteSheet, "EventDispatcher");
  })();
  (function() {
    function Graphics() {
      this.command = null;
      this._stroke = null;
      this._strokeStyle = null;
      this._oldStrokeStyle = null;
      this._strokeDash = null;
      this._oldStrokeDash = null;
      this._strokeIgnoreScale = false;
      this._fill = null;
      this._instructions = [];
      this._commitIndex = 0;
      this._activeInstructions = [];
      this._dirty = false;
      this._storeIndex = 0;
      this.clear();
    }
    var p = Graphics.prototype;
    var G = Graphics;
    Graphics.getRGB = function(r, g, b, alpha) {
      if (r != null && b == null) {
        alpha = g;
        b = r & 255;
        g = r >> 8 & 255;
        r = r >> 16 & 255;
      }
      if (alpha == null) {
        return "rgb(" + r + "," + g + "," + b + ")";
      } else {
        return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
      }
    };
    Graphics.getHSL = function(hue, saturation, lightness, alpha) {
      if (alpha == null) {
        return "hsl(" + hue % 360 + "," + saturation + "%," + lightness + "%)";
      } else {
        return "hsla(" + hue % 360 + "," + saturation + "%," + lightness + "%," + alpha + ")";
      }
    };
    Graphics.BASE_64 = { "A": 0, "B": 1, "C": 2, "D": 3, "E": 4, "F": 5, "G": 6, "H": 7, "I": 8, "J": 9, "K": 10, "L": 11, "M": 12, "N": 13, "O": 14, "P": 15, "Q": 16, "R": 17, "S": 18, "T": 19, "U": 20, "V": 21, "W": 22, "X": 23, "Y": 24, "Z": 25, "a": 26, "b": 27, "c": 28, "d": 29, "e": 30, "f": 31, "g": 32, "h": 33, "i": 34, "j": 35, "k": 36, "l": 37, "m": 38, "n": 39, "o": 40, "p": 41, "q": 42, "r": 43, "s": 44, "t": 45, "u": 46, "v": 47, "w": 48, "x": 49, "y": 50, "z": 51, "0": 52, "1": 53, "2": 54, "3": 55, "4": 56, "5": 57, "6": 58, "7": 59, "8": 60, "9": 61, "+": 62, "/": 63 };
    Graphics.STROKE_CAPS_MAP = ["butt", "round", "square"];
    Graphics.STROKE_JOINTS_MAP = ["miter", "round", "bevel"];
    var canvas = createjs2.createCanvas ? createjs2.createCanvas() : document.createElement("canvas");
    if (canvas.getContext) {
      Graphics._ctx = canvas.getContext("2d");
      canvas.width = canvas.height = 1;
    }
    p.getInstructions = function() {
      this._updateInstructions();
      return this._instructions;
    };
    try {
      Object.defineProperties(p, {
        instructions: { get: p.getInstructions }
      });
    } catch (e) {
    }
    p.isEmpty = function() {
      return !(this._instructions.length || this._activeInstructions.length);
    };
    p.draw = function(ctx, data) {
      this._updateInstructions();
      var instr = this._instructions;
      for (var i2 = this._storeIndex, l = instr.length; i2 < l; i2++) {
        instr[i2].exec(ctx, data);
      }
    };
    p.drawAsPath = function(ctx) {
      this._updateInstructions();
      var instr, instrs = this._instructions;
      for (var i2 = this._storeIndex, l = instrs.length; i2 < l; i2++) {
        if ((instr = instrs[i2]).path !== false) {
          instr.exec(ctx);
        }
      }
    };
    p.moveTo = function(x2, y) {
      return this.append(new G.MoveTo(x2, y), true);
    };
    p.lineTo = function(x2, y) {
      return this.append(new G.LineTo(x2, y));
    };
    p.arcTo = function(x1, y1, x2, y2, radius) {
      return this.append(new G.ArcTo(x1, y1, x2, y2, radius));
    };
    p.arc = function(x2, y, radius, startAngle, endAngle, anticlockwise) {
      return this.append(new G.Arc(x2, y, radius, startAngle, endAngle, anticlockwise));
    };
    p.quadraticCurveTo = function(cpx, cpy, x2, y) {
      return this.append(new G.QuadraticCurveTo(cpx, cpy, x2, y));
    };
    p.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x2, y) {
      return this.append(new G.BezierCurveTo(cp1x, cp1y, cp2x, cp2y, x2, y));
    };
    p.rect = function(x2, y, w, h) {
      return this.append(new G.Rect(x2, y, w, h));
    };
    p.closePath = function() {
      return this._activeInstructions.length ? this.append(new G.ClosePath()) : this;
    };
    p.clear = function() {
      this._instructions.length = this._activeInstructions.length = this._commitIndex = 0;
      this._strokeStyle = this._oldStrokeStyle = this._stroke = this._fill = this._strokeDash = this._oldStrokeDash = null;
      this._dirty = this._strokeIgnoreScale = false;
      return this;
    };
    p.beginFill = function(color2) {
      return this._setFill(color2 ? new G.Fill(color2) : null);
    };
    p.beginLinearGradientFill = function(colors, ratios, x0, y0, x1, y1) {
      return this._setFill(new G.Fill().linearGradient(colors, ratios, x0, y0, x1, y1));
    };
    p.beginRadialGradientFill = function(colors, ratios, x0, y0, r0, x1, y1, r1) {
      return this._setFill(new G.Fill().radialGradient(colors, ratios, x0, y0, r0, x1, y1, r1));
    };
    p.beginBitmapFill = function(image, repetition, matrix2) {
      return this._setFill(new G.Fill(null, matrix2).bitmap(image, repetition));
    };
    p.endFill = function() {
      return this.beginFill();
    };
    p.setStrokeStyle = function(thickness, caps, joints, miterLimit, ignoreScale) {
      this._updateInstructions(true);
      this._strokeStyle = this.command = new G.StrokeStyle(thickness, caps, joints, miterLimit, ignoreScale);
      if (this._stroke) {
        this._stroke.ignoreScale = ignoreScale;
      }
      this._strokeIgnoreScale = ignoreScale;
      return this;
    };
    p.setStrokeDash = function(segments, offset2) {
      this._updateInstructions(true);
      this._strokeDash = this.command = new G.StrokeDash(segments, offset2);
      return this;
    };
    p.beginStroke = function(color2) {
      return this._setStroke(color2 ? new G.Stroke(color2) : null);
    };
    p.beginLinearGradientStroke = function(colors, ratios, x0, y0, x1, y1) {
      return this._setStroke(new G.Stroke().linearGradient(colors, ratios, x0, y0, x1, y1));
    };
    p.beginRadialGradientStroke = function(colors, ratios, x0, y0, r0, x1, y1, r1) {
      return this._setStroke(new G.Stroke().radialGradient(colors, ratios, x0, y0, r0, x1, y1, r1));
    };
    p.beginBitmapStroke = function(image, repetition) {
      return this._setStroke(new G.Stroke().bitmap(image, repetition));
    };
    p.endStroke = function() {
      return this.beginStroke();
    };
    p.curveTo = p.quadraticCurveTo;
    p.drawRect = p.rect;
    p.drawRoundRect = function(x2, y, w, h, radius) {
      return this.drawRoundRectComplex(x2, y, w, h, radius, radius, radius, radius);
    };
    p.drawRoundRectComplex = function(x2, y, w, h, radiusTL, radiusTR, radiusBR, radiusBL) {
      return this.append(new G.RoundRect(x2, y, w, h, radiusTL, radiusTR, radiusBR, radiusBL));
    };
    p.drawCircle = function(x2, y, radius) {
      return this.append(new G.Circle(x2, y, radius));
    };
    p.drawEllipse = function(x2, y, w, h) {
      return this.append(new G.Ellipse(x2, y, w, h));
    };
    p.drawPolyStar = function(x2, y, radius, sides2, pointSize, angle) {
      return this.append(new G.PolyStar(x2, y, radius, sides2, pointSize, angle));
    };
    p.append = function(command, clean) {
      this._activeInstructions.push(command);
      this.command = command;
      if (!clean) {
        this._dirty = true;
      }
      return this;
    };
    p.decodePath = function(str) {
      var instructions = [this.moveTo, this.lineTo, this.quadraticCurveTo, this.bezierCurveTo, this.closePath];
      var paramCount = [2, 2, 4, 6, 0];
      var i2 = 0, l = str.length;
      var params = [];
      var x2 = 0, y = 0;
      var base64 = Graphics.BASE_64;
      while (i2 < l) {
        var c = str.charAt(i2);
        var n2 = base64[c];
        var fi = n2 >> 3;
        var f = instructions[fi];
        if (!f || n2 & 3) {
          throw "bad path data (@" + i2 + "): " + c;
        }
        var pl = paramCount[fi];
        if (!fi) {
          x2 = y = 0;
        }
        params.length = 0;
        i2++;
        var charCount = (n2 >> 2 & 1) + 2;
        for (var p2 = 0; p2 < pl; p2++) {
          var num = base64[str.charAt(i2)];
          var sign = num >> 5 ? -1 : 1;
          num = (num & 31) << 6 | base64[str.charAt(i2 + 1)];
          if (charCount == 3) {
            num = num << 6 | base64[str.charAt(i2 + 2)];
          }
          num = sign * num / 10;
          if (p2 % 2) {
            x2 = num += x2;
          } else {
            y = num += y;
          }
          params[p2] = num;
          i2 += charCount;
        }
        f.apply(this, params);
      }
      return this;
    };
    p.store = function() {
      this._updateInstructions(true);
      this._storeIndex = this._instructions.length;
      return this;
    };
    p.unstore = function() {
      this._storeIndex = 0;
      return this;
    };
    p.clone = function() {
      var o = new Graphics();
      o.command = this.command;
      o._stroke = this._stroke;
      o._strokeStyle = this._strokeStyle;
      o._strokeDash = this._strokeDash;
      o._strokeIgnoreScale = this._strokeIgnoreScale;
      o._fill = this._fill;
      o._instructions = this._instructions.slice();
      o._commitIndex = this._commitIndex;
      o._activeInstructions = this._activeInstructions.slice();
      o._dirty = this._dirty;
      o._storeIndex = this._storeIndex;
      return o;
    };
    p.toString = function() {
      return "[Graphics]";
    };
    p.mt = p.moveTo;
    p.lt = p.lineTo;
    p.at = p.arcTo;
    p.bt = p.bezierCurveTo;
    p.qt = p.quadraticCurveTo;
    p.a = p.arc;
    p.r = p.rect;
    p.cp = p.closePath;
    p.c = p.clear;
    p.f = p.beginFill;
    p.lf = p.beginLinearGradientFill;
    p.rf = p.beginRadialGradientFill;
    p.bf = p.beginBitmapFill;
    p.ef = p.endFill;
    p.ss = p.setStrokeStyle;
    p.sd = p.setStrokeDash;
    p.s = p.beginStroke;
    p.ls = p.beginLinearGradientStroke;
    p.rs = p.beginRadialGradientStroke;
    p.bs = p.beginBitmapStroke;
    p.es = p.endStroke;
    p.dr = p.drawRect;
    p.rr = p.drawRoundRect;
    p.rc = p.drawRoundRectComplex;
    p.dc = p.drawCircle;
    p.de = p.drawEllipse;
    p.dp = p.drawPolyStar;
    p.p = p.decodePath;
    p._updateInstructions = function(commit) {
      var instr = this._instructions, active = this._activeInstructions, commitIndex = this._commitIndex;
      if (this._dirty && active.length) {
        instr.length = commitIndex;
        instr.push(Graphics.beginCmd);
        var l = active.length, ll = instr.length;
        instr.length = ll + l;
        for (var i2 = 0; i2 < l; i2++) {
          instr[i2 + ll] = active[i2];
        }
        if (this._fill) {
          instr.push(this._fill);
        }
        if (this._stroke) {
          if (this._strokeDash !== this._oldStrokeDash) {
            this._oldStrokeDash = this._strokeDash;
            instr.push(this._strokeDash);
          }
          if (this._strokeStyle !== this._oldStrokeStyle) {
            this._oldStrokeStyle = this._strokeStyle;
            instr.push(this._strokeStyle);
          }
          instr.push(this._stroke);
        }
        this._dirty = false;
      }
      if (commit) {
        active.length = 0;
        this._commitIndex = instr.length;
      }
    };
    p._setFill = function(fill) {
      this._updateInstructions(true);
      this.command = this._fill = fill;
      return this;
    };
    p._setStroke = function(stroke) {
      this._updateInstructions(true);
      if (this.command = this._stroke = stroke) {
        stroke.ignoreScale = this._strokeIgnoreScale;
      }
      return this;
    };
    (G.LineTo = function(x2, y) {
      this.x = x2;
      this.y = y;
    }).prototype.exec = function(ctx) {
      ctx.lineTo(this.x, this.y);
    };
    (G.MoveTo = function(x2, y) {
      this.x = x2;
      this.y = y;
    }).prototype.exec = function(ctx) {
      ctx.moveTo(this.x, this.y);
    };
    (G.ArcTo = function(x1, y1, x2, y2, radius) {
      this.x1 = x1;
      this.y1 = y1;
      this.x2 = x2;
      this.y2 = y2;
      this.radius = radius;
    }).prototype.exec = function(ctx) {
      ctx.arcTo(this.x1, this.y1, this.x2, this.y2, this.radius);
    };
    (G.Arc = function(x2, y, radius, startAngle, endAngle, anticlockwise) {
      this.x = x2;
      this.y = y;
      this.radius = radius;
      this.startAngle = startAngle;
      this.endAngle = endAngle;
      this.anticlockwise = !!anticlockwise;
    }).prototype.exec = function(ctx) {
      ctx.arc(this.x, this.y, this.radius, this.startAngle, this.endAngle, this.anticlockwise);
    };
    (G.QuadraticCurveTo = function(cpx, cpy, x2, y) {
      this.cpx = cpx;
      this.cpy = cpy;
      this.x = x2;
      this.y = y;
    }).prototype.exec = function(ctx) {
      ctx.quadraticCurveTo(this.cpx, this.cpy, this.x, this.y);
    };
    (G.BezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x2, y) {
      this.cp1x = cp1x;
      this.cp1y = cp1y;
      this.cp2x = cp2x;
      this.cp2y = cp2y;
      this.x = x2;
      this.y = y;
    }).prototype.exec = function(ctx) {
      ctx.bezierCurveTo(this.cp1x, this.cp1y, this.cp2x, this.cp2y, this.x, this.y);
    };
    (G.Rect = function(x2, y, w, h) {
      this.x = x2;
      this.y = y;
      this.w = w;
      this.h = h;
    }).prototype.exec = function(ctx) {
      ctx.rect(this.x, this.y, this.w, this.h);
    };
    (G.ClosePath = function() {
    }).prototype.exec = function(ctx) {
      ctx.closePath();
    };
    (G.BeginPath = function() {
    }).prototype.exec = function(ctx) {
      ctx.beginPath();
    };
    p = (G.Fill = function(style2, matrix2) {
      this.style = style2;
      this.matrix = matrix2;
    }).prototype;
    p.exec = function(ctx) {
      if (!this.style) {
        return;
      }
      ctx.fillStyle = this.style;
      var mtx = this.matrix;
      if (mtx) {
        ctx.save();
        ctx.transform(mtx.a, mtx.b, mtx.c, mtx.d, mtx.tx, mtx.ty);
      }
      ctx.fill();
      if (mtx) {
        ctx.restore();
      }
    };
    p.linearGradient = function(colors, ratios, x0, y0, x1, y1) {
      var o = this.style = Graphics._ctx.createLinearGradient(x0, y0, x1, y1);
      for (var i2 = 0, l = colors.length; i2 < l; i2++) {
        o.addColorStop(ratios[i2], colors[i2]);
      }
      o.props = { colors, ratios, x0, y0, x1, y1, type: "linear" };
      return this;
    };
    p.radialGradient = function(colors, ratios, x0, y0, r0, x1, y1, r1) {
      var o = this.style = Graphics._ctx.createRadialGradient(x0, y0, r0, x1, y1, r1);
      for (var i2 = 0, l = colors.length; i2 < l; i2++) {
        o.addColorStop(ratios[i2], colors[i2]);
      }
      o.props = { colors, ratios, x0, y0, r0, x1, y1, r1, type: "radial" };
      return this;
    };
    p.bitmap = function(image, repetition) {
      if (image.naturalWidth || image.getContext || image.readyState >= 2) {
        var o = this.style = Graphics._ctx.createPattern(image, repetition || "");
        o.props = { image, repetition, type: "bitmap" };
      }
      return this;
    };
    p.path = false;
    p = (G.Stroke = function(style2, ignoreScale) {
      this.style = style2;
      this.ignoreScale = ignoreScale;
    }).prototype;
    p.exec = function(ctx) {
      if (!this.style) {
        return;
      }
      ctx.strokeStyle = this.style;
      if (this.ignoreScale) {
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
      }
      ctx.stroke();
      if (this.ignoreScale) {
        ctx.restore();
      }
    };
    p.linearGradient = G.Fill.prototype.linearGradient;
    p.radialGradient = G.Fill.prototype.radialGradient;
    p.bitmap = G.Fill.prototype.bitmap;
    p.path = false;
    p = (G.StrokeStyle = function(width, caps, joints, miterLimit, ignoreScale) {
      this.width = width;
      this.caps = caps;
      this.joints = joints;
      this.miterLimit = miterLimit;
      this.ignoreScale = ignoreScale;
    }).prototype;
    p.exec = function(ctx) {
      ctx.lineWidth = this.width == null ? "1" : this.width;
      ctx.lineCap = this.caps == null ? "butt" : isNaN(this.caps) ? this.caps : Graphics.STROKE_CAPS_MAP[this.caps];
      ctx.lineJoin = this.joints == null ? "miter" : isNaN(this.joints) ? this.joints : Graphics.STROKE_JOINTS_MAP[this.joints];
      ctx.miterLimit = this.miterLimit == null ? "10" : this.miterLimit;
      ctx.ignoreScale = this.ignoreScale == null ? false : this.ignoreScale;
    };
    p.path = false;
    (G.StrokeDash = function(segments, offset2) {
      this.segments = segments;
      this.offset = offset2 || 0;
    }).prototype.exec = function(ctx) {
      if (ctx.setLineDash) {
        ctx.setLineDash(this.segments || G.StrokeDash.EMPTY_SEGMENTS);
        ctx.lineDashOffset = this.offset || 0;
      }
    };
    G.StrokeDash.EMPTY_SEGMENTS = [];
    (G.RoundRect = function(x2, y, w, h, radiusTL, radiusTR, radiusBR, radiusBL) {
      this.x = x2;
      this.y = y;
      this.w = w;
      this.h = h;
      this.radiusTL = radiusTL;
      this.radiusTR = radiusTR;
      this.radiusBR = radiusBR;
      this.radiusBL = radiusBL;
    }).prototype.exec = function(ctx) {
      var max2 = (w < h ? w : h) / 2;
      var mTL = 0, mTR = 0, mBR = 0, mBL = 0;
      var x2 = this.x, y = this.y, w = this.w, h = this.h;
      var rTL = this.radiusTL, rTR = this.radiusTR, rBR = this.radiusBR, rBL = this.radiusBL;
      if (rTL < 0) {
        rTL *= mTL = -1;
      }
      if (rTL > max2) {
        rTL = max2;
      }
      if (rTR < 0) {
        rTR *= mTR = -1;
      }
      if (rTR > max2) {
        rTR = max2;
      }
      if (rBR < 0) {
        rBR *= mBR = -1;
      }
      if (rBR > max2) {
        rBR = max2;
      }
      if (rBL < 0) {
        rBL *= mBL = -1;
      }
      if (rBL > max2) {
        rBL = max2;
      }
      ctx.moveTo(x2 + w - rTR, y);
      ctx.arcTo(x2 + w + rTR * mTR, y - rTR * mTR, x2 + w, y + rTR, rTR);
      ctx.lineTo(x2 + w, y + h - rBR);
      ctx.arcTo(x2 + w + rBR * mBR, y + h + rBR * mBR, x2 + w - rBR, y + h, rBR);
      ctx.lineTo(x2 + rBL, y + h);
      ctx.arcTo(x2 - rBL * mBL, y + h + rBL * mBL, x2, y + h - rBL, rBL);
      ctx.lineTo(x2, y + rTL);
      ctx.arcTo(x2 - rTL * mTL, y - rTL * mTL, x2 + rTL, y, rTL);
      ctx.closePath();
    };
    (G.Circle = function(x2, y, radius) {
      this.x = x2;
      this.y = y;
      this.radius = radius;
    }).prototype.exec = function(ctx) {
      ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
    };
    (G.Ellipse = function(x2, y, w, h) {
      this.x = x2;
      this.y = y;
      this.w = w;
      this.h = h;
    }).prototype.exec = function(ctx) {
      var x2 = this.x, y = this.y;
      var w = this.w, h = this.h;
      var k = 0.5522848;
      var ox = w / 2 * k;
      var oy = h / 2 * k;
      var xe = x2 + w;
      var ye = y + h;
      var xm = x2 + w / 2;
      var ym = y + h / 2;
      ctx.moveTo(x2, ym);
      ctx.bezierCurveTo(x2, ym - oy, xm - ox, y, xm, y);
      ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
      ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
      ctx.bezierCurveTo(xm - ox, ye, x2, ym + oy, x2, ym);
    };
    (G.PolyStar = function(x2, y, radius, sides2, pointSize, angle) {
      this.x = x2;
      this.y = y;
      this.radius = radius;
      this.sides = sides2;
      this.pointSize = pointSize;
      this.angle = angle;
    }).prototype.exec = function(ctx) {
      var x2 = this.x, y = this.y;
      var radius = this.radius;
      var angle = (this.angle || 0) / 180 * Math.PI;
      var sides2 = this.sides;
      var ps = 1 - (this.pointSize || 0);
      var a = Math.PI / sides2;
      ctx.moveTo(x2 + Math.cos(angle) * radius, y + Math.sin(angle) * radius);
      for (var i2 = 0; i2 < sides2; i2++) {
        angle += a;
        if (ps != 1) {
          ctx.lineTo(x2 + Math.cos(angle) * radius * ps, y + Math.sin(angle) * radius * ps);
        }
        angle += a;
        ctx.lineTo(x2 + Math.cos(angle) * radius, y + Math.sin(angle) * radius);
      }
      ctx.closePath();
    };
    Graphics.beginCmd = new G.BeginPath();
    createjs2.Graphics = Graphics;
  })();
  (function() {
    function DisplayObject() {
      this.EventDispatcher_constructor();
      this.alpha = 1;
      this.cacheCanvas = null;
      this.cacheID = 0;
      this.id = createjs2.UID.get();
      this.mouseEnabled = true;
      this.tickEnabled = true;
      this.name = null;
      this.parent = null;
      this.regX = 0;
      this.regY = 0;
      this.rotation = 0;
      this.scaleX = 1;
      this.scaleY = 1;
      this.skewX = 0;
      this.skewY = 0;
      this.shadow = null;
      this.visible = true;
      this.x = 0;
      this.y = 0;
      this.transformMatrix = null;
      this.compositeOperation = null;
      this.snapToPixel = true;
      this.filters = null;
      this.mask = null;
      this.hitArea = null;
      this.cursor = null;
      this._cacheOffsetX = 0;
      this._cacheOffsetY = 0;
      this._filterOffsetX = 0;
      this._filterOffsetY = 0;
      this._cacheScale = 1;
      this._cacheDataURLID = 0;
      this._cacheDataURL = null;
      this._props = new createjs2.DisplayProps();
      this._rectangle = new createjs2.Rectangle();
      this._bounds = null;
    }
    var p = createjs2.extend(DisplayObject, createjs2.EventDispatcher);
    DisplayObject._MOUSE_EVENTS = ["click", "dblclick", "mousedown", "mouseout", "mouseover", "pressmove", "pressup", "rollout", "rollover"];
    DisplayObject.suppressCrossDomainErrors = false;
    DisplayObject._snapToPixelEnabled = false;
    var canvas = createjs2.createCanvas ? createjs2.createCanvas() : document.createElement("canvas");
    if (canvas.getContext) {
      DisplayObject._hitTestCanvas = canvas;
      DisplayObject._hitTestContext = canvas.getContext("2d");
      canvas.width = canvas.height = 1;
    }
    DisplayObject._nextCacheID = 1;
    p.getStage = function() {
      var o = this, _Stage = createjs2["Stage"];
      while (o.parent) {
        o = o.parent;
      }
      if (o instanceof _Stage) {
        return o;
      }
      return null;
    };
    try {
      Object.defineProperties(p, {
        stage: { get: p.getStage }
      });
    } catch (e) {
    }
    p.isVisible = function() {
      return !!(this.visible && this.alpha > 0 && this.scaleX != 0 && this.scaleY != 0);
    };
    p.draw = function(ctx, ignoreCache) {
      var cacheCanvas = this.cacheCanvas;
      if (ignoreCache || !cacheCanvas) {
        return false;
      }
      var scale = this._cacheScale;
      ctx.drawImage(cacheCanvas, this._cacheOffsetX + this._filterOffsetX, this._cacheOffsetY + this._filterOffsetY, cacheCanvas.width / scale, cacheCanvas.height / scale);
      return true;
    };
    p.updateContext = function(ctx) {
      var o = this, mask = o.mask, mtx = o._props.matrix;
      if (mask && mask.graphics && !mask.graphics.isEmpty()) {
        mask.getMatrix(mtx);
        ctx.transform(mtx.a, mtx.b, mtx.c, mtx.d, mtx.tx, mtx.ty);
        mask.graphics.drawAsPath(ctx);
        ctx.clip();
        mtx.invert();
        ctx.transform(mtx.a, mtx.b, mtx.c, mtx.d, mtx.tx, mtx.ty);
      }
      this.getMatrix(mtx);
      var tx = mtx.tx, ty = mtx.ty;
      if (DisplayObject._snapToPixelEnabled && o.snapToPixel) {
        tx = tx + (tx < 0 ? -0.5 : 0.5) | 0;
        ty = ty + (ty < 0 ? -0.5 : 0.5) | 0;
      }
      ctx.transform(mtx.a, mtx.b, mtx.c, mtx.d, tx, ty);
      ctx.globalAlpha *= o.alpha;
      if (o.compositeOperation) {
        ctx.globalCompositeOperation = o.compositeOperation;
      }
      if (o.shadow) {
        this._applyShadow(ctx, o.shadow);
      }
    };
    p.cache = function(x2, y, width, height, scale) {
      scale = scale || 1;
      if (!this.cacheCanvas) {
        this.cacheCanvas = createjs2.createCanvas ? createjs2.createCanvas() : document.createElement("canvas");
      }
      this._cacheWidth = width;
      this._cacheHeight = height;
      this._cacheOffsetX = x2;
      this._cacheOffsetY = y;
      this._cacheScale = scale;
      this.updateCache();
    };
    p.updateCache = function(compositeOperation) {
      var cacheCanvas = this.cacheCanvas;
      if (!cacheCanvas) {
        throw "cache() must be called before updateCache()";
      }
      var scale = this._cacheScale, offX = this._cacheOffsetX * scale, offY = this._cacheOffsetY * scale;
      var w = this._cacheWidth, h = this._cacheHeight, ctx = cacheCanvas.getContext("2d");
      var fBounds = this._getFilterBounds();
      offX += this._filterOffsetX = fBounds.x;
      offY += this._filterOffsetY = fBounds.y;
      w = Math.ceil(w * scale) + fBounds.width;
      h = Math.ceil(h * scale) + fBounds.height;
      if (w != cacheCanvas.width || h != cacheCanvas.height) {
        cacheCanvas.width = w;
        cacheCanvas.height = h;
      } else if (!compositeOperation) {
        ctx.clearRect(0, 0, w + 1, h + 1);
      }
      ctx.save();
      ctx.globalCompositeOperation = compositeOperation;
      ctx.setTransform(scale, 0, 0, scale, -offX, -offY);
      this.draw(ctx, true);
      this._applyFilters();
      ctx.restore();
      this.cacheID = DisplayObject._nextCacheID++;
    };
    p.uncache = function() {
      this._cacheDataURL = this.cacheCanvas = null;
      this.cacheID = this._cacheOffsetX = this._cacheOffsetY = this._filterOffsetX = this._filterOffsetY = 0;
      this._cacheScale = 1;
    };
    p.getCacheDataURL = function() {
      if (!this.cacheCanvas) {
        return null;
      }
      if (this.cacheID != this._cacheDataURLID) {
        this._cacheDataURL = this.cacheCanvas.toDataURL();
      }
      return this._cacheDataURL;
    };
    p.localToGlobal = function(x2, y, pt) {
      return this.getConcatenatedMatrix(this._props.matrix).transformPoint(x2, y, pt || new createjs2.Point());
    };
    p.globalToLocal = function(x2, y, pt) {
      return this.getConcatenatedMatrix(this._props.matrix).invert().transformPoint(x2, y, pt || new createjs2.Point());
    };
    p.localToLocal = function(x2, y, target2, pt) {
      pt = this.localToGlobal(x2, y, pt);
      return target2.globalToLocal(pt.x, pt.y, pt);
    };
    p.setTransform = function(x2, y, scaleX, scaleY, rotation, skewX, skewY, regX, regY) {
      this.x = x2 || 0;
      this.y = y || 0;
      this.scaleX = scaleX == null ? 1 : scaleX;
      this.scaleY = scaleY == null ? 1 : scaleY;
      this.rotation = rotation || 0;
      this.skewX = skewX || 0;
      this.skewY = skewY || 0;
      this.regX = regX || 0;
      this.regY = regY || 0;
      return this;
    };
    p.getMatrix = function(matrix2) {
      var o = this, mtx = matrix2 && matrix2.identity() || new createjs2.Matrix2D();
      return o.transformMatrix ? mtx.copy(o.transformMatrix) : mtx.appendTransform(o.x, o.y, o.scaleX, o.scaleY, o.rotation, o.skewX, o.skewY, o.regX, o.regY);
    };
    p.getConcatenatedMatrix = function(matrix2) {
      var o = this, mtx = this.getMatrix(matrix2);
      while (o = o.parent) {
        mtx.prependMatrix(o.getMatrix(o._props.matrix));
      }
      return mtx;
    };
    p.getConcatenatedDisplayProps = function(props2) {
      props2 = props2 ? props2.identity() : new createjs2.DisplayProps();
      var o = this, mtx = o.getMatrix(props2.matrix);
      do {
        props2.prepend(o.visible, o.alpha, o.shadow, o.compositeOperation);
        if (o != this) {
          mtx.prependMatrix(o.getMatrix(o._props.matrix));
        }
      } while (o = o.parent);
      return props2;
    };
    p.hitTest = function(x2, y) {
      var ctx = DisplayObject._hitTestContext;
      ctx.setTransform(1, 0, 0, 1, -x2, -y);
      this.draw(ctx);
      var hit = this._testHit(ctx);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, 2, 2);
      return hit;
    };
    p.set = function(props2) {
      for (var n2 in props2) {
        this[n2] = props2[n2];
      }
      return this;
    };
    p.getBounds = function() {
      if (this._bounds) {
        return this._rectangle.copy(this._bounds);
      }
      var cacheCanvas = this.cacheCanvas;
      if (cacheCanvas) {
        var scale = this._cacheScale;
        return this._rectangle.setValues(this._cacheOffsetX, this._cacheOffsetY, cacheCanvas.width / scale, cacheCanvas.height / scale);
      }
      return null;
    };
    p.getTransformedBounds = function() {
      return this._getBounds();
    };
    p.setBounds = function(x2, y, width, height) {
      if (x2 == null) {
        this._bounds = x2;
      }
      this._bounds = (this._bounds || new createjs2.Rectangle()).setValues(x2, y, width, height);
    };
    p.clone = function() {
      return this._cloneProps(new DisplayObject());
    };
    p.toString = function() {
      return "[DisplayObject (name=" + this.name + ")]";
    };
    p._cloneProps = function(o) {
      o.alpha = this.alpha;
      o.mouseEnabled = this.mouseEnabled;
      o.tickEnabled = this.tickEnabled;
      o.name = this.name;
      o.regX = this.regX;
      o.regY = this.regY;
      o.rotation = this.rotation;
      o.scaleX = this.scaleX;
      o.scaleY = this.scaleY;
      o.shadow = this.shadow;
      o.skewX = this.skewX;
      o.skewY = this.skewY;
      o.visible = this.visible;
      o.x = this.x;
      o.y = this.y;
      o.compositeOperation = this.compositeOperation;
      o.snapToPixel = this.snapToPixel;
      o.filters = this.filters == null ? null : this.filters.slice(0);
      o.mask = this.mask;
      o.hitArea = this.hitArea;
      o.cursor = this.cursor;
      o._bounds = this._bounds;
      return o;
    };
    p._applyShadow = function(ctx, shadow) {
      shadow = shadow || Shadow.identity;
      ctx.shadowColor = shadow.color;
      ctx.shadowOffsetX = shadow.offsetX;
      ctx.shadowOffsetY = shadow.offsetY;
      ctx.shadowBlur = shadow.blur;
    };
    p._tick = function(evtObj) {
      var ls = this._listeners;
      if (ls && ls["tick"]) {
        evtObj.target = null;
        evtObj.propagationStopped = evtObj.immediatePropagationStopped = false;
        this.dispatchEvent(evtObj);
      }
    };
    p._testHit = function(ctx) {
      try {
        var hit = ctx.getImageData(0, 0, 1, 1).data[3] > 1;
      } catch (e) {
        if (!DisplayObject.suppressCrossDomainErrors) {
          throw "An error has occurred. This is most likely due to security restrictions on reading canvas pixel data with local or cross-domain images.";
        }
      }
      return hit;
    };
    p._applyFilters = function() {
      if (!this.filters || this.filters.length == 0 || !this.cacheCanvas) {
        return;
      }
      var l = this.filters.length;
      var ctx = this.cacheCanvas.getContext("2d");
      var w = this.cacheCanvas.width;
      var h = this.cacheCanvas.height;
      for (var i2 = 0; i2 < l; i2++) {
        this.filters[i2].applyFilter(ctx, 0, 0, w, h);
      }
    };
    p._getFilterBounds = function(rect) {
      var l, filters = this.filters, bounds = this._rectangle.setValues(0, 0, 0, 0);
      if (!filters || !(l = filters.length)) {
        return bounds;
      }
      for (var i2 = 0; i2 < l; i2++) {
        var f = this.filters[i2];
        f.getBounds && f.getBounds(bounds);
      }
      return bounds;
    };
    p._getBounds = function(matrix2, ignoreTransform) {
      return this._transformBounds(this.getBounds(), matrix2, ignoreTransform);
    };
    p._transformBounds = function(bounds, matrix2, ignoreTransform) {
      if (!bounds) {
        return bounds;
      }
      var x2 = bounds.x, y = bounds.y, width = bounds.width, height = bounds.height, mtx = this._props.matrix;
      mtx = ignoreTransform ? mtx.identity() : this.getMatrix(mtx);
      if (x2 || y) {
        mtx.appendTransform(0, 0, 1, 1, 0, 0, 0, -x2, -y);
      }
      if (matrix2) {
        mtx.prependMatrix(matrix2);
      }
      var x_a = width * mtx.a, x_b = width * mtx.b;
      var y_c = height * mtx.c, y_d = height * mtx.d;
      var tx = mtx.tx, ty = mtx.ty;
      var minX = tx, maxX = tx, minY = ty, maxY = ty;
      if ((x2 = x_a + tx) < minX) {
        minX = x2;
      } else if (x2 > maxX) {
        maxX = x2;
      }
      if ((x2 = x_a + y_c + tx) < minX) {
        minX = x2;
      } else if (x2 > maxX) {
        maxX = x2;
      }
      if ((x2 = y_c + tx) < minX) {
        minX = x2;
      } else if (x2 > maxX) {
        maxX = x2;
      }
      if ((y = x_b + ty) < minY) {
        minY = y;
      } else if (y > maxY) {
        maxY = y;
      }
      if ((y = x_b + y_d + ty) < minY) {
        minY = y;
      } else if (y > maxY) {
        maxY = y;
      }
      if ((y = y_d + ty) < minY) {
        minY = y;
      } else if (y > maxY) {
        maxY = y;
      }
      return bounds.setValues(minX, minY, maxX - minX, maxY - minY);
    };
    p._hasMouseEventListener = function() {
      var evts = DisplayObject._MOUSE_EVENTS;
      for (var i2 = 0, l = evts.length; i2 < l; i2++) {
        if (this.hasEventListener(evts[i2])) {
          return true;
        }
      }
      return !!this.cursor;
    };
    createjs2.DisplayObject = createjs2.promote(DisplayObject, "EventDispatcher");
  })();
  (function() {
    function Container3() {
      this.DisplayObject_constructor();
      this.children = [];
      this.mouseChildren = true;
      this.tickChildren = true;
    }
    var p = createjs2.extend(Container3, createjs2.DisplayObject);
    p.getNumChildren = function() {
      return this.children.length;
    };
    try {
      Object.defineProperties(p, {
        numChildren: { get: p.getNumChildren }
      });
    } catch (e) {
    }
    p.initialize = Container3;
    p.isVisible = function() {
      var hasContent = this.cacheCanvas || this.children.length;
      return !!(this.visible && this.alpha > 0 && this.scaleX != 0 && this.scaleY != 0 && hasContent);
    };
    p.draw = function(ctx, ignoreCache) {
      if (this.DisplayObject_draw(ctx, ignoreCache)) {
        return true;
      }
      var list2 = this.children.slice();
      for (var i2 = 0, l = list2.length; i2 < l; i2++) {
        var child = list2[i2];
        if (!child.isVisible()) {
          continue;
        }
        ctx.save();
        child.updateContext(ctx);
        child.draw(ctx);
        ctx.restore();
      }
      return true;
    };
    p.addChild = function(child) {
      if (child == null) {
        return child;
      }
      var l = arguments.length;
      if (l > 1) {
        for (var i2 = 0; i2 < l; i2++) {
          this.addChild(arguments[i2]);
        }
        return arguments[l - 1];
      }
      if (child.parent) {
        child.parent.removeChild(child);
      }
      child.parent = this;
      this.children.push(child);
      child.dispatchEvent("added");
      return child;
    };
    p.addChildAt = function(child, index2) {
      var l = arguments.length;
      var indx = arguments[l - 1];
      if (indx < 0 || indx > this.children.length) {
        return arguments[l - 2];
      }
      if (l > 2) {
        for (var i2 = 0; i2 < l - 1; i2++) {
          this.addChildAt(arguments[i2], indx + i2);
        }
        return arguments[l - 2];
      }
      if (child.parent) {
        child.parent.removeChild(child);
      }
      child.parent = this;
      this.children.splice(index2, 0, child);
      child.dispatchEvent("added");
      return child;
    };
    p.removeChild = function(child) {
      var l = arguments.length;
      if (l > 1) {
        var good = true;
        for (var i2 = 0; i2 < l; i2++) {
          good = good && this.removeChild(arguments[i2]);
        }
        return good;
      }
      return this.removeChildAt(createjs2.indexOf(this.children, child));
    };
    p.removeChildAt = function(index2) {
      var l = arguments.length;
      if (l > 1) {
        var a = [];
        for (var i2 = 0; i2 < l; i2++) {
          a[i2] = arguments[i2];
        }
        a.sort(function(a2, b) {
          return b - a2;
        });
        var good = true;
        for (var i2 = 0; i2 < l; i2++) {
          good = good && this.removeChildAt(a[i2]);
        }
        return good;
      }
      if (index2 < 0 || index2 > this.children.length - 1) {
        return false;
      }
      var child = this.children[index2];
      if (child) {
        child.parent = null;
      }
      this.children.splice(index2, 1);
      child.dispatchEvent("removed");
      return true;
    };
    p.removeAllChildren = function() {
      var kids = this.children;
      while (kids.length) {
        this.removeChildAt(0);
      }
    };
    p.getChildAt = function(index2) {
      return this.children[index2];
    };
    p.getChildByName = function(name) {
      var kids = this.children;
      for (var i2 = 0, l = kids.length; i2 < l; i2++) {
        if (kids[i2].name == name) {
          return kids[i2];
        }
      }
      return null;
    };
    p.sortChildren = function(sortFunction) {
      this.children.sort(sortFunction);
    };
    p.getChildIndex = function(child) {
      return createjs2.indexOf(this.children, child);
    };
    p.swapChildrenAt = function(index1, index2) {
      var kids = this.children;
      var o1 = kids[index1];
      var o2 = kids[index2];
      if (!o1 || !o2) {
        return;
      }
      kids[index1] = o2;
      kids[index2] = o1;
    };
    p.swapChildren = function(child1, child2) {
      var kids = this.children;
      var index1, index2;
      for (var i2 = 0, l = kids.length; i2 < l; i2++) {
        if (kids[i2] == child1) {
          index1 = i2;
        }
        if (kids[i2] == child2) {
          index2 = i2;
        }
        if (index1 != null && index2 != null) {
          break;
        }
      }
      if (i2 == l) {
        return;
      }
      kids[index1] = child2;
      kids[index2] = child1;
    };
    p.setChildIndex = function(child, index2) {
      var kids = this.children, l = kids.length;
      if (child.parent != this || index2 < 0 || index2 >= l) {
        return;
      }
      for (var i2 = 0; i2 < l; i2++) {
        if (kids[i2] == child) {
          break;
        }
      }
      if (i2 == l || i2 == index2) {
        return;
      }
      kids.splice(i2, 1);
      kids.splice(index2, 0, child);
    };
    p.contains = function(child) {
      while (child) {
        if (child == this) {
          return true;
        }
        child = child.parent;
      }
      return false;
    };
    p.hitTest = function(x2, y) {
      return this.getObjectUnderPoint(x2, y) != null;
    };
    p.getObjectsUnderPoint = function(x2, y, mode) {
      var arr = [];
      var pt = this.localToGlobal(x2, y);
      this._getObjectsUnderPoint(pt.x, pt.y, arr, mode > 0, mode == 1);
      return arr;
    };
    p.getObjectUnderPoint = function(x2, y, mode) {
      var pt = this.localToGlobal(x2, y);
      return this._getObjectsUnderPoint(pt.x, pt.y, null, mode > 0, mode == 1);
    };
    p.getBounds = function() {
      return this._getBounds(null, true);
    };
    p.getTransformedBounds = function() {
      return this._getBounds();
    };
    p.clone = function(recursive) {
      var o = this._cloneProps(new Container3());
      if (recursive) {
        this._cloneChildren(o);
      }
      return o;
    };
    p.toString = function() {
      return "[Container (name=" + this.name + ")]";
    };
    p._tick = function(evtObj) {
      if (this.tickChildren) {
        for (var i2 = this.children.length - 1; i2 >= 0; i2--) {
          var child = this.children[i2];
          if (child.tickEnabled && child._tick) {
            child._tick(evtObj);
          }
        }
      }
      this.DisplayObject__tick(evtObj);
    };
    p._cloneChildren = function(o) {
      if (o.children.length) {
        o.removeAllChildren();
      }
      var arr = o.children;
      for (var i2 = 0, l = this.children.length; i2 < l; i2++) {
        var clone2 = this.children[i2].clone(true);
        clone2.parent = o;
        arr.push(clone2);
      }
    };
    p._getObjectsUnderPoint = function(x2, y, arr, mouse, activeListener, currentDepth) {
      currentDepth = currentDepth || 0;
      if (!currentDepth && !this._testMask(this, x2, y)) {
        return null;
      }
      var mtx, ctx = createjs2.DisplayObject._hitTestContext;
      activeListener = activeListener || mouse && this._hasMouseEventListener();
      var children = this.children, l = children.length;
      for (var i2 = l - 1; i2 >= 0; i2--) {
        var child = children[i2];
        var hitArea = child.hitArea;
        if (!child.visible || !hitArea && !child.isVisible() || mouse && !child.mouseEnabled) {
          continue;
        }
        if (!hitArea && !this._testMask(child, x2, y)) {
          continue;
        }
        if (!hitArea && child instanceof Container3) {
          var result2 = child._getObjectsUnderPoint(x2, y, arr, mouse, activeListener, currentDepth + 1);
          if (!arr && result2) {
            return mouse && !this.mouseChildren ? this : result2;
          }
        } else {
          if (mouse && !activeListener && !child._hasMouseEventListener()) {
            continue;
          }
          var props2 = child.getConcatenatedDisplayProps(child._props);
          mtx = props2.matrix;
          if (hitArea) {
            mtx.appendMatrix(hitArea.getMatrix(hitArea._props.matrix));
            props2.alpha = hitArea.alpha;
          }
          ctx.globalAlpha = props2.alpha;
          ctx.setTransform(mtx.a, mtx.b, mtx.c, mtx.d, mtx.tx - x2, mtx.ty - y);
          (hitArea || child).draw(ctx);
          if (!this._testHit(ctx)) {
            continue;
          }
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.clearRect(0, 0, 2, 2);
          if (arr) {
            arr.push(child);
          } else {
            return mouse && !this.mouseChildren ? this : child;
          }
        }
      }
      return null;
    };
    p._testMask = function(target2, x2, y) {
      var mask = target2.mask;
      if (!mask || !mask.graphics || mask.graphics.isEmpty()) {
        return true;
      }
      var mtx = this._props.matrix, parent2 = target2.parent;
      mtx = parent2 ? parent2.getConcatenatedMatrix(mtx) : mtx.identity();
      mtx = mask.getMatrix(mask._props.matrix).prependMatrix(mtx);
      var ctx = createjs2.DisplayObject._hitTestContext;
      ctx.setTransform(mtx.a, mtx.b, mtx.c, mtx.d, mtx.tx - x2, mtx.ty - y);
      mask.graphics.drawAsPath(ctx);
      ctx.fillStyle = "#000";
      ctx.fill();
      if (!this._testHit(ctx)) {
        return false;
      }
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, 2, 2);
      return true;
    };
    p._getBounds = function(matrix2, ignoreTransform) {
      var bounds = this.DisplayObject_getBounds();
      if (bounds) {
        return this._transformBounds(bounds, matrix2, ignoreTransform);
      }
      var mtx = this._props.matrix;
      mtx = ignoreTransform ? mtx.identity() : this.getMatrix(mtx);
      if (matrix2) {
        mtx.prependMatrix(matrix2);
      }
      var l = this.children.length, rect = null;
      for (var i2 = 0; i2 < l; i2++) {
        var child = this.children[i2];
        if (!child.visible || !(bounds = child._getBounds(mtx))) {
          continue;
        }
        if (rect) {
          rect.extend(bounds.x, bounds.y, bounds.width, bounds.height);
        } else {
          rect = bounds.clone();
        }
      }
      return rect;
    };
    createjs2.Container = createjs2.promote(Container3, "DisplayObject");
  })();
  (function() {
    function Stage(canvas) {
      this.Container_constructor();
      this.autoClear = true;
      this.canvas = typeof canvas == "string" ? document.getElementById(canvas) : canvas;
      this.mouseX = 0;
      this.mouseY = 0;
      this.drawRect = null;
      this.snapToPixelEnabled = false;
      this.mouseInBounds = false;
      this.tickOnUpdate = true;
      this.mouseMoveOutside = false;
      this.preventSelection = true;
      this._pointerData = {};
      this._pointerCount = 0;
      this._primaryPointerID = null;
      this._mouseOverIntervalID = null;
      this._nextStage = null;
      this._prevStage = null;
      this.enableDOMEvents(true);
    }
    var p = createjs2.extend(Stage, createjs2.Container);
    p._get_nextStage = function() {
      return this._nextStage;
    };
    p._set_nextStage = function(value) {
      if (this._nextStage) {
        this._nextStage._prevStage = null;
      }
      if (value) {
        value._prevStage = this;
      }
      this._nextStage = value;
    };
    try {
      Object.defineProperties(p, {
        nextStage: { get: p._get_nextStage, set: p._set_nextStage }
      });
    } catch (e) {
    }
    p.update = function(props2) {
      if (!this.canvas) {
        return;
      }
      if (this.tickOnUpdate) {
        this.tick(props2);
      }
      if (this.dispatchEvent("drawstart", false, true) === false) {
        return;
      }
      createjs2.DisplayObject._snapToPixelEnabled = this.snapToPixelEnabled;
      var r = this.drawRect, ctx = this.canvas.getContext("2d");
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      if (this.autoClear) {
        if (r) {
          ctx.clearRect(r.x, r.y, r.width, r.height);
        } else {
          ctx.clearRect(0, 0, this.canvas.width + 1, this.canvas.height + 1);
        }
      }
      ctx.save();
      if (this.drawRect) {
        ctx.beginPath();
        ctx.rect(r.x, r.y, r.width, r.height);
        ctx.clip();
      }
      this.updateContext(ctx);
      this.draw(ctx, false);
      ctx.restore();
      this.dispatchEvent("drawend");
    };
    p.tick = function(props2) {
      if (!this.tickEnabled || this.dispatchEvent("tickstart", false, true) === false) {
        return;
      }
      var evtObj = new createjs2.Event("tick");
      if (props2) {
        for (var n2 in props2) {
          if (props2.hasOwnProperty(n2)) {
            evtObj[n2] = props2[n2];
          }
        }
      }
      this._tick(evtObj);
      this.dispatchEvent("tickend");
    };
    p.handleEvent = function(evt) {
      if (evt.type == "tick") {
        this.update(evt);
      }
    };
    p.clear = function() {
      if (!this.canvas) {
        return;
      }
      var ctx = this.canvas.getContext("2d");
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, this.canvas.width + 1, this.canvas.height + 1);
    };
    p.toDataURL = function(backgroundColor, mimeType) {
      var data, ctx = this.canvas.getContext("2d"), w = this.canvas.width, h = this.canvas.height;
      if (backgroundColor) {
        data = ctx.getImageData(0, 0, w, h);
        var compositeOperation = ctx.globalCompositeOperation;
        ctx.globalCompositeOperation = "destination-over";
        ctx.fillStyle = backgroundColor;
        ctx.fillRect(0, 0, w, h);
      }
      var dataURL = this.canvas.toDataURL(mimeType || "image/png");
      if (backgroundColor) {
        ctx.putImageData(data, 0, 0);
        ctx.globalCompositeOperation = compositeOperation;
      }
      return dataURL;
    };
    p.enableMouseOver = function(frequency) {
      if (this._mouseOverIntervalID) {
        clearInterval(this._mouseOverIntervalID);
        this._mouseOverIntervalID = null;
        if (frequency == 0) {
          this._testMouseOver(true);
        }
      }
      if (frequency == null) {
        frequency = 20;
      } else if (frequency <= 0) {
        return;
      }
      var o = this;
      this._mouseOverIntervalID = setInterval(function() {
        o._testMouseOver();
      }, 1e3 / Math.min(50, frequency));
    };
    p.enableDOMEvents = function(enable) {
      if (enable == null) {
        enable = true;
      }
      var n2, o, ls = this._eventListeners;
      if (!enable && ls) {
        for (n2 in ls) {
          o = ls[n2];
          o.t.removeEventListener(n2, o.f, false);
        }
        this._eventListeners = null;
      } else if (enable && !ls && this.canvas) {
        var t3 = window.addEventListener ? window : document;
        var _this2 = this;
        ls = this._eventListeners = {};
        ls["mouseup"] = { t: t3, f: function(e) {
          _this2._handleMouseUp(e);
        } };
        ls["mousemove"] = { t: t3, f: function(e) {
          _this2._handleMouseMove(e);
        } };
        ls["dblclick"] = { t: this.canvas, f: function(e) {
          _this2._handleDoubleClick(e);
        } };
        ls["mousedown"] = { t: this.canvas, f: function(e) {
          _this2._handleMouseDown(e);
        } };
        for (n2 in ls) {
          o = ls[n2];
          o.t.addEventListener(n2, o.f, false);
        }
      }
    };
    p.clone = function() {
      throw "Stage cannot be cloned.";
    };
    p.toString = function() {
      return "[Stage (name=" + this.name + ")]";
    };
    p._getElementRect = function(e) {
      var bounds;
      try {
        bounds = e.getBoundingClientRect();
      } catch (err2) {
        bounds = { top: e.offsetTop, left: e.offsetLeft, width: e.offsetWidth, height: e.offsetHeight };
      }
      var offX = (window.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || document.body.clientLeft || 0);
      var offY = (window.pageYOffset || document.scrollTop || 0) - (document.clientTop || document.body.clientTop || 0);
      var styles = window.getComputedStyle ? getComputedStyle(e, null) : e.currentStyle;
      var padL = parseInt(styles.paddingLeft) + parseInt(styles.borderLeftWidth);
      var padT = parseInt(styles.paddingTop) + parseInt(styles.borderTopWidth);
      var padR = parseInt(styles.paddingRight) + parseInt(styles.borderRightWidth);
      var padB = parseInt(styles.paddingBottom) + parseInt(styles.borderBottomWidth);
      return {
        left: bounds.left + offX + padL,
        right: bounds.right + offX - padR,
        top: bounds.top + offY + padT,
        bottom: bounds.bottom + offY - padB
      };
    };
    p._getPointerData = function(id) {
      var data = this._pointerData[id];
      if (!data) {
        data = this._pointerData[id] = { x: 0, y: 0 };
      }
      return data;
    };
    p._handleMouseMove = function(e) {
      if (!e) {
        e = window.event;
      }
      this._handlePointerMove(-1, e, e.pageX, e.pageY);
    };
    p._handlePointerMove = function(id, e, pageX, pageY, owner) {
      if (this._prevStage && owner === void 0) {
        return;
      }
      if (!this.canvas) {
        return;
      }
      var nextStage = this._nextStage, o = this._getPointerData(id);
      var inBounds = o.inBounds;
      this._updatePointerPosition(id, e, pageX, pageY);
      if (inBounds || o.inBounds || this.mouseMoveOutside) {
        if (id === -1 && o.inBounds == !inBounds) {
          this._dispatchMouseEvent(this, inBounds ? "mouseleave" : "mouseenter", false, id, o, e);
        }
        this._dispatchMouseEvent(this, "stagemousemove", false, id, o, e);
        this._dispatchMouseEvent(o.target, "pressmove", true, id, o, e);
      }
      nextStage && nextStage._handlePointerMove(id, e, pageX, pageY, null);
    };
    p._updatePointerPosition = function(id, e, pageX, pageY) {
      var rect = this._getElementRect(this.canvas);
      pageX -= rect.left;
      pageY -= rect.top;
      var w = this.canvas.width;
      var h = this.canvas.height;
      pageX /= (rect.right - rect.left) / w;
      pageY /= (rect.bottom - rect.top) / h;
      var o = this._getPointerData(id);
      if (o.inBounds = pageX >= 0 && pageY >= 0 && pageX <= w - 1 && pageY <= h - 1) {
        o.x = pageX;
        o.y = pageY;
      } else if (this.mouseMoveOutside) {
        o.x = pageX < 0 ? 0 : pageX > w - 1 ? w - 1 : pageX;
        o.y = pageY < 0 ? 0 : pageY > h - 1 ? h - 1 : pageY;
      }
      o.posEvtObj = e;
      o.rawX = pageX;
      o.rawY = pageY;
      if (id === this._primaryPointerID || id === -1) {
        this.mouseX = o.x;
        this.mouseY = o.y;
        this.mouseInBounds = o.inBounds;
      }
    };
    p._handleMouseUp = function(e) {
      this._handlePointerUp(-1, e, false);
    };
    p._handlePointerUp = function(id, e, clear, owner) {
      var nextStage = this._nextStage, o = this._getPointerData(id);
      if (this._prevStage && owner === void 0) {
        return;
      }
      var target2 = null, oTarget = o.target;
      if (!owner && (oTarget || nextStage)) {
        target2 = this._getObjectsUnderPoint(o.x, o.y, null, true);
      }
      if (o.down) {
        this._dispatchMouseEvent(this, "stagemouseup", false, id, o, e, target2);
        o.down = false;
      }
      if (target2 == oTarget) {
        this._dispatchMouseEvent(oTarget, "click", true, id, o, e);
      }
      this._dispatchMouseEvent(oTarget, "pressup", true, id, o, e);
      if (clear) {
        if (id == this._primaryPointerID) {
          this._primaryPointerID = null;
        }
        delete this._pointerData[id];
      } else {
        o.target = null;
      }
      nextStage && nextStage._handlePointerUp(id, e, clear, owner || target2 && this);
    };
    p._handleMouseDown = function(e) {
      this._handlePointerDown(-1, e, e.pageX, e.pageY);
    };
    p._handlePointerDown = function(id, e, pageX, pageY, owner) {
      if (this.preventSelection) {
        e.preventDefault();
      }
      if (this._primaryPointerID == null || id === -1) {
        this._primaryPointerID = id;
      }
      if (pageY != null) {
        this._updatePointerPosition(id, e, pageX, pageY);
      }
      var target2 = null, nextStage = this._nextStage, o = this._getPointerData(id);
      if (!owner) {
        target2 = o.target = this._getObjectsUnderPoint(o.x, o.y, null, true);
      }
      if (o.inBounds) {
        this._dispatchMouseEvent(this, "stagemousedown", false, id, o, e, target2);
        o.down = true;
      }
      this._dispatchMouseEvent(target2, "mousedown", true, id, o, e);
      nextStage && nextStage._handlePointerDown(id, e, pageX, pageY, owner || target2 && this);
    };
    p._testMouseOver = function(clear, owner, eventTarget) {
      if (this._prevStage && owner === void 0) {
        return;
      }
      var nextStage = this._nextStage;
      if (!this._mouseOverIntervalID) {
        nextStage && nextStage._testMouseOver(clear, owner, eventTarget);
        return;
      }
      var o = this._getPointerData(-1);
      if (!o || !clear && this.mouseX == this._mouseOverX && this.mouseY == this._mouseOverY && this.mouseInBounds) {
        return;
      }
      var e = o.posEvtObj;
      var isEventTarget = eventTarget || e && e.target == this.canvas;
      var target2 = null, common = -1, cursor = "", t3, i2, l;
      if (!owner && (clear || this.mouseInBounds && isEventTarget)) {
        target2 = this._getObjectsUnderPoint(this.mouseX, this.mouseY, null, true);
        this._mouseOverX = this.mouseX;
        this._mouseOverY = this.mouseY;
      }
      var oldList = this._mouseOverTarget || [];
      var oldTarget = oldList[oldList.length - 1];
      var list2 = this._mouseOverTarget = [];
      t3 = target2;
      while (t3) {
        list2.unshift(t3);
        if (!cursor) {
          cursor = t3.cursor;
        }
        t3 = t3.parent;
      }
      this.canvas.style.cursor = cursor;
      if (!owner && eventTarget) {
        eventTarget.canvas.style.cursor = cursor;
      }
      for (i2 = 0, l = list2.length; i2 < l; i2++) {
        if (list2[i2] != oldList[i2]) {
          break;
        }
        common = i2;
      }
      if (oldTarget != target2) {
        this._dispatchMouseEvent(oldTarget, "mouseout", true, -1, o, e, target2);
      }
      for (i2 = oldList.length - 1; i2 > common; i2--) {
        this._dispatchMouseEvent(oldList[i2], "rollout", false, -1, o, e, target2);
      }
      for (i2 = list2.length - 1; i2 > common; i2--) {
        this._dispatchMouseEvent(list2[i2], "rollover", false, -1, o, e, oldTarget);
      }
      if (oldTarget != target2) {
        this._dispatchMouseEvent(target2, "mouseover", true, -1, o, e, oldTarget);
      }
      nextStage && nextStage._testMouseOver(clear, owner || target2 && this, eventTarget || isEventTarget && this);
    };
    p._handleDoubleClick = function(e, owner) {
      var target2 = null, nextStage = this._nextStage, o = this._getPointerData(-1);
      if (!owner) {
        target2 = this._getObjectsUnderPoint(o.x, o.y, null, true);
        this._dispatchMouseEvent(target2, "dblclick", true, -1, o, e);
      }
      nextStage && nextStage._handleDoubleClick(e, owner || target2 && this);
    };
    p._dispatchMouseEvent = function(target2, type, bubbles, pointerId, o, nativeEvent, relatedTarget) {
      if (!target2 || !bubbles && !target2.hasEventListener(type)) {
        return;
      }
      var evt = new createjs2.MouseEvent(type, bubbles, false, o.x, o.y, nativeEvent, pointerId, pointerId === this._primaryPointerID || pointerId === -1, o.rawX, o.rawY, relatedTarget);
      target2.dispatchEvent(evt);
    };
    createjs2.Stage = createjs2.promote(Stage, "Container");
  })();
  (function() {
    function Bitmap(imageOrUri) {
      this.DisplayObject_constructor();
      if (typeof imageOrUri == "string") {
        this.image = document.createElement("img");
        this.image.src = imageOrUri;
      } else {
        this.image = imageOrUri;
      }
      this.sourceRect = null;
    }
    var p = createjs2.extend(Bitmap, createjs2.DisplayObject);
    p.initialize = Bitmap;
    p.isVisible = function() {
      var image = this.image;
      var hasContent = this.cacheCanvas || image && (image.naturalWidth || image.getContext || image.readyState >= 2);
      return !!(this.visible && this.alpha > 0 && this.scaleX != 0 && this.scaleY != 0 && hasContent);
    };
    p.draw = function(ctx, ignoreCache) {
      if (this.DisplayObject_draw(ctx, ignoreCache) || !this.image) {
        return true;
      }
      var img = this.image, rect = this.sourceRect;
      if (rect) {
        var x1 = rect.x, y1 = rect.y, x2 = x1 + rect.width, y2 = y1 + rect.height, x3 = 0, y = 0, w = img.width, h = img.height;
        if (x1 < 0) {
          x3 -= x1;
          x1 = 0;
        }
        if (x2 > w) {
          x2 = w;
        }
        if (y1 < 0) {
          y -= y1;
          y1 = 0;
        }
        if (y2 > h) {
          y2 = h;
        }
        ctx.drawImage(img, x1, y1, x2 - x1, y2 - y1, x3, y, x2 - x1, y2 - y1);
      } else {
        ctx.drawImage(img, 0, 0);
      }
      return true;
    };
    p.getBounds = function() {
      var rect = this.DisplayObject_getBounds();
      if (rect) {
        return rect;
      }
      var image = this.image, o = this.sourceRect || image;
      var hasContent = image && (image.naturalWidth || image.getContext || image.readyState >= 2);
      return hasContent ? this._rectangle.setValues(0, 0, o.width, o.height) : null;
    };
    p.clone = function() {
      var o = new Bitmap(this.image);
      if (this.sourceRect) {
        o.sourceRect = this.sourceRect.clone();
      }
      this._cloneProps(o);
      return o;
    };
    p.toString = function() {
      return "[Bitmap (name=" + this.name + ")]";
    };
    createjs2.Bitmap = createjs2.promote(Bitmap, "DisplayObject");
  })();
  (function() {
    function Sprite(spriteSheet, frameOrAnimation) {
      this.DisplayObject_constructor();
      this.currentFrame = 0;
      this.currentAnimation = null;
      this.paused = true;
      this.spriteSheet = spriteSheet;
      this.currentAnimationFrame = 0;
      this.framerate = 0;
      this._animation = null;
      this._currentFrame = null;
      this._skipAdvance = false;
      if (frameOrAnimation != null) {
        this.gotoAndPlay(frameOrAnimation);
      }
    }
    var p = createjs2.extend(Sprite, createjs2.DisplayObject);
    p.initialize = Sprite;
    p.isVisible = function() {
      var hasContent = this.cacheCanvas || this.spriteSheet.complete;
      return !!(this.visible && this.alpha > 0 && this.scaleX != 0 && this.scaleY != 0 && hasContent);
    };
    p.draw = function(ctx, ignoreCache) {
      if (this.DisplayObject_draw(ctx, ignoreCache)) {
        return true;
      }
      this._normalizeFrame();
      var o = this.spriteSheet.getFrame(this._currentFrame | 0);
      if (!o) {
        return false;
      }
      var rect = o.rect;
      if (rect.width && rect.height) {
        ctx.drawImage(o.image, rect.x, rect.y, rect.width, rect.height, -o.regX, -o.regY, rect.width, rect.height);
      }
      return true;
    };
    p.play = function() {
      this.paused = false;
    };
    p.stop = function() {
      this.paused = true;
    };
    p.gotoAndPlay = function(frameOrAnimation) {
      this.paused = false;
      this._skipAdvance = true;
      this._goto(frameOrAnimation);
    };
    p.gotoAndStop = function(frameOrAnimation) {
      this.paused = true;
      this._goto(frameOrAnimation);
    };
    p.advance = function(time) {
      var fps = this.framerate || this.spriteSheet.framerate;
      var t3 = fps && time != null ? time / (1e3 / fps) : 1;
      this._normalizeFrame(t3);
    };
    p.getBounds = function() {
      return this.DisplayObject_getBounds() || this.spriteSheet.getFrameBounds(this.currentFrame, this._rectangle);
    };
    p.clone = function() {
      return this._cloneProps(new Sprite(this.spriteSheet));
    };
    p.toString = function() {
      return "[Sprite (name=" + this.name + ")]";
    };
    p._cloneProps = function(o) {
      this.DisplayObject__cloneProps(o);
      o.currentFrame = this.currentFrame;
      o.currentAnimation = this.currentAnimation;
      o.paused = this.paused;
      o.currentAnimationFrame = this.currentAnimationFrame;
      o.framerate = this.framerate;
      o._animation = this._animation;
      o._currentFrame = this._currentFrame;
      o._skipAdvance = this._skipAdvance;
      return o;
    };
    p._tick = function(evtObj) {
      if (!this.paused) {
        if (!this._skipAdvance) {
          this.advance(evtObj && evtObj.delta);
        }
        this._skipAdvance = false;
      }
      this.DisplayObject__tick(evtObj);
    };
    p._normalizeFrame = function(frameDelta) {
      frameDelta = frameDelta || 0;
      var animation = this._animation;
      var paused = this.paused;
      var frame = this._currentFrame;
      var l;
      if (animation) {
        var speed = animation.speed || 1;
        var animFrame = this.currentAnimationFrame;
        l = animation.frames.length;
        if (animFrame + frameDelta * speed >= l) {
          var next = animation.next;
          if (this._dispatchAnimationEnd(animation, frame, paused, next, l - 1)) {
            return;
          } else if (next) {
            return this._goto(next, frameDelta - (l - animFrame) / speed);
          } else {
            this.paused = true;
            animFrame = animation.frames.length - 1;
          }
        } else {
          animFrame += frameDelta * speed;
        }
        this.currentAnimationFrame = animFrame;
        this._currentFrame = animation.frames[animFrame | 0];
      } else {
        frame = this._currentFrame += frameDelta;
        l = this.spriteSheet.getNumFrames();
        if (frame >= l && l > 0) {
          if (!this._dispatchAnimationEnd(animation, frame, paused, l - 1)) {
            if ((this._currentFrame -= l) >= l) {
              return this._normalizeFrame();
            }
          }
        }
      }
      frame = this._currentFrame | 0;
      if (this.currentFrame != frame) {
        this.currentFrame = frame;
        this.dispatchEvent("change");
      }
    };
    p._dispatchAnimationEnd = function(animation, frame, paused, next, end) {
      var name = animation ? animation.name : null;
      if (this.hasEventListener("animationend")) {
        var evt = new createjs2.Event("animationend");
        evt.name = name;
        evt.next = next;
        this.dispatchEvent(evt);
      }
      var changed = this._animation != animation || this._currentFrame != frame;
      if (!changed && !paused && this.paused) {
        this.currentAnimationFrame = end;
        changed = true;
      }
      return changed;
    };
    p._goto = function(frameOrAnimation, frame) {
      this.currentAnimationFrame = 0;
      if (isNaN(frameOrAnimation)) {
        var data = this.spriteSheet.getAnimation(frameOrAnimation);
        if (data) {
          this._animation = data;
          this.currentAnimation = frameOrAnimation;
          this._normalizeFrame(frame);
        }
      } else {
        this.currentAnimation = this._animation = null;
        this._currentFrame = frameOrAnimation;
        this._normalizeFrame();
      }
    };
    createjs2.Sprite = createjs2.promote(Sprite, "DisplayObject");
  })();
  (function() {
    function Shape(graphics) {
      this.DisplayObject_constructor();
      this.graphics = graphics ? graphics : new createjs2.Graphics();
    }
    var p = createjs2.extend(Shape, createjs2.DisplayObject);
    p.isVisible = function() {
      var hasContent = this.cacheCanvas || this.graphics && !this.graphics.isEmpty();
      return !!(this.visible && this.alpha > 0 && this.scaleX != 0 && this.scaleY != 0 && hasContent);
    };
    p.draw = function(ctx, ignoreCache) {
      if (this.DisplayObject_draw(ctx, ignoreCache)) {
        return true;
      }
      this.graphics.draw(ctx, this);
      return true;
    };
    p.clone = function(recursive) {
      var g = recursive && this.graphics ? this.graphics.clone() : this.graphics;
      return this._cloneProps(new Shape(g));
    };
    p.toString = function() {
      return "[Shape (name=" + this.name + ")]";
    };
    createjs2.Shape = createjs2.promote(Shape, "DisplayObject");
  })();
  (function() {
    function Text2(text2, font, color2) {
      this.DisplayObject_constructor();
      this.text = text2;
      this.font = font;
      this.color = color2;
      this.textAlign = "left";
      this.textBaseline = "top";
      this.maxWidth = null;
      this.outline = 0;
      this.lineHeight = 0;
      this.lineWidth = null;
    }
    var p = createjs2.extend(Text2, createjs2.DisplayObject);
    var canvas = createjs2.createCanvas ? createjs2.createCanvas() : document.createElement("canvas");
    if (canvas.getContext) {
      Text2._workingContext = canvas.getContext("2d");
      canvas.width = canvas.height = 1;
    }
    Text2.H_OFFSETS = { start: 0, left: 0, center: -0.5, end: -1, right: -1 };
    Text2.V_OFFSETS = { top: 0, hanging: -0.01, middle: -0.4, alphabetic: -0.8, ideographic: -0.85, bottom: -1 };
    p.isVisible = function() {
      var hasContent = this.cacheCanvas || this.text != null && this.text !== "";
      return !!(this.visible && this.alpha > 0 && this.scaleX != 0 && this.scaleY != 0 && hasContent);
    };
    p.draw = function(ctx, ignoreCache) {
      if (this.DisplayObject_draw(ctx, ignoreCache)) {
        return true;
      }
      var col = this.color || "#000";
      if (this.outline) {
        ctx.strokeStyle = col;
        ctx.lineWidth = this.outline * 1;
      } else {
        ctx.fillStyle = col;
      }
      this._drawText(this._prepContext(ctx));
      return true;
    };
    p.getMeasuredWidth = function() {
      return this._getMeasuredWidth(this.text);
    };
    p.getMeasuredLineHeight = function() {
      return this._getMeasuredWidth("M") * 1.2;
    };
    p.getMeasuredHeight = function() {
      return this._drawText(null, {}).height;
    };
    p.getBounds = function() {
      var rect = this.DisplayObject_getBounds();
      if (rect) {
        return rect;
      }
      if (this.text == null || this.text === "") {
        return null;
      }
      var o = this._drawText(null, {});
      var w = this.maxWidth && this.maxWidth < o.width ? this.maxWidth : o.width;
      var x2 = w * Text2.H_OFFSETS[this.textAlign || "left"];
      var lineHeight = this.lineHeight || this.getMeasuredLineHeight();
      var y = lineHeight * Text2.V_OFFSETS[this.textBaseline || "top"];
      return this._rectangle.setValues(x2, y, w, o.height);
    };
    p.getMetrics = function() {
      var o = { lines: [] };
      o.lineHeight = this.lineHeight || this.getMeasuredLineHeight();
      o.vOffset = o.lineHeight * Text2.V_OFFSETS[this.textBaseline || "top"];
      return this._drawText(null, o, o.lines);
    };
    p.clone = function() {
      return this._cloneProps(new Text2(this.text, this.font, this.color));
    };
    p.toString = function() {
      return "[Text (text=" + (this.text.length > 20 ? this.text.substr(0, 17) + "..." : this.text) + ")]";
    };
    p._cloneProps = function(o) {
      this.DisplayObject__cloneProps(o);
      o.textAlign = this.textAlign;
      o.textBaseline = this.textBaseline;
      o.maxWidth = this.maxWidth;
      o.outline = this.outline;
      o.lineHeight = this.lineHeight;
      o.lineWidth = this.lineWidth;
      return o;
    };
    p._prepContext = function(ctx) {
      ctx.font = this.font || "10px sans-serif";
      ctx.textAlign = this.textAlign || "left";
      ctx.textBaseline = this.textBaseline || "top";
      return ctx;
    };
    p._drawText = function(ctx, o, lines) {
      var paint = !!ctx;
      if (!paint) {
        ctx = Text2._workingContext;
        ctx.save();
        this._prepContext(ctx);
      }
      var lineHeight = this.lineHeight || this.getMeasuredLineHeight();
      var maxW = 0, count = 0;
      var hardLines = String(this.text).split(/(?:\r\n|\r|\n)/);
      for (var i2 = 0, l = hardLines.length; i2 < l; i2++) {
        var str = hardLines[i2];
        var w = null;
        if (this.lineWidth != null && (w = ctx.measureText(str).width) > this.lineWidth) {
          var words = str.split(/(\s)/);
          str = words[0];
          w = ctx.measureText(str).width;
          for (var j = 1, jl = words.length; j < jl; j += 2) {
            var wordW = ctx.measureText(words[j] + words[j + 1]).width;
            if (w + wordW > this.lineWidth) {
              if (paint) {
                this._drawTextLine(ctx, str, count * lineHeight);
              }
              if (lines) {
                lines.push(str);
              }
              if (w > maxW) {
                maxW = w;
              }
              str = words[j + 1];
              w = ctx.measureText(str).width;
              count++;
            } else {
              str += words[j] + words[j + 1];
              w += wordW;
            }
          }
        }
        if (paint) {
          this._drawTextLine(ctx, str, count * lineHeight);
        }
        if (lines) {
          lines.push(str);
        }
        if (o && w == null) {
          w = ctx.measureText(str).width;
        }
        if (w > maxW) {
          maxW = w;
        }
        count++;
      }
      if (o) {
        o.width = maxW;
        o.height = count * lineHeight;
      }
      if (!paint) {
        ctx.restore();
      }
      return o;
    };
    p._drawTextLine = function(ctx, text2, y) {
      if (this.outline) {
        ctx.strokeText(text2, 0, y, this.maxWidth || 65535);
      } else {
        ctx.fillText(text2, 0, y, this.maxWidth || 65535);
      }
    };
    p._getMeasuredWidth = function(text2) {
      var ctx = Text2._workingContext;
      ctx.save();
      var w = this._prepContext(ctx).measureText(text2).width;
      ctx.restore();
      return w;
    };
    createjs2.Text = createjs2.promote(Text2, "DisplayObject");
  })();
  (function() {
    function BitmapText(text2, spriteSheet) {
      this.Container_constructor();
      this.text = text2 || "";
      this.spriteSheet = spriteSheet;
      this.lineHeight = 0;
      this.letterSpacing = 0;
      this.spaceWidth = 0;
      this._oldProps = { text: 0, spriteSheet: 0, lineHeight: 0, letterSpacing: 0, spaceWidth: 0 };
    }
    var p = createjs2.extend(BitmapText, createjs2.Container);
    BitmapText.maxPoolSize = 100;
    BitmapText._spritePool = [];
    p.draw = function(ctx, ignoreCache) {
      if (this.DisplayObject_draw(ctx, ignoreCache)) {
        return;
      }
      this._updateText();
      this.Container_draw(ctx, ignoreCache);
    };
    p.getBounds = function() {
      this._updateText();
      return this.Container_getBounds();
    };
    p.isVisible = function() {
      var hasContent = this.cacheCanvas || this.spriteSheet && this.spriteSheet.complete && this.text;
      return !!(this.visible && this.alpha > 0 && this.scaleX !== 0 && this.scaleY !== 0 && hasContent);
    };
    p.clone = function() {
      return this._cloneProps(new BitmapText(this.text, this.spriteSheet));
    };
    p.addChild = p.addChildAt = p.removeChild = p.removeChildAt = p.removeAllChildren = function() {
    };
    p._cloneProps = function(o) {
      this.Container__cloneProps(o);
      o.lineHeight = this.lineHeight;
      o.letterSpacing = this.letterSpacing;
      o.spaceWidth = this.spaceWidth;
      return o;
    };
    p._getFrameIndex = function(character, spriteSheet) {
      var c, o = spriteSheet.getAnimation(character);
      if (!o) {
        character != (c = character.toUpperCase()) || character != (c = character.toLowerCase()) || (c = null);
        if (c) {
          o = spriteSheet.getAnimation(c);
        }
      }
      return o && o.frames[0];
    };
    p._getFrame = function(character, spriteSheet) {
      var index2 = this._getFrameIndex(character, spriteSheet);
      return index2 == null ? index2 : spriteSheet.getFrame(index2);
    };
    p._getLineHeight = function(ss) {
      var frame = this._getFrame("1", ss) || this._getFrame("T", ss) || this._getFrame("L", ss) || ss.getFrame(0);
      return frame ? frame.rect.height : 1;
    };
    p._getSpaceWidth = function(ss) {
      var frame = this._getFrame("1", ss) || this._getFrame("l", ss) || this._getFrame("e", ss) || this._getFrame("a", ss) || ss.getFrame(0);
      return frame ? frame.rect.width : 1;
    };
    p._updateText = function() {
      var x2 = 0, y = 0, o = this._oldProps, change = false, spaceW = this.spaceWidth, lineH = this.lineHeight, ss = this.spriteSheet;
      var pool = BitmapText._spritePool, kids = this.children, childIndex = 0, numKids = kids.length, sprite;
      for (var n2 in o) {
        if (o[n2] != this[n2]) {
          o[n2] = this[n2];
          change = true;
        }
      }
      if (!change) {
        return;
      }
      var hasSpace = !!this._getFrame(" ", ss);
      if (!hasSpace && !spaceW) {
        spaceW = this._getSpaceWidth(ss);
      }
      if (!lineH) {
        lineH = this._getLineHeight(ss);
      }
      for (var i2 = 0, l = this.text.length; i2 < l; i2++) {
        var character = this.text.charAt(i2);
        if (character == " " && !hasSpace) {
          x2 += spaceW;
          continue;
        } else if (character == "\n" || character == "\r") {
          if (character == "\r" && this.text.charAt(i2 + 1) == "\n") {
            i2++;
          }
          x2 = 0;
          y += lineH;
          continue;
        }
        var index2 = this._getFrameIndex(character, ss);
        if (index2 == null) {
          continue;
        }
        if (childIndex < numKids) {
          sprite = kids[childIndex];
        } else {
          kids.push(sprite = pool.length ? pool.pop() : new createjs2.Sprite());
          sprite.parent = this;
          numKids++;
        }
        sprite.spriteSheet = ss;
        sprite.gotoAndStop(index2);
        sprite.x = x2;
        sprite.y = y;
        childIndex++;
        x2 += sprite.getBounds().width + this.letterSpacing;
      }
      while (numKids > childIndex) {
        pool.push(sprite = kids.pop());
        sprite.parent = null;
        numKids--;
      }
      if (pool.length > BitmapText.maxPoolSize) {
        pool.length = BitmapText.maxPoolSize;
      }
    };
    createjs2.BitmapText = createjs2.promote(BitmapText, "Container");
  })();
  (function() {
    function MovieClip(mode, startPosition, loop, labels) {
      this.Container_constructor();
      !MovieClip.inited && MovieClip.init();
      this.mode = mode || MovieClip.INDEPENDENT;
      this.startPosition = startPosition || 0;
      this.loop = loop;
      this.currentFrame = 0;
      this.timeline = new createjs2.Timeline(null, labels, { paused: true, position: startPosition, useTicks: true });
      this.paused = false;
      this.actionsEnabled = true;
      this.autoReset = true;
      this.frameBounds = this.frameBounds || null;
      this.framerate = null;
      this._synchOffset = 0;
      this._prevPos = -1;
      this._prevPosition = 0;
      this._t = 0;
      this._managed = {};
    }
    var p = createjs2.extend(MovieClip, createjs2.Container);
    MovieClip.INDEPENDENT = "independent";
    MovieClip.SINGLE_FRAME = "single";
    MovieClip.SYNCHED = "synched";
    MovieClip.inited = false;
    MovieClip.init = function() {
      if (MovieClip.inited) {
        return;
      }
      MovieClipPlugin.install();
      MovieClip.inited = true;
    };
    p.getLabels = function() {
      return this.timeline.getLabels();
    };
    p.getCurrentLabel = function() {
      this._updateTimeline();
      return this.timeline.getCurrentLabel();
    };
    p.getDuration = function() {
      return this.timeline.duration;
    };
    try {
      Object.defineProperties(p, {
        labels: { get: p.getLabels },
        currentLabel: { get: p.getCurrentLabel },
        totalFrames: { get: p.getDuration },
        duration: { get: p.getDuration }
      });
    } catch (e) {
    }
    p.initialize = MovieClip;
    p.isVisible = function() {
      return !!(this.visible && this.alpha > 0 && this.scaleX != 0 && this.scaleY != 0);
    };
    p.draw = function(ctx, ignoreCache) {
      if (this.DisplayObject_draw(ctx, ignoreCache)) {
        return true;
      }
      this._updateTimeline();
      this.Container_draw(ctx, ignoreCache);
      return true;
    };
    p.play = function() {
      this.paused = false;
    };
    p.stop = function() {
      this.paused = true;
    };
    p.gotoAndPlay = function(positionOrLabel) {
      this.paused = false;
      this._goto(positionOrLabel);
    };
    p.gotoAndStop = function(positionOrLabel) {
      this.paused = true;
      this._goto(positionOrLabel);
    };
    p.advance = function(time) {
      var independent = MovieClip.INDEPENDENT;
      if (this.mode != independent) {
        return;
      }
      var o = this, fps = o.framerate;
      while ((o = o.parent) && fps == null) {
        if (o.mode == independent) {
          fps = o._framerate;
        }
      }
      this._framerate = fps;
      var t3 = fps != null && fps != -1 && time != null ? time / (1e3 / fps) + this._t : 1;
      var frames = t3 | 0;
      this._t = t3 - frames;
      while (!this.paused && frames--) {
        this._prevPosition = this._prevPos < 0 ? 0 : this._prevPosition + 1;
        this._updateTimeline();
      }
    };
    p.clone = function() {
      throw "MovieClip cannot be cloned.";
    };
    p.toString = function() {
      return "[MovieClip (name=" + this.name + ")]";
    };
    p._tick = function(evtObj) {
      this.advance(evtObj && evtObj.delta);
      this.Container__tick(evtObj);
    };
    p._goto = function(positionOrLabel) {
      var pos = this.timeline.resolve(positionOrLabel);
      if (pos == null) {
        return;
      }
      if (this._prevPos == -1) {
        this._prevPos = NaN;
      }
      this._prevPosition = pos;
      this._t = 0;
      this._updateTimeline();
    };
    p._reset = function() {
      this._prevPos = -1;
      this._t = this.currentFrame = 0;
      this.paused = false;
    };
    p._updateTimeline = function() {
      var tl = this.timeline;
      var synched = this.mode != MovieClip.INDEPENDENT;
      tl.loop = this.loop == null ? true : this.loop;
      var pos = synched ? this.startPosition + (this.mode == MovieClip.SINGLE_FRAME ? 0 : this._synchOffset) : this._prevPos < 0 ? 0 : this._prevPosition;
      var mode = synched || !this.actionsEnabled ? createjs2.Tween.NONE : null;
      this.currentFrame = tl._calcPosition(pos);
      tl.setPosition(pos, mode);
      this._prevPosition = tl._prevPosition;
      if (this._prevPos == tl._prevPos) {
        return;
      }
      this.currentFrame = this._prevPos = tl._prevPos;
      for (var n2 in this._managed) {
        this._managed[n2] = 1;
      }
      var tweens = tl._tweens;
      for (var i2 = 0, l = tweens.length; i2 < l; i2++) {
        var tween = tweens[i2];
        var target2 = tween._target;
        if (target2 == this || tween.passive) {
          continue;
        }
        var offset2 = tween._stepPosition;
        if (target2 instanceof createjs2.DisplayObject) {
          this._addManagedChild(target2, offset2);
        } else {
          this._setState(target2.state, offset2);
        }
      }
      var kids = this.children;
      for (i2 = kids.length - 1; i2 >= 0; i2--) {
        var id = kids[i2].id;
        if (this._managed[id] == 1) {
          this.removeChildAt(i2);
          delete this._managed[id];
        }
      }
    };
    p._setState = function(state, offset2) {
      if (!state) {
        return;
      }
      for (var i2 = state.length - 1; i2 >= 0; i2--) {
        var o = state[i2];
        var target2 = o.t;
        var props2 = o.p;
        for (var n2 in props2) {
          target2[n2] = props2[n2];
        }
        this._addManagedChild(target2, offset2);
      }
    };
    p._addManagedChild = function(child, offset2) {
      if (child._off) {
        return;
      }
      this.addChildAt(child, 0);
      if (child instanceof MovieClip) {
        child._synchOffset = offset2;
        if (child.mode == MovieClip.INDEPENDENT && child.autoReset && !this._managed[child.id]) {
          child._reset();
        }
      }
      this._managed[child.id] = 2;
    };
    p._getBounds = function(matrix2, ignoreTransform) {
      var bounds = this.DisplayObject_getBounds();
      if (!bounds) {
        this._updateTimeline();
        if (this.frameBounds) {
          bounds = this._rectangle.copy(this.frameBounds[this.currentFrame]);
        }
      }
      if (bounds) {
        return this._transformBounds(bounds, matrix2, ignoreTransform);
      }
      return this.Container__getBounds(matrix2, ignoreTransform);
    };
    createjs2.MovieClip = createjs2.promote(MovieClip, "Container");
    function MovieClipPlugin() {
      throw "MovieClipPlugin cannot be instantiated.";
    }
    MovieClipPlugin.priority = 100;
    MovieClipPlugin.install = function() {
      createjs2.Tween.installPlugin(MovieClipPlugin, ["startPosition"]);
    };
    MovieClipPlugin.init = function(tween, prop, value) {
      return value;
    };
    MovieClipPlugin.step = function() {
    };
    MovieClipPlugin.tween = function(tween, prop, value, startValues, endValues, ratio, wait, end) {
      if (!(tween.target instanceof MovieClip)) {
        return value;
      }
      return ratio == 1 ? endValues[prop] : startValues[prop];
    };
  })();
  (function() {
    function SpriteSheetUtils() {
      throw "SpriteSheetUtils cannot be instantiated";
    }
    var canvas = createjs2.createCanvas ? createjs2.createCanvas() : document.createElement("canvas");
    if (canvas.getContext) {
      SpriteSheetUtils._workingCanvas = canvas;
      SpriteSheetUtils._workingContext = canvas.getContext("2d");
      canvas.width = canvas.height = 1;
    }
    SpriteSheetUtils.addFlippedFrames = function(spriteSheet, horizontal, vertical, both) {
      if (!horizontal && !vertical && !both) {
        return;
      }
      var count = 0;
      if (horizontal) {
        SpriteSheetUtils._flip(spriteSheet, ++count, true, false);
      }
      if (vertical) {
        SpriteSheetUtils._flip(spriteSheet, ++count, false, true);
      }
      if (both) {
        SpriteSheetUtils._flip(spriteSheet, ++count, true, true);
      }
    };
    SpriteSheetUtils.extractFrame = function(spriteSheet, frameOrAnimation) {
      if (isNaN(frameOrAnimation)) {
        frameOrAnimation = spriteSheet.getAnimation(frameOrAnimation).frames[0];
      }
      var data = spriteSheet.getFrame(frameOrAnimation);
      if (!data) {
        return null;
      }
      var r = data.rect;
      var canvas2 = SpriteSheetUtils._workingCanvas;
      canvas2.width = r.width;
      canvas2.height = r.height;
      SpriteSheetUtils._workingContext.drawImage(data.image, r.x, r.y, r.width, r.height, 0, 0, r.width, r.height);
      var img = document.createElement("img");
      img.src = canvas2.toDataURL("image/png");
      return img;
    };
    SpriteSheetUtils.mergeAlpha = function(rgbImage, alphaImage, canvas2) {
      if (!canvas2) {
        canvas2 = createjs2.createCanvas ? createjs2.createCanvas() : document.createElement("canvas");
      }
      canvas2.width = Math.max(alphaImage.width, rgbImage.width);
      canvas2.height = Math.max(alphaImage.height, rgbImage.height);
      var ctx = canvas2.getContext("2d");
      ctx.save();
      ctx.drawImage(rgbImage, 0, 0);
      ctx.globalCompositeOperation = "destination-in";
      ctx.drawImage(alphaImage, 0, 0);
      ctx.restore();
      return canvas2;
    };
    SpriteSheetUtils._flip = function(spriteSheet, count, h, v) {
      var imgs = spriteSheet._images;
      var canvas2 = SpriteSheetUtils._workingCanvas;
      var ctx = SpriteSheetUtils._workingContext;
      var il = imgs.length / count;
      for (var i2 = 0; i2 < il; i2++) {
        var src = imgs[i2];
        src.__tmp = i2;
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, canvas2.width + 1, canvas2.height + 1);
        canvas2.width = src.width;
        canvas2.height = src.height;
        ctx.setTransform(h ? -1 : 1, 0, 0, v ? -1 : 1, h ? src.width : 0, v ? src.height : 0);
        ctx.drawImage(src, 0, 0);
        var img = document.createElement("img");
        img.src = canvas2.toDataURL("image/png");
        img.width = src.width;
        img.height = src.height;
        imgs.push(img);
      }
      var frames = spriteSheet._frames;
      var fl = frames.length / count;
      for (i2 = 0; i2 < fl; i2++) {
        src = frames[i2];
        var rect = src.rect.clone();
        img = imgs[src.image.__tmp + il * count];
        var frame = { image: img, rect, regX: src.regX, regY: src.regY };
        if (h) {
          rect.x = img.width - rect.x - rect.width;
          frame.regX = rect.width - src.regX;
        }
        if (v) {
          rect.y = img.height - rect.y - rect.height;
          frame.regY = rect.height - src.regY;
        }
        frames.push(frame);
      }
      var sfx = "_" + (h ? "h" : "") + (v ? "v" : "");
      var names = spriteSheet._animations;
      var data = spriteSheet._data;
      var al = names.length / count;
      for (i2 = 0; i2 < al; i2++) {
        var name = names[i2];
        src = data[name];
        var anim = { name: name + sfx, speed: src.speed, next: src.next, frames: [] };
        if (src.next) {
          anim.next += sfx;
        }
        frames = src.frames;
        for (var j = 0, l = frames.length; j < l; j++) {
          anim.frames.push(frames[j] + fl * count);
        }
        data[anim.name] = anim;
        names.push(anim.name);
      }
    };
    createjs2.SpriteSheetUtils = SpriteSheetUtils;
  })();
  (function() {
    function SpriteSheetBuilder(framerate) {
      this.EventDispatcher_constructor();
      this.maxWidth = 2048;
      this.maxHeight = 2048;
      this.spriteSheet = null;
      this.scale = 1;
      this.padding = 1;
      this.timeSlice = 0.3;
      this.progress = -1;
      this.framerate = framerate || 0;
      this._frames = [];
      this._animations = {};
      this._data = null;
      this._nextFrameIndex = 0;
      this._index = 0;
      this._timerID = null;
      this._scale = 1;
    }
    var p = createjs2.extend(SpriteSheetBuilder, createjs2.EventDispatcher);
    SpriteSheetBuilder.ERR_DIMENSIONS = "frame dimensions exceed max spritesheet dimensions";
    SpriteSheetBuilder.ERR_RUNNING = "a build is already running";
    p.addFrame = function(source, sourceRect, scale, setupFunction, setupData) {
      if (this._data) {
        throw SpriteSheetBuilder.ERR_RUNNING;
      }
      var rect = sourceRect || source.bounds || source.nominalBounds;
      if (!rect && source.getBounds) {
        rect = source.getBounds();
      }
      if (!rect) {
        return null;
      }
      scale = scale || 1;
      return this._frames.push({ source, sourceRect: rect, scale, funct: setupFunction, data: setupData, index: this._frames.length, height: rect.height * scale }) - 1;
    };
    p.addAnimation = function(name, frames, next, speed) {
      if (this._data) {
        throw SpriteSheetBuilder.ERR_RUNNING;
      }
      this._animations[name] = { frames, next, speed };
    };
    p.addMovieClip = function(source, sourceRect, scale, setupFunction, setupData, labelFunction) {
      if (this._data) {
        throw SpriteSheetBuilder.ERR_RUNNING;
      }
      var rects = source.frameBounds;
      var rect = sourceRect || source.bounds || source.nominalBounds;
      if (!rect && source.getBounds) {
        rect = source.getBounds();
      }
      if (!rect && !rects) {
        return;
      }
      var i2, l, baseFrameIndex = this._frames.length;
      var duration = source.timeline.duration;
      for (i2 = 0; i2 < duration; i2++) {
        var r = rects && rects[i2] ? rects[i2] : rect;
        this.addFrame(source, r, scale, this._setupMovieClipFrame, { i: i2, f: setupFunction, d: setupData });
      }
      var labels = source.timeline._labels;
      var lbls = [];
      for (var n2 in labels) {
        lbls.push({ index: labels[n2], label: n2 });
      }
      if (lbls.length) {
        lbls.sort(function(a, b) {
          return a.index - b.index;
        });
        for (i2 = 0, l = lbls.length; i2 < l; i2++) {
          var label = lbls[i2].label;
          var start = baseFrameIndex + lbls[i2].index;
          var end = baseFrameIndex + (i2 == l - 1 ? duration : lbls[i2 + 1].index);
          var frames = [];
          for (var j = start; j < end; j++) {
            frames.push(j);
          }
          if (labelFunction) {
            label = labelFunction(label, source, start, end);
            if (!label) {
              continue;
            }
          }
          this.addAnimation(label, frames, true);
        }
      }
    };
    p.build = function() {
      if (this._data) {
        throw SpriteSheetBuilder.ERR_RUNNING;
      }
      this._startBuild();
      while (this._drawNext()) {
      }
      this._endBuild();
      return this.spriteSheet;
    };
    p.buildAsync = function(timeSlice) {
      if (this._data) {
        throw SpriteSheetBuilder.ERR_RUNNING;
      }
      this.timeSlice = timeSlice;
      this._startBuild();
      var _this2 = this;
      this._timerID = setTimeout(function() {
        _this2._run();
      }, 50 - Math.max(0.01, Math.min(0.99, this.timeSlice || 0.3)) * 50);
    };
    p.stopAsync = function() {
      clearTimeout(this._timerID);
      this._data = null;
    };
    p.clone = function() {
      throw "SpriteSheetBuilder cannot be cloned.";
    };
    p.toString = function() {
      return "[SpriteSheetBuilder]";
    };
    p._startBuild = function() {
      var pad = this.padding || 0;
      this.progress = 0;
      this.spriteSheet = null;
      this._index = 0;
      this._scale = this.scale;
      var dataFrames = [];
      this._data = {
        images: [],
        frames: dataFrames,
        framerate: this.framerate,
        animations: this._animations
        // TODO: should we "clone" _animations in case someone adds more animations after a build?
      };
      var frames = this._frames.slice();
      frames.sort(function(a, b) {
        return a.height <= b.height ? -1 : 1;
      });
      if (frames[frames.length - 1].height + pad * 2 > this.maxHeight) {
        throw SpriteSheetBuilder.ERR_DIMENSIONS;
      }
      var y = 0, x2 = 0;
      var img = 0;
      while (frames.length) {
        var o = this._fillRow(frames, y, img, dataFrames, pad);
        if (o.w > x2) {
          x2 = o.w;
        }
        y += o.h;
        if (!o.h || !frames.length) {
          var canvas = createjs2.createCanvas ? createjs2.createCanvas() : document.createElement("canvas");
          canvas.width = this._getSize(x2, this.maxWidth);
          canvas.height = this._getSize(y, this.maxHeight);
          this._data.images[img] = canvas;
          if (!o.h) {
            x2 = y = 0;
            img++;
          }
        }
      }
    };
    p._setupMovieClipFrame = function(source, data) {
      var ae = source.actionsEnabled;
      source.actionsEnabled = false;
      source.gotoAndStop(data.i);
      source.actionsEnabled = ae;
      data.f && data.f(source, data.d, data.i);
    };
    p._getSize = function(size, max2) {
      var pow = 4;
      while (Math.pow(2, ++pow) < size) {
      }
      return Math.min(max2, Math.pow(2, pow));
    };
    p._fillRow = function(frames, y, img, dataFrames, pad) {
      var w = this.maxWidth;
      var maxH = this.maxHeight;
      y += pad;
      var h = maxH - y;
      var x2 = pad;
      var height = 0;
      for (var i2 = frames.length - 1; i2 >= 0; i2--) {
        var frame = frames[i2];
        var sc = this._scale * frame.scale;
        var rect = frame.sourceRect;
        var source = frame.source;
        var rx = Math.floor(sc * rect.x - pad);
        var ry = Math.floor(sc * rect.y - pad);
        var rh = Math.ceil(sc * rect.height + pad * 2);
        var rw = Math.ceil(sc * rect.width + pad * 2);
        if (rw > w) {
          throw SpriteSheetBuilder.ERR_DIMENSIONS;
        }
        if (rh > h || x2 + rw > w) {
          continue;
        }
        frame.img = img;
        frame.rect = new createjs2.Rectangle(x2, y, rw, rh);
        height = height || rh;
        frames.splice(i2, 1);
        dataFrames[frame.index] = [x2, y, rw, rh, img, Math.round(-rx + sc * source.regX - pad), Math.round(-ry + sc * source.regY - pad)];
        x2 += rw;
      }
      return { w: x2, h: height };
    };
    p._endBuild = function() {
      this.spriteSheet = new createjs2.SpriteSheet(this._data);
      this._data = null;
      this.progress = 1;
      this.dispatchEvent("complete");
    };
    p._run = function() {
      var ts = Math.max(0.01, Math.min(0.99, this.timeSlice || 0.3)) * 50;
      var t3 = (/* @__PURE__ */ new Date()).getTime() + ts;
      var complete = false;
      while (t3 > (/* @__PURE__ */ new Date()).getTime()) {
        if (!this._drawNext()) {
          complete = true;
          break;
        }
      }
      if (complete) {
        this._endBuild();
      } else {
        var _this2 = this;
        this._timerID = setTimeout(function() {
          _this2._run();
        }, 50 - ts);
      }
      var p2 = this.progress = this._index / this._frames.length;
      if (this.hasEventListener("progress")) {
        var evt = new createjs2.Event("progress");
        evt.progress = p2;
        this.dispatchEvent(evt);
      }
    };
    p._drawNext = function() {
      var frame = this._frames[this._index];
      var sc = frame.scale * this._scale;
      var rect = frame.rect;
      var sourceRect = frame.sourceRect;
      var canvas = this._data.images[frame.img];
      var ctx = canvas.getContext("2d");
      frame.funct && frame.funct(frame.source, frame.data);
      ctx.save();
      ctx.beginPath();
      ctx.rect(rect.x, rect.y, rect.width, rect.height);
      ctx.clip();
      ctx.translate(Math.ceil(rect.x - sourceRect.x * sc), Math.ceil(rect.y - sourceRect.y * sc));
      ctx.scale(sc, sc);
      frame.source.draw(ctx);
      ctx.restore();
      return ++this._index < this._frames.length;
    };
    createjs2.SpriteSheetBuilder = createjs2.promote(SpriteSheetBuilder, "EventDispatcher");
  })();
  (function() {
    function DOMElement(htmlElement) {
      this.DisplayObject_constructor();
      if (typeof htmlElement == "string") {
        htmlElement = document.getElementById(htmlElement);
      }
      this.mouseEnabled = false;
      var style2 = htmlElement.style;
      style2.position = "absolute";
      style2.transformOrigin = style2.WebkitTransformOrigin = style2.msTransformOrigin = style2.MozTransformOrigin = style2.OTransformOrigin = "0% 0%";
      this.htmlElement = htmlElement;
      this._oldProps = null;
    }
    var p = createjs2.extend(DOMElement, createjs2.DisplayObject);
    p.isVisible = function() {
      return this.htmlElement != null;
    };
    p.draw = function(ctx, ignoreCache) {
      return true;
    };
    p.cache = function() {
    };
    p.uncache = function() {
    };
    p.updateCache = function() {
    };
    p.hitTest = function() {
    };
    p.localToGlobal = function() {
    };
    p.globalToLocal = function() {
    };
    p.localToLocal = function() {
    };
    p.clone = function() {
      throw "DOMElement cannot be cloned.";
    };
    p.toString = function() {
      return "[DOMElement (name=" + this.name + ")]";
    };
    p._tick = function(evtObj) {
      var stage = this.getStage();
      stage && stage.on("drawend", this._handleDrawEnd, this, true);
      this.DisplayObject__tick(evtObj);
    };
    p._handleDrawEnd = function(evt) {
      var o = this.htmlElement;
      if (!o) {
        return;
      }
      var style2 = o.style;
      var props2 = this.getConcatenatedDisplayProps(this._props), mtx = props2.matrix;
      var visibility = props2.visible ? "visible" : "hidden";
      if (visibility != style2.visibility) {
        style2.visibility = visibility;
      }
      if (!props2.visible) {
        return;
      }
      var oldProps = this._oldProps, oldMtx = oldProps && oldProps.matrix;
      var n2 = 1e4;
      if (!oldMtx || !oldMtx.equals(mtx)) {
        var str = "matrix(" + (mtx.a * n2 | 0) / n2 + "," + (mtx.b * n2 | 0) / n2 + "," + (mtx.c * n2 | 0) / n2 + "," + (mtx.d * n2 | 0) / n2 + "," + (mtx.tx + 0.5 | 0);
        style2.transform = style2.WebkitTransform = style2.OTransform = style2.msTransform = str + "," + (mtx.ty + 0.5 | 0) + ")";
        style2.MozTransform = str + "px," + (mtx.ty + 0.5 | 0) + "px)";
        if (!oldProps) {
          oldProps = this._oldProps = new createjs2.DisplayProps(true, NaN);
        }
        oldProps.matrix.copy(mtx);
      }
      if (oldProps.alpha != props2.alpha) {
        style2.opacity = "" + (props2.alpha * n2 | 0) / n2;
        oldProps.alpha = props2.alpha;
      }
    };
    createjs2.DOMElement = createjs2.promote(DOMElement, "DisplayObject");
  })();
  (function() {
    function Filter() {
    }
    var p = Filter.prototype;
    p.getBounds = function(rect) {
      return rect;
    };
    p.applyFilter = function(ctx, x2, y, width, height, targetCtx, targetX, targetY) {
      targetCtx = targetCtx || ctx;
      if (targetX == null) {
        targetX = x2;
      }
      if (targetY == null) {
        targetY = y;
      }
      try {
        var imageData = ctx.getImageData(x2, y, width, height);
      } catch (e) {
        return false;
      }
      if (this._applyFilter(imageData)) {
        targetCtx.putImageData(imageData, targetX, targetY);
        return true;
      }
      return false;
    };
    p.toString = function() {
      return "[Filter]";
    };
    p.clone = function() {
      return new Filter();
    };
    p._applyFilter = function(imageData) {
      return true;
    };
    createjs2.Filter = Filter;
  })();
  (function() {
    function BlurFilter(blurX, blurY, quality) {
      if (isNaN(blurX) || blurX < 0)
        blurX = 0;
      if (isNaN(blurY) || blurY < 0)
        blurY = 0;
      if (isNaN(quality) || quality < 1)
        quality = 1;
      this.blurX = blurX | 0;
      this.blurY = blurY | 0;
      this.quality = quality | 0;
    }
    var p = createjs2.extend(BlurFilter, createjs2.Filter);
    BlurFilter.MUL_TABLE = [1, 171, 205, 293, 57, 373, 79, 137, 241, 27, 391, 357, 41, 19, 283, 265, 497, 469, 443, 421, 25, 191, 365, 349, 335, 161, 155, 149, 9, 278, 269, 261, 505, 245, 475, 231, 449, 437, 213, 415, 405, 395, 193, 377, 369, 361, 353, 345, 169, 331, 325, 319, 313, 307, 301, 37, 145, 285, 281, 69, 271, 267, 263, 259, 509, 501, 493, 243, 479, 118, 465, 459, 113, 446, 55, 435, 429, 423, 209, 413, 51, 403, 199, 393, 97, 3, 379, 375, 371, 367, 363, 359, 355, 351, 347, 43, 85, 337, 333, 165, 327, 323, 5, 317, 157, 311, 77, 305, 303, 75, 297, 294, 73, 289, 287, 71, 141, 279, 277, 275, 68, 135, 67, 133, 33, 262, 260, 129, 511, 507, 503, 499, 495, 491, 61, 121, 481, 477, 237, 235, 467, 232, 115, 457, 227, 451, 7, 445, 221, 439, 218, 433, 215, 427, 425, 211, 419, 417, 207, 411, 409, 203, 202, 401, 399, 396, 197, 49, 389, 387, 385, 383, 95, 189, 47, 187, 93, 185, 23, 183, 91, 181, 45, 179, 89, 177, 11, 175, 87, 173, 345, 343, 341, 339, 337, 21, 167, 83, 331, 329, 327, 163, 81, 323, 321, 319, 159, 79, 315, 313, 39, 155, 309, 307, 153, 305, 303, 151, 75, 299, 149, 37, 295, 147, 73, 291, 145, 289, 287, 143, 285, 71, 141, 281, 35, 279, 139, 69, 275, 137, 273, 17, 271, 135, 269, 267, 133, 265, 33, 263, 131, 261, 130, 259, 129, 257, 1];
    BlurFilter.SHG_TABLE = [0, 9, 10, 11, 9, 12, 10, 11, 12, 9, 13, 13, 10, 9, 13, 13, 14, 14, 14, 14, 10, 13, 14, 14, 14, 13, 13, 13, 9, 14, 14, 14, 15, 14, 15, 14, 15, 15, 14, 15, 15, 15, 14, 15, 15, 15, 15, 15, 14, 15, 15, 15, 15, 15, 15, 12, 14, 15, 15, 13, 15, 15, 15, 15, 16, 16, 16, 15, 16, 14, 16, 16, 14, 16, 13, 16, 16, 16, 15, 16, 13, 16, 15, 16, 14, 9, 16, 16, 16, 16, 16, 16, 16, 16, 16, 13, 14, 16, 16, 15, 16, 16, 10, 16, 15, 16, 14, 16, 16, 14, 16, 16, 14, 16, 16, 14, 15, 16, 16, 16, 14, 15, 14, 15, 13, 16, 16, 15, 17, 17, 17, 17, 17, 17, 14, 15, 17, 17, 16, 16, 17, 16, 15, 17, 16, 17, 11, 17, 16, 17, 16, 17, 16, 17, 17, 16, 17, 17, 16, 17, 17, 16, 16, 17, 17, 17, 16, 14, 17, 17, 17, 17, 15, 16, 14, 16, 15, 16, 13, 16, 15, 16, 14, 16, 15, 16, 12, 16, 15, 16, 17, 17, 17, 17, 17, 13, 16, 15, 17, 17, 17, 16, 15, 17, 17, 17, 16, 15, 17, 17, 14, 16, 17, 17, 16, 17, 17, 16, 15, 17, 16, 14, 17, 16, 15, 17, 16, 17, 17, 16, 17, 15, 16, 17, 14, 17, 16, 15, 17, 16, 17, 13, 17, 16, 17, 17, 16, 17, 14, 17, 16, 17, 16, 17, 16, 17, 9];
    p.getBounds = function(rect) {
      var x2 = this.blurX | 0, y = this.blurY | 0;
      if (x2 <= 0 && y <= 0) {
        return rect;
      }
      var q = Math.pow(this.quality, 0.2);
      return (rect || new createjs2.Rectangle()).pad(x2 * q + 1, y * q + 1, x2 * q + 1, y * q + 1);
    };
    p.clone = function() {
      return new BlurFilter(this.blurX, this.blurY, this.quality);
    };
    p.toString = function() {
      return "[BlurFilter]";
    };
    p._applyFilter = function(imageData) {
      var radiusX = this.blurX >> 1;
      if (isNaN(radiusX) || radiusX < 0)
        return false;
      var radiusY = this.blurY >> 1;
      if (isNaN(radiusY) || radiusY < 0)
        return false;
      if (radiusX == 0 && radiusY == 0)
        return false;
      var iterations = this.quality;
      if (isNaN(iterations) || iterations < 1)
        iterations = 1;
      iterations |= 0;
      if (iterations > 3)
        iterations = 3;
      if (iterations < 1)
        iterations = 1;
      var px = imageData.data;
      var x2 = 0, y = 0, i2 = 0, p2 = 0, yp = 0, yi = 0, yw = 0, r = 0, g = 0, b = 0, a = 0, pr = 0, pg = 0, pb = 0, pa = 0;
      var divx = radiusX + radiusX + 1 | 0;
      var divy = radiusY + radiusY + 1 | 0;
      var w = imageData.width | 0;
      var h = imageData.height | 0;
      var w1 = w - 1 | 0;
      var h1 = h - 1 | 0;
      var rxp1 = radiusX + 1 | 0;
      var ryp1 = radiusY + 1 | 0;
      var ssx = { r: 0, b: 0, g: 0, a: 0 };
      var sx = ssx;
      for (i2 = 1; i2 < divx; i2++) {
        sx = sx.n = { r: 0, b: 0, g: 0, a: 0 };
      }
      sx.n = ssx;
      var ssy = { r: 0, b: 0, g: 0, a: 0 };
      var sy = ssy;
      for (i2 = 1; i2 < divy; i2++) {
        sy = sy.n = { r: 0, b: 0, g: 0, a: 0 };
      }
      sy.n = ssy;
      var si = null;
      var mtx = BlurFilter.MUL_TABLE[radiusX] | 0;
      var stx = BlurFilter.SHG_TABLE[radiusX] | 0;
      var mty = BlurFilter.MUL_TABLE[radiusY] | 0;
      var sty = BlurFilter.SHG_TABLE[radiusY] | 0;
      while (iterations-- > 0) {
        yw = yi = 0;
        var ms = mtx;
        var ss = stx;
        for (y = h; --y > -1; ) {
          r = rxp1 * (pr = px[yi | 0]);
          g = rxp1 * (pg = px[yi + 1 | 0]);
          b = rxp1 * (pb = px[yi + 2 | 0]);
          a = rxp1 * (pa = px[yi + 3 | 0]);
          sx = ssx;
          for (i2 = rxp1; --i2 > -1; ) {
            sx.r = pr;
            sx.g = pg;
            sx.b = pb;
            sx.a = pa;
            sx = sx.n;
          }
          for (i2 = 1; i2 < rxp1; i2++) {
            p2 = yi + ((w1 < i2 ? w1 : i2) << 2) | 0;
            r += sx.r = px[p2];
            g += sx.g = px[p2 + 1];
            b += sx.b = px[p2 + 2];
            a += sx.a = px[p2 + 3];
            sx = sx.n;
          }
          si = ssx;
          for (x2 = 0; x2 < w; x2++) {
            px[yi++] = r * ms >>> ss;
            px[yi++] = g * ms >>> ss;
            px[yi++] = b * ms >>> ss;
            px[yi++] = a * ms >>> ss;
            p2 = yw + ((p2 = x2 + radiusX + 1) < w1 ? p2 : w1) << 2;
            r -= si.r - (si.r = px[p2]);
            g -= si.g - (si.g = px[p2 + 1]);
            b -= si.b - (si.b = px[p2 + 2]);
            a -= si.a - (si.a = px[p2 + 3]);
            si = si.n;
          }
          yw += w;
        }
        ms = mty;
        ss = sty;
        for (x2 = 0; x2 < w; x2++) {
          yi = x2 << 2 | 0;
          r = ryp1 * (pr = px[yi]) | 0;
          g = ryp1 * (pg = px[yi + 1 | 0]) | 0;
          b = ryp1 * (pb = px[yi + 2 | 0]) | 0;
          a = ryp1 * (pa = px[yi + 3 | 0]) | 0;
          sy = ssy;
          for (i2 = 0; i2 < ryp1; i2++) {
            sy.r = pr;
            sy.g = pg;
            sy.b = pb;
            sy.a = pa;
            sy = sy.n;
          }
          yp = w;
          for (i2 = 1; i2 <= radiusY; i2++) {
            yi = yp + x2 << 2;
            r += sy.r = px[yi];
            g += sy.g = px[yi + 1];
            b += sy.b = px[yi + 2];
            a += sy.a = px[yi + 3];
            sy = sy.n;
            if (i2 < h1) {
              yp += w;
            }
          }
          yi = x2;
          si = ssy;
          if (iterations > 0) {
            for (y = 0; y < h; y++) {
              p2 = yi << 2;
              px[p2 + 3] = pa = a * ms >>> ss;
              if (pa > 0) {
                px[p2] = r * ms >>> ss;
                px[p2 + 1] = g * ms >>> ss;
                px[p2 + 2] = b * ms >>> ss;
              } else {
                px[p2] = px[p2 + 1] = px[p2 + 2] = 0;
              }
              p2 = x2 + ((p2 = y + ryp1) < h1 ? p2 : h1) * w << 2;
              r -= si.r - (si.r = px[p2]);
              g -= si.g - (si.g = px[p2 + 1]);
              b -= si.b - (si.b = px[p2 + 2]);
              a -= si.a - (si.a = px[p2 + 3]);
              si = si.n;
              yi += w;
            }
          } else {
            for (y = 0; y < h; y++) {
              p2 = yi << 2;
              px[p2 + 3] = pa = a * ms >>> ss;
              if (pa > 0) {
                pa = 255 / pa;
                px[p2] = (r * ms >>> ss) * pa;
                px[p2 + 1] = (g * ms >>> ss) * pa;
                px[p2 + 2] = (b * ms >>> ss) * pa;
              } else {
                px[p2] = px[p2 + 1] = px[p2 + 2] = 0;
              }
              p2 = x2 + ((p2 = y + ryp1) < h1 ? p2 : h1) * w << 2;
              r -= si.r - (si.r = px[p2]);
              g -= si.g - (si.g = px[p2 + 1]);
              b -= si.b - (si.b = px[p2 + 2]);
              a -= si.a - (si.a = px[p2 + 3]);
              si = si.n;
              yi += w;
            }
          }
        }
      }
      return true;
    };
    createjs2.BlurFilter = createjs2.promote(BlurFilter, "Filter");
  })();
  (function() {
    function AlphaMapFilter(alphaMap) {
      this.alphaMap = alphaMap;
      this._alphaMap = null;
      this._mapData = null;
    }
    var p = createjs2.extend(AlphaMapFilter, createjs2.Filter);
    p.clone = function() {
      var o = new AlphaMapFilter(this.alphaMap);
      o._alphaMap = this._alphaMap;
      o._mapData = this._mapData;
      return o;
    };
    p.toString = function() {
      return "[AlphaMapFilter]";
    };
    p._applyFilter = function(imageData) {
      if (!this.alphaMap) {
        return true;
      }
      if (!this._prepAlphaMap()) {
        return false;
      }
      var data = imageData.data;
      var map = this._mapData;
      for (var i2 = 0, l = data.length; i2 < l; i2 += 4) {
        data[i2 + 3] = map[i2] || 0;
      }
      return true;
    };
    p._prepAlphaMap = function() {
      if (!this.alphaMap) {
        return false;
      }
      if (this.alphaMap == this._alphaMap && this._mapData) {
        return true;
      }
      this._mapData = null;
      var map = this._alphaMap = this.alphaMap;
      var canvas = map;
      var ctx;
      if (map instanceof HTMLCanvasElement) {
        ctx = canvas.getContext("2d");
      } else {
        canvas = createjs2.createCanvas ? createjs2.createCanvas() : document.createElement("canvas");
        canvas.width = map.width;
        canvas.height = map.height;
        ctx = canvas.getContext("2d");
        ctx.drawImage(map, 0, 0);
      }
      try {
        var imgData = ctx.getImageData(0, 0, map.width, map.height);
      } catch (e) {
        return false;
      }
      this._mapData = imgData.data;
      return true;
    };
    createjs2.AlphaMapFilter = createjs2.promote(AlphaMapFilter, "Filter");
  })();
  (function() {
    function AlphaMaskFilter(mask) {
      this.mask = mask;
    }
    var p = createjs2.extend(AlphaMaskFilter, createjs2.Filter);
    p.applyFilter = function(ctx, x2, y, width, height, targetCtx, targetX, targetY) {
      if (!this.mask) {
        return true;
      }
      targetCtx = targetCtx || ctx;
      if (targetX == null) {
        targetX = x2;
      }
      if (targetY == null) {
        targetY = y;
      }
      targetCtx.save();
      if (ctx != targetCtx) {
        return false;
      }
      targetCtx.globalCompositeOperation = "destination-in";
      targetCtx.drawImage(this.mask, targetX, targetY);
      targetCtx.restore();
      return true;
    };
    p.clone = function() {
      return new AlphaMaskFilter(this.mask);
    };
    p.toString = function() {
      return "[AlphaMaskFilter]";
    };
    createjs2.AlphaMaskFilter = createjs2.promote(AlphaMaskFilter, "Filter");
  })();
  (function() {
    function ColorFilter(redMultiplier, greenMultiplier, blueMultiplier, alphaMultiplier, redOffset, greenOffset, blueOffset, alphaOffset) {
      this.redMultiplier = redMultiplier != null ? redMultiplier : 1;
      this.greenMultiplier = greenMultiplier != null ? greenMultiplier : 1;
      this.blueMultiplier = blueMultiplier != null ? blueMultiplier : 1;
      this.alphaMultiplier = alphaMultiplier != null ? alphaMultiplier : 1;
      this.redOffset = redOffset || 0;
      this.greenOffset = greenOffset || 0;
      this.blueOffset = blueOffset || 0;
      this.alphaOffset = alphaOffset || 0;
    }
    var p = createjs2.extend(ColorFilter, createjs2.Filter);
    p.toString = function() {
      return "[ColorFilter]";
    };
    p.clone = function() {
      return new ColorFilter(this.redMultiplier, this.greenMultiplier, this.blueMultiplier, this.alphaMultiplier, this.redOffset, this.greenOffset, this.blueOffset, this.alphaOffset);
    };
    p._applyFilter = function(imageData) {
      var data = imageData.data;
      var l = data.length;
      for (var i2 = 0; i2 < l; i2 += 4) {
        data[i2] = data[i2] * this.redMultiplier + this.redOffset;
        data[i2 + 1] = data[i2 + 1] * this.greenMultiplier + this.greenOffset;
        data[i2 + 2] = data[i2 + 2] * this.blueMultiplier + this.blueOffset;
        data[i2 + 3] = data[i2 + 3] * this.alphaMultiplier + this.alphaOffset;
      }
      return true;
    };
    createjs2.ColorFilter = createjs2.promote(ColorFilter, "Filter");
  })();
  (function() {
    function ColorMatrix(brightness, contrast, saturation, hue) {
      this.setColor(brightness, contrast, saturation, hue);
    }
    var p = ColorMatrix.prototype;
    ColorMatrix.DELTA_INDEX = [
      0,
      0.01,
      0.02,
      0.04,
      0.05,
      0.06,
      0.07,
      0.08,
      0.1,
      0.11,
      0.12,
      0.14,
      0.15,
      0.16,
      0.17,
      0.18,
      0.2,
      0.21,
      0.22,
      0.24,
      0.25,
      0.27,
      0.28,
      0.3,
      0.32,
      0.34,
      0.36,
      0.38,
      0.4,
      0.42,
      0.44,
      0.46,
      0.48,
      0.5,
      0.53,
      0.56,
      0.59,
      0.62,
      0.65,
      0.68,
      0.71,
      0.74,
      0.77,
      0.8,
      0.83,
      0.86,
      0.89,
      0.92,
      0.95,
      0.98,
      1,
      1.06,
      1.12,
      1.18,
      1.24,
      1.3,
      1.36,
      1.42,
      1.48,
      1.54,
      1.6,
      1.66,
      1.72,
      1.78,
      1.84,
      1.9,
      1.96,
      2,
      2.12,
      2.25,
      2.37,
      2.5,
      2.62,
      2.75,
      2.87,
      3,
      3.2,
      3.4,
      3.6,
      3.8,
      4,
      4.3,
      4.7,
      4.9,
      5,
      5.5,
      6,
      6.5,
      6.8,
      7,
      7.3,
      7.5,
      7.8,
      8,
      8.4,
      8.7,
      9,
      9.4,
      9.6,
      9.8,
      10
    ];
    ColorMatrix.IDENTITY_MATRIX = [
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1
    ];
    ColorMatrix.LENGTH = ColorMatrix.IDENTITY_MATRIX.length;
    p.setColor = function(brightness, contrast, saturation, hue) {
      return this.reset().adjustColor(brightness, contrast, saturation, hue);
    };
    p.reset = function() {
      return this.copy(ColorMatrix.IDENTITY_MATRIX);
    };
    p.adjustColor = function(brightness, contrast, saturation, hue) {
      this.adjustHue(hue);
      this.adjustContrast(contrast);
      this.adjustBrightness(brightness);
      return this.adjustSaturation(saturation);
    };
    p.adjustBrightness = function(value) {
      if (value == 0 || isNaN(value)) {
        return this;
      }
      value = this._cleanValue(value, 255);
      this._multiplyMatrix([
        1,
        0,
        0,
        0,
        value,
        0,
        1,
        0,
        0,
        value,
        0,
        0,
        1,
        0,
        value,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1
      ]);
      return this;
    };
    p.adjustContrast = function(value) {
      if (value == 0 || isNaN(value)) {
        return this;
      }
      value = this._cleanValue(value, 100);
      var x2;
      if (value < 0) {
        x2 = 127 + value / 100 * 127;
      } else {
        x2 = value % 1;
        if (x2 == 0) {
          x2 = ColorMatrix.DELTA_INDEX[value];
        } else {
          x2 = ColorMatrix.DELTA_INDEX[value << 0] * (1 - x2) + ColorMatrix.DELTA_INDEX[(value << 0) + 1] * x2;
        }
        x2 = x2 * 127 + 127;
      }
      this._multiplyMatrix([
        x2 / 127,
        0,
        0,
        0,
        0.5 * (127 - x2),
        0,
        x2 / 127,
        0,
        0,
        0.5 * (127 - x2),
        0,
        0,
        x2 / 127,
        0,
        0.5 * (127 - x2),
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1
      ]);
      return this;
    };
    p.adjustSaturation = function(value) {
      if (value == 0 || isNaN(value)) {
        return this;
      }
      value = this._cleanValue(value, 100);
      var x2 = 1 + (value > 0 ? 3 * value / 100 : value / 100);
      var lumR = 0.3086;
      var lumG = 0.6094;
      var lumB = 0.082;
      this._multiplyMatrix([
        lumR * (1 - x2) + x2,
        lumG * (1 - x2),
        lumB * (1 - x2),
        0,
        0,
        lumR * (1 - x2),
        lumG * (1 - x2) + x2,
        lumB * (1 - x2),
        0,
        0,
        lumR * (1 - x2),
        lumG * (1 - x2),
        lumB * (1 - x2) + x2,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1
      ]);
      return this;
    };
    p.adjustHue = function(value) {
      if (value == 0 || isNaN(value)) {
        return this;
      }
      value = this._cleanValue(value, 180) / 180 * Math.PI;
      var cosVal = Math.cos(value);
      var sinVal = Math.sin(value);
      var lumR = 0.213;
      var lumG = 0.715;
      var lumB = 0.072;
      this._multiplyMatrix([
        lumR + cosVal * (1 - lumR) + sinVal * -lumR,
        lumG + cosVal * -lumG + sinVal * -lumG,
        lumB + cosVal * -lumB + sinVal * (1 - lumB),
        0,
        0,
        lumR + cosVal * -lumR + sinVal * 0.143,
        lumG + cosVal * (1 - lumG) + sinVal * 0.14,
        lumB + cosVal * -lumB + sinVal * -0.283,
        0,
        0,
        lumR + cosVal * -lumR + sinVal * -(1 - lumR),
        lumG + cosVal * -lumG + sinVal * lumG,
        lumB + cosVal * (1 - lumB) + sinVal * lumB,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1
      ]);
      return this;
    };
    p.concat = function(matrix2) {
      matrix2 = this._fixMatrix(matrix2);
      if (matrix2.length != ColorMatrix.LENGTH) {
        return this;
      }
      this._multiplyMatrix(matrix2);
      return this;
    };
    p.clone = function() {
      return new ColorMatrix().copy(this);
    };
    p.toArray = function() {
      var arr = [];
      for (var i2 = 0, l = ColorMatrix.LENGTH; i2 < l; i2++) {
        arr[i2] = this[i2];
      }
      return arr;
    };
    p.copy = function(matrix2) {
      var l = ColorMatrix.LENGTH;
      for (var i2 = 0; i2 < l; i2++) {
        this[i2] = matrix2[i2];
      }
      return this;
    };
    p.toString = function() {
      return "[ColorMatrix]";
    };
    p._multiplyMatrix = function(matrix2) {
      var i2, j, k, col = [];
      for (i2 = 0; i2 < 5; i2++) {
        for (j = 0; j < 5; j++) {
          col[j] = this[j + i2 * 5];
        }
        for (j = 0; j < 5; j++) {
          var val = 0;
          for (k = 0; k < 5; k++) {
            val += matrix2[j + k * 5] * col[k];
          }
          this[j + i2 * 5] = val;
        }
      }
    };
    p._cleanValue = function(value, limit) {
      return Math.min(limit, Math.max(-limit, value));
    };
    p._fixMatrix = function(matrix2) {
      if (matrix2 instanceof ColorMatrix) {
        matrix2 = matrix2.toArray();
      }
      if (matrix2.length < ColorMatrix.LENGTH) {
        matrix2 = matrix2.slice(0, matrix2.length).concat(ColorMatrix.IDENTITY_MATRIX.slice(matrix2.length, ColorMatrix.LENGTH));
      } else if (matrix2.length > ColorMatrix.LENGTH) {
        matrix2 = matrix2.slice(0, ColorMatrix.LENGTH);
      }
      return matrix2;
    };
    createjs2.ColorMatrix = ColorMatrix;
  })();
  (function() {
    function ColorMatrixFilter(matrix2) {
      this.matrix = matrix2;
    }
    var p = createjs2.extend(ColorMatrixFilter, createjs2.Filter);
    p.toString = function() {
      return "[ColorMatrixFilter]";
    };
    p.clone = function() {
      return new ColorMatrixFilter(this.matrix);
    };
    p._applyFilter = function(imageData) {
      var data = imageData.data;
      var l = data.length;
      var r, g, b, a;
      var mtx = this.matrix;
      var m0 = mtx[0], m1 = mtx[1], m2 = mtx[2], m3 = mtx[3], m4 = mtx[4];
      var m5 = mtx[5], m6 = mtx[6], m7 = mtx[7], m8 = mtx[8], m9 = mtx[9];
      var m10 = mtx[10], m11 = mtx[11], m12 = mtx[12], m13 = mtx[13], m14 = mtx[14];
      var m15 = mtx[15], m16 = mtx[16], m17 = mtx[17], m18 = mtx[18], m19 = mtx[19];
      for (var i2 = 0; i2 < l; i2 += 4) {
        r = data[i2];
        g = data[i2 + 1];
        b = data[i2 + 2];
        a = data[i2 + 3];
        data[i2] = r * m0 + g * m1 + b * m2 + a * m3 + m4;
        data[i2 + 1] = r * m5 + g * m6 + b * m7 + a * m8 + m9;
        data[i2 + 2] = r * m10 + g * m11 + b * m12 + a * m13 + m14;
        data[i2 + 3] = r * m15 + g * m16 + b * m17 + a * m18 + m19;
      }
      return true;
    };
    createjs2.ColorMatrixFilter = createjs2.promote(ColorMatrixFilter, "Filter");
  })();
  (function() {
    function Touch() {
      throw "Touch cannot be instantiated";
    }
    Touch.isSupported = function() {
      return !!("ontouchstart" in window || window.navigator["msPointerEnabled"] && window.navigator["msMaxTouchPoints"] > 0 || window.navigator["pointerEnabled"] && window.navigator["maxTouchPoints"] > 0);
    };
    Touch.enable = function(stage, singleTouch, allowDefault) {
      if (!stage || !stage.canvas || !Touch.isSupported()) {
        return false;
      }
      if (stage.__touch) {
        return true;
      }
      stage.__touch = { pointers: {}, multitouch: !singleTouch, preventDefault: !allowDefault, count: 0 };
      if ("ontouchstart" in window) {
        Touch._IOS_enable(stage);
      } else if (window.navigator["msPointerEnabled"] || window.navigator["pointerEnabled"]) {
        Touch._IE_enable(stage);
      }
      return true;
    };
    Touch.disable = function(stage) {
      if (!stage) {
        return;
      }
      if ("ontouchstart" in window) {
        Touch._IOS_disable(stage);
      } else if (window.navigator["msPointerEnabled"] || window.navigator["pointerEnabled"]) {
        Touch._IE_disable(stage);
      }
      delete stage.__touch;
    };
    Touch._IOS_enable = function(stage) {
      var canvas = stage.canvas;
      var f = stage.__touch.f = function(e) {
        Touch._IOS_handleEvent(stage, e);
      };
      canvas.addEventListener("touchstart", f, false);
      canvas.addEventListener("touchmove", f, false);
      canvas.addEventListener("touchend", f, false);
      canvas.addEventListener("touchcancel", f, false);
    };
    Touch._IOS_disable = function(stage) {
      var canvas = stage.canvas;
      if (!canvas) {
        return;
      }
      var f = stage.__touch.f;
      canvas.removeEventListener("touchstart", f, false);
      canvas.removeEventListener("touchmove", f, false);
      canvas.removeEventListener("touchend", f, false);
      canvas.removeEventListener("touchcancel", f, false);
    };
    Touch._IOS_handleEvent = function(stage, e) {
      if (!stage) {
        return;
      }
      if (stage.__touch.preventDefault) {
        e.preventDefault && e.preventDefault();
      }
      var touches = e.changedTouches;
      var type = e.type;
      for (var i2 = 0, l = touches.length; i2 < l; i2++) {
        var touch = touches[i2];
        var id = touch.identifier;
        if (touch.target != stage.canvas) {
          continue;
        }
        if (type == "touchstart") {
          this._handleStart(stage, id, e, touch.pageX, touch.pageY);
        } else if (type == "touchmove") {
          this._handleMove(stage, id, e, touch.pageX, touch.pageY);
        } else if (type == "touchend" || type == "touchcancel") {
          this._handleEnd(stage, id, e);
        }
      }
    };
    Touch._IE_enable = function(stage) {
      var canvas = stage.canvas;
      var f = stage.__touch.f = function(e) {
        Touch._IE_handleEvent(stage, e);
      };
      if (window.navigator["pointerEnabled"] === void 0) {
        canvas.addEventListener("MSPointerDown", f, false);
        window.addEventListener("MSPointerMove", f, false);
        window.addEventListener("MSPointerUp", f, false);
        window.addEventListener("MSPointerCancel", f, false);
        if (stage.__touch.preventDefault) {
          canvas.style.msTouchAction = "none";
        }
      } else {
        canvas.addEventListener("pointerdown", f, false);
        window.addEventListener("pointermove", f, false);
        window.addEventListener("pointerup", f, false);
        window.addEventListener("pointercancel", f, false);
        if (stage.__touch.preventDefault) {
          canvas.style.touchAction = "none";
        }
      }
      stage.__touch.activeIDs = {};
    };
    Touch._IE_disable = function(stage) {
      var f = stage.__touch.f;
      if (window.navigator["pointerEnabled"] === void 0) {
        window.removeEventListener("MSPointerMove", f, false);
        window.removeEventListener("MSPointerUp", f, false);
        window.removeEventListener("MSPointerCancel", f, false);
        if (stage.canvas) {
          stage.canvas.removeEventListener("MSPointerDown", f, false);
        }
      } else {
        window.removeEventListener("pointermove", f, false);
        window.removeEventListener("pointerup", f, false);
        window.removeEventListener("pointercancel", f, false);
        if (stage.canvas) {
          stage.canvas.removeEventListener("pointerdown", f, false);
        }
      }
    };
    Touch._IE_handleEvent = function(stage, e) {
      if (!stage) {
        return;
      }
      if (stage.__touch.preventDefault) {
        e.preventDefault && e.preventDefault();
      }
      var type = e.type;
      var id = e.pointerId;
      var ids = stage.__touch.activeIDs;
      if (type == "MSPointerDown" || type == "pointerdown") {
        if (e.srcElement != stage.canvas) {
          return;
        }
        ids[id] = true;
        this._handleStart(stage, id, e, e.pageX, e.pageY);
      } else if (ids[id]) {
        if (type == "MSPointerMove" || type == "pointermove") {
          this._handleMove(stage, id, e, e.pageX, e.pageY);
        } else if (type == "MSPointerUp" || type == "MSPointerCancel" || type == "pointerup" || type == "pointercancel") {
          delete ids[id];
          this._handleEnd(stage, id, e);
        }
      }
    };
    Touch._handleStart = function(stage, id, e, x2, y) {
      var props2 = stage.__touch;
      if (!props2.multitouch && props2.count) {
        return;
      }
      var ids = props2.pointers;
      if (ids[id]) {
        return;
      }
      ids[id] = true;
      props2.count++;
      stage._handlePointerDown(id, e, x2, y);
    };
    Touch._handleMove = function(stage, id, e, x2, y) {
      if (!stage.__touch.pointers[id]) {
        return;
      }
      stage._handlePointerMove(id, e, x2, y);
    };
    Touch._handleEnd = function(stage, id, e) {
      var props2 = stage.__touch;
      var ids = props2.pointers;
      if (!ids[id]) {
        return;
      }
      props2.count--;
      stage._handlePointerUp(id, e, true);
      delete ids[id];
    };
    createjs2.Touch = Touch;
  })();
  (function() {
    var s2 = createjs2.EaselJS = createjs2.EaselJS || {};
    s2.version = /*=version*/
    "0.8.2";
    s2.buildDate = /*=date*/
    "Thu, 26 Nov 2015 20:44:34 GMT";
  })();
  (function() {
    var s2 = createjs2.PreloadJS = createjs2.PreloadJS || {};
    s2.version = /*=version*/
    "0.6.2";
    s2.buildDate = /*=date*/
    "Thu, 26 Nov 2015 20:44:31 GMT";
  })();
  (function() {
    createjs2.proxy = function(method, scope) {
      var aArgs = Array.prototype.slice.call(arguments, 2);
      return function() {
        return method.apply(scope, Array.prototype.slice.call(arguments, 0).concat(aArgs));
      };
    };
  })();
  (function() {
    function ErrorEvent(title, message, data) {
      this.Event_constructor("error");
      this.title = title;
      this.message = message;
      this.data = data;
    }
    var p = createjs2.extend(ErrorEvent, createjs2.Event);
    p.clone = function() {
      return new createjs2.ErrorEvent(this.title, this.message, this.data);
    };
    createjs2.ErrorEvent = createjs2.promote(ErrorEvent, "Event");
  })();
  (function(scope) {
    function ProgressEvent(loaded, total) {
      this.Event_constructor("progress");
      this.loaded = loaded;
      this.total = total == null ? 1 : total;
      this.progress = total == 0 ? 0 : this.loaded / this.total;
    }
    var p = createjs2.extend(ProgressEvent, createjs2.Event);
    p.clone = function() {
      return new createjs2.ProgressEvent(this.loaded, this.total);
    };
    createjs2.ProgressEvent = createjs2.promote(ProgressEvent, "Event");
  })();
  (function() {
    var isLoader = false;
    var objectTypes = {
      "function": true,
      "object": true
    };
    var freeExports = exports && !exports.nodeType && exports;
    var root2 = objectTypes[typeof window] && window || this, freeGlobal2 = freeExports && objectTypes["object"] && module && !module.nodeType && typeof commonjsGlobal == "object" && commonjsGlobal;
    if (freeGlobal2 && (freeGlobal2["global"] === freeGlobal2 || freeGlobal2["window"] === freeGlobal2 || freeGlobal2["self"] === freeGlobal2)) {
      root2 = freeGlobal2;
    }
    function runInContext(context, exports2) {
      context || (context = root2["Object"]());
      exports2 || (exports2 = root2["Object"]());
      var Number2 = context["Number"] || root2["Number"], String2 = context["String"] || root2["String"], Object2 = context["Object"] || root2["Object"], Date2 = context["Date"] || root2["Date"], SyntaxError = context["SyntaxError"] || root2["SyntaxError"], TypeError2 = context["TypeError"] || root2["TypeError"], Math2 = context["Math"] || root2["Math"], nativeJSON2 = context["JSON"] || root2["JSON"];
      if (typeof nativeJSON2 == "object" && nativeJSON2) {
        exports2.stringify = nativeJSON2.stringify;
        exports2.parse = nativeJSON2.parse;
      }
      var objectProto2 = Object2.prototype, getClass = objectProto2.toString, isProperty, forEach3, undef;
      var isExtended = new Date2(-3509827334573292);
      try {
        isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 && // Safari < 2.0.2 stores the internal millisecond time value correctly,
        // but clips the values returned by the date methods to the range of
        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
      } catch (exception) {
      }
      function has2(name) {
        if (has2[name] !== undef) {
          return has2[name];
        }
        var isSupported;
        if (name == "bug-string-char-index") {
          isSupported = "a"[0] != "a";
        } else if (name == "json") {
          isSupported = has2("json-stringify") && has2("json-parse");
        } else {
          var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
          if (name == "json-stringify") {
            var stringify2 = exports2.stringify, stringifySupported = typeof stringify2 == "function" && isExtended;
            if (stringifySupported) {
              (value = function() {
                return 1;
              }).toJSON = value;
              try {
                stringifySupported = // Firefox 3.1b1 and b2 serialize string, number, and boolean
                // primitives as object literals.
                stringify2(0) === "0" && // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
                // literals.
                stringify2(new Number2()) === "0" && stringify2(new String2()) == '""' && // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
                // does not define a canonical JSON representation (this applies to
                // objects with `toJSON` properties as well, *unless* they are nested
                // within an object or array).
                stringify2(getClass) === undef && // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
                // FF 3.1b3 pass this test.
                stringify2(undef) === undef && // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
                // respectively, if the value is omitted entirely.
                stringify2() === undef && // FF 3.1b1, 2 throw an error if the given value is not a number,
                // string, array, object, Boolean, or `null` literal. This applies to
                // objects with custom `toJSON` methods as well, unless they are nested
                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
                // methods entirely.
                stringify2(value) === "1" && stringify2([value]) == "[1]" && // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
                // `"[null]"`.
                stringify2([undef]) == "[null]" && // YUI 3.0.0b1 fails to serialize `null` literals.
                stringify2(null) == "null" && // FF 3.1b1, 2 halts serialization if an array contains a function:
                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
                // elides non-JSON values from objects and arrays, unless they
                // define custom `toJSON` methods.
                stringify2([undef, getClass, null]) == "[null,null,null]" && // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
                // where character escape codes are expected (e.g., `\b` => `\u0008`).
                stringify2({ "a": [value, true, false, null, "\0\b\n\f\r	"] }) == serialized && // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
                stringify2(null, value) === "1" && stringify2([1, 2], null, 1) == "[\n 1,\n 2\n]" && // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
                // serialize extended years.
                stringify2(new Date2(-864e13)) == '"-271821-04-20T00:00:00.000Z"' && // The milliseconds are optional in ES 5, but required in 5.1.
                stringify2(new Date2(864e13)) == '"+275760-09-13T00:00:00.000Z"' && // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
                // four-digit years instead of six-digit years. Credits: @Yaffle.
                stringify2(new Date2(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' && // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
                // values less than 1000. Credits: @Yaffle.
                stringify2(new Date2(-1)) == '"1969-12-31T23:59:59.999Z"';
              } catch (exception) {
                stringifySupported = false;
              }
            }
            isSupported = stringifySupported;
          }
          if (name == "json-parse") {
            var parse2 = exports2.parse;
            if (typeof parse2 == "function") {
              try {
                if (parse2("0") === 0 && !parse2(false)) {
                  value = parse2(serialized);
                  var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
                  if (parseSupported) {
                    try {
                      parseSupported = !parse2('"	"');
                    } catch (exception) {
                    }
                    if (parseSupported) {
                      try {
                        parseSupported = parse2("01") !== 1;
                      } catch (exception) {
                      }
                    }
                    if (parseSupported) {
                      try {
                        parseSupported = parse2("1.") !== 1;
                      } catch (exception) {
                      }
                    }
                  }
                }
              } catch (exception) {
                parseSupported = false;
              }
            }
            isSupported = parseSupported;
          }
        }
        return has2[name] = !!isSupported;
      }
      if (!has2("json")) {
        var functionClass = "[object Function]", dateClass = "[object Date]", numberClass = "[object Number]", stringClass = "[object String]", arrayClass = "[object Array]", booleanClass = "[object Boolean]";
        var charIndexBuggy = has2("bug-string-char-index");
        if (!isExtended) {
          var floor = Math2.floor;
          var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
          var getDay = function(year, month) {
            return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
          };
        }
        if (!(isProperty = objectProto2.hasOwnProperty)) {
          isProperty = function(property2) {
            var members = {}, constructor;
            if ((members.__proto__ = null, members.__proto__ = {
              // The *proto* property cannot be set multiple times in recent
              // versions of Firefox and SeaMonkey.
              "toString": 1
            }, members).toString != getClass) {
              isProperty = function(property3) {
                var original = this.__proto__, result2 = property3 in (this.__proto__ = null, this);
                this.__proto__ = original;
                return result2;
              };
            } else {
              constructor = members.constructor;
              isProperty = function(property3) {
                var parent2 = (this.constructor || constructor).prototype;
                return property3 in this && !(property3 in parent2 && this[property3] === parent2[property3]);
              };
            }
            members = null;
            return isProperty.call(this, property2);
          };
        }
        forEach3 = function(object, callback) {
          var size = 0, Properties, members, property2;
          (Properties = function() {
            this.valueOf = 0;
          }).prototype.valueOf = 0;
          members = new Properties();
          for (property2 in members) {
            if (isProperty.call(members, property2)) {
              size++;
            }
          }
          Properties = members = null;
          if (!size) {
            members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
            forEach3 = function(object2, callback2) {
              var isFunction2 = getClass.call(object2) == functionClass, property3, length;
              var hasProperty = !isFunction2 && typeof object2.constructor != "function" && objectTypes[typeof object2.hasOwnProperty] && object2.hasOwnProperty || isProperty;
              for (property3 in object2) {
                if (!(isFunction2 && property3 == "prototype") && hasProperty.call(object2, property3)) {
                  callback2(property3);
                }
              }
              for (length = members.length; property3 = members[--length]; hasProperty.call(object2, property3) && callback2(property3))
                ;
            };
          } else if (size == 2) {
            forEach3 = function(object2, callback2) {
              var members2 = {}, isFunction2 = getClass.call(object2) == functionClass, property3;
              for (property3 in object2) {
                if (!(isFunction2 && property3 == "prototype") && !isProperty.call(members2, property3) && (members2[property3] = 1) && isProperty.call(object2, property3)) {
                  callback2(property3);
                }
              }
            };
          } else {
            forEach3 = function(object2, callback2) {
              var isFunction2 = getClass.call(object2) == functionClass, property3, isConstructor;
              for (property3 in object2) {
                if (!(isFunction2 && property3 == "prototype") && isProperty.call(object2, property3) && !(isConstructor = property3 === "constructor")) {
                  callback2(property3);
                }
              }
              if (isConstructor || isProperty.call(object2, property3 = "constructor")) {
                callback2(property3);
              }
            };
          }
          return forEach3(object, callback);
        };
        if (!has2("json-stringify")) {
          var Escapes = {
            92: "\\\\",
            34: '\\"',
            8: "\\b",
            12: "\\f",
            10: "\\n",
            13: "\\r",
            9: "\\t"
          };
          var leadingZeroes = "000000";
          var toPaddedString = function(width, value) {
            return (leadingZeroes + (value || 0)).slice(-width);
          };
          var unicodePrefix = "\\u00";
          var quote = function(value) {
            var result2 = '"', index2 = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
            var symbols2 = useCharIndex && (charIndexBuggy ? value.split("") : value);
            for (; index2 < length; index2++) {
              var charCode = value.charCodeAt(index2);
              switch (charCode) {
                case 8:
                case 9:
                case 10:
                case 12:
                case 13:
                case 34:
                case 92:
                  result2 += Escapes[charCode];
                  break;
                default:
                  if (charCode < 32) {
                    result2 += unicodePrefix + toPaddedString(2, charCode.toString(16));
                    break;
                  }
                  result2 += useCharIndex ? symbols2[index2] : value.charAt(index2);
              }
            }
            return result2 + '"';
          };
          var serialize = function(property2, object, callback, properties, whitespace, indentation, stack) {
            var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index2, length, prefix, result2;
            try {
              value = object[property2];
            } catch (exception) {
            }
            if (typeof value == "object" && value) {
              className = getClass.call(value);
              if (className == dateClass && !isProperty.call(value, "toJSON")) {
                if (value > -1 / 0 && value < 1 / 0) {
                  if (getDay) {
                    date = floor(value / 864e5);
                    for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++)
                      ;
                    for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++)
                      ;
                    date = 1 + date - getDay(year, month);
                    time = (value % 864e5 + 864e5) % 864e5;
                    hours = floor(time / 36e5) % 24;
                    minutes = floor(time / 6e4) % 60;
                    seconds = floor(time / 1e3) % 60;
                    milliseconds = time % 1e3;
                  } else {
                    year = value.getUTCFullYear();
                    month = value.getUTCMonth();
                    date = value.getUTCDate();
                    hours = value.getUTCHours();
                    minutes = value.getUTCMinutes();
                    seconds = value.getUTCSeconds();
                    milliseconds = value.getUTCMilliseconds();
                  }
                  value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) + "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) + // Months, dates, hours, minutes, and seconds should have two
                  // digits; milliseconds should have three.
                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) + // Milliseconds are optional in ES 5.0, but required in 5.1.
                  "." + toPaddedString(3, milliseconds) + "Z";
                } else {
                  value = null;
                }
              } else if (typeof value.toJSON == "function" && (className != numberClass && className != stringClass && className != arrayClass || isProperty.call(value, "toJSON"))) {
                value = value.toJSON(property2);
              }
            }
            if (callback) {
              value = callback.call(object, property2, value);
            }
            if (value === null) {
              return "null";
            }
            className = getClass.call(value);
            if (className == booleanClass) {
              return "" + value;
            } else if (className == numberClass) {
              return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
            } else if (className == stringClass) {
              return quote("" + value);
            }
            if (typeof value == "object") {
              for (length = stack.length; length--; ) {
                if (stack[length] === value) {
                  throw TypeError2();
                }
              }
              stack.push(value);
              results = [];
              prefix = indentation;
              indentation += whitespace;
              if (className == arrayClass) {
                for (index2 = 0, length = value.length; index2 < length; index2++) {
                  element = serialize(index2, value, callback, properties, whitespace, indentation, stack);
                  results.push(element === undef ? "null" : element);
                }
                result2 = results.length ? whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : "[" + results.join(",") + "]" : "[]";
              } else {
                forEach3(properties || value, function(property3) {
                  var element2 = serialize(property3, value, callback, properties, whitespace, indentation, stack);
                  if (element2 !== undef) {
                    results.push(quote(property3) + ":" + (whitespace ? " " : "") + element2);
                  }
                });
                result2 = results.length ? whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : "{" + results.join(",") + "}" : "{}";
              }
              stack.pop();
              return result2;
            }
          };
          exports2.stringify = function(source, filter2, width) {
            var whitespace, callback, properties, className;
            if (objectTypes[typeof filter2] && filter2) {
              if ((className = getClass.call(filter2)) == functionClass) {
                callback = filter2;
              } else if (className == arrayClass) {
                properties = {};
                for (var index2 = 0, length = filter2.length, value; index2 < length; value = filter2[index2++], (className = getClass.call(value), className == stringClass || className == numberClass) && (properties[value] = 1))
                  ;
              }
            }
            if (width) {
              if ((className = getClass.call(width)) == numberClass) {
                if ((width -= width % 1) > 0) {
                  for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ")
                    ;
                }
              } else if (className == stringClass) {
                whitespace = width.length <= 10 ? width : width.slice(0, 10);
              }
            }
            return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
          };
        }
        if (!has2("json-parse")) {
          var fromCharCode = String2.fromCharCode;
          var Unescapes = {
            92: "\\",
            34: '"',
            47: "/",
            98: "\b",
            116: "	",
            110: "\n",
            102: "\f",
            114: "\r"
          };
          var Index, Source2;
          var abort = function() {
            Index = Source2 = null;
            throw SyntaxError();
          };
          var lex = function() {
            var source = Source2, length = source.length, value, begin, position, isSigned, charCode;
            while (Index < length) {
              charCode = source.charCodeAt(Index);
              switch (charCode) {
                case 9:
                case 10:
                case 13:
                case 32:
                  Index++;
                  break;
                case 123:
                case 125:
                case 91:
                case 93:
                case 58:
                case 44:
                  value = charIndexBuggy ? source.charAt(Index) : source[Index];
                  Index++;
                  return value;
                case 34:
                  for (value = "@", Index++; Index < length; ) {
                    charCode = source.charCodeAt(Index);
                    if (charCode < 32) {
                      abort();
                    } else if (charCode == 92) {
                      charCode = source.charCodeAt(++Index);
                      switch (charCode) {
                        case 92:
                        case 34:
                        case 47:
                        case 98:
                        case 116:
                        case 110:
                        case 102:
                        case 114:
                          value += Unescapes[charCode];
                          Index++;
                          break;
                        case 117:
                          begin = ++Index;
                          for (position = Index + 4; Index < position; Index++) {
                            charCode = source.charCodeAt(Index);
                            if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
                              abort();
                            }
                          }
                          value += fromCharCode("0x" + source.slice(begin, Index));
                          break;
                        default:
                          abort();
                      }
                    } else {
                      if (charCode == 34) {
                        break;
                      }
                      charCode = source.charCodeAt(Index);
                      begin = Index;
                      while (charCode >= 32 && charCode != 92 && charCode != 34) {
                        charCode = source.charCodeAt(++Index);
                      }
                      value += source.slice(begin, Index);
                    }
                  }
                  if (source.charCodeAt(Index) == 34) {
                    Index++;
                    return value;
                  }
                  abort();
                default:
                  begin = Index;
                  if (charCode == 45) {
                    isSigned = true;
                    charCode = source.charCodeAt(++Index);
                  }
                  if (charCode >= 48 && charCode <= 57) {
                    if (charCode == 48 && (charCode = source.charCodeAt(Index + 1), charCode >= 48 && charCode <= 57)) {
                      abort();
                    }
                    isSigned = false;
                    for (; Index < length && (charCode = source.charCodeAt(Index), charCode >= 48 && charCode <= 57); Index++)
                      ;
                    if (source.charCodeAt(Index) == 46) {
                      position = ++Index;
                      for (; position < length && (charCode = source.charCodeAt(position), charCode >= 48 && charCode <= 57); position++)
                        ;
                      if (position == Index) {
                        abort();
                      }
                      Index = position;
                    }
                    charCode = source.charCodeAt(Index);
                    if (charCode == 101 || charCode == 69) {
                      charCode = source.charCodeAt(++Index);
                      if (charCode == 43 || charCode == 45) {
                        Index++;
                      }
                      for (position = Index; position < length && (charCode = source.charCodeAt(position), charCode >= 48 && charCode <= 57); position++)
                        ;
                      if (position == Index) {
                        abort();
                      }
                      Index = position;
                    }
                    return +source.slice(begin, Index);
                  }
                  if (isSigned) {
                    abort();
                  }
                  if (source.slice(Index, Index + 4) == "true") {
                    Index += 4;
                    return true;
                  } else if (source.slice(Index, Index + 5) == "false") {
                    Index += 5;
                    return false;
                  } else if (source.slice(Index, Index + 4) == "null") {
                    Index += 4;
                    return null;
                  }
                  abort();
              }
            }
            return "$";
          };
          var get5 = function(value) {
            var results, hasMembers;
            if (value == "$") {
              abort();
            }
            if (typeof value == "string") {
              if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
                return value.slice(1);
              }
              if (value == "[") {
                results = [];
                for (; ; hasMembers || (hasMembers = true)) {
                  value = lex();
                  if (value == "]") {
                    break;
                  }
                  if (hasMembers) {
                    if (value == ",") {
                      value = lex();
                      if (value == "]") {
                        abort();
                      }
                    } else {
                      abort();
                    }
                  }
                  if (value == ",") {
                    abort();
                  }
                  results.push(get5(value));
                }
                return results;
              } else if (value == "{") {
                results = {};
                for (; ; hasMembers || (hasMembers = true)) {
                  value = lex();
                  if (value == "}") {
                    break;
                  }
                  if (hasMembers) {
                    if (value == ",") {
                      value = lex();
                      if (value == "}") {
                        abort();
                      }
                    } else {
                      abort();
                    }
                  }
                  if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
                    abort();
                  }
                  results[value.slice(1)] = get5(lex());
                }
                return results;
              }
              abort();
            }
            return value;
          };
          var update5 = function(source, property2, callback) {
            var element = walk2(source, property2, callback);
            if (element === undef) {
              delete source[property2];
            } else {
              source[property2] = element;
            }
          };
          var walk2 = function(source, property2, callback) {
            var value = source[property2], length;
            if (typeof value == "object" && value) {
              if (getClass.call(value) == arrayClass) {
                for (length = value.length; length--; ) {
                  update5(value, length, callback);
                }
              } else {
                forEach3(value, function(property3) {
                  update5(value, property3, callback);
                });
              }
            }
            return callback.call(source, property2, value);
          };
          exports2.parse = function(source, callback) {
            var result2, value;
            Index = 0;
            Source2 = "" + source;
            result2 = get5(lex());
            if (lex() != "$") {
              abort();
            }
            Index = Source2 = null;
            return callback && getClass.call(callback) == functionClass ? walk2((value = {}, value[""] = result2, value), "", callback) : result2;
          };
        }
      }
      exports2["runInContext"] = runInContext;
      return exports2;
    }
    if (freeExports && !isLoader) {
      runInContext(root2, freeExports);
    } else {
      var nativeJSON = root2.JSON, previousJSON = root2["JSON3"], isRestored = false;
      var JSON3 = runInContext(root2, root2["JSON3"] = {
        // Public: Restores the original value of the global `JSON` object and
        // returns a reference to the `JSON3` object.
        "noConflict": function() {
          if (!isRestored) {
            isRestored = true;
            root2.JSON = nativeJSON;
            root2["JSON3"] = previousJSON;
            nativeJSON = previousJSON = null;
          }
          return JSON3;
        }
      });
      root2.JSON = {
        "parse": JSON3.parse,
        "stringify": JSON3.stringify
      };
    }
  }).call(commonjsGlobal);
  (function() {
    var s2 = {};
    s2.appendToHead = function(el) {
      s2.getHead().appendChild(el);
    };
    s2.getHead = function() {
      return document.head || document.getElementsByTagName("head")[0];
    };
    s2.getBody = function() {
      return document.body || document.getElementsByTagName("body")[0];
    };
    createjs2.DomUtils = s2;
  })();
  (function() {
    var s2 = {};
    s2.parseXML = function(text2, type) {
      var xml = null;
      try {
        if (window.DOMParser) {
          var parser2 = new DOMParser();
          xml = parser2.parseFromString(text2, type);
        }
      } catch (e) {
      }
      if (!xml) {
        try {
          xml = new ActiveXObject("Microsoft.XMLDOM");
          xml.async = false;
          xml.loadXML(text2);
        } catch (e) {
          xml = null;
        }
      }
      return xml;
    };
    s2.parseJSON = function(value) {
      if (value == null) {
        return null;
      }
      try {
        return JSON.parse(value);
      } catch (e) {
        throw e;
      }
    };
    createjs2.DataUtils = s2;
  })();
  (function() {
    function LoadItem() {
      this.src = null;
      this.type = null;
      this.id = null;
      this.maintainOrder = false;
      this.callback = null;
      this.data = null;
      this.method = createjs2.LoadItem.GET;
      this.values = null;
      this.headers = null;
      this.withCredentials = false;
      this.mimeType = null;
      this.crossOrigin = null;
      this.loadTimeout = s2.LOAD_TIMEOUT_DEFAULT;
    }
    var p = LoadItem.prototype = {};
    var s2 = LoadItem;
    s2.LOAD_TIMEOUT_DEFAULT = 8e3;
    s2.create = function(value) {
      if (typeof value == "string") {
        var item = new LoadItem();
        item.src = value;
        return item;
      } else if (value instanceof s2) {
        return value;
      } else if (value instanceof Object && value.src) {
        if (value.loadTimeout == null) {
          value.loadTimeout = s2.LOAD_TIMEOUT_DEFAULT;
        }
        return value;
      } else {
        throw new Error("Type not recognized.");
      }
    };
    p.set = function(props2) {
      for (var n2 in props2) {
        this[n2] = props2[n2];
      }
      return this;
    };
    createjs2.LoadItem = s2;
  })();
  (function() {
    var s2 = {};
    s2.ABSOLUTE_PATT = /^(?:\w+:)?\/{2}/i;
    s2.RELATIVE_PATT = /^[./]*?\//i;
    s2.EXTENSION_PATT = /\/?[^/]+\.(\w{1,5})$/i;
    s2.parseURI = function(path) {
      var info = { absolute: false, relative: false };
      if (path == null) {
        return info;
      }
      var queryIndex = path.indexOf("?");
      if (queryIndex > -1) {
        path = path.substr(0, queryIndex);
      }
      var match;
      if (s2.ABSOLUTE_PATT.test(path)) {
        info.absolute = true;
      } else if (s2.RELATIVE_PATT.test(path)) {
        info.relative = true;
      }
      if (match = path.match(s2.EXTENSION_PATT)) {
        info.extension = match[1].toLowerCase();
      }
      return info;
    };
    s2.formatQueryString = function(data, query2) {
      if (data == null) {
        throw new Error("You must specify data.");
      }
      var params = [];
      for (var n2 in data) {
        params.push(n2 + "=" + escape(data[n2]));
      }
      if (query2) {
        params = params.concat(query2);
      }
      return params.join("&");
    };
    s2.buildPath = function(src, data) {
      if (data == null) {
        return src;
      }
      var query2 = [];
      var idx = src.indexOf("?");
      if (idx != -1) {
        var q = src.slice(idx + 1);
        query2 = query2.concat(q.split("&"));
      }
      if (idx != -1) {
        return src.slice(0, idx) + "?" + this.formatQueryString(data, query2);
      } else {
        return src + "?" + this.formatQueryString(data, query2);
      }
    };
    s2.isCrossDomain = function(item) {
      var target2 = document.createElement("a");
      target2.href = item.src;
      var host = document.createElement("a");
      host.href = location.href;
      var crossdomain = target2.hostname != "" && (target2.port != host.port || target2.protocol != host.protocol || target2.hostname != host.hostname);
      return crossdomain;
    };
    s2.isLocal = function(item) {
      var target2 = document.createElement("a");
      target2.href = item.src;
      return target2.hostname == "" && target2.protocol == "file:";
    };
    s2.isBinary = function(type) {
      switch (type) {
        case createjs2.AbstractLoader.IMAGE:
        case createjs2.AbstractLoader.BINARY:
          return true;
        default:
          return false;
      }
    };
    s2.isImageTag = function(item) {
      return item instanceof HTMLImageElement;
    };
    s2.isAudioTag = function(item) {
      if (window.HTMLAudioElement) {
        return item instanceof HTMLAudioElement;
      } else {
        return false;
      }
    };
    s2.isVideoTag = function(item) {
      if (window.HTMLVideoElement) {
        return item instanceof HTMLVideoElement;
      } else {
        return false;
      }
    };
    s2.isText = function(type) {
      switch (type) {
        case createjs2.AbstractLoader.TEXT:
        case createjs2.AbstractLoader.JSON:
        case createjs2.AbstractLoader.MANIFEST:
        case createjs2.AbstractLoader.XML:
        case createjs2.AbstractLoader.CSS:
        case createjs2.AbstractLoader.SVG:
        case createjs2.AbstractLoader.JAVASCRIPT:
        case createjs2.AbstractLoader.SPRITESHEET:
          return true;
        default:
          return false;
      }
    };
    s2.getTypeByExtension = function(extension) {
      if (extension == null) {
        return createjs2.AbstractLoader.TEXT;
      }
      switch (extension.toLowerCase()) {
        case "jpeg":
        case "jpg":
        case "gif":
        case "png":
        case "webp":
        case "bmp":
          return createjs2.AbstractLoader.IMAGE;
        case "ogg":
        case "mp3":
        case "webm":
          return createjs2.AbstractLoader.SOUND;
        case "mp4":
        case "webm":
        case "ts":
          return createjs2.AbstractLoader.VIDEO;
        case "json":
          return createjs2.AbstractLoader.JSON;
        case "xml":
          return createjs2.AbstractLoader.XML;
        case "css":
          return createjs2.AbstractLoader.CSS;
        case "js":
          return createjs2.AbstractLoader.JAVASCRIPT;
        case "svg":
          return createjs2.AbstractLoader.SVG;
        default:
          return createjs2.AbstractLoader.TEXT;
      }
    };
    createjs2.RequestUtils = s2;
  })();
  (function() {
    function AbstractLoader(loadItem, preferXHR, type) {
      this.EventDispatcher_constructor();
      this.loaded = false;
      this.canceled = false;
      this.progress = 0;
      this.type = type;
      this.resultFormatter = null;
      if (loadItem) {
        this._item = createjs2.LoadItem.create(loadItem);
      } else {
        this._item = null;
      }
      this._preferXHR = preferXHR;
      this._result = null;
      this._rawResult = null;
      this._loadedItems = null;
      this._tagSrcAttribute = null;
      this._tag = null;
    }
    var p = createjs2.extend(AbstractLoader, createjs2.EventDispatcher);
    var s2 = AbstractLoader;
    s2.POST = "POST";
    s2.GET = "GET";
    s2.BINARY = "binary";
    s2.CSS = "css";
    s2.IMAGE = "image";
    s2.JAVASCRIPT = "javascript";
    s2.JSON = "json";
    s2.JSONP = "jsonp";
    s2.MANIFEST = "manifest";
    s2.SOUND = "sound";
    s2.VIDEO = "video";
    s2.SPRITESHEET = "spritesheet";
    s2.SVG = "svg";
    s2.TEXT = "text";
    s2.XML = "xml";
    p.getItem = function() {
      return this._item;
    };
    p.getResult = function(raw) {
      return raw ? this._rawResult : this._result;
    };
    p.getTag = function() {
      return this._tag;
    };
    p.setTag = function(tag) {
      this._tag = tag;
    };
    p.load = function() {
      this._createRequest();
      this._request.on("complete", this, this);
      this._request.on("progress", this, this);
      this._request.on("loadStart", this, this);
      this._request.on("abort", this, this);
      this._request.on("timeout", this, this);
      this._request.on("error", this, this);
      var evt = new createjs2.Event("initialize");
      evt.loader = this._request;
      this.dispatchEvent(evt);
      this._request.load();
    };
    p.cancel = function() {
      this.canceled = true;
      this.destroy();
    };
    p.destroy = function() {
      if (this._request) {
        this._request.removeAllEventListeners();
        this._request.destroy();
      }
      this._request = null;
      this._item = null;
      this._rawResult = null;
      this._result = null;
      this._loadItems = null;
      this.removeAllEventListeners();
    };
    p.getLoadedItems = function() {
      return this._loadedItems;
    };
    p._createRequest = function() {
      if (!this._preferXHR) {
        this._request = new createjs2.TagRequest(this._item, this._tag || this._createTag(), this._tagSrcAttribute);
      } else {
        this._request = new createjs2.XHRRequest(this._item);
      }
    };
    p._createTag = function(src) {
      return null;
    };
    p._sendLoadStart = function() {
      if (this._isCanceled()) {
        return;
      }
      this.dispatchEvent("loadstart");
    };
    p._sendProgress = function(value) {
      if (this._isCanceled()) {
        return;
      }
      var event = null;
      if (typeof value == "number") {
        this.progress = value;
        event = new createjs2.ProgressEvent(this.progress);
      } else {
        event = value;
        this.progress = value.loaded / value.total;
        event.progress = this.progress;
        if (isNaN(this.progress) || this.progress == Infinity) {
          this.progress = 0;
        }
      }
      this.hasEventListener("progress") && this.dispatchEvent(event);
    };
    p._sendComplete = function() {
      if (this._isCanceled()) {
        return;
      }
      this.loaded = true;
      var event = new createjs2.Event("complete");
      event.rawResult = this._rawResult;
      if (this._result != null) {
        event.result = this._result;
      }
      this.dispatchEvent(event);
    };
    p._sendError = function(event) {
      if (this._isCanceled() || !this.hasEventListener("error")) {
        return;
      }
      if (event == null) {
        event = new createjs2.ErrorEvent("PRELOAD_ERROR_EMPTY");
      }
      this.dispatchEvent(event);
    };
    p._isCanceled = function() {
      if (window.createjs == null || this.canceled) {
        return true;
      }
      return false;
    };
    p.resultFormatter = null;
    p.handleEvent = function(event) {
      switch (event.type) {
        case "complete":
          this._rawResult = event.target._response;
          var result2 = this.resultFormatter && this.resultFormatter(this);
          if (result2 instanceof Function) {
            result2.call(
              this,
              createjs2.proxy(this._resultFormatSuccess, this),
              createjs2.proxy(this._resultFormatFailed, this)
            );
          } else {
            this._result = result2 || this._rawResult;
            this._sendComplete();
          }
          break;
        case "progress":
          this._sendProgress(event);
          break;
        case "error":
          this._sendError(event);
          break;
        case "loadstart":
          this._sendLoadStart();
          break;
        case "abort":
        case "timeout":
          if (!this._isCanceled()) {
            this.dispatchEvent(new createjs2.ErrorEvent("PRELOAD_" + event.type.toUpperCase() + "_ERROR"));
          }
          break;
      }
    };
    p._resultFormatSuccess = function(result2) {
      this._result = result2;
      this._sendComplete();
    };
    p._resultFormatFailed = function(event) {
      this._sendError(event);
    };
    p.buildPath = function(src, data) {
      return createjs2.RequestUtils.buildPath(src, data);
    };
    p.toString = function() {
      return "[PreloadJS AbstractLoader]";
    };
    createjs2.AbstractLoader = createjs2.promote(AbstractLoader, "EventDispatcher");
  })();
  (function() {
    function AbstractMediaLoader(loadItem, preferXHR, type) {
      this.AbstractLoader_constructor(loadItem, preferXHR, type);
      this.resultFormatter = this._formatResult;
      this._tagSrcAttribute = "src";
      this.on("initialize", this._updateXHR, this);
    }
    var p = createjs2.extend(AbstractMediaLoader, createjs2.AbstractLoader);
    p.load = function() {
      if (!this._tag) {
        this._tag = this._createTag(this._item.src);
      }
      this._tag.preload = "auto";
      this._tag.load();
      this.AbstractLoader_load();
    };
    p._createTag = function() {
    };
    p._createRequest = function() {
      if (!this._preferXHR) {
        this._request = new createjs2.MediaTagRequest(this._item, this._tag || this._createTag(), this._tagSrcAttribute);
      } else {
        this._request = new createjs2.XHRRequest(this._item);
      }
    };
    p._updateXHR = function(event) {
      if (event.loader.setResponseType) {
        event.loader.setResponseType("blob");
      }
    };
    p._formatResult = function(loader) {
      this._tag.removeEventListener && this._tag.removeEventListener("canplaythrough", this._loadedHandler);
      this._tag.onstalled = null;
      if (this._preferXHR) {
        var URL2 = window.URL || window.webkitURL;
        var result2 = loader.getResult(true);
        loader.getTag().src = URL2.createObjectURL(result2);
      }
      return loader.getTag();
    };
    createjs2.AbstractMediaLoader = createjs2.promote(AbstractMediaLoader, "AbstractLoader");
  })();
  (function() {
    var AbstractRequest = function(item) {
      this._item = item;
    };
    var p = createjs2.extend(AbstractRequest, createjs2.EventDispatcher);
    p.load = function() {
    };
    p.destroy = function() {
    };
    p.cancel = function() {
    };
    createjs2.AbstractRequest = createjs2.promote(AbstractRequest, "EventDispatcher");
  })();
  (function() {
    function TagRequest(loadItem, tag, srcAttribute) {
      this.AbstractRequest_constructor(loadItem);
      this._tag = tag;
      this._tagSrcAttribute = srcAttribute;
      this._loadedHandler = createjs2.proxy(this._handleTagComplete, this);
      this._addedToDOM = false;
      this._startTagVisibility = null;
    }
    var p = createjs2.extend(TagRequest, createjs2.AbstractRequest);
    p.load = function() {
      this._tag.onload = createjs2.proxy(this._handleTagComplete, this);
      this._tag.onreadystatechange = createjs2.proxy(this._handleReadyStateChange, this);
      this._tag.onerror = createjs2.proxy(this._handleError, this);
      var evt = new createjs2.Event("initialize");
      evt.loader = this._tag;
      this.dispatchEvent(evt);
      this._hideTag();
      this._loadTimeout = setTimeout(createjs2.proxy(this._handleTimeout, this), this._item.loadTimeout);
      this._tag[this._tagSrcAttribute] = this._item.src;
      if (this._tag.parentNode == null) {
        window.document.body.appendChild(this._tag);
        this._addedToDOM = true;
      }
    };
    p.destroy = function() {
      this._clean();
      this._tag = null;
      this.AbstractRequest_destroy();
    };
    p._handleReadyStateChange = function() {
      clearTimeout(this._loadTimeout);
      var tag = this._tag;
      if (tag.readyState == "loaded" || tag.readyState == "complete") {
        this._handleTagComplete();
      }
    };
    p._handleError = function() {
      this._clean();
      this.dispatchEvent("error");
    };
    p._handleTagComplete = function() {
      this._rawResult = this._tag;
      this._result = this.resultFormatter && this.resultFormatter(this) || this._rawResult;
      this._clean();
      this._showTag();
      this.dispatchEvent("complete");
    };
    p._handleTimeout = function() {
      this._clean();
      this.dispatchEvent(new createjs2.Event("timeout"));
    };
    p._clean = function() {
      this._tag.onload = null;
      this._tag.onreadystatechange = null;
      this._tag.onerror = null;
      if (this._addedToDOM && this._tag.parentNode != null) {
        this._tag.parentNode.removeChild(this._tag);
      }
      clearTimeout(this._loadTimeout);
    };
    p._hideTag = function() {
      this._startTagVisibility = this._tag.style.visibility;
      this._tag.style.visibility = "hidden";
    };
    p._showTag = function() {
      this._tag.style.visibility = this._startTagVisibility;
    };
    p._handleStalled = function() {
    };
    createjs2.TagRequest = createjs2.promote(TagRequest, "AbstractRequest");
  })();
  (function() {
    function MediaTagRequest(loadItem, tag, srcAttribute) {
      this.AbstractRequest_constructor(loadItem);
      this._tag = tag;
      this._tagSrcAttribute = srcAttribute;
      this._loadedHandler = createjs2.proxy(this._handleTagComplete, this);
    }
    var p = createjs2.extend(MediaTagRequest, createjs2.TagRequest);
    p.load = function() {
      var sc = createjs2.proxy(this._handleStalled, this);
      this._stalledCallback = sc;
      var pc = createjs2.proxy(this._handleProgress, this);
      this._handleProgress = pc;
      this._tag.addEventListener("stalled", sc);
      this._tag.addEventListener("progress", pc);
      this._tag.addEventListener && this._tag.addEventListener("canplaythrough", this._loadedHandler, false);
      this.TagRequest_load();
    };
    p._handleReadyStateChange = function() {
      clearTimeout(this._loadTimeout);
      var tag = this._tag;
      if (tag.readyState == "loaded" || tag.readyState == "complete") {
        this._handleTagComplete();
      }
    };
    p._handleStalled = function() {
    };
    p._handleProgress = function(event) {
      if (!event || event.loaded > 0 && event.total == 0) {
        return;
      }
      var newEvent = new createjs2.ProgressEvent(event.loaded, event.total);
      this.dispatchEvent(newEvent);
    };
    p._clean = function() {
      this._tag.removeEventListener && this._tag.removeEventListener("canplaythrough", this._loadedHandler);
      this._tag.removeEventListener("stalled", this._stalledCallback);
      this._tag.removeEventListener("progress", this._progressCallback);
      this.TagRequest__clean();
    };
    createjs2.MediaTagRequest = createjs2.promote(MediaTagRequest, "TagRequest");
  })();
  (function() {
    function XHRRequest(item) {
      this.AbstractRequest_constructor(item);
      this._request = null;
      this._loadTimeout = null;
      this._xhrLevel = 1;
      this._response = null;
      this._rawResponse = null;
      this._canceled = false;
      this._handleLoadStartProxy = createjs2.proxy(this._handleLoadStart, this);
      this._handleProgressProxy = createjs2.proxy(this._handleProgress, this);
      this._handleAbortProxy = createjs2.proxy(this._handleAbort, this);
      this._handleErrorProxy = createjs2.proxy(this._handleError, this);
      this._handleTimeoutProxy = createjs2.proxy(this._handleTimeout, this);
      this._handleLoadProxy = createjs2.proxy(this._handleLoad, this);
      this._handleReadyStateChangeProxy = createjs2.proxy(this._handleReadyStateChange, this);
      if (!this._createXHR(item))
        ;
    }
    var p = createjs2.extend(XHRRequest, createjs2.AbstractRequest);
    XHRRequest.ACTIVEX_VERSIONS = [
      "Msxml2.XMLHTTP.6.0",
      "Msxml2.XMLHTTP.5.0",
      "Msxml2.XMLHTTP.4.0",
      "MSXML2.XMLHTTP.3.0",
      "MSXML2.XMLHTTP",
      "Microsoft.XMLHTTP"
    ];
    p.getResult = function(raw) {
      if (raw && this._rawResponse) {
        return this._rawResponse;
      }
      return this._response;
    };
    p.cancel = function() {
      this.canceled = true;
      this._clean();
      this._request.abort();
    };
    p.load = function() {
      if (this._request == null) {
        this._handleError();
        return;
      }
      if (this._request.addEventListener != null) {
        this._request.addEventListener("loadstart", this._handleLoadStartProxy, false);
        this._request.addEventListener("progress", this._handleProgressProxy, false);
        this._request.addEventListener("abort", this._handleAbortProxy, false);
        this._request.addEventListener("error", this._handleErrorProxy, false);
        this._request.addEventListener("timeout", this._handleTimeoutProxy, false);
        this._request.addEventListener("load", this._handleLoadProxy, false);
        this._request.addEventListener("readystatechange", this._handleReadyStateChangeProxy, false);
      } else {
        this._request.onloadstart = this._handleLoadStartProxy;
        this._request.onprogress = this._handleProgressProxy;
        this._request.onabort = this._handleAbortProxy;
        this._request.onerror = this._handleErrorProxy;
        this._request.ontimeout = this._handleTimeoutProxy;
        this._request.onload = this._handleLoadProxy;
        this._request.onreadystatechange = this._handleReadyStateChangeProxy;
      }
      if (this._xhrLevel == 1) {
        this._loadTimeout = setTimeout(createjs2.proxy(this._handleTimeout, this), this._item.loadTimeout);
      }
      try {
        if (!this._item.values || this._item.method == createjs2.AbstractLoader.GET) {
          this._request.send();
        } else if (this._item.method == createjs2.AbstractLoader.POST) {
          this._request.send(createjs2.RequestUtils.formatQueryString(this._item.values));
        }
      } catch (error2) {
        this.dispatchEvent(new createjs2.ErrorEvent("XHR_SEND", null, error2));
      }
    };
    p.setResponseType = function(type) {
      if (type === "blob") {
        type = window.URL ? "blob" : "arraybuffer";
        this._responseType = type;
      }
      this._request.responseType = type;
    };
    p.getAllResponseHeaders = function() {
      if (this._request.getAllResponseHeaders instanceof Function) {
        return this._request.getAllResponseHeaders();
      } else {
        return null;
      }
    };
    p.getResponseHeader = function(header) {
      if (this._request.getResponseHeader instanceof Function) {
        return this._request.getResponseHeader(header);
      } else {
        return null;
      }
    };
    p._handleProgress = function(event) {
      if (!event || event.loaded > 0 && event.total == 0) {
        return;
      }
      var newEvent = new createjs2.ProgressEvent(event.loaded, event.total);
      this.dispatchEvent(newEvent);
    };
    p._handleLoadStart = function(event) {
      clearTimeout(this._loadTimeout);
      this.dispatchEvent("loadstart");
    };
    p._handleAbort = function(event) {
      this._clean();
      this.dispatchEvent(new createjs2.ErrorEvent("XHR_ABORTED", null, event));
    };
    p._handleError = function(event) {
      this._clean();
      this.dispatchEvent(new createjs2.ErrorEvent(event.message));
    };
    p._handleReadyStateChange = function(event) {
      if (this._request.readyState == 4) {
        this._handleLoad();
      }
    };
    p._handleLoad = function(event) {
      if (this.loaded) {
        return;
      }
      this.loaded = true;
      var error2 = this._checkError();
      if (error2) {
        this._handleError(error2);
        return;
      }
      this._response = this._getResponse();
      if (this._responseType === "arraybuffer") {
        try {
          this._response = new Blob([this._response]);
        } catch (e) {
          window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
          if (e.name === "TypeError" && window.BlobBuilder) {
            var builder = new BlobBuilder();
            builder.append(this._response);
            this._response = builder.getBlob();
          }
        }
      }
      this._clean();
      this.dispatchEvent(new createjs2.Event("complete"));
    };
    p._handleTimeout = function(event) {
      this._clean();
      this.dispatchEvent(new createjs2.ErrorEvent("PRELOAD_TIMEOUT", null, event));
    };
    p._checkError = function() {
      var status = parseInt(this._request.status);
      switch (status) {
        case 404:
        case 0:
          return new Error(status);
      }
      return null;
    };
    p._getResponse = function() {
      if (this._response != null) {
        return this._response;
      }
      if (this._request.response != null) {
        return this._request.response;
      }
      try {
        if (this._request.responseText != null) {
          return this._request.responseText;
        }
      } catch (e) {
      }
      try {
        if (this._request.responseXML != null) {
          return this._request.responseXML;
        }
      } catch (e) {
      }
      return null;
    };
    p._createXHR = function(item) {
      var crossdomain = createjs2.RequestUtils.isCrossDomain(item);
      var headers = {};
      var req = null;
      if (window.XMLHttpRequest) {
        req = new XMLHttpRequest();
        if (crossdomain && req.withCredentials === void 0 && window.XDomainRequest) {
          req = new XDomainRequest();
        }
      } else {
        for (var i2 = 0, l = s.ACTIVEX_VERSIONS.length; i2 < l; i2++) {
          var axVersion = s.ACTIVEX_VERSIONS[i2];
          try {
            req = new ActiveXObject(axVersion);
            break;
          } catch (e) {
          }
        }
        if (req == null) {
          return false;
        }
      }
      if (item.mimeType == null && createjs2.RequestUtils.isText(item.type)) {
        item.mimeType = "text/plain; charset=utf-8";
      }
      if (item.mimeType && req.overrideMimeType) {
        req.overrideMimeType(item.mimeType);
      }
      this._xhrLevel = typeof req.responseType === "string" ? 2 : 1;
      var src = null;
      if (item.method == createjs2.AbstractLoader.GET) {
        src = createjs2.RequestUtils.buildPath(item.src, item.values);
      } else {
        src = item.src;
      }
      req.open(item.method || createjs2.AbstractLoader.GET, src, true);
      if (crossdomain && req instanceof XMLHttpRequest && this._xhrLevel == 1) {
        headers["Origin"] = location.origin;
      }
      if (item.values && item.method == createjs2.AbstractLoader.POST) {
        headers["Content-Type"] = "application/x-www-form-urlencoded";
      }
      if (!crossdomain && !headers["X-Requested-With"]) {
        headers["X-Requested-With"] = "XMLHttpRequest";
      }
      if (item.headers) {
        for (var n2 in item.headers) {
          headers[n2] = item.headers[n2];
        }
      }
      for (n2 in headers) {
        req.setRequestHeader(n2, headers[n2]);
      }
      if (req instanceof XMLHttpRequest && item.withCredentials !== void 0) {
        req.withCredentials = item.withCredentials;
      }
      this._request = req;
      return true;
    };
    p._clean = function() {
      clearTimeout(this._loadTimeout);
      if (this._request.removeEventListener != null) {
        this._request.removeEventListener("loadstart", this._handleLoadStartProxy);
        this._request.removeEventListener("progress", this._handleProgressProxy);
        this._request.removeEventListener("abort", this._handleAbortProxy);
        this._request.removeEventListener("error", this._handleErrorProxy);
        this._request.removeEventListener("timeout", this._handleTimeoutProxy);
        this._request.removeEventListener("load", this._handleLoadProxy);
        this._request.removeEventListener("readystatechange", this._handleReadyStateChangeProxy);
      } else {
        this._request.onloadstart = null;
        this._request.onprogress = null;
        this._request.onabort = null;
        this._request.onerror = null;
        this._request.ontimeout = null;
        this._request.onload = null;
        this._request.onreadystatechange = null;
      }
    };
    p.toString = function() {
      return "[PreloadJS XHRRequest]";
    };
    createjs2.XHRRequest = createjs2.promote(XHRRequest, "AbstractRequest");
  })();
  (function() {
    function LoadQueue(preferXHR, basePath, crossOrigin) {
      this.AbstractLoader_constructor();
      this._plugins = [];
      this._typeCallbacks = {};
      this._extensionCallbacks = {};
      this.next = null;
      this.maintainScriptOrder = true;
      this.stopOnError = false;
      this._maxConnections = 1;
      this._availableLoaders = [
        createjs2.ImageLoader,
        createjs2.JavaScriptLoader,
        createjs2.CSSLoader,
        createjs2.JSONLoader,
        createjs2.JSONPLoader,
        createjs2.SoundLoader,
        createjs2.ManifestLoader,
        createjs2.SpriteSheetLoader,
        createjs2.XMLLoader,
        createjs2.SVGLoader,
        createjs2.BinaryLoader,
        createjs2.VideoLoader,
        createjs2.TextLoader
      ];
      this._defaultLoaderLength = this._availableLoaders.length;
      this.init(preferXHR, basePath, crossOrigin);
    }
    var p = createjs2.extend(LoadQueue, createjs2.AbstractLoader);
    var s2 = LoadQueue;
    p.init = function(preferXHR, basePath, crossOrigin) {
      this.useXHR = true;
      this.preferXHR = true;
      this._preferXHR = true;
      this.setPreferXHR(preferXHR);
      this._paused = false;
      this._basePath = basePath;
      this._crossOrigin = crossOrigin;
      this._loadStartWasDispatched = false;
      this._currentlyLoadingScript = null;
      this._currentLoads = [];
      this._loadQueue = [];
      this._loadQueueBackup = [];
      this._loadItemsById = {};
      this._loadItemsBySrc = {};
      this._loadedResults = {};
      this._loadedRawResults = {};
      this._numItems = 0;
      this._numItemsLoaded = 0;
      this._scriptOrder = [];
      this._loadedScripts = [];
      this._lastProgress = NaN;
    };
    s2.loadTimeout = 8e3;
    s2.LOAD_TIMEOUT = 0;
    s2.BINARY = createjs2.AbstractLoader.BINARY;
    s2.CSS = createjs2.AbstractLoader.CSS;
    s2.IMAGE = createjs2.AbstractLoader.IMAGE;
    s2.JAVASCRIPT = createjs2.AbstractLoader.JAVASCRIPT;
    s2.JSON = createjs2.AbstractLoader.JSON;
    s2.JSONP = createjs2.AbstractLoader.JSONP;
    s2.MANIFEST = createjs2.AbstractLoader.MANIFEST;
    s2.SOUND = createjs2.AbstractLoader.SOUND;
    s2.VIDEO = createjs2.AbstractLoader.VIDEO;
    s2.SVG = createjs2.AbstractLoader.SVG;
    s2.TEXT = createjs2.AbstractLoader.TEXT;
    s2.XML = createjs2.AbstractLoader.XML;
    s2.POST = createjs2.AbstractLoader.POST;
    s2.GET = createjs2.AbstractLoader.GET;
    p.registerLoader = function(loader) {
      if (!loader || !loader.canLoadItem) {
        throw new Error("loader is of an incorrect type.");
      } else if (this._availableLoaders.indexOf(loader) != -1) {
        throw new Error("loader already exists.");
      }
      this._availableLoaders.unshift(loader);
    };
    p.unregisterLoader = function(loader) {
      var idx = this._availableLoaders.indexOf(loader);
      if (idx != -1 && idx < this._defaultLoaderLength - 1) {
        this._availableLoaders.splice(idx, 1);
      }
    };
    p.setUseXHR = function(value) {
      return this.setPreferXHR(value);
    };
    p.setPreferXHR = function(value) {
      this.preferXHR = value != false && window.XMLHttpRequest != null;
      return this.preferXHR;
    };
    p.removeAll = function() {
      this.remove();
    };
    p.remove = function(idsOrUrls) {
      var args = null;
      if (idsOrUrls && !Array.isArray(idsOrUrls)) {
        args = [idsOrUrls];
      } else if (idsOrUrls) {
        args = idsOrUrls;
      } else if (arguments.length > 0) {
        return;
      }
      var itemsWereRemoved = false;
      if (!args) {
        this.close();
        for (var n2 in this._loadItemsById) {
          this._disposeItem(this._loadItemsById[n2]);
        }
        this.init(this.preferXHR, this._basePath);
      } else {
        while (args.length) {
          var item = args.pop();
          var r = this.getResult(item);
          for (i2 = this._loadQueue.length - 1; i2 >= 0; i2--) {
            loadItem = this._loadQueue[i2].getItem();
            if (loadItem.id == item || loadItem.src == item) {
              this._loadQueue.splice(i2, 1)[0].cancel();
              break;
            }
          }
          for (i2 = this._loadQueueBackup.length - 1; i2 >= 0; i2--) {
            loadItem = this._loadQueueBackup[i2].getItem();
            if (loadItem.id == item || loadItem.src == item) {
              this._loadQueueBackup.splice(i2, 1)[0].cancel();
              break;
            }
          }
          if (r) {
            this._disposeItem(this.getItem(item));
          } else {
            for (var i2 = this._currentLoads.length - 1; i2 >= 0; i2--) {
              var loadItem = this._currentLoads[i2].getItem();
              if (loadItem.id == item || loadItem.src == item) {
                this._currentLoads.splice(i2, 1)[0].cancel();
                itemsWereRemoved = true;
                break;
              }
            }
          }
        }
        if (itemsWereRemoved) {
          this._loadNext();
        }
      }
    };
    p.reset = function() {
      this.close();
      for (var n2 in this._loadItemsById) {
        this._disposeItem(this._loadItemsById[n2]);
      }
      var a = [];
      for (var i2 = 0, l = this._loadQueueBackup.length; i2 < l; i2++) {
        a.push(this._loadQueueBackup[i2].getItem());
      }
      this.loadManifest(a, false);
    };
    p.installPlugin = function(plugin3) {
      if (plugin3 == null) {
        return;
      }
      if (plugin3.getPreloadHandlers != null) {
        this._plugins.push(plugin3);
        var map = plugin3.getPreloadHandlers();
        map.scope = plugin3;
        if (map.types != null) {
          for (var i2 = 0, l = map.types.length; i2 < l; i2++) {
            this._typeCallbacks[map.types[i2]] = map;
          }
        }
        if (map.extensions != null) {
          for (i2 = 0, l = map.extensions.length; i2 < l; i2++) {
            this._extensionCallbacks[map.extensions[i2]] = map;
          }
        }
      }
    };
    p.setMaxConnections = function(value) {
      this._maxConnections = value;
      if (!this._paused && this._loadQueue.length > 0) {
        this._loadNext();
      }
    };
    p.loadFile = function(file, loadNow, basePath) {
      if (file == null) {
        var event = new createjs2.ErrorEvent("PRELOAD_NO_FILE");
        this._sendError(event);
        return;
      }
      this._addItem(file, null, basePath);
      if (loadNow !== false) {
        this.setPaused(false);
      } else {
        this.setPaused(true);
      }
    };
    p.loadManifest = function(manifest, loadNow, basePath) {
      var fileList = null;
      var path = null;
      if (Array.isArray(manifest)) {
        if (manifest.length == 0) {
          var event = new createjs2.ErrorEvent("PRELOAD_MANIFEST_EMPTY");
          this._sendError(event);
          return;
        }
        fileList = manifest;
      } else if (typeof manifest === "string") {
        fileList = [
          {
            src: manifest,
            type: s2.MANIFEST
          }
        ];
      } else if (typeof manifest == "object") {
        if (manifest.src !== void 0) {
          if (manifest.type == null) {
            manifest.type = s2.MANIFEST;
          } else if (manifest.type != s2.MANIFEST) {
            var event = new createjs2.ErrorEvent("PRELOAD_MANIFEST_TYPE");
            this._sendError(event);
          }
          fileList = [manifest];
        } else if (manifest.manifest !== void 0) {
          fileList = manifest.manifest;
          path = manifest.path;
        }
      } else {
        var event = new createjs2.ErrorEvent("PRELOAD_MANIFEST_NULL");
        this._sendError(event);
        return;
      }
      for (var i2 = 0, l = fileList.length; i2 < l; i2++) {
        this._addItem(fileList[i2], path, basePath);
      }
      if (loadNow !== false) {
        this.setPaused(false);
      } else {
        this.setPaused(true);
      }
    };
    p.load = function() {
      this.setPaused(false);
    };
    p.getItem = function(value) {
      return this._loadItemsById[value] || this._loadItemsBySrc[value];
    };
    p.getResult = function(value, rawResult) {
      var item = this._loadItemsById[value] || this._loadItemsBySrc[value];
      if (item == null) {
        return null;
      }
      var id = item.id;
      if (rawResult && this._loadedRawResults[id]) {
        return this._loadedRawResults[id];
      }
      return this._loadedResults[id];
    };
    p.getItems = function(loaded) {
      var arr = [];
      for (var n2 in this._loadItemsById) {
        var item = this._loadItemsById[n2];
        var result2 = this.getResult(n2);
        if (loaded === true && result2 == null) {
          continue;
        }
        arr.push({
          item,
          result: result2,
          rawResult: this.getResult(n2, true)
        });
      }
      return arr;
    };
    p.setPaused = function(value) {
      this._paused = value;
      if (!this._paused) {
        this._loadNext();
      }
    };
    p.close = function() {
      while (this._currentLoads.length) {
        this._currentLoads.pop().cancel();
      }
      this._scriptOrder.length = 0;
      this._loadedScripts.length = 0;
      this.loadStartWasDispatched = false;
      this._itemCount = 0;
      this._lastProgress = NaN;
    };
    p._addItem = function(value, path, basePath) {
      var item = this._createLoadItem(value, path, basePath);
      if (item == null) {
        return;
      }
      var loader = this._createLoader(item);
      if (loader != null) {
        if ("plugins" in loader) {
          loader.plugins = this._plugins;
        }
        item._loader = loader;
        this._loadQueue.push(loader);
        this._loadQueueBackup.push(loader);
        this._numItems++;
        this._updateProgress();
        if (this.maintainScriptOrder && item.type == createjs2.LoadQueue.JAVASCRIPT || item.maintainOrder === true) {
          this._scriptOrder.push(item);
          this._loadedScripts.push(null);
        }
      }
    };
    p._createLoadItem = function(value, path, basePath) {
      var item = createjs2.LoadItem.create(value);
      if (item == null) {
        return null;
      }
      var bp = "";
      var useBasePath = basePath || this._basePath;
      if (item.src instanceof Object) {
        if (!item.type) {
          return null;
        }
        if (path) {
          bp = path;
          var pathMatch = createjs2.RequestUtils.parseURI(path);
          if (useBasePath != null && !pathMatch.absolute && !pathMatch.relative) {
            bp = useBasePath + bp;
          }
        } else if (useBasePath != null) {
          bp = useBasePath;
        }
      } else {
        var match = createjs2.RequestUtils.parseURI(item.src);
        if (match.extension) {
          item.ext = match.extension;
        }
        if (item.type == null) {
          item.type = createjs2.RequestUtils.getTypeByExtension(item.ext);
        }
        var autoId = item.src;
        if (!match.absolute && !match.relative) {
          if (path) {
            bp = path;
            var pathMatch = createjs2.RequestUtils.parseURI(path);
            autoId = path + autoId;
            if (useBasePath != null && !pathMatch.absolute && !pathMatch.relative) {
              bp = useBasePath + bp;
            }
          } else if (useBasePath != null) {
            bp = useBasePath;
          }
        }
        item.src = bp + item.src;
      }
      item.path = bp;
      if (item.id === void 0 || item.id === null || item.id === "") {
        item.id = autoId;
      }
      var customHandler = this._typeCallbacks[item.type] || this._extensionCallbacks[item.ext];
      if (customHandler) {
        var result2 = customHandler.callback.call(customHandler.scope, item, this);
        if (result2 === false) {
          return null;
        } else if (result2 === true)
          ;
        else if (result2 != null) {
          item._loader = result2;
        }
        match = createjs2.RequestUtils.parseURI(item.src);
        if (match.extension != null) {
          item.ext = match.extension;
        }
      }
      this._loadItemsById[item.id] = item;
      this._loadItemsBySrc[item.src] = item;
      if (item.crossOrigin == null) {
        item.crossOrigin = this._crossOrigin;
      }
      return item;
    };
    p._createLoader = function(item) {
      if (item._loader != null) {
        return item._loader;
      }
      var preferXHR = this.preferXHR;
      for (var i2 = 0; i2 < this._availableLoaders.length; i2++) {
        var loader = this._availableLoaders[i2];
        if (loader && loader.canLoadItem(item)) {
          return new loader(item, preferXHR);
        }
      }
      return null;
    };
    p._loadNext = function() {
      if (this._paused) {
        return;
      }
      if (!this._loadStartWasDispatched) {
        this._sendLoadStart();
        this._loadStartWasDispatched = true;
      }
      if (this._numItems == this._numItemsLoaded) {
        this.loaded = true;
        this._sendComplete();
        if (this.next && this.next.load) {
          this.next.load();
        }
      } else {
        this.loaded = false;
      }
      for (var i2 = 0; i2 < this._loadQueue.length; i2++) {
        if (this._currentLoads.length >= this._maxConnections) {
          break;
        }
        var loader = this._loadQueue[i2];
        if (!this._canStartLoad(loader)) {
          continue;
        }
        this._loadQueue.splice(i2, 1);
        i2--;
        this._loadItem(loader);
      }
    };
    p._loadItem = function(loader) {
      loader.on("fileload", this._handleFileLoad, this);
      loader.on("progress", this._handleProgress, this);
      loader.on("complete", this._handleFileComplete, this);
      loader.on("error", this._handleError, this);
      loader.on("fileerror", this._handleFileError, this);
      this._currentLoads.push(loader);
      this._sendFileStart(loader.getItem());
      loader.load();
    };
    p._handleFileLoad = function(event) {
      event.target = null;
      this.dispatchEvent(event);
    };
    p._handleFileError = function(event) {
      var newEvent = new createjs2.ErrorEvent("FILE_LOAD_ERROR", null, event.item);
      this._sendError(newEvent);
    };
    p._handleError = function(event) {
      var loader = event.target;
      this._numItemsLoaded++;
      this._finishOrderedItem(loader, true);
      this._updateProgress();
      var newEvent = new createjs2.ErrorEvent("FILE_LOAD_ERROR", null, loader.getItem());
      this._sendError(newEvent);
      if (!this.stopOnError) {
        this._removeLoadItem(loader);
        this._cleanLoadItem(loader);
        this._loadNext();
      } else {
        this.setPaused(true);
      }
    };
    p._handleFileComplete = function(event) {
      var loader = event.target;
      var item = loader.getItem();
      var result2 = loader.getResult();
      this._loadedResults[item.id] = result2;
      var rawResult = loader.getResult(true);
      if (rawResult != null && rawResult !== result2) {
        this._loadedRawResults[item.id] = rawResult;
      }
      this._saveLoadedItems(loader);
      this._removeLoadItem(loader);
      if (!this._finishOrderedItem(loader)) {
        this._processFinishedLoad(item, loader);
      }
      this._cleanLoadItem(loader);
    };
    p._saveLoadedItems = function(loader) {
      var list2 = loader.getLoadedItems();
      if (list2 === null) {
        return;
      }
      for (var i2 = 0; i2 < list2.length; i2++) {
        var item = list2[i2].item;
        this._loadItemsBySrc[item.src] = item;
        this._loadItemsById[item.id] = item;
        this._loadedResults[item.id] = list2[i2].result;
        this._loadedRawResults[item.id] = list2[i2].rawResult;
      }
    };
    p._finishOrderedItem = function(loader, loadFailed) {
      var item = loader.getItem();
      if (this.maintainScriptOrder && item.type == createjs2.LoadQueue.JAVASCRIPT || item.maintainOrder) {
        if (loader instanceof createjs2.JavaScriptLoader) {
          this._currentlyLoadingScript = false;
        }
        var index2 = createjs2.indexOf(this._scriptOrder, item);
        if (index2 == -1) {
          return false;
        }
        this._loadedScripts[index2] = loadFailed === true ? true : item;
        this._checkScriptLoadOrder();
        return true;
      }
      return false;
    };
    p._checkScriptLoadOrder = function() {
      var l = this._loadedScripts.length;
      for (var i2 = 0; i2 < l; i2++) {
        var item = this._loadedScripts[i2];
        if (item === null) {
          break;
        }
        if (item === true) {
          continue;
        }
        var loadItem = this._loadedResults[item.id];
        if (item.type == createjs2.LoadQueue.JAVASCRIPT) {
          createjs2.DomUtils.appendToHead(loadItem);
        }
        var loader = item._loader;
        this._processFinishedLoad(item, loader);
        this._loadedScripts[i2] = true;
      }
    };
    p._processFinishedLoad = function(item, loader) {
      this._numItemsLoaded++;
      if (!this.maintainScriptOrder && item.type == createjs2.LoadQueue.JAVASCRIPT) {
        var tag = loader.getTag();
        createjs2.DomUtils.appendToHead(tag);
      }
      this._updateProgress();
      this._sendFileComplete(item, loader);
      this._loadNext();
    };
    p._canStartLoad = function(loader) {
      if (!this.maintainScriptOrder || loader.preferXHR) {
        return true;
      }
      var item = loader.getItem();
      if (item.type != createjs2.LoadQueue.JAVASCRIPT) {
        return true;
      }
      if (this._currentlyLoadingScript) {
        return false;
      }
      var index2 = this._scriptOrder.indexOf(item);
      var i2 = 0;
      while (i2 < index2) {
        var checkItem = this._loadedScripts[i2];
        if (checkItem == null) {
          return false;
        }
        i2++;
      }
      this._currentlyLoadingScript = true;
      return true;
    };
    p._removeLoadItem = function(loader) {
      var l = this._currentLoads.length;
      for (var i2 = 0; i2 < l; i2++) {
        if (this._currentLoads[i2] == loader) {
          this._currentLoads.splice(i2, 1);
          break;
        }
      }
    };
    p._cleanLoadItem = function(loader) {
      var item = loader.getItem();
      if (item) {
        delete item._loader;
      }
    };
    p._handleProgress = function(event) {
      var loader = event.target;
      this._sendFileProgress(loader.getItem(), loader.progress);
      this._updateProgress();
    };
    p._updateProgress = function() {
      var loaded = this._numItemsLoaded / this._numItems;
      var remaining = this._numItems - this._numItemsLoaded;
      if (remaining > 0) {
        var chunk2 = 0;
        for (var i2 = 0, l = this._currentLoads.length; i2 < l; i2++) {
          chunk2 += this._currentLoads[i2].progress;
        }
        loaded += chunk2 / remaining * (remaining / this._numItems);
      }
      if (this._lastProgress != loaded) {
        this._sendProgress(loaded);
        this._lastProgress = loaded;
      }
    };
    p._disposeItem = function(item) {
      delete this._loadedResults[item.id];
      delete this._loadedRawResults[item.id];
      delete this._loadItemsById[item.id];
      delete this._loadItemsBySrc[item.src];
    };
    p._sendFileProgress = function(item, progress) {
      if (this._isCanceled() || this._paused) {
        return;
      }
      if (!this.hasEventListener("fileprogress")) {
        return;
      }
      var event = new createjs2.Event("fileprogress");
      event.progress = progress;
      event.loaded = progress;
      event.total = 1;
      event.item = item;
      this.dispatchEvent(event);
    };
    p._sendFileComplete = function(item, loader) {
      if (this._isCanceled() || this._paused) {
        return;
      }
      var event = new createjs2.Event("fileload");
      event.loader = loader;
      event.item = item;
      event.result = this._loadedResults[item.id];
      event.rawResult = this._loadedRawResults[item.id];
      if (item.completeHandler) {
        item.completeHandler(event);
      }
      this.hasEventListener("fileload") && this.dispatchEvent(event);
    };
    p._sendFileStart = function(item) {
      var event = new createjs2.Event("filestart");
      event.item = item;
      this.hasEventListener("filestart") && this.dispatchEvent(event);
    };
    p.toString = function() {
      return "[PreloadJS LoadQueue]";
    };
    createjs2.LoadQueue = createjs2.promote(LoadQueue, "AbstractLoader");
  })();
  (function() {
    function TextLoader(loadItem) {
      this.AbstractLoader_constructor(loadItem, true, createjs2.AbstractLoader.TEXT);
    }
    createjs2.extend(TextLoader, createjs2.AbstractLoader);
    var s2 = TextLoader;
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.TEXT;
    };
    createjs2.TextLoader = createjs2.promote(TextLoader, "AbstractLoader");
  })();
  (function() {
    function BinaryLoader(loadItem) {
      this.AbstractLoader_constructor(loadItem, true, createjs2.AbstractLoader.BINARY);
      this.on("initialize", this._updateXHR, this);
    }
    var p = createjs2.extend(BinaryLoader, createjs2.AbstractLoader);
    var s2 = BinaryLoader;
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.BINARY;
    };
    p._updateXHR = function(event) {
      event.loader.setResponseType("arraybuffer");
    };
    createjs2.BinaryLoader = createjs2.promote(BinaryLoader, "AbstractLoader");
  })();
  (function() {
    function CSSLoader(loadItem, preferXHR) {
      this.AbstractLoader_constructor(loadItem, preferXHR, createjs2.AbstractLoader.CSS);
      this.resultFormatter = this._formatResult;
      this._tagSrcAttribute = "href";
      if (preferXHR) {
        this._tag = document.createElement("style");
      } else {
        this._tag = document.createElement("link");
      }
      this._tag.rel = "stylesheet";
      this._tag.type = "text/css";
    }
    var p = createjs2.extend(CSSLoader, createjs2.AbstractLoader);
    var s2 = CSSLoader;
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.CSS;
    };
    p._formatResult = function(loader) {
      if (this._preferXHR) {
        var tag = loader.getTag();
        if (tag.styleSheet) {
          tag.styleSheet.cssText = loader.getResult(true);
        } else {
          var textNode = document.createTextNode(loader.getResult(true));
          tag.appendChild(textNode);
        }
      } else {
        tag = this._tag;
      }
      createjs2.DomUtils.appendToHead(tag);
      return tag;
    };
    createjs2.CSSLoader = createjs2.promote(CSSLoader, "AbstractLoader");
  })();
  (function() {
    function ImageLoader(loadItem, preferXHR) {
      this.AbstractLoader_constructor(loadItem, preferXHR, createjs2.AbstractLoader.IMAGE);
      this.resultFormatter = this._formatResult;
      this._tagSrcAttribute = "src";
      if (createjs2.RequestUtils.isImageTag(loadItem)) {
        this._tag = loadItem;
      } else if (createjs2.RequestUtils.isImageTag(loadItem.src)) {
        this._tag = loadItem.src;
      } else if (createjs2.RequestUtils.isImageTag(loadItem.tag)) {
        this._tag = loadItem.tag;
      }
      if (this._tag != null) {
        this._preferXHR = false;
      } else {
        this._tag = document.createElement("img");
      }
      this.on("initialize", this._updateXHR, this);
    }
    var p = createjs2.extend(ImageLoader, createjs2.AbstractLoader);
    var s2 = ImageLoader;
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.IMAGE;
    };
    p.load = function() {
      if (this._tag.src != "" && this._tag.complete) {
        this._sendComplete();
        return;
      }
      var crossOrigin = this._item.crossOrigin;
      if (crossOrigin == true) {
        crossOrigin = "Anonymous";
      }
      if (crossOrigin != null && !createjs2.RequestUtils.isLocal(this._item.src)) {
        this._tag.crossOrigin = crossOrigin;
      }
      this.AbstractLoader_load();
    };
    p._updateXHR = function(event) {
      event.loader.mimeType = "text/plain; charset=x-user-defined-binary";
      if (event.loader.setResponseType) {
        event.loader.setResponseType("blob");
      }
    };
    p._formatResult = function(loader) {
      return this._formatImage;
    };
    p._formatImage = function(successCallback, errorCallback) {
      var tag = this._tag;
      var URL2 = window.URL || window.webkitURL;
      if (!this._preferXHR)
        ;
      else if (URL2) {
        var objURL = URL2.createObjectURL(this.getResult(true));
        tag.src = objURL;
        tag.addEventListener("load", this._cleanUpURL, false);
        tag.addEventListener("error", this._cleanUpURL, false);
      } else {
        tag.src = this._item.src;
      }
      if (tag.complete) {
        successCallback(tag);
      } else {
        tag.onload = createjs2.proxy(function() {
          successCallback(this._tag);
        }, this);
        tag.onerror = createjs2.proxy(function() {
          errorCallback(_this._tag);
        }, this);
      }
    };
    p._cleanUpURL = function(event) {
      var URL2 = window.URL || window.webkitURL;
      URL2.revokeObjectURL(event.target.src);
    };
    createjs2.ImageLoader = createjs2.promote(ImageLoader, "AbstractLoader");
  })();
  (function() {
    function JavaScriptLoader(loadItem, preferXHR) {
      this.AbstractLoader_constructor(loadItem, preferXHR, createjs2.AbstractLoader.JAVASCRIPT);
      this.resultFormatter = this._formatResult;
      this._tagSrcAttribute = "src";
      this.setTag(document.createElement("script"));
    }
    var p = createjs2.extend(JavaScriptLoader, createjs2.AbstractLoader);
    var s2 = JavaScriptLoader;
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.JAVASCRIPT;
    };
    p._formatResult = function(loader) {
      var tag = loader.getTag();
      if (this._preferXHR) {
        tag.text = loader.getResult(true);
      }
      return tag;
    };
    createjs2.JavaScriptLoader = createjs2.promote(JavaScriptLoader, "AbstractLoader");
  })();
  (function() {
    function JSONLoader(loadItem) {
      this.AbstractLoader_constructor(loadItem, true, createjs2.AbstractLoader.JSON);
      this.resultFormatter = this._formatResult;
    }
    var p = createjs2.extend(JSONLoader, createjs2.AbstractLoader);
    var s2 = JSONLoader;
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.JSON;
    };
    p._formatResult = function(loader) {
      var json = null;
      try {
        json = createjs2.DataUtils.parseJSON(loader.getResult(true));
      } catch (e) {
        var event = new createjs2.ErrorEvent("JSON_FORMAT", null, e);
        this._sendError(event);
        return e;
      }
      return json;
    };
    createjs2.JSONLoader = createjs2.promote(JSONLoader, "AbstractLoader");
  })();
  (function() {
    function JSONPLoader(loadItem) {
      this.AbstractLoader_constructor(loadItem, false, createjs2.AbstractLoader.JSONP);
      this.setTag(document.createElement("script"));
      this.getTag().type = "text/javascript";
    }
    var p = createjs2.extend(JSONPLoader, createjs2.AbstractLoader);
    var s2 = JSONPLoader;
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.JSONP;
    };
    p.cancel = function() {
      this.AbstractLoader_cancel();
      this._dispose();
    };
    p.load = function() {
      if (this._item.callback == null) {
        throw new Error("callback is required for loading JSONP requests.");
      }
      if (window[this._item.callback] != null) {
        throw new Error(
          "JSONP callback '" + this._item.callback + "' already exists on window. You need to specify a different callback or re-name the current one."
        );
      }
      window[this._item.callback] = createjs2.proxy(this._handleLoad, this);
      window.document.body.appendChild(this._tag);
      this._loadTimeout = setTimeout(createjs2.proxy(this._handleTimeout, this), this._item.loadTimeout);
      this._tag.src = this._item.src;
    };
    p._handleLoad = function(data) {
      this._result = this._rawResult = data;
      this._sendComplete();
      this._dispose();
    };
    p._handleTimeout = function() {
      this._dispose();
      this.dispatchEvent(new createjs2.ErrorEvent("timeout"));
    };
    p._dispose = function() {
      window.document.body.removeChild(this._tag);
      delete window[this._item.callback];
      clearTimeout(this._loadTimeout);
    };
    createjs2.JSONPLoader = createjs2.promote(JSONPLoader, "AbstractLoader");
  })();
  (function() {
    function ManifestLoader(loadItem) {
      this.AbstractLoader_constructor(loadItem, null, createjs2.AbstractLoader.MANIFEST);
      this.plugins = null;
      this._manifestQueue = null;
    }
    var p = createjs2.extend(ManifestLoader, createjs2.AbstractLoader);
    var s2 = ManifestLoader;
    s2.MANIFEST_PROGRESS = 0.25;
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.MANIFEST;
    };
    p.load = function() {
      this.AbstractLoader_load();
    };
    p._createRequest = function() {
      var callback = this._item.callback;
      if (callback != null) {
        this._request = new createjs2.JSONPLoader(this._item);
      } else {
        this._request = new createjs2.JSONLoader(this._item);
      }
    };
    p.handleEvent = function(event) {
      switch (event.type) {
        case "complete":
          this._rawResult = event.target.getResult(true);
          this._result = event.target.getResult();
          this._sendProgress(s2.MANIFEST_PROGRESS);
          this._loadManifest(this._result);
          return;
        case "progress":
          event.loaded *= s2.MANIFEST_PROGRESS;
          this.progress = event.loaded / event.total;
          if (isNaN(this.progress) || this.progress == Infinity) {
            this.progress = 0;
          }
          this._sendProgress(event);
          return;
      }
      this.AbstractLoader_handleEvent(event);
    };
    p.destroy = function() {
      this.AbstractLoader_destroy();
      this._manifestQueue.close();
    };
    p._loadManifest = function(json) {
      if (json && json.manifest) {
        var queue2 = this._manifestQueue = new createjs2.LoadQueue();
        queue2.on("fileload", this._handleManifestFileLoad, this);
        queue2.on("progress", this._handleManifestProgress, this);
        queue2.on("complete", this._handleManifestComplete, this, true);
        queue2.on("error", this._handleManifestError, this, true);
        for (var i2 = 0, l = this.plugins.length; i2 < l; i2++) {
          queue2.installPlugin(this.plugins[i2]);
        }
        queue2.loadManifest(json);
      } else {
        this._sendComplete();
      }
    };
    p._handleManifestFileLoad = function(event) {
      event.target = null;
      this.dispatchEvent(event);
    };
    p._handleManifestComplete = function(event) {
      this._loadedItems = this._manifestQueue.getItems(true);
      this._sendComplete();
    };
    p._handleManifestProgress = function(event) {
      this.progress = event.progress * (1 - s2.MANIFEST_PROGRESS) + s2.MANIFEST_PROGRESS;
      this._sendProgress(this.progress);
    };
    p._handleManifestError = function(event) {
      var newEvent = new createjs2.Event("fileerror");
      newEvent.item = event.data;
      this.dispatchEvent(newEvent);
    };
    createjs2.ManifestLoader = createjs2.promote(ManifestLoader, "AbstractLoader");
  })();
  (function() {
    function SoundLoader(loadItem, preferXHR) {
      this.AbstractMediaLoader_constructor(loadItem, preferXHR, createjs2.AbstractLoader.SOUND);
      if (createjs2.RequestUtils.isAudioTag(loadItem)) {
        this._tag = loadItem;
      } else if (createjs2.RequestUtils.isAudioTag(loadItem.src)) {
        this._tag = loadItem;
      } else if (createjs2.RequestUtils.isAudioTag(loadItem.tag)) {
        this._tag = createjs2.RequestUtils.isAudioTag(loadItem) ? loadItem : loadItem.src;
      }
      if (this._tag != null) {
        this._preferXHR = false;
      }
    }
    var p = createjs2.extend(SoundLoader, createjs2.AbstractMediaLoader);
    var s2 = SoundLoader;
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.SOUND;
    };
    p._createTag = function(src) {
      var tag = document.createElement("audio");
      tag.autoplay = false;
      tag.preload = "none";
      tag.src = src;
      return tag;
    };
    createjs2.SoundLoader = createjs2.promote(SoundLoader, "AbstractMediaLoader");
  })();
  (function() {
    function VideoLoader(loadItem, preferXHR) {
      this.AbstractMediaLoader_constructor(loadItem, preferXHR, createjs2.AbstractLoader.VIDEO);
      if (createjs2.RequestUtils.isVideoTag(loadItem) || createjs2.RequestUtils.isVideoTag(loadItem.src)) {
        this.setTag(createjs2.RequestUtils.isVideoTag(loadItem) ? loadItem : loadItem.src);
        this._preferXHR = false;
      } else {
        this.setTag(this._createTag());
      }
    }
    var p = createjs2.extend(VideoLoader, createjs2.AbstractMediaLoader);
    var s2 = VideoLoader;
    p._createTag = function() {
      return document.createElement("video");
    };
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.VIDEO;
    };
    createjs2.VideoLoader = createjs2.promote(VideoLoader, "AbstractMediaLoader");
  })();
  (function() {
    function SpriteSheetLoader(loadItem, preferXHR) {
      this.AbstractLoader_constructor(loadItem, preferXHR, createjs2.AbstractLoader.SPRITESHEET);
      this._manifestQueue = null;
    }
    var p = createjs2.extend(SpriteSheetLoader, createjs2.AbstractLoader);
    var s2 = SpriteSheetLoader;
    s2.SPRITESHEET_PROGRESS = 0.25;
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.SPRITESHEET;
    };
    p.destroy = function() {
      this.AbstractLoader_destroy;
      this._manifestQueue.close();
    };
    p._createRequest = function() {
      var callback = this._item.callback;
      if (callback != null) {
        this._request = new createjs2.JSONPLoader(this._item);
      } else {
        this._request = new createjs2.JSONLoader(this._item);
      }
    };
    p.handleEvent = function(event) {
      switch (event.type) {
        case "complete":
          this._rawResult = event.target.getResult(true);
          this._result = event.target.getResult();
          this._sendProgress(s2.SPRITESHEET_PROGRESS);
          this._loadManifest(this._result);
          return;
        case "progress":
          event.loaded *= s2.SPRITESHEET_PROGRESS;
          this.progress = event.loaded / event.total;
          if (isNaN(this.progress) || this.progress == Infinity) {
            this.progress = 0;
          }
          this._sendProgress(event);
          return;
      }
      this.AbstractLoader_handleEvent(event);
    };
    p._loadManifest = function(json) {
      if (json && json.images) {
        var queue2 = this._manifestQueue = new createjs2.LoadQueue(this._preferXHR, this._item.path, this._item.crossOrigin);
        queue2.on("complete", this._handleManifestComplete, this, true);
        queue2.on("fileload", this._handleManifestFileLoad, this);
        queue2.on("progress", this._handleManifestProgress, this);
        queue2.on("error", this._handleManifestError, this, true);
        queue2.loadManifest(json.images);
      }
    };
    p._handleManifestFileLoad = function(event) {
      var image = event.result;
      if (image != null) {
        var images = this.getResult().images;
        var pos = images.indexOf(event.item.src);
        images[pos] = image;
      }
    };
    p._handleManifestComplete = function(event) {
      this._result = new createjs2.SpriteSheet(this._result);
      this._loadedItems = this._manifestQueue.getItems(true);
      this._sendComplete();
    };
    p._handleManifestProgress = function(event) {
      this.progress = event.progress * (1 - s2.SPRITESHEET_PROGRESS) + s2.SPRITESHEET_PROGRESS;
      this._sendProgress(this.progress);
    };
    p._handleManifestError = function(event) {
      var newEvent = new createjs2.Event("fileerror");
      newEvent.item = event.data;
      this.dispatchEvent(newEvent);
    };
    createjs2.SpriteSheetLoader = createjs2.promote(SpriteSheetLoader, "AbstractLoader");
  })();
  (function() {
    function SVGLoader(loadItem, preferXHR) {
      this.AbstractLoader_constructor(loadItem, preferXHR, createjs2.AbstractLoader.SVG);
      this.resultFormatter = this._formatResult;
      this._tagSrcAttribute = "data";
      if (preferXHR) {
        this.setTag(document.createElement("svg"));
      } else {
        this.setTag(document.createElement("object"));
        this.getTag().type = "image/svg+xml";
      }
    }
    var p = createjs2.extend(SVGLoader, createjs2.AbstractLoader);
    var s2 = SVGLoader;
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.SVG;
    };
    p._formatResult = function(loader) {
      var xml = createjs2.DataUtils.parseXML(loader.getResult(true), "text/xml");
      var tag = loader.getTag();
      if (!this._preferXHR && document.body.contains(tag)) {
        document.body.removeChild(tag);
      }
      if (xml.documentElement != null) {
        tag.appendChild(xml.documentElement);
        tag.style.visibility = "visible";
        return tag;
      } else {
        return xml;
      }
    };
    createjs2.SVGLoader = createjs2.promote(SVGLoader, "AbstractLoader");
  })();
  (function() {
    function XMLLoader(loadItem) {
      this.AbstractLoader_constructor(loadItem, true, createjs2.AbstractLoader.XML);
      this.resultFormatter = this._formatResult;
    }
    var p = createjs2.extend(XMLLoader, createjs2.AbstractLoader);
    var s2 = XMLLoader;
    s2.canLoadItem = function(item) {
      return item.type == createjs2.AbstractLoader.XML;
    };
    p._formatResult = function(loader) {
      return createjs2.DataUtils.parseXML(loader.getResult(true), "text/xml");
    };
    createjs2.XMLLoader = createjs2.promote(XMLLoader, "AbstractLoader");
  })();
  (function() {
    var s2 = createjs2.SoundJS = createjs2.SoundJS || {};
    s2.version = /*=version*/
    "0.6.2";
    s2.buildDate = /*=date*/
    "Thu, 26 Nov 2015 20:44:31 GMT";
  })();
  createjs2.indexOf = function(array, searchElement) {
    for (var i2 = 0, l = array.length; i2 < l; i2++) {
      if (searchElement === array[i2]) {
        return i2;
      }
    }
    return -1;
  };
  (function() {
    createjs2.proxy = function(method, scope) {
      var aArgs = Array.prototype.slice.call(arguments, 2);
      return function() {
        return method.apply(scope, Array.prototype.slice.call(arguments, 0).concat(aArgs));
      };
    };
  })();
  (function() {
    function BrowserDetect() {
      throw "BrowserDetect cannot be instantiated";
    }
    var agent = BrowserDetect.agent = window.navigator.userAgent;
    BrowserDetect.isWindowPhone = agent.indexOf("IEMobile") > -1 || agent.indexOf("Windows Phone") > -1;
    BrowserDetect.isFirefox = agent.indexOf("Firefox") > -1;
    BrowserDetect.isOpera = window.opera != null;
    BrowserDetect.isChrome = agent.indexOf("Chrome") > -1;
    BrowserDetect.isIOS = (agent.indexOf("iPod") > -1 || agent.indexOf("iPhone") > -1 || agent.indexOf("iPad") > -1) && !BrowserDetect.isWindowPhone;
    BrowserDetect.isAndroid = agent.indexOf("Android") > -1 && !BrowserDetect.isWindowPhone;
    BrowserDetect.isBlackberry = agent.indexOf("Blackberry") > -1;
    createjs2.BrowserDetect = BrowserDetect;
  })();
  (function() {
    var PlayPropsConfig = function() {
      this.interrupt = null;
      this.delay = null;
      this.offset = null;
      this.loop = null;
      this.volume = null;
      this.pan = null;
      this.startTime = null;
      this.duration = null;
    };
    var p = PlayPropsConfig.prototype = {};
    var s2 = PlayPropsConfig;
    s2.create = function(value) {
      if (value instanceof s2 || value instanceof Object) {
        var ppc = new createjs2.PlayPropsConfig();
        ppc.set(value);
        return ppc;
      } else {
        throw new Error("Type not recognized.");
      }
    };
    p.set = function(props2) {
      for (var n2 in props2) {
        this[n2] = props2[n2];
      }
      return this;
    };
    p.toString = function() {
      return "[PlayPropsConfig]";
    };
    createjs2.PlayPropsConfig = s2;
  })();
  (function() {
    function Sound() {
      throw "Sound cannot be instantiated";
    }
    var s2 = Sound;
    s2.INTERRUPT_ANY = "any";
    s2.INTERRUPT_EARLY = "early";
    s2.INTERRUPT_LATE = "late";
    s2.INTERRUPT_NONE = "none";
    s2.PLAY_INITED = "playInited";
    s2.PLAY_SUCCEEDED = "playSucceeded";
    s2.PLAY_INTERRUPTED = "playInterrupted";
    s2.PLAY_FINISHED = "playFinished";
    s2.PLAY_FAILED = "playFailed";
    s2.SUPPORTED_EXTENSIONS = ["mp3", "ogg", "opus", "mpeg", "wav", "m4a", "mp4", "aiff", "wma", "mid"];
    s2.EXTENSION_MAP = {
      m4a: "mp4"
    };
    s2.FILE_PATTERN = /^(?:(\w+:)\/{2}(\w+(?:\.\w+)*\/?))?([/.]*?(?:[^?]+)?\/)?((?:[^/?]+)\.(\w+))(?:\?(\S+)?)?$/;
    s2.defaultInterruptBehavior = s2.INTERRUPT_NONE;
    s2.alternateExtensions = [];
    s2.activePlugin = null;
    s2._masterVolume = 1;
    Object.defineProperty(s2, "volume", {
      get: function() {
        return this._masterVolume;
      },
      set: function(value) {
        if (Number(value) == null) {
          return false;
        }
        value = Math.max(0, Math.min(1, value));
        s2._masterVolume = value;
        if (!this.activePlugin || !this.activePlugin.setVolume || !this.activePlugin.setVolume(value)) {
          var instances = this._instances;
          for (var i2 = 0, l = instances.length; i2 < l; i2++) {
            instances[i2].setMasterVolume(value);
          }
        }
      }
    });
    s2._masterMute = false;
    Object.defineProperty(s2, "muted", {
      get: function() {
        return this._masterMute;
      },
      set: function(value) {
        if (value == null) {
          return false;
        }
        this._masterMute = value;
        if (!this.activePlugin || !this.activePlugin.setMute || !this.activePlugin.setMute(value)) {
          var instances = this._instances;
          for (var i2 = 0, l = instances.length; i2 < l; i2++) {
            instances[i2].setMasterMute(value);
          }
        }
        return true;
      }
    });
    Object.defineProperty(s2, "capabilities", {
      get: function() {
        if (s2.activePlugin == null) {
          return null;
        }
        return s2.activePlugin._capabilities;
      },
      set: function(value) {
        return false;
      }
    });
    s2._pluginsRegistered = false;
    s2._lastID = 0;
    s2._instances = [];
    s2._idHash = {};
    s2._preloadHash = {};
    s2._defaultPlayPropsHash = {};
    s2.addEventListener = null;
    s2.removeEventListener = null;
    s2.removeAllEventListeners = null;
    s2.dispatchEvent = null;
    s2.hasEventListener = null;
    s2._listeners = null;
    createjs2.EventDispatcher.initialize(s2);
    s2.getPreloadHandlers = function() {
      return {
        callback: createjs2.proxy(s2.initLoad, s2),
        types: ["sound"],
        extensions: s2.SUPPORTED_EXTENSIONS
      };
    };
    s2._handleLoadComplete = function(event) {
      var src = event.target.getItem().src;
      if (!s2._preloadHash[src]) {
        return;
      }
      for (var i2 = 0, l = s2._preloadHash[src].length; i2 < l; i2++) {
        var item = s2._preloadHash[src][i2];
        s2._preloadHash[src][i2] = true;
        if (!s2.hasEventListener("fileload")) {
          continue;
        }
        var event = new createjs2.Event("fileload");
        event.src = item.src;
        event.id = item.id;
        event.data = item.data;
        event.sprite = item.sprite;
        s2.dispatchEvent(event);
      }
    };
    s2._handleLoadError = function(event) {
      var src = event.target.getItem().src;
      if (!s2._preloadHash[src]) {
        return;
      }
      for (var i2 = 0, l = s2._preloadHash[src].length; i2 < l; i2++) {
        var item = s2._preloadHash[src][i2];
        s2._preloadHash[src][i2] = false;
        if (!s2.hasEventListener("fileerror")) {
          continue;
        }
        var event = new createjs2.Event("fileerror");
        event.src = item.src;
        event.id = item.id;
        event.data = item.data;
        event.sprite = item.sprite;
        s2.dispatchEvent(event);
      }
    };
    s2._registerPlugin = function(plugin3) {
      if (plugin3.isSupported()) {
        s2.activePlugin = new plugin3();
        return true;
      }
      return false;
    };
    s2.registerPlugins = function(plugins2) {
      s2._pluginsRegistered = true;
      for (var i2 = 0, l = plugins2.length; i2 < l; i2++) {
        if (s2._registerPlugin(plugins2[i2])) {
          return true;
        }
      }
      return false;
    };
    s2.initializeDefaultPlugins = function() {
      if (s2.activePlugin != null) {
        return true;
      }
      if (s2._pluginsRegistered) {
        return false;
      }
      if (s2.registerPlugins([createjs2.WebAudioPlugin, createjs2.HTMLAudioPlugin])) {
        return true;
      }
      return false;
    };
    s2.isReady = function() {
      return s2.activePlugin != null;
    };
    s2.getCapabilities = function() {
      if (s2.activePlugin == null) {
        return null;
      }
      return s2.activePlugin._capabilities;
    };
    s2.getCapability = function(key) {
      if (s2.activePlugin == null) {
        return null;
      }
      return s2.activePlugin._capabilities[key];
    };
    s2.initLoad = function(loadItem) {
      return s2._registerSound(loadItem);
    };
    s2._registerSound = function(loadItem) {
      if (!s2.initializeDefaultPlugins()) {
        return false;
      }
      var details;
      if (loadItem.src instanceof Object) {
        details = s2._parseSrc(loadItem.src);
        details.src = loadItem.path + details.src;
      } else {
        details = s2._parsePath(loadItem.src);
      }
      if (details == null) {
        return false;
      }
      loadItem.src = details.src;
      loadItem.type = "sound";
      var data = loadItem.data;
      var numChannels = null;
      if (data != null) {
        if (!isNaN(data.channels)) {
          numChannels = parseInt(data.channels);
        } else if (!isNaN(data)) {
          numChannels = parseInt(data);
        }
        if (data.audioSprite) {
          var sp;
          for (var i2 = data.audioSprite.length; i2--; ) {
            sp = data.audioSprite[i2];
            s2._idHash[sp.id] = { src: loadItem.src, startTime: parseInt(sp.startTime), duration: parseInt(sp.duration) };
            if (sp.defaultPlayProps) {
              s2._defaultPlayPropsHash[sp.id] = createjs2.PlayPropsConfig.create(sp.defaultPlayProps);
            }
          }
        }
      }
      if (loadItem.id != null) {
        s2._idHash[loadItem.id] = { src: loadItem.src };
      }
      var loader = s2.activePlugin.register(loadItem);
      SoundChannel.create(loadItem.src, numChannels);
      if (data == null || !isNaN(data)) {
        loadItem.data = numChannels || SoundChannel.maxPerChannel();
      } else {
        loadItem.data.channels = numChannels || SoundChannel.maxPerChannel();
      }
      if (loader.type) {
        loadItem.type = loader.type;
      }
      if (loadItem.defaultPlayProps) {
        s2._defaultPlayPropsHash[loadItem.src] = createjs2.PlayPropsConfig.create(loadItem.defaultPlayProps);
      }
      return loader;
    };
    s2.registerSound = function(src, id, data, basePath, defaultPlayProps) {
      var loadItem = { src, id, data, defaultPlayProps };
      if (src instanceof Object && src.src) {
        basePath = id;
        loadItem = src;
      }
      loadItem = createjs2.LoadItem.create(loadItem);
      loadItem.path = basePath;
      if (basePath != null && !(loadItem.src instanceof Object)) {
        loadItem.src = basePath + src;
      }
      var loader = s2._registerSound(loadItem);
      if (!loader) {
        return false;
      }
      if (!s2._preloadHash[loadItem.src]) {
        s2._preloadHash[loadItem.src] = [];
      }
      s2._preloadHash[loadItem.src].push(loadItem);
      if (s2._preloadHash[loadItem.src].length == 1) {
        loader.on("complete", createjs2.proxy(this._handleLoadComplete, this));
        loader.on("error", createjs2.proxy(this._handleLoadError, this));
        s2.activePlugin.preload(loader);
      } else {
        if (s2._preloadHash[loadItem.src][0] == true) {
          return true;
        }
      }
      return loadItem;
    };
    s2.registerSounds = function(sounds, basePath) {
      var returnValues = [];
      if (sounds.path) {
        if (!basePath) {
          basePath = sounds.path;
        } else {
          basePath = basePath + sounds.path;
        }
        sounds = sounds.manifest;
      }
      for (var i2 = 0, l = sounds.length; i2 < l; i2++) {
        returnValues[i2] = createjs2.Sound.registerSound(sounds[i2].src, sounds[i2].id, sounds[i2].data, basePath, sounds[i2].defaultPlayProps);
      }
      return returnValues;
    };
    s2.removeSound = function(src, basePath) {
      if (s2.activePlugin == null) {
        return false;
      }
      if (src instanceof Object && src.src) {
        src = src.src;
      }
      var details;
      if (src instanceof Object) {
        details = s2._parseSrc(src);
      } else {
        src = s2._getSrcById(src).src;
        details = s2._parsePath(src);
      }
      if (details == null) {
        return false;
      }
      src = details.src;
      if (basePath != null) {
        src = basePath + src;
      }
      for (var prop in s2._idHash) {
        if (s2._idHash[prop].src == src) {
          delete s2._idHash[prop];
        }
      }
      SoundChannel.removeSrc(src);
      delete s2._preloadHash[src];
      s2.activePlugin.removeSound(src);
      return true;
    };
    s2.removeSounds = function(sounds, basePath) {
      var returnValues = [];
      if (sounds.path) {
        if (!basePath) {
          basePath = sounds.path;
        } else {
          basePath = basePath + sounds.path;
        }
        sounds = sounds.manifest;
      }
      for (var i2 = 0, l = sounds.length; i2 < l; i2++) {
        returnValues[i2] = createjs2.Sound.removeSound(sounds[i2].src, basePath);
      }
      return returnValues;
    };
    s2.removeAllSounds = function() {
      s2._idHash = {};
      s2._preloadHash = {};
      SoundChannel.removeAll();
      if (s2.activePlugin) {
        s2.activePlugin.removeAllSounds();
      }
    };
    s2.loadComplete = function(src) {
      if (!s2.isReady()) {
        return false;
      }
      var details = s2._parsePath(src);
      if (details) {
        src = s2._getSrcById(details.src).src;
      } else {
        src = s2._getSrcById(src).src;
      }
      if (s2._preloadHash[src] == void 0) {
        return false;
      }
      return s2._preloadHash[src][0] == true;
    };
    s2._parsePath = function(value) {
      if (typeof value != "string") {
        value = value.toString();
      }
      var match = value.match(s2.FILE_PATTERN);
      if (match == null) {
        return false;
      }
      var name = match[4];
      var ext = match[5];
      var c = s2.capabilities;
      var i2 = 0;
      while (!c[ext]) {
        ext = s2.alternateExtensions[i2++];
        if (i2 > s2.alternateExtensions.length) {
          return null;
        }
      }
      value = value.replace("." + match[5], "." + ext);
      var ret = { name, src: value, extension: ext };
      return ret;
    };
    s2._parseSrc = function(value) {
      var ret = { name: void 0, src: void 0, extension: void 0 };
      var c = s2.capabilities;
      for (var prop in value) {
        if (value.hasOwnProperty(prop) && c[prop]) {
          ret.src = value[prop];
          ret.extension = prop;
          break;
        }
      }
      if (!ret.src) {
        return false;
      }
      var i2 = ret.src.lastIndexOf("/");
      if (i2 != -1) {
        ret.name = ret.src.slice(i2 + 1);
      } else {
        ret.name = ret.src;
      }
      return ret;
    };
    s2.play = function(src, interrupt, delay, offset2, loop, volume, pan, startTime, duration) {
      var playProps;
      if (interrupt instanceof Object || interrupt instanceof createjs2.PlayPropsConfig) {
        playProps = createjs2.PlayPropsConfig.create(interrupt);
      } else {
        playProps = createjs2.PlayPropsConfig.create({ interrupt, delay, offset: offset2, loop, volume, pan, startTime, duration });
      }
      var instance = s2.createInstance(src, playProps.startTime, playProps.duration);
      var ok = s2._playInstance(instance, playProps);
      if (!ok) {
        instance._playFailed();
      }
      return instance;
    };
    s2.createInstance = function(src, startTime, duration) {
      if (!s2.initializeDefaultPlugins()) {
        return new createjs2.DefaultSoundInstance(src, startTime, duration);
      }
      var defaultPlayProps = s2._defaultPlayPropsHash[src];
      src = s2._getSrcById(src);
      var details = s2._parsePath(src.src);
      var instance = null;
      if (details != null && details.src != null) {
        SoundChannel.create(details.src);
        if (startTime == null) {
          startTime = src.startTime;
        }
        instance = s2.activePlugin.create(details.src, startTime, duration || src.duration);
        defaultPlayProps = defaultPlayProps || s2._defaultPlayPropsHash[details.src];
        if (defaultPlayProps) {
          instance.applyPlayProps(defaultPlayProps);
        }
      } else {
        instance = new createjs2.DefaultSoundInstance(src, startTime, duration);
      }
      instance.uniqueId = s2._lastID++;
      return instance;
    };
    s2.stop = function() {
      var instances = this._instances;
      for (var i2 = instances.length; i2--; ) {
        instances[i2].stop();
      }
    };
    s2.setVolume = function(value) {
      if (Number(value) == null) {
        return false;
      }
      value = Math.max(0, Math.min(1, value));
      s2._masterVolume = value;
      if (!this.activePlugin || !this.activePlugin.setVolume || !this.activePlugin.setVolume(value)) {
        var instances = this._instances;
        for (var i2 = 0, l = instances.length; i2 < l; i2++) {
          instances[i2].setMasterVolume(value);
        }
      }
    };
    s2.getVolume = function() {
      return this._masterVolume;
    };
    s2.setMute = function(value) {
      if (value == null) {
        return false;
      }
      this._masterMute = value;
      if (!this.activePlugin || !this.activePlugin.setMute || !this.activePlugin.setMute(value)) {
        var instances = this._instances;
        for (var i2 = 0, l = instances.length; i2 < l; i2++) {
          instances[i2].setMasterMute(value);
        }
      }
      return true;
    };
    s2.getMute = function() {
      return this._masterMute;
    };
    s2.setDefaultPlayProps = function(src, playProps) {
      src = s2._getSrcById(src);
      s2._defaultPlayPropsHash[s2._parsePath(src.src).src] = createjs2.PlayPropsConfig.create(playProps);
    };
    s2.getDefaultPlayProps = function(src) {
      src = s2._getSrcById(src);
      return s2._defaultPlayPropsHash[s2._parsePath(src.src).src];
    };
    s2._playInstance = function(instance, playProps) {
      var defaultPlayProps = s2._defaultPlayPropsHash[instance.src] || {};
      if (playProps.interrupt == null) {
        playProps.interrupt = defaultPlayProps.interrupt || s2.defaultInterruptBehavior;
      }
      if (playProps.delay == null) {
        playProps.delay = defaultPlayProps.delay || 0;
      }
      if (playProps.offset == null) {
        playProps.offset = instance.getPosition();
      }
      if (playProps.loop == null) {
        playProps.loop = instance.loop;
      }
      if (playProps.volume == null) {
        playProps.volume = instance.volume;
      }
      if (playProps.pan == null) {
        playProps.pan = instance.pan;
      }
      if (playProps.delay == 0) {
        var ok = s2._beginPlaying(instance, playProps);
        if (!ok) {
          return false;
        }
      } else {
        var delayTimeoutId = setTimeout(function() {
          s2._beginPlaying(instance, playProps);
        }, playProps.delay);
        instance.delayTimeoutId = delayTimeoutId;
      }
      this._instances.push(instance);
      return true;
    };
    s2._beginPlaying = function(instance, playProps) {
      if (!SoundChannel.add(instance, playProps.interrupt)) {
        return false;
      }
      var result2 = instance._beginPlaying(playProps);
      if (!result2) {
        var index2 = createjs2.indexOf(this._instances, instance);
        if (index2 > -1) {
          this._instances.splice(index2, 1);
        }
        return false;
      }
      return true;
    };
    s2._getSrcById = function(value) {
      return s2._idHash[value] || { src: value };
    };
    s2._playFinished = function(instance) {
      SoundChannel.remove(instance);
      var index2 = createjs2.indexOf(this._instances, instance);
      if (index2 > -1) {
        this._instances.splice(index2, 1);
      }
    };
    createjs2.Sound = Sound;
    function SoundChannel(src, max2) {
      this.init(src, max2);
    }
    SoundChannel.channels = {};
    SoundChannel.create = function(src, max2) {
      var channel = SoundChannel.get(src);
      if (channel == null) {
        SoundChannel.channels[src] = new SoundChannel(src, max2);
        return true;
      }
      return false;
    };
    SoundChannel.removeSrc = function(src) {
      var channel = SoundChannel.get(src);
      if (channel == null) {
        return false;
      }
      channel._removeAll();
      delete SoundChannel.channels[src];
      return true;
    };
    SoundChannel.removeAll = function() {
      for (var channel in SoundChannel.channels) {
        SoundChannel.channels[channel]._removeAll();
      }
      SoundChannel.channels = {};
    };
    SoundChannel.add = function(instance, interrupt) {
      var channel = SoundChannel.get(instance.src);
      if (channel == null) {
        return false;
      }
      return channel._add(instance, interrupt);
    };
    SoundChannel.remove = function(instance) {
      var channel = SoundChannel.get(instance.src);
      if (channel == null) {
        return false;
      }
      channel._remove(instance);
      return true;
    };
    SoundChannel.maxPerChannel = function() {
      return p.maxDefault;
    };
    SoundChannel.get = function(src) {
      return SoundChannel.channels[src];
    };
    var p = SoundChannel.prototype;
    p.constructor = SoundChannel;
    p.src = null;
    p.max = null;
    p.maxDefault = 100;
    p.length = 0;
    p.init = function(src, max2) {
      this.src = src;
      this.max = max2 || this.maxDefault;
      if (this.max == -1) {
        this.max = this.maxDefault;
      }
      this._instances = [];
    };
    p._get = function(index2) {
      return this._instances[index2];
    };
    p._add = function(instance, interrupt) {
      if (!this._getSlot(interrupt, instance)) {
        return false;
      }
      this._instances.push(instance);
      this.length++;
      return true;
    };
    p._remove = function(instance) {
      var index2 = createjs2.indexOf(this._instances, instance);
      if (index2 == -1) {
        return false;
      }
      this._instances.splice(index2, 1);
      this.length--;
      return true;
    };
    p._removeAll = function() {
      for (var i2 = this.length - 1; i2 >= 0; i2--) {
        this._instances[i2].stop();
      }
    };
    p._getSlot = function(interrupt, instance) {
      var target2, replacement;
      if (interrupt != Sound.INTERRUPT_NONE) {
        replacement = this._get(0);
        if (replacement == null) {
          return true;
        }
      }
      for (var i2 = 0, l = this.max; i2 < l; i2++) {
        target2 = this._get(i2);
        if (target2 == null) {
          return true;
        }
        if (target2.playState == Sound.PLAY_FINISHED || target2.playState == Sound.PLAY_INTERRUPTED || target2.playState == Sound.PLAY_FAILED) {
          replacement = target2;
          break;
        }
        if (interrupt == Sound.INTERRUPT_NONE) {
          continue;
        }
        if (interrupt == Sound.INTERRUPT_EARLY && target2.getPosition() < replacement.getPosition() || interrupt == Sound.INTERRUPT_LATE && target2.getPosition() > replacement.getPosition()) {
          replacement = target2;
        }
      }
      if (replacement != null) {
        replacement._interrupt();
        this._remove(replacement);
        return true;
      }
      return false;
    };
    p.toString = function() {
      return "[Sound SoundChannel]";
    };
  })();
  (function() {
    var AbstractSoundInstance = function(src, startTime, duration, playbackResource) {
      this.EventDispatcher_constructor();
      this.src = src;
      this.uniqueId = -1;
      this.playState = null;
      this.delayTimeoutId = null;
      this._volume = 1;
      Object.defineProperty(this, "volume", {
        get: this.getVolume,
        set: this.setVolume
      });
      this._pan = 0;
      Object.defineProperty(this, "pan", {
        get: this.getPan,
        set: this.setPan
      });
      this._startTime = Math.max(0, startTime || 0);
      Object.defineProperty(this, "startTime", {
        get: this.getStartTime,
        set: this.setStartTime
      });
      this._duration = Math.max(0, duration || 0);
      Object.defineProperty(this, "duration", {
        get: this.getDuration,
        set: this.setDuration
      });
      this._playbackResource = null;
      Object.defineProperty(this, "playbackResource", {
        get: this.getPlaybackResource,
        set: this.setPlaybackResource
      });
      if (playbackResource !== false && playbackResource !== true) {
        this.setPlaybackResource(playbackResource);
      }
      this._position = 0;
      Object.defineProperty(this, "position", {
        get: this.getPosition,
        set: this.setPosition
      });
      this._loop = 0;
      Object.defineProperty(this, "loop", {
        get: this.getLoop,
        set: this.setLoop
      });
      this._muted = false;
      Object.defineProperty(this, "muted", {
        get: this.getMuted,
        set: this.setMuted
      });
      this._paused = false;
      Object.defineProperty(this, "paused", {
        get: this.getPaused,
        set: this.setPaused
      });
    };
    var p = createjs2.extend(AbstractSoundInstance, createjs2.EventDispatcher);
    p.play = function(interrupt, delay, offset2, loop, volume, pan) {
      var playProps;
      if (interrupt instanceof Object || interrupt instanceof createjs2.PlayPropsConfig) {
        playProps = createjs2.PlayPropsConfig.create(interrupt);
      } else {
        playProps = createjs2.PlayPropsConfig.create({ interrupt, delay, offset: offset2, loop, volume, pan });
      }
      if (this.playState == createjs2.Sound.PLAY_SUCCEEDED) {
        this.applyPlayProps(playProps);
        if (this._paused) {
          this.setPaused(false);
        }
        return;
      }
      this._cleanUp();
      createjs2.Sound._playInstance(this, playProps);
      return this;
    };
    p.stop = function() {
      this._position = 0;
      this._paused = false;
      this._handleStop();
      this._cleanUp();
      this.playState = createjs2.Sound.PLAY_FINISHED;
      return this;
    };
    p.destroy = function() {
      this._cleanUp();
      this.src = null;
      this.playbackResource = null;
      this.removeAllEventListeners();
    };
    p.applyPlayProps = function(playProps) {
      if (playProps.offset != null) {
        this.setPosition(playProps.offset);
      }
      if (playProps.loop != null) {
        this.setLoop(playProps.loop);
      }
      if (playProps.volume != null) {
        this.setVolume(playProps.volume);
      }
      if (playProps.pan != null) {
        this.setPan(playProps.pan);
      }
      if (playProps.startTime != null) {
        this.setStartTime(playProps.startTime);
        this.setDuration(playProps.duration);
      }
      return this;
    };
    p.toString = function() {
      return "[AbstractSoundInstance]";
    };
    p.getPaused = function() {
      return this._paused;
    };
    p.setPaused = function(value) {
      if (value !== true && value !== false || this._paused == value) {
        return;
      }
      if (value == true && this.playState != createjs2.Sound.PLAY_SUCCEEDED) {
        return;
      }
      this._paused = value;
      if (value) {
        this._pause();
      } else {
        this._resume();
      }
      clearTimeout(this.delayTimeoutId);
      return this;
    };
    p.setVolume = function(value) {
      if (value == this._volume) {
        return this;
      }
      this._volume = Math.max(0, Math.min(1, value));
      if (!this._muted) {
        this._updateVolume();
      }
      return this;
    };
    p.getVolume = function() {
      return this._volume;
    };
    p.setMuted = function(value) {
      if (value !== true && value !== false) {
        return;
      }
      this._muted = value;
      this._updateVolume();
      return this;
    };
    p.getMuted = function() {
      return this._muted;
    };
    p.setPan = function(value) {
      if (value == this._pan) {
        return this;
      }
      this._pan = Math.max(-1, Math.min(1, value));
      this._updatePan();
      return this;
    };
    p.getPan = function() {
      return this._pan;
    };
    p.getPosition = function() {
      if (!this._paused && this.playState == createjs2.Sound.PLAY_SUCCEEDED) {
        this._position = this._calculateCurrentPosition();
      }
      return this._position;
    };
    p.setPosition = function(value) {
      this._position = Math.max(0, value);
      if (this.playState == createjs2.Sound.PLAY_SUCCEEDED) {
        this._updatePosition();
      }
      return this;
    };
    p.getStartTime = function() {
      return this._startTime;
    };
    p.setStartTime = function(value) {
      if (value == this._startTime) {
        return this;
      }
      this._startTime = Math.max(0, value || 0);
      this._updateStartTime();
      return this;
    };
    p.getDuration = function() {
      return this._duration;
    };
    p.setDuration = function(value) {
      if (value == this._duration) {
        return this;
      }
      this._duration = Math.max(0, value || 0);
      this._updateDuration();
      return this;
    };
    p.setPlaybackResource = function(value) {
      this._playbackResource = value;
      if (this._duration == 0) {
        this._setDurationFromSource();
      }
      return this;
    };
    p.getPlaybackResource = function() {
      return this._playbackResource;
    };
    p.getLoop = function() {
      return this._loop;
    };
    p.setLoop = function(value) {
      if (this._playbackResource != null) {
        if (this._loop != 0 && value == 0) {
          this._removeLooping(value);
        } else if (this._loop == 0 && value != 0) {
          this._addLooping(value);
        }
      }
      this._loop = value;
    };
    p._sendEvent = function(type) {
      var event = new createjs2.Event(type);
      this.dispatchEvent(event);
    };
    p._cleanUp = function() {
      clearTimeout(this.delayTimeoutId);
      this._handleCleanUp();
      this._paused = false;
      createjs2.Sound._playFinished(this);
    };
    p._interrupt = function() {
      this._cleanUp();
      this.playState = createjs2.Sound.PLAY_INTERRUPTED;
      this._sendEvent("interrupted");
    };
    p._beginPlaying = function(playProps) {
      this.setPosition(playProps.offset);
      this.setLoop(playProps.loop);
      this.setVolume(playProps.volume);
      this.setPan(playProps.pan);
      if (playProps.startTime != null) {
        this.setStartTime(playProps.startTime);
        this.setDuration(playProps.duration);
      }
      if (this._playbackResource != null && this._position < this._duration) {
        this._paused = false;
        this._handleSoundReady();
        this.playState = createjs2.Sound.PLAY_SUCCEEDED;
        this._sendEvent("succeeded");
        return true;
      } else {
        this._playFailed();
        return false;
      }
    };
    p._playFailed = function() {
      this._cleanUp();
      this.playState = createjs2.Sound.PLAY_FAILED;
      this._sendEvent("failed");
    };
    p._handleSoundComplete = function(event) {
      this._position = 0;
      if (this._loop != 0) {
        this._loop--;
        this._handleLoop();
        this._sendEvent("loop");
        return;
      }
      this._cleanUp();
      this.playState = createjs2.Sound.PLAY_FINISHED;
      this._sendEvent("complete");
    };
    p._handleSoundReady = function() {
    };
    p._updateVolume = function() {
    };
    p._updatePan = function() {
    };
    p._updateStartTime = function() {
    };
    p._updateDuration = function() {
    };
    p._setDurationFromSource = function() {
    };
    p._calculateCurrentPosition = function() {
    };
    p._updatePosition = function() {
    };
    p._removeLooping = function(value) {
    };
    p._addLooping = function(value) {
    };
    p._pause = function() {
    };
    p._resume = function() {
    };
    p._handleStop = function() {
    };
    p._handleCleanUp = function() {
    };
    p._handleLoop = function() {
    };
    createjs2.AbstractSoundInstance = createjs2.promote(AbstractSoundInstance, "EventDispatcher");
    createjs2.DefaultSoundInstance = createjs2.AbstractSoundInstance;
  })();
  (function() {
    var AbstractPlugin = function() {
      this._capabilities = null;
      this._loaders = {};
      this._audioSources = {};
      this._soundInstances = {};
      this._volume = 1;
      this._loaderClass;
      this._soundInstanceClass;
    };
    var p = AbstractPlugin.prototype;
    AbstractPlugin._capabilities = null;
    AbstractPlugin.isSupported = function() {
      return true;
    };
    p.register = function(loadItem) {
      var loader = this._loaders[loadItem.src];
      if (loader && !loader.canceled) {
        return this._loaders[loadItem.src];
      }
      this._audioSources[loadItem.src] = true;
      this._soundInstances[loadItem.src] = [];
      loader = new this._loaderClass(loadItem);
      loader.on("complete", this._handlePreloadComplete, this);
      this._loaders[loadItem.src] = loader;
      return loader;
    };
    p.preload = function(loader) {
      loader.on("error", this._handlePreloadError, this);
      loader.load();
    };
    p.isPreloadStarted = function(src) {
      return this._audioSources[src] != null;
    };
    p.isPreloadComplete = function(src) {
      return !(this._audioSources[src] == null || this._audioSources[src] == true);
    };
    p.removeSound = function(src) {
      if (!this._soundInstances[src]) {
        return;
      }
      for (var i2 = this._soundInstances[src].length; i2--; ) {
        var item = this._soundInstances[src][i2];
        item.destroy();
      }
      delete this._soundInstances[src];
      delete this._audioSources[src];
      if (this._loaders[src]) {
        this._loaders[src].destroy();
      }
      delete this._loaders[src];
    };
    p.removeAllSounds = function() {
      for (var key in this._audioSources) {
        this.removeSound(key);
      }
    };
    p.create = function(src, startTime, duration) {
      if (!this.isPreloadStarted(src)) {
        this.preload(this.register(src));
      }
      var si = new this._soundInstanceClass(src, startTime, duration, this._audioSources[src]);
      this._soundInstances[src].push(si);
      return si;
    };
    p.setVolume = function(value) {
      this._volume = value;
      this._updateVolume();
      return true;
    };
    p.getVolume = function() {
      return this._volume;
    };
    p.setMute = function(value) {
      this._updateVolume();
      return true;
    };
    p.toString = function() {
      return "[AbstractPlugin]";
    };
    p._handlePreloadComplete = function(event) {
      var src = event.target.getItem().src;
      this._audioSources[src] = event.result;
      for (var i2 = 0, l = this._soundInstances[src].length; i2 < l; i2++) {
        var item = this._soundInstances[src][i2];
        item.setPlaybackResource(this._audioSources[src]);
      }
    };
    p._handlePreloadError = function(event) {
    };
    p._updateVolume = function() {
    };
    createjs2.AbstractPlugin = AbstractPlugin;
  })();
  (function() {
    function Loader(loadItem) {
      this.AbstractLoader_constructor(loadItem, true, createjs2.AbstractLoader.SOUND);
    }
    var p = createjs2.extend(Loader, createjs2.AbstractLoader);
    Loader.context = null;
    p.toString = function() {
      return "[WebAudioLoader]";
    };
    p._createRequest = function() {
      this._request = new createjs2.XHRRequest(this._item, false);
      this._request.setResponseType("arraybuffer");
    };
    p._sendComplete = function(event) {
      Loader.context.decodeAudioData(
        this._rawResult,
        createjs2.proxy(this._handleAudioDecoded, this),
        createjs2.proxy(this._sendError, this)
      );
    };
    p._handleAudioDecoded = function(decodedAudio) {
      this._result = decodedAudio;
      this.AbstractLoader__sendComplete();
    };
    createjs2.WebAudioLoader = createjs2.promote(Loader, "AbstractLoader");
  })();
  (function() {
    function WebAudioSoundInstance(src, startTime, duration, playbackResource) {
      this.AbstractSoundInstance_constructor(src, startTime, duration, playbackResource);
      this.gainNode = s2.context.createGain();
      this.panNode = s2.context.createPanner();
      this.panNode.panningModel = s2._panningModel;
      this.panNode.connect(this.gainNode);
      this._updatePan();
      this.sourceNode = null;
      this._soundCompleteTimeout = null;
      this._sourceNodeNext = null;
      this._playbackStartTime = 0;
      this._endedHandler = createjs2.proxy(this._handleSoundComplete, this);
    }
    var p = createjs2.extend(WebAudioSoundInstance, createjs2.AbstractSoundInstance);
    var s2 = WebAudioSoundInstance;
    s2.context = null;
    s2._scratchBuffer = null;
    s2.destinationNode = null;
    s2._panningModel = "equalpower";
    p.destroy = function() {
      this.AbstractSoundInstance_destroy();
      this.panNode.disconnect(0);
      this.panNode = null;
      this.gainNode.disconnect(0);
      this.gainNode = null;
    };
    p.toString = function() {
      return "[WebAudioSoundInstance]";
    };
    p._updatePan = function() {
      this.panNode.setPosition(this._pan, 0, -0.5);
    };
    p._removeLooping = function(value) {
      this._sourceNodeNext = this._cleanUpAudioNode(this._sourceNodeNext);
    };
    p._addLooping = function(value) {
      if (this.playState != createjs2.Sound.PLAY_SUCCEEDED) {
        return;
      }
      this._sourceNodeNext = this._createAndPlayAudioNode(this._playbackStartTime, 0);
    };
    p._setDurationFromSource = function() {
      this._duration = this.playbackResource.duration * 1e3;
    };
    p._handleCleanUp = function() {
      if (this.sourceNode && this.playState == createjs2.Sound.PLAY_SUCCEEDED) {
        this.sourceNode = this._cleanUpAudioNode(this.sourceNode);
        this._sourceNodeNext = this._cleanUpAudioNode(this._sourceNodeNext);
      }
      if (this.gainNode.numberOfOutputs != 0) {
        this.gainNode.disconnect(0);
      }
      clearTimeout(this._soundCompleteTimeout);
      this._playbackStartTime = 0;
    };
    p._cleanUpAudioNode = function(audioNode) {
      if (audioNode) {
        audioNode.stop(0);
        audioNode.disconnect(0);
        try {
          audioNode.buffer = s2._scratchBuffer;
        } catch (e) {
        }
        audioNode = null;
      }
      return audioNode;
    };
    p._handleSoundReady = function(event) {
      this.gainNode.connect(s2.destinationNode);
      var dur = this._duration * 1e-3;
      var pos = this._position * 1e-3;
      if (pos > dur) {
        pos = dur;
      }
      this.sourceNode = this._createAndPlayAudioNode(s2.context.currentTime - dur, pos);
      this._playbackStartTime = this.sourceNode.startTime - pos;
      this._soundCompleteTimeout = setTimeout(this._endedHandler, (dur - pos) * 1e3);
      if (this._loop != 0) {
        this._sourceNodeNext = this._createAndPlayAudioNode(this._playbackStartTime, 0);
      }
    };
    p._createAndPlayAudioNode = function(startTime, offset2) {
      var audioNode = s2.context.createBufferSource();
      audioNode.buffer = this.playbackResource;
      audioNode.connect(this.panNode);
      var dur = this._duration * 1e-3;
      audioNode.startTime = startTime + dur;
      audioNode.start(audioNode.startTime, offset2 + this._startTime * 1e-3, dur - offset2);
      return audioNode;
    };
    p._pause = function() {
      this._position = (s2.context.currentTime - this._playbackStartTime) * 1e3;
      this.sourceNode = this._cleanUpAudioNode(this.sourceNode);
      this._sourceNodeNext = this._cleanUpAudioNode(this._sourceNodeNext);
      if (this.gainNode.numberOfOutputs != 0) {
        this.gainNode.disconnect(0);
      }
      clearTimeout(this._soundCompleteTimeout);
    };
    p._resume = function() {
      this._handleSoundReady();
    };
    p._updateVolume = function() {
      var newVolume = this._muted ? 0 : this._volume;
      if (newVolume != this.gainNode.gain.value) {
        this.gainNode.gain.value = newVolume;
      }
    };
    p._calculateCurrentPosition = function() {
      return (s2.context.currentTime - this._playbackStartTime) * 1e3;
    };
    p._updatePosition = function() {
      this.sourceNode = this._cleanUpAudioNode(this.sourceNode);
      this._sourceNodeNext = this._cleanUpAudioNode(this._sourceNodeNext);
      clearTimeout(this._soundCompleteTimeout);
      if (!this._paused) {
        this._handleSoundReady();
      }
    };
    p._handleLoop = function() {
      this._cleanUpAudioNode(this.sourceNode);
      this.sourceNode = this._sourceNodeNext;
      this._playbackStartTime = this.sourceNode.startTime;
      this._sourceNodeNext = this._createAndPlayAudioNode(this._playbackStartTime, 0);
      this._soundCompleteTimeout = setTimeout(this._endedHandler, this._duration);
    };
    p._updateDuration = function() {
      if (this.playState == createjs2.Sound.PLAY_SUCCEEDED) {
        this._pause();
        this._resume();
      }
    };
    createjs2.WebAudioSoundInstance = createjs2.promote(WebAudioSoundInstance, "AbstractSoundInstance");
  })();
  (function() {
    function WebAudioPlugin() {
      this.AbstractPlugin_constructor();
      this._panningModel = s2._panningModel;
      this.context = s2.context;
      this.dynamicsCompressorNode = this.context.createDynamicsCompressor();
      this.dynamicsCompressorNode.connect(this.context.destination);
      this.gainNode = this.context.createGain();
      this.gainNode.connect(this.dynamicsCompressorNode);
      createjs2.WebAudioSoundInstance.destinationNode = this.gainNode;
      this._capabilities = s2._capabilities;
      this._loaderClass = createjs2.WebAudioLoader;
      this._soundInstanceClass = createjs2.WebAudioSoundInstance;
      this._addPropsToClasses();
    }
    var p = createjs2.extend(WebAudioPlugin, createjs2.AbstractPlugin);
    var s2 = WebAudioPlugin;
    s2._capabilities = null;
    s2._panningModel = "equalpower";
    s2.context = null;
    s2._scratchBuffer = null;
    s2._unlocked = false;
    s2.isSupported = function() {
      var isMobilePhoneGap = createjs2.BrowserDetect.isIOS || createjs2.BrowserDetect.isAndroid || createjs2.BrowserDetect.isBlackberry;
      if (location.protocol == "file:" && !isMobilePhoneGap && !this._isFileXHRSupported()) {
        return false;
      }
      s2._generateCapabilities();
      if (s2.context == null) {
        return false;
      }
      return true;
    };
    s2.playEmptySound = function() {
      if (s2.context == null) {
        return;
      }
      var source = s2.context.createBufferSource();
      source.buffer = s2._scratchBuffer;
      source.connect(s2.context.destination);
      source.start(0, 0, 0);
    };
    s2._isFileXHRSupported = function() {
      var supported2 = true;
      var xhr2 = new XMLHttpRequest();
      try {
        xhr2.open("GET", "WebAudioPluginTest.fail", false);
      } catch (error2) {
        supported2 = false;
        return supported2;
      }
      xhr2.onerror = function() {
        supported2 = false;
      };
      xhr2.onload = function() {
        supported2 = this.status == 404 || (this.status == 200 || this.status == 0 && this.response != "");
      };
      try {
        xhr2.send();
      } catch (error2) {
        supported2 = false;
      }
      return supported2;
    };
    s2._generateCapabilities = function() {
      if (s2._capabilities != null) {
        return;
      }
      var t3 = document.createElement("audio");
      if (t3.canPlayType == null) {
        return null;
      }
      if (s2.context == null) {
        if (window.AudioContext) {
          s2.context = new AudioContext();
        } else if (window.webkitAudioContext) {
          s2.context = new webkitAudioContext();
        } else {
          return null;
        }
      }
      if (s2._scratchBuffer == null) {
        s2._scratchBuffer = s2.context.createBuffer(1, 1, 22050);
      }
      s2._compatibilitySetUp();
      if ("ontouchstart" in window && s2.context.state != "running") {
        s2._unlock();
        document.addEventListener("mousedown", s2._unlock, true);
        document.addEventListener("touchend", s2._unlock, true);
      }
      s2._capabilities = {
        panning: true,
        volume: true,
        tracks: -1
      };
      var supportedExtensions = createjs2.Sound.SUPPORTED_EXTENSIONS;
      var extensionMap = createjs2.Sound.EXTENSION_MAP;
      for (var i2 = 0, l = supportedExtensions.length; i2 < l; i2++) {
        var ext = supportedExtensions[i2];
        var playType = extensionMap[ext] || ext;
        s2._capabilities[ext] = t3.canPlayType("audio/" + ext) != "no" && t3.canPlayType("audio/" + ext) != "" || t3.canPlayType("audio/" + playType) != "no" && t3.canPlayType("audio/" + playType) != "";
      }
      if (s2.context.destination.numberOfChannels < 2) {
        s2._capabilities.panning = false;
      }
    };
    s2._compatibilitySetUp = function() {
      s2._panningModel = "equalpower";
      if (s2.context.createGain) {
        return;
      }
      s2.context.createGain = s2.context.createGainNode;
      var audioNode = s2.context.createBufferSource();
      audioNode.__proto__.start = audioNode.__proto__.noteGrainOn;
      audioNode.__proto__.stop = audioNode.__proto__.noteOff;
      s2._panningModel = 0;
    };
    s2._unlock = function() {
      if (s2._unlocked) {
        return;
      }
      s2.playEmptySound();
      if (s2.context.state == "running") {
        document.removeEventListener("mousedown", s2._unlock, true);
        document.removeEventListener("touchend", s2._unlock, true);
        s2._unlocked = true;
      }
    };
    p.toString = function() {
      return "[WebAudioPlugin]";
    };
    p._addPropsToClasses = function() {
      var c = this._soundInstanceClass;
      c.context = this.context;
      c._scratchBuffer = s2._scratchBuffer;
      c.destinationNode = this.gainNode;
      c._panningModel = this._panningModel;
      this._loaderClass.context = this.context;
    };
    p._updateVolume = function() {
      var newVolume = createjs2.Sound._masterMute ? 0 : this._volume;
      if (newVolume != this.gainNode.gain.value) {
        this.gainNode.gain.value = newVolume;
      }
    };
    createjs2.WebAudioPlugin = createjs2.promote(WebAudioPlugin, "AbstractPlugin");
  })();
  (function() {
    function HTMLAudioTagPool() {
      throw "HTMLAudioTagPool cannot be instantiated";
    }
    var s2 = HTMLAudioTagPool;
    s2._tags = {};
    s2._tagPool = new TagPool();
    s2._tagUsed = {};
    s2.get = function(src) {
      var t3 = s2._tags[src];
      if (t3 == null) {
        t3 = s2._tags[src] = s2._tagPool.get();
        t3.src = src;
      } else {
        if (s2._tagUsed[src]) {
          t3 = s2._tagPool.get();
          t3.src = src;
        } else {
          s2._tagUsed[src] = true;
        }
      }
      return t3;
    };
    s2.set = function(src, tag) {
      if (tag == s2._tags[src]) {
        s2._tagUsed[src] = false;
      } else {
        s2._tagPool.set(tag);
      }
    };
    s2.remove = function(src) {
      var tag = s2._tags[src];
      if (tag == null) {
        return false;
      }
      s2._tagPool.set(tag);
      delete s2._tags[src];
      delete s2._tagUsed[src];
      return true;
    };
    s2.getDuration = function(src) {
      var t3 = s2._tags[src];
      if (t3 == null || !t3.duration) {
        return 0;
      }
      return t3.duration * 1e3;
    };
    createjs2.HTMLAudioTagPool = HTMLAudioTagPool;
    function TagPool(src) {
      this._tags = [];
    }
    var p = TagPool.prototype;
    p.constructor = TagPool;
    p.get = function() {
      var tag;
      if (this._tags.length == 0) {
        tag = this._createTag();
      } else {
        tag = this._tags.pop();
      }
      if (tag.parentNode == null) {
        document.body.appendChild(tag);
      }
      return tag;
    };
    p.set = function(tag) {
      var index2 = createjs2.indexOf(this._tags, tag);
      if (index2 == -1) {
        this._tags.src = null;
        this._tags.push(tag);
      }
    };
    p.toString = function() {
      return "[TagPool]";
    };
    p._createTag = function() {
      var tag = document.createElement("audio");
      tag.autoplay = false;
      tag.preload = "none";
      return tag;
    };
  })();
  (function() {
    function HTMLAudioSoundInstance(src, startTime, duration, playbackResource) {
      this.AbstractSoundInstance_constructor(src, startTime, duration, playbackResource);
      this._audioSpriteStopTime = null;
      this._delayTimeoutId = null;
      this._endedHandler = createjs2.proxy(this._handleSoundComplete, this);
      this._readyHandler = createjs2.proxy(this._handleTagReady, this);
      this._stalledHandler = createjs2.proxy(this._playFailed, this);
      this._audioSpriteEndHandler = createjs2.proxy(this._handleAudioSpriteLoop, this);
      this._loopHandler = createjs2.proxy(this._handleSoundComplete, this);
      if (duration) {
        this._audioSpriteStopTime = (startTime + duration) * 1e-3;
      } else {
        this._duration = createjs2.HTMLAudioTagPool.getDuration(this.src);
      }
    }
    var p = createjs2.extend(HTMLAudioSoundInstance, createjs2.AbstractSoundInstance);
    p.setMasterVolume = function(value) {
      this._updateVolume();
    };
    p.setMasterMute = function(isMuted) {
      this._updateVolume();
    };
    p.toString = function() {
      return "[HTMLAudioSoundInstance]";
    };
    p._removeLooping = function() {
      if (this._playbackResource == null) {
        return;
      }
      this._playbackResource.loop = false;
      this._playbackResource.removeEventListener(createjs2.HTMLAudioPlugin._AUDIO_SEEKED, this._loopHandler, false);
    };
    p._addLooping = function() {
      if (this._playbackResource == null || this._audioSpriteStopTime) {
        return;
      }
      this._playbackResource.addEventListener(createjs2.HTMLAudioPlugin._AUDIO_SEEKED, this._loopHandler, false);
      this._playbackResource.loop = true;
    };
    p._handleCleanUp = function() {
      var tag = this._playbackResource;
      if (tag != null) {
        tag.pause();
        tag.loop = false;
        tag.removeEventListener(createjs2.HTMLAudioPlugin._AUDIO_ENDED, this._endedHandler, false);
        tag.removeEventListener(createjs2.HTMLAudioPlugin._AUDIO_READY, this._readyHandler, false);
        tag.removeEventListener(createjs2.HTMLAudioPlugin._AUDIO_STALLED, this._stalledHandler, false);
        tag.removeEventListener(createjs2.HTMLAudioPlugin._AUDIO_SEEKED, this._loopHandler, false);
        tag.removeEventListener(createjs2.HTMLAudioPlugin._TIME_UPDATE, this._audioSpriteEndHandler, false);
        try {
          tag.currentTime = this._startTime;
        } catch (e) {
        }
        createjs2.HTMLAudioTagPool.set(this.src, tag);
        this._playbackResource = null;
      }
    };
    p._beginPlaying = function(playProps) {
      this._playbackResource = createjs2.HTMLAudioTagPool.get(this.src);
      return this.AbstractSoundInstance__beginPlaying(playProps);
    };
    p._handleSoundReady = function(event) {
      if (this._playbackResource.readyState !== 4) {
        var tag = this._playbackResource;
        tag.addEventListener(createjs2.HTMLAudioPlugin._AUDIO_READY, this._readyHandler, false);
        tag.addEventListener(createjs2.HTMLAudioPlugin._AUDIO_STALLED, this._stalledHandler, false);
        tag.preload = "auto";
        tag.load();
        return;
      }
      this._updateVolume();
      this._playbackResource.currentTime = (this._startTime + this._position) * 1e-3;
      if (this._audioSpriteStopTime) {
        this._playbackResource.addEventListener(createjs2.HTMLAudioPlugin._TIME_UPDATE, this._audioSpriteEndHandler, false);
      } else {
        this._playbackResource.addEventListener(createjs2.HTMLAudioPlugin._AUDIO_ENDED, this._endedHandler, false);
        if (this._loop != 0) {
          this._playbackResource.addEventListener(createjs2.HTMLAudioPlugin._AUDIO_SEEKED, this._loopHandler, false);
          this._playbackResource.loop = true;
        }
      }
      this._playbackResource.play();
    };
    p._handleTagReady = function(event) {
      this._playbackResource.removeEventListener(createjs2.HTMLAudioPlugin._AUDIO_READY, this._readyHandler, false);
      this._playbackResource.removeEventListener(createjs2.HTMLAudioPlugin._AUDIO_STALLED, this._stalledHandler, false);
      this._handleSoundReady();
    };
    p._pause = function() {
      this._playbackResource.pause();
    };
    p._resume = function() {
      this._playbackResource.play();
    };
    p._updateVolume = function() {
      if (this._playbackResource != null) {
        var newVolume = this._muted || createjs2.Sound._masterMute ? 0 : this._volume * createjs2.Sound._masterVolume;
        if (newVolume != this._playbackResource.volume) {
          this._playbackResource.volume = newVolume;
        }
      }
    };
    p._calculateCurrentPosition = function() {
      return this._playbackResource.currentTime * 1e3 - this._startTime;
    };
    p._updatePosition = function() {
      this._playbackResource.removeEventListener(createjs2.HTMLAudioPlugin._AUDIO_SEEKED, this._loopHandler, false);
      this._playbackResource.addEventListener(createjs2.HTMLAudioPlugin._AUDIO_SEEKED, this._handleSetPositionSeek, false);
      try {
        this._playbackResource.currentTime = (this._position + this._startTime) * 1e-3;
      } catch (error2) {
        this._handleSetPositionSeek(null);
      }
    };
    p._handleSetPositionSeek = function(event) {
      if (this._playbackResource == null) {
        return;
      }
      this._playbackResource.removeEventListener(createjs2.HTMLAudioPlugin._AUDIO_SEEKED, this._handleSetPositionSeek, false);
      this._playbackResource.addEventListener(createjs2.HTMLAudioPlugin._AUDIO_SEEKED, this._loopHandler, false);
    };
    p._handleAudioSpriteLoop = function(event) {
      if (this._playbackResource.currentTime <= this._audioSpriteStopTime) {
        return;
      }
      this._playbackResource.pause();
      if (this._loop == 0) {
        this._handleSoundComplete(null);
      } else {
        this._position = 0;
        this._loop--;
        this._playbackResource.currentTime = this._startTime * 1e-3;
        if (!this._paused) {
          this._playbackResource.play();
        }
        this._sendEvent("loop");
      }
    };
    p._handleLoop = function(event) {
      if (this._loop == 0) {
        this._playbackResource.loop = false;
        this._playbackResource.removeEventListener(createjs2.HTMLAudioPlugin._AUDIO_SEEKED, this._loopHandler, false);
      }
    };
    p._updateStartTime = function() {
      this._audioSpriteStopTime = (this._startTime + this._duration) * 1e-3;
      if (this.playState == createjs2.Sound.PLAY_SUCCEEDED) {
        this._playbackResource.removeEventListener(createjs2.HTMLAudioPlugin._AUDIO_ENDED, this._endedHandler, false);
        this._playbackResource.addEventListener(createjs2.HTMLAudioPlugin._TIME_UPDATE, this._audioSpriteEndHandler, false);
      }
    };
    p._updateDuration = function() {
      this._audioSpriteStopTime = (this._startTime + this._duration) * 1e-3;
      if (this.playState == createjs2.Sound.PLAY_SUCCEEDED) {
        this._playbackResource.removeEventListener(createjs2.HTMLAudioPlugin._AUDIO_ENDED, this._endedHandler, false);
        this._playbackResource.addEventListener(createjs2.HTMLAudioPlugin._TIME_UPDATE, this._audioSpriteEndHandler, false);
      }
    };
    p._setDurationFromSource = function() {
      this._duration = createjs2.HTMLAudioTagPool.getDuration(this.src);
      this._playbackResource = null;
    };
    createjs2.HTMLAudioSoundInstance = createjs2.promote(HTMLAudioSoundInstance, "AbstractSoundInstance");
  })();
  (function() {
    function HTMLAudioPlugin() {
      this.AbstractPlugin_constructor();
      this.defaultNumChannels = 2;
      this._capabilities = s2._capabilities;
      this._loaderClass = createjs2.SoundLoader;
      this._soundInstanceClass = createjs2.HTMLAudioSoundInstance;
    }
    var p = createjs2.extend(HTMLAudioPlugin, createjs2.AbstractPlugin);
    var s2 = HTMLAudioPlugin;
    s2.MAX_INSTANCES = 30;
    s2._AUDIO_READY = "canplaythrough";
    s2._AUDIO_ENDED = "ended";
    s2._AUDIO_SEEKED = "seeked";
    s2._AUDIO_STALLED = "stalled";
    s2._TIME_UPDATE = "timeupdate";
    s2._capabilities = null;
    s2.isSupported = function() {
      s2._generateCapabilities();
      return s2._capabilities != null;
    };
    s2._generateCapabilities = function() {
      if (s2._capabilities != null) {
        return;
      }
      var t3 = document.createElement("audio");
      if (t3.canPlayType == null) {
        return null;
      }
      s2._capabilities = {
        panning: false,
        volume: true,
        tracks: -1
      };
      var supportedExtensions = createjs2.Sound.SUPPORTED_EXTENSIONS;
      var extensionMap = createjs2.Sound.EXTENSION_MAP;
      for (var i2 = 0, l = supportedExtensions.length; i2 < l; i2++) {
        var ext = supportedExtensions[i2];
        var playType = extensionMap[ext] || ext;
        s2._capabilities[ext] = t3.canPlayType("audio/" + ext) != "no" && t3.canPlayType("audio/" + ext) != "" || t3.canPlayType("audio/" + playType) != "no" && t3.canPlayType("audio/" + playType) != "";
      }
    };
    p.register = function(loadItem) {
      var tag = createjs2.HTMLAudioTagPool.get(loadItem.src);
      var loader = this.AbstractPlugin_register(loadItem);
      loader.setTag(tag);
      return loader;
    };
    p.removeSound = function(src) {
      this.AbstractPlugin_removeSound(src);
      createjs2.HTMLAudioTagPool.remove(src);
    };
    p.create = function(src, startTime, duration) {
      var si = this.AbstractPlugin_create(src, startTime, duration);
      si.setPlaybackResource(null);
      return si;
    };
    p.toString = function() {
      return "[HTMLAudioPlugin]";
    };
    p.setVolume = p.getVolume = p.setMute = null;
    createjs2.HTMLAudioPlugin = createjs2.promote(HTMLAudioPlugin, "AbstractPlugin");
  })();
  (function() {
    function Tween(target2, props2, pluginData) {
      this.ignoreGlobalPause = false;
      this.loop = false;
      this.duration = 0;
      this.pluginData = pluginData || {};
      this.target = target2;
      this.position = null;
      this.passive = false;
      this._paused = false;
      this._curQueueProps = {};
      this._initQueueProps = {};
      this._steps = [];
      this._actions = [];
      this._prevPosition = 0;
      this._stepPosition = 0;
      this._prevPos = -1;
      this._target = target2;
      this._useTicks = false;
      this._inited = false;
      this._registered = false;
      if (props2) {
        this._useTicks = props2.useTicks;
        this.ignoreGlobalPause = props2.ignoreGlobalPause;
        this.loop = props2.loop;
        props2.onChange && this.addEventListener("change", props2.onChange);
        if (props2.override) {
          Tween.removeTweens(target2);
        }
      }
      if (props2 && props2.paused) {
        this._paused = true;
      } else {
        createjs2.Tween._register(this, true);
      }
      if (props2 && props2.position != null) {
        this.setPosition(props2.position, Tween.NONE);
      }
    }
    var p = createjs2.extend(Tween, createjs2.EventDispatcher);
    Tween.NONE = 0;
    Tween.LOOP = 1;
    Tween.REVERSE = 2;
    Tween.IGNORE = {};
    Tween._tweens = [];
    Tween._plugins = {};
    Tween.get = function(target2, props2, pluginData, override) {
      if (override) {
        Tween.removeTweens(target2);
      }
      return new Tween(target2, props2, pluginData);
    };
    Tween.tick = function(delta, paused) {
      var tweens = Tween._tweens.slice();
      for (var i2 = tweens.length - 1; i2 >= 0; i2--) {
        var tween = tweens[i2];
        if (paused && !tween.ignoreGlobalPause || tween._paused) {
          continue;
        }
        tween.tick(tween._useTicks ? 1 : delta);
      }
    };
    Tween.handleEvent = function(event) {
      if (event.type == "tick") {
        this.tick(event.delta, event.paused);
      }
    };
    Tween.removeTweens = function(target2) {
      if (!target2.tweenjs_count) {
        return;
      }
      var tweens = Tween._tweens;
      for (var i2 = tweens.length - 1; i2 >= 0; i2--) {
        var tween = tweens[i2];
        if (tween._target == target2) {
          tween._paused = true;
          tweens.splice(i2, 1);
        }
      }
      target2.tweenjs_count = 0;
    };
    Tween.removeAllTweens = function() {
      var tweens = Tween._tweens;
      for (var i2 = 0, l = tweens.length; i2 < l; i2++) {
        var tween = tweens[i2];
        tween._paused = true;
        tween.target && (tween.target.tweenjs_count = 0);
      }
      tweens.length = 0;
    };
    Tween.hasActiveTweens = function(target2) {
      if (target2) {
        return target2.tweenjs_count != null && !!target2.tweenjs_count;
      }
      return Tween._tweens && !!Tween._tweens.length;
    };
    Tween.installPlugin = function(plugin3, properties) {
      var priority = plugin3.priority;
      if (priority == null) {
        plugin3.priority = priority = 0;
      }
      for (var i2 = 0, l = properties.length, p2 = Tween._plugins; i2 < l; i2++) {
        var n2 = properties[i2];
        if (!p2[n2]) {
          p2[n2] = [plugin3];
        } else {
          var arr = p2[n2];
          for (var j = 0, jl = arr.length; j < jl; j++) {
            if (priority < arr[j].priority) {
              break;
            }
          }
          p2[n2].splice(j, 0, plugin3);
        }
      }
    };
    Tween._register = function(tween, value) {
      var target2 = tween._target;
      var tweens = Tween._tweens;
      if (value && !tween._registered) {
        if (target2) {
          target2.tweenjs_count = target2.tweenjs_count ? target2.tweenjs_count + 1 : 1;
        }
        tweens.push(tween);
        if (!Tween._inited && createjs2.Ticker) {
          createjs2.Ticker.addEventListener("tick", Tween);
          Tween._inited = true;
        }
      } else if (!value && tween._registered) {
        if (target2) {
          target2.tweenjs_count--;
        }
        var i2 = tweens.length;
        while (i2--) {
          if (tweens[i2] == tween) {
            tweens.splice(i2, 1);
            break;
          }
        }
      }
      tween._registered = value;
    };
    p.wait = function(duration, passive) {
      if (duration == null || duration <= 0) {
        return this;
      }
      var o = this._cloneProps(this._curQueueProps);
      return this._addStep({ d: duration, p0: o, e: this._linearEase, p1: o, v: passive });
    };
    p.to = function(props2, duration, ease) {
      if (isNaN(duration) || duration < 0) {
        duration = 0;
      }
      return this._addStep({ d: duration || 0, p0: this._cloneProps(this._curQueueProps), e: ease, p1: this._cloneProps(this._appendQueueProps(props2)) });
    };
    p.call = function(callback, params, scope) {
      return this._addAction({ f: callback, p: params ? params : [this], o: scope ? scope : this._target });
    };
    p.set = function(props2, target2) {
      return this._addAction({ f: this._set, o: this, p: [props2, target2 ? target2 : this._target] });
    };
    p.play = function(tween) {
      if (!tween) {
        tween = this;
      }
      return this.call(tween.setPaused, [false], tween);
    };
    p.pause = function(tween) {
      if (!tween) {
        tween = this;
      }
      return this.call(tween.setPaused, [true], tween);
    };
    p.setPosition = function(value, actionsMode) {
      if (value < 0) {
        value = 0;
      }
      if (actionsMode == null) {
        actionsMode = 1;
      }
      var t3 = value;
      var end = false;
      if (t3 >= this.duration) {
        if (this.loop) {
          t3 = t3 % this.duration;
        } else {
          t3 = this.duration;
          end = true;
        }
      }
      if (t3 == this._prevPos) {
        return end;
      }
      var prevPos = this._prevPos;
      this.position = this._prevPos = t3;
      this._prevPosition = value;
      if (this._target) {
        if (end) {
          this._updateTargetProps(null, 1);
        } else if (this._steps.length > 0) {
          for (var i2 = 0, l = this._steps.length; i2 < l; i2++) {
            if (this._steps[i2].t > t3) {
              break;
            }
          }
          var step = this._steps[i2 - 1];
          this._updateTargetProps(step, (this._stepPosition = t3 - step.t) / step.d);
        }
      }
      if (actionsMode != 0 && this._actions.length > 0) {
        if (this._useTicks) {
          this._runActions(t3, t3);
        } else if (actionsMode == 1 && t3 < prevPos) {
          if (prevPos != this.duration) {
            this._runActions(prevPos, this.duration);
          }
          this._runActions(0, t3, true);
        } else {
          this._runActions(prevPos, t3);
        }
      }
      if (end) {
        this.setPaused(true);
      }
      this.dispatchEvent("change");
      return end;
    };
    p.tick = function(delta) {
      if (this._paused) {
        return;
      }
      this.setPosition(this._prevPosition + delta);
    };
    p.setPaused = function(value) {
      if (this._paused === !!value) {
        return this;
      }
      this._paused = !!value;
      Tween._register(this, !value);
      return this;
    };
    p.w = p.wait;
    p.t = p.to;
    p.c = p.call;
    p.s = p.set;
    p.toString = function() {
      return "[Tween]";
    };
    p.clone = function() {
      throw "Tween can not be cloned.";
    };
    p._updateTargetProps = function(step, ratio) {
      var p0, p1, v, v0, v1, arr;
      if (!step && ratio == 1) {
        this.passive = false;
        p0 = p1 = this._curQueueProps;
      } else {
        this.passive = !!step.v;
        if (this.passive) {
          return;
        }
        if (step.e) {
          ratio = step.e(ratio, 0, 1, 1);
        }
        p0 = step.p0;
        p1 = step.p1;
      }
      for (var n2 in this._initQueueProps) {
        if ((v0 = p0[n2]) == null) {
          p0[n2] = v0 = this._initQueueProps[n2];
        }
        if ((v1 = p1[n2]) == null) {
          p1[n2] = v1 = v0;
        }
        if (v0 == v1 || ratio == 0 || ratio == 1 || typeof v0 != "number") {
          v = ratio == 1 ? v1 : v0;
        } else {
          v = v0 + (v1 - v0) * ratio;
        }
        var ignore = false;
        if (arr = Tween._plugins[n2]) {
          for (var i2 = 0, l = arr.length; i2 < l; i2++) {
            var v2 = arr[i2].tween(this, n2, v, p0, p1, ratio, !!step && p0 == p1, !step);
            if (v2 == Tween.IGNORE) {
              ignore = true;
            } else {
              v = v2;
            }
          }
        }
        if (!ignore) {
          this._target[n2] = v;
        }
      }
    };
    p._runActions = function(startPos, endPos, includeStart) {
      var sPos = startPos;
      var ePos = endPos;
      var i2 = -1;
      var j = this._actions.length;
      var k = 1;
      if (startPos > endPos) {
        sPos = endPos;
        ePos = startPos;
        i2 = j;
        j = k = -1;
      }
      while ((i2 += k) != j) {
        var action = this._actions[i2];
        var pos = action.t;
        if (pos == ePos || pos > sPos && pos < ePos || includeStart && pos == startPos) {
          action.f.apply(action.o, action.p);
        }
      }
    };
    p._appendQueueProps = function(o) {
      var arr, oldValue, i2, l, injectProps;
      for (var n2 in o) {
        if (this._initQueueProps[n2] === void 0) {
          oldValue = this._target[n2];
          if (arr = Tween._plugins[n2]) {
            for (i2 = 0, l = arr.length; i2 < l; i2++) {
              oldValue = arr[i2].init(this, n2, oldValue);
            }
          }
          this._initQueueProps[n2] = this._curQueueProps[n2] = oldValue === void 0 ? null : oldValue;
        } else {
          oldValue = this._curQueueProps[n2];
        }
      }
      for (var n2 in o) {
        oldValue = this._curQueueProps[n2];
        if (arr = Tween._plugins[n2]) {
          injectProps = injectProps || {};
          for (i2 = 0, l = arr.length; i2 < l; i2++) {
            if (arr[i2].step) {
              arr[i2].step(this, n2, oldValue, o[n2], injectProps);
            }
          }
        }
        this._curQueueProps[n2] = o[n2];
      }
      if (injectProps) {
        this._appendQueueProps(injectProps);
      }
      return this._curQueueProps;
    };
    p._cloneProps = function(props2) {
      var o = {};
      for (var n2 in props2) {
        o[n2] = props2[n2];
      }
      return o;
    };
    p._addStep = function(o) {
      if (o.d > 0) {
        this._steps.push(o);
        o.t = this.duration;
        this.duration += o.d;
      }
      return this;
    };
    p._addAction = function(o) {
      o.t = this.duration;
      this._actions.push(o);
      return this;
    };
    p._set = function(props2, o) {
      for (var n2 in props2) {
        o[n2] = props2[n2];
      }
    };
    createjs2.Tween = createjs2.promote(Tween, "EventDispatcher");
  })();
  (function() {
    function Timeline(tweens, labels, props2) {
      this.EventDispatcher_constructor();
      this.ignoreGlobalPause = false;
      this.duration = 0;
      this.loop = false;
      this.position = null;
      this._paused = false;
      this._tweens = [];
      this._labels = null;
      this._labelList = null;
      this._prevPosition = 0;
      this._prevPos = -1;
      this._useTicks = false;
      this._registered = false;
      if (props2) {
        this._useTicks = props2.useTicks;
        this.loop = props2.loop;
        this.ignoreGlobalPause = props2.ignoreGlobalPause;
        props2.onChange && this.addEventListener("change", props2.onChange);
      }
      if (tweens) {
        this.addTween.apply(this, tweens);
      }
      this.setLabels(labels);
      if (props2 && props2.paused) {
        this._paused = true;
      } else {
        createjs2.Tween._register(this, true);
      }
      if (props2 && props2.position != null) {
        this.setPosition(props2.position, createjs2.Tween.NONE);
      }
    }
    var p = createjs2.extend(Timeline, createjs2.EventDispatcher);
    p.addTween = function(tween) {
      var l = arguments.length;
      if (l > 1) {
        for (var i2 = 0; i2 < l; i2++) {
          this.addTween(arguments[i2]);
        }
        return arguments[0];
      } else if (l == 0) {
        return null;
      }
      this.removeTween(tween);
      this._tweens.push(tween);
      tween.setPaused(true);
      tween._paused = false;
      tween._useTicks = this._useTicks;
      if (tween.duration > this.duration) {
        this.duration = tween.duration;
      }
      if (this._prevPos >= 0) {
        tween.setPosition(this._prevPos, createjs2.Tween.NONE);
      }
      return tween;
    };
    p.removeTween = function(tween) {
      var l = arguments.length;
      if (l > 1) {
        var good = true;
        for (var i2 = 0; i2 < l; i2++) {
          good = good && this.removeTween(arguments[i2]);
        }
        return good;
      } else if (l == 0) {
        return false;
      }
      var tweens = this._tweens;
      var i2 = tweens.length;
      while (i2--) {
        if (tweens[i2] == tween) {
          tweens.splice(i2, 1);
          if (tween.duration >= this.duration) {
            this.updateDuration();
          }
          return true;
        }
      }
      return false;
    };
    p.addLabel = function(label, position) {
      this._labels[label] = position;
      var list2 = this._labelList;
      if (list2) {
        for (var i2 = 0, l = list2.length; i2 < l; i2++) {
          if (position < list2[i2].position) {
            break;
          }
        }
        list2.splice(i2, 0, { label, position });
      }
    };
    p.setLabels = function(o) {
      this._labels = o ? o : {};
    };
    p.getLabels = function() {
      var list2 = this._labelList;
      if (!list2) {
        list2 = this._labelList = [];
        var labels = this._labels;
        for (var n2 in labels) {
          list2.push({ label: n2, position: labels[n2] });
        }
        list2.sort(function(a, b) {
          return a.position - b.position;
        });
      }
      return list2;
    };
    p.getCurrentLabel = function() {
      var labels = this.getLabels();
      var pos = this.position;
      var l = labels.length;
      if (l) {
        for (var i2 = 0; i2 < l; i2++) {
          if (pos < labels[i2].position) {
            break;
          }
        }
        return i2 == 0 ? null : labels[i2 - 1].label;
      }
      return null;
    };
    p.gotoAndPlay = function(positionOrLabel) {
      this.setPaused(false);
      this._goto(positionOrLabel);
    };
    p.gotoAndStop = function(positionOrLabel) {
      this.setPaused(true);
      this._goto(positionOrLabel);
    };
    p.setPosition = function(value, actionsMode) {
      var t3 = this._calcPosition(value);
      var end = !this.loop && value >= this.duration;
      if (t3 == this._prevPos) {
        return end;
      }
      this._prevPosition = value;
      this.position = this._prevPos = t3;
      for (var i2 = 0, l = this._tweens.length; i2 < l; i2++) {
        this._tweens[i2].setPosition(t3, actionsMode);
        if (t3 != this._prevPos) {
          return false;
        }
      }
      if (end) {
        this.setPaused(true);
      }
      this.dispatchEvent("change");
      return end;
    };
    p.setPaused = function(value) {
      this._paused = !!value;
      createjs2.Tween._register(this, !value);
    };
    p.updateDuration = function() {
      this.duration = 0;
      for (var i2 = 0, l = this._tweens.length; i2 < l; i2++) {
        var tween = this._tweens[i2];
        if (tween.duration > this.duration) {
          this.duration = tween.duration;
        }
      }
    };
    p.tick = function(delta) {
      this.setPosition(this._prevPosition + delta);
    };
    p.resolve = function(positionOrLabel) {
      var pos = Number(positionOrLabel);
      if (isNaN(pos)) {
        pos = this._labels[positionOrLabel];
      }
      return pos;
    };
    p.toString = function() {
      return "[Timeline]";
    };
    p.clone = function() {
      throw "Timeline can not be cloned.";
    };
    p._goto = function(positionOrLabel) {
      var pos = this.resolve(positionOrLabel);
      if (pos != null) {
        this.setPosition(pos);
      }
    };
    p._calcPosition = function(value) {
      if (value < 0) {
        return 0;
      }
      if (value < this.duration) {
        return value;
      }
      return this.loop ? value % this.duration : this.duration;
    };
    createjs2.Timeline = createjs2.promote(Timeline, "EventDispatcher");
  })();
  (function() {
    function Ease() {
      throw "Ease cannot be instantiated.";
    }
    Ease.linear = function(t3) {
      return t3;
    };
    Ease.none = Ease.linear;
    Ease.get = function(amount) {
      if (amount < -1) {
        amount = -1;
      }
      if (amount > 1) {
        amount = 1;
      }
      return function(t3) {
        if (amount == 0) {
          return t3;
        }
        if (amount < 0) {
          return t3 * (t3 * -amount + 1 + amount);
        }
        return t3 * ((2 - t3) * amount + (1 - amount));
      };
    };
    Ease.getPowIn = function(pow) {
      return function(t3) {
        return Math.pow(t3, pow);
      };
    };
    Ease.getPowOut = function(pow) {
      return function(t3) {
        return 1 - Math.pow(1 - t3, pow);
      };
    };
    Ease.getPowInOut = function(pow) {
      return function(t3) {
        if ((t3 *= 2) < 1)
          return 0.5 * Math.pow(t3, pow);
        return 1 - 0.5 * Math.abs(Math.pow(2 - t3, pow));
      };
    };
    Ease.quadIn = Ease.getPowIn(2);
    Ease.quadOut = Ease.getPowOut(2);
    Ease.quadInOut = Ease.getPowInOut(2);
    Ease.cubicIn = Ease.getPowIn(3);
    Ease.cubicOut = Ease.getPowOut(3);
    Ease.cubicInOut = Ease.getPowInOut(3);
    Ease.quartIn = Ease.getPowIn(4);
    Ease.quartOut = Ease.getPowOut(4);
    Ease.quartInOut = Ease.getPowInOut(4);
    Ease.quintIn = Ease.getPowIn(5);
    Ease.quintOut = Ease.getPowOut(5);
    Ease.quintInOut = Ease.getPowInOut(5);
    Ease.sineIn = function(t3) {
      return 1 - Math.cos(t3 * Math.PI / 2);
    };
    Ease.sineOut = function(t3) {
      return Math.sin(t3 * Math.PI / 2);
    };
    Ease.sineInOut = function(t3) {
      return -0.5 * (Math.cos(Math.PI * t3) - 1);
    };
    Ease.getBackIn = function(amount) {
      return function(t3) {
        return t3 * t3 * ((amount + 1) * t3 - amount);
      };
    };
    Ease.backIn = Ease.getBackIn(1.7);
    Ease.getBackOut = function(amount) {
      return function(t3) {
        return --t3 * t3 * ((amount + 1) * t3 + amount) + 1;
      };
    };
    Ease.backOut = Ease.getBackOut(1.7);
    Ease.getBackInOut = function(amount) {
      amount *= 1.525;
      return function(t3) {
        if ((t3 *= 2) < 1)
          return 0.5 * (t3 * t3 * ((amount + 1) * t3 - amount));
        return 0.5 * ((t3 -= 2) * t3 * ((amount + 1) * t3 + amount) + 2);
      };
    };
    Ease.backInOut = Ease.getBackInOut(1.7);
    Ease.circIn = function(t3) {
      return -(Math.sqrt(1 - t3 * t3) - 1);
    };
    Ease.circOut = function(t3) {
      return Math.sqrt(1 - --t3 * t3);
    };
    Ease.circInOut = function(t3) {
      if ((t3 *= 2) < 1)
        return -0.5 * (Math.sqrt(1 - t3 * t3) - 1);
      return 0.5 * (Math.sqrt(1 - (t3 -= 2) * t3) + 1);
    };
    Ease.bounceIn = function(t3) {
      return 1 - Ease.bounceOut(1 - t3);
    };
    Ease.bounceOut = function(t3) {
      if (t3 < 1 / 2.75) {
        return 7.5625 * t3 * t3;
      } else if (t3 < 2 / 2.75) {
        return 7.5625 * (t3 -= 1.5 / 2.75) * t3 + 0.75;
      } else if (t3 < 2.5 / 2.75) {
        return 7.5625 * (t3 -= 2.25 / 2.75) * t3 + 0.9375;
      } else {
        return 7.5625 * (t3 -= 2.625 / 2.75) * t3 + 0.984375;
      }
    };
    Ease.bounceInOut = function(t3) {
      if (t3 < 0.5)
        return Ease.bounceIn(t3 * 2) * 0.5;
      return Ease.bounceOut(t3 * 2 - 1) * 0.5 + 0.5;
    };
    Ease.getElasticIn = function(amplitude, period) {
      var pi2 = Math.PI * 2;
      return function(t3) {
        if (t3 == 0 || t3 == 1)
          return t3;
        var s2 = period / pi2 * Math.asin(1 / amplitude);
        return -(amplitude * Math.pow(2, 10 * (t3 -= 1)) * Math.sin((t3 - s2) * pi2 / period));
      };
    };
    Ease.elasticIn = Ease.getElasticIn(1, 0.3);
    Ease.getElasticOut = function(amplitude, period) {
      var pi2 = Math.PI * 2;
      return function(t3) {
        if (t3 == 0 || t3 == 1)
          return t3;
        var s2 = period / pi2 * Math.asin(1 / amplitude);
        return amplitude * Math.pow(2, -10 * t3) * Math.sin((t3 - s2) * pi2 / period) + 1;
      };
    };
    Ease.elasticOut = Ease.getElasticOut(1, 0.3);
    Ease.getElasticInOut = function(amplitude, period) {
      var pi2 = Math.PI * 2;
      return function(t3) {
        var s2 = period / pi2 * Math.asin(1 / amplitude);
        if ((t3 *= 2) < 1)
          return -0.5 * (amplitude * Math.pow(2, 10 * (t3 -= 1)) * Math.sin((t3 - s2) * pi2 / period));
        return amplitude * Math.pow(2, -10 * (t3 -= 1)) * Math.sin((t3 - s2) * pi2 / period) * 0.5 + 1;
      };
    };
    Ease.elasticInOut = Ease.getElasticInOut(1, 0.3 * 1.5);
    createjs2.Ease = Ease;
  })();
  (function() {
    function MotionGuidePlugin() {
      throw "MotionGuidePlugin cannot be instantiated.";
    }
    MotionGuidePlugin.priority = 0;
    MotionGuidePlugin._rotOffS;
    MotionGuidePlugin._rotOffE;
    MotionGuidePlugin._rotNormS;
    MotionGuidePlugin._rotNormE;
    MotionGuidePlugin.install = function() {
      createjs2.Tween.installPlugin(MotionGuidePlugin, ["guide", "x", "y", "rotation"]);
      return createjs2.Tween.IGNORE;
    };
    MotionGuidePlugin.init = function(tween, prop, value) {
      var target2 = tween.target;
      if (!target2.hasOwnProperty("x")) {
        target2.x = 0;
      }
      if (!target2.hasOwnProperty("y")) {
        target2.y = 0;
      }
      if (!target2.hasOwnProperty("rotation")) {
        target2.rotation = 0;
      }
      if (prop == "rotation") {
        tween.__needsRot = true;
      }
      return prop == "guide" ? null : value;
    };
    MotionGuidePlugin.step = function(tween, prop, startValue, endValue, injectProps) {
      if (prop == "rotation") {
        tween.__rotGlobalS = startValue;
        tween.__rotGlobalE = endValue;
        MotionGuidePlugin.testRotData(tween, injectProps);
      }
      if (prop != "guide") {
        return endValue;
      }
      var temp, data = endValue;
      if (!data.hasOwnProperty("path")) {
        data.path = [];
      }
      var path = data.path;
      if (!data.hasOwnProperty("end")) {
        data.end = 1;
      }
      if (!data.hasOwnProperty("start")) {
        data.start = startValue && startValue.hasOwnProperty("end") && startValue.path === path ? startValue.end : 0;
      }
      if (data.hasOwnProperty("_segments") && data._length) {
        return endValue;
      }
      var l = path.length;
      var accuracy = 10;
      if (l >= 6 && (l - 2) % 4 == 0) {
        data._segments = [];
        data._length = 0;
        for (var i2 = 2; i2 < l; i2 += 4) {
          var sx = path[i2 - 2], sy = path[i2 - 1];
          var cx = path[i2 + 0], cy = path[i2 + 1];
          var ex = path[i2 + 2], ey = path[i2 + 3];
          var oldX = sx, oldY = sy;
          var tempX, tempY, total = 0;
          var sublines = [];
          for (var j = 1; j <= accuracy; j++) {
            var t3 = j / accuracy;
            var inv = 1 - t3;
            tempX = inv * inv * sx + 2 * inv * t3 * cx + t3 * t3 * ex;
            tempY = inv * inv * sy + 2 * inv * t3 * cy + t3 * t3 * ey;
            total += sublines[sublines.push(Math.sqrt((temp = tempX - oldX) * temp + (temp = tempY - oldY) * temp)) - 1];
            oldX = tempX;
            oldY = tempY;
          }
          data._segments.push(total);
          data._segments.push(sublines);
          data._length += total;
        }
      } else {
        throw "invalid 'path' data, please see documentation for valid paths";
      }
      temp = data.orient;
      data.orient = true;
      var o = {};
      MotionGuidePlugin.calc(data, data.start, o);
      tween.__rotPathS = Number(o.rotation.toFixed(5));
      MotionGuidePlugin.calc(data, data.end, o);
      tween.__rotPathE = Number(o.rotation.toFixed(5));
      data.orient = false;
      MotionGuidePlugin.calc(data, data.end, injectProps);
      data.orient = temp;
      if (!data.orient) {
        return endValue;
      }
      tween.__guideData = data;
      MotionGuidePlugin.testRotData(tween, injectProps);
      return endValue;
    };
    MotionGuidePlugin.testRotData = function(tween, injectProps) {
      if (tween.__rotGlobalS === void 0 || tween.__rotGlobalE === void 0) {
        if (tween.__needsRot) {
          return;
        }
        if (tween._curQueueProps.rotation !== void 0) {
          tween.__rotGlobalS = tween.__rotGlobalE = tween._curQueueProps.rotation;
        } else {
          tween.__rotGlobalS = tween.__rotGlobalE = injectProps.rotation = tween.target.rotation || 0;
        }
      }
      if (tween.__guideData === void 0) {
        return;
      }
      var data = tween.__guideData;
      var rotGlobalD = tween.__rotGlobalE - tween.__rotGlobalS;
      var rotPathD = tween.__rotPathE - tween.__rotPathS;
      var rot = rotGlobalD - rotPathD;
      if (data.orient == "auto") {
        if (rot > 180) {
          rot -= 360;
        } else if (rot < -180) {
          rot += 360;
        }
      } else if (data.orient == "cw") {
        while (rot < 0) {
          rot += 360;
        }
        if (rot == 0 && rotGlobalD > 0 && rotGlobalD != 180) {
          rot += 360;
        }
      } else if (data.orient == "ccw") {
        rot = rotGlobalD - (rotPathD > 180 ? 360 - rotPathD : rotPathD);
        while (rot > 0) {
          rot -= 360;
        }
        if (rot == 0 && rotGlobalD < 0 && rotGlobalD != -180) {
          rot -= 360;
        }
      }
      data.rotDelta = rot;
      data.rotOffS = tween.__rotGlobalS - tween.__rotPathS;
      tween.__rotGlobalS = tween.__rotGlobalE = tween.__guideData = tween.__needsRot = void 0;
    };
    MotionGuidePlugin.tween = function(tween, prop, value, startValues, endValues, ratio, wait, end) {
      var data = endValues.guide;
      if (data == void 0 || data === startValues.guide) {
        return value;
      }
      if (data.lastRatio != ratio) {
        var t3 = (data.end - data.start) * (wait ? data.end : ratio) + data.start;
        MotionGuidePlugin.calc(data, t3, tween.target);
        switch (data.orient) {
          case "cw":
          case "ccw":
          case "auto":
            tween.target.rotation += data.rotOffS + data.rotDelta * ratio;
            break;
          case "fixed":
          default:
            tween.target.rotation += data.rotOffS;
            break;
        }
        data.lastRatio = ratio;
      }
      if (prop == "rotation" && (!data.orient || data.orient == "false")) {
        return value;
      }
      return tween.target[prop];
    };
    MotionGuidePlugin.calc = function(data, ratio, target2) {
      if (data._segments == void 0) {
        throw "Missing critical pre-calculated information, please file a bug";
      }
      if (target2 == void 0) {
        target2 = { x: 0, y: 0, rotation: 0 };
      }
      var seg = data._segments;
      var path = data.path;
      var pos = data._length * ratio;
      var cap = seg.length - 2;
      var n2 = 0;
      while (pos > seg[n2] && n2 < cap) {
        pos -= seg[n2];
        n2 += 2;
      }
      var sublines = seg[n2 + 1];
      var i2 = 0;
      cap = sublines.length - 1;
      while (pos > sublines[i2] && i2 < cap) {
        pos -= sublines[i2];
        i2++;
      }
      var t3 = i2 / ++cap + pos / (cap * sublines[i2]);
      n2 = n2 * 2 + 2;
      var inv = 1 - t3;
      target2.x = inv * inv * path[n2 - 2] + 2 * inv * t3 * path[n2 + 0] + t3 * t3 * path[n2 + 2];
      target2.y = inv * inv * path[n2 - 1] + 2 * inv * t3 * path[n2 + 1] + t3 * t3 * path[n2 + 3];
      if (data.orient) {
        target2.rotation = 57.2957795 * Math.atan2(
          (path[n2 + 1] - path[n2 - 1]) * inv + (path[n2 + 3] - path[n2 + 1]) * t3,
          (path[n2 + 0] - path[n2 - 2]) * inv + (path[n2 + 2] - path[n2 + 0]) * t3
        );
      }
      return target2;
    };
    createjs2.MotionGuidePlugin = MotionGuidePlugin;
  })();
  (function() {
    var s2 = createjs2.TweenJS = createjs2.TweenJS || {};
    s2.version = /*=version*/
    "0.6.2";
    s2.buildDate = /*=date*/
    "Thu, 26 Nov 2015 20:44:31 GMT";
  })();
  module.exports = commonjsGlobal.createjs;
})(createjs$1, createjs$1.exports);
var createjsExports = createjs$1.exports;
const createjs = /* @__PURE__ */ getDefaultExportFromCjs(createjsExports);
const _position = new Vector3();
const _quaternion = new Quaternion();
const _scale = new Vector3();
class CSS3DObject extends Object3D {
  /**
   * Constructs a new CSS3D object.
   *
   * @param {DOMElement} [element] - The DOM element.
   */
  constructor(element = document.createElement("div")) {
    super();
    this.isCSS3DObject = true;
    this.element = element;
    this.element.style.position = "absolute";
    this.element.style.pointerEvents = "auto";
    this.element.style.userSelect = "none";
    this.element.setAttribute("draggable", false);
    this.addEventListener("removed", function() {
      this.traverse(function(object) {
        if (object.element instanceof object.element.ownerDocument.defaultView.Element && object.element.parentNode !== null) {
          object.element.remove();
        }
      });
    });
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.element = source.element.cloneNode(true);
    return this;
  }
}
const _matrix = new Matrix4();
const _matrix2 = new Matrix4();
class CSS3DRenderer {
  /**
   * Constructs a new CSS3D renderer.
   *
   * @param {CSS3DRenderer~Parameters} [parameters] - The parameters.
   */
  constructor(parameters = {}) {
    const _this2 = this;
    let _width, _height;
    let _widthHalf, _heightHalf;
    const cache = {
      camera: { style: "" },
      objects: /* @__PURE__ */ new WeakMap()
    };
    const domElement = parameters.element !== void 0 ? parameters.element : document.createElement("div");
    domElement.style.overflow = "hidden";
    this.domElement = domElement;
    const viewElement = document.createElement("div");
    viewElement.style.transformOrigin = "0 0";
    viewElement.style.pointerEvents = "none";
    domElement.appendChild(viewElement);
    const cameraElement = document.createElement("div");
    cameraElement.style.transformStyle = "preserve-3d";
    viewElement.appendChild(cameraElement);
    this.getSize = function() {
      return {
        width: _width,
        height: _height
      };
    };
    this.render = function(scene, camera2) {
      const fov = camera2.projectionMatrix.elements[5] * _heightHalf;
      if (camera2.view && camera2.view.enabled) {
        viewElement.style.transform = `translate( ${-camera2.view.offsetX * (_width / camera2.view.width)}px, ${-camera2.view.offsetY * (_height / camera2.view.height)}px )`;
        viewElement.style.transform += `scale( ${camera2.view.fullWidth / camera2.view.width}, ${camera2.view.fullHeight / camera2.view.height} )`;
      } else {
        viewElement.style.transform = "";
      }
      if (scene.matrixWorldAutoUpdate === true)
        scene.updateMatrixWorld();
      if (camera2.parent === null && camera2.matrixWorldAutoUpdate === true)
        camera2.updateMatrixWorld();
      let tx, ty;
      if (camera2.isOrthographicCamera) {
        tx = -(camera2.right + camera2.left) / 2;
        ty = (camera2.top + camera2.bottom) / 2;
      }
      const scaleByViewOffset = camera2.view && camera2.view.enabled ? camera2.view.height / camera2.view.fullHeight : 1;
      const cameraCSSMatrix = camera2.isOrthographicCamera ? `scale( ${scaleByViewOffset} )scale(` + fov + ")translate(" + epsilon(tx) + "px," + epsilon(ty) + "px)" + getCameraCSSMatrix(camera2.matrixWorldInverse) : `scale( ${scaleByViewOffset} )translateZ(` + fov + "px)" + getCameraCSSMatrix(camera2.matrixWorldInverse);
      const perspective = camera2.isPerspectiveCamera ? "perspective(" + fov + "px) " : "";
      const style2 = perspective + cameraCSSMatrix + "translate(" + _widthHalf + "px," + _heightHalf + "px)";
      if (cache.camera.style !== style2) {
        cameraElement.style.transform = style2;
        cache.camera.style = style2;
      }
      renderObject(scene, scene, camera2);
    };
    this.setSize = function(width, height) {
      _width = width;
      _height = height;
      _widthHalf = _width / 2;
      _heightHalf = _height / 2;
      domElement.style.width = width + "px";
      domElement.style.height = height + "px";
      viewElement.style.width = width + "px";
      viewElement.style.height = height + "px";
      cameraElement.style.width = width + "px";
      cameraElement.style.height = height + "px";
    };
    function epsilon(value) {
      return Math.abs(value) < 1e-10 ? 0 : value;
    }
    function getCameraCSSMatrix(matrix2) {
      const elements = matrix2.elements;
      return "matrix3d(" + epsilon(elements[0]) + "," + epsilon(-elements[1]) + "," + epsilon(elements[2]) + "," + epsilon(elements[3]) + "," + epsilon(elements[4]) + "," + epsilon(-elements[5]) + "," + epsilon(elements[6]) + "," + epsilon(elements[7]) + "," + epsilon(elements[8]) + "," + epsilon(-elements[9]) + "," + epsilon(elements[10]) + "," + epsilon(elements[11]) + "," + epsilon(elements[12]) + "," + epsilon(-elements[13]) + "," + epsilon(elements[14]) + "," + epsilon(elements[15]) + ")";
    }
    function getObjectCSSMatrix(matrix2) {
      const elements = matrix2.elements;
      const matrix3d = "matrix3d(" + epsilon(elements[0]) + "," + epsilon(elements[1]) + "," + epsilon(elements[2]) + "," + epsilon(elements[3]) + "," + epsilon(-elements[4]) + "," + epsilon(-elements[5]) + "," + epsilon(-elements[6]) + "," + epsilon(-elements[7]) + "," + epsilon(elements[8]) + "," + epsilon(elements[9]) + "," + epsilon(elements[10]) + "," + epsilon(elements[11]) + "," + epsilon(elements[12]) + "," + epsilon(elements[13]) + "," + epsilon(elements[14]) + "," + epsilon(elements[15]) + ")";
      return "translate(-50%,-50%)" + matrix3d;
    }
    function hideObject(object) {
      if (object.isCSS3DObject)
        object.element.style.display = "none";
      for (let i2 = 0, l = object.children.length; i2 < l; i2++) {
        hideObject(object.children[i2]);
      }
    }
    function renderObject(object, scene, camera2, cameraCSSMatrix) {
      if (object.visible === false) {
        hideObject(object);
        return;
      }
      if (object.isCSS3DObject) {
        const visible = object.layers.test(camera2.layers) === true;
        const element = object.element;
        element.style.display = visible === true ? "" : "none";
        if (visible === true) {
          object.onBeforeRender(_this2, scene, camera2);
          let style2;
          if (object.isCSS3DSprite) {
            _matrix.copy(camera2.matrixWorldInverse);
            _matrix.transpose();
            if (object.rotation2D !== 0)
              _matrix.multiply(_matrix2.makeRotationZ(object.rotation2D));
            object.matrixWorld.decompose(_position, _quaternion, _scale);
            _matrix.setPosition(_position);
            _matrix.scale(_scale);
            _matrix.elements[3] = 0;
            _matrix.elements[7] = 0;
            _matrix.elements[11] = 0;
            _matrix.elements[15] = 1;
            style2 = getObjectCSSMatrix(_matrix);
          } else {
            style2 = getObjectCSSMatrix(object.matrixWorld);
          }
          const cachedObject = cache.objects.get(object);
          if (cachedObject === void 0 || cachedObject.style !== style2) {
            element.style.transform = style2;
            const objectData = { style: style2 };
            cache.objects.set(object, objectData);
          }
          if (element.parentNode !== cameraElement) {
            cameraElement.appendChild(element);
          }
          object.onAfterRender(_this2, scene, camera2);
        }
      }
      for (let i2 = 0, l = object.children.length; i2 < l; i2++) {
        renderObject(object.children[i2], scene, camera2);
      }
    }
  }
}
class CSS2DObject extends Object3D {
  /**
   * Constructs a new CSS2D object.
   *
   * @param {DOMElement} [element] - The DOM element.
   */
  constructor(element = document.createElement("div")) {
    super();
    this.isCSS2DObject = true;
    this.element = element;
    this.element.style.position = "absolute";
    this.element.style.userSelect = "none";
    this.element.setAttribute("draggable", false);
    this.center = new Vector2(0.5, 0.5);
    this.addEventListener("removed", function() {
      this.traverse(function(object) {
        if (object.element instanceof object.element.ownerDocument.defaultView.Element && object.element.parentNode !== null) {
          object.element.remove();
        }
      });
    });
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.element = source.element.cloneNode(true);
    this.center = source.center;
    return this;
  }
}
const _vector = new Vector3();
const _viewMatrix = new Matrix4();
const _viewProjectionMatrix = new Matrix4();
const _a = new Vector3();
const _b = new Vector3();
class CSS2DRenderer {
  /**
   * Constructs a new CSS2D renderer.
   *
   * @param {CSS2DRenderer~Parameters} [parameters] - The parameters.
   */
  constructor(parameters = {}) {
    const _this2 = this;
    let _width, _height;
    let _widthHalf, _heightHalf;
    const cache = {
      objects: /* @__PURE__ */ new WeakMap()
    };
    const domElement = parameters.element !== void 0 ? parameters.element : document.createElement("div");
    domElement.style.overflow = "hidden";
    this.domElement = domElement;
    this.getSize = function() {
      return {
        width: _width,
        height: _height
      };
    };
    this.render = function(scene, camera2) {
      if (scene.matrixWorldAutoUpdate === true)
        scene.updateMatrixWorld();
      if (camera2.parent === null && camera2.matrixWorldAutoUpdate === true)
        camera2.updateMatrixWorld();
      _viewMatrix.copy(camera2.matrixWorldInverse);
      _viewProjectionMatrix.multiplyMatrices(camera2.projectionMatrix, _viewMatrix);
      renderObject(scene, scene, camera2);
      zOrder(scene);
    };
    this.setSize = function(width, height) {
      _width = width;
      _height = height;
      _widthHalf = _width / 2;
      _heightHalf = _height / 2;
      domElement.style.width = width + "px";
      domElement.style.height = height + "px";
    };
    function hideObject(object) {
      if (object.isCSS2DObject)
        object.element.style.display = "none";
      for (let i2 = 0, l = object.children.length; i2 < l; i2++) {
        hideObject(object.children[i2]);
      }
    }
    function renderObject(object, scene, camera2) {
      if (object.visible === false) {
        hideObject(object);
        return;
      }
      if (object.isCSS2DObject) {
        _vector.setFromMatrixPosition(object.matrixWorld);
        _vector.applyMatrix4(_viewProjectionMatrix);
        const visible = _vector.z >= -1 && _vector.z <= 1 && object.layers.test(camera2.layers) === true;
        const element = object.element;
        element.style.display = visible === true ? "" : "none";
        if (visible === true) {
          object.onBeforeRender(_this2, scene, camera2);
          element.style.transform = "translate(" + -100 * object.center.x + "%," + -100 * object.center.y + "%)translate(" + (_vector.x * _widthHalf + _widthHalf) + "px," + (-_vector.y * _heightHalf + _heightHalf) + "px)";
          if (element.parentNode !== domElement) {
            domElement.appendChild(element);
          }
          object.onAfterRender(_this2, scene, camera2);
        }
        const objectData = {
          distanceToCameraSquared: getDistanceToSquared(camera2, object)
        };
        cache.objects.set(object, objectData);
      }
      for (let i2 = 0, l = object.children.length; i2 < l; i2++) {
        renderObject(object.children[i2], scene, camera2);
      }
    }
    function getDistanceToSquared(object1, object2) {
      _a.setFromMatrixPosition(object1.matrixWorld);
      _b.setFromMatrixPosition(object2.matrixWorld);
      return _a.distanceToSquared(_b);
    }
    function filterAndFlatten(scene) {
      const result2 = [];
      scene.traverseVisible(function(object) {
        if (object.isCSS2DObject)
          result2.push(object);
      });
      return result2;
    }
    function zOrder(scene) {
      const sorted = filterAndFlatten(scene).sort(function(a, b) {
        if (a.renderOrder !== b.renderOrder) {
          return b.renderOrder - a.renderOrder;
        }
        const distanceA = cache.objects.get(a).distanceToCameraSquared;
        const distanceB = cache.objects.get(b).distanceToCameraSquared;
        return distanceA - distanceB;
      });
      const zMax = sorted.length;
      for (let i2 = 0, l = sorted.length; i2 < l; i2++) {
        sorted[i2].element.style.zIndex = zMax - i2;
      }
    }
  }
}
class BillboardComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "root", null);
    __publicField(this, "mesh", null);
    __publicField(this, "geometory", null);
    __publicField(this, "material", null);
    __publicField(this, "texture", null);
    __publicField(this, "loader", null);
    __publicField(this, "inputs", {
      localName: "",
      localPosition: { x: 0, y: 0, z: 0 },
      localScale: { x: 1, y: 1 },
      url: ""
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    const THREE = this.context.three;
    this.root = new THREE.Object3D();
    this.outputs.objectRoot = this.root;
    this.outputs.collider = this.root;
    this.material = new THREE.MeshBasicMaterial({ transparent: true });
    this.loader = new THREE.TextureLoader();
    if (this.inputs.url) {
      this.loadTexture();
    }
    this.geometory = new THREE.PlaneGeometry();
    this.mesh = new THREE.Mesh(this.geometory, this.material);
    this.root.position.set(this.inputs.localPosition.x, this.inputs.localPosition.y, this.inputs.localPosition.z);
    this.root.scale.set(this.inputs.localScale.x, this.inputs.localScale.y, 1);
    this.mesh.renderOrder = 1;
    this.root.add(this.mesh);
  }
  onEvent(type, data) {
    if (type === ComponentInteractionType.CLICK) {
      this.notify(ComponentInteractionType.CLICK, {
        type,
        node: this.context.root,
        component: this
      });
    }
    if (type === ComponentInteractionType.HOVER) {
      this.notify(ComponentInteractionType.HOVER, {
        hover: data.hover
      });
    }
  }
  onInputsUpdated(_previous) {
    if (this.inputs.url) {
      this.loadTexture();
    }
  }
  onTick(_tickDelta) {
    this.mesh.rotation.setFromRotationMatrix(this.context.camera.matrix);
  }
  onDestroy() {
    this.root.remove(this.mesh);
    this.geometory.dispose();
    this.material.dispose();
    this.texture.dispose();
  }
  loadTexture() {
    return __async(this, null, function* () {
      this.loader.load(this.inputs.url, (texture) => {
        this.texture = texture;
        this.material.map = this.texture;
        this.material.needsUpdate = true;
      });
    });
  }
}
const billboardType = "dpm.billboard";
const billboardFactory = () => {
  return new BillboardComponent();
};
class FaceComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "THREE", null);
    __publicField(this, "root", null);
    __publicField(this, "scene", null);
    __publicField(this, "nameMesh", null);
    __publicField(this, "targetPos", null);
    __publicField(this, "targetPosDistance", null);
    __publicField(this, "targetRot", null);
    __publicField(this, "targetRotDistance", null);
    __publicField(this, "inputs", {
      componentId: "",
      name: "Guest",
      num: 0,
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0 },
      scale: { x: 1, y: 1, z: 1 },
      url: ""
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    this.THREE = this.context.three;
    this.root = new this.THREE.Object3D();
    this.context.scene.add(this.root);
    this.outputs.objectRoot = this.root;
    this.outputs.collider = this.root;
    new this.THREE.GLTFLoader().load(this.inputs.url, (gltf) => {
      this.scene = gltf.scene || gltf.scenes[0];
      this.scene.children[0].applyMatrix4(new this.THREE.Matrix4().makeTranslation(0, -0.5, 0));
      this.root.add(this.scene);
      this.nameMesh = createTextMesh(this.THREE, this.inputs.name, 0.1, 0.15, 100);
      this.nameMesh.position.set(0, 0.35, 0);
      this.root.add(this.nameMesh);
    });
  }
  setInputs() {
    const euler = new this.THREE.Euler(this.THREE.MathUtils.degToRad(this.inputs.rotation.x), this.THREE.MathUtils.degToRad(this.inputs.rotation.y), 0, "YXZ");
    const quaternion = new this.THREE.Quaternion().setFromEuler(euler);
    this.scene.rotation.setFromQuaternion(quaternion);
    this.root.position.set(
      this.inputs.position.x + 0.6 * Math.cos(Math.PI / 6 * this.inputs.num),
      this.inputs.position.y + 0.15,
      this.inputs.position.z + 0.6 * Math.sin(Math.PI / 6 * this.inputs.num)
    );
    this.root.scale.set(this.inputs.scale.x, this.inputs.scale.y, this.inputs.scale.z);
  }
  onEvent(type, data) {
  }
  onInputsUpdated(previous) {
  }
  onUpdatePosition(pos) {
    this.targetPos = { position: pos };
    this.targetPosDistance = new this.THREE.Vector3(
      pos.x - this.inputs.position.x,
      pos.y - this.inputs.position.y,
      pos.z - this.inputs.position.z
    );
  }
  onUpdateRotation(rot) {
    this.targetRot = { rotation: rot };
    this.targetRotDistance = new this.THREE.Vector3(
      rot.x - this.inputs.rotation.x,
      rot.y - this.inputs.rotation.y
    );
  }
  onTick(tickDelta) {
    if (!this.root || this.root.children.length < 2) {
      return;
    }
    if (this.targetPos) {
      this.inputs.position.x += this.targetPosDistance.x * 1e-3 * tickDelta;
      this.inputs.position.y += this.targetPosDistance.y * 1e-3 * tickDelta;
      this.inputs.position.z += this.targetPosDistance.z * 1e-3 * tickDelta;
      if (this.targetPosDistance.x >= 0 && this.inputs.position.x > this.targetPos.position.x || this.targetPosDistance.x < 0 && this.inputs.position.x < this.targetPos.position.x) {
        _merge(this.inputs, this.targetPos);
        this.targetPos = null;
      }
    }
    if (this.targetRot) {
      this.inputs.rotation.x += this.targetRotDistance.x * 0.01 * tickDelta;
      this.inputs.rotation.y += this.targetRotDistance.y * 0.01 * tickDelta;
      if (this.targetRotDistance.x >= 0 && this.inputs.rotation.x > this.targetRot.rotation.x || this.targetRotDistance.x < 0 && this.inputs.rotation.x < this.targetRot.rotation.x) {
        _merge(this.inputs, this.targetRot);
        this.targetRot = null;
      }
    }
    this.setInputs();
    this.nameMesh.rotation.setFromRotationMatrix(this.context.camera.matrix);
  }
  onDestroy() {
    this.nameMesh.geometry.dispose();
    this.root.remove(this.nameMesh);
    this.root.remove(this.scene);
    this.root.parent.remove(this.root);
  }
}
const faceType = "dpm.face";
const faceFactory = () => {
  return new FaceComponent();
};
function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index2-- : ++index2 < length) {
    if (predicate(array[index2], index2, array)) {
      return index2;
    }
  }
  return -1;
}
var _baseFindIndex = baseFindIndex$1;
function baseIsNaN$1(value) {
  return value !== value;
}
var _baseIsNaN = baseIsNaN$1;
function strictIndexOf$1(array, value, fromIndex) {
  var index2 = fromIndex - 1, length = array.length;
  while (++index2 < length) {
    if (array[index2] === value) {
      return index2;
    }
  }
  return -1;
}
var _strictIndexOf = strictIndexOf$1;
var baseFindIndex = _baseFindIndex, baseIsNaN = _baseIsNaN, strictIndexOf = _strictIndexOf;
function baseIndexOf$1(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
var _baseIndexOf = baseIndexOf$1;
var baseIndexOf = _baseIndexOf;
function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}
var _arrayIncludes = arrayIncludes$1;
function arrayIncludesWith$1(array, value, comparator) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (comparator(value, array[index2])) {
      return true;
    }
  }
  return false;
}
var _arrayIncludesWith = arrayIncludesWith$1;
function noop$1() {
}
var noop_1 = noop$1;
var Set$1 = _Set, noop = noop_1, setToArray$1 = _setToArray;
var INFINITY$1 = 1 / 0;
var createSet$1 = !(Set$1 && 1 / setToArray$1(new Set$1([, -0]))[1] == INFINITY$1) ? noop : function(values2) {
  return new Set$1(values2);
};
var _createSet = createSet$1;
var SetCache = _SetCache, arrayIncludes = _arrayIncludes, arrayIncludesWith = _arrayIncludesWith, cacheHas = _cacheHas, createSet = _createSet, setToArray = _setToArray;
var LARGE_ARRAY_SIZE = 200;
function baseUniq$2(array, iteratee, comparator) {
  var index2 = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
  if (comparator) {
    isCommon = false;
    includes2 = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set2 = iteratee ? null : createSet(array);
    if (set2) {
      return setToArray(set2);
    }
    isCommon = false;
    includes2 = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result2;
  }
  outer:
    while (++index2 < length) {
      var value = array[index2], computed2 = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed2 === computed2) {
        var seenIndex = seen.length;
        while (seenIndex--) {
          if (seen[seenIndex] === computed2) {
            continue outer;
          }
        }
        if (iteratee) {
          seen.push(computed2);
        }
        result2.push(value);
      } else if (!includes2(seen, computed2, comparator)) {
        if (seen !== result2) {
          seen.push(computed2);
        }
        result2.push(value);
      }
    }
  return result2;
}
var _baseUniq = baseUniq$2;
var baseUniq$1 = _baseUniq;
function uniqWith(array, comparator) {
  comparator = typeof comparator == "function" ? comparator : void 0;
  return array && array.length ? baseUniq$1(array, void 0, comparator) : [];
}
var uniqWith_1 = uniqWith;
const _uniqWith = /* @__PURE__ */ getDefaultExportFromCjs(uniqWith_1);
class fileLoaderComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "root", null);
    __publicField(this, "mixer");
    __publicField(this, "boneList", []);
    __publicField(this, "model");
    __publicField(this, "inputs", {
      bones: {},
      localName: "",
      localPosition: { x: 0, y: 0, z: 0 },
      localScale: { x: 1, y: 1, z: 1 },
      localRotation: { x: 0, y: 0, z: 0 },
      url: ""
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    return __async(this, null, function* () {
      const sdkThree = this.context.three;
      const rotation = new Vector3(
        MathUtils.degToRad(this.inputs.localRotation.x),
        MathUtils.degToRad(this.inputs.localRotation.y),
        MathUtils.degToRad(this.inputs.localRotation.z)
      );
      this.root = new sdkThree.Object3D();
      this.root.rotation.set(rotation.x, rotation.y, rotation.z);
      this.root.position.set(this.inputs.localPosition.x, this.inputs.localPosition.y, this.inputs.localPosition.z);
      this.root.scale.set(this.inputs.localScale.x, this.inputs.localScale.y, this.inputs.localScale.z);
      this.outputs.objectRoot = this.root;
      this.outputs.collider = this.root;
      const getBoneHierarchy = (rootBone) => {
        return {
          name: rootBone.name,
          children: rootBone.children.filter((child) => child.isBone).map((child) => getBoneHierarchy(child))
        };
      };
      const setBoneList = () => {
        const rootBones = [];
        this.model.traverse((object) => {
          if (object.isSkinnedMesh && object.skeleton) {
            const bones = object.skeleton.bones;
            rootBones.push(...bones.filter((bone) => !bones.includes(bone.parent)));
          }
        });
        _uniqWith(rootBones, _isEqual).forEach((root2) => this.boneList.push(getBoneHierarchy(root2)));
      };
      const setBoneData = () => {
        Object.keys(this.inputs.bones).forEach((boneName) => {
          const bone = this.model.getObjectByName(boneName);
          const boneData = this.inputs.bones[boneName];
          bone.position.set(boneData.position.x, boneData.position.y, boneData.position.z);
          bone.rotation.set(MathUtils.degToRad(boneData.rotation.x), MathUtils.degToRad(boneData.rotation.y), MathUtils.degToRad(boneData.rotation.z));
          bone.scale.set(boneData.scale.x, boneData.scale.y, boneData.scale.z);
        });
      };
      if (!this.inputs.url)
        return;
      const splited_url = this.inputs.url.split(".");
      const ext = splited_url[splited_url.length - 1];
      switch (ext) {
        case "fbx":
          new sdkThree.FBXLoader().load(this.inputs.url, (fbx) => {
            this.model = fbx;
            const clips = fbx.animations || [];
            fbx.scale.set(0.01, 0.01, 0.01);
            setBoneList();
            setBoneData();
            if (clips.length) {
              this.mixer = new AnimationMixer(fbx);
              this.mixer.clipAction(clips[0]).reset().play();
            }
            this.root.add(fbx);
          });
          break;
        case "glb":
        case "gltf":
          new sdkThree.GLTFLoader().load(this.inputs.url, (gltf) => {
            this.model = gltf.scene || gltf.scenes[0];
            const clips = gltf.animations || [];
            setBoneList();
            setBoneData();
            if (clips.length) {
              this.mixer = new AnimationMixer(this.model);
              this.mixer.clipAction(clips[0]).reset().play();
            }
            this.root.add(this.model);
          });
          break;
        case "obj":
          new sdkThree.OBJLoader().load(this.inputs.url, (obj) => {
            this.root.add(obj);
          });
          break;
      }
    });
  }
  getBoneList() {
    return this.boneList;
  }
  getBone(name) {
    return this.model.getObjectByName(name);
  }
  onEvent(_type, _data) {
  }
  onInputsUpdated(_previous) {
  }
  onTick(tickDelta) {
    if (this.mixer) {
      this.mixer.update(tickDelta / 1e3);
    }
  }
  onDestroy() {
    this.root.children.forEach((scene) => {
      scene.traverse((child) => {
        var _a2, _b2;
        if (child.isMesh) {
          (_a2 = child.geometry) == null ? void 0 : _a2.dispose();
          if ((_b2 = child.material) == null ? void 0 : _b2.isMaterial) {
            child.material.dispose();
          } else if (Array.isArray(child.material)) {
            child.material.forEach((mtrl) => mtrl.dispose());
          }
        }
        this.root.remove(child);
      });
      this.root.remove(scene);
    });
  }
}
const fileLoaderType = "dpm.fileLoader";
const fileLoaderFactory = () => {
  return new fileLoaderComponent();
};
class FixPositionComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "THREE");
    __publicField(this, "root", null);
    __publicField(this, "rootGeometry", null);
    __publicField(this, "rootMesh", null);
    __publicField(this, "geometry", null);
    __publicField(this, "meshes", []);
    __publicField(this, "inputs", {
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0 },
      scale: { x: 1, y: 1, z: 1 },
      data: []
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    this.THREE = this.context.three;
    this.root = new this.THREE.Object3D();
    this.outputs.objectRoot = this.root;
    this.outputs.collider = this.root;
    const material = new this.THREE.MeshBasicMaterial({
      transparent: true,
      opacity: 0.8,
      side: this.THREE.DoubleSide
    });
    this.rootGeometry = new this.THREE.BoxGeometry();
    this.rootMesh = new this.THREE.Mesh(this.rootGeometry, material);
    this.root.add(this.rootMesh);
    this.geometry = new this.THREE.SphereGeometry(0.15, 16, 16);
    this.inputs.data.forEach((child) => {
      const material2 = new this.THREE.MeshBasicMaterial({
        color: new Color$2(toHex(child.color)),
        transparent: true,
        opacity: 0.8
      });
      const mesh = new this.THREE.Mesh(this.geometry, material2);
      mesh.isObject = child.isObject;
      mesh.sid = child.sid;
      mesh.position.set(child.anchorPosition.x, child.anchorPosition.y, child.anchorPosition.z);
      this.root.add(mesh);
      this.meshes.push(mesh);
    });
  }
  onEvent(type, data) {
    if (type === ComponentInteractionType.CLICK) {
      this.notify(ComponentInteractionType.CLICK, {
        type,
        node: this.context.root,
        component: this
      });
    }
    if (type === ComponentInteractionType.HOVER) {
      this.notify(ComponentInteractionType.HOVER, {
        hover: data.hover
      });
    }
  }
  onInputsUpdated(_previous) {
  }
  onTick(_tickDelta) {
  }
  onDestroy() {
    this.meshes.forEach((mesh) => {
      mesh.geometry.dispose();
      mesh.material.dispose();
      this.root.remove(mesh);
    });
    this.rootMesh.geometry.dispose();
    this.rootMesh.material.dispose();
    this.root.remove(this.rootMesh);
  }
}
const fixPositionType = "dpm.fixPosition";
const fixPositionFactory = () => {
  return new FixPositionComponent();
};
class GazeLineComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "THREE", null);
    __publicField(this, "root", null);
    __publicField(this, "geometry", null);
    __publicField(this, "material", null);
    __publicField(this, "mesh", null);
    __publicField(this, "targetPos", null);
    __publicField(this, "inputs", {
      componentId: "",
      num: 0,
      position: { x: 0, y: 0, z: 0 }
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    this.THREE = this.context.three;
    this.root = new this.THREE.Object3D();
    this.context.scene.add(this.root);
    this.outputs.objectRoot = this.root;
    this.outputs.collider = this.root;
    const colorNames2 = ["red", "blue", "green", "cyan", "magenta", "yellow", "pink", "lime", "indigo", "white", "goldenrod", "brown"];
    const colorName2 = this.inputs.num < 12 ? colorNames2[this.inputs.num] : colorNames2[this.inputs.num % 12];
    const color2 = new this.THREE.Color(colorName2);
    const indices = [0, 1, 2, 3, 0, 2, 3, 1, 0, 3, 2, 1];
    this.geometry = new this.THREE.BufferGeometry();
    this.geometry.setFromPoints(this.createVertices());
    this.geometry.setIndex(indices);
    this.material = new this.THREE.MeshBasicMaterial({
      color: color2,
      opacity: 0.5,
      side: this.THREE.DoubleSide,
      transparent: true
    });
    this.mesh = new this.THREE.Mesh(this.geometry, this.material);
    this.mesh.frustumCulled = false;
    this.root.add(this.mesh);
    this.setPosition();
  }
  createVertices() {
    if (!this.targetPos) {
      this.targetPos = new this.THREE.Vector3(this.inputs.position.x, this.inputs.position.y, this.inputs.position.z + 1);
    }
    const distance = Math.sqrt(
      Math.pow(Math.abs(this.targetPos.z - this.inputs.position.z), 2) + Math.pow(Math.abs(this.targetPos.x - this.inputs.position.x), 2) + Math.pow(Math.abs(this.targetPos.y - this.inputs.position.y), 2)
    );
    return [
      new this.THREE.Vector3(0, 0.015, 0),
      new this.THREE.Vector3(-0.015, -0.015, 0),
      new this.THREE.Vector3(0.015, -0.015, 0),
      new this.THREE.Vector3(0, 0, distance)
    ];
  }
  setPosition() {
    this.geometry.setFromPoints(this.createVertices());
    this.geometry.attributes.position.needsUpdate = true;
    this.root.position.set(
      this.inputs.position.x + 0.6 * Math.cos(Math.PI / 6 * this.inputs.num),
      this.inputs.position.y,
      this.inputs.position.z + 0.6 * Math.sin(Math.PI / 6 * this.inputs.num)
    );
  }
  onEvent(type, data) {
  }
  onInputsUpdated(previous) {
  }
  onUpdatePosition(pos) {
    this.inputs.position = pos;
    this.setPosition();
  }
  onUpdateTarget(target2) {
    this.targetPos = target2.position;
    this.mesh.lookAt(this.targetPos.x, this.targetPos.y, this.targetPos.z);
    this.setPosition();
  }
  onTick(tickDelta) {
  }
  onDestroy() {
    this.root.remove(this.mesh);
    this.geometry.dispose();
    this.material.dispose();
    this.root.parent.remove(this.root);
  }
}
const gazeLineType = "dpm.gazeline";
const gazeLineFactory = () => {
  return new GazeLineComponent();
};
class PrimitiveComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "THREE");
    __publicField(this, "root", null);
    __publicField(this, "mesh", null);
    __publicField(this, "label");
    __publicField(this, "lineLabels", []);
    __publicField(this, "edgeLine");
    __publicField(this, "inputs", {
      color: "#FFFFFF",
      endPosition: { x: 0, y: 0, z: 0 },
      linePoints: [{ x: 0, y: 0, z: 0 }, { x: 0, y: 0, z: 0 }],
      linewidth: 2,
      localName: "",
      localPosition: { x: 0, y: 0, z: 0 },
      localRotation: { x: 0, y: 0, z: 0 },
      localScale: { x: 1, y: 1, z: 1 },
      opacity: 1,
      type: "box"
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    this.THREE = this.context.three;
    this.root = new this.THREE.Object3D();
    this.outputs.objectRoot = this.root;
    this.outputs.collider = this.root;
    const rotation = new this.THREE.Vector3(
      this.THREE.MathUtils.degToRad(this.inputs.localRotation.x),
      this.THREE.MathUtils.degToRad(this.inputs.localRotation.y),
      this.THREE.MathUtils.degToRad(this.inputs.localRotation.z)
    );
    this.root.position.set(this.inputs.localPosition.x, this.inputs.localPosition.y, this.inputs.localPosition.z);
    this.root.rotation.set(rotation.x, rotation.y, rotation.z);
    this.root.scale.set(this.inputs.localScale.x, this.inputs.localScale.y, this.inputs.localScale.z);
    let geometry;
    let material;
    material = new this.THREE.MeshBasicMaterial({
      transparent: true,
      opacity: this.inputs.opacity,
      color: new Color$2(this.inputs.color),
      side: this.THREE.DoubleSide
    });
    const loadGltf = (url) => {
      new this.THREE.GLTFLoader().load(url, (gltf) => {
        this.mesh = gltf.scene.children[0];
        this.mesh.material = material;
        this.mesh.renderOrder = 1;
        this.root.add(this.mesh);
        const edges = new this.THREE.EdgesGeometry(this.mesh.geometry);
        const lineGeometry = new this.THREE.LineSegmentsGeometry();
        lineGeometry.setPositions(edges.attributes.position.array);
        const lineMaterial = new this.THREE.LineMaterial({
          color: 0,
          linewidth: 5e-3,
          worldUnits: true
        });
        const edgeLine = new this.THREE.LineSegments2(lineGeometry, lineMaterial);
        edgeLine.scale.set(1.0025, 1.0025, 1.0025);
        this.root.add(edgeLine);
      });
    };
    switch (this.inputs.type) {
      case "Box":
        geometry = new this.THREE.BoxGeometry();
        break;
      case "Capsule":
        geometry = new this.THREE.CapsuleGeometry();
        break;
      case "Circle":
        geometry = new this.THREE.CircleGeometry();
        break;
      case "Cone":
        geometry = new this.THREE.ConeGeometry();
        break;
      case "Cylinder":
        geometry = new this.THREE.CylinderGeometry();
        break;
      case "Dodecahedron":
        geometry = new this.THREE.DodecahedronGeometry();
        break;
      case "Icosahedron":
        geometry = new this.THREE.IcosahedronGeometry();
        break;
      case "Octahedron":
        geometry = new this.THREE.OctahedronGeometry();
        break;
      case "Plane":
        geometry = new this.THREE.PlaneGeometry();
        break;
      case "Ring":
        geometry = new this.THREE.RingGeometry();
        break;
      case "Sphere":
        geometry = new this.THREE.SphereGeometry();
        break;
      case "Tetrahedron":
        geometry = new this.THREE.TetrahedronGeometry();
        break;
      case "Torus":
        geometry = new this.THREE.TorusGeometry();
        break;
      case "TorusKnot":
        geometry = new this.THREE.TorusKnotGeometry();
        break;
      case "TriangularPrism1":
        loadGltf("/virtual-staging/models/triangular-prism1.glb");
        break;
      case "TriangularPrism2":
        loadGltf("/virtual-staging/models/triangular-prism2.glb");
        break;
      case "Line":
        if (this.inputs.endPosition.x !== 0 || this.inputs.endPosition.y !== 0 || this.inputs.endPosition.z !== 0) {
          this.inputs.linePoints = [
            { x: 0, y: 0, z: 0 },
            { x: this.inputs.endPosition.x, y: this.inputs.endPosition.y, z: this.inputs.endPosition.z }
          ];
        }
        geometry = new this.THREE.LineGeometry();
        geometry.setPositions(this.inputs.linePoints.flatMap((p) => [p.x, p.y, p.z]));
        material = new this.THREE.LineMaterial({
          color: this.inputs.color || 0,
          linewidth: this.inputs.linewidth / 100 || 0.02,
          worldUnits: true
        });
        break;
    }
    if (geometry) {
      if (this.inputs.type !== "Line") {
        this.mesh = new this.THREE.Mesh(geometry, material);
        this.mesh.position.set(0.5, 0.5, -0.5);
        if (this.inputs.type === "Plane") {
          this.mesh.position.set(0.5, 0.5, 0);
        }
        const edges = new this.THREE.EdgesGeometry(geometry);
        const lineGeometry = new this.THREE.LineSegmentsGeometry();
        lineGeometry.setPositions(edges.attributes.position.array);
        const lineMaterial = new this.THREE.LineMaterial({
          color: 0,
          linewidth: 5e-3,
          worldUnits: true
        });
        this.edgeLine = new this.THREE.LineSegments2(lineGeometry, lineMaterial);
        this.edgeLine.scale.set(1.0025, 1.0025, 1.0025);
        this.edgeLine.position.set(0.5, 0.5, -0.5);
        if (this.inputs.type === "Plane") {
          this.edgeLine.position.set(0.5, 0.5, 0);
        }
        this.root.add(this.edgeLine);
      } else {
        this.mesh = new this.THREE.Line2(geometry, material);
      }
      this.mesh.renderOrder = 1;
      this.root.add(this.mesh);
      if (this.inputs.type === "Box" || this.inputs.type === "Plane") {
        const label = this.createLabel();
        window.css2dScene.add(label);
        this.label = label;
        this.updateLabel({ x: 1, y: 1, z: 1 });
      } else if (this.inputs.type === "Line") {
        for (let i2 = 0; i2 < this.inputs.linePoints.length - 1; i2++) {
          const label = this.createLabel(i2);
          window.css2dScene.add(label);
          this.lineLabels.push(label);
        }
        this.updateLabel({ x: 1, y: 1, z: 1 });
      }
    }
  }
  createLabel(index2 = 0) {
    const div = document.createElement("div");
    div.style.color = "black";
    div.style.backgroundColor = "white";
    const label = new CSS2DObject(div);
    label.element.classList.add("css-2d-object-label");
    const position = this.calcCenter(index2);
    label.position.set(position.x, position.y, position.z);
    return label;
  }
  calcCenter(index2 = 0) {
    if (this.inputs.type === "Line") {
      const vectorA = new this.THREE.Vector3(this.inputs.linePoints[index2].x, this.inputs.linePoints[index2].y, this.inputs.linePoints[index2].z);
      const vectorB = new this.THREE.Vector3(this.inputs.linePoints[index2 + 1].x, this.inputs.linePoints[index2 + 1].y, this.inputs.linePoints[index2 + 1].z);
      const worldPositionA = vectorA.clone().applyMatrix4(this.mesh.matrixWorld);
      const worldPositionB = vectorB.clone().applyMatrix4(this.mesh.matrixWorld);
      return new this.THREE.Vector3().addVectors(worldPositionA, worldPositionB).multiplyScalar(0.5);
    } else {
      const box = new this.THREE.Box3().setFromObject(this.mesh);
      const center = new this.THREE.Vector3();
      box.getCenter(center);
      return center;
    }
  }
  onEvent(type, data) {
    if (type === ComponentInteractionType.CLICK) {
      this.notify(ComponentInteractionType.CLICK, {
        type,
        node: this.context.root,
        component: this
      });
    }
    if (type === ComponentInteractionType.HOVER) {
      this.notify(ComponentInteractionType.HOVER, {
        hover: data.hover
      });
    }
  }
  onInputsUpdated(_previous) {
    if (this.inputs.type !== "Line") {
      this.mesh.material.opacity = this.inputs.opacity;
      this.mesh.material.color = new Color$2(this.inputs.color);
    } else {
      this.mesh.material.linewidth = this.inputs.linewidth / 100;
      this.mesh.material.color = new Color$2(this.inputs.color);
    }
  }
  updateLabel(scale) {
    const scaleX = scale.x * this.inputs.localScale.x;
    const scaleY = scale.y * this.inputs.localScale.y;
    const scaleZ = scale.z * this.inputs.localScale.z;
    if (this.label) {
      switch (this.inputs.type) {
        case "Box":
          const volume = Math.abs(scaleX * scaleY * scaleZ).toFixed(3).toString();
          this.label.element.innerHTML = `${volume.replace(/(\.0+|0+)$/, "")} m&sup3;`;
          break;
        case "Plane":
          const area = Math.abs(scaleX * scaleY).toFixed(3).toString();
          this.label.element.innerHTML = `${area.replace(/(\.0+|0+)$/, "")} m&sup2;`;
          break;
      }
    } else if (this.lineLabels.length) {
      const scaleVector = new this.THREE.Vector3(scaleX, scaleY, scaleZ);
      for (let i2 = 0; i2 < this.lineLabels.length; i2++) {
        const point1 = new this.THREE.Vector3(this.inputs.linePoints[i2].x, this.inputs.linePoints[i2].y, this.inputs.linePoints[i2].z).multiply(scaleVector);
        const point2 = new this.THREE.Vector3(this.inputs.linePoints[i2 + 1].x, this.inputs.linePoints[i2 + 1].y, this.inputs.linePoints[i2 + 1].z).multiply(scaleVector);
        const distance = point1.distanceTo(point2);
        this.lineLabels[i2].element.innerHTML = `${distance.toFixed(3).toString().replace(/(\.0+|0+)$/, "")} m`;
      }
    }
  }
  updateLine(position, confirm2) {
    if (confirm2) {
      this.inputs.linePoints.push(position);
      const label = this.createLabel(this.inputs.linePoints.length - 2);
      window.css2dScene.add(label);
      this.lineLabels.push(label);
      this.mesh.geometry.dispose();
      this.mesh.geometry = new this.THREE.LineGeometry();
    } else {
      this.inputs.linePoints[this.inputs.linePoints.length - 1] = position;
    }
    this.mesh.geometry.setPositions(this.inputs.linePoints.flatMap((p) => [p.x, p.y, p.z]));
    this.mesh.computeLineDistances();
    this.updateLabel({ x: this.root.parent.scale.x, y: this.root.parent.scale.y, z: this.root.parent.scale.z });
  }
  lineCreationCompleted() {
    this.inputs.linePoints.pop();
    this.mesh.geometry.dispose();
    this.mesh.geometry = new this.THREE.LineGeometry();
    this.mesh.geometry.setPositions(this.inputs.linePoints.flatMap((p) => [p.x, p.y, p.z]));
    this.mesh.computeLineDistances();
    window.css2dScene.remove(this.lineLabels.pop());
    return this.inputs.linePoints.length;
  }
  onTick(_tickDelta) {
    if (this.label) {
      const position = this.calcCenter();
      this.label.position.set(position.x, position.y, position.z);
    }
    for (let i2 = 0; i2 < this.lineLabels.length; i2++) {
      const position = this.calcCenter(i2);
      this.lineLabels[i2].position.set(position.x, position.y, position.z);
    }
  }
  onDestroy() {
    this.mesh.geometry.dispose();
    this.mesh.material.dispose();
    if (this.edgeLine) {
      this.edgeLine.geometry.dispose();
      this.edgeLine.material.dispose();
    }
    if (this.label) {
      window.css2dScene.remove(this.label);
    }
    for (const label of this.lineLabels) {
      window.css2dScene.remove(label);
    }
    this.root.remove(this.mesh);
  }
}
const primitiveType = "dpm.primitive";
const primitiveFactory = () => {
  return new PrimitiveComponent();
};
class SweepComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "root", null);
    __publicField(this, "inputs", {
      position: { x: 0, y: 0, z: 0 },
      scale: { x: 1, y: 1 },
      svgTag: null,
      degree: 0
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    const THREE = this.context.three;
    this.root = new THREE.Object3D();
    this.outputs.objectRoot = this.root;
    this.outputs.collider = this.root;
    const svgLoader = new THREE.SVGLoader();
    const svgData = svgLoader.parse(this.inputs.svgTag);
    const svgGroup = new THREE.Group();
    svgData.paths.forEach((path, _i2) => {
      const shapes = THREE.SVGLoader.createShapes(path);
      const fillColor = Color$1(path.userData.style.fill);
      shapes.forEach((shape, _j) => {
        const material = new THREE.MeshBasicMaterial({
          // color: new THREE.Color().setStyle(fillColor.hex()).convertSRGBToLinear(),
          color: new THREE.Color().setStyle(fillColor.hex()),
          opacity: fillColor.valpha,
          side: THREE.DoubleSide,
          depthWrite: false,
          transparent: true
        });
        const geometry = new THREE.ShapeGeometry(shape);
        const mesh = new THREE.Mesh(geometry, material);
        const fixCentering = -(12 / 90);
        mesh.position.set(fixCentering, fixCentering, 0);
        mesh.renderOrder = _i2;
        svgGroup.add(mesh);
      });
    });
    this.root.scale.set(1, 1, 1);
    svgGroup.rotation.set(Math.PI / 2, 0, this.inputs.degree * (Math.PI / 180));
    this.root.position.set(this.inputs.position.x, this.inputs.position.y - 1e-5, this.inputs.position.z);
    this.root.add(svgGroup);
  }
  onEvent(type, data) {
    if (type === ComponentInteractionType.CLICK) {
      this.notify(ComponentInteractionType.CLICK, {
        type,
        node: this.context.root,
        component: this
      });
    }
    if (type === ComponentInteractionType.HOVER) {
      this.notify(ComponentInteractionType.HOVER, {
        hover: data.hover
      });
    }
  }
  onInputsUpdated(previous) {
  }
  onTick(tickDelta) {
  }
  onDestroy() {
  }
}
const sweepType = "dpm.sweep";
const sweepFactory = () => {
  return new SweepComponent();
};
class TotemHtmlComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "root", null);
    __publicField(this, "mesh", null);
    __publicField(this, "geometory", null);
    __publicField(this, "material", null);
    __publicField(this, "canvas", null);
    __publicField(this, "inputs", {
      size: { width: 100, height: 100 },
      position: { x: 0, y: 0, z: 0 },
      scale: { x: 1, y: 1 },
      rotation: { x: 0, y: 0, z: 0 },
      htmlString: ""
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    this.canvas = document.getElementById("showcase").contentWindow.document.querySelector(".webgl-canvas");
    const THREE2 = this.context.three;
    this.root = new THREE2.Object3D();
    this.outputs.objectRoot = this.root;
    this.outputs.collider = this.root;
    const rotation = new Vector3(
      MathUtils.degToRad(this.inputs.rotation.x),
      MathUtils.degToRad(this.inputs.rotation.y),
      MathUtils.degToRad(this.inputs.rotation.z)
    );
    this.material = new THREE2.MeshBasicMaterial({
      blending: THREE2.NoBlending,
      color: 0,
      opacity: 0,
      side: THREE2.DoubleSide,
      transparent: true
    });
    this.geometory = new THREE2.PlaneGeometry(this.inputs.size.width * 25e-4, this.inputs.size.height * 25e-4, 1, 1);
    this.mesh = new THREE2.Mesh(this.geometory, this.material);
    this.root.scale.set(this.inputs.scale.x, this.inputs.scale.y, 1);
    this.mesh.renderOrder = 1;
    this.root.rotation.set(rotation.x, rotation.y, rotation.z);
    this.root.position.set(this.inputs.position.x, this.inputs.position.y, this.inputs.position.z);
    this.root.add(this.mesh);
    this.context.scene.add(this.root);
    const div = document.createElement("div");
    div.style.width = `${this.inputs.size.width}px`;
    div.style.height = `${this.inputs.size.width}px`;
    div.style.backgroundColor = "#FFF";
    div.innerHTML = this.inputs.htmlString;
    const object = new CSS3DObject(div);
    object.position.set(this.inputs.position.x, this.inputs.position.y, this.inputs.position.z);
    object.scale.x = this.inputs.scale.x * 25e-4;
    object.scale.y = this.inputs.scale.y * 25e-4;
    object.rotation.set(rotation.x, rotation.y, rotation.z);
    window.css3dScene.add(object);
  }
  onEvent(type, data) {
    if (type === ComponentInteractionType.CLICK) {
      this.canvas.style.pointerEvents = "none";
      this.notify(ComponentInteractionType.CLICK, {
        type,
        node: this.context.root,
        component: this
      });
    }
    if (type === ComponentInteractionType.HOVER) {
      if (data.hover) {
        this.canvas.style.pointerEvents = "none";
      } else {
        this.canvas.style.pointerEvents = "";
      }
      this.notify(ComponentInteractionType.HOVER, {
        hover: data.hover
      });
    }
  }
  onInputsUpdated(previous) {
  }
  onTick(tickDelta) {
  }
  onDestroy() {
    this.root.remove(this.mesh);
    this.geometory.dispose();
    this.material.dispose();
  }
}
const totemHtmlType = "dpm.totemHtml";
const totemHtmlFactory = () => {
  return new TotemHtmlComponent();
};
class TotemImageComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "THREE");
    __publicField(this, "root", null);
    __publicField(this, "mesh", null);
    __publicField(this, "geometory", null);
    __publicField(this, "material", null);
    __publicField(this, "div", null);
    __publicField(this, "object", null);
    __publicField(this, "fixScale", 1e3);
    // NOTE: 1m === 1000pxにする用。background-imageだと1pxのdivに画像が設定されてもブラウザに依っては出そうだが（Chrome: 138.0.7204.92だと離れると見れるが、近づくとモザイクになる状態）、意図しない見た目の原因になりそうなので、この大きさにしている
    __publicField(this, "group", null);
    __publicField(this, "initialized", false);
    __publicField(this, "inputs", {
      localName: "",
      localPosition: { x: 0, y: 0, z: 0 },
      localRotation: { x: 0, y: 0, z: 0 },
      localScale: { x: 1, y: 1 },
      scale: { x: 1, y: 1 },
      url: ""
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    return __async(this, null, function* () {
      this.THREE = this.context.three;
      this.root = new this.THREE.Object3D();
      this.outputs.objectRoot = this.root;
      this.outputs.collider = this.root;
      const localRotation = new this.THREE.Vector3(
        this.THREE.MathUtils.degToRad(this.inputs.localRotation.x),
        this.THREE.MathUtils.degToRad(this.inputs.localRotation.y),
        this.THREE.MathUtils.degToRad(this.inputs.localRotation.z)
      );
      this.root.position.set(this.inputs.localPosition.x, this.inputs.localPosition.y, this.inputs.localPosition.z);
      this.root.rotation.set(localRotation.x, localRotation.y, localRotation.z);
      this.root.scale.set(this.inputs.localScale.x, this.inputs.localScale.y, 1);
      this.material = new this.THREE.MeshBasicMaterial({
        blending: this.THREE.NoBlending,
        color: 0,
        opacity: 0,
        side: this.THREE.DoubleSide,
        transparent: true
      });
      this.geometory = new this.THREE.PlaneGeometry(1, 1, 1, 1);
      this.mesh = new this.THREE.Mesh(this.geometory, this.material);
      this.mesh.position.set(0.5, 0.5, 0);
      this.mesh.renderOrder = 1;
      this.root.add(this.mesh);
      this.div = document.createElement("div");
      this.div.className = "totem-image";
      this.div.style.width = `${this.inputs.scale.x * this.fixScale * this.inputs.localScale.x}px`;
      this.div.style.height = `${this.inputs.scale.y * this.fixScale * this.inputs.localScale.y}px`;
      this.div.style.backgroundColor = "#FFF";
      this.div.style.backgroundSize = "cover";
      this.div.style.backgroundPosition = "center";
      this.div.style.backgroundRepeat = "no-repeat";
      yield this.setBackgroundImage();
      this.object = new CSS3DObject(this.div);
      this.object.position.set(0.5 * this.inputs.scale.x * this.inputs.localScale.x, 0.5 * this.inputs.scale.y * this.inputs.localScale.y, 0);
      this.object.scale.x = 1 / this.fixScale;
      this.object.scale.y = 1 / this.fixScale;
      this.group = new this.THREE.Group();
      this.group.add(this.object);
      window.css3dScene.add(this.group);
    });
  }
  onEvent(type, data) {
    if (type === ComponentInteractionType.CLICK)
      ;
    if (type === ComponentInteractionType.HOVER)
      ;
  }
  onInputsUpdated(_previous) {
    return __async(this, null, function* () {
      yield this.setBackgroundImage();
      this.div.style.width = `${this.inputs.scale.x * this.fixScale * this.inputs.localScale.x}px`;
      this.div.style.height = `${this.inputs.scale.y * this.fixScale * this.inputs.localScale.y}px`;
      this.object.position.set(0.5 * this.inputs.scale.x * this.inputs.localScale.x, 0.5 * this.inputs.scale.y * this.inputs.localScale.y, 0);
      this.root.updateMatrixWorld(true);
      const newPosition = new this.THREE.Vector3();
      this.root.getWorldPosition(newPosition);
      const newQuaternion = new this.THREE.Quaternion();
      this.root.getWorldQuaternion(newQuaternion);
      this.group.position.copy(newPosition);
      this.group.quaternion.copy(newQuaternion);
    });
  }
  setBackgroundImage() {
    return __async(this, null, function* () {
      if (this.inputs.url) {
        if (this.inputs.url.indexOf("get_media_url") === -1) {
          this.div.style.backgroundImage = `url(${this.inputs.url})`;
        } else {
          try {
            const res = yield axios$1.get(this.inputs.url);
            this.div.style.backgroundImage = `url(${res.data.url})`;
          } catch (error2) {
            console.error("Failed to fetch image URL:", error2);
          }
        }
      } else {
        this.div.style.backgroundImage = "";
      }
    });
  }
  onTick(_tickDelta) {
    if (!this.initialized && this.group) {
      this.onInputsUpdated(null);
      this.initialized = true;
    }
  }
  onDestroy() {
    this.root.remove(this.mesh);
    this.geometory.dispose();
    this.material.dispose();
    this.group.remove(this.object);
    window.css3dScene.remove(this.group);
    if (this.object.element && this.object.element.parentNode) {
      this.object.element.parentNode.removeChild(this.object.element);
    }
    this.object.element = null;
    this.object = null;
  }
}
const totemImageType = "dpm.totemImage";
const totemImageFactory = () => {
  return new TotemImageComponent();
};
class TotemMovieComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "THREE");
    __publicField(this, "root", null);
    __publicField(this, "mesh", null);
    __publicField(this, "geometory", null);
    __publicField(this, "material", null);
    __publicField(this, "canvas", null);
    __publicField(this, "iframe", null);
    __publicField(this, "div", null);
    __publicField(this, "object", null);
    __publicField(this, "group", null);
    __publicField(this, "togglePointerEvents", false);
    __publicField(this, "initialized", false);
    __publicField(this, "fixScale", 1e3);
    __publicField(this, "inputs", {
      localName: "",
      localPosition: { x: 0, y: 0, z: 0 },
      localRotation: { x: 0, y: 0, z: 0 },
      localScale: { x: 1, y: 1 },
      scale: { x: 1, y: 1 },
      url: ""
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    this.canvas = document.getElementById("showcase").contentWindow.document.querySelector(".webgl-canvas");
    this.THREE = this.context.three;
    this.root = new this.THREE.Object3D();
    this.outputs.objectRoot = this.root;
    this.outputs.collider = this.root;
    const localRotation = new this.THREE.Vector3(
      this.THREE.MathUtils.degToRad(this.inputs.localRotation.x),
      this.THREE.MathUtils.degToRad(this.inputs.localRotation.y),
      this.THREE.MathUtils.degToRad(this.inputs.localRotation.z)
    );
    this.root.position.set(this.inputs.localPosition.x, this.inputs.localPosition.y, this.inputs.localPosition.z);
    this.root.rotation.set(localRotation.x, localRotation.y, localRotation.z);
    this.root.scale.set(this.inputs.localScale.x, this.inputs.localScale.y, 1);
    this.material = new this.THREE.MeshBasicMaterial({
      blending: this.THREE.NoBlending,
      color: 0,
      opacity: 0,
      side: this.THREE.DoubleSide,
      transparent: true
    });
    this.geometory = new this.THREE.PlaneGeometry(1, 1, 1, 1);
    this.mesh = new this.THREE.Mesh(this.geometory, this.material);
    this.mesh.position.set(0.5, 0.5, 0);
    this.mesh.renderOrder = 1;
    this.root.add(this.mesh);
    this.div = document.createElement("div");
    this.div.style.width = `${this.inputs.scale.x * this.fixScale * this.inputs.localScale.x}px`;
    this.div.style.height = `${this.inputs.scale.y * this.fixScale * this.inputs.localScale.y}px`;
    this.div.style.backgroundColor = "#FFF";
    this.iframe = document.createElement("iframe");
    this.iframe.style.width = "100%";
    this.iframe.style.height = "100%";
    this.iframe.style.border = "0px";
    this.iframe.setAttribute("allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture");
    if (this.inputs.url) {
      this.iframe.src = this.inputs.url;
    }
    this.div.appendChild(this.iframe);
    this.object = new CSS3DObject(this.div);
    this.object.position.set(0.5 * this.inputs.scale.x * this.inputs.localScale.x, 0.5 * this.inputs.scale.y * this.inputs.localScale.y, 0);
    this.object.scale.x = 1 / this.fixScale;
    this.object.scale.y = 1 / this.fixScale;
    this.group = new this.THREE.Group();
    this.group.add(this.object);
    window.css3dScene.add(this.group);
  }
  onEvent(type, data) {
    if (type === ComponentInteractionType.CLICK) {
      this.canvas.style.pointerEvents = "none";
      this.togglePointerEvents = !this.togglePointerEvents;
      this.notify(ComponentInteractionType.CLICK, {
        type,
        node: this.context.root,
        component: this
      });
    }
    if (type === ComponentInteractionType.HOVER) {
      if (data.hover) {
        this.canvas.style.pointerEvents = "none";
      } else if (!this.togglePointerEvents) {
        this.canvas.style.pointerEvents = "";
      }
      this.notify(ComponentInteractionType.HOVER, {
        hover: data.hover
      });
    }
  }
  onInputsUpdated(_previous) {
    if (this.inputs.url) {
      this.iframe.src = this.inputs.url;
    }
    this.div.style.width = `${this.inputs.scale.x * this.fixScale * this.inputs.localScale.x}px`;
    this.div.style.height = `${this.inputs.scale.y * this.fixScale * this.inputs.localScale.y}px`;
    this.object.position.set(0.5 * this.inputs.scale.x * this.inputs.localScale.x, 0.5 * this.inputs.scale.y * this.inputs.localScale.y, 0);
    this.root.updateMatrixWorld(true);
    const newPosition = new this.THREE.Vector3();
    this.root.getWorldPosition(newPosition);
    const newQuaternion = new this.THREE.Quaternion();
    this.root.getWorldQuaternion(newQuaternion);
    this.group.position.copy(newPosition);
    this.group.quaternion.copy(newQuaternion);
  }
  onTick(_tickDelta) {
    if (!this.initialized) {
      this.onInputsUpdated(null);
      this.initialized = true;
    }
  }
  onDestroy() {
    this.root.remove(this.mesh);
    this.geometory.dispose();
    this.material.dispose();
    this.group.remove(this.object);
    window.css3dScene.remove(this.group);
    if (this.object.element && this.object.element.parentNode) {
      this.object.element.parentNode.removeChild(this.object.element);
    }
    this.object.element = null;
    this.object = null;
  }
}
const totemMovieType = "dpm.totemMovie";
const totemMovieFactory = () => {
  return new TotemMovieComponent();
};
class TotemMovieWithFrameComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "root", null);
    __publicField(this, "mesh", null);
    __publicField(this, "geometory", null);
    __publicField(this, "material", null);
    __publicField(this, "canvas", null);
    __publicField(this, "inputs", {
      size: { width: 100, height: 100 },
      position: { x: 0, y: 0, z: 0 },
      scale: { x: 1, y: 1 },
      rotation: { x: 0, y: 0, z: 0 },
      src: ""
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    return __async(this, null, function* () {
      this.canvas = document.getElementById("showcase").contentWindow.document.querySelector(".webgl-canvas");
      const THREE = this.context.three;
      this.root = new THREE.Object3D();
      this.outputs.objectRoot = this.root;
      this.outputs.collider = this.root;
      const rotation = new THREE.Vector3(
        THREE.MathUtils.degToRad(this.inputs.rotation.x),
        THREE.MathUtils.degToRad(this.inputs.rotation.y),
        THREE.MathUtils.degToRad(this.inputs.rotation.z)
      );
      this.material = new THREE.MeshBasicMaterial({
        blending: THREE.NoBlending,
        color: 0,
        opacity: 0,
        side: THREE.DoubleSide,
        transparent: true
      });
      this.geometory = new THREE.PlaneGeometry(this.inputs.size.width * 25e-4, this.inputs.size.height * 25e-4, 1, 1);
      this.mesh = new THREE.Mesh(this.geometory, this.material);
      this.root.scale.set(this.inputs.scale.x, this.inputs.scale.y, 1);
      this.mesh.renderOrder = 1;
      this.root.rotation.set(rotation.x, rotation.y, rotation.z);
      this.root.position.set(this.inputs.position.x, this.inputs.position.y, this.inputs.position.z);
      this.root.add(this.mesh);
      this.context.scene.add(this.root);
      const div = document.createElement("div");
      div.style.width = `${this.inputs.size.width}px`;
      div.style.height = `${this.inputs.size.height}px`;
      div.style.backgroundColor = "#FFF";
      const iframe = document.createElement("iframe");
      iframe.style.width = `${this.inputs.size.width}px`;
      iframe.style.height = `${this.inputs.size.height}px`;
      iframe.style.border = "0px";
      iframe.setAttribute("allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture");
      iframe.src = this.inputs.src;
      div.appendChild(iframe);
      const object = new CSS3DObject(div);
      object.position.set(this.inputs.position.x, this.inputs.position.y, this.inputs.position.z);
      object.scale.x = this.inputs.scale.x * 25e-4;
      object.scale.y = this.inputs.scale.y * 25e-4;
      object.rotation.set(rotation.x, rotation.y, rotation.z);
      yield new THREE.GLTFLoader().load("../../../../showcase_assets/models/frame.gltf", (gltf) => {
        const scene = gltf.scene || gltf.scenes[0];
        scene.children[0].scale.x = this.inputs.size.width * 25e-4;
        scene.children[0].scale.y = this.inputs.size.height * 25e-4;
        this.root.add(scene);
      });
      window.css3dScene.add(object);
    });
  }
  onEvent(type, data) {
    if (type === ComponentInteractionType.CLICK) {
      this.canvas.style.pointerEvents = "none";
      this.notify(ComponentInteractionType.CLICK, {
        type,
        node: this.context.root,
        component: this
      });
    }
    if (type === ComponentInteractionType.HOVER) {
      if (data.hover) {
        this.canvas.style.pointerEvents = "none";
      } else {
        this.canvas.style.pointerEvents = "";
      }
      this.notify(ComponentInteractionType.HOVER, {
        hover: data.hover
      });
    }
  }
  onInputsUpdated(previous) {
  }
  onTick(tickDelta) {
  }
  onDestroy() {
    this.root.remove(this.mesh);
    this.geometory.dispose();
    this.material.dispose();
  }
}
const totemMovieWithFrameType = "dpm.totemMovieWithFrame";
const totemMovieWithFrameFactory = () => {
  return new TotemMovieWithFrameComponent();
};
class VideoComponent extends SceneComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "geometory");
    __publicField(this, "material");
    __publicField(this, "mesh");
    __publicField(this, "root");
    __publicField(this, "texture");
    __publicField(this, "video");
    __publicField(this, "inputs", {
      size: { width: 100, height: 100 },
      position: { x: 0, y: 0, z: 0 },
      scale: { x: 1, y: 1 },
      rotation: { x: 0, y: 0, z: 0 },
      src: ""
    });
    __publicField(this, "events", {
      [ComponentInteractionType.CLICK]: true,
      [ComponentInteractionType.HOVER]: true,
      [ComponentInteractionType.DRAG]: false
    });
  }
  onInit() {
    const THREE2 = this.context.three;
    this.root = new THREE2.Object3D();
    this.outputs.objectRoot = this.root;
    this.outputs.collider = this.root;
    this.video = document.createElement("video");
    this.video.crossOrigin = "anonymous";
    this.video.muted = true;
    this.video.loop = true;
    this.video.src = this.inputs.src;
    this.video.load();
    this.texture = new THREE2.VideoTexture(this.video);
    this.texture.minFilter = THREE2.LinearFilter;
    this.texture.magFilter = THREE2.LinearFilter;
    this.texture.format = THREE2.RGBAFormat;
    this.material = new THREE2.MeshBasicMaterial({
      map: this.texture,
      side: THREE2.DoubleSide
    });
    this.geometory = new THREE2.PlaneGeometry(this.inputs.size.width * 25e-4, this.inputs.size.height * 25e-4, 1, 1);
    this.mesh = new THREE2.Mesh(this.geometory, this.material);
    const rotation = new Vector3(
      MathUtils.degToRad(this.inputs.rotation.x),
      MathUtils.degToRad(this.inputs.rotation.y),
      MathUtils.degToRad(this.inputs.rotation.z)
    );
    this.root.scale.set(this.inputs.scale.x, this.inputs.scale.y, 1);
    this.mesh.renderOrder = 1;
    this.root.rotation.set(rotation.x, rotation.y, rotation.z);
    this.root.position.set(this.inputs.position.x, this.inputs.position.y, this.inputs.position.z);
    this.root.add(this.mesh);
    this.context.scene.add(this.root);
    this.video.play();
  }
  onInputsUpdated(previous) {
  }
  onTick(tickDelta) {
  }
  onEvent(type, data) {
  }
  onDestroy() {
    this.root.remove(this.mesh);
    this.geometory.dispose();
    this.material.dispose();
    this.texture.dispose();
  }
}
const videoType = "dpm.video";
const videoFactory = () => {
  return new VideoComponent();
};
const initComponents = (sdk) => __async(void 0, null, function* () {
  yield Promise.all([
    sdk.Scene.register(balloonType, balloonFactory),
    sdk.Scene.register(billboardType, billboardFactory),
    sdk.Scene.register(cilbeeBeeType, cilbeeBeeFactory),
    sdk.Scene.register(cilbeeDestinationType, cilbeeDestinationFactory),
    sdk.Scene.register(cilbeeRouteLineType, cilbeeRouteLineFactory),
    sdk.Scene.register(faceType, faceFactory),
    sdk.Scene.register(fileLoaderType, fileLoaderFactory),
    sdk.Scene.register(fixPositionType, fixPositionFactory),
    sdk.Scene.register(gazeLineType, gazeLineFactory),
    sdk.Scene.register(labelType, labelFactory),
    sdk.Scene.register(primitiveType, primitiveFactory),
    sdk.Scene.register(sweepType, sweepFactory),
    sdk.Scene.register(totemHtmlType, totemHtmlFactory),
    sdk.Scene.register(totemImageType, totemImageFactory),
    sdk.Scene.register(totemMovieType, totemMovieFactory),
    sdk.Scene.register(totemMovieWithFrameType, totemMovieWithFrameFactory),
    sdk.Scene.register(videoType, videoFactory)
  ]);
});
class SceneLoader {
  constructor(sdk) {
    __publicField(this, "sceneNodes", []);
    this.sdk = sdk;
  }
  load(scene) {
    return __async(this, null, function* () {
      scene.payload.objects = scene.payload.objects.filter((object) => object.name !== "Ambient Light");
      const sceneObject = yield this.sdk.Scene.deserialize(JSON.stringify(scene));
      for (const node2 of sceneObject.nodeIterator()) {
        if (node2.name.includes("transformControls")) {
          continue;
        }
        this.sceneNodes.push(node2);
      }
      for (const node2 of this.sceneNodes) {
        for (const component of node2.componentIterator()) {
          if (component.componentType === "dpm.primitive" && (component.inputs.type === "Box" || component.inputs.type === "Plane" || component.inputs.type === "Line")) {
            if (window.css2dScene == null) {
              window.css2dScene = new Scene$1();
            }
            break;
          }
        }
      }
      for (const node2 of this.sceneNodes) {
        for (const component of node2.componentIterator()) {
          if (component.componentType === "dpm.totemHtml" || component.componentType === "dpm.totemImage" || component.componentType === "dpm.totemMovie" || component.componentType === "dpm.totemMovieWithFrame") {
            if (window.css3dScene == null) {
              window.css3dScene = new Scene$1();
            }
            break;
          }
        }
      }
      for (const node2 of this.sceneNodes) {
        node2.start();
      }
      this.changeAllObjectsInvisible();
      const startPose = yield this.sdk.Camera.getPose();
      this.changeObjectsVisible(startPose.mode, this.sdk.Mode.Event.CHANGE_END);
      this.sdk.on(this.sdk.Mode.Event.CHANGE_START, (_oldMode, newMode) => {
        this.changeObjectsVisible(newMode, this.sdk.Mode.Event.CHANGE_START);
      });
      this.sdk.on(this.sdk.Mode.Event.CHANGE_END, (_oldMode, newMode) => {
        this.changeObjectsVisible(newMode, this.sdk.Mode.Event.CHANGE_END);
      });
      const tick = () => {
        requestAnimationFrame(tick);
        for (const object of scene.payload.objects) {
          if (object.rotate) {
            const targetNode = this.sceneNodes.find((node2) => node2.name === object.name);
            targetNode.obj3D.rotation.y -= 0.02;
          }
        }
      };
      tick();
      return sceneObject;
    });
  }
  // public *nodeIterator(): IterableIterator<ISceneNode> {
  //   for (const node of this.sceneObject.nodes) {
  //     yield node
  //   }
  // }
  changeObjectsVisible(newMode, timing) {
    const setVisibleByMode = (objects, mode) => {
      objects.forEach((node2) => {
        switch (mode) {
          case this.sdk.Mode.Mode.INSIDE:
            if (newMode === mode && timing === this.sdk.Mode.Event.CHANGE_END) {
              node2.obj3D.visible = true;
            } else {
              node2.obj3D.visible = false;
            }
            break;
          case this.sdk.Mode.Mode.DOLLHOUSE:
            if (newMode === mode && (timing === this.sdk.Mode.Event.CHANGE_START || timing === this.sdk.Mode.Event.CHANGE_END)) {
              node2.obj3D.visible = true;
            } else if ((newMode === this.sdk.Mode.Mode.INSIDE || newMode === this.sdk.Mode.Mode.FLOORPLAN) && timing === this.sdk.Mode.Event.CHANGE_START) {
              node2.obj3D.visible = true;
            } else {
              node2.obj3D.visible = false;
            }
            break;
          case this.sdk.Mode.Mode.FLOORPLAN:
            if (newMode === mode && (timing === this.sdk.Mode.Event.CHANGE_START || timing === this.sdk.Mode.Event.CHANGE_END)) {
              node2.obj3D.visible = true;
            } else {
              node2.obj3D.visible = false;
            }
            break;
          case this.sdk.Mode.Mode.OUTSIDE:
            if ((newMode === this.sdk.Mode.Mode.DOLLHOUSE || newMode === this.sdk.Mode.Mode.FLOORPLAN) && (timing === this.sdk.Mode.Event.CHANGE_START || timing === this.sdk.Mode.Event.CHANGE_END)) {
              node2.obj3D.visible = true;
            } else if (newMode !== this.sdk.Mode.Mode.DOLLHOUSE && newMode !== this.sdk.Mode.Mode.FLOORPLAN && timing === this.sdk.Mode.Event.CHANGE_END) {
              node2.obj3D.visible = false;
            } else
              ;
            break;
        }
      });
    };
    const obfuscators = this.sceneNodes.filter((node2) => {
      return node2.name.match(/Obfuscator|Inside/g);
    });
    setVisibleByMode(obfuscators, this.sdk.Mode.Mode.INSIDE);
    const dollhouses = this.sceneNodes.filter((node2) => {
      return node2.name.match(/Dollhouse/g);
    });
    setVisibleByMode(dollhouses, this.sdk.Mode.Mode.DOLLHOUSE);
    const floorplans = this.sceneNodes.filter((node2) => {
      return node2.name.match(/Floorplan/g);
    });
    setVisibleByMode(floorplans, this.sdk.Mode.Mode.FLOORPLAN);
    const outsides = this.sceneNodes.filter((node2) => {
      return node2.name.match(/Outside/g);
    });
    setVisibleByMode(outsides, this.sdk.Mode.Mode.OUTSIDE);
  }
  changeAllObjectsInvisible() {
    this.sceneNodes.forEach((node2) => {
      if (node2.name.match(/Obfuscator|Inside|Dollhouse|Floorplan|Outside/g)) {
        node2.obj3D.visible = false;
      }
    });
  }
}
function createBillboard(sceneObject, position, url, options) {
  return __async(this, null, function* () {
    let inputs = {
      localName: "",
      localPosition: { x: 0, y: 0, z: 0 },
      localScale: { x: 1, y: 1 },
      url
    };
    _merge(inputs, options);
    const node2 = yield sceneObject.addNode();
    node2.name = "Billboard";
    node2.addComponent(billboardType, inputs);
    node2.position.set(position.x, position.y, position.z);
    node2.start();
    return node2;
  });
}
function createFace(sceneObject, userId, options = null) {
  return __async(this, null, function* () {
    let inputs = {
      componentId: "",
      name: "Guest",
      num: 0,
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0 },
      scale: { x: 1, y: 1, z: 1 },
      url: ""
    };
    _merge(inputs, options);
    const node2 = yield sceneObject.addNode();
    node2.name = `Face - ${userId}`;
    const component = node2.addComponent(faceType, {
      componentId: node2.name,
      name: inputs.name,
      num: inputs.num,
      position: { x: inputs.position.x, y: inputs.position.y, z: inputs.position.z },
      rotation: { x: inputs.rotation.x, y: inputs.rotation.y, z: inputs.rotation.z },
      scale: { x: inputs.scale.x, y: inputs.scale.y, z: inputs.scale.z },
      url: inputs.url
    });
    node2.start();
    return component;
  });
}
function createFixPosition(sceneObject, position, data, options) {
  return __async(this, null, function* () {
    const node2 = yield sceneObject.addNode();
    node2.name = `FixPosition`;
    node2.addComponent(fixPositionType, { data });
    node2.position.set(position.x, position.y, position.z);
    if (options == null ? void 0 : options.scale) {
      node2.scale.set(options.scale.x, options.scale.y, options.scale.z);
    }
    node2.start();
    return node2;
  });
}
function createGazeLine(sceneObject, userId, options = null) {
  return __async(this, null, function* () {
    let inputs = {
      componentId: "",
      num: 0,
      position: { x: 0, y: 0, z: 0 }
    };
    _merge(inputs, options);
    const node2 = yield sceneObject.addNode();
    node2.name = `GazeLine - ${userId}`;
    const component = node2.addComponent(gazeLineType, {
      componentId: node2.name,
      num: inputs.num,
      position: inputs.position
    });
    node2.start();
    return component;
  });
}
function createGroup(sceneObject, position, children) {
  return __async(this, null, function* () {
    const node2 = yield sceneObject.addNode();
    node2.name = "Group";
    node2.position.set(position.x, position.y, position.z);
    node2.assetFileIds = Array(children.length).fill("");
    for (let i2 = 0; i2 < children.length; i2++) {
      const child = children[i2];
      node2.addComponent(child.type, child.inputs);
      node2.assetFileIds[i2] = child.assetFileId;
    }
    node2.start();
    return node2;
  });
}
function createModel(sceneObject, position, url, name, options = null) {
  return __async(this, null, function* () {
    let inputs = {
      bones: {},
      localName: "",
      localPosition: { x: 0, y: 0, z: 0 },
      localRotation: { x: 0, y: 0, z: 0 },
      localScale: { x: 1, y: 1, z: 1 },
      url
    };
    _merge(inputs, options);
    const node2 = yield sceneObject.addNode();
    node2.name = name;
    node2.addComponent(fileLoaderType, inputs);
    node2.position.set(position.x, position.y, position.z);
    node2.start();
    return node2;
  });
}
function createPrimitive(sceneObject, position, type, options) {
  return __async(this, null, function* () {
    const inputs = {
      color: "#FFFFFF",
      endPosition: { x: 0, y: 0, z: 0 },
      linewidth: 2,
      localName: "",
      localPosition: { x: 0, y: 0, z: 0 },
      localRotation: { x: 0, y: 0, z: 0 },
      localScale: { x: 1, y: 1, z: 1 },
      opacity: 1,
      type
    };
    _merge(inputs, options);
    const node2 = yield sceneObject.addNode();
    node2.name = `Primitive ${type}`;
    node2.addComponent(primitiveType, inputs);
    node2.position.set(position.x, position.y, position.z);
    node2.start();
    return node2;
  });
}
function createSkySphere(sceneObject, options = null) {
  return __async(this, null, function* () {
    let inputs = {
      position: { x: 0, y: 0, z: 0 },
      scale: { x: 1, y: 1, z: 1 }
    };
    _merge(inputs, options);
    const node2 = yield sceneObject.addNode();
    node2.name = "SkySphere";
    node2.addComponent(fileLoaderType, {
      url: "/showcase_assets/models/sky_sphere.gltf",
      localPosition: { x: inputs.position.x, y: inputs.position.y, z: inputs.position.z },
      localScale: { x: inputs.scale.x, y: inputs.scale.y, z: inputs.scale.z }
    });
    node2.start();
    return node2;
  });
}
function createTotemHtml(sceneObject, position, htmlString, options = null) {
  return __async(this, null, function* () {
    let inputs = {
      size: { width: 100, height: 100 },
      position: { x: 0, y: 0, z: 0 },
      scale: { x: 1, y: 1 },
      rotation: { x: 0, y: 0, z: 0 }
    };
    _merge(inputs, options);
    const node2 = yield sceneObject.addNode();
    node2.name = "CSS3D TotemHtml";
    node2.addComponent(totemHtmlType, {
      size: { width: inputs.size.width, height: inputs.size.height },
      position: { x: inputs.position.x, y: inputs.position.y, z: inputs.position.z },
      scale: { x: inputs.scale.x, y: inputs.scale.y },
      rotation: { x: inputs.rotation.x, y: inputs.rotation.y, z: inputs.rotation.z },
      htmlString
    });
    node2.position.set(position.x, position.y, position.z);
    node2.start();
    return node2;
  });
}
function createTotemModel(sceneObject, position, modelUrl, options = null) {
  return __async(this, null, function* () {
    let inputs = {
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0 },
      scale: { x: 1, y: 1, z: 1 }
    };
    _merge(inputs, options);
    const node2 = yield sceneObject.addNode();
    node2.name = "TotemModel";
    node2.addComponent(fileLoaderType, {
      url: modelUrl,
      localPosition: { x: inputs.position.x, y: inputs.position.y, z: inputs.position.z },
      localRotation: { x: inputs.rotation.x, y: inputs.rotation.y, z: inputs.rotation.z },
      localScale: { x: inputs.scale.x, y: inputs.scale.y, z: inputs.scale.z }
    });
    node2.position.set(position.x, position.y, position.z);
    node2.start();
    return node2;
  });
}
function createTotemMovie(sceneObject, position, url, options) {
  return __async(this, null, function* () {
    let inputs = {
      localName: "",
      localPosition: { x: 0, y: 0, z: 0 },
      localRotation: { x: 0, y: 0, z: 0 },
      localScale: { x: 1, y: 1 },
      scale: { x: 1, y: 1 },
      url
    };
    _merge(inputs, options);
    const node2 = yield sceneObject.addNode();
    node2.name = "CSS3D TotemMovie";
    node2.addComponent(totemMovieType, inputs);
    node2.position.set(position.x, position.y, position.z);
    node2.start();
    return node2;
  });
}
function createTotemImage(sceneObject, position, url, options) {
  return __async(this, null, function* () {
    let inputs = {
      localName: "",
      localPosition: { x: 0, y: 0, z: 0 },
      localRotation: { x: 0, y: 0, z: 0 },
      localScale: { x: 1, y: 1 },
      scale: { x: 1, y: 1 },
      url
    };
    _merge(inputs, options);
    const node2 = yield sceneObject.addNode();
    node2.name = "CSS3D TotemImage";
    node2.addComponent(totemImageType, inputs);
    node2.position.set(position.x, position.y, position.z);
    node2.start();
    return node2;
  });
}
function createTotemMovieWithFrame(sceneObject, position, src, options = null) {
  return __async(this, null, function* () {
    let inputs = {
      size: { width: 100, height: 100 },
      position: { x: 0, y: 0, z: 0 },
      scale: { x: 1, y: 1 },
      rotation: { x: 0, y: 0, z: 0 }
    };
    _merge(inputs, options);
    const node2 = yield sceneObject.addNode();
    node2.name = "CSS3D TotemMovieWithFrame";
    node2.addComponent(totemMovieWithFrameType, {
      size: { width: inputs.size.width, height: inputs.size.height },
      position: { x: inputs.position.x, y: inputs.position.y, z: inputs.position.z },
      scale: { x: inputs.scale.x, y: inputs.scale.y },
      rotation: { x: inputs.rotation.x, y: inputs.rotation.y, z: inputs.rotation.z },
      src
    });
    node2.position.set(position.x, position.y, position.z);
    node2.start();
    return node2;
  });
}
function createVideo(sceneObject, position, src, options = null) {
  return __async(this, null, function* () {
    let inputs = {
      size: { width: 100, height: 100 },
      position: { x: 0, y: 0, z: 0 },
      scale: { x: 1, y: 1 },
      rotation: { x: 0, y: 0, z: 0 },
      src: ""
    };
    _merge(inputs, options);
    const node2 = yield sceneObject.addNode();
    node2.name = "Video";
    node2.addComponent(videoType, {
      size: { width: inputs.size.width, height: inputs.size.height },
      position: { x: inputs.position.x, y: inputs.position.y, z: inputs.position.z },
      scale: { x: inputs.scale.x, y: inputs.scale.y },
      rotation: { x: inputs.rotation.x, y: inputs.rotation.y, z: inputs.rotation.z },
      src
    });
    node2.position.set(position.x, position.y, position.z);
    node2.start();
    return node2;
  });
}
let hitCheckObjects = null;
let camera = null;
class Scene2 {
  constructor(showcase, sdk) {
    __publicField(this, "css3dRenderer", null);
    __publicField(this, "css2dRenderer", null);
    // private webGlRenderer : WebGLRenderer | null = null
    __publicField(this, "loader", null);
    __publicField(this, "sceneObject", null);
    __publicField(this, "loadedSceneObjects", []);
    this.showcase = showcase;
    this.sdk = sdk;
  }
  init() {
    return __async(this, null, function* () {
      yield initComponents(this.sdk);
      this.sceneObject = (yield this.sdk.Scene.createObjects(1))[0];
      this.loader = new SceneLoader(this.sdk);
      this.addAmbientLight();
    });
  }
  serialize() {
    return __async(this, null, function* () {
      const data = JSON.parse(yield this.sdk.Scene.serialize(this.sceneObject));
      data.payload.objects = data.payload.objects.filter((object) => object.name !== "transformControls" && object.name !== "deleted");
      for (const loadedSceneObjects of this.loadedSceneObjects) {
        const tmpData = JSON.parse(yield this.sdk.Scene.serialize(loadedSceneObjects));
        const filteredTmpData = tmpData.payload.objects.filter((object) => object.name !== "transformControls" && object.name !== "deleted");
        data.payload.objects = data.payload.objects.concat(filteredTmpData);
      }
      return data;
    });
  }
  loadFromJson(jsonData) {
    return __async(this, null, function* () {
      const sceneData = yield this.loader.load(jsonData);
      this.loadedSceneObjects.push(sceneData);
      this.prepareCss2d();
      this.prepareCss3d();
      return sceneData;
    });
  }
  loadObjectsFromShowcaseEditorData(showcaseEditorData) {
    return __async(this, null, function* () {
      let sceneData = null;
      if (showcaseEditorData.objects && Object.keys(showcaseEditorData.objects).length) {
        sceneData = yield this.loader.load(showcaseEditorData.objects);
        this.loadedSceneObjects.push(sceneData);
        this.prepareCss2d();
        this.prepareCss3d();
      }
      return sceneData;
    });
  }
  loadTagsFromShowcaseEditorData(showcaseEditorData) {
    return __async(this, null, function* () {
      if (showcaseEditorData.mattertags || showcaseEditorData.mattertag_groups) {
        new Promise((resolve2, _reject) => {
          this.sdk.App.state.subscribe((appState) => __async(this, null, function* () {
            if (appState.phase === this.sdk.App.Phase.PLAYING) {
              yield editShowcase.applyData(this.sdk);
              resolve2(true);
            }
          }));
        });
      }
    });
  }
  addAmbientLight() {
    return __async(this, null, function* () {
      var _a2, _b2;
      for (const loadedSceneObject of Array(this.sceneObject, ...this.loadedSceneObjects)) {
        for (const node22 of loadedSceneObject.nodeIterator()) {
          if (((_b2 = (_a2 = node22.obj3D) == null ? void 0 : _a2.children[0]) == null ? void 0 : _b2.type) === "AmbientLight") {
            return;
          }
        }
      }
      const node2 = yield this.sceneObject.addNode();
      node2.name = "Ambient Light";
      const initial = {
        intensity: Math.PI,
        color: { r: 1, g: 1, b: 1 }
      };
      node2.addComponent("mp.ambientLight", initial);
      node2.start();
      return node2;
    });
  }
  addFace(userId, options = null) {
    return __async(this, null, function* () {
      return yield createFace(this.sceneObject, userId, options);
    });
  }
  addGazeLine(userId, options = null) {
    return __async(this, null, function* () {
      return yield createGazeLine(this.sceneObject, userId, options);
    });
  }
  clearScene() {
    var _a2, _b2;
    Array(this.sceneObject, ...this.loadedSceneObjects).forEach((loadedSceneObject) => {
      for (const node2 of loadedSceneObject.nodeIterator()) {
        node2.stop();
      }
    });
    (_a2 = window.css2dScene) == null ? void 0 : _a2.children.forEach((child) => {
      window.css2dScene.remove(child);
    });
    (_b2 = window.css3dScene) == null ? void 0 : _b2.children.forEach((child) => {
      window.css3dScene.remove(child);
    });
    this.addAmbientLight();
  }
  createCss2dScene() {
    if (!window.css2dScene) {
      window.css2dScene = new Scene$1();
    }
  }
  createCss3dScene() {
    if (!window.css3dScene) {
      window.css3dScene = new Scene$1();
    }
  }
  prepareCss2d() {
    const css2dComponents = [];
    for (const loadedSceneObject of this.loadedSceneObjects) {
      for (const node2 of loadedSceneObject.nodeIterator()) {
        for (const component of node2.componentIterator()) {
          if (component.componentType === "dpm.primitive" && (component.inputs.type === "Box" || component.inputs.type === "Plane" || component.inputs.type === "Line")) {
            css2dComponents.push(component);
            component.updateLabel(node2.scale);
          }
        }
      }
    }
    if (window.css2dScene) {
      this.prepareCss2dRenderer(css2dComponents[0]);
    }
  }
  prepareCss3d() {
    const css3dComponents = [];
    for (const loadedSceneObject of this.loadedSceneObjects) {
      for (const node2 of loadedSceneObject.nodeIterator()) {
        for (const component of node2.componentIterator()) {
          if (component.componentType === "dpm.totemHtml" || component.componentType === "dpm.totemImage" || component.componentType === "dpm.totemMovie" || component.componentType === "dpm.totemMovieWithFrame") {
            css3dComponents.push(component);
          }
        }
      }
    }
    if (window.css3dScene) {
      this.prepareCss3dRenderer(css3dComponents[0]);
    }
    css3dComponents.forEach((component) => {
      hitCheckObjects.push(component.root.children[0]);
    });
  }
  prepareCss2dRenderer(component) {
    if (this.css2dRenderer) {
      return;
    }
    const context = component.context;
    camera = context.camera;
    this.css2dRenderer = new CSS2DRenderer();
    this.css2dRenderer.setSize(this.showcase.clientWidth, this.showcase.clientHeight);
    this.css2dRenderer.domElement.style.position = "absolute";
    this.css2dRenderer.domElement.style.top = `${this.showcase.getBoundingClientRect().top}px`;
    this.css2dRenderer.domElement.style.left = `${this.showcase.getBoundingClientRect().left}px`;
    this.css2dRenderer.domElement.style.pointerEvents = "none";
    document.body.appendChild(this.css2dRenderer.domElement);
    window.addEventListener("resize", () => {
      this.css2dRendererResize();
    });
    this.css2dRendererRender();
  }
  prepareCss3dRenderer(component) {
    if (this.css3dRenderer) {
      return;
    }
    const context = component.context;
    camera = context.camera;
    hitCheckObjects = [];
    this.css3dRenderer = new CSS3DRenderer();
    this.css3dRenderer.setSize(this.showcase.clientWidth, this.showcase.clientHeight);
    const canvas = document.getElementById("showcase").contentWindow.document.querySelector(".webgl-canvas");
    canvas.before(this.css3dRenderer.domElement);
    const raycaster = new Raycaster();
    const checkEvent = (event) => {
      const mouse = new Vector2();
      const x2 = event.clientX - context.renderer.domElement.offsetLeft;
      const y = event.clientY - context.renderer.domElement.offsetTop;
      const w = context.renderer.domElement.offsetWidth;
      const h = context.renderer.domElement.offsetHeight;
      mouse.x = x2 / w * 2 - 1;
      mouse.y = -(y / h) * 2 + 1;
      raycaster.setFromCamera(mouse, camera);
      const hits = raycaster.intersectObjects(hitCheckObjects);
      if (hits.length === 0) {
        canvas.style.pointerEvents = "";
      }
    };
    this.css3dRenderer.domElement.addEventListener("pointermove", checkEvent);
    this.css3dRenderer.domElement.addEventListener("pointerup", checkEvent);
    window.addEventListener("resize", () => {
      this.css3dRendererResize();
    });
    this.css3dRendererRender();
  }
  css3dRendererRender() {
    requestAnimationFrame(() => {
      this.css3dRendererRender();
    });
    this.css3dRenderer.render(window.css3dScene, camera);
  }
  css2dRendererRender() {
    requestAnimationFrame(() => {
      this.css2dRendererRender();
    });
    this.css2dRenderer.render(window.css2dScene, camera);
  }
  css3dRendererResize() {
    this.css3dRenderer.setSize(this.showcase.clientWidth, this.showcase.clientHeight);
  }
  css2dRendererResize() {
    this.css2dRenderer.setSize(this.showcase.clientWidth, this.showcase.clientHeight);
    this.css2dRenderer.domElement.style.top = `${this.showcase.getBoundingClientRect().top}px`;
  }
  addBillboard(position, url, options) {
    return __async(this, null, function* () {
      return yield createBillboard(this.sceneObject, position, url, options);
    });
  }
  addFixPosition(position, mattertags, options) {
    return __async(this, null, function* () {
      return yield createFixPosition(this.sceneObject, position, mattertags, options);
    });
  }
  addFile(position, url, name, options) {
    return __async(this, null, function* () {
      return yield createModel(this.sceneObject, position, url, name, options);
    });
  }
  addObfuscator(position, url, options) {
    return __async(this, null, function* () {
      return yield createModel(this.sceneObject, position, url, "Obfuscator", options);
    });
  }
  addGroup(position, children) {
    return __async(this, null, function* () {
      return yield createGroup(this.sceneObject, position, children);
    });
  }
  addPrimitive(position, type, options) {
    return __async(this, null, function* () {
      this.createCss2dScene();
      const node2 = yield createPrimitive(this.sceneObject, position, type, options);
      if (type === "Box" || type === "Plane" || type === "Line") {
        for (const component of node2.componentIterator()) {
          this.prepareCss2dRenderer(component);
        }
      }
      return node2;
    });
  }
  addTransformControls(mode = "translate") {
    return __async(this, null, function* () {
      const node2 = yield this.sceneObject.addNode();
      node2.addComponent("mp.transformControls", { mode });
      node2.name = "transformControls";
      node2.start();
      return node2;
    });
  }
  addSkySphere(options = null) {
    return __async(this, null, function* () {
      return yield createSkySphere(this.sceneObject, options);
    });
  }
  addTotemModel(position, modelUrl, options = null) {
    return __async(this, null, function* () {
      return yield createTotemModel(this.sceneObject, position, modelUrl, options);
    });
  }
  addTotemHtml(position, src, options = null) {
    return __async(this, null, function* () {
      this.createCss3dScene();
      const node2 = yield createTotemHtml(this.sceneObject, position, src, options);
      for (const component of node2.componentIterator()) {
        this.addCss3dComponent(component);
      }
      return node2;
    });
  }
  addTotemImage(position, url, options = null) {
    return __async(this, null, function* () {
      this.createCss3dScene();
      const node2 = yield createTotemImage(this.sceneObject, position, url, options);
      for (const component of node2.componentIterator()) {
        this.addCss3dComponent(component);
      }
      return node2;
    });
  }
  addTotemMovie(position, url, options) {
    return __async(this, null, function* () {
      this.createCss3dScene();
      const node2 = yield createTotemMovie(this.sceneObject, position, url, options);
      for (const component of node2.componentIterator()) {
        this.addCss3dComponent(component);
      }
      return node2;
    });
  }
  addTotemMovieWithFrame(position, src, options = null) {
    return __async(this, null, function* () {
      this.createCss3dScene();
      const node2 = yield createTotemMovieWithFrame(this.sceneObject, position, src, options);
      for (const component of node2.componentIterator()) {
        this.addCss3dComponent(component);
      }
      return node2;
    });
  }
  addVideo(position, src, options = null) {
    return __async(this, null, function* () {
      return yield createVideo(this.sceneObject, position, src, options);
    });
  }
  addCss3dComponent(component) {
    this.prepareCss3dRenderer(component);
    hitCheckObjects.push(component.root.children[0]);
  }
}
var render$o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "pe-auto df justify-content-center",
    attrs: {
      "id": "dpm-shared-experience"
    }
  }, [_c("div", {
    staticClass: "button-container"
  }, [_c("v-switch", {
    staticClass: "mt-0 pt-0",
    attrs: {
      "disabled": !_vm.dpmStore.sharedExperience.isHost,
      "flat": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.notifyMode
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c("span", [_vm._v("フォロー")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.following,
      callback: function($$v) {
        _vm.following = $$v;
      },
      expression: "following"
    }
  })], 1), _vm.dpmStore.sharedExperience.isHost ? [_c("div", {
    staticClass: "button-container"
  }, [_c("v-btn", {
    attrs: {
      "fab": "",
      "small": "",
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        return _vm.subscription.createAction("call", {
          sid: _vm.dpmStore.current.sweep.sid,
          targetUserId: null
        });
      }
    }
  }, [_c("v-icon", {
    attrs: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiAccountMultiple))])], 1), _c("span", [_vm._v("全員呼ぶ")])], 1), _c("div", {
    staticClass: "button-container"
  }, [_c("div", {
    staticClass: "df"
  }, _vm._l(_vm.users, function(user) {
    return _c("div", {
      key: user.id,
      staticClass: "mx-1 text-center"
    }, [_c("div", [_c("span", {
      staticClass: "name-container d-block w-100"
    }, [_vm._v(_vm._s(user.name))]), _c("v-btn", {
      staticClass: "pe-none",
      attrs: {
        "fab": "",
        "small": "",
        "elevation": "0"
      }
    }, [_c("v-icon", {
      attrs: {
        "color": user.color
      }
    }, [_vm._v(_vm._s(_vm.$global.icons.mdiAccount))])], 1)], 1), _c("div", {
      staticClass: "host-buttons"
    }, [_c("v-tooltip", {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(_ref) {
          var on2 = _ref.on;
          return [_c("v-btn", _vm._g({
            attrs: {
              "fab": "",
              "x-small": "",
              "elevation": "3"
            },
            on: {
              "click": function($event) {
                return _vm.subscription.createAction("call", {
                  sid: _vm.dpmStore.current.sweep.sid,
                  targetUserId: user.id
                });
              }
            }
          }, on2), [_c("v-icon", {
            attrs: {
              "color": user.color,
              "size": "24"
            }
          }, [_vm._v(_vm._s(_vm.$global.icons.mdiMapMarkerDown))])], 1)];
        }
      }], null, true)
    }, [_c("span", [_vm._v("このゲストを呼ぶ")])]), _c("v-tooltip", {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(_ref2) {
          var on2 = _ref2.on;
          return [_c("v-btn", _vm._g({
            attrs: {
              "fab": "",
              "x-small": "",
              "elevation": "3"
            },
            on: {
              "click": function($event) {
                return _vm.subscription.createAction("move", {
                  targetUserId: user.id
                });
              }
            }
          }, on2), [_c("v-icon", {
            attrs: {
              "color": user.color,
              "size": "24"
            }
          }, [_vm._v(_vm._s(_vm.$global.icons.mdiMapMarkerUp))])], 1)];
        }
      }], null, true)
    }, [_c("span", [_vm._v("このゲストの現在地へ移動")])])], 1)]);
  }), 0)])] : _vm._e(), !_vm.dpmStore.sharedExperience.isHost ? _c("div", {
    staticClass: "button-container"
  }, [_c("div", {
    staticClass: "df"
  }, _vm._l(_vm.users, function(user) {
    return _c("div", {
      key: user.id,
      staticClass: "mx-1 text-center"
    }, [_c("span", {
      staticClass: "name-container"
    }, [_vm._v(_vm._s(user.name))]), _c("v-btn", {
      attrs: {
        "fab": "",
        "small": "",
        "elevation": "0"
      },
      on: {
        "click": function($event) {
          return _vm.subscription.createAction("move", {
            targetUserId: user.id
          });
        }
      }
    }, [_c("v-icon", {
      attrs: {
        "color": user.color
      }
    }, [_vm._v(_vm._s(_vm.$global.icons.mdiAccount))])], 1)], 1);
  }), 0), _c("span", [_vm._v("他のゲストの現在地へ移動")])]) : _vm._e()], 2);
};
var staticRenderFns$o = [];
const __vue2_script$o = {
  data() {
    return {
      beforePose: null,
      colorNames: ["#FF0000", "#0000FF", "#008800", "#00FFFF", "#FF00FF", "#FFFF00", "#FFC0CB", "#00FF00", "#4B0082", "#BEBEBE", "#DAA520", "#A52A2A"],
      currentMode: null,
      events: [],
      following: false,
      inTransition: false,
      movingSweep: false,
      navigating: false,
      movingCamera: false,
      subscription: null,
      users: []
    };
  },
  created() {
    return __async(this, null, function* () {
      var _a2;
      this.consumer = createConsumer();
      createjs.Ticker.addEventListener("tick", this.onTick.bind(this));
      if (!this.dpmStore.global.scene) {
        this.dpmStore.global.scene = new Scene2(document.getElementById("showcase"), this.$global.sdk, (_a2 = this.dpmStore.global.enableExtensions) == null ? void 0 : _a2.mattertag);
        yield this.dpmStore.global.scene.init();
      }
      const tmpNode = (yield this.$global.sdk.Scene.createObjects(1))[0].addNode();
      tmpNode.start();
      this.subscription = this.consumer.subscriptions.create({ channel: "RoomChannel", room: this.dpmStore.sharedExperience.room }, {
        connected: () => {
          this.subscription.createAction("requireUserData", {
            pose: this.dpmStore.current.pose,
            name: this.dpmStore.sharedExperience.name,
            num: this.dpmStore.sharedExperience.num,
            url: this.dpmStore.sharedExperience.avatarUrl
          });
        },
        disconnected: () => {
        },
        received: (received) => __async(this, null, function* () {
          var _a3, _b2;
          if (received.type === "message") {
            const div = document.createElement("div");
            div.classList.add("d-flex");
            div.innerHTML = received["message"];
            document.getElementById("message-list").prepend(div);
          }
          if (received.type === "action" && received.data.type === "leave") {
            this.users = this.users.filter((user) => user.id !== received.data.userId);
            (_a3 = this.getComponent(`Face - ${received.data.userId}`)) == null ? void 0 : _a3.onDestroy();
            (_b2 = this.getComponent(`GazeLine - ${received.data.userId}`)) == null ? void 0 : _b2.onDestroy();
          }
          if (received.type === "action" && received.data.userId !== this.dpmStore.sharedExperience.userId) {
            if (received.data.type === "follow" && !this.dpmStore.sharedExperience.isHost) {
              this.following = received.data.following;
              if (this.following && this.dpmStore.current.pose.mode !== received.data.mode) {
                received.data.type = "mode";
                this.events.push(received.data);
              }
            }
            if (this.following && received.data.hostUser) {
              if (received.data.type === "extension") {
                this.dpmStore.$patch({ current: { extension: received.data.extension } });
              } else {
                this.events.push(received.data);
              }
            }
            if (received.data.type && (received.data.targetUserId === this.dpmStore.sharedExperience.userId || received.data.targetUserId === null)) {
              this.events.push(received.data);
            }
            const faceComponent = this.getComponent(`Face - ${received.data.userId}`);
            if (faceComponent) {
              if (received.data.type === "sweep") {
                const sweep = this.dpmStore.global.sweeps[received.data.sid];
                faceComponent.onUpdatePosition({
                  x: sweep.position.x,
                  y: sweep.position.y,
                  z: sweep.position.z
                });
              }
              if (received.data.type === "camera") {
                faceComponent.onUpdateRotation({
                  x: -received.data.pose.rotation.x,
                  // NOTE: そのままだと逆回転するため
                  y: received.data.pose.rotation.y - 180
                  // NOTE: そのままだと半回転するため
                });
              }
            }
            const gazeLineComponent = this.getComponent(`GazeLine - ${received.data.userId}`);
            if (gazeLineComponent) {
              if (received.data.type === "sweep") {
                const sweep = this.dpmStore.global.sweeps[received.data.sid];
                gazeLineComponent.onUpdatePosition({
                  x: sweep.position.x,
                  y: sweep.position.y + 0.3,
                  z: sweep.position.z
                });
              }
              if (received.data.type === "pointer") {
                gazeLineComponent.onUpdateTarget(received.data.intersectionData);
              }
            }
            if (received.data.type === "createModel") {
              yield this.createModel(received.data);
            }
            if (received.data.type === "requireUserData") {
              this.subscription.createAction("createModel", {
                pose: this.dpmStore.current.pose,
                name: this.dpmStore.sharedExperience.name,
                num: this.dpmStore.sharedExperience.num,
                url: this.dpmStore.sharedExperience.avatarUrl
              });
              if (this.dpmStore.sharedExperience.isHost) {
                this.notifyMode();
              }
              yield this.createModel(received.data);
            }
            if (received.data.type === "move" && received.data.targetUserId === this.dpmStore.sharedExperience.userId) {
              this.subscription.createAction("call", {
                sid: this.dpmStore.current.sweep.sid,
                targetUserId: received.data.userId
              });
            }
          }
        }),
        createAction: (type, params) => {
          const data = {
            room: this.dpmStore.sharedExperience.room,
            userId: this.dpmStore.sharedExperience.userId,
            hostUser: this.dpmStore.sharedExperience.isHost,
            type
          };
          this.subscription.perform("action", _merge(data, params));
        },
        clickTag: (tagSid, openModal) => {
          if (this.following && this.dpmStore.sharedExperience.isHost) {
            this.subscription.createAction("tag", { sid: tagSid, openModal });
          }
        }
      });
      this.$global.sdk.on(this.$global.sdk.Mattertag.Event.CLICK, (tagSid) => {
        this.subscription.clickTag(tagSid, this.dpmStore.current.extension !== null);
      });
      this.$global.sdk.Pointer.intersection.subscribe((intersectionData) => {
        this.subscription.createAction("pointer", { intersectionData });
      });
      this.$global.sdk.Camera.zoom.subscribe((zoom) => {
        if (this.following && this.dpmStore.sharedExperience.isHost) {
          this.subscription.createAction("zoom", { zoom: zoom.level });
        }
      });
      this.$global.sdk.on(this.$global.sdk.Sweep.Event.EXIT, (fromSweep, toSweep) => {
        if (fromSweep && toSweep) {
          this.movingSweep = true;
        }
      });
      this.$global.sdk.on(this.$global.sdk.Sweep.Event.ENTER, (_oldSweep, _newSweep) => {
        this.movingSweep = false;
      });
      this.dpmStore.sharedExperience.subscription = this.subscription;
      this.dpmStore.$subscribe((mutation, _state) => {
        var _a3, _b2, _c, _d2, _e, _f, _g, _h, _i2, _j, _k, _l, _m, _n2, _o, _p;
        if (mutation.type.includes("patch") && ((_b2 = (_a3 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _a3.current) == null ? void 0 : _b2.sweep)) {
          if (mutation.payload.current.sweep.sid) {
            this.subscription.createAction("sweep", { sid: this.dpmStore.current.sweep.sid });
          }
        }
        if (mutation.type.includes("patch") && ((_d2 = (_c = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _c.current) == null ? void 0 : _d2.pose)) {
          const pose = JSON.parse(JSON.stringify(mutation.payload.current.pose));
          if (pose.mode !== this.$global.sdk.Mode.Mode.TRANSITIONING) {
            if (pose.mode === this.$global.sdk.Mode.Mode.INSIDE) {
              if (!this.movingSweep && (((_e = this.beforePose) == null ? void 0 : _e.rotation.x) !== pose.rotation.x || ((_f = this.beforePose) == null ? void 0 : _f.rotation.y) !== pose.rotation.y)) {
                this.subscription.createAction("camera", { pose: this.dpmStore.current.pose });
              }
            } else {
              if (((_g = this.beforePose) == null ? void 0 : _g.rotation.x) !== pose.rotation.x || ((_h = this.beforePose) == null ? void 0 : _h.rotation.y) !== pose.rotation.y) {
                this.subscription.createAction("camera", { pose: this.dpmStore.current.pose });
              } else {
                if (this.beforePose.position) {
                  this.subscription.createAction("camera pan", { pose: this.dpmStore.current.pose });
                }
              }
            }
          }
          this.beforePose = pose;
        }
        if (mutation.type.includes("patch") && ((_j = (_i2 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _i2.current) == null ? void 0 : _j.mode)) {
          this.currentMode = mutation.payload.current.mode;
          if (this.following && this.dpmStore.sharedExperience.isHost && this.currentMode !== this.$global.sdk.Mode.Mode.TRANSITIONING) {
            this.subscription.createAction("mode", { mode: this.currentMode });
          }
        }
        if (this.dpmStore.sharedExperience.isHost && this.following && mutation.type.includes("patch")) {
          if (((_l = (_k = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _k.current) == null ? void 0 : _l.extension) || ((_n2 = (_m = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _m.current) == null ? void 0 : _n2.extension) === null) {
            this.subscription.createAction("extension", { extension: mutation.payload.current.extension });
          }
          if (((_p = (_o = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _o.current) == null ? void 0 : _p.floor) && mutation.payload.current.floor.sequence >= 0) {
            this.subscription.createAction("floor", { floor: mutation.payload.current.floor.sequence });
          }
        }
      });
    });
  },
  methods: {
    notifyMode() {
      this.subscription.createAction("follow", { following: this.following });
    },
    createModel(data) {
      return __async(this, null, function* () {
        if (!this.getComponent(`Face - ${data.userId}`)) {
          yield this.dpmStore.global.scene.addFace(data.userId, {
            position: {
              x: data.pose.position.x,
              y: data.pose.position.y,
              z: data.pose.position.z
            },
            rotation: {
              x: -data.pose.rotation.x,
              y: data.pose.rotation.y - 180
            },
            num: data.num,
            url: data.url,
            name: data.name
          });
          yield this.dpmStore.global.scene.addGazeLine(data.userId, {
            position: {
              x: data.pose.position.x,
              y: data.pose.position.y + 0.3,
              z: data.pose.position.z
            },
            num: data.num
          });
          const colorName2 = data.num < 12 ? this.colorNames[data.num] : this.colorNames[data.num % 12];
          this.users.push({ id: data.userId, name: data.name, color: colorName2 });
        }
      });
    },
    getComponent(componentId) {
      for (const node2 of this.dpmStore.global.scene.sceneObject.nodeIterator()) {
        if (node2.name === componentId) {
          for (const component of node2.componentIterator()) {
            if (component.inputs.componentId === componentId) {
              return component;
            }
          }
        }
      }
      return null;
    },
    onTick() {
      return __async(this, null, function* () {
        if (this.events.length === 0 || this.inTransition) {
          return;
        }
        const nextEvent = this.events.shift();
        if (this.movingCamera || this.navigating) {
          return;
        }
        this.inTransition = true;
        switch (nextEvent.type) {
          case "sweep":
          case "call":
            yield this.$global.sdk.Sweep.moveTo(nextEvent.sid, {
              transition: this.$global.sdk.Sweep.Transition.FADEOUT
            }).catch(() => {
            });
            break;
          case "camera":
            if (nextEvent.pose.mode === this.$global.sdk.Mode.Mode.INSIDE && !this.movingSweep) {
              yield this.$global.sdk.Camera.setRotation({
                x: nextEvent.pose.rotation.x,
                y: nextEvent.pose.rotation.y
              }, {
                speed: 360
              }).catch(() => {
              });
            }
            if (nextEvent.pose.mode === this.$global.sdk.Mode.Mode.DOLLHOUSE || nextEvent.pose.mode === this.$global.sdk.Mode.Mode.FLOORPLAN) {
              this.movingCamera = true;
              yield this.$global.sdk.Camera.rotate(
                nextEvent.pose.rotation.y - this.beforePose.rotation.y,
                -(nextEvent.pose.rotation.x - this.beforePose.rotation.x),
                { speed: 120 }
              ).catch(() => {
              });
              this.movingCamera = false;
            }
            break;
          case "camera pan":
            if ((nextEvent.pose.mode === this.$global.sdk.Mode.Mode.DOLLHOUSE || nextEvent.pose.mode === this.$global.sdk.Mode.Mode.FLOORPLAN) && (Math.abs(this.beforePose.position.x - nextEvent.pose.position.x) > 0.01 || Math.abs(this.beforePose.position.z - nextEvent.pose.position.z) > 0.01)) {
              this.movingCamera = true;
              yield this.$global.sdk.Camera.pan({
                x: nextEvent.pose.position.x,
                z: nextEvent.pose.position.z
              }).catch(() => {
              });
              this.movingCamera = false;
            }
            break;
          case "zoom":
            if (this.beforePose.mode === this.$global.sdk.Mode.Mode.INSIDE && !this.movingSweep) {
              yield this.$global.sdk.Camera.zoomTo(nextEvent.zoom).catch(() => {
              });
            }
            break;
          case "tag":
            if (nextEvent.openModal) {
              const mattertag = this.dpmStore.SED.mattertags.find((mattertag2) => mattertag2.sid === nextEvent.sid);
              if (mattertag == null ? void 0 : mattertag.extension) {
                this.dpmStore.$patch({ current: { extension: mattertag.extension } });
              }
            } else {
              yield this.$global.sdk.Mattertag.navigateToTag(nextEvent.sid, this.$global.sdk.Mattertag.Transition.FADEOUT);
            }
            window.focusedTagSid = nextEvent.sid;
            this.navigating = true;
            setTimeout(() => {
              this.navigating = false;
            }, 3e3);
            break;
          case "mode":
            yield this.$global.sdk.Mode.moveTo(nextEvent.mode).catch(() => {
            });
            this.navigating = true;
            setTimeout(() => {
              this.navigating = false;
            }, 1e3);
            break;
          case "floor":
            if (this.currentMode === this.$global.sdk.Mode.Mode.DOLLHOUSE || this.currentMode === this.$global.sdk.Mode.Mode.FLOORPLAN) {
              yield this.$global.sdk.Floor.moveTo(nextEvent.floor);
            }
            break;
        }
        this.inTransition = false;
      });
    }
  },
  computed: __spreadValues({}, mapStores(useDpmStore))
};
const __cssModules$o = {};
var __component__$o = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$o,
  render$o,
  staticRenderFns$o,
  false,
  __vue2_injectStyles$o,
  null,
  null,
  null
);
function __vue2_injectStyles$o(context) {
  for (let o in __cssModules$o) {
    this[o] = __cssModules$o[o];
  }
}
const SharedExperience = /* @__PURE__ */ function() {
  return __component__$o.exports;
}();
var reWhitespace = /\s/;
function trimmedEndIndex$1(string) {
  var index2 = string.length;
  while (index2-- && reWhitespace.test(string.charAt(index2))) {
  }
  return index2;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var _baseTrim = baseTrim$1;
var baseTrim = _baseTrim, isObject = isObject_1, isSymbol = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$1(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;
var toNumber = toNumber_1;
var INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
var toFinite_1 = toFinite$1;
var toFinite = toFinite_1;
function toInteger$1(value) {
  var result2 = toFinite(value), remainder = result2 % 1;
  return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
}
var toInteger_1 = toInteger$1;
var baseSlice = _baseSlice, isIterateeCall = _isIterateeCall, toInteger = toInteger_1;
var nativeCeil = Math.ceil, nativeMax = Math.max;
function chunk(array, size, guard) {
  if (guard ? isIterateeCall(array, size, guard) : size === void 0) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index2 = 0, resIndex = 0, result2 = Array(nativeCeil(length / size));
  while (index2 < length) {
    result2[resIndex++] = baseSlice(array, index2, index2 += size);
  }
  return result2;
}
var chunk_1 = chunk;
const _chunk = /* @__PURE__ */ getDefaultExportFromCjs(chunk_1);
var baseClone = _baseClone;
var CLONE_SYMBOLS_FLAG = 4;
function clone$1(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}
var clone_1 = clone$1;
const _clone = /* @__PURE__ */ getDefaultExportFromCjs(clone_1);
var render$n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("v-dialog", {
    attrs: {
      "content-class": "m-3 dpm-image-detail-modal dpm-modal",
      "eager": "",
      "scrollable": ""
    },
    model: {
      value: _vm.dialog,
      callback: function($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c("v-card", [_c("v-card-title", [_vm._v("画像詳細")]), _c("v-divider"), _c("v-card-text", {
    staticClass: "p-3"
  }, [_c("div", {
    staticClass: "df justify-content-center"
  }, [_c("img", {
    attrs: {
      "src": _vm.imageSrc,
      "height": "400"
    }
  })]), _c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "label": "タイトル"
    },
    model: {
      value: _vm.imageData.title,
      callback: function($$v) {
        _vm.$set(_vm.imageData, "title", $$v);
      },
      expression: "imageData.title"
    }
  })], 1)], 1), _c("v-row", [_c("v-col", [_c("v-textarea", {
    attrs: {
      "label": "説明文"
    },
    model: {
      value: _vm.imageData.description,
      callback: function($$v) {
        _vm.$set(_vm.imageData, "description", $$v);
      },
      expression: "imageData.description"
    }
  })], 1)], 1)], 1), _c("v-divider"), _c("v-card-actions", {
    staticClass: "justify-content-end"
  }, [_c("v-btn", {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog = false;
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))]), _vm._v("閉じる")], 1)], 1)], 1)], 1);
};
var staticRenderFns$n = [];
const __vue2_script$n = {
  data() {
    return initialState$3();
  },
  watch: {
    dialog(visible) {
      if (visible)
        ;
      else {
        Object.assign(this.$data, initialState$3());
      }
    }
  },
  methods: {
    openDialog(src, data) {
      this.imageSrc = src;
      this.imageData = data;
      this.dialog = true;
    }
  }
};
const initialState$3 = () => {
  return {
    dialog: false,
    imageData: { title: "", description: "", src: "" },
    imageSrc: null
  };
};
const __cssModules$n = {};
var __component__$n = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$n,
  render$n,
  staticRenderFns$n,
  false,
  __vue2_injectStyles$n,
  null,
  null,
  null
);
function __vue2_injectStyles$n(context) {
  for (let o in __cssModules$n) {
    this[o] = __cssModules$n[o];
  }
}
const ImageDetail = /* @__PURE__ */ function() {
  return __component__$n.exports;
}();
var render$m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  _vm._self._c || _h;
  return _vm._m(0);
};
var staticRenderFns$m = [function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "quill-editor-wrapper"
  }, [_c("div", {
    staticClass: "ql-toolbar ql-snow",
    attrs: {
      "id": "toolbar-container"
    }
  }, [_c("span", {
    staticClass: "ql-formats"
  }, [_c("select", {
    staticClass: "ql-font"
  }), _c("select", {
    staticClass: "ql-size"
  })]), _c("span", {
    staticClass: "ql-formats"
  }, [_c("button", {
    staticClass: "ql-bold"
  }), _c("button", {
    staticClass: "ql-italic"
  }), _c("button", {
    staticClass: "ql-underline"
  }), _c("button", {
    staticClass: "ql-strike"
  })]), _c("span", {
    staticClass: "ql-formats"
  }, [_c("select", {
    staticClass: "ql-color"
  }), _c("select", {
    staticClass: "ql-background"
  })]), _c("span", {
    staticClass: "ql-formats"
  }, [_c("button", {
    staticClass: "ql-script",
    attrs: {
      "value": "sub"
    }
  }), _c("button", {
    staticClass: "ql-script",
    attrs: {
      "value": "super"
    }
  })]), _c("span", {
    staticClass: "ql-formats"
  }, [_c("button", {
    staticClass: "ql-header",
    attrs: {
      "value": "1"
    }
  }), _c("button", {
    staticClass: "ql-header",
    attrs: {
      "value": "2"
    }
  }), _c("button", {
    staticClass: "ql-blockquote"
  }), _c("button", {
    staticClass: "ql-code-block"
  })]), _c("span", {
    staticClass: "ql-formats"
  }, [_c("button", {
    staticClass: "ql-list",
    attrs: {
      "value": "ordered"
    }
  }), _c("button", {
    staticClass: "ql-list",
    attrs: {
      "value": "bullet"
    }
  }), _c("button", {
    staticClass: "ql-indent",
    attrs: {
      "value": "-1"
    }
  }), _c("button", {
    staticClass: "ql-indent",
    attrs: {
      "value": "+1"
    }
  })]), _c("span", {
    staticClass: "ql-formats"
  }, [_c("button", {
    staticClass: "ql-direction",
    attrs: {
      "value": "rtl"
    }
  }), _c("select", {
    staticClass: "ql-align"
  })]), _c("span", {
    staticClass: "ql-formats"
  }, [_c("button", {
    staticClass: "ql-link"
  }), _c("button", {
    staticClass: "ql-video"
  }), _c("button", {
    staticClass: "ql-formula"
  })]), _c("span", {
    staticClass: "ql-formats"
  }, [_c("button", {
    staticClass: "ql-clean"
  })])]), _c("div", {
    staticClass: "ql-container ql-snow",
    attrs: {
      "id": "quill-editor"
    }
  })]);
}];
const __vue2_script$m = {
  props: ["useBy"],
  components: {},
  data() {
    return {
      languages: ["en-US", "en", "ja", "ko", "zh-CN", "zh-TW"],
      quill: null
    };
  },
  created() {
    this.cilbeeStore.$subscribe((mutation, _state) => {
      var _a2;
      if (mutation.type.includes("patch") && ((_a2 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _a2.selectedLanguage)) {
        this.quill.clipboard.dangerouslyPasteHTML(this.dpmStore.SED.cilbee.arrivedText[this.languages[this.cilbeeStore.selectedLanguage]]);
      }
    });
  },
  mounted() {
    var _a2, _b2;
    this.quill = new Quill("#quill-editor", {
      modules: {
        toolbar: "#toolbar-container"
      },
      theme: "snow"
    });
    this.quill.on("text-change", (_delta, _oldDelta, _source) => {
      if (this.useBy === "cilbee") {
        this.dpmStore.SED.cilbee.arrivedText[this.languages[this.cilbeeStore.selectedLanguage]] = this.quill.root.innerHTML;
      } else {
        this.dpmStore.currentEditData(this.useBy).extension.data.htmlText = this.quill.root.innerHTML;
      }
    });
    if (this.useBy === "cilbee") {
      this.quill.clipboard.dangerouslyPasteHTML(this.dpmStore.SED.cilbee.arrivedText[this.languages[this.cilbeeStore.selectedLanguage]]);
    } else {
      if ((_b2 = (_a2 = this.dpmStore.currentEditData(this.useBy).extension) == null ? void 0 : _a2.data) == null ? void 0 : _b2.htmlText) {
        this.quill.clipboard.dangerouslyPasteHTML(this.dpmStore.currentEditData(this.useBy).extension.data.htmlText);
      }
    }
  },
  computed: __spreadValues({}, mapStores(useDpmStore, useCilbeeStore)),
  methods: {}
};
const __cssModules$m = {};
var __component__$m = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$m,
  render$m,
  staticRenderFns$m,
  false,
  __vue2_injectStyles$m,
  null,
  null,
  null
);
function __vue2_injectStyles$m(context) {
  for (let o in __cssModules$m) {
    this[o] = __cssModules$m[o];
  }
}
const quillEditor = /* @__PURE__ */ function() {
  return __component__$m.exports;
}();
var render$l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "dpm-extension-editor"
  }, [_c("v-select", {
    attrs: {
      "items": _vm.types,
      "label": "拡張タイプを指定してください",
      "hide-details": ""
    },
    on: {
      "change": _vm.onChangeType
    },
    model: {
      value: _vm.dpmStore.currentEditData(_vm.useBy).extension.type,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditData(_vm.useBy).extension, "type", $$v);
      },
      expression: "dpmStore.currentEditData(useBy).extension.type"
    }
  }), _vm.dpmStore.currentEditData(_vm.useBy).extension.type !== "none" && _vm.dpmStore.currentEditData(_vm.useBy).extension.type !== "link" && _vm.dpmStore.currentEditData(_vm.useBy).extension.type !== "panorama" ? _c("div", {
    staticClass: "mt-2",
    attrs: {
      "id": "type-any"
    }
  }, [_c("v-row", [_c("v-col", {
    attrs: {
      "cols": "6"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "モーダルの最大横幅(px)",
      "hide-details": ""
    },
    model: {
      value: _vm.dpmStore.currentEditData(_vm.useBy).extension.maxWidth,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditData(_vm.useBy).extension, "maxWidth", $$v);
      },
      expression: "dpmStore.currentEditData(useBy).extension.maxWidth"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "6"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "モーダルの最大縦幅(px)",
      "hide-details": ""
    },
    model: {
      value: _vm.dpmStore.currentEditData(_vm.useBy).extension.maxHeight,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditData(_vm.useBy).extension, "maxHeight", $$v);
      },
      expression: "dpmStore.currentEditData(useBy).extension.maxHeight"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.dpmStore.currentEditData(_vm.useBy).extension.type === "iframe" ? _c("div", {
    staticClass: "mt-4",
    attrs: {
      "id": "type-iframe"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "src"
    },
    model: {
      value: _vm.dpmStore.currentEditData(_vm.useBy).extension.data.iframeSrc,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditData(_vm.useBy).extension.data, "iframeSrc", $$v);
      },
      expression: "dpmStore.currentEditData(useBy).extension.data.iframeSrc"
    }
  })], 1) : _vm._e(), _vm.dpmStore.currentEditData(_vm.useBy).extension.type === "images" ? _c("div", {
    staticClass: "mt-4",
    attrs: {
      "id": "type-images"
    }
  }, [_vm.imageUrls.length ? _c("v-row", [_c("v-col", [_c("div", {
    staticClass: "lightbox-wrapper mt-3"
  }, [_c("CoolLightBox", {
    attrs: {
      "items": _vm.imageUrls,
      "index": _vm.lightboxIndex,
      "useZoomBar": true,
      "thumbsPosition": "bottom",
      "showThumbs": true
    },
    on: {
      "close": function($event) {
        _vm.lightboxIndex = null;
      }
    }
  }), _c("div", {
    staticClass: "thumbnails-wrapper"
  }, [_c("v-row", _vm._l(_vm.imageUrls, function(imageUrl, imageIndex) {
    return _c("v-col", {
      key: imageIndex,
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c("div", {
      staticClass: "image w-100 df justify-content-end",
      style: {
        backgroundImage: "url(" + imageUrl + ")"
      },
      on: {
        "click": function($event) {
          _vm.lightboxIndex = imageIndex;
        }
      }
    }, [_c("v-btn", {
      staticClass: "m-1",
      staticStyle: {
        "height": "30px",
        "padding": "4px"
      },
      attrs: {
        "color": "primary",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editImageDetail(imageIndex);
        }
      }
    }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPencil))])], 1), _c("v-btn", {
      staticClass: "m-1",
      staticStyle: {
        "height": "30px",
        "padding": "4px"
      },
      attrs: {
        "color": "error",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteImage(imageIndex);
        }
      }
    }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))])], 1)], 1)]);
  }), 1)], 1)], 1)])], 1) : _vm._e(), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "9"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "追加する画像のURL"
    },
    model: {
      value: _vm.addedImageUrl,
      callback: function($$v) {
        _vm.addedImageUrl = $$v;
      },
      expression: "addedImageUrl"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "3"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.addedImageUrl
    },
    on: {
      "click": _vm.addImageUrl
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPlus))]), _vm._v("追加")], 1)], 1)], 1), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "9"
    }
  }, [_c("v-file-input", {
    attrs: {
      "multiple": "",
      "label": "アップロードするファイル",
      "messages": "複数ある場合はまとめてアップロードしてください。10MBまでのjpg, png, gifファイルがアップロード可能です。",
      "accept": ".jpg, .jpeg, .png, .gif"
    },
    model: {
      value: _vm.uploadedImageFiles,
      callback: function($$v) {
        _vm.uploadedImageFiles = $$v;
      },
      expression: "uploadedImageFiles"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "3"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.uploadedImageFiles
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiUpload))]), _vm._v("アップロード")], 1)], 1)], 1), _c("div", {
    staticClass: "text-muted mt-2"
  }, [_vm._v(_vm._s(`登録出来る画像は${_vm.MAX_IMAGE_NUM}枚までです。`))])], 1) : _vm._e(), _vm.dpmStore.currentEditData(_vm.useBy).extension.type === "video" ? _c("div", {
    staticClass: "mt-4",
    attrs: {
      "id": "type-video"
    }
  }, [_c("v-row", [_c("v-col", {
    staticClass: "position-relative"
  }, [_vm.videoHtmlText ? _c("div", {
    staticClass: "media-wrapper",
    domProps: {
      "innerHTML": _vm._s(_vm.videoHtmlText)
    }
  }) : _vm._e(), _vm.videoTagSrc ? _c("div", {
    staticClass: "media-wrapper"
  }, [_c("video", {
    attrs: {
      "src": _vm.videoTagSrc,
      "controls": ""
    }
  })]) : _vm._e(), _vm.videoHtmlText || _vm.videoTagSrc ? _c("div", {
    staticClass: "position-absolute top-0 end-0 m-3"
  }, [_c("v-btn", {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.deleteVideo
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v("削除")], 1)], 1) : _vm._e()])], 1), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "9"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "埋め込む動画のURL",
      "messages": "動画ファイルのURLか、YouTubeもしくはVimeoのURLを設定してください。"
    },
    model: {
      value: _vm.addedVideoUrl,
      callback: function($$v) {
        _vm.addedVideoUrl = $$v;
      },
      expression: "addedVideoUrl"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "3"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.addedVideoUrl
    },
    on: {
      "click": _vm.addVideo
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPlus))]), _vm._v("決定")], 1)], 1)], 1), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "9"
    }
  }, [_c("v-file-input", {
    attrs: {
      "label": "アップロードするファイル",
      "messages": "50MBまでのmp4, webmファイルがアップロード可能です。",
      "accept": ".mp4, .webm"
    },
    model: {
      value: _vm.uploadedVideoFile,
      callback: function($$v) {
        _vm.uploadedVideoFile = $$v;
      },
      expression: "uploadedVideoFile"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "3"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.uploadedVideoFile
    },
    on: {
      "click": _vm.uploadVideo
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiUpload))]), _vm._v("アップロード")], 1)], 1)], 1), _c("div", {
    staticClass: "mt-2"
  }, [_c("v-checkbox", {
    attrs: {
      "label": "自動再生",
      "messages": "登録出来る動画は1つだけです。追加登録した場合、古い物は自動的に削除されます。"
    },
    model: {
      value: _vm.dpmStore.currentEditData(_vm.useBy).extension.data.autoPlayVideo,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditData(_vm.useBy).extension.data, "autoPlayVideo", $$v);
      },
      expression: "dpmStore.currentEditData(useBy).extension.data.autoPlayVideo"
    }
  })], 1), _c("v-divider", {
    staticClass: "my-3"
  }), _c("h6", {
    staticClass: "mt-5"
  }, [_vm._v("フローティング設定")]), _vm._v("この設定を有効にすると" + _vm._s(_vm.showcaseAlias) + "が操作可能な状態で動画を表示します。"), _c("br"), _vm._v("※フローティング表示ではデフォルトだと「最大横幅が320pxで、アスペクト比が16:9」の表示になります。"), _c("br"), _vm._v("※フローティング表示が有効な場合、モーダルの最大縦幅設定は効かず、表示サイズの計算のみに使われます。"), _c("v-select", {
    staticClass: "mt-2",
    attrs: {
      "label": "動画が表示される場所を選択して下さい",
      "items": _vm.floatPositions,
      "menu-props": {
        top: true,
        offsetY: true
      }
    },
    model: {
      value: _vm.dpmStore.currentEditData(_vm.useBy).extension.data.floatingPosition,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditData(_vm.useBy).extension.data, "floatingPosition", $$v);
      },
      expression: "dpmStore.currentEditData(useBy).extension.data.floatingPosition"
    }
  })], 1) : _vm._e(), _vm.dpmStore.currentEditData(_vm.useBy).extension.type === "audio" ? _c("div", {
    staticClass: "mt-4",
    attrs: {
      "id": "type-audio"
    }
  }, [_c("v-row", [_c("v-col", {
    staticClass: "position-relative"
  }, [_vm.audioHtmlText ? _c("div", {
    staticClass: "media-wrapper",
    domProps: {
      "innerHTML": _vm._s(_vm.audioHtmlText)
    }
  }) : _vm._e(), _vm.audioTagSrc ? _c("div", {
    staticClass: "media-wrapper"
  }, [_c("audio", {
    attrs: {
      "src": _vm.audioTagSrc,
      "controls": ""
    }
  })]) : _vm._e(), _vm.audioHtmlText || _vm.audioTagSrc ? _c("div", {
    staticClass: "position-absolute top-0 end-0 m-3"
  }, [_c("v-btn", {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.deleteAudio
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v("削除")], 1)], 1) : _vm._e()])], 1), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "9"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "埋め込む音声のURL",
      "messages": "音声ファイルのURLか、SoundCloudのURLを設定してください。"
    },
    model: {
      value: _vm.addedAudioUrl,
      callback: function($$v) {
        _vm.addedAudioUrl = $$v;
      },
      expression: "addedAudioUrl"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "3"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.addedAudioUrl
    },
    on: {
      "click": _vm.addAudio
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPlus))]), _vm._v("決定")], 1)], 1)], 1), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "9"
    }
  }, [_c("v-file-input", {
    attrs: {
      "label": "アップロードするファイル",
      "messages": "10MBまでのmp3ファイルがアップロード可能です。",
      "accept": ".mp3"
    },
    model: {
      value: _vm.uploadedAudioFile,
      callback: function($$v) {
        _vm.uploadedAudioFile = $$v;
      },
      expression: "uploadedAudioFile"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "3"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.uploadedAudioFile
    },
    on: {
      "click": _vm.uploadAudio
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiUpload))]), _vm._v("アップロード")], 1)], 1)], 1), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "6"
    }
  }, [_c("v-checkbox", {
    attrs: {
      "label": "自動再生",
      "hide-details": ""
    },
    model: {
      value: _vm.dpmStore.currentEditData(_vm.useBy).extension.data.autoPlayAudio,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditData(_vm.useBy).extension.data, "autoPlayAudio", $$v);
      },
      expression: "dpmStore.currentEditData(useBy).extension.data.autoPlayAudio"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "6"
    }
  }, [_c("v-checkbox", {
    attrs: {
      "label": "他の拡張のBGMとして再生",
      "messages": "拡張タイプが動画・音声の時は無視されます。"
    },
    model: {
      value: _vm.dpmStore.currentEditData(_vm.useBy).extension.data.useAsBgm,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditData(_vm.useBy).extension.data, "useAsBgm", $$v);
      },
      expression: "dpmStore.currentEditData(useBy).extension.data.useAsBgm"
    }
  })], 1)], 1), _c("div", {
    staticClass: "text-muted mt-2"
  }, [_vm._v("登録出来る音声は1つだけです。追加登録した場合、古い物は自動的に削除されます。")])], 1) : _vm._e(), _vm.dpmStore.currentEditData(_vm.useBy).extension.type === "link" ? _c("div", {
    staticClass: "mt-4",
    attrs: {
      "id": "type-link"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "リンクアドレス"
    },
    model: {
      value: _vm.dpmStore.currentEditData(_vm.useBy).extension.data.linkAddress,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditData(_vm.useBy).extension.data, "linkAddress", $$v);
      },
      expression: "dpmStore.currentEditData(useBy).extension.data.linkAddress"
    }
  })], 1) : _vm._e(), _vm.dpmStore.currentEditData(_vm.useBy).extension.type === "html" ? _c("div", {
    staticClass: "mt-4",
    attrs: {
      "id": "type-html"
    }
  }, [_c("quillEditor", {
    attrs: {
      "useBy": _vm.useBy
    }
  })], 1) : _vm._e(), _vm.dpmStore.currentEditData(_vm.useBy).extension.type === "panorama" ? _c("div", {
    staticClass: "mt-4",
    attrs: {
      "id": "type-panorama"
    }
  }, [_c("v-row", [_c("v-col", {
    staticClass: "position-relative"
  }, [_vm.panoramaSrc ? _c("div", {
    staticClass: "media-wrapper"
  }, [_c("img", {
    attrs: {
      "src": _vm.panoramaSrc
    }
  })]) : _vm._e(), _vm.panoramaSrc ? _c("div", {
    staticClass: "position-absolute top-0 end-0 m-3"
  }, [_c("v-btn", {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.deletePanorama
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v("削除")], 1)], 1) : _vm._e()])], 1), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "9"
    }
  }, [_c("v-file-input", {
    attrs: {
      "label": "アップロードするファイル",
      "messages": "10MBまでのjpg, pngファイルがアップロード可能です。",
      "accept": ".jpg, .png"
    },
    model: {
      value: _vm.uploadedPanoramaFile,
      callback: function($$v) {
        _vm.uploadedPanoramaFile = $$v;
      },
      expression: "uploadedPanoramaFile"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "3"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.uploadedPanoramaFile
    },
    on: {
      "click": _vm.uploadPanorama
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiUpload))]), _vm._v("アップロード")], 1)], 1)], 1)], 1) : _vm._e(), _vm.dpmStore.currentEditData(_vm.useBy).extension.type === "pdf" ? _c("div", {
    staticClass: "mt-4",
    attrs: {
      "id": "type-pdf"
    }
  }, [_c("v-row", [_c("v-col", {
    staticClass: "position-relative"
  }, [_vm.pdfSrc ? _c("div", {
    staticClass: "media-wrapper"
  }, [_c("iframe", {
    staticClass: "w-100",
    attrs: {
      "src": _vm.pdfSrc,
      "height": "500",
      "scrolling": "no",
      "frameborder": "0",
      "allow": "fullscreen; picture-in-picture"
    }
  })]) : _vm._e(), _vm.pdfSrc ? _c("div", {
    staticClass: "position-absolute top-0 end-0 m-3"
  }, [_c("v-btn", {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.deletePdf
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v("削除")], 1)], 1) : _vm._e()])], 1), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "9"
    }
  }, [_c("v-file-input", {
    attrs: {
      "label": "アップロードするファイル",
      "messages": "10MBまでのpdfファイルがアップロード可能です。",
      "accept": ".pdf"
    },
    model: {
      value: _vm.uploadedPdfFile,
      callback: function($$v) {
        _vm.uploadedPdfFile = $$v;
      },
      expression: "uploadedPdfFile"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "3"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.uploadedPdfFile
    },
    on: {
      "click": _vm.uploadPdf
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiUpload))]), _vm._v("アップロード")], 1)], 1)], 1)], 1) : _vm._e(), _vm.dpmStore.mattertagEditor.errorText ? _c("div", {
    staticClass: "mt-2",
    attrs: {
      "id": "type-error"
    }
  }, [_c("span", {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.dpmStore.mattertagEditor.errorText))])]) : _vm._e(), _c("ImageDetail", {
    ref: "dpmImageDetailModal"
  })], 1);
};
var staticRenderFns$l = [];
const __vue2_script$l = {
  props: ["useBy"],
  components: {
    quillEditor,
    CoolLightBox,
    ImageDetail
  },
  data() {
    return initialState$2();
  },
  created() {
    return __async(this, null, function* () {
      if (!this.dpmStore.mattertagEditor.errorText) {
        yield this.setData();
      }
      if (this.useBy === "sweep") {
        this.types = this.types.filter((type) => type.value !== "link" && type.value !== "panorama" && type.value !== "pdf");
      }
    });
  },
  mounted() {
    document.addEventListener("focusin", this.focusinTox, true);
    this.showcaseAlias = document.getElementById("showcase").dataset.showcaseAlias || "ショーケース";
  },
  beforeDestroy() {
    document.removeEventListener("focusin", this.focusinTox, true);
  },
  computed: __spreadValues({}, mapStores(useDpmStore)),
  methods: {
    focusinTox(event) {
      if (event.target.closest(".tox-dialog")) {
        event.stopImmediatePropagation();
      }
    },
    setData() {
      return __async(this, null, function* () {
        var _a2;
        switch (this.useBy) {
          case "mattertag":
            if (!this.dpmStore.currentEditData(this.useBy)) {
              this.dpmStore.SED.mattertags.push({ sid: _clone$1(this.dpmStore.current.mattertagSid) });
            }
            break;
        }
        this.dpmStore.currentEditData(this.useBy).extension = __spreadValues(__spreadValues({}, this.initialExtensionData), this.dpmStore.currentEditData(this.useBy).extension);
        if (this.dpmStore.currentEditData(this.useBy).extension.data.images) {
          this.imageUrls.splice(0);
          this.imageUrls.push(...yield Promise.all(this.dpmStore.currentEditData(this.useBy).extension.data.images.map((image) => __async(this, null, function* () {
            if (image.src.indexOf("active_storage") !== -1) {
              const res = yield this.getMediaUrl("mattertag_images", image.src.split(":")[1]);
              return res;
            } else {
              return image.src;
            }
          }))));
        }
        if (this.dpmStore.currentEditData(this.useBy).extension.data.video) {
          if (this.dpmStore.currentEditData(this.useBy).extension.data.video.indexOf("active_storage") !== -1) {
            this.videoTagSrc = yield this.getMediaUrl("mattertag_videos", this.dpmStore.currentEditData(this.useBy).extension.data.video.split(":")[1]);
          } else {
            this.videoHtmlText = yield this.getMedia(this.dpmStore.currentEditData(this.useBy).extension.data.video, "video");
          }
        }
        if (this.dpmStore.currentEditData(this.useBy).extension.data.audio) {
          if (this.dpmStore.currentEditData(this.useBy).extension.data.audio.indexOf("active_storage") !== -1) {
            this.audioTagSrc = yield this.getMediaUrl("mattertag_audios", this.dpmStore.currentEditData(this.useBy).extension.data.audio.split(":")[1]);
          } else {
            this.audioHtmlText = yield this.getMedia(this.dpmStore.currentEditData(this.useBy).extension.data.audio, "audio");
          }
        }
        if (this.dpmStore.currentEditData(this.useBy).extension.data.panorama) {
          this.panoramaSrc = yield this.getMediaUrl("mattertag_panorama_images", this.dpmStore.currentEditData(this.useBy).extension.data.panorama.split(":")[1]);
        }
        if (this.dpmStore.currentEditData(this.useBy).extension.type === "none" && this.useBy === "mattertag") {
          const targetTagWithAttachmentsData = __spreadProps(__spreadValues({}, _clone$1(this.dpmStore.currentOriginMattertag)), {
            carouselItems: [],
            attachmentDownloadLinks: []
          });
          yield this.dpmStore.setAttachmentsData(targetTagWithAttachmentsData);
          if (!this.dpmStore.currentEditData(this.useBy).extension.data.images.length) {
            this.imageUrls.splice(0);
            targetTagWithAttachmentsData.carouselItems.filter((item) => item.type === "image" && !/matterport.com\/attachments/.test(item.src)).forEach((targetItem) => {
              this.dpmStore.currentEditData(this.useBy).extension.data.images.push({
                src: targetItem.src
              });
              this.imageUrls.push(targetItem.src);
            });
          }
          if (!this.dpmStore.currentEditData(this.useBy).extension.data.video) {
            targetTagWithAttachmentsData.carouselItems.filter((item) => /youtube|vimeo|video/.test(item.type) && !/matterport.com\/attachments/.test(item.src)).some((targetItem) => {
              const element = Object.assign(document.createElement("div"), { innerHTML: targetItem.src }).firstElementChild;
              this.dpmStore.currentEditData(this.useBy).extension.data.video = element.src;
              this.videoHtmlText = targetItem.src;
              return true;
            });
          }
          if (!this.dpmStore.currentEditData(this.useBy).extension.data.audio) {
            targetTagWithAttachmentsData.carouselItems.filter((item) => /soundcloud|audio/.test(item.type) && !/matterport.com\/attachments/.test(item.src)).some((targetItem) => {
              const element = Object.assign(document.createElement("div"), { innerHTML: targetItem.src }).firstElementChild;
              this.dpmStore.currentEditData(this.useBy).extension.data.audio = element.src;
              this.audioHtmlText = targetItem.src;
              return true;
            });
          }
          if (!this.dpmStore.currentEditData(this.useBy).extension.data.htmlText) {
            (_a2 = targetTagWithAttachmentsData.description) != null ? _a2 : targetTagWithAttachmentsData.description = "";
            this.dpmStore.currentEditData(this.useBy).extension.data.htmlText = esmEntry(targetTagWithAttachmentsData.description);
            targetTagWithAttachmentsData.carouselItems.filter((item) => /html/.test(item.type) && !/matterport.com\/attachments/.test(item.src)).forEach((targetItem) => {
              this.dpmStore.currentEditData(this.useBy).extension.data.htmlText += `${targetItem.src}<br>`;
            });
          }
        }
        if (this.dpmStore.currentEditData(this.useBy).extension.data.pdf) {
          const url = yield this.getMediaUrl("mattertag_images", this.dpmStore.currentEditData(this.useBy).extension.data.pdf.split(":")[1]);
          this.pdfSrc = `/pdfjs-2.13.216-dist/web/viewer.html?file=${url}`;
        }
      });
    },
    onChangeType() {
      return __async(this, null, function* () {
        this.dpmStore.mattertagEditor.errorText = "";
        yield this.setData();
      });
    },
    addImageUrl() {
      if (this.dpmStore.currentEditData(this.useBy).extension.data.images.length >= this.MAX_IMAGE_NUM) {
        this.dpmStore.mattertagEditor.errorText = `登録出来る画像は${this.MAX_IMAGE_NUM}枚までです。画像を削除してから追加してください。`;
        return;
      }
      this.dpmStore.currentEditData(this.useBy).extension.data.images.push({ title: "", description: "", src: this.addedImageUrl });
      this.imageUrls.push(this.addedImageUrl);
      this.addedImageUrl = null;
    },
    editImageDetail(index2) {
      this.$refs.dpmImageDetailModal.openDialog(this.imageUrls[index2], this.dpmStore.currentEditData(this.useBy).extension.data.images[index2]);
    },
    deleteImage(index2) {
      return __async(this, null, function* () {
        this.dpmStore.currentEditData(this.useBy).extension.data.images.splice(index2, 1);
        this.imageUrls.splice(index2, 1);
      });
    },
    uploadImage() {
      return __async(this, null, function* () {
        if (this.dpmStore.currentEditData(this.useBy).extension.data.images.length >= this.MAX_IMAGE_NUM) {
          this.dpmStore.mattertagEditor.errorText = `登録出来る画像は${this.MAX_IMAGE_NUM}枚までです。画像を削除してから追加してください。`;
          return;
        }
        const params = new FormData();
        this.uploadedImageFiles.forEach((file, i2) => params.append(`files[${i2}]`, file));
        const res = yield this.uploadMediaFile(params, "mattertag_images");
        if (res) {
          res.images.forEach((image) => {
            this.dpmStore.currentEditData(this.useBy).extension.data.images.push({ title: "", description: "", src: `active_storage:${image.id}` });
            this.imageUrls.push(image.url);
          });
          this.uploadedImageFiles = null;
          this.dpmStore.mattertagEditor.errorText = "";
        }
      });
    },
    addVideo() {
      return __async(this, null, function* () {
        this.videoHtmlText = yield this.getMedia(this.addedVideoUrl, "video");
        this.dpmStore.currentEditData(this.useBy).extension.data.video = _clone$1(this.addedVideoUrl);
        this.videoTagSrc = null;
        this.addedVideoUrl = null;
      });
    },
    deleteVideo() {
      return __async(this, null, function* () {
        this.videoHtmlText = null;
        this.videoTagSrc = null;
        this.dpmStore.currentEditData(this.useBy).extension.data.video = null;
      });
    },
    uploadVideo() {
      return __async(this, null, function* () {
        const params = new FormData();
        params.append("file", this.uploadedVideoFile);
        const res = yield this.uploadMediaFile(params, "mattertag_videos");
        if (res) {
          this.videoTagSrc = res.url;
          this.dpmStore.currentEditData(this.useBy).extension.data.video = `active_storage:${res.id}`;
          this.videoHtmlText = null;
          this.uploadedVideoFile = null;
          this.dpmStore.mattertagEditor.errorText = "";
        }
      });
    },
    addAudio() {
      return __async(this, null, function* () {
        this.audioHtmlText = yield this.getMedia(this.addedAudioUrl, "audio");
        this.dpmStore.currentEditData(this.useBy).extension.data.audio = _clone$1(this.addedAudioUrl);
        this.audioTagSrc = null;
        this.addedAudioUrl = null;
      });
    },
    deleteAudio() {
      return __async(this, null, function* () {
        this.audioHtmlText = null;
        this.audioTagSrc = null;
        this.dpmStore.currentEditData(this.useBy).extension.data.audio = null;
      });
    },
    uploadAudio() {
      return __async(this, null, function* () {
        const params = new FormData();
        params.append("file", this.uploadedAudioFile);
        const res = yield this.uploadMediaFile(params, "mattertag_audios");
        if (res) {
          this.audioTagSrc = res.url;
          this.dpmStore.currentEditData(this.useBy).extension.data.audio = `active_storage:${res.id}`;
          this.audioHtmlText = null;
          this.uploadedAudioFile = null;
          this.dpmStore.mattertagEditor.errorText = "";
        }
      });
    },
    deletePanorama() {
      return __async(this, null, function* () {
        this.panoramaSrc = null;
        this.dpmStore.currentEditData(this.useBy).extension.data.panorama = null;
      });
    },
    uploadPanorama() {
      return __async(this, null, function* () {
        const params = new FormData();
        params.append("file", this.uploadedPanoramaFile);
        const res = yield this.uploadMediaFile(params, "mattertag_panorama_images");
        if (res) {
          this.panoramaSrc = res.url;
          this.dpmStore.currentEditData(this.useBy).extension.data.panorama = `active_storage:${res.id}`;
          this.uploadedPanoramaFile = null;
          this.dpmStore.mattertagEditor.errorText = "";
        }
      });
    },
    deletePdf() {
      return __async(this, null, function* () {
        this.pdfSrc = null;
        this.dpmStore.currentEditData(this.useBy).extension.data.pdf = null;
      });
    },
    uploadPdf() {
      return __async(this, null, function* () {
        const params = new FormData();
        params.append("files[0]", this.uploadedPdfFile);
        const res = yield this.uploadMediaFile(params, "mattertag_images");
        if (res) {
          this.pdfSrc = `/pdfjs-2.13.216-dist/web/viewer.html?file=${res.images[0].url}`;
          this.dpmStore.currentEditData(this.useBy).extension.data.pdf = `active_storage:${res.images[0].id}`;
          this.uploadedPdfFile = null;
          this.dpmStore.mattertagEditor.errorText = "";
        }
      });
    },
    deleteMediaFile(fileSrc, type) {
      return __async(this, null, function* () {
        if (fileSrc && fileSrc.indexOf("active_storage") !== -1) {
          return yield axios$1.delete(
            `${this.$global.apiUrl}/purge_media?type=${type}&file_id=${fileSrc.split(":")[1]}`,
            { headers: this.$global.csrfHeader }
          ).catch((error2) => {
            this.dpmStore.mattertagEditor.errorText = error2;
          });
        }
      });
    },
    uploadMediaFile(params, type) {
      return __async(this, null, function* () {
        this.dpmStore.mattertagEditor.errorText = "";
        return axios$1.post(
          `${this.$global.apiUrl}/upload_media?type=${type}`,
          params,
          { headers: __spreadProps(__spreadValues({}, this.$global.csrfHeader), { "content-type": "multipart/form-data" }) }
        ).then((res) => {
          return res.data;
        }).catch((err2) => {
          this.dpmStore.mattertagEditor.errorText = err2.response.data.error || err2;
        });
      });
    },
    getMedia(src, type) {
      return __async(this, null, function* () {
        this.dpmStore.mattertagEditor.errorText = "";
        const res = yield this.$global.utils.getMediaHtml(src, type);
        if (res.error) {
          this.dpmStore.mattertagEditor.errorText = res.error;
          return null;
        }
        return res.html;
      });
    },
    getMediaUrl(type, id) {
      return __async(this, null, function* () {
        this.dpmStore.mattertagEditor.errorText = "";
        return axios$1.get(
          `${this.$global.apiUrl}/get_media_url?type=${type}&file_id=${id}`,
          { headers: this.$global.csrfHeader }
        ).then((res) => {
          return res.data.url;
        }).catch((err2) => {
          this.dpmStore.mattertagEditor.errorText = err2.response.data.error || err2;
        });
      });
    },
    apply() {
      this.dpmStore.mattertagEditor.errorText = "";
      switch (this.dpmStore.currentEditData(this.useBy).extension.type) {
        case "iframe":
          if (!this.dpmStore.currentEditData(this.useBy).extension.data.iframeSrc) {
            this.dpmStore.mattertagEditor.errorText = "srcを入力するか、拡張タイプを「拡張機能無し」にしてください。";
          }
          break;
        case "images":
          if (!this.dpmStore.currentEditData(this.useBy).extension.data.images.length) {
            this.dpmStore.mattertagEditor.errorText = "画像を追加するか、拡張タイプを「拡張機能無し」にしてください。";
          }
          break;
        case "video":
          if (!this.dpmStore.currentEditData(this.useBy).extension.data.video) {
            this.dpmStore.mattertagEditor.errorText = "動画を追加するか、拡張タイプを「拡張機能無し」にしてください。";
          }
          break;
        case "audio":
          if (!this.dpmStore.currentEditData(this.useBy).extension.data.audio) {
            this.dpmStore.mattertagEditor.errorText = "音声を追加するか、拡張タイプを「拡張機能無し」にしてください。";
          }
          break;
        case "link":
          if (!this.dpmStore.currentEditData(this.useBy).extension.data.linkAddress) {
            this.dpmStore.mattertagEditor.errorText = "アドレスを入力するか、拡張タイプを「拡張機能無し」にしてください。";
          }
          break;
        case "html":
          if (!this.dpmStore.currentEditData(this.useBy).extension.data.htmlText) {
            this.dpmStore.mattertagEditor.errorText = "HTMLを入力するか、拡張タイプを「拡張機能無し」にしてください。";
          }
          break;
        case "panorama":
          if (!this.dpmStore.currentEditData(this.useBy).extension.data.panorama) {
            this.dpmStore.mattertagEditor.errorText = "画像を追加するか、拡張タイプを「拡張機能無し」にしてください。";
          }
          break;
        case "pdf":
          if (!this.dpmStore.currentEditData(this.useBy).extension.data.pdf) {
            this.dpmStore.mattertagEditor.errorText = "ファイルを追加するか、拡張タイプを「拡張機能無し」にしてください。";
          }
          break;
      }
      if (this.dpmStore.currentEditData(this.useBy).extension.data.useAsBgm && !this.dpmStore.currentEditData(this.useBy).extension.data.audio && this.dpmStore.currentEditData(this.useBy).extension.type !== "video" && this.dpmStore.currentEditData(this.useBy).extension.type !== "audio") {
        this.dpmStore.mattertagEditor.errorText = "音声を追加するか、「他の拡張のBGMとして再生」のチェックを外してください。";
      }
      if (this.dpmStore.currentEditData(this.useBy).extension.type !== "video") {
        this.dpmStore.currentEditData(this.useBy).extension.data.floatingPosition = null;
      }
      return this.dpmStore.mattertagEditor.errorText ? false : true;
    }
  }
};
const initialState$2 = () => {
  return {
    addedAudioUrl: null,
    audioHtmlText: null,
    addedImageUrl: null,
    audioTagSrc: null,
    addedVideoUrl: null,
    floatPositions: [
      { value: null, text: "フローティングしない" },
      { value: "upperLeft", text: "左上" },
      { value: "upperCenter", text: "中央上" },
      { value: "upperRight", text: "右上" },
      { value: "left", text: "左" },
      { value: "center", text: "中央" },
      { value: "right", text: "右" },
      { value: "lowerLeft", text: "左下" },
      { value: "lowerCenter", text: "中央下" },
      { value: "lowerRight", text: "右下" }
    ],
    imageUrls: [],
    initialExtensionData: {
      type: "none",
      data: {
        autoPlayVideo: true,
        floatingPosition: null,
        autoPlayAudio: true,
        useAsBgm: false,
        images: [],
        video: null,
        audio: null
      }
    },
    lightboxIndex: null,
    MAX_IMAGE_NUM: 10,
    panoramaSrc: null,
    pdfSrc: null,
    types: [
      { value: "none", text: "拡張機能無し" },
      { value: "iframe", text: "iframe" },
      { value: "images", text: "画像" },
      { value: "video", text: "動画" },
      { value: "audio", text: "音声" },
      { value: "link", text: "リンク" },
      { value: "html", text: "HTML" },
      { value: "panorama", text: "パノラマ" },
      { value: "pdf", text: "PDF" }
    ],
    uploadedAudioFile: null,
    uploadedImageFiles: null,
    uploadedPanoramaFile: null,
    uploadedPdfFile: null,
    uploadedVideoFile: null,
    showcaseAlias: "",
    videoHtmlText: null,
    videoTagSrc: null
  };
};
const __cssModules$l = {};
var __component__$l = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$l,
  render$l,
  staticRenderFns$l,
  false,
  __vue2_injectStyles$l,
  null,
  null,
  null
);
function __vue2_injectStyles$l(context) {
  for (let o in __cssModules$l) {
    this[o] = __cssModules$l[o];
  }
}
const DpmExtensionEditTab = /* @__PURE__ */ function() {
  return __component__$l.exports;
}();
var render$k = function() {
  var _vm$dpmStore$currentE;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    attrs: {
      "id": "icon-edit-view"
    }
  }, [_vm.useBy !== "group" || !((_vm$dpmStore$currentE = _vm.dpmStore.currentEditGroup) !== null && _vm$dpmStore$currentE !== void 0 && _vm$dpmStore$currentE.colorless) ? _c("v-row", {
    staticClass: "mt-2"
  }, [_c("v-col", {
    staticClass: "df justify-content-center align-items-center",
    attrs: {
      "cols": "6"
    }
  }, [_c("div", {
    staticClass: "df justify-content-center align-items-center border",
    attrs: {
      "id": "icon-preview"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.previewIcon)
    }
  })]), _c("v-col", {
    staticClass: "df justify-content-center",
    attrs: {
      "cols": "6"
    }
  }, [_c("v-color-picker", {
    attrs: {
      "value": _vm.$global.utils.toHex(_vm.dpmStore.currentEditIconData.color),
      "swatches": _vm.$global.swatches,
      "show-swatches": "",
      "width": "350px"
    },
    on: {
      "update:color": _vm.onUpdateColor
    }
  })], 1), _vm.useBy === "mattertag" ? _c("v-col", {
    staticClass: "pt-0"
  }, [_c("div", {
    staticClass: "small text-muted"
  }, [_vm._v("※グループカラーが設定されている場合、そちらが優先されます。")])]) : _c("v-col", {
    staticClass: "pt-0"
  }, [_c("div", {
    staticClass: "small text-muted"
  }, [_vm._v("※このカラーはグループチップにも適用されます。")])])], 1) : _vm._e(), _c("v-divider"), _c("v-row", {
    staticClass: "mt-0"
  }, [_c("v-col", {
    attrs: {
      "cols": "2"
    }
  }, [_c("p", [_vm._v("アイコン変更")])]), _c("v-col", {
    attrs: {
      "cols": "4"
    }
  }, [_c("v-btn", {
    staticClass: "mt-2",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.resetIcon
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiRedo))]), _vm._v("アイコン設定をデフォルトに戻す")], 1)], 1)], 1), _c("h6", {
    staticClass: "my-5"
  }, [_vm._v("プリセットアイコン")]), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "6"
    }
  }, [_c("v-text-field", {
    staticClass: "mb-2",
    attrs: {
      "prepend-inner-icon": _vm.$global.icons.mdiMagnify,
      "label": "アイコン検索",
      "outlined": "",
      "hide-details": "",
      "dense": ""
    },
    on: {
      "input": _vm.filterIcons
    }
  }), _c("v-virtual-scroll", {
    attrs: {
      "bench": "1",
      "items": _vm.presetIconRows,
      "height": "410",
      "item-height": "32"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "df"
        }, _vm._l(item, function(key) {
          return _c("div", {
            directives: [{
              name: "ripple",
              rawName: "v-ripple"
            }],
            staticClass: "mattertag-icon p-2 df align-items-center justify-content-center flex-column",
            on: {
              "click": function($event) {
                return _vm.onChangeIcon(key);
              }
            }
          }, [_c("v-tooltip", {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(_ref2) {
                var on2 = _ref2.on;
                return [_c("v-icon", _vm._g({}, on2), [_vm._v(_vm._s(_vm.$global.icons[key]))])];
              }
            }], null, true)
          }, [_c("span", [_vm._v(_vm._s(key))])])], 1);
        }), 0)];
      }
    }])
  })], 1), _c("v-col", {
    attrs: {
      "id": "preset-background",
      "cols": "6"
    }
  }, [_c("p", {
    staticClass: "mb-2"
  }, [_vm._v("背景")]), _c("v-radio-group", {
    staticClass: "mt-0 mb-2",
    attrs: {
      "value": _vm.bgShape,
      "row": "",
      "hide-details": "",
      "disabled": !_vm.usePresetIcon
    },
    on: {
      "change": _vm.onChangeBgShape
    }
  }, [_c("v-radio", {
    attrs: {
      "label": "なし",
      "value": "none"
    }
  }), _c("v-radio", {
    attrs: {
      "label": "丸",
      "value": "circle"
    }
  }), _c("v-radio", {
    attrs: {
      "label": "四角",
      "value": "rect"
    }
  }), _c("v-radio", {
    attrs: {
      "label": "三角",
      "value": "triangle"
    }
  }), _c("v-radio", {
    attrs: {
      "label": "逆三角",
      "value": "invertedTriangle"
    }
  }), _c("v-radio", {
    attrs: {
      "label": "菱形",
      "value": "rhombus"
    }
  })], 1), _c("v-color-picker", {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "value": _vm.bgColor,
      "disabled": !_vm.usePresetIcon,
      "swatches": _vm.$global.swatches,
      "show-swatches": "",
      "width": "350px"
    },
    on: {
      "update:color": _vm.onUpdateBgColor
    }
  })], 1)], 1), _c("h6", {
    staticClass: "mt-5"
  }, [_vm._v("カスタムアイコン")]), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_vm.registeredCustomIconData.length === 0 ? _c("p", [_vm._v("アイコン登録を行ってください")]) : _vm._e(), _vm.registeredCustomIconData.length ? _c("v-virtual-scroll", {
    attrs: {
      "bench": "1",
      "items": _vm.customIconRows,
      "height": _vm.customIconRows.length > 1 ? "240" : "120",
      "item-height": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          staticClass: "df"
        }, _vm._l(item, function(icon) {
          return _c("div", {
            directives: [{
              name: "ripple",
              rawName: "v-ripple"
            }],
            staticClass: "custom-mattertag-icon p-2 df align-items-center justify-content-center flex-column",
            on: {
              "click": function($event) {
                return _vm.onChangeIcon(icon.id, icon.url, icon.activeStorageId);
              }
            }
          }, [_c("v-tooltip", {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(_ref4) {
                var on2 = _ref4.on;
                return [_c("v-img", _vm._g({
                  attrs: {
                    "src": icon.url
                  }
                }, on2))];
              }
            }], null, true)
          }, [_c("span", [_vm._v(_vm._s(icon.id))])])], 1);
        }), 0)];
      }
    }], null, false, 648934219)
  }) : _vm._e()], 1)], 1), _c("h6", {
    staticClass: "mt-5"
  }, [_vm._v("カスタムアイコン登録")]), _c("p", {
    staticClass: "text-danger mb-0",
    class: {
      "d-none": !_vm.errorText
    }
  }, [_vm._v(_vm._s(_vm.errorText))]), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "アイコンID",
      "messages": `${_vm.showcaseAlias}内で一意のIDを入力してください。`
    },
    model: {
      value: _vm.iconId,
      callback: function($$v) {
        _vm.iconId = $$v;
      },
      expression: "iconId"
    }
  })], 1)], 1), _c("v-row", {
    staticClass: "mt-0"
  }, [_c("v-col", {
    attrs: {
      "cols": "4"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "画像URL",
      "messages": "アップロードファイルが優先されます。"
    },
    model: {
      value: _vm.iconUrl,
      callback: function($$v) {
        _vm.iconUrl = $$v;
      },
      expression: "iconUrl"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "5"
    }
  }, [_c("v-file-input", {
    attrs: {
      "label": "アップロードするファイル",
      "messages": "5MBまでのjpg, png, gifファイルがアップロード可能です。"
    },
    model: {
      value: _vm.uploadedImageFile,
      callback: function($$v) {
        _vm.uploadedImageFile = $$v;
      },
      expression: "uploadedImageFile"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "3"
    }
  }, [_vm.uploadedImageFile ? [_c("v-btn", {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.uploadedImageFile || !_vm.iconId
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiUpload))]), _vm._v("アップロード")], 1)] : [_c("v-btn", {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "loading": _vm.registeringIcon,
      "disabled": _vm.uploadedImageFile || !_vm.iconId || !_vm.iconUrl
    },
    on: {
      "click": _vm.onRegisterIcon
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiContentSave))]), _vm._v("登録")], 1)]], 2)], 1)], 1);
};
var staticRenderFns$k = [];
const __vue2_script$k = {
  data() {
    return {
      errorText: null,
      iconId: null,
      iconUrl: null,
      pressetIconKeys: [],
      registeredCustomIconData: [],
      registeringIcon: false,
      showcaseAlias: "",
      uploadedImageFile: null
    };
  },
  created() {
    return __async(this, null, function* () {
      var _a2;
      const setIconData = (obj) => __async(this, null, function* () {
        var _a3;
        if (obj.url.indexOf("active_storage") !== -1) {
          const activeStorageId = obj.url.split(":")[1];
          const res = yield this.dpmStore.getMediaUrl("mattertag_icon_images", activeStorageId);
          if ((_a3 = res == null ? void 0 : res.data) == null ? void 0 : _a3.url) {
            this.registeredCustomIconData.push({ id: obj.id, url: res.data.url, activeStorageId });
          } else {
            this.errorText = res.error;
          }
        } else {
          this.registeredCustomIconData.push({ id: obj.id, url: obj.url });
        }
      });
      for (let i2 = 0; i2 < this.dpmStore.SED.mattertags.length; i2++) {
        if ((_a2 = this.dpmStore.SED.mattertags[i2].icon) == null ? void 0 : _a2.url) {
          yield setIconData(this.dpmStore.SED.mattertags[i2].icon);
        }
      }
      for (let i2 = 0; i2 < this.dpmStore.SED.mattertag_groups.length; i2++) {
        if (this.dpmStore.SED.mattertag_groups[i2].url) {
          yield setIconData(this.dpmStore.SED.mattertag_groups[i2]);
        }
      }
      this.pressetIconKeys = Object.keys(this.$global.icons);
    });
  },
  mounted() {
    this.showcaseAlias = document.getElementById("showcase").dataset.showcaseAlias || "ショーケース";
  },
  methods: {
    checkId() {
      return this.registeredCustomIconData.some((data) => data.id === this.iconId) ? "すでに使用されているIDです。" : null;
    },
    filterIcons(query2) {
      this.pressetIconKeys = Object.keys(this.$global.icons).filter((key) => key.search(new RegExp(query2, "i")) !== -1);
    },
    onChangeBgShape(data) {
      this.dpmStore.currentEditIconData.id = this.dpmStore.replaceIconId(this.dpmStore.currentEditIconData.id, data, 2);
    },
    onChangeIcon(id, url = null, activeStorageId = null) {
      if (url) {
        this.$set(this.dpmStore.currentEditIconData, "id", id);
      } else {
        this.$set(this.dpmStore.currentEditIconData, "id", `${id}-${this.$global.utils.toHex(this.dpmStore.currentEditIconData.color)}-${this.bgShape}-${this.bgColor}`);
      }
      this.$set(this.dpmStore.currentEditIconData, "url", url);
      this.$set(this.dpmStore.currentEditIconData, "activeStorageId", activeStorageId);
    },
    onRegisterIcon() {
      if (this.errorText = this.checkId()) {
        return;
      }
      this.registerWithSdk();
    },
    onUpdateBgColor(data) {
      this.dpmStore.currentEditIconData.id = this.dpmStore.replaceIconId(this.dpmStore.currentEditIconData.id, data.hex, 3);
    },
    onUpdateColor(data) {
      this.dpmStore.currentEditIconData.color = { r: data.rgba.r / 255, g: data.rgba.g / 255, b: data.rgba.b / 255 };
      if (this.usePresetIcon) {
        this.dpmStore.currentEditIconData.id = this.dpmStore.replaceIconId(this.dpmStore.currentEditIconData.id, data.hex, 1);
      }
    },
    registerWithSdk(res) {
      const url = res ? res.data.url : this.iconUrl;
      const activeStorageId = res ? res.data.id : null;
      this.registeringIcon = true;
      this.$global.sdk.Asset.registerTexture(this.iconId, url).then(() => {
        this.registeredCustomIconData.push({ id: this.iconId, url, activeStorageId });
        this.uploadedImageFile = null;
        this.errorText = null;
        this.iconId = null;
        this.iconUrl = null;
      }).catch((error2) => {
        this.errorText = error2;
      }).finally(() => {
        this.registeringIcon = false;
      });
    },
    resetIcon() {
      let color2 = { r: 1, g: 0, b: 0 };
      if (this.useBy === "mattertag") {
        color2 = this.dpmStore.isAddedMattertag(this.dpmStore.current.mattertagSid) ? { r: 0, g: 0, b: 1 } : _clone(this.dpmStore.currentOriginMattertag.color);
      }
      const target2 = this.dpmStore.currentEditIconData;
      target2.color = color2;
      target2.id = null;
      target2.url = null;
      target2.activeStorageId = null;
    },
    uploadImage() {
      return __async(this, null, function* () {
        if (this.errorText = this.checkId()) {
          return;
        }
        const params = new FormData();
        params.append("file", this.uploadedImageFile);
        const res = yield axios$1.post(
          `${this.$global.apiUrl}/upload_media?type=mattertag_icon_images`,
          params,
          { headers: __spreadProps(__spreadValues({}, this.$global.csrfHeader), { "content-type": "multipart/form-data" }) }
        ).catch((err2) => {
          this.errorText = err2.response.data.error || err2;
        });
        if (res && res.data && res.data.url) {
          this.registerWithSdk(res);
        }
      });
    }
  },
  computed: __spreadProps(__spreadValues({}, mapStores(useDpmStore)), {
    bgShape() {
      const target2 = this.dpmStore.currentEditIconData;
      return target2.id && target2.id.split("-").length === 4 ? target2.id.split("-")[2] : "none";
    },
    bgColor() {
      const target2 = this.dpmStore.currentEditIconData;
      return target2.id && target2.id.split("-").length === 4 ? target2.id.split("-")[3] : "#FFFFFF";
    },
    customIconRows() {
      return _chunk(this.registeredCustomIconData, 5);
    },
    presetIconRows() {
      return _chunk(this.pressetIconKeys, 8);
    },
    previewIcon() {
      if (this.useBy === "group" && this.dpmStore.currentEditGroup.colorless) {
        return "";
      }
      if (this.useCustomIcon) {
        return `<img src='${this.dpmStore.currentEditIconData.url}' />`;
      } else if (this.usePresetIcon) {
        return this.$global.utils.SVG.createSvgTag(this.dpmStore.currentEditIconData.id);
      } else {
        return this.$global.utils.SVG.createDefaultSvgTag(this.$global.utils.toHex(this.dpmStore.currentEditIconData.color));
      }
    },
    useBy() {
      return this.dpmStore.mattertagEditor.useBy;
    },
    useCustomIcon() {
      return this.dpmStore.currentEditIconData.url && !this.dpmStore.currentEditIconData.url.includes("active_storage:");
    },
    useDefaultIcon() {
      return !this.useCustomIcon() && !this.usePresetIcon();
    },
    usePresetIcon() {
      return this.dpmStore.currentEditIconData.id && !this.dpmStore.currentEditIconData.url;
    }
  })
};
const __cssModules$k = {};
var __component__$k = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$k,
  render$k,
  staticRenderFns$k,
  false,
  __vue2_injectStyles$k,
  null,
  null,
  null
);
function __vue2_injectStyles$k(context) {
  for (let o in __cssModules$k) {
    this[o] = __cssModules$k[o];
  }
}
const IconEditView = /* @__PURE__ */ function() {
  return __component__$k.exports;
}();
var render$j = function() {
  var _vm$dpmStore$currentE, _vm$dpmStore$currentO;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.dpmStore.currentEditMattertag ? _c("v-dialog", {
    attrs: {
      "content-class": "animate__animated animate__faster mattertag-edit-modal dpm-modal",
      "retain-focus": false,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: _vm.dpmStore.mattertagEditor.editDialogVisible,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.mattertagEditor, "editDialogVisible", $$v);
      },
      expression: "dpmStore.mattertagEditor.editDialogVisible"
    }
  }, [_c("v-card", [_c("v-card-title", [_vm._v(_vm._s(_vm.dpmStore.currentEditMattertag.notes ? "Chat編集" : "Tag編集"))]), _c("v-tabs", {
    attrs: {
      "background-color": "transparent",
      "grow": ""
    },
    on: {
      "change": _vm.onTabChange
    },
    model: {
      value: _vm.currentTab,
      callback: function($$v) {
        _vm.currentTab = $$v;
      },
      expression: "currentTab"
    }
  }, [_c("v-tab", {
    key: "icon"
  }, [_vm._v("アイコン")]), _c("v-tab", {
    key: "description"
  }, [_vm._v("説明文・フロア設定")]), !_vm.dpmStore.currentEditMattertag.notes ? _c("v-tab", {
    key: "extension"
  }, [_vm._v("拡張")]) : _vm._e()], 1), _c("v-card-text", {
    staticClass: "p-3",
    staticStyle: {
      "height": "900px",
      "overflow-y": "scroll"
    }
  }, [_c("v-tabs-items", {
    model: {
      value: _vm.currentTabItem,
      callback: function($$v) {
        _vm.currentTabItem = $$v;
      },
      expression: "currentTabItem"
    }
  }, [_c("v-tab-item", {
    key: "icon"
  }, [_c("v-row", [_c("v-col", {
    staticClass: "df",
    attrs: {
      "cols": "12"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "ラベル",
      "hide-details": ""
    },
    model: {
      value: _vm.dpmStore.currentEditMattertag.label,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditMattertag, "label", $$v);
      },
      expression: "dpmStore.currentEditMattertag.label"
    }
  })], 1)], 1), _vm.dpmStore.currentEditMattertag.anchorPosition ? _c("v-row", [_c("v-col", {
    staticClass: "df",
    attrs: {
      "cols": "6"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "stemの長さ(メートル)",
      "type": "number",
      "step": "0.1",
      "hide-details": ""
    },
    model: {
      value: _vm.dpmStore.currentEditMattertag.stemHeight,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditMattertag, "stemHeight", _vm._n($$v));
      },
      expression: "dpmStore.currentEditMattertag.stemHeight"
    }
  })], 1), _c("v-col", {
    staticClass: "df",
    attrs: {
      "cols": "5"
    }
  }, [_c("v-checkbox", {
    attrs: {
      "label": "stemの表示"
    },
    model: {
      value: _vm.dpmStore.currentEditMattertag.stemVisible,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditMattertag, "stemVisible", $$v);
      },
      expression: "dpmStore.currentEditMattertag.stemVisible"
    }
  })], 1)], 1) : _vm._e(), _c("IconEditView")], 1), _c("v-tab-item", {
    key: "description"
  }, [_c("div", {
    staticClass: "h6 mb-2"
  }, [_vm._v("説明文")]), _c("v-divider"), _c("v-row", {
    staticClass: "my-1"
  }, [_c("v-col", [_c("v-textarea", {
    ref: "descriptionTextarea",
    attrs: {
      "outlined": "",
      "hide-details": "",
      "height": "300"
    },
    model: {
      value: _vm.dpmStore.currentEditMattertag.description,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditMattertag, "description", $$v);
      },
      expression: "dpmStore.currentEditMattertag.description"
    }
  })], 1)], 1), _c("v-row", {
    staticClass: "my-1"
  }, [_c("v-col", {
    attrs: {
      "cols": "5"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "リンクテキスト",
      "hide-details": ""
    },
    model: {
      value: _vm.linkText,
      callback: function($$v) {
        _vm.linkText = $$v;
      },
      expression: "linkText"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "5"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "URL",
      "hide-details": ""
    },
    model: {
      value: _vm.linkUrl,
      callback: function($$v) {
        _vm.linkUrl = $$v;
      },
      expression: "linkUrl"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "2"
    }
  }, [_c("v-btn", {
    staticClass: "mt-2",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.insertLink
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiLink))]), _vm._v("挿入")], 1)], 1)], 1), _c("div", {
    staticClass: "h6 mt-6 mb-2"
  }, [_vm._v("フロア設定")]), _c("v-divider"), (_vm$dpmStore$currentE = _vm.dpmStore.currentEditMattertag) !== null && _vm$dpmStore$currentE !== void 0 && _vm$dpmStore$currentE.roomId || (_vm$dpmStore$currentO = _vm.dpmStore.currentOriginMattertag) !== null && _vm$dpmStore$currentO !== void 0 && _vm$dpmStore$currentO.roomId ? _c("div", [_vm._v("フロアデータはデフォルトで設定されていますが、変更が必要な場合は下記セレクトボックスから行って下さい。")]) : _vm._e(), _c("v-select", {
    attrs: {
      "items": Object.keys(_vm.dpmStore.global.floors).map(function(key) {
        return {
          text: _vm.dpmStore.global.floors[key].name,
          value: _vm.dpmStore.global.floors[key].id
        };
      }),
      "label": "タグが属するフロアを設定してください"
    },
    model: {
      value: _vm.dpmStore.currentEditMattertag.floorId,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditMattertag, "floorId", $$v);
      },
      expression: "dpmStore.currentEditMattertag.floorId"
    }
  })], 1), _c("v-tab-item", {
    key: "extension"
  }, [_vm.currentTab === 2 ? _c("DpmExtensionEditTab", {
    ref: "extensionTab",
    attrs: {
      "useBy": "mattertag"
    }
  }) : _vm._e()], 1)], 1)], 1), _c("v-divider"), _c("v-card-actions", {
    staticClass: "justify-content-end"
  }, [_vm.dpmStore.isAddedMattertag(_vm.dpmStore.currentEditMattertag.sid) ? _c("v-btn", {
    staticClass: "mr-auto",
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.deleteTag
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v(_vm._s(_vm.dpmStore.currentEditMattertag.notes ? "このchatを削除" : "この追加タグを削除"))], 1) : _c("v-btn", {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.resetMattertag
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v("このTagの設定を全て削除")], 1), _c("v-btn", {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.apply
    }
  }, [_c("v-icon", [_vm._v(" " + _vm._s(_vm.$global.icons.mdiCheck))]), _vm._v("適用")], 1)], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns$j = [];
const __vue2_script$j = {
  components: {
    DpmExtensionEditTab,
    IconEditView
  },
  data() {
    return initialState$1();
  },
  created() {
    return __async(this, null, function* () {
      this.dpmStore.mattertagEditor.useBy = "mattertag";
      this.dpmStore.$subscribe((mutation, _state) => __async(this, null, function* () {
        var _a2, _b2, _c, _d2, _e, _f, _g, _h, _i2;
        if (mutation.type.includes("patch") && ((_b2 = (_a2 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _a2.mattertagEditor) == null ? void 0 : _b2.editDialogVisible)) {
          this.dpmStore.mattertagEditor.useBy = "mattertag";
          this.currentTab = 0;
          this.currentTabItem = 0;
          if (!this.dpmStore.currentEditMattertag) {
            const initialIconData = {
              id: null,
              url: null,
              activeStorageId: null,
              // NOTE: activeStorageIdは一時保存用。dpmStoreで保存するようにしたい。
              color: this.dpmStore.isAddedMattertag(this.dpmStore.current.mattertagSid) ? { r: 0, g: 0, b: 1 } : _clone(this.dpmStore.currentOriginMattertag.color)
            };
            this.dpmStore.SED.mattertags.push({
              sid: _clone(this.dpmStore.current.mattertagSid),
              icon: _clone(initialIconData),
              extension: null,
              label: this.dpmStore.currentOriginMattertag.label
            });
          }
          if ((_e = (_d2 = (_c = this.dpmStore.currentEditMattertag) == null ? void 0 : _c.icon) == null ? void 0 : _d2.url) == null ? void 0 : _e.includes("active_storage")) {
            const activeStorageId = this.dpmStore.currentEditMattertag.icon.url.split(":")[1];
            this.dpmStore.currentEditMattertag.icon.activeStorageId = activeStorageId;
            const res = yield this.dpmStore.getMediaUrl("mattertag_icon_images", activeStorageId);
            if ((_f = res == null ? void 0 : res.data) == null ? void 0 : _f.url) {
              this.dpmStore.currentEditMattertag.icon.url = res.data.url;
            } else {
              this.errorText = res.error;
            }
          }
          if (!((_g = this.dpmStore.currentEditMattertag) == null ? void 0 : _g.description)) {
            this.$set(this.dpmStore.currentEditMattertag, "description", ((_h = this.dpmStore.currentOriginMattertag) == null ? void 0 : _h.description) || "");
          }
          if (!((_i2 = this.dpmStore.currentEditMattertag) == null ? void 0 : _i2.label)) {
            this.$set(this.dpmStore.currentEditMattertag, "label", this.dpmStore.currentOriginMattertag.label);
          }
        }
      }));
    });
  },
  mounted() {
    this.showcaseAlias = document.getElementById("showcase").dataset.showcaseAlias || "ショーケース";
  },
  computed: __spreadValues({}, mapStores(useDpmStore)),
  methods: {
    apply() {
      return __async(this, null, function* () {
        var _a2, _b2, _c, _d2, _e, _f;
        const index2 = this.dpmStore.SED.mattertags.findIndex((data) => data.sid === this.dpmStore.current.mattertagSid);
        if (this.dpmStore.currentEditMattertag.icon.activeStorageId) {
          this.dpmStore.SED.mattertags[index2].icon.url = `active_storage:${this.dpmStore.currentEditMattertag.icon.activeStorageId}`;
        }
        this.$delete(this.dpmStore.SED.mattertags[index2].icon, "activeStorageId");
        if ((_a2 = this.dpmStore.currentEditMattertag) == null ? void 0 : _a2.description) {
          if (this.dpmStore.currentEditMattertag.description === ((_b2 = this.dpmStore.currentOriginMattertag) == null ? void 0 : _b2.description) && !this.dpmStore.currentEditMattertag.anchorPosition) {
            this.$delete(this.dpmStore.currentEditMattertag, "description");
          } else {
            yield this.$global.sdk.Tag.editBillboard(this.dpmStore.current.mattertagSid, {
              description: this.dpmStore.currentEditMattertag.description
            });
          }
        }
        if (!((_c = this.dpmStore.currentEditMattertag) == null ? void 0 : _c.description)) {
          if ((_d2 = this.dpmStore.currentOriginMattertag) == null ? void 0 : _d2.description) {
            yield this.$global.sdk.Tag.editBillboard(this.dpmStore.current.mattertagSid, {
              description: this.dpmStore.currentOriginMattertag.description
            });
          }
        }
        if ((_e = this.dpmStore.currentEditMattertag) == null ? void 0 : _e.label) {
          yield this.$global.sdk.Tag.editBillboard(this.dpmStore.current.mattertagSid, {
            label: this.dpmStore.currentEditMattertag.label
          });
        } else {
          if ((_f = this.dpmStore.currentOriginMattertag) == null ? void 0 : _f.label) {
            yield this.$global.sdk.Tag.editBillboard(this.dpmStore.current.mattertagSid, {
              label: this.dpmStore.currentOriginMattertag.label
            });
          }
        }
        if (this.$refs.extensionTab && !this.$refs.extensionTab.apply()) {
          return;
        }
        if (this.dpmStore.currentEditMattertag.anchorPosition) {
          const tag = this.dpmStore.currentEditMattertag;
          yield this.$global.sdk.Tag.editStem(tag.sid, { stemVisible: tag.stemVisible, stemHeight: tag.stemHeight });
        }
        this.dpmStore.$patch({ mattertagEditor: { editDialogVisible: false, tagChanged: true } });
      });
    },
    deleteTag() {
      return __async(this, null, function* () {
        const result2 = window.confirm("本当に削除しますか？");
        if (result2) {
          yield this.$global.sdk.Tag.remove(this.dpmStore.current.mattertagSid);
          this.dpmStore.SED.mattertags.splice(this.dpmStore.SED.mattertags.findIndex((mattertag) => mattertag.sid === this.dpmStore.current.mattertagSid), 1);
          this.dpmStore.SED.mattertag_groups.forEach((group) => {
            const index2 = group.mattertags.findIndex((mattertag) => mattertag.sid === this.dpmStore.current.mattertagSid);
            if (index2 !== -1) {
              group.mattertags.splice(index2, 1);
            }
          });
          this.dpmStore.$patch({
            current: { mattertagSid: null },
            mattertagEditor: { editDialogVisible: false, tagChanged: true }
          });
        }
      });
    },
    insertLink() {
      const textarea = this.$refs.descriptionTextarea.$refs.input;
      const before = textarea.value.slice(0, textarea.selectionStart);
      const after = textarea.value.slice(textarea.selectionEnd, textarea.value.length);
      this.$set(this.dpmStore.currentEditMattertag, "description", `${before}[${this.linkText}](${this.linkUrl})${after}`);
    },
    onTabChange(_e) {
      if (this.$refs.extensionTab && !this.$refs.extensionTab.apply()) {
        this.$nextTick(() => {
          this.isShakeModal = true;
          const mattertagEditModal2 = document.querySelector(".mattertag-edit-modal");
          mattertagEditModal2.classList.add("animate__shakeX");
          setTimeout(() => {
            mattertagEditModal2.classList.remove("animate__shakeX");
          }, 500);
          this.currentTab = this.currentTabItem;
        });
      } else {
        this.currentTabItem = this.currentTab;
      }
    },
    resetMattertag() {
      return __async(this, null, function* () {
        const result2 = window.confirm("本当に削除しますか？");
        if (result2) {
          this.dpmStore.SED.mattertags = this.dpmStore.SED.mattertags.filter((mattertag) => mattertag.sid !== this.dpmStore.current.mattertagSid);
          this.dpmStore.$patch({ mattertagEditor: { editDialogVisible: false, tagChanged: true } });
        }
      });
    }
  }
};
const initialState$1 = () => {
  return {
    currentTab: null,
    currentTabItem: null,
    errorText: null,
    iconId: null,
    iconUrl: null,
    isShakeModal: false,
    linkText: null,
    linkUrl: null,
    pressetIconKeys: [],
    registeringIcon: false,
    uploadedImageFile: null,
    showcaseAlias: ""
  };
};
const __cssModules$j = {};
var __component__$j = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$j,
  render$j,
  staticRenderFns$j,
  false,
  __vue2_injectStyles$j,
  null,
  null,
  null
);
function __vue2_injectStyles$j(context) {
  for (let o in __cssModules$j) {
    this[o] = __cssModules$j[o];
  }
}
const mattertagEditModal = /* @__PURE__ */ function() {
  return __component__$j.exports;
}();
var vuedraggable_umd = { exports: {} };
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function(target2) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target2[key] = source[key];
        }
      }
    }
    return target2;
  };
  return _extends.apply(this, arguments);
}
function _objectSpread(target2) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _defineProperty(target2, key, source[key]);
    });
  }
  return target2;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target2 = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target2[key] = source[key];
  }
  return target2;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target2 = _objectWithoutPropertiesLoose(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target2[key] = source[key];
    }
  }
  return target2;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i2 = 0, arr2 = new Array(arr.length); i2 < arr.length; i2++)
      arr2[i2] = arr[i2];
    return arr2;
  }
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]")
    return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
var version = "1.10.2";
function userAgent(pattern) {
  if (typeof window !== "undefined" && window.navigator) {
    return !!/* @__PURE__ */ navigator.userAgent.match(pattern);
  }
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
var captureMode = {
  capture: false,
  passive: false
};
function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}
function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}
function matches(el, selector) {
  if (!selector)
    return;
  selector[0] === ">" && (selector = selector.substring(1));
  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }
  return false;
}
function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function closest(el, selector, ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;
    do {
      if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }
      if (el === ctx)
        break;
    } while (el = getParentOrHost(el));
  }
  return null;
}
var R_SPACE = /\s+/g;
function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? "add" : "remove"](name);
    } else {
      var className = (" " + el.className + " ").replace(R_SPACE, " ").replace(" " + name + " ", " ");
      el.className = (className + (state ? " " + name : "")).replace(R_SPACE, " ");
    }
  }
}
function css(el, prop, val) {
  var style2 = el && el.style;
  if (style2) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, "");
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }
      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style2) && prop.indexOf("webkit") === -1) {
        prop = "-webkit-" + prop;
      }
      style2[prop] = val + (typeof val === "string" ? "" : "px");
    }
  }
}
function matrix(el, selfOnly) {
  var appliedTransforms = "";
  if (typeof el === "string") {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, "transform");
      if (transform && transform !== "none") {
        appliedTransforms = transform + " " + appliedTransforms;
      }
    } while (!selfOnly && (el = el.parentNode));
  }
  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return matrixFn && new matrixFn(appliedTransforms);
}
function find(ctx, tagName2, iterator) {
  if (ctx) {
    var list2 = ctx.getElementsByTagName(tagName2), i2 = 0, n2 = list2.length;
    if (iterator) {
      for (; i2 < n2; i2++) {
        iterator(list2[i2], i2);
      }
    }
    return list2;
  }
  return [];
}
function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;
  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container2) {
  if (!el.getBoundingClientRect && el !== window)
    return;
  var elRect, top, left, bottom, right, height, width;
  if (el !== window && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }
  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    container2 = container2 || el.parentNode;
    if (!IE11OrLess) {
      do {
        if (container2 && container2.getBoundingClientRect && (css(container2, "transform") !== "none" || relativeToNonStaticParent && css(container2, "position") !== "static")) {
          var containerRect = container2.getBoundingClientRect();
          top -= containerRect.top + parseInt(css(container2, "border-top-width"));
          left -= containerRect.left + parseInt(css(container2, "border-left-width"));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
      } while (container2 = container2.parentNode);
    }
  }
  if (undoScale && el !== window) {
    var elMatrix = matrix(container2 || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }
  return {
    top,
    left,
    bottom,
    right,
    width,
    height
  };
}
function isScrolledPast(el, elSide, parentSide) {
  var parent2 = getParentAutoScrollElement(el, true), elSideVal = getRect(el)[elSide];
  while (parent2) {
    var parentSideVal = getRect(parent2)[parentSide], visible = void 0;
    if (parentSide === "top" || parentSide === "left") {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }
    if (!visible)
      return parent2;
    if (parent2 === getWindowScrollingElement())
      break;
    parent2 = getParentAutoScrollElement(parent2, false);
  }
  return false;
}
function getChild(el, childNum, options) {
  var currentChild = 0, i2 = 0, children = el.children;
  while (i2 < children.length) {
    if (children[i2].style.display !== "none" && children[i2] !== Sortable.ghost && children[i2] !== Sortable.dragged && closest(children[i2], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i2];
      }
      currentChild++;
    }
    i2++;
  }
  return null;
}
function lastChild(el, selector) {
  var last2 = el.lastElementChild;
  while (last2 && (last2 === Sortable.ghost || css(last2, "display") === "none" || selector && !matches(last2, selector))) {
    last2 = last2.previousElementSibling;
  }
  return last2 || null;
}
function index$1(el, selector) {
  var index2 = 0;
  if (!el || !el.parentNode) {
    return -1;
  }
  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index2++;
    }
  }
  return index2;
}
function getRelativeScrollOffset(el) {
  var offsetLeft = 0, offsetTop = 0, winScroller = getWindowScrollingElement();
  if (el) {
    do {
      var elMatrix = matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }
  return [offsetLeft, offsetTop];
}
function indexOfObject(arr, obj) {
  for (var i2 in arr) {
    if (!arr.hasOwnProperty(i2))
      continue;
    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i2][key])
        return Number(i2);
    }
  }
  return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
  if (!el || !el.getBoundingClientRect)
    return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;
  do {
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);
      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
        if (!elem.getBoundingClientRect || elem === document.body)
          return getWindowScrollingElement();
        if (gotSelf || includeSelf)
          return elem;
        gotSelf = true;
      }
    }
  } while (elem = elem.parentNode);
  return getWindowScrollingElement();
}
function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }
  return dst;
}
function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle(callback, ms) {
  return function() {
    if (!_throttleTimeout) {
      var args = arguments, _this2 = this;
      if (args.length === 1) {
        callback.call(_this2, args[0]);
      } else {
        callback.apply(_this2, args);
      }
      _throttleTimeout = setTimeout(function() {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}
function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}
function scrollBy(el, x2, y) {
  el.scrollLeft += x2;
  el.scrollTop += y;
}
function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;
  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}
function setRect(el, rect) {
  css(el, "position", "absolute");
  css(el, "top", rect.top);
  css(el, "left", rect.left);
  css(el, "width", rect.width);
  css(el, "height", rect.height);
}
function unsetRect(el) {
  css(el, "position", "");
  css(el, "top", "");
  css(el, "left", "");
  css(el, "width", "");
  css(el, "height", "");
}
var expando = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function AnimationStateManager() {
  var animationStates = [], animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation)
        return;
      var children = [].slice.call(this.el.children);
      children.forEach(function(child) {
        if (css(child, "display") === "none" || child === Sortable.ghost)
          return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });
        var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect);
        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);
          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }
        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target2) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target2
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this2 = this;
      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === "function")
          callback();
        return;
      }
      var animating = false, animationTime = 0;
      animationStates.forEach(function(state) {
        var time = 0, target2 = state.target, fromRect = target2.fromRect, toRect = getRect(target2), prevFromRect = target2.prevFromRect, prevToRect = target2.prevToRect, animatingRect = state.rect, targetMatrix = matrix(target2, true);
        if (targetMatrix) {
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }
        target2.toRect = toRect;
        if (target2.thisAnimationDuration) {
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this2.options);
          }
        }
        if (!isRectEqual(toRect, fromRect)) {
          target2.prevFromRect = fromRect;
          target2.prevToRect = toRect;
          if (!time) {
            time = _this2.options.animation;
          }
          _this2.animate(target2, animatingRect, toRect, time);
        }
        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target2.animationResetTimer);
          target2.animationResetTimer = setTimeout(function() {
            target2.animationTime = 0;
            target2.prevFromRect = null;
            target2.fromRect = null;
            target2.prevToRect = null;
            target2.thisAnimationDuration = null;
          }, time);
          target2.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);
      if (!animating) {
        if (typeof callback === "function")
          callback();
      } else {
        animationCallbackId = setTimeout(function() {
          if (typeof callback === "function")
            callback();
        }, animationTime);
      }
      animationStates = [];
    },
    animate: function animate(target2, currentRect, toRect, duration) {
      if (duration) {
        css(target2, "transition", "");
        css(target2, "transform", "");
        var elMatrix = matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target2.animatingX = !!translateX;
        target2.animatingY = !!translateY;
        css(target2, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
        repaint(target2);
        css(target2, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
        css(target2, "transform", "translate3d(0,0,0)");
        typeof target2.animated === "number" && clearTimeout(target2.animated);
        target2.animated = setTimeout(function() {
          css(target2, "transition", "");
          css(target2, "transform", "");
          target2.animated = false;
          target2.animatingX = false;
          target2.animatingY = false;
        }, duration);
      }
    }
  };
}
function repaint(target2) {
  return target2.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin3) {
    for (var option2 in defaults) {
      if (defaults.hasOwnProperty(option2) && !(option2 in plugin3)) {
        plugin3[option2] = defaults[option2];
      }
    }
    plugins.push(plugin3);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this2 = this;
    this.eventCanceled = false;
    evt.cancel = function() {
      _this2.eventCanceled = true;
    };
    var eventNameGlobal = eventName + "Global";
    plugins.forEach(function(plugin3) {
      if (!sortable[plugin3.pluginName])
        return;
      if (sortable[plugin3.pluginName][eventNameGlobal]) {
        sortable[plugin3.pluginName][eventNameGlobal](_objectSpread({
          sortable
        }, evt));
      }
      if (sortable.options[plugin3.pluginName] && sortable[plugin3.pluginName][eventName]) {
        sortable[plugin3.pluginName][eventName](_objectSpread({
          sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults2, options) {
    plugins.forEach(function(plugin3) {
      var pluginName = plugin3.pluginName;
      if (!sortable.options[pluginName] && !plugin3.initializeByDefault)
        return;
      var initialized = new plugin3(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized;
      _extends(defaults2, initialized.defaults);
    });
    for (var option2 in sortable.options) {
      if (!sortable.options.hasOwnProperty(option2))
        continue;
      var modified = this.modifyOption(sortable, option2, sortable.options[option2]);
      if (typeof modified !== "undefined") {
        sortable.options[option2] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function(plugin3) {
      if (typeof plugin3.eventProperties !== "function")
        return;
      _extends(eventProperties, plugin3.eventProperties.call(sortable[plugin3.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function(plugin3) {
      if (!sortable[plugin3.pluginName])
        return;
      if (plugin3.optionListeners && typeof plugin3.optionListeners[name] === "function") {
        modifiedValue = plugin3.optionListeners[name].call(sortable[plugin3.pluginName], value);
      }
    });
    return modifiedValue;
  }
};
function dispatchEvent(_ref) {
  var sortable = _ref.sortable, rootEl2 = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl2 = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex2 = _ref.oldIndex, newIndex2 = _ref.newIndex, oldDraggableIndex2 = _ref.oldDraggableIndex, newDraggableIndex2 = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl2 && rootEl2[expando];
  if (!sortable)
    return;
  var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent(name, true, true);
  }
  evt.to = toEl || rootEl2;
  evt.from = fromEl || rootEl2;
  evt.item = targetEl || rootEl2;
  evt.clone = cloneEl2;
  evt.oldIndex = oldIndex2;
  evt.newIndex = newIndex2;
  evt.oldDraggableIndex = oldDraggableIndex2;
  evt.newDraggableIndex = newDraggableIndex2;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable2 ? putSortable2.lastPutMode : void 0;
  var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));
  for (var option2 in allEventProperties) {
    evt[option2] = allEventProperties[option2];
  }
  if (rootEl2) {
    rootEl2.dispatchEvent(evt);
  }
  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}
var pluginEvent2 = function pluginEvent3(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, originalEvent = _ref.evt, data = _objectWithoutProperties(_ref, ["evt"]);
  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
    dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    dragStarted: moved,
    putSortable,
    activeSortable: Sortable.active,
    originalEvent,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable,
        name,
        originalEvent
      });
    }
  }, data));
};
function _dispatchEvent(info) {
  dispatchEvent(_objectSpread({
    putSortable,
    cloneEl,
    targetEl: dragEl,
    rootEl,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex
  }, info));
}
var dragEl, parentEl, ghostEl, rootEl, nextEl, lastDownEl, cloneEl, cloneHidden, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, activeGroup, putSortable, awaitingDragStarted = false, ignoreNextClick = false, sortables = [], tapEvt, touchEvt, lastDx, lastDy, tapDistanceLeft, tapDistanceTop, moved, lastTarget, lastDirection, pastFirstInvertThresh = false, isCircumstantialInvert = false, targetMoveDistance, ghostRelativeParent, ghostRelativeParentInitialScroll = [], _silent = false, savedInputChecked = [];
var documentExists = typeof document !== "undefined", PositionGhostAbsolutely = IOS, CSSFloatProperty = Edge || IE11OrLess ? "cssFloat" : "float", supportDraggable = documentExists && !ChromeForAndroid && !IOS && "draggable" in document.createElement("div"), supportCssPointerEvents = function() {
  if (!documentExists)
    return;
  if (IE11OrLess) {
    return false;
  }
  var el = document.createElement("x");
  el.style.cssText = "pointer-events:auto";
  return el.style.pointerEvents === "auto";
}(), _detectDirection = function _detectDirection2(el, options) {
  var elCSS = css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = getChild(el, 0, options), child2 = getChild(el, 1, options), firstChildCSS = child1 && css(child1), secondChildCSS = child2 && css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
  if (elCSS.display === "flex") {
    return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  }
  if (elCSS.display === "grid") {
    return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  }
  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
    var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
    return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
  }
  return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === "none" || child2 && elCSS[CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, _dragElInRowColumn = function _dragElInRowColumn2(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, _detectNearestEmptySortable = function _detectNearestEmptySortable2(x2, y) {
  var ret;
  sortables.some(function(sortable) {
    if (lastChild(sortable))
      return;
    var rect = getRect(sortable), threshold = sortable[expando].options.emptyInsertThreshold, insideHorizontally = x2 >= rect.left - threshold && x2 <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
    if (threshold && insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
}, _prepareGroup = function _prepareGroup2(options) {
  function toFn(value, pull) {
    return function(to, from, dragEl2, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
      if (value == null && (pull || sameGroup)) {
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === "clone") {
        return value;
      } else if (typeof value === "function") {
        return toFn(value(to, from, dragEl2, evt), pull)(to, from, dragEl2, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }
  var group = {};
  var originalGroup = options.group;
  if (!originalGroup || _typeof(originalGroup) != "object") {
    originalGroup = {
      name: originalGroup
    };
  }
  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
}, _hideGhostForTarget = function _hideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "none");
  }
}, _unhideGhostForTarget = function _unhideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "");
  }
};
if (documentExists) {
  document.addEventListener("click", function(evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent2(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;
    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
    if (nearest) {
      var event = {};
      for (var i2 in evt) {
        if (evt.hasOwnProperty(i2)) {
          event[i2] = evt[i2];
        }
      }
      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;
      nearest[expando]._onDragOver(event);
    }
  }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl2(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }
  this.el = el;
  this.options = options = _extends({}, options);
  el[expando] = this;
  var defaults2 = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl2) {
      dataTransfer.setData("Text", dragEl2.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && "PointerEvent" in window,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults2);
  for (var name in defaults2) {
    !(name in options) && (options[name] = defaults2[name]);
  }
  _prepareGroup(options);
  for (var fn in this) {
    if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
      this[fn] = this[fn].bind(this);
    }
  }
  this.nativeDraggable = options.forceFallback ? false : supportDraggable;
  if (this.nativeDraggable) {
    this.options.touchStartThreshold = 1;
  }
  if (options.supportPointer) {
    on(el, "pointerdown", this._onTapStart);
  } else {
    on(el, "mousedown", this._onTapStart);
    on(el, "touchstart", this._onTapStart);
  }
  if (this.nativeDraggable) {
    on(el, "dragover", this);
    on(el, "dragenter", this);
  }
  sortables.push(this.el);
  options.store && options.store.get && this.sort(options.store.get(this) || []);
  _extends(this, AnimationStateManager());
}
Sortable.prototype = /** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target2) {
    if (!this.el.contains(target2) && target2 !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target2) {
    return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target2, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(evt) {
    if (!evt.cancelable)
      return;
    var _this2 = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target2 = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target2, filter2 = options.filter;
    _saveInputCheckedState(el);
    if (dragEl) {
      return;
    }
    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return;
    }
    if (originalTarget.isContentEditable) {
      return;
    }
    target2 = closest(target2, options.draggable, el, false);
    if (target2 && target2.animated) {
      return;
    }
    if (lastDownEl === target2) {
      return;
    }
    oldIndex = index$1(target2);
    oldDraggableIndex = index$1(target2, options.draggable);
    if (typeof filter2 === "function") {
      if (filter2.call(this, evt, target2, this)) {
        _dispatchEvent({
          sortable: _this2,
          rootEl: originalTarget,
          name: "filter",
          targetEl: target2,
          toEl: el,
          fromEl: el
        });
        pluginEvent2("filter", _this2, {
          evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    } else if (filter2) {
      filter2 = filter2.split(",").some(function(criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);
        if (criteria) {
          _dispatchEvent({
            sortable: _this2,
            rootEl: criteria,
            name: "filter",
            targetEl: target2,
            fromEl: el,
            toEl: el
          });
          pluginEvent2("filter", _this2, {
            evt
          });
          return true;
        }
      });
      if (filter2) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    }
    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    }
    this._prepareDragStart(evt, touch, target2);
  },
  _prepareDragStart: function _prepareDragStart(evt, touch, target2) {
    var _this2 = this, el = _this2.el, options = _this2.options, ownerDocument = el.ownerDocument, dragStartFn;
    if (target2 && !dragEl && target2.parentNode === el) {
      var dragRect = getRect(target2);
      rootEl = el;
      dragEl = target2;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target2;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style["will-change"] = "all";
      dragStartFn = function dragStartFn2() {
        pluginEvent2("delayEnded", _this2, {
          evt
        });
        if (Sortable.eventCanceled) {
          _this2._onDrop();
          return;
        }
        _this2._disableDelayedDragEvents();
        if (!FireFox && _this2.nativeDraggable) {
          dragEl.draggable = true;
        }
        _this2._triggerDragStart(evt, touch);
        _dispatchEvent({
          sortable: _this2,
          name: "choose",
          originalEvent: evt
        });
        toggleClass(dragEl, options.chosenClass, true);
      };
      options.ignore.split(",").forEach(function(criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, "dragover", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "mousemove", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "touchmove", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "mouseup", _this2._onDrop);
      on(ownerDocument, "touchend", _this2._onDrop);
      on(ownerDocument, "touchcancel", _this2._onDrop);
      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }
      pluginEvent2("delayStart", this, {
        evt
      });
      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();
          return;
        }
        on(ownerDocument, "mouseup", _this2._disableDelayedDrag);
        on(ownerDocument, "touchend", _this2._disableDelayedDrag);
        on(ownerDocument, "touchcancel", _this2._disableDelayedDrag);
        on(ownerDocument, "mousemove", _this2._delayedDragTouchMoveHandler);
        on(ownerDocument, "touchmove", _this2._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, "pointermove", _this2._delayedDragTouchMoveHandler);
        _this2._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
    var touch = e.touches ? e.touches[0] : e;
    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);
    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._disableDelayedDrag);
    off(ownerDocument, "touchend", this._disableDelayedDrag);
    off(ownerDocument, "touchcancel", this._disableDelayedDrag);
    off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(evt, touch) {
    touch = touch || evt.pointerType == "touch" && evt;
    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, "pointermove", this._onTouchMove);
      } else if (touch) {
        on(document, "touchmove", this._onTouchMove);
      } else {
        on(document, "mousemove", this._onTouchMove);
      }
    } else {
      on(dragEl, "dragend", this);
      on(rootEl, "dragstart", this._onDragStart);
    }
    try {
      if (document.selection) {
        _nextTick(function() {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err2) {
    }
  },
  _dragStarted: function _dragStarted(fallback, evt) {
    awaitingDragStarted = false;
    if (rootEl && dragEl) {
      pluginEvent2("dragStarted", this, {
        evt
      });
      if (this.nativeDraggable) {
        on(document, "dragover", _checkOutsideTargetEl);
      }
      var options = this.options;
      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost();
      _dispatchEvent({
        sortable: this,
        name: "start",
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;
      _hideGhostForTarget();
      var target2 = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent2 = target2;
      while (target2 && target2.shadowRoot) {
        target2 = target2.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target2 === parent2)
          break;
        parent2 = target2;
      }
      dragEl.parentNode[expando]._isOutsideThisEl(target2);
      if (parent2) {
        do {
          if (parent2[expando]) {
            var inserted2 = void 0;
            inserted2 = parent2[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target2,
              rootEl: parent2
            });
            if (inserted2 && !this.options.dragoverBubble) {
              break;
            }
          }
          target2 = parent2;
        } while (parent2 = parent2.parentNode);
      }
      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(evt) {
    if (tapEvt) {
      var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = ghostEl && matrix(ghostEl, true), scaleX = ghostEl && ghostMatrix && ghostMatrix.a, scaleY = ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }
        this._onDragStart(evt, true);
      }
      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }
        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, "webkitTransform", cssMatrix);
        css(ghostEl, "mozTransform", cssMatrix);
        css(ghostEl, "msTransform", cssMatrix);
        css(ghostEl, "transform", cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }
      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    if (!ghostEl) {
      var container2 = this.options.fallbackOnBody ? document.body : rootEl, rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container2), options = this.options;
      if (PositionGhostAbsolutely) {
        ghostRelativeParent = container2;
        while (css(ghostRelativeParent, "position") === "static" && css(ghostRelativeParent, "transform") === "none" && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }
        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document)
            ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }
        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }
      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, "transition", "");
      css(ghostEl, "transform", "");
      css(ghostEl, "box-sizing", "border-box");
      css(ghostEl, "margin", 0);
      css(ghostEl, "top", rect.top);
      css(ghostEl, "left", rect.left);
      css(ghostEl, "width", rect.width);
      css(ghostEl, "height", rect.height);
      css(ghostEl, "opacity", "0.8");
      css(ghostEl, "position", PositionGhostAbsolutely ? "absolute" : "fixed");
      css(ghostEl, "zIndex", "100000");
      css(ghostEl, "pointerEvents", "none");
      Sortable.ghost = ghostEl;
      container2.appendChild(ghostEl);
      css(ghostEl, "transform-origin", tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + "% " + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + "%");
    }
  },
  _onDragStart: function _onDragStart(evt, fallback) {
    var _this2 = this;
    var dataTransfer = evt.dataTransfer;
    var options = _this2.options;
    pluginEvent2("dragStart", this, {
      evt
    });
    if (Sortable.eventCanceled) {
      this._onDrop();
      return;
    }
    pluginEvent2("setupClone", this);
    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style["will-change"] = "";
      this._hideClone();
      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    }
    _this2.cloneId = _nextTick(function() {
      pluginEvent2("clone", _this2);
      if (Sortable.eventCanceled)
        return;
      if (!_this2.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }
      _this2._hideClone();
      _dispatchEvent({
        sortable: _this2,
        name: "clone"
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true);
    if (fallback) {
      ignoreNextClick = true;
      _this2._loopId = setInterval(_this2._emulateDragOver, 50);
    } else {
      off(document, "mouseup", _this2._onDrop);
      off(document, "touchend", _this2._onDrop);
      off(document, "touchcancel", _this2._onDrop);
      if (dataTransfer) {
        dataTransfer.effectAllowed = "move";
        options.setData && options.setData.call(_this2, dataTransfer, dragEl);
      }
      on(document, "drop", _this2);
      css(dragEl, "transform", "translateZ(0)");
    }
    awaitingDragStarted = true;
    _this2._dragStartId = _nextTick(_this2._dragStarted.bind(_this2, fallback, evt));
    on(document, "selectstart", _this2);
    moved = true;
    if (Safari) {
      css(document.body, "user-select", "none");
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(evt) {
    var el = this.el, target2 = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = Sortable.active, isOwner = activeGroup === group, canSort = options.sort, fromSortable = putSortable || activeSortable, vertical, _this2 = this, completedFired = false;
    if (_silent)
      return;
    function dragOverEvent(name, extra) {
      pluginEvent2(name, _this2, _objectSpread({
        evt,
        isOwner,
        axis: vertical ? "vertical" : "horizontal",
        revert,
        dragRect,
        targetRect,
        canSort,
        fromSortable,
        target: target2,
        completed,
        onMove: function onMove(target3, after2) {
          return _onMove(rootEl, el, dragEl, dragRect, target3, getRect(target3), evt, after2);
        },
        changed
      }, extra));
    }
    function capture() {
      dragOverEvent("dragOverAnimationCapture");
      _this2.captureAnimationState();
      if (_this2 !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    }
    function completed(insertion) {
      dragOverEvent("dragOverCompleted", {
        insertion
      });
      if (insertion) {
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this2);
        }
        if (_this2 !== fromSortable) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }
        if (putSortable !== _this2 && _this2 !== Sortable.active) {
          putSortable = _this2;
        } else if (_this2 === Sortable.active && putSortable) {
          putSortable = null;
        }
        if (fromSortable === _this2) {
          _this2._ignoreWhileAnimating = target2;
        }
        _this2.animateAll(function() {
          dragOverEvent("dragOverAnimationComplete");
          _this2._ignoreWhileAnimating = null;
        });
        if (_this2 !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      }
      if (target2 === dragEl && !dragEl.animated || target2 === el && !target2.animated) {
        lastTarget = null;
      }
      if (!options.dragoverBubble && !evt.rootEl && target2 !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
        !insertion && nearestEmptyInsertDetectEvent(evt);
      }
      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    }
    function changed() {
      newIndex = index$1(dragEl);
      newDraggableIndex = index$1(dragEl, options.draggable);
      _dispatchEvent({
        sortable: _this2,
        name: "change",
        toEl: el,
        newIndex,
        newDraggableIndex,
        originalEvent: evt
      });
    }
    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }
    target2 = closest(target2, options.draggable, el, true);
    dragOverEvent("dragOver");
    if (Sortable.eventCanceled)
      return completedFired;
    if (dragEl.contains(evt.target) || target2.animated && target2.animatingX && target2.animatingY || _this2._ignoreWhileAnimating === target2) {
      return completed(false);
    }
    ignoreNextClick = false;
    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target2) === "vertical";
      dragRect = getRect(dragEl);
      dragOverEvent("dragOverValid");
      if (Sortable.eventCanceled)
        return completedFired;
      if (revert) {
        parentEl = rootEl;
        capture();
        this._hideClone();
        dragOverEvent("revert");
        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }
        return completed(true);
      }
      var elLastChild = lastChild(el, options.draggable);
      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        if (elLastChild === dragEl) {
          return completed(false);
        }
        if (elLastChild && el === evt.target) {
          target2 = elLastChild;
        }
        if (target2) {
          targetRect = getRect(target2);
        }
        if (_onMove(rootEl, el, dragEl, dragRect, target2, targetRect, evt, !!target2) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (target2.parentNode === el) {
        targetRect = getRect(target2);
        var direction = 0, targetBeforeFirstSwap, differentLevel = dragEl.parentNode !== el, differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target2.animated && target2.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = isScrolledPast(target2, "top", "top") || isScrolledPast(dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
        if (lastTarget !== target2) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }
        direction = _getSwapDirection(evt, target2, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target2);
        var sibling;
        if (direction !== 0) {
          var dragIndex = index$1(dragEl);
          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, "display") === "none" || sibling === ghostEl));
        }
        if (direction === 0 || sibling === target2) {
          return completed(false);
        }
        lastTarget = target2;
        lastDirection = direction;
        var nextSibling2 = target2.nextElementSibling, after = false;
        after = direction === 1;
        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target2, targetRect, evt, after);
        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }
          _silent = true;
          setTimeout(_unsilent, 30);
          capture();
          if (after && !nextSibling2) {
            el.appendChild(dragEl);
          } else {
            target2.parentNode.insertBefore(dragEl, after ? nextSibling2 : target2);
          }
          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }
          parentEl = dragEl.parentNode;
          if (targetBeforeFirstSwap !== void 0 && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target2)[side1]);
          }
          changed();
          return completed(true);
        }
      }
      if (el.contains(dragEl)) {
        return completed(false);
      }
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, "mousemove", this._onTouchMove);
    off(document, "touchmove", this._onTouchMove);
    off(document, "pointermove", this._onTouchMove);
    off(document, "dragover", nearestEmptyInsertDetectEvent);
    off(document, "mousemove", nearestEmptyInsertDetectEvent);
    off(document, "touchmove", nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._onDrop);
    off(ownerDocument, "touchend", this._onDrop);
    off(ownerDocument, "pointerup", this._onDrop);
    off(ownerDocument, "touchcancel", this._onDrop);
    off(document, "selectstart", this);
  },
  _onDrop: function _onDrop(evt) {
    var el = this.el, options = this.options;
    newIndex = index$1(dragEl);
    newDraggableIndex = index$1(dragEl, options.draggable);
    pluginEvent2("drop", this, {
      evt
    });
    parentEl = dragEl && dragEl.parentNode;
    newIndex = index$1(dragEl);
    newDraggableIndex = index$1(dragEl, options.draggable);
    if (Sortable.eventCanceled) {
      this._nulling();
      return;
    }
    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);
    _cancelNextTick(this.cloneId);
    _cancelNextTick(this._dragStartId);
    if (this.nativeDraggable) {
      off(document, "drop", this);
      off(el, "dragstart", this._onDragStart);
    }
    this._offMoveEvents();
    this._offUpEvents();
    if (Safari) {
      css(document.body, "user-select", "");
    }
    css(dragEl, "transform", "");
    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }
      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") {
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }
      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, "dragend", this);
        }
        _disableDraggable(dragEl);
        dragEl.style["will-change"] = "";
        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }
        toggleClass(dragEl, this.options.chosenClass, false);
        _dispatchEvent({
          sortable: this,
          name: "unchoose",
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });
        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            _dispatchEvent({
              rootEl: parentEl,
              name: "add",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "remove",
              toEl: parentEl,
              originalEvent: evt
            });
            _dispatchEvent({
              rootEl: parentEl,
              name: "sort",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "sort",
              toEl: parentEl,
              originalEvent: evt
            });
          }
          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              _dispatchEvent({
                sortable: this,
                name: "update",
                toEl: parentEl,
                originalEvent: evt
              });
              _dispatchEvent({
                sortable: this,
                name: "sort",
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }
        if (Sortable.active) {
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }
          _dispatchEvent({
            sortable: this,
            name: "end",
            toEl: parentEl,
            originalEvent: evt
          });
          this.save();
        }
      }
    }
    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent2("nulling", this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function(el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(evt) {
    switch (evt.type) {
      case "drop":
      case "dragend":
        this._onDrop(evt);
        break;
      case "dragenter":
      case "dragover":
        if (dragEl) {
          this._onDragOver(evt);
          _globalDragOver(evt);
        }
        break;
      case "selectstart":
        evt.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray2() {
    var order = [], el, children = this.el.children, i2 = 0, n2 = children.length, options = this.options;
    for (; i2 < n2; i2++) {
      el = children[i2];
      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }
    return order;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order) {
    var items = {}, rootEl2 = this.el;
    this.toArray().forEach(function(id, i2) {
      var el = rootEl2.children[i2];
      if (closest(el, this.options.draggable, rootEl2, false)) {
        items[id] = el;
      }
    }, this);
    order.forEach(function(id) {
      if (items[id]) {
        rootEl2.removeChild(items[id]);
        rootEl2.appendChild(items[id]);
      }
    });
  },
  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;
    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);
      if (typeof modifiedValue !== "undefined") {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }
      if (name === "group") {
        _prepareGroup(options);
      }
    }
  },
  /**
   * Destroy
   */
  destroy: function destroy3() {
    pluginEvent2("destroy", this);
    var el = this.el;
    el[expando] = null;
    off(el, "mousedown", this._onTapStart);
    off(el, "touchstart", this._onTapStart);
    off(el, "pointerdown", this._onTapStart);
    if (this.nativeDraggable) {
      off(el, "dragover", this);
      off(el, "dragenter", this);
    }
    Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el2) {
      el2.removeAttribute("draggable");
    });
    this._onDrop();
    this._disableDelayedDragEvents();
    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent2("hideClone", this);
      if (Sortable.eventCanceled)
        return;
      css(cloneEl, "display", "none");
      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }
      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable2) {
    if (putSortable2.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (cloneHidden) {
      pluginEvent2("showClone", this);
      if (Sortable.eventCanceled)
        return;
      if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }
      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }
      css(cloneEl, "display", "");
      cloneHidden = false;
    }
  }
};
function _globalDragOver(evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = "move";
  }
  evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl2, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt, sortable = fromEl[expando], onMoveFn = sortable.options.onMove, retVal;
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent("move", {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent("move", true, true);
  }
  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl2;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);
  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }
  return retVal;
}
function _disableDraggable(el) {
  el.draggable = false;
}
function _unsilent() {
  _silent = false;
}
function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}
function _getSwapDirection(evt, target2, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
  if (!invertSwap) {
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        pastFirstInvertThresh = true;
      }
      if (!pastFirstInvertThresh) {
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target2);
      }
    }
  }
  invert = invert || invertSwap;
  if (invert) {
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }
  return 0;
}
function _getInsertDirection(target2) {
  if (index$1(dragEl) < index$1(target2)) {
    return 1;
  } else {
    return -1;
  }
}
function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent, i2 = str.length, sum = 0;
  while (i2--) {
    sum += str.charCodeAt(i2);
  }
  return sum.toString(36);
}
function _saveInputCheckedState(root2) {
  savedInputChecked.length = 0;
  var inputs = root2.getElementsByTagName("input");
  var idx = inputs.length;
  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}
function _nextTick(fn) {
  return setTimeout(fn, 0);
}
function _cancelNextTick(id) {
  return clearTimeout(id);
}
if (documentExists) {
  on(document, "touchmove", function(evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
}
Sortable.utils = {
  on,
  off,
  css,
  find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend,
  throttle,
  closest,
  toggleClass,
  clone,
  index: index$1,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild
};
Sortable.get = function(element) {
  return element[expando];
};
Sortable.mount = function() {
  for (var _len = arguments.length, plugins2 = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins2[_key] = arguments[_key];
  }
  if (plugins2[0].constructor === Array)
    plugins2 = plugins2[0];
  plugins2.forEach(function(plugin3) {
    if (!plugin3.prototype || !plugin3.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin3));
    }
    if (plugin3.utils)
      Sortable.utils = _objectSpread({}, Sortable.utils, plugin3.utils);
    PluginManager.mount(plugin3);
  });
};
Sortable.create = function(el, options) {
  return new Sortable(el, options);
};
Sortable.version = version;
var autoScrolls = [], scrollEl, scrollRootEl, scrolling = false, lastAutoScrollX, lastAutoScrollY, touchEvt$1, pointerElemChangedInterval;
function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    };
    for (var fn in this) {
      if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
        this[fn] = this[fn].bind(this);
      }
    }
  }
  AutoScroll.prototype = {
    dragStarted: function dragStarted2(_ref) {
      var originalEvent = _ref.originalEvent;
      if (this.sortable.nativeDraggable) {
        on(document, "dragover", this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, "pointermove", this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, "touchmove", this._handleFallbackAutoScroll);
        } else {
          on(document, "mousemove", this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop3() {
      if (this.sortable.nativeDraggable) {
        off(document, "dragover", this._handleAutoScroll);
      } else {
        off(document, "pointermove", this._handleFallbackAutoScroll);
        off(document, "touchmove", this._handleFallbackAutoScroll);
        off(document, "mousemove", this._handleFallbackAutoScroll);
      }
      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this2 = this;
      var x2 = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x2, y);
      touchEvt$1 = evt;
      if (fallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback);
        var ogElemScroller = getParentAutoScrollElement(elem, true);
        if (scrolling && (!pointerElemChangedInterval || x2 !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval();
          pointerElemChangedInterval = setInterval(function() {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x2, y), true);
            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }
            autoScroll(evt, _this2.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x2;
          lastAutoScrollY = y;
        }
      } else {
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }
        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: "scroll",
    initializeByDefault: true
  });
}
function clearAutoScrolls() {
  autoScrolls.forEach(function(autoScroll2) {
    clearInterval(autoScroll2.pid);
  });
  autoScrolls = [];
}
function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle(function(evt, options, rootEl2, isFallback) {
  if (!options.scroll)
    return;
  var x2 = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = getWindowScrollingElement();
  var scrollThisInstance = false, scrollCustomFn;
  if (scrollRootEl !== rootEl2) {
    scrollRootEl = rootEl2;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;
    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl2, true);
    }
  }
  var layersOut = 0;
  var currentParent = scrollEl;
  do {
    var el = currentParent, rect = getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
    }
    var vx = canScrollX && (Math.abs(right - x2) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x2) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
    if (!autoScrolls[layersOut]) {
      for (var i2 = 0; i2 <= layersOut; i2++) {
        if (!autoScrolls[i2]) {
          autoScrolls[i2] = {};
        }
      }
    }
    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);
      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        autoScrolls[layersOut].pid = setInterval(function() {
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1);
          }
          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
          if (typeof scrollCustomFn === "function") {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== "continue") {
              return;
            }
          }
          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }
    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
  scrolling = scrollThisInstance;
}, 30);
var drop = function drop2(_ref) {
  var originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, dragEl2 = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent)
    return;
  var toSortable = putSortable2 || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target2 = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();
  if (toSortable && !toSortable.el.contains(target2)) {
    dispatchSortableEvent("spill");
    this.onSpill({
      dragEl: dragEl2,
      putSortable: putSortable2
    });
  }
};
function Revert() {
}
Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex2 = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex2;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl2 = _ref3.dragEl, putSortable2 = _ref3.putSortable;
    this.sortable.captureAnimationState();
    if (putSortable2) {
      putSortable2.captureAnimationState();
    }
    var nextSibling2 = getChild(this.sortable.el, this.startIndex, this.options);
    if (nextSibling2) {
      this.sortable.el.insertBefore(dragEl2, nextSibling2);
    } else {
      this.sortable.el.appendChild(dragEl2);
    }
    this.sortable.animateAll();
    if (putSortable2) {
      putSortable2.animateAll();
    }
  },
  drop
};
_extends(Revert, {
  pluginName: "revertOnSpill"
});
function Remove() {
}
Remove.prototype = {
  onSpill: function onSpill2(_ref4) {
    var dragEl2 = _ref4.dragEl, putSortable2 = _ref4.putSortable;
    var parentSortable = putSortable2 || this.sortable;
    parentSortable.captureAnimationState();
    dragEl2.parentNode && dragEl2.parentNode.removeChild(dragEl2);
    parentSortable.animateAll();
  },
  drop
};
_extends(Remove, {
  pluginName: "removeOnSpill"
});
var lastSwapEl;
function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: "sortable-swap-highlight"
    };
  }
  Swap.prototype = {
    dragStart: function dragStart2(_ref) {
      var dragEl2 = _ref.dragEl;
      lastSwapEl = dragEl2;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed, target2 = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
      if (!activeSortable.options.swap)
        return;
      var el = this.sortable.el, options = this.options;
      if (target2 && target2 !== el) {
        var prevSwapEl = lastSwapEl;
        if (onMove(target2) !== false) {
          toggleClass(target2, options.swapClass, true);
          lastSwapEl = target2;
        } else {
          lastSwapEl = null;
        }
        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }
      changed();
      completed(true);
      cancel();
    },
    drop: function drop3(_ref3) {
      var activeSortable = _ref3.activeSortable, putSortable2 = _ref3.putSortable, dragEl2 = _ref3.dragEl;
      var toSortable = putSortable2 || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);
      if (lastSwapEl && (options.swap || putSortable2 && putSortable2.options.swap)) {
        if (dragEl2 !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable)
            activeSortable.captureAnimationState();
          swapNodes(dragEl2, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable)
            activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: "swap",
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}
function swapNodes(n1, n2) {
  var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1))
    return;
  i1 = index$1(n1);
  i2 = index$1(n2);
  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }
  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}
var multiDragElements = [], multiDragClones = [], lastMultiDragSelect, multiDragSortable, initialFolding = false, folding = false, dragStarted = false, dragEl$1, clonesFromRect, clonesHidden;
function MultiDragPlugin() {
  function MultiDrag(sortable) {
    for (var fn in this) {
      if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
        this[fn] = this[fn].bind(this);
      }
    }
    if (sortable.options.supportPointer) {
      on(document, "pointerup", this._deselectMultiDrag);
    } else {
      on(document, "mouseup", this._deselectMultiDrag);
      on(document, "touchend", this._deselectMultiDrag);
    }
    on(document, "keydown", this._checkKeyDown);
    on(document, "keyup", this._checkKeyUp);
    this.defaults = {
      selectedClass: "sortable-selected",
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl2) {
        var data = "";
        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function(multiDragElement, i2) {
            data += (!i2 ? "" : ", ") + multiDragElement.textContent;
          });
        } else {
          data = dragEl2.textContent;
        }
        dataTransfer.setData("Text", data);
      }
    };
  }
  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable, cancel = _ref2.cancel;
      if (!this.isMultiDrag)
        return;
      for (var i2 = 0; i2 < multiDragElements.length; i2++) {
        multiDragClones.push(clone(multiDragElements[i2]));
        multiDragClones[i2].sortableIndex = multiDragElements[i2].sortableIndex;
        multiDragClones[i2].draggable = false;
        multiDragClones[i2].style["will-change"] = "";
        toggleClass(multiDragClones[i2], this.options.selectedClass, false);
        multiDragElements[i2] === dragEl$1 && toggleClass(multiDragClones[i2], this.options.chosenClass, false);
      }
      sortable._hideClone();
      cancel();
    },
    clone: function clone2(_ref3) {
      var sortable = _ref3.sortable, rootEl2 = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
      if (!this.isMultiDrag)
        return;
      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl2);
          dispatchSortableEvent("clone");
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown, rootEl2 = _ref4.rootEl, cancel = _ref4.cancel;
      if (!this.isMultiDrag)
        return;
      insertMultiDragClones(false, rootEl2);
      multiDragClones.forEach(function(clone2) {
        css(clone2, "display", "");
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this2 = this;
      _ref5.sortable;
      var cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
      if (!this.isMultiDrag)
        return;
      multiDragClones.forEach(function(clone2) {
        css(clone2, "display", "none");
        if (_this2.options.removeCloneOnHide && clone2.parentNode) {
          clone2.parentNode.removeChild(clone2);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      _ref6.sortable;
      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }
      multiDragElements.forEach(function(multiDragElement) {
        multiDragElement.sortableIndex = index$1(multiDragElement);
      });
      multiDragElements = multiDragElements.sort(function(a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted2(_ref7) {
      var _this2 = this;
      var sortable = _ref7.sortable;
      if (!this.isMultiDrag)
        return;
      if (this.options.sort) {
        sortable.captureAnimationState();
        if (this.options.animation) {
          multiDragElements.forEach(function(multiDragElement) {
            if (multiDragElement === dragEl$1)
              return;
            css(multiDragElement, "position", "absolute");
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function(multiDragElement) {
            if (multiDragElement === dragEl$1)
              return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }
      sortable.animateAll(function() {
        folding = false;
        initialFolding = false;
        if (_this2.options.animation) {
          multiDragElements.forEach(function(multiDragElement) {
            unsetRect(multiDragElement);
          });
        }
        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target2 = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
      if (folding && ~multiDragElements.indexOf(target2)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable, rootEl2 = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
      if (multiDragElements.length > 1) {
        multiDragElements.forEach(function(multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl2);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl2 = _ref10.parentEl, putSortable2 = _ref10.putSortable;
      var options = this.options;
      if (insertion) {
        if (isOwner) {
          activeSortable._hideClone();
        }
        initialFolding = false;
        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable2)) {
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function(multiDragElement) {
            if (multiDragElement === dragEl$1)
              return;
            setRect(multiDragElement, dragRectAbsolute);
            parentEl2.appendChild(multiDragElement);
          });
          folding = true;
        }
        if (!isOwner) {
          if (!folding) {
            removeMultiDragElements();
          }
          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;
            activeSortable._showClone(sortable);
            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function(clone2) {
                activeSortable.addAnimationState({
                  target: clone2,
                  rect: clonesFromRect
                });
                clone2.fromRect = clonesFromRect;
                clone2.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function(multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });
      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop3(_ref12) {
      var evt = _ref12.originalEvent, rootEl2 = _ref12.rootEl, parentEl2 = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex2 = _ref12.oldIndex, putSortable2 = _ref12.putSortable;
      var toSortable = putSortable2 || this.sortable;
      if (!evt)
        return;
      var options = this.options, children = parentEl2.children;
      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }
        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));
        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable,
            rootEl: rootEl2,
            name: "select",
            targetEl: dragEl$1,
            originalEvt: evt
          });
          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index$1(lastMultiDragSelect), currentIndex = index$1(dragEl$1);
            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              var n2, i2;
              if (currentIndex > lastIndex) {
                i2 = lastIndex;
                n2 = currentIndex;
              } else {
                i2 = currentIndex;
                n2 = lastIndex + 1;
              }
              for (; i2 < n2; i2++) {
                if (~multiDragElements.indexOf(children[i2]))
                  continue;
                toggleClass(children[i2], options.selectedClass, true);
                multiDragElements.push(children[i2]);
                dispatchEvent({
                  sortable,
                  rootEl: rootEl2,
                  name: "select",
                  targetEl: children[i2],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }
          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable,
            rootEl: rootEl2,
            name: "deselect",
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      }
      if (dragStarted && this.isMultiDrag) {
        if ((parentEl2[expando].options.sort || parentEl2 !== rootEl2) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1), multiDragIndex = index$1(dragEl$1, ":not(." + this.options.selectedClass + ")");
          if (!initialFolding && options.animation)
            dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();
          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect;
                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect
                  });
                }
              });
            }
            removeMultiDragElements();
            multiDragElements.forEach(function(multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl2.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl2.appendChild(multiDragElement);
              }
              multiDragIndex++;
            });
            if (oldIndex2 === index$1(dragEl$1)) {
              var update5 = false;
              multiDragElements.forEach(function(multiDragElement) {
                if (multiDragElement.sortableIndex !== index$1(multiDragElement)) {
                  update5 = true;
                  return;
                }
              });
              if (update5) {
                dispatchSortableEvent("update");
              }
            }
          }
          multiDragElements.forEach(function(multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }
        multiDragSortable = toSortable;
      }
      if (rootEl2 === parentEl2 || putSortable2 && putSortable2.lastPutMode !== "clone") {
        multiDragClones.forEach(function(clone2) {
          clone2.parentNode && clone2.parentNode.removeChild(clone2);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();
      off(document, "pointerup", this._deselectMultiDrag);
      off(document, "mouseup", this._deselectMultiDrag);
      off(document, "touchend", this._deselectMultiDrag);
      off(document, "keydown", this._checkKeyDown);
      off(document, "keyup", this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted)
        return;
      if (multiDragSortable !== this.sortable)
        return;
      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false))
        return;
      if (evt && evt.button !== 0)
        return;
      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: "deselect",
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: "multiDrag",
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el))
          return;
        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();
          multiDragSortable = sortable;
        }
        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },
      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando], index2 = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index2)
          return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index2, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;
      var oldIndicies = [], newIndicies = [];
      multiDragElements.forEach(function(multiDragElement) {
        oldIndicies.push({
          multiDragElement,
          index: multiDragElement.sortableIndex
        });
        var newIndex2;
        if (folding && multiDragElement !== dragEl$1) {
          newIndex2 = -1;
        } else if (folding) {
          newIndex2 = index$1(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
        } else {
          newIndex2 = index$1(multiDragElement);
        }
        newIndicies.push({
          multiDragElement,
          index: newIndex2
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies,
        newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();
        if (key === "ctrl") {
          key = "Control";
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }
        return key;
      }
    }
  });
}
function insertMultiDragElements(clonesInserted, rootEl2) {
  multiDragElements.forEach(function(multiDragElement, i2) {
    var target2 = rootEl2.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i2) : 0)];
    if (target2) {
      rootEl2.insertBefore(multiDragElement, target2);
    } else {
      rootEl2.appendChild(multiDragElement);
    }
  });
}
function insertMultiDragClones(elementsInserted, rootEl2) {
  multiDragClones.forEach(function(clone2, i2) {
    var target2 = rootEl2.children[clone2.sortableIndex + (elementsInserted ? Number(i2) : 0)];
    if (target2) {
      rootEl2.insertBefore(clone2, target2);
    } else {
      rootEl2.appendChild(clone2);
    }
  });
}
function removeMultiDragElements() {
  multiDragElements.forEach(function(multiDragElement) {
    if (multiDragElement === dragEl$1)
      return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}
Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);
const sortable_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MultiDrag: MultiDragPlugin,
  Sortable,
  Swap: SwapPlugin,
  default: Sortable
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(sortable_esm);
(function(module, exports) {
  (function webpackUniversalModuleDefinition(root2, factory) {
    module.exports = factory(require$$0);
  })(typeof self !== "undefined" ? self : commonjsGlobal, function(__WEBPACK_EXTERNAL_MODULE_a352__) {
    return (
      /******/
      function(modules2) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
          if (installedModules[moduleId]) {
            return installedModules[moduleId].exports;
          }
          var module2 = installedModules[moduleId] = {
            /******/
            i: moduleId,
            /******/
            l: false,
            /******/
            exports: {}
            /******/
          };
          modules2[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
          module2.l = true;
          return module2.exports;
        }
        __webpack_require__.m = modules2;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports2, name, getter) {
          if (!__webpack_require__.o(exports2, name)) {
            Object.defineProperty(exports2, name, { enumerable: true, get: getter });
          }
        };
        __webpack_require__.r = function(exports2) {
          if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
            Object.defineProperty(exports2, Symbol.toStringTag, { value: "Module" });
          }
          Object.defineProperty(exports2, "__esModule", { value: true });
        };
        __webpack_require__.t = function(value, mode) {
          if (mode & 1)
            value = __webpack_require__(value);
          if (mode & 8)
            return value;
          if (mode & 4 && typeof value === "object" && value && value.__esModule)
            return value;
          var ns = /* @__PURE__ */ Object.create(null);
          __webpack_require__.r(ns);
          Object.defineProperty(ns, "default", { enumerable: true, value });
          if (mode & 2 && typeof value != "string")
            for (var key in value)
              __webpack_require__.d(ns, key, function(key2) {
                return value[key2];
              }.bind(null, key));
          return ns;
        };
        __webpack_require__.n = function(module2) {
          var getter = module2 && module2.__esModule ? (
            /******/
            function getDefault() {
              return module2["default"];
            }
          ) : (
            /******/
            function getModuleExports() {
              return module2;
            }
          );
          __webpack_require__.d(getter, "a", getter);
          return getter;
        };
        __webpack_require__.o = function(object, property2) {
          return Object.prototype.hasOwnProperty.call(object, property2);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = "fb15");
      }({
        /***/
        "01f9": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var LIBRARY = __webpack_require__("2d00");
            var $export = __webpack_require__("5ca1");
            var redefine = __webpack_require__("2aba");
            var hide = __webpack_require__("32e9");
            var Iterators = __webpack_require__("84f2");
            var $iterCreate = __webpack_require__("41a0");
            var setToStringTag = __webpack_require__("7f20");
            var getPrototypeOf = __webpack_require__("38fd");
            var ITERATOR = __webpack_require__("2b4c")("iterator");
            var BUGGY = !([].keys && "next" in [].keys());
            var FF_ITERATOR = "@@iterator";
            var KEYS = "keys";
            var VALUES = "values";
            var returnThis = function() {
              return this;
            };
            module2.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
              $iterCreate(Constructor, NAME, next);
              var getMethod = function(kind) {
                if (!BUGGY && kind in proto)
                  return proto[kind];
                switch (kind) {
                  case KEYS:
                    return function keys2() {
                      return new Constructor(this, kind);
                    };
                  case VALUES:
                    return function values2() {
                      return new Constructor(this, kind);
                    };
                }
                return function entries() {
                  return new Constructor(this, kind);
                };
              };
              var TAG = NAME + " Iterator";
              var DEF_VALUES = DEFAULT == VALUES;
              var VALUES_BUG = false;
              var proto = Base.prototype;
              var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
              var $default = $native || getMethod(DEFAULT);
              var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod("entries") : void 0;
              var $anyNative = NAME == "Array" ? proto.entries || $native : $native;
              var methods, key, IteratorPrototype;
              if ($anyNative) {
                IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
                if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
                  setToStringTag(IteratorPrototype, TAG, true);
                  if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != "function")
                    hide(IteratorPrototype, ITERATOR, returnThis);
                }
              }
              if (DEF_VALUES && $native && $native.name !== VALUES) {
                VALUES_BUG = true;
                $default = function values2() {
                  return $native.call(this);
                };
              }
              if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
                hide(proto, ITERATOR, $default);
              }
              Iterators[NAME] = $default;
              Iterators[TAG] = returnThis;
              if (DEFAULT) {
                methods = {
                  values: DEF_VALUES ? $default : getMethod(VALUES),
                  keys: IS_SET ? $default : getMethod(KEYS),
                  entries: $entries
                };
                if (FORCED)
                  for (key in methods) {
                    if (!(key in proto))
                      redefine(proto, key, methods[key]);
                  }
                else
                  $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
              }
              return methods;
            };
          }
        ),
        /***/
        "02f4": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var toInteger2 = __webpack_require__("4588");
            var defined = __webpack_require__("be13");
            module2.exports = function(TO_STRING) {
              return function(that, pos) {
                var s2 = String(defined(that));
                var i2 = toInteger2(pos);
                var l = s2.length;
                var a, b;
                if (i2 < 0 || i2 >= l)
                  return TO_STRING ? "" : void 0;
                a = s2.charCodeAt(i2);
                return a < 55296 || a > 56319 || i2 + 1 === l || (b = s2.charCodeAt(i2 + 1)) < 56320 || b > 57343 ? TO_STRING ? s2.charAt(i2) : a : TO_STRING ? s2.slice(i2, i2 + 2) : (a - 55296 << 10) + (b - 56320) + 65536;
              };
            };
          }
        ),
        /***/
        "0390": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var at = __webpack_require__("02f4")(true);
            module2.exports = function(S, index2, unicode) {
              return index2 + (unicode ? at(S, index2).length : 1);
            };
          }
        ),
        /***/
        "0bfb": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var anObject = __webpack_require__("cb7c");
            module2.exports = function() {
              var that = anObject(this);
              var result2 = "";
              if (that.global)
                result2 += "g";
              if (that.ignoreCase)
                result2 += "i";
              if (that.multiline)
                result2 += "m";
              if (that.unicode)
                result2 += "u";
              if (that.sticky)
                result2 += "y";
              return result2;
            };
          }
        ),
        /***/
        "0d58": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var $keys = __webpack_require__("ce10");
            var enumBugKeys = __webpack_require__("e11e");
            module2.exports = Object.keys || function keys2(O) {
              return $keys(O, enumBugKeys);
            };
          }
        ),
        /***/
        "1495": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var dP = __webpack_require__("86cc");
            var anObject = __webpack_require__("cb7c");
            var getKeys2 = __webpack_require__("0d58");
            module2.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
              anObject(O);
              var keys2 = getKeys2(Properties);
              var length = keys2.length;
              var i2 = 0;
              var P;
              while (length > i2)
                dP.f(O, P = keys2[i2++], Properties[P]);
              return O;
            };
          }
        ),
        /***/
        "214f": (
          /***/
          function(module2, exports2, __webpack_require__) {
            __webpack_require__("b0c5");
            var redefine = __webpack_require__("2aba");
            var hide = __webpack_require__("32e9");
            var fails = __webpack_require__("79e5");
            var defined = __webpack_require__("be13");
            var wks = __webpack_require__("2b4c");
            var regexpExec = __webpack_require__("520a");
            var SPECIES = wks("species");
            var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
              var re = /./;
              re.exec = function() {
                var result2 = [];
                result2.groups = { a: "7" };
                return result2;
              };
              return "".replace(re, "$<a>") !== "7";
            });
            var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function() {
              var re = /(?:)/;
              var originalExec = re.exec;
              re.exec = function() {
                return originalExec.apply(this, arguments);
              };
              var result2 = "ab".split(re);
              return result2.length === 2 && result2[0] === "a" && result2[1] === "b";
            }();
            module2.exports = function(KEY, length, exec) {
              var SYMBOL = wks(KEY);
              var DELEGATES_TO_SYMBOL = !fails(function() {
                var O = {};
                O[SYMBOL] = function() {
                  return 7;
                };
                return ""[KEY](O) != 7;
              });
              var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function() {
                var execCalled = false;
                var re = /a/;
                re.exec = function() {
                  execCalled = true;
                  return null;
                };
                if (KEY === "split") {
                  re.constructor = {};
                  re.constructor[SPECIES] = function() {
                    return re;
                  };
                }
                re[SYMBOL]("");
                return !execCalled;
              }) : void 0;
              if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === "replace" && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === "split" && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
                var nativeRegExpMethod = /./[SYMBOL];
                var fns = exec(
                  defined,
                  SYMBOL,
                  ""[KEY],
                  function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
                    if (regexp.exec === regexpExec) {
                      if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                        return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
                      }
                      return { done: true, value: nativeMethod.call(str, regexp, arg2) };
                    }
                    return { done: false };
                  }
                );
                var strfn = fns[0];
                var rxfn = fns[1];
                redefine(String.prototype, KEY, strfn);
                hide(
                  RegExp.prototype,
                  SYMBOL,
                  length == 2 ? function(string, arg) {
                    return rxfn.call(string, this, arg);
                  } : function(string) {
                    return rxfn.call(string, this);
                  }
                );
              }
            };
          }
        ),
        /***/
        "230e": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var isObject2 = __webpack_require__("d3f4");
            var document2 = __webpack_require__("7726").document;
            var is2 = isObject2(document2) && isObject2(document2.createElement);
            module2.exports = function(it) {
              return is2 ? document2.createElement(it) : {};
            };
          }
        ),
        /***/
        "23c6": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var cof = __webpack_require__("2d95");
            var TAG = __webpack_require__("2b4c")("toStringTag");
            var ARG = cof(function() {
              return arguments;
            }()) == "Arguments";
            var tryGet = function(it, key) {
              try {
                return it[key];
              } catch (e) {
              }
            };
            module2.exports = function(it) {
              var O, T, B;
              return it === void 0 ? "Undefined" : it === null ? "Null" : typeof (T = tryGet(O = Object(it), TAG)) == "string" ? T : ARG ? cof(O) : (B = cof(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : B;
            };
          }
        ),
        /***/
        "2621": (
          /***/
          function(module2, exports2) {
            exports2.f = Object.getOwnPropertySymbols;
          }
        ),
        /***/
        "2aba": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var global2 = __webpack_require__("7726");
            var hide = __webpack_require__("32e9");
            var has2 = __webpack_require__("69a8");
            var SRC = __webpack_require__("ca5a")("src");
            var $toString = __webpack_require__("fa5b");
            var TO_STRING = "toString";
            var TPL = ("" + $toString).split(TO_STRING);
            __webpack_require__("8378").inspectSource = function(it) {
              return $toString.call(it);
            };
            (module2.exports = function(O, key, val, safe) {
              var isFunction2 = typeof val == "function";
              if (isFunction2)
                has2(val, "name") || hide(val, "name", key);
              if (O[key] === val)
                return;
              if (isFunction2)
                has2(val, SRC) || hide(val, SRC, O[key] ? "" + O[key] : TPL.join(String(key)));
              if (O === global2) {
                O[key] = val;
              } else if (!safe) {
                delete O[key];
                hide(O, key, val);
              } else if (O[key]) {
                O[key] = val;
              } else {
                hide(O, key, val);
              }
            })(Function.prototype, TO_STRING, function toString2() {
              return typeof this == "function" && this[SRC] || $toString.call(this);
            });
          }
        ),
        /***/
        "2aeb": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var anObject = __webpack_require__("cb7c");
            var dPs = __webpack_require__("1495");
            var enumBugKeys = __webpack_require__("e11e");
            var IE_PROTO = __webpack_require__("613b")("IE_PROTO");
            var Empty = function() {
            };
            var PROTOTYPE = "prototype";
            var createDict = function() {
              var iframe = __webpack_require__("230e")("iframe");
              var i2 = enumBugKeys.length;
              var lt = "<";
              var gt = ">";
              var iframeDocument;
              iframe.style.display = "none";
              __webpack_require__("fab2").appendChild(iframe);
              iframe.src = "javascript:";
              iframeDocument = iframe.contentWindow.document;
              iframeDocument.open();
              iframeDocument.write(lt + "script" + gt + "document.F=Object" + lt + "/script" + gt);
              iframeDocument.close();
              createDict = iframeDocument.F;
              while (i2--)
                delete createDict[PROTOTYPE][enumBugKeys[i2]];
              return createDict();
            };
            module2.exports = Object.create || function create4(O, Properties) {
              var result2;
              if (O !== null) {
                Empty[PROTOTYPE] = anObject(O);
                result2 = new Empty();
                Empty[PROTOTYPE] = null;
                result2[IE_PROTO] = O;
              } else
                result2 = createDict();
              return Properties === void 0 ? result2 : dPs(result2, Properties);
            };
          }
        ),
        /***/
        "2b4c": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var store = __webpack_require__("5537")("wks");
            var uid2 = __webpack_require__("ca5a");
            var Symbol2 = __webpack_require__("7726").Symbol;
            var USE_SYMBOL = typeof Symbol2 == "function";
            var $exports = module2.exports = function(name) {
              return store[name] || (store[name] = USE_SYMBOL && Symbol2[name] || (USE_SYMBOL ? Symbol2 : uid2)("Symbol." + name));
            };
            $exports.store = store;
          }
        ),
        /***/
        "2d00": (
          /***/
          function(module2, exports2) {
            module2.exports = false;
          }
        ),
        /***/
        "2d95": (
          /***/
          function(module2, exports2) {
            var toString2 = {}.toString;
            module2.exports = function(it) {
              return toString2.call(it).slice(8, -1);
            };
          }
        ),
        /***/
        "2fdb": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var $export = __webpack_require__("5ca1");
            var context = __webpack_require__("d2c8");
            var INCLUDES = "includes";
            $export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), "String", {
              includes: function includes2(searchString) {
                return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : void 0);
              }
            });
          }
        ),
        /***/
        "32e9": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var dP = __webpack_require__("86cc");
            var createDesc = __webpack_require__("4630");
            module2.exports = __webpack_require__("9e1e") ? function(object, key, value) {
              return dP.f(object, key, createDesc(1, value));
            } : function(object, key, value) {
              object[key] = value;
              return object;
            };
          }
        ),
        /***/
        "38fd": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var has2 = __webpack_require__("69a8");
            var toObject2 = __webpack_require__("4bf8");
            var IE_PROTO = __webpack_require__("613b")("IE_PROTO");
            var ObjectProto = Object.prototype;
            module2.exports = Object.getPrototypeOf || function(O) {
              O = toObject2(O);
              if (has2(O, IE_PROTO))
                return O[IE_PROTO];
              if (typeof O.constructor == "function" && O instanceof O.constructor) {
                return O.constructor.prototype;
              }
              return O instanceof Object ? ObjectProto : null;
            };
          }
        ),
        /***/
        "41a0": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var create4 = __webpack_require__("2aeb");
            var descriptor = __webpack_require__("4630");
            var setToStringTag = __webpack_require__("7f20");
            var IteratorPrototype = {};
            __webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")("iterator"), function() {
              return this;
            });
            module2.exports = function(Constructor, NAME, next) {
              Constructor.prototype = create4(IteratorPrototype, { next: descriptor(1, next) });
              setToStringTag(Constructor, NAME + " Iterator");
            };
          }
        ),
        /***/
        "456d": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var toObject2 = __webpack_require__("4bf8");
            var $keys = __webpack_require__("0d58");
            __webpack_require__("5eda")("keys", function() {
              return function keys2(it) {
                return $keys(toObject2(it));
              };
            });
          }
        ),
        /***/
        "4588": (
          /***/
          function(module2, exports2) {
            var ceil = Math.ceil;
            var floor = Math.floor;
            module2.exports = function(it) {
              return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
            };
          }
        ),
        /***/
        "4630": (
          /***/
          function(module2, exports2) {
            module2.exports = function(bitmap, value) {
              return {
                enumerable: !(bitmap & 1),
                configurable: !(bitmap & 2),
                writable: !(bitmap & 4),
                value
              };
            };
          }
        ),
        /***/
        "4bf8": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var defined = __webpack_require__("be13");
            module2.exports = function(it) {
              return Object(defined(it));
            };
          }
        ),
        /***/
        "5147": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var MATCH = __webpack_require__("2b4c")("match");
            module2.exports = function(KEY) {
              var re = /./;
              try {
                "/./"[KEY](re);
              } catch (e) {
                try {
                  re[MATCH] = false;
                  return !"/./"[KEY](re);
                } catch (f) {
                }
              }
              return true;
            };
          }
        ),
        /***/
        "520a": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var regexpFlags = __webpack_require__("0bfb");
            var nativeExec = RegExp.prototype.exec;
            var nativeReplace = String.prototype.replace;
            var patchedExec = nativeExec;
            var LAST_INDEX = "lastIndex";
            var UPDATES_LAST_INDEX_WRONG = function() {
              var re1 = /a/, re2 = /b*/g;
              nativeExec.call(re1, "a");
              nativeExec.call(re2, "a");
              return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
            }();
            var NPCG_INCLUDED = /()??/.exec("")[1] !== void 0;
            var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
            if (PATCH) {
              patchedExec = function exec(str) {
                var re = this;
                var lastIndex, reCopy, match, i2;
                if (NPCG_INCLUDED) {
                  reCopy = new RegExp("^" + re.source + "$(?!\\s)", regexpFlags.call(re));
                }
                if (UPDATES_LAST_INDEX_WRONG)
                  lastIndex = re[LAST_INDEX];
                match = nativeExec.call(re, str);
                if (UPDATES_LAST_INDEX_WRONG && match) {
                  re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
                }
                if (NPCG_INCLUDED && match && match.length > 1) {
                  nativeReplace.call(match[0], reCopy, function() {
                    for (i2 = 1; i2 < arguments.length - 2; i2++) {
                      if (arguments[i2] === void 0)
                        match[i2] = void 0;
                    }
                  });
                }
                return match;
              };
            }
            module2.exports = patchedExec;
          }
        ),
        /***/
        "52a7": (
          /***/
          function(module2, exports2) {
            exports2.f = {}.propertyIsEnumerable;
          }
        ),
        /***/
        "5537": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var core = __webpack_require__("8378");
            var global2 = __webpack_require__("7726");
            var SHARED = "__core-js_shared__";
            var store = global2[SHARED] || (global2[SHARED] = {});
            (module2.exports = function(key, value) {
              return store[key] || (store[key] = value !== void 0 ? value : {});
            })("versions", []).push({
              version: core.version,
              mode: __webpack_require__("2d00") ? "pure" : "global",
              copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
            });
          }
        ),
        /***/
        "5ca1": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var global2 = __webpack_require__("7726");
            var core = __webpack_require__("8378");
            var hide = __webpack_require__("32e9");
            var redefine = __webpack_require__("2aba");
            var ctx = __webpack_require__("9b43");
            var PROTOTYPE = "prototype";
            var $export = function(type, name, source) {
              var IS_FORCED = type & $export.F;
              var IS_GLOBAL = type & $export.G;
              var IS_STATIC = type & $export.S;
              var IS_PROTO = type & $export.P;
              var IS_BIND = type & $export.B;
              var target2 = IS_GLOBAL ? global2 : IS_STATIC ? global2[name] || (global2[name] = {}) : (global2[name] || {})[PROTOTYPE];
              var exports3 = IS_GLOBAL ? core : core[name] || (core[name] = {});
              var expProto = exports3[PROTOTYPE] || (exports3[PROTOTYPE] = {});
              var key, own, out, exp;
              if (IS_GLOBAL)
                source = name;
              for (key in source) {
                own = !IS_FORCED && target2 && target2[key] !== void 0;
                out = (own ? target2 : source)[key];
                exp = IS_BIND && own ? ctx(out, global2) : IS_PROTO && typeof out == "function" ? ctx(Function.call, out) : out;
                if (target2)
                  redefine(target2, key, out, type & $export.U);
                if (exports3[key] != out)
                  hide(exports3, key, exp);
                if (IS_PROTO && expProto[key] != out)
                  expProto[key] = out;
              }
            };
            global2.core = core;
            $export.F = 1;
            $export.G = 2;
            $export.S = 4;
            $export.P = 8;
            $export.B = 16;
            $export.W = 32;
            $export.U = 64;
            $export.R = 128;
            module2.exports = $export;
          }
        ),
        /***/
        "5eda": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var $export = __webpack_require__("5ca1");
            var core = __webpack_require__("8378");
            var fails = __webpack_require__("79e5");
            module2.exports = function(KEY, exec) {
              var fn = (core.Object || {})[KEY] || Object[KEY];
              var exp = {};
              exp[KEY] = exec(fn);
              $export($export.S + $export.F * fails(function() {
                fn(1);
              }), "Object", exp);
            };
          }
        ),
        /***/
        "5f1b": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var classof = __webpack_require__("23c6");
            var builtinExec = RegExp.prototype.exec;
            module2.exports = function(R, S) {
              var exec = R.exec;
              if (typeof exec === "function") {
                var result2 = exec.call(R, S);
                if (typeof result2 !== "object") {
                  throw new TypeError("RegExp exec method returned something other than an Object or null");
                }
                return result2;
              }
              if (classof(R) !== "RegExp") {
                throw new TypeError("RegExp#exec called on incompatible receiver");
              }
              return builtinExec.call(R, S);
            };
          }
        ),
        /***/
        "613b": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var shared = __webpack_require__("5537")("keys");
            var uid2 = __webpack_require__("ca5a");
            module2.exports = function(key) {
              return shared[key] || (shared[key] = uid2(key));
            };
          }
        ),
        /***/
        "626a": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var cof = __webpack_require__("2d95");
            module2.exports = Object("z").propertyIsEnumerable(0) ? Object : function(it) {
              return cof(it) == "String" ? it.split("") : Object(it);
            };
          }
        ),
        /***/
        "6762": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var $export = __webpack_require__("5ca1");
            var $includes = __webpack_require__("c366")(true);
            $export($export.P, "Array", {
              includes: function includes2(el) {
                return $includes(this, el, arguments.length > 1 ? arguments[1] : void 0);
              }
            });
            __webpack_require__("9c6c")("includes");
          }
        ),
        /***/
        "6821": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var IObject = __webpack_require__("626a");
            var defined = __webpack_require__("be13");
            module2.exports = function(it) {
              return IObject(defined(it));
            };
          }
        ),
        /***/
        "69a8": (
          /***/
          function(module2, exports2) {
            var hasOwnProperty2 = {}.hasOwnProperty;
            module2.exports = function(it, key) {
              return hasOwnProperty2.call(it, key);
            };
          }
        ),
        /***/
        "6a99": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var isObject2 = __webpack_require__("d3f4");
            module2.exports = function(it, S) {
              if (!isObject2(it))
                return it;
              var fn, val;
              if (S && typeof (fn = it.toString) == "function" && !isObject2(val = fn.call(it)))
                return val;
              if (typeof (fn = it.valueOf) == "function" && !isObject2(val = fn.call(it)))
                return val;
              if (!S && typeof (fn = it.toString) == "function" && !isObject2(val = fn.call(it)))
                return val;
              throw TypeError("Can't convert object to primitive value");
            };
          }
        ),
        /***/
        "7333": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var getKeys2 = __webpack_require__("0d58");
            var gOPS = __webpack_require__("2621");
            var pIE = __webpack_require__("52a7");
            var toObject2 = __webpack_require__("4bf8");
            var IObject = __webpack_require__("626a");
            var $assign = Object.assign;
            module2.exports = !$assign || __webpack_require__("79e5")(function() {
              var A = {};
              var B = {};
              var S = Symbol();
              var K = "abcdefghijklmnopqrst";
              A[S] = 7;
              K.split("").forEach(function(k) {
                B[k] = k;
              });
              return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join("") != K;
            }) ? function assign2(target2, source) {
              var T = toObject2(target2);
              var aLen = arguments.length;
              var index2 = 1;
              var getSymbols2 = gOPS.f;
              var isEnum = pIE.f;
              while (aLen > index2) {
                var S = IObject(arguments[index2++]);
                var keys2 = getSymbols2 ? getKeys2(S).concat(getSymbols2(S)) : getKeys2(S);
                var length = keys2.length;
                var j = 0;
                var key;
                while (length > j)
                  if (isEnum.call(S, key = keys2[j++]))
                    T[key] = S[key];
              }
              return T;
            } : $assign;
          }
        ),
        /***/
        "7726": (
          /***/
          function(module2, exports2) {
            var global2 = module2.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
            if (typeof __g == "number")
              __g = global2;
          }
        ),
        /***/
        "77f1": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var toInteger2 = __webpack_require__("4588");
            var max2 = Math.max;
            var min2 = Math.min;
            module2.exports = function(index2, length) {
              index2 = toInteger2(index2);
              return index2 < 0 ? max2(index2 + length, 0) : min2(index2, length);
            };
          }
        ),
        /***/
        "79e5": (
          /***/
          function(module2, exports2) {
            module2.exports = function(exec) {
              try {
                return !!exec();
              } catch (e) {
                return true;
              }
            };
          }
        ),
        /***/
        "7f20": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var def2 = __webpack_require__("86cc").f;
            var has2 = __webpack_require__("69a8");
            var TAG = __webpack_require__("2b4c")("toStringTag");
            module2.exports = function(it, tag, stat) {
              if (it && !has2(it = stat ? it : it.prototype, TAG))
                def2(it, TAG, { configurable: true, value: tag });
            };
          }
        ),
        /***/
        "8378": (
          /***/
          function(module2, exports2) {
            var core = module2.exports = { version: "2.6.5" };
            if (typeof __e == "number")
              __e = core;
          }
        ),
        /***/
        "84f2": (
          /***/
          function(module2, exports2) {
            module2.exports = {};
          }
        ),
        /***/
        "86cc": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var anObject = __webpack_require__("cb7c");
            var IE8_DOM_DEFINE = __webpack_require__("c69a");
            var toPrimitive = __webpack_require__("6a99");
            var dP = Object.defineProperty;
            exports2.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty2(O, P, Attributes) {
              anObject(O);
              P = toPrimitive(P, true);
              anObject(Attributes);
              if (IE8_DOM_DEFINE)
                try {
                  return dP(O, P, Attributes);
                } catch (e) {
                }
              if ("get" in Attributes || "set" in Attributes)
                throw TypeError("Accessors not supported!");
              if ("value" in Attributes)
                O[P] = Attributes.value;
              return O;
            };
          }
        ),
        /***/
        "9b43": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var aFunction = __webpack_require__("d8e8");
            module2.exports = function(fn, that, length) {
              aFunction(fn);
              if (that === void 0)
                return fn;
              switch (length) {
                case 1:
                  return function(a) {
                    return fn.call(that, a);
                  };
                case 2:
                  return function(a, b) {
                    return fn.call(that, a, b);
                  };
                case 3:
                  return function(a, b, c) {
                    return fn.call(that, a, b, c);
                  };
              }
              return function() {
                return fn.apply(that, arguments);
              };
            };
          }
        ),
        /***/
        "9c6c": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var UNSCOPABLES = __webpack_require__("2b4c")("unscopables");
            var ArrayProto = Array.prototype;
            if (ArrayProto[UNSCOPABLES] == void 0)
              __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
            module2.exports = function(key) {
              ArrayProto[UNSCOPABLES][key] = true;
            };
          }
        ),
        /***/
        "9def": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var toInteger2 = __webpack_require__("4588");
            var min2 = Math.min;
            module2.exports = function(it) {
              return it > 0 ? min2(toInteger2(it), 9007199254740991) : 0;
            };
          }
        ),
        /***/
        "9e1e": (
          /***/
          function(module2, exports2, __webpack_require__) {
            module2.exports = !__webpack_require__("79e5")(function() {
              return Object.defineProperty({}, "a", { get: function() {
                return 7;
              } }).a != 7;
            });
          }
        ),
        /***/
        "a352": (
          /***/
          function(module2, exports2) {
            module2.exports = __WEBPACK_EXTERNAL_MODULE_a352__;
          }
        ),
        /***/
        "a481": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var anObject = __webpack_require__("cb7c");
            var toObject2 = __webpack_require__("4bf8");
            var toLength = __webpack_require__("9def");
            var toInteger2 = __webpack_require__("4588");
            var advanceStringIndex = __webpack_require__("0390");
            var regExpExec = __webpack_require__("5f1b");
            var max2 = Math.max;
            var min2 = Math.min;
            var floor = Math.floor;
            var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
            var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
            var maybeToString = function(it) {
              return it === void 0 ? it : String(it);
            };
            __webpack_require__("214f")("replace", 2, function(defined, REPLACE, $replace, maybeCallNative) {
              return [
                // `String.prototype.replace` method
                // https://tc39.github.io/ecma262/#sec-string.prototype.replace
                function replace(searchValue, replaceValue) {
                  var O = defined(this);
                  var fn = searchValue == void 0 ? void 0 : searchValue[REPLACE];
                  return fn !== void 0 ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
                },
                // `RegExp.prototype[@@replace]` method
                // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
                function(regexp, replaceValue) {
                  var res = maybeCallNative($replace, regexp, this, replaceValue);
                  if (res.done)
                    return res.value;
                  var rx = anObject(regexp);
                  var S = String(this);
                  var functionalReplace = typeof replaceValue === "function";
                  if (!functionalReplace)
                    replaceValue = String(replaceValue);
                  var global2 = rx.global;
                  if (global2) {
                    var fullUnicode = rx.unicode;
                    rx.lastIndex = 0;
                  }
                  var results = [];
                  while (true) {
                    var result2 = regExpExec(rx, S);
                    if (result2 === null)
                      break;
                    results.push(result2);
                    if (!global2)
                      break;
                    var matchStr = String(result2[0]);
                    if (matchStr === "")
                      rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                  }
                  var accumulatedResult = "";
                  var nextSourcePosition = 0;
                  for (var i2 = 0; i2 < results.length; i2++) {
                    result2 = results[i2];
                    var matched = String(result2[0]);
                    var position = max2(min2(toInteger2(result2.index), S.length), 0);
                    var captures = [];
                    for (var j = 1; j < result2.length; j++)
                      captures.push(maybeToString(result2[j]));
                    var namedCaptures = result2.groups;
                    if (functionalReplace) {
                      var replacerArgs = [matched].concat(captures, position, S);
                      if (namedCaptures !== void 0)
                        replacerArgs.push(namedCaptures);
                      var replacement = String(replaceValue.apply(void 0, replacerArgs));
                    } else {
                      replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                    }
                    if (position >= nextSourcePosition) {
                      accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                      nextSourcePosition = position + matched.length;
                    }
                  }
                  return accumulatedResult + S.slice(nextSourcePosition);
                }
              ];
              function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
                var tailPos = position + matched.length;
                var m = captures.length;
                var symbols2 = SUBSTITUTION_SYMBOLS_NO_NAMED;
                if (namedCaptures !== void 0) {
                  namedCaptures = toObject2(namedCaptures);
                  symbols2 = SUBSTITUTION_SYMBOLS;
                }
                return $replace.call(replacement, symbols2, function(match, ch) {
                  var capture;
                  switch (ch.charAt(0)) {
                    case "$":
                      return "$";
                    case "&":
                      return matched;
                    case "`":
                      return str.slice(0, position);
                    case "'":
                      return str.slice(tailPos);
                    case "<":
                      capture = namedCaptures[ch.slice(1, -1)];
                      break;
                    default:
                      var n2 = +ch;
                      if (n2 === 0)
                        return match;
                      if (n2 > m) {
                        var f = floor(n2 / 10);
                        if (f === 0)
                          return match;
                        if (f <= m)
                          return captures[f - 1] === void 0 ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                        return match;
                      }
                      capture = captures[n2 - 1];
                  }
                  return capture === void 0 ? "" : capture;
                });
              }
            });
          }
        ),
        /***/
        "aae3": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var isObject2 = __webpack_require__("d3f4");
            var cof = __webpack_require__("2d95");
            var MATCH = __webpack_require__("2b4c")("match");
            module2.exports = function(it) {
              var isRegExp2;
              return isObject2(it) && ((isRegExp2 = it[MATCH]) !== void 0 ? !!isRegExp2 : cof(it) == "RegExp");
            };
          }
        ),
        /***/
        "ac6a": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var $iterators = __webpack_require__("cadf");
            var getKeys2 = __webpack_require__("0d58");
            var redefine = __webpack_require__("2aba");
            var global2 = __webpack_require__("7726");
            var hide = __webpack_require__("32e9");
            var Iterators = __webpack_require__("84f2");
            var wks = __webpack_require__("2b4c");
            var ITERATOR = wks("iterator");
            var TO_STRING_TAG = wks("toStringTag");
            var ArrayValues = Iterators.Array;
            var DOMIterables = {
              CSSRuleList: true,
              // TODO: Not spec compliant, should be false.
              CSSStyleDeclaration: false,
              CSSValueList: false,
              ClientRectList: false,
              DOMRectList: false,
              DOMStringList: false,
              DOMTokenList: true,
              DataTransferItemList: false,
              FileList: false,
              HTMLAllCollection: false,
              HTMLCollection: false,
              HTMLFormElement: false,
              HTMLSelectElement: false,
              MediaList: true,
              // TODO: Not spec compliant, should be false.
              MimeTypeArray: false,
              NamedNodeMap: false,
              NodeList: true,
              PaintRequestList: false,
              Plugin: false,
              PluginArray: false,
              SVGLengthList: false,
              SVGNumberList: false,
              SVGPathSegList: false,
              SVGPointList: false,
              SVGStringList: false,
              SVGTransformList: false,
              SourceBufferList: false,
              StyleSheetList: true,
              // TODO: Not spec compliant, should be false.
              TextTrackCueList: false,
              TextTrackList: false,
              TouchList: false
            };
            for (var collections = getKeys2(DOMIterables), i2 = 0; i2 < collections.length; i2++) {
              var NAME = collections[i2];
              var explicit = DOMIterables[NAME];
              var Collection = global2[NAME];
              var proto = Collection && Collection.prototype;
              var key;
              if (proto) {
                if (!proto[ITERATOR])
                  hide(proto, ITERATOR, ArrayValues);
                if (!proto[TO_STRING_TAG])
                  hide(proto, TO_STRING_TAG, NAME);
                Iterators[NAME] = ArrayValues;
                if (explicit) {
                  for (key in $iterators)
                    if (!proto[key])
                      redefine(proto, key, $iterators[key], true);
                }
              }
            }
          }
        ),
        /***/
        "b0c5": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var regexpExec = __webpack_require__("520a");
            __webpack_require__("5ca1")({
              target: "RegExp",
              proto: true,
              forced: regexpExec !== /./.exec
            }, {
              exec: regexpExec
            });
          }
        ),
        /***/
        "be13": (
          /***/
          function(module2, exports2) {
            module2.exports = function(it) {
              if (it == void 0)
                throw TypeError("Can't call method on  " + it);
              return it;
            };
          }
        ),
        /***/
        "c366": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var toIObject = __webpack_require__("6821");
            var toLength = __webpack_require__("9def");
            var toAbsoluteIndex = __webpack_require__("77f1");
            module2.exports = function(IS_INCLUDES) {
              return function($this, el, fromIndex) {
                var O = toIObject($this);
                var length = toLength(O.length);
                var index2 = toAbsoluteIndex(fromIndex, length);
                var value;
                if (IS_INCLUDES && el != el)
                  while (length > index2) {
                    value = O[index2++];
                    if (value != value)
                      return true;
                  }
                else
                  for (; length > index2; index2++)
                    if (IS_INCLUDES || index2 in O) {
                      if (O[index2] === el)
                        return IS_INCLUDES || index2 || 0;
                    }
                return !IS_INCLUDES && -1;
              };
            };
          }
        ),
        /***/
        "c649": (
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            (function(global2) {
              __webpack_require__.d(__webpack_exports__, "c", function() {
                return insertNodeAt;
              });
              __webpack_require__.d(__webpack_exports__, "a", function() {
                return camelize2;
              });
              __webpack_require__.d(__webpack_exports__, "b", function() {
                return console2;
              });
              __webpack_require__.d(__webpack_exports__, "d", function() {
                return removeNode;
              });
              __webpack_require__("a481");
              function getConsole() {
                if (typeof window !== "undefined") {
                  return window.console;
                }
                return global2.console;
              }
              var console2 = getConsole();
              function cached2(fn) {
                var cache = /* @__PURE__ */ Object.create(null);
                return function cachedFn(str) {
                  var hit = cache[str];
                  return hit || (cache[str] = fn(str));
                };
              }
              var regex = /-(\w)/g;
              var camelize2 = cached2(function(str) {
                return str.replace(regex, function(_, c) {
                  return c ? c.toUpperCase() : "";
                });
              });
              function removeNode(node2) {
                if (node2.parentElement !== null) {
                  node2.parentElement.removeChild(node2);
                }
              }
              function insertNodeAt(fatherNode, node2, position) {
                var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
                fatherNode.insertBefore(node2, refNode);
              }
            }).call(this, __webpack_require__("c8ba"));
          }
        ),
        /***/
        "c69a": (
          /***/
          function(module2, exports2, __webpack_require__) {
            module2.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function() {
              return Object.defineProperty(__webpack_require__("230e")("div"), "a", { get: function() {
                return 7;
              } }).a != 7;
            });
          }
        ),
        /***/
        "c8ba": (
          /***/
          function(module2, exports2) {
            var g;
            g = function() {
              return this;
            }();
            try {
              g = g || new Function("return this")();
            } catch (e) {
              if (typeof window === "object")
                g = window;
            }
            module2.exports = g;
          }
        ),
        /***/
        "ca5a": (
          /***/
          function(module2, exports2) {
            var id = 0;
            var px = Math.random();
            module2.exports = function(key) {
              return "Symbol(".concat(key === void 0 ? "" : key, ")_", (++id + px).toString(36));
            };
          }
        ),
        /***/
        "cadf": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var addToUnscopables = __webpack_require__("9c6c");
            var step = __webpack_require__("d53b");
            var Iterators = __webpack_require__("84f2");
            var toIObject = __webpack_require__("6821");
            module2.exports = __webpack_require__("01f9")(Array, "Array", function(iterated, kind) {
              this._t = toIObject(iterated);
              this._i = 0;
              this._k = kind;
            }, function() {
              var O = this._t;
              var kind = this._k;
              var index2 = this._i++;
              if (!O || index2 >= O.length) {
                this._t = void 0;
                return step(1);
              }
              if (kind == "keys")
                return step(0, index2);
              if (kind == "values")
                return step(0, O[index2]);
              return step(0, [index2, O[index2]]);
            }, "values");
            Iterators.Arguments = Iterators.Array;
            addToUnscopables("keys");
            addToUnscopables("values");
            addToUnscopables("entries");
          }
        ),
        /***/
        "cb7c": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var isObject2 = __webpack_require__("d3f4");
            module2.exports = function(it) {
              if (!isObject2(it))
                throw TypeError(it + " is not an object!");
              return it;
            };
          }
        ),
        /***/
        "ce10": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var has2 = __webpack_require__("69a8");
            var toIObject = __webpack_require__("6821");
            var arrayIndexOf = __webpack_require__("c366")(false);
            var IE_PROTO = __webpack_require__("613b")("IE_PROTO");
            module2.exports = function(object, names) {
              var O = toIObject(object);
              var i2 = 0;
              var result2 = [];
              var key;
              for (key in O)
                if (key != IE_PROTO)
                  has2(O, key) && result2.push(key);
              while (names.length > i2)
                if (has2(O, key = names[i2++])) {
                  ~arrayIndexOf(result2, key) || result2.push(key);
                }
              return result2;
            };
          }
        ),
        /***/
        "d2c8": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var isRegExp2 = __webpack_require__("aae3");
            var defined = __webpack_require__("be13");
            module2.exports = function(that, searchString, NAME) {
              if (isRegExp2(searchString))
                throw TypeError("String#" + NAME + " doesn't accept regex!");
              return String(defined(that));
            };
          }
        ),
        /***/
        "d3f4": (
          /***/
          function(module2, exports2) {
            module2.exports = function(it) {
              return typeof it === "object" ? it !== null : typeof it === "function";
            };
          }
        ),
        /***/
        "d53b": (
          /***/
          function(module2, exports2) {
            module2.exports = function(done, value) {
              return { value, done: !!done };
            };
          }
        ),
        /***/
        "d8e8": (
          /***/
          function(module2, exports2) {
            module2.exports = function(it) {
              if (typeof it != "function")
                throw TypeError(it + " is not a function!");
              return it;
            };
          }
        ),
        /***/
        "e11e": (
          /***/
          function(module2, exports2) {
            module2.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
          }
        ),
        /***/
        "f559": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var $export = __webpack_require__("5ca1");
            var toLength = __webpack_require__("9def");
            var context = __webpack_require__("d2c8");
            var STARTS_WITH = "startsWith";
            var $startsWith = ""[STARTS_WITH];
            $export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), "String", {
              startsWith: function startsWith(searchString) {
                var that = context(this, searchString, STARTS_WITH);
                var index2 = toLength(Math.min(arguments.length > 1 ? arguments[1] : void 0, that.length));
                var search = String(searchString);
                return $startsWith ? $startsWith.call(that, search, index2) : that.slice(index2, index2 + search.length) === search;
              }
            });
          }
        ),
        /***/
        "f6fd": (
          /***/
          function(module2, exports2) {
            (function(document2) {
              var currentScript = "currentScript", scripts2 = document2.getElementsByTagName("script");
              if (!(currentScript in document2)) {
                Object.defineProperty(document2, currentScript, {
                  get: function() {
                    try {
                      throw new Error();
                    } catch (err2) {
                      var i2, res = (/.*at [^\(]*\((.*):.+:.+\)$/ig.exec(err2.stack) || [false])[1];
                      for (i2 in scripts2) {
                        if (scripts2[i2].src == res || scripts2[i2].readyState == "interactive") {
                          return scripts2[i2];
                        }
                      }
                      return null;
                    }
                  }
                });
              }
            })(document);
          }
        ),
        /***/
        "f751": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var $export = __webpack_require__("5ca1");
            $export($export.S + $export.F, "Object", { assign: __webpack_require__("7333") });
          }
        ),
        /***/
        "fa5b": (
          /***/
          function(module2, exports2, __webpack_require__) {
            module2.exports = __webpack_require__("5537")("native-function-to-string", Function.toString);
          }
        ),
        /***/
        "fab2": (
          /***/
          function(module2, exports2, __webpack_require__) {
            var document2 = __webpack_require__("7726").document;
            module2.exports = document2 && document2.documentElement;
          }
        ),
        /***/
        "fb15": (
          /***/
          function(module2, __webpack_exports__, __webpack_require__) {
            __webpack_require__.r(__webpack_exports__);
            if (typeof window !== "undefined") {
              {
                __webpack_require__("f6fd");
              }
              var setPublicPath_i;
              if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
                __webpack_require__.p = setPublicPath_i[1];
              }
            }
            __webpack_require__("f751");
            __webpack_require__("f559");
            __webpack_require__("ac6a");
            __webpack_require__("cadf");
            __webpack_require__("456d");
            function _arrayWithHoles(arr) {
              if (Array.isArray(arr))
                return arr;
            }
            function _iterableToArrayLimit(arr, i2) {
              if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr)))
                return;
              var _arr = [];
              var _n2 = true;
              var _d2 = false;
              var _e = void 0;
              try {
                for (var _i2 = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i2.next()).done); _n2 = true) {
                  _arr.push(_s.value);
                  if (i2 && _arr.length === i2)
                    break;
                }
              } catch (err2) {
                _d2 = true;
                _e = err2;
              } finally {
                try {
                  if (!_n2 && _i2["return"] != null)
                    _i2["return"]();
                } finally {
                  if (_d2)
                    throw _e;
                }
              }
              return _arr;
            }
            function _arrayLikeToArray(arr, len) {
              if (len == null || len > arr.length)
                len = arr.length;
              for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
                arr2[i2] = arr[i2];
              }
              return arr2;
            }
            function _unsupportedIterableToArray(o, minLen) {
              if (!o)
                return;
              if (typeof o === "string")
                return _arrayLikeToArray(o, minLen);
              var n2 = Object.prototype.toString.call(o).slice(8, -1);
              if (n2 === "Object" && o.constructor)
                n2 = o.constructor.name;
              if (n2 === "Map" || n2 === "Set")
                return Array.from(o);
              if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
                return _arrayLikeToArray(o, minLen);
            }
            function _nonIterableRest() {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _slicedToArray(arr, i2) {
              return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
            }
            __webpack_require__("6762");
            __webpack_require__("2fdb");
            function _arrayWithoutHoles2(arr) {
              if (Array.isArray(arr))
                return _arrayLikeToArray(arr);
            }
            function _iterableToArray2(iter) {
              if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter))
                return Array.from(iter);
            }
            function _nonIterableSpread2() {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _toConsumableArray2(arr) {
              return _arrayWithoutHoles2(arr) || _iterableToArray2(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread2();
            }
            var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
            var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /* @__PURE__ */ __webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);
            var helper2 = __webpack_require__("c649");
            function buildAttribute(object, propName, value) {
              if (value === void 0) {
                return object;
              }
              object = object || {};
              object[propName] = value;
              return object;
            }
            function computeVmIndex(vnodes, element) {
              return vnodes.map(function(elt) {
                return elt.elm;
              }).indexOf(element);
            }
            function _computeIndexes(slots, children, isTransition, footerOffset) {
              if (!slots) {
                return [];
              }
              var elmFromNodes = slots.map(function(elt) {
                return elt.elm;
              });
              var footerIndex = children.length - footerOffset;
              var rawIndexes = _toConsumableArray2(children).map(function(elt, idx) {
                return idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt);
              });
              return isTransition ? rawIndexes.filter(function(ind) {
                return ind !== -1;
              }) : rawIndexes;
            }
            function emit(evtName, evtData) {
              var _this2 = this;
              this.$nextTick(function() {
                return _this2.$emit(evtName.toLowerCase(), evtData);
              });
            }
            function delegateAndEmit(evtName) {
              var _this2 = this;
              return function(evtData) {
                if (_this2.realList !== null) {
                  _this2["onDrag" + evtName](evtData);
                }
                emit.call(_this2, evtName, evtData);
              };
            }
            function isTransitionName(name) {
              return ["transition-group", "TransitionGroup"].includes(name);
            }
            function vuedraggable_isTransition(slots) {
              if (!slots || slots.length !== 1) {
                return false;
              }
              var _slots = _slicedToArray(slots, 1), componentOptions = _slots[0].componentOptions;
              if (!componentOptions) {
                return false;
              }
              return isTransitionName(componentOptions.tag);
            }
            function getSlot(slot, scopedSlot, key) {
              return slot[key] || (scopedSlot[key] ? scopedSlot[key]() : void 0);
            }
            function computeChildrenAndOffsets(children, slot, scopedSlot) {
              var headerOffset = 0;
              var footerOffset = 0;
              var header = getSlot(slot, scopedSlot, "header");
              if (header) {
                headerOffset = header.length;
                children = children ? [].concat(_toConsumableArray2(header), _toConsumableArray2(children)) : _toConsumableArray2(header);
              }
              var footer = getSlot(slot, scopedSlot, "footer");
              if (footer) {
                footerOffset = footer.length;
                children = children ? [].concat(_toConsumableArray2(children), _toConsumableArray2(footer)) : _toConsumableArray2(footer);
              }
              return {
                children,
                headerOffset,
                footerOffset
              };
            }
            function getComponentAttributes($attrs, componentData) {
              var attributes2 = null;
              var update5 = function update6(name, value) {
                attributes2 = buildAttribute(attributes2, name, value);
              };
              var attrs2 = Object.keys($attrs).filter(function(key) {
                return key === "id" || key.startsWith("data-");
              }).reduce(function(res, key) {
                res[key] = $attrs[key];
                return res;
              }, {});
              update5("attrs", attrs2);
              if (!componentData) {
                return attributes2;
              }
              var on2 = componentData.on, props3 = componentData.props, componentDataAttrs = componentData.attrs;
              update5("on", on2);
              update5("props", props3);
              Object.assign(attributes2.attrs, componentDataAttrs);
              return attributes2;
            }
            var eventsListened = ["Start", "Add", "Remove", "Update", "End"];
            var eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
            var readonlyProperties = ["Move"].concat(eventsListened, eventsToEmit).map(function(evt) {
              return "on" + evt;
            });
            var draggingElement = null;
            var props2 = {
              options: Object,
              list: {
                type: Array,
                required: false,
                default: null
              },
              value: {
                type: Array,
                required: false,
                default: null
              },
              noTransitionOnDrag: {
                type: Boolean,
                default: false
              },
              clone: {
                type: Function,
                default: function _default(original) {
                  return original;
                }
              },
              element: {
                type: String,
                default: "div"
              },
              tag: {
                type: String,
                default: null
              },
              move: {
                type: Function,
                default: null
              },
              componentData: {
                type: Object,
                required: false,
                default: null
              }
            };
            var draggableComponent = {
              name: "draggable",
              inheritAttrs: false,
              props: props2,
              data: function data() {
                return {
                  transitionMode: false,
                  noneFunctionalComponentMode: false
                };
              },
              render: function render8(h) {
                var slots = this.$slots.default;
                this.transitionMode = vuedraggable_isTransition(slots);
                var _computeChildrenAndOf = computeChildrenAndOffsets(slots, this.$slots, this.$scopedSlots), children = _computeChildrenAndOf.children, headerOffset = _computeChildrenAndOf.headerOffset, footerOffset = _computeChildrenAndOf.footerOffset;
                this.headerOffset = headerOffset;
                this.footerOffset = footerOffset;
                var attributes2 = getComponentAttributes(this.$attrs, this.componentData);
                return h(this.getTag(), attributes2, children);
              },
              created: function created2() {
                if (this.list !== null && this.value !== null) {
                  helper2[
                    "b"
                    /* console */
                  ].error("Value and list props are mutually exclusive! Please set one or another.");
                }
                if (this.element !== "div") {
                  helper2[
                    "b"
                    /* console */
                  ].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
                }
                if (this.options !== void 0) {
                  helper2[
                    "b"
                    /* console */
                  ].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
                }
              },
              mounted: function mounted3() {
                var _this3 = this;
                this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();
                if (this.noneFunctionalComponentMode && this.transitionMode) {
                  throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
                }
                var optionsAdded = {};
                eventsListened.forEach(function(elt) {
                  optionsAdded["on" + elt] = delegateAndEmit.call(_this3, elt);
                });
                eventsToEmit.forEach(function(elt) {
                  optionsAdded["on" + elt] = emit.bind(_this3, elt);
                });
                var attributes2 = Object.keys(this.$attrs).reduce(function(res, key) {
                  res[Object(helper2[
                    "a"
                    /* camelize */
                  ])(key)] = _this3.$attrs[key];
                  return res;
                }, {});
                var options = Object.assign({}, this.options, attributes2, optionsAdded, {
                  onMove: function onMove(evt, originalEvent) {
                    return _this3.onDragMove(evt, originalEvent);
                  }
                });
                !("draggable" in options) && (options.draggable = ">*");
                this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(this.rootContainer, options);
                this.computeIndexes();
              },
              beforeDestroy: function beforeDestroy2() {
                if (this._sortable !== void 0)
                  this._sortable.destroy();
              },
              computed: {
                rootContainer: function rootContainer() {
                  return this.transitionMode ? this.$el.children[0] : this.$el;
                },
                realList: function realList() {
                  return this.list ? this.list : this.value;
                }
              },
              watch: {
                options: {
                  handler: function handler(newOptionValue) {
                    this.updateOptions(newOptionValue);
                  },
                  deep: true
                },
                $attrs: {
                  handler: function handler(newOptionValue) {
                    this.updateOptions(newOptionValue);
                  },
                  deep: true
                },
                realList: function realList() {
                  this.computeIndexes();
                }
              },
              methods: {
                getIsFunctional: function getIsFunctional() {
                  var fnOptions = this._vnode.fnOptions;
                  return fnOptions && fnOptions.functional;
                },
                getTag: function getTag2() {
                  return this.tag || this.element;
                },
                updateOptions: function updateOptions(newOptionValue) {
                  for (var property2 in newOptionValue) {
                    var value = Object(helper2[
                      "a"
                      /* camelize */
                    ])(property2);
                    if (readonlyProperties.indexOf(value) === -1) {
                      this._sortable.option(value, newOptionValue[property2]);
                    }
                  }
                },
                getChildrenNodes: function getChildrenNodes() {
                  if (this.noneFunctionalComponentMode) {
                    return this.$children[0].$slots.default;
                  }
                  var rawNodes = this.$slots.default;
                  return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
                },
                computeIndexes: function computeIndexes() {
                  var _this4 = this;
                  this.$nextTick(function() {
                    _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode, _this4.footerOffset);
                  });
                },
                getUnderlyingVm: function getUnderlyingVm(htmlElt) {
                  var index2 = computeVmIndex(this.getChildrenNodes() || [], htmlElt);
                  if (index2 === -1) {
                    return null;
                  }
                  var element = this.realList[index2];
                  return {
                    index: index2,
                    element
                  };
                },
                getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
                  var vue = _ref.__vue__;
                  if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
                    if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0])
                      return vue.$children[0];
                    return vue;
                  }
                  return vue.$parent;
                },
                emitChanges: function emitChanges(evt) {
                  var _this5 = this;
                  this.$nextTick(function() {
                    _this5.$emit("change", evt);
                  });
                },
                alterList: function alterList(onList) {
                  if (this.list) {
                    onList(this.list);
                    return;
                  }
                  var newList = _toConsumableArray2(this.value);
                  onList(newList);
                  this.$emit("input", newList);
                },
                spliceList: function spliceList() {
                  var _arguments = arguments;
                  var spliceList2 = function spliceList3(list2) {
                    return list2.splice.apply(list2, _toConsumableArray2(_arguments));
                  };
                  this.alterList(spliceList2);
                },
                updatePosition: function updatePosition(oldIndex2, newIndex2) {
                  var updatePosition2 = function updatePosition3(list2) {
                    return list2.splice(newIndex2, 0, list2.splice(oldIndex2, 1)[0]);
                  };
                  this.alterList(updatePosition2);
                },
                getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
                  var to = _ref2.to, related = _ref2.related;
                  var component = this.getUnderlyingPotencialDraggableComponent(to);
                  if (!component) {
                    return {
                      component
                    };
                  }
                  var list2 = component.realList;
                  var context = {
                    list: list2,
                    component
                  };
                  if (to !== related && list2 && component.getUnderlyingVm) {
                    var destination = component.getUnderlyingVm(related);
                    if (destination) {
                      return Object.assign(destination, context);
                    }
                  }
                  return context;
                },
                getVmIndex: function getVmIndex(domIndex) {
                  var indexes = this.visibleIndexes;
                  var numberIndexes = indexes.length;
                  return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
                },
                getComponent: function getComponent() {
                  return this.$slots.default[0].componentInstance;
                },
                resetTransitionData: function resetTransitionData(index2) {
                  if (!this.noTransitionOnDrag || !this.transitionMode) {
                    return;
                  }
                  var nodes = this.getChildrenNodes();
                  nodes[index2].data = null;
                  var transitionContainer = this.getComponent();
                  transitionContainer.children = [];
                  transitionContainer.kept = void 0;
                },
                onDragStart: function onDragStart(evt) {
                  this.context = this.getUnderlyingVm(evt.item);
                  evt.item._underlying_vm_ = this.clone(this.context.element);
                  draggingElement = evt.item;
                },
                onDragAdd: function onDragAdd(evt) {
                  var element = evt.item._underlying_vm_;
                  if (element === void 0) {
                    return;
                  }
                  Object(helper2[
                    "d"
                    /* removeNode */
                  ])(evt.item);
                  var newIndex2 = this.getVmIndex(evt.newIndex);
                  this.spliceList(newIndex2, 0, element);
                  this.computeIndexes();
                  var added = {
                    element,
                    newIndex: newIndex2
                  };
                  this.emitChanges({
                    added
                  });
                },
                onDragRemove: function onDragRemove(evt) {
                  Object(helper2[
                    "c"
                    /* insertNodeAt */
                  ])(this.rootContainer, evt.item, evt.oldIndex);
                  if (evt.pullMode === "clone") {
                    Object(helper2[
                      "d"
                      /* removeNode */
                    ])(evt.clone);
                    return;
                  }
                  var oldIndex2 = this.context.index;
                  this.spliceList(oldIndex2, 1);
                  var removed = {
                    element: this.context.element,
                    oldIndex: oldIndex2
                  };
                  this.resetTransitionData(oldIndex2);
                  this.emitChanges({
                    removed
                  });
                },
                onDragUpdate: function onDragUpdate(evt) {
                  Object(helper2[
                    "d"
                    /* removeNode */
                  ])(evt.item);
                  Object(helper2[
                    "c"
                    /* insertNodeAt */
                  ])(evt.from, evt.item, evt.oldIndex);
                  var oldIndex2 = this.context.index;
                  var newIndex2 = this.getVmIndex(evt.newIndex);
                  this.updatePosition(oldIndex2, newIndex2);
                  var moved2 = {
                    element: this.context.element,
                    oldIndex: oldIndex2,
                    newIndex: newIndex2
                  };
                  this.emitChanges({
                    moved: moved2
                  });
                },
                updateProperty: function updateProperty(evt, propertyName) {
                  evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
                },
                computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
                  if (!relatedContext.element) {
                    return 0;
                  }
                  var domChildren = _toConsumableArray2(evt.to.children).filter(function(el) {
                    return el.style["display"] !== "none";
                  });
                  var currentDOMIndex = domChildren.indexOf(evt.related);
                  var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
                  var draggedInList = domChildren.indexOf(draggingElement) !== -1;
                  return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
                },
                onDragMove: function onDragMove(evt, originalEvent) {
                  var onMove = this.move;
                  if (!onMove || !this.realList) {
                    return true;
                  }
                  var relatedContext = this.getRelatedContextFromMoveEvent(evt);
                  var draggedContext = this.context;
                  var futureIndex = this.computeFutureIndex(relatedContext, evt);
                  Object.assign(draggedContext, {
                    futureIndex
                  });
                  var sendEvt = Object.assign({}, evt, {
                    relatedContext,
                    draggedContext
                  });
                  return onMove(sendEvt, originalEvent);
                },
                onDragEnd: function onDragEnd() {
                  this.computeIndexes();
                  draggingElement = null;
                }
              }
            };
            if (typeof window !== "undefined" && "Vue" in window) {
              window.Vue.component("draggable", draggableComponent);
            }
            var vuedraggable = draggableComponent;
            __webpack_exports__["default"] = vuedraggable;
          }
        )
        /******/
      })["default"]
    );
  });
})(vuedraggable_umd);
var vuedraggable_umdExports = vuedraggable_umd.exports;
const draggable = /* @__PURE__ */ getDefaultExportFromCjs(vuedraggable_umdExports);
var render$i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("v-dialog", {
    attrs: {
      "content-class": "mattertag-group-modal dpm-modal",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: _vm.dpmStore.mattertagEditor.groupDialogVisible,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.mattertagEditor, "groupDialogVisible", $$v);
      },
      expression: "dpmStore.mattertagEditor.groupDialogVisible"
    }
  }, [_c("v-card", [_c("v-card-title", [_vm._v("タググループ")]), _c("v-divider"), _c("v-card-text", {
    staticClass: "p-3",
    staticStyle: {
      "height": "900px"
    }
  }, [_c("div", {
    staticClass: "mb-6"
  }, [_c("v-chip-group", {
    attrs: {
      "active-class": "primary--text",
      "column": "",
      "multiple": ""
    },
    on: {
      "change": _vm.changeGroup
    },
    model: {
      value: _vm.filteredGroups,
      callback: function($$v) {
        _vm.filteredGroups = $$v;
      },
      expression: "filteredGroups"
    }
  }, [_c("v-chip", {
    attrs: {
      "filter": "",
      "filter-icon": _vm.$global.icons.mdiEye,
      "color": "black",
      "text-color": "black",
      "outlined": ""
    }
  }, [_vm._v("ALL")]), _c("draggable", {
    attrs: {
      "list": _vm.dpmStore.SED.mattertag_groups,
      "group": "groups-chip"
    },
    on: {
      "start": function($event) {
        _vm.dragging = true;
      },
      "end": function($event) {
        _vm.dragging = false;
      }
    }
  }, _vm._l(_vm.dpmStore.SED.mattertag_groups, function(group, i2) {
    return _c("v-chip", {
      key: i2,
      attrs: {
        "filter": "",
        "filter-icon": _vm.$global.icons.mdiEye,
        "close": !group.uneditable,
        "close-icon": _vm.$global.icons.mdiPencil,
        "color": group.colorless ? "black" : _vm.$global.utils.toHex(group.color),
        "text-color": group.colorless ? "black" : "white",
        "outlined": group.colorless
      },
      on: {
        "click:close": function($event) {
          return _vm.editGroup(i2);
        }
      }
    }, [_vm._v(_vm._s(group.label))]);
  }), 1)], 1), _c("v-btn", {
    staticClass: "d-inline-flex",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.newGroup
    }
  }, [_c("v-icon", [_vm._v(" " + _vm._s(_vm.$global.icons.mdiPlus))]), _vm._v("グループ作成")], 1), _c("v-tooltip", {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref) {
        var on2 = _ref.on;
        return [_c("v-icon", _vm._g({
          staticClass: "float-right"
        }, on2), [_vm._v(_vm._s(_vm.$global.icons.mdiHelpCircle))])];
      }
    }])
  }, [_c("span", {
    staticClass: "d-block"
  }, [_vm._v("グループをクリックでフィルタリングが出来ます。（※ungroupedのラベル名は閲覧時には表示されません。）")]), _c("span", {
    staticClass: "d-block"
  }, [_vm._v("上に表示されているグループは左右に、下に表示されているグループは上下にドラッグすることで表示順を変更することが出来ます。")]), _c("span", {
    staticClass: "d-block"
  }, [_vm._v("グループ内のアイテムを上下にドラッグすることでグループ内での表示順を変更出来ます。")]), _c("span", {
    staticClass: "d-block"
  }, [_vm._v("目のアイコンをクリックすることでアイテムの表示・非表示を切り替えられます。")])])], 1), _c("v-divider", {
    staticClass: "mb-5"
  }), _c("v-expansion-panels", {
    attrs: {
      "multiple": ""
    }
  }, [_c("draggable", {
    attrs: {
      "list": _vm.dpmStore.SED.mattertag_groups,
      "group": "groups"
    },
    on: {
      "start": function($event) {
        _vm.dragging = true;
      },
      "end": function($event) {
        _vm.dragging = false;
      }
    }
  }, _vm._l(_vm.dpmStore.SED.mattertag_groups, function(group, i2) {
    return _c("v-expansion-panel", {
      key: `panel-${group.label}-${i2}`
    }, [_vm.filteredGroups.includes(i2 + 1) || _vm.filteredGroups.includes(0) ? [_c("v-expansion-panel-header", [_c("span", {
      staticClass: "group-select-container"
    }, [_c("v-select", {
      attrs: {
        "items": _vm.selectableNum(_vm.dpmStore.SED.mattertag_groups.length),
        "value": i2 + 1
      },
      on: {
        "change": function($event) {
          return _vm.changePosition(_vm.dpmStore.SED.mattertag_groups, i2, $event);
        }
      }
    })], 1), _c("v-chip", {
      staticClass: "ms-6",
      attrs: {
        "color": group.colorless ? "black" : _vm.$global.utils.toHex(group.color),
        "text-color": group.colorless ? "black" : "white",
        "outlined": group.colorless
      }
    }, [_vm._v(_vm._s(group.label))]), group.useCustomColor ? _c("span", {
      staticClass: "ms-1"
    }, [_vm._v("カスタムカラーを優先")]) : _vm._e(), _c("v-badge", {
      attrs: {
        "color": "primary",
        "content": `タグ数: ${group.mattertags.length}`,
        "inline": ""
      }
    })], 1), _c("v-expansion-panel-content", [_c("v-list", {
      key: `${group.label}-${i2}`,
      staticClass: "mb-3 p-0",
      attrs: {
        "dense": "",
        "outlined": ""
      }
    }, [_c("draggable", {
      attrs: {
        "list": group.mattertags,
        "group": `group_${i2}`
      },
      on: {
        "start": function($event) {
          _vm.dragging = true;
        },
        "end": function($event) {
          _vm.dragging = false;
        }
      }
    }, _vm._l(group.mattertags, function(mattertag, j) {
      return _c("v-list-item", {
        key: mattertag.sid,
        class: {
          "border-bottom": j < group.mattertags.length - 1
        },
        staticStyle: {
          "cursor": "ns-resize"
        }
      }, [_c("v-list-item-icon", [_c("span", {
        staticClass: "tag-select-container"
      }, [_c("v-select", {
        attrs: {
          "items": _vm.selectableNum(group.mattertags.length),
          "value": j + 1
        },
        on: {
          "change": function($event) {
            return _vm.changePosition(group.mattertags, j, $event);
          }
        }
      })], 1)]), _c("v-list-item-content", [_c("v-list-item-title", [_vm._v(_vm._s(_vm.dpmStore.getLabel(mattertag.sid)))])], 1), _c("v-list-item-action", [_c("v-btn", {
        attrs: {
          "fab": "",
          "small": "",
          "elevation": "0"
        },
        on: {
          "click": function($event) {
            mattertag.visible = !mattertag.visible;
          }
        }
      }, [mattertag.visible ? _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiEye))]) : _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiEyeOff))])], 1)], 1)], 1);
    }), 1)], 1)], 1)] : _vm._e()], 2);
  }), 1)], 1)], 1), _c("v-divider"), _c("v-card-actions", [_c("v-btn", {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm.progress ? _c("v-progress-circular", {
    attrs: {
      "indeterminate": "",
      "color": "red"
    }
  }) : _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiContentSave))]), _vm._v("保存して編集を続ける")], 1), _c("v-btn", {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.apply
    }
  }, [_c("v-icon", [_vm._v(" " + _vm._s(_vm.$global.icons.mdiClose))]), _vm._v("閉じる")], 1)], 1), _vm.saveErrorText ? _c("p", {
    staticClass: "mx-3 mb-3 text-danger mb-0"
  }, [_vm._v(_vm._s(_vm.saveErrorText))]) : _vm._e()], 1), _c("v-dialog", {
    attrs: {
      "content-class": "mattertag-group-edit-modal dpm-modal",
      "width": "800px",
      "persistent": "",
      "scrollable": "",
      "retain-focus": false
    },
    model: {
      value: _vm.groupEditDialog,
      callback: function($$v) {
        _vm.groupEditDialog = $$v;
      },
      expression: "groupEditDialog"
    }
  }, [_vm.groupEditDialog ? _c("v-card", [_c("v-card-title", [_vm._v(_vm._s(_vm.dialogType === "edit" ? "グループ編集" : "グループ作成"))]), _c("v-card-text", {
    staticClass: "p-3"
  }, [_c("div", [_c("v-text-field", {
    staticClass: "mb-3 mt-0",
    attrs: {
      "label": "グループ名",
      "hide-details": ""
    },
    model: {
      value: _vm.dpmStore.currentEditGroup.label,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditGroup, "label", $$v);
      },
      expression: "dpmStore.currentEditGroup.label"
    }
  }), _vm.errorText ? _c("p", {
    staticClass: "text-danger mb-0"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()], 1), _c("v-tabs", {
    attrs: {
      "background-color": "transparent",
      "grow": ""
    },
    model: {
      value: _vm.currentTab,
      callback: function($$v) {
        _vm.currentTab = $$v;
      },
      expression: "currentTab"
    }
  }, [_c("v-tab", [_vm._v("タグ選択")]), _c("v-tab", [_vm._v("アイコン設定")])], 1), _c("v-tabs-items", {
    model: {
      value: _vm.currentTab,
      callback: function($$v) {
        _vm.currentTab = $$v;
      },
      expression: "currentTab"
    }
  }, [_c("v-tab-item", [_c("v-text-field", {
    staticClass: "pt-2 px-3 pb-3",
    attrs: {
      "prepend-inner-icon": _vm.$global.icons.mdiMagnify,
      "label": "ラベル検索",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: _vm.search,
      callback: function($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c("v-data-table", {
    attrs: {
      "headers": _vm.dataTableHeaders,
      "items": _vm.allMattertags,
      "item-key": "sid",
      "search": _vm.search,
      "custom-filter": _vm.searchLabel,
      "show-select": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "item.title",
      fn: function(_ref2) {
        var item = _ref2.item;
        return [_vm._v(_vm._s(_vm.dpmStore.getLabel(item.sid)))];
      }
    }, {
      key: "item.floor",
      fn: function(_ref3) {
        var _vm$dpmStore$getFloor;
        var item = _ref3.item;
        return [_vm._v(_vm._s((_vm$dpmStore$getFloor = _vm.dpmStore.getFloorByMattertag(_vm.dpmStore.getMattertagBySid(item.sid))) !== null && _vm$dpmStore$getFloor !== void 0 && _vm$dpmStore$getFloor.name ? _vm.dpmStore.getFloorByMattertag(_vm.dpmStore.getMattertagBySid(item.sid)).name : "未設定"))];
      }
    }, {
      key: "item.group",
      fn: function(_ref4) {
        var item = _ref4.item;
        return [_vm._v(_vm._s(_vm.groupLabel(item.sid)))];
      }
    }], null, false, 2133083189),
    model: {
      value: _vm.editingSelectedMattertags,
      callback: function($$v) {
        _vm.editingSelectedMattertags = $$v;
      },
      expression: "editingSelectedMattertags"
    }
  })], 1), _c("v-tab-item", [_c("v-row", {
    staticClass: "my-2"
  }, [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("v-checkbox", {
    staticClass: "mt-0",
    attrs: {
      "label": "グループ設定を最優先",
      "hide-details": ""
    },
    on: {
      "change": _vm.togglePriority
    },
    model: {
      value: _vm.dpmStore.currentEditGroup.topPriority,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditGroup, "topPriority", $$v);
      },
      expression: "dpmStore.currentEditGroup.topPriority"
    }
  }), _c("small", {
    staticClass: "text-muted"
  }, [_vm._v("※このチェックがオフで、個別にカスタムアイコン/プリセットアイコンを設定している場合はそちらを優先します。")]), _c("v-checkbox", {
    staticClass: "mt-0",
    attrs: {
      "label": "グループカラーを設定しない",
      "hide-details": "",
      "disabled": _vm.dpmStore.currentEditGroup.topPriority
    },
    model: {
      value: _vm.dpmStore.currentEditGroup.colorless,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditGroup, "colorless", $$v);
      },
      expression: "dpmStore.currentEditGroup.colorless"
    }
  }), _c("v-checkbox", {
    staticClass: "mt-0",
    attrs: {
      "label": "グループタグがデフォルト時、個別のカスタムカラーを優先する",
      "hide-details": "",
      "disabled": _vm.dpmStore.currentEditGroup.topPriority
    },
    model: {
      value: _vm.dpmStore.currentEditGroup.useCustomColor,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditGroup, "useCustomColor", $$v);
      },
      expression: "dpmStore.currentEditGroup.useCustomColor"
    }
  })], 1)], 1), _c("IconEditView")], 1)], 1)], 1), _c("v-divider"), _c("v-card-actions", {
    staticClass: "justify-content-end"
  }, [_vm.dialogType === "edit" ? _c("v-btn", {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.deleteGroup
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v("削除")], 1) : _vm._e(), _vm.dialogType === "new" ? _c("v-btn", {
    attrs: {
      "color": "warning"
    },
    on: {
      "click": _vm.cancelGroup
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiCancel))]), _vm._v("キャンセル")], 1) : _vm._e(), _c("v-btn", {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveGroup
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.dialogType === "edit" ? _vm.$global.icons.mdiClose : _vm.$global.icons.mdiCheck))]), _vm._v(_vm._s(_vm.dialogType === "edit" ? "閉じる" : "作成"))], 1)], 1), _vm.dialogType === "edit" ? _c("small", {
    staticClass: "mx-3 mb-3 text-muted"
  }, [_vm._v("※タグがグループに含まれている状態でグループを削除した場合はungroupedになります。")]) : _vm._e()], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns$i = [];
const __vue2_script$i = {
  props: [],
  data() {
    return initialState();
  },
  components: {
    draggable,
    IconEditView
  },
  computed: __spreadProps(__spreadValues({}, mapStores(useDpmStore)), {
    allMattertags() {
      const tags1 = Object.keys(this.dpmStore.global.mattertags).map((key) => {
        return { sid: key, visible: true };
      });
      const tags2 = this.dpmStore.SED.mattertags.map((mattertag) => {
        return { sid: mattertag.sid, visible: true };
      });
      const merged = [...tags1, ...tags2].reduce((acc, item) => {
        acc[item.sid] = __spreadValues(__spreadValues({}, acc[item.sid]), item);
        return acc;
      }, {});
      return Object.values(merged);
    },
    groupLabel: function() {
      return function(sid) {
        const groups = this.dpmStore.SED.mattertag_groups.filter((group) => group.mattertags.find((mattertag) => mattertag.sid === sid));
        return groups.map((group) => group.label).join(",");
      };
    },
    groupedMattertagSids() {
      const mattertagSids = [];
      this.dpmStore.SED.mattertag_groups.forEach((group) => {
        if (group !== this.dpmStore.getUngroupedGroup) {
          group.mattertags.forEach((mattertags) => mattertagSids.push(mattertags.sid));
        }
      });
      return mattertagSids;
    },
    selectableNum: function() {
      return function(length) {
        return [...Array(length).keys()].map((i2) => i2 + 1);
      };
    }
  }),
  created() {
    this.filteredGroups = [0];
  },
  methods: {
    addToUngrouped(removedMattertags) {
      const ungroupdMatertags = removedMattertags.filter((removedMattertag) => !this.groupedMattertagSids.find((sid) => sid === removedMattertag.sid));
      this.dpmStore.getUngroupedGroup.mattertags = this.dpmStore.getUngroupedGroup.mattertags.concat(ungroupdMatertags);
    },
    apply() {
      this.dpmStore.$patch({ mattertagEditor: { groupDialogVisible: false, tagChanged: true } });
    },
    cancelGroup() {
      this.dpmStore.SED.mattertag_groups.pop();
      this.closeGroupEditDialog();
    },
    changeGroup() {
      if (this.filteredGroups.length > 1) {
        if (this.filteredGroups[this.filteredGroups.length - 1] === 0) {
          this.filteredGroups = [0];
        } else {
          this.filteredGroups = this.filteredGroups.filter((group) => group !== 0);
        }
      }
      if (this.filteredGroups.length === 0) {
        this.filteredGroups = [0];
      }
    },
    changePosition(target2, currentPos, newPos) {
      if (newPos > currentPos) {
        target2.splice(newPos, 0, target2[currentPos]);
        target2.splice(currentPos, 1);
      } else {
        target2.splice(newPos - 1, 0, target2[currentPos]);
        target2.splice(currentPos + 1, 1);
      }
    },
    closeGroupEditDialog() {
      this.errorText = null;
      this.groupEditDialog = false;
    },
    deleteGroup() {
      const check = confirm("削除してよろしいですか？");
      if (check) {
        const removedMattertags = JSON.parse(JSON.stringify(this.dpmStore.currentEditGroup.mattertags));
        this.dpmStore.SED.mattertag_groups.splice(this.dpmStore.mattertagEditor.currentEditGroupIndex, 1);
        this.addToUngrouped(removedMattertags);
        this.filteredGroups = [0];
        this.closeGroupEditDialog();
      }
    },
    editGroup(i2) {
      this.dpmStore.mattertagEditor.currentEditGroupIndex = i2;
      this.editingSelectedMattertags = JSON.parse(JSON.stringify(this.dpmStore.currentEditGroup.mattertags));
      this.dialogType = "edit";
      this.dpmStore.mattertagEditor.useBy = "group";
      this.currentTab = 0;
      this.search = "";
      this.groupEditDialog = true;
    },
    newGroup() {
      this.dpmStore.SED.mattertag_groups.push({ label: "", color: { r: 1, g: 0, b: 0 }, mattertags: [], colorless: false, useCustomColor: false });
      this.dpmStore.mattertagEditor.currentEditGroupIndex = this.dpmStore.SED.mattertag_groups.length - 1;
      this.editingSelectedMattertags = [];
      this.dialogType = "new";
      this.dpmStore.mattertagEditor.useBy = "group";
      this.currentTab = 0;
      this.search = "";
      this.groupEditDialog = true;
    },
    save() {
      this.saveErrorText = null;
      this.progress = true;
      return axios$1.patch(
        `${this.$global.apiUrl}/save_mattertag_groups`,
        { showcase: { showcase_editor_data: JSON.stringify(this.dpmStore.SED) } },
        { headers: this.$global.csrfHeader }
      ).then((_res) => {
        this.saveErrorText = null;
      }).catch((err2) => {
        this.saveErrorText = err2.response ? err2.response.data : err2;
      }).finally(() => {
        this.progress = false;
      });
    },
    saveGroup() {
      if (!this.dpmStore.currentEditGroup.label) {
        this.errorText = "グループ名を入力してください";
        return;
      }
      this.errorText = null;
      if (this.dpmStore.currentEditGroup.activeStorageId) {
        this.dpmStore.currentEditGroup.url = `active_storage:${this.dpmStore.currentEditGroup.activeStorageId}`;
      }
      this.$delete(this.dpmStore.currentEditGroup, "activeStorageId");
      this.dpmStore.getUngroupedGroup.mattertags = this.dpmStore.getUngroupedGroup.mattertags.filter((ungroupedMattertag) => !this.editingSelectedMattertags.find((m) => m.sid === ungroupedMattertag.sid));
      const removedMattertags = this.dpmStore.currentEditGroup.mattertags.filter((mattertag) => !this.editingSelectedMattertags.find((m) => m.sid === mattertag.sid));
      this.dpmStore.currentEditGroup.mattertags = JSON.parse(JSON.stringify(this.editingSelectedMattertags));
      this.addToUngrouped(removedMattertags);
      if (this.dialogType === "new") {
        this.filteredGroups = [0];
      }
      this.closeGroupEditDialog();
    },
    searchLabel(_value, search, item) {
      const label = this.dpmStore.getLabel(item.sid);
      return label.indexOf(search) !== -1;
    },
    togglePriority() {
      if (this.dpmStore.currentEditGroup.topPriority) {
        this.dpmStore.currentEditGroup.colorless = false;
        this.dpmStore.currentEditGroup.useCustomColor = false;
      }
    }
  }
};
const initialState = () => {
  return {
    currentTab: 0,
    dataTableHeaders: [
      { text: "ラベル or SID", value: "title", sortable: true },
      { text: "フロア", value: "floor", sortable: true },
      { text: "グループ", value: "group", sortable: true }
    ],
    dragging: false,
    dialogType: "new",
    editingSelectedMattertags: [],
    errorText: null,
    filteredGroups: [],
    groupEditDialog: false,
    progress: false,
    saveErrorText: null,
    search: ""
  };
};
const __cssModules$i = {};
var __component__$i = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$i,
  render$i,
  staticRenderFns$i,
  false,
  __vue2_injectStyles$i,
  null,
  null,
  null
);
function __vue2_injectStyles$i(context) {
  for (let o in __cssModules$i) {
    this[o] = __cssModules$i[o];
  }
}
const mattertagGroupEditor = /* @__PURE__ */ function() {
  return __component__$i.exports;
}();
var render$h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("v-card", [_c("v-card-title", [_vm._v("タグリストタイトルUI編集")]), _c("v-divider"), _c("v-card-text", {
    staticClass: "p-3 d-grid"
  }, [_c("div", {
    staticClass: "h6 mb-2"
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiEye))]), _vm._v("プレビュー")], 1), _c("v-row", [_c("v-col", [_c("div", {
    staticClass: "group-list-title-preview df justify-content-between align-items-center px-3 py-2 m-auto",
    style: `background-color: ${_vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title.bg_color}; width: 418px`
  }, [_vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title.image && (_vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title.image.active_storage_id || _vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title.image.url) ? [_c("v-img", {
    attrs: {
      "src": _vm.imageSrc || _vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title.image.url,
      "contain": "",
      "position": "center left",
      "max-width": "316",
      "height": "50"
    }
  }), _vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title.image.active_storage_id ? _c("div", {
    staticClass: "position-relative",
    staticStyle: {
      "right": "139px",
      "margin-top": "-16px"
    }
  }, [_c("v-btn", {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.deleteImage
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v("アップロード画像を削除")], 1)], 1) : _vm._e()] : [_c("div", {
    staticClass: "v-list-item__title"
  }, [_vm._v(_vm._s(_vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title.text))])], _c("v-btn", {
    staticClass: "ms-4 my-3",
    attrs: {
      "icon": ""
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))])], 1)], 2)])], 1), _c("div", {
    staticClass: "h6 mt-4 mb-2"
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiPencil))]), _vm._v("編集")], 1), _c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "label": "タイトルテキスト",
      "messages": "画像が設定されている場合、そちらが優先されます。"
    },
    model: {
      value: _vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title.text,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title, "text", $$v);
      },
      expression: "dpmStore.SED.ui[selectedLanguage].group_list_title.text"
    }
  })], 1)], 1), _c("v-row", [_c("v-col", {
    staticClass: "pb-0"
  }, [_c("p", {
    staticClass: "mb-1"
  }, [_vm._v("タグリストタイトルの背景色")]), _c("v-color-picker", {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "value": _vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title.bg_color,
      "width": "418"
    },
    on: {
      "update:color": _vm.onUpdateColor
    }
  })], 1)], 1), _c("v-row", {
    staticClass: "mt-0"
  }, [_c("v-col", {
    attrs: {
      "cols": "4"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "タイトル画像のURL",
      "messages": "画像がアップロードされている場合、そちらが優先されます。"
    },
    model: {
      value: _vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title.image.url,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.SED.ui[_vm.selectedLanguage].group_list_title.image, "url", $$v);
      },
      expression: "dpmStore.SED.ui[selectedLanguage].group_list_title.image.url"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "4"
    }
  }, [_c("v-file-input", {
    attrs: {
      "label": "アップロードするタイトル画像ファイル",
      "messages": "5MBまでのjpg, png, gifファイルがアップロード可能です。"
    },
    model: {
      value: _vm.uploadedImageFile,
      callback: function($$v) {
        _vm.uploadedImageFile = $$v;
      },
      expression: "uploadedImageFile"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "4"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.uploadedImageFile
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiUpload))]), _vm._v("アップロード")], 1)], 1)], 1), _vm.errorText ? _c("v-row", [_c("div", {
    staticClass: "ms-3 text-danger"
  }, [_vm._v(_vm._s(_vm.errorText))])]) : _vm._e()], 1), _c("v-divider"), _c("v-card-actions", {
    staticClass: "justify-content-end"
  }, [_c("v-btn", {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dpmStore.uiEditor.tagListTitleModal = false;
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))]), _vm._v("閉じる")], 1)], 1)], 1);
};
var staticRenderFns$h = [];
const __vue2_script$h = {
  data() {
    return {
      errorText: null,
      imageSrc: null,
      languages: ["de", "en", "es", "fr", "it", "ja", "ko", "nl", "pt", "ru", "zh"],
      selectedColor: null,
      selectedLanguage: "default",
      // TODO: 独自UIを作成の時に多言語対応するけれど、今はdefaultを使用する。
      toHex,
      toHex,
      uploadedImageFile: null
    };
  },
  created() {
    return __async(this, null, function* () {
      const id = this.dpmStore.SED.ui[this.selectedLanguage].group_list_title.image.active_storage_id;
      if (id) {
        const res = yield axios$1.get(
          `${this.$global.apiUrl}/get_media_url?type=group_list_title_image&file_id=${id}`
        ).catch((err2) => {
          this.errorText = err2.response && err2.response.data ? err2.response.data.error : err2;
        });
        this.imageSrc = res.data.url;
      }
    });
  },
  methods: {
    deleteImage() {
      return __async(this, null, function* () {
        this.errorText = null;
        const res = yield axios$1.delete(
          `${this.$global.apiUrl}/purge_media?type=group_list_title_image&file_id=${this.dpmStore.SED.ui[this.selectedLanguage].group_list_title.image.active_storage_id}`,
          { headers: this.$global.csrfHeader }
        ).catch((error2) => {
          this.errorText = error2;
        });
        if (res) {
          this.imageSrc = null;
          this.dpmStore.SED.ui[this.selectedLanguage].group_list_title.image.active_storage_id = null;
        }
      });
    },
    onUpdateColor(data) {
      this.dpmStore.SED.ui[this.selectedLanguage].group_list_title.bg_color = data.hex;
    },
    uploadImage() {
      return __async(this, null, function* () {
        this.errorText = null;
        const params = new FormData();
        params.append("file", this.uploadedImageFile);
        const res = yield axios$1.post(
          `${this.$global.apiUrl}/upload_media?type=group_list_title_image`,
          params,
          { headers: __spreadProps(__spreadValues({}, this.$global.csrfHeader), { "content-type": "multipart/form-data" }) }
        ).catch((err2) => {
          this.errorText = err2.response && err2.response.data ? err2.response.data.error : err2;
        });
        if (res) {
          this.imageSrc = res.data.url;
          this.dpmStore.SED.ui[this.selectedLanguage].group_list_title.image.active_storage_id = res.data.id;
          this.uploadedImageFile = null;
        }
      });
    }
  },
  computed: __spreadValues({}, mapStores(useDpmStore))
};
const __cssModules$h = {};
var __component__$h = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$h,
  render$h,
  staticRenderFns$h,
  false,
  __vue2_injectStyles$h,
  null,
  null,
  null
);
function __vue2_injectStyles$h(context) {
  for (let o in __cssModules$h) {
    this[o] = __cssModules$h[o];
  }
}
const GroupListTitleUiEditorModal = /* @__PURE__ */ function() {
  return __component__$h.exports;
}();
var render$g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "minimap-image-editor-modal p-3"
  }, [_c("v-row", _vm._l(_vm.minimapData, function(data, index2) {
    return _c("v-col", {
      key: index2,
      attrs: {
        "cols": "4"
      }
    }, [_c("div", {
      staticClass: "image-wrapper p-2 position-relative df justify-content-center overflow-hidden"
    }, [_c("img", {
      staticClass: "w-100",
      style: `transform: rotate(${_vm.dpmStore.showcaseEditorData.minimap_rotate}deg);`,
      attrs: {
        "src": data.url
      }
    }), _c("div", {
      staticClass: "floor-name p-2 position-absolute top-0 start-0"
    }, [_vm._v(_vm._s(_vm.getFloorDataByMinimapIndex(index2).name))]), data.activeStorageId ? _c("v-btn", {
      staticClass: "m-1 position-absolute bottom-0",
      attrs: {
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImage(data.activeStorageId, index2);
        }
      }
    }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v("アップロード画像を削除")], 1) : _vm._e(), !data.activeStorageId ? _c("v-btn", {
      staticClass: "m-1 position-absolute bottom-0 end-0",
      attrs: {
        "fab": "",
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.downloadImage(index2);
        }
      }
    }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDownload))])], 1) : _vm._e()], 1)]);
  }), 1), _c("v-row", {
    staticClass: "my-1"
  }, [_c("v-col", {
    attrs: {
      "cols": "3"
    }
  }, [_c("v-select", {
    attrs: {
      "placeholder": "フロアを選択して下さい",
      "items": Object.keys(_vm.dpmStore.global.floors).map(function(key) {
        return {
          text: _vm.dpmStore.global.floors[key].name,
          value: _vm.dpmStore.global.floors[key].sequence
        };
      })
    },
    model: {
      value: _vm.selectedFloor,
      callback: function($$v) {
        _vm.selectedFloor = $$v;
      },
      expression: "selectedFloor"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "6"
    }
  }, [_c("v-file-input", {
    attrs: {
      "label": "アップロードするファイル",
      "messages": "10MBまでのjpg, png, gifファイルがアップロード可能です。"
    },
    model: {
      value: _vm.uploadedImageFile,
      callback: function($$v) {
        _vm.uploadedImageFile = $$v;
      },
      expression: "uploadedImageFile"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "3"
    }
  }, [_c("v-btn", {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.uploadedImageFile || _vm.selectedFloor === null
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiUpload))]), _vm._v("アップロード")], 1)], 1)], 1), _vm.errorText ? _c("div", {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e(), _c("v-row", {
    staticClass: "my-1"
  }, [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("v-slider", {
    attrs: {
      "value": _vm.dpmStore.showcaseEditorData.minimap_rotate,
      "min": "0",
      "max": "359",
      "label": "画像の角度",
      "thumb-label": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.changeRotate
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c("v-text-field", {
          staticClass: "mt-0 pt-0",
          staticStyle: {
            "width": "60px"
          },
          attrs: {
            "value": _vm.dpmStore.showcaseEditorData.minimap_rotate,
            "type": "number"
          },
          on: {
            "change": _vm.changeRotate
          }
        })];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);
};
var staticRenderFns$g = [];
const __vue2_script$g = {
  data() {
    return {
      apiMinimapData: [],
      errorText: null,
      minimapData: [],
      selectedFloor: null,
      uploadedImageFile: null
    };
  },
  created() {
    return __async(this, null, function* () {
      const res = yield axios$1.get(`${this.$global.apiUrl}/get_minimap_data.json`).catch((error2) => {
        this.errorText = error2.response ? error2.response.data.error : error2;
      });
      if (res && res.data.minimaps) {
        this.apiMinimapData = res.data.minimaps;
      }
      if (this.dpmStore.SED.minimap_images.length === 0) {
        this.minimapData = this.apiMinimapData.map((data) => {
          return { activeStorageId: null, url: data.url };
        });
      } else {
        this.minimapData.push(...yield Promise.all(this.dpmStore.SED.minimap_images.map((minimapImageUrl, i2) => __async(this, null, function* () {
          if (minimapImageUrl === "" || !minimapImageUrl.includes("active_storage")) {
            return { activeStorageId: null, url: this.apiMinimapData[i2].url };
          } else {
            const activeStorageId = minimapImageUrl.split(":")[1];
            const res2 = yield axios$1.get(`${this.$global.apiUrl}/get_media_url?type=minimap_images&file_id=${activeStorageId}`).catch((error2) => {
              this.errorText = error2.response ? error2.response.data.error : error2;
            });
            if (res2 && res2.data) {
              return { activeStorageId, url: res2.data.url };
            }
          }
        }))));
      }
    });
  },
  methods: {
    changeRotate(data) {
      data = Number(data);
      if (data > 360) {
        data = data - 360;
      } else if (data < 0) {
        data = data + 360;
      }
      this.dpmStore.$patch({ showcaseEditorData: { minimap_rotate: data } });
    },
    deleteImage(activeStorageId, index2) {
      return __async(this, null, function* () {
        const res = yield axios$1.delete(
          `${this.$global.apiUrl}/purge_media?type=minimap_images&file_id=${activeStorageId}`,
          { headers: this.$global.csrfHeader }
        ).catch((error2) => {
          this.errorText = error2.response ? error2.response.data.error : err;
        });
        if (res) {
          this.minimapData.splice(index2, 1, { activeStorageId: null, url: this.apiMinimapData[index2].url });
          this.errorText = null;
          this.dpmStore.$patch({ showcaseEditorData: { minimap_images: this.minimapData.map((data) => data.activeStorageId === null ? "" : `active_storage:${data.activeStorageId}`) } });
        }
      });
    },
    downloadImage(index2) {
      const link2 = document.createElement("a");
      link2.href = this.apiMinimapData[index2].url;
      link2.download = `minimap-floor-${index2}.png`;
      link2.click();
    },
    getFloorDataByMinimapIndex(index2) {
      for (const value of Object.values(this.dpmStore.global.floors)) {
        if (value.sequence === index2) {
          return value;
        }
      }
    },
    uploadImage() {
      return __async(this, null, function* () {
        const params = new FormData();
        params.append("file", this.uploadedImageFile);
        const res = yield axios$1.post(
          `${this.$global.apiUrl}/upload_media?type=minimap_images`,
          params,
          { headers: this.$global.csrfHeader }
        ).catch((error2) => {
          this.errorText = error2.response ? error2.response.data.error : err;
        });
        if (res && res.data) {
          this.minimapData.splice(this.selectedFloor, 1, { activeStorageId: res.data.id, url: res.data.url });
          this.errorText = null;
          this.selectedFloor = null;
          this.uploadedImageFile = null;
          this.dpmStore.$patch({ showcaseEditorData: { minimap_images: this.minimapData.map((data) => data.activeStorageId === null ? "" : `active_storage:${data.activeStorageId}`) } });
        }
      });
    }
  },
  computed: __spreadValues({}, mapStores(useDpmStore))
};
const __cssModules$g = {};
var __component__$g = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$g,
  render$g,
  staticRenderFns$g,
  false,
  __vue2_injectStyles$g,
  null,
  null,
  null
);
function __vue2_injectStyles$g(context) {
  for (let o in __cssModules$g) {
    this[o] = __cssModules$g[o];
  }
}
const imageTabContent = /* @__PURE__ */ function() {
  return __component__$g.exports;
}();
var render$f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("v-row", {
    staticClass: "p-3"
  }, [_c("v-col", {
    attrs: {
      "cols": "4"
    }
  }, [_c("v-textarea", {
    attrs: {
      "label": "Labelトグルボタン: ラベル",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.dpmStore.SED.ui[_vm.selectedLanguage].minimap.label.switch,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.SED.ui[_vm.selectedLanguage].minimap.label, "switch", $$v);
      },
      expression: "dpmStore.SED.ui[selectedLanguage].minimap.label.switch"
    }
  }), _c("v-textarea", {
    staticClass: "mt-3",
    attrs: {
      "label": "Labelトグルボタン: ヘルプ",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.dpmStore.SED.ui[_vm.selectedLanguage].minimap.label.help,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.SED.ui[_vm.selectedLanguage].minimap.label, "help", $$v);
      },
      expression: "dpmStore.SED.ui[selectedLanguage].minimap.label.help"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "4"
    }
  }, [_c("v-textarea", {
    attrs: {
      "label": "Tagトグルボタン: ラベル",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.dpmStore.SED.ui[_vm.selectedLanguage].minimap.mattertag.switch,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.SED.ui[_vm.selectedLanguage].minimap.mattertag, "switch", $$v);
      },
      expression: "dpmStore.SED.ui[selectedLanguage].minimap.mattertag.switch"
    }
  }), _c("v-textarea", {
    staticClass: "mt-3",
    attrs: {
      "label": "Tagトグルボタン: ヘルプ",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.dpmStore.SED.ui[_vm.selectedLanguage].minimap.mattertag.help,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.SED.ui[_vm.selectedLanguage].minimap.mattertag, "help", $$v);
      },
      expression: "dpmStore.SED.ui[selectedLanguage].minimap.mattertag.help"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "4"
    }
  }, [_c("v-textarea", {
    attrs: {
      "label": "Sweepトグルボタン: ラベル",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.dpmStore.SED.ui[_vm.selectedLanguage].minimap.sweep.switch,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.SED.ui[_vm.selectedLanguage].minimap.sweep, "switch", $$v);
      },
      expression: "dpmStore.SED.ui[selectedLanguage].minimap.sweep.switch"
    }
  }), _c("v-textarea", {
    staticClass: "mt-3",
    attrs: {
      "label": "Sweepトグルボタン: ヘルプ",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.dpmStore.SED.ui[_vm.selectedLanguage].minimap.sweep.help,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.SED.ui[_vm.selectedLanguage].minimap.sweep, "help", $$v);
      },
      expression: "dpmStore.SED.ui[selectedLanguage].minimap.sweep.help"
    }
  })], 1)], 1);
};
var staticRenderFns$f = [];
const __vue2_script$f = {
  data() {
    return {
      languages: ["de", "en", "es", "fr", "it", "ja", "ko", "nl", "pt", "ru", "zh"],
      selectedLanguage: "default",
      // TODO: 独自UIを作成の時に多言語対応するけれど、今はdefaultを使用する。
      ui: {}
    };
  },
  computed: __spreadValues({}, mapStores(useDpmStore)),
  methods: {
    save() {
      this.$emit("applyMinimap", this.ui);
    }
  }
};
const __cssModules$f = {};
var __component__$f = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$f,
  render$f,
  staticRenderFns$f,
  false,
  __vue2_injectStyles$f,
  null,
  null,
  null
);
function __vue2_injectStyles$f(context) {
  for (let o in __cssModules$f) {
    this[o] = __cssModules$f[o];
  }
}
const textTabContent = /* @__PURE__ */ function() {
  return __component__$f.exports;
}();
var render$e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("v-card", [_c("v-card-title", [_vm._v("ミニマップUI編集")]), _c("v-tabs", {
    attrs: {
      "background-color": "transparent",
      "grow": ""
    },
    model: {
      value: _vm.tab,
      callback: function($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c("v-tab", {
    key: "image"
  }, [_vm._v("画像")]), _c("v-tab", {
    key: "text"
  }, [_vm._v("テキスト")])], 1), _c("v-card-text", {
    staticClass: "p-3"
  }, [_c("v-tabs-items", {
    model: {
      value: _vm.tab,
      callback: function($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c("v-tab-item", [_c("imageTabContent")], 1), _c("v-tab-item", [_c("textTabContent")], 1)], 1)], 1), _c("v-divider"), _c("v-card-actions", {
    staticClass: "justify-content-end"
  }, [_c("v-btn", {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dpmStore.uiEditor.minimapModal = false;
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))]), _vm._v("閉じる")], 1)], 1)], 1);
};
var staticRenderFns$e = [];
const __vue2_script$e = {
  components: {
    imageTabContent,
    textTabContent
  },
  data: () => ({
    tab: 0
  }),
  computed: __spreadValues({}, mapStores(useDpmStore))
};
const __cssModules$e = {};
var __component__$e = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$e,
  render$e,
  staticRenderFns$e,
  false,
  __vue2_injectStyles$e,
  null,
  null,
  null
);
function __vue2_injectStyles$e(context) {
  for (let o in __cssModules$e) {
    this[o] = __cssModules$e[o];
  }
}
const MinimapUiEditorModal = /* @__PURE__ */ function() {
  return __component__$e.exports;
}();
var render$d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "w-100"
  }, [_c("h6", [_vm._v(_vm._s(_vm.showcaseAlias) + "の各種UI表示の編集")]), _vm.dpmStore.global.enableExtensions.minimap && _vm.dpmStore.global.minimap ? _c("v-btn", {
    staticClass: "mt-2",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.dpmStore.uiEditor.minimapModal = true;
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiMapOutline))]), _vm._v("ミニマップ")], 1) : _vm._e(), _c("v-btn", {
    staticClass: "mt-2",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.dpmStore.uiEditor.tagListTitleModal = true;
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiMenu))]), _vm._v("タグリストタイトル")], 1), _c("v-dialog", {
    attrs: {
      "content-class": "minimap-ui-editor-modal dpm-modal",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: _vm.dpmStore.uiEditor.minimapModal,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.uiEditor, "minimapModal", $$v);
      },
      expression: "dpmStore.uiEditor.minimapModal"
    }
  }, [_c("MinimapUiEditorModal")], 1), _c("v-dialog", {
    attrs: {
      "content-class": "group-list-title-ui-editor-modal dpm-modal",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: _vm.dpmStore.uiEditor.tagListTitleModal,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.uiEditor, "tagListTitleModal", $$v);
      },
      expression: "dpmStore.uiEditor.tagListTitleModal"
    }
  }, [_c("GroupListTitleUiEditorModal")], 1)], 1);
};
var staticRenderFns$d = [];
const __vue2_script$d = {
  data() {
    return {
      showcaseAlias: ""
    };
  },
  components: {
    GroupListTitleUiEditorModal,
    MinimapUiEditorModal
  },
  mounted() {
    this.showcaseAlias = document.getElementById("showcase").dataset.showcaseAlias || "ショーケース";
  },
  computed: __spreadValues({}, mapStores(useDpmStore))
};
const __cssModules$d = {};
var __component__$d = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$d,
  render$d,
  staticRenderFns$d,
  false,
  __vue2_injectStyles$d,
  null,
  null,
  null
);
function __vue2_injectStyles$d(context) {
  for (let o in __cssModules$d) {
    this[o] = __cssModules$d[o];
  }
}
const uiEditor = /* @__PURE__ */ function() {
  return __component__$d.exports;
}();
var render$c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "dpm-minimap-component sweep-selector"
  }, [_c("div", [_c("v-select", {
    attrs: {
      "label": "フロアセレクター",
      "items": Object.keys(_vm.dpmStore.global.floors).map(function(key) {
        return {
          text: _vm.dpmStore.global.floors[key].name,
          value: _vm.dpmStore.global.floors[key].sequence
        };
      })
    },
    model: {
      value: _vm.selectedFloorSequence,
      callback: function($$v) {
        _vm.selectedFloorSequence = $$v;
      },
      expression: "selectedFloorSequence"
    }
  })], 1), _c("div", {
    staticClass: "df"
  }, [_c("div", [_c("div", {
    ref: "sweepSelectorImageContainer",
    staticClass: "info-wrapper pe-auto",
    style: `width: ${_vm.width + _vm.wrapperPadding * 2}px; height: ${_vm.height + _vm.wrapperPadding * 2}px;`,
    attrs: {
      "dragging": _vm.dragging
    }
  }, [_c("img", {
    staticClass: "d-none",
    attrs: {
      "src": _vm.dpmStore.global.minimap.data[_vm.selectedFloorSequence].url
    },
    on: {
      "error": _vm.reloadMinimapData
    }
  }), _c("div", {
    staticClass: "minimap-info",
    style: `width: ${_vm.width}px; height: ${_vm.height}px; background-image: url(${_vm.dpmStore.global.minimap.data[_vm.selectedFloorSequence].url}); transform: scale(${_vm.currentZoomLevel}); transform-origin: 0 0`
  }, [_vm.dpmStore.cilbeeEditor.visible ? _c("div", {
    staticClass: "cilbee-route"
  }, _vm._l(_vm.routeLines, function(line, i2) {
    return _c("div", {
      key: `line-${line.id}`,
      staticClass: "line",
      style: `width: ${line.width}px; left: ${line.left - _vm.sweepButtonSize / 4 / _vm.currentZoomLevel}px; top: ${line.top - _vm.sweepButtonSize / 4 / _vm.currentZoomLevel}px; transform: rotate(${line.degree}deg) scale(1, ${1 / _vm.currentZoomLevel}); background-color: ${line.color};`
    });
  }), 0) : _vm._e(), _c("v-fade-transition", [_c("div", {
    ref: "sweeps",
    staticClass: "sweeps"
  }, [_vm._l(_vm.defaultSweeps, function(sweep) {
    return [_c("div", {
      key: sweep.sid,
      staticClass: "minimap-sweep-button position-absolute",
      style: `width: ${_vm.sweepButtonSize}px; height: ${_vm.sweepButtonSize}px; right: ${sweep.right - _vm.sweepButtonSize / 2}px; top: ${sweep.top - _vm.sweepButtonSize / 2}px; border: ${_vm.sweepButtonSize * 0.1}px solid #fff; ${_vm.dpmStore.cilbeeEditor.visible && _vm.connectedAnotherFloorSweeps.includes(sweep.sid) ? "background-color: #fff000" : ""}; transform: scale(${1 / _vm.currentZoomLevel})`,
      attrs: {
        "data-sid": sweep.sid
      },
      on: {
        "click": [function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey)
            return null;
          return _vm.onClickSweep(sweep.sid);
        }, function($event) {
          if (!$event.ctrlKey)
            return null;
          return _vm.onCtrlClickSweep(sweep.sid);
        }]
      }
    })];
  })], 2)]), _c("v-fade-transition", [!_vm.dpmStore.cilbeeEditor.visible ? _c("div", {
    staticClass: "grouped-sweeps"
  }, [_vm._l(_vm.groupedSweepsOfselectedFloor, function(sweepGroup, i2) {
    return [_c("div", {
      staticClass: "sweep-group"
    }, _vm._l(sweepGroup, function(sweep) {
      return _c("div", {
        staticClass: "grouped-sweep"
      }, [_c("div", {
        staticClass: "selected-ring"
      }, [_vm.checkActiveGroup(sweep.sid) ? _c("div", {
        key: `${sweep.sid}-selected`,
        staticClass: "position-absolute",
        style: `width: ${_vm.currentPointSize * 1.6}px; height: ${_vm.currentPointSize * 1.6}px; right: ${sweep.right - _vm.currentPointSize * 1.6 / 2}px; top: ${sweep.top - _vm.currentPointSize * 1.6 / 2}px; border: ${_vm.sweepButtonSize * 1.6 * 0.2}px solid ${_vm.dpmStore.SED.sweep_groups[i2].colorless ? "#FFF" : _vm.dpmStore.SED.sweep_groups[i2].color}; background-color: transparent; transform: scale(${1 / _vm.currentZoomLevel})`
      }) : _vm._e()]), !_vm.dpmStore.SED.sweeps.find(function(s2) {
        return s2.sid === sweep.sid && _vm.dpmStore.checkSweepIconChenged(s2.sid) && !s2.colorless;
      }) ? _c("v-btn", {
        key: `${sweep.sid}-active`,
        staticClass: "position-absolute",
        style: `right: ${sweep.right - _vm.currentPointSize / 2}px; top: ${sweep.top - _vm.currentPointSize / 2}px; transform: scale(${1 / _vm.currentZoomLevel})`,
        attrs: {
          "fab": "",
          "dark": "",
          "x-small": "",
          "elevation": "0",
          "width": _vm.currentPointSize,
          "height": _vm.currentPointSize,
          "color": "transparent"
        },
        on: {
          "click": function($event) {
            return _vm.onClickSweep(sweep.sid);
          }
        }
      }, [_c("v-icon", {
        attrs: {
          "color": _vm.dpmStore.SED.sweep_groups[i2].colorless ? "transparent" : _vm.dpmStore.SED.sweep_groups[i2].color,
          "dark": "",
          "size": _vm.currentPointSize
        }
      }, [_vm._v(_vm._s(_vm.$global.icons.mdiCircle))])], 1) : _vm._e()], 1);
    }), 0)];
  })], 2) : _vm._e()]), _c("v-fade-transition", [!_vm.dpmStore.cilbeeEditor.visible ? _c("div", {
    staticClass: "edited-sweeps"
  }, [_vm._l(_vm.minimapSweepsOfSelectedFloor, function(sweep) {
    return [(_vm.extensionData = _vm.dpmStore.SED.sweeps.find(function(s2) {
      return s2.sid === sweep.sid;
    })) ? _c("v-btn", {
      key: `${sweep.sid}-edited`,
      staticClass: "position-absolute",
      style: `right: ${sweep.right - _vm.currentPointSize / 2}px; top: ${sweep.top - _vm.currentPointSize / 2}px; transform: rotate(${_vm.extensionData.degree}deg); transform: scale(${1 / _vm.currentZoomLevel})`,
      attrs: {
        "fab": "",
        "dark": "",
        "x-small": "",
        "elevation": "0",
        "width": _vm.currentPointSize,
        "height": _vm.currentPointSize,
        "color": _vm.extensionData.colorless ? "transparent" : _vm.extensionData.bgColor
      },
      on: {
        "click": function($event) {
          return _vm.onClickSweep(sweep.sid);
        }
      }
    }, [_c("v-icon", {
      attrs: {
        "color": _vm.extensionData.icon.color,
        "size": _vm.currentPointSize
      }
    }, [_vm._v(_vm._s(_vm.$global.icons[_vm.extensionData.icon.id]))])], 1) : _vm._e()];
  })], 2) : _vm._e()]), _c("v-fade-transition", [_c("div", {
    staticClass: "selected-sweep"
  }, [_vm._l(_vm.minimapSweepsOfSelectedFloor, function(sweep) {
    return [_vm.dpmStore.cilbeeEditor.visible && _vm.dpmStore.cilbeeEditor.rootSweep && sweep.sid === _vm.dpmStore.cilbeeEditor.rootSweep.sid || _vm.dpmStore.sweepEditor.activeTab === 1 && _vm.dpmStore.sweepEditor.selectedSweep && sweep.sid === _vm.dpmStore.sweepEditor.selectedSweep.sid ? _c("div", {
      key: `${sweep.sid}-selected`,
      staticClass: "minimap-sweep-button position-absolute",
      style: `width: ${_vm.sweepButtonSize}px; height: ${_vm.sweepButtonSize}px; right: ${sweep.right - _vm.sweepButtonSize / 2}px; top: ${sweep.top - _vm.sweepButtonSize / 2}px; border: ${_vm.sweepButtonSize * 0.1}px solid #fff; background-color: transparent; pointer-events: none; transform: scale(${1 / _vm.currentZoomLevel * 2.5})`
    }) : _vm._e()];
  })], 2)]), _c("v-fade-transition", [_vm._l(_vm.minimapSweepsOfSelectedFloor, function(sweep) {
    return [_vm.dpmStore.cilbeeEditor.visible && _vm.dpmStore.cilbeeEditor.rootSweep && sweep.sid === _vm.dpmStore.cilbeeEditor.rootSweep.sid ? _c("div", {
      key: `${sweep.sid}-root`,
      staticClass: "root-sweep position-absolute",
      style: `width: ${_vm.sweepButtonSize}px; height: ${_vm.sweepButtonSize}px; right: ${sweep.right - _vm.sweepButtonSize / 2}px; top: ${sweep.top - _vm.sweepButtonSize / 2}px; border: ${_vm.sweepButtonSize * 0.1}px solid #fff; background-color: red; transform: scale(${1 / _vm.currentZoomLevel})`
    }) : _vm._e()];
  })], 2)], 1)])]), _c("div", {
    staticClass: "menu-container df pe-auto"
  }, [_c("v-fade-transition", [_c("div", {
    staticClass: "menu df"
  }, [_c("div", {
    staticClass: "menu-item"
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": "",
      "attach": ".sweep-editor-modal .dpm-minimap-component .menu-container"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref) {
        var on2 = _ref.on;
        return [_c("v-btn", _vm._g({
          attrs: {
            "outlined": "",
            "fab": "",
            "small": "",
            "elevation": "0",
            "color": "white"
          },
          on: {
            "click": function($event) {
              return _vm.onZoomClick(0.5);
            }
          }
        }, on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiMagnifyPlusOutline))])], 1)];
      }
    }])
  }, [_c("span", [_vm._v("拡大")])])], 1), _c("div", {
    staticClass: "menu-item"
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": "",
      "attach": ".sweep-editor-modal .dpm-minimap-component .menu-container"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref2) {
        var on2 = _ref2.on;
        return [_c("v-btn", _vm._g({
          attrs: {
            "outlined": "",
            "fab": "",
            "small": "",
            "elevation": "0",
            "color": "white"
          },
          on: {
            "click": function($event) {
              return _vm.onZoomClick(-0.5);
            }
          }
        }, on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiMagnifyMinusOutline))])], 1)];
      }
    }])
  }, [_c("span", [_vm._v("縮小")])])], 1)])])], 1)])]);
};
var staticRenderFns$c = [];
const __vue2_script$c = {
  data() {
    return {
      aspect: 1,
      connectedAnotherFloorSweeps: [],
      currentZoomLevel: 1,
      dragging: false,
      height: 100,
      reductionRate: 0.58,
      selectedFloorSequence: 0,
      width: 100,
      wrapperPadding: 8
    };
  },
  created() {
    var _a2;
    this.currentZoomLevel = 1;
    this.selectedFloorSequence = ((_a2 = this.dpmStore.current.floor) == null ? void 0 : _a2.sequence) || this.selectedFloorSequence;
    this.aspect = this.dpmStore.global.minimap.data[0].width / this.dpmStore.global.minimap.data[0].height;
    this.calcDefaultSize();
    this.setMinimapImage();
    if (this.dpmStore.cilbeeEditor.visible) {
      this.dpmStore.cilbeeEditor.rootSweep = this.dpmStore.current.sweep;
      if (!this.cilbeeStore.currentPassableAreaFloorSweeps(this.selectedFloorSequence)[this.dpmStore.cilbeeEditor.rootSweep.sid]) {
        this.$set(this.cilbeeStore.currentPassableAreaFloorSweeps(this.selectedFloorSequence), this.dpmStore.cilbeeEditor.rootSweep.sid, []);
      }
    }
  },
  mounted() {
    let previousEvent = null;
    const onPointerMove = (e) => {
      this.$refs.sweepSelectorImageContainer.scrollTop -= e.screenY - previousEvent.screenY;
      this.$refs.sweepSelectorImageContainer.scrollLeft -= e.screenX - previousEvent.screenX;
      previousEvent = e;
    };
    this.$refs.sweepSelectorImageContainer.addEventListener("pointerup", (e) => {
      this.dragging = false;
      this.$refs.sweepSelectorImageContainer.removeEventListener("pointermove", onPointerMove);
    });
    this.$refs.sweepSelectorImageContainer.addEventListener("pointerdown", (e) => {
      this.dragging = true;
      previousEvent = e;
      this.$refs.sweepSelectorImageContainer.addEventListener("pointermove", onPointerMove);
    });
  },
  methods: {
    calcDefaultSize() {
      this.width = this.matterportStore.iframeSize.width * 0.9 * this.reductionRate;
      this.height = this.width / this.aspect;
    },
    changeRootSweep(sweepSid) {
      this.dpmStore.cilbeeEditor.rootSweep = this.dpmStore.global.sweeps[sweepSid];
      if (!this.cilbeeStore.currentPassableAreaFloorSweeps(this.selectedFloorSequence)[this.dpmStore.cilbeeEditor.rootSweep.sid]) {
        this.$set(this.cilbeeStore.currentPassableAreaFloorSweeps(this.selectedFloorSequence), this.dpmStore.cilbeeEditor.rootSweep.sid, []);
      }
    },
    onClickSweep(sweepSid) {
      var _a2, _b2;
      if (this.dpmStore.cilbeeEditor.visible) {
        if (!this.dpmStore.cilbeeEditor.rootSweep.sid) {
          this.changeRootSweep(sweepSid);
          return;
        }
        this.dpmStore.cilbeeEditor.selectedSweep = this.minimapSweepsOfSelectedFloor.find((sweep) => sweep.sid === sweepSid);
        if (!((_b2 = (_a2 = this.cilbeeStore.currentPassableAreaFloorSweeps(this.dpmStore.cilbeeEditor.rootSweep.floorInfo.sequence)) == null ? void 0 : _a2[this.dpmStore.cilbeeEditor.rootSweep.sid]) == null ? void 0 : _b2.find((sid) => sid === this.dpmStore.cilbeeEditor.selectedSweep.sid))) {
          this.cilbeeStore.currentPassableAreaFloorSweeps(this.dpmStore.cilbeeEditor.rootSweep.floorInfo.sequence)[this.dpmStore.cilbeeEditor.rootSweep.sid].push(this.dpmStore.cilbeeEditor.selectedSweep.sid);
          if (!this.cilbeeStore.currentPassableAreaFloorSweeps(this.selectedFloorSequence)[this.dpmStore.cilbeeEditor.selectedSweep.sid]) {
            this.$set(this.cilbeeStore.currentPassableAreaFloorSweeps(this.selectedFloorSequence), this.dpmStore.cilbeeEditor.selectedSweep.sid, []);
          }
          this.cilbeeStore.currentPassableAreaFloorSweeps(this.selectedFloorSequence)[this.dpmStore.cilbeeEditor.selectedSweep.sid].push(this.dpmStore.cilbeeEditor.rootSweep.sid);
          if (!this.cilbeeStore.fixRootSweep) {
            this.changeRootSweep(sweepSid);
          }
        } else {
          const rootIndex = this.cilbeeStore.currentPassableAreaFloorSweeps(this.dpmStore.cilbeeEditor.rootSweep.floorInfo.sequence)[this.dpmStore.cilbeeEditor.rootSweep.sid].indexOf(sweepSid);
          if (rootIndex >= 0) {
            this.cilbeeStore.currentPassableAreaFloorSweeps(this.dpmStore.cilbeeEditor.rootSweep.floorInfo.sequence)[this.dpmStore.cilbeeEditor.rootSweep.sid].splice(rootIndex, 1);
          }
          const selectedIndex = this.cilbeeStore.currentPassableAreaFloorSweeps(this.selectedFloorSequence)[this.dpmStore.cilbeeEditor.selectedSweep.sid].indexOf(this.dpmStore.cilbeeEditor.rootSweep.sid);
          if (selectedIndex >= 0) {
            this.cilbeeStore.currentPassableAreaFloorSweeps(this.selectedFloorSequence)[this.dpmStore.cilbeeEditor.selectedSweep.sid].splice(selectedIndex, 1);
          }
        }
      }
      if (this.dpmStore.sweepEditor.visible) {
        this.dpmStore.sweepEditor.selectedSweep = this.minimapSweepsOfSelectedFloor.find((sweep) => sweep.sid === sweepSid);
        if (this.dpmStore.sweepEditor.activeTab === 0 && this.dpmStore.sweepEditor.activeGroupIndex !== void 0) {
          if (this.dpmStore.sweepEditor.activeGroupIndex !== void 0 && this.dpmStore.currentEditSweepGroup.sweeps.includes(sweepSid)) {
            this.dpmStore.currentEditSweepGroup.sweeps = this.dpmStore.currentEditSweepGroup.sweeps.filter((sid) => sid !== sweepSid);
          } else {
            this.dpmStore.SED.sweep_groups.forEach((group) => {
              group.sweeps = group.sweeps.filter((sid) => sid !== sweepSid);
            });
            this.dpmStore.SED.sweep_groups[this.dpmStore.sweepEditor.activeGroupIndex].sweeps.push(sweepSid);
          }
        } else if (this.dpmStore.sweepEditor.activeTab === 1) {
          if (!this.dpmStore.currentEditSweep) {
            this.dpmStore.SED.sweeps.push(this.dpmStore.getDefaultSweepIconData(this.dpmStore.sweepEditor.selectedSweep.sid));
          }
        }
      }
    },
    onCtrlClickSweep(sweepSid) {
      if (this.dpmStore.cilbeeEditor.visible) {
        this.changeRootSweep(sweepSid);
      }
    },
    onZoomClick(param) {
      this.currentZoomLevel += param;
      if (this.currentZoomLevel < 1) {
        this.currentZoomLevel = 1;
      }
      if (this.currentZoomLevel > 20) {
        this.currentZoomLevel = 20;
      }
    },
    // TODO: この辺りminimap.vueと同じなので共通化したい
    // TODO: Rails側への問い合わせも別ファイルで一元管理したさある
    reloadMinimapData() {
      return __async(this, null, function* () {
        const res = yield axios$1.get(`${this.$global.apiUrl}/get_minimap_data.json`);
        this.dpmStore.$patch({ global: { minimap: { data: res.data.minimaps } } });
      });
    },
    getZPos(currentMinimapData, targetZ) {
      return this.height + (targetZ + currentMinimapData.origin.y) * currentMinimapData.resolution * this.height / currentMinimapData.height;
    },
    getXPos(currentMinimapData, targetX) {
      return this.width - (targetX - currentMinimapData.origin.x) * currentMinimapData.resolution * this.width / currentMinimapData.width;
    },
    setMinimapImage() {
      return __async(this, null, function* () {
        if (this.dpmStore.SED.minimap_images.length) {
          for (let i2 = 0; i2 < this.dpmStore.SED.minimap_images.length; i2++) {
            const data = this.dpmStore.SED.minimap_images[i2];
            if (data.indexOf("active_storage") !== -1) {
              const res = yield axios$1.get(`${this.$global.apiUrl}/get_media_url?type=minimap_images&file_id=${data.split(":")[1]}`).catch((_err) => {
              });
              if (res && res.data) {
                this.dpmStore.global.minimap.data[i2].url = res.data.url;
              }
            }
          }
        }
      });
    }
  },
  computed: __spreadProps(__spreadValues({}, mapStores(matterportStore, useDpmStore, useCilbeeStore)), {
    routeLines() {
      var _a2;
      this.connectedAnotherFloorSweeps.splice(0);
      const renderedLines = [];
      const routeLines = [];
      if (this.cilbeeStore.currentPassableArea) {
        (_a2 = Object.keys(this.cilbeeStore.currentPassableAreaFloorSweeps(this.selectedFloorSequence))) == null ? void 0 : _a2.forEach((startingSweepSid) => {
          const connectedSweepSids = this.cilbeeStore.currentPassableAreaFloorSweeps(this.selectedFloorSequence)[startingSweepSid];
          connectedSweepSids.forEach((connectedSweepSid) => {
            const isRenderedLine = renderedLines.find((pair) => pair.includes(startingSweepSid) && pair.includes(connectedSweepSid));
            if (!isRenderedLine) {
              const point1 = this.minimapSweepsOfSelectedFloor.find((sweep) => sweep.sid === startingSweepSid);
              const point2 = this.minimapSweepsOfSelectedFloor.find((sweep) => sweep.sid === connectedSweepSid);
              if (!point1 || !point2) {
                if (this.cilbeeStore.showSelectedOnly && this.dpmStore.cilbeeEditor.rootSweep.sid !== startingSweepSid && this.dpmStore.cilbeeEditor.rootSweep.sid !== connectedSweepSid) {
                  return;
                }
                this.connectedAnotherFloorSweeps.push(startingSweepSid);
                this.connectedAnotherFloorSweeps.push(connectedSweepSid);
                return;
              }
              if (this.cilbeeStore.showSelectedOnly && this.dpmStore.cilbeeEditor.rootSweep.sid !== startingSweepSid) {
                return;
              }
              routeLines.push(createRouteLine(this.width, point1, point2, "#d63030"));
              renderedLines.push([startingSweepSid, connectedSweepSid]);
            }
          });
        });
      }
      return routeLines;
    },
    defaultSweeps() {
      const customedSweeps = this.dpmStore.SED.sweeps.filter((sweep) => sweep.icon && sweep.icon.id);
      if (customedSweeps.length && !this.dpmStore.cilbeeEditor.visible) {
        return this.minimapSweepsOfSelectedFloor.filter((sweep) => !customedSweeps.find((customedSweep) => customedSweep.sid === sweep.sid));
      } else {
        return this.minimapSweepsOfSelectedFloor;
      }
    },
    sweepButtonSize() {
      return 12 * 0.75;
    },
    currentPointSize() {
      return 12 * 1.2;
    },
    minimapSweepsOfSelectedFloor() {
      const sweeps = Object.values(this.dpmStore.global.sweeps).filter((sweep) => sweep.floorInfo.sequence === this.selectedFloorSequence);
      return sweeps.map((sweep) => {
        return {
          sid: sweep.sid,
          top: this.getZPos(this.dpmStore.global.minimap.data[this.selectedFloorSequence], sweep.position.z),
          right: this.getXPos(this.dpmStore.global.minimap.data[this.selectedFloorSequence], sweep.position.x)
        };
      });
    },
    groupedSweepsOfselectedFloor() {
      return this.dpmStore.SED.sweep_groups.map((sweepGroup) => {
        return this.minimapSweepsOfSelectedFloor.filter((sweep) => sweepGroup.sweeps.includes(sweep.sid));
      });
    },
    checkActiveGroup() {
      return (sid) => {
        return this.dpmStore.sweepEditor.activeGroupIndex !== void 0 && this.dpmStore.SED.sweep_groups[this.dpmStore.sweepEditor.activeGroupIndex].sweeps.includes(sid);
      };
    }
  })
};
const __cssModules$c = {};
var __component__$c = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$c,
  render$c,
  staticRenderFns$c,
  false,
  __vue2_injectStyles$c,
  null,
  null,
  null
);
function __vue2_injectStyles$c(context) {
  for (let o in __cssModules$c) {
    this[o] = __cssModules$c[o];
  }
}
const sweepSelector = /* @__PURE__ */ function() {
  return __component__$c.exports;
}();
var render$b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "p-3 df"
  }, [_c("div", {
    staticClass: "group-info flex-grow-1 pr-3"
  }, [_c("v-text-field", {
    attrs: {
      "label": "グループ名",
      "rules": [_vm.$global.rules.required]
    },
    model: {
      value: _vm.dpmStore.currentEditSweepGroup.name,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditSweepGroup, "name", $$v);
      },
      expression: "dpmStore.currentEditSweepGroup.name"
    }
  })], 1), _c("div", {
    staticClass: "group-color"
  }, [!_vm.dpmStore.currentEditSweepGroup.colorless ? _c("v-color-picker", {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "swatches": _vm.$global.swatches,
      "show-swatches": "",
      "width": "350px"
    },
    model: {
      value: _vm.dpmStore.currentEditSweepGroup.color,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditSweepGroup, "color", $$v);
      },
      expression: "dpmStore.currentEditSweepGroup.color"
    }
  }) : _vm._e(), _c("v-checkbox", {
    staticClass: "mb-3",
    attrs: {
      "label": "カラーを設定しない",
      "hide-details": ""
    },
    model: {
      value: _vm.dpmStore.currentEditSweepGroup.colorless,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditSweepGroup, "colorless", $$v);
      },
      expression: "dpmStore.currentEditSweepGroup.colorless"
    }
  })], 1)]);
};
var staticRenderFns$b = [];
const __vue2_script$b = {
  data: () => ({}),
  created() {
  },
  methods: {},
  computed: __spreadValues({}, mapStores(useDpmStore))
};
const __cssModules$b = {};
var __component__$b = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$b,
  render$b,
  staticRenderFns$b,
  false,
  __vue2_injectStyles$b,
  null,
  null,
  null
);
function __vue2_injectStyles$b(context) {
  for (let o in __cssModules$b) {
    this[o] = __cssModules$b[o];
  }
}
const GroupInfoTab = /* @__PURE__ */ function() {
  return __component__$b.exports;
}();
var render$a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("v-dialog", {
    attrs: {
      "content-class": "sweep-group-editor-modal dpm-modal",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: _vm.dpmStore.sweepEditor.groupEditorVisible,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.sweepEditor, "groupEditorVisible", $$v);
      },
      expression: "dpmStore.sweepEditor.groupEditorVisible"
    }
  }, [_c("v-card", [_c("v-card-title", [_vm._v("スウィープグループを編集")]), _c("v-card-text", [_c("v-tabs", {
    attrs: {
      "fixed-tabs": ""
    },
    model: {
      value: _vm.activeTab,
      callback: function($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_c("v-tab", [_vm._v("グループ情報")]), _c("v-tab", [_vm._v("拡張")])], 1), _c("v-divider"), _c("v-tabs-items", {
    model: {
      value: _vm.activeTab,
      callback: function($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_c("v-tab-item", [_c("GroupInfoTab")], 1), _c("v-tab-item", [_c("DpmExtensionEditTab", {
    attrs: {
      "dpmData": [],
      "targetSid": _vm.dpmStore.sweepEditor.activeGroupIndex,
      "useBy": "sweep"
    }
  })], 1)], 1)], 1), _c("v-divider"), _c("v-card-actions", [_c("v-btn", {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.deleteGroup
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v("このグループを削除")], 1), _c("v-btn", {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary",
      "disabled": !_vm.dpmStore.currentEditSweepGroup.name
    },
    on: {
      "click": function($event) {
        _vm.dpmStore.sweepEditor.groupEditorVisible = false;
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))]), _vm._v("閉じる")], 1)], 1)], 1)], 1);
};
var staticRenderFns$a = [];
const __vue2_script$a = {
  components: { GroupInfoTab, DpmExtensionEditTab },
  data() {
    return {
      activeTab: 0
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    deleteGroup() {
      const check = confirm("削除してよろしいですか？");
      if (check) {
        this.dpmStore.sweepEditor.groupEditorVisible = false;
        this.dpmStore.SED.sweep_groups = this.dpmStore.SED.sweep_groups.filter((group) => group !== this.dpmStore.currentEditSweepGroup);
        this.dpmStore.sweepEditor.activeGroupIndex = void 0;
      }
    }
  },
  computed: __spreadValues({}, mapStores(useDpmStore))
};
const __cssModules$a = {};
var __component__$a = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$a,
  render$a,
  staticRenderFns$a,
  false,
  __vue2_injectStyles$a,
  null,
  null,
  null
);
function __vue2_injectStyles$a(context) {
  for (let o in __cssModules$a) {
    this[o] = __cssModules$a[o];
  }
}
const groupEditorModal = /* @__PURE__ */ function() {
  return __component__$a.exports;
}();
var render$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("v-row", {
    staticClass: "p-3 group-tab-item"
  }, [_c("v-col", {
    attrs: {
      "cols": "8"
    }
  }, [_c("sweepSelector")], 1), _c("v-col", {
    attrs: {
      "cols": "4"
    }
  }, [_c("div", {
    staticClass: "group-editor"
  }, [_c("div", {
    staticClass: "h5"
  }, [_vm._v("スウィープグループを追加・グループにスウィープを追加")]), _c("div", {
    staticClass: "df"
  }, [_c("v-text-field", {
    attrs: {
      "placeholder": "グループ名を入力して下さい"
    },
    model: {
      value: _vm.newGroupName,
      callback: function($$v) {
        _vm.newGroupName = $$v;
      },
      expression: "newGroupName"
    }
  }), _c("v-btn", {
    staticClass: "mt-3 ms-2",
    attrs: {
      "disabled": !_vm.newGroupName
    },
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("グループを追加")])], 1), _c("v-chip-group", {
    staticClass: "sweep-group-list",
    attrs: {
      "active-class": "primary--text",
      "column": ""
    },
    model: {
      value: _vm.dpmStore.sweepEditor.activeGroupIndex,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.sweepEditor, "activeGroupIndex", $$v);
      },
      expression: "dpmStore.sweepEditor.activeGroupIndex"
    }
  }, _vm._l(_vm.dpmStore.SED.sweep_groups, function(sweepGroup, i2) {
    return _c("v-chip", {
      key: `sweep-group-${i2}`,
      staticClass: "sweep-group",
      attrs: {
        "filter": "",
        "close": "",
        "close-icon": _vm.$global.icons.mdiPencil,
        "color": sweepGroup.colorless ? "black" : sweepGroup.color,
        "text-color": sweepGroup.colorless ? "black" : "white",
        "outlined": sweepGroup.colorless
      },
      on: {
        "click:close": function($event) {
          _vm.dpmStore.sweepEditor.activeGroupIndex = i2;
          _vm.dpmStore.sweepEditor.groupEditorVisible = true;
        }
      }
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(sweepGroup.name))])]);
  }), 1)], 1)]), _vm.dpmStore.sweepEditor.groupEditorVisible ? _c("groupEditorModal") : _vm._e()], 1);
};
var staticRenderFns$9 = [];
const __vue2_script$9 = {
  components: { sweepSelector, groupEditorModal },
  data: () => ({
    newGroupName: ""
  }),
  created() {
  },
  methods: {
    addGroup() {
      this.dpmStore.SED.sweep_groups.push({
        name: this.newGroupName,
        sweeps: [],
        colorless: false,
        color: "#ff0000",
        extension: null
      });
      this.newGroupName = "";
      this.dpmStore.sweepEditor.activeGroupIndex = this.dpmStore.SED.sweep_groups.length - 1;
    }
  },
  computed: __spreadValues({}, mapStores(useDpmStore))
};
const __cssModules$9 = {};
var __component__$9 = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$9,
  render$9,
  staticRenderFns$9,
  false,
  __vue2_injectStyles$9,
  null,
  null,
  null
);
function __vue2_injectStyles$9(context) {
  for (let o in __cssModules$9) {
    this[o] = __cssModules$9[o];
  }
}
const groupTab = /* @__PURE__ */ function() {
  return __component__$9.exports;
}();
var render$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.dpmStore.sweepEditor.selectedSweep ? _c("v-dialog", {
    attrs: {
      "content-class": "sweep-single-editor-modal dpm-modal",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: _vm.dpmStore.sweepEditor.singleEditorVisible,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.sweepEditor, "singleEditorVisible", $$v);
      },
      expression: "dpmStore.sweepEditor.singleEditorVisible"
    }
  }, [_c("v-card", [_c("v-card-title", [_vm._v("スウィープ単体を編集")]), _c("v-card-text", [_c("v-row", [_c("v-col", [_c("v-text-field", {
    staticClass: "mb-2",
    attrs: {
      "prepend-inner-icon": _vm.$global.icons.mdiMagnify,
      "label": "アイコン検索",
      "outlined": "",
      "hide-details": "",
      "dense": ""
    },
    on: {
      "input": _vm.filterIcons
    }
  }), _c("v-virtual-scroll", {
    attrs: {
      "bench": "1",
      "items": _vm.presetIconRows,
      "height": "300",
      "item-height": "32"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "df"
        }, _vm._l(item, function(key) {
          return _c("div", {
            directives: [{
              name: "ripple",
              rawName: "v-ripple"
            }],
            staticClass: "mattertag-icon p-2 df align-items-center justify-content-center flex-column",
            on: {
              "click": function($event) {
                return _vm.onChangeIcon(key);
              }
            }
          }, [_c("v-tooltip", {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(_ref2) {
                var on2 = _ref2.on;
                return [_c("v-icon", _vm._g({}, on2), [_vm._v(_vm._s(_vm.$global.icons[key]))])];
              }
            }], null, true)
          }, [_c("span", [_vm._v(_vm._s(key))])])], 1);
        }), 0)];
      }
    }], null, false, 650326207)
  })], 1), _c("v-col", [_vm.dpmStore.currentEditSweep ? _c("div", [!_vm.dpmStore.currentEditSweep.colorless ? _c("v-color-picker", {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "swatches": _vm.$global.swatches,
      "show-swatches": "",
      "width": "350px"
    },
    model: {
      value: _vm.dpmStore.currentEditSweep.bgColor,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditSweep, "bgColor", $$v);
      },
      expression: "dpmStore.currentEditSweep.bgColor"
    }
  }) : _vm._e(), _c("v-checkbox", {
    staticClass: "mb-3",
    attrs: {
      "label": "カラーを設定しない",
      "hide-details": ""
    },
    model: {
      value: _vm.dpmStore.currentEditSweep.colorless,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditSweep, "colorless", $$v);
      },
      expression: "dpmStore.currentEditSweep.colorless"
    }
  }), _c("span", [_vm._v("※グループカラーが設定してある場合はグループカラーになります。")])], 1) : _vm._e()])], 1)], 1), _c("v-divider"), _c("v-card-actions", {
    staticClass: "justify-content-end"
  }, [_c("v-btn", {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dpmStore.sweepEditor.singleEditorVisible = false;
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))]), _vm._v("閉じる")], 1)], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns$8 = [];
const __vue2_script$8 = {
  data: () => ({
    pressetIconKeys: []
  }),
  created() {
    this.pressetIconKeys = Object.keys(this.$global.icons);
  },
  methods: {
    filterIcons(query2) {
      this.pressetIconKeys = Object.keys(this.$global.icons).filter((key) => key.search(new RegExp(query2, "i")) !== -1);
    },
    onChangeIcon(key) {
      if (!this.dpmStore.sweepEditor.selectedSweep) {
        return;
      }
      if (this.dpmStore.currentEditSweep) {
        this.dpmStore.currentEditSweep.icon = key;
      }
    }
  },
  computed: __spreadProps(__spreadValues({}, mapStores(useDpmStore)), {
    presetIconRows() {
      return _chunk(this.pressetIconKeys, 8);
    }
  })
};
const __cssModules$8 = {};
var __component__$8 = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$8,
  render$8,
  staticRenderFns$8,
  false,
  __vue2_injectStyles$8,
  null,
  null,
  null
);
function __vue2_injectStyles$8(context) {
  for (let o in __cssModules$8) {
    this[o] = __cssModules$8[o];
  }
}
const singleEditorModal = /* @__PURE__ */ function() {
  return __component__$8.exports;
}();
var render$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("v-row", {
    staticClass: "p-3 single-tab-item"
  }, [_c("v-col", [_c("sweepSelector")], 1), _c("v-col", [_vm.dpmStore.sweepEditor.activeTab === 1 ? _c("div", [_c("h6", {
    staticClass: "mb-3"
  }, [_vm._v("スウィーププレビュー"), _vm.dpmStore.sweepEditor.selectedSweep && _vm.dpmStore.checkSweepIconChenged(_vm.dpmStore.sweepEditor.selectedSweep.sid) ? _c("v-btn", {
    staticClass: "ms-2",
    attrs: {
      "small": "",
      "color": "error"
    },
    on: {
      "click": _vm.resetIcon
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v("編集データを削除")], 1) : _vm._e()], 1), _vm.dpmStore.sweepEditor.selectedSweep ? _c("div", {
    staticClass: "single-editor"
  }, [_c("div", {
    staticClass: "preview-wrapper"
  }, [_c("div", {
    staticClass: "icon-preview df justify-content-center align-items-center",
    style: `transform: rotate(${_vm.dpmStore.currentEditSweep.degree}deg)`,
    domProps: {
      "innerHTML": _vm._s(_vm.preview)
    }
  })]), _c("v-row", {
    staticClass: "degree-editor mt-2"
  }, [_c("v-col", {
    attrs: {
      "cols": "10"
    }
  }, [_c("v-slider", {
    staticClass: "slider",
    attrs: {
      "label": "角度調整",
      "max": "360",
      "min": "0"
    },
    model: {
      value: _vm.dpmStore.currentEditSweep.degree,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditSweep, "degree", $$v);
      },
      expression: "dpmStore.currentEditSweep.degree"
    }
  })], 1), _c("v-col", [_c("v-text-field", {
    staticClass: "input",
    attrs: {
      "type": "number",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.dpmStore.currentEditSweep.degree,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditSweep, "degree", $$v);
      },
      expression: "dpmStore.currentEditSweep.degree"
    }
  })], 1)], 1), _c("v-row", [_c("v-col", {
    staticClass: "icon-editor"
  }, [_c("h6", {
    staticClass: "mb-3"
  }, [_vm._v("アイコン変更")]), _c("v-text-field", {
    staticClass: "mb-2",
    attrs: {
      "prepend-inner-icon": _vm.$global.icons.mdiMagnify,
      "label": "アイコン検索",
      "outlined": "",
      "hide-details": "",
      "dense": ""
    },
    on: {
      "input": _vm.filterIcons
    }
  }), _c("v-virtual-scroll", {
    attrs: {
      "bench": "1",
      "items": _vm.presetIconRows,
      "height": "160",
      "item-height": "32"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "df"
        }, _vm._l(item, function(key) {
          return _c("div", {
            directives: [{
              name: "ripple",
              rawName: "v-ripple"
            }],
            staticClass: "mattertag-icon p-2 df align-items-center justify-content-center flex-column",
            on: {
              "click": function($event) {
                return _vm.onChangeIcon(key);
              }
            }
          }, [_c("v-tooltip", {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(_ref2) {
                var on2 = _ref2.on;
                return [_c("v-icon", _vm._g({}, on2), [_vm._v(_vm._s(_vm.$global.icons[key]))])];
              }
            }], null, true)
          }, [_c("span", [_vm._v(_vm._s(key))])])], 1);
        }), 0)];
      }
    }], null, false, 650326207)
  }), _c("v-color-picker", {
    staticClass: "icon mt-2",
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "width": "240px"
    },
    model: {
      value: _vm.dpmStore.currentEditSweep.icon.color,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditSweep.icon, "color", $$v);
      },
      expression: "dpmStore.currentEditSweep.icon.color"
    }
  })], 1), _c("v-col", {
    staticClass: "background-editor"
  }, [_c("h6", {
    staticClass: "mb-3"
  }, [_vm._v("背景色変更")]), !_vm.dpmStore.currentEditSweep.colorless ? _c("v-color-picker", {
    staticClass: "background",
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "swatches": _vm.$global.swatches,
      "show-swatches": "",
      "width": "350px"
    },
    model: {
      value: _vm.dpmStore.currentEditSweep.bgColor,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditSweep, "bgColor", $$v);
      },
      expression: "dpmStore.currentEditSweep.bgColor"
    }
  }) : _vm._e(), _c("v-checkbox", {
    staticClass: "toggle-color mb-3",
    attrs: {
      "label": "カラーを設定しない",
      "hide-details": ""
    },
    model: {
      value: _vm.dpmStore.currentEditSweep.colorless,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.currentEditSweep, "colorless", $$v);
      },
      expression: "dpmStore.currentEditSweep.colorless"
    }
  }), _c("span", [_vm._v("※グループカラーが設定してある場合はグループカラーになります。")])], 1)], 1)], 1) : _c("p", [_vm._v("編集するスウィープを選択して下さい")])]) : _vm._e()]), _c("singleEditorModal")], 1);
};
var staticRenderFns$7 = [];
const __vue2_script$7 = {
  components: { sweepSelector, singleEditorModal },
  data: () => ({
    pressetIconKeys: []
  }),
  created() {
    this.pressetIconKeys = Object.keys(this.$global.icons);
  },
  methods: {
    createCustomIconPreview() {
      return `<img src='${this.dpmStore.currentEditSweep.icon.url}' />`;
    },
    createDefaultIconPreview() {
      return this.$global.utils.SVG.createDefaultSweepSvgTag(6);
    },
    createPresetIconPreview() {
      return this.$global.utils.SVG.createSweepSvgTag(
        this.dpmStore.currentEditSweep.icon,
        this.dpmStore.currentEditSweep.colorless ? "#00000000" : this.dpmStore.currentEditSweep.bgColor
      );
    },
    filterIcons(query2) {
      this.pressetIconKeys = Object.keys(this.$global.icons).filter((key) => key.search(new RegExp(query2, "i")) !== -1);
    },
    onChangeIcon(key) {
      if (!this.dpmStore.sweepEditor.selectedSweep) {
        return;
      }
      if (this.dpmStore.currentEditSweep) {
        this.dpmStore.currentEditSweep.icon.id = key;
      }
    },
    resetIcon() {
      const check = confirm("Sweepのアイコン編集データを削除しますか？");
      if (check) {
        this.dpmStore.SED.sweeps = this.dpmStore.SED.sweeps.filter((sweep) => sweep !== this.dpmStore.currentEditSweep);
        this.dpmStore.sweepEditor.selectedSweep = null;
      }
    }
  },
  computed: __spreadProps(__spreadValues({}, mapStores(useDpmStore)), {
    customIconRows() {
      return _chunk(this.registeredCustomIconData, 5);
    },
    presetIconRows() {
      return _chunk(this.pressetIconKeys, 6);
    },
    useCustomIcon() {
      return this.dpmStore.currentEditSweep.icon && this.dpmStore.currentEditSweep.icon.url;
    },
    useDefaultIcon() {
      return !this.useCustomIcon() && !this.usePresetIcon();
    },
    usePresetIcon() {
      return this.dpmStore.currentEditSweep.icon && this.dpmStore.currentEditSweep.icon.id && !this.dpmStore.currentEditSweep.icon.url;
    },
    preview() {
      if (this.dpmStore.currentEditSweep.icon.id || !this.dpmStore.currentEditSweep.colorless) {
        return this.createPresetIconPreview();
      } else {
        return this.createDefaultIconPreview();
      }
    }
  })
};
const __cssModules$7 = {};
var __component__$7 = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$7,
  render$7,
  staticRenderFns$7,
  false,
  __vue2_injectStyles$7,
  null,
  null,
  null
);
function __vue2_injectStyles$7(context) {
  for (let o in __cssModules$7) {
    this[o] = __cssModules$7[o];
  }
}
const singleTab = /* @__PURE__ */ function() {
  return __component__$7.exports;
}();
var render$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("v-dialog", {
    attrs: {
      "content-class": "sweep-editor-modal dpm-modal",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: _vm.dpmStore.sweepEditor.visible,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.sweepEditor, "visible", $$v);
      },
      expression: "dpmStore.sweepEditor.visible"
    }
  }, [_c("v-card", [_c("v-card-title", [_vm._v("スウィープを編集")]), _c("v-tabs", {
    attrs: {
      "grow": ""
    },
    model: {
      value: _vm.activeTab,
      callback: function($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_c("v-tab", [_vm._v("グループ")]), _c("v-tab", [_vm._v("色・アイコン設定")])], 1), _c("v-divider"), _c("v-card-text", [_c("v-tabs-items", {
    model: {
      value: _vm.activeTab,
      callback: function($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_c("v-tab-item", [_c("groupTab")], 1), _c("v-tab-item", [_c("singleTab")], 1)], 1)], 1), _c("v-divider"), _c("v-card-actions", {
    staticClass: "justify-content-end"
  }, [_c("v-btn", {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.closeSweepEditor
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))]), _vm._v("閉じる")], 1)], 1)], 1)], 1);
};
var staticRenderFns$6 = [];
const __vue2_script$6 = {
  components: { groupTab, singleTab },
  data() {
    return {
      activeTab: 0,
      ui: {}
    };
  },
  watch: {
    activeTab() {
      this.dpmStore.sweepEditor.activeGroupIndex = void 0;
      this.dpmStore.sweepEditor.selectedSweep = null;
      this.dpmStore.sweepEditor.activeTab = this.activeTab;
    }
  },
  created() {
    this.dpmStore.sweepEditor.activeTab = this.activeTab;
  },
  methods: {
    closeSweepEditor() {
      this.dpmStore.sweepEditor.visible = false;
      this.dpmStore.SED.sweeps = this.dpmStore.SED.sweeps.filter((sweep) => sweep.icon && sweep.icon.id);
    }
  },
  computed: __spreadValues({}, mapStores(useDpmStore))
};
const __cssModules$6 = {};
var __component__$6 = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$6,
  render$6,
  staticRenderFns$6,
  false,
  __vue2_injectStyles$6,
  null,
  null,
  null
);
function __vue2_injectStyles$6(context) {
  for (let o in __cssModules$6) {
    this[o] = __cssModules$6[o];
  }
}
const sweepEditor = /* @__PURE__ */ function() {
  return __component__$6.exports;
}();
var render$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("v-dialog", {
    attrs: {
      "content-class": "animate__animated animate__faster sweep-editor-modal dpm-modal",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: _vm.dpmStore.cilbeeEditor.visible,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.cilbeeEditor, "visible", $$v);
      },
      expression: "dpmStore.cilbeeEditor.visible"
    }
  }, [_c("v-card", [_c("v-card-title", [_vm._v("スウィープの繋がりを編集")]), _c("v-divider"), _c("v-card-text", [_c("v-tabs", {
    attrs: {
      "grow": ""
    },
    on: {
      "change": _vm.onTabChange
    },
    model: {
      value: _vm.currentTab,
      callback: function($$v) {
        _vm.currentTab = $$v;
      },
      expression: "currentTab"
    }
  }, [_c("v-tab", [_vm._v("経路")]), _c("v-tab", [_vm._v("テキスト")])], 1), _c("v-divider"), _c("v-tabs-items", {
    model: {
      value: _vm.currentTabItem,
      callback: function($$v) {
        _vm.currentTabItem = $$v;
      },
      expression: "currentTabItem"
    }
  }, [_c("v-tab-item", [_c("div", {
    staticClass: "df"
  }, [_vm.cilbeeStore.currentPassableArea ? _c("sweepSelector") : _vm._e(), _c("div", {
    staticClass: "m-3 flex-grow-1"
  }, [_c("div", {
    staticClass: "passable-area-list"
  }, [_c("div", {
    staticClass: "h6"
  }, [_vm._v("新しい通路タイプを追加")]), _c("v-text-field", {
    model: {
      value: _vm.newPassableAreaName,
      callback: function($$v) {
        _vm.newPassableAreaName = $$v;
      },
      expression: "newPassableAreaName"
    }
  }), _c("v-btn", {
    staticClass: "me-3 mb-3",
    attrs: {
      "disabled": !_vm.newPassableAreaName || _vm.cilbeeStore.currentPassableArea && !_vm.cilbeeStore.currentPassableArea.name
    },
    on: {
      "click": function($event) {
        return _vm.addPaasableArea(false);
      }
    }
  }, [_vm._v("通路タイプを追加")]), _vm.cilbeeStore.currentPassableArea ? _c("v-btn", {
    staticClass: "mb-3",
    attrs: {
      "disabled": _vm.cilbeeStore.currentPassableArea && !_vm.cilbeeStore.currentPassableArea.name
    },
    on: {
      "click": function($event) {
        return _vm.addPaasableArea(true);
      }
    }
  }, [_vm._v("現在の通路タイプのデータをコピーして追加")]) : _vm._e(), _c("div", [_c("v-btn", {
    attrs: {
      "disabled": !_vm.newPassableAreaName || _vm.cilbeeStore.currentPassableArea && !_vm.cilbeeStore.currentPassableArea.name
    },
    on: {
      "click": _vm.importPaasableArea
    }
  }, [_vm._v("matterport公式の近接sweepのデータで自動生成")]), _c("div", {
    staticClass: "text-caption"
  }, [_vm._v("※自動生成されたルートは正確ではありません。適宜修正が必要となります。")])], 1), _vm.cilbeeStore.currentPassableArea ? _c("div", {
    staticClass: "df flex-column mt-8"
  }, [_c("div", {
    staticClass: "h6"
  }, [_vm._v("編集中の通路タイプ")]), _c("div", {
    staticClass: "df"
  }, [_c("v-text-field", {
    staticClass: "mb-1",
    attrs: {
      "rules": [_vm.$global.rules.required]
    },
    model: {
      value: _vm.cilbeeStore.currentPassableArea.name,
      callback: function($$v) {
        _vm.$set(_vm.cilbeeStore.currentPassableArea, "name", $$v);
      },
      expression: "cilbeeStore.currentPassableArea.name"
    }
  }), _c("v-btn", {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.deleteSeletedPassableArea
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v("削除")], 1)], 1), _c("div", {
    staticClass: "df"
  }, [_c("draggable", {
    attrs: {
      "list": _vm.cilbeeStore.passableAreas
    },
    on: {
      "start": _vm.dragStart,
      "end": _vm.dragEnd
    }
  }, _vm._l(_vm.cilbeeStore.passableAreas, function(passableArea, i2) {
    return _c("v-chip", {
      key: `passableArea-${i2}`,
      staticClass: "me-3",
      attrs: {
        "color": i2 === _vm.cilbeeStore.currentPassableAreaIndex ? "primary" : "",
        "close": "",
        "close-icon": `${passableArea.visible ? _vm.$global.icons.mdiEye : _vm.$global.icons.mdiEyeOff}`,
        "disabled": _vm.cilbeeStore.currentPassableArea && !_vm.cilbeeStore.currentPassableArea.name
      },
      on: {
        "click": function($event) {
          return _vm.changeCurrentPassableArea(i2);
        },
        "click:close": function($event) {
          passableArea.visible = !passableArea.visible;
        }
      }
    }, [_vm._v(_vm._s(passableArea.name))]);
  }), 1)], 1), _c("div", {
    staticClass: "df"
  }, [_c("v-checkbox", {
    attrs: {
      "hide-details": "",
      "label": "選択中のスウィープのルートのみ表示する"
    },
    model: {
      value: _vm.cilbeeStore.showSelectedOnly,
      callback: function($$v) {
        _vm.$set(_vm.cilbeeStore, "showSelectedOnly", $$v);
      },
      expression: "cilbeeStore.showSelectedOnly"
    }
  })], 1), _c("div", {
    staticClass: "df"
  }, [_c("v-checkbox", {
    attrs: {
      "hide-details": "",
      "label": "起点スウィープを固定"
    },
    model: {
      value: _vm.cilbeeStore.fixRootSweep,
      callback: function($$v) {
        _vm.$set(_vm.cilbeeStore, "fixRootSweep", $$v);
      },
      expression: "cilbeeStore.fixRootSweep"
    }
  })], 1)]) : _vm._e()], 1)])], 1)]), _c("v-tab-item", [_c("div", {
    staticClass: "df align-items-center mt-3"
  }, [_c("span", {
    staticClass: "me-3"
  }, [_vm._v("編集中の言語")]), _c("span", [_c("v-chip-group", {
    attrs: {
      "mandatory": "",
      "active-class": "primary--text"
    },
    on: {
      "change": _vm.changeLanguage
    },
    model: {
      value: _vm.cilbeeStore.selectedLanguage,
      callback: function($$v) {
        _vm.$set(_vm.cilbeeStore, "selectedLanguage", $$v);
      },
      expression: "cilbeeStore.selectedLanguage"
    }
  }, _vm._l(_vm.languages, function(language) {
    return _c("v-chip", {
      key: language,
      attrs: {
        "filter": "",
        "filter-icon": _vm.$global.icons.mdiCheck
      }
    }, [_vm._v(_vm._s(language))]);
  }), 1)], 1)]), _c("div", {
    staticClass: "h6 my-3"
  }, [_vm._v("経路が見付からなかった時の文言")]), _c("v-textarea", {
    model: {
      value: _vm.dpmStore.SED.cilbee.noResultText[_vm.languages[_vm.cilbeeStore.selectedLanguage]],
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.SED.cilbee.noResultText, _vm.languages[_vm.cilbeeStore.selectedLanguage], $$v);
      },
      expression: "dpmStore.SED.cilbee.noResultText[languages[cilbeeStore.selectedLanguage]]"
    }
  }), _c("v-divider"), _c("div", {
    staticClass: "h6 my-3"
  }, [_vm._v("案内終了後の文言")]), _c("quillEditor", {
    attrs: {
      "useBy": "cilbee"
    }
  })], 1)], 1)], 1), _c("v-divider"), _c("v-card-actions", {
    staticClass: "justify-content-end"
  }, [_c("v-btn", {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary",
      "disabled": _vm.cilbeeStore.currentPassableArea && !_vm.cilbeeStore.currentPassableArea.name
    },
    on: {
      "click": _vm.closeCilbeeEditor
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))]), _vm._v("閉じる")], 1)], 1)], 1)], 1);
};
var staticRenderFns$5 = [];
const __vue2_script$5 = {
  components: { sweepSelector, draggable, quillEditor },
  data() {
    return {
      currentTab: 0,
      currentTabItem: 0,
      dragging: false,
      isShakeModal: false,
      languages: ["en-US", "en", "ja", "ko", "zh-CN", "zh-TW"],
      newPassableAreaName: ""
    };
  },
  created() {
  },
  methods: {
    changeLanguage(index2) {
      this.cilbeeStore.$patch({ selectedLanguage: index2 });
    },
    closeCilbeeEditor() {
      this.dpmStore.cilbeeEditor.visible = false;
      this.dpmStore.SED.cilbee.passableAreas = this.cilbeeStore.passableAreas;
    },
    deleteSeletedPassableArea() {
      const check = confirm("編集中の通路タイプを削除しますか？");
      if (check) {
        this.cilbeeStore.passableAreas.splice(this.cilbeeStore.currentPassableAreaIndex, 1);
        this.cilbeeStore.currentPassableAreaIndex = 0;
      }
    },
    changeCurrentPassableArea(index2) {
      this.cilbeeStore.currentPassableAreaIndex = index2;
      if (!this.cilbeeStore.currentPassableAreaFloorSweeps(this.dpmStore.cilbeeEditor.rootSweep.floor)[this.dpmStore.cilbeeEditor.rootSweep.sid]) {
        this.$set(this.cilbeeStore.currentPassableAreaFloorSweeps(this.dpmStore.cilbeeEditor.rootSweep.floor), this.dpmStore.cilbeeEditor.rootSweep.sid, []);
      }
    },
    addPaasableArea(copy) {
      if (copy) {
        this.cilbeeStore.passableAreas.push({
          name: this.newPassableAreaName || `${this.cilbeeStore.currentPassableArea.name} コピー`,
          area: _clone$1(this.cilbeeStore.currentPassableArea.area),
          visible: this.cilbeeStore.currentPassableArea.visible
        });
      } else {
        const areaObject = {};
        for (let i2 = 0; i2 < Object.keys(this.dpmStore.global.floors).length; i2++) {
          areaObject[i2] = {};
        }
        this.cilbeeStore.passableAreas.push({
          name: this.newPassableAreaName,
          area: areaObject,
          visible: true
        });
      }
      this.newPassableAreaName = "";
      this.cilbeeStore.currentPassableAreaIndex = this.cilbeeStore.passableAreas.length - 1;
      if (this.dpmStore.cilbeeEditor.rootSweep && !this.cilbeeStore.currentPassableAreaFloorSweeps(this.dpmStore.current.floor.sequence)[this.dpmStore.cilbeeEditor.rootSweep.sid]) {
        this.$set(this.cilbeeStore.currentPassableAreaFloorSweeps(this.dpmStore.current.floor.sequence), this.dpmStore.cilbeeEditor.rootSweep.sid, []);
      }
    },
    dragStart(_data) {
      this.dragging = true;
    },
    dragEnd(data) {
      this.dragging = false;
      if (data.oldIndex === this.cilbeeStore.currentPassableAreaIndex) {
        this.cilbeeStore.currentPassableAreaIndex = data.newIndex;
      } else if (data.oldIndex > this.cilbeeStore.currentPassableAreaIndex && data.newIndex <= this.cilbeeStore.currentPassableAreaIndex) {
        this.cilbeeStore.currentPassableAreaIndex += 1;
      } else if (data.oldIndex < this.cilbeeStore.currentPassableAreaIndex && data.newIndex >= this.cilbeeStore.currentPassableAreaIndex) {
        this.cilbeeStore.currentPassableAreaIndex -= 1;
      }
    },
    importPaasableArea() {
      const areaObject = {};
      for (let i2 = 0; i2 < Object.keys(this.dpmStore.global.floors).length; i2++) {
        areaObject[i2] = {};
      }
      Object.keys(this.dpmStore.global.sweeps).forEach((key) => {
        const sweep = this.dpmStore.global.sweeps[key];
        if (sweep.floorInfo.sequence > 0) {
          areaObject[sweep.floorInfo.sequence][key] = sweep.neighbors;
        }
      });
      this.cilbeeStore.passableAreas.push({
        name: this.newPassableAreaName,
        area: areaObject,
        visible: true
      });
      this.newPassableAreaName = "";
      this.cilbeeStore.currentPassableAreaIndex = this.cilbeeStore.passableAreas.length - 1;
    },
    onTabChange(_e) {
      if (this.cilbeeStore.currentPassableArea && !this.cilbeeStore.currentPassableArea.name) {
        this.$nextTick(() => {
          this.isShakeModal = true;
          const modal = document.querySelector(".sweep-editor-modal.animate__animated");
          modal.classList.add("animate__shakeX");
          setTimeout(() => {
            modal.classList.remove("animate__shakeX");
          }, 500);
          this.currentTab = this.currentTabItem;
        });
      } else {
        this.currentTabItem = this.currentTab;
      }
    }
  },
  computed: __spreadValues({}, mapStores(useDpmStore, useCilbeeStore))
};
const __cssModules$5 = {};
var __component__$5 = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$5,
  render$5,
  staticRenderFns$5,
  false,
  __vue2_injectStyles$5,
  null,
  null,
  null
);
function __vue2_injectStyles$5(context) {
  for (let o in __cssModules$5) {
    this[o] = __cssModules$5[o];
  }
}
const cilbeeEditor = /* @__PURE__ */ function() {
  return __component__$5.exports;
}();
var baseUniq = _baseUniq;
function uniq(array) {
  return array && array.length ? baseUniq(array) : [];
}
var uniq_1 = uniq;
const _uniq = /* @__PURE__ */ getDefaultExportFromCjs(uniq_1);
var render$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "rounded m-3 mt-16 pe-auto position-absolute",
    style: `max-height: ${_vm.matterportStore.iframeSize.height - 48}px`,
    attrs: {
      "id": "dpm-showcase-editor"
    }
  }, [_c("v-list", {
    class: {
      "in-add-mode": _vm.tagAddMode || _vm.noteMode || _vm.fixPositionMode || _vm.tagDuplicateMode
    },
    style: `max-height: ${_vm.matterportStore.iframeSize.height - 244}px`
  }, [_c("v-list-group", {
    attrs: {
      "prepend-icon": _vm.$global.icons.mdiMapMarker
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c("v-list-item-title", [_vm._v("Tag")])];
      },
      proxy: true
    }])
  }, [_vm.dpmStore.global.mattertags ? _c("v-list-item", {
    staticClass: "p-3"
  }, [_c("div", {
    staticClass: "w-100"
  }, [_vm.dpmStore.global.enableExtensions && _vm.dpmStore.global.enableExtensions.mattertag ? _c("v-btn", {
    staticClass: "mb-4",
    class: {
      "in-add-mode-off": _vm.tagAddMode
    },
    attrs: {
      "block": "",
      "color": `${_vm.tagAddMode ? "primary" : "lightgray"}`
    },
    on: {
      "click": _vm.toggleTagAddMode
    }
  }, [_vm.tagAddMode ? [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiCheck))]), _vm._v("終了")] : [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiPlus))]), _vm._v("タグ追加・追加タグの移動")]], 2) : _vm._e(), _vm.tagAddMode ? [_c("div", {
    staticClass: "df justify-content-between my-4 pe-auto in-add-mode-off"
  }, [_c("v-btn", {
    attrs: {
      "color": `${_vm.tagMoveMode ? "lightgray" : "success"}`
    },
    on: {
      "click": function($event) {
        _vm.tagMoveMode = false;
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiPlus))]), _vm._v("追加モード")], 1), _c("v-btn", {
    attrs: {
      "color": `${_vm.tagMoveMode ? "success" : "lightgray"}`
    },
    on: {
      "click": function($event) {
        _vm.tagMoveMode = true;
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiArrowExpandAll))]), _vm._v("移動モード")], 1)], 1)] : _vm._e(), _c("v-btn", {
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.dpmStore.$patch({
          mattertagEditor: {
            groupDialogVisible: true
          }
        });
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiPlaylistEdit))]), _vm._v("グループ作成・編集")], 1), _vm.tagDuplicateMode ? _c("v-card", {
    staticClass: "mt-4 in-add-mode-off"
  }, [_c("v-card-text", [_c("div", {
    staticClass: "text-center"
  }, [_vm._v("複製する場所を選択してください")]), _c("v-text-field", {
    staticClass: "mt-4",
    attrs: {
      "label": "次の番号",
      "hide-details": ""
    },
    model: {
      value: _vm.nextDuplicateNumber,
      callback: function($$v) {
        _vm.nextDuplicateNumber = $$v;
      },
      expression: "nextDuplicateNumber"
    }
  }), _c("v-checkbox", {
    attrs: {
      "label": "フロアを指定する",
      "hide-details": ""
    },
    model: {
      value: _vm.useCustomFloorId,
      callback: function($$v) {
        _vm.useCustomFloorId = $$v;
      },
      expression: "useCustomFloorId"
    }
  }), _vm.useCustomFloorId ? _c("v-select", {
    attrs: {
      "items": Object.keys(_vm.dpmStore.global.floors).reverse().map(function(key) {
        return {
          text: _vm.dpmStore.global.floors[key].name,
          value: _vm.dpmStore.global.floors[key].id
        };
      }),
      "hide-details": ""
    },
    model: {
      value: _vm.selectedCustomFloorId,
      callback: function($$v) {
        _vm.selectedCustomFloorId = $$v;
      },
      expression: "selectedCustomFloorId"
    }
  }) : _vm._e(), _c("v-switch", {
    staticClass: "my-4",
    attrs: {
      "label": "タグのデータを全て複製",
      "hide-details": ""
    },
    model: {
      value: _vm.withAllData,
      callback: function($$v) {
        _vm.withAllData = $$v;
      },
      expression: "withAllData"
    }
  }), _c("v-btn", {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.toggleTagDuplicateMode
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiCheck))]), _vm._v("終了")], 1)], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "my-4",
    attrs: {
      "id": "clicked-mattertag"
    }
  }, [_c("v-card", [_c("v-card-text", [_c("h6", [_vm._v("クリックしたタグ")]), _vm.clickedMattertag && !_vm.clickedMattertag.notes ? _c("div", {
    staticClass: "df align-items-center mt-3"
  }, [_c("div", {
    key: _vm.clickedMattertagKey,
    staticClass: "mattertag-icon",
    domProps: {
      "innerHTML": _vm._s(_vm.clickedMattertag.iconSvg)
    }
  }), _c("div", {
    staticClass: "ms-2"
  }, [_c("div", [_c("span", [_vm._v("ラベル:")]), _c("a", {
    staticClass: "clicked-mattertag",
    on: {
      "click": function($event) {
        return _vm.navigateToTag(_vm.clickedMattertag.sid);
      }
    }
  }, [_vm._v(_vm._s(" " + _vm.clickedMattertag.label))])]), _c("div", [_vm._v("SID: " + _vm._s(_vm.clickedMattertag.sid))])]), _vm.dpmStore.global.enableExtensions && _vm.dpmStore.global.enableExtensions.mattertag ? _c("div", {
    staticClass: "ml-auto df"
  }, [!_vm.dpmStore.global.mattertags[_vm.clickedMattertag.sid] ? _c("v-btn", {
    attrs: {
      "icon": "",
      "color": "blue"
    },
    on: {
      "click": _vm.toggleTagDuplicateMode
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiContentCopy))])], 1) : _vm._e(), _c("v-btn", {
    attrs: {
      "icon": "",
      "color": "blue"
    },
    on: {
      "click": function($event) {
        return _vm.openDialog(_vm.clickedMattertag);
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPencil))])], 1)], 1) : _vm._e()]) : _vm._e()])], 1)], 1), _c("div", {
    staticClass: "my-4",
    attrs: {
      "id": "mattertag-list"
    }
  }, [_c("h6", {
    staticClass: "mb-2"
  }, [_vm._v("タグ一覧")]), _c("v-card", [_c("v-text-field", {
    staticClass: "pt-2 px-3 pb-3",
    attrs: {
      "prepend-inner-icon": _vm.$global.icons.mdiMagnify,
      "label": "ラベル検索",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: _vm.search,
      callback: function($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c("v-data-table", {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.mattertagList,
      "items-per-page": -1,
      "group-by": "floor",
      "hide-default-footer": "",
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "item.label",
      fn: function(_ref) {
        var item = _ref.item;
        return [_c("a", {
          on: {
            "click": function($event) {
              return _vm.navigateToTag(item.sid);
            }
          }
        }, [_vm._v(_vm._s(item.label))])];
      }
    }, {
      key: "item.textEdited",
      fn: function(_ref2) {
        var item = _ref2.item;
        return [_vm.isTextEdited(item.sid) ? _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiFileDocumentEdit))]) : _vm._e()];
      }
    }, {
      key: "item.iconEdited",
      fn: function(_ref3) {
        var item = _ref3.item;
        return [_vm.isIconEdited(item.sid) ? _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiCircleEditOutline))]) : _vm._e()];
      }
    }, {
      key: "item.icon",
      fn: function(_ref4) {
        var item = _ref4.item;
        return [_c("div", {
          staticStyle: {
            "width": "30px",
            "height": "30px"
          },
          domProps: {
            "innerHTML": _vm._s(item.icon)
          }
        })];
      }
    }, {
      key: "item.edit",
      fn: function(_ref5) {
        var item = _ref5.item;
        return [_vm.dpmStore.global.enableExtensions && _vm.dpmStore.global.enableExtensions.mattertag ? _c("v-btn", {
          attrs: {
            "icon": "",
            "color": "blue"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(item.data);
            }
          }
        }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPencil))])], 1) : _vm._e()];
      }
    }, {
      key: "item.data",
      fn: function(_ref6) {
        var item = _ref6.item;
        return [_vm.dpmStore.isAddedMattertag(item.sid) ? _c("v-btn", {
          attrs: {
            "icon": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(item.sid);
            }
          }
        }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiTrashCan))])], 1) : _vm._e()];
      }
    }], null, false, 3644391262)
  })], 1)], 1)], 2)]) : _c("div", {
    staticClass: "p-3 text-center"
  }, [_c("v-progress-circular", {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)], 1), _vm.dpmStore.global.enableExtensions && _vm.dpmStore.global.enableExtensions.mattertag ? _c("v-list-group", {
    attrs: {
      "prepend-icon": _vm.$global.icons.mdiNote
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c("v-list-item-title", [_vm._v("Chat")])];
      },
      proxy: true
    }], null, false, 3252760729)
  }, [_c("v-list-item", {
    staticClass: "p-3"
  }, [_c("div", {
    staticClass: "w-100"
  }, [_c("v-btn", {
    class: {
      "in-add-mode-off": _vm.noteMode
    },
    attrs: {
      "block": "",
      "color": `${_vm.noteMode ? "primary" : "lightgray"}`
    },
    on: {
      "click": _vm.toggleNoteMode
    }
  }, [_vm.noteMode ? [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiCheck))]), _vm._v("終了")] : [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiPlus))]), _vm._v("chat追加・移動")]], 2), _c("div", {
    staticClass: "my-4",
    attrs: {
      "id": "clicked-note"
    }
  }, [_c("v-card", [_c("v-card-text", [_c("h6", [_vm._v("クリックしたチャット")]), _vm.clickedMattertag && _vm.clickedMattertag.notes ? _c("div", {
    staticClass: "df align-items-center mt-3"
  }, [_c("div", {
    key: _vm.clickedMattertagKey,
    staticClass: "mattertag-icon",
    domProps: {
      "innerHTML": _vm._s(_vm.clickedMattertag.iconSvg)
    }
  }), _c("div", {
    staticClass: "ms-2"
  }, [_c("div", [_c("span", [_vm._v("ラベル:")]), _c("a", {
    staticClass: "clicked-mattertag",
    on: {
      "click": function($event) {
        return _vm.navigateToTag(_vm.clickedMattertag.sid);
      }
    }
  }, [_vm._v(_vm._s(_vm.clickedMattertag.label))])]), _c("div", [_vm._v("SID: " + _vm._s(_vm.clickedMattertag.sid))])]), _vm.dpmStore.global.enableExtensions && _vm.dpmStore.global.enableExtensions.mattertag ? _c("div", {
    staticClass: "ml-auto"
  }, [_c("v-btn", {
    attrs: {
      "icon": "",
      "color": "blue"
    },
    on: {
      "click": function($event) {
        return _vm.openDialog(_vm.clickedMattertag);
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPencil))])], 1)], 1) : _vm._e()]) : _vm._e()])], 1)], 1), _vm.noteMode ? [_c("div", {
    staticClass: "df justify-content-between mt-4 pe-auto in-add-mode-off"
  }, [_c("v-btn", {
    attrs: {
      "color": `${_vm.tagMoveMode ? "lightgray" : "success"}`
    },
    on: {
      "click": function($event) {
        _vm.tagMoveMode = false;
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiPlus))]), _vm._v("追加モード")], 1), _c("v-btn", {
    attrs: {
      "color": `${_vm.tagMoveMode ? "success" : "lightgray"}`
    },
    on: {
      "click": function($event) {
        _vm.tagMoveMode = true;
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiArrowExpandAll))]), _vm._v("移動モード")], 1)], 1)] : _vm._e(), _c("div", {
    staticClass: "my-4",
    attrs: {
      "id": "note-list"
    }
  }, [_c("h6", {
    staticClass: "mb-2"
  }, [_vm._v("Chat 一覧")]), _c("v-card", [_c("v-text-field", {
    staticClass: "pt-2 px-3 pb-3",
    attrs: {
      "prepend-inner-icon": _vm.$global.icons.mdiMagnify,
      "label": "ラベル検索",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: _vm.noteSearch,
      callback: function($$v) {
        _vm.noteSearch = $$v;
      },
      expression: "noteSearch"
    }
  }), _c("v-data-table", {
    attrs: {
      "headers": _vm.noteTableHeaders,
      "items": _vm.noteList,
      "items-per-page": -1,
      "group-by": "floor",
      "hide-default-footer": "",
      "search": _vm.noteSearch
    },
    scopedSlots: _vm._u([{
      key: "item.label",
      fn: function(_ref7) {
        var item = _ref7.item;
        return [_c("a", {
          on: {
            "click": function($event) {
              return _vm.navigateToTag(item.sid);
            }
          }
        }, [_vm._v(_vm._s(item.label))])];
      }
    }, {
      key: "item.icon",
      fn: function(_ref8) {
        var item = _ref8.item;
        return [_c("div", {
          staticStyle: {
            "width": "30px",
            "height": "30px"
          },
          domProps: {
            "innerHTML": _vm._s(item.icon)
          }
        })];
      }
    }, {
      key: "item.edit",
      fn: function(_ref9) {
        var item = _ref9.item;
        return [_vm.dpmStore.global.enableExtensions && _vm.dpmStore.global.enableExtensions.mattertag ? _c("v-btn", {
          attrs: {
            "icon": "",
            "color": "blue"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(item.data);
            }
          }
        }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiPencil))])], 1) : _vm._e()];
      }
    }, {
      key: "item.data",
      fn: function(_ref10) {
        var item = _ref10.item;
        return [_c("v-btn", {
          attrs: {
            "icon": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.deleteDialog(item.sid);
            }
          }
        }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiTrashCan))])], 1)];
      }
    }], null, false, 4066576101)
  })], 1)], 1)], 2)])], 1) : _vm._e(), _vm.dpmStore.global.enableExtensions && _vm.dpmStore.global.enableExtensions.sweep ? _c("v-list-group", {
    attrs: {
      "prepend-icon": _vm.$global.icons.mdiCircleOutline
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c("v-list-item-title", [_vm._v("Sweep")])];
      },
      proxy: true
    }], null, false, 3445128851)
  }, [_c("v-list-item", {
    staticClass: "p-3"
  }, [_c("sweepEditor"), _c("v-btn", {
    staticClass: "mt-2",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.dpmStore.sweepEditor.visible = true;
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiPencil))]), _vm._v("スウィープを編集")], 1)], 1)], 1) : _vm._e(), _vm.dpmStore.global.enableExtensions && _vm.dpmStore.global.enableExtensions.cilbee ? _c("v-list-group", {
    attrs: {
      "prepend-icon": _vm.$global.icons.mdiBee
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c("v-list-item-title", [_vm._v("Cilbee")])];
      },
      proxy: true
    }], null, false, 3030675523)
  }, [_c("v-list-item", {
    staticClass: "p-3"
  }, [_c("cilbeeEditor"), _c("v-btn", {
    staticClass: "mt-2",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.dpmStore.cilbeeEditor.visible = true;
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiPencil))]), _vm._v("スウィープの繋がりを編集")], 1)], 1)], 1) : _vm._e(), _c("v-list-group", {
    attrs: {
      "prepend-icon": _vm.$global.icons.mdiPlaylistEdit
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c("v-list-item-title", [_vm._v("UI")])];
      },
      proxy: true
    }])
  }, [_c("v-list-item", {
    staticClass: "p-3"
  }, [_c("uiEditor", {
    attrs: {
      "apiUrl": _vm.$global.apiUrl,
      "sdk": _vm.$global.sdk,
      "showcaseEditorDataMinimapImages": _vm.dpmStore.SED.minimap_images,
      "uiData": _vm.dpmStore.SED.ui
    }
  })], 1)], 1), _c("v-list-group", {
    attrs: {
      "prepend-icon": _vm.$global.icons.mdiWrench
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c("v-list-item-title", [_vm._v("インポートエクスポート")])];
      },
      proxy: true
    }])
  }, [_c("v-list-item", [_c("v-container", {
    staticClass: "py-2"
  }, [_c("v-row", [_c("v-col", {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c("h6", [_vm._v("JSONデータ")])]), _c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("インポートするデータを選択して下さい。"), _c("v-tooltip", {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref11) {
        var on2 = _ref11.on, attrs2 = _ref11.attrs;
        return [_c("v-icon", _vm._g(_vm._b({}, "v-icon", attrs2, false), on2), [_vm._v(_vm._s(_vm.$global.icons.mdiHelpCircle))])];
      }
    }])
  }, [_c("span", [_vm._v("mattertagsは追加でインポートされ、その後位置調整UIが起動します。それ以外のデータは上書き保存されます。")])]), _vm._l(_vm.selectableSEDItems, function(item) {
    return [item !== "sweeps" && item !== "sweep_groups" && item !== "cilbee" ? _c("v-checkbox", {
      key: item,
      attrs: {
        "label": item,
        "dense": "",
        "hide-details": ""
      },
      on: {
        "change": function($event) {
          return _vm.updateSelectedSEDItems($event, item);
        }
      }
    }) : _vm._e()];
  }), _c("v-btn", {
    staticClass: "mt-2",
    attrs: {
      "small": "",
      "block": ""
    },
    on: {
      "click": _vm.selectImportFile
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiImport))]), _vm._v("インポート")], 1), _c("input", {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleImportFileChange
    }
  })], 2), _vm.errorText ? _c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.errorText))])]) : _vm._e(), _c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("v-btn", {
    attrs: {
      "small": "",
      "block": ""
    },
    on: {
      "click": _vm.downloadShowcaseEditorData
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiExport))]), _vm._v("エクスポート")], 1)], 1)], 1), _c("v-divider", {
    staticClass: "my-5"
  }), !_vm.fixPositionMode ? _c("v-row", [_c("v-col", {
    staticClass: "mb-3",
    attrs: {
      "cols": "12"
    }
  }, [_c("v-btn", {
    class: {
      "in-add-mode-off": _vm.fixPositionMode
    },
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.startFixPositionMode(_vm.dpmStore.SED.mattertags);
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiWrench))]), _vm._v("タグの位置角度調整を始める")], 1)], 1)], 1) : _vm._e(), _vm.fixPosition.controller ? _c("div", [_c("v-row", {
    staticClass: "mt-0"
  }, [_c("v-col", {
    attrs: {
      "cols": "6"
    }
  }, [_c("v-btn", {
    class: {
      "in-add-mode-off": _vm.fixPositionMode
    },
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.fixPosition.controller.componentIterator().next().value.inputs.mode = "translate";
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiArrowAll))]), _vm._v("位置")], 1), _c("v-text-field", {
    staticClass: "mt-2",
    class: {
      "in-add-mode-off": _vm.fixPositionMode
    },
    attrs: {
      "type": "number",
      "prefix": "X:",
      "dense": "",
      "step": "0.01",
      "solo": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.updateFixPositionNodeByinputs
    },
    model: {
      value: _vm.fixPosition.position.x,
      callback: function($$v) {
        _vm.$set(_vm.fixPosition.position, "x", _vm._n($$v));
      },
      expression: "fixPosition.position.x"
    }
  }), _c("v-text-field", {
    staticClass: "mt-2",
    class: {
      "in-add-mode-off": _vm.fixPositionMode
    },
    attrs: {
      "type": "number",
      "prefix": "Y:",
      "dense": "",
      "step": "0.01",
      "solo": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.updateFixPositionNodeByinputs
    },
    model: {
      value: _vm.fixPosition.position.y,
      callback: function($$v) {
        _vm.$set(_vm.fixPosition.position, "y", _vm._n($$v));
      },
      expression: "fixPosition.position.y"
    }
  }), _c("v-text-field", {
    staticClass: "mt-2",
    class: {
      "in-add-mode-off": _vm.fixPositionMode
    },
    attrs: {
      "type": "number",
      "prefix": "Z:",
      "dense": "",
      "step": "0.01",
      "solo": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.updateFixPositionNodeByinputs
    },
    model: {
      value: _vm.fixPosition.position.z,
      callback: function($$v) {
        _vm.$set(_vm.fixPosition.position, "z", _vm._n($$v));
      },
      expression: "fixPosition.position.z"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "6"
    }
  }, [_c("v-btn", {
    class: {
      "in-add-mode-off": _vm.fixPositionMode
    },
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.fixPosition.controller.componentIterator().next().value.inputs.mode = "rotate";
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiSync))]), _vm._v("角度")], 1), _c("v-text-field", {
    staticClass: "mt-2",
    class: {
      "in-add-mode-off": _vm.fixPositionMode
    },
    attrs: {
      "type": "number",
      "prefix": "Y:",
      "dense": "",
      "min": "0",
      "max": "360",
      "step": "1",
      "solo": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.updateFixPositionNodeByinputs
    },
    model: {
      value: _vm.fixPosition.rotation.y,
      callback: function($$v) {
        _vm.$set(_vm.fixPosition.rotation, "y", _vm._n($$v));
      },
      expression: "fixPosition.rotation.y"
    }
  })], 1)], 1), _c("v-row", {
    staticClass: "mb-2"
  }, [_c("v-col", {
    staticClass: "pt-0",
    attrs: {
      "cols": "7"
    }
  }, [_c("v-btn", {
    class: {
      "in-add-mode-off": _vm.fixPositionMode
    },
    attrs: {
      "color": "primary",
      "block": ""
    },
    on: {
      "click": _vm.confirmPositionFix
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiCheck))]), _vm._v("調整を確定")], 1)], 1), _c("v-col", {
    staticClass: "pt-0",
    attrs: {
      "cols": "5"
    }
  }, [_c("v-btn", {
    class: {
      "in-add-mode-off": _vm.fixPositionMode
    },
    attrs: {
      "block": "",
      "color": "warning"
    },
    on: {
      "click": _vm.resetForFixPositionMode
    }
  }, [_vm._v("キャンセル")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _c("v-list-group", {
    attrs: {
      "prepend-icon": _vm.$global.icons.mdiInformation
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c("v-list-item-title", [_vm._v("Info")])];
      },
      proxy: true
    }])
  }, [_c("v-list-item", {
    staticClass: "p-3"
  }, [_c("div", {
    staticClass: "w-100"
  }, [_c("div", {
    staticClass: "h5"
  }, [_vm._v("カメラ情報")]), _c("div", {
    staticClass: "my-2"
  }, [_c("div", {
    staticClass: "h6"
  }, [_vm._v("現在地")]), _vm._v("x: " + _vm._s(_vm.dpmStore.current.pose ? _vm.dpmStore.current.pose.position.x : "")), _c("br"), _vm._v("y: " + _vm._s(_vm.dpmStore.current.pose ? _vm.dpmStore.current.pose.position.y : "")), _c("br"), _vm._v("z: " + _vm._s(_vm.dpmStore.current.pose ? _vm.dpmStore.current.pose.position.z : ""))]), _c("div", [_c("div", {
    staticClass: "h6"
  }, [_vm._v("向き")]), _vm._v("x: " + _vm._s(_vm.dpmStore.current.pose ? _vm.dpmStore.current.pose.rotation.x : "")), _c("br"), _vm._v("y: " + _vm._s(_vm.dpmStore.current.pose ? _vm.dpmStore.current.pose.rotation.y : ""))]), _c("h5", {
    staticClass: "mt-3"
  }, [_vm._v("Sweep情報")]), _c("div", {
    staticClass: "mb-3"
  }, [_vm._v("現在のSweep: " + _vm._s(_vm.dpmStore.current.sweep ? _vm.dpmStore.current.sweep.sid : ""))]), _c("v-divider", {
    staticClass: "my-4"
  }), _c("div", [_c("div", {
    staticClass: "h5"
  }, [_vm._v("Showcase Editor + Minimap Data")]), _c("v-btn", {
    staticClass: "mt-3",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.onDownload
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiDownload))]), _vm._v("編集データのダウンロード")], 1), _c("div", {
    staticClass: "h6 mt-3 mb-2"
  }, [_vm._v("Objectsのみ")]), _c("v-textarea", {
    attrs: {
      "outlined": "",
      "label": "JSON",
      "hide-details": "",
      "value": JSON.stringify(_vm.dpmStore.SED.objects)
    },
    on: {
      "input": _vm.onChangeObjects
    }
  }), _c("v-btn", {
    staticClass: "mt-2",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.onCopyObjects
    }
  }, [_c("v-icon", {
    staticClass: "me-1"
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiContentCopy))]), _vm._v("コピー")], 1), _c("p", {
    staticClass: "text-danger mb-0",
    class: {
      "d-none": !_vm.objectsErrorText
    }
  }, [_vm._v(_vm._s(_vm.objectsErrorText))]), _c("div", {
    staticClass: "h6 mt-3 mb-2"
  }, [_vm._v("SED直接編集（要注意）")]), _c("v-textarea", {
    attrs: {
      "outlined": "",
      "label": "JSON",
      "hide-details": "",
      "value": JSON.stringify(_vm.dpmStore.SED)
    },
    on: {
      "input": _vm.onChangeSed
    }
  })], 1)], 1)])], 1), _c("mattertagGroupEditor"), _c("mattertagEditModal")], 1)], 1);
};
var staticRenderFns$4 = [];
const __vue2_script$4 = {
  components: { mattertagEditModal, mattertagGroupEditor, uiEditor, sweepEditor, cilbeeEditor },
  data() {
    return {
      clickedMattertag: null,
      clickedMattertagKey: 0,
      currentPointer: {},
      errorText: null,
      fixPosition: {
        node: null,
        controller: null,
        selection: null,
        position: { x: 0, y: 0, z: 0 },
        rotation: { x: 0, y: 0, z: 0 }
      },
      fixPositionMode: false,
      headers: [
        { text: "階", value: "floor", sortable: false },
        { text: "ラベル or SID", value: "label", groupable: false },
        { text: "", value: "textEdited", groupable: false, sortable: false },
        { text: "", value: "iconEdited", groupable: false, sortable: false },
        { text: "", value: "icon", groupable: false, sortable: false },
        { text: "", value: "edit", groupable: false, sortable: false },
        { text: "", value: "data", groupable: false, sortable: false }
      ],
      importMode: false,
      isDragging: false,
      mattertagErrorText: null,
      mattertagList: [],
      nextDuplicateNumber: 0,
      noteTableHeaders: [
        { text: "階", value: "floor", sortable: false },
        { text: "ラベル or SID", value: "label", groupable: false },
        { text: "", value: "icon", groupable: false, sortable: false },
        { text: "", value: "edit", groupable: false, sortable: false },
        { text: "", value: "data", groupable: false, sortable: false }
      ],
      noteList: [],
      noteMode: false,
      noteSearch: "",
      objectsErrorText: null,
      pendingData: null,
      search: "",
      selectableSEDItems: ["mattertags", "mattertag_groups", "sweeps", "sweep_groups", "objects", "minimap_images", "minimap_rotate", "cilbee", "ui"],
      selectedSEDItems: {
        mattertags: false,
        mattertag_groups: false,
        sweeps: false,
        sweep_groups: false,
        objects: false,
        selectedCustomFloorId: null,
        minimap_images: false,
        minimap_rotate: false,
        cilbee: false,
        ui: false
      },
      tagAddMode: false,
      tagDuplicateMode: false,
      tagMoveMode: false,
      useCustomFloorId: false,
      withAllData: false
    };
  },
  created() {
    return __async(this, null, function* () {
      this.$global.sdk.on(this.$global.sdk.Mattertag.Event.CLICK, (tagSid) => __async(this, null, function* () {
        var _a2;
        if (this.tagMoveMode && ((_a2 = this.clickedMattertag) == null ? void 0 : _a2.sid) === tagSid) {
          this.clickedMattertag = null;
        } else {
          this.updateClickedMattertag(tagSid);
        }
      }));
      yield this.initializeList();
      this.dpmStore.$subscribe((mutation, _state) => __async(this, null, function* () {
        var _a2, _b2;
        if (mutation.type.includes("patch") && ((_b2 = (_a2 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _a2.mattertagEditor) == null ? void 0 : _b2.tagChanged)) {
          yield this.initializeList();
          yield this.applyDataToShowcase();
          this.dpmStore.mattertagEditor.tagChanged = false;
        }
      }));
      this.$global.sdk.Tag.data.subscribe({
        onAdded: (id, item, _collection) => __async(this, null, function* () {
          var _a2;
          if (this.tagAddMode || this.noteMode || this.tagDuplicateMode) {
            let extensionData = null;
            if (this.tagDuplicateMode && ((_a2 = this.clickedMattertag.extension) == null ? void 0 : _a2.type)) {
              extensionData = {
                type: this.clickedMattertag.extension.type,
                data: { autoPlayVideo: true, floatingPosition: null, autoPlayAudio: true, useAsBgm: false, images: [], video: null, audio: null, htmlText: null }
              };
              if (this.withAllData) {
                extensionData.data = this.clickedMattertag.extension.data;
              }
            }
            const tagData = Object.assign(item, { sid: id });
            const commonData = Object.assign({
              label: JSON.parse(JSON.stringify(item.label)),
              description: JSON.parse(JSON.stringify(item.description)),
              anchorPosition: JSON.parse(JSON.stringify(item.anchorPosition)),
              stemVector: JSON.parse(JSON.stringify(item.stemVector ? item.stemVector : { x: 0, y: 0, z: 0 })),
              stemHeight: JSON.parse(JSON.stringify(item.stemHeight ? item.stemHeight : 0.3)),
              stemVisible: JSON.parse(JSON.stringify(item.stemVisible ? item.stemVisible : true)),
              roomId: this.dpmStore.calcCurrentRoomId(new Vector3(item.anchorPosition.x, item.anchorPosition.y, item.anchorPosition.z), null, item),
              extension: extensionData || null
            }, { sid: id });
            if (this.useCustomFloorId) {
              commonData.floorId = this.selectedCustomFloorId;
            } else {
              commonData.floorId = this.dpmStore.current.floor.id;
              Object.values(this.dpmStore.global.floors).forEach((floor) => {
                if (floor.sequence === this.currentPointer.floorId) {
                  commonData.floorId = floor.id;
                }
              });
            }
            if (this.tagAddMode) {
              this.dpmStore.SED.mattertags.push(Object.assign({ icon: { color: JSON.parse(JSON.stringify(item.color)), id: null, url: null, activeStorageId: null } }, commonData));
            } else if (this.tagDuplicateMode) {
              this.dpmStore.SED.mattertags.push(Object.assign({ icon: this.clickedMattertag.icon }, commonData));
            } else {
              this.dpmStore.SED.mattertags.push(
                Object.assign({ icon: { color: JSON.parse(JSON.stringify(item.color)), id: "mdiNote-#FFFFFF-circle-#FF0000", url: null, activeStorageId: null }, notes: [] }, commonData)
              );
            }
            const icon = yield this.dpmStore.createIcon(this.$global.apiUrl, id);
            if (this.tagAddMode || this.tagDuplicateMode) {
              this.mattertagList.push({ floor: this.dpmStore.current.floor.name, label: JSON.parse(JSON.stringify(item.label)), sid: id, icon, data: tagData });
            } else {
              this.noteList.push({ floor: this.dpmStore.current.floor.name, label: JSON.parse(JSON.stringify(item.label)), sid: id, icon, data: tagData });
            }
            if (!this.tagDuplicateMode) {
              this.dpmStore.getUngroupedGroup.mattertags.push({ sid: id, visible: true });
            } else {
              for (const group of this.dpmStore.SED.mattertag_groups) {
                for (const tag of group.mattertags) {
                  if (tag.sid === this.clickedMattertag.sid) {
                    group.mattertags.push({ sid: id, visible: true });
                    break;
                  }
                }
              }
            }
            this.dpmStore.$patch({ mattertagEditor: { tagChanged: true } });
            if (!this.tagDuplicateMode) {
              this.updateClickedMattertag(id);
            }
          }
        }),
        onCollectionUpdated: (collection) => {
          this.dpmStore.$patch({ global: { displayedMattertagSids: Object.keys(collection) } });
        }
      });
      this.$global.sdk.Pointer.intersection.subscribe((intersectionData) => {
        this.$set(this.currentPointer, "position", intersectionData.position);
        this.$set(this.currentPointer, "normal", intersectionData.normal);
        this.$set(this.currentPointer, "object", intersectionData.object);
        this.$set(this.currentPointer, "floorId", intersectionData.floorId);
      });
      this.$global.sdk.Mode.current.subscribe((mode) => {
        var _a2;
        if ((_a2 = this.fixPosition) == null ? void 0 : _a2.controller) {
          if (mode === "mode.floorplan") {
            this.fixPosition.controller.componentIterator().next().value.inputs.size = 0.01;
          } else {
            this.fixPosition.controller.componentIterator().next().value.inputs.size = 1;
          }
        }
      });
      const target2 = document.querySelector("iframe#showcase").contentWindow.document.querySelector("canvas");
      target2.addEventListener("pointerdown", () => this.isDragging = false);
      target2.addEventListener("pointermove", () => this.isDragging = true);
      target2.addEventListener("pointerup", () => __async(this, null, function* () {
        var _a2;
        if (this.isDragging || !this.tagAddMode && !this.noteMode && !this.tagDuplicateMode || this.currentPointer.object !== "intersectedobject.model") {
          this.isDragging = false;
          return;
        }
        this.isDragging = false;
        if (!this.tagMoveMode) {
          let newLabel = "New tag";
          if (this.noteMode) {
            newLabel = "New chat";
          } else if (this.tagDuplicateMode) {
            if (!/\d$/.test(this.clickedMattertag.label)) {
              newLabel = `${this.clickedMattertag.label}_${this.nextDuplicateNumber}`;
            } else {
              newLabel = `${this.clickedMattertag.label.match(/^(.*?)(\d+)$/).slice(1)[0]}${this.nextDuplicateNumber}`;
            }
            this.nextDuplicateNumber = parseInt(this.nextDuplicateNumber, 10) + 1;
          }
          yield this.$global.sdk.Tag.add({
            label: newLabel,
            description: this.tagAddMode ? "This tag was added" : this.noteMode ? "This chat was added" : this.clickedMattertag.description,
            anchorPosition: this.currentPointer.position,
            stemVector: new Vector3(this.currentPointer.normal.x, this.currentPointer.normal.y, this.currentPointer.normal.z).multiplyScalar(0.3),
            color: this.tagAddMode ? { r: 0, g: 0, b: 1 } : this.noteMode ? { r: 1, g: 1, b: 1 } : this.clickedMattertag.icon.color
          });
        }
        if (this.tagMoveMode && ((_a2 = this.clickedMattertag) == null ? void 0 : _a2.sid) && this.clickedMattertag.stemHeight) {
          this.dpmStore.SED.mattertags.forEach((mattertag) => {
            if (mattertag.sid === this.clickedMattertag.sid) {
              mattertag.anchorPosition = __spreadValues({}, this.currentPointer.position);
              mattertag.stemVector = new Vector3(this.currentPointer.normal.x, this.currentPointer.normal.y, this.currentPointer.normal.z).multiplyScalar(mattertag.stemHeight);
            }
          });
          yield this.$global.sdk.Tag.editPosition(this.clickedMattertag.sid, {
            anchorPosition: this.currentPointer.position,
            stemVector: new Vector3(this.currentPointer.normal.x, this.currentPointer.normal.y, this.currentPointer.normal.z).multiplyScalar(this.clickedMattertag.stemHeight)
          });
        }
      }));
    });
  },
  methods: {
    applyDataToShowcase(newData = null) {
      return __async(this, null, function* () {
        try {
          if (newData) {
            this.dpmStore.SED.mattertags = JSON.parse(newData);
          }
          for (const key in this.dpmStore.global.mattertags) {
            const mattertag = this.dpmStore.global.mattertags[key];
            yield this.$global.sdk.Tag.resetIcon(mattertag.sid);
            yield this.$global.sdk.Tag.editColor(mattertag.sid, mattertag.color);
            yield this.$global.sdk.Tag.editBillboard(mattertag.sid, {
              description: mattertag.description,
              // TODO: descriptionが強制的に畳んで表示される様になったので直す必要あり…いつ直すか？が問題だ…
              label: mattertag.label
            });
            yield this.$global.sdk.Tag.editStem(mattertag.sid, { stemHeight: mattertag.stemHeight, stemVisible: mattertag.stemVisible });
            yield this.$global.sdk.Tag.editPosition(mattertag.sid, { anchorPosition: mattertag.anchorPosition, roomId: mattertag.roomId, stemVector: mattertag.stemVector });
          }
          this.mattertagErrorText = null;
        } catch (error2) {
          this.mattertagErrorText = error2;
        }
        for (const mattertag of this.dpmStore.SED.mattertags) {
          try {
            yield this.$global.sdk.Tag.resetIcon(mattertag.sid);
          } catch (error2) {
            this.mattertagErrorText = error2;
          }
        }
        try {
          yield this.$global.utils.editShowcase.applyData(this.$global.sdk);
        } catch (error2) {
          this.mattertagErrorText = error2;
        }
        if (this.clickedMattertag) {
          this.updateClickedMattertag(this.clickedMattertag.sid);
        }
        yield this.setAllowAction();
      });
    },
    confirmPositionFix() {
      return __async(this, null, function* () {
        this.fixPosition.node.obj3D.children[0].children.slice(1).forEach((mesh) => __async(this, null, function* () {
          const newPosition = mesh.getWorldPosition(new Vector3());
          const originData = this.dpmStore.global.mattertags[mesh.sid];
          if (this.importMode) {
            if (mesh.isObject) {
              const data = this.pendingData.objects.payload.objects.find((object) => object.id === mesh.sid);
              data.position = newPosition;
              data.rotation.y += this.fixPosition.rotation.y;
            } else {
              const data = this.pendingData.mattertags.find((mattertag) => mattertag.sid === mesh.sid);
              data.anchorPosition = newPosition;
              data.roomId = this.dpmStore.calcCurrentRoomId(newPosition, originData, data);
              if (!data.stemVector) {
                data.stemVector = this.dpmStore.global.mattertags[mesh.sid].stemVector;
              }
              data.stemVector = new Vector3(data.stemVector.x, data.stemVector.y, data.stemVector.z).applyQuaternion(this.fixPosition.node.obj3D.quaternion);
              if (!this.dpmStore.global.displayedMattertagSids.includes(mesh.sid)) {
                yield this.$global.sdk.Tag.add({
                  // NOTE: ここでaddしておかないとallowActionでエラーが発生する
                  id: data.sid,
                  label: data.label,
                  description: data.description,
                  anchorPosition: data.anchorPosition,
                  stemVector: data.stemVector,
                  color: data.icon.color
                });
              }
            }
          } else {
            const existData = this.dpmStore.SED.mattertags.find((mattertag) => mattertag.sid === mesh.sid);
            if (existData) {
              existData.anchorPosition = newPosition;
              existData.roomId = this.dpmStore.calcCurrentRoomId(newPosition, originData, existData);
              existData.stemVector = new Vector3(existData.stemVector.x, existData.stemVector.y, existData.stemVector.z).applyQuaternion(this.fixPosition.node.obj3D.quaternion);
            } else {
              const targetMattertag = this.dpmStore.global.mattertags[mesh.sid];
              this.dpmStore.SED.mattertags.push({
                label: targetMattertag.label,
                description: targetMattertag.description,
                anchorPosition: newPosition,
                stemVector: new Vector3(targetMattertag.stemVector.x, targetMattertag.stemVector.y, targetMattertag.stemVector.z).applyQuaternion(this.fixPosition.node.obj3D.quaternion),
                stemHeight: targetMattertag.stemHeight,
                stemVisible: targetMattertag.stemVisible,
                roomId: this.dpmStore.calcCurrentRoomId(newPosition, originData),
                extension: null,
                sid: mesh.sid,
                icon: { color: targetMattertag.color, id: null, url: null, activeStorageId: null }
              });
            }
          }
        }));
        if (this.importMode) {
          yield this.copyBlobFiles();
        }
        yield this.applyDataToShowcase();
        this.resetForFixPositionMode();
      });
    },
    copyBlobFiles() {
      return __async(this, null, function* () {
        yield axios$1.post(
          `${this.$global.apiUrl}/copy_blob_files`,
          { showcase_editor_data: JSON.stringify(this.pendingData) },
          { headers: this.$global.csrfHeader }
        ).then((res) => {
          if (res) {
            this.dpmStore.$patch({ showcaseEditorData: res.data.showcase_editor_data });
          }
        }).catch((error2) => {
          console.error("showcaseEditor.vue copyBlobFiles", error2);
          this.errorText = error2.response ? error2.response.data.error : error2;
        });
      });
    },
    deepMergeWithArrayConcat(target2, source) {
      for (const key in source) {
        let srcVal = source[key];
        let tgtVal = target2[key];
        if (Array.isArray(srcVal) && Array.isArray(tgtVal)) {
          let srcUngroupedGroup = srcVal.find((group) => (group == null ? void 0 : group.label) === "ungrouped" && (group == null ? void 0 : group.mattertags));
          let tgtUngroupedGroup = tgtVal.find((group) => (group == null ? void 0 : group.label) === "ungrouped" && (group == null ? void 0 : group.mattertags));
          if (srcUngroupedGroup && tgtUngroupedGroup) {
            tgtUngroupedGroup.mattertags = _uniq(_merge(tgtUngroupedGroup.mattertags, srcUngroupedGroup.mattertags));
            srcVal = srcVal.filter((group) => !((group == null ? void 0 : group.label) === "ungrouped" && (group == null ? void 0 : group.mattertags)));
          }
          target2[key] = tgtVal.concat(srcVal);
        } else if (srcVal && typeof srcVal === "object" && tgtVal && typeof tgtVal === "object") {
          target2[key] = this.deepMergeWithArrayConcat(__spreadValues({}, tgtVal), srcVal);
        } else {
          target2[key] = srcVal;
        }
      }
      return target2;
    },
    deleteDialog(sid) {
      var _a2;
      if (window.confirm("本当に削除しますか？")) {
        const sedIndex = this.dpmStore.SED.mattertags.findIndex((mattertag) => mattertag.sid === sid);
        this.dpmStore.SED.mattertags.splice(sedIndex, 1);
        this.dpmStore.SED.mattertag_groups.forEach((group) => {
          const index2 = group.mattertags.findIndex((mattertag) => mattertag.sid === sid);
          if (index2 !== -1) {
            group.mattertags.splice(index2, 1);
          }
        });
        const listIndex = this.mattertagList.findIndex((mattertag) => mattertag.sid === sid);
        this.mattertagList.splice(listIndex, 1);
        if (((_a2 = this.clickedMattertag) == null ? void 0 : _a2.sid) === sid) {
          this.clickedMattertag = null;
        }
        this.$global.sdk.Tag.remove(sid);
        this.dpmStore.$patch({ mattertagEditor: { tagChanged: true } });
      }
    },
    downloadShowcaseEditorData() {
      return __async(this, null, function* () {
        saveJsonToFile(JSON.stringify(this.dpmStore.showcaseEditorData), `${this.dpmStore.global.modelSid}-exported.json`);
      });
    },
    fixGrayOutSize() {
      this.$nextTick(() => {
        var _a2, _b2;
        loop:
          for (let i2 = document.styleSheets.length - 1; i2 >= 0; i2--) {
            const rules2 = (_a2 = document.styleSheets[i2]) == null ? void 0 : _a2.cssRules;
            for (let j = 0; j < rules2.length; j++) {
              if ((_b2 = rules2[j].selectorText) == null ? void 0 : _b2.includes(".in-add-mode::after")) {
                rules2[j].style.height = `${document.querySelector(".in-add-mode").scrollHeight}px`;
                break loop;
              }
            }
          }
      });
    },
    handleImportFileChange() {
      return __async(this, null, function* () {
        const file = this.$refs.fileInput.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (event) => __async(this, null, function* () {
            var _a2, _b2, _c;
            const data = event.target.result;
            if (data) {
              const jsonData = JSON.parse(data);
              Object.keys(jsonData).forEach((key) => {
                if (!this.selectedSEDItems[key]) {
                  delete jsonData[key];
                }
              });
              this.pendingData = this.deepMergeWithArrayConcat(Object.assign({}, JSON.parse(JSON.stringify(this.dpmStore.showcaseEditorData))), jsonData);
              if (((_a2 = jsonData.mattertags) == null ? void 0 : _a2.length) || typeof jsonData.objects === "object" && jsonData.objects.payload.objects.length) {
                this.importMode = true;
                this.startFixPositionMode(jsonData.mattertags, typeof jsonData.objects === "object" ? jsonData.objects.payload.objects : null);
              } else {
                yield this.copyBlobFiles();
                if (this.dpmStore.SED.objects) {
                  this.dpmStore.global.scene.clearScene();
                  yield this.dpmStore.global.scene.loadObjectsFromShowcaseEditorData(this.dpmStore.SED);
                }
                if (((_b2 = this.pendingData.mattertags) == null ? void 0 : _b2.length) || ((_c = this.pendingData.mattertag_groups) == null ? void 0 : _c.length)) {
                  this.dpmStore.$patch({ mattertagEditor: { tagChanged: true } });
                }
                this.pendingData = null;
              }
            }
          });
          reader.readAsText(file);
          this.$refs.fileInput.value = "";
          this.errorText = null;
        }
      });
    },
    initializeList() {
      return __async(this, null, function* () {
        this.mattertagList.splice(0, this.mattertagList.length);
        this.noteList.splice(0, this.noteList.length);
        this.mattertagList.push(...yield Promise.all(Object.keys(this.dpmStore.global.mattertags).map((tagId) => __async(this, null, function* () {
          var _a2;
          const tag = this.dpmStore.global.mattertags[tagId];
          const icon = yield this.dpmStore.createIcon(this.$global.apiUrl, tagId);
          const floorName = (_a2 = this.dpmStore.getFloorByMattertag(tag)) == null ? void 0 : _a2.name;
          return { floor: floorName ? floorName : "未設定", label: this.dpmStore.getLabel(tagId), sid: tag.sid, icon, data: tag };
        }))));
        yield Promise.all(this.dpmStore.SED.mattertags.map((mattertag) => __async(this, null, function* () {
          const icon = yield this.dpmStore.createIcon(this.$global.apiUrl, mattertag.sid);
          let floorName = this.dpmStore.getFloorByMattertag(mattertag).name;
          const label = this.dpmStore.getLabel(mattertag.sid);
          const originMattertag = this.dpmStore.global.mattertags[mattertag.sid];
          const data = { floor: floorName, label, sid: mattertag.sid, icon, data: mattertag };
          if (originMattertag) {
            const index2 = this.mattertagList.findIndex((tag) => tag.sid === mattertag.sid);
            this.mattertagList.splice(index2, 1, data);
          } else {
            if (mattertag.notes) {
              this.noteList.push(data);
            } else {
              this.mattertagList.push(data);
            }
          }
        })));
      });
    },
    isIconEdited(sid) {
      var _a2;
      const targetIcon = (_a2 = this.dpmStore.SED.mattertags.find((mattertag) => mattertag.sid === sid)) == null ? void 0 : _a2.icon;
      if (targetIcon) {
        if (targetIcon.id || targetIcon.url) {
          return true;
        }
        if (targetIcon.color && (this.dpmStore.global.mattertags[sid] && this.$global.utils.toHex(targetIcon.color) !== this.$global.utils.toHex(this.dpmStore.global.mattertags[sid].color))) {
          return true;
        }
      }
      const targetGroup = this.dpmStore.SED.mattertag_groups.find((group) => group.mattertags.find((mattertag) => mattertag.sid === sid));
      if (targetGroup == null ? void 0 : targetGroup.color) {
        return true;
      }
      return false;
    },
    isTextEdited(sid) {
      var _a2;
      const target2 = this.dpmStore.SED.mattertags.find((mattertag) => mattertag.sid === sid);
      if ((target2 == null ? void 0 : target2.description) && target2.description !== ((_a2 = this.dpmStore.global.mattertags[sid]) == null ? void 0 : _a2.description)) {
        return true;
      }
      return false;
    },
    navigateToTag(sid) {
      return __async(this, null, function* () {
        window.focusedTagSid = sid;
        this.$global.sdk.Mattertag.navigateToTag(sid, this.$global.sdk.Mattertag.Transition.FADEOUT);
        this.updateClickedMattertag(sid);
      });
    },
    // NOTE: 現在JSON部分はコメントアウトされている
    // async onChangeMattertags(newData) {
    //   await this.applyDataToShowcase(newData)
    // },
    onChangeSed(data) {
      return __async(this, null, function* () {
        this.dpmStore.showcaseEditorData = JSON.parse(data);
      });
    },
    onChangeObjects(data) {
      return __async(this, null, function* () {
        try {
          this.dpmStore.SED.objects = JSON.parse(data);
          this.objectsErrorText = null;
          this.dpmStore.global.scene.clearScene();
          yield this.dpmStore.global.scene.loadObjectsFromShowcaseEditorData(this.dpmStore.SED);
        } catch (error2) {
          this.objectsErrorText = error2;
        }
      });
    },
    // NOTE: 現在JSON部分はコメントアウトされている
    // onCopyMattertags() {
    //   if (navigator.clipboard) {
    //     navigator.clipboard.writeText(JSON.stringify(this.dpmStore.SED.mattertags))
    //   }
    // },
    onCopyObjects() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(JSON.stringify(this.dpmStore.SED.objects));
      }
    },
    onDownload() {
      const data = {
        showcase_editor_data: this.dpmStore.showcaseEditorData,
        minimap: this.dpmStore.global.minimap
      };
      saveJsonToFile(JSON.stringify(data), `${this.dpmStore.global.modelSid}.json`);
    },
    openDialog(target2) {
      this.dpmStore.$patch({
        current: { mattertagSid: target2.sid },
        mattertagEditor: { editDialogVisible: true }
      });
    },
    resetForFixPositionMode() {
      return __async(this, null, function* () {
        var _a2, _b2;
        const transformControls = this.fixPosition.controller.componentIterator().next().value.transformControls;
        transformControls.removeEventListener("change", this.transformControlsChangeEvent);
        this.fixPositionMode = false;
        transformControls.detach();
        this.fixPosition.node.stop();
        this.fixPosition.node = null;
        this.fixPosition.controller = null;
        this.fixPosition.position = { x: 0, y: 0, z: 0 };
        this.fixPosition.rotation = { x: 0, y: 0, z: 0 };
        if (this.importMode) {
          if (this.dpmStore.SED.objects) {
            this.dpmStore.global.scene.clearScene();
            yield this.dpmStore.global.scene.loadObjectsFromShowcaseEditorData(this.dpmStore.SED);
          }
          if (((_a2 = this.pendingData.mattertags) == null ? void 0 : _a2.length) || ((_b2 = this.pendingData.mattertag_groups) == null ? void 0 : _b2.length)) {
            this.dpmStore.$patch({ mattertagEditor: { tagChanged: true } });
          }
        }
        this.importMode = false;
        this.pendingData = null;
      });
    },
    selectImportFile() {
      return __async(this, null, function* () {
        this.$refs.fileInput.click();
      });
    },
    setAllowAction() {
      return __async(this, null, function* () {
        const hasExtensionMattertagSids = this.dpmStore.SED.mattertags.filter((mattertag) => mattertag.extension && mattertag.extension.type !== "none").map((mattertag) => mattertag.sid);
        for (const mattertagSid in this.dpmStore.global.mattertags) {
          yield this.$global.sdk.Tag.allowAction(mattertagSid, {
            opening: true,
            navigating: hasExtensionMattertagSids.includes(mattertagSid) ? false : true,
            docking: true,
            sharing: true
          });
        }
        for (const mattertag of this.dpmStore.SED.mattertags) {
          yield this.$global.sdk.Tag.allowAction(mattertag.sid, {
            opening: true,
            navigating: hasExtensionMattertagSids.includes(mattertag.sid) ? false : true,
            docking: true,
            sharing: true
          });
        }
      });
    },
    setPreventAction() {
      return __async(this, null, function* () {
        for (const mattertagSid in this.dpmStore.global.mattertags) {
          yield this.$global.sdk.Tag.allowAction(mattertagSid, {
            opening: false,
            navigating: false,
            docking: false,
            sharing: false
          });
        }
        for (const mattertag of this.dpmStore.SED.mattertags) {
          yield this.$global.sdk.Tag.allowAction(mattertag.sid, {
            opening: false,
            navigating: false,
            docking: false,
            sharing: false
          });
        }
      });
    },
    startFixPositionMode(targets, objects = null) {
      return __async(this, null, function* () {
        this.fixPositionMode = true;
        targets.forEach((mattertag) => {
          if (!mattertag.anchorPosition) {
            mattertag.anchorPosition = this.dpmStore.global.mattertags[mattertag.sid].anchorPosition;
          }
        });
        if (this.importMode) {
          let data = Object.keys(targets).map((sid) => __spreadProps(__spreadValues({}, targets[sid]), { color: targets[sid].icon.color }));
          if (objects == null ? void 0 : objects.length) {
            data = [...data, ...objects.map((object) => ({ sid: object.id, anchorPosition: object.position, color: { r: 1, g: 1, b: 1 }, isObject: true }))];
          }
          this.fixPosition.node = yield this.dpmStore.global.scene.addFixPosition(
            { x: 0, y: 0, z: 0 },
            data
          );
        } else {
          const editedSids = targets.map((mattertag) => mattertag.sid);
          const originSids = Object.keys(this.dpmStore.global.mattertags).filter((sid) => !editedSids.includes(sid));
          this.fixPosition.node = yield this.dpmStore.global.scene.addFixPosition(
            { x: 0, y: 0, z: 0 },
            [...targets.map((mattertag) => __spreadProps(__spreadValues({}, mattertag), { color: mattertag.icon.color })), ...originSids.map((sid) => this.dpmStore.global.mattertags[sid])]
          );
        }
        this.fixPosition.controller = yield this.dpmStore.global.scene.addTransformControls();
        const tcComponent = this.fixPosition.controller.componentIterator().next().value;
        tcComponent.inputs.selection = this.fixPosition.node;
        tcComponent.transformControls.addEventListener("change", this.transformControlsChangeEvent);
        if (this.dpmStore.current.mode === "mode.floorplan") {
          tcComponent.inputs.size = 0.01;
        }
        this.fixGrayOutSize();
      });
    },
    toggleTagDuplicateMode() {
      return __async(this, null, function* () {
        if (!/\d$/.test(this.clickedMattertag.label)) {
          this.nextDuplicateNumber = 1;
        } else {
          this.nextDuplicateNumber = parseInt(this.clickedMattertag.label.match(/^(.*?)(\d+)$/).slice(1)[1], 10) + 1;
        }
        this.tagDuplicateMode = !this.tagDuplicateMode;
        this.selectedCustomFloorId = this.dpmStore.current.floor.id;
        this.useCustomFloorId = false;
        this.withAllData = false;
        this.toggleTagAndSweep(this.tagDuplicateMode);
      });
    },
    toggleNoteMode() {
      return __async(this, null, function* () {
        this.noteMode = !this.noteMode;
        this.tagMoveMode = false;
        this.toggleTagAndSweep(this.noteMode);
      });
    },
    toggleTagAddMode() {
      return __async(this, null, function* () {
        this.tagAddMode = !this.tagAddMode;
        this.tagMoveMode = false;
        this.toggleTagAndSweep(this.tagAddMode);
      });
    },
    toggleTagAndSweep(mode) {
      return __async(this, null, function* () {
        const sweepIds = Object.keys(this.dpmStore.global.sweeps);
        if (mode) {
          this.setPreventAction();
          yield this.$global.sdk.Sweep.disable(...sweepIds);
          this.fixGrayOutSize();
        } else {
          yield this.setAllowAction();
          yield this.$global.sdk.Sweep.enable(...sweepIds);
        }
      });
    },
    transformControlsChangeEvent() {
      const transformControls = this.fixPosition.controller.componentIterator().next().value.transformControls;
      if (transformControls.mode === "rotate") {
        transformControls.showX = false;
        transformControls.showZ = false;
        const quaternion = this.fixPosition.node.obj3D.quaternion;
        const euler = new Euler(0, 0, 0, "YXZ").setFromQuaternion(quaternion);
        this.fixPosition.rotation.y = MathUtils.radToDeg(euler.y);
      } else {
        transformControls.showX = true;
        transformControls.showZ = true;
        this.fixPosition.position.x = this.fixPosition.node.obj3D.position.x;
        this.fixPosition.position.y = this.fixPosition.node.obj3D.position.y;
        this.fixPosition.position.z = this.fixPosition.node.obj3D.position.z;
      }
    },
    updateClickedMattertag(sid) {
      return __async(this, null, function* () {
        if (this.dpmStore.global.mattertags[sid]) {
          this.clickedMattertag = JSON.parse(JSON.stringify(this.dpmStore.global.mattertags[sid]));
        } else if (this.dpmStore.SED.mattertags.find((mattertag) => mattertag.sid === sid)) {
          this.clickedMattertag = JSON.parse(JSON.stringify(this.dpmStore.SED.mattertags.find((mattertag) => mattertag.sid === sid)));
        } else {
          this.clickedMattertag = null;
          return;
        }
        this.clickedMattertag.iconSvg = yield this.dpmStore.createIcon(this.$global.apiUrl, sid);
        this.clickedMattertagKey += 1;
      });
    },
    updateFixPositionNodeByinputs() {
      return __async(this, null, function* () {
        this.fixPosition.node.obj3D.position.x = this.fixPosition.position.x;
        this.fixPosition.node.obj3D.position.y = this.fixPosition.position.y;
        this.fixPosition.node.obj3D.position.z = this.fixPosition.position.z;
        this.fixPosition.node.obj3D.rotation.y = MathUtils.degToRad(this.fixPosition.rotation.y);
      });
    },
    updateSelectedSEDItems(event, item) {
      this.$set(this.selectedSEDItems, item, event);
    }
  },
  computed: __spreadValues({}, mapStores(matterportStore, useDpmStore))
};
const __cssModules$4 = {};
var __component__$4 = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$4,
  render$4,
  staticRenderFns$4,
  false,
  __vue2_injectStyles$4,
  null,
  null,
  null
);
function __vue2_injectStyles$4(context) {
  for (let o in __cssModules$4) {
    this[o] = __cssModules$4[o];
  }
}
const ShowcaseEditor = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
var render$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("v-dialog", {
    attrs: {
      "content-class": "m-3 dpm-shared-link-modal dpm-modal",
      "eager": ""
    },
    model: {
      value: _vm.dpmStore.global.showSharedLink,
      callback: function($$v) {
        _vm.$set(_vm.dpmStore.global, "showSharedLink", $$v);
      },
      expression: "dpmStore.global.showSharedLink"
    }
  }, [_c("v-card", [_c("v-card-title", [_vm._v("共有")]), _c("v-divider"), _c("v-card-text", {
    staticClass: "p-3"
  }, [_c("v-row", [_c("v-col", {
    attrs: {
      "cols": "10"
    }
  }, [_c("v-text-field", {
    attrs: {
      "label": "リンク"
    },
    model: {
      value: _vm.sharedLinkText,
      callback: function($$v) {
        _vm.sharedLinkText = $$v;
      },
      expression: "sharedLinkText"
    }
  })], 1), _c("v-col", {
    attrs: {
      "cols": "2"
    }
  }, [_c("v-btn", {
    attrs: {
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        return _vm.copy(_vm.sharedLinkText);
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiContentCopy))]), _vm._v("コピー")], 1)], 1)], 1), _c("v-expand-transition", [_vm.dpmStore.global.showCilbee ? _c("v-card", {
    staticClass: "df flex-column"
  }, [_c("v-card-title", {
    staticClass: "justify-space-between",
    on: {
      "click": function($event) {
        _vm.showCilbeeLinkList = !_vm.showCilbeeLinkList;
      }
    }
  }, [_c("div", {
    staticClass: "h6"
  }, [_vm._v("Cilbee用URL")]), _c("v-icon", [_vm._v(_vm._s(_vm.showCilbeeLinkList ? _vm.$global.icons.mdiMenuUp : _vm.$global.icons.mdiMenuDown))])], 1), _c("v-expand-transition", [_vm.showCilbeeLinkList && _vm.cilbeeStore.destinations.length ? _c("v-card-text", {
    staticClass: "overflow-y-auto"
  }, _vm._l(_vm.cilbeeStore.destinations, function(destination) {
    return _c("v-row", {
      key: `destination-${destination.sweep.sid}-${destination.mattertagSid}`
    }, [_c("v-col", {
      attrs: {
        "cols": "10"
      }
    }, [_c("v-text-field", {
      attrs: {
        "value": _vm.cilbeeLinkText(destination),
        "label": "リンク"
      }
    })], 1), _c("v-col", {
      attrs: {
        "cols": "2"
      }
    }, [_c("v-btn", {
      attrs: {
        "elevation": "0"
      },
      on: {
        "click": function($event) {
          _vm.copy(_vm.cilbeeLinkText(destination));
        }
      }
    }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiContentCopy))]), _vm._v("コピー")], 1)], 1)], 1);
  }), 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1), _c("v-divider"), _c("v-card-actions", {
    staticClass: "justify-content-end"
  }, [_c("v-btn", {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.close
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))]), _vm._v("閉じる")], 1)], 1)], 1)], 1);
};
var staticRenderFns$3 = [];
const __vue2_script$3 = {
  data() {
    return {
      baseLinkText: "",
      sharedLinkText: "",
      showCilbeeLinkList: false
    };
  },
  created() {
    return __async(this, null, function* () {
      const deepLink = yield this.$global.sdk.Link.createDeepLink();
      const params = {};
      new URL(deepLink).searchParams.forEach((value, key) => {
        if (!["useLegacyIds", "applicationKey", "newtags", "m"].includes(key)) {
          params[key] = value;
        }
      });
      const version2 = document.querySelector("#showcase").dataset.version;
      if (version2) {
        params.version = version2;
      }
      this.baseLinkText = `${new URL(deepLink).origin}${this.dpmStore.global.standalone ? "" : "/show"}?m=${new URL(deepLink).searchParams.get("m")}`;
      this.sharedLinkText = `${this.baseLinkText}&${Object.keys(params).map((key) => `${key}=${params[key]}`).join("&")}`;
    });
  },
  methods: {
    close() {
      this.dpmStore.$patch({ global: { showSharedLink: false } });
    },
    copy(text2) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text2);
      }
    }
  },
  computed: __spreadProps(__spreadValues({}, mapStores(useDpmStore, useCilbeeStore)), {
    cilbeeLinkText() {
      return (destination) => {
        return `${this.baseLinkText}&ss=${this.cilbeeStore.ss}&sweep=${destination.sweep.sid}&mattertag=${destination.mattertagSid}&cilbee=true`;
      };
    }
  })
};
const __cssModules$3 = {};
var __component__$3 = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$3,
  render$3,
  staticRenderFns$3,
  false,
  __vue2_injectStyles$3,
  null,
  null,
  null
);
function __vue2_injectStyles$3(context) {
  for (let o in __cssModules$3) {
    this[o] = __cssModules$3[o];
  }
}
const SharedLinkModal = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !(_vm.matterportStore.dockOpen || _vm.matterportStore.hideDpm) ? _c("div", {
    staticClass: "dpm-trimming-component pe-none"
  }, [_c("div", {
    staticClass: "df pe-auto pb-2",
    attrs: {
      "id": "trimming-always-show-area"
    }
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref) {
        var on2 = _ref.on;
        return [_c("v-btn", _vm._g({
          attrs: {
            "id": "trimming-toggle-btn",
            "fab": "",
            "small": "",
            "elevation": "0",
            "color": "white"
          },
          on: {
            "click": _vm.toggleTrimming
          }
        }, on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiScissorsCutting))])], 1)];
      }
    }], null, false, 890718973)
  }, [_c("span", [_vm._v(_vm._s(_vm.dpmStore.global.showTrimmingEditor ? "閉じる" : "開く"))])])], 1), _c("v-slide-x-reverse-transition", [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dpmStore.global.showTrimmingEditor,
      expression: "dpmStore.global.showTrimmingEditor"
    }],
    staticClass: "dpm-trimming-editor pe-auto",
    staticStyle: {
      "width": "300px"
    }
  }, [_c("v-card", {
    staticClass: "pa-2",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c("v-toolbar", {
    attrs: {
      "flat": "",
      "dense": ""
    }
  }, [_c("v-toolbar-title", {
    staticClass: "text-subtitle-1"
  }, [_vm._v("トリミングエディター")]), _c("v-switch", {
    staticClass: "ms-4",
    attrs: {
      "inset": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.beforeApplyClipping
    },
    model: {
      value: _vm.enableClipping,
      callback: function($$v) {
        _vm.enableClipping = $$v;
      },
      expression: "enableClipping"
    }
  }), _c("v-btn", {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.resetBox
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global ? _vm.$global.icons.mdiRefresh : "mdi-refresh"))])], 1)], 1), _c("v-divider"), _c("v-container", {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c("v-row", {
    attrs: {
      "no-gutters": ""
    }
  }, [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_vm.mounted ? _c("v-card", {
    staticClass: "pa-2 controls-card",
    attrs: {
      "flat": ""
    }
  }, [_c("v-subheader", {
    staticClass: "mb-1",
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_vm._v(_vm._s(_vm.rangeX[0].toFixed(1)) + " 〜 " + _vm._s(_vm.rangeX[1].toFixed(1)))];
      },
      proxy: true
    }], null, false, 2653852910)
  }, [_vm._v("バウンディングボックス(ローカル座標)")]), _c("v-row", {
    staticClass: "axis-row",
    attrs: {
      "no-gutters": ""
    }
  }, [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("v-range-slider", {
    attrs: {
      "min": _vm.rangeLimits.min.x,
      "max": _vm.rangeLimits.max.x,
      "step": "0.01",
      "label": "X",
      "hide-details": ""
    },
    on: {
      "input": _vm.updateFromUI
    },
    model: {
      value: _vm.rangeX,
      callback: function($$v) {
        _vm.rangeX = $$v;
      },
      expression: "rangeX"
    }
  })], 1), _c("div", {
    staticClass: "d-flex align-center justify-center"
  }, [_c("v-text-field", {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "step": "0.01"
    },
    on: {
      "input": _vm.updateFromUI
    },
    model: {
      value: _vm.rangeX[0],
      callback: function($$v) {
        _vm.$set(_vm.rangeX, 0, _vm._n($$v));
      },
      expression: "rangeX[0]"
    }
  }), _c("div", {
    staticClass: "mx-2"
  }, [_vm._v("〜")]), _c("v-text-field", {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "step": "0.01"
    },
    on: {
      "input": _vm.updateFromUI
    },
    model: {
      value: _vm.rangeX[1],
      callback: function($$v) {
        _vm.$set(_vm.rangeX, 1, _vm._n($$v));
      },
      expression: "rangeX[1]"
    }
  })], 1)], 1), _c("v-row", {
    staticClass: "mt-3 axis-row",
    attrs: {
      "no-gutters": ""
    }
  }, [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("v-range-slider", {
    attrs: {
      "min": _vm.rangeLimits.min.y,
      "max": _vm.rangeLimits.max.y,
      "step": "0.01",
      "label": "Y",
      "hide-details": ""
    },
    on: {
      "input": _vm.updateFromUI
    },
    model: {
      value: _vm.rangeY,
      callback: function($$v) {
        _vm.rangeY = $$v;
      },
      expression: "rangeY"
    }
  })], 1), _c("div", {
    staticClass: "d-flex align-center justify-center"
  }, [_c("v-text-field", {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "step": "0.01"
    },
    on: {
      "input": _vm.updateFromUI
    },
    model: {
      value: _vm.rangeY[0],
      callback: function($$v) {
        _vm.$set(_vm.rangeY, 0, _vm._n($$v));
      },
      expression: "rangeY[0]"
    }
  }), _c("div", {
    staticClass: "mx-2"
  }, [_vm._v("〜")]), _c("v-text-field", {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "step": "0.01"
    },
    on: {
      "input": _vm.updateFromUI
    },
    model: {
      value: _vm.rangeY[1],
      callback: function($$v) {
        _vm.$set(_vm.rangeY, 1, _vm._n($$v));
      },
      expression: "rangeY[1]"
    }
  })], 1)], 1), _c("v-row", {
    staticClass: "mt-3 axis-row",
    attrs: {
      "no-gutters": ""
    }
  }, [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("v-range-slider", {
    attrs: {
      "min": _vm.rangeLimits.min.z,
      "max": _vm.rangeLimits.max.z,
      "step": "0.01",
      "label": "Z",
      "hide-details": ""
    },
    on: {
      "input": _vm.updateFromUI
    },
    model: {
      value: _vm.rangeZ,
      callback: function($$v) {
        _vm.rangeZ = $$v;
      },
      expression: "rangeZ"
    }
  })], 1), _c("div", {
    staticClass: "d-flex align-center justify-center"
  }, [_c("v-text-field", {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "step": "0.01"
    },
    on: {
      "input": _vm.updateFromUI
    },
    model: {
      value: _vm.rangeZ[0],
      callback: function($$v) {
        _vm.$set(_vm.rangeZ, 0, _vm._n($$v));
      },
      expression: "rangeZ[0]"
    }
  }), _c("div", {
    staticClass: "mx-2"
  }, [_vm._v("〜")]), _c("v-text-field", {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "type": "number",
      "step": "0.01"
    },
    on: {
      "input": _vm.updateFromUI
    },
    model: {
      value: _vm.rangeZ[1],
      callback: function($$v) {
        _vm.$set(_vm.rangeZ, 1, _vm._n($$v));
      },
      expression: "rangeZ[1]"
    }
  })], 1)], 1), _c("v-divider", {
    staticClass: "my-2"
  }), _c("v-row", {
    attrs: {
      "no-gutters": ""
    }
  }, [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("v-checkbox", {
    attrs: {
      "label": "ボックス枠を表示",
      "hide-details": ""
    },
    on: {
      "change": _vm.toggleHelper
    },
    model: {
      value: _vm.showHelper,
      callback: function($$v) {
        _vm.showHelper = $$v;
      },
      expression: "showHelper"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)])], 1) : _vm._e();
};
var staticRenderFns$2 = [];
let rootScene = null;
let helper = null;
const __vue2_script$2 = {
  name: "TrimingEditorClippingBox",
  data() {
    return {
      three: null,
      renderer: null,
      planes: [],
      enableClipping: false,
      showHelper: true,
      rangeX: [0, 0],
      rangeY: [0, 0],
      rangeZ: [0, 0],
      rangeLimits: {
        max: {
          x: 0,
          y: 0,
          z: 0
        },
        min: {
          x: 0,
          y: 0,
          z: 0
        }
      },
      frameId: null,
      glslReplaceParams: {
        vertexShader: [{
          pattern: "precision highp int;",
          replacement: "\nprecision highp int;\n\n#include <clipping_planes_pars_vertex>\n"
        }, {
          pattern: "void main(){",
          replacement: "\nvoid main(){\nvec4 mvPosition = modelViewMatrix * vec4(position, 1.0);\n"
        }, {
          pattern: "gl_Position=projectedPosition;}",
          replacement: "\n#include <clipping_planes_vertex>\ngl_Position = projectedPosition;\n}"
        }],
        fragmentShader: [{
          pattern: "void main(){",
          replacement: "\n#include <clipping_planes_pars_fragment>\nvoid main(){\n#include <clipping_planes_fragment>\n"
        }]
      },
      mounted: false
    };
  },
  mounted() {
    return __async(this, null, function* () {
      this.mounted = true;
      yield this.initThree();
      this.createPlanes();
      this.applyClipping();
      this.updateHelper();
      this.animateLoop();
    });
  },
  beforeDestroy() {
    cancelAnimationFrame(this.frameId);
  },
  methods: {
    initThree() {
      return __async(this, null, function* () {
        yield this.$global.sdk.Scene.configure((renderer, three) => {
          this.three = three;
          this.renderer = renderer;
        });
        const tmpNode = (yield this.$global.sdk.Scene.createObjects(1))[0].addNode();
        tmpNode.start();
        rootScene = tmpNode.obj3D.parent.parent;
      });
    },
    createPlanes() {
      const box = new this.three.Box3().setFromObject(rootScene.children[2].children[0].children[0]);
      this.rangeX = [box.min.x, box.max.x];
      this.rangeY = [box.min.y, box.max.y];
      this.rangeZ = [box.min.z, box.max.z];
      this.rangeLimits.max = {
        x: box.max.x,
        y: box.max.y,
        z: box.max.z
      };
      this.rangeLimits.min = {
        x: box.min.x,
        y: box.min.y,
        z: box.min.z
      };
      this.planes = [
        new this.three.Plane(new this.three.Vector3(-1, 0, 0), box.max.x),
        // +X 側 (x <= maxX)
        new this.three.Plane(new this.three.Vector3(1, 0, 0), -box.min.x),
        // -X 側 (x >= minX)
        new this.three.Plane(new this.three.Vector3(0, -1, 0), box.max.y),
        // +Y 側
        new this.three.Plane(new this.three.Vector3(0, 1, 0), -box.min.y),
        // -Y 側
        new this.three.Plane(new this.three.Vector3(0, 0, -1), box.max.z),
        // +Z 側
        new this.three.Plane(new this.three.Vector3(0, 0, 1), -box.min.z)
        // -Z 側
      ];
    },
    updatePlaneConstants() {
      const [minX, maxX] = this.rangeX;
      const [minY, maxY] = this.rangeY;
      const [minZ, maxZ] = this.rangeZ;
      if (!this.planes.length)
        return;
      this.planes[0].constant = maxX;
      this.planes[1].constant = -minX;
      this.planes[2].constant = maxY;
      this.planes[3].constant = -minY;
      this.planes[4].constant = maxZ;
      this.planes[5].constant = -minZ;
      this.updateHelper();
    },
    beforeApplyClipping() {
      if (this.enableClipping) {
        this.renderer.localClippingEnabled = true;
        this.addClipping();
      } else {
        this.removeClipping();
        this.renderer.localClippingEnabled = false;
      }
      this.applyClipping();
    },
    applyClipping() {
      if (!this.renderer)
        return;
      if (this.enableClipping) {
        this.showHelper = true;
        this.toggleHelper();
      } else {
        this.showHelper = false;
        this.toggleHelper();
      }
    },
    updateFromUI() {
      this.normalizeRanges();
      this.updatePlaneConstants();
      this.applyClipping();
    },
    normalizeRanges() {
      const fix = (r) => {
        if (r[0] > r[1]) {
          const t3 = r[0];
          r[0] = r[1];
          r[1] = t3;
        }
      };
      fix(this.rangeX);
      fix(this.rangeY);
      fix(this.rangeZ);
    },
    currentBox() {
      return {
        min: { x: this.rangeX[0], y: this.rangeY[0], z: this.rangeZ[0] },
        max: { x: this.rangeX[1], y: this.rangeY[1], z: this.rangeZ[1] }
      };
    },
    setRangesFromBox(box) {
      if (!box)
        return;
      this.rangeX = [box.min.x, box.max.x];
      this.rangeY = [box.min.y, box.max.y];
      this.rangeZ = [box.min.z, box.max.z];
    },
    resetBox() {
      this.rangeX = [this.rangeLimits.min.x, this.rangeLimits.max.x];
      this.rangeY = [this.rangeLimits.min.y, this.rangeLimits.max.y];
      this.rangeZ = [this.rangeLimits.min.z, this.rangeLimits.max.z];
      this.updateFromUI();
    },
    updateHelper() {
      if (!this.showHelper)
        return;
      const boxHelperBox = new this.three.Box3(
        new this.three.Vector3(this.rangeX[0], this.rangeY[0], this.rangeZ[0]),
        new this.three.Vector3(this.rangeX[1], this.rangeY[1], this.rangeZ[1])
      );
      if (!helper) {
        helper = new this.three.Box3Helper(boxHelperBox, 16711880);
        rootScene.add(helper);
      } else {
        helper.box.copy(boxHelperBox);
        helper.updateMatrixWorld(true);
      }
    },
    toggleHelper() {
      if (!helper && this.showHelper) {
        this.updateHelper();
      } else if (helper) {
        helper.visible = this.showHelper;
      }
    },
    isInsideClippingBox(point, planes) {
      return planes.every((plane) => plane.distanceToPoint(point) >= 0);
    },
    addClippingParams(material) {
      if (material.type === "ShaderMaterial") {
        if (material.vertexShader && !material.vertexShader.includes("clipping_planes_pars_vertex")) {
          this.glslReplaceParams.vertexShader.forEach((param) => {
            material.vertexShader = material.vertexShader.replace(param.pattern, param.replacement);
          });
        }
        if (material.fragmentShader && !material.fragmentShader.includes("clipping_planes_pars_fragment")) {
          this.glslReplaceParams.fragmentShader.forEach((param) => {
            material.fragmentShader = material.fragmentShader.replace(param.pattern, param.replacement);
          });
        }
      }
      material.clipping = true;
      material.needsUpdate = true;
    },
    addClipping() {
      rootScene.traverse((child) => {
        var _a2, _b2;
        if (child.name.includes("Skysphere") || ((_a2 = child.parent) == null ? void 0 : _a2.name.includes("mattertag"))) {
          return;
        }
        if ((_b2 = child.material) == null ? void 0 : _b2.length) {
          child.material.forEach((material) => {
            this.addClippingParams(material);
          });
        } else {
          if (child.material) {
            this.addClippingParams(child.material);
          }
        }
      });
    },
    updateClipping() {
      this.planes.map(
        (p) => new this.three.Vector4(p.normal.x, p.normal.y, p.normal.z, p.constant)
      );
      const toggleTagOpacityByCippingBox = (mattertag) => {
        if (this.isInsideClippingBox(mattertag.anchorPosition, this.planes)) {
          this.$global.sdk.Tag.editOpacity(mattertag.sid, 1);
        } else {
          this.$global.sdk.Tag.editOpacity(mattertag.sid, 0);
        }
      };
      for (const mattertagId in this.dpmStore.global.mattertags) {
        toggleTagOpacityByCippingBox(this.dpmStore.global.mattertags[mattertagId]);
      }
      for (const mattertag of this.dpmStore.SED.mattertags) {
        if (mattertag.anchorPosition) {
          toggleTagOpacityByCippingBox(mattertag);
        }
      }
      rootScene.traverse((child) => {
        var _a2, _b2;
        if (child.name.includes("Skysphere") || ((_a2 = child.parent) == null ? void 0 : _a2.name.includes("mattertag"))) {
          return;
        }
        if ((_b2 = child.material) == null ? void 0 : _b2.length) {
          child.material.forEach((material) => {
            material.clippingPlanes = this.planes;
            material.needsUpdate = true;
          });
        } else {
          if (child.material) {
            child.material.clippingPlanes = this.planes;
            child.material.needsUpdate = true;
          }
        }
      });
    },
    removeClippingParams(material) {
      if (material.type === "ShaderMaterial") {
        if (material.vertexShader && material.vertexShader.includes("#include <clipping_planes_pars_vertex>")) {
          this.glslReplaceParams.vertexShader.forEach((param) => {
            material.vertexShader = material.vertexShader.replace(param.replacement, param.pattern);
          });
        }
        if (material.fragmentShader && material.fragmentShader.includes("#include <clipping_planes_pars_fragment>")) {
          this.glslReplaceParams.fragmentShader.forEach((param) => {
            material.fragmentShader = material.fragmentShader.replace(param.replacement, param.pattern);
          });
        }
      }
      material.clippingPlanes = [];
      material.clipping = false;
      material.needsUpdate = true;
    },
    removeClipping() {
      rootScene.traverse((child) => {
        var _a2, _b2;
        if (child.name.includes("Skysphere") || ((_a2 = child.parent) == null ? void 0 : _a2.name.includes("mattertag"))) {
          return;
        }
        if ((_b2 = child.material) == null ? void 0 : _b2.length) {
          child.material.forEach((material) => {
            this.removeClippingParams(material);
          });
        } else {
          if (child.material) {
            this.removeClippingParams(child.material);
          }
        }
      });
    },
    animateLoop() {
      this.frameId = requestAnimationFrame(this.animateLoop);
      if (this.enableClipping) {
        this.updateClipping();
      }
    },
    toggleTrimming() {
      this.dpmStore.$patch({ global: { showTrimmingEditor: !this.dpmStore.global.showTrimmingEditor } });
    }
  },
  watch: {
    box: {
      deep: true,
      handler(v) {
        if (!v)
          return;
        this.setRangesFromBox(v);
        this.updateFromUI();
      }
    },
    "dpmStore.current.mode"(newValue, _oldValue) {
      if (this.enableClipping && ["mode.inside", "mode.dollhouse", "mode.floorplan"].includes(newValue)) {
        this.removeClipping();
        this.addClipping();
      }
    }
  },
  computed: __spreadValues({}, mapStores(useDpmStore, matterportStore))
};
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$2,
  render$2,
  staticRenderFns$2,
  false,
  __vue2_injectStyles$2,
  null,
  null,
  null
);
function __vue2_injectStyles$2(context) {
  for (let o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
const TrimmingEditor = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    attrs: {
      "id": "dpm-virtual-staging-ui"
    }
  }, [_c("div", {
    staticClass: "pe-auto d-flex my-3",
    attrs: {
      "id": "main-menu"
    }
  }, [_c("div", {
    staticClass: "v-select-wrapper"
  }, [_c("v-select", {
    staticClass: "mt-2",
    attrs: {
      "items": _vm.basicItems,
      "item-text": "label",
      "item-value": "value",
      "disabled": _vm.currentLineNode !== null,
      "label": "基本オブジェクト",
      "hide-details": "",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "d-flex align-center"
        }, [item.src ? _c("img", {
          staticClass: "selected-image",
          attrs: {
            "src": item.src
          }
        }) : _vm._e(), _c("span", {
          staticClass: "ms-1"
        }, [_vm._v(_vm._s(item.label))])])];
      }
    }, {
      key: "item",
      fn: function(_ref2) {
        var item = _ref2.item;
        return [_c("div", {
          staticClass: "d-flex align-center my-1"
        }, [item.src ? _c("img", {
          staticClass: "selectable-image",
          attrs: {
            "src": item.src
          }
        }) : _vm._e(), _c("span", {
          staticClass: "ms-2"
        }, [_vm._v(_vm._s(item.label))])])];
      }
    }]),
    model: {
      value: _vm.selectedBasicItem,
      callback: function($$v) {
        _vm.selectedBasicItem = $$v;
      },
      expression: "selectedBasicItem"
    }
  })], 1), _vm.addObjectMode && _vm.currentType === "basic" ? _c("v-btn", {
    staticClass: "ms-4",
    on: {
      "click": function($event) {
        return _vm.setAddObjectMode(false);
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-0",
    attrs: {
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiCheck))]), _vm._v("終了")], 1) : _c("v-btn", {
    staticClass: "ms-4",
    on: {
      "click": function($event) {
        return _vm.setAddObjectMode(true, "basic");
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-0",
    attrs: {
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiPlus))]), _vm._v("配置")], 1), _c("v-btn", {
    staticClass: "ms-4",
    on: {
      "click": function($event) {
        _vm.showAssetFilesSlectorModal = true;
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-0",
    attrs: {
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiFileTree))]), _vm._v("登録済みモデルを配置")], 1), _c("v-dialog", {
    attrs: {
      "scrollable": "",
      "max-width": "1024px"
    },
    model: {
      value: _vm.showAssetFilesSlectorModal,
      callback: function($$v) {
        _vm.showAssetFilesSlectorModal = $$v;
      },
      expression: "showAssetFilesSlectorModal"
    }
  }, [_c("v-card", {
    staticClass: "model-selector"
  }, [_c("v-card-title", {
    staticClass: "h4"
  }, [_vm._v("モデルセレクター")]), _c("v-card-text", [_c("v-treeview", {
    ref: "modelSelector",
    attrs: {
      "items": _vm.categories_tree_with_asset_files,
      "item-text": "name",
      "activatable": "",
      "open-on-click": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function(_ref3) {
        var item = _ref3.item, open2 = _ref3.open;
        return [item.children ? _c("v-icon", [_vm._v(_vm._s(open2 ? _vm.$global.icons.mdiFolderOpen : _vm.$global.icons.mdiFolder))]) : _vm._e()];
      }
    }, {
      key: "label",
      fn: function(_ref4) {
        var item = _ref4.item;
        return [_c("div", {
          staticClass: "d-flex align-center my-2"
        }, [item.thumbnail_url ? _c("v-img", {
          attrs: {
            "src": item.thumbnail_url,
            "contain": "",
            "width": "40",
            "height": "40"
          }
        }) : _vm._e(), _c("div", {
          staticClass: "h6 ms-3"
        }, [_vm._v(_vm._s(item.name))])], 1)];
      }
    }])
  })], 1), _c("v-divider"), _c("v-card-actions", [_c("v-btn", {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showAssetFilesSlectorModal = false;
      }
    }
  }, [_vm._v("キャンセル")]), _c("v-spacer"), _c("v-btn", {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.onSelectModel
    }
  }, [_vm._v("選択したモデルを配置")])], 1)], 1)], 1), _vm.selectedModelItem ? _c("div", {
    staticClass: "ms-3 d-flex align-center"
  }, [_c("span", [_vm._v("選択中のモデル:")]), _vm.selectedModelItem.thumbnail_url ? _c("img", {
    staticClass: "ms-2",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.selectedModelItem.thumbnail_url,
      "width": "32px",
      "height": "32px"
    }
  }) : _vm._e(), _c("span", {
    staticClass: "ms-2"
  }, [_vm._v(_vm._s(_vm.selectedModelItem.file_name))])]) : _vm._e(), _vm.addObjectMode && _vm.currentType === "model" ? _c("v-btn", {
    staticClass: "ms-4",
    attrs: {
      "disabled": !_vm.selectedModelItem
    },
    on: {
      "click": function($event) {
        return _vm.setAddObjectMode(false);
      }
    }
  }, [_c("v-icon", {
    staticClass: "me-0",
    attrs: {
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiCheck))]), _vm._v("終了")], 1) : _vm._e(), _c("v-btn", {
    staticClass: "ms-auto",
    attrs: {
      "color": "primary",
      "disabled": _vm.currentLineNode !== null
    },
    on: {
      "click": _vm.saveFile
    }
  }, [_c("v-icon", {
    staticClass: "me-0",
    attrs: {
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiContentSave))]), _vm._v("編集データのダウンロード")], 1), _c("v-btn", {
    staticClass: "ms-4",
    attrs: {
      "color": "success",
      "disabled": _vm.currentLineNode !== null
    },
    on: {
      "click": _vm.loadJsonFile
    }
  }, [_c("v-icon", {
    staticClass: "me-0",
    attrs: {
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.$global.icons.mdiFileUpload))]), _vm._v("ロード")], 1), _c("input", {
    ref: "jsonFileInput",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": ".json"
    }
  }), _c("v-checkbox", {
    staticClass: "ms-1 mt-1",
    attrs: {
      "label": "追加でロード"
    },
    model: {
      value: _vm.isAddObject,
      callback: function($$v) {
        _vm.isAddObject = $$v;
      },
      expression: "isAddObject"
    }
  })], 1), _c("v-btn", {
    staticClass: "dpm-sub-menu-drawer-button pe-auto",
    attrs: {
      "fab": "",
      "small": "",
      "elevation": "0",
      "color": "white"
    },
    on: {
      "click": function($event) {
        _vm.subMenuExpand = true;
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiFormatListBulletedType))])], 1), _c("v-navigation-drawer", {
    style: `top: 60px; height: ${_vm.subMenuHeight}px;`,
    attrs: {
      "width": "400px",
      "absolute": "",
      "right": "",
      "hide-overlay": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function() {
        return [_c("div", {
          staticClass: "d-flex justify-space-between"
        }, [_c("v-btn", {
          staticClass: "m-2",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.subMenuExpand = false;
            }
          }
        }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiClose))])], 1), !_vm.groupSelectMode ? _c("v-btn", {
          staticClass: "m-2",
          on: {
            "click": function($event) {
              _vm.groupSelectMode = true;
            }
          }
        }, [_vm._v("グループ化")]) : _vm._e(), _vm.groupSelectMode ? _c("v-btn", {
          staticClass: "m-2 ms-auto",
          on: {
            "click": function($event) {
              _vm.groupSelectMode = false;
            }
          }
        }, [_vm._v("終了")]) : _vm._e(), _vm.groupSelectMode ? _c("v-btn", {
          staticClass: "m-2",
          attrs: {
            "color": "success"
          },
          on: {
            "click": _vm.createGroup
          }
        }, [_vm._v("実行")]) : _vm._e()], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.subMenuExpand,
      callback: function($$v) {
        _vm.subMenuExpand = $$v;
      },
      expression: "subMenuExpand"
    }
  }, [_c("div", {
    style: `height: ${_vm.subMenuHeight - 52}px;`,
    attrs: {
      "id": "sub-menu"
    }
  }, [_c("v-expansion-panels", {
    attrs: {
      "multiple": "",
      "accordion": ""
    },
    model: {
      value: _vm.panel,
      callback: function($$v) {
        _vm.panel = $$v;
      },
      expression: "panel"
    }
  }, [_c("v-expansion-panel", {
    attrs: {
      "value": true
    }
  }, [_c("v-expansion-panel-header", [_vm._v("オブジェクトリスト")]), _c("v-expansion-panel-content", [_c("v-list", _vm._l(_vm.nodesList, function(node2, index2) {
    return _c("v-list-item", {
      key: node2.id,
      attrs: {
        "disabled": _vm.currentLineNode !== null
      },
      on: {
        "click": function($event) {
          return _vm.listClicked(node2.id);
        }
      }
    }, [_c("v-list-item-title", [_c("div", {
      staticClass: "d-flex align-center"
    }, [_vm.groupSelectMode && !node2.isGroup ? _c("v-checkbox", {
      staticClass: "m-0",
      attrs: {
        "value": node2.id,
        "hide-details": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      },
      model: {
        value: _vm.selectedObjects,
        callback: function($$v) {
          _vm.selectedObjects = $$v;
        },
        expression: "selectedObjects"
      }
    }) : _vm._e(), node2.deleted ? _c("v-tooltip", {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(_ref5) {
          var on2 = _ref5.on, attrs2 = _ref5.attrs;
          return [_c("v-icon", _vm._g(_vm._b({
            staticClass: "mr-2",
            attrs: {
              "color": "error"
            }
          }, "v-icon", attrs2, false), on2), [_vm._v(_vm._s(_vm.$global.icons.mdiAlertDecagram))])];
        }
      }], null, true)
    }, [_c("div", [_c("p", {
      staticClass: "mb-0"
    }, [_vm._v("配置されたオブジェクトのアセット（ID: " + _vm._s(node2.assetFileId) + "）は削除されているので表示できません")])])]) : _vm._e(), _c("span", {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(node2.name) + " " + _vm._s(node2.deleted ? "（削除済み）" : ""))]), _c("div", {
      staticClass: "ms-auto d-flex"
    }, [node2.categoryName ? _c("div", [_c("v-tooltip", {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(_ref6) {
          var on2 = _ref6.on, attrs2 = _ref6.attrs;
          return [_c("v-btn", _vm._g(_vm._b({
            attrs: {
              "icon": ""
            }
          }, "v-btn", attrs2, false), on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiInformation))])], 1)];
        }
      }], null, true)
    }, [_c("div", [_c("p", {
      staticClass: "mb-0"
    }, [_vm._v("カテゴリ名: " + _vm._s(node2.categoryName))]), _c("p", {
      staticClass: "mb-0"
    }, [_vm._v("アセット名: " + _vm._s(node2.assetName))])])])], 1) : _vm._e(), _c("v-btn", {
      staticClass: "p-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": [function($event) {
          return _vm.navigateToSweep(node2.position);
        }, function($event) {
          $event.stopPropagation();
        }],
        "mousedown": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiShareCircle))])], 1)], 1)], 1)])], 1);
  }), 1)], 1)], 1), _c("v-expansion-panel", {
    attrs: {
      "value": true
    }
  }, [_c("v-expansion-panel-header", [_vm._v("選択中オブジェクトのデータ")]), _c("v-expansion-panel-content", [_vm.showData ? _c("div", {
    staticClass: "card-wrapper"
  }, [_c("v-card", [_c("v-card-text", [_c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "prepend-icon": _vm.$global.icons.mdiAlphaA
    },
    on: {
      "input": function($event) {
        return _vm.changeNodeName($event);
      }
    },
    model: {
      value: _vm.selectedNode.name,
      callback: function($$v) {
        _vm.$set(_vm.selectedNode, "name", $$v);
      },
      expression: "selectedNode.name"
    }
  })], 1)], 1), _vm.selectedNode.isGroup ? [_c("v-row", [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.setNode(null);
      }
    }
  }, [_vm._v("選択解除")])], 1)], 1), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "5"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.deleteGroup
    }
  }, [_vm._v("グループ解除")])], 1), _c("v-col", {
    attrs: {
      "cols": "7"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "error"
    },
    on: {
      "click": _vm.deleteObject
    }
  }, [_vm._v("グループごと削除")])], 1)], 1)] : [_c("v-row", [_c("v-col", {
    attrs: {
      "cols": "6"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.setNode(null);
      }
    }
  }, [_vm._v("選択解除")])], 1), _c("v-col", {
    attrs: {
      "cols": "6"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "error"
    },
    on: {
      "click": _vm.deleteObject
    }
  }, [_vm._v("削除")])], 1)], 1)], !_vm.selectedNode.isGroup ? _c("v-row", [_c("v-col", [_c("v-btn", {
    staticClass: "me-2",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.navigateToSweep(_vm.selectedNode.position);
      }
    }
  }, [_vm._v("このオブジェクトの近くへ移動")])], 1)], 1) : _vm._e(), _c("v-row", [_c("v-col", [_c("v-btn", {
    staticClass: "me-2",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.copyObjectWithSelectedNode
    }
  }, [_vm._v(_vm._s(_vm.selectedNode.isGroup ? "このグループを複製" : "このオブジェクトを複製"))])], 1)], 1)], 2)], 1), _vm.selectedNode.isGroup ? _c("v-card", [_c("v-card-text", {
    staticStyle: {
      "overflow-x": "auto",
      "max-width": "100%"
    }
  }, [_c("v-expansion-panel", {
    staticClass: "group-object-list"
  }, [_c("v-expansion-panel-header", {
    staticClass: "px-0"
  }, [_vm._v("オブジェクト一覧")]), _c("v-expansion-panel-content", {
    staticClass: "group-object-list"
  }, [_c("v-list", _vm._l(_vm.groupObjectList, function(obj, index2) {
    return _c("v-list-item", {
      key: `groupObjectList-${index2}`,
      attrs: {
        "disabled": _vm.currentLineNode !== null
      }
    }, [_c("v-list-item-title", [_c("div", {
      staticClass: "d-flex align-center"
    }, [_c("span", {
      staticClass: "mt-1"
    }, [_vm._v(_vm._s(obj.name))]), obj.categoryName ? [_c("v-tooltip", {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(_ref7) {
          var on2 = _ref7.on, attrs2 = _ref7.attrs;
          return [_c("v-btn", _vm._g(_vm._b({
            staticClass: "ms-auto",
            attrs: {
              "icon": ""
            }
          }, "v-btn", attrs2, false), on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiInformation))])], 1)];
        }
      }], null, true)
    }, [_c("div", [_c("p", {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(obj.categoryName))]), _c("p", {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(`${obj.assetName} : ${obj.assetFileId}`))])])])] : _vm._e(), _c("v-btn", {
      staticClass: "ms-auto",
      class: {
        "ms-auto": !obj.categoryName
      },
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.navigateToSweep(_vm.groupObjectList[index2].position);
        }
      }
    }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiShareCircle))])], 1)], 2)])], 1);
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm.boneList.length ? _c("v-card", [_c("v-card-subtitle", [_vm._v("ボーン一覧")]), _c("v-card-text", {
    staticStyle: {
      "overflow-x": "auto",
      "max-width": "100%"
    }
  }, [_c("v-treeview", {
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "activatable": "",
      "items": _vm.boneList,
      "item-key": "name",
      "item-text": "name",
      "item-value": "name"
    },
    on: {
      "update:active": function($event) {
        return _vm.onBoneClick($event[0]);
      }
    }
  })], 1)], 1) : _vm._e(), _vm.selectedBone ? [_c("v-card", [_c("v-card-subtitle", [_vm._v("拡大縮小")]), _c("v-card-text", [_c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAlphaXBoxOutline
    },
    on: {
      "input": function($event) {
        return _vm.boneValueChanged($event, "sclX");
      }
    },
    model: {
      value: _vm.selectedBone.scale.x,
      callback: function($$v) {
        _vm.$set(_vm.selectedBone.scale, "x", $$v);
      },
      expression: "selectedBone.scale.x"
    }
  })], 1)], 1), _c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAlphaYBoxOutline
    },
    on: {
      "input": function($event) {
        return _vm.boneValueChanged($event, "sclY");
      }
    },
    model: {
      value: _vm.selectedBone.scale.y,
      callback: function($$v) {
        _vm.$set(_vm.selectedBone.scale, "y", $$v);
      },
      expression: "selectedBone.scale.y"
    }
  })], 1)], 1), _vm.selectedNode.type !== _vm.types.billboard && _vm.selectedNode.type !== _vm.types.totemMovie ? _c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAlphaZBoxOutline
    },
    on: {
      "input": function($event) {
        return _vm.boneValueChanged($event, "sclZ");
      }
    },
    model: {
      value: _vm.selectedBone.scale.z,
      callback: function($$v) {
        _vm.$set(_vm.selectedBone.scale, "z", $$v);
      },
      expression: "selectedBone.scale.z"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _c("v-card", [_c("v-card-subtitle", [_vm._v("位置")]), _c("v-card-text", [_c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAlphaXBoxOutline
    },
    on: {
      "input": function($event) {
        return _vm.boneValueChanged($event, "posX");
      }
    },
    model: {
      value: _vm.selectedBone.position.x,
      callback: function($$v) {
        _vm.$set(_vm.selectedBone.position, "x", $$v);
      },
      expression: "selectedBone.position.x"
    }
  })], 1)], 1), _c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAlphaYBoxOutline
    },
    on: {
      "input": function($event) {
        return _vm.boneValueChanged($event, "posY");
      }
    },
    model: {
      value: _vm.selectedBone.position.y,
      callback: function($$v) {
        _vm.$set(_vm.selectedBone.position, "y", $$v);
      },
      expression: "selectedBone.position.y"
    }
  })], 1)], 1), _c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAlphaZBoxOutline
    },
    on: {
      "input": function($event) {
        return _vm.boneValueChanged($event, "posZ");
      }
    },
    model: {
      value: _vm.selectedBone.position.z,
      callback: function($$v) {
        _vm.$set(_vm.selectedBone.position, "z", $$v);
      },
      expression: "selectedBone.position.z"
    }
  })], 1)], 1)], 1)], 1), _c("v-card", [_c("v-card-subtitle", [_vm._v("回転")]), _c("v-card-text", [_c("v-row", [_c("v-col", [_c("v-text-field", {
    ref: "boneRotationX",
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "1",
      "prepend-icon": _vm.$global.icons.mdiAlphaXBoxOutline,
      "value": _vm.quaternionToDegree(_vm.selectedBone.quaternion, "x")
    },
    on: {
      "input": function($event) {
        return _vm.boneValueChanged($event, "rotX");
      }
    }
  })], 1)], 1), _c("v-row", [_c("v-col", [_c("v-text-field", {
    ref: "boneRotationY",
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "1",
      "prepend-icon": _vm.$global.icons.mdiAlphaYBoxOutline,
      "value": _vm.quaternionToDegree(_vm.selectedBone.quaternion, "y")
    },
    on: {
      "input": function($event) {
        return _vm.boneValueChanged($event, "rotY");
      }
    }
  })], 1)], 1), _c("v-row", [_c("v-col", [_c("v-text-field", {
    ref: "boneRotationZ",
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "1",
      "prepend-icon": _vm.$global.icons.mdiAlphaZBoxOutline,
      "value": _vm.quaternionToDegree(_vm.selectedBone.quaternion, "z")
    },
    on: {
      "input": function($event) {
        return _vm.boneValueChanged($event, "rotZ");
      }
    }
  })], 1)], 1)], 1)], 1)] : [_vm.selectedNode.type === _vm.types.billboard || _vm.selectedNode.type === _vm.types.totemMovie || _vm.selectedNode.type === _vm.types.totemImage ? _c("v-card", [_c("v-card-subtitle", [_vm._v("URL")]), _c("v-card-text", [_c("v-row", [_c("v-col", [_vm.selectedNode.type === _vm.types.totemImage ? _c("v-text-field", {
    attrs: {
      "hide-details": "",
      "prepend-icon": _vm.$global.icons.mdiMonitor,
      "value": _vm.imageUrl
    },
    on: {
      "change": function($event) {
        return _vm.valueChanged($event, "image-url");
      }
    }
  }) : _c("v-text-field", {
    attrs: {
      "hide-details": "",
      "prepend-icon": _vm.$global.icons.mdiMonitor
    },
    on: {
      "change": function($event) {
        return _vm.valueChanged($event, "url");
      }
    },
    model: {
      value: _vm.selectedNode.inputs.url,
      callback: function($$v) {
        _vm.$set(_vm.selectedNode.inputs, "url", $$v);
      },
      expression: "selectedNode.inputs.url"
    }
  })], 1)], 1), _vm.selectedNode.type === _vm.types.totemImage ? [_c("v-row", [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("v-file-input", {
    attrs: {
      "label": "アップロードするファイル",
      "messages": "10MBまでのjpg, pngァイルがアップロード可能です。",
      "accept": ".jpg,.jpeg,.png"
    },
    model: {
      value: _vm.uploadedImageFile,
      callback: function($$v) {
        _vm.uploadedImageFile = $$v;
      },
      expression: "uploadedImageFile"
    }
  })], 1)], 1), _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "6"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "primary",
      "disabled": !_vm.uploadedImageFile
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiUpload))]), _vm._v("アップロード")], 1)], 1), _vm.selectedNode.inputs.url ? _c("v-col", {
    attrs: {
      "cols": "6"
    }
  }, [_c("v-btn", {
    attrs: {
      "block": "",
      "color": "error",
      "disabled": _vm.selectedNode.inputs.url && _vm.selectedNode.inputs.url.indexOf("get_media_url") === -1
    },
    on: {
      "click": _vm.deleteImage
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiDelete))]), _vm._v("削除")], 1)], 1) : _vm._e()], 1), _vm.uploadErrorText ? _c("v-row", [_c("v-col", {
    attrs: {
      "cols": "12"
    }
  }, [_c("span", {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.uploadErrorText))])])], 1) : _vm._e()] : _vm._e()], 2)], 1) : _vm._e(), _vm.selectedNode.type === _vm.types.primitive && _vm.selectedNode.inputs.type !== "Line" ? _c("v-card", [_c("v-card-subtitle", [_vm._v("透明度")]), _c("v-card-text", [_c("v-row", [_c("v-col", [_c("v-slider", {
    attrs: {
      "hide-details": "",
      "prepend-icon": _vm.$global.icons.mdiOpacity,
      "max": "1",
      "min": "0",
      "step": "0.1",
      "thumb-size": 24,
      "thumb-label": "always"
    },
    on: {
      "input": function($event) {
        return _vm.valueChanged($event, "opacity");
      }
    },
    model: {
      value: _vm.selectedNode.inputs.opacity,
      callback: function($$v) {
        _vm.$set(_vm.selectedNode.inputs, "opacity", $$v);
      },
      expression: "selectedNode.inputs.opacity"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm.selectedNode.type === _vm.types.primitive && _vm.selectedNode.inputs.type === "Line" ? _c("v-card", [_c("v-card-subtitle", [_vm._v("ラインの太さ")]), _c("v-card-text", [_c("v-row", [_c("v-col", [_c("v-slider", {
    attrs: {
      "hide-details": "",
      "prepend-icon": _vm.$global.icons.mdiMinusThick,
      "max": "10",
      "min": "1",
      "step": "0.1",
      "thumb-size": 24,
      "thumb-label": "always"
    },
    on: {
      "input": function($event) {
        return _vm.valueChanged($event, "linewidth");
      }
    },
    model: {
      value: _vm.selectedNode.inputs.linewidth,
      callback: function($$v) {
        _vm.$set(_vm.selectedNode.inputs, "linewidth", $$v);
      },
      expression: "selectedNode.inputs.linewidth"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm.selectedNode.type === _vm.types.primitive ? _c("v-card", [_c("v-card-subtitle", [_vm._v("カラー")]), _c("v-card-text", [_c("v-row", [_c("v-col", [_c("v-color-picker", {
    attrs: {
      "hide-inputs": ""
    },
    on: {
      "update:color": function($event) {
        return _vm.valueChanged($event, "color");
      }
    },
    model: {
      value: _vm.selectedNode.inputs.color,
      callback: function($$v) {
        _vm.$set(_vm.selectedNode.inputs, "color", $$v);
      },
      expression: "selectedNode.inputs.color"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _c("v-card", [_c("v-card-subtitle", [_vm._v("拡大縮小")]), _c("v-card-text", [_vm.selectedNode.isGroup ? [_c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAxisArrow
    },
    on: {
      "input": function($event) {
        return _vm.valueChanged($event, "sclXYZ");
      }
    },
    model: {
      value: _vm.selectedNode.scale.x,
      callback: function($$v) {
        _vm.$set(_vm.selectedNode.scale, "x", $$v);
      },
      expression: "selectedNode.scale.x"
    }
  })], 1)], 1)] : [_c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAlphaXBoxOutline
    },
    on: {
      "input": function($event) {
        return _vm.valueChanged($event, "sclX");
      }
    },
    model: {
      value: _vm.selectedNode.scale.x,
      callback: function($$v) {
        _vm.$set(_vm.selectedNode.scale, "x", $$v);
      },
      expression: "selectedNode.scale.x"
    }
  })], 1)], 1), _c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAlphaYBoxOutline
    },
    on: {
      "input": function($event) {
        return _vm.valueChanged($event, "sclY");
      }
    },
    model: {
      value: _vm.selectedNode.scale.y,
      callback: function($$v) {
        _vm.$set(_vm.selectedNode.scale, "y", $$v);
      },
      expression: "selectedNode.scale.y"
    }
  })], 1)], 1), _vm.selectedNode.type !== _vm.types.billboard && _vm.selectedNode.type !== _vm.types.totemMovie ? _c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAlphaZBoxOutline
    },
    on: {
      "input": function($event) {
        return _vm.valueChanged($event, "sclZ");
      }
    },
    model: {
      value: _vm.selectedNode.scale.z,
      callback: function($$v) {
        _vm.$set(_vm.selectedNode.scale, "z", $$v);
      },
      expression: "selectedNode.scale.z"
    }
  })], 1)], 1) : _vm._e()]], 2)], 1), _c("v-card", [_c("v-card-subtitle", [_vm._v("位置")]), _c("v-card-text", [_c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAlphaXBoxOutline
    },
    on: {
      "input": function($event) {
        return _vm.valueChanged($event, "posX");
      }
    },
    model: {
      value: _vm.selectedNode.position.x,
      callback: function($$v) {
        _vm.$set(_vm.selectedNode.position, "x", $$v);
      },
      expression: "selectedNode.position.x"
    }
  })], 1)], 1), _c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAlphaYBoxOutline
    },
    on: {
      "input": function($event) {
        return _vm.valueChanged($event, "posY");
      }
    },
    model: {
      value: _vm.selectedNode.position.y,
      callback: function($$v) {
        _vm.$set(_vm.selectedNode.position, "y", $$v);
      },
      expression: "selectedNode.position.y"
    }
  })], 1)], 1), _c("v-row", [_c("v-col", [_c("v-text-field", {
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "0.01",
      "prepend-icon": _vm.$global.icons.mdiAlphaZBoxOutline
    },
    on: {
      "input": function($event) {
        return _vm.valueChanged($event, "posZ");
      }
    },
    model: {
      value: _vm.selectedNode.position.z,
      callback: function($$v) {
        _vm.$set(_vm.selectedNode.position, "z", $$v);
      },
      expression: "selectedNode.position.z"
    }
  })], 1)], 1)], 1)], 1), _vm.selectedNode.type !== _vm.types.billboard ? _c("v-card", [_c("v-card-subtitle", [_vm._v("回転")]), _c("v-card-text", [_c("v-row", [_c("v-col", [_c("v-text-field", {
    ref: "rotationX",
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "1",
      "prepend-icon": _vm.$global.icons.mdiAlphaXBoxOutline,
      "value": _vm.quaternionToDegree(_vm.selectedNode.quaternion, "x")
    },
    on: {
      "input": function($event) {
        return _vm.valueChanged($event, "rotX");
      }
    }
  })], 1)], 1), _c("v-row", [_c("v-col", [_c("v-text-field", {
    ref: "rotationY",
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "1",
      "prepend-icon": _vm.$global.icons.mdiAlphaYBoxOutline,
      "value": _vm.quaternionToDegree(_vm.selectedNode.quaternion, "y")
    },
    on: {
      "input": function($event) {
        return _vm.valueChanged($event, "rotY");
      }
    }
  })], 1)], 1), _c("v-row", [_c("v-col", [_c("v-text-field", {
    ref: "rotationZ",
    attrs: {
      "hide-details": "",
      "type": "number",
      "step": "1",
      "prepend-icon": _vm.$global.icons.mdiAlphaZBoxOutline,
      "value": _vm.quaternionToDegree(_vm.selectedNode.quaternion, "z")
    },
    on: {
      "input": function($event) {
        return _vm.valueChanged($event, "rotZ");
      }
    }
  })], 1)], 1)], 1)], 1) : _vm._e()]], 2) : _vm._e()])], 1)], 1)], 1)]), _c("div", {
    attrs: {
      "id": "overlay-menu"
    }
  }, [_vm.addObjectMode && _vm.selectedBasicItem !== "Line" ? _c("span", [_vm._v("設置箇所をクリックしてください")]) : _vm._e(), _vm.addObjectMode && _vm.currentType === "basic" && _vm.selectedBasicItem === "Line" && !_vm.currentLineNode ? _c("span", [_vm._v("始点をクリックしてください")]) : _vm._e(), _vm.addObjectMode && _vm.currentType === "basic" && _vm.selectedBasicItem === "Line" && _vm.currentLineNode ? _c("span", [_vm._v("終点をクリックしてください")]) : _vm._e()]), _c("div", {
    attrs: {
      "id": "overlay-transform-menu"
    }
  }, [_c("div", {
    staticClass: "d-flex pe-auto"
  }, [_c("v-btn", {
    class: {
      "v-btn--active": _vm.selectedTransformMode === "translate"
    },
    attrs: {
      "fab": "",
      "small": "",
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        return _vm.transformModeChanged("translate");
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiAxisArrow))])], 1)], 1), _c("div", {
    staticClass: "d-flex mt-2 pe-auto"
  }, [_c("v-btn", {
    class: {
      "v-btn--active": _vm.selectedTransformMode === "rotate"
    },
    attrs: {
      "fab": "",
      "small": "",
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        return _vm.transformModeChanged("rotate");
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiRotateOrbit))])], 1)], 1), _c("div", {
    staticClass: "d-flex mt-2 pe-auto"
  }, [_c("v-btn", {
    class: {
      "v-btn--active": _vm.selectedTransformMode === "scale"
    },
    attrs: {
      "fab": "",
      "small": "",
      "elevation": "0"
    },
    on: {
      "click": function($event) {
        return _vm.transformModeChanged("scale");
      }
    }
  }, [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiArrowExpandAll))])], 1)], 1)])], 1);
};
var staticRenderFns$1 = [];
const __vue2_script$1 = {
  data() {
    return {
      addObjectMode: false,
      assetData: {},
      assetFileUrls: {},
      basicItems: [
        { label: "直線", value: "Line", src: "/virtual-staging/icons/line.png" },
        { label: "平面", value: "Plane", src: "/virtual-staging/icons/plane.png" },
        { label: "立方体", value: "Box", src: "/virtual-staging/icons/box.png" },
        { label: "三角柱１", value: "TriangularPrism1", src: "/virtual-staging/icons/triangular-prism1.png" },
        { label: "三角柱２", value: "TriangularPrism2", src: "/virtual-staging/icons/triangular-prism2.png" },
        { label: "球", value: "Sphere", src: "/virtual-staging/icons/sphere.png" },
        { label: "円", value: "Circle", src: "/virtual-staging/icons/circle.png" },
        { label: "円錐", value: "Cone", src: "/virtual-staging/icons/cone.png" },
        { label: "円柱", value: "Cylinder", src: "/virtual-staging/icons/cylinder.png" },
        { label: "四面体", value: "Tetrahedron", src: "/virtual-staging/icons/tetrahedron.png" },
        { label: "八面体", value: "Octahedron", src: "/virtual-staging/icons/octahedron.png" },
        { label: "十二面体", value: "Dodecahedron", src: "/virtual-staging/icons/dodecahedron.png" },
        { label: "二十面体", value: "Icosahedron", src: "/virtual-staging/icons/icosahedron.png" },
        { label: "カプセル", value: "Capsule", src: "/virtual-staging/icons/capsule.png" },
        { label: "リング", value: "Ring", src: "/virtual-staging/icons/ring.png" },
        { label: "トーラス", value: "Torus", src: "/virtual-staging/icons/torus.png" },
        { label: "トーラスノット", value: "TorusKnot", src: "/virtual-staging/icons/torus-knot.png" },
        { label: "ビルボード", value: "Billboard" },
        { label: "トーテム（動画）", value: "TotemMovie" },
        { label: "トーテム（画像）", value: "TotemImage" }
      ],
      boneList: [],
      categories_tree_with_asset_files: [],
      currentLineNode: null,
      currentPointer: null,
      currentType: null,
      imageUrl: null,
      isAddObject: false,
      isDragging: false,
      groupSelectMode: false,
      groupObjectList: [],
      nodesList: [],
      panel: [0, 1],
      selectedBasicItem: "Box",
      selectedBone: null,
      selectedNode: {},
      selectedModelAssetId: null,
      selectedModelItem: null,
      selectedObjects: [],
      selectedTransformMode: null,
      showAssetFilesSlectorModal: false,
      showData: false,
      subMenuExpand: true,
      subMenuHeight: 0,
      transformControlsId: null,
      types: {
        billboard: billboardType,
        fileLoader: fileLoaderType,
        primitive: primitiveType,
        totemImage: totemImageType,
        totemMovie: totemMovieType
      },
      uploadedImageFile: null,
      uploadErrorText: ""
    };
  },
  created() {
    return __async(this, null, function* () {
      const node2 = yield this.dpmStore.global.scene.addTransformControls();
      this.transformControlsId = node2.id;
      const transformControls = this.getComponentOrNode(this.transformControlsId);
      transformControls.transformControls.addEventListener("change", this.controlsEvent);
      this.$global.sdk.Mode.current.subscribe((mode) => {
        if (mode === "mode.floorplan") {
          transformControls.transformControls.setSize(0.01);
        } else {
          transformControls.transformControls.setSize(1);
        }
      });
      this.$global.sdk.Pointer.intersection.subscribe((intersectionData) => {
        this.currentPointer = intersectionData;
      });
      const setLinePosition = (confirm2) => {
        if (this.currentLineNode) {
          const endPosition = new Vector3(this.currentPointer.position.x, this.currentPointer.position.y, this.currentPointer.position.z);
          const relativeVector = new Vector3().subVectors(endPosition, this.currentLineNode.position);
          this.currentLineNode.componentIterator().next().value.updateLine({ x: relativeVector.x, y: relativeVector.y, z: relativeVector.z }, confirm2);
        }
      };
      const canvas = document.getElementById("showcase").contentWindow.document.getElementsByTagName("canvas")[0];
      canvas.addEventListener("pointerdown", () => {
        this.isDragging = false;
        setLinePosition(false);
      });
      canvas.addEventListener("pointermove", () => {
        this.isDragging = true;
        setLinePosition(false);
      });
      canvas.addEventListener("pointerup", () => __async(this, null, function* () {
        if (this.isDragging || !this.addObjectMode) {
          return;
        }
        switch (this.currentType) {
          case "basic":
            let basicNode;
            if (this.selectedBasicItem === "Line") {
              if (!this.currentLineNode) {
                basicNode = yield this.dpmStore.global.scene.addPrimitive(this.currentPointer.position, this.selectedBasicItem);
                this.currentLineNode = basicNode;
                yield this.onModelAdded(basicNode, this.dpmStore.global.scene.sceneObject);
              } else {
                setLinePosition(true);
              }
            } else {
              switch (this.selectedBasicItem) {
                case "Billboard":
                  basicNode = yield this.dpmStore.global.scene.addBillboard(this.currentPointer.position);
                  break;
                case "TotemMovie":
                  basicNode = yield this.dpmStore.global.scene.addTotemMovie(this.currentPointer.position);
                  break;
                case "TotemImage":
                  basicNode = yield this.dpmStore.global.scene.addTotemImage(this.currentPointer.position);
                  break;
                default:
                  basicNode = yield this.dpmStore.global.scene.addPrimitive(this.currentPointer.position, this.selectedBasicItem);
              }
              yield this.onModelAdded(basicNode, this.dpmStore.global.scene.sceneObject);
              this.setAddObjectMode(false);
            }
            break;
          case "model":
            const modelNode = yield this.dpmStore.global.scene.addFile(this.currentPointer.position, this.selectedModelItem.origin_file_url, this.selectedModelItem.file_name);
            yield this.onModelAdded(modelNode, this.dpmStore.global.scene.sceneObject);
            this.setAddObjectMode(false);
            break;
        }
      }));
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.selectedNode) {
          this.setNode(null);
        }
      });
      document.getElementById("showcase").contentWindow.document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.selectedNode) {
          this.setNode(null);
        }
      });
    });
  },
  mounted() {
    return __async(this, null, function* () {
      var _a2;
      this.subMenuHeight = document.getElementById("showcase").clientHeight;
      this.categories_tree_with_asset_files = yield this.getCategoriesTreeWithAssetFiles();
      if (this.dpmStore.SED.objects) {
        const assetFileIds = [];
        this.dpmStore.SED.objects.payload.objects.forEach((obj) => {
          var _a3;
          if (obj.assetFileId)
            assetFileIds.push(obj.assetFileId);
          (_a3 = obj.assetFileIds) == null ? void 0 : _a3.forEach((id) => {
            if (id)
              assetFileIds.push(id);
          });
        });
        const uniqueAssetFileIds = [...new Set(assetFileIds)];
        if (uniqueAssetFileIds == null ? void 0 : uniqueAssetFileIds.length)
          yield this.updateAssetData(uniqueAssetFileIds);
        yield Promise.all(uniqueAssetFileIds.map((assetFileId) => __async(this, null, function* () {
          this.assetFileUrls[assetFileId] = (yield this.getAssetFileById(assetFileId)).data.origin_file_url;
        })));
        this.dpmStore.SED.objects.payload.objects.map((object) => {
          var _a3, _b2, _c;
          if (((_a3 = object.components) == null ? void 0 : _a3.length) && ((_b2 = object.components[0]) == null ? void 0 : _b2.type) === this.types.fileLoader && object.assetFileId) {
            object.components[0].inputs.url = this.assetFileUrls[object.assetFileId];
          }
          if (object.isGroup && ((_c = object.assetFileIds) == null ? void 0 : _c.length)) {
            for (let i2 = 0; i2 < object.assetFileIds.length; i2++) {
              const id = object.assetFileIds[i2];
              if (id)
                object.components[i2].inputs.url = this.assetFileUrls[id];
            }
          }
        });
        const sceneObject = yield this.dpmStore.global.scene.loadObjectsFromShowcaseEditorData(this.dpmStore.SED);
        for (const node2 of sceneObject.nodeIterator()) {
          const target2 = this.dpmStore.SED.objects.payload.objects.find((object) => object.id === node2.id);
          if (target2 == null ? void 0 : target2.assetFileId) {
            node2.assetFileId = target2.assetFileId;
          }
          if (target2 == null ? void 0 : target2.isGroup) {
            node2.isGroup = true;
            node2.assetFileIds = target2.assetFileIds;
          }
          yield this.onModelAdded(node2, sceneObject);
        }
      }
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      const generateRandomId = () => {
        let result2 = "";
        for (let i2 = 0; i2 < 4; i2++) {
          const randomIndex = Math.floor(Math.random() * chars.length);
          result2 += chars[randomIndex];
        }
        return result2;
      };
      (_a2 = this.$refs) == null ? void 0 : _a2.jsonFileInput.addEventListener("change", (e) => {
        const reader = new FileReader();
        reader.onload = (e2) => __async(this, null, function* () {
          const loadedData = JSON.parse(e2.target.result);
          loadedData.payload.objects = loadedData.payload.objects.filter((object) => object.name !== "Ambient Light");
          for (let i2 = 0; i2 < loadedData.payload.objects.length; i2++) {
            const assetFileId = loadedData.payload.objects[i2].assetFileId;
            if (assetFileId) {
              if (!this.assetFileUrls[assetFileId]) {
                this.assetFileUrls[assetFileId] = (yield this.getAssetFileById(assetFileId)).data.origin_file_url;
              }
              loadedData.payload.objects[i2].components[0].inputs.url = this.assetFileUrls[assetFileId];
            }
            const assetFileIds = loadedData.payload.objects[i2].assetFileIds;
            if (assetFileIds == null ? void 0 : assetFileIds.length) {
              for (let j = 0; j < assetFileIds.length; j++) {
                if (assetFileIds[j]) {
                  if (!this.assetFileUrls[assetFileIds[j]]) {
                    this.assetFileUrls[assetFileIds[j]] = (yield this.getAssetFileById(assetFileIds[j])).data.origin_file_url;
                  }
                  loadedData.payload.objects[i2].components[j].inputs.url = this.assetFileUrls[assetFileIds[j]];
                }
              }
            }
          }
          if (!this.isAddObject) {
            const deleteNodeIds = this.nodesList.map((node2) => node2.id);
            deleteNodeIds.forEach((id) => this.deleteNode(id));
          }
          loadedData.payload.objects.forEach((object) => {
            object.id = generateRandomId();
            object.components.forEach((component) => {
              component.id = generateRandomId();
            });
          });
          const sceneObject = yield this.dpmStore.global.scene.loadObjectsFromShowcaseEditorData({ objects: loadedData });
          for (const node2 of sceneObject.nodeIterator()) {
            const target2 = loadedData.payload.objects.find((object) => object.id === node2.id);
            if (target2 == null ? void 0 : target2.assetFileId) {
              node2.assetFileId = target2.assetFileId;
            }
            if (target2 == null ? void 0 : target2.isGroup) {
              node2.isGroup = true;
              node2.assetFileIds = target2.assetFileIds;
            }
            yield this.onModelAdded(node2, sceneObject);
          }
        });
        reader.readAsText(e.target.files[0]);
      });
    });
  },
  methods: {
    updateAssetData(newAssetFileIds) {
      return __async(this, null, function* () {
        _merge(this.assetData, yield axios$1.get(
          "/asset_files/get_assets_info.json",
          { params: { file_ids: newAssetFileIds } }
        ).then((res) => res.data));
      });
    },
    boneValueChanged(value, type) {
      if (!this.selectedBone) {
        return;
      }
      const data = parseFloat(value);
      const degreeToQuaternion = () => {
        const euler = new Euler(
          MathUtils.degToRad(parseFloat(this.$refs.boneRotationX.$refs.input.value)),
          MathUtils.degToRad(parseFloat(this.$refs.boneRotationY.$refs.input.value)),
          MathUtils.degToRad(parseFloat(this.$refs.boneRotationZ.$refs.input.value))
        );
        const newQuaternion = new Quaternion();
        newQuaternion.setFromEuler(euler);
        this.selectedBone.quaternion.set(newQuaternion.x, newQuaternion.y, newQuaternion.z, newQuaternion.w);
      };
      switch (type) {
        case "posX":
          this.selectedBone.position.x = data;
          break;
        case "posY":
          this.selectedBone.position.y = data;
          break;
        case "posZ":
          this.selectedBone.position.z = data;
          break;
        case "rotX":
          degreeToQuaternion();
          break;
        case "rotY":
          degreeToQuaternion();
          break;
        case "rotZ":
          degreeToQuaternion();
          break;
        case "sclX":
          this.selectedBone.scale.x = data;
          break;
        case "sclY":
          this.selectedBone.scale.y = data;
          break;
        case "sclZ":
          this.selectedBone.scale.z = data;
          break;
      }
      this.controlsEvent();
    },
    copyObject(node2, input2) {
      return __async(this, null, function* () {
        var _a2;
        let newNode = null;
        switch (node2.type) {
          case this.types.billboard:
            newNode = yield this.dpmStore.global.scene.addBillboard(node2.position, input2.url, input2);
            break;
          case this.types.fileLoader:
            newNode = yield this.dpmStore.global.scene.addFile(node2.position, input2.url, node2.name, input2);
            break;
          case this.types.primitive:
            newNode = yield this.dpmStore.global.scene.addPrimitive(node2.position, input2.type, input2);
            break;
          case this.types.totemImage:
            newNode = yield this.dpmStore.global.scene.addTotemImage(node2.position, input2.url, input2);
            break;
          case this.types.totemMovie:
            newNode = yield this.dpmStore.global.scene.addTotemMovie(node2.position, input2.url, input2);
            break;
          case "group":
            const targetNode = this.getComponentOrNode(node2.id, "node");
            const children = [];
            let i2 = 0;
            for (const component of targetNode.componentIterator()) {
              children.push({ type: component.componentType, inputs: component.inputs, assetFileId: targetNode.assetFileIds[i2] });
              i2++;
            }
            newNode = yield this.dpmStore.global.scene.addGroup(targetNode.position, children);
            newNode.isGroup = true;
            break;
        }
        newNode.name = node2.name;
        newNode.quaternion.set(node2.quaternion.x, node2.quaternion.y, node2.quaternion.z, node2.quaternion.w);
        newNode.scale.set(node2.scale.x, node2.scale.y, node2.scale.z);
        if (node2.type === this.types.primitive) {
          this.getComponentOrNode(newNode.id).updateLabel(newNode.scale);
        }
        if (newNode.isGroup) {
          for (const component of newNode.componentIterator()) {
            if (component.componentType === this.types.primitive) {
              component.updateLabel(newNode.scale);
            }
          }
        }
        const assetFileId = ((_a2 = this.nodesList.find((listData) => listData.id === node2.id)) == null ? void 0 : _a2.assetFileId) || node2.assetFileId;
        if (assetFileId) {
          newNode.assetFileId = assetFileId;
        }
        yield this.onModelAdded(newNode, this.dpmStore.global.scene.sceneObject);
      });
    },
    copyObjectWithSelectedNode() {
      return __async(this, null, function* () {
        let targetInput = null;
        for (const node2 of this.dpmStore.global.scene.sceneObject.nodeIterator()) {
          if (node2.id === this.selectedNode.id) {
            targetInput = node2.componentIterator().next().value.inputs;
            break;
          }
        }
        if (!targetInput) {
          this.dpmStore.global.scene.loadedSceneObjects.forEach((loadedSceneObject) => {
            for (const node2 of loadedSceneObject.nodeIterator()) {
              if (node2.id === this.selectedNode.id) {
                targetInput = node2.componentIterator().next().value.inputs;
                break;
              }
            }
          });
        }
        yield this.copyObject(this.selectedNode, targetInput);
      });
    },
    createGroup() {
      return __async(this, null, function* () {
        if (this.selectedObjects.length > 0) {
          this.setNode(null);
          const children = [];
          const box = new Box3();
          for (const nodeId of this.selectedObjects) {
            const targetNode = this.getComponentOrNode(nodeId, "node");
            box.expandByObject(targetNode.obj3D);
          }
          const center = new Vector3();
          box.getCenter(center);
          const bottomCenter = new Vector3(center.x, box.min.y, center.z);
          for (const nodeId of this.selectedObjects) {
            const targetNode = this.getComponentOrNode(nodeId, "node");
            const newPosition = new Vector3(...targetNode.position).sub(bottomCenter);
            const targetComponent = targetNode.componentIterator().next().value;
            const euler = new Euler(0, 0, 0, "YXZ").setFromQuaternion(targetNode.quaternion);
            const newRotation = { x: MathUtils.radToDeg(euler.x), y: MathUtils.radToDeg(euler.y), z: MathUtils.radToDeg(euler.z) };
            const newInputs = __spreadProps(__spreadValues({}, targetComponent.inputs), {
              localName: targetNode.name,
              localPosition: newPosition,
              localRotation: newRotation,
              localScale: targetNode.scale,
              position: { x: 0, y: 0, z: 0 },
              rotation: { x: 0, y: 0, z: 0 },
              scale: { x: 1, y: 1, z: 1 }
            });
            const [removedList] = this.nodesList.splice(this.nodesList.findIndex((node2) => node2.id === nodeId), 1);
            children.push({ type: targetComponent.componentType, inputs: newInputs, assetFileId: removedList.assetFileId || "" });
            targetNode.stop();
            targetNode.name = "deleted";
          }
          const newNode = yield this.dpmStore.global.scene.addGroup(bottomCenter, children);
          newNode.isGroup = true;
          yield this.onModelAdded(newNode, this.dpmStore.global.scene.sceneObject);
        }
        this.selectedObjects.splice(0, this.selectedObjects.length);
        this.groupSelectMode = false;
      });
    },
    getAssetFileById(id) {
      return __async(this, null, function* () {
        return yield axios$1.get(`/asset_files/get_asset_file_urls_by_id.json`, {
          params: {
            id
          }
        });
      });
    },
    onSelectModel() {
      return __async(this, null, function* () {
        const selectedItemId = Array.from(this.$refs.modelSelector.activeCache)[0];
        if (selectedItemId) {
          const res = yield this.getAssetFileById(selectedItemId);
          this.showAssetFilesSlectorModal = false;
          this.selectedModelItem = res.data;
          this.selectedModelAssetId = selectedItemId;
          this.setAddObjectMode(true, "model");
        }
      });
    },
    getCategoriesTreeWithAssetFiles() {
      return __async(this, null, function* () {
        const res = yield axios$1.get(`/categories/get_categories_tree_with_asset_files.json`);
        return res.data.categories_tree_with_asset_files;
      });
    },
    setUseMeasurementPrimitiveToStore() {
      this.dpmStore.virtualStaging.useMeasurementPrimitive = this.nodesList.some((node2) => {
        var _a2, _b2;
        if (node2.isGroup) {
          for (const component of this.getComponentOrNode(node2.id, "node").componentIterator()) {
            if (["Box", "Plane", "Line"].includes((_a2 = component.inputs) == null ? void 0 : _a2.type)) {
              return true;
            }
          }
          return false;
        } else {
          return ["Box", "Plane", "Line"].includes((_b2 = this.getComponentOrNode(node2.id).inputs) == null ? void 0 : _b2.type);
        }
      });
    },
    onModelAdded(node2, sceneObject) {
      return __async(this, null, function* () {
        if (this.selectedModelAssetId)
          yield this.updateAssetData([this.selectedModelAssetId]);
        const position = new Vector3(node2.position.x, node2.position.y, node2.position.z);
        if (node2.isGroup) {
          this.nodesList.push({ id: node2.id, name: node2.name, position, isGroup: true });
        } else {
          if (this.getComponentOrNode(node2.id).componentType === this.types.fileLoader && (node2.assetFileId || this.selectedModelItem && this.selectedModelAssetId)) {
            const assetData = this.assetData[this.selectedModelAssetId || node2.assetFileId];
            if (assetData) {
              this.nodesList.push({ id: node2.id, name: node2.name, position, assetFileId: this.selectedModelAssetId || node2.assetFileId, assetName: assetData.name, categoryName: assetData.category_name });
            } else {
              this.nodesList.push({ id: node2.id, name: node2.name, deleted: true, assetFileId: this.selectedModelAssetId || node2.assetFileId });
            }
          } else {
            this.nodesList.push({ id: node2.id, name: node2.name, position });
          }
        }
        this.setUseMeasurementPrimitiveToStore();
        for (const component of node2.componentIterator()) {
          sceneObject.spyOnEvent({
            func: this.setNode,
            // TODO: もっと良い書き方はないものか…
            controls: this.getComponentOrNode(this.transformControlsId),
            // NOTE: thisのコンテキストが変わって変数にアクセスできなくなるためこの書き方をしている
            node: node2,
            //       公式にないパラメータなので、直せるなら直したい
            path: sceneObject.addEventPath(component, ComponentInteractionType.CLICK),
            onEvent(_eventData) {
              if (this.controls.inputs.selection === this.node) {
                this.func(null);
              } else {
                this.func(this.node);
              }
            }
          });
        }
      });
    },
    changeNodeName(newName) {
      this.nodesList[this.nodesList.findIndex((node2) => node2.id === this.selectedNode.id)].name = newName;
      this.getComponentOrNode(this.selectedNode.id, "node").name = newName;
    },
    controlsEvent() {
      const transformControls = this.getComponentOrNode(this.transformControlsId);
      const selectionNode = transformControls.inputs.selection;
      if (!selectionNode) {
        return;
      }
      if (this.selectedNode.isGroup && this.selectedTransformMode === "scale") {
        const currentScale = transformControls.transformControls.object.scale;
        switch (transformControls.transformControls.axis) {
          case "X":
            currentScale.y = currentScale.x;
            currentScale.z = currentScale.x;
            break;
          case "Y":
            currentScale.x = currentScale.y;
            currentScale.z = currentScale.y;
            break;
          case "Z":
            currentScale.x = currentScale.z;
            currentScale.y = currentScale.z;
            break;
          case "XY":
            currentScale.z = currentScale.x;
            break;
          case "XZ":
            currentScale.y = currentScale.x;
            break;
          case "YZ":
            currentScale.x = currentScale.y;
            break;
        }
      }
      for (const component of selectionNode.componentIterator()) {
        if (this.selectedBone) {
          const boneName = this.selectedBone.name;
          const euler = new Euler(0, 0, 0, "YXZ").setFromQuaternion(this.selectedBone.quaternion);
          component.inputs.bones[boneName] = {
            position: { x: this.selectedBone.position.x, y: this.selectedBone.position.y, z: this.selectedBone.position.z },
            rotation: { x: MathUtils.radToDeg(euler.x), y: MathUtils.radToDeg(euler.y), z: MathUtils.radToDeg(euler.z) },
            scale: { x: this.selectedBone.scale.x, y: this.selectedBone.scale.y, z: this.selectedBone.scale.z }
          };
        } else {
          if (component.componentType === this.types.totemMovie || component.componentType === this.types.totemImage) {
            component.inputs.scale = { x: selectionNode.scale.x, y: selectionNode.scale.y };
          }
          if (component.componentType === this.types.primitive) {
            component.updateLabel(selectionNode.scale);
          }
        }
      }
    },
    deleteGroup() {
      return __async(this, null, function* () {
        const result2 = window.confirm("本当にグループ解除しますか？");
        if (result2) {
          let i2 = 0;
          const node2 = this.getComponentOrNode(this.selectedNode.id, "node");
          const listIndex = this.nodesList.findIndex((node3) => node3.id === this.selectedNode.id);
          for (const component of node2.componentIterator()) {
            const child = node2.obj3D.children[i2];
            child.updateMatrixWorld(true);
            const worldMatrix = child.matrixWorld;
            const position = new Vector3();
            const quaternion = new Quaternion();
            const scale = new Vector3();
            worldMatrix.decompose(position, quaternion, scale);
            const copyNode = __spreadProps(__spreadValues({}, this.selectedNode), {
              position: { x: position.x, y: position.y, z: position.z },
              quaternion: { x: quaternion.x, y: quaternion.y, z: quaternion.z, w: quaternion.w },
              scale: { x: scale.x, y: scale.y, z: scale.z },
              type: component.componentType,
              name: component.inputs.localName,
              isGroup: false,
              assetFileId: node2.assetFileIds[i2]
            });
            const newInputs = __spreadProps(__spreadValues({}, component.inputs), {
              localName: "",
              localPosition: { x: 0, y: 0, z: 0 },
              localRotation: { x: 0, y: 0, z: 0 },
              localScale: { x: 1, y: 1, z: 1 }
            });
            if (component.componentType === this.types.totemMovie || component.componentType === this.types.totemImage) {
              newInputs.scale = copyNode.scale;
            }
            yield this.copyObject(copyNode, newInputs);
            const [removed] = this.nodesList.splice(this.nodesList.length - 1, 1);
            this.nodesList.splice(listIndex + i2, 0, removed);
            i2++;
          }
          this.deleteNode();
        }
      });
    },
    deleteImage() {
      return __async(this, null, function* () {
        const result2 = window.confirm("本当に削除しますか？");
        if (result2) {
          const file_id = this.selectedNode.inputs.url.split("file_id=")[1];
          yield axios$1.delete(
            `${this.$global.apiUrl}/purge_media?type=virtual_staging_images&file_id=${file_id}`,
            { headers: this.$global.csrfHeader }
          );
          this.selectedNode.inputs.url = null;
          this.imageUrl = null;
        }
      });
    },
    deleteNode() {
      return __async(this, arguments, function* (nodeId = this.selectedNode.id) {
        var _a2;
        const node2 = this.getComponentOrNode(nodeId, "node");
        if (node2.id === ((_a2 = this.getComponentOrNode(this.transformControlsId).inputs.selection) == null ? void 0 : _a2.id)) {
          this.getComponentOrNode(this.transformControlsId).transformControls.detach();
        }
        node2.stop();
        this.nodesList.splice(this.nodesList.findIndex((n2) => n2.id === node2.id), 1);
        this.setUseMeasurementPrimitiveToStore();
        yield this.setNode(null);
        node2.name = "deleted";
      });
    },
    deleteObject() {
      const result2 = window.confirm("本当に削除しますか？");
      if (result2) {
        this.deleteNode();
      }
    },
    getComponentOrNode(id, type = "component") {
      for (const node2 of this.dpmStore.global.scene.sceneObject.nodeIterator()) {
        if (node2.id === id) {
          if (type === "node") {
            return node2;
          } else {
            return node2.componentIterator().next().value;
          }
        }
      }
      for (const loadedSceneObject of this.dpmStore.global.scene.loadedSceneObjects) {
        for (const node2 of loadedSceneObject.nodeIterator()) {
          if (node2.id === id) {
            if (type === "node") {
              return node2;
            } else {
              return node2.componentIterator().next().value;
            }
          }
        }
      }
    },
    getImageUrl(id) {
      return __async(this, null, function* () {
        this.uploadErrorText = "";
        return axios$1.get(
          `${this.$global.apiUrl}/get_media_url?type=virtual_staging_images&file_id=${id}`,
          { headers: this.$global.csrfHeader }
        ).then((res) => {
          return res.data.url;
        }).catch((err2) => {
          this.uploadErrorText = err2.response.data.error || err2;
        });
      });
    },
    listClicked(id) {
      const node2 = this.getComponentOrNode(id, "node");
      const controls = this.getComponentOrNode(this.transformControlsId);
      if (controls.inputs.selection === node2) {
        this.setNode(null);
      } else {
        this.setNode(node2);
      }
    },
    loadJsonFile() {
      this.$refs.jsonFileInput.click();
    },
    navigateToSweep() {
      return __async(this, null, function* () {
        yield this.$global.sdk.Sweep.moveTo(this.dpmStore.getClosestSweepSid(this.selectedNode.position));
      });
    },
    onBoneClick(item) {
      if (item) {
        this.selectedBone = this.getComponentOrNode(this.selectedNode.id).getBone(item);
        this.getComponentOrNode(this.transformControlsId).transformControls.attach(this.selectedBone);
      } else {
        this.selectedBone = null;
        this.getComponentOrNode(this.transformControlsId).transformControls.detach();
      }
    },
    quaternionToDegree(target2, type) {
      let angle;
      const euler = new Euler(0, 0, 0, "YXZ").setFromQuaternion(target2);
      if (type === "x") {
        angle = MathUtils.radToDeg(euler.x);
      } else if (type === "y") {
        angle = MathUtils.radToDeg(euler.y);
      } else {
        angle = MathUtils.radToDeg(euler.z);
      }
      return angle === 0 ? 0 : angle;
    },
    saveFile() {
      return __async(this, null, function* () {
        if (this.nodesList.length > 0) {
          const data = yield this.saveScene();
          saveJsonToFile(JSON.stringify(data));
        }
      });
    },
    saveScene() {
      return __async(this, null, function* () {
        if (this.nodesList.length > 0) {
          let serialized = yield this.dpmStore.global.scene.serialize();
          serialized.payload.objects.forEach((object) => {
            var _a2, _b2;
            if (((_a2 = object.components[0]) == null ? void 0 : _a2.type) === this.types.fileLoader) {
              object.components[0].inputs.url = null;
              object.assetFileId = this.nodesList.find((node2) => node2.id === object.id).assetFileId;
            }
            if ((_b2 = this.nodesList.find((node2) => node2.id === object.id)) == null ? void 0 : _b2.isGroup) {
              object.isGroup = true;
              object.assetFileIds = this.getComponentOrNode(object.id, "node").assetFileIds;
            }
          });
          const tmpMap = new Map(serialized.payload.objects.map((item) => [item.id, item]));
          const sorted = this.nodesList.map((item) => tmpMap.get(item.id));
          serialized.payload.objects = sorted;
          return serialized;
        }
        return "";
      });
    },
    setAddObjectMode(mode, type = null) {
      this.addObjectMode = mode;
      this.currentType = type;
      this.setNode(null);
      if (this.currentLineNode) {
        const pointCOunt = this.currentLineNode.componentIterator().next().value.lineCreationCompleted();
        if (pointCOunt < 2) {
          const node2 = this.getComponentOrNode(this.currentLineNode.id, "node");
          node2.stop();
          this.nodesList.splice(this.nodesList.findIndex((n2) => n2.id === node2.id), 1);
          this.setUseMeasurementPrimitiveToStore();
          this.setNode(null);
          node2.name = "deleted";
        }
      }
      this.currentLineNode = null;
      if (this.addObjectMode) {
        this.$global.sdk.Sweep.disable(...Object.keys(this.dpmStore.global.sweeps));
      } else {
        setTimeout(() => {
          this.$global.sdk.Sweep.enable(...Object.keys(this.dpmStore.global.sweeps));
        }, 500);
        this.selectedModelItem = null;
        this.selectedModelAssetId = null;
      }
    },
    setNode(node2) {
      return __async(this, null, function* () {
        var _a2;
        const controls = this.getComponentOrNode(this.transformControlsId);
        if (node2) {
          const component = node2.componentIterator().next().value;
          controls.inputs.selection = node2;
          if (!this.selectedTransformMode) {
            this.selectedTransformMode = controls.inputs.mode;
          }
          if (this.dpmStore.current.mode === "mode.floorplan") {
            controls.inputs.size = 0.01;
          }
          this.$set(this.selectedNode, "id", node2.id);
          this.$set(this.selectedNode, "name", node2.name);
          this.$set(this.selectedNode, "type", node2.isGroup ? "group" : component.componentType);
          this.$set(this.selectedNode, "position", node2.position);
          this.$set(this.selectedNode, "quaternion", node2.quaternion);
          this.$set(this.selectedNode, "scale", node2.scale);
          this.$set(this.selectedNode, "isGroup", node2.isGroup);
          this.$set(this.selectedNode, "assetFileId", node2.assetFileId);
          this.$set(this.selectedNode, "inputs", component.inputs);
          if (typeof component.getBoneList === "function" && ((_a2 = component.getBoneList()) == null ? void 0 : _a2.length) > 0) {
            this.boneList = component.getBoneList();
          } else {
            this.boneList = [];
          }
          this.groupObjectList = [];
          if (node2.isGroup) {
            let i2 = 0;
            for (const component2 of node2.componentIterator()) {
              const child = node2.obj3D.children[i2];
              child.updateMatrixWorld(true);
              const worldMatrix = child.matrixWorld;
              const position = new Vector3();
              position.setFromMatrixPosition(worldMatrix);
              const listData = { name: component2.inputs.localName, position };
              if (node2.assetFileId) {
                const data = this.assetData[node2.assetFileId];
                Object.assign(listData, { assetFileId: node2.assetFileId, assetName: data.name, categoryName: data.categoryName });
              }
              this.groupObjectList.push(listData);
              i2++;
            }
          }
          this.showData = true;
        } else {
          controls.inputs.selection = null;
          this.selectedTransformMode = null;
          this.$set(this.selectedNode, "id", "");
          this.$set(this.selectedNode, "name", "");
          this.$set(this.selectedNode, "type", "");
          this.$set(this.selectedNode, "position", { x: 0, y: 0, z: 0 });
          this.$set(this.selectedNode, "rotation", { x: 0, y: 0, z: 0 });
          this.$set(this.selectedNode, "scale", { x: 1, y: 1, z: 1 });
          this.$set(this.selectedNode, "isGroup", false);
          this.$set(this.selectedNode, "assetFileId", "");
          this.$set(this.selectedNode, "inputs", {});
          this.boneList = [];
          this.groupObjectList = [];
          this.showData = false;
        }
        this.selectedBone = null;
        this.uploadedImageFile = null;
        this.uploadErrorText = "";
        if (this.selectedNode.type === this.types.totemImage) {
          if (this.selectedNode.inputs.url && this.selectedNode.inputs.url.indexOf("get_media_url") !== -1) {
            this.imageUrl = yield this.getImageUrl(this.selectedNode.inputs.url.split("file_id=")[1]);
          } else {
            this.imageUrl = this.selectedNode.inputs.url;
          }
        } else {
          this.imageUrl = null;
        }
      });
    },
    transformModeChanged(selected) {
      this.selectedTransformMode = selected;
      const transformControls = this.getComponentOrNode(this.transformControlsId);
      if (this.selectedBone) {
        transformControls.transformControls.setMode(selected);
      } else {
        transformControls.inputs.mode = selected;
      }
      setTimeout(() => {
        if (this.dpmStore.current.mode === "mode.floorplan") {
          transformControls.inputs.size = 0.01;
        } else {
          transformControls.inputs.size = 1;
        }
      }, 100);
    },
    uploadImage() {
      return __async(this, null, function* () {
        this.uploadErrorText = "";
        const params = new FormData();
        params.append("file", this.uploadedImageFile);
        yield axios$1.post(
          `${this.$global.apiUrl}/upload_media?type=virtual_staging_images`,
          params,
          { headers: __spreadProps(__spreadValues({}, this.$global.csrfHeader), { "content-type": "multipart/form-data" }) }
        ).then((res) => {
          if (res.data) {
            this.selectedNode.inputs.url = `${this.$global.apiUrl}/get_media_url?type=virtual_staging_images&file_id=${res.data.id}`;
            this.imageUrl = res.data.url;
            this.uploadedImageFile = null;
            this.uploadErrorText = "";
          }
        }).catch((err2) => {
          this.uploadErrorText = err2.response.data.error || err2;
        });
      });
    },
    valueChanged(value, type) {
      return __async(this, null, function* () {
        const controls = this.getComponentOrNode(this.transformControlsId);
        if (controls.inputs.selection === null) {
          return;
        }
        const data = parseFloat(value);
        const component = this.getComponentOrNode(controls.inputs.selection.id);
        const degreeToQuaternion = () => {
          const euler = new Euler(
            MathUtils.degToRad(parseFloat(this.$refs.rotationX.$refs.input.value)),
            MathUtils.degToRad(parseFloat(this.$refs.rotationY.$refs.input.value)),
            MathUtils.degToRad(parseFloat(this.$refs.rotationZ.$refs.input.value))
          );
          const newQuaternion = new Quaternion();
          newQuaternion.setFromEuler(euler);
          controls.inputs.selection.quaternion.set(newQuaternion.x, newQuaternion.y, newQuaternion.z, newQuaternion.w);
        };
        switch (type) {
          case "posX":
            controls.inputs.selection.position.x = data;
            break;
          case "posY":
            controls.inputs.selection.position.y = data;
            break;
          case "posZ":
            controls.inputs.selection.position.z = data;
            break;
          case "rotX":
            degreeToQuaternion();
            break;
          case "rotY":
            degreeToQuaternion();
            break;
          case "rotZ":
            degreeToQuaternion();
            break;
          case "sclX":
            controls.inputs.selection.scale.x = data;
            break;
          case "sclY":
            controls.inputs.selection.scale.y = data;
            break;
          case "sclZ":
            controls.inputs.selection.scale.z = data;
            break;
          case "sclXYZ":
            controls.inputs.selection.scale.x = data;
            controls.inputs.selection.scale.y = data;
            controls.inputs.selection.scale.z = data;
            break;
          case "opacity":
            component.inputs.opacity = data;
            break;
          case "color":
            component.inputs.color = value.hex;
            break;
          case "url":
            component.inputs.url = value;
            break;
          case "image-url":
            if (value.indexOf("get_media_url") !== -1) {
              component.inputs.url = value;
              this.imageUrl = yield this.getImageUrl(value.split("file_id=")[1]);
            } else {
              component.inputs.url = value;
              this.imageUrl = value;
            }
            break;
          case "linewidth":
            component.inputs.linewidth = data;
            break;
        }
        controls.transformControls.dispatchEvent({ type: "change" });
      });
    }
  },
  computed: __spreadValues({}, mapStores(useDpmStore))
};
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script$1,
  render$1,
  staticRenderFns$1,
  false,
  __vue2_injectStyles$1,
  null,
  null,
  null
);
function __vue2_injectStyles$1(context) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
const VirtualStaging = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var SC = "object" == typeof SC ? SC : {};
SC.Widget = function(e) {
  var t3 = {};
  function n2(r) {
    if (t3[r])
      return t3[r].exports;
    var o = t3[r] = { i: r, l: false, exports: {} };
    return e[r].call(o.exports, o, o.exports, n2), o.l = true, o.exports;
  }
  return n2.m = e, n2.c = t3, n2.d = function(e2, t4, r) {
    n2.o(e2, t4) || Object.defineProperty(e2, t4, { enumerable: true, get: r });
  }, n2.r = function(e2) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e2, "__esModule", { value: true });
  }, n2.t = function(e2, t4) {
    if (1 & t4 && (e2 = n2(e2)), 8 & t4)
      return e2;
    if (4 & t4 && "object" == typeof e2 && e2 && e2.__esModule)
      return e2;
    var r = /* @__PURE__ */ Object.create(null);
    if (n2.r(r), Object.defineProperty(r, "default", { enumerable: true, value: e2 }), 2 & t4 && "string" != typeof e2)
      for (var o in e2)
        n2.d(r, o, function(t5) {
          return e2[t5];
        }.bind(null, o));
    return r;
  }, n2.n = function(e2) {
    var t4 = e2 && e2.__esModule ? function() {
      return e2.default;
    } : function() {
      return e2;
    };
    return n2.d(t4, "a", t4), t4;
  }, n2.o = function(e2, t4) {
    return Object.prototype.hasOwnProperty.call(e2, t4);
  }, n2.p = "", n2(n2.s = 0);
}([function(e, t3, n2) {
  var r, o, i2, u = n2(1), a = n2(2), c = n2(3), s2 = u.api, l = u.bridge, d2 = [], f = [], p = /^http(?:s?)/;
  function E(e2) {
    var t4, n3;
    for (t4 = 0, n3 = f.length; t4 < n3 && false !== e2(f[t4]); t4++)
      ;
  }
  function v(e2) {
    return e2.contentWindow ? e2.contentWindow : e2.contentDocument && "parentWindow" in e2.contentDocument ? e2.contentDocument.parentWindow : null;
  }
  function _(e2) {
    var t4, n3 = [];
    for (t4 in e2)
      e2.hasOwnProperty(t4) && n3.push(e2[t4]);
    return n3;
  }
  function S(e2, t4, n3) {
    n3.callbacks[e2] = n3.callbacks[e2] || [], n3.callbacks[e2].push(t4);
  }
  function h(e2, t4) {
    var n3 = true;
    return t4.callbacks[e2] = [], E(function(t5) {
      if ((t5.callbacks[e2] || []).length)
        return n3 = false, false;
    }), n3;
  }
  function y(e2, t4, n3) {
    var r2, o2, i3 = v(n3);
    if (!i3.postMessage)
      return false;
    r2 = n3.getAttribute("src").split("?")[0], o2 = JSON.stringify({ method: e2, value: t4 }), "//" === r2.substr(0, 2) && (r2 = window.location.protocol + r2), r2 = r2.replace(/http:\/\/(w|wt).soundcloud.com/, "https://$1.soundcloud.com"), i3.postMessage(o2, r2);
  }
  function b(e2) {
    var t4;
    return E(function(n3) {
      if (n3.instance === e2)
        return t4 = n3, false;
    }), t4;
  }
  function g(e2) {
    var t4;
    return E(function(n3) {
      if (v(n3.element) === e2)
        return t4 = n3, false;
    }), t4;
  }
  function m(e2, t4) {
    return function(n3) {
      var r2, o2 = !!((r2 = n3) && r2.constructor && r2.call && r2.apply), i3 = b(this), u2 = !o2 && t4 ? n3 : null, a2 = o2 && !t4 ? n3 : null;
      return a2 && S(e2, a2, i3), y(e2, u2, i3.element), this;
    };
  }
  function R(e2, t4, n3) {
    var r2, o2, i3;
    for (r2 = 0, o2 = t4.length; r2 < o2; r2++)
      e2[i3 = t4[r2]] = m(i3, n3);
  }
  function O(e2, t4, n3) {
    return e2 + "?url=" + t4 + "&" + function(e3) {
      var t5, n4, r2 = [];
      for (t5 in e3)
        e3.hasOwnProperty(t5) && (n4 = e3[t5], r2.push(t5 + "=" + ("start_track" === t5 ? parseInt(n4, 10) : n4 ? "true" : "false")));
      return r2.join("&");
    }(n3);
  }
  function w(e2, t4, n3) {
    var r2, o2, i3 = e2.callbacks[t4] || [];
    for (r2 = 0, o2 = i3.length; r2 < o2; r2++)
      i3[r2].apply(e2.instance, n3);
    (function(e3) {
      var t5, n4 = false;
      for (t5 in a)
        if (a.hasOwnProperty(t5) && a[t5] === e3) {
          n4 = true;
          break;
        }
      return n4;
    }(t4) || t4 === s2.READY) && (e2.callbacks[t4] = []);
  }
  function A(e2) {
    var t4, n3, r2, o2, i3;
    try {
      n3 = JSON.parse(e2.data);
    } catch (e3) {
      return false;
    }
    return t4 = g(e2.source), r2 = n3.method, o2 = n3.value, (!t4 || P(e2.origin) === P(t4.domain)) && (t4 ? (r2 === s2.READY && (t4.isReady = true, w(t4, "__LATE_BINDING__"), h("__LATE_BINDING__", t4)), r2 !== s2.PLAY || t4.playEventFired || (t4.playEventFired = true), r2 !== s2.PLAY_PROGRESS || t4.playEventFired || (t4.playEventFired = true, w(t4, s2.PLAY, [o2])), i3 = [], void 0 !== o2 && i3.push(o2), void w(t4, r2, i3)) : (r2 === s2.READY && d2.push(e2.source), false));
  }
  function P(e2) {
    return e2.replace(p, "");
  }
  window.addEventListener ? window.addEventListener("message", A, false) : window.attachEvent("onmessage", A), e.exports = i2 = function(e2, t4, n3) {
    var i3;
    if (("" === (i3 = e2) || i3 && i3.charCodeAt && i3.substr) && (e2 = document.getElementById(e2)), !function(e3) {
      return !(!e3 || 1 !== e3.nodeType || "IFRAME" !== e3.nodeName.toUpperCase());
    }(e2))
      throw new Error("SC.Widget function should be given either iframe element or a string specifying id attribute of iframe element.");
    t4 && (n3 = n3 || {}, e2.src = O("http://wt.soundcloud.test:9200/", t4, n3));
    var u2, a2, c2 = g(v(e2));
    return c2 && c2.instance ? c2.instance : (u2 = d2.indexOf(v(e2)) > -1, a2 = new r(e2), f.push(new o(a2, e2, u2)), a2);
  }, i2.Events = s2, window.SC = window.SC || {}, window.SC.Widget = i2, o = function(e2, t4, n3) {
    this.instance = e2, this.element = t4, this.domain = function(e3) {
      var t5, n4, r2, o2 = "";
      "//" === e3.substr(0, 2) && (e3 = window.location.protocol + e3);
      for (r2 = e3.split("/"), t5 = 0, n4 = r2.length; t5 < n4 && t5 < 3; t5++)
        o2 += r2[t5], t5 < 2 && (o2 += "/");
      return o2;
    }(t4.getAttribute("src")), this.isReady = !!n3, this.callbacks = {};
  }, (r = function() {
  }).prototype = { constructor: r, load: function(e2, t4) {
    if (e2) {
      t4 = t4 || {};
      var n3 = this, r2 = b(this), o2 = r2.element, i3 = o2.src, u2 = i3.substr(0, i3.indexOf("?"));
      r2.isReady = false, r2.playEventFired = false, o2.onload = function() {
        n3.bind(s2.READY, function() {
          var e3, n4 = r2.callbacks;
          for (e3 in n4)
            n4.hasOwnProperty(e3) && e3 !== s2.READY && y(l.ADD_LISTENER, e3, r2.element);
          t4.callback && t4.callback();
        });
      }, o2.src = O(u2, e2, t4);
    }
  }, bind: function(e2, t4) {
    var n3 = this, r2 = b(this);
    return r2 && r2.element && (e2 === s2.READY && r2.isReady ? setTimeout(t4, 1) : r2.isReady ? (S(e2, t4, r2), y(l.ADD_LISTENER, e2, r2.element)) : S("__LATE_BINDING__", function() {
      n3.bind(e2, t4);
    }, r2)), this;
  }, unbind: function(e2) {
    var t4, n3 = b(this);
    n3 && n3.element && (t4 = h(e2, n3), e2 !== s2.READY && t4 && y(l.REMOVE_LISTENER, e2, n3.element));
  } }, R(r.prototype, _(a)), R(r.prototype, _(c), true);
}, function(e, t3) {
  t3.api = { LOAD_PROGRESS: "loadProgress", PLAY_PROGRESS: "playProgress", PLAY: "play", PAUSE: "pause", FINISH: "finish", SEEK: "seek", READY: "ready", OPEN_SHARE_PANEL: "sharePanelOpened", CLICK_DOWNLOAD: "downloadClicked", CLICK_BUY: "buyClicked", ERROR: "error" }, t3.bridge = { REMOVE_LISTENER: "removeEventListener", ADD_LISTENER: "addEventListener" };
}, function(e, t3) {
  e.exports = { GET_VOLUME: "getVolume", GET_DURATION: "getDuration", GET_POSITION: "getPosition", GET_SOUNDS: "getSounds", GET_CURRENT_SOUND: "getCurrentSound", GET_CURRENT_SOUND_INDEX: "getCurrentSoundIndex", IS_PAUSED: "isPaused" };
}, function(e, t3) {
  e.exports = { PLAY: "play", PAUSE: "pause", TOGGLE: "toggle", SEEK_TO: "seekTo", SET_VOLUME: "setVolume", NEXT: "next", PREV: "prev", SKIP: "skip" };
}]);
var render7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "position-absolute top-0 end-0 pe-none overflow-hidden",
    class: [_vm.dpmStore.global.showCilbee && "mode-cilbee", _vm.dpmStore.global.showVirtualStaging && !_vm.matterportStore.hideDpm && "mode-virtual-staging"],
    attrs: {
      "id": "dpm-v-app"
    }
  }, [_c("style", {
    tag: "div",
    staticClass: "dpmExtraStyle"
  }, [_vm._v(_vm._s(_vm.getExtraStyle))]), _c("v-app", [!_vm.matterportStore.hideDpm ? _c("DpmExtensions", {
    staticClass: "dpm-extensions"
  }) : _vm._e(), _c("div", {
    staticClass: "d-grid",
    staticStyle: {
      "grid-template-areas": '"overlap"'
    }
  }, [_vm.dpmStore.global.showVirtualStaging && !_vm.matterportStore.hideDpm ? _c("VirtualStaging", {
    staticStyle: {
      "grid-area": "overlap"
    }
  }) : _vm._e(), _vm.dpmStore.global.showCilbee ? _c("CilbeeApp", {
    staticStyle: {
      "grid-area": "overlap"
    }
  }) : _vm._e(), _vm.dpmStore.sharedExperience.room ? _c("SharedExperience", {
    staticStyle: {
      "grid-area": "overlap"
    }
  }) : _vm._e(), _c("div", {
    staticClass: "top-right-ui",
    staticStyle: {
      "grid-area": "overlap",
      "z-index": "1"
    }
  }, [!_vm.dpmStore.global.showVirtualStaging ? _c("div", {
    staticClass: "df",
    attrs: {
      "id": "dpm-options-container"
    }
  }, [!(_vm.matterportStore.dockOpen || _vm.matterportStore.hideDpm) && _vm.notPlayer && _vm.dpmStore.global.enableExtensions.sweep && !_vm.dpmStore.global.showCilbee ? _c("div", {
    staticClass: "pe-auto",
    attrs: {
      "id": "dpm-sweep-extension-toggle-button"
    }
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref) {
        var on2 = _ref.on;
        return [_c("v-btn", _vm._g({
          attrs: {
            "id": "sweep-toggle-btn",
            "fab": "",
            "small": "",
            "elevation": "0",
            "color": _vm.dpmStore.global.activeSweepExtension ? "light-blue" : "white"
          },
          on: {
            "click": function($event) {
              _vm.dpmStore.global.activeSweepExtension = !_vm.dpmStore.global.activeSweepExtension;
            }
          }
        }, on2), [_c("v-icon", {
          attrs: {
            "color": _vm.dpmStore.global.activeSweepExtension ? "white" : "black"
          }
        }, [_vm._v(_vm._s(_vm.$global.icons.mdiMapMarkerRadius))])], 1)];
      }
    }], null, false, 3841302449)
  }, [_c("span", [_vm._v("特定のSweepへ移動した際に出てくる情報の表示・非表示を設定出来ます")])])], 1) : _vm._e(), !(_vm.matterportStore.dockOpen || _vm.matterportStore.hideDpm) && _vm.notPlayer ? _c("div", {
    staticClass: "pe-auto",
    attrs: {
      "id": "shared-link-button"
    }
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref2) {
        var on2 = _ref2.on;
        return [_c("v-btn", _vm._g({
          attrs: {
            "fab": "",
            "small": "",
            "elevation": "0"
          },
          on: {
            "click": _vm.showSharedLink
          }
        }, on2), [_c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiShareVariant))])], 1)];
      }
    }], null, false, 1726413347)
  }, [_c("span", [_vm._v("現在地を共有するアドレスを表示します")])])], 1) : _vm._e(), _vm.isShowBgmUi() ? _c("div", {
    staticClass: "pe-auto",
    attrs: {
      "id": "bgm-toggle-button"
    }
  }, [_c("v-tooltip", {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(_ref3) {
        var on2 = _ref3.on;
        return [_c("v-btn", _vm._g({
          attrs: {
            "fab": "",
            "small": "",
            "elevation": "0"
          },
          on: {
            "click": _vm.toggleBgm
          }
        }, on2), [_vm.dpmStore.global.bgm.isPlaying ? _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiVolumeHigh))]) : _c("v-icon", [_vm._v(_vm._s(_vm.$global.icons.mdiVolumeOff))])], 1)];
      }
    }], null, false, 3513622060)
  }, [_vm.dpmStore.global.bgm.isPlaying ? _c("span", [_vm._v("BGM ON")]) : _c("span", [_vm._v("BGM OFF")])]), _c("div", {
    ref: "bgmElementContainer",
    staticClass: "d-none",
    attrs: {
      "id": "bgm-element-container"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm.dpmStore.global.groupListDrawer.display && !(_vm.matterportStore.dockOpen || _vm.matterportStore.hideDpm) && (!_vm.dpmStore.global.showCilbee || _vm.dpmStore.global.showShowcaseEditor) ? _c("MattertagGroupListDrawer") : _vm._e(), _vm.dpmStore.global.objectListDrawer.display && !(_vm.matterportStore.dockOpen || _vm.matterportStore.hideDpm) && (!_vm.dpmStore.global.showCilbee || _vm.dpmStore.global.showShowcaseEditor || !_vm.dpmStore.sharedExperience.room) ? _c("ObjectListDrawer") : _vm._e(), _vm.dpmStore.global.organizationListDrawer.display && !(_vm.matterportStore.dockOpen || _vm.matterportStore.hideDpm) && (!_vm.dpmStore.global.showCilbee || !_vm.dpmStore.sharedExperience.room) ? _c("OrganizationListDrawer") : _vm._e(), _vm.dpmStore.global.enableExtensions.trimming && !_vm.dpmStore.global.showCilbee && !_vm.dpmStore.sharedExperience.room ? _c("TrimmingEditor") : _vm._e(), _vm.dpmStore.global.enableExtensions.minimap && _vm.dpmStore.global.minimap && _vm.dpmStore.global.minimap.data && _vm.dpmStore.global.minimap.data.length ? _c("Minimap") : _vm._e()], 1)], 1), _c("div", {
    staticClass: "wrapper"
  }, [_c("v-dialog", {
    attrs: {
      "content-class": "dpm-bgm-modal",
      "max-width": "400",
      "persistent": ""
    },
    model: {
      value: _vm.bgmModal,
      callback: function($$v) {
        _vm.bgmModal = $$v;
      },
      expression: "bgmModal"
    }
  }, [_c("v-card", {
    staticClass: "text-center"
  }, [_c("v-card-title", {
    staticClass: "d-block"
  }, [_vm._v("BGMが流れます")]), _c("v-card-text", [_c("v-btn", {
    staticClass: "m-3",
    on: {
      "click": function($event) {
        return _vm.allowBgm(true);
      }
    }
  }, [_vm._v("OK")]), _c("v-btn", {
    staticClass: "m-3",
    on: {
      "click": function($event) {
        return _vm.allowBgm(false);
      }
    }
  }, [_vm._v("ミュート")])], 1)], 1)], 1)], 1), _vm.dpmStore.global.showSharedLink ? _c("SharedLinkModal") : _vm._e(), !(_vm.matterportStore.dockOpen || _vm.matterportStore.hideDpm) && _vm.notPlayer ? _c("BottomUi") : _vm._e(), _vm.dpmStore.global.showShowcaseEditor ? _c("ShowcaseEditor") : _vm._e(), _c("Note"), _c("div", {
    attrs: {
      "id": "version"
    }
  }, [_vm._v("Module ver: " + _vm._s(_vm.version))])], 1)], 1);
};
var staticRenderFns = [];
const __vue2_script = {
  components: {
    DpmExtensions,
    MattertagGroupListDrawer,
    Minimap,
    SharedExperience,
    ShowcaseEditor,
    BottomUi,
    SharedLinkModal,
    CilbeeApp,
    VirtualStaging,
    Note,
    TrimmingEditor,
    ObjectListDrawer,
    OrganizationListDrawer
  },
  data() {
    return {
      bgmController: null,
      bgmModal: false,
      version: "2026/08/28-15:20-b89050a"
    };
  },
  created() {
    return __async(this, null, function* () {
      const iframeElement = document.querySelector("iframe#showcase");
      this.matterportStore.iframeSize = { width: iframeElement.clientWidth, height: iframeElement.clientHeight };
      new ResizeObserver((entries) => {
        this.matterportStore.iframeSize = { width: entries[0].contentRect.width, height: entries[0].contentRect.height };
      }).observe(iframeElement);
      yield new Promise((resolve2, _reject) => {
        const waitElements = [
          "#bottom-ui .collapsible-list-items",
          "#showcase-modals > .modal-background",
          ".tool-overlay"
        ];
        let waitInterval = setInterval(() => {
          if (iframeElement.contentDocument.querySelectorAll(waitElements.join(",")).length === waitElements.length) {
            clearInterval(waitInterval);
            resolve2(true);
          }
        }, 100);
      });
      const dockOpenObserver = new MutationObserver((mutations) => {
        this.matterportStore.dockOpen = mutations[0].target.classList.contains("panel-open") || mutations[0].target.classList.contains("panel-collapsed");
      });
      const dockOpenObserverOption = {
        attributes: true,
        attributeFilter: ["class"]
      };
      iframeElement.contentDocument.querySelectorAll(".showcase-ui .panels").forEach((panel) => dockOpenObserver.observe(panel, dockOpenObserverOption));
      new MutationObserver((mutations) => {
        this.matterportStore.attachmentOpen = mutations[0].target.classList.contains("open");
      }).observe(iframeElement.contentDocument.querySelector(".showcase-ui .scene-overlay .overlay-ui .attachment-overlay"), {
        attributes: true,
        attributeFilter: ["class"]
      });
      if (iframeElement.contentDocument.querySelector("#bottom-ui .highlight-reel")) {
        new MutationObserver((mutations) => {
          this.matterportStore.reelOpen = !mutations[0].target.classList.contains("closed");
        }).observe(iframeElement.contentDocument.querySelector("#bottom-ui .highlight-reel"), {
          attributes: true,
          attributeFilter: ["class"]
        });
      }
      new MutationObserver((mutations) => {
        this.matterportStore.modalOpen = mutations[0].target.classList.contains("open");
      }).observe(iframeElement.contentDocument.querySelector("#showcase-modals > .modal-background"), {
        attributes: true,
        attributeFilter: ["class"]
      });
      new MutationObserver((mutations) => {
        var _a2, _b2, _c;
        this.matterportStore.measurementsOpen = !!((_c = (_b2 = (_a2 = mutations[0]) == null ? void 0 : _a2.addedNodes[0]) == null ? void 0 : _b2.classList) == null ? void 0 : _c.contains("measurements-overlay"));
      }).observe(iframeElement.contentDocument.querySelector(".tool-overlay"), {
        childList: true,
        subtree: true
      });
      this.dpmStore.$subscribe((mutation, _state) => {
        var _a2, _b2, _c;
        if (mutation.type.includes("patch") && ((_c = (_b2 = (_a2 = mutation == null ? void 0 : mutation.payload) == null ? void 0 : _a2.global) == null ? void 0 : _b2.bgm) == null ? void 0 : _c.isPlaying) !== void 0) {
          if (!this.bgmController) {
            return;
          }
          if (mutation.payload.global.bgm.isPlaying) {
            this.bgmController.play();
          } else {
            this.bgmController.pause();
          }
        }
      });
      const organizationListDrawer = JSON.parse(document.getElementById("showcase").dataset.organizationListDrawer);
      if (organizationListDrawer.data) {
        this.dpmStore.global.organizationListDrawer = organizationListDrawer;
      }
    });
  },
  methods: {
    showSharedLink() {
      this.dpmStore.$patch({ global: { showSharedLink: true } });
    },
    toggleBgm() {
      this.dpmStore.$patch({ global: { bgm: { isPlaying: !this.dpmStore.global.bgm.isPlaying, beforeState: !this.dpmStore.global.bgm.isPlaying } } });
    },
    allowBgm(allow) {
      if (allow) {
        this.dpmStore.$patch({ global: { bgm: { isPlaying: true } } });
      }
      this.bgmModal = false;
    },
    isShowBgmUi() {
      return this.dpmStore.global.bgm.url && !(this.matterportStore.dockOpen || this.matterportStore.hideDpm) && this.notPlayer && !this.dpmStore.global.showCilbee;
    }
  },
  computed: __spreadProps(__spreadValues({}, mapStores(useDpmStore, matterportStore)), {
    getExtraStyle() {
      var _a2, _b2, _c, _d2, _e;
      let extraStyle = "";
      if ((_b2 = (_a2 = this.dpmStore.current.extension) == null ? void 0 : _a2.data) == null ? void 0 : _b2.floatingPosition) {
        extraStyle = `.dpm-extensions .floating-content * {
          ${((_c = this.dpmStore.current.extension) == null ? void 0 : _c.maxWidth) ? `max-width: ${this.dpmStore.current.extension.maxWidth}px !important;` : "max-width: 320px;"}
        }`;
      } else {
        extraStyle = `.dpm-extension-modal {
          ${((_d2 = this.dpmStore.current.extension) == null ? void 0 : _d2.maxWidth) ? `max-width: ${this.dpmStore.current.extension.maxWidth}px !important;` : ""}
          ${((_e = this.dpmStore.current.extension) == null ? void 0 : _e.maxHeight) ? `max-height: ${this.dpmStore.current.extension.maxHeight}px !important;` : ""}
        }`;
      }
      return extraStyle;
    },
    notPlayer() {
      return !document.querySelector("#showcase.player");
    }
  }),
  mounted() {
    return __async(this, null, function* () {
      if (this.isShowBgmUi()) {
        const container2 = this.$refs.bgmElementContainer;
        const res = yield this.$global.utils.getMediaHtml(this.dpmStore.global.bgm.url, "audio", { autoPlay: this.dpmStore.global.bgm.autoPlay });
        container2.innerHTML = res.html;
        if (this.dpmStore.global.bgm.url.includes("soundcloud.com")) {
          this.bgmController = SC.Widget(container2.children[0]);
        } else {
          this.bgmController = container2.children[0];
        }
        if (this.dpmStore.global.bgm.autoPlay) {
          this.bgmModal = true;
        }
      }
    });
  }
};
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent$1(
  __vue2_script,
  render7,
  staticRenderFns,
  false,
  __vue2_injectStyles,
  null,
  null,
  null
);
function __vue2_injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
const Main = /* @__PURE__ */ function() {
  return __component__.exports;
}();
Vue$1.use(Vuetify);
Vue$1.use(PiniaVuePlugin);
Vue$1.use(VueI18n$1);
Vue$1.use(plugin$1);
class Component {
  constructor(options) {
    __publicField(this, "vueContext");
    // private vueIframeContext: any
    __publicField(this, "sdk");
    __publicField(this, "apiUrl");
    __publicField(this, "bgm");
    __publicField(this, "enableExtensions");
    __publicField(this, "showCilbee");
    __publicField(this, "showcaseEditorData", null);
    __publicField(this, "showShowcaseEditor", false);
    __publicField(this, "showVirtualStaging", false);
    __publicField(this, "virtualStagingAssets", []);
    __publicField(this, "groupListDrawer");
    __publicField(this, "objectListDrawer");
    __publicField(this, "minimap");
    __publicField(this, "mattertags");
    __publicField(this, "modelSid");
    __publicField(this, "rooms");
    __publicField(this, "dpmStore");
    __publicField(this, "attachments");
    __publicField(this, "cilbeeStore");
    __publicField(this, "sharedExperience");
    __publicField(this, "scene");
    __publicField(this, "floors");
    __publicField(this, "labels");
    __publicField(this, "sweeps");
    __publicField(this, "standalone");
    __publicField(this, "pinia");
    var _a2;
    Object.assign(this, options);
    const iframe = document.getElementById("showcase");
    Vue$1.prototype.$global = __spreadValues(__spreadValues({}, Vue$1.prototype.$global), {
      icons,
      utils: Utils,
      swatches: [
        ["#d44441", "#f44336", "#e91e63"],
        ["#f78da7", "#9c4b92", "#673ab7"],
        ["#03687d", "#03a9f4", "#00bcd4"],
        ["#417505", "#51a868", "#37d67a"],
        ["#cddc39", "#fbcd00", "#ffac17"],
        ["#ff6900", "#abb8c3", "#607d8b"]
      ],
      rules: {
        required: (value) => !!value || "このフィールドは空に出来ません"
        // min: v => v.length >= 8 || 'Min 8 characters',
        // emailMatch: () => (`The email and password you entered don't match`),
      },
      apiUrl: this.apiUrl,
      sdk: this.sdk,
      csrfHeader: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]') ? document.querySelector('meta[name="csrf-token"]').getAttribute("content") : ""
      }
    });
    const vuetify2 = new Vuetify({
      icons: {
        iconfont: "mdiSvg"
      }
    });
    const i18n = new VueI18n$1({
      locale: navigator.language,
      fallbackLocale: "en",
      messages
    });
    this.vueContext = new Vue$1({
      vuetify: vuetify2,
      pinia: this.pinia,
      i18n,
      render: (h) => h(Main, {
        ref: "dpm"
      })
    });
    this.dpmStore = useDpmStore();
    this.dpmStore.$reset();
    this.dpmStore.$patch({
      global: {
        attachments: this.attachments,
        attachmentType: this.sdk.Tag.AttachmentType,
        bgm: this.bgm,
        enableExtensions: this.enableExtensions,
        floors: this.floors,
        groupListDrawer: this.groupListDrawer,
        labels: this.labels,
        mattertags: this.mattertags,
        minimap: this.minimap,
        modelSid: this.modelSid,
        objectListDrawer: this.objectListDrawer,
        rooms: this.rooms,
        scene: this.scene,
        showCilbee: this.showCilbee,
        showShowcaseEditor: this.showShowcaseEditor,
        showVirtualStaging: this.showVirtualStaging,
        standalone: this.standalone,
        sweeps: this.sweeps,
        userName: iframe.dataset.userName
      }
    });
    this.cilbeeStore = useCilbeeStore();
    this.cilbeeStore.$reset();
    (_a2 = this.showcaseEditorData) == null ? void 0 : _a2.mattertags.forEach((mattertag) => {
      if (mattertag.extension === void 0) {
        mattertag.extension = null;
      }
    });
    this.dpmStore.showcaseEditorData = __spreadValues(__spreadValues({}, this.dpmStore.SED), this.showcaseEditorData);
    this.dpmStore.setUngroupedMattertags();
    this.dpmStore.sharedExperience = __spreadValues(__spreadValues({}, this.dpmStore.sharedExperience), this.sharedExperience);
    this.cilbeeStore.passableAreas = this.showcaseEditorData.cilbee.passableAreas;
    this.dpmStore.virtualStaging.assets = this.virtualStagingAssets;
    this.subscribeShowcaseData();
    if (this.dpmStore.global.enableExtensions.sweep) {
      this.showCustomSweep();
    }
    if (this.dpmStore.global.showCilbee) {
      this.dpmStore.global.activeSweepExtension = false;
    }
    iframe.parentElement.appendChild(this.vueContext.$mount().$el);
    let focusedTag = null;
    const officialAttachmentUiObserver = new MutationObserver((mutations) => __async(this, null, function* () {
      var _a3, _b2, _c, _d2, _e, _f, _g, _h, _i2, _j, _k, _l, _m, _n2, _o, _p;
      const getDpmAttachmentIframeElement = (focusedTag2) => {
        return Object.assign(document.createElement("div"), { innerHTML: `
          <div class="iframe-content dpm-media">
            <div class="oembed oembed-loading is-loaded">
              <div class="gui-spinner-icon"></div>
            </div>
            <div class="media ${focusedTag2.carouselItems[0].type}">${focusedTag2.carouselItems[0].src}</div>
          </div>
        ` }).firstElementChild;
      };
      const getDpmAttachmentImageElement = (focusedTag2) => {
        return Object.assign(document.createElement("div"), { innerHTML: `
          <div class="image-content dpm-media attachment-preview">
            <div class="oembed-image fill-cover-image attachment-view clickable" style="min-height: 275px; max-width: 366px;">
              <div class="fill-blur" style="background-image: url('${focusedTag2.carouselItems[0].src}');"></div>
              <img class="image attachment-view clickable" src="${focusedTag2.carouselItems[0].src}" style="max-height: 488px;"/>
            </div>
          </div>
        ` }).firstElementChild;
      };
      const setFocusedTag = () => __async(this, null, function* () {
        focusedTag = __spreadProps(__spreadValues({}, _clone$1(this.dpmStore.global.mattertags[window.focusedTagSid])), {
          carouselItems: [],
          attachmentDownloadLinks: []
        });
        if (focusedTag.attachments.length) {
          yield this.dpmStore.setAttachmentsData(focusedTag, { autoPlay: true });
        }
      });
      for (let i2 = 0; i2 < mutations.length; i2++) {
        if (mutations[i2].addedNodes.length && mutations[i2].target === iframe.contentDocument.querySelector(".text-box-text")) {
          mutations[i2].target.querySelectorAll('a[data-blocktype="link"]').forEach((el) => el.removeAttribute("data-blocktype"));
        }
        if (mutations[i2].addedNodes[0] === iframe.contentDocument.querySelector(".oembed.oembed-error")) {
          yield setFocusedTag();
          if ((_a3 = focusedTag.carouselItems[0]) == null ? void 0 : _a3.type.includes("html-iframe")) {
            mutations[i2].addedNodes[0].closest(".attachment-external").prepend(getDpmAttachmentIframeElement(focusedTag));
          } else if (((_b2 = focusedTag.carouselItems[0]) == null ? void 0 : _b2.type) === "image" && !/cdn.*matterport\.com/.test(focusedTag.carouselItems[0].src)) {
            mutations[i2].addedNodes[0].closest(".attachment-external").prepend(getDpmAttachmentImageElement(focusedTag));
          }
        } else if (mutations[i2].removedNodes.length && mutations[i2].removedNodes[0].nodeType === Node.ELEMENT_NODE && ((_c = mutations[i2].removedNodes[0].classList) == null ? void 0 : _c.contains("tag-media")) && !mutations[i2].target.querySelector(".tag-media") && (((_d2 = mutations[i2].target.classList) == null ? void 0 : _d2.contains("tag-billboard-contents")) || ((_e = mutations[i2].target.classList) == null ? void 0 : _e.contains("tag-view-panel")) && true)) {
          yield setFocusedTag();
          if ((_f = focusedTag.carouselItems[0]) == null ? void 0 : _f.type.includes("html-iframe")) {
            const officialWrapperMock = Object.assign(document.createElement("div"), {
              innerHTML: `
              <div class="tag-media">
                <div class="attachment-carousel">
                  <div class="attachment-carousel-view">
                    <div class="attachment-container">
                      <div class="attachment attachment-external">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            `
            }).firstElementChild;
            officialWrapperMock.querySelector(".attachment-external").prepend(getDpmAttachmentIframeElement(focusedTag));
            mutations[i2].target.prepend(officialWrapperMock);
          }
        } else if (mutations[i2].removedNodes.length && mutations[i2].removedNodes[0].nodeType === Node.ELEMENT_NODE) {
          if (((_g = mutations[i2].removedNodes[0].classList) == null ? void 0 : _g.contains("tags-navigation-overlay")) && ((_h = mutations[i2].target.classList) == null ? void 0 : _h.contains("tags-overlay"))) {
            const tagMediaElements = (_i2 = mutations[i2].target.closest(".scene-overlay")) == null ? void 0 : _i2.querySelectorAll(".tag-media");
            if (tagMediaElements.length === 1) {
              tagMediaElements.forEach((tagMediaElement) => __async(this, null, function* () {
                var _a4, _b3;
                if (tagMediaElement.querySelector(".dpm-media")) {
                  tagMediaElement.querySelector(".dpm-media").remove();
                  yield setFocusedTag();
                  if ((_a4 = focusedTag.carouselItems[0]) == null ? void 0 : _a4.type.includes("html-iframe")) {
                    tagMediaElement.querySelector(".attachment").prepend(getDpmAttachmentIframeElement(focusedTag));
                  } else if (((_b3 = focusedTag.carouselItems[0]) == null ? void 0 : _b3.type) === "image" && !/cdn.*matterport\.com/.test(focusedTag.carouselItems[0].src)) {
                    tagMediaElement.querySelector(".attachment").prepend(getDpmAttachmentImageElement(focusedTag));
                  }
                }
              }));
            } else if (tagMediaElements.length > 1) {
              tagMediaElements.forEach((tagMediaElement) => {
                if (tagMediaElement.querySelector(".dpm-media")) {
                  tagMediaElement.remove();
                }
              });
            }
          } else if (((_j = mutations[i2].removedNodes[0].classList) == null ? void 0 : _j.contains("oembed-error")) && ((_k = mutations[i2].target.classList) == null ? void 0 : _k.contains("attachment"))) {
            mutations[i2].target.querySelectorAll(".dpm-media").forEach((iframeContent) => {
              iframeContent.remove();
            });
          } else if (((_l = mutations[i2].removedNodes[0].classList) == null ? void 0 : _l.contains("oembed")) && ((_m = mutations[i2].target.classList) == null ? void 0 : _m.contains("attachment"))) {
            (_n2 = mutations[i2].target.closest(".tag-view-panel")) == null ? void 0 : _n2.querySelectorAll(".tag-media").forEach((tagMediaElement) => {
              if (tagMediaElement.querySelector(".dpm-media")) {
                tagMediaElement.remove();
              }
            });
          }
          ovserveOfficialAttachmentUiObserver();
        } else if (mutations[i2].type === "characterData" && mutations[i2].target.parentElement.classList.contains("tag-view-panel-title")) {
          const tagMediaElement = mutations[i2].target.parentElement.closest(".tag-view-panel").querySelector(".tag-media");
          if (tagMediaElement.querySelector(".dpm-media")) {
            tagMediaElement.querySelector(".dpm-media").remove();
            yield setFocusedTag();
            if ((_o = focusedTag.carouselItems[0]) == null ? void 0 : _o.type.includes("html-iframe")) {
              tagMediaElement.querySelector(".attachment").prepend(getDpmAttachmentIframeElement(focusedTag));
            } else if (((_p = focusedTag.carouselItems[0]) == null ? void 0 : _p.type) === "image" && !/cdn.*matterport\.com/.test(focusedTag.carouselItems[0].src)) {
              tagMediaElement.querySelector(".attachment").prepend(getDpmAttachmentImageElement(focusedTag));
            }
          }
        }
      }
    }));
    const ovserveOfficialAttachmentUiObserver = () => {
      const intervalId = setInterval(() => {
        const targetElement = iframe.contentDocument.querySelector(".showcase-ui");
        if (targetElement) {
          clearInterval(intervalId);
          officialAttachmentUiObserver.observe(iframe.contentDocument.querySelector(".showcase-ui"), { characterData: true, childList: true, subtree: true });
        }
      }, 100);
    };
    ovserveOfficialAttachmentUiObserver();
  }
  subscribeShowcaseData() {
    let time = Date.now() - 1e3;
    this.sdk.Camera.pose.subscribe((pose) => {
      if (Date.now() - time > 1e3 && pose.mode !== this.sdk.Mode.Mode.TRANSITIONING) {
        this.dpmStore.$patch({ current: { pose: JSON.parse(JSON.stringify(pose)) } });
        time = Date.now();
      }
    });
    let onStartSweepCurrentSubscribe = true;
    this.sdk.Sweep.current.subscribe((currentSweep) => {
      this.dpmStore.$patch({ current: { sweep: JSON.parse(JSON.stringify(currentSweep)) } });
      if (onStartSweepCurrentSubscribe && this.dpmStore.global.activeSweepExtension) {
        this.dpmStore.$patch({ current: { sweepSid: currentSweep.sid } });
        if (this.dpmStore.currentSweepGroup && this.dpmStore.currentSweepGroup.extension) {
          this.dpmStore.$patch({ current: { extension: this.dpmStore.currentSweepGroup.extension } });
        }
        onStartSweepCurrentSubscribe = false;
      }
    });
    this.sdk.Floor.current.subscribe((currentFloor) => {
      var _a2;
      if (currentFloor.id === "" && currentFloor.sequence === -1 && currentFloor.name === "all") {
        this.dpmStore.$patch({ current: { floor: JSON.parse(JSON.stringify(this.dpmStore.current.sweep.floorInfo)) } });
      } else if (currentFloor.sequence !== void 0 && currentFloor.sequence >= 0 && ((_a2 = this.dpmStore.current.floor) == null ? void 0 : _a2.sequence) !== currentFloor.sequence) {
        this.dpmStore.$patch({ current: { floor: JSON.parse(JSON.stringify(currentFloor)) } });
      }
    });
    this.sdk.Mode.current.subscribe((mode) => {
      this.dpmStore.$patch({ current: { mode } });
    });
  }
  showCustomSweep() {
    return __async(this, null, function* () {
      const customSweepsNode = (yield this.sdk.Scene.createObjects(1))[0].addNode();
      customSweepsNode.name = "CustomSweeps";
      const tmpNode = (yield this.sdk.Scene.createObjects(1))[0].addNode();
      tmpNode.start();
      const sweepPucks = [];
      tmpNode.obj3D.parent.parent.children[3].traverse((node2) => {
        if (node2.sweep) {
          sweepPucks.push({ name: node2.name, position: node2.position });
        }
      });
      this.dpmStore.SED.sweep_groups.forEach((sweepGroup) => {
        sweepGroup.sweeps.forEach((groupedSweepSid) => {
          const customizedSweep = this.dpmStore.SED.sweeps.find((sweep) => sweep.sid === groupedSweepSid);
          const sweepSvg = {
            bgColor: "#00000000",
            degree: 0
          };
          if (!sweepGroup.colorless) {
            if (!customizedSweep || customizedSweep.colorless) {
              sweepSvg.bgColor = sweepGroup.color;
            }
          }
          if (customizedSweep) {
            if (!customizedSweep.colorless) {
              sweepSvg.bgColor = customizedSweep.bgColor;
            }
            sweepSvg.icon = customizedSweep.icon;
            sweepSvg.degree = customizedSweep.degree;
          }
          customSweepsNode.addComponent("dpm.sweep", {
            svgTag: Utils.SVG.createSweepSvgTag(sweepSvg.icon ? sweepSvg.icon : null, sweepSvg.bgColor, 1 / 90),
            position: sweepPucks.find((sweepPuck) => sweepPuck.name === groupedSweepSid).position,
            degree: sweepSvg.degree
          });
        });
      });
      this.dpmStore.SED.sweeps.filter((sweep) => !this.dpmStore.SED.sweep_groups.find((sweepGroup) => sweepGroup.sweeps.find((groupedSweepSid) => groupedSweepSid === sweep.sid))).forEach((sweep) => {
        customSweepsNode.addComponent("dpm.sweep", {
          svgTag: Utils.SVG.createSweepSvgTag(sweep.icon, sweep.colorless ? "#00000000" : sweep.bgColor, 1 / 90),
          position: sweepPucks.find((sweepPuck) => sweepPuck.name === sweep.sid).position,
          degree: sweep.degree
        });
      });
      customSweepsNode.start();
    });
  }
}
class EventsPlayer {
  constructor(sdk) {
    __publicField(this, "currentEventsIndex", 0);
    __publicField(this, "waitTransition", () => {
      this.availableElements(true);
    });
    __publicField(this, "elements", null);
    __publicField(this, "playing", false);
    __publicField(this, "transitionTime", 30);
    __publicField(this, "originSweepSids", []);
    __publicField(this, "originMattertagSids", []);
    __publicField(this, "recordingEvents", []);
    this.sdk = sdk;
  }
  createButton(id, text2) {
    let element = document.createElement("div");
    element.id = id;
    element.innerHTML = text2;
    return element;
  }
  createElementFromHTML(htmlString) {
    let div = document.createElement("div");
    div.innerHTML = htmlString.trim();
    return div.firstChild;
  }
  availableElements(flag) {
    let className = flag ? "" : "disabled";
    this.elements.playBtn.className = className;
    this.elements.stopBtn.className = className;
    this.elements.skipStartBtn.className = className;
    this.elements.prevBtn.className = className;
    this.elements.nextBtn.className = className;
    this.elements.skipEndBtn.className = className;
  }
  reset() {
    return __async(this, null, function* () {
      let oldContainer = document.getElementById("dpm-events-player");
      if (oldContainer) {
        if (this.recordingEvents.length && this.recordingEvents[this.currentEventsIndex].data !== this.recordingEvents[0].data) {
          yield this.moveModeAndSweepTo(this.recordingEvents[0].data);
        }
        oldContainer.remove();
      }
      this.currentEventsIndex = 0;
    });
  }
  prepare(eventsData) {
    return __async(this, null, function* () {
      yield new Promise((resolve2, _reject) => {
        this.sdk.Sweep.data.subscribe({
          onCollectionUpdated: (collection) => {
            this.originSweepSids = Object.keys(collection);
            resolve2(true);
          }
        });
      });
      yield new Promise((resolve2, _reject) => {
        this.sdk.Tag.data.subscribe({
          onCollectionUpdated: (collection) => {
            this.originMattertagSids = Object.keys(collection);
            resolve2(true);
          }
        });
      });
      const jsonStringToObject = (data) => {
        try {
          return JSON.parse(data);
        } catch (error2) {
          return data;
        }
      };
      eventsData.forEach((event) => {
        event.data = jsonStringToObject(event.data);
      });
      this.recordingEvents = eventsData.filter((event) => {
        if (typeof event.data === "string") {
          return true;
        }
        if (event.data.sweep && this.originSweepSids.includes(event.data.sweep) && event.data.mode !== this.sdk.Mode.Mode.TRANSITIONING) {
          return true;
        }
        if (event.data.mode === this.sdk.Mode.Mode.DOLLHOUSE || event.data.mode === this.sdk.Mode.Mode.FLOORPLAN) {
          return true;
        }
        if (event.data.Mattertag && event.data.Mattertag.type === "tag.gaze") {
          return false;
        }
        if (event.data.Mattertag && this.originMattertagSids.includes(event.data.Mattertag.tagSid)) {
          return true;
        }
        return false;
      });
      this.elements = {
        seekbar: this.createElementFromHTML(`
        <div id="seekbar">
          <div class="progress">
            <div id="seekbar-progress-bar" class="progress-bar" role="progressbar" style="width: 0%"></div>
          </div>
          <input type="range" class="form-range" id="seekbar-range" value="0" min="0" max="${this.recordingEvents.length - 1}">
        </div>
      `),
        playBtn: this.createButton("play-btn", '<i class="bi bi-play-fill"></i>'),
        stopBtn: this.createButton("stop-btn", '<i class="bi bi-stop-fill"></i>'),
        skipStartBtn: this.createButton("skip-start-btn", '<i class="bi bi-skip-start-fill"></i>'),
        prevBtn: this.createButton("prev-btn", '<i class="bi bi-chevron-left"></i>'),
        nextBtn: this.createButton("next-btn", '<i class="bi bi-chevron-right"></i>'),
        skipEndBtn: this.createButton("skip-end-btn", '<i class="bi bi-skip-end-fill"></i>'),
        eventType: this.createElementFromHTML(`<div id="event-type">${this.recordingEvents.length ? "" : "No event"}</div>`),
        counter: this.createElementFromHTML(`<div id="counter">${this.recordingEvents.length ? 1 : 0} / ${this.recordingEvents.length}</div>`)
      };
      const showcaseIframe = document.getElementById("showcase");
      showcaseIframe.className = "player";
      this.elements.playBtn.addEventListener("click", () => __async(this, null, function* () {
        this.availableElements(false);
        this.elements.stopBtn.className = "";
        yield this.play();
      }));
      this.elements.stopBtn.addEventListener("click", () => __async(this, null, function* () {
        yield this.stop();
      }));
      this.elements.skipStartBtn.addEventListener("click", () => __async(this, null, function* () {
        this.availableElements(false);
        yield this.skipStart();
        setTimeout(this.waitTransition(), this.transitionTime);
      }));
      this.elements.prevBtn.addEventListener("click", () => __async(this, null, function* () {
        this.availableElements(false);
        yield this.prev();
        setTimeout(this.waitTransition(), this.transitionTime);
      }));
      this.elements.nextBtn.addEventListener("click", () => __async(this, null, function* () {
        this.availableElements(false);
        yield this.next();
        setTimeout(this.waitTransition(), this.transitionTime);
      }));
      this.elements.skipEndBtn.addEventListener("click", () => __async(this, null, function* () {
        this.availableElements(false);
        yield this.skipEnd();
        setTimeout(this.waitTransition(), this.transitionTime);
      }));
      const container2 = this.createElementFromHTML('<div id="dpm-events-player" />');
      container2.appendChild(this.elements.seekbar);
      container2.appendChild(this.elements.playBtn);
      container2.appendChild(this.elements.stopBtn);
      container2.appendChild(this.elements.skipStartBtn);
      container2.appendChild(this.elements.prevBtn);
      container2.appendChild(this.elements.nextBtn);
      container2.appendChild(this.elements.skipEndBtn);
      container2.appendChild(this.elements.eventType);
      container2.appendChild(this.elements.counter);
      showcaseIframe.after(container2);
      this.availableElements(false);
      document.getElementById("seekbar-range").addEventListener("change", (e) => __async(this, null, function* () {
        this.currentEventsIndex = Number(e.target.value);
        yield this.goTo(this.currentEventsIndex);
      }));
      if (this.recordingEvents.length) {
        this.sdk.App.state.subscribe((appState) => __async(this, null, function* () {
          if (appState.phase === this.sdk.App.Phase.PLAYING) {
            yield this.goTo(this.currentEventsIndex);
            setTimeout(this.waitTransition(), this.transitionTime);
          }
        }));
      } else {
        this.availableElements(false);
      }
    });
  }
  rotateCameraTo(rotation) {
    this.sdk.Camera.setRotation(rotation);
  }
  moveModeAndSweepTo(data) {
    return __async(this, null, function* () {
      if (typeof data === "object") {
        if (data.mode === this.sdk.Mode.Mode.INSIDE) {
          return yield this.sdk.Sweep.moveTo(data.sweep, {
            rotation: data.rotation,
            transition: this.sdk.Sweep.Transition.FLY,
            transitionTime: this.transitionTime
          });
        } else {
          return yield this.sdk.Mode.moveTo(data.mode, {
            position: data.position,
            rotation: data.rotation,
            transition: this.sdk.Sweep.Transition.FLY,
            transitionTime: this.transitionTime
          });
        }
      } else {
        return yield this.sdk.Sweep.moveTo(data, {
          transition: this.sdk.Sweep.Transition.FLY,
          transitionTime: this.transitionTime
        });
      }
    });
  }
  play() {
    return __async(this, null, function* () {
      this.playing = true;
      while (this.currentEventsIndex < this.recordingEvents.length - 1) {
        if (!this.playing) {
          break;
        }
        yield this.next();
        yield new Promise((resolve2) => {
          setTimeout(() => {
            resolve2(true);
          }, this.transitionTime);
        });
      }
      this.stop();
    });
  }
  stop() {
    this.playing = false;
    this.availableElements(true);
  }
  skipEnd() {
    return __async(this, null, function* () {
      this.currentEventsIndex = this.recordingEvents.length - 1;
      yield this.goTo(this.currentEventsIndex);
    });
  }
  skipStart() {
    return __async(this, null, function* () {
      this.currentEventsIndex = 0;
      yield this.goTo(this.currentEventsIndex);
    });
  }
  setSeekbar() {
    document.getElementById("seekbar-progress-bar").style.width = `${100 / (this.recordingEvents.length - 1) * this.currentEventsIndex}%`;
    document.getElementById("seekbar-range").value = `${this.currentEventsIndex}`;
  }
  goTo(index2) {
    return __async(this, null, function* () {
      this.setSeekbar();
      this.elements.counter.innerHTML = `${index2 + 1} / ${this.recordingEvents.length}`;
      const data = this.recordingEvents[index2].data;
      this.elements.eventType.innerHTML = data.Mattertag ? `Mattertag: ${data.Mattertag.type}` : "Camera: move";
      if (data.Mattertag) {
        window.focusedTagSid = data.Mattertag.tagSid;
        yield this.sdk.Mattertag.navigateToTag(data.Mattertag.tagSid, this.sdk.Mattertag.Transition.FLY);
        return yield new Promise((resolve2) => setTimeout(resolve2, 2e3));
      } else {
        return yield this.moveModeAndSweepTo(data);
      }
    });
  }
  next() {
    return __async(this, null, function* () {
      if (this.currentEventsIndex === this.recordingEvents.length - 1) {
        return;
      }
      return yield this.goTo(++this.currentEventsIndex);
    });
  }
  prev() {
    return __async(this, null, function* () {
      if (this.currentEventsIndex <= 0) {
        return;
      }
      return yield this.goTo(--this.currentEventsIndex);
    });
  }
}
class EventsRecorder {
  constructor(sdk, apiUrl, recordingID, hasGuestbook) {
    this.sdk = sdk;
    this.apiUrl = apiUrl;
    this.recordingID = recordingID;
    this.hasGuestbook = hasGuestbook;
    if (this.hasGuestbook) {
      this.sdk.on(this.sdk.Camera.Event.MOVE, (pose) => {
        const copyPose = JSON.parse(JSON.stringify(pose));
        if (copyPose.sweep && copyPose.mode !== this.sdk.Mode.Mode.TRANSITIONING) {
          delete copyPose.projection;
          if (copyPose.mode === this.sdk.Mode.Mode.INSIDE) {
            delete copyPose.position;
          } else {
            delete copyPose.sweep;
          }
          axios$1.post(`${this.apiUrl}/${this.recordingID}/events.json`, {
            event: { recording_id: this.recordingID, data: JSON.stringify(copyPose) }
          });
        }
      });
    } else {
      this.sdk.Sweep.current.subscribe((currentSweep) => {
        if (currentSweep.sid !== "") {
          axios$1.post(`${this.apiUrl}/${this.recordingID}/events.json`, {
            event: { recording_id: this.recordingID, data: currentSweep.sid }
          });
        }
      });
    }
    this.sdk.on(this.sdk.Mattertag.Event.CLICK, (tagSid) => {
      axios$1.post(`${this.apiUrl}/${this.recordingID}/events.json`, {
        event: { recording_id: this.recordingID, data: JSON.stringify({ Mattertag: { type: this.sdk.Mattertag.Event.CLICK, tagSid } }) }
      });
    });
    this.sdk.on(this.sdk.Mattertag.Event.LINK_OPEN, (tagSid, url) => {
      axios$1.post(`${this.apiUrl}/${this.recordingID}/events.json`, {
        event: { recording_id: this.recordingID, data: JSON.stringify({ Mattertag: { type: this.sdk.Mattertag.Event.LINK_OPEN, tagSid, url } }) }
      });
    });
    let gazeTimer = null;
    this.sdk.on(this.sdk.Mattertag.Event.HOVER, (tagSid, hovering) => {
      if (hovering) {
        gazeTimer = setTimeout(() => {
          axios$1.post(`${this.apiUrl}/${this.recordingID}/events.json`, {
            event: { recording_id: this.recordingID, data: JSON.stringify({ Mattertag: { type: "tag.gaze", tagSid } }) }
          });
        }, 3e3);
      } else {
        clearTimeout(gazeTimer);
      }
    });
    let currentTourIndex = 0;
    this.sdk.on(this.sdk.Tour.Event.STEPPED, (tourIndex) => {
      currentTourIndex = tourIndex;
    });
    this.sdk.on(this.sdk.Tour.Event.STARTED, () => {
      axios$1.post(`${this.apiUrl}/${this.recordingID}/events.json`, {
        event: { recording_id: this.recordingID, data: JSON.stringify({ Tour: { startIndex: currentTourIndex } }) }
      });
    });
  }
}
const Module = { Component, EventsPlayer, EventsRecorder };
const DP = { Module, Scene: Scene2, Utils };
const index = "";
const showcaseCss = "body.showcase>section#app-container #loading-header.hidden{display:block!important}body.showcase>section#app-container #loading-presented-by{opacity:1!important}body.showcase>section#app-container .loadingSpinner{display:none}body.showcase>section#app-container #bottom-ui .fullscreen-mode{display:none}body.showcase>section#app-container #bottom-ui .collapsible-list-items{margin-right:40px}body.showcase>section#app-container #bottom-ui .collapsible-list-items.margin-icon-2{margin-right:72px}body.showcase>section#app-container .billboard-content>.iframe-content{min-width:320px;margin-top:12px}body.showcase>section#app-container .top-ui{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;flex-direction:column;-webkit-box-align:start;-webkit-align-items:start;-moz-box-align:start;align-items:start}body.showcase>section#app-container .top-ui img{max-height:3rem}body.showcase>section#app-container .top-ui .search-mode-button{display:none}body.showcase>section#app-container .top-ui .child-container{-webkit-align-self:unset!important;align-self:unset!important}body.showcase>section#app-container .top-ui .main-title{min-width:unset!important;max-width:90vw!important}body.showcase>section#app-container .showcase-ui .annotation-preview.tag-preview{pointer-events:none}body.showcase>section#app-container .showcase-ui .annotation-preview.tag-preview .annotation-preview-contents{pointer-events:auto}body.showcase>section#app-container .showcase-ui .tag-view-panel .tag-media.embed-error:before{height:0px!important}body.showcase>section#app-container .showcase-ui .attachment-carousel-view{height:auto!important}body.showcase>section#app-container .showcase-ui .attachment-carousel-view .attachment .iframe-content{margin-top:8px;width:100%}body.showcase>section#app-container .showcase-ui .attachment-carousel-view .attachment .iframe-content .oembed-loading{background-color:transparent}body.showcase>section#app-container .showcase-ui .attachment-carousel-view .attachment .iframe-content .media{position:relative;z-index:1}body.showcase>section#app-container .showcase-ui .attachment-carousel-view .attachment .iframe-content .media.html-iframe-youtube,body.showcase>section#app-container .showcase-ui .attachment-carousel-view .attachment .iframe-content .media.html-iframe-vimeo,body.showcase>section#app-container .showcase-ui .attachment-carousel-view .attachment .iframe-content .media.html-iframe-soundcloud{padding-top:56.25%}body.showcase>section#app-container .showcase-ui .attachment-carousel-view .attachment .iframe-content .media.html-iframe-youtube iframe,body.showcase>section#app-container .showcase-ui .attachment-carousel-view .attachment .iframe-content .media.html-iframe-vimeo iframe,body.showcase>section#app-container .showcase-ui .attachment-carousel-view .attachment .iframe-content .media.html-iframe-soundcloud iframe{position:absolute;top:0;left:0;width:100%;height:100%}body.showcase>section#app-container .overlay-top-center .overlay-info .list-nav{display:none}body.showcase>section#app-container .tag-preview .tag-billboard .tag-billboard-contents .tag-billboard-description{margin-bottom:0}body.showcase>section#app-container .tool-panel .detail-panel-header .list-nav{display:none}body.showcase>section#app-container .oembed-error{display:none}\n";
Vue$1.use(PiniaVuePlugin);
Vue$1.prototype.$global = {};
const pinia = createPinia();
class DriftPhotoModule {
  // TODO: 各種データを引数じゃなくthis.showcase.datasetから取ってくるようにしたい
  constructor(modelSid, options = {}) {
    __publicField(this, "showcase");
    __publicField(this, "sdk");
    __publicField(this, "scene", null);
    __publicField(this, "eventsPlayer", null);
    __publicField(this, "showShowcaseEditor", false);
    __publicField(this, "apiUrl", null);
    __publicField(this, "hasGuestbook", false);
    __publicField(this, "recordingId", null);
    __publicField(this, "showcaseEditorData", null);
    __publicField(this, "urlParams", {});
    __publicField(this, "minimap", null);
    __publicField(this, "enableExtensions", { mattertag: false, sweep: false, minimap: false });
    __publicField(this, "showCilbee", false);
    __publicField(this, "sharedExperience", null);
    __publicField(this, "groupListDrawer", { display: false, expand: false });
    __publicField(this, "objectListDrawer", { display: false, expand: false });
    __publicField(this, "standalone", false);
    __publicField(this, "showVirtualStaging", false);
    __publicField(this, "virtualStagingAssets");
    __publicField(this, "debug");
    __publicField(this, "bgm", { autpPlay: false, url: null, isPlaying: false });
    __publicField(this, "applicationKey", null);
    this.modelSid = modelSid;
    this.showcase = document.getElementById("showcase");
    const jsonStringToObject = (data2) => {
      try {
        return JSON.parse(data2);
      } catch (error2) {
        return data2;
      }
    };
    const data = JSON.parse(JSON.stringify(options));
    Object.keys(data).forEach((key) => data[key] = jsonStringToObject(data[key]));
    Object.assign(this, data);
    if (this.debug) {
      window.DPM = this;
    }
    if (this.showCilbee) {
      this.urlParams.play = 1;
      this.urlParams.hl = 2;
      const vueContext = new Vue$1({
        pinia,
        render: (h) => h(LoadingUi)
      });
      this.showcase.parentElement.appendChild(vueContext.$mount().$el);
    }
  }
  load() {
    return __async(this, null, function* () {
      let paramsString = "";
      if (this.standalone) {
        new URL(window.location.href).searchParams.forEach((value, key) => {
          this.urlParams[key] = value;
        });
      }
      if (Object.keys(this.urlParams)) {
        paramsString = Object.keys(this.urlParams).map((key) => `&${key}=${this.urlParams[key]}`).join("");
      }
      this.showcase.src = `/bundle/showcase.html?useLegacyIds=0&m=${this.modelSid}&applicationKey=${this.applicationKey ? this.applicationKey : "w08eg7ghix30593s0krdrp9tc"}${paramsString}&newtags=1`;
      return new Promise((resolve2, _reject) => {
        this.showcase.addEventListener("load", () => __async(this, null, function* () {
          const customIframeStyle = document.createElement("style");
          customIframeStyle.innerHTML = showcaseCss;
          this.showcase.contentWindow.document.head.appendChild(customIframeStyle);
          if (this.showcase.dataset.password) {
            const passwordObserver = new MutationObserver((mutations) => __async(this, null, function* () {
              mutations.forEach((mutation) => {
                if (mutation.addedNodes.length && mutation.addedNodes[0].className === "sc-password-ui") {
                  passwordObserver.disconnect();
                  const passwordInput = this.showcase.contentDocument.querySelector(".sc-password-input");
                  passwordInput.value = this.showcase.dataset.password;
                  passwordInput.dispatchEvent(new Event("input", { bubbles: true }));
                  setTimeout(() => {
                    this.showcase.contentDocument.querySelector(".sc-password-submit").click();
                  }, 100);
                }
              });
            }));
            passwordObserver.observe(this.showcase.contentDocument.querySelector("body"), { childList: true, subtree: true });
          }
          if (this.showcase.dataset.logoUrl) {
            const img = document.createElement("img");
            img.src = this.showcase.dataset.logoUrl;
            const logoObserver = new MutationObserver((mutations) => {
              for (const mutation of mutations) {
                for (const node2 of Array.from(mutation.addedNodes)) {
                  if (node2.nodeType === Node.ELEMENT_NODE && node2.classList.contains("showcase-ui")) {
                    logoObserver.disconnect();
                    const timer = setInterval(() => {
                      const topUiElement = node2.querySelector(".top-ui");
                      if (topUiElement) {
                        clearInterval(timer);
                        topUiElement.appendChild(img);
                      }
                    }, 100);
                  }
                }
              }
            });
            logoObserver.observe(this.showcase.contentDocument.querySelector("#react-render-root"), { childList: true, subtree: true });
          }
          this.sdk = yield GetSDK(this.showcase);
          this.sdk.Scene.configure((renderer, three, _effectComposer) => {
            renderer.useLegacyLights = true;
          });
          let originData = {
            mattertags: null,
            attachments: null,
            rooms: null,
            floors: null,
            labels: null,
            sweeps: null
          };
          const appSubscriptionOnlyPlaying = this.sdk.App.state.subscribe((appState) => __async(this, null, function* () {
            var _a2, _b2, _c, _d2;
            if (appState.phase === this.sdk.App.Phase.PLAYING) {
              const labelPromise = new Promise((resolve22, _reject2) => {
                const labelSubscription = this.sdk.Label.data.subscribe({
                  onCollectionUpdated: (collection) => {
                    labelSubscription.cancel();
                    originData.labels = JSON.parse(JSON.stringify(collection));
                    resolve22(true);
                  }
                });
              });
              const sweepPromise = new Promise((resolve22, _reject2) => {
                const sweepDataSubscription = this.sdk.Sweep.data.subscribe({
                  onCollectionUpdated: (collection) => {
                    sweepDataSubscription.cancel();
                    originData.sweeps = JSON.parse(JSON.stringify(collection));
                    resolve22(true);
                  }
                });
              });
              const tagPromise = new Promise((resolve22, _reject2) => {
                const tagDataSubscription = this.sdk.Tag.data.subscribe({
                  onCollectionUpdated: (collection) => {
                    tagDataSubscription.cancel();
                    Vue$1.prototype.$global.mattertags = JSON.parse(JSON.stringify(collection));
                    originData.mattertags = JSON.parse(JSON.stringify(collection));
                    resolve22(true);
                  }
                });
              });
              const tagAttachmentsPromise = new Promise((resolve22, _reject2) => {
                const tagAttachmentsSubscription = this.sdk.Tag.attachments.subscribe({
                  onCollectionUpdated: (collection) => {
                    tagAttachmentsSubscription.cancel();
                    originData.attachments = JSON.parse(JSON.stringify(collection));
                    resolve22(true);
                  }
                });
              });
              const roomPromise = new Promise((resolve22, _reject2) => {
                const roomDataSubscription = this.sdk.Room.data.subscribe({
                  onCollectionUpdated: (collection) => {
                    roomDataSubscription.cancel();
                    originData.rooms = JSON.parse(JSON.stringify(collection));
                    resolve22(true);
                  }
                });
              });
              const floorPromise = new Promise((resolve22, _reject2) => {
                const floorDataSubscription = this.sdk.Floor.data.subscribe({
                  onCollectionUpdated: (collection) => {
                    floorDataSubscription.cancel();
                    originData.floors = JSON.parse(JSON.stringify(collection));
                    resolve22(true);
                  }
                });
              });
              yield Promise.all([labelPromise, sweepPromise, tagPromise, tagAttachmentsPromise, roomPromise, floorPromise]).catch(() => new Error("Can not get data."));
              const tmpNode = (yield this.sdk.Scene.createObjects(1))[0].addNode();
              tmpNode.start();
              Vue$1.prototype.$global.rootScene = (_b2 = (_a2 = tmpNode == null ? void 0 : tmpNode.obj3D) == null ? void 0 : _a2.parent) == null ? void 0 : _b2.parent;
              yield new Promise((resolve22, reject) => {
                const waitDataTimeOutTimer = setTimeout(() => {
                  clearInterval(waitDataIntervalTimer);
                  reject(new Error("Tag not rendered."));
                }, 6e4);
                const waitDataIntervalTimer = setInterval(() => __async(this, null, function* () {
                  var _a3, _b3;
                  let matterTagsNodes = [];
                  Vue$1.prototype.$global.rootScene.traverse((node2) => {
                    if (node2.renderedPins) {
                      matterTagsNodes.push(node2.renderedPins);
                    }
                  });
                  if (Object.keys(originData.mattertags).length === 0 || matterTagsNodes.flat().length) {
                    clearTimeout(waitDataTimeOutTimer);
                    clearInterval(waitDataIntervalTimer);
                    for (const mattertagId in originData.mattertags) {
                      originData.mattertags[mattertagId].sid = mattertagId;
                      const tagOfSed = (_b3 = (_a3 = this.showcaseEditorData) == null ? void 0 : _a3.mattertags) == null ? void 0 : _b3.find((mattertag) => mattertag.sid === mattertagId);
                      if (tagOfSed == null ? void 0 : tagOfSed.floorId) {
                        originData.mattertags[mattertagId].floorId = tagOfSed.floorId;
                      }
                    }
                    resolve22(true);
                  }
                }), 100);
              }).catch((_error) => {
                return {};
              });
              if (this.standalone) {
                const standaloneJsonData = (yield axios$1.get(`./${this.modelSid}.json`)).data;
                this.showcaseEditorData = standaloneJsonData.showcase_editor_data;
                this.minimap = standaloneJsonData.minimap;
              }
              if (this.showcaseEditorData) {
                if (this.showcaseEditorData.mattertags) {
                  const filteredMattertags = this.showcaseEditorData.mattertags.filter((mattertag) => originData.mattertags[mattertag.sid] || mattertag.anchorPosition);
                  this.showcaseEditorData.mattertags = filteredMattertags;
                }
                if (this.showcaseEditorData.mattertag_groups) {
                  for (let i2 = 0; i2 < this.showcaseEditorData.mattertag_groups.length; i2++) {
                    const filteredMattertags = this.showcaseEditorData.mattertag_groups[i2].mattertags.filter((mattertag) => {
                      if (originData.mattertags[mattertag.sid]) {
                        return true;
                      }
                      const sed = this.showcaseEditorData.mattertags.find((tags) => tags.sid === mattertag.sid);
                      if (sed == null ? void 0 : sed.anchorPosition) {
                        return true;
                      }
                      return false;
                    });
                    this.showcaseEditorData.mattertag_groups[i2].mattertags = filteredMattertags;
                  }
                }
              }
              window.css2dScene = null;
              window.css3dScene = null;
              if (this.showcaseEditorData) {
                this.scene = new DP.Scene(this.showcase, this.sdk);
                yield this.scene.init();
              }
              new DP.Module.Component({
                apiUrl: this.apiUrl,
                attachments: originData.attachments,
                bgm: this.bgm,
                enableExtensions: this.enableExtensions,
                showCilbee: this.showCilbee,
                floors: originData.floors,
                groupListDrawer: this.groupListDrawer,
                labels: originData.labels,
                mattertags: originData.mattertags,
                minimap: this.minimap,
                modelSid: this.modelSid,
                objectListDrawer: this.objectListDrawer,
                rooms: originData.rooms,
                scene: this.scene,
                sdk: this.sdk,
                sharedExperience: this.sharedExperience,
                showcaseEditorData: this.showcaseEditorData,
                showShowcaseEditor: this.showShowcaseEditor,
                showVirtualStaging: this.showVirtualStaging,
                standalone: this.standalone,
                sweeps: originData.sweeps,
                pinia,
                virtualStagingAssets: this.virtualStagingAssets
              });
              if (this.showcaseEditorData) {
                {
                  if (this.showcaseEditorData.objects) {
                    yield Promise.all(this.showcaseEditorData.objects.payload.objects.map((object) => __async(this, null, function* () {
                      if (object.assetFileId) {
                        object.components[0].inputs.url = (yield axios$1.get(`/asset_files/get_asset_file_urls_by_id.json`, {
                          params: {
                            id: object.assetFileId
                          }
                        })).data.origin_file_url;
                      }
                    })));
                  }
                  if (this.showVirtualStaging) {
                    yield this.scene.loadTagsFromShowcaseEditorData(this.showcaseEditorData);
                  } else {
                    yield this.scene.loadTagsFromShowcaseEditorData(this.showcaseEditorData);
                    yield this.scene.loadObjectsFromShowcaseEditorData(this.showcaseEditorData);
                  }
                }
              }
              this.sdk.on(this.sdk.Mattertag.Event.HOVER, (tagSid, hovering) => __async(this, null, function* () {
                window.focusedTagSid = tagSid;
              }));
              this.sdk.on(this.sdk.Mattertag.Event.CLICK, (tagSid) => __async(this, null, function* () {
                window.focusedTagSid = tagSid;
              }));
              if (this.apiUrl && this.recordingId && !this.showCilbee) {
                new DP.Module.EventsRecorder(this.sdk, `${this.apiUrl}/recordings`, this.recordingId, this.hasGuestbook);
              }
              this.sdk.Link.setExternalLinkPolicy(true);
              this.sdk.Link.setModelLinkPolicy(this.sdk.Link.OpenPolicy.NEW_WINDOW, this.sdk.Link.DestinationPolicy.DEFAULT);
              this.sdk.Link.setNavigationLinkPolicy(this.sdk.Link.OpenPolicy.SAME_FRAME);
              this.sdk.Link.setSameOriginLinkPolicy(this.sdk.Link.OpenPolicy.NEW_WINDOW);
              if (this.enableExtensions.mattertag && ((_c = this.showcaseEditorData) == null ? void 0 : _c.mattertags.length) && !this.showCilbee) {
                yield new Promise((resolve22) => {
                  const checkRenderSedTagInterval = setInterval(() => {
                    Vue$1.prototype.$global.rootScene.traverse((node2) => {
                      if (node2.renderedPins) {
                        node2.renderedPins.forEach((tag) => {
                          if (this.showcaseEditorData.mattertags.find((sedTag) => sedTag.sid === tag.sid)) {
                            clearInterval(checkRenderSedTagInterval);
                            resolve22(null);
                          }
                        });
                      }
                    });
                  }, 1);
                });
                (_d2 = this.showcaseEditorData) == null ? void 0 : _d2.mattertags.forEach((mattertag) => {
                  if (mattertag.extension && mattertag.extension.type !== "none") {
                    this.sdk.Tag.allowAction(mattertag.sid, {
                      opening: true,
                      navigating: false,
                      docking: true,
                      sharing: true
                    });
                  }
                });
              }
              yield this.sdk.App.state.waitUntil((c) => c);
              appSubscriptionOnlyPlaying.cancel();
              resolve2(null);
            }
          }));
        }));
      });
    });
  }
  initEventsPlayer(eventsJson) {
    return __async(this, null, function* () {
      if (!!this.eventsPlayer) {
        yield this.eventsPlayer.reset();
      }
      this.eventsPlayer = new DP.Module.EventsPlayer(this.sdk);
      yield this.eventsPlayer.prepare(JSON.parse(eventsJson));
    });
  }
  test() {
    return __async(this, null, function* () {
      if (!this.scene) {
        this.scene = new DP.Scene(this.showcase, this.sdk);
        yield this.scene.init();
      }
    });
  }
}
export {
  DriftPhotoModule as default
};
